/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 585);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(690);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(721)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.5';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    return key == '__proto__'
      ? undefined
      : object[key];
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(107)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function stripHtmlTags(value) {
    var el = document.createElement('div');
    el.innerHTML = value;
    return el.innerText;
}
exports.stripHtmlTags = stripHtmlTags;
exports.promiseAllObject = function (promises) { return new Promise(function (resolve, reject) {
    var keys = Object.keys(promises);
    var promisesArray = keys.map(function (key) { return promises[key]; });
    return Promise.all(promisesArray)
        .then(function (promiseAllResults) {
        var promiseResultsObject = keys.reduce(function (obj, key, i) {
            obj[keys[i]] = promiseAllResults[i];
            return obj;
        }, {});
        resolve(promiseResultsObject);
    })
        .catch(reject);
}); };
/**
 * Get superdesk supported type for data transfer if any
 *
 * @param {Event} event
 * @param {Boolean} supportExternalFiles
 * @return {string}
 */
exports.getSuperdeskType = function (event, supportExternalFiles) {
    if (supportExternalFiles === void 0) { supportExternalFiles = true; }
    return event.originalEvent.dataTransfer.types.find(function (name) {
        return name.includes('application/superdesk') || supportExternalFiles && name === 'Files';
    });
};
/**
* @ngdoc method
* @name gettext
* @param {String} text - the text that will be translated, it supports parameters (see the example)
* @param {Object} params - dictionary of parameters used in text and their value (see the example)
* @description Used angular gettext service for displaying localised text on Browser
*
* gettext('This item was locked by {{username}}.', {username: 'John'});
* result -> 'This item was locked by John'
*/
exports.gettext = function (text, params) {
    if (params === void 0) { params = null; }
    if (!text) {
        return '';
    }
    var injector = angular.element(document.body).injector();
    if (injector) { // in tests this will be empty
        return injector.get('gettextCatalog').getString(text, params || {});
    }
    return text;
};
/**
 * @ngdoc method
 * @name gettextPlural
 * @param {Number} count
 * @param {String} text
 * @param {String} pluralText
 * @param {Object} params
 * @description Used angular gettext service for displaying plural localised text on Browser
 */
var gettextPlural = function (count, text, pluralText, params) {
    if (params === void 0) { params = {}; }
    if (!text) {
        return '';
    }
    var injector = angular.element(document.body).injector();
    if (injector) { // in tests this will be empty
        return injector.get('gettextCatalog').getPlural(count, text, pluralText, params);
    }
    return text;
};
exports.gettextCatalog = {
    getPlural: gettextPlural,
};
/**
 * Escape given string for reg exp
 *
 * @url https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
 *
 * @param {string} string
 * @return {string}
 */
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
exports.escapeRegExp = escapeRegExp;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__(649)("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(207);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1003);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1007);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(207);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(442);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["prefix"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsClass", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsStyles", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bsSizes", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["getClassSet"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["splitBsProps"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["splitBsPropsAndOmit"] = splitBsPropsAndOmit;
/* harmony export (immutable) */ __webpack_exports__["addStyle"] = addStyle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_curry", function() { return _curry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(35);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = existing;
  propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(619);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(712);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 * @format
 * 
 */



var AtomicBlockUtils = __webpack_require__(775);
var BlockMapBuilder = __webpack_require__(108);
var CharacterMetadata = __webpack_require__(40);
var CompositeDraftDecorator = __webpack_require__(791);
var ContentBlock = __webpack_require__(77);
var ContentState = __webpack_require__(177);
var DefaultDraftBlockRenderMap = __webpack_require__(180);
var DefaultDraftInlineStyle = __webpack_require__(393);
var DraftEditor = __webpack_require__(792);
var DraftEditorBlock = __webpack_require__(395);
var DraftEntity = __webpack_require__(130);
var DraftModifier = __webpack_require__(37);
var DraftEntityInstance = __webpack_require__(391);
var EditorState = __webpack_require__(20);
var KeyBindingUtil = __webpack_require__(186);
var RichTextEditorUtil = __webpack_require__(408);
var SelectionState = __webpack_require__(85);

var convertFromDraftStateToRaw = __webpack_require__(851);
var convertFromHTMLToContentBlocks = __webpack_require__(406);
var convertFromRawToDraftState = __webpack_require__(854);
var generateRandomKey = __webpack_require__(60);
var getDefaultKeyBinding = __webpack_require__(409);
var getVisibleSelectionRect = __webpack_require__(859);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,

  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,

  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  SelectionState: SelectionState,

  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};

module.exports = DraftPublic;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var waitUtil_1 = __webpack_require__(770);
var $injector = null;
/**
 * @class
 * @name ProviderService
 * @description Returns a singleton that is used to access the Angular
 * application's injector. In order for this service to work, the application
 * must register the $injector (ideally via a .run clause) after loading.
 */
exports.default = new /** @class */ (function () {
    function ProviderService() {
    }
    /**
     * @name ProviderService#register
     * @param {Object} injector The Angular $injector
     * @description Register an injector
     */
    ProviderService.prototype.register = function (injector) {
        $injector = injector;
    };
    /**
     * @name ProviderService#get
     * @param {string} name The name of the service to retrieve from the $injector.
     * @description Gets the given service from the injector. If a mock has been set
     * up for it, it returns that instead.
     */
    ProviderService.prototype.get = function (name) {
        if ($injector === null) {
            throw new Error('ng: $injector not registered for core/services/ng');
        }
        return $injector.get(name);
    };
    ProviderService.prototype.waitForServicesToBeAvailable = function () {
        return waitUtil_1.waitUntil(function () { return $injector != null; });
    };
    ProviderService.prototype.getService = function (name) {
        return this.getServices([name]).then(function (res) { return res[0]; });
    };
    ProviderService.prototype.getServices = function (names) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.waitForServicesToBeAvailable()
                .then(function () {
                resolve(names.map(function (name) { return $injector.get(name); }));
            });
        });
    };
    return ProviderService;
}())();


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlockTree = __webpack_require__(390);
var ContentState = __webpack_require__(177);
var EditorBidiService = __webpack_require__(788);
var Immutable = __webpack_require__(19);
var SelectionState = __webpack_require__(85);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack;


var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record(defaultRecord);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable) {
    _classCallCheck(this, EditorState);

    this._immutable = immutable;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(459);

var _createChainableTypeChecker = __webpack_require__(138);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ItemPriority_1 = __webpack_require__(561);
exports.ItemPriority = ItemPriority_1.ItemPriority;
var ItemUrgency_1 = __webpack_require__(562);
exports.ItemUrgency = ItemUrgency_1.ItemUrgency;
var TimeElem_1 = __webpack_require__(1733);
exports.TimeElem = TimeElem_1.TimeElem;
var MediaPreview_1 = __webpack_require__(563);
exports.MediaPreview = MediaPreview_1.MediaPreview;
var PhotoDeskPreview_1 = __webpack_require__(564);
exports.PhotoDeskPreview = PhotoDeskPreview_1.PhotoDeskPreview;
var ItemContainer_1 = __webpack_require__(1734);
exports.ItemContainer = ItemContainer_1.ItemContainer;
var SelectBox_1 = __webpack_require__(1735);
exports.SelectBox = SelectBox_1.SelectBox;
var MediaInfo_1 = __webpack_require__(565);
exports.MediaInfo = MediaInfo_1.MediaInfo;
var PhotoDeskInfo_1 = __webpack_require__(566);
exports.PhotoDeskInfo = PhotoDeskInfo_1.PhotoDeskInfo;
var FetchedDesksInfo_1 = __webpack_require__(1736);
exports.FetchedDesksInfo = FetchedDesksInfo_1.FetchedDesksInfo;
var DesksDropdown_1 = __webpack_require__(1737);
exports.DesksDropdown = DesksDropdown_1.DesksDropdown;
var TypeIcon_1 = __webpack_require__(1738);
exports.TypeIcon = TypeIcon_1.TypeIcon;
var GridTypeIcon_1 = __webpack_require__(568);
exports.GridTypeIcon = GridTypeIcon_1.GridTypeIcon;
var ListTypeIcon_1 = __webpack_require__(249);
exports.ListTypeIcon = ListTypeIcon_1.ListTypeIcon;
var ListPriority_1 = __webpack_require__(569);
exports.ListPriority = ListPriority_1.ListPriority;
var HighlightsInfo_1 = __webpack_require__(1739);
exports.HighlightsInfo = HighlightsInfo_1.HighlightsInfo;
var HighlightsList_1 = __webpack_require__(1740);
exports.HighlightsList = HighlightsList_1.HighlightsList;
var MarkedDesksInfo_1 = __webpack_require__(1741);
exports.MarkedDesksInfo = MarkedDesksInfo_1.MarkedDesksInfo;
var MarkedDesksList_1 = __webpack_require__(1742);
exports.MarkedDesksList = MarkedDesksList_1.MarkedDesksList;
var actions_menu_1 = __webpack_require__(1743);
exports.ActionsMenu = actions_menu_1.ActionsMenu;
var ErrorBox_1 = __webpack_require__(1751);
exports.ErrorBox = ErrorBox_1.ErrorBox;
var ListItemInfo_1 = __webpack_require__(571);
exports.ListItemInfo = ListItemInfo_1.ListItemInfo;
var Item_1 = __webpack_require__(1752);
exports.Item = Item_1.Item;
var ItemList_1 = __webpack_require__(1759);
exports.ItemList = ItemList_1.ItemList;
var Associations_1 = __webpack_require__(1762);
exports.Associations = Associations_1.Associations;
var QueueError_1 = __webpack_require__(1763);
exports.QueueError = QueueError_1.QueueError;
var WidgetItem_1 = __webpack_require__(1764);
exports.WidgetItem = WidgetItem_1.WidgetItem;
var WidgetItemList_1 = __webpack_require__(1765);
exports.WidgetItemList = WidgetItemList_1.WidgetItemList;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var List = __importStar(__webpack_require__(429));
exports.List = List;
var SidePanel = __importStar(__webpack_require__(1127));
exports.SidePanel = SidePanel;
var Nav = __importStar(__webpack_require__(491));
exports.Nav = Nav;
var SubNav = __importStar(__webpack_require__(1140));
exports.SubNav = SubNav;
var Preview = __importStar(__webpack_require__(1154));
exports.Preview = Preview;
var Form = __importStar(__webpack_require__(30));
exports.Form = Form;
var ColumnBox = __importStar(__webpack_require__(1157));
exports.ColumnBox = ColumnBox;
var SlideInPanel = __importStar(__webpack_require__(1161));
exports.SlideInPanel = SlideInPanel;
var SearchBox_1 = __importDefault(__webpack_require__(1168));
exports.SearchBox = SearchBox_1.default;
var DateTime_1 = __importDefault(__webpack_require__(1169));
exports.DateTime = DateTime_1.default;
var PanelInfo_1 = __importDefault(__webpack_require__(1172));
exports.PanelInfo = PanelInfo_1.default;
var CollapseBox_1 = __webpack_require__(1173);
exports.CollapseBox = CollapseBox_1.CollapseBox;
var TermsList_1 = __importDefault(__webpack_require__(1174));
exports.TermsList = TermsList_1.default;
var Popup = __importStar(__webpack_require__(80));
exports.Popup = Popup;
var SearchBar_1 = __importDefault(__webpack_require__(1175));
exports.SearchBar = SearchBar_1.default;
var ToggleBox_1 = __webpack_require__(1180);
exports.ToggleBox = ToggleBox_1.ToggleBox;
var Toggle_1 = __importDefault(__webpack_require__(1183));
exports.Toggle = Toggle_1.default;
var SearchField_1 = __importDefault(__webpack_require__(1186));
exports.SearchField = SearchField_1.default;
var Button_1 = __importDefault(__webpack_require__(441));
exports.Button = Button_1.default;
var ButtonList_1 = __importDefault(__webpack_require__(1187));
exports.ButtonList = ButtonList_1.default;
var IconButton_1 = __importDefault(__webpack_require__(1188));
exports.IconButton = IconButton_1.default;
var Icon_1 = __importDefault(__webpack_require__(493));
exports.Icon = Icon_1.default;
var IconMix_1 = __importDefault(__webpack_require__(1189));
exports.IconMix = IconMix_1.default;
var dropdown_1 = __webpack_require__(1190);
exports.Dropdown = dropdown_1.Dropdown;
var dropdown_menu_divider_1 = __webpack_require__(1191);
exports.DropdownMenuDivider = dropdown_menu_divider_1.DropdownMenuDivider;
var nav_tabs_1 = __webpack_require__(1192);
exports.NavTabs = nav_tabs_1.NavTabs;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(769));
__export(__webpack_require__(175));
__export(__webpack_require__(384));
__export(__webpack_require__(771));
__export(__webpack_require__(772));
__export(__webpack_require__(773));
__export(__webpack_require__(774));
__export(__webpack_require__(385));


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var constants_1 = __webpack_require__(73);
var fields = __importStar(__webpack_require__(160));
var ng_1 = __importDefault(__webpack_require__(18));
function getSpecStyle(spec) {
    var style = {};
    if (spec.color) {
        style['backgroundColor'] = spec.color;
    }
    return style;
}
exports.getSpecStyle = getSpecStyle;
function getSpecTitle(spec, title) {
    return spec.name ? title + ": " + spec.name : title;
}
exports.getSpecTitle = getSpecTitle;
function getSpecValue(spec, value) {
    return spec.short || value;
}
exports.getSpecValue = getSpecValue;
/**
 * Test if an multi-selection allowed
 *
 * @return {Boolean}
 */
function isCheckAllowed(item) {
    return !(item._type === 'items' || item._type === 'externalsource' ||
        item.state === 'killed' || item.state === 'recalled' ||
        item._type === 'published' && !item.last_published_version);
}
exports.isCheckAllowed = isCheckAllowed;
function createMarkUp(html) {
    return { __html: html };
}
exports.createMarkUp = createMarkUp;
function menuHolderElem() {
    return document.getElementById('react-placeholder');
}
exports.menuHolderElem = menuHolderElem;
function closeActionsMenu(itemId) {
    var menuHolder = menuHolderElem();
    var menuItemId = menuHolder.getAttribute('data-item-id');
    if (menuItemId && menuItemId !== itemId) {
        return;
    }
    menuHolder.removeAttribute('data-item-id');
    react_dom_1.default.unmountComponentAtNode(menuHolderElem());
}
exports.closeActionsMenu = closeActionsMenu;
function openActionsMenu(elem, target, itemId) {
    var menuHolder = menuHolderElem();
    menuHolder.setAttribute('data-item-id', itemId);
    renderToBody(elem, target);
}
exports.openActionsMenu = openActionsMenu;
/**
 * Render element close to target, but append to body
 *
 * Used for dropdown menus that would be only partialy visible if rendered
 * within parent which has overflow: hidden that is required for scrolling
 *
 * @param {Object} elem React element
 * @param {Node} target DOM node
 * @param {integer} zIndex z-index styling to be applied to the elem
 */
function renderToBody(elem, target, zIndex) {
    if (zIndex === void 0) { zIndex = 1000; }
    // first render it somewhere not visible
    menuHolderElem().style.zIndex = '-1';
    var node = react_dom_1.default.findDOMNode(react_dom_1.default.render(elem, menuHolderElem()));
    // make sure it's rendered
    node.style.display = 'block';
    var rect = node.getBoundingClientRect();
    var width = rect.width;
    var height = rect.height;
    var ACTION_MENU_FROM_TOP = 100; // top-menu + search bar
    var MENU_MARGIN_HEIGHT = 16;
    var LEFT_BAR_WIDTH = 48;
    var BOTTOM_BAR_HEIGHT = 30;
    var BUFFER = 5;
    // get target position
    var targetRect = target.getBoundingClientRect();
    // get workspace
    var workspace = document.getElementById('main-container');
    // compute menu position
    var top = targetRect.top + targetRect.height;
    var left = targetRect.left + targetRect.width - width;
    // menu goes off on the right side
    if (left + width + BUFFER > workspace.clientWidth) {
        left -= width;
        left += targetRect.width;
    }
    // menu goes off on the left side
    if (left - LEFT_BAR_WIDTH < 0) {
        left = targetRect.left;
    }
    // menu goes out on the bottom side
    if (top + height + BOTTOM_BAR_HEIGHT + BUFFER > workspace.clientHeight) {
        top -= height;
        top -= targetRect.height;
        top -= MENU_MARGIN_HEIGHT;
        top = top < ACTION_MENU_FROM_TOP ? ACTION_MENU_FROM_TOP : top;
    }
    node.style.top = top.toFixed() + 'px';
    node.style.left = left.toFixed() + 'px';
    node.style.position = 'absolute';
    menuHolderElem().style.zIndex = zIndex.toString();
}
exports.renderToBody = renderToBody;
function renderArea(area, itemProps, props, customRender) {
    if (customRender === void 0) { customRender = {}; }
    // If singleline preference is set, don't show second line
    if (itemProps.scope.singleLine && area === 'secondLine') {
        return;
    }
    /* globals __SUPERDESK_CONFIG__: true */
    var listConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]}.list || constants_1.DEFAULT_LIST_CONFIG;
    var specs = listConfig[area] || [];
    // If narrowView configuration is available and also singleline are active
    if (itemProps.scope.singleLine && itemProps.narrow && listConfig.narrowView) {
        specs = listConfig.narrowView;
    }
    var contents = specs.map(function (field) {
        if (customRender.fields && field in customRender.fields) {
            return customRender.fields[field](itemProps);
        }
        if (field in fields) {
            return fields[field](itemProps);
        }
        return null;
    }).filter(angular.identity);
    var elemProps = angular.extend({ key: area }, props);
    return contents.length ? react_1.default.createElement('div', elemProps, contents) : null;
}
exports.renderArea = renderArea;
/*
 * Bind mark Item dropdown action
 * @param {String} label - activity label
 */
function bindMarkItemShortcut(label) {
    var keyboardManager = ng_1.default.get('keyboardManager');
    angular.element('.active .more-activity-toggle').click();
    var markDropdown = angular.element('.more-activity-menu.open .dropdown--noarrow');
    if (markDropdown.find('[title="' + label + '"]').length > 0) {
        markDropdown.find('[title="' + label + '"]')[0].click();
    }
    if (markDropdown.find('button').length > 0) {
        markDropdown.find('button:not([disabled])')
            .first()
            .focus();
        keyboardManager.push('up', function () {
            markDropdown.find('button:focus')
                .parent('li')
                .prev()
                .children('button')
                .focus();
        });
        keyboardManager.push('down', function () {
            markDropdown.find('button:focus')
                .parent('li')
                .next()
                .children('button')
                .focus();
        });
        keyboardManager.push('escape', function () {
            var actionMenu = angular.element('.more-activity-menu.open');
            actionMenu.find('button.dropdown__menu-close').click();
        });
    }
}
exports.bindMarkItemShortcut = bindMarkItemShortcut;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYCODES = {
    BACKSPACE: 8,
    ENTER: 13,
    ESCAPE: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    S: 83,
    E: 69,
    TAB: 9,
};
exports.ICON_COLORS = {
    BLUE: 'icon--blue',
    DARK_BLUE_GREY: 'icon--dark-blue-grey',
    GRAY: 'icon--gray',
    GREEN: 'icon--green',
    LIGHT_BLUE: 'icon--light-blue',
    RED: 'icon--red',
    WHITE: 'icon--white',
    YELLOW: 'icon--yellow',
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = __webpack_require__(430);
exports.Label = Label_1.Label;
var LineInput_1 = __webpack_require__(197);
exports.LineInput = LineInput_1.LineInput;
var Row_1 = __webpack_require__(431);
exports.Row = Row_1.Row;
var RowItem_1 = __webpack_require__(922);
exports.RowItem = RowItem_1.RowItem;
var Input_1 = __webpack_require__(432);
exports.Input = Input_1.Input;
var Select_1 = __webpack_require__(923);
exports.Select = Select_1.Select;
var TextInput_1 = __webpack_require__(924);
exports.TextInput = TextInput_1.TextInput;
var TextArea_1 = __webpack_require__(433);
exports.TextArea = TextArea_1.TextArea;
var TextAreaInput_1 = __webpack_require__(925);
exports.TextAreaInput = TextAreaInput_1.TextAreaInput;
var SelectInput_1 = __webpack_require__(926);
exports.SelectInput = SelectInput_1.SelectInput;
var FileInput_1 = __webpack_require__(927);
exports.FileInput = FileInput_1.FileInput;
var LinkInput_1 = __webpack_require__(928);
exports.LinkInput = LinkInput_1.LinkInput;
var index_1 = __webpack_require__(930);
exports.SelectMetaTermsInput = index_1.SelectMetaTermsInput;
var SelectUserInput_1 = __webpack_require__(943);
exports.SelectUserInput = SelectUserInput_1.SelectUserInput;
var SelectTagInput_1 = __webpack_require__(947);
exports.SelectTagInput = SelectTagInput_1.SelectTagInput;
var Checkbox_1 = __webpack_require__(950);
exports.Checkbox = Checkbox_1.Checkbox;
var ToggleInput_1 = __webpack_require__(951);
exports.ToggleInput = ToggleInput_1.ToggleInput;
var ColouredValueInput_1 = __webpack_require__(954);
exports.ColouredValueInput = ColouredValueInput_1.ColouredValueInput;
var TimeInput_1 = __webpack_require__(958);
exports.TimeInput = TimeInput_1.TimeInput;
var DateInput_1 = __webpack_require__(961);
exports.DateInput = DateInput_1.DateInput;
var DateTimeInput_1 = __webpack_require__(967);
exports.DateTimeInput = DateTimeInput_1.DateTimeInput;
var InputArray_1 = __webpack_require__(970);
exports.InputArray = InputArray_1.InputArray;
var RadioButtonInput_1 = __webpack_require__(973);
exports.RadioButtonInput = RadioButtonInput_1.RadioButtonInput;
var Field_1 = __webpack_require__(974);
exports.Field = Field_1.Field;


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(__webpack_require__(14));
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc method
 * @name onEventCapture
 * @param {Object} event
 * @description Provides boiler plate event handling
 */
exports.onEventCapture = function (event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
};
/**
 * @ngdoc method
 * @name scrollListItemIfNeeded
 * @param {number} selectedIndex
 * @param {Object} listRefElement
 * @description Scroll an item in a unordered scrollable list based on index to be visible in the list
 */
exports.scrollListItemIfNeeded = function (selectedIndex, listRefElement) {
    if (listRefElement.children.length > 0) {
        var activeElement = listRefElement.children[selectedIndex];
        if (activeElement) {
            var distanceOfSelItemFromVisibleTop = jquery_1.default(activeElement).offset().top -
                jquery_1.default(document).scrollTop() -
                jquery_1.default(listRefElement).offset().top - jquery_1.default(document).scrollTop();
            // If the selected item goes beyond container view, scroll it to middle.
            if (distanceOfSelItemFromVisibleTop >=
                (listRefElement.clientHeight - activeElement.clientHeight) ||
                distanceOfSelItemFromVisibleTop < 0) {
                jquery_1.default(listRefElement).scrollTop(jquery_1.default(listRefElement).scrollTop() +
                    distanceOfSelItemFromVisibleTop -
                    listRefElement.offsetHeight * 0.5);
            }
        }
    }
};
/**
 * @ngdoc method
 * @name isNotForPublication
 * @param {Object} item
 * @returns {Boolean}
 * @description Checks if an item is marked 'not for publication'
 */
exports.isNotForPublication = function (item) { return lodash_1.get(item, 'flags.marked_for_not_publication', false); };
/**
 * @ngdoc method
 * @name firstCharUpperCase
 * @param {String} item
 * @returns {String}
 * @description Converts first case of a string to upper case
 */
exports.firstCharUpperCase = function (string) { return string && string.replace(/\b\w/g, function (l) { return l.toUpperCase(); }); };


/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bc64c8da982d3a424c62b4d324c50a18.gif";

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var lang_1 = __importDefault(__webpack_require__(167));
var utils_1 = __webpack_require__(3);
var constants = {
    MENU_MAIN: 'superdesk.core.menu.main',
    MENU_SETTINGS: 'superdesk.core.menu.settings',
    ACTION_EDIT: 'edit',
    ACTION_LIST: 'list',
    ACTION_VIEW: 'view',
    ACTION_PREVIEW: 'preview',
};
// using a function with no arguments is required so gettext
// is not called before angular starts and translations are loaded
exports.coreMenuGroups = {
    WORKFLOW: {
        id: 'WORKFLOW',
        priority: -500,
        getLabel: function () { return utils_1.gettext('Workflow'); },
    },
    CONTENT_CONFIG: {
        id: 'CONTENT_CONFIG',
        priority: -800,
        getLabel: function () { return utils_1.gettext('Content config'); },
    },
    CONTENT_FLOW: {
        id: 'CONTENT_FLOW',
        priority: -200,
        getLabel: function () { return utils_1.gettext('Content flow'); },
    },
};
/**
 * @ngdoc provider
 * @module superdesk.core.activity
 * @name superdeskProvider
 * @requires $routeProvider
 * @requires lodash
 * @description The superdesk provider exposes an API for registering new
 * application components, such as activities, widgets, etc.
 */
SuperdeskProvider.$inject = ['$routeProvider', 'lodash'];
function SuperdeskProvider($routeProvider, _) {
    var widgets = {};
    var activities = {};
    var permissions = {};
    var panes = {};
    angular.extend(this, constants);
    /**
     * @ngdoc method
     * @name superdeskProvider#widget
     * @public
     * @param {string} id
     * @param {Object} data
     * @returns {Object} self
     * @description Register widget.
     */
    this.widget = function (id, data) {
        widgets[id] = angular.extend({ _id: id, wcode: id }, data);
        return this;
    };
    /**
     * @ngdoc method
     * @name superdeskProvider#pane
     * @public
     * @description Register a pane.
     */
    this.pane = function (key, data) {
        panes[key] = angular.extend({ _id: key }, data);
        return this;
    };
    // Register a new activity.
    this.activity = function (id, activityData) {
        var activity = angular.extend({
            _id: id,
            priority: 0,
            when: id,
            href: id,
            filters: [],
            beta: false,
            reloadOnSearch: false,
            auth: true,
            features: {},
            privileges: {},
            condition: function (item) {
                return true;
            },
        }, activityData);
        var actionless = _.find(activity.filters, function (filter) { return !filter.action; });
        if (actionless) {
            console.error('Missing filters action for activity', activity);
        }
        if (activity.when[0] === '/' && (activity.template || activity.templateUrl)) {
            $routeProvider.when(activity.when, activity);
        }
        activities[id] = activity;
        return this;
    };
    /**
     * @ngdoc method
     * @name superdeskProvider#permission
     * @public
     *
     * @param {string} id
     * @param {Object} data
     * @returns {Object} self
     *
     * @description Register permission.
     */
    this.permission = function (id, data) {
        permissions[id] = angular.extend({ _id: id }, data);
        return this;
    };
    /**
     * @ngdoc service
     * @module superdesk.core.activity
     * @name superdesk
     * @requires $q
     * @requires $route
     * @requires $rootScope
     * @requires activityService
     * @requires activityChoose
     * @requires betaService
     * @requires features
     * @requires privileges
     * @requires $injector
     * @requires lodash
     * @requires config
     * @description This service allows interacting with registered activities.
     */
    this.$get = ['$q', '$rootScope', 'activityService', 'activityChooser',
        'betaService', 'features', 'privileges', '$injector', 'config',
        function superdeskFactory($q, $rootScope, activityService, activityChooser, betaService, features, privileges, $injector, config) {
            /**
             * Render main menu depending on registered acitivites
             */
            betaService.isBeta().then(function (beta) {
                lodash_1.forEach(activities, function (activity, id) {
                    if (activity.beta === true && !beta || !isAllowed(activity)) {
                        $routeProvider.when(activity.when, { redirectTo: '/workspace' });
                    }
                });
            });
            /**
             * Let user to choose an activity
             */
            function chooseActivity(_activities) {
                return activityChooser.choose(_activities);
            }
            function checkFeatures(activity) {
                var isMatch = true;
                angular.forEach(activity.features, function (val, key) {
                    isMatch = isMatch && features[key] && val;
                });
                return isMatch;
            }
            function checkPrivileges(activity) {
                return privileges.userHasPrivileges(activity.privileges);
            }
            function checkActivityEnabled(activity) {
                if (!_.get(config, 'activity')) {
                    return true;
                }
                if (_.isUndefined(config.activity[activity._id])) {
                    return true;
                }
                return config.activity[activity._id];
            }
            /**
             * @ngdoc method
             * @name superdesk#isAllowed
             * @private
             *
             * @param {Object} activity
             *
             * @description Test if user is allowed to use given activity.
             * Testing is based on current server setup (features) and user privileges.
             */
            function isAllowed(activity) {
                return checkActivityEnabled(activity) && checkFeatures(activity) && checkPrivileges(activity);
            }
            return angular.extend({
                widgets: widgets,
                activities: activities,
                permissions: permissions,
                panes: panes,
                /**
                 * @ngdoc method
                 * @name superdesk#activity
                 * @public
                 * @description Return activity by given id
                 */
                activity: function (id) {
                    return activities[id] || null;
                },
                /**
                 * @ngdoc method
                 * @name superdesk#resolve
                 * @public
                 * @description Resolve an intent to a single activity
                 */
                resolve: function (intent) {
                    var _activities = this.findActivities(intent);
                    switch (_activities.length) {
                        case 0:
                            return $q.reject();
                        case 1:
                            return $q.when(_activities[0]);
                        default:
                            return chooseActivity(_activities);
                    }
                },
                /**
                 * @ngdoc method
                 * @name superdesk#findActivities
                 * @public
                 * @description
                 * Find all available activities for given intent
                 */
                findActivities: function (intent, item) {
                    var criteria = {};
                    if (intent.action) {
                        criteria.action = intent.action;
                    }
                    if (intent.type) {
                        criteria.type = intent.type;
                    }
                    if (intent.id) {
                        criteria.id = intent.id;
                    }
                    return _.sortBy(_.filter(this.activities, function (activity) {
                        return _.find(activity.filters, criteria) && isAllowed(activity) &&
                            activity.condition(item) && testAdditionalCondition();
                        function testAdditionalCondition() {
                            if (activity.additionalCondition) {
                                return $injector.invoke(activity.additionalCondition, {}, { item: item ? item : intent.data });
                            }
                            return true;
                        }
                    }), 'priority').reverse();
                },
                /**
                 * @ngdoc method
                 * @name superdesk#intent
                 * @param {string} action
                 * @param {string} type
                 * @param {Object} data
                 * @returns {Object} promise
                 * @public
                 * @description
                 * Starts an activity for given action and data
                 */
                intent: function (action, type, data, id) {
                    var intent = {
                        action: action,
                        type: type,
                        data: data,
                        id: id,
                    };
                    var self = this;
                    return this.resolve(intent).then(function (activity) { return self.start(activity, intent); }, function () {
                        $rootScope.$broadcast([
                            'intent',
                            intent.action || '*',
                            intent.type || '*',
                        ].join(':'), intent);
                        return $q.reject();
                    });
                },
                /**
                 * @ngdoc method
                 * @name superdesk#link
                 *
                 * @param {string} activity
                 * @param {Object} data
                 * @returns {string}
                 *
                 * @description
                 * Get a link for given activity
                 */
                link: function getSuperdeskLink(activity, data) {
                    return activityService.getLink(this.activity(activity), data);
                },
                /**
                 * @ngdoc method
                 * @name superdesk#start
                 *
                 * @param {Object} activity
                 * @param {Object} locals
                 * @return {Promise}
                 *
                 * @description Start activity
                 *
                 */
                start: function (activity, locals) {
                    return activityService.start(activity, locals);
                },
                /**
                 * @ngdoc method
                 * @name superdesk#getMenu
                 *
                 * @param {string} category
                 *
                 * @description
                 * Get activities based on menu category
                 */
                getMenu: function getMenu(category) {
                    return privileges.loaded.then(function () {
                        var menu = [];
                        angular.forEach(activities, function (activity) {
                            if (activity.category === category && isAllowed(activity) &&
                                (activity.beta === false || $rootScope.beta)) {
                                menu.push(activity);
                            }
                        });
                        return menu;
                    });
                },
            }, constants);
        }];
}
/**
 * @ngdoc module
 * @module superdesk.core.activity
 * @name superdesk.core.activity
 * @packageName superdesk.core
 * @description Superdesk core activities module. Used to register new activities,
 * apps and functionalities.
 */
angular.module('superdesk.core.activity', [
    'ngRoute',
    'superdesk.core.notify',
    'superdesk.core.features',
    'superdesk.core.translate',
    'superdesk.core.services.beta',
    'superdesk.core.services.modal',
    'superdesk.core.privileges',
    'superdesk.core.keyboard',
    'superdesk.core.activity.chooser',
    'superdesk.core.activity.list',
    'superdesk.core.activity.modal',
])
    .constant('lodash', window._)
    .constant('langmap', lang_1.default)
    .provider('superdesk', SuperdeskProvider)
    /**
     * @ngdoc service
     * @module superdesk.core.activity
     * @name activityService
     * @requires $location
     * @requires $injector
     * @requires $q
     * @requires modal
     * @requires lodash
     * @description The service allows choosing activities to perform.
     */
    .service('activityService', ['$location', '$injector', '$q', 'modal', 'lodash',
    function ($location, $injector, $q, modal, _) {
        var activityStack = [];
        this.activityStack = activityStack;
        /**
 * Expand path using given locals, eg. with /users/:Id and locals {Id: 2} returns /users/2
 *
 * @param {Object} activity
 * @param {Object} locals
 * @returns {string}
 */
        function getPath(activity, locals) {
            if (activity.href[0] === '/') { // trigger route
                var matchAll = true, path = activity.href.replace(/:([_a-zA-Z0-9]+)/, function (match, key) {
                    matchAll = matchAll && locals[key];
                    return locals[key] ? locals[key] : match;
                });
                path = matchAll ? path : null;
                if (activity.href.indexOf('_type') !== -1 && !_.isNull(path)) {
                    path = path.replace(':_type', locals._type ? locals._type : 'archive');
                }
                return path;
            }
        }
        /**
 * @ngdoc method
 * @name activityService#getLink
 * @public
 *
 * @param {Object} activity
 * @param {Object} locals
 * @returns {string}
 *
 * @description
 * Get URL for given activity
 */
        this.getLink = getPath;
        /**
 * @ngdoc method
 * @name activityService#start
 * @public
 *
 * @param {object} activity
 * @param {object} locals
 * @returns {object} promise
 *
 * @description
 * Start given activity
 */
        this.start = function startActivity(activity, locals) {
            function execute(_activity, _locals) {
                var path = getPath(_activity, _locals && _locals.data);
                if (path) { // trigger route
                    $location.path(path);
                    return $q.when(_locals);
                }
                if (_activity.modal) {
                    var defer = $q.defer();
                    activityStack.push({
                        defer: defer,
                        activity: _activity,
                        locals: _locals,
                    });
                    return defer.promise;
                }
                return $q.when($injector.invoke(_activity.controller, {}, _locals));
            }
            if (activity.confirm) {
                return modal.confirm(utils_1.gettext(activity.confirm)).then(function runConfirmed() {
                    return execute(activity, locals);
                }, function () { return $q.reject({ confirm: 1 }); });
            }
            return execute(activity, locals);
        };
    }])
    .run(['$rootScope', 'superdesk', function ($rootScope, superdesk) {
        $rootScope.superdesk = superdesk; // add superdesk reference so we can use constants in templates
        $rootScope.intent = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return superdesk.intent.apply(superdesk, args);
        };
        $rootScope.link = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var path = superdesk.link.apply(superdesk, args);
            return path ? '#' + path : null;
        };
    }])
    /**
     * @ngdoc service
     * @module superdesk.core.activity
     * @name activityChooser
     * @description
     * Activity chooser service - bridge between superdesk and activity chooser directive
     */
    .service('activityChooser', ['$q', function ($q) {
        var defer;
        this.choose = function (activities) {
            defer = $q.defer();
            this.activities = activities;
            return defer.promise;
        };
        this.resolve = function (activity) {
            this.activities = null;
            defer.resolve(activity);
        };
        this.reject = function () {
            this.activities = null;
            defer.reject();
        };
    }])
    /**
     * @ngdoc service
     * @module superdesk.core.activity
     * @name referrer
     * @description
     * Referrer service to set/get the referrer Url
     */
    .service('referrer', ['lodash', function (_) {
        /**
         * @ngdoc method
         * @name referrer#setReferrer
         * @public
         *
         * @param {Object} currentRoute
         * @param {Object} previousRoute
         * @returns {string}
         *
         * @description
         * Serving for the purpose of setting referrer url via referrer service, also
         * setting url in localStorage. which is utilized to get last working screen
         * on authoring page if referrer url is unidentified direct link
         * (i.e from notification pane)
         */
        this.setReferrer = function (currentRoute, previousRoute) {
            if (currentRoute && previousRoute) {
                if (currentRoute.$$route !== undefined && previousRoute.$$route !== undefined) {
                    if (currentRoute.$$route.originalPath === '/') {
                        this.setReferrerUrl('/workspace');
                        localStorage.setItem('referrerUrl', '/workspace');
                        sessionStorage.removeItem('previewUrl');
                    }
                    else if (currentRoute.$$route.authoring && (!previousRoute.$$route.authoring ||
                        previousRoute.$$route._id === 'packaging')) {
                        this.setReferrerUrl(prepareUrl(previousRoute));
                        localStorage.setItem('referrerUrl', this.getReferrerUrl());
                        sessionStorage.removeItem('previewUrl');
                    }
                }
            }
        };
        var referrerURL;
        this.setReferrerUrl = function (refURL) {
            referrerURL = refURL;
        };
        this.getReferrerUrl = function () {
            if (typeof referrerURL === 'undefined' || referrerURL === null) {
                if (typeof localStorage.getItem('referrerUrl') === 'undefined'
                    || localStorage.getItem('referrerUrl') === null) {
                    this.setReferrerUrl('/workspace');
                }
                else {
                    referrerURL = localStorage.getItem('referrerUrl');
                }
            }
            return referrerURL;
        };
        /**
     * @ngdoc method
     * @name referrer#prepareUrl
     * @private
     *
     * @param {Object} refRoute
     * @returns {string}
     *
     * @description
     * Prepares complete Referrer Url from previous route href and querystring params(if exist),
     * e.g /workspace/content?q=test$repo=archive
     */
        function prepareUrl(refRoute) {
            var completeUrl;
            if (refRoute) {
                completeUrl = refRoute.$$route.href.replace('/:_id', '');
                if (!_.isEqual({}, refRoute.pathParams)) {
                    completeUrl = completeUrl + '/' + refRoute.pathParams._id;
                }
                if (!_.isEqual({}, refRoute.params)) {
                    completeUrl = completeUrl + '?';
                    completeUrl = completeUrl + decodeURIComponent($.param(refRoute.params));
                }
            }
            return completeUrl;
        }
    }])
    // reject modal on route change
    // todo(petr): what about blocking route change as long as it is opened?
    .run(['$rootScope', 'activityService', 'referrer', function ($rootScope, activityService, referrer) {
        $rootScope.$on('$routeChangeStart', function () {
            if (activityService.activityStack.length) {
                var item = activityService.activityStack.pop();
                item.defer.reject();
            }
        });
        $rootScope.$on('$routeChangeSuccess', function (ev, currentRoute, previousRoute) {
            referrer.setReferrer(currentRoute, previousRoute);
        });
    }])
    .directive('sdActivityItem', ActivityItemDirective)
    .directive('sdActivityDropdownItem', ActivityItemDropdownDirective);
ActivityItemDirective.$inject = ['asset'];
function ActivityItemDirective(asset) {
    return {
        templateUrl: asset.templateUrl('core/activity/views/activity-item.html'),
    };
}
ActivityItemDropdownDirective.$inject = ['asset'];
function ActivityItemDropdownDirective(asset) {
    return {
        templateUrl: asset.templateUrl('core/activity/views/activity-dropdown-item.html'),
        link: function (scope, elem, attr) {
            scope.group = attr.group;
        },
    };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(40);
var ContentStateInlineStyle = __webpack_require__(777);
var DraftFeatureFlags = __webpack_require__(65);
var Immutable = __webpack_require__(19);

var applyEntityToContentState = __webpack_require__(778);
var getCharacterRemovalRange = __webpack_require__(780);
var getContentStateFragment = __webpack_require__(129);
var insertFragmentIntoContentState = __webpack_require__(783);
var insertTextIntoContentState = __webpack_require__(784);
var invariant = __webpack_require__(17);
var modifyBlockForContentState = __webpack_require__(785);
var removeEntitiesAtEdges = __webpack_require__(387);
var removeRangeFromContentState = __webpack_require__(786);
var splitBlockInContentState = __webpack_require__(787);

var OrderedSet = Immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);

    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });

    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);

    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);

    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};

module.exports = DraftModifier;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = void 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(19),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var highlightsConfig_1 = __webpack_require__(46);
var editor3CustomData_1 = __webpack_require__(48);
var getDraftCharacterListForSelection_1 = __webpack_require__(188);
var getDraftSelectionForEntireContent_1 = __webpack_require__(416);
var resizeDraftSelection_1 = __webpack_require__(417);
var clearInlineStyles_1 = __webpack_require__(871);
var highlightsConfig_2 = __webpack_require__(46);
var lodash_1 = __webpack_require__(2);
exports.paragraphSeparator = '¶';
exports.availableHighlights = Object.keys(highlightsConfig_1.highlightsConfig).reduce(function (obj, key) {
    obj[key] = highlightsConfig_1.highlightsConfig[key].draftStyleMap;
    return obj;
}, {});
var mapHighlightTypeToInlineStyle = Object.keys(highlightsConfig_1.highlightsConfig).reduce(function (obj, key) {
    if (highlightsConfig_1.highlightsConfig[key].type === 'STYLE') {
        obj[key] = highlightsConfig_1.highlightsConfig[key].style;
    }
    return obj;
}, {});
var mapInlineStyleToHighlightType = Object.keys(highlightsConfig_1.highlightsConfig).reduce(function (obj, key) {
    if (highlightsConfig_1.highlightsConfig[key].type === 'STYLE') {
        obj[highlightsConfig_1.highlightsConfig[key].style] = key;
    }
    return obj;
}, {});
function getTypeByInlineStyle(inlineStyle) {
    return mapInlineStyleToHighlightType[inlineStyle];
}
exports.getTypeByInlineStyle = getTypeByInlineStyle;
function getInlineStyleByType(type) {
    return mapHighlightTypeToInlineStyle[type];
}
exports.getInlineStyleByType = getInlineStyleByType;
function getHighlightDescription(suggestionsType) {
    var highlight = highlightsConfig_1.highlightsConfig[suggestionsType];
    if (highlight != null && highlight.description) {
        return highlight.description;
    }
    return suggestionsType;
}
exports.getHighlightDescription = getHighlightDescription;
function getBlockStylesDescription(blockStyle) {
    if (blockStyle == null || !(blockStyle in highlightsConfig_2.blockStylesDescription)) {
        return '';
    }
    return highlightsConfig_2.blockStylesDescription[blockStyle];
}
exports.getBlockStylesDescription = getBlockStylesDescription;
function getInitialHighlightsState() {
    return {
        highlightsStyleMap: {},
        highlightsData: {},
        lastHighlightIds: Object.keys(exports.availableHighlights).reduce(function (obj, key) {
            obj[key] = 0;
            return obj;
        }, {}),
    };
}
function getHighlightsState(editorState) {
    var initialHighlightsState = getInitialHighlightsState();
    var highlightsDataFromEditor = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS);
    if (highlightsDataFromEditor == null) {
        return initialHighlightsState;
    }
    var dataFromEditorContainsRequiredKeys = Object.keys(initialHighlightsState)
        .filter(function (key) { return Object.keys(highlightsDataFromEditor).includes(key) === false; })
        .length === 0;
    if (dataFromEditorContainsRequiredKeys === false) {
        return initialHighlightsState;
    }
    return highlightsDataFromEditor;
}
function setHighlightsState(editorState, hightlightsState) {
    return editor3CustomData_1.setCustomDataForEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS, hightlightsState);
}
function getHighlightType(styleName) {
    var delimiterIndex = styleName.lastIndexOf('-');
    if (delimiterIndex === -1) {
        throw new Error('styleName doesn\'t belong to a highlight');
    }
    return styleName.slice(0, delimiterIndex);
}
/**
 * @ngdoc method
 * @name getHighlightsStyleMap
 * @param {Object} editorState
 * @return {Object}
 * @description return the current highlights style map.
 */
function getHighlightsStyleMap(editorState) {
    var highlightsState = getHighlightsState(editorState);
    return highlightsState.highlightsStyleMap;
}
exports.getHighlightsStyleMap = getHighlightsStyleMap;
/**
 * @ngdoc method
 * @name highlightTypeValid
 * @param {String} highlightType
 * @return {Boolean}
 * @description return true if the highlightType is a valid highlight type for current editor.
 */
function highlightTypeValid(highlightType) {
    return Object.keys(exports.availableHighlights).includes(highlightType);
}
/**
 * @ngdoc method
 * @name styleNameBelongsToHighlight
 * @param {String} styleName
 * @return {Boolean}
 * @description return true if the styleName is a valid style for current editor.
 */
function styleNameBelongsToHighlight(styleName) {
    if (typeof styleName !== 'string') {
        return false;
    }
    var delimiterIndex = styleName.lastIndexOf('-');
    if (delimiterIndex === -1) {
        return false;
    }
    return Object.keys(exports.availableHighlights).includes(styleName.slice(0, delimiterIndex));
}
exports.styleNameBelongsToHighlight = styleNameBelongsToHighlight;
/**
 * @ngdoc method
 * @name getHighlightTypeFromStyleName
 * @param {String} styleName
 * @return {String}
 * @description return the highlight type for styleName.
 */
function getHighlightTypeFromStyleName(styleName) {
    if (typeof styleName !== 'string') {
        throw new Error('string expected');
    }
    var delimiterIndex = styleName.lastIndexOf('-');
    if (delimiterIndex === -1) {
        throw new Error('Style name does not contain a highlight type');
    }
    var highlightType = styleName.slice(0, delimiterIndex);
    if (highlightTypeValid(highlightType) === false) {
        throw new Error("Invalid highlight type '" + highlightType + "'");
    }
    return highlightType;
}
exports.getHighlightTypeFromStyleName = getHighlightTypeFromStyleName;
/**
 * @ngdoc method
 * @name isHighlightStyle
 * @param {String} styleName
 * @return {Boolean}
 * @description return true if styleName coresponds to a valid type.
 */
function isHighlightStyle(styleName) {
    var delimiterIndex = styleName.lastIndexOf('-');
    if (delimiterIndex === -1) {
        return false;
    }
    return highlightTypeValid(styleName.slice(0, delimiterIndex));
}
exports.isHighlightStyle = isHighlightStyle;
/**
 * @ngdoc method
 * @name getHighlightsCount
 * @param {Object} editorState
 * @param {String} styleName
 * @return {String}
 * @description return the number of individual highlights.
 */
function getHighlightsCount(editorState, highlightType) {
    var highlightsState = getHighlightsState(editorState);
    if (highlightType !== undefined) {
        if (highlightTypeValid(highlightType) === false) {
            throw new Error("Invalid highlight type '" + highlightType + "'");
        }
        return highlightsState.lastHighlightIds[highlightType];
    }
    else {
        // count highlights of all types
        return Object.keys(highlightsState.lastHighlightIds)
            .reduce(function (count, key) { return count + highlightsState.lastHighlightIds[key]; }, 0);
    }
}
exports.getHighlightsCount = getHighlightsCount;
/**
 * @ngdoc method
 * @name canAddHighlight
 * @param {Object} editorState
 * @param {String} highlightType
 * @return {Boolean}
 * @description return true if a highlight of type highlightType can be set
 * for current selection
 */
function canAddHighlight(editorState, highlightType) {
    if (highlightTypeValid(highlightType) !== true) {
        return false;
    }
    function characterHasAHighlightOfTheSameType(character) {
        var _this = this;
        if (character.getStyle()
            .some(function (styleName) {
            return _this.styleNameBelongsToHighlight(styleName)
                && getHighlightType(styleName) === highlightType;
        })) {
            return true;
        }
        return false;
    }
    if (editorState.getSelection().isCollapsed()) {
        return false;
    }
    // selection is expanded to include edges
    // so you can't add a highlight right next to another
    var selection = resizeDraftSelection_1.resizeDraftSelection(1, 1, editorState.getSelection(), editorState, true);
    return getDraftCharacterListForSelection_1.getDraftCharacterListForSelection(editorState, selection)
        .some(characterHasAHighlightOfTheSameType.bind(this)) === false;
}
exports.canAddHighlight = canAddHighlight;
/**
 * @ngdoc method
 * @name getHighlightStyleAtOffset
 * @param {Object} editorState
 * @param {List} types
 * @param {Object} selection
 * @param {Integer} offset
 * @param {Boolean} fromEnd - if true start from end of the selection
 * @param {Boolean} firstFound - if true return first style found otherwise return all styles found
 * @description the highlight style from the new possition specified by offset.
 */
function getHighlightStyleAtOffset(editorState, types, selection, offset, fromEnd, firstFound) {
    if (fromEnd === void 0) { fromEnd = false; }
    if (firstFound === void 0) { firstFound = true; }
    var _a = exports.getBlockAndOffset(editorState, selection, offset, fromEnd), block = _a.block, newOffset = _a.newOffset;
    if (block == null) {
        return null;
    }
    var inlineStyles = block.getInlineStyleAt(newOffset);
    var highlightStyle = firstFound ? null : [];
    inlineStyles.forEach(function (style) {
        if (styleNameBelongsToHighlight(style)) {
            var type = getHighlightTypeFromStyleName(style);
            if (type != null && types.indexOf(type) !== -1 && type !== style) {
                if (firstFound) {
                    highlightStyle = highlightStyle || style;
                }
                else {
                    highlightStyle.push(style);
                }
            }
        }
    });
    return highlightStyle;
}
exports.getHighlightStyleAtOffset = getHighlightStyleAtOffset;
/**
 * @ngdoc method
 * @name getHighlightStyleAtCurrentPosition
 * @param {Object} editorState
 * @param {List} types
 * @param {Boolean} fromEnd - if true start from end of the selection
 * @param {Boolean} firstFound - if true return first style found otherwise return all styles found
 * @return {String}
 * @description return the style of type for current character position.
 */
function getHighlightStyleAtCurrentPosition(editorState, types, fromEnd, firstFound) {
    if (fromEnd === void 0) { fromEnd = false; }
    if (firstFound === void 0) { firstFound = true; }
    var selection = editorState.getSelection();
    return getHighlightStyleAtOffset(editorState, types, selection, 0, fromEnd, firstFound);
}
exports.getHighlightStyleAtCurrentPosition = getHighlightStyleAtCurrentPosition;
/**
 * @ngdoc method
 * @name getHighlightData
 * @param {Object} editorstate
 * @return {String} style
 * @description returns the data associated to the style.
 */
function getHighlightData(editorState, style) {
    var highlightsState = getHighlightsState(editorState);
    if (highlightsState.highlightsData[style] === undefined) {
        throw new Error('Highlight doesn\'t exist.');
    }
    return highlightsState.highlightsData[style];
}
exports.getHighlightData = getHighlightData;
/**
 * @ngdoc method
 * @name getHighlightAuthor
 * @param {Object} editorstate
 * @return {String} style
 * @description returns the author associated to the style.
 */
function getHighlightAuthor(editorState, style) {
    var data = getHighlightData(editorState, style);
    if (data == null) {
        return null;
    }
    return data.author;
}
exports.getHighlightAuthor = getHighlightAuthor;
/**
 * @ngdoc method
 * @name getHighlightDataAtOffset
 * @param {Object} editorState
 * @param {Array} types
 * @param {Object} selection
 * @param {Integer} offset
 * @return {Object}
 * @description the highlight associated data from the new possition specified by offset.
 */
function getHighlightDataAtOffset(editorState, types, selection, offset, fromEnd) {
    if (fromEnd === void 0) { fromEnd = false; }
    var style = getHighlightStyleAtOffset(editorState, types, selection, offset, fromEnd);
    if (style == null) {
        return null;
    }
    var highlightsState = getHighlightsState(editorState);
    return highlightsState.highlightsData[style];
}
exports.getHighlightDataAtOffset = getHighlightDataAtOffset;
/**
 * @ngdoc method
 * @name getHighlightDataAtCurrentPosition
 * @param {Object} editorState
 * @param {Array} types
 * @return {Object}
 * @description the highlight associated data from current position.
 */
function getHighlightDataAtCurrentPosition(editorState, types) {
    var selection = editorState.getSelection();
    return getHighlightDataAtOffset(editorState, types, selection, 0);
}
exports.getHighlightDataAtCurrentPosition = getHighlightDataAtCurrentPosition;
/**
 * Test if current selection has given type style applied
 *
 * @param {EditorState} editorState
 * @param {String} type
 * @returns {Boolean}
 */
function selectionHasType(editorState, type) {
    var characters = getDraftCharacterListForSelection_1.getDraftCharacterListForSelection(editorState, editorState.getSelection());
    return characters.every(function (character) { return character.getStyle().some(function (style) { return style.indexOf(type) === 0; }); });
}
/**
 * @ngdoc method
 * @name addHighlight
 * @param {Object} editorState
 * @param {String} type
 * @param {Object} data
 * @return {Object} new editor state
 * @description add a new highlight for the current selection.
 */
function addHighlight(editorState, type, data, single) {
    if (single === void 0) { single = false; }
    var _a, _b, _c;
    var nextEditorState = editorState;
    var initialSelection = nextEditorState.getSelection().merge({
        hasFocus: true,
    });
    var highlightsState = getHighlightsState(nextEditorState);
    if (highlightTypeValid(type) !== true) {
        throw new Error('Highlight type invalid');
    }
    if (single && selectionHasType(editorState, type)) {
        return editorState;
    }
    var newIndex = 0;
    if (highlightsState.lastHighlightIds && lodash_1.has(highlightsState.lastHighlightIds, type)) {
        newIndex = highlightsState.lastHighlightIds[type] + 1;
    }
    var styleName = type + '-' + newIndex;
    var newHighlightsState = {
        lastHighlightIds: __assign({}, highlightsState.lastHighlightIds, (_a = {}, _a[type] = newIndex, _a)),
        highlightsStyleMap: __assign({}, highlightsState.highlightsStyleMap, (_b = {}, _b[styleName] = exports.availableHighlights[type], _b)),
        highlightsData: __assign({}, highlightsState.highlightsData, (_c = {}, _c[styleName] = __assign({}, data, { type: type }), _c)),
    };
    nextEditorState = draft_js_1.RichUtils.toggleInlineStyle(nextEditorState, styleName);
    // prevent recording the changes to undo stack so user doesn't have to undo twice
    // for the highlight to be completelly(both inline styles and related data) undone
    nextEditorState = draft_js_1.EditorState.set(nextEditorState, { allowUndo: false });
    nextEditorState = setHighlightsState(nextEditorState, newHighlightsState);
    // make sure the cursor is at the right position after undo
    // it used to always end up at the position 0 of the first block
    // when undoing after changing block data with `allowUndo` set to false
    nextEditorState = draft_js_1.EditorState.push(nextEditorState, nextEditorState.getCurrentContent().set('selectionBefore', initialSelection), 'change-block-data');
    // restore focus lost after clicking a toolbar action or entering highlight data OR pushing editorState
    // so the selection is visible after undo
    nextEditorState = draft_js_1.EditorState.acceptSelection(nextEditorState, initialSelection);
    nextEditorState = draft_js_1.EditorState.set(nextEditorState, { allowUndo: true });
    return nextEditorState;
}
exports.addHighlight = addHighlight;
/**
 * @ngdoc method
 * @name updateHighlightData
 * @param {Object} editorState
 * @param {String} styleName
 * @param {Object} nextData
 * @return {Object} new editor state
 * @description update highlight data associated to given style.
 */
function updateHighlightData(editorState, styleName, nextData) {
    var _a;
    var highlightsState = getHighlightsState(editorState);
    if (highlightsState.highlightsData[styleName] === undefined) {
        throw new Error('Highlight doesn\'t exist.');
    }
    var newHighlightsState = __assign({}, highlightsState, { highlightsData: __assign({}, highlightsState.highlightsData, (_a = {}, _a[styleName] = nextData, _a)) });
    return setHighlightsState(editorState, newHighlightsState);
}
exports.updateHighlightData = updateHighlightData;
/**
 * @ngdoc method
 * @name removeHighlight
 * @param {Object} editorState
 * @param {String} styleName
 * @return {Object} new editor state
 * @description for current selection remove the highlight style and associated data.
 */
function removeHighlight(editorState, styleName) {
    var highlightsState = getHighlightsState(editorState);
    if (highlightsState.highlightsData[styleName] === undefined) {
        return editorState;
    }
    var nextHighlightsStyleMap = __assign({}, highlightsState.highlightsStyleMap);
    delete nextHighlightsStyleMap[styleName];
    var nextHighlightsData = __assign({}, highlightsState.highlightsData);
    delete nextHighlightsData[styleName];
    var newHighlightsState = {
        lastHighlightIds: highlightsState.lastHighlightIds,
        highlightsStyleMap: nextHighlightsStyleMap,
        highlightsData: nextHighlightsData,
    };
    var newEditorState = clearInlineStyles_1.clearInlineStyles(editorState, getDraftSelectionForEntireContent_1.getDraftSelectionForEntireContent(editorState), [styleName]);
    // prevent recording the changes to undo stack so user doesn't have to undo twice
    // for the highlight deletion to be completelly(both inline styles and related data) undone
    newEditorState = draft_js_1.EditorState.set(newEditorState, { allowUndo: false });
    newEditorState = setHighlightsState(newEditorState, newHighlightsState);
    newEditorState = draft_js_1.EditorState.set(newEditorState, { allowUndo: true });
    return newEditorState;
}
exports.removeHighlight = removeHighlight;
function hadHighlightsChanged(prevEditorState, nextEditorState) {
    return getHighlightsState(prevEditorState) !== getHighlightsState(nextEditorState);
}
exports.hadHighlightsChanged = hadHighlightsChanged;
/**
 * @ngdoc method
 * @name resetHighlightForCurrentSelection
 * @param {Object} editorState
 * @param {String} style
 * @return {Object} editor state
 * @description For current selection reset the highlight style. If it was the last
 * selection with given style, delete the associated data too.
 */
function resetHighlightForCurrentSelection(editorState, style) {
    var type = getHighlightType(style);
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    var offset = selection.getStartOffset() === block.getLength() - 1 ? 1 : 0;
    var styleBefore = getHighlightStyleAtOffset(editorState, [type], selection, -1);
    var styleAfter = getHighlightStyleAtOffset(editorState, [type], selection, offset, true);
    if (styleBefore !== style && styleAfter !== style) {
        return removeHighlight(editorState, style);
    }
    return draft_js_1.RichUtils.toggleInlineStyle(editorState, style);
}
exports.resetHighlightForCurrentSelection = resetHighlightForCurrentSelection;
/**
 * @ngdoc method
 * @name getCharByOffset
 * @param {Object} content
 * @param {Object} selection
 * @param {Integer} offset
 * @return {Char} return char
 * @description the char from the new possition specified by offset.
 */
function getCharByOffset(editorState, selection, offset) {
    var _a = exports.getBlockAndOffset(editorState, selection, offset), block = _a.block, newOffset = _a.newOffset;
    if (block == null) {
        return null;
    }
    return block.getText()[newOffset];
}
exports.getCharByOffset = getCharByOffset;
/**
 * @ngdoc method
 * @name changeEditorSelection
 * @param {Object} editorState
 * @param {Integer} startOffset - the anchor offset relative to current start offset
 * @param {Integer} endOffset - the focus offset relative to current end offset
 * @param {Boolean} force - apply accept or force selection
 * @return {Object} returns new state
 * @description Change the current editor selection.
 */
function changeEditorSelection(editorState, startOffset, endOffset, force) {
    var selection = editorState.getSelection();
    var _a = exports.getBlockAndOffset(editorState, selection, startOffset, false), startBlock = _a.block, newStartOffset = _a.newOffset;
    var _b = exports.getBlockAndOffset(editorState, selection, endOffset, true), endBlock = _b.block, newEndOffset = _b.newOffset;
    if (startBlock == null || endBlock == null) {
        return editorState;
    }
    var newSelection = selection.merge({
        anchorOffset: newStartOffset,
        anchorKey: startBlock.getKey(),
        focusOffset: newEndOffset,
        focusKey: endBlock.getKey(),
        isBackward: false,
    });
    if (force) {
        return draft_js_1.EditorState.forceSelection(editorState, newSelection);
    }
    return draft_js_1.EditorState.acceptSelection(editorState, newSelection);
}
exports.changeEditorSelection = changeEditorSelection;
/**
 * @ngdoc method
 * @name getBlockAndOffset
 * @param {Object} editorState
 * @param {Object} selection
 * @param {Integer} offset
 * @param {Boolean} startFromEnd
 * @return {Object} return block and offset at new position
 * @description find the block and offset for the new position specified by offset starting
 * from beggining of selection if startFromEnd is false or from end of selection otherwise.
 */
exports.getBlockAndOffset = function (editorState, selection, offset, startFromEnd, limitedToSingleBlock) {
    if (startFromEnd === void 0) { startFromEnd = false; }
    if (limitedToSingleBlock === void 0) { limitedToSingleBlock = false; }
    var noValue = { block: null, newOffset: null };
    var content = editorState.getCurrentContent();
    var newOffset;
    var block;
    if (startFromEnd) {
        newOffset = selection.getEndOffset() + offset;
        block = content.getBlockForKey(selection.getEndKey());
    }
    else {
        newOffset = selection.getStartOffset() + offset;
        block = content.getBlockForKey(selection.getStartKey());
    }
    if (block == null) {
        return noValue;
    }
    if (limitedToSingleBlock === true) {
        var offsetWithinBlock = startFromEnd === true
            ? Math.min(newOffset, block.getLength())
            : Math.max(newOffset, 0);
        return { block: block, newOffset: offsetWithinBlock };
    }
    while (newOffset < 0) {
        block = content.getBlockBefore(block.getKey());
        if (block == null) {
            return noValue;
        }
        newOffset = block.getLength() + newOffset + 1;
    }
    while (newOffset > block.getLength()) {
        newOffset = newOffset - block.getLength() - 1;
        block = content.getBlockAfter(block.getKey());
        if (block == null) {
            return noValue;
        }
    }
    return { block: block, newOffset: newOffset };
};
function getLeftRangeAndTextForStyle(editorState, style) {
    var type = getHighlightTypeFromStyleName(style);
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var startBlock = content.getBlockForKey(selection.getStartKey());
    var startOffset = selection.getStartOffset();
    var startText = '';
    var block = startBlock;
    var offset = startOffset < block.getLength() ? startOffset : block.getLength() - 1;
    var characterMetadataList;
    var characterMetadata;
    var blockText;
    var found;
    var newBlock = false;
    if (highlightsConfig_2.paragraphSuggestionTypes.indexOf(type) !== -1) {
        startText = block.getText()
            .substring(0, startOffset) + exports.paragraphSeparator;
        return { startOffset: startOffset, startBlock: startBlock, startText: startText };
    }
    while (block) {
        if (block.getLength() === 0) {
            block = content.getBlockBefore(block.getKey());
            continue;
        }
        found = false;
        offset = (offset == null) ? (block.getLength() - 1) : offset;
        characterMetadataList = block.getCharacterList();
        blockText = block.getText();
        for (var i = offset; i >= 0; i--) {
            characterMetadata = characterMetadataList.get(i);
            if (!characterMetadata.hasStyle(style)) {
                continue;
            }
            if (newBlock) {
                startText = exports.paragraphSeparator + startText;
                newBlock = false;
            }
            startText = blockText[i] + startText;
            startOffset = i;
            startBlock = block;
            found = true;
        }
        if (found) {
            block = content.getBlockBefore(block.getKey());
            offset = null;
            newBlock = true;
        }
        else {
            block = null;
        }
    }
    return { startOffset: startOffset, startBlock: startBlock, startText: startText };
}
function getRightRangeAndTextForStyle(editorState, style) {
    var type = getHighlightTypeFromStyleName(style);
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var endText = '';
    var endBlock = content.getBlockForKey(selection.getStartKey());
    var endOffset = selection.getStartOffset() + 1;
    var block = endBlock;
    var offset = endOffset;
    var characterMetadataList;
    var characterMetadata;
    var blockText;
    var found;
    var newBlock = false;
    if (highlightsConfig_2.paragraphSuggestionTypes.indexOf(type) !== -1) {
        endText = block.getText()
            .substring(endOffset);
        if (endText === '') {
            block = content.getBlockAfter(block.getKey());
            endText = block.getText();
        }
        return { endOffset: endOffset, endBlock: endBlock, endText: endText };
    }
    if (block.getLength() === offset && offset !== 0) {
        block = content.getBlockAfter(block.getKey());
        if (block == null) {
            return { endOffset: endOffset, endBlock: endBlock, endText: endText };
        }
        offset = null;
        newBlock = true;
    }
    while (block) {
        if (block.getLength() === 0) {
            block = content.getBlockAfter(block.getKey());
            continue;
        }
        found = false;
        offset = offset == null ? 0 : offset;
        characterMetadataList = block.getCharacterList();
        blockText = block.getText();
        for (var i = offset; i < block.getLength(); i++) {
            characterMetadata = characterMetadataList.get(i);
            if (!characterMetadata.hasStyle(style)) {
                continue;
            }
            if (newBlock) {
                endText = endText + exports.paragraphSeparator;
                newBlock = false;
            }
            endText = endText + blockText[i];
            endOffset = i + 1;
            endBlock = block;
            found = true;
        }
        if (found) {
            block = content.getBlockAfter(block.getKey());
            offset = null;
            newBlock = true;
        }
        else {
            block = null;
        }
    }
    return { endOffset: endOffset, endBlock: endBlock, endText: endText };
}
/**
 * @ngdoc method
 * @name getRangeAndTextForStyle
 * @param {Object} editorState
 * @param {String} style
 * @return {Object} return a selection and text that are associated to given highlight style.
 */
function getRangeAndTextForStyle(editorState, style, leftOnly) {
    if (leftOnly === void 0) { leftOnly = false; }
    var selection = editorState.getSelection();
    if (selection.isCollapsed() === false) {
        throw new Error('Only collapsed selection supported');
    }
    var _a = getLeftRangeAndTextForStyle(editorState, style), startOffset = _a.startOffset, startBlock = _a.startBlock, startText = _a.startText;
    var _b = getRightRangeAndTextForStyle(editorState, style), endOffset = _b.endOffset, endBlock = _b.endBlock, endText = _b.endText;
    var newSelection = selection.merge({
        anchorOffset: startOffset,
        anchorKey: startBlock.getKey(),
        focusOffset: leftOnly ? selection.getEndOffset() : endOffset,
        focusKey: leftOnly ? selection.getEndKey() : endBlock.getKey(),
        isBackward: false,
    });
    return {
        selection: newSelection,
        highlightedText: leftOnly ? startText + endText[0] : startText + endText,
    };
}
exports.getRangeAndTextForStyle = getRangeAndTextForStyle;
function getRangeAndTextForStyleInRawState(rawEditorState, highlightId) {
    var highlightedText = '';
    for (var _i = 0, _a = rawEditorState.blocks; _i < _a.length; _i++) {
        var _b = _a[_i], inlineStyleRanges = _b.inlineStyleRanges, text = _b.text;
        for (var _c = 0, inlineStyleRanges_1 = inlineStyleRanges; _c < inlineStyleRanges_1.length; _c++) {
            var _d = inlineStyleRanges_1[_c], offset = _d.offset, length = _d.length, style = _d.style;
            if (style === highlightId) {
                var textRange = text.substring(offset, offset + length);
                highlightedText = highlightedText.length > 0
                    ? highlightedText = "" + highlightedText + exports.paragraphSeparator + textRange
                    : highlightedText = textRange;
            }
        }
    }
    return { highlightedText: highlightedText };
}
exports.getRangeAndTextForStyleInRawState = getRangeAndTextForStyleInRawState;
/**
 * @ngdoc method
 * @name isPeerHighlight
 * @param {Object} editorState
 * @param {String} style
 * @param {String} type
 * @param {String} author
 * @return {Object} return true if the current suggestion is a complementary to type
 * (one is ADD_SUGGESTION and one is DELETE_SUGGESTION) and they have the same author
 */
function isPeerHighlight(editorState, style, type, author) {
    return style != null && getHighlightType(style) !== type
        && getHighlightAuthor(editorState, style) === author;
}
/**
 * @ngdoc method
 * @name getSuggestionData
 * @param {Object} editorState
 * @param {String} style
 * @return {Object} return the data associated with a suggestion; for replace suggestion returns
 * both old text and the suggested text and the selection returned wrap both texts.
 */
function getSuggestionData(editorState, styleName) {
    var type = getHighlightType(styleName);
    var _a = getRangeAndTextForStyle(editorState, styleName), selection = _a.selection, highlightedText = _a.highlightedText;
    var data = __assign({}, getHighlightData(editorState, styleName), { suggestionText: highlightedText, selection: selection, styleName: styleName });
    if (highlightsConfig_2.changeSuggestionsTypes.indexOf(type) === -1) {
        return data;
    }
    var peerStyleName = getHighlightStyleAtOffset(editorState, highlightsConfig_2.changeSuggestionsTypes, selection, 0, true);
    var afterPeer = true;
    if (!isPeerHighlight(editorState, peerStyleName, type, data.author)) {
        peerStyleName = getHighlightStyleAtOffset(editorState, highlightsConfig_2.changeSuggestionsTypes, selection, -1, false);
        if (!isPeerHighlight(editorState, peerStyleName, type, data.author)) {
            return data;
        }
        afterPeer = false;
    }
    var beforeSelection = selection.merge({
        anchorOffset: selection.getStartOffset(),
        anchorKey: selection.getStartKey(),
        focusOffset: selection.getStartOffset(),
        focusKey: selection.getStartKey(),
        isBackward: false,
    });
    var afterSelection = selection.merge({
        anchorOffset: selection.getEndOffset(),
        anchorKey: selection.getEndKey(),
        focusOffset: selection.getEndOffset(),
        focusKey: selection.getEndKey(),
        isBackward: false,
    });
    var beforeEditorState = draft_js_1.EditorState.acceptSelection(editorState, beforeSelection);
    var afterEditorState = draft_js_1.EditorState.acceptSelection(editorState, afterSelection);
    var peerRangeAndText = getRangeAndTextForStyle(afterPeer ? afterEditorState : beforeEditorState, peerStyleName);
    var suggestionSelection = selection.merge({
        anchorOffset: afterPeer ? selection.getStartOffset() : peerRangeAndText.selection.getStartOffset(),
        anchorKey: afterPeer ? selection.getStartKey() : peerRangeAndText.selection.getStartKey(),
        focusOffset: afterPeer ? peerRangeAndText.selection.getEndOffset() : selection.getEndOffset(),
        focusKey: afterPeer ? peerRangeAndText.selection.getEndKey() : selection.getEndKey(),
        isBackward: false,
    });
    if (type === 'ADD_SUGGESTION') {
        return __assign({}, data, { type: 'REPLACE_SUGGESTION', oldText: peerRangeAndText.highlightedText, selection: suggestionSelection });
    }
    return __assign({}, data, { type: 'REPLACE_SUGGESTION', suggestionText: peerRangeAndText.highlightedText, oldText: data.suggestionText, selection: suggestionSelection });
}
exports.getSuggestionData = getSuggestionData;
/**
 * @ngdoc method
 * @name addCommentsForServer
 * @param {EditorState} editorState
 * @return {EditorState}
 */
function addCommentsForServer(editorState) {
    var multipleHighlights = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS);
    if (multipleHighlights === undefined || multipleHighlights.highlightsData === undefined) {
        return editorState;
    }
    var highlightsData = multipleHighlights.highlightsData;
    var comments = Object.keys(highlightsData)
        .filter(function (key) { return key.indexOf(highlightsConfig_1.highlightsConfig.COMMENT.type) === 0; })
        .map(function (key) { return highlightsData[key].data; });
    return editor3CustomData_1.setCustomDataForEditor(editorState, editor3CustomData_1.editor3DataKeys.__PUBLIC_API__comments, comments);
}
/**
 * @ngdoc method
 * @name applyHighlightsStyleMap
 * @param {EditorState} editorState
 * @return {EditorState}
 * @description highlightsStyleMap is not stored on the server and needs to be generated
 * If it were stored, changing highights' styles wouldn't be possible for already existing highlights
 */
function applyHighlightsStyleMap(editorState) {
    var highlights = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS);
    if (highlights === undefined || highlights.highlightsData === undefined) {
        return editorState;
    }
    var highlightsWithStyleMapApplied = __assign({}, highlights, { highlightsStyleMap: Object.keys(highlights.highlightsData).reduce(function (obj, styleName) {
            obj[styleName] = exports.availableHighlights[getHighlightType(styleName)];
            return obj;
        }, {}) });
    return editor3CustomData_1.setCustomDataForEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS, highlightsWithStyleMapApplied);
}
exports.initializeHighlights = applyHighlightsStyleMap;
/**
 * @ngdoc method
 * @name removeHighlightsStyleMap
 * @param {EditorState} editorState
 * @return {EditorState}
 * @description highlightsStyleMap needs to be removed, since it's generated data
 * and not removing it, might lead to old styles being used
 */
function removeHighlightsStyleMap(editorState) {
    var highlights = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS);
    var nextHighlights = __assign({}, highlights);
    delete nextHighlights.highlightsStyleMap;
    return editor3CustomData_1.setCustomDataForEditor(editorState, editor3CustomData_1.editor3DataKeys.MULTIPLE_HIGHLIGHTS, nextHighlights);
}
exports.prepareHighlightsForExport = function (editorState) { return addCommentsForServer(removeHighlightsStyleMap(editorState)); };
/**
 * Highlight current entity
 *
 * @param {EditorState} initialState
 * @param {String} type
 * @param {Object} data
 * @param {Boolean} single
 * @returns {EditorState}
 */
function highlightEntity(initialState, type, data, single) {
    var editorState = initialState;
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    var entity = block.getEntityAt(selection.getStartOffset());
    block.findEntityRanges(function (characterMeta) { return characterMeta.getEntity() === entity; }, function (start, end) {
        editorState = draft_js_1.EditorState.acceptSelection(editorState, selection.merge({
            isBackward: false,
            anchorOffset: start,
            focusOffset: end,
        }));
        editorState = addHighlight(editorState, type, data, single);
        editorState = draft_js_1.EditorState.push(editorState, editorState.getCurrentContent(), 'change-block-data');
        editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    });
    return editorState;
}
exports.highlightEntity = highlightEntity;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Default list of fields
 */
exports.DEFAULT_LIST_CONFIG = {
    firstLine: [
        'ContactName',
        'JobTitle',
        'Email',
        'Phone',
        'VersionCreated',
    ],
    secondLine: [
        'OrgName',
        'ContactLocation',
        'SocialInfo',
    ],
    singleLine: [
        'ContactName',
        'JobTitle',
        'OrgName',
        'ContactLocation',
        'Email',
        'Phone',
        'SocialInfo',
        'VersionCreated',
    ],
};
exports.KEYCODES = {
    BACKSPACE: 8,
    ENTER: 13,
    ESCAPE: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SPACE: 32,
};
/**
 * Lookup fields for at least one of them should be provided
 */
exports.LOOKUP_FIELDS = [
    'mobile',
    'contact_phone',
    'contact_email',
    'twitter',
    'facebook',
    'instagram',
];
exports.FB_URL = 'https://www.facebook.com/';
exports.IG_URL = 'https://www.instagram.com/';
exports.TWITTER_URL = 'https://twitter.com/';
exports.MAP_URL = 'https://maps.google.com/maps?q=';
exports.MAILTO_URL = 'mailto://';
exports.FILTER_FIELDS = {
    PRIVACY_LEVEL: 'public',
    STATUS: 'is_active',
};
exports.URL_PARAMETERS = {
    first_name: utils_1.gettext('First Name'),
    last_name: utils_1.gettext('Last Name'),
    contact_email: utils_1.gettext('Email'),
    organisation: utils_1.gettext('organisation'),
    job_title: utils_1.gettext('Job Title'),
    postcode: utils_1.gettext('Post Code'),
    city: utils_1.gettext('City'),
    contact_state: utils_1.gettext('State'),
    country: utils_1.gettext('Country'),
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(40);
var Immutable = __webpack_require__(19);

var findRangesImmutable = __webpack_require__(109);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var ENTITY_STYLE_MAP = {
    backgroundColor: 'rgba(100, 235, 59, 0.2)',
};
exports.highlightsConfig = {
    COMMENT: {
        type: 'COMMENT',
        description: utils_1.gettext('Comment'),
        draftStyleMap: {
            backgroundColor: 'rgba(255, 235, 59, 0.2)',
        },
    },
    ANNOTATION: {
        type: 'ANNOTATION',
        description: utils_1.gettext('Annotation'),
        draftStyleMap: {
            borderBottom: '4px solid rgba(100, 205, 0, 0.6)',
        },
    },
    ADD_SUGGESTION: {
        type: 'CHANGE',
        description: utils_1.gettext('Add'),
        draftStyleMap: {
            color: 'rgba(0, 180, 0, 1.0)',
        },
    },
    DELETE_SUGGESTION: {
        type: 'CHANGE',
        description: utils_1.gettext('Remove'),
        draftStyleMap: {
            color: 'rgba(255, 0, 0, 1.0)',
            textDecoration: 'line-through',
        },
    },
    TOGGLE_BOLD_SUGGESTION: {
        type: 'STYLE',
        style: 'BOLD',
        description: utils_1.gettext('Toggle bold'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    TOGGLE_ITALIC_SUGGESTION: {
        type: 'STYLE',
        style: 'ITALIC',
        description: utils_1.gettext('Toggle italic'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    TOGGLE_UNDERLINE_SUGGESTION: {
        type: 'STYLE',
        style: 'UNDERLINE',
        description: utils_1.gettext('Toggle underline'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    TOGGLE_SUBSCRIPT_SUGGESTION: {
        type: 'STYLE',
        style: 'SUBSCRIPT',
        description: utils_1.gettext('Toggle subscript'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    TOGGLE_SUPERSCRIPT_SUGGESTION: {
        type: 'STYLE',
        style: 'SUPERSCRIPT',
        description: utils_1.gettext('Toggle superscript'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    TOGGLE_STRIKETHROUGH_SUGGESTION: {
        type: 'STYLE',
        style: 'STRIKETHROUGH',
        description: utils_1.gettext('Toggle strikethrough'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    BLOCK_STYLE_SUGGESTION: {
        type: 'BLOCK',
        description: utils_1.gettext('Toggle'),
        draftStyleMap: {
            backgroundColor: 'rgba(100, 235, 59, 0.2)',
        },
    },
    SPLIT_PARAGRAPH_SUGGESTION: {
        type: 'SPLIT',
        description: utils_1.gettext('Split paragraph'),
        draftStyleMap: {
            color: 'rgba(0, 180, 0, 1.0)',
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
        },
    },
    MERGE_PARAGRAPHS_SUGGESTION: {
        type: 'MERGE',
        description: utils_1.gettext('Merge paragraphs'),
        draftStyleMap: {
            color: 'rgba(255, 0, 0, 1.0)',
            textDecoration: 'line-through',
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
        },
    },
    DELETE_EMPTY_PARAGRAPH_SUGGESTION: {
        type: 'DELETE',
        description: utils_1.gettext('Delete empty paragraphs'),
        draftStyleMap: {
            color: 'rgba(255, 0, 0, 1.0)',
            textDecoration: 'line-through',
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
        },
    },
    ADD_LINK_SUGGESTION: {
        type: 'ENTITY',
        description: utils_1.gettext('Add link'),
        draftStyleMap: ENTITY_STYLE_MAP,
    },
    REMOVE_LINK_SUGGESTION: {
        type: 'ENTITY',
        description: utils_1.gettext('Remove link'),
        draftStyleMap: ENTITY_STYLE_MAP,
    },
    CHANGE_LINK_SUGGESTION: {
        type: 'ENTITY',
        description: utils_1.gettext('Edit link'),
        draftStyleMap: ENTITY_STYLE_MAP,
    },
};
exports.blockStylesDescription = {
    'header-one': 'H1',
    'header-two': 'H2',
    'header-three': 'H3',
    'header-four': 'H4',
    'header-five': 'H5',
    'header-six': 'H6',
    blockquote: utils_1.gettext('quote'),
    'unordered-list-item': utils_1.gettext('unordered list'),
    'ordered-list-item': utils_1.gettext('ordered list'),
    'code-block': utils_1.gettext('preformatted'),
};
exports.DELETE_SUGGESTION = 'DELETE_SUGGESTION';
exports.ADD_SUGGESTION = 'ADD_SUGGESTION';
exports.changeSuggestionsTypes = [exports.DELETE_SUGGESTION, exports.ADD_SUGGESTION];
exports.styleSuggestionsTypes = Object.keys(exports.highlightsConfig).filter(function (key) { return exports.highlightsConfig[key].type === 'STYLE'; });
exports.blockSuggestionTypes = [
    'BLOCK_STYLE_SUGGESTION',
];
exports.paragraphSuggestionTypes = [
    'SPLIT_PARAGRAPH_SUGGESTION',
    'MERGE_PARAGRAPHS_SUGGESTION',
];
exports.suggestionsTypes = exports.changeSuggestionsTypes.concat(exports.styleSuggestionsTypes, exports.blockSuggestionTypes, exports.paragraphSuggestionTypes, [
    'ADD_LINK_SUGGESTION',
    'REMOVE_LINK_SUGGESTION',
    'CHANGE_LINK_SUGGESTION',
]);
exports.isSuggestion = function (highlightId) { return exports.suggestionsTypes.some(function (suggestionType) { return highlightId.indexOf(suggestionType) === 0; }); };
exports.isComment = function (highlightId) { return highlightId.startsWith(exports.highlightsConfig.COMMENT.type); };


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(51);
var draft_js_1 = __webpack_require__(16);
var fieldsMeta_1 = __webpack_require__(66);
var getDraftSelectionForEntireContent_1 = __webpack_require__(416);
var highlights_1 = __webpack_require__(41);
var getUniqueStyleNamesInDraftSelection_1 = __webpack_require__(872);
var highlightsConfig_1 = __webpack_require__(46);
var editor3StateToHtml_1 = __webpack_require__(88);
function getCustomMetadataFromContentState(contentState, highlightType) {
    var editorState = highlights_1.initializeHighlights(draft_js_1.EditorState.createWithContent(contentState));
    var allStyleNames = getUniqueStyleNamesInDraftSelection_1.getUniqueStyleNamesInDraftSelection(editorState, getDraftSelectionForEntireContent_1.getDraftSelectionForEntireContent(editorState));
    return allStyleNames
        .filter(highlights_1.styleNameBelongsToHighlight)
        .filter(function (h) { return highlights_1.getHighlightTypeFromStyleName(h) === highlightType; })
        .map(function (styleName) { return ({
        styleName: styleName,
        obj: highlights_1.getHighlightData(editorState, styleName),
    }); });
}
function getAnnotationsFromHighlights(highlights) {
    return highlights.map(function (_a, index) {
        var styleName = _a.styleName, obj = _a.obj;
        return ({
            styleName: styleName,
            id: index + 1,
            index: index + 1,
            type: obj.data.annotationType,
            body: editor3StateToHtml_1.editor3StateToHtml(draft_js_1.convertFromRaw(JSON.parse(obj.data.msg))),
        });
    });
}
exports.editor3DataKeys = {
    MULTIPLE_HIGHLIGHTS: 'MULTIPLE_HIGHLIGHTS',
    RESOLVED_COMMENTS_HISTORY: 'RESOLVED_COMMENTS_HISTORY',
    RESOLVED_SUGGESTIONS_HISTORY: 'RESOLVED_SUGGESTIONS_HISTORY',
    // required in order to expose commnets to the server, but not couple it
    // with the client-side implementation of text-highlights
    __PUBLIC_API__comments: '__PUBLIC_API__comments',
};
function keyValid(key) {
    return Object.keys(exports.editor3DataKeys).includes(key);
}
exports.keyValid = keyValid;
function setAllCustomDataForEditor(editorState, value) {
    var currentSelectionToPreserve = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var firstBlockSelection = draft_js_1.SelectionState.createEmpty(content.getFirstBlock().getKey());
    content = draft_js_1.Modifier.mergeBlockData(content, firstBlockSelection, value);
    var editorStateWithDataSet = draft_js_1.EditorState.push(editorState, content, 'change-block-data');
    var editorStateWithSelectionRestored = draft_js_1.EditorState.acceptSelection(editorStateWithDataSet, currentSelectionToPreserve);
    return editorStateWithSelectionRestored;
}
exports.setAllCustomDataForEditor = setAllCustomDataForEditor;
function getAllCustomDataFromEditor(editorState) {
    return editorState
        .getCurrentContent()
        .getFirstBlock()
        .getData()
        .filter(function (value, key) { return keyValid(key); });
}
exports.getAllCustomDataFromEditor = getAllCustomDataFromEditor;
function setCustomDataForEditor(editorState, key, value) {
    if (!keyValid(key)) {
        throw new Error("Key '" + key + "' is not defined");
    }
    return setAllCustomDataForEditor(editorState, immutable_1.Map().set(key, value));
}
exports.setCustomDataForEditor = setCustomDataForEditor;
function getCustomDataFromEditor(editorState, key) {
    if (!keyValid(key)) {
        throw new Error("Key '" + key + "' is not defined");
    }
    return editorState
        .getCurrentContent()
        .getFirstBlock()
        .getData()
        .get(key);
}
exports.getCustomDataFromEditor = getCustomDataFromEditor;
function getCustomDataFromEditorRawState(rawState, key) {
    return getCustomDataFromEditor(draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(rawState)), key);
}
exports.getCustomDataFromEditorRawState = getCustomDataFromEditorRawState;
function getAnnotationsFromItem(item, field) {
    var highlights = getCustomMetadata(item, field, highlightsConfig_1.highlightsConfig.ANNOTATION.type);
    return getAnnotationsFromHighlights(highlights);
}
exports.getAnnotationsFromItem = getAnnotationsFromItem;
function getAnnotationsFromContentState(contentState) {
    var highlights = getCustomMetadataFromContentState(contentState, highlightsConfig_1.highlightsConfig.ANNOTATION.type);
    return getAnnotationsFromHighlights(highlights);
}
exports.getAnnotationsFromContentState = getAnnotationsFromContentState;
function getCustomMetadata(item, field, highlightType) {
    var contentStateRaw = fieldsMeta_1.getFieldMetadata(item, field, fieldsMeta_1.fieldsMetaKeys.draftjsState);
    if (contentStateRaw) {
        var contentState = draft_js_1.convertFromRaw(contentStateRaw);
        return getCustomMetadataFromContentState(contentState, highlightType);
    }
    return [];
}
exports.getCustomMetadata = getCustomMetadata;


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(31);











var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled', 'onKeyDown']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var UserAgentData = __webpack_require__(798);
var VersionRange = __webpack_require__(800);

var mapObject = __webpack_require__(801);
var memoizeStringOnly = __webpack_require__(802);

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};

module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(67);
var core = __webpack_require__(38);
var ctx = __webpack_require__(198);
var hide = __webpack_require__(92);
var has = __webpack_require__(81);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(204)('wks');
var uid = __webpack_require__(137);
var Symbol = __webpack_require__(67).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
var ng_1 = __importDefault(__webpack_require__(18));
var ReactRenderAsync = /** @class */ (function (_super) {
    __extends(ReactRenderAsync, _super);
    function ReactRenderAsync(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true,
            mappedProps: {},
        };
        return _this;
    }
    ReactRenderAsync.prototype.componentDidMount = function () {
        var _this = this;
        utils_1.promiseAllObject(this.props.promises)
            .then(function (result) {
            _this.setState({
                loading: false,
                mappedProps: result,
            });
        })
            .catch(function (err) {
            console.error(err);
        });
    };
    ReactRenderAsync.prototype.render = function () {
        var Component = this.props.component;
        return this.state.loading === true
            ? null
            : react_1.default.createElement(Component, __assign({}, __assign({}, this.props.originalProps, this.state.mappedProps)));
    };
    return ReactRenderAsync;
}(react_1.default.Component));
ReactRenderAsync.propTypes = {
    promises: prop_types_1.default.object,
    component: prop_types_1.default.func,
    originalProps: prop_types_1.default.object,
};
/* eslint-disable react/no-multi-comp */
function connectPromiseResults(getPromises) {
    return function (component) {
        return function connectPromiseComponent(props) {
            return (react_1.default.createElement(ReactRenderAsync, { promises: getPromises(props), component: component, originalProps: props }));
        };
    };
}
exports.connectPromiseResults = connectPromiseResults;
function connectServices(component, services) {
    return connectPromiseResults(function () {
        var promisesObject = {};
        services.forEach(function (serviceName) {
            promisesObject[serviceName] = ng_1.default.getService(serviceName);
        });
        return promisesObject;
    })(component);
}
exports.connectServices = connectServices;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(497);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function nameof(name) {
    return name;
}
exports.nameof = nameof;
function assertNever(x) {
    throw new Error('Unexpected object: ' + x);
}
exports.assertNever = assertNever;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimeElem_1 = __webpack_require__(2082);
exports.TimeElem = TimeElem_1.TimeElem;
var ItemContainer_1 = __webpack_require__(2083);
exports.ItemContainer = ItemContainer_1.ItemContainer;
var ListItemInfo_1 = __webpack_require__(2084);
exports.ListItemInfo = ListItemInfo_1.ListItemInfo;
var Item_1 = __webpack_require__(2085);
exports.Item = Item_1.Item;
var ItemList_1 = __webpack_require__(2086);
exports.ItemList = ItemList_1.ItemList;
var ContactHeader_1 = __webpack_require__(2087);
exports.ContactHeader = ContactHeader_1.ContactHeader;
var ContactInfo_1 = __webpack_require__(2088);
exports.ContactInfo = ContactInfo_1.ContactInfo;
var ContactFooter_1 = __webpack_require__(2089);
exports.ContactFooter = ContactFooter_1.ContactFooter;
var ListTypeIcon_1 = __webpack_require__(2090);
exports.ListTypeIcon = ListTypeIcon_1.ListTypeIcon;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "876e52a1ea0f40093a764217cb6a130a.png";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

!function(root,factory){if(true)module.exports=factory();else if("function"==typeof define&&define.amd)define([],factory);else{var a=factory();for(var i in a)("object"==typeof exports?exports:root)[i]=a[i]}}("undefined"!=typeof self?self:this,function(){return function(modules){function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}var installedModules={};return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{configurable:!1,enumerable:!0,get:getter})},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=22)}([function(module,exports,__webpack_require__){"use strict";module.exports=__webpack_require__(8)},function(module,exports,__webpack_require__){"use strict";function makeEmptyFunction(arg){return function(){return arg}}var emptyFunction=function(){};emptyFunction.thatReturns=makeEmptyFunction,emptyFunction.thatReturnsFalse=makeEmptyFunction(!1),emptyFunction.thatReturnsTrue=makeEmptyFunction(!0),emptyFunction.thatReturnsNull=makeEmptyFunction(null),emptyFunction.thatReturnsThis=function(){return this},emptyFunction.thatReturnsArgument=function(arg){return arg},module.exports=emptyFunction},function(module,exports,__webpack_require__){var __WEBPACK_AMD_DEFINE_ARRAY__,__WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
!function(global,factory){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=global.document?factory(global,!0):function(w){if(!w.document)throw new Error("jQuery requires a window with a document");return factory(w)}:factory(global)}("undefined"!=typeof window?window:this,function(window,noGlobal){"use strict";function DOMEval(code,doc){doc=doc||document;var script=doc.createElement("script");script.text=code,doc.head.appendChild(script).parentNode.removeChild(script)}function isArrayLike(obj){var length=!!obj&&"length"in obj&&obj.length,type=jQuery.type(obj);return"function"!==type&&!jQuery.isWindow(obj)&&("array"===type||0===length||"number"==typeof length&&length>0&&length-1 in obj)}function nodeName(elem,name){return elem.nodeName&&elem.nodeName.toLowerCase()===name.toLowerCase()}function winnow(elements,qualifier,not){return jQuery.isFunction(qualifier)?jQuery.grep(elements,function(elem,i){return!!qualifier.call(elem,i,elem)!==not}):qualifier.nodeType?jQuery.grep(elements,function(elem){return elem===qualifier!==not}):"string"!=typeof qualifier?jQuery.grep(elements,function(elem){return indexOf.call(qualifier,elem)>-1!==not}):risSimple.test(qualifier)?jQuery.filter(qualifier,elements,not):(qualifier=jQuery.filter(qualifier,elements),jQuery.grep(elements,function(elem){return indexOf.call(qualifier,elem)>-1!==not&&1===elem.nodeType}))}function sibling(cur,dir){for(;(cur=cur[dir])&&1!==cur.nodeType;);return cur}function createOptions(options){var object={};return jQuery.each(options.match(rnothtmlwhite)||[],function(_,flag){object[flag]=!0}),object}function Identity(v){return v}function Thrower(ex){throw ex}function adoptValue(value,resolve,reject,noValue){var method;try{value&&jQuery.isFunction(method=value.promise)?method.call(value).done(resolve).fail(reject):value&&jQuery.isFunction(method=value.then)?method.call(value,resolve,reject):resolve.apply(void 0,[value].slice(noValue))}catch(value){reject.apply(void 0,[value])}}function completed(){document.removeEventListener("DOMContentLoaded",completed),window.removeEventListener("load",completed),jQuery.ready()}function Data(){this.expando=jQuery.expando+Data.uid++}function getData(data){return"true"===data||"false"!==data&&("null"===data?null:data===+data+""?+data:rbrace.test(data)?JSON.parse(data):data)}function dataAttr(elem,key,data){var name;if(void 0===data&&1===elem.nodeType)if(name="data-"+key.replace(rmultiDash,"-$&").toLowerCase(),"string"==typeof(data=elem.getAttribute(name))){try{data=getData(data)}catch(e){}dataUser.set(elem,key,data)}else data=void 0;return data}function adjustCSS(elem,prop,valueParts,tween){var adjusted,scale=1,maxIterations=20,currentValue=tween?function(){return tween.cur()}:function(){return jQuery.css(elem,prop,"")},initial=currentValue(),unit=valueParts&&valueParts[3]||(jQuery.cssNumber[prop]?"":"px"),initialInUnit=(jQuery.cssNumber[prop]||"px"!==unit&&+initial)&&rcssNum.exec(jQuery.css(elem,prop));if(initialInUnit&&initialInUnit[3]!==unit){unit=unit||initialInUnit[3],valueParts=valueParts||[],initialInUnit=+initial||1;do{scale=scale||".5",initialInUnit/=scale,jQuery.style(elem,prop,initialInUnit+unit)}while(scale!==(scale=currentValue()/initial)&&1!==scale&&--maxIterations)}return valueParts&&(initialInUnit=+initialInUnit||+initial||0,adjusted=valueParts[1]?initialInUnit+(valueParts[1]+1)*valueParts[2]:+valueParts[2],tween&&(tween.unit=unit,tween.start=initialInUnit,tween.end=adjusted)),adjusted}function getDefaultDisplay(elem){var temp,doc=elem.ownerDocument,nodeName=elem.nodeName,display=defaultDisplayMap[nodeName];return display||(temp=doc.body.appendChild(doc.createElement(nodeName)),display=jQuery.css(temp,"display"),temp.parentNode.removeChild(temp),"none"===display&&(display="block"),defaultDisplayMap[nodeName]=display,display)}function showHide(elements,show){for(var display,elem,values=[],index=0,length=elements.length;index<length;index++)elem=elements[index],elem.style&&(display=elem.style.display,show?("none"===display&&(values[index]=dataPriv.get(elem,"display")||null,values[index]||(elem.style.display="")),""===elem.style.display&&isHiddenWithinTree(elem)&&(values[index]=getDefaultDisplay(elem))):"none"!==display&&(values[index]="none",dataPriv.set(elem,"display",display)));for(index=0;index<length;index++)null!=values[index]&&(elements[index].style.display=values[index]);return elements}function getAll(context,tag){var ret;return ret=void 0!==context.getElementsByTagName?context.getElementsByTagName(tag||"*"):void 0!==context.querySelectorAll?context.querySelectorAll(tag||"*"):[],void 0===tag||tag&&nodeName(context,tag)?jQuery.merge([context],ret):ret}function setGlobalEval(elems,refElements){for(var i=0,l=elems.length;i<l;i++)dataPriv.set(elems[i],"globalEval",!refElements||dataPriv.get(refElements[i],"globalEval"))}function buildFragment(elems,context,scripts,selection,ignored){for(var elem,tmp,tag,wrap,contains,j,fragment=context.createDocumentFragment(),nodes=[],i=0,l=elems.length;i<l;i++)if((elem=elems[i])||0===elem)if("object"===jQuery.type(elem))jQuery.merge(nodes,elem.nodeType?[elem]:elem);else if(rhtml.test(elem)){for(tmp=tmp||fragment.appendChild(context.createElement("div")),tag=(rtagName.exec(elem)||["",""])[1].toLowerCase(),wrap=wrapMap[tag]||wrapMap._default,tmp.innerHTML=wrap[1]+jQuery.htmlPrefilter(elem)+wrap[2],j=wrap[0];j--;)tmp=tmp.lastChild;jQuery.merge(nodes,tmp.childNodes),tmp=fragment.firstChild,tmp.textContent=""}else nodes.push(context.createTextNode(elem));for(fragment.textContent="",i=0;elem=nodes[i++];)if(selection&&jQuery.inArray(elem,selection)>-1)ignored&&ignored.push(elem);else if(contains=jQuery.contains(elem.ownerDocument,elem),tmp=getAll(fragment.appendChild(elem),"script"),contains&&setGlobalEval(tmp),scripts)for(j=0;elem=tmp[j++];)rscriptType.test(elem.type||"")&&scripts.push(elem);return fragment}function returnTrue(){return!0}function returnFalse(){return!1}function safeActiveElement(){try{return document.activeElement}catch(err){}}function on(elem,types,selector,data,fn,one){var origFn,type;if("object"==typeof types){"string"!=typeof selector&&(data=data||selector,selector=void 0);for(type in types)on(elem,type,selector,data,types[type],one);return elem}if(null==data&&null==fn?(fn=selector,data=selector=void 0):null==fn&&("string"==typeof selector?(fn=data,data=void 0):(fn=data,data=selector,selector=void 0)),!1===fn)fn=returnFalse;else if(!fn)return elem;return 1===one&&(origFn=fn,fn=function(event){return jQuery().off(event),origFn.apply(this,arguments)},fn.guid=origFn.guid||(origFn.guid=jQuery.guid++)),elem.each(function(){jQuery.event.add(this,types,fn,data,selector)})}function manipulationTarget(elem,content){return nodeName(elem,"table")&&nodeName(11!==content.nodeType?content:content.firstChild,"tr")?jQuery(">tbody",elem)[0]||elem:elem}function disableScript(elem){return elem.type=(null!==elem.getAttribute("type"))+"/"+elem.type,elem}function restoreScript(elem){var match=rscriptTypeMasked.exec(elem.type);return match?elem.type=match[1]:elem.removeAttribute("type"),elem}function cloneCopyEvent(src,dest){var i,l,type,pdataOld,pdataCur,udataOld,udataCur,events;if(1===dest.nodeType){if(dataPriv.hasData(src)&&(pdataOld=dataPriv.access(src),pdataCur=dataPriv.set(dest,pdataOld),events=pdataOld.events)){delete pdataCur.handle,pdataCur.events={};for(type in events)for(i=0,l=events[type].length;i<l;i++)jQuery.event.add(dest,type,events[type][i])}dataUser.hasData(src)&&(udataOld=dataUser.access(src),udataCur=jQuery.extend({},udataOld),dataUser.set(dest,udataCur))}}function fixInput(src,dest){var nodeName=dest.nodeName.toLowerCase();"input"===nodeName&&rcheckableType.test(src.type)?dest.checked=src.checked:"input"!==nodeName&&"textarea"!==nodeName||(dest.defaultValue=src.defaultValue)}function domManip(collection,args,callback,ignored){args=concat.apply([],args);var fragment,first,scripts,hasScripts,node,doc,i=0,l=collection.length,iNoClone=l-1,value=args[0],isFunction=jQuery.isFunction(value);if(isFunction||l>1&&"string"==typeof value&&!support.checkClone&&rchecked.test(value))return collection.each(function(index){var self=collection.eq(index);isFunction&&(args[0]=value.call(this,index,self.html())),domManip(self,args,callback,ignored)});if(l&&(fragment=buildFragment(args,collection[0].ownerDocument,!1,collection,ignored),first=fragment.firstChild,1===fragment.childNodes.length&&(fragment=first),first||ignored)){for(scripts=jQuery.map(getAll(fragment,"script"),disableScript),hasScripts=scripts.length;i<l;i++)node=fragment,i!==iNoClone&&(node=jQuery.clone(node,!0,!0),hasScripts&&jQuery.merge(scripts,getAll(node,"script"))),callback.call(collection[i],node,i);if(hasScripts)for(doc=scripts[scripts.length-1].ownerDocument,jQuery.map(scripts,restoreScript),i=0;i<hasScripts;i++)node=scripts[i],rscriptType.test(node.type||"")&&!dataPriv.access(node,"globalEval")&&jQuery.contains(doc,node)&&(node.src?jQuery._evalUrl&&jQuery._evalUrl(node.src):DOMEval(node.textContent.replace(rcleanScript,""),doc))}return collection}function remove(elem,selector,keepData){for(var node,nodes=selector?jQuery.filter(selector,elem):elem,i=0;null!=(node=nodes[i]);i++)keepData||1!==node.nodeType||jQuery.cleanData(getAll(node)),node.parentNode&&(keepData&&jQuery.contains(node.ownerDocument,node)&&setGlobalEval(getAll(node,"script")),node.parentNode.removeChild(node));return elem}function curCSS(elem,name,computed){var width,minWidth,maxWidth,ret,style=elem.style;return computed=computed||getStyles(elem),computed&&(ret=computed.getPropertyValue(name)||computed[name],""!==ret||jQuery.contains(elem.ownerDocument,elem)||(ret=jQuery.style(elem,name)),!support.pixelMarginRight()&&rnumnonpx.test(ret)&&rmargin.test(name)&&(width=style.width,minWidth=style.minWidth,maxWidth=style.maxWidth,style.minWidth=style.maxWidth=style.width=ret,ret=computed.width,style.width=width,style.minWidth=minWidth,style.maxWidth=maxWidth)),void 0!==ret?ret+"":ret}function addGetHookIf(conditionFn,hookFn){return{get:function(){return conditionFn()?void delete this.get:(this.get=hookFn).apply(this,arguments)}}}function vendorPropName(name){if(name in emptyStyle)return name;for(var capName=name[0].toUpperCase()+name.slice(1),i=cssPrefixes.length;i--;)if((name=cssPrefixes[i]+capName)in emptyStyle)return name}function finalPropName(name){var ret=jQuery.cssProps[name];return ret||(ret=jQuery.cssProps[name]=vendorPropName(name)||name),ret}function setPositiveNumber(elem,value,subtract){var matches=rcssNum.exec(value);return matches?Math.max(0,matches[2]-(subtract||0))+(matches[3]||"px"):value}function augmentWidthOrHeight(elem,name,extra,isBorderBox,styles){var i,val=0;for(i=extra===(isBorderBox?"border":"content")?4:"width"===name?1:0;i<4;i+=2)"margin"===extra&&(val+=jQuery.css(elem,extra+cssExpand[i],!0,styles)),isBorderBox?("content"===extra&&(val-=jQuery.css(elem,"padding"+cssExpand[i],!0,styles)),"margin"!==extra&&(val-=jQuery.css(elem,"border"+cssExpand[i]+"Width",!0,styles))):(val+=jQuery.css(elem,"padding"+cssExpand[i],!0,styles),"padding"!==extra&&(val+=jQuery.css(elem,"border"+cssExpand[i]+"Width",!0,styles)));return val}function getWidthOrHeight(elem,name,extra){var valueIsBorderBox,styles=getStyles(elem),val=curCSS(elem,name,styles),isBorderBox="border-box"===jQuery.css(elem,"boxSizing",!1,styles);return rnumnonpx.test(val)?val:(valueIsBorderBox=isBorderBox&&(support.boxSizingReliable()||val===elem.style[name]),"auto"===val&&(val=elem["offset"+name[0].toUpperCase()+name.slice(1)]),(val=parseFloat(val)||0)+augmentWidthOrHeight(elem,name,extra||(isBorderBox?"border":"content"),valueIsBorderBox,styles)+"px")}function Tween(elem,options,prop,end,easing){return new Tween.prototype.init(elem,options,prop,end,easing)}function schedule(){inProgress&&(!1===document.hidden&&window.requestAnimationFrame?window.requestAnimationFrame(schedule):window.setTimeout(schedule,jQuery.fx.interval),jQuery.fx.tick())}function createFxNow(){return window.setTimeout(function(){fxNow=void 0}),fxNow=jQuery.now()}function genFx(type,includeWidth){var which,i=0,attrs={height:type};for(includeWidth=includeWidth?1:0;i<4;i+=2-includeWidth)which=cssExpand[i],attrs["margin"+which]=attrs["padding"+which]=type;return includeWidth&&(attrs.opacity=attrs.width=type),attrs}function createTween(value,prop,animation){for(var tween,collection=(Animation.tweeners[prop]||[]).concat(Animation.tweeners["*"]),index=0,length=collection.length;index<length;index++)if(tween=collection[index].call(animation,prop,value))return tween}function defaultPrefilter(elem,props,opts){var prop,value,toggle,hooks,oldfire,propTween,restoreDisplay,display,isBox="width"in props||"height"in props,anim=this,orig={},style=elem.style,hidden=elem.nodeType&&isHiddenWithinTree(elem),dataShow=dataPriv.get(elem,"fxshow");opts.queue||(hooks=jQuery._queueHooks(elem,"fx"),null==hooks.unqueued&&(hooks.unqueued=0,oldfire=hooks.empty.fire,hooks.empty.fire=function(){hooks.unqueued||oldfire()}),hooks.unqueued++,anim.always(function(){anim.always(function(){hooks.unqueued--,jQuery.queue(elem,"fx").length||hooks.empty.fire()})}));for(prop in props)if(value=props[prop],rfxtypes.test(value)){if(delete props[prop],toggle=toggle||"toggle"===value,value===(hidden?"hide":"show")){if("show"!==value||!dataShow||void 0===dataShow[prop])continue;hidden=!0}orig[prop]=dataShow&&dataShow[prop]||jQuery.style(elem,prop)}if((propTween=!jQuery.isEmptyObject(props))||!jQuery.isEmptyObject(orig)){isBox&&1===elem.nodeType&&(opts.overflow=[style.overflow,style.overflowX,style.overflowY],restoreDisplay=dataShow&&dataShow.display,null==restoreDisplay&&(restoreDisplay=dataPriv.get(elem,"display")),display=jQuery.css(elem,"display"),"none"===display&&(restoreDisplay?display=restoreDisplay:(showHide([elem],!0),restoreDisplay=elem.style.display||restoreDisplay,display=jQuery.css(elem,"display"),showHide([elem]))),("inline"===display||"inline-block"===display&&null!=restoreDisplay)&&"none"===jQuery.css(elem,"float")&&(propTween||(anim.done(function(){style.display=restoreDisplay}),null==restoreDisplay&&(display=style.display,restoreDisplay="none"===display?"":display)),style.display="inline-block")),opts.overflow&&(style.overflow="hidden",anim.always(function(){style.overflow=opts.overflow[0],style.overflowX=opts.overflow[1],style.overflowY=opts.overflow[2]})),propTween=!1;for(prop in orig)propTween||(dataShow?"hidden"in dataShow&&(hidden=dataShow.hidden):dataShow=dataPriv.access(elem,"fxshow",{display:restoreDisplay}),toggle&&(dataShow.hidden=!hidden),hidden&&showHide([elem],!0),anim.done(function(){hidden||showHide([elem]),dataPriv.remove(elem,"fxshow");for(prop in orig)jQuery.style(elem,prop,orig[prop])})),propTween=createTween(hidden?dataShow[prop]:0,prop,anim),prop in dataShow||(dataShow[prop]=propTween.start,hidden&&(propTween.end=propTween.start,propTween.start=0))}}function propFilter(props,specialEasing){var index,name,easing,value,hooks;for(index in props)if(name=jQuery.camelCase(index),easing=specialEasing[name],value=props[index],Array.isArray(value)&&(easing=value[1],value=props[index]=value[0]),index!==name&&(props[name]=value,delete props[index]),(hooks=jQuery.cssHooks[name])&&"expand"in hooks){value=hooks.expand(value),delete props[name];for(index in value)index in props||(props[index]=value[index],specialEasing[index]=easing)}else specialEasing[name]=easing}function Animation(elem,properties,options){var result,stopped,index=0,length=Animation.prefilters.length,deferred=jQuery.Deferred().always(function(){delete tick.elem}),tick=function(){if(stopped)return!1;for(var currentTime=fxNow||createFxNow(),remaining=Math.max(0,animation.startTime+animation.duration-currentTime),temp=remaining/animation.duration||0,percent=1-temp,index=0,length=animation.tweens.length;index<length;index++)animation.tweens[index].run(percent);return deferred.notifyWith(elem,[animation,percent,remaining]),percent<1&&length?remaining:(length||deferred.notifyWith(elem,[animation,1,0]),deferred.resolveWith(elem,[animation]),!1)},animation=deferred.promise({elem:elem,props:jQuery.extend({},properties),opts:jQuery.extend(!0,{specialEasing:{},easing:jQuery.easing._default},options),originalProperties:properties,originalOptions:options,startTime:fxNow||createFxNow(),duration:options.duration,tweens:[],createTween:function(prop,end){var tween=jQuery.Tween(elem,animation.opts,prop,end,animation.opts.specialEasing[prop]||animation.opts.easing);return animation.tweens.push(tween),tween},stop:function(gotoEnd){var index=0,length=gotoEnd?animation.tweens.length:0;if(stopped)return this;for(stopped=!0;index<length;index++)animation.tweens[index].run(1);return gotoEnd?(deferred.notifyWith(elem,[animation,1,0]),deferred.resolveWith(elem,[animation,gotoEnd])):deferred.rejectWith(elem,[animation,gotoEnd]),this}}),props=animation.props;for(propFilter(props,animation.opts.specialEasing);index<length;index++)if(result=Animation.prefilters[index].call(animation,elem,props,animation.opts))return jQuery.isFunction(result.stop)&&(jQuery._queueHooks(animation.elem,animation.opts.queue).stop=jQuery.proxy(result.stop,result)),result;return jQuery.map(props,createTween,animation),jQuery.isFunction(animation.opts.start)&&animation.opts.start.call(elem,animation),animation.progress(animation.opts.progress).done(animation.opts.done,animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always),jQuery.fx.timer(jQuery.extend(tick,{elem:elem,anim:animation,queue:animation.opts.queue})),animation}function stripAndCollapse(value){return(value.match(rnothtmlwhite)||[]).join(" ")}function getClass(elem){return elem.getAttribute&&elem.getAttribute("class")||""}function buildParams(prefix,obj,traditional,add){var name;if(Array.isArray(obj))jQuery.each(obj,function(i,v){traditional||rbracket.test(prefix)?add(prefix,v):buildParams(prefix+"["+("object"==typeof v&&null!=v?i:"")+"]",v,traditional,add)});else if(traditional||"object"!==jQuery.type(obj))add(prefix,obj);else for(name in obj)buildParams(prefix+"["+name+"]",obj[name],traditional,add)}function addToPrefiltersOrTransports(structure){return function(dataTypeExpression,func){"string"!=typeof dataTypeExpression&&(func=dataTypeExpression,dataTypeExpression="*");var dataType,i=0,dataTypes=dataTypeExpression.toLowerCase().match(rnothtmlwhite)||[];if(jQuery.isFunction(func))for(;dataType=dataTypes[i++];)"+"===dataType[0]?(dataType=dataType.slice(1)||"*",(structure[dataType]=structure[dataType]||[]).unshift(func)):(structure[dataType]=structure[dataType]||[]).push(func)}}function inspectPrefiltersOrTransports(structure,options,originalOptions,jqXHR){function inspect(dataType){var selected;return inspected[dataType]=!0,jQuery.each(structure[dataType]||[],function(_,prefilterOrFactory){var dataTypeOrTransport=prefilterOrFactory(options,originalOptions,jqXHR);return"string"!=typeof dataTypeOrTransport||seekingTransport||inspected[dataTypeOrTransport]?seekingTransport?!(selected=dataTypeOrTransport):void 0:(options.dataTypes.unshift(dataTypeOrTransport),inspect(dataTypeOrTransport),!1)}),selected}var inspected={},seekingTransport=structure===transports;return inspect(options.dataTypes[0])||!inspected["*"]&&inspect("*")}function ajaxExtend(target,src){var key,deep,flatOptions=jQuery.ajaxSettings.flatOptions||{};for(key in src)void 0!==src[key]&&((flatOptions[key]?target:deep||(deep={}))[key]=src[key]);return deep&&jQuery.extend(!0,target,deep),target}function ajaxHandleResponses(s,jqXHR,responses){for(var ct,type,finalDataType,firstDataType,contents=s.contents,dataTypes=s.dataTypes;"*"===dataTypes[0];)dataTypes.shift(),void 0===ct&&(ct=s.mimeType||jqXHR.getResponseHeader("Content-Type"));if(ct)for(type in contents)if(contents[type]&&contents[type].test(ct)){dataTypes.unshift(type);break}if(dataTypes[0]in responses)finalDataType=dataTypes[0];else{for(type in responses){if(!dataTypes[0]||s.converters[type+" "+dataTypes[0]]){finalDataType=type;break}firstDataType||(firstDataType=type)}finalDataType=finalDataType||firstDataType}if(finalDataType)return finalDataType!==dataTypes[0]&&dataTypes.unshift(finalDataType),responses[finalDataType]}function ajaxConvert(s,response,jqXHR,isSuccess){var conv2,current,conv,tmp,prev,converters={},dataTypes=s.dataTypes.slice();if(dataTypes[1])for(conv in s.converters)converters[conv.toLowerCase()]=s.converters[conv];for(current=dataTypes.shift();current;)if(s.responseFields[current]&&(jqXHR[s.responseFields[current]]=response),!prev&&isSuccess&&s.dataFilter&&(response=s.dataFilter(response,s.dataType)),prev=current,current=dataTypes.shift())if("*"===current)current=prev;else if("*"!==prev&&prev!==current){if(!(conv=converters[prev+" "+current]||converters["* "+current]))for(conv2 in converters)if(tmp=conv2.split(" "),tmp[1]===current&&(conv=converters[prev+" "+tmp[0]]||converters["* "+tmp[0]])){!0===conv?conv=converters[conv2]:!0!==converters[conv2]&&(current=tmp[0],dataTypes.unshift(tmp[1]));break}if(!0!==conv)if(conv&&s.throws)response=conv(response);else try{response=conv(response)}catch(e){return{state:"parsererror",error:conv?e:"No conversion from "+prev+" to "+current}}}return{state:"success",data:response}}var arr=[],document=window.document,getProto=Object.getPrototypeOf,slice=arr.slice,concat=arr.concat,push=arr.push,indexOf=arr.indexOf,class2type={},toString=class2type.toString,hasOwn=class2type.hasOwnProperty,fnToString=hasOwn.toString,ObjectFunctionString=fnToString.call(Object),support={},jQuery=function(selector,context){return new jQuery.fn.init(selector,context)},rtrim=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,rmsPrefix=/^-ms-/,rdashAlpha=/-([a-z])/g,fcamelCase=function(all,letter){return letter.toUpperCase()};jQuery.fn=jQuery.prototype={jquery:"3.2.1",constructor:jQuery,length:0,toArray:function(){return slice.call(this)},get:function(num){return null==num?slice.call(this):num<0?this[num+this.length]:this[num]},pushStack:function(elems){var ret=jQuery.merge(this.constructor(),elems);return ret.prevObject=this,ret},each:function(callback){return jQuery.each(this,callback)},map:function(callback){return this.pushStack(jQuery.map(this,function(elem,i){return callback.call(elem,i,elem)}))},slice:function(){return this.pushStack(slice.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(i){var len=this.length,j=+i+(i<0?len:0);return this.pushStack(j>=0&&j<len?[this[j]]:[])},end:function(){return this.prevObject||this.constructor()},push:push,sort:arr.sort,splice:arr.splice},jQuery.extend=jQuery.fn.extend=function(){var options,name,src,copy,copyIsArray,clone,target=arguments[0]||{},i=1,length=arguments.length,deep=!1;for("boolean"==typeof target&&(deep=target,target=arguments[i]||{},i++),"object"==typeof target||jQuery.isFunction(target)||(target={}),i===length&&(target=this,i--);i<length;i++)if(null!=(options=arguments[i]))for(name in options)src=target[name],copy=options[name],target!==copy&&(deep&&copy&&(jQuery.isPlainObject(copy)||(copyIsArray=Array.isArray(copy)))?(copyIsArray?(copyIsArray=!1,clone=src&&Array.isArray(src)?src:[]):clone=src&&jQuery.isPlainObject(src)?src:{},target[name]=jQuery.extend(deep,clone,copy)):void 0!==copy&&(target[name]=copy));return target},jQuery.extend({expando:"jQuery"+("3.2.1"+Math.random()).replace(/\D/g,""),isReady:!0,error:function(msg){throw new Error(msg)},noop:function(){},isFunction:function(obj){return"function"===jQuery.type(obj)},isWindow:function(obj){return null!=obj&&obj===obj.window},isNumeric:function(obj){var type=jQuery.type(obj);return("number"===type||"string"===type)&&!isNaN(obj-parseFloat(obj))},isPlainObject:function(obj){var proto,Ctor;return!(!obj||"[object Object]"!==toString.call(obj))&&(!(proto=getProto(obj))||"function"==typeof(Ctor=hasOwn.call(proto,"constructor")&&proto.constructor)&&fnToString.call(Ctor)===ObjectFunctionString)},isEmptyObject:function(obj){var name;for(name in obj)return!1;return!0},type:function(obj){return null==obj?obj+"":"object"==typeof obj||"function"==typeof obj?class2type[toString.call(obj)]||"object":typeof obj},globalEval:function(code){DOMEval(code)},camelCase:function(string){return string.replace(rmsPrefix,"ms-").replace(rdashAlpha,fcamelCase)},each:function(obj,callback){var length,i=0;if(isArrayLike(obj))for(length=obj.length;i<length&&!1!==callback.call(obj[i],i,obj[i]);i++);else for(i in obj)if(!1===callback.call(obj[i],i,obj[i]))break;return obj},trim:function(text){return null==text?"":(text+"").replace(rtrim,"")},makeArray:function(arr,results){var ret=results||[];return null!=arr&&(isArrayLike(Object(arr))?jQuery.merge(ret,"string"==typeof arr?[arr]:arr):push.call(ret,arr)),ret},inArray:function(elem,arr,i){return null==arr?-1:indexOf.call(arr,elem,i)},merge:function(first,second){for(var len=+second.length,j=0,i=first.length;j<len;j++)first[i++]=second[j];return first.length=i,first},grep:function(elems,callback,invert){for(var matches=[],i=0,length=elems.length,callbackExpect=!invert;i<length;i++)!callback(elems[i],i)!==callbackExpect&&matches.push(elems[i]);return matches},map:function(elems,callback,arg){var length,value,i=0,ret=[];if(isArrayLike(elems))for(length=elems.length;i<length;i++)null!=(value=callback(elems[i],i,arg))&&ret.push(value);else for(i in elems)null!=(value=callback(elems[i],i,arg))&&ret.push(value);return concat.apply([],ret)},guid:1,proxy:function(fn,context){var tmp,args,proxy;if("string"==typeof context&&(tmp=fn[context],context=fn,fn=tmp),jQuery.isFunction(fn))return args=slice.call(arguments,2),proxy=function(){return fn.apply(context||this,args.concat(slice.call(arguments)))},proxy.guid=fn.guid=fn.guid||jQuery.guid++,proxy},now:Date.now,support:support}),"function"==typeof Symbol&&(jQuery.fn[Symbol.iterator]=arr[Symbol.iterator]),jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(i,name){class2type["[object "+name+"]"]=name.toLowerCase()});var Sizzle=/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
function(window){function Sizzle(selector,context,results,seed){var m,i,elem,nid,match,groups,newSelector,newContext=context&&context.ownerDocument,nodeType=context?context.nodeType:9;if(results=results||[],"string"!=typeof selector||!selector||1!==nodeType&&9!==nodeType&&11!==nodeType)return results;if(!seed&&((context?context.ownerDocument||context:preferredDoc)!==document&&setDocument(context),context=context||document,documentIsHTML)){if(11!==nodeType&&(match=rquickExpr.exec(selector)))if(m=match[1]){if(9===nodeType){if(!(elem=context.getElementById(m)))return results;if(elem.id===m)return results.push(elem),results}else if(newContext&&(elem=newContext.getElementById(m))&&contains(context,elem)&&elem.id===m)return results.push(elem),results}else{if(match[2])return push.apply(results,context.getElementsByTagName(selector)),results;if((m=match[3])&&support.getElementsByClassName&&context.getElementsByClassName)return push.apply(results,context.getElementsByClassName(m)),results}if(support.qsa&&!compilerCache[selector+" "]&&(!rbuggyQSA||!rbuggyQSA.test(selector))){if(1!==nodeType)newContext=context,newSelector=selector;else if("object"!==context.nodeName.toLowerCase()){for((nid=context.getAttribute("id"))?nid=nid.replace(rcssescape,fcssescape):context.setAttribute("id",nid=expando),groups=tokenize(selector),i=groups.length;i--;)groups[i]="#"+nid+" "+toSelector(groups[i]);newSelector=groups.join(","),newContext=rsibling.test(selector)&&testContext(context.parentNode)||context}if(newSelector)try{return push.apply(results,newContext.querySelectorAll(newSelector)),results}catch(qsaError){}finally{nid===expando&&context.removeAttribute("id")}}}return select(selector.replace(rtrim,"$1"),context,results,seed)}function createCache(){function cache(key,value){return keys.push(key+" ")>Expr.cacheLength&&delete cache[keys.shift()],cache[key+" "]=value}var keys=[];return cache}function markFunction(fn){return fn[expando]=!0,fn}function assert(fn){var el=document.createElement("fieldset");try{return!!fn(el)}catch(e){return!1}finally{el.parentNode&&el.parentNode.removeChild(el),el=null}}function addHandle(attrs,handler){for(var arr=attrs.split("|"),i=arr.length;i--;)Expr.attrHandle[arr[i]]=handler}function siblingCheck(a,b){var cur=b&&a,diff=cur&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(diff)return diff;if(cur)for(;cur=cur.nextSibling;)if(cur===b)return-1;return a?1:-1}function createDisabledPseudo(disabled){return function(elem){return"form"in elem?elem.parentNode&&!1===elem.disabled?"label"in elem?"label"in elem.parentNode?elem.parentNode.disabled===disabled:elem.disabled===disabled:elem.isDisabled===disabled||elem.isDisabled!==!disabled&&disabledAncestor(elem)===disabled:elem.disabled===disabled:"label"in elem&&elem.disabled===disabled}}function createPositionalPseudo(fn){return markFunction(function(argument){return argument=+argument,markFunction(function(seed,matches){for(var j,matchIndexes=fn([],seed.length,argument),i=matchIndexes.length;i--;)seed[j=matchIndexes[i]]&&(seed[j]=!(matches[j]=seed[j]))})})}function testContext(context){return context&&void 0!==context.getElementsByTagName&&context}function setFilters(){}function toSelector(tokens){for(var i=0,len=tokens.length,selector="";i<len;i++)selector+=tokens[i].value;return selector}function addCombinator(matcher,combinator,base){var dir=combinator.dir,skip=combinator.next,key=skip||dir,checkNonElements=base&&"parentNode"===key,doneName=done++;return combinator.first?function(elem,context,xml){for(;elem=elem[dir];)if(1===elem.nodeType||checkNonElements)return matcher(elem,context,xml);return!1}:function(elem,context,xml){var oldCache,uniqueCache,outerCache,newCache=[dirruns,doneName];if(xml){for(;elem=elem[dir];)if((1===elem.nodeType||checkNonElements)&&matcher(elem,context,xml))return!0}else for(;elem=elem[dir];)if(1===elem.nodeType||checkNonElements)if(outerCache=elem[expando]||(elem[expando]={}),uniqueCache=outerCache[elem.uniqueID]||(outerCache[elem.uniqueID]={}),skip&&skip===elem.nodeName.toLowerCase())elem=elem[dir]||elem;else{if((oldCache=uniqueCache[key])&&oldCache[0]===dirruns&&oldCache[1]===doneName)return newCache[2]=oldCache[2];if(uniqueCache[key]=newCache,newCache[2]=matcher(elem,context,xml))return!0}return!1}}function elementMatcher(matchers){return matchers.length>1?function(elem,context,xml){for(var i=matchers.length;i--;)if(!matchers[i](elem,context,xml))return!1;return!0}:matchers[0]}function multipleContexts(selector,contexts,results){for(var i=0,len=contexts.length;i<len;i++)Sizzle(selector,contexts[i],results);return results}function condense(unmatched,map,filter,context,xml){for(var elem,newUnmatched=[],i=0,len=unmatched.length,mapped=null!=map;i<len;i++)(elem=unmatched[i])&&(filter&&!filter(elem,context,xml)||(newUnmatched.push(elem),mapped&&map.push(i)));return newUnmatched}function setMatcher(preFilter,selector,matcher,postFilter,postFinder,postSelector){return postFilter&&!postFilter[expando]&&(postFilter=setMatcher(postFilter)),postFinder&&!postFinder[expando]&&(postFinder=setMatcher(postFinder,postSelector)),markFunction(function(seed,results,context,xml){var temp,i,elem,preMap=[],postMap=[],preexisting=results.length,elems=seed||multipleContexts(selector||"*",context.nodeType?[context]:context,[]),matcherIn=!preFilter||!seed&&selector?elems:condense(elems,preMap,preFilter,context,xml),matcherOut=matcher?postFinder||(seed?preFilter:preexisting||postFilter)?[]:results:matcherIn;if(matcher&&matcher(matcherIn,matcherOut,context,xml),postFilter)for(temp=condense(matcherOut,postMap),postFilter(temp,[],context,xml),i=temp.length;i--;)(elem=temp[i])&&(matcherOut[postMap[i]]=!(matcherIn[postMap[i]]=elem));if(seed){if(postFinder||preFilter){if(postFinder){for(temp=[],i=matcherOut.length;i--;)(elem=matcherOut[i])&&temp.push(matcherIn[i]=elem);postFinder(null,matcherOut=[],temp,xml)}for(i=matcherOut.length;i--;)(elem=matcherOut[i])&&(temp=postFinder?indexOf(seed,elem):preMap[i])>-1&&(seed[temp]=!(results[temp]=elem))}}else matcherOut=condense(matcherOut===results?matcherOut.splice(preexisting,matcherOut.length):matcherOut),postFinder?postFinder(null,results,matcherOut,xml):push.apply(results,matcherOut)})}function matcherFromTokens(tokens){for(var checkContext,matcher,j,len=tokens.length,leadingRelative=Expr.relative[tokens[0].type],implicitRelative=leadingRelative||Expr.relative[" "],i=leadingRelative?1:0,matchContext=addCombinator(function(elem){return elem===checkContext},implicitRelative,!0),matchAnyContext=addCombinator(function(elem){return indexOf(checkContext,elem)>-1},implicitRelative,!0),matchers=[function(elem,context,xml){var ret=!leadingRelative&&(xml||context!==outermostContext)||((checkContext=context).nodeType?matchContext(elem,context,xml):matchAnyContext(elem,context,xml));return checkContext=null,ret}];i<len;i++)if(matcher=Expr.relative[tokens[i].type])matchers=[addCombinator(elementMatcher(matchers),matcher)];else{if(matcher=Expr.filter[tokens[i].type].apply(null,tokens[i].matches),matcher[expando]){for(j=++i;j<len&&!Expr.relative[tokens[j].type];j++);return setMatcher(i>1&&elementMatcher(matchers),i>1&&toSelector(tokens.slice(0,i-1).concat({value:" "===tokens[i-2].type?"*":""})).replace(rtrim,"$1"),matcher,i<j&&matcherFromTokens(tokens.slice(i,j)),j<len&&matcherFromTokens(tokens=tokens.slice(j)),j<len&&toSelector(tokens))}matchers.push(matcher)}return elementMatcher(matchers)}function matcherFromGroupMatchers(elementMatchers,setMatchers){var bySet=setMatchers.length>0,byElement=elementMatchers.length>0,superMatcher=function(seed,context,xml,results,outermost){var elem,j,matcher,matchedCount=0,i="0",unmatched=seed&&[],setMatched=[],contextBackup=outermostContext,elems=seed||byElement&&Expr.find.TAG("*",outermost),dirrunsUnique=dirruns+=null==contextBackup?1:Math.random()||.1,len=elems.length;for(outermost&&(outermostContext=context===document||context||outermost);i!==len&&null!=(elem=elems[i]);i++){if(byElement&&elem){for(j=0,context||elem.ownerDocument===document||(setDocument(elem),xml=!documentIsHTML);matcher=elementMatchers[j++];)if(matcher(elem,context||document,xml)){results.push(elem);break}outermost&&(dirruns=dirrunsUnique)}bySet&&((elem=!matcher&&elem)&&matchedCount--,seed&&unmatched.push(elem))}if(matchedCount+=i,bySet&&i!==matchedCount){for(j=0;matcher=setMatchers[j++];)matcher(unmatched,setMatched,context,xml);if(seed){if(matchedCount>0)for(;i--;)unmatched[i]||setMatched[i]||(setMatched[i]=pop.call(results));setMatched=condense(setMatched)}push.apply(results,setMatched),outermost&&!seed&&setMatched.length>0&&matchedCount+setMatchers.length>1&&Sizzle.uniqueSort(results)}return outermost&&(dirruns=dirrunsUnique,outermostContext=contextBackup),unmatched};return bySet?markFunction(superMatcher):superMatcher}var i,support,Expr,getText,isXML,tokenize,compile,select,outermostContext,sortInput,hasDuplicate,setDocument,document,docElem,documentIsHTML,rbuggyQSA,rbuggyMatches,matches,contains,expando="sizzle"+1*new Date,preferredDoc=window.document,dirruns=0,done=0,classCache=createCache(),tokenCache=createCache(),compilerCache=createCache(),sortOrder=function(a,b){return a===b&&(hasDuplicate=!0),0},hasOwn={}.hasOwnProperty,arr=[],pop=arr.pop,push_native=arr.push,push=arr.push,slice=arr.slice,indexOf=function(list,elem){for(var i=0,len=list.length;i<len;i++)if(list[i]===elem)return i;return-1},booleans="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",whitespace="[\\x20\\t\\r\\n\\f]",identifier="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",attributes="\\["+whitespace+"*("+identifier+")(?:"+whitespace+"*([*^$|!~]?=)"+whitespace+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+identifier+"))|)"+whitespace+"*\\]",pseudos=":("+identifier+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+attributes+")*)|.*)\\)|)",rwhitespace=new RegExp(whitespace+"+","g"),rtrim=new RegExp("^"+whitespace+"+|((?:^|[^\\\\])(?:\\\\.)*)"+whitespace+"+$","g"),rcomma=new RegExp("^"+whitespace+"*,"+whitespace+"*"),rcombinators=new RegExp("^"+whitespace+"*([>+~]|"+whitespace+")"+whitespace+"*"),rattributeQuotes=new RegExp("="+whitespace+"*([^\\]'\"]*?)"+whitespace+"*\\]","g"),rpseudo=new RegExp(pseudos),ridentifier=new RegExp("^"+identifier+"$"),matchExpr={ID:new RegExp("^#("+identifier+")"),CLASS:new RegExp("^\\.("+identifier+")"),TAG:new RegExp("^("+identifier+"|[*])"),ATTR:new RegExp("^"+attributes),PSEUDO:new RegExp("^"+pseudos),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+whitespace+"*(even|odd|(([+-]|)(\\d*)n|)"+whitespace+"*(?:([+-]|)"+whitespace+"*(\\d+)|))"+whitespace+"*\\)|)","i"),bool:new RegExp("^(?:"+booleans+")$","i"),needsContext:new RegExp("^"+whitespace+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+whitespace+"*((?:-\\d)?\\d*)"+whitespace+"*\\)|)(?=[^-]|$)","i")},rinputs=/^(?:input|select|textarea|button)$/i,rheader=/^h\d$/i,rnative=/^[^{]+\{\s*\[native \w/,rquickExpr=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,rsibling=/[+~]/,runescape=new RegExp("\\\\([\\da-f]{1,6}"+whitespace+"?|("+whitespace+")|.)","ig"),funescape=function(_,escaped,escapedWhitespace){var high="0x"+escaped-65536;return high!==high||escapedWhitespace?escaped:high<0?String.fromCharCode(high+65536):String.fromCharCode(high>>10|55296,1023&high|56320)},rcssescape=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,fcssescape=function(ch,asCodePoint){return asCodePoint?"\0"===ch?"�":ch.slice(0,-1)+"\\"+ch.charCodeAt(ch.length-1).toString(16)+" ":"\\"+ch},unloadHandler=function(){setDocument()},disabledAncestor=addCombinator(function(elem){return!0===elem.disabled&&("form"in elem||"label"in elem)},{dir:"parentNode",next:"legend"});try{push.apply(arr=slice.call(preferredDoc.childNodes),preferredDoc.childNodes),arr[preferredDoc.childNodes.length].nodeType}catch(e){push={apply:arr.length?function(target,els){push_native.apply(target,slice.call(els))}:function(target,els){for(var j=target.length,i=0;target[j++]=els[i++];);target.length=j-1}}}support=Sizzle.support={},isXML=Sizzle.isXML=function(elem){var documentElement=elem&&(elem.ownerDocument||elem).documentElement;return!!documentElement&&"HTML"!==documentElement.nodeName},setDocument=Sizzle.setDocument=function(node){var hasCompare,subWindow,doc=node?node.ownerDocument||node:preferredDoc;return doc!==document&&9===doc.nodeType&&doc.documentElement?(document=doc,docElem=document.documentElement,documentIsHTML=!isXML(document),preferredDoc!==document&&(subWindow=document.defaultView)&&subWindow.top!==subWindow&&(subWindow.addEventListener?subWindow.addEventListener("unload",unloadHandler,!1):subWindow.attachEvent&&subWindow.attachEvent("onunload",unloadHandler)),support.attributes=assert(function(el){return el.className="i",!el.getAttribute("className")}),support.getElementsByTagName=assert(function(el){return el.appendChild(document.createComment("")),!el.getElementsByTagName("*").length}),support.getElementsByClassName=rnative.test(document.getElementsByClassName),support.getById=assert(function(el){return docElem.appendChild(el).id=expando,!document.getElementsByName||!document.getElementsByName(expando).length}),support.getById?(Expr.filter.ID=function(id){var attrId=id.replace(runescape,funescape);return function(elem){return elem.getAttribute("id")===attrId}},Expr.find.ID=function(id,context){if(void 0!==context.getElementById&&documentIsHTML){var elem=context.getElementById(id);return elem?[elem]:[]}}):(Expr.filter.ID=function(id){var attrId=id.replace(runescape,funescape);return function(elem){var node=void 0!==elem.getAttributeNode&&elem.getAttributeNode("id");return node&&node.value===attrId}},Expr.find.ID=function(id,context){if(void 0!==context.getElementById&&documentIsHTML){var node,i,elems,elem=context.getElementById(id);if(elem){if((node=elem.getAttributeNode("id"))&&node.value===id)return[elem];for(elems=context.getElementsByName(id),i=0;elem=elems[i++];)if((node=elem.getAttributeNode("id"))&&node.value===id)return[elem]}return[]}}),Expr.find.TAG=support.getElementsByTagName?function(tag,context){return void 0!==context.getElementsByTagName?context.getElementsByTagName(tag):support.qsa?context.querySelectorAll(tag):void 0}:function(tag,context){var elem,tmp=[],i=0,results=context.getElementsByTagName(tag);if("*"===tag){for(;elem=results[i++];)1===elem.nodeType&&tmp.push(elem);return tmp}return results},Expr.find.CLASS=support.getElementsByClassName&&function(className,context){if(void 0!==context.getElementsByClassName&&documentIsHTML)return context.getElementsByClassName(className)},rbuggyMatches=[],rbuggyQSA=[],(support.qsa=rnative.test(document.querySelectorAll))&&(assert(function(el){docElem.appendChild(el).innerHTML="<a id='"+expando+"'></a><select id='"+expando+"-\r\\' msallowcapture=''><option selected=''></option></select>",el.querySelectorAll("[msallowcapture^='']").length&&rbuggyQSA.push("[*^$]="+whitespace+"*(?:''|\"\")"),el.querySelectorAll("[selected]").length||rbuggyQSA.push("\\["+whitespace+"*(?:value|"+booleans+")"),el.querySelectorAll("[id~="+expando+"-]").length||rbuggyQSA.push("~="),el.querySelectorAll(":checked").length||rbuggyQSA.push(":checked"),el.querySelectorAll("a#"+expando+"+*").length||rbuggyQSA.push(".#.+[+~]")}),assert(function(el){el.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var input=document.createElement("input");input.setAttribute("type","hidden"),el.appendChild(input).setAttribute("name","D"),el.querySelectorAll("[name=d]").length&&rbuggyQSA.push("name"+whitespace+"*[*^$|!~]?="),2!==el.querySelectorAll(":enabled").length&&rbuggyQSA.push(":enabled",":disabled"),docElem.appendChild(el).disabled=!0,2!==el.querySelectorAll(":disabled").length&&rbuggyQSA.push(":enabled",":disabled"),el.querySelectorAll("*,:x"),rbuggyQSA.push(",.*:")})),(support.matchesSelector=rnative.test(matches=docElem.matches||docElem.webkitMatchesSelector||docElem.mozMatchesSelector||docElem.oMatchesSelector||docElem.msMatchesSelector))&&assert(function(el){support.disconnectedMatch=matches.call(el,"*"),matches.call(el,"[s!='']:x"),rbuggyMatches.push("!=",pseudos)}),rbuggyQSA=rbuggyQSA.length&&new RegExp(rbuggyQSA.join("|")),rbuggyMatches=rbuggyMatches.length&&new RegExp(rbuggyMatches.join("|")),hasCompare=rnative.test(docElem.compareDocumentPosition),contains=hasCompare||rnative.test(docElem.contains)?function(a,b){var adown=9===a.nodeType?a.documentElement:a,bup=b&&b.parentNode;return a===bup||!(!bup||1!==bup.nodeType||!(adown.contains?adown.contains(bup):a.compareDocumentPosition&&16&a.compareDocumentPosition(bup)))}:function(a,b){if(b)for(;b=b.parentNode;)if(b===a)return!0;return!1},sortOrder=hasCompare?function(a,b){if(a===b)return hasDuplicate=!0,0;var compare=!a.compareDocumentPosition-!b.compareDocumentPosition;return compare||(compare=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&compare||!support.sortDetached&&b.compareDocumentPosition(a)===compare?a===document||a.ownerDocument===preferredDoc&&contains(preferredDoc,a)?-1:b===document||b.ownerDocument===preferredDoc&&contains(preferredDoc,b)?1:sortInput?indexOf(sortInput,a)-indexOf(sortInput,b):0:4&compare?-1:1)}:function(a,b){if(a===b)return hasDuplicate=!0,0;var cur,i=0,aup=a.parentNode,bup=b.parentNode,ap=[a],bp=[b];if(!aup||!bup)return a===document?-1:b===document?1:aup?-1:bup?1:sortInput?indexOf(sortInput,a)-indexOf(sortInput,b):0;if(aup===bup)return siblingCheck(a,b);for(cur=a;cur=cur.parentNode;)ap.unshift(cur);for(cur=b;cur=cur.parentNode;)bp.unshift(cur);for(;ap[i]===bp[i];)i++;return i?siblingCheck(ap[i],bp[i]):ap[i]===preferredDoc?-1:bp[i]===preferredDoc?1:0},document):document},Sizzle.matches=function(expr,elements){return Sizzle(expr,null,null,elements)},Sizzle.matchesSelector=function(elem,expr){if((elem.ownerDocument||elem)!==document&&setDocument(elem),expr=expr.replace(rattributeQuotes,"='$1']"),support.matchesSelector&&documentIsHTML&&!compilerCache[expr+" "]&&(!rbuggyMatches||!rbuggyMatches.test(expr))&&(!rbuggyQSA||!rbuggyQSA.test(expr)))try{var ret=matches.call(elem,expr);if(ret||support.disconnectedMatch||elem.document&&11!==elem.document.nodeType)return ret}catch(e){}return Sizzle(expr,document,null,[elem]).length>0},Sizzle.contains=function(context,elem){return(context.ownerDocument||context)!==document&&setDocument(context),contains(context,elem)},Sizzle.attr=function(elem,name){(elem.ownerDocument||elem)!==document&&setDocument(elem);var fn=Expr.attrHandle[name.toLowerCase()],val=fn&&hasOwn.call(Expr.attrHandle,name.toLowerCase())?fn(elem,name,!documentIsHTML):void 0;return void 0!==val?val:support.attributes||!documentIsHTML?elem.getAttribute(name):(val=elem.getAttributeNode(name))&&val.specified?val.value:null},Sizzle.escape=function(sel){return(sel+"").replace(rcssescape,fcssescape)},Sizzle.error=function(msg){throw new Error("Syntax error, unrecognized expression: "+msg)},Sizzle.uniqueSort=function(results){var elem,duplicates=[],j=0,i=0;if(hasDuplicate=!support.detectDuplicates,sortInput=!support.sortStable&&results.slice(0),results.sort(sortOrder),hasDuplicate){for(;elem=results[i++];)elem===results[i]&&(j=duplicates.push(i));for(;j--;)results.splice(duplicates[j],1)}return sortInput=null,results},getText=Sizzle.getText=function(elem){var node,ret="",i=0,nodeType=elem.nodeType;if(nodeType){if(1===nodeType||9===nodeType||11===nodeType){if("string"==typeof elem.textContent)return elem.textContent;for(elem=elem.firstChild;elem;elem=elem.nextSibling)ret+=getText(elem)}else if(3===nodeType||4===nodeType)return elem.nodeValue}else for(;node=elem[i++];)ret+=getText(node);return ret},Expr=Sizzle.selectors={cacheLength:50,createPseudo:markFunction,match:matchExpr,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(match){return match[1]=match[1].replace(runescape,funescape),match[3]=(match[3]||match[4]||match[5]||"").replace(runescape,funescape),"~="===match[2]&&(match[3]=" "+match[3]+" "),match.slice(0,4)},CHILD:function(match){return match[1]=match[1].toLowerCase(),"nth"===match[1].slice(0,3)?(match[3]||Sizzle.error(match[0]),match[4]=+(match[4]?match[5]+(match[6]||1):2*("even"===match[3]||"odd"===match[3])),match[5]=+(match[7]+match[8]||"odd"===match[3])):match[3]&&Sizzle.error(match[0]),match},PSEUDO:function(match){var excess,unquoted=!match[6]&&match[2];return matchExpr.CHILD.test(match[0])?null:(match[3]?match[2]=match[4]||match[5]||"":unquoted&&rpseudo.test(unquoted)&&(excess=tokenize(unquoted,!0))&&(excess=unquoted.indexOf(")",unquoted.length-excess)-unquoted.length)&&(match[0]=match[0].slice(0,excess),match[2]=unquoted.slice(0,excess)),match.slice(0,3))}},filter:{TAG:function(nodeNameSelector){var nodeName=nodeNameSelector.replace(runescape,funescape).toLowerCase();return"*"===nodeNameSelector?function(){return!0}:function(elem){return elem.nodeName&&elem.nodeName.toLowerCase()===nodeName}},CLASS:function(className){var pattern=classCache[className+" "];return pattern||(pattern=new RegExp("(^|"+whitespace+")"+className+"("+whitespace+"|$)"))&&classCache(className,function(elem){return pattern.test("string"==typeof elem.className&&elem.className||void 0!==elem.getAttribute&&elem.getAttribute("class")||"")})},ATTR:function(name,operator,check){return function(elem){var result=Sizzle.attr(elem,name);return null==result?"!="===operator:!operator||(result+="","="===operator?result===check:"!="===operator?result!==check:"^="===operator?check&&0===result.indexOf(check):"*="===operator?check&&result.indexOf(check)>-1:"$="===operator?check&&result.slice(-check.length)===check:"~="===operator?(" "+result.replace(rwhitespace," ")+" ").indexOf(check)>-1:"|="===operator&&(result===check||result.slice(0,check.length+1)===check+"-"))}},CHILD:function(type,what,argument,first,last){var simple="nth"!==type.slice(0,3),forward="last"!==type.slice(-4),ofType="of-type"===what;return 1===first&&0===last?function(elem){return!!elem.parentNode}:function(elem,context,xml){var cache,uniqueCache,outerCache,node,nodeIndex,start,dir=simple!==forward?"nextSibling":"previousSibling",parent=elem.parentNode,name=ofType&&elem.nodeName.toLowerCase(),useCache=!xml&&!ofType,diff=!1;if(parent){if(simple){for(;dir;){for(node=elem;node=node[dir];)if(ofType?node.nodeName.toLowerCase()===name:1===node.nodeType)return!1;start=dir="only"===type&&!start&&"nextSibling"}return!0}if(start=[forward?parent.firstChild:parent.lastChild],forward&&useCache){for(node=parent,outerCache=node[expando]||(node[expando]={}),uniqueCache=outerCache[node.uniqueID]||(outerCache[node.uniqueID]={}),cache=uniqueCache[type]||[],nodeIndex=cache[0]===dirruns&&cache[1],diff=nodeIndex&&cache[2],node=nodeIndex&&parent.childNodes[nodeIndex];node=++nodeIndex&&node&&node[dir]||(diff=nodeIndex=0)||start.pop();)if(1===node.nodeType&&++diff&&node===elem){uniqueCache[type]=[dirruns,nodeIndex,diff];break}}else if(useCache&&(node=elem,outerCache=node[expando]||(node[expando]={}),uniqueCache=outerCache[node.uniqueID]||(outerCache[node.uniqueID]={}),cache=uniqueCache[type]||[],nodeIndex=cache[0]===dirruns&&cache[1],diff=nodeIndex),!1===diff)for(;(node=++nodeIndex&&node&&node[dir]||(diff=nodeIndex=0)||start.pop())&&((ofType?node.nodeName.toLowerCase()!==name:1!==node.nodeType)||!++diff||(useCache&&(outerCache=node[expando]||(node[expando]={}),uniqueCache=outerCache[node.uniqueID]||(outerCache[node.uniqueID]={}),uniqueCache[type]=[dirruns,diff]),node!==elem)););return(diff-=last)===first||diff%first==0&&diff/first>=0}}},PSEUDO:function(pseudo,argument){var args,fn=Expr.pseudos[pseudo]||Expr.setFilters[pseudo.toLowerCase()]||Sizzle.error("unsupported pseudo: "+pseudo);return fn[expando]?fn(argument):fn.length>1?(args=[pseudo,pseudo,"",argument],Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())?markFunction(function(seed,matches){for(var idx,matched=fn(seed,argument),i=matched.length;i--;)idx=indexOf(seed,matched[i]),seed[idx]=!(matches[idx]=matched[i])}):function(elem){return fn(elem,0,args)}):fn}},pseudos:{not:markFunction(function(selector){var input=[],results=[],matcher=compile(selector.replace(rtrim,"$1"));return matcher[expando]?markFunction(function(seed,matches,context,xml){for(var elem,unmatched=matcher(seed,null,xml,[]),i=seed.length;i--;)(elem=unmatched[i])&&(seed[i]=!(matches[i]=elem))}):function(elem,context,xml){return input[0]=elem,matcher(input,null,xml,results),input[0]=null,!results.pop()}}),has:markFunction(function(selector){return function(elem){return Sizzle(selector,elem).length>0}}),contains:markFunction(function(text){return text=text.replace(runescape,funescape),function(elem){return(elem.textContent||elem.innerText||getText(elem)).indexOf(text)>-1}}),lang:markFunction(function(lang){return ridentifier.test(lang||"")||Sizzle.error("unsupported lang: "+lang),lang=lang.replace(runescape,funescape).toLowerCase(),function(elem){var elemLang;do{if(elemLang=documentIsHTML?elem.lang:elem.getAttribute("xml:lang")||elem.getAttribute("lang"))return(elemLang=elemLang.toLowerCase())===lang||0===elemLang.indexOf(lang+"-")}while((elem=elem.parentNode)&&1===elem.nodeType);return!1}}),target:function(elem){var hash=window.location&&window.location.hash;return hash&&hash.slice(1)===elem.id},root:function(elem){return elem===docElem},focus:function(elem){return elem===document.activeElement&&(!document.hasFocus||document.hasFocus())&&!!(elem.type||elem.href||~elem.tabIndex)},enabled:createDisabledPseudo(!1),disabled:createDisabledPseudo(!0),checked:function(elem){var nodeName=elem.nodeName.toLowerCase();return"input"===nodeName&&!!elem.checked||"option"===nodeName&&!!elem.selected},selected:function(elem){return elem.parentNode&&elem.parentNode.selectedIndex,!0===elem.selected},empty:function(elem){for(elem=elem.firstChild;elem;elem=elem.nextSibling)if(elem.nodeType<6)return!1;return!0},parent:function(elem){return!Expr.pseudos.empty(elem)},header:function(elem){return rheader.test(elem.nodeName)},input:function(elem){return rinputs.test(elem.nodeName)},button:function(elem){var name=elem.nodeName.toLowerCase();return"input"===name&&"button"===elem.type||"button"===name},text:function(elem){var attr;return"input"===elem.nodeName.toLowerCase()&&"text"===elem.type&&(null==(attr=elem.getAttribute("type"))||"text"===attr.toLowerCase())},first:createPositionalPseudo(function(){return[0]}),last:createPositionalPseudo(function(matchIndexes,length){return[length-1]}),eq:createPositionalPseudo(function(matchIndexes,length,argument){return[argument<0?argument+length:argument]}),even:createPositionalPseudo(function(matchIndexes,length){for(var i=0;i<length;i+=2)matchIndexes.push(i);return matchIndexes}),odd:createPositionalPseudo(function(matchIndexes,length){for(var i=1;i<length;i+=2)matchIndexes.push(i);return matchIndexes}),lt:createPositionalPseudo(function(matchIndexes,length,argument){for(var i=argument<0?argument+length:argument;--i>=0;)matchIndexes.push(i);return matchIndexes}),gt:createPositionalPseudo(function(matchIndexes,length,argument){for(var i=argument<0?argument+length:argument;++i<length;)matchIndexes.push(i);return matchIndexes})}},Expr.pseudos.nth=Expr.pseudos.eq;for(i in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})Expr.pseudos[i]=function(type){return function(elem){return"input"===elem.nodeName.toLowerCase()&&elem.type===type}}(i);for(i in{submit:!0,reset:!0})Expr.pseudos[i]=function(type){return function(elem){var name=elem.nodeName.toLowerCase();return("input"===name||"button"===name)&&elem.type===type}}(i);return setFilters.prototype=Expr.filters=Expr.pseudos,Expr.setFilters=new setFilters,tokenize=Sizzle.tokenize=function(selector,parseOnly){var matched,match,tokens,type,soFar,groups,preFilters,cached=tokenCache[selector+" "];if(cached)return parseOnly?0:cached.slice(0);for(soFar=selector,groups=[],preFilters=Expr.preFilter;soFar;){matched&&!(match=rcomma.exec(soFar))||(match&&(soFar=soFar.slice(match[0].length)||soFar),groups.push(tokens=[])),matched=!1,(match=rcombinators.exec(soFar))&&(matched=match.shift(),tokens.push({value:matched,type:match[0].replace(rtrim," ")}),soFar=soFar.slice(matched.length));for(type in Expr.filter)!(match=matchExpr[type].exec(soFar))||preFilters[type]&&!(match=preFilters[type](match))||(matched=match.shift(),tokens.push({value:matched,type:type,matches:match}),soFar=soFar.slice(matched.length));if(!matched)break}return parseOnly?soFar.length:soFar?Sizzle.error(selector):tokenCache(selector,groups).slice(0)},compile=Sizzle.compile=function(selector,match){var i,setMatchers=[],elementMatchers=[],cached=compilerCache[selector+" "];if(!cached){for(match||(match=tokenize(selector)),i=match.length;i--;)cached=matcherFromTokens(match[i]),cached[expando]?setMatchers.push(cached):elementMatchers.push(cached);cached=compilerCache(selector,matcherFromGroupMatchers(elementMatchers,setMatchers)),cached.selector=selector}return cached},select=Sizzle.select=function(selector,context,results,seed){var i,tokens,token,type,find,compiled="function"==typeof selector&&selector,match=!seed&&tokenize(selector=compiled.selector||selector);if(results=results||[],1===match.length){if(tokens=match[0]=match[0].slice(0),tokens.length>2&&"ID"===(token=tokens[0]).type&&9===context.nodeType&&documentIsHTML&&Expr.relative[tokens[1].type]){if(!(context=(Expr.find.ID(token.matches[0].replace(runescape,funescape),context)||[])[0]))return results;compiled&&(context=context.parentNode),selector=selector.slice(tokens.shift().value.length)}for(i=matchExpr.needsContext.test(selector)?0:tokens.length;i--&&(token=tokens[i],!Expr.relative[type=token.type]);)if((find=Expr.find[type])&&(seed=find(token.matches[0].replace(runescape,funescape),rsibling.test(tokens[0].type)&&testContext(context.parentNode)||context))){if(tokens.splice(i,1),!(selector=seed.length&&toSelector(tokens)))return push.apply(results,seed),results;break}}return(compiled||compile(selector,match))(seed,context,!documentIsHTML,results,!context||rsibling.test(selector)&&testContext(context.parentNode)||context),results},support.sortStable=expando.split("").sort(sortOrder).join("")===expando,support.detectDuplicates=!!hasDuplicate,setDocument(),support.sortDetached=assert(function(el){return 1&el.compareDocumentPosition(document.createElement("fieldset"))}),assert(function(el){return el.innerHTML="<a href='#'></a>","#"===el.firstChild.getAttribute("href")})||addHandle("type|href|height|width",function(elem,name,isXML){if(!isXML)return elem.getAttribute(name,"type"===name.toLowerCase()?1:2)}),support.attributes&&assert(function(el){return el.innerHTML="<input/>",el.firstChild.setAttribute("value",""),""===el.firstChild.getAttribute("value")})||addHandle("value",function(elem,name,isXML){if(!isXML&&"input"===elem.nodeName.toLowerCase())return elem.defaultValue}),assert(function(el){return null==el.getAttribute("disabled")})||addHandle(booleans,function(elem,name,isXML){var val;if(!isXML)return!0===elem[name]?name.toLowerCase():(val=elem.getAttributeNode(name))&&val.specified?val.value:null}),Sizzle}(window);jQuery.find=Sizzle,jQuery.expr=Sizzle.selectors,jQuery.expr[":"]=jQuery.expr.pseudos,jQuery.uniqueSort=jQuery.unique=Sizzle.uniqueSort,jQuery.text=Sizzle.getText,jQuery.isXMLDoc=Sizzle.isXML,jQuery.contains=Sizzle.contains,jQuery.escapeSelector=Sizzle.escape;var dir=function(elem,dir,until){for(var matched=[],truncate=void 0!==until;(elem=elem[dir])&&9!==elem.nodeType;)if(1===elem.nodeType){if(truncate&&jQuery(elem).is(until))break;matched.push(elem)}return matched},siblings=function(n,elem){for(var matched=[];n;n=n.nextSibling)1===n.nodeType&&n!==elem&&matched.push(n);return matched},rneedsContext=jQuery.expr.match.needsContext,rsingleTag=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,risSimple=/^.[^:#\[\.,]*$/;jQuery.filter=function(expr,elems,not){var elem=elems[0];return not&&(expr=":not("+expr+")"),1===elems.length&&1===elem.nodeType?jQuery.find.matchesSelector(elem,expr)?[elem]:[]:jQuery.find.matches(expr,jQuery.grep(elems,function(elem){return 1===elem.nodeType}))},jQuery.fn.extend({find:function(selector){var i,ret,len=this.length,self=this;if("string"!=typeof selector)return this.pushStack(jQuery(selector).filter(function(){for(i=0;i<len;i++)if(jQuery.contains(self[i],this))return!0}));for(ret=this.pushStack([]),i=0;i<len;i++)jQuery.find(selector,self[i],ret);return len>1?jQuery.uniqueSort(ret):ret},filter:function(selector){return this.pushStack(winnow(this,selector||[],!1))},not:function(selector){return this.pushStack(winnow(this,selector||[],!0))},is:function(selector){return!!winnow(this,"string"==typeof selector&&rneedsContext.test(selector)?jQuery(selector):selector||[],!1).length}});var rootjQuery,rquickExpr=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(jQuery.fn.init=function(selector,context,root){var match,elem;if(!selector)return this;if(root=root||rootjQuery,"string"==typeof selector){if(!(match="<"===selector[0]&&">"===selector[selector.length-1]&&selector.length>=3?[null,selector,null]:rquickExpr.exec(selector))||!match[1]&&context)return!context||context.jquery?(context||root).find(selector):this.constructor(context).find(selector);if(match[1]){if(context=context instanceof jQuery?context[0]:context,jQuery.merge(this,jQuery.parseHTML(match[1],context&&context.nodeType?context.ownerDocument||context:document,!0)),rsingleTag.test(match[1])&&jQuery.isPlainObject(context))for(match in context)jQuery.isFunction(this[match])?this[match](context[match]):this.attr(match,context[match]);return this}return elem=document.getElementById(match[2]),elem&&(this[0]=elem,this.length=1),this}return selector.nodeType?(this[0]=selector,this.length=1,this):jQuery.isFunction(selector)?void 0!==root.ready?root.ready(selector):selector(jQuery):jQuery.makeArray(selector,this)}).prototype=jQuery.fn,rootjQuery=jQuery(document);var rparentsprev=/^(?:parents|prev(?:Until|All))/,guaranteedUnique={children:!0,contents:!0,next:!0,prev:!0};jQuery.fn.extend({has:function(target){var targets=jQuery(target,this),l=targets.length;return this.filter(function(){for(var i=0;i<l;i++)if(jQuery.contains(this,targets[i]))return!0})},closest:function(selectors,context){var cur,i=0,l=this.length,matched=[],targets="string"!=typeof selectors&&jQuery(selectors);if(!rneedsContext.test(selectors))for(;i<l;i++)for(cur=this[i];cur&&cur!==context;cur=cur.parentNode)if(cur.nodeType<11&&(targets?targets.index(cur)>-1:1===cur.nodeType&&jQuery.find.matchesSelector(cur,selectors))){matched.push(cur);break}return this.pushStack(matched.length>1?jQuery.uniqueSort(matched):matched)},index:function(elem){return elem?"string"==typeof elem?indexOf.call(jQuery(elem),this[0]):indexOf.call(this,elem.jquery?elem[0]:elem):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(selector,context){return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(),jQuery(selector,context))))},addBack:function(selector){return this.add(null==selector?this.prevObject:this.prevObject.filter(selector))}}),jQuery.each({parent:function(elem){var parent=elem.parentNode;return parent&&11!==parent.nodeType?parent:null},parents:function(elem){return dir(elem,"parentNode")},parentsUntil:function(elem,i,until){return dir(elem,"parentNode",until)},next:function(elem){return sibling(elem,"nextSibling")},prev:function(elem){return sibling(elem,"previousSibling")},nextAll:function(elem){return dir(elem,"nextSibling")},prevAll:function(elem){return dir(elem,"previousSibling")},nextUntil:function(elem,i,until){return dir(elem,"nextSibling",until)},prevUntil:function(elem,i,until){return dir(elem,"previousSibling",until)},siblings:function(elem){return siblings((elem.parentNode||{}).firstChild,elem)},children:function(elem){return siblings(elem.firstChild)},contents:function(elem){return nodeName(elem,"iframe")?elem.contentDocument:(nodeName(elem,"template")&&(elem=elem.content||elem),jQuery.merge([],elem.childNodes))}},function(name,fn){jQuery.fn[name]=function(until,selector){var matched=jQuery.map(this,fn,until);return"Until"!==name.slice(-5)&&(selector=until),selector&&"string"==typeof selector&&(matched=jQuery.filter(selector,matched)),this.length>1&&(guaranteedUnique[name]||jQuery.uniqueSort(matched),rparentsprev.test(name)&&matched.reverse()),this.pushStack(matched)}});var rnothtmlwhite=/[^\x20\t\r\n\f]+/g;jQuery.Callbacks=function(options){options="string"==typeof options?createOptions(options):jQuery.extend({},options);var firing,memory,fired,locked,list=[],queue=[],firingIndex=-1,fire=function(){for(locked=locked||options.once,fired=firing=!0;queue.length;firingIndex=-1)for(memory=queue.shift();++firingIndex<list.length;)!1===list[firingIndex].apply(memory[0],memory[1])&&options.stopOnFalse&&(firingIndex=list.length,memory=!1);options.memory||(memory=!1),firing=!1,locked&&(list=memory?[]:"")},self={add:function(){return list&&(memory&&!firing&&(firingIndex=list.length-1,queue.push(memory)),function add(args){jQuery.each(args,function(_,arg){jQuery.isFunction(arg)?options.unique&&self.has(arg)||list.push(arg):arg&&arg.length&&"string"!==jQuery.type(arg)&&add(arg)})}(arguments),memory&&!firing&&fire()),this},remove:function(){return jQuery.each(arguments,function(_,arg){for(var index;(index=jQuery.inArray(arg,list,index))>-1;)list.splice(index,1),index<=firingIndex&&firingIndex--}),this},has:function(fn){return fn?jQuery.inArray(fn,list)>-1:list.length>0},empty:function(){return list&&(list=[]),this},disable:function(){return locked=queue=[],list=memory="",this},disabled:function(){return!list},lock:function(){return locked=queue=[],memory||firing||(list=memory=""),this},locked:function(){return!!locked},fireWith:function(context,args){return locked||(args=args||[],args=[context,args.slice?args.slice():args],queue.push(args),firing||fire()),this},fire:function(){return self.fireWith(this,arguments),this},fired:function(){return!!fired}};return self},jQuery.extend({Deferred:function(func){var tuples=[["notify","progress",jQuery.Callbacks("memory"),jQuery.Callbacks("memory"),2],["resolve","done",jQuery.Callbacks("once memory"),jQuery.Callbacks("once memory"),0,"resolved"],["reject","fail",jQuery.Callbacks("once memory"),jQuery.Callbacks("once memory"),1,"rejected"]],state="pending",promise={state:function(){return state},always:function(){return deferred.done(arguments).fail(arguments),this},catch:function(fn){return promise.then(null,fn)},pipe:function(){var fns=arguments;return jQuery.Deferred(function(newDefer){jQuery.each(tuples,function(i,tuple){var fn=jQuery.isFunction(fns[tuple[4]])&&fns[tuple[4]];deferred[tuple[1]](function(){var returned=fn&&fn.apply(this,arguments);returned&&jQuery.isFunction(returned.promise)?returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject):newDefer[tuple[0]+"With"](this,fn?[returned]:arguments)})}),fns=null}).promise()},then:function(onFulfilled,onRejected,onProgress){function resolve(depth,deferred,handler,special){return function(){var that=this,args=arguments,mightThrow=function(){var returned,then;if(!(depth<maxDepth)){if((returned=handler.apply(that,args))===deferred.promise())throw new TypeError("Thenable self-resolution");then=returned&&("object"==typeof returned||"function"==typeof returned)&&returned.then,jQuery.isFunction(then)?special?then.call(returned,resolve(maxDepth,deferred,Identity,special),resolve(maxDepth,deferred,Thrower,special)):(maxDepth++,then.call(returned,resolve(maxDepth,deferred,Identity,special),resolve(maxDepth,deferred,Thrower,special),resolve(maxDepth,deferred,Identity,deferred.notifyWith))):(handler!==Identity&&(that=void 0,args=[returned]),(special||deferred.resolveWith)(that,args))}},process=special?mightThrow:function(){try{mightThrow()}catch(e){jQuery.Deferred.exceptionHook&&jQuery.Deferred.exceptionHook(e,process.stackTrace),depth+1>=maxDepth&&(handler!==Thrower&&(that=void 0,args=[e]),deferred.rejectWith(that,args))}};depth?process():(jQuery.Deferred.getStackHook&&(process.stackTrace=jQuery.Deferred.getStackHook()),window.setTimeout(process))}}var maxDepth=0;return jQuery.Deferred(function(newDefer){tuples[0][3].add(resolve(0,newDefer,jQuery.isFunction(onProgress)?onProgress:Identity,newDefer.notifyWith)),tuples[1][3].add(resolve(0,newDefer,jQuery.isFunction(onFulfilled)?onFulfilled:Identity)),tuples[2][3].add(resolve(0,newDefer,jQuery.isFunction(onRejected)?onRejected:Thrower))}).promise()},promise:function(obj){return null!=obj?jQuery.extend(obj,promise):promise}},deferred={};return jQuery.each(tuples,function(i,tuple){var list=tuple[2],stateString=tuple[5];promise[tuple[1]]=list.add,stateString&&list.add(function(){state=stateString},tuples[3-i][2].disable,tuples[0][2].lock),list.add(tuple[3].fire),deferred[tuple[0]]=function(){return deferred[tuple[0]+"With"](this===deferred?void 0:this,arguments),this},deferred[tuple[0]+"With"]=list.fireWith}),promise.promise(deferred),func&&func.call(deferred,deferred),deferred},when:function(singleValue){var remaining=arguments.length,i=remaining,resolveContexts=Array(i),resolveValues=slice.call(arguments),master=jQuery.Deferred(),updateFunc=function(i){return function(value){resolveContexts[i]=this,resolveValues[i]=arguments.length>1?slice.call(arguments):value,--remaining||master.resolveWith(resolveContexts,resolveValues)}};if(remaining<=1&&(adoptValue(singleValue,master.done(updateFunc(i)).resolve,master.reject,!remaining),"pending"===master.state()||jQuery.isFunction(resolveValues[i]&&resolveValues[i].then)))return master.then();for(;i--;)adoptValue(resolveValues[i],updateFunc(i),master.reject);return master.promise()}});var rerrorNames=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;jQuery.Deferred.exceptionHook=function(error,stack){window.console&&window.console.warn&&error&&rerrorNames.test(error.name)&&window.console.warn("jQuery.Deferred exception: "+error.message,error.stack,stack)},jQuery.readyException=function(error){window.setTimeout(function(){throw error})};var readyList=jQuery.Deferred();jQuery.fn.ready=function(fn){return readyList.then(fn).catch(function(error){jQuery.readyException(error)}),this},jQuery.extend({isReady:!1,readyWait:1,ready:function(wait){(!0===wait?--jQuery.readyWait:jQuery.isReady)||(jQuery.isReady=!0,!0!==wait&&--jQuery.readyWait>0||readyList.resolveWith(document,[jQuery]))}}),jQuery.ready.then=readyList.then,"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(jQuery.ready):(document.addEventListener("DOMContentLoaded",completed),window.addEventListener("load",completed));var access=function(elems,fn,key,value,chainable,emptyGet,raw){var i=0,len=elems.length,bulk=null==key;if("object"===jQuery.type(key)){chainable=!0;for(i in key)access(elems,fn,i,key[i],!0,emptyGet,raw)}else if(void 0!==value&&(chainable=!0,jQuery.isFunction(value)||(raw=!0),bulk&&(raw?(fn.call(elems,value),fn=null):(bulk=fn,fn=function(elem,key,value){return bulk.call(jQuery(elem),value)})),fn))for(;i<len;i++)fn(elems[i],key,raw?value:value.call(elems[i],i,fn(elems[i],key)));return chainable?elems:bulk?fn.call(elems):len?fn(elems[0],key):emptyGet},acceptData=function(owner){return 1===owner.nodeType||9===owner.nodeType||!+owner.nodeType};Data.uid=1,Data.prototype={cache:function(owner){var value=owner[this.expando];return value||(value={},acceptData(owner)&&(owner.nodeType?owner[this.expando]=value:Object.defineProperty(owner,this.expando,{value:value,configurable:!0}))),value},set:function(owner,data,value){var prop,cache=this.cache(owner);if("string"==typeof data)cache[jQuery.camelCase(data)]=value;else for(prop in data)cache[jQuery.camelCase(prop)]=data[prop];return cache},get:function(owner,key){return void 0===key?this.cache(owner):owner[this.expando]&&owner[this.expando][jQuery.camelCase(key)]},access:function(owner,key,value){return void 0===key||key&&"string"==typeof key&&void 0===value?this.get(owner,key):(this.set(owner,key,value),void 0!==value?value:key)},remove:function(owner,key){var i,cache=owner[this.expando];if(void 0!==cache){if(void 0!==key){Array.isArray(key)?key=key.map(jQuery.camelCase):(key=jQuery.camelCase(key),key=key in cache?[key]:key.match(rnothtmlwhite)||[]),i=key.length;for(;i--;)delete cache[key[i]]}(void 0===key||jQuery.isEmptyObject(cache))&&(owner.nodeType?owner[this.expando]=void 0:delete owner[this.expando])}},hasData:function(owner){var cache=owner[this.expando];return void 0!==cache&&!jQuery.isEmptyObject(cache)}};var dataPriv=new Data,dataUser=new Data,rbrace=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,rmultiDash=/[A-Z]/g;jQuery.extend({hasData:function(elem){return dataUser.hasData(elem)||dataPriv.hasData(elem)},data:function(elem,name,data){return dataUser.access(elem,name,data)},removeData:function(elem,name){dataUser.remove(elem,name)},_data:function(elem,name,data){return dataPriv.access(elem,name,data)},_removeData:function(elem,name){dataPriv.remove(elem,name)}}),jQuery.fn.extend({data:function(key,value){var i,name,data,elem=this[0],attrs=elem&&elem.attributes;if(void 0===key){if(this.length&&(data=dataUser.get(elem),1===elem.nodeType&&!dataPriv.get(elem,"hasDataAttrs"))){for(i=attrs.length;i--;)attrs[i]&&(name=attrs[i].name,0===name.indexOf("data-")&&(name=jQuery.camelCase(name.slice(5)),dataAttr(elem,name,data[name])));dataPriv.set(elem,"hasDataAttrs",!0)}return data}return"object"==typeof key?this.each(function(){dataUser.set(this,key)}):access(this,function(value){var data;if(elem&&void 0===value){if(void 0!==(data=dataUser.get(elem,key)))return data;if(void 0!==(data=dataAttr(elem,key)))return data}else this.each(function(){dataUser.set(this,key,value)})},null,value,arguments.length>1,null,!0)},removeData:function(key){return this.each(function(){dataUser.remove(this,key)})}}),jQuery.extend({queue:function(elem,type,data){var queue;if(elem)return type=(type||"fx")+"queue",queue=dataPriv.get(elem,type),data&&(!queue||Array.isArray(data)?queue=dataPriv.access(elem,type,jQuery.makeArray(data)):queue.push(data)),queue||[]},dequeue:function(elem,type){type=type||"fx";var queue=jQuery.queue(elem,type),startLength=queue.length,fn=queue.shift(),hooks=jQuery._queueHooks(elem,type),next=function(){jQuery.dequeue(elem,type)};"inprogress"===fn&&(fn=queue.shift(),startLength--),fn&&("fx"===type&&queue.unshift("inprogress"),delete hooks.stop,fn.call(elem,next,hooks)),!startLength&&hooks&&hooks.empty.fire()},_queueHooks:function(elem,type){var key=type+"queueHooks";return dataPriv.get(elem,key)||dataPriv.access(elem,key,{empty:jQuery.Callbacks("once memory").add(function(){dataPriv.remove(elem,[type+"queue",key])})})}}),jQuery.fn.extend({queue:function(type,data){var setter=2;return"string"!=typeof type&&(data=type,type="fx",setter--),arguments.length<setter?jQuery.queue(this[0],type):void 0===data?this:this.each(function(){var queue=jQuery.queue(this,type,data);jQuery._queueHooks(this,type),"fx"===type&&"inprogress"!==queue[0]&&jQuery.dequeue(this,type)})},dequeue:function(type){return this.each(function(){jQuery.dequeue(this,type)})},clearQueue:function(type){return this.queue(type||"fx",[])},promise:function(type,obj){var tmp,count=1,defer=jQuery.Deferred(),elements=this,i=this.length,resolve=function(){--count||defer.resolveWith(elements,[elements])};for("string"!=typeof type&&(obj=type,type=void 0),type=type||"fx";i--;)(tmp=dataPriv.get(elements[i],type+"queueHooks"))&&tmp.empty&&(count++,tmp.empty.add(resolve));return resolve(),defer.promise(obj)}});var pnum=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,rcssNum=new RegExp("^(?:([+-])=|)("+pnum+")([a-z%]*)$","i"),cssExpand=["Top","Right","Bottom","Left"],isHiddenWithinTree=function(elem,el){return elem=el||elem,"none"===elem.style.display||""===elem.style.display&&jQuery.contains(elem.ownerDocument,elem)&&"none"===jQuery.css(elem,"display")},swap=function(elem,options,callback,args){var ret,name,old={};for(name in options)old[name]=elem.style[name],elem.style[name]=options[name];ret=callback.apply(elem,args||[]);for(name in options)elem.style[name]=old[name];return ret},defaultDisplayMap={};jQuery.fn.extend({show:function(){return showHide(this,!0)},hide:function(){return showHide(this)},toggle:function(state){return"boolean"==typeof state?state?this.show():this.hide():this.each(function(){isHiddenWithinTree(this)?jQuery(this).show():jQuery(this).hide()})}});var rcheckableType=/^(?:checkbox|radio)$/i,rtagName=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,rscriptType=/^$|\/(?:java|ecma)script/i,wrapMap={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};wrapMap.optgroup=wrapMap.option,wrapMap.tbody=wrapMap.tfoot=wrapMap.colgroup=wrapMap.caption=wrapMap.thead,wrapMap.th=wrapMap.td;var rhtml=/<|&#?\w+;/;!function(){var fragment=document.createDocumentFragment(),div=fragment.appendChild(document.createElement("div")),input=document.createElement("input");input.setAttribute("type","radio"),input.setAttribute("checked","checked"),input.setAttribute("name","t"),div.appendChild(input),support.checkClone=div.cloneNode(!0).cloneNode(!0).lastChild.checked,div.innerHTML="<textarea>x</textarea>",support.noCloneChecked=!!div.cloneNode(!0).lastChild.defaultValue}();var documentElement=document.documentElement,rkeyEvent=/^key/,rmouseEvent=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,rtypenamespace=/^([^.]*)(?:\.(.+)|)/;jQuery.event={global:{},add:function(elem,types,handler,data,selector){var handleObjIn,eventHandle,tmp,events,t,handleObj,special,handlers,type,namespaces,origType,elemData=dataPriv.get(elem);if(elemData)for(handler.handler&&(handleObjIn=handler,handler=handleObjIn.handler,selector=handleObjIn.selector),selector&&jQuery.find.matchesSelector(documentElement,selector),handler.guid||(handler.guid=jQuery.guid++),(events=elemData.events)||(events=elemData.events={}),(eventHandle=elemData.handle)||(eventHandle=elemData.handle=function(e){return void 0!==jQuery&&jQuery.event.triggered!==e.type?jQuery.event.dispatch.apply(elem,arguments):void 0}),types=(types||"").match(rnothtmlwhite)||[""],t=types.length;t--;)tmp=rtypenamespace.exec(types[t])||[],type=origType=tmp[1],namespaces=(tmp[2]||"").split(".").sort(),type&&(special=jQuery.event.special[type]||{},type=(selector?special.delegateType:special.bindType)||type,special=jQuery.event.special[type]||{},handleObj=jQuery.extend({type:type,origType:origType,data:data,handler:handler,guid:handler.guid,selector:selector,needsContext:selector&&jQuery.expr.match.needsContext.test(selector),namespace:namespaces.join(".")},handleObjIn),(handlers=events[type])||(handlers=events[type]=[],handlers.delegateCount=0,special.setup&&!1!==special.setup.call(elem,data,namespaces,eventHandle)||elem.addEventListener&&elem.addEventListener(type,eventHandle)),special.add&&(special.add.call(elem,handleObj),handleObj.handler.guid||(handleObj.handler.guid=handler.guid)),selector?handlers.splice(handlers.delegateCount++,0,handleObj):handlers.push(handleObj),jQuery.event.global[type]=!0)},remove:function(elem,types,handler,selector,mappedTypes){var j,origCount,tmp,events,t,handleObj,special,handlers,type,namespaces,origType,elemData=dataPriv.hasData(elem)&&dataPriv.get(elem);if(elemData&&(events=elemData.events)){for(types=(types||"").match(rnothtmlwhite)||[""],t=types.length;t--;)if(tmp=rtypenamespace.exec(types[t])||[],type=origType=tmp[1],namespaces=(tmp[2]||"").split(".").sort(),type){for(special=jQuery.event.special[type]||{},type=(selector?special.delegateType:special.bindType)||type,handlers=events[type]||[],tmp=tmp[2]&&new RegExp("(^|\\.)"+namespaces.join("\\.(?:.*\\.|)")+"(\\.|$)"),origCount=j=handlers.length;j--;)handleObj=handlers[j],!mappedTypes&&origType!==handleObj.origType||handler&&handler.guid!==handleObj.guid||tmp&&!tmp.test(handleObj.namespace)||selector&&selector!==handleObj.selector&&("**"!==selector||!handleObj.selector)||(handlers.splice(j,1),handleObj.selector&&handlers.delegateCount--,special.remove&&special.remove.call(elem,handleObj));origCount&&!handlers.length&&(special.teardown&&!1!==special.teardown.call(elem,namespaces,elemData.handle)||jQuery.removeEvent(elem,type,elemData.handle),delete events[type])}else for(type in events)jQuery.event.remove(elem,type+types[t],handler,selector,!0);jQuery.isEmptyObject(events)&&dataPriv.remove(elem,"handle events")}},dispatch:function(nativeEvent){var i,j,ret,matched,handleObj,handlerQueue,event=jQuery.event.fix(nativeEvent),args=new Array(arguments.length),handlers=(dataPriv.get(this,"events")||{})[event.type]||[],special=jQuery.event.special[event.type]||{};for(args[0]=event,i=1;i<arguments.length;i++)args[i]=arguments[i];if(event.delegateTarget=this,!special.preDispatch||!1!==special.preDispatch.call(this,event)){for(handlerQueue=jQuery.event.handlers.call(this,event,handlers),i=0;(matched=handlerQueue[i++])&&!event.isPropagationStopped();)for(event.currentTarget=matched.elem,j=0;(handleObj=matched.handlers[j++])&&!event.isImmediatePropagationStopped();)event.rnamespace&&!event.rnamespace.test(handleObj.namespace)||(event.handleObj=handleObj,event.data=handleObj.data,void 0!==(ret=((jQuery.event.special[handleObj.origType]||{}).handle||handleObj.handler).apply(matched.elem,args))&&!1===(event.result=ret)&&(event.preventDefault(),event.stopPropagation()));return special.postDispatch&&special.postDispatch.call(this,event),event.result}},handlers:function(event,handlers){var i,handleObj,sel,matchedHandlers,matchedSelectors,handlerQueue=[],delegateCount=handlers.delegateCount,cur=event.target;if(delegateCount&&cur.nodeType&&!("click"===event.type&&event.button>=1))for(;cur!==this;cur=cur.parentNode||this)if(1===cur.nodeType&&("click"!==event.type||!0!==cur.disabled)){for(matchedHandlers=[],matchedSelectors={},i=0;i<delegateCount;i++)handleObj=handlers[i],sel=handleObj.selector+" ",void 0===matchedSelectors[sel]&&(matchedSelectors[sel]=handleObj.needsContext?jQuery(sel,this).index(cur)>-1:jQuery.find(sel,this,null,[cur]).length),matchedSelectors[sel]&&matchedHandlers.push(handleObj);matchedHandlers.length&&handlerQueue.push({elem:cur,handlers:matchedHandlers})}return cur=this,delegateCount<handlers.length&&handlerQueue.push({elem:cur,handlers:handlers.slice(delegateCount)}),handlerQueue},addProp:function(name,hook){Object.defineProperty(jQuery.Event.prototype,name,{enumerable:!0,configurable:!0,get:jQuery.isFunction(hook)?function(){if(this.originalEvent)return hook(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[name]},set:function(value){Object.defineProperty(this,name,{enumerable:!0,configurable:!0,writable:!0,value:value})}})},fix:function(originalEvent){return originalEvent[jQuery.expando]?originalEvent:new jQuery.Event(originalEvent)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==safeActiveElement()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===safeActiveElement()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&nodeName(this,"input"))return this.click(),!1},_default:function(event){return nodeName(event.target,"a")}},beforeunload:{postDispatch:function(event){void 0!==event.result&&event.originalEvent&&(event.originalEvent.returnValue=event.result)}}}},jQuery.removeEvent=function(elem,type,handle){elem.removeEventListener&&elem.removeEventListener(type,handle)},jQuery.Event=function(src,props){if(!(this instanceof jQuery.Event))return new jQuery.Event(src,props);src&&src.type?(this.originalEvent=src,this.type=src.type,this.isDefaultPrevented=src.defaultPrevented||void 0===src.defaultPrevented&&!1===src.returnValue?returnTrue:returnFalse,this.target=src.target&&3===src.target.nodeType?src.target.parentNode:src.target,this.currentTarget=src.currentTarget,this.relatedTarget=src.relatedTarget):this.type=src,props&&jQuery.extend(this,props),this.timeStamp=src&&src.timeStamp||jQuery.now(),this[jQuery.expando]=!0},jQuery.Event.prototype={constructor:jQuery.Event,isDefaultPrevented:returnFalse,isPropagationStopped:returnFalse,isImmediatePropagationStopped:returnFalse,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=returnTrue,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=returnTrue,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=returnTrue,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},jQuery.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(event){var button=event.button;return null==event.which&&rkeyEvent.test(event.type)?null!=event.charCode?event.charCode:event.keyCode:!event.which&&void 0!==button&&rmouseEvent.test(event.type)?1&button?1:2&button?3:4&button?2:0:event.which}},jQuery.event.addProp),jQuery.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(orig,fix){jQuery.event.special[orig]={delegateType:fix,bindType:fix,handle:function(event){var ret,target=this,related=event.relatedTarget,handleObj=event.handleObj;return related&&(related===target||jQuery.contains(target,related))||(event.type=handleObj.origType,ret=handleObj.handler.apply(this,arguments),event.type=fix),ret}}}),jQuery.fn.extend({on:function(types,selector,data,fn){return on(this,types,selector,data,fn)},one:function(types,selector,data,fn){return on(this,types,selector,data,fn,1)},off:function(types,selector,fn){var handleObj,type;if(types&&types.preventDefault&&types.handleObj)return handleObj=types.handleObj,jQuery(types.delegateTarget).off(handleObj.namespace?handleObj.origType+"."+handleObj.namespace:handleObj.origType,handleObj.selector,handleObj.handler),this;if("object"==typeof types){for(type in types)this.off(type,selector,types[type]);return this}return!1!==selector&&"function"!=typeof selector||(fn=selector,selector=void 0),!1===fn&&(fn=returnFalse),this.each(function(){jQuery.event.remove(this,types,fn,selector)})}});var rxhtmlTag=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,rnoInnerhtml=/<script|<style|<link/i,rchecked=/checked\s*(?:[^=]|=\s*.checked.)/i,rscriptTypeMasked=/^true\/(.*)/,rcleanScript=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;jQuery.extend({htmlPrefilter:function(html){return html.replace(rxhtmlTag,"<$1></$2>")},clone:function(elem,dataAndEvents,deepDataAndEvents){var i,l,srcElements,destElements,clone=elem.cloneNode(!0),inPage=jQuery.contains(elem.ownerDocument,elem);if(!(support.noCloneChecked||1!==elem.nodeType&&11!==elem.nodeType||jQuery.isXMLDoc(elem)))for(destElements=getAll(clone),srcElements=getAll(elem),i=0,l=srcElements.length;i<l;i++)fixInput(srcElements[i],destElements[i]);if(dataAndEvents)if(deepDataAndEvents)for(srcElements=srcElements||getAll(elem),destElements=destElements||getAll(clone),i=0,l=srcElements.length;i<l;i++)cloneCopyEvent(srcElements[i],destElements[i]);else cloneCopyEvent(elem,clone);return destElements=getAll(clone,"script"),destElements.length>0&&setGlobalEval(destElements,!inPage&&getAll(elem,"script")),clone},cleanData:function(elems){for(var data,elem,type,special=jQuery.event.special,i=0;void 0!==(elem=elems[i]);i++)if(acceptData(elem)){if(data=elem[dataPriv.expando]){if(data.events)for(type in data.events)special[type]?jQuery.event.remove(elem,type):jQuery.removeEvent(elem,type,data.handle);elem[dataPriv.expando]=void 0}elem[dataUser.expando]&&(elem[dataUser.expando]=void 0)}}}),jQuery.fn.extend({detach:function(selector){return remove(this,selector,!0)},remove:function(selector){return remove(this,selector)},text:function(value){return access(this,function(value){return void 0===value?jQuery.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=value)})},null,value,arguments.length)},append:function(){return domManip(this,arguments,function(elem){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){manipulationTarget(this,elem).appendChild(elem)}})},prepend:function(){return domManip(this,arguments,function(elem){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var target=manipulationTarget(this,elem);target.insertBefore(elem,target.firstChild)}})},before:function(){return domManip(this,arguments,function(elem){this.parentNode&&this.parentNode.insertBefore(elem,this)})},after:function(){return domManip(this,arguments,function(elem){this.parentNode&&this.parentNode.insertBefore(elem,this.nextSibling)})},empty:function(){for(var elem,i=0;null!=(elem=this[i]);i++)1===elem.nodeType&&(jQuery.cleanData(getAll(elem,!1)),elem.textContent="");return this},clone:function(dataAndEvents,deepDataAndEvents){return dataAndEvents=null!=dataAndEvents&&dataAndEvents,deepDataAndEvents=null==deepDataAndEvents?dataAndEvents:deepDataAndEvents,this.map(function(){return jQuery.clone(this,dataAndEvents,deepDataAndEvents)})},html:function(value){return access(this,function(value){var elem=this[0]||{},i=0,l=this.length;if(void 0===value&&1===elem.nodeType)return elem.innerHTML;if("string"==typeof value&&!rnoInnerhtml.test(value)&&!wrapMap[(rtagName.exec(value)||["",""])[1].toLowerCase()]){value=jQuery.htmlPrefilter(value);try{for(;i<l;i++)elem=this[i]||{},1===elem.nodeType&&(jQuery.cleanData(getAll(elem,!1)),elem.innerHTML=value);elem=0}catch(e){}}elem&&this.empty().append(value)},null,value,arguments.length)},replaceWith:function(){var ignored=[];return domManip(this,arguments,function(elem){var parent=this.parentNode;jQuery.inArray(this,ignored)<0&&(jQuery.cleanData(getAll(this)),parent&&parent.replaceChild(elem,this))},ignored)}}),jQuery.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(name,original){jQuery.fn[name]=function(selector){for(var elems,ret=[],insert=jQuery(selector),last=insert.length-1,i=0;i<=last;i++)elems=i===last?this:this.clone(!0),jQuery(insert[i])[original](elems),push.apply(ret,elems.get());return this.pushStack(ret)}});var rmargin=/^margin/,rnumnonpx=new RegExp("^("+pnum+")(?!px)[a-z%]+$","i"),getStyles=function(elem){var view=elem.ownerDocument.defaultView;return view&&view.opener||(view=window),view.getComputedStyle(elem)};!function(){function computeStyleTests(){if(div){div.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",div.innerHTML="",documentElement.appendChild(container);var divStyle=window.getComputedStyle(div);pixelPositionVal="1%"!==divStyle.top,reliableMarginLeftVal="2px"===divStyle.marginLeft,boxSizingReliableVal="4px"===divStyle.width,div.style.marginRight="50%",pixelMarginRightVal="4px"===divStyle.marginRight,documentElement.removeChild(container),div=null}}var pixelPositionVal,boxSizingReliableVal,pixelMarginRightVal,reliableMarginLeftVal,container=document.createElement("div"),div=document.createElement("div");div.style&&(div.style.backgroundClip="content-box",div.cloneNode(!0).style.backgroundClip="",support.clearCloneStyle="content-box"===div.style.backgroundClip,container.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",container.appendChild(div),jQuery.extend(support,{pixelPosition:function(){return computeStyleTests(),pixelPositionVal},boxSizingReliable:function(){return computeStyleTests(),boxSizingReliableVal},pixelMarginRight:function(){return computeStyleTests(),pixelMarginRightVal},reliableMarginLeft:function(){return computeStyleTests(),reliableMarginLeftVal}}))}();var rdisplayswap=/^(none|table(?!-c[ea]).+)/,rcustomProp=/^--/,cssShow={position:"absolute",visibility:"hidden",display:"block"},cssNormalTransform={letterSpacing:"0",fontWeight:"400"},cssPrefixes=["Webkit","Moz","ms"],emptyStyle=document.createElement("div").style;jQuery.extend({cssHooks:{opacity:{get:function(elem,computed){if(computed){var ret=curCSS(elem,"opacity");return""===ret?"1":ret}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{float:"cssFloat"},style:function(elem,name,value,extra){if(elem&&3!==elem.nodeType&&8!==elem.nodeType&&elem.style){var ret,type,hooks,origName=jQuery.camelCase(name),isCustomProp=rcustomProp.test(name),style=elem.style;if(isCustomProp||(name=finalPropName(origName)),hooks=jQuery.cssHooks[name]||jQuery.cssHooks[origName],void 0===value)return hooks&&"get"in hooks&&void 0!==(ret=hooks.get(elem,!1,extra))?ret:style[name];type=typeof value,"string"===type&&(ret=rcssNum.exec(value))&&ret[1]&&(value=adjustCSS(elem,name,ret),type="number"),null!=value&&value===value&&("number"===type&&(value+=ret&&ret[3]||(jQuery.cssNumber[origName]?"":"px")),support.clearCloneStyle||""!==value||0!==name.indexOf("background")||(style[name]="inherit"),hooks&&"set"in hooks&&void 0===(value=hooks.set(elem,value,extra))||(isCustomProp?style.setProperty(name,value):style[name]=value))}},css:function(elem,name,extra,styles){var val,num,hooks,origName=jQuery.camelCase(name);return rcustomProp.test(name)||(name=finalPropName(origName)),hooks=jQuery.cssHooks[name]||jQuery.cssHooks[origName],hooks&&"get"in hooks&&(val=hooks.get(elem,!0,extra)),void 0===val&&(val=curCSS(elem,name,styles)),"normal"===val&&name in cssNormalTransform&&(val=cssNormalTransform[name]),""===extra||extra?(num=parseFloat(val),!0===extra||isFinite(num)?num||0:val):val}}),jQuery.each(["height","width"],function(i,name){jQuery.cssHooks[name]={get:function(elem,computed,extra){if(computed)return!rdisplayswap.test(jQuery.css(elem,"display"))||elem.getClientRects().length&&elem.getBoundingClientRect().width?getWidthOrHeight(elem,name,extra):swap(elem,cssShow,function(){return getWidthOrHeight(elem,name,extra)})},set:function(elem,value,extra){var matches,styles=extra&&getStyles(elem),subtract=extra&&augmentWidthOrHeight(elem,name,extra,"border-box"===jQuery.css(elem,"boxSizing",!1,styles),styles);return subtract&&(matches=rcssNum.exec(value))&&"px"!==(matches[3]||"px")&&(elem.style[name]=value,value=jQuery.css(elem,name)),setPositiveNumber(elem,value,subtract)}}}),jQuery.cssHooks.marginLeft=addGetHookIf(support.reliableMarginLeft,function(elem,computed){if(computed)return(parseFloat(curCSS(elem,"marginLeft"))||elem.getBoundingClientRect().left-swap(elem,{marginLeft:0},function(){return elem.getBoundingClientRect().left}))+"px"}),jQuery.each({margin:"",padding:"",border:"Width"},function(prefix,suffix){jQuery.cssHooks[prefix+suffix]={expand:function(value){for(var i=0,expanded={},parts="string"==typeof value?value.split(" "):[value];i<4;i++)expanded[prefix+cssExpand[i]+suffix]=parts[i]||parts[i-2]||parts[0];return expanded}},rmargin.test(prefix)||(jQuery.cssHooks[prefix+suffix].set=setPositiveNumber)}),jQuery.fn.extend({css:function(name,value){return access(this,function(elem,name,value){var styles,len,map={},i=0;if(Array.isArray(name)){for(styles=getStyles(elem),len=name.length;i<len;i++)map[name[i]]=jQuery.css(elem,name[i],!1,styles);return map}return void 0!==value?jQuery.style(elem,name,value):jQuery.css(elem,name)},name,value,arguments.length>1)}}),jQuery.Tween=Tween,Tween.prototype={constructor:Tween,init:function(elem,options,prop,end,easing,unit){this.elem=elem,this.prop=prop,this.easing=easing||jQuery.easing._default,this.options=options,this.start=this.now=this.cur(),this.end=end,this.unit=unit||(jQuery.cssNumber[prop]?"":"px")},cur:function(){var hooks=Tween.propHooks[this.prop];return hooks&&hooks.get?hooks.get(this):Tween.propHooks._default.get(this)},run:function(percent){var eased,hooks=Tween.propHooks[this.prop];return this.options.duration?this.pos=eased=jQuery.easing[this.easing](percent,this.options.duration*percent,0,1,this.options.duration):this.pos=eased=percent,this.now=(this.end-this.start)*eased+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),hooks&&hooks.set?hooks.set(this):Tween.propHooks._default.set(this),this}},Tween.prototype.init.prototype=Tween.prototype,Tween.propHooks={_default:{get:function(tween){var result;return 1!==tween.elem.nodeType||null!=tween.elem[tween.prop]&&null==tween.elem.style[tween.prop]?tween.elem[tween.prop]:(result=jQuery.css(tween.elem,tween.prop,""),result&&"auto"!==result?result:0)},set:function(tween){jQuery.fx.step[tween.prop]?jQuery.fx.step[tween.prop](tween):1!==tween.elem.nodeType||null==tween.elem.style[jQuery.cssProps[tween.prop]]&&!jQuery.cssHooks[tween.prop]?tween.elem[tween.prop]=tween.now:jQuery.style(tween.elem,tween.prop,tween.now+tween.unit)}}},Tween.propHooks.scrollTop=Tween.propHooks.scrollLeft={set:function(tween){tween.elem.nodeType&&tween.elem.parentNode&&(tween.elem[tween.prop]=tween.now)}},jQuery.easing={linear:function(p){return p},swing:function(p){return.5-Math.cos(p*Math.PI)/2},_default:"swing"},jQuery.fx=Tween.prototype.init,jQuery.fx.step={};var fxNow,inProgress,rfxtypes=/^(?:toggle|show|hide)$/,rrun=/queueHooks$/;jQuery.Animation=jQuery.extend(Animation,{tweeners:{"*":[function(prop,value){var tween=this.createTween(prop,value);return adjustCSS(tween.elem,prop,rcssNum.exec(value),tween),tween}]},tweener:function(props,callback){jQuery.isFunction(props)?(callback=props,props=["*"]):props=props.match(rnothtmlwhite);for(var prop,index=0,length=props.length;index<length;index++)prop=props[index],Animation.tweeners[prop]=Animation.tweeners[prop]||[],Animation.tweeners[prop].unshift(callback)},prefilters:[defaultPrefilter],prefilter:function(callback,prepend){prepend?Animation.prefilters.unshift(callback):Animation.prefilters.push(callback)}}),jQuery.speed=function(speed,easing,fn){var opt=speed&&"object"==typeof speed?jQuery.extend({},speed):{complete:fn||!fn&&easing||jQuery.isFunction(speed)&&speed,duration:speed,easing:fn&&easing||easing&&!jQuery.isFunction(easing)&&easing};return jQuery.fx.off?opt.duration=0:"number"!=typeof opt.duration&&(opt.duration in jQuery.fx.speeds?opt.duration=jQuery.fx.speeds[opt.duration]:opt.duration=jQuery.fx.speeds._default),null!=opt.queue&&!0!==opt.queue||(opt.queue="fx"),opt.old=opt.complete,opt.complete=function(){jQuery.isFunction(opt.old)&&opt.old.call(this),opt.queue&&jQuery.dequeue(this,opt.queue)},opt},jQuery.fn.extend({fadeTo:function(speed,to,easing,callback){return this.filter(isHiddenWithinTree).css("opacity",0).show().end().animate({opacity:to},speed,easing,callback)},animate:function(prop,speed,easing,callback){var empty=jQuery.isEmptyObject(prop),optall=jQuery.speed(speed,easing,callback),doAnimation=function(){var anim=Animation(this,jQuery.extend({},prop),optall);(empty||dataPriv.get(this,"finish"))&&anim.stop(!0)};return doAnimation.finish=doAnimation,empty||!1===optall.queue?this.each(doAnimation):this.queue(optall.queue,doAnimation)},stop:function(type,clearQueue,gotoEnd){var stopQueue=function(hooks){var stop=hooks.stop;delete hooks.stop,stop(gotoEnd)};return"string"!=typeof type&&(gotoEnd=clearQueue,clearQueue=type,type=void 0),clearQueue&&!1!==type&&this.queue(type||"fx",[]),this.each(function(){var dequeue=!0,index=null!=type&&type+"queueHooks",timers=jQuery.timers,data=dataPriv.get(this);if(index)data[index]&&data[index].stop&&stopQueue(data[index]);else for(index in data)data[index]&&data[index].stop&&rrun.test(index)&&stopQueue(data[index]);for(index=timers.length;index--;)timers[index].elem!==this||null!=type&&timers[index].queue!==type||(timers[index].anim.stop(gotoEnd),dequeue=!1,timers.splice(index,1));!dequeue&&gotoEnd||jQuery.dequeue(this,type)})},finish:function(type){return!1!==type&&(type=type||"fx"),this.each(function(){var index,data=dataPriv.get(this),queue=data[type+"queue"],hooks=data[type+"queueHooks"],timers=jQuery.timers,length=queue?queue.length:0;for(data.finish=!0,jQuery.queue(this,type,[]),hooks&&hooks.stop&&hooks.stop.call(this,!0),index=timers.length;index--;)timers[index].elem===this&&timers[index].queue===type&&(timers[index].anim.stop(!0),timers.splice(index,1));for(index=0;index<length;index++)queue[index]&&queue[index].finish&&queue[index].finish.call(this);delete data.finish})}}),jQuery.each(["toggle","show","hide"],function(i,name){var cssFn=jQuery.fn[name];jQuery.fn[name]=function(speed,easing,callback){return null==speed||"boolean"==typeof speed?cssFn.apply(this,arguments):this.animate(genFx(name,!0),speed,easing,callback)}}),jQuery.each({slideDown:genFx("show"),slideUp:genFx("hide"),slideToggle:genFx("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(name,props){jQuery.fn[name]=function(speed,easing,callback){return this.animate(props,speed,easing,callback)}}),jQuery.timers=[],jQuery.fx.tick=function(){var timer,i=0,timers=jQuery.timers;for(fxNow=jQuery.now();i<timers.length;i++)(timer=timers[i])()||timers[i]!==timer||timers.splice(i--,1);timers.length||jQuery.fx.stop(),fxNow=void 0},jQuery.fx.timer=function(timer){jQuery.timers.push(timer),jQuery.fx.start()},jQuery.fx.interval=13,jQuery.fx.start=function(){inProgress||(inProgress=!0,schedule())},jQuery.fx.stop=function(){inProgress=null},jQuery.fx.speeds={slow:600,fast:200,_default:400},jQuery.fn.delay=function(time,type){return time=jQuery.fx?jQuery.fx.speeds[time]||time:time,type=type||"fx",this.queue(type,function(next,hooks){var timeout=window.setTimeout(next,time);hooks.stop=function(){window.clearTimeout(timeout)}})},function(){var input=document.createElement("input"),select=document.createElement("select"),opt=select.appendChild(document.createElement("option"));input.type="checkbox",support.checkOn=""!==input.value,support.optSelected=opt.selected,input=document.createElement("input"),input.value="t",input.type="radio",support.radioValue="t"===input.value}();var boolHook,attrHandle=jQuery.expr.attrHandle;jQuery.fn.extend({attr:function(name,value){return access(this,jQuery.attr,name,value,arguments.length>1)},removeAttr:function(name){return this.each(function(){jQuery.removeAttr(this,name)})}}),jQuery.extend({attr:function(elem,name,value){var ret,hooks,nType=elem.nodeType;if(3!==nType&&8!==nType&&2!==nType)return void 0===elem.getAttribute?jQuery.prop(elem,name,value):(1===nType&&jQuery.isXMLDoc(elem)||(hooks=jQuery.attrHooks[name.toLowerCase()]||(jQuery.expr.match.bool.test(name)?boolHook:void 0)),void 0!==value?null===value?void jQuery.removeAttr(elem,name):hooks&&"set"in hooks&&void 0!==(ret=hooks.set(elem,value,name))?ret:(elem.setAttribute(name,value+""),value):hooks&&"get"in hooks&&null!==(ret=hooks.get(elem,name))?ret:(ret=jQuery.find.attr(elem,name),null==ret?void 0:ret))},attrHooks:{type:{set:function(elem,value){if(!support.radioValue&&"radio"===value&&nodeName(elem,"input")){var val=elem.value;return elem.setAttribute("type",value),val&&(elem.value=val),value}}}},removeAttr:function(elem,value){var name,i=0,attrNames=value&&value.match(rnothtmlwhite);if(attrNames&&1===elem.nodeType)for(;name=attrNames[i++];)elem.removeAttribute(name)}}),boolHook={set:function(elem,value,name){return!1===value?jQuery.removeAttr(elem,name):elem.setAttribute(name,name),name}},jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g),function(i,name){var getter=attrHandle[name]||jQuery.find.attr;attrHandle[name]=function(elem,name,isXML){var ret,handle,lowercaseName=name.toLowerCase();return isXML||(handle=attrHandle[lowercaseName],attrHandle[lowercaseName]=ret,ret=null!=getter(elem,name,isXML)?lowercaseName:null,attrHandle[lowercaseName]=handle),ret}});var rfocusable=/^(?:input|select|textarea|button)$/i,rclickable=/^(?:a|area)$/i;jQuery.fn.extend({prop:function(name,value){return access(this,jQuery.prop,name,value,arguments.length>1)},removeProp:function(name){return this.each(function(){delete this[jQuery.propFix[name]||name]})}}),jQuery.extend({prop:function(elem,name,value){var ret,hooks,nType=elem.nodeType;if(3!==nType&&8!==nType&&2!==nType)return 1===nType&&jQuery.isXMLDoc(elem)||(name=jQuery.propFix[name]||name,hooks=jQuery.propHooks[name]),void 0!==value?hooks&&"set"in hooks&&void 0!==(ret=hooks.set(elem,value,name))?ret:elem[name]=value:hooks&&"get"in hooks&&null!==(ret=hooks.get(elem,name))?ret:elem[name]},propHooks:{tabIndex:{get:function(elem){var tabindex=jQuery.find.attr(elem,"tabindex");return tabindex?parseInt(tabindex,10):rfocusable.test(elem.nodeName)||rclickable.test(elem.nodeName)&&elem.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),support.optSelected||(jQuery.propHooks.selected={get:function(elem){var parent=elem.parentNode;return parent&&parent.parentNode&&parent.parentNode.selectedIndex,null},set:function(elem){var parent=elem.parentNode;parent&&(parent.selectedIndex,parent.parentNode&&parent.parentNode.selectedIndex)}}),jQuery.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){jQuery.propFix[this.toLowerCase()]=this}),jQuery.fn.extend({addClass:function(value){var classes,elem,cur,curValue,clazz,j,finalValue,i=0;if(jQuery.isFunction(value))return this.each(function(j){jQuery(this).addClass(value.call(this,j,getClass(this)))});if("string"==typeof value&&value)for(classes=value.match(rnothtmlwhite)||[];elem=this[i++];)if(curValue=getClass(elem),cur=1===elem.nodeType&&" "+stripAndCollapse(curValue)+" "){for(j=0;clazz=classes[j++];)cur.indexOf(" "+clazz+" ")<0&&(cur+=clazz+" ");finalValue=stripAndCollapse(cur),curValue!==finalValue&&elem.setAttribute("class",finalValue)}return this},removeClass:function(value){var classes,elem,cur,curValue,clazz,j,finalValue,i=0;if(jQuery.isFunction(value))return this.each(function(j){jQuery(this).removeClass(value.call(this,j,getClass(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof value&&value)for(classes=value.match(rnothtmlwhite)||[];elem=this[i++];)if(curValue=getClass(elem),cur=1===elem.nodeType&&" "+stripAndCollapse(curValue)+" "){for(j=0;clazz=classes[j++];)for(;cur.indexOf(" "+clazz+" ")>-1;)cur=cur.replace(" "+clazz+" "," ");finalValue=stripAndCollapse(cur),curValue!==finalValue&&elem.setAttribute("class",finalValue)}return this},toggleClass:function(value,stateVal){var type=typeof value;return"boolean"==typeof stateVal&&"string"===type?stateVal?this.addClass(value):this.removeClass(value):jQuery.isFunction(value)?this.each(function(i){jQuery(this).toggleClass(value.call(this,i,getClass(this),stateVal),stateVal)}):this.each(function(){var className,i,self,classNames;if("string"===type)for(i=0,self=jQuery(this),classNames=value.match(rnothtmlwhite)||[];className=classNames[i++];)self.hasClass(className)?self.removeClass(className):self.addClass(className);else void 0!==value&&"boolean"!==type||(className=getClass(this),className&&dataPriv.set(this,"__className__",className),this.setAttribute&&this.setAttribute("class",className||!1===value?"":dataPriv.get(this,"__className__")||""))})},hasClass:function(selector){var className,elem,i=0;for(className=" "+selector+" ";elem=this[i++];)if(1===elem.nodeType&&(" "+stripAndCollapse(getClass(elem))+" ").indexOf(className)>-1)return!0;return!1}});var rreturn=/\r/g;jQuery.fn.extend({val:function(value){var hooks,ret,isFunction,elem=this[0];{if(arguments.length)return isFunction=jQuery.isFunction(value),this.each(function(i){var val;1===this.nodeType&&(val=isFunction?value.call(this,i,jQuery(this).val()):value,null==val?val="":"number"==typeof val?val+="":Array.isArray(val)&&(val=jQuery.map(val,function(value){return null==value?"":value+""})),(hooks=jQuery.valHooks[this.type]||jQuery.valHooks[this.nodeName.toLowerCase()])&&"set"in hooks&&void 0!==hooks.set(this,val,"value")||(this.value=val))});if(elem)return(hooks=jQuery.valHooks[elem.type]||jQuery.valHooks[elem.nodeName.toLowerCase()])&&"get"in hooks&&void 0!==(ret=hooks.get(elem,"value"))?ret:(ret=elem.value,"string"==typeof ret?ret.replace(rreturn,""):null==ret?"":ret)}}}),jQuery.extend({valHooks:{option:{get:function(elem){var val=jQuery.find.attr(elem,"value");return null!=val?val:stripAndCollapse(jQuery.text(elem))}},select:{get:function(elem){var value,option,i,options=elem.options,index=elem.selectedIndex,one="select-one"===elem.type,values=one?null:[],max=one?index+1:options.length;for(i=index<0?max:one?index:0;i<max;i++)if(option=options[i],(option.selected||i===index)&&!option.disabled&&(!option.parentNode.disabled||!nodeName(option.parentNode,"optgroup"))){if(value=jQuery(option).val(),one)return value;values.push(value)}return values},set:function(elem,value){for(var optionSet,option,options=elem.options,values=jQuery.makeArray(value),i=options.length;i--;)option=options[i],(option.selected=jQuery.inArray(jQuery.valHooks.option.get(option),values)>-1)&&(optionSet=!0);return optionSet||(elem.selectedIndex=-1),values}}}}),jQuery.each(["radio","checkbox"],function(){jQuery.valHooks[this]={set:function(elem,value){if(Array.isArray(value))return elem.checked=jQuery.inArray(jQuery(elem).val(),value)>-1}},support.checkOn||(jQuery.valHooks[this].get=function(elem){return null===elem.getAttribute("value")?"on":elem.value})});var rfocusMorph=/^(?:focusinfocus|focusoutblur)$/;jQuery.extend(jQuery.event,{trigger:function(event,data,elem,onlyHandlers){var i,cur,tmp,bubbleType,ontype,handle,special,eventPath=[elem||document],type=hasOwn.call(event,"type")?event.type:event,namespaces=hasOwn.call(event,"namespace")?event.namespace.split("."):[];if(cur=tmp=elem=elem||document,3!==elem.nodeType&&8!==elem.nodeType&&!rfocusMorph.test(type+jQuery.event.triggered)&&(type.indexOf(".")>-1&&(namespaces=type.split("."),type=namespaces.shift(),namespaces.sort()),ontype=type.indexOf(":")<0&&"on"+type,event=event[jQuery.expando]?event:new jQuery.Event(type,"object"==typeof event&&event),event.isTrigger=onlyHandlers?2:3,event.namespace=namespaces.join("."),event.rnamespace=event.namespace?new RegExp("(^|\\.)"+namespaces.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,event.result=void 0,event.target||(event.target=elem),data=null==data?[event]:jQuery.makeArray(data,[event]),special=jQuery.event.special[type]||{},onlyHandlers||!special.trigger||!1!==special.trigger.apply(elem,data))){if(!onlyHandlers&&!special.noBubble&&!jQuery.isWindow(elem)){for(bubbleType=special.delegateType||type,rfocusMorph.test(bubbleType+type)||(cur=cur.parentNode);cur;cur=cur.parentNode)eventPath.push(cur),tmp=cur;tmp===(elem.ownerDocument||document)&&eventPath.push(tmp.defaultView||tmp.parentWindow||window)}for(i=0;(cur=eventPath[i++])&&!event.isPropagationStopped();)event.type=i>1?bubbleType:special.bindType||type,handle=(dataPriv.get(cur,"events")||{})[event.type]&&dataPriv.get(cur,"handle"),handle&&handle.apply(cur,data),(handle=ontype&&cur[ontype])&&handle.apply&&acceptData(cur)&&(event.result=handle.apply(cur,data),!1===event.result&&event.preventDefault());return event.type=type,onlyHandlers||event.isDefaultPrevented()||special._default&&!1!==special._default.apply(eventPath.pop(),data)||!acceptData(elem)||ontype&&jQuery.isFunction(elem[type])&&!jQuery.isWindow(elem)&&(tmp=elem[ontype],tmp&&(elem[ontype]=null),jQuery.event.triggered=type,elem[type](),jQuery.event.triggered=void 0,tmp&&(elem[ontype]=tmp)),event.result}},simulate:function(type,elem,event){var e=jQuery.extend(new jQuery.Event,event,{type:type,isSimulated:!0});jQuery.event.trigger(e,null,elem)}}),jQuery.fn.extend({trigger:function(type,data){return this.each(function(){jQuery.event.trigger(type,data,this)})},triggerHandler:function(type,data){var elem=this[0];if(elem)return jQuery.event.trigger(type,data,elem,!0)}}),jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(i,name){jQuery.fn[name]=function(data,fn){return arguments.length>0?this.on(name,null,data,fn):this.trigger(name)}}),jQuery.fn.extend({hover:function(fnOver,fnOut){return this.mouseenter(fnOver).mouseleave(fnOut||fnOver)}}),support.focusin="onfocusin"in window,support.focusin||jQuery.each({focus:"focusin",blur:"focusout"},function(orig,fix){var handler=function(event){jQuery.event.simulate(fix,event.target,jQuery.event.fix(event))};jQuery.event.special[fix]={setup:function(){var doc=this.ownerDocument||this,attaches=dataPriv.access(doc,fix);attaches||doc.addEventListener(orig,handler,!0),dataPriv.access(doc,fix,(attaches||0)+1)},teardown:function(){var doc=this.ownerDocument||this,attaches=dataPriv.access(doc,fix)-1;attaches?dataPriv.access(doc,fix,attaches):(doc.removeEventListener(orig,handler,!0),dataPriv.remove(doc,fix))}}});var location=window.location,nonce=jQuery.now(),rquery=/\?/;jQuery.parseXML=function(data){var xml;if(!data||"string"!=typeof data)return null;try{xml=(new window.DOMParser).parseFromString(data,"text/xml")}catch(e){xml=void 0}return xml&&!xml.getElementsByTagName("parsererror").length||jQuery.error("Invalid XML: "+data),xml};var rbracket=/\[\]$/,rCRLF=/\r?\n/g,rsubmitterTypes=/^(?:submit|button|image|reset|file)$/i,rsubmittable=/^(?:input|select|textarea|keygen)/i;jQuery.param=function(a,traditional){var prefix,s=[],add=function(key,valueOrFunction){var value=jQuery.isFunction(valueOrFunction)?valueOrFunction():valueOrFunction;s[s.length]=encodeURIComponent(key)+"="+encodeURIComponent(null==value?"":value)};if(Array.isArray(a)||a.jquery&&!jQuery.isPlainObject(a))jQuery.each(a,function(){add(this.name,this.value)});else for(prefix in a)buildParams(prefix,a[prefix],traditional,add);return s.join("&")},jQuery.fn.extend({serialize:function(){return jQuery.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var elements=jQuery.prop(this,"elements");return elements?jQuery.makeArray(elements):this}).filter(function(){var type=this.type;return this.name&&!jQuery(this).is(":disabled")&&rsubmittable.test(this.nodeName)&&!rsubmitterTypes.test(type)&&(this.checked||!rcheckableType.test(type))}).map(function(i,elem){var val=jQuery(this).val();return null==val?null:Array.isArray(val)?jQuery.map(val,function(val){return{name:elem.name,value:val.replace(rCRLF,"\r\n")}}):{name:elem.name,value:val.replace(rCRLF,"\r\n")}}).get()}});var r20=/%20/g,rhash=/#.*$/,rantiCache=/([?&])_=[^&]*/,rheaders=/^(.*?):[ \t]*([^\r\n]*)$/gm,rlocalProtocol=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,rnoContent=/^(?:GET|HEAD)$/,rprotocol=/^\/\//,prefilters={},transports={},allTypes="*/".concat("*"),originAnchor=document.createElement("a");originAnchor.href=location.href,jQuery.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:location.href,type:"GET",isLocal:rlocalProtocol.test(location.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":allTypes,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":jQuery.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(target,settings){return settings?ajaxExtend(ajaxExtend(target,jQuery.ajaxSettings),settings):ajaxExtend(jQuery.ajaxSettings,target)},ajaxPrefilter:addToPrefiltersOrTransports(prefilters),ajaxTransport:addToPrefiltersOrTransports(transports),ajax:function(url,options){function done(status,nativeStatusText,responses,headers){var isSuccess,success,error,response,modified,statusText=nativeStatusText;completed||(completed=!0,timeoutTimer&&window.clearTimeout(timeoutTimer),transport=void 0,responseHeadersString=headers||"",jqXHR.readyState=status>0?4:0,isSuccess=status>=200&&status<300||304===status,responses&&(response=ajaxHandleResponses(s,jqXHR,responses)),response=ajaxConvert(s,response,jqXHR,isSuccess),isSuccess?(s.ifModified&&(modified=jqXHR.getResponseHeader("Last-Modified"),modified&&(jQuery.lastModified[cacheURL]=modified),(modified=jqXHR.getResponseHeader("etag"))&&(jQuery.etag[cacheURL]=modified)),204===status||"HEAD"===s.type?statusText="nocontent":304===status?statusText="notmodified":(statusText=response.state,success=response.data,error=response.error,isSuccess=!error)):(error=statusText,!status&&statusText||(statusText="error",status<0&&(status=0))),jqXHR.status=status,jqXHR.statusText=(nativeStatusText||statusText)+"",isSuccess?deferred.resolveWith(callbackContext,[success,statusText,jqXHR]):deferred.rejectWith(callbackContext,[jqXHR,statusText,error]),jqXHR.statusCode(statusCode),statusCode=void 0,fireGlobals&&globalEventContext.trigger(isSuccess?"ajaxSuccess":"ajaxError",[jqXHR,s,isSuccess?success:error]),completeDeferred.fireWith(callbackContext,[jqXHR,statusText]),fireGlobals&&(globalEventContext.trigger("ajaxComplete",[jqXHR,s]),--jQuery.active||jQuery.event.trigger("ajaxStop")))}"object"==typeof url&&(options=url,url=void 0),options=options||{};var transport,cacheURL,responseHeadersString,responseHeaders,timeoutTimer,urlAnchor,completed,fireGlobals,i,uncached,s=jQuery.ajaxSetup({},options),callbackContext=s.context||s,globalEventContext=s.context&&(callbackContext.nodeType||callbackContext.jquery)?jQuery(callbackContext):jQuery.event,deferred=jQuery.Deferred(),completeDeferred=jQuery.Callbacks("once memory"),statusCode=s.statusCode||{},requestHeaders={},requestHeadersNames={},strAbort="canceled",jqXHR={readyState:0,getResponseHeader:function(key){var match;if(completed){if(!responseHeaders)for(responseHeaders={};match=rheaders.exec(responseHeadersString);)responseHeaders[match[1].toLowerCase()]=match[2];match=responseHeaders[key.toLowerCase()]}return null==match?null:match},getAllResponseHeaders:function(){return completed?responseHeadersString:null},setRequestHeader:function(name,value){return null==completed&&(name=requestHeadersNames[name.toLowerCase()]=requestHeadersNames[name.toLowerCase()]||name,requestHeaders[name]=value),this},overrideMimeType:function(type){return null==completed&&(s.mimeType=type),this},statusCode:function(map){var code;if(map)if(completed)jqXHR.always(map[jqXHR.status]);else for(code in map)statusCode[code]=[statusCode[code],map[code]];return this},abort:function(statusText){var finalText=statusText||strAbort;return transport&&transport.abort(finalText),done(0,finalText),this}};if(deferred.promise(jqXHR),s.url=((url||s.url||location.href)+"").replace(rprotocol,location.protocol+"//"),s.type=options.method||options.type||s.method||s.type,s.dataTypes=(s.dataType||"*").toLowerCase().match(rnothtmlwhite)||[""],null==s.crossDomain){urlAnchor=document.createElement("a");try{urlAnchor.href=s.url,urlAnchor.href=urlAnchor.href,s.crossDomain=originAnchor.protocol+"//"+originAnchor.host!=urlAnchor.protocol+"//"+urlAnchor.host}catch(e){s.crossDomain=!0}}if(s.data&&s.processData&&"string"!=typeof s.data&&(s.data=jQuery.param(s.data,s.traditional)),inspectPrefiltersOrTransports(prefilters,s,options,jqXHR),completed)return jqXHR;fireGlobals=jQuery.event&&s.global,fireGlobals&&0==jQuery.active++&&jQuery.event.trigger("ajaxStart"),s.type=s.type.toUpperCase(),s.hasContent=!rnoContent.test(s.type),cacheURL=s.url.replace(rhash,""),s.hasContent?s.data&&s.processData&&0===(s.contentType||"").indexOf("application/x-www-form-urlencoded")&&(s.data=s.data.replace(r20,"+")):(uncached=s.url.slice(cacheURL.length),s.data&&(cacheURL+=(rquery.test(cacheURL)?"&":"?")+s.data,delete s.data),!1===s.cache&&(cacheURL=cacheURL.replace(rantiCache,"$1"),uncached=(rquery.test(cacheURL)?"&":"?")+"_="+nonce+++uncached),s.url=cacheURL+uncached),s.ifModified&&(jQuery.lastModified[cacheURL]&&jqXHR.setRequestHeader("If-Modified-Since",jQuery.lastModified[cacheURL]),jQuery.etag[cacheURL]&&jqXHR.setRequestHeader("If-None-Match",jQuery.etag[cacheURL])),(s.data&&s.hasContent&&!1!==s.contentType||options.contentType)&&jqXHR.setRequestHeader("Content-Type",s.contentType),jqXHR.setRequestHeader("Accept",s.dataTypes[0]&&s.accepts[s.dataTypes[0]]?s.accepts[s.dataTypes[0]]+("*"!==s.dataTypes[0]?", "+allTypes+"; q=0.01":""):s.accepts["*"]);for(i in s.headers)jqXHR.setRequestHeader(i,s.headers[i]);if(s.beforeSend&&(!1===s.beforeSend.call(callbackContext,jqXHR,s)||completed))return jqXHR.abort();if(strAbort="abort",completeDeferred.add(s.complete),jqXHR.done(s.success),jqXHR.fail(s.error),transport=inspectPrefiltersOrTransports(transports,s,options,jqXHR)){if(jqXHR.readyState=1,fireGlobals&&globalEventContext.trigger("ajaxSend",[jqXHR,s]),completed)return jqXHR;s.async&&s.timeout>0&&(timeoutTimer=window.setTimeout(function(){jqXHR.abort("timeout")},s.timeout));try{completed=!1,transport.send(requestHeaders,done)}catch(e){if(completed)throw e;done(-1,e)}}else done(-1,"No Transport");return jqXHR},getJSON:function(url,data,callback){return jQuery.get(url,data,callback,"json")},getScript:function(url,callback){return jQuery.get(url,void 0,callback,"script")}}),jQuery.each(["get","post"],function(i,method){jQuery[method]=function(url,data,callback,type){return jQuery.isFunction(data)&&(type=type||callback,callback=data,data=void 0),jQuery.ajax(jQuery.extend({url:url,type:method,dataType:type,data:data,success:callback},jQuery.isPlainObject(url)&&url))}}),jQuery._evalUrl=function(url){return jQuery.ajax({url:url,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,throws:!0})},jQuery.fn.extend({wrapAll:function(html){var wrap;return this[0]&&(jQuery.isFunction(html)&&(html=html.call(this[0])),wrap=jQuery(html,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&wrap.insertBefore(this[0]),wrap.map(function(){for(var elem=this;elem.firstElementChild;)elem=elem.firstElementChild;return elem}).append(this)),this},wrapInner:function(html){return jQuery.isFunction(html)?this.each(function(i){jQuery(this).wrapInner(html.call(this,i))}):this.each(function(){var self=jQuery(this),contents=self.contents();contents.length?contents.wrapAll(html):self.append(html)})},wrap:function(html){var isFunction=jQuery.isFunction(html);return this.each(function(i){jQuery(this).wrapAll(isFunction?html.call(this,i):html)})},unwrap:function(selector){return this.parent(selector).not("body").each(function(){jQuery(this).replaceWith(this.childNodes)}),this}}),jQuery.expr.pseudos.hidden=function(elem){return!jQuery.expr.pseudos.visible(elem)},jQuery.expr.pseudos.visible=function(elem){return!!(elem.offsetWidth||elem.offsetHeight||elem.getClientRects().length)},jQuery.ajaxSettings.xhr=function(){try{return new window.XMLHttpRequest}catch(e){}};var xhrSuccessStatus={0:200,1223:204},xhrSupported=jQuery.ajaxSettings.xhr();support.cors=!!xhrSupported&&"withCredentials"in xhrSupported,support.ajax=xhrSupported=!!xhrSupported,jQuery.ajaxTransport(function(options){var callback,errorCallback;if(support.cors||xhrSupported&&!options.crossDomain)return{send:function(headers,complete){var i,xhr=options.xhr();if(xhr.open(options.type,options.url,options.async,options.username,options.password),options.xhrFields)for(i in options.xhrFields)xhr[i]=options.xhrFields[i];options.mimeType&&xhr.overrideMimeType&&xhr.overrideMimeType(options.mimeType),options.crossDomain||headers["X-Requested-With"]||(headers["X-Requested-With"]="XMLHttpRequest");for(i in headers)xhr.setRequestHeader(i,headers[i]);callback=function(type){return function(){callback&&(callback=errorCallback=xhr.onload=xhr.onerror=xhr.onabort=xhr.onreadystatechange=null,"abort"===type?xhr.abort():"error"===type?"number"!=typeof xhr.status?complete(0,"error"):complete(xhr.status,xhr.statusText):complete(xhrSuccessStatus[xhr.status]||xhr.status,xhr.statusText,"text"!==(xhr.responseType||"text")||"string"!=typeof xhr.responseText?{binary:xhr.response}:{text:xhr.responseText},xhr.getAllResponseHeaders()))}},xhr.onload=callback(),errorCallback=xhr.onerror=callback("error"),void 0!==xhr.onabort?xhr.onabort=errorCallback:xhr.onreadystatechange=function(){4===xhr.readyState&&window.setTimeout(function(){callback&&errorCallback()})},callback=callback("abort");try{xhr.send(options.hasContent&&options.data||null)}catch(e){if(callback)throw e}},abort:function(){callback&&callback()}}}),jQuery.ajaxPrefilter(function(s){s.crossDomain&&(s.contents.script=!1)}),jQuery.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(text){return jQuery.globalEval(text),text}}}),jQuery.ajaxPrefilter("script",function(s){void 0===s.cache&&(s.cache=!1),s.crossDomain&&(s.type="GET")}),jQuery.ajaxTransport("script",function(s){if(s.crossDomain){var script,callback;return{send:function(_,complete){script=jQuery("<script>").prop({charset:s.scriptCharset,src:s.url}).on("load error",callback=function(evt){script.remove(),callback=null,evt&&complete("error"===evt.type?404:200,evt.type)}),document.head.appendChild(script[0])},abort:function(){callback&&callback()}}}});var oldCallbacks=[],rjsonp=/(=)\?(?=&|$)|\?\?/;jQuery.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var callback=oldCallbacks.pop()||jQuery.expando+"_"+nonce++;return this[callback]=!0,callback}}),jQuery.ajaxPrefilter("json jsonp",function(s,originalSettings,jqXHR){var callbackName,overwritten,responseContainer,jsonProp=!1!==s.jsonp&&(rjsonp.test(s.url)?"url":"string"==typeof s.data&&0===(s.contentType||"").indexOf("application/x-www-form-urlencoded")&&rjsonp.test(s.data)&&"data");if(jsonProp||"jsonp"===s.dataTypes[0])return callbackName=s.jsonpCallback=jQuery.isFunction(s.jsonpCallback)?s.jsonpCallback():s.jsonpCallback,jsonProp?s[jsonProp]=s[jsonProp].replace(rjsonp,"$1"+callbackName):!1!==s.jsonp&&(s.url+=(rquery.test(s.url)?"&":"?")+s.jsonp+"="+callbackName),s.converters["script json"]=function(){return responseContainer||jQuery.error(callbackName+" was not called"),responseContainer[0]},s.dataTypes[0]="json",overwritten=window[callbackName],window[callbackName]=function(){responseContainer=arguments},jqXHR.always(function(){void 0===overwritten?jQuery(window).removeProp(callbackName):window[callbackName]=overwritten,s[callbackName]&&(s.jsonpCallback=originalSettings.jsonpCallback,oldCallbacks.push(callbackName)),responseContainer&&jQuery.isFunction(overwritten)&&overwritten(responseContainer[0]),responseContainer=overwritten=void 0}),"script"}),support.createHTMLDocument=function(){var body=document.implementation.createHTMLDocument("").body;return body.innerHTML="<form></form><form></form>",2===body.childNodes.length}(),jQuery.parseHTML=function(data,context,keepScripts){if("string"!=typeof data)return[];"boolean"==typeof context&&(keepScripts=context,context=!1);var base,parsed,scripts;return context||(support.createHTMLDocument?(context=document.implementation.createHTMLDocument(""),base=context.createElement("base"),base.href=document.location.href,context.head.appendChild(base)):context=document),parsed=rsingleTag.exec(data),scripts=!keepScripts&&[],parsed?[context.createElement(parsed[1])]:(parsed=buildFragment([data],context,scripts),scripts&&scripts.length&&jQuery(scripts).remove(),jQuery.merge([],parsed.childNodes))},jQuery.fn.load=function(url,params,callback){var selector,type,response,self=this,off=url.indexOf(" ");return off>-1&&(selector=stripAndCollapse(url.slice(off)),url=url.slice(0,off)),jQuery.isFunction(params)?(callback=params,params=void 0):params&&"object"==typeof params&&(type="POST"),self.length>0&&jQuery.ajax({url:url,type:type||"GET",dataType:"html",data:params}).done(function(responseText){response=arguments,self.html(selector?jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector):responseText)}).always(callback&&function(jqXHR,status){self.each(function(){callback.apply(this,response||[jqXHR.responseText,status,jqXHR])})}),this},jQuery.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(i,type){jQuery.fn[type]=function(fn){return this.on(type,fn)}}),jQuery.expr.pseudos.animated=function(elem){return jQuery.grep(jQuery.timers,function(fn){return elem===fn.elem}).length},jQuery.offset={setOffset:function(elem,options,i){var curPosition,curLeft,curCSSTop,curTop,curOffset,curCSSLeft,calculatePosition,position=jQuery.css(elem,"position"),curElem=jQuery(elem),props={};"static"===position&&(elem.style.position="relative"),curOffset=curElem.offset(),curCSSTop=jQuery.css(elem,"top"),curCSSLeft=jQuery.css(elem,"left"),calculatePosition=("absolute"===position||"fixed"===position)&&(curCSSTop+curCSSLeft).indexOf("auto")>-1,calculatePosition?(curPosition=curElem.position(),curTop=curPosition.top,curLeft=curPosition.left):(curTop=parseFloat(curCSSTop)||0,curLeft=parseFloat(curCSSLeft)||0),jQuery.isFunction(options)&&(options=options.call(elem,i,jQuery.extend({},curOffset))),null!=options.top&&(props.top=options.top-curOffset.top+curTop),null!=options.left&&(props.left=options.left-curOffset.left+curLeft),"using"in options?options.using.call(elem,props):curElem.css(props)}},jQuery.fn.extend({offset:function(options){if(arguments.length)return void 0===options?this:this.each(function(i){jQuery.offset.setOffset(this,options,i)});var doc,docElem,rect,win,elem=this[0];if(elem)return elem.getClientRects().length?(rect=elem.getBoundingClientRect(),doc=elem.ownerDocument,docElem=doc.documentElement,win=doc.defaultView,{top:rect.top+win.pageYOffset-docElem.clientTop,left:rect.left+win.pageXOffset-docElem.clientLeft}):{top:0,left:0}},position:function(){if(this[0]){var offsetParent,offset,elem=this[0],parentOffset={top:0,left:0};return"fixed"===jQuery.css(elem,"position")?offset=elem.getBoundingClientRect():(offsetParent=this.offsetParent(),offset=this.offset(),nodeName(offsetParent[0],"html")||(parentOffset=offsetParent.offset()),parentOffset={top:parentOffset.top+jQuery.css(offsetParent[0],"borderTopWidth",!0),left:parentOffset.left+jQuery.css(offsetParent[0],"borderLeftWidth",!0)}),{top:offset.top-parentOffset.top-jQuery.css(elem,"marginTop",!0),left:offset.left-parentOffset.left-jQuery.css(elem,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){for(var offsetParent=this.offsetParent;offsetParent&&"static"===jQuery.css(offsetParent,"position");)offsetParent=offsetParent.offsetParent;return offsetParent||documentElement})}}),jQuery.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(method,prop){var top="pageYOffset"===prop;jQuery.fn[method]=function(val){return access(this,function(elem,method,val){var win;if(jQuery.isWindow(elem)?win=elem:9===elem.nodeType&&(win=elem.defaultView),void 0===val)return win?win[prop]:elem[method];win?win.scrollTo(top?win.pageXOffset:val,top?val:win.pageYOffset):elem[method]=val},method,val,arguments.length)}}),jQuery.each(["top","left"],function(i,prop){jQuery.cssHooks[prop]=addGetHookIf(support.pixelPosition,function(elem,computed){if(computed)return computed=curCSS(elem,prop),rnumnonpx.test(computed)?jQuery(elem).position()[prop]+"px":computed})}),jQuery.each({Height:"height",Width:"width"},function(name,type){jQuery.each({padding:"inner"+name,content:type,"":"outer"+name},function(defaultExtra,funcName){jQuery.fn[funcName]=function(margin,value){var chainable=arguments.length&&(defaultExtra||"boolean"!=typeof margin),extra=defaultExtra||(!0===margin||!0===value?"margin":"border");return access(this,function(elem,type,value){var doc;return jQuery.isWindow(elem)?0===funcName.indexOf("outer")?elem["inner"+name]:elem.document.documentElement["client"+name]:9===elem.nodeType?(doc=elem.documentElement,Math.max(elem.body["scroll"+name],doc["scroll"+name],elem.body["offset"+name],doc["offset"+name],doc["client"+name])):void 0===value?jQuery.css(elem,type,extra):jQuery.style(elem,type,value,extra)},type,chainable?margin:void 0,chainable)}})}),jQuery.fn.extend({bind:function(types,data,fn){return this.on(types,null,data,fn)},unbind:function(types,fn){return this.off(types,null,fn)},delegate:function(selector,types,data,fn){return this.on(types,selector,data,fn)},undelegate:function(selector,types,fn){return 1===arguments.length?this.off(selector,"**"):this.off(types,selector||"**",fn)}}),jQuery.holdReady=function(hold){hold?jQuery.readyWait++:jQuery.ready(!0)},jQuery.isArray=Array.isArray,jQuery.parseJSON=JSON.parse,jQuery.nodeName=nodeName,__WEBPACK_AMD_DEFINE_ARRAY__=[],void 0!==(__WEBPACK_AMD_DEFINE_RESULT__=function(){return jQuery}.apply(exports,__WEBPACK_AMD_DEFINE_ARRAY__))&&(module.exports=__WEBPACK_AMD_DEFINE_RESULT__);var _jQuery=window.jQuery,_$=window.$;return jQuery.noConflict=function(deep){return window.$===jQuery&&(window.$=_$),deep&&window.jQuery===jQuery&&(window.jQuery=_jQuery),jQuery},noGlobal||(window.jQuery=window.$=jQuery),jQuery})},function(module,exports,__webpack_require__){"use strict";function toObject(val){if(null===val||void 0===val)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(val)}/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols=Object.getOwnPropertySymbols,hasOwnProperty=Object.prototype.hasOwnProperty,propIsEnumerable=Object.prototype.propertyIsEnumerable;module.exports=function(){try{if(!Object.assign)return!1;var test1=new String("abc");if(test1[5]="de","5"===Object.getOwnPropertyNames(test1)[0])return!1;for(var test2={},i=0;i<10;i++)test2["_"+String.fromCharCode(i)]=i;if("0123456789"!==Object.getOwnPropertyNames(test2).map(function(n){return test2[n]}).join(""))return!1;var test3={};return"abcdefghijklmnopqrst".split("").forEach(function(letter){test3[letter]=letter}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},test3)).join("")}catch(err){return!1}}()?Object.assign:function(target,source){for(var from,symbols,to=toObject(target),s=1;s<arguments.length;s++){from=Object(arguments[s]);for(var key in from)hasOwnProperty.call(from,key)&&(to[key]=from[key]);if(getOwnPropertySymbols){symbols=getOwnPropertySymbols(from);for(var i=0;i<symbols.length;i++)propIsEnumerable.call(from,symbols[i])&&(to[symbols[i]]=from[symbols[i]])}}return to}},function(module,exports,__webpack_require__){"use strict";var emptyObject={};module.exports=emptyObject},function(module,exports,__webpack_require__){"use strict";function checkDCE(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE)try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE)}catch(err){console.error(err)}}checkDCE(),module.exports=__webpack_require__(9)},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!call||"object"!==(void 0===call?"undefined":_typeof(call))&&"function"!=typeof call?self:call}function _inherits(subClass,superClass){if("function"!=typeof superClass&&null!==superClass)throw new TypeError("Super expression must either be null or a function, not "+(void 0===superClass?"undefined":_typeof(superClass)));subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}function reactToAngular1(component){var bindings=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],dependenciesToInject=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],wrapperStyleString=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"";return{transclude:!0,bindings:bindings.reduce(function(result,key){return result[key]="<",result},{}),controller:["$element"].concat(_toConsumableArray(dependenciesToInject),[function(){function _class($element){for(var _this2=this,_len=arguments.length,dependenciesInjected=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++)dependenciesInjected[_key-1]=arguments[_key];_classCallCheck(this,_class),this._private={componentProps:{},lastComponentPropsStringified:"",angular1BridgeInstance:null,$element:$element},dependenciesToInject.forEach(function(dependencyName,i){_this2._private.componentProps[dependencyName]=dependenciesInjected[i]})}return _createClass(_class,[{key:"setComponentProps",value:function(){for(var key in this)"_private"!==key&&(this._private.componentProps[key]=this[key])}},{key:"$onInit",value:function(){var _this3=this;setTimeout(function(){var $element=_this3._private.$element;_this3.setComponentProps(),_reactDom2.default.render(_react2.default.createElement(Angular1Bridge,{ref:function(i){_this3._private.angular1BridgeInstance=i},component:component,componentProps:_this3._private.componentProps,angularTranscludeEl:$element[0].children[1].children[0]}),$element[0].children[0])})}},{key:"$onDestroy",value:function(){var $element=this._private.$element;_reactDom2.default.unmountComponentAtNode($element[0].children[0])}},{key:"$doCheck",value:function(){var propsStringified=JSON.stringify(_extends({},this,{_private:null}));propsStringified!==this._private.lastComponentPropsStringified&&(this.setComponentProps(),this._private.lastComponentPropsStringified=propsStringified,null!=this._private.angular1BridgeInstance&&this._private.angular1BridgeInstance.forceUpdate())}}]),_class}()]),template:'<div style="'+wrapperStyleString+'"></div><div style="display: none;"><div ng-transclude></div></div>'}}var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj};Object.defineProperty(exports,"__esModule",{value:!0});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key])}return target},_createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();exports.reactToAngular1=reactToAngular1;var _react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_reactDom=__webpack_require__(5),_reactDom2=_interopRequireDefault(_reactDom);Error.prototype.$$passToExceptionHandler=!0;var Angular1Bridge=function(_React$Component){function Angular1Bridge(props){_classCallCheck(this,Angular1Bridge);var _this=_possibleConstructorReturn(this,(Angular1Bridge.__proto__||Object.getPrototypeOf(Angular1Bridge)).call(this,props));return _this.setRef=_this.setRef.bind(_this),_this}return _inherits(Angular1Bridge,_React$Component),_createClass(Angular1Bridge,[{key:"setRef",value:function(childrenContainer){null!=childrenContainer&&null!=this.props.angularTranscludeEl&&childrenContainer.appendChild(this.props.angularTranscludeEl)}},{key:"render",value:function(){var ComponentToBridge=this.props.component;return _react2.default.createElement(ComponentToBridge,_extends({},this.props.componentProps,{children:_react2.default.createElement("div",{ref:this.setRef})}))}}]),Angular1Bridge}(_react2.default.Component)},function(module,exports){var g;g=function(){return this}();try{g=g||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(g=window)}module.exports=g},function(module,exports,__webpack_require__){"use strict";function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);throw b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."),b.name="Invariant Violation",b.framesToPop=1,b}function A(a,b,e){this.props=a,this.context=b,this.refs=n,this.updater=e||z}function B(a,b,e){this.props=a,this.context=b,this.refs=n,this.updater=e||z}function C(){}function E(a,b,e){this.props=a,this.context=b,this.refs=n,this.updater=e||z}function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"==typeof a&&null!==a&&a.$$typeof===r}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}function N(a,b,e,c){if(M.length){var d=M.pop();return d.result=a,d.keyPrefix=b,d.func=e,d.context=c,d.count=0,d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null,a.keyPrefix=null,a.func=null,a.context=null,a.count=0,10>M.length&&M.push(a)}function P(a,b,e,c){var d=typeof a;"undefined"!==d&&"boolean"!==d||(a=null);var g=!1;if(null===a)g=!0;else switch(d){case"string":case"number":g=!0;break;case"object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;if(g=0,b=""===b?".":b+":",Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||void 0===a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"==typeof f?f:null),"function"==typeof f)for(a=f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"==typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++),Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$&/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$&/")+"/"),b=N(b,g,c,d),null==a||P(a,"",S,b),O(b)}/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var m=__webpack_require__(3),n=__webpack_require__(4),p=__webpack_require__(1),q="function"==typeof Symbol&&Symbol.for,r=q?Symbol.for("react.element"):60103,t=q?Symbol.for("react.call"):60104,u=q?Symbol.for("react.return"):60105,v=q?Symbol.for("react.portal"):60106,w=q?Symbol.for("react.fragment"):60107,x="function"==typeof Symbol&&Symbol.iterator,z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};A.prototype.isReactComponent={},A.prototype.setState=function(a,b){"object"!=typeof a&&"function"!=typeof a&&null!=a&&y("85"),this.updater.enqueueSetState(this,a,b,"setState")},A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")},C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B,m(D,A.prototype),D.isPureReactComponent=!0;var F=E.prototype=new C;F.constructor=E,m(F,A.prototype),F.unstable_isAsyncReactComponent=!0,F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0},L=/\/+/g,M=[],U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];return T(a,c,null,b,e),c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e),null==a||P(a,"",R,b),O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];return T(a,b,null,p.thatReturnsArgument),b},only:function(a){return K(a)||y("143"),a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){if(void 0!==b.ref&&(g=b.ref,k=G.current),void 0!==b.key&&(d=""+b.key),a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);return b.type=a,b},isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W.default?W.default:W},function(module,exports,__webpack_require__){"use strict";function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);throw b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."),b.name="Invariant Violation",b.framesToPop=1,b}function pa(a,b){return(a&b)===b}function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case"boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case"undefined":case"number":case"string":case"object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}function Ia(a){return a[1].toUpperCase()}function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1,P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}function Ka(){if(P._hasRethrowError){var a=P._rethrowError;throw P._rethrowError=null,P._hasRethrowError=!1,a}}function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);if(-1<c||E("96",a),!Oa[c]){b.extractEvents||E("97",a),Oa[c]=b,c=b.eventTypes;for(var d in c){var e=void 0,f=c[d],g=b,h=d;Pa.hasOwnProperty(h)&&E("99",h),Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e||E("98",d,a)}}}}function Qa(a,b,c){Ra[a]&&E("100",a),Ra[a]=b,Sa[a]=b.eventTypes[c].dependencies}function Ta(a){La&&E("101"),La=Array.prototype.slice.call(a),Na()}function Ua(a){var c,b=!1;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]&&E("102",c),Ma[c]=d,b=!0)}b&&Na()}function Za(a,b,c,d){b=a.type||"unknown-event",a.currentTarget=Ya(d),P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a),a.currentTarget=null}function $a(a,b){return null==b&&E("30"),null==a?b:Array.isArray(a)?Array.isArray(b)?(a.push.apply(a,b),a):(a.push(b),a):Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null,a._dispatchInstances=null,a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a)),a=!d;break a;default:a=!1}return a?null:(c&&"function"!=typeof c&&E("231",b,typeof c),c)}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null,b&&(a?ab(b,db):ab(b,gb),bb&&E("95"),P.rethrowCaughtError())}function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];){if(b.push(a),!a.parentNode)return null;a=a.parentNode}var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}function tb(a){do{a=a.return}while(a&&5!==a.tag);return a||null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function vb(a,b,c){(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null,ub(b,vb,a)}}function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}function Bb(a,b,c,d){if(c&&d)a:{for(var e=c,f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e),f=tb(f)}e=null}else e=null;for(f=e,e=[];c&&c!==f&&(null===(g=c.alternate)||g!==f);)e.push(c),c=tb(c);for(c=[];d&&d!==f&&(null===(g=d.alternate)||g!==f);)c.push(d),d=tb(d);for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}function Eb(){return!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText"),Db}function Fb(){if(S._fallbackText)return S._fallbackText;var a,d,b=S._startText,c=b.length,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return S._fallbackText=e.slice(a,1<d?1-d:void 0),S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}function T(a,b,c,d){this.dispatchConfig=a,this._targetInst=b,this.nativeEvent=c,a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);return this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse,this.isPropagationStopped=C.thatReturnsFalse,this}function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();return this.call(e,a,b,c,d),e}return new this(a,b,c,d)}function Lb(a){a instanceof this||E("223"),a.destructor(),10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[],a.getPooled=Kb,a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}function Nb(a,b,c,d){return T.call(this,a,b,c,d)}function dc(a,b){switch(a){case"topKeyUp":return-1!==Pb.indexOf(b.keyCode);case"topKeyDown":return 229!==b.keyCode;case"topKeyPress":case"topMouseDown":case"topBlur":return!0;default:return!1}}function ec(a){return a=a.detail,"object"==typeof a&&"data"in a?a.data:null}function gc(a,b){switch(a){case"topCompositionEnd":return ec(b);case"topKeyPress":return 32!==b.which?null:(cc=!0,ac);case"topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case"topPaste":return null;case"topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case"topCompositionEnd":return $b?null:b.data;default:return null}}function mc(a){if(a=Xa(a)){jc&&"function"==typeof jc.restoreControlledState||E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}function pc(){if(kc){var a=kc,b=lc;if(lc=kc=null,mc(a),b)for(a=0;a<b.length;a++)mc(b[a])}}function rc(a,b){return a(b)}function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b}function wc(a){return a=a.target||a.srcElement||window,a.correspondingUseElement&&(a=a.correspondingUseElement),3===a.nodeType?a.parentNode:a}function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;return c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"==typeof c[b]),!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0")),c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"==typeof c.get&&"function"==typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a,c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null,delete a[b]}}}function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue(),d="";return a&&(d=zc(a)?a.checked?"true":"false":a.value),(a=d)!==c&&(b.setValue(a),!0)}function Ec(a,b,c){return a=T.getPooled(Dc.change,a,b,c),a.type="change",oc(c),Ab(a),a}function Hc(a){kb(a),lb(!1)}function Ic(a){if(Cc(qb(a)))return a}function Jc(a,b){if("topChange"===a)return b}function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}function bd(a,b,c,d){return T.call(this,a,b,c,d)}function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):!!(a=cd[a])&&!!b[a]}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}function jd(a){return a=a.type,"string"==typeof a?a:"function"==typeof a?a.displayName||a.name:null}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!=(2&b.effectTag))return 1;for(;b.return;)if(b=b.return,0!=(2&b.effectTag))return 1}return 3===b.tag?2:3}function ld(a){return!!(a=a._reactInternalFiber)&&2===kd(a)}function md(a){2!==kd(a)&&E("188")}function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b&&E("188"),1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0,c=e,d=f;break}if(h===d){g=!0,d=e,c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0,c=f,d=e;break}if(h===d){g=!0,d=f,c=e;break}h=h.sibling}g||E("189")}}c.alternate!==d&&E("190")}return 3!==c.tag&&E("188"),c.stateNode.current===c?a:b}function od(a){if(!(a=nd(a)))return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return,b=b.sibling}}return null}function pd(a){if(!(a=nd(a)))return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return,b=b.sibling}}return null}function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;if(!(c=3!==c.tag?null:c.stateNode.containerInfo))break;a.ancestors.push(b),b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}function vd(a,b){if(td){var c=wc(b);if(c=pb(c),null===c||"number"!=typeof c.tag||2===kd(c)||(c=null),qd.length){var d=qd.pop();d.topLevelType=a,d.nativeEvent=b,d.targetInst=c,a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}function yd(a,b){var c={};return c[a.toLowerCase()]=b.toLowerCase(),c["Webkit"+a]="webkit"+b,c["Moz"+a]="moz"+b,c["ms"+a]="MS"+b,c["O"+a]="o"+b.toLowerCase(),c}function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var c,b=zd[a];for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}function Hd(a){return Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={}),Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){if(d=a+c.textContent.length,a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;return"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0,Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}function Td(a,b,c,d){return T.call(this,a,b,c,d)}function Ud(a,b,c,d){return T.call(this,a,b,c,d)}function Vd(a,b,c,d){return T.call(this,a,b,c,d)}function Wd(a){var b=a.keyCode;return"charCode"in a?0===(a=a.charCode)&&13===b&&(a=13):a=b,32<=a||13===a?a:0}function Zd(a,b,c,d){return T.call(this,a,b,c,d)}function $d(a,b,c,d){return T.call(this,a,b,c,d)}function ae(a,b,c,d){return T.call(this,a,b,c,d)}function be(a,b,c,d){return T.call(this,a,b,c,d)}function ce(a,b,c,d){return T.call(this,a,b,c,d)}function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++,ge[he]=a.current,a.current=b}function ke(a){return le(a)?je:ie.current}function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var f,e={};for(f in c)e[f]=b[f];return d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e),e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}function oe(a,b,c){null!=ie.cursor&&E("168"),W(ie,b,a),W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!=typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d||E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;return b=b&&b.__reactInternalMemoizedMergedChildContext||D,je=ie.current,W(ie,b,a),W(X,X.current,a),!0}function re(a,b){var c=a.stateNode;if(c||E("169"),b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d,V(X,a),V(ie,a),W(ie,d,a)}else V(X,a);W(X,b,a)}function Y(a,b,c){this.tag=a,this.key=b,this.stateNode=this.type=null,this.sibling=this.child=this.return=null,this.index=0,this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null,this.internalContextTag=c,this.effectTag=0,this.lastEffect=this.firstEffect=this.nextEffect=null,this.expirationTime=0,this.alternate=null}function se(a,b,c){var d=a.alternate;return null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null),d.expirationTime=c,d.pendingProps=b,d.child=a.child,d.memoizedProps=a.memoizedProps,d.memoizedState=a.memoizedState,d.updateQueue=a.updateQueue,d.sibling=a.sibling,d.index=a.index,d.ref=a.ref,d}function te(a,b,c){var d=void 0,e=a.type,f=a.key;return"function"==typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"==typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"==typeof e&&null!==e&&"number"==typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,""),d.expirationTime=c,d}function ue(a,b,c,d){return b=new Y(10,d,b),b.pendingProps=a,b.expirationTime=c,b}function ve(a,b,c){return b=new Y(6,null,b),b.pendingProps=a,b.expirationTime=c,b}function we(a,b,c){return b=new Y(7,a.key,b),b.type=a.handler,b.pendingProps=a,b.expirationTime=c,b}function xe(a,b,c){return a=new Y(9,null,b),a.expirationTime=c,a}function ye(a,b,c){return b=new Y(4,a.key,b),b.pendingProps=a.children||[],b.expirationTime=c,b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation},b}function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)}),Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"==typeof ze&&ze(a)}function Ee(a){"function"==typeof Ae&&Ae(a)}function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b),(0===a.expirationTime||a.expirationTime>b.expirationTime)&&(a.expirationTime=b.expirationTime)}function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null)),null!==c?null===(a=c.updateQueue)&&(a=c.updateQueue=Fe(null)):a=null,a=a!==d?a:null,null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){return a=a.partialState,"function"==typeof a?a.call(b,c,d):a}function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1}),c.expirationTime=0,c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;(0===v||v>q)&&(c.expirationTime=q),k||(k=!0,c.baseState=a)}else k||(c.first=h.next,null===c.first&&(c.last=null)),h.isReplace?(a=Ie(h,d,a,e),g=!0):(q=Ie(h,d,a,e))&&(a=g?B({},a,q):B(a,q),g=!1),h.isForced&&(c.hasForceUpdate=!0),null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h));h=h.next}return null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null),k||(c.baseState=a),a}function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null,"function"!=typeof e&&E("191",e),e.call(b)}}function Le(a,b,c,d){function e(a,b){b.updater=f,a.stateNode=b,b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber,e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null}),a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber,e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null}),a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber,d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null}),a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;return b=new c(b,g),e(a,b),f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g),b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g||E("158");var h=ke(a);d.props=g,d.state=a.memoizedState=e,d.refs=D,d.context=me(a,h),null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1),"function"==typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),null!==(e=a.updateQueue)&&(d.state=Je(c,a,e,d,g,b))),"function"==typeof d.componentDidMount&&(a.effectTag|=4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps,g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||null==(k=h)&&E("159");var u=g.context,z=ke(b);if(z=me(b,z),"function"!=typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null)),u=b.memoizedState,e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u,!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!=typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"==typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):!L.prototype||!L.prototype.isPureReactComponent||(!ea(h,G)||!ea(u,e))}return G?("function"==typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"==typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!=typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e)),g.props=k,g.state=e,g.context=z,G}}}function Xe(a){return null===a||void 0===a?null:(a=We&&a[We]||a["@@iterator"],"function"==typeof a?a:null)}function Ze(a,b){var c=b.ref;if(null!==c&&"function"!=typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag&&E("110"),d=b.stateNode),d||E("147",c);var e=""+c;return null!==a&&null!==a.ref&&a.ref._stringRef===e?a.ref:(a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a},a._stringRef=e,a)}"string"!=typeof c&&E("148"),b._owner||E("149",c)}return c}function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c,c.nextEffect=null,c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){return a=se(a,b,c),a.index=0,a.sibling=null,a}function f(b,c,d){return b.index=d,a?null!==(d=b.alternate)?(d=d.index,d<c?(b.effectTag=2,c):d):(b.effectTag=2,c):c}function g(b){return a&&null===b.alternate&&(b.effectTag=2),b}function h(a,b,c,d){return null===b||6!==b.tag?(b=ve(c,a.internalContextTag,d),b.return=a,b):(b=e(b,c,d),b.return=a,b)}function k(a,b,c,d){return null!==b&&b.type===c.type?(d=e(b,c.props,d),d.ref=Ze(b,c),d.return=a,d):(d=te(c,a.internalContextTag,d),d.ref=Ze(b,c),d.return=a,d)}function q(a,b,c,d){return null===b||7!==b.tag?(b=we(c,a.internalContextTag,d),b.return=a,b):(b=e(b,c,d),b.return=a,b)}function v(a,b,c,d){return null===b||9!==b.tag?(b=xe(c,a.internalContextTag,d),b.type=c.value,b.return=a,b):(b=e(b,null,d),b.type=c.value,b.return=a,b)}function y(a,b,c,d){return null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation?(b=ye(c,a.internalContextTag,d),b.return=a,b):(b=e(b,c.children||[],d),b.return=a,b)}function u(a,b,c,d,f){return null===b||10!==b.tag?(b=ue(c,a.internalContextTag,d,f),b.return=a,b):(b=e(b,c,d),b.return=a,b)}function z(a,b,c){if("string"==typeof b||"number"==typeof b)return b=ve(""+b,a.internalContextTag,c),b.return=a,b;if("object"==typeof b&&null!==b){switch(b.$$typeof){case Re:return b.type===Ve?(b=ue(b.props.children,a.internalContextTag,c,b.key),b.return=a,b):(c=te(b,a.internalContextTag,c),c.ref=Ze(null,b),c.return=a,c);case Se:return b=we(b,a.internalContextTag,c),b.return=a,b;case Te:return c=xe(b,a.internalContextTag,c),c.type=b.value,c.return=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b.return=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b.return=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"==typeof c||"number"==typeof c)return null!==e?null:h(a,b,""+c,d);if("object"==typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"==typeof d||"number"==typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"==typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n),g=f(x,g,w),null===r?h=x:r.sibling=x,r=x,n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)(n=z(e,m[w],A))&&(g=f(n,g,w),null===r?h=n:r.sibling=n,r=n);return h}for(n=d(e,n);w<m.length;w++)(k=I(n,e,w,m[w],A))&&(a&&null!==k.alternate&&n.delete(null===k.key?w:k.key),g=f(k,g,w),null===r?h=k:r.sibling=k,r=k);return a&&n.forEach(function(a){return b(e,a)}),h}function N(e,g,m,A){var h=Xe(m);"function"!=typeof h&&E("150"),null==(m=h.call(m))&&E("151");for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n),g=f(J,g,w),null===r?h=J:r.sibling=J,r=J,n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())null!==(x=z(e,x.value,A))&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())null!==(x=I(n,e,w,x.value,A))&&(a&&null!==x.alternate&&n.delete(null===x.key?w:x.key),g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return a&&n.forEach(function(a){return b(e,a)}),h}return function(a,d,f,h){"object"==typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);var m="object"==typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r){if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling),d=e(m,f.type===Ve?f.props.children:f.props,h),d.ref=Ze(m,f),d.return=a,a=d;break a}c(a,m);break}b(a,m),m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d.return=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h.return=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===m){if(7===d.tag){c(a,d.sibling),d=e(d,f,h),d.return=a,a=d;break a}c(a,d);break}b(a,d),d=d.sibling}d=we(f,a.internalContextTag,h),d.return=a,a=d}return g(a);case Te:a:{if(null!==d){if(9===d.tag){c(a,d.sibling),d=e(d,null,h),d.type=f.value,d.return=a,a=d;break a}c(a,d)}d=xe(f,a.internalContextTag,h),d.type=f.value,d.return=a,a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling),d=e(d,f.children||[],h),d.return=a,a=d;break a}c(a,d);break}b(a,d),d=d.sibling}d=ye(f,a.internalContextTag,h),d.return=a,a=d}return g(a)}if("string"==typeof f||"number"==typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d.return=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);if(m&&$e(a,f),void 0===f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||h.name||"Component")}return c(a,d)}}function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){if(g(a,b),!c)return d&&re(b,!1),q(a,b);c=b.stateNode,id.current=b;var e=c.render();return b.effectTag|=1,f(a,b,e),b.memoizedState=c.state,b.memoizedProps=c.props,d&&re(b,!0),b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,b.context,!1),I(a,b.containerInfo)}function q(a,b){if(null!==a&&b.child!==a.child&&E("153"),null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);for(b.child=c,c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a&&E("155");var d=b.type,e=b.pendingProps,r=ke(b);return r=me(b,r),d=d(e,r),b.effectTag|=1,"object"==typeof d&&null!==d&&"function"==typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child),b;case 1:a:{if(e=b.type,c=b.pendingProps,d=b.memoizedProps,X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b),d=me(b,d),e=e(c,d),b.effectTag|=1,f(a,b,e),b.memoizedProps=c,b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b),null===a&&J(b),e=b.type;var n=b.memoizedProps;return d=b.pendingProps,null===d&&null===(d=n)&&E("154"),r=null!==a?a.memoizedProps:null,X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b),b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:return e=b.pendingProps,X.current?null===e&&null===(e=a&&a.memoizedProps)&&E("154"):null!==e&&b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:a:{if(I(b,b.stateNode.containerInfo),e=b.pendingProps,X.current)null===e&&null==(e=a&&a.memoizedProps)&&E("154");else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e),b.memoizedProps=e,b=b.child}return b;case 10:a:{if(c=b.pendingProps,X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c),b.memoizedProps=c,b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}return b.effectTag|=64,null===a?b.child=null:b.child!==a.child&&(b.child=a.child),0===b.expirationTime||b.expirationTime>c?v(a,b):(b.firstEffect=null,b.lastEffect=null,b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c),2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state),b.child)}}}function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;return a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):E(q?"235":"236"),{completeWork:function(a,b,c){var m=b.pendingProps;switch(null===m?m=b.memoizedProps:2147483647===b.expirationTime&&2147483647!==c||(b.pendingProps=null),b.tag){case 1:return null;case 2:return ne(b),null;case 3:return z(b),V(X,b),V(ie,b),m=b.stateNode,m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null),null!==a&&null!==a.child||(L(b),b.effectTag&=-3),N(b),null;case 5:y(b),c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=k(q,A,p,m,c,x),J(a,b,q,A,p,m,c),a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode&&E("166"),null;if(a=u(),L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child.return=p,p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p.return||p.return===b)break a;p=p.return}p.sibling.return=p.return,p=p.sibling}h(a,A,m,c)&&d(b),b.stateNode=a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!=typeof m)return null===b.stateNode&&E("166"),null;a=v(),c=u(),L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)||E("165"),b.tag=8,A=[];a:for((p=b.stateNode)&&(p.return=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child.return=p,p=p.child;continue}for(;null===p.sibling;){if(null===p.return||p.return===b)break a;p=p.return}p.sibling.return=p.return,p=p.sibling}return p=m.handler,m=p(m.props,A),b.child=bf(b,null!==a?a.child:null,m,c),b.child;case 8:return b.tag=7,null;case 9:case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){switch("function"==typeof Ee&&Ee(a),a.tag){case 2:c(a);var d=a.stateNode;if("function"==typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return}b.sibling.return=b.return,b=b.sibling}else b.child.return=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b.return;a:for(;;){switch(null===c&&E("160"),c.tag){case 5:f=c.stateNode,g=!1;break a;case 3:case 4:f=c.stateNode.containerInfo,g=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child.return=b,b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return,4===b.tag&&(c=!1)}b.sibling.return=b.return,b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence,k||E(a?"235":"236");var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a.return;null!==b;){if(f(b)){var c=b;break a}b=b.return}E("160"),c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode,d=!1;break;case 3:case 4:b=c.stateNode.containerInfo,d=!0;break;default:E("161")}16&c.effectTag&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||f(c.return)){c=null;break a}c=c.return}for(c.sibling.return=c.return,c=c.sibling;5!==c.tag&&6!==c.tag;){if(2&c.effectTag)continue b;if(null===c.child||4===c.tag)continue b;c.child.return=c,c=c.child}if(!(2&c.effectTag)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e,e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return,e=e.sibling}},commitDeletion:function(a){g(a),a.return=null,a.child=null,a.alternate&&(a.alternate.child=null,a.alternate.return=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null,null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode&&E("162"),c=b.memoizedProps,u(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(4&b.effectTag)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState,c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidUpdate(d,a)}b=b.updateQueue,null!==b&&Ke(b,c);break;case 3:c=b.updateQueue,null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode,null===a&&4&b.effectTag&&q(c,b.type,b.memoizedProps,b);break;case 6:case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){null!==(a=a.ref)&&a(null)}}}function hf(a){function b(a){return a===gf&&E("174"),a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a),V(f,a),V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a),b=d(b),W(f,a,a),W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,d),h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf,g.current=gf}}}function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED",c.stateNode=b,c.return=a,c.effectTag=8,null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return null!==(b=f(b,a.type,a.pendingProps))&&(a.stateNode=b,!0);case 6:return null!==(b=g(b,a.pendingProps))&&(a.stateNode=b,!0);default:return!1}}function d(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;y=a}var e=a.shouldSetTextContent;if(!(a=a.hydration))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){return u=k(a.stateNode.containerInfo),y=a,z=!0},resetHydrationState:function(){u=y=null,z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){if(!(d=h(d))||!c(a,d))return a.effectTag|=2,z=!1,void(y=a);b(y,u)}y=a,u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){return b=q(a.stateNode,a.type,a.memoizedProps,b,c,a),a.updateQueue=b,null!==b},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);return d(a),u=y?h(a.stateNode):null,!0}}}function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;if(b.current===a&&E("177"),b.isReadyForCommit=!1,id.current=null,1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;for(yg(),t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;if(16&f&&zg(t),128&f){var g=t.alternate;null!==g&&Ag(g)}switch(-242&f){case 2:Ne(t),t.effectTag&=-3;break;case 6:Ne(t),t.effectTag&=-3,Oe(t.alternate,t);break;case 4:Oe(t.alternate,t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t&&E("178"),h(t,e),null!==t&&(t=t.nextEffect))}for(Cg(),b.current=a,t=c;null!==t;){c=!1,d=void 0;try{for(;null!==t;){var k=t.effectTag;if(36&k&&Dg(t.alternate,t),128&k&&Eg(t),64&k)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R.delete(e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R.delete(e))),null==f&&E("184"),e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null,t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t&&E("178"),h(t,d),null!==t&&(t=t.nextEffect))}return ja=Qb=!1,"function"==typeof De&&De(a.stateNode),ha&&(ha.forEach(G),ha=null),null!==ca&&(a=ca,ca=null,Ob(a)),b=b.current.expirationTime,0===b&&(qa=R=null),b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a.return,d=a.sibling,e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;if(null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a)),null!==d)return d;if(null===c){a.stateNode.isReadyForCommit=!0;break}a=c}return null}function d(a){var b=rg(a.alternate,a,H);return null===b&&(b=c(a)),id.current=null,b}function e(a){var b=Gg(a.alternate,a,H);return null===b&&(b=c(a)),id.current=null,b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){if(ja&&E("243"),ja=!0,a.isReadyForCommit=!1,a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D,ie.current=D,X.current=!1,x(),ra=a,H=b,F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);if(null===k&&E("183"),!eb){try{for(c=k,d=b,k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g.return}F=e(c),f(d)}catch(Rc){c=!0,d=Rc;continue}break}}}return b=ca,eb=ja=!1,ca=null,null!==b&&Ob(b),a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a.return;null!==g&&null===c;){if(2===g.tag?"function"==typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g),q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null,e=!1}g=g.return}if(null!==c){null===qa&&(qa=new Set),qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=g._debugOwner,Qc=g._debugSource,m=jd(g),n=null;k&&(n=jd(k)),k=Qc,m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m,g=g.return}while(g);g=h,a=jd(a),null===R&&(R=new Map),b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e},R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&Vc.suppressReactErrorLogging||console.error(Vc)}return Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c),c}return null===ca&&(ca=b),null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(1+((I()+100)/20|0))}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||1&a.internalContextTag?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if((0===a.expirationTime||a.expirationTime>b)&&(a.expirationTime=b),null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b),null===a.return){if(3!==a.tag)break;var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;if(Rb>Ig&&E("185"),null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;(0===f||e<f)&&(d.remainingExpirationTime=e)}Fa||(la?Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e)),!ja&&c===ra&&b<H&&(F=ra=null,H=0)}a=a.return}}function G(a){z(a,1,!0)}function I(){return Uc=2+((Wc()-Pe)/10|0)}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a,Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){if((null===c||null===O)&&E("244"),d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}if(d===sa)sa=e=d.nextScheduledRoot,O.nextScheduledRoot=e,d.nextScheduledRoot=null;else{if(d===O){O=c,O.nextScheduledRoot=sa,d.nextScheduledRoot=null;break}c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null}d=c.nextScheduledRoot}else{if((0===a||e<a)&&(a=e,b=d),d===O)break;c=d,d=d.nextScheduledRoot}}c=ma,null!==c&&c===b?Rb++:Rb=0,ma=b,na=a}function J(a){w(0,a)}function w(a,b){for(fb=b,N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();if(null!==fb&&(Tb=0,Xc=-1),0!==na&&L(na),fb=null,Yc=!1,Rb=0,Ub)throw a=Zc,Zc=null,Ub=!1,a}function m(a,c){if(Fa&&E("245"),Fa=!0,c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,null!==(d=g(a,c))&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,null!==(d=g(a,c))&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return!(null===fb||fb.timeRemaining()>Lg)&&(Yc=!0)}function Ob(a){null===ma&&E("246"),ma.remainingExpirationTime=0,Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1e3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa&&E("187"),w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}function lf(a){function b(a){return a=od(a),null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);return a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null},c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=c._reactInternalFiber;var h;b:{for(2===kd(c)&&2===c.tag||E("170"),h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h.return)||E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c,b=q,b=void 0===b?null:b,q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g),He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,nextCallback:null,next:null}),f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){if(a=a.current,!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){return a=pd(a),null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}function Hf(a){return!!Gf.hasOwnProperty(a)||!Ff.hasOwnProperty(a)&&(Ef.test(a)?Gf[a]=!0:(Ff[a]=!0,!1))}function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=!c.hasBooleanValue&&"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Nf(a,b){null!=(b=b.checked)&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;null!=c?0===c&&""===a.value?a.value="0":"number"===b.type?(b=parseFloat(a.value)||0,(c!=b||c==b&&a.value!=c)&&(a.value=""+c)):a.value!==""+c&&(a.value=""+c):(null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked))}function Pf(a,b){switch(b.type){case"submit":case"reset":break;case"color":case"date":case"datetime":case"datetime-local":case"month":case"time":case"week":a.value="",a.value=a.defaultValue;break;default:a.value=a.value}b=a.name,""!==b&&(a.name=""),a.defaultChecked=!a.defaultChecked,a.defaultChecked=!a.defaultChecked,""!==b&&(a.name=b)}function Qf(a){var b="";return aa.Children.forEach(a,function(a){null==a||"string"!=typeof a&&"number"!=typeof a||(b+=a)}),b}function Rf(a,b){return a=B({children:void 0},b),(b=Qf(b.children))&&(a.children=b),a}function Sf(a,b,c,d){if(a=a.options,b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{for(c=""+c,b=null,e=0;e<a.length;e++){if(a[e].value===c)return a[e].selected=!0,void(d&&(a[e].defaultSelected=!0));null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){return null!=b.dangerouslySetInnerHTML&&E("91"),B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c&&E("92"),Array.isArray(b)&&(1>=b.length||E("93"),b=b[0]),c=""+b),null==c&&(c="")),a._wrapperState={initialValue:""+c}}function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c)),null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}function Zf(a){switch(a){case"svg":return"http://www.w3.org/2000/svg";case"math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType)return void(c.nodeValue=b)}a.textContent=b}function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=c,f=b[c];e=null==f||"boolean"==typeof f||""===f?"":d||"number"!=typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px","float"===c&&(c="cssFloat"),d?a.setProperty(c,e):a[c]=e}}function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML)&&E("137",a,c()),null!=b.dangerouslySetInnerHTML&&(null!=b.children&&E("60"),"object"==typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML||E("61")),null!=b.style&&"object"!=typeof b.style&&E("62",c()))}function ig(a,b){if(-1===a.indexOf("-"))return"string"==typeof b.is;switch(a){case"annotation-xml":case"color-profile":case"font-face":case"font-face-src":case"font-face-uri":case"font-face-format":case"font-face-name":case"missing-glyph":return!1;default:return!0}}function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}function ng(a,b,c,d){return c=9===c.nodeType?c:c.ownerDocument,d===jg&&(d=Zf(a)),d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="<script><\/script>",a=a.removeChild(a.firstChild)):a="string"==typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a),a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}function pg(a,b,c,d){var e=ig(b,c);switch(b){case"iframe":case"object":U("topLoad","load",a);var f=c;break;case"video":case"audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case"source":U("topError","error",a),f=c;break;case"img":case"image":U("topError","error",a),U("topLoad","load",a),f=c;break;case"form":U("topReset","reset",a),U("topSubmit","submit",a),f=c;break;case"details":U("topToggle","toggle",a),f=c;break;case"input":Mf(a,c),f=Lf(a,c),U("topInvalid","invalid",a),lg(d,"onChange");break;case"option":f=Rf(a,c);break;case"select":Tf(a,c),f=B({},c,{value:void 0}),U("topInvalid","invalid",a),lg(d,"onChange");break;case"textarea":Vf(a,c),f=Uf(a,c),U("topInvalid","invalid",a),lg(d,"onChange");break;default:f=c}hg(b,f,kg);var h,g=f;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?null!=(k=k?k.__html:void 0)&&bg(a,k):"children"===h?"string"==typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"==typeof k&&cg(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case"input":Bc(a),Pf(a,c);break;case"textarea":Bc(a),Xf(a,c);break;case"option":null!=c.value&&a.setAttribute("value",c.value);break;case"select":a.multiple=!!c.multiple,b=c.value,null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"==typeof f.onClick&&(a.onclick=C)}}function sg(a,b,c,d,e){var f=null;switch(b){case"input":c=Lf(a,c),d=Lf(a,d),f=[];break;case"option":c=Rf(a,c),d=Rf(a,d),f=[];break;case"select":c=B({},c,{value:void 0}),d=B({},d,{value:void 0}),f=[];break;case"textarea":c=Uf(a,c),d=Uf(a,d),f=[];break;default:"function"!=typeof c.onClick&&"function"==typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g])b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];if(b=null!=c?c[g]:void 0,d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!=typeof k&&"number"!=typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}return a&&(f=f||[]).push("style",a),f}function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e),ig(c,d),d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case"input":Of(a,e);break;case"textarea":Wf(a,e);break;case"select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}function ug(a,b,c,d,e){switch(b){case"iframe":case"object":U("topLoad","load",a);break;case"video":case"audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case"source":U("topError","error",a);break;case"img":case"image":U("topError","error",a),U("topLoad","load",a);break;case"form":U("topReset","reset",a),U("topSubmit","submit",a);break;case"details":U("topToggle","toggle",a);break;case"input":Mf(a,c),U("topInvalid","invalid",a),lg(e,"onChange");break;case"select":Tf(a,c),U("topInvalid","invalid",a),lg(e,"onChange");break;case"textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg),d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"==typeof f?a.textContent!==f&&(d=["children",f]):"number"==typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case"input":Bc(a),Pf(a,c);break;case"textarea":Bc(a),Xf(a,c);break;case"select":case"option":break;default:"function"==typeof c.onClick&&(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function Og(a){return!(!(a=a?9===a.nodeType?a.documentElement:a.firstChild:null)||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}function Pg(a,b,c,d,e){Ng(c)||E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{if(!(d=d||Og(c)))for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g,Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;return Ng(b)||E("200"),pf(a,b,null,c)}function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa=__webpack_require__(0),l=__webpack_require__(10),B=__webpack_require__(3),C=__webpack_require__(1),ba=__webpack_require__(11),da=__webpack_require__(12),ea=__webpack_require__(13),fa=__webpack_require__(14),ia=__webpack_require__(17),D=__webpack_require__(4);aa||E("227");var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0},ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)&&E("48",f);var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)},1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue||E("50",f),e.hasOwnProperty(f)&&(g.attributeName=e[f]),d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]),a.hasOwnProperty(f)&&(g.mutationMethod=a[f]),ua[f]=g}}},ua={},xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,default:K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,Ia);Ga.Properties[b]=0,Ga.DOMAttributeNames[b]=a}),xa.injectDOMPropertyConfig(Da),xa.injectDOMPropertyConfig(Ga);var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!=typeof a.invokeGuardedCallback&&E("197"),Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){if(P.invokeGuardedCallback.apply(this,arguments),P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;return P._caughtError=null,P._hasCaughtError=!1,a}E("198")}},La=null,Ma={},Oa=[],Pa={},Ra={},Sa={},Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null,bb=null,hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua},mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb,sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){return a=a[Q],!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}}),Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null,S={_root:null,_startText:null,_fallbackText:null},Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!=typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!=typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,destructor:function(){var b,a=this.constructor.Interface;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}}),T.Interface=Ib,T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype),a.prototype=d,a.prototype.constructor=a,a.Interface=B({},this.Interface,b),a.augmentClass=this.augmentClass,Jb(a)},Jb(T),T.augmentClass(Mb,{data:null}),T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"==typeof Yb&&"function"==typeof Yb.version&&12>=parseInt(Yb.version(),10))}var xc,Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1,fc=!1,ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case"topCompositionStart":var f=bc.compositionStart;break b;case"topCompositionEnd":f=bc.compositionEnd;break b;case"topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);return f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=e:null!==(e=ec(c))&&(f.data=e),Ab(f),e=f):e=null,(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null,[e,b]}},jc=null,kc=null,lc=null,nc={injectFiberControlledHostComponent:function(a){jc=a}},qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc}),sc=!1,uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}},Fc=null,Gc=null,Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else!(f=e.nodeName)||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b),"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==a&&e.setAttribute("value",a))}};T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if("topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null,a===b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);return g.type="mouseleave",g.target=f,g.relatedTarget=e,c=fd.getPooled(gd.mouseEnter,b,c,d),c.type="mouseenter",c.target=e,c.relatedTarget=f,Bb(g,c,a,b),[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,qd=[],td=!0,sd=void 0,xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd}),zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2),Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1,Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var f,e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument;if(!(f=!e)){a:{e=Hd(e),f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;switch(e=b?qb(b):window,a){case"topFocus":(vc(e)||"true"===e.contentEditable)&&(Nd=e,Od=b,Pd=null);break;case"topBlur":Pd=Od=Nd=null;break;case"topMouseDown":Qd=!0;break;case"topContextMenu":case"topMouseUp":return Qd=!1,Rd(c,d);case"topSelectionChange":if(Ld)break;case"topKeyDown":case"topKeyUp":return Rd(c,d)}return null}};T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null}),T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),bd.augmentClass(Vd,{relatedTarget:null});var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),fd.augmentClass($d,{dataTransfer:null}),bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed}),T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null}),fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+a.slice(1),c="on"+b;b="top"+b,c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]},de[a]=c,ee[b]=c});var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case"topKeyPress":if(0===Wd(c))return null;case"topKeyDown":case"topKeyUp":a=Zd;break;case"topBlur":case"topFocus":a=Vd;break;case"topClick":if(2===c.button)return null;case"topDoubleClick":case"topMouseDown":case"topMouseMove":case"topMouseUp":case"topMouseOut":case"topMouseOver":case"topContextMenu":a=fd;break;case"topDrag":case"topDragEnd":case"topDragEnter":case"topDragExit":case"topDragLeave":case"topDragOver":case"topDragStart":case"topDrop":a=$d;break;case"topTouchCancel":case"topTouchEnd":case"topTouchMove":case"topTouchStart":a=ae;break;case"topAnimationEnd":case"topAnimationIteration":case"topAnimationStart":a=Td;break;case"topTransitionEnd":a=be;break;case"topScroll":a=bd;break;case"topWheel":a=ce;break;case"topCopy":case"topCut":case"topPaste":a=Ud;break;default:a=T}return b=a.getPooled(e,b,c,d),Ab(b),b}};sd=function(a,b,c,d){a=jb(a,b,c,d),kb(a),lb(!1)},hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")),Wa=sb.getFiberCurrentPropsFromNode,Xa=sb.getInstanceFromNode,Ya=sb.getNodeFromInstance,hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;new Set;var ie={current:D},X={current:!1},je=D,ze=null,Ae=null,Qe="function"==typeof Symbol&&Symbol.for,Re=Qe?Symbol.for("react.element"):60103,Se=Qe?Symbol.for("react.call"):60104,Te=Qe?Symbol.for("react.return"):60105,Ue=Qe?Symbol.for("react.portal"):60106,Ve=Qe?Symbol.for("react.fragment"):60107,We="function"==typeof Symbol&&Symbol.iterator,Ye=Array.isArray,bf=af(!0),cf=af(!1),gf={},mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf.default?nf.default:nf,qf="object"==typeof performance&&"function"==typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};var sf=void 0,tf=void 0;if(l.canUseDOM)if("function"!=typeof requestIdleCallback||"function"!=typeof cancelIdleCallback){var Bf,uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){if(vf=!1,a=rf(),0>=yf-a){if(!(-1!==wf&&wf<=a))return void(xf||(xf=!0,requestAnimationFrame(Df)));Bf.didTimeout=!0}else Bf.didTimeout=!1;wf=-1,a=uf,uf=null,null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b,yf=a+Af,vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){return uf=a,null!=b&&"number"==typeof b.timeout&&(wf=rf()+b.timeout),xf||(xf=!0,requestAnimationFrame(Df)),0},tf=function(){uf=null,vf=!1,wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return 1/0}})})},tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={},Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},ag=void 0,bg=function(a){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{for(ag=ag||document.createElement("div"),ag.innerHTML="<svg>"+b+"</svg>",b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}}),dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1),dg[b]=dg[a]})});var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0}),jg=Yf.html,kg=C.thatReturns(""),mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case"input":if(Of(a,c),b=c.name,"radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;for(c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]'),b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e||E("90"),Cc(d),Of(d,e)}}}break;case"textarea":Wf(a,c);break;case"select":null!=(b=c.value)&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null,Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;v!==b||0!==d&&3!==v.nodeType||(g=f+d),v!==e||0!==c&&3!==v.nodeType||(h=f+c),3===v.nodeType&&(f+=v.nodeValue.length),null!==(u=v.firstChild);)y=v,v=u;for(;;){if(v===a)break b;if(y===b&&++k===d&&(g=f),y===e&&++q===c&&(h=f),null!==(u=v.nextSibling))break;v=y,y=v.parentNode}v=u}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b},ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e),d=void 0===d.end?a:Math.min(d.end,e),!b.extend&&a>d&&(e=d,d=a,a=e),e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset),b.removeAllRanges(),a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}for(b=[],a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});for(ia(c),c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}Mg=null,ud(xg),xg=null},createInstance:function(a,b,c,d,e){return a=ng(a,b,c,d),a[Q]=e,a[ob]=b,a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case"button":case"input":case"select":case"textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"==typeof b.children||"number"==typeof b.children||"object"==typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"==typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){return a=og(a,b),a[Q]=d,a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e,tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){return a[Q]=f,a[ob]=c,ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){return a[Q]=c,vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates,Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)},Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"==typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){return(null==a||void 0===a._reactInternalFiber)&&E("38"),Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){return Ng(a)||E("40"),!!a._reactRootContainer&&(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0)},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug.default?Ug.default:Ug},function(module,exports,__webpack_require__){"use strict";var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement),ExecutionEnvironment={canUseDOM:canUseDOM,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:canUseDOM&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:canUseDOM&&!!window.screen,isInWorker:!canUseDOM};module.exports=ExecutionEnvironment},function(module,exports,__webpack_require__){"use strict";var emptyFunction=__webpack_require__(1),EventListener={listen:function(target,eventType,callback){return target.addEventListener?(target.addEventListener(eventType,callback,!1),{remove:function(){target.removeEventListener(eventType,callback,!1)}}):target.attachEvent?(target.attachEvent("on"+eventType,callback),{remove:function(){target.detachEvent("on"+eventType,callback)}}):void 0},capture:function(target,eventType,callback){return target.addEventListener?(target.addEventListener(eventType,callback,!0),{remove:function(){target.removeEventListener(eventType,callback,!0)}}):{remove:emptyFunction}},registerDefault:function(){}};module.exports=EventListener},function(module,exports,__webpack_require__){"use strict";function getActiveElement(doc){if(void 0===(doc=doc||("undefined"!=typeof document?document:void 0)))return null;try{return doc.activeElement||doc.body}catch(e){return doc.body}}module.exports=getActiveElement},function(module,exports,__webpack_require__){"use strict";function is(x,y){return x===y?0!==x||0!==y||1/x==1/y:x!==x&&y!==y}function shallowEqual(objA,objB){if(is(objA,objB))return!0;if("object"!=typeof objA||null===objA||"object"!=typeof objB||null===objB)return!1;var keysA=Object.keys(objA),keysB=Object.keys(objB);if(keysA.length!==keysB.length)return!1;for(var i=0;i<keysA.length;i++)if(!hasOwnProperty.call(objB,keysA[i])||!is(objA[keysA[i]],objB[keysA[i]]))return!1;return!0}var hasOwnProperty=Object.prototype.hasOwnProperty;module.exports=shallowEqual},function(module,exports,__webpack_require__){"use strict";function containsNode(outerNode,innerNode){return!(!outerNode||!innerNode)&&(outerNode===innerNode||!isTextNode(outerNode)&&(isTextNode(innerNode)?containsNode(outerNode,innerNode.parentNode):"contains"in outerNode?outerNode.contains(innerNode):!!outerNode.compareDocumentPosition&&!!(16&outerNode.compareDocumentPosition(innerNode))))}var isTextNode=__webpack_require__(15);module.exports=containsNode},function(module,exports,__webpack_require__){"use strict";function isTextNode(object){return isNode(object)&&3==object.nodeType}var isNode=__webpack_require__(16);module.exports=isTextNode},function(module,exports,__webpack_require__){"use strict";function isNode(object){var doc=object?object.ownerDocument||object:document,defaultView=doc.defaultView||window;return!(!object||!("function"==typeof defaultView.Node?object instanceof defaultView.Node:"object"==typeof object&&"number"==typeof object.nodeType&&"string"==typeof object.nodeName))}module.exports=isNode},function(module,exports,__webpack_require__){"use strict";function focusNode(node){try{node.focus()}catch(e){}}module.exports=focusNode},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!call||"object"!==(void 0===call?"undefined":_typeof(call))&&"function"!=typeof call?self:call}function _inherits(subClass,superClass){if("function"!=typeof superClass&&null!==superClass)throw new TypeError("Super expression must either be null or a function, not "+(void 0===superClass?"undefined":_typeof(superClass)));subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj};Object.defineProperty(exports,"__esModule",{value:!0}),exports.ToggleBoxNext=void 0;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_propTypes=__webpack_require__(19),_propTypes2=_interopRequireDefault(_propTypes),_reactToAngular=__webpack_require__(6),ToggleBoxNext=exports.ToggleBoxNext=function(_React$Component){function ToggleBoxNext(props){_classCallCheck(this,ToggleBoxNext);var _this=_possibleConstructorReturn(this,(ToggleBoxNext.__proto__||Object.getPrototypeOf(ToggleBoxNext)).call(this,props));return _this.state={isOpen:_this.props.isOpen||!1},_this.toggle=_this.toggle.bind(_this),_this}return _inherits(ToggleBoxNext,_React$Component),_createClass(ToggleBoxNext,[{key:"toggle",value:function(){this.setState({isOpen:!this.state.isOpen})}},{key:"render",value:function(){var _props=this.props,title=_props.title,style=_props.style,mode=_props.mode,children=_props.children,isOpen=this.state.isOpen,classNames=["toggle-box toggle-box--"+style,mode];return isOpen||classNames.push("hidden"),_react2.default.createElement("div",{className:classNames.join(" ")},_react2.default.createElement("div",{className:"toggle-box__header",onClick:this.toggle},_react2.default.createElement("div",{className:"toggle-box__chevron"},_react2.default.createElement("i",{className:"icon-chevron-right-thin"})),_react2.default.createElement("div",{className:"toggle-box__label"},title),_react2.default.createElement("div",{className:"toggle-box__line"})),_react2.default.createElement("div",{className:"toggle-box__content-wraper"},isOpen?_react2.default.createElement("div",{className:"toggle-box__content"},children):null))}}]),ToggleBoxNext}(_react2.default.Component);ToggleBoxNext.propTypes={mode:_propTypes2.default.string,title:_propTypes2.default.string.isRequired,style:_propTypes2.default.string,children:_propTypes2.default.any,isOpen:_propTypes2.default.bool},angular.module("superdesk-ui.toggleBoxNext",[]).component("toggleBoxNext",(0,_reactToAngular.reactToAngular1)(ToggleBoxNext,["mode","title","style","isOpen"]))},function(module,exports,__webpack_require__){module.exports=__webpack_require__(23)()},function(module,exports,__webpack_require__){"use strict";function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!call||"object"!==(void 0===call?"undefined":_typeof(call))&&"function"!=typeof call?self:call}function _inherits(subClass,superClass){if("function"!=typeof superClass&&null!==superClass)throw new TypeError("Super expression must either be null or a function, not "+(void 0===superClass?"undefined":_typeof(superClass)));subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj};Object.defineProperty(exports,"__esModule",{value:!0}),exports.Positioner=void 0;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key])}return target},_createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(0),_react2=_interopRequireDefault(_react),_reactDom=__webpack_require__(5),_reactDom2=_interopRequireDefault(_reactDom),_popper=__webpack_require__(21),_popper2=_interopRequireDefault(_popper),_propTypes=__webpack_require__(19),_propTypes2=_interopRequireDefault(_propTypes),_reactToAngular=__webpack_require__(6),eventCloseOthers="superdesk-ui-framework.positioner.closeOthers",PopperWrapper=function(_React$Component){function PopperWrapper(){return _classCallCheck(this,PopperWrapper),_possibleConstructorReturn(this,(PopperWrapper.__proto__||Object.getPrototypeOf(PopperWrapper)).apply(this,arguments))}return _inherits(PopperWrapper,_React$Component),_createClass(PopperWrapper,[{key:"componentDidMount",value:function(){this.closeDropdownOnOutsideClickBound=this.props.closeDropdownOnOutsideClick.bind(null,this.wrapper),window.addEventListener("click",this.closeDropdownOnOutsideClickBound),window.addEventListener(eventCloseOthers,this.props.handleCloseOthers);var dropdownElement=this.wrapper;null!=this.props.zIndex&&(dropdownElement.style["z-index"]=this.props.zIndex);var rect=this.props.triggerElement.getBoundingClientRect(),viewportHeight=document.documentElement.clientHeight,viewportWidth=document.documentElement.clientWidth,availableSpaceTop=rect.top-5,availableSpaceBottom=viewportHeight-rect.bottom-5,availableSpaceLeft=rect.left,availableSpaceRight=viewportWidth-rect.right;this.wrapper.style.maxHeight=Math.max(availableSpaceBottom,availableSpaceTop)+"px",this.wrapper.style.maxWidth=Math.max(availableSpaceLeft,availableSpaceRight)+"px",this.wrapper.style.overflow="auto",this.popperInstance=new _popper2.default(this.props.triggerElement,dropdownElement,{placement:this.props.placement,eventsEnabled:!1})}},{key:"componentWillUnmount",value:function(){window.removeEventListener("click",this.closeDropdownOnOutsideClickBound),window.removeEventListener(eventCloseOthers,this.props.handleCloseOthers),this.popperInstance.destroy()}},{key:"render",value:function(){var _this2=this;return _react2.default.createElement("div",{className:this.props.className||null,ref:function(w){return _this2.wrapper=w}},this.props.children)}}]),PopperWrapper}(_react2.default.Component);PopperWrapper.propTypes={children:_propTypes2.default.any,triggerSelector:_propTypes2.default.string,handleCloseOthers:_propTypes2.default.func,closeDropdownOnOutsideClick:_propTypes2.default.func,triggerElement:_propTypes2.default.object,placement:_propTypes2.default.string,zIndex:_propTypes2.default.number,className:_propTypes2.default.string};var Positioner=exports.Positioner=function(_React$Component2){function Positioner(props){_classCallCheck(this,Positioner);var _this3=_possibleConstructorReturn(this,(Positioner.__proto__||Object.getPrototypeOf(Positioner)).call(this,props));return _this3.elementForPositioner=document.body.appendChild(document.createElement("div")),_this3.state={open:!1},_this3.toggleDropdown=_this3.toggleDropdown.bind(_this3),_this3.handleCloseOthers=_this3.handleCloseOthers.bind(_this3),_this3.closeDropdownOnOutsideClick=_this3.closeDropdownOnOutsideClick.bind(_this3),_this3}return _inherits(Positioner,_React$Component2),_createClass(Positioner,[{key:"handleCloseOthers",value:function(event){event.detail.triggerElement!==this.triggerElement&&this.setState({open:!1})}},{key:"componentDidMount",value:function(){var _this4=this;setTimeout(function(){_this4.triggerElement=document.querySelector(_this4.props.triggerSelector),_this4.triggerElement.addEventListener("click",_this4.toggleDropdown)})}},{key:"componentWillUnmount",value:function(){this.elementForPositioner.remove(),_reactDom2.default.unmountComponentAtNode(this.elementForPositioner),this.triggerElement.removeEventListener("click",this.toggleDropdown)}},{key:"toggleDropdown",value:function(e){e.stopPropagation(),window.dispatchEvent(new CustomEvent(eventCloseOthers,{detail:{triggerElement:this.triggerElement}})),this.setState({open:!this.state.open})}},{key:"closeDropdownOnOutsideClick",value:function(wrapper,event){!0!==this.state.open||null==event||event.target===this.triggerElement||null==event.target||null==wrapper||wrapper.contains(event.target)||this.setState({open:!1})}},{key:"componentDidUpdate",value:function(){!0===this.state.open?_reactDom2.default.render(_react2.default.createElement(PopperWrapper,_extends({},this.props,{handleCloseOthers:this.handleCloseOthers,closeDropdownOnOutsideClick:this.closeDropdownOnOutsideClick,triggerElement:this.triggerElement})),this.elementForPositioner):_reactDom2.default.unmountComponentAtNode(this.elementForPositioner)}},{key:"render",value:function(){return null}}]),Positioner}(_react2.default.Component);Positioner.propTypes={children:_propTypes2.default.any,triggerSelector:_propTypes2.default.string,placement:_propTypes2.default.string,zIndex:_propTypes2.default.number,className:_propTypes2.default.string},angular.module("superdesk-ui.positioner",[]).component("sdPositioner",(0,_reactToAngular.reactToAngular1)(Positioner,["triggerSelector","placement","zIndex","className"]))},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0}),function(global){function microtaskDebounce(fn){var called=!1;return function(){called||(called=!0,window.Promise.resolve().then(function(){called=!1,fn()}))}}function taskDebounce(fn){var scheduled=!1;return function(){scheduled||(scheduled=!0,setTimeout(function(){scheduled=!1,fn()},timeoutDuration))}}function isFunction(functionToCheck){var getType={};return functionToCheck&&"[object Function]"===getType.toString.call(functionToCheck)}function getStyleComputedProperty(element,property){if(1!==element.nodeType)return[];var css=getComputedStyle(element,null);return property?css[property]:css}function getParentNode(element){return"HTML"===element.nodeName?element:element.parentNode||element.host}function getScrollParent(element){if(!element)return document.body;switch(element.nodeName){case"HTML":case"BODY":return element.ownerDocument.body;case"#document":return element.body}var _getStyleComputedProp=getStyleComputedProperty(element),overflow=_getStyleComputedProp.overflow,overflowX=_getStyleComputedProp.overflowX;return/(auto|scroll|overlay)/.test(overflow+_getStyleComputedProp.overflowY+overflowX)?element:getScrollParent(getParentNode(element))}function isIE(version){return 11===version?isIE11:10===version?isIE10:isIE11||isIE10}function getOffsetParent(element){if(!element)return document.documentElement;for(var noOffsetParent=isIE(10)?document.body:null,offsetParent=element.offsetParent;offsetParent===noOffsetParent&&element.nextElementSibling;)offsetParent=(element=element.nextElementSibling).offsetParent;var nodeName=offsetParent&&offsetParent.nodeName;return nodeName&&"BODY"!==nodeName&&"HTML"!==nodeName?-1!==["TD","TABLE"].indexOf(offsetParent.nodeName)&&"static"===getStyleComputedProperty(offsetParent,"position")?getOffsetParent(offsetParent):offsetParent:element?element.ownerDocument.documentElement:document.documentElement}function isOffsetContainer(element){var nodeName=element.nodeName;return"BODY"!==nodeName&&("HTML"===nodeName||getOffsetParent(element.firstElementChild)===element)}function getRoot(node){return null!==node.parentNode?getRoot(node.parentNode):node}function findCommonOffsetParent(element1,element2){if(!(element1&&element1.nodeType&&element2&&element2.nodeType))return document.documentElement;var order=element1.compareDocumentPosition(element2)&Node.DOCUMENT_POSITION_FOLLOWING,start=order?element1:element2,end=order?element2:element1,range=document.createRange();range.setStart(start,0),range.setEnd(end,0);var commonAncestorContainer=range.commonAncestorContainer;if(element1!==commonAncestorContainer&&element2!==commonAncestorContainer||start.contains(end))return isOffsetContainer(commonAncestorContainer)?commonAncestorContainer:getOffsetParent(commonAncestorContainer);var element1root=getRoot(element1);return element1root.host?findCommonOffsetParent(element1root.host,element2):findCommonOffsetParent(element1,getRoot(element2).host)}function getScroll(element){var side=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",upperSide="top"===side?"scrollTop":"scrollLeft",nodeName=element.nodeName;if("BODY"===nodeName||"HTML"===nodeName){var html=element.ownerDocument.documentElement;return(element.ownerDocument.scrollingElement||html)[upperSide]}return element[upperSide]}function includeScroll(rect,element){var subtract=arguments.length>2&&void 0!==arguments[2]&&arguments[2],scrollTop=getScroll(element,"top"),scrollLeft=getScroll(element,"left"),modifier=subtract?-1:1;return rect.top+=scrollTop*modifier,rect.bottom+=scrollTop*modifier,rect.left+=scrollLeft*modifier,rect.right+=scrollLeft*modifier,rect}function getBordersSize(styles,axis){var sideA="x"===axis?"Left":"Top",sideB="Left"===sideA?"Right":"Bottom";return parseFloat(styles["border"+sideA+"Width"],10)+parseFloat(styles["border"+sideB+"Width"],10)}function getSize(axis,body,html,computedStyle){return Math.max(body["offset"+axis],body["scroll"+axis],html["client"+axis],html["offset"+axis],html["scroll"+axis],isIE(10)?parseInt(html["offset"+axis])+parseInt(computedStyle["margin"+("Height"===axis?"Top":"Left")])+parseInt(computedStyle["margin"+("Height"===axis?"Bottom":"Right")]):0)}function getWindowSizes(document){var body=document.body,html=document.documentElement,computedStyle=isIE(10)&&getComputedStyle(html);return{height:getSize("Height",body,html,computedStyle),width:getSize("Width",body,html,computedStyle)}}function getClientRect(offsets){return _extends({},offsets,{right:offsets.left+offsets.width,bottom:offsets.top+offsets.height})}function getBoundingClientRect(element){var rect={};try{if(isIE(10)){rect=element.getBoundingClientRect();var scrollTop=getScroll(element,"top"),scrollLeft=getScroll(element,"left");rect.top+=scrollTop,rect.left+=scrollLeft,rect.bottom+=scrollTop,rect.right+=scrollLeft}else rect=element.getBoundingClientRect()}catch(e){}var result={left:rect.left,top:rect.top,width:rect.right-rect.left,height:rect.bottom-rect.top},sizes="HTML"===element.nodeName?getWindowSizes(element.ownerDocument):{},width=sizes.width||element.clientWidth||result.right-result.left,height=sizes.height||element.clientHeight||result.bottom-result.top,horizScrollbar=element.offsetWidth-width,vertScrollbar=element.offsetHeight-height;if(horizScrollbar||vertScrollbar){var styles=getStyleComputedProperty(element);horizScrollbar-=getBordersSize(styles,"x"),vertScrollbar-=getBordersSize(styles,"y"),result.width-=horizScrollbar,result.height-=vertScrollbar}return getClientRect(result)}function getOffsetRectRelativeToArbitraryNode(children,parent){var fixedPosition=arguments.length>2&&void 0!==arguments[2]&&arguments[2],isIE10=isIE(10),isHTML="HTML"===parent.nodeName,childrenRect=getBoundingClientRect(children),parentRect=getBoundingClientRect(parent),scrollParent=getScrollParent(children),styles=getStyleComputedProperty(parent),borderTopWidth=parseFloat(styles.borderTopWidth,10),borderLeftWidth=parseFloat(styles.borderLeftWidth,10);fixedPosition&&isHTML&&(parentRect.top=Math.max(parentRect.top,0),parentRect.left=Math.max(parentRect.left,0));var offsets=getClientRect({top:childrenRect.top-parentRect.top-borderTopWidth,left:childrenRect.left-parentRect.left-borderLeftWidth,width:childrenRect.width,height:childrenRect.height});if(offsets.marginTop=0,offsets.marginLeft=0,!isIE10&&isHTML){var marginTop=parseFloat(styles.marginTop,10),marginLeft=parseFloat(styles.marginLeft,10);offsets.top-=borderTopWidth-marginTop,offsets.bottom-=borderTopWidth-marginTop,offsets.left-=borderLeftWidth-marginLeft,offsets.right-=borderLeftWidth-marginLeft,offsets.marginTop=marginTop,offsets.marginLeft=marginLeft}return(isIE10&&!fixedPosition?parent.contains(scrollParent):parent===scrollParent&&"BODY"!==scrollParent.nodeName)&&(offsets=includeScroll(offsets,parent)),offsets}function getViewportOffsetRectRelativeToArtbitraryNode(element){var excludeScroll=arguments.length>1&&void 0!==arguments[1]&&arguments[1],html=element.ownerDocument.documentElement,relativeOffset=getOffsetRectRelativeToArbitraryNode(element,html),width=Math.max(html.clientWidth,window.innerWidth||0),height=Math.max(html.clientHeight,window.innerHeight||0),scrollTop=excludeScroll?0:getScroll(html),scrollLeft=excludeScroll?0:getScroll(html,"left");return getClientRect({top:scrollTop-relativeOffset.top+relativeOffset.marginTop,left:scrollLeft-relativeOffset.left+relativeOffset.marginLeft,width:width,height:height})}function isFixed(element){var nodeName=element.nodeName;return"BODY"!==nodeName&&"HTML"!==nodeName&&("fixed"===getStyleComputedProperty(element,"position")||isFixed(getParentNode(element)))}function getFixedPositionOffsetParent(element){if(!element||!element.parentElement||isIE())return document.documentElement;for(var el=element.parentElement;el&&"none"===getStyleComputedProperty(el,"transform");)el=el.parentElement;return el||document.documentElement}function getBoundaries(popper,reference,padding,boundariesElement){var fixedPosition=arguments.length>4&&void 0!==arguments[4]&&arguments[4],boundaries={top:0,left:0},offsetParent=fixedPosition?getFixedPositionOffsetParent(popper):findCommonOffsetParent(popper,reference);if("viewport"===boundariesElement)boundaries=getViewportOffsetRectRelativeToArtbitraryNode(offsetParent,fixedPosition);else{var boundariesNode=void 0;"scrollParent"===boundariesElement?(boundariesNode=getScrollParent(getParentNode(reference)),"BODY"===boundariesNode.nodeName&&(boundariesNode=popper.ownerDocument.documentElement)):boundariesNode="window"===boundariesElement?popper.ownerDocument.documentElement:boundariesElement;var offsets=getOffsetRectRelativeToArbitraryNode(boundariesNode,offsetParent,fixedPosition);if("HTML"!==boundariesNode.nodeName||isFixed(offsetParent))boundaries=offsets;else{var _getWindowSizes=getWindowSizes(popper.ownerDocument),height=_getWindowSizes.height,width=_getWindowSizes.width;boundaries.top+=offsets.top-offsets.marginTop,boundaries.bottom=height+offsets.top,boundaries.left+=offsets.left-offsets.marginLeft,boundaries.right=width+offsets.left}}padding=padding||0;var isPaddingNumber="number"==typeof padding;return boundaries.left+=isPaddingNumber?padding:padding.left||0,boundaries.top+=isPaddingNumber?padding:padding.top||0,boundaries.right-=isPaddingNumber?padding:padding.right||0,boundaries.bottom-=isPaddingNumber?padding:padding.bottom||0,boundaries}function getArea(_ref){return _ref.width*_ref.height}function computeAutoPlacement(placement,refRect,popper,reference,boundariesElement){var padding=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(-1===placement.indexOf("auto"))return placement;var boundaries=getBoundaries(popper,reference,padding,boundariesElement),rects={top:{width:boundaries.width,height:refRect.top-boundaries.top},right:{width:boundaries.right-refRect.right,height:boundaries.height},bottom:{width:boundaries.width,height:boundaries.bottom-refRect.bottom},left:{width:refRect.left-boundaries.left,height:boundaries.height}},sortedAreas=Object.keys(rects).map(function(key){return _extends({key:key},rects[key],{area:getArea(rects[key])})}).sort(function(a,b){return b.area-a.area}),filteredAreas=sortedAreas.filter(function(_ref2){var width=_ref2.width,height=_ref2.height;return width>=popper.clientWidth&&height>=popper.clientHeight}),computedPlacement=filteredAreas.length>0?filteredAreas[0].key:sortedAreas[0].key,variation=placement.split("-")[1];return computedPlacement+(variation?"-"+variation:"")}function getReferenceOffsets(state,popper,reference){var fixedPosition=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;return getOffsetRectRelativeToArbitraryNode(reference,fixedPosition?getFixedPositionOffsetParent(popper):findCommonOffsetParent(popper,reference),fixedPosition)}function getOuterSizes(element){var styles=getComputedStyle(element),x=parseFloat(styles.marginTop)+parseFloat(styles.marginBottom),y=parseFloat(styles.marginLeft)+parseFloat(styles.marginRight);return{width:element.offsetWidth+y,height:element.offsetHeight+x}}function getOppositePlacement(placement){var hash={left:"right",right:"left",bottom:"top",top:"bottom"};return placement.replace(/left|right|bottom|top/g,function(matched){return hash[matched]})}function getPopperOffsets(popper,referenceOffsets,placement){placement=placement.split("-")[0];var popperRect=getOuterSizes(popper),popperOffsets={width:popperRect.width,height:popperRect.height},isHoriz=-1!==["right","left"].indexOf(placement),mainSide=isHoriz?"top":"left",secondarySide=isHoriz?"left":"top",measurement=isHoriz?"height":"width",secondaryMeasurement=isHoriz?"width":"height";return popperOffsets[mainSide]=referenceOffsets[mainSide]+referenceOffsets[measurement]/2-popperRect[measurement]/2,popperOffsets[secondarySide]=placement===secondarySide?referenceOffsets[secondarySide]-popperRect[secondaryMeasurement]:referenceOffsets[getOppositePlacement(secondarySide)],popperOffsets}function find(arr,check){return Array.prototype.find?arr.find(check):arr.filter(check)[0]}function findIndex(arr,prop,value){if(Array.prototype.findIndex)return arr.findIndex(function(cur){return cur[prop]===value});var match=find(arr,function(obj){return obj[prop]===value});return arr.indexOf(match)}function runModifiers(modifiers,data,ends){return(void 0===ends?modifiers:modifiers.slice(0,findIndex(modifiers,"name",ends))).forEach(function(modifier){modifier.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var fn=modifier.function||modifier.fn;modifier.enabled&&isFunction(fn)&&(data.offsets.popper=getClientRect(data.offsets.popper),data.offsets.reference=getClientRect(data.offsets.reference),data=fn(data,modifier))}),data}function update(){if(!this.state.isDestroyed){var data={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};data.offsets.reference=getReferenceOffsets(this.state,this.popper,this.reference,this.options.positionFixed),data.placement=computeAutoPlacement(this.options.placement,data.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),data.originalPlacement=data.placement,data.positionFixed=this.options.positionFixed,data.offsets.popper=getPopperOffsets(this.popper,data.offsets.reference,data.placement),data.offsets.popper.position=this.options.positionFixed?"fixed":"absolute",data=runModifiers(this.modifiers,data),this.state.isCreated?this.options.onUpdate(data):(this.state.isCreated=!0,this.options.onCreate(data))}}function isModifierEnabled(modifiers,modifierName){return modifiers.some(function(_ref){var name=_ref.name;return _ref.enabled&&name===modifierName})}function getSupportedPropertyName(property){for(var prefixes=[!1,"ms","Webkit","Moz","O"],upperProp=property.charAt(0).toUpperCase()+property.slice(1),i=0;i<prefixes.length;i++){var prefix=prefixes[i],toCheck=prefix?""+prefix+upperProp:property;if(void 0!==document.body.style[toCheck])return toCheck}return null}function destroy(){return this.state.isDestroyed=!0,isModifierEnabled(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.position="",this.popper.style.top="",this.popper.style.left="",this.popper.style.right="",this.popper.style.bottom="",this.popper.style.willChange="",this.popper.style[getSupportedPropertyName("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function getWindow(element){var ownerDocument=element.ownerDocument;return ownerDocument?ownerDocument.defaultView:window}function attachToScrollParents(scrollParent,event,callback,scrollParents){var isBody="BODY"===scrollParent.nodeName,target=isBody?scrollParent.ownerDocument.defaultView:scrollParent;target.addEventListener(event,callback,{passive:!0}),isBody||attachToScrollParents(getScrollParent(target.parentNode),event,callback,scrollParents),scrollParents.push(target)}function setupEventListeners(reference,options,state,updateBound){state.updateBound=updateBound,getWindow(reference).addEventListener("resize",state.updateBound,{passive:!0});var scrollElement=getScrollParent(reference);return attachToScrollParents(scrollElement,"scroll",state.updateBound,state.scrollParents),state.scrollElement=scrollElement,state.eventsEnabled=!0,state}function enableEventListeners(){this.state.eventsEnabled||(this.state=setupEventListeners(this.reference,this.options,this.state,this.scheduleUpdate))}function removeEventListeners(reference,state){return getWindow(reference).removeEventListener("resize",state.updateBound),state.scrollParents.forEach(function(target){target.removeEventListener("scroll",state.updateBound)}),state.updateBound=null,state.scrollParents=[],state.scrollElement=null,state.eventsEnabled=!1,state}function disableEventListeners(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=removeEventListeners(this.reference,this.state))}function isNumeric(n){return""!==n&&!isNaN(parseFloat(n))&&isFinite(n)}function setStyles(element,styles){Object.keys(styles).forEach(function(prop){var unit="";-1!==["width","height","top","right","bottom","left"].indexOf(prop)&&isNumeric(styles[prop])&&(unit="px"),element.style[prop]=styles[prop]+unit})}function setAttributes(element,attributes){Object.keys(attributes).forEach(function(prop){!1!==attributes[prop]?element.setAttribute(prop,attributes[prop]):element.removeAttribute(prop)})}function applyStyle(data){return setStyles(data.instance.popper,data.styles),setAttributes(data.instance.popper,data.attributes),data.arrowElement&&Object.keys(data.arrowStyles).length&&setStyles(data.arrowElement,data.arrowStyles),data}function applyStyleOnLoad(reference,popper,options,modifierOptions,state){var referenceOffsets=getReferenceOffsets(state,popper,reference,options.positionFixed),placement=computeAutoPlacement(options.placement,referenceOffsets,popper,reference,options.modifiers.flip.boundariesElement,options.modifiers.flip.padding);return popper.setAttribute("x-placement",placement),setStyles(popper,{position:options.positionFixed?"fixed":"absolute"}),options}function computeStyle(data,options){var x=options.x,y=options.y,popper=data.offsets.popper,legacyGpuAccelerationOption=find(data.instance.modifiers,function(modifier){return"applyStyle"===modifier.name}).gpuAcceleration;void 0!==legacyGpuAccelerationOption&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var gpuAcceleration=void 0!==legacyGpuAccelerationOption?legacyGpuAccelerationOption:options.gpuAcceleration,offsetParent=getOffsetParent(data.instance.popper),offsetParentRect=getBoundingClientRect(offsetParent),styles={position:popper.position},offsets={left:Math.floor(popper.left),top:Math.round(popper.top),bottom:Math.round(popper.bottom),right:Math.floor(popper.right)},sideA="bottom"===x?"top":"bottom",sideB="right"===y?"left":"right",prefixedProperty=getSupportedPropertyName("transform"),left=void 0,top=void 0;if(top="bottom"===sideA?"HTML"===offsetParent.nodeName?-offsetParent.clientHeight+offsets.bottom:-offsetParentRect.height+offsets.bottom:offsets.top,left="right"===sideB?"HTML"===offsetParent.nodeName?-offsetParent.clientWidth+offsets.right:-offsetParentRect.width+offsets.right:offsets.left,gpuAcceleration&&prefixedProperty)styles[prefixedProperty]="translate3d("+left+"px, "+top+"px, 0)",styles[sideA]=0,styles[sideB]=0,styles.willChange="transform";else{var invertTop="bottom"===sideA?-1:1,invertLeft="right"===sideB?-1:1;styles[sideA]=top*invertTop,styles[sideB]=left*invertLeft,styles.willChange=sideA+", "+sideB}var attributes={"x-placement":data.placement};return data.attributes=_extends({},attributes,data.attributes),data.styles=_extends({},styles,data.styles),data.arrowStyles=_extends({},data.offsets.arrow,data.arrowStyles),data}function isModifierRequired(modifiers,requestingName,requestedName){var requesting=find(modifiers,function(_ref){return _ref.name===requestingName}),isRequired=!!requesting&&modifiers.some(function(modifier){return modifier.name===requestedName&&modifier.enabled&&modifier.order<requesting.order});if(!isRequired){var _requesting="`"+requestingName+"`",requested="`"+requestedName+"`";console.warn(requested+" modifier is required by "+_requesting+" modifier in order to work, be sure to include it before "+_requesting+"!")}return isRequired}function arrow(data,options){var _data$offsets$arrow;if(!isModifierRequired(data.instance.modifiers,"arrow","keepTogether"))return data;var arrowElement=options.element;if("string"==typeof arrowElement){if(!(arrowElement=data.instance.popper.querySelector(arrowElement)))return data}else if(!data.instance.popper.contains(arrowElement))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),data;var placement=data.placement.split("-")[0],_data$offsets=data.offsets,popper=_data$offsets.popper,reference=_data$offsets.reference,isVertical=-1!==["left","right"].indexOf(placement),len=isVertical?"height":"width",sideCapitalized=isVertical?"Top":"Left",side=sideCapitalized.toLowerCase(),altSide=isVertical?"left":"top",opSide=isVertical?"bottom":"right",arrowElementSize=getOuterSizes(arrowElement)[len];reference[opSide]-arrowElementSize<popper[side]&&(data.offsets.popper[side]-=popper[side]-(reference[opSide]-arrowElementSize)),reference[side]+arrowElementSize>popper[opSide]&&(data.offsets.popper[side]+=reference[side]+arrowElementSize-popper[opSide]),data.offsets.popper=getClientRect(data.offsets.popper);var center=reference[side]+reference[len]/2-arrowElementSize/2,css=getStyleComputedProperty(data.instance.popper),popperMarginSide=parseFloat(css["margin"+sideCapitalized],10),popperBorderSide=parseFloat(css["border"+sideCapitalized+"Width"],10),sideValue=center-data.offsets.popper[side]-popperMarginSide-popperBorderSide;return sideValue=Math.max(Math.min(popper[len]-arrowElementSize,sideValue),0),data.arrowElement=arrowElement,data.offsets.arrow=(_data$offsets$arrow={},defineProperty(_data$offsets$arrow,side,Math.round(sideValue)),defineProperty(_data$offsets$arrow,altSide,""),_data$offsets$arrow),data}function getOppositeVariation(variation){return"end"===variation?"start":"start"===variation?"end":variation}function clockwise(placement){var counter=arguments.length>1&&void 0!==arguments[1]&&arguments[1],index=validPlacements.indexOf(placement),arr=validPlacements.slice(index+1).concat(validPlacements.slice(0,index));return counter?arr.reverse():arr}function flip(data,options){if(isModifierEnabled(data.instance.modifiers,"inner"))return data;if(data.flipped&&data.placement===data.originalPlacement)return data;var boundaries=getBoundaries(data.instance.popper,data.instance.reference,options.padding,options.boundariesElement,data.positionFixed),placement=data.placement.split("-")[0],placementOpposite=getOppositePlacement(placement),variation=data.placement.split("-")[1]||"",flipOrder=[];switch(options.behavior){case BEHAVIORS.FLIP:flipOrder=[placement,placementOpposite];break;case BEHAVIORS.CLOCKWISE:flipOrder=clockwise(placement);break;case BEHAVIORS.COUNTERCLOCKWISE:flipOrder=clockwise(placement,!0);break;default:flipOrder=options.behavior}return flipOrder.forEach(function(step,index){if(placement!==step||flipOrder.length===index+1)return data;placement=data.placement.split("-")[0],placementOpposite=getOppositePlacement(placement);var popperOffsets=data.offsets.popper,refOffsets=data.offsets.reference,floor=Math.floor,overlapsRef="left"===placement&&floor(popperOffsets.right)>floor(refOffsets.left)||"right"===placement&&floor(popperOffsets.left)<floor(refOffsets.right)||"top"===placement&&floor(popperOffsets.bottom)>floor(refOffsets.top)||"bottom"===placement&&floor(popperOffsets.top)<floor(refOffsets.bottom),overflowsLeft=floor(popperOffsets.left)<floor(boundaries.left),overflowsRight=floor(popperOffsets.right)>floor(boundaries.right),overflowsTop=floor(popperOffsets.top)<floor(boundaries.top),overflowsBottom=floor(popperOffsets.bottom)>floor(boundaries.bottom),overflowsBoundaries="left"===placement&&overflowsLeft||"right"===placement&&overflowsRight||"top"===placement&&overflowsTop||"bottom"===placement&&overflowsBottom,isVertical=-1!==["top","bottom"].indexOf(placement),flippedVariation=!!options.flipVariations&&(isVertical&&"start"===variation&&overflowsLeft||isVertical&&"end"===variation&&overflowsRight||!isVertical&&"start"===variation&&overflowsTop||!isVertical&&"end"===variation&&overflowsBottom);(overlapsRef||overflowsBoundaries||flippedVariation)&&(data.flipped=!0,(overlapsRef||overflowsBoundaries)&&(placement=flipOrder[index+1]),flippedVariation&&(variation=getOppositeVariation(variation)),data.placement=placement+(variation?"-"+variation:""),data.offsets.popper=_extends({},data.offsets.popper,getPopperOffsets(data.instance.popper,data.offsets.reference,data.placement)),data=runModifiers(data.instance.modifiers,data,"flip"))}),data}function keepTogether(data){var _data$offsets=data.offsets,popper=_data$offsets.popper,reference=_data$offsets.reference,placement=data.placement.split("-")[0],floor=Math.floor,isVertical=-1!==["top","bottom"].indexOf(placement),side=isVertical?"right":"bottom",opSide=isVertical?"left":"top",measurement=isVertical?"width":"height";return popper[side]<floor(reference[opSide])&&(data.offsets.popper[opSide]=floor(reference[opSide])-popper[measurement]),popper[opSide]>floor(reference[side])&&(data.offsets.popper[opSide]=floor(reference[side])),data}function toValue(str,measurement,popperOffsets,referenceOffsets){var split=str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),value=+split[1],unit=split[2];if(!value)return str;if(0===unit.indexOf("%")){var element=void 0;switch(unit){case"%p":element=popperOffsets;break;case"%":case"%r":default:element=referenceOffsets}return getClientRect(element)[measurement]/100*value}if("vh"===unit||"vw"===unit){return("vh"===unit?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0))/100*value}return value}function parseOffset(offset,popperOffsets,referenceOffsets,basePlacement){var offsets=[0,0],useHeight=-1!==["right","left"].indexOf(basePlacement),fragments=offset.split(/(\+|\-)/).map(function(frag){return frag.trim()}),divider=fragments.indexOf(find(fragments,function(frag){return-1!==frag.search(/,|\s/)}));fragments[divider]&&-1===fragments[divider].indexOf(",")&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var splitRegex=/\s*,\s*|\s+/,ops=-1!==divider?[fragments.slice(0,divider).concat([fragments[divider].split(splitRegex)[0]]),[fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider+1))]:[fragments];return ops=ops.map(function(op,index){var measurement=(1===index?!useHeight:useHeight)?"height":"width",mergeWithPrevious=!1;return op.reduce(function(a,b){return""===a[a.length-1]&&-1!==["+","-"].indexOf(b)?(a[a.length-1]=b,mergeWithPrevious=!0,a):mergeWithPrevious?(a[a.length-1]+=b,mergeWithPrevious=!1,a):a.concat(b)},[]).map(function(str){return toValue(str,measurement,popperOffsets,referenceOffsets)})}),ops.forEach(function(op,index){op.forEach(function(frag,index2){isNumeric(frag)&&(offsets[index]+=frag*("-"===op[index2-1]?-1:1))})}),offsets}function offset(data,_ref){var offset=_ref.offset,placement=data.placement,_data$offsets=data.offsets,popper=_data$offsets.popper,reference=_data$offsets.reference,basePlacement=placement.split("-")[0],offsets=void 0;return offsets=isNumeric(+offset)?[+offset,0]:parseOffset(offset,popper,reference,basePlacement),"left"===basePlacement?(popper.top+=offsets[0],popper.left-=offsets[1]):"right"===basePlacement?(popper.top+=offsets[0],popper.left+=offsets[1]):"top"===basePlacement?(popper.left+=offsets[0],popper.top-=offsets[1]):"bottom"===basePlacement&&(popper.left+=offsets[0],popper.top+=offsets[1]),data.popper=popper,data}function preventOverflow(data,options){var boundariesElement=options.boundariesElement||getOffsetParent(data.instance.popper);data.instance.reference===boundariesElement&&(boundariesElement=getOffsetParent(boundariesElement));var transformProp=getSupportedPropertyName("transform"),popperStyles=data.instance.popper.style,top=popperStyles.top,left=popperStyles.left,transform=popperStyles[transformProp];popperStyles.top="",popperStyles.left="",popperStyles[transformProp]="";var boundaries=getBoundaries(data.instance.popper,data.instance.reference,options.padding,boundariesElement,data.positionFixed);popperStyles.top=top,popperStyles.left=left,popperStyles[transformProp]=transform,options.boundaries=boundaries;var order=options.priority,popper=data.offsets.popper,check={primary:function(placement){var value=popper[placement];return popper[placement]<boundaries[placement]&&!options.escapeWithReference&&(value=Math.max(popper[placement],boundaries[placement])),defineProperty({},placement,value)},secondary:function(placement){var mainSide="right"===placement?"left":"top",value=popper[mainSide];return popper[placement]>boundaries[placement]&&!options.escapeWithReference&&(value=Math.min(popper[mainSide],boundaries[placement]-("right"===placement?popper.width:popper.height))),defineProperty({},mainSide,value)}};return order.forEach(function(placement){var side=-1!==["left","top"].indexOf(placement)?"primary":"secondary";popper=_extends({},popper,check[side](placement))}),data.offsets.popper=popper,data}function shift(data){var placement=data.placement,basePlacement=placement.split("-")[0],shiftvariation=placement.split("-")[1];if(shiftvariation){var _data$offsets=data.offsets,reference=_data$offsets.reference,popper=_data$offsets.popper,isVertical=-1!==["bottom","top"].indexOf(basePlacement),side=isVertical?"left":"top",measurement=isVertical?"width":"height",shiftOffsets={start:defineProperty({},side,reference[side]),end:defineProperty({},side,reference[side]+reference[measurement]-popper[measurement])};data.offsets.popper=_extends({},popper,shiftOffsets[shiftvariation])}return data}function hide(data){if(!isModifierRequired(data.instance.modifiers,"hide","preventOverflow"))return data;var refRect=data.offsets.reference,bound=find(data.instance.modifiers,function(modifier){return"preventOverflow"===modifier.name}).boundaries;if(refRect.bottom<bound.top||refRect.left>bound.right||refRect.top>bound.bottom||refRect.right<bound.left){if(!0===data.hide)return data;data.hide=!0,data.attributes["x-out-of-boundaries"]=""}else{if(!1===data.hide)return data;data.hide=!1,data.attributes["x-out-of-boundaries"]=!1}return data}function inner(data){var placement=data.placement,basePlacement=placement.split("-")[0],_data$offsets=data.offsets,popper=_data$offsets.popper,reference=_data$offsets.reference,isHoriz=-1!==["left","right"].indexOf(basePlacement),subtractLength=-1===["top","left"].indexOf(basePlacement);return popper[isHoriz?"left":"top"]=reference[basePlacement]-(subtractLength?popper[isHoriz?"width":"height"]:0),data.placement=getOppositePlacement(placement),data.offsets.popper=getClientRect(popper),data}for(var isBrowser="undefined"!=typeof window&&"undefined"!=typeof document,longerTimeoutBrowsers=["Edge","Trident","Firefox"],timeoutDuration=0,i=0;i<longerTimeoutBrowsers.length;i+=1)if(isBrowser&&navigator.userAgent.indexOf(longerTimeoutBrowsers[i])>=0){timeoutDuration=1;break}var supportsMicroTasks=isBrowser&&window.Promise,debounce=supportsMicroTasks?microtaskDebounce:taskDebounce,isIE11=isBrowser&&!(!window.MSInputMethodContext||!document.documentMode),isIE10=isBrowser&&/MSIE 10/.test(navigator.userAgent),classCallCheck=function(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")},createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),defineProperty=function(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj},_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key])}return target},placements=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],validPlacements=placements.slice(3),BEHAVIORS={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"},modifiers={shift:{order:100,enabled:!0,fn:shift},offset:{order:200,enabled:!0,fn:offset,offset:0},preventOverflow:{order:300,enabled:!0,fn:preventOverflow,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:keepTogether},arrow:{order:500,enabled:!0,fn:arrow,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:flip,behavior:"flip",padding:5,boundariesElement:"viewport"},inner:{order:700,enabled:!1,fn:inner},hide:{order:800,enabled:!0,fn:hide},computeStyle:{order:850,enabled:!0,fn:computeStyle,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:applyStyle,onLoad:applyStyleOnLoad,gpuAcceleration:void 0}},Defaults={placement:"bottom",positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:modifiers},Popper=function(){function Popper(reference,popper){var _this=this,options=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};classCallCheck(this,Popper),this.scheduleUpdate=function(){return requestAnimationFrame(_this.update)},this.update=debounce(this.update.bind(this)),this.options=_extends({},Popper.Defaults,options),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=reference&&reference.jquery?reference[0]:reference,this.popper=popper&&popper.jquery?popper[0]:popper,this.options.modifiers={},Object.keys(_extends({},Popper.Defaults.modifiers,options.modifiers)).forEach(function(name){_this.options.modifiers[name]=_extends({},Popper.Defaults.modifiers[name]||{},options.modifiers?options.modifiers[name]:{})}),this.modifiers=Object.keys(this.options.modifiers).map(function(name){return _extends({name:name},_this.options.modifiers[name])}).sort(function(a,b){return a.order-b.order}),this.modifiers.forEach(function(modifierOptions){modifierOptions.enabled&&isFunction(modifierOptions.onLoad)&&modifierOptions.onLoad(_this.reference,_this.popper,_this.options,modifierOptions,_this.state)}),this.update();var eventsEnabled=this.options.eventsEnabled;eventsEnabled&&this.enableEventListeners(),this.state.eventsEnabled=eventsEnabled}return createClass(Popper,[{key:"update",value:function(){return update.call(this)}},{key:"destroy",value:function(){return destroy.call(this)}},{key:"enableEventListeners",value:function(){return enableEventListeners.call(this)}},{key:"disableEventListeners",value:function(){return disableEventListeners.call(this)}}]),Popper}();Popper.Utils=("undefined"!=typeof window?window:global).PopperUtils,Popper.placements=placements,Popper.Defaults=Defaults,__webpack_exports__.default=Popper}.call(__webpack_exports__,__webpack_require__(7))},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.Positioner=exports.ToggleBoxNext=exports.reactToAngular1=void 0;var _reactToAngular=__webpack_require__(6);Object.defineProperty(exports,"reactToAngular1",{enumerable:!0,get:function(){return _reactToAngular.reactToAngular1}});var _toggleBoxNext=__webpack_require__(18);Object.defineProperty(exports,"ToggleBoxNext",{enumerable:!0,get:function(){return _toggleBoxNext.ToggleBoxNext}});var _positioner=__webpack_require__(20);Object.defineProperty(exports,"Positioner",{enumerable:!0,get:function(){return _positioner.Positioner}}),__webpack_require__(26),__webpack_require__(61),exports.default=angular.module("superdesk-ui",["superdesk-ui.helper","superdesk-ui.carousel","superdesk-ui.wizard","superdesk-ui.dropdown","superdesk-ui.positioner","superdesk-ui.modals","superdesk-ui.switch","superdesk-ui.check","superdesk-ui.circularProgress","superdesk-ui.toggleBox","superdesk-ui.toggleBoxNext","superdesk-ui.tags","superdesk-ui.lineInput","superdesk-ui.searchHandler","superdesk-ui.splitter","superdesk-ui.mediaQuery"])},function(module,exports,__webpack_require__){"use strict";var emptyFunction=__webpack_require__(1),invariant=__webpack_require__(24),ReactPropTypesSecret=__webpack_require__(25);module.exports=function(){function shim(props,propName,componentName,location,propFullName,secret){secret!==ReactPropTypesSecret&&invariant(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function getShim(){return shim}shim.isRequired=shim;var ReactPropTypes={array:shim,bool:shim,func:shim,number:shim,object:shim,string:shim,symbol:shim,any:shim,arrayOf:getShim,element:shim,instanceOf:getShim,node:shim,objectOf:getShim,oneOf:getShim,oneOfType:getShim,shape:getShim,exact:getShim};return ReactPropTypes.checkPropTypes=emptyFunction,ReactPropTypes.PropTypes=ReactPropTypes,ReactPropTypes}},function(module,exports,__webpack_require__){"use strict";function invariant(condition,format,a,b,c,d,e,f){if(validateFormat(format),!condition){var error;if(void 0===format)error=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var args=[a,b,c,d,e,f],argIndex=0;error=new Error(format.replace(/%s/g,function(){return args[argIndex++]})),error.name="Invariant Violation"}throw error.framesToPop=1,error}}var validateFormat=function(format){};module.exports=invariant},function(module,exports,__webpack_require__){"use strict";module.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(module,exports,__webpack_require__){"use strict";__webpack_require__(27),__webpack_require__(41),__webpack_require__(43),__webpack_require__(44),__webpack_require__(20),__webpack_require__(45),__webpack_require__(46),__webpack_require__(47),__webpack_require__(18),__webpack_require__(48),__webpack_require__(51),__webpack_require__(53),__webpack_require__(55),__webpack_require__(57),__webpack_require__(59),__webpack_require__(60)},function(module,exports,__webpack_require__){"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),__webpack_require__(28),__webpack_require__(29),__webpack_require__(35),__webpack_require__(36),__webpack_require__(39),__webpack_require__(40),exports.default=angular.module("superdesk-ui.helper",["superdesk-ui.helper.dropdown","superdesk-ui.helper.modal","superdesk-ui.helper.datepicker","superdesk-ui.helper.ngTagsInput"])},function(module,exports,__webpack_require__){"use strict";angular.module("superdesk-ui.helper.dateparser",[]).service("dateParser",["$locale","orderByFilter",function($locale,orderByFilter){function createParser(format){var map=[],regex=format.split("");return angular.forEach(formatCodeToRegex,function(data,code){var index=format.indexOf(code);if(index>-1){format=format.split(""),regex[index]="("+data.regex+")",format[index]="$";for(var i=index+1,n=index+code.length;i<n;i++)regex[i]="",format[i]="$";format=format.join(""),map.push({index:index,apply:data.apply})}}),{regex:new RegExp("^"+regex.join("")+"$"),map:orderByFilter(map,"index")}}function isValid(year,month,date){return!(date<1)&&(1===month&&date>28?29===date&&(year%4==0&&year%100!=0||year%400==0):3!==month&&5!==month&&8!==month&&10!==month||date<31)}var SPECIAL_CHARACTERS_REGEXP=/[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;this.parsers={};var formatCodeToRegex={yyyy:{regex:"\\d{4}",apply:function(value){this.year=+value}},yy:{regex:"\\d{2}",apply:function(value){this.year=+value+2e3}},y:{regex:"\\d{1,4}",apply:function(value){this.year=+value}},MMMM:{regex:$locale.DATETIME_FORMATS.MONTH.join("|"),apply:function(value){this.month=$locale.DATETIME_FORMATS.MONTH.indexOf(value)}},MMM:{regex:$locale.DATETIME_FORMATS.SHORTMONTH.join("|"),apply:function(value){this.month=$locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value)}},MM:{regex:"0[1-9]|1[0-2]",apply:function(value){this.month=value-1}},M:{regex:"[1-9]|1[0-2]",apply:function(value){this.month=value-1}},dd:{regex:"[0-2][0-9]{1}|3[0-1]{1}",apply:function(value){this.date=+value}},d:{regex:"[1-2]?[0-9]{1}|3[0-1]{1}",apply:function(value){this.date=+value}},EEEE:{regex:$locale.DATETIME_FORMATS.DAY.join("|")},EEE:{regex:$locale.DATETIME_FORMATS.SHORTDAY.join("|")},HH:{regex:"(?:0|1)[0-9]|2[0-3]",apply:function(value){this.hours=+value}},H:{regex:"1?[0-9]|2[0-3]",apply:function(value){this.hours=+value}},mm:{regex:"[0-5][0-9]",apply:function(value){this.minutes=+value}},m:{regex:"[0-9]|[1-5][0-9]",apply:function(value){this.minutes=+value}},sss:{regex:"[0-9][0-9][0-9]",apply:function(value){this.milliseconds=+value}},ss:{regex:"[0-5][0-9]",apply:function(value){this.seconds=+value}},s:{regex:"[0-9]|[1-5][0-9]",apply:function(value){this.seconds=+value}}};this.parse=function(input,format,baseDate){if(!angular.isString(input)||!format)return input;format=$locale.DATETIME_FORMATS[format]||format,format=format.replace(SPECIAL_CHARACTERS_REGEXP,"\\$&"),this.parsers[format]||(this.parsers[format]=createParser(format));var parser=this.parsers[format],regex=parser.regex,map=parser.map,results=input.match(regex);if(results&&results.length){var fields,dt;fields=baseDate?{year:baseDate.getFullYear(),month:baseDate.getMonth(),date:baseDate.getDate(),hours:baseDate.getHours(),minutes:baseDate.getMinutes(),seconds:baseDate.getSeconds(),milliseconds:baseDate.getMilliseconds()}:{year:1900,month:0,date:1,hours:0,minutes:0,seconds:0,milliseconds:0};for(var i=1,n=results.length;i<n;i++){var mapper=map[i-1];mapper.apply&&mapper.apply.call(fields,results[i])}return isValid(fields.year,fields.month,fields.date)&&(dt=new Date(fields.year,fields.month,fields.date,fields.hours,fields.minutes,fields.seconds,fields.milliseconds||0)),dt}}}])},function(module,exports,__webpack_require__){"use strict";angular.module("superdesk-ui.helper.datepicker",["superdesk-ui.helper.dateparser","superdesk-ui.helper.position"]).constant("datepickerConfig",{formatDay:"dd",formatMonth:"MMMM",formatYear:"yyyy",formatDayHeader:"EEE",formatDayTitle:"MMMM yyyy",formatMonthTitle:"yyyy",datepickerMode:"day",minMode:"day",maxMode:"year",showWeeks:!0,startingDay:0,yearRange:20,minDate:null,maxDate:null,shortcutPropagation:!1}).controller("DatepickerController",["$scope","$attrs","$parse","$interpolate","$log","dateFilter","datepickerConfig",function($scope,$attrs,$parse,$interpolate,$log,dateFilter,datepickerConfig){var self=this,ngModelCtrl={$setViewValue:angular.noop};this.modes=["day","month","year"],angular.forEach(["formatDay","formatMonth","formatYear","formatDayHeader","formatDayTitle","formatMonthTitle","minMode","maxMode","showWeeks","startingDay","yearRange","shortcutPropagation"],function(key,index){self[key]=angular.isDefined($attrs[key])?index<8?$interpolate($attrs[key])($scope.$parent):$scope.$parent.$eval($attrs[key]):datepickerConfig[key]}),angular.forEach(["minDate","maxDate"],function(key){$attrs[key]?$scope.$parent.$watch($parse($attrs[key]),function(value){self[key]=value?new Date(value):null,self.refreshView()}):self[key]=datepickerConfig[key]?new Date(datepickerConfig[key]):null}),$scope.datepickerMode=$scope.datepickerMode||datepickerConfig.datepickerMode,$scope.maxMode=self.maxMode,$scope.uniqueId="datepicker-"+$scope.$id+"-"+Math.floor(1e4*Math.random()),angular.isDefined($attrs.initDate)?(this.activeDate=$scope.$parent.$eval($attrs.initDate)||new Date,$scope.$parent.$watch($attrs.initDate,function(initDate){initDate&&(ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue)||ngModelCtrl.$invalid)&&(self.activeDate=initDate,self.refreshView())})):this.activeDate=new Date,$scope.isActive=function(dateObject){return 0===self.compare(dateObject.date,self.activeDate)&&($scope.activeDateId=dateObject.uid,!0)},this.init=function(ngModelCtrl_){ngModelCtrl=ngModelCtrl_,ngModelCtrl.$render=function(){self.render()}},this.render=function(){if(ngModelCtrl.$viewValue){var date=new Date(ngModelCtrl.$viewValue),isValid=!isNaN(date);isValid?this.activeDate=date:$log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.'),ngModelCtrl.$setValidity("date",isValid)}this.refreshView()},this.refreshView=function(){if(this.element){this._refreshView();var date=ngModelCtrl.$viewValue?new Date(ngModelCtrl.$viewValue):null;ngModelCtrl.$setValidity("date-disabled",!date||this.element&&!this.isDisabled(date))}},this.createDateObject=function(date,format){var model=ngModelCtrl.$viewValue?new Date(ngModelCtrl.$viewValue):null;return{date:date,label:dateFilter(date,format),selected:model&&0===this.compare(date,model),disabled:this.isDisabled(date),current:0===this.compare(date,new Date),customClass:this.customClass(date)}},this.isDisabled=function(date){return this.minDate&&this.compare(date,this.minDate)<0||this.maxDate&&this.compare(date,this.maxDate)>0||$attrs.dateDisabled&&$scope.dateDisabled({date:date,mode:$scope.datepickerMode})},this.customClass=function(date){return $scope.customClass({date:date,mode:$scope.datepickerMode})},this.split=function(arr,size){for(var arrays=[];arr.length>0;)arrays.push(arr.splice(0,size));return arrays},this.fixTimeZone=function(date){var hours=date.getHours();date.setHours(23===hours?hours+2:0)},$scope.select=function(date){if($scope.datepickerMode===self.minMode){var dt=ngModelCtrl.$viewValue?new Date(ngModelCtrl.$viewValue):new Date(0,0,0,0,0,0,0);dt.setFullYear(date.getFullYear(),date.getMonth(),date.getDate()),ngModelCtrl.$setViewValue(dt),ngModelCtrl.$render()}else self.activeDate=date,$scope.datepickerMode=self.modes[self.modes.indexOf($scope.datepickerMode)-1]},$scope.move=function(direction){var year=self.activeDate.getFullYear()+direction*(self.step.years||0),month=self.activeDate.getMonth()+direction*(self.step.months||0);self.activeDate.setFullYear(year,month,1),self.refreshView()},$scope.toggleMode=function(direction){direction=direction||1,$scope.datepickerMode===self.maxMode&&1===direction||$scope.datepickerMode===self.minMode&&-1===direction||($scope.datepickerMode=self.modes[self.modes.indexOf($scope.datepickerMode)+direction])},$scope.keys={13:"enter",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down"};var focusElement=function(){self.element[0].focus()};$scope.$on("datepicker.focus",focusElement),$scope.keydown=function(evt){var key=$scope.keys[evt.which];if(key&&!evt.shiftKey&&!evt.altKey)if(evt.preventDefault(),self.shortcutPropagation||evt.stopPropagation(),"enter"===key||"space"===key){if(self.isDisabled(self.activeDate))return;$scope.select(self.activeDate),focusElement()}else!evt.ctrlKey||"up"!==key&&"down"!==key?(self.handleKeyDown(key,evt),self.refreshView()):($scope.toggleMode("up"===key?1:-1),focusElement())}}]).directive("datepicker",function(){return{restrict:"EA",replace:!0,template:__webpack_require__(30),scope:{datepickerMode:"=?",dateDisabled:"&",customClass:"&",shortcutPropagation:"&?"},require:["datepicker","?^ngModel"],controller:"DatepickerController",link:function(scope,element,attrs,ctrls){var datepickerCtrl=ctrls[0],ngModelCtrl=ctrls[1];ngModelCtrl&&datepickerCtrl.init(ngModelCtrl)}}}).directive("daypicker",["dateFilter",function(dateFilter){return{restrict:"EA",replace:!0,template:__webpack_require__(31),require:"^datepicker",link:function(scope,element,attrs,ctrl){function getDaysInMonth(year,month){return 1!==month||year%4!=0||year%100==0&&year%400!=0?DAYS_IN_MONTH[month]:29}function getDates(startDate,n){for(var date,dates=new Array(n),current=new Date(startDate),i=0;i<n;)date=new Date(current),ctrl.fixTimeZone(date),dates[i++]=date,current.setDate(current.getDate()+1);return dates}function getISO8601WeekNumber(date){var checkDate=new Date(date);checkDate.setDate(checkDate.getDate()+4-(checkDate.getDay()||7));var time=checkDate.getTime();return checkDate.setMonth(0),checkDate.setDate(1),Math.floor(Math.round((time-checkDate)/864e5)/7)+1}scope.showWeeks=ctrl.showWeeks,ctrl.step={months:1},ctrl.element=element;var DAYS_IN_MONTH=[31,28,31,30,31,30,31,31,30,31,30,31];ctrl._refreshView=function(){var year=ctrl.activeDate.getFullYear(),month=ctrl.activeDate.getMonth(),firstDayOfMonth=new Date(year,month,1),difference=ctrl.startingDay-firstDayOfMonth.getDay(),numDisplayedFromPreviousMonth=difference>0?7-difference:-difference,firstDate=new Date(firstDayOfMonth);numDisplayedFromPreviousMonth>0&&firstDate.setDate(1-numDisplayedFromPreviousMonth);for(var days=getDates(firstDate,42),i=0;i<42;i++)days[i]=angular.extend(ctrl.createDateObject(days[i],ctrl.formatDay),{secondary:days[i].getMonth()!==month,uid:scope.uniqueId+"-"+i});scope.labels=new Array(7);for(var j=0;j<7;j++)scope.labels[j]={abbr:dateFilter(days[j].date,ctrl.formatDayHeader),full:dateFilter(days[j].date,"EEEE")};if(scope.title=dateFilter(ctrl.activeDate,ctrl.formatDayTitle),scope.rows=ctrl.split(days,7),scope.showWeeks){scope.weekNumbers=[];for(var thursdayIndex=(11-ctrl.startingDay)%7,numWeeks=scope.rows.length,curWeek=0;curWeek<numWeeks;curWeek++)scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date))}},ctrl.compare=function(date1,date2){return new Date(date1.getFullYear(),date1.getMonth(),date1.getDate())-new Date(date2.getFullYear(),date2.getMonth(),date2.getDate())},ctrl.handleKeyDown=function(key,evt){var date=ctrl.activeDate.getDate();if("left"===key)date-=1;else if("up"===key)date-=7;else if("right"===key)date+=1;else if("down"===key)date+=7;else if("pageup"===key||"pagedown"===key){var month=ctrl.activeDate.getMonth()+("pageup"===key?-1:1);ctrl.activeDate.setMonth(month,1),date=Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(),ctrl.activeDate.getMonth()),date)}else"home"===key?date=1:"end"===key&&(date=getDaysInMonth(ctrl.activeDate.getFullYear(),ctrl.activeDate.getMonth()));ctrl.activeDate.setDate(date)},ctrl.refreshView()}}}]).directive("monthpicker",["dateFilter",function(dateFilter){return{restrict:"EA",replace:!0,template:__webpack_require__(32),require:"^datepicker",link:function(scope,element,attrs,ctrl){ctrl.step={years:1},ctrl.element=element,ctrl._refreshView=function(){for(var date,months=new Array(12),year=ctrl.activeDate.getFullYear(),i=0;i<12;i++)date=new Date(year,i,1),ctrl.fixTimeZone(date),months[i]=angular.extend(ctrl.createDateObject(date,ctrl.formatMonth),{uid:scope.uniqueId+"-"+i});scope.title=dateFilter(ctrl.activeDate,ctrl.formatMonthTitle),scope.rows=ctrl.split(months,3)},ctrl.compare=function(date1,date2){return new Date(date1.getFullYear(),date1.getMonth())-new Date(date2.getFullYear(),date2.getMonth())},ctrl.handleKeyDown=function(key,evt){var date=ctrl.activeDate.getMonth();if("left"===key)date-=1;else if("up"===key)date-=3;else if("right"===key)date+=1;else if("down"===key)date+=3;else if("pageup"===key||"pagedown"===key){var year=ctrl.activeDate.getFullYear()+("pageup"===key?-1:1);ctrl.activeDate.setFullYear(year)}else"home"===key?date=0:"end"===key&&(date=11);ctrl.activeDate.setMonth(date)},ctrl.refreshView()}}}]).directive("yearpicker",["dateFilter",function(dateFilter){return{restrict:"EA",replace:!0,template:__webpack_require__(33),require:"^datepicker",link:function(scope,element,attrs,ctrl){function getStartingYear(year){return parseInt((year-1)/range,10)*range+1}var range=ctrl.yearRange;ctrl.step={years:range},ctrl.element=element,ctrl._refreshView=function(){for(var date,years=new Array(range),i=0,start=getStartingYear(ctrl.activeDate.getFullYear());i<range;i++)date=new Date(start+i,0,1),ctrl.fixTimeZone(date),years[i]=angular.extend(ctrl.createDateObject(date,ctrl.formatYear),{uid:scope.uniqueId+"-"+i});scope.title=[years[0].label,years[range-1].label].join(" - "),scope.rows=ctrl.split(years,5)},ctrl.compare=function(date1,date2){return date1.getFullYear()-date2.getFullYear()},ctrl.handleKeyDown=function(key,evt){var date=ctrl.activeDate.getFullYear();"left"===key?date-=1:"up"===key?date-=5:"right"===key?date+=1:"down"===key?date+=5:"pageup"===key||"pagedown"===key?date+=("pageup"===key?-1:1)*ctrl.step.years:"home"===key?date=getStartingYear(ctrl.activeDate.getFullYear()):"end"===key&&(date=getStartingYear(ctrl.activeDate.getFullYear())+range-1),ctrl.activeDate.setFullYear(date)},ctrl.refreshView()}}}]).constant("datepickerPopupConfig",{datepickerPopup:"yyyy-MM-dd",html5Types:{date:"yyyy-MM-dd","datetime-local":"yyyy-MM-ddTHH:mm:ss.sss",month:"yyyy-MM"},currentText:"Today",clearText:"Clear",closeText:"Done",closeOnDateSelection:!0,appendToBody:!1,showButtonBar:!0}).directive("datepickerPopup",["$compile","$parse","$document","$position","dateFilter","dateParser","datepickerPopupConfig","$timeout",function($compile,$parse,$document,$position,dateFilter,dateParser,datepickerPopupConfig,$timeout){return{restrict:"EA",require:"ngModel",scope:{isOpen:"=?",currentText:"@",clearText:"@",closeText:"@",dateDisabled:"&",customClass:"&"},link:function(scope,element,attrs,ngModel){function cameltoDash(string){return string.replace(/([A-Z])/g,function($1){return"-"+$1.toLowerCase()})}function parseDate(viewValue){if(angular.isNumber(viewValue)&&(viewValue=new Date(viewValue)),!viewValue)return null;if(angular.isDate(viewValue)&&!isNaN(viewValue))return viewValue;if(angular.isString(viewValue)){var date=dateParser.parse(viewValue,dateFormat,scope.date)||new Date(viewValue);if(isNaN(date))return;return date}}function validator(modelValue,viewValue){var value=modelValue||viewValue;if(angular.isNumber(value)&&(value=new Date(value)),!value)return!0;if(angular.isDate(value)&&!isNaN(value))return!0;if(angular.isString(value)){var date=dateParser.parse(value,dateFormat)||new Date(value);return!isNaN(date)}return!1}var dateFormat,closeOnDateSelection=angular.isDefined(attrs.closeOnDateSelection)?scope.$parent.$eval(attrs.closeOnDateSelection):datepickerPopupConfig.closeOnDateSelection,appendToBody=angular.isDefined(attrs.datepickerAppendToBody)?scope.$parent.$eval(attrs.datepickerAppendToBody):datepickerPopupConfig.appendToBody;scope.showButtonBar=angular.isDefined(attrs.showButtonBar)?scope.$parent.$eval(attrs.showButtonBar):datepickerPopupConfig.showButtonBar,scope.getText=function(key){return scope[key+"Text"]||datepickerPopupConfig[key+"Text"]};var isHtml5DateInput=!1;if(datepickerPopupConfig.html5Types[attrs.type]?(dateFormat=datepickerPopupConfig.html5Types[attrs.type],isHtml5DateInput=!0):(dateFormat=attrs.datepickerPopup||datepickerPopupConfig.datepickerPopup,attrs.$observe("datepickerPopup",function(value,oldValue){var newDateFormat=value||datepickerPopupConfig.datepickerPopup;if(newDateFormat!==dateFormat&&(dateFormat=newDateFormat,ngModel.$modelValue=null,!dateFormat))throw new Error("datepickerPopup must have a date format specified.")})),!dateFormat)throw new Error("datepickerPopup must have a date format specified.");if(isHtml5DateInput&&attrs.datepickerPopup)throw new Error("HTML5 date input types do not support custom formats.");var popupEl=angular.element("<div datepicker-popup-wrap><div datepicker></div></div>");popupEl.attr({"ng-model":"date","ng-change":"dateSelection(date)"});var datepickerEl=angular.element(popupEl.children()[0]);if(isHtml5DateInput&&"month"==attrs.type&&(datepickerEl.attr("datepicker-mode",'"month"'),datepickerEl.attr("min-mode","month")),attrs.datepickerOptions){var options=scope.$parent.$eval(attrs.datepickerOptions);options.initDate&&(scope.initDate=options.initDate,datepickerEl.attr("init-date","initDate"),delete options.initDate),angular.forEach(options,function(value,option){datepickerEl.attr(cameltoDash(option),value)})}scope.watchData={},angular.forEach(["minDate","maxDate","datepickerMode","initDate","shortcutPropagation"],function(key){if(attrs[key]){var getAttribute=$parse(attrs[key]);if(scope.$parent.$watch(getAttribute,function(value){scope.watchData[key]=value}),datepickerEl.attr(cameltoDash(key),"watchData."+key),"datepickerMode"===key){var setAttribute=getAttribute.assign;scope.$watch("watchData."+key,function(value,oldvalue){angular.isFunction(setAttribute)&&value!==oldvalue&&setAttribute(scope.$parent,value)})}}}),attrs.dateDisabled&&datepickerEl.attr("date-disabled","dateDisabled({ date: date, mode: mode })"),attrs.showWeeks&&datepickerEl.attr("show-weeks",attrs.showWeeks),attrs.customClass&&datepickerEl.attr("custom-class","customClass({ date: date, mode: mode })"),isHtml5DateInput?ngModel.$formatters.push(function(value){return scope.date=value,value}):(ngModel.$$parserName="date",ngModel.$validators.date=validator,ngModel.$parsers.unshift(parseDate),ngModel.$formatters.push(function(value){return scope.date=value,ngModel.$isEmpty(value)?value:dateFilter(value,dateFormat)})),scope.dateSelection=function(dt){angular.isDefined(dt)&&(scope.date=dt);var date=scope.date?dateFilter(scope.date,dateFormat):"";element.val(date),ngModel.$setViewValue(date),closeOnDateSelection&&(scope.isOpen=!1,element[0].focus())},ngModel.$viewChangeListeners.push(function(){scope.date=dateParser.parse(ngModel.$viewValue,dateFormat,scope.date)||new Date(ngModel.$viewValue)});var documentClickBind=function(event){scope.isOpen&&event.target!==element[0]&&scope.$apply(function(){scope.isOpen=!1})},inputKeydownBind=function(evt){27===evt.which&&scope.isOpen?(evt.preventDefault(),evt.stopPropagation(),scope.$apply(function(){scope.isOpen=!1}),element[0].focus()):40!==evt.which||scope.isOpen||(evt.preventDefault(),evt.stopPropagation(),scope.$apply(function(){scope.isOpen=!0}))};element.bind("keydown",inputKeydownBind),scope.keydown=function(evt){27===evt.which&&(scope.isOpen=!1,element[0].focus())},scope.$watch("isOpen",function(value){value?(scope.position=appendToBody?$position.offset(element):$position.position(element),scope.position.top=scope.position.top+element.prop("offsetHeight"),$document.bind("click",documentClickBind),$timeout(function(){scope.$broadcast("datepicker.focus")},0,!1)):$document.unbind("click",documentClickBind)}),scope.select=function(date){if("today"===date){var today=new Date;angular.isDate(scope.date)?(date=new Date(scope.date),date.setFullYear(today.getFullYear(),today.getMonth(),today.getDate())):date=new Date(today.setHours(0,0,0,0))}scope.dateSelection(date)},scope.close=function(){scope.isOpen=!1,element[0].focus()};var $popup=$compile(popupEl)(scope);popupEl.remove(),appendToBody?$document.find("body").append($popup):element.after($popup),scope.$on("$destroy",function(){!0===scope.isOpen&&scope.$apply(function(){scope.isOpen=!1}),$popup.remove(),element.unbind("keydown",inputKeydownBind),$document.unbind("click",documentClickBind)})}}}]).directive("datepickerPopupWrap",function(){return{restrict:"EA",replace:!0,transclude:!0,template:__webpack_require__(34)}})},function(module,exports){module.exports='<div ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <daypicker ng-switch-when="day" tabindex="0"></daypicker>\n  <monthpicker ng-switch-when="month" tabindex="0"></monthpicker>\n  <yearpicker ng-switch-when="year" tabindex="0"></yearpicker>\n</div>'},function(module,exports){module.exports='<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon-chevron-left-thin"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon-chevron-right-thin"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n'},function(module,exports){module.exports='<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon-chevron-left-thin"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon-chevron-right-thin"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n'},function(module,exports){module.exports='<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><i class="icon-chevron-left-thin"></i></button></th>\n      <th colspan="3"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><i class="icon-chevron-right-thin"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}">\n        <button type="button" style="min-width:100%;" class="btn btn-default" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n'},function(module,exports){module.exports='<ul class="dropdown-menu" ng-if="isOpen" style="display: block" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n\t<li ng-transclude></li>\n\t<li ng-if="showButtonBar" style="padding:10px 9px 2px">\n\t\t<span class="btn-group pull-left">\n\t\t\t<button type="button" class="btn btn-sm btn-info" ng-click="select(\'today\')">{{ getText(\'current\') }}</button>\n\t\t\t<button type="button" class="btn btn-sm btn-danger" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n\t\t</span>\n\t\t<button type="button" class="btn btn-sm btn-success pull-right" ng-click="close()">{{ getText(\'close\') }}</button>\n\t</li>\n</ul>\n'},function(module,exports,__webpack_require__){"use strict";angular.module("superdesk-ui.helper.dropdown",["superdesk-ui.helper.position"]).constant("dropdownConfig",{openClass:"open"}).service("dropdownService",["$document","$rootScope",function($document,$rootScope){var openScope=null;this.open=function(dropdownScope){openScope||($document.bind("click",closeDropdown),$document.bind("keydown",keybindFilter)),openScope&&openScope!==dropdownScope&&(openScope.isOpen=!1),openScope=dropdownScope},this.close=function(dropdownScope){openScope===dropdownScope&&(openScope=null,$document.unbind("click",closeDropdown),$document.unbind("keydown",keybindFilter))};var closeDropdown=function(evt){if(openScope&&(!evt||"disabled"!==openScope.getAutoClose())){var toggleElement=openScope.getToggleElement();if(!(evt&&toggleElement&&toggleElement[0].contains(evt.target))){var dropdownElement=openScope.getDropdownElement();evt&&"outsideClick"===openScope.getAutoClose()&&dropdownElement&&dropdownElement[0].contains(evt.target)||(openScope.isOpen=!1,$rootScope.$$phase||openScope.$apply())}}},keybindFilter=function(evt){27===evt.which?(openScope.focusToggleElement(),closeDropdown()):openScope.isKeynavEnabled()&&/(38|40)/.test(evt.which)&&openScope.isOpen&&(evt.preventDefault(),evt.stopPropagation(),openScope.focusDropdownEntry(evt.which))}}]).controller("DropdownController",["$scope","$attrs","$parse","dropdownConfig","dropdownService","$animate","$position","$document","$compile","$templateRequest",function($scope,$attrs,$parse,dropdownConfig,dropdownService,$animate,$position,$document,$compile,$templateRequest){var templateScope,getIsOpen,self=this,scope=$scope.$new(),openClass=dropdownConfig.openClass,setIsOpen=angular.noop,toggleInvoker=$attrs.onToggle?$parse($attrs.onToggle):angular.noop,appendToBody=!1,keynavEnabled=!1;this.init=function(element){self.$element=element,$attrs.isOpen&&(getIsOpen=$parse($attrs.isOpen),setIsOpen=getIsOpen.assign,$scope.$watch(getIsOpen,function(value){scope.isOpen=!!value})),appendToBody=angular.isDefined($attrs.dropdownAppendToBody),keynavEnabled=angular.isDefined($attrs.keyboardNav),appendToBody&&self.dropdownMenu&&($document.find("body").append(self.dropdownMenu),element.on("$destroy",function(){self.dropdownMenu.remove()}))},this.toggle=function(open){return scope.isOpen=arguments.length?!!open:!scope.isOpen},this.isOpen=function(){return scope.isOpen},scope.getToggleElement=function(){return self.toggleElement},scope.getAutoClose=function(){return $attrs.autoClose||"always"},scope.getElement=function(){return self.$element},scope.isKeynavEnabled=function(){return keynavEnabled},scope.focusDropdownEntry=function(keyCode){var elems=self.dropdownMenu?angular.element(self.dropdownMenu).find("a"):angular.element(self.$element).find("ul").eq(0).find("a");switch(keyCode){case 40:angular.isNumber(self.selectedOption)?self.selectedOption=self.selectedOption===elems.length-1?self.selectedOption:self.selectedOption+1:self.selectedOption=0;break;case 38:if(!angular.isNumber(self.selectedOption))return;self.selectedOption=0===self.selectedOption?0:self.selectedOption-1}elems[self.selectedOption].focus()},scope.getDropdownElement=function(){return self.dropdownMenu},scope.focusToggleElement=function(){self.toggleElement&&self.toggleElement[0].focus()},scope.$watch("isOpen",function(isOpen,wasOpen){if(appendToBody&&self.dropdownMenu){var pos=$position.positionElements(self.$element,self.dropdownMenu,"bottom-left",!0),css={top:pos.top+"px",display:isOpen?"block":"none"};self.dropdownMenu.hasClass("dropdown-menu-right")?(css.left="auto",css.right=window.innerWidth-(pos.left+self.$element.prop("offsetWidth"))+"px"):(css.left=pos.left+"px",css.right="auto"),self.dropdownMenu.css(css)}if($animate[isOpen?"addClass":"removeClass"](self.$element,openClass).then(function(){angular.isDefined(isOpen)&&isOpen!==wasOpen&&toggleInvoker($scope,{open:!!isOpen})}),isOpen)self.dropdownMenuTemplateUrl&&$templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent){templateScope=scope.$new(),$compile(tplContent.trim())(templateScope,function(dropdownElement){var newEl=dropdownElement;self.dropdownMenu.replaceWith(newEl),self.dropdownMenu=newEl})}),scope.focusToggleElement(),dropdownService.open(scope);else{if(self.dropdownMenuTemplateUrl){templateScope&&templateScope.$destroy();var newEl=angular.element('<ul class="dropdown-menu"></ul>');self.dropdownMenu.replaceWith(newEl),self.dropdownMenu=newEl}dropdownService.close(scope),self.selectedOption=null}setIsOpen($scope,isOpen)}),$scope.$on("$locationChangeSuccess",function(){"disabled"!==scope.getAutoClose()&&(scope.isOpen=!1)}),$scope.$on("$destroy",function(){scope.$destroy()})}]).directive("dropdown",function(){return{controller:"DropdownController",link:function(scope,element,attrs,dropdownCtrl){dropdownCtrl.init(element),element.addClass("dropdown")}}}).directive("dropdownMenu",function(){return{restrict:"AC",require:"?^dropdown",link:function(scope,element,attrs,dropdownCtrl){if(dropdownCtrl){var tplUrl=attrs.templateUrl;tplUrl&&(dropdownCtrl.dropdownMenuTemplateUrl=tplUrl),dropdownCtrl.dropdownMenu||(dropdownCtrl.dropdownMenu=element)}}}}).directive("keyboardNav",function(){return{restrict:"A",require:"?^dropdown",link:function(scope,element,attrs,dropdownCtrl){element.bind("keydown",function(e){if(-1!==[38,40].indexOf(e.which)){e.preventDefault(),e.stopPropagation();var elems=angular.element(element).find("a");switch(e.keyCode){case 40:angular.isNumber(dropdownCtrl.selectedOption)?dropdownCtrl.selectedOption=dropdownCtrl.selectedOption===elems.length-1?dropdownCtrl.selectedOption:dropdownCtrl.selectedOption+1:dropdownCtrl.selectedOption=0;break;case 38:dropdownCtrl.selectedOption=0===dropdownCtrl.selectedOption?0:dropdownCtrl.selectedOption-1}elems[dropdownCtrl.selectedOption].focus()}})}}}).directive("dropdownToggle",function(){return{require:"?^dropdown",link:function(scope,element,attrs,dropdownCtrl){if(dropdownCtrl){element.addClass("dropdown-toggle"),dropdownCtrl.toggleElement=element;var toggleDropdown=function(event){event.preventDefault(),element.hasClass("disabled")||attrs.disabled||scope.$apply(function(){dropdownCtrl.toggle()})};element.bind("click",toggleDropdown),element.attr({"aria-haspopup":!0,"aria-expanded":!1}),scope.$watch(dropdownCtrl.isOpen,function(isOpen){element.attr("aria-expanded",!!isOpen)}),scope.$on("$destroy",function(){element.unbind("click",toggleDropdown)})}}}})},function(module,exports,__webpack_require__){"use strict";angular.module("superdesk-ui.helper.modal",[]).factory("$$stackedMap",function(){return{createNew:function(){var stack=[];return{add:function(key,value){stack.push({key:key,value:value})},get:function(key){for(var i=0;i<stack.length;i++)if(key==stack[i].key)return stack[i]},keys:function(){for(var keys=[],i=0;i<stack.length;i++)keys.push(stack[i].key);return keys},top:function(){return stack[stack.length-1]},remove:function(key){for(var idx=-1,i=0;i<stack.length;i++)if(key==stack[i].key){idx=i;break}return stack.splice(idx,1)[0]},removeTop:function(){return stack.splice(stack.length-1,1)[0]},length:function(){return stack.length}}}}}).directive("modalBackdrop",["$animate","$modalStack",function($animate,$modalStack){function linkFn(scope,element,attrs){attrs.modalInClass&&($animate.addClass(element,attrs.modalInClass),scope.$on($modalStack.NOW_CLOSING_EVENT,function(e,setIsAsync){var done=setIsAsync();$animate.removeClass(element,attrs.modalInClass).then(done)}))}return{restrict:"EA",replace:!0,template:__webpack_require__(37),compile:function(tElement,tAttrs){return tElement.addClass(tAttrs.backdropClass),linkFn}}}]).directive("modalWindow",["$modalStack","$q","$animate",function($modalStack,$q,$animate){return{restrict:"EA",scope:{index:"@"},replace:!0,transclude:!0,template:__webpack_require__(38),link:function(scope,element,attrs){element.addClass(attrs.windowClass||""),scope.size=attrs.size,scope.close=function(evt){var modal=$modalStack.getTop();modal&&modal.value.backdrop&&"static"!=modal.value.backdrop&&evt.target===evt.currentTarget&&(evt.preventDefault(),evt.stopPropagation(),$modalStack.dismiss(modal.key,"backdrop click"))},scope.$isRendered=!0;var modalRenderDeferObj=$q.defer();attrs.$observe("modalRender",function(value){"true"==value&&modalRenderDeferObj.resolve()}),modalRenderDeferObj.promise.then(function(){attrs.modalInClass&&($animate.addClass(element,attrs.modalInClass),scope.$on($modalStack.NOW_CLOSING_EVENT,function(e,setIsAsync){var done=setIsAsync();$animate.removeClass(element,attrs.modalInClass).then(done)}));var inputsWithAutofocus=element[0].querySelectorAll("[autofocus]");inputsWithAutofocus.length?inputsWithAutofocus[0].focus():element[0].focus();var modal=$modalStack.getTop();modal&&$modalStack.modalRendered(modal.key)})}}}]).directive("modalAnimationClass",[function(){return{compile:function(tElement,tAttrs){tAttrs.modalAnimation&&tElement.addClass(tAttrs.modalAnimationClass)}}}]).directive("modalTransclude",function(){return{link:function($scope,$element,$attrs,controller,$transclude){$transclude($scope.$parent,function(clone){$element.empty(),$element.append(clone)})}}}).factory("$modalStack",["$animate","$timeout","$document","$compile","$rootScope","$q","$$stackedMap",function($animate,$timeout,$document,$compile,$rootScope,$q,$$stackedMap){function backdropIndex(){for(var topBackdropIndex=-1,opened=openedWindows.keys(),i=0;i<opened.length;i++)openedWindows.get(opened[i]).value.backdrop&&(topBackdropIndex=i);return topBackdropIndex}function removeModalWindow(modalInstance,elementToReceiveFocus){var body=$document.find("body").eq(0),modalWindow=openedWindows.get(modalInstance).value;openedWindows.remove(modalInstance),removeAfterAnimate(modalWindow.modalDomEl,modalWindow.modalScope,function(){body.toggleClass(OPENED_MODAL_CLASS,openedWindows.length()>0),checkRemoveBackdrop()}),elementToReceiveFocus&&elementToReceiveFocus.focus?elementToReceiveFocus.focus():body.focus()}function checkRemoveBackdrop(){if(backdropDomEl&&-1==backdropIndex()){var backdropScopeRef=backdropScope;removeAfterAnimate(backdropDomEl,backdropScope,function(){backdropScopeRef=null}),backdropDomEl=void 0,backdropScope=void 0}}function removeAfterAnimate(domEl,scope,done){function afterAnimating(){afterAnimating.done||(afterAnimating.done=!0,domEl.remove(),scope.$destroy(),done&&done())}var asyncDeferred,asyncPromise=null,setIsAsync=function(){return asyncDeferred||(asyncDeferred=$q.defer(),asyncPromise=asyncDeferred.promise),function(){asyncDeferred.resolve()}};return scope.$broadcast($modalStack.NOW_CLOSING_EVENT,setIsAsync),$q.when(asyncPromise).then(afterAnimating)}function broadcastClosing(modalWindow,resultOrReason,closing){return!modalWindow.value.modalScope.$broadcast("modal.closing",resultOrReason,closing).defaultPrevented}var backdropDomEl,backdropScope,OPENED_MODAL_CLASS="modal-open",openedWindows=$$stackedMap.createNew(),$modalStack={NOW_CLOSING_EVENT:"modal.stack.now-closing"};return $rootScope.$watch(backdropIndex,function(newBackdropIndex){backdropScope&&(backdropScope.index=newBackdropIndex)}),$document.bind("keydown",function(evt){var modal;27===evt.which&&(modal=openedWindows.top())&&modal.value.keyboard&&(evt.preventDefault(),$rootScope.$apply(function(){$modalStack.dismiss(modal.key,"escape key press")}))}),$modalStack.open=function(modalInstance,modal){var modalOpener=$document[0].activeElement;openedWindows.add(modalInstance,{deferred:modal.deferred,renderDeferred:modal.renderDeferred,modalScope:modal.scope,backdrop:modal.backdrop,keyboard:modal.keyboard});var body=$document.find("body").eq(0),currBackdropIndex=backdropIndex();if(currBackdropIndex>=0&&!backdropDomEl){backdropScope=$rootScope.$new(!0),backdropScope.index=currBackdropIndex;var angularBackgroundDomEl=angular.element('<div modal-backdrop="modal-backdrop"></div>');angularBackgroundDomEl.attr("backdrop-class",modal.backdropClass),modal.animation&&angularBackgroundDomEl.attr("modal-animation","true"),backdropDomEl=$compile(angularBackgroundDomEl)(backdropScope),body.append(backdropDomEl)}var angularDomEl=angular.element('<div modal-window="modal-window"></div>');angularDomEl.attr({"template-url":modal.windowTemplateUrl,"window-class":modal.windowClass,size:modal.size,index:openedWindows.length()-1,animate:"animate"}).html(modal.content),modal.animation&&angularDomEl.attr("modal-animation","true");var modalDomEl=$compile(angularDomEl)(modal.scope);openedWindows.top().value.modalDomEl=modalDomEl,openedWindows.top().value.modalOpener=modalOpener,body.append(modalDomEl),body.addClass(OPENED_MODAL_CLASS)},$modalStack.close=function(modalInstance,result){var modalWindow=openedWindows.get(modalInstance);return modalWindow&&broadcastClosing(modalWindow,result,!0)?(modalWindow.value.deferred.resolve(result),removeModalWindow(modalInstance,modalWindow.value.modalOpener),!0):!modalWindow},$modalStack.dismiss=function(modalInstance,reason){var modalWindow=openedWindows.get(modalInstance);return modalWindow&&broadcastClosing(modalWindow,reason,!1)?(modalWindow.value.deferred.reject(reason),removeModalWindow(modalInstance,modalWindow.value.modalOpener),!0):!modalWindow},$modalStack.dismissAll=function(reason){for(var topModal=this.getTop();topModal&&this.dismiss(topModal.key,reason);)topModal=this.getTop()},$modalStack.getTop=function(){return openedWindows.top()},$modalStack.modalRendered=function(modalInstance){var modalWindow=openedWindows.get(modalInstance);modalWindow&&modalWindow.value.renderDeferred.resolve()},$modalStack}]).provider("$modal",function(){var $modalProvider={options:{animation:!0,backdrop:!0,keyboard:!0},$get:["$injector","$rootScope","$q","$templateRequest","$controller","$modalStack",function($injector,$rootScope,$q,$templateRequest,$controller,$modalStack){function getTemplatePromise(options){return options.template?$q.when(options.template):$templateRequest(angular.isFunction(options.templateUrl)?options.templateUrl():options.templateUrl)}function getResolvePromises(resolves){var promisesArr=[];return angular.forEach(resolves,function(value){(angular.isFunction(value)||angular.isArray(value))&&promisesArr.push($q.when($injector.invoke(value)))}),promisesArr}var $modal={};return $modal.open=function(modalOptions){var modalResultDeferred=$q.defer(),modalOpenedDeferred=$q.defer(),modalRenderDeferred=$q.defer(),modalInstance={result:modalResultDeferred.promise,opened:modalOpenedDeferred.promise,rendered:modalRenderDeferred.promise,close:function(result){return $modalStack.close(modalInstance,result)},dismiss:function(reason){return $modalStack.dismiss(modalInstance,reason)}};if(modalOptions=angular.extend({},$modalProvider.options,modalOptions),modalOptions.resolve=modalOptions.resolve||{},!modalOptions.template&&!modalOptions.templateUrl)throw new Error("One of template or templateUrl options is required.");var templateAndResolvePromise=$q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));return templateAndResolvePromise.then(function(tplAndVars){var modalScope=(modalOptions.scope||$rootScope).$new();modalScope.$close=modalInstance.close,modalScope.$dismiss=modalInstance.dismiss;var ctrlInstance,ctrlLocals={},resolveIter=1;modalOptions.controller&&(ctrlLocals.$scope=modalScope,ctrlLocals.$modalInstance=modalInstance,angular.forEach(modalOptions.resolve,function(value,key){ctrlLocals[key]=tplAndVars[resolveIter++]}),ctrlInstance=$controller(modalOptions.controller,ctrlLocals),modalOptions.controllerAs&&(modalOptions.bindToController?angular.extend(modalScope,ctrlInstance):modalScope[modalOptions.controllerAs]=ctrlInstance)),$modalStack.open(modalInstance,{scope:modalScope,deferred:modalResultDeferred,renderDeferred:modalRenderDeferred,content:tplAndVars[0],animation:modalOptions.animation,backdrop:modalOptions.backdrop,keyboard:modalOptions.keyboard,backdropClass:modalOptions.backdropClass,windowClass:modalOptions.windowClass,windowTemplateUrl:modalOptions.windowTemplateUrl,size:modalOptions.size})},function(reason){modalResultDeferred.reject(reason)}),templateAndResolvePromise.then(function(){modalOpenedDeferred.resolve(!0)},function(reason){modalOpenedDeferred.reject(reason)}),modalInstance},$modal}]};return $modalProvider})},function(module,exports){module.exports='<div class="modal__backdrop fade in"></div>'},function(module,exports){module.exports='<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n     modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1050 + index * 10, display: \'block\'}"\n     ng-class="size ? \'modal--\' + size : \'\'">\n    <div class="modal__dialog">\n        <div class="modal__content" modal-transclude></div>\n    </div>\n</div>\n'},function(module,exports,__webpack_require__){"use strict";angular.module("superdesk-ui.helper.position",[]).factory("$position",["$document","$window",function($document,$window){function getStyle(el,cssprop){return el.currentStyle?el.currentStyle[cssprop]:$window.getComputedStyle?$window.getComputedStyle(el)[cssprop]:el.style[cssprop]}function isStaticPositioned(element){return"static"===(getStyle(element,"position")||"static")}var parentOffsetEl=function(element){for(var docDomEl=$document[0],offsetParent=element.offsetParent||docDomEl;offsetParent&&offsetParent!==docDomEl&&isStaticPositioned(offsetParent);)offsetParent=offsetParent.offsetParent;return offsetParent||docDomEl};return{position:function(element){var elBCR=this.offset(element),offsetParentBCR={top:0,left:0},offsetParentEl=parentOffsetEl(element[0]);offsetParentEl!=$document[0]&&(offsetParentBCR=this.offset(angular.element(offsetParentEl)),offsetParentBCR.top+=offsetParentEl.clientTop-offsetParentEl.scrollTop,offsetParentBCR.left+=offsetParentEl.clientLeft-offsetParentEl.scrollLeft);var boundingClientRect=element[0].getBoundingClientRect();return{width:boundingClientRect.width||element.prop("offsetWidth"),height:boundingClientRect.height||element.prop("offsetHeight"),top:elBCR.top-offsetParentBCR.top,left:elBCR.left-offsetParentBCR.left}},offset:function(element){var boundingClientRect=element[0].getBoundingClientRect();return{width:boundingClientRect.width||element.prop("offsetWidth"),height:boundingClientRect.height||element.prop("offsetHeight"),top:boundingClientRect.top+($window.pageYOffset||$document[0].documentElement.scrollTop),left:boundingClientRect.left+($window.pageXOffset||$document[0].documentElement.scrollLeft)}},positionElements:function(hostEl,targetEl,positionStr,appendToBody){var hostElPos,targetElWidth,targetElHeight,targetElPos,positionStrParts=positionStr.split("-"),pos0=positionStrParts[0],pos1=positionStrParts[1]||"center";hostElPos=appendToBody?this.offset(hostEl):this.position(hostEl),targetElWidth=targetEl.prop("offsetWidth"),targetElHeight=targetEl.prop("offsetHeight");var shiftWidth={center:function(){return hostElPos.left+hostElPos.width/2-targetElWidth/2},left:function(){return hostElPos.left},right:function(){return hostElPos.left+hostElPos.width}},shiftHeight={center:function(){return hostElPos.top+hostElPos.height/2-targetElHeight/2},top:function(){return hostElPos.top},bottom:function(){return hostElPos.top+hostElPos.height}};switch(pos0){case"right":targetElPos={top:shiftHeight[pos1](),left:shiftWidth[pos0]()};break;case"left":targetElPos={top:shiftHeight[pos1](),left:hostElPos.left-targetElWidth};break;case"bottom":targetElPos={top:shiftHeight[pos0](),left:shiftWidth[pos1]()};break;default:targetElPos={top:hostElPos.top-targetElHeight,left:shiftWidth[pos1]()}}return targetElPos}}}])},function(module,exports,__webpack_require__){"use strict";function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}var _popper=__webpack_require__(21),_popper2=function(obj){return obj&&obj.__esModule?obj:{default:obj}}(_popper);!function(){var KEYS={backspace:8,tab:9,enter:13,escape:27,space:32,up:38,down:40,left:37,right:39,delete:46,comma:188},SUPPORTED_INPUT_TYPES=["text","email","url"],tagsInput=angular.module("superdesk-ui.helper.ngTagsInput",[]);tagsInput.directive("tagsInput",["$timeout","$document","$window","$q","tagsInputConfig","tiUtil",function($timeout,$document,$window,$q,tagsInputConfig,tiUtil){function TagList(options,events,onTagAdding,onTagRemoving){var getTagText,setTagText,canAddTag,canRemoveTag,list={},defaultPlaceholder=options.placeholder;return getTagText=function(tag){return tiUtil.safeToString(tag[options.displayProperty])},setTagText=function(tag,text){tag[options.displayProperty]=text},canAddTag=function(tag){var tagText=getTagText(tag),valid=tagText&&tagText.length>=options.minLength&&tagText.length<=options.maxLength&&list.items.length<options.maxItems&&options.allowedTagsPattern.test(tagText)&&!tiUtil.findInObjectArray(list.items,tag,options.keyProperty||options.displayProperty,tiUtil.defaultComparer);return $q.when(valid&&onTagAdding({$tag:tag})).then(tiUtil.promisifyValue)},canRemoveTag=function(tag){return $q.when(onTagRemoving({$tag:tag})).then(tiUtil.promisifyValue)},list.items=[],list.addText=function(text){var tag={};return setTagText(tag,text),list.add(tag)},list.add=function(tag){var tagText=getTagText(tag);return options.replaceSpacesWithDashes&&(tagText=tiUtil.replaceSpacesWithDashes(tagText)),setTagText(tag,tagText),canAddTag(tag).then(function(){list.items.push(tag),options.placeholder="",events.trigger("tag-added",{$tag:tag})}).catch(function(){tagText&&events.trigger("invalid-tag",{$tag:tag})})},list.remove=function(index){var tag=list.items[index];return canRemoveTag(tag).then(function(){return list.items.splice(index,1),list.clearSelection(),events.trigger("tag-removed",{$tag:tag}),list.items.length||(options.placeholder=defaultPlaceholder),tag})},list.select=function(index){var nextIndex=index;index<0?nextIndex=list.items.length-1:index>=list.items.length&&(nextIndex=0),list.index=nextIndex,list.selected=list.items[nextIndex]},list.selectPrior=function(){list.select(--list.index)},list.selectNext=function(){list.select(++list.index)},list.removeSelected=function(){return list.remove(list.index)},list.clearSelection=function(){list.selected=null,list.index=-1},list.getItems=function(){return options.useStrings?list.items.map(getTagText):list.items},list.clearSelection(),list}function validateType(type){return-1!==SUPPORTED_INPUT_TYPES.indexOf(type)}return{restrict:"E",require:"ngModel",scope:{tags:"=ngModel",text:"=?",templateScope:"=?",tagClass:"&",onTagAdding:"&",onTagAdded:"&",onInvalidTag:"&",onTagRemoving:"&",onTagRemoved:"&",onTagClicked:"&"},replace:!1,transclude:!0,templateUrl:"ngTagsInput/tags-input.html",controller:["$scope","$attrs","$element",function($scope,$attrs,$element){$scope.events=tiUtil.simplePubSub(),tagsInputConfig.load("tagsInput",$scope,$attrs,{template:[String,"ngTagsInput/tag-item.html"],type:[String,"text",validateType],placeholder:[String," "],tabindex:[Number,null],removeTagSymbol:[String,"icon-close-small"],replaceSpacesWithDashes:[Boolean,!1],minLength:[Number,3],maxLength:[Number,9007199254740991],maxItems:[Number,9007199254740991],addOnEnter:[Boolean,!0],addOnSpace:[Boolean,!1],addOnComma:[Boolean,!0],addOnBlur:[Boolean,!0],addOnPaste:[Boolean,!1],pasteSplitPattern:[RegExp,/,/],allowedTagsPattern:[RegExp,/.+/],enableEditingLastTag:[Boolean,!1],minTags:[Number,0],maxTags:[Number,9007199254740991],displayProperty:[String,"text"],keyProperty:[String,""],allowLeftoverText:[Boolean,!1],addFromAutocompleteOnly:[Boolean,!1],showButton:[Boolean,!0],boxed:[Boolean,!1],spellcheck:[Boolean,!0],useStrings:[Boolean,!1]}),$scope.tagList=new TagList($scope.options,$scope.events,tiUtil.handleUndefinedResult($scope.onTagAdding,!0),tiUtil.handleUndefinedResult($scope.onTagRemoving,!0)),this.registerAutocomplete=function(){return{addTag:function(tag){return $scope.tagList.add(tag)},getTags:function(){return $scope.tagList.items},getCurrentTagText:function(){return $scope.newTag.text()},getOptions:function(){return $scope.options},getTemplateScope:function(){return $scope.templateScope},on:function(name,handler){return $scope.events.on(name,handler,!0),this}}},this.registerTagItem=function(){return{getOptions:function(){return $scope.options},removeTag:function(index){$scope.disabled||$scope.tagList.remove(index)}}}}],link:function(scope,element,attrs,ngModelCtrl){var setElementValidity,focusInput,hotkeys=[KEYS.enter,KEYS.comma,KEYS.space,KEYS.backspace,KEYS.delete,KEYS.left,KEYS.right],tagList=scope.tagList,events=scope.events,options=scope.options,input=element.find("input"),validationOptions=["minTags","maxTags","allowLeftoverText"];setElementValidity=function(){ngModelCtrl.$setValidity("maxTags",tagList.items.length<=options.maxTags),ngModelCtrl.$setValidity("minTags",tagList.items.length>=options.minTags),ngModelCtrl.$setValidity("leftoverText",!(!scope.hasFocus&&!options.allowLeftoverText)||!scope.newTag.text())},focusInput=function(){$timeout(function(){input[0].focus()})},ngModelCtrl.$isEmpty=function(value){return!value||!value.length},scope.newTag={text:function(value){if(!angular.isDefined(value))return scope.text||"";scope.text=value,events.trigger("input-change",value)},invalid:null},scope.track=function(tag){return tag[options.keyProperty||options.displayProperty]},scope.getTagClass=function(tag,index){var selected=tag===tagList.selected;return[scope.tagClass({$tag:tag,$index:index,$selected:selected}),{selected:selected}]},scope.$watch("tags",function(value){if(value){if(tagList.items=tiUtil.makeObjectArray(value,options.displayProperty),options.useStrings)return;scope.tags=tagList.items}else tagList.items=[]}),scope.$watch("tags.length",function(){setElementValidity(),ngModelCtrl.$validate()}),attrs.$observe("disabled",function(value){scope.disabled=value}),scope.eventHandlers={input:{keydown:function($event){events.trigger("input-keydown",$event)},focus:function(){scope.hasFocus||(scope.hasFocus=!0,events.trigger("input-focus"))},blur:function(){$timeout(function(){var activeElement=$document.prop("activeElement"),lostFocusToBrowserWindow=activeElement===input[0],lostFocusToChildElement=element[0].contains(activeElement);!lostFocusToBrowserWindow&&lostFocusToChildElement||(scope.hasFocus=!1,events.trigger("input-blur"))})},paste:function($event){$event.getTextData=function(){var clipboardData=$event.clipboardData||$event.originalEvent&&$event.originalEvent.clipboardData;return clipboardData?clipboardData.getData("text/plain"):$window.clipboardData.getData("Text")},events.trigger("input-paste",$event)},loadSuggestions:function($event){events.trigger("load-suggestions",$event)}},host:{click:function(){scope.disabled||focusInput()}},tag:{click:function(tag){events.trigger("tag-clicked",{$tag:tag})}}},events.on("tag-added",scope.onTagAdded).on("invalid-tag",scope.onInvalidTag).on("tag-removed",scope.onTagRemoved).on("tag-clicked",scope.onTagClicked).on("tag-added",function(){scope.newTag.text("")}).on("tag-added tag-removed",function(){scope.tags=tagList.getItems(),ngModelCtrl.$setDirty(),focusInput()}).on("invalid-tag",function(){scope.newTag.invalid=!0}).on("option-change",function(e){-1!==validationOptions.indexOf(e.name)&&setElementValidity()}).on("input-change",function(){tagList.clearSelection(),scope.newTag.invalid=null}).on("input-focus",function(){element.triggerHandler("focus"),ngModelCtrl.$setValidity("leftoverText",!0)}).on("input-blur",function(){options.addOnBlur&&!options.addFromAutocompleteOnly&&tagList.addText(scope.newTag.text()),element.triggerHandler("blur"),setElementValidity()}).on("input-keydown",function(event){var shouldAdd,shouldRemove,shouldSelect,shouldEditLastTag,key=event.keyCode,addKeys={};tiUtil.isModifierOn(event)||-1===hotkeys.indexOf(key)||(addKeys[KEYS.enter]=options.addOnEnter,addKeys[KEYS.comma]=options.addOnComma,addKeys[KEYS.space]=options.addOnSpace,shouldAdd=!options.addFromAutocompleteOnly&&addKeys[key],shouldRemove=(key===KEYS.backspace||key===KEYS.delete)&&tagList.selected,shouldEditLastTag=key===KEYS.backspace&&0===scope.newTag.text().length&&options.enableEditingLastTag,shouldSelect=(key===KEYS.backspace||key===KEYS.left||key===KEYS.right)&&0===scope.newTag.text().length&&!options.enableEditingLastTag,shouldAdd?tagList.addText(scope.newTag.text()):shouldEditLastTag?(tagList.selectPrior(),tagList.removeSelected().then(function(tag){tag&&scope.newTag.text(tag[options.displayProperty])})):shouldRemove?tagList.removeSelected():shouldSelect&&(key===KEYS.left||key===KEYS.backspace?tagList.selectPrior():key===KEYS.right&&tagList.selectNext()),(shouldAdd||shouldSelect||shouldRemove||shouldEditLastTag)&&event.preventDefault())}).on("input-paste",function(event){if(options.addOnPaste){var data=event.getTextData(),tags=data.split(options.pasteSplitPattern);tags.length>1&&(tags.forEach(function(tag){tagList.addText(tag)}),event.preventDefault())}})}}}]),tagsInput.directive("tiTagItem",["tiUtil",function(tiUtil){return{restrict:"E",require:"^tagsInput",template:'<ng-include class="tags-input__helper-box" src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(scope,element,attrs,tagsInputCtrl){var tagsInput=tagsInputCtrl.registerTagItem(),options=tagsInput.getOptions();scope.$$template=options.template,scope.$$removeTagSymbol=options.removeTagSymbol,scope.$getDisplayText=function(){return tiUtil.safeToString(scope.data[options.displayProperty])},scope.$removeTag=function(){tagsInput.removeTag(scope.$index)},scope.$watch("$parent.$index",function(value){scope.$index=value})}}}]),tagsInput.directive("autoComplete",["$q","tagsInputConfig","tiUtil","$timeout",function($q,tagsInputConfig,tiUtil,$timeout){function SuggestionList(loadFn,options,events){var lastPromise,getTagId,list={};return getTagId=function(){return options.tagsInput.keyProperty||options.tagsInput.displayProperty},list.reset=function(){lastPromise=null,list.items=[],list.visible=!1,list.index=-1,list.selected=null,list.query=null},list.show=function(){options.selectFirstMatch?list.select(0):list.selected=null,list.visible=!0,events.trigger("update-autocomplete-position",list.visible)},list.load=tiUtil.debounce(function(query,tags){list.query=query;var promise=$q.when(loadFn({$query:query}));lastPromise=promise,promise.then(function(items){if(promise===lastPromise){var _items=tiUtil.makeObjectArray(items.data||items,getTagId());list.items=options.maxResultsToShow>0?_items.slice(0,options.maxResultsToShow):_items,list.items.length>0&&tags.length<options.tagsInput.maxItems?list.show():list.reset()}})},options.debounceDelay),list.selectNext=function(){list.select(++list.index)},list.selectPrior=function(){list.select(--list.index)},list.select=function(index){var nextIndex=index;index<0?nextIndex=list.items.length-1:index>=list.items.length&&(nextIndex=0),list.index=nextIndex,list.selected=list.items[nextIndex],events.trigger("suggestion-selected",nextIndex)},list.reset(),list}function scrollToElement(root,index){var element=root.find("li").eq(index),parent=element.parent(),elementTop=element.prop("offsetTop"),elementHeight=element.prop("offsetHeight"),parentHeight=parent.prop("clientHeight"),parentScrollTop=parent.prop("scrollTop");elementTop<parentScrollTop?parent.prop("scrollTop",elementTop):elementTop+elementHeight>parentHeight+parentScrollTop&&parent.prop("scrollTop",elementTop+elementHeight-parentHeight)}return{restrict:"E",require:"^tagsInput",scope:{source:"&",matchClass:"&"},templateUrl:"ngTagsInput/auto-complete.html",controller:["$scope","$element","$attrs",function($scope,$element,$attrs){$scope.events=tiUtil.simplePubSub(),tagsInputConfig.load("autoComplete",$scope,$attrs,{template:[String,"ngTagsInput/auto-complete-match.html"],debounceDelay:[Number,100],minLength:[Number,3],highlightMatchedText:[Boolean,!0],loadOnDownArrow:[Boolean,!1],loadOnEmpty:[Boolean,!1],loadOnFocus:[Boolean,!1],selectFirstMatch:[Boolean,!0],displayProperty:[String,""]}),$scope.suggestionList=new SuggestionList($scope.source,$scope.options,$scope.events),this.registerAutocompleteMatch=function(){return{getOptions:function(){return $scope.options},getQuery:function(){return $scope.suggestionList.query}}}}],link:function(scope,element,attrs,tagsInputCtrl){var shouldLoadSuggestions,hotkeys=[KEYS.enter,KEYS.tab,KEYS.escape,KEYS.up,KEYS.down],suggestionList=scope.suggestionList,tagsInput=tagsInputCtrl.registerAutocomplete(),options=scope.options,events=scope.events;options.tagsInput=tagsInput.getOptions(),shouldLoadSuggestions=function(value){return value&&value.length>=options.minLength||!value&&options.loadOnEmpty},scope.templateScope=tagsInput.getTemplateScope(),scope.addSuggestionByIndex=function(index){suggestionList.select(index),scope.addSuggestion()},scope.addSuggestion=function(){var added=!1;return suggestionList.selected&&(tagsInput.addTag(angular.copy(suggestionList.selected)),suggestionList.reset(),added=!0),added},scope.track=function(item){return item[options.tagsInput.keyProperty||options.tagsInput.displayProperty]},scope.getSuggestionClass=function(item,index){var selected=item===suggestionList.selected;return[scope.matchClass({$match:item,$index:index,$selected:selected}),{selected:selected}]},scope.isSuggestionSelected=function(item){return!!tiUtil.findInObjectArray(tagsInput.getTags(),item,options.tagsInput.keyProperty||options.tagsInput.displayProperty,tiUtil.defaultComparer)},tagsInput.on("tag-added tag-removed invalid-tag input-blur",function(){suggestionList.reset()}).on("input-change",function(value){shouldLoadSuggestions(value)?suggestionList.load(value,tagsInput.getTags()):suggestionList.reset()}).on("input-focus",function(){var value=tagsInput.getCurrentTagText();options.loadOnFocus&&shouldLoadSuggestions(value)&&suggestionList.load(value,tagsInput.getTags())}).on("load-suggestions",function(){suggestionList.load("",tagsInput.getTags())}).on("input-keydown",function(event){var key=event.keyCode,handled=!1;if(!tiUtil.isModifierOn(event)&&-1!==hotkeys.indexOf(key))return suggestionList.visible?key===KEYS.down?(suggestionList.selectNext(),handled=!0):key===KEYS.up?(suggestionList.selectPrior(),handled=!0):key===KEYS.escape?(suggestionList.reset(),handled=!0):key!==KEYS.enter&&key!==KEYS.tab||(handled=scope.addSuggestion()):key===KEYS.down&&scope.options.loadOnDownArrow&&(suggestionList.load(tagsInput.getCurrentTagText(),tagsInput.getTags()),handled=!0),handled?(event.preventDefault(),event.stopImmediatePropagation(),!1):void 0}),events.on("suggestion-selected",function(index){scrollToElement(element,index)}),events.on("update-autocomplete-position",function(){$timeout(function(){new _popper2.default(element.parent(),element.children())})})}}}]),tagsInput.directive("tiAutocompleteMatch",["$sce","tiUtil",function($sce,tiUtil){return{restrict:"E",require:"^autoComplete",template:'<ng-include src="$$template"></ng-include>',scope:{$scope:"=scope",data:"="},link:function(scope,element,attrs,autoCompleteCtrl){var autoComplete=autoCompleteCtrl.registerAutocompleteMatch(),options=autoComplete.getOptions();scope.$$template=options.template,scope.$index=scope.$parent.$index,scope.$highlight=function(text){return options.highlightMatchedText?$sce.trustAsHtml(tiUtil.safeHighlight(text,autoComplete.getQuery())):$sce.trustAsHtml(text)},scope.$getDisplayText=function(){return tiUtil.safeToString(scope.data[options.displayProperty||options.tagsInput.displayProperty])}}}}]),tagsInput.directive("tiTranscludeAppend",function(){return function(scope,element,attrs,ctrl,transcludeFn){transcludeFn(function(clone){element.append(clone)})}}),tagsInput.directive("tiAutosize",["tagsInputConfig",function(tagsInputConfig){return{restrict:"A",require:"ngModel",link:function(scope,element,attrs,ctrl){var span,resize,threshold=tagsInputConfig.getTextAutosizeThreshold();span=angular.element('<span class="tag-input__input"></span>'),span.css("display","none").css("visibility","hidden").css("width","auto").css("white-space","pre"),element.parent().append(span),resize=function(originalValue){var width,value=originalValue;return angular.isString(value)&&0===value.length&&(value=attrs.placeholder),value&&(span.text(value),span.css("display",""),width=span.prop("offsetWidth"),span.css("display","none")),element.css("width",width?width+threshold+"px":""),originalValue},ctrl.$parsers.unshift(resize),ctrl.$formatters.unshift(resize),attrs.$observe("placeholder",function(value){ctrl.$modelValue||resize(value)})}}}]),tagsInput.directive("tiBindAttrs",function(){return function(scope,element,attrs){scope.$watch(attrs.tiBindAttrs,function(value){angular.forEach(value,function(value,key){attrs.$set(key,value)})},!0)}}),tagsInput.provider("tagsInputConfig",function(){var globalDefaults={},interpolationStatus={},autosizeThreshold=3;this.setDefaults=function(directive,defaults){return globalDefaults[directive]=defaults,this},this.setActiveInterpolation=function(directive,options){return interpolationStatus[directive]=options,this},this.setTextAutosizeThreshold=function(threshold){return autosizeThreshold=threshold,this},this.$get=["$interpolate",function($interpolate){var converters={};return converters[String]=function(value){return value},converters[Number]=function(value){return parseInt(value,10)},converters[Boolean]=function(value){return"true"===value.toLowerCase()},converters[RegExp]=function(value){return new RegExp(value)},{load:function(directive,scope,attrs,options){var defaultValidator=function(){return!0};scope.options={},angular.forEach(options,function(value,key){var type,localDefault,validator,converter,getDefault,updateValue;type=value[0],localDefault=value[1],validator=value[2]||defaultValidator,converter=converters[type],getDefault=function(){var globalValue=globalDefaults[directive]&&globalDefaults[directive][key];return angular.isDefined(globalValue)?globalValue:localDefault},updateValue=function(value){scope.options[key]=value&&validator(value)?converter(value):getDefault()},interpolationStatus[directive]&&interpolationStatus[directive][key]?attrs.$observe(key,function(value){updateValue(value),scope.events.trigger("option-change",{name:key,newValue:value})}):updateValue(attrs[key]&&$interpolate(attrs[key])(scope.$parent))})},getTextAutosizeThreshold:function(){return autosizeThreshold}}}]}),tagsInput.factory("tiUtil",["$timeout","$q",function($timeout,$q){var utils={};return utils.debounce=function(fn,delay){var timeoutId;return function(){var args=arguments;$timeout.cancel(timeoutId),timeoutId=$timeout(function(){fn.apply(void 0,_toConsumableArray(args))},delay)}},utils.makeObjectArray=function(array,key){if(!angular.isArray(array)||0===array.length||angular.isObject(array[0]))return array;var newArray=[];return array.forEach(function(item){var obj={};obj[key]=item,newArray.push(obj)}),newArray},utils.findInObjectArray=function(array,obj,key,comparer){var item=null,_comparer=comparer||utils.defaultComparer;return array.some(function(element){return!!_comparer(element[key],obj[key])&&(item=element,!0)}),item},utils.defaultComparer=function(a,b){return utils.safeToString(a).toLowerCase()===utils.safeToString(b).toLowerCase()},utils.safeHighlight=function(_str,_value){var str=utils.encodeHTML(_str),value=utils.encodeHTML(_value);if(!value)return str;var expression=new RegExp("&[^;]+;|"+function(str){return str.replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")}(value),"gi");return str.replace(expression,function(match){return match.toLowerCase()===value.toLowerCase()?"<em>"+match+"</em>":match})},utils.safeToString=function(value){return angular.isUndefined(value)||null==value?"":value.toString().trim()},utils.encodeHTML=function(value){return utils.safeToString(value).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")},utils.handleUndefinedResult=function(fn,valueIfUndefined){return function(){var result=fn.apply(void 0,arguments);return angular.isUndefined(result)?valueIfUndefined:result}},utils.replaceSpacesWithDashes=function(str){return utils.safeToString(str).replace(/\s/g,"-")},utils.isModifierOn=function(event){return event.shiftKey||event.ctrlKey||event.altKey||event.metaKey},utils.promisifyValue=function(_value){var value=!!angular.isUndefined(_value)||_value;return $q[value?"when":"reject"]()},utils.simplePubSub=function(){var events={};return{on:function(names,handler,first){return names.split(" ").forEach(function(name){events[name]||(events[name]=[]),(first?[].unshift:[].push).call(events[name],handler)}),this},trigger:function(name,args){return(events[name]||[]).every(function(handler){return utils.handleUndefinedResult(handler,!0)(args)}),this}}},utils}]),tagsInput.run(["$templateCache",function($templateCache){$templateCache.put("ngTagsInput/tags-input.html",'<div class="tags-input__host" tabindex="-1" ng-click="eventHandlers.host.click()" ti-transclude-append><div class="tags-input__tags" ng-class="{focused: hasFocus, \'tags-input__tags--boxed\': options.boxed}"><button class="tags-input__add-button" ng-if="options.showButton" ng-click="eventHandlers.input.loadSuggestions($event)" ng-disabled="tagList.items.length >= options.maxItems"><i class="icon-plus-large"></i></button><ul class="tags-input__tag-list"><li class="tags-input__tag-item" ng-repeat="tag in tagList.items track by track(tag)" ng-class="getTagClass(tag, $index)" ng-click="eventHandlers.tag.click(tag)"><ti-tag-item scope="templateScope" data="::tag"></ti-tag-item></li></ul><input class="tags-input__input" autocomplete="off" ng-model="newTag.text" ng-model-options="{getterSetter: true}" ng-keydown="eventHandlers.input.keydown($event)" ng-focus="eventHandlers.input.focus($event)" ng-blur="eventHandlers.input.blur($event)" ng-paste="eventHandlers.input.paste($event)" ng-trim="false" ng-class="{\'invalid-tag\': newTag.invalid}" ng-disabled="disabled" ti-bind-attrs="{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}" ti-autosize></div></div>'),$templateCache.put("ngTagsInput/tag-item.html",'<span ng-bind="$getDisplayText()"></span> <a class="tags-input__remove-button" ng-click="$removeTag()"><i ng-class="::$$removeTagSymbol"></i></a>'),$templateCache.put("ngTagsInput/auto-complete.html",'<div class="autocomplete" ng-if="suggestionList.visible"><ul class="suggestion-list"><li class="suggestion-item" ng-repeat="item in suggestionList.items track by track(item)" ng-class="getSuggestionClass(item, $index)" ng-click="addSuggestionByIndex($index)" ng-mouseenter="suggestionList.select($index)" ng-disabled="isSuggestionSelected(item)"><ti-autocomplete-match scope="templateScope" data="::item"></ti-autocomplete-match></li></ul></div>'),$templateCache.put("ngTagsInput/auto-complete-match.html",'<span ng-bind-html="$highlight($getDisplayText())"></span>')}])}()},function(module,exports,__webpack_require__){"use strict";function CarouselDirective(){return{scope:{currentStep:"=",finish:"&",model:"="},template:__webpack_require__(42),transclude:!0,controllerAs:"ctrl",controller:["$scope","$document",function($scope,$document){function unselectAll(){_.each($scope.steps,function(step){step.selected=!1}),$scope.selectedStep=null}var self=this;$scope.selectedStep=null,$scope.pageIndex=0,$scope.steps=[],$scope.goTo=function(step){unselectAll(),$scope.selectedStep=step,$scope.pageIndex=_.indexOf($scope.steps,step),_.isUndefined($scope.currentStep)||($scope.currentStep=step.code),step.selected=!0},this.addStep=function(step){$scope.steps.push(step),$scope.$watch("currentStep",function(stepCode){stepCode&&($scope.selectedStep&&$scope.selectedStep.code!==stepCode||!$scope.selectedStep)&&$scope.goTo(_.find($scope.steps,{code:stepCode}))}),$scope.selectedStep||this.goTo(0)},this.goTo=function(step){var stepTo;stepTo=_.isNumber(step)?$scope.steps[step]:_.find($scope.steps,{code:step}),$scope.goTo(stepTo)},this.next=function(){var index=_.indexOf($scope.steps,$scope.selectedStep);index===$scope.steps.length-1?this.finish():$scope.goTo($scope.steps[index+1])},this.previous=function(){var index=_.indexOf($scope.steps,$scope.selectedStep);index>0&&$scope.goTo($scope.steps[index-1])},this.finish=function(){$scope.finish&&$scope.finish()},$document.bind("keydown",function(e){37===e.keyCode?$scope.$applyAsync(function(){self.previous()}):39===e.keyCode&&$scope.$applyAsync(function(){self.next()})}),$scope.$on("$destroy",function(){$document.unbind("keydown")})}],link:function(scope,elem){scope.$watch("model",function(){scope.model?elem.show():elem.hide()})}}}function CarouselStepDirective(){return{scope:{code:"@"},template:'<div class="sd-carousel__page" ng-show="selected" ng-transclude></div>',transclude:!0,replace:!0,require:"^sdCarousel",link:function(scope,elem,attr,carousel){carousel.addStep(scope)}}}CarouselDirective.$inject=[],CarouselStepDirective.$inject=[],angular.module("superdesk-ui.carousel",[]).directive("sdCarousel",CarouselDirective).directive("sdCarouselStep",CarouselStepDirective)},function(module,exports){module.exports='<div class="sd-carousel__backdrop"></div>\n<div class="sd-carousel">\n    <div class="sd-carousel__dialog">\n        <div class="sd-carousel__content" ng-transclude></div>\n        <a class="sd-carousel__nav-button sd-carousel__nav-button--prev" ng-click="ctrl.previous()" ng-hide="pageIndex === 0"></a>\n        <a class="sd-carousel__nav-button" ng-click="pageIndex === steps.length-1 ? ctrl.finish() : ctrl.next()" ng-class="pageIndex === steps.length-1 ? \'sd-carousel__nav-button--end\' : \'sd-carousel__nav-button--next\'"></a>\n        <div class="sd-carousel__page-indication-bar">\n            <span ng-repeat="step in steps" \n                  class="sd-carousel__page-indicator" \n                  ng-class="{\'sd-carousel__page-indicator--selected\': step.selected}"\n                  ng-click="goTo(step)">\n            </span>\n        </div>\n    </div>\n</div>'},function(module,exports,__webpack_require__){"use strict";function sdCheck($parse){return{require:"ngModel",replace:!0,transclude:!0,template:'<span class="sd-check__wrapper"><span class="sd-checkbox"></span><label ng-transclude></label></span>',link:function($scope,element,attrs,ngModel){function render(label,checkbox,value){"radio"===attrs.type&&(value=ngModel.$viewValue===attrs.ngValue,checkbox.addClass("sd-checkbox--radio")),attrs.ngTrueValue&&(value=ngModel.$viewValue===attrs.ngTrueValue),attrs.disabled&&(checkbox.addClass("sd-checkbox sd-checkbox--disabled"),label.addClass("sd-label--disabled")),attrs.icon&&checkbox.html('<i class="icon-'+attrs.icon+'">').append(label).addClass("sd-checkbox sd-checkbox--button-style"),checkbox.toggleClass("checked",!!value).attr("checked",!!value),"inside"!==attrs.labelPosition&&label.toggleClass("label--active",!!value)}var label=element.find("label"),checkbox=element.find("span");$parse(attrs.ngChecked)($scope)&&("radio"===attrs.type&&ngModel.$setViewValue(attrs.ngValue),attrs.ngTrueValue&&ngModel.$setViewValue(attrs.ngTrueValue),ngModel.$setViewValue(!ngModel.$viewValue)),ngModel.$render=function(){render(label,checkbox,ngModel.$viewValue)},$scope.$watch(attrs.ngModel,function(){render(label,checkbox,ngModel.$viewValue)}),element.on("click",function(){if(attrs.disabled)return!1;$scope.$apply(function(){return"radio"===attrs.type?ngModel.$setViewValue(attrs.ngValue):attrs.ngTrueValue?ngModel.$setViewValue(ngModel.$viewValue===attrs.ngTrueValue?attrs.ngFalseValue:attrs.ngTrueValue):ngModel.$setViewValue(!ngModel.$viewValue)})}),"inside"===attrs.labelPosition?(checkbox.html(label).addClass("sd-checkbox sd-checkbox--button-style"),attrs.icon&&checkbox.prepend('<i class="icon-'+attrs.icon+'">')):"left"===attrs.labelPosition&&label.after(checkbox)}}}sdCheck.$inject=["$parse"],angular.module("superdesk-ui.check",[]).directive("sdCheck",sdCheck)},function(module,exports,__webpack_require__){"use strict";(function($){function sdDropdown($window){return{link:function(scope,elem){function closeToBottom(){return!(!button||!button.offset())&&checkEnvironment().bottom<menu.outerHeight()+button.outerHeight()}function closeToTop(){return!(!button||!button.offset())&&button.offset().top-$window.scrollY<menu.outerHeight()+button.outerHeight()}function closeToLeft(){return checkEnvironment().left<menu.outerWidth()}function closeToRight(){return!(!button||!button.offset())&&$window.innerWidth-button.offset().left-button.outerWidth()<menu.outerWidth()}function checkEnvironment(){var container=!1;return elem.parents("#authoring-container").length?container="#authoring-container":elem.parents(".modal__body").length&&(container=".modal__body"),{left:container?elem.offset().left-$(container).offset().left:elem.offset().left,bottom:container?$(container).innerHeight()-button.offset().top:$window.innerHeight-(button.offset().top-$window.scrollY)}}function doTheMath(){button=elem.find(".dropdown__toggle")||elem.find(".dropdown-toggle")||elem.find("[dropdown__toggle]"),closeToBottom()?elem.addClass("dropdown--dropup"):elem.removeClass("dropdown--dropup"),closeToTop()&&elem.removeClass("dropdown--dropup"),closeToLeft()&&(settings.isInlineOrientedRight||settings.isInlineOrientedLeft?elem.removeClass("dropdown--dropleft").addClass("dropdown--dropright"):menu.removeClass("dropdown--align-right")),closeToRight()&&(settings.isInlineOrientedRight||settings.isInlineOrientedLeft?elem.addClass("dropdown--dropleft").removeClass("dropdown--dropright"):menu.addClass("dropdown--align-right")),closeToLeft()&&closeToRight()&&(settings.isInlineOrientedRight||settings.isInlineOrientedLeft?elem.removeClass("dropdown--dropleft").removeClass("dropdown--dropright"):menu.removeClass("dropdown--align-right")),closeToLeft()||closeToRight()||(settings.isInlineOrientedRight?elem.addClass("dropdown--dropright").removeClass("dropdown--dropleft"):settings.isInlineOrientedLeft?elem.addClass("dropdown--dropleft").removeClass("dropdown--dropright"):settings.isRightOriented?menu.addClass("dropdown--align-right"):menu.removeClass("dropdown--align-right"))}var button,menu=elem.children(".dropdown__menu"),settings={isTopOriented:menu.hasClass("dropdown--dropup"),isRightOriented:menu.hasClass("dropdown--align-right"),isInlineOrientedRight:elem.hasClass("dropdown--dropright"),isInlineOrientedLeft:elem.hasClass("dropdown--dropleft")};elem.bind("click",doTheMath),elem.hasClass("dropdown--hover")&&elem.bind("mouseover",doTheMath)}}}function sdDropdownAppendToBody($window,$timeout){return{require:"dropdown",link:function(scope,elem,attr,ctrl){function closeToRight(menu,inline){return $window.innerWidth-elem.offset().left<menu.outerWidth()+(inline?button.outerWidth():0)}function closeToTop(menu){return button.offset().top<menu.outerHeight()+button.outerHeight()}function closeToBottom(menu){return $window.innerHeight-(button.offset().top-$window.scrollY)<menu.outerHeight()+button.outerHeight()}var button=elem.find("[dropdown__toggle]");scope.$watch(ctrl.isOpen,function(isOpen){if(!isOpen)return!1;var style={display:isOpen?"block":"none",top:elem.offset().top+button.outerHeight(),left:elem.offset().left,opacity:1};scope.$evalAsync(function(){ctrl.dropdownMenu.css({opacity:0,display:"none"})}),$timeout(function(){scope.$applyAsync(function(){closeToBottom(ctrl.dropdownMenu)?style.top=elem.offset().top-ctrl.dropdownMenu.outerHeight():style.top=elem.offset().top+button.outerHeight(),elem.hasClass("dropdown--align-right")&&(style.left=elem.offset().left-ctrl.dropdownMenu.outerWidth()+button.outerWidth()),closeToRight(ctrl.dropdownMenu)&&(style.left=elem.offset().left-ctrl.dropdownMenu.outerWidth()-15),closeToTop(ctrl.dropdownMenu)&&!elem.hasClass("dropdown--dropup")&&(style.top=48,style.left=closeToRight(ctrl.dropdownMenu,!0)?elem.offset().left-ctrl.dropdownMenu.outerWidth()-15:elem.offset().left+button.outerWidth()),ctrl.dropdownMenu.css(style)})},150,!1)})}}}sdDropdown.$inject=["$window"],sdDropdownAppendToBody.$inject=["$window","$timeout"],angular.module("superdesk-ui.dropdown",[]).directive("dropdown",sdDropdown).directive("dropdownAppendToBody",sdDropdownAppendToBody)}).call(exports,__webpack_require__(2))},function(module,exports,__webpack_require__){"use strict";function sdModal($document,$rootScope){return{template:['<div class="modal" data-backdrop="static">','<div class="modal__dialog" ng-if="model"><div class="modal__content" ng-transclude></div></div>','</div><div class="modal__backdrop fade in" ng-if="model"></div>'].join(""),transclude:!0,scope:{model:"="},link:function(scope,element){function initialized(){return _initialized&&content}$rootScope.modals=$rootScope.modals?$rootScope.modals:0;var content,_initialized=!1;scope.$watch("model",function(){scope.model?(initialized()||(content=element.children(),content.addClass(element.attr("class")),content.appendTo($document.find("body")),content[0].style="z-index: "+(1050+$rootScope.modals),content[1].style="z-index: "+(1049+$rootScope.modals),_initialized=!0),content.show().addClass("in"),$document.find("body").addClass("modal-open"),$rootScope.modals++):initialized()&&(content.hide().removeClass("in"),$document.find("body").removeClass("modal-open"),closeModal())});var closeModal=function(){scope.model=!1,$rootScope.modals--,scope.$evalAsync()};$document.bind("keydown",function(evt){27===evt.which&&closeModal()}),scope.$on("$destroy",function(){initialized()&&(content.hide(),content.remove(),delete $rootScope.modals)})}}}sdModal.$inject=["$document","$rootScope"],angular.module("superdesk-ui.modals",[]).directive("sdModal",sdModal)},function(module,exports,__webpack_require__){"use strict";function sdSwitch(){return{require:"ngModel",replace:!0,template:['<span class="sd-toggle">','<span class="inner"></span>',"</span>"].join(""),link:function($scope,element,attrs,ngModel){function render(element,value){element.toggleClass("checked",!!value),element.attr("checked",!!value)}var Keys={pageup:33,pagedown:34,left:37,up:38,right:39,down:40,enter:13,escape:27,space:32,backspace:8};ngModel.$render=function(){render(element,ngModel.$viewValue)},element.bind("keydown",function(e){if(e.keyCode===Keys.enter||e.keyCode===Keys.space)return e.preventDefault(),$scope.$apply(function(){ngModel.$setViewValue(!ngModel.$viewValue)}),!1}),$scope.$watch(attrs.ngModel,function(){render(element,ngModel.$viewValue)}),element.on("click",function(e){return $scope.$apply(function(){ngModel.$setViewValue(!ngModel.$viewValue)}),!1}),$scope.$on("$destroy",function(){element.unbind("keydown"),element.off("click")})}}}sdSwitch.$inject=[],angular.module("superdesk-ui.switch",[]).directive("sdSwitch",sdSwitch)},function(module,exports,__webpack_require__){"use strict";function ToggleBoxDirective(){return{template:'<toggle-box-next ng-if="loaded" data-title="title" mode="mode" style="style" is-open="isOpen"><div><div ng-transclude></div></div></toggle-box-next>',transclude:!0,scope:{},link:function($scope,element,attrs){$scope.isOpen="true"===attrs.open,$scope.mode=attrs.mode,$scope.style=attrs.style,$scope.toggleModule=function(){$scope.isOpen=!$scope.isOpen},attrs.$observe("title",function(title){$scope.title=title,$scope.loaded=!0})}}}angular.module("superdesk-ui.toggleBox",[]).directive("sdToggleBox",ToggleBoxDirective)},function(module,exports,__webpack_require__){"use strict";function WizardHandlerFactory(){var service={},wizards={};return service.defaultName="defaultWizard",service.addWizard=function(name,wizard){wizards[name]=wizard},service.removeWizard=function(name){delete wizards[name]},service.wizard=function(name){var nameToUse=name||service.defaultName;return wizards[nameToUse]},service}function WizardDirective(){return{template:__webpack_require__(49),scope:{currentStep:"=",finish:"&",name:"@"},transclude:!0,controller:["$scope","WizardHandler",function($scope,WizardHandler){function unselectAll(){_.each($scope.steps,function(step){step.selected=!1}),$scope.selectedStep=null}WizardHandler.addWizard($scope.name||WizardHandler.defaultName,this),$scope.$on("$destroy",function(){WizardHandler.removeWizard($scope.name||WizardHandler.defaultName)}),$scope.selectedStep=null,$scope.steps=[];var stopWatch;this.addStep=function(step){$scope.steps.push(step),stopWatch||(stopWatch=$scope.$watch("currentStep",function(stepCode){stepCode&&($scope.selectedStep&&$scope.selectedStep.code!==stepCode||!$scope.selectedStep)&&$scope.goTo(_.find($scope.steps,{code:stepCode}))})),$scope.selectedStep||this.goTo(0)},$scope.goTo=function(step){unselectAll(),$scope.selectedStep=step,_.isUndefined($scope.currentStep)||($scope.currentStep=step.code),step.selected=!0},this.goTo=function(step){var stepTo;stepTo=_.isNumber(step)?$scope.steps[step]:_.find($scope.steps,{code:step}),$scope.goTo(stepTo)},this.next=function(){var index=_.indexOf($scope.steps,$scope.selectedStep);index===$scope.steps.length-1?this.finish():$scope.goTo($scope.steps[index+1])},this.previous=function(){var index=_.indexOf($scope.steps,$scope.selectedStep);$scope.goTo($scope.steps[index-1])},this.finish=function(){$scope.finish&&$scope.finish()}}]}}function WizardStepDirective(){return{template:__webpack_require__(50),scope:{title:"@",code:"@",disabled:"=",hide:"="},transclude:!0,require:"^sdWizard",link:function($scope,element,attrs,wizard){wizard.addStep($scope)}}}WizardHandlerFactory.$inject=[],WizardDirective.$inject=[],WizardStepDirective.$inject=[],angular.module("superdesk-ui.wizard",[]).factory("WizardHandler",WizardHandlerFactory).directive("sdWizard",WizardDirective).directive("sdWizardStep",WizardStepDirective)},function(module,exports){module.exports='<div class="modal__body-header">\n    <ul class="nav-tabs">\n        <li ng-repeat="step in steps" ng-class="{\'nav-tabs__tab--active\': step.selected}" class="nav-tabs__tab">\n            <button ng-click="goTo(step)" ng-disabled="step.disabled" ng-hide="step.hide" class="nav-tabs__link">{{ step.title}}</button>\n        </li>\n    </ul>\n</div>\n<div class="modal__body-content" ng-transclude></div>'},function(module,exports){module.exports='<div ng-show="selected" class="modal-screen" ng-transclude></div>\r\n'},function(module,exports,__webpack_require__){"use strict";function TagInputDirective($q){return{scope:{model:"=ngModel",items:"=",field:"@",label:"@",freetext:"=",required:"=",onChange:"&",keyProperty:"@",replaceSpacesWithDashes:"=?",minLength:"=",maxLength:"=",maxItems:"=",boxed:"=",placeholder:"@",maxResultsToShow:"="},require:"?ngModel",template:__webpack_require__(52),link:function(scope){scope.loadTags=function(query){return $q(function(resolve,reject){resolve(scope.items.filter(function(el){return scope.field?el[scope.field].toLowerCase().indexOf(query.toLowerCase())>-1:el.toLowerCase().indexOf(query.toLowerCase())>-1}))})}}}}TagInputDirective.$inject=["$q"],angular.module("superdesk-ui.tags",[]).directive("sdTagInput",TagInputDirective)},function(module,exports){module.exports='<label class="tags-input__label" ng-if="label">{{label}}</label>\n<tags-input ng-model="model"\n    add-from-autocomplete-only="{{items ? !freetext : false}}"\n    show-button="{{!!items}}"\n    display-property="{{field}}"\n    key-property="{{keyProperty}}"\n    use-strings="{{!field}}"\n    ng-required="required"\n    on-tag-added="onChange($tag)"\n    on-tag-removed="onChange($tag)"\n    replace-spaces-with-dashes="{{replaceSpacesWithDashes}}"\n    min-length="{{minLength}}"\n    max-length="{{maxLength}}"\n    max-tags="{{maxTags}}"\n    max-items="{{maxItems}}"\n    boxed={{boxed}}\n    placeholder="{{placeholder}}">\n\n    <auto-complete ng-if="items"\n        source="loadTags($query)"\n        load-on-empty="true"\n        min-length="{{minLength}}"\n        display-property="{{field}}"\n        key-property="{{keyProperty}}"\n        max-results-to-show="{{maxResultsToShow}}">\n    </auto-complete>\n</tags-input>\n'},function(module,exports,__webpack_require__){"use strict";function LineInputDirective(){return{template:__webpack_require__(54),replace:!0,transclude:!0,require:"?ngModel",scope:{model:"=ngModel",sync:"=",dark:"=",boxed:"=",label:"@",maxlength:"=",disabled:"=",required:"=",textarea:"=",placeholder:"@",transclude:"=",onchange:"&",onblur:"&"},link:function(scope,elem,attrs,ngModel){scope.modelFixed={value:scope.model},scope.$watch("model",function(model){!0===scope.sync&&(scope.modelFixed.value=model)}),scope.update=function(value){return ngModel.$setViewValue(value),scope.onchange()}}}}angular.module("superdesk-ui.lineInput",[]).directive("sdLineInput",LineInputDirective)},function(module,exports){module.exports=' <div class="sd-line-input" ng-class="{\'sd-line-input--dark-ui\': dark, \'sd-line-input--boxed\': boxed, \'sd-line-input--required\': required}">\n    <label class="sd-line-input__label" translate>{{label}}</label>\n\n    <input class="sd-line-input__input" type="text" ng-model="modelFixed.value" ng-change="update(modelFixed.value)" ng-blur="onblur()" ng-disabled="disabled" placeholder="{{placeholder}}" ng-if="!transclude && !textarea">\n\n    <textarea class="sd-line-input__input"\n        ng-model="modelFixed.value"\n        ng-change="update(modelFixed.value)"\n        ng-blur="onblur()"\n        ng-disabled="disabled"\n        placeholder="{{placeholder}}"\n        ng-if="textarea"\n        sd-auto-height>\n    </textarea>\n\n    <ng-transclude></ng-transclude>\n    <div class="sd-line-input__char-count" ng-if="maxlength" sd-character-count data-item="modelFixed.value" data-limit="maxlength" data-html="true"></div>\n</div>\n'},function(module,exports,__webpack_require__){"use strict";function SearchHandlerDirective(){return{template:__webpack_require__(56),replace:!0,transclude:!0,require:"?ngModel",scope:{model:"=ngModel",label:"@",debounce:"@"},link:function(scope,elem,attrs,ngModel){scope.update=function(value){ngModel.$setViewValue(value)}}}}angular.module("superdesk-ui.searchHandler",[]).directive("sdSearchHandler",SearchHandlerDirective)},function(module,exports){module.exports='<div class="flat-searchbar" ng-class="{extended: extended}">\n    <div class="search-handler">\n        <label for="search-input" class="trigger-icon" ng-click="extended = !extended"><i class="icon-search"></i></label>\n        <input id="search-input" type="text" placeholder="{{ :: label || \'Search\' | translate }}" ng-model="model" ng-model-options="{debounce: debounce}">\n    </div>\n</div>'},function(module,exports,__webpack_require__){"use strict";(function($){function sdCircularProgress(){return{scope:{value:"=",error:"=",counter:"="},template:__webpack_require__(58),link:function(scope,element){var elem=$(element).find(".progress-svg"),width=elem.outerWidth(),strokeWidth=parseInt(elem.find("circle").css("strokeWidth"));setTimeout(function(){elem.find("circle").css("transition","stroke-dashoffset ease-in-out .3s")},500),scope.radius=width/2-strokeWidth/2,scope.circumference=2*Math.PI*scope.radius,scope.$watch("error",function(val){val?(element.addClass("error"),scope.status="error"):(element.removeClass("error"),delete scope.status)}),scope.$watch("value",function(){!scope.value||scope.value<0?scope.value=0:scope.value>=100?(scope.value=100,element.addClass("completed"),scope.status="completed"):(element.removeClass("completed"),delete scope.status),scope.dashOffset=scope.circumference*(1-scope.value/100)})}}}sdCircularProgress.$inject=[],angular.module("superdesk-ui.circularProgress",[]).directive("sdCircularProgress",sdCircularProgress)}).call(exports,__webpack_require__(2))},function(module,exports){module.exports='<div class="progress-bar-container">\n    <div  class="progress-done" ng-class="{\'progress-done--completed\': status === \'completed\', \'progress-done--error\': status === \'error\'}">\n        <i class="icon-ok" ng-hide="status === \'error\'"></i>\n        <i class="icon-close-small" ng-hide="status === \'completed\'"></i>\n    </div>\n    <span class="progress-text" ng-if="counter">{{value}}<em>%</em></span>\n    <svg class="progress-svg">\n        <circle ng-attr-r="{{radius}}" ng-attr-cx="50%" ng-attr-cy="50%"></circle>\n        <circle class="progressbar" ng-attr-r="{{radius}}" ng-attr-cx="50%" ng-attr-cy="50%" ng-style="{\'stroke-dashoffset\': dashOffset, \'stroke-dasharray\': circumference}"></circle>\n    </svg>\n</div>'},function(module,exports,__webpack_require__){"use strict";function SplitterDirective($window){return{link:function(scope,elem,attr){function mouseDownHandler(){splitter=document.getElementById(attr.sdSplitter),document.body.addEventListener("mousemove",handleScroller)}function handleScroller(event){var size=splitter.offsetWidth-event.movementX;size<=attr.splitterMax&&size>=attr.splitterMin&&(splitter.style.width=size+"px",$window.dispatchEvent(new Event("resize")))}var splitter=void 0;elem[0].addEventListener("mousedown",mouseDownHandler),document.body.addEventListener("mouseup",function(){document.body.removeEventListener("mousemove",handleScroller)}),scope.$on("$destroy",function(){elem[0].removeEventListener("mousedown",mouseDownHandler)})}}}SplitterDirective.$inject=["$window"],angular.module("superdesk-ui.splitter",[]).directive("sdSplitter",SplitterDirective)},function(module,exports,__webpack_require__){"use strict";function MediaQuery($window){return{link:function(scope,elem,attr){function handleResize(){var width=elem.width();width<attr.minWidth?elem.removeClass("comfort").addClass("compact"):width>attr.maxWidth?elem.removeClass("compact").addClass("comfort"):elem.removeClass("compact comfort")}var window=angular.element($window),resize=_.debounce(handleResize,150);window.on("resize",resize),scope.$on("$destroy",function(){window.off("resize",resize)}),resize()}}}MediaQuery.$inject=["$window"],angular.module("superdesk-ui.mediaQuery",[]).directive("sdMediaQuery",MediaQuery)},function(module,exports,__webpack_require__){"use strict";__webpack_require__(62)},function(module,exports){}])});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(95)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(244);
var ng_1 = __importDefault(__webpack_require__(18));
exports.getLabelForFieldId = function (fieldId, vocabularies) {
    var labelMap = constants_1.GET_LABEL_MAP();
    if (labelMap.hasOwnProperty(fieldId)) {
        return labelMap[fieldId];
    }
    var field = vocabularies.find(function (obj) { return obj._id === fieldId; });
    if (field != null
        && field.hasOwnProperty('display_name')
        && field['display_name'].length > 0) {
        return field['display_name'];
    }
    console.warn("could not find label for " + fieldId + ". Please add it in " +
        '(apps/workspace/content/content/directives/ContentProfileSchemaEditor).' +
        'ContentProfileSchemaEditor/labelMap');
    return fieldId.charAt(0).toUpperCase() + fieldId.substr(1).toLowerCase();
};
exports.getLabelNameResolver = function () { return ng_1.default.getService('vocabularies')
    .then(function (vocabulariesService) { return vocabulariesService.getAllActiveVocabularies(); })
    .then(function (vocabulariesCollection) { return function (fieldId) { return exports.getLabelForFieldId(fieldId, vocabulariesCollection); }; }); };


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactFormContainer_1 = __webpack_require__(2076);
exports.ContactFormContainer = ContactFormContainer_1.ContactFormContainer;
var ContactProfile_1 = __webpack_require__(579);
exports.ContactProfile = ContactProfile_1.ContactProfile;
var ActionBar_1 = __webpack_require__(582);
exports.ActionBar = ActionBar_1.ActionBar;
var ProfileHeader_1 = __webpack_require__(580);
exports.ProfileHeader = ProfileHeader_1.ProfileHeader;
var ProfileDetail_1 = __webpack_require__(581);
exports.ProfileDetail = ProfileDetail_1.ProfileDetail;
var Row_1 = __webpack_require__(2097);
exports.Row = Row_1.Row;
var InputArray_1 = __webpack_require__(2098);
exports.InputArray = InputArray_1.InputArray;
var LineInput_1 = __webpack_require__(2099);
exports.LineInput = LineInput_1.LineInput;
var MultiTextInput_1 = __webpack_require__(2100);
exports.MultiTextInput = MultiTextInput_1.MultiTextInput;
var Input_1 = __webpack_require__(2101);
exports.Input = Input_1.Input;
var SelectInput_1 = __webpack_require__(2102);
exports.SelectInput = SelectInput_1.SelectInput;
var Select_1 = __webpack_require__(2103);
exports.Select = Select_1.Select;
var Label_1 = __webpack_require__(2104);
exports.Label = Label_1.Label;
var Toggle_1 = __webpack_require__(2105);
exports.Toggle = Toggle_1.Toggle;
var ToggleBox_1 = __webpack_require__(2106);
exports.ToggleBox = ToggleBox_1.ToggleBox;
var ContactNumberInput_1 = __webpack_require__(2107);
exports.ContactNumberInput = ContactNumberInput_1.ContactNumberInput;
var SelectFieldSearchInput_1 = __webpack_require__(2108);
exports.SelectFieldSearchInput = SelectFieldSearchInput_1.SelectFieldSearchInput;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(43);
var fields = __importStar(__webpack_require__(251));
exports.onEventCapture = function (event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
};
function replaceUrls(contact) {
    if (contact.facebook) {
        lodash_1.default.set(contact, 'facebook', lodash_1.default.replace(contact.facebook, constants_1.FB_URL, ''));
    }
    if (contact.instagram) {
        lodash_1.default.set(contact, 'instagram', lodash_1.default.replace(contact.instagram, constants_1.IG_URL, ''));
    }
    return contact;
}
exports.replaceUrls = replaceUrls;
function renderArea(area, itemProps, props) {
    // If singleline preference is set, don't show second line
    if (itemProps.scope.singleLine && area === 'secondLine') {
        return;
    }
    /* globals __SUPERDESK_CONFIG__: true */
    var listConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]}.contactList || constants_1.DEFAULT_LIST_CONFIG;
    var specs = listConfig[area] || [];
    var contents = specs.map(function (field, index) {
        if (fields[field]) {
            return fields[field](itemProps);
        }
        console.warn('missing field in list: ' + field);
        return null;
    }).filter(angular.identity);
    var elemProps = angular.extend({ key: area }, props);
    return contents.length ? react_1.default.createElement('div', elemProps, contents) : null;
}
exports.renderArea = renderArea;
/**
 * renders the contents passed as array of elements
 */
function renderContents(contents) {
    return react_1.default.createElement.apply(null, contents);
}
exports.renderContents = renderContents;
function getContactType(contact) {
    return lodash_1.default.some([contact.first_name, contact.last_name], function (v) { return !lodash_1.default.isEmpty(v); }) ? 'person' : 'organisation';
}
exports.getContactType = getContactType;
function validateRequiredFormFields(contact) {
    return validateRequiredField(contact) && validateMinRequiredField(contact);
}
exports.validateRequiredFormFields = validateRequiredFormFields;
function validateRequiredField(contact) {
    var REQUIRED_CONTACT_FIELDS = getContactType(contact) === 'person' ?
        ['first_name', 'last_name'] : ['organisation'];
    var invalid = lodash_1.default.some(REQUIRED_CONTACT_FIELDS, function (field) {
        switch (field) {
            default:
                return lodash_1.default.isEmpty(contact[field]);
        }
    });
    return !invalid;
}
exports.validateRequiredField = validateRequiredField;
function validateMinRequiredField(contact) {
    return lodash_1.default.some(constants_1.LOOKUP_FIELDS, function (field) {
        switch (field) {
            case 'contact_email':
                return lodash_1.default.get(contact, field, 0).length > 0 && !lodash_1.default.some(contact[field], function (v) { return lodash_1.default.isEmpty(v); });
            case 'contact_phone':
            case 'mobile':
                return lodash_1.default.get(contact, field, 0).length > 0 && !lodash_1.default.some(lodash_1.default.map(contact[field], 'number'), function (v) { return lodash_1.default.isEmpty(v); });
            default:
                return !lodash_1.default.isEmpty(contact[field]);
        }
    });
}
exports.validateMinRequiredField = validateMinRequiredField;
exports.scrollListItemIfNeeded = function (selectedIndex, listRefElement) {
    if (listRefElement.children.length > 0) {
        var activeElement = listRefElement.children[selectedIndex];
        if (activeElement) {
            var distanceOfSelItemFromVisibleTop = $(activeElement).offset().top -
                $(document).scrollTop() -
                $(listRefElement).offset().top - $(document).scrollTop();
            // If the selected item goes beyond container view, scroll it to middle.
            if (distanceOfSelItemFromVisibleTop >=
                (listRefElement.clientHeight - activeElement.clientHeight) ||
                distanceOfSelItemFromVisibleTop < 0) {
                $(listRefElement).scrollTop($(listRefElement).scrollTop() +
                    distanceOfSelItemFromVisibleTop -
                    listRefElement.offsetHeight * 0.5);
            }
        }
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(776);

module.exports = DraftFeatureFlags;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsMetaKeys = {
    draftjsState: 'draftjsState',
};
// . is not a valid character for mongo key
exports.FIELD_KEY_SEPARATOR = '>';
exports.getFieldId = function (contentKey) { return contentKey.split(exports.FIELD_KEY_SEPARATOR).slice(-1)[0]; };
exports.META_FIELD_NAME = 'fields_meta';
var wrapper = {
    // wrapping is performed, so backend API doesn't try to merge the keys of our value
    wrap: function (value) { return [value]; },
    unwrap: function (wrappedValue) { return wrappedValue[0]; },
};
// Content key is similar to fieldName, except it supports nested objects
// which have content keys like such "extra>customFieldName"
function getFieldMetadata(item, fieldKey, contentKey) {
    if (Object.keys(exports.fieldsMetaKeys).includes(contentKey) === false) {
        throw new Error("Invalid key '" + contentKey + "'");
    }
    if (item == null || item[exports.META_FIELD_NAME] == null || item[exports.META_FIELD_NAME][fieldKey] == null) {
        return null;
    }
    if (Array.isArray(item[exports.META_FIELD_NAME][fieldKey][contentKey]) === false) {
        return null;
    }
    return wrapper.unwrap(item[exports.META_FIELD_NAME][fieldKey][contentKey]);
}
exports.getFieldMetadata = getFieldMetadata;
function setFieldMetadata(item, fieldKey, contentKey, contentValue) {
    var _a;
    if (Object.keys(exports.fieldsMetaKeys).includes(contentKey) === false) {
        throw new Error('Invalid key');
    }
    if (item[exports.META_FIELD_NAME] == null) {
        item[exports.META_FIELD_NAME] = {};
    }
    item[exports.META_FIELD_NAME][fieldKey] = __assign({}, item[exports.META_FIELD_NAME][fieldKey], (_a = {}, _a[contentKey] = wrapper.wrap(contentValue), _a));
}
exports.setFieldMetadata = setFieldMetadata;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(93);
var IE8_DOM_DEFINE = __webpack_require__(443);
var toPrimitive = __webpack_require__(199);
var dP = Object.defineProperty;

exports.f = __webpack_require__(61) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
var fieldsMeta_1 = __webpack_require__(66);
var highlightsConfig_1 = __webpack_require__(46);
exports.CONTENT_FIELDS_DEFAULTS = Object.freeze((_a = {
        headline: '',
        slugline: '',
        body_html: '',
        abstract: '',
        anpa_take_key: null,
        byline: '',
        urgency: null,
        priority: null,
        subject: [],
        anpa_category: [],
        genre: null,
        groups: null,
        usageterms: null,
        ednote: null,
        authors: [],
        place: [],
        dateline: {},
        language: null,
        unique_name: '',
        keywords: [],
        description_text: null,
        sign_off: null,
        publish_schedule: null,
        flags: null,
        pubstatus: null,
        target_regions: [],
        target_types: [],
        target_subscribers: [],
        embargo: null,
        renditions: {},
        associations: {},
        body_footer: '',
        company_codes: [],
        schedule_settings: null,
        sms_message: null,
        poi: {},
        profile: null,
        format: 'HTML',
        alt_text: null,
        copyrightnotice: null,
        copyrightholder: null,
        archive_description: null,
        extra: {},
        attachments: null,
        semantics: null,
        annotations: null
    },
    _a[fieldsMeta_1.META_FIELD_NAME] = {},
    _a));
exports.DEFAULT_ACTIONS = Object.freeze({
    publish: false,
    correct: false,
    kill: false,
    deschedule: false,
    new_take: false,
    re_write: false,
    save: false,
    edit: false,
    mark_item: false,
    duplicate: false,
    copy: false,
    view: true,
    spike: false,
    unspike: false,
    package_item: false,
    multi_edit: false,
    send: false,
    create_broadcast: false,
    add_to_current: false,
    resend: false,
    set_label: true,
    takedown: false,
});
/**
 * Extend content of dest
 *
 * @param {Object} dest
 * @param {Object} src
 */
function extendItem(dest, src) {
    return angular.extend(dest, lodash_1.default.pick(src, lodash_1.default.keys(exports.CONTENT_FIELDS_DEFAULTS)));
}
exports.extendItem = extendItem;
/**
 * Filter out default values from diff
 *
 * @param {Object} diff
 * @param {Object} orig
 */
function filterDefaultValues(diff, orig) {
    Object.keys(exports.CONTENT_FIELDS_DEFAULTS).forEach(function (key) {
        if (diff.hasOwnProperty(key) && angular.equals(diff[key], exports.CONTENT_FIELDS_DEFAULTS[key]) &&
            !orig.hasOwnProperty(key)) {
            delete diff[key];
        }
    });
}
exports.filterDefaultValues = filterDefaultValues;
function stripHtmlRaw(content) {
    if (content) {
        var elem = document.createElement('div');
        elem.innerHTML = content;
        return utils_1.stripHtmlTags(elem.textContent);
    }
    return '';
}
exports.stripHtmlRaw = stripHtmlRaw;
function stripHtml(item) {
    var fields = ['headline'];
    lodash_1.default.each(fields, function (key) {
        if (angular.isDefined(item[key])) {
            item[key] = stripHtmlRaw(item[key]);
        }
    });
    return item;
}
exports.stripHtml = stripHtml;
/**
 * Extend content of dest by forcing 'default' values
 * if the value doesn't exist in src
 *
 * @param {Object} dest
 * @param {Object} src
 */
function forcedExtend(dest, src) {
    lodash_1.default.each(exports.CONTENT_FIELDS_DEFAULTS, function (value, key) {
        if (dest[key]) {
            if (src[key]) {
                dest[key] = src[key];
            }
            else {
                dest[key] = value;
            }
        }
        else if (src[key]) {
            dest[key] = src[key];
        }
    });
}
exports.forcedExtend = forcedExtend;
/**
* Clean the given html by removing tags and embeds, in order to count words and characters later
*/
function cleanHtml(data) {
    return data
        // remove embeds by using the comments around them. Embeds don't matter for word counters
        .replace(/<!-- EMBED START [\s\S]+?<!-- EMBED END .* -->/g, '')
        .replace(/<br[^>]*>/gi, '&nbsp;')
        .replace(/<\/?[^>]+><\/?[^>]+>/gi, ' ')
        .replace(/<\/?[^>]+>/gi, '')
        .trim()
        .replace(/&nbsp;/g, ' ');
}
exports.cleanHtml = cleanHtml;
/**
 * Removes whitespaces
 * @param data
 */
function removeWhitespaces(data) {
    if (!data) {
        return data;
    }
    return data
        .replace(/&nbsp;/g, ' ')
        .replace(/\s\s+/g, ' ')
        .trim();
}
exports.removeWhitespaces = removeWhitespaces;
/**
 * Removes whitespaces for fields
 * @param item
 */
function stripWhitespaces(item) {
    var fields = ['headline', 'slugline', 'anpa_take_key', 'sms_message', 'abstract'];
    lodash_1.default.each(fields, function (key) {
        if (angular.isDefined(item[key])) {
            item[key] = removeWhitespaces(item[key]);
        }
    });
}
exports.stripWhitespaces = stripWhitespaces;
/**
 * Check if the item has at least one style of type suggestion
 */
function itemHasUnresolvedHighlight(item, isHighlightFn) {
    return Object.keys(item[fieldsMeta_1.META_FIELD_NAME] || {})
        .map(function (contentKey) { return fieldsMeta_1.getFieldMetadata(item, contentKey, fieldsMeta_1.fieldsMetaKeys.draftjsState); })
        .filter(function (draftjsState) { return draftjsState != null; })
        .some(function (draftjsState) { return (draftjsState.blocks || [])
        .some(function (block) { return (block.inlineStyleRanges || [])
        .some(function (inlineStyleRange) { return isHighlightFn(inlineStyleRange.style); }); }); });
}
exports.itemHasUnresolvedHighlight = itemHasUnresolvedHighlight;
function itemHasUnresolvedSuggestions(item) {
    return itemHasUnresolvedHighlight(item, highlightsConfig_1.isSuggestion);
}
exports.itemHasUnresolvedSuggestions = itemHasUnresolvedSuggestions;
function itemHasUnresolvedComments(item) {
    return itemHasUnresolvedHighlight(item, highlightsConfig_1.isComment);
}
exports.itemHasUnresolvedComments = itemHasUnresolvedComments;
/**
 * Removes renditions from previously used image(s)
 * @param {object} update
 * @param {object} origItem
 */
function cutoffPreviousRenditions(update, origItem) {
    var defaultRenditions = ['original', 'baseImage', 'thumbnail', 'viewImage'];
    var updateRenditions = null;
    var origRenditions = null;
    if (!('associations' in origItem)) {
        return;
    }
    Object.keys(origItem.associations).forEach(function (key) {
        try {
            updateRenditions = update.associations[key].renditions;
            origRenditions = origItem.associations[key].renditions;
            if (updateRenditions == null || origRenditions == null) {
                return;
            }
            if (updateRenditions.original == null && origRenditions.original == null) {
                return; // external image
            }
        }
        catch (error) {
            if (error instanceof TypeError) {
                return;
            }
            throw error;
        }
        // image was changed
        if (updateRenditions.original.href !== origRenditions.original.href) {
            // walk through all renditions
            Object.keys(origRenditions).forEach(function (_key) {
                // ignore default renditions, because all images have default renditions
                if (!(_key in defaultRenditions) &&
                    _key in updateRenditions &&
                    origRenditions[_key] !== null &&
                    // image was changed, but rendition(s) still equal
                    origRenditions[_key].href === updateRenditions[_key].href) {
                    // remove rendition from previously used image
                    delete updateRenditions[_key];
                }
            });
        }
    });
}
exports.cutoffPreviousRenditions = cutoffPreviousRenditions;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
  * Global search parameters and label mapping.
 */
exports.PARAMETERS = Object.freeze({
    unique_name: 'Unique Name',
    original_creator: 'Creator',
    from_desk: 'From Desk',
    to_desk: 'To Desk',
    spike: 'Spiked',
    subject: 'Subject',
    company_codes: 'Company Codes',
    marked_desks: 'Marked Desks',
    ingest_provider: 'Provider',
    featuremedia: 'Associated Feature Media',
    subscriber: 'Subscriber',
});
/**
 * Facet field and label mapping and used when facets are removed.
 */
exports.EXCLUDE_FACETS = Object.freeze({
    notdesk: 'Not Desk',
    nottype: 'Not Type',
    notgenre: 'Not Genre',
    notcategory: 'Not Category',
    noturgency: 'Not Urgency',
    notsource: 'Not Source',
    notpriority: 'Not Priority',
    notlegal: 'Not Legal',
    notsms: 'Not Sms',
    notlanguage: 'Not Language',
});
/**
 * Default list of fields
 */
exports.DEFAULT_LIST_CONFIG = {
    priority: [
        'priority',
        'urgency',
    ],
    firstLine: [
        'wordcount',
        'slugline',
        'highlights',
        'markedDesks',
        'associations',
        'publish_queue_errors',
        'headline',
        'versioncreated',
    ],
    secondLine: [
        'profile',
        'state',
        'embargo',
        'update',
        'takekey',
        'signal',
        'broadcast',
        'flags',
        'updated',
        'category',
        'provider',
        'expiry',
        'desk',
        'fetchedDesk',
        'nestedlink',
        'associatedItems',
    ],
};
exports.DEFAULT_GRID_VIEW_FIELDS_CONFIG = [
    'source',
];
exports.DEFAULT_GRID_VIEW_FOOTER_CONFIG = {
    left: [
        'type',
        'urgency',
        'priority',
    ],
    right: [
        'state',
    ],
};
exports.DEFAULT_SWIMLANE_FIELDS_CONFIG = {
    left: [{ fields: ['urgency'] }, { fields: ['slugline', 'headline'], ellipsis: true }],
    right: [{ fields: ['versioncreated'] }],
};
/**
 * Core list of fields that has to be returned in search results
 * for core functionality to work
 */
exports.CORE_PROJECTED_FIELDS = {
    fields: [
        'highlights',
        '_created',
        '_updated',
        '_etag',
        '_type',
        'state',
        'embargo',
        'publish_schedule',
        'broadcast',
        'flags',
        'rewrite_of',
        'rewritten_by',
        'expiry',
        'task',
        'type',
        'linked_in_packages',
        'renditions',
        'item_id',
        'guid',
        '_current_version',
        'lock_action',
        'lock_user',
        'lock_session',
        'genre',
        'source',
        'language',
        'last_published_version',
        'archived',
        'associations',
        'queue_state',
        'alt_text',
        'description_text',
        'assignment_id',
        // Added in order not to lose data while drag-and-droping an image to the body | SDESK-1508
        'byline',
        'copyrightholder',
        'copyrightnotice',
        'usageterms',
        // added in order to show the list of items on spiked packages
        'groups',
        'deleted_groups',
    ],
};
/**
 * Mappings of UI fields to schema fields for projection
 */
exports.UI_PROJECTED_FIELD_MAPPINGS = {
    priority: 'priority',
    urgency: 'urgency',
    wordcount: 'word_count',
    slugline: 'slugline',
    headline: 'headline',
    profile: 'profile',
    signal: 'signal',
    takekey: 'anpa_take_key',
    update: 'correction_sequence',
    provider: 'ingest_provider',
    category: 'anpa_category',
    versioncreator: 'version_creator',
    versioncreated: 'versioncreated',
    markedDesks: 'marked_desks',
    queueError: 'error_message',
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FormFieldType;
(function (FormFieldType) {
    FormFieldType["textSingleLine"] = "textSingleLine";
    FormFieldType["textEditor3"] = "textEditor3";
    FormFieldType["vocabularySingleValue"] = "vocabularySingleValue";
    FormFieldType["checkbox"] = "checkbox";
    FormFieldType["contentFilterSingleValue"] = "contentFilterSingleValue";
    FormFieldType["deskSingleValue"] = "deskSingleValue";
    FormFieldType["stageSingleValue"] = "stage_singstageSingleValuele_value";
    FormFieldType["macroSingleValue"] = "macroSingleValue";
    FormFieldType["yesNo"] = "yesNo";
})(FormFieldType = exports.FormFieldType || (exports.FormFieldType = {}));
function isIFormField(x) {
    return x['direction'] == null;
}
exports.isIFormField = isIFormField;
function isIFormGroupCollapsible(x) {
    var keys = Object.keys(x);
    return keys.length === 2 && keys.includes('label') && keys.includes('openByDefault');
}
exports.isIFormGroupCollapsible = isIFormGroupCollapsible;
function isIFormGroup(x) {
    var keys = Object.keys(x);
    return keys.length === 3 && keys.includes('direction') && keys.includes('type') && keys.includes('form');
}
exports.isIFormGroup = isIFormGroup;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fbfa3aa187a33c6d54dca1dd558fd79c.png";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(40);
var Immutable = __webpack_require__(19);

var findRangesImmutable = __webpack_require__(109);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};

var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck(this, ContentBlock);

    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */



var invariant = __webpack_require__(17);

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

module.exports = UnicodeUtils;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
/**
 * @description Returns the key belonging to the entity that the start key of the
 * current selection is on.
 * @param {Object} editorState Editor state object.
 * @returns {string} Entity key.
 */
function getSelectedEntityKey(editorState) {
    var offset = editorState.getSelection().getStartOffset();
    return getSelectedBlock(editorState).getEntityAt(offset);
}
exports.getSelectedEntityKey = getSelectedEntityKey;
/**
 * @description Returns the entity under the cursor.
 * @param {Object} editorState Editor state object.
 * @returns {Object} Entity.
 */
function getSelectedEntity(editorState) {
    var entityKey = getSelectedEntityKey(editorState);
    var contentState = editorState.getCurrentContent();
    return entityKey !== null ? contentState.getEntity(entityKey) : null;
}
exports.getSelectedEntity = getSelectedEntity;
/**
 * @description Merge entity data of selected entity
 * @param {Object} editorState Editor state object.
 * @param {Object} data to merge.
 * @returns {Object} Editor state.
 */
function mergeSelectedEntityData(editorState, data) {
    var entityKey = getSelectedEntityKey(editorState);
    var contentState = editorState.getCurrentContent();
    return draft_js_1.EditorState.push(editorState, contentState.mergeEntityData(entityKey, data), 'change-block-data');
}
exports.mergeSelectedEntityData = mergeSelectedEntityData;
/**
 * @description Replace entity data of selected entity
 * @param {Object} editorState Editor state object.
 * @param {Object} data to merge.
 * @returns {Object} Editor state.
 */
function replaceSelectedEntityData(editorState, data) {
    var entityKey = getSelectedEntityKey(editorState);
    var contentState = editorState.getCurrentContent();
    return draft_js_1.EditorState.push(editorState, contentState.replaceEntityData(entityKey, data), 'change-block-data');
}
exports.replaceSelectedEntityData = replaceSelectedEntityData;
/**
 * @description Returns the entity type under the cursor.
 * @param {Object} editorState Editor state object.
 * @returns {string} Entity type.
 */
function getSelectedEntityType(editorState) {
    var e = getSelectedEntity(editorState);
    return e !== null ? e.getType() : null;
}
exports.getSelectedEntityType = getSelectedEntityType;
/**
 * @description Returns the entity data under the cursor.
 * @param {Object} editorState Editor state object.
 * @returns {Object} Entity data.
 */
function getSelectedEntityData(editorState) {
    var e = getSelectedEntity(editorState);
    return e !== null ? e.getData() : {};
}
exports.getSelectedEntityData = getSelectedEntityData;
/**
 * @description Returns the block that the start key of the current selection is on.
 * @param {Object} editorState Editor state object.
 * @returns {Object} Block
 */
function getSelectedBlock(editorState) {
    var startKey = editorState.getSelection().getStartKey();
    var selectedBlock = editorState
        .getCurrentContent()
        .getBlockForKey(startKey);
    return selectedBlock;
}
exports.getSelectedBlock = getSelectedBlock;
/**
 * @description Finds the selected (start key) entity and calls the given function
 * with the start and end offset of the entity within the block.
 * @param {Object} editorState Editor state object.
 * @param {Function} fn Function to call when entity range is found. Parameters of
 * function are start and end.
 */
function getSelectedEntityRange(editorState, fn) {
    var entityKey = getSelectedEntityKey(editorState);
    var selectedBlock = getSelectedBlock(editorState);
    selectedBlock.findEntityRanges(function (c) { return c.getEntity() === entityKey; }, fn);
}
exports.getSelectedEntityRange = getSelectedEntityRange;
/**
 * @description Gets the entity type of the entity located on the same spot as the
 * cursor. If offset is set, it gets the entity type offset to the cursor.
 * @param {EditorState} editorState
 * @param {Number} offset Offset to cursor. Negative is allowed.
 * @returns {string} Entity type.
 */
function getEntityTypeOffsetToCursor(editorState, offset) {
    if (offset === void 0) { offset = 0; }
    var selection = editorState.getSelection();
    var selectedBlock = getSelectedBlock(editorState);
    var focusOffset = selection.getFocusOffset();
    var targetOffset = focusOffset + offset;
    if (targetOffset < 0 || targetOffset > selectedBlock.getText().length) {
        return null;
    }
    var selectedEntityKey = selectedBlock.getEntityAt(focusOffset + offset);
    if (selectedEntityKey === null) {
        return null;
    }
    var contentState = editorState.getCurrentContent();
    var selectedEntity = contentState.getEntity(selectedEntityKey);
    return selectedEntity !== null ? selectedEntity.getType() : null;
}
exports.getEntityTypeOffsetToCursor = getEntityTypeOffsetToCursor;
/**
 * @description Gets the entity type of the entity located after (at) the cursor.
 * @param {EditorState} editorState
 * @returns {string} Entity type.
 */
function getEntityTypeAfterCursor(editorState) {
    return getEntityTypeOffsetToCursor(editorState);
}
exports.getEntityTypeAfterCursor = getEntityTypeAfterCursor;
/**
 * @description Gets the entity type of the entity located before the cursor.
 * @param {EditorState} editorState
 * @returns {string} Entity type.
 */
function getEntityTypeBeforeCursor(editorState) {
    return getEntityTypeOffsetToCursor(editorState, -1);
}
exports.getEntityTypeBeforeCursor = getEntityTypeBeforeCursor;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Content_1 = __importDefault(__webpack_require__(933));
exports.Content = Content_1.default;
var Footer_1 = __importDefault(__webpack_require__(934));
exports.Footer = Footer_1.default;
var Header_1 = __importDefault(__webpack_require__(935));
exports.Header = Header_1.default;
var Label_1 = __importDefault(__webpack_require__(435));
exports.Label = Label_1.default;
var Menu_1 = __importDefault(__webpack_require__(436));
exports.Menu = Menu_1.default;
var Popup_1 = __importDefault(__webpack_require__(936));
exports.Popup = Popup_1.default;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(446);
var defined = __webpack_require__(201);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(1010);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1226),
    getValue = __webpack_require__(1229);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(19);

var Record = Immutable.Record;


var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = function (_SelectionStateRecord) {
  _inherits(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck(this, SelectionState);

    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var blockKeys_1 = __webpack_require__(861);
exports.getBlockKeys = blockKeys_1.getBlockKeys;
var selectedBlocks_1 = __webpack_require__(862);
exports.getSelectedBlocks = selectedBlocks_1.getSelectedBlocks;
var blockInsideSelection_1 = __webpack_require__(863);
exports.blockInsideSelection = blockInsideSelection_1.blockInsideSelection;
var selectionIterator_1 = __webpack_require__(864);
exports.initSelectionIterator = selectionIterator_1.initSelectionIterator;
exports.hasNextSelection = selectionIterator_1.hasNextSelection;
var collapseSelection_1 = __webpack_require__(865);
exports.collapseSelection = collapseSelection_1.collapseSelection;
var createBlockSelection_1 = __webpack_require__(866);
exports.createBlockSelection = createBlockSelection_1.createBlockSelection;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(867);
var editor3CustomData_1 = __webpack_require__(48);
var draft_js_export_html_1 = __webpack_require__(873);
var utils_1 = __webpack_require__(419);
exports.editor3StateToHtml = function (contentState, disabled) {
    if (disabled === void 0) { disabled = []; }
    var annotationsByStyleName = editor3CustomData_1.getAnnotationsFromContentState(contentState)
        .reduce(function (accumulator, item) {
        var _a;
        return __assign({}, accumulator, (_a = {}, _a[item.styleName] = item, _a));
    }, {});
    var options = {
        inlineStyles: {
            BOLD: { element: 'b' },
            ITALIC: { element: 'i' },
            STRIKETHROUGH: { element: 's' },
            SUBSCRIPT: { element: 'sub' },
            SUPERSCRIPT: { element: 'sup' },
        },
        entityStyleFn: function (entity) {
            if (entity.getType() === 'LINK') {
                var data = entity.getData();
                if (data.url) {
                    return {
                        element: 'a',
                        attributes: { href: data.url },
                    };
                }
                else {
                    var link = data.link;
                    if (link.attachment != null) {
                        return {
                            element: 'a',
                            attributes: { 'data-attachment': link.attachment },
                        };
                    }
                    else if (link.target != null) {
                        return {
                            element: 'a',
                            attributes: { href: link.target, target: link.target },
                        };
                    }
                    else {
                        return {
                            element: 'a',
                            attributes: { href: link.href },
                        };
                    }
                }
            }
        },
        blockRenderers: {
            atomic: function (block) { return new _1.AtomicBlockParser(contentState, disabled).parse(block); },
        },
        inlineStyleFn: function (styles) {
            var annotationStyleName = styles.find(function (styleName) { return annotationsByStyleName[styleName] != null; });
            if (annotationStyleName != null) {
                return {
                    element: 'span',
                    attributes: {
                        'annotation-id': annotationsByStyleName[annotationStyleName].id,
                    },
                };
            }
        },
    };
    /*
        If an atomic block is the only content in the editor, it automatically gets line breaks around it.
        trimStartExact & trimEndExact gets rid of those line breaks.
        .trim() at the end removes whitespace.
    */
    var res = utils_1.trimStartExact(utils_1.trimEndExact(draft_js_export_html_1.stateToHTML(contentState, options), '<p><br></p>'), '<p><br></p>').trim();
    return res;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(921);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/*
 * @ngdoc React
 * @module superdesk.apps.users
 * @name UserAvatar
 * @param {string} displayName The user's display name.
 * @param {string=} pictureUrl URL of the user's avatar, if provided.
 * @description Displays the user avatar. If `pictureUrl` is provided it shows the picture
 * at that URL, otherwise it shows the initial of `displayName`.
 */
exports.UserAvatar = function (_a) {
    var displayName = _a.displayName, pictureUrl = _a.pictureUrl, rest = __rest(_a, ["displayName", "pictureUrl"]);
    return react_1.default.createElement("div", __assign({ className: "user-avatar" }, rest),
        react_1.default.createElement("figure", { className: classnames_1.default('avatar', { 'no-bg': pictureUrl }, { initials: !pictureUrl }) },
            pictureUrl && react_1.default.createElement("img", { src: pictureUrl }),
            displayName && react_1.default.createElement("span", null, displayName[0].toUpperCase())));
};
exports.UserAvatar.propTypes = {
    displayName: prop_types_1.default.string.isRequired,
    pictureUrl: prop_types_1.default.string,
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(68);
var createDesc = __webpack_require__(115);
module.exports = __webpack_require__(61) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(94);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1015), __esModule: true };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(97);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(495),
    baseKeys = __webpack_require__(1211),
    isArrayLike = __webpack_require__(501);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102),
    getRawTag = __webpack_require__(1206),
    objectToString = __webpack_require__(1207);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPropsDecorator = exports.defaultStyle = exports.EnhancerProvider = exports.createSubstyle = undefined;

var _createSubstyle = __webpack_require__(519);

var _createSubstyle2 = _interopRequireDefault(_createSubstyle);

var _defaultStyle = __webpack_require__(1304);

var _defaultStyle2 = _interopRequireDefault(_defaultStyle);

var _EnhancerProvider = __webpack_require__(1307);

var _EnhancerProvider2 = _interopRequireDefault(_EnhancerProvider);

var _defaultPropsDecorator = __webpack_require__(520);

var _defaultPropsDecorator2 = _interopRequireDefault(_defaultPropsDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createSubstyle = _createSubstyle2.default;
exports.EnhancerProvider = _EnhancerProvider2.default;
exports.defaultStyle = _defaultStyle2.default;
exports.defaultPropsDecorator = _defaultPropsDecorator2.default;
exports.default = (0, _defaultStyle2.default)();

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var tansa_1 = __webpack_require__(412);
var toolbar_1 = __webpack_require__(534);
var store_1 = __webpack_require__(157);
var spellchecker_1 = __webpack_require__(533);
var highlightsConfig_1 = __webpack_require__(46);
var draftMoveBlockWithoutDispatching_1 = __webpack_require__(538);
var draftInsertEntity_1 = __webpack_require__(536);
/**
 * @description Contains the list of editor related reducers.
 */
var editor3 = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'EDITOR_CHANGE_STATE':
            return exports.onChange(state, action.payload.editorState, action.payload.force, false, action.payload.skipOnChange);
        case 'EDITOR_SET_LOCKED':
            return setLocked(state, action.payload);
        case 'EDITOR_SET_READONLY':
            return setReadOnly(state, action.payload);
        case 'EDITOR_TAB':
            return onTab(state, action.payload);
        case 'EDITOR_FORCE_UPDATE':
            return exports.forceUpdate(state);
        case 'EDITOR_SET_ABBREVIATIONS':
            return setAbbreviations(state, action.payload);
        case 'EDITOR_DRAG_DROP':
            return dragDrop(state, action.payload);
        case 'EDITOR_SET_CELL':
            return setCell(state, action.payload);
        case 'MERGE_ENTITY_DATA_BY_KEY':
            return mergeEntityDataByKey(state, action.payload);
        case 'EDITOR_CHANGE_IMAGE_CAPTION':
            return changeImageCaption(state, action.payload);
        case 'EDITOR_SET_HTML_FROM_TANSA':
            return setHtmlFromTansa(state, action.payload);
        case 'EDITOR_MOVE_BLOCK':
            return moveBlock(state, action.payload);
        case 'EDITOR_APPLY_EMBED':
            return applyEmbed(state, action.payload);
        default:
            return state;
    }
};
/**
 * @ngdoc method
 * @name forceUpdate
 * @param {Object} editorState
 * @param {Bool} keepSelection if set to true it won't force selection
 * @return {Object}
 * @description Forces an update of the editor. This is somewhat of a hack
 * based on https://github.com/facebook/draft-js/issues/458#issuecomment-225710311
 * until a better solution is found.
 */
exports.forceUpdate = function (state, keepSelection) {
    if (keepSelection === void 0) { keepSelection = false; }
    var editorState = state.editorState, spellcheckerEnabled = state.spellcheckerEnabled;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var decorator = editorState.getDecorator(!spellcheckerEnabled);
    var newState = draft_js_1.EditorState.createWithContent(content, decorator);
    newState = draft_js_1.EditorState.set(newState, {
        undoStack: editorState.getUndoStack(),
        redoStack: editorState.getRedoStack(),
    });
    if (!keepSelection) {
        newState = draft_js_1.EditorState.forceSelection(newState, selection);
    }
    return __assign({}, state, { editorState: newState });
};
/**
 * @ngdoc method
 * @name onChange
 * @param {Object} state
 * @param {Object} editorState
 * @param {Bool} force When true, forces an editor update regardless of whether the content has changed.
 * This is used because currently it is impossible to detect changes happening solely on entity data.
 * In Draft v0.11.0 we will be able to request all entities from the content and could compare them to get a
 * more accurate result.
 * See https://draftjs.org/docs/api-reference-content-state.html#getentitymap"
 * @param {Bool} keepSelection keep selection as it is
 * @return {Object} returns new state
 * @description Handle the editor state has been changed event
 */
exports.onChange = function (state, newState, force, keepSelection, skipOnChange) {
    if (force === void 0) { force = false; }
    if (keepSelection === void 0) { keepSelection = false; }
    if (skipOnChange === void 0) { skipOnChange = false; }
    // TODO(x): Remove `force` once Draft v0.11.0 is in
    var editorState = newState;
    var contentChanged = state.editorState.getCurrentContent() !== newState.getCurrentContent();
    if (!skipOnChange && (contentChanged || force)) {
        var plainText = store_1.isEditorPlainText(state);
        state.onChangeValue(editorState.getCurrentContent(), { plainText: plainText });
    }
    if (force) {
        return exports.forceUpdate(applyAbbreviations(__assign({}, state, { editorState: editorState })), keepSelection);
    }
    return applyAbbreviations(__assign({}, state, { editorState: editorState }));
};
/**
 * @ngdoc method
 * @name setAbbreviations
 * @param {Object} state
 * @param {Object} abbreviations
 * @return {Object} returns new state
 * @description Set the abbreviations dictionary
 */
var setAbbreviations = function (state, abbreviations) { return (__assign({}, state, { abbreviations: abbreviations })); };
/**
 * @ngdoc method
 * @name applyAbbreviations
 * @param {Object} editorState
 * @param {Array} abbreviations
 * @return {Object} returns new state
 * @description Handle the editor tab key pressed event
 */
var applyAbbreviations = function (state) {
    var editorState = state.editorState, abbreviations = state.abbreviations;
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || abbreviations == null || Object.keys(abbreviations).length === 0) {
        return state;
    }
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    var word = getAbbreviationText(block, selection.getStartOffset());
    if (word == null) {
        return state;
    }
    var keys = Object.keys(abbreviations);
    var pattern = '\\b(' + keys.map(function (item) { return escapeRegExp(item); }).join('|') + ')(\\*)';
    var found = word.text.match(new RegExp(pattern, 'g'));
    if (found) {
        var abbreviation = found[0].replace('*', '');
        var newWord = abbreviations[abbreviation];
        return spellchecker_1.replaceWord(state, { word: word, newWord: newWord }, true);
    }
    return state;
};
/**
 * @ngdoc method
 * @name getAbbreviationText
 * @param {Object} block
 * @param {Integer} offset
 * @return {String} returns text that can contain abbreviation
 * @description From current position extract text that is
 * delimited on both sides by space, round brackets or delete suggestion
 */
var getAbbreviationText = function (block, offset) {
    var text = block.getText();
    var length = block.getLength();
    var start = offset;
    var end = offset;
    if (!text.includes('*')) {
        return null;
    }
    while (start > 0 && text[start - 1] !== ' ' && text[start - 1] !== '(' && text[start - 1] !== ')') {
        var inlineStyles = block.getInlineStyleAt(start - 1);
        if (inlineStyles.some(function (style) { return style.startsWith(highlightsConfig_1.DELETE_SUGGESTION); })) {
            break;
        }
        start--;
    }
    while (end < length && text[end] !== ' ' && text[end] !== '(' && text[end] !== ')') {
        var inlineStyles = block.getInlineStyleAt(end);
        if (inlineStyles.some(function (style) { return style.startsWith(highlightsConfig_1.DELETE_SUGGESTION); })) {
            break;
        }
        end++;
    }
    var textWithAbbreviation = text.substring(start, end);
    if (!textWithAbbreviation.includes('*')) {
        return null;
    }
    return { text: textWithAbbreviation, offset: start };
};
/**
 * Escape given string for reg exp
 *
 * @url https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
 *
 * @param {string} string
 * @return {string}
 */
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
/**
 * @ngdoc method
 * @name onTab
 * @param {Object} event
 * @return {Object} returns new state
 * @description Handle the editor tab key pressed event
 */
var onTab = function (state, e) {
    var editorState = state.editorState;
    var newState = draft_js_1.RichUtils.onTab(e, editorState, 4);
    return exports.onChange(state, newState);
};
/**
 * @ngdoc method
 * @name dragDrop
 * @param {String} data event data
 * @return {Object} New state
 * @description Handles the dragdrop event over the editor.
 */
var dragDrop = function (state, _a) {
    var data = _a.data, blockKey = _a.blockKey;
    var media = JSON.parse(data);
    var editorState = toolbar_1.addMedia(state.editorState, media, blockKey);
    return exports.onChange(state, editorState);
};
/**
 * @ngdoc method
 * @name setLocked
 * @param {Boolean=} locked If true, editor is locked (read-only).
 * @return {Object} New state
 * @description Handles setting the editor as active, or read-only.
 */
var setLocked = function (state, locked) {
    if (locked === void 0) { locked = true; }
    var activeCell = state.activeCell;
    if (!locked) {
        activeCell = null;
    }
    return __assign({}, state, { locked: locked, activeCell: activeCell });
};
/**
 * @ngdoc method
 * @name setReadOnly
 * @param {Boolean=} locked If true, editor is set to read-only.
 * @return {Object} New state
 * @description Handles setting the editor as active, or read-only.
 */
var setReadOnly = function (state, readOnly) { return (__assign({}, state, { readOnly: readOnly, activeCell: null })); };
/**
 * @ngdoc method
 * @name setCell
 * @param {Object} ijK Contains active block key, row (i) and col (j).
 * @return {Object} New state
 * @description Sets the currently being edited (active) table cell.
 */
var setCell = function (state, _a) {
    var i = _a.i, j = _a.j, key = _a.key, currentStyle = _a.currentStyle, selection = _a.selection;
    return (__assign({}, state, { locked: true, activeCell: { i: i, j: j, key: key, currentStyle: currentStyle, selection: selection } }));
};
var mergeEntityDataByKey = function (state, _a) {
    var blockKey = _a.blockKey, entityKey = _a.entityKey, valuesToMerge = _a.valuesToMerge;
    var editorState = state.editorState;
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityDataHasChanged = true;
    var newContentState = contentState.mergeEntityData(entityKey, valuesToMerge);
    var newBlockKey = newContentState.getKeyAfter(blockKey) || blockKey;
    var newBlock = newContentState.getBlockBefore(blockKey);
    var newSelection = selection.merge({
        anchorOffset: newBlock != null ? newBlock.getLength() : null,
        anchorKey: newBlock != null ? newBlock.getKey() : newBlockKey,
        focusOffset: newBlock != null ? newBlock.getLength() : null,
        focusKey: newBlock != null ? newBlock.getKey() : newBlockKey,
        isBackward: false,
        hasFocus: true,
    });
    var newEditorState = draft_js_1.EditorState.push(editorState, newContentState, 'change-block-data');
    newEditorState = draft_js_1.EditorState.forceSelection(newEditorState, newSelection);
    return exports.onChange(state, newEditorState, entityDataHasChanged, true);
};
/**
 * @ngdoc method
 * @name setCell
 * @param {string} entityKey
 * @param {string} changeImageCaption
 * @return {Object} New state
 * @description Sets a new caption for the image at entityKey.
 */
var changeImageCaption = function (state, _a) {
    var entityKey = _a.entityKey, newCaption = _a.newCaption, field = _a.field;
    var editorState = state.editorState;
    var contentState = editorState.getCurrentContent();
    var entity = contentState.getEntity(entityKey);
    var media = entity.getData().media;
    if (field === 'Title') {
        media.headline = newCaption;
    }
    else {
        media.description_text = newCaption;
    }
    var newContentState = contentState.replaceEntityData(entityKey, { media: media });
    var newEditorState = draft_js_1.EditorState.push(editorState, newContentState, 'change-block-data');
    var entityDataHasChanged = true;
    return exports.onChange(state, newEditorState, entityDataHasChanged, true);
};
/**
 * @ngdoc method
 * @name setHtmlForTansa
 * @param {string} html
 * @param {string} simpleReplace
 * @description Replaces the current editor content with the given HTML. This is used
 * by the Tansa spellchecker to apply a corrected text.
 * If the simpleReplace is true try to preserve the existing inline styles and entities
 * @returns {Object}
 */
var setHtmlFromTansa = function (state, _a) {
    var html = _a.html, simpleReplace = _a.simpleReplace;
    var editorState = state.editorState;
    var newEditorState = tansa_1.setTansaHtml(editorState, html, simpleReplace);
    return exports.onChange(state, newEditorState);
};
/**
 * Move atomic block
 *
 * @param {Object} state
 * @param {Object} options
 *                 block
 *                 dest
 *                 insertionMode before|after
 * @return {Object}
 */
function moveBlock(state, options) {
    var stateWithMovedBlock = draftMoveBlockWithoutDispatching_1.moveBlockWithoutDispatching(state, options);
    return exports.onChange(state, stateWithMovedBlock.editorState);
}
exports.moveBlock = moveBlock;
/**
 * @ngdoc method
 * @name applyEmbed
 * @param {Object|string} data oEmbed data, HTML string.
 * @description Applies the embed in the given oEmbed data to the active block.
 */
var applyEmbed = function (state, _a) {
    var code = _a.code, targetBlockKey = _a.targetBlockKey;
    var data = typeof code === 'string' ? { html: code } : code;
    var nextEditorState = draftInsertEntity_1.insertEntity(state.editorState, 'EMBED', 'MUTABLE', { data: data }, targetBlockKey);
    return exports.onChange(state, nextEditorState);
};
exports.default = editor3;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
function getSelectSingleValue(getItems, itemsUnavailableMessage, getDependentFields) {
    return /** @class */ (function (_super) {
        __extends(SelectSingleValue, _super);
        function SelectSingleValue(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                items: null,
            };
            _this.initialValue = props.value;
            _this.dependentFields = typeof getDependentFields === 'function'
                ? getDependentFields(props)
                : [];
            _this.fetchData = _this.fetchData.bind(_this);
            return _this;
        }
        SelectSingleValue.prototype.fetchData = function () {
            var _this = this;
            getItems(this.props)
                .then(function (items) {
                _this.setState({ items: items });
            });
        };
        SelectSingleValue.prototype.componentDidMount = function () {
            this.fetchData();
        };
        SelectSingleValue.prototype.componentDidUpdate = function (prevProps) {
            var _this = this;
            if (this.dependentFields.some(function (field) { return prevProps.formValues[field] !== _this.props.formValues[field]; })) {
                this.props.onChange(this.initialValue); // resetting the value since dependent field changed
                this.fetchData();
            }
        };
        SelectSingleValue.prototype.render = function () {
            var _this = this;
            if (this.props.previewOutput) {
                if (this.state.items == null) {
                    return null; // loading
                }
                else {
                    var item = this.state.items.find(function (_a) {
                        var id = _a.id;
                        return id === _this.props.value;
                    });
                    return item == null ? react_1.default.createElement("div", null, this.props.value) : react_1.default.createElement("div", null, item.label);
                }
            }
            var getFirstItemMessage = function () {
                if (_this.state.items == null) {
                    return itemsUnavailableMessage != null ? itemsUnavailableMessage : '';
                }
                else if (_this.state.items.length < 1) {
                    return gettext('No items available');
                }
                else {
                    return '';
                }
            };
            return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
                    'sd-line-input--invalid': this.props.issues.length > 0,
                    'sd-line-input--required': this.props.formField.required === true,
                }) },
                react_1.default.createElement("label", { className: "sd-line-input__label" }, this.props.formField.label),
                react_1.default.createElement("select", { disabled: this.props.disabled || this.state.items == null || this.state.items.length < 1, value: this.props.value || '', className: "sd-line-input__select", onChange: function (event) {
                        _this.props.onChange(event.target.value === '' ? _this.initialValue : event.target.value);
                    }, "data-test-id": "gform-input--" + this.props.formField.field },
                    react_1.default.createElement("option", { value: "" }, getFirstItemMessage()),
                    this.state.items == null
                        ? null
                        : this.state.items.map(function (_a, i) {
                            var id = _a.id, label = _a.label;
                            return (react_1.default.createElement("option", { key: i, value: id }, label));
                        })),
                this.props.issues.map(function (str, i) { return (react_1.default.createElement("div", { key: i, className: "sd-line-input__message" }, str)); })));
        };
        return SelectSingleValue;
    }(react_1.default.Component));
}
exports.getSelectSingleValue = getSelectSingleValue;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f7f36aed53d755bd988a6ec6a434cf9b.gif";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * @format
 * 
 */



var Immutable = __webpack_require__(19);

var OrderedMap = Immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

module.exports = BlockMapBuilder;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */



/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var immutable_1 = __webpack_require__(51);
var LinkDecorator_1 = __webpack_require__(411);
var selection_1 = __webpack_require__(87);
/**
 * @ngdoc method
 * @name getCell
 * @param {Array} cells The array of cells in the table
 * @param {Number} row The row of the cell in the table
 * @param {Number} col The column of the cell in the table
 * @description Retrieves the content state of the cell at row/col.
 */
function getCell(data, row, col, currentStyle, selection) {
    var decorator = new draft_js_1.CompositeDecorator([LinkDecorator_1.LinkDecorator]);
    var cells = data.cells;
    var cellEditorState;
    if (!cells[row] || !cells[row][col]) {
        cellEditorState = draft_js_1.EditorState.createWithContent(draft_js_1.ContentState.createFromText(''), decorator);
    }
    else {
        cellEditorState = draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(cells[row][col]), decorator);
    }
    if (selection != null) {
        var anchorKey = selection.anchorKey, focusKey = selection.focusKey;
        var cellContentState = cellEditorState.getCurrentContent();
        var anchorBlock = cellContentState.getBlockForKey(anchorKey);
        var focusBlock = cellContentState.getBlockForKey(focusKey);
        if (anchorBlock != null && focusBlock != null) {
            var newSelection = cellEditorState
                .getSelection()
                .merge(__assign({}, selection));
            cellEditorState = draft_js_1.EditorState.forceSelection(cellEditorState, newSelection);
        }
    }
    if (currentStyle != null) {
        cellEditorState = draft_js_1.EditorState.setInlineStyleOverride(cellEditorState, immutable_1.OrderedSet(currentStyle));
    }
    return cellEditorState;
}
exports.getCell = getCell;
/**
 * @ngdoc method
 * @name TableBlockComponent#setCell
 * @param {Number} row The row of the cell in the table
 * @param {Number} col The column of the cell in the table
 * @param {Object} cellContentState The state of the editor within the cell
 * @description Updates data about this cell inside the entity for this atomic
 * block.
 */
function setCell(data, row, col, cellEditorState) {
    var cellContentState = cellEditorState.getCurrentContent();
    var needUpdate = true;
    var forceUpdate = true;
    if (!data.cells[row]) {
        data.cells[row] = [];
    }
    if (data.cells[row][col]) {
        needUpdate =
            JSON.stringify(data.cells[row][col]) !==
                JSON.stringify(draft_js_1.convertToRaw(cellContentState));
        forceUpdate =
            draft_js_1.convertFromRaw(data.cells[row][col]).getPlainText() !==
                cellContentState.getPlainText();
    }
    data.cells[row][col] = draft_js_1.convertToRaw(cellContentState);
    return { data: data, needUpdate: needUpdate, forceUpdate: forceUpdate };
}
exports.setCell = setCell;
/**
 * @ngdoc method
 * @name getData
 * @param {Object} contentState The editor content state
 * @param {String} blockKey The current atomic block key
 * @description Returns the data contained in the entity of this atomic block.
 * @return {Object}
 */
function getData(contentState, blockKey) {
    var block = contentState.getBlockForKey(blockKey);
    var entityKey = block.getEntityAt(0);
    var data = contentState.getEntity(entityKey).getData().data;
    var blockData = block.getData().get('data');
    if (!blockData && data) {
        return data;
    }
    return JSON.parse(blockData);
}
exports.getData = getData;
/**
 * @ngdoc method
 * @name setData
 * @param {Object} contentState The editor content state
 * @param {Object} block The current atomic block
 * @description Returns EditorState with the data contained in the entity of this atomic block.
 * @return {Object}
 */
function setData(editorState, block, data, lastChangeType) {
    var contentState = editorState.getCurrentContent();
    var selection = selection_1.createBlockSelection(editorState, block);
    var newContentState = setDataForContent(contentState, selection, block, data);
    var newEditorState = draft_js_1.EditorState.push(editorState, newContentState, lastChangeType);
    return newEditorState;
}
exports.setData = setData;
/**
 * @ngdoc method
 * @name setDataForContent
 * @param {Object} contentState The editor content state
 * @param {Object} block The current atomic block
 * @description Returns ContentState with the data contained in the entity of this atomic block.
 * @return {Object}
 */
function setDataForContent(contentState, selection, block, data) {
    var entityKey = block.getEntityAt(0);
    var newContentState = draft_js_1.Modifier.setBlockData(contentState, selection, immutable_1.Map().set('data', JSON.stringify(data)));
    newContentState.replaceEntityData(entityKey, { data: data });
    return newContentState;
}
exports.setDataForContent = setDataForContent;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
/**
 * @type {Object}
 * @description Maps server 'editorFormat' options to Draft inline styles.
 */
exports.inlineStyles = {
    bold: 'BOLD',
    italic: 'ITALIC',
    underline: 'UNDERLINE',
    subscript: 'SUBSCRIPT',
    superscript: 'SUPERSCRIPT',
    strikethrough: 'STRIKETHROUGH',
};
exports.acceptedInlineStyles = Object.values(exports.inlineStyles);
/**
 * Sanitize given content state on paste
 *
 * @param {ContentState} content
 * @param {Array} inlineStyles
 * @returns {ContentState}
 */
function sanitizeContent(editorState, styles) {
    if (styles === void 0) { styles = exports.acceptedInlineStyles; }
    var contentState = editorState.getCurrentContent();
    var ignoreStyle = function (style) { return styles.indexOf(style) === -1; };
    var getSelection = function (block, start, end) { return draft_js_1.SelectionState.createEmpty(block.getKey()).merge({
        anchorOffset: start,
        focusOffset: end,
    }); };
    var nextEditorState = editorState;
    contentState.getBlockMap().forEach(function (block) {
        // remove extra styles
        block.findStyleRanges(function (character) { return character.getStyle().some(ignoreStyle); }, function (start, end) {
            var selection = getSelection(block, start, end);
            var inlineStyle = block.getInlineStyleAt(start).find(ignoreStyle);
            contentState = draft_js_1.Modifier.removeInlineStyle(contentState, selection, inlineStyle);
        });
    });
    nextEditorState = draft_js_1.EditorState.push(nextEditorState, contentState, 'change-inline-style');
    nextEditorState = draft_js_1.EditorState.push(nextEditorState, contentState, 'apply-entity');
    return nextEditorState;
}
exports.sanitizeContent = sanitizeContent;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(964);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(445);
var enumBugKeys = __webpack_require__(205);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(201);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(49);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('btn', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(461));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1026));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1028));

var _removeStyle = _interopRequireDefault(__webpack_require__(1029));

var _properties = __webpack_require__(214);

var _isTransform = _interopRequireDefault(__webpack_require__(1030));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 122 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(506),
    baseAssignValue = __webpack_require__(507);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(51);
var docs_soap_1 = __importDefault(__webpack_require__(1318));
var draft_js_1 = __webpack_require__(16);
/**
 * @ngdoc class
 * @name HTMLParser
 * @description HTMLParser is a class that takes HTML and returns a ContentState. At
 * its simplest form, it uses `convertFromHTML` from draft-js to do this operation.
 *
 * To make it compatible with Editor3, it additionally processes Editor3 atomic blocks,
 * such as tables, images and embeds. To process these blocks, which `convertFromHTML`
 * doesn't do, it simply extracts the nodes from the HTML before processing it, and saves
 * them in a separate structure, replacing the nodes with <figure> tags that contain text
 * indicating in which structure and at which position the information was saved.
 *
 * Afterwards, it traverses the returned blocks, looking for atomic blocks. When an atomic
 * block is found, it reads its text, and if it indicates one of the saved structures along
 * with an ID, it creates the needed block.
 *
 * This "small hack" allows us to use a reliable HTML convertor provided by DraftJS, as
 * well as accommodate Editor3 custom atomic blocks.
 */
var HTMLParser = /** @class */ (function () {
    function HTMLParser(html, associations) {
        this.iframes = {};
        this.scripts = {};
        this.figures = {};
        this.tables = {};
        this.media = {};
        this.associations = associations;
        this.tree = $('<div></div>');
        this.createTree(html);
    }
    /**
     * @name HTMLParser#createTree
     * @param {string} html
     * @description Takes the given HTML, extracts the atomic blocks, and creates
     * the tree to be parsed by the DraftJS's convertor.
     */
    HTMLParser.prototype.createTree = function (html) {
        var _html = docs_soap_1.default.default(html); // Needed for Google docs
        this.tree.html(_html);
        this.pruneNodes();
    };
    /**
     * @name HTMLParser#pruneNodes
     * @description Replaces the nodes that need to be converted to atomic blocks
     * with <figure> tags containing text indicating the type of block that is needed
     * there, along with an ID. The ID links to a structure that stores information
     * about the HTML that was extracted.
     */
    HTMLParser.prototype.pruneNodes = function () {
        var _this = this;
        this.tree.find('iframe').each(function (i, node) {
            _this.iframes[i] = node.outerHTML;
            $(node).replaceWith("<figure>BLOCK_IFRAME_" + i + "</figure>");
        });
        this.tree.find('script').each(function (i, node) {
            _this.scripts[i] = node.outerHTML;
            $(node).replaceWith("<figure>BLOCK_SCRIPT_" + i + "</figure>");
        });
        this.tree.find('figure').each(function (i, node) {
            if (node.innerText.startsWith('BLOCK_')) {
                // iframe or script
                return;
            }
            if (node.querySelector('img, video') != null) {
                try {
                    // editor2 media support
                    var lineAfterFigureClosingTag = node.parentElement.innerHTML.slice(node.parentElement.innerHTML.indexOf(node.outerHTML) + node.outerHTML.length + 1).match(/.+\n/)[0];
                    var embedId = lineAfterFigureClosingTag
                        .match(/<!-- EMBED END (?:Image|Video) {id: "([a-z0-9]*?)"} -->/)[1];
                    $(node).replaceWith("<figure>BLOCK_MEDIA_" + i + "</figure>");
                    _this.media[i] = {
                        media: _this.associations[embedId],
                    };
                    return;
                }
                catch (e) {
                    // continue
                }
            }
            // assume embed
            _this.figures[i] = $(node).html();
            $(node).replaceWith("<figure>BLOCK_FIGURE_" + i + "></figure>");
        });
        this.tree.find('table').each(function (i, node) {
            _this.tables[i] = $(node).html();
            $(node).replaceWith("<figure>BLOCK_TABLE_" + i + "</figure>");
        });
        this.tree.find('.media-block').each(function (i, node) {
            _this.media[i] = $(node)[0].outerHTML;
            $(node).replaceWith("<figure>BLOCK_MEDIA_" + i + "</figure>");
        });
        // import external media as embeds
        this.tree.find('img, audio, video').each(function (i, node) {
            _this.figures[i] = node.outerHTML;
            $(node).replaceWith("<figure>BLOCK_FIGURE_" + i + "</figure>");
        });
    };
    /**
     * @name HTMLParser#contentState
     * @description Returns the full content state corresponding to the HTML that
     * initialized the instance.
     * @returns {ContentState} contentState
     */
    HTMLParser.prototype.contentState = function () {
        var processBlock = this.processBlock.bind(this);
        var conversionResult = draft_js_1.convertFromHTML(this.tree.html());
        var contentState = draft_js_1.ContentState.createFromBlockArray(conversionResult.contentBlocks, conversionResult.entityMap);
        contentState = this.processLinks(contentState);
        return draft_js_1.ContentState.createFromBlockArray(contentState.getBlocksAsArray().map(processBlock), contentState.getEntityMap());
    };
    /**
     * Convert link entity data to editor3 format
     *
     * @param {ContentState} initialState
     * @returns {ContentState}
     */
    HTMLParser.prototype.processLinks = function (initialState) {
        var contentState = initialState;
        contentState.getBlocksAsArray().forEach(function (block) {
            block.findEntityRanges(function (characterMetadata) { return characterMetadata.getEntity(); }, function (start, end) {
                var key = block.getEntityAt(start);
                if (key != null) {
                    var entity = contentState.getEntity(key);
                    if (entity.type === 'LINK') {
                        contentState = contentState.replaceEntityData(key, {
                            link: { href: entity.getData().url },
                        });
                    }
                }
            });
        });
        return contentState;
    };
    /**
     * @name HTMLParser#processBlock
     * @param {ContentBlock} block
     * @description Processes the given block. If it's an atomic block that has text
     * indicating the ID of a pruned node, it returns the new corresponding block.
     * @returns {ContentBlock} New block.
     */
    HTMLParser.prototype.processBlock = function (block) {
        var isAtomic = block.getType() === 'atomic';
        var isTable = block.getText().startsWith('BLOCK_TABLE_');
        var isMedia = block.getText().startsWith('BLOCK_MEDIA_');
        var isFigure = block.getText().startsWith('BLOCK_FIGURE_');
        var isIframe = block.getText().startsWith('BLOCK_IFRAME_');
        var isScript = block.getText().startsWith('BLOCK_SCRIPT_');
        if (isAtomic && isTable) {
            return this.createTableBlock(block);
        }
        if (isAtomic && isMedia) {
            return this.createMediaBlock(block);
        }
        if (isAtomic && isFigure) {
            return this.createFigureBlock(block);
        }
        if (isAtomic && isIframe) {
            return this.createEmbedBlock(block, this.iframes);
        }
        if (isAtomic && isScript) {
            return this.createEmbedBlock(block, this.scripts);
        }
        return block;
    };
    /**
     * Create atomic block for embeds
     *
     * @param {ContentBlock} block
     * @returns {ContentBlock}
     */
    HTMLParser.prototype.createFigureBlock = function (block) {
        var id = this.getBlockId(block);
        var htmlElement = document.createElement('div');
        htmlElement.innerHTML = this.figures[id];
        // capturing description from editor2
        var descriptionElement = htmlElement.querySelector('figcaption');
        var descriptionText = descriptionElement != null ? descriptionElement.innerText : '';
        if (descriptionElement != null) {
            descriptionElement.remove();
        }
        return atomicBlock(block, 'EMBED', 'MUTABLE', {
            data: { html: htmlElement.innerHTML },
            description: descriptionText,
        });
    };
    /**
     * Create atomic block for embeds
     *
     * @param {ContentBlock} block
     * @returns {ContentBlock}
     */
    HTMLParser.prototype.createEmbedBlock = function (block, items) {
        var id = this.getBlockId(block);
        var htmlElement = document.createElement('div');
        htmlElement.innerHTML = items[id];
        return atomicBlock(block, 'EMBED', 'MUTABLE', {
            data: { html: htmlElement.innerHTML },
        });
    };
    /**
     * @name HTMLParser#createTableBlock
     * @param {ContentBlock} block
     * @description Takes an unprocessed atomic block (that is assumed to be a
     * soon-to-be table block) and processes it.
     * @returns {ContentBlock} The fully restored table block.
     */
    HTMLParser.prototype.createTableBlock = function (block) {
        var id = this.getBlockId(block);
        var tableHTML = this.tables[id];
        var tableNode = $('<table></table>');
        tableNode.html(tableHTML);
        var rows = tableNode.find('tr');
        var numRows = rows.length;
        var numCols = rows.first().find('th,td').length;
        var cells = [];
        for (var i = 0; i < numRows; i++) {
            for (var j = 0; j < numCols; j++) {
                var row = $(rows[i]);
                var col = $(row.find('th,td')[j]);
                var _a = draft_js_1.convertFromHTML(col.html()), contentBlocks = _a.contentBlocks, entityMap = _a.entityMap;
                var cellContentState = draft_js_1.ContentState.createFromBlockArray(contentBlocks, entityMap);
                cells[i] = cells[i] || [];
                cells[i][j] = draft_js_1.convertToRaw(cellContentState);
            }
        }
        return atomicBlock(block, 'TABLE', 'MUTABLE', { data: { numRows: numRows, numCols: numCols, cells: cells } });
    };
    /**
     * Get block id from block text
     *
     * @param {ContentBlock} block
     * @returns {number}
     */
    HTMLParser.prototype.getBlockId = function (block) {
        return parseInt(block.getText()
            .split('_')
            .pop(), 10);
    };
    /**
     * @name HTMLParser#createMediaBlock
     * @param {ContentBlock} block
     * @description Takes an unprocessed atomic block (that is assumed to be a
     * an media block) and processes it.
     * @returns {ContentBlock} The restored image block.
     */
    HTMLParser.prototype.createMediaBlock = function (block) {
        var id = this.getBlockId(block);
        var mediaJson = this.media[id];
        return atomicBlock(block, 'MEDIA', 'MUTABLE', mediaJson);
    };
    return HTMLParser;
}());
/**
 * @param {string} html
 * @param {Object} associations (optional)
 */
function getContentStateFromHtml(html, associations) {
    if (associations === void 0) { associations = null; }
    return new HTMLParser(html, associations).contentState();
}
exports.getContentStateFromHtml = getContentStateFromHtml;
/**
 * @name atomicBlock
 * @param {Object} block The block to copy
 * @param {string} entityType
 * @param {string} entityMutability Mutability type (MUTABLE, IMMUTABLE).
 * @param {Object} entityData
 * @description Returns the given block, having its text replaced by one space that
 * has the corresponding character metadata linked to the given entity.
 * @returns {Object} The new atomic block.
 */
function atomicBlock(block, entityType, entityMutability, entityData) {
    // TODO(gbbr): Will not work with DraftJS 0.11
    var entityKey = draft_js_1.Entity.create(entityType, entityMutability, entityData);
    var text = ' ';
    var _a = block.toJS(), type = _a.type, key = _a.key, depth = _a.depth;
    var data = immutable_1.fromJS(block.toJS().data);
    var char = draft_js_1.CharacterMetadata.create({
        style: immutable_1.OrderedSet([]),
        entity: entityKey,
    });
    var characterList = immutable_1.List([char]);
    return new draft_js_1.ContentBlock({ type: type, key: key, depth: depth, data: data, text: text, characterList: characterList });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var ui_1 = __webpack_require__(148);
exports.INIT_ATTACHMENTS = 'INIT_ATTACHMENTS';
function initAttachments(item) {
    return function (dispatch, geState, _a) {
        var deployConfig = _a.deployConfig, attachments = _a.attachments;
        attachments.byItem(item)
            .then(function (files) {
            dispatch({
                type: exports.INIT_ATTACHMENTS,
                payload: {
                    files: files,
                    maxSize: deployConfig.getSync('attachments_max_size'),
                    maxFiles: deployConfig.getSync('attachments_max_files'),
                },
            });
        });
    };
}
exports.initAttachments = initAttachments;
exports.ADD_ATTACHMENTS = 'ADD_ATTACHMENTS';
function selectFiles(files) {
    return function (dispatch, getState, _a) {
        var notify = _a.notify, superdesk = _a.superdesk;
        var state = getState();
        if (Array.isArray(files) && files.length > 0 && !state.editor.isLocked) {
            if (files.length + state.attachments.files.length > state.attachments.maxFiles) {
                notify.error(utils_1.gettextCatalog.getPlural(state.attachments.maxFiles, 'Too many files selected. Only 1 file is allowed.', 'Too many files selected. Only {{$count}} files are allowed.'));
                return;
            }
            var filenames = files.filter(function (file) { return file.size > state.attachments.maxSize; })
                .map(function (file) { return file.name; });
            if (filenames.length) {
                notify.error(utils_1.gettext('Sorry, but some files "{{filenames}}" are bigger than limit ({{limit}}).', {
                    filenames: filenames.join(', '),
                    limit: ui_1.filesize(state.attachments.maxSize),
                }));
                return;
            }
            superdesk
                .intent('upload', 'attachments', files)
                .then(function (uploadedFiles) {
                dispatch({ type: exports.ADD_ATTACHMENTS, payload: uploadedFiles });
            });
        }
    };
}
exports.selectFiles = selectFiles;
exports.REMOVE_ATTACHMENT = 'REMOVE_ATTACHMENT';
function removeFile(file) {
    return { type: exports.REMOVE_ATTACHMENT, payload: file };
}
exports.removeFile = removeFile;
exports.OPEN_ATTACHMENT_FOR_EDITING = 'OPEN_ATTACHMENT_FOR_EDITING';
function editFile(file) {
    return { type: exports.OPEN_ATTACHMENT_FOR_EDITING, payload: file };
}
exports.editFile = editFile;
exports.UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT';
function saveFile(file, diff) {
    return function (dispatch, getState, _a) {
        var attachments = _a.attachments;
        attachments.save(file, diff).then(function (updated) {
            dispatch({ type: exports.UPDATE_ATTACHMENT, payload: updated });
            dispatch(closeEdit());
        });
    };
}
exports.saveFile = saveFile;
exports.CLOSE_ATTACHMENT_EDITOR = 'CLOSE_ATTACHMENT_EDITOR';
function closeEdit() {
    return { type: exports.CLOSE_ATTACHMENT_EDITOR };
}
exports.closeEdit = closeEdit;
function download(file) {
    return function (dispatch, getState, _a) {
        var urls = _a.urls;
        window.open(urls.media(file.media, 'attachments'), '_blank');
    };
}
exports.download = download;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var before1MonthFilter = {
    key: 'before_next_month',
    label: utils_1.gettext('Next Month'),
    elasticSearchDateRange: {
        lte: 'now+1M/d',
    },
};
var before3MonthsFilter = {
    key: 'before_3_months_ahead',
    label: utils_1.gettext('Next 3 Months'),
    elasticSearchDateRange: {
        lte: 'now+3M/d',
    },
};
var last30daysFilter = {
    key: 'last_30_days',
    label: utils_1.gettext('Last 30 Days'),
    elasticSearchDateRange: {
        gte: 'now-30d',
    },
};
var last7daysFilter = {
    key: 'last_7_days',
    label: utils_1.gettext('Last 7 Days'),
    elasticSearchDateRange: {
        gte: 'now-7d',
    },
};
var last24hoursFilter = {
    key: 'last_24_hours',
    label: utils_1.gettext('Last 24 Hours'),
    elasticSearchDateRange: {
        gte: 'now-24H',
    },
};
var last8hoursFilter = {
    key: 'last_8_hours',
    label: utils_1.gettext('Last 8 Hours'),
    elasticSearchDateRange: {
        gte: 'now-8H',
    },
};
exports.dateRangesByKey = {
    before_next_month: before1MonthFilter,
    before_3_months_ahead: before3MonthsFilter,
    last_30_days: last30daysFilter,
    last_7_days: last7daysFilter,
    last_24_hours: last24hoursFilter,
    last_8_hours: last8hoursFilter,
};
exports.getDateFilters = function () { return [
    {
        labelBlock: utils_1.gettext('Date created'),
        labelFrom: utils_1.gettext('Created from'),
        labelTo: utils_1.gettext('Created to'),
        fieldname: 'firstcreated',
        predefinedFilters: [last24hoursFilter, last7daysFilter, last30daysFilter],
        isEnabled: function () { return true; },
    },
    {
        labelBlock: utils_1.gettext('Date modified'),
        labelFrom: utils_1.gettext('Modified from'),
        labelTo: utils_1.gettext('Modified to'),
        fieldname: 'versioncreated',
        predefinedFilters: [last24hoursFilter, last7daysFilter, last30daysFilter],
        isEnabled: function () { return true; },
    },
    {
        labelBlock: utils_1.gettext('Date published'),
        labelFrom: utils_1.gettext('Published from'),
        labelTo: utils_1.gettext('Published to'),
        fieldname: 'firstpublished',
        predefinedFilters: [last24hoursFilter, last7daysFilter, last30daysFilter],
        isEnabled: function () { return true; },
    },
    {
        labelBlock: utils_1.gettext('Date scheduled'),
        labelFrom: null,
        labelTo: null,
        fieldname: 'schedule_settings.utc_publish_schedule',
        predefinedFilters: [last24hoursFilter, last8hoursFilter],
        isEnabled: function (searchConfig) { return searchConfig.scheduled; },
    },
]; };
var elasticSearchDateRangeToFieldNames = function (elasticSearchDateRange, baseFieldName) {
    var result = {};
    if (elasticSearchDateRange.gte != null) {
        result[baseFieldName + 'from'] = elasticSearchDateRange.gte;
    }
    if (elasticSearchDateRange.lte != null) {
        result[baseFieldName + 'to'] = elasticSearchDateRange.lte;
    }
    return result;
};
function mapPredefinedDateFiltersClientToServer(search) {
    var nextSearch = __assign({}, search);
    // map custom range keys to from/to values server can understand
    exports.getDateFilters().forEach(function (dateFilter) {
        var searchValueForFilter = search[dateFilter.fieldname];
        var predefinedFilter = dateFilter.predefinedFilters.find(function (_predefinedFilter) { return _predefinedFilter.key === searchValueForFilter; });
        if (predefinedFilter != null) {
            nextSearch = __assign({}, search, elasticSearchDateRangeToFieldNames(predefinedFilter.elasticSearchDateRange, dateFilter.fieldname));
            delete nextSearch[dateFilter.fieldname];
        }
    });
    return nextSearch;
}
exports.mapPredefinedDateFiltersClientToServer = mapPredefinedDateFiltersClientToServer;
function mapPredefinedDateFiltersServerToClient(search) {
    var nextSearch = __assign({}, search);
    exports.getDateFilters().forEach(function (dateFilter) {
        dateFilter.predefinedFilters.forEach(function (predefinedFilter) {
            var expectedSearch = elasticSearchDateRangeToFieldNames(predefinedFilter.elasticSearchDateRange, dateFilter.fieldname);
            if (Object.keys(expectedSearch).every(function (key) { return expectedSearch[key] === nextSearch[key]; })) {
                Object.keys(expectedSearch).forEach(function (key) {
                    delete nextSearch[key];
                });
                nextSearch[dateFilter.fieldname] = predefinedFilter.key;
            }
        });
    });
    return nextSearch;
}
exports.mapPredefinedDateFiltersServerToClient = mapPredefinedDateFiltersServerToClient;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "39341fa4af9a113a40f4bf53c5cc9e7f.svg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(717);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(386);
var removeEntitiesAtEdges = __webpack_require__(387);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */

var DraftEntityInstance = __webpack_require__(391);
var Immutable = __webpack_require__(19);

var invariant = __webpack_require__(17);

var Map = Immutable.Map;


var instances = Map();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

module.exports = DraftEntity;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var utils_1 = __webpack_require__(3);
var StyleIcons = {
    bold: 'icon-bold',
    italic: 'icon-italic',
    underline: 'icon-underline',
    strikethrough: 'icon-strikethrough',
    h1: 'icon-heading-1',
    h2: 'icon-heading-2',
    h3: 'icon-heading-3',
    h4: 'icon-heading-4',
    h5: 'icon-heading-5',
    h6: 'icon-heading-6',
    quote: 'icon-quote',
    'unordered list': 'icon-unordered-list',
    'ordered list': 'icon-ordered-list',
    suggestions: 'icon-suggestion',
    invisibles: 'icon-paragraph',
    pre: 'icon-preformatted',
    subscript: 'icon-subscript',
    superscript: 'icon-superscript',
};
var StyleTooltips = {
    bold: utils_1.gettext('Bold (Ctrl+B)'),
    italic: utils_1.gettext('Italic (Ctrl+I)'),
    underline: utils_1.gettext('Underline (Ctrl+U)'),
    strikethrough: utils_1.gettext('Strikethrough'),
    h1: utils_1.gettext('H1'),
    h2: utils_1.gettext('H2'),
    h3: utils_1.gettext('H3'),
    h4: utils_1.gettext('H4'),
    h5: utils_1.gettext('H5'),
    h6: utils_1.gettext('H6'),
    quote: utils_1.gettext('Quote'),
    'unordered list': utils_1.gettext('Unordered list'),
    'ordered list': utils_1.gettext('Ordered list'),
    TH: utils_1.gettext('Toggle Header'),
    suggestions: utils_1.gettext('Toggle Suggestions Mode'),
    invisibles: utils_1.gettext('Toggle formatting marks'),
    pre: utils_1.gettext('Preformatted text'),
    subscript: utils_1.gettext('Subscript'),
    superscript: utils_1.gettext('Superscript'),
};
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name StyleButton
 * @description Toolbar button that can be toggled.
 */
var StyleButton = /** @class */ (function (_super) {
    __extends(StyleButton, _super);
    function StyleButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    StyleButton.prototype.onToggle = function (e) {
        e.preventDefault();
        this.props.onToggle(this.props.style, this.props.active);
    };
    StyleButton.prototype.render = function () {
        var _a = this.props, active = _a.active, label = _a.label;
        var iconClass = StyleIcons[label];
        var cx = classnames_1.default({
            'Editor3-styleButton': true,
            'Editor3-activeButton': active,
        });
        return (react_1.default.createElement("span", { className: cx, "data-sd-tooltip": StyleTooltips[label], "data-flow": 'down', onMouseDown: this.onToggle }, iconClass ? react_1.default.createElement("i", { className: iconClass }) : react_1.default.createElement("b", null, label)));
    };
    return StyleButton;
}(react_1.default.Component));
exports.default = StyleButton;
StyleButton.propTypes = {
    onToggle: prop_types_1.default.func,
    style: prop_types_1.default.string,
    active: prop_types_1.default.bool,
    label: prop_types_1.default.string,
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var Highlights = __importStar(__webpack_require__(41));
var highlightsConfig_1 = __webpack_require__(46);
var selection_1 = __webpack_require__(87);
/**
 * @ngdoc method
 * @name allowEditSuggestionOnLeft
 * @param {Object} editor state
 * @param {String} author
 * @returns {Boolean} True if on current text there are no noneditable suggestion on the left.
 * @description Check if the current text don't contain a noneditable suggestion on the right.
 */
function allowEditSuggestionOnLeft(editorState, author) {
    return allowEditSuggestion(editorState, author, true);
}
exports.allowEditSuggestionOnLeft = allowEditSuggestionOnLeft;
/**
 * @ngdoc method
 * @name allowEditSuggestionOnRight
 * @param {Object} editor state
 * @param {String} author
 * @returns {Boolean} True if on current text there are no noneditable suggestion on the right.
 * @description Check if the current text don't contain a noneditable suggestion on the right.
 */
function allowEditSuggestionOnRight(editorState, author) {
    return allowEditSuggestion(editorState, author, false);
}
exports.allowEditSuggestionOnRight = allowEditSuggestionOnRight;
/**
 * @ngdoc method
 * @name allowEditSuggestionOnBlock
 * @param {Object} editor state
 * @param {String} author
 * @returns {Boolean} True if on current block(s) there are no noneditable suggestions.
 * @description Check if the current block(s) don't contain a noneditable suggestion.
 */
function allowEditSuggestionOnBlock(editorState, author) {
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getEndKey());
    var newSelection = selection.merge({
        anchorOffset: 0,
        anchorKey: selection.getStartKey(),
        focusOffset: block.getLength(),
        focusKey: selection.getEndKey(),
        isBackward: true,
    });
    var newEditorState = draft_js_1.EditorState.forceSelection(editorState, newSelection);
    return allowEditSuggestionOnLeft(newEditorState, author);
}
exports.allowEditSuggestionOnBlock = allowEditSuggestionOnBlock;
/**
 * @ngdoc method
 * @name allowEditSuggestion
 * @param {Object} editor state
 * @param {String} author
 * @param {boolean} isBackward
 * @returns {Boolean} True if the current text don't contains a noneditable suggestion.
 * @description Check if the current text don't contain a noneditable suggestion.
 */
var allowEditSuggestion = function (editorState, author, isBackward) {
    var selection = editorState.getSelection();
    var newEditorState;
    var tmpEditorState;
    if (!selection.isCollapsed()) {
        newEditorState = selection_1.initSelectionIterator(editorState);
        while (selection_1.hasNextSelection(newEditorState, selection)) {
            var data = Highlights.getHighlightDataAtCurrentPosition(newEditorState, highlightsConfig_1.suggestionsTypes);
            if (!allowEditForData(data, author, false)) {
                return false;
            }
            tmpEditorState = Highlights.changeEditorSelection(newEditorState, 1, 1, false);
            if (tmpEditorState === newEditorState) {
                break;
            }
            newEditorState = tmpEditorState;
        }
        var styleBefore = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.suggestionsTypes, selection, -1);
        var styleAfter = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.suggestionsTypes, selection, 0, true);
        if (styleBefore != null && styleAfter != null && styleBefore === styleAfter) {
            return false;
        }
    }
    if (isBackward) {
        var dataBefore = Highlights.getHighlightDataAtOffset(editorState, highlightsConfig_1.suggestionsTypes, selection, -1);
        return allowEditForData(dataBefore, author);
    }
    var dataAfter = Highlights.getHighlightDataAtOffset(editorState, highlightsConfig_1.suggestionsTypes, selection, 0, true);
    return allowEditForData(dataAfter, author);
};
// Check if the current allow the edit.
var allowEditForData = function (data, author, checkDelete) {
    if (checkDelete === void 0) { checkDelete = true; }
    if (data == null) {
        return true;
    }
    var allow = (!checkDelete || data.type !== 'DELETE_SUGGESTION');
    return author === data.author && allow;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
function getCurrentAuthor() {
    return ng_1.default.get('session').identity._id;
}
exports.getCurrentAuthor = getCurrentAuthor;


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(976);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return __WEBPACK_IMPORTED_MODULE_0__Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_1__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1017);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_2__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbItem", function() { return __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1020);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(1021);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return __WEBPACK_IMPORTED_MODULE_8__Carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselItem", function() { return __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(1031);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_10__Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(1032);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Clearfix", function() { return __WEBPACK_IMPORTED_MODULE_11__Clearfix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CloseButton", function() { return __WEBPACK_IMPORTED_MODULE_12__CloseButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(1033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ControlLabel", function() { return __WEBPACK_IMPORTED_MODULE_13__ControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(1034);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Col", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_16__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(1048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownButton", function() { return __WEBPACK_IMPORTED_MODULE_17__DropdownButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return __WEBPACK_IMPORTED_MODULE_18__Fade__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(1049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_19__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(1050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_20__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(1053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_21__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Glyphicon", function() { return __WEBPACK_IMPORTED_MODULE_22__Glyphicon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_23__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(1054);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HelpBlock", function() { return __WEBPACK_IMPORTED_MODULE_24__HelpBlock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(1055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_25__Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(1056);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_26__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(1059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return __WEBPACK_IMPORTED_MODULE_27__Jumbotron__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(1060);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_28__Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(1061);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return __WEBPACK_IMPORTED_MODULE_29__ListGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroupItem", function() { return __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_31__Media__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(1068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_32__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(1069);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalBody", function() { return __WEBPACK_IMPORTED_MODULE_34__ModalBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalFooter__ = __webpack_require__(477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalFooter", function() { return __WEBPACK_IMPORTED_MODULE_35__ModalFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalHeader__ = __webpack_require__(478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return __WEBPACK_IMPORTED_MODULE_36__ModalHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalTitle__ = __webpack_require__(479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalTitle", function() { return __WEBPACK_IMPORTED_MODULE_37__ModalTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Nav__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_38__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Navbar__ = __webpack_require__(1085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_39__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavbarBrand", function() { return __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavDropdown__ = __webpack_require__(1089);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavDropdown", function() { return __WEBPACK_IMPORTED_MODULE_41__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavItem__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavItem", function() { return __WEBPACK_IMPORTED_MODULE_42__NavItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Overlay__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Overlay", function() { return __WEBPACK_IMPORTED_MODULE_43__Overlay__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__ = __webpack_require__(1097);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "OverlayTrigger", function() { return __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageHeader__ = __webpack_require__(1098);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageHeader", function() { return __WEBPACK_IMPORTED_MODULE_45__PageHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageItem__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PageItem", function() { return __WEBPACK_IMPORTED_MODULE_46__PageItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pager__ = __webpack_require__(1101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pager", function() { return __WEBPACK_IMPORTED_MODULE_47__Pager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pagination__ = __webpack_require__(1102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_48__Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Panel__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return __WEBPACK_IMPORTED_MODULE_49__Panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__PanelGroup__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PanelGroup", function() { return __WEBPACK_IMPORTED_MODULE_50__PanelGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Popover__ = __webpack_require__(1110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_51__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ProgressBar__ = __webpack_require__(1111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return __WEBPACK_IMPORTED_MODULE_52__ProgressBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Radio__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_53__Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ResponsiveEmbed__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsiveEmbed", function() { return __WEBPACK_IMPORTED_MODULE_54__ResponsiveEmbed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Row__ = __webpack_require__(1114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return __WEBPACK_IMPORTED_MODULE_55__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__SafeAnchor__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SafeAnchor", function() { return __WEBPACK_IMPORTED_MODULE_56__SafeAnchor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SplitButton__ = __webpack_require__(1115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SplitButton", function() { return __WEBPACK_IMPORTED_MODULE_57__SplitButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Tab__ = __webpack_require__(1117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_58__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__TabContainer__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContainer", function() { return __WEBPACK_IMPORTED_MODULE_59__TabContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContent__ = __webpack_require__(222);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_60__TabContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Table__ = __webpack_require__(1118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_61__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__TabPane__ = __webpack_require__(489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_62__TabPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Tabs__ = __webpack_require__(1119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_63__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Thumbnail__ = __webpack_require__(1120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return __WEBPACK_IMPORTED_MODULE_64__Thumbnail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ToggleButton__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_65__ToggleButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButtonGroup__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ToggleButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_66__ToggleButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Tooltip__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_67__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Well__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Well", function() { return __WEBPACK_IMPORTED_MODULE_68__Well__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__utils__ = __webpack_require__(1124);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_69__utils__; });













































































































































/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(138);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(39);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  defaultOpen: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["prefix"])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["prefix"])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id,
              disabled: disabled,
              open: open,
              role: role,
              bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id,
              open: open,
              pullRight: pullRight,
              bsClass: bsClass,
              onSelect: onSelect,
              rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["bsClass"])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);






var _fadeStyles;






var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};

var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a,
      props,
      function (status, innerProps) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, innerProps, {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('fade', className, children.props.className, fadeStyles[status])
        }));
      }
    );
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(12);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["bsClass"])('media', Media));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(138);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/* eslint-disable max-len */
/* tslint:disable:max-line-length */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importStar(__webpack_require__(2));
var moment_timezone_1 = __importDefault(__webpack_require__(380));
var utils_1 = __webpack_require__(3);
/**
 * Gives top shadow for scroll elements
 *
 * Usage:
 * <div sd-shadow></div>
 */
ShadowDirective.$inject = ['$timeout'];
function ShadowDirective($timeout) {
    return {
        link: function (scope, element, attrs) {
            element.addClass('shadow-list-holder');
            function shadowTimeout() {
                var shadow = angular.element('<div class="scroll-shadow"><div class="inner"></div></div>');
                element.parent().prepend(shadow);
                element.on('scroll', function scroll() {
                    if ($(this).scrollTop() > 0) {
                        shadow.addClass('shadow');
                    }
                    else {
                        shadow.removeClass('shadow');
                    }
                });
            }
            scope.$on('$destroy', function () {
                element.off('scroll');
            });
            $timeout(shadowTimeout, 1, false);
        },
    };
}
/**
 * Convert newline charachter from text into given html element (default <br/>)
 *
 * Usage:
 * <div data-html="text | nl2el"></div>
 * or
 * <div data-html="text | nl2el:'</p><p>'"></div> for specific replace element
 */
function NewlineToElement() {
    return function (input, el) {
        return input.replace(/(?:\r\n|\r|\n)/g, el || '<br/>');
    };
}
CreateButtonDirective.$inject = [];
function CreateButtonDirective() {
    return {
        restrict: 'C',
        template: '<i class="icon-plus-large"></i><span class="circle"></span>',
    };
}
AutofocusDirective.$inject = [];
function AutofocusDirective() {
    return {
        link: function (scope, element) {
            lodash_1.default.defer(function () {
                var value = element.val();
                element.val('').focus();
                element.val(value);
            });
        },
    };
}
AutoexpandDirective.$inject = [];
function AutoexpandDirective() {
    return {
        link: function (scope, element) {
            var _minHeight = element.outerHeight();
            function resize() {
                var e = element[0];
                var vlen = e.value.length;
                if (vlen !== e.valLength) {
                    if (vlen < e.valLength) {
                        e.style.height = '0px';
                    }
                    var h = Math.max(_minHeight, e.scrollHeight);
                    e.style.overflow = e.scrollHeight > h ? 'auto' : 'hidden';
                    e.style.height = h + 1 + 'px';
                    e.valLength = vlen;
                }
            }
            resize();
            element.on('keyup change', function () {
                resize();
            });
        },
    };
}
DropdownFocus.$inject = ['Keys'];
function DropdownFocus(Keys) {
    return {
        require: 'dropdown',
        link: function (scope, elem, attrs, dropdown) {
            scope.$watch(dropdown.isOpen, function (isOpen) {
                var inputField = elem.find('input[type="text"]');
                if (isOpen) {
                    lodash_1.default.defer(function () {
                        var buttonList = elem.find('button:not([disabled]):not(.dropdown__toggle)');
                        var handlers = {};
                        /**
                         * If input field exist, put focus on it,
                         * otherwise put it on first button in list
                         */
                        if (inputField.length > 0) {
                            inputField.focus();
                        }
                        else if (buttonList.length) {
                            buttonList[0].focus();
                        }
                        elem.tabindex = ''; // make parent element receive keyboard events
                        elem.on('keydown', function (event) {
                            if (handlers[event.keyCode] && !event.ctrlKey && !event.metaKey) {
                                event.preventDefault();
                                event.stopPropagation();
                                handlers[event.keyCode]();
                            }
                        });
                        inputField.on('keyup', function (event) {
                            var mainList = elem.find('.main-list')
                                .children('ul')
                                .find('li > button')[0];
                            if (event.keyCode === Keys.down && mainList) {
                                mainList.focus();
                            }
                        });
                        handlers[Keys.up] = function handleUp() {
                            var prevElem = elem.find('button:focus')
                                .parent('li')
                                .prev()
                                .children('button'), categoryButton = elem.find('.levelup button');
                            if (prevElem.length > 0) {
                                prevElem.focus();
                            }
                            else {
                                inputField.focus();
                                categoryButton.focus();
                            }
                        };
                        handlers[Keys.down] = function handleDown() {
                            var nextElem = elem.find('button:focus')
                                .parent('li')
                                .next()
                                .children('button'), categoryButton = elem.find('.levelup button');
                            /*
                             * If category button exist, update button list with new values,
                             * but exclude category button
                             */
                            if (categoryButton.length > 0) {
                                var newList = elem.find('button:not([disabled]):not(.dropdown__toggle)');
                                buttonList = lodash_1.default.without(newList, categoryButton[0]);
                            }
                            if (inputField.is(':focus') || categoryButton.is(':focus')) {
                                if (lodash_1.default.isEmpty(inputField.val())) {
                                    var mainList = elem.find('.main-list')
                                        .children('ul')
                                        .find('li > button');
                                    if (mainList[0] !== undefined) {
                                        mainList[0].focus();
                                    }
                                }
                                else {
                                    var buttonSet = elem.find('button:not([disabled]):not(.dropdown__toggle)');
                                    if (buttonSet[0] !== undefined) {
                                        buttonSet[0].focus();
                                    }
                                }
                            }
                            else if (nextElem.length > 0) {
                                nextElem.focus();
                            }
                            else if (buttonList[0] !== undefined) {
                                buttonList[0].focus();
                            }
                        };
                        handlers[Keys.left] = function handleLeft() {
                            elem.find('.backlink').click();
                        };
                        handlers[Keys.right] = function handleRight() {
                            var selectedElem = elem.find('button:focus').parent('li');
                            selectedElem.find('.nested-toggle').click();
                        };
                    });
                }
                else if (isOpen === false) { // Exclusively false, prevent executing if it is undefined
                    elem.off('keydown');
                    inputField.off('keyup');
                }
            });
        },
    };
}
PopupService.$inject = ['$document'];
function PopupService($document) {
    var service = {};
    service.position = function (width, height, target) {
        // taking care of screen size and responsiveness
        var tolerance = 10;
        var elOffset = target.offset();
        var elHeight = target.outerHeight();
        var docHeight = $document.height();
        var docWidth = $document.width();
        var position = { top: 0, left: 0 };
        if (elOffset.top + elHeight + height + tolerance > docHeight) {
            position.top = elOffset.top - height;
        }
        else {
            position.top = elOffset.top + elHeight;
        }
        if (elOffset.left + width + tolerance > docWidth) {
            position.left = docWidth - tolerance - width;
        }
        else {
            position.left = elOffset.left;
        }
        return position;
    };
    return service;
}
function DatepickerWrapper() {
    return {
        transclude: true,
        templateUrl: 'scripts/core/ui/views/datepicker-wrapper.html',
        link: function (scope, element) {
            element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
            });
        },
    };
}
/**
 * Datepicker directive
 *
 * Usage:
 * <div sd-datepicker ng-model="date"></div>
 *
 */
DatepickerDirective.$inject = ['$document'];
function DatepickerDirective($document) {
    return {
        scope: {
            dt: '=ngModel',
            disabled: '=ngDisabled',
            tabindex: '=',
            shortcuts: '=',
            format: '@',
            onChange: '&',
        },
        templateUrl: 'scripts/core/ui/views/sd-datepicker.html',
        link: function (scope, element) {
            scope.state = { opened: false };
            scope.openCalendar = function (e) {
                scope.state.opened = !scope.state.opened;
                $document.on('click', handleDatePicker);
            };
            function close() {
                scope.state.opened = false;
                $document.off('click', handleDatePicker);
            }
            function handleDatePicker(event) {
                var isChild = element.find(event.target).length > 0;
                if (scope.state.opened && !isChild) { // outside Datepicker click
                    scope.$apply(function () {
                        close();
                    });
                }
            }
            scope.change = function () {
                if (scope.onChange) {
                    scope.onChange();
                }
            };
            scope.$on('$destroy', function () {
                $document.off('click', handleDatePicker);
            });
        },
    };
}
DatepickerInnerDirective.$inject = ['$compile', '$document', 'popupService', 'datetimeHelper', 'config'];
function DatepickerInnerDirective($compile, $document, popupService, datetimeHelper, config) {
    var popupTpl = '<div sd-datepicker-wrapper ng-model="date">' +
        '<div datepicker format-day="d" starting-day="' + config.startingDay + '" show-weeks="false"></div>' +
        '</div>';
    return {
        require: 'ngModel',
        scope: {
            open: '=opened',
            dtFormat: '=format',
            shortcuts: '=?',
        },
        link: function (scope, element, attrs, ctrl) {
            var VIEW_DATE_FORMAT = config.view.dateformat;
            var MODEL_DATE_FORMAT = scope.dtFormat || config.model.dateformat;
            var ESC = 27;
            var DOWN_ARROW = 40;
            var popup = angular.element(popupTpl);
            ctrl.$parsers.unshift(function parseDate(viewValue) {
                if (!viewValue) {
                    ctrl.$setValidity('date', true);
                    return null;
                }
                else if (viewValue.dpdate) {
                    // from datepicker
                    ctrl.$setValidity('date', true);
                    return moment_timezone_1.default(viewValue.dpdate).format(MODEL_DATE_FORMAT);
                }
                else if (datetimeHelper.isValidDate(viewValue, VIEW_DATE_FORMAT)) {
                    // date was typed in
                    ctrl.$setValidity('date', true);
                    return moment_timezone_1.default(viewValue, VIEW_DATE_FORMAT).format(MODEL_DATE_FORMAT);
                }
                // input is not valid
                ctrl.$setValidity('date', false);
                return null;
            });
            scope.dateSelection = function (dt) {
                if (angular.isDefined(dt)) {
                    // if one of predefined dates is selected (today, tomorrow...)
                    scope.date = dt;
                }
                ctrl.$setViewValue({
                    dpdate: scope.date,
                    viewdate: moment_timezone_1.default(scope.date).format(VIEW_DATE_FORMAT),
                });
                ctrl.$render();
                scope.close();
            };
            // select one of predefined dates
            scope.selectShortcut = function (offset, type) {
                var day = moment_timezone_1.default().startOf('day')
                    .add(offset, type);
                scope.dateSelection(day);
            };
            // select one of predefined dates
            scope.select = function (offset) {
                scope.selectShortcut(offset, 'days');
            };
            ctrl.$render = function () {
                element.val(ctrl.$viewValue.viewdate); // set the view
                scope.date = ctrl.$viewValue.dpdate || moment_timezone_1.default().tz(config.defaultTimezone); // set datepicker model
            };
            // handle model changes
            ctrl.$formatters.unshift(function dateFormatter(modelValue) {
                var dpdate, viewdate = 'Invalid Date';
                if (modelValue) {
                    if (datetimeHelper.isValidDate(modelValue, MODEL_DATE_FORMAT)) {
                        dpdate = moment_timezone_1.default(modelValue, MODEL_DATE_FORMAT).toDate();
                        viewdate = moment_timezone_1.default(modelValue, MODEL_DATE_FORMAT).format(VIEW_DATE_FORMAT);
                    }
                }
                else {
                    viewdate = '';
                }
                return {
                    dpdate: dpdate,
                    viewdate: viewdate,
                };
            });
            scope.$watch('open', function (value) {
                if (value) {
                    $popupWrapper.offset(popupService.position(260, 270, element));
                    scope.$broadcast('datepicker.focus');
                }
            });
            scope.keydown = function (evt) {
                if (evt.which === ESC) {
                    evt.preventDefault();
                    scope.close();
                }
                else if (evt.which === DOWN_ARROW && !scope.open) {
                    scope.$apply(function () {
                        scope.open = true;
                    });
                }
            };
            element.bind('keydown', scope.keydown);
            scope.close = function () {
                scope.open = false;
                element[0].focus();
            };
            var $popupWrapper = $compile(popup)(scope);
            popup.remove();
            $document.find('body').append($popupWrapper);
            scope.$on('$destroy', function () {
                $popupWrapper.remove();
                element.unbind('keydown', scope.keydown);
            });
        },
    };
}
TimepickerDirective.$inject = ['$document'];
function TimepickerDirective($document) {
    return {
        scope: {
            tt: '=ngModel',
            style: '@',
            disabled: '=ngDisabled',
        },
        templateUrl: 'scripts/core/ui/views/sd-timepicker.html',
        link: function (scope, element) {
            scope.openTimePicker = function (e) {
                scope.opened = !scope.opened;
                $document.on('click', handleTimePicker);
            };
            function close() {
                scope.opened = false;
                $document.off('click', handleTimePicker);
            }
            function handleTimePicker(event) {
                var isChild = element.find(event.target).length > 0;
                if (scope.opened && !isChild) { // outside Timepicker click
                    scope.$apply(function () {
                        close();
                    });
                }
            }
            scope.$on('$destroy', function () {
                $document.off('click', handleTimePicker);
            });
        },
    };
}
TimepickerInnerDirective.$inject = ['$compile', '$document', 'popupService', 'datetimeHelper', 'config'];
function TimepickerInnerDirective($compile, $document, popupService, datetimeHelper, config) {
    var popupTpl = '<div sd-timepicker-popup ' +
        'data-open="open" data-time="time" data-select="timeSelection({time: time})" data-keydown="keydown(e)">' +
        '</div>';
    return {
        scope: {
            open: '=opened',
        },
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            var MODEL_TIME_FORMAT = config.model.timeformat;
            var VIEW_TIME_FORMAT = config.view.timeformat || MODEL_TIME_FORMAT;
            var ESC = 27;
            var DOWN_ARROW = 40;
            var popup = angular.element(popupTpl);
            function viewFormat(modelTime) {
                return moment_timezone_1.default(modelTime, MODEL_TIME_FORMAT).format(VIEW_TIME_FORMAT);
            }
            ctrl.$parsers.unshift(function parseDate(viewValue) {
                if (!viewValue) {
                    ctrl.$setValidity('time', true);
                    return null;
                }
                else if (viewValue.tptime) {
                    // time selected from picker
                    ctrl.$setValidity('time', true);
                    return viewValue.tptime;
                }
                else if (datetimeHelper.isValidTime(viewValue, VIEW_TIME_FORMAT)) {
                    // time written in
                    ctrl.$setValidity('time', true);
                    scope.time = moment_timezone_1.default(viewValue, VIEW_TIME_FORMAT).format(MODEL_TIME_FORMAT);
                    return scope.time;
                }
                // regex not passing
                ctrl.$setValidity('time', false);
                return null;
            });
            scope.timeSelection = function (tt) {
                if (angular.isDefined(tt)) {
                    // if one of predefined time options is selected
                    scope.time = tt.time;
                    ctrl.$setViewValue({ tptime: tt.time, viewtime: viewFormat(tt.time) });
                    ctrl.$render();
                }
                scope.close();
            };
            ctrl.$render = function () {
                element.val(ctrl.$viewValue.viewtime); // set the view
                scope.time = ctrl.$viewValue.tptime; // set timepicker model
            };
            // handle model changes
            ctrl.$formatters.unshift(function dateFormatter(modelValue) {
                var tptime, viewtime = 'Invalid Time';
                if (modelValue) {
                    if (datetimeHelper.isValidTime(modelValue, MODEL_TIME_FORMAT)) {
                        // formatter pass fine
                        tptime = modelValue;
                        viewtime = viewFormat(modelValue);
                    }
                }
                else {
                    viewtime = '';
                }
                return {
                    tptime: tptime,
                    viewtime: viewtime,
                };
            });
            scope.$watch('open', function (value) {
                if (value) {
                    $popupWrapper.offset(popupService.position(200, 310, element));
                    scope.$broadcast('timepicker.focus');
                }
            });
            scope.keydown = function (evt) {
                if (evt.which === ESC) {
                    evt.preventDefault();
                    scope.close();
                }
                else if (evt.which === DOWN_ARROW && !scope.open) {
                    scope.$apply(function () {
                        scope.open = true;
                    });
                }
            };
            element.bind('keydown', scope.keydown);
            scope.close = function () {
                scope.open = false;
                element[0].focus();
            };
            var $popupWrapper = $compile(popup)(scope);
            popup.remove();
            $document.find('body').append($popupWrapper);
            scope.$on('$destroy', function () {
                $popupWrapper.remove();
                element.unbind('keydown', scope.keydown);
            });
        },
    };
}
TimezoneDirective.$inject = ['tzdata', 'config', '$timeout'];
function TimezoneDirective(tzdata, config, $timeout) {
    return {
        templateUrl: 'scripts/core/ui/views/sd-timezone.html',
        scope: {
            timezone: '=',
            style: '@',
        },
        link: function (scope, el) {
            scope.timeZones = []; // all time zones to choose from
            scope.tzSearchTerm = ''; // the current time zone search term
            // filtered time zone list containing only those that match
            // user-provided search term
            scope.matchingTimeZones = [];
            tzdata.$promise.then(function () {
                scope.timeZones = tzdata.getTzNames();
                if (!scope.timezone && config.defaultTimezone) {
                    scope.selectTimeZone(config.defaultTimezone);
                }
            });
            /**
             * Sets the list of time zones to select from to only those
             * that contain the given search term (case-insensitive).
             * If the search term is empty, it results in an empty list.
             *
             * @method searchTimeZones
             * @param {string} searchTerm
             */
            scope.searchTimeZones = function (searchTerm) {
                var termLower;
                scope.tzSearchTerm = searchTerm;
                if (!searchTerm) {
                    scope.matchingTimeZones = [];
                    return;
                }
                termLower = searchTerm.toLowerCase();
                scope.matchingTimeZones = lodash_1.default.filter(scope.timeZones, function (item) { return item.toLowerCase().indexOf(termLower) >= 0; });
            };
            /**
             * Sets the time zone of the routing rule's schedule and resets
             * the current time zone search term.
             *
             * @method selectTimeZone
             * @param {string} tz - name of the time zone to select
             */
            scope.selectTimeZone = function (tz) {
                scope.timezone = tz;
                scope.tzSearchTerm = '';
            };
            /**
             * Clears the currently selected time zone of the routing
             * rule's schedule.
             *
             * @method clearSelectedTimeZone
             */
            scope.clearSelectedTimeZone = function () {
                $timeout(function () {
                    el.find('input')[0].focus();
                }, 0, false);
                delete scope.timezone;
            };
        },
    };
}
TimepickerPopupDirective.$inject = ['$timeout', 'config'];
function TimepickerPopupDirective($timeout, config) {
    return {
        templateUrl: 'scripts/core/ui/views/sd-timepicker-popup.html',
        scope: {
            open: '=',
            select: '&',
            keydown: '&',
            time: '=',
        },
        link: function (scope, element) {
            var MODEL_TIME_FORMAT = config.model.timeformat;
            var POPUP = '.timepicker-popup';
            var focusEl = function () {
                $timeout(function () {
                    element.find(POPUP).focus();
                }, 0, false);
            };
            scope.$on('timepicker.focus', focusEl);
            element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
            });
            scope.hours = lodash_1.default.range(24);
            scope.minutes = lodash_1.default.range(0, 60, 5);
            scope.$watch('time', function (newVal, oldVal) {
                var local;
                if (newVal) {
                    local = moment_timezone_1.default(newVal, MODEL_TIME_FORMAT);
                }
                else {
                    local = moment_timezone_1.default();
                    local.add(5 - local.minute() % 5, 'm'); // and some time up to 5m
                }
                scope.hour = local.hour();
                scope.minute = local.minute();
                scope.second = 0;
            });
            scope.submit = function (offset) {
                var local, time;
                if (offset) {
                    local = moment_timezone_1.default()
                        .add(offset, 'minutes')
                        .format(MODEL_TIME_FORMAT);
                }
                else {
                    local = scope.hour + ':' + scope.minute + ':' + scope.second;
                }
                // convert from local to utc
                time = moment_timezone_1.default(local, MODEL_TIME_FORMAT).format(MODEL_TIME_FORMAT);
                scope.select({ time: time });
            };
            scope.cancel = function () {
                scope.select();
            };
        },
    };
}
function LeadingZeroFilter() {
    return function (input) {
        return input < 10 ? '0' + input : input;
    };
}
function FileiconFilter() {
    var mapping = {
        pdf: 'pdf',
        excel: 'doc',
        msword: 'doc',
        opendocument: 'doc',
        officedocument: 'doc',
    };
    return function (mimetype) {
        var match = Object.keys(mapping).find(function (key) { return mimetype.indexOf(key) > -1; });
        return 'document-' + (match ? mapping[match] : 'default');
    };
}
exports.FileiconFilter = FileiconFilter;
function FilesizeFilter() {
    var KB = Math.pow(2, 10);
    var MB = KB * KB;
    return function (bytes) {
        if (bytes >= MB) {
            return (bytes / MB).toFixed(1) + ' MB';
        }
        else if (bytes >= KB) {
            return (bytes / KB).toFixed(1) + ' kB';
        }
        return bytes + ' b';
    };
}
exports.FilesizeFilter = FilesizeFilter;
WeekdayPickerDirective.$inject = ['weekdays'];
function WeekdayPickerDirective(weekdays) {
    return {
        templateUrl: 'scripts/core/ui/views/weekday-picker.html',
        scope: {
            model: '=',
            shortWeekdayLabels: '=',
        },
        link: function (scope) {
            scope.weekdays = scope.shortWeekdayLabels !== true
                ? weekdays
                : lodash_1.mapValues(weekdays, function (weekday) { return weekday.slice(0, 3); });
            scope.weekdayList = Object.keys(weekdays);
            scope.model = scope.model || [];
            /**
             * Test if given day is selected for schedule
             *
             * @param {string} day
             * @return {boolean}
             */
            scope.isDayChecked = function (day) {
                return scope.model.indexOf(day) !== -1;
            };
            /**
             * Toggle given day on/off
             *
             * @param {string} day
             */
            scope.toggleDay = function (day) {
                if (scope.isDayChecked(day)) {
                    scope.model.splice(scope.model.indexOf(day), 1);
                }
                else {
                    scope.model.push(day);
                }
            };
        },
    };
}
/*
 * Splitter widget, allows user to dinamicaly
 * resize monitoring and authoring screen
 *
 */
splitterWidget.$inject = ['superdesk', '$timeout'];
function splitterWidget(superdesk, $timeout) {
    return {
        link: function (scope, element) {
            var workspace = element, authoring = element.next('#authoring-container');
            /*
             * If custom sizes are defined, preload them
             */
            if (superdesk.monitoringWidth && superdesk.authoringWidth) {
                workspace.css({ width: superdesk.monitoringWidth });
                authoring.css({ width: superdesk.authoringWidth });
            }
            /*
             * If authoring is not initialized,
             * wait, and initialize it again
             *
             * This issue is observed when you are
             * switching from settings back to monitoring
             */
            if (!authoring.length) {
                $timeout(function () {
                    authoring = element.next('#authoring-container');
                    authoring.width(superdesk.authoringWidth);
                }, 0, false);
            }
            workspace.resizable({
                handles: 'e',
                minWidth: 400,
                start: function (e, ui) {
                    var container = ui.element.parent();
                    workspace.resizable({ maxWidth: container.width() - 730 });
                },
                resize: function (e, ui) {
                    var container = ui.element.parent(), remainingSpace = container.width() - workspace.outerWidth() - 48, authoringWidth = remainingSpace - (authoring.outerWidth() - authoring.width());
                    var stage = ui.element.find('.stage.swimlane');
                    var header = stage.find('.column-header.swimlane');
                    if (workspace.outerWidth() < 655) {
                        workspace.addClass('ui-responsive-medium');
                    }
                    else {
                        workspace.removeClass('ui-responsive-medium');
                    }
                    if (workspace.outerWidth() < 460) {
                        workspace.addClass('ui-responsive-small');
                    }
                    else {
                        workspace.removeClass('ui-responsive-small');
                    }
                    authoring.width(authoringWidth / container.width() * 100 + '%');
                    header.width(stage.outerWidth());
                },
                stop: function (e, ui) {
                    var container = ui.element.parent();
                    var stage = ui.element.find('.stage.swimlane');
                    var header = stage.find('.column-header.swimlane');
                    superdesk.monitoringWidth = workspace.outerWidth() / container.width() * 100 + '%';
                    superdesk.authoringWidth = authoring.outerWidth() / container.width() * 100 + '%';
                    superdesk.headerWidth = superdesk.stageWidth = stage.outerWidth();
                    ui.element.css({
                        width: superdesk.monitoringWidth,
                    });
                    header.css({
                        width: superdesk.headerWidth,
                    });
                },
            });
        },
    };
}
/*
 * Media Query directive is used for creating responsive
 * layout's for single elements on page
 *
 * Usage:
 * <div sd-media-query min-width='650' max-width='1440'></div>
 *
 */
mediaQuery.$inject = ['$window', 'authoringWorkspace'];
function mediaQuery($window, authoringWorkspace) {
    return {
        scope: {
            minWidth: '=',
            maxWidth: '=',
            elementClass: '@',
        },
        link: function (scope, elem) {
            var window = angular.element($window);
            var resize = lodash_1.default.debounce(calcSize, 300);
            var elementClass = scope.elementClass ? scope.elementClass : 'elementState';
            window.on('resize', resize);
            scope.$watch(authoringWorkspace.getState, resize);
            function calcSize() {
                var width = elem.width();
                if (width < scope.minWidth) {
                    scope.$parent.$applyAsync(function () {
                        scope.$parent[elementClass] = 'compact';
                    });
                    elem.removeClass('comfort').addClass('compact');
                }
                else if (width > scope.maxWidth) {
                    scope.$parent.$applyAsync(function () {
                        scope.$parent[elementClass] = 'comfort';
                    });
                    elem.removeClass('compact').addClass('comfort');
                }
                else {
                    scope.$parent.$applyAsync(function () {
                        scope.$parent[elementClass] = null;
                    });
                    elem.removeClass('compact comfort');
                }
            }
            // init
            resize();
            scope.$on('$destroy', function () {
                window.off('resize', resize);
            });
        },
    };
}
/*
 * Focus directive is used for adding class
 * to closest elementon focus and removing it on blur
 *
 * Usage:
 * <div sd-focus-element data-element='input' data-append-element='.field' data-append-class='active'></div>
 *
 */
focusElement.$inject = [];
function focusElement() {
    return {
        link: function (scope, elem) {
            var dataElement = elem.attr('data-element'), dataAppendElement = elem.attr('data-append-element'), dataClass = elem.attr('data-append-class'), element = elem;
            if (dataElement) {
                element = elem.find(dataElement);
            }
            element.on('focus', function () {
                element.closest(dataAppendElement).addClass(dataClass);
            });
            element.on('blur', function () {
                element.closest(dataAppendElement).removeClass(dataClass);
            });
        },
    };
}
/*
 * Required fields directive
 *
 * Usage:
 * <input type='text' sd-validation-error='error.field' ng-required='schema.field.required' />
 */
validationDirective.$inject = [];
function validationDirective() {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs, ctrl) {
            var invalidText = '<span id="required_span" class="sd-invalid-text">' +
                utils_1.gettext('This field is required') + '</span>';
            scope.$watch(attrs.required, function (required) {
                if (!required) {
                    if (elem.hasClass('sd-validate')) {
                        elem.removeClass('sd-validate');
                    }
                    if (elem.find('#required_span').length) {
                        elem.find('#required_span').remove();
                    }
                    return;
                }
                if (elem.find('#required_span').length) {
                    return;
                }
                elem.addClass('sd-validate');
                if (elem.hasClass('field')) {
                    elem.find('label')
                        .after('<span id="required_span" class="sd-required">'
                        + utils_1.gettext('Required') + '</span>');
                }
                else if (elem.find('.authoring-header__input-holder').length) {
                    elem.find('.authoring-header__input-holder').append(invalidText);
                }
                else {
                    elem.append(invalidText);
                }
            });
            scope.$watch(attrs.sdValidationError, function (isError) {
                if (isError === true) {
                    elem.addClass('sd-invalid').removeClass('sd-valid');
                }
                else if (isError === false) {
                    elem.removeClass('sd-invalid').addClass('sd-valid');
                }
            });
        },
    };
}
function MultipleEmailsValidation() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+\/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
            ctrl.$validators.multipleEmails = function (modelValue, viewValue) {
                if (ctrl.$isEmpty(modelValue)) {
                    return true;
                }
                var emails = modelValue.split(',');
                function testEmail(email) {
                    return EMAIL_REGEXP.test(email);
                }
                return emails.every(testEmail);
            };
        },
    };
}
/**
 * Loading indicator directive
 *
 * Will fill the closest parent with position absolute/relative,
 * not necessary the element where it's used.
 */
function LoadingDirective() {
    return {
        transclude: true,
        scope: { loading: '=sdLoading' },
        template: [
            '<div>',
            '<div ng-transclude></div>',
            '<div class="loading-overlay" ng-class="{active: loading}" style="opacity: 0.5;"></div>',
            '</div>',
        ].join(''),
    };
}
multiSelectDirective.$inject = [];
function multiSelectDirective() {
    return {
        scope: {
            item: '=',
            list: '=',
            change: '&',
            output: '@',
            disabled: '=',
        },
        templateUrl: 'scripts/core/ui/views/sd-multi-select.html',
        link: function (scope) {
            scope.selectedItems = [];
            scope.list = lodash_1.default.sortBy(scope.list);
            scope.activeList = false;
            scope.selectItem = function (item) {
                scope.list = lodash_1.default.without(scope.list, item);
                scope.activeList = false;
                scope.selectedTerm = '';
                scope.selectedItems.push(item);
                updateItem();
            };
            scope.removeItem = function (item) {
                scope.list.push(item);
                scope.list = lodash_1.default.sortBy(scope.list);
                scope.selectedItems = lodash_1.default.without(scope.selectedItems, item);
                updateItem();
            };
            scope.$watch('item', function (item) {
                if (!item) {
                    return false;
                }
                scope.selectedItems = lodash_1.default.union(scope.item, scope.selectedItems);
                scope.list = lodash_1.default.sortBy(lodash_1.default.difference(scope.list, scope.item));
            });
            function updateItem() {
                switch (scope.output) {
                    case 'string':
                        scope.item = scope.selectedItems.join(', ');
                        break;
                    default:
                        scope.item = scope.selectedItems;
                }
                scope.change(scope.item);
            }
            // Typeahead search
            scope.searchTerms = function (term) {
                if (!term) {
                    scope.$applyAsync(function () {
                        scope.activeList = false;
                    });
                }
                scope.terms = lodash_1.default.filter(scope.list, function (t) { return t.toLowerCase().indexOf(term.toLowerCase()) !== -1; });
                scope.activeList = true;
            };
        },
    };
}
// export filter instances for react
exports.fileicon = FileiconFilter();
exports.filesize = FilesizeFilter();
/**
 * @ngdoc module
 * @module superdesk.core.ui
 * @name superdesk.core.ui
 * @packageName superdesk.core
 * @description A set of provided core UI components.
 */
exports.default = angular.module('superdesk.core.ui', [
    'superdesk.config',
    'superdesk.core.datetime',
    'superdesk.core.ui.autoheight',
])
    .config(['defaultConfigProvider', function (defaultConfig) {
        defaultConfig.set('ui.italicAbstract', true);
    }])
    .run(['$rootScope', '$location', function ($rootScope, $location) {
        $rootScope.popup = $location.search().popup || false;
    }])
    .directive('sdShadow', ShadowDirective)
    .filter('nl2el', NewlineToElement)
    .directive('sdCreateBtn', CreateButtonDirective)
    .directive('sdAutofocus', AutofocusDirective)
    .directive('sdAutoexpand', AutoexpandDirective)
    .directive('sdTimezone', TimezoneDirective)
    .directive('sdDatepickerInner', DatepickerInnerDirective)
    .directive('sdDatepickerWrapper', DatepickerWrapper)
    .directive('sdDatepicker', DatepickerDirective)
    .directive('sdTimepickerInner', TimepickerInnerDirective)
    .directive('sdTimepickerPopup', TimepickerPopupDirective)
    .directive('sdTimepicker', TimepickerDirective)
    .service('popupService', PopupService)
    .filter('leadingZero', LeadingZeroFilter)
    .filter('filesize', FilesizeFilter)
    .filter('fileicon', FileiconFilter)
    .directive('sdDropdownFocus', DropdownFocus)
    .directive('sdWeekdayPicker', WeekdayPickerDirective)
    .directive('sdSplitterWidget', splitterWidget)
    .directive('sdMediaQuery', mediaQuery)
    .directive('sdFocusElement', focusElement)
    .directive('sdValidationError', validationDirective)
    .directive('sdLoading', LoadingDirective)
    .directive('sdMultipleEmails', MultipleEmailsValidation)
    .directive('sdMultiSelect', multiSelectDirective);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1198), __esModule: true };

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1201);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1216),
    listCacheDelete = __webpack_require__(1217),
    listCacheGet = __webpack_require__(1218),
    listCacheHas = __webpack_require__(1219),
    listCacheSet = __webpack_require__(1220);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(230);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1238);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1252),
    Map = __webpack_require__(231),
    Promise = __webpack_require__(1253),
    Set = __webpack_require__(1254),
    WeakMap = __webpack_require__(1255),
    baseGetTag = __webpack_require__(101),
    toSource = __webpack_require__(505);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var keys = exports.keys = function keys(obj) {
  return obj === Object(obj) ? Object.keys(obj) : [];
};

var values = exports.values = function values(obj) {
  return obj === Object(obj) ? Object.values(obj) : [];
};

function mergeDeep(target, source) {
  var output = assign({}, target);
  if (isPlainObject(target) && isPlainObject(source)) {
    keys(source).forEach(function (key) {
      if (isPlainObject(source[key])) {
        if (!(key in target)) assign(output, _defineProperty({}, key, source[key]));else output[key] = mergeDeep(target[key], source[key]);
      } else {
        assign(output, _defineProperty({}, key, source[key]));
      }
    });
  }
  return output;
}

var merge = exports.merge = function merge(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return sources.reduce(function (t, s) {
    return mergeDeep(t, s);
  }, target);
};

var assign = exports.assign = function assign(target) {
  for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    sources[_key2 - 1] = arguments[_key2];
  }

  return Object.assign.apply(Object, [target].concat(sources));
};

var identity = exports.identity = function identity(value) {
  return value;
};

var omit = function omit(obj, keys) {
  var _obj = _extends({}, obj),
      other = _objectWithoutProperties(_obj, []);

  if (keys) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        delete other[key];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return other;
};

exports.omit = omit;
var isPlainObject = exports.isPlainObject = function isPlainObject(obj) {
  return obj === Object(obj) && !(obj instanceof Date) && !Array.isArray(obj);
};

var compact = exports.compact = function compact(arr) {
  return (arr || []).filter(Boolean);
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var redux_1 = __webpack_require__(191);
var redux_logger_1 = __webpack_require__(1317);
var redux_thunk_1 = __importDefault(__webpack_require__(530));
var lodash_1 = __webpack_require__(2);
var Editor3_1 = __webpack_require__(193);
var actions_1 = __webpack_require__(24);
var fieldsMeta_1 = __webpack_require__(66);
var from_html_1 = __webpack_require__(124);
var editor3CustomData_1 = __webpack_require__(48);
var highlights_1 = __webpack_require__(41);
var removeFormat_1 = __webpack_require__(532);
var reducers_1 = __importDefault(__webpack_require__(1321));
var editor3StateToHtml_1 = __webpack_require__(88);
exports.ignoreInternalAnnotationFields = function (annotations) {
    return annotations.map(function (annotation) { return lodash_1.pick(annotation, ['id', 'type', 'body']); });
};
exports.isEditorPlainText = function (props) { return props.singleLine || (props.editorFormat || []).length === 0; };
/**
 * @name createEditorStore
 * @description Returns a new redux store.
 * @param {Object} props The properties of the editor (for Angular, the controller instance).
 * @param {Boolean=} isReact True if the store is created for a React component.
 * @returns {Object} Redux store.
 */
function createEditorStore(props, spellcheck, isReact) {
    if (isReact === void 0) { isReact = false; }
    var disableSpellchecker = true;
    if (spellcheck != null) {
        disableSpellchecker = props.disableSpellchecker || !spellcheck.isAutoSpellchecker;
        if (!props.disableSpellchecker) {
            spellcheck.setLanguage(props.language);
        }
    }
    var content = getInitialContent(props);
    var decorators = Editor3_1.Editor3Base.getDecorator(disableSpellchecker);
    var showToolbar = !exports.isEditorPlainText(props);
    var onChangeValue = isReact ? props.onChange : lodash_1.debounce(onChange.bind(props), props.debounce);
    var middlewares = [redux_thunk_1.default];
    var devtools = localStorage.getItem('devtools');
    var reduxLoggerEnabled = devtools == null ? false : JSON.stringify(devtools).includes('redux-logger');
    if (reduxLoggerEnabled) {
        // (this should always be the last middleware)
        middlewares.push(redux_logger_1.createLogger());
    }
    var store = redux_1.createStore(reducers_1.default, {
        editorState: draft_js_1.EditorState.createWithContent(content, decorators),
        searchTerm: { pattern: '', index: -1, caseSensitive: false },
        popup: { type: actions_1.PopupTypes.Hidden },
        readOnly: props.readOnly,
        locked: false,
        showToolbar: showToolbar,
        singleLine: props.singleLine,
        tabindex: props.tabindex,
        showTitle: props.showTitle,
        activeCell: null,
        editorFormat: props.editorFormat || [],
        onChangeValue: onChangeValue,
        item: props.item,
        spellcheckerEnabled: !props.disableSpellchecker,
        suggestingMode: false,
        invisibles: false,
        svc: props.svc,
        abbreviations: {},
    }, redux_1.applyMiddleware.apply(void 0, middlewares));
    if (spellcheck != null) {
        // after we have the dictionary, force update the editor to highlight typos
        spellcheck.getDict().finally(function () { return store.dispatch(actions_1.forceUpdate()); });
        spellcheck.getAbbreviationsDict().then(function (abbreviations) {
            store.dispatch(actions_1.setAbbreviations(abbreviations || {}));
        });
    }
    return store;
}
exports.default = createEditorStore;
/**
 * Generate item annotations field
 *
 * @param {Object} item
 */
function generateAnnotations(item) {
    item.annotations = exports.ignoreInternalAnnotationFields(editor3CustomData_1.getAnnotationsFromItem(item, 'body_html'));
}
/**
 * @name onChange
 * @params {ContentState} contentState New editor content state.
 * @params {Boolean} plainText If this is true, the editor content will be text instead of html
 * @description Triggered whenever the state of the editor changes. It takes the
 * current content states and updates the values of the host controller. This function
 * is bound to the controller, so 'this' points to controller attributes.
 */
function onChange(contentState, _a) {
    var _this = this;
    var _b = (_a === void 0 ? {} : _a).plainText, plainText = _b === void 0 ? false : _b;
    var pathToValue = this.pathToValue;
    if (pathToValue == null || pathToValue.length < 1) {
        throw new Error('pathToValue is required');
    }
    var decorativeStyles = ['HIGHLIGHT', 'HIGHLIGHT_STRONG'];
    var contentStateCleaned = removeFormat_1.removeInlineStyles(contentState, decorativeStyles);
    var contentStateHighlightsReadyForExport = highlights_1.prepareHighlightsForExport(draft_js_1.EditorState.createWithContent(contentStateCleaned)).getCurrentContent();
    var rawState = draft_js_1.convertToRaw(contentStateHighlightsReadyForExport);
    fieldsMeta_1.setFieldMetadata(this.item, pathToValue, fieldsMeta_1.fieldsMetaKeys.draftjsState, rawState);
    if (pathToValue === 'body_html') {
        syncAssociations(this.item, rawState);
    }
    // example: "extra.customField"
    var pathToValueArray = pathToValue.split(fieldsMeta_1.FIELD_KEY_SEPARATOR);
    var objectToUpdate = pathToValueArray.length < 2 ?
        this.item :
        pathToValueArray.slice(0, -1).reduce(function (obj, pathSegment) {
            if (obj[pathSegment] == null) {
                obj[pathSegment] = {};
            }
            return obj[pathSegment];
        }, this.item);
    var fieldName = pathToValueArray[pathToValueArray.length - 1];
    if (plainText) {
        objectToUpdate[fieldName] = contentStateHighlightsReadyForExport.getPlainText();
    }
    else {
        objectToUpdate[fieldName] = editor3StateToHtml_1.editor3StateToHtml(contentStateHighlightsReadyForExport);
        generateAnnotations(this.item);
    }
    // call on change with scope updated
    this.$rootScope.$applyAsync(function () {
        _this.onChange();
    });
}
exports.onChange = onChange;
/**
 * @name getInitialContent
 * @param {Object} props Controller hosting the editor
 * @returns {ContentState} DraftJS ContentState object.
 * @description Gets the initial content state of the editor based on available information.
 * If an editor state is available as saved in the DB, we use that, otherwise we attempt to
 * use available HTML. If none are available, an empty ContentState is created.
 */
function getInitialContent(props) {
    // support standalone instance of editor3 which is not connected to item field
    if (props.editorState != null) {
        var contentState = draft_js_1.convertFromRaw((props.editorState instanceof Array) ? props.editorState[0] : props.editorState);
        return highlights_1.initializeHighlights(draft_js_1.EditorState.createWithContent(contentState)).getCurrentContent();
    }
    var draftjsRawState = fieldsMeta_1.getFieldMetadata(props.item, props.pathToValue, fieldsMeta_1.fieldsMetaKeys.draftjsState);
    if (draftjsRawState != null) {
        var initialContent = draft_js_1.convertFromRaw(draftjsRawState);
        return highlights_1.initializeHighlights(draft_js_1.EditorState.createWithContent(initialContent)).getCurrentContent();
    }
    if (props.value) {
        // we have only HTML (possibly legacy editor2 or ingested item)
        return from_html_1.getContentStateFromHtml(props.value, props.item.associations);
    }
    return draft_js_1.ContentState.createFromText('');
}
exports.getInitialContent = getInitialContent;
/**
 * Sync editor embeds in item.associations
 *
 * @param {Object} item
 * @param {RawDraftContentState} rawState
 */
function syncAssociations(item, rawState) {
    var associations = Object.assign({}, item.associations);
    Object.keys(associations).forEach(function (key) {
        if (key.startsWith('editor_')) {
            associations[key] = null;
        }
    });
    Object.keys(rawState.entityMap).forEach(function (key) {
        associations['editor_' + key] = lodash_1.get(rawState.entityMap[key], 'data.media');
    });
    item.associations = associations;
}


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
exports.MEDIA_TYPES = {
    GALLERY: {
        id: 'media',
        label: utils_1.gettext('Media gallery'),
    },
    RELATED_CONTENT: {
        id: 'related_content',
        label: utils_1.gettext('Related items'),
    },
};
exports.MEDIA_TYPE_KEYS = Object.keys(exports.MEDIA_TYPES).map(function (type) { return exports.MEDIA_TYPES[type].id; });
exports.VOCABULARY_SELECTION_TYPES = {
    SINGLE_SELECTION: {
        id: 'single selection',
        label: utils_1.gettext('Single selection'),
    },
    MULTIPLE_SELECTION: {
        id: 'multi selection',
        label: utils_1.gettext('Multi selection'),
    },
    DO_NOT_SHOW: {
        id: 'do not show',
        label: utils_1.gettext('Do not show'),
    },
};
exports.DEFAULT_SCHEMA = {
    name: {},
    qcode: {},
    parent: {},
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(1680);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = __webpack_require__(1701);
exports.type = type_1.type;
var headline_1 = __webpack_require__(1702);
exports.headline = headline_1.headline;
var slugline_1 = __webpack_require__(1703);
exports.slugline = slugline_1.slugline;
var wordcount_1 = __webpack_require__(1704);
exports.wordcount = wordcount_1.wordcount;
var highlights_1 = __webpack_require__(1705);
exports.highlights = highlights_1.highlights;
var markedDesks_1 = __webpack_require__(1706);
exports.markedDesks = markedDesks_1.markedDesks;
var versioncreated_1 = __webpack_require__(1707);
exports.versioncreated = versioncreated_1.versioncreated;
var versioncreator_1 = __webpack_require__(1708);
exports.versioncreator = versioncreator_1.versioncreator;
var profile_1 = __webpack_require__(1709);
exports.profile = profile_1.profile;
var state_1 = __webpack_require__(559);
exports.state = state_1.state;
var embargo_1 = __webpack_require__(1710);
exports.embargo = embargo_1.embargo;
var update_1 = __webpack_require__(1711);
exports.update = update_1.update;
var updated_1 = __webpack_require__(1712);
exports.updated = updated_1.updated;
var takekey_1 = __webpack_require__(1713);
exports.takekey = takekey_1.takekey;
var signal_1 = __webpack_require__(1714);
exports.signal = signal_1.signal;
var broadcast_1 = __webpack_require__(1715);
exports.broadcast = broadcast_1.broadcast;
var flags_1 = __webpack_require__(1716);
exports.flags = flags_1.flags;
var category_1 = __webpack_require__(1717);
exports.category = category_1.category;
var provider_1 = __webpack_require__(1718);
exports.provider = provider_1.provider;
var expiry_1 = __webpack_require__(1719);
exports.expiry = expiry_1.expiry;
var desk_1 = __webpack_require__(1720);
exports.desk = desk_1.desk;
var fetchedDesk_1 = __webpack_require__(1721);
exports.fetchedDesk = fetchedDesk_1.fetchedDesk;
var priority_1 = __webpack_require__(1722);
exports.priority = priority_1.priority;
var urgency_1 = __webpack_require__(1723);
exports.urgency = urgency_1.urgency;
var associations_1 = __webpack_require__(1724);
exports.associations = associations_1.associations;
var queueError_1 = __webpack_require__(1725);
exports.queueError = queueError_1.queueError;
var assignment_1 = __webpack_require__(1726);
exports.assignment = assignment_1.assignment;
var language_1 = __webpack_require__(1727);
exports.language = language_1.language;
var copyright_1 = __webpack_require__(1728);
exports.copyright = copyright_1.copyright;
var usageterms_1 = __webpack_require__(1729);
exports.usageterms = usageterms_1.usageterms;
var nested_link_1 = __webpack_require__(1730);
exports.nestedlink = nested_link_1.nestedlink;
var associatedItems_1 = __webpack_require__(1731);
exports.associatedItems = associatedItems_1.associatedItems;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var DateFilters_1 = __webpack_require__(126);
var SearchService_1 = __webpack_require__(248);
// TODO: implement diffing
// server doesn't allow read-only fields in patch request
var removeReadOnlyUserSubscriberFields = function (subscription) { return ({
    user: subscription.user,
    scheduling: subscription.scheduling,
}); };
// TODO: implement diffing
// server doesn't allow read-only fields in patch request
var removeReadOnlyDeskSubscriberFields = function (subscription) { return ({
    desk: subscription.desk,
    scheduling: subscription.scheduling,
}); };
exports.isUserSubscribedToSavedSearch = function (_savedSearch, userId, getDesk) {
    var subscribers = _savedSearch.subscribers;
    if (subscribers == null) {
        return false;
    }
    if (subscribers.user_subscriptions.some(function (subscription) { return subscription.user === userId; })) {
        return true;
    }
    if (subscribers.desk_subscriptions.some(function (subscription) {
        var desk = getDesk(subscription.desk);
        return desk.members.includes(userId);
    })) {
        return true;
    }
    else {
        return false;
    }
};
exports.updateSubscribers = function (savedSearch, nextSubscribers, api) {
    var savedSearchNext = __assign({}, savedSearch, { subscribers: nextSubscribers });
    return saveOrUpdateSavedSearch(api, savedSearch, savedSearchNext);
};
exports.unsubscribeUser = function (savedSearch, userId, api) {
    var nextSubscribers = __assign({}, savedSearch.subscribers, { user_subscriptions: savedSearch.subscribers.user_subscriptions.filter(function (subscription) { return subscription.user !== userId; }) });
    return exports.updateSubscribers(savedSearch, nextSubscribers, api);
};
exports.unsubscribeDesk = function (savedSearch, deskId, api) {
    var nextSubscribers = __assign({}, savedSearch.subscribers, { desk_subscriptions: savedSearch.subscribers.desk_subscriptions.filter(function (subscription) { return subscription.desk !== deskId; }) });
    return exports.updateSubscribers(savedSearch, nextSubscribers, api);
};
function mapFiltersServerToClient(savedSearch) {
    if (typeof savedSearch.filter === 'object' && savedSearch.filter.hasOwnProperty('query')) {
        savedSearch.filter.query = SearchService_1.setFilters(savedSearch.filter.query);
        // after saving the item, filter value is string similar to
        // filter: "{"query": {"desk": "[\"5c04e596149f111ebc9d3da3\"]", "spike": "exclude"}}"
        // This check can be replaced with `!= null` check after SDESK-3698 is merged
    }
    return savedSearch;
}
exports.mapFiltersServerToClient = mapFiltersServerToClient;
function mapFiltersClientToServer(search) {
    var nextSearch = __assign({}, search);
    lodash_1.forOwn(nextSearch, function (value, key) {
        if (['priority', 'urgency'].includes(key)) {
            // Convert integer fields: priority and urgency to objects
            nextSearch[key] = JSON.parse(value);
        }
    });
    nextSearch = DateFilters_1.mapPredefinedDateFiltersClientToServer(nextSearch);
    return nextSearch;
}
function saveOrUpdateSavedSearch(api, savedSearchOriginal, savedSearchChanged) {
    if (savedSearchChanged.filter != null && savedSearchChanged.filter.query != null) {
        savedSearchChanged.filter.query = mapFiltersClientToServer(savedSearchChanged.filter.query);
    }
    if (savedSearchChanged.subscribers != null) {
        if (savedSearchChanged.subscribers.user_subscriptions != null) {
            savedSearchChanged.subscribers.user_subscriptions = savedSearchChanged.subscribers.user_subscriptions
                .map(removeReadOnlyUserSubscriberFields);
        }
        if (savedSearchChanged.subscribers.desk_subscriptions != null) {
            savedSearchChanged.subscribers.desk_subscriptions = savedSearchChanged.subscribers.desk_subscriptions
                .map(removeReadOnlyDeskSubscriberFields);
        }
    }
    return api('saved_searches').save(savedSearchOriginal, savedSearchChanged)
        .then(mapFiltersServerToClient);
}
exports.saveOrUpdateSavedSearch = saveOrUpdateSavedSearch;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseSortBar = /** @class */ (function () {
    function BaseSortBar(scope, elem, sortService) {
        this.scope = scope;
        this.sortService = sortService;
        this.scope.toggleDir = this.toggleDir.bind(this);
        this.scope.sort = this.sort.bind(this);
        this.scope.getActive = this.getActive.bind(this);
        this.scope.$on('$routeUpdate', this.scope.getActive);
    }
    BaseSortBar.prototype.getActive = function () {
        this.scope.active = this.sortService.getSort(this.scope.sortOptions);
    };
    BaseSortBar.prototype.toggleDir = function ($event) {
        this.sortService.toggleSortDir(this.scope.sortOptions);
    };
    BaseSortBar.prototype.sort = function (field) {
        this.sortService.setSort(field, this.scope.sortOptions);
    };
    BaseSortBar.prototype.canSort = function () {
        return true;
    };
    return BaseSortBar;
}());
exports.BaseSortBar = BaseSortBar;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sortbar\" ng-show=\"canSort()\">\n    <span ng-show=\"total\" translate>Total:</span>\n    <span ng-show=\"total\" class=\"label-total\">{{total}}</span>    \n    <div class=\"dropdown dropdown--align-right dropdown--hover\" dropdown>\n        <button id=\"order_button\" class=\"dropdown__toggle\" dropdown__toggle>\n            {{ active.label | translate }}\n            <span class=\"dropdown__caret\"></span>\n        </button>\n        <ul class=\"dropdown__menu\" id=\"order_selector\">\n            <li ng-repeat=\"option in sortOptions\" ng-class=\"{active: option === selected}\">\n                <a href=\"\" ng-click=\"sort(option.field)\">{{ option.label | translate }}</a>\n            </li>\n        </ul>\n    </div>\n    <button ng-click=\"toggleDir()\" class=\"icn-btn direction\" title=\"{{active.dir}}\">\n        <i class=\"icon-ascending\" ng-if=\"active.dir === 'asc'\"></i>\n        <i class=\"icon-descending\" ng-if=\"active.dir === 'desc'\"></i>\n    </button>\n</div>\n";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e75a5be1a5d982f59f85390c3e3ad1be.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(652);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsFetch: supportsFetch,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals __SUPERDESK_CONFIG__: true */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var appConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]};
var LANG_OVERRIDE = appConfig.langOverride || {};
/**
 * Add langOverride strings to catalog for given language
 *
 * @param {gettextCatalog} catalog
 * @param {String} lang
 */
function addLangOverride(catalog, lang) {
    catalog.setStrings(lang, lodash_1.get(LANG_OVERRIDE, lang, {}));
}
exports.addLangOverride = addLangOverride;
/**
 * Noop for registering string for translation in js files.
 *
 * This is supposed to be used in angular config phase,
 * where we can't use the translate service.
 *
 * And while this doesn't do much, you still have to call translate in template.
 *
 * @param {string} input
 * @return {string} unmodified input
 */
window.gettext = function (input) {
    return input;
};
var language_mapping_list_1 = __importDefault(__webpack_require__(663));
exports.default = language_mapping_list_1.default;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var isIE = isBrowser ? !!document.documentElement.currentStyle : false;
var hiddenTextarea = isBrowser && document.createElement('textarea');
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null || maxRows !== null) {
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      height = Math.min(maxHeight, height);
    }
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths

  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  return delete computedStyleCache[uid];
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

/**
 * <TextareaAutosize />
 */
var noop = function noop() {}; // IE11 has a problem with eval source maps, can be reproduced with:
// eval('"use strict"; var onNextFrame = window.cancelAnimationFrame; onNextFrame(4);')
// so we bind window as context in dev modes


var _ref = isBrowser && window.requestAnimationFrame ?  true ? [window.requestAnimationFrame, window.cancelAnimationFrame] : [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)] : [setTimeout, clearTimeout];
var onNextFrame = _ref[0];
var clearNextFrameAction = _ref[1];

var TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._resizeLock = false;

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      }
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event);
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      if (typeof _this._rootDOMNode === 'undefined') {
        callback();
        return;
      }

      var nodeHeight = calculateNodeHeight(_this._rootDOMNode, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount;
      _this.rowCount = rowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid();
    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _props = this.props,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ["minRows", "maxRows", "onHeightChange", "useCacheForDOMMeasurements", "inputRef"]);
    props.style = _extends({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        return _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    var _this3 = this;

    this._clearNextFrame();

    this._onNextFrameActionId = onNextFrame(function () {
      return _this3._resizeComponent();
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearNextFrame();

    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  _proto._clearNextFrame = function _clearNextFrame() {
    clearNextFrameAction(this._onNextFrameActionId);
  };

  return TextareaAutosize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextareaAutosize.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useCacheForDOMMeasurements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};

/* harmony default export */ __webpack_exports__["default"] = (TextareaAutosize);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.ModalHeader = function (props) { return (react_1.default.createElement("div", { className: "modal__header" },
    props.onClose &&
        react_1.default.createElement("button", { className: "modal__close pull-right", onClick: props.onClose },
            react_1.default.createElement("i", { className: "icon-close-small" })),
    react_1.default.createElement("h3", { className: "modal__heading" }, props.children))); };
exports.ModalHeader.propTypes = {
    children: prop_types_1.default.any.isRequired,
    onClose: prop_types_1.default.func,
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.ModalBody = function (props) { return (react_1.default.createElement("div", { className: "modal__body" }, props.children)); };
exports.ModalBody.propTypes = {
    children: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.ModalFooter = function (props) { return (react_1.default.createElement("div", { className: "modal__footer" }, props.children)); };
exports.ModalFooter.propTypes = {
    children: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_RESULT__;/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

// Full polyfill for browsers with no classList support
if (!("classList" in document.createElement("_"))) {
  (function (view) {

  "use strict";

  if (!('Element' in view)) return;

  var
      classListProp = "classList"
    , protoProp = "prototype"
    , elemCtrProto = view.Element[protoProp]
    , objCtr = Object
    , strTrim = String[protoProp].trim || function () {
      return this.replace(/^\s+|\s+$/g, "");
    }
    , arrIndexOf = Array[protoProp].indexOf || function (item) {
      var
          i = 0
        , len = this.length
      ;
      for (; i < len; i++) {
        if (i in this && this[i] === item) {
          return i;
        }
      }
      return -1;
    }
    // Vendors: please allow content code to instantiate DOMExceptions
    , DOMEx = function (type, message) {
      this.name = type;
      this.code = DOMException[type];
      this.message = message;
    }
    , checkTokenAndGetIndex = function (classList, token) {
      if (token === "") {
        throw new DOMEx(
            "SYNTAX_ERR"
          , "An invalid or illegal string was specified"
        );
      }
      if (/\s/.test(token)) {
        throw new DOMEx(
            "INVALID_CHARACTER_ERR"
          , "String contains an invalid character"
        );
      }
      return arrIndexOf.call(classList, token);
    }
    , ClassList = function (elem) {
      var
          trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
        , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
        , i = 0
        , len = classes.length
      ;
      for (; i < len; i++) {
        this.push(classes[i]);
      }
      this._updateClassName = function () {
        elem.setAttribute("class", this.toString());
      };
    }
    , classListProto = ClassList[protoProp] = []
    , classListGetter = function () {
      return new ClassList(this);
    }
  ;
  // Most DOMException implementations don't allow calling DOMException's toString()
  // on non-DOMExceptions. Error's toString() is sufficient here.
  DOMEx[protoProp] = Error[protoProp];
  classListProto.item = function (i) {
    return this[i] || null;
  };
  classListProto.contains = function (token) {
    token += "";
    return checkTokenAndGetIndex(this, token) !== -1;
  };
  classListProto.add = function () {
    var
        tokens = arguments
      , i = 0
      , l = tokens.length
      , token
      , updated = false
    ;
    do {
      token = tokens[i] + "";
      if (checkTokenAndGetIndex(this, token) === -1) {
        this.push(token);
        updated = true;
      }
    }
    while (++i < l);

    if (updated) {
      this._updateClassName();
    }
  };
  classListProto.remove = function () {
    var
        tokens = arguments
      , i = 0
      , l = tokens.length
      , token
      , updated = false
      , index
    ;
    do {
      token = tokens[i] + "";
      index = checkTokenAndGetIndex(this, token);
      while (index !== -1) {
        this.splice(index, 1);
        updated = true;
        index = checkTokenAndGetIndex(this, token);
      }
    }
    while (++i < l);

    if (updated) {
      this._updateClassName();
    }
  };
  classListProto.toggle = function (token, force) {
    token += "";

    var
        result = this.contains(token)
      , method = result ?
        force !== true && "remove"
      :
        force !== false && "add"
    ;

    if (method) {
      this[method](token);
    }

    if (force === true || force === false) {
      return force;
    } else {
      return !result;
    }
  };
  classListProto.toString = function () {
    return this.join(" ");
  };

  if (objCtr.defineProperty) {
    var classListPropDesc = {
        get: classListGetter
      , enumerable: true
      , configurable: true
    };
    try {
      objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
    } catch (ex) { // IE 8 doesn't support enumerable:true
      if (ex.number === -0x7FF5EC54) {
        classListPropDesc.enumerable = false;
        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
      }
    }
  } else if (objCtr[protoProp].__defineGetter__) {
    elemCtrProto.__defineGetter__(classListProp, classListGetter);
  }

  }(self));
}

/* Blob.js
 * A Blob implementation.
 * 2014-07-24
 *
 * By Eli Grey, http://eligrey.com
 * By Devin Samarin, https://github.com/dsamarin
 * License: X11/MIT
 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
 */

/*global self, unescape */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */

(function (view) {
  "use strict";

  view.URL = view.URL || view.webkitURL;

  if (view.Blob && view.URL) {
    try {
      new Blob;
      return;
    } catch (e) {}
  }

  // Internally we use a BlobBuilder implementation to base Blob off of
  // in order to support older browsers that only have BlobBuilder
  var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view) {
    var
        get_class = function(object) {
        return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
      }
      , FakeBlobBuilder = function BlobBuilder() {
        this.data = [];
      }
      , FakeBlob = function Blob(data, type, encoding) {
        this.data = data;
        this.size = data.length;
        this.type = type;
        this.encoding = encoding;
      }
      , FBB_proto = FakeBlobBuilder.prototype
      , FB_proto = FakeBlob.prototype
      , FileReaderSync = view.FileReaderSync
      , FileException = function(type) {
        this.code = this[this.name = type];
      }
      , file_ex_codes = (
          "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
        + "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
      ).split(" ")
      , file_ex_code = file_ex_codes.length
      , real_URL = view.URL || view.webkitURL || view
      , real_create_object_URL = real_URL.createObjectURL
      , real_revoke_object_URL = real_URL.revokeObjectURL
      , URL = real_URL
      , btoa = view.btoa
      , atob = view.atob

      , ArrayBuffer = view.ArrayBuffer
      , Uint8Array = view.Uint8Array

      , origin = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/
    ;
    FakeBlob.fake = FB_proto.fake = true;
    while (file_ex_code--) {
      FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
    }
    // Polyfill URL
    if (!real_URL.createObjectURL) {
      URL = view.URL = function(uri) {
        var
            uri_info = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
          , uri_origin
        ;
        uri_info.href = uri;
        if (!("origin" in uri_info)) {
          if (uri_info.protocol.toLowerCase() === "data:") {
            uri_info.origin = null;
          } else {
            uri_origin = uri.match(origin);
            uri_info.origin = uri_origin && uri_origin[1];
          }
        }
        return uri_info;
      };
    }
    URL.createObjectURL = function(blob) {
      var
          type = blob.type
        , data_URI_header
      ;
      if (type === null) {
        type = "application/octet-stream";
      }
      if (blob instanceof FakeBlob) {
        data_URI_header = "data:" + type;
        if (blob.encoding === "base64") {
          return data_URI_header + ";base64," + blob.data;
        } else if (blob.encoding === "URI") {
          return data_URI_header + "," + decodeURIComponent(blob.data);
        } if (btoa) {
          return data_URI_header + ";base64," + btoa(blob.data);
        } else {
          return data_URI_header + "," + encodeURIComponent(blob.data);
        }
      } else if (real_create_object_URL) {
        return real_create_object_URL.call(real_URL, blob);
      }
    };
    URL.revokeObjectURL = function(object_URL) {
      if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
        real_revoke_object_URL.call(real_URL, object_URL);
      }
    };
    FBB_proto.append = function(data/*, endings*/) {
      var bb = this.data;
      // decode data to a binary string
      if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
        var
            str = ""
          , buf = new Uint8Array(data)
          , i = 0
          , buf_len = buf.length
        ;
        for (; i < buf_len; i++) {
          str += String.fromCharCode(buf[i]);
        }
        bb.push(str);
      } else if (get_class(data) === "Blob" || get_class(data) === "File") {
        if (FileReaderSync) {
          var fr = new FileReaderSync;
          bb.push(fr.readAsBinaryString(data));
        } else {
          // async FileReader won't work as BlobBuilder is sync
          throw new FileException("NOT_READABLE_ERR");
        }
      } else if (data instanceof FakeBlob) {
        if (data.encoding === "base64" && atob) {
          bb.push(atob(data.data));
        } else if (data.encoding === "URI") {
          bb.push(decodeURIComponent(data.data));
        } else if (data.encoding === "raw") {
          bb.push(data.data);
        }
      } else {
        if (typeof data !== "string") {
          data += ""; // convert unsupported types to strings
        }
        // decode UTF-16 to binary string
        bb.push(unescape(encodeURIComponent(data)));
      }
    };
    FBB_proto.getBlob = function(type) {
      if (!arguments.length) {
        type = null;
      }
      return new FakeBlob(this.data.join(""), type, "raw");
    };
    FBB_proto.toString = function() {
      return "[object BlobBuilder]";
    };
    FB_proto.slice = function(start, end, type) {
      var args = arguments.length;
      if (args < 3) {
        type = null;
      }
      return new FakeBlob(
          this.data.slice(start, args > 1 ? end : this.data.length)
        , type
        , this.encoding
      );
    };
    FB_proto.toString = function() {
      return "[object Blob]";
    };
    FB_proto.close = function() {
      this.size = 0;
      delete this.data;
    };
    return FakeBlobBuilder;
  }(view));

  view.Blob = function(blobParts, options) {
    var type = options ? (options.type || "") : "";
    var builder = new BlobBuilder();
    if (blobParts) {
      for (var i = 0, len = blobParts.length; i < len; i++) {
        if (Uint8Array && blobParts[i] instanceof Uint8Array) {
          builder.append(blobParts[i].buffer);
        }
        else {
          builder.append(blobParts[i]);
        }
      }
    }
    var blob = builder.getBlob(type);
    if (!blob.slice && blob.webkitSlice) {
      blob.slice = blob.webkitSlice;
    }
    return blob;
  };

  var getPrototypeOf = Object.getPrototypeOf || function(object) {
    return object.__proto__;
  };
  view.Blob.prototype = getPrototypeOf(new view.Blob());
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));

(function (root, factory) {
    'use strict';
    var isElectron = typeof module === 'object' && typeof process !== 'undefined' && process && process.versions && process.versions.electron;
    if (!isElectron && typeof module === 'object') {
        module.exports = factory;
    } else if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return factory;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        root.MediumEditor = factory;
    }
}(this, function () {

    'use strict';

function MediumEditor(elements, options) {
    'use strict';
    return this.init(elements, options);
}

MediumEditor.extensions = {};
/*jshint unused: true */
(function (window) {
    'use strict';

    function copyInto(overwrite, dest) {
        var prop,
            sources = Array.prototype.slice.call(arguments, 2);
        dest = dest || {};
        for (var i = 0; i < sources.length; i++) {
            var source = sources[i];
            if (source) {
                for (prop in source) {
                    if (source.hasOwnProperty(prop) &&
                        typeof source[prop] !== 'undefined' &&
                        (overwrite || dest.hasOwnProperty(prop) === false)) {
                        dest[prop] = source[prop];
                    }
                }
            }
        }
        return dest;
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
    // Some browsers (including phantom) don't return true for Node.contains(child)
    // if child is a text node.  Detect these cases here and use a fallback
    // for calls to Util.isDescendant()
    var nodeContainsWorksWithTextNodes = false;
    try {
        var testParent = document.createElement('div'),
            testText = document.createTextNode(' ');
        testParent.appendChild(testText);
        nodeContainsWorksWithTextNodes = testParent.contains(testText);
    } catch (exc) {}

    var Util = {

        // http://stackoverflow.com/questions/17907445/how-to-detect-ie11#comment30165888_17907562
        // by rg89
        isIE: ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp('Trident/.*rv:([0-9]{1,}[.0-9]{0,})').exec(navigator.userAgent) !== null))),

        isEdge: (/Edge\/\d+/).exec(navigator.userAgent) !== null,

        // if firefox
        isFF: (navigator.userAgent.toLowerCase().indexOf('firefox') > -1),

        // http://stackoverflow.com/a/11752084/569101
        isMac: (window.navigator.platform.toUpperCase().indexOf('MAC') >= 0),

        // https://github.com/jashkenas/underscore
        // Lonely letter MUST USE the uppercase code
        keyCode: {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            SPACE: 32,
            DELETE: 46,
            K: 75, // K keycode, and not k
            M: 77,
            V: 86
        },

        /**
         * Returns true if it's metaKey on Mac, or ctrlKey on non-Mac.
         * See #591
         */
        isMetaCtrlKey: function (event) {
            if ((Util.isMac && event.metaKey) || (!Util.isMac && event.ctrlKey)) {
                return true;
            }

            return false;
        },

        /**
         * Returns true if the key associated to the event is inside keys array
         *
         * @see : https://github.com/jquery/jquery/blob/0705be475092aede1eddae01319ec931fb9c65fc/src/event.js#L473-L484
         * @see : http://stackoverflow.com/q/4471582/569101
         */
        isKey: function (event, keys) {
            var keyCode = Util.getKeyCode(event);

            // it's not an array let's just compare strings!
            if (false === Array.isArray(keys)) {
                return keyCode === keys;
            }

            if (-1 === keys.indexOf(keyCode)) {
                return false;
            }

            return true;
        },

        getKeyCode: function (event) {
            var keyCode = event.which;

            // getting the key code from event
            if (null === keyCode) {
                keyCode = event.charCode !== null ? event.charCode : event.keyCode;
            }

            return keyCode;
        },

        blockContainerElementNames: [
            // elements our editor generates
            'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'ul', 'li', 'ol',
            // all other known block elements
            'address', 'article', 'aside', 'audio', 'canvas', 'dd', 'dl', 'dt', 'fieldset',
            'figcaption', 'figure', 'footer', 'form', 'header', 'hgroup', 'main', 'nav',
            'noscript', 'output', 'section', 'video',
            'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td'
        ],

        emptyElementNames: ['br', 'col', 'colgroup', 'hr', 'img', 'input', 'source', 'wbr'],

        extend: function extend(/* dest, source1, source2, ...*/) {
            var args = [true].concat(Array.prototype.slice.call(arguments));
            return copyInto.apply(this, args);
        },

        defaults: function defaults(/*dest, source1, source2, ...*/) {
            var args = [false].concat(Array.prototype.slice.call(arguments));
            return copyInto.apply(this, args);
        },

        /*
         * Create a link around the provided text nodes which must be adjacent to each other and all be
         * descendants of the same closest block container. If the preconditions are not met, unexpected
         * behavior will result.
         */
        createLink: function (document, textNodes, href, target) {
            var anchor = document.createElement('a');
            Util.moveTextRangeIntoElement(textNodes[0], textNodes[textNodes.length - 1], anchor);
            anchor.setAttribute('href', href);
            if (target) {
                if (target === '_blank') {
                    anchor.setAttribute('rel', 'noopener noreferrer');
                }
                anchor.setAttribute('target', target);
            }
            return anchor;
        },

        /*
         * Given the provided match in the format {start: 1, end: 2} where start and end are indices into the
         * textContent of the provided element argument, modify the DOM inside element to ensure that the text
         * identified by the provided match can be returned as text nodes that contain exactly that text, without
         * any additional text at the beginning or end of the returned array of adjacent text nodes.
         *
         * The only DOM manipulation performed by this function is splitting the text nodes, non-text nodes are
         * not affected in any way.
         */
        findOrCreateMatchingTextNodes: function (document, element, match) {
            var treeWalker = document.createTreeWalker(element, NodeFilter.SHOW_ALL, null, false),
                matchedNodes = [],
                currentTextIndex = 0,
                startReached = false,
                currentNode = null,
                newNode = null;

            while ((currentNode = treeWalker.nextNode()) !== null) {
                if (currentNode.nodeType > 3) {
                    continue;
                } else if (currentNode.nodeType === 3) {
                    if (!startReached && match.start < (currentTextIndex + currentNode.nodeValue.length)) {
                        startReached = true;
                        newNode = Util.splitStartNodeIfNeeded(currentNode, match.start, currentTextIndex);
                    }
                    if (startReached) {
                        Util.splitEndNodeIfNeeded(currentNode, newNode, match.end, currentTextIndex);
                    }
                    if (startReached && currentTextIndex === match.end) {
                        break; // Found the node(s) corresponding to the link. Break out and move on to the next.
                    } else if (startReached && currentTextIndex > (match.end + 1)) {
                        throw new Error('PerformLinking overshot the target!'); // should never happen...
                    }

                    if (startReached) {
                        matchedNodes.push(newNode || currentNode);
                    }

                    currentTextIndex += currentNode.nodeValue.length;
                    if (newNode !== null) {
                        currentTextIndex += newNode.nodeValue.length;
                        // Skip the newNode as we'll already have pushed it to the matches
                        treeWalker.nextNode();
                    }
                    newNode = null;
                } else if (currentNode.tagName.toLowerCase() === 'img') {
                    if (!startReached && (match.start <= currentTextIndex)) {
                        startReached = true;
                    }
                    if (startReached) {
                        matchedNodes.push(currentNode);
                    }
                }
            }
            return matchedNodes;
        },

        /*
         * Given the provided text node and text coordinates, split the text node if needed to make it align
         * precisely with the coordinates.
         *
         * This function is intended to be called from Util.findOrCreateMatchingTextNodes.
         */
        splitStartNodeIfNeeded: function (currentNode, matchStartIndex, currentTextIndex) {
            if (matchStartIndex !== currentTextIndex) {
                return currentNode.splitText(matchStartIndex - currentTextIndex);
            }
            return null;
        },

        /*
         * Given the provided text node and text coordinates, split the text node if needed to make it align
         * precisely with the coordinates. The newNode argument should from the result of Util.splitStartNodeIfNeeded,
         * if that function has been called on the same currentNode.
         *
         * This function is intended to be called from Util.findOrCreateMatchingTextNodes.
         */
        splitEndNodeIfNeeded: function (currentNode, newNode, matchEndIndex, currentTextIndex) {
            var textIndexOfEndOfFarthestNode,
                endSplitPoint;
            textIndexOfEndOfFarthestNode = currentTextIndex + currentNode.nodeValue.length +
                    (newNode ? newNode.nodeValue.length : 0) - 1;
            endSplitPoint = matchEndIndex - currentTextIndex -
                    (newNode ? currentNode.nodeValue.length : 0);
            if (textIndexOfEndOfFarthestNode >= matchEndIndex &&
                    currentTextIndex !== textIndexOfEndOfFarthestNode &&
                    endSplitPoint !== 0) {
                (newNode || currentNode).splitText(endSplitPoint);
            }
        },

        /*
        * Take an element, and break up all of its text content into unique pieces such that:
         * 1) All text content of the elements are in separate blocks. No piece of text content should span
         *    across multiple blocks. This means no element return by this function should have
         *    any blocks as children.
         * 2) The union of the textcontent of all of the elements returned here covers all
         *    of the text within the element.
         *
         *
         * EXAMPLE:
         * In the event that we have something like:
         *
         * <blockquote>
         *   <p>Some Text</p>
         *   <ol>
         *     <li>List Item 1</li>
         *     <li>List Item 2</li>
         *   </ol>
         * </blockquote>
         *
         * This function would return these elements as an array:
         *   [ <p>Some Text</p>, <li>List Item 1</li>, <li>List Item 2</li> ]
         *
         * Since the <blockquote> and <ol> elements contain blocks within them they are not returned.
         * Since the <p> and <li>'s don't contain block elements and cover all the text content of the
         * <blockquote> container, they are the elements returned.
         */
        splitByBlockElements: function (element) {
            if (element.nodeType !== 3 && element.nodeType !== 1) {
                return [];
            }

            var toRet = [],
                blockElementQuery = MediumEditor.util.blockContainerElementNames.join(',');

            if (element.nodeType === 3 || element.querySelectorAll(blockElementQuery).length === 0) {
                return [element];
            }

            for (var i = 0; i < element.childNodes.length; i++) {
                var child = element.childNodes[i];
                if (child.nodeType === 3) {
                    toRet.push(child);
                } else if (child.nodeType === 1) {
                    var blockElements = child.querySelectorAll(blockElementQuery);
                    if (blockElements.length === 0) {
                        toRet.push(child);
                    } else {
                        toRet = toRet.concat(MediumEditor.util.splitByBlockElements(child));
                    }
                }
            }

            return toRet;
        },

        // Find the next node in the DOM tree that represents any text that is being
        // displayed directly next to the targetNode (passed as an argument)
        // Text that appears directly next to the current node can be:
        //  - A sibling text node
        //  - A descendant of a sibling element
        //  - A sibling text node of an ancestor
        //  - A descendant of a sibling element of an ancestor
        findAdjacentTextNodeWithContent: function findAdjacentTextNodeWithContent(rootNode, targetNode, ownerDocument) {
            var pastTarget = false,
                nextNode,
                nodeIterator = ownerDocument.createNodeIterator(rootNode, NodeFilter.SHOW_TEXT, null, false);

            // Use a native NodeIterator to iterate over all the text nodes that are descendants
            // of the rootNode.  Once past the targetNode, choose the first non-empty text node
            nextNode = nodeIterator.nextNode();
            while (nextNode) {
                if (nextNode === targetNode) {
                    pastTarget = true;
                } else if (pastTarget) {
                    if (nextNode.nodeType === 3 && nextNode.nodeValue && nextNode.nodeValue.trim().length > 0) {
                        break;
                    }
                }
                nextNode = nodeIterator.nextNode();
            }

            return nextNode;
        },

        // Find an element's previous sibling within a medium-editor element
        // If one doesn't exist, find the closest ancestor's previous sibling
        findPreviousSibling: function (node) {
            if (!node || Util.isMediumEditorElement(node)) {
                return false;
            }

            var previousSibling = node.previousSibling;
            while (!previousSibling && !Util.isMediumEditorElement(node.parentNode)) {
                node = node.parentNode;
                previousSibling = node.previousSibling;
            }

            return previousSibling;
        },

        isDescendant: function isDescendant(parent, child, checkEquality) {
            if (!parent || !child) {
                return false;
            }
            if (parent === child) {
                return !!checkEquality;
            }
            // If parent is not an element, it can't have any descendants
            if (parent.nodeType !== 1) {
                return false;
            }
            if (nodeContainsWorksWithTextNodes || child.nodeType !== 3) {
                return parent.contains(child);
            }
            var node = child.parentNode;
            while (node !== null) {
                if (node === parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        },

        // https://github.com/jashkenas/underscore
        isElement: function isElement(obj) {
            return !!(obj && obj.nodeType === 1);
        },

        // https://github.com/jashkenas/underscore
        throttle: function (func, wait) {
            var THROTTLE_INTERVAL = 50,
                context,
                args,
                result,
                timeout = null,
                previous = 0,
                later = function () {
                    previous = Date.now();
                    timeout = null;
                    result = func.apply(context, args);
                    if (!timeout) {
                        context = args = null;
                    }
                };

            if (!wait && wait !== 0) {
                wait = THROTTLE_INTERVAL;
            }

            return function () {
                var now = Date.now(),
                    remaining = wait - (now - previous);

                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout) {
                        context = args = null;
                    }
                } else if (!timeout) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        },

        traverseUp: function (current, testElementFunction) {
            if (!current) {
                return false;
            }

            do {
                if (current.nodeType === 1) {
                    if (testElementFunction(current)) {
                        return current;
                    }
                    // do not traverse upwards past the nearest containing editor
                    if (Util.isMediumEditorElement(current)) {
                        return false;
                    }
                }

                current = current.parentNode;
            } while (current);

            return false;
        },

        htmlEntities: function (str) {
            // converts special characters (like <) into their escaped/encoded values (like &lt;).
            // This allows you to show to display the string without the browser reading it as HTML.
            return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        },

        // http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
        insertHTMLCommand: function (doc, html) {
            var selection, range, el, fragment, node, lastNode, toReplace,
                res = false,
                ecArgs = ['insertHTML', false, html];

            /* Edge's implementation of insertHTML is just buggy right now:
             * - Doesn't allow leading white space at the beginning of an element
             * - Found a case when a <font size="2"> tag was inserted when calling alignCenter inside a blockquote
             *
             * There are likely other bugs, these are just the ones we found so far.
             * For now, let's just use the same fallback we did for IE
             */
            if (!MediumEditor.util.isEdge && doc.queryCommandSupported('insertHTML')) {
                try {
                    return doc.execCommand.apply(doc, ecArgs);
                } catch (ignore) {}
            }

            selection = doc.getSelection();
            if (selection.rangeCount) {
                range = selection.getRangeAt(0);
                toReplace = range.commonAncestorContainer;

                // https://github.com/yabwe/medium-editor/issues/748
                // If the selection is an empty editor element, create a temporary text node inside of the editor
                // and select it so that we don't delete the editor element
                if (Util.isMediumEditorElement(toReplace) && !toReplace.firstChild) {
                    range.selectNode(toReplace.appendChild(doc.createTextNode('')));
                } else if ((toReplace.nodeType === 3 && range.startOffset === 0 && range.endOffset === toReplace.nodeValue.length) ||
                        (toReplace.nodeType !== 3 && toReplace.innerHTML === range.toString())) {
                    // Ensure range covers maximum amount of nodes as possible
                    // By moving up the DOM and selecting ancestors whose only child is the range
                    while (!Util.isMediumEditorElement(toReplace) &&
                            toReplace.parentNode &&
                            toReplace.parentNode.childNodes.length === 1 &&
                            !Util.isMediumEditorElement(toReplace.parentNode)) {
                        toReplace = toReplace.parentNode;
                    }
                    range.selectNode(toReplace);
                }
                range.deleteContents();

                el = doc.createElement('div');
                el.innerHTML = html;
                fragment = doc.createDocumentFragment();
                while (el.firstChild) {
                    node = el.firstChild;
                    lastNode = fragment.appendChild(node);
                }
                range.insertNode(fragment);

                // Preserve the selection:
                if (lastNode) {
                    range = range.cloneRange();
                    range.setStartAfter(lastNode);
                    range.collapse(true);
                    MediumEditor.selection.selectRange(doc, range);
                }
                res = true;
            }

            // https://github.com/yabwe/medium-editor/issues/992
            // If we're monitoring calls to execCommand, notify listeners as if a real call had happened
            if (doc.execCommand.callListeners) {
                doc.execCommand.callListeners(ecArgs, res);
            }
            return res;
        },

        execFormatBlock: function (doc, tagName) {
            // Get the top level block element that contains the selection
            var blockContainer = Util.getTopBlockContainer(MediumEditor.selection.getSelectionStart(doc)),
                childNodes;

            // Special handling for blockquote
            if (tagName === 'blockquote') {
                if (blockContainer) {
                    childNodes = Array.prototype.slice.call(blockContainer.childNodes);
                    // Check if the blockquote has a block element as a child (nested blocks)
                    if (childNodes.some(function (childNode) {
                        return Util.isBlockContainer(childNode);
                    })) {
                        // FF handles blockquote differently on formatBlock
                        // allowing nesting, we need to use outdent
                        // https://developer.mozilla.org/en-US/docs/Rich-Text_Editing_in_Mozilla
                        return doc.execCommand('outdent', false, null);
                    }
                }

                // When IE blockquote needs to be called as indent
                // http://stackoverflow.com/questions/1816223/rich-text-editor-with-blockquote-function/1821777#1821777
                if (Util.isIE) {
                    return doc.execCommand('indent', false, tagName);
                }
            }

            // If the blockContainer is already the element type being passed in
            // treat it as 'undo' formatting and just convert it to a <p>
            if (blockContainer && tagName === blockContainer.nodeName.toLowerCase()) {
                tagName = 'p';
            }

            // When IE we need to add <> to heading elements
            // http://stackoverflow.com/questions/10741831/execcommand-formatblock-headings-in-ie
            if (Util.isIE) {
                tagName = '<' + tagName + '>';
            }

            // When FF, IE and Edge, we have to handle blockquote node seperately as 'formatblock' does not work.
            // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand#Commands
            if (blockContainer && blockContainer.nodeName.toLowerCase() === 'blockquote') {
                // For IE, just use outdent
                if (Util.isIE && tagName === '<p>') {
                    return doc.execCommand('outdent', false, tagName);
                }

                // For Firefox and Edge, make sure there's a nested block element before calling outdent
                if ((Util.isFF || Util.isEdge) && tagName === 'p') {
                    childNodes = Array.prototype.slice.call(blockContainer.childNodes);
                    // If there are some non-block elements we need to wrap everything in a <p> before we outdent
                    if (childNodes.some(function (childNode) {
                        return !Util.isBlockContainer(childNode);
                    })) {
                        doc.execCommand('formatBlock', false, tagName);
                    }
                    return doc.execCommand('outdent', false, tagName);
                }
            }

            return doc.execCommand('formatBlock', false, tagName);
        },

        /**
         * Set target to blank on the given el element
         *
         * TODO: not sure if this should be here
         *
         * When creating a link (using core -> createLink) the selection returned by Firefox will be the parent of the created link
         * instead of the created link itself (as it is for Chrome for example), so we retrieve all "a" children to grab the good one by
         * using `anchorUrl` to ensure that we are adding target="_blank" on the good one.
         * This isn't a bulletproof solution anyway ..
         */
        setTargetBlank: function (el, anchorUrl) {
            var i, url = anchorUrl || false;
            if (el.nodeName.toLowerCase() === 'a') {
                el.target = '_blank';
                el.rel = 'noopener noreferrer';
            } else {
                el = el.getElementsByTagName('a');

                for (i = 0; i < el.length; i += 1) {
                    if (false === url || url === el[i].attributes.href.value) {
                        el[i].target = '_blank';
                        el[i].rel = 'noopener noreferrer';
                    }
                }
            }
        },

        /*
         * this function is called to explicitly remove the target='_blank' as FF holds on to _blank value even
         * after unchecking the checkbox on anchor form
         */
        removeTargetBlank: function (el, anchorUrl) {
            var i;
            if (el.nodeName.toLowerCase() === 'a') {
                el.removeAttribute('target');
                el.removeAttribute('rel');
            } else {
                el = el.getElementsByTagName('a');

                for (i = 0; i < el.length; i += 1) {
                    if (anchorUrl === el[i].attributes.href.value) {
                        el[i].removeAttribute('target');
                        el[i].removeAttribute('rel');
                    }
                }
            }
        },

        /*
         * this function adds one or several classes on an a element.
         * if el parameter is not an a, it will look for a children of el.
         * if no a children are found, it will look for the a parent.
         */
        addClassToAnchors: function (el, buttonClass) {
            var classes = buttonClass.split(' '),
                i,
                j;
            if (el.nodeName.toLowerCase() === 'a') {
                for (j = 0; j < classes.length; j += 1) {
                    el.classList.add(classes[j]);
                }
            } else {
                var aChildren = el.getElementsByTagName('a');
                if (aChildren.length === 0) {
                    var parentAnchor = Util.getClosestTag(el, 'a');
                    el = parentAnchor ? [parentAnchor] : [];
                } else {
                    el = aChildren;
                }
                for (i = 0; i < el.length; i += 1) {
                    for (j = 0; j < classes.length; j += 1) {
                        el[i].classList.add(classes[j]);
                    }
                }
            }
        },

        isListItem: function (node) {
            if (!node) {
                return false;
            }
            if (node.nodeName.toLowerCase() === 'li') {
                return true;
            }

            var parentNode = node.parentNode,
                tagName = parentNode.nodeName.toLowerCase();
            while (tagName === 'li' || (!Util.isBlockContainer(parentNode) && tagName !== 'div')) {
                if (tagName === 'li') {
                    return true;
                }
                parentNode = parentNode.parentNode;
                if (parentNode) {
                    tagName = parentNode.nodeName.toLowerCase();
                } else {
                    return false;
                }
            }
            return false;
        },

        cleanListDOM: function (ownerDocument, element) {
            if (element.nodeName.toLowerCase() !== 'li') {
                return;
            }

            var list = element.parentElement;

            if (list.parentElement.nodeName.toLowerCase() === 'p') { // yes we need to clean up
                Util.unwrap(list.parentElement, ownerDocument);

                // move cursor at the end of the text inside the list
                // for some unknown reason, the cursor is moved to end of the "visual" line
                MediumEditor.selection.moveCursor(ownerDocument, element.firstChild, element.firstChild.textContent.length);
            }
        },

        /* splitDOMTree
         *
         * Given a root element some descendant element, split the root element
         * into its own element containing the descendant element and all elements
         * on the left or right side of the descendant ('right' is default)
         *
         * example:
         *
         *         <div>
         *      /    |   \
         *  <span> <span> <span>
         *   / \    / \    / \
         *  1   2  3   4  5   6
         *
         *  If I wanted to split this tree given the <div> as the root and "4" as the leaf
         *  the result would be (the prime ' marks indicates nodes that are created as clones):
         *
         *   SPLITTING OFF 'RIGHT' TREE       SPLITTING OFF 'LEFT' TREE
         *
         *     <div>            <div>'              <div>'      <div>
         *      / \              / \                 / \          |
         * <span> <span>   <span>' <span>       <span> <span>   <span>
         *   / \    |        |      / \           /\     /\       /\
         *  1   2   3        4     5   6         1  2   3  4     5  6
         *
         *  The above example represents splitting off the 'right' or 'left' part of a tree, where
         *  the <div>' would be returned as an element not appended to the DOM, and the <div>
         *  would remain in place where it was
         *
        */
        splitOffDOMTree: function (rootNode, leafNode, splitLeft) {
            var splitOnNode = leafNode,
                createdNode = null,
                splitRight = !splitLeft;

            // loop until we hit the root
            while (splitOnNode !== rootNode) {
                var currParent = splitOnNode.parentNode,
                    newParent = currParent.cloneNode(false),
                    targetNode = (splitRight ? splitOnNode : currParent.firstChild),
                    appendLast;

                // Create a new parent element which is a clone of the current parent
                if (createdNode) {
                    if (splitRight) {
                        // If we're splitting right, add previous created element before siblings
                        newParent.appendChild(createdNode);
                    } else {
                        // If we're splitting left, add previous created element last
                        appendLast = createdNode;
                    }
                }
                createdNode = newParent;

                while (targetNode) {
                    var sibling = targetNode.nextSibling;
                    // Special handling for the 'splitNode'
                    if (targetNode === splitOnNode) {
                        if (!targetNode.hasChildNodes()) {
                            targetNode.parentNode.removeChild(targetNode);
                        } else {
                            // For the node we're splitting on, if it has children, we need to clone it
                            // and not just move it
                            targetNode = targetNode.cloneNode(false);
                        }
                        // If the resulting split node has content, add it
                        if (targetNode.textContent) {
                            createdNode.appendChild(targetNode);
                        }

                        targetNode = (splitRight ? sibling : null);
                    } else {
                        // For general case, just remove the element and only
                        // add it to the split tree if it contains something
                        targetNode.parentNode.removeChild(targetNode);
                        if (targetNode.hasChildNodes() || targetNode.textContent) {
                            createdNode.appendChild(targetNode);
                        }

                        targetNode = sibling;
                    }
                }

                // If we had an element we wanted to append at the end, do that now
                if (appendLast) {
                    createdNode.appendChild(appendLast);
                }

                splitOnNode = currParent;
            }

            return createdNode;
        },

        moveTextRangeIntoElement: function (startNode, endNode, newElement) {
            if (!startNode || !endNode) {
                return false;
            }

            var rootNode = Util.findCommonRoot(startNode, endNode);
            if (!rootNode) {
                return false;
            }

            if (endNode === startNode) {
                var temp = startNode.parentNode,
                    sibling = startNode.nextSibling;
                temp.removeChild(startNode);
                newElement.appendChild(startNode);
                if (sibling) {
                    temp.insertBefore(newElement, sibling);
                } else {
                    temp.appendChild(newElement);
                }
                return newElement.hasChildNodes();
            }

            // create rootChildren array which includes all the children
            // we care about
            var rootChildren = [],
                firstChild,
                lastChild,
                nextNode;
            for (var i = 0; i < rootNode.childNodes.length; i++) {
                nextNode = rootNode.childNodes[i];
                if (!firstChild) {
                    if (Util.isDescendant(nextNode, startNode, true)) {
                        firstChild = nextNode;
                    }
                } else {
                    if (Util.isDescendant(nextNode, endNode, true)) {
                        lastChild = nextNode;
                        break;
                    } else {
                        rootChildren.push(nextNode);
                    }
                }
            }

            var afterLast = lastChild.nextSibling,
                fragment = rootNode.ownerDocument.createDocumentFragment();

            // build up fragment on startNode side of tree
            if (firstChild === startNode) {
                firstChild.parentNode.removeChild(firstChild);
                fragment.appendChild(firstChild);
            } else {
                fragment.appendChild(Util.splitOffDOMTree(firstChild, startNode));
            }

            // add any elements between firstChild & lastChild
            rootChildren.forEach(function (element) {
                element.parentNode.removeChild(element);
                fragment.appendChild(element);
            });

            // build up fragment on endNode side of the tree
            if (lastChild === endNode) {
                lastChild.parentNode.removeChild(lastChild);
                fragment.appendChild(lastChild);
            } else {
                fragment.appendChild(Util.splitOffDOMTree(lastChild, endNode, true));
            }

            // Add fragment into passed in element
            newElement.appendChild(fragment);

            if (lastChild.parentNode === rootNode) {
                // If last child is in the root, insert newElement in front of it
                rootNode.insertBefore(newElement, lastChild);
            } else if (afterLast) {
                // If last child was removed, but it had a sibling, insert in front of it
                rootNode.insertBefore(newElement, afterLast);
            } else {
                // lastChild was removed and was the last actual element just append
                rootNode.appendChild(newElement);
            }

            return newElement.hasChildNodes();
        },

        /* based on http://stackoverflow.com/a/6183069 */
        depthOfNode: function (inNode) {
            var theDepth = 0,
                node = inNode;
            while (node.parentNode !== null) {
                node = node.parentNode;
                theDepth++;
            }
            return theDepth;
        },

        findCommonRoot: function (inNode1, inNode2) {
            var depth1 = Util.depthOfNode(inNode1),
                depth2 = Util.depthOfNode(inNode2),
                node1 = inNode1,
                node2 = inNode2;

            while (depth1 !== depth2) {
                if (depth1 > depth2) {
                    node1 = node1.parentNode;
                    depth1 -= 1;
                } else {
                    node2 = node2.parentNode;
                    depth2 -= 1;
                }
            }

            while (node1 !== node2) {
                node1 = node1.parentNode;
                node2 = node2.parentNode;
            }

            return node1;
        },
        /* END - based on http://stackoverflow.com/a/6183069 */

        isElementAtBeginningOfBlock: function (node) {
            var textVal,
                sibling;
            while (!Util.isBlockContainer(node) && !Util.isMediumEditorElement(node)) {
                sibling = node;
                while (sibling = sibling.previousSibling) {
                    textVal = sibling.nodeType === 3 ? sibling.nodeValue : sibling.textContent;
                    if (textVal.length > 0) {
                        return false;
                    }
                }
                node = node.parentNode;
            }
            return true;
        },

        isMediumEditorElement: function (element) {
            return element && element.getAttribute && !!element.getAttribute('data-medium-editor-element');
        },

        getContainerEditorElement: function (element) {
            return Util.traverseUp(element, function (node) {
                return Util.isMediumEditorElement(node);
            });
        },

        isBlockContainer: function (element) {
            return element && element.nodeType !== 3 && Util.blockContainerElementNames.indexOf(element.nodeName.toLowerCase()) !== -1;
        },

        /* Finds the closest ancestor which is a block container element
         * If element is within editor element but not within any other block element,
         * the editor element is returned
         */
        getClosestBlockContainer: function (node) {
            return Util.traverseUp(node, function (node) {
                return Util.isBlockContainer(node) || Util.isMediumEditorElement(node);
            });
        },

        /* Finds highest level ancestor element which is a block container element
         * If element is within editor element but not within any other block element,
         * the editor element is returned
         */
        getTopBlockContainer: function (element) {
            var topBlock = Util.isBlockContainer(element) ? element : false;
            Util.traverseUp(element, function (el) {
                if (Util.isBlockContainer(el)) {
                    topBlock = el;
                }
                if (!topBlock && Util.isMediumEditorElement(el)) {
                    topBlock = el;
                    return true;
                }
                return false;
            });
            return topBlock;
        },

        getFirstSelectableLeafNode: function (element) {
            while (element && element.firstChild) {
                element = element.firstChild;
            }

            // We don't want to set the selection to an element that can't have children, this messes up Gecko.
            element = Util.traverseUp(element, function (el) {
                return Util.emptyElementNames.indexOf(el.nodeName.toLowerCase()) === -1;
            });
            // Selecting at the beginning of a table doesn't work in PhantomJS.
            if (element.nodeName.toLowerCase() === 'table') {
                var firstCell = element.querySelector('th, td');
                if (firstCell) {
                    element = firstCell;
                }
            }
            return element;
        },

        // TODO: remove getFirstTextNode AND _getFirstTextNode when jumping in 6.0.0 (no code references)
        getFirstTextNode: function (element) {
            Util.warn('getFirstTextNode is deprecated and will be removed in version 6.0.0');
            return Util._getFirstTextNode(element);
        },

        _getFirstTextNode: function (element) {
            if (element.nodeType === 3) {
                return element;
            }

            for (var i = 0; i < element.childNodes.length; i++) {
                var textNode = Util._getFirstTextNode(element.childNodes[i]);
                if (textNode !== null) {
                    return textNode;
                }
            }
            return null;
        },

        ensureUrlHasProtocol: function (url) {
            if (url.indexOf('://') === -1) {
                return 'http://' + url;
            }
            return url;
        },

        warn: function () {
            if (window.console !== undefined && typeof window.console.warn === 'function') {
                window.console.warn.apply(window.console, arguments);
            }
        },

        deprecated: function (oldName, newName, version) {
            // simple deprecation warning mechanism.
            var m = oldName + ' is deprecated, please use ' + newName + ' instead.';
            if (version) {
                m += ' Will be removed in ' + version;
            }
            Util.warn(m);
        },

        deprecatedMethod: function (oldName, newName, args, version) {
            // run the replacement and warn when someone calls a deprecated method
            Util.deprecated(oldName, newName, version);
            if (typeof this[newName] === 'function') {
                this[newName].apply(this, args);
            }
        },

        cleanupAttrs: function (el, attrs) {
            attrs.forEach(function (attr) {
                el.removeAttribute(attr);
            });
        },

        cleanupTags: function (el, tags) {
            if (tags.indexOf(el.nodeName.toLowerCase()) !== -1) {
                el.parentNode.removeChild(el);
            }
        },

        unwrapTags: function (el, tags) {
            if (tags.indexOf(el.nodeName.toLowerCase()) !== -1) {
                MediumEditor.util.unwrap(el, document);
            }
        },

        // get the closest parent
        getClosestTag: function (el, tag) {
            return Util.traverseUp(el, function (element) {
                return element.nodeName.toLowerCase() === tag.toLowerCase();
            });
        },

        unwrap: function (el, doc) {
            var fragment = doc.createDocumentFragment(),
                nodes = Array.prototype.slice.call(el.childNodes);

            // cast nodeList to array since appending child
            // to a different node will alter length of el.childNodes
            for (var i = 0; i < nodes.length; i++) {
                fragment.appendChild(nodes[i]);
            }

            if (fragment.childNodes.length) {
                el.parentNode.replaceChild(fragment, el);
            } else {
                el.parentNode.removeChild(el);
            }
        },

        guid: function () {
            function _s4() {
                return Math
                    .floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }

            return _s4() + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + _s4() + _s4();
        }
    };

    MediumEditor.util = Util;
}(window));

(function () {
    'use strict';

    var Extension = function (options) {
        MediumEditor.util.extend(this, options);
    };

    Extension.extend = function (protoProps) {
        // magic extender thinger. mostly borrowed from backbone/goog.inherits
        // place this function on some thing you want extend-able.
        //
        // example:
        //
        //      function Thing(args){
        //          this.options = args;
        //      }
        //
        //      Thing.prototype = { foo: "bar" };
        //      Thing.extend = extenderify;
        //
        //      var ThingTwo = Thing.extend({ foo: "baz" });
        //
        //      var thingOne = new Thing(); // foo === "bar"
        //      var thingTwo = new ThingTwo(); // foo === "baz"
        //
        //      which seems like some simply shallow copy nonsense
        //      at first, but a lot more is going on there.
        //
        //      passing a `constructor` to the extend props
        //      will cause the instance to instantiate through that
        //      instead of the parent's constructor.

        var parent = this,
            child;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.

        if (protoProps && protoProps.hasOwnProperty('constructor')) {
            child = protoProps.constructor;
        } else {
            child = function () {
                return parent.apply(this, arguments);
            };
        }

        // das statics (.extend comes over, so your subclass can have subclasses too)
        MediumEditor.util.extend(child, parent);

        // Set the prototype chain to inherit from `parent`, without calling
        // `parent`'s constructor function.
        var Surrogate = function () {
            this.constructor = child;
        };
        Surrogate.prototype = parent.prototype;
        child.prototype = new Surrogate();

        if (protoProps) {
            MediumEditor.util.extend(child.prototype, protoProps);
        }

        // todo: $super?

        return child;
    };

    Extension.prototype = {
        /* init: [function]
         *
         * Called by MediumEditor during initialization.
         * The .base property will already have been set to
         * current instance of MediumEditor when this is called.
         * All helper methods will exist as well
         */
        init: function () {},

        /* base: [MediumEditor instance]
         *
         * If not overriden, this will be set to the current instance
         * of MediumEditor, before the init method is called
         */
        base: undefined,

        /* name: [string]
         *
         * 'name' of the extension, used for retrieving the extension.
         * If not set, MediumEditor will set this to be the key
         * used when passing the extension into MediumEditor via the
         * 'extensions' option
         */
        name: undefined,

        /* checkState: [function (node)]
         *
         * If implemented, this function will be called one or more times
         * the state of the editor & toolbar are updated.
         * When the state is updated, the editor does the following:
         *
         * 1) Find the parent node containing the current selection
         * 2) Call checkState on the extension, passing the node as an argument
         * 3) Get the parent node of the previous node
         * 4) Repeat steps #2 and #3 until we move outside the parent contenteditable
         */
        checkState: undefined,

        /* destroy: [function ()]
         *
         * This method should remove any created html, custom event handlers
         * or any other cleanup tasks that should be performed.
         * If implemented, this function will be called when MediumEditor's
         * destroy method has been called.
         */
        destroy: undefined,

        /* As alternatives to checkState, these functions provide a more structured
         * path to updating the state of an extension (usually a button) whenever
         * the state of the editor & toolbar are updated.
         */

        /* queryCommandState: [function ()]
         *
         * If implemented, this function will be called once on each extension
         * when the state of the editor/toolbar is being updated.
         *
         * If this function returns a non-null value, the extension will
         * be ignored as the code climbs the dom tree.
         *
         * If this function returns true, and the setActive() function is defined
         * setActive() will be called
         */
        queryCommandState: undefined,

        /* isActive: [function ()]
         *
         * If implemented, this function will be called when MediumEditor
         * has determined that this extension is 'active' for the current selection.
         * This may be called when the editor & toolbar are being updated,
         * but only if queryCommandState() or isAlreadyApplied() functions
         * are implemented, and when called, return true.
         */
        isActive: undefined,

        /* isAlreadyApplied: [function (node)]
         *
         * If implemented, this function is similar to checkState() in
         * that it will be called repeatedly as MediumEditor moves up
         * the DOM to update the editor & toolbar after a state change.
         *
         * NOTE: This function will NOT be called if checkState() has
         * been implemented. This function will NOT be called if
         * queryCommandState() is implemented and returns a non-null
         * value when called
         */
        isAlreadyApplied: undefined,

        /* setActive: [function ()]
         *
         * If implemented, this function is called when MediumEditor knows
         * that this extension is currently enabled.  Currently, this
         * function is called when updating the editor & toolbar, and
         * only if queryCommandState() or isAlreadyApplied(node) return
         * true when called
         */
        setActive: undefined,

        /* setInactive: [function ()]
         *
         * If implemented, this function is called when MediumEditor knows
         * that this extension is currently disabled.  Curently, this
         * is called at the beginning of each state change for
         * the editor & toolbar. After calling this, MediumEditor
         * will attempt to update the extension, either via checkState()
         * or the combination of queryCommandState(), isAlreadyApplied(node),
         * isActive(), and setActive()
         */
        setInactive: undefined,

        /* getInteractionElements: [function ()]
         *
         * If the extension renders any elements that the user can interact with,
         * this method should be implemented and return the root element or an array
         * containing all of the root elements. MediumEditor will call this function
         * during interaction to see if the user clicked on something outside of the editor.
         * The elements are used to check if the target element of a click or
         * other user event is a descendant of any extension elements.
         * This way, the editor can also count user interaction within editor elements as
         * interactions with the editor, and thus not trigger 'blur'
         */
        getInteractionElements: undefined,

        /************************ Helpers ************************
         * The following are helpers that are either set by MediumEditor
         * during initialization, or are helper methods which either
         * route calls to the MediumEditor instance or provide common
         * functionality for all extensions
         *********************************************************/

        /* window: [Window]
         *
         * If not overriden, this will be set to the window object
         * to be used by MediumEditor and its extensions.  This is
         * passed via the 'contentWindow' option to MediumEditor
         * and is the global 'window' object by default
         */
        'window': undefined,

        /* document: [Document]
         *
         * If not overriden, this will be set to the document object
         * to be used by MediumEditor and its extensions. This is
         * passed via the 'ownerDocument' optin to MediumEditor
         * and is the global 'document' object by default
         */
        'document': undefined,

        /* getEditorElements: [function ()]
         *
         * Helper function which returns an array containing
         * all the contenteditable elements for this instance
         * of MediumEditor
         */
        getEditorElements: function () {
            return this.base.elements;
        },

        /* getEditorId: [function ()]
         *
         * Helper function which returns a unique identifier
         * for this instance of MediumEditor
         */
        getEditorId: function () {
            return this.base.id;
        },

        /* getEditorOptions: [function (option)]
         *
         * Helper function which returns the value of an option
         * used to initialize this instance of MediumEditor
         */
        getEditorOption: function (option) {
            return this.base.options[option];
        }
    };

    /* List of method names to add to the prototype of Extension
     * Each of these methods will be defined as helpers that
     * just call directly into the MediumEditor instance.
     *
     * example for 'on' method:
     * Extension.prototype.on = function () {
     *     return this.base.on.apply(this.base, arguments);
     * }
     */
    [
        // general helpers
        'execAction',

        // event handling
        'on',
        'off',
        'subscribe',
        'trigger'

    ].forEach(function (helper) {
        Extension.prototype[helper] = function () {
            return this.base[helper].apply(this.base, arguments);
        };
    });

    MediumEditor.Extension = Extension;
})();

(function () {
    'use strict';

    function filterOnlyParentElements(node) {
        if (MediumEditor.util.isBlockContainer(node)) {
            return NodeFilter.FILTER_ACCEPT;
        } else {
            return NodeFilter.FILTER_SKIP;
        }
    }

    var Selection = {
        findMatchingSelectionParent: function (testElementFunction, contentWindow) {
            var selection = contentWindow.getSelection(),
                range,
                current;

            if (selection.rangeCount === 0) {
                return false;
            }

            range = selection.getRangeAt(0);
            current = range.commonAncestorContainer;

            return MediumEditor.util.traverseUp(current, testElementFunction);
        },

        getSelectionElement: function (contentWindow) {
            return this.findMatchingSelectionParent(function (el) {
                return MediumEditor.util.isMediumEditorElement(el);
            }, contentWindow);
        },

        // http://stackoverflow.com/questions/17678843/cant-restore-selection-after-html-modify-even-if-its-the-same-html
        // Tim Down
        exportSelection: function (root, doc) {
            if (!root) {
                return null;
            }

            var selectionState = null,
                selection = doc.getSelection();

            if (selection.rangeCount > 0) {
                var range = selection.getRangeAt(0),
                    preSelectionRange = range.cloneRange(),
                    start;

                preSelectionRange.selectNodeContents(root);
                preSelectionRange.setEnd(range.startContainer, range.startOffset);
                start = preSelectionRange.toString().length;

                selectionState = {
                    start: start,
                    end: start + range.toString().length
                };

                // Check to see if the selection starts with any images
                // if so we need to make sure the the beginning of the selection is
                // set correctly when importing selection
                if (this.doesRangeStartWithImages(range, doc)) {
                    selectionState.startsWithImage = true;
                }

                // Check to see if the selection has any trailing images
                // if so, this this means we need to look for them when we import selection
                var trailingImageCount = this.getTrailingImageCount(root, selectionState, range.endContainer, range.endOffset);
                if (trailingImageCount) {
                    selectionState.trailingImageCount = trailingImageCount;
                }

                // If start = 0 there may still be an empty paragraph before it, but we don't care.
                if (start !== 0) {
                    var emptyBlocksIndex = this.getIndexRelativeToAdjacentEmptyBlocks(doc, root, range.startContainer, range.startOffset);
                    if (emptyBlocksIndex !== -1) {
                        selectionState.emptyBlocksIndex = emptyBlocksIndex;
                    }
                }
            }

            return selectionState;
        },

        // http://stackoverflow.com/questions/17678843/cant-restore-selection-after-html-modify-even-if-its-the-same-html
        // Tim Down
        //
        // {object} selectionState - the selection to import
        // {DOMElement} root - the root element the selection is being restored inside of
        // {Document} doc - the document to use for managing selection
        // {boolean} [favorLaterSelectionAnchor] - defaults to false. If true, import the cursor immediately
        //      subsequent to an anchor tag if it would otherwise be placed right at the trailing edge inside the
        //      anchor. This cursor positioning, even though visually equivalent to the user, can affect behavior
        //      in MS IE.
        importSelection: function (selectionState, root, doc, favorLaterSelectionAnchor) {
            if (!selectionState || !root) {
                return;
            }

            var range = doc.createRange();
            range.setStart(root, 0);
            range.collapse(true);

            var node = root,
                nodeStack = [],
                charIndex = 0,
                foundStart = false,
                foundEnd = false,
                trailingImageCount = 0,
                stop = false,
                nextCharIndex,
                allowRangeToStartAtEndOfNode = false,
                lastTextNode = null;

            // When importing selection, the start of the selection may lie at the end of an element
            // or at the beginning of an element.  Since visually there is no difference between these 2
            // we will try to move the selection to the beginning of an element since this is generally
            // what users will expect and it's a more predictable behavior.
            //
            // However, there are some specific cases when we don't want to do this:
            //  1) We're attempting to move the cursor outside of the end of an anchor [favorLaterSelectionAnchor = true]
            //  2) The selection starts with an image, which is special since an image doesn't have any 'content'
            //     as far as selection and ranges are concerned
            //  3) The selection starts after a specified number of empty block elements (selectionState.emptyBlocksIndex)
            //
            // For these cases, we want the selection to start at a very specific location, so we should NOT
            // automatically move the cursor to the beginning of the first actual chunk of text
            if (favorLaterSelectionAnchor || selectionState.startsWithImage || typeof selectionState.emptyBlocksIndex !== 'undefined') {
                allowRangeToStartAtEndOfNode = true;
            }

            while (!stop && node) {
                // Only iterate over elements and text nodes
                if (node.nodeType > 3) {
                    node = nodeStack.pop();
                    continue;
                }

                // If we hit a text node, we need to add the amount of characters to the overall count
                if (node.nodeType === 3 && !foundEnd) {
                    nextCharIndex = charIndex + node.length;
                    // Check if we're at or beyond the start of the selection we're importing
                    if (!foundStart && selectionState.start >= charIndex && selectionState.start <= nextCharIndex) {
                        // NOTE: We only want to allow a selection to start at the END of an element if
                        //  allowRangeToStartAtEndOfNode is true
                        if (allowRangeToStartAtEndOfNode || selectionState.start < nextCharIndex) {
                            range.setStart(node, selectionState.start - charIndex);
                            foundStart = true;
                        }
                        // We're at the end of a text node where the selection could start but we shouldn't
                        // make the selection start here because allowRangeToStartAtEndOfNode is false.
                        // However, we should keep a reference to this node in case there aren't any more
                        // text nodes after this, so that we have somewhere to import the selection to
                        else {
                            lastTextNode = node;
                        }
                    }
                    // We've found the start of the selection, check if we're at or beyond the end of the selection we're importing
                    if (foundStart && selectionState.end >= charIndex && selectionState.end <= nextCharIndex) {
                        if (!selectionState.trailingImageCount) {
                            range.setEnd(node, selectionState.end - charIndex);
                            stop = true;
                        } else {
                            foundEnd = true;
                        }
                    }
                    charIndex = nextCharIndex;
                } else {
                    if (selectionState.trailingImageCount && foundEnd) {
                        if (node.nodeName.toLowerCase() === 'img') {
                            trailingImageCount++;
                        }
                        if (trailingImageCount === selectionState.trailingImageCount) {
                            // Find which index the image is in its parent's children
                            var endIndex = 0;
                            while (node.parentNode.childNodes[endIndex] !== node) {
                                endIndex++;
                            }
                            range.setEnd(node.parentNode, endIndex + 1);
                            stop = true;
                        }
                    }

                    if (!stop && node.nodeType === 1) {
                        // this is an element
                        // add all its children to the stack
                        var i = node.childNodes.length - 1;
                        while (i >= 0) {
                            nodeStack.push(node.childNodes[i]);
                            i -= 1;
                        }
                    }
                }

                if (!stop) {
                    node = nodeStack.pop();
                }
            }

            // If we've gone through the entire text but didn't find the beginning of a text node
            // to make the selection start at, we should fall back to starting the selection
            // at the END of the last text node we found
            if (!foundStart && lastTextNode) {
                range.setStart(lastTextNode, lastTextNode.length);
                range.setEnd(lastTextNode, lastTextNode.length);
            }

            if (typeof selectionState.emptyBlocksIndex !== 'undefined') {
                range = this.importSelectionMoveCursorPastBlocks(doc, root, selectionState.emptyBlocksIndex, range);
            }

            // If the selection is right at the ending edge of a link, put it outside the anchor tag instead of inside.
            if (favorLaterSelectionAnchor) {
                range = this.importSelectionMoveCursorPastAnchor(selectionState, range);
            }

            this.selectRange(doc, range);
        },

        // Utility method called from importSelection only
        importSelectionMoveCursorPastAnchor: function (selectionState, range) {
            var nodeInsideAnchorTagFunction = function (node) {
                return node.nodeName.toLowerCase() === 'a';
            };
            if (selectionState.start === selectionState.end &&
                    range.startContainer.nodeType === 3 &&
                    range.startOffset === range.startContainer.nodeValue.length &&
                    MediumEditor.util.traverseUp(range.startContainer, nodeInsideAnchorTagFunction)) {
                var prevNode = range.startContainer,
                    currentNode = range.startContainer.parentNode;
                while (currentNode !== null && currentNode.nodeName.toLowerCase() !== 'a') {
                    if (currentNode.childNodes[currentNode.childNodes.length - 1] !== prevNode) {
                        currentNode = null;
                    } else {
                        prevNode = currentNode;
                        currentNode = currentNode.parentNode;
                    }
                }
                if (currentNode !== null && currentNode.nodeName.toLowerCase() === 'a') {
                    var currentNodeIndex = null;
                    for (var i = 0; currentNodeIndex === null && i < currentNode.parentNode.childNodes.length; i++) {
                        if (currentNode.parentNode.childNodes[i] === currentNode) {
                            currentNodeIndex = i;
                        }
                    }
                    range.setStart(currentNode.parentNode, currentNodeIndex + 1);
                    range.collapse(true);
                }
            }
            return range;
        },

        // Uses the emptyBlocksIndex calculated by getIndexRelativeToAdjacentEmptyBlocks
        // to move the cursor back to the start of the correct paragraph
        importSelectionMoveCursorPastBlocks: function (doc, root, index, range) {
            var treeWalker = doc.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, filterOnlyParentElements, false),
                startContainer = range.startContainer,
                startBlock,
                targetNode,
                currIndex = 0;
            index = index || 1; // If index is 0, we still want to move to the next block

            // Chrome counts newlines and spaces that separate block elements as actual elements.
            // If the selection is inside one of these text nodes, and it has a previous sibling
            // which is a block element, we want the treewalker to start at the previous sibling
            // and NOT at the parent of the textnode
            if (startContainer.nodeType === 3 && MediumEditor.util.isBlockContainer(startContainer.previousSibling)) {
                startBlock = startContainer.previousSibling;
            } else {
                startBlock = MediumEditor.util.getClosestBlockContainer(startContainer);
            }

            // Skip over empty blocks until we hit the block we want the selection to be in
            while (treeWalker.nextNode()) {
                if (!targetNode) {
                    // Loop through all blocks until we hit the starting block element
                    if (startBlock === treeWalker.currentNode) {
                        targetNode = treeWalker.currentNode;
                    }
                } else {
                    targetNode = treeWalker.currentNode;
                    currIndex++;
                    // We hit the target index, bail
                    if (currIndex === index) {
                        break;
                    }
                    // If we find a non-empty block, ignore the emptyBlocksIndex and just put selection here
                    if (targetNode.textContent.length > 0) {
                        break;
                    }
                }
            }

            if (!targetNode) {
                targetNode = startBlock;
            }

            // We're selecting a high-level block node, so make sure the cursor gets moved into the deepest
            // element at the beginning of the block
            range.setStart(MediumEditor.util.getFirstSelectableLeafNode(targetNode), 0);

            return range;
        },

        // Returns -1 unless the cursor is at the beginning of a paragraph/block
        // If the paragraph/block is preceeded by empty paragraphs/block (with no text)
        // it will return the number of empty paragraphs before the cursor.
        // Otherwise, it will return 0, which indicates the cursor is at the beginning
        // of a paragraph/block, and not at the end of the paragraph/block before it
        getIndexRelativeToAdjacentEmptyBlocks: function (doc, root, cursorContainer, cursorOffset) {
            // If there is text in front of the cursor, that means there isn't only empty blocks before it
            if (cursorContainer.textContent.length > 0 && cursorOffset > 0) {
                return -1;
            }

            // Check if the block that contains the cursor has any other text in front of the cursor
            var node = cursorContainer;
            if (node.nodeType !== 3) {
                node = cursorContainer.childNodes[cursorOffset];
            }
            if (node) {
                // The element isn't at the beginning of a block, so it has content before it
                if (!MediumEditor.util.isElementAtBeginningOfBlock(node)) {
                    return -1;
                }

                var previousSibling = MediumEditor.util.findPreviousSibling(node);
                // If there is no previous sibling, this is the first text element in the editor
                if (!previousSibling) {
                    return -1;
                }
                // If the previous sibling has text, then there are no empty blocks before this
                else if (previousSibling.nodeValue) {
                    return -1;
                }
            }

            // Walk over block elements, counting number of empty blocks between last piece of text
            // and the block the cursor is in
            var closestBlock = MediumEditor.util.getClosestBlockContainer(cursorContainer),
                treeWalker = doc.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, filterOnlyParentElements, false),
                emptyBlocksCount = 0;
            while (treeWalker.nextNode()) {
                var blockIsEmpty = treeWalker.currentNode.textContent === '';
                if (blockIsEmpty || emptyBlocksCount > 0) {
                    emptyBlocksCount += 1;
                }
                if (treeWalker.currentNode === closestBlock) {
                    return emptyBlocksCount;
                }
                if (!blockIsEmpty) {
                    emptyBlocksCount = 0;
                }
            }

            return emptyBlocksCount;
        },

        // Returns true if the selection range begins with an image tag
        // Returns false if the range starts with any non empty text nodes
        doesRangeStartWithImages: function (range, doc) {
            if (range.startOffset !== 0 || range.startContainer.nodeType !== 1) {
                return false;
            }

            if (range.startContainer.nodeName.toLowerCase() === 'img') {
                return true;
            }

            var img = range.startContainer.querySelector('img');
            if (!img) {
                return false;
            }

            var treeWalker = doc.createTreeWalker(range.startContainer, NodeFilter.SHOW_ALL, null, false);
            while (treeWalker.nextNode()) {
                var next = treeWalker.currentNode;
                // If we hit the image, then there isn't any text before the image so
                // the image is at the beginning of the range
                if (next === img) {
                    break;
                }
                // If we haven't hit the iamge, but found text that contains content
                // then the range doesn't start with an image
                if (next.nodeValue) {
                    return false;
                }
            }

            return true;
        },

        getTrailingImageCount: function (root, selectionState, endContainer, endOffset) {
            // If the endOffset of a range is 0, the endContainer doesn't contain images
            // If the endContainer is a text node, there are no trailing images
            if (endOffset === 0 || endContainer.nodeType !== 1) {
                return 0;
            }

            // If the endContainer isn't an image, and doesn't have an image descendants
            // there are no trailing images
            if (endContainer.nodeName.toLowerCase() !== 'img' && !endContainer.querySelector('img')) {
                return 0;
            }

            var lastNode = endContainer.childNodes[endOffset - 1];
            while (lastNode.hasChildNodes()) {
                lastNode = lastNode.lastChild;
            }

            var node = root,
                nodeStack = [],
                charIndex = 0,
                foundStart = false,
                foundEnd = false,
                stop = false,
                nextCharIndex,
                trailingImages = 0;

            while (!stop && node) {
                // Only iterate over elements and text nodes
                if (node.nodeType > 3) {
                    node = nodeStack.pop();
                    continue;
                }

                if (node.nodeType === 3 && !foundEnd) {
                    trailingImages = 0;
                    nextCharIndex = charIndex + node.length;
                    if (!foundStart && selectionState.start >= charIndex && selectionState.start <= nextCharIndex) {
                        foundStart = true;
                    }
                    if (foundStart && selectionState.end >= charIndex && selectionState.end <= nextCharIndex) {
                        foundEnd = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    if (node.nodeName.toLowerCase() === 'img') {
                        trailingImages++;
                    }

                    if (node === lastNode) {
                        stop = true;
                    } else if (node.nodeType === 1) {
                        // this is an element
                        // add all its children to the stack
                        var i = node.childNodes.length - 1;
                        while (i >= 0) {
                            nodeStack.push(node.childNodes[i]);
                            i -= 1;
                        }
                    }
                }

                if (!stop) {
                    node = nodeStack.pop();
                }
            }

            return trailingImages;
        },

        // determine if the current selection contains any 'content'
        // content being any non-white space text or an image
        selectionContainsContent: function (doc) {
            var sel = doc.getSelection();

            // collapsed selection or selection withour range doesn't contain content
            if (!sel || sel.isCollapsed || !sel.rangeCount) {
                return false;
            }

            // if toString() contains any text, the selection contains some content
            if (sel.toString().trim() !== '') {
                return true;
            }

            // if selection contains only image(s), it will return empty for toString()
            // so check for an image manually
            var selectionNode = this.getSelectedParentElement(sel.getRangeAt(0));
            if (selectionNode) {
                if (selectionNode.nodeName.toLowerCase() === 'img' ||
                    (selectionNode.nodeType === 1 && selectionNode.querySelector('img'))) {
                    return true;
                }
            }

            return false;
        },

        selectionInContentEditableFalse: function (contentWindow) {
            // determine if the current selection is exclusively inside
            // a contenteditable="false", though treat the case of an
            // explicit contenteditable="true" inside a "false" as false.
            var sawtrue,
                sawfalse = this.findMatchingSelectionParent(function (el) {
                    var ce = el && el.getAttribute('contenteditable');
                    if (ce === 'true') {
                        sawtrue = true;
                    }
                    return el.nodeName !== '#text' && ce === 'false';
                }, contentWindow);

            return !sawtrue && sawfalse;
        },

        // http://stackoverflow.com/questions/4176923/html-of-selected-text
        // by Tim Down
        getSelectionHtml: function getSelectionHtml(doc) {
            var i,
                html = '',
                sel = doc.getSelection(),
                len,
                container;
            if (sel.rangeCount) {
                container = doc.createElement('div');
                for (i = 0, len = sel.rangeCount; i < len; i += 1) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;
            }
            return html;
        },

        /**
         *  Find the caret position within an element irrespective of any inline tags it may contain.
         *
         *  @param {DOMElement} An element containing the cursor to find offsets relative to.
         *  @param {Range} A Range representing cursor position. Will window.getSelection if none is passed.
         *  @return {Object} 'left' and 'right' attributes contain offsets from begining and end of Element
         */
        getCaretOffsets: function getCaretOffsets(element, range) {
            var preCaretRange, postCaretRange;

            if (!range) {
                range = window.getSelection().getRangeAt(0);
            }

            preCaretRange = range.cloneRange();
            postCaretRange = range.cloneRange();

            preCaretRange.selectNodeContents(element);
            preCaretRange.setEnd(range.endContainer, range.endOffset);

            postCaretRange.selectNodeContents(element);
            postCaretRange.setStart(range.endContainer, range.endOffset);

            return {
                left: preCaretRange.toString().length,
                right: postCaretRange.toString().length
            };
        },

        // http://stackoverflow.com/questions/15867542/range-object-get-selection-parent-node-chrome-vs-firefox
        rangeSelectsSingleNode: function (range) {
            var startNode = range.startContainer;
            return startNode === range.endContainer &&
                startNode.hasChildNodes() &&
                range.endOffset === range.startOffset + 1;
        },

        getSelectedParentElement: function (range) {
            if (!range) {
                return null;
            }

            // Selection encompasses a single element
            if (this.rangeSelectsSingleNode(range) && range.startContainer.childNodes[range.startOffset].nodeType !== 3) {
                return range.startContainer.childNodes[range.startOffset];
            }

            // Selection range starts inside a text node, so get its parent
            if (range.startContainer.nodeType === 3) {
                return range.startContainer.parentNode;
            }

            // Selection starts inside an element
            return range.startContainer;
        },

        getSelectedElements: function (doc) {
            var selection = doc.getSelection(),
                range,
                toRet,
                currNode;

            if (!selection.rangeCount || selection.isCollapsed || !selection.getRangeAt(0).commonAncestorContainer) {
                return [];
            }

            range = selection.getRangeAt(0);

            if (range.commonAncestorContainer.nodeType === 3) {
                toRet = [];
                currNode = range.commonAncestorContainer;
                while (currNode.parentNode && currNode.parentNode.childNodes.length === 1) {
                    toRet.push(currNode.parentNode);
                    currNode = currNode.parentNode;
                }

                return toRet;
            }

            return [].filter.call(range.commonAncestorContainer.getElementsByTagName('*'), function (el) {
                return (typeof selection.containsNode === 'function') ? selection.containsNode(el, true) : true;
            });
        },

        selectNode: function (node, doc) {
            var range = doc.createRange();
            range.selectNodeContents(node);
            this.selectRange(doc, range);
        },

        select: function (doc, startNode, startOffset, endNode, endOffset) {
            var range = doc.createRange();
            range.setStart(startNode, startOffset);
            if (endNode) {
                range.setEnd(endNode, endOffset);
            } else {
                range.collapse(true);
            }
            this.selectRange(doc, range);
            return range;
        },

        /**
         *  Clear the current highlighted selection and set the caret to the start or the end of that prior selection, defaults to end.
         *
         *  @param {DomDocument} doc            Current document
         *  @param {boolean} moveCursorToStart  A boolean representing whether or not to set the caret to the beginning of the prior selection.
         */
        clearSelection: function (doc, moveCursorToStart) {
            if (moveCursorToStart) {
                doc.getSelection().collapseToStart();
            } else {
                doc.getSelection().collapseToEnd();
            }
        },

        /**
         * Move cursor to the given node with the given offset.
         *
         * @param  {DomDocument} doc     Current document
         * @param  {DomElement}  node    Element where to jump
         * @param  {integer}     offset  Where in the element should we jump, 0 by default
         */
        moveCursor: function (doc, node, offset) {
            this.select(doc, node, offset);
        },

        getSelectionRange: function (ownerDocument) {
            var selection = ownerDocument.getSelection();
            if (selection.rangeCount === 0) {
                return null;
            }
            return selection.getRangeAt(0);
        },

        selectRange: function (ownerDocument, range) {
            var selection = ownerDocument.getSelection();

            selection.removeAllRanges();
            selection.addRange(range);
        },

        // http://stackoverflow.com/questions/1197401/how-can-i-get-the-element-the-caret-is-in-with-javascript-when-using-contentedi
        // by You
        getSelectionStart: function (ownerDocument) {
            var node = ownerDocument.getSelection().anchorNode,
                startNode = (node && node.nodeType === 3 ? node.parentNode : node);

            return startNode;
        }
    };

    MediumEditor.selection = Selection;
}());

(function () {
    'use strict';

    function isElementDescendantOfExtension(extensions, element) {
        if (!extensions) {
            return false;
        }

        return extensions.some(function (extension) {
            if (typeof extension.getInteractionElements !== 'function') {
                return false;
            }

            var extensionElements = extension.getInteractionElements();
            if (!extensionElements) {
                return false;
            }

            if (!Array.isArray(extensionElements)) {
                extensionElements = [extensionElements];
            }
            return extensionElements.some(function (el) {
                return MediumEditor.util.isDescendant(el, element, true);
            });
        });
    }

    var Events = function (instance) {
        this.base = instance;
        this.options = this.base.options;
        this.events = [];
        this.disabledEvents = {};
        this.customEvents = {};
        this.listeners = {};
    };

    Events.prototype = {
        InputEventOnContenteditableSupported: !MediumEditor.util.isIE && !MediumEditor.util.isEdge,

        // Helpers for event handling

        attachDOMEvent: function (targets, event, listener, useCapture) {
            var win = this.base.options.contentWindow,
                doc = this.base.options.ownerDocument;

            targets = MediumEditor.util.isElement(targets) || [win, doc].indexOf(targets) > -1 ? [targets] : targets;

            Array.prototype.forEach.call(targets, function (target) {
                target.addEventListener(event, listener, useCapture);
                this.events.push([target, event, listener, useCapture]);
            }.bind(this));
        },

        detachDOMEvent: function (targets, event, listener, useCapture) {
            var index, e,
                win = this.base.options.contentWindow,
                doc = this.base.options.ownerDocument;

            if (targets) {
                targets = MediumEditor.util.isElement(targets) || [win, doc].indexOf(targets) > -1 ? [targets] : targets;

                Array.prototype.forEach.call(targets, function (target) {
                    index = this.indexOfListener(target, event, listener, useCapture);
                    if (index !== -1) {
                        e = this.events.splice(index, 1)[0];
                        e[0].removeEventListener(e[1], e[2], e[3]);
                    }
                }.bind(this));
            }
        },

        indexOfListener: function (target, event, listener, useCapture) {
            var i, n, item;
            for (i = 0, n = this.events.length; i < n; i = i + 1) {
                item = this.events[i];
                if (item[0] === target && item[1] === event && item[2] === listener && item[3] === useCapture) {
                    return i;
                }
            }
            return -1;
        },

        detachAllDOMEvents: function () {
            var e = this.events.pop();
            while (e) {
                e[0].removeEventListener(e[1], e[2], e[3]);
                e = this.events.pop();
            }
        },

        detachAllEventsFromElement: function (element) {
            var filtered = this.events.filter(function (e) {
                return e && e[0].getAttribute && e[0].getAttribute('medium-editor-index') === element.getAttribute('medium-editor-index');
            });

            for (var i = 0, len = filtered.length; i < len; i++) {
                var e = filtered[i];
                this.detachDOMEvent(e[0], e[1], e[2], e[3]);
            }
        },

        // Attach all existing handlers to a new element
        attachAllEventsToElement: function (element) {
            if (this.listeners['editableInput']) {
                this.contentCache[element.getAttribute('medium-editor-index')] = element.innerHTML;
            }

            if (this.eventsCache) {
                this.eventsCache.forEach(function (e) {
                    this.attachDOMEvent(element, e['name'], e['handler'].bind(this));
                }, this);
            }
        },

        enableCustomEvent: function (event) {
            if (this.disabledEvents[event] !== undefined) {
                delete this.disabledEvents[event];
            }
        },

        disableCustomEvent: function (event) {
            this.disabledEvents[event] = true;
        },

        // custom events
        attachCustomEvent: function (event, listener) {
            this.setupListener(event);
            if (!this.customEvents[event]) {
                this.customEvents[event] = [];
            }
            this.customEvents[event].push(listener);
        },

        detachCustomEvent: function (event, listener) {
            var index = this.indexOfCustomListener(event, listener);
            if (index !== -1) {
                this.customEvents[event].splice(index, 1);
                // TODO: If array is empty, should detach internal listeners via destroyListener()
            }
        },

        indexOfCustomListener: function (event, listener) {
            if (!this.customEvents[event] || !this.customEvents[event].length) {
                return -1;
            }

            return this.customEvents[event].indexOf(listener);
        },

        detachAllCustomEvents: function () {
            this.customEvents = {};
            // TODO: Should detach internal listeners here via destroyListener()
        },

        triggerCustomEvent: function (name, data, editable) {
            if (this.customEvents[name] && !this.disabledEvents[name]) {
                this.customEvents[name].forEach(function (listener) {
                    listener(data, editable);
                });
            }
        },

        // Cleaning up

        destroy: function () {
            this.detachAllDOMEvents();
            this.detachAllCustomEvents();
            this.detachExecCommand();

            if (this.base.elements) {
                this.base.elements.forEach(function (element) {
                    element.removeAttribute('data-medium-focused');
                });
            }
        },

        // Listening to calls to document.execCommand

        // Attach a listener to be notified when document.execCommand is called
        attachToExecCommand: function () {
            if (this.execCommandListener) {
                return;
            }

            // Store an instance of the listener so:
            // 1) We only attach to execCommand once
            // 2) We can remove the listener later
            this.execCommandListener = function (execInfo) {
                this.handleDocumentExecCommand(execInfo);
            }.bind(this);

            // Ensure that execCommand has been wrapped correctly
            this.wrapExecCommand();

            // Add listener to list of execCommand listeners
            this.options.ownerDocument.execCommand.listeners.push(this.execCommandListener);
        },

        // Remove our listener for calls to document.execCommand
        detachExecCommand: function () {
            var doc = this.options.ownerDocument;
            if (!this.execCommandListener || !doc.execCommand.listeners) {
                return;
            }

            // Find the index of this listener in the array of listeners so it can be removed
            var index = doc.execCommand.listeners.indexOf(this.execCommandListener);
            if (index !== -1) {
                doc.execCommand.listeners.splice(index, 1);
            }

            // If the list of listeners is now empty, put execCommand back to its original state
            if (!doc.execCommand.listeners.length) {
                this.unwrapExecCommand();
            }
        },

        // Wrap document.execCommand in a custom method so we can listen to calls to it
        wrapExecCommand: function () {
            var doc = this.options.ownerDocument;

            // Ensure all instance of MediumEditor only wrap execCommand once
            if (doc.execCommand.listeners) {
                return;
            }

            // Helper method to call all listeners to execCommand
            var callListeners = function (args, result) {
                if (doc.execCommand.listeners) {
                    doc.execCommand.listeners.forEach(function (listener) {
                        listener({
                            command: args[0],
                            value: args[2],
                            args: args,
                            result: result
                        });
                    });
                }
            },

                // Create a wrapper method for execCommand which will:
                // 1) Call document.execCommand with the correct arguments
                // 2) Loop through any listeners and notify them that execCommand was called
                //    passing extra info on the call
                // 3) Return the result
                wrapper = function () {
                    var result = doc.execCommand.orig.apply(this, arguments);

                    if (!doc.execCommand.listeners) {
                        return result;
                    }

                    var args = Array.prototype.slice.call(arguments);
                    callListeners(args, result);

                    return result;
                };

            // Store a reference to the original execCommand
            wrapper.orig = doc.execCommand;

            // Attach an array for storing listeners
            wrapper.listeners = [];

            // Helper for notifying listeners
            wrapper.callListeners = callListeners;

            // Overwrite execCommand
            doc.execCommand = wrapper;
        },

        // Revert document.execCommand back to its original self
        unwrapExecCommand: function () {
            var doc = this.options.ownerDocument;
            if (!doc.execCommand.orig) {
                return;
            }

            // Use the reference to the original execCommand to revert back
            doc.execCommand = doc.execCommand.orig;
        },

        // Listening to browser events to emit events medium-editor cares about
        setupListener: function (name) {
            if (this.listeners[name]) {
                return;
            }

            switch (name) {
                case 'externalInteraction':
                    // Detecting when user has interacted with elements outside of MediumEditor
                    this.attachDOMEvent(this.options.ownerDocument.body, 'mousedown', this.handleBodyMousedown.bind(this), true);
                    this.attachDOMEvent(this.options.ownerDocument.body, 'click', this.handleBodyClick.bind(this), true);
                    this.attachDOMEvent(this.options.ownerDocument.body, 'focus', this.handleBodyFocus.bind(this), true);
                    break;
                case 'blur':
                    // Detecting when focus is lost
                    this.setupListener('externalInteraction');
                    break;
                case 'focus':
                    // Detecting when focus moves into some part of MediumEditor
                    this.setupListener('externalInteraction');
                    break;
                case 'editableInput':
                    // setup cache for knowing when the content has changed
                    this.contentCache = {};
                    this.base.elements.forEach(function (element) {
                        this.contentCache[element.getAttribute('medium-editor-index')] = element.innerHTML;
                    }, this);

                    // Attach to the 'oninput' event, handled correctly by most browsers
                    if (this.InputEventOnContenteditableSupported) {
                        this.attachToEachElement('input', this.handleInput);
                    }

                    // For browsers which don't support the input event on contenteditable (IE)
                    // we'll attach to 'selectionchange' on the document and 'keypress' on the editables
                    if (!this.InputEventOnContenteditableSupported) {
                        this.setupListener('editableKeypress');
                        this.keypressUpdateInput = true;
                        this.attachDOMEvent(document, 'selectionchange', this.handleDocumentSelectionChange.bind(this));
                        // Listen to calls to execCommand
                        this.attachToExecCommand();
                    }
                    break;
                case 'editableClick':
                    // Detecting click in the contenteditables
                    this.attachToEachElement('click', this.handleClick);
                    break;
                case 'editableBlur':
                    // Detecting blur in the contenteditables
                    this.attachToEachElement('blur', this.handleBlur);
                    break;
                case 'editableKeypress':
                    // Detecting keypress in the contenteditables
                    this.attachToEachElement('keypress', this.handleKeypress);
                    break;
                case 'editableKeyup':
                    // Detecting keyup in the contenteditables
                    this.attachToEachElement('keyup', this.handleKeyup);
                    break;
                case 'editableKeydown':
                    // Detecting keydown on the contenteditables
                    this.attachToEachElement('keydown', this.handleKeydown);
                    break;
                case 'editableKeydownSpace':
                    // Detecting keydown for SPACE on the contenteditables
                    this.setupListener('editableKeydown');
                    break;
                case 'editableKeydownEnter':
                    // Detecting keydown for ENTER on the contenteditables
                    this.setupListener('editableKeydown');
                    break;
                case 'editableKeydownTab':
                    // Detecting keydown for TAB on the contenteditable
                    this.setupListener('editableKeydown');
                    break;
                case 'editableKeydownDelete':
                    // Detecting keydown for DELETE/BACKSPACE on the contenteditables
                    this.setupListener('editableKeydown');
                    break;
                case 'editableMouseover':
                    // Detecting mouseover on the contenteditables
                    this.attachToEachElement('mouseover', this.handleMouseover);
                    break;
                case 'editableDrag':
                    // Detecting dragover and dragleave on the contenteditables
                    this.attachToEachElement('dragover', this.handleDragging);
                    this.attachToEachElement('dragleave', this.handleDragging);
                    break;
                case 'editableDrop':
                    // Detecting drop on the contenteditables
                    this.attachToEachElement('drop', this.handleDrop);
                    break;
                // TODO: We need to have a custom 'paste' event separate from 'editablePaste'
                // Need to think about the way to introduce this without breaking folks
                case 'editablePaste':
                    // Detecting paste on the contenteditables
                    this.attachToEachElement('paste', this.handlePaste);
                    break;
            }
            this.listeners[name] = true;
        },

        attachToEachElement: function (name, handler) {
            // build our internal cache to know which element got already what handler attached
            if (!this.eventsCache) {
                this.eventsCache = [];
            }

            this.base.elements.forEach(function (element) {
                this.attachDOMEvent(element, name, handler.bind(this));
            }, this);

            this.eventsCache.push({ 'name': name, 'handler': handler });
        },

        cleanupElement: function (element) {
            var index = element.getAttribute('medium-editor-index');
            if (index) {
                this.detachAllEventsFromElement(element);
                if (this.contentCache) {
                    delete this.contentCache[index];
                }
            }
        },

        focusElement: function (element) {
            element.focus();
            this.updateFocus(element, { target: element, type: 'focus' });
        },

        updateFocus: function (target, eventObj) {
            var hadFocus = this.base.getFocusedElement(),
                toFocus;

            // For clicks, we need to know if the mousedown that caused the click happened inside the existing focused element
            // or one of the extension elements.  If so, we don't want to focus another element
            if (hadFocus &&
                eventObj.type === 'click' &&
                this.lastMousedownTarget &&
                (MediumEditor.util.isDescendant(hadFocus, this.lastMousedownTarget, true) ||
                    isElementDescendantOfExtension(this.base.extensions, this.lastMousedownTarget))) {
                toFocus = hadFocus;
            }

            if (!toFocus) {
                this.base.elements.some(function (element) {
                    // If the target is part of an editor element, this is the element getting focus
                    if (!toFocus && (MediumEditor.util.isDescendant(element, target, true))) {
                        toFocus = element;
                    }

                    // bail if we found an element that's getting focus
                    return !!toFocus;
                }, this);
            }

            // Check if the target is external (not part of the editor, toolbar, or any other extension)
            var externalEvent = !MediumEditor.util.isDescendant(hadFocus, target, true) &&
                !isElementDescendantOfExtension(this.base.extensions, target);

            if (toFocus !== hadFocus) {
                // If element has focus, and focus is going outside of editor
                // Don't blur focused element if clicking on editor, toolbar, or anchorpreview
                if (hadFocus && externalEvent) {
                    // Trigger blur on the editable that has lost focus
                    hadFocus.removeAttribute('data-medium-focused');
                    this.triggerCustomEvent('blur', eventObj, hadFocus);
                }

                // If focus is going into an editor element
                if (toFocus) {
                    // Trigger focus on the editable that now has focus
                    toFocus.setAttribute('data-medium-focused', true);
                    this.triggerCustomEvent('focus', eventObj, toFocus);
                }
            }

            if (externalEvent) {
                this.triggerCustomEvent('externalInteraction', eventObj);
            }
        },

        updateInput: function (target, eventObj) {
            if (!this.contentCache) {
                return;
            }
            // An event triggered which signifies that the user may have changed someting
            // Look in our cache of input for the contenteditables to see if something changed
            var index = target.getAttribute('medium-editor-index'),
                html = target.innerHTML;

            if (html !== this.contentCache[index]) {
                // The content has changed since the last time we checked, fire the event
                this.triggerCustomEvent('editableInput', eventObj, target);
            }
            this.contentCache[index] = html;
        },

        handleDocumentSelectionChange: function (event) {
            // When selectionchange fires, target and current target are set
            // to document, since this is where the event is handled
            // However, currentTarget will have an 'activeElement' property
            // which will point to whatever element has focus.
            if (event.currentTarget && event.currentTarget.activeElement) {
                var activeElement = event.currentTarget.activeElement,
                    currentTarget;
                // We can look at the 'activeElement' to determine if the selectionchange has
                // happened within a contenteditable owned by this instance of MediumEditor
                this.base.elements.some(function (element) {
                    if (MediumEditor.util.isDescendant(element, activeElement, true)) {
                        currentTarget = element;
                        return true;
                    }
                    return false;
                }, this);

                // We know selectionchange fired within one of our contenteditables
                if (currentTarget) {
                    this.updateInput(currentTarget, { target: activeElement, currentTarget: currentTarget });
                }
            }
        },

        handleDocumentExecCommand: function () {
            // document.execCommand has been called
            // If one of our contenteditables currently has focus, we should
            // attempt to trigger the 'editableInput' event
            var target = this.base.getFocusedElement();
            if (target) {
                this.updateInput(target, { target: target, currentTarget: target });
            }
        },

        handleBodyClick: function (event) {
            this.updateFocus(event.target, event);
        },

        handleBodyFocus: function (event) {
            this.updateFocus(event.target, event);
        },

        handleBodyMousedown: function (event) {
            this.lastMousedownTarget = event.target;
        },

        handleInput: function (event) {
            this.updateInput(event.currentTarget, event);
        },

        handleClick: function (event) {
            this.triggerCustomEvent('editableClick', event, event.currentTarget);
        },

        handleBlur: function (event) {
            this.triggerCustomEvent('editableBlur', event, event.currentTarget);
        },

        handleKeypress: function (event) {
            this.triggerCustomEvent('editableKeypress', event, event.currentTarget);

            // If we're doing manual detection of the editableInput event we need
            // to check for input changes during 'keypress'
            if (this.keypressUpdateInput) {
                var eventObj = { target: event.target, currentTarget: event.currentTarget };

                // In IE, we need to let the rest of the event stack complete before we detect
                // changes to input, so using setTimeout here
                setTimeout(function () {
                    this.updateInput(eventObj.currentTarget, eventObj);
                }.bind(this), 0);
            }
        },

        handleKeyup: function (event) {
            this.triggerCustomEvent('editableKeyup', event, event.currentTarget);
        },

        handleMouseover: function (event) {
            this.triggerCustomEvent('editableMouseover', event, event.currentTarget);
        },

        handleDragging: function (event) {
            this.triggerCustomEvent('editableDrag', event, event.currentTarget);
        },

        handleDrop: function (event) {
            this.triggerCustomEvent('editableDrop', event, event.currentTarget);
        },

        handlePaste: function (event) {
            this.triggerCustomEvent('editablePaste', event, event.currentTarget);
        },

        handleKeydown: function (event) {

            this.triggerCustomEvent('editableKeydown', event, event.currentTarget);

            if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.SPACE)) {
                return this.triggerCustomEvent('editableKeydownSpace', event, event.currentTarget);
            }

            if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.ENTER) || (event.ctrlKey && MediumEditor.util.isKey(event, MediumEditor.util.keyCode.M))) {
                return this.triggerCustomEvent('editableKeydownEnter', event, event.currentTarget);
            }

            if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.TAB)) {
                return this.triggerCustomEvent('editableKeydownTab', event, event.currentTarget);
            }

            if (MediumEditor.util.isKey(event, [MediumEditor.util.keyCode.DELETE, MediumEditor.util.keyCode.BACKSPACE])) {
                return this.triggerCustomEvent('editableKeydownDelete', event, event.currentTarget);
            }
        }
    };

    MediumEditor.Events = Events;
}());

(function () {
    'use strict';

    var Button = MediumEditor.Extension.extend({

        /* Button Options */

        /* action: [string]
         * The action argument to pass to MediumEditor.execAction()
         * when the button is clicked
         */
        action: undefined,

        /* aria: [string]
         * The value to add as the aria-label attribute of the button
         * element displayed in the toolbar.
         * This is also used as the tooltip for the button
         */
        aria: undefined,

        /* tagNames: [Array]
         * NOTE: This is not used if useQueryState is set to true.
         *
         * Array of element tag names that would indicate that this
         * button has already been applied. If this action has already
         * been applied, the button will be displayed as 'active' in the toolbar
         *
         * Example:
         * For 'bold', if the text is ever within a <b> or <strong>
         * tag that indicates the text is already bold. So the array
         * of tagNames for bold would be: ['b', 'strong']
         */
        tagNames: undefined,

        /* style: [Object]
         * NOTE: This is not used if useQueryState is set to true.
         *
         * A pair of css property & value(s) that indicate that this
         * button has already been applied. If this action has already
         * been applied, the button will be displayed as 'active' in the toolbar
         * Properties of the object:
         *   prop [String]: name of the css property
         *   value [String]: value(s) of the css property
         *                   multiple values can be separated by a '|'
         *
         * Example:
         * For 'bold', if the text is ever within an element with a 'font-weight'
         * style property set to '700' or 'bold', that indicates the text
         * is already bold.  So the style object for bold would be:
         * { prop: 'font-weight', value: '700|bold' }
         */
        style: undefined,

        /* useQueryState: [boolean]
         * Enables/disables whether this button should use the built-in
         * document.queryCommandState() method to determine whether
         * the action has already been applied.  If the action has already
         * been applied, the button will be displayed as 'active' in the toolbar
         *
         * Example:
         * For 'bold', if this is set to true, the code will call:
         * document.queryCommandState('bold') which will return true if the
         * browser thinks the text is already bold, and false otherwise
         */
        useQueryState: undefined,

        /* contentDefault: [string]
         * Default innerHTML to put inside the button
         */
        contentDefault: undefined,

        /* contentFA: [string]
         * The innerHTML to use for the content of the button
         * if the `buttonLabels` option for MediumEditor is set to 'fontawesome'
         */
        contentFA: undefined,

        /* classList: [Array]
         * An array of classNames (strings) to be added to the button
         */
        classList: undefined,

        /* attrs: [object]
         * A set of key-value pairs to add to the button as custom attributes
         */
        attrs: undefined,

        // The button constructor can optionally accept the name of a built-in button
        // (ie 'bold', 'italic', etc.)
        // When the name of a button is passed, it will initialize itself with the
        // configuration for that button
        constructor: function (options) {
            if (Button.isBuiltInButton(options)) {
                MediumEditor.Extension.call(this, this.defaults[options]);
            } else {
                MediumEditor.Extension.call(this, options);
            }
        },

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.button = this.createButton();
            this.on(this.button, 'click', this.handleClick.bind(this));
        },

        /* getButton: [function ()]
         *
         * If implemented, this function will be called when
         * the toolbar is being created.  The DOM Element returned
         * by this function will be appended to the toolbar along
         * with any other buttons.
         */
        getButton: function () {
            return this.button;
        },

        getAction: function () {
            return (typeof this.action === 'function') ? this.action(this.base.options) : this.action;
        },

        getAria: function () {
            return (typeof this.aria === 'function') ? this.aria(this.base.options) : this.aria;
        },

        getTagNames: function () {
            return (typeof this.tagNames === 'function') ? this.tagNames(this.base.options) : this.tagNames;
        },

        createButton: function () {
            var button = this.document.createElement('button'),
                content = this.contentDefault,
                ariaLabel = this.getAria(),
                buttonLabels = this.getEditorOption('buttonLabels');
            // Add class names
            button.classList.add('medium-editor-action');
            button.classList.add('medium-editor-action-' + this.name);
            if (this.classList) {
                this.classList.forEach(function (className) {
                    button.classList.add(className);
                });
            }

            // Add attributes
            button.setAttribute('data-action', this.getAction());
            if (ariaLabel) {
                button.setAttribute('title', ariaLabel);
                button.setAttribute('aria-label', ariaLabel);
            }
            if (this.attrs) {
                Object.keys(this.attrs).forEach(function (attr) {
                    button.setAttribute(attr, this.attrs[attr]);
                }, this);
            }

            if (buttonLabels === 'fontawesome' && this.contentFA) {
                content = this.contentFA;
            }
            button.innerHTML = content;
            return button;
        },

        handleClick: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var action = this.getAction();

            if (action) {
                this.execAction(action);
            }
        },

        isActive: function () {
            return this.button.classList.contains(this.getEditorOption('activeButtonClass'));
        },

        setInactive: function () {
            this.button.classList.remove(this.getEditorOption('activeButtonClass'));
            delete this.knownState;
        },

        setActive: function () {
            this.button.classList.add(this.getEditorOption('activeButtonClass'));
            delete this.knownState;
        },

        queryCommandState: function () {
            var queryState = null;
            if (this.useQueryState) {
                queryState = this.base.queryCommandState(this.getAction());
            }
            return queryState;
        },

        isAlreadyApplied: function (node) {
            var isMatch = false,
                tagNames = this.getTagNames(),
                styleVals,
                computedStyle;

            if (this.knownState === false || this.knownState === true) {
                return this.knownState;
            }

            if (tagNames && tagNames.length > 0) {
                isMatch = tagNames.indexOf(node.nodeName.toLowerCase()) !== -1;
            }

            if (!isMatch && this.style) {
                styleVals = this.style.value.split('|');
                computedStyle = this.window.getComputedStyle(node, null).getPropertyValue(this.style.prop);
                styleVals.forEach(function (val) {
                    if (!this.knownState) {
                        isMatch = (computedStyle.indexOf(val) !== -1);
                        // text-decoration is not inherited by default
                        // so if the computed style for text-decoration doesn't match
                        // don't write to knownState so we can fallback to other checks
                        if (isMatch || this.style.prop !== 'text-decoration') {
                            this.knownState = isMatch;
                        }
                    }
                }, this);
            }

            return isMatch;
        }
    });

    Button.isBuiltInButton = function (name) {
        return (typeof name === 'string') && MediumEditor.extensions.button.prototype.defaults.hasOwnProperty(name);
    };

    MediumEditor.extensions.button = Button;
}());

(function () {
    'use strict';

    /* MediumEditor.extensions.button.defaults: [Object]
     * Set of default config options for all of the built-in MediumEditor buttons
     */
    MediumEditor.extensions.button.prototype.defaults = {
        'bold': {
            name: 'bold',
            action: 'bold',
            aria: 'bold',
            tagNames: ['b', 'strong'],
            style: {
                prop: 'font-weight',
                value: '700|bold'
            },
            useQueryState: true,
            contentDefault: '<b>B</b>',
            contentFA: '<i class="fa fa-bold"></i>'
        },
        'italic': {
            name: 'italic',
            action: 'italic',
            aria: 'italic',
            tagNames: ['i', 'em'],
            style: {
                prop: 'font-style',
                value: 'italic'
            },
            useQueryState: true,
            contentDefault: '<b><i>I</i></b>',
            contentFA: '<i class="fa fa-italic"></i>'
        },
        'underline': {
            name: 'underline',
            action: 'underline',
            aria: 'underline',
            tagNames: ['u'],
            style: {
                prop: 'text-decoration',
                value: 'underline'
            },
            useQueryState: true,
            contentDefault: '<b><u>U</u></b>',
            contentFA: '<i class="fa fa-underline"></i>'
        },
        'strikethrough': {
            name: 'strikethrough',
            action: 'strikethrough',
            aria: 'strike through',
            tagNames: ['strike'],
            style: {
                prop: 'text-decoration',
                value: 'line-through'
            },
            useQueryState: true,
            contentDefault: '<s>A</s>',
            contentFA: '<i class="fa fa-strikethrough"></i>'
        },
        'superscript': {
            name: 'superscript',
            action: 'superscript',
            aria: 'superscript',
            tagNames: ['sup'],
            /* firefox doesn't behave the way we want it to, so we CAN'T use queryCommandState for superscript
               https://github.com/guardian/scribe/blob/master/BROWSERINCONSISTENCIES.md#documentquerycommandstate */
            // useQueryState: true
            contentDefault: '<b>x<sup>1</sup></b>',
            contentFA: '<i class="fa fa-superscript"></i>'
        },
        'subscript': {
            name: 'subscript',
            action: 'subscript',
            aria: 'subscript',
            tagNames: ['sub'],
            /* firefox doesn't behave the way we want it to, so we CAN'T use queryCommandState for subscript
               https://github.com/guardian/scribe/blob/master/BROWSERINCONSISTENCIES.md#documentquerycommandstate */
            // useQueryState: true
            contentDefault: '<b>x<sub>1</sub></b>',
            contentFA: '<i class="fa fa-subscript"></i>'
        },
        'image': {
            name: 'image',
            action: 'image',
            aria: 'image',
            tagNames: ['img'],
            contentDefault: '<b>image</b>',
            contentFA: '<i class="fa fa-picture-o"></i>'
        },
        'html': {
            name: 'html',
            action: 'html',
            aria: 'evaluate html',
            tagNames: ['iframe', 'object'],
            contentDefault: '<b>html</b>',
            contentFA: '<i class="fa fa-code"></i>'
        },
        'orderedlist': {
            name: 'orderedlist',
            action: 'insertorderedlist',
            aria: 'ordered list',
            tagNames: ['ol'],
            useQueryState: true,
            contentDefault: '<b>1.</b>',
            contentFA: '<i class="fa fa-list-ol"></i>'
        },
        'unorderedlist': {
            name: 'unorderedlist',
            action: 'insertunorderedlist',
            aria: 'unordered list',
            tagNames: ['ul'],
            useQueryState: true,
            contentDefault: '<b>&bull;</b>',
            contentFA: '<i class="fa fa-list-ul"></i>'
        },
        'indent': {
            name: 'indent',
            action: 'indent',
            aria: 'indent',
            tagNames: [],
            contentDefault: '<b>&rarr;</b>',
            contentFA: '<i class="fa fa-indent"></i>'
        },
        'outdent': {
            name: 'outdent',
            action: 'outdent',
            aria: 'outdent',
            tagNames: [],
            contentDefault: '<b>&larr;</b>',
            contentFA: '<i class="fa fa-outdent"></i>'
        },
        'justifyCenter': {
            name: 'justifyCenter',
            action: 'justifyCenter',
            aria: 'center justify',
            tagNames: [],
            style: {
                prop: 'text-align',
                value: 'center'
            },
            contentDefault: '<b>C</b>',
            contentFA: '<i class="fa fa-align-center"></i>'
        },
        'justifyFull': {
            name: 'justifyFull',
            action: 'justifyFull',
            aria: 'full justify',
            tagNames: [],
            style: {
                prop: 'text-align',
                value: 'justify'
            },
            contentDefault: '<b>J</b>',
            contentFA: '<i class="fa fa-align-justify"></i>'
        },
        'justifyLeft': {
            name: 'justifyLeft',
            action: 'justifyLeft',
            aria: 'left justify',
            tagNames: [],
            style: {
                prop: 'text-align',
                value: 'left'
            },
            contentDefault: '<b>L</b>',
            contentFA: '<i class="fa fa-align-left"></i>'
        },
        'justifyRight': {
            name: 'justifyRight',
            action: 'justifyRight',
            aria: 'right justify',
            tagNames: [],
            style: {
                prop: 'text-align',
                value: 'right'
            },
            contentDefault: '<b>R</b>',
            contentFA: '<i class="fa fa-align-right"></i>'
        },
        // Known inline elements that are not removed, or not removed consistantly across browsers:
        // <span>, <label>, <br>
        'removeFormat': {
            name: 'removeFormat',
            aria: 'remove formatting',
            action: 'removeFormat',
            contentDefault: '<b>X</b>',
            contentFA: '<i class="fa fa-eraser"></i>'
        },

        /***** Buttons for appending block elements (append-<element> action) *****/

        'quote': {
            name: 'quote',
            action: 'append-blockquote',
            aria: 'blockquote',
            tagNames: ['blockquote'],
            contentDefault: '<b>&ldquo;</b>',
            contentFA: '<i class="fa fa-quote-right"></i>'
        },
        'pre': {
            name: 'pre',
            action: 'append-pre',
            aria: 'preformatted text',
            tagNames: ['pre'],
            contentDefault: '<b>0101</b>',
            contentFA: '<i class="fa fa-code fa-lg"></i>'
        },
        'h1': {
            name: 'h1',
            action: 'append-h1',
            aria: 'header type one',
            tagNames: ['h1'],
            contentDefault: '<b>H1</b>',
            contentFA: '<i class="fa fa-header"><sup>1</sup>'
        },
        'h2': {
            name: 'h2',
            action: 'append-h2',
            aria: 'header type two',
            tagNames: ['h2'],
            contentDefault: '<b>H2</b>',
            contentFA: '<i class="fa fa-header"><sup>2</sup>'
        },
        'h3': {
            name: 'h3',
            action: 'append-h3',
            aria: 'header type three',
            tagNames: ['h3'],
            contentDefault: '<b>H3</b>',
            contentFA: '<i class="fa fa-header"><sup>3</sup>'
        },
        'h4': {
            name: 'h4',
            action: 'append-h4',
            aria: 'header type four',
            tagNames: ['h4'],
            contentDefault: '<b>H4</b>',
            contentFA: '<i class="fa fa-header"><sup>4</sup>'
        },
        'h5': {
            name: 'h5',
            action: 'append-h5',
            aria: 'header type five',
            tagNames: ['h5'],
            contentDefault: '<b>H5</b>',
            contentFA: '<i class="fa fa-header"><sup>5</sup>'
        },
        'h6': {
            name: 'h6',
            action: 'append-h6',
            aria: 'header type six',
            tagNames: ['h6'],
            contentDefault: '<b>H6</b>',
            contentFA: '<i class="fa fa-header"><sup>6</sup>'
        }
    };

})();

(function () {
    'use strict';

    /* Base functionality for an extension which will display
     * a 'form' inside the toolbar
     */
    var FormExtension = MediumEditor.extensions.button.extend({

        init: function () {
            MediumEditor.extensions.button.prototype.init.apply(this, arguments);
        },

        // default labels for the form buttons
        formSaveLabel: '&#10003;',
        formCloseLabel: '&times;',

        /* activeClass: [string]
         * set class which added to shown form
         */
        activeClass: 'medium-editor-toolbar-form-active',

        /* hasForm: [boolean]
         *
         * Setting this to true will cause getForm() to be called
         * when the toolbar is created, so the form can be appended
         * inside the toolbar container
         */
        hasForm: true,

        /* getForm: [function ()]
         *
         * When hasForm is true, this function must be implemented
         * and return a DOM Element which will be appended to
         * the toolbar container. The form should start hidden, and
         * the extension can choose when to hide/show it
         */
        getForm: function () {},

        /* isDisplayed: [function ()]
         *
         * This function should return true/false reflecting
         * whether the form is currently displayed
         */
        isDisplayed: function () {
            if (this.hasForm) {
                return this.getForm().classList.contains(this.activeClass);
            }
            return false;
        },

        /* hideForm: [function ()]
         *
         * This function should show the form element inside
         * the toolbar container
         */
        showForm: function () {
            if (this.hasForm) {
                this.getForm().classList.add(this.activeClass);
            }
        },

        /* hideForm: [function ()]
         *
         * This function should hide the form element inside
         * the toolbar container
         */
        hideForm: function () {
            if (this.hasForm) {
                this.getForm().classList.remove(this.activeClass);
            }
        },

        /************************ Helpers ************************
         * The following are helpers that are either set by MediumEditor
         * during initialization, or are helper methods which either
         * route calls to the MediumEditor instance or provide common
         * functionality for all form extensions
         *********************************************************/

        /* showToolbarDefaultActions: [function ()]
         *
         * Helper method which will turn back the toolbar after canceling
         * the customized form
         */
        showToolbarDefaultActions: function () {
            var toolbar = this.base.getExtensionByName('toolbar');
            if (toolbar) {
                toolbar.showToolbarDefaultActions();
            }
        },

        /* hideToolbarDefaultActions: [function ()]
         *
         * Helper function which will hide the default contents of the
         * toolbar, but leave the toolbar container in the same state
         * to allow a form to display its custom contents inside the toolbar
         */
        hideToolbarDefaultActions: function () {
            var toolbar = this.base.getExtensionByName('toolbar');
            if (toolbar) {
                toolbar.hideToolbarDefaultActions();
            }
        },

        /* setToolbarPosition: [function ()]
         *
         * Helper function which will update the size and position
         * of the toolbar based on the toolbar content and the current
         * position of the user's selection
         */
        setToolbarPosition: function () {
            var toolbar = this.base.getExtensionByName('toolbar');
            if (toolbar) {
                toolbar.setToolbarPosition();
            }
        }
    });

    MediumEditor.extensions.form = FormExtension;
})();
(function () {
    'use strict';

    var AnchorForm = MediumEditor.extensions.form.extend({
        /* Anchor Form Options */

        /* customClassOption: [string]  (previously options.anchorButton + options.anchorButtonClass)
         * Custom class name the user can optionally have added to their created links (ie 'button').
         * If passed as a non-empty string, a checkbox will be displayed allowing the user to choose
         * whether to have the class added to the created link or not.
         */
        customClassOption: null,

        /* customClassOptionText: [string]
         * text to be shown in the checkbox when the __customClassOption__ is being used.
         */
        customClassOptionText: 'Button',

        /* linkValidation: [boolean]  (previously options.checkLinkFormat)
         * enables/disables check for common URL protocols on anchor links.
         */
        linkValidation: false,

        /* placeholderText: [string]  (previously options.anchorInputPlaceholder)
         * text to be shown as placeholder of the anchor input.
         */
        placeholderText: 'Paste or type a link',

        /* targetCheckbox: [boolean]  (previously options.anchorTarget)
         * enables/disables displaying a "Open in new window" checkbox, which when checked
         * changes the `target` attribute of the created link.
         */
        targetCheckbox: false,

        /* targetCheckboxText: [string]  (previously options.anchorInputCheckboxLabel)
         * text to be shown in the checkbox enabled via the __targetCheckbox__ option.
         */
        targetCheckboxText: 'Open in new window',

        // Options for the Button base class
        name: 'anchor',
        action: 'createLink',
        aria: 'link',
        tagNames: ['a'],
        contentDefault: '<b>#</b>',
        contentFA: '<i class="fa fa-link"></i>',

        init: function () {
            MediumEditor.extensions.form.prototype.init.apply(this, arguments);

            this.subscribe('editableKeydown', this.handleKeydown.bind(this));
        },

        // Called when the button the toolbar is clicked
        // Overrides ButtonExtension.handleClick
        handleClick: function (event) {
            event.preventDefault();
            event.stopPropagation();

            var range = MediumEditor.selection.getSelectionRange(this.document);

            if (range.startContainer.nodeName.toLowerCase() === 'a' ||
                range.endContainer.nodeName.toLowerCase() === 'a' ||
                MediumEditor.util.getClosestTag(MediumEditor.selection.getSelectedParentElement(range), 'a')) {
                return this.execAction('unlink');
            }

            if (!this.isDisplayed()) {
                this.showForm();
            }

            return false;
        },

        // Called when user hits the defined shortcut (CTRL / COMMAND + K)
        handleKeydown: function (event) {
            if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.K) && MediumEditor.util.isMetaCtrlKey(event) && !event.shiftKey) {
                this.handleClick(event);
            }
        },

        // Called by medium-editor to append form to the toolbar
        getForm: function () {
            if (!this.form) {
                this.form = this.createForm();
            }
            return this.form;
        },

        getTemplate: function () {
            var template = [
                '<input type="text" class="medium-editor-toolbar-input" placeholder="', this.placeholderText, '">'
            ];

            template.push(
                '<a href="#" class="medium-editor-toolbar-save">',
                this.getEditorOption('buttonLabels') === 'fontawesome' ? '<i class="fa fa-check"></i>' : this.formSaveLabel,
                '</a>'
            );

            template.push('<a href="#" class="medium-editor-toolbar-close">',
                this.getEditorOption('buttonLabels') === 'fontawesome' ? '<i class="fa fa-times"></i>' : this.formCloseLabel,
                '</a>');

            // both of these options are slightly moot with the ability to
            // override the various form buildup/serialize functions.

            if (this.targetCheckbox) {
                // fixme: ideally, this targetCheckboxText would be a formLabel too,
                // figure out how to deprecate? also consider `fa-` icon default implcations.
                template.push(
                    '<div class="medium-editor-toolbar-form-row">',
                    '<input type="checkbox" class="medium-editor-toolbar-anchor-target" id="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">',
                    '<label for="medium-editor-toolbar-anchor-target-field-' + this.getEditorId() + '">',
                    this.targetCheckboxText,
                    '</label>',
                    '</div>'
                );
            }

            if (this.customClassOption) {
                // fixme: expose this `Button` text as a formLabel property, too
                // and provide similar access to a `fa-` icon default.
                template.push(
                    '<div class="medium-editor-toolbar-form-row">',
                    '<input type="checkbox" class="medium-editor-toolbar-anchor-button">',
                    '<label>',
                    this.customClassOptionText,
                    '</label>',
                    '</div>'
                );
            }

            return template.join('');

        },

        // Used by medium-editor when the default toolbar is to be displayed
        isDisplayed: function () {
            return MediumEditor.extensions.form.prototype.isDisplayed.apply(this);
        },

        hideForm: function () {
            MediumEditor.extensions.form.prototype.hideForm.apply(this);
            this.getInput().value = '';
        },

        showForm: function (opts) {
            var input = this.getInput(),
                targetCheckbox = this.getAnchorTargetCheckbox(),
                buttonCheckbox = this.getAnchorButtonCheckbox();

            opts = opts || { value: '' };
            // TODO: This is for backwards compatability
            // We don't need to support the 'string' argument in 6.0.0
            if (typeof opts === 'string') {
                opts = {
                    value: opts
                };
            }

            this.base.saveSelection();
            this.hideToolbarDefaultActions();
            MediumEditor.extensions.form.prototype.showForm.apply(this);
            this.setToolbarPosition();

            input.value = opts.value;
            input.focus();

            // If we have a target checkbox, we want it to be checked/unchecked
            // based on whether the existing link has target=_blank
            if (targetCheckbox) {
                targetCheckbox.checked = opts.target === '_blank';
            }

            // If we have a custom class checkbox, we want it to be checked/unchecked
            // based on whether an existing link already has the class
            if (buttonCheckbox) {
                var classList = opts.buttonClass ? opts.buttonClass.split(' ') : [];
                buttonCheckbox.checked = (classList.indexOf(this.customClassOption) !== -1);
            }
        },

        // Called by core when tearing down medium-editor (destroy)
        destroy: function () {
            if (!this.form) {
                return false;
            }

            if (this.form.parentNode) {
                this.form.parentNode.removeChild(this.form);
            }

            delete this.form;
        },

        // core methods

        getFormOpts: function () {
            // no notion of private functions? wanted `_getFormOpts`
            var targetCheckbox = this.getAnchorTargetCheckbox(),
                buttonCheckbox = this.getAnchorButtonCheckbox(),
                opts = {
                    value: this.getInput().value.trim()
                };

            if (this.linkValidation) {
                opts.value = this.checkLinkFormat(opts.value);
            }

            opts.target = '_self';
            if (targetCheckbox && targetCheckbox.checked) {
                opts.target = '_blank';
            }

            if (buttonCheckbox && buttonCheckbox.checked) {
                opts.buttonClass = this.customClassOption;
            }

            return opts;
        },

        doFormSave: function () {
            var opts = this.getFormOpts();
            this.completeFormSave(opts);
        },

        completeFormSave: function (opts) {
            this.base.restoreSelection();
            this.execAction(this.action, opts);
            this.base.checkSelection();
        },

        ensureEncodedUri: function (str) {
            return str === decodeURI(str) ? encodeURI(str) : str;
        },

        ensureEncodedUriComponent: function (str) {
            return str === decodeURIComponent(str) ? encodeURIComponent(str) : str;
        },

        ensureEncodedParam: function (param) {
            var split = param.split('='),
                key = split[0],
                val = split[1];

            return key + (val === undefined ? '' : '=' + this.ensureEncodedUriComponent(val));
        },

        ensureEncodedQuery: function (queryString) {
            return queryString.split('&').map(this.ensureEncodedParam.bind(this)).join('&');
        },

        checkLinkFormat: function (value) {
            // Matches any alphabetical characters followed by ://
            // Matches protocol relative "//"
            // Matches common external protocols "mailto:" "tel:" "maps:"
            // Matches relative hash link, begins with "#"
            var urlSchemeRegex = /^([a-z]+:)?\/\/|^(mailto|tel|maps):|^\#/i,
                hasScheme = urlSchemeRegex.test(value),
                scheme = '',
                // telRegex is a regex for checking if the string is a telephone number
                telRegex = /^\+?\s?\(?(?:\d\s?\-?\)?){3,20}$/,
                urlParts = value.match(/^(.*?)(?:\?(.*?))?(?:#(.*))?$/),
                path = urlParts[1],
                query = urlParts[2],
                fragment = urlParts[3];

            if (telRegex.test(value)) {
                return 'tel:' + value;
            }

            if (!hasScheme) {
                var host = path.split('/')[0];
                // if the host part of the path looks like a hostname
                if (host.match(/.+(\.|:).+/) || host === 'localhost') {
                    scheme = 'http://';
                }
            }

            return scheme +
                // Ensure path is encoded
                this.ensureEncodedUri(path) +
                // Ensure query is encoded
                (query === undefined ? '' : '?' + this.ensureEncodedQuery(query)) +
                // Include fragment unencoded as encodeUriComponent is too
                // heavy handed for the many characters allowed in a fragment
                (fragment === undefined ? '' : '#' + fragment);
        },

        doFormCancel: function () {
            this.base.restoreSelection();
            this.base.checkSelection();
        },

        // form creation and event handling
        attachFormEvents: function (form) {
            var close = form.querySelector('.medium-editor-toolbar-close'),
                save = form.querySelector('.medium-editor-toolbar-save'),
                input = form.querySelector('.medium-editor-toolbar-input');

            // Handle clicks on the form itself
            this.on(form, 'click', this.handleFormClick.bind(this));

            // Handle typing in the textbox
            this.on(input, 'keyup', this.handleTextboxKeyup.bind(this));

            // Handle close button clicks
            this.on(close, 'click', this.handleCloseClick.bind(this));

            // Handle save button clicks (capture)
            this.on(save, 'click', this.handleSaveClick.bind(this), true);

        },

        createForm: function () {
            var doc = this.document,
                form = doc.createElement('div');

            // Anchor Form (div)
            form.className = 'medium-editor-toolbar-form';
            form.id = 'medium-editor-toolbar-form-anchor-' + this.getEditorId();
            form.innerHTML = this.getTemplate();
            this.attachFormEvents(form);

            return form;
        },

        getInput: function () {
            return this.getForm().querySelector('input.medium-editor-toolbar-input');
        },

        getAnchorTargetCheckbox: function () {
            return this.getForm().querySelector('.medium-editor-toolbar-anchor-target');
        },

        getAnchorButtonCheckbox: function () {
            return this.getForm().querySelector('.medium-editor-toolbar-anchor-button');
        },

        handleTextboxKeyup: function (event) {
            // For ENTER -> create the anchor
            if (event.keyCode === MediumEditor.util.keyCode.ENTER) {
                event.preventDefault();
                this.doFormSave();
                return;
            }

            // For ESCAPE -> close the form
            if (event.keyCode === MediumEditor.util.keyCode.ESCAPE) {
                event.preventDefault();
                this.doFormCancel();
            }
        },

        handleFormClick: function (event) {
            // make sure not to hide form when clicking inside the form
            event.stopPropagation();
        },

        handleSaveClick: function (event) {
            // Clicking Save -> create the anchor
            event.preventDefault();
            this.doFormSave();
        },

        handleCloseClick: function (event) {
            // Click Close -> close the form
            event.preventDefault();
            this.doFormCancel();
        }
    });

    MediumEditor.extensions.anchor = AnchorForm;
}());

(function () {
    'use strict';

    var AnchorPreview = MediumEditor.Extension.extend({
        name: 'anchor-preview',

        // Anchor Preview Options

        /* hideDelay: [number]  (previously options.anchorPreviewHideDelay)
         * time in milliseconds to show the anchor tag preview after the mouse has left the anchor tag.
         */
        hideDelay: 500,

        /* previewValueSelector: [string]
         * the default selector to locate where to put the activeAnchor value in the preview
         */
        previewValueSelector: 'a',

        /* showWhenToolbarIsVisible: [boolean]
         * determines whether the anchor tag preview shows up when the toolbar is visible
         */
        showWhenToolbarIsVisible: false,

        /* showOnEmptyLinks: [boolean]
        * determines whether the anchor tag preview shows up on links with href="" or href="#something"
        */
        showOnEmptyLinks: true,

        init: function () {
            this.anchorPreview = this.createPreview();

            this.getEditorOption('elementsContainer').appendChild(this.anchorPreview);

            this.attachToEditables();
        },

        getInteractionElements: function () {
            return this.getPreviewElement();
        },

        // TODO: Remove this function in 6.0.0
        getPreviewElement: function () {
            return this.anchorPreview;
        },

        createPreview: function () {
            var el = this.document.createElement('div');

            el.id = 'medium-editor-anchor-preview-' + this.getEditorId();
            el.className = 'medium-editor-anchor-preview';
            el.innerHTML = this.getTemplate();

            this.on(el, 'click', this.handleClick.bind(this));

            return el;
        },

        getTemplate: function () {
            return '<div class="medium-editor-toolbar-anchor-preview" id="medium-editor-toolbar-anchor-preview">' +
                '    <a class="medium-editor-toolbar-anchor-preview-inner"></a>' +
                '</div>';
        },

        destroy: function () {
            if (this.anchorPreview) {
                if (this.anchorPreview.parentNode) {
                    this.anchorPreview.parentNode.removeChild(this.anchorPreview);
                }
                delete this.anchorPreview;
            }
        },

        hidePreview: function () {
            if (this.anchorPreview) {
                this.anchorPreview.classList.remove('medium-editor-anchor-preview-active');
            }
            this.activeAnchor = null;
        },

        showPreview: function (anchorEl) {
            if (this.anchorPreview.classList.contains('medium-editor-anchor-preview-active') ||
                    anchorEl.getAttribute('data-disable-preview')) {
                return true;
            }

            if (this.previewValueSelector) {
                this.anchorPreview.querySelector(this.previewValueSelector).textContent = anchorEl.attributes.href.value;
                this.anchorPreview.querySelector(this.previewValueSelector).href = anchorEl.attributes.href.value;
            }

            this.anchorPreview.classList.add('medium-toolbar-arrow-over');
            this.anchorPreview.classList.remove('medium-toolbar-arrow-under');

            if (!this.anchorPreview.classList.contains('medium-editor-anchor-preview-active')) {
                this.anchorPreview.classList.add('medium-editor-anchor-preview-active');
            }

            this.activeAnchor = anchorEl;

            this.positionPreview();
            this.attachPreviewHandlers();

            return this;
        },

        positionPreview: function (activeAnchor) {
            activeAnchor = activeAnchor || this.activeAnchor;
            var containerWidth = this.window.innerWidth,
                buttonHeight = this.anchorPreview.offsetHeight,
                boundary = activeAnchor.getBoundingClientRect(),
                diffLeft = this.diffLeft,
                diffTop = this.diffTop,
                elementsContainer = this.getEditorOption('elementsContainer'),
                elementsContainerAbsolute = ['absolute', 'fixed'].indexOf(window.getComputedStyle(elementsContainer).getPropertyValue('position')) > -1,
                relativeBoundary = {},
                halfOffsetWidth, defaultLeft, middleBoundary, elementsContainerBoundary, top;

            halfOffsetWidth = this.anchorPreview.offsetWidth / 2;
            var toolbarExtension = this.base.getExtensionByName('toolbar');
            if (toolbarExtension) {
                diffLeft = toolbarExtension.diffLeft;
                diffTop = toolbarExtension.diffTop;
            }
            defaultLeft = diffLeft - halfOffsetWidth;

            // If container element is absolute / fixed, recalculate boundaries to be relative to the container
            if (elementsContainerAbsolute) {
                elementsContainerBoundary = elementsContainer.getBoundingClientRect();
                ['top', 'left'].forEach(function (key) {
                    relativeBoundary[key] = boundary[key] - elementsContainerBoundary[key];
                });

                relativeBoundary.width = boundary.width;
                relativeBoundary.height = boundary.height;
                boundary = relativeBoundary;

                containerWidth = elementsContainerBoundary.width;

                // Adjust top position according to container scroll position
                top = elementsContainer.scrollTop;
            } else {
                // Adjust top position according to window scroll position
                top = this.window.pageYOffset;
            }

            middleBoundary = boundary.left + boundary.width / 2;
            top += buttonHeight + boundary.top + boundary.height - diffTop - this.anchorPreview.offsetHeight;

            this.anchorPreview.style.top = Math.round(top) + 'px';
            this.anchorPreview.style.right = 'initial';
            if (middleBoundary < halfOffsetWidth) {
                this.anchorPreview.style.left = defaultLeft + halfOffsetWidth + 'px';
                this.anchorPreview.style.right = 'initial';
            } else if ((containerWidth - middleBoundary) < halfOffsetWidth) {
                this.anchorPreview.style.left = 'auto';
                this.anchorPreview.style.right = 0;
            } else {
                this.anchorPreview.style.left = defaultLeft + middleBoundary + 'px';
                this.anchorPreview.style.right = 'initial';
            }
        },

        attachToEditables: function () {
            this.subscribe('editableMouseover', this.handleEditableMouseover.bind(this));
            this.subscribe('positionedToolbar', this.handlePositionedToolbar.bind(this));
        },

        handlePositionedToolbar: function () {
            // If the toolbar is visible and positioned, we don't need to hide the preview
            // when showWhenToolbarIsVisible is true
            if (!this.showWhenToolbarIsVisible) {
                this.hidePreview();
            }
        },

        handleClick: function (event) {
            var anchorExtension = this.base.getExtensionByName('anchor'),
                activeAnchor = this.activeAnchor;

            if (anchorExtension && activeAnchor) {
                event.preventDefault();

                this.base.selectElement(this.activeAnchor);

                // Using setTimeout + delay because:
                // We may actually be displaying the anchor form, which should be controlled by delay
                this.base.delay(function () {
                    if (activeAnchor) {
                        var opts = {
                            value: activeAnchor.attributes.href.value,
                            target: activeAnchor.getAttribute('target'),
                            buttonClass: activeAnchor.getAttribute('class')
                        };
                        anchorExtension.showForm(opts);
                        activeAnchor = null;
                    }
                }.bind(this));
            }

            this.hidePreview();
        },

        handleAnchorMouseout: function () {
            this.anchorToPreview = null;
            this.off(this.activeAnchor, 'mouseout', this.instanceHandleAnchorMouseout);
            this.instanceHandleAnchorMouseout = null;
        },

        handleEditableMouseover: function (event) {
            var target = MediumEditor.util.getClosestTag(event.target, 'a');

            if (false === target) {
                return;
            }

            // Detect empty href attributes
            // The browser will make href="" or href="#top"
            // into absolute urls when accessed as event.target.href, so check the html
            if (!this.showOnEmptyLinks &&
                (!/href=["']\S+["']/.test(target.outerHTML) || /href=["']#\S+["']/.test(target.outerHTML))) {
                return true;
            }

            // only show when toolbar is not present
            var toolbar = this.base.getExtensionByName('toolbar');
            if (!this.showWhenToolbarIsVisible && toolbar && toolbar.isDisplayed && toolbar.isDisplayed()) {
                return true;
            }

            // detach handler for other anchor in case we hovered multiple anchors quickly
            if (this.activeAnchor && this.activeAnchor !== target) {
                this.detachPreviewHandlers();
            }

            this.anchorToPreview = target;

            this.instanceHandleAnchorMouseout = this.handleAnchorMouseout.bind(this);
            this.on(this.anchorToPreview, 'mouseout', this.instanceHandleAnchorMouseout);
            // Using setTimeout + delay because:
            // - We're going to show the anchor preview according to the configured delay
            //   if the mouse has not left the anchor tag in that time
            this.base.delay(function () {
                if (this.anchorToPreview) {
                    this.showPreview(this.anchorToPreview);
                }
            }.bind(this));
        },

        handlePreviewMouseover: function () {
            this.lastOver = (new Date()).getTime();
            this.hovering = true;
        },

        handlePreviewMouseout: function (event) {
            if (!event.relatedTarget || !/anchor-preview/.test(event.relatedTarget.className)) {
                this.hovering = false;
            }
        },

        updatePreview: function () {
            if (this.hovering) {
                return true;
            }
            var durr = (new Date()).getTime() - this.lastOver;
            if (durr > this.hideDelay) {
                // hide the preview 1/2 second after mouse leaves the link
                this.detachPreviewHandlers();
            }
        },

        detachPreviewHandlers: function () {
            // cleanup
            clearInterval(this.intervalTimer);
            if (this.instanceHandlePreviewMouseover) {
                this.off(this.anchorPreview, 'mouseover', this.instanceHandlePreviewMouseover);
                this.off(this.anchorPreview, 'mouseout', this.instanceHandlePreviewMouseout);
                if (this.activeAnchor) {
                    this.off(this.activeAnchor, 'mouseover', this.instanceHandlePreviewMouseover);
                    this.off(this.activeAnchor, 'mouseout', this.instanceHandlePreviewMouseout);
                }
            }

            this.hidePreview();

            this.hovering = this.instanceHandlePreviewMouseover = this.instanceHandlePreviewMouseout = null;
        },

        // TODO: break up method and extract out handlers
        attachPreviewHandlers: function () {
            this.lastOver = (new Date()).getTime();
            this.hovering = true;

            this.instanceHandlePreviewMouseover = this.handlePreviewMouseover.bind(this);
            this.instanceHandlePreviewMouseout = this.handlePreviewMouseout.bind(this);

            this.intervalTimer = setInterval(this.updatePreview.bind(this), 200);

            this.on(this.anchorPreview, 'mouseover', this.instanceHandlePreviewMouseover);
            this.on(this.anchorPreview, 'mouseout', this.instanceHandlePreviewMouseout);
            this.on(this.activeAnchor, 'mouseover', this.instanceHandlePreviewMouseover);
            this.on(this.activeAnchor, 'mouseout', this.instanceHandlePreviewMouseout);
        }
    });

    MediumEditor.extensions.anchorPreview = AnchorPreview;
}());

(function () {
    'use strict';

    var WHITESPACE_CHARS,
        KNOWN_TLDS_FRAGMENT,
        LINK_REGEXP_TEXT,
        KNOWN_TLDS_REGEXP,
        LINK_REGEXP;

    WHITESPACE_CHARS = [' ', '\t', '\n', '\r', '\u00A0', '\u2000', '\u2001', '\u2002', '\u2003',
                                    '\u2028', '\u2029'];
    KNOWN_TLDS_FRAGMENT = 'com|net|org|edu|gov|mil|aero|asia|biz|cat|coop|info|int|jobs|mobi|museum|name|post|pro|tel|travel|' +
        'xxx|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|' +
        'bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cs|cu|cv|cx|cy|cz|dd|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|' +
        'fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|' +
        'is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|' +
        'mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|' +
        'pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|ja|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|' +
        'tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw';

    LINK_REGEXP_TEXT =
        '(' +
        // Version of Gruber URL Regexp optimized for JS: http://stackoverflow.com/a/17733640
        '((?:(https?://|ftps?://|nntp://)|www\\d{0,3}[.]|[a-z0-9.\\-]+[.](' + KNOWN_TLDS_FRAGMENT + ')\\\/)\\S+(?:[^\\s`!\\[\\]{};:\'\".,?\u00AB\u00BB\u201C\u201D\u2018\u2019]))' +
        // Addition to above Regexp to support bare domains/one level subdomains with common non-i18n TLDs and without www prefix:
        ')|(([a-z0-9\\-]+\\.)?[a-z0-9\\-]+\\.(' + KNOWN_TLDS_FRAGMENT + '))';

    KNOWN_TLDS_REGEXP = new RegExp('^(' + KNOWN_TLDS_FRAGMENT + ')$', 'i');

    LINK_REGEXP = new RegExp(LINK_REGEXP_TEXT, 'gi');

    function nodeIsNotInsideAnchorTag(node) {
        return !MediumEditor.util.getClosestTag(node, 'a');
    }

    var AutoLink = MediumEditor.Extension.extend({
        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.disableEventHandling = false;
            this.subscribe('editableKeypress', this.onKeypress.bind(this));
            this.subscribe('editableBlur', this.onBlur.bind(this));
            // MS IE has it's own auto-URL detect feature but ours is better in some ways. Be consistent.
            this.document.execCommand('AutoUrlDetect', false, false);
        },

        isLastInstance: function () {
            var activeInstances = 0;
            for (var i = 0; i < this.window._mediumEditors.length; i++) {
                var editor = this.window._mediumEditors[i];
                if (editor !== null && editor.getExtensionByName('autoLink') !== undefined) {
                    activeInstances++;
                }
            }
            return activeInstances === 1;
        },

        destroy: function () {
            // Turn AutoUrlDetect back on
            if (this.document.queryCommandSupported('AutoUrlDetect') && this.isLastInstance()) {
                this.document.execCommand('AutoUrlDetect', false, true);
            }
        },

        onBlur: function (blurEvent, editable) {
            this.performLinking(editable);
        },

        onKeypress: function (keyPressEvent) {
            if (this.disableEventHandling) {
                return;
            }

            if (MediumEditor.util.isKey(keyPressEvent, [MediumEditor.util.keyCode.SPACE, MediumEditor.util.keyCode.ENTER])) {
                clearTimeout(this.performLinkingTimeout);
                // Saving/restoring the selection in the middle of a keypress doesn't work well...
                this.performLinkingTimeout = setTimeout(function () {
                    try {
                        var sel = this.base.exportSelection();
                        if (this.performLinking(keyPressEvent.target)) {
                            // pass true for favorLaterSelectionAnchor - this is needed for links at the end of a
                            // paragraph in MS IE, or MS IE causes the link to be deleted right after adding it.
                            this.base.importSelection(sel, true);
                        }
                    } catch (e) {
                        if (window.console) {
                            window.console.error('Failed to perform linking', e);
                        }
                        this.disableEventHandling = true;
                    }
                }.bind(this), 0);
            }
        },

        performLinking: function (contenteditable) {
            /*
            Perform linking on blockElement basis, blockElements are HTML elements with text content and without
            child element.

            Example:
            - HTML content
            <blockquote>
              <p>link.</p>
              <p>my</p>
            </blockquote>

            - blockElements
            [<p>link.</p>, <p>my</p>]

            otherwise the detection can wrongly find the end of one paragraph and the beginning of another paragraph
            to constitute a link, such as a paragraph ending "link." and the next paragraph beginning with "my" is
            interpreted into "link.my" and the code tries to create a link across blockElements - which doesn't work
            and is terrible.
            (Medium deletes the spaces/returns between P tags so the textContent ends up without paragraph spacing)
            */
            var blockElements = MediumEditor.util.splitByBlockElements(contenteditable),
                documentModified = false;
            if (blockElements.length === 0) {
                blockElements = [contenteditable];
            }
            for (var i = 0; i < blockElements.length; i++) {
                documentModified = this.removeObsoleteAutoLinkSpans(blockElements[i]) || documentModified;
                documentModified = this.performLinkingWithinElement(blockElements[i]) || documentModified;
            }
            this.base.events.updateInput(contenteditable, { target: contenteditable, currentTarget: contenteditable });
            return documentModified;
        },

        removeObsoleteAutoLinkSpans: function (element) {
            if (!element || element.nodeType === 3) {
                return false;
            }

            var spans = element.querySelectorAll('span[data-auto-link="true"]'),
                documentModified = false;

            for (var i = 0; i < spans.length; i++) {
                var textContent = spans[i].textContent;
                if (textContent.indexOf('://') === -1) {
                    textContent = MediumEditor.util.ensureUrlHasProtocol(textContent);
                }
                if (spans[i].getAttribute('data-href') !== textContent && nodeIsNotInsideAnchorTag(spans[i])) {
                    documentModified = true;
                    var trimmedTextContent = textContent.replace(/\s+$/, '');
                    if (spans[i].getAttribute('data-href') === trimmedTextContent) {
                        var charactersTrimmed = textContent.length - trimmedTextContent.length,
                            subtree = MediumEditor.util.splitOffDOMTree(spans[i], this.splitTextBeforeEnd(spans[i], charactersTrimmed));
                        spans[i].parentNode.insertBefore(subtree, spans[i].nextSibling);
                    } else {
                        // Some editing has happened to the span, so just remove it entirely. The user can put it back
                        // around just the href content if they need to prevent it from linking
                        MediumEditor.util.unwrap(spans[i], this.document);
                    }
                }
            }
            return documentModified;
        },

        splitTextBeforeEnd: function (element, characterCount) {
            var treeWalker = this.document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false),
                lastChildNotExhausted = true;

            // Start the tree walker at the last descendant of the span
            while (lastChildNotExhausted) {
                lastChildNotExhausted = treeWalker.lastChild() !== null;
            }

            var currentNode,
                currentNodeValue,
                previousNode;
            while (characterCount > 0 && previousNode !== null) {
                currentNode = treeWalker.currentNode;
                currentNodeValue = currentNode.nodeValue;
                if (currentNodeValue.length > characterCount) {
                    previousNode = currentNode.splitText(currentNodeValue.length - characterCount);
                    characterCount = 0;
                } else {
                    previousNode = treeWalker.previousNode();
                    characterCount -= currentNodeValue.length;
                }
            }
            return previousNode;
        },

        performLinkingWithinElement: function (element) {
            var matches = this.findLinkableText(element),
                linkCreated = false;

            for (var matchIndex = 0; matchIndex < matches.length; matchIndex++) {
                var matchingTextNodes = MediumEditor.util.findOrCreateMatchingTextNodes(this.document, element,
                        matches[matchIndex]);
                if (this.shouldNotLink(matchingTextNodes)) {
                    continue;
                }
                this.createAutoLink(matchingTextNodes, matches[matchIndex].href);
            }
            return linkCreated;
        },

        shouldNotLink: function (textNodes) {
            var shouldNotLink = false;
            for (var i = 0; i < textNodes.length && shouldNotLink === false; i++) {
                // Do not link if the text node is either inside an anchor or inside span[data-auto-link]
                shouldNotLink = !!MediumEditor.util.traverseUp(textNodes[i], function (node) {
                    return node.nodeName.toLowerCase() === 'a' ||
                        (node.getAttribute && node.getAttribute('data-auto-link') === 'true');
                });
            }
            return shouldNotLink;
        },

        findLinkableText: function (contenteditable) {
            var textContent = contenteditable.textContent,
                match = null,
                matches = [];

            while ((match = LINK_REGEXP.exec(textContent)) !== null) {
                var matchOk = true,
                    matchEnd = match.index + match[0].length;
                // If the regexp detected something as a link that has text immediately preceding/following it, bail out.
                matchOk = (match.index === 0 || WHITESPACE_CHARS.indexOf(textContent[match.index - 1]) !== -1) &&
                    (matchEnd === textContent.length || WHITESPACE_CHARS.indexOf(textContent[matchEnd]) !== -1);
                // If the regexp detected a bare domain that doesn't use one of our expected TLDs, bail out.
                matchOk = matchOk && (match[0].indexOf('/') !== -1 ||
                    KNOWN_TLDS_REGEXP.test(match[0].split('.').pop().split('?').shift()));

                if (matchOk) {
                    matches.push({
                        href: match[0],
                        start: match.index,
                        end: matchEnd
                    });
                }
            }
            return matches;
        },

        createAutoLink: function (textNodes, href) {
            href = MediumEditor.util.ensureUrlHasProtocol(href);
            var anchor = MediumEditor.util.createLink(this.document, textNodes, href, this.getEditorOption('targetBlank') ? '_blank' : null),
                span = this.document.createElement('span');
            span.setAttribute('data-auto-link', 'true');
            span.setAttribute('data-href', href);
            anchor.insertBefore(span, anchor.firstChild);
            while (anchor.childNodes.length > 1) {
                span.appendChild(anchor.childNodes[1]);
            }
        }

    });

    MediumEditor.extensions.autoLink = AutoLink;
}());

(function () {
    'use strict';

    var CLASS_DRAG_OVER = 'medium-editor-dragover';

    function clearClassNames(element) {
        var editable = MediumEditor.util.getContainerEditorElement(element),
            existing = Array.prototype.slice.call(editable.parentElement.querySelectorAll('.' + CLASS_DRAG_OVER));

        existing.forEach(function (el) {
            el.classList.remove(CLASS_DRAG_OVER);
        });
    }

    var FileDragging = MediumEditor.Extension.extend({
        name: 'fileDragging',

        allowedTypes: ['image'],

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.subscribe('editableDrag', this.handleDrag.bind(this));
            this.subscribe('editableDrop', this.handleDrop.bind(this));
        },

        handleDrag: function (event) {
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';

            var target = event.target.classList ? event.target : event.target.parentElement;

            // Ensure the class gets removed from anything that had it before
            clearClassNames(target);

            if (event.type === 'dragover') {
                target.classList.add(CLASS_DRAG_OVER);
            }
        },

        handleDrop: function (event) {
            // Prevent file from opening in the current window
            event.preventDefault();
            event.stopPropagation();
            // Select the dropping target, and set the selection to the end of the target
            // https://github.com/yabwe/medium-editor/issues/980
            this.base.selectElement(event.target);
            var selection = this.base.exportSelection();
            selection.start = selection.end;
            this.base.importSelection(selection);
            // IE9 does not support the File API, so prevent file from opening in the window
            // but also don't try to actually get the file
            if (event.dataTransfer.files) {
                Array.prototype.slice.call(event.dataTransfer.files).forEach(function (file) {
                    if (this.isAllowedFile(file)) {
                        if (file.type.match('image')) {
                            this.insertImageFile(file);
                        }
                    }
                }, this);
            }

            // Make sure we remove our class from everything
            clearClassNames(event.target);
        },

        isAllowedFile: function (file) {
            return this.allowedTypes.some(function (fileType) {
                return !!file.type.match(fileType);
            });
        },

        insertImageFile: function (file) {
            if (typeof FileReader !== 'function') {
                return;
            }
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            // attach the onload event handler, makes it easier to listen in with jasmine
            fileReader.addEventListener('load', function (e) {
                var addImageElement = this.document.createElement('img');
                addImageElement.src = e.target.result;
                MediumEditor.util.insertHTMLCommand(this.document, addImageElement.outerHTML);
            }.bind(this));
        }
    });

    MediumEditor.extensions.fileDragging = FileDragging;
}());

(function () {
    'use strict';

    var KeyboardCommands = MediumEditor.Extension.extend({
        name: 'keyboard-commands',

        /* KeyboardCommands Options */

        /* commands: [Array]
         * Array of objects describing each command and the combination of keys that will trigger it
         * Required for each object:
         *   command [String] (argument passed to editor.execAction())
         *   key [String] (keyboard character that triggers this command)
         *   meta [boolean] (whether the ctrl/meta key has to be active or inactive)
         *   shift [boolean] (whether the shift key has to be active or inactive)
         *   alt [boolean] (whether the alt key has to be active or inactive)
         */
        commands: [
            {
                command: 'bold',
                key: 'B',
                meta: true,
                shift: false,
                alt: false
            },
            {
                command: 'italic',
                key: 'I',
                meta: true,
                shift: false,
                alt: false
            },
            {
                command: 'underline',
                key: 'U',
                meta: true,
                shift: false,
                alt: false
            }
        ],

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.subscribe('editableKeydown', this.handleKeydown.bind(this));
            this.keys = {};
            this.commands.forEach(function (command) {
                var keyCode = command.key.charCodeAt(0);
                if (!this.keys[keyCode]) {
                    this.keys[keyCode] = [];
                }
                this.keys[keyCode].push(command);
            }, this);
        },

        handleKeydown: function (event) {
            var keyCode = MediumEditor.util.getKeyCode(event);
            if (!this.keys[keyCode]) {
                return;
            }

            var isMeta = MediumEditor.util.isMetaCtrlKey(event),
                isShift = !!event.shiftKey,
                isAlt = !!event.altKey;

            this.keys[keyCode].forEach(function (data) {
                if (data.meta === isMeta &&
                    data.shift === isShift &&
                    (data.alt === isAlt ||
                     undefined === data.alt)) { // TODO deprecated: remove check for undefined === data.alt when jumping to 6.0.0
                    event.preventDefault();
                    event.stopPropagation();

                    // command can be a function to execute
                    if (typeof data.command === 'function') {
                        data.command.apply(this);
                    }
                    // command can be false so the shortcut is just disabled
                    else if (false !== data.command) {
                        this.execAction(data.command);
                    }
                }
            }, this);
        }
    });

    MediumEditor.extensions.keyboardCommands = KeyboardCommands;
}());

(function () {
    'use strict';

    var FontNameForm = MediumEditor.extensions.form.extend({

        name: 'fontname',
        action: 'fontName',
        aria: 'change font name',
        contentDefault: '&#xB1;', // ±
        contentFA: '<i class="fa fa-font"></i>',

        fonts: ['', 'Arial', 'Verdana', 'Times New Roman'],

        init: function () {
            MediumEditor.extensions.form.prototype.init.apply(this, arguments);
        },

        // Called when the button the toolbar is clicked
        // Overrides ButtonExtension.handleClick
        handleClick: function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.isDisplayed()) {
                // Get FontName of current selection (convert to string since IE returns this as number)
                var fontName = this.document.queryCommandValue('fontName') + '';
                this.showForm(fontName);
            }

            return false;
        },

        // Called by medium-editor to append form to the toolbar
        getForm: function () {
            if (!this.form) {
                this.form = this.createForm();
            }
            return this.form;
        },

        // Used by medium-editor when the default toolbar is to be displayed
        isDisplayed: function () {
            return this.getForm().style.display === 'block';
        },

        hideForm: function () {
            this.getForm().style.display = 'none';
            this.getSelect().value = '';
        },

        showForm: function (fontName) {
            var select = this.getSelect();

            this.base.saveSelection();
            this.hideToolbarDefaultActions();
            this.getForm().style.display = 'block';
            this.setToolbarPosition();

            select.value = fontName || '';
            select.focus();
        },

        // Called by core when tearing down medium-editor (destroy)
        destroy: function () {
            if (!this.form) {
                return false;
            }

            if (this.form.parentNode) {
                this.form.parentNode.removeChild(this.form);
            }

            delete this.form;
        },

        // core methods

        doFormSave: function () {
            this.base.restoreSelection();
            this.base.checkSelection();
        },

        doFormCancel: function () {
            this.base.restoreSelection();
            this.clearFontName();
            this.base.checkSelection();
        },

        // form creation and event handling
        createForm: function () {
            var doc = this.document,
                form = doc.createElement('div'),
                select = doc.createElement('select'),
                close = doc.createElement('a'),
                save = doc.createElement('a'),
                option;

            // Font Name Form (div)
            form.className = 'medium-editor-toolbar-form';
            form.id = 'medium-editor-toolbar-form-fontname-' + this.getEditorId();

            // Handle clicks on the form itself
            this.on(form, 'click', this.handleFormClick.bind(this));

            // Add font names
            for (var i = 0; i<this.fonts.length; i++) {
                option = doc.createElement('option');
                option.innerHTML = this.fonts[i];
                option.value = this.fonts[i];
                select.appendChild(option);
            }

            select.className = 'medium-editor-toolbar-select';
            form.appendChild(select);

            // Handle typing in the textbox
            this.on(select, 'change', this.handleFontChange.bind(this));

            // Add save buton
            save.setAttribute('href', '#');
            save.className = 'medium-editor-toobar-save';
            save.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                             '<i class="fa fa-check"></i>' :
                             '&#10003;';
            form.appendChild(save);

            // Handle save button clicks (capture)
            this.on(save, 'click', this.handleSaveClick.bind(this), true);

            // Add close button
            close.setAttribute('href', '#');
            close.className = 'medium-editor-toobar-close';
            close.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                              '<i class="fa fa-times"></i>' :
                              '&times;';
            form.appendChild(close);

            // Handle close button clicks
            this.on(close, 'click', this.handleCloseClick.bind(this));

            return form;
        },

        getSelect: function () {
            return this.getForm().querySelector('select.medium-editor-toolbar-select');
        },

        clearFontName: function () {
            MediumEditor.selection.getSelectedElements(this.document).forEach(function (el) {
                if (el.nodeName.toLowerCase() === 'font' && el.hasAttribute('face')) {
                    el.removeAttribute('face');
                }
            });
        },

        handleFontChange: function () {
            var font = this.getSelect().value;
            if (font === '') {
                this.clearFontName();
            } else {
                this.execAction('fontName', { value: font });
            }
        },

        handleFormClick: function (event) {
            // make sure not to hide form when clicking inside the form
            event.stopPropagation();
        },

        handleSaveClick: function (event) {
            // Clicking Save -> create the font size
            event.preventDefault();
            this.doFormSave();
        },

        handleCloseClick: function (event) {
            // Click Close -> close the form
            event.preventDefault();
            this.doFormCancel();
        }
    });

    MediumEditor.extensions.fontName = FontNameForm;
}());

(function () {
    'use strict';

    var FontSizeForm = MediumEditor.extensions.form.extend({

        name: 'fontsize',
        action: 'fontSize',
        aria: 'increase/decrease font size',
        contentDefault: '&#xB1;', // ±
        contentFA: '<i class="fa fa-text-height"></i>',

        init: function () {
            MediumEditor.extensions.form.prototype.init.apply(this, arguments);
        },

        // Called when the button the toolbar is clicked
        // Overrides ButtonExtension.handleClick
        handleClick: function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.isDisplayed()) {
                // Get fontsize of current selection (convert to string since IE returns this as number)
                var fontSize = this.document.queryCommandValue('fontSize') + '';
                this.showForm(fontSize);
            }

            return false;
        },

        // Called by medium-editor to append form to the toolbar
        getForm: function () {
            if (!this.form) {
                this.form = this.createForm();
            }
            return this.form;
        },

        // Used by medium-editor when the default toolbar is to be displayed
        isDisplayed: function () {
            return this.getForm().style.display === 'block';
        },

        hideForm: function () {
            this.getForm().style.display = 'none';
            this.getInput().value = '';
        },

        showForm: function (fontSize) {
            var input = this.getInput();

            this.base.saveSelection();
            this.hideToolbarDefaultActions();
            this.getForm().style.display = 'block';
            this.setToolbarPosition();

            input.value = fontSize || '';
            input.focus();
        },

        // Called by core when tearing down medium-editor (destroy)
        destroy: function () {
            if (!this.form) {
                return false;
            }

            if (this.form.parentNode) {
                this.form.parentNode.removeChild(this.form);
            }

            delete this.form;
        },

        // core methods

        doFormSave: function () {
            this.base.restoreSelection();
            this.base.checkSelection();
        },

        doFormCancel: function () {
            this.base.restoreSelection();
            this.clearFontSize();
            this.base.checkSelection();
        },

        // form creation and event handling
        createForm: function () {
            var doc = this.document,
                form = doc.createElement('div'),
                input = doc.createElement('input'),
                close = doc.createElement('a'),
                save = doc.createElement('a');

            // Font Size Form (div)
            form.className = 'medium-editor-toolbar-form';
            form.id = 'medium-editor-toolbar-form-fontsize-' + this.getEditorId();

            // Handle clicks on the form itself
            this.on(form, 'click', this.handleFormClick.bind(this));

            // Add font size slider
            input.setAttribute('type', 'range');
            input.setAttribute('min', '1');
            input.setAttribute('max', '7');
            input.className = 'medium-editor-toolbar-input';
            form.appendChild(input);

            // Handle typing in the textbox
            this.on(input, 'change', this.handleSliderChange.bind(this));

            // Add save buton
            save.setAttribute('href', '#');
            save.className = 'medium-editor-toobar-save';
            save.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                             '<i class="fa fa-check"></i>' :
                             '&#10003;';
            form.appendChild(save);

            // Handle save button clicks (capture)
            this.on(save, 'click', this.handleSaveClick.bind(this), true);

            // Add close button
            close.setAttribute('href', '#');
            close.className = 'medium-editor-toobar-close';
            close.innerHTML = this.getEditorOption('buttonLabels') === 'fontawesome' ?
                              '<i class="fa fa-times"></i>' :
                              '&times;';
            form.appendChild(close);

            // Handle close button clicks
            this.on(close, 'click', this.handleCloseClick.bind(this));

            return form;
        },

        getInput: function () {
            return this.getForm().querySelector('input.medium-editor-toolbar-input');
        },

        clearFontSize: function () {
            MediumEditor.selection.getSelectedElements(this.document).forEach(function (el) {
                if (el.nodeName.toLowerCase() === 'font' && el.hasAttribute('size')) {
                    el.removeAttribute('size');
                }
            });
        },

        handleSliderChange: function () {
            var size = this.getInput().value;
            if (size === '4') {
                this.clearFontSize();
            } else {
                this.execAction('fontSize', { value: size });
            }
        },

        handleFormClick: function (event) {
            // make sure not to hide form when clicking inside the form
            event.stopPropagation();
        },

        handleSaveClick: function (event) {
            // Clicking Save -> create the font size
            event.preventDefault();
            this.doFormSave();
        },

        handleCloseClick: function (event) {
            // Click Close -> close the form
            event.preventDefault();
            this.doFormCancel();
        }
    });

    MediumEditor.extensions.fontSize = FontSizeForm;
}());
(function () {
    'use strict';

    /* Helpers and internal variables that don't need to be members of actual paste handler */

    var pasteBinDefaultContent = '%ME_PASTEBIN%',
        lastRange = null,
        keyboardPasteEditable = null,
        stopProp = function (event) {
            event.stopPropagation();
        };

    /*jslint regexp: true*/
    /*
        jslint does not allow character negation, because the negation
        will not match any unicode characters. In the regexes in this
        block, negation is used specifically to match the end of an html
        tag, and in fact unicode characters *should* be allowed.
    */
    function createReplacements() {
        return [
            // Remove anything but the contents within the BODY element
            [new RegExp(/^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/g), ''],

            // cleanup comments added by Chrome when pasting html
            [new RegExp(/<!--StartFragment-->|<!--EndFragment-->/g), ''],

            // Trailing BR elements
            [new RegExp(/<br>$/i), ''],

            // replace two bogus tags that begin pastes from google docs
            [new RegExp(/<[^>]*docs-internal-guid[^>]*>/gi), ''],
            [new RegExp(/<\/b>(<br[^>]*>)?$/gi), ''],

             // un-html spaces and newlines inserted by OS X
            [new RegExp(/<span class="Apple-converted-space">\s+<\/span>/g), ' '],
            [new RegExp(/<br class="Apple-interchange-newline">/g), '<br>'],

            // replace google docs italics+bold with a span to be replaced once the html is inserted
            [new RegExp(/<span[^>]*(font-style:italic;font-weight:(bold|700)|font-weight:(bold|700);font-style:italic)[^>]*>/gi), '<span class="replace-with italic bold">'],

            // replace google docs italics with a span to be replaced once the html is inserted
            [new RegExp(/<span[^>]*font-style:italic[^>]*>/gi), '<span class="replace-with italic">'],

            //[replace google docs bolds with a span to be replaced once the html is inserted
            [new RegExp(/<span[^>]*font-weight:(bold|700)[^>]*>/gi), '<span class="replace-with bold">'],

             // replace manually entered b/i/a tags with real ones
            [new RegExp(/&lt;(\/?)(i|b|a)&gt;/gi), '<$1$2>'],

             // replace manually a tags with real ones, converting smart-quotes from google docs
            [new RegExp(/&lt;a(?:(?!href).)+href=(?:&quot;|&rdquo;|&ldquo;|"|“|”)(((?!&quot;|&rdquo;|&ldquo;|"|“|”).)*)(?:&quot;|&rdquo;|&ldquo;|"|“|”)(?:(?!&gt;).)*&gt;/gi), '<a href="$1">'],

            // Newlines between paragraphs in html have no syntactic value,
            // but then have a tendency to accidentally become additional paragraphs down the line
            [new RegExp(/<\/p>\n+/gi), '</p>'],
            [new RegExp(/\n+<p/gi), '<p'],

            // Microsoft Word makes these odd tags, like <o:p></o:p>
            [new RegExp(/<\/?o:[a-z]*>/gi), ''],

            // Microsoft Word adds some special elements around list items
            [new RegExp(/<!\[if !supportLists\]>(((?!<!).)*)<!\[endif]\>/gi), '$1']
        ];
    }
    /*jslint regexp: false*/

    /**
     * Gets various content types out of the Clipboard API. It will also get the
     * plain text using older IE and WebKit API.
     *
     * @param {event} event Event fired on paste.
     * @param {win} reference to window
     * @param {doc} reference to document
     * @return {Object} Object with mime types and data for those mime types.
     */
    function getClipboardContent(event, win, doc) {
        var dataTransfer = event.clipboardData || win.clipboardData || doc.dataTransfer,
            data = {};

        if (!dataTransfer) {
            return data;
        }

        // Use old WebKit/IE API
        if (dataTransfer.getData) {
            var legacyText = dataTransfer.getData('Text');
            if (legacyText && legacyText.length > 0) {
                data['text/plain'] = legacyText;
            }
        }

        if (dataTransfer.types) {
            for (var i = 0; i < dataTransfer.types.length; i++) {
                var contentType = dataTransfer.types[i];
                data[contentType] = dataTransfer.getData(contentType);
            }
        }

        return data;
    }

    var PasteHandler = MediumEditor.Extension.extend({
        /* Paste Options */

        /* forcePlainText: [boolean]
         * Forces pasting as plain text.
         */
        forcePlainText: true,

        /* cleanPastedHTML: [boolean]
         * cleans pasted content from different sources, like google docs etc.
         */
        cleanPastedHTML: false,

        /* preCleanReplacements: [Array]
         * custom pairs (2 element arrays) of RegExp and replacement text to use during past when
         * __forcePlainText__ or __cleanPastedHTML__ are `true` OR when calling `cleanPaste(text)` helper method.
         * These replacements are executed before any medium editor defined replacements.
         */
        preCleanReplacements: [],

        /* cleanReplacements: [Array]
         * custom pairs (2 element arrays) of RegExp and replacement text to use during paste when
         * __forcePlainText__ or __cleanPastedHTML__ are `true` OR when calling `cleanPaste(text)` helper method.
         * These replacements are executed after any medium editor defined replacements.
         */
        cleanReplacements: [],

        /* cleanAttrs:: [Array]
         * list of element attributes to remove during paste when __cleanPastedHTML__ is `true` or when
         * calling `cleanPaste(text)` or `pasteHTML(html, options)` helper methods.
         */
        cleanAttrs: ['class', 'style', 'dir'],

        /* cleanTags: [Array]
         * list of element tag names to remove during paste when __cleanPastedHTML__ is `true` or when
         * calling `cleanPaste(text)` or `pasteHTML(html, options)` helper methods.
         */
        cleanTags: ['meta'],

        /* unwrapTags: [Array]
         * list of element tag names to unwrap (remove the element tag but retain its child elements)
         * during paste when __cleanPastedHTML__ is `true` or when
         * calling `cleanPaste(text)` or `pasteHTML(html, options)` helper methods.
         */
        unwrapTags: [],

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            if (this.forcePlainText || this.cleanPastedHTML) {
                this.subscribe('editableKeydown', this.handleKeydown.bind(this));
                // We need access to the full event data in paste
                // so we can't use the editablePaste event here
                this.getEditorElements().forEach(function (element) {
                    this.on(element, 'paste', this.handlePaste.bind(this));
                }, this);
                this.subscribe('addElement', this.handleAddElement.bind(this));
            }
        },

        handleAddElement: function (event, editable) {
            this.on(editable, 'paste', this.handlePaste.bind(this));
        },

        destroy: function () {
            // Make sure pastebin is destroyed in case it's still around for some reason
            if (this.forcePlainText || this.cleanPastedHTML) {
                this.removePasteBin();
            }
        },

        handlePaste: function (event, editable) {
            if (event.defaultPrevented) {
                return;
            }

            var clipboardContent = getClipboardContent(event, this.window, this.document),
                pastedHTML = clipboardContent['text/html'],
                pastedPlain = clipboardContent['text/plain'];

            if (this.window.clipboardData && event.clipboardData === undefined && !pastedHTML) {
                // If window.clipboardData exists, but event.clipboardData doesn't exist,
                // we're probably in IE. IE only has two possibilities for clipboard
                // data format: 'Text' and 'URL'.
                //
                // For IE, we'll fallback to 'Text' for text/html
                pastedHTML = pastedPlain;
            }

            if (pastedHTML || pastedPlain) {
                event.preventDefault();

                this.doPaste(pastedHTML, pastedPlain, editable);
            }
        },

        doPaste: function (pastedHTML, pastedPlain, editable) {
            var paragraphs,
                html = '',
                p;

            if (this.cleanPastedHTML && pastedHTML) {
                return this.cleanPaste(pastedHTML);
            }

            if (!pastedPlain) {
                return;
            }

            if (!(this.getEditorOption('disableReturn') || (editable && editable.getAttribute('data-disable-return')))) {
                paragraphs = pastedPlain.split(/[\r\n]+/g);
                // If there are no \r\n in data, don't wrap in <p>
                if (paragraphs.length > 1) {
                    for (p = 0; p < paragraphs.length; p += 1) {
                        if (paragraphs[p] !== '') {
                            html += '<p>' + MediumEditor.util.htmlEntities(paragraphs[p]) + '</p>';
                        }
                    }
                } else {
                    html = MediumEditor.util.htmlEntities(paragraphs[0]);
                }
            } else {
                html = MediumEditor.util.htmlEntities(pastedPlain);
            }
            MediumEditor.util.insertHTMLCommand(this.document, html);
        },

        handlePasteBinPaste: function (event) {
            if (event.defaultPrevented) {
                this.removePasteBin();
                return;
            }

            var clipboardContent = getClipboardContent(event, this.window, this.document),
                pastedHTML = clipboardContent['text/html'],
                pastedPlain = clipboardContent['text/plain'],
                editable = keyboardPasteEditable;

            // If we have valid html already, or we're not in cleanPastedHTML mode
            // we can ignore the paste bin and just paste now
            if (!this.cleanPastedHTML || pastedHTML) {
                event.preventDefault();
                this.removePasteBin();
                this.doPaste(pastedHTML, pastedPlain, editable);

                // The event handling code listens for paste on the editable element
                // in order to trigger the editablePaste event.  Since this paste event
                // is happening on the pastebin, the event handling code never knows about it
                // So, we have to trigger editablePaste manually
                this.trigger('editablePaste', { currentTarget: editable, target: editable }, editable);
                return;
            }

            // We need to look at the paste bin, so do a setTimeout to let the paste
            // fall through into the paste bin
            setTimeout(function () {
                // Only look for HTML if we're in cleanPastedHTML mode
                if (this.cleanPastedHTML) {
                    // If clipboard didn't have HTML, try the paste bin
                    pastedHTML = this.getPasteBinHtml();
                }

                // If we needed the paste bin, we're done with it now, remove it
                this.removePasteBin();

                // Handle the paste with the html from the paste bin
                this.doPaste(pastedHTML, pastedPlain, editable);

                // The event handling code listens for paste on the editable element
                // in order to trigger the editablePaste event.  Since this paste event
                // is happening on the pastebin, the event handling code never knows about it
                // So, we have to trigger editablePaste manually
                this.trigger('editablePaste', { currentTarget: editable, target: editable }, editable);
            }.bind(this), 0);
        },

        handleKeydown: function (event, editable) {
            // if it's not Ctrl+V, do nothing
            if (!(MediumEditor.util.isKey(event, MediumEditor.util.keyCode.V) && MediumEditor.util.isMetaCtrlKey(event))) {
                return;
            }

            event.stopImmediatePropagation();

            this.removePasteBin();
            this.createPasteBin(editable);
        },

        createPasteBin: function (editable) {
            var rects,
                range = MediumEditor.selection.getSelectionRange(this.document),
                top = this.window.pageYOffset;

            keyboardPasteEditable = editable;

            if (range) {
                rects = range.getClientRects();

                // on empty line, rects is empty so we grab information from the first container of the range
                if (rects.length) {
                    top += rects[0].top;
                } else if (range.startContainer.getBoundingClientRect !== undefined) {
                    top += range.startContainer.getBoundingClientRect().top;
                } else {
                    top += range.getBoundingClientRect().top;
                }
            }

            lastRange = range;

            var pasteBinElm = this.document.createElement('div');
            pasteBinElm.id = this.pasteBinId = 'medium-editor-pastebin-' + (+Date.now());
            pasteBinElm.setAttribute('style', 'border: 1px red solid; position: absolute; top: ' + top + 'px; width: 10px; height: 10px; overflow: hidden; opacity: 0');
            pasteBinElm.setAttribute('contentEditable', true);
            pasteBinElm.innerHTML = pasteBinDefaultContent;

            this.document.body.appendChild(pasteBinElm);

            // avoid .focus() to stop other event (actually the paste event)
            this.on(pasteBinElm, 'focus', stopProp);
            this.on(pasteBinElm, 'focusin', stopProp);
            this.on(pasteBinElm, 'focusout', stopProp);

            pasteBinElm.focus();

            MediumEditor.selection.selectNode(pasteBinElm, this.document);

            if (!this.boundHandlePaste) {
                this.boundHandlePaste = this.handlePasteBinPaste.bind(this);
            }

            this.on(pasteBinElm, 'paste', this.boundHandlePaste);
        },

        removePasteBin: function () {
            if (null !== lastRange) {
                MediumEditor.selection.selectRange(this.document, lastRange);
                lastRange = null;
            }

            if (null !== keyboardPasteEditable) {
                keyboardPasteEditable = null;
            }

            var pasteBinElm = this.getPasteBin();
            if (!pasteBinElm) {
                return;
            }

            if (pasteBinElm) {
                this.off(pasteBinElm, 'focus', stopProp);
                this.off(pasteBinElm, 'focusin', stopProp);
                this.off(pasteBinElm, 'focusout', stopProp);
                this.off(pasteBinElm, 'paste', this.boundHandlePaste);
                pasteBinElm.parentElement.removeChild(pasteBinElm);
            }
        },

        getPasteBin: function () {
            return this.document.getElementById(this.pasteBinId);
        },

        getPasteBinHtml: function () {
            var pasteBinElm = this.getPasteBin();

            if (!pasteBinElm) {
                return false;
            }

            // WebKit has a nice bug where it clones the paste bin if you paste from for example notepad
            // so we need to force plain text mode in this case
            if (pasteBinElm.firstChild && pasteBinElm.firstChild.id === 'mcepastebin') {
                return false;
            }

            var pasteBinHtml = pasteBinElm.innerHTML;

            // If paste bin is empty try using plain text mode
            // since that is better than nothing right
            if (!pasteBinHtml || pasteBinHtml === pasteBinDefaultContent) {
                return false;
            }

            return pasteBinHtml;
        },

        cleanPaste: function (text) {
            var i, elList, tmp, workEl,
                multiline = /<p|<br|<div/.test(text),
                replacements = [].concat(
                    this.preCleanReplacements || [],
                    createReplacements(),
                    this.cleanReplacements || []);

            for (i = 0; i < replacements.length; i += 1) {
                text = text.replace(replacements[i][0], replacements[i][1]);
            }

            if (!multiline) {
                return this.pasteHTML(text);
            }

            // create a temporary div to cleanup block elements
            tmp = this.document.createElement('div');

            // double br's aren't converted to p tags, but we want paragraphs.
            tmp.innerHTML = '<p>' + text.split('<br><br>').join('</p><p>') + '</p>';

            // block element cleanup
            elList = tmp.querySelectorAll('a,p,div,br');
            for (i = 0; i < elList.length; i += 1) {
                workEl = elList[i];

                // Microsoft Word replaces some spaces with newlines.
                // While newlines between block elements are meaningless, newlines within
                // elements are sometimes actually spaces.
                workEl.innerHTML = workEl.innerHTML.replace(/\n/gi, ' ');

                switch (workEl.nodeName.toLowerCase()) {
                    case 'p':
                    case 'div':
                        this.filterCommonBlocks(workEl);
                        break;
                    case 'br':
                        this.filterLineBreak(workEl);
                        break;
                }
            }

            this.pasteHTML(tmp.innerHTML);
        },

        pasteHTML: function (html, options) {
            options = MediumEditor.util.defaults({}, options, {
                cleanAttrs: this.cleanAttrs,
                cleanTags: this.cleanTags,
                unwrapTags: this.unwrapTags
            });

            var elList, workEl, i, fragmentBody, pasteBlock = this.document.createDocumentFragment();

            pasteBlock.appendChild(this.document.createElement('body'));

            fragmentBody = pasteBlock.querySelector('body');
            fragmentBody.innerHTML = html;

            this.cleanupSpans(fragmentBody);

            elList = fragmentBody.querySelectorAll('*');
            for (i = 0; i < elList.length; i += 1) {
                workEl = elList[i];

                if ('a' === workEl.nodeName.toLowerCase() && this.getEditorOption('targetBlank')) {
                    MediumEditor.util.setTargetBlank(workEl);
                }

                MediumEditor.util.cleanupAttrs(workEl, options.cleanAttrs);
                MediumEditor.util.cleanupTags(workEl, options.cleanTags);
                MediumEditor.util.unwrapTags(workEl, options.unwrapTags);
            }

            MediumEditor.util.insertHTMLCommand(this.document, fragmentBody.innerHTML.replace(/&nbsp;/g, ' '));
        },

        // TODO (6.0): Make this an internal helper instead of member of paste handler
        isCommonBlock: function (el) {
            return (el && (el.nodeName.toLowerCase() === 'p' || el.nodeName.toLowerCase() === 'div'));
        },

        // TODO (6.0): Make this an internal helper instead of member of paste handler
        filterCommonBlocks: function (el) {
            if (/^\s*$/.test(el.textContent) && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        },

        // TODO (6.0): Make this an internal helper instead of member of paste handler
        filterLineBreak: function (el) {
            if (this.isCommonBlock(el.previousElementSibling)) {
                // remove stray br's following common block elements
                this.removeWithParent(el);
            } else if (this.isCommonBlock(el.parentNode) && (el.parentNode.firstChild === el || el.parentNode.lastChild === el)) {
                // remove br's just inside open or close tags of a div/p
                this.removeWithParent(el);
            } else if (el.parentNode && el.parentNode.childElementCount === 1 && el.parentNode.textContent === '') {
                // and br's that are the only child of elements other than div/p
                this.removeWithParent(el);
            }
        },

        // TODO (6.0): Make this an internal helper instead of member of paste handler
        // remove an element, including its parent, if it is the only element within its parent
        removeWithParent: function (el) {
            if (el && el.parentNode) {
                if (el.parentNode.parentNode && el.parentNode.childElementCount === 1) {
                    el.parentNode.parentNode.removeChild(el.parentNode);
                } else {
                    el.parentNode.removeChild(el);
                }
            }
        },

        // TODO (6.0): Make this an internal helper instead of member of paste handler
        cleanupSpans: function (containerEl) {
            var i,
                el,
                newEl,
                spans = containerEl.querySelectorAll('.replace-with'),
                isCEF = function (el) {
                    return (el && el.nodeName !== '#text' && el.getAttribute('contenteditable') === 'false');
                };

            for (i = 0; i < spans.length; i += 1) {
                el = spans[i];
                newEl = this.document.createElement(el.classList.contains('bold') ? 'b' : 'i');

                if (el.classList.contains('bold') && el.classList.contains('italic')) {
                    // add an i tag as well if this has both italics and bold
                    newEl.innerHTML = '<i>' + el.innerHTML + '</i>';
                } else {
                    newEl.innerHTML = el.innerHTML;
                }
                el.parentNode.replaceChild(newEl, el);
            }

            spans = containerEl.querySelectorAll('span');
            for (i = 0; i < spans.length; i += 1) {
                el = spans[i];

                // bail if span is in contenteditable = false
                if (MediumEditor.util.traverseUp(el, isCEF)) {
                    return false;
                }

                // remove empty spans, replace others with their contents
                MediumEditor.util.unwrap(el, this.document);
            }
        }
    });

    MediumEditor.extensions.paste = PasteHandler;
}());

(function () {
    'use strict';

    var Placeholder = MediumEditor.Extension.extend({
        name: 'placeholder',

        /* Placeholder Options */

        /* text: [string]
         * Text to display in the placeholder
         */
        text: 'Type your text',

        /* hideOnClick: [boolean]
         * Should we hide the placeholder on click (true) or when user starts typing (false)
         */
        hideOnClick: true,

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.initPlaceholders();
            this.attachEventHandlers();
        },

        initPlaceholders: function () {
            this.getEditorElements().forEach(this.initElement, this);
        },

        handleAddElement: function (event, editable) {
            this.initElement(editable);
        },

        initElement: function (el) {
            if (!el.getAttribute('data-placeholder')) {
                el.setAttribute('data-placeholder', this.text);
            }
            this.updatePlaceholder(el);
        },

        destroy: function () {
            this.getEditorElements().forEach(this.cleanupElement, this);
        },

        handleRemoveElement: function (event, editable) {
            this.cleanupElement(editable);
        },

        cleanupElement: function (el) {
            if (el.getAttribute('data-placeholder') === this.text) {
                el.removeAttribute('data-placeholder');
            }
        },

        showPlaceholder: function (el) {
            if (el) {
                // https://github.com/yabwe/medium-editor/issues/234
                // In firefox, styling the placeholder with an absolutely positioned
                // pseudo element causes the cursor to appear in a bad location
                // when the element is completely empty, so apply a different class to
                // style it with a relatively positioned pseudo element
                if (MediumEditor.util.isFF && el.childNodes.length === 0) {
                    el.classList.add('medium-editor-placeholder-relative');
                    el.classList.remove('medium-editor-placeholder');
                } else {
                    el.classList.add('medium-editor-placeholder');
                    el.classList.remove('medium-editor-placeholder-relative');
                }
            }
        },

        hidePlaceholder: function (el) {
            if (el) {
                el.classList.remove('medium-editor-placeholder');
                el.classList.remove('medium-editor-placeholder-relative');
            }
        },

        updatePlaceholder: function (el, dontShow) {
            // If the element has content, hide the placeholder
            if (el.querySelector('img, blockquote, ul, ol, table') || (el.textContent.replace(/^\s+|\s+$/g, '') !== '')) {
                return this.hidePlaceholder(el);
            }

            if (!dontShow) {
                this.showPlaceholder(el);
            }
        },

        attachEventHandlers: function () {
            if (this.hideOnClick) {
                // For the 'hideOnClick' option, the placeholder should always be hidden on focus
                this.subscribe('focus', this.handleFocus.bind(this));
            }

            // If the editor has content, it should always hide the placeholder
            this.subscribe('editableInput', this.handleInput.bind(this));

            // When the editor loses focus, check if the placeholder should be visible
            this.subscribe('blur', this.handleBlur.bind(this));

            // Need to know when elements are added/removed from the editor
            this.subscribe('addElement', this.handleAddElement.bind(this));
            this.subscribe('removeElement', this.handleRemoveElement.bind(this));
        },

        handleInput: function (event, element) {
            // If the placeholder should be hidden on focus and the
            // element has focus, don't show the placeholder
            var dontShow = this.hideOnClick && (element === this.base.getFocusedElement());

            // Editor's content has changed, check if the placeholder should be hidden
            this.updatePlaceholder(element, dontShow);
        },

        handleFocus: function (event, element) {
            // Editor has focus, hide the placeholder
            this.hidePlaceholder(element);
        },

        handleBlur: function (event, element) {
            // Editor has lost focus, check if the placeholder should be shown
            this.updatePlaceholder(element);
        }
    });

    MediumEditor.extensions.placeholder = Placeholder;
}());

(function () {
    'use strict';

    var Toolbar = MediumEditor.Extension.extend({
        name: 'toolbar',

        /* Toolbar Options */

        /* align: ['left'|'center'|'right']
         * When the __static__ option is true, this aligns the static toolbar
         * relative to the medium-editor element.
         */
        align: 'center',

        /* allowMultiParagraphSelection: [boolean]
         * enables/disables whether the toolbar should be displayed when
         * selecting multiple paragraphs/block elements
         */
        allowMultiParagraphSelection: true,

        /* buttons: [Array]
         * the names of the set of buttons to display on the toolbar.
         */
        buttons: ['bold', 'italic', 'underline', 'anchor', 'h2', 'h3', 'quote'],

        /* diffLeft: [Number]
         * value in pixels to be added to the X axis positioning of the toolbar.
         */
        diffLeft: 0,

        /* diffTop: [Number]
         * value in pixels to be added to the Y axis positioning of the toolbar.
         */
        diffTop: -10,

        /* firstButtonClass: [string]
         * CSS class added to the first button in the toolbar.
         */
        firstButtonClass: 'medium-editor-button-first',

        /* lastButtonClass: [string]
         * CSS class added to the last button in the toolbar.
         */
        lastButtonClass: 'medium-editor-button-last',

        /* standardizeSelectionStart: [boolean]
         * enables/disables standardizing how the beginning of a range is decided
         * between browsers whenever the selected text is analyzed for updating toolbar buttons status.
         */
        standardizeSelectionStart: false,

        /* static: [boolean]
         * enable/disable the toolbar always displaying in the same location
         * relative to the medium-editor element.
         */
        static: false,

        /* sticky: [boolean]
         * When the __static__ option is true, this enables/disables the toolbar
         * "sticking" to the viewport and staying visible on the screen while
         * the page scrolls.
         */
        sticky: false,

        /* stickyTopOffset: [Number]
         * Value in pixel of the top offset above the toolbar
         */
        stickyTopOffset: 0,

        /* updateOnEmptySelection: [boolean]
         * When the __static__ option is true, this enables/disables updating
         * the state of the toolbar buttons even when the selection is collapsed
         * (there is no selection, just a cursor).
         */
        updateOnEmptySelection: false,

        /* relativeContainer: [node]
         * appending the toolbar to a given node instead of body
         */
        relativeContainer: null,

        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.initThrottledMethods();

            if (!this.relativeContainer) {
                this.getEditorOption('elementsContainer').appendChild(this.getToolbarElement());
            } else {
                this.relativeContainer.appendChild(this.getToolbarElement());
            }
        },

        // Helper method to execute method for every extension, but ignoring the toolbar extension
        forEachExtension: function (iterator, context) {
            return this.base.extensions.forEach(function (command) {
                if (command === this) {
                    return;
                }
                return iterator.apply(context || this, arguments);
            }, this);
        },

        // Toolbar creation/deletion

        createToolbar: function () {
            var toolbar = this.document.createElement('div');

            toolbar.id = 'medium-editor-toolbar-' + this.getEditorId();
            toolbar.className = 'medium-editor-toolbar';

            if (this.static) {
                toolbar.className += ' static-toolbar';
            } else if (this.relativeContainer) {
                toolbar.className += ' medium-editor-relative-toolbar';
            } else {
                toolbar.className += ' medium-editor-stalker-toolbar';
            }

            toolbar.appendChild(this.createToolbarButtons());

            // Add any forms that extensions may have
            this.forEachExtension(function (extension) {
                if (extension.hasForm) {
                    toolbar.appendChild(extension.getForm());
                }
            });

            this.attachEventHandlers();

            return toolbar;
        },

        createToolbarButtons: function () {
            var ul = this.document.createElement('ul'),
                li,
                btn,
                buttons,
                extension,
                buttonName,
                buttonOpts;

            ul.id = 'medium-editor-toolbar-actions' + this.getEditorId();
            ul.className = 'medium-editor-toolbar-actions';
            ul.style.display = 'block';

            this.buttons.forEach(function (button) {
                if (typeof button === 'string') {
                    buttonName = button;
                    buttonOpts = null;
                } else {
                    buttonName = button.name;
                    buttonOpts = button;
                }

                // If the button already exists as an extension, it'll be returned
                // othwerise it'll create the default built-in button
                extension = this.base.addBuiltInExtension(buttonName, buttonOpts);

                if (extension && typeof extension.getButton === 'function') {
                    btn = extension.getButton(this.base);
                    li = this.document.createElement('li');
                    if (MediumEditor.util.isElement(btn)) {
                        li.appendChild(btn);
                    } else {
                        li.innerHTML = btn;
                    }
                    ul.appendChild(li);
                }
            }, this);

            buttons = ul.querySelectorAll('button');
            if (buttons.length > 0) {
                buttons[0].classList.add(this.firstButtonClass);
                buttons[buttons.length - 1].classList.add(this.lastButtonClass);
            }

            return ul;
        },

        destroy: function () {
            if (this.toolbar) {
                if (this.toolbar.parentNode) {
                    this.toolbar.parentNode.removeChild(this.toolbar);
                }
                delete this.toolbar;
            }
        },

        // Toolbar accessors

        getInteractionElements: function () {
            return this.getToolbarElement();
        },

        getToolbarElement: function () {
            if (!this.toolbar) {
                this.toolbar = this.createToolbar();
            }

            return this.toolbar;
        },

        getToolbarActionsElement: function () {
            return this.getToolbarElement().querySelector('.medium-editor-toolbar-actions');
        },

        // Toolbar event handlers

        initThrottledMethods: function () {
            // throttledPositionToolbar is throttled because:
            // - It will be called when the browser is resizing, which can fire many times very quickly
            // - For some event (like resize) a slight lag in UI responsiveness is OK and provides performance benefits
            this.throttledPositionToolbar = MediumEditor.util.throttle(function () {
                if (this.base.isActive) {
                    this.positionToolbarIfShown();
                }
            }.bind(this));
        },

        attachEventHandlers: function () {
            // MediumEditor custom events for when user beings and ends interaction with a contenteditable and its elements
            this.subscribe('blur', this.handleBlur.bind(this));
            this.subscribe('focus', this.handleFocus.bind(this));

            // Updating the state of the toolbar as things change
            this.subscribe('editableClick', this.handleEditableClick.bind(this));
            this.subscribe('editableKeyup', this.handleEditableKeyup.bind(this));

            // Handle mouseup on document for updating the selection in the toolbar
            this.on(this.document.documentElement, 'mouseup', this.handleDocumentMouseup.bind(this));

            // Add a scroll event for sticky toolbar
            if (this.static && this.sticky) {
                // On scroll (capture), re-position the toolbar
                this.on(this.window, 'scroll', this.handleWindowScroll.bind(this), true);
            }

            // On resize, re-position the toolbar
            this.on(this.window, 'resize', this.handleWindowResize.bind(this));
        },

        handleWindowScroll: function () {
            this.positionToolbarIfShown();
        },

        handleWindowResize: function () {
            this.throttledPositionToolbar();
        },

        handleDocumentMouseup: function (event) {
            // Do not trigger checkState when mouseup fires over the toolbar
            if (event &&
                    event.target &&
                    MediumEditor.util.isDescendant(this.getToolbarElement(), event.target)) {
                return false;
            }
            this.checkState();
        },

        handleEditableClick: function () {
            // Delay the call to checkState to handle bug where selection is empty
            // immediately after clicking inside a pre-existing selection
            setTimeout(function () {
                this.checkState();
            }.bind(this), 0);
        },

        handleEditableKeyup: function () {
            this.checkState();
        },

        handleBlur: function () {
            // Kill any previously delayed calls to hide the toolbar
            clearTimeout(this.hideTimeout);

            // Blur may fire even if we have a selection, so we want to prevent any delayed showToolbar
            // calls from happening in this specific case
            clearTimeout(this.delayShowTimeout);

            // Delay the call to hideToolbar to handle bug with multiple editors on the page at once
            this.hideTimeout = setTimeout(function () {
                this.hideToolbar();
            }.bind(this), 1);
        },

        handleFocus: function () {
            this.checkState();
        },

        // Hiding/showing toolbar

        isDisplayed: function () {
            return this.getToolbarElement().classList.contains('medium-editor-toolbar-active');
        },

        showToolbar: function () {
            clearTimeout(this.hideTimeout);
            if (!this.isDisplayed()) {
                this.getToolbarElement().classList.add('medium-editor-toolbar-active');
                this.trigger('showToolbar', {}, this.base.getFocusedElement());
            }
        },

        hideToolbar: function () {
            if (this.isDisplayed()) {
                this.getToolbarElement().classList.remove('medium-editor-toolbar-active');
                this.trigger('hideToolbar', {}, this.base.getFocusedElement());
            }
        },

        isToolbarDefaultActionsDisplayed: function () {
            return this.getToolbarActionsElement().style.display === 'block';
        },

        hideToolbarDefaultActions: function () {
            if (this.isToolbarDefaultActionsDisplayed()) {
                this.getToolbarActionsElement().style.display = 'none';
            }
        },

        showToolbarDefaultActions: function () {
            this.hideExtensionForms();

            if (!this.isToolbarDefaultActionsDisplayed()) {
                this.getToolbarActionsElement().style.display = 'block';
            }

            // Using setTimeout + options.delay because:
            // We will actually be displaying the toolbar, which should be controlled by options.delay
            this.delayShowTimeout = this.base.delay(function () {
                this.showToolbar();
            }.bind(this));
        },

        hideExtensionForms: function () {
            // Hide all extension forms
            this.forEachExtension(function (extension) {
                if (extension.hasForm && extension.isDisplayed()) {
                    extension.hideForm();
                }
            });
        },

        // Responding to changes in user selection

        // Checks for existance of multiple block elements in the current selection
        multipleBlockElementsSelected: function () {
            var regexEmptyHTMLTags = /<[^\/>][^>]*><\/[^>]+>/gim, // http://stackoverflow.com/questions/3129738/remove-empty-tags-using-regex
                regexBlockElements = new RegExp('<(' + MediumEditor.util.blockContainerElementNames.join('|') + ')[^>]*>', 'g'),
                selectionHTML = MediumEditor.selection.getSelectionHtml(this.document).replace(regexEmptyHTMLTags, ''), // Filter out empty blocks from selection
                hasMultiParagraphs = selectionHTML.match(regexBlockElements); // Find how many block elements are within the html

            return !!hasMultiParagraphs && hasMultiParagraphs.length > 1;
        },

        modifySelection: function () {
            var selection = this.window.getSelection(),
                selectionRange = selection.getRangeAt(0);

            /*
            * In firefox, there are cases (ie doubleclick of a word) where the selectionRange start
            * will be at the very end of an element.  In other browsers, the selectionRange start
            * would instead be at the very beginning of an element that actually has content.
            * example:
            *   <span>foo</span><span>bar</span>
            *
            * If the text 'bar' is selected, most browsers will have the selectionRange start at the beginning
            * of the 'bar' span.  However, there are cases where firefox will have the selectionRange start
            * at the end of the 'foo' span.  The contenteditable behavior will be ok, but if there are any
            * properties on the 'bar' span, they won't be reflected accurately in the toolbar
            * (ie 'Bold' button wouldn't be active)
            *
            * So, for cases where the selectionRange start is at the end of an element/node, find the next
            * adjacent text node that actually has content in it, and move the selectionRange start there.
            */
            if (this.standardizeSelectionStart &&
                    selectionRange.startContainer.nodeValue &&
                    (selectionRange.startOffset === selectionRange.startContainer.nodeValue.length)) {
                var adjacentNode = MediumEditor.util.findAdjacentTextNodeWithContent(MediumEditor.selection.getSelectionElement(this.window), selectionRange.startContainer, this.document);
                if (adjacentNode) {
                    var offset = 0;
                    while (adjacentNode.nodeValue.substr(offset, 1).trim().length === 0) {
                        offset = offset + 1;
                    }
                    selectionRange = MediumEditor.selection.select(this.document, adjacentNode, offset,
                        selectionRange.endContainer, selectionRange.endOffset);
                }
            }
        },

        checkState: function () {
            if (this.base.preventSelectionUpdates) {
                return;
            }

            // If no editable has focus OR selection is inside contenteditable = false
            // hide toolbar
            if (!this.base.getFocusedElement() ||
                    MediumEditor.selection.selectionInContentEditableFalse(this.window)) {
                return this.hideToolbar();
            }

            // If there's no selection element, selection element doesn't belong to this editor
            // or toolbar is disabled for this selection element
            // hide toolbar
            var selectionElement = MediumEditor.selection.getSelectionElement(this.window);
            if (!selectionElement ||
                    this.getEditorElements().indexOf(selectionElement) === -1 ||
                    selectionElement.getAttribute('data-disable-toolbar')) {
                return this.hideToolbar();
            }

            // Now we know there's a focused editable with a selection

            // If the updateOnEmptySelection option is true, show the toolbar
            if (this.updateOnEmptySelection && this.static) {
                return this.showAndUpdateToolbar();
            }

            // If we don't have a 'valid' selection -> hide toolbar
            if (!MediumEditor.selection.selectionContainsContent(this.document) ||
                (this.allowMultiParagraphSelection === false && this.multipleBlockElementsSelected())) {
                return this.hideToolbar();
            }

            this.showAndUpdateToolbar();
        },

        // Updating the toolbar

        showAndUpdateToolbar: function () {
            this.modifySelection();
            this.setToolbarButtonStates();
            this.trigger('positionToolbar', {}, this.base.getFocusedElement());
            this.showToolbarDefaultActions();
            this.setToolbarPosition();
        },

        setToolbarButtonStates: function () {
            this.forEachExtension(function (extension) {
                if (typeof extension.isActive === 'function' &&
                    typeof extension.setInactive === 'function') {
                    extension.setInactive();
                }
            });

            this.checkActiveButtons();
        },

        checkActiveButtons: function () {
            var manualStateChecks = [],
                queryState = null,
                selectionRange = MediumEditor.selection.getSelectionRange(this.document),
                parentNode,
                updateExtensionState = function (extension) {
                    if (typeof extension.checkState === 'function') {
                        extension.checkState(parentNode);
                    } else if (typeof extension.isActive === 'function' &&
                               typeof extension.isAlreadyApplied === 'function' &&
                               typeof extension.setActive === 'function') {
                        if (!extension.isActive() && extension.isAlreadyApplied(parentNode)) {
                            extension.setActive();
                        }
                    }
                };

            if (!selectionRange) {
                return;
            }

            // Loop through all extensions
            this.forEachExtension(function (extension) {
                // For those extensions where we can use document.queryCommandState(), do so
                if (typeof extension.queryCommandState === 'function') {
                    queryState = extension.queryCommandState();
                    // If queryCommandState returns a valid value, we can trust the browser
                    // and don't need to do our manual checks
                    if (queryState !== null) {
                        if (queryState && typeof extension.setActive === 'function') {
                            extension.setActive();
                        }
                        return;
                    }
                }
                // We can't use queryCommandState for this extension, so add to manualStateChecks
                manualStateChecks.push(extension);
            });

            parentNode = MediumEditor.selection.getSelectedParentElement(selectionRange);

            // Make sure the selection parent isn't outside of the contenteditable
            if (!this.getEditorElements().some(function (element) {
                    return MediumEditor.util.isDescendant(element, parentNode, true);
                })) {
                return;
            }

            // Climb up the DOM and do manual checks for whether a certain extension is currently enabled for this node
            while (parentNode) {
                manualStateChecks.forEach(updateExtensionState);

                // we can abort the search upwards if we leave the contentEditable element
                if (MediumEditor.util.isMediumEditorElement(parentNode)) {
                    break;
                }
                parentNode = parentNode.parentNode;
            }
        },

        // Positioning toolbar

        positionToolbarIfShown: function () {
            if (this.isDisplayed()) {
                this.setToolbarPosition();
            }
        },

        setToolbarPosition: function () {
            var container = this.base.getFocusedElement(),
                selection = this.window.getSelection();

            // If there isn't a valid selection, bail
            if (!container) {
                return this;
            }

            if (this.static || !selection.isCollapsed) {
                this.showToolbar();

                // we don't need any absolute positioning if relativeContainer is set
                if (!this.relativeContainer) {
                    if (this.static) {
                        this.positionStaticToolbar(container);
                    } else {
                        this.positionToolbar(selection);
                    }
                }

                this.trigger('positionedToolbar', {}, this.base.getFocusedElement());
            }
        },

        positionStaticToolbar: function (container) {
            // position the toolbar at left 0, so we can get the real width of the toolbar
            this.getToolbarElement().style.left = '0';

            // document.documentElement for IE 9
            var scrollTop = (this.document.documentElement && this.document.documentElement.scrollTop) || this.document.body.scrollTop,
                windowWidth = this.window.innerWidth,
                toolbarElement = this.getToolbarElement(),
                containerRect = container.getBoundingClientRect(),
                containerTop = containerRect.top + scrollTop,
                containerCenter = (containerRect.left + (containerRect.width / 2)),
                toolbarHeight = toolbarElement.offsetHeight,
                toolbarWidth = toolbarElement.offsetWidth,
                halfOffsetWidth = toolbarWidth / 2,
                targetLeft;

            if (this.sticky) {
                // If it's beyond the height of the editor, position it at the bottom of the editor
                if (scrollTop > (containerTop + container.offsetHeight - toolbarHeight - this.stickyTopOffset)) {
                    toolbarElement.style.top = (containerTop + container.offsetHeight - toolbarHeight) + 'px';
                    toolbarElement.classList.remove('medium-editor-sticky-toolbar');
                // Stick the toolbar to the top of the window
                } else if (scrollTop > (containerTop - toolbarHeight - this.stickyTopOffset)) {
                    toolbarElement.classList.add('medium-editor-sticky-toolbar');
                    toolbarElement.style.top = this.stickyTopOffset + 'px';
                // Normal static toolbar position
                } else {
                    toolbarElement.classList.remove('medium-editor-sticky-toolbar');
                    toolbarElement.style.top = containerTop - toolbarHeight + 'px';
                }
            } else {
                toolbarElement.style.top = containerTop - toolbarHeight + 'px';
            }

            switch (this.align) {
                case 'left':
                    targetLeft = containerRect.left;
                    break;

                case 'right':
                    targetLeft = containerRect.right - toolbarWidth;
                    break;

                case 'center':
                    targetLeft = containerCenter - halfOffsetWidth;
                    break;
            }

            if (targetLeft < 0) {
                targetLeft = 0;
            } else if ((targetLeft + toolbarWidth) > windowWidth) {
                targetLeft = (windowWidth - Math.ceil(toolbarWidth) - 1);
            }

            toolbarElement.style.left = targetLeft + 'px';
        },

        positionToolbar: function (selection) {
            // position the toolbar at left 0, so we can get the real width of the toolbar
            this.getToolbarElement().style.left = '0';
            this.getToolbarElement().style.right = 'initial';

            var range = selection.getRangeAt(0),
                boundary = range.getBoundingClientRect();

            // Handle selections with just images
            if (!boundary || ((boundary.height === 0 && boundary.width === 0) && range.startContainer === range.endContainer)) {
                // If there's a nested image, use that for the bounding rectangle
                if (range.startContainer.nodeType === 1 && range.startContainer.querySelector('img')) {
                    boundary = range.startContainer.querySelector('img').getBoundingClientRect();
                } else {
                    boundary = range.startContainer.getBoundingClientRect();
                }
            }

            var containerWidth = this.window.innerWidth,
                toolbarElement = this.getToolbarElement(),
                toolbarHeight = toolbarElement.offsetHeight,
                toolbarWidth = toolbarElement.offsetWidth,
                halfOffsetWidth = toolbarWidth / 2,
                buttonHeight = 50,
                defaultLeft = this.diffLeft - halfOffsetWidth,
                elementsContainer = this.getEditorOption('elementsContainer'),
                elementsContainerAbsolute = ['absolute', 'fixed'].indexOf(window.getComputedStyle(elementsContainer).getPropertyValue('position')) > -1,
                positions = {},
                relativeBoundary = {},
                middleBoundary, elementsContainerBoundary;

            // If container element is absolute / fixed, recalculate boundaries to be relative to the container
            if (elementsContainerAbsolute) {
                elementsContainerBoundary = elementsContainer.getBoundingClientRect();
                ['top', 'left'].forEach(function (key) {
                    relativeBoundary[key] = boundary[key] - elementsContainerBoundary[key];
                });

                relativeBoundary.width = boundary.width;
                relativeBoundary.height = boundary.height;
                boundary = relativeBoundary;

                containerWidth = elementsContainerBoundary.width;

                // Adjust top position according to container scroll position
                positions.top = elementsContainer.scrollTop;
            } else {
                // Adjust top position according to window scroll position
                positions.top = this.window.pageYOffset;
            }

            middleBoundary = boundary.left + boundary.width / 2;
            positions.top += boundary.top - toolbarHeight;

            if (boundary.top < buttonHeight) {
                toolbarElement.classList.add('medium-toolbar-arrow-over');
                toolbarElement.classList.remove('medium-toolbar-arrow-under');
                positions.top += buttonHeight + boundary.height - this.diffTop;
            } else {
                toolbarElement.classList.add('medium-toolbar-arrow-under');
                toolbarElement.classList.remove('medium-toolbar-arrow-over');
                positions.top += this.diffTop;
            }

            if (middleBoundary < halfOffsetWidth) {
                positions.left = defaultLeft + halfOffsetWidth;
                positions.right = 'initial';
            } else if ((containerWidth - middleBoundary) < halfOffsetWidth) {
                positions.left = 'auto';
                positions.right = 0;
            } else {
                positions.left = defaultLeft + middleBoundary;
                positions.right = 'initial';
            }

            ['top', 'left', 'right'].forEach(function (key) {
                toolbarElement.style[key] = positions[key] + (isNaN(positions[key]) ? '' : 'px');
            });
        }
    });

    MediumEditor.extensions.toolbar = Toolbar;
}());

(function () {
    'use strict';

    var ImageDragging = MediumEditor.Extension.extend({
        init: function () {
            MediumEditor.Extension.prototype.init.apply(this, arguments);

            this.subscribe('editableDrag', this.handleDrag.bind(this));
            this.subscribe('editableDrop', this.handleDrop.bind(this));
        },

        handleDrag: function (event) {
            var className = 'medium-editor-dragover';
            event.preventDefault();
            event.dataTransfer.dropEffect = 'copy';

            if (event.type === 'dragover') {
                event.target.classList.add(className);
            } else if (event.type === 'dragleave') {
                event.target.classList.remove(className);
            }
        },

        handleDrop: function (event) {
            var className = 'medium-editor-dragover',
                files;
            event.preventDefault();
            event.stopPropagation();

            // IE9 does not support the File API, so prevent file from opening in a new window
            // but also don't try to actually get the file
            if (event.dataTransfer.files) {
                files = Array.prototype.slice.call(event.dataTransfer.files, 0);
                files.some(function (file) {
                    if (file.type.match('image')) {
                        var fileReader, id;
                        fileReader = new FileReader();
                        fileReader.readAsDataURL(file);

                        id = 'medium-img-' + (+new Date());
                        MediumEditor.util.insertHTMLCommand(this.document, '<img class="medium-editor-image-loading" id="' + id + '" />');

                        fileReader.onload = function () {
                            var img = this.document.getElementById(id);
                            if (img) {
                                img.removeAttribute('id');
                                img.removeAttribute('class');
                                img.src = fileReader.result;
                            }
                        }.bind(this);
                    }
                }.bind(this));
            }
            event.target.classList.remove(className);
        }
    });

    MediumEditor.extensions.imageDragging = ImageDragging;
}());

(function () {
    'use strict';

    // Event handlers that shouldn't be exposed externally

    function handleDisableExtraSpaces(event) {
        var node = MediumEditor.selection.getSelectionStart(this.options.ownerDocument),
            textContent = node.textContent,
            caretPositions = MediumEditor.selection.getCaretOffsets(node);

        if ((textContent[caretPositions.left - 1] === undefined) || (textContent[caretPositions.left - 1].trim() === '') || (textContent[caretPositions.left] !== undefined && textContent[caretPositions.left].trim() === '')) {
            event.preventDefault();
        }
    }

    function handleDisabledEnterKeydown(event, element) {
        if (this.options.disableReturn || element.getAttribute('data-disable-return')) {
            event.preventDefault();
        } else if (this.options.disableDoubleReturn || element.getAttribute('data-disable-double-return')) {
            var node = MediumEditor.selection.getSelectionStart(this.options.ownerDocument);

            // if current text selection is empty OR previous sibling text is empty OR it is not a list
            if ((node && node.textContent.trim() === '' && node.nodeName.toLowerCase() !== 'li') ||
                (node.previousElementSibling && node.previousElementSibling.nodeName.toLowerCase() !== 'br' &&
                 node.previousElementSibling.textContent.trim() === '')) {
                event.preventDefault();
            }
        }
    }

    function handleTabKeydown(event) {
        // Override tab only for pre nodes
        var node = MediumEditor.selection.getSelectionStart(this.options.ownerDocument),
            tag = node && node.nodeName.toLowerCase();

        if (tag === 'pre') {
            event.preventDefault();
            MediumEditor.util.insertHTMLCommand(this.options.ownerDocument, '    ');
        }

        // Tab to indent list structures!
        if (MediumEditor.util.isListItem(node)) {
            event.preventDefault();

            // If Shift is down, outdent, otherwise indent
            if (event.shiftKey) {
                this.options.ownerDocument.execCommand('outdent', false, null);
            } else {
                this.options.ownerDocument.execCommand('indent', false, null);
            }
        }
    }

    function handleBlockDeleteKeydowns(event) {
        var p, node = MediumEditor.selection.getSelectionStart(this.options.ownerDocument),
            tagName = node.nodeName.toLowerCase(),
            isEmpty = /^(\s+|<br\/?>)?$/i,
            isHeader = /h\d/i;

        if (MediumEditor.util.isKey(event, [MediumEditor.util.keyCode.BACKSPACE, MediumEditor.util.keyCode.ENTER]) &&
                // has a preceeding sibling
                node.previousElementSibling &&
                // in a header
                isHeader.test(tagName) &&
                // at the very end of the block
                MediumEditor.selection.getCaretOffsets(node).left === 0) {
            if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.BACKSPACE) && isEmpty.test(node.previousElementSibling.innerHTML)) {
                // backspacing the begining of a header into an empty previous element will
                // change the tagName of the current node to prevent one
                // instead delete previous node and cancel the event.
                node.previousElementSibling.parentNode.removeChild(node.previousElementSibling);
                event.preventDefault();
            } else if (!this.options.disableDoubleReturn && MediumEditor.util.isKey(event, MediumEditor.util.keyCode.ENTER)) {
                // hitting return in the begining of a header will create empty header elements before the current one
                // instead, make "<p><br></p>" element, which are what happens if you hit return in an empty paragraph
                p = this.options.ownerDocument.createElement('p');
                p.innerHTML = '<br>';
                node.previousElementSibling.parentNode.insertBefore(p, node);
                event.preventDefault();
            }
        } else if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.DELETE) &&
                    // between two sibling elements
                    node.nextElementSibling &&
                    node.previousElementSibling &&
                    // not in a header
                    !isHeader.test(tagName) &&
                    // in an empty tag
                    isEmpty.test(node.innerHTML) &&
                    // when the next tag *is* a header
                    isHeader.test(node.nextElementSibling.nodeName.toLowerCase())) {
            // hitting delete in an empty element preceding a header, ex:
            //  <p>[CURSOR]</p><h1>Header</h1>
            // Will cause the h1 to become a paragraph.
            // Instead, delete the paragraph node and move the cursor to the begining of the h1

            // remove node and move cursor to start of header
            MediumEditor.selection.moveCursor(this.options.ownerDocument, node.nextElementSibling);

            node.previousElementSibling.parentNode.removeChild(node);

            event.preventDefault();
        } else if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.BACKSPACE) &&
                tagName === 'li' &&
                // hitting backspace inside an empty li
                isEmpty.test(node.innerHTML) &&
                // is first element (no preceeding siblings)
                !node.previousElementSibling &&
                // parent also does not have a sibling
                !node.parentElement.previousElementSibling &&
                // is not the only li in a list
                node.nextElementSibling &&
                node.nextElementSibling.nodeName.toLowerCase() === 'li') {
            // backspacing in an empty first list element in the first list (with more elements) ex:
            //  <ul><li>[CURSOR]</li><li>List Item 2</li></ul>
            // will remove the first <li> but add some extra element before (varies based on browser)
            // Instead, this will:
            // 1) remove the list element
            // 2) create a paragraph before the list
            // 3) move the cursor into the paragraph

            // create a paragraph before the list
            p = this.options.ownerDocument.createElement('p');
            p.innerHTML = '<br>';
            node.parentElement.parentElement.insertBefore(p, node.parentElement);

            // move the cursor into the new paragraph
            MediumEditor.selection.moveCursor(this.options.ownerDocument, p);

            // remove the list element
            node.parentElement.removeChild(node);

            event.preventDefault();
        } else if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.BACKSPACE) &&
                (MediumEditor.util.getClosestTag(node, 'blockquote') !== false) &&
                MediumEditor.selection.getCaretOffsets(node).left === 0) {

            // when cursor is at the begining of the element and the element is <blockquote>
            // then pressing backspace key should change the <blockquote> to a <p> tag
            event.preventDefault();
            MediumEditor.util.execFormatBlock(this.options.ownerDocument, 'p');
        } else if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.ENTER) &&
                (MediumEditor.util.getClosestTag(node, 'blockquote') !== false) &&
                MediumEditor.selection.getCaretOffsets(node).right === 0) {

            // when cursor is at the end of <blockquote>,
            // then pressing enter key should create <p> tag, not <blockquote>
            p = this.options.ownerDocument.createElement('p');
            p.innerHTML = '<br>';
            node.parentElement.insertBefore(p, node.nextSibling);

            // move the cursor into the new paragraph
            MediumEditor.selection.moveCursor(this.options.ownerDocument, p);

            event.preventDefault();
        } else if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.BACKSPACE) &&
                MediumEditor.util.isMediumEditorElement(node.parentElement) &&
                !node.previousElementSibling &&
                node.nextElementSibling &&
                isEmpty.test(node.innerHTML)) {

            // when cursor is in the first element, it's empty and user presses backspace,
            // do delete action instead to get rid of the first element and move caret to 2nd
            event.preventDefault();
            MediumEditor.selection.moveCursor(this.options.ownerDocument, node.nextSibling);
            node.parentElement.removeChild(node);
        }
    }

    function handleKeyup(event) {
        var node = MediumEditor.selection.getSelectionStart(this.options.ownerDocument),
            tagName;

        if (!node) {
            return;
        }

        // https://github.com/yabwe/medium-editor/issues/994
        // Firefox thrown an error when calling `formatBlock` on an empty editable blockContainer that's not a <div>
        if (MediumEditor.util.isMediumEditorElement(node) && node.children.length === 0 && !MediumEditor.util.isBlockContainer(node)) {
            this.options.ownerDocument.execCommand('formatBlock', false, 'p');
        }

        // https://github.com/yabwe/medium-editor/issues/834
        // https://github.com/yabwe/medium-editor/pull/382
        // Don't call format block if this is a block element (ie h1, figCaption, etc.)
        if (MediumEditor.util.isKey(event, MediumEditor.util.keyCode.ENTER) &&
            !MediumEditor.util.isListItem(node) &&
            !MediumEditor.util.isBlockContainer(node)) {

            tagName = node.nodeName.toLowerCase();
            // For anchor tags, unlink
            if (tagName === 'a') {
                this.options.ownerDocument.execCommand('unlink', false, null);
            } else if (!event.shiftKey && !event.ctrlKey) {
                this.options.ownerDocument.execCommand('formatBlock', false, 'p');
            }
        }
    }

    function handleEditableInput(event, editable) {
        var textarea = editable.parentNode.querySelector('textarea[medium-editor-textarea-id="' + editable.getAttribute('medium-editor-textarea-id') + '"]');
        if (textarea) {
            textarea.value = editable.innerHTML.trim();
        }
    }

    // Internal helper methods which shouldn't be exposed externally

    function addToEditors(win) {
        if (!win._mediumEditors) {
            // To avoid breaking users who are assuming that the unique id on
            // medium-editor elements will start at 1, inserting a 'null' in the
            // array so the unique-id can always map to the index of the editor instance
            win._mediumEditors = [null];
        }

        // If this already has a unique id, re-use it
        if (!this.id) {
            this.id = win._mediumEditors.length;
        }

        win._mediumEditors[this.id] = this;
    }

    function removeFromEditors(win) {
        if (!win._mediumEditors || !win._mediumEditors[this.id]) {
            return;
        }

        /* Setting the instance to null in the array instead of deleting it allows:
         * 1) Each instance to preserve its own unique-id, even after being destroyed
         *    and initialized again
         * 2) The unique-id to always correspond to an index in the array of medium-editor
         *    instances. Thus, we will be able to look at a contenteditable, and determine
         *    which instance it belongs to, by indexing into the global array.
         */
        win._mediumEditors[this.id] = null;
    }

    function createElementsArray(selector, doc, filterEditorElements) {
        var elements = [];

        if (!selector) {
            selector = [];
        }
        // If string, use as query selector
        if (typeof selector === 'string') {
            selector = doc.querySelectorAll(selector);
        }
        // If element, put into array
        if (MediumEditor.util.isElement(selector)) {
            selector = [selector];
        }

        if (filterEditorElements) {
            // Remove elements that have already been initialized by the editor
            // selecotr might not be an array (ie NodeList) so use for loop
            for (var i = 0; i < selector.length; i++) {
                var el = selector[i];
                if (MediumEditor.util.isElement(el) &&
                    !el.getAttribute('data-medium-editor-element') &&
                    !el.getAttribute('medium-editor-textarea-id')) {
                    elements.push(el);
                }
            }
        } else {
            // Convert NodeList (or other array like object) into an array
            elements = Array.prototype.slice.apply(selector);
        }

        return elements;
    }

    function cleanupTextareaElement(element) {
        var textarea = element.parentNode.querySelector('textarea[medium-editor-textarea-id="' + element.getAttribute('medium-editor-textarea-id') + '"]');
        if (textarea) {
            // Un-hide the textarea
            textarea.classList.remove('medium-editor-hidden');
            textarea.removeAttribute('medium-editor-textarea-id');
        }
        if (element.parentNode) {
            element.parentNode.removeChild(element);
        }
    }

    function setExtensionDefaults(extension, defaults) {
        Object.keys(defaults).forEach(function (prop) {
            if (extension[prop] === undefined) {
                extension[prop] = defaults[prop];
            }
        });
        return extension;
    }

    function initExtension(extension, name, instance) {
        var extensionDefaults = {
            'window': instance.options.contentWindow,
            'document': instance.options.ownerDocument,
            'base': instance
        };

        // Add default options into the extension
        extension = setExtensionDefaults(extension, extensionDefaults);

        // Call init on the extension
        if (typeof extension.init === 'function') {
            extension.init();
        }

        // Set extension name (if not already set)
        if (!extension.name) {
            extension.name = name;
        }
        return extension;
    }

    function isToolbarEnabled() {
        // If any of the elements don't have the toolbar disabled
        // We need a toolbar
        if (this.elements.every(function (element) {
                return !!element.getAttribute('data-disable-toolbar');
            })) {
            return false;
        }

        return this.options.toolbar !== false;
    }

    function isAnchorPreviewEnabled() {
        // If toolbar is disabled, don't add
        if (!isToolbarEnabled.call(this)) {
            return false;
        }

        return this.options.anchorPreview !== false;
    }

    function isPlaceholderEnabled() {
        return this.options.placeholder !== false;
    }

    function isAutoLinkEnabled() {
        return this.options.autoLink !== false;
    }

    function isImageDraggingEnabled() {
        return this.options.imageDragging !== false;
    }

    function isKeyboardCommandsEnabled() {
        return this.options.keyboardCommands !== false;
    }

    function shouldUseFileDraggingExtension() {
        // Since the file-dragging extension replaces the image-dragging extension,
        // we need to check if the user passed an overrided image-dragging extension.
        // If they have, to avoid breaking users, we won't use file-dragging extension.
        return !this.options.extensions['imageDragging'];
    }

    function createContentEditable(textarea) {
        var div = this.options.ownerDocument.createElement('div'),
            now = Date.now(),
            uniqueId = 'medium-editor-' + now,
            atts = textarea.attributes;

        // Some browsers can move pretty fast, since we're using a timestamp
        // to make a unique-id, ensure that the id is actually unique on the page
        while (this.options.ownerDocument.getElementById(uniqueId)) {
            now++;
            uniqueId = 'medium-editor-' + now;
        }

        div.className = textarea.className;
        div.id = uniqueId;
        div.innerHTML = textarea.value;

        textarea.setAttribute('medium-editor-textarea-id', uniqueId);

        // re-create all attributes from the textearea to the new created div
        for (var i = 0, n = atts.length; i < n; i++) {
            // do not re-create existing attributes
            if (!div.hasAttribute(atts[i].nodeName)) {
                div.setAttribute(atts[i].nodeName, atts[i].value);
            }
        }

        // If textarea has a form, listen for reset on the form to clear
        // the content of the created div
        if (textarea.form) {
            this.on(textarea.form, 'reset', function (event) {
                if (!event.defaultPrevented) {
                    this.resetContent(this.options.ownerDocument.getElementById(uniqueId));
                }
            }.bind(this));
        }

        textarea.classList.add('medium-editor-hidden');
        textarea.parentNode.insertBefore(
            div,
            textarea
        );

        return div;
    }

    function initElement(element, editorId) {
        if (!element.getAttribute('data-medium-editor-element')) {
            if (element.nodeName.toLowerCase() === 'textarea') {
                element = createContentEditable.call(this, element);

                // Make sure we only attach to editableInput once for <textarea> elements
                if (!this.instanceHandleEditableInput) {
                    this.instanceHandleEditableInput = handleEditableInput.bind(this);
                    this.subscribe('editableInput', this.instanceHandleEditableInput);
                }
            }

            if (!this.options.disableEditing && !element.getAttribute('data-disable-editing')) {
                element.setAttribute('contentEditable', true);
                element.setAttribute('spellcheck', this.options.spellcheck);
            }

            // Make sure we only attach to editableKeydownEnter once for disable-return options
            if (!this.instanceHandleEditableKeydownEnter) {
                if (element.getAttribute('data-disable-return') || element.getAttribute('data-disable-double-return')) {
                    this.instanceHandleEditableKeydownEnter = handleDisabledEnterKeydown.bind(this);
                    this.subscribe('editableKeydownEnter', this.instanceHandleEditableKeydownEnter);
                }
            }

            // if we're not disabling return, add a handler to help handle cleanup
            // for certain cases when enter is pressed
            if (!this.options.disableReturn && !element.getAttribute('data-disable-return')) {
                this.on(element, 'keyup', handleKeyup.bind(this));
            }

            var elementId = MediumEditor.util.guid();

            element.setAttribute('data-medium-editor-element', true);
            element.classList.add('medium-editor-element');
            element.setAttribute('role', 'textbox');
            element.setAttribute('aria-multiline', true);
            element.setAttribute('data-medium-editor-editor-index', editorId);
            // TODO: Merge data-medium-editor-element and medium-editor-index attributes for 6.0.0
            // medium-editor-index is not named correctly anymore and can be re-purposed to signify
            // whether the element has been initialized or not
            element.setAttribute('medium-editor-index', elementId);
            initialContent[elementId] = element.innerHTML;

            this.events.attachAllEventsToElement(element);
        }

        return element;
    }

    function attachHandlers() {
        // attach to tabs
        this.subscribe('editableKeydownTab', handleTabKeydown.bind(this));

        // Bind keys which can create or destroy a block element: backspace, delete, return
        this.subscribe('editableKeydownDelete', handleBlockDeleteKeydowns.bind(this));
        this.subscribe('editableKeydownEnter', handleBlockDeleteKeydowns.bind(this));

        // Bind double space event
        if (this.options.disableExtraSpaces) {
            this.subscribe('editableKeydownSpace', handleDisableExtraSpaces.bind(this));
        }

        // Make sure we only attach to editableKeydownEnter once for disable-return options
        if (!this.instanceHandleEditableKeydownEnter) {
            // disabling return or double return
            if (this.options.disableReturn || this.options.disableDoubleReturn) {
                this.instanceHandleEditableKeydownEnter = handleDisabledEnterKeydown.bind(this);
                this.subscribe('editableKeydownEnter', this.instanceHandleEditableKeydownEnter);
            }
        }
    }

    function initExtensions() {

        this.extensions = [];

        // Passed in extensions
        Object.keys(this.options.extensions).forEach(function (name) {
            // Always save the toolbar extension for last
            if (name !== 'toolbar' && this.options.extensions[name]) {
                this.extensions.push(initExtension(this.options.extensions[name], name, this));
            }
        }, this);

        // 4 Cases for imageDragging + fileDragging extensons:
        //
        // 1. ImageDragging ON + No Custom Image Dragging Extension:
        //    * Use fileDragging extension (default options)
        // 2. ImageDragging OFF + No Custom Image Dragging Extension:
        //    * Use fileDragging extension w/ images turned off
        // 3. ImageDragging ON + Custom Image Dragging Extension:
        //    * Don't use fileDragging (could interfere with custom image dragging extension)
        // 4. ImageDragging OFF + Custom Image Dragging:
        //    * Don't use fileDragging (could interfere with custom image dragging extension)
        if (shouldUseFileDraggingExtension.call(this)) {
            var opts = this.options.fileDragging;
            if (!opts) {
                opts = {};

                // Image is in the 'allowedTypes' list by default.
                // If imageDragging is off override the 'allowedTypes' list with an empty one
                if (!isImageDraggingEnabled.call(this)) {
                    opts.allowedTypes = [];
                }
            }
            this.addBuiltInExtension('fileDragging', opts);
        }

        // Built-in extensions
        var builtIns = {
            paste: true,
            'anchor-preview': isAnchorPreviewEnabled.call(this),
            autoLink: isAutoLinkEnabled.call(this),
            keyboardCommands: isKeyboardCommandsEnabled.call(this),
            placeholder: isPlaceholderEnabled.call(this)
        };
        Object.keys(builtIns).forEach(function (name) {
            if (builtIns[name]) {
                this.addBuiltInExtension(name);
            }
        }, this);

        // Users can pass in a custom toolbar extension
        // so check for that first and if it's not present
        // just create the default toolbar
        var toolbarExtension = this.options.extensions['toolbar'];
        if (!toolbarExtension && isToolbarEnabled.call(this)) {
            // Backwards compatability
            var toolbarOptions = MediumEditor.util.extend({}, this.options.toolbar, {
                allowMultiParagraphSelection: this.options.allowMultiParagraphSelection // deprecated
            });
            toolbarExtension = new MediumEditor.extensions.toolbar(toolbarOptions);
        }

        // If the toolbar is not disabled, so we actually have an extension
        // initialize it and add it to the extensions array
        if (toolbarExtension) {
            this.extensions.push(initExtension(toolbarExtension, 'toolbar', this));
        }
    }

    function mergeOptions(defaults, options) {
        var deprecatedProperties = [
            ['allowMultiParagraphSelection', 'toolbar.allowMultiParagraphSelection']
        ];
        // warn about using deprecated properties
        if (options) {
            deprecatedProperties.forEach(function (pair) {
                if (options.hasOwnProperty(pair[0]) && options[pair[0]] !== undefined) {
                    MediumEditor.util.deprecated(pair[0], pair[1], 'v6.0.0');
                }
            });
        }

        return MediumEditor.util.defaults({}, options, defaults);
    }

    function execActionInternal(action, opts) {
        /*jslint regexp: true*/
        var appendAction = /^append-(.+)$/gi,
            justifyAction = /justify([A-Za-z]*)$/g, /* Detecting if is justifyCenter|Right|Left */
            match,
            cmdValueArgument;
        /*jslint regexp: false*/

        // Actions starting with 'append-' should attempt to format a block of text ('formatBlock') using a specific
        // type of block element (ie append-blockquote, append-h1, append-pre, etc.)
        match = appendAction.exec(action);
        if (match) {
            return MediumEditor.util.execFormatBlock(this.options.ownerDocument, match[1]);
        }

        if (action === 'fontSize') {
            // TODO: Deprecate support for opts.size in 6.0.0
            if (opts.size) {
                MediumEditor.util.deprecated('.size option for fontSize command', '.value', '6.0.0');
            }
            cmdValueArgument = opts.value || opts.size;
            return this.options.ownerDocument.execCommand('fontSize', false, cmdValueArgument);
        }

        if (action === 'fontName') {
            // TODO: Deprecate support for opts.name in 6.0.0
            if (opts.name) {
                MediumEditor.util.deprecated('.name option for fontName command', '.value', '6.0.0');
            }
            cmdValueArgument = opts.value || opts.name;
            return this.options.ownerDocument.execCommand('fontName', false, cmdValueArgument);
        }

        if (action === 'createLink') {
            return this.createLink(opts);
        }

        if (action === 'image') {
            var src = this.options.contentWindow.getSelection().toString().trim();
            return this.options.ownerDocument.execCommand('insertImage', false, src);
        }

        if (action === 'html') {
            var html = this.options.contentWindow.getSelection().toString().trim();
            return MediumEditor.util.insertHTMLCommand(this.options.ownerDocument, html);
        }

        /* Issue: https://github.com/yabwe/medium-editor/issues/595
         * If the action is to justify the text */
        if (justifyAction.exec(action)) {
            var result = this.options.ownerDocument.execCommand(action, false, null),
                parentNode = MediumEditor.selection.getSelectedParentElement(MediumEditor.selection.getSelectionRange(this.options.ownerDocument));
            if (parentNode) {
                cleanupJustifyDivFragments.call(this, MediumEditor.util.getTopBlockContainer(parentNode));
            }

            return result;
        }

        cmdValueArgument = opts && opts.value;
        return this.options.ownerDocument.execCommand(action, false, cmdValueArgument);
    }

    /* If we've just justified text within a container block
     * Chrome may have removed <br> elements and instead wrapped lines in <div> elements
     * with a text-align property.  If so, we want to fix this
     */
    function cleanupJustifyDivFragments(blockContainer) {
        if (!blockContainer) {
            return;
        }

        var textAlign,
            childDivs = Array.prototype.slice.call(blockContainer.childNodes).filter(function (element) {
                var isDiv = element.nodeName.toLowerCase() === 'div';
                if (isDiv && !textAlign) {
                    textAlign = element.style.textAlign;
                }
                return isDiv;
            });

        /* If we found child <div> elements with text-align style attributes
         * we should fix this by:
         *
         * 1) Unwrapping each <div> which has a text-align style
         * 2) Insert a <br> element after each set of 'unwrapped' div children
         * 3) Set the text-align style of the parent block element
         */
        if (childDivs.length) {
            // Since we're mucking with the HTML, preserve selection
            this.saveSelection();
            childDivs.forEach(function (div) {
                if (div.style.textAlign === textAlign) {
                    var lastChild = div.lastChild;
                    if (lastChild) {
                        // Instead of a div, extract the child elements and add a <br>
                        MediumEditor.util.unwrap(div, this.options.ownerDocument);
                        var br = this.options.ownerDocument.createElement('BR');
                        lastChild.parentNode.insertBefore(br, lastChild.nextSibling);
                    }
                }
            }, this);
            blockContainer.style.textAlign = textAlign;
            // We're done, so restore selection
            this.restoreSelection();
        }
    }

    var initialContent = {};

    MediumEditor.prototype = {
        // NOT DOCUMENTED - exposed for backwards compatability
        init: function (elements, options) {
            this.options = mergeOptions.call(this, this.defaults, options);
            this.origElements = elements;

            if (!this.options.elementsContainer) {
                this.options.elementsContainer = this.options.ownerDocument.body;
            }

            return this.setup();
        },

        setup: function () {
            if (this.isActive) {
                return;
            }

            addToEditors.call(this, this.options.contentWindow);
            this.events = new MediumEditor.Events(this);
            this.elements = [];

            this.addElements(this.origElements);

            if (this.elements.length === 0) {
                return;
            }

            this.isActive = true;

            // Call initialization helpers
            initExtensions.call(this);
            attachHandlers.call(this);
        },

        destroy: function () {
            if (!this.isActive) {
                return;
            }

            this.isActive = false;

            this.extensions.forEach(function (extension) {
                if (typeof extension.destroy === 'function') {
                    extension.destroy();
                }
            }, this);

            this.events.destroy();

            this.elements.forEach(function (element) {
                // Reset elements content, fix for issue where after editor destroyed the red underlines on spelling errors are left
                if (this.options.spellcheck) {
                    element.innerHTML = element.innerHTML;
                }

                // cleanup extra added attributes
                element.removeAttribute('contentEditable');
                element.removeAttribute('spellcheck');
                element.removeAttribute('data-medium-editor-element');
                element.classList.remove('medium-editor-element');
                element.removeAttribute('role');
                element.removeAttribute('aria-multiline');
                element.removeAttribute('medium-editor-index');
                element.removeAttribute('data-medium-editor-editor-index');

                // Remove any elements created for textareas
                if (element.getAttribute('medium-editor-textarea-id')) {
                    cleanupTextareaElement(element);
                }
            }, this);
            this.elements = [];
            this.instanceHandleEditableKeydownEnter = null;
            this.instanceHandleEditableInput = null;

            removeFromEditors.call(this, this.options.contentWindow);
        },

        on: function (target, event, listener, useCapture) {
            this.events.attachDOMEvent(target, event, listener, useCapture);

            return this;
        },

        off: function (target, event, listener, useCapture) {
            this.events.detachDOMEvent(target, event, listener, useCapture);

            return this;
        },

        subscribe: function (event, listener) {
            this.events.attachCustomEvent(event, listener);

            return this;
        },

        unsubscribe: function (event, listener) {
            this.events.detachCustomEvent(event, listener);

            return this;
        },

        trigger: function (name, data, editable) {
            this.events.triggerCustomEvent(name, data, editable);

            return this;
        },

        delay: function (fn) {
            var self = this;
            return setTimeout(function () {
                if (self.isActive) {
                    fn();
                }
            }, this.options.delay);
        },

        serialize: function () {
            var i,
                elementid,
                content = {},
                len = this.elements.length;

            for (i = 0; i < len; i += 1) {
                elementid = (this.elements[i].id !== '') ? this.elements[i].id : 'element-' + i;
                content[elementid] = {
                    value: this.elements[i].innerHTML.trim()
                };
            }
            return content;
        },

        getExtensionByName: function (name) {
            var extension;
            if (this.extensions && this.extensions.length) {
                this.extensions.some(function (ext) {
                    if (ext.name === name) {
                        extension = ext;
                        return true;
                    }
                    return false;
                });
            }
            return extension;
        },

        /**
         * NOT DOCUMENTED - exposed as a helper for other extensions to use
         */
        addBuiltInExtension: function (name, opts) {
            var extension = this.getExtensionByName(name),
                merged;
            if (extension) {
                return extension;
            }

            switch (name) {
                case 'anchor':
                    merged = MediumEditor.util.extend({}, this.options.anchor, opts);
                    extension = new MediumEditor.extensions.anchor(merged);
                    break;
                case 'anchor-preview':
                    extension = new MediumEditor.extensions.anchorPreview(this.options.anchorPreview);
                    break;
                case 'autoLink':
                    extension = new MediumEditor.extensions.autoLink();
                    break;
                case 'fileDragging':
                    extension = new MediumEditor.extensions.fileDragging(opts);
                    break;
                case 'fontname':
                    extension = new MediumEditor.extensions.fontName(this.options.fontName);
                    break;
                case 'fontsize':
                    extension = new MediumEditor.extensions.fontSize(opts);
                    break;
                case 'keyboardCommands':
                    extension = new MediumEditor.extensions.keyboardCommands(this.options.keyboardCommands);
                    break;
                case 'paste':
                    extension = new MediumEditor.extensions.paste(this.options.paste);
                    break;
                case 'placeholder':
                    extension = new MediumEditor.extensions.placeholder(this.options.placeholder);
                    break;
                default:
                    // All of the built-in buttons for MediumEditor are extensions
                    // so check to see if the extension we're creating is a built-in button
                    if (MediumEditor.extensions.button.isBuiltInButton(name)) {
                        if (opts) {
                            merged = MediumEditor.util.defaults({}, opts, MediumEditor.extensions.button.prototype.defaults[name]);
                            extension = new MediumEditor.extensions.button(merged);
                        } else {
                            extension = new MediumEditor.extensions.button(name);
                        }
                    }
            }

            if (extension) {
                this.extensions.push(initExtension(extension, name, this));
            }

            return extension;
        },

        stopSelectionUpdates: function () {
            this.preventSelectionUpdates = true;
        },

        startSelectionUpdates: function () {
            this.preventSelectionUpdates = false;
        },

        checkSelection: function () {
            var toolbar = this.getExtensionByName('toolbar');
            if (toolbar) {
                toolbar.checkState();
            }
            return this;
        },

        // Wrapper around document.queryCommandState for checking whether an action has already
        // been applied to the current selection
        queryCommandState: function (action) {
            var fullAction = /^full-(.+)$/gi,
                match,
                queryState = null;

            // Actions starting with 'full-' need to be modified since this is a medium-editor concept
            match = fullAction.exec(action);
            if (match) {
                action = match[1];
            }

            try {
                queryState = this.options.ownerDocument.queryCommandState(action);
            } catch (exc) {
                queryState = null;
            }

            return queryState;
        },

        execAction: function (action, opts) {
            /*jslint regexp: true*/
            var fullAction = /^full-(.+)$/gi,
                match,
                result;
            /*jslint regexp: false*/

            // Actions starting with 'full-' should be applied to to the entire contents of the editable element
            // (ie full-bold, full-append-pre, etc.)
            match = fullAction.exec(action);
            if (match) {
                // Store the current selection to be restored after applying the action
                this.saveSelection();
                // Select all of the contents before calling the action
                this.selectAllContents();
                result = execActionInternal.call(this, match[1], opts);
                // Restore the previous selection
                this.restoreSelection();
            } else {
                result = execActionInternal.call(this, action, opts);
            }

            // do some DOM clean-up for known browser issues after the action
            if (action === 'insertunorderedlist' || action === 'insertorderedlist') {
                MediumEditor.util.cleanListDOM(this.options.ownerDocument, this.getSelectedParentElement());
            }

            this.checkSelection();
            return result;
        },

        getSelectedParentElement: function (range) {
            if (range === undefined) {
                range = this.options.contentWindow.getSelection().getRangeAt(0);
            }
            return MediumEditor.selection.getSelectedParentElement(range);
        },

        selectAllContents: function () {
            var currNode = MediumEditor.selection.getSelectionElement(this.options.contentWindow);

            if (currNode) {
                // Move to the lowest descendant node that still selects all of the contents
                while (currNode.children.length === 1) {
                    currNode = currNode.children[0];
                }

                this.selectElement(currNode);
            }
        },

        selectElement: function (element) {
            MediumEditor.selection.selectNode(element, this.options.ownerDocument);

            var selElement = MediumEditor.selection.getSelectionElement(this.options.contentWindow);
            if (selElement) {
                this.events.focusElement(selElement);
            }
        },

        getFocusedElement: function () {
            var focused;
            this.elements.some(function (element) {
                // Find the element that has focus
                if (!focused && element.getAttribute('data-medium-focused')) {
                    focused = element;
                }

                // bail if we found the element that had focus
                return !!focused;
            }, this);

            return focused;
        },

        // Export the state of the selection in respect to one of this
        // instance of MediumEditor's elements
        exportSelection: function () {
            var selectionElement = MediumEditor.selection.getSelectionElement(this.options.contentWindow),
                editableElementIndex = this.elements.indexOf(selectionElement),
                selectionState = null;

            if (editableElementIndex >= 0) {
                selectionState = MediumEditor.selection.exportSelection(selectionElement, this.options.ownerDocument);
            }

            if (selectionState !== null && editableElementIndex !== 0) {
                selectionState.editableElementIndex = editableElementIndex;
            }

            return selectionState;
        },

        saveSelection: function () {
            this.selectionState = this.exportSelection();
        },

        // Restore a selection based on a selectionState returned by a call
        // to MediumEditor.exportSelection
        importSelection: function (selectionState, favorLaterSelectionAnchor) {
            if (!selectionState) {
                return;
            }

            var editableElement = this.elements[selectionState.editableElementIndex || 0];
            MediumEditor.selection.importSelection(selectionState, editableElement, this.options.ownerDocument, favorLaterSelectionAnchor);
        },

        restoreSelection: function () {
            this.importSelection(this.selectionState);
        },

        createLink: function (opts) {
            var currentEditor = MediumEditor.selection.getSelectionElement(this.options.contentWindow),
                customEvent = {},
                targetUrl;

            // Make sure the selection is within an element this editor is tracking
            if (this.elements.indexOf(currentEditor) === -1) {
                return;
            }

            try {
                this.events.disableCustomEvent('editableInput');
                // TODO: Deprecate support for opts.url in 6.0.0
                if (opts.url) {
                    MediumEditor.util.deprecated('.url option for createLink', '.value', '6.0.0');
                }
                targetUrl = opts.url || opts.value;
                if (targetUrl && targetUrl.trim().length > 0) {
                    var currentSelection = this.options.contentWindow.getSelection();
                    if (currentSelection) {
                        var currRange = currentSelection.getRangeAt(0),
                            commonAncestorContainer = currRange.commonAncestorContainer,
                            exportedSelection,
                            startContainerParentElement,
                            endContainerParentElement,
                            textNodes;

                        // If the selection is contained within a single text node
                        // and the selection starts at the beginning of the text node,
                        // MSIE still says the startContainer is the parent of the text node.
                        // If the selection is contained within a single text node, we
                        // want to just use the default browser 'createLink', so we need
                        // to account for this case and adjust the commonAncestorContainer accordingly
                        if (currRange.endContainer.nodeType === 3 &&
                            currRange.startContainer.nodeType !== 3 &&
                            currRange.startOffset === 0 &&
                            currRange.startContainer.firstChild === currRange.endContainer) {
                            commonAncestorContainer = currRange.endContainer;
                        }

                        startContainerParentElement = MediumEditor.util.getClosestBlockContainer(currRange.startContainer);
                        endContainerParentElement = MediumEditor.util.getClosestBlockContainer(currRange.endContainer);

                        // If the selection is not contained within a single text node
                        // but the selection is contained within the same block element
                        // we want to make sure we create a single link, and not multiple links
                        // which can happen with the built in browser functionality
                        if (commonAncestorContainer.nodeType !== 3 && commonAncestorContainer.textContent.length !== 0 && startContainerParentElement === endContainerParentElement) {
                            var parentElement = (startContainerParentElement || currentEditor),
                                fragment = this.options.ownerDocument.createDocumentFragment();

                            // since we are going to create a link from an extracted text,
                            // be sure that if we are updating a link, we won't let an empty link behind (see #754)
                            // (Workaroung for Chrome)
                            this.execAction('unlink');

                            exportedSelection = this.exportSelection();
                            fragment.appendChild(parentElement.cloneNode(true));

                            if (currentEditor === parentElement) {
                                // We have to avoid the editor itself being wiped out when it's the only block element,
                                // as our reference inside this.elements gets detached from the page when insertHTML runs.
                                // If we just use [parentElement, 0] and [parentElement, parentElement.childNodes.length]
                                // as the range boundaries, this happens whenever parentElement === currentEditor.
                                // The tradeoff to this workaround is that a orphaned tag can sometimes be left behind at
                                // the end of the editor's content.
                                // In Gecko:
                                // as an empty <strong></strong> if parentElement.lastChild is a <strong> tag.
                                // In WebKit:
                                // an invented <br /> tag at the end in the same situation
                                MediumEditor.selection.select(
                                    this.options.ownerDocument,
                                    parentElement.firstChild,
                                    0,
                                    parentElement.lastChild,
                                    parentElement.lastChild.nodeType === 3 ?
                                    parentElement.lastChild.nodeValue.length : parentElement.lastChild.childNodes.length
                                );
                            } else {
                                MediumEditor.selection.select(
                                    this.options.ownerDocument,
                                    parentElement,
                                    0,
                                    parentElement,
                                    parentElement.childNodes.length
                                );
                            }

                            var modifiedExportedSelection = this.exportSelection();

                            textNodes = MediumEditor.util.findOrCreateMatchingTextNodes(
                                this.options.ownerDocument,
                                fragment,
                                {
                                    start: exportedSelection.start - modifiedExportedSelection.start,
                                    end: exportedSelection.end - modifiedExportedSelection.start,
                                    editableElementIndex: exportedSelection.editableElementIndex
                                }
                            );
                            // If textNodes are not present, when changing link on images
                            // ex: <a><img src="http://image.test.com"></a>, change fragment to currRange.startContainer
                            // and set textNodes array to [imageElement, imageElement]
                            if (textNodes.length === 0) {
                                fragment = this.options.ownerDocument.createDocumentFragment();
                                fragment.appendChild(commonAncestorContainer.cloneNode(true));
                                textNodes = [fragment.firstChild.firstChild, fragment.firstChild.lastChild];
                            }

                            // Creates the link in the document fragment
                            MediumEditor.util.createLink(this.options.ownerDocument, textNodes, targetUrl.trim());

                            // Chrome trims the leading whitespaces when inserting HTML, which messes up restoring the selection.
                            var leadingWhitespacesCount = (fragment.firstChild.innerHTML.match(/^\s+/) || [''])[0].length;

                            // Now move the created link back into the original document in a way to preserve undo/redo history
                            MediumEditor.util.insertHTMLCommand(this.options.ownerDocument, fragment.firstChild.innerHTML.replace(/^\s+/, ''));
                            exportedSelection.start -= leadingWhitespacesCount;
                            exportedSelection.end -= leadingWhitespacesCount;

                            this.importSelection(exportedSelection);
                        } else {
                            this.options.ownerDocument.execCommand('createLink', false, targetUrl);
                        }

                        if (this.options.targetBlank || opts.target === '_blank') {
                            MediumEditor.util.setTargetBlank(MediumEditor.selection.getSelectionStart(this.options.ownerDocument), targetUrl);
                        } else {
                            MediumEditor.util.removeTargetBlank(MediumEditor.selection.getSelectionStart(this.options.ownerDocument), targetUrl);
                        }

                        if (opts.buttonClass) {
                            MediumEditor.util.addClassToAnchors(MediumEditor.selection.getSelectionStart(this.options.ownerDocument), opts.buttonClass);
                        }
                    }
                }
                // Fire input event for backwards compatibility if anyone was listening directly to the DOM input event
                if (this.options.targetBlank || opts.target === '_blank' || opts.buttonClass) {
                    customEvent = this.options.ownerDocument.createEvent('HTMLEvents');
                    customEvent.initEvent('input', true, true, this.options.contentWindow);
                    for (var i = 0, len = this.elements.length; i < len; i += 1) {
                        this.elements[i].dispatchEvent(customEvent);
                    }
                }
            } finally {
                this.events.enableCustomEvent('editableInput');
            }
            // Fire our custom editableInput event
            this.events.triggerCustomEvent('editableInput', customEvent, currentEditor);
        },

        cleanPaste: function (text) {
            this.getExtensionByName('paste').cleanPaste(text);
        },

        pasteHTML: function (html, options) {
            this.getExtensionByName('paste').pasteHTML(html, options);
        },

        setContent: function (html, index) {
            index = index || 0;

            if (this.elements[index]) {
                var target = this.elements[index];
                target.innerHTML = html;
                this.checkContentChanged(target);
            }
        },

        getContent: function (index) {
            index = index || 0;

            if (this.elements[index]) {
                return this.elements[index].innerHTML.trim();
            }
            return null;
        },

        checkContentChanged: function (editable) {
            editable = editable || MediumEditor.selection.getSelectionElement(this.options.contentWindow);
            this.events.updateInput(editable, { target: editable, currentTarget: editable });
        },

        resetContent: function (element) {
            // For all elements that exist in the this.elements array, we can assume:
            // - Its initial content has been set in the initialContent object
            // - It has a medium-editor-index attribute which is the key value in the initialContent object

            if (element) {
                var index = this.elements.indexOf(element);
                if (index !== -1) {
                    this.setContent(initialContent[element.getAttribute('medium-editor-index')], index);
                }
                return;
            }

            this.elements.forEach(function (el, idx) {
                this.setContent(initialContent[el.getAttribute('medium-editor-index')], idx);
            }, this);
        },

        addElements: function (selector) {
            // Convert elements into an array
            var elements = createElementsArray(selector, this.options.ownerDocument, true);

            // Do we have elements to add now?
            if (elements.length === 0) {
                return false;
            }

            elements.forEach(function (element) {
                // Initialize all new elements (we check that in those functions don't worry)
                element = initElement.call(this, element, this.id);

                // Add new elements to our internal elements array
                this.elements.push(element);

                // Trigger event so extensions can know when an element has been added
                this.trigger('addElement', { target: element, currentTarget: element }, element);
            }, this);
        },

        removeElements: function (selector) {
            // Convert elements into an array
            var elements = createElementsArray(selector, this.options.ownerDocument),
                toRemove = elements.map(function (el) {
                    // For textareas, make sure we're looking at the editor div and not the textarea itself
                    if (el.getAttribute('medium-editor-textarea-id') && el.parentNode) {
                        return el.parentNode.querySelector('div[medium-editor-textarea-id="' + el.getAttribute('medium-editor-textarea-id') + '"]');
                    } else {
                        return el;
                    }
                });

            this.elements = this.elements.filter(function (element) {
                // If this is an element we want to remove
                if (toRemove.indexOf(element) !== -1) {
                    this.events.cleanupElement(element);
                    if (element.getAttribute('medium-editor-textarea-id')) {
                        cleanupTextareaElement(element);
                    }
                    // Trigger event so extensions can clean-up elements that are being removed
                    this.trigger('removeElement', { target: element, currentTarget: element }, element);
                    return false;
                }
                return true;
            }, this);
        }
    };

    MediumEditor.getEditorFromElement = function (element) {
        var index = element.getAttribute('data-medium-editor-editor-index'),
            win = element && element.ownerDocument && (element.ownerDocument.defaultView || element.ownerDocument.parentWindow);
        if (win && win._mediumEditors && win._mediumEditors[index]) {
            return win._mediumEditors[index];
        }
        return null;
    };
}());

(function () {
    // summary: The default options hash used by the Editor

    MediumEditor.prototype.defaults = {
        activeButtonClass: 'medium-editor-button-active',
        buttonLabels: false,
        delay: 0,
        disableReturn: false,
        disableDoubleReturn: false,
        disableExtraSpaces: false,
        disableEditing: false,
        autoLink: false,
        elementsContainer: false,
        contentWindow: window,
        ownerDocument: document,
        targetBlank: false,
        extensions: {},
        spellcheck: true
    };
})();

MediumEditor.parseVersionString = function (release) {
    var split = release.split('-'),
        version = split[0].split('.'),
        preRelease = (split.length > 1) ? split[1] : '';
    return {
        major: parseInt(version[0], 10),
        minor: parseInt(version[1], 10),
        revision: parseInt(version[2], 10),
        preRelease: preRelease,
        toString: function () {
            return [version[0], version[1], version[2]].join('.') + (preRelease ? '-' + preRelease : '');
        }
    };
};

MediumEditor.version = MediumEditor.parseVersionString.call(this, ({
    // grunt-bump looks for this:
    'version': '5.23.3'
}).version);

    return MediumEditor;
}()));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(174)))

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var toolbar_1 = __webpack_require__(384);
/**
 * @ngdoc method
 * @name changeEditorState
 * @param {Object} editorState
 * @param {force} force update
 * @return {String} action
 * @description Creates the change editor action
 */
function changeEditorState(editorState, force, skipOnChange) {
    if (force === void 0) { force = false; }
    if (skipOnChange === void 0) { skipOnChange = false; }
    return {
        type: 'EDITOR_CHANGE_STATE',
        payload: { editorState: editorState, force: force, skipOnChange: skipOnChange },
    };
}
exports.changeEditorState = changeEditorState;
/**
 * @ngdoc method
 * @name forceUpdate
 * @return {String} action
 * @description Causes the editor to force update. This is used by the spellchecker
 * to cause the editor to re-render its decorators based on new information retrieved
 * in dictionaries. Use of this method should be avoided.
 */
function forceUpdate() {
    return { type: 'EDITOR_FORCE_UPDATE' };
}
exports.forceUpdate = forceUpdate;
/**
 * @ngdoc method
 * @name setAbbreviations
 * @return {Object} abbreviations
 * @description set the abbreviation dictionary
 */
function setAbbreviations(abbreviations) {
    return {
        type: 'EDITOR_SET_ABBREVIATIONS',
        payload: abbreviations,
    };
}
exports.setAbbreviations = setAbbreviations;
/**
 * @ngdoc method
 * @name handleEditorTab
 * @param {Object} e on tab event
 * @return {String} action
 * @description Creates the change editor action
 */
function handleEditorTab(e) {
    return {
        type: 'EDITOR_TAB',
        payload: e,
    };
}
exports.handleEditorTab = handleEditorTab;
/**
 * @ngdoc method
 * @name dragDrop
 * @param {DataTransfer} transfer
 * @return {String} mediaType
 * @return {String} blockKey
 * @description Creates the editor drop action.
 */
function dragDrop(transfer, mediaType, blockKey) {
    if (blockKey === void 0) { blockKey = null; }
    if (mediaType === 'Files') {
        return toolbar_1.insertMedia(transfer.files);
    }
    return {
        type: 'EDITOR_DRAG_DROP',
        payload: { data: transfer.getData(mediaType), blockKey: blockKey },
    };
}
exports.dragDrop = dragDrop;
/**
 * @ngdoc method
 * @name setLocked
 * @param {Event} v
 * @return {String} action
 * @description Dispatches the action to set the main editor as locked. The main editor
 * is locked when other atomic blocks are edited that manage their own editor, such
 * as tables or image descriptions.
 */
function setLocked(v) {
    return {
        type: 'EDITOR_SET_LOCKED',
        payload: v,
    };
}
exports.setLocked = setLocked;
/**
 * @ngdoc method
 * @name setReadOnly
 * @param {Event} v
 * @return {String} action
 * @description Dispatches the action to set the main editor as read-only. This is
 * mainly used externally to allow bi-directional binding of the readOnly attribute
 * on the Angular directive. Not used in React.
 */
function setReadOnly(v) {
    return {
        type: 'EDITOR_SET_READONLY',
        payload: v,
    };
}
exports.setReadOnly = setReadOnly;
/**
 * @ngdoc method
 * @name setActiveCell
 * @description Sets the active table and cell inside the editor.
 */
function setActiveCell(i, j, key, currentStyle, selection) {
    return {
        type: 'EDITOR_SET_CELL',
        payload: { i: i, j: j, key: key, currentStyle: currentStyle, selection: selection },
    };
}
exports.setActiveCell = setActiveCell;
/**
 * @ngdoc method
 * @name changeImageCaption
 * @param {string} entityKey
 * @param {string} newCaption
 * @param {string} field
 * @description Change the image caption contained in the given entity key.
 * @returns {Object}
 */
function changeImageCaption(entityKey, newCaption, field) {
    return {
        type: 'EDITOR_CHANGE_IMAGE_CAPTION',
        payload: { entityKey: entityKey, newCaption: newCaption, field: field },
    };
}
exports.changeImageCaption = changeImageCaption;
function mergeEntityDataByKey(blockKey, entityKey, valuesToMerge) {
    return {
        type: 'MERGE_ENTITY_DATA_BY_KEY',
        payload: { blockKey: blockKey, entityKey: entityKey, valuesToMerge: valuesToMerge },
    };
}
exports.mergeEntityDataByKey = mergeEntityDataByKey;
/**
 * @ngdoc method
 * @name setHtmlFromTansa
 * @param {string} html
 * @param {string} simpleReplace
 * @description For every block from editor content merge the changes received from Tansa.
 * If simpleReplace is true on merge will not try to preserve inline style and entity
 * @returns {Object}
 */
function setHtmlFromTansa(html, simpleReplace) {
    return {
        type: 'EDITOR_SET_HTML_FROM_TANSA',
        payload: { html: html, simpleReplace: simpleReplace },
    };
}
exports.setHtmlFromTansa = setHtmlFromTansa;
/**
 * Move one block after another
 *
 * @param {String} block
 * @param {String} dest
 * @return {Object}
 */
function moveBlock(block, dest, insertionMode) {
    return {
        type: 'EDITOR_MOVE_BLOCK',
        payload: { block: block, dest: dest, insertionMode: insertionMode },
    };
}
exports.moveBlock = moveBlock;
/**
 * @ngdoc method
 * @name embed
 * @param {Object|string} oEmbed code, HTML string.
 * @return {Object}
 * @description Dispatches the action to use the given oEmbed data for media embedding.
 */
function embed(code, targetBlockKey) {
    if (targetBlockKey === void 0) { targetBlockKey = null; }
    return {
        type: 'EDITOR_APPLY_EMBED',
        payload: {
            code: code,
            targetBlockKey: targetBlockKey,
        },
    };
}
exports.embed = embed;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var table_1 = __webpack_require__(112);
var utils_1 = __webpack_require__(3);
/**
 * @name clearHighlights
 * @param {ContentState} c The content to clear the highlights in.
 * @param {EditorState=} es If provided, the new content state is pushed into this editor state.
 * @returns {Object} Returns an object that contains two keys, the cleared content state and
 * the new editor state (if it was provided).
 * @description Clears all the highlights in the given content. If an editor state is provided,
 * it also returns it updated.
 */
exports.clearHighlights = function (c, es) {
    if (es === void 0) { es = null; }
    var content = c;
    var editorState = es;
    var changedContent = false;
    var filterFn = function (d) { return d.hasStyle('HIGHLIGHT') || d.hasStyle('HIGHLIGHT_STRONG'); };
    content = exports.forEachBlock(content, function (blockIndex, block, _content) {
        var newContent = _content;
        block.findStyleRanges(filterFn, function (start, end) {
            var selection = createSelection(block.getKey(), start, end);
            newContent = draft_js_1.Modifier.removeInlineStyle(newContent, selection, 'HIGHLIGHT');
            newContent = draft_js_1.Modifier.removeInlineStyle(newContent, selection, 'HIGHLIGHT_STRONG');
            changedContent = true;
        });
        return newContent;
    });
    if (changedContent && editorState) {
        editorState = exports.quietPush(editorState, content);
    }
    return { content: content, editorState: editorState };
};
/**
 * @name forEachBlock
 * @param {ContentState} content The content to interate over.
 * @param {function} cb The callback to call for each block. Receives index, block and content.
 * @returns {ContentState} returns  the new content state.
 * @description Iterates over blocks in  conntent and calls the given callback
 * for each block, passing it current index, block and content.
 */
exports.forEachBlock = function (content, cb) {
    var newContent = content;
    content.getBlocksAsArray().forEach(function (block) {
        var _a;
        var entityKey = block.getEntityAt(0);
        var entity = entityKey != null ? content.getEntity(entityKey) : null;
        var blockIndex = -1;
        if (entity != null && entity.getType() === 'TABLE') {
            (_a = forEachBlockInTable(newContent, block, blockIndex, cb), newContent = _a.newContent, blockIndex = _a.blockIndex);
        }
        else {
            newContent = cb(++blockIndex, block, newContent);
        }
    });
    return newContent;
};
/**
 * @name forEachBlockInTable
 * @param {ContentState} content The content to iterate  over.
 * @param {String} the block that contains the table.
 * @param {number} current marching index
 * @param {function} cb The callback to call for each block. Receives index, block and content.
 * @returns {ContentState} returns  the new content state.
 * @description Iterates the table content and calls the given callback
 * for each block, passing it current index, block and content.
 */
var forEachBlockInTable = function (content, block, _blockIndex, cb) {
    var key = block.getKey();
    var selection = createSelection(key, 0, 1);
    var data = table_1.getData(content, key);
    var newContent = content;
    var blockIndex = _blockIndex;
    for (var i = 0; i < (data.numRows || 0); i++) {
        var _loop_1 = function (j) {
            var cellEditorState = table_1.getCell(data, i, j, null, null);
            var cellContent = cellEditorState.getCurrentContent();
            cellContent.getBlocksAsArray().forEach(function (_block) {
                cellContent = cb(++blockIndex, _block, cellContent);
            });
            cellEditorState = draft_js_1.EditorState.push(cellEditorState, cellContent, 'insert-characters');
            table_1.setCell(data, i, j, cellEditorState);
        };
        for (var j = 0; j < (data.numCols || 0); j++) {
            _loop_1(j);
        }
    }
    newContent = table_1.setDataForContent(newContent, selection, block, data);
    return { newContent: newContent, blockIndex: blockIndex };
};
/**
 * @name forEachMatch
 * @param {ContentState} content The content to search in.
 * @param {string} pattern The pattern to search by.
 * @param {boolean} caseSensitive Whether the search should be case sensitive or not.
 * @param {function} cb The callback to call for each occurrence. Receives index, selection, block and content.
 * @returns {ContentState} returns  the new content state.
 * @description Searches the content for the given pattern and calls the given callback
 * for each occurrence, passing it current content, index of the match and its SelectionState.
 */
exports.forEachMatch = function (content, pattern, caseSensitive, cb) {
    if (!pattern) {
        return false;
    }
    var matchIndex = -1;
    var newContent = content;
    content.getBlocksAsArray().forEach(function (block) {
        var _a, _b;
        var entityKey = block.getEntityAt(0);
        var entity = entityKey != null ? content.getEntity(entityKey) : null;
        if (entity != null && entity.getType() === 'TABLE') {
            (_a = forEachMatchInTable(newContent, block, pattern, caseSensitive, matchIndex, cb), newContent = _a.newContent, matchIndex = _a.matchIndex);
        }
        else {
            (_b = forEachMatchInParagraph(newContent, block, pattern, caseSensitive, matchIndex, cb), newContent = _b.newContent, matchIndex = _b.matchIndex);
        }
    });
    return newContent;
};
/**
 * @name forEachMatchInParagraph
 * @param {ContentState} content The content to search in.
 * @param {Block} the block to search in.
 * @param {string} pattern The pattern to search by.
 * @param {boolean} caseSensitive Whether the search should be case sensitive or not.
 * @param {number} current marching index
 * @param {function} cb The callback to call for each occurrence. Receives index, selection, block and content.
 * @returns {ContentState} returns  the new content state.
 * @description Searches the block for the given pattern and calls the given callback
 * for each occurrence, passing it the index of the match and its SelectionState.
 */
var forEachMatchInParagraph = function (content, block, pattern, caseSensitive, _matchIndex, cb) {
    var re = getRegExp({ pattern: pattern, caseSensitive: caseSensitive });
    var key = block.getKey();
    var text = block.getText();
    var newContent = content;
    var matchIndex = _matchIndex;
    var match;
    // eslint-disable-next-line no-cond-assign
    while (match = re.exec(text)) {
        newContent = cb(++matchIndex, createSelection(key, match.index, match.index + match[0].length), block, newContent, match[0]);
    }
    return { newContent: newContent, matchIndex: matchIndex };
};
/**
 * @name forEachMatchInTable
 * @param {ContentState} content The parent content to search in.
 * @param {Block} the block that contains the table.
 * @param {string} pattern The pattern to search by.
 * @param {boolean} caseSensitive Whether the search should be case sensitive or not.
 * @param {number} current marching index
 * @param {function} cb The callback to call for each occurrence. Receives index, selection, block and content.
 * @returns {ContentState} returns  the new content state.
 * @description Searches the table content for the given pattern and calls the given callback
 * for each occurrence, passing it the index of the match and its SelectionState.
 */
var forEachMatchInTable = function (content, block, pattern, caseSensitive, _matchIndex, cb) {
    var key = block.getKey();
    var selection = createSelection(key, 0, 1);
    var data = table_1.getData(content, key);
    var newContent = content;
    var matchIndex = _matchIndex;
    for (var i = 0; i < (data.numRows || 0); i++) {
        var _loop_2 = function (j) {
            var cellEditorState = table_1.getCell(data, i, j, null, null);
            var cellContent = cellEditorState.getCurrentContent();
            cellContent.getBlocksAsArray().forEach(function (_block) {
                var _a;
                (_a = forEachMatchInParagraph(cellContent, _block, pattern, caseSensitive, matchIndex, cb), cellContent = _a.newContent, matchIndex = _a.matchIndex);
            });
            cellEditorState = draft_js_1.EditorState.push(cellEditorState, cellContent, 'insert-characters');
            table_1.setCell(data, i, j, cellEditorState);
        };
        for (var j = 0; j < (data.numCols || 0); j++) {
            _loop_2(j);
        }
    }
    newContent = table_1.setDataForContent(newContent, selection, block, data);
    return { newContent: newContent, matchIndex: matchIndex };
};
// create reg exp from pattern if neede
var getRegExp = function (_a) {
    var pattern = _a.pattern, caseSensitive = _a.caseSensitive;
    return typeof pattern === 'string' ? new RegExp(utils_1.escapeRegExp(pattern), 'g' + (caseSensitive ? '' : 'i')) : pattern;
};
/**
 * @name quietPush
 * @param {EditorState} editorState
 * @param {ContentState} content
 * @description Silently pushes the new content state into the given editor state, without
 * affecting the undo/redo stack.
 */
exports.quietPush = function (editorState, content, changeType) {
    if (changeType === void 0) { changeType = 'insert-characters'; }
    var newState;
    newState = draft_js_1.EditorState.set(editorState, { allowUndo: false });
    newState = draft_js_1.EditorState.push(newState, content, changeType);
    newState = draft_js_1.EditorState.set(newState, { allowUndo: true });
    return newState;
};
/**
 * Creates a new selection state, based on the given block key, having the specified
 * anchor and offset.
 */
var createSelection = function (key, start, end) {
    return draft_js_1.SelectionState.createEmpty(key).merge({
        anchorOffset: start,
        focusOffset: end,
    });
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(108);
var CharacterMetadata = __webpack_require__(40);
var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var DraftEntity = __webpack_require__(130);
var DraftFeatureFlags = __webpack_require__(65);
var Immutable = __webpack_require__(19);
var SelectionState = __webpack_require__(85);

var generateRandomKey = __webpack_require__(60);
var sanitizeDraftText = __webpack_require__(178);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var ContentStateRecord = Record(defaultRecord);

var ContentState = function (_ContentStateRecord) {
  _inherits(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */



var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var invariant = __webpack_require__(17);

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

module.exports = UnicodeBidiDirection;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * @format
 * 
 */



var _require = __webpack_require__(19),
    Map = _require.Map;

var React = __webpack_require__(0);

var cx = __webpack_require__(86);

var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */



/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getStyleProperty = __webpack_require__(805);

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

module.exports = Style;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var getDocumentScrollElement = __webpack_require__(810);
var getUnboundedScrollPosition = __webpack_require__(811);

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @format
 * 
 */



var getSelectionOffsetKeyForNode = __webpack_require__(398);

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @format
 * 
 */



var UserAgent = __webpack_require__(50);

var isOSX = UserAgent.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

module.exports = KeyBindingUtil;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(51);
/**
 * @ngdoc method
 * @name orderedMapGetRange
 * @returns {OrderedMap}
 */
function orderedMapGetRange(orderedMap, fromKey, toKey) {
    var firstItemFound = false;
    var lastItemFound = false;
    return orderedMap.filter(function (item) {
        var itemKey = item.getKey();
        if (itemKey === fromKey) {
            firstItemFound = true;
        }
        if (itemKey === toKey) {
            lastItemFound = true;
        }
        if (itemKey === fromKey || itemKey === toKey) {
            return true;
        }
        return firstItemFound && !lastItemFound;
    });
}
/**
 * @ngdoc method
 * @name getDraftCharacterListForSelection
 * @returns {List<CharacterMetadata>}
 */
function getDraftCharacterListForSelection(editorState, selection) {
    // including all blocks
    if (selection.isCollapsed()) {
        return immutable_1.List();
    }
    var selectionStartKey = selection.getStartKey();
    var selectionEndKey = selection.getEndKey();
    var selectedBlocks = orderedMapGetRange(editorState.getCurrentContent().getBlockMap(), selectionStartKey, selectionEndKey);
    var selectedCharacters = selectedBlocks
        .map(function (block) {
        var blockKey = block.getKey();
        if (selectionStartKey === selectionEndKey && selectionStartKey === blockKey) {
            return block.getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset());
        }
        else if (blockKey === selectionStartKey) {
            return block.getCharacterList().slice(selection.getStartOffset(), block.getLength());
        }
        else if (blockKey === selectionEndKey) {
            return block.getCharacterList().slice(0, selection.getEndOffset());
        }
        else {
            return block.getCharacterList();
        }
    })
        .reduce(function (acc, item) { return acc.concat(item); });
    return selectedCharacters;
}
exports.getDraftCharacterListForSelection = getDraftCharacterListForSelection;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an array of all `ContentBlock` instances within two block keys
 *
 * @param  {object} contentState A draft.js `ContentState` instance
 * @param  {string} anchorKey    The block key to start searching from
 * @param  {string} focusKey     The block key until which to search
 *
 * @return {array} An array containing the found content blocks
 */
/* harmony default export */ __webpack_exports__["a"] = (function (contentState, anchorKey, focusKey) {
  var isSameBlock = anchorKey === focusKey;
  var startingBlock = contentState.getBlockForKey(anchorKey);

  if (!startingBlock) {
    return [];
  }

  var selectedBlocks = [startingBlock];

  if (!isSameBlock) {
    var blockKey = anchorKey;

    while (blockKey !== focusKey) {
      var nextBlock = contentState.getBlockAfter(blockKey);

      if (!nextBlock) {
        selectedBlocks = [];
        break;
      }

      selectedBlocks.push(nextBlock);
      blockKey = nextBlock.getKey();
    }
  }

  return selectedBlocks;
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(896);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var Editor3Component_1 = __webpack_require__(194);
var MultipleHighlights_1 = __webpack_require__(1345);
var actions = __importStar(__webpack_require__(24));
var Editor3Base = /** @class */ (function (_super) {
    __extends(Editor3Base, _super);
    function Editor3Base() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Editor3Base.getDecorator = function (disableSpellchecker) {
        return Editor3Component_1.Editor3Component.getDecorator(disableSpellchecker);
    };
    Editor3Base.prototype.render = function () {
        return (react_1.default.createElement(MultipleHighlights_1.MultipleHighlights, __assign({}, this.props),
            react_1.default.createElement(Editor3Component_1.Editor3Component, null)));
    };
    return Editor3Base;
}(react_1.default.Component));
exports.Editor3Base = Editor3Base;
Editor3Base.propTypes = Editor3Component_1.Editor3Component.propTypes = {
    onChange: prop_types_1.default.func,
};
var mapStateToProps = function (state) { return ({
    readOnly: state.readOnly,
    showToolbar: state.showToolbar,
    editorState: state.editorState,
    locked: state.locked,
    editorFormat: state.editorFormat,
    tabindex: state.tabindex,
    suggestingMode: state.suggestingMode,
    invisibles: state.invisibles,
    svc: state.svc,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    onChange: function (editorState) { return dispatch(actions.changeEditorState(editorState)); },
    onTab: function (e) { return dispatch(actions.handleEditorTab(e)); },
    dragDrop: function (transfer, mediaType) { return dispatch(actions.dragDrop(transfer, mediaType)); },
    unlock: function () { return dispatch(actions.setLocked(false)); },
    dispatch: function (x) { return dispatch(x); },
    onCreateAddSuggestion: function (chars) { return dispatch(actions.createAddSuggestion(chars)); },
    onCreateDeleteSuggestion: function (action) { return dispatch(actions.createDeleteSuggestion(action)); },
    onPasteFromSuggestingMode: function (content) { return dispatch(actions.onPasteFromSuggestingMode(content)); },
    onCreateSplitParagraphSuggestion: function () { return dispatch(actions.createSplitParagraphSuggestion()); },
    onCreateChangeStyleSuggestion: function (type, active) { return dispatch(actions.createChangeStyleSuggestion(type, active)); },
}); };
exports.Editor3 = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Editor3Base);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_dom_1 = __importDefault(__webpack_require__(15));
var draft_js_1 = __webpack_require__(16);
var draft_js_2 = __webpack_require__(16);
var immutable_1 = __webpack_require__(51);
var toolbar_1 = __importDefault(__webpack_require__(907));
var spellchecker_1 = __webpack_require__(1328);
var links_1 = __webpack_require__(195);
var blockRenderer_1 = __webpack_require__(1333);
var customStyleMap_1 = __webpack_require__(545);
var classnames_1 = __importDefault(__webpack_require__(4));
var handlePastedText_1 = __webpack_require__(1338);
var entityUtils_1 = __webpack_require__(79);
var HighlightsPopup_1 = __webpack_require__(1340);
var UnstyledBlock_1 = __importDefault(__webpack_require__(1342));
var UnstyledWrapper_1 = __importDefault(__webpack_require__(1343));
var handleBeforeInputHighlights_1 = __webpack_require__(1344);
var Suggestions = __importStar(__webpack_require__(133));
var author_1 = __webpack_require__(134);
var VALID_MEDIA_TYPES = [
    'application/superdesk.item.picture',
    'application/superdesk.item.graphic',
    'application/superdesk.item.video',
    'application/superdesk.item.audio',
    'text/uri-list',
    'text/html',
    'Files',
];
exports.EDITOR_GLOBAL_REFS = 'editor3-refs';
/**
 * Get valid media type from event dataTransfer types
 *
 * Prefer superdesk media types
 *
 * @param {Event} event
 * @return {String}
 */
function getValidMediaType(event) {
    return VALID_MEDIA_TYPES.find(function (mediaType) { return event.dataTransfer.types.indexOf(mediaType) !== -1; });
}
exports.getValidMediaType = getValidMediaType;
/**
    * @ngdoc method
    * @name Editor3#canDropMedia
    * @param {Object} e Event
    * @param {Array} editorConfig
    * @returns {Boolean} Returns true if the item is permitted.
    * @description Check if the editor accept images and if current item is valid media.
*/
function canDropMedia(e, editorConfig) {
    var editorFormat = editorConfig.editorFormat, readOnly = editorConfig.readOnly, singleLine = editorConfig.singleLine;
    var isValidMedia = !!getValidMediaType(e.originalEvent);
    var supportsMedia = !readOnly && !singleLine && editorFormat.indexOf('media') !== -1;
    return supportsMedia && isValidMedia;
}
exports.canDropMedia = canDropMedia;
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name Editor3
 * @param {Boolean} readOnly if true the editor is read only
 * @param {Boolean} showToolbar if true the editor will show the toolbar
 * @param {editorState} the current state of draftjs editor
 * @param {Function} onChange the callback executed when the editor value is changed
 * @param {Function} onTab the callback for onTab event
 * @description Editor3 is a draft.js based editor that support customizable
 *  formatting, spellchecker and media files.
 */
var Editor3Component = /** @class */ (function (_super) {
    __extends(Editor3Component, _super);
    function Editor3Component(props) {
        var _this = _super.call(this, props) || this;
        _this.editorKey = null;
        _this.editorNode = undefined;
        _this.focus = _this.focus.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.handleKeyCommand = _this.handleKeyCommand.bind(_this);
        _this.handleBeforeInput = _this.handleBeforeInput.bind(_this);
        _this.keyBindingFn = _this.keyBindingFn.bind(_this);
        return _this;
    }
    Editor3Component.getDecorator = function (disableSpellchecker) {
        var decorators = [
            links_1.LinkDecorator,
        ];
        if (!disableSpellchecker) {
            decorators.push(spellchecker_1.SpellcheckerDecorator);
        }
        return new draft_js_1.CompositeDecorator(decorators);
    };
    /**
     * @ngdoc method
     * @name Editor3#focus
     * @description Handle the editor get focus event
     */
    Editor3Component.prototype.focus = function () {
        this.props.unlock();
    };
    /**
     * @ngdoc method
     * @name Editor3#onDragOver
     * @returns {Boolean} Returns true if the item is not permitted.
     * @description Checks if the dragged over item is not allowed.
     */
    Editor3Component.prototype.onDragOver = function (e) {
        return !canDropMedia(e, this.props);
    };
    Editor3Component.prototype.keyBindingFn = function (e) {
        var keyCode = e.keyCode, shiftKey = e.shiftKey;
        if (keyCode === 13 && shiftKey) {
            return 'soft-newline';
        }
        // ctrl + X
        if (keyCode === 88 && draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            var editorState = this.props.editorState;
            var selection = editorState.getSelection();
            if (!selection.isCollapsed()) {
                document.execCommand('copy'); // add selected text to clipboard
                return 'delete';
            }
        }
        if (draft_js_1.KeyBindingUtil.hasCommandModifier(e)) {
            var editorFormat = this.props.editorFormat;
            var notAllowBold = keyCode === 66 && editorFormat.indexOf('bold') === -1;
            var notAllowItalic = keyCode === 73 && editorFormat.indexOf('italic') === -1;
            var notAllowUnderline = keyCode === 85 && editorFormat.indexOf('underline') === -1;
            if (notAllowBold || notAllowItalic || notAllowUnderline) {
                e.preventDefault();
                return '';
            }
        }
        return draft_js_1.getDefaultKeyBinding(e);
    };
    /**
     * @ngdoc method
     * @name Editor3#handleKeyCommand
     * @description Handles key commands in the editor.
     */
    Editor3Component.prototype.handleKeyCommand = function (command) {
        var author = author_1.getCurrentAuthor();
        var _a = this.props, editorState = _a.editorState, onChange = _a.onChange, singleLine = _a.singleLine, suggestingMode = _a.suggestingMode;
        var _b = this.props, onCreateSplitParagraphSuggestion = _b.onCreateSplitParagraphSuggestion, onCreateDeleteSuggestion = _b.onCreateDeleteSuggestion, onCreateChangeStyleSuggestion = _b.onCreateChangeStyleSuggestion;
        if (singleLine && command === 'split-block') {
            return 'handled';
        }
        var newState;
        switch (command) {
            case 'bold':
            case 'italic':
            case 'underline':
                if (suggestingMode) {
                    // prevent to change other user suggestion
                    if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)
                        && !Suggestions.allowEditSuggestionOnRight(editorState, author)) {
                        return 'handled';
                    }
                    var style = command.toUpperCase();
                    var inlineStyles = editorState.getCurrentInlineStyle();
                    var active = inlineStyles.has(style);
                    onCreateChangeStyleSuggestion(style, active);
                    return 'handled';
                }
                newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
                break;
            case 'soft-newline':
                newState = draft_js_1.RichUtils.insertSoftNewline(editorState);
                break;
            case 'split-block':
                if (suggestingMode) {
                    // prevent to change other user suggestion
                    if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)
                        && !Suggestions.allowEditSuggestionOnRight(editorState, author)) {
                        return 'handled';
                    }
                    onCreateSplitParagraphSuggestion();
                    return 'handled';
                }
                newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
                break;
            case 'delete':
                if (suggestingMode) {
                    // prevent to change other user suggestion that is after current position
                    if (!Suggestions.allowEditSuggestionOnRight(editorState, author)) {
                        return 'handled';
                    }
                    onCreateDeleteSuggestion('delete');
                    return 'handled';
                }
                newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
                break;
            case 'secondary-paste': // this is blocking redo on non-windows systems, should be osx specific
                newState = draft_js_1.EditorState.redo(editorState);
                break;
            case 'backspace': {
                if (suggestingMode) {
                    // prevent to change other user suggestion that is before current position
                    if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)) {
                        return 'handled';
                    }
                    onCreateDeleteSuggestion('backspace');
                    return 'handled';
                }
                // This is a workaround for un/ordered-list-item, when it is deleted an empty
                // ordered list(just 1. is shown) it will delete the previous block if it exists
                // (for example a table and then imediately after the ordered list)
                var selection = editorState.getSelection();
                var key = selection.getAnchorKey();
                var content = editorState.getCurrentContent();
                var block = content.getBlockForKey(key);
                var commands = ['unordered-list-item', 'ordered-list-item'];
                if (block.text === '' && commands.indexOf(block.type) !== -1) {
                    newState = draft_js_1.RichUtils.toggleBlockType(editorState, block.type);
                    break;
                }
            } // fall through
            default:
                newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
        }
        if (newState) {
            onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };
    /**
     * @ngdoc method
     * @name Editor3#handleBeforeInput
     * @description Handles space characters before they are inputed. Makes sure that
     * any space character added after a link does not perpetuate the link. It basically
     * stops default DraftJS behavior, which is not quite suitable: when a link is added
     * at the end of content, any character added will continue to be part of the link.
     * This logic stops that behavior.
     */
    Editor3Component.prototype.handleBeforeInput = function (chars, editorState) {
        var author = author_1.getCurrentAuthor();
        var _a = this.props, onChange = _a.onChange, suggestingMode = _a.suggestingMode, onCreateAddSuggestion = _a.onCreateAddSuggestion;
        if (suggestingMode) {
            if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)
                && !Suggestions.allowEditSuggestionOnRight(editorState, author)) {
                return 'handled';
            }
            onCreateAddSuggestion(chars);
            return 'handled';
        }
        if (handleBeforeInputHighlights_1.handleBeforeInputHighlights(this.props.onChange, chars, editorState) === 'handled') {
            return 'handled';
        }
        if (chars !== ' ') {
            return 'not-handled';
        }
        var typeAfterCursor = entityUtils_1.getEntityTypeAfterCursor(editorState);
        var typeBeforeCursor = entityUtils_1.getEntityTypeBeforeCursor(editorState);
        var shouldBreakLink = typeAfterCursor !== 'LINK' && typeBeforeCursor === 'LINK';
        if (shouldBreakLink) {
            var contentState = editorState.getCurrentContent();
            var selection = editorState.getSelection();
            var newContentState = draft_js_1.Modifier.insertText(contentState, selection, ' ');
            var newEditorState = draft_js_1.EditorState.push(editorState, newContentState, 'insert-characters');
            onChange(newEditorState);
            return 'handled';
        }
        return 'not-handled';
    };
    Editor3Component.prototype.componentDidMount = function () {
        $(this.div).on('dragover', this.onDragOver);
        if (!window[exports.EDITOR_GLOBAL_REFS]) {
            window[exports.EDITOR_GLOBAL_REFS] = {};
        }
        window[exports.EDITOR_GLOBAL_REFS][this.editorKey] = this.editor;
    };
    Editor3Component.prototype.handleRefs = function (editor) {
        this.editor = editor;
        this.editorKey = this.editor === null ? null : this.editor._editorKey;
        this.editorNode = this.editor === null ? undefined : react_dom_1.default.findDOMNode(this.editor);
    };
    Editor3Component.prototype.componentWillUnmount = function () {
        $(this.div).off();
        delete window[exports.EDITOR_GLOBAL_REFS][this.editorKey];
    };
    Editor3Component.prototype.componentDidUpdate = function () {
        if (window.hasOwnProperty('instgrm')) {
            window.instgrm.Embeds.process();
        }
    };
    Editor3Component.prototype.render = function () {
        var _this = this;
        var _a = this.props, readOnly = _a.readOnly, locked = _a.locked, showToolbar = _a.showToolbar, editorState = _a.editorState, onChange = _a.onChange, onTab = _a.onTab, tabindex = _a.tabindex, scrollContainer = _a.scrollContainer;
        var cx = classnames_1.default({
            'Editor3-root Editor3-editor': true,
            'no-toolbar': !showToolbar,
            'read-only': readOnly,
            'unstyled__block--invisibles': this.props.invisibles,
        });
        var mediaEnabled = this.props.editorFormat.indexOf('media') !== -1;
        var blockRenderMap = draft_js_1.DefaultDraftBlockRenderMap.merge(immutable_1.Map(mediaEnabled ? {
            unstyled: {
                element: UnstyledBlock_1.default,
                aliasedElements: ['p'],
                wrapper: react_1.default.createElement(UnstyledWrapper_1.default, { dispatch: this.props.dispatch, editorProps: this.props }),
            },
        } : {}));
        return (react_1.default.createElement("div", { className: cx, ref: function (div) { return _this.div = div; } },
            showToolbar &&
                react_1.default.createElement(toolbar_1.default, { disabled: locked || readOnly, scrollContainer: scrollContainer, editorNode: this.editorNode, highlightsManager: this.props.highlightsManager, editorWrapperElement: this.div }),
            react_1.default.createElement(HighlightsPopup_1.HighlightsPopup, { editorNode: this.editorNode, editorState: editorState, highlightsManager: this.props.highlightsManager, onChange: this.props.onChange }),
            react_1.default.createElement("div", { className: "focus-screen", onMouseDown: this.focus },
                react_1.default.createElement(draft_js_1.Editor, { editorState: editorState, handleKeyCommand: this.handleKeyCommand, keyBindingFn: this.keyBindingFn, handleBeforeInput: this.handleBeforeInput, blockRenderMap: blockRenderMap, blockRendererFn: blockRenderer_1.getBlockRenderer({ svc: this.props.svc }), customStyleMap: __assign({}, customStyleMap_1.customStyleMap, this.props.highlightsManager.styleMap), onChange: function () {
                        // in order to position the popup component we need to know the position of editor selection
                        // even when it's not focused, or another input is focused
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var selectionRect = draft_js_2.getVisibleSelectionRect(window);
                        if (_this.editorNode != null && selectionRect != null) {
                            _this.editorNode.dataset.editorSelectionRect = JSON.stringify(selectionRect);
                        }
                        onChange.apply(void 0, args);
                    }, onTab: onTab, tabIndex: tabindex, handlePastedText: handlePastedText_1.handlePastedText.bind(this), readOnly: locked || readOnly, ref: function (editor) { return _this.handleRefs(editor); } }))));
    };
    return Editor3Component;
}(react_1.default.Component));
exports.Editor3Component = Editor3Component;
Editor3Component.propTypes = {
    readOnly: prop_types_1.default.bool,
    locked: prop_types_1.default.bool,
    showToolbar: prop_types_1.default.bool,
    editorState: prop_types_1.default.object,
    onChange: prop_types_1.default.func,
    unlock: prop_types_1.default.func,
    onTab: prop_types_1.default.func,
    dragDrop: prop_types_1.default.func,
    scrollContainer: prop_types_1.default.string.isRequired,
    singleLine: prop_types_1.default.bool,
    editorFormat: prop_types_1.default.array,
    tabindex: prop_types_1.default.number,
    dispatch: prop_types_1.default.func,
    suggestingMode: prop_types_1.default.bool,
    onCreateAddSuggestion: prop_types_1.default.func,
    onCreateDeleteSuggestion: prop_types_1.default.func,
    onPasteFromSuggestingMode: prop_types_1.default.func,
    onCreateSplitParagraphSuggestion: prop_types_1.default.func,
    onCreateChangeStyleSuggestion: prop_types_1.default.func,
    svc: prop_types_1.default.object,
    invisibles: prop_types_1.default.bool,
    highlights: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object,
};
Editor3Component.defaultProps = {
    readOnly: false,
    singleLine: false,
    editorFormat: [],
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkInput_1 = __webpack_require__(914);
exports.LinkInput = LinkInput_1.LinkInput;
var LinkToolbar_1 = __webpack_require__(1194);
exports.LinkToolbar = LinkToolbar_1.LinkToolbar;
var LinkDecorator_1 = __webpack_require__(411);
exports.LinkDecorator = LinkDecorator_1.LinkDecorator;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Column
 * @description Column Component of a list item
 */
exports.Column = function (_a) {
    var children = _a.children, grow = _a.grow, border = _a.border, noPadding = _a.noPadding, hasCheck = _a.hasCheck, checked = _a.checked;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-item__column', {
            'sd-list-item__column--grow': grow,
            'sd-list-item__column--no-border': !border,
            'sd-list-item__column--no-padding': noPadding,
            'sd-list-item__column--has-check': hasCheck,
            'sd-list-item__column--checked': checked,
        }) }, children));
};
exports.Column.propTypes = {
    children: prop_types_1.default.node.isRequired,
    grow: prop_types_1.default.bool,
    border: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
    hasCheck: prop_types_1.default.bool,
    checked: prop_types_1.default.bool,
};
exports.Column.defaultProps = {
    grow: false,
    border: true,
    noPadding: false,
    hasCheck: false,
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name LineInput
 * @description Component to style input component in a line-input style
 */
exports.LineInput = function (_a) {
    var children = _a.children, required = _a.required, invalid = _a.invalid, readOnly = _a.readOnly, boxed = _a.boxed, isSelect = _a.isSelect, noMargin = _a.noMargin, noLabel = _a.noLabel, withButton = _a.withButton, labelLeft = _a.labelLeft, labelLeftAuto = _a.labelLeftAuto, hint = _a.hint, message = _a.message, className = _a.className, borderBottom = _a.borderBottom, onClick = _a.onClick;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
            'sd-line-input--required': required,
            'sd-line-input--invalid': invalid,
            'sd-line-input--disabled': readOnly,
            'sd-line-input--boxed': boxed,
            'sd-line-input--is-select': isSelect,
            'sd-line-input--no-margin': noMargin,
            'sd-line-input--no-label': noLabel,
            'sd-line-input--with-button': withButton,
            'sd-line-input--label-left': labelLeft,
            'sd-line-input--label-left-auto': labelLeftAuto,
            'sd-line-input--no-border-bottom': !borderBottom,
        }, className), onClick: onClick ? onClick : undefined },
        children,
        hint && react_1.default.createElement("div", { className: "sd-line-input__hint" }, hint),
        message && react_1.default.createElement("div", { className: "sd-line-input__message" }, message)));
};
exports.LineInputProps = {
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    isSelect: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    noLabel: prop_types_1.default.bool,
    withButton: prop_types_1.default.bool,
    labelLeft: prop_types_1.default.bool,
    labelLeftAuto: prop_types_1.default.bool,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
    borderBottom: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
exports.LineInputDefaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    isSelect: false,
    noMargin: false,
    noLabel: false,
    withButton: false,
    labelLeft: false,
    labelLeftAuto: false,
    borderBottom: true,
};
exports.LineInput.propTypes = __assign({ children: prop_types_1.default.node, className: prop_types_1.default.string }, exports.LineInputProps);
exports.LineInput.defaultProps = __assign({}, exports.LineInputDefaultProps);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(979);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(94);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 200 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(204)('keys');
var uid = __webpack_require__(137);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(38);
var global = __webpack_require__(67);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(136) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 206 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(983);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(993);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(93);
var dPs = __webpack_require__(987);
var enumBugKeys = __webpack_require__(205);
var IE_PROTO = __webpack_require__(203)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(444)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(988).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(68).f;
var has = __webpack_require__(81);
var TAG = __webpack_require__(53)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(53);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(67);
var core = __webpack_require__(38);
var LIBRARY = __webpack_require__(136);
var wksExt = __webpack_require__(210);
var defineProperty = __webpack_require__(68).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  label: 'Close'
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      { type: 'button', className: 'close', onClick: onClick },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('btn-group', ButtonGroup));

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('glyphicon', Glyphicon));

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(31);






var _collapseStyles;










var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    }, _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    }, _this.handleExit = function (elem) {
      var dimension = _this.getDimension();
      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + 'px';
      triggerBrowserReflow(elem);
    }, _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Collapse.prototype.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  /* -- Expanding -- */


  /* -- Collapsing -- */


  Collapse.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className', 'children']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9_react_transition_group_Transition___default.a,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        'aria-expanded': props.role ? props.in : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting
      }),
      function (state, innerProps) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, innerProps, {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
        }));
      }
    );
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1107);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('tab', TabContent));

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(1176),
    DebounceInput = _require.DebounceInput;

DebounceInput.DebounceInput = DebounceInput;

module.exports = DebounceInput;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_mentions_1 = __webpack_require__(1196);
var components_1 = __webpack_require__(527);
var mentionsStyle_1 = __importDefault(__webpack_require__(1313));
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
var CommentTextArea = /** @class */ (function (_super) {
    __extends(CommentTextArea, _super);
    function CommentTextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.suggestUser = _this.suggestUser.bind(_this);
        _this.suggestDesk = _this.suggestDesk.bind(_this);
        _this.renderSuggestion = _this.renderSuggestion.bind(_this);
        _this.userList = ng_1.default.get('userList');
        _this.desks = ng_1.default.get('desks');
        return _this;
    }
    CommentTextArea.prototype.componentDidMount = function () {
        $('.comment-input textarea').focus();
    };
    /**
     * @ngdoc method
     * @name CommentInputBody#suggestDesk
     * @param {String} q Query string for mentions
     * @param {Function<Array>} cb Callback for async ops on requesting the results.
     * @description suggest returns the list of suggestions for a given query q.
     */
    CommentTextArea.prototype.suggestDesk = function (q, cb) {
        var _this = this;
        this.desks.initialize().then(function () {
            return cb(_this.desks.desks._items
                .filter(function (_a) {
                var name = _a.name;
                return name.toLowerCase().indexOf(q.toLowerCase()) > -1;
            })
                .map(function (d) { return ({
                id: d._id,
                display: d.name,
                type: 'desk',
            }); }));
        });
    };
    /**
     * @ngdoc method
     * @name CommentInputBody#suggestUser
     * @param {String} q Query string for mentions
     * @param {Function<Array>} cb Callback for async ops on requesting the results.
     * @description suggest returns the list of suggestions for a given query q.
     */
    CommentTextArea.prototype.suggestUser = function (q, cb) {
        this.userList.get(q).then(function (users) {
            return cb(users._items.map(function (u) { return ({
                id: u._id,
                display: u.display_name,
                type: 'user',
            }); }));
        });
    };
    /**
     * @ngdoc method
     * @name CommentInputBody#renderSuggestion
     * @description renderSuggestion renders each list item to be displayed in the
     * suggested items dropdown based on its data.
     * @returns {JSX}
     */
    CommentTextArea.prototype.renderSuggestion = function (_a, search, highlightedDisplay) {
        var type = _a.type, display = _a.display;
        return (react_1.default.createElement("div", { className: "entry" },
            type === 'desk' ? react_1.default.createElement("i", { className: "icon-tasks" }) : react_1.default.createElement(components_1.UserAvatar, { displayName: display }),
            highlightedDisplay));
    };
    CommentTextArea.prototype.render = function () {
        var mentionsInputStyle = typeof this.props.maxHeight !== 'number'
            ? mentionsStyle_1.default.input
            : __assign({}, mentionsStyle_1.default.input, { '&multiLine': __assign({}, mentionsStyle_1.default.input['&multiLine'], { input: __assign({}, mentionsStyle_1.default.input['&multiLine'].input, { maxHeight: this.props.maxHeight }) }) });
        return (react_1.default.createElement("div", { className: "comment-textarea" },
            react_1.default.createElement(react_mentions_1.MentionsInput, { value: this.props.value, onChange: this.props.onChange, style: mentionsInputStyle, className: "mentions-input", markup: "@[__display__](__type__:__id__)", placeholder: this.props.placeholder || utils_1.gettext('Type your comment...'), onFocus: this.props.onFocus, onBlur: this.props.onBlur, singleLine: this.props.singleLine },
                react_1.default.createElement(react_mentions_1.Mention, { trigger: "@", type: "user", data: this.suggestUser, renderSuggestion: this.renderSuggestion, style: mentionsStyle_1.default.mention, appendSpaceOnAdd: true }),
                react_1.default.createElement(react_mentions_1.Mention, { trigger: "#", type: "desk", data: this.suggestDesk, renderSuggestion: this.renderSuggestion, style: mentionsStyle_1.default.mention, appendSpaceOnAdd: true }))));
    };
    return CommentTextArea;
}(react_1.default.Component));
CommentTextArea.propTypes = {
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func.isRequired,
    placeholder: prop_types_1.default.string,
    onFocus: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    singleLine: prop_types_1.default.bool,
    maxHeight: prop_types_1.default.number,
};
exports.default = CommentTextArea;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(55),
    stubFalse = __webpack_require__(1208);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 226 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(497);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1230),
    mapCacheDelete = __webpack_require__(1237),
    mapCacheGet = __webpack_require__(1239),
    mapCacheHas = __webpack_require__(1240),
    mapCacheSet = __webpack_require__(1241);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1250),
    stubArray = __webpack_require__(510);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 234 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(500);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(515);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(71),
    isKey = __webpack_require__(1269),
    stringToPath = __webpack_require__(1270),
    toString = __webpack_require__(1273);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(101),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(525);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLACEHOLDERS = {
  id: "__id__",
  display: "__display__",
  type: "__type__"
};

var escapeMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
var createEscaper = function createEscaper(map) {
  var escaper = function escaper(match) {
    return map[match];
  };
  var keys = [];
  for (var key in map) {
    if (map.hasOwnProperty(key)) keys.push(key);
  }
  var source = '(?:' + keys.join('|') + ')';
  var testRegexp = RegExp(source);
  var replaceRegexp = RegExp(source, 'g');
  return function (string) {
    string = string == null ? '' : '' + string;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
};

var numericComparator = function numericComparator(a, b) {
  a = a === null ? Number.MAX_VALUE : a;
  b = b === null ? Number.MAX_VALUE : b;
  return a - b;
};

module.exports = {

  escapeHtml: createEscaper(escapeMap),

  escapeRegex: function escapeRegex(str) {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  },

  markupToRegex: function markupToRegex(markup, matchAtEnd) {
    var markupPattern = this.escapeRegex(markup);
    markupPattern = markupPattern.replace(PLACEHOLDERS.display, "(.+?)");
    markupPattern = markupPattern.replace(PLACEHOLDERS.id, "(.+?)");
    markupPattern = markupPattern.replace(PLACEHOLDERS.type, "(.+?)");
    if (matchAtEnd) {
      // append a $ to match at the end of the string
      markupPattern = markupPattern + "$";
    }
    return new RegExp(markupPattern, "g");
  },

  spliceString: function spliceString(str, start, end, insert) {
    return str.substring(0, start) + insert + str.substring(end);
  },

  extend: function extend(obj) {
    var source, prop;
    for (var i = 1, length = arguments.length; i < length; i++) {
      source = arguments[i];
      for (prop in source) {
        if (hasOwnProperty.call(source, prop)) {
          obj[prop] = source[prop];
        }
      }
    }
    return obj;
  },

  isNumber: function isNumber(obj) {
    return Object.prototype.toString.call(obj) === "[object Number]";
  },

  /**
   * parameterName: "id", "display", or "type"
   */
  getPositionOfCapturingGroup: function getPositionOfCapturingGroup(markup, parameterName) {
    if (parameterName !== "id" && parameterName !== "display" && parameterName !== "type") {
      throw new Error("parameterName must be 'id', 'display', or 'type'");
    }

    // calculate positions of placeholders in the markup
    var indexDisplay = markup.indexOf(PLACEHOLDERS.display);
    var indexId = markup.indexOf(PLACEHOLDERS.id);
    var indexType = markup.indexOf(PLACEHOLDERS.type);

    // set indices to null if not found
    if (indexDisplay < 0) indexDisplay = null;
    if (indexId < 0) indexId = null;
    if (indexType < 0) indexType = null;

    if (indexDisplay === null && indexId === null) {
      // markup contains none of the mandatory placeholders
      throw new Error("The markup `" + markup + "` must contain at least one of the placeholders `__id__` or `__display__`");
    }

    if (indexType === null && parameterName === "type") {
      // markup does not contain optional __type__ placeholder
      return null;
    }

    // sort indices in ascending order (null values will always be at the end)
    var sortedIndices = [indexDisplay, indexId, indexType].sort(numericComparator);

    // If only one the placeholders __id__ and __display__ is present,
    // use the captured string for both parameters, id and display
    if (indexDisplay === null) indexDisplay = indexId;
    if (indexId === null) indexId = indexDisplay;

    if (parameterName === "id") return sortedIndices.indexOf(indexId);
    if (parameterName === "display") return sortedIndices.indexOf(indexDisplay);
    if (parameterName === "type") return indexType === null ? null : sortedIndices.indexOf(indexType);
  },

  // Finds all occurences of the markup in the value and iterates the plain text sub strings
  // in between those markups using `textIteratee` and the markup occurrences using the
  // `markupIteratee`.
  iterateMentionsMarkup: function iterateMentionsMarkup(value, markup, textIteratee, markupIteratee, displayTransform) {
    var regex = this.markupToRegex(markup);
    var displayPos = this.getPositionOfCapturingGroup(markup, "display");
    var idPos = this.getPositionOfCapturingGroup(markup, "id");
    var typePos = this.getPositionOfCapturingGroup(markup, "type");

    var match;
    var start = 0;
    var currentPlainTextIndex = 0;

    // detect all mention markup occurences in the value and iterate the matches
    while ((match = regex.exec(value)) !== null) {

      var id = match[idPos + 1];
      var display = match[displayPos + 1];
      var type = typePos !== null ? match[typePos + 1] : null;

      if (displayTransform) display = displayTransform(id, display, type);

      var substr = value.substring(start, match.index);
      textIteratee(substr, start, currentPlainTextIndex);
      currentPlainTextIndex += substr.length;

      markupIteratee(match[0], match.index, currentPlainTextIndex, id, display, type, start);
      currentPlainTextIndex += display.length;

      start = regex.lastIndex;
    }

    if (start < value.length) {
      textIteratee(value.substring(start), start, currentPlainTextIndex);
    }
  },

  // For the passed character index in the plain text string, returns the corresponding index
  // in the marked up value string.
  // If the passed character index lies inside a mention, the value of `inMarkupCorrection` defines the
  // correction to apply:
  //   - 'START' to return the index of the mention markup's first char (default)
  //   - 'END' to return the index after its last char
  //   - 'NULL' to return null
  mapPlainTextIndex: function mapPlainTextIndex(value, markup, indexInPlainText) {
    var inMarkupCorrection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'START';
    var displayTransform = arguments[4];

    if (!this.isNumber(indexInPlainText)) {
      return indexInPlainText;
    }

    var result;
    var textIteratee = function textIteratee(substr, index, substrPlainTextIndex) {
      if (result !== undefined) return;

      if (substrPlainTextIndex + substr.length >= indexInPlainText) {
        // found the corresponding position in the current plain text range
        result = index + indexInPlainText - substrPlainTextIndex;
      }
    };
    var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, type, lastMentionEndIndex) {
      if (result !== undefined) return;

      if (mentionPlainTextIndex + display.length > indexInPlainText) {
        // found the corresponding position inside current match,
        // return the index of the first or after the last char of the matching markup
        // depending on whether the `inMarkupCorrection`
        if (inMarkupCorrection === 'NULL') {
          result = null;
        } else {
          result = index + (inMarkupCorrection === 'END' ? markup.length : 0);
        }
      }
    };

    this.iterateMentionsMarkup(value, markup, textIteratee, markupIteratee, displayTransform);

    // when a mention is at the end of the value and we want to get the caret position
    // at the end of the string, result is undefined
    return result === undefined ? value.length : result;
  },

  // For a given indexInPlainText that lies inside a mention,
  // returns a the index of of the first char of the mention in the plain text.
  // If indexInPlainText does not lie inside a mention, returns indexInPlainText.
  findStartOfMentionInPlainText: function findStartOfMentionInPlainText(value, markup, indexInPlainText, displayTransform) {
    var result = indexInPlainText;
    var foundMention = false;

    var markupIteratee = function markupIteratee(markup, index, mentionPlainTextIndex, id, display, type, lastMentionEndIndex) {
      if (mentionPlainTextIndex <= indexInPlainText && mentionPlainTextIndex + display.length > indexInPlainText) {
        result = mentionPlainTextIndex;
        foundMention = true;
      }
    };
    this.iterateMentionsMarkup(value, markup, function () {}, markupIteratee, displayTransform);

    if (foundMention) {
      return result;
    }
  },

  // Returns whether the given plain text index lies inside a mention
  isInsideOfMention: function isInsideOfMention(value, markup, indexInPlainText, displayTransform) {
    var mentionStart = this.findStartOfMentionInPlainText(value, markup, indexInPlainText, displayTransform);
    return mentionStart !== undefined && mentionStart !== indexInPlainText;
  },

  // Applies a change from the plain text textarea to the underlying marked up value
  // guided by the textarea text selection ranges before and after the change
  applyChangeToValue: function applyChangeToValue(value, markup, plainTextValue, selectionStartBeforeChange, selectionEndBeforeChange, selectionEndAfterChange, displayTransform) {
    var oldPlainTextValue = this.getPlainText(value, markup, displayTransform);

    var lengthDelta = oldPlainTextValue.length - plainTextValue.length;
    if (selectionStartBeforeChange === 'undefined') {
      selectionStartBeforeChange = selectionEndAfterChange + lengthDelta;
    }

    if (selectionEndBeforeChange === 'undefined') {
      selectionEndBeforeChange = selectionStartBeforeChange;
    }

    // Fixes an issue with replacing combined characters for complex input. Eg like acented letters on OSX
    if (selectionStartBeforeChange === selectionEndBeforeChange && selectionEndBeforeChange === selectionEndAfterChange && oldPlainTextValue.length === plainTextValue.length) {
      selectionStartBeforeChange = selectionStartBeforeChange - 1;
    }

    // extract the insertion from the new plain text value
    var insert = plainTextValue.slice(selectionStartBeforeChange, selectionEndAfterChange);

    // handling for Backspace key with no range selection
    var spliceStart = Math.min(selectionStartBeforeChange, selectionEndAfterChange);

    var spliceEnd = selectionEndBeforeChange;
    if (selectionStartBeforeChange === selectionEndAfterChange) {
      // handling for Delete key with no range selection
      spliceEnd = Math.max(selectionEndBeforeChange, selectionStartBeforeChange + lengthDelta);
    }

    var mappedSpliceStart = this.mapPlainTextIndex(value, markup, spliceStart, 'START', displayTransform);
    var mappedSpliceEnd = this.mapPlainTextIndex(value, markup, spliceEnd, 'END', displayTransform);

    var controlSpliceStart = this.mapPlainTextIndex(value, markup, spliceStart, 'NULL', displayTransform);
    var controlSpliceEnd = this.mapPlainTextIndex(value, markup, spliceEnd, 'NULL', displayTransform);
    var willRemoveMention = controlSpliceStart === null || controlSpliceEnd === null;

    var newValue = this.spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);

    if (!willRemoveMention) {
      // test for auto-completion changes
      var controlPlainTextValue = this.getPlainText(newValue, markup, displayTransform);
      if (controlPlainTextValue !== plainTextValue) {
        // some auto-correction is going on

        // find start of diff
        spliceStart = 0;
        while (plainTextValue[spliceStart] === controlPlainTextValue[spliceStart]) {
          spliceStart++;
        } // extract auto-corrected insertion
        insert = plainTextValue.slice(spliceStart, selectionEndAfterChange);

        // find index of the unchanged remainder
        spliceEnd = oldPlainTextValue.lastIndexOf(plainTextValue.substring(selectionEndAfterChange));

        // re-map the corrected indices
        mappedSpliceStart = this.mapPlainTextIndex(value, markup, spliceStart, 'START', displayTransform);
        mappedSpliceEnd = this.mapPlainTextIndex(value, markup, spliceEnd, 'END', displayTransform);
        newValue = this.spliceString(value, mappedSpliceStart, mappedSpliceEnd, insert);
      }
    }

    return newValue;
  },

  getPlainText: function getPlainText(value, markup, displayTransform) {
    var regex = this.markupToRegex(markup);
    var idPos = this.getPositionOfCapturingGroup(markup, "id");
    var displayPos = this.getPositionOfCapturingGroup(markup, "display");
    var typePos = this.getPositionOfCapturingGroup(markup, "type");
    return value.replace(regex, function () {
      // first argument is the whole match, capturing groups are following
      var id = arguments[idPos + 1];
      var display = arguments[displayPos + 1];
      var type = arguments[typePos + 1];
      if (displayTransform) display = displayTransform(id, display, type);
      return display;
    });
  },

  getMentions: function getMentions(value, markup, displayTransform) {
    var mentions = [];
    this.iterateMentionsMarkup(value, markup, function () {}, function (match, index, plainTextIndex, id, display, type, start) {
      mentions.push({
        id: id,
        display: display,
        type: type,
        index: index,
        plainTextIndex: plainTextIndex
      });
    }, displayTransform);
    return mentions;
  },

  getEndOfLastMention: function getEndOfLastMention(value, markup, displayTransform) {
    var mentions = this.getMentions(value, markup, displayTransform);
    var lastMention = mentions[mentions.length - 1];
    return lastMention ? lastMention.plainTextIndex + lastMention.display.length : 0;
  },

  makeMentionsMarkup: function makeMentionsMarkup(markup, id, display, type) {
    var result = markup.replace(PLACEHOLDERS.id, id);
    result = result.replace(PLACEHOLDERS.display, display);
    result = result.replace(PLACEHOLDERS.type, type);
    return result;
  },

  countSuggestions: function countSuggestions(suggestions) {
    var result = 0;
    for (var prop in suggestions) {
      if (suggestions.hasOwnProperty(prop)) {
        result += suggestions[prop].results.length;
      }
    }
    return result;
  },

  getSuggestions: function getSuggestions(suggestions) {
    var result = [];

    for (var mentionType in suggestions) {
      if (!suggestions.hasOwnProperty(mentionType)) {
        return;
      }

      result = result.concat({
        suggestions: suggestions[mentionType].results,
        descriptor: suggestions[mentionType]
      });
    }

    return result;
  },

  getSuggestion: function getSuggestion(suggestions, index) {
    return this.getSuggestions(suggestions).reduce(function (result, _ref) {
      var suggestions = _ref.suggestions,
          descriptor = _ref.descriptor;
      return [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(suggestions.map(function (suggestion) {
        return {
          suggestion: suggestion,
          descriptor: descriptor
        };
      })));
    }, [])[index];
  }

};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var EditorHighlightsHeader = /** @class */ (function (_super) {
    __extends(EditorHighlightsHeader, _super);
    function EditorHighlightsHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            actionsDropdownOpen: false,
        };
        return _this;
    }
    EditorHighlightsHeader.prototype.toggleActionsDropdown = function () {
        this.setState({
            actionsDropdownOpen: !this.state.actionsDropdownOpen,
        });
    };
    EditorHighlightsHeader.prototype.render = function () {
        var _this = this;
        var availableActions = this.props.availableActions;
        var actionsDropdownStyles = this.state.actionsDropdownOpen !== true ? {} : {
            display: 'block',
            position: 'absolute',
            width: 'auto',
            padding: '1rem 0',
            marginBottom: 12,
        };
        return (react_1.default.createElement("div", { className: "editor-popup__header" },
            react_1.default.createElement("div", { className: "editor-popup__header-text" }, this.props.children),
            availableActions.length < 1 ? null : (react_1.default.createElement("div", { className: "editor-popup__header-tools" },
                react_1.default.createElement("div", { className: "dropdown dropdown--align-right" },
                    react_1.default.createElement("button", { className: "icn-btn dropdown__toggle", onClick: function () { return _this.toggleActionsDropdown(); } },
                        react_1.default.createElement("i", { className: "icon-dots-vertical" })),
                    react_1.default.createElement("ul", { className: "dropdown__menu", style: actionsDropdownStyles }, availableActions.map(function (action, i) { return (react_1.default.createElement("li", { key: i },
                        react_1.default.createElement("button", { onClick: function () {
                                _this.toggleActionsDropdown();
                                action.onClick();
                            } },
                            react_1.default.createElement("i", { className: action.icon }),
                            action.text))); })))))));
    };
    return EditorHighlightsHeader;
}(react_1.default.Component));
exports.EditorHighlightsHeader = EditorHighlightsHeader;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var FluidRows = /** @class */ (function (_super) {
    __extends(FluidRows, _super);
    function FluidRows() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FluidRows.prototype.render = function () {
        return (react_1.default.createElement("div", { onClick: this.props.onClick, className: this.props.className, style: {
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '100%',
                width: '100%',
            } }, this.props.children));
    };
    return FluidRows;
}(react_1.default.Component));
exports.FluidRows = FluidRows;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var FluidRow = /** @class */ (function (_super) {
    __extends(FluidRow, _super);
    function FluidRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FluidRow.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.props.className, style: this.props.scrollable === true ? { overflow: 'auto' } : {} }, this.props.children));
    };
    return FluidRow;
}(react_1.default.Component));
exports.FluidRow = FluidRow;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var HighlightsPopupPositioner = /** @class */ (function (_super) {
    __extends(HighlightsPopupPositioner, _super);
    function HighlightsPopupPositioner(props) {
        var _this = _super.call(this, props) || this;
        _this.animationTimer = null;
        _this.position = _this.position.bind(_this);
        _this.positionOnNextAnimationFrame = _this.positionOnNextAnimationFrame.bind(_this);
        return _this;
    }
    HighlightsPopupPositioner.prototype.positionOnNextAnimationFrame = function () {
        var _this = this;
        if (this.animationTimer != null) {
            window.cancelAnimationFrame(this.animationTimer);
        }
        var position = this.position;
        this.animationTimer = window.requestAnimationFrame(function () {
            _this.animationTimer = null;
            position();
        });
    };
    HighlightsPopupPositioner.prototype.position = function () {
        var editorNode = this.props.editorNode;
        var element = this.highlightsPopupRootElement;
        var mainFlexElement = this.highlightsPopupMainFlexElement;
        if (editorNode == null || element == null || mainFlexElement == null) {
            return;
        }
        var selectionRect = JSON.parse(editorNode.dataset.editorSelectionRect);
        if (selectionRect == null) {
            return;
        }
        // reset calculated values so new calculation can be performed
        element.style.top = '';
        element.style.bottom = '';
        mainFlexElement.style['max-height'] = '';
        element.style.left = (this.props.editorNode.getBoundingClientRect().left - 360) + 'px';
        var paddingTop = 4;
        var paddingBottom = 4;
        var viewportHeight = $(window).innerHeight();
        var remainingSpaceAtTheBottomOfSelectedText = viewportHeight - selectionRect.top;
        element.style.bottom = (remainingSpaceAtTheBottomOfSelectedText > element.offsetHeight
            ? Math.max(remainingSpaceAtTheBottomOfSelectedText - element.offsetHeight, paddingBottom)
            : paddingBottom) + 'px';
        mainFlexElement.style['max-height'] = (viewportHeight
            - parseInt(element.style.bottom, 10)
            - paddingTop) + 'px';
    };
    HighlightsPopupPositioner.prototype.componentDidMount = function () {
        this.position();
        window.addEventListener('keydown', this.positionOnNextAnimationFrame);
        window.addEventListener('resize', this.positionOnNextAnimationFrame);
        window.addEventListener('click', this.positionOnNextAnimationFrame);
    };
    HighlightsPopupPositioner.prototype.componentDidUpdate = function () {
        this.position();
    };
    HighlightsPopupPositioner.prototype.componentWillUnmount = function () {
        window.removeEventListener('keydown', this.positionOnNextAnimationFrame);
        window.removeEventListener('resize', this.positionOnNextAnimationFrame);
        window.removeEventListener('click', this.positionOnNextAnimationFrame);
    };
    HighlightsPopupPositioner.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: 'editor-popup editor-popup--open ', ref: function (el) {
                _this.highlightsPopupRootElement = el;
            } },
            react_1.default.createElement("div", { className: "editor-popup__main editor-popup__main--floating", ref: function (el) {
                    _this.highlightsPopupMainFlexElement = el;
                } }, this.props.children)));
    };
    return HighlightsPopupPositioner;
}(react_1.default.Component));
exports.HighlightsPopupPositioner = HighlightsPopupPositioner;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
// http://docs.python-cerberus.org/en/stable/usage.html
exports.DEFAULT_SCHEMA = Object.freeze({
    slugline: { maxlength: 24, type: 'string', required: true },
    relatedItems: {},
    genre: { type: 'list' },
    anpa_take_key: { type: 'string' },
    place: { type: 'list' },
    priority: { type: 'integer' },
    urgency: { type: 'integer' },
    anpa_category: { type: 'list', required: true },
    subject: { type: 'list', required: true },
    company_codes: { type: 'list' },
    ednote: { type: 'string' },
    headline: { maxlength: 42, type: 'string', required: true },
    sms: { maxlength: 160, type: 'string' },
    abstract: { maxlength: 160, type: 'string' },
    body_html: { required: true, type: 'string' },
    byline: { type: 'string' },
    dateline: { type: 'dict', required: false },
    sign_off: { type: 'string' },
    footer: {},
    body_footer: { type: 'string' },
});
exports.DEFAULT_EDITOR = Object.freeze({
    slugline: { order: 1, sdWidth: 'full', enabled: true },
    genre: { order: 2, sdWidth: 'half', enabled: true },
    anpa_take_key: { order: 3, sdWidth: 'half', enabled: true },
    place: { order: 4, sdWidth: 'half', enabled: true },
    priority: { order: 5, sdWidth: 'quarter', enabled: true },
    urgency: { order: 6, sdWidth: 'quarter', enabled: true },
    anpa_category: { order: 7, sdWidth: 'full', enabled: true },
    subject: { order: 8, sdWidth: 'full', enabled: true },
    company_codes: { order: 9, sdWidth: 'full', enabled: true },
    ednote: { order: 10, sdWidth: 'full', enabled: true },
    headline: { order: 11, formatOptions: ['underline', 'link', 'bold'], enabled: true },
    sms: { order: 12, enabled: true },
    abstract: {
        order: 13,
        formatOptions: ['bold', 'italic', 'underline', 'link'],
        enabled: true,
    },
    byline: { order: 14, enabled: true },
    dateline: { order: 15, enabled: true },
    body_html: {
        order: 16,
        formatOptions: ['h2', 'bold', 'italic', 'underline', 'quote', 'link', 'embed', 'media'],
        enabled: true,
    },
    footer: { order: 17, enabled: true },
    body_footer: { order: 18, enabled: true },
    sign_off: { order: 19, enabled: true },
});
// labelMap maps schema entry keys to their display names.
exports.GET_LABEL_MAP = function () { return ({
    headline: utils_1.gettext('Headline'),
    slugline: utils_1.gettext('Slugline'),
    genre: utils_1.gettext('Genre'),
    anpa_take_key: utils_1.gettext('Take Key'),
    place: utils_1.gettext('Place'),
    priority: utils_1.gettext('Priority'),
    urgency: utils_1.gettext('Urgency'),
    anpa_category: utils_1.gettext('ANPA Category'),
    categories: utils_1.gettext('Categories'),
    desk: utils_1.gettext('Desk'),
    embargo: utils_1.gettext('Embargo'),
    footers: utils_1.gettext('Footers'),
    'package-story-labels': utils_1.gettext('Package story labels'),
    source: utils_1.gettext('Source'),
    stage: utils_1.gettext('Stage'),
    type: utils_1.gettext('Type'),
    ingest_provider: utils_1.gettext('Ingest Provider'),
    subject: utils_1.gettext('Subject'),
    ednote: utils_1.gettext('Editorial Note'),
    abstract: utils_1.gettext('Abstract'),
    body_html: utils_1.gettext('Body HTML'),
    byline: utils_1.gettext('Byline'),
    dateline: utils_1.gettext('Dateline'),
    sign_off: utils_1.gettext('Sign Off'),
    sms: utils_1.gettext('SMS'),
    body_footer: utils_1.gettext('Body footer'),
    footer: utils_1.gettext('Footer'),
    media: utils_1.gettext('Media'),
    media_description: utils_1.gettext('Media Description'),
    feature_image: utils_1.gettext('Feature Image'),
    feature_media: utils_1.gettext('Feature Media'),
    relatedItems: utils_1.gettext('Related Items'),
    company_codes: utils_1.gettext('Company Codes'),
    keywords: utils_1.gettext('Keywords'),
    language: utils_1.gettext('Language'),
    usageterms: utils_1.gettext('Usage Terms'),
    sms_message: utils_1.gettext('SMS Message'),
    description_text: utils_1.gettext('Description'),
    archive_description: utils_1.gettext('Archive description'),
    alt_text: utils_1.gettext('Alt text'),
    copyrightholder: utils_1.gettext('Copyright holder'),
    copyrightnotice: utils_1.gettext('Copyright notice'),
    attachments: utils_1.gettext('Attachments'),
}); };
exports.HAS_FORMAT_OPTIONS = Object.freeze({
    abstract: true,
    body_html: true,
    footer: true,
    body_footer: true,
});
exports.CV_ALIAS = Object.freeze({
    locators: 'place',
    categories: 'anpa_category',
});
exports.EXTRA_SCHEMA_FIELDS = Object.freeze({
    feature_media: {},
    media_description: {},
});
exports.EXTRA_EDITOR_FIELDS = Object.freeze({
    feature_media: { enabled: true },
    media_description: { enabled: true },
});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MarkBtn_1 = __webpack_require__(1556);
exports.MarkBtn = MarkBtn_1.MarkBtn;
var MarkDesksDropdown_1 = __webpack_require__(1557);
exports.MarkDesksDropdown = MarkDesksDropdown_1.MarkDesksDropdown;
var MarkedDeskItem_1 = __webpack_require__(1558);
exports.MarkedDeskItem = MarkedDeskItem_1.MarkedDeskItem;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AuthoringController_1 = __webpack_require__(1616);
exports.AuthoringController = AuthoringController_1.AuthoringController;
var ChangeImageController_1 = __webpack_require__(558);
exports.ChangeImageController = ChangeImageController_1.ChangeImageController;
var AssociationController_1 = __webpack_require__(1617);
exports.AssociationController = AssociationController_1.AssociationController;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LEFT_SIDEBAR_WIDTH = 48;
var utils_1 = __webpack_require__(3);
exports.getGenericErrorMessage = function () {
    return utils_1.gettext('Unknow error occured. Try repeating the action or reloading the page.');
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(73);
var lodash_1 = __importDefault(__webpack_require__(2));
var DateFilters_1 = __webpack_require__(126);
var utils_1 = __webpack_require__(3);
var DEFAULT_REPOS = ['ingest', 'archive', 'published', 'archived'];
/**
 * Converts the integer fields to string
 * within a given search
 *
 * @return {Object} the updated search object
 */
function setFilters(search) {
    lodash_1.default.forOwn(search, function (value, key) {
        if (lodash_1.default.includes(['priority', 'urgency'], key)) {
            search[key] = JSON.stringify(value);
        }
    });
    return search;
}
exports.setFilters = setFilters;
/**
 * @ngdoc service
 * @module superdesk.apps.search
 * @name search
 *
 * @requires $location
 * @requires config
 * @requires session
 * @requires multi
 * @requires preferencesService
 * @requires moment
 * @requires sort
 *
 * @description Search Service is responsible for creation and manipulation of Query object
 */
SearchService.$inject = [
    '$location',
    'config',
    'session',
    'multi',
    'preferencesService',
    'moment',
    'sort',
];
function SearchService($location, config, session, multi, preferencesService, moment, sortService) {
    var _this = this;
    var sortOptions = [
        { field: 'versioncreated', label: utils_1.gettext('Updated') },
        { field: 'firstcreated', label: utils_1.gettext('Created') },
        { field: 'urgency', label: utils_1.gettext('Urgency') },
        { field: 'anpa_category.name', label: utils_1.gettext('ANPA Category') },
        { field: 'slugline.phrase', label: utils_1.gettext('Slugline') },
        { field: 'priority', label: utils_1.gettext('Priority') },
        { field: 'genre.name', label: utils_1.gettext('Genre') },
    ];
    var self = this;
    this.cvs = config.search_cvs ||
        [{ id: 'subject', name: 'Subject', field: 'subject', list: 'subjectcodes' },
            { id: 'companycodes', name: 'Company Codes', field: 'company_codes', list: 'company_codes' }];
    preferencesService.get('singleline:view').then(function (result) {
        if (result) {
            // No preference, but global config set
            if (result.enabled === null && lodash_1.default.get(config, 'list.singleLineView') && lodash_1.default.get(config, 'list.singleLine')) {
                _this.singleLine = true;
                return;
            }
            // Preference set, but singleLine not in config
            if (result.enabled && !lodash_1.default.get(config, 'list.singleLine')) {
                _this.singleLine = false;
                return;
            }
            _this.singleLine = result.enabled;
        }
    });
    /*
     * Set filters for parameters
     */
    function setParameters(filters, params) {
        var addFromDeskFilter = function (key) {
            var desk = params[key].split('-');
            if (desk.length === 2) {
                if (desk[1] === 'authoring') {
                    filters.push({ term: { 'task.last_authoring_desk': desk[0] } });
                }
                else {
                    filters.push({ term: { 'task.last_production_desk': desk[0] } });
                }
            }
        };
        var addToDeskFilter = function (key) {
            var desk = params[key].split('-');
            if (desk.length === 2) {
                filters.push({ term: { 'task.desk': desk[0] } });
                if (!params.from_desk) {
                    var field = desk[1] === 'authoring' ? 'task.last_production_desk' : 'task.last_authoring_desk';
                    filters.push({ exists: { field: field } });
                }
            }
        };
        angular.forEach(self.cvs, function (cv) {
            if (params[cv.id] && cv.field !== cv.id) {
                var filter = { terms: {} };
                filter.terms[cv.field + '.qcode'] = JSON.parse(params[cv.id]);
                filters.push(filter);
            }
        });
        // set the filters for parameters defined in the parameters panel.
        lodash_1.default.each(constants_1.PARAMETERS, function (value, key) {
            if (!params[key]) {
                return;
            }
            switch (key) {
                case 'from_desk':
                    addFromDeskFilter(key);
                    break;
                case 'to_desk':
                    addToDeskFilter(key);
                    break;
                case 'spike':
                    // Will get set in the base filters
                    break;
                case 'featuremedia':
                    filters.push({ exists: { field: 'associations.featuremedia' } });
                    break;
                case 'subject':
                    filters.push({ or: [
                            { terms: { 'subject.qcode': JSON.parse(params[key]) } },
                            { terms: { 'subject.parent': JSON.parse(params[key]) } },
                        ] });
                    break;
                case 'company_codes':
                    filters.push({ terms: { 'company_codes.qcode': JSON.parse(params[key]) } });
                    break;
                case 'marked_desks':
                    filters.push({ terms: { 'marked_desks.desk_id': JSON.parse(params[key]) } });
                    break;
                default:
                    var filter = { term: {} };
                    filter.term[key] = params[key];
                    filters.push(filter);
            }
        });
        // Set filters for Aggregates when facet is removed from the filter panel.
        lodash_1.default.each(constants_1.EXCLUDE_FACETS, function (value, key) {
            if (!params[key]) {
                return;
            }
            var termKey = {
                nottype: 'type',
                notdesk: 'task.desk',
                notgenre: 'genre.name',
                notcategory: 'anpa_category.name',
                noturgency: 'urgency',
                notpriority: 'priority',
                notsource: 'source',
                notlegal: 'flags.marked_for_legal',
                notsms: 'flags.marked_for_sms',
            }[key];
            if (termKey) {
                var f = { not: { terms: {} } };
                f.not.terms[termKey] = JSON.parse(params[key]);
                filters.push(f);
            }
        });
    }
    /*
     * Function for finding object by string array for cv codes
     */
    this.getSelectedCodes = function (currentTags, codeList, field) {
        var queryArray = currentTags.selectedParameters, filteredArray = [];
        if (!$location.search().q) {
            return filteredArray;
        }
        for (var i = 0, queryArrayLength = queryArray.length; i < queryArrayLength; i++) {
            var queryArrayElement = queryArray[i];
            if (queryArrayElement.indexOf(field + '.qcode') === -1 &&
                queryArrayElement.indexOf(field + '.name') === -1) {
                continue;
            }
            var elementName = queryArrayElement.substring(queryArrayElement.lastIndexOf('(') + 1, queryArrayElement.lastIndexOf(')'));
            for (var j = 0, codeListLength = codeList.length; j < codeListLength; j++) {
                if (codeList[j].qcode === elementName || codeList[j].name === elementName) {
                    filteredArray.push(codeList[j]);
                }
            }
        }
        return filteredArray;
    };
    /*
     * Function for finding object by string array for subject codes
     */
    this.getSubjectCodes = function (currentTags, subjectcodes) {
        return this.getSelectedCodes(currentTags, subjectcodes, 'subject');
    };
    /*
     * Function for finding object by string array for company codes
     */
    this.getCompanyCodes = function (currentTags, codes) {
        return this.getSelectedCodes(currentTags, codes, 'company_codes');
    };
    this.sortOptions = sortOptions;
    this.setFilters = setFilters;
    /**
     * Prepares the date based on the timezone settings.
     * If useDefaultTimezone is used then all search are based on the server timezone else users browser timezone
     * @param {String} date - Date selected by the User
     * @param {String} timeSuffix - time part
     * @return {String} date
     */
    function formatDate(date, timeSuffix) {
        var local = moment(date, config.view.dateformat).format('YYYY-MM-DD') + timeSuffix;
        if (config.search && config.search.useDefaultTimezone) {
            // use the default timezone of the server.
            local += moment.tz(config.defaultTimezone).format('ZZ');
        }
        else {
            // use the client timezone of the server.
            local += moment().format('ZZ');
        }
        return local;
    }
    this.formatDate = formatDate;
    /**
     * Single query instance
     */
    function Query(_params) {
        var size, filters = [], postFilters = [], params = {}, zeroHourSuffix = 'T00:00:00', midnightSuffix = 'T23:59:59';
        angular.forEach(_params, function (value, key) {
            params[key] = value;
        });
        if (params.q) {
            angular.forEach(this.cvs, function (cv) {
                if (cv.field !== cv.id) {
                    params.q = params.q.replace(cv.id + '.qcode:(', cv.field + '.qcode:(');
                }
            });
        }
        function buildGeneralFilters(paramsObject, query) {
            if (paramsObject.urgency) {
                query.post_filter({ terms: { urgency: JSON.parse(paramsObject.urgency) } });
            }
            if (paramsObject.priority) {
                query.post_filter({ terms: { priority: JSON.parse(paramsObject.priority) } });
            }
            if (paramsObject.source) {
                query.post_filter({ terms: { source: JSON.parse(paramsObject.source) } });
            }
            // used by aap multimedia datalayer
            if (paramsObject.creditqcode) {
                query.post_filter({ terms: { credit: lodash_1.default.map(JSON.parse(paramsObject.creditqcode), 'value') } });
            }
            if (paramsObject.category) {
                query.post_filter({ terms: { 'anpa_category.name': JSON.parse(paramsObject.category) } });
            }
            if (paramsObject.genre) {
                query.post_filter({ terms: { 'genre.name': JSON.parse(paramsObject.genre) } });
            }
            if (paramsObject.desk) {
                query.post_filter({ terms: { 'task.desk': JSON.parse(paramsObject.desk) } });
            }
            if (paramsObject.legal) {
                query.post_filter({ terms: { 'flags.marked_for_legal': JSON.parse(paramsObject.legal) } });
            }
            if (paramsObject.sms) {
                query.post_filter({ terms: { 'flags.marked_for_sms': JSON.parse(paramsObject.sms) } });
            }
            if (paramsObject.language) {
                query.post_filter({ terms: { language: JSON.parse(paramsObject.language) } });
            }
        }
        /**
          * Builds Post Filter search query used when the filtering done via facets/aggregates.
          * @param {String} params - search parameters
          * @param {Object} query - Query object
          */
        function buildFilters(paramsObject, query) {
            // date filters start
            var facetrange = {};
            // inject custom date field filters { fieldname: 'string(IDateRange)' }
            if (typeof paramsObject.customFields !== 'undefined') {
                for (var fieldname in paramsObject.customFields) {
                    var range = paramsObject.customFields[fieldname];
                    if (typeof DateFilters_1.dateRangesByKey[range] !== 'undefined') {
                        facetrange[fieldname] = DateFilters_1.dateRangesByKey[range].elasticSearchDateRange;
                    }
                }
            }
            DateFilters_1.getDateFilters().forEach(function (_a) {
                var fieldname = _a.fieldname;
                var dateRangeKey = paramsObject[fieldname];
                if (paramsObject[fieldname] != null && DateFilters_1.dateRangesByKey[dateRangeKey] != null) {
                    // handle predefined ranges
                    facetrange[fieldname] = DateFilters_1.dateRangesByKey[dateRangeKey].elasticSearchDateRange;
                }
                else {
                    // handle manual ranges
                    if (paramsObject[fieldname + 'to'] != null) {
                        if (facetrange[fieldname] == null) {
                            facetrange[fieldname] = {};
                        }
                        facetrange[fieldname].lte = formatDate(paramsObject[fieldname + 'to'], midnightSuffix);
                    }
                    if (paramsObject[fieldname + 'from'] != null) {
                        if (facetrange[fieldname] == null) {
                            facetrange[fieldname] = {};
                        }
                        facetrange[fieldname].gte = formatDate(paramsObject[fieldname + 'from'], zeroHourSuffix);
                    }
                }
            });
            if (Object.keys(facetrange).length > 0) {
                query.post_filter({ range: facetrange });
            }
            // date filters end
            if (paramsObject.type) {
                var type = {
                    type: JSON.parse(paramsObject.type),
                };
                query.post_filter({ terms: type });
            }
            buildGeneralFilters(paramsObject, query);
        }
        /**
         * Get criteria for given query
         */
        this.getCriteria = function getCriteria(withSource) {
            var search = params;
            var sort = sortService.getSort(sortOptions);
            setParameters(filters, params);
            var criteria = {
                query: { filtered: { filter: { and: filters } } },
                sort: [lodash_1.default.zipObject([sort.field], [sort.dir])],
            };
            if (postFilters.length > 0) {
                criteria.post_filter = { and: postFilters };
            }
            // Construct the query string by combining the q parameter and the raw parameter, if both present
            var queryString = null;
            if (search.q && search.raw) {
                queryString = [search.q, search.raw]
                    .filter(function (q) { return q; })
                    .map(function (q) { return '(' + q.replace(/\//g, '\\/') + ')'; })
                    .join(' AND ');
            }
            else {
                queryString = [search.q, search.raw]
                    .filter(function (q) { return q; })
                    .map(function (q) { return q.replace(/\//g, '\\/'); })
                    .join('');
            }
            if (queryString) {
                criteria.query.filtered.query = { query_string: {
                        query: queryString,
                        lenient: false,
                        default_operator: 'AND',
                    } };
            }
            if (withSource) {
                criteria = { source: criteria };
                if (search.repo) {
                    criteria.repo = search.repo;
                }
                else if (config.defaultSearch) {
                    criteria.repo = DEFAULT_REPOS.filter(function (repo) { return config.defaultSearch[repo] !== false; }).join(',');
                }
            }
            return criteria;
        };
        /**
         * Add filter to query
         *
         * @param {Object} filter
         */
        this.filter = function addFilter(filter) {
            filters.push(filter);
            return this;
        };
        /**
         * Add post filter to query
         *
         * @param {Object} filter
         */
        this.post_filter = function addPostFilter(filter) {
            postFilters.push(filter);
            return this;
        };
        /**
         * Clears all filters
         */
        this.clear_filters = function clearFilters() {
            filters = [];
            postFilters = [];
            buildFilters({}, this);
            return this;
        };
        /**
         * Set size
         *
         * @param {number} _size
         */
        this.size = function setSize(_size) {
            size = !lodash_1.default.isNil(_size) ? _size : size;
            return this;
        };
        // set spiked filters
        if (params.spike === 'include') {
            // no filters needed
        }
        else if (params.spike === 'only') {
            this.filter({ term: { state: 'spiked' } });
        }
        else {
            // default exclude spiked items
            this.filter({ not: { term: { state: 'spiked' } } });
        }
        if (params.ignoreKilled) {
            this.filter({ not: { terms: { state: ['killed', 'recalled'] } } });
        }
        if (params.onlyLastPublished) {
            this.filter({ not: { term: { last_published_version: 'false' } } });
        }
        if (params.ignoreScheduled) {
            this.filter({ not: { term: { state: 'scheduled' } } });
        }
        // remove other users drafts.
        this.filter({ or: [{ and: [{ term: { state: 'draft' } },
                        { term: { original_creator: session.identity._id } }] },
                { not: { terms: { state: ['draft'] } } }] });
        // this is needed for archived collection
        this.filter({ not: { term: { package_type: 'takes' } } });
        // inject custom elastic search queries
        if (params.customQueries != null) {
            for (var _i = 0, _a = params.customQueries; _i < _a.length; _i++) {
                var q = _a[_i];
                this.filter(q);
            }
        }
        buildFilters(params, this);
    }
    /**
     * Start creating a new query
     *
     * @param {Object} params
     */
    this.query = function createQuery(params) {
        return new Query(params);
    };
    /**
     * Generate Track By Identifier for search results.
     *
     * @param {Object} item
     * @return {String}
     */
    this.generateTrackByIdentifier = function (item) {
        return this.getTrackByIdentifier(item._id, item.state !== 'ingested' ? item._current_version : null);
    };
    /**
     * Get unique id for an item
     *
     * @param {String} id
     * @param {String} version
     * @return {String}
     */
    this.getTrackByIdentifier = function (id, version) {
        return version ? id + ':' + version : id;
    };
    /*
     * helper to compare if items in 'a' are different with 'b' on _id and _current_version, if type is published.
     */
    function compareWith(a, b) {
        return lodash_1.default.filter(a._items, function (item) {
            if (item._type === 'published') {
                return !lodash_1.default.find(b._items, { _id: item._id, _current_version: item._current_version });
            }
            return !lodash_1.default.find(b._items, { _id: item._id });
        });
    }
    /*
     * To determine if refresh button needs to be shown, i-e:
     * when any difference found in scopeItems and recently fetched newItems
     *
     * @param {Object} data - {newItems, scopeItems, scrollTop, isItemPreviewing}
     */
    this.canShowRefresh = function (data) {
        var _showRefresh, diff = [];
        if (data.scopeItems) {
            // determine if items are different (in terms of added or removed) in scope items from
            // fetched new items or vice versa.
            diff = compareWith(data.scopeItems, data.newItems);
            if (lodash_1.default.isEmpty(diff)) {
                diff = compareWith(data.newItems, data.scopeItems);
            }
        }
        if (!lodash_1.default.isEmpty(diff)) {
            // if different, then determine _showReferesh, such that, if item is previewing or scroll in not on top.
            _showRefresh = data.isItemPreviewing || !!data.scrollTop;
        }
        return _showRefresh;
    };
    /**
     * @ngdoc method
     * @name search#mergeHighlightFields
     * @public
     * @description Merges the highlighted fields to the item
     * @param {Object} item
     * @returns {Object}
     */
    this.mergeHighlightFields = function (item) {
        if (item.es_highlight) {
            lodash_1.default.forEach(lodash_1.default.keys(item.es_highlight), function (key) {
                item[key] = item.es_highlight[key][0];
            });
        }
        else {
            item.es_highlight = [];
        }
        return item;
    };
    /**
     * Merge newItems list with scopeItems list if any
     *
     * @param {Object} newItems
     * @param {Object} scopeItems
     * @param {boolean} append
     * @param {boolean} force
     * @returns {Object}
     */
    this.mergeItems = function (newItems, scopeItems, append, force) {
        if (this.getElasticHighlight()) {
            newItems._items = lodash_1.default.map(newItems._items, this.mergeHighlightFields);
        }
        newItems._items.forEach(function (item) {
            item.selected = multi.isSelected(item);
        });
        if (force || !scopeItems) {
            return newItems;
        }
        else if (append && scopeItems) {
            var nextItems = scopeItems._items.concat(newItems._items);
            return angular.extend({}, newItems, { _items: nextItems });
        }
        // items in scopeItem, which are no longer exist in fetched newItems. i-e; need to remove from scopeItems
        var diffToMinus = lodash_1.default.map(compareWith(scopeItems, newItems), '_id');
        // items in fetched newItems, which are new for scopeItems. i-e; need to include in scopeItems
        var diffToAdd = lodash_1.default.map(compareWith(newItems, scopeItems), '_id');
        // if fetched items are new or removed then update current scope.items
        // by adding or removing items found in diffToAdd or diffToMinus respectively.
        if (!lodash_1.default.isEmpty(diffToMinus)) {
            lodash_1.default.remove(scopeItems._items, function (item) { return lodash_1.default.includes(diffToMinus, item._id); });
        }
        if (!lodash_1.default.isEmpty(diffToAdd)) {
            var index = 0;
            lodash_1.default.map(newItems._items, function (item) {
                if (lodash_1.default.includes(diffToAdd, item._id)) {
                    // insert item at its place from the fetched sorted items
                    scopeItems._items.splice(index, 0, item);
                }
                index++;
            });
        }
        // update scope.item item-wise with matching fetched items to maintain
        // item's current position in scope.
        return this.updateItems(newItems, scopeItems); // i.e. updated scope.items
    };
    /**
     * Check if elasticsearch highlight feature is configured or not.
     */
    this.getElasticHighlight = function () {
        return config.features && config.features.elasticHighlight ? 1 : 0;
    };
    /**
     * Returns a query to search items by id
     *
     * @param {Object} items - {_id: 1}
     */
    this.getItemQuery = function (items) {
        var updatedItems = lodash_1.default.keys(items);
        return { filtered: { filter: { terms: { _id: updatedItems } } } };
    };
    /**
     * @ngdoc method
     * @name search#doesSearchAgainstRepo
     * @public
     * @returns {Boolean}
     * @description Checks if the given search object will do the search agains the given repo
     * @param {Object} search search criteria
     * @param {String} repo name of the repo: ingest, archive, published, archived
     */
    this.doesSearchAgainstRepo = function (search, repo) {
        return !search.filter.query.repo || search.filter.query.repo.toLowerCase().indexOf(repo.toLowerCase()) !== -1;
    };
    /**
     * @ngdoc method
     * @name search#getSingleItemCriteria
     * @public
     * @returns {Object}
     * @description Returns the query criteria for a single item while keeping keywords or
     * q values so that the results will have highlights
     * @param {Object} item
     * @param {Object} criteria
     */
    this.getSingleItemCriteria = function (item, criteria) {
        var itemCriteria = criteria || this.query($location.search()).getCriteria(true);
        itemCriteria.source.from = 0;
        itemCriteria.source.size = 1;
        itemCriteria.es_highlight = this.getElasticHighlight();
        var itemId = item._type !== 'published' ? item._id : item.item_id;
        itemCriteria.source.query.filtered.filter = {
            or: [
                { term: { _id: itemId } }, { term: { item_id: itemId } },
            ],
        };
        return itemCriteria;
    };
    /**
     * Update scope items only with the matching fetched newItems
     *
     * @param {Object} newItems
     * @param {Object} scopeItems
     * @return {Object}
     */
    this.updateItems = function (newItems, scopeItems) {
        lodash_1.default.map(scopeItems._items, function (item) {
            if (item._type === 'published') {
                return lodash_1.default.extend(item, lodash_1.default.find(newItems._items, { _id: item._id, _current_version: item._current_version }));
            }
            // remove gone flag to prevent item remaining grey, if gone item moves back to this stage.
            var itm = item;
            if (angular.isDefined(item.gone)) {
                itm = lodash_1.default.omit(item, 'gone');
            }
            return lodash_1.default.extend(itm, lodash_1.default.find(newItems._items, { _id: itm._id }));
        });
        // update aggregations
        scopeItems._aggregations = newItems._aggregations;
        return angular.extend({}, scopeItems);
    };
    /**
     * @ngdoc method
     * @name search#getProjectedFields
     * @public
     * @returns {Array}
     * @description Returns the list of fields to be used in projections
     */
    this.getProjectedFields = function () {
        var uiConfig = config.list || constants_1.DEFAULT_LIST_CONFIG;
        var uiFields = lodash_1.default.union(uiConfig.priority, uiConfig.firstLine, uiConfig.secondLine);
        var projectedFields = [];
        uiFields.forEach(function (uiField) {
            if (uiField in constants_1.UI_PROJECTED_FIELD_MAPPINGS) {
                projectedFields.push(constants_1.UI_PROJECTED_FIELD_MAPPINGS[uiField]);
            }
        });
        return lodash_1.default.union(constants_1.CORE_PROJECTED_FIELDS.fields, projectedFields);
    };
    /**
     * @ngdoc method
     * @name search#updateSingleLineStatus
     * @public
     * @returns {Boolean}
     * @description updates singleLine value after computation
     */
    this.updateSingleLineStatus = function (singleLinePref) {
        if (singleLinePref && lodash_1.default.get(config, 'list.singleLine')) {
            self.singleLine = true;
            return;
        }
        self.singleLine = false;
    };
}
exports.SearchService = SearchService;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var index_1 = __webpack_require__(22);
var classnames_1 = __importDefault(__webpack_require__(4));
var ListTypeIcon = /** @class */ (function (_super) {
    __extends(ListTypeIcon, _super);
    function ListTypeIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hover: false };
        _this.setHover = _this.setHover.bind(_this);
        _this.unsetHover = _this.unsetHover.bind(_this);
        return _this;
    }
    ListTypeIcon.prototype.setHover = function () {
        this.setState({ hover: true });
    };
    ListTypeIcon.prototype.unsetHover = function () {
        if (this.state.hover) {
            this.setState({ hover: false });
        }
    };
    ListTypeIcon.prototype.render = function () {
        var selectingDisabled = this.props.selectingDisabled;
        var showSelect = selectingDisabled !== true && (this.state.hover || this.props.item.selected);
        return react_1.default.createElement('div', {
            className: classnames_1.default('list-field type-icon sd-monitoring-item-multi-select-checkbox'),
            onMouseEnter: selectingDisabled ? null : this.setHover,
            onMouseLeave: selectingDisabled ? null : this.unsetHover,
            style: { lineHeight: 0 },
        }, showSelect ?
            react_1.default.createElement(index_1.SelectBox, {
                item: this.props.item,
                onMultiSelect: this.props.onMultiSelect,
            }) :
            react_1.default.createElement(index_1.TypeIcon, {
                type: this.props.item.type,
                highlight: this.props.item.highlight,
                svc: this.props.svc,
            }));
    };
    return ListTypeIcon;
}(react_1.default.Component));
exports.ListTypeIcon = ListTypeIcon;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var text_single_line_1 = __webpack_require__(2027);
var typescript_helpers_1 = __webpack_require__(56);
var form_1 = __webpack_require__(74);
var vocabulary_single_value_1 = __webpack_require__(2028);
var text_editor3_1 = __webpack_require__(2029);
var lodash_1 = __webpack_require__(2);
var checkbox_1 = __webpack_require__(2031);
var content_filter_single_value_1 = __webpack_require__(2032);
var desk_single_value_1 = __webpack_require__(2033);
var stage_single_value_1 = __webpack_require__(2034);
var macro_single_value_1 = __webpack_require__(2035);
var yes_no_1 = __webpack_require__(2036);
function getFormFieldComponent(type) {
    switch (type) {
        case form_1.FormFieldType.textSingleLine:
            return text_single_line_1.TextSingleLine;
        case form_1.FormFieldType.textEditor3:
            return text_editor3_1.TextEditor3;
        case form_1.FormFieldType.vocabularySingleValue:
            return vocabulary_single_value_1.VocabularySingleValue;
        case form_1.FormFieldType.checkbox:
            return checkbox_1.CheckboxInput;
        case form_1.FormFieldType.contentFilterSingleValue:
            return content_filter_single_value_1.ContentFilterSingleValue;
        case form_1.FormFieldType.deskSingleValue:
            return desk_single_value_1.DeskSingleValue;
        case form_1.FormFieldType.stageSingleValue:
            return stage_single_value_1.StageSingleValue;
        case form_1.FormFieldType.macroSingleValue:
            return macro_single_value_1.MacroSingleValue;
        case form_1.FormFieldType.yesNo:
            return yes_no_1.YesNo;
        default:
            typescript_helpers_1.assertNever(type);
    }
}
exports.getFormFieldComponent = getFormFieldComponent;
function getFormFieldPreviewComponent(item, formFieldConfig) {
    var Component = getFormFieldComponent(formFieldConfig.type);
    return (react_1.default.createElement(Component, { formValues: item, previewOutput: true, value: item[formFieldConfig.field], formField: formFieldConfig, disabled: false, issues: [], onChange: lodash_1.noop }));
}
exports.getFormFieldPreviewComponent = getFormFieldPreviewComponent;
function getFormFieldsRecursive(form) {
    var result = [];
    form.forEach(function (item) {
        if (form_1.isIFormGroup(item)) {
            result = result.concat(getFormFieldsRecursive(item.form));
        }
        else if (form_1.isIFormField(item)) {
            result.push(item);
        }
        else {
            typescript_helpers_1.assertNever(item);
        }
    });
    return result;
}
exports.getFormFieldsRecursive = getFormFieldsRecursive;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Notes_1 = __webpack_require__(2077);
exports.Notes = Notes_1.Notes;
var ContactName_1 = __webpack_require__(2078);
exports.ContactName = ContactName_1.ContactName;
var JobTitle_1 = __webpack_require__(2079);
exports.JobTitle = JobTitle_1.JobTitle;
var State_1 = __webpack_require__(2080);
exports.State = State_1.State;
var VersionCreated_1 = __webpack_require__(2081);
exports.VersionCreated = VersionCreated_1.VersionCreated;
var Phone_1 = __webpack_require__(2091);
exports.Phone = Phone_1.Phone;
var Email_1 = __webpack_require__(2092);
exports.Email = Email_1.Email;
var OrgName_1 = __webpack_require__(2093);
exports.OrgName = OrgName_1.OrgName;
var Mobile_1 = __webpack_require__(2094);
exports.Mobile = Mobile_1.Mobile;
var ContactLocation_1 = __webpack_require__(2095);
exports.ContactLocation = ContactLocation_1.ContactLocation;
var SocialInfo_1 = __webpack_require__(2096);
exports.SocialInfo = SocialInfo_1.SocialInfo;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4c27b34156b7a3776f31cc456ca01c10.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ec5e59da4b23573927bda544cbb29401.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d47047084ba4c0d911f6332bb664a292.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "aa0862fd381bddd5f44d8dd103df9f60.eot";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "95f8a5d5e4da9f2910bcd7a34c411a29.eot";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "29795682bd73d5472ae0f7f53ccfd395.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "de6d75af6b355dbf9cfbbd1cbe869089.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(637);
module.exports = angular;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(5)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Rangy, a cross-browser JavaScript range and selection library
 * https://github.com/timdown/rangy
 *
 * Copyright 2015, Tim Down
 * Licensed under the MIT license.
 * Version: 1.3.0
 * Build date: 10 May 2015
 */

(function(factory, root) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module != "undefined" && typeof exports == "object") {
        // Node/CommonJS style
        module.exports = factory();
    } else {
        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
        root.rangy = factory();
    }
})(function() {

    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";

    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer"];

    // Minimal set of methods required for DOM Level 2 Range compliance
    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];

    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];

    // Subset of TextRange's full set of methods that we're interested in
    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
        "setEndPoint", "getBoundingClientRect"];

    /*----------------------------------------------------------------------------------------------------------------*/

    // Trio of functions taken from Peter Michaux's article:
    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
    function isHostMethod(o, p) {
        var t = typeof o[p];
        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
    }

    function isHostObject(o, p) {
        return !!(typeof o[p] == OBJECT && o[p]);
    }

    function isHostProperty(o, p) {
        return typeof o[p] != UNDEFINED;
    }

    // Creates a convenience function to save verbose repeated calls to tests functions
    function createMultiplePropertyTest(testFunc) {
        return function(o, props) {
            var i = props.length;
            while (i--) {
                if (!testFunc(o, props[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
    var areHostMethods = createMultiplePropertyTest(isHostMethod);
    var areHostObjects = createMultiplePropertyTest(isHostObject);
    var areHostProperties = createMultiplePropertyTest(isHostProperty);

    function isTextRange(range) {
        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
    }

    function getBody(doc) {
        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
    }

    var forEach = [].forEach ?
        function(arr, func) {
            arr.forEach(func);
        } :
        function(arr, func) {
            for (var i = 0, len = arr.length; i < len; ++i) {
                func(arr[i], i);
            }
        };

    var modules = {};

    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);

    var util = {
        isHostMethod: isHostMethod,
        isHostObject: isHostObject,
        isHostProperty: isHostProperty,
        areHostMethods: areHostMethods,
        areHostObjects: areHostObjects,
        areHostProperties: areHostProperties,
        isTextRange: isTextRange,
        getBody: getBody,
        forEach: forEach
    };

    var api = {
        version: "1.3.0",
        initialized: false,
        isBrowser: isBrowser,
        supported: true,
        util: util,
        features: {},
        modules: modules,
        config: {
            alertOnFail: false,
            alertOnWarn: false,
            preferTextRange: false,
            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
        }
    };

    function consoleLog(msg) {
        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
            console.log(msg);
        }
    }

    function alertOrLog(msg, shouldAlert) {
        if (isBrowser && shouldAlert) {
            alert(msg);
        } else  {
            consoleLog(msg);
        }
    }

    function fail(reason) {
        api.initialized = true;
        api.supported = false;
        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
    }

    api.fail = fail;

    function warn(msg) {
        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
    }

    api.warn = warn;

    // Add utility extend() method
    var extend;
    if ({}.hasOwnProperty) {
        util.extend = extend = function(obj, props, deep) {
            var o, p;
            for (var i in props) {
                if (props.hasOwnProperty(i)) {
                    o = obj[i];
                    p = props[i];
                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
                        extend(o, p, true);
                    }
                    obj[i] = p;
                }
            }
            // Special case for toString, which does not show up in for...in loops in IE <= 8
            if (props.hasOwnProperty("toString")) {
                obj.toString = props.toString;
            }
            return obj;
        };

        util.createOptions = function(optionsParam, defaults) {
            var options = {};
            extend(options, defaults);
            if (optionsParam) {
                extend(options, optionsParam);
            }
            return options;
        };
    } else {
        fail("hasOwnProperty not supported");
    }

    // Test whether we're in a browser and bail out if not
    if (!isBrowser) {
        fail("Rangy can only run in a browser");
    }

    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
    (function() {
        var toArray;

        if (isBrowser) {
            var el = document.createElement("div");
            el.appendChild(document.createElement("span"));
            var slice = [].slice;
            try {
                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
                    toArray = function(arrayLike) {
                        return slice.call(arrayLike, 0);
                    };
                }
            } catch (e) {}
        }

        if (!toArray) {
            toArray = function(arrayLike) {
                var arr = [];
                for (var i = 0, len = arrayLike.length; i < len; ++i) {
                    arr[i] = arrayLike[i];
                }
                return arr;
            };
        }

        util.toArray = toArray;
    })();

    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
    // normalization of event properties
    var addListener;
    if (isBrowser) {
        if (isHostMethod(document, "addEventListener")) {
            addListener = function(obj, eventType, listener) {
                obj.addEventListener(eventType, listener, false);
            };
        } else if (isHostMethod(document, "attachEvent")) {
            addListener = function(obj, eventType, listener) {
                obj.attachEvent("on" + eventType, listener);
            };
        } else {
            fail("Document does not have required addEventListener or attachEvent method");
        }

        util.addListener = addListener;
    }

    var initListeners = [];

    function getErrorDesc(ex) {
        return ex.message || ex.description || String(ex);
    }

    // Initialization
    function init() {
        if (!isBrowser || api.initialized) {
            return;
        }
        var testRange;
        var implementsDomRange = false, implementsTextRange = false;

        // First, perform basic feature tests

        if (isHostMethod(document, "createRange")) {
            testRange = document.createRange();
            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
                implementsDomRange = true;
            }
        }

        var body = getBody(document);
        if (!body || body.nodeName.toLowerCase() != "body") {
            fail("No body element found");
            return;
        }

        if (body && isHostMethod(body, "createTextRange")) {
            testRange = body.createTextRange();
            if (isTextRange(testRange)) {
                implementsTextRange = true;
            }
        }

        if (!implementsDomRange && !implementsTextRange) {
            fail("Neither Range nor TextRange are available");
            return;
        }

        api.initialized = true;
        api.features = {
            implementsDomRange: implementsDomRange,
            implementsTextRange: implementsTextRange
        };

        // Initialize modules
        var module, errorMessage;
        for (var moduleName in modules) {
            if ( (module = modules[moduleName]) instanceof Module ) {
                module.init(module, api);
            }
        }

        // Call init listeners
        for (var i = 0, len = initListeners.length; i < len; ++i) {
            try {
                initListeners[i](api);
            } catch (ex) {
                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
                consoleLog(errorMessage);
            }
        }
    }

    function deprecationNotice(deprecated, replacement, module) {
        if (module) {
            deprecated += " in module " + module.name;
        }
        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
        replacement + " instead.");
    }

    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
        owner[deprecated] = function() {
            deprecationNotice(deprecated, replacement, module);
            return owner[replacement].apply(owner, util.toArray(arguments));
        };
    }

    util.deprecationNotice = deprecationNotice;
    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;

    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
    api.init = init;

    // Execute listener immediately if already initialized
    api.addInitListener = function(listener) {
        if (api.initialized) {
            listener(api);
        } else {
            initListeners.push(listener);
        }
    };

    var shimListeners = [];

    api.addShimListener = function(listener) {
        shimListeners.push(listener);
    };

    function shim(win) {
        win = win || window;
        init();

        // Notify listeners
        for (var i = 0, len = shimListeners.length; i < len; ++i) {
            shimListeners[i](win);
        }
    }

    if (isBrowser) {
        api.shim = api.createMissingNativeApi = shim;
        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
    }

    function Module(name, dependencies, initializer) {
        this.name = name;
        this.dependencies = dependencies;
        this.initialized = false;
        this.supported = false;
        this.initializer = initializer;
    }

    Module.prototype = {
        init: function() {
            var requiredModuleNames = this.dependencies || [];
            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
                moduleName = requiredModuleNames[i];

                requiredModule = modules[moduleName];
                if (!requiredModule || !(requiredModule instanceof Module)) {
                    throw new Error("required module '" + moduleName + "' not found");
                }

                requiredModule.init();

                if (!requiredModule.supported) {
                    throw new Error("required module '" + moduleName + "' not supported");
                }
            }

            // Now run initializer
            this.initializer(this);
        },

        fail: function(reason) {
            this.initialized = true;
            this.supported = false;
            throw new Error(reason);
        },

        warn: function(msg) {
            api.warn("Module " + this.name + ": " + msg);
        },

        deprecationNotice: function(deprecated, replacement) {
            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
                replacement + " instead");
        },

        createError: function(msg) {
            return new Error("Error in Rangy " + this.name + " module: " + msg);
        }
    };

    function createModule(name, dependencies, initFunc) {
        var newModule = new Module(name, dependencies, function(module) {
            if (!module.initialized) {
                module.initialized = true;
                try {
                    initFunc(api, module);
                    module.supported = true;
                } catch (ex) {
                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
                    consoleLog(errorMessage);
                    if (ex.stack) {
                        consoleLog(ex.stack);
                    }
                }
            }
        });
        modules[name] = newModule;
        return newModule;
    }

    api.createModule = function(name) {
        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
        var initFunc, dependencies;
        if (arguments.length == 2) {
            initFunc = arguments[1];
            dependencies = [];
        } else {
            initFunc = arguments[2];
            dependencies = arguments[1];
        }

        var module = createModule(name, dependencies, initFunc);

        // Initialize the module immediately if the core is already initialized
        if (api.initialized && api.supported) {
            module.init();
        }
    };

    api.createCoreModule = function(name, dependencies, initFunc) {
        createModule(name, dependencies, initFunc);
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately

    function RangePrototype() {}
    api.RangePrototype = RangePrototype;
    api.rangePrototype = new RangePrototype();

    function SelectionPrototype() {}
    api.selectionPrototype = new SelectionPrototype();

    /*----------------------------------------------------------------------------------------------------------------*/

    // DOM utility methods used by Rangy
    api.createCoreModule("DomUtil", [], function(api, module) {
        var UNDEF = "undefined";
        var util = api.util;
        var getBody = util.getBody;

        // Perform feature tests
        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
            module.fail("document missing a Node creation method");
        }

        if (!util.isHostMethod(document, "getElementsByTagName")) {
            module.fail("document missing getElementsByTagName method");
        }

        var el = document.createElement("div");
        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
            module.fail("Incomplete Element implementation");
        }

        // innerHTML is required for Range's createContextualFragment method
        if (!util.isHostProperty(el, "innerHTML")) {
            module.fail("Element is missing innerHTML property");
        }

        var textNode = document.createTextNode("test");
        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
                !util.areHostProperties(textNode, ["data"]))) {
            module.fail("Incomplete Text Node implementation");
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
        // contains just the document as a single element and the value searched for is the document.
        var arrayContains = /*Array.prototype.indexOf ?
            function(arr, val) {
                return arr.indexOf(val) > -1;
            }:*/

            function(arr, val) {
                var i = arr.length;
                while (i--) {
                    if (arr[i] === val) {
                        return true;
                    }
                }
                return false;
            };

        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
        function isHtmlNamespace(node) {
            var ns;
            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
        }

        function parentElement(node) {
            var parent = node.parentNode;
            return (parent.nodeType == 1) ? parent : null;
        }

        function getNodeIndex(node) {
            var i = 0;
            while( (node = node.previousSibling) ) {
                ++i;
            }
            return i;
        }

        function getNodeLength(node) {
            switch (node.nodeType) {
                case 7:
                case 10:
                    return 0;
                case 3:
                case 8:
                    return node.length;
                default:
                    return node.childNodes.length;
            }
        }

        function getCommonAncestor(node1, node2) {
            var ancestors = [], n;
            for (n = node1; n; n = n.parentNode) {
                ancestors.push(n);
            }

            for (n = node2; n; n = n.parentNode) {
                if (arrayContains(ancestors, n)) {
                    return n;
                }
            }

            return null;
        }

        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
            var n = selfIsAncestor ? descendant : descendant.parentNode;
            while (n) {
                if (n === ancestor) {
                    return true;
                } else {
                    n = n.parentNode;
                }
            }
            return false;
        }

        function isOrIsAncestorOf(ancestor, descendant) {
            return isAncestorOf(ancestor, descendant, true);
        }

        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
            var p, n = selfIsAncestor ? node : node.parentNode;
            while (n) {
                p = n.parentNode;
                if (p === ancestor) {
                    return n;
                }
                n = p;
            }
            return null;
        }

        function isCharacterDataNode(node) {
            var t = node.nodeType;
            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
        }

        function isTextOrCommentNode(node) {
            if (!node) {
                return false;
            }
            var t = node.nodeType;
            return t == 3 || t == 8 ; // Text or Comment
        }

        function insertAfter(node, precedingNode) {
            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
            if (nextNode) {
                parent.insertBefore(node, nextNode);
            } else {
                parent.appendChild(node);
            }
            return node;
        }

        // Note that we cannot use splitText() because it is bugridden in IE 9.
        function splitDataNode(node, index, positionsToPreserve) {
            var newNode = node.cloneNode(false);
            newNode.deleteData(0, index);
            node.deleteData(index, node.length - index);
            insertAfter(newNode, node);

            // Preserve positions
            if (positionsToPreserve) {
                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
                    // Handle case where position was inside the portion of node after the split point
                    if (position.node == node && position.offset > index) {
                        position.node = newNode;
                        position.offset -= index;
                    }
                    // Handle the case where the position is a node offset within node's parent
                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
                        ++position.offset;
                    }
                }
            }
            return newNode;
        }

        function getDocument(node) {
            if (node.nodeType == 9) {
                return node;
            } else if (typeof node.ownerDocument != UNDEF) {
                return node.ownerDocument;
            } else if (typeof node.document != UNDEF) {
                return node.document;
            } else if (node.parentNode) {
                return getDocument(node.parentNode);
            } else {
                throw module.createError("getDocument: no document found for node");
            }
        }

        function getWindow(node) {
            var doc = getDocument(node);
            if (typeof doc.defaultView != UNDEF) {
                return doc.defaultView;
            } else if (typeof doc.parentWindow != UNDEF) {
                return doc.parentWindow;
            } else {
                throw module.createError("Cannot get a window object for node");
            }
        }

        function getIframeDocument(iframeEl) {
            if (typeof iframeEl.contentDocument != UNDEF) {
                return iframeEl.contentDocument;
            } else if (typeof iframeEl.contentWindow != UNDEF) {
                return iframeEl.contentWindow.document;
            } else {
                throw module.createError("getIframeDocument: No Document object found for iframe element");
            }
        }

        function getIframeWindow(iframeEl) {
            if (typeof iframeEl.contentWindow != UNDEF) {
                return iframeEl.contentWindow;
            } else if (typeof iframeEl.contentDocument != UNDEF) {
                return iframeEl.contentDocument.defaultView;
            } else {
                throw module.createError("getIframeWindow: No Window object found for iframe element");
            }
        }

        // This looks bad. Is it worth it?
        function isWindow(obj) {
            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
        }

        function getContentDocument(obj, module, methodName) {
            var doc;

            if (!obj) {
                doc = document;
            }

            // Test if a DOM node has been passed and obtain a document object for it if so
            else if (util.isHostProperty(obj, "nodeType")) {
                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
                    getIframeDocument(obj) : getDocument(obj);
            }

            // Test if the doc parameter appears to be a Window object
            else if (isWindow(obj)) {
                doc = obj.document;
            }

            if (!doc) {
                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
            }

            return doc;
        }

        function getRootContainer(node) {
            var parent;
            while ( (parent = node.parentNode) ) {
                node = parent;
            }
            return node;
        }

        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
            var nodeC, root, childA, childB, n;
            if (nodeA == nodeB) {
                // Case 1: nodes are the same
                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
                // Case 2: node C (container B or an ancestor) is a child node of A
                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
                // Case 3: node C (container A or an ancestor) is a child node of B
                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
            } else {
                root = getCommonAncestor(nodeA, nodeB);
                if (!root) {
                    throw new Error("comparePoints error: nodes have no common ancestor");
                }

                // Case 4: containers are siblings or descendants of siblings
                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);

                if (childA === childB) {
                    // This shouldn't be possible
                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
                } else {
                    n = root.firstChild;
                    while (n) {
                        if (n === childA) {
                            return -1;
                        } else if (n === childB) {
                            return 1;
                        }
                        n = n.nextSibling;
                    }
                }
            }
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
        var crashyTextNodes = false;

        function isBrokenNode(node) {
            var n;
            try {
                n = node.parentNode;
                return false;
            } catch (e) {
                return true;
            }
        }

        (function() {
            var el = document.createElement("b");
            el.innerHTML = "1";
            var textNode = el.firstChild;
            el.innerHTML = "<br />";
            crashyTextNodes = isBrokenNode(textNode);

            api.features.crashyTextNodes = crashyTextNodes;
        })();

        /*----------------------------------------------------------------------------------------------------------------*/

        function inspectNode(node) {
            if (!node) {
                return "[No node]";
            }
            if (crashyTextNodes && isBrokenNode(node)) {
                return "[Broken node]";
            }
            if (isCharacterDataNode(node)) {
                return '"' + node.data + '"';
            }
            if (node.nodeType == 1) {
                var idAttr = node.id ? ' id="' + node.id + '"' : "";
                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
            }
            return node.nodeName;
        }

        function fragmentFromNodeChildren(node) {
            var fragment = getDocument(node).createDocumentFragment(), child;
            while ( (child = node.firstChild) ) {
                fragment.appendChild(child);
            }
            return fragment;
        }

        var getComputedStyleProperty;
        if (typeof window.getComputedStyle != UNDEF) {
            getComputedStyleProperty = function(el, propName) {
                return getWindow(el).getComputedStyle(el, null)[propName];
            };
        } else if (typeof document.documentElement.currentStyle != UNDEF) {
            getComputedStyleProperty = function(el, propName) {
                return el.currentStyle ? el.currentStyle[propName] : "";
            };
        } else {
            module.fail("No means of obtaining computed style properties found");
        }

        function createTestElement(doc, html, contentEditable) {
            var body = getBody(doc);
            var el = doc.createElement("div");
            el.contentEditable = "" + !!contentEditable;
            if (html) {
                el.innerHTML = html;
            }

            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
            var bodyFirstChild = body.firstChild;
            if (bodyFirstChild) {
                body.insertBefore(el, bodyFirstChild);
            } else {
                body.appendChild(el);
            }

            return el;
        }

        function removeNode(node) {
            return node.parentNode.removeChild(node);
        }

        function NodeIterator(root) {
            this.root = root;
            this._next = root;
        }

        NodeIterator.prototype = {
            _current: null,

            hasNext: function() {
                return !!this._next;
            },

            next: function() {
                var n = this._current = this._next;
                var child, next;
                if (this._current) {
                    child = n.firstChild;
                    if (child) {
                        this._next = child;
                    } else {
                        next = null;
                        while ((n !== this.root) && !(next = n.nextSibling)) {
                            n = n.parentNode;
                        }
                        this._next = next;
                    }
                }
                return this._current;
            },

            detach: function() {
                this._current = this._next = this.root = null;
            }
        };

        function createIterator(root) {
            return new NodeIterator(root);
        }

        function DomPosition(node, offset) {
            this.node = node;
            this.offset = offset;
        }

        DomPosition.prototype = {
            equals: function(pos) {
                return !!pos && this.node === pos.node && this.offset == pos.offset;
            },

            inspect: function() {
                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
            },

            toString: function() {
                return this.inspect();
            }
        };

        function DOMException(codeName) {
            this.code = this[codeName];
            this.codeName = codeName;
            this.message = "DOMException: " + this.codeName;
        }

        DOMException.prototype = {
            INDEX_SIZE_ERR: 1,
            HIERARCHY_REQUEST_ERR: 3,
            WRONG_DOCUMENT_ERR: 4,
            NO_MODIFICATION_ALLOWED_ERR: 7,
            NOT_FOUND_ERR: 8,
            NOT_SUPPORTED_ERR: 9,
            INVALID_STATE_ERR: 11,
            INVALID_NODE_TYPE_ERR: 24
        };

        DOMException.prototype.toString = function() {
            return this.message;
        };

        api.dom = {
            arrayContains: arrayContains,
            isHtmlNamespace: isHtmlNamespace,
            parentElement: parentElement,
            getNodeIndex: getNodeIndex,
            getNodeLength: getNodeLength,
            getCommonAncestor: getCommonAncestor,
            isAncestorOf: isAncestorOf,
            isOrIsAncestorOf: isOrIsAncestorOf,
            getClosestAncestorIn: getClosestAncestorIn,
            isCharacterDataNode: isCharacterDataNode,
            isTextOrCommentNode: isTextOrCommentNode,
            insertAfter: insertAfter,
            splitDataNode: splitDataNode,
            getDocument: getDocument,
            getWindow: getWindow,
            getIframeWindow: getIframeWindow,
            getIframeDocument: getIframeDocument,
            getBody: getBody,
            isWindow: isWindow,
            getContentDocument: getContentDocument,
            getRootContainer: getRootContainer,
            comparePoints: comparePoints,
            isBrokenNode: isBrokenNode,
            inspectNode: inspectNode,
            getComputedStyleProperty: getComputedStyleProperty,
            createTestElement: createTestElement,
            removeNode: removeNode,
            fragmentFromNodeChildren: fragmentFromNodeChildren,
            createIterator: createIterator,
            DomPosition: DomPosition
        };

        api.DOMException = DOMException;
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // Pure JavaScript implementation of DOM Range
    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
        var dom = api.dom;
        var util = api.util;
        var DomPosition = dom.DomPosition;
        var DOMException = api.DOMException;

        var isCharacterDataNode = dom.isCharacterDataNode;
        var getNodeIndex = dom.getNodeIndex;
        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
        var getDocument = dom.getDocument;
        var comparePoints = dom.comparePoints;
        var splitDataNode = dom.splitDataNode;
        var getClosestAncestorIn = dom.getClosestAncestorIn;
        var getNodeLength = dom.getNodeLength;
        var arrayContains = dom.arrayContains;
        var getRootContainer = dom.getRootContainer;
        var crashyTextNodes = api.features.crashyTextNodes;

        var removeNode = dom.removeNode;

        /*----------------------------------------------------------------------------------------------------------------*/

        // Utility functions

        function isNonTextPartiallySelected(node, range) {
            return (node.nodeType != 3) &&
                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
        }

        function getRangeDocument(range) {
            return range.document || getDocument(range.startContainer);
        }

        function getRangeRoot(range) {
            return getRootContainer(range.startContainer);
        }

        function getBoundaryBeforeNode(node) {
            return new DomPosition(node.parentNode, getNodeIndex(node));
        }

        function getBoundaryAfterNode(node) {
            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
        }

        function insertNodeAtPosition(node, n, o) {
            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
            if (isCharacterDataNode(n)) {
                if (o == n.length) {
                    dom.insertAfter(node, n);
                } else {
                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
                }
            } else if (o >= n.childNodes.length) {
                n.appendChild(node);
            } else {
                n.insertBefore(node, n.childNodes[o]);
            }
            return firstNodeInserted;
        }

        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
            assertRangeValid(rangeA);
            assertRangeValid(rangeB);

            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }

            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        }

        function cloneSubtree(iterator) {
            var partiallySelected;
            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
                partiallySelected = iterator.isPartiallySelectedSubtree();
                node = node.cloneNode(!partiallySelected);
                if (partiallySelected) {
                    subIterator = iterator.getSubtreeIterator();
                    node.appendChild(cloneSubtree(subIterator));
                    subIterator.detach();
                }

                if (node.nodeType == 10) { // DocumentType
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }
                frag.appendChild(node);
            }
            return frag;
        }

        function iterateSubtree(rangeIterator, func, iteratorState) {
            var it, n;
            iteratorState = iteratorState || { stop: false };
            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
                if (rangeIterator.isPartiallySelectedSubtree()) {
                    if (func(node) === false) {
                        iteratorState.stop = true;
                        return;
                    } else {
                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
                        // the node selected by the Range.
                        subRangeIterator = rangeIterator.getSubtreeIterator();
                        iterateSubtree(subRangeIterator, func, iteratorState);
                        subRangeIterator.detach();
                        if (iteratorState.stop) {
                            return;
                        }
                    }
                } else {
                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
                    // descendants
                    it = dom.createIterator(node);
                    while ( (n = it.next()) ) {
                        if (func(n) === false) {
                            iteratorState.stop = true;
                            return;
                        }
                    }
                }
            }
        }

        function deleteSubtree(iterator) {
            var subIterator;
            while (iterator.next()) {
                if (iterator.isPartiallySelectedSubtree()) {
                    subIterator = iterator.getSubtreeIterator();
                    deleteSubtree(subIterator);
                    subIterator.detach();
                } else {
                    iterator.remove();
                }
            }
        }

        function extractSubtree(iterator) {
            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {

                if (iterator.isPartiallySelectedSubtree()) {
                    node = node.cloneNode(false);
                    subIterator = iterator.getSubtreeIterator();
                    node.appendChild(extractSubtree(subIterator));
                    subIterator.detach();
                } else {
                    iterator.remove();
                }
                if (node.nodeType == 10) { // DocumentType
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }
                frag.appendChild(node);
            }
            return frag;
        }

        function getNodesInRange(range, nodeTypes, filter) {
            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
            var filterExists = !!filter;
            if (filterNodeTypes) {
                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
            }

            var nodes = [];
            iterateSubtree(new RangeIterator(range, false), function(node) {
                if (filterNodeTypes && !regex.test(node.nodeType)) {
                    return;
                }
                if (filterExists && !filter(node)) {
                    return;
                }
                // Don't include a boundary container if it is a character data node and the range does not contain any
                // of its character data. See issue 190.
                var sc = range.startContainer;
                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
                    return;
                }

                var ec = range.endContainer;
                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
                    return;
                }

                nodes.push(node);
            });
            return nodes;
        }

        function inspect(range) {
            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)

        function RangeIterator(range, clonePartiallySelectedTextNodes) {
            this.range = range;
            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;


            if (!range.collapsed) {
                this.sc = range.startContainer;
                this.so = range.startOffset;
                this.ec = range.endContainer;
                this.eo = range.endOffset;
                var root = range.commonAncestorContainer;

                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
                    this.isSingleCharacterDataNode = true;
                    this._first = this._last = this._next = this.sc;
                } else {
                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
                }
            }
        }

        RangeIterator.prototype = {
            _current: null,
            _next: null,
            _first: null,
            _last: null,
            isSingleCharacterDataNode: false,

            reset: function() {
                this._current = null;
                this._next = this._first;
            },

            hasNext: function() {
                return !!this._next;
            },

            next: function() {
                // Move to next node
                var current = this._current = this._next;
                if (current) {
                    this._next = (current !== this._last) ? current.nextSibling : null;

                    // Check for partially selected text nodes
                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
                        if (current === this.ec) {
                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
                        }
                        if (this._current === this.sc) {
                            (current = current.cloneNode(true)).deleteData(0, this.so);
                        }
                    }
                }

                return current;
            },

            remove: function() {
                var current = this._current, start, end;

                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
                    start = (current === this.sc) ? this.so : 0;
                    end = (current === this.ec) ? this.eo : current.length;
                    if (start != end) {
                        current.deleteData(start, end - start);
                    }
                } else {
                    if (current.parentNode) {
                        removeNode(current);
                    } else {
                    }
                }
            },

            // Checks if the current node is partially selected
            isPartiallySelectedSubtree: function() {
                var current = this._current;
                return isNonTextPartiallySelected(current, this.range);
            },

            getSubtreeIterator: function() {
                var subRange;
                if (this.isSingleCharacterDataNode) {
                    subRange = this.range.cloneRange();
                    subRange.collapse(false);
                } else {
                    subRange = new Range(getRangeDocument(this.range));
                    var current = this._current;
                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);

                    if (isOrIsAncestorOf(current, this.sc)) {
                        startContainer = this.sc;
                        startOffset = this.so;
                    }
                    if (isOrIsAncestorOf(current, this.ec)) {
                        endContainer = this.ec;
                        endOffset = this.eo;
                    }

                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
                }
                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
            },

            detach: function() {
                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
            }
        };

        /*----------------------------------------------------------------------------------------------------------------*/

        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
        var rootContainerNodeTypes = [2, 9, 11];
        var readonlyNodeTypes = [5, 6, 10, 12];
        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];

        function createAncestorFinder(nodeTypes) {
            return function(node, selfIsAncestor) {
                var t, n = selfIsAncestor ? node : node.parentNode;
                while (n) {
                    t = n.nodeType;
                    if (arrayContains(nodeTypes, t)) {
                        return n;
                    }
                    n = n.parentNode;
                }
                return null;
            };
        }

        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );

        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
                throw new DOMException("INVALID_NODE_TYPE_ERR");
            }
        }

        function assertValidNodeType(node, invalidTypes) {
            if (!arrayContains(invalidTypes, node.nodeType)) {
                throw new DOMException("INVALID_NODE_TYPE_ERR");
            }
        }

        function assertValidOffset(node, offset) {
            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
                throw new DOMException("INDEX_SIZE_ERR");
            }
        }

        function assertSameDocumentOrFragment(node1, node2) {
            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }
        }

        function assertNodeNotReadOnly(node) {
            if (getReadonlyAncestor(node, true)) {
                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
            }
        }

        function assertNode(node, codeName) {
            if (!node) {
                throw new DOMException(codeName);
            }
        }

        function isValidOffset(node, offset) {
            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
        }

        function isRangeValid(range) {
            return (!!range.startContainer && !!range.endContainer &&
                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
                    isValidOffset(range.startContainer, range.startOffset) &&
                    isValidOffset(range.endContainer, range.endOffset));
        }

        function assertRangeValid(range) {
            if (!isRangeValid(range)) {
                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
            }
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Test the browser's innerHTML support to decide how to implement createContextualFragment
        var styleEl = document.createElement("style");
        var htmlParsingConforms = false;
        try {
            styleEl.innerHTML = "<b>x</b>";
            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
        } catch (e) {
            // IE 6 and 7 throw
        }

        api.features.htmlParsingConforms = htmlParsingConforms;

        var createContextualFragment = htmlParsingConforms ?

            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
            // discussion and base code for this implementation at issue 67.
            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
            // Thanks to Aleks Williams.
            function(fragmentStr) {
                // "Let node the context object's start's node."
                var node = this.startContainer;
                var doc = getDocument(node);

                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
                // exception and abort these steps."
                if (!node) {
                    throw new DOMException("INVALID_STATE_ERR");
                }

                // "Let element be as follows, depending on node's interface:"
                // Document, Document Fragment: null
                var el = null;

                // "Element: node"
                if (node.nodeType == 1) {
                    el = node;

                // "Text, Comment: node's parentElement"
                } else if (isCharacterDataNode(node)) {
                    el = dom.parentElement(node);
                }

                // "If either element is null or element's ownerDocument is an HTML document
                // and element's local name is "html" and element's namespace is the HTML
                // namespace"
                if (el === null || (
                    el.nodeName == "HTML" &&
                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
                    dom.isHtmlNamespace(el)
                )) {

                // "let element be a new Element with "body" as its local name and the HTML
                // namespace as its namespace.""
                    el = doc.createElement("body");
                } else {
                    el = el.cloneNode(false);
                }

                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
                // "In either case, the algorithm must be invoked with fragment as the input
                // and element as the context element."
                el.innerHTML = fragmentStr;

                // "If this raises an exception, then abort these steps. Otherwise, let new
                // children be the nodes returned."

                // "Let fragment be a new DocumentFragment."
                // "Append all new children to fragment."
                // "Return fragment."
                return dom.fragmentFromNodeChildren(el);
            } :

            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
            // previous versions of Rangy used (with the exception of using a body element rather than a div)
            function(fragmentStr) {
                var doc = getRangeDocument(this);
                var el = doc.createElement("body");
                el.innerHTML = fragmentStr;

                return dom.fragmentFromNodeChildren(el);
            };

        function splitRangeBoundaries(range, positionsToPreserve) {
            assertRangeValid(range);

            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
            var startEndSame = (sc === ec);

            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
                splitDataNode(ec, eo, positionsToPreserve);
            }

            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
                sc = splitDataNode(sc, so, positionsToPreserve);
                if (startEndSame) {
                    eo -= so;
                    ec = sc;
                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
                    eo++;
                }
                so = 0;
            }
            range.setStartAndEnd(sc, so, ec, eo);
        }

        function rangeToHtml(range) {
            assertRangeValid(range);
            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
            container.appendChild( range.cloneContents() );
            return container.innerHTML;
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
            "commonAncestorContainer"];

        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;

        util.extend(api.rangePrototype, {
            compareBoundaryPoints: function(how, range) {
                assertRangeValid(this);
                assertSameDocumentOrFragment(this.startContainer, range.startContainer);

                var nodeA, offsetA, nodeB, offsetB;
                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
                nodeA = this[prefixA + "Container"];
                offsetA = this[prefixA + "Offset"];
                nodeB = range[prefixB + "Container"];
                offsetB = range[prefixB + "Offset"];
                return comparePoints(nodeA, offsetA, nodeB, offsetB);
            },

            insertNode: function(node) {
                assertRangeValid(this);
                assertValidNodeType(node, insertableNodeTypes);
                assertNodeNotReadOnly(this.startContainer);

                if (isOrIsAncestorOf(node, this.startContainer)) {
                    throw new DOMException("HIERARCHY_REQUEST_ERR");
                }

                // No check for whether the container of the start of the Range is of a type that does not allow
                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
                // to add the node

                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
                this.setStartBefore(firstNodeInserted);
            },

            cloneContents: function() {
                assertRangeValid(this);

                var clone, frag;
                if (this.collapsed) {
                    return getRangeDocument(this).createDocumentFragment();
                } else {
                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
                        clone = this.startContainer.cloneNode(true);
                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
                        frag = getRangeDocument(this).createDocumentFragment();
                        frag.appendChild(clone);
                        return frag;
                    } else {
                        var iterator = new RangeIterator(this, true);
                        clone = cloneSubtree(iterator);
                        iterator.detach();
                    }
                    return clone;
                }
            },

            canSurroundContents: function() {
                assertRangeValid(this);
                assertNodeNotReadOnly(this.startContainer);
                assertNodeNotReadOnly(this.endContainer);

                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                // no non-text nodes.
                var iterator = new RangeIterator(this, true);
                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                iterator.detach();
                return !boundariesInvalid;
            },

            surroundContents: function(node) {
                assertValidNodeType(node, surroundNodeTypes);

                if (!this.canSurroundContents()) {
                    throw new DOMException("INVALID_STATE_ERR");
                }

                // Extract the contents
                var content = this.extractContents();

                // Clear the children of the node
                if (node.hasChildNodes()) {
                    while (node.lastChild) {
                        node.removeChild(node.lastChild);
                    }
                }

                // Insert the new node and add the extracted contents
                insertNodeAtPosition(node, this.startContainer, this.startOffset);
                node.appendChild(content);

                this.selectNode(node);
            },

            cloneRange: function() {
                assertRangeValid(this);
                var range = new Range(getRangeDocument(this));
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = this[prop];
                }
                return range;
            },

            toString: function() {
                assertRangeValid(this);
                var sc = this.startContainer;
                if (sc === this.endContainer && isCharacterDataNode(sc)) {
                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
                } else {
                    var textParts = [], iterator = new RangeIterator(this, true);
                    iterateSubtree(iterator, function(node) {
                        // Accept only text or CDATA nodes, not comments
                        if (node.nodeType == 3 || node.nodeType == 4) {
                            textParts.push(node.data);
                        }
                    });
                    iterator.detach();
                    return textParts.join("");
                }
            },

            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
            // been removed from Mozilla.

            compareNode: function(node) {
                assertRangeValid(this);

                var parent = node.parentNode;
                var nodeIndex = getNodeIndex(node);

                if (!parent) {
                    throw new DOMException("NOT_FOUND_ERR");
                }

                var startComparison = this.comparePoint(parent, nodeIndex),
                    endComparison = this.comparePoint(parent, nodeIndex + 1);

                if (startComparison < 0) { // Node starts before
                    return (endComparison > 0) ? n_b_a : n_b;
                } else {
                    return (endComparison > 0) ? n_a : n_i;
                }
            },

            comparePoint: function(node, offset) {
                assertRangeValid(this);
                assertNode(node, "HIERARCHY_REQUEST_ERR");
                assertSameDocumentOrFragment(node, this.startContainer);

                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
                    return -1;
                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
                    return 1;
                }
                return 0;
            },

            createContextualFragment: createContextualFragment,

            toHtml: function() {
                return rangeToHtml(this);
            },

            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
            intersectsNode: function(node, touchingIsIntersecting) {
                assertRangeValid(this);
                if (getRootContainer(node) != getRangeRoot(this)) {
                    return false;
                }

                var parent = node.parentNode, offset = getNodeIndex(node);
                if (!parent) {
                    return true;
                }

                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);

                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
            },

            isPointInRange: function(node, offset) {
                assertRangeValid(this);
                assertNode(node, "HIERARCHY_REQUEST_ERR");
                assertSameDocumentOrFragment(node, this.startContainer);

                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
            },

            // The methods below are non-standard and invented by me.

            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
            intersectsRange: function(range) {
                return rangesIntersect(this, range, false);
            },

            // Sharing a boundary start-to-end or end-to-start does count as intersection.
            intersectsOrTouchesRange: function(range) {
                return rangesIntersect(this, range, true);
            },

            intersection: function(range) {
                if (this.intersectsRange(range)) {
                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);

                    var intersectionRange = this.cloneRange();
                    if (startComparison == -1) {
                        intersectionRange.setStart(range.startContainer, range.startOffset);
                    }
                    if (endComparison == 1) {
                        intersectionRange.setEnd(range.endContainer, range.endOffset);
                    }
                    return intersectionRange;
                }
                return null;
            },

            union: function(range) {
                if (this.intersectsOrTouchesRange(range)) {
                    var unionRange = this.cloneRange();
                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
                        unionRange.setStart(range.startContainer, range.startOffset);
                    }
                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
                        unionRange.setEnd(range.endContainer, range.endOffset);
                    }
                    return unionRange;
                } else {
                    throw new DOMException("Ranges do not intersect");
                }
            },

            containsNode: function(node, allowPartial) {
                if (allowPartial) {
                    return this.intersectsNode(node, false);
                } else {
                    return this.compareNode(node) == n_i;
                }
            },

            containsNodeContents: function(node) {
                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
            },

            containsRange: function(range) {
                var intersection = this.intersection(range);
                return intersection !== null && range.equals(intersection);
            },

            containsNodeText: function(node) {
                var nodeRange = this.cloneRange();
                nodeRange.selectNode(node);
                var textNodes = nodeRange.getNodes([3]);
                if (textNodes.length > 0) {
                    nodeRange.setStart(textNodes[0], 0);
                    var lastTextNode = textNodes.pop();
                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
                    return this.containsRange(nodeRange);
                } else {
                    return this.containsNodeContents(node);
                }
            },

            getNodes: function(nodeTypes, filter) {
                assertRangeValid(this);
                return getNodesInRange(this, nodeTypes, filter);
            },

            getDocument: function() {
                return getRangeDocument(this);
            },

            collapseBefore: function(node) {
                this.setEndBefore(node);
                this.collapse(false);
            },

            collapseAfter: function(node) {
                this.setStartAfter(node);
                this.collapse(true);
            },

            getBookmark: function(containerNode) {
                var doc = getRangeDocument(this);
                var preSelectionRange = api.createRange(doc);
                containerNode = containerNode || dom.getBody(doc);
                preSelectionRange.selectNodeContents(containerNode);
                var range = this.intersection(preSelectionRange);
                var start = 0, end = 0;
                if (range) {
                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
                    start = preSelectionRange.toString().length;
                    end = start + range.toString().length;
                }

                return {
                    start: start,
                    end: end,
                    containerNode: containerNode
                };
            },

            moveToBookmark: function(bookmark) {
                var containerNode = bookmark.containerNode;
                var charIndex = 0;
                this.setStart(containerNode, 0);
                this.collapse(true);
                var nodeStack = [containerNode], node, foundStart = false, stop = false;
                var nextCharIndex, i, childNodes;

                while (!stop && (node = nodeStack.pop())) {
                    if (node.nodeType == 3) {
                        nextCharIndex = charIndex + node.length;
                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
                            this.setStart(node, bookmark.start - charIndex);
                            foundStart = true;
                        }
                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
                            this.setEnd(node, bookmark.end - charIndex);
                            stop = true;
                        }
                        charIndex = nextCharIndex;
                    } else {
                        childNodes = node.childNodes;
                        i = childNodes.length;
                        while (i--) {
                            nodeStack.push(childNodes[i]);
                        }
                    }
                }
            },

            getName: function() {
                return "DomRange";
            },

            equals: function(range) {
                return Range.rangesEqual(this, range);
            },

            isValid: function() {
                return isRangeValid(this);
            },

            inspect: function() {
                return inspect(this);
            },

            detach: function() {
                // In DOM4, detach() is now a no-op.
            }
        });

        function copyComparisonConstantsToObject(obj) {
            obj.START_TO_START = s2s;
            obj.START_TO_END = s2e;
            obj.END_TO_END = e2e;
            obj.END_TO_START = e2s;

            obj.NODE_BEFORE = n_b;
            obj.NODE_AFTER = n_a;
            obj.NODE_BEFORE_AND_AFTER = n_b_a;
            obj.NODE_INSIDE = n_i;
        }

        function copyComparisonConstants(constructor) {
            copyComparisonConstantsToObject(constructor);
            copyComparisonConstantsToObject(constructor.prototype);
        }

        function createRangeContentRemover(remover, boundaryUpdater) {
            return function() {
                assertRangeValid(this);

                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;

                var iterator = new RangeIterator(this, true);

                // Work out where to position the range after content removal
                var node, boundary;
                if (sc !== root) {
                    node = getClosestAncestorIn(sc, root, true);
                    boundary = getBoundaryAfterNode(node);
                    sc = boundary.node;
                    so = boundary.offset;
                }

                // Check none of the range is read-only
                iterateSubtree(iterator, assertNodeNotReadOnly);

                iterator.reset();

                // Remove the content
                var returnValue = remover(iterator);
                iterator.detach();

                // Move to the new position
                boundaryUpdater(this, sc, so, sc, so);

                return returnValue;
            };
        }

        function createPrototypeRange(constructor, boundaryUpdater) {
            function createBeforeAfterNodeSetter(isBefore, isStart) {
                return function(node) {
                    assertValidNodeType(node, beforeAfterNodeTypes);
                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);

                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
                };
            }

            function setRangeStart(range, node, offset) {
                var ec = range.endContainer, eo = range.endOffset;
                if (node !== range.startContainer || offset !== range.startOffset) {
                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
                    // is after the current end. In either case, collapse the range to the new position
                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
                        ec = node;
                        eo = offset;
                    }
                    boundaryUpdater(range, node, offset, ec, eo);
                }
            }

            function setRangeEnd(range, node, offset) {
                var sc = range.startContainer, so = range.startOffset;
                if (node !== range.endContainer || offset !== range.endOffset) {
                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
                    // is after the current end. In either case, collapse the range to the new position
                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
                        sc = node;
                        so = offset;
                    }
                    boundaryUpdater(range, sc, so, node, offset);
                }
            }

            // Set up inheritance
            var F = function() {};
            F.prototype = api.rangePrototype;
            constructor.prototype = new F();

            util.extend(constructor.prototype, {
                setStart: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);

                    setRangeStart(this, node, offset);
                },

                setEnd: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);

                    setRangeEnd(this, node, offset);
                },

                /**
                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
                 * - Two parameters (node, offset) creates a collapsed range at that position
                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
                 *   startOffset and ending at endOffset
                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
                 *   startNode and ending at endOffset in endNode
                 */
                setStartAndEnd: function() {
                    var args = arguments;
                    var sc = args[0], so = args[1], ec = sc, eo = so;

                    switch (args.length) {
                        case 3:
                            eo = args[2];
                            break;
                        case 4:
                            ec = args[2];
                            eo = args[3];
                            break;
                    }

                    boundaryUpdater(this, sc, so, ec, eo);
                },

                setBoundary: function(node, offset, isStart) {
                    this["set" + (isStart ? "Start" : "End")](node, offset);
                },

                setStartBefore: createBeforeAfterNodeSetter(true, true),
                setStartAfter: createBeforeAfterNodeSetter(false, true),
                setEndBefore: createBeforeAfterNodeSetter(true, false),
                setEndAfter: createBeforeAfterNodeSetter(false, false),

                collapse: function(isStart) {
                    assertRangeValid(this);
                    if (isStart) {
                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
                    } else {
                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
                    }
                },

                selectNodeContents: function(node) {
                    assertNoDocTypeNotationEntityAncestor(node, true);

                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
                },

                selectNode: function(node) {
                    assertNoDocTypeNotationEntityAncestor(node, false);
                    assertValidNodeType(node, beforeAfterNodeTypes);

                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
                },

                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),

                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),

                canSurroundContents: function() {
                    assertRangeValid(this);
                    assertNodeNotReadOnly(this.startContainer);
                    assertNodeNotReadOnly(this.endContainer);

                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                    // no non-text nodes.
                    var iterator = new RangeIterator(this, true);
                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                    iterator.detach();
                    return !boundariesInvalid;
                },

                splitBoundaries: function() {
                    splitRangeBoundaries(this);
                },

                splitBoundariesPreservingPositions: function(positionsToPreserve) {
                    splitRangeBoundaries(this, positionsToPreserve);
                },

                normalizeBoundaries: function() {
                    assertRangeValid(this);

                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;

                    var mergeForward = function(node) {
                        var sibling = node.nextSibling;
                        if (sibling && sibling.nodeType == node.nodeType) {
                            ec = node;
                            eo = node.length;
                            node.appendData(sibling.data);
                            removeNode(sibling);
                        }
                    };

                    var mergeBackward = function(node) {
                        var sibling = node.previousSibling;
                        if (sibling && sibling.nodeType == node.nodeType) {
                            sc = node;
                            var nodeLength = node.length;
                            so = sibling.length;
                            node.insertData(0, sibling.data);
                            removeNode(sibling);
                            if (sc == ec) {
                                eo += so;
                                ec = sc;
                            } else if (ec == node.parentNode) {
                                var nodeIndex = getNodeIndex(node);
                                if (eo == nodeIndex) {
                                    ec = node;
                                    eo = nodeLength;
                                } else if (eo > nodeIndex) {
                                    eo--;
                                }
                            }
                        }
                    };

                    var normalizeStart = true;
                    var sibling;

                    if (isCharacterDataNode(ec)) {
                        if (eo == ec.length) {
                            mergeForward(ec);
                        } else if (eo == 0) {
                            sibling = ec.previousSibling;
                            if (sibling && sibling.nodeType == ec.nodeType) {
                                eo = sibling.length;
                                if (sc == ec) {
                                    normalizeStart = false;
                                }
                                sibling.appendData(ec.data);
                                removeNode(ec);
                                ec = sibling;
                            }
                        }
                    } else {
                        if (eo > 0) {
                            var endNode = ec.childNodes[eo - 1];
                            if (endNode && isCharacterDataNode(endNode)) {
                                mergeForward(endNode);
                            }
                        }
                        normalizeStart = !this.collapsed;
                    }

                    if (normalizeStart) {
                        if (isCharacterDataNode(sc)) {
                            if (so == 0) {
                                mergeBackward(sc);
                            } else if (so == sc.length) {
                                sibling = sc.nextSibling;
                                if (sibling && sibling.nodeType == sc.nodeType) {
                                    if (ec == sibling) {
                                        ec = sc;
                                        eo += sc.length;
                                    }
                                    sc.appendData(sibling.data);
                                    removeNode(sibling);
                                }
                            }
                        } else {
                            if (so < sc.childNodes.length) {
                                var startNode = sc.childNodes[so];
                                if (startNode && isCharacterDataNode(startNode)) {
                                    mergeBackward(startNode);
                                }
                            }
                        }
                    } else {
                        sc = ec;
                        so = eo;
                    }

                    boundaryUpdater(this, sc, so, ec, eo);
                },

                collapseToPoint: function(node, offset) {
                    assertNoDocTypeNotationEntityAncestor(node, true);
                    assertValidOffset(node, offset);
                    this.setStartAndEnd(node, offset);
                }
            });

            copyComparisonConstants(constructor);
        }

        /*----------------------------------------------------------------------------------------------------------------*/

        // Updates commonAncestorContainer and collapsed after boundary change
        function updateCollapsedAndCommonAncestor(range) {
            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
            range.commonAncestorContainer = range.collapsed ?
                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
        }

        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
            range.startContainer = startContainer;
            range.startOffset = startOffset;
            range.endContainer = endContainer;
            range.endOffset = endOffset;
            range.document = dom.getDocument(startContainer);

            updateCollapsedAndCommonAncestor(range);
        }

        function Range(doc) {
            this.startContainer = doc;
            this.startOffset = 0;
            this.endContainer = doc;
            this.endOffset = 0;
            this.document = doc;
            updateCollapsedAndCommonAncestor(this);
        }

        createPrototypeRange(Range, updateBoundaries);

        util.extend(Range, {
            rangeProperties: rangeProperties,
            RangeIterator: RangeIterator,
            copyComparisonConstants: copyComparisonConstants,
            createPrototypeRange: createPrototypeRange,
            inspect: inspect,
            toHtml: rangeToHtml,
            getRangeDocument: getRangeDocument,
            rangesEqual: function(r1, r2) {
                return r1.startContainer === r2.startContainer &&
                    r1.startOffset === r2.startOffset &&
                    r1.endContainer === r2.endContainer &&
                    r1.endOffset === r2.endOffset;
            }
        });

        api.DomRange = Range;
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wrappers for the browser's native DOM Range and/or TextRange implementation
    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
        var WrappedRange, WrappedTextRange;
        var dom = api.dom;
        var util = api.util;
        var DomPosition = dom.DomPosition;
        var DomRange = api.DomRange;
        var getBody = dom.getBody;
        var getContentDocument = dom.getContentDocument;
        var isCharacterDataNode = dom.isCharacterDataNode;


        /*----------------------------------------------------------------------------------------------------------------*/

        if (api.features.implementsDomRange) {
            // This is a wrapper around the browser's native DOM Range. It has two aims:
            // - Provide workarounds for specific browser bugs
            // - provide convenient extensions, which are inherited from Rangy's DomRange

            (function() {
                var rangeProto;
                var rangeProperties = DomRange.rangeProperties;

                function updateRangeProperties(range) {
                    var i = rangeProperties.length, prop;
                    while (i--) {
                        prop = rangeProperties[i];
                        range[prop] = range.nativeRange[prop];
                    }
                    // Fix for broken collapsed property in IE 9.
                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
                }

                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
                    var nativeRangeDifferent = !range.equals(range.nativeRange);

                    // Always set both boundaries for the benefit of IE9 (see issue 35)
                    if (startMoved || endMoved || nativeRangeDifferent) {
                        range.setEnd(endContainer, endOffset);
                        range.setStart(startContainer, startOffset);
                    }
                }

                var createBeforeAfterNodeSetter;

                WrappedRange = function(range) {
                    if (!range) {
                        throw module.createError("WrappedRange: Range must be specified");
                    }
                    this.nativeRange = range;
                    updateRangeProperties(this);
                };

                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);

                rangeProto = WrappedRange.prototype;

                rangeProto.selectNode = function(node) {
                    this.nativeRange.selectNode(node);
                    updateRangeProperties(this);
                };

                rangeProto.cloneContents = function() {
                    return this.nativeRange.cloneContents();
                };

                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
                // insertNode() is never delegated to the native range.

                rangeProto.surroundContents = function(node) {
                    this.nativeRange.surroundContents(node);
                    updateRangeProperties(this);
                };

                rangeProto.collapse = function(isStart) {
                    this.nativeRange.collapse(isStart);
                    updateRangeProperties(this);
                };

                rangeProto.cloneRange = function() {
                    return new WrappedRange(this.nativeRange.cloneRange());
                };

                rangeProto.refresh = function() {
                    updateRangeProperties(this);
                };

                rangeProto.toString = function() {
                    return this.nativeRange.toString();
                };

                // Create test range and node for feature detection

                var testTextNode = document.createTextNode("test");
                getBody(document).appendChild(testTextNode);
                var range = document.createRange();

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
                // correct for it

                range.setStart(testTextNode, 0);
                range.setEnd(testTextNode, 0);

                try {
                    range.setStart(testTextNode, 1);

                    rangeProto.setStart = function(node, offset) {
                        this.nativeRange.setStart(node, offset);
                        updateRangeProperties(this);
                    };

                    rangeProto.setEnd = function(node, offset) {
                        this.nativeRange.setEnd(node, offset);
                        updateRangeProperties(this);
                    };

                    createBeforeAfterNodeSetter = function(name) {
                        return function(node) {
                            this.nativeRange[name](node);
                            updateRangeProperties(this);
                        };
                    };

                } catch(ex) {

                    rangeProto.setStart = function(node, offset) {
                        try {
                            this.nativeRange.setStart(node, offset);
                        } catch (ex) {
                            this.nativeRange.setEnd(node, offset);
                            this.nativeRange.setStart(node, offset);
                        }
                        updateRangeProperties(this);
                    };

                    rangeProto.setEnd = function(node, offset) {
                        try {
                            this.nativeRange.setEnd(node, offset);
                        } catch (ex) {
                            this.nativeRange.setStart(node, offset);
                            this.nativeRange.setEnd(node, offset);
                        }
                        updateRangeProperties(this);
                    };

                    createBeforeAfterNodeSetter = function(name, oppositeName) {
                        return function(node) {
                            try {
                                this.nativeRange[name](node);
                            } catch (ex) {
                                this.nativeRange[oppositeName](node);
                                this.nativeRange[name](node);
                            }
                            updateRangeProperties(this);
                        };
                    };
                }

                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");

                /*--------------------------------------------------------------------------------------------------------*/

                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
                // whether the native implementation can be trusted
                rangeProto.selectNodeContents = function(node) {
                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
                };

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738

                range.selectNodeContents(testTextNode);
                range.setEnd(testTextNode, 3);

                var range2 = document.createRange();
                range2.selectNodeContents(testTextNode);
                range2.setEnd(testTextNode, 4);
                range2.setStart(testTextNode, 2);

                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
                    // This is the wrong way round, so correct for it

                    rangeProto.compareBoundaryPoints = function(type, range) {
                        range = range.nativeRange || range;
                        if (type == range.START_TO_END) {
                            type = range.END_TO_START;
                        } else if (type == range.END_TO_START) {
                            type = range.START_TO_END;
                        }
                        return this.nativeRange.compareBoundaryPoints(type, range);
                    };
                } else {
                    rangeProto.compareBoundaryPoints = function(type, range) {
                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
                    };
                }

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.

                var el = document.createElement("div");
                el.innerHTML = "123";
                var textNode = el.firstChild;
                var body = getBody(document);
                body.appendChild(el);

                range.setStart(textNode, 1);
                range.setEnd(textNode, 2);
                range.deleteContents();

                if (textNode.data == "13") {
                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
                    // extractContents()
                    rangeProto.deleteContents = function() {
                        this.nativeRange.deleteContents();
                        updateRangeProperties(this);
                    };

                    rangeProto.extractContents = function() {
                        var frag = this.nativeRange.extractContents();
                        updateRangeProperties(this);
                        return frag;
                    };
                } else {
                }

                body.removeChild(el);
                body = null;

                /*--------------------------------------------------------------------------------------------------------*/

                // Test for existence of createContextualFragment and delegate to it if it exists
                if (util.isHostMethod(range, "createContextualFragment")) {
                    rangeProto.createContextualFragment = function(fragmentStr) {
                        return this.nativeRange.createContextualFragment(fragmentStr);
                    };
                }

                /*--------------------------------------------------------------------------------------------------------*/

                // Clean up
                getBody(document).removeChild(testTextNode);

                rangeProto.getName = function() {
                    return "WrappedRange";
                };

                api.WrappedRange = WrappedRange;

                api.createNativeRange = function(doc) {
                    doc = getContentDocument(doc, module, "createNativeRange");
                    return doc.createRange();
                };
            })();
        }

        if (api.features.implementsTextRange) {
            /*
            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
            method. For example, in the following (where pipes denote the selection boundaries):

            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>

            var range = document.selection.createRange();
            alert(range.parentElement().id); // Should alert "ul" but alerts "b"

            This method returns the common ancestor node of the following:
            - the parentElement() of the textRange
            - the parentElement() of the textRange after calling collapse(true)
            - the parentElement() of the textRange after calling collapse(false)
            */
            var getTextRangeContainerElement = function(textRange) {
                var parentEl = textRange.parentElement();
                var range = textRange.duplicate();
                range.collapse(true);
                var startEl = range.parentElement();
                range = textRange.duplicate();
                range.collapse(false);
                var endEl = range.parentElement();
                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);

                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
            };

            var textRangeIsCollapsed = function(textRange) {
                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
            };

            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
            // bugs, handling for inputs and images, plus optimizations.
            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
                var workingRange = textRange.duplicate();
                workingRange.collapse(isStart);
                var containerElement = workingRange.parentElement();

                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
                // check for that
                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
                    containerElement = wholeRangeContainerElement;
                }


                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
                if (!containerElement.canHaveHTML) {
                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
                    return {
                        boundaryPosition: pos,
                        nodeInfo: {
                            nodeIndex: pos.offset,
                            containerElement: pos.node
                        }
                    };
                }

                var workingNode = dom.getDocument(containerElement).createElement("span");

                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
                if (workingNode.parentNode) {
                    dom.removeNode(workingNode);
                }

                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
                var previousNode, nextNode, boundaryPosition, boundaryNode;
                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
                var childNodeCount = containerElement.childNodes.length;
                var end = childNodeCount;

                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
                // after the range boundary.
                var nodeIndex = end;

                while (true) {
                    if (nodeIndex == childNodeCount) {
                        containerElement.appendChild(workingNode);
                    } else {
                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
                    }
                    workingRange.moveToElementText(workingNode);
                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
                    if (comparison == 0 || start == end) {
                        break;
                    } else if (comparison == -1) {
                        if (end == start + 1) {
                            // We know the endth child node is after the range boundary, so we must be done.
                            break;
                        } else {
                            start = nodeIndex;
                        }
                    } else {
                        end = (end == start + 1) ? start : nodeIndex;
                    }
                    nodeIndex = Math.floor((start + end) / 2);
                    containerElement.removeChild(workingNode);
                }


                // We've now reached or gone past the boundary of the text range we're interested in
                // so have identified the node we want
                boundaryNode = workingNode.nextSibling;

                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
                    // the node containing the text range's boundary, so we move the end of the working range to the
                    // boundary point and measure the length of its text to get the boundary's offset within the node.
                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);

                    var offset;

                    if (/[\r\n]/.test(boundaryNode.data)) {
                        /*
                        For the particular case of a boundary within a text node containing rendered line breaks (within a
                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
                        IE. The facts:

                        - Each line break is represented as \r in the text node's data/nodeValue properties
                        - Each line break is represented as \r\n in the TextRange's 'text' property
                        - The 'text' property of the TextRange does not contain trailing line breaks

                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
                        to use this to store the characters moved when moving both the start and end of the range to the
                        start of the document body and subtracting the start offset from the end offset (the
                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
                        the end of the document) has the same problem.

                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
                        end boundary one character at a time and incrementing a counter with the value returned by the
                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
                        by the location of the range within the document).

                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
                        be longer than the text of the TextRange, so the start of the range is moved that length initially
                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
                        property. This has good performance in most situations compared to the previous two methods.
                        */
                        var tempRange = workingRange.duplicate();
                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;

                        offset = tempRange.moveStart("character", rangeLength);
                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
                            offset++;
                            tempRange.moveStart("character", 1);
                        }
                    } else {
                        offset = workingRange.text.length;
                    }
                    boundaryPosition = new DomPosition(boundaryNode, offset);
                } else {

                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
                    // a position within that, and likewise for a start boundary preceding a character data node
                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
                    if (nextNode && isCharacterDataNode(nextNode)) {
                        boundaryPosition = new DomPosition(nextNode, 0);
                    } else if (previousNode && isCharacterDataNode(previousNode)) {
                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
                    } else {
                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
                    }
                }

                // Clean up
                dom.removeNode(workingNode);

                return {
                    boundaryPosition: boundaryPosition,
                    nodeInfo: {
                        nodeIndex: nodeIndex,
                        containerElement: containerElement
                    }
                };
            };

            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
            // (http://code.google.com/p/ierange/)
            var createBoundaryTextRange = function(boundaryPosition, isStart) {
                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
                var doc = dom.getDocument(boundaryPosition.node);
                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);

                if (nodeIsDataNode) {
                    boundaryNode = boundaryPosition.node;
                    boundaryParent = boundaryNode.parentNode;
                } else {
                    childNodes = boundaryPosition.node.childNodes;
                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
                    boundaryParent = boundaryPosition.node;
                }

                // Position the range immediately before the node containing the boundary
                workingNode = doc.createElement("span");

                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
                // the element rather than immediately before or after it
                workingNode.innerHTML = "&#feff;";

                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
                if (boundaryNode) {
                    boundaryParent.insertBefore(workingNode, boundaryNode);
                } else {
                    boundaryParent.appendChild(workingNode);
                }

                workingRange.moveToElementText(workingNode);
                workingRange.collapse(!isStart);

                // Clean up
                boundaryParent.removeChild(workingNode);

                // Move the working range to the text offset, if required
                if (nodeIsDataNode) {
                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
                }

                return workingRange;
            };

            /*------------------------------------------------------------------------------------------------------------*/

            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
            // prototype

            WrappedTextRange = function(textRange) {
                this.textRange = textRange;
                this.refresh();
            };

            WrappedTextRange.prototype = new DomRange(document);

            WrappedTextRange.prototype.refresh = function() {
                var start, end, startBoundary;

                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
                var rangeContainerElement = getTextRangeContainerElement(this.textRange);

                if (textRangeIsCollapsed(this.textRange)) {
                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
                        true).boundaryPosition;
                } else {
                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
                    start = startBoundary.boundaryPosition;

                    // An optimization used here is that if the start and end boundaries have the same parent element, the
                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
                    // the start boundary
                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
                        startBoundary.nodeInfo).boundaryPosition;
                }

                this.setStart(start.node, start.offset);
                this.setEnd(end.node, end.offset);
            };

            WrappedTextRange.prototype.getName = function() {
                return "WrappedTextRange";
            };

            DomRange.copyComparisonConstants(WrappedTextRange);

            var rangeToTextRange = function(range) {
                if (range.collapsed) {
                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                } else {
                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
                    textRange.setEndPoint("StartToStart", startRange);
                    textRange.setEndPoint("EndToEnd", endRange);
                    return textRange;
                }
            };

            WrappedTextRange.rangeToTextRange = rangeToTextRange;

            WrappedTextRange.prototype.toTextRange = function() {
                return rangeToTextRange(this);
            };

            api.WrappedTextRange = WrappedTextRange;

            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
            // implementation to use by default.
            if (!api.features.implementsDomRange || api.config.preferTextRange) {
                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
                var globalObj = (function(f) { return f("return this;")(); })(Function);
                if (typeof globalObj.Range == "undefined") {
                    globalObj.Range = WrappedTextRange;
                }

                api.createNativeRange = function(doc) {
                    doc = getContentDocument(doc, module, "createNativeRange");
                    return getBody(doc).createTextRange();
                };

                api.WrappedRange = WrappedTextRange;
            }
        }

        api.createRange = function(doc) {
            doc = getContentDocument(doc, module, "createRange");
            return new api.WrappedRange(api.createNativeRange(doc));
        };

        api.createRangyRange = function(doc) {
            doc = getContentDocument(doc, module, "createRangyRange");
            return new DomRange(doc);
        };

        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");

        api.addShimListener(function(win) {
            var doc = win.document;
            if (typeof doc.createRange == "undefined") {
                doc.createRange = function() {
                    return api.createRange(doc);
                };
            }
            doc = win = null;
        });
    });

    /*----------------------------------------------------------------------------------------------------------------*/

    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
        api.config.checkSelectionRanges = true;

        var BOOLEAN = "boolean";
        var NUMBER = "number";
        var dom = api.dom;
        var util = api.util;
        var isHostMethod = util.isHostMethod;
        var DomRange = api.DomRange;
        var WrappedRange = api.WrappedRange;
        var DOMException = api.DOMException;
        var DomPosition = dom.DomPosition;
        var getNativeSelection;
        var selectionIsCollapsed;
        var features = api.features;
        var CONTROL = "Control";
        var getDocument = dom.getDocument;
        var getBody = dom.getBody;
        var rangesEqual = DomRange.rangesEqual;


        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
        // "forward" or "forwards") or a Boolean (true for backwards).
        function isDirectionBackward(dir) {
            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
        }

        function getWindow(win, methodName) {
            if (!win) {
                return window;
            } else if (dom.isWindow(win)) {
                return win;
            } else if (win instanceof WrappedSelection) {
                return win.win;
            } else {
                var doc = dom.getContentDocument(win, module, methodName);
                return dom.getWindow(doc);
            }
        }

        function getWinSelection(winParam) {
            return getWindow(winParam, "getWinSelection").getSelection();
        }

        function getDocSelection(winParam) {
            return getWindow(winParam, "getDocSelection").document.selection;
        }

        function winSelectionIsBackward(sel) {
            var backward = false;
            if (sel.anchorNode) {
                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
            }
            return backward;
        }

        // Test for the Range/TextRange and Selection features required
        // Test for ability to retrieve selection
        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
            implementsDocSelection = util.isHostObject(document, "selection");

        features.implementsWinGetSelection = implementsWinGetSelection;
        features.implementsDocSelection = implementsDocSelection;

        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);

        if (useDocumentSelection) {
            getNativeSelection = getDocSelection;
            api.isSelectionValid = function(winParam) {
                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;

                // Check whether the selection TextRange is actually contained within the correct document
                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
            };
        } else if (implementsWinGetSelection) {
            getNativeSelection = getWinSelection;
            api.isSelectionValid = function() {
                return true;
            };
        } else {
            module.fail("Neither document.selection or window.getSelection() detected.");
            return false;
        }

        api.getNativeSelection = getNativeSelection;

        var testSelection = getNativeSelection();

        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
        if (!testSelection) {
            module.fail("Native selection was null (possibly issue 138?)");
            return false;
        }

        var testRange = api.createNativeRange(document);
        var body = getBody(document);

        // Obtaining a range from a selection
        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);

        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;

        // Test for existence of native selection extend() method
        var selectionHasExtend = isHostMethod(testSelection, "extend");
        features.selectionHasExtend = selectionHasExtend;

        // Test if rangeCount exists
        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
        features.selectionHasRangeCount = selectionHasRangeCount;

        var selectionSupportsMultipleRanges = false;
        var collapsedNonEditableSelectionsSupported = true;

        var addRangeBackwardToNative = selectionHasExtend ?
            function(nativeSelection, range) {
                var doc = DomRange.getRangeDocument(range);
                var endRange = api.createRange(doc);
                endRange.collapseToPoint(range.endContainer, range.endOffset);
                nativeSelection.addRange(getNativeRange(endRange));
                nativeSelection.extend(range.startContainer, range.startOffset);
            } : null;

        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {

            (function() {
                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
                // performed on the current document's selection. See issue 109.

                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
                // will result in the selection direction begin reversed if the original selection was backwards and the
                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
                var sel = window.getSelection();
                if (sel) {
                    // Store the current selection
                    var originalSelectionRangeCount = sel.rangeCount;
                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
                    var originalSelectionRanges = [];
                    var originalSelectionBackward = winSelectionIsBackward(sel);
                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
                        originalSelectionRanges[i] = sel.getRangeAt(i);
                    }

                    // Create some test elements
                    var testEl = dom.createTestElement(document, "", false);
                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );

                    // Test whether the native selection will allow a collapsed selection within a non-editable element
                    var r1 = document.createRange();

                    r1.setStart(textNode, 1);
                    r1.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(r1);
                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
                    sel.removeAllRanges();

                    // Test whether the native selection is capable of supporting multiple ranges.
                    if (!selectionHasMultipleRanges) {
                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
                        // sniff. I'm not happy about it. See
                        // https://code.google.com/p/chromium/issues/detail?id=399791
                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
                            selectionSupportsMultipleRanges = false;
                        } else {
                            var r2 = r1.cloneRange();
                            r1.setStart(textNode, 0);
                            r2.setEnd(textNode, 3);
                            r2.setStart(textNode, 2);
                            sel.addRange(r1);
                            sel.addRange(r2);
                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
                        }
                    }

                    // Clean up
                    dom.removeNode(testEl);
                    sel.removeAllRanges();

                    for (i = 0; i < originalSelectionRangeCount; ++i) {
                        if (i == 0 && originalSelectionBackward) {
                            if (addRangeBackwardToNative) {
                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
                            } else {
                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
                                sel.addRange(originalSelectionRanges[i]);
                            }
                        } else {
                            sel.addRange(originalSelectionRanges[i]);
                        }
                    }
                }
            })();
        }

        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;

        // ControlRanges
        var implementsControlRange = false, testControlRange;

        if (body && isHostMethod(body, "createControlRange")) {
            testControlRange = body.createControlRange();
            if (util.areHostProperties(testControlRange, ["item", "add"])) {
                implementsControlRange = true;
            }
        }
        features.implementsControlRange = implementsControlRange;

        // Selection collapsedness
        if (selectionHasAnchorAndFocus) {
            selectionIsCollapsed = function(sel) {
                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
            };
        } else {
            selectionIsCollapsed = function(sel) {
                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
            };
        }

        function updateAnchorAndFocusFromRange(sel, range, backward) {
            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
            sel.anchorNode = range[anchorPrefix + "Container"];
            sel.anchorOffset = range[anchorPrefix + "Offset"];
            sel.focusNode = range[focusPrefix + "Container"];
            sel.focusOffset = range[focusPrefix + "Offset"];
        }

        function updateAnchorAndFocusFromNativeSelection(sel) {
            var nativeSel = sel.nativeSelection;
            sel.anchorNode = nativeSel.anchorNode;
            sel.anchorOffset = nativeSel.anchorOffset;
            sel.focusNode = nativeSel.focusNode;
            sel.focusOffset = nativeSel.focusOffset;
        }

        function updateEmptySelection(sel) {
            sel.anchorNode = sel.focusNode = null;
            sel.anchorOffset = sel.focusOffset = 0;
            sel.rangeCount = 0;
            sel.isCollapsed = true;
            sel._ranges.length = 0;
        }

        function getNativeRange(range) {
            var nativeRange;
            if (range instanceof DomRange) {
                nativeRange = api.createNativeRange(range.getDocument());
                nativeRange.setEnd(range.endContainer, range.endOffset);
                nativeRange.setStart(range.startContainer, range.startOffset);
            } else if (range instanceof WrappedRange) {
                nativeRange = range.nativeRange;
            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
                nativeRange = range;
            }
            return nativeRange;
        }

        function rangeContainsSingleElement(rangeNodes) {
            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
                return false;
            }
            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
                    return false;
                }
            }
            return true;
        }

        function getSingleElementFromRange(range) {
            var nodes = range.getNodes();
            if (!rangeContainsSingleElement(nodes)) {
                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
            }
            return nodes[0];
        }

        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
        function isTextRange(range) {
            return !!range && typeof range.text != "undefined";
        }

        function updateFromTextRange(sel, range) {
            // Create a Range from the selected TextRange
            var wrappedRange = new WrappedRange(range);
            sel._ranges = [wrappedRange];

            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
            sel.rangeCount = 1;
            sel.isCollapsed = wrappedRange.collapsed;
        }

        function updateControlSelection(sel) {
            // Update the wrapped selection based on what's now in the native selection
            sel._ranges.length = 0;
            if (sel.docSelection.type == "None") {
                updateEmptySelection(sel);
            } else {
                var controlRange = sel.docSelection.createRange();
                if (isTextRange(controlRange)) {
                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
                    // ControlRange have been removed from the ControlRange and removed from the document.
                    updateFromTextRange(sel, controlRange);
                } else {
                    sel.rangeCount = controlRange.length;
                    var range, doc = getDocument(controlRange.item(0));
                    for (var i = 0; i < sel.rangeCount; ++i) {
                        range = api.createRange(doc);
                        range.selectNode(controlRange.item(i));
                        sel._ranges.push(range);
                    }
                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
                }
            }
        }

        function addRangeToControlSelection(sel, range) {
            var controlRange = sel.docSelection.createRange();
            var rangeElement = getSingleElementFromRange(range);

            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
            // contained by the supplied range
            var doc = getDocument(controlRange.item(0));
            var newControlRange = getBody(doc).createControlRange();
            for (var i = 0, len = controlRange.length; i < len; ++i) {
                newControlRange.add(controlRange.item(i));
            }
            try {
                newControlRange.add(rangeElement);
            } catch (ex) {
                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
            }
            newControlRange.select();

            // Update the wrapped selection based on what's now in the native selection
            updateControlSelection(sel);
        }

        var getSelectionRangeAt;

        if (isHostMethod(testSelection, "getRangeAt")) {
            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
            // lesson to us all, especially me.
            getSelectionRangeAt = function(sel, index) {
                try {
                    return sel.getRangeAt(index);
                } catch (ex) {
                    return null;
                }
            };
        } else if (selectionHasAnchorAndFocus) {
            getSelectionRangeAt = function(sel) {
                var doc = getDocument(sel.anchorNode);
                var range = api.createRange(doc);
                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);

                // Handle the case when the selection was selected backwards (from the end to the start in the
                // document)
                if (range.collapsed !== this.isCollapsed) {
                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
                }

                return range;
            };
        }

        function WrappedSelection(selection, docSelection, win) {
            this.nativeSelection = selection;
            this.docSelection = docSelection;
            this._ranges = [];
            this.win = win;
            this.refresh();
        }

        WrappedSelection.prototype = api.selectionPrototype;

        function deleteProperties(sel) {
            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
            sel.detached = true;
        }

        var cachedRangySelections = [];

        function actOnCachedSelection(win, action) {
            var i = cachedRangySelections.length, cached, sel;
            while (i--) {
                cached = cachedRangySelections[i];
                sel = cached.selection;
                if (action == "deleteAll") {
                    deleteProperties(sel);
                } else if (cached.win == win) {
                    if (action == "delete") {
                        cachedRangySelections.splice(i, 1);
                        return true;
                    } else {
                        return sel;
                    }
                }
            }
            if (action == "deleteAll") {
                cachedRangySelections.length = 0;
            }
            return null;
        }

        var getSelection = function(win) {
            // Check if the parameter is a Rangy Selection object
            if (win && win instanceof WrappedSelection) {
                win.refresh();
                return win;
            }

            win = getWindow(win, "getNativeSelection");

            var sel = actOnCachedSelection(win);
            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
            if (sel) {
                sel.nativeSelection = nativeSel;
                sel.docSelection = docSel;
                sel.refresh();
            } else {
                sel = new WrappedSelection(nativeSel, docSel, win);
                cachedRangySelections.push( { win: win, selection: sel } );
            }
            return sel;
        };

        api.getSelection = getSelection;

        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");

        var selProto = WrappedSelection.prototype;

        function createControlSelection(sel, ranges) {
            // Ensure that the selection becomes of type "Control"
            var doc = getDocument(ranges[0].startContainer);
            var controlRange = getBody(doc).createControlRange();
            for (var i = 0, el, len = ranges.length; i < len; ++i) {
                el = getSingleElementFromRange(ranges[i]);
                try {
                    controlRange.add(el);
                } catch (ex) {
                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
                }
            }
            controlRange.select();

            // Update the wrapped selection based on what's now in the native selection
            updateControlSelection(sel);
        }

        // Selecting a range
        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
            selProto.removeAllRanges = function() {
                this.nativeSelection.removeAllRanges();
                updateEmptySelection(this);
            };

            var addRangeBackward = function(sel, range) {
                addRangeBackwardToNative(sel.nativeSelection, range);
                sel.refresh();
            };

            if (selectionHasRangeCount) {
                selProto.addRange = function(range, direction) {
                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                        addRangeToControlSelection(this, range);
                    } else {
                        if (isDirectionBackward(direction) && selectionHasExtend) {
                            addRangeBackward(this, range);
                        } else {
                            var previousRangeCount;
                            if (selectionSupportsMultipleRanges) {
                                previousRangeCount = this.rangeCount;
                            } else {
                                this.removeAllRanges();
                                previousRangeCount = 0;
                            }
                            // Clone the native range so that changing the selected range does not affect the selection.
                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
                            // issue 80.
                            var clonedNativeRange = getNativeRange(range).cloneRange();
                            try {
                                this.nativeSelection.addRange(clonedNativeRange);
                            } catch (ex) {
                            }

                            // Check whether adding the range was successful
                            this.rangeCount = this.nativeSelection.rangeCount;

                            if (this.rangeCount == previousRangeCount + 1) {
                                // The range was added successfully

                                // Check whether the range that we added to the selection is reflected in the last range extracted from
                                // the selection
                                if (api.config.checkSelectionRanges) {
                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
                                        range = new WrappedRange(nativeRange);
                                    }
                                }
                                this._ranges[this.rangeCount - 1] = range;
                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
                                this.isCollapsed = selectionIsCollapsed(this);
                            } else {
                                // The range was not added successfully. The simplest thing is to refresh
                                this.refresh();
                            }
                        }
                    }
                };
            } else {
                selProto.addRange = function(range, direction) {
                    if (isDirectionBackward(direction) && selectionHasExtend) {
                        addRangeBackward(this, range);
                    } else {
                        this.nativeSelection.addRange(getNativeRange(range));
                        this.refresh();
                    }
                };
            }

            selProto.setRanges = function(ranges) {
                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
                    createControlSelection(this, ranges);
                } else {
                    this.removeAllRanges();
                    for (var i = 0, len = ranges.length; i < len; ++i) {
                        this.addRange(ranges[i]);
                    }
                }
            };
        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
                   implementsControlRange && useDocumentSelection) {

            selProto.removeAllRanges = function() {
                // Added try/catch as fix for issue #21
                try {
                    this.docSelection.empty();

                    // Check for empty() not working (issue #24)
                    if (this.docSelection.type != "None") {
                        // Work around failure to empty a control selection by instead selecting a TextRange and then
                        // calling empty()
                        var doc;
                        if (this.anchorNode) {
                            doc = getDocument(this.anchorNode);
                        } else if (this.docSelection.type == CONTROL) {
                            var controlRange = this.docSelection.createRange();
                            if (controlRange.length) {
                                doc = getDocument( controlRange.item(0) );
                            }
                        }
                        if (doc) {
                            var textRange = getBody(doc).createTextRange();
                            textRange.select();
                            this.docSelection.empty();
                        }
                    }
                } catch(ex) {}
                updateEmptySelection(this);
            };

            selProto.addRange = function(range) {
                if (this.docSelection.type == CONTROL) {
                    addRangeToControlSelection(this, range);
                } else {
                    api.WrappedTextRange.rangeToTextRange(range).select();
                    this._ranges[0] = range;
                    this.rangeCount = 1;
                    this.isCollapsed = this._ranges[0].collapsed;
                    updateAnchorAndFocusFromRange(this, range, false);
                }
            };

            selProto.setRanges = function(ranges) {
                this.removeAllRanges();
                var rangeCount = ranges.length;
                if (rangeCount > 1) {
                    createControlSelection(this, ranges);
                } else if (rangeCount) {
                    this.addRange(ranges[0]);
                }
            };
        } else {
            module.fail("No means of selecting a Range or TextRange was found");
            return false;
        }

        selProto.getRangeAt = function(index) {
            if (index < 0 || index >= this.rangeCount) {
                throw new DOMException("INDEX_SIZE_ERR");
            } else {
                // Clone the range to preserve selection-range independence. See issue 80.
                return this._ranges[index].cloneRange();
            }
        };

        var refreshSelection;

        if (useDocumentSelection) {
            refreshSelection = function(sel) {
                var range;
                if (api.isSelectionValid(sel.win)) {
                    range = sel.docSelection.createRange();
                } else {
                    range = getBody(sel.win.document).createTextRange();
                    range.collapse(true);
                }

                if (sel.docSelection.type == CONTROL) {
                    updateControlSelection(sel);
                } else if (isTextRange(range)) {
                    updateFromTextRange(sel, range);
                } else {
                    updateEmptySelection(sel);
                }
            };
        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
            refreshSelection = function(sel) {
                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
                    updateControlSelection(sel);
                } else {
                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
                    if (sel.rangeCount) {
                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
                        }
                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
                        sel.isCollapsed = selectionIsCollapsed(sel);
                    } else {
                        updateEmptySelection(sel);
                    }
                }
            };
        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
            refreshSelection = function(sel) {
                var range, nativeSel = sel.nativeSelection;
                if (nativeSel.anchorNode) {
                    range = getSelectionRangeAt(nativeSel, 0);
                    sel._ranges = [range];
                    sel.rangeCount = 1;
                    updateAnchorAndFocusFromNativeSelection(sel);
                    sel.isCollapsed = selectionIsCollapsed(sel);
                } else {
                    updateEmptySelection(sel);
                }
            };
        } else {
            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
            return false;
        }

        selProto.refresh = function(checkForChanges) {
            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;

            refreshSelection(this);
            if (checkForChanges) {
                // Check the range count first
                var i = oldRanges.length;
                if (i != this._ranges.length) {
                    return true;
                }

                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
                // ranges after this
                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
                    return true;
                }

                // Finally, compare each range in turn
                while (i--) {
                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
                        return true;
                    }
                }
                return false;
            }
        };

        // Removal of a single range
        var removeRangeManually = function(sel, range) {
            var ranges = sel.getAllRanges();
            sel.removeAllRanges();
            for (var i = 0, len = ranges.length; i < len; ++i) {
                if (!rangesEqual(range, ranges[i])) {
                    sel.addRange(ranges[i]);
                }
            }
            if (!sel.rangeCount) {
                updateEmptySelection(sel);
            }
        };

        if (implementsControlRange && implementsDocSelection) {
            selProto.removeRange = function(range) {
                if (this.docSelection.type == CONTROL) {
                    var controlRange = this.docSelection.createRange();
                    var rangeElement = getSingleElementFromRange(range);

                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
                    // element contained by the supplied range
                    var doc = getDocument(controlRange.item(0));
                    var newControlRange = getBody(doc).createControlRange();
                    var el, removed = false;
                    for (var i = 0, len = controlRange.length; i < len; ++i) {
                        el = controlRange.item(i);
                        if (el !== rangeElement || removed) {
                            newControlRange.add(controlRange.item(i));
                        } else {
                            removed = true;
                        }
                    }
                    newControlRange.select();

                    // Update the wrapped selection based on what's now in the native selection
                    updateControlSelection(this);
                } else {
                    removeRangeManually(this, range);
                }
            };
        } else {
            selProto.removeRange = function(range) {
                removeRangeManually(this, range);
            };
        }

        // Detecting if a selection is backward
        var selectionIsBackward;
        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
            selectionIsBackward = winSelectionIsBackward;

            selProto.isBackward = function() {
                return selectionIsBackward(this);
            };
        } else {
            selectionIsBackward = selProto.isBackward = function() {
                return false;
            };
        }

        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
        selProto.isBackwards = selProto.isBackward;

        // Selection stringifier
        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
        // The current spec does not yet define this method.
        selProto.toString = function() {
            var rangeTexts = [];
            for (var i = 0, len = this.rangeCount; i < len; ++i) {
                rangeTexts[i] = "" + this._ranges[i];
            }
            return rangeTexts.join("");
        };

        function assertNodeInSameDocument(sel, node) {
            if (sel.win.document != getDocument(node)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }
        }

        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
        selProto.collapse = function(node, offset) {
            assertNodeInSameDocument(this, node);
            var range = api.createRange(node);
            range.collapseToPoint(node, offset);
            this.setSingleRange(range);
            this.isCollapsed = true;
        };

        selProto.collapseToStart = function() {
            if (this.rangeCount) {
                var range = this._ranges[0];
                this.collapse(range.startContainer, range.startOffset);
            } else {
                throw new DOMException("INVALID_STATE_ERR");
            }
        };

        selProto.collapseToEnd = function() {
            if (this.rangeCount) {
                var range = this._ranges[this.rangeCount - 1];
                this.collapse(range.endContainer, range.endOffset);
            } else {
                throw new DOMException("INVALID_STATE_ERR");
            }
        };

        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
        // specified so the native implementation is never used by Rangy.
        selProto.selectAllChildren = function(node) {
            assertNodeInSameDocument(this, node);
            var range = api.createRange(node);
            range.selectNodeContents(node);
            this.setSingleRange(range);
        };

        selProto.deleteFromDocument = function() {
            // Sepcial behaviour required for IE's control selections
            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                var controlRange = this.docSelection.createRange();
                var element;
                while (controlRange.length) {
                    element = controlRange.item(0);
                    controlRange.remove(element);
                    dom.removeNode(element);
                }
                this.refresh();
            } else if (this.rangeCount) {
                var ranges = this.getAllRanges();
                if (ranges.length) {
                    this.removeAllRanges();
                    for (var i = 0, len = ranges.length; i < len; ++i) {
                        ranges[i].deleteContents();
                    }
                    // The spec says nothing about what the selection should contain after calling deleteContents on each
                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
                    this.addRange(ranges[len - 1]);
                }
            }
        };

        // The following are non-standard extensions
        selProto.eachRange = function(func, returnValue) {
            for (var i = 0, len = this._ranges.length; i < len; ++i) {
                if ( func( this.getRangeAt(i) ) ) {
                    return returnValue;
                }
            }
        };

        selProto.getAllRanges = function() {
            var ranges = [];
            this.eachRange(function(range) {
                ranges.push(range);
            });
            return ranges;
        };

        selProto.setSingleRange = function(range, direction) {
            this.removeAllRanges();
            this.addRange(range, direction);
        };

        selProto.callMethodOnEachRange = function(methodName, params) {
            var results = [];
            this.eachRange( function(range) {
                results.push( range[methodName].apply(range, params || []) );
            } );
            return results;
        };

        function createStartOrEndSetter(isStart) {
            return function(node, offset) {
                var range;
                if (this.rangeCount) {
                    range = this.getRangeAt(0);
                    range["set" + (isStart ? "Start" : "End")](node, offset);
                } else {
                    range = api.createRange(this.win.document);
                    range.setStartAndEnd(node, offset);
                }
                this.setSingleRange(range, this.isBackward());
            };
        }

        selProto.setStart = createStartOrEndSetter(true);
        selProto.setEnd = createStartOrEndSetter(false);

        // Add select() method to Range prototype. Any existing selection will be removed.
        api.rangePrototype.select = function(direction) {
            getSelection( this.getDocument() ).setSingleRange(this, direction);
        };

        selProto.changeEachRange = function(func) {
            var ranges = [];
            var backward = this.isBackward();

            this.eachRange(function(range) {
                func(range);
                ranges.push(range);
            });

            this.removeAllRanges();
            if (backward && ranges.length == 1) {
                this.addRange(ranges[0], "backward");
            } else {
                this.setRanges(ranges);
            }
        };

        selProto.containsNode = function(node, allowPartial) {
            return this.eachRange( function(range) {
                return range.containsNode(node, allowPartial);
            }, true ) || false;
        };

        selProto.getBookmark = function(containerNode) {
            return {
                backward: this.isBackward(),
                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
            };
        };

        selProto.moveToBookmark = function(bookmark) {
            var selRanges = [];
            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
                range = api.createRange(this.win);
                range.moveToBookmark(rangeBookmark);
                selRanges.push(range);
            }
            if (bookmark.backward) {
                this.setSingleRange(selRanges[0], "backward");
            } else {
                this.setRanges(selRanges);
            }
        };

        selProto.saveRanges = function() {
            return {
                backward: this.isBackward(),
                ranges: this.callMethodOnEachRange("cloneRange")
            };
        };

        selProto.restoreRanges = function(selRanges) {
            this.removeAllRanges();
            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
                this.addRange(range, (selRanges.backward && i == 0));
            }
        };

        selProto.toHtml = function() {
            var rangeHtmls = [];
            this.eachRange(function(range) {
                rangeHtmls.push( DomRange.toHtml(range) );
            });
            return rangeHtmls.join("");
        };

        if (features.implementsTextRange) {
            selProto.getNativeTextRange = function() {
                var sel, textRange;
                if ( (sel = this.docSelection) ) {
                    var range = sel.createRange();
                    if (isTextRange(range)) {
                        return range;
                    } else {
                        throw module.createError("getNativeTextRange: selection is a control selection");
                    }
                } else if (this.rangeCount > 0) {
                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
                } else {
                    throw module.createError("getNativeTextRange: selection contains no range");
                }
            };
        }

        function inspect(sel) {
            var rangeInspects = [];
            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";

            if (typeof sel.rangeCount != "undefined") {
                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
                }
            }
            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
        }

        selProto.getName = function() {
            return "WrappedSelection";
        };

        selProto.inspect = function() {
            return inspect(this);
        };

        selProto.detach = function() {
            actOnCachedSelection(this.win, "delete");
            deleteProperties(this);
        };

        WrappedSelection.detachAll = function() {
            actOnCachedSelection(null, "deleteAll");
        };

        WrappedSelection.inspect = inspect;
        WrappedSelection.isDirectionBackward = isDirectionBackward;

        api.Selection = WrappedSelection;

        api.selectionPrototype = selProto;

        api.addShimListener(function(win) {
            if (typeof win.getSelection == "undefined") {
                win.getSelection = function() {
                    return getSelection(win);
                };
            }
            win = null;
        });
    });
    

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wait for document to load before initializing
    var docReady = false;

    var loadHandler = function(e) {
        if (!docReady) {
            docReady = true;
            if (!api.initialized && api.config.autoInitialize) {
                init();
            }
        }
    };

    if (isBrowser) {
        // Test whether the document has already been loaded and initialize immediately if so
        if (document.readyState == "complete") {
            loadHandler();
        } else {
            if (isHostMethod(document, "addEventListener")) {
                document.addEventListener("DOMContentLoaded", loadHandler, false);
            }

            // Add a fallback in case the DOMContentLoaded event isn't supported
            addListener(window, "load", loadHandler);
        }
    }

    return api;
}, this);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.14
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.14",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	loadData({
		"version": "2017c",
		"zones": [
			"Africa/Abidjan|GMT|0|0||48e5",
			"Africa/Nairobi|EAT|-30|0||47e5",
			"Africa/Algiers|CET|-10|0||26e5",
			"Africa/Lagos|WAT|-10|0||17e6",
			"Africa/Maputo|CAT|-20|0||26e5",
			"Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|WET WEST|0 -10|0101010101010101010101010101010101010101010|1H3C0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00|32e5",
			"Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6",
			"Africa/Johannesburg|SAST|-20|0||84e5",
			"Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5",
			"Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5",
			"Africa/Windhoek|WAST WAT CAT|-20 -10 -20|0101010101012|1GQo0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4",
			"America/Santo_Domingo|AST|40|0||29e5",
			"America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4",
			"America/Fortaleza|-03|30|0||34e5",
			"America/Asuncion|-03 -04|30 40|01010101010101010101010|1GTf0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5",
			"America/Panama|EST|50|0||15e5",
			"America/Bahia|-02 -03|20 30|01|1GCq0|27e5",
			"America/Mexico_City|CST CDT|60 50|01010101010101010101010|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Managua|CST|60|0||22e5",
			"America/La_Paz|-04|40|0||19e5",
			"America/Lima|-05|50|0||11e6",
			"America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5",
			"America/Campo_Grande|-03 -04|30 40|01010101010101010101010|1GCr0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0|77e4",
			"America/Cancun|CST CDT EST|60 50 50|01010102|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5",
			"America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|MST MDT|70 60|01010101010101010101010|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Phoenix|MST|70|0||42e5",
			"America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6",
			"America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6",
			"America/Rio_Branco|-04 -05|40 50|01|1KLE0|31e4",
			"America/Fort_Nelson|PST PDT MST|80 70 70|01010102|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Halifax|AST ADT|40 30|01010101010101010101010|1GI60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4",
			"America/Godthab|-03 -02|30 20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3",
			"America/Grand_Turk|EST EDT AST|50 40 40|0101010121010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2",
			"America/Havana|CST CDT|50 40|01010101010101010101010|1GQt0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5",
			"America/Metlakatla|PST AKST AKDT|80 90 80|0121212121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2",
			"America/Miquelon|-03 -02|30 20|01010101010101010101010|1GI50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2",
			"America/Montevideo|-02 -03|20 30|01010101|1GI40 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Noronha|-02|20|0||30e2",
			"America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5",
			"Antarctica/Palmer|-03 -04|30 40|010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"America/Santiago|-03 -04|30 40|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0|62e5",
			"America/Sao_Paulo|-02 -03|20 30|01010101010101010101010|1GCq0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0|20e6",
			"Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4",
			"America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1GI5u 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4",
			"Antarctica/Casey|+11 +08|-b0 -80|010|1GAF0 blz0|10",
			"Antarctica/Davis|+05 +07|-50 -70|01|1GAI0|70",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Pacific/Guadalcanal|+11|-b0|0||11e4",
			"Asia/Tashkent|+05|-50|0||23e5",
			"Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Asia/Baghdad|+03|-30|0||66e5",
			"Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40",
			"Asia/Dhaka|+06|-60|0||16e6",
			"Asia/Amman|EET EEST|-20 -30|010101010101010101010|1GPy0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00|25e5",
			"Asia/Kamchatka|+12|-c0|0||18e4",
			"Asia/Baku|+04 +05|-40 -50|010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|+07|-70|0||15e6",
			"Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1GNy0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5",
			"Asia/Manila|+08|-80|0||24e6",
			"Asia/Kolkata|IST|-5u|0||15e6",
			"Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4",
			"Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Shanghai|CST|-80|0||23e6",
			"Asia/Colombo|+0530|-5u|0||22e5",
			"Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1GPy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|+09|-90|0||19e4",
			"Asia/Dubai|+04|-40|0||39e5",
			"Asia/Famagusta|EET EEST +03|-20 -30 -30|0101010101201010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1GPy0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|18e5",
			"Asia/Hong_Kong|HKT|-80|0||73e5",
			"Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4",
			"Europe/Istanbul|EET EEST +03|-20 -30 -30|01010101012|1GNB0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|WIB|-70|0||31e6",
			"Asia/Jayapura|WIT|-90|0||26e4",
			"Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1GPA0 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4",
			"Asia/Kabul|+0430|-4u|0||46e5",
			"Asia/Karachi|PKT|-50|0||24e6",
			"Asia/Kathmandu|+0545|-5J|0||12e5",
			"Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4",
			"Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5",
			"Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3",
			"Asia/Makassar|WITA|-80|0||15e5",
			"Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5",
			"Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5",
			"Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5",
			"Asia/Pyongyang|KST KST|-90 -8u|01|1P4D0|29e5",
			"Asia/Rangoon|+0630|-6u|0||48e5",
			"Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4",
			"Asia/Seoul|KST|-90|0||23e6",
			"Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2",
			"Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1GLUu 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Tokyo|JST|-90|0||38e6",
			"Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5",
			"Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4",
			"Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5",
			"Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5",
			"Atlantic/Cape_Verde|-01|10|0||50e4",
			"Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1GQg0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1GQgu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST|-a0|0||20e5",
			"Australia/Darwin|ACST|-9u|0||12e4",
			"Australia/Eucla|+0845|-8J|0||368",
			"Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1GQf0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Perth|AWST|-80|0||18e5",
			"Pacific/Easter|-05 -06|50 60|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0|30e2",
			"Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5",
			"Pacific/Tahiti|-10|a0|0||18e4",
			"Pacific/Niue|-11|b0|0||12e2",
			"Etc/GMT+12|-12|c0|0|",
			"Pacific/Galapagos|-06|60|0||25e3",
			"Etc/GMT+7|-07|70|0|",
			"Pacific/Pitcairn|-08|80|0||56",
			"Pacific/Gambier|-09|90|0||125",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Fakaofo|+13|-d0|0||483",
			"Pacific/Kiritimati|+14|-e0|0||51e2",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Astrakhan|+04 +03|-40 -30|010|1N7y0 3rd0",
			"Europe/London|GMT BST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6",
			"Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4",
			"Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4",
			"Europe/Volgograd|+04 +03|-40 -30|01|1N7y0|10e5",
			"Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6",
			"Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810",
			"Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|0101023|1GNB0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Pacific/Honolulu|HST|a0|0||37e4",
			"MET|MET MEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0",
			"Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4",
			"Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101010|1Goe0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0|88e4",
			"Pacific/Guam|ChST|-a0|0||17e4",
			"Pacific/Marquesas|-0930|9u|0||86e2",
			"Pacific/Pago_Pago|SST|b0|0||37e2",
			"Pacific/Norfolk|+1130 +11|-bu -b0|01|1PoCu|25e4",
			"Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Bissau",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Monrovia",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|America/Danmarkshavn",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Etc/GMT",
			"Africa/Abidjan|Etc/GMT+0",
			"Africa/Abidjan|Etc/GMT-0",
			"Africa/Abidjan|Etc/GMT0",
			"Africa/Abidjan|Etc/Greenwich",
			"Africa/Abidjan|GMT",
			"Africa/Abidjan|GMT+0",
			"Africa/Abidjan|GMT-0",
			"Africa/Abidjan|GMT0",
			"Africa/Abidjan|Greenwich",
			"Africa/Abidjan|Iceland",
			"Africa/Algiers|Africa/Tunis",
			"Africa/Cairo|Egypt",
			"Africa/Casablanca|Africa/El_Aaiun",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Ndjamena",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Juba",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|America/Juneau",
			"America/Anchorage|America/Nome",
			"America/Anchorage|America/Sitka",
			"America/Anchorage|America/Yakutat",
			"America/Anchorage|US/Alaska",
			"America/Campo_Grande|America/Cuiaba",
			"America/Chicago|America/Indiana/Knox",
			"America/Chicago|America/Indiana/Tell_City",
			"America/Chicago|America/Knox_IN",
			"America/Chicago|America/Matamoros",
			"America/Chicago|America/Menominee",
			"America/Chicago|America/North_Dakota/Beulah",
			"America/Chicago|America/North_Dakota/Center",
			"America/Chicago|America/North_Dakota/New_Salem",
			"America/Chicago|America/Rainy_River",
			"America/Chicago|America/Rankin_Inlet",
			"America/Chicago|America/Resolute",
			"America/Chicago|America/Winnipeg",
			"America/Chicago|CST6CDT",
			"America/Chicago|Canada/Central",
			"America/Chicago|US/Central",
			"America/Chicago|US/Indiana-Starke",
			"America/Chihuahua|America/Mazatlan",
			"America/Chihuahua|Mexico/BajaSur",
			"America/Denver|America/Boise",
			"America/Denver|America/Cambridge_Bay",
			"America/Denver|America/Edmonton",
			"America/Denver|America/Inuvik",
			"America/Denver|America/Ojinaga",
			"America/Denver|America/Shiprock",
			"America/Denver|America/Yellowknife",
			"America/Denver|Canada/Mountain",
			"America/Denver|MST7MDT",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Fortaleza|America/Argentina/Buenos_Aires",
			"America/Fortaleza|America/Argentina/Catamarca",
			"America/Fortaleza|America/Argentina/ComodRivadavia",
			"America/Fortaleza|America/Argentina/Cordoba",
			"America/Fortaleza|America/Argentina/Jujuy",
			"America/Fortaleza|America/Argentina/La_Rioja",
			"America/Fortaleza|America/Argentina/Mendoza",
			"America/Fortaleza|America/Argentina/Rio_Gallegos",
			"America/Fortaleza|America/Argentina/Salta",
			"America/Fortaleza|America/Argentina/San_Juan",
			"America/Fortaleza|America/Argentina/San_Luis",
			"America/Fortaleza|America/Argentina/Tucuman",
			"America/Fortaleza|America/Argentina/Ushuaia",
			"America/Fortaleza|America/Belem",
			"America/Fortaleza|America/Buenos_Aires",
			"America/Fortaleza|America/Catamarca",
			"America/Fortaleza|America/Cayenne",
			"America/Fortaleza|America/Cordoba",
			"America/Fortaleza|America/Jujuy",
			"America/Fortaleza|America/Maceio",
			"America/Fortaleza|America/Mendoza",
			"America/Fortaleza|America/Paramaribo",
			"America/Fortaleza|America/Recife",
			"America/Fortaleza|America/Rosario",
			"America/Fortaleza|America/Santarem",
			"America/Fortaleza|Antarctica/Rothera",
			"America/Fortaleza|Atlantic/Stanley",
			"America/Fortaleza|Etc/GMT+3",
			"America/Halifax|America/Glace_Bay",
			"America/Halifax|America/Goose_Bay",
			"America/Halifax|America/Moncton",
			"America/Halifax|America/Thule",
			"America/Halifax|Atlantic/Bermuda",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/La_Paz|America/Boa_Vista",
			"America/La_Paz|America/Guyana",
			"America/La_Paz|America/Manaus",
			"America/La_Paz|America/Porto_Velho",
			"America/La_Paz|Brazil/West",
			"America/La_Paz|Etc/GMT+4",
			"America/Lima|America/Bogota",
			"America/Lima|America/Guayaquil",
			"America/Lima|Etc/GMT+5",
			"America/Los_Angeles|America/Dawson",
			"America/Los_Angeles|America/Ensenada",
			"America/Los_Angeles|America/Santa_Isabel",
			"America/Los_Angeles|America/Tijuana",
			"America/Los_Angeles|America/Vancouver",
			"America/Los_Angeles|America/Whitehorse",
			"America/Los_Angeles|Canada/Pacific",
			"America/Los_Angeles|Canada/Yukon",
			"America/Los_Angeles|Mexico/BajaNorte",
			"America/Los_Angeles|PST8PDT",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Managua|America/Belize",
			"America/Managua|America/Costa_Rica",
			"America/Managua|America/El_Salvador",
			"America/Managua|America/Guatemala",
			"America/Managua|America/Regina",
			"America/Managua|America/Swift_Current",
			"America/Managua|America/Tegucigalpa",
			"America/Managua|Canada/Saskatchewan",
			"America/Mexico_City|America/Bahia_Banderas",
			"America/Mexico_City|America/Merida",
			"America/Mexico_City|America/Monterrey",
			"America/Mexico_City|Mexico/General",
			"America/New_York|America/Detroit",
			"America/New_York|America/Fort_Wayne",
			"America/New_York|America/Indiana/Indianapolis",
			"America/New_York|America/Indiana/Marengo",
			"America/New_York|America/Indiana/Petersburg",
			"America/New_York|America/Indiana/Vevay",
			"America/New_York|America/Indiana/Vincennes",
			"America/New_York|America/Indiana/Winamac",
			"America/New_York|America/Indianapolis",
			"America/New_York|America/Iqaluit",
			"America/New_York|America/Kentucky/Louisville",
			"America/New_York|America/Kentucky/Monticello",
			"America/New_York|America/Louisville",
			"America/New_York|America/Montreal",
			"America/New_York|America/Nassau",
			"America/New_York|America/Nipigon",
			"America/New_York|America/Pangnirtung",
			"America/New_York|America/Thunder_Bay",
			"America/New_York|America/Toronto",
			"America/New_York|Canada/Eastern",
			"America/New_York|EST5EDT",
			"America/New_York|US/East-Indiana",
			"America/New_York|US/Eastern",
			"America/New_York|US/Michigan",
			"America/Noronha|Atlantic/South_Georgia",
			"America/Noronha|Brazil/DeNoronha",
			"America/Noronha|Etc/GMT+2",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Panama|America/Jamaica",
			"America/Panama|EST",
			"America/Panama|Jamaica",
			"America/Phoenix|America/Creston",
			"America/Phoenix|America/Dawson_Creek",
			"America/Phoenix|America/Hermosillo",
			"America/Phoenix|MST",
			"America/Phoenix|US/Arizona",
			"America/Rio_Branco|America/Eirunepe",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Santo_Domingo|America/Anguilla",
			"America/Santo_Domingo|America/Antigua",
			"America/Santo_Domingo|America/Aruba",
			"America/Santo_Domingo|America/Barbados",
			"America/Santo_Domingo|America/Blanc-Sablon",
			"America/Santo_Domingo|America/Curacao",
			"America/Santo_Domingo|America/Dominica",
			"America/Santo_Domingo|America/Grenada",
			"America/Santo_Domingo|America/Guadeloupe",
			"America/Santo_Domingo|America/Kralendijk",
			"America/Santo_Domingo|America/Lower_Princes",
			"America/Santo_Domingo|America/Marigot",
			"America/Santo_Domingo|America/Martinique",
			"America/Santo_Domingo|America/Montserrat",
			"America/Santo_Domingo|America/Port_of_Spain",
			"America/Santo_Domingo|America/Puerto_Rico",
			"America/Santo_Domingo|America/St_Barthelemy",
			"America/Santo_Domingo|America/St_Kitts",
			"America/Santo_Domingo|America/St_Lucia",
			"America/Santo_Domingo|America/St_Thomas",
			"America/Santo_Domingo|America/St_Vincent",
			"America/Santo_Domingo|America/Tortola",
			"America/Santo_Domingo|America/Virgin",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"Antarctica/Palmer|America/Punta_Arenas",
			"Asia/Baghdad|Antarctica/Syowa",
			"Asia/Baghdad|Asia/Aden",
			"Asia/Baghdad|Asia/Bahrain",
			"Asia/Baghdad|Asia/Kuwait",
			"Asia/Baghdad|Asia/Qatar",
			"Asia/Baghdad|Asia/Riyadh",
			"Asia/Baghdad|Etc/GMT-3",
			"Asia/Baghdad|Europe/Minsk",
			"Asia/Bangkok|Asia/Ho_Chi_Minh",
			"Asia/Bangkok|Asia/Novokuznetsk",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Saigon",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Etc/GMT-7",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Dhaka|Antarctica/Vostok",
			"Asia/Dhaka|Asia/Almaty",
			"Asia/Dhaka|Asia/Bishkek",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dhaka|Asia/Kashgar",
			"Asia/Dhaka|Asia/Qyzylorda",
			"Asia/Dhaka|Asia/Thimbu",
			"Asia/Dhaka|Asia/Thimphu",
			"Asia/Dhaka|Asia/Urumqi",
			"Asia/Dhaka|Etc/GMT-6",
			"Asia/Dhaka|Indian/Chagos",
			"Asia/Dili|Etc/GMT-9",
			"Asia/Dili|Pacific/Palau",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Asia/Tbilisi",
			"Asia/Dubai|Asia/Yerevan",
			"Asia/Dubai|Etc/GMT-4",
			"Asia/Dubai|Europe/Samara",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Mauritius",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Gaza|Asia/Hebron",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jakarta|Asia/Pontianak",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kamchatka|Asia/Anadyr",
			"Asia/Kamchatka|Etc/GMT-12",
			"Asia/Kamchatka|Kwajalein",
			"Asia/Kamchatka|Pacific/Funafuti",
			"Asia/Kamchatka|Pacific/Kwajalein",
			"Asia/Kamchatka|Pacific/Majuro",
			"Asia/Kamchatka|Pacific/Nauru",
			"Asia/Kamchatka|Pacific/Tarawa",
			"Asia/Kamchatka|Pacific/Wake",
			"Asia/Kamchatka|Pacific/Wallis",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Manila|Asia/Brunei",
			"Asia/Manila|Asia/Kuala_Lumpur",
			"Asia/Manila|Asia/Kuching",
			"Asia/Manila|Asia/Singapore",
			"Asia/Manila|Etc/GMT-8",
			"Asia/Manila|Singapore",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|Asia/Macao",
			"Asia/Shanghai|Asia/Macau",
			"Asia/Shanghai|Asia/Taipei",
			"Asia/Shanghai|PRC",
			"Asia/Shanghai|ROC",
			"Asia/Tashkent|Antarctica/Mawson",
			"Asia/Tashkent|Asia/Aqtau",
			"Asia/Tashkent|Asia/Aqtobe",
			"Asia/Tashkent|Asia/Ashgabat",
			"Asia/Tashkent|Asia/Ashkhabad",
			"Asia/Tashkent|Asia/Atyrau",
			"Asia/Tashkent|Asia/Dushanbe",
			"Asia/Tashkent|Asia/Oral",
			"Asia/Tashkent|Asia/Samarkand",
			"Asia/Tashkent|Etc/GMT-5",
			"Asia/Tashkent|Indian/Kerguelen",
			"Asia/Tashkent|Indian/Maldives",
			"Asia/Tehran|Iran",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Choibalsan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Vladivostok|Asia/Ust-Nera",
			"Asia/Yakutsk|Asia/Khandyga",
			"Atlantic/Azores|America/Scoresbysund",
			"Atlantic/Cape_Verde|Etc/GMT+1",
			"Australia/Adelaide|Australia/Broken_Hill",
			"Australia/Adelaide|Australia/South",
			"Australia/Adelaide|Australia/Yancowinna",
			"Australia/Brisbane|Australia/Lindeman",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Darwin|Australia/North",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/Currie",
			"Australia/Sydney|Australia/Hobart",
			"Australia/Sydney|Australia/Melbourne",
			"Australia/Sydney|Australia/NSW",
			"Australia/Sydney|Australia/Tasmania",
			"Australia/Sydney|Australia/Victoria",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Astrakhan|Europe/Ulyanovsk",
			"Europe/Athens|Asia/Nicosia",
			"Europe/Athens|EET",
			"Europe/Athens|Europe/Bucharest",
			"Europe/Athens|Europe/Helsinki",
			"Europe/Athens|Europe/Kiev",
			"Europe/Athens|Europe/Mariehamn",
			"Europe/Athens|Europe/Nicosia",
			"Europe/Athens|Europe/Riga",
			"Europe/Athens|Europe/Sofia",
			"Europe/Athens|Europe/Tallinn",
			"Europe/Athens|Europe/Uzhgorod",
			"Europe/Athens|Europe/Vilnius",
			"Europe/Athens|Europe/Zaporozhye",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Atlantic/Canary",
			"Europe/Lisbon|Atlantic/Faeroe",
			"Europe/Lisbon|Atlantic/Faroe",
			"Europe/Lisbon|Atlantic/Madeira",
			"Europe/Lisbon|Portugal",
			"Europe/Lisbon|WET",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Africa/Ceuta",
			"Europe/Paris|Arctic/Longyearbyen",
			"Europe/Paris|Atlantic/Jan_Mayen",
			"Europe/Paris|CET",
			"Europe/Paris|Europe/Amsterdam",
			"Europe/Paris|Europe/Andorra",
			"Europe/Paris|Europe/Belgrade",
			"Europe/Paris|Europe/Berlin",
			"Europe/Paris|Europe/Bratislava",
			"Europe/Paris|Europe/Brussels",
			"Europe/Paris|Europe/Budapest",
			"Europe/Paris|Europe/Busingen",
			"Europe/Paris|Europe/Copenhagen",
			"Europe/Paris|Europe/Gibraltar",
			"Europe/Paris|Europe/Ljubljana",
			"Europe/Paris|Europe/Luxembourg",
			"Europe/Paris|Europe/Madrid",
			"Europe/Paris|Europe/Malta",
			"Europe/Paris|Europe/Monaco",
			"Europe/Paris|Europe/Oslo",
			"Europe/Paris|Europe/Podgorica",
			"Europe/Paris|Europe/Prague",
			"Europe/Paris|Europe/Rome",
			"Europe/Paris|Europe/San_Marino",
			"Europe/Paris|Europe/Sarajevo",
			"Europe/Paris|Europe/Skopje",
			"Europe/Paris|Europe/Stockholm",
			"Europe/Paris|Europe/Tirane",
			"Europe/Paris|Europe/Vaduz",
			"Europe/Paris|Europe/Vatican",
			"Europe/Paris|Europe/Vienna",
			"Europe/Paris|Europe/Warsaw",
			"Europe/Paris|Europe/Zagreb",
			"Europe/Paris|Europe/Zurich",
			"Europe/Paris|Poland",
			"Europe/Volgograd|Europe/Kirov",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Fakaofo|Etc/GMT-13",
			"Pacific/Fakaofo|Pacific/Enderbury",
			"Pacific/Galapagos|Etc/GMT+6",
			"Pacific/Gambier|Etc/GMT+9",
			"Pacific/Guadalcanal|Antarctica/Macquarie",
			"Pacific/Guadalcanal|Etc/GMT-11",
			"Pacific/Guadalcanal|Pacific/Efate",
			"Pacific/Guadalcanal|Pacific/Kosrae",
			"Pacific/Guadalcanal|Pacific/Noumea",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|HST",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kiritimati|Etc/GMT-14",
			"Pacific/Niue|Etc/GMT+11",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pitcairn|Etc/GMT+8",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tahiti|Etc/GMT+10",
			"Pacific/Tahiti|Pacific/Rarotonga"
		]
	});


	return moment;
}));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var moment_1 = __importDefault(__webpack_require__(5));
var superdesk_ui_framework_1 = __webpack_require__(59);
var RelativeDate = /** @class */ (function (_super) {
    __extends(RelativeDate, _super);
    function RelativeDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelativeDate.prototype.render = function () {
        var date = moment_1.default.utc(this.props.datetime);
        date.local(); // switch to local time zone
        var datetimeIso = date.toISOString();
        var title = date.format('LLLL');
        var reldate = date.fromNow();
        return (react_1.default.createElement("time", { dateTime: datetimeIso, title: title }, reldate));
    };
    return RelativeDate;
}(react_1.default.Component));
exports.RelativeDate = RelativeDate;
angular.module('superdesk.core.datetime.relativeDate', [])
    .component('sdRelativeDate', superdesk_ui_framework_1.reactToAngular1(RelativeDate, ['datetime']));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.Modal = function (props) { return (react_1.default.createElement("div", null, props.children)); };
exports.Modal.propTypes = {
    children: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
/**
 * @ngdoc method
 * @name toggleBlockStyle
 * @param {String} blockType Type of block styling to toggle.
 * @return {String} action
 * @description Returns the block style toggling action.
 */
function toggleBlockStyle(blockType) {
    return {
        type: 'TOOLBAR_TOGGLE_BLOCK_STYLE',
        payload: blockType,
    };
}
exports.toggleBlockStyle = toggleBlockStyle;
/**
 * @ngdoc method
 * @name toggleInlineStyle
 * @param {String} inlineStyle Type of inline styling to toggle.
 * @return {String} action
 * @description Returns the inline style toggling action.
 */
function toggleInlineStyle(inlineStyle) {
    return {
        type: 'TOOLBAR_TOGGLE_INLINE_STYLE',
        payload: inlineStyle,
    };
}
exports.toggleInlineStyle = toggleInlineStyle;
/**
 * @ngdoc method
 * @name applyLink
 * @param {Object} linkAndEntity
 * @return {String} action
 * @description Returns the action for applying links to text selections.
 */
function applyLink(link, entity) {
    if (entity === void 0) { entity = null; }
    return {
        type: 'TOOLBAR_APPLY_LINK',
        payload: { link: link, entity: entity },
    };
}
exports.applyLink = applyLink;
/**
 * @ngdoc method
 * @name removeLink
 * @return {String} action
 * @description Returns the action for removing a link under the cursor.
 */
function removeLink() {
    return { type: 'TOOLBAR_REMOVE_LINK' };
}
exports.removeLink = removeLink;
function removeFormat() {
    return { type: 'TOOLBAR_REMOVE_FORMAT' };
}
exports.removeFormat = removeFormat;
/**
 * @ngdoc method
 * @name insertMedia
 * @param {Array} files to be uploaded and inserted
 * @return {String} action
 * @description Displays the external upload dialog and returns the insert media
 * action.
 */
function insertMedia(files, targetBlockKey) {
    if (targetBlockKey === void 0) { targetBlockKey = null; }
    var superdesk = ng_1.default.get('superdesk');
    return function (dispatch) {
        superdesk.intent('upload', 'media', files).then(function (media) {
            dispatch({
                type: 'TOOLBAR_INSERT_MEDIA',
                payload: { files: media, targetBlockKey: targetBlockKey },
            });
        });
    };
}
exports.insertMedia = insertMedia;
/**
 * @ngdoc method
 * @name cropImage
 * @param {String} entityKey
 * @param {Object} entityData
 * @param {Object} options
 * @return {String} action
 * @description Displays the external crop image dialog and returns the crop image
 * action using data from the provided entity.
 */
function cropImage(entityKey, entityData, options) {
    if (options === void 0) { options = {}; }
    var renditions = ng_1.default.get('renditions');
    var media = entityData.media;
    return function (dispatch) {
        renditions.crop(media, options).then(function (cropped) {
            dispatch({
                type: 'TOOLBAR_UPDATE_IMAGE',
                payload: {
                    entityKey: entityKey,
                    media: cropped,
                },
            });
        });
    };
}
exports.cropImage = cropImage;
/**
 * @ngdoc method
 * @name removeBlock
 * @param {String} blockKey
 * @return {String} action
 * @description Removes a media block
 */
function removeBlock(blockKey) {
    return {
        type: 'TOOLBAR_REMOVE_BLOCK',
        payload: {
            blockKey: blockKey,
        },
    };
}
exports.removeBlock = removeBlock;
/**
 * @ngdoc method
 * @name toggleInvisibles
 * @return {String} action
 * @description Toggles paragraph marks on body
 */
function toggleInvisibles() {
    return { type: 'TOOLBAR_TOGGLE_INVISIBLES' };
}
exports.toggleInvisibles = toggleInvisibles;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
/**
 * @ngdoc method
 * @name toggleSuggestingMode
 * @return {String} action
 * @description Enable/disable suggestions mode.
 */
function toggleSuggestingMode() {
    return {
        type: 'TOGGLE_SUGGESTING_MODE',
    };
}
exports.toggleSuggestingMode = toggleSuggestingMode;
/**
 * @ngdoc method
 * @name createAddSuggestion
 * @param {String} chars
 * @return {Object} action
 * @description add a new suggestion of type ADD.
 */
function createAddSuggestion(chars) {
    return {
        type: 'CREATE_ADD_SUGGESTION',
        payload: {
            text: chars,
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.createAddSuggestion = createAddSuggestion;
/**
 * @ngdoc method
 * @name createDeleteSuggestion
 * @return {Object} action
 * @description add a new suggestion of type DELETE.
 */
function createDeleteSuggestion(action) {
    return {
        type: 'CREATE_DELETE_SUGGESTION',
        payload: {
            action: action,
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.createDeleteSuggestion = createDeleteSuggestion;
/**
 * @ngdoc method
 * @name createChangeStyleSuggestion
 * @param {String} style
 * @param {String} active, true if style was active
 * @return {Object} action
 * @description add a new suggestion of type change style.
 */
function createChangeStyleSuggestion(style, active) {
    return {
        type: 'CREATE_CHANGE_STYLE_SUGGESTION',
        payload: {
            style: style,
            data: __assign({}, exports.getSuggestionMetadata(), { originalStyle: active ? style : '' }),
        },
    };
}
exports.createChangeStyleSuggestion = createChangeStyleSuggestion;
/**
 * @ngdoc method
 * @name createChangeBlockStyleSuggestion
 * @param {String} type
 * @param {String} active, true if type was active
 * @return {Object} action
 * @description add a new suggestion of type change block style.
 */
function createChangeBlockStyleSuggestion(type, active) {
    return {
        type: 'CREATE_CHANGE_BLOCK_STYLE_SUGGESTION',
        payload: {
            blockType: type,
            data: __assign({}, exports.getSuggestionMetadata(), { originalStyle: active ? type : '' }),
        },
    };
}
exports.createChangeBlockStyleSuggestion = createChangeBlockStyleSuggestion;
/**
 * @ngdoc method
 * @name createSplitParagraphSuggestion
 * @param {String} blockKey
 * @param {String} blockOffset
 * @return {Object} action
 * @description add a new suggestion of type split paragraph.
 */
function createSplitParagraphSuggestion() {
    return {
        type: 'CREATE_SPLIT_PARAGRAPH_SUGGESTION',
        payload: {
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.createSplitParagraphSuggestion = createSplitParagraphSuggestion;
/**
 * @ngdoc method
 * @name acceptSuggestion
 * @param {Object} selection
 * @return {Object} action
 * @description accept the suggestions for the selection.
 */
function acceptSuggestion(suggestion) {
    return {
        type: 'ACCEPT_SUGGESTION',
        payload: {
            suggestion: suggestion,
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.acceptSuggestion = acceptSuggestion;
/**
 * @ngdoc method
 * @name rejectSuggestion
 * @param {Object} selection
 * @return {Object} action
 * @description reject the suggestions for the selection.
 */
function rejectSuggestion(suggestion) {
    return {
        type: 'REJECT_SUGGESTION',
        payload: {
            suggestion: suggestion,
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.rejectSuggestion = rejectSuggestion;
/**
 * @ngdoc method
 * @name onPasteFromSuggestingMode
 * @param {Object} content, pasted editor content
 * @return {Object} action
 * @description add a new suggestion of type ADD based on pasted content.
 */
function onPasteFromSuggestingMode(content) {
    return {
        type: 'PASTE_ADD_SUGGESTION',
        payload: {
            content: content,
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.onPasteFromSuggestingMode = onPasteFromSuggestingMode;
/**
 * @ngdoc method
 * @name createLinkSuggestion
 * @param {Object} link, object containing the link href
 * @return {Object} action
 * @description add a new suggestion of type ADD link to text
 */
function createLinkSuggestion(link) {
    return {
        type: 'CREATE_LINK_SUGGESTION',
        payload: {
            data: __assign({}, exports.getSuggestionMetadata(), { link: link }),
        },
    };
}
exports.createLinkSuggestion = createLinkSuggestion;
/**
 * @ngdoc method
 * @name removeLinkSuggestion
 * @return {Object} action
 * @description add a new suggestion of type REMOVE link
 */
function removeLinkSuggestion() {
    return {
        type: 'REMOVE_LINK_SUGGESTION',
        payload: {
            data: exports.getSuggestionMetadata(),
        },
    };
}
exports.removeLinkSuggestion = removeLinkSuggestion;
/**
 * @ngdoc method
 * @name changeLinkSuggestion
 * @param {Object} link, object containing the link href
 * @param {Object} entity - the link entity
 * @return {Object} action
 * @description add a new suggestion of type CAHNGE link
 */
function changeLinkSuggestion(link, entity) {
    return {
        type: 'CHANGE_LINK_SUGGESTION',
        payload: {
            data: exports.getSuggestionMetadata(),
            link: link,
            entity: entity,
        },
    };
}
exports.changeLinkSuggestion = changeLinkSuggestion;
/**
 * @ngdoc method
 * @name getSuggestionMetadata
 * @param {String} type
 * @return {Object} returns suggestion metadata
 * @description Creates data structure with info about current user and current date.
 */
exports.getSuggestionMetadata = function () {
    var data = {};
    var date = new Date();
    data.author = ng_1.default.get('session').identity._id;
    data.date = date;
    return data;
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(45);
var Immutable = __webpack_require__(19);

var generateRandomKey = __webpack_require__(60);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(40);

var findRangesImmutable = __webpack_require__(109);
var invariant = __webpack_require__(17);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */



/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var ContentBlockNode = __webpack_require__(45);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * @format
 * 
 */



var Immutable = __webpack_require__(19);

var emptyFunction = __webpack_require__(76);
var findRangesImmutable = __webpack_require__(109);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;


var returnTrue = emptyFunction.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * @legacyServerCallableInstance
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(19);

var Record = Immutable.Record;


var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck(this, DraftEntityInstance);

    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var UnicodeBidiDirection = __webpack_require__(179);

var invariant = __webpack_require__(17);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }
  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

module.exports = UnicodeBidi;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */



module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */



function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorLeaf = __webpack_require__(796);
var DraftOffsetKey = __webpack_require__(131);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var Scroll = __webpack_require__(396);
var Style = __webpack_require__(183);
var UnicodeBidi = __webpack_require__(392);
var UnicodeBidiDirection = __webpack_require__(179);

var cx = __webpack_require__(86);
var getElementPosition = __webpack_require__(808);
var getScrollPosition = __webpack_require__(184);
var getViewportDimensions = __webpack_require__(812);
var invariant = __webpack_require__(17);
var nullthrows = __webpack_require__(47);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck(this, DraftEditorBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);

      return React.createElement(
        DecoratorComponent,
        _extends({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

module.exports = Scroll;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var PhotosMimeType = __webpack_require__(815);

var createArrayFromMixed = __webpack_require__(816);
var emptyFunction = __webpack_require__(76);

var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */



/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * @format
 * 
 */



var invariant = __webpack_require__(17);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * @format
 * 
 */



var DraftOffsetKey = __webpack_require__(131);

var nullthrows = __webpack_require__(47);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());
  if (false) {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */
      return selection;
    }
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(129);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @format
 * 
 */



var UserAgent = __webpack_require__(50);

var invariant = __webpack_require__(17);

var isChrome = UserAgent.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

module.exports = getRangeClientRects;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @format
 * 
 */



var findAncestorOffsetKey = __webpack_require__(185);
var getSelectionOffsetKeyForNode = __webpack_require__(398);
var getUpdatedSelectionState = __webpack_require__(400);
var invariant = __webpack_require__(17);
var nullthrows = __webpack_require__(47);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @format
 * 
 */



var TokenizeUtil = __webpack_require__(834);

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

module.exports = DraftRemovableWord;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

module.exports = moveSelectionForward;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @format
 * 
 */



var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl,
    _assign = __webpack_require__(44);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(40);
var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var DefaultDraftBlockRenderMap = __webpack_require__(180);
var DraftEntity = __webpack_require__(130);
var DraftFeatureFlags = __webpack_require__(65);
var Immutable = __webpack_require__(19);

var _require = __webpack_require__(19),
    Set = _require.Set;

var URI = __webpack_require__(845);

var cx = __webpack_require__(86);
var generateRandomKey = __webpack_require__(60);
var getSafeBodyFromHTML = __webpack_require__(407);
var invariant = __webpack_require__(17);
var sanitizeDraftText = __webpack_require__(178);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    OrderedSet = Immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE',
  sub: 'SUBSCRIPT',
  sup: 'SUPERSCRIPT'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey();

        var textNode = new ContentBlockNode({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * @format
 * 
 */



var UserAgent = __webpack_require__(50);

var invariant = __webpack_require__(17);

var isOldIE = UserAgent.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var SelectionState = __webpack_require__(85);

var adjustBlockDepthForContentState = __webpack_require__(846);
var nullthrows = __webpack_require__(47);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

module.exports = RichTextEditorUtil;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @format
 * 
 */



var KeyBindingUtil = __webpack_require__(186);
var Keys = __webpack_require__(181);
var UserAgent = __webpack_require__(50);

var isOSX = UserAgent.isPlatform('Mac OS X');
var isWindows = UserAgent.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */



var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

module.exports = DraftStringKey;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ng_1 = __importDefault(__webpack_require__(18));
/**
 * @name LinkStrategy
 * @param {Object} contentBlock The content block being scanned
 * @param {Function} callback The callback to call upon finding a range to decorate
 * @param {Object} contentState The content state
 * @description The function that defines the strategy for identifying ranges to decorate.
 */
function LinkStrategy(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
}
/**
 * @name LinkComponent
 * @param {Object} props
 * @description The link decorator.
 */
var LinkComponent = /** @class */ (function (_super) {
    __extends(LinkComponent, _super);
    function LinkComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: '' };
        _this.getLinksAndAttachments(props);
        return _this;
    }
    LinkComponent.prototype.componentWillReceiveProps = function (nextProps) {
        this.getLinksAndAttachments(nextProps);
    };
    LinkComponent.prototype.getLinksAndAttachments = function (props) {
        var _this = this;
        var entity = props.contentState.getEntity(props.entityKey);
        this.link = entity.getData().link;
        if (!this.link && entity.getData() && entity.getData().url) {
            this.link = { href: entity.getData().url };
        }
        if (this.link.attachment) {
            ng_1.default.get('attachments').byId(this.link.attachment)
                .then(function (attachment) {
                _this.setState({ title: attachment.title });
            });
        }
    };
    LinkComponent.prototype.render = function () {
        if (this.link.attachment) {
            return react_1.default.createElement("a", { "data-attachment": this.link.attachment, title: this.state.title }, this.props.children);
        }
        return react_1.default.createElement("a", { href: this.link.href, title: this.link.href }, this.props.children);
    };
    return LinkComponent;
}(react_1.default.Component));
LinkComponent.propTypes = {
    contentState: prop_types_1.default.object.isRequired,
    entityKey: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.array.isRequired,
};
exports.LinkDecorator = {
    strategy: LinkStrategy,
    component: LinkComponent,
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var diff_match_patch_1 = __importDefault(__webpack_require__(413));
/**
 * Create a custom html for Tansa
 *
 * @param {EditorState} editorState
 * @returns {String}
 */
function getTansaHtml(editorState) {
    var content = editorState.getCurrentContent();
    var blockMap = content.getBlockMap();
    return blockMap.reduce(function (tansaHtml, block) {
        var html = '';
        if (block.getType() === 'atomic' && block.getEntityAt(0) != null) {
            var entityKey = block.getEntityAt(0);
            var entity = content.getEntity(entityKey);
            var data = (entity != null && entity.getData() != null) ? entity.getData() : { media: {} };
            var media = data.media;
            if (media != null) {
                if (media.description_text != null) {
                    html += getBlockHtml('description', block.getKey(), media.description_text);
                }
                if (media.alt_text != null) {
                    html += getBlockHtml('alt', block.getKey(), media.alt_text);
                }
                if (media.headline != null) {
                    html += getBlockHtml('headline', block.getKey(), media.headline);
                }
            }
        }
        else {
            html = getBlockHtml('text', block.getKey(), block.getText());
        }
        return tansaHtml + html;
    }, '');
}
exports.getTansaHtml = getTansaHtml;
/**
 * Update the editor with the changes performed by Tansa
 * If the simpleReplace is true try to preserve the existing inline styles and entities
 *
 * @param {EditorState} editorState
 * @param {String} html
 * @param {String} simpleReplace
 * @returns {EditorState}
 */
function setTansaHtml(editorState, html, simpleReplace) {
    var content = editorState.getCurrentContent();
    var blockMap = content.getBlockMap();
    var htmlElement = document.createElement('div');
    var diffMatchPatch = new diff_match_patch_1.default();
    htmlElement.innerHTML = html;
    blockMap.forEach(function (block) {
        var key = block.getKey();
        if (block.getType() === 'atomic') {
            var newDescription = getTextFromTag(htmlElement, 'description', key);
            var newAlt = getTextFromTag(htmlElement, 'alt', key);
            var newHeadline = getTextFromTag(htmlElement, 'headline', key);
            content = updateMedia(content, block, newDescription, newAlt, newHeadline);
        }
        else {
            var newText = getTextFromTag(htmlElement, 'text', key);
            content = updateText(editorState, content, block, newText, diffMatchPatch, simpleReplace);
        }
    });
    return draft_js_1.EditorState.push(editorState, content, 'insert-characters');
}
exports.setTansaHtml = setTansaHtml;
/**
 * Find the tag and extract the text
 *
 * @param {HtmlDom} htmlElement
 * @param {String} field
 * @param {String} key
 * @returns {String}
 */
function getTextFromTag(htmlElement, field, key) {
    var tagElement = htmlElement.querySelector('#' + getHtmlId(field, key));
    return tagElement != null ? tagElement.innerHTML : null;
}
/**
 * Generate an id for html tag
 *
 * @param {String} field
 * @param {String} key
 * @returns {String}
 */
function getHtmlId(field, key) {
    return field + '-' + key;
}
/**
 * Generate the tag
 *
 * @param {String} field
 * @param {String} key
 * @param {String} text
 * @returns {String}
 */
function getBlockHtml(field, key, text) {
    return "<p id=\"" + getHtmlId(field, key) + "\">" + text + "</p>\n";
}
/**
 * Update the description of the media block
 *
 * @param {ContentState} contentState
 * @param {Block} block
 * @param {String} text
 * @returns {ContentState}
 */
function updateMedia(content, block, newDescription, newAlt, newHeadline) {
    var entityKey = block.getEntityAt(0);
    var entity = content.getEntity(entityKey);
    var data = (entity != null && entity.getData() != null) ? entity.getData() : null;
    var newContent = content;
    if (data != null) {
        if (newDescription) {
            data.media.description_text = newDescription;
        }
        if (newAlt) {
            data.media.alt_text = newAlt;
        }
        if (newHeadline) {
            data.media.headline = newHeadline;
        }
        newContent = content.mergeEntityData(entityKey, data);
    }
    return newContent;
}
/**
 * Update the text in the block
 * If the simpleReplace is true try to preserve the existing inline styles and entities
 *
 * @param {EditorState} editorState
 * @param {ContentState} content
 * @param {Block} block
 * @param {String} newText
 * @param {Object} diffMatchPatch
 * @param {boolean} simpleReplace
 * @returns {ContentState}
 */
function updateText(editorState, content, block, newText, diffMatchPatch, simpleReplace) {
    var text = block.getText();
    var newContent = content;
    var offset = 0;
    var diffs;
    var previousDiff;
    diffs = diffMatchPatch.diff_main(text, newText);
    diffs.forEach(function (diff) {
        var _a, _b;
        var _text = diff[1];
        if (diff[0] === 0) {
            if (previousDiff != null) {
                var _previousText = previousDiff[1];
                newContent = removeText(editorState, newContent, block, offset, _previousText);
            }
            offset += _text.length;
            previousDiff = null;
        }
        else if (diff[0] === 1) {
            if (previousDiff == null) {
                (_a = insertText(editorState, newContent, block, offset, _text), newContent = _a.newContent, offset = _a.offset);
            }
            else {
                var _previousText = previousDiff[1];
                (_b = replaceText(editorState, newContent, block, offset, _previousText, _text), newContent = _b.newContent, offset = _b.offset);
                previousDiff = null;
            }
        }
        else {
            if (previousDiff != null) {
                var _previousText = previousDiff[1];
                newContent = removeText(editorState, newContent, block, offset, _previousText);
            }
            if (simpleReplace === true) {
                newContent = removeText(editorState, newContent, block, offset, _text);
            }
            else {
                previousDiff = diff;
            }
        }
    });
    return newContent;
}
/**
 * Insert a new text at offset position
 *
 * @param {EditorState} editorState
 * @param {ContentState} content
 * @param {Block} block
 * @param {Integer} offset
 * @param {String} text
 * @returns {ContentState, Integer}
 */
function insertText(editorState, content, block, offset, text) {
    var selection = createSelectionForBlock(editorState, block, offset);
    var newContent = draft_js_1.Modifier.insertText(content, selection, text);
    // eslint-disable-next-line
    offset += text.length;
    return { newContent: newContent, offset: offset };
}
/**
 * Replate text with newText and preserve the existing inline styles and entities
 *
 * @param {EditorState} editorState
 * @param {ContentState} content
 * @param {Block} block
 * @param {Integer} offset
 * @param {String} text
 * @param {String} newText
 * @returns {ContentState, Integer}
 */
function replaceText(editorState, content, block, offset, text, newText) {
    var overlapLength = text.length < newText.length ? text.length : newText.length;
    var newContent = content;
    for (var i = 0; i < overlapLength; i++) {
        var inlineStyle = block.getInlineStyleAt(offset + i);
        var entity = block.getEntityAt(offset + i);
        var selection = createSelectionForBlock(editorState, block, offset + i, 1);
        var newCharacter = newText[i];
        newContent = draft_js_1.Modifier.replaceText(newContent, selection, newCharacter, inlineStyle, entity);
    }
    // eslint-disable-next-line no-param-reassign
    offset += overlapLength;
    if (overlapLength < text.length) {
        var extraText = text.substring(overlapLength);
        newContent = removeText(editorState, newContent, block, offset, extraText);
    }
    if (overlapLength < newText.length) {
        var lastInlineStyle = block.getInlineStyleAt(overlapLength - 1);
        var lastEntity = block.getEntityAt(overlapLength - 1);
        var extraText = newText.substring(overlapLength);
        var selection = createSelectionForBlock(editorState, block, offset, extraText.length);
        newContent = draft_js_1.Modifier.insertText(newContent, selection, extraText, lastInlineStyle, lastEntity);
        // eslint-disable-next-line no-param-reassign
        offset += extraText.length;
    }
    return { newContent: newContent, offset: offset };
}
/**
 * Remove the 'text' at offset position
 *
 * @param {EditorState} editorState
 * @param {ContentState} content
 * @param {Block} block
 * @param {Integer} offset
 * @param {String} text
 * @returns {ContentState}
 */
function removeText(editorState, content, block, offset, text) {
    var selection = createSelectionForBlock(editorState, block, offset, text.length);
    var newContent = draft_js_1.Modifier.removeRange(content, selection, 'forward');
    return newContent;
}
/**
 * Create a selection in block at the offset
 *
 * @param {EditorState} editorState
 * @param {Block} block
 * @returns {SelectionState}
 */
function createSelectionForBlock(editorState, block, offset, size) {
    if (size === void 0) { size = 0; }
    var selection = editorState.getSelection();
    return selection.merge({
        anchorKey: block.getKey(),
        anchorOffset: offset,
        focusKey: block.getKey(),
        focusOffset: offset + size,
        isBackward: false,
    });
}


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
function diff_match_patch() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
}


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/** @typedef {{0: number, 1: string}} */
diff_match_patch.Diff;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push([DIFF_EQUAL, '']);
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var a = this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = a.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, a[j]);
          }
          pointer = pointer + a.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);
      lineStart = lineEnd + 1;

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
    }
    return chars;
  }

  var chars1 = diff_linesToCharsMunge_(text1);
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var x = 0; x < diffs.length; x++) {
    var chars = diffs[x][1];
    var text = [];
    for (var y = 0; y < chars.length; y++) {
      text[y] = lineArray[chars.charCodeAt(y)];
    }
    diffs[x][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastequality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastequality && (lastequality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastequality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastequality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, insertion.substring(0, overlap_length1)]);
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, deletion.substring(0, overlap_length2)]);
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastequality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastequality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastequality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastequality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastequality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] = [DIFF_INSERT, decodeURI(param)];
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = [DIFF_EQUAL, text];
        } else {
          diffs[diffsLength++] = [DIFF_DELETE, text];
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift([DIFF_EQUAL, prefix]);
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push([DIFF_EQUAL, suffix]);
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] = patch.diffs[y].slice();
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift([DIFF_EQUAL, nullPadding]);
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push([DIFF_EQUAL, nullPadding]);
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push([DIFF_EQUAL, precontext]);
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push([diff_type, diff_text]);
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push([diff_type, diff_text]);
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push([DIFF_EQUAL, postcontext]);
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push([DIFF_DELETE, line]);
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push([DIFF_INSERT, line]);
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push([DIFF_EQUAL, line]);
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emmulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indicies are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// The following export code was added by @ForbesLindesay
module.exports = diff_match_patch;
module.exports['diff_match_patch'] = diff_match_patch;
module.exports['DIFF_DELETE'] = DIFF_DELETE;
module.exports['DIFF_INSERT'] = DIFF_INSERT;
module.exports['DIFF_EQUAL'] = DIFF_EQUAL;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var json5_1 = __importDefault(__webpack_require__(869));
var ng_1 = __importDefault(__webpack_require__(18));
var uuid_1 = __webpack_require__(870);
var lodash_1 = __webpack_require__(2);
// String identifying embed codes that are Qumu widgets.
var QumuString = 'KV.widget';
function getQumuData(html) {
    var configString = getQumuConfigString(html);
    return lodash_1.extend(json5_1.default.parse(configString), {
        selector: "#qumu-" + uuid_1.uuid(),
    });
}
exports.isQumuWidget = function (html) {
    var config = ng_1.default.get('config');
    return config.features != null && config.features.qumu && html.includes(QumuString);
};
var getQumuConfigString = function (html) { return html.slice(html.indexOf('{'), html.lastIndexOf('}') + 1); };
function postProccessQumuEmbed(html) {
    var data = getQumuData(html);
    var configString = getQumuConfigString(html);
    var htmlWithDataReplaced = html.replace(configString, JSON.stringify(data));
    return htmlWithDataReplaced + ("<div id=\"" + data.selector.slice(1) + "\"></div>");
}
exports.postProccessQumuEmbed = postProccessQumuEmbed;
var QumuWidget = /** @class */ (function (_super) {
    __extends(QumuWidget, _super);
    function QumuWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QumuWidget.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.html !== nextProps.html;
    };
    QumuWidget.prototype.componentDidMount = function () {
        KV.widget(this.qumuData); // eslint-disable-line no-undef
    };
    QumuWidget.prototype.componentDidUpdate = function () {
        KV.widget(this.qumuData); // eslint-disable-line no-undef
    };
    QumuWidget.prototype.render = function () {
        this.qumuData = getQumuData(this.props.html);
        return react_1.default.createElement("div", { id: this.qumuData.selector.slice(1), className: "qumu-embed" });
    };
    return QumuWidget;
}(react_1.default.Component));
exports.QumuWidget = QumuWidget;
QumuWidget.propTypes = {
    html: prop_types_1.default.string.isRequired,
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var raven_js_1 = __importDefault(__webpack_require__(165));
var Logger = /** @class */ (function () {
    function Logger() {
        /* globals __SUPERDESK_CONFIG__: true */
        var appConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]};
        if (appConfig.raven && appConfig.raven.dsn.length > 0) {
            raven_js_1.default.config(appConfig.raven.dsn, {
                logger: 'javascript-client',
                release: appConfig.version,
            }).install();
        }
    }
    Logger.prototype.error = function (e) {
        console.error(e);
        raven_js_1.default.captureException(e);
    };
    Logger.prototype.warn = function (message, additionalData) {
        var data = {};
        data['level'] = 'warning';
        if (additionalData != null) {
            try {
                data['extra'] = { additionalData: JSON.stringify(additionalData) };
            }
            catch (e) {
                data['extra'] = { additionalData: 'Failed to serialize' };
            }
        }
        console.warn(message, data);
        if (raven_js_1.default.isSetup()) {
            raven_js_1.default.captureMessage(message, data);
        }
    };
    return Logger;
}());
exports.logger = new Logger();
exports.default = angular.module('superdesk.core.services.logger', [])
    .service('logger', [Logger]);


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
function getDraftSelectionForEntireContent(editorState) {
    var contentState = editorState.getCurrentContent();
    return new draft_js_1.SelectionState({
        anchorKey: contentState.getFirstBlock().getKey(),
        anchorOffset: 0,
        focusKey: contentState.getLastBlock().getKey(),
        focusOffset: contentState.getLastBlock().getLength(),
        isBackward: false,
    });
}
exports.getDraftSelectionForEntireContent = getDraftSelectionForEntireContent;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var highlights_1 = __webpack_require__(41);
function resizeDraftSelection(stretchLeft, stretchRight, selection, editorState, limitedToSingleBlock) {
    if (limitedToSingleBlock === void 0) { limitedToSingleBlock = false; }
    var nextLeft = highlights_1.getBlockAndOffset(editorState, selection, -stretchLeft, false, limitedToSingleBlock);
    var nextRight = highlights_1.getBlockAndOffset(editorState, selection, stretchRight, true, limitedToSingleBlock);
    var nextLeftOffset = nextLeft.newOffset == null ? selection.getStartOffset() : nextLeft.newOffset;
    var nextRightOffset = nextRight.newOffset == null ? selection.getEndOffset() : nextRight.newOffset;
    var nextRightBlockKey = nextRight.block == null ? selection.getEndKey() : nextRight.block.getKey();
    var nextLeftBlockKey = nextLeft.block == null ? selection.getStartKey() : nextLeft.block.getKey();
    return selection.merge({
        anchorKey: selection.getIsBackward() ? nextRightBlockKey : nextLeftBlockKey,
        focusKey: selection.getIsBackward() ? nextLeftBlockKey : nextRightBlockKey,
        anchorOffset: selection.getIsBackward() ? nextRightOffset : nextLeftOffset,
        focusOffset: selection.getIsBackward() ? nextLeftOffset : nextRightOffset,
    });
}
exports.resizeDraftSelection = resizeDraftSelection;


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INLINE_STYLE; });
var BLOCK_TYPE = {
  // This is used to represent a normal text block (paragraph).
  UNSTYLED: 'unstyled',
  HEADER_ONE: 'header-one',
  HEADER_TWO: 'header-two',
  HEADER_THREE: 'header-three',
  HEADER_FOUR: 'header-four',
  HEADER_FIVE: 'header-five',
  HEADER_SIX: 'header-six',
  UNORDERED_LIST_ITEM: 'unordered-list-item',
  ORDERED_LIST_ITEM: 'ordered-list-item',
  BLOCKQUOTE: 'blockquote',
  PULLQUOTE: 'pullquote',
  CODE: 'code-block',
  ATOMIC: 'atomic'
};
var ENTITY_TYPE = {
  LINK: 'LINK',
  IMAGE: 'IMAGE',
  EMBED: 'embed'
};
var INLINE_STYLE = {
  BOLD: 'BOLD',
  CODE: 'CODE',
  ITALIC: 'ITALIC',
  STRIKETHROUGH: 'STRIKETHROUGH',
  UNDERLINE: 'UNDERLINE'
};
/* harmony default export */ __webpack_exports__["d"] = ({
  BLOCK_TYPE: BLOCK_TYPE,
  ENTITY_TYPE: ENTITY_TYPE,
  INLINE_STYLE: INLINE_STYLE
});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyString = function (str) { return typeof str === 'string' && str.length > 0; };
// Unlike `String.prototype.trimStart` this only trims an exact match
exports.trimStartExact = function (str, toTrim) {
    var checkStart = str.slice(0, toTrim.length);
    return checkStart === toTrim ? str.slice(toTrim.length) : str;
};
// Unlike `String.prototype.trimEnd` this only trims an exact match
exports.trimEndExact = function (str, toTrim) {
    var checkEnd = str.slice(str.length - toTrim.length);
    return checkEnd === toTrim ? str.slice(0, str.length - toTrim.length) : str;
};
// type-safe alternative to lodash.pick
function pick(obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var picked = {};
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        picked[key] = obj[key];
    }
    return picked;
}
exports.pick = pick;


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(420);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(897);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(890);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(427);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(190);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Editor3_1 = __webpack_require__(193);
exports.Editor3 = Editor3_1.Editor3;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Group_1 = __webpack_require__(915);
exports.Group = Group_1.Group;
var Item_1 = __webpack_require__(916);
exports.Item = Item_1.Item;
var Border_1 = __webpack_require__(917);
exports.Border = Border_1.Border;
var Column_1 = __webpack_require__(196);
exports.Column = Column_1.Column;
var Row_1 = __webpack_require__(918);
exports.Row = Row_1.Row;
var ActionMenu_1 = __webpack_require__(919);
exports.ActionMenu = ActionMenu_1.ActionMenu;
var ItemType_1 = __webpack_require__(920);
exports.ItemType = ItemType_1.ItemType;
var PubStatus_1 = __webpack_require__(975);
exports.PubStatus = PubStatus_1.PubStatus;
var Header_1 = __webpack_require__(1125);
exports.Header = Header_1.Header;
var NestedItem_1 = __webpack_require__(1126);
exports.NestedItem = NestedItem_1.NestedItem;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
__webpack_require__(90);
/**
 * @ngdoc react
 * @name Label
 * @description Form label component
 */
exports.Label = function (_a) {
    var text = _a.text, row = _a.row, light = _a.light, invalid = _a.invalid;
    return (!text ? null : (react_1.default.createElement("label", { className: classnames_1.default({
            'sd-line-input__label': !row,
            'form-label': row,
            'form-label--light': row && light,
            'form-label--invalid': row && invalid,
        }) }, text)));
};
exports.Label.propTypes = {
    text: prop_types_1.default.string,
    row: prop_types_1.default.bool,
    light: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
};
exports.Label.defaultProps = {
    row: false,
    light: false,
    invalid: false,
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
__webpack_require__(90);
/**
 * @ngdoc react
 * @name Row
 * @description Component to encapsulate a component in Form row style
 */
exports.Row = function (_a) {
    var children = _a.children, flex = _a.flex, noPadding = _a.noPadding, halfWidth = _a.halfWidth, className = _a.className, enabled = _a.enabled;
    return (!enabled ?
        null :
        react_1.default.createElement("div", { className: classnames_1.default('form__row', {
                'form__row--flex': flex,
                'no-padding': noPadding,
                'form__row--half-width': halfWidth,
            }, className) }, children));
};
exports.Row.propTypes = {
    children: prop_types_1.default.node,
    flex: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
    className: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
    ]),
    halfWidth: prop_types_1.default.bool,
    enabled: prop_types_1.default.bool,
};
exports.Row.defaultProps = {
    flex: false,
    noPadding: false,
    halfWidth: false,
    enabled: true,
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name Input
 * @description Text input component
 */
exports.Input = function (_a) {
    var field = _a.field, type = _a.type, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, onBlur = _a.onBlur, onClick = _a.onClick, onFocus = _a.onFocus, readOnly = _a.readOnly, refNode = _a.refNode, className = _a.className, props = __rest(_a, ["field", "type", "value", "onChange", "placeholder", "onBlur", "onClick", "onFocus", "readOnly", "refNode", "className"]);
    var onInputChanged = function (e) {
        var data = e.target.value;
        if (type === 'file') {
            data = e.target.files;
        }
        onChange(field, data);
    };
    return (react_1.default.createElement("input", __assign({ className: className ? "sd-line-input__input " + className : 'sd-line-input__input', type: type, name: field, value: value, placeholder: placeholder, onChange: onInputChanged, onBlur: onBlur, onClick: onClick, onFocus: onFocus, disabled: readOnly, ref: refNode }, props)));
};
exports.Input.propTypes = {
    field: prop_types_1.default.string,
    type: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
    ]),
    onChange: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    onClick: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    refNode: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    className: prop_types_1.default.string,
};
exports.Input.defaultProps = {
    type: 'text',
    readOnly: false,
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
__webpack_require__(90);
/**
 * @ngdoc react
 * @name TextArea
 * @description Auto-resizing component to multi-line text input
 */
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.dom = { input: null };
        _this.autoResize = _this.autoResize.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.delayedResize = null;
        return _this;
    }
    TextArea.prototype.componentDidMount = function () {
        this.delayedResize = lodash_1.debounce(this.autoResize, this.props.autoHeightTimeout);
        if (this.props.autoHeight) {
            this.delayedResize();
        }
    };
    TextArea.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.autoHeight && nextProps.value !== this.props.value) {
            this.delayedResize(nextProps.value);
        }
    };
    TextArea.prototype.autoResize = function (value) {
        if (value === void 0) { value = null; }
        if (this.dom.input) {
            if (value !== null) {
                this.dom.input.value = value;
            }
            // This is required so that when the height is reduced, the scrollHeight
            // is recalculated based on the new height, otherwise it will not
            // shrink the height back down
            this.dom.input.style.height = '5px';
            // Now set the height to the scrollHeight value to display the entire
            // text content
            this.dom.input.style.height = this.dom.input.scrollHeight + "px";
        }
    };
    TextArea.prototype.onChange = function (event) {
        var _a = this.props, nativeOnChange = _a.nativeOnChange, onChange = _a.onChange, field = _a.field, autoHeight = _a.autoHeight, multiLine = _a.multiLine;
        if (nativeOnChange) {
            onChange(event);
        }
        else {
            onChange(field, multiLine ? event.target.value : event.target.value.replace('\n', ''));
        }
        if (autoHeight) {
            this.delayedResize();
        }
    };
    TextArea.prototype.render = function () {
        var _this = this;
        var _a = this.props, field = _a.field, value = _a.value, autoHeight = _a.autoHeight, readOnly = _a.readOnly, placeholder = _a.placeholder, paddingRight60 = _a.paddingRight60, 
        // Remove these variables from the props variable
        // So they are not passed down to the textarea dom node
        // eslint-disable-next-line no-unused-vars
        onChange = _a.onChange, autoHeightTimeout = _a.autoHeightTimeout, nativeOnChange = _a.nativeOnChange, multiLine = _a.multiLine, props = __rest(_a, ["field", "value", "autoHeight", "readOnly", "placeholder", "paddingRight60", "onChange", "autoHeightTimeout", "nativeOnChange", "multiLine"]);
        return (react_1.default.createElement("textarea", __assign({ ref: function (node) { return _this.dom.input = node; }, className: classnames_1.default('sd-line-input__input', {
                'sd-line-input__input--auto-height': autoHeight,
                'sd-line-input__input--padding-right-60': paddingRight60,
            }), value: value, name: field, disabled: readOnly, placeholder: readOnly ? '' : placeholder }, props, { onChange: readOnly ? null : this.onChange })));
    };
    return TextArea;
}(react_1.default.Component));
exports.TextArea = TextArea;
TextArea.propTypes = {
    field: prop_types_1.default.string,
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func.isRequired,
    autoHeight: prop_types_1.default.bool,
    autoHeightTimeout: prop_types_1.default.number,
    nativeOnChange: prop_types_1.default.bool,
    placeholder: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    paddingRight60: prop_types_1.default.bool,
    multiLine: prop_types_1.default.bool,
};
TextArea.defaultProps = {
    readOnly: false,
    autoHeight: true,
    autoHeightTimeout: 50,
    nativeOnChange: false,
    paddingRight60: false,
    multiLine: true,
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(932);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc react
 * @name Label
 * @description Label used in a popup, typically in header
 */
var Label = function (_a) {
    var text = _a.text, children = _a.children, centerText = _a.centerText;
    return (react_1.default.createElement("span", { className: classnames_1.default('popup__menu-label', { 'popup__menu-label--center': centerText }) },
        utils_1.gettext(text),
        children));
};
Label.propTypes = {
    text: prop_types_1.default.string,
    children: prop_types_1.default.node,
    centerText: prop_types_1.default.bool,
};
Label.defaultProps = { centerText: false };
exports.default = Label;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Menu
 * @description Menu Component in a popup
 */
var Menu = function (_a) {
    var children = _a.children, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu', { 'popup__menu--no-padding': noPadding }) }, children));
};
Menu.propTypes = {
    children: prop_types_1.default.node.isRequired,
    noPadding: prop_types_1.default.bool,
};
Menu.defaultProps = { noPadding: false };
exports.default = Menu;


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortalCompat__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PortalWithState__ = __webpack_require__(940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_0__PortalCompat__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PortalWithState", function() { return __WEBPACK_IMPORTED_MODULE_1__PortalWithState__["a"]; });





/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Portal__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__ = __webpack_require__(939);





var Portal = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.createPortal) {
  Portal = __WEBPACK_IMPORTED_MODULE_1__Portal__["a" /* default */];
} else {
  Portal = __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(949);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(960);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
/**
 * @ngdoc react
 * @name Button
 * @description Generic Button component
 */
var Button = function (_a) {
    var className = _a.className, onClick = _a.onClick, icon = _a.icon, title = _a.title, text = _a.text, disabled = _a.disabled, textOnly = _a.textOnly, hollow = _a.hollow, expanded = _a.expanded, color = _a.color, size = _a.size, iconOnly = _a.iconOnly, tabIndex = _a.tabIndex, enterKeyIsClick = _a.enterKeyIsClick, autoFocus = _a.autoFocus, refNode = _a.refNode, onKeyDown = _a.onKeyDown, iconOnlyCircle = _a.iconOnlyCircle, children = _a.children, pullRight = _a.pullRight, props = __rest(_a, ["className", "onClick", "icon", "title", "text", "disabled", "textOnly", "hollow", "expanded", "color", "size", "iconOnly", "tabIndex", "enterKeyIsClick", "autoFocus", "refNode", "onKeyDown", "iconOnlyCircle", "children", "pullRight"]);
    var handeKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ENTER) {
            utils_1.onEventCapture(event);
            onClick();
            return;
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    return (react_1.default.createElement("button", __assign({ className: classnames_1.default('btn', color ? "btn--" + color : null, size ? "btn--" + size : null, {
            'btn--disabled': disabled,
            'btn--text-only': textOnly,
            'btn--hollow': hollow,
            'btn--expanded': expanded,
            'btn--icon-only': iconOnly,
            'btn--icon-only-circle': iconOnlyCircle,
            'pull-right': pullRight,
        }, className), onClick: disabled ? null : onClick || null, title: title, tabIndex: tabIndex, onKeyDown: enterKeyIsClick ? handeKeyDown : onKeyDown, autoFocus: autoFocus, ref: refNode }, props),
        icon && react_1.default.createElement("i", { className: icon }),
        !iconOnly && text,
        children));
};
Button.propTypes = {
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func.isRequired,
    icon: prop_types_1.default.string,
    title: prop_types_1.default.string,
    text: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    textOnly: prop_types_1.default.bool,
    hollow: prop_types_1.default.bool,
    iconOnly: prop_types_1.default.bool,
    expanded: prop_types_1.default.bool,
    color: prop_types_1.default.oneOf(['primary', 'success', 'warning', 'alert', 'highlight', 'sd-green', 'ui-dark', 'default']),
    size: prop_types_1.default.oneOf(['small', 'large']),
    tabIndex: prop_types_1.default.number,
    enterKeyIsClick: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
    onKeyDown: prop_types_1.default.func,
    refNode: prop_types_1.default.func,
    iconOnlyCircle: prop_types_1.default.bool,
    children: prop_types_1.default.node,
    pullRight: prop_types_1.default.bool,
};
Button.defaultProps = {
    disabled: false,
    textOnly: false,
    hollow: false,
    iconOnly: false,
    expanded: false,
    enterKeyIsClick: false,
    autoFocus: false,
    iconOnlyCircle: false,
    pullRight: false,
};
exports.default = Button;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(977), __esModule: true };

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(61) && !__webpack_require__(95)(function () {
  return Object.defineProperty(__webpack_require__(444)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(94);
var document = __webpack_require__(67).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(81);
var toIObject = __webpack_require__(82);
var arrayIndexOf = __webpack_require__(981)(false);
var IE_PROTO = __webpack_require__(203)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(200);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(202);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(985)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(449)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(136);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(450);
var hide = __webpack_require__(92);
var Iterators = __webpack_require__(119);
var $iterCreate = __webpack_require__(986);
var setToStringTag = __webpack_require__(209);
var getPrototypeOf = __webpack_require__(451);
var ITERATOR = __webpack_require__(53)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(92);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(81);
var toObject = __webpack_require__(118);
var IE_PROTO = __webpack_require__(203)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(445);
var hiddenKeys = __webpack_require__(205).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(117);
var createDesc = __webpack_require__(115);
var toIObject = __webpack_require__(82);
var toPrimitive = __webpack_require__(199);
var has = __webpack_require__(81);
var IE8_DOM_DEFINE = __webpack_require__(443);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(61) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_PropTypes__ = __webpack_require__(457);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_11__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};

var defaultProps = {
  accordion: false
};

var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  PanelGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        accordion = _props.accordion,
        generateChildId = _props.generateChildId,
        id = _props.id;

    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + '-' + type + '-' + key : null;
      };
    }

    return {
      $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  PanelGroup.prototype.render = function render() {
    var _props2 = this.props,
        accordion = _props2.accordion,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['accordion', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        });
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1012), __esModule: true };

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(61);
var getKeys = __webpack_require__(116);
var toIObject = __webpack_require__(82);
var isEnum = __webpack_require__(117).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(39);





var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);

function generatedId(name) {
  return function (props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var error = null;

    if (!props.generateChildId) {
      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize the ' + name + ' in a way that is accessible to assistive technologies ' + ('(such as screen readers) an `id` or a `generateChildId` prop to ' + name + ' is required'));
      }
    }
    return error;
  };
}

function requiredRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1019);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition__);











var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1025));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(464));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(15));

var _reactLifecyclesCompat = __webpack_require__(1037);

var _PropTypes = __webpack_require__(1038);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1035)();
}


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(97));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1040), __esModule: true };

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(98);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(468);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(218);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(219);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('container', Grid));

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(35);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(146);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(97);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(145);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(147);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1081);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-body', ModalBody));

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-footer', ModalFooter));

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(212);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      closeButton && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-header', ModalHeader));

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal-title', ModalTitle));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(39);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'nav')] = true;

      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('nav', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsStyles"])(['tabs', 'pills'], Nav)));

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(143);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { transition: transition }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(98));

var _isWindow = _interopRequireDefault(__webpack_require__(146));

var _ownerDocument = _interopRequireDefault(__webpack_require__(97));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(146));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(216);










var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var PanelCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelCollapse, _React$Component);

  function PanelCollapse() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelCollapse);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelCollapse.prototype.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["splitBsProps"])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["prefix"])(bsProps, 'collapse') },
        children
      )
    );
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["bsClass"])('panel', PanelCollapse));

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);











var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */]
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var PanelToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelToggle, _React$Component);

  function PanelToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args)));

    _this.handleToggle = _this.handleToggle.bind(_this);
    return _this;
  }

  PanelToggle.prototype.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  PanelToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        componentClass = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'componentClass']);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;

    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);

    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(143);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this.in = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('tab-pane', TabPane));

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(120);










var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired
};

var ToggleButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButton, _React$Component);

  function ToggleButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    var disabled = props.disabled;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { active: !!checked, componentClass: 'label' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        disabled: !!disabled,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Tabs_1 = __webpack_require__(1136);
exports.Tabs = Tabs_1.Tabs;
var Button_1 = __webpack_require__(1137);
exports.Button = Button_1.Button;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name ButtonStack
 * @description Stack of buttons of a Sub Nav bar
 */
exports.ButtonStack = function (_a) {
    var children = _a.children, right = _a.right, padded = _a.padded, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('subnav__button-stack', {
            'subnav__button-stack--right': right,
            'subnav__button-stack--padded': padded,
        }, className) }, children));
};
exports.ButtonStack.propTypes = {
    children: prop_types_1.default.node,
    right: prop_types_1.default.bool,
    padded: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.ButtonStack.defaultProps = {
    right: false,
    padded: false,
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var react_bootstrap_1 = __webpack_require__(135);
var constants_1 = __webpack_require__(28);
/**
 * @ngdoc react
 * @name Icon
 * @description Generic Icon component with tooltip
 */
var Icon = function (_a) {
    var icon = _a.icon, doubleSize = _a.doubleSize, big = _a.big, className = _a.className, tooltip = _a.tooltip, color = _a.color;
    var iconElement = (react_1.default.createElement("i", { className: classnames_1.default(icon, {
            'icon--2x': doubleSize,
            'double-size-icn': big,
        }, color, className) }));
    return tooltip ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "icon_list_item" }, tooltip) }, iconElement)) :
        iconElement;
};
Icon.propTypes = {
    icon: prop_types_1.default.string,
    big: prop_types_1.default.bool,
    doubleSize: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    tooltip: prop_types_1.default.string,
    color: prop_types_1.default.oneOf(lodash_1.values(constants_1.ICON_COLORS)),
};
Icon.defaultProps = {
    big: false,
    doubleSize: false,
};
exports.default = Icon;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CommentInput_1 = __webpack_require__(1195);
exports.CommentInput = CommentInput_1.CommentInput;
var CommentPopup_1 = __webpack_require__(1314);
exports.CommentPopup = CommentPopup_1.CommentPopup;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1204),
    isArguments = __webpack_require__(496),
    isArray = __webpack_require__(71),
    isBuffer = __webpack_require__(225),
    isIndex = __webpack_require__(1209),
    isTypedArray = __webpack_require__(498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1205),
    isObjectLike = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1210),
    baseUnary = __webpack_require__(226),
    nodeUtil = __webpack_require__(227);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 500 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(502),
    isLength = __webpack_require__(499);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(101),
    isObject = __webpack_require__(122);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(229),
    baseClone = __webpack_require__(1215),
    baseUnset = __webpack_require__(1268),
    castPath = __webpack_require__(237),
    copyObject = __webpack_require__(123),
    customOmitClone = __webpack_require__(1279),
    flatRest = __webpack_require__(1281),
    getAllKeysIn = __webpack_require__(514);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151),
    stackClear = __webpack_require__(1221),
    stackDelete = __webpack_require__(1222),
    stackGet = __webpack_require__(1223),
    stackHas = __webpack_require__(1224),
    stackSet = __webpack_require__(1225);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(507),
    eq = __webpack_require__(230);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(508);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(495),
    baseKeysIn = __webpack_require__(1245),
    isArrayLike = __webpack_require__(501);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 510 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(234),
    getPrototype = __webpack_require__(235),
    getSymbols = __webpack_require__(233),
    stubArray = __webpack_require__(510);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(513),
    getSymbols = __webpack_require__(233),
    keys = __webpack_require__(100);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(234),
    isArray = __webpack_require__(71);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(513),
    getSymbolsIn = __webpack_require__(511),
    keysIn = __webpack_require__(509);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(238);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1292);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1294),
    arraySome = __webpack_require__(1297),
    cacheHas = __webpack_require__(1298);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(156);

var _defaultPropsDecorator = __webpack_require__(520);

var _defaultPropsDecorator2 = _interopRequireDefault(_defaultPropsDecorator);

var _pickStyles = __webpack_require__(521);

var _filterKeys = __webpack_require__(522);

var _coerceSelection = __webpack_require__(523);

var _coerceSelection2 = _interopRequireDefault(_coerceSelection);

var _memoize = __webpack_require__(1303);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var guessBaseClassName = function guessBaseClassName(classNames) {
  // all class names must start with the same prefix: the component's base class name
  // which will finally go to the container element
  var firstKey = classNames && (0, _utils.keys)(classNames)[0];
  return firstKey && firstKey.split('__')[0].split('--')[0];
};

var deriveClassNames = function deriveClassNames(className, elementKeys, modifierKeys) {
  // do not derive class names, if the user did not specify any class name
  if (!className) {
    return undefined;
  }

  // derive class names based using the passed modifier/element keys
  var firstClassName = className.split(' ')[0];
  var derivedClassNames = [].concat(_toConsumableArray(elementKeys.length === 0 ? modifierKeys.map(function (key) {
    return firstClassName + '--' + key.substring(1);
  }) : []), _toConsumableArray(elementKeys.map(function (key) {
    return firstClassName + '__' + key;
  })));

  // also use the provided `className` if there is no sub-element selection
  return elementKeys.length === 0 ? [className].concat(_toConsumableArray(derivedClassNames)) : derivedClassNames;
};

function createSubstyle(_ref) {
  var style = _ref.style,
      className = _ref.className,
      classNames = _ref.classNames;
  var propsDecorator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _defaultPropsDecorator2.default;

  var baseClassName = className || guessBaseClassName(classNames);

  var substyle = typeof style === 'function' ? style : (0, _memoize2.default)(function (select, defaultStyle) {
    var selectedKeys = (0, _coerceSelection2.default)(select);

    (0, _invariant2.default)(Array.isArray(selectedKeys), 'First parameter must be a string, an array of strings, ' + 'a plain object with boolean values, or a falsy value.');

    (0, _invariant2.default)(!defaultStyle || (0, _utils.isPlainObject)(defaultStyle), 'Optional second parameter must be a plain object.');

    var modifierKeys = selectedKeys.filter(_filterKeys.isModifier);
    var elementKeys = selectedKeys.filter(_filterKeys.isElement);

    var collectElementStyles = elementKeys.length > 0 ? function (fromStyle) {
      return (0, _utils.values)((0, _pickStyles.pickNestedStyles)(fromStyle, elementKeys));
    } : function (fromStyle) {
      return [fromStyle];
    };

    var collectSelectedStyles = function collectSelectedStyles() {
      var fromStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return collectElementStyles((0, _pickStyles.hoistModifierStylesRecursive)(fromStyle, modifierKeys));
    };

    var derivedClassNames = deriveClassNames(baseClassName, elementKeys, modifierKeys);

    return createSubstyle(_extends({}, (style || defaultStyle) && {
      style: _utils.merge.apply(undefined, [{}].concat(_toConsumableArray(collectSelectedStyles(defaultStyle)), _toConsumableArray(collectSelectedStyles(style))))
    }, derivedClassNames && {
      className: derivedClassNames.join(' ')
    }, classNames && { classNames: classNames }), propsDecorator);
  });

  // $FlowFixMe Flow does not believe that also a function can be spread
  var styleProps = _extends({}, typeof style === 'function' ? style : { style: style });

  var classNameSplit = [].concat(_toConsumableArray(styleProps.className ? styleProps.className.split(' ') : []), _toConsumableArray(baseClassName ? baseClassName.split(' ') : []));
  var mappedClassNames = classNames ? (0, _utils.compact)(classNameSplit.map(function (singleClassName) {
    return classNames[singleClassName];
  })) : classNameSplit;

  var propsForSpread = propsDecorator(_extends({}, styleProps, mappedClassNames.length > 0 ? {
    className: mappedClassNames.join(' ')
  } : {}));

  // assign `style` and/or `className` props to the return function object
  (0, _utils.assign)(substyle, propsForSpread);
  return substyle;
}

exports.default = createSubstyle;
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pickStyles = __webpack_require__(521);

// many css-in-js libs process keyframes objects as the value for `animationName`
var defaultObjectPropsWhitelist = ['animationName'];

var defaultPropsDecorator = function defaultPropsDecorator(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _extends({}, style ? { style: (0, _pickStyles.pickDirectStyles)(style, defaultObjectPropsWhitelist) } : {}, className ? { className: className } : {});
};

exports.default = defaultPropsDecorator;
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hoistModifierStylesRecursive = exports.pickNestedStyles = exports.pickDirectStyles = undefined;

var _utils = __webpack_require__(156);

var _filterKeys = __webpack_require__(522);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var camelize = function camelize(key) {
  return key.replace(/-(\w)/g, function (m, c) {
    return c.toUpperCase();
  });
};

var pickDirectStyles = exports.pickDirectStyles = function pickDirectStyles(style) {
  var objectPropertiesWhitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styleKeys = (0, _utils.keys)(style);
  var result = {};
  for (var i = 0, l = styleKeys.length; i < l; i += 1) {
    var key = styleKeys[i];
    var isDirect = Object.prototype.toString.call(style[key]) !== '[object Object]' || // style defs
    key[0] === ':' || // pseudo selectors
    key[0] === '@' || // @media / @keyframes / @supports / @font-face
    objectPropertiesWhitelist.indexOf(key) >= 0; // whitelisted object-type properties

    if (isDirect) {
      result[key] = style[key];
    }
  }
  return result;
};

var pickNestedStyles = exports.pickNestedStyles = function pickNestedStyles(style, keysToPick) {
  var camelizedKeysToPick = keysToPick.map(camelize);
  var styleKeys = (0, _utils.keys)(style);
  var result = {};
  for (var i = 0, l = styleKeys.length; i < l; i += 1) {
    var key = styleKeys[i];
    if (keysToPick.indexOf(key) >= 0 || camelizedKeysToPick.indexOf(camelize(key)) >= 0) {
      result[key] = style[key];
    }
  }
  return result;
};

// breadth-first hoisting of selected modifier style subtrees
// does not traverse into element, :pseudo-selector or @directive subtrees
var hoistModifierStylesRecursive = exports.hoistModifierStylesRecursive = function hoistModifierStylesRecursive(style, modifierKeysToPick) {
  // hoist styles for selected modifiers on current level
  var result = _utils.merge.apply(undefined, [{}, (0, _utils.omit)(style, modifierKeysToPick)].concat(_toConsumableArray((0, _utils.values)(pickNestedStyles(style, modifierKeysToPick)))));

  // traverse nested styled for ALL modifiers
  var modifierKeys = (0, _utils.keys)(result).filter(_filterKeys.isModifier);
  for (var i = 0, l = modifierKeys.length; i < l; i += 1) {
    var key = modifierKeys[i];
    var subresult = hoistModifierStylesRecursive(result[key], modifierKeysToPick);
    if (modifierKeysToPick.indexOf(key) >= 0) {
      // selected modifier: hoist subresult
      delete result[key];
      result = (0, _utils.merge)({}, result, subresult);
    } else {
      // non-selected modifier: replace with subresult
      result[key] = subresult;
    }
  }

  return result;
};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isModifier = exports.isModifier = function isModifier(key) {
  return key[0] === '&';
};
var isElement = exports.isElement = function isElement(key) {
  return !isModifier(key);
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(156);

var coerceSelection = function coerceSelection(select) {
  if (!select) {
    return [];
  } else if (typeof select === 'string') {
    return [select];
  } else if (!Array.isArray(select)) {
    var objSelect = select; // workaround for https://github.com/facebook/flow/issues/5781
    return (0, _utils.keys)(select).reduce(function (acc, key) {
      return acc.concat(objSelect[key] ? [key] : []);
    }, []);
  }
  return select;
};
exports.default = coerceSelection;
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextTypes = exports.PropTypes = exports.PROPS_DECORATOR_CONTEXT_NAME = exports.ENHANCER_CONTEXT_NAME = undefined;

var _ContextTypes;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ENHANCER_CONTEXT_NAME = exports.ENHANCER_CONTEXT_NAME = '__substyle__enhancer';
var PROPS_DECORATOR_CONTEXT_NAME = exports.PROPS_DECORATOR_CONTEXT_NAME = '__substyle__propsDecorator';

var StylePT = _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]);

var ClassNamesPT = _propTypes2.default.objectOf(_propTypes2.default.string);

var PropTypes = exports.PropTypes = {
  style: StylePT,
  className: _propTypes2.default.string,
  classNames: ClassNamesPT,
  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    current: typeof Element === 'undefined' ? _propTypes2.default.any : _propTypes2.default.instanceOf(Element)
  })])
};

var ContextTypes = exports.ContextTypes = (_ContextTypes = {}, _defineProperty(_ContextTypes, ENHANCER_CONTEXT_NAME, _propTypes2.default.func), _defineProperty(_ContextTypes, PROPS_DECORATOR_CONTEXT_NAME, _propTypes2.default.func), _ContextTypes);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(466);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _substyle = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styled = (0, _substyle.defaultStyle)({
  fontWeight: "inherit"
});

var Mention = styled(function (_ref) {
  var display = _ref.display,
      style = _ref.style;
  return _react2.default.createElement(
    'strong',
    style,
    display
  );
});

Mention.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,

  renderSuggestion: _propTypes2.default.func,

  trigger: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)]),

  isLoading: _propTypes2.default.bool
};

Mention.defaultProps = {
  trigger: "@",

  onAdd: function onAdd() {
    return null;
  },
  onRemove: function onRemove() {
    return null;
  },
  renderSuggestion: null,
  isLoading: false,
  appendSpaceOnAdd: false
};

exports.default = Mention;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserAvatar_1 = __webpack_require__(91);
exports.UserAvatar = UserAvatar_1.UserAvatar;
var TextWithMentions_1 = __webpack_require__(1312);
exports.TextWithMentions = TextWithMentions_1.TextWithMentions;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AnnotationInput_1 = __webpack_require__(1316);
exports.AnnotationInput = AnnotationInput_1.AnnotationInput;
var AnnotationPopup_1 = __webpack_require__(1326);
exports.AnnotationPopup = AnnotationPopup_1.AnnotationPopup;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var store_1 = __importDefault(__webpack_require__(157));
var components_1 = __webpack_require__(428);
var react_redux_1 = __webpack_require__(25);
var ng_1 = __importDefault(__webpack_require__(18));
var draft_js_1 = __webpack_require__(16);
var editor3_1 = __webpack_require__(175);
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc React
 * @name Editor
 * @description Editor as a React component. Standalone means that it isn't connected to article item.
 */
var Editor3Standalone = /** @class */ (function (_super) {
    __extends(Editor3Standalone, _super);
    function Editor3Standalone(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeInterceptor = _this.onChangeInterceptor.bind(_this);
        var _a = _this.props, disableSpellchecker = _a.disableSpellchecker, language = _a.language, readOnly = _a.readOnly, singleLine = _a.singleLine, tabindex = _a.tabindex, showTitle = _a.showTitle, editorFormat = _a.editorFormat;
        var store = store_1.default({
            disableSpellchecker: disableSpellchecker,
            language: language,
            readOnly: readOnly,
            singleLine: singleLine,
            tabindex: tabindex,
            showTitle: showTitle,
            editorFormat: editorFormat,
            editorState: _this.props.rawDraftContentState,
            onChange: _this.onChangeInterceptor,
        }, null, true);
        if (props.findReplaceTarget) {
            ng_1.default.get('editor3').setStore(store);
        }
        _this.store = store;
        return _this;
    }
    Editor3Standalone.prototype.onChangeInterceptor = function (contentState) {
        // ensure that onChange value is of the same type as received from the props
        var rawState = draft_js_1.convertToRaw(contentState);
        this.props.onChange(rawState);
    };
    Editor3Standalone.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.readOnly !== prevProps.readOnly) {
            this.store.dispatch(editor3_1.setReadOnly(this.props.readOnly));
        }
        var rawStateFromStore = draft_js_1.convertToRaw(this.store.getState().editorState.getCurrentContent());
        if (lodash_1.isEqual(this.props.rawDraftContentState, rawStateFromStore) === false) {
            // This component holds it's own state which is derived from props
            // internal state is reloaded when it doesn't match with what's in the props
            this.store.dispatch(editor3_1.changeEditorState(draft_js_1.EditorState.createWithContent(draft_js_1.convertFromRaw(this.props.rawDraftContentState)), true));
        }
    };
    Editor3Standalone.prototype.render = function () {
        var _a = this.props, scrollContainer = _a.scrollContainer, singleLine = _a.singleLine;
        return (react_1.default.createElement(react_redux_1.Provider, { store: this.store },
            react_1.default.createElement(components_1.Editor3, { scrollContainer: scrollContainer, singleLine: singleLine })));
    };
    Editor3Standalone.defaultProps = {
        findReplaceTarget: false,
        highlights: false,
        editorFormat: [],
        html: '',
        readOnly: false,
        singleLine: false,
        onChangeDebounce: 100,
        disableSpellchecker: true,
        showTitle: false,
        tabindex: 0,
    };
    return Editor3Standalone;
}(react_1.default.Component));
exports.Editor3Standalone = Editor3Standalone;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (html) {
  var doc = void 0;
  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');
  } else {
    doc = document.implementation.createHTMLDocument('');
    doc.documentElement.innerHTML = html;
  }
  return doc.body;
};

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var inlineStyles_1 = __webpack_require__(113);
var selection_1 = __webpack_require__(87);
/**
 * @name removeInlineStyle
 * @description Returns a new content state with all the styles indicated in `styles`
 * removed.
 * @param {ContentState} content
 * @param {Array<string>} styles Styles to remove.
 * @returns {ContentState}
 */
function removeInlineStyles(content, styles) {
    var contentState = content;
    var filterFn = function (c) { return styles.some(function (s) { return c.hasStyle(s); }); };
    contentState.getBlocksAsArray().forEach(function (b) {
        b.findStyleRanges(filterFn, function (start, end) {
            var empty = draft_js_1.SelectionState.createEmpty(b.getKey());
            var selection = empty.merge({ anchorOffset: start, focusOffset: end });
            styles.forEach(function (s) {
                contentState = draft_js_1.Modifier.removeInlineStyle(contentState, selection, s);
            });
        });
    });
    return contentState;
}
exports.removeInlineStyles = removeInlineStyles;
/*
 * @ngdoc method
 * @name removeInlineStylesForSelection
 * @param {Object} content ContentState
 * @param {Object} selection SelectionState
 * @description Remove all inline styles from selection
 * @return {Object} ContentState
 */
function removeInlineStylesForSelection(content, selection) {
    var contentWithoutStyles = inlineStyles_1.acceptedInlineStyles.reduce(function (newContentState, style) {
        return draft_js_1.Modifier.removeInlineStyle(newContentState, selection, style);
    }, content);
    return contentWithoutStyles;
}
exports.removeInlineStylesForSelection = removeInlineStylesForSelection;
/*
 * @ngdoc method
 * @name removeBlockStyles
 * @param {Object} editorState
 * @param {Object} content ContentState
 * @param {Object} selection SelectionState
 * @description Set all blocks in selection to unstyled except keepTypes
 * @return {Object} ContentState
 */
function removeBlockStyles(editorState, content, selection, keepTypes) {
    var blockArray = content.getBlocksAsArray().map(function (block) {
        var shouldRemoveStyle = block.getType() !== 'unstyled' &&
            !keepTypes.includes(block.getType()) &&
            selection_1.blockInsideSelection(editorState, block.getKey());
        if (!shouldRemoveStyle) {
            return block;
        }
        return new draft_js_1.ContentBlock({
            type: 'unstyled',
            text: block.getText(),
            key: block.getKey(),
            characterList: block.getCharacterList(),
            data: block.getData(),
        });
    });
    return draft_js_1.ContentState.createFromBlockArray(blockArray);
}
exports.removeBlockStyles = removeBlockStyles;
/*
 * @ngdoc method
 * @name removeFormatFromState
 * @param {Object} editorState
 * @description Set all blocks in selection to unstyled except atomic blocks
 * @return {Object} EditorState
 */
function removeFormatFromState(editorState) {
    var selection = editorState.getSelection();
    var contentWithoutInlineStyles = removeInlineStylesForSelection(editorState.getCurrentContent(), selection);
    var contentWithoutBlockStyles = removeBlockStyles(editorState, contentWithoutInlineStyles, selection, ['atomic']);
    // Push new editor state as only one change so 'UNDO' will change both at the same type
    return draft_js_1.EditorState.push(editorState, contentWithoutBlockStyles, 'change-block-type');
}
exports.removeFormatFromState = removeFormatFromState;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var editor3_1 = __webpack_require__(104);
var Editor3_1 = __webpack_require__(193);
var suggestions_1 = __webpack_require__(539);
var suggestions_2 = __webpack_require__(385);
var spellchecker = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'SPELLCHECKER_REPLACE_WORD':
            return exports.replaceWord(state, action.payload);
        case 'SPELLCHECKER_REFRESH_WORD':
            return refreshWord(state, action.payload);
        case 'SPELLCHECKER_AUTO':
            return autoSpellchecker(state, action.payload);
        default:
            return state;
    }
};
/**
 * @ngdoc method
 * @name replaceWord
 * @param {Object} state
 * @param {String} word
 * @return {Object} returns new state
 * @description Replace the current word with the new selected one
 */
exports.replaceWord = function (state, _a, skipOnChange) {
    var word = _a.word, newWord = _a.newWord;
    if (skipOnChange === void 0) { skipOnChange = false; }
    var editorState = state.editorState, suggestingMode = state.suggestingMode;
    if (word.text === newWord) {
        return editor3_1.onChange(state, editorState, true);
    }
    if (suggestingMode) {
        var data = suggestions_2.getSuggestionMetadata();
        var wordSelection = editorState.getSelection().merge({
            anchorOffset: word.offset,
            focusOffset: word.offset + word.text.length,
            hasFocus: true,
        });
        return suggestions_1.createAddSuggestion(state, { text: newWord, data: data }, wordSelection);
    }
    else {
        var selection = editorState.getSelection();
        var newSelection = selection.merge({
            anchorOffset: word.offset + newWord.length,
            focusOffset: word.offset + newWord.length,
            hasFocus: true,
        });
        var newContent = editorState.getCurrentContent();
        var block = newContent.getBlockForKey(selection.getStartKey());
        var length = word.text.length < newWord.length ? word.text.length : newWord.length;
        for (var i = 0; i < length; i++) {
            var characterSelection = selection.merge({
                anchorOffset: word.offset + i,
                focusOffset: word.offset + i + 1,
                hasFocus: true,
            });
            var inlineStyle = block.getInlineStyleAt(word.offset + i);
            newContent = draft_js_1.Modifier.replaceText(newContent, characterSelection, newWord[i], inlineStyle);
        }
        if (word.text.length < newWord.length) {
            // insert remaining text
            var insertSelection = selection.merge({
                anchorOffset: word.offset + word.text.length,
                focusOffset: word.offset + word.text.length,
            });
            var text = newWord.substring(word.text.length);
            var inlineStyle = block.getInlineStyleAt(word.offset + word.text.length - 1);
            newContent = draft_js_1.Modifier.replaceText(newContent, insertSelection, text, inlineStyle);
        }
        if (word.text.length > newWord.length) {
            // delete extra text
            var deleteSelection = selection.merge({
                anchorOffset: word.offset + newWord.length,
                focusOffset: word.offset + word.text.length,
            });
            newContent = draft_js_1.Modifier.replaceText(newContent, deleteSelection, '');
        }
        var newState = draft_js_1.EditorState.push(editorState, newContent, 'spellcheck-change');
        newState = draft_js_1.EditorState.acceptSelection(newState, newSelection);
        if (skipOnChange) {
            return __assign({}, state, { editorState: newState });
        }
        return editor3_1.onChange(state, newState);
    }
};
/**
 * @ngdoc method
 * @name refreshWord
 * @param {Object} state
 * @param {String} word
 * @return {Object} returns new state
 * @description Refreshes the current word (usually after having being added to the
 * dictionary).
 */
var refreshWord = function (state, word) { return exports.replaceWord(state, { word: word, newWord: word.text }); };
/**
 * @ngdoc method
 * @name autoSpelchecker
 * @param {Object} state
 * @param {Boolean} spellcheckerEnabled True if the autospellchecker should be enabled
 * @return {Object} returns new state
 * @description Disable/enable auto mode for spellchecker.
 */
var autoSpellchecker = function (state, spellcheckerEnabled) {
    var editorState = state.editorState;
    var Editor3Alias = Editor3_1.Editor3;
    var decorator = Editor3Alias.getDecorator(!spellcheckerEnabled);
    var newState = draft_js_1.EditorState.set(editorState, { decorator: decorator });
    var stateNotChanged = false;
    return __assign({}, editor3_1.onChange(state, newState, stateNotChanged), { spellcheckerEnabled: spellcheckerEnabled });
};
exports.default = spellchecker;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var entityUtils = __importStar(__webpack_require__(79));
var editor3_1 = __webpack_require__(104);
var Links = __importStar(__webpack_require__(535));
var Blocks = __importStar(__webpack_require__(1322));
var Highlights = __importStar(__webpack_require__(41));
var removeFormat_1 = __webpack_require__(532);
var draftInsertEntity_1 = __webpack_require__(536);
/**
 * @description Contains the list of toolbar related reducers.
 */
var toolbar = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'TOOLBAR_TOGGLE_BLOCK_STYLE':
            return toggleBlockStyle(state, action.payload);
        case 'TOOLBAR_TOGGLE_INLINE_STYLE':
            return toggleInlineStyle(state, action.payload);
        case 'TOOLBAR_APPLY_LINK':
            return applyLink(state, action.payload);
        case 'TOOLBAR_REMOVE_LINK':
            return removeLink(state);
        case 'TOOLBAR_REMOVE_FORMAT':
            return removeFormat(state);
        case 'TOOLBAR_INSERT_MEDIA':
            return insertMedia(state, action.payload);
        case 'TOOLBAR_UPDATE_IMAGE':
            return updateImage(state, action.payload);
        case 'TOOLBAR_REMOVE_BLOCK':
            return removeBlock(state, action.payload);
        case 'TOOLBAR_SET_POPUP':
            return setPopup(state, action.payload);
        case 'TOOLBAR_TOGGLE_INVISIBLES':
            return toggleInvisibles(state);
        default:
            return state;
    }
};
/**
 * @ngdoc method
 * @name toggleBlockStyle
 * @param {string} blockStyle
 * @description Applies the given block style.
 */
var toggleBlockStyle = function (state, blockType) {
    var editorState = state.editorState;
    var stateAfterChange = draft_js_1.RichUtils.toggleBlockType(editorState, blockType);
    return editor3_1.onChange(state, stateAfterChange);
};
/**
 * @ngdoc method
 * @name toggleInlineStyle
 * @param {string} inlineStyle
 * @description Applies the given inline style.
 */
var toggleInlineStyle = function (state, inlineStyle) {
    var editorState = state.editorState;
    var stateAfterChange = draft_js_1.RichUtils.toggleInlineStyle(editorState, inlineStyle);
    // Check if there was a suggestions to toggle that style
    stateAfterChange = handleExistingInlineStyleSuggestionOnToggle(stateAfterChange, inlineStyle);
    return editor3_1.onChange(state, stateAfterChange);
};
var handleExistingInlineStyleSuggestionOnToggle = function (editorState, inlineStyle) {
    var type = Highlights.getTypeByInlineStyle(inlineStyle);
    var highlightName = Highlights.getHighlightStyleAtCurrentPosition(editorState, type);
    if (highlightName) {
        return Highlights.removeHighlight(editorState, highlightName);
    }
    return editorState;
};
/**
 * @ngdoc method
 * @name applyLink
 * @param {Object} link Link data to apply
 * @param {Entity|null} entity The entity to apply the URL too.
 * @description Applies the given URL to the current content selection. If an
 * entity is specified, it applies the link to that entity instead.
 */
var applyLink = function (state, _a) {
    var link = _a.link, entity = _a.entity;
    var editorState = state.editorState;
    if (entity) {
        return editor3_1.onChange(state, entityUtils.replaceSelectedEntityData(editorState, { link: link }), true);
    }
    editorState = Links.createLink(editorState, link);
    return editor3_1.onChange(state, editorState);
};
/**
 * @ngdoc method
 * @name removeLink
 * @description Removes the link on the entire entity under the cursor.
 */
var removeLink = function (state) {
    var editorState = state.editorState;
    editorState = Links.removeLink(editorState);
    return editor3_1.onChange(state, editorState);
};
/*
 * @ngdoc method
 * @name removeFormat
 * @description Set all blocks in selection to unstyled except atomic blocks
 *              and remove inline styles
 */
var removeFormat = function (state) {
    var editorState = state.editorState;
    var selection = editorState.getSelection();
    var stateWithoutFormat = removeFormat_1.removeFormatFromState(editorState);
    var newSelection = selection.merge({
        anchorOffset: selection.getEndOffset(),
        anchorKey: selection.getEndKey(),
        focusOffset: selection.getEndOffset(),
        focusKey: selection.getEndKey(),
        isBackward: false,
        hasFocus: true,
    });
    return editor3_1.onChange(state, draft_js_1.EditorState.acceptSelection(stateWithoutFormat, newSelection));
};
/**
 * @ngdoc method
 * @name insertMedia
 * @param {Array} files List of media files to be inserted into document.
 * @param {String} targetBlockKey Block key where we want to insert the media
 * @description Inserts a list of media files into the document.
 */
var insertMedia = function (state, _a) {
    var _b = _a.files, files = _b === void 0 ? [] : _b, _c = _a.targetBlockKey, targetBlockKey = _c === void 0 ? null : _c;
    var editorState = state.editorState;
    files.forEach(function (file) {
        editorState = exports.addMedia(editorState, file, targetBlockKey);
    });
    return editor3_1.onChange(state, editorState);
};
/**
 * @ngdoc method
 * @name addMedia
 * @param {Object} editorState Editor state to add the media to.
 * @param {Object} media Media data.
 * @param {String} targetBlockKey Block key where the media is going to
 * @returns {Object} New editor state with media inserted as atomic block.
 * @description Inserts the given media into the given editor state's content and returns
 * the updated editor state.
 */
exports.addMedia = function (editorState, media, targetBlockKey) {
    if (targetBlockKey === void 0) { targetBlockKey = null; }
    return draftInsertEntity_1.insertEntity(editorState, 'MEDIA', 'MUTABLE', { media: media }, targetBlockKey);
};
/**
 * @ngdoc method
 * @name updateImage
 * @param {Object} data Contains the entityKey and the new image data.
 * @description Updates the given entityKey with the new image data.
 */
var updateImage = function (state, _a) {
    var entityKey = _a.entityKey, media = _a.media;
    var editorState = state.editorState;
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var newContentState = contentState.replaceEntityData(entityKey, { media: media });
    var newEditorState = draft_js_1.EditorState.push(editorState, newContentState, 'change-block-data');
    // focus the editor and softly force a refresh
    var newState = draft_js_1.EditorState.forceSelection(newEditorState, selection);
    var entityDataHasChanged = true;
    return editor3_1.onChange(state, newState, entityDataHasChanged);
};
/**
 * @ngdoc method
 * @name removeBlock
 * @param {Object} data Contains the key from of block to remove
 * @description Removes block from editor
 */
var removeBlock = function (state, _a) {
    var blockKey = _a.blockKey;
    var editorState = state.editorState;
    var newEditorState = Blocks.removeBlock(editorState, blockKey);
    return editor3_1.onChange(state, newEditorState);
};
/**
 * @ngdoc method
 * @name toggleInvisibles
 * @param {Object} state
 * @return {Object} returns new state
 * @description Enable/Disable the paragraph marks
 */
var toggleInvisibles = function (state) {
    var invisibles = state.invisibles;
    return __assign({}, state, { invisibles: !invisibles });
};
/**
 * @ngdoc method
 * @name setPopup
 * @param {Object} data Type of popup and popup data.
 * @description Sets the toolbar popup to the given type.
 */
var setPopup = function (state, _a) {
    var type = _a.type, data = _a.data;
    return (__assign({}, state, { popup: { type: type, data: data } }));
};
exports.default = toolbar;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var entityUtils = __importStar(__webpack_require__(79));
/**
 * @ngdoc method
 * @name createLink
 * @param {Object} editorState
 * @param {Object} link, object with href
 * @return {Object} EditorState
 * @description Create a hyperlink on editorState selection
 */
function createLink(editorState, link) {
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { link: link });
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    var stateAfterChange = draft_js_1.RichUtils.toggleLink(editorState, editorState.getSelection(), entityKey);
    return stateAfterChange;
}
exports.createLink = createLink;
/**
 * @ngdoc method
 * @name removeLink
 * @param {Object} editorState
 * @return {Object} EditorState
 * @description Removes the hyperlink on current selection
 */
function removeLink(editorState) {
    var stateAfterChange = __assign({}, editorState);
    entityUtils.getSelectedEntityRange(editorState, function (start, end) {
        var selection = editorState.getSelection();
        var entitySelection = selection.merge({
            anchorOffset: start,
            focusOffset: end,
            isBackward: false,
        });
        stateAfterChange = draft_js_1.RichUtils.toggleLink(editorState, entitySelection, null);
    });
    return stateAfterChange;
}
exports.removeLink = removeLink;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var insertAtomicBlockWithoutEmptyLines_1 = __importDefault(__webpack_require__(537));
var draftMoveBlockWithoutDispatching_1 = __webpack_require__(538);
function insertEntity(editorState, draftEntityType, mutability, data, targetBlockKey) {
    if (targetBlockKey === void 0) { targetBlockKey = null; }
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity(draftEntityType, mutability, data);
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    var insertResult = insertAtomicBlockWithoutEmptyLines_1.default(editorState, entityKey, ' ');
    var stateWithBlock = insertResult.editorState;
    var newBlockKey = insertResult.blockKey;
    if (targetBlockKey) {
        stateWithBlock = draftMoveBlockWithoutDispatching_1.moveBlockWithoutDispatching({ editorState: stateWithBlock }, {
            block: newBlockKey,
            dest: targetBlockKey,
            insertionMode: 'after',
        }).editorState;
    }
    return stateWithBlock;
}
exports.insertEntity = insertEntity;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var editor3CustomData_1 = __webpack_require__(48);
var immutable_1 = __importDefault(__webpack_require__(51));
var List = immutable_1.default.List, Repeat = immutable_1.default.Repeat;
function getInsertionTarget(contentState, selectionState) {
    var afterRemoval = draft_js_1.Modifier.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = draft_js_1.Modifier.splitBlock(afterRemoval, targetSelection);
    // return unsplit content if after the splitting first line is empty
    if (afterSplit.getBlockForKey(afterSplit.getSelectionBefore().getAnchorKey()).getText().length < 1) {
        return {
            contentState: afterRemoval,
            selectionState: targetSelection,
        };
    }
    var insertionTarget = afterSplit.getSelectionAfter();
    return {
        contentState: afterSplit,
        selectionState: insertionTarget,
    };
}
/*
    insertAtomicBlockWithoutEmptyLines: function(
        editorState: EditorState,
        entityKey: string,
        character: string
    ): { editorState: EditorState, blockKey: String }
*/
function insertAtomicBlockWithoutEmptyLines(editorState, entityKey, character) {
    var selectionState = editorState.getSelection();
    var target = getInsertionTarget(editorState.getCurrentContent(), selectionState);
    var asAtomicBlock = draft_js_1.Modifier.setBlockType(target.contentState, target.selectionState, 'atomic');
    var charData = draft_js_1.CharacterMetadata.create({ entity: entityKey });
    var fragmentArray = [];
    if (asAtomicBlock.getFirstBlock().getKey() === target.selectionState.getAnchorKey()) {
        fragmentArray.push(new draft_js_1.ContentBlock({
            key: draft_js_1.genKey(),
            type: 'unstyled',
            text: '',
            characterList: List(),
        }));
    }
    fragmentArray.push(new draft_js_1.ContentBlock({
        key: draft_js_1.genKey(),
        type: 'atomic',
        text: character,
        characterList: List(Repeat(charData, character.length)),
    }));
    if (
    // check if atomic is the last block in the editor
    asAtomicBlock.getLastBlock().getKey() === target.selectionState.getAnchorKey()
        ||
            // check if cursor is not at the end of the block
            target.selectionState.getFocusOffset()
                !== target.contentState.getBlockForKey(target.selectionState.getFocusKey()).getText().length) {
        fragmentArray.push(new draft_js_1.ContentBlock({
            key: draft_js_1.genKey(),
            type: 'unstyled',
            text: '',
            characterList: List(),
        }));
    }
    var fragment = draft_js_1.BlockMapBuilder.createFromArray(fragmentArray);
    var customData = editor3CustomData_1.getAllCustomDataFromEditor(editorState);
    var withAtomicBlock = draft_js_1.Modifier.replaceWithFragment(asAtomicBlock, target.selectionState, fragment);
    var newContent = withAtomicBlock.merge({
        selectionBefore: selectionState,
        selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true),
    });
    var blockKeyForEntity = newContent.getBlocksAsArray()
        .map(function (b) { return ({ entity: b.getEntityAt(0), block: b.getKey() }); })
        .find(function (b) { return b.entity === entityKey; }).block;
    var newEditorState = draft_js_1.EditorState.push(editorState, newContent, 'insert-fragment');
    // for the first block recover the initial block data because on replaceWithFragment the block data is
    // replaced with the data from pasted fragment
    newEditorState = editor3CustomData_1.setAllCustomDataForEditor(newEditorState, customData);
    newEditorState = draft_js_1.EditorState.push(editorState, newEditorState.getCurrentContent(), 'insert-fragment');
    return {
        editorState: newEditorState,
        blockKey: blockKeyForEntity,
    };
}
exports.default = insertAtomicBlockWithoutEmptyLines;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
/**
 * Move atomic block and return the state
 *
 * @param {Object} state
 * @param {String} block
 * @param {String} dest
 * @param {String} insertionMode before|after
 * @return {Object}
 */
function moveBlockWithoutDispatching(state, _a) {
    var block = _a.block, dest = _a.dest, insertionMode = _a.insertionMode;
    var editorState = state.editorState;
    var contentState = editorState.getCurrentContent();
    switch (true) {
        case block === dest:
        case !contentState.getBlockForKey(dest):
        case !contentState.getBlockForKey(block):
        case dest === contentState.getKeyBefore(block) && insertionMode === 'after':
        case dest === contentState.getKeyAfter(block) && insertionMode === 'before':
        case dest === contentState.getKeyAfter(block) && !insertionMode:
            return state; // noop
    }
    var atomicBlock = contentState.getBlockForKey(block);
    var targetRange = draft_js_1.SelectionState.createEmpty(dest);
    var withMovedAtomicBlock = draft_js_1.AtomicBlockUtils.moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode);
    return __assign({}, state, { editorState: withMovedAtomicBlock });
}
exports.moveBlockWithoutDispatching = moveBlockWithoutDispatching;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var editor3_1 = __webpack_require__(104);
var inlineStyles_1 = __webpack_require__(113);
var highlightsConfig_1 = __webpack_require__(46);
var Highlights = __importStar(__webpack_require__(41));
var selection_1 = __webpack_require__(87);
var editor3CustomData_1 = __webpack_require__(48);
var Links = __importStar(__webpack_require__(535));
var entityUtils_1 = __webpack_require__(79);
var suggestions = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'TOGGLE_SUGGESTING_MODE':
            return toggleSuggestingMode(state);
        case 'CREATE_ADD_SUGGESTION':
            return exports.createAddSuggestion(state, action.payload);
        case 'CREATE_DELETE_SUGGESTION':
            return createDeleteSuggestion(state, action.payload);
        case 'CREATE_CHANGE_STYLE_SUGGESTION':
            return createChangeStyleSuggestion(state, action.payload);
        case 'CREATE_CHANGE_BLOCK_STYLE_SUGGESTION':
            return createChangeBlockStyleSuggestion(state, action.payload);
        case 'CREATE_SPLIT_PARAGRAPH_SUGGESTION':
            return createSplitParagraphSuggestion(state, action.payload);
        case 'PASTE_ADD_SUGGESTION':
            return pasteAddSuggestion(state, action.payload);
        case 'CREATE_LINK_SUGGESTION':
            return createLinkSuggestion(state, action.payload);
        case 'CHANGE_LINK_SUGGESTION':
            return changeLinkSuggestion(state, action.payload);
        case 'REMOVE_LINK_SUGGESTION':
            return removeLinkSuggestion(state, action.payload);
        case 'ACCEPT_SUGGESTION':
            return processSuggestion(state, action.payload, true);
        case 'REJECT_SUGGESTION':
            return processSuggestion(state, action.payload, false);
        default:
            return state;
    }
};
/**
 * @ngdoc method
 * @name toggleSuggestingMode
 * @param {Object} state
 * @return {Object} returns new state
 * @description Disable/enable the suggesting mode.
 */
var toggleSuggestingMode = function (state) {
    var suggestingMode = state.suggestingMode;
    return __assign({}, state, { suggestingMode: !suggestingMode });
};
/**
 * @ngdoc method
 * @name saveEditorStatus
 * @param {Object} state
 * @param {Object} tmpEditorState
 * @param {String} changeType
 * @return {Object} returns new state
 * @description Save the changes as a single change in undo stack.
 */
var saveEditorStatus = function (state, tmpEditorState, changeType, restoreSelection) {
    if (restoreSelection === void 0) { restoreSelection = false; }
    var editorState = state.editorState;
    var content = tmpEditorState.getCurrentContent();
    var selection = restoreSelection ? editorState.getSelection() : tmpEditorState.getSelection();
    var newEditorState;
    newEditorState = draft_js_1.EditorState.push(editorState, content, changeType);
    newEditorState = draft_js_1.EditorState.forceSelection(newEditorState, selection);
    return editor3_1.onChange(state, newEditorState);
};
/**
 * @ngdoc method
 * @name createAddSuggestion
 * @param {Object} state
 * @param {String} text - the suggestion added text
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type ADD.
 */
exports.createAddSuggestion = function (state, _a, selection) {
    var text = _a.text, data = _a.data;
    if (selection === void 0) { selection = null; }
    var editorState = state.editorState;
    var inlineStyle = editorState.getCurrentInlineStyle();
    if (selection) {
        editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    }
    editorState = deleteCurrentSelection(editorState, data);
    for (var i = 0; i < text.length; i++) {
        // for every character from inserted text apply add suggestion
        editorState = setAddSuggestionForCharacter(editorState, data, text[i], inlineStyle);
    }
    return saveEditorStatus(state, editorState, 'insert-characters');
};
/**
 * @ngdoc method
 * @name createDeleteSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type DELETE.
 */
var createDeleteSuggestion = function (state, _a) {
    var action = _a.action, data = _a.data;
    var editorState = state.editorState;
    var selection = editorState.getSelection();
    if (selection.isCollapsed()) {
        if (action === 'backspace') {
            editorState = Highlights.changeEditorSelection(editorState, -1, 0, false);
        }
        else {
            editorState = Highlights.changeEditorSelection(editorState, 0, 1, false);
        }
    }
    editorState = deleteCurrentSelection(editorState, data, action);
    return saveEditorStatus(state, editorState, 'change-inline-style');
};
/**
 * @ngdoc method
 * @name createAddSuggestion
 * @param {Object} state
 * @param {String} style - the suggestion style
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type ADD.
 */
var createChangeStyleSuggestion = function (state, _a) {
    var style = _a.style, data = _a.data;
    var editorState = state.editorState;
    var type = Highlights.getTypeByInlineStyle(style);
    editorState = applyStyleSuggestion(editorState, type, style, data);
    editorState = draft_js_1.RichUtils.toggleInlineStyle(editorState, style);
    return saveEditorStatus(state, editorState, 'change-inline-style', true);
};
function applyStyleSuggestion(editorState, type, style, data) {
    var selection = editorState.getSelection();
    var newEditorState = editorState;
    var tmpEditorState;
    var currentStyle;
    var changeStyle = true;
    newEditorState = selection_1.initSelectionIterator(newEditorState);
    while (selection_1.hasNextSelection(newEditorState, selection)) {
        currentStyle = Highlights.getHighlightStyleAtCurrentPosition(newEditorState, type);
        if (currentStyle) {
            tmpEditorState = resetSuggestion(newEditorState, currentStyle);
        }
        else {
            var currentSelection = newEditorState.getSelection();
            var content = newEditorState.getCurrentContent();
            var block = content.getBlockForKey(currentSelection.getStartKey());
            if (block.getLength() !== currentSelection.getStartOffset()) {
                changeStyle = false;
            }
            tmpEditorState = Highlights.changeEditorSelection(newEditorState, 1, 1, false);
        }
        if (tmpEditorState === newEditorState) {
            break;
        }
        newEditorState = tmpEditorState;
    }
    if (changeStyle && currentStyle != null) {
        var oldData = Highlights.getHighlightData(editorState, currentStyle);
        if (oldData.originalStyle === style && data.originalStyle === '' ||
            oldData.originalStyle === '' && data.originalStyle === style) {
            // the style is toggled back, so no suggestion is added
            // restore the selection
            newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, selection);
            return newEditorState;
        }
        else {
            data.originalStyle = oldData.originalStyle;
        }
    }
    newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, selection);
    newEditorState = Highlights.addHighlight(newEditorState, type, data);
    return newEditorState;
}
/**
 * @ngdoc method
 * @name createLinkSuggestion
 * @param {Object} state
 * @param {Object} data - info about the suggestion (includes link object)
 * @return {Object} returns new state
 * @description Add a new suggestion of type ADD link to text
 */
var createLinkSuggestion = function (state, _a) {
    var data = _a.data;
    var editorState = state.editorState;
    var stateWithLink = Links.createLink(editorState, data.link);
    var newState = Highlights.addHighlight(stateWithLink, 'ADD_LINK_SUGGESTION', data);
    return saveEditorStatus(state, newState, 'apply-entity');
};
/**
 * @ngdoc method
 * @name changeLinkSuggestion
 * @param {Object} state
 * @param {Object} data - info about the suggestion
 * @param {Object} link - the new link
 * @param {Object} entity - the link entity
 * @return {Object} returns new state
 * @description Add a new suggestion of type CHANGE link
 */
var changeLinkSuggestion = function (state, _a) {
    var data = _a.data, link = _a.link, entity = _a.entity;
    var editorState = state.editorState;
    var newState = Highlights.highlightEntity(editorState, 'CHANGE_LINK_SUGGESTION', __assign({}, data, { to: link, from: entity.getData().link }), undefined);
    newState = entityUtils_1.replaceSelectedEntityData(newState, { link: link });
    return saveEditorStatus(state, newState, 'apply-entity');
};
/**
 * @ngdoc method
 * @name changeLinkSuggestion
 * @param {Object} state
 * @param {Object} data - info about the suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type CHANGE link
 */
var removeLinkSuggestion = function (state, _a) {
    var data = _a.data;
    var editorState = state.editorState;
    var newState = Highlights.highlightEntity(editorState, 'REMOVE_LINK_SUGGESTION', data, true);
    return saveEditorStatus(state, newState, 'apply-entity');
};
/**
 * @ngdoc method
 * @name createChangeBlockStyleSuggestion
 * @param {Object} state
 * @param {String} blockType - the suggestion block type
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type change block style.
 */
var createChangeBlockStyleSuggestion = function (state, _a) {
    var blockType = _a.blockType, data = _a.data;
    var editorState = state.editorState;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var firstBlock = content.getBlockForKey(selection.getStartKey());
    var lastBlock = content.getBlockForKey(selection.getEndKey());
    if (selection.getEndOffset() === 0 && selection.getStartKey() !== selection.getEndKey()) {
        lastBlock = content.getBlockBefore(selection.getEndKey());
    }
    var blocksSelection = selection.merge({
        anchorOffset: 0,
        anchorKey: firstBlock.getKey(),
        focusOffset: lastBlock.getLength(),
        focusKey: lastBlock.getKey(),
        isBackward: false,
    });
    var type = 'BLOCK_STYLE_SUGGESTION';
    var newData = __assign({}, data, { blockType: blockType });
    editorState = draft_js_1.EditorState.acceptSelection(editorState, blocksSelection);
    editorState = applyStyleSuggestion(editorState, type, blockType, newData);
    editorState = draft_js_1.RichUtils.toggleBlockType(editorState, blockType);
    return saveEditorStatus(state, editorState, 'change-block-type', true);
};
/**
 * @ngdoc method
 * @name isMergeParagraph
 * @param {Object} editorState
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns true if there is a merge paragraph suggestion for the same user
 * @description Check if at current position there is a merge paragraph suggestion.
 */
var isMergeParagraph = function (editorState, data) {
    var suggestionStyle = Highlights.getHighlightStyleAtCurrentPosition(editorState, ['MERGE_PARAGRAPHS_SUGGESTION']);
    if (suggestionStyle == null) {
        return false;
    }
    var suggestionAuthor = Highlights.getHighlightAuthor(editorState, suggestionStyle);
    return suggestionAuthor != null && suggestionAuthor === data.author;
};
/**
 * @ngdoc method
 * @name createSplitParagraphSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type split block.
 */
var createSplitParagraphSuggestion = function (state, _a) {
    var data = _a.data;
    var type = 'SPLIT_PARAGRAPH_SUGGESTION';
    var editorState = state.editorState;
    var isMergeParagraphAfter = isMergeParagraph(editorState, data);
    var checkState = Highlights.changeEditorSelection(editorState, -1, -1, false);
    var isMergeParagraphBefore = isMergeParagraph(checkState, data);
    var selection = editorState.getSelection();
    var content = draft_js_1.Modifier.splitBlock(editorState.getCurrentContent(), selection);
    var firstBlock = content.getBlockForKey(selection.getStartKey());
    var secondBlock = content.getBlockAfter(selection.getStartKey());
    if (isMergeParagraphBefore || isMergeParagraphAfter) {
        if (isMergeParagraphBefore) {
            selection = selection.merge({
                anchorOffset: firstBlock.getLength() - 1,
                anchorKey: firstBlock.getKey(),
                focusOffset: firstBlock.getLength(),
                focusKey: firstBlock.getKey(),
                isBackward: false,
            });
        }
        else {
            selection = selection.merge({
                anchorOffset: 0,
                anchorKey: secondBlock.getKey(),
                focusOffset: 1,
                focusKey: secondBlock.getKey(),
                isBackward: false,
            });
        }
        content = draft_js_1.Modifier.removeRange(content, selection, 'backward');
        editorState = draft_js_1.EditorState.push(editorState, content, 'remove-range');
    }
    else {
        selection = selection.merge({
            anchorOffset: firstBlock.getLength(),
            anchorKey: firstBlock.getKey(),
            focusOffset: firstBlock.getLength(),
            focusKey: firstBlock.getKey(),
            isBackward: false,
        });
        content = draft_js_1.Modifier.insertText(content, selection, Highlights.paragraphSeparator);
        editorState = draft_js_1.EditorState.push(editorState, content, 'insert-characters');
        editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
        editorState = Highlights.changeEditorSelection(editorState, 0, 1, false);
        editorState = Highlights.addHighlight(editorState, type, data);
    }
    selection = selection.merge({
        anchorOffset: 0,
        anchorKey: secondBlock.getKey(),
        focusOffset: 0,
        focusKey: secondBlock.getKey(),
        isBackward: false,
    });
    editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    return saveEditorStatus(state, editorState, 'change-inline-style', false);
};
/**
 * @ngdoc method
 * @name pasteAddSuggestion
 * @param {Object} state
 * @param {Object} content - the suggestion added content
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add a new suggestion of type ADD based on content.
 */
var pasteAddSuggestion = function (state, _a) {
    var content = _a.content, data = _a.data;
    var editorState = state.editorState;
    var selection = editorState.getSelection();
    var beforeStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, -1);
    var beforeData = beforeStyle != null ? Highlights.getHighlightData(editorState, beforeStyle) : null;
    // if text is selected mark it as removed and collapse the selection before replacing
    if (!selection.isCollapsed()) {
        editorState = deleteCurrentSelection(editorState, data);
        selection = editorState.getSelection();
    }
    // only get it now after adding delete suggestions
    var customData = editor3CustomData_1.getAllCustomDataFromEditor(editorState);
    // add content to editor state
    var mergedContent = draft_js_1.Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), inlineStyles_1.sanitizeContent(draft_js_1.EditorState.createWithContent(content))
        .getCurrentContent()
        .getBlockMap());
    // push new content
    editorState = draft_js_1.EditorState.push(editorState, mergedContent, 'insert-fragment');
    // store current selection for later
    var finalSelection = editorState.getSelection();
    var newSelection = selection.merge({
        anchorKey: selection.getStartKey(),
        anchorOffset: selection.getStartOffset(),
        focusKey: finalSelection.getStartKey(),
        focusOffset: finalSelection.getStartOffset(),
        hasFocus: true,
        isBackward: false,
    });
    // for the first block recover the initial block data because on replaceWithFragment the block data is
    // replaced with the data from pasted fragment
    editorState = editor3CustomData_1.setAllCustomDataForEditor(editorState, customData);
    // select pasted content
    editorState = draft_js_1.EditorState.acceptSelection(editorState, newSelection);
    // apply highlights
    if (beforeData != null && beforeData.type === 'ADD_SUGGESTION' && beforeData.author === data.author) {
        editorState = draft_js_1.RichUtils.toggleInlineStyle(editorState, beforeStyle);
    }
    else {
        editorState = Highlights.addHighlight(editorState, 'ADD_SUGGESTION', data);
    }
    // reset selection
    editorState = draft_js_1.EditorState.forceSelection(editorState, finalSelection);
    return saveEditorStatus(state, editorState, 'change-block-type');
};
/**
 * @ngdoc method
 * @name moveToSuggestionsHistory
 * @param {Object} editorState
 * @param {Object} data - info about the author
 * @param {Object} suggestion
 * @param {Boolean} accepted
 * @return {editorState} returns new state
 */
function moveToSuggestionsHistory(editorState, data, suggestion, accepted) {
    var resolvedSuggestions = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.RESOLVED_SUGGESTIONS_HISTORY) || [];
    var nextEditorState = editorState;
    nextEditorState = editor3CustomData_1.setCustomDataForEditor(editorState, editor3CustomData_1.editor3DataKeys.RESOLVED_SUGGESTIONS_HISTORY, resolvedSuggestions.concat({
        suggestionText: suggestion.suggestionText,
        oldText: suggestion.oldText,
        suggestionInfo: __assign({}, suggestion),
        resolutionInfo: {
            resolverUserId: data.author,
            date: data.date,
            accepted: accepted,
        },
    }));
    nextEditorState = Highlights.removeHighlight(nextEditorState, suggestion.styleName);
    return nextEditorState;
}
/**
 * @ngdoc method
 * @name processSplitBlockSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author
 * @param {Object} suggestion
 * @param {Boolean} accepted - the suggestion is accepted
 * @return {Object} returns new state
 * @description Accept or reject the split suggestions in the selection.
 */
var processSplitBlockSuggestion = function (state, data, suggestion, accepted) {
    var selection = suggestion.selection;
    var editorState = state.editorState;
    editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
    var content = editorState.getCurrentContent();
    var block = content.getBlockAfter(selection.getStartKey());
    var newSelection = selection.merge({
        anchorOffset: selection.getStartOffset(),
        anchorKey: selection.getStartKey(),
        focusOffset: accepted ? selection.getEndOffset() : 0,
        focusKey: accepted ? selection.getEndKey() : block.getKey(),
        isBackward: false,
    });
    content = draft_js_1.Modifier.removeRange(content, newSelection, 'backward');
    editorState = draft_js_1.EditorState.push(editorState, content, 'remove-range');
    return saveEditorStatus(state, editorState, 'change-inline-style', false);
};
/**
 * @ngdoc method
 * @name processMergeBlocksSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author
 * @param {Object} suggestion
 * @param {Boolean} accepted - the suggestion is accepted
 * @return {Object} returns new state
 * @description Accept or reject the merge suggestions in the selection.
 */
var processMergeBlocksSuggestion = function (state, data, suggestion, accepted) {
    var selection = suggestion.selection;
    var editorState = state.editorState;
    var crtSelection = editorState.getSelection();
    editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
    var content = editorState.getCurrentContent();
    content = draft_js_1.Modifier.removeRange(content, selection, 'backward');
    if (!accepted) {
        content = draft_js_1.Modifier.splitBlock(content, crtSelection);
    }
    editorState = draft_js_1.EditorState.push(editorState, content, 'remove-range');
    editorState = draft_js_1.EditorState.acceptSelection(editorState, crtSelection);
    return saveEditorStatus(state, editorState, 'change-inline-style', false);
};
/**
 * @ngdoc method
 * @name processSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author
 * @param {Object} suggestion
 * @param {Boolean} accepted - the suggestion is accepted
 * @return {Object} returns new state
 * @description Accept or reject the suggestions in the selection.
 */
var processSuggestion = function (state, _a, accepted) {
    var data = _a.data, suggestion = _a.suggestion;
    if (accepted === true || accepted === false) {
        // after clicking accept/reject editor focus is lost
        // restore the focus so undo stack is correct
        // and pop up can be positioned properly on undo SDFID-401
        state.editorState = draft_js_1.EditorState.acceptSelection(state.editorState, state.editorState.getSelection().merge({
            hasFocus: true,
        }));
    }
    var selection = suggestion.selection;
    var editorState = state.editorState;
    var style;
    if (suggestion.type === 'SPLIT_PARAGRAPH_SUGGESTION') {
        return processSplitBlockSuggestion(state, data, suggestion, accepted);
    }
    if (suggestion.type === 'MERGE_PARAGRAPHS_SUGGESTION') {
        return processMergeBlocksSuggestion(state, data, suggestion, accepted);
    }
    // If link it's rejected we remove the entity
    if (suggestion.type === 'ADD_LINK_SUGGESTION') {
        editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
        if (!accepted) {
            editorState = Links.removeLink(editorState);
        }
        return saveEditorStatus(state, editorState, 'apply-entity', true);
    }
    // remove link if remove link is accepted
    if (suggestion.type === 'REMOVE_LINK_SUGGESTION') {
        editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
        if (accepted) {
            editorState = Links.removeLink(editorState);
        }
        return saveEditorStatus(state, editorState, 'apply-entity', true);
    }
    if (suggestion.type === 'CHANGE_LINK_SUGGESTION') {
        editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
        if (!accepted) {
            editorState = entityUtils_1.replaceSelectedEntityData(editorState, { link: suggestion.from });
        }
        return saveEditorStatus(state, editorState, 'apply-entity', true);
    }
    editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    if (suggestion.type === 'BLOCK_STYLE_SUGGESTION') {
        editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
        if (!accepted) {
            editorState = draft_js_1.RichUtils.toggleBlockType(editorState, suggestion.blockType);
        }
        return saveEditorStatus(state, editorState, 'change-inline-style', true);
    }
    if (highlightsConfig_1.styleSuggestionsTypes.indexOf(suggestion.type) !== -1) {
        editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
        if (!accepted) {
            style = Highlights.getInlineStyleByType(suggestion.type);
            editorState = draft_js_1.RichUtils.toggleInlineStyle(editorState, style);
        }
        return saveEditorStatus(state, editorState, 'change-inline-style', true);
    }
    editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    editorState = applyChangeSuggestion(editorState, accepted);
    selection = editorState.getSelection();
    selection = selection.merge({
        anchorOffset: selection.getEndOffset(),
        anchorKey: selection.getEndKey(),
        focusOffset: selection.getEndOffset(),
        focusKey: selection.getEndKey(),
        isBackward: false,
    });
    editorState = draft_js_1.EditorState.acceptSelection(editorState, selection);
    editorState = moveToSuggestionsHistory(editorState, data, suggestion, accepted);
    return saveEditorStatus(state, editorState, 'change-block-data');
};
/**
 * @ngdoc method
 * @name applyChangeSuggestion
 * @param {Object} editorState
 * @param {Boolean} accepted - the suggestion is accepted
 * @return {Object} returns new state
 * @description Accept or reject the change suggestions in current editor selection.
 */
var applyChangeSuggestion = function (editorState, accepted) {
    var suggestionTypes = highlightsConfig_1.changeSuggestionsTypes.concat(highlightsConfig_1.paragraphSuggestionTypes);
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var lastBlock = content.getBlockForKey(selection.getEndKey());
    var afterSectionLength = lastBlock.getLength() - selection.getEndOffset();
    var nextBlock = content.getBlockAfter(selection.getEndKey());
    var newEditorState;
    var oldEditorState;
    var style;
    var data;
    newEditorState = removeDeleteParagraphSuggestions(editorState);
    newEditorState = selection_1.initSelectionIterator(newEditorState, true);
    while (selection_1.hasNextSelection(newEditorState, selection, true)) {
        oldEditorState = newEditorState;
        newEditorState = Highlights.changeEditorSelection(newEditorState, -1, -1, false);
        style = Highlights.getHighlightStyleAtCurrentPosition(newEditorState, suggestionTypes);
        if (style == null) {
            continue;
        }
        data = Highlights.getHighlightData(newEditorState, style);
        if (highlightsConfig_1.paragraphSuggestionTypes.indexOf(data.type) !== -1) {
            // delete any paragraph suggestion
            newEditorState = Highlights.changeEditorSelection(newEditorState, 1, 1, false);
            newEditorState = deleteCharacter(newEditorState, style);
            if (newEditorState === oldEditorState) {
                break;
            }
            continue;
        }
        var applySuggestion = data.type === 'ADD_SUGGESTION' && accepted ||
            data.type === 'DELETE_SUGGESTION' && !accepted;
        var newSelection = Highlights.getRangeAndTextForStyle(newEditorState, style, true).selection;
        var offset = 0;
        if (selection.getStartKey() === newSelection.getStartKey() &&
            selection.getStartOffset() > newSelection.getStartOffset()) {
            offset = selection.getStartOffset() - newSelection.getStartOffset();
        }
        newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, newSelection);
        newEditorState = Highlights.changeEditorSelection(newEditorState, offset, 1, false);
        newSelection = newEditorState.getSelection();
        newEditorState = Highlights.resetHighlightForCurrentSelection(newEditorState, style);
        if (!applySuggestion) {
            // delete current selection
            var _content = newEditorState.getCurrentContent();
            var newContent = draft_js_1.Modifier.removeRange(_content, newSelection, 'forward');
            newEditorState = draft_js_1.EditorState.push(newEditorState, newContent, 'backspace-character');
        }
        newSelection = newSelection.merge({
            anchorOffset: newSelection.getStartOffset(),
            anchorKey: newSelection.getStartKey(),
            focusOffset: newSelection.getStartOffset(),
            focusKey: newSelection.getStartKey(),
            isBackward: false,
        });
        newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, newSelection);
        if (newEditorState === oldEditorState) {
            break;
        }
    }
    content = newEditorState.getCurrentContent();
    if (nextBlock != null) {
        lastBlock = content.getBlockBefore(nextBlock.getKey());
    }
    else {
        lastBlock = content.getLastBlock();
    }
    selection = selection.merge({
        anchorKey: selection.getStartKey(),
        anchorOffset: selection.getStartOffset(),
        focusKey: lastBlock.getKey(),
        focusOffset: lastBlock.getLength() - afterSectionLength,
        isBackward: false,
    });
    return draft_js_1.EditorState.acceptSelection(newEditorState, selection);
};
/**
 * @ngdoc method
 * @name addDeleteParagraphSuggestions
 * @param {Object} editorState
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Add delete paragraph suggestion for every empty block.
 */
var addDeleteParagraphSuggestions = function (editorState, data) {
    var selection = editorState.getSelection();
    var newEditorState = editorState;
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    var offset = 0;
    var changed = false;
    while (block != null) {
        if (block.getLength() === 0 && block.getType() !== 'atomic') {
            var newSelection = selection.merge({
                anchorOffset: 0,
                anchorKey: block.getKey(),
                focusOffset: 0,
                focusKey: block.getKey(),
                isBackward: false,
            });
            content = draft_js_1.Modifier.insertText(content, newSelection, Highlights.paragraphSeparator);
            newEditorState = draft_js_1.EditorState.push(newEditorState, content, 'insert-characters');
            newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, newSelection);
            newEditorState = Highlights.changeEditorSelection(newEditorState, 0, 1, false);
            newEditorState = Highlights.addHighlight(newEditorState, 'DELETE_EMPTY_PARAGRAPH_SUGGESTION', data);
            content = newEditorState.getCurrentContent();
            changed = true;
        }
        if (block.getKey() === selection.getEndKey()) {
            if (block.getLength() === 0) {
                offset = 1;
            }
            break;
        }
        block = content.getBlockAfter(block.getKey());
    }
    if (!changed) {
        return editorState;
    }
    newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, selection);
    return Highlights.changeEditorSelection(newEditorState, 0, offset, false);
};
/**
 * @ngdoc method
 * @name removeDeleteParagraphSuggestions
 * @param {Object} editorState
 * @return {Object} returns new state
 * @description Remove all delete paragraph suggestions.
 */
var removeDeleteParagraphSuggestions = function (editorState) {
    var selection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    var offset = 0;
    var changed = false;
    var newEditorState;
    while (block != null) {
        var key = block.getKey();
        var checkBlock = block.getLength() === 1 && block.getType() !== 'atomic';
        var checkMiddleBlock = key !== selection.getStartKey() && key !== selection.getEndKey();
        var checkFirstBlock = key === selection.getStartKey() && selection.getStartOffset() === 0;
        var checkLastBlock = key === selection.getEndKey() && selection.getEndOffset() === 1;
        if (checkBlock && (checkMiddleBlock || checkFirstBlock || checkLastBlock)) {
            var newSelection = selection.merge({
                anchorOffset: 0,
                anchorKey: block.getKey(),
                focusOffset: 1,
                focusKey: block.getKey(),
                isBackward: false,
            });
            newEditorState = draft_js_1.EditorState.acceptSelection(editorState, newSelection);
            var style = Highlights.getHighlightStyleAtCurrentPosition(newEditorState, ['DELETE_EMPTY_PARAGRAPH_SUGGESTION']);
            if (style != null) {
                content = draft_js_1.Modifier.removeRange(content, newSelection, 'forward');
                changed = true;
                offset = checkLastBlock ? -1 : 0;
            }
        }
        if (block.getKey() === selection.getEndKey()) {
            break;
        }
        block = content.getBlockAfter(block.getKey());
    }
    if (!changed) {
        return editorState;
    }
    newEditorState = draft_js_1.EditorState.push(editorState, content, 'backspace-character');
    newEditorState = draft_js_1.EditorState.acceptSelection(newEditorState, selection);
    return Highlights.changeEditorSelection(newEditorState, 0, offset, false);
};
/**
 * @ngdoc method
 * @name deleteCurrentSelection
 * @param {Object} editorState
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Set the delete suggestion for current editor selection.
 */
var deleteCurrentSelection = function (editorState, data, action) {
    if (action === void 0) { action = 'delete'; }
    var selection = editorState.getSelection();
    var newEditorState;
    if (selection.isCollapsed()) {
        return editorState;
    }
    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(selection.getStartKey());
    if (selection.getEndOffset() === 0 && selection.getStartOffset() === block.getLength()) {
        newEditorState = setMergeParagraphSuggestion(editorState, data);
        if (action !== 'delete') {
            return newEditorState;
        }
        return Highlights.changeEditorSelection(newEditorState, 1, 1, false);
    }
    if (selection.getStartKey() === selection.getEndKey() &&
        selection.getStartOffset() === selection.getEndOffset() - 1) {
        newEditorState = Highlights.changeEditorSelection(editorState, 1, 0, false);
        newEditorState = setDeleteSuggestionForCharacter(newEditorState, data);
        if (action !== 'delete') {
            return newEditorState;
        }
        return Highlights.changeEditorSelection(newEditorState, 1, 1, false);
    }
    // if there are insert or delete suggestion, reject them and then set delete suggestion
    newEditorState = applyChangeSuggestion(editorState, false);
    newEditorState = addDeleteParagraphSuggestions(newEditorState, data);
    selection = newEditorState.getSelection();
    selection = selection.merge({
        anchorOffset: action === 'delete' ? selection.getEndOffset() : selection.getStartOffset(),
        anchorKey: action === 'delete' ? selection.getEndKey() : selection.getStartKey(),
        focusOffset: action === 'delete' ? selection.getEndOffset() : selection.getStartOffset(),
        focusKey: action === 'delete' ? selection.getEndKey() : selection.getStartKey(),
        isBackward: false,
    });
    newEditorState = Highlights.addHighlight(newEditorState, 'DELETE_SUGGESTION', data);
    return draft_js_1.EditorState.acceptSelection(newEditorState, selection);
};
/**
 * @ngdoc method
 * @name setAddSuggestionForCharacter
 * @param {Object} state
 * @param {Object} data - info about the author of suggestion
 * @param {String} text - the suggestion added text
 * @param {Object} inlineStyle - the style for the text
 * @return {Object} returns new state
 * @description Set the add suggestion for current character.
 *   On suggestion mode:
 *   1. next neighbor is 'delete suggestion' with same user and the same char as added one -> reset related data
 *       1.1. if both neighbors are 'new suggestion' and has the same user -> concatenate them?
 *   2. at least one of neighbors is 'new suggestion' and has same user -> set the same data
 *   3. other cases -> add new 'new suggestion'
 */
var setAddSuggestionForCharacter = function (editorState, data, text, inlineStyle) {
    if (inlineStyle === void 0) { inlineStyle = null; }
    var crtInlineStyle = inlineStyle || editorState.getCurrentInlineStyle();
    var selection = editorState.getSelection();
    var beforeStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, -1);
    var beforeData = beforeStyle != null ? Highlights.getHighlightData(editorState, beforeStyle) : null;
    var currentStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, 0);
    var currentData = currentStyle != null ? Highlights.getHighlightData(editorState, currentStyle) : null;
    var content = editorState.getCurrentContent();
    var newState = editorState;
    content = draft_js_1.Modifier.insertText(content, selection, text);
    newState = draft_js_1.EditorState.push(newState, content, 'insert-characters');
    newState = Highlights.changeEditorSelection(newState, -1, 0, false);
    newState = applyStyleForSuggestion(newState, crtInlineStyle);
    if (beforeData != null && beforeData.type === 'ADD_SUGGESTION'
        && beforeData.author === data.author) {
        // if previous character is an add suggestion of the same user, set the same data
        newState = draft_js_1.RichUtils.toggleInlineStyle(newState, beforeStyle);
    }
    else if (currentData != null && currentData.type === 'ADD_SUGGESTION'
        && currentData.author === data.author) {
        // if next character is an add suggestion of the same user, set the same data
        newState = draft_js_1.RichUtils.toggleInlineStyle(newState, currentStyle);
    }
    else {
        // create a new suggestion
        newState = Highlights.addHighlight(newState, 'ADD_SUGGESTION', data);
    }
    newState = Highlights.changeEditorSelection(newState, 1, 0, true);
    return newState;
};
/**
 * @ngdoc method
 * @name isSplitParagraph
 * @param {Object} editorState
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns true if there is a split paragraph suggestion for the same user
 * @description Check if at current position there is a split paragraph suggestion.
 */
var isSplitParagraph = function (editorState, data) {
    var suggestionStyle = Highlights.getHighlightStyleAtCurrentPosition(editorState, ['SPLIT_PARAGRAPH_SUGGESTION']);
    if (suggestionStyle == null) {
        return false;
    }
    var suggestionAuthor = Highlights.getHighlightAuthor(editorState, suggestionStyle);
    return suggestionAuthor != null && suggestionAuthor === data.author;
};
/**
 * @ngdoc method
 * @name setMergeParagraphSuggestion
 * @param {Object} editorState
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Set the merge paragraph suggestion for current adjacent blocks.
 */
var setMergeParagraphSuggestion = function (editorState, data) {
    var type = 'MERGE_PARAGRAPHS_SUGGESTION';
    var checkState = Highlights.changeEditorSelection(editorState, -2, 0, false);
    var deleteSplitSuggestion = isSplitParagraph(checkState, data);
    var offset = deleteSplitSuggestion ? -1 : 0;
    var newState = Highlights.changeEditorSelection(editorState, offset, 0, false);
    var content = newState.getCurrentContent();
    var selection = newState.getSelection();
    if (deleteSplitSuggestion) {
        content = draft_js_1.Modifier.removeRange(content, selection, 'backward');
        newState = draft_js_1.EditorState.push(newState, content, 'remove-range');
    }
    else {
        content = draft_js_1.Modifier.replaceText(content, selection, Highlights.paragraphSeparator);
        newState = draft_js_1.EditorState.push(newState, content, 'insert-characters');
        newState = Highlights.changeEditorSelection(newState, -1, 0, false);
        newState = Highlights.addHighlight(newState, type, data);
        newState = Highlights.changeEditorSelection(newState, 0, -1, false);
    }
    return newState;
};
/**
 * @ngdoc method
 * @name createDeleteSuggestion
 * @param {Object} state
 * @param {Object} data - info about the author of suggestion
 * @return {Object} returns new state
 * @description Set the delete suggestion for current character.
 *    On suggestion mode:
 *   1. if previous neighbor is 'new suggestion' with the same user -> delete char
 *       1.1. if both new neighbors are 'new suggestion' and has the same user -> concatenate them?
 *   2. at least one of neighbors is 'delete suggestion' and has same user -> set the same suggestion data
 *   3. other cases -> add new 'delete suggestion'
 */
var setDeleteSuggestionForCharacter = function (editorState, data) {
    var selection = editorState.getSelection();
    var paragraphStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.paragraphSuggestionTypes, selection, -1);
    if (paragraphStyle != null) {
        // if current character is marked as paragraph suggestion, skip
        return Highlights.changeEditorSelection(editorState, -1, -1, true);
    }
    var currentStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, -1);
    var currentData = currentStyle != null ? Highlights.getHighlightData(editorState, currentStyle) : null;
    if (currentData != null && currentData.type === 'DELETE_SUGGESTION') {
        // if current character is already marked as a delete suggestion, skip
        return Highlights.changeEditorSelection(editorState, -1, -1, true);
    }
    if (currentData != null && currentData.type === 'ADD_SUGGESTION' &&
        currentData.author === data.author) {
        // if current character already a suggestion of current user, delete the character
        return deleteCharacter(editorState, currentStyle);
    }
    var beforeStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, -2);
    var beforeData = beforeStyle != null ? Highlights.getHighlightData(editorState, beforeStyle) : null;
    var afterParagraphStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.paragraphSuggestionTypes, selection, 0);
    var offset = afterParagraphStyle == null ? 0 : 1;
    var afterStyle = Highlights.getHighlightStyleAtOffset(editorState, highlightsConfig_1.changeSuggestionsTypes, selection, offset);
    var afterData = afterStyle != null ? Highlights.getHighlightData(editorState, afterStyle) : null;
    var newState = Highlights.changeEditorSelection(editorState, -1, 0, false);
    if (beforeData != null && beforeData.type === 'DELETE_SUGGESTION'
        && beforeData.author === data.author) {
        // if previous character is a delete suggestion of the same user, set the same data
        newState = draft_js_1.RichUtils.toggleInlineStyle(newState, beforeStyle);
    }
    else if (afterData != null && afterData.type === 'DELETE_SUGGESTION'
        && afterData.author === data.author) {
        // if next character is a delete suggestion of the same user, set the same data
        newState = draft_js_1.RichUtils.toggleInlineStyle(newState, afterStyle);
    }
    else {
        // create a new suggestion
        newState = Highlights.addHighlight(newState, 'DELETE_SUGGESTION', data);
    }
    return Highlights.changeEditorSelection(newState, 0, -1, true);
};
/**
 * @ngdoc method
 * @name applyStyleForSuggestion
 * @param {Object} editorState
 * @param {Objest} inlineStyle
 * @param {String} style
 * @return {Object} returns new state
 * @description Apply the style for current selection.
 */
var applyStyleForSuggestion = function (editorState, inlineStyle) {
    var newState = editorState;
    inlineStyle.filter(function (style) { return inlineStyles_1.acceptedInlineStyles.indexOf(style) !== -1; })
        .forEach(function (style) {
        newState = draft_js_1.RichUtils.toggleInlineStyle(newState, style);
    });
    var nextInlineStyle = Highlights.getHighlightStyleAtCurrentPosition(newState, highlightsConfig_1.styleSuggestionsTypes, true, false);
    if (nextInlineStyle == null) {
        return newState;
    }
    inlineStyle.forEach(function (style) {
        var type = Highlights.isHighlightStyle(style) ? Highlights.getHighlightTypeFromStyleName(style) : null;
        if (type != null && highlightsConfig_1.styleSuggestionsTypes.indexOf(type) !== -1 && nextInlineStyle.indexOf(style) !== -1 ||
            highlightsConfig_1.blockSuggestionTypes.indexOf(type) !== -1) {
            newState = draft_js_1.RichUtils.toggleInlineStyle(newState, style);
        }
    });
    return newState;
};
/**
 * @ngdoc method
 * @name resetSuggestion
 * @param {Object} editorState
 * @param {String} style
 * @return {Object} returns new state
 * @description For type suggestion reset both style and data for
 * current character position.
 */
var resetSuggestion = function (editorState, style) {
    var newState = editorState;
    newState = Highlights.changeEditorSelection(newState, 0, 1, false);
    newState = Highlights.resetHighlightForCurrentSelection(newState, style);
    newState = Highlights.changeEditorSelection(newState, 1, 0, false);
    return newState;
};
/**
 * @ngdoc method
 * @name deleteCharacter
 * @param {Object} editorState
 * @param {String} style - style of the current selection (optional)
 * @return {Object} returns new state
 * @description Delete the current character.
 */
var deleteCharacter = function (editorState, style) {
    if (style === void 0) { style = null; }
    var newState = Highlights.changeEditorSelection(editorState, -1, 0, false);
    var content = newState.getCurrentContent();
    var selection = newState.getSelection();
    content = draft_js_1.Modifier.removeRange(content, selection, 'forward');
    newState = draft_js_1.EditorState.push(newState, content, 'backspace-character');
    if (style) {
        var textForHighlight = Highlights.getRangeAndTextForStyle(newState, style);
        if (textForHighlight.highlightedText === '') {
            // also delete the suggestion if it was the last character of that suggestion
            newState = Highlights.removeHighlight(newState, style);
        }
    }
    return newState;
};
exports.default = suggestions;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EmbedBlock_1 = __webpack_require__(1327);
exports.EmbedBlock = EmbedBlock_1.EmbedBlock;
var EmbedInput_1 = __webpack_require__(542);
exports.EmbedInput = EmbedInput_1.EmbedInput;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// see https://iframely.com/docs/reactjs and https://gist.github.com/nleush/7e7775c9709eb3bdb6e6
Object.defineProperty(exports, "__esModule", { value: true });
var promise = null;
function importIframelyEmbedJs() {
    if (promise === null) {
        promise = new Promise(function (resolve) {
            var embed = document.createElement('script');
            embed.type = 'text/javascript';
            embed.async = true;
            embed.onload = resolve;
            embed.src = (document.location.protocol === 'https:' ? 'https:' : 'http:') + '//cdn.iframe.ly/embed.js';
            document.body.appendChild(embed);
        });
    }
    return promise;
}
function loadIframelyEmbedJs() {
    importIframelyEmbedJs().then(function () {
        var iframely = window.iframely = window.iframely || {};
        var widgets = iframely.widgets = iframely.widgets || {};
        if (widgets.load) {
            widgets.load();
        }
    });
}
exports.loadIframelyEmbedJs = loadIframelyEmbedJs;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var loadIframely_1 = __webpack_require__(541);
var ng_1 = __importDefault(__webpack_require__(18));
var react_redux_1 = __webpack_require__(25);
var actions_1 = __webpack_require__(24);
var utils_1 = __webpack_require__(3);
var fallbackAPIKey = '1d1728bf82b2ac8139453f'; // register to author's personal account
var GenericError = utils_1.gettext('This URL could not be embedded.');
exports.getEmbedObject = function (url) {
    var config = ng_1.default.get('config');
    var apiKey = config.iframely.key || fallbackAPIKey;
    return $.ajax({
        url: "//iframe.ly/api/oembed?callback=?&url=" + url + "&api_key=" + apiKey + "&omit_script=true&iframe=true",
        dataType: 'json',
    });
};
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @param {Function} hidePopups To be called when the input needs to be hidden.
 * @param {Function} onSubmit Dispatcher for the submit action. Takes the oEmbed response object as a parameter.
 * @name EmbedInputComponent
 * @description The dialog displayed when an embed URL is entered.
 */
var EmbedInputComponent = /** @class */ (function (_super) {
    __extends(EmbedInputComponent, _super);
    function EmbedInputComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { error: '' };
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onCancel = _this.onCancel.bind(_this);
        _this.processSuccess = _this.processSuccess.bind(_this);
        _this.processError = _this.processError.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name EmbedInputComponent#onKeyUp
     * @param {Event} e
     * @description Handles key up events in the input. Cancels on ESC.
     */
    EmbedInputComponent.prototype.onKeyUp = function (e) {
        if (e.key === 'Escape') {
            this.onCancel();
        }
    };
    /**
     * @ngdoc method
     * @name EmbedInputComponent#processResponse
     * @param {Object} data
     * @param {String} status
     * @description Processes the success XHR response from the iframe.ly request. Dispatches
     * the action that embeds the response into the editor.
     */
    EmbedInputComponent.prototype.processSuccess = function (data) {
        this.props.embed(data);
        this.onCancel();
    };
    /**
     * @ngdoc method
     * @name EmbedInputComponent#processError
     * @param {Object} data
     * @param {String} status
     * @description Processes the error XHR response from the iframe.ly request. Sets the state
     * to erroneous, which should be shown in the UI.
     */
    EmbedInputComponent.prototype.processError = function (data, status) {
        if (data === void 0) { data = {}; }
        var responseJSON = data.responseJSON;
        var hasMessage = responseJSON && responseJSON.error;
        var is404 = !hasMessage && data.status === 404;
        var error = hasMessage ? responseJSON.error : GenericError;
        if (is404) {
            error = utils_1.gettext('URL not found.');
        }
        this.setState({ error: error });
    };
    /**
     * @ngdoc method
     * @name EmbedInputComponent#onKeyUp
     * @param {Object} data
     * @param {String} status
     * @description Verifies with the iframe.ly API if the submitted URL is valid.
     */
    EmbedInputComponent.prototype.onSubmit = function () {
        var value = this.txt.value;
        if (!value.startsWith('http://') && !value.startsWith('https://')) {
            return this.processSuccess(value);
        }
        exports.getEmbedObject(value)
            .then(function (data) { return data.type === 'link' ? $.Deferred().reject() : data; })
            .then(this.processSuccess, this.processError);
    };
    /**
     * @ngdoc method
     * @name EmbedInputComponent#onCancel
     * @description Calls the onCancel prop function and resets the error state.
     */
    EmbedInputComponent.prototype.onCancel = function () {
        this.setState({ error: '' });
        this.props.hidePopups();
    };
    EmbedInputComponent.prototype.componentDidMount = function () {
        loadIframely_1.loadIframelyEmbedJs();
        this.txt.focus();
    };
    EmbedInputComponent.prototype.render = function () {
        var _this = this;
        var error = this.state.error;
        return (react_1.default.createElement("form", { onSubmit: this.onSubmit, className: "embed-dialog", onKeyUp: this.onKeyUp },
            react_1.default.createElement("input", { type: "url", ref: function (txt) {
                    _this.txt = txt;
                }, placeholder: utils_1.gettext('Enter URL or code to embed') }),
            react_1.default.createElement("div", { className: "input-controls" },
                react_1.default.createElement("a", { className: "icn-btn", onClick: this.onSubmit },
                    react_1.default.createElement("i", { className: "icon-ok" })),
                react_1.default.createElement("a", { className: "icn-btn", onClick: this.onCancel },
                    react_1.default.createElement("i", { className: "icon-close-small" }))),
            error ? react_1.default.createElement("div", { className: "embed-dialog__error" }, error) : null));
    };
    return EmbedInputComponent;
}(react_1.default.Component));
exports.EmbedInputComponent = EmbedInputComponent;
EmbedInputComponent.propTypes = {
    embed: prop_types_1.default.func.isRequired,
    hidePopups: prop_types_1.default.func.isRequired,
};
exports.EmbedInput = react_redux_1.connect(null, {
    embed: actions_1.embed,
    hidePopups: actions_1.hidePopups,
})(EmbedInputComponent);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var actions = __importStar(__webpack_require__(24));
var ng_1 = __importDefault(__webpack_require__(18));
var stickElementsWithTracking_1 = __webpack_require__(1329);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name SpellcheckerContextMenu
 * @param {String} word the text the menu is opened for
 * @param {Array} suggestions the list of suggestions for the target word
 * @param {Object} position the editor relative position where the context menu will be showed
 * @param {replaceWord} replaceWord callback
 * @description The context menu for correction spellcheck errors. Contains a list of suggestions
 * and 'Add to dictionary' and 'Ignore word' actions.
 */
var SpellcheckerContextMenuComponent = /** @class */ (function (_super) {
    __extends(SpellcheckerContextMenuComponent, _super);
    function SpellcheckerContextMenuComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.addWord = _this.addWord.bind(_this);
        _this.replaceWord = _this.replaceWord.bind(_this);
        _this.ignoreWord = _this.ignoreWord.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name SpellcheckerContextMenu#addWord
     * @param {Event} e
     * @description Handles the add word command.
     */
    SpellcheckerContextMenuComponent.prototype.addWord = function (e) {
        var spellcheck = ng_1.default.get('spellcheck');
        var _a = this.props, word = _a.word, refreshWord = _a.refreshWord;
        spellcheck.addWord(word.text, false);
        refreshWord(word);
    };
    /**
     * @ngdoc method
     * @name SpellcheckerContextMenu#replaceWord
     * @param {Event} e
     * @description Handles the replace word command.
     */
    SpellcheckerContextMenuComponent.prototype.replaceWord = function (newWord) {
        var _a = this.props, word = _a.word, replaceWord = _a.replaceWord;
        return function (e) {
            replaceWord({ word: word, newWord: newWord });
        };
    };
    /**
     * @ngdoc method
     * @name SpellcheckerContextMenu#ignoreWord
     * @param {Event} e
     * @description Handles the ignore word command.
     */
    SpellcheckerContextMenuComponent.prototype.ignoreWord = function (e) {
        var spellcheck = ng_1.default.get('spellcheck');
        var _a = this.props, word = _a.word, refreshWord = _a.refreshWord;
        spellcheck.addWord(word.text, true);
        refreshWord(word);
    };
    SpellcheckerContextMenuComponent.prototype.componentDidMount = function () {
        this.stickyElementTracker = new stickElementsWithTracking_1.StickElementsWithTracking(this.props.targetElement, this.dropdownElement);
    };
    SpellcheckerContextMenuComponent.prototype.componentWillUnmount = function () {
        this.stickyElementTracker.destroy();
    };
    SpellcheckerContextMenuComponent.prototype.render = function () {
        var _this = this;
        var suggestions = this.props.suggestions;
        return (react_1.default.createElement("div", { className: 'dropdown open suggestions-dropdown', ref: function (el) { return _this.dropdownElement = el; }, style: { zIndex: 999, border: 'solid transparent', borderWidth: '6px 0' } },
            react_1.default.createElement("ul", { className: 'dropdown__menu', style: { position: 'static' } },
                suggestions.length === 0 ? react_1.default.createElement("li", null,
                    react_1.default.createElement("button", null, "SORRY, NO SUGGESTIONS."))
                    : suggestions.map(function (suggestion, index) {
                        return react_1.default.createElement("li", { key: index },
                            react_1.default.createElement("button", { onMouseDown: _this.replaceWord(suggestion.key) }, suggestion.value));
                    }),
                react_1.default.createElement("li", { className: "divider" }),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { onMouseDown: this.addWord }, "Add to dictionary")),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("button", { onMouseDown: this.ignoreWord }, "Ignore word")))));
    };
    return SpellcheckerContextMenuComponent;
}(react_1.default.Component));
exports.SpellcheckerContextMenuComponent = SpellcheckerContextMenuComponent;
/** Set the types of props for the spellchecker context menu component*/
SpellcheckerContextMenuComponent.propTypes = {
    word: prop_types_1.default.object,
    suggestions: prop_types_1.default.array,
    replaceWord: prop_types_1.default.func,
    refreshWord: prop_types_1.default.func,
    targetElement: prop_types_1.default.object,
};
/**
 * @ngdoc method
 * @name SpellcheckerContextMenu#mapDispatchToProps
 * @param {Function} dispatch callback to store
 * @returns {Object} Returns the props values
 * @description Maps the values from state to the component callback type props.
 */
var mapDispatchToProps = function (dispatch) { return ({
    refreshWord: function (word) { return setTimeout(function () { return dispatch(actions.refreshWord(word)); }, 0); },
    replaceWord: function (word) { return setTimeout(function () { return dispatch(actions.replaceWord(word)); }, 0); },
}); };
exports.SpellcheckerContextMenu = react_redux_1.connect(null, mapDispatchToProps)(SpellcheckerContextMenuComponent);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TableBlock_1 = __webpack_require__(1336);
exports.TableBlock = TableBlock_1.TableBlock;
var TableCell_1 = __webpack_require__(1337);
exports.TableCell = TableCell_1.TableCell;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.customStyleMap = {
    HIGHLIGHT: {
        display: 'inline-block',
        padding: '1px 3px',
        backgroundColor: 'rgba(255, 235, 59, 0.2)',
    },
    HIGHLIGHT_STRONG: {
        display: 'inline-block',
        padding: '1px 3px',
        backgroundColor: 'rgba(255, 235, 59, 0.8)',
    },
    COMMENT: {
        backgroundColor: 'rgba(255, 235, 59, 0.2)',
    },
    COMMENT_SELECTED: {
        backgroundColor: 'rgba(255, 235, 59, 0.6)',
    },
    ANNOTATION: {
        borderBottom: '4px solid rgba(100, 205, 0, 0.6)',
    },
    ANNOTATION_SELECTED: {
        borderBottom: '4px solid rgba(100, 205, 0, 1.0)',
    },
    STRIKETHROUGH: {
        textDecoration: 'line-through',
    },
    CODE: {
        backgroundColor: '#e6ffe6',
    },
    SUBSCRIPT: {
        verticalAlign: 'sub',
        fontSize: 'smaller',
    },
    SUPERSCRIPT: {
        verticalAlign: 'super',
        fontSize: 'smaller',
    },
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var Editor3Component_1 = __webpack_require__(194);
var editor3_1 = __webpack_require__(175);
var EmbedInput_1 = __webpack_require__(542);
var EDITOR_BLOCK_TYPE = 'superdesk/editor3-block';
function isEditorBlockEvent(event) {
    return event.originalEvent.dataTransfer.types.indexOf(EDITOR_BLOCK_TYPE) > -1;
}
exports.isEditorBlockEvent = isEditorBlockEvent;
function getEditorBlock(event) {
    return event.originalEvent.dataTransfer.getData(EDITOR_BLOCK_TYPE);
}
exports.getEditorBlock = getEditorBlock;
var BaseUnstyledComponent = /** @class */ (function (_super) {
    __extends(BaseUnstyledComponent, _super);
    function BaseUnstyledComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onDrop = _this.onDrop.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.onDragLeave = _this.onDragLeave.bind(_this);
        _this.state = { over: false };
        return _this;
    }
    BaseUnstyledComponent.prototype.onDrop = function (event) {
        var _this = this;
        this.setState({ over: false });
        event.preventDefault();
        event.stopPropagation();
        var block = getEditorBlock(event);
        if (typeof block === 'string' && block.length > 0) {
            // existing media item dropped to another place
            this.props.dispatch(editor3_1.moveBlock(block, this.getDropBlockKey(), this.dropInsertionMode));
            return;
        }
        var dataTransfer = event.originalEvent.dataTransfer;
        var mediaType = Editor3Component_1.getValidMediaType(event.originalEvent);
        var blockKey = this.getDropBlockKey();
        var link = event.originalEvent.dataTransfer.getData('URL');
        if (Editor3Component_1.canDropMedia(event, this.props.editorProps) && mediaType.includes('application/superdesk')) {
            this.props.dispatch(editor3_1.dragDrop(dataTransfer, mediaType, blockKey));
        }
        else if (typeof link === 'string'
            && link.startsWith('http')
            && this.props.editorProps.editorFormat.includes('embed')) {
            EmbedInput_1.getEmbedObject(link)
                .then(function (oEmbed) {
                _this.props.dispatch(editor3_1.embed(oEmbed, blockKey));
            });
        }
        else if (mediaType === 'text/html' && this.props.editorProps.editorFormat.includes('embed')) {
            this.props.dispatch(editor3_1.embed(event.originalEvent.dataTransfer.getData(mediaType), blockKey));
        }
        else {
            console.warn('unsupported media type on drop', mediaType);
        }
    };
    BaseUnstyledComponent.prototype.onDragOver = function (event) {
        if (this.leaveTimeout) {
            clearTimeout(this.leaveTimeout);
            this.leaveTimeout = null;
        }
        event.preventDefault();
        event.stopPropagation();
        this.setState({ over: true });
    };
    BaseUnstyledComponent.prototype.onDragLeave = function (event) {
        var _this = this;
        event.stopPropagation();
        if (this.state.over && !this.leaveTimeout) {
            this.leaveTimeout = setTimeout(function () {
                _this.setState({ over: false });
                _this.leaveTimeout = null;
            }, 50); // avoid placeholder flickering
        }
    };
    BaseUnstyledComponent.prototype.componentDidMount = function () {
        $(this.div).on('drop', this.onDrop);
        $(this.div).on('dragleave', this.onDragLeave);
        $(this.div).on('dragover dragenter', this.onDragOver);
    };
    BaseUnstyledComponent.prototype.componentWillUnmount = function () {
        $(this.div).off();
    };
    return BaseUnstyledComponent;
}(react_1.default.Component));
BaseUnstyledComponent.propTypes = {
    dispatch: prop_types_1.default.func.isRequired,
    editorProps: prop_types_1.default.object,
};
exports.default = BaseUnstyledComponent;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataUrl = function (file) { return new Promise(function (resolve) {
    var fileReader = new FileReader();
    fileReader.onload = function () { return resolve(fileReader.result.toString()); };
    fileReader.readAsDataURL(file);
}); };
angular.module('superdesk.core.upload.imagepreview', []).directive('sdImagePreview', [function () {
        var IS_IMG_REGEXP = /^image\//;
        return {
            scope: {
                file: '=',
                sdImagePreview: '=',
                progressWidth: '=',
                width: '=?',
                height: '=?',
            },
            link: function (scope, elem) {
                function setProgress(val) {
                    if (scope.progressWidth !== undefined) {
                        scope.progressWidth = val;
                    }
                }
                scope.$watch('file', function (file) {
                    if (file && IS_IMG_REGEXP.test(file.type)) {
                        setProgress(30);
                        exports.getDataUrl(file).then(function (dataUrl) {
                            scope.$apply(function () {
                                scope.sdImagePreview = dataUrl;
                                setProgress(50);
                            });
                            var img = document.createElement('img');
                            img.onload = function () {
                                scope.$apply(function () {
                                    scope.width = img.width;
                                    scope.height = img.height;
                                });
                            };
                            img.src = dataUrl;
                        });
                    }
                });
                scope.$on('$destroy', function () {
                    window.URL.revokeObjectURL(scope.sdImagePreview);
                });
            },
        };
    }]);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var ReactRenderAsync_1 = __webpack_require__(54);
exports.isWidgetVisibleForContentProfile = function (widgetsConfig, widgetId) {
    var defaultOption = true;
    if (widgetsConfig == null) {
        return defaultOption;
    }
    var widgetConfig = widgetsConfig.find(function (config) { return config.widget_id === widgetId; });
    return widgetConfig == null ? defaultOption : widgetConfig.is_displayed;
};
var WidgetsConfigComponent = /** @class */ (function (_super) {
    __extends(WidgetsConfigComponent, _super);
    function WidgetsConfigComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            widgetsConfig: _this.props.initialWidgetsConfig || [],
        };
        return _this;
    }
    WidgetsConfigComponent.prototype.handleChange = function (id, nextValue) {
        var _this = this;
        var configForWidgetExists = this.state.widgetsConfig.find(function (widget) { return widget.widget_id === id; }) != null;
        this.setState({
            widgetsConfig: configForWidgetExists
                ? this.state.widgetsConfig.map(function (config) {
                    return config.widget_id === id ? __assign({}, config, { is_displayed: nextValue }) : config;
                })
                : this.state.widgetsConfig.concat({ widget_id: id, is_displayed: nextValue }),
        }, function () {
            _this.props.onUpdate(_this.state.widgetsConfig);
        });
    };
    WidgetsConfigComponent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "sd-alert sd-alert--hollow sd-alert--small", style: { marginTop: 20 } }, gettext('Show or hide the widgets in the right toolbar in the editor workspace.')),
            react_1.default.createElement("ul", { className: "sd-list-item-group sd-shadow--z2" }, this.props.authoringWidgets.map(function (widget, i) { return (react_1.default.createElement("li", { className: "sd-list-item", key: i },
                react_1.default.createElement("span", { className: "sd-list-item__column" },
                    react_1.default.createElement("input", { type: "checkbox", checked: exports.isWidgetVisibleForContentProfile(_this.state.widgetsConfig, widget._id), onChange: function (e) { return _this.handleChange(widget._id, e.target.checked); } })),
                react_1.default.createElement("span", { className: "sd-list-item__column" }, widget.label))); }))));
    };
    return WidgetsConfigComponent;
}(react_1.default.Component));
exports.WidgetsConfigComponent = WidgetsConfigComponent;
exports.WidgetsConfig = ReactRenderAsync_1.connectServices(WidgetsConfigComponent, ['authoringWidgets']);


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c12d208a5eb6e69390855a2392335f4.png";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
}();

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ConfigController_1 = __webpack_require__(1437);
exports.ConfigController = ConfigController_1.ConfigController;
var DashboardController_1 = __webpack_require__(1438);
exports.DashboardController = DashboardController_1.DashboardController;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ab424dc9a7a6342063ebe78bff323eb0.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserEditController_1 = __webpack_require__(1456);
exports.UserEditController = UserEditController_1.UserEditController;
var UserListController_1 = __webpack_require__(1457);
exports.UserListController = UserListController_1.UserListController;
var ChangeAvatarController_1 = __webpack_require__(1458);
exports.ChangeAvatarController = ChangeAvatarController_1.ChangeAvatarController;
var UserEnableCommand_1 = __webpack_require__(1459);
exports.UserEnableCommand = UserEnableCommand_1.UserEnableCommand;
var UserDeleteCommand_1 = __webpack_require__(1460);
exports.UserDeleteCommand = UserDeleteCommand_1.UserDeleteCommand;
var SessionsDeleteCommand_1 = __webpack_require__(1461);
exports.SessionsDeleteCommand = SessionsDeleteCommand_1.SessionsDeleteCommand;
var UserResolver_1 = __webpack_require__(1462);
exports.UserResolver = UserResolver_1.UserResolver;
// TODO: is this needed?
UserRolesController.$inject = ['$scope'];
function UserRolesController($scope) { }
exports.UserRolesController = UserRolesController;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
* Common error handler code for privilege errors
*/
function privilegesErrorHandler(response) {
    if (angular.isDefined(response.data._issues) &&
        angular.isDefined(response.data._issues['validator exception'])) {
        return 'Error: ' + response.data._issues['validator exception'];
    }
    else if (angular.isDefined(response.data._message)) {
        return 'Error: ' + response.data._message;
    }
    return 'Error. Privileges not updated.';
}
exports.default = privilegesErrorHandler;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
function notifySaveError(response, notify) {
    if (angular.isDefined(response.data._issues) &&
        angular.isDefined(response.data._issues['validator exception'])) {
        notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
    }
    else if (angular.isDefined(response.data._issues) &&
        angular.isDefined(response.data._issues.template_name)) {
        notify.error(utils_1.gettext('Error: ' + response.data._issues.template_name));
    }
    else if (angular.isDefined(response.data._message)) {
        notify.error(utils_1.gettext(response.data._message));
    }
    else {
        notify.error(utils_1.gettext('Error: Failed to save template.'));
    }
}
exports.default = notifySaveError;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.limits = {
    stage: 40,
    desk: 40,
};


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name DesksReactDropdown
 *
 * @requires React
 * @requires item
 * @requires className
 * @requires desks
 * @requires noDesksLabel
 *
 * @description Creates dropdown react element with list of available desks
 */
var react_1 = __importDefault(__webpack_require__(0));
var components_1 = __webpack_require__(245);
exports.DesksReactDropdown = function (item, className, desks, noDesksLabel) { return (react_1.default.createElement(components_1.MarkDesksDropdown, { className: className, desks: desks, item: item, noDesksLabel: noDesksLabel })); };
exports.DesksReactDropdown.$inject = ['item', 'className', 'desks', 'noDesksLabel'];


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring
 * @name ChangeImageController
 *
 * @requires $scope
 * @requires notify
 * @requires modal
 * @requires lodash
 * @requires api
 * @requires $rootScope
 * @requires deployConfig
 *
 * @description Controller is responsible for cropping pictures and setting Point of Interest for an image.
 */
function validateMediaFieldsThrows(validator, metadata) {
    for (var key in validator) {
        var value = metadata[key];
        var regex = new RegExp('^\<*br\/*\>*$', 'i');
        if (validator[key].required && (!value || value.match(regex))) {
            throw utils_1.gettext('Required field(s) missing');
        }
    }
}
exports.validateMediaFieldsThrows = validateMediaFieldsThrows;
ChangeImageController.$inject = ['$scope', 'notify', 'lodash', 'api', '$rootScope',
    'deployConfig', '$q', 'config'];
function ChangeImageController($scope, notify, _, api, $rootScope, deployConfig, $q, config) {
    $scope.data = $scope.locals.data;
    $scope.data.cropData = {};
    $scope.validator = deployConfig.getSync('validator_media_metadata');
    var sizes = {};
    var DEFAULT_CONTROLS = {
        brightness: 1,
        contrast: 1,
        saturation: 1,
        rotate: 0,
        fliph: 0,
        flipv: 0,
        isDirty: false,
    };
    var EDITABLE_METADATA = [
        'subject',
        'headline',
        'description_text',
        'archive_description',
        'alt_text',
        'byline',
        'copyrightholder',
        'usageterms',
        'copyrightnotice',
        'place',
        'subject',
        'keywords',
    ].concat(Object.keys(lodash_1.get(deployConfig.getSync('schema'), 'picture', {})));
    $scope.controls = angular.copy(DEFAULT_CONTROLS);
    $scope.showMetadata = $scope.data.showMetadata;
    $scope.nav = $scope.data.defaultTab || 'view';
    $scope.tabs = $scope.data.tabs || ['view', 'image-edit', 'crop'];
    $scope.metadata = {
        isDirty: false,
    };
    $scope.crops = {
        isDirty: false,
    };
    if ($scope.data.renditions) {
        $scope.data.renditions.forEach(function (rendition) {
            var original = $scope.data.item.renditions.original;
            // only extend the item renditions if the original image can fit the rendition dimensions
            // otherwise we will get an error saving
            if (original && original.height >= rendition.height && original.width >= rendition.width) {
                sizes[rendition.name] = { width: rendition.width, height: rendition.height };
                $scope.data.cropData[rendition.name] = angular.extend({}, $scope.data.item.renditions[rendition.name]);
            }
        });
    }
    $scope.data.isDirty = false;
    $scope.isNew = $scope.data.isNew === true;
    // should show the metadata form in the view
    $scope.data.showMetadataEditor = $scope.data.showMetadataEditor === true;
    // initialize metadata from `item`
    $scope.data.metadata = angular.copy($scope.data.item);
    $scope.selectedRendition = null;
    $scope.selectRendition = function (rendition) {
        if (!rendition) {
            $scope.selectedRendition = null;
        }
        else if ($scope.selectedRendition === null || $scope.selectedRendition.name !== rendition.name) {
            $scope.selectedRendition = rendition;
        }
    };
    var _origCropsData = angular.copy($scope.data.cropData);
    if (_origCropsData && Object.keys(_origCropsData).length === 0) {
        $scope.data.isDirty = true;
    }
    /**
     * @ngdoc method
     * @name ChangeImageController#isDoneEnabled
     * @public
     * @description if dirty or is new picture item.
     * @returns {Boolean}
     */
    $scope.isDoneEnabled = function () {
        return !$scope.metadata.isDirty &&
            !$scope.controls.isDirty &&
            !$scope.crops.isDirty &&
            !$scope.isAoISelectionModeEnabled;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#saveCrops
    * @public
    * @description Validate new crop-coordinates and resolve the promise and return
    * modified crop information, point of interest and metadata changes.
    */
    $scope.saveCrops = function () {
        /* Throw an exception if PoI is outside of a crop */
        function poiIsInsideEachCrop() {
            var originalImage = $scope.data.metadata.renditions.original;
            if (!$scope.data.poi || !_.isFinite($scope.data.poi.x) || !_.isFinite($scope.data.poi.y)) {
                throw utils_1.gettext('Point of interest is not defined.');
            }
            var originalPoi = {
                x: originalImage.width * $scope.data.poi.x,
                y: originalImage.height * $scope.data.poi.y,
            };
            _.forEach($scope.data.cropData, function (cropData, cropName) {
                if (!cropData || _.isEmpty(cropData)) {
                    throw utils_1.gettext('Crop coordinates are not defined for {{cropName}} picture crop.', { cropName: cropName });
                }
                if (originalPoi.y < cropData.CropTop ||
                    originalPoi.y > cropData.CropBottom ||
                    originalPoi.x < cropData.CropLeft ||
                    originalPoi.x > cropData.CropRight) {
                    throw utils_1.gettext('Point of interest outside the crop {{cropName}} limits', { cropName: cropName });
                }
            });
        }
        // check if data are valid
        try {
            if (config.features.validatePointOfInterestForImages === true) {
                poiIsInsideEachCrop();
            }
        }
        catch (e) {
            // show an error and stop the "done" operation
            notify.error(e);
            return false;
        }
        // update crop and poi data in `item`
        angular.extend($scope.data.item, $scope.data.metadata);
        $scope.data.item.poi = $scope.data.poi;
        $scope.data.metadata.poi = $scope.data.poi;
        $scope.crops.isDirty = false;
        $scope.data.isDirty = true;
        return true;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#cancelCrops
    * @public
    * @description
    */
    $scope.cancelCrops = function () {
        $scope.data.cropData = angular.copy(_origCropsData);
        $scope.crops.isDirty = false;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#applyMetadataChanges
    * @public
    * @description
    */
    $scope.applyMetadataChanges = function () {
        try {
            validateMediaFieldsThrows($scope.validator, $scope.data.metadata);
        }
        catch (e) {
            // show an error and stop the "done" operation
            notify.error(e);
            return false;
        }
        $scope.metadata.isDirty = false;
        $scope.data.isDirty = true;
        return true;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#cancelMetadataChanges
    * @public
    * @description
    */
    $scope.cancelMetadataChanges = function () {
        $rootScope.$broadcast('clear: selectedUsageTerms');
        $scope.data.metadata = angular.copy($scope.data.item);
        $scope.metadata.isDirty = false;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#done
    * @public
    * @description Validate new crop-coordinates and resolve the promise and return
    * modified crop information, point of interest and metadata changes.
    */
    $scope.done = function () {
        if ($scope.data.isDirty) {
            if ($scope.data.item.type === 'picture' && config.features.validatePointOfInterestForImages === true) {
                if (!$scope.saveCrops() || !$scope.applyMetadataChanges()) {
                    return;
                }
            }
            $scope.resolve({
                cropData: $scope.data.cropData,
                metadata: _.pick($scope.data.metadata, EDITABLE_METADATA.concat([
                    'poi',
                    'renditions',
                    '_etag',
                ])),
            });
        }
        else {
            $scope.reject();
        }
    };
    // Area of Interest
    $scope.data.showAoISelectionButton = $scope.data.showAoISelectionButton === true;
    /**
    * @ngdoc method
    * @name ChangeImageController#showAreaOfInterestView
    * @public
    * @description Open the area for interest view.
    */
    $scope.showAreaOfInterestView = function (show) {
        angular.extend($scope, {
            isAoISelectionModeEnabled: show === undefined || show,
            areaOfInterestData: {},
            showLoader: false,
            isAoIDirty: false,
        });
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#enableSaveAreaOfInterest
    * @public
    * @description Enable/Disable the Save button for Area of Interest
    * @returns {Boolean}
    */
    $scope.enableSaveAreaOfInterest = function () {
        $scope.$applyAsync(function () {
            $scope.isAoIDirty = isAreaOfInterestChanged();
        });
    };
    function isAreaOfInterestChanged() {
        if ($scope.areaOfInterestData && angular.isDefined($scope.areaOfInterestData.CropLeft)) {
            var _a = $scope.data.item.renditions.original, width = _a.width, height = _a.height;
            return width !== $scope.areaOfInterestData.CropRight - $scope.areaOfInterestData.CropLeft ||
                height !== $scope.areaOfInterestData.CropBottom - $scope.areaOfInterestData.CropTop;
        }
        return false;
    }
    function extractEditableMetadata(metadata) {
        return _.pick(metadata, EDITABLE_METADATA);
    }
    /**
    * @ngdoc method
    * @name ChangeImageController#saveAreaOfInterest
    * @public
    * @description Based on the new Area of Interest save the original image and crops.
    */
    $scope.saveAreaOfInterest = function (croppingData) {
        var _a = [
            croppingData.CropRight - croppingData.CropLeft,
            croppingData.CropBottom - croppingData.CropTop,
        ], width = _a[0], height = _a[1];
        var validCrop = true;
        // check if new crop is valid or not.
        if (Object.keys(sizes)) {
            validCrop = Object.keys(sizes).every(function (key) { return width >= sizes[key].width && height >= sizes[key].height; });
        }
        if (!validCrop) {
            notify.error(utils_1.gettext('Original size cannot be less than the required crop sizes.'));
            return;
        }
        $scope.showLoader = true;
        api.save('picture_crop', { item: $scope.data.item, crop: croppingData })
            .then(function (result) {
            angular.extend(result.item.renditions.original, {
                href: result.href,
                width: result.width,
                height: result.height,
                media: result._id,
            });
            $scope.data.isDirty = true;
            return api.save('picture_renditions', { item: result.item, no_custom_crops: true }).then(function (item) {
                $scope.data.item.renditions = item.renditions;
                var editableMetadata = extractEditableMetadata($scope.data.metadata);
                $scope.data.metadata = Object.assign($scope.data.item, editableMetadata);
                $scope.data.poi = { x: 0.5, y: 0.5 };
                $rootScope.$broadcast('poiUpdate', $scope.data.poi);
            });
        }, function (response) {
            return $q.reject(response);
        })
            .then(function () {
            $scope.showAreaOfInterestView(false);
        }, function (response) {
            if (_.isObject(response.data) && angular.isDefined(response.data._message)) {
                notify.error(utils_1.gettext('Failed to save the area of interest: ' + response.data._message));
            }
            else {
                notify.error(utils_1.gettext('There was an error. Failed to save the area of interest.'));
            }
            $scope.showLoader = false;
        });
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#rotateImage
    * @public
    * @description Rotate image
    */
    $scope.rotateImage = function (direction) {
        switch (direction) {
            case 'left':
                $scope.controls.rotate = $scope.controls.rotate - 90;
                break;
            case 'right':
                $scope.controls.rotate = $scope.controls.rotate + 90;
                break;
        }
        return $scope.controls.isDirty = true;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#flipImage
    * @public
    * @description Flip image
    */
    $scope.flipImage = function (direction) {
        switch (direction) {
            case 'horizontal':
                $scope.controls.fliph = $scope.controls.fliph + 180;
                break;
            case 'vertical':
                $scope.controls.flipv = $scope.controls.flipv + 180;
                break;
        }
        return $scope.controls.isDirty = true;
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#applyImageChanges
    * @public
    * @description Apply image modifications
    */
    $scope.applyImageChanges = function () {
        var flip = 'none', flipH = Math.abs($scope.controls.fliph / 180 % 2), flipV = Math.abs($scope.controls.flipv / 180 % 2);
        if (flipH === 1 && flipV === 1) {
            flip = 'both';
        }
        else if (flipH === 1 && flipV === 0) {
            flip = 'horizontal';
        }
        else if (flipH === 0 && flipV === 1) {
            flip = 'vertical';
        }
        $scope.loaderForMediaEdit = true;
        return api.save('media_editor', { item: $scope.data.item, edit: {
                brightness: $scope.controls.brightness,
                contrast: $scope.controls.contrast,
                saturation: $scope.controls.saturation,
                rotate: -$scope.controls.rotate,
                flip: flip,
            } }).then(function (result) {
            $scope.data.item.renditions = result.renditions;
            $scope.data.item._etag = result._etag;
            var editableMetadata = extractEditableMetadata($scope.data.metadata);
            $scope.data.metadata = Object.assign($scope.data.item, editableMetadata);
            $scope.controls = angular.copy(DEFAULT_CONTROLS);
            $scope.data.isDirty = true;
            $scope.loaderForMediaEdit = false;
        });
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#setRatio
    * @public
    * @description Set image ratio
    */
    $scope.setRatio = function (ratio) {
        var originalImage = $scope.data.metadata.renditions.original;
        var sizeW, sizeH;
        switch (ratio) {
            case '16:9':
                sizeW = originalImage.width - (originalImage.height * 16 / 9);
                sizeH = originalImage.height - (originalImage.width * 9 / 16);
                break;
            case '4:3':
                sizeW = originalImage.width - (originalImage.height * 4 / 3);
                sizeH = originalImage.height - (originalImage.width * 3 / 4);
                break;
            case '3:2':
                sizeW = originalImage.width - (originalImage.height * 3 / 2);
                sizeH = originalImage.height - (originalImage.width * 2 / 3);
                break;
            default:
                sizeW = 0;
                sizeH = 0;
        }
        $scope.areaOfInterestData.CropTop = sizeH > 0 ? Math.round(sizeH / 2) : 0;
        $scope.areaOfInterestData.CropBottom = sizeH > 0 ?
            originalImage.height - Math.round(sizeH / 2) :
            originalImage.height;
        $scope.areaOfInterestData.CropLeft = sizeW > 0 ? Math.round(sizeW / 2) : 0;
        $scope.areaOfInterestData.CropRight = sizeW > 0 ?
            originalImage.width - Math.round(sizeW / 2) :
            originalImage.width;
    };
    $scope.resizeImage = function (image) {
        var originalImage = $scope.data.metadata.renditions.original;
        $scope.areaOfInterestData.CropTop = originalImage.height - image.height / 2;
        $scope.areaOfInterestData.CropBottom = originalImage.height - (originalImage.height - image.height / 2);
        $scope.areaOfInterestData.CropLeft = originalImage.width - image.width / 2;
        $scope.areaOfInterestData.CropRight = originalImage.width - (originalImage.width - image.width / 2);
    };
    /**
    * @ngdoc method
    * @name ChangeImageController#cancelImageChanges
    * @public
    * @description Cancel image changes and set values back to default
    */
    $scope.cancelImageChanges = function () { return $scope.controls = angular.copy(DEFAULT_CONTROLS); };
    /**
    * @ngdoc method
    * @name ChangeImageController#onChange
    * @public
    * @description Based on the new Area of Interest save the original image and crops.
    */
    $scope.onChange = function (renditionName, cropData) {
        $scope.$applyAsync(function () {
            if (angular.isDefined(renditionName)) {
                $scope.data.cropData[renditionName] = angular.extend({}, cropData, sizes[renditionName]);
                $scope.data.isDirty = true;
                $scope.crops.isDirty = true;
            }
        });
    };
    // init poi if not set
    if (!$scope.data.poi) {
        $scope.data.poi = { x: 0.5, y: 0.5 };
        if (!config.features.validatePointOfInterestForImages) {
            $scope.saveCrops(); // save it as defaults
        }
    }
}
exports.ChangeImageController = ChangeImageController;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
exports.state = function (props) {
    // support passing services as props
    var $filter = props.$filter || props.svc.$filter;
    var datetime = props.datetime || props.svc.datetime;
    if (props.item.state !== undefined && props.item.state !== null) {
        var title = $filter('removeLodash')(props.item.state);
        if (props.item.state === 'scheduled') {
            var scheduled = lodash_1.get(props.item, 'archive_item.schedule_settings.utc_publish_schedule');
            if (scheduled) {
                title = utils_1.gettext('Scheduled for {{date}}', { date: datetime.longFormat(scheduled) });
            }
        }
        return react_1.default.createElement('span', {
            title: title,
            style: props.style || {},
            className: 'state-label state-' + props.item.state,
            key: 'state',
        }, $filter('removeLodash')(utils_1.gettext(props.item.state)));
    }
};
exports.state.propTypes = {
    svc: prop_types_1.default.any,
    item: prop_types_1.default.any,
    style: prop_types_1.default.any,
    $filter: prop_types_1.default.any,
    datetime: prop_types_1.default.any,
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__(1681);

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var utils_1 = __webpack_require__(3);
exports.ItemPriority = function (props) {
    var metadata = props.svc.metadata;
    var priority = props.priority || 3;
    var spec = metadata.priorityByValue(priority);
    if (spec) {
        return react_1.default.createElement('span', {
            className: 'badge badge--square priority-label--' + priority,
            style: helpers_1.getSpecStyle(spec),
            title: helpers_1.getSpecTitle(spec, utils_1.gettext('Priority')),
            key: 'priority',
        }, helpers_1.getSpecValue(spec, priority));
    }
    return react_1.default.createElement('span', {
        className: 'badge badge--square priority-label--' + priority,
        title: utils_1.gettext('Priority'),
        key: 'priority',
    }, priority);
};
exports.ItemPriority.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    priority: prop_types_1.default.any,
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var utils_1 = __webpack_require__(3);
exports.ItemUrgency = function (props) {
    var metadata = props.svc.metadata;
    var urgency = props.urgency || 3;
    var spec = metadata.urgencyByValue(urgency);
    if (spec) {
        return react_1.default.createElement('span', {
            className: 'badge urgency-label--' + urgency,
            title: helpers_1.getSpecTitle(spec, utils_1.gettext('Urgency')),
            style: helpers_1.getSpecStyle(spec),
            key: 'urgency',
        }, helpers_1.getSpecValue(spec, urgency));
    }
    return react_1.default.createElement('span', {
        className: 'badge urgency-label--' + urgency,
        title: utils_1.gettext('Urgency'),
        key: 'urgency',
    }, urgency);
};
exports.ItemUrgency.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    urgency: prop_types_1.default.any,
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var helpers_1 = __webpack_require__(27);
function hasThumbnail(item) {
    return item.renditions && item.renditions.thumbnail;
}
/**
 * Media Preview - renders item thumbnail
 */
exports.MediaPreview = function (props) {
    var item = props.item;
    var headline = item.headline || item.slugline || item.type;
    // headline could contains html tags hence stripping for tooltips
    var headlineText = headline.replace(/(<([^>]+)>)/ig, '');
    var preview;
    if (hasThumbnail(props.item)) {
        preview = react_1.default.createElement('img', { src: props.item.renditions.thumbnail.href });
    }
    return react_1.default.createElement('div', { className: 'media multi' }, preview ? react_1.default.createElement('figure', null, preview) : null, react_1.default.createElement('span', { className: 'text' }, react_1.default.createElement('small', { title: headlineText,
        dangerouslySetInnerHTML: helpers_1.createMarkUp(headline) }), react_1.default.createElement(index_1.ItemContainer, {
        item: item,
        desk: props.desk,
    })), react_1.default.createElement(index_1.SelectBox, {
        item: item,
        onMultiSelect: props.onMultiSelect,
        svc: props.svc,
    }));
};
exports.MediaPreview.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    onMultiSelect: prop_types_1.default.func,
    desk: prop_types_1.default.any,
    item: prop_types_1.default.any,
};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
function hasThumbnail(item) {
    return item.renditions && item.renditions.thumbnail;
}
/**
 * Media Preview - renders item thumbnail
 */
exports.PhotoDeskPreview = function (props) {
    var item = props.item;
    var classType = 'sd-grid-item__type-icon filetype-icon-' + props.item.type;
    var preview = react_1.default.createElement("i", { className: classType });
    if (hasThumbnail(props.item)) {
        preview = react_1.default.createElement("img", { src: item.renditions.thumbnail.href });
    }
    return (react_1.default.createElement("div", { className: "sd-grid-item__thumb" },
        preview,
        react_1.default.createElement(index_1.SelectBox, { item: item, classes: "sd-grid-item__checkbox", onMultiSelect: props.onMultiSelect, svc: props.svc })));
};
exports.PhotoDeskPreview.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    onMultiSelect: prop_types_1.default.func,
    item: prop_types_1.default.any,
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var index_1 = __webpack_require__(22);
var utils_1 = __webpack_require__(3);
/**
 * Media Info - renders item metadata
 */
exports.MediaInfo = function (props) {
    var datetime = props.svc.datetime;
    var item = props.item;
    var meta = [];
    var source = props.ingestProvider ? props.ingestProvider.source : '';
    if (item.source) {
        source = item.source;
    }
    if (source) {
        meta.push(react_1.default.createElement('dt', { key: 1 }, utils_1.gettext('source')), react_1.default.createElement('dd', { key: 2, className: 'provider' }, source));
    }
    meta.push(react_1.default.createElement('dt', { key: 3 }, utils_1.gettext('updated')), react_1.default.createElement('dd', { key: 4 }, datetime.shortFormat(item.versioncreated)));
    if (item.is_spiked) {
        meta.push(react_1.default.createElement('dt', { key: 5 }, utils_1.gettext('expires')));
        meta.push(react_1.default.createElement('dd', { key: 6 }, datetime.shortFormat(item.expiry)));
    }
    var info = [];
    var flags = item.flags || {};
    info.push(react_1.default.createElement('h5', { key: 1,
        dangerouslySetInnerHTML: helpers_1.createMarkUp(item.headline || item.slugline || item.type) }));
    info.push(react_1.default.createElement('dl', { key: 2 }, meta));
    if (flags.marked_for_legal) {
        info.push(react_1.default.createElement('div', { key: 3, className: 'state-label legal' }, utils_1.gettext('Legal')));
    }
    if (item.archived) {
        info.push(react_1.default.createElement('div', { className: 'fetched-desk', key: 4 }, react_1.default.createElement(index_1.FetchedDesksInfo, {
            item: item,
            svc: props.svc,
        })));
    }
    return react_1.default.createElement('div', { className: 'media-info' }, info);
};
exports.MediaInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
    ingestProvider: prop_types_1.default.any,
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var PhotoDeskFields_1 = __webpack_require__(567);
var constants_1 = __webpack_require__(73);
var lodash_1 = __webpack_require__(2);
exports.PhotoDeskInfo = function (props) {
    var datetime = props.svc.datetime;
    var item = props.item, svc = props.svc;
    var gridViewFieldsConfig = lodash_1.get(svc.config, 'gridViewFields', constants_1.DEFAULT_GRID_VIEW_FIELDS_CONFIG);
    return (react_1.default.createElement("div", { className: "sd-grid-item__content" },
        react_1.default.createElement("time", null, datetime.longFormat(item.versioncreated)),
        react_1.default.createElement("span", { className: "sd-grid-item__title sd-grid-item--element-grow", dangerouslySetInnerHTML: helpers_1.createMarkUp(item.headline || item.slugline || item.type) }),
        react_1.default.createElement(PhotoDeskFields_1.PhotoDeskFields, { fieldsConfig: gridViewFieldsConfig, item: item, svc: svc, itemClassName: "sd-grid-item__content-block" })));
};
exports.PhotoDeskInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var fields = __importStar(__webpack_require__(160));
var getLabelForFieldId_1 = __webpack_require__(62);
var ReactRenderAsync_1 = __webpack_require__(54);
exports.PhotoDeskFieldsComponent = function (props) {
    var item = props.item, getLabelForFieldId = props.getLabelForFieldId, itemClassName = props.itemClassName;
    return props.fieldsConfig
        .map(function (fieldId, i) {
        var customRenderedAvailable = typeof fields[fieldId] === 'function';
        var value = customRenderedAvailable
            ? fields[fieldId]({ item: item, svc: props.svc, className: itemClassName })
            : item[fieldId];
        if (value == null) {
            return null;
        }
        var showLabel = props.labelMode === 'always'
            || !(props.labelMode === 'never-with-custom-renderer' && customRenderedAvailable);
        return showLabel === true
            ? (react_1.default.createElement("span", { key: i, className: itemClassName },
                react_1.default.createElement("span", { className: "sd-grid-item__text-label" },
                    getLabelForFieldId(fieldId),
                    ":"),
                react_1.default.createElement("span", { className: "sd-grid-item__text-strong" }, value)))
            : react_1.default.createElement("span", { className: "sd-grid-item__footer-block-item", key: i }, value);
    });
};
exports.PhotoDeskFields = ReactRenderAsync_1.connectPromiseResults(function () { return ({
    getLabelForFieldId: getLabelForFieldId_1.getLabelNameResolver(),
}); })(exports.PhotoDeskFieldsComponent);


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var classnames_1 = __importDefault(__webpack_require__(4));
exports.GridTypeIcon = function (props) {
    if (props.photoGrid) {
        return react_1.default.createElement('span', { className: classnames_1.default('sd-grid-item__type-icn', { swimlane: props.swimlane }) }, react_1.default.createElement(index_1.TypeIcon, { type: props.item.type, svc: props.svc }));
    }
    return react_1.default.createElement('span', {}, react_1.default.createElement(index_1.TypeIcon, { type: props.item.type, svc: props.svc }));
};
exports.GridTypeIcon.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    swimlane: prop_types_1.default.any,
    item: prop_types_1.default.any,
    photoGrid: prop_types_1.default.bool,
};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var helpers_1 = __webpack_require__(27);
exports.ListPriority = function (props) {
    var css = {
        className: classnames_1.default('list-field urgency', {
            'urgency-reduced-rowheight': props.scope.singleLine,
        }),
    };
    return helpers_1.renderArea('priority', props, css) || react_1.default.createElement('div', css);
};
exports.ListPriority.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Menu groups for authoring
 */
exports.AUTHORING_MENU_GROUPS = [
    { _id: 'default', label: utils_1.gettext('Actions') },
    { _id: 'duplicate', label: utils_1.gettext('Duplicate'), concate: true },
    { _id: 'packaging' },
    { _id: 'highlights' },
    { _id: 'corrections' },
];


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var helpers_1 = __webpack_require__(27);
exports.ListItemInfo = function (props) {
    if (props.scope.singleLine) {
        return react_1.default.createElement('div', { className: 'item-info item-info-reduced-rowheight' }, helpers_1.renderArea('singleLine', angular.extend({
            svc: props.svc,
            scope: props.scope,
        }, props), { className: 'line' }));
    }
    return react_1.default.createElement('div', { className: classnames_1.default('item-info', { 'item-info-reduced-rowheight': props.scope.singleLine }) }, helpers_1.renderArea('firstLine', angular.extend({
        svc: props.svc,
        scope: props.scope,
    }, props), { className: 'line' }, props.scope.customRender), helpers_1.renderArea('secondLine', angular.extend({
        svc: props.svc,
        scope: props.scope,
    }, props), { className: 'line' }, props.scope.customRender));
};
exports.ListItemInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MultiActionBarController_1 = __webpack_require__(1792);
exports.MultiActionBarController = MultiActionBarController_1.MultiActionBarController;
var SearchController_1 = __webpack_require__(1793);
exports.SearchController = SearchController_1.SearchController;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentFiltersController_1 = __webpack_require__(1867);
exports.ContentFiltersConfigController = ContentFiltersController_1.ContentFiltersConfigController;
var FilterConditionsController_1 = __webpack_require__(1868);
exports.FilterConditionsController = FilterConditionsController_1.FilterConditionsController;
var ManageContentFiltersController_1 = __webpack_require__(1869);
exports.ManageContentFiltersController = ManageContentFiltersController_1.ManageContentFiltersController;
var ProductionTestController_1 = __webpack_require__(1870);
exports.ProductionTestController = ProductionTestController_1.ProductionTestController;
var FilterSearchController_1 = __webpack_require__(1871);
exports.FilterSearchController = FilterSearchController_1.FilterSearchController;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BaseListController_1 = __webpack_require__(575);
exports.BaseListController = BaseListController_1.BaseListController;
var ArchiveListController_1 = __webpack_require__(1945);
exports.ArchiveListController = ArchiveListController_1.ArchiveListController;
var UploadController_1 = __webpack_require__(1946);
exports.UploadController = UploadController_1.UploadController;
var UploadAttachmentsController_1 = __webpack_require__(1948);
exports.UploadAttachmentsController = UploadAttachmentsController_1.UploadAttachmentsController;
var DuplicateController_1 = __webpack_require__(1949);
exports.DuplicateController = DuplicateController_1.DuplicateController;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var BaseListController = /** @class */ (function () {
    function BaseListController($scope, $location, search, desks) {
        var _this = this;
        this.lastQueryParams = {};
        this.$location = $location;
        this.search = search;
        this.desks = desks;
        $scope.selected = {};
        $scope.fetchNext = function (from) {
            var source = _this.getQuery(null, $scope.repo.archive || false);
            source.from = from;
            _this.fetchItems(_this.getCriteria(source));
        };
        $scope.$on('$routeUpdate', function (e, data) {
            if (!$location.search()._id) {
                $scope.selected.preview = null;
            }
            if ($location.search().fetch) {
                _this.fetchItem(decodeURIComponent($location.search().fetch))
                    .then(function (item) {
                    $scope.selected.preview = null;
                    $scope.selected.fetch = item;
                });
            }
            if (!$location.search().fetch) {
                $scope.selected.fetch = null;
            }
        });
    }
    BaseListController.prototype.buildQuery = function (params, filterDesk) {
        var query = this.search.query(params);
        if (filterDesk) {
            if (this.desks.active.stage) {
                query.filter({ term: { 'task.stage': this.desks.active.stage } });
            }
            else if (this.desks.active.desk) {
                query.filter({ term: { 'task.desk': this.desks.active.desk } });
            }
        }
        return query.getCriteria();
    };
    BaseListController.prototype.getQuery = function (params, filterDesk) {
        if (!lodash_1.default.isEqual(lodash_1.default.omit(params, 'page'), lodash_1.default.omit(this.lastQueryParams, 'page'))) {
            this.$location.search('page', null);
        }
        var query = this.buildQuery(params, filterDesk);
        this.lastQueryParams = params;
        return query;
    };
    BaseListController.prototype.fetchItems = function (criteria, next) {
        console.warn('No API defined.');
    };
    BaseListController.prototype.fetchItem = function (id) {
        console.warn('no api defined');
        return Promise.resolve();
    };
    BaseListController.prototype.refresh = function (filterDesk) {
        var query = this.getQuery(lodash_1.default.omit(this.$location.search(), '_id'), filterDesk);
        this.fetchItems(this.getCriteria(query));
    };
    BaseListController.prototype.getCriteria = function (source) {
        var params = this.$location.search().params ? JSON.parse(this.$location.search().params) : {};
        return { source: source, params: params };
    };
    return BaseListController;
}());
exports.BaseListController = BaseListController;
BaseListController.$inject = ['$scope', '$location', 'search', 'desks'];


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var ListItem = /** @class */ (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItem.prototype.render = function () {
        return (react_1.default.createElement("div", { onClick: this.props.onClick, className: classnames_1.default(this.props.className, 'sd-list-item sd-shadow--z1', {
                inactive: this.props.inactive,
                'sd-list-item--no-hover': this.props.noHover,
            }), "data-test-id": this.props['data-test-id'] }, this.props.children));
    };
    return ListItem;
}(react_1.default.Component));
exports.ListItem = ListItem;
var ListItemColumn = /** @class */ (function (_super) {
    __extends(ListItemColumn, _super);
    function ListItemColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemColumn.prototype.render = function () {
        var cssClasses = [];
        if (this.props.noBorder) {
            cssClasses.push('sd-list-item__column--no-border');
        }
        if (this.props.ellipsisAndGrow) {
            return (react_1.default.createElement("div", { className: cssClasses.concat(['sd-list-item__column', 'sd-list-item__column--grow']).join(' ') },
                react_1.default.createElement("div", { className: "sd-list-item__row" },
                    react_1.default.createElement("span", { className: "sd-overflow-ellipsis" }, this.props.children))));
        }
        else {
            return (react_1.default.createElement("div", { className: cssClasses.concat(['sd-list-item__column']).join(' ') }, this.props.children));
        }
    };
    return ListItemColumn;
}(react_1.default.Component));
exports.ListItemColumn = ListItemColumn;
var ListItemActionsMenu = /** @class */ (function (_super) {
    __extends(ListItemActionsMenu, _super);
    function ListItemActionsMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemActionsMenu.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "sd-list-item__action-menu" }, this.props.children));
    };
    return ListItemActionsMenu;
}(react_1.default.Component));
exports.ListItemActionsMenu = ListItemActionsMenu;
var ListItemRow = /** @class */ (function (_super) {
    __extends(ListItemRow, _super);
    function ListItemRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemRow.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "sd-list-item__row" }, this.props.children));
    };
    return ListItemRow;
}(react_1.default.Component));
exports.ListItemRow = ListItemRow;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var typescript_helpers_1 = __webpack_require__(56);
var SidePanel = /** @class */ (function (_super) {
    __extends(SidePanel, _super);
    function SidePanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanel.prototype.render = function () {
        var classes = ['side-panel'];
        if (this.props.side === 'right') {
            classes.push('side-panel--shadow-right');
        }
        else if (this.props.side === 'left') {
            classes.push('side-panel--shadow-left');
        }
        else {
            typescript_helpers_1.assertNever(this.props.side);
        }
        return (react_1.default.createElement("div", { className: classes.join(' '), style: { width: this.props.width }, "data-test-id": this.props['data-test-id'] }, this.props.children));
    };
    return SidePanel;
}(react_1.default.Component));
exports.SidePanel = SidePanel;
var SidePanelHeader = /** @class */ (function (_super) {
    __extends(SidePanelHeader, _super);
    function SidePanelHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanelHeader.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "side-panel__header" }, this.props.children));
    };
    return SidePanelHeader;
}(react_1.default.Component));
exports.SidePanelHeader = SidePanelHeader;
var SidePanelContent = /** @class */ (function (_super) {
    __extends(SidePanelContent, _super);
    function SidePanelContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanelContent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "side-panel__content" }, this.props.children));
    };
    return SidePanelContent;
}(react_1.default.Component));
exports.SidePanelContent = SidePanelContent;
var SidePanelContentBlock = /** @class */ (function (_super) {
    __extends(SidePanelContentBlock, _super);
    function SidePanelContentBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanelContentBlock.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "side-panel__content-block" }, this.props.children));
    };
    return SidePanelContentBlock;
}(react_1.default.Component));
exports.SidePanelContentBlock = SidePanelContentBlock;
var SidePanelHeading = /** @class */ (function (_super) {
    __extends(SidePanelHeading, _super);
    function SidePanelHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanelHeading.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "side-panel__heading" }, this.props.children));
    };
    return SidePanelHeading;
}(react_1.default.Component));
exports.SidePanelHeading = SidePanelHeading;
var SidePanelTools = /** @class */ (function (_super) {
    __extends(SidePanelTools, _super);
    function SidePanelTools() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SidePanelTools.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "side-panel__tools" }, this.props.children));
    };
    return SidePanelTools;
}(react_1.default.Component));
exports.SidePanelTools = SidePanelTools;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var form_1 = __webpack_require__(74);
var form_field_1 = __webpack_require__(250);
var typescript_helpers_1 = __webpack_require__(56);
var form_group_wrapper_1 = __webpack_require__(2037);
// The component is recursive!
var FormViewEdit = /** @class */ (function (_super) {
    __extends(FormViewEdit, _super);
    function FormViewEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormViewEdit.prototype.render = function () {
        var _this = this;
        var group = this.props.formConfig;
        return (react_1.default.createElement(form_group_wrapper_1.FormGroupWrapper, { group: group }, group.form.map(function (item, i) {
            if (form_1.isIFormGroup(item)) {
                return (react_1.default.createElement(FormViewEdit, { key: i, formConfig: item, item: _this.props.item, editMode: _this.props.editMode, issues: _this.props.issues, handleFieldChange: _this.props.handleFieldChange }));
            }
            else if (form_1.isIFormField(item)) {
                var FieldComponent = form_field_1.getFormFieldComponent(item.type);
                return (react_1.default.createElement(FieldComponent, { key: i, formValues: _this.props.item, formField: item, value: _this.props.item[item.field], disabled: !_this.props.editMode, issues: _this.props.issues[item.field] || [], previewOutput: false, onChange: function (nextValue, fieldName) {
                        return _this.props.handleFieldChange(item.field != null ? item.field : fieldName, nextValue);
                    } }));
            }
            else {
                return typescript_helpers_1.assertNever(item);
            }
        })));
    };
    return FormViewEdit;
}(react_1.default.Component));
exports.FormViewEdit = FormViewEdit;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ProfileHeader_1 = __webpack_require__(580);
var ProfileDetail_1 = __webpack_require__(581);
var helpers_1 = __webpack_require__(64);
var lodash_1 = __webpack_require__(2);
var ContactProfile = /** @class */ (function (_super) {
    __extends(ContactProfile, _super);
    function ContactProfile(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            contactType: 'person',
        };
        return _this;
    }
    ContactProfile.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            contactType: helpers_1.getContactType(nextProps.contact),
        });
    };
    ContactProfile.prototype.render = function () {
        var _a = this.props, svc = _a.svc, contact = _a.contact, dirty = _a.dirty, onChange = _a.onChange, readOnly = _a.readOnly, errors = _a.errors;
        return (react_1.default.createElement("div", { className: "profile-info" },
            react_1.default.createElement(ProfileHeader_1.ProfileHeader, { contact: contact, svc: svc, dirty: dirty, onChange: onChange, readOnly: readOnly, contactType: lodash_1.get(this.state, 'contactType', 'person') }),
            react_1.default.createElement(ProfileDetail_1.ProfileDetail, { contact: contact, svc: svc, onChange: onChange, readOnly: readOnly, errors: errors, contactType: lodash_1.get(this.state, 'contactType', 'person') })));
    };
    return ContactProfile;
}(react_1.default.Component));
exports.ContactProfile = ContactProfile;
ContactProfile.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    contact: prop_types_1.default.object.isRequired,
    dirty: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    errors: prop_types_1.default.object,
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var index_1 = __webpack_require__(63);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
exports.ProfileHeader = function (_a) {
    var contact = _a.contact, onChange = _a.onChange, readOnly = _a.readOnly, contactType = _a.contactType;
    var displayName = contact.first_name ? contact.first_name + ' ' + contact.last_name : contact.organisation;
    var cssClass = classnames_1.default('header-info');
    var avatarClass = classnames_1.default('avatar', { organisation: contactType === 'organisation' });
    return (react_1.default.createElement("div", { className: cssClass },
        react_1.default.createElement("div", { className: "profile-pic" },
            react_1.default.createElement("figure", { className: avatarClass }),
            contact._id && !contact.is_active &&
                react_1.default.createElement("span", { className: "disabled-label" }, "inactive")),
        react_1.default.createElement("h2", null, displayName),
        react_1.default.createElement("h5", null, contact.job_title),
        !readOnly &&
            react_1.default.createElement("div", { className: "active", "data-sd-tooltip": utils_1.gettext('ACTIVE/INACTIVE'), "data-flow": "left" },
                react_1.default.createElement(index_1.Toggle, { value: lodash_1.get(contact, 'is_active', false), onChange: function (e) { return onChange('is_active', e.target.value); }, readOnly: readOnly }))));
};
exports.ProfileHeader.propTypes = {
    contact: prop_types_1.default.object.isRequired,
    contactType: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var index_1 = __webpack_require__(63);
var lodash_1 = __webpack_require__(2);
var helpers_1 = __webpack_require__(64);
var utils_1 = __webpack_require__(3);
var ProfileDetail = /** @class */ (function (_super) {
    __extends(ProfileDetail, _super);
    function ProfileDetail(props) {
        var _this = _super.call(this, props) || this;
        var svc = props.svc, contact = props.contact;
        var metadata = svc.metadata;
        var stateNames = [], countries = [];
        if (metadata.values.regions) {
            stateNames = lodash_1.orderBy(metadata.values.regions, 'name', 'asc');
        }
        if (metadata.values.countries) {
            countries = lodash_1.orderBy(metadata.values.countries, 'name', 'asc');
        }
        _this.state = {
            jobTitles: lodash_1.orderBy(metadata.values.contact_job_titles, 'name', 'asc') || [],
            stateNames: stateNames,
            countries: countries,
            phoneUsages: metadata.values.contact_phone_usage || [],
            mobileUsages: metadata.values.contact_mobile_usage || [],
            displayOtherStateField: _this.shouldDisplayOtherState(props) || false,
            requiredField: !helpers_1.validateMinRequiredField(contact) || false,
            touched: {},
            organisations: [],
            orgValue: lodash_1.get(contact, 'organisation', ''),
        };
        _this.changeOtherStateField = _this.changeOtherStateField.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.isFieldInvalid = _this.isFieldInvalid.bind(_this);
        _this.getSearchResult = _this.getSearchResult.bind(_this);
        _this.handleOrgChange = _this.handleOrgChange.bind(_this);
        return _this;
    }
    ProfileDetail.prototype.onBlur = function (e) {
        var _touched = this.state.touched;
        lodash_1.set(_touched, e.target.name, true);
        this.setState({ touched: _touched });
    };
    ProfileDetail.prototype.isFieldInvalid = function (field) {
        return this.state.touched[field] && lodash_1.isEmpty(this.props.contact[field]);
    };
    ProfileDetail.prototype.changeOtherStateField = function (e) {
        this.setState({ displayOtherStateField: e.target.checked });
    };
    ProfileDetail.prototype.shouldDisplayOtherState = function (props) {
        var svc = props.svc, contact = props.contact;
        var metadata = svc.metadata;
        return !lodash_1.isEmpty(contact.contact_state) &&
            !lodash_1.findKey(metadata.values.regions, function (m) { return m.qcode === contact.contact_state; });
    };
    ProfileDetail.prototype.getSearchResult = function (field, text) {
        var _this = this;
        var svc = this.props.svc;
        var contacts = svc.contacts;
        if (text) {
            contacts.queryField(field, text).then(function (items) {
                switch (field) {
                    case 'organisation':
                        _this.setState({
                            organisations: lodash_1.map(items._items, field),
                            orgValue: text,
                        });
                }
            });
        }
    };
    ProfileDetail.prototype.handleOrgChange = function (field, value) {
        this.setState({
            orgValue: value,
        });
        this.props.onChange(field, value);
    };
    ProfileDetail.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.contact !== this.props.contact) {
            var displayOtherState = this.shouldDisplayOtherState(nextProps);
            this.setState({
                displayOtherStateField: displayOtherState,
                requiredField: !helpers_1.validateMinRequiredField(nextProps.contact) || false,
                orgValue: lodash_1.get(nextProps.contact, 'organisation', ''),
            });
        }
    };
    ProfileDetail.prototype.render = function () {
        var _this = this;
        var _a = this.props, contact = _a.contact, onChange = _a.onChange, readOnly = _a.readOnly, errors = _a.errors, contactType = _a.contactType;
        var contactLabel = contactType === 'person' ? utils_1.gettext('Role') : utils_1.gettext('Point of contact');
        var isRequired = lodash_1.get(this.state, 'requiredField', false);
        var MSG_REQUIRED = utils_1.gettext('This field is required.');
        return (react_1.default.createElement("div", { className: "details-info" },
            !readOnly &&
                react_1.default.createElement("div", { className: "sd-alert__container" },
                    react_1.default.createElement("div", { className: "sd-alert sd-alert--hollow" },
                        react_1.default.createElement("span", { className: "alert-info-msg" }, utils_1.gettext('Please specify \'first name, last name\' or  \'organisation\' or both, ' +
                            'and at least one of [mobile, phone, email, twitter, facebook, instagram] fields.')))),
            !readOnly &&
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, className: "sd-line-input__toggle" },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('public') }),
                        react_1.default.createElement(index_1.Toggle, { value: lodash_1.get(contact, 'public', false), onChange: function (e) { return onChange('public', e.target.value); }, readOnly: readOnly }))),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, hint: utils_1.gettext('e.g. professor, commissioner') },
                    react_1.default.createElement(index_1.Label, { text: utils_1.gettext('honorific') }),
                    react_1.default.createElement(index_1.Input, { field: "honorific", value: lodash_1.get(contact, 'honorific', ''), onChange: onChange, type: "text", readOnly: readOnly, autoFocus: true }))),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { required: contactType === 'person', invalid: contactType === 'person' && this.isFieldInvalid('first_name'), message: contactType === 'person' && this.isFieldInvalid('first_name') ?
                        MSG_REQUIRED : '', readOnly: readOnly },
                    react_1.default.createElement(index_1.Label, { text: utils_1.gettext('first name') }),
                    react_1.default.createElement(index_1.Input, { field: "first_name", value: lodash_1.get(contact, 'first_name', ''), onChange: onChange, onBlur: this.onBlur, type: "text", readOnly: readOnly, required: true }))),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: contactType === 'person', invalid: contactType === 'person' && this.isFieldInvalid('last_name'), message: contactType === 'person' && this.isFieldInvalid('last_name') ?
                        MSG_REQUIRED : '' },
                    react_1.default.createElement(index_1.Label, { text: utils_1.gettext('last name') }),
                    react_1.default.createElement(index_1.Input, { field: "last_name", value: lodash_1.get(contact, 'last_name', ''), onChange: onChange, onBlur: this.onBlur, type: "text", readOnly: readOnly }))),
            contactType === 'organisation' &&
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: contactType === 'organisation', invalid: contactType === 'organisation' && this.isFieldInvalid('organisation'), message: (contactType === 'organisation' && this.isFieldInvalid('organisation')) ?
                            MSG_REQUIRED : '' },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('organisation') }),
                        react_1.default.createElement(index_1.Input, { field: "organisation", value: lodash_1.get(contact, 'organisation', ''), onChange: onChange, onBlur: this.onBlur, type: "text", readOnly: readOnly }))),
            contactType === 'person' &&
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.SelectFieldSearchInput, { field: "organisation", label: utils_1.gettext('Organisation'), value: this.state.orgValue, onChange: this.handleOrgChange, querySearch: true, onQuerySearch: (function (text) { return _this.getSearchResult('organisation', text); }), dataList: this.state.organisations, readOnly: readOnly })),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                    react_1.default.createElement(index_1.Label, { text: contactLabel }),
                    react_1.default.createElement(index_1.Input, { field: "job_title", onChange: onChange, value: lodash_1.get(contact, 'job_title', ''), onBlur: this.onBlur, type: "text", readOnly: readOnly }))),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired },
                    react_1.default.createElement(index_1.Label, { text: utils_1.gettext('email') }),
                    react_1.default.createElement(index_1.InputArray, { field: "contact_email", type: "email", value: lodash_1.get(contact, 'contact_email', []), onChange: onChange, component: index_1.MultiTextInput, defaultValue: "", errors: errors, readOnly: readOnly }))),
            react_1.default.createElement(index_1.Row, null,
                react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired },
                    react_1.default.createElement(index_1.Label, { text: utils_1.gettext('phone') }),
                    react_1.default.createElement(index_1.InputArray, { field: "contact_phone", value: lodash_1.get(contact, 'contact_phone', []), onChange: onChange, component: index_1.ContactNumberInput, usages: lodash_1.get(this.state, 'phoneUsages', []), defaultValue: { number: '', usage: '', public: true }, readOnly: readOnly }))),
            react_1.default.createElement(index_1.ToggleBox, { title: utils_1.gettext('MORE'), isOpen: false, style: "toggle-box--circle", scrollInView: true },
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('mobile') }),
                        react_1.default.createElement(index_1.InputArray, { field: "mobile", value: lodash_1.get(contact, 'mobile', []), onChange: onChange, component: index_1.ContactNumberInput, usages: lodash_1.get(this.state, 'mobileUsages', []), defaultValue: { number: '', usage: '', public: true }, readOnly: readOnly }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('fax') }),
                        react_1.default.createElement(index_1.Input, { field: "fax", value: lodash_1.get(contact, 'fax', ''), onChange: onChange, type: "text", readOnly: readOnly }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, hint: utils_1.gettext('e.g. http://www.website.com') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('website') }),
                        react_1.default.createElement(index_1.Input, { field: "website", value: lodash_1.get(contact, 'website', ''), onChange: onChange, type: "text", readOnly: readOnly }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired, hint: utils_1.gettext('e.g. @cityofsydney'), invalid: !lodash_1.isEmpty(errors.twitter), message: lodash_1.get(errors, 'twitter', '') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('twitter') }),
                        react_1.default.createElement(index_1.Input, { field: "twitter", value: lodash_1.get(contact, 'twitter', ''), onChange: onChange, type: "text", readOnly: readOnly, placeholder: "@username" }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired, hint: utils_1.gettext('e.g. cityofsydney from https://www.facebook.com/cityofsydney') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('facebook') }),
                        react_1.default.createElement(index_1.Input, { field: "facebook", value: lodash_1.get(contact, 'facebook', ''), onChange: onChange, type: "text", readOnly: readOnly, placeholder: "username" }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, required: isRequired, hint: utils_1.gettext('e.g. cityofsydney from https://www.instagram.com/cityofsydney') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('instagram') }),
                        react_1.default.createElement(index_1.Input, { field: "instagram", value: lodash_1.get(contact, 'instagram', ''), onChange: onChange, type: "text", readOnly: readOnly, placeholder: "username" }))),
                react_1.default.createElement(index_1.Row, { noPadding: true },
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, hint: utils_1.gettext('Street Address, PO Box, Company Name') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('Street Address') }),
                        react_1.default.createElement(index_1.Input, { field: "contact_address[0]", value: lodash_1.get(contact, 'contact_address[0]', ''), onChange: onChange, type: "text", readOnly: readOnly, placeholder: utils_1.gettext('Address line 1') }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, hint: utils_1.gettext('Building, Suite, Unit, Apartment, Floor, etc.') },
                        react_1.default.createElement(index_1.Input, { field: "contact_address[1]", value: lodash_1.get(contact, 'contact_address[1]', ''), onChange: onChange, type: "text", readOnly: readOnly, placeholder: utils_1.gettext('Address line 2') }))),
                react_1.default.createElement(index_1.Row, { flex: true },
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly, hint: utils_1.gettext('e.g. Rhodes, CBD') },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('locality') }),
                        react_1.default.createElement(index_1.Input, { field: "locality", value: lodash_1.get(contact, 'locality', ''), onChange: onChange, type: "text", readOnly: readOnly })),
                    react_1.default.createElement(index_1.LineInput, null,
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('postcode') }),
                        react_1.default.createElement(index_1.Input, { field: "postcode", value: lodash_1.get(contact, 'postcode', ''), onChange: onChange, type: "text", readOnly: readOnly }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('city') }),
                        react_1.default.createElement(index_1.Input, { field: "city", value: lodash_1.get(contact, 'city', ''), onChange: onChange, type: "text", readOnly: readOnly }))),
                react_1.default.createElement(index_1.Row, { flex: true },
                    !this.state.displayOtherStateField && react_1.default.createElement(index_1.SelectInput, { field: "contact_state", label: utils_1.gettext('State/Province or Region'), value: lodash_1.get(contact, 'contact_state', ''), onChange: onChange, options: lodash_1.get(this.state, 'stateNames', []), labelField: "name", keyField: "qcode", clearable: true }),
                    this.state.displayOtherStateField && react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('State/Province or Region') }),
                        react_1.default.createElement(index_1.Input, { field: "contact_state", value: lodash_1.get(contact, 'contact_state', ''), onChange: onChange, type: "text", placeholder: "State/Province or Region", readOnly: readOnly })),
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('other') }),
                        react_1.default.createElement("input", { checked: lodash_1.get(this.state, 'displayOtherStateField', false), onChange: this.changeOtherStateField, type: "checkbox" }))),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.SelectInput, { label: utils_1.gettext('Country'), field: "country", value: lodash_1.get(contact, 'country', ''), onChange: onChange, type: "text", readOnly: readOnly, options: lodash_1.get(this.state, 'countries'), keyField: "qcode", labelField: "name", clearable: true })),
                react_1.default.createElement(index_1.Row, null,
                    react_1.default.createElement(index_1.LineInput, { readOnly: readOnly },
                        react_1.default.createElement(index_1.Label, { text: utils_1.gettext('notes') }),
                        react_1.default.createElement("textarea", { className: classnames_1.default('sd-line-input__input', { 'sd-line-input__input--add-min-height': !lodash_1.isEmpty(contact.notes) }), name: "notes", value: lodash_1.get(contact, 'notes', ''), onChange: function (e) { return onChange('notes', e.target.value); }, readOnly: readOnly }))))));
    };
    return ProfileDetail;
}(react_1.default.Component));
exports.ProfileDetail = ProfileDetail;
ProfileDetail.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    contact: prop_types_1.default.object.isRequired,
    contactType: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    errors: prop_types_1.default.object,
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.ActionBar = function (_a) {
    var svc = _a.svc, readOnly = _a.readOnly, dirty = _a.dirty, valid = _a.valid, onSave = _a.onSave, onCancel = _a.onCancel;
    return (react_1.default.createElement("div", { className: "action-bar clearfix show" },
        react_1.default.createElement("span", { className: "pull-right" },
            react_1.default.createElement("button", { id: "cancel-edit-btn", type: "button", className: "btn", onClick: onCancel }, utils_1.gettext('Cancel')),
            !readOnly &&
                react_1.default.createElement("button", { id: "save-edit-btn", type: "button", className: "btn btn--primary", onClick: onSave, disabled: !valid || !dirty }, utils_1.gettext('Save')))));
};
exports.ActionBar.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    onSave: prop_types_1.default.func,
    onCancel: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    dirty: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Label = function (_a) {
    var text = _a.text, children = _a.children, centerText = _a.centerText;
    return (react_1.default.createElement("span", { className: classnames_1.default('popup__menu-label', { 'popup__menu-label--center': centerText }) },
        text,
        children));
};
Label.propTypes = {
    text: prop_types_1.default.string,
    children: prop_types_1.default.node,
    centerText: prop_types_1.default.bool,
};
Label.defaultProps = { centerText: false };
exports.default = Label;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Menu = function (_a) {
    var children = _a.children, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu', { 'popup__menu--no-padding': noPadding }) }, children));
};
Menu.propTypes = {
    children: prop_types_1.default.node.isRequired,
    noPadding: prop_types_1.default.bool,
};
Menu.defaultProps = { noPadding: false };
exports.default = Menu;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(586);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(587); // styles
__webpack_require__(620);
__webpack_require__(659);
__webpack_require__(1392); // generated by grunt 'ngtemplates' task
__webpack_require__(1393);
__webpack_require__(2132);
/* globals __SUPERDESK_CONFIG__: true */
var appConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]};
if (appConfig.features.useTansaProofing) {
    // tslint:disable-next-line:no-var-requires
    __webpack_require__(2133);
}
var body = angular.element('body');
function initializeConfigDefaults(config) {
    var sunday = '0';
    return __assign({}, config, { startingDay: config.startingDay != null ? config.startingDay : sunday });
}
body.ready(function () {
    // update config via config.js
    if (window.superdeskConfig) {
        angular.merge(appConfig, window.superdeskConfig);
    }
    // non-mock app configuration must live here to allow tests to override
    // since tests do not import this file.
    angular.module('superdesk.config').constant('config', initializeConfigDefaults(appConfig));
    /**
     * @ngdoc module
     * @name superdesk-client
     * @packageName superdesk-client
     * @description The root superdesk module.
     */
    angular.bootstrap(body, [
        'superdesk.config',
        'superdesk.core',
        'superdesk.apps',
    ].concat(appConfig.apps || []), { strictDi: true });
    window['superdeskIsReady'] = true;
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(588);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!../../../sass-loader/lib/loader.js!./app.scss", function() {
		var newContent = require("!!../../../css-loader/index.js!../../../sass-loader/lib/loader.js!./app.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports
exports.push([module.i, "@import url(//fonts.googleapis.com/css?family=Roboto+Mono:400,300,500,700,300italic,400italic,500italic,700italic&subset=latin,latin-ext);", ""]);
exports.push([module.i, "@import url(//fonts.googleapis.com/css?family=Roboto:400,300,300italic,400italic,500,500italic,700,700italic&subset=latin,latin-ext);", ""]);
exports.i(__webpack_require__(589), "");
exports.i(__webpack_require__(591), "");
exports.i(__webpack_require__(602), "");
exports.i(__webpack_require__(603), "");
exports.i(__webpack_require__(604), "");
exports.i(__webpack_require__(606), "");

// module
exports.push([module.i, "/*was 65*/\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nnav,\nsection {\n  display: block; }\n\naudio,\ncanvas,\nvideo {\n  display: inline-block;\n  *display: inline;\n  *zoom: 1; }\n\naudio:not([controls]) {\n  display: none; }\n\nhtml {\n  font-size: 100%;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%; }\n\na:focus {\n  outline: thin dotted #333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px; }\n\na:hover,\na:active {\n  outline: 0; }\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline; }\n\nsup {\n  top: -0.5em; }\n\nsub {\n  bottom: -0.25em; }\n\nimg {\n  height: auto;\n  border: 0;\n  -ms-interpolation-mode: bicubic;\n  vertical-align: middle; }\n\nbutton,\ninput,\nselect,\ntextarea {\n  margin: 0;\n  font-size: 100%;\n  vertical-align: middle; }\n\nbutton,\ninput {\n  *overflow: visible;\n  line-height: normal; }\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  padding: 0;\n  border: 0; }\n\nbutton,\ninput[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  cursor: pointer;\n  -webkit-appearance: button; }\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box; }\n\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none; }\n\ntextarea {\n  overflow: auto;\n  vertical-align: top; }\n\n:focus {\n  outline: none; }\n\n[ng\\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {\n  display: none !important; }\n\n.pull-right {\n  float: right; }\n\n.pull-left {\n  float: left; }\n\n.pull-left-10x {\n  float: left;\n  padding: 10px; }\n\n.pull-right-10x {\n  float: right;\n  padding: 10px; }\n\n.hide {\n  display: none; }\n\n.show {\n  display: block; }\n\n.invisible {\n  visibility: hidden; }\n\n.beta-hide {\n  display: none !important; }\n\n.sd-blue {\n  color: #5ea9c8; }\n\n.blue-text {\n  color: #419fc6 !important; }\n  .blue-text::-webkit-input-placeholder {\n    color: #419fc6 !important; }\n  .blue-text:-moz-placeholder {\n    color: #419fc6 !important; }\n  .blue-text::-moz-placeholder {\n    color: #419fc6 !important; }\n  .blue-text::-ms-input-placeholder {\n    color: #419fc6 !important; }\n\n.no-bg {\n  background: none !important; }\n  .no-bg:hover {\n    background: none !important; }\n\n.uppercase {\n  text-transform: uppercase; }\n\n.discreet {\n  color: #888; }\n\nul.list-view.list-without-items li {\n  line-height: 38px;\n  text-align: center;\n  color: #999; }\n\n.sd-grid-list.list-without-items li {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.16);\n  display: flex;\n  line-height: 38px;\n  align-content: center;\n  justify-content: center;\n  text-align: center;\n  color: #999;\n  border-radius: 3px; }\n\n.space-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.flex-bar {\n  display: flex;\n  align-items: center; }\n\n.text-red {\n  color: #e51c23; }\n\n.sibling-spacer-4 > * + * {\n  margin-left: 4px; }\n\n.user-html-in-single-line p {\n  display: inline; }\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 18px;\n  color: #333;\n  background-color: #f8f8f8;\n  overflow: hidden;\n  height: 100%; }\n\na {\n  color: #5d9bc0;\n  text-decoration: none; }\n\na:hover {\n  color: #94bdd5;\n  text-decoration: underline; }\n\n@page {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 1.5cm;\n  margin-bottom: 1.5cm; }\n\n.top-menu-hidden #top-menu {\n  display: none; }\n\n.top-menu-hidden .monitoring {\n  top: 0; }\n\n.top-menu-hidden .subnav--authoring {\n  top: 0; }\n\n.top-menu-hidden .main-section {\n  top: 48px; }\n\n#main-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  padding-top: 48px;\n  box-sizing: border-box;\n  background: #f8f8f8;\n  overflow: hidden;\n  transition: all 0.3s ease; }\n  #main-container.menu {\n    left: 300px; }\n  #main-container.authoring #workspace-container {\n    box-shadow: 2px 0 10px 0 rgba(0, 0, 0, 0.3);\n    right: 44%;\n    z-index: 100;\n    border-right: 3px solid #666;\n    transition: all 0.5s; }\n    @media only screen and (max-width: 1430px) {\n      #main-container.authoring #workspace-container {\n        right: 54%; } }\n    #main-container.authoring #workspace-container.ui-resizable-resizing {\n      transition: none; }\n      #main-container.authoring #workspace-container.ui-resizable-resizing + #authoring-container {\n        transition: none; }\n    #main-container.authoring #workspace-container .ui-resizable-handle {\n      display: block; }\n  #main-container.authoring #authoring-container {\n    width: 44%;\n    transition: width 0.5s; }\n    #main-container.authoring #authoring-container .content-item-preview {\n      display: flex; }\n    @media only screen and (max-width: 1430px) {\n      #main-container.authoring #authoring-container {\n        width: 54%; } }\n  #main-container:not(.authoring) #workspace-container {\n    width: auto !important; }\n  #main-container:not(.authoring) #authoring-container {\n    width: auto !important; }\n  #main-container:not(.authoring) .ui-resizable-handle {\n    display: none !important; }\n  #main-container.hideMonitoring #workspace-container {\n    right: 100%;\n    margin-left: -100%; }\n  #main-container.hideMonitoring #authoring-container {\n    width: calc(100% - 48px) !important; }\n  #main-container.hideMonitoring .content-item-preview {\n    display: none; }\n\n#workspace-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  box-sizing: border-box;\n  bottom: 30px;\n  left: 48px;\n  background-color: #f8f8f8; }\n\n#authoring-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  box-sizing: border-box; }\n\n.main-section {\n  position: absolute;\n  top: 96px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  z-index: 1; }\n  .main-section.with-subnav .preview-layout {\n    top: 48px; }\n    .main-section.with-subnav .preview-layout .preview-pane .actions {\n      padding: 15px 20px;\n      height: 28px; }\n    .main-section.with-subnav .preview-layout .preview-pane .user-details-pane {\n      top: 40px; }\n\n.main-section.filter {\n  top: 96px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  z-index: 1; }\n  .main-section.filter.with-subnav .preview-layout {\n    top: 48px; }\n    .main-section.filter.with-subnav .preview-layout .preview-pane .actions {\n      padding: 15px 20px;\n      height: 28px; }\n    .main-section.filter.with-subnav .preview-layout .preview-pane .user-details-pane {\n      top: 40px; }\n\n.main-section.search {\n  top: 48px; }\n  .main-section.search .archive-sidebar {\n    top: 48px; }\n\n.search-label {\n  margin-bottom: -2px;\n  margin-top: 10px; }\n\n.main-section.users .preview-layout .list-pane > .content {\n  right: 400px;\n  transition: all ease-in-out 0.2s; }\n\n.main-section.users .preview-layout.closed .list-pane > .content {\n  right: 0; }\n\n.main-section.contacts-section .preview-layout .content {\n  right: 560px;\n  transition: all ease-in-out 0.2s; }\n\n.main-section.contacts-section .preview-layout.closed .content {\n  right: 0;\n  transition: all ease-in-out 0.2s; }\n\n.action-bar {\n  position: absolute;\n  top: -96px;\n  left: 0;\n  right: 0;\n  height: 48px;\n  background: #fff;\n  z-index: 1;\n  box-sizing: border-box;\n  padding: 10px;\n  transition: all ease 0.35s;\n  border-bottom: 1px solid #dfdfdf; }\n  .action-bar.show {\n    top: -48px; }\n\n.preview-layout {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  transition: right ease 0.2s; }\n  .preview-layout .list-pane > header, .preview-layout .preview-pane > header {\n    height: 48px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1);\n    z-index: 1; }\n  .preview-layout .list-pane > .content, .preview-layout .preview-pane > .content {\n    position: absolute;\n    top: 48px;\n    left: 0;\n    bottom: 0;\n    right: 0; }\n  .preview-layout .list-pane {\n    position: absolute;\n    background: #f8f8f8;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    border-right: 1px solid #d0d0d0;\n    z-index: 1;\n    transition: right ease 0.2s; }\n    .preview-layout .list-pane .shadow-list-holder {\n      padding: 20px; }\n    .preview-layout .list-pane > header {\n      background-color: #f8f8f8; }\n    .preview-layout .list-pane > .content {\n      overflow: auto; }\n  .preview-layout .preview-pane {\n    position: absolute;\n    width: 400px;\n    top: 48px;\n    right: 0;\n    bottom: 0;\n    background: #fff;\n    overflow-y: auto;\n    transition: right ease 0.2s;\n    z-index: 2;\n    box-shadow: inset 2px 0 3px -1px #d8d8d8; }\n    .preview-layout .preview-pane > header {\n      position: relative; }\n      .preview-layout .preview-pane > header .btn {\n        margin-top: 10px; }\n      .preview-layout .preview-pane > header .close-preview {\n        position: absolute;\n        top: 10px;\n        right: 8px;\n        opacity: 0.5; }\n        .preview-layout .preview-pane > header .close-preview:hover {\n          opacity: 1; }\n    .preview-layout .preview-pane > .content .additional-info {\n      border-bottom: 1px solid #dfdfdf;\n      padding: 10px 20px; }\n    .preview-layout .preview-pane > .content .action-menu {\n      position: absolute;\n      top: 1px;\n      right: 0;\n      width: 50px;\n      height: 44px; }\n      .preview-layout .preview-pane > .content .action-menu .dropdown {\n        display: block; }\n    .preview-layout .preview-pane img {\n      max-width: 100%; }\n\n.ingest-container .list-pane {\n  top: -48px; }\n\n.archive-container .archive-sidebar {\n  top: 48px; }\n\n.sd-overlay-panel {\n  z-index: 100 !important; }\n\n.workspace .main-section .sd-overlay-panel {\n  top: 0;\n  bottom: 0;\n  width: 56rem; }\n\n.workspace.authoring .main-section .sd-overlay-panel {\n  width: 40rem; }\n\n.workspace .main-section .archive-content .sd-overlay-panel {\n  top: 4.8rem; }\n\n.slide-pane {\n  position: absolute;\n  top: 1px;\n  bottom: 0;\n  right: -400px;\n  width: 400px;\n  background-color: #fff;\n  z-index: 100;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column; }\n  .slide-pane.slide-pane--inset {\n    top: 96px;\n    bottom: 30px; }\n  .slide-pane.open {\n    right: 0; }\n  .slide-pane > .slide-pane__header {\n    height: 48px;\n    border-bottom: 1px solid #424242; }\n    .slide-pane > .slide-pane__header h3 {\n      font-size: 20px;\n      line-height: 48px;\n      color: #000;\n      font-weight: 300;\n      float: left; }\n    .slide-pane > .slide-pane__header .close {\n      margin-top: 14px;\n      position: absolute;\n      top: 0;\n      right: 12px; }\n  .slide-pane > .slide-pane__content {\n    flex-grow: 1;\n    width: 100%;\n    top: 48px;\n    overflow: auto;\n    padding: 20px 15px 0 20px;\n    box-sizing: border-box; }\n    .slide-pane > .slide-pane__content .dropdown {\n      margin-bottom: 20px; }\n      .slide-pane > .slide-pane__content .dropdown .dropdown__toggle, .slide-pane > .slide-pane__content .dropdown .dropdown__menu {\n        width: 100%; }\n        .slide-pane > .slide-pane__content .dropdown .dropdown__toggle.focus, .slide-pane > .slide-pane__content .dropdown .dropdown__toggle:focus, .slide-pane > .slide-pane__content .dropdown .dropdown__menu.focus, .slide-pane > .slide-pane__content .dropdown .dropdown__menu:focus {\n          outline: 2px solid #5ea9c8; }\n  .slide-pane > .slide-pane__footer {\n    width: 100%;\n    padding: 15px 15px 0 15px;\n    border-top: 1px solid #424242;\n    box-sizing: border-box; }\n    .slide-pane > .slide-pane__footer button {\n      margin-bottom: 15px; }\n    .slide-pane > .slide-pane__footer .btn-list li {\n      padding-bottom: 0; }\n  .slide-pane.slide-pane--dark {\n    background-color: #3b3b3b; }\n    .slide-pane.slide-pane--dark > .slide-pane__header h3 {\n      color: #fff; }\n\n.btn-list {\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  overflow-x: auto;\n  flex-wrap: wrap;\n  margin-left: -0.4rem;\n  margin-right: -0.4rem;\n  margin-bottom: 0.6rem; }\n  .btn-list li {\n    flex: 0 0 calc(50% - 0.8rem);\n    max-width: calc(50% - 0.8rem);\n    margin: 0.4rem !important; }\n    .btn-list li .btn__check {\n      width: 100%; }\n\n.form__row--desk-select .dropdown__toggle, .form__row--desk-select .dropdown__menu {\n  width: 100%; }\n\n.form__row--desk-select .dropdown__toggle {\n  width: 100%;\n  max-height: 3.2rem; }\n\n.split-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n  .split-content > .nav, .split-content > .header, .split-content > header {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 48px;\n    border-bottom: 1px solid #f0f0f0;\n    box-sizing: border-box; }\n  .split-content > .content {\n    position: absolute;\n    top: 48px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    overflow: auto;\n    overflow-x: hidden;\n    padding: 20px;\n    background-color: #f8f8f8; }\n\n.tablist {\n  transition: all 0.3s ease;\n  width: 48px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 20;\n  background: #a1a1a1;\n  overflow: hidden; }\n  .tablist.left-tablist {\n    left: 0;\n    overflow: visible;\n    box-shadow: inset -8px 0 7px -6px #888; }\n  .tablist.right-tablist {\n    right: 0;\n    overflow: visible;\n    box-shadow: inset 8px 0 7px -6px #888; }\n  .tablist .navigation-tabs {\n    margin: 0;\n    border: 0;\n    list-style-type: none; }\n    .tablist .navigation-tabs > li {\n      position: relative;\n      float: none; }\n      .tablist .navigation-tabs > li .btn {\n        display: block;\n        position: relative;\n        box-sizing: border-box;\n        width: 48px;\n        height: 48px;\n        text-align: center;\n        padding: 0;\n        margin: 0;\n        border-radius: 0px;\n        border: 1px solid #898989;\n        border-width: 0 0 1px 0 !important;\n        background: none;\n        box-shadow: none; }\n        .tablist .navigation-tabs > li .btn:hover {\n          background: #b7b7b7;\n          border: 1px solid #898989;\n          border-width: 0 0 1px 0 !important; }\n        .tablist .navigation-tabs > li .btn .helper-icon, .tablist .navigation-tabs > li .btn .main-icon {\n          position: absolute;\n          top: 10px;\n          left: 10px; }\n        .tablist .navigation-tabs > li .btn .helper-icon {\n          opacity: 0;\n          margin: 0;\n          left: 12px;\n          width: 24px;\n          height: 24px;\n          font-size: 24px;\n          line-height: 24px;\n          z-index: 2;\n          transition: all 0.4s 0s, transform 0.3s 0s; }\n        .tablist .navigation-tabs > li .btn .main-icon {\n          opacity: 1;\n          transition: all 0.2s, transform 0.2s; }\n      .tablist .navigation-tabs > li .label--info {\n        position: absolute;\n        top: 3px;\n        right: 3px;\n        text-shadow: none;\n        z-index: 2; }\n      .tablist .navigation-tabs > li.active .btn {\n        background: #b8b8b8; }\n      .tablist .navigation-tabs > li.active .btn:hover .helper-icon {\n        opacity: 1;\n        transform: rotate(180deg);\n        transition: all 0.3s 0.2s, transform 0.2s 0.2s; }\n      .tablist .navigation-tabs > li.active .btn:hover .main-icon {\n        opacity: 0;\n        height: 8px;\n        width: 8px;\n        top: 20px;\n        left: 20px;\n        background-size: 100%; }\n\n.tabpane {\n  position: absolute;\n  width: 330px;\n  top: 0;\n  bottom: 0;\n  background: #f5f5f5;\n  border-color: #7c7c7c;\n  border-style: solid;\n  z-index: 15;\n  box-sizing: border-box;\n  transition: all 0.3s ease; }\n  .tabpane.left-tabpane {\n    left: -330px;\n    border-width: 0 3px 0 0;\n    box-shadow: 2px 0px 8px 0px rgba(50, 50, 50, 0.35); }\n    .tabpane.left-tabpane.open-tabpane {\n      left: 48px; }\n  .tabpane.right-tabpane {\n    right: -330px;\n    border-width: 0 0 0 3px;\n    box-shadow: -2px 0px 8px 0px rgba(40, 50, 50, 0.35); }\n    .tabpane.right-tabpane.open-tabpane {\n      right: 48px; }\n  .tabpane .tabcontent {\n    padding: 15px;\n    box-sizing: border-box;\n    position: absolute;\n    bottom: 0;\n    top: 0;\n    left: 1px;\n    right: 1px;\n    overflow: hidden; }\n\n.notification-pane {\n  position: fixed;\n  top: 48px;\n  bottom: 0;\n  right: -300px;\n  width: 300px;\n  box-sizing: border-box;\n  background: #313131;\n  z-index: 2000;\n  transition: right ease 0.3s; }\n  .notification-pane.show {\n    right: 0; }\n  .notification-pane > .header {\n    height: 65px;\n    width: 100%;\n    background: #212121;\n    box-shadow: inset 0 4px 4px -2px #000;\n    border-bottom: 1px solid #313131; }\n    .notification-pane > .header .avatar {\n      margin: 12px 16px; }\n    .notification-pane > .header .user-info {\n      margin-left: 60px;\n      height: 40px;\n      padding: 12px 10px 2px 10px;\n      box-sizing: border-box; }\n      .notification-pane > .header .user-info .name {\n        color: #c5c5c5;\n        font-size: 12px;\n        display: block;\n        line-height: 12px; }\n      .notification-pane > .header .user-info .displayname {\n        font-size: 11px;\n        color: #727272;\n        display: block;\n        line-height: 12px;\n        margin-top: 2px; }\n    .notification-pane > .header .actions {\n      margin-left: 70px;\n      height: 20px;\n      box-sizing: border-box; }\n      .notification-pane > .header .actions button {\n        border: 0;\n        background: 0;\n        color: #333; }\n      .notification-pane > .header .actions a, .notification-pane > .header .actions button {\n        font-size: 10px;\n        color: #8d8d8d;\n        text-decoration: none;\n        text-transform: uppercase;\n        box-sizing: border-box;\n        line-height: 20px;\n        padding-right: 16px;\n        padding-left: 0;\n        display: inline-block;\n        margin: 0 !important; }\n        .notification-pane > .header .actions a:last-child, .notification-pane > .header .actions button:last-child {\n          border: 0; }\n        .notification-pane > .header .actions a:hover, .notification-pane > .header .actions button:hover {\n          color: #ccc; }\n  .notification-pane > .content {\n    position: absolute;\n    top: 65px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-top: 2px solid #464646;\n    overflow: auto;\n    box-shadow: inset 4px 0 4px -2px #202020; }\n    .notification-pane > .content .module {\n      margin-top: 20px; }\n      .notification-pane > .content .module .title {\n        font-size: 16px;\n        color: #f8f8f8;\n        padding: 10px;\n        font-weight: 300; }\n\n.card-box {\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  background-color: white;\n  font-size: 13px;\n  color: #333; }\n  .card-box--with-click:hover {\n    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.5); }\n  .card-box--flex {\n    display: flex;\n    flex-direction: column; }\n  .card-box .card-box__header {\n    background-color: #607d8b;\n    padding: 0;\n    border-radius: 2px 2px 0 0;\n    color: white;\n    box-sizing: border-box; }\n    .card-box .card-box__header::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 8px;\n      background-color: rgba(0, 0, 0, 0.2);\n      border-radius: 2px 2px 0 0; }\n    .card-box .card-box__header .dropdown {\n      float: right;\n      margin-top: 8px; }\n      .card-box .card-box__header .dropdown .dropdown__menu {\n        margin-top: 0; }\n      .card-box .card-box__header .dropdown .dropdown__toggle {\n        border: none;\n        outline: none;\n        padding: 0 8px;\n        display: block;\n        background: transparent;\n        height: 42px;\n        text-align: center;\n        line-height: 0;\n        font-size: 15px;\n        position: relative;\n        z-index: 2;\n        opacity: .4; }\n        .card-box .card-box__header .dropdown .dropdown__toggle i {\n          color: #fff; }\n        .card-box .card-box__header .dropdown .dropdown__toggle:hover {\n          opacity: .7; }\n      .card-box .card-box__header .dropdown.open .dropdown__toggle {\n        opacity: 1; }\n    .card-box .card-box__header--empty {\n      height: 8px; }\n    .card-box .card-box__header--padded-flex {\n      display: flex;\n      padding: 14px 24px 6px 14px; }\n      .card-box .card-box__header--padded-flex i {\n        color: rgba(255, 255, 255, 0.8);\n        padding-right: 10px; }\n  .card-box.active .card-box__header {\n    background-color: #5ea9c8; }\n  .card-box .card-box__heading {\n    padding: 20px 16px 12px;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    box-sizing: border-box;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color: #fff; }\n    .card-box .card-box__heading--editable {\n      padding: 10px 16px 10px;\n      text-transform: initial; }\n      .card-box .card-box__heading--editable:hover {\n        cursor: text; }\n      .card-box .card-box__heading--editable > div {\n        padding: 9px 0 3px 0; }\n      .card-box .card-box__heading--editable > input {\n        margin-top: 6px; }\n  .card-box .card-box__sub-heading {\n    background-color: #9daeb7;\n    font-size: 11px;\n    font-weight: 500;\n    color: white;\n    text-transform: uppercase;\n    padding: 4px 16px; }\n    .card-box .card-box__sub-heading.success {\n      background-color: #8bc34a; }\n  .card-box .card-box__btn-group {\n    margin: 14px 6px 0 0; }\n    .card-box .card-box__btn-group--right {\n      float: right; }\n    .card-box .card-box__btn-group .btn {\n      background: transparent;\n      padding: 10px 2px;\n      color: #fff;\n      opacity: 0.4; }\n      .card-box .card-box__btn-group .btn:focus, .card-box .card-box__btn-group .btn:hover {\n        box-shadow: none;\n        opacity: 1; }\n      .card-box .card-box__btn-group .btn [class^=\"icon-\"],\n      .card-box .card-box__btn-group .btn [class*=\" icon-\"] {\n        color: #fff; }\n  .card-box .card-box__thumbnail {\n    padding-top: 8px;\n    line-height: 0; }\n    .card-box .card-box__thumbnail + .heading {\n      background-color: white;\n      font-weight: 500;\n      text-align: center;\n      color: #333;\n      padding: 10px 16px; }\n  .card-box .card-box__content {\n    padding: 16px;\n    flex-grow: 1;\n    box-sizing: border-box; }\n    .card-box .card-box__content h4 {\n      text-transform: uppercase;\n      font-size: 11px;\n      color: rgba(0, 0, 0, 0.5);\n      letter-spacing: 0.04em;\n      margin-bottom: 4px; }\n      .card-box .card-box__content h4.with-value {\n        margin-bottom: 0; }\n      .card-box .card-box__content h4 .label {\n        float: right;\n        box-sizing: border-box;\n        height: 15px;\n        margin: auto 0;\n        padding: 3px 5px 0;\n        border-radius: 8px;\n        color: white;\n        background: rgba(0, 0, 0, 0.25);\n        font-size: 10px;\n        line-height: 100%;\n        letter-spacing: .06em;\n        font-weight: 400; }\n      .card-box .card-box__content h4 .value-label {\n        float: right;\n        font-size: 13px;\n        color: #333;\n        font-weight: 400;\n        text-transform: none;\n        letter-spacing: 0em; }\n      .card-box .card-box__content h4.card-box__h4--normal-case {\n        font-size: 12px;\n        text-transform: initial; }\n    .card-box .card-box__content--scrollable {\n      min-height: 20vh;\n      max-height: 30vh;\n      overflow-y: auto; }\n  .card-box .card-box__placeholder {\n    padding: 16px;\n    flex-grow: 1;\n    box-sizing: border-box;\n    height: calc(100% - 48px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n    font-weight: 300;\n    font-size: 1.2rem; }\n    .card-box .card-box__placeholder--cursorPointer {\n      cursor: pointer; }\n  .card-box .card-box__content-list {\n    margin: -16px;\n    padding: 0;\n    list-style: none; }\n    .card-box .card-box__content-list li, .card-box .card-box__content-list .card-box__content-list-item {\n      padding: 16px;\n      border-bottom: 1px solid #ebebeb; }\n      .card-box .card-box__content-list li--inline, .card-box .card-box__content-list .card-box__content-list-item--inline {\n        display: flex; }\n        .card-box .card-box__content-list li--inline h4, .card-box .card-box__content-list .card-box__content-list-item--inline h4 {\n          flex: 1 1; }\n        .card-box .card-box__content-list li--inline span, .card-box .card-box__content-list .card-box__content-list-item--inline span {\n          flex: 1 1;\n          text-align: right; }\n      .card-box .card-box__content-list li .card-box__content-list-inline-span, .card-box .card-box__content-list .card-box__content-list-item .card-box__content-list-inline-span {\n        display: inline-block; }\n      .card-box .card-box__content-list li:last-child, .card-box .card-box__content-list .card-box__content-list-item:last-child {\n        border: none; }\n      .card-box .card-box__content-list li--border-bottom:last-child, .card-box .card-box__content-list .card-box__content-list-item--border-bottom:last-child {\n        border-bottom: 1px solid #ebebeb; }\n      .card-box .card-box__content-list li--small, .card-box .card-box__content-list .card-box__content-list-item--small {\n        padding: 7px 16px; }\n        .card-box .card-box__content-list li--small h4, .card-box .card-box__content-list .card-box__content-list-item--small h4 {\n          margin: 0; }\n    .card-box .card-box__content-list .creation-time {\n      display: block;\n      font-size: 12px;\n      color: #999; }\n      .card-box .card-box__content-list .creation-time i {\n        display: inline-block;\n        opacity: 0.5;\n        margin-top: -2px; }\n    .card-box .card-box__content-list .button__view-all {\n      border-bottom: 1px dotted #5598B4;\n      color: #5598B4;\n      cursor: pointer; }\n  .card-box .card-box__article-header {\n    padding: 16px; }\n  .card-box .card-box__time-date {\n    font-size: 11px;\n    color: #ababab;\n    font-weight: 300; }\n    .card-box .card-box__time-date--reverse-color {\n      color: rgba(255, 255, 255, 0.6); }\n  .card-box .cardbox__close {\n    position: absolute;\n    top: 12px;\n    right: 6px;\n    z-index: 3; }\n  .card-box .card-box__footer {\n    padding: 14px 16px;\n    border-top: 1px solid #ccc;\n    background-color: #f8f8f8;\n    border-radius: 0 0 2px 2px; }\n    .card-box .card-box__footer--light {\n      background-color: white; }\n  .card-box .card-box__full-click {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 2; }\n\n.flex-grid {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  overflow-x: auto; }\n  .flex-grid .flex-item {\n    box-sizing: border-box;\n    position: relative; }\n    .flex-grid .flex-item.inactive .card-box__header {\n      background-color: #aaa; }\n  .flex-grid.wrap-items {\n    flex-wrap: wrap; }\n  .flex-grid.content-center {\n    justify-content: center; }\n  .flex-grid.two-lines-heading .header {\n    min-height: 72px; }\n  .flex-grid.box .flex-item {\n    margin: 16px;\n    background-color: white; }\n  .flex-grid.box.small-6 .flex-item {\n    -webkit-flex: 0 0 calc(16.6666% - 32px);\n    -ms-flex: 0 0 calc(16.6666% - 32px);\n    flex: 0 0 calc(16.6666% - 32px);\n    max-width: calc(16.6666% - 32px); }\n  .flex-grid.box.small-5 .flex-item {\n    -webkit-flex: 0 0 calc(20% - 32px);\n    -ms-flex: 0 0 calc(20% - 32px);\n    flex: 0 0 calc(20% - 32px);\n    max-width: calc(20% - 32px); }\n  .flex-grid.box.small-4 .flex-item {\n    -webkit-flex: 0 0 calc(25% - 32px);\n    -ms-flex: 0 0 calc(25% - 32px);\n    flex: 0 0 calc(25% - 32px);\n    max-width: calc(25% - 32px); }\n  .flex-grid.box.small-3 .flex-item {\n    -webkit-flex: 0 0 calc(33.3333% - 32px);\n    -ms-flex: 0 0 calc(33.3333% - 32px);\n    flex: 0 0 calc(33.3333% - 32px);\n    max-width: calc(33.3333% - 32px); }\n  .flex-grid.box.small-2 .flex-item {\n    -webkit-flex: 0 0 calc(50% - 32px);\n    -ms-flex: 0 0 calc(50% - 32px);\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px); }\n  .flex-grid.box.small-1 .flex-item {\n    -webkit-flex: 0 0 calc(100% - 32px);\n    -ms-flex: 0 0 calc(100% - 32px);\n    flex: 0 0 calc(100% - 32px);\n    max-width: calc(100% - 32px); }\n  .flex-grid.small-6 .flex-item {\n    -webkit-flex: 0 0 16.6666%;\n    -ms-flex: 0 0 16.6666%;\n    flex: 0 0 16.6666%;\n    max-width: 16.6666%; }\n  .flex-grid.small-5 .flex-item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid.small-4 .flex-item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid.small-3 .flex-item {\n    -webkit-flex: 0 0 33.3333%;\n    -ms-flex: 0 0 33.3333%;\n    flex: 0 0 33.3333%;\n    max-width: 33.3333%; }\n  .flex-grid.small-2 .flex-item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid.small-1 .flex-item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; }\n\n@media only screen and (min-width: 40em) {\n  .flex-grid.box.medium-6 .flex-item {\n    -webkit-flex: 0 0 calc(16.6666% - 32px);\n    -ms-flex: 0 0 calc(16.6666% - 32px);\n    flex: 0 0 calc(16.6666% - 32px);\n    max-width: calc(16.6666% - 32px); }\n  .flex-grid.box.medium-5 .flex-item {\n    -webkit-flex: 0 0 calc(20% - 32px);\n    -ms-flex: 0 0 calc(20% - 32px);\n    flex: 0 0 calc(20% - 32px);\n    max-width: calc(20% - 32px); }\n  .flex-grid.box.medium-4 .flex-item {\n    -webkit-flex: 0 0 calc(25% - 32px);\n    -ms-flex: 0 0 calc(25% - 32px);\n    flex: 0 0 calc(25% - 32px);\n    max-width: calc(25% - 32px); }\n  .flex-grid.box.medium-3 .flex-item {\n    -webkit-flex: 0 0 calc(33.3333% - 32px);\n    -ms-flex: 0 0 calc(33.3333% - 32px);\n    flex: 0 0 calc(33.3333% - 32px);\n    max-width: calc(33.3333% - 32px); }\n  .flex-grid.box.medium-2 .flex-item {\n    -webkit-flex: 0 0 calc(50% - 32px);\n    -ms-flex: 0 0 calc(50% - 32px);\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px); }\n  .flex-grid.box.medium-1 .flex-item {\n    -webkit-flex: 0 0 calc(100% - 32px);\n    -ms-flex: 0 0 calc(100% - 32px);\n    flex: 0 0 calc(100% - 32px);\n    max-width: calc(100% - 32px); }\n  .flex-grid.medium-6 .flex-item {\n    -webkit-flex: 0 0 16.6666%;\n    -ms-flex: 0 0 16.6666%;\n    flex: 0 0 16.6666%;\n    max-width: 16.6666%; }\n  .flex-grid.medium-5 .flex-item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid.medium-4 .flex-item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid.medium-3 .flex-item {\n    -webkit-flex: 0 0 33.3333%;\n    -ms-flex: 0 0 33.3333%;\n    flex: 0 0 33.3333%;\n    max-width: 33.3333%; }\n  .flex-grid.medium-2 .flex-item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid.medium-1 .flex-item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; } }\n\n@media only screen and (min-width: 60em) {\n  .flex-grid.box.large-6 .flex-item {\n    -webkit-flex: 0 0 calc(16.6666% - 32px);\n    -ms-flex: 0 0 calc(16.6666% - 32px);\n    flex: 0 0 calc(16.6666% - 32px);\n    max-width: calc(16.6666% - 32px); }\n  .flex-grid.box.large-5 .flex-item {\n    -webkit-flex: 0 0 calc(20% - 32px);\n    -ms-flex: 0 0 calc(20% - 32px);\n    flex: 0 0 calc(20% - 32px);\n    max-width: calc(20% - 32px); }\n  .flex-grid.box.large-4 .flex-item {\n    -webkit-flex: 0 0 calc(25% - 32px);\n    -ms-flex: 0 0 calc(25% - 32px);\n    flex: 0 0 calc(25% - 32px);\n    max-width: calc(25% - 32px); }\n  .flex-grid.box.large-3 .flex-item {\n    -webkit-flex: 0 0 calc(33.3333% - 32px);\n    -ms-flex: 0 0 calc(33.3333% - 32px);\n    flex: 0 0 calc(33.3333% - 32px);\n    max-width: calc(33.3333% - 32px); }\n  .flex-grid.box.large-2 .flex-item {\n    -webkit-flex: 0 0 calc(50% - 32px);\n    -ms-flex: 0 0 calc(50% - 32px);\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px); }\n  .flex-grid.box.large-1 .flex-item {\n    -webkit-flex: 0 0 calc(100% - 32px);\n    -ms-flex: 0 0 calc(100% - 32px);\n    flex: 0 0 calc(100% - 32px);\n    max-width: calc(100% - 32px); }\n  .flex-grid.large-6 .flex-item {\n    -webkit-flex: 0 0 16.6666%;\n    -ms-flex: 0 0 16.6666%;\n    flex: 0 0 16.6666%;\n    max-width: 16.6666%; }\n  .flex-grid.large-5 .flex-item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid.large-4 .flex-item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid.large-3 .flex-item {\n    -webkit-flex: 0 0 33.3333%;\n    -ms-flex: 0 0 33.3333%;\n    flex: 0 0 33.3333%;\n    max-width: 33.3333%; }\n  .flex-grid.large-2 .flex-item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid.large-1 .flex-item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; } }\n\n@media only screen and (min-width: 100em) {\n  .flex-grid.box.xlarge-6 .flex-item {\n    -webkit-flex: 0 0 calc(16.6666% - 32px);\n    -ms-flex: 0 0 calc(16.6666% - 32px);\n    flex: 0 0 calc(16.6666% - 32px);\n    max-width: calc(16.6666% - 32px); }\n  .flex-grid.box.xlarge-5 .flex-item {\n    -webkit-flex: 0 0 calc(20% - 32px);\n    -ms-flex: 0 0 calc(20% - 32px);\n    flex: 0 0 calc(20% - 32px);\n    max-width: calc(20% - 32px); }\n  .flex-grid.box.xlarge-4 .flex-item {\n    -webkit-flex: 0 0 calc(25% - 32px);\n    -ms-flex: 0 0 calc(25% - 32px);\n    flex: 0 0 calc(25% - 32px);\n    max-width: calc(25% - 32px); }\n  .flex-grid.box.xlarge-3 .flex-item {\n    -webkit-flex: 0 0 calc(33.3333% - 32px);\n    -ms-flex: 0 0 calc(33.3333% - 32px);\n    flex: 0 0 calc(33.3333% - 32px);\n    max-width: calc(33.3333% - 32px); }\n  .flex-grid.box.xlarge-2 .flex-item {\n    -webkit-flex: 0 0 calc(50% - 32px);\n    -ms-flex: 0 0 calc(50% - 32px);\n    flex: 0 0 calc(50% - 32px);\n    max-width: calc(50% - 32px); }\n  .flex-grid.box.xlarge-1 .flex-item {\n    -webkit-flex: 0 0 calc(100% - 32px);\n    -ms-flex: 0 0 calc(100% - 32px);\n    flex: 0 0 calc(100% - 32px);\n    max-width: calc(100% - 32px); }\n  .flex-grid.xlarge-6 .flex-item {\n    -webkit-flex: 0 0 16.6666%;\n    -ms-flex: 0 0 16.6666%;\n    flex: 0 0 16.6666%;\n    max-width: 16.6666%; }\n  .flex-grid.xlarge-5 .flex-item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid.xlarge-4 .flex-item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid.xlarge-3 .flex-item {\n    -webkit-flex: 0 0 33.3333%;\n    -ms-flex: 0 0 33.3333%;\n    flex: 0 0 33.3333%;\n    max-width: 33.3333%; }\n  .flex-grid.xlarge-2 .flex-item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid.xlarge-1 .flex-item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; } }\n\nbody.prepare-print {\n  margin-left: 1.5cm;\n  margin-right: 1.5cm;\n  background: none !important;\n  overflow: visible !important;\n  color: black; }\n  body.prepare-print > * {\n    display: none !important; }\n  body.prepare-print > .modal--fullscreen {\n    position: static !important;\n    display: block !important;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    background: none; }\n    body.prepare-print > .modal--fullscreen .modal-dialog {\n      display: block !important; }\n    body.prepare-print > .modal--fullscreen .association {\n      margin-bottom: 16px !important; }\n    body.prepare-print > .modal--fullscreen p {\n      font-size: 9pt !important;\n      line-height: 140% !important;\n      margin-bottom: 12px !important; }\n    body.prepare-print > .modal--fullscreen h2 {\n      font-size: 13pt !important; }\n    body.prepare-print > .modal--fullscreen h3 {\n      font-size: 10pt !important; }\n    body.prepare-print > .modal--fullscreen .headline {\n      font-size: 16pt !important;\n      margin-bottom: 16px !important; }\n    body.prepare-print > .modal--fullscreen .modal-content {\n      display: block !important; }\n      body.prepare-print > .modal--fullscreen .modal-content > * {\n        display: none !important; }\n      body.prepare-print > .modal--fullscreen .modal-content .byline {\n        font-size: 10pt !important;\n        margin-bottom: 20px !important; }\n      body.prepare-print > .modal--fullscreen .modal-content > .modal-body {\n        display: block !important;\n        padding: 0 !important; }\n      body.prepare-print > .modal--fullscreen .modal-content .preview-content {\n        max-width: 100% !important; }\n      body.prepare-print > .modal--fullscreen .modal-content .metadata {\n        margin-top: 0 !important;\n        margin-bottom: 15px !important; }\n        body.prepare-print > .modal--fullscreen .modal-content .metadata > div {\n          margin-bottom: 0 !important; }\n        body.prepare-print > .modal--fullscreen .modal-content .metadata .preview-label label {\n          color: black; }\n        body.prepare-print > .modal--fullscreen .modal-content .metadata .preview-data span {\n          border-radius: 0 !important;\n          background-color: transparent !important;\n          border-right: 1px solid black; }\n          body.prepare-print > .modal--fullscreen .modal-content .metadata .preview-data span:last-of-type {\n            border-right: 0 !important; }\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0; }\n  .loading-overlay.active {\n    width: 100%;\n    height: 100%;\n    background: #fff url(" + escape(__webpack_require__(34)) + ") no-repeat center;\n    z-index: 1000; }\n\n.tab-box {\n  display: flex;\n  padding-bottom: 20px; }\n  .tab-box__item {\n    flex: 1;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 33px;\n    text-transform: uppercase;\n    color: #666;\n    background-color: transparent;\n    border: 0;\n    border-bottom: 1px solid #c2c2c2;\n    border-right: 1px solid #c2c2c2; }\n    .tab-box__item:last-of-type {\n      border-right: 0; }\n    .tab-box__item--active {\n      color: #5ea9c8;\n      border-top: 1px solid #c2c2c2;\n      border-bottom: 0; }\n\np {\n  margin: 0 0 9px;\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 18px; }\n  p small {\n    font-size: 11px;\n    color: #999; }\n\n.lead {\n  margin-bottom: 18px;\n  font-size: 20px;\n  font-weight: 200;\n  line-height: 27px; }\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 0;\n  font-family: inherit;\n  font-weight: 500;\n  color: inherit;\n  text-rendering: optimizelegibility; }\n  h1 small, h2 small, h3 small, h4 small, h5 small, h6 small {\n    font-weight: normal;\n    color: #999; }\n\nh1 {\n  font-size: 30px;\n  line-height: 36px; }\n  h1 small {\n    font-size: 18px; }\n\nh2 {\n  font-size: 22px;\n  line-height: 36px; }\n  h2 small {\n    font-size: 18px; }\n\nh3 {\n  line-height: 27px;\n  font-size: 18px; }\n  h3 small {\n    font-size: 14px; }\n\nh4, h5, h6 {\n  line-height: 18px; }\n\nh4 {\n  font-size: 14px; }\n  h4 small {\n    font-size: 12px; }\n\nh5 {\n  font-size: 12px; }\n\nh6 {\n  font-size: 11px;\n  color: #999; }\n\n.page-header {\n  padding-bottom: 17px;\n  margin: 18px 0;\n  border-bottom: 1px solid #F5F5F5; }\n\n.page-header h1 {\n  line-height: 1; }\n\nfigure {\n  margin: 0;\n  padding: 0; }\n\nul ul,\nul ol,\nol ol,\nol ul {\n  margin-bottom: 0; }\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0; }\n\n.html-preview ul {\n  list-style-type: disc;\n  padding-left: 40px;\n  margin-top: 1em;\n  margin-bottom: 1em; }\n\nol {\n  list-style: decimal; }\n\nli {\n  line-height: 18px; }\n\nul.unstyled,\nol.unstyled {\n  margin-left: 0;\n  list-style: none; }\n\ndl {\n  margin-bottom: 18px; }\n\ndt,\ndd {\n  line-height: 18px; }\n\ndt {\n  font-weight: bold;\n  line-height: 17px; }\n\ndd {\n  margin-left: 9px; }\n\n.dl-horizontal dt {\n  float: left;\n  clear: left;\n  width: 120px;\n  text-align: right; }\n\n.dl-horizontal dd {\n  margin-left: 130px; }\n\nhr {\n  margin: 18px 0;\n  border: 0;\n  border-top: 1px solid rgba(123, 123, 123, 0.4);\n  border-bottom: none; }\n  hr.hr--dotted {\n    border-top: 1px dotted rgba(123, 123, 123, 0.4); }\n\nstrong {\n  font-weight: bold; }\n\nem {\n  font-style: italic; }\n\n.muted {\n  color: #999; }\n\nabbr[title] {\n  border-bottom: 1px dotted #ddd;\n  cursor: help; }\n\nabbr.initialism {\n  font-size: 90%;\n  text-transform: uppercase; }\n\nq:before,\nq:after,\nblockquote:before,\nblockquote:after {\n  content: \"\"; }\n\naddress {\n  display: block;\n  margin-bottom: 18px;\n  line-height: 18px;\n  font-style: normal; }\n\nsmall {\n  font-size: 100%; }\n\ncite {\n  font-style: normal; }\n\n.italicAbstract .abstract {\n  font-style: italic; }\n\nform {\n  margin: 0; }\n\nfieldset {\n  padding: 0;\n  margin: 0;\n  border: 0; }\n  fieldset.separated {\n    border: 1px solid #d0d0d0;\n    border-width: 1px 0;\n    padding-bottom: 10px; }\n\nlegend {\n  display: block;\n  padding: 0 6px 0 0;\n  margin-bottom: 10px;\n  font-size: 12px;\n  line-height: 31px;\n  color: #666;\n  border: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n  background-color: transparent; }\n  legend.small {\n    margin-bottom: 10px; }\n  legend small {\n    font-size: 13.5px;\n    color: #999; }\n\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif; }\n\nlabel {\n  display: block;\n  margin-bottom: 5px; }\n\ninput,\ntextarea,\nselect,\n.uneditable-input {\n  display: inline-block;\n  width: 210px;\n  min-height: 18px;\n  padding: 4px;\n  margin-bottom: 9px;\n  font-size: 13px;\n  line-height: 18px;\n  border: 1px solid #ccc;\n  border-radius: 2px; }\n\n.uneditable-textarea {\n  width: auto;\n  height: auto; }\n\nlabel input,\nlabel textarea,\nlabel select {\n  display: block; }\n\ninput[type=\"image\"],\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 2px 0;\n  display: inline-block;\n  line-height: normal;\n  cursor: pointer;\n  border-radius: 0;\n  border: 0 \\9;\n  /* IE9 and down */ }\n\ninput[type=\"image\"] {\n  border: 0; }\n\ninput[type=\"file\"] {\n  width: auto;\n  padding: initial;\n  line-height: initial;\n  border: initial;\n  background-color: #fff;\n  background-color: initial;\n  box-shadow: none; }\n\ninput[type=\"button\"],\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  width: auto;\n  height: auto; }\n\nselect {\n  height: 28px;\n  /* In IE7, the height of the select element cannot be changed by height, only font-size */\n  line-height: 28px; }\n\ninput[type=\"file\"] {\n  height: 28px;\n  padding-top: 4px;\n  font-size: 13px; }\n\nselect {\n  width: 220px;\n  background-color: #fff; }\n\nselect[multiple],\nselect[size] {\n  height: auto; }\n\ninput[type=\"image\"] {\n  box-shadow: none; }\n\ntextarea {\n  height: auto; }\n\ninput[type=\"hidden\"] {\n  display: none; }\n\n.legend {\n  padding: 0;\n  color: #999;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  padding: 0 0 10px 0; }\n\n.radio,\n.checkbox {\n  padding-left: 18px; }\n\n.radio input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"] {\n  float: left;\n  margin-left: -18px; }\n\n.controls > .radio:first-child,\n.controls > .checkbox:first-child {\n  padding-top: 5px; }\n\n.radio.inline,\n.checkbox.inline {\n  display: inline-block;\n  padding-top: 5px;\n  margin-bottom: 0;\n  vertical-align: middle; }\n\n.radio.inline + .radio.inline,\n.checkbox.inline + .checkbox.inline {\n  margin-left: 10px; }\n\n.sd-radio {\n  position: relative;\n  padding-left: 3px; }\n  .sd-radio input[type=\"radio\"] {\n    visibility: hidden; }\n    .sd-radio input[type=\"radio\"] + .check {\n      display: inline-block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 11px;\n      height: 11px;\n      border-radius: 50%;\n      border: 2px solid #ccc;\n      vertical-align: middle;\n      margin-left: 0px; }\n    .sd-radio input[type=\"radio\"]:checked + .check {\n      border: 2px solid #5ea9c8; }\n      .sd-radio input[type=\"radio\"]:checked + .check:before {\n        content: '';\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        margin: 2px 0 0 2px;\n        background-color: #5ea9c8;\n        border-radius: 50%;\n        box-sizing: border-box; }\n  .sd-radio:hover input[type=\"radio\"] + .check {\n    border: 2px solid #999; }\n  .sd-radio:hover input[type=\"radio\"]:checked + .check {\n    border: 2px solid #5ea9c8; }\n\ninput,\ntextarea {\n  transition: border linear 0.2s, box-shadow linear 0.2s; }\n\ninput:focus,\ntextarea:focus {\n  border-color: rgba(82, 168, 236, 0.8);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(82, 168, 236, 0.6);\n  outline: 0;\n  outline: thin dotted \\9;\n  /* IE6-9 */ }\n\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus,\nselect:focus {\n  box-shadow: none;\n  outline: thin dotted #333;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px; }\n\ninput, textarea, select {\n  width: 100%; }\n\n.input-mini {\n  width: 50px; }\n\n.input-small {\n  width: 90px; }\n\n.input-medium {\n  width: 150px; }\n\n.input-large {\n  width: 210px; }\n\n.input-xlarge {\n  width: 270px; }\n\n.input-xxlarge {\n  width: 530px; }\n\ninput[disabled],\nselect[disabled],\ntextarea[disabled],\ninput[readonly],\nselect[readonly],\ntextarea[readonly] {\n  background-color: #F5F5F5;\n  border-color: #ddd;\n  cursor: not-allowed; }\n\n.sd-validate:not(.field) label:after {\n  color: #E51C23;\n  content: '*';\n  vertical-align: top;\n  font-size: 12px;\n  padding-left: 3px; }\n\n.sd-validate .sd-required {\n  font-size: 11px;\n  font-style: italic;\n  padding-left: 5px;\n  color: #333; }\n\n.sd-validate .sd-invalid-text {\n  display: none;\n  font-size: 11px;\n  font-style: italic;\n  padding-left: 5px;\n  color: #E51C23; }\n\n.sd-validate.sd-invalid label span {\n  color: red; }\n\n.sd-validate.sd-invalid input, .sd-validate.sd-invalid textarea, .sd-validate.sd-invalid .text-editor, .sd-validate.sd-invalid .line-input,\n.sd-validate.sd-invalid input:focus, .sd-validate.sd-invalid textarea:focus, .sd-validate.sd-invalid .text-editor:focus,\n.sd-validate.sd-invalid input:hover, .sd-validate.sd-invalid textarea:hover, .sd-validate.sd-invalid text-editor:hover {\n  border-bottom: 1px solid red !important;\n  border-bottom-color: red !important;\n  box-shadow: none !important; }\n\n.sd-validate.sd-invalid.field label {\n  background-color: red; }\n  .sd-validate.sd-invalid.field label span {\n    border-bottom: 0 !important;\n    color: #fff; }\n\n.sd-validate.sd-invalid .sd-required {\n  color: #E51C23; }\n\n.sd-validate.sd-invalid .sd-invalid-text {\n  display: inline-block; }\n\n.sd-validate.field label span {\n  border-bottom: 0 !important; }\n\n.form-actions {\n  padding: 17px 20px 18px;\n  margin-top: 18px;\n  margin-bottom: 18px;\n  background-color: #F5F5F5;\n  border-top: 1px solid #ddd;\n  *zoom: 1; }\n  .form-actions:before, .form-actions:after {\n    display: table;\n    content: \"\"; }\n  .form-actions:after {\n    clear: both; }\n\n.uneditable-input {\n  display: block;\n  background-color: #fff;\n  border-color: #eee;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.025);\n  cursor: not-allowed; }\n\n:-moz-placeholder {\n  color: #999; }\n\n::-webkit-input-placeholder {\n  color: #999; }\n\n.input-prepend,\n.input-append {\n  margin-bottom: 5px; }\n  .input-prepend input,\n  .input-prepend select,\n  .input-prepend .uneditable-input,\n  .input-append input,\n  .input-append select,\n  .input-append .uneditable-input {\n    *margin-left: 0;\n    border-radius: 0 3px 3px 0; }\n    .input-prepend input:focus,\n    .input-prepend select:focus,\n    .input-prepend .uneditable-input:focus,\n    .input-append input:focus,\n    .input-append select:focus,\n    .input-append .uneditable-input:focus {\n      position: relative;\n      z-index: 2; }\n  .input-prepend .uneditable-input,\n  .input-append .uneditable-input {\n    border-left-color: #ccc; }\n  .input-prepend .add-on,\n  .input-append .add-on {\n    display: inline-block;\n    width: auto;\n    min-width: 16px;\n    height: 18px;\n    padding: 4px 5px;\n    font-weight: 400;\n    line-height: 18px;\n    text-align: center;\n    text-shadow: 0 1px 0 #fff;\n    vertical-align: middle;\n    background-color: #F5F5F5;\n    border: 1px solid #ccc; }\n  .input-prepend .add-on,\n  .input-append .add-on {\n    border-radius: 3px 0 0 3px;\n    position: relative;\n    z-index: 5; }\n  .input-prepend .active,\n  .input-append .active {\n    background-color: #a9dba9;\n    border-color: #46a546; }\n\n.input-prepend .add-on,\n.input-prepend .btn {\n  margin-right: -1px; }\n\n.input-append input,\n.input-append select .uneditable-input {\n  border-radius: 3px 0 0 3px;\n  margin-bottom: 0; }\n\n.input-append .uneditable-input {\n  border-left-color: #eee;\n  border-right-color: #ccc; }\n\n.input-append .add-on {\n  padding-bottom: 3px !important;\n  margin-left: -4px;\n  border-radius: 0 3px 3px 0; }\n\n.input-prepend.input-append input,\n.input-prepend.input-append select,\n.input-prepend.input-append .uneditable-input {\n  border-radius: 0; }\n\n.input-prepend.input-append .add-on:first-child,\n.input-prepend.input-append .btn:first-child {\n  margin-right: -1px;\n  border-radius: 3px 0 0 3px; }\n\n.input-prepend.input-append .add-on:last-child,\n.input-prepend.input-append .btn:last-child {\n  margin-left: -1px;\n  border-radius: 0 3px 3px 0; }\n\n.form-inline input,\n.form-inline textarea,\n.form-inline select,\n.form-inline .help-inline,\n.form-inline .uneditable-input,\n.form-inline .input-prepend,\n.form-inline .input-append,\n.form-horizontal input,\n.form-horizontal textarea,\n.form-horizontal select,\n.form-horizontal .help-inline,\n.form-horizontal .uneditable-input,\n.form-horizontal .input-prepend,\n.form-horizontal .input-append {\n  display: inline-block;\n  margin-bottom: 0; }\n\n.form-inline .hide,\n.form-horizontal .hide {\n  display: none; }\n\n.form-inline label {\n  display: inline-block; }\n\n.form-inline .input-append,\n.form-inline .input-prepend {\n  margin-bottom: 0; }\n\n.form-inline .radio,\n.form-inline .checkbox {\n  padding-left: 0;\n  margin-bottom: 0;\n  vertical-align: middle; }\n\n.form-inline .radio input[type=\"radio\"],\n.form-inline .checkbox input[type=\"checkbox\"] {\n  float: left;\n  margin-left: 0;\n  margin-right: 3px; }\n\ninput[type=\"text\"],\ninput[type=\"date\"], input[type=\"datetime\"], input[type=\"datetime-local\"], input[type=\"time\"],\ninput[type=\"number\"], input[type=\"range\"],\ninput[type=\"url\"],\ninput[type=\"password\"],\ninput[type=\"email\"],\nselect {\n  height: 27px; }\n\nselect {\n  padding: 4px; }\n\n.inline-input {\n  border: 0;\n  margin: 0 !important;\n  vertical-align: baseline;\n  box-shadow: none; }\n  .inline-input:focus {\n    box-shadow: none !important;\n    box-shadow: inset none !important; }\n\n.large-text-input {\n  height: 37px !important;\n  font-size: 16px !important;\n  line-height: 25px !important; }\n\n/* FORM ELEMENTS */\nform fieldset, form .fieldset, ng-form fieldset, ng-form .fieldset {\n  *zoom: 1; }\n  form fieldset:before, form fieldset:after, form .fieldset:before, form .fieldset:after, ng-form fieldset:before, ng-form fieldset:after, ng-form .fieldset:before, ng-form .fieldset:after {\n    display: table;\n    content: \"\"; }\n  form fieldset:after, form .fieldset:after, ng-form fieldset:after, ng-form .fieldset:after {\n    clear: both; }\n  form fieldset .field, form .fieldset .field, ng-form fieldset .field, ng-form .fieldset .field {\n    margin-bottom: 24px;\n    width: 100%; }\n    form fieldset .field > .inline-label, form .fieldset .field > .inline-label, ng-form fieldset .field > .inline-label, ng-form .fieldset .field > .inline-label {\n      margin-left: 20px;\n      margin-right: -10px; }\n  form fieldset .multiple, form .fieldset .multiple, ng-form fieldset .multiple, ng-form .fieldset .multiple {\n    display: flex; }\n    form fieldset .multiple .field, form fieldset .multiple .flex-field, form .fieldset .multiple .field, form .fieldset .multiple .flex-field, ng-form fieldset .multiple .field, ng-form fieldset .multiple .flex-field, ng-form .fieldset .multiple .field, ng-form .fieldset .multiple .flex-field {\n      flex: 1 1 auto;\n      margin-bottom: 0; }\n      form fieldset .multiple .field:not(.btn), form fieldset .multiple .flex-field:not(.btn), form .fieldset .multiple .field:not(.btn), form .fieldset .multiple .flex-field:not(.btn), ng-form fieldset .multiple .field:not(.btn), ng-form fieldset .multiple .flex-field:not(.btn), ng-form .fieldset .multiple .field:not(.btn), ng-form .fieldset .multiple .flex-field:not(.btn) {\n        padding-right: 20px; }\n      form fieldset .multiple .field:last-child:not(.btn), form fieldset .multiple .flex-field:last-child:not(.btn), form .fieldset .multiple .field:last-child:not(.btn), form .fieldset .multiple .flex-field:last-child:not(.btn), ng-form fieldset .multiple .field:last-child:not(.btn), ng-form fieldset .multiple .flex-field:last-child:not(.btn), ng-form .fieldset .multiple .field:last-child:not(.btn), ng-form .fieldset .multiple .flex-field:last-child:not(.btn) {\n        padding-right: 0; }\n      form fieldset .multiple .field.no-grow, form fieldset .multiple .flex-field.no-grow, form .fieldset .multiple .field.no-grow, form .fieldset .multiple .flex-field.no-grow, ng-form fieldset .multiple .field.no-grow, ng-form fieldset .multiple .flex-field.no-grow, ng-form .fieldset .multiple .field.no-grow, ng-form .fieldset .multiple .flex-field.no-grow {\n        flex: 0 1 auto; }\n      form fieldset .multiple .field.no-shrink, form fieldset .multiple .flex-field.no-shrink, form .fieldset .multiple .field.no-shrink, form .fieldset .multiple .flex-field.no-shrink, ng-form fieldset .multiple .field.no-shrink, ng-form fieldset .multiple .flex-field.no-shrink, ng-form .fieldset .multiple .field.no-shrink, ng-form .fieldset .multiple .flex-field.no-shrink {\n        flex: 1 0 auto; }\n    form fieldset .multiple .btn, form .fieldset .multiple .btn, ng-form fieldset .multiple .btn, ng-form .fieldset .multiple .btn {\n      white-space: nowrap; }\n  form fieldset + legend, form .fieldset + legend, ng-form fieldset + legend, ng-form .fieldset + legend {\n    margin-top: 20px; }\n  form fieldset + fieldset, form fieldset + .fieldset, form .fieldset + fieldset, form .fieldset + .fieldset, ng-form fieldset + fieldset, ng-form fieldset + .fieldset, ng-form .fieldset + fieldset, ng-form .fieldset + .fieldset {\n    margin-top: 20px; }\n\nform.form-horizontal .field > label, ng-form.form-horizontal .field > label {\n  width: 150px;\n  padding-right: 20px;\n  text-align: right;\n  float: left; }\n\nform.form-horizontal .field .control, ng-form.form-horizontal .field .control {\n  margin-left: 170px; }\n\n.field {\n  margin-bottom: 24px;\n  width: 100%; }\n  .field > .inline-label {\n    margin-left: 20px;\n    margin-right: -10px; }\n  .field label {\n    font-size: 11px;\n    font-weight: 500;\n    color: #747474;\n    text-transform: uppercase;\n    height: 18px;\n    letter-spacing: 0.08em; }\n    .field label.inline-label {\n      color: #333;\n      text-transform: none;\n      font-size: 13px;\n      line-height: 18px;\n      display: inline-block;\n      margin-right: 20px;\n      font-weight: 400;\n      letter-spacing: normal; }\n\nform.flat .title, .form-flat .title {\n  padding: 0 10px 10px 0;\n  color: #333;\n  font-size: 16px;\n  line-height: 22px; }\n\nform.flat .required-info, .form-flat .required-info {\n  display: none;\n  font-size: 11px;\n  color: #999;\n  float: right; }\n\nform.flat fieldset, form.flat .fieldset, .form-flat fieldset, .form-flat .fieldset {\n  margin-bottom: 20px;\n  position: relative; }\n  form.flat fieldset legend, form.flat fieldset .legend, form.flat .fieldset legend, form.flat .fieldset .legend, .form-flat fieldset legend, .form-flat fieldset .legend, .form-flat .fieldset legend, .form-flat .fieldset .legend {\n    padding: 0;\n    color: #333;\n    font-size: 12px;\n    text-transform: uppercase;\n    font-weight: 500;\n    padding: 10px 0;\n    margin-top: 20px; }\n  form.flat fieldset .item, form.flat .fieldset .item, .form-flat fieldset .item, .form-flat .fieldset .item {\n    width: 100%;\n    font-size: 13px;\n    color: #333;\n    position: relative;\n    box-sizing: border-box;\n    height: auto;\n    line-height: 24px;\n    padding: 10px 2px; }\n    form.flat fieldset .item .required-asteriks, form.flat .fieldset .item .required-asteriks, .form-flat fieldset .item .required-asteriks, .form-flat .fieldset .item .required-asteriks {\n      font-size: 12px;\n      color: #999;\n      position: absolute;\n      right: 10px;\n      top: 8px; }\n    form.flat fieldset .item label, form.flat .fieldset .item label, .form-flat fieldset .item label, .form-flat .fieldset .item label {\n      color: #333;\n      min-width: 100px;\n      margin-right: 10px;\n      display: inline-block; }\n    form.flat fieldset .item a, form.flat .fieldset .item a, .form-flat fieldset .item a, .form-flat .fieldset .item a {\n      color: #3599b6; }\n    form.flat fieldset .item .info-value, form.flat .fieldset .item .info-value, .form-flat fieldset .item .info-value, .form-flat .fieldset .item .info-value {\n      display: inline-block;\n      vertical-align: middle; }\n      form.flat fieldset .item .info-value .sdselect-btn, form.flat .fieldset .item .info-value .sdselect-btn, .form-flat fieldset .item .info-value .sdselect-btn, .form-flat .fieldset .item .info-value .sdselect-btn {\n        float: left;\n        color: #333;\n        width: auto; }\n        form.flat fieldset .item .info-value .sdselect-btn .caret, form.flat .fieldset .item .info-value .sdselect-btn .caret, .form-flat fieldset .item .info-value .sdselect-btn .caret, .form-flat .fieldset .item .info-value .sdselect-btn .caret {\n          margin-left: 5px; }\n    form.flat fieldset .item.password .info-value, form.flat .fieldset .item.password .info-value, .form-flat fieldset .item.password .info-value, .form-flat .fieldset .item.password .info-value {\n      -webkit-text-security: disc; }\n      form.flat fieldset .item.password .info-value .info-editable, form.flat .fieldset .item.password .info-value .info-editable, .form-flat fieldset .item.password .info-value .info-editable, .form-flat .fieldset .item.password .info-value .info-editable {\n        -webkit-text-security: disc; }\n    form.flat fieldset .item.password .change-btn:hover, form.flat .fieldset .item.password .change-btn:hover, .form-flat fieldset .item.password .change-btn:hover, .form-flat .fieldset .item.password .change-btn:hover {\n      cursor: pointer; }\n    form.flat fieldset .item p.info-editable, form.flat .fieldset .item p.info-editable, .form-flat fieldset .item p.info-editable, .form-flat .fieldset .item p.info-editable {\n      margin: 0; }\n    form.flat fieldset .item .info-editable, form.flat .fieldset .item .info-editable, .form-flat fieldset .item .info-editable, .form-flat .fieldset .item .info-editable {\n      min-width: 275px;\n      border-color: rgba(0, 0, 0, 0.1) !important;\n      border-width: 0 0 1px 0 !important;\n      border-radius: 0px !important;\n      font-size: 13px;\n      text-overflow: ellipsis;\n      margin-left: -6px;\n      background-color: transparent;\n      color: #000 !important;\n      box-sizing: border-box;\n      margin-top: 0;\n      transition: 0.3s; }\n      form.flat fieldset .item .info-editable:hover, form.flat .fieldset .item .info-editable:hover, .form-flat fieldset .item .info-editable:hover, .form-flat .fieldset .item .info-editable:hover {\n        border-color: rgba(0, 0, 0, 0.25) !important; }\n      form.flat fieldset .item .info-editable:focus, form.flat .fieldset .item .info-editable:focus, .form-flat fieldset .item .info-editable:focus, .form-flat .fieldset .item .info-editable:focus {\n        box-shadow: 0 1px 0 0 #5ea9c8 !important;\n        border-color: #5ea9c8 !important; }\n    form.flat fieldset .item input.info-editable, form.flat .fieldset .item input.info-editable, .form-flat fieldset .item input.info-editable, .form-flat .fieldset .item input.info-editable {\n      min-width: auto; }\n    form.flat fieldset .item textarea.info-editable, form.flat .fieldset .item textarea.info-editable, .form-flat fieldset .item textarea.info-editable, .form-flat .fieldset .item textarea.info-editable {\n      height: 150px;\n      width: 100%;\n      max-width: 100%;\n      line-height: 18px;\n      margin-left: 0; }\n    form.flat fieldset .item select.info-editable, form.flat .fieldset .item select.info-editable, .form-flat fieldset .item select.info-editable, .form-flat .fieldset .item select.info-editable {\n      padding: 0 !important;\n      border: 1px solid #d0d0d0 !important; }\n      form.flat fieldset .item select.info-editable:focus, form.flat .fieldset .item select.info-editable:focus, .form-flat fieldset .item select.info-editable:focus, .form-flat .fieldset .item select.info-editable:focus {\n        text-decoration: none !important; }\n  form.flat fieldset.label-light label, form.flat .fieldset.label-light label, .form-flat fieldset.label-light label, .form-flat .fieldset.label-light label {\n    color: #999;\n    text-transform: uppercase;\n    font-size: 11px;\n    font-weight: 500; }\n\n[sd-slider].ui-slider {\n  margin-left: 10px;\n  border-top: 2px solid #5ea9c8; }\n  [sd-slider].ui-slider .ui-slider-range {\n    transition: width 0.1s;\n    margin-top: -2px;\n    border-top: 2px solid #ccc; }\n  [sd-slider].ui-slider .ui-slider-handle {\n    width: 12px;\n    height: 12px;\n    top: -7px;\n    margin-left: -6px;\n    transition: left 0.1s;\n    border-radius: 50%;\n    background-color: #5ea9c8; }\n  [sd-slider].ui-slider .ui-slider-thumb {\n    font-size: 28px;\n    text-align: center;\n    color: white;\n    position: absolute;\n    margin-left: -27px;\n    top: -50px;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    border-radius: 50px;\n    background-color: #5ea9c8;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n    -webkit-transform: translate(0, 70px, 0);\n    transform: translate(0, 70px, 0);\n    transition: all 0.2s ease-in-out; }\n    [sd-slider].ui-slider .ui-slider-thumb:after {\n      position: absolute;\n      content: '';\n      left: 0;\n      border-radius: 28px;\n      top: 35px;\n      border-left: 25px solid transparent;\n      border-right: 25px solid transparent;\n      border-top-width: 28px;\n      border-top-style: solid;\n      border-top-color: #5ea9c8;\n      -webkit-transform: translate(0, -8px, 0);\n      transform: translate(0, -8px, 0);\n      transition: all 0.1s ease-in-out; }\n    [sd-slider].ui-slider .ui-slider-thumb.ui-slider-thumb-active {\n      -webkit-transform: scale(0.4);\n      transform: scale(0.4); }\n  [sd-slider].ui-slider .ui-slider-label {\n    font-size: 8px;\n    color: #c0c0c0;\n    margin-top: -18px;\n    text-transform: uppercase; }\n    [sd-slider].ui-slider .ui-slider-label.left {\n      float: left; }\n    [sd-slider].ui-slider .ui-slider-label.right {\n      float: right; }\n  [sd-slider].ui-slider .ui-slider-indicator {\n    font-size: 0;\n    line-height: 0;\n    padding-top: 7px; }\n    [sd-slider].ui-slider .ui-slider-indicator span {\n      display: inline-block;\n      height: 5px;\n      box-sizing: border-box;\n      border-left: 1px solid #d1d1d1; }\n      [sd-slider].ui-slider .ui-slider-indicator span:last-of-type {\n        border-right: 1px solid #d1d1d1; }\n\n.flex-header {\n  display: flex;\n  height: 20px;\n  margin-bottom: 8px; }\n  .flex-header .line {\n    height: 1px;\n    margin: auto 4px auto 0;\n    background: #dcdcdc;\n    flex: 1; }\n  .flex-header .flex-space {\n    height: 1px;\n    margin: auto 4px auto 0;\n    background: transparent;\n    flex: 1; }\n  .flex-header .flex-header-toggle {\n    border: 0;\n    padding: 0;\n    margin: 0 5px 0;\n    display: flex;\n    background: transparent; }\n    .flex-header .flex-header-toggle i {\n      -webkit-transition: all 0.2s ease;\n      -o-transition: all 0.2s ease;\n      transition: all 0.2s ease; }\n    .flex-header .flex-header-toggle.closed i {\n      -webkit-transform: rotate(-90deg);\n      transform: rotate(-90deg);\n      margin: auto; }\n  .flex-header .flex-header-name {\n    padding: 0 8px 0 0;\n    margin: auto 0;\n    font-size: 12px;\n    line-height: 100%;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.06em; }\n    .flex-header .flex-header-name .lighten-text {\n      color: #666;\n      font-weight: 400; }\n  .flex-header .flex-header-label {\n    box-sizing: border-box;\n    height: 16px;\n    margin: auto 0;\n    padding: 3px 6px 0;\n    border-radius: 8px;\n    color: #fff;\n    background: #bbb;\n    font-size: 10px;\n    line-height: 100%;\n    letter-spacing: 0.06em;\n    font-weight: 400; }\n\ninput.line-input, textarea.line-input, .dropdown__toggle.line-input {\n  width: 100%;\n  border-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background-color: transparent;\n  padding: 0;\n  height: 24px;\n  font-size: 13px;\n  /* alt is line input for dark background */ }\n  input.line-input:hover, textarea.line-input:hover, .dropdown__toggle.line-input:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: transparent !important; }\n  input.line-input:focus, textarea.line-input:focus, .dropdown__toggle.line-input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important;\n    background-color: transparent !important; }\n  input.line-input.line-input--alt, textarea.line-input.line-input--alt, .dropdown__toggle.line-input.line-input--alt {\n    color: #fff;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important; }\n    input.line-input.line-input--alt:hover, textarea.line-input.line-input--alt:hover, .dropdown__toggle.line-input.line-input--alt:hover {\n      border-color: rgba(255, 255, 255, 0.5) !important; }\n    input.line-input.line-input--alt:focus, textarea.line-input.line-input--alt:focus, .dropdown__toggle.line-input.line-input--alt:focus {\n      box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.7) !important;\n      border-color: rgba(255, 255, 255, 0.7) !important;\n      background-color: transparent !important; }\n\ntextarea.line-input {\n  padding-top: 3px; }\n\n.dropdown__toggle.line-input {\n  position: relative;\n  padding: 0 15px 0 0 !important;\n  line-height: 24px;\n  text-align: left; }\n\n.line-select {\n  position: relative; }\n  .line-select select {\n    position: relative;\n    z-index: 2;\n    padding: 0 15px 0 0 !important;\n    line-height: 24px;\n    text-align: left;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    width: 100%;\n    border-radius: 0 !important;\n    border: 0 !important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n    background-color: transparent;\n    padding: 0;\n    height: 24px; }\n    .line-select select:hover {\n      border-color: rgba(0, 0, 0, 0.3) !important;\n      background-color: transparent !important; }\n    .line-select select:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8 !important;\n      border-color: #5ea9c8 !important;\n      background-color: transparent !important; }\n  .line-select::after {\n    position: absolute;\n    top: 12px;\n    right: 4px;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    margin-top: -2px;\n    border-left: 4px solid transparent;\n    border-right: 4px solid transparent;\n    border-top: 4px solid #000;\n    opacity: 0.3;\n    filter: alpha(opacity=30);\n    content: \"\";\n    z-index: 0; }\n  .line-select:hover::after {\n    opacity: 0.6;\n    filter: alpha(opacity=60); }\n\ninput.line-input--inline-mini {\n  text-align: center;\n  width: 40px; }\n\n.sd-line-input input.sd-line-input__input.sd-line-input__input--mini {\n  text-align: center;\n  width: 40px; }\n\n.sd-line-input select.sd-line-input__select.sd-line-input__select--mini {\n  text-align: center;\n  width: 45px; }\n\n.helper-text {\n  display: inline-block;\n  color: #747474; }\n\n.helper-text--after-icon {\n  padding-left: 0.5rem;\n  vertical-align: top;\n  font-weight: 300; }\n\n.helper-text--padded {\n  padding: 0 10px; }\n\n.label--inline {\n  text-transform: none;\n  color: #333;\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 0;\n  vertical-align: top; }\n\n.input-group {\n  padding-top: 6px; }\n\n.contenteditable-input {\n  min-height: 23px;\n  padding: 3px 0;\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  line-height: 16px; }\n  .contenteditable-input:hover {\n    border-color: rgba(0, 0, 0, 0.3);\n    background-color: transparent; }\n  .contenteditable-input:focus {\n    box-shadow: none;\n    border-color: #5ea9c8;\n    background-color: transparent; }\n  .contenteditable-input--side-padding {\n    padding: 3px 6px; }\n\n.fieldset-flex .field {\n  display: flex; }\n\n.fieldset-flex label {\n  min-width: 100px;\n  flex: 0 1 auto; }\n\n.fieldset-flex .controls {\n  flex: 1 1 auto; }\n\n.label-asterisk:after {\n  content: ' *'; }\n\n.char-count {\n  display: inline-block;\n  margin-left: 5px; }\n  .char-count.error {\n    color: #E51C23; }\n\n.list-row {\n  padding: 1rem 0; }\n\n.list-row--dotted {\n  border-bottom: 1px dotted #999; }\n  .list-row--dotted:first-child {\n    border-top: 1px dotted #999; }\n\n.list-row--flex {\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n\n.list-row__item {\n  display: inline-block;\n  flex-grow: 0;\n  flex-shrink: 0; }\n\n.list-row__item--block {\n  display: block; }\n\n.list-row__item--grow {\n  flex-grow: 1; }\n\n.list-row--small {\n  padding: 0 0 1rem 0; }\n\n.text-label {\n  display: inline-block;\n  color: #747474;\n  margin: 0; }\n\n.column {\n  padding: 2rem 0 1rem;\n  clear: both; }\n\n.column--mb24 {\n  margin-bottom: 2.4rem; }\n\n.basic-input {\n  border: 1px solid rgba(123, 123, 123, 0.5);\n  border-radius: 3px;\n  padding-right: 5px;\n  padding-left: 5px; }\n  .basic-input:hover {\n    border: 1px solid rgba(123, 123, 123, 0.8); }\n  .basic-input:focus {\n    border: 1px solid #5ea9c8;\n    box-shadow: inset 0 0 0 1px #5ea9c8; }\n  .basic-input[disabled] {\n    border-color: #ddd !important; }\n\n.form-group-horizontal {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between; }\n  .form-group-horizontal > * {\n    flex-grow: 1; }\n  .form-group-horizontal > * + * {\n    margin-left: 1.2rem !important; }\n\ntable {\n  max-width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  background-color: transparent; }\n\n.table {\n  width: 100%;\n  margin-bottom: 18px; }\n  .table th,\n  .table td {\n    padding: 8px;\n    line-height: 18px;\n    text-align: left;\n    vertical-align: top;\n    border-top: 1px solid #ddd; }\n  .table th {\n    font-weight: bold; }\n  .table thead th {\n    vertical-align: bottom; }\n  .table colgroup + thead tr:first-child th,\n  .table colgroup + thead tr:first-child td,\n  .table thead:first-child tr:first-child th,\n  .table thead:first-child tr:first-child td {\n    border-top: 0; }\n  .table tbody + tbody {\n    border-top: 2px solid #ddd; }\n  .table .blank-field {\n    width: 100%; }\n\n.table-condensed th,\n.table-condensed td {\n  padding: 4px 5px; }\n\n.table-bordered {\n  border: 1px solid #ddd;\n  border-left: 0;\n  border-collapse: separate;\n  *border-collapse: collapsed;\n  border-radius: 4px; }\n  .table-bordered th,\n  .table-bordered td {\n    border-left: 1px solid #ddd; }\n  .table-bordered thead:first-child tr:first-child th,\n  .table-bordered tbody:first-child tr:first-child th,\n  .table-bordered tbody:first-child tr:first-child td {\n    border-top: 0; }\n  .table-bordered thead:first-child tr:first-child th:first-child,\n  .table-bordered tbody:first-child tr:first-child td:first-child {\n    border-radius: 4px 0 0 0; }\n  .table-bordered thead:first-child tr:first-child th:last-child,\n  .table-bordered tbody:first-child tr:first-child td:last-child {\n    border-radius: 0 4px 0 0; }\n  .table-bordered thead:last-child tr:last-child th:first-child,\n  .table-bordered tbody:last-child tr:last-child td:first-child {\n    border-radius: 0 0 0 4px; }\n  .table-bordered thead:last-child tr:last-child th:last-child,\n  .table-bordered tbody:last-child tr:last-child td:last-child {\n    border-radius: 0 0 4px 0; }\n\n.table-striped tbody tr:nth-child(odd) td,\n.table-striped tbody tr:nth-child(odd) th {\n  background-color: #f9f9f9; }\n\n.table tbody tr:hover td,\n.table tbody tr:hover th {\n  background-color: #f5f5f5; }\n\n.table.styled-table {\n  border-top: 2px solid #d7d7d7; }\n  .table.styled-table th, .table.styled-table td {\n    vertical-align: middle;\n    background: #fff; }\n    .table.styled-table th.align-right, .table.styled-table td.align-right {\n      text-align: right; }\n  .table.styled-table th {\n    font-size: 13px;\n    font-weight: 500;\n    padding: 11px;\n    color: #333; }\n\n.table--fixed-header thead, .table--fixed-header tbody {\n  display: block; }\n\n.table--fixed-header tbody {\n  max-height: calc(100vh - 250px);\n  overflow: auto;\n  overflow-x: hidden; }\n\n.table--fixed-header th, .table--fixed-header td {\n  min-width: 80px; }\n\n.bs-pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: 20px 0;\n  border-radius: 4px; }\n\n.bs-pagination a:hover {\n  cursor: pointer; }\n\n.bs-pagination > li {\n  display: inline; }\n\n.bs-pagination > li > a,\n.bs-pagination > li > span {\n  position: relative;\n  float: left;\n  padding: 6px 12px;\n  line-height: 1.42857143;\n  text-decoration: none;\n  color: #5ea9c8;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  margin-left: -1px; }\n\n.bs-pagination > li:first-child > a,\n.bs-pagination > li:first-child > span {\n  margin-left: 0;\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px; }\n\n.bs-pagination > li:last-child > a,\n.bs-pagination > li:last-child > span {\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px; }\n\n.bs-pagination > li > a:hover,\n.bs-pagination > li > span:hover,\n.bs-pagination > li > a:focus,\n.bs-pagination > li > span:focus {\n  z-index: 2;\n  color: #23527c;\n  background-color: #eeeeee;\n  border-color: #ddd; }\n\n.bs-pagination > .active > a,\n.bs-pagination > .active > span,\n.bs-pagination > .active > a:hover,\n.bs-pagination > .active > span:hover,\n.bs-pagination > .active > a:focus,\n.bs-pagination > .active > span:focus {\n  z-index: 3;\n  color: #fff;\n  background-color: #5ea9c8;\n  border-color: #5ea9c8;\n  cursor: default; }\n\n.bs-pagination > .disabled > span,\n.bs-pagination > .disabled > span:hover,\n.bs-pagination > .disabled > span:focus,\n.bs-pagination > .disabled > a,\n.bs-pagination > .disabled > a:hover,\n.bs-pagination > .disabled > a:focus {\n  color: #777777;\n  background-color: #fff;\n  border-color: #ddd;\n  cursor: not-allowed; }\n\n.sd-typeahead {\n  position: relative;\n  list-style-type: none; }\n  .sd-typeahead .item-list {\n    z-index: 9999;\n    min-width: 190px;\n    width: 100%;\n    height: auto;\n    max-height: 170px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: #fff;\n    border: 1px #bbb;\n    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);\n    position: absolute;\n    top: 28px;\n    z-index: 61; }\n    .sd-typeahead .item-list li {\n      width: 100%;\n      font-size: 1.3rem;\n      margin-bottom: 0.4rem; }\n      .sd-typeahead .item-list li:hover {\n        cursor: pointer;\n        background-color: rgba(94, 169, 200, 0.1); }\n      .sd-typeahead .item-list li.active button {\n        background-color: rgba(94, 169, 200, 0.4) !important; }\n      .sd-typeahead .item-list li .country_state_info {\n        font-weight: 500; }\n      .sd-typeahead .item-list li em {\n        font-size: 11px; }\n      .sd-typeahead .item-list li.typeahead-item--padded {\n        padding: 0.4rem 1.2rem; }\n    .sd-typeahead .item-list button.greyout {\n      opacity: .5; }\n\ndiv.password-strength {\n  color: #666;\n  margin: 3px 0;\n  font-size: 12px; }\n  div.password-strength .label.red {\n    background-color: #E51C23; }\n  div.password-strength .label.yellow {\n    background-color: #ffc40d; }\n  div.password-strength .label.green {\n    background-color: #46a546; }\n  div.password-strength .icon-question-sign {\n    margin: 0px 0 0 5px;\n    position: relative;\n    top: 3px;\n    color: #5d9bc0;\n    cursor: pointer; }\n  div.password-strength .tooltip > .tooltip-arrow {\n    border-color: #333 transparent #333 transparent;\n    opacity: 0.9; }\n  div.password-strength .tooltip > .tooltip-inner {\n    text-align: left;\n    background-color: #333;\n    border-radius: 3px;\n    opacity: 0.9;\n    line-height: 16px; }\n    div.password-strength .tooltip > .tooltip-inner ul {\n      padding: 3px 0; }\n      div.password-strength .tooltip > .tooltip-inner ul li {\n        padding: 0;\n        margin: 0;\n        line-height: 16px; }\n        div.password-strength .tooltip > .tooltip-inner ul li:before {\n          content: \"- \";\n          padding-left: 5px; }\n\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n/* ====================================== */\n.output-item-label {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 10px;\n  background: #8a8a8a;\n  box-sizing: border-box;\n  line-height: 17px;\n  vertical-align: top;\n  font-style: normal; }\n  .output-item-label.label-0 {\n    background: #8a8a8a; }\n  .output-item-label.label-1 {\n    background: #005e84; }\n  .output-item-label.label-2 {\n    background: #64a4bf; }\n  .output-item-label.label-3, .output-item-label.label-4, .output-item-label.label-5 {\n    background: #b0cfdd; }\n\n/* ====================================== */\n.status-label {\n  box-sizing: border-box;\n  height: 15px;\n  padding: 4px 7px;\n  background: #1f6681;\n  border-radius: 2px;\n  display: inline-block;\n  font-size: 10px;\n  color: #fff;\n  line-height: 7px;\n  margin: 0 5px 0 0;\n  text-transform: uppercase; }\n  .status-label.label-canceled {\n    background: #1c1c1c;\n    color: #ff5353; }\n\n.archive-content {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  height: calc(100% - 30px);\n  background-color: #f8f8f8;\n  transition: left 0.2s ease;\n  z-index: 11; }\n  .archive-content.wide {\n    left: 10px; }\n  .archive-content .content-inner {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 49px; }\n    .archive-content .content-inner .newest-items {\n      margin-bottom: 35px; }\n      .archive-content .content-inner .newest-items > span {\n        height: 30px;\n        font-size: 11px;\n        color: #8a8a8a;\n        line-height: 30px;\n        font-weight: 300;\n        text-transform: uppercase; }\n      .archive-content .content-inner .newest-items ul {\n        *zoom: 1; }\n        .archive-content .content-inner .newest-items ul:before, .archive-content .content-inner .newest-items ul:after {\n          display: table;\n          content: \"\"; }\n        .archive-content .content-inner .newest-items ul:after {\n          clear: both; }\n  .archive-content .statistics {\n    position: absolute;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    top: 0;\n    padding: 30px;\n    overflow: auto;\n    overflow-x: hidden; }\n  .archive-content .preview-layout .list-pane .list-view {\n    *zoom: 1; }\n    .archive-content .preview-layout .list-pane .list-view:before, .archive-content .preview-layout .list-pane .list-view:after {\n      display: table;\n      content: \"\"; }\n    .archive-content .preview-layout .list-pane .list-view:after {\n      clear: both; }\n    .archive-content .preview-layout .list-pane .list-view .panel {\n      float: left; }\n      .archive-content .preview-layout .list-pane .list-view .panel.alert {\n        float: none; }\n      .archive-content .preview-layout .list-pane .list-view .panel .panel-body {\n        display: inline-block; }\n        .archive-content .preview-layout .list-pane .list-view .panel .panel-body .ui-draggable {\n          display: inline-block; }\n  .archive-content .content .shadow-list-holder {\n    position: relative;\n    max-height: none;\n    min-height: auto; }\n\n.view-select button {\n  height: 48px;\n  width: 48px;\n  background: none;\n  border: 0;\n  padding: 15px 16px;\n  border-left: 1px solid #dfdfdf;\n  opacity: 0.6;\n  filter: \"alpha(opacity=60)\"; }\n  .view-select button:hover {\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.loading-indicator {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  margin-left: -5rem;\n  min-width: 10rem;\n  padding: 0.8rem 1.6rem;\n  border-radius: 0 0 4px 4px;\n  border: 1px solid #52b1cc;\n  border-width: 0 1px 1px;\n  text-align: center;\n  font-size: 1.3rem;\n  font-weight: 400;\n  letter-spacing: 0.06em;\n  color: #3599b6;\n  background: #eff7fa;\n  z-index: 3;\n  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12); }\n\n/* ====================================== */\n.mgrid-view .media-box {\n  height: auto;\n  width: auto;\n  min-height: 225px;\n  min-width: 176px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  border-width: 0px 0px 3px 0px;\n  margin: 1px 12px 10px 1px;\n  border-radius: 2px;\n  padding: 5px;\n  position: relative;\n  float: left;\n  display: block;\n  cursor: pointer;\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  /* control buttons on the bottom */ }\n  .mgrid-view .media-box .action {\n    display: none;\n    height: 33px;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0; }\n  .mgrid-view .media-box:hover .action {\n    display: block; }\n  .mgrid-view .media-box.archived {\n    background: #f2f2f2 url(" + escape(__webpack_require__(614)) + ") no-repeat bottom right;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.03); }\n  .mgrid-view .media-box.error {\n    border-color: #d19796;\n    border-bottom-color: #c00000; }\n  .mgrid-view .media-box .error-box {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.9);\n    z-index: 1; }\n    .mgrid-view .media-box .error-box .message {\n      color: #970000;\n      font-weight: 400;\n      font-size: 12px;\n      padding: 40px 10px 0;\n      text-transform: uppercase;\n      text-align: center;\n      line-height: 20px; }\n      .mgrid-view .media-box .error-box .message b {\n        display: block;\n        font-size: 16px; }\n    .mgrid-view .media-box .error-box .buttons {\n      position: absolute;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      height: 30px;\n      background: #f7eaea;\n      border-top: 1px solid #e1bbbb; }\n  .mgrid-view .media-box .media {\n    box-sizing: border-box;\n    height: 120px;\n    margin: 0 2px 5px;\n    display: block;\n    position: relative;\n    background: #f8f8f8; }\n    .mgrid-view .media-box .media img {\n      height: auto;\n      width: auto;\n      max-width: 172px;\n      max-height: 120px; }\n    .mgrid-view .media-box .media .caption {\n      display: none; }\n    .mgrid-view .media-box .media .selectbox {\n      position: absolute;\n      top: 0;\n      right: 0;\n      margin: 0;\n      padding: 1px 2px 2px 2px;\n      background-color: rgba(255, 255, 255, 0.85);\n      border-radius: 0 0 0 2px; }\n      .mgrid-view .media-box .media .selectbox .sd-checkbox {\n        margin: 0; }\n  .mgrid-view .media-box.media-picture .text, .mgrid-view .media-box.media-graphic .text, .mgrid-view .media-box.media-video .text {\n    display: none;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 176px;\n    height: 120px;\n    background: rgba(192, 192, 192, 0.9); }\n  .mgrid-view .media-box.media-picture .media:hover .text, .mgrid-view .media-box.media-graphic .media:hover .text, .mgrid-view .media-box.media-video .media:hover .text {\n    display: block; }\n  .mgrid-view .media-box.media-text .media, .mgrid-view .media-box.media-preformatted .media, .mgrid-view .media-box.media-composite .media, .mgrid-view .media-box.media-picture .media, .mgrid-view .media-box.media-graphic .media {\n    max-width: 172px;\n    font-size: 12px;\n    font-style: italic;\n    white-space: normal;\n    overflow: hidden; }\n  .mgrid-view .media-box.media-text small, .mgrid-view .media-box.media-preformatted small, .mgrid-view .media-box.media-composite small, .mgrid-view .media-box.media-picture small, .mgrid-view .media-box.media-graphic small {\n    display: block;\n    padding: 2px 5px;\n    font-size: 13px; }\n  .mgrid-view .media-box.media-text .container, .mgrid-view .media-box.media-preformatted .container, .mgrid-view .media-box.media-composite .container, .mgrid-view .media-box.media-picture .container, .mgrid-view .media-box.media-graphic .container {\n    font-weight: 500;\n    color: #444;\n    margin-left: 6px; }\n  .mgrid-view .media-box.media-audio .media {\n    width: 176px;\n    max-width: 176px;\n    text-align: center; }\n    .mgrid-view .media-box.media-audio .media i {\n      margin-top: 35px;\n      opacity: 0.35;\n      filter: \"alpha(opacity=35)\"; }\n  .mgrid-view .media-box .media-info {\n    position: relative;\n    padding: 18px 0 0; }\n    .mgrid-view .media-box .media-info .legal {\n      bottom: 16px; }\n  .mgrid-view .media-box h5 {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    width: auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    height: 18px;\n    font-size: 11px;\n    margin: 0 2px;\n    color: #216278;\n    text-transform: uppercase; }\n    .mgrid-view .media-box h5.shifted {\n      left: 20px; }\n  .mgrid-view .media-box dl {\n    *zoom: 1;\n    font-size: 11px;\n    height: 1%;\n    margin: 0 2px; }\n    .mgrid-view .media-box dl:before, .mgrid-view .media-box dl:after {\n      display: table;\n      content: \"\"; }\n    .mgrid-view .media-box dl:after {\n      clear: both; }\n    .mgrid-view .media-box dl dt {\n      width: auto;\n      float: left;\n      clear: left;\n      color: #787878;\n      line-height: 16px;\n      font-weight: normal; }\n    .mgrid-view .media-box dl dt:after {\n      content: \":\"; }\n    .mgrid-view .media-box dl dd {\n      width: auto;\n      color: #b4b4b4;\n      line-height: 16px;\n      float: left;\n      margin-left: 4px; }\n      .mgrid-view .media-box dl dd.subject-line {\n        max-width: 90px;\n        height: 15px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n      .mgrid-view .media-box dl dd.dropdown:hover .dropdown__menu {\n        display: block;\n        min-width: 100%; }\n  .mgrid-view .media-box .type-icon {\n    text-align: center; }\n    .mgrid-view .media-box .type-icon i {\n      color: #999; }\n  .mgrid-view .media-box .source:after {\n    content: \"\" !important; }\n  .mgrid-view .media-box .provider {\n    color: #787878;\n    margin-left: 0; }\n  .mgrid-view .media-box .urgency-label {\n    position: absolute;\n    bottom: 7px;\n    left: 36px; }\n  .mgrid-view .media-box .priority-label {\n    position: absolute;\n    bottom: 7px;\n    left: 60px; }\n  .mgrid-view .media-box .broadcast-status {\n    position: absolute;\n    bottom: 7px;\n    left: 82px;\n    background: #e51c23;\n    color: #FFFFFF;\n    border-radius: 2px;\n    font-size: 14px;\n    font-weight: bold;\n    width: 14px;\n    text-align: center; }\n  .mgrid-view .media-box .state-label, .mgrid-view .mlist-view .media-box.contacts .org-label, .mlist-view .mgrid-view .media-box.contacts .org-label, .mgrid-view .compact-view .media-box.contacts .org-label, .compact-view .mgrid-view .media-box.contacts .org-label, .mgrid-view .media-box .profile-label, .mgrid-view .media-box .language-label {\n    position: absolute;\n    bottom: 8px;\n    right: 0px; }\n  .mgrid-view .media-box .fetched-desk {\n    font-size: 11px;\n    margin-top: 3px; }\n  .mgrid-view .media-box .not-for-publication {\n    position: static; }\n  .mgrid-view .media-box.contacts {\n    min-height: 270px;\n    min-width: 425px; }\n    .mgrid-view .media-box.contacts .media {\n      height: 25px; }\n    .mgrid-view .media-box.contacts dl dt:after {\n      content: \"\"; }\n    .mgrid-view .media-box.contacts dl dd {\n      margin-left: 6px;\n      line-height: 18px; }\n      .mgrid-view .media-box.contacts dl dd.dark {\n        color: #444;\n        font-weight: 500; }\n    .mgrid-view .media-box.contacts .media-info {\n      padding-left: 0.5rem; }\n      .mgrid-view .media-box.contacts .media-info h5 {\n        padding: 0rem 0.5rem 0; }\n    .mgrid-view .media-box.contacts .item-info {\n      padding: 6px 6px 6px 6px; }\n      .mgrid-view .media-box.contacts .item-info .container {\n        font-weight: 500;\n        color: #444;\n        margin-right: 10px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n        .mgrid-view .media-box.contacts .item-info .container.link {\n          color: #3599b6;\n          font-weight: 400;\n          text-overflow: ellipsis; }\n    .mgrid-view .media-box.contacts .contact-footer {\n      border-top: .1rem solid #e8e8e8;\n      margin-top: 25px;\n      margin-left: -5px;\n      margin-right: -5px; }\n      .mgrid-view .media-box.contacts .contact-footer.padded {\n        margin-top: 45px !important; }\n      .mgrid-view .media-box.contacts .contact-footer .update-info {\n        position: absolute;\n        bottom: 0.6rem;\n        padding-left: 0.5rem; }\n      .mgrid-view .media-box.contacts .contact-footer .social-info {\n        position: absolute;\n        bottom: 10px;\n        right: 0px;\n        margin-right: 20px; }\n        .mgrid-view .media-box.contacts .contact-footer .social-info span {\n          padding-left: 10px; }\n    .mgrid-view .media-box.contacts .link {\n      color: #3599b6;\n      font-weight: 400;\n      font-size: small; }\n    .mgrid-view .media-box.contacts .notes {\n      display: flex;\n      background: none; }\n    .mgrid-view .media-box.contacts .contact-name {\n      font-size: 1.1em; }\n    .mgrid-view .media-box.contacts .item-notes {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin: 0 5px 0 5px;\n      max-width: 380px;\n      display: flex; }\n  .mgrid-view .media-box.locked {\n    border-bottom-color: #e51c23 !important; }\n  .mgrid-view .media-box.gone {\n    opacity: 0.5; }\n  .mgrid-view .media-box.actioning {\n    background-color: fade(#f7f7f7, 20%);\n    border-color: fade(#cfcfcf, 20%); }\n    .mgrid-view .media-box.actioning:before {\n      content: '';\n      zoom: .7;\n      top: 50%;\n      transform: translateY(-50%);\n      position: absolute;\n      z-index: 1;\n      background-image: url(" + escape(__webpack_require__(34)) + ");\n      background-repeat: no-repeat;\n      background-position: center;\n      display: inline-block;\n      width: 100%;\n      height: 40px;\n      line-height: 40px;\n      vertical-align: middle;\n      text-align: center; }\n  .mgrid-view .media-box .highlights-title {\n    position: absolute;\n    top: -2px;\n    left: 0;\n    display: block; }\n  .mgrid-view .media-box .item-functions {\n    background: #fff;\n    position: absolute;\n    height: 32px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    font-size: 0;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n    .mgrid-view .media-box .item-functions .item-field {\n      width: 31px;\n      height: 32px;\n      border-left: 0;\n      border-right: 1px solid #f0f0f0;\n      box-sizing: border-box;\n      padding: 0; }\n      .mgrid-view .media-box .item-functions .item-field a {\n        display: inline-block;\n        width: 100%;\n        height: 32px;\n        line-height: 32px;\n        vertical-align: middle;\n        text-align: center; }\n        .mgrid-view .media-box .item-functions .item-field a .actioning {\n          background-image: url(" + escape(__webpack_require__(106)) + ");\n          background-repeat: no-repeat;\n          background-position: center;\n          display: inline-block;\n          width: 100%;\n          height: 32px;\n          line-height: 32px;\n          vertical-align: middle;\n          text-align: center; }\n        .mgrid-view .media-box .item-functions .item-field a i {\n          vertical-align: middle; }\n      .mgrid-view .media-box .item-functions .item-field .more-activity-dropdown li {\n        border-right: 0; }\n  .mgrid-view .media-box .more-activity-toggle {\n    background: none; }\n  .mgrid-view .media-box .media-box__footer {\n    margin: 6px 0;\n    position: relative;\n    display: flex;\n    align-content: center; }\n    .mgrid-view .media-box .media-box__footer .type-icon {\n      height: 16px;\n      margin-right: 6px;\n      flex-grow: 0; }\n    .mgrid-view .media-box .media-box__footer .badge {\n      margin-right: 6px; }\n    .mgrid-view .media-box .media-box__footer .item-right {\n      top: -2px;\n      height: 22px;\n      width: 32px; }\n\n.fetched-desk-tooltip {\n  border: 0;\n  background: transparent; }\n\n.mgrid-view {\n  padding-bottom: 80px; }\n  .mgrid-view .draggable-item {\n    float: left; }\n  .mgrid-view .list-item-view {\n    float: left; }\n\n#last-item {\n  background: transparent;\n  border: none;\n  height: 1px;\n  width: 1px;\n  margin: 0; }\n\n.sd-grid-list .sd-grid-item {\n  height: 100%; }\n\n.sd-grid-list .item-right {\n  top: auto;\n  height: 1.8rem;\n  width: 2.4rem;\n  margin-right: 1rem;\n  position: relative;\n  margin-left: -1rem; }\n  .sd-grid-list .item-right .more-activity-toggle {\n    background: none; }\n\n.sd-grid-list .sd-grid-item__type-icn > i {\n  vertical-align: middle; }\n\n.sd-grid-item__footer i {\n  vertical-align: middle;\n  opacity: 0.4; }\n\n/* ====================================== */\n.media-box .keyword, .mgrid-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .contact-name {\n  font-weight: 500;\n  color: #216278;\n  text-transform: uppercase;\n  font-size: 12px;\n  margin-right: 10px;\n  white-space: nowrap; }\n\n.mlist-view, .compact-view {\n  box-shadow: 0px 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .mlist-view .list-item-view, .compact-view .list-item-view {\n    width: 100%; }\n    .mlist-view .list-item-view:last-child .media-box, .compact-view .list-item-view:last-child .media-box {\n      border-bottom: none; }\n    .mlist-view .list-item-view .panel-body, .compact-view .list-item-view .panel-body {\n      display: block !important;\n      width: 100%; }\n  .mlist-view .actions-visible .media-box:hover .item-info, .compact-view .actions-visible .media-box:hover .item-info {\n    padding: 10px 30px 10px 10px; }\n  .mlist-view .media-box, .compact-view .media-box {\n    position: relative;\n    background: #fff;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n    border-right: 2px solid #fff;\n    padding-left: 40px;\n    overflow: hidden; }\n    .mlist-view .media-box:hover, .compact-view .media-box:hover {\n      background-color: #f4f4f4 !important;\n      border-right: 2px solid #f4f4f4;\n      cursor: pointer; }\n      .mlist-view .media-box:hover .list-field, .compact-view .media-box:hover .list-field {\n        border-color: #ebebeb; }\n      .mlist-view .media-box:hover .item-info-reduced-rowheight, .compact-view .media-box:hover .item-info-reduced-rowheight {\n        padding: 5px 10px 5px 10px; }\n      .mlist-view .media-box:hover .more-activity-toggle, .compact-view .media-box:hover .more-activity-toggle {\n        background: linear-gradient(to right, rgba(244, 244, 244, 0) 0%, rgba(244, 244, 244, 0) 0%, #f4f4f4 40%) !important; }\n    .mlist-view .media-box.gone, .compact-view .media-box.gone {\n      opacity: 0.5; }\n    .mlist-view .media-box.actioning, .compact-view .media-box.actioning {\n      background-color: fade(#f7f7f7, 20%);\n      border-color: fade(#cfcfcf, 20%); }\n      .mlist-view .media-box.actioning:before, .compact-view .media-box.actioning:before {\n        content: '';\n        zoom: .7;\n        top: 50%;\n        transform: translateY(-50%);\n        position: absolute;\n        z-index: 1;\n        background-image: url(" + escape(__webpack_require__(34)) + ");\n        background-repeat: no-repeat;\n        background-position: center;\n        display: inline-block;\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        vertical-align: middle;\n        text-align: center; }\n    .mlist-view .media-box .list-field, .compact-view .media-box .list-field {\n      border-right: 1px solid rgba(0, 0, 0, 0.06);\n      float: left;\n      padding: 10px; }\n      .mlist-view .media-box .list-field.no-border, .compact-view .media-box .list-field.no-border {\n        border: 0; }\n    .mlist-view .media-box .type-icon, .compact-view .media-box .type-icon {\n      position: absolute;\n      top: 0;\n      left: 4px;\n      bottom: 0;\n      padding: 0;\n      width: 37px;\n      text-align: center;\n      display: flex;\n      justify-content: center;\n      align-items: center; }\n      .mlist-view .media-box .type-icon i, .compact-view .media-box .type-icon i {\n        color: #999;\n        width: 24px;\n        margin: 0;\n        padding: 0; }\n      .mlist-view .media-box .type-icon .sd-checkbox, .compact-view .media-box .type-icon .sd-checkbox {\n        margin: 1px 0 0 1px;\n        padding: 0; }\n    .mlist-view .media-box .urgency, .compact-view .media-box .urgency {\n      position: absolute;\n      top: 0;\n      left: 42px;\n      bottom: 0;\n      padding: 0;\n      width: 37px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      column-count: 1; }\n      .mlist-view .media-box .urgency .output-item-label, .mlist-view .media-box .urgency .urgency-label, .compact-view .media-box .urgency .output-item-label, .compact-view .media-box .urgency .urgency-label {\n        margin: 3px 0; }\n      .mlist-view .media-box .urgency .badge:nth-child(1), .compact-view .media-box .urgency .badge:nth-child(1) {\n        margin-bottom: 0.2rem; }\n      .mlist-view .media-box .urgency .badge:nth-child(2), .compact-view .media-box .urgency .badge:nth-child(2) {\n        margin-top: 0.2rem; }\n      .mlist-view .media-box .urgency .badge:only-child, .compact-view .media-box .urgency .badge:only-child {\n        margin: 0; }\n      .mlist-view .media-box .urgency i, .mlist-view .media-box .urgency .priority-label, .compact-view .media-box .urgency i, .compact-view .media-box .urgency .priority-label {\n        clear: both;\n        margin: 3px 0; }\n    .mlist-view .media-box .urgency-reduced-rowheight, .compact-view .media-box .urgency-reduced-rowheight {\n      flex-direction: row; }\n      .mlist-view .media-box .urgency-reduced-rowheight .urgency-label, .compact-view .media-box .urgency-reduced-rowheight .urgency-label {\n        margin: 3px 2px 3px 0; }\n      .mlist-view .media-box .urgency-reduced-rowheight i, .mlist-view .media-box .urgency-reduced-rowheight .priority-label, .compact-view .media-box .urgency-reduced-rowheight i, .compact-view .media-box .urgency-reduced-rowheight .priority-label {\n        clear: both;\n        margin: 3px 0 3px 1px; }\n    .mlist-view .media-box .version-creator, .compact-view .media-box .version-creator {\n      color: #686b6c;\n      padding: 0px 0px 0px 2px; }\n    .mlist-view .media-box .word-count, .compact-view .media-box .word-count {\n      font-weight: 700;\n      font-size: 12px;\n      margin-right: 8px; }\n      .mlist-view .media-box .word-count:empty, .compact-view .media-box .word-count:empty {\n        margin-right: 0px; }\n    .mlist-view .media-box.contacts, .compact-view .media-box.contacts {\n      padding-left: 20px; }\n      .mlist-view .media-box.contacts .org-label, .compact-view .media-box.contacts .org-label {\n        background-color: #8c8c8c;\n        color: #fff !important; }\n      .mlist-view .media-box.contacts .item-notes, .compact-view .media-box.contacts .item-notes {\n        flex-grow: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin: 0 5px 0 5px; }\n      .mlist-view .media-box.contacts .item-info .social-info, .compact-view .media-box.contacts .item-info .social-info {\n        position: absolute;\n        right: 0px; }\n      .mlist-view .media-box.contacts .item-info.item-info-reduced-rowheight .social-info, .compact-view .media-box.contacts .item-info.item-info-reduced-rowheight .social-info {\n        position: unset; }\n      .mlist-view .media-box.contacts i, .compact-view .media-box.contacts i {\n        color: #999;\n        width: 24px;\n        margin: 0;\n        padding: 0; }\n    .mlist-view .media-box .item-info, .compact-view .media-box .item-info {\n      padding: 10px 10px 10px 10px; }\n      .mlist-view .media-box .item-info .line, .compact-view .media-box .item-info .line {\n        height: 18px;\n        line-height: 18px;\n        position: relative;\n        margin-left: 38px;\n        display: flex;\n        box-sizing: border-box;\n        white-space: nowrap; }\n        .mlist-view .media-box .item-info .line dl, .compact-view .media-box .item-info .line dl {\n          margin: 0;\n          white-space: nowrap; }\n        .mlist-view .media-box .item-info .line dt, .mlist-view .media-box .item-info .line dd, .compact-view .media-box .item-info .line dt, .compact-view .media-box .item-info .line dd {\n          display: inline-block;\n          margin-left: 0px; }\n          .mlist-view .media-box .item-info .line dt.dropdown:hover .dropdown__menu, .mlist-view .media-box .item-info .line dd.dropdown:hover .dropdown__menu, .compact-view .media-box .item-info .line dt.dropdown:hover .dropdown__menu, .compact-view .media-box .item-info .line dd.dropdown:hover .dropdown__menu {\n            display: block;\n            min-width: 100%; }\n          .mlist-view .media-box .item-info .line dt .dropdown__toggle, .mlist-view .media-box .item-info .line dd .dropdown__toggle, .compact-view .media-box .item-info .line dt .dropdown__toggle, .compact-view .media-box .item-info .line dd .dropdown__toggle {\n            padding: 0;\n            margin: 0 0 0 5px; }\n      .mlist-view .media-box .item-info div:not(.state-label):not(.mlist-view .media-box.contacts .org-label):not(.compact-view .media-box.contacts .org-label):not(.profile-label):not(.language-label), .compact-view .media-box .item-info div:not(.state-label):not(.mlist-view .media-box.contacts .org-label):not(.compact-view .media-box.contacts .org-label):not(.profile-label):not(.language-label) {\n        display: flex;\n        white-space: nowrap;\n        overflow: hidden;\n        flex-shrink: 0; }\n      .mlist-view .media-box .item-info .state-label, .mlist-view .media-box.contacts .item-info .org-label, .mlist-view .media-box .item-info .profile-label, .mlist-view .media-box .item-info .language-label, .mlist-view .media-box .item-info .profile-label, .compact-view .media-box .item-info .state-label, .compact-view .media-box.contacts .item-info .org-label, .compact-view .media-box .item-info .profile-label, .compact-view .media-box .item-info .language-label, .compact-view .media-box .item-info .profile-label {\n        margin-top: 2px;\n        margin-right: 4px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n      .mlist-view .media-box .item-info .language-label, .compact-view .media-box .item-info .language-label {\n        overflow: visible;\n        text-overflow: initial; }\n      .mlist-view .media-box .item-info .label, .compact-view .media-box .item-info .label {\n        margin-right: 6px;\n        margin-top: 2px;\n        line-height: 11px; }\n      .mlist-view .media-box .item-info .signal, .compact-view .media-box .item-info .signal {\n        display: inline-block;\n        background: rgba(0, 0, 0, 0.1);\n        padding: 1px 5px;\n        border-radius: 2px;\n        text-transform: uppercase;\n        font-size: 9px;\n        letter-spacing: 0.08em;\n        font-weight: 500;\n        line-height: 14px;\n        margin-top: 2px;\n        margin-right: 10px; }\n      .mlist-view .media-box .item-info .broadcast-status, .compact-view .media-box .item-info .broadcast-status {\n        display: inline-block;\n        background: #e51c23;\n        color: #FFFFFF;\n        padding: 1px 5px;\n        border-radius: 2px;\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 14px;\n        margin-top: 2px;\n        margin-right: 10px; }\n      .mlist-view .media-box .item-info .headline, .compact-view .media-box .item-info .headline {\n        color: #686b6c;\n        margin-right: 65px;\n        display: flex;\n        flex-grow: 1;\n        display: table; }\n      .mlist-view .media-box .item-info .highlights-box, .compact-view .media-box .item-info .highlights-box {\n        margin-top: -2px;\n        margin-right: 5px; }\n      .mlist-view .media-box .item-info .item-heading, .compact-view .media-box .item-info .item-heading {\n        flex-grow: 1;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin: 0; }\n        .mlist-view .media-box .item-info .item-heading p, .compact-view .media-box .item-info .item-heading p {\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          margin: 0; }\n      .mlist-view .media-box .item-info .location-desk-label, .compact-view .media-box .item-info .location-desk-label {\n        font-style: italic;\n        color: #666;\n        font-weight: 300;\n        margin-right: 3px; }\n      .mlist-view .media-box .item-info .container, .compact-view .media-box .item-info .container {\n        font-weight: 500;\n        color: #444;\n        margin-right: 10px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap; }\n        .mlist-view .media-box .item-info .container.link, .compact-view .media-box .item-info .container.link {\n          color: #3599b6;\n          font-weight: 400;\n          text-overflow: inherit; }\n        .mlist-view .media-box .item-info .container.grow, .compact-view .media-box .item-info .container.grow {\n          flex-grow: 1; }\n      .mlist-view .media-box .item-info .takekey, .compact-view .media-box .item-info .takekey {\n        color: #333;\n        margin-right: 20px;\n        float: left; }\n      .mlist-view .media-box .item-info .category, .compact-view .media-box .item-info .category {\n        color: #444;\n        margin-right: 10px;\n        float: left; }\n      .mlist-view .media-box .item-info .provider, .compact-view .media-box .item-info .provider {\n        color: #686b6c;\n        float: left;\n        margin-right: 10px;\n        white-space: nowrap; }\n      .mlist-view .media-box .item-info .expires, .compact-view .media-box .item-info .expires {\n        float: right;\n        background: #f2dede;\n        color: #b94a48;\n        font-size: 10px;\n        line-height: 15px;\n        padding: 0 5px;\n        border-radius: 3px;\n        margin-top: 4px; }\n      .mlist-view .media-box .item-info time, .compact-view .media-box .item-info time {\n        font-size: 11px;\n        color: #999;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        min-width: 60px;\n        text-align: right;\n        margin-left: 3px; }\n        .mlist-view .media-box .item-info time.time--short, .compact-view .media-box .item-info time.time--short {\n          min-width: 30px; }\n      .mlist-view .media-box .item-info .associations, .compact-view .media-box .item-info .associations {\n        position: static; }\n      .mlist-view .media-box .item-info .queue-error, .compact-view .media-box .item-info .queue-error {\n        margin-right: 5px; }\n    .mlist-view .media-box .item-info-reduced-rowheight, .compact-view .media-box .item-info-reduced-rowheight {\n      padding: 5px 10px 5px 10px; }\n    .mlist-view .media-box.archived, .compact-view .media-box.archived {\n      background: #f1f1f1 url(" + escape(__webpack_require__(257)) + ") no-repeat 70% 50%;\n      background-size: 36px;\n      border-right: 2px solid #f1f1f1; }\n      .mlist-view .media-box.archived.active, .compact-view .media-box.archived.active {\n        border-right: 2px solid rgba(94, 169, 200, 0.75) !important; }\n    .mlist-view .media-box:hover .action, .compact-view .media-box:hover .action {\n      display: block; }\n    .mlist-view .media-box .state-border, .compact-view .media-box .state-border {\n      position: absolute;\n      width: 4px;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      background: transparent; }\n    .mlist-view .media-box.locked .state-border, .compact-view .media-box.locked .state-border {\n      background: #e51c23; }\n    .mlist-view .media-box.media-box--state-published, .mlist-view .media-box.media-box--state-corrected, .compact-view .media-box.media-box--state-published, .compact-view .media-box.media-box--state-corrected {\n      background: #f8fcf5; }\n      .mlist-view .media-box.media-box--state-published .state-border, .mlist-view .media-box.media-box--state-corrected .state-border, .compact-view .media-box.media-box--state-published .state-border, .compact-view .media-box.media-box--state-corrected .state-border {\n        background: #5e8d32; }\n    .mlist-view .media-box.media-box--state-killed, .compact-view .media-box.media-box--state-killed {\n      background: #fff9f8; }\n      .mlist-view .media-box.media-box--state-killed .state-border, .compact-view .media-box.media-box--state-killed .state-border {\n        background: #303030; }\n\n.more-activity-menu.dropdown__menu {\n  margin: 8px 0;\n  z-index: 99999; }\n  .more-activity-menu.dropdown__menu:before {\n    display: none; }\n  .more-activity-menu.dropdown__menu li {\n    width: 100%; }\n\n.mgrid-view .active:not(.selected) .media-box {\n  border-color: #787878;\n  box-shadow: 0 0px 6px 1px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(0, 0, 0, 0.12); }\n\n.mlist-view .active:not(.selected) .more-activity-toggle, .compact-view .active:not(.selected) .more-activity-toggle {\n  background: linear-gradient(to right, rgba(239, 247, 250, 0) 0%, rgba(239, 247, 250, 0) 0%, #eff7fa 40%) !important; }\n\n.mlist-view .active:not(.selected) .media-box, .compact-view .active:not(.selected) .media-box {\n  background-color: #c8e4ee !important;\n  border-right: 2px solid rgba(94, 169, 200, 0.75) !important; }\n  .mlist-view .active:not(.selected) .media-box:hover .more-activity-toggle, .compact-view .active:not(.selected) .media-box:hover .more-activity-toggle {\n    background: linear-gradient(to right, rgba(239, 247, 250, 0) 0%, rgba(239, 247, 250, 0) 0%, #eff7fa 40%) !important; }\n  .mlist-view .active:not(.selected) .media-box:hover .item-functions, .compact-view .active:not(.selected) .media-box:hover .item-functions {\n    background-color: #eff7fa; }\n    .mlist-view .active:not(.selected) .media-box:hover .item-functions .item-field:hover, .compact-view .active:not(.selected) .media-box:hover .item-functions .item-field:hover {\n      background-color: #d6e8ef; }\n    .mlist-view .active:not(.selected) .media-box:hover .item-functions .item-field.disabled:hover, .compact-view .active:not(.selected) .media-box:hover .item-functions .item-field.disabled:hover {\n      background-color: #d6e8ef; }\n\n.mlist-view .selected .media-box, .compact-view .selected .media-box {\n  background-color: #e3f1f6; }\n  .mlist-view .selected .media-box:hover, .compact-view .selected .media-box:hover {\n    background-color: rgba(239, 247, 250, 0.6) !important; }\n\n/*modal window*/\n.modal-body .row-fluid .span6 figure {\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  max-width: 379px;\n  height: auto;\n  max-height: 250px; }\n\n.modal-body .row-fluid .span6 dl {\n  font-size: 13px;\n  color: #777;\n  position: relative;\n  height: auto;\n  margin: 0; }\n  .modal-body .row-fluid .span6 dl dt {\n    width: 110px;\n    float: left;\n    clear: left;\n    font-weight: normal;\n    color: #474747;\n    margin-bottom: 5px;\n    line-height: 16px;\n    vertical-align: middle; }\n  .modal-body .row-fluid .span6 dl dt:after {\n    content: \":\"; }\n  .modal-body .row-fluid .span6 dl dd {\n    width: 245px;\n    max-width: 245px;\n    float: left;\n    margin-left: 0px;\n    line-height: 16px;\n    margin-bottom: 5px;\n    vertical-align: middle; }\n  .modal-body .row-fluid .span6 dl.line-borders {\n    width: 379px;\n    border-top: 1px solid #e8e8e8;\n    margin-top: 15px; }\n    .modal-body .row-fluid .span6 dl.line-borders dt {\n      border-bottom: 1px solid #e8e8e8;\n      vertical-align: top;\n      line-height: 20px;\n      margin-bottom: 0px; }\n    .modal-body .row-fluid .span6 dl.line-borders dd {\n      padding-right: 24px;\n      border-bottom: 1px solid #e8e8e8;\n      vertical-align: top;\n      line-height: 20px;\n      margin-bottom: 0px; }\n\n.metadata-language {\n  height: 38px;\n  position: relative;\n  z-index: 10; }\n\n.metadata-details {\n  max-height: 350px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 5px; }\n  .metadata-details input, .metadata-details textarea {\n    border-color: #e0e0e0 !important;\n    color: #585858; }\n    .metadata-details input:focus, .metadata-details textarea:focus {\n      border-color: rgba(82, 168, 236, 0.8) !important;\n      color: #000; }\n\n.edit-metadata-select {\n  margin-top: 2px;\n  height: 26px; }\n\n.modal-header button.close {\n  padding: 0;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  -webkit-appearance: none; }\n  .modal-header button.close:hover {\n    color: #b3b3b3; }\n\n.btn.pull-right {\n  margin-left: 10px; }\n\n.meta-description-text {\n  height: 52px;\n  max-width: 245px; }\n\n.close:hover {\n  color: #b3b3b3; }\n\n/* uploads grid used for upload popup */\n.uploads-grid {\n  list-style-type: none;\n  margin: 60px 0 0;\n  padding: 0;\n  top: 0;\n  bottom: 0;\n  overflow: scroll;\n  position: absolute; }\n  .uploads-grid li {\n    max-height: 100px;\n    float: left;\n    margin: 0 15px 15px 0;\n    padding: 3px;\n    border: 1px solid #d0d0d0;\n    position: relative; }\n    .uploads-grid li .add-button {\n      position: absolute;\n      background-color: #0079cc;\n      left: 3px;\n      top: 3px;\n      width: 16px;\n      height: 18px;\n      padding: 4px;\n      display: none; }\n    .uploads-grid li:hover {\n      background: #0079cc;\n      border-color: #2d95dd;\n      cursor: pointer;\n      box-shadow: 0px 0px 3px #a0a0a0; }\n      .uploads-grid li:hover .add-button {\n        display: block !important; }\n    .uploads-grid li.grid-selected {\n      background: #0079cc;\n      border-color: #2d95dd; }\n    .uploads-grid li img {\n      height: 100px;\n      max-height: 100px; }\n\n.cropItems {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));\n  grid-gap: 1.6rem;\n  margin: 1rem 0;\n  padding-bottom: 2.5rem;\n  border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n  .cropItems .cropItems__item {\n    text-align: center;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.16);\n    display: flex;\n    flex-direction: column; }\n    .cropItems .cropItems__item img {\n      display: block; }\n    .cropItems .cropItems__item figure {\n      display: block;\n      margin: 0; }\n  .cropItems .cropItems__item-rendition {\n    flex-grow: 1;\n    background-color: rgba(0, 0, 0, 0.75);\n    display: flex;\n    align-items: center; }\n  .cropItems .cropItems__item-label {\n    display: block;\n    padding: 0.6rem 0;\n    opacity: 0.7;\n    font-family: 'Roboto';\n    font-size: 1.3rem;\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.item-right {\n  width: 48px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding: 0;\n  background: transparent;\n  z-index: 3; }\n  .item-right .more-activity-dropdown {\n    position: relative;\n    width: 100%;\n    height: 100%; }\n    .item-right .more-activity-dropdown .submenu {\n      overflow: hidden;\n      display: block; }\n    .item-right .more-activity-dropdown.open i {\n      opacity: 1; }\n\n.more-activity-toggle {\n  position: absolute;\n  width: 100%;\n  max-width: 60px;\n  height: 100%;\n  right: 0;\n  top: 0;\n  text-align: center;\n  vertical-align: middle;\n  border: none;\n  background: none;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 0%, white 40%); }\n  .more-activity-toggle i {\n    opacity: 0.4;\n    margin-right: -14px; }\n  .more-activity-toggle:hover i {\n    opacity: 1; }\n\n.content-item-preview .more-activity-toggle {\n  background: transparent;\n  padding: 14px;\n  z-index: 2;\n  min-height: 40px; }\n\n.list-item-view.sd-list-item-nested {\n  margin-top: 0; }\n\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.composite-preview .toggle-box {\n  margin-bottom: 20px; }\n  .composite-preview .toggle-box header:before {\n    left: 45px; }\n  .composite-preview .toggle-box header .box-icon {\n    display: none; }\n  .composite-preview .toggle-box header h6 {\n    background: #fff;\n    padding-left: 0; }\n  .composite-preview .toggle-box header .chevron {\n    background-color: #fff; }\n\n.composite-preview .picture figure, .composite-preview .graphic figure {\n  width: 100%; }\n  .composite-preview .picture figure img, .composite-preview .graphic figure img {\n    max-width: 100%;\n    height: auto; }\n\n.composite-preview .picture .item-headline, .composite-preview .graphic .item-headline {\n  max-height: 74px;\n  overflow: hidden; }\n\n.composite-preview .video .holder {\n  line-height: 80px;\n  text-align: center; }\n  .composite-preview .video .holder i {\n    vertical-align: middle;\n    opacity: 0.5;\n    filter: \"alpha(opacity=50)\"; }\n\n.composite-preview .video .item-headline {\n  max-height: 74px;\n  overflow: hidden; }\n\n.composite-preview .audio .holder {\n  background: #fff;\n  width: 100%;\n  height: auto; }\n\n.wrap {\n  white-space: pre-wrap; }\n\n.content-item-preview .item-locked {\n  box-sizing: border-box;\n  border-radius: 14px;\n  height: 28px;\n  line-height: 24px;\n  margin: 4px 0 20px 0; }\n  .content-item-preview .item-locked .lock-sign {\n    width: 28px;\n    height: 28px;\n    min-width: 28px;\n    border-radius: 50%;\n    margin-right: 10px;\n    background: #f4cccd;\n    display: inline-block;\n    text-align: center;\n    line-height: 30px; }\n  .content-item-preview .item-locked .locked-content {\n    display: flex; }\n  .content-item-preview .item-locked em {\n    font-style: normal;\n    vertical-align: top; }\n  .content-item-preview .item-locked time {\n    position: relative;\n    top: -5px;\n    font-size: 11px;\n    color: #999;\n    padding-left: 38px;\n    display: inline-block; }\n  .content-item-preview .item-locked .text {\n    font-weight: 500;\n    color: #666;\n    flex-grow: 1;\n    margin-top: 2px;\n    padding-right: 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: #e51b22; }\n  .content-item-preview .item-locked .btn {\n    display: none;\n    border-radius: 0 14px 14px 0;\n    padding-left: 5%;\n    border-left: 1px solid #fff; }\n  .content-item-preview .item-locked:hover {\n    background: #f8f8f8; }\n    .content-item-preview .item-locked:hover .btn {\n      visibility: visible;\n      display: inline-flex; }\n\n.content-item-preview .content .content-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 0 20px 0;\n  overflow: auto; }\n  .content-item-preview .content .content-container .core-content {\n    margin-bottom: 80px; }\n\n.content-item-preview .content .date {\n  *zoom: 1; }\n  .content-item-preview .content .date:before, .content-item-preview .content .date:after {\n    display: table;\n    content: \"\"; }\n  .content-item-preview .content .date:after {\n    clear: both; }\n  .content-item-preview .content .date p {\n    float: left;\n    font-weight: 300;\n    font-size: 13px;\n    color: #a1a1a1;\n    padding-right: 10px;\n    margin-right: 10px;\n    margin-bottom: 0;\n    line-height: 28px; }\n    .content-item-preview .content .date p:first-child {\n      border-right: 1px solid #e2e2e2; }\n  .content-item-preview .content .date + li {\n    margin-top: 10px; }\n\n.content-item-preview .content .nav-space {\n  height: 48px; }\n\n.content-item-preview .content .rewrite {\n  margin-top: 15px; }\n\n.content-item-preview .content .title {\n  font-size: 19px;\n  line-height: 120%;\n  font-weight: 500;\n  margin-top: 15px;\n  margin-bottom: 20px;\n  color: #333; }\n  .content-item-preview .content .title.condensed {\n    padding-right: 15px; }\n\n.content-item-preview .content .composite-nav {\n  min-height: 24px;\n  font-size: 16px;\n  display: flex;\n  margin-top: 20px;\n  font-weight: 300; }\n  .content-item-preview .content .composite-nav i {\n    opacity: 0.5;\n    filter: \"alpha(opacity=50)\";\n    vertical-align: middle;\n    margin: 0 15px 0 0;\n    min-width: 24px;\n    max-width: 24px; }\n  .content-item-preview .content .composite-nav .title {\n    flex-grow: 1;\n    margin-top: 0; }\n  .content-item-preview .content .composite-nav span {\n    line-height: 24px; }\n\n.content-item-preview .content .preview-header + .composite-nav {\n  margin-top: 30px; }\n\n.content-item-preview .content .state-label, .content-item-preview .content .mlist-view .media-box.contacts .org-label, .mlist-view .media-box.contacts .content-item-preview .content .org-label, .content-item-preview .content .compact-view .media-box.contacts .org-label, .compact-view .media-box.contacts .content-item-preview .content .org-label, .content-item-preview .content .profile-label, .content-item-preview .content .language-label {\n  float: none; }\n\n.content-item-preview .content .core-content {\n  font-size: 14px; }\n  .content-item-preview .content .core-content .expires {\n    display: inline-block;\n    margin-bottom: 5px; }\n  .content-item-preview .content .core-content .description {\n    font-style: italic;\n    color: #656565;\n    margin-top: 15px; }\n  .content-item-preview .content .core-content .picture-preview, .content-item-preview .content .core-content .graphic-preview {\n    margin-top: 15px;\n    max-width: 100%; }\n    .content-item-preview .content .core-content .picture-preview img, .content-item-preview .content .core-content .graphic-preview img {\n      max-width: 100%;\n      height: auto; }\n    .content-item-preview .content .core-content .picture-preview.loading, .content-item-preview .content .core-content .graphic-preview.loading {\n      width: 100%;\n      height: 200px;\n      background: #f8f8f8 url(" + escape(__webpack_require__(34)) + ") center center no-repeat; }\n  .content-item-preview .content .core-content figure {\n    margin: 10px 0 8px 0; }\n  .content-item-preview .content .core-content figcaption {\n    margin: 6px 0 10px 0; }\n  .content-item-preview .content .core-content video, .content-item-preview .content .core-content audio {\n    width: 100%;\n    max-width: 100%; }\n  .content-item-preview .content .core-content .abstract {\n    margin-bottom: 14px;\n    font-size: 15px;\n    line-height: 140%; }\n  .content-item-preview .content .core-content .byline {\n    font-size: 14px;\n    line-height: 120%;\n    font-weight: 300;\n    margin-bottom: 12px; }\n  .content-item-preview .content .core-content .dateline {\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 16px; }\n  .content-item-preview .content .core-content .text.sign-off {\n    word-break: break-all; }\n  .content-item-preview .content .core-content p {\n    font-size: 15px;\n    line-height: 140%;\n    font-weight: 300;\n    word-wrap: break-word; }\n    .content-item-preview .content .core-content p.description-text {\n      font-size: 14px;\n      font-weight: 400;\n      display: inline-block; }\n  .content-item-preview .content .core-content .body-text {\n    line-height: 140%; }\n    .content-item-preview .content .core-content .body-text h1, .content-item-preview .content .core-content .body-text h2, .content-item-preview .content .core-content .body-text h3, .content-item-preview .content .core-content .body-text h4, .content-item-preview .content .core-content .body-text h5, .content-item-preview .content .core-content .body-text h6 {\n      font-size: 16px;\n      margin-bottom: 10px; }\n  .content-item-preview .content .core-content .body-footer {\n    font-size: 13px;\n    color: #ADADAD;\n    line-height: 140%;\n    margin-top: 30px; }\n  .content-item-preview .content .core-content table {\n    width: 100%;\n    border-collapse: collapse;\n    resize: both;\n    table-layout: auto;\n    border: 1px solid #dadada;\n    margin: 16px 0; }\n    .content-item-preview .content .core-content table td, .content-item-preview .content .core-content table th {\n      border: 1px solid #dadada;\n      padding: 5px 8px;\n      font-size: 14px;\n      font-weight: 300; }\n    .content-item-preview .content .core-content table th {\n      font-weight: 500;\n      text-align: left;\n      background-color: rgba(195, 195, 195, 0.2); }\n  .content-item-preview .content .core-content blockquote {\n    font-size: 14px;\n    line-height: 140%;\n    margin: 16px 0;\n    border-left: 3px solid rgba(160, 160, 160, 0.5);\n    padding: 4px 0 4px 14px;\n    font-style: italic; }\n  .content-item-preview .content .core-content .embed-block iframe {\n    width: 97%; }\n\n.content-item-preview .metadata-view,\n.content-item-preview .article-versions {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 20px 20px 50px;\n  overflow: auto; }\n\n.content-item-preview .article-versions {\n  padding-top: 10px;\n  padding-right: 10px;\n  padding-left: 10px; }\n\n.content-item-preview .related-item-view, .content-item-preview .mediaUsed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 20px 20px 50px;\n  overflow: auto; }\n  .content-item-preview .related-item-view .related-item, .content-item-preview .related-item-view .mediaUsed--Item, .content-item-preview .mediaUsed .related-item, .content-item-preview .mediaUsed .mediaUsed--Item {\n    cursor: pointer; }\n\n.content-item-preview .core-content {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-content: flex-start; }\n  .content-item-preview .core-content .media-block, .content-item-preview .core-content .embed-block {\n    margin: 2rem 0; }\n  .content-item-preview .core-content .media-block__description {\n    display: block;\n    padding: 0.5rem 0;\n    font-size: 1.3rem;\n    font-weight: 300;\n    opacity: 0.75;\n    border-bottom: 1px dotted rgba(123, 123, 123, 0.4); }\n\n.metadata-view div {\n  border-bottom: 1px solid #e5e5e5; }\n\n.metadata-view div:last-child {\n  border: 0px; }\n\n.metadata-view h4 {\n  margin-top: 10px; }\n\n.metadata-view dl {\n  *zoom: 1;\n  margin-bottom: 10px; }\n  .metadata-view dl:before, .metadata-view dl:after {\n    display: table;\n    content: \"\"; }\n  .metadata-view dl:after {\n    clear: both; }\n  .metadata-view dl > dt {\n    clear: both;\n    float: left;\n    width: 140px;\n    font-size: 11px;\n    text-transform: uppercase;\n    color: #999;\n    line-height: 20px;\n    font-weight: 500; }\n  .metadata-view dl > dd {\n    padding-left: 140px;\n    min-height: 18px;\n    margin: 0;\n    word-break: break-word; }\n    .metadata-view dl > dd div {\n      border: 0px; }\n\n.related-item-view .related-item, .related-item-view .mediaUsed--Item, .mediaUsed .related-item, .mediaUsed .mediaUsed--Item {\n  margin-top: 16px;\n  border-bottom: 1px solid #ebebeb;\n  padding-bottom: 16px; }\n  .related-item-view .related-item .item, .related-item-view .mediaUsed--Item .item, .mediaUsed .related-item .item, .mediaUsed .mediaUsed--Item .item {\n    margin: 5px 5px 0px 0px; }\n  .related-item-view .related-item .container, .related-item-view .mediaUsed--Item .container, .mediaUsed .related-item .container, .mediaUsed .mediaUsed--Item .container {\n    font-weight: 500;\n    color: #444;\n    margin-right: 16px; }\n  .related-item-view .related-item .keyword, .related-item-view .related-item .mgrid-view .media-box.contacts .contact-name, .mgrid-view .media-box.contacts .related-item-view .related-item .contact-name, .related-item-view .related-item .mlist-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .related-item-view .related-item .contact-name, .related-item-view .related-item .compact-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .related-item-view .related-item .contact-name, .related-item-view .mediaUsed--Item .keyword, .related-item-view .mediaUsed--Item .mgrid-view .media-box.contacts .contact-name, .mgrid-view .media-box.contacts .related-item-view .mediaUsed--Item .contact-name, .related-item-view .mediaUsed--Item .mlist-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .related-item-view .mediaUsed--Item .contact-name, .related-item-view .mediaUsed--Item .compact-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .related-item-view .mediaUsed--Item .contact-name, .mediaUsed .related-item .keyword, .mediaUsed .related-item .mgrid-view .media-box.contacts .contact-name, .mgrid-view .media-box.contacts .mediaUsed .related-item .contact-name, .mediaUsed .related-item .mlist-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .mediaUsed .related-item .contact-name, .mediaUsed .related-item .compact-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .mediaUsed .related-item .contact-name, .mediaUsed .mediaUsed--Item .keyword, .mediaUsed .mediaUsed--Item .mgrid-view .media-box.contacts .contact-name, .mgrid-view .media-box.contacts .mediaUsed .mediaUsed--Item .contact-name, .mediaUsed .mediaUsed--Item .mlist-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .mediaUsed .mediaUsed--Item .contact-name, .mediaUsed .mediaUsed--Item .compact-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .mediaUsed .mediaUsed--Item .contact-name {\n    font-weight: 500;\n    color: #216278;\n    font-size: 12px;\n    margin-right: 16px; }\n  .related-item-view .related-item .type-icon, .related-item-view .mediaUsed--Item .type-icon, .mediaUsed .related-item .type-icon, .mediaUsed .mediaUsed--Item .type-icon {\n    opacity: 0.5;\n    height: 16px;\n    width: 16px;\n    padding-left: 0;\n    margin-right: 12px; }\n  .related-item-view .related-item .headline, .related-item-view .mediaUsed--Item .headline, .mediaUsed .related-item .headline, .mediaUsed .mediaUsed--Item .headline {\n    color: #686b6c; }\n\n.related-item-view li:first-child .related-item, .related-item-view .mediaUsed--Item, .mediaUsed li:first-child .related-item, .mediaUsed .mediaUsed--Item {\n  margin-top: 6px; }\n\n/* ====================================== */\n.preview-backdrop {\n  position: absolute;\n  width: 400px;\n  top: 49px;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  opacity: 0;\n  filter: \"alpha(opacity=0)\";\n  transition: all ease 0.2s; }\n  .preview-backdrop.show {\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.context-menu {\n  position: absolute;\n  right: 400px;\n  width: 250px;\n  top: 49px;\n  bottom: 0;\n  background: #fff;\n  border-right: 1px solid #dbdbdb;\n  box-shadow: 2px 0 3px 0 #e8e8e8;\n  transition: all ease 0.3s; }\n  .context-menu.show {\n    right: 150px; }\n  .context-menu .title {\n    font-size: 17px;\n    font-weight: 300;\n    color: #333;\n    padding: 10px 15px; }\n  .context-menu .context-list {\n    padding: 10px 15px 20px; }\n    .context-menu .context-list li {\n      border: 1px solid #fff;\n      border-bottom: 1px solid #e5e5e5;\n      background: #e9f4f8;\n      padding: 6px 13px;\n      height: 21px;\n      line-height: 21px;\n      margin-bottom: 7px;\n      font-size: 14px;\n      color: #333;\n      border-radius: 2px; }\n      .context-menu .context-list li i {\n        font-style: normal;\n        color: #676565;\n        font-weight: 300; }\n      .context-menu .context-list li:hover, .context-menu .context-list li.selected {\n        background: #b3daf2;\n        border-color: #4aa8eb;\n        cursor: pointer; }\n\n/* ====================================== */\n.lightbox-preview.modal {\n  position: fixed;\n  border-radius: 0px;\n  top: 0 !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  background: #000 !important;\n  margin: 0 !important;\n  width: auto !important;\n  overflow: hidden; }\n\n.lightbox-preview .lightbox-right {\n  width: 380px;\n  position: absolute;\n  box-sizing: border-box;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: #f8f8f8;\n  padding: 15px; }\n  .lightbox-preview .lightbox-right .lightbox-title {\n    font-size: 18px;\n    font-weight: normal;\n    max-width: 100%;\n    padding-right: 40px;\n    height: 24px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .lightbox-preview .lightbox-right .lightbox-close {\n    background: none;\n    padding: 0;\n    border: 0;\n    width: 16px;\n    height: 16px;\n    display: block;\n    position: absolute;\n    right: 12px;\n    top: 14px;\n    opacity: 0.7;\n    filter: \"alpha(opacity=70)\"; }\n    .lightbox-preview .lightbox-right .lightbox-close:hover {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .lightbox-preview .lightbox-right .lightbox-modified-info {\n    color: #a9a9a9;\n    font-size: 12px;\n    display: block; }\n  .lightbox-preview .lightbox-right .lightbox-media-type {\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\";\n    float: none;\n    margin-left: -2px; }\n  .lightbox-preview .lightbox-right .urgency-label {\n    margin-top: 3px;\n    margin-right: 5px; }\n  .lightbox-preview .lightbox-right .status-label {\n    margin-top: 4px; }\n  .lightbox-preview .lightbox-right .lightbox-actions {\n    margin-top: 10px; }\n    .lightbox-preview .lightbox-right .lightbox-actions i {\n      margin-right: 5px; }\n      .lightbox-preview .lightbox-right .lightbox-actions i.icon-archive {\n        margin-top: 0; }\n  .lightbox-preview .lightbox-right .lightbox-media-data {\n    position: absolute;\n    top: 130px;\n    left: 15px;\n    right: 5px;\n    bottom: 15px;\n    overflow: auto;\n    padding-right: 10px; }\n  .lightbox-preview .lightbox-right .lightbox-descritpion {\n    width: 100%;\n    margin-top: 10px;\n    color: #484848; }\n  .lightbox-preview .lightbox-right .toggle-box {\n    margin: 20px 0; }\n\n.lightbox-preview .lightbox-left {\n  background: #101010;\n  position: absolute;\n  box-sizing: border-box;\n  right: 380px;\n  top: 0;\n  bottom: 0;\n  left: 0; }\n  .lightbox-preview .lightbox-left .full-preview {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    text-align: center; }\n    .lightbox-preview .lightbox-left .full-preview > .rendition {\n      position: absolute;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      left: 0; }\n      .lightbox-preview .lightbox-left .full-preview > .rendition > figure {\n        position: absolute;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        display: flex;\n        justify-content: space-around;\n        align-items: center; }\n      .lightbox-preview .lightbox-left .full-preview > .rendition img {\n        max-width: 100%;\n        max-height: 100%;\n        height: auto !important; }\n    .lightbox-preview .lightbox-left .full-preview.composite {\n      padding: 20px 20px 40px;\n      overflow: auto; }\n      .lightbox-preview .lightbox-left .full-preview.composite::-webkit-scrollbar {\n        width: 16px;\n        border-left: 1px solid #282828;\n        background: #000;\n        border-right: 1px solid #282828; }\n      .lightbox-preview .lightbox-left .full-preview.composite::-webkit-scrollbar-thumb {\n        border-right: 1px solid #282828;\n        border-left: 1px solid #282828;\n        background: #383838;\n        box-shadow: inset 0 0 0 2px #000; }\n      .lightbox-preview .lightbox-left .full-preview.composite .item {\n        position: relative;\n        float: left;\n        width: 220px;\n        height: 150px;\n        border-radius: 3px;\n        overflow: hidden;\n        margin: 15px;\n        background: #3d3d3d;\n        box-shadow: 0 2px 0 0 #000; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item .icons-holder i {\n          margin: -12px 0 0 -12px;\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\"; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item .item-headline {\n          padding: 15px;\n          text-align: left;\n          font-size: 14px; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item.picture .item-headline, .lightbox-preview .lightbox-left .full-preview.composite .item.graphic .item-headline {\n          display: none; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item.picture img, .lightbox-preview .lightbox-left .full-preview.composite .item.graphic img {\n          height: 150px;\n          width: auto; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item.text {\n          background: #fff; }\n          .lightbox-preview .lightbox-left .full-preview.composite .item.text .icons-holder {\n            opacity: 0.5;\n            filter: \"alpha(opacity=50)\"; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item.composite .item-headline, .lightbox-preview .lightbox-left .full-preview.composite .item.audio .item-headline {\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          color: #9a9a9a;\n          text-align: center; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item .open-item {\n          display: none;\n          position: absolute;\n          right: 5px;\n          top: 5px; }\n        .lightbox-preview .lightbox-left .full-preview.composite .item:hover .open-item {\n          display: block; }\n  .lightbox-preview .lightbox-left .condensed-preview {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    left: 0; }\n  .lightbox-preview .lightbox-left.composite .condensed-preview, .lightbox-preview .lightbox-left.composite .navigation.left {\n    left: 100px; }\n  .lightbox-preview .lightbox-left.composite.open .condensed-preview, .lightbox-preview .lightbox-left.composite.open .navigation.left {\n    left: 340px; }\n  .lightbox-preview .lightbox-left .navigation {\n    position: absolute;\n    top: 50%;\n    height: 80px;\n    margin-top: -120px;\n    padding: 12px 25px;\n    border: 0;\n    background: 0; }\n    .lightbox-preview .lightbox-left .navigation.left {\n      left: 0; }\n    .lightbox-preview .lightbox-left .navigation.right {\n      right: 0;\n      left: auto; }\n    .lightbox-preview .lightbox-left .navigation i {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n    .lightbox-preview .lightbox-left .navigation:hover i {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .lightbox-preview .lightbox-left .lightbox-caption {\n    background: rgba(0, 0, 0, 0.7);\n    color: #fff;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 10px 20px;\n    text-align: center;\n    font-size: 14px;\n    line-height: 20px;\n    box-sizing: border-box; }\n  .lightbox-preview .lightbox-left .lightbox-paper {\n    position: absolute;\n    top: 50px;\n    left: 50px;\n    right: 50px;\n    bottom: 50px; }\n    .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text {\n      background: #fff;\n      max-width: 800px;\n      margin: 0px auto;\n      height: 100%;\n      position: relative;\n      border-radius: 5px; }\n      .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text .lightbox-title {\n        position: absolute;\n        top: 20px;\n        left: 20px;\n        right: 20px;\n        height: 55px;\n        font-size: 18px;\n        line-height: 24px;\n        border-bottom: 5px solid #e0e0e0; }\n      .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text .lightbox-fulltext {\n        position: absolute;\n        top: 110px;\n        left: 30px;\n        right: 30px;\n        bottom: 20px;\n        overflow: auto; }\n        .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text .lightbox-fulltext small {\n          color: #777; }\n        .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text .lightbox-fulltext .lightbox-fullcontent {\n          margin: 20px 0; }\n        .lightbox-preview .lightbox-left .lightbox-paper .lightbox-text .lightbox-fulltext p {\n          font-size: 13px;\n          line-height: 20px;\n          margin-bottom: 15px; }\n  .lightbox-preview .lightbox-left .lightbox-audio, .lightbox-preview .lightbox-left .lightbox-video {\n    background: #101010;\n    margin: 50px;\n    padding: 50px 0;\n    text-align: center; }\n  .lightbox-preview .lightbox-left .full-preview.composite .icons-holder i {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin: -70px 0 0 -20px;\n    zoom: 2; }\n\n.lightbox-preview .lightbox-composite {\n  width: 100px;\n  box-sizing: border-box;\n  background: #000;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2; }\n  .lightbox-preview .lightbox-composite.open {\n    width: 340px; }\n  .lightbox-preview .lightbox-composite .toggle-composite {\n    width: 40px;\n    height: 43px;\n    position: absolute;\n    right: -40px;\n    top: 0;\n    background: rgba(0, 0, 0, 0.8);\n    line-height: 43px;\n    text-align: center;\n    opacity: 0.9;\n    filter: \"alpha(opacity=90)\"; }\n    .lightbox-preview .lightbox-composite .toggle-composite i {\n      vertical-align: middle;\n      opacity: 0.6;\n      filter: \"alpha(opacity=60)\";\n      -webkit-transform: rotate(-90deg);\n      transform: rotate(-90deg);\n      transition: all 0.2s ease; }\n    .lightbox-preview .lightbox-composite .toggle-composite:hover {\n      cursor: pointer; }\n  .lightbox-preview .lightbox-composite.open .toggle-composite i {\n    -webkit-transform: rotate(90deg);\n    transform: rotate(90deg); }\n  .lightbox-preview .lightbox-composite .header {\n    background: #1e353f; }\n    .lightbox-preview .lightbox-composite .header h5 {\n      display: none; }\n    .lightbox-preview .lightbox-composite .header span {\n      display: block;\n      height: 43px;\n      text-align: center; }\n      .lightbox-preview .lightbox-composite .header span i {\n        margin-top: 8px;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n  .lightbox-preview .lightbox-composite.open .header {\n    height: 43px;\n    background: #223d49; }\n    .lightbox-preview .lightbox-composite.open .header h5 {\n      color: #fff;\n      font-size: 15px;\n      line-height: 43px;\n      height: 43px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      padding: 0 20px 0 10px;\n      display: block;\n      cursor: pointer; }\n    .lightbox-preview .lightbox-composite.open .header span {\n      float: left;\n      width: 50px;\n      display: inline-block;\n      background: #62b0d0; }\n      .lightbox-preview .lightbox-composite.open .header span i {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n      .lightbox-preview .lightbox-composite.open .header span:hover {\n        cursor: pointer; }\n  .lightbox-preview .lightbox-composite > .content {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 43px;\n    bottom: 0;\n    overflow: auto; }\n    .lightbox-preview .lightbox-composite > .content::-webkit-scrollbar {\n      width: 16px;\n      border-left: 1px solid #282828;\n      background: #000;\n      border-right: 1px solid #282828; }\n    .lightbox-preview .lightbox-composite > .content::-webkit-scrollbar-thumb {\n      border-right: 1px solid #282828;\n      border-left: 1px solid #282828;\n      background: #383838;\n      box-shadow: inset 0 0 0 2px #000; }\n  .lightbox-preview .lightbox-composite ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    margin-top: 10px; }\n    .lightbox-preview .lightbox-composite ul .item {\n      border-bottom: 1px solid #272727;\n      height: 40px;\n      padding: 20px;\n      position: relative; }\n      .lightbox-preview .lightbox-composite ul .item:hover {\n        cursor: pointer;\n        background: rgba(98, 176, 208, 0.2); }\n      .lightbox-preview .lightbox-composite ul .item.selected {\n        padding-left: 17px;\n        border-left: 3px solid #62b0d0;\n        background: rgba(98, 176, 208, 0.4); }\n      .lightbox-preview .lightbox-composite ul .item .holder, .lightbox-preview .lightbox-composite ul .item .icons-holder {\n        float: left;\n        width: 60px;\n        height: 40px;\n        margin-right: 20px;\n        background: #3d3d3d;\n        border-radius: 2px;\n        border: 1px solid #3d3d3d;\n        overflow: hidden;\n        text-align: center;\n        box-sizing: border-box; }\n        .lightbox-preview .lightbox-composite ul .item .holder i, .lightbox-preview .lightbox-composite ul .item .icons-holder i {\n          margin-top: 7px; }\n      .lightbox-preview .lightbox-composite ul .item .item-headline {\n        height: 40px;\n        overflow: hidden;\n        color: #dedede;\n        text-transform: none;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 21px; }\n      .lightbox-preview .lightbox-composite ul .item .open-item {\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        display: none;\n        background: #888;\n        padding: 2px 2px 2px 4px; }\n      .lightbox-preview .lightbox-composite ul .item:hover .open-item {\n        display: block; }\n      .lightbox-preview .lightbox-composite ul .item.composite {\n        padding-right: 35px; }\n        .lightbox-preview .lightbox-composite ul .item.composite .package-details {\n          position: absolute;\n          top: 50%;\n          right: 5px;\n          margin-top: -7px; }\n    .lightbox-preview .lightbox-composite ul .toggle-box > header {\n      margin-left: 5px;\n      background: #223d49;\n      margin-bottom: 0; }\n      .lightbox-preview .lightbox-composite ul .toggle-box > header:before {\n        display: none; }\n      .lightbox-preview .lightbox-composite ul .toggle-box > header h6 {\n        background: #223d49;\n        color: #fff; }\n  .lightbox-preview .lightbox-composite.open ul .toggle-box > header {\n    background: #000;\n    border: 0; }\n    .lightbox-preview .lightbox-composite.open ul .toggle-box > header:before {\n      display: block;\n      border-bottom-color: #223d49; }\n    .lightbox-preview .lightbox-composite.open ul .toggle-box > header h6 {\n      background: #000;\n      color: #fff;\n      padding-right: 10px; }\n  .lightbox-preview .lightbox-composite.open ul .item.composite .package-details {\n    display: block; }\n\n.lightbox-preview .lightbox-mosaic {\n  padding: 200px; }\n  .lightbox-preview .lightbox-mosaic li {\n    width: 220px;\n    height: 150px;\n    float: left;\n    margin: 0 30px 30px 0;\n    border-radius: 3px;\n    overflow: hidden;\n    background: #333; }\n\n.lightbox-preview .preview-overlay {\n  display: none; }\n\n.preview-header {\n  position: relative;\n  margin: 1px -20px 20px;\n  padding: 5px 20px 12px 20px;\n  border-top: 0;\n  border-bottom: 0;\n  z-index: 2;\n  box-sizing: border-box;\n  box-shadow: 0px 1px 3px -1px rgba(0, 0, 0, 0.2);\n  max-height: 45px;\n  transition: max-height 0.3s ease-in; }\n  .preview-header.active {\n    transition: max-height 0.3s ease-in;\n    max-height: 200px; }\n    .preview-header.active .preview-header__flex-container {\n      display: flex;\n      padding: 8px 0;\n      height: auto;\n      opacity: 1; }\n    .preview-header.active .preview-header__timestamp {\n      padding-bottom: 8px; }\n  .preview-header .preview-header__toggle {\n    position: absolute;\n    width: 21px;\n    height: 21px;\n    border: 0;\n    padding: 0;\n    left: 50%;\n    margin-left: -10.5px;\n    bottom: -11px;\n    background-color: #fff;\n    z-index: 3;\n    line-height: 0;\n    border-radius: 50%;\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.4);\n    transition: transform 0.5s; }\n    .preview-header .preview-header__toggle i {\n      height: 15px; }\n    .preview-header .preview-header__toggle.active {\n      -webkit-transform: rotate(180deg);\n      transform: rotate(180deg); }\n  .preview-header .preview-header__timestamp {\n    padding: 8px 16px 2px 0;\n    display: flex;\n    white-space: nowrap;\n    overflow: hidden; }\n    .preview-header .preview-header__timestamp label, .preview-header .preview-header__timestamp time {\n      display: inline-block;\n      vertical-align: top;\n      font-size: 11px;\n      color: #ababab;\n      padding-right: .4em;\n      margin: 0;\n      font-weight: 300; }\n    .preview-header .preview-header__timestamp b {\n      color: #333;\n      font-size: 11px;\n      font-weight: 400;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden; }\n  .preview-header .preview-header__border-block {\n    margin-left: 8px;\n    padding-left: 8px;\n    border-left: 1px solid #e2e2e2; }\n  .preview-header .preview-header__flex-container {\n    height: 0;\n    padding: 0;\n    overflow: hidden;\n    opacity: 0;\n    transition: opacity 0.3s 0.4s;\n    box-sizing: border-box; }\n  .preview-header .preview-header__icon-block {\n    width: 25px;\n    padding-right: 8px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column; }\n    .preview-header .preview-header__icon-block [class*=filetype-icon-],\n    .preview-header .preview-header__icon-block [class^=filetype-icon-] {\n      color: #999; }\n  .preview-header .preview-header__main-block,\n  .preview-header .preview-header__side-block {\n    box-sizing: border-box;\n    padding-left: 12px;\n    border-left: 1px solid #e2e2e2;\n    text-align: right; }\n  .preview-header .preview-header__main-block {\n    flex-grow: 1;\n    padding-right: 12px;\n    text-align: left;\n    overflow: hidden; }\n  .preview-header .preview-header__flex-row {\n    min-height: 18px;\n    margin-bottom: 4px;\n    overflow: hidden; }\n  .preview-header .keyword, .preview-header .mgrid-view .media-box.contacts .contact-name, .mgrid-view .media-box.contacts .preview-header .contact-name, .preview-header .mlist-view .media-box.contacts .contact-name, .mlist-view .media-box.contacts .preview-header .contact-name, .preview-header .compact-view .media-box.contacts .contact-name, .compact-view .media-box.contacts .preview-header .contact-name {\n    font-size: 12px;\n    font-weight: 500;\n    display: inline-block;\n    line-height: 116.6%;\n    color: #216278;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%;\n    overflow: hidden; }\n  .preview-header .word-count {\n    font-size: 10px;\n    line-height: 16px;\n    min-width: 0;\n    margin: 0;\n    color: silver;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .preview-header .word-count b {\n      font-size: 12px;\n      line-height: 12px;\n      color: #565656;\n      padding-right: .2em; }\n  .preview-header .data {\n    font-size: 12px;\n    color: #686868; }\n  .preview-header .inline-label {\n    display: inline;\n    text-transform: uppercase;\n    font-size: 11px;\n    margin: 0 6px 0 0;\n    color: silver;\n    line-height: 116.6%; }\n  .preview-header .takekey, .preview-header company-codes {\n    display: inline;\n    font-size: 12px;\n    color: #333;\n    line-height: 116.6%; }\n  .preview-header .ednote {\n    display: inline;\n    font-size: 12px;\n    color: #d25932;\n    line-height: 116.6%; }\n  .preview-header .stage {\n    font-size: 10px;\n    font-weight: 300;\n    letter-spacing: 0.035em;\n    line-height: 29px;\n    color: #666;\n    border: 0;\n    background-color: transparent;\n    text-transform: uppercase;\n    display: inline-block;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n    .preview-header .stage b {\n      color: #333;\n      font-weight: 500; }\n\nfigure.preview-overlay-on {\n  position: relative;\n  display: inline-block; }\n  figure.preview-overlay-on:hover .preview-overlay {\n    opacity: 1;\n    transition: opacity 0.2s;\n    cursor: pointer; }\n\n.preview-overlay {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  margin-top: 0;\n  opacity: 0;\n  transition: opacity 0.2s; }\n  .preview-overlay i {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -16px;\n    margin-left: -16px;\n    color: rgba(255, 255, 255, 0.9);\n    width: 32px;\n    height: 32px;\n    font-size: 32px;\n    line-height: 32px; }\n\n.featuremedia-confirmation .picture-preview > div {\n  margin-top: auto;\n  margin-bottom: auto;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7); }\n\n.featuremedia-confirmation .picture-preview img {\n  max-width: 440px;\n  max-height: 440px;\n  object-fit: contain; }\n\n.featuremedia-confirmation .picture-preview .description-text {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: italic;\n  display: inline-block;\n  word-wrap: break-word;\n  margin-top: 0.7rem; }\n\n/* END OF LIGHTBOX PREVIEW */\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n@keyframes dropOut {\n  0% {\n    transform: translateY(-43px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight {\n  0% {\n    transform: translateX(20px);\n    opacity: 0; }\n  50% {\n    transform: translateX(20px);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes slideInFromRight {\n  0% {\n    transform: translateX(400px); }\n  100% {\n    transform: translateX(0); } }\n\n@keyframes appearFromBottomLeft {\n  0% {\n    transform: translateY(900px);\n    opacity: 0; }\n  100% {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@keyframes appearFromRight2 {\n  0% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  50% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  100% {\n    transform: translateX(0) rotate(0deg);\n    opacity: 1; } }\n\n@keyframes dropOut2 {\n  0% {\n    transform: translateY(-48px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes fadeIn3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n.archive-sidebar {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0;\n  width: 300px;\n  box-sizing: border-box;\n  background-color: #ededed;\n  box-shadow: inset -1px 0px 6px 0px rgba(0, 0, 0, 0.1);\n  transition: left 0.2s ease;\n  border-right: 2px solid #bbb;\n  z-index: 10; }\n  .archive-sidebar .header {\n    height: 48px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 1px 0 rgba(0, 0, 0, 0.06);\n    background-color: #f4f4f4;\n    position: relative;\n    z-index: 4; }\n    .archive-sidebar .header .icon {\n      width: 48px;\n      height: 48px;\n      float: left;\n      text-align: center;\n      line-height: 54px;\n      cursor: pointer;\n      opacity: 0.8;\n      filter: \"alpha(opacity=80)\"; }\n    .archive-sidebar .header ul {\n      float: left;\n      padding-left: 5px; }\n      .archive-sidebar .header ul li {\n        float: left;\n        height: 48px;\n        box-sizing: border-box;\n        margin: 0 15px;\n        line-height: 48px;\n        font-size: 14px;\n        opacity: 0.7;\n        filter: \"alpha(opacity=70)\"; }\n        .archive-sidebar .header ul li:hover {\n          cursor: pointer;\n          border-bottom: 3px solid #bbb; }\n        .archive-sidebar .header ul li.active {\n          border-bottom: 3px solid #5ea9c8;\n          opacity: 1;\n          filter: \"alpha(opacity=100)\"; }\n    .archive-sidebar .header .doopen {\n      position: absolute;\n      top: 16px;\n      right: 8px;\n      padding-left: 10px;\n      padding-right: 10px;\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n      .archive-sidebar .header .doopen:hover {\n        cursor: pointer;\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n  .archive-sidebar .content {\n    position: absolute;\n    top: 48px;\n    left: 0px;\n    bottom: 0px;\n    right: 0px;\n    padding: 20px;\n    overflow: auto;\n    padding-bottom: 80px; }\n    .archive-sidebar .content.pull {\n      bottom: 60px; }\n    .archive-sidebar .content.pull-heigher {\n      bottom: 120px; }\n    .archive-sidebar .content .sd-check__wrapper {\n      margin-left: 0; }\n    .archive-sidebar .content .superdeskRepos {\n      margin-bottom: 2rem; }\n  .archive-sidebar .tab-box {\n    margin: 0 -20px 0 -20px;\n    position: sticky;\n    top: -20px;\n    background-color: #ededed;\n    padding-bottom: 0.4rem;\n    z-index: 3; }\n  .archive-sidebar .edit-search {\n    font-size: 15px;\n    margin: 10px -20px 15px; }\n    .archive-sidebar .edit-search fieldset {\n      padding: 0 20px; }\n  .archive-sidebar .toggle-box .toggle-box__label {\n    font-size: 12px;\n    font-weight: 500;\n    color: #666; }\n  .archive-sidebar .toggle-box.pane {\n    margin: 0 -20px; }\n    .archive-sidebar .toggle-box.pane > .toggle-content {\n      padding: 20px 15px; }\n  .archive-sidebar .toggle-box .terms {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    clear: both;\n    float: right;\n    padding-top: 10px;\n    margin-bottom: 15px;\n    *zoom: 1; }\n    .archive-sidebar .toggle-box .terms:before, .archive-sidebar .toggle-box .terms:after {\n      display: table;\n      content: \"\"; }\n    .archive-sidebar .toggle-box .terms:after {\n      clear: both; }\n    .archive-sidebar .toggle-box .terms li {\n      background: rgba(0, 0, 0, 0.06);\n      line-height: 26px;\n      height: 26px;\n      padding: 0 6px;\n      border-radius: 3px;\n      margin: 0 5px 5px 0;\n      float: left; }\n      .archive-sidebar .toggle-box .terms li i {\n        vertical-align: sub;\n        margin-left: 5px;\n        opacity: 0.4;\n        filter: \"alpha(opacity=40)\"; }\n      .archive-sidebar .toggle-box .terms li:hover {\n        cursor: pointer;\n        background: rgba(0, 0, 0, 0.1); }\n        .archive-sidebar .toggle-box .terms li:hover i {\n          opacity: 0.7;\n          filter: \"alpha(opacity=70)\"; }\n  .archive-sidebar .raw-search {\n    height: 200px; }\n  .archive-sidebar .search-within-filter {\n    position: relative;\n    margin: -19px -20px 20px -20px;\n    height: 48px; }\n    .archive-sidebar .search-within-filter input {\n      height: 48px;\n      border-width: 0 0 1px 0 !important;\n      padding-left: 15px; }\n    .archive-sidebar .search-within-filter button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      height: 48px;\n      width: 33px;\n      border: 0;\n      background: none; }\n      .archive-sidebar .search-within-filter button i {\n        width: 18px;\n        background-repeat: no-repeat;\n        margin-top: 5px; }\n  .archive-sidebar .search-filters {\n    position: relative;\n    margin: 1px 0px 20px;\n    height: 48px; }\n    .archive-sidebar .search-filters input {\n      height: 48px;\n      border-width: 0 0 1px 0 !important;\n      padding-left: 15px; }\n    .archive-sidebar .search-filters button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      height: 48px;\n      width: 33px;\n      border: 0;\n      background: none; }\n      .archive-sidebar .search-filters button i {\n        width: 18px;\n        background-repeat: no-repeat;\n        margin-top: 5px; }\n  .archive-sidebar .date-filter .predefined-dates {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 15px; }\n    .archive-sidebar .date-filter .predefined-dates > div {\n      flex: 1 1 auto;\n      padding: 4px; }\n      .archive-sidebar .date-filter .predefined-dates > div button {\n        display: block;\n        width: 100%; }\n    .archive-sidebar .date-filter .predefined-dates .btn--mini, .archive-sidebar .date-filter .predefined-dates .toggle-button {\n      min-height: 20px;\n      height: auto;\n      margin-right: 4px;\n      flex-grow: 1; }\n      .archive-sidebar .date-filter .predefined-dates .btn--mini:last-child, .archive-sidebar .date-filter .predefined-dates .toggle-button:last-child {\n        margin-right: 0; }\n    .archive-sidebar .date-filter .predefined-dates .toggle-button {\n      padding: 5px;\n      line-height: 130%;\n      font-size: 11px;\n      font-weight: 500; }\n  .archive-sidebar .date-filter .datepicker-input {\n    min-width: initial; }\n  .archive-sidebar .date-filter fieldset .multiple .field {\n    padding-right: 10px; }\n    .archive-sidebar .date-filter fieldset .multiple .field:last-child {\n      padding: 0; }\n  .archive-sidebar .views {\n    padding: 0; }\n    .archive-sidebar .views .header {\n      padding: 10px; }\n    .archive-sidebar .views .list {\n      top: 48px;\n      position: absolute;\n      left: 0;\n      right: 0;\n      overflow: auto; }\n      .archive-sidebar .views .list ul > li {\n        display: block;\n        box-sizing: border-box;\n        padding: 10px 15px 10px 20px;\n        border-bottom: 1px solid #ddd;\n        overflow: hidden;\n        position: relative; }\n        .archive-sidebar .views .list ul > li .search-item {\n          width: 80%; }\n          .archive-sidebar .views .list ul > li .search-item i {\n            color: #999;\n            font-weight: 400; }\n          .archive-sidebar .views .list ul > li .search-item .search-name {\n            font-weight: 500; }\n          .archive-sidebar .views .list ul > li .search-item .search-description {\n            font-size: 12px;\n            color: #999; }\n        .archive-sidebar .views .list ul > li .search-button {\n          position: absolute;\n          right: 6px;\n          top: 8px; }\n        .archive-sidebar .views .list ul > li .delete, .archive-sidebar .views .list ul > li .edit {\n          border: 0;\n          background: 0;\n          display: none;\n          opacity: 0.4; }\n          .archive-sidebar .views .list ul > li .delete:hover, .archive-sidebar .views .list ul > li .edit:hover {\n            opacity: 1; }\n        .archive-sidebar .views .list ul > li:hover {\n          cursor: pointer;\n          background: #f8f8f8; }\n          .archive-sidebar .views .list ul > li:hover .delete {\n            display: inline-block; }\n        .archive-sidebar .views .list ul > li.active {\n          background: #eff7fa; }\n        .archive-sidebar .views .list ul > li:first-child {\n          border-top: 1px solid #ddd; }\n    .archive-sidebar .views .edit-saved-searches {\n      position: absolute;\n      margin-left: 0px; }\n      .archive-sidebar .views .edit-saved-searches .content {\n        position: static;\n        padding: 0; }\n\n.filter-box .filter-box__item {\n  display: flex;\n  margin-bottom: 2px;\n  border-radius: 2px;\n  padding: 4px 4px 4px 5px;\n  line-height: 100%;\n  background-color: transparent;\n  transition: background-color ease-in-out 0.2s; }\n  .filter-box .filter-box__item button {\n    border: 0;\n    background: none;\n    display: block;\n    width: 100%;\n    padding: 0;\n    color: #666;\n    text-align: left;\n    height: 22px;\n    line-height: 22px;\n    font-size: 12px; }\n  .filter-box .filter-box__item .filter-box__hover-box {\n    height: 1.6rem;\n    width: 1.6rem;\n    flex-shrink: 0;\n    flex-grow: 0;\n    position: relative;\n    margin-right: 0.8rem; }\n    .filter-box .filter-box__item .filter-box__hover-box:hover i[class*=\"filetype-icon-\"] {\n      visibility: hidden; }\n    .filter-box .filter-box__item .filter-box__hover-box:hover .sd-checkbox {\n      visibility: visible; }\n    .filter-box .filter-box__item .filter-box__hover-box .sd-checkbox {\n      position: absolute;\n      left: 0;\n      top: 0;\n      visibility: hidden; }\n  .filter-box .filter-box__item.checked .sd-checkbox {\n    visibility: visible; }\n  .filter-box .filter-box__item [class*=\"filetype-icon-\"] {\n    color: #666; }\n  .filter-box .filter-box__item:hover {\n    cursor: pointer;\n    background-color: rgba(0, 0, 0, 0.1); }\n    .filter-box .filter-box__item:hover .filter-box__negate-filter {\n      opacity: 0.6;\n      transition: all ease-in-out 0.2s; }\n      .filter-box .filter-box__item:hover .filter-box__negate-filter:hover {\n        opacity: 1; }\n      .filter-box .filter-box__item:hover .filter-box__negate-filter:active {\n        color: #be1600; }\n  .filter-box .filter-box__item:active {\n    background: #ccc; }\n  .filter-box .filter-box__item .filter-box__negate-filter {\n    opacity: 0;\n    transition: all ease-in-out 0.1s; }\n\n.filter-box .filter-box__name {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n  .filter-box .filter-box__name i {\n    margin-left: 10px;\n    font-style: italic;\n    color: #747474;\n    font-weight: 300; }\n\n.filter-box .filter-box__check {\n  flex-grow: 0;\n  margin-right: 8px; }\n\n.backlink-toolbar {\n  padding: 16px 20px 0;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n  height: 48px;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  position: relative;\n  z-index: 2;\n  animation: dropOut 0.2s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1; }\n  .backlink-toolbar .backlink {\n    animation: appearFromRight 0.4s ease-out 1; }\n\n.saved-searches__group-title {\n  padding: 14px;\n  font-weight: 500;\n  line-height: 100%;\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  color: #8A8A8A; }\n\n.sidebar-open .archive-content {\n  left: 300px !important; }\n\n.save-search,\n.float-search-btn,\n.save-search-panel {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  background-color: #fff;\n  box-sizing: border-box;\n  padding: 16px 24px;\n  text-align: right;\n  box-shadow: 0 -1px 2px 0 rgba(0, 0, 0, 0.12); }\n  .save-search .search,\n  .float-search-btn .search,\n  .save-search-panel .search {\n    margin-bottom: 5px; }\n  .save-search .save-search__button-split,\n  .float-search-btn .save-search__button-split,\n  .save-search-panel .save-search__button-split {\n    display: flex;\n    align-items: center; }\n    .save-search .save-search__button-split .btn,\n    .float-search-btn .save-search__button-split .btn,\n    .save-search-panel .save-search__button-split .btn {\n      flex-basis: auto;\n      flex-grow: 1; }\n      .save-search .save-search__button-split .btn + .btn,\n      .float-search-btn .save-search__button-split .btn + .btn,\n      .save-search-panel .save-search__button-split .btn + .btn {\n        margin-left: 5px; }\n\n.save-search-panel {\n  text-align: left; }\n  .save-search-panel input {\n    margin-bottom: 10px; }\n\n.save-search-panel__title {\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 500;\n  color: #666;\n  margin-bottom: 20px; }\n\n.save-search__link {\n  display: inline-block;\n  margin-right: 32px;\n  cursor: pointer;\n  font-size: 14px; }\n  .save-search__link:hover {\n    text-decoration: underline; }\n\n.float-search-btn {\n  background-color: #f6f6f6; }\n  .float-search-btn .search {\n    margin-bottom: 0; }\n\n.float-search-btn--shift {\n  bottom: 60px; }\n\n.avatar {\n  display: block;\n  border-radius: 50%;\n  overflow: hidden;\n  background: #b9b9b9 url(" + escape(__webpack_require__(615)) + ") no-repeat;\n  width: 30px;\n  height: 30px;\n  background-size: 100%;\n  float: left; }\n  .avatar img {\n    width: 100%;\n    height: auto;\n    display: block; }\n  .avatar.no-bg {\n    background: #fff;\n    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15); }\n  .avatar.initials {\n    background-color: #005b7f;\n    background-image: none !important;\n    color: #fff;\n    text-align: center;\n    font-size: 11px;\n    line-height: 31px; }\n  .avatar.organisation {\n    background-image: url(" + escape(__webpack_require__(164)) + "); }\n\n.avatar.avatar-with-info {\n  overflow: visible;\n  position: relative; }\n  .avatar.avatar-with-info .logged-info {\n    display: block;\n    background-color: #fff;\n    height: 8px;\n    width: 8px;\n    border-radius: 50%;\n    position: absolute;\n    bottom: -1px;\n    right: -4px;\n    box-shadow: 0px 0 0 2px #fff;\n    border: 1px solid #a2c59e;\n    box-sizing: border-box; }\n  .avatar.avatar-with-info .user-image {\n    display: block;\n    border-radius: 50%;\n    overflow: hidden; }\n  .avatar.avatar-with-info.user-logged .logged-info {\n    background-color: #67b461;\n    border: 1px solid #67b461; }\n\n.avatar.small {\n  width: 24px;\n  height: 24px; }\n  .avatar.small.initials {\n    line-height: 25px;\n    font-size: 10px; }\n\n.avatar.medium {\n  width: 40px;\n  height: 40px; }\n  .avatar.medium.initials {\n    line-height: 40px;\n    font-size: 16px; }\n\n.avatar.large {\n  width: 48px;\n  height: 48px; }\n  .avatar.large.initials {\n    line-height: 48px;\n    font-size: 18px; }\n\n.avatar.big {\n  width: 64px;\n  height: 64px; }\n  .avatar.big.initials {\n    line-height: 64px;\n    font-size: 22px; }\n\n.avatar.unassigned {\n  background-color: #bababa; }\n\n.avatar.desk {\n  background-image: url(" + escape(__webpack_require__(164)) + "); }\n\n.toggle-button {\n  display: inline-block;\n  text-decoration: none;\n  border-radius: 2px;\n  box-sizing: border-box;\n  padding: 2px 10px;\n  text-decoration: none;\n  font-size: 12px;\n  background: transparent;\n  color: #5a5a5a;\n  border: 1px solid #c6c6c6;\n  height: 26px;\n  line-height: 20px;\n  margin-bottom: 4px;\n  transition: all 0.2s ease-out; }\n  .toggle-button:hover {\n    text-decoration: none;\n    color: #0e0e0e;\n    border-color: #7a7a7a;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2); }\n  .toggle-button:active {\n    box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.2);\n    border-color: #7a7a7a; }\n  .toggle-button .toggle-button__icon {\n    color: #5a5a5a;\n    line-height: 20px; }\n\n.toggle-button--active {\n  color: #fff;\n  background-color: #3d8fb1;\n  border-color: #3d8fb1;\n  border-top-color: #245569;\n  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.2); }\n  .toggle-button--active:hover {\n    color: #fff;\n    border-color: #36809e;\n    background-color: #36809e;\n    box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.2); }\n  .toggle-button--active:active {\n    box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.2);\n    border-color: #3d8fb1;\n    background-color: #5aa7c7; }\n  .toggle-button--active .toggle-button__icon {\n    color: #fff; }\n\n.toggle-button__text {\n  line-height: 22px; }\n\n.button-list {\n  overflow: hidden; }\n  .button-list .toggle-button, .button-list .btn {\n    float: left;\n    margin-right: 6px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.subnav .toggle-list .button-list {\n  white-space: nowrap;\n  max-height: 26px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.subnav .button-list .toggle-button, .subnav .button-list .btn {\n  margin-bottom: 0; }\n\n.button-list--padded {\n  padding: 11px 0 11px 20px; }\n\n.btn__check {\n  position: relative;\n  color: #fff;\n  padding: 10px 15px;\n  background: #546E7A;\n  border: none;\n  font-size: 13px;\n  border-radius: 3px; }\n  .btn__check:hover {\n    cursor: pointer;\n    background: #5e7c89; }\n  .btn__check.focus, .btn__check:focus {\n    outline: 1px solid #5ea9c8; }\n  .btn__check.active, .btn__check:active {\n    background: #78909C;\n    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.2); }\n    .btn__check.active:after, .btn__check:active:after {\n      content: \"\";\n      width: 42px;\n      position: absolute;\n      background: url(" + escape(__webpack_require__(257)) + ") no-repeat;\n      background-size: 42px;\n      background-position: 0 -2px;\n      top: 0;\n      bottom: 0;\n      right: 8px;\n      opacity: 0.16;\n      filter: \"alpha(opacity=16)\"; }\n  .btn__check.active {\n    cursor: default; }\n  .btn__check:active {\n    background: #6a8491;\n    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.2); }\n    .btn__check:active:after {\n      opacity: 0.1;\n      filter: \"alpha(opacity=10)\"; }\n  .btn__check.active:disabled {\n    opacity: 0.4; }\n  .btn__check:disabled {\n    opacity: 0.4;\n    color: rgba(255, 255, 255, 0.7); }\n    .btn__check:disabled:not(.active) {\n      background: #546E7A !important; }\n    .btn__check:disabled:hover {\n      cursor: default; }\n\n.btn-group {\n  position: relative;\n  *zoom: 1; }\n  .btn-group:before, .btn-group:after {\n    display: table;\n    content: \"\"; }\n  .btn-group:after {\n    clear: both; }\n\n.btn-group + .btn-group {\n  margin-left: 5px; }\n\n.btn-toolbar {\n  margin-top: 9px;\n  margin-bottom: 9px; }\n  .btn-toolbar .btn-group {\n    display: inline-block; }\n\n.btn-group .btn {\n  position: relative;\n  float: left;\n  margin-left: -1px;\n  border-radius: 0; }\n\n.btn-group .btn:first-child {\n  margin-left: 0;\n  border-radius: 3px 0 0 3px; }\n\n.btn-group .btn:last-child,\n.btn-group .dropdown__toggle {\n  border-radius: 0 3px 3px 0; }\n\n.btn-group .btn.large:first-child {\n  margin-left: 0;\n  border-radius: 6px 0 0 6px; }\n\n.btn-group .btn.large:last-child,\n.btn-group .large.dropdown__toggle {\n  border-radius: 0 6px 6px 0; }\n\n.btn-group .btn:hover,\n.btn-group .btn:focus,\n.btn-group .btn:active,\n.btn-group .btn.active {\n  z-index: 2; }\n\n.btn-group .dropdown__toggle:active,\n.btn-group.open .dropdown__toggle {\n  outline: 0; }\n\n.btn-group .dropdown__toggle {\n  padding-left: 8px;\n  padding-right: 8px;\n  *padding-top: 3px;\n  *padding-bottom: 3px; }\n\n.btn-group .btn--mini.dropdown__toggle {\n  padding-left: 5px;\n  padding-right: 5px;\n  *padding-top: 1px;\n  *padding-bottom: 1px; }\n\n.btn-group .btn--small.dropdown__toggle {\n  *padding-top: 4px;\n  *padding-bottom: 4px; }\n\n.btn-group .btn--large.dropdown__toggle {\n  padding-left: 12px;\n  padding-right: 12px; }\n\n.btn-group.open {\n  *z-index: 1000; }\n  .btn-group.open .dropdown__menu {\n    display: block;\n    margin-top: 1px;\n    border-radius: 5px; }\n\n.btn--primary .caret,\n.btn--danger .caret,\n.btn--success .caret,\n.btn--inverse .caret {\n  border-top-color: #fff;\n  border-bottom-color: #fff;\n  opacity: 0.75;\n  filter: \"alpha(opacity=75)\"; }\n\n.subnav__button-stack--custom-buttons .btn--custom {\n  color: #fff;\n  white-space: nowrap;\n  background-color: #666; }\n  .subnav__button-stack--custom-buttons .btn--custom:hover {\n    text-decoration: none;\n    color: #fff;\n    background-color: #404040; }\n\n.subnav__button-stack--custom-buttons .btn--publish {\n  background-color: #01579b; }\n  .subnav__button-stack--custom-buttons .btn--publish:hover {\n    background-color: #012c4f; }\n\n.subnav__button-stack--custom-buttons .btn--publish-plus {\n  background-color: #623b7a; }\n  .subnav__button-stack--custom-buttons .btn--publish-plus:hover {\n    background-color: #392246; }\n\n.alert {\n  padding: 8px 35px 8px 14px;\n  margin-bottom: 18px;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n  background-color: #fcf8e3;\n  border: 1px solid #fbeed5;\n  border-radius: 4px;\n  color: #c09853; }\n\n.alert-heading {\n  color: inherit; }\n\n.alert .close {\n  position: relative;\n  top: -2px;\n  right: -21px;\n  line-height: 18px; }\n\n.alert-success {\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  color: #468847; }\n\n.alert-danger,\n.alert-error {\n  background-color: #f2dede;\n  border-color: #eed3d7;\n  color: #b94a48; }\n\n.alert-info {\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n  color: #3a87ad; }\n\n.alert-block {\n  padding-top: 14px;\n  padding-bottom: 14px; }\n\n.alert-block > p,\n.alert-block > ul {\n  margin-bottom: 0; }\n\n.alert-block p + p {\n  margin-top: 5px; }\n\n.nav {\n  margin-left: 0;\n  list-style: none; }\n\n.nav > li > a,\n.nav > li > button {\n  display: block; }\n\n.nav > li > a:hover {\n  text-decoration: none;\n  background-color: #F5F5F5; }\n\n.nav-list {\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 0; }\n\n.nav-list > li > button {\n  border: 0;\n  background: 0; }\n\n.nav-list > li > a,\n.nav-list > li > button {\n  margin-left: -15px;\n  margin-right: -15px; }\n\n.nav-list > li > a, .nav-list > li > button {\n  padding: 3px 15px; }\n\n.nav-list > .active > a,\n.nav-list > .active > button,\n.nav-list > .active > a:hover {\n  color: #fff;\n  background-color: #5d9bc0; }\n\n.nav-list [class^=\"icon-\"] {\n  margin-right: 2px; }\n\n.nav-list .divider {\n  height: 1px;\n  margin: 8px 1px;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  border-bottom: 1px solid #fff;\n  *width: 100%;\n  *margin: -5px 0 5px; }\n\n.nav-tabs,\n.nav-pills {\n  *zoom: 1; }\n  .nav-tabs:before, .nav-tabs:after,\n  .nav-pills:before,\n  .nav-pills:after {\n    display: table;\n    content: \"\"; }\n  .nav-tabs:after,\n  .nav-pills:after {\n    clear: both; }\n\n.nav-tabs > li,\n.nav-pills > li {\n  float: left; }\n\n.nav-tabs > li > a,\n.nav-tabs > li > button,\n.nav-pills > li > a,\n.nav-pills > li > button {\n  padding-right: 12px;\n  padding-left: 12px;\n  margin-right: 2px;\n  line-height: 14px; }\n\n.nav-tabs {\n  box-sizing: border-box;\n  height: 48px; }\n  .nav-tabs > li {\n    margin-bottom: -1px; }\n\n.nav-tabs > li > a,\n.nav-tabs > li > button {\n  padding: 8px 0px;\n  margin: 0 10px;\n  line-height: 30px;\n  font-size: 14px;\n  height: 48px;\n  background: none;\n  color: #7c7c7c;\n  border: 0;\n  border-bottom: 3px solid transparent; }\n  .nav-tabs > li > a:hover,\n  .nav-tabs > li > button:hover {\n    border-bottom-color: #d8d8d8;\n    background: none;\n    text-decoration: none; }\n\n.nav-tabs > li > a {\n  box-sizing: border-box; }\n\n.nav-tabs > .active > a,\n.nav-tabs > .active > a:hover,\n.nav-tabs > .active > button,\n.nav-tabs > .active > button:hover {\n  background: none;\n  border-bottom-color: #5ea9c8;\n  cursor: default;\n  color: #333; }\n\n.nav-pills > li > a {\n  padding-top: 8px;\n  padding-bottom: 8px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  border-radius: 5px; }\n\n.nav-pills > .active > a,\n.nav-pills > .active > a:hover {\n  color: #fff;\n  background-color: #5d9bc0; }\n\n.nav-stacked > li {\n  float: none; }\n\n.nav-stacked > li > a {\n  margin-right: 0; }\n\n.nav-tabs.nav-stacked {\n  border-bottom: 0;\n  height: auto; }\n\n.nav-tabs.nav-stacked > li > a {\n  border: 1px solid #ddd;\n  border-radius: 0;\n  margin: 0; }\n\n.nav-tabs.nav-stacked > li.active a {\n  background: #fff; }\n\n.nav-tabs.nav-stacked > li:first-child > a {\n  border-radius: 4px 4px 0 0; }\n\n.nav-tabs.nav-stacked > li:last-child > a {\n  border-radius: 0 0 4px 4px; }\n\n.nav-tabs.nav-stacked > li > a:hover {\n  border-color: #ddd;\n  z-index: 2; }\n\n.nav-pills.nav-stacked > li > a {\n  margin-bottom: 3px; }\n\n.nav-pills.nav-stacked > li:last-child > a {\n  margin-bottom: 1px; }\n\n.nav-tabs .dropdown__menu,\n.nav-pills .dropdown__menu {\n  margin-top: 1px;\n  border-width: 1px; }\n\n.nav-pills .dropdown__menu {\n  border-radius: 4px; }\n\n.nav-tabs .dropdown__toggle .dropdown__caret,\n.nav-pills .dropdown__toggle .dropdown__caret {\n  border-top-color: #5d9bc0;\n  border-bottom-color: #5d9bc0;\n  margin-top: 6px; }\n\n.nav-tabs .dropdown__toggle:hover .dropdown__caret,\n.nav-pills .dropdown__toggle:hover .dropdown__caret {\n  border-top-color: #94bdd5;\n  border-bottom-color: #94bdd5; }\n\n.nav-tabs .active .dropdown__toggle .dropdown__caret,\n.nav-pills .active .dropdown__toggle .dropdown__caret {\n  border-top-color: #333;\n  border-bottom-color: #333; }\n\n.nav > .dropdown.active > a:hover {\n  color: #000;\n  cursor: pointer; }\n\n.nav-tabs .open .dropdown__toggle,\n.nav-pills .open .dropdown__toggle,\n.nav > .open.active > a:hover {\n  color: #fff;\n  background-color: #999;\n  border-color: #999; }\n\n.nav .open .dropdown__caret,\n.nav .open.active .dropdown__caret,\n.nav .open a:hover .dropdown__caret {\n  border-top-color: #fff;\n  border-bottom-color: #fff;\n  opacity: 1;\n  filter: \"alpha(opacity=100)\"; }\n\n.tabs-stacked .open > a:hover {\n  border-color: #999; }\n\n.tabbable {\n  *zoom: 1; }\n  .tabbable:before, .tabbable:after {\n    display: table;\n    content: \"\"; }\n  .tabbable:after {\n    clear: both; }\n\n.tab-content {\n  display: table;\n  width: 100%; }\n\n.tabs-below .nav-tabs,\n.tabs-right .nav-tabs,\n.tabs-left .nav-tabs {\n  border-bottom: 0; }\n\n.tab-content > .tab-pane,\n.pill-content > .pill-pane {\n  display: none; }\n\n.tab-content > .active,\n.pill-content > .active {\n  display: block; }\n\n.tabs-left .nav-tabs > li {\n  float: none; }\n\n.tabs-left .nav-tabs > li > a {\n  min-width: 74px;\n  margin-right: 0;\n  margin-bottom: 3px; }\n\n.tabs-left .nav-tabs {\n  float: left;\n  margin-right: 19px;\n  border-right: 1px solid #ddd; }\n\n.tabs-left .nav-tabs > li > a {\n  margin-right: -1px;\n  border-radius: 4px 0 0 4px; }\n\n.tabs-left .nav-tabs > li > a:hover {\n  border-color: #F5F5F5 #ddd #F5F5F5 #F5F5F5; }\n\n.tabs-left .nav-tabs .active > a,\n.tabs-left .nav-tabs .active > a:hover {\n  border-color: #ddd transparent #ddd #ddd;\n  *border-right-color: #fff; }\n\n.subnav {\n  align-items: center; }\n  .subnav--padded {\n    padding: 10px 20px; }\n\n.subnav--absolute {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  right: 0;\n  z-index: 10; }\n\n.subnav--top {\n  top: 48px; }\n\n.subnav__page-title,\n.page-nav-title {\n  padding: 10px 20px;\n  color: #444;\n  font-size: 18px;\n  line-height: 28px;\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 400; }\n  .subnav__page-title--text-light,\n  .page-nav-title--text-light {\n    font-weight: 300; }\n\n.subnav__desk-stage {\n  flex-grow: 1; }\n\n.subnav--white-background {\n  background-color: #fff; }\n\n.subnav.level2 {\n  position: absolute;\n  background: #f5f5f5;\n  top: 0;\n  left: 0 !important;\n  height: 48px;\n  z-index: 2;\n  box-shadow: none; }\n\n.monitoring .subnav .page-nav-title {\n  padding-left: 20px; }\n\n.button-stack {\n  height: 48px !important;\n  position: relative;\n  margin: 0 20px 0 0;\n  float: left; }\n  .button-stack > .btn {\n    margin-left: 20px;\n    margin-top: 10px; }\n  .button-stack.right-stack {\n    float: right;\n    margin: 0 0 0 5px; }\n    .button-stack.right-stack .navbtn {\n      border-left: 1px solid rgba(0, 0, 0, 0.1) !important;\n      border-right: 0 !important; }\n      .button-stack.right-stack .navbtn .dropdown__toggle {\n        width: 100%; }\n    .button-stack.right-stack > .btn {\n      margin-right: 12px;\n      margin-left: 0; }\n  .button-stack .dropdown [class^=\"filetype-icon-\"], .button-stack .dropdown [class*=\"filetype-icon-\"] {\n    vertical-align: middle; }\n\n.subnav__stretch-bar {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  margin: 0 16px; }\n\n.subnav__button-stack {\n  position: relative;\n  max-width: 100%; }\n  .subnav__button-stack--square-buttons {\n    height: 48px;\n    margin: 0 0 0 16px;\n    display: flex;\n    flex-wrap: nowrap;\n    flex-grow: 0;\n    flex-shrink: 1;\n    max-width: 100%; }\n  .subnav__button-stack--custom-buttons {\n    margin: 0 auto;\n    padding: 10px 12px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-width: 0 1px;\n    box-sizing: border-box;\n    display: flex;\n    max-width: 100%; }\n    .subnav__button-stack--custom-buttons .btn {\n      flex-grow: 0;\n      margin: 0 4px; }\n    .subnav__button-stack--custom-buttons .btn__text--short {\n      display: none; }\n    .subnav__button-stack--custom-buttons .btn__text {\n      display: inline; }\n\n.subnav__button-stack--custom-buttons .btn__text--short {\n  display: none; }\n\n.subnav__button-stack--custom-buttons .btn__text {\n  display: inline; }\n\n.compact .subnav__button-stack--custom-buttons .btn__text--short {\n  display: inline; }\n\n.compact .subnav__button-stack--custom-buttons .btn__text {\n  display: none; }\n\n.subnav__button-stack--default {\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n  padding: 10px 0; }\n  .subnav__button-stack--default .btn {\n    flex-grow: 0;\n    margin: 0 4px; }\n  .subnav__button-stack--default .btn--close .btn__text--alt-icon {\n    display: none; }\n  .subnav__button-stack--default .btn--close .btn__text {\n    display: inline; }\n\n.subnav__button-stack--default.compact .btn--close {\n  padding: 0 3px 0 6px; }\n  .subnav__button-stack--default.compact .btn--close .btn__text--alt-icon {\n    display: inline;\n    opacity: 0.7; }\n  .subnav__button-stack--default.compact .btn--close .btn__text {\n    display: none; }\n\n.shortcut {\n  font-style: italic;\n  opacity: 0.5; }\n\n.modal__wrapper {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto; }\n\n.modal--nested-fix .modal__content > div, .modal--nested-fix .modal__content > div > div, .modal--nested-fix .modal__content > div > div > div, .modal--nested-fix .modal__content > div > div > div > div {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto; }\n\n.modal--nested-fix .modal__content .modal__header,\n.modal--nested-fix .modal__content .modal__footer {\n  display: block; }\n\n.modal--z-index-fix {\n  z-index: 1051 !important; }\n\n.split-popup {\n  height: 400px;\n  max-height: 400px; }\n  .split-popup .sidebar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 200px;\n    border-right: 1px solid #ddd; }\n  .split-popup .main {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 200px; }\n\n.add-scheme-modal .modal__dialog {\n  max-width: 840px !important;\n  width: 100%; }\n\n.add-scheme-modal .modal__body {\n  max-width: 840px !important; }\n  .add-scheme-modal .modal__body > * {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto; }\n\n.add-scheme-modal .modal__body-header {\n  flex-shrink: 0; }\n\n.add-scheme-modal .modal__body-content {\n  padding: 0 !important; }\n\n.add-scheme-modal .nav-tabs {\n  background: #fff; }\n\n.add-scheme-modal .field {\n  clear: both;\n  float: none; }\n  .add-scheme-modal .field label {\n    display: inline-block;\n    margin-right: 6px; }\n\n.add-scheme-modal .summary {\n  margin-top: 20px; }\n  .add-scheme-modal .summary > label {\n    margin-bottom: 10px; }\n  .add-scheme-modal .summary .list-item {\n    display: block; }\n  .add-scheme-modal .summary .title {\n    font-size: 11px;\n    text-transform: none;\n    color: #333;\n    min-width: 0;\n    font-weight: 700; }\n  .add-scheme-modal .summary .field {\n    font-size: 11px; }\n\n.add-scheme-modal .action-tab .field {\n  margin-bottom: 10px; }\n\n.add-scheme-modal .action-tab label {\n  min-width: 90px; }\n\n.add-scheme-modal .btn-group .btn {\n  margin-right: 5px; }\n\n.add-scheme-modal .add {\n  position: absolute;\n  padding: 0;\n  margin-left: 10px;\n  height: 22px;\n  width: 22px;\n  border-radius: 50%;\n  line-height: 20px; }\n  .add-scheme-modal .add i {\n    margin: 0; }\n\n.add-scheme-modal .term-editor .main-list {\n  overflow: visible; }\n\n.split-view {\n  display: flex; }\n  .split-view .sidebar, .split-view .main {\n    overflow-x: hidden;\n    overflow-y: auto; }\n  .split-view .sidebar {\n    width: 250px;\n    max-width: 250px;\n    flex: 0 0 auto;\n    padding: 20px; }\n    .split-view .sidebar + .main {\n      border-left: 1px solid #e0e0e0; }\n  .split-view .main {\n    flex: 1 1 auto; }\n  .split-view .main + .main {\n    border-left: 1px solid #e0e0e0; }\n  .split-view .content {\n    padding: 2rem; }\n\n.modal--preview-article .scroll-shadow {\n  position: absolute;\n  top: 47px;\n  width: 100vw; }\n\n.modal--preview-article .modal__header {\n  padding: 0.9rem 1.5rem !important; }\n  .modal--preview-article .modal__header .btn-group button {\n    cursor: pointer;\n    background: 0 0;\n    border: 0;\n    margin-top: 2px;\n    -webkit-appearance: none; }\n    .modal--preview-article .modal__header .btn-group button [class^=\"icon-\"], .modal--preview-article .modal__header .btn-group button [class*=\" icon-\"] {\n      width: 24px;\n      height: 24px;\n      font-size: 24px;\n      line-height: 24px;\n      color: #bfbfbf; }\n      .modal--preview-article .modal__header .btn-group button [class^=\"icon-\"]:hover, .modal--preview-article .modal__header .btn-group button [class*=\" icon-\"]:hover {\n        color: #666; }\n  .modal--preview-article .modal__header .btn-group label {\n    line-height: 18px;\n    display: inline-block; }\n  .modal--preview-article .modal__header .btn {\n    margin-right: 12px; }\n  .modal--preview-article .modal__header--no-border {\n    border: 0 !important; }\n\n.modal--preview-article .preview-content {\n  width: 100%;\n  max-width: 740px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column; }\n  .modal--preview-article .preview-content .metadata {\n    margin: 30px 0 40px;\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0; }\n    .modal--preview-article .preview-content .metadata > div {\n      min-height: 24px;\n      overflow: hidden;\n      margin-bottom: 10px; }\n    .modal--preview-article .preview-content .metadata .preview-label {\n      min-width: 100px;\n      vertical-align: top; }\n    .modal--preview-article .preview-content .metadata .preview-data span {\n      font-size: 12px;\n      color: #000;\n      background-color: #f5f5f5;\n      margin-right: 3px;\n      margin-bottom: 3px;\n      padding: 3px 6px;\n      border-radius: 2px;\n      display: inline-block; }\n  .modal--preview-article .preview-content .headline {\n    min-height: 33px;\n    font-size: 28px;\n    line-height: 120%;\n    font-weight: 500;\n    padding: 0;\n    margin: 0 0 30px; }\n  .modal--preview-article .preview-content .byline {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0 0 30px; }\n  .modal--preview-article .preview-content .association {\n    margin-bottom: 40px; }\n    .modal--preview-article .preview-content .association p {\n      font-style: italic; }\n  .modal--preview-article .preview-content .body {\n    margin-bottom: 30px; }\n  .modal--preview-article .preview-content p {\n    font-size: 16px;\n    line-height: 150%;\n    font-weight: 300;\n    margin: 0 0 16px; }\n  .modal--preview-article .preview-content figure {\n    margin-bottom: 20px; }\n  .modal--preview-article .preview-content figcaption {\n    color: #999;\n    padding: 4px 0; }\n  .modal--preview-article .preview-content img {\n    max-width: 100%; }\n  .modal--preview-article .preview-content.hide-images .association p {\n    padding: 10px;\n    border: 1px solid black; }\n  .modal--preview-article .preview-content.hide-images .association i {\n    vertical-align: middle;\n    margin-right: 10px; }\n  .modal--preview-article .preview-content.hide-images figure, .modal--preview-article .preview-content.hide-images .media-block {\n    display: none !important; }\n\n.modal--about h4 {\n  font-size: 16px; }\n\n.modal--about .date-released {\n  color: #767676;\n  margin-bottom: 24px; }\n\n.modal__header--about {\n  background-color: #1eb06c;\n  padding: 15px 15px 20px 20px !important; }\n  .modal__header--about i {\n    color: white; }\n  .modal__header--about .modal__header-sd-logo {\n    background: url(" + escape(__webpack_require__(616)) + ") no-repeat 0 0;\n    width: 154px;\n    height: 48px;\n    text-indent: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    float: left; }\n\n.animate-zoom__from-bottom-left {\n  animation: appearFromBottomLeft 0.4s ease-out 1; }\n\n.animate-slide-in__from-right {\n  animation: appearFromRight2 0.6s ease-out 0s 1; }\n\n.keyboard-map h4 {\n  font-size: 16px;\n  font-weight: 400;\n  padding: 0 3px 8px 3px;\n  border-bottom: 2px solid rgba(0, 0, 0, 0.15); }\n\n.keyboard-map ul {\n  margin-bottom: 20px; }\n  .keyboard-map ul li {\n    display: flex;\n    padding: 6px 3px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.1);\n    border-width: 0 0 1px 0; }\n    .keyboard-map ul li:hover {\n      background-color: #f0f0f0; }\n    .keyboard-map ul li .keyboard-map__shortcut {\n      font-weight: 500;\n      padding: 2px 7px;\n      background-color: rgba(0, 0, 0, 0.08); }\n    .keyboard-map ul li .keyboard-map__description {\n      flex-grow: 1; }\n\n.tooltip {\n  position: absolute;\n  z-index: 1040;\n  display: block;\n  visibility: visible;\n  padding: 5px;\n  font-size: 11px;\n  opacity: 0;\n  filter: \"alpha(opacity=0)\"; }\n  .tooltip.in {\n    opacity: 0.9;\n    filter: \"alpha(opacity=90)\"; }\n  .tooltip.top {\n    margin-top: -2px; }\n  .tooltip.right {\n    margin-left: 2px; }\n  .tooltip.bottom {\n    margin-top: 2px; }\n  .tooltip.left {\n    margin-left: -2px; }\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 4px 8px;\n  color: #fff;\n  line-height: 20px;\n  text-align: center;\n  text-decoration: none;\n  background-color: #000;\n  border-radius: 1px; }\n\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0; }\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1010;\n  display: none;\n  padding: 5px; }\n  .popover.top {\n    margin-top: -5px; }\n  .popover.right {\n    margin-left: 5px; }\n  .popover.bottom {\n    margin-top: 5px; }\n  .popover.left {\n    margin-left: -5px; }\n  .popover .arrow {\n    position: absolute;\n    width: 0;\n    height: 0; }\n\n.popover-inner {\n  padding: 3px;\n  width: 280px;\n  overflow: hidden;\n  background: #000;\n  background: rgba(0, 0, 0, 0.8);\n  border-radius: 6px;\n  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3); }\n\n.popover-title {\n  padding: 9px 15px;\n  line-height: 1;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #eee;\n  border-radius: 3px 3px 0 0; }\n\n.popover-content {\n  padding: 14px;\n  background-color: #fff;\n  border-radius: 0 0 3px 3px;\n  -webkit-background-clip: padding-box;\n  -moz-background-clip: padding-box;\n  background-clip: padding-box; }\n  .popover-content p, .popover-content ul, .popover-content ol {\n    margin-bottom: 0; }\n\n@keyframes dropOut {\n  0% {\n    transform: translateY(-43px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight {\n  0% {\n    transform: translateX(20px);\n    opacity: 0; }\n  50% {\n    transform: translateX(20px);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes slideInFromRight {\n  0% {\n    transform: translateX(400px); }\n  100% {\n    transform: translateX(0); } }\n\n@keyframes appearFromBottomLeft {\n  0% {\n    transform: translateY(900px);\n    opacity: 0; }\n  100% {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@keyframes appearFromRight2 {\n  0% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  50% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  100% {\n    transform: translateX(0) rotate(0deg);\n    opacity: 1; } }\n\n@keyframes dropOut2 {\n  0% {\n    transform: translateY(-48px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes fadeIn3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n.label--lite {\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.65);\n  text-transform: uppercase; }\n\n.inline-tag-list {\n  *zoom: 1;\n  padding: 10px 0 0 0; }\n  .inline-tag-list:before, .inline-tag-list:after {\n    display: table;\n    content: \"\"; }\n  .inline-tag-list:after {\n    clear: both; }\n  .inline-tag-list li {\n    float: left; }\n    .inline-tag-list li .inline-tag {\n      line-height: 26px;\n      border-radius: 2px;\n      padding: 0px 0px 0px 8px;\n      background: #dedede;\n      color: #333;\n      margin: 0 5px 5px 0;\n      float: left; }\n      .inline-tag-list li .inline-tag.tag-prime {\n        background: #5ea9c8;\n        color: #fff; }\n      .inline-tag-list li .inline-tag.tag-darker {\n        background: #bababa; }\n      .inline-tag-list li .inline-tag span {\n        font-weight: 500;\n        margin-right: 5px;\n        text-transform: uppercase;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n      .inline-tag-list li .inline-tag button {\n        background: none;\n        border: 0;\n        float: right;\n        height: 26px;\n        margin-left: 5px;\n        padding-left: 2px;\n        border-radius: 0 3px 3px 0; }\n        .inline-tag-list li .inline-tag button i {\n          opacity: 0.3;\n          filter: \"alpha(opacity=30)\";\n          margin-top: -4px; }\n        .inline-tag-list li .inline-tag button:hover {\n          background: rgba(0, 0, 0, 0.1); }\n          .inline-tag-list li .inline-tag button:hover i {\n            opacity: 1;\n            filter: \"alpha(opacity=100)\"; }\n\n/*----------------------------------------\n  #Urgency label\n----------------------------------------*/\n.urgency-label {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 10px;\n  background: #cccccc;\n  box-sizing: border-box;\n  line-height: 17px;\n  vertical-align: top;\n  font-style: normal; }\n\n.urgency-label--0 {\n  background: #cccccc; }\n\n.urgency-label--1 {\n  background: #01405b; }\n\n.urgency-label--2 {\n  background: #005e84; }\n\n.urgency-label--3 {\n  background: #3684a4; }\n\n.urgency-label--4 {\n  background: #64a4bf; }\n\n.urgency-label--5 {\n  background: #a1c6d8; }\n\n/*----------------------------------------\n  #Priority label\n----------------------------------------*/\n.priority-label {\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 10px;\n  background: #cccccc;\n  box-sizing: border-box;\n  line-height: 17px;\n  vertical-align: top;\n  font-style: normal; }\n\n.priority-label--0 {\n  background: #cccccc; }\n\n.priority-label--1 {\n  background: #b82f00; }\n\n.priority-label--2 {\n  background: #de6237; }\n\n.priority-label--3 {\n  background: #e49c56; }\n\n.priority-label--4 {\n  background: #edc175; }\n\n.priority-label--5 {\n  background: #b6c28b; }\n\n.priority-label--6 {\n  background: #c0c9a1; }\n\n/*----------------------------------------\n  #State labels\n----------------------------------------*/\n.state-label, .mlist-view .media-box.contacts .org-label, .compact-view .media-box.contacts .org-label, .profile-label, .language-label {\n  display: inline-block;\n  line-height: 1.4rem;\n  font-size: 0.9rem;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  border-radius: 8px;\n  padding: 0 0.8rem;\n  margin-right: 1rem;\n  border: 1px solid;\n  vertical-align: middle;\n  border-color: #8c8c8c;\n  color: #8c8c8c;\n  font-weight: 500; }\n  .state-label.state_embargo, .mlist-view .media-box.contacts .state_embargo.org-label, .compact-view .media-box.contacts .state_embargo.org-label, .state_embargo.profile-label, .state_embargo.language-label {\n    border-color: #ff3381 !important;\n    color: #ff3381 !important; }\n  .state-label.state-draft, .mlist-view .media-box.contacts .state-draft.org-label, .compact-view .media-box.contacts .state-draft.org-label, .state-draft.profile-label, .state-draft.language-label {\n    border-color: #8c8c8c;\n    color: #8c8c8c; }\n  .state-label.state-ingested, .mlist-view .media-box.contacts .state-ingested.org-label, .compact-view .media-box.contacts .state-ingested.org-label, .state-ingested.profile-label, .state-ingested.language-label, .state-label.state-routed, .mlist-view .media-box.contacts .state-routed.org-label, .compact-view .media-box.contacts .state-routed.org-label, .state-routed.profile-label, .state-routed.language-label, .state-label.state-fetched, .mlist-view .media-box.contacts .state-fetched.org-label, .compact-view .media-box.contacts .state-fetched.org-label, .state-fetched.profile-label, .state-fetched.language-label {\n    border-color: #5d9bc0;\n    color: #5d9bc0; }\n  .state-label.state-submitted, .mlist-view .media-box.contacts .state-submitted.org-label, .compact-view .media-box.contacts .state-submitted.org-label, .state-submitted.profile-label, .state-submitted.language-label, .state-label.state-in_progress, .mlist-view .media-box.contacts .state-in_progress.org-label, .compact-view .media-box.contacts .state-in_progress.org-label, .state-in_progress.profile-label, .state-in_progress.language-label, .state-label.state-subbed, .mlist-view .media-box.contacts .state-subbed.org-label, .compact-view .media-box.contacts .state-subbed.org-label, .state-subbed.profile-label, .state-subbed.language-label {\n    border-color: #d2a800;\n    color: #d2a800; }\n  .state-label.state-published, .mlist-view .media-box.contacts .state-published.org-label, .compact-view .media-box.contacts .state-published.org-label, .state-published.profile-label, .state-published.language-label {\n    border-color: #5e8d32;\n    color: #5e8d32; }\n  .state-label.state-spiked, .mlist-view .media-box.contacts .state-spiked.org-label, .compact-view .media-box.contacts .state-spiked.org-label, .state-spiked.profile-label, .state-spiked.language-label, .state-label.state-recalled, .mlist-view .media-box.contacts .state-recalled.org-label, .compact-view .media-box.contacts .state-recalled.org-label, .state-recalled.profile-label, .state-recalled.language-label, .state-label.state-killed, .mlist-view .media-box.contacts .state-killed.org-label, .compact-view .media-box.contacts .state-killed.org-label, .state-killed.profile-label, .state-killed.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.state-killed, .mlist-view .media-box.contacts .state-killed.org-label, .compact-view .media-box.contacts .state-killed.org-label, .state-killed.profile-label, .state-killed.language-label {\n    border-color: #be1600;\n    color: #be1600;\n    background-color: #ffeae7; }\n  .state-label.state-on_hold, .mlist-view .media-box.contacts .state-on_hold.org-label, .compact-view .media-box.contacts .state-on_hold.org-label, .state-on_hold.profile-label, .state-on_hold.language-label, .state-label.state-scheduled, .mlist-view .media-box.contacts .state-scheduled.org-label, .compact-view .media-box.contacts .state-scheduled.org-label, .state-scheduled.profile-label, .state-scheduled.language-label {\n    border-color: #da7200;\n    color: #da7200; }\n  .state-label.state-corrected, .mlist-view .media-box.contacts .state-corrected.org-label, .compact-view .media-box.contacts .state-corrected.org-label, .state-corrected.profile-label, .state-corrected.language-label {\n    border-color: navy;\n    color: navy; }\n  .state-label.not-for-publication, .mlist-view .media-box.contacts .not-for-publication.org-label, .compact-view .media-box.contacts .not-for-publication.org-label, .not-for-publication.profile-label, .not-for-publication.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.for-publication, .mlist-view .media-box.contacts .for-publication.org-label, .compact-view .media-box.contacts .for-publication.org-label, .for-publication.profile-label, .for-publication.language-label {\n    border-color: #5e8d32;\n    color: #5e8d32; }\n  .state-label.legal, .mlist-view .media-box.contacts .legal.org-label, .compact-view .media-box.contacts .legal.org-label, .legal.profile-label, .legal.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.missing-link, .mlist-view .media-box.contacts .missing-link.org-label, .compact-view .media-box.contacts .missing-link.org-label, .missing-link.profile-label, .missing-link.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.takes, .mlist-view .media-box.contacts .takes.org-label, .compact-view .media-box.contacts .takes.org-label, .takes.profile-label, .takes.language-label {\n    border-color: darkmagenta;\n    color: darkmagenta; }\n    .state-label.takes div:hover, .mlist-view .media-box.contacts .takes.org-label div:hover, .compact-view .media-box.contacts .takes.org-label div:hover, .takes.profile-label div:hover, .takes.language-label div:hover {\n      background-color: darkmagenta; }\n  .state-label.takes:hover, .mlist-view .media-box.contacts .takes.org-label:hover, .compact-view .media-box.contacts .takes.org-label:hover, .takes.profile-label:hover, .takes.language-label:hover {\n    background-color: darkmagenta;\n    color: #fff; }\n  .state-label.sms, .mlist-view .media-box.contacts .sms.org-label, .compact-view .media-box.contacts .sms.org-label, .sms.profile-label, .sms.language-label, .state-label.updated, .mlist-view .media-box.contacts .updated.org-label, .compact-view .media-box.contacts .updated.org-label, .updated.profile-label, .updated.language-label {\n    border-color: navy;\n    color: navy; }\n  .state-label.updated:hover, .mlist-view .media-box.contacts .updated.org-label:hover, .compact-view .media-box.contacts .updated.org-label:hover, .updated.profile-label:hover, .updated.language-label:hover {\n    background-color: navy;\n    color: #fff; }\n\n.profile-label {\n  background-color: #8c8c8c;\n  color: #fff; }\n\n.info-block {\n  max-width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  padding: 15px 0;\n  color: #999; }\n\n@-webkit-keyframes medium-editor-image-loading {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1); } }\n\n@keyframes medium-editor-image-loading {\n  0% {\n    -webkit-transform: scale(0);\n    transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n    transform: scale(1); } }\n\n@-webkit-keyframes medium-editor-pop-upwards {\n  0% {\n    opacity: 0;\n    -webkit-transform: matrix(0.97, 0, 0, 1, 0, 12);\n    transform: matrix(0.97, 0, 0, 1, 0, 12); }\n  20% {\n    opacity: .7;\n    -webkit-transform: matrix(0.99, 0, 0, 1, 0, 2);\n    transform: matrix(0.99, 0, 0, 1, 0, 2); }\n  40% {\n    opacity: 1;\n    -webkit-transform: matrix(1, 0, 0, 1, 0, -1);\n    transform: matrix(1, 0, 0, 1, 0, -1); }\n  100% {\n    -webkit-transform: matrix(1, 0, 0, 1, 0, 0);\n    transform: matrix(1, 0, 0, 1, 0, 0); } }\n\n@keyframes medium-editor-pop-upwards {\n  0% {\n    opacity: 0;\n    -webkit-transform: matrix(0.97, 0, 0, 1, 0, 12);\n    transform: matrix(0.97, 0, 0, 1, 0, 12); }\n  20% {\n    opacity: .7;\n    -webkit-transform: matrix(0.99, 0, 0, 1, 0, 2);\n    transform: matrix(0.99, 0, 0, 1, 0, 2); }\n  40% {\n    opacity: 1;\n    -webkit-transform: matrix(1, 0, 0, 1, 0, -1);\n    transform: matrix(1, 0, 0, 1, 0, -1); }\n  100% {\n    -webkit-transform: matrix(1, 0, 0, 1, 0, 0);\n    transform: matrix(1, 0, 0, 1, 0, 0); } }\n\n.medium-editor-anchor-preview {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  left: 0;\n  line-height: 1.4;\n  max-width: 280px;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  word-break: break-all;\n  word-wrap: break-word;\n  visibility: hidden;\n  z-index: 2000; }\n\n.medium-editor-anchor-preview a {\n  color: #fff;\n  display: inline-block;\n  margin: 5px 5px 10px; }\n\n.medium-editor-anchor-preview-active {\n  visibility: visible; }\n\n.medium-editor-dragover {\n  background: #ddd; }\n\n.medium-editor-image-loading {\n  -webkit-animation: medium-editor-image-loading 1s infinite ease-in-out;\n  animation: medium-editor-image-loading 1s infinite ease-in-out;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  height: 40px;\n  width: 40px; }\n\n.medium-editor-placeholder {\n  position: relative; }\n\n.medium-editor-placeholder:after {\n  content: attr(data-placeholder) !important;\n  font-style: italic;\n  left: 0;\n  position: absolute;\n  top: 0;\n  white-space: pre;\n  padding: inherit;\n  margin: inherit; }\n\n.medium-toolbar-arrow-under:after, .medium-toolbar-arrow-over:before {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  left: 50%;\n  margin-left: -8px;\n  position: absolute;\n  width: 0; }\n\n.medium-toolbar-arrow-under:after {\n  border-width: 8px 8px 0 8px; }\n\n.medium-toolbar-arrow-over:before {\n  border-width: 0 8px 8px 8px;\n  top: -8px; }\n\n.medium-editor-toolbar {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  visibility: hidden;\n  z-index: 9999; }\n\n.medium-editor-toolbar ul {\n  margin: 0;\n  padding: 0; }\n\n.medium-editor-toolbar li {\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.medium-editor-toolbar li button {\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: 15px;\n  text-decoration: none; }\n\n.medium-editor-toolbar li button:focus {\n  outline: none; }\n\n.medium-editor-toolbar li .medium-editor-action-underline {\n  text-decoration: underline; }\n\n.medium-editor-toolbar li .medium-editor-action-pre {\n  font-family: Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  font-size: 12px;\n  font-weight: 100;\n  padding: 15px 0; }\n\n.medium-editor-toolbar-active {\n  visibility: visible; }\n\n.medium-editor-sticky-toolbar {\n  position: fixed;\n  top: 1px; }\n\n.medium-editor-relative-toolbar {\n  position: relative; }\n\n.medium-editor-toolbar-active.medium-editor-stalker-toolbar {\n  -webkit-animation: medium-editor-pop-upwards 160ms forwards linear;\n  animation: medium-editor-pop-upwards 160ms forwards linear; }\n\n.medium-editor-action-bold {\n  font-weight: bolder; }\n\n.medium-editor-action-italic {\n  font-style: italic; }\n\n.medium-editor-toolbar-form {\n  display: none; }\n\n.medium-editor-toolbar-form input,\n.medium-editor-toolbar-form a {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-form-row {\n  line-height: 14px;\n  margin-left: 5px;\n  padding-bottom: 5px; }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input,\n.medium-editor-toolbar-form label {\n  border: none;\n  box-sizing: border-box;\n  font-size: 14px;\n  margin: 0;\n  padding: 6px;\n  width: 316px;\n  display: inline-block; }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input:focus,\n.medium-editor-toolbar-form label:focus {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: none;\n  box-shadow: none;\n  outline: 0; }\n\n.medium-editor-toolbar-form a {\n  display: inline-block;\n  font-size: 24px;\n  font-weight: bolder;\n  margin: 0 10px;\n  text-decoration: none; }\n\n.medium-editor-toolbar-actions:after {\n  clear: both;\n  content: \"\";\n  display: table; }\n\n[data-medium-editor-element] img {\n  max-width: 100%; }\n\n[data-medium-editor-element] sub {\n  vertical-align: sub; }\n\n[data-medium-editor-element] sup {\n  vertical-align: super; }\n\n.medium-editor-hidden {\n  display: none; }\n\n.medium-toolbar-arrow-under:after {\n  top: 60px;\n  border-color: #5ea9c8 transparent transparent transparent; }\n\n.medium-toolbar-arrow-over:before {\n  top: -8px;\n  border-color: transparent transparent #5ea9c8 transparent; }\n\n.medium-editor-toolbar {\n  background-color: #5ea9c8; }\n\n.medium-editor-toolbar li {\n  padding: 0; }\n\n.medium-editor-toolbar li button {\n  min-width: 60px;\n  height: 60px;\n  border: none;\n  border-right: 1px solid #f8f8f8;\n  background-color: transparent;\n  color: #fff;\n  -webkit-transition: background-color .2s ease-in, color .2s ease-in;\n  transition: background-color .2s ease-in, color .2s ease-in; }\n\n.medium-editor-toolbar li button:hover {\n  background-color: #31748f;\n  color: #fff; }\n\n.medium-editor-toolbar li .medium-editor-button-active {\n  background-color: #245569;\n  color: #fff; }\n\n.medium-editor-toolbar li .medium-editor-button-last {\n  border-right: none; }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input {\n  height: 60px;\n  background: #5ea9c8;\n  color: #fff; }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input::-webkit-input-placeholder {\n  color: #fff;\n  color: rgba(255, 255, 255, 0.8); }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input:-moz-placeholder {\n  /* Firefox 18- */\n  color: #fff;\n  color: rgba(255, 255, 255, 0.8); }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #fff;\n  color: rgba(255, 255, 255, 0.8); }\n\n.medium-editor-toolbar-form .medium-editor-toolbar-input:-ms-input-placeholder {\n  color: #fff;\n  color: rgba(255, 255, 255, 0.8); }\n\n.medium-editor-toolbar-form a {\n  color: #fff; }\n\n.medium-editor-toolbar-anchor-preview {\n  background: #5ea9c8;\n  color: #fff; }\n\n.medium-editor-placeholder:after {\n  color: #fff; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  margin: -1px 0;\n  position: fixed;\n  right: 10px; }\n\n::-webkit-scrollbar:hover {\n  background-color: #e8e8e8;\n  cursor: pointer; }\n\n::-webkit-scrollbar-thumb {\n  background: #bbb; }\n\n::-webkit-scrollbar-thumb:hover {\n  background: #777;\n  cursor: pointer; }\n\n/*\n    ----------------------------------------------------------------------\n    INPUT ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.sdselect {\n  width: 210px;\n  position: relative; }\n  .sdselect.open {\n    box-shadow: 0px 0px 5px 0px #d0d0d0 !important; }\n    .sdselect.open .sdselect-btn {\n      border-bottom: 0 !important; }\n  .sdselect:hover .sdselect-btn {\n    cursor: pointer; }\n  .sdselect .sdselect-btn {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 2px;\n    border: 1px solid #d0d0d0;\n    padding: 6px;\n    height: 27px;\n    outline: none !important;\n    box-shadow: inset 0 0 0 #000 !important;\n    box-shadow: none !important;\n    text-decoration: none;\n    color: #333;\n    line-height: 15px;\n    font-size: 12px; }\n    .sdselect .sdselect-btn .caret {\n      margin: 5px 3px 0 0; }\n  .sdselect .sdselect-menu {\n    position: absolute;\n    background: #fff;\n    z-index: 10;\n    top: 26px;\n    left: 0;\n    right: 0;\n    height: auto;\n    border: 1px solid #d0d0d0;\n    border-radius: 0 0 2px 2px; }\n    .sdselect .sdselect-menu .sdselect-filter {\n      padding: 2px 7px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"] {\n        height: 21px !important;\n        padding: 3px !important;\n        border: 0 !important;\n        min-height: 0;\n        box-shadow: 0 0 0 0 #000; }\n        .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"]:focus {\n          box-shadow: 0 0 0 0 #000 !important; }\n    .sdselect .sdselect-menu .sdselect-all {\n      padding: 4px 9px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-all a {\n        text-decoration: none;\n        font-size: 9px;\n        text-transform: uppercase;\n        color: #989898;\n        margin-right: 10px; }\n        .sdselect .sdselect-menu .sdselect-all a:hover {\n          cursor: pointer;\n          color: #666; }\n    .sdselect .sdselect-menu .list-holder {\n      height: auto;\n      max-height: 150px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      margin: 7px 0; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar {\n        border-left: 5px solid #fff;\n        border-right: 5px solid #fff;\n        width: 13px;\n        background: #fff; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar:hover {\n          background: #e8e8e8; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb {\n        border-left: 4px solid #fff;\n        border-right: 4px solid #fff;\n        background: #bbb; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb:hover {\n          background: #787878; }\n    .sdselect .sdselect-menu ul li a {\n      display: block;\n      padding: 3px 7px;\n      font-size: 12px;\n      color: #333;\n      text-decoration: none; }\n      .sdselect .sdselect-menu ul li a:hover {\n        cursor: pointer;\n        color: #fff;\n        background: #0083c4; }\n      .sdselect .sdselect-menu ul li a i {\n        margin-right: 5px;\n        vertical-align: middle;\n        margin-top: -4px;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n\n.searchbar {\n  border-radius: 2px !important;\n  background: url(" + escape(__webpack_require__(75)) + ") no-repeat 9px 4px #ffffff !important;\n  padding: 0 0 0 35px !important; }\n  .searchbar.searchbar-large {\n    background-position: 9px 7px !important;\n    height: 32px !important;\n    font-size: 15px;\n    line-height: 26px; }\n\n.flat-searchbar {\n  flex-grow: 0; }\n  .flat-searchbar .search-handler {\n    min-width: 48px;\n    height: 48px;\n    padding: 10px 10px 10px 14px;\n    box-sizing: border-box;\n    background: none;\n    display: flex;\n    border-right: 1px solid #e0e0e0;\n    white-space: nowrap;\n    transition: all 0.3s ease; }\n    .flat-searchbar .search-handler input {\n      height: 28px;\n      line-height: 100%;\n      font-size: 14px;\n      border: 0 !important;\n      width: 0;\n      padding: 0;\n      background-color: rgba(255, 255, 255, 0);\n      transition: all 0.3s ease; }\n      .flat-searchbar .search-handler input:focus {\n        box-shadow: none !important; }\n    .flat-searchbar .search-handler .trigger-icon {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -o-user-select: none;\n      user-select: none;\n      -webkit-touch-callout: none;\n      -khtml-user-select: none;\n      -ms-user-select: none;\n      float: left;\n      width: 28px;\n      height: 28px;\n      display: inline-block;\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\"; }\n      .flat-searchbar .search-handler .trigger-icon:hover {\n        cursor: pointer;\n        opacity: 0.8;\n        filter: \"alpha(opacity=80)\"; }\n      .flat-searchbar .search-handler .trigger-icon i {\n        padding: 7px 3px 4px 6px; }\n  .flat-searchbar .separator-handler {\n    margin: 9px 0 0 5px;\n    border-right: 2px dotted #bcbcbc;\n    height: 30px;\n    float: left; }\n  .flat-searchbar .search-close {\n    border: 0;\n    background: none;\n    display: none;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n    .flat-searchbar .search-close.visible {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n      .flat-searchbar .search-close.visible:hover {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n  .flat-searchbar.extended {\n    flex-grow: 1; }\n    .flat-searchbar.extended .search-handler {\n      border-right: 1px solid #e0e0e0; }\n      .flat-searchbar.extended .search-handler input {\n        width: auto;\n        padding: 0 6px; }\n    .flat-searchbar.extended .separator-handler {\n      margin-left: 14px; }\n    .flat-searchbar.extended .search-close {\n      display: inline-block; }\n\n.ui-responsive-small .flat-searchbar.extended {\n  position: absolute;\n  z-index: 2; }\n\n.monitoring-backlink .separator-handler {\n  margin-top: 0;\n  margin-right: 10px; }\n\n.filter-type {\n  white-space: nowrap; }\n  .filter-type__item {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 3px 2px;\n    cursor: pointer; }\n    .filter-type__item i {\n      height: auto;\n      color: #999;\n      padding: 2px 8px 1px 8px;\n      background: rgba(255, 255, 255, 0.5);\n      border: 1px solid rgba(215, 215, 215, 0.7);\n      border-radius: 2px;\n      box-sizing: border-box; }\n    .filter-type__item a {\n      height: 21px;\n      font-size: 11px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n      line-height: 21px;\n      text-decoration: none;\n      padding: 4px 10px;\n      border-radius: 2px;\n      border: 1px solid #999;\n      box-sizing: border-box;\n      text-transform: uppercase;\n      background: #fff !important;\n      color: #333;\n      opacity: 0.7; }\n      .filter-type__item a:hover {\n        color: #000;\n        opacity: 1; }\n      .filter-type__item a.filter-type__link--blue {\n        border-color: #5ea9c8;\n        color: #5ea9c8; }\n      .filter-type__item a.filter-type__link--dark-blue {\n        border-color: #216278;\n        color: #216278; }\n    .filter-type__item:hover i {\n      background: rgba(255, 255, 255, 0.8);\n      border: 1px solid #aaaaaa;\n      color: #666; }\n    .filter-type__item--active i {\n      opacity: 1;\n      color: #F5F5F5;\n      background: #505050;\n      border-color: #505050;\n      box-shadow: inset 0 1px 0px #373737 !important; }\n    .filter-type__item--active a {\n      opacity: 1;\n      background: #505050 !important;\n      border-color: #373737 #505050 #505050 !important;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0px #373737 !important; }\n    .filter-type__item--active:hover i {\n      border-color: rgba(80, 80, 80, 0.8);\n      background-color: rgba(80, 80, 80, 0.8);\n      color: #F5F5F5; }\n    .filter-type__item--active:hover a {\n      opacity: 0.8; }\n\n.filter-type--padded {\n  padding: 10px 0 10px 20px; }\n\n.result-type {\n  margin-left: 10px; }\n\n.dropdown__menu .filter-type {\n  padding: 0 10px; }\n\n.dropdown__menu--compare-versions {\n  max-height: 400px;\n  min-width: 250px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--compare-versions li {\n    margin-bottom: 2px;\n    line-height: 14px !important; }\n    .dropdown__menu--compare-versions li .dropdown.open li .dropdown .dropdown__toggle:hover {\n      display: none; }\n    .dropdown__menu--compare-versions li button {\n      width: 300px;\n      padding-right: 30px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      position: relative;\n      border-radius: 0;\n      line-height: 14px !important;\n      box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.15); }\n      .dropdown__menu--compare-versions li button i {\n        position: absolute;\n        right: -5px;\n        top: 9px; }\n      .dropdown__menu--compare-versions li button.disabled, .dropdown__menu--compare-versions li button.disabled:hover {\n        background: #f0f0f0; }\n        .dropdown__menu--compare-versions li button.disabled i, .dropdown__menu--compare-versions li button.disabled:hover i {\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\"; }\n      .dropdown__menu--compare-versions li button .headline {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-size: 11px;\n        font-weight: 500;\n        width: 240px;\n        display: inline-block; }\n      .dropdown__menu--compare-versions li button .desk-details {\n        display: flex;\n        font-size: 10px;\n        margin: 4px 0; }\n        .dropdown__menu--compare-versions li button .desk-details span:first-of-type {\n          flex-grow: 1; }\n      .dropdown__menu--compare-versions li button em {\n        font-size: 10px;\n        font-weight: 500;\n        color: #888;\n        float: left;\n        padding-right: 10px; }\n    .dropdown__menu--compare-versions li .msg {\n      padding: 0 20px; }\n\n.dropdown__menu .fieldset button {\n  text-align: center;\n  width: auto;\n  min-width: 50px;\n  clear: none;\n  margin-right: 10px;\n  float: right; }\n\n.online-users {\n  float: left;\n  height: 48px;\n  padding-left: 15px;\n  margin-left: 5px; }\n  .online-users > * {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    padding: 16px 0;\n    line-height: 13px; }\n\n[sd-timezone] .timezone-label {\n  margin-bottom: 1rem; }\n\n[sd-timezone] .input-term input {\n  height: 3.2rem;\n  margin-bottom: 5px;\n  width: 100%;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  border: none;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.3rem;\n  color: inherit;\n  padding-left: 1rem; }\n  [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(0, 0, 0, 0.3);\n    background-color: rgba(0, 0, 0, 0.1); }\n  [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[sd-timezone] .item-list {\n  width: 100%;\n  color: #333; }\n\n[sd-timezone] .pills-list li {\n  padding: 0.7rem 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 1.3rem; }\n  [sd-timezone] .pills-list li .icon-remove-sign {\n    color: inherit; }\n  [sd-timezone] .pills-list li #timezone {\n    padding-right: 2.5rem;\n    flex-grow: 1; }\n\n[class^=\"--dark-ui\"] [sd-timezone] .input-term input,\n[class*=\"--dark-ui\"] [sd-timezone] .input-term input {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:hover,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:focus,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input, .timepicker-input {\n  position: relative;\n  width: auto;\n  min-width: 130px; }\n  .datepicker-input input, .timepicker-input input {\n    width: 100%;\n    transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n    padding-right: 3.2rem;\n    padding-left: 1rem;\n    min-height: 2.8rem;\n    border: none;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    font-size: 1.3rem;\n    color: inherit; }\n    .datepicker-input input:hover, .timepicker-input input:hover {\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n      background-color: rgba(0, 0, 0, 0.1); }\n    .datepicker-input input:focus, .timepicker-input input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n    .datepicker-input input.ng-invalid, .timepicker-input input.ng-invalid {\n      color: #d10000;\n      border-color: #b61818 !important;\n      box-shadow: 0 1px 0 0 #b61818 !important; }\n  .datepicker-input .icn-btn, .timepicker-input .icn-btn {\n    position: absolute;\n    right: 2px;\n    top: 0; }\n\n.datepicker-input--dark input, .timepicker-input--dark input {\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 1.3rem;\n  line-height: 1.8rem;\n  color: inherit;\n  min-height: 32px; }\n  .datepicker-input--dark input:hover, .timepicker-input--dark input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  .datepicker-input--dark input:focus, .timepicker-input--dark input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input--dark .icn-btn, .timepicker-input--dark .icn-btn {\n  background: transparent;\n  top: 50%;\n  margin-top: -14px; }\n\n.datepicker-input--dark .name, .timepicker-input--dark .name {\n  background-color: #4f4f4f;\n  height: 24px;\n  font-size: 12px;\n  color: #fff; }\n\n.datepicker-input--dark ul > li, .timepicker-input--dark ul > li {\n  width: 90%; }\n\n.datepicker-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 260px;\n  box-sizing: border-box; }\n  .datepicker-wrapper .btn {\n    height: 28px; }\n    .datepicker-wrapper .btn:hover {\n      box-shadow: none; }\n  .datepicker-wrapper .btn--mini {\n    padding: 4px 6px;\n    font-size: 11px;\n    line-height: 11px !important;\n    height: auto; }\n  .datepicker-wrapper table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 0; }\n    .datepicker-wrapper table td, .datepicker-wrapper table th {\n      padding: 1px;\n      border: 0; }\n  .datepicker-wrapper .datepicker-additional {\n    margin-bottom: 5px; }\n    .datepicker-wrapper .datepicker-additional table {\n      width: 100%; }\n    .datepicker-wrapper .datepicker-additional .btn {\n      width: 100%; }\n  .datepicker-wrapper .datepicker-core table {\n    width: 100%; }\n    .datepicker-wrapper .datepicker-core table thead tr th .btn {\n      background: none;\n      padding: 0; }\n    .datepicker-wrapper .datepicker-core table thead tr:last-child th small {\n      font-weight: 500; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn strong {\n      font-weight: normal;\n      font-size: 14px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn i {\n      display: inline-block;\n      width: 14px;\n      height: 14px;\n      background-repeat: no-repeat; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:first-child .btn i {\n      margin-left: 3px;\n      background-position: -189px -165px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:last-child .btn i {\n      margin-right: 3px;\n      background-position: -213px -165px; }\n    .datepicker-wrapper .datepicker-core table tbody tr:first-child td {\n      padding-top: 5px; }\n    .datepicker-wrapper .datepicker-core table tbody td {\n      padding: 0 2px; }\n      .datepicker-wrapper .datepicker-core table tbody td .btn {\n        width: 100% !important;\n        min-width: 28px !important;\n        padding: 0;\n        background: none;\n        color: #333;\n        box-shadow: none; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn .text-muted {\n          color: #999; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn:hover, .datepicker-wrapper .datepicker-core table tbody td .btn.active {\n          color: #333;\n          box-shadow: inset 0 0 1px 0 #5ea9c8;\n          background: #eff7fa; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active {\n          color: #fff;\n          background: #5ea9c8; }\n          .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary .text-muted, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active .text-muted {\n            color: #fff; }\n\n.timepicker-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 200px;\n  height: 310px;\n  box-sizing: border-box; }\n  .timepicker-popup .timepicker-additional {\n    margin-bottom: 5px; }\n    .timepicker-popup .timepicker-additional table {\n      width: 100%;\n      border-collapse: collapse;\n      border: 0; }\n      .timepicker-popup .timepicker-additional table td, .timepicker-popup .timepicker-additional table th {\n        padding: 1px; }\n    .timepicker-popup .timepicker-additional .btn {\n      width: 100%;\n      letter-spacing: 0; }\n    .timepicker-popup .timepicker-additional .btn--mini {\n      padding: 4px 6px;\n      font-size: 11px;\n      line-height: 11px !important;\n      height: 20px; }\n  .timepicker-popup .timepicker-core .select-area {\n    margin-top: 15px;\n    border-top: 1px solid #ddd; }\n    .timepicker-popup .timepicker-core .select-area .header {\n      margin-top: -10px;\n      float: left;\n      background: #fff;\n      text-transform: uppercase;\n      color: #adadad;\n      font-size: 11px;\n      padding-right: 10px; }\n    .timepicker-popup .timepicker-core .select-area ul {\n      padding-top: 15px;\n      *zoom: 1; }\n      .timepicker-popup .timepicker-core .select-area ul:before, .timepicker-popup .timepicker-core .select-area ul:after {\n        display: table;\n        content: \"\"; }\n      .timepicker-popup .timepicker-core .select-area ul:after {\n        clear: both; }\n      .timepicker-popup .timepicker-core .select-area ul > li {\n        float: left;\n        box-sizing: border-box;\n        width: 28px;\n        height: 28px;\n        line-height: 28px;\n        text-align: center;\n        margin: 0 2px 2px 0;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none;\n        border-radius: 2px; }\n        .timepicker-popup .timepicker-core .select-area ul > li:hover {\n          background: #eff7fa;\n          cursor: pointer; }\n        .timepicker-popup .timepicker-core .select-area ul > li.active {\n          background: #5ea9c8;\n          color: #fff; }\n\n.pills-list.line-input > li {\n  width: 100%;\n  border-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background-color: transparent;\n  padding: 0;\n  height: 24px;\n  box-shadow: none; }\n  .pills-list.line-input > li .actions {\n    top: -9px; }\n  .pills-list.line-input > li:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: transparent !important;\n    box-shadow: none; }\n  .pills-list.line-input > li:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important;\n    background-color: transparent !important; }\n\n/*\n    ----------------------------------------------------------------------\n    OTHER CUSTOM ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.backlink, a.backlink {\n  text-decoration: none !important;\n  color: #333;\n  border: 0;\n  transition: all ease 0.2s;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  padding: 0;\n  margin: 0;\n  cursor: pointer; }\n  .backlink:before, a.backlink:before {\n    font-family: 'sd_icons';\n    font-weight: normal;\n    font-style: normal;\n    content: \"\\E677\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n    flex-grow: 0;\n    margin: -1px 8px 0 0;\n    text-decoration: none !important;\n    transition: all ease 0.2s;\n    opacity: 0.7; }\n  .backlink.white, a.backlink.white {\n    color: #fff; }\n  .backlink:hover, a.backlink:hover {\n    color: #5ea9c8;\n    text-decoration: none !important; }\n    .backlink:hover:before, a.backlink:hover:before {\n      text-decoration: none !important;\n      margin: -1px 10px 0 -2px;\n      opacity: 1; }\n\n.stage-header__name a {\n  transition: all ease 0.2s; }\n\n.widget-content .stage-header__name a {\n  text-decoration: none !important; }\n\n.activity-log {\n  margin-top: 10px; }\n  .activity-log ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; }\n    .activity-log ul li.activity .activity-content {\n      padding-left: 45px;\n      margin-top: -3px;\n      padding-right: 20px;\n      color: #555; }\n      .activity-log ul li.activity .activity-content b {\n        font-weight: 500; }\n    .activity-log ul li.activity .activity-date {\n      padding-left: 45px;\n      font-size: 11px;\n      color: #999;\n      margin-top: -5px; }\n    .activity-log ul li.activity.with-date {\n      margin-top: 35px; }\n      .activity-log ul li.activity.with-date .date {\n        border-top: 1px solid #ebebeb;\n        top: -17px;\n        position: absolute;\n        right: 0;\n        left: 0; }\n        .activity-log ul li.activity.with-date .date span {\n          font-size: 12px;\n          color: #999;\n          margin-top: -10px;\n          display: block;\n          float: left;\n          background: #f8f8f8;\n          padding-right: 5px; }\n    .activity-log ul li.activity:hover {\n      cursor: default; }\n\n.activity-load-more {\n  width: 100%;\n  font-size: 12px;\n  margin: 20px 0; }\n\n.notification-list {\n  margin: 0;\n  margin-bottom: 20px;\n  list-style-type: none; }\n  .notification-list li {\n    background: #393939;\n    padding: 10px 5px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    width: 100%;\n    min-height: 45px;\n    margin: 10px 0;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5); }\n    .notification-list li .content {\n      padding-left: 40px; }\n      .notification-list li .content .text {\n        margin: 0;\n        font-size: 12px;\n        overflow: hidden;\n        color: #d7d7d7; }\n      .notification-list li .content .date, .notification-list li .content .date time, .notification-list li .content time {\n        font-size: 11px;\n        color: #848484;\n        margin-top: -3px;\n        display: block; }\n      .notification-list li .content a {\n        cursor: pointer;\n        color: #5ea9c8; }\n        .notification-list li .content a:hover {\n          text-decoration: none;\n          color: #97c7db; }\n    .notification-list li.unread {\n      border-color: #545454;\n      background: #2c2c2c; }\n    .notification-list li.important {\n      border: 1px solid #a60101 !important;\n      box-shadow: inset 0px 0px 1px 1px #e4b2b2, 0px 2px 2px 0px #d8d8d8 !important; }\n    .notification-list li.personal, .notification-list li.important {\n      border: 1px solid #c8c8c8;\n      border-radius: 3px;\n      background: #fff;\n      padding: 5px;\n      margin-bottom: 7px;\n      box-shadow: 0px 2px 2px 0 #d8d8d8; }\n      .notification-list li.personal + li, .notification-list li.important + li {\n        border-top-width: 0; }\n        .notification-list li.personal + li.personal, .notification-list li.personal + li.important, .notification-list li.important + li.personal, .notification-list li.important + li.important {\n          border-top-width: 1px; }\n    .notification-list li .info {\n      color: #e0e0e0; }\n  .notification-list.white li {\n    background: #fff;\n    border-color: #dedede;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12); }\n    .notification-list.white li .content .text {\n      color: #333; }\n    .notification-list.white li.active {\n      border-color: #999;\n      box-shadow: 0 1px 2px 0 #666; }\n\n.notification-pane ::-webkit-scrollbar:hover {\n  background-color: #4a4a4a; }\n\n.notification-pane ::-webkit-scrollbar-thumb {\n  background: #5a5a5a; }\n\n.notification-pane ::-webkit-scrollbar-thumb:hover {\n  background: #666; }\n\n.hard-error {\n  position: fixed;\n  top: 0;\n  right: 200px;\n  z-index: 9999;\n  width: auto;\n  max-width: 400px; }\n  .hard-error .alert {\n    border-radius: 0;\n    border: 0;\n    box-sizing: border-box;\n    height: 40px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n    padding: 0 15px; }\n  .hard-error .alert-error {\n    background-color: #612525;\n    color: #cc7c7b;\n    text-shadow: none; }\n  .hard-error:hover .alert {\n    height: auto;\n    line-height: 20px;\n    padding: 10px 15px;\n    overflow: visible;\n    white-space: pre-wrap; }\n\n.sd-pagination {\n  padding: 7px 20px; }\n  .sd-pagination .btn {\n    padding: 10px; }\n    .sd-pagination .btn i {\n      margin-right: 0; }\n  .sd-pagination .page-info {\n    margin-right: 20px;\n    display: inline-block; }\n    .sd-pagination .page-info input {\n      display: inline-block;\n      width: 30px;\n      text-align: center;\n      margin-top: -1px;\n      padding: 6px 3px !important;\n      border-radius: 5px;\n      margin: 0 5px;\n      box-shadow: inset 0 5px 5px -5px #acacac; }\n  .sd-pagination .btn-group, .sd-pagination .btn-group > .btn {\n    display: inline-block;\n    vertical-align: middle;\n    float: none; }\n  .sd-pagination .btn-group > .btn + .btn {\n    margin-left: 0px; }\n\n.assignment-menu .assignment-box {\n  width: 270px; }\n  .assignment-menu .assignment-box h5 {\n    border: 0; }\n  .assignment-menu .assignment-box .assignment-content .assignment-result-list {\n    margin-top: 10px;\n    height: 140px;\n    overflow: auto; }\n    .assignment-menu .assignment-box .assignment-content .assignment-result-list ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li {\n        height: 32px;\n        margin-bottom: 3px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li .avatar-small {\n          width: 24px;\n          height: 24px;\n          border: 0;\n          padding: 0;\n          margin: 0;\n          background-size: 24px 24px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li span {\n          font-size: 13px;\n          color: #4f4f4f;\n          line-height: 24px;\n          margin-left: 10px; }\n\n.sortbar {\n  white-space: nowrap;\n  margin: 0 5px;\n  padding: 0 10px; }\n  .sortbar > * {\n    display: inline-block !important;\n    vertical-align: middle; }\n  .sortbar > .dropdown {\n    margin-right: 10px; }\n  .sortbar .lab {\n    margin-right: 10px; }\n  .sortbar .dropdown__toggle {\n    color: #808080;\n    min-width: auto !important; }\n  .sortbar .direction {\n    background: none;\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.selectionlist {\n  list-style-type: none;\n  padding: 2px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  overflow: auto; }\n  .selectionlist li {\n    line-height: 16px;\n    height: 16px;\n    padding: 4px;\n    margin-bottom: 3px;\n    border-radius: 3px;\n    background: #e8e8e8; }\n  .selectionlist .sf-toggle-custom {\n    margin-top: -1px;\n    float: right; }\n\n.plain-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n  .plain-list.plain-border-top {\n    border-top: 1px solid #e5e5e5; }\n  .plain-list > li {\n    border-bottom: 1px solid #e5e5e5;\n    height: 41px;\n    line-height: 40px;\n    cursor: pointer;\n    position: relative;\n    padding: 0 5px;\n    box-sizing: border-box; }\n    .plain-list > li:hover {\n      background: #eff7fa; }\n    .plain-list > li .btn--mini {\n      margin-top: 10px; }\n\n.plain-small > li {\n  height: 31px;\n  line-height: 30px; }\n\n.users-list > li .avatar {\n  margin-top: 5px;\n  margin-right: 15px; }\n\n.users-list > li .name {\n  font-size: 13px;\n  color: #3599b6; }\n\n.plain-small.users-list > li .avatar {\n  margin-top: 3px; }\n\n.users-list-embed {\n  position: relative; }\n  .users-list-embed > li {\n    height: 32px;\n    line-height: 32px;\n    margin-right: -5px; }\n    .users-list-embed > li .avatar {\n      margin: 3px 10px 4px 4px; }\n    .users-list-embed > li:hover, .users-list-embed > li.active {\n      cursor: pointer;\n      color: #fff; }\n    .users-list-embed > li:hover {\n      background: #84bdd5; }\n    .users-list-embed > li:active {\n      background: #97c7db; }\n    .users-list-embed > li.active {\n      background: #5ea9c8; }\n    .users-list-embed > li.inactive {\n      color: #ccc; }\n\n.mentio-menu {\n  padding: 5px;\n  border: 1px solid #ddd;\n  max-height: 126px;\n  z-index: 9999 !important;\n  overflow: auto;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);\n  width: 190px;\n  bottom: 5px; }\n  .mentio-menu ul li {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.card-list > li, .card {\n  display: block;\n  padding: 10px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  margin-bottom: 7px;\n  position: relative; }\n  .card-list > li:not([disabled]):hover, .card:not([disabled]):hover {\n    cursor: pointer;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li:not([disabled]):hover .action, .card:not([disabled]):hover .action {\n      display: block !important; }\n  .card-list > li.selected, .card.selected {\n    background-color: #eff7fa;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li.selected:hover, .card.selected:hover {\n      box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n  .card-list > li[disabled], .card[disabled] {\n    cursor: default !important;\n    background-color: rgba(255, 255, 255, 0.45); }\n  .card-list > li .action, .card .action {\n    display: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    min-width: 200px; }\n    .card-list > li .action ul, .card .action ul {\n      height: 100%;\n      text-align: right; }\n    .card-list > li .action .item-field, .card .action .item-field {\n      height: 100%; }\n      .card-list > li .action .item-field span, .card .action .item-field span {\n        display: none; }\n      .card-list > li .action .item-field a, .card .action .item-field a {\n        padding: 0 23px;\n        line-height: 62px;\n        display: block; }\n\n.active .card {\n  background-color: #eff7fa;\n  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n  .active .card:hover {\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n\n.pills-list {\n  max-width: 650px; }\n  .pills-list > li {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    background: #fff;\n    margin-bottom: 6px;\n    margin-right: 2px;\n    border-radius: 2px;\n    padding: 10px 16px;\n    min-height: 18px;\n    color: inherit;\n    position: relative;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.08);\n    transition: all ease-in-out 0.2s; }\n    .pills-list > li:hover {\n      box-shadow: 0 0px 3px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.2); }\n    .pills-list > li.active {\n      background: #5ea9c8;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0 #3e92b5; }\n    .pills-list > li.inactive {\n      opacity: 0.5; }\n    .pills-list > li.empty-info {\n      background: transparent;\n      border: 1px dotted rgba(123, 123, 123, 0.5);\n      opacity: 0.75;\n      box-shadow: none !important; }\n    .pills-list > li .dropdown {\n      margin-top: -3px; }\n    .pills-list > li .actions {\n      display: none;\n      position: absolute;\n      top: 0px;\n      right: 4px; }\n      .pills-list > li .actions button {\n        transition: opacity ease-in-out 0.2s;\n        border: 0;\n        height: 30px;\n        width: 30px;\n        margin: 3px;\n        background: none;\n        text-align: center;\n        display: block;\n        float: left;\n        line-height: 0;\n        opacity: 0.4; }\n        .pills-list > li .actions button:hover {\n          cursor: pointer;\n          opacity: 1; }\n        .pills-list > li .actions button i {\n          margin-top: -2px; }\n    .pills-list > li h6 {\n      text-transform: none;\n      color: inherit;\n      font-size: 14px;\n      font-weight: 300;\n      float: left;\n      max-width: 99%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .pills-list > li .label-group {\n      display: inline-block; }\n      .pills-list > li .label-group.label-group--right {\n        float: right; }\n    .pills-list > li .label {\n      font-size: 9px;\n      font-weight: 700;\n      padding: 2px 5px;\n      line-height: 12px;\n      margin-left: 5px;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n      font-weight: 400; }\n    .pills-list > li:hover .actions {\n      display: block !important; }\n    .pills-list > li:hover h6 {\n      max-width: 550px; }\n    .pills-list > li .avatar {\n      display: inline-block;\n      float: none; }\n    .pills-list > li h5 {\n      display: inline-block; }\n  .pills-list.pills-editable li.editable {\n    padding: 0;\n    height: auto;\n    background: transparent; }\n    .pills-list.pills-editable li.editable input {\n      height: 30px;\n      line-height: 30px;\n      border-radius: 3px; }\n\n[class^=\"--dark-ui\"] .pills-list > li,\n[class*=\"--dark-ui\"] .pills-list > li {\n  background: #4f4f4f; }\n\n.pill-small {\n  width: 200px;\n  margin: 4px; }\n\n.item-field {\n  border-left: 1px solid #d8d8d8;\n  display: inline-block; }\n  .item-field span {\n    display: none; }\n  .item-field button {\n    border: 0;\n    padding: 0;\n    background: none;\n    vertical-align: text-top; }\n  .item-field:hover {\n    background: rgba(0, 0, 0, 0.1);\n    border-color: #e0e0e0; }\n  .item-field.disabled {\n    cursor: default; }\n    .item-field.disabled i {\n      opacity: 0.3;\n      filter: \"alpha(opacity=30)\"; }\n    .item-field.disabled:hover {\n      background: #e8e8e8; }\n\n.dropdown .item-field {\n  display: block;\n  border-left: 0; }\n  .dropdown .item-field span {\n    display: inline-block; }\n\n.dropdown .item-field:hover {\n  background: none; }\n\n.or-label {\n  position: relative;\n  text-align: center;\n  font-style: italic; }\n  .or-label:before {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: -75px; }\n  .or-label:after {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: 15px; }\n\n.list-group {\n  box-sizing: border-box;\n  width: 300px; }\n  .list-group .list-group-item {\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-width: 0 1px 1px 1px;\n    background-color: #fff; }\n    .list-group .list-group-item:first-child {\n      border-width: 1px;\n      border-radius: 5px 5px 0 0; }\n    .list-group .list-group-item:last-child {\n      border-radius: 0 0 5px 5px; }\n    .list-group .list-group-item:hover {\n      background-color: #f4f4f4;\n      cursor: pointer; }\n    .list-group .list-group-item a {\n      text-decoration: none;\n      color: #444; }\n\n.shadow-list-holder {\n  overflow-y: auto;\n  width: 100%;\n  max-height: 100%;\n  min-height: 100%;\n  box-sizing: border-box; }\n\n.scroll-shadow {\n  height: 0; }\n  .scroll-shadow .inner {\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(transparent));\n    height: 4px;\n    position: relative;\n    z-index: 503;\n    transition: linear 0.1s all;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n  .scroll-shadow.shadow .inner {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n\n.toggle-box__button {\n  transition: color ease-in-out 0.2s;\n  color: #999;\n  cursor: pointer; }\n  .toggle-box__button i {\n    color: inherit;\n    margin-right: 5px;\n    vertical-align: text-bottom; }\n  .toggle-box__button:hover {\n    text-decoration: none;\n    color: #fff; }\n\n.fade {\n  transition: opacity 0.15s linear;\n  opacity: 0; }\n  .fade.in {\n    opacity: 1; }\n\n.close {\n  float: right;\n  line-height: 18px;\n  opacity: 0.2;\n  filter: \"alpha(opacity=20)\"; }\n  .close:hover {\n    text-decoration: none;\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\";\n    cursor: pointer; }\n  .close i {\n    vertical-align: middle; }\n\n.draggable-list__item {\n  background-color: #fff;\n  padding: 18px 14px 19px 25px;\n  margin-bottom: 10px;\n  cursor: move;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  position: relative; }\n  .draggable-list__item.placeholder {\n    background: none;\n    box-shadow: none;\n    border: 2px dashed #ebebeb; }\n  .draggable-list__item:after {\n    content: \"\";\n    width: 10px;\n    top: 0;\n    bottom: 0;\n    left: 2px;\n    background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 3px top 3px;\n    opacity: 0.2;\n    position: absolute;\n    display: block; }\n  .draggable-list__item:hover {\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4); }\n    .draggable-list__item:hover:after {\n      opacity: 0.8; }\n  .draggable-list__item--small {\n    padding: 10px 14px 10px 25px; }\n  .draggable-list__item--no-padding {\n    padding: 0 0 0 8px; }\n    .draggable-list__item--no-padding:after {\n      width: 6px;\n      left: 2px;\n      background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 0px top 3px; }\n\n.draggable-list.serial-decimal {\n  list-style-type: decimal !important;\n  padding-top: 0px;\n  margin-left: 5px; }\n  .draggable-list.serial-decimal > li {\n    word-spacing: 2px;\n    line-height: 0px; }\n  .draggable-list.serial-decimal .sort-item.active {\n    background-color: #eee; }\n\n.ui-resizable-e {\n  cursor: col-resize !important; }\n\n.spinner-big {\n  background-image: url(" + escape(__webpack_require__(34)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  vertical-align: middle;\n  text-align: center; }\n\n.spinner-alt {\n  background-image: url(" + escape(__webpack_require__(106)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  line-height: 32px;\n  vertical-align: middle;\n  text-align: center; }\n\n.sd-check__wrapper .sd-checkbox + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: inherit;\n  height: auto;\n  text-transform: none; }\n  .sd-check__wrapper .sd-checkbox + label.label--active {\n    color: #479dc0; }\n\n.sd-toggle + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: #333;\n  height: auto;\n  text-transform: none; }\n\n.definition-list .definition-list__term {\n  font-size: 1.6rem;\n  margin-bottom: 0.6rem;\n  font-weight: 400; }\n\n.definition-list .definition-list__item {\n  padding: 0.3rem 0;\n  margin-left: 0;\n  font-size: 1.4rem;\n  font-weight: 300; }\n\n.definition-list .definition-list__item + .definition-list__term {\n  margin-top: 2rem; }\n\n.nav-button-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 0; }\n  .nav-button-bar .btn {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.modal__header--flex .icn-btn.close, .modal__header--flex .icn-btn.close-modal, .modal__header--flex .icn-btn.modal__close {\n  margin: 0 -0.6rem 0;\n  border: 0;\n  padding: .6rem;\n  opacity: 0.5; }\n  .modal__header--flex .icn-btn.close:hover, .modal__header--flex .icn-btn.close-modal:hover, .modal__header--flex .icn-btn.modal__close:hover {\n    opacity: 0.8; }\n  .modal__header--flex .icn-btn.close:active, .modal__header--flex .icn-btn.close-modal:active, .modal__header--flex .icn-btn.modal__close:active {\n    opacity: 1; }\n\n.sd-line-input__message--with-char-count {\n  padding-right: 10rem; }\n\n.sd-list-item.inactive {\n  background-color: transparent;\n  color: rgba(123, 123, 123, 0.75); }\n\n.sd-toggle + label {\n  letter-spacing: 0; }\n\n.sd-list-item__text-label time {\n  padding: 0;\n  font-style: normal; }\n\n[sd-meta-terms] {\n  min-height: 2.8rem; }\n\n.line-input--boxed .input-term input[type=\"text\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.4rem;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 0 1rem;\n  height: 3.2rem;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  .line-input--boxed .input-term input[type=\"text\"]:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: rgba(0, 0, 0, 0.1) !important; }\n  .line-input--boxed .input-term input[type=\"text\"]:focus {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important; }\n\n.line-input--boxed .terms-list {\n  width: 100%;\n  margin-top: 0.8rem; }\n\nsd-tag-input + .sd-line-input__message {\n  margin-top: -2rem; }\n\nsd-multi-image-edit {\n  height: 100vh;\n  display: flex;\n  flex-direction: column; }\n\n.sd-wrap-helper {\n  display: contents !important; }\n\n.subnav {\n  z-index: 5; }\n\n.subnav + .subnav {\n  z-index: 4; }\n\n/* classic icons*/\n.icon-unplug {\n  background-image: url(" + escape(__webpack_require__(617)) + "); }\n\n.active [class^=\"big-icon-\"],\n.active [class*=\" big-icon-\"],\n.active button:hover [class^=\"big-icon-\"],\n.active button:hover [class*=\" big-icon-\"],\n.active a:hover [class^=\"big-icon-\"],\n.active a:hover [class*=\" big-icon-\"] {\n  opacity: 1;\n  color: white; }\n\n.sd-sidetab-menu--right .active [class^=\"big-icon-\"],\n.sd-sidetab-menu--right .active [class*=\" big-icon-\"],\n.sd-sidetab-menu--right .active button:hover [class^=\"big-icon-\"],\n.sd-sidetab-menu--right .active button:hover [class*=\" big-icon-\"],\n.sd-sidetab-menu--right .active a:hover [class^=\"big-icon-\"],\n.sd-sidetab-menu--right .active a:hover [class*=\" big-icon-\"] {\n  color: #3783a2 !important; }\n\n[class^=\"filetype-icon-\"], [class*=\"filetype-icon-\"] {\n  display: inline-block;\n  height: 16px;\n  line-height: 16px;\n  font-family: 'sd_icons';\n  font-size: 16px;\n  color: #333;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.filetype-icon-photo:before, .filetype-icon-picture:before {\n  content: \"\\E600\"; }\n\n.filetype-icon-video:before {\n  content: \"\\E601\"; }\n\n.filetype-icon-slideshow:before {\n  content: \"\\E603\"; }\n\n.filetype-icon-audio:before {\n  content: \"\\E608\"; }\n\n.filetype-icon-file:before {\n  content: \"\\E605\"; }\n\n.filetype-icon-maps:before {\n  content: \"\\E602\"; }\n\n.filetype-icon-calendar:before {\n  content: \"\\E606\"; }\n\n.filetype-icon-text:before, .filetype-icon-preformatted:before {\n  content: \"\\E604\"; }\n\n.filetype-icon-composite:before {\n  content: \"\\E607\"; }\n\n.filetype-icon-graphic:before {\n  content: \"\\E66D\"; }\n\n.filetype-icon-highlight-pack:before {\n  content: \"\\E671\"; }\n\n[class^=\"filetype-icon-large-\"], [class*=\"filetype-icon-large\"] {\n  font-family: Arial, Helvetica, sans-serif;\n  height: 24px;\n  width: 24px;\n  display: inline-block;\n  color: #333333;\n  line-height: 24px;\n  vertical-align: top;\n  position: relative;\n  padding-left: 0;\n  float: none;\n  background-repeat: no-repeat; }\n\n.filetype-icon-large-composite {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCB5PSIyIiB3aWR0aD0iMjQiIGhlaWdodD0iNCIvPg0KCTxwYXRoIGQ9Ik0yLDIwYzAsMSwxLDIsMiwyaDE2YzEsMCwyLTEsMi0yVjdIMlYyMHogTTcsOWgxMHYzSDdWOXoiLz4NCjwvZz4NCjwvc3ZnPg0K); }\n  .filetype-icon-large-composite.icon-white {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCB5PSIyIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMjQiIGhlaWdodD0iNCIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yLDIwYzAsMSwxLDIsMiwyaDE2YzEsMCwyLTEsMi0yVjdIMlYyMHogTTcsOWgxMHYzSDdWOXoiLz4NCjwvZz4NCjwvc3ZnPg0K); }\n\n.lightbox-composite .icons-holder .filetype-icon-large-composite {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCB5PSIyIiBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMjQiIGhlaWdodD0iNCIvPg0KCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yLDIwYzAsMSwxLDIsMiwyaDE2YzEsMCwyLTEsMi0yVjdIMlYyMHogTTcsOWgxMHYzSDdWOXoiLz4NCjwvZz4NCjwvc3ZnPg0K); }\n\n.filetype-icon-large-text {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBkPSJNNCwydjIwaDE2VjJINHogTTE3LDE2SDd2LTFoMTBWMTZ6IE0xNywxM0g3di0xaDEwVjEzeiBNMTcsMTBIN1Y5aDEwVjEweiBNMTcsN0g3VjZoMTBWN3oiLz4NCjwvc3ZnPg0K); }\n  .filetype-icon-large-text.icon-white {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNCwydjIwaDE2VjJINHogTTE3LDE2SDd2LTFoMTBWMTZ6IE0xNywxM0g3di0xaDEwVjEzeiBNMTcsMTBIN1Y5aDEwVjEweiBNMTcsN0g3VjZoMTBWN3oiLz4NCjwvc3ZnPg0K); }\n\n.lightbox-composite .icons-holder .filetype-icon-large-text {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNNCwydjIwaDE2VjJINHogTTE3LDE2SDd2LTFoMTBWMTZ6IE0xNywxM0g3di0xaDEwVjEzeiBNMTcsMTBIN1Y5aDEwVjEweiBNMTcsN0g3VjZoMTBWN3oiLz4NCjwvc3ZnPg0K); }\n\n.filetype-icon-large-video {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Y2lyY2xlIGN4PSI0IiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZD0iTTE1LjksMTBIMS4xQzAuNSwxMCwwLDEwLjUsMCwxMS4xdjkuOEMwLDIxLjUsMC41LDIyLDEuMSwyMmgxNC44YzAuNiwwLDEuMS0wLjUsMS4xLTEuMXYtOS44QzE3LDEwLjUsMTYuNSwxMCwxNS45LDEweg0KCSBNNSwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDNTNi43LDE5LDUsMTl6IE0xMiwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDNTMTMuNywxOSwxMiwxOXoiLz4NCjxjaXJjbGUgY3g9IjEzIiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZD0iTTE2LDE0aDEuNWMwLjMsMCwwLjctMC4xLDEtMC4zbDMuMy0yLjVjMC4yLTAuMSwwLjQtMC4yLDAuNi0wLjJoMS4xYzAuMywwLDAuNiwwLjMsMC42LDAuNnY4LjhjMCwwLjMtMC4zLDAuNi0wLjYsMC42aC0xLjENCgljLTAuMiwwLTAuNC0wLjEtMC42LTAuMmwtMy4zLTIuNWMtMC4zLTAuMi0wLjYtMC4zLTAuOS0wLjNIMTZWMTR6Ii8+DQo8Y2lyY2xlIGN4PSI1IiBjeT0iMTYiIHI9IjEiLz4NCjxjaXJjbGUgY3g9IjEyIiBjeT0iMTYiIHI9IjEiLz4NCjwvc3ZnPg0K); }\n  .filetype-icon-large-video.icon-white {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Y2lyY2xlIGZpbGw9IiNGRkZGRkYiIGN4PSI0IiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE1LjksMTBIMS4xQzAuNSwxMCwwLDEwLjUsMCwxMS4xdjkuOEMwLDIxLjUsMC41LDIyLDEuMSwyMmgxNC44YzAuNiwwLDEuMS0wLjUsMS4xLTEuMXYtOS44DQoJQzE3LDEwLjUsMTYuNSwxMCwxNS45LDEweiBNNSwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDNTNi43LDE5LDUsMTl6IE0xMiwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDMNCglTMTMuNywxOSwxMiwxOXoiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjEzIiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE2LDE0aDEuNWMwLjMsMCwwLjctMC4xLDEtMC4zbDMuMy0yLjVjMC4yLTAuMSwwLjQtMC4yLDAuNi0wLjJoMS4xYzAuMywwLDAuNiwwLjMsMC42LDAuNnY4LjgNCgljMCwwLjMtMC4zLDAuNi0wLjYsMC42aC0xLjFjLTAuMiwwLTAuNC0wLjEtMC42LTAuMmwtMy4zLTIuNWMtMC4zLTAuMi0wLjYtMC4zLTAuOS0wLjNIMTZWMTR6Ii8+DQo8Y2lyY2xlIGZpbGw9IiNGRkZGRkYiIGN4PSI1IiBjeT0iMTYiIHI9IjEiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjEyIiBjeT0iMTYiIHI9IjEiLz4NCjwvc3ZnPg0K); }\n\n.lightbox-composite .icons-holder .filetype-icon-large-video {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Y2lyY2xlIGZpbGw9IiNGRkZGRkYiIGN4PSI0IiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE1LjksMTBIMS4xQzAuNSwxMCwwLDEwLjUsMCwxMS4xdjkuOEMwLDIxLjUsMC41LDIyLDEuMSwyMmgxNC44YzAuNiwwLDEuMS0wLjUsMS4xLTEuMXYtOS44DQoJQzE3LDEwLjUsMTYuNSwxMCwxNS45LDEweiBNNSwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDNTNi43LDE5LDUsMTl6IE0xMiwxOWMtMS43LDAtMy0xLjMtMy0zczEuMy0zLDMtM3MzLDEuMywzLDMNCglTMTMuNywxOSwxMiwxOXoiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjEzIiBjeT0iNSIgcj0iNCIvPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE2LDE0aDEuNWMwLjMsMCwwLjctMC4xLDEtMC4zbDMuMy0yLjVjMC4yLTAuMSwwLjQtMC4yLDAuNi0wLjJoMS4xYzAuMywwLDAuNiwwLjMsMC42LDAuNnY4LjgNCgljMCwwLjMtMC4zLDAuNi0wLjYsMC42aC0xLjFjLTAuMiwwLTAuNC0wLjEtMC42LTAuMmwtMy4zLTIuNWMtMC4zLTAuMi0wLjYtMC4zLTAuOS0wLjNIMTZWMTR6Ii8+DQo8Y2lyY2xlIGZpbGw9IiNGRkZGRkYiIGN4PSI1IiBjeT0iMTYiIHI9IjEiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjEyIiBjeT0iMTYiIHI9IjEiLz4NCjwvc3ZnPg0K); }\n\n.filetype-icon-large-audio {\n  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNiw2SDguNmMtMC40LDAtMC43LDAuMS0xLDAuNEw1LDljLTAuNSwwLjUtMSwxLTIsMUgwLjlDMC40LDEwLDAsMTAuNCwwLDEwLjkNCgkJCWwwLDIuMUMwLDEzLjYsMC40LDE0LDAuOSwxNEgzYzAuOSwwLDEuNSwwLjUsMiwxbDIuNiwyLjZjMC4zLDAuMywwLjYsMC40LDEsMC40aDEuMWMwLjIsMCwwLjQtMC4yLDAuNC0wLjRWNi40DQoJCQlDMTAsNi4yLDkuOCw2LDkuNiw2eiBNMTkuMSwxbC0xLjIsMS42YzIuMiwyLjUsMy42LDUuOCwzLjYsOS40YzAsMy42LTEuMyw2LjktMy42LDkuNGwxLjIsMS42YzIuNS0yLjksNC4xLTYuOCw0LjEtMTENCgkJCUMyMy4yLDcuOCwyMS43LDMuOSwxOS4xLDF6IE0xNS45LDQuMWwtMS4xLDEuNmMxLjYsMS42LDIuNSwzLjksMi41LDYuM2MwLDIuNS0xLDQuOC0yLjYsNi40bDEsMS42YzItMi4xLDMuMi00LjksMy4yLTgNCgkJCUMxOSw4LjksMTcuOCw2LjIsMTUuOSw0LjF6IE0xMi44LDcuM0wxMiw5YzAuOCwwLjcsMS4zLDEuOCwxLjMsMi45YzAsMS4zLTEsMi40LTIsMy4xbDEuNiwxLjVjMS4yLTEuMSwyLTIuOCwyLTQuNw0KCQkJQzE0LjksMTAuMSwxNC4xLDguNCwxMi44LDcuM3oiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==); }\n  .filetype-icon-large-audio.icon-white {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTkuNiw2aC0xYy0wLjQsMC0wLjcsMC4xLTEsMC40TDUsOWMtMC41LDAuNS0xLDEtMiwxSDAuOUMwLjQsMTAsMCwxMC40LDAsMTAuOVYxM2MwLDAuNiwwLjQsMSwwLjksMUgzDQoJCQljMC45LDAsMS41LDAuNSwyLDFsMi42LDIuNmMwLjMsMC4zLDAuNiwwLjQsMSwwLjRoMS4xYzAuMiwwLDAuNC0wLjIsMC40LTAuNFY2LjRDMTAsNi4yLDkuOCw2LDkuNiw2eiBNMTkuMSwxbC0xLjIsMS42DQoJCQljMi4yLDIuNSwzLjYsNS44LDMuNiw5LjRzLTEuMyw2LjktMy42LDkuNGwxLjIsMS42YzIuNS0yLjksNC4xLTYuOCw0LjEtMTFTMjEuNywzLjksMTkuMSwxeiBNMTUuOSw0LjFsLTEuMSwxLjYNCgkJCWMxLjYsMS42LDIuNSwzLjksMi41LDYuM2MwLDIuNS0xLDQuOC0yLjYsNi40bDEsMS42YzItMi4xLDMuMi00LjksMy4yLThDMTksOC45LDE3LjgsNi4yLDE1LjksNC4xeiBNMTIuOCw3LjNMMTIsOQ0KCQkJYzAuOCwwLjcsMS4zLDEuOCwxLjMsMi45YzAsMS4zLTEsMi40LTIsMy4xbDEuNiwxLjVjMS4yLTEuMSwyLTIuOCwyLTQuN0MxNC45LDEwLjEsMTQuMSw4LjQsMTIuOCw3LjN6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=); }\n\n.lightbox-composite .icons-holder .filetype-icon-large-audio {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTkuNiw2aC0xYy0wLjQsMC0wLjcsMC4xLTEsMC40TDUsOWMtMC41LDAuNS0xLDEtMiwxSDAuOUMwLjQsMTAsMCwxMC40LDAsMTAuOVYxM2MwLDAuNiwwLjQsMSwwLjksMUgzDQoJCQljMC45LDAsMS41LDAuNSwyLDFsMi42LDIuNmMwLjMsMC4zLDAuNiwwLjQsMSwwLjRoMS4xYzAuMiwwLDAuNC0wLjIsMC40LTAuNFY2LjRDMTAsNi4yLDkuOCw2LDkuNiw2eiBNMTkuMSwxbC0xLjIsMS42DQoJCQljMi4yLDIuNSwzLjYsNS44LDMuNiw5LjRzLTEuMyw2LjktMy42LDkuNGwxLjIsMS42YzIuNS0yLjksNC4xLTYuOCw0LjEtMTFTMjEuNywzLjksMTkuMSwxeiBNMTUuOSw0LjFsLTEuMSwxLjYNCgkJCWMxLjYsMS42LDIuNSwzLjksMi41LDYuM2MwLDIuNS0xLDQuOC0yLjYsNi40bDEsMS42YzItMi4xLDMuMi00LjksMy4yLThDMTksOC45LDE3LjgsNi4yLDE1LjksNC4xeiBNMTIuOCw3LjNMMTIsOQ0KCQkJYzAuOCwwLjcsMS4zLDEuOCwxLjMsMi45YzAsMS4zLTEsMi40LTIsMy4xbDEuNiwxLjVjMS4yLTEuMSwyLTIuOCwyLTQuN0MxNC45LDEwLjEsMTQuMSw4LjQsMTIuOCw3LjN6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=); }\n\n.filetype-icon-large-picture,\n.filetype-icon-large-image {\n  background-image: url(data:image/svg+xml;base64,PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjQgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZD0iTTAsMHYyMGgyNFYwSDB6IE0yMywxNkgxVjFoMjJWMTZ6Ii8+DQo8Y2lyY2xlIGN4PSI1LjUiIGN5PSI1LjUiIHI9IjIuNSIvPg0KPHBhdGggZD0iTTIsMTVsMy01bDIsMmw0LTVsMiwzbDQtN2MwLDAsMi43LDUuNywzLjQsNi43UzIyLDEyLDIyLDEydjNIMnoiLz4NCjwvc3ZnPg0K); }\n  .filetype-icon-large-picture.icon-white,\n  .filetype-icon-large-image.icon-white {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMCwwdjIwaDI0VjBIMHogTTIzLDE2SDFWMWgyMlYxNnoiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMi41Ii8+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMiwxNWwzLTVsMiwybDQtNWwyLDNsNC03YzAsMCwyLjcsNS43LDMuNCw2LjdTMjIsMTIsMjIsMTJ2M0gyeiIvPg0KPC9zdmc+DQo=); }\n\n.lightbox-composite .icons-holder .filetype-icon-large-picture,\n.lightbox-composite .icons-holder .filetype-icon-large-image {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMCwwdjIwaDI0VjBIMHogTTIzLDE2SDFWMWgyMlYxNnoiLz4NCjxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjUuNSIgY3k9IjUuNSIgcj0iMi41Ii8+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMiwxNWwzLTVsMiwybDQtNWwyLDNsNC03YzAsMCwyLjcsNS43LDMuNCw2LjdTMjIsMTIsMjIsMTJ2M0gyeiIvPg0KPC9zdmc+DQo=); }\n\n.arrow-icon-large-left {\n  width: 32px;\n  height: 56px;\n  display: inline-block;\n  background: url(" + escape(__webpack_require__(258)) + ") no-repeat 0 0; }\n\n.arrow-icon-large-right {\n  width: 32px;\n  height: 56px;\n  display: inline-block;\n  background: url(" + escape(__webpack_require__(258)) + ") no-repeat -32px 0; }\n\n/* * * * * *  SVG ICONS  * * * * * */\n[class^=\"svg-icon-\"], [class*=\"svg-icon-\"] {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-size: contain; }\n\n.svg-icon-plus {\n  width: 10px;\n  height: 10px;\n  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3Qm94PSIwIDAgMTAgMTAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwIDEwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTAsNCA2LDQgNiwwIDQsMCA0LDQgMCw0IDAsNiA0LDYgNCwxMCA2LDEwIDYsNiAxMCw2ICIvPg0KPC9zdmc+DQo=); }\n\n.svg-icon-ok {\n  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDE0OTQ4KSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjNjI2MzYzIiBkPSJNMjEuNjUyLDMuMjExYy0wLjI5My0wLjI5NS0wLjc3MS0wLjI5NS0xLjA2MiwwTDkuNDEsMTQuMzRjLTAuMjkzLDAuMjk3LTAuNzcxLDAuMjk3LTEuMDYyLDBMMy40NDksOS4zNTENCglDMy4zMDQsOS4yMDMsMy4xMTQsOS4xMywyLjkyMyw5LjEyOUMyLjczLDkuMTI4LDIuNTM0LDkuMjAxLDIuMzg3LDkuMzUxbC0yLjE2NSwxLjk0NkMwLjA3OCwxMS40NDUsMCwxMS42MywwLDExLjgyMw0KCWMwLDAuMTk0LDAuMDc4LDAuMzk2LDAuMjIzLDAuNTQ0bDQuOTQsNS4xODRjMC4yOTIsMC4yOTcsMC43NzEsMC43NzYsMS4wNjIsMS4wN2wyLjEyNCwyLjE0MWMwLjI5MiwwLjI5MywwLjc2OSwwLjI5MywxLjA2MiwwDQoJbDE0LjM2Ni0xNC4zNGMwLjI5My0wLjI5NCwwLjI5My0wLjc3NywwLTEuMDcxTDIxLjY1MiwzLjIxMXoiLz4NCjwvc3ZnPg0K); }\n  .svg-icon-ok.inverse {\n    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDE0OTQ4KSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNCAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMjEuNjUyLDMuMjExYy0wLjI5My0wLjI5NS0wLjc3MS0wLjI5NS0xLjA2MiwwTDkuNDEsMTQuMzRjLTAuMjkzLDAuMjk3LTAuNzcxLDAuMjk3LTEuMDYyLDBMMy40NDksOS4zNTENCglDMy4zMDQsOS4yMDMsMy4xMTQsOS4xMywyLjkyMyw5LjEyOUMyLjczLDkuMTI4LDIuNTM0LDkuMjAxLDIuMzg3LDkuMzUxbC0yLjE2NSwxLjk0NkMwLjA3OCwxMS40NDUsMCwxMS42MywwLDExLjgyMw0KCWMwLDAuMTk0LDAuMDc4LDAuMzk2LDAuMjIzLDAuNTQ0bDQuOTQsNS4xODRjMC4yOTIsMC4yOTcsMC43NzEsMC43NzYsMS4wNjIsMS4wN2wyLjEyNCwyLjE0MWMwLjI5MiwwLjI5MywwLjc2OSwwLjI5MywxLjA2MiwwDQoJbDE0LjM2Ni0xNC4zNGMwLjI5My0wLjI5NCwwLjI5My0wLjc3NywwLTEuMDcxTDIxLjY1MiwzLjIxMXoiLz4NCjwvc3ZnPg0K); }\n\n.svg-icon-move {\n  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDE0OTQ4KSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjMycHgiIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iTGF5ZXJfMV8xXyI+DQo8L2c+DQo8ZyBpZD0ibW92ZSI+DQoJPGc+DQoJCTxwb2x5Z29uIGZpbGw9IiM2MTYzNjMiIHBvaW50cz0iMTgsMjAgMTgsMjYgMjIsMjYgMTYsMzIgMTAsMjYgMTQsMjYgMTQsMjAgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iIzYxNjM2MyIgcG9pbnRzPSIxNCwxMiAxNCw2IDEwLDYgMTYsMCAyMiw2IDE4LDYgMTgsMTIgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iIzYxNjM2MyIgcG9pbnRzPSIxMiwxOCA2LDE4IDYsMjIgMCwxNiA2LDEwIDYsMTQgMTIsMTQgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iIzYxNjM2MyIgcG9pbnRzPSIyMCwxNCAyNiwxNCAyNiwxMCAzMiwxNiAyNiwyMiAyNiwxOCAyMCwxOCAJCSIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K); }\n  .svg-icon-move.inverse {\n    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDE0OTQ4KSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjMycHgiIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDMyIDMyIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMiAzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iTGF5ZXJfMV8xXyI+DQo8L2c+DQo8ZyBpZD0ibW92ZSI+DQoJPGc+DQoJCTxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTgsMjAgMTgsMjYgMjIsMjYgMTYsMzIgMTAsMjYgMTQsMjYgMTQsMjAgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIxNCwxMiAxNCw2IDEwLDYgMTYsMCAyMiw2IDE4LDYgMTgsMTIgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIxMiwxOCA2LDE4IDYsMjIgMCwxNiA2LDEwIDYsMTQgMTIsMTQgCQkiLz4NCgkJPHBvbHlnb24gZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIyMCwxNCAyNiwxNCAyNiwxMCAzMiwxNiAyNiwyMiAyNiwxOCAyMCwxOCAJCSIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K); }\n\n.svg-icon-down, .svg-icon-top, .svg-icon-right, .svg-icon-left {\n  width: 25px;\n  height: 14px;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjIzcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIzIDEzIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMyAxMyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9IiM2MjYyNjIiIGQ9Ik0yMi42IDAuNEwyMi42IDAuNGMtMC42LTAuNi0xLjUtMC42LTIuMSAwbC04LjkgOC45TDIuNiAwLjRDMi0wLjEgMS0wLjEgMC40IDAuNHYwQy0wLjEgMS0wLjEgMiAwLjQgMi42IGwxMCAxMGMwIDAgMCAwIDAgMGMwLjMgMC4zIDAuNyAwLjQgMS4xIDAuNGMwLjQgMCAwLjgtMC4xIDEuMS0wLjRjMCAwIDAgMCAwIDBsMTAtMTBDMjMuMSAyIDIzLjEgMSAyMi42IDAuNHoiLz4KPC9zdmc+Cg==); }\n  .svg-icon-down.inverse, .svg-icon-top.inverse, .svg-icon-right.inverse, .svg-icon-left.inverse {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjIzcHgiIGhlaWdodD0iMTNweCIgdmlld0JveD0iMCAwIDIzIDEzIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMyAxMyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0yMi42IDAuNEwyMi42IDAuNGMtMC42LTAuNi0xLjUtMC42LTIuMSAwbC04LjkgOC45TDIuNiAwLjRDMi0wLjEgMS0wLjEgMC40IDAuNHYwQy0wLjEgMS0wLjEgMiAwLjQgMi42IGwxMCAxMGMwIDAgMCAwIDAgMGMwLjMgMC4zIDAuNyAwLjQgMS4xIDAuNGMwLjQgMCAwLjgtMC4xIDEuMS0wLjRjMCAwIDAgMCAwIDBsMTAtMTBDMjMuMSAyIDIzLjEgMSAyMi42IDAuNHoiLz4KPC9zdmc+Cg==); }\n\n.svg-icon-left {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg); }\n\n.svg-icon-top {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg); }\n\n.svg-icon-right {\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg); }\n\n.svg-icon-add-to-list {\n  height: 18px;\n  opacity: 0.5;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjIwcHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDIwIDE4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMCAxOCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMiIvPg0KCTxyZWN0IHk9IjQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIyIi8+DQoJPHJlY3QgeT0iOCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIiLz4NCgk8cG9seWdvbiBwb2ludHM9IjE2LDEyIDE2LDggMTQsOCAxNCwxMiAxMCwxMiAxMCwxNCAxNCwxNCAxNCwxOCAxNiwxOCAxNiwxNCAyMCwxNCAyMCwxMiAJIi8+DQoJPHJlY3QgeT0iMTIiIHdpZHRoPSI4IiBoZWlnaHQ9IjIiLz4NCjwvZz4NCjwvc3ZnPg0K); }\n  .svg-icon-add-to-list.inverse {\n    opacity: 1;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjIwcHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDIwIDE4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyMCAxOCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cmVjdCBmaWxsPSIjRkZGRkZGIiB3aWR0aD0iMTYiIGhlaWdodD0iMiIvPg0KCTxyZWN0IHk9IjQiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSIxNiIgaGVpZ2h0PSIyIi8+DQoJPHJlY3QgeT0iOCIgZmlsbD0iI0ZGRkZGRiIgd2lkdGg9IjEyIiBoZWlnaHQ9IjIiLz4NCgk8cG9seWdvbiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjE2LDEyIDE2LDggMTQsOCAxNCwxMiAxMCwxMiAxMCwxNCAxNCwxNCAxNCwxOCAxNiwxOCAxNiwxNCAyMCwxNCAyMCwxMiAJIi8+DQoJPHJlY3QgeT0iMTIiIGZpbGw9IiNGRkZGRkYiIHdpZHRoPSI4IiBoZWlnaHQ9IjIiLz4NCjwvZz4NCjwvc3ZnPg0K); }\n\n.sf-logo {\n  display: block;\n  background: url(" + escape(__webpack_require__(618)) + ") no-repeat 0 0;\n  width: 124px;\n  height: 32px; }\n\n.search-list {\n  position: relative;\n  width: 100%;\n  border: 1px solid #d0d0d0; }\n  .search-list .search-list-button {\n    width: 98%;\n    padding: 4px;\n    background-color: #fff;\n    border: 0;\n    border-radius: 2px !important;\n    text-align: left; }\n    .search-list .search-list-button .caret {\n      position: absolute;\n      top: 12px;\n      right: 10px; }\n  .search-list .search-list-content {\n    position: absolute;\n    z-index: 1000;\n    top: 100%;\n    width: 100%;\n    margin: 0px;\n    padding: 4px;\n    background-color: #fff;\n    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);\n    box-sizing: border-box;\n    border: 1px solid #dcdcdc; }\n    .search-list .search-list-content .close-list {\n      position: absolute;\n      right: 5px;\n      top: 5px;\n      border: 0;\n      background: none;\n      border-radius: 2px;\n      line-height: 15px;\n      height: 15px; }\n    .search-list .search-list-content .selected-list {\n      margin-right: 2px;\n      border-bottom: 1px solid #d0d0d0;\n      width: 98%;\n      box-sizing: border-box; }\n      .search-list .search-list-content .selected-list .selected-helper {\n        margin-left: 40px; }\n    .search-list .search-list-content .unselected-list input {\n      margin-left: 20px;\n      width: 200px;\n      left: 0;\n      right: 0;\n      top: 0;\n      height: 28px;\n      border: 1px solid #dcdcdc !important;\n      box-sizing: border-box; }\n    .search-list .search-list-content .unselected-list .pagination button {\n      border: 0;\n      color: #000;\n      left: 0;\n      right: 0;\n      top: 0;\n      border-radius: 2px;\n      line-height: 15px;\n      height: 15px; }\n    .search-list .search-list-content .unselected-list .page-info {\n      margin-right: 2px;\n      border-bottom: 1px solid #d0d0d0;\n      box-sizing: border-box;\n      width: 98%; }\n    .search-list .search-list-content .select-button {\n      padding: 4px;\n      margin-left: 10px;\n      background-color: #fff;\n      border: 0;\n      text-align: left;\n      width: 97%; }\n      .search-list .search-list-content .select-button:hover {\n        background-color: #f0f0f0; }\n\n.sd-photo-preview .jcrop-handle {\n  opacity: 1 !important;\n  background-color: #333333;\n  border: 1px #eeeeee solid;\n  width: 12px;\n  height: 12px;\n  font-size: 1px;\n  border-radius: 50%; }\n\n.sd-photo-preview .jcrop-handle.ord-n {\n  margin-left: -6px;\n  margin-top: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-s {\n  margin-bottom: -6px;\n  margin-left: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-e {\n  margin-right: -6px;\n  margin-top: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-w {\n  margin-left: -6px;\n  margin-top: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-nw {\n  margin-left: -6px;\n  margin-top: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-ne {\n  margin-right: -6px;\n  margin-top: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-se {\n  margin-bottom: -6px;\n  margin-right: -6px; }\n\n.sd-photo-preview .jcrop-handle.ord-sw {\n  margin-bottom: -6px;\n  margin-left: -6px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle {\n  width: 8px;\n  height: 8px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-n {\n  margin-left: -4px;\n  margin-top: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-s {\n  margin-bottom: -4px;\n  margin-left: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-e {\n  margin-right: -4px;\n  margin-top: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-w {\n  margin-left: -4px;\n  margin-top: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-nw {\n  margin-left: -4px;\n  margin-top: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-ne {\n  margin-right: -4px;\n  margin-top: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-se {\n  margin-bottom: -4px;\n  margin-right: -4px; }\n\n.sd-photo-preview .sd-grid-item .jcrop-handle.ord-sw {\n  margin-bottom: -4px;\n  margin-left: -4px; }\n\n.sd-photo-preview .jcrop-dark .jcrop-handle {\n  opacity: 1 !important;\n  background-color: rgba(205, 205, 205, 0.5);\n  border-color: white;\n  border-radius: 50%; }\n\n.sd-photo-preview .jcrop-dark .jcrop-vline, .sd-photo-preview .jcrop-dark .jcrop-hline {\n  background: rgba(255, 255, 255, 0.3);\n  opacity: 1; }\n\n.sd-photo-preview .jcrop-dark .jcrop-handle.ord-n, .sd-photo-preview .jcrop-dark .jcrop-handle.ord-s, .sd-photo-preview .jcrop-dark .jcrop-handle.ord-e, .sd-photo-preview .jcrop-dark .jcrop-handle.ord-w {\n  display: none; }\n\n.saved-search-subscriptions {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  padding-top: 4px; }\n\n.saved-search-subscriptions--manage-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: -30px;\n  margin-bottom: 10px;\n  padding: 9px 20px;\n  font-size: 13px;\n  background: #DEE5E8; }\n\n.saved-search-subscriptions--action {\n  visibility: hidden; }\n\n.saved-search-item:hover .saved-search-subscriptions--action {\n  visibility: visible; }\n", ""]);

// exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/* jquery.Jcrop.css v0.9.12 - MIT License */\n/*\n  The outer-most container in a typical Jcrop instance\n  If you are having difficulty with formatting related to styles\n  on a parent element, place any fixes here or in a like selector\n\n  You can also style this element if you want to add a border, etc\n  A better method for styling can be seen below with .jcrop-light\n  (Add a class to the holder and style elements for that extended class)\n*/\n.jcrop-holder {\n  direction: ltr;\n  text-align: left;\n  /* IE10 touch compatibility */\n  -ms-touch-action: none;\n}\n/* Selection Border */\n.jcrop-vline,\n.jcrop-hline {\n  background: #ffffff url(" + escape(__webpack_require__(590)) + ");\n  font-size: 0;\n  position: absolute;\n}\n.jcrop-vline {\n  height: 100%;\n  width: 1px !important;\n}\n.jcrop-vline.right {\n  right: 0;\n}\n.jcrop-hline {\n  height: 1px !important;\n  width: 100%;\n}\n.jcrop-hline.bottom {\n  bottom: 0;\n}\n/* Invisible click targets */\n.jcrop-tracker {\n  height: 100%;\n  width: 100%;\n  /* \"turn off\" link highlight */\n  -webkit-tap-highlight-color: transparent;\n  /* disable callout, image save panel */\n  -webkit-touch-callout: none;\n  /* disable cut copy paste */\n  -webkit-user-select: none;\n}\n/* Selection Handles */\n.jcrop-handle {\n  background-color: #333333;\n  border: 1px #eeeeee solid;\n  width: 7px;\n  height: 7px;\n  font-size: 1px;\n}\n.jcrop-handle.ord-n {\n  left: 50%;\n  margin-left: -4px;\n  margin-top: -4px;\n  top: 0;\n}\n.jcrop-handle.ord-s {\n  bottom: 0;\n  left: 50%;\n  margin-bottom: -4px;\n  margin-left: -4px;\n}\n.jcrop-handle.ord-e {\n  margin-right: -4px;\n  margin-top: -4px;\n  right: 0;\n  top: 50%;\n}\n.jcrop-handle.ord-w {\n  left: 0;\n  margin-left: -4px;\n  margin-top: -4px;\n  top: 50%;\n}\n.jcrop-handle.ord-nw {\n  left: 0;\n  margin-left: -4px;\n  margin-top: -4px;\n  top: 0;\n}\n.jcrop-handle.ord-ne {\n  margin-right: -4px;\n  margin-top: -4px;\n  right: 0;\n  top: 0;\n}\n.jcrop-handle.ord-se {\n  bottom: 0;\n  margin-bottom: -4px;\n  margin-right: -4px;\n  right: 0;\n}\n.jcrop-handle.ord-sw {\n  bottom: 0;\n  left: 0;\n  margin-bottom: -4px;\n  margin-left: -4px;\n}\n/* Dragbars */\n.jcrop-dragbar.ord-n,\n.jcrop-dragbar.ord-s {\n  height: 7px;\n  width: 100%;\n}\n.jcrop-dragbar.ord-e,\n.jcrop-dragbar.ord-w {\n  height: 100%;\n  width: 7px;\n}\n.jcrop-dragbar.ord-n {\n  margin-top: -4px;\n}\n.jcrop-dragbar.ord-s {\n  bottom: 0;\n  margin-bottom: -4px;\n}\n.jcrop-dragbar.ord-e {\n  margin-right: -4px;\n  right: 0;\n}\n.jcrop-dragbar.ord-w {\n  margin-left: -4px;\n}\n/* The \"jcrop-light\" class/extension */\n.jcrop-light .jcrop-vline,\n.jcrop-light .jcrop-hline {\n  background: #ffffff;\n  filter: alpha(opacity=70) !important;\n  opacity: .70!important;\n}\n.jcrop-light .jcrop-handle {\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  background-color: #000000;\n  border-color: #ffffff;\n  border-radius: 3px;\n}\n/* The \"jcrop-dark\" class/extension */\n.jcrop-dark .jcrop-vline,\n.jcrop-dark .jcrop-hline {\n  background: #000000;\n  filter: alpha(opacity=70) !important;\n  opacity: 0.7 !important;\n}\n.jcrop-dark .jcrop-handle {\n  -moz-border-radius: 3px;\n  -webkit-border-radius: 3px;\n  background-color: #ffffff;\n  border-color: #000000;\n  border-radius: 3px;\n}\n/* Simple macro to turn off the antlines */\n.solid-line .jcrop-vline,\n.solid-line .jcrop-hline {\n  background: #ffffff;\n}\n/* Fix for twitter bootstrap et al. */\n.jcrop-holder img,\nimg.jcrop-preview {\n  max-width: none;\n}\n", ""]);

// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7a4b4c6ebdb549fcbe47408f9457493e.gif";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*! jQuery UI - v1.11.4 - 2015-03-11\n* http://jqueryui.com\n* Includes: core.css, accordion.css, autocomplete.css, button.css, datepicker.css, dialog.css, draggable.css, menu.css, progressbar.css, resizable.css, selectable.css, selectmenu.css, slider.css, sortable.css, spinner.css, tabs.css, tooltip.css, theme.css\n* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Verdana%2CArial%2Csans-serif&fwDefault=normal&fsDefault=1.1em&cornerRadius=4px&bgColorHeader=cccccc&bgTextureHeader=highlight_soft&bgImgOpacityHeader=75&borderColorHeader=aaaaaa&fcHeader=222222&iconColorHeader=222222&bgColorContent=ffffff&bgTextureContent=flat&bgImgOpacityContent=75&borderColorContent=aaaaaa&fcContent=222222&iconColorContent=222222&bgColorDefault=e6e6e6&bgTextureDefault=glass&bgImgOpacityDefault=75&borderColorDefault=d3d3d3&fcDefault=555555&iconColorDefault=888888&bgColorHover=dadada&bgTextureHover=glass&bgImgOpacityHover=75&borderColorHover=999999&fcHover=212121&iconColorHover=454545&bgColorActive=ffffff&bgTextureActive=glass&bgImgOpacityActive=65&borderColorActive=aaaaaa&fcActive=212121&iconColorActive=454545&bgColorHighlight=fbf9ee&bgTextureHighlight=glass&bgImgOpacityHighlight=55&borderColorHighlight=fcefa1&fcHighlight=363636&iconColorHighlight=2e83ff&bgColorError=fef1ec&bgTextureError=glass&bgImgOpacityError=95&borderColorError=cd0a0a&fcError=cd0a0a&iconColorError=cd0a0a&bgColorOverlay=aaaaaa&bgTextureOverlay=flat&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=aaaaaa&bgTextureShadow=flat&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=8px&offsetTopShadow=-8px&offsetLeftShadow=-8px&cornerRadiusShadow=8px\n* Copyright 2015 jQuery Foundation and other contributors; Licensed MIT */\n\n/* Layout helpers\n----------------------------------*/\n.ui-helper-hidden {\n\tdisplay: none;\n}\n.ui-helper-hidden-accessible {\n\tborder: 0;\n\tclip: rect(0 0 0 0);\n\theight: 1px;\n\tmargin: -1px;\n\toverflow: hidden;\n\tpadding: 0;\n\tposition: absolute;\n\twidth: 1px;\n}\n.ui-helper-reset {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\tline-height: 1.3;\n\ttext-decoration: none;\n\tfont-size: 100%;\n\tlist-style: none;\n}\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n\tcontent: \"\";\n\tdisplay: table;\n\tborder-collapse: collapse;\n}\n.ui-helper-clearfix:after {\n\tclear: both;\n}\n.ui-helper-clearfix {\n\tmin-height: 0; /* support: IE7 */\n}\n.ui-helper-zfix {\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\topacity: 0;\n\tfilter:Alpha(Opacity=0); /* support: IE8 */\n}\n\n.ui-front {\n\tz-index: 100;\n}\n\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-disabled {\n\tcursor: default !important;\n}\n\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n\tdisplay: block;\n\ttext-indent: -99999px;\n\toverflow: hidden;\n\tbackground-repeat: no-repeat;\n}\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Overlays */\n.ui-widget-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n.ui-accordion .ui-accordion-header {\n\tdisplay: block;\n\tcursor: pointer;\n\tposition: relative;\n\tmargin: 2px 0 0 0;\n\tpadding: .5em .5em .5em .7em;\n\tmin-height: 0; /* support: IE7 */\n\tfont-size: 100%;\n}\n.ui-accordion .ui-accordion-icons {\n\tpadding-left: 2.2em;\n}\n.ui-accordion .ui-accordion-icons .ui-accordion-icons {\n\tpadding-left: 2.2em;\n}\n.ui-accordion .ui-accordion-header .ui-accordion-header-icon {\n\tposition: absolute;\n\tleft: .5em;\n\ttop: 50%;\n\tmargin-top: -8px;\n}\n.ui-accordion .ui-accordion-content {\n\tpadding: 1em 2.2em;\n\tborder-top: 0;\n\toverflow: auto;\n}\n.ui-autocomplete {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tcursor: default;\n}\n.ui-button {\n\tdisplay: inline-block;\n\tposition: relative;\n\tpadding: 0;\n\tline-height: normal;\n\tmargin-right: .1em;\n\tcursor: pointer;\n\tvertical-align: middle;\n\ttext-align: center;\n\toverflow: visible; /* removes extra width in IE */\n}\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n\ttext-decoration: none;\n}\n/* to make room for the icon, a width needs to be set here */\n.ui-button-icon-only {\n\twidth: 2.2em;\n}\n/* button elements seem to need a little more width */\nbutton.ui-button-icon-only {\n\twidth: 2.4em;\n}\n.ui-button-icons-only {\n\twidth: 3.4em;\n}\nbutton.ui-button-icons-only {\n\twidth: 3.7em;\n}\n\n/* button text element */\n.ui-button .ui-button-text {\n\tdisplay: block;\n\tline-height: normal;\n}\n.ui-button-text-only .ui-button-text {\n\tpadding: .4em 1em;\n}\n.ui-button-icon-only .ui-button-text,\n.ui-button-icons-only .ui-button-text {\n\tpadding: .4em;\n\ttext-indent: -9999999px;\n}\n.ui-button-text-icon-primary .ui-button-text,\n.ui-button-text-icons .ui-button-text {\n\tpadding: .4em 1em .4em 2.1em;\n}\n.ui-button-text-icon-secondary .ui-button-text,\n.ui-button-text-icons .ui-button-text {\n\tpadding: .4em 2.1em .4em 1em;\n}\n.ui-button-text-icons .ui-button-text {\n\tpadding-left: 2.1em;\n\tpadding-right: 2.1em;\n}\n/* no icon support for input elements, provide padding by default */\ninput.ui-button {\n\tpadding: .4em 1em;\n}\n\n/* button icon element(s) */\n.ui-button-icon-only .ui-icon,\n.ui-button-text-icon-primary .ui-icon,\n.ui-button-text-icon-secondary .ui-icon,\n.ui-button-text-icons .ui-icon,\n.ui-button-icons-only .ui-icon {\n\tposition: absolute;\n\ttop: 50%;\n\tmargin-top: -8px;\n}\n.ui-button-icon-only .ui-icon {\n\tleft: 50%;\n\tmargin-left: -8px;\n}\n.ui-button-text-icon-primary .ui-button-icon-primary,\n.ui-button-text-icons .ui-button-icon-primary,\n.ui-button-icons-only .ui-button-icon-primary {\n\tleft: .5em;\n}\n.ui-button-text-icon-secondary .ui-button-icon-secondary,\n.ui-button-text-icons .ui-button-icon-secondary,\n.ui-button-icons-only .ui-button-icon-secondary {\n\tright: .5em;\n}\n\n/* button sets */\n.ui-buttonset {\n\tmargin-right: 7px;\n}\n.ui-buttonset .ui-button {\n\tmargin-left: 0;\n\tmargin-right: -.3em;\n}\n\n/* workarounds */\n/* reset extra padding in Firefox, see h5bp.com/l */\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n\tborder: 0;\n\tpadding: 0;\n}\n.ui-datepicker {\n\twidth: 17em;\n\tpadding: .2em .2em 0;\n\tdisplay: none;\n}\n.ui-datepicker .ui-datepicker-header {\n\tposition: relative;\n\tpadding: .2em 0;\n}\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n\tposition: absolute;\n\ttop: 2px;\n\twidth: 1.8em;\n\theight: 1.8em;\n}\n.ui-datepicker .ui-datepicker-prev-hover,\n.ui-datepicker .ui-datepicker-next-hover {\n\ttop: 1px;\n}\n.ui-datepicker .ui-datepicker-prev {\n\tleft: 2px;\n}\n.ui-datepicker .ui-datepicker-next {\n\tright: 2px;\n}\n.ui-datepicker .ui-datepicker-prev-hover {\n\tleft: 1px;\n}\n.ui-datepicker .ui-datepicker-next-hover {\n\tright: 1px;\n}\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n\tdisplay: block;\n\tposition: absolute;\n\tleft: 50%;\n\tmargin-left: -8px;\n\ttop: 50%;\n\tmargin-top: -8px;\n}\n.ui-datepicker .ui-datepicker-title {\n\tmargin: 0 2.3em;\n\tline-height: 1.8em;\n\ttext-align: center;\n}\n.ui-datepicker .ui-datepicker-title select {\n\tfont-size: 1em;\n\tmargin: 1px 0;\n}\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n\twidth: 45%;\n}\n.ui-datepicker table {\n\twidth: 100%;\n\tfont-size: .9em;\n\tborder-collapse: collapse;\n\tmargin: 0 0 .4em;\n}\n.ui-datepicker th {\n\tpadding: .7em .3em;\n\ttext-align: center;\n\tfont-weight: bold;\n\tborder: 0;\n}\n.ui-datepicker td {\n\tborder: 0;\n\tpadding: 1px;\n}\n.ui-datepicker td span,\n.ui-datepicker td a {\n\tdisplay: block;\n\tpadding: .2em;\n\ttext-align: right;\n\ttext-decoration: none;\n}\n.ui-datepicker .ui-datepicker-buttonpane {\n\tbackground-image: none;\n\tmargin: .7em 0 0 0;\n\tpadding: 0 .2em;\n\tborder-left: 0;\n\tborder-right: 0;\n\tborder-bottom: 0;\n}\n.ui-datepicker .ui-datepicker-buttonpane button {\n\tfloat: right;\n\tmargin: .5em .2em .4em;\n\tcursor: pointer;\n\tpadding: .2em .6em .3em .6em;\n\twidth: auto;\n\toverflow: visible;\n}\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\n\tfloat: left;\n}\n\n/* with multiple calendars */\n.ui-datepicker.ui-datepicker-multi {\n\twidth: auto;\n}\n.ui-datepicker-multi .ui-datepicker-group {\n\tfloat: left;\n}\n.ui-datepicker-multi .ui-datepicker-group table {\n\twidth: 95%;\n\tmargin: 0 auto .4em;\n}\n.ui-datepicker-multi-2 .ui-datepicker-group {\n\twidth: 50%;\n}\n.ui-datepicker-multi-3 .ui-datepicker-group {\n\twidth: 33.3%;\n}\n.ui-datepicker-multi-4 .ui-datepicker-group {\n\twidth: 25%;\n}\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n\tborder-left-width: 0;\n}\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n\tclear: left;\n}\n.ui-datepicker-row-break {\n\tclear: both;\n\twidth: 100%;\n\tfont-size: 0;\n}\n\n/* RTL support */\n.ui-datepicker-rtl {\n\tdirection: rtl;\n}\n.ui-datepicker-rtl .ui-datepicker-prev {\n\tright: 2px;\n\tleft: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-next {\n\tleft: 2px;\n\tright: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n\tright: 1px;\n\tleft: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n\tleft: 1px;\n\tright: auto;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n\tclear: right;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n\tfloat: left;\n}\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n\tfloat: right;\n}\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n\tborder-right-width: 0;\n\tborder-left-width: 1px;\n}\n.ui-dialog {\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tpadding: .2em;\n\toutline: 0;\n}\n.ui-dialog .ui-dialog-titlebar {\n\tpadding: .4em 1em;\n\tposition: relative;\n}\n.ui-dialog .ui-dialog-title {\n\tfloat: left;\n\tmargin: .1em 0;\n\twhite-space: nowrap;\n\twidth: 90%;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n.ui-dialog .ui-dialog-titlebar-close {\n\tposition: absolute;\n\tright: .3em;\n\ttop: 50%;\n\twidth: 20px;\n\tmargin: -10px 0 0 0;\n\tpadding: 1px;\n\theight: 20px;\n}\n.ui-dialog .ui-dialog-content {\n\tposition: relative;\n\tborder: 0;\n\tpadding: .5em 1em;\n\tbackground: none;\n\toverflow: auto;\n}\n.ui-dialog .ui-dialog-buttonpane {\n\ttext-align: left;\n\tborder-width: 1px 0 0 0;\n\tbackground-image: none;\n\tmargin-top: .5em;\n\tpadding: .3em 1em .5em .4em;\n}\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n\tfloat: right;\n}\n.ui-dialog .ui-dialog-buttonpane button {\n\tmargin: .5em .4em .5em 0;\n\tcursor: pointer;\n}\n.ui-dialog .ui-resizable-se {\n\twidth: 12px;\n\theight: 12px;\n\tright: -5px;\n\tbottom: -5px;\n\tbackground-position: 16px 16px;\n}\n.ui-draggable .ui-dialog-titlebar {\n\tcursor: move;\n}\n.ui-draggable-handle {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-menu {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n\tdisplay: block;\n\toutline: none;\n}\n.ui-menu .ui-menu {\n\tposition: absolute;\n}\n.ui-menu .ui-menu-item {\n\tposition: relative;\n\tmargin: 0;\n\tpadding: 3px 1em 3px .4em;\n\tcursor: pointer;\n\tmin-height: 0; /* support: IE7 */\n\t/* support: IE10, see #8844 */\n\tlist-style-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\n}\n.ui-menu .ui-menu-divider {\n\tmargin: 5px 0;\n\theight: 0;\n\tfont-size: 0;\n\tline-height: 0;\n\tborder-width: 1px 0 0 0;\n}\n.ui-menu .ui-state-focus,\n.ui-menu .ui-state-active {\n\tmargin: -1px;\n}\n\n/* icon support */\n.ui-menu-icons {\n\tposition: relative;\n}\n.ui-menu-icons .ui-menu-item {\n\tpadding-left: 2em;\n}\n\n/* left-aligned */\n.ui-menu .ui-icon {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: .2em;\n\tmargin: auto 0;\n}\n\n/* right-aligned */\n.ui-menu .ui-menu-icon {\n\tleft: auto;\n\tright: 0;\n}\n.ui-progressbar {\n\theight: 2em;\n\ttext-align: left;\n\toverflow: hidden;\n}\n.ui-progressbar .ui-progressbar-value {\n\tmargin: -1px;\n\theight: 100%;\n}\n.ui-progressbar .ui-progressbar-overlay {\n\tbackground: url(\"data:image/gif;base64,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\");\n\theight: 100%;\n\tfilter: alpha(opacity=25); /* support: IE8 */\n\topacity: 0.25;\n}\n.ui-progressbar-indeterminate .ui-progressbar-value {\n\tbackground-image: none;\n}\n.ui-resizable {\n\tposition: relative;\n}\n.ui-resizable-handle {\n\tposition: absolute;\n\tfont-size: 0.1px;\n\tdisplay: block;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n\tdisplay: none;\n}\n.ui-resizable-n {\n\tcursor: n-resize;\n\theight: 7px;\n\twidth: 100%;\n\ttop: -5px;\n\tleft: 0;\n}\n.ui-resizable-s {\n\tcursor: s-resize;\n\theight: 7px;\n\twidth: 100%;\n\tbottom: -5px;\n\tleft: 0;\n}\n.ui-resizable-e {\n\tcursor: e-resize;\n\twidth: 7px;\n\tright: -5px;\n\ttop: 0;\n\theight: 100%;\n}\n.ui-resizable-w {\n\tcursor: w-resize;\n\twidth: 7px;\n\tleft: -5px;\n\ttop: 0;\n\theight: 100%;\n}\n.ui-resizable-se {\n\tcursor: se-resize;\n\twidth: 12px;\n\theight: 12px;\n\tright: 1px;\n\tbottom: 1px;\n}\n.ui-resizable-sw {\n\tcursor: sw-resize;\n\twidth: 9px;\n\theight: 9px;\n\tleft: -5px;\n\tbottom: -5px;\n}\n.ui-resizable-nw {\n\tcursor: nw-resize;\n\twidth: 9px;\n\theight: 9px;\n\tleft: -5px;\n\ttop: -5px;\n}\n.ui-resizable-ne {\n\tcursor: ne-resize;\n\twidth: 9px;\n\theight: 9px;\n\tright: -5px;\n\ttop: -5px;\n}\n.ui-selectable {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-selectable-helper {\n\tposition: absolute;\n\tz-index: 100;\n\tborder: 1px dotted black;\n}\n.ui-selectmenu-menu {\n\tpadding: 0;\n\tmargin: 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tdisplay: none;\n}\n.ui-selectmenu-menu .ui-menu {\n\toverflow: auto;\n\t/* Support: IE7 */\n\toverflow-x: hidden;\n\tpadding-bottom: 1px;\n}\n.ui-selectmenu-menu .ui-menu .ui-selectmenu-optgroup {\n\tfont-size: 1em;\n\tfont-weight: bold;\n\tline-height: 1.5;\n\tpadding: 2px 0.4em;\n\tmargin: 0.5em 0 0 0;\n\theight: auto;\n\tborder: 0;\n}\n.ui-selectmenu-open {\n\tdisplay: block;\n}\n.ui-selectmenu-button {\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tposition: relative;\n\ttext-decoration: none;\n\tcursor: pointer;\n}\n.ui-selectmenu-button span.ui-icon {\n\tright: 0.5em;\n\tleft: auto;\n\tmargin-top: -8px;\n\tposition: absolute;\n\ttop: 50%;\n}\n.ui-selectmenu-button span.ui-selectmenu-text {\n\ttext-align: left;\n\tpadding: 0.4em 2.1em 0.4em 1em;\n\tdisplay: block;\n\tline-height: 1.4;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n.ui-slider {\n\tposition: relative;\n\ttext-align: left;\n}\n.ui-slider .ui-slider-handle {\n\tposition: absolute;\n\tz-index: 2;\n\twidth: 1.2em;\n\theight: 1.2em;\n\tcursor: default;\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-slider .ui-slider-range {\n\tposition: absolute;\n\tz-index: 1;\n\tfont-size: .7em;\n\tdisplay: block;\n\tborder: 0;\n\tbackground-position: 0 0;\n}\n\n/* support: IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n\tfilter: inherit;\n}\n\n.ui-slider-horizontal {\n\theight: .8em;\n}\n.ui-slider-horizontal .ui-slider-handle {\n\ttop: -.3em;\n\tmargin-left: -.6em;\n}\n.ui-slider-horizontal .ui-slider-range {\n\ttop: 0;\n\theight: 100%;\n}\n.ui-slider-horizontal .ui-slider-range-min {\n\tleft: 0;\n}\n.ui-slider-horizontal .ui-slider-range-max {\n\tright: 0;\n}\n\n.ui-slider-vertical {\n\twidth: .8em;\n\theight: 100px;\n}\n.ui-slider-vertical .ui-slider-handle {\n\tleft: -.3em;\n\tmargin-left: 0;\n\tmargin-bottom: -.6em;\n}\n.ui-slider-vertical .ui-slider-range {\n\tleft: 0;\n\twidth: 100%;\n}\n.ui-slider-vertical .ui-slider-range-min {\n\tbottom: 0;\n}\n.ui-slider-vertical .ui-slider-range-max {\n\ttop: 0;\n}\n.ui-sortable-handle {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-spinner {\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tpadding: 0;\n\tvertical-align: middle;\n}\n.ui-spinner-input {\n\tborder: none;\n\tbackground: none;\n\tcolor: inherit;\n\tpadding: 0;\n\tmargin: .2em 0;\n\tvertical-align: middle;\n\tmargin-left: .4em;\n\tmargin-right: 22px;\n}\n.ui-spinner-button {\n\twidth: 16px;\n\theight: 50%;\n\tfont-size: .5em;\n\tpadding: 0;\n\tmargin: 0;\n\ttext-align: center;\n\tposition: absolute;\n\tcursor: default;\n\tdisplay: block;\n\toverflow: hidden;\n\tright: 0;\n}\n/* more specificity required here to override default borders */\n.ui-spinner a.ui-spinner-button {\n\tborder-top: none;\n\tborder-bottom: none;\n\tborder-right: none;\n}\n/* vertically center icon */\n.ui-spinner .ui-icon {\n\tposition: absolute;\n\tmargin-top: -8px;\n\ttop: 50%;\n\tleft: 0;\n}\n.ui-spinner-up {\n\ttop: 0;\n}\n.ui-spinner-down {\n\tbottom: 0;\n}\n\n/* TR overrides */\n.ui-spinner .ui-icon-triangle-1-s {\n\t/* need to fix icons sprite */\n\tbackground-position: -65px -16px;\n}\n.ui-tabs {\n\tposition: relative;/* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\n\tpadding: .2em;\n}\n.ui-tabs .ui-tabs-nav {\n\tmargin: 0;\n\tpadding: .2em .2em 0;\n}\n.ui-tabs .ui-tabs-nav li {\n\tlist-style: none;\n\tfloat: left;\n\tposition: relative;\n\ttop: 0;\n\tmargin: 1px .2em 0 0;\n\tborder-bottom-width: 0;\n\tpadding: 0;\n\twhite-space: nowrap;\n}\n.ui-tabs .ui-tabs-nav .ui-tabs-anchor {\n\tfloat: left;\n\tpadding: .5em 1em;\n\ttext-decoration: none;\n}\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n\tmargin-bottom: -1px;\n\tpadding-bottom: 1px;\n}\n.ui-tabs .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-state-disabled .ui-tabs-anchor,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading .ui-tabs-anchor {\n\tcursor: text;\n}\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active .ui-tabs-anchor {\n\tcursor: pointer;\n}\n.ui-tabs .ui-tabs-panel {\n\tdisplay: block;\n\tborder-width: 0;\n\tpadding: 1em 1.4em;\n\tbackground: none;\n}\n.ui-tooltip {\n\tpadding: 8px;\n\tposition: absolute;\n\tz-index: 9999;\n\tmax-width: 300px;\n\t-webkit-box-shadow: 0 0 5px #aaa;\n\tbox-shadow: 0 0 5px #aaa;\n}\nbody .ui-tooltip {\n\tborder-width: 2px;\n}\n\n/* Component containers\n----------------------------------*/\n.ui-widget {\n\tfont-family: Verdana,Arial,sans-serif;\n\tfont-size: 1.1em;\n}\n.ui-widget .ui-widget {\n\tfont-size: 1em;\n}\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n\tfont-family: Verdana,Arial,sans-serif;\n\tfont-size: 1em;\n}\n.ui-widget-content {\n\tborder: 1px solid #aaaaaa;\n\tbackground: #ffffff url(" + escape(__webpack_require__(592)) + ") 50% 50% repeat-x;\n\tcolor: #222222;\n}\n.ui-widget-content a {\n\tcolor: #222222;\n}\n.ui-widget-header {\n\tborder: 1px solid #aaaaaa;\n\tbackground: #cccccc url(" + escape(__webpack_require__(593)) + ") 50% 50% repeat-x;\n\tcolor: #222222;\n\tfont-weight: bold;\n}\n.ui-widget-header a {\n\tcolor: #222222;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n\tborder: 1px solid #d3d3d3;\n\tbackground: #e6e6e6 url(" + escape(__webpack_require__(594)) + ") 50% 50% repeat-x;\n\tfont-weight: normal;\n\tcolor: #555555;\n}\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited {\n\tcolor: #555555;\n\ttext-decoration: none;\n}\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus {\n\tborder: 1px solid #999999;\n\tbackground: #dadada url(" + escape(__webpack_require__(595)) + ") 50% 50% repeat-x;\n\tfont-weight: normal;\n\tcolor: #212121;\n}\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited {\n\tcolor: #212121;\n\ttext-decoration: none;\n}\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active {\n\tborder: 1px solid #aaaaaa;\n\tbackground: #ffffff url(" + escape(__webpack_require__(596)) + ") 50% 50% repeat-x;\n\tfont-weight: normal;\n\tcolor: #212121;\n}\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n\tcolor: #212121;\n\ttext-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n\tborder: 1px solid #fcefa1;\n\tbackground: #fbf9ee url(" + escape(__webpack_require__(597)) + ") 50% 50% repeat-x;\n\tcolor: #363636;\n}\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n\tcolor: #363636;\n}\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n\tborder: 1px solid #cd0a0a;\n\tbackground: #fef1ec url(" + escape(__webpack_require__(598)) + ") 50% 50% repeat-x;\n\tcolor: #cd0a0a;\n}\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n\tcolor: #cd0a0a;\n}\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n\tcolor: #cd0a0a;\n}\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n\tfont-weight: bold;\n}\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n\topacity: .7;\n\tfilter:Alpha(Opacity=70); /* support: IE8 */\n\tfont-weight: normal;\n}\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n\topacity: .35;\n\tfilter:Alpha(Opacity=35); /* support: IE8 */\n\tbackground-image: none;\n}\n.ui-state-disabled .ui-icon {\n\tfilter:Alpha(Opacity=35); /* support: IE8 - See #6059 */\n}\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n\twidth: 16px;\n\theight: 16px;\n}\n.ui-icon,\n.ui-widget-content .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(252)) + ");\n}\n.ui-widget-header .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(252)) + ");\n}\n.ui-state-default .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(599)) + ");\n}\n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(253)) + ");\n}\n.ui-state-active .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(253)) + ");\n}\n.ui-state-highlight .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(600)) + ");\n}\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n\tbackground-image: url(" + escape(__webpack_require__(601)) + ");\n}\n\n/* positioning */\n.ui-icon-blank { background-position: 16px 16px; }\n.ui-icon-carat-1-n { background-position: 0 0; }\n.ui-icon-carat-1-ne { background-position: -16px 0; }\n.ui-icon-carat-1-e { background-position: -32px 0; }\n.ui-icon-carat-1-se { background-position: -48px 0; }\n.ui-icon-carat-1-s { background-position: -64px 0; }\n.ui-icon-carat-1-sw { background-position: -80px 0; }\n.ui-icon-carat-1-w { background-position: -96px 0; }\n.ui-icon-carat-1-nw { background-position: -112px 0; }\n.ui-icon-carat-2-n-s { background-position: -128px 0; }\n.ui-icon-carat-2-e-w { background-position: -144px 0; }\n.ui-icon-triangle-1-n { background-position: 0 -16px; }\n.ui-icon-triangle-1-ne { background-position: -16px -16px; }\n.ui-icon-triangle-1-e { background-position: -32px -16px; }\n.ui-icon-triangle-1-se { background-position: -48px -16px; }\n.ui-icon-triangle-1-s { background-position: -64px -16px; }\n.ui-icon-triangle-1-sw { background-position: -80px -16px; }\n.ui-icon-triangle-1-w { background-position: -96px -16px; }\n.ui-icon-triangle-1-nw { background-position: -112px -16px; }\n.ui-icon-triangle-2-n-s { background-position: -128px -16px; }\n.ui-icon-triangle-2-e-w { background-position: -144px -16px; }\n.ui-icon-arrow-1-n { background-position: 0 -32px; }\n.ui-icon-arrow-1-ne { background-position: -16px -32px; }\n.ui-icon-arrow-1-e { background-position: -32px -32px; }\n.ui-icon-arrow-1-se { background-position: -48px -32px; }\n.ui-icon-arrow-1-s { background-position: -64px -32px; }\n.ui-icon-arrow-1-sw { background-position: -80px -32px; }\n.ui-icon-arrow-1-w { background-position: -96px -32px; }\n.ui-icon-arrow-1-nw { background-position: -112px -32px; }\n.ui-icon-arrow-2-n-s { background-position: -128px -32px; }\n.ui-icon-arrow-2-ne-sw { background-position: -144px -32px; }\n.ui-icon-arrow-2-e-w { background-position: -160px -32px; }\n.ui-icon-arrow-2-se-nw { background-position: -176px -32px; }\n.ui-icon-arrowstop-1-n { background-position: -192px -32px; }\n.ui-icon-arrowstop-1-e { background-position: -208px -32px; }\n.ui-icon-arrowstop-1-s { background-position: -224px -32px; }\n.ui-icon-arrowstop-1-w { background-position: -240px -32px; }\n.ui-icon-arrowthick-1-n { background-position: 0 -48px; }\n.ui-icon-arrowthick-1-ne { background-position: -16px -48px; }\n.ui-icon-arrowthick-1-e { background-position: -32px -48px; }\n.ui-icon-arrowthick-1-se { background-position: -48px -48px; }\n.ui-icon-arrowthick-1-s { background-position: -64px -48px; }\n.ui-icon-arrowthick-1-sw { background-position: -80px -48px; }\n.ui-icon-arrowthick-1-w { background-position: -96px -48px; }\n.ui-icon-arrowthick-1-nw { background-position: -112px -48px; }\n.ui-icon-arrowthick-2-n-s { background-position: -128px -48px; }\n.ui-icon-arrowthick-2-ne-sw { background-position: -144px -48px; }\n.ui-icon-arrowthick-2-e-w { background-position: -160px -48px; }\n.ui-icon-arrowthick-2-se-nw { background-position: -176px -48px; }\n.ui-icon-arrowthickstop-1-n { background-position: -192px -48px; }\n.ui-icon-arrowthickstop-1-e { background-position: -208px -48px; }\n.ui-icon-arrowthickstop-1-s { background-position: -224px -48px; }\n.ui-icon-arrowthickstop-1-w { background-position: -240px -48px; }\n.ui-icon-arrowreturnthick-1-w { background-position: 0 -64px; }\n.ui-icon-arrowreturnthick-1-n { background-position: -16px -64px; }\n.ui-icon-arrowreturnthick-1-e { background-position: -32px -64px; }\n.ui-icon-arrowreturnthick-1-s { background-position: -48px -64px; }\n.ui-icon-arrowreturn-1-w { background-position: -64px -64px; }\n.ui-icon-arrowreturn-1-n { background-position: -80px -64px; }\n.ui-icon-arrowreturn-1-e { background-position: -96px -64px; }\n.ui-icon-arrowreturn-1-s { background-position: -112px -64px; }\n.ui-icon-arrowrefresh-1-w { background-position: -128px -64px; }\n.ui-icon-arrowrefresh-1-n { background-position: -144px -64px; }\n.ui-icon-arrowrefresh-1-e { background-position: -160px -64px; }\n.ui-icon-arrowrefresh-1-s { background-position: -176px -64px; }\n.ui-icon-arrow-4 { background-position: 0 -80px; }\n.ui-icon-arrow-4-diag { background-position: -16px -80px; }\n.ui-icon-extlink { background-position: -32px -80px; }\n.ui-icon-newwin { background-position: -48px -80px; }\n.ui-icon-refresh { background-position: -64px -80px; }\n.ui-icon-shuffle { background-position: -80px -80px; }\n.ui-icon-transfer-e-w { background-position: -96px -80px; }\n.ui-icon-transferthick-e-w { background-position: -112px -80px; }\n.ui-icon-folder-collapsed { background-position: 0 -96px; }\n.ui-icon-folder-open { background-position: -16px -96px; }\n.ui-icon-document { background-position: -32px -96px; }\n.ui-icon-document-b { background-position: -48px -96px; }\n.ui-icon-note { background-position: -64px -96px; }\n.ui-icon-mail-closed { background-position: -80px -96px; }\n.ui-icon-mail-open { background-position: -96px -96px; }\n.ui-icon-suitcase { background-position: -112px -96px; }\n.ui-icon-comment { background-position: -128px -96px; }\n.ui-icon-person { background-position: -144px -96px; }\n.ui-icon-print { background-position: -160px -96px; }\n.ui-icon-trash { background-position: -176px -96px; }\n.ui-icon-locked { background-position: -192px -96px; }\n.ui-icon-unlocked { background-position: -208px -96px; }\n.ui-icon-bookmark { background-position: -224px -96px; }\n.ui-icon-tag { background-position: -240px -96px; }\n.ui-icon-home { background-position: 0 -112px; }\n.ui-icon-flag { background-position: -16px -112px; }\n.ui-icon-calendar { background-position: -32px -112px; }\n.ui-icon-cart { background-position: -48px -112px; }\n.ui-icon-pencil { background-position: -64px -112px; }\n.ui-icon-clock { background-position: -80px -112px; }\n.ui-icon-disk { background-position: -96px -112px; }\n.ui-icon-calculator { background-position: -112px -112px; }\n.ui-icon-zoomin { background-position: -128px -112px; }\n.ui-icon-zoomout { background-position: -144px -112px; }\n.ui-icon-search { background-position: -160px -112px; }\n.ui-icon-wrench { background-position: -176px -112px; }\n.ui-icon-gear { background-position: -192px -112px; }\n.ui-icon-heart { background-position: -208px -112px; }\n.ui-icon-star { background-position: -224px -112px; }\n.ui-icon-link { background-position: -240px -112px; }\n.ui-icon-cancel { background-position: 0 -128px; }\n.ui-icon-plus { background-position: -16px -128px; }\n.ui-icon-plusthick { background-position: -32px -128px; }\n.ui-icon-minus { background-position: -48px -128px; }\n.ui-icon-minusthick { background-position: -64px -128px; }\n.ui-icon-close { background-position: -80px -128px; }\n.ui-icon-closethick { background-position: -96px -128px; }\n.ui-icon-key { background-position: -112px -128px; }\n.ui-icon-lightbulb { background-position: -128px -128px; }\n.ui-icon-scissors { background-position: -144px -128px; }\n.ui-icon-clipboard { background-position: -160px -128px; }\n.ui-icon-copy { background-position: -176px -128px; }\n.ui-icon-contact { background-position: -192px -128px; }\n.ui-icon-image { background-position: -208px -128px; }\n.ui-icon-video { background-position: -224px -128px; }\n.ui-icon-script { background-position: -240px -128px; }\n.ui-icon-alert { background-position: 0 -144px; }\n.ui-icon-info { background-position: -16px -144px; }\n.ui-icon-notice { background-position: -32px -144px; }\n.ui-icon-help { background-position: -48px -144px; }\n.ui-icon-check { background-position: -64px -144px; }\n.ui-icon-bullet { background-position: -80px -144px; }\n.ui-icon-radio-on { background-position: -96px -144px; }\n.ui-icon-radio-off { background-position: -112px -144px; }\n.ui-icon-pin-w { background-position: -128px -144px; }\n.ui-icon-pin-s { background-position: -144px -144px; }\n.ui-icon-play { background-position: 0 -160px; }\n.ui-icon-pause { background-position: -16px -160px; }\n.ui-icon-seek-next { background-position: -32px -160px; }\n.ui-icon-seek-prev { background-position: -48px -160px; }\n.ui-icon-seek-end { background-position: -64px -160px; }\n.ui-icon-seek-start { background-position: -80px -160px; }\n/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */\n.ui-icon-seek-first { background-position: -80px -160px; }\n.ui-icon-stop { background-position: -96px -160px; }\n.ui-icon-eject { background-position: -112px -160px; }\n.ui-icon-volume-off { background-position: -128px -160px; }\n.ui-icon-volume-on { background-position: -144px -160px; }\n.ui-icon-power { background-position: 0 -176px; }\n.ui-icon-signal-diag { background-position: -16px -176px; }\n.ui-icon-signal { background-position: -32px -176px; }\n.ui-icon-battery-0 { background-position: -48px -176px; }\n.ui-icon-battery-1 { background-position: -64px -176px; }\n.ui-icon-battery-2 { background-position: -80px -176px; }\n.ui-icon-battery-3 { background-position: -96px -176px; }\n.ui-icon-circle-plus { background-position: 0 -192px; }\n.ui-icon-circle-minus { background-position: -16px -192px; }\n.ui-icon-circle-close { background-position: -32px -192px; }\n.ui-icon-circle-triangle-e { background-position: -48px -192px; }\n.ui-icon-circle-triangle-s { background-position: -64px -192px; }\n.ui-icon-circle-triangle-w { background-position: -80px -192px; }\n.ui-icon-circle-triangle-n { background-position: -96px -192px; }\n.ui-icon-circle-arrow-e { background-position: -112px -192px; }\n.ui-icon-circle-arrow-s { background-position: -128px -192px; }\n.ui-icon-circle-arrow-w { background-position: -144px -192px; }\n.ui-icon-circle-arrow-n { background-position: -160px -192px; }\n.ui-icon-circle-zoomin { background-position: -176px -192px; }\n.ui-icon-circle-zoomout { background-position: -192px -192px; }\n.ui-icon-circle-check { background-position: -208px -192px; }\n.ui-icon-circlesmall-plus { background-position: 0 -208px; }\n.ui-icon-circlesmall-minus { background-position: -16px -208px; }\n.ui-icon-circlesmall-close { background-position: -32px -208px; }\n.ui-icon-squaresmall-plus { background-position: -48px -208px; }\n.ui-icon-squaresmall-minus { background-position: -64px -208px; }\n.ui-icon-squaresmall-close { background-position: -80px -208px; }\n.ui-icon-grip-dotted-vertical { background-position: 0 -224px; }\n.ui-icon-grip-dotted-horizontal { background-position: -16px -224px; }\n.ui-icon-grip-solid-vertical { background-position: -32px -224px; }\n.ui-icon-grip-solid-horizontal { background-position: -48px -224px; }\n.ui-icon-gripsmall-diagonal-se { background-position: -64px -224px; }\n.ui-icon-grip-diagonal-se { background-position: -80px -224px; }\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Corner radius */\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n\tborder-top-left-radius: 4px;\n}\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n\tborder-top-right-radius: 4px;\n}\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n\tborder-bottom-left-radius: 4px;\n}\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n\tborder-bottom-right-radius: 4px;\n}\n\n/* Overlays */\n.ui-widget-overlay {\n\tbackground: #aaaaaa url(" + escape(__webpack_require__(254)) + ") 50% 50% repeat-x;\n\topacity: .3;\n\tfilter: Alpha(Opacity=30); /* support: IE8 */\n}\n.ui-widget-shadow {\n\tmargin: -8px 0 0 -8px;\n\tpadding: 8px;\n\tbackground: #aaaaaa url(" + escape(__webpack_require__(254)) + ") 50% 50% repeat-x;\n\topacity: .3;\n\tfilter: Alpha(Opacity=30); /* support: IE8 */\n\tborder-radius: 8px;\n}\n", ""]);

// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cc546fa0a4b98fad0917c5693587bc6b.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac76811df9c1bf8af392f21e7cb9dff7.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7de5a7addad547244d33f4209e3d6306.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "04646fb634cba8c8b6487d26200c5fcc.png";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "487b704edf1cf3ce0f8c153bb29652cf.png";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3c59f14abdbc105190b9db0ec30c232c.png";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9a3f2305cb5cb2921ca7184bd955744e.png";

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e63c67228df4a03cd91321bdf98e7555.png";

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "14d55152e99f22245c9e1e8bb784a7f6.png";

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b00a65a4b157ec627ee9ff4d0c8f1176.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes medium-editor-image-loading {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes medium-editor-image-loading {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes medium-editor-pop-upwards {\n  0% {\n    opacity: 0;\n    -webkit-transform: matrix(0.97, 0, 0, 1, 0, 12);\n            transform: matrix(0.97, 0, 0, 1, 0, 12); }\n  20% {\n    opacity: .7;\n    -webkit-transform: matrix(0.99, 0, 0, 1, 0, 2);\n            transform: matrix(0.99, 0, 0, 1, 0, 2); }\n  40% {\n    opacity: 1;\n    -webkit-transform: matrix(1, 0, 0, 1, 0, -1);\n            transform: matrix(1, 0, 0, 1, 0, -1); }\n  100% {\n    -webkit-transform: matrix(1, 0, 0, 1, 0, 0);\n            transform: matrix(1, 0, 0, 1, 0, 0); } }\n\n@keyframes medium-editor-pop-upwards {\n  0% {\n    opacity: 0;\n    -webkit-transform: matrix(0.97, 0, 0, 1, 0, 12);\n            transform: matrix(0.97, 0, 0, 1, 0, 12); }\n  20% {\n    opacity: .7;\n    -webkit-transform: matrix(0.99, 0, 0, 1, 0, 2);\n            transform: matrix(0.99, 0, 0, 1, 0, 2); }\n  40% {\n    opacity: 1;\n    -webkit-transform: matrix(1, 0, 0, 1, 0, -1);\n            transform: matrix(1, 0, 0, 1, 0, -1); }\n  100% {\n    -webkit-transform: matrix(1, 0, 0, 1, 0, 0);\n            transform: matrix(1, 0, 0, 1, 0, 0); } }\n\n.medium-editor-anchor-preview {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  left: 0;\n  line-height: 1.4;\n  max-width: 280px;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  word-break: break-all;\n  word-wrap: break-word;\n  visibility: hidden;\n  z-index: 2000; }\n  .medium-editor-anchor-preview a {\n    color: #fff;\n    display: inline-block;\n    margin: 5px 5px 10px; }\n\n.medium-editor-anchor-preview-active {\n  visibility: visible; }\n\n.medium-editor-dragover {\n  background: #ddd; }\n\n.medium-editor-image-loading {\n  -webkit-animation: medium-editor-image-loading 1s infinite ease-in-out;\n          animation: medium-editor-image-loading 1s infinite ease-in-out;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  height: 40px;\n  width: 40px; }\n\n.medium-editor-placeholder {\n  position: relative; }\n  .medium-editor-placeholder:after {\n    content: attr(data-placeholder) !important;\n    font-style: italic;\n    position: absolute;\n    left: 0;\n    top: 0;\n    white-space: pre;\n    padding: inherit;\n    margin: inherit; }\n\n.medium-editor-placeholder-relative {\n  position: relative; }\n  .medium-editor-placeholder-relative:after {\n    content: attr(data-placeholder) !important;\n    font-style: italic;\n    position: relative;\n    white-space: pre;\n    padding: inherit;\n    margin: inherit; }\n\n.medium-toolbar-arrow-under:after, .medium-toolbar-arrow-over:before {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  left: 50%;\n  margin-left: -8px;\n  position: absolute;\n  width: 0; }\n\n.medium-toolbar-arrow-under:after {\n  border-width: 8px 8px 0 8px; }\n\n.medium-toolbar-arrow-over:before {\n  border-width: 0 8px 8px 8px;\n  top: -8px; }\n\n.medium-editor-toolbar {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  visibility: hidden;\n  z-index: 2000; }\n  .medium-editor-toolbar ul {\n    margin: 0;\n    padding: 0; }\n  .medium-editor-toolbar li {\n    float: left;\n    list-style: none;\n    margin: 0;\n    padding: 0; }\n    .medium-editor-toolbar li button {\n      box-sizing: border-box;\n      cursor: pointer;\n      display: block;\n      font-size: 14px;\n      line-height: 1.33;\n      margin: 0;\n      padding: 15px;\n      text-decoration: none; }\n      .medium-editor-toolbar li button:focus {\n        outline: none; }\n    .medium-editor-toolbar li .medium-editor-action-underline {\n      text-decoration: underline; }\n    .medium-editor-toolbar li .medium-editor-action-pre {\n      font-family: Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n      font-size: 12px;\n      font-weight: 100;\n      padding: 15px 0; }\n\n.medium-editor-toolbar-active {\n  visibility: visible; }\n\n.medium-editor-sticky-toolbar {\n  position: fixed;\n  top: 1px; }\n\n.medium-editor-relative-toolbar {\n  position: relative; }\n\n.medium-editor-toolbar-active.medium-editor-stalker-toolbar {\n  -webkit-animation: medium-editor-pop-upwards 160ms forwards linear;\n          animation: medium-editor-pop-upwards 160ms forwards linear; }\n\n.medium-editor-action-bold {\n  font-weight: bolder; }\n\n.medium-editor-action-italic {\n  font-style: italic; }\n\n.medium-editor-toolbar-form {\n  display: none; }\n  .medium-editor-toolbar-form input,\n  .medium-editor-toolbar-form a {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif; }\n  .medium-editor-toolbar-form .medium-editor-toolbar-form-row {\n    line-height: 14px;\n    margin-left: 5px;\n    padding-bottom: 5px; }\n  .medium-editor-toolbar-form .medium-editor-toolbar-input,\n  .medium-editor-toolbar-form label {\n    border: none;\n    box-sizing: border-box;\n    font-size: 14px;\n    margin: 0;\n    padding: 6px;\n    width: 316px;\n    display: inline-block; }\n    .medium-editor-toolbar-form .medium-editor-toolbar-input:focus,\n    .medium-editor-toolbar-form label:focus {\n      -webkit-appearance: none;\n         -moz-appearance: none;\n              appearance: none;\n      border: none;\n      box-shadow: none;\n      outline: 0; }\n  .medium-editor-toolbar-form a {\n    display: inline-block;\n    font-size: 24px;\n    font-weight: bolder;\n    margin: 0 10px;\n    text-decoration: none; }\n\n.medium-editor-toolbar-form-active {\n  display: block; }\n\n.medium-editor-toolbar-actions:after {\n  clear: both;\n  content: \"\";\n  display: table; }\n\n.medium-editor-element {\n  word-wrap: break-word;\n  min-height: 30px; }\n  .medium-editor-element img {\n    max-width: 100%; }\n  .medium-editor-element sub {\n    vertical-align: sub; }\n  .medium-editor-element sup {\n    vertical-align: super; }\n\n.medium-editor-hidden {\n  display: none; }\n", ""]);

// exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".medium-editor-table-builder {\n  display: none;\n  position: absolute;\n  left: 0;\n  top: 101%; }\n  .medium-editor-table-builder * {\n    box-sizing: border-box; }\n\n.medium-editor-table-builder-grid {\n  border: 1px solid #000;\n  border-radius: 3px;\n  overflow: hidden; }\n\n.medium-editor-table-builder-cell {\n  background-color: #333;\n  border: 1px solid #000;\n  display: block;\n  float: left;\n  height: 16px;\n  margin: 0;\n  width: 16px; }\n  .medium-editor-table-builder-cell.active {\n    background-color: #ccc; }\n\n.medium-editor-table-builder-cell:hover {\n  background-color: #ccc; }\n\n.medium-editor-table {\n  border-collapse: collapse;\n  resize: both;\n  table-layout: fixed; }\n\n.medium-editor-table,\n.medium-editor-table td {\n  border: 1px dashed #e3e3e3; }\n\n.medium-editor-table-builder-toolbar {\n  display: block;\n  min-width: 162px;\n  background-color: #333;\n  font-size: 0.8em;\n  color: white; }\n  .medium-editor-table-builder-toolbar span {\n    width: 45px;\n    display: block;\n    float: left;\n    margin-left: 5px; }\n  .medium-editor-table-builder-toolbar button {\n    margin: 0 3px;\n    background-color: #333;\n    border: 0;\n    width: 30px;\n    cursor: pointer; }\n    .medium-editor-table-builder-toolbar button i {\n      color: white; }\n", ""]);

// exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/**\n * Owl Carousel v2.2.0\n * Copyright 2013-2016 David Deutsch\n * Licensed under MIT (https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE)\n */\n.owl-carousel,.owl-carousel .owl-item{-webkit-tap-highlight-color:transparent;position:relative}.owl-carousel{display:none;width:100%;z-index:1}.owl-carousel .owl-stage{position:relative;-ms-touch-action:pan-Y}.owl-carousel .owl-stage:after{content:\".\";display:block;clear:both;visibility:hidden;line-height:0;height:0}.owl-carousel .owl-stage-outer{position:relative;overflow:hidden;-webkit-transform:translate3d(0,0,0)}.owl-carousel .owl-item{min-height:1px;float:left;-webkit-backface-visibility:hidden;-webkit-touch-callout:none}.owl-carousel .owl-item img{display:block;width:100%;-webkit-transform-style:preserve-3d}.owl-carousel .owl-dots.disabled,.owl-carousel .owl-nav.disabled{display:none}.no-js .owl-carousel,.owl-carousel.owl-loaded{display:block}.owl-carousel .owl-dot,.owl-carousel .owl-nav .owl-next,.owl-carousel .owl-nav .owl-prev{cursor:pointer;cursor:hand;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-loading{opacity:0;display:block}.owl-carousel.owl-hidden{opacity:0}.owl-carousel.owl-refresh .owl-item{visibility:hidden}.owl-carousel.owl-drag .owl-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.owl-carousel.owl-grab{cursor:move;cursor:grab}.owl-carousel.owl-rtl{direction:rtl}.owl-carousel.owl-rtl .owl-item{float:right}.owl-carousel .animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.owl-carousel .owl-animated-in{z-index:0}.owl-carousel .owl-animated-out{z-index:1}.owl-carousel .fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}.owl-height{transition:height .5s ease-in-out}.owl-carousel .owl-item .owl-lazy{opacity:0;transition:opacity .4s ease}.owl-carousel .owl-item img.owl-lazy{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.owl-carousel .owl-video-wrapper{position:relative;height:100%;background:#000}.owl-carousel .owl-video-play-icon{position:absolute;height:80px;width:80px;left:50%;top:50%;margin-left:-40px;margin-top:-40px;background:url(" + escape(__webpack_require__(605)) + ") no-repeat;cursor:pointer;z-index:1;-webkit-backface-visibility:hidden;transition:-webkit-transform .1s ease;transition:transform .1s ease}.owl-carousel .owl-video-play-icon:hover{-webkit-transform:scale(1.3,1.3);-ms-transform:scale(1.3,1.3);transform:scale(1.3,1.3)}.owl-carousel .owl-video-playing .owl-video-play-icon,.owl-carousel .owl-video-playing .owl-video-tn{display:none}.owl-carousel .owl-video-tn{opacity:0;height:100%;background-position:center center;background-repeat:no-repeat;background-size:contain;transition:opacity .4s ease}.owl-carousel .owl-video-frame{position:relative;z-index:1;height:100%;width:100%}", ""]);

// exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4a37f8008959c75f619bf0a3a4e2d7a2.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";\n.red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n/**\n * SD Reboot\n */\n* {\n  box-sizing: border-box; }\n\n*::before,\n*::after {\n  box-sizing: inherit; }\n\n:focus,\nselect:focus,\nselect:active {\n  outline: none; }\n\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: transparent; }\n\nbody {\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 1.3rem;\n  line-height: 1.8rem; }\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  margin: 0;\n  border-radius: 0; }\n\ninput[type=\"search\"] {\n  box-sizing: border-box; }\n\nbutton {\n  border: 0;\n  background: transparent;\n  cursor: pointer; }\n\nbutton {\n  color: inherit; }\n\n.fade.ng-hide {\n  opacity: 0; }\n\n.fade.ng-hide-remove,\n.fade.ng-hide-add {\n  display: block !important; }\n\n.fade.ng-hide-remove {\n  transition: all linear 200ms; }\n\n.fade.ng-hide-add {\n  position: absolute;\n  transition: all linear 300ms; }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0; }\n  50% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes dropOut2 {\n  0% {\n    transform: translateY(-4.8rem); }\n  100% {\n    transform: translateY(0); } }\n\n.sd-card__thumbnail {\n  transition: all 0.2s ease-in;\n  height: 20rem; }\n\n.sd-card__thumbnail.ng-hide {\n  opacity: 0;\n  height: 0.1rem !important; }\n\n.pull-left {\n  float: left; }\n\n.pull-right {\n  float: right; }\n\n.clearfix {\n  *zoom: 1; }\n  .clearfix:before, .clearfix:after {\n    display: table;\n    content: \"\"; }\n  .clearfix:after {\n    clear: both; }\n\n.no-padding {\n  padding: 0 !important; }\n\n.no-margin {\n  margin: 0 !important; }\n\n.no-border {\n  border: 0 !important; }\n\n.no-line-height {\n  line-height: 0 !important; }\n\n.sd-d-none {\n  display: none !important; }\n\n.sd-d-inline {\n  display: inline !important; }\n\n.sd-d-inline-block {\n  display: inline-block !important; }\n\n.sd-d-block {\n  display: block !important; }\n\n.sd-d-flex {\n  display: flex !important; }\n\n.sd-d-inline-flex {\n  display: inline-flex !important; }\n\n.overflow-auto {\n  overflow: auto !important; }\n\n.overflow-hidden {\n  overflow: hidden !important; }\n\n.overflow-x-hidden {\n  overflow-x: hidden !important; }\n\n.sd-shadow--z1 {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16), 0 0 1px rgba(0, 0, 0, 0.1) !important;\n  transition: box-shadow 0.3s ease-out; }\n  .sd-shadow--z1.btn:active {\n    box-shadow: none !important;\n    transition: box-shadow 0.4s ease-out; }\n\n.sd-shadow--z2 {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 0 2px 6px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.1) !important;\n  transition: box-shadow 0.3s ease-out; }\n  .sd-shadow--z2.btn:active {\n    box-shadow: none !important;\n    transition: box-shadow 0.4s ease-out; }\n\n.sd-shadow--z3 {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16), 0 3px 8px rgba(0, 0, 0, 0.24), 0 0 1px rgba(0, 0, 0, 0.1) !important;\n  transition: box-shadow 0.3s ease-out; }\n  .sd-shadow--z3.btn:active {\n    box-shadow: none !important;\n    transition: box-shadow 0.4s ease-out; }\n\n.sd-shadow--z4 {\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.1) !important;\n  transition: box-shadow 0.3s ease-out; }\n  .sd-shadow--z4.btn:active {\n    box-shadow: none !important;\n    transition: box-shadow 0.4s ease-out; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  margin: -1px 0;\n  position: fixed;\n  right: 10px; }\n\n::-webkit-scrollbar:hover {\n  background-color: rgba(140, 140, 140, 0.2);\n  cursor: pointer; }\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.3); }\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.6);\n  cursor: pointer; }\n\n.sd-overflow-ellipsis {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.sd-no-wrap {\n  white-space: nowrap; }\n\n.element-with-badge {\n  display: inline-block;\n  position: relative; }\n  .element-with-badge .badge {\n    position: absolute;\n    top: -.9rem;\n    right: -.9rem; }\n  .element-with-badge + .element-with-badge, .element-with-badge + .btn {\n    margin-left: 1.2rem;\n    vertical-align: top; }\n\n.btn + .element-with-badge {\n  margin-left: 1.2rem;\n  vertical-align: top; }\n\n.sd-heading-3 {\n  font-size: 1.6rem;\n  margin-bottom: 1.6rem; }\n\n.sd-text__slugline {\n  color: #005b7f;\n  font-weight: 500;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  margin-right: 1rem; }\n\np strong {\n  font-weight: 500; }\n\ntime {\n  color: #747474;\n  font-weight: 300;\n  letter-spacing: .025em; }\n  time.small {\n    font-size: calc(100% - 0.1rem); }\n\n.sd-text__date-time {\n  color: #747474;\n  font-weight: 300;\n  letter-spacing: .025em; }\n  .sd-text__date-time--small {\n    font-size: 1.2rem; }\n\n.sd-text__strong {\n  font-weight: 500;\n  font-size: 1.4rem; }\n\n.sd-text__date-and-author {\n  font-size: 1.2rem; }\n\n.sd-text__author {\n  font-weight: 500; }\n\n.sd-text__info {\n  font-weight: 300;\n  color: #747474; }\n\n.sd-text__right {\n  text-align: right; }\n\n.dark-ui .sd-text__slugline {\n  color: #678b98; }\n\n.dashboard-content-header {\n  display: flex;\n  padding: 1.5rem; }\n\n.big-number-block {\n  display: flex;\n  color: #7b7b7b; }\n  .big-number-block__number {\n    font-size: 3.6rem;\n    font-weight: 300;\n    line-height: 100%;\n    letter-spacing: -.02em; }\n  .big-number-block__text {\n    margin: 0 1rem;\n    line-height: 120%;\n    font-weight: 300; }\n  .big-number-block--grow {\n    flex-grow: 1; }\n  .big-number-block--center {\n    align-items: center; }\n\n.dashboard-thumbnail-block {\n  display: flex; }\n  .dashboard-thumbnail-block__image {\n    border: 1px solid #d6d6d6; }\n  .dashboard-thumbnail-block__meta {\n    padding: 0 1rem;\n    display: flex;\n    flex-direction: column; }\n  .dashboard-thumbnail-block__label {\n    font-size: 1.2rem;\n    color: #999; }\n  .dashboard-thumbnail-block__heading {\n    display: flex;\n    font-weight: 700;\n    padding: .3rem 0; }\n    .dashboard-thumbnail-block__heading i {\n      margin-right: .5rem; }\n  .dashboard-thumbnail-block__link {\n    color: #5ea9c8;\n    text-decoration: none;\n    border-bottom: 1px dotted #5ea9c8; }\n    .dashboard-thumbnail-block__link:hover {\n      border-bottom: 1px solid #5ea9c8;\n      text-decoration: none;\n      color: #5ea9c8; }\n\n.sd-text-icon {\n  display: inline-flex; }\n  .sd-text-icon i {\n    margin-right: 0.3rem; }\n\n.sd-text-icon + .sd-text-icon {\n  margin-right: 1rem; }\n\n.sd-text-icon.sd-text-icon--aligned-r + .sd-text-icon.sd-text-icon--aligned-r {\n  margin-right: 0;\n  margin-left: 1rem; }\n\n.sd-opacity--20 {\n  opacity: 0.2 !important; }\n\n.sd-opacity--25 {\n  opacity: 0.25 !important; }\n\n.sd-opacity--30 {\n  opacity: 0.3 !important; }\n\n.sd-opacity--40 {\n  opacity: 0.4 !important; }\n\n.sd-opacity--50 {\n  opacity: 0.5 !important; }\n\n.sd-opacity--60 {\n  opacity: 0.6 !important; }\n\n.sd-opacity--75 {\n  opacity: 0.75 !important; }\n\n.panel-border-left {\n  border-right: 0;\n  border-left: 2px solid rgba(0, 0, 0, 0.4); }\n\n.panel-border-right {\n  border-left: 0;\n  border-right: 2px solid rgba(0, 0, 0, 0.4); }\n\n.ml-auto {\n  margin-left: auto !important; }\n\n.mr-auto {\n  margin-right: auto !important; }\n\n.mt-auto {\n  margin-top: auto !important; }\n\n.mb-auto {\n  margin-bottom: auto !important; }\n\n.sd-display-flex-column {\n  display: flex;\n  flex-direction: column;\n  overflow: auto; }\n\n.sd-flex-wrap {\n  flex-wrap: wrap; }\n\n.sd-flex-shrink {\n  flex-shrink: 1 !important; }\n\n.sd-flex-no-shrink {\n  flex-shrink: 0 !important; }\n\n.sd-flex-justify-end {\n  justify-content: flex-end !important; }\n\n.sd-margin-t--1 {\n  margin-top: 1rem !important; }\n\n.sd-margin-t--2 {\n  margin-top: 2rem !important; }\n\n.sd-margin-t--3 {\n  margin-top: 3rem !important; }\n\n.sd-margin-r--1 {\n  margin-right: 1rem !important; }\n\n.sd-margin-r--2 {\n  margin-right: 2rem !important; }\n\n.sd-margin-r--3 {\n  margin-right: 3rem !important; }\n\n.sd-margin-b--1 {\n  margin-bottom: 1rem !important; }\n\n.sd-margin-b--2 {\n  margin-bottom: 2rem !important; }\n\n.sd-margin-b--3 {\n  margin-bottom: 3rem !important; }\n\n.sd-margin-l--1 {\n  margin-left: 1rem !important; }\n\n.sd-margin-l--2 {\n  margin-left: 2rem !important; }\n\n.sd-margin-l--3 {\n  margin-left: 3rem !important; }\n\n.sd-padding-t--1 {\n  padding-top: 0.8rem !important; }\n\n.sd-padding-t--2 {\n  padding-top: 1.6rem !important; }\n\n.sd-padding-t--3 {\n  padding-top: 2.4rem !important; }\n\n.sd-padding-r--1 {\n  padding-right: 0.8rem !important; }\n\n.sd-padding-r--2 {\n  padding-right: 1.6rem !important; }\n\n.sd-padding-r--3 {\n  padding-right: 2.4rem !important; }\n\n.sd-padding-b--1 {\n  padding-bottom: 0.8rem !important; }\n\n.sd-padding-b--2 {\n  padding-bottom: 1.6rem !important; }\n\n.sd-padding-b--3 {\n  padding-bottom: 2.4rem !important; }\n\n.sd-padding-l--1 {\n  padding-left: 0.8rem !important; }\n\n.sd-padding-l--2 {\n  padding-left: 1.6rem !important; }\n\n.sd-padding-l--3 {\n  padding-left: 2.4rem !important; }\n\n.sd-padding-all--1 {\n  padding: 0.8rem !important; }\n\n.sd-padding-all--2 {\n  padding: 1.6rem !important; }\n\n.sd-padding-all--3 {\n  padding: 2.4rem !important; }\n\n.sd-overlay-block {\n  position: relative; }\n  .sd-overlay-block img {\n    width: 100%; }\n  .sd-overlay-block__overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: 0.2s linear opacity;\n    opacity: 0;\n    color: #fff; }\n  .sd-overlay-block:hover .sd-overlay-block__overlay {\n    opacity: 1; }\n  .sd-overlay-block__overlay-action-group {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1; }\n  .sd-overlay-block__overlay-action {\n    flex-grow: 0;\n    flex-shrink: 0;\n    color: #fff;\n    width: 5.6rem;\n    height: 5.6rem;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    transition: 0.2s linear all;\n    cursor: pointer;\n    text-decoration: none;\n    background-color: transparent; }\n    .sd-overlay-block__overlay-action i {\n      color: #fff;\n      height: 2.4rem;\n      width: 2.4rem;\n      font-size: 2.4rem;\n      line-height: 1;\n      opacity: 0.5;\n      transition: 0.2s linear all; }\n    .sd-overlay-block__overlay-action:hover {\n      border-color: white;\n      background-color: rgba(0, 0, 0, 0.4);\n      text-decoration: none; }\n      .sd-overlay-block__overlay-action:hover i {\n        opacity: 1; }\n    .sd-overlay-block__overlay-action + .sd-overlay-block__overlay-action {\n      margin-left: 2rem; }\n\n.sd-wrap-helper {\n  display: contents !important; }\n\n.btn {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n  padding: 0.7rem 1.4rem;\n  -webkit-appearance: none;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  line-height: 1;\n  font-weight: 400;\n  letter-spacing: 0.1em;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer;\n  background-color: rgba(51, 51, 51, 0.25);\n  color: #333; }\n  .btn:hover, .btn:focus {\n    background-color: rgba(8, 8, 8, 0.25);\n    color: #333;\n    text-decoration: none;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n  .btn:active {\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n    border-width: 1px; }\n  .btn.btn--small {\n    font-size: 1rem;\n    padding: 0.5rem 1rem; }\n  .btn.btn--large {\n    font-size: 1.4rem;\n    padding: 1rem 2rem; }\n  .btn.btn--active {\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n    border-width: 1px; }\n  .btn.btn--expanded {\n    display: block;\n    width: 100%;\n    margin-right: 0;\n    margin-left: 0; }\n  .btn.btn--default {\n    background-color: rgba(51, 51, 51, 0.25);\n    color: #333; }\n    .btn.btn--default:hover, .btn.btn--default:focus {\n      background-color: rgba(41, 41, 41, 0.25);\n      color: #333;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--default:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n  .btn.btn--primary {\n    background-color: #5ea9c8;\n    color: #fff; }\n    .btn.btn--primary:hover, .btn.btn--primary:focus {\n      background-color: #3c8eaf;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--primary:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--primary [class^=\"icon-\"], .btn.btn--primary [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--success {\n    background-color: #46a546;\n    color: #fff; }\n    .btn.btn--success:hover, .btn.btn--success:focus {\n      background-color: #388438;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--success:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--success [class^=\"icon-\"], .btn.btn--success [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--warning {\n    background-color: #dd8200;\n    color: #fff; }\n    .btn.btn--warning:hover, .btn.btn--warning:focus {\n      background-color: #b16800;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--warning:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--warning [class^=\"icon-\"], .btn.btn--warning [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--alert {\n    background-color: #E51C23;\n    color: #fff; }\n    .btn.btn--alert:hover, .btn.btn--alert:focus {\n      background-color: #b8151b;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--alert:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--alert [class^=\"icon-\"], .btn.btn--alert [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--highlight {\n    background-color: #9c27b0;\n    color: #fff; }\n    .btn.btn--highlight:hover, .btn.btn--highlight:focus {\n      background-color: #7d1f8d;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--highlight:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--highlight [class^=\"icon-\"], .btn.btn--highlight [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--sd-green {\n    background-color: #1eb06c;\n    color: #fff; }\n    .btn.btn--sd-green:hover, .btn.btn--sd-green:focus {\n      background-color: #188d56;\n      color: #fff;\n      text-decoration: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3); }\n    .btn.btn--sd-green:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--sd-green [class^=\"icon-\"], .btn.btn--sd-green [class*=\" icon-\"] {\n      color: #fff; }\n  .btn.btn--hollow {\n    border: 1px solid rgba(51, 51, 51, 0.4);\n    color: #333;\n    box-shadow: none; }\n    .btn.btn--hollow, .btn.btn--hollow:hover, .btn.btn--hollow:focus {\n      background-color: transparent; }\n    .btn.btn--hollow:hover, .btn.btn--hollow:focus {\n      border-color: rgba(51, 51, 51, 0.9);\n      color: rgba(51, 51, 51, 0.9); }\n    .btn.btn--hollow:active {\n      box-shadow: inset 0 1px 0 0 #333; }\n    .btn.btn--hollow.btn--default {\n      border: 1px solid rgba(51, 51, 51, 0.4);\n      color: #333;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--default:hover, .btn.btn--hollow.btn--default:focus {\n        border-color: rgba(51, 51, 51, 0.9);\n        color: rgba(51, 51, 51, 0.9); }\n      .btn.btn--hollow.btn--default:active {\n        box-shadow: inset 0 1px 0 0 #333; }\n      .btn.btn--hollow.btn--default [class^=\"icon-\"], .btn.btn--hollow.btn--default [class*=\" icon-\"] {\n        color: #333; }\n    .btn.btn--hollow.btn--primary {\n      border: 1px solid rgba(94, 169, 200, 0.4);\n      color: #5ea9c8;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--primary:hover, .btn.btn--hollow.btn--primary:focus {\n        border-color: rgba(94, 169, 200, 0.9);\n        color: rgba(94, 169, 200, 0.9); }\n      .btn.btn--hollow.btn--primary:active {\n        box-shadow: inset 0 1px 0 0 #5ea9c8; }\n      .btn.btn--hollow.btn--primary [class^=\"icon-\"], .btn.btn--hollow.btn--primary [class*=\" icon-\"] {\n        color: #5ea9c8; }\n    .btn.btn--hollow.btn--success {\n      border: 1px solid rgba(70, 165, 70, 0.4);\n      color: #46a546;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--success:hover, .btn.btn--hollow.btn--success:focus {\n        border-color: rgba(70, 165, 70, 0.9);\n        color: rgba(70, 165, 70, 0.9); }\n      .btn.btn--hollow.btn--success:active {\n        box-shadow: inset 0 1px 0 0 #46a546; }\n      .btn.btn--hollow.btn--success [class^=\"icon-\"], .btn.btn--hollow.btn--success [class*=\" icon-\"] {\n        color: #46a546; }\n    .btn.btn--hollow.btn--warning {\n      border: 1px solid rgba(221, 130, 0, 0.4);\n      color: #dd8200;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--warning:hover, .btn.btn--hollow.btn--warning:focus {\n        border-color: rgba(221, 130, 0, 0.9);\n        color: rgba(221, 130, 0, 0.9); }\n      .btn.btn--hollow.btn--warning:active {\n        box-shadow: inset 0 1px 0 0 #dd8200; }\n      .btn.btn--hollow.btn--warning [class^=\"icon-\"], .btn.btn--hollow.btn--warning [class*=\" icon-\"] {\n        color: #dd8200; }\n    .btn.btn--hollow.btn--alert {\n      border: 1px solid rgba(229, 28, 35, 0.4);\n      color: #E51C23;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--alert:hover, .btn.btn--hollow.btn--alert:focus {\n        border-color: rgba(229, 28, 35, 0.9);\n        color: rgba(229, 28, 35, 0.9); }\n      .btn.btn--hollow.btn--alert:active {\n        box-shadow: inset 0 1px 0 0 #E51C23; }\n      .btn.btn--hollow.btn--alert [class^=\"icon-\"], .btn.btn--hollow.btn--alert [class*=\" icon-\"] {\n        color: #E51C23; }\n    .btn.btn--hollow.btn--highlight {\n      border: 1px solid rgba(156, 39, 176, 0.4);\n      color: #9c27b0;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--highlight:hover, .btn.btn--hollow.btn--highlight:focus {\n        border-color: rgba(156, 39, 176, 0.9);\n        color: rgba(156, 39, 176, 0.9); }\n      .btn.btn--hollow.btn--highlight:active {\n        box-shadow: inset 0 1px 0 0 #9c27b0; }\n      .btn.btn--hollow.btn--highlight [class^=\"icon-\"], .btn.btn--hollow.btn--highlight [class*=\" icon-\"] {\n        color: #9c27b0; }\n    .btn.btn--hollow.btn--sd-green {\n      border: 1px solid rgba(30, 176, 108, 0.4);\n      color: #1eb06c;\n      box-shadow: none; }\n      .btn.btn--hollow.btn--sd-green:hover, .btn.btn--hollow.btn--sd-green:focus {\n        border-color: rgba(30, 176, 108, 0.9);\n        color: rgba(30, 176, 108, 0.9); }\n      .btn.btn--hollow.btn--sd-green:active {\n        box-shadow: inset 0 1px 0 0 #1eb06c; }\n      .btn.btn--hollow.btn--sd-green [class^=\"icon-\"], .btn.btn--hollow.btn--sd-green [class*=\" icon-\"] {\n        color: #1eb06c; }\n  .btn.btn--text-only {\n    background-color: transparent;\n    color: #333; }\n    .btn.btn--text-only:hover, .btn.btn--text-only:focus {\n      background-color: rgba(51, 51, 51, 0.125);\n      color: #333;\n      box-shadow: none; }\n    .btn.btn--text-only:active {\n      box-shadow: inset 0 1px 0 0 rgba(51, 51, 51, 0.4);\n      border-color: rgba(51, 51, 51, 0.4) transparent transparent transparent;\n      background-color: rgba(51, 51, 51, 0.2125); }\n    .btn.btn--text-only.btn--default {\n      background-color: transparent;\n      box-shadow: none;\n      color: #333; }\n      .btn.btn--text-only.btn--default:hover, .btn.btn--text-only.btn--default:focus {\n        background-color: rgba(51, 51, 51, 0.1);\n        color: #333;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--default:active {\n        box-shadow: inset 0 1px 0 0 rgba(51, 51, 51, 0.4);\n        border-color: rgba(51, 51, 51, 0.4) transparent transparent transparent;\n        background-color: rgba(51, 51, 51, 0.19); }\n    .btn.btn--text-only.btn--primary {\n      background-color: transparent;\n      box-shadow: none;\n      color: #5ea9c8; }\n      .btn.btn--text-only.btn--primary:hover, .btn.btn--text-only.btn--primary:focus {\n        background-color: rgba(94, 169, 200, 0.1);\n        color: #5ea9c8;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--primary:active {\n        box-shadow: inset 0 1px 0 0 rgba(94, 169, 200, 0.4);\n        border-color: rgba(94, 169, 200, 0.4) transparent transparent transparent;\n        background-color: rgba(94, 169, 200, 0.19); }\n    .btn.btn--text-only.btn--success {\n      background-color: transparent;\n      box-shadow: none;\n      color: #46a546; }\n      .btn.btn--text-only.btn--success:hover, .btn.btn--text-only.btn--success:focus {\n        background-color: rgba(70, 165, 70, 0.1);\n        color: #46a546;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--success:active {\n        box-shadow: inset 0 1px 0 0 rgba(70, 165, 70, 0.4);\n        border-color: rgba(70, 165, 70, 0.4) transparent transparent transparent;\n        background-color: rgba(70, 165, 70, 0.19); }\n    .btn.btn--text-only.btn--warning {\n      background-color: transparent;\n      box-shadow: none;\n      color: #dd8200; }\n      .btn.btn--text-only.btn--warning:hover, .btn.btn--text-only.btn--warning:focus {\n        background-color: rgba(221, 130, 0, 0.1);\n        color: #dd8200;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--warning:active {\n        box-shadow: inset 0 1px 0 0 rgba(221, 130, 0, 0.4);\n        border-color: rgba(221, 130, 0, 0.4) transparent transparent transparent;\n        background-color: rgba(221, 130, 0, 0.19); }\n    .btn.btn--text-only.btn--alert {\n      background-color: transparent;\n      box-shadow: none;\n      color: #E51C23; }\n      .btn.btn--text-only.btn--alert:hover, .btn.btn--text-only.btn--alert:focus {\n        background-color: rgba(229, 28, 35, 0.1);\n        color: #E51C23;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--alert:active {\n        box-shadow: inset 0 1px 0 0 rgba(229, 28, 35, 0.4);\n        border-color: rgba(229, 28, 35, 0.4) transparent transparent transparent;\n        background-color: rgba(229, 28, 35, 0.19); }\n    .btn.btn--text-only.btn--highlight {\n      background-color: transparent;\n      box-shadow: none;\n      color: #9c27b0; }\n      .btn.btn--text-only.btn--highlight:hover, .btn.btn--text-only.btn--highlight:focus {\n        background-color: rgba(156, 39, 176, 0.1);\n        color: #9c27b0;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--highlight:active {\n        box-shadow: inset 0 1px 0 0 rgba(156, 39, 176, 0.4);\n        border-color: rgba(156, 39, 176, 0.4) transparent transparent transparent;\n        background-color: rgba(156, 39, 176, 0.19); }\n    .btn.btn--text-only.btn--sd-green {\n      background-color: transparent;\n      box-shadow: none;\n      color: #1eb06c; }\n      .btn.btn--text-only.btn--sd-green:hover, .btn.btn--text-only.btn--sd-green:focus {\n        background-color: rgba(30, 176, 108, 0.1);\n        color: #1eb06c;\n        box-shadow: none; }\n      .btn.btn--text-only.btn--sd-green:active {\n        box-shadow: inset 0 1px 0 0 rgba(30, 176, 108, 0.4);\n        border-color: rgba(30, 176, 108, 0.4) transparent transparent transparent;\n        background-color: rgba(30, 176, 108, 0.19); }\n  .btn.btn--disabled, .btn[disabled] {\n    opacity: 0.25;\n    cursor: not-allowed;\n    box-shadow: none; }\n    .btn.btn--disabled:hover, .btn.btn--disabled:focus, .btn[disabled]:hover, .btn[disabled]:focus {\n      background-color: rgba(51, 51, 51, 0.25);\n      color: #333;\n      box-shadow: none;\n      border: 1px solid transparent; }\n    .btn.btn--disabled.btn--default, .btn[disabled].btn--default {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--default:hover, .btn.btn--disabled.btn--default:focus, .btn[disabled].btn--default:hover, .btn[disabled].btn--default:focus {\n        background-color: #333;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--primary, .btn[disabled].btn--primary {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--primary:hover, .btn.btn--disabled.btn--primary:focus, .btn[disabled].btn--primary:hover, .btn[disabled].btn--primary:focus {\n        background-color: #5ea9c8;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--success, .btn[disabled].btn--success {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--success:hover, .btn.btn--disabled.btn--success:focus, .btn[disabled].btn--success:hover, .btn[disabled].btn--success:focus {\n        background-color: #46a546;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--warning, .btn[disabled].btn--warning {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--warning:hover, .btn.btn--disabled.btn--warning:focus, .btn[disabled].btn--warning:hover, .btn[disabled].btn--warning:focus {\n        background-color: #dd8200;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--alert, .btn[disabled].btn--alert {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--alert:hover, .btn.btn--disabled.btn--alert:focus, .btn[disabled].btn--alert:hover, .btn[disabled].btn--alert:focus {\n        background-color: #E51C23;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--highlight, .btn[disabled].btn--highlight {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--highlight:hover, .btn.btn--disabled.btn--highlight:focus, .btn[disabled].btn--highlight:hover, .btn[disabled].btn--highlight:focus {\n        background-color: #9c27b0;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--sd-green, .btn[disabled].btn--sd-green {\n      opacity: 0.25;\n      cursor: not-allowed;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--sd-green:hover, .btn.btn--disabled.btn--sd-green:focus, .btn[disabled].btn--sd-green:hover, .btn[disabled].btn--sd-green:focus {\n        background-color: #1eb06c;\n        color: #fff;\n        box-shadow: none;\n        border: 1px solid transparent; }\n    .btn.btn--disabled.btn--hollow, .btn[disabled].btn--hollow {\n      border: 1px solid 0;\n      color: #333;\n      box-shadow: none; }\n      .btn.btn--disabled.btn--hollow, .btn.btn--disabled.btn--hollow:hover, .btn.btn--disabled.btn--hollow:focus, .btn[disabled].btn--hollow, .btn[disabled].btn--hollow:hover, .btn[disabled].btn--hollow:focus {\n        background-color: transparent; }\n      .btn.btn--disabled.btn--hollow:hover, .btn.btn--disabled.btn--hollow:focus, .btn[disabled].btn--hollow:hover, .btn[disabled].btn--hollow:focus {\n        border-color: rgba(51, 51, 51, 0.9);\n        color: rgba(51, 51, 51, 0.9); }\n      .btn.btn--disabled.btn--hollow:active, .btn[disabled].btn--hollow:active {\n        box-shadow: inset 0 1px 0 0 #333; }\n      .btn.btn--disabled.btn--hollow:active, .btn[disabled].btn--hollow:active {\n        box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--default, .btn[disabled].btn--hollow.btn--default {\n        border: 1px solid 0;\n        color: #333;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--default:hover, .btn.btn--disabled.btn--hollow.btn--default:focus, .btn[disabled].btn--hollow.btn--default:hover, .btn[disabled].btn--hollow.btn--default:focus {\n          border-color: rgba(51, 51, 51, 0.9);\n          color: rgba(51, 51, 51, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--default:active, .btn[disabled].btn--hollow.btn--default:active {\n          box-shadow: inset 0 1px 0 0 #333; }\n        .btn.btn--disabled.btn--hollow.btn--default:active, .btn[disabled].btn--hollow.btn--default:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--primary, .btn[disabled].btn--hollow.btn--primary {\n        border: 1px solid 0;\n        color: #5ea9c8;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--primary:hover, .btn.btn--disabled.btn--hollow.btn--primary:focus, .btn[disabled].btn--hollow.btn--primary:hover, .btn[disabled].btn--hollow.btn--primary:focus {\n          border-color: rgba(94, 169, 200, 0.9);\n          color: rgba(94, 169, 200, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--primary:active, .btn[disabled].btn--hollow.btn--primary:active {\n          box-shadow: inset 0 1px 0 0 #5ea9c8; }\n        .btn.btn--disabled.btn--hollow.btn--primary:active, .btn[disabled].btn--hollow.btn--primary:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--success, .btn[disabled].btn--hollow.btn--success {\n        border: 1px solid 0;\n        color: #46a546;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--success:hover, .btn.btn--disabled.btn--hollow.btn--success:focus, .btn[disabled].btn--hollow.btn--success:hover, .btn[disabled].btn--hollow.btn--success:focus {\n          border-color: rgba(70, 165, 70, 0.9);\n          color: rgba(70, 165, 70, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--success:active, .btn[disabled].btn--hollow.btn--success:active {\n          box-shadow: inset 0 1px 0 0 #46a546; }\n        .btn.btn--disabled.btn--hollow.btn--success:active, .btn[disabled].btn--hollow.btn--success:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--warning, .btn[disabled].btn--hollow.btn--warning {\n        border: 1px solid 0;\n        color: #dd8200;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--warning:hover, .btn.btn--disabled.btn--hollow.btn--warning:focus, .btn[disabled].btn--hollow.btn--warning:hover, .btn[disabled].btn--hollow.btn--warning:focus {\n          border-color: rgba(221, 130, 0, 0.9);\n          color: rgba(221, 130, 0, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--warning:active, .btn[disabled].btn--hollow.btn--warning:active {\n          box-shadow: inset 0 1px 0 0 #dd8200; }\n        .btn.btn--disabled.btn--hollow.btn--warning:active, .btn[disabled].btn--hollow.btn--warning:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--alert, .btn[disabled].btn--hollow.btn--alert {\n        border: 1px solid 0;\n        color: #E51C23;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--alert:hover, .btn.btn--disabled.btn--hollow.btn--alert:focus, .btn[disabled].btn--hollow.btn--alert:hover, .btn[disabled].btn--hollow.btn--alert:focus {\n          border-color: rgba(229, 28, 35, 0.9);\n          color: rgba(229, 28, 35, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--alert:active, .btn[disabled].btn--hollow.btn--alert:active {\n          box-shadow: inset 0 1px 0 0 #E51C23; }\n        .btn.btn--disabled.btn--hollow.btn--alert:active, .btn[disabled].btn--hollow.btn--alert:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--highlight, .btn[disabled].btn--hollow.btn--highlight {\n        border: 1px solid 0;\n        color: #9c27b0;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--highlight:hover, .btn.btn--disabled.btn--hollow.btn--highlight:focus, .btn[disabled].btn--hollow.btn--highlight:hover, .btn[disabled].btn--hollow.btn--highlight:focus {\n          border-color: rgba(156, 39, 176, 0.9);\n          color: rgba(156, 39, 176, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--highlight:active, .btn[disabled].btn--hollow.btn--highlight:active {\n          box-shadow: inset 0 1px 0 0 #9c27b0; }\n        .btn.btn--disabled.btn--hollow.btn--highlight:active, .btn[disabled].btn--hollow.btn--highlight:active {\n          box-shadow: none; }\n      .btn.btn--disabled.btn--hollow.btn--sd-green, .btn[disabled].btn--hollow.btn--sd-green {\n        border: 1px solid 0;\n        color: #1eb06c;\n        box-shadow: none; }\n        .btn.btn--disabled.btn--hollow.btn--sd-green:hover, .btn.btn--disabled.btn--hollow.btn--sd-green:focus, .btn[disabled].btn--hollow.btn--sd-green:hover, .btn[disabled].btn--hollow.btn--sd-green:focus {\n          border-color: rgba(30, 176, 108, 0.9);\n          color: rgba(30, 176, 108, 0.9); }\n        .btn.btn--disabled.btn--hollow.btn--sd-green:active, .btn[disabled].btn--hollow.btn--sd-green:active {\n          box-shadow: inset 0 1px 0 0 #1eb06c; }\n        .btn.btn--disabled.btn--hollow.btn--sd-green:active, .btn[disabled].btn--hollow.btn--sd-green:active {\n          box-shadow: none; }\n    .btn.btn--disabled.btn--text-only, .btn[disabled].btn--text-only {\n      background-color: transparent;\n      color: #333; }\n      .btn.btn--disabled.btn--text-only:hover, .btn.btn--disabled.btn--text-only:focus, .btn[disabled].btn--text-only:hover, .btn[disabled].btn--text-only:focus {\n        background-color: transparent;\n        color: #333;\n        box-shadow: none; }\n      .btn.btn--disabled.btn--text-only:active, .btn[disabled].btn--text-only:active {\n        box-shadow: inset 0 1px 0 0 rgba(51, 51, 51, 0.4);\n        border-color: rgba(51, 51, 51, 0.4) transparent transparent transparent;\n        background-color: rgba(0, 0, 0, 0.1); }\n      .btn.btn--disabled.btn--text-only:hover, .btn.btn--disabled.btn--text-only:focus, .btn.btn--disabled.btn--text-only:active, .btn[disabled].btn--text-only:hover, .btn[disabled].btn--text-only:focus, .btn[disabled].btn--text-only:active {\n        box-shadow: none;\n        border-color: transparent;\n        background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--default, .btn[disabled].btn--text-only.btn--default {\n        background-color: transparent;\n        color: #333; }\n        .btn.btn--disabled.btn--text-only.btn--default:hover, .btn.btn--disabled.btn--text-only.btn--default:focus, .btn[disabled].btn--text-only.btn--default:hover, .btn[disabled].btn--text-only.btn--default:focus {\n          background-color: transparent;\n          color: #333;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--default:active, .btn[disabled].btn--text-only.btn--default:active {\n          box-shadow: inset 0 1px 0 0 rgba(51, 51, 51, 0.4);\n          border-color: rgba(51, 51, 51, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--default:hover, .btn.btn--disabled.btn--text-only.btn--default:focus, .btn.btn--disabled.btn--text-only.btn--default:active, .btn[disabled].btn--text-only.btn--default:hover, .btn[disabled].btn--text-only.btn--default:focus, .btn[disabled].btn--text-only.btn--default:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--primary, .btn[disabled].btn--text-only.btn--primary {\n        background-color: transparent;\n        color: #5ea9c8; }\n        .btn.btn--disabled.btn--text-only.btn--primary:hover, .btn.btn--disabled.btn--text-only.btn--primary:focus, .btn[disabled].btn--text-only.btn--primary:hover, .btn[disabled].btn--text-only.btn--primary:focus {\n          background-color: transparent;\n          color: #5ea9c8;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--primary:active, .btn[disabled].btn--text-only.btn--primary:active {\n          box-shadow: inset 0 1px 0 0 rgba(94, 169, 200, 0.4);\n          border-color: rgba(94, 169, 200, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--primary:hover, .btn.btn--disabled.btn--text-only.btn--primary:focus, .btn.btn--disabled.btn--text-only.btn--primary:active, .btn[disabled].btn--text-only.btn--primary:hover, .btn[disabled].btn--text-only.btn--primary:focus, .btn[disabled].btn--text-only.btn--primary:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--success, .btn[disabled].btn--text-only.btn--success {\n        background-color: transparent;\n        color: #46a546; }\n        .btn.btn--disabled.btn--text-only.btn--success:hover, .btn.btn--disabled.btn--text-only.btn--success:focus, .btn[disabled].btn--text-only.btn--success:hover, .btn[disabled].btn--text-only.btn--success:focus {\n          background-color: transparent;\n          color: #46a546;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--success:active, .btn[disabled].btn--text-only.btn--success:active {\n          box-shadow: inset 0 1px 0 0 rgba(70, 165, 70, 0.4);\n          border-color: rgba(70, 165, 70, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--success:hover, .btn.btn--disabled.btn--text-only.btn--success:focus, .btn.btn--disabled.btn--text-only.btn--success:active, .btn[disabled].btn--text-only.btn--success:hover, .btn[disabled].btn--text-only.btn--success:focus, .btn[disabled].btn--text-only.btn--success:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--warning, .btn[disabled].btn--text-only.btn--warning {\n        background-color: transparent;\n        color: #dd8200; }\n        .btn.btn--disabled.btn--text-only.btn--warning:hover, .btn.btn--disabled.btn--text-only.btn--warning:focus, .btn[disabled].btn--text-only.btn--warning:hover, .btn[disabled].btn--text-only.btn--warning:focus {\n          background-color: transparent;\n          color: #dd8200;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--warning:active, .btn[disabled].btn--text-only.btn--warning:active {\n          box-shadow: inset 0 1px 0 0 rgba(221, 130, 0, 0.4);\n          border-color: rgba(221, 130, 0, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--warning:hover, .btn.btn--disabled.btn--text-only.btn--warning:focus, .btn.btn--disabled.btn--text-only.btn--warning:active, .btn[disabled].btn--text-only.btn--warning:hover, .btn[disabled].btn--text-only.btn--warning:focus, .btn[disabled].btn--text-only.btn--warning:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--alert, .btn[disabled].btn--text-only.btn--alert {\n        background-color: transparent;\n        color: #E51C23; }\n        .btn.btn--disabled.btn--text-only.btn--alert:hover, .btn.btn--disabled.btn--text-only.btn--alert:focus, .btn[disabled].btn--text-only.btn--alert:hover, .btn[disabled].btn--text-only.btn--alert:focus {\n          background-color: transparent;\n          color: #E51C23;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--alert:active, .btn[disabled].btn--text-only.btn--alert:active {\n          box-shadow: inset 0 1px 0 0 rgba(229, 28, 35, 0.4);\n          border-color: rgba(229, 28, 35, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--alert:hover, .btn.btn--disabled.btn--text-only.btn--alert:focus, .btn.btn--disabled.btn--text-only.btn--alert:active, .btn[disabled].btn--text-only.btn--alert:hover, .btn[disabled].btn--text-only.btn--alert:focus, .btn[disabled].btn--text-only.btn--alert:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--highlight, .btn[disabled].btn--text-only.btn--highlight {\n        background-color: transparent;\n        color: #9c27b0; }\n        .btn.btn--disabled.btn--text-only.btn--highlight:hover, .btn.btn--disabled.btn--text-only.btn--highlight:focus, .btn[disabled].btn--text-only.btn--highlight:hover, .btn[disabled].btn--text-only.btn--highlight:focus {\n          background-color: transparent;\n          color: #9c27b0;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--highlight:active, .btn[disabled].btn--text-only.btn--highlight:active {\n          box-shadow: inset 0 1px 0 0 rgba(156, 39, 176, 0.4);\n          border-color: rgba(156, 39, 176, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--highlight:hover, .btn.btn--disabled.btn--text-only.btn--highlight:focus, .btn.btn--disabled.btn--text-only.btn--highlight:active, .btn[disabled].btn--text-only.btn--highlight:hover, .btn[disabled].btn--text-only.btn--highlight:focus, .btn[disabled].btn--text-only.btn--highlight:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n      .btn.btn--disabled.btn--text-only.btn--sd-green, .btn[disabled].btn--text-only.btn--sd-green {\n        background-color: transparent;\n        color: #1eb06c; }\n        .btn.btn--disabled.btn--text-only.btn--sd-green:hover, .btn.btn--disabled.btn--text-only.btn--sd-green:focus, .btn[disabled].btn--text-only.btn--sd-green:hover, .btn[disabled].btn--text-only.btn--sd-green:focus {\n          background-color: transparent;\n          color: #1eb06c;\n          box-shadow: none; }\n        .btn.btn--disabled.btn--text-only.btn--sd-green:active, .btn[disabled].btn--text-only.btn--sd-green:active {\n          box-shadow: inset 0 1px 0 0 rgba(30, 176, 108, 0.4);\n          border-color: rgba(30, 176, 108, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--disabled.btn--text-only.btn--sd-green:hover, .btn.btn--disabled.btn--text-only.btn--sd-green:focus, .btn.btn--disabled.btn--text-only.btn--sd-green:active, .btn[disabled].btn--text-only.btn--sd-green:hover, .btn[disabled].btn--text-only.btn--sd-green:focus, .btn[disabled].btn--text-only.btn--sd-green:active {\n          box-shadow: none;\n          border-color: transparent;\n          background: transparent; }\n  .btn.btn--ui-dark {\n    background-color: rgba(245, 245, 245, 0.25);\n    color: #fff; }\n    .btn.btn--ui-dark:hover, .btn.btn--ui-dark:focus {\n      background-color: rgba(196, 196, 196, 0.25);\n      color: #fff; }\n    .btn.btn--ui-dark:active {\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n      border-style: solid;\n      border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n      border-width: 1px; }\n    .btn.btn--ui-dark.btn--default {\n      background-color: #F5F5F5;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--default:hover, .btn.btn--ui-dark.btn--default:focus {\n        background-color: #c4c4c4;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--default:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--primary {\n      background-color: #5ea9c8;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--primary:hover, .btn.btn--ui-dark.btn--primary:focus {\n        background-color: #3c8eaf;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--primary:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--success {\n      background-color: #46a546;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--success:hover, .btn.btn--ui-dark.btn--success:focus {\n        background-color: #388438;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--success:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--warning {\n      background-color: #dd8200;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--warning:hover, .btn.btn--ui-dark.btn--warning:focus {\n        background-color: #b16800;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--warning:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--alert {\n      background-color: #E51C23;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--alert:hover, .btn.btn--ui-dark.btn--alert:focus {\n        background-color: #b8151b;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--alert:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--highlight {\n      background-color: #bf00e0;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--highlight:hover, .btn.btn--ui-dark.btn--highlight:focus {\n        background-color: #9900b3;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--highlight:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--sd-green {\n      background-color: #1eb06c;\n      color: #fff; }\n      .btn.btn--ui-dark.btn--sd-green:hover, .btn.btn--ui-dark.btn--sd-green:focus {\n        background-color: #188d56;\n        color: #fff; }\n      .btn.btn--ui-dark.btn--sd-green:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n    .btn.btn--ui-dark.btn--disabled, .btn.btn--ui-dark[disabled] {\n      background-color: rgba(245, 245, 245, 0.25);\n      color: #fff; }\n      .btn.btn--ui-dark.btn--disabled:hover, .btn.btn--ui-dark.btn--disabled:focus, .btn.btn--ui-dark[disabled]:hover, .btn.btn--ui-dark[disabled]:focus {\n        background-color: rgba(245, 245, 245, 0.25);\n        color: #fff; }\n      .btn.btn--ui-dark.btn--disabled:active, .btn.btn--ui-dark[disabled]:active {\n        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n        border-style: solid;\n        border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n        border-width: 1px; }\n      .btn.btn--ui-dark.btn--disabled:hover, .btn.btn--ui-dark.btn--disabled:focus, .btn.btn--ui-dark.btn--disabled:active, .btn.btn--ui-dark[disabled]:hover, .btn.btn--ui-dark[disabled]:focus, .btn.btn--ui-dark[disabled]:active {\n        box-shadow: none;\n        border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--default, .btn.btn--ui-dark[disabled].btn--default {\n        background-color: #F5F5F5;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--disabled.btn--default:focus, .btn.btn--ui-dark[disabled].btn--default:hover, .btn.btn--ui-dark[disabled].btn--default:focus {\n          background-color: whitesmoke;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--default:active, .btn.btn--ui-dark[disabled].btn--default:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--disabled.btn--default:focus, .btn.btn--ui-dark.btn--disabled.btn--default:active, .btn.btn--ui-dark[disabled].btn--default:hover, .btn.btn--ui-dark[disabled].btn--default:focus, .btn.btn--ui-dark[disabled].btn--default:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--primary, .btn.btn--ui-dark[disabled].btn--primary {\n        background-color: #5ea9c8;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--disabled.btn--primary:focus, .btn.btn--ui-dark[disabled].btn--primary:hover, .btn.btn--ui-dark[disabled].btn--primary:focus {\n          background-color: #5ea9c8;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--primary:active, .btn.btn--ui-dark[disabled].btn--primary:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--disabled.btn--primary:focus, .btn.btn--ui-dark.btn--disabled.btn--primary:active, .btn.btn--ui-dark[disabled].btn--primary:hover, .btn.btn--ui-dark[disabled].btn--primary:focus, .btn.btn--ui-dark[disabled].btn--primary:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--success, .btn.btn--ui-dark[disabled].btn--success {\n        background-color: #46a546;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--disabled.btn--success:focus, .btn.btn--ui-dark[disabled].btn--success:hover, .btn.btn--ui-dark[disabled].btn--success:focus {\n          background-color: #46a546;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--success:active, .btn.btn--ui-dark[disabled].btn--success:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--disabled.btn--success:focus, .btn.btn--ui-dark.btn--disabled.btn--success:active, .btn.btn--ui-dark[disabled].btn--success:hover, .btn.btn--ui-dark[disabled].btn--success:focus, .btn.btn--ui-dark[disabled].btn--success:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--warning, .btn.btn--ui-dark[disabled].btn--warning {\n        background-color: #dd8200;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--disabled.btn--warning:focus, .btn.btn--ui-dark[disabled].btn--warning:hover, .btn.btn--ui-dark[disabled].btn--warning:focus {\n          background-color: #dd8200;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--warning:active, .btn.btn--ui-dark[disabled].btn--warning:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--disabled.btn--warning:focus, .btn.btn--ui-dark.btn--disabled.btn--warning:active, .btn.btn--ui-dark[disabled].btn--warning:hover, .btn.btn--ui-dark[disabled].btn--warning:focus, .btn.btn--ui-dark[disabled].btn--warning:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--alert, .btn.btn--ui-dark[disabled].btn--alert {\n        background-color: #E51C23;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--disabled.btn--alert:focus, .btn.btn--ui-dark[disabled].btn--alert:hover, .btn.btn--ui-dark[disabled].btn--alert:focus {\n          background-color: #e51c23;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--alert:active, .btn.btn--ui-dark[disabled].btn--alert:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--disabled.btn--alert:focus, .btn.btn--ui-dark.btn--disabled.btn--alert:active, .btn.btn--ui-dark[disabled].btn--alert:hover, .btn.btn--ui-dark[disabled].btn--alert:focus, .btn.btn--ui-dark[disabled].btn--alert:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--highlight, .btn.btn--ui-dark[disabled].btn--highlight {\n        background-color: #bf00e0;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark[disabled].btn--highlight:hover, .btn.btn--ui-dark[disabled].btn--highlight:focus {\n          background-color: #bf00e0;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--highlight:active, .btn.btn--ui-dark[disabled].btn--highlight:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark.btn--disabled.btn--highlight:active, .btn.btn--ui-dark[disabled].btn--highlight:hover, .btn.btn--ui-dark[disabled].btn--highlight:focus, .btn.btn--ui-dark[disabled].btn--highlight:active {\n          box-shadow: none;\n          border-color: transparent; }\n      .btn.btn--ui-dark.btn--disabled.btn--sd-green, .btn.btn--ui-dark[disabled].btn--sd-green {\n        background-color: #1eb06c;\n        color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark[disabled].btn--sd-green:hover, .btn.btn--ui-dark[disabled].btn--sd-green:focus {\n          background-color: #1eb06c;\n          color: #fff; }\n        .btn.btn--ui-dark.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark[disabled].btn--sd-green:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark[disabled].btn--sd-green:hover, .btn.btn--ui-dark[disabled].btn--sd-green:focus, .btn.btn--ui-dark[disabled].btn--sd-green:active {\n          box-shadow: none;\n          border-color: transparent; }\n    .btn.btn--ui-dark [class^=\"icon-\"], .btn.btn--ui-dark [class*=\" icon-\"] {\n      color: #fff; }\n    .btn.btn--ui-dark.btn--text-only {\n      background-color: transparent;\n      box-shadow: none;\n      color: #F5F5F5; }\n      .btn.btn--ui-dark.btn--text-only:hover, .btn.btn--ui-dark.btn--text-only:focus {\n        background-color: rgba(245, 245, 245, 0.1);\n        color: #F5F5F5;\n        box-shadow: none; }\n      .btn.btn--ui-dark.btn--text-only:active {\n        box-shadow: inset 0 1px 0 0 rgba(245, 245, 245, 0.4);\n        border-color: rgba(245, 245, 245, 0.4) transparent transparent transparent;\n        background-color: rgba(245, 245, 245, 0.19); }\n      .btn.btn--ui-dark.btn--text-only.btn--default {\n        background-color: transparent;\n        color: #F5F5F5; }\n        .btn.btn--ui-dark.btn--text-only.btn--default:hover, .btn.btn--ui-dark.btn--text-only.btn--default:focus {\n          background-color: rgba(245, 245, 245, 0.2);\n          color: #F5F5F5; }\n        .btn.btn--ui-dark.btn--text-only.btn--default:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--default:active {\n          box-shadow: inset 0 1px 0 0 rgba(245, 245, 245, 0.4);\n          border-color: rgba(245, 245, 245, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--primary {\n        background-color: transparent;\n        color: #5ea9c8; }\n        .btn.btn--ui-dark.btn--text-only.btn--primary:hover, .btn.btn--ui-dark.btn--text-only.btn--primary:focus {\n          background-color: rgba(94, 169, 200, 0.2);\n          color: #5ea9c8; }\n        .btn.btn--ui-dark.btn--text-only.btn--primary:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--primary:active {\n          box-shadow: inset 0 1px 0 0 rgba(94, 169, 200, 0.4);\n          border-color: rgba(94, 169, 200, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--success {\n        background-color: transparent;\n        color: #46a546; }\n        .btn.btn--ui-dark.btn--text-only.btn--success:hover, .btn.btn--ui-dark.btn--text-only.btn--success:focus {\n          background-color: rgba(70, 165, 70, 0.2);\n          color: #46a546; }\n        .btn.btn--ui-dark.btn--text-only.btn--success:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--success:active {\n          box-shadow: inset 0 1px 0 0 rgba(70, 165, 70, 0.4);\n          border-color: rgba(70, 165, 70, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--warning {\n        background-color: transparent;\n        color: #dd8200; }\n        .btn.btn--ui-dark.btn--text-only.btn--warning:hover, .btn.btn--ui-dark.btn--text-only.btn--warning:focus {\n          background-color: rgba(221, 130, 0, 0.2);\n          color: #dd8200; }\n        .btn.btn--ui-dark.btn--text-only.btn--warning:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--warning:active {\n          box-shadow: inset 0 1px 0 0 rgba(221, 130, 0, 0.4);\n          border-color: rgba(221, 130, 0, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--alert {\n        background-color: transparent;\n        color: #E51C23; }\n        .btn.btn--ui-dark.btn--text-only.btn--alert:hover, .btn.btn--ui-dark.btn--text-only.btn--alert:focus {\n          background-color: rgba(229, 28, 35, 0.2);\n          color: #E51C23; }\n        .btn.btn--ui-dark.btn--text-only.btn--alert:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--alert:active {\n          box-shadow: inset 0 1px 0 0 rgba(229, 28, 35, 0.4);\n          border-color: rgba(229, 28, 35, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--highlight {\n        background-color: transparent;\n        color: #bf00e0; }\n        .btn.btn--ui-dark.btn--text-only.btn--highlight:hover, .btn.btn--ui-dark.btn--text-only.btn--highlight:focus {\n          background-color: rgba(191, 0, 224, 0.2);\n          color: #bf00e0; }\n        .btn.btn--ui-dark.btn--text-only.btn--highlight:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--highlight:active {\n          box-shadow: inset 0 1px 0 0 rgba(191, 0, 224, 0.4);\n          border-color: rgba(191, 0, 224, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--sd-green {\n        background-color: transparent;\n        color: #1eb06c; }\n        .btn.btn--ui-dark.btn--text-only.btn--sd-green:hover, .btn.btn--ui-dark.btn--text-only.btn--sd-green:focus {\n          background-color: rgba(30, 176, 108, 0.2);\n          color: #1eb06c; }\n        .btn.btn--ui-dark.btn--text-only.btn--sd-green:active {\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n          border-style: solid;\n          border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n          border-width: 1px; }\n        .btn.btn--ui-dark.btn--text-only.btn--sd-green:active {\n          box-shadow: inset 0 1px 0 0 rgba(30, 176, 108, 0.4);\n          border-color: rgba(30, 176, 108, 0.4) transparent transparent transparent; }\n      .btn.btn--ui-dark.btn--text-only.btn--disabled, .btn.btn--ui-dark.btn--text-only[disabled] {\n        background-color: transparent;\n        color: #F5F5F5; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled:focus, .btn.btn--ui-dark.btn--text-only[disabled]:hover, .btn.btn--ui-dark.btn--text-only[disabled]:focus {\n          background-color: transparent;\n          color: #F5F5F5;\n          box-shadow: none; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled:active, .btn.btn--ui-dark.btn--text-only[disabled]:active {\n          box-shadow: inset 0 1px 0 0 rgba(245, 245, 245, 0.4);\n          border-color: rgba(245, 245, 245, 0.4) transparent transparent transparent;\n          background-color: rgba(0, 0, 0, 0.1); }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled:active, .btn.btn--ui-dark.btn--text-only[disabled]:hover, .btn.btn--ui-dark.btn--text-only[disabled]:focus, .btn.btn--ui-dark.btn--text-only[disabled]:active {\n          box-shadow: none;\n          border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default, .btn.btn--ui-dark.btn--text-only[disabled].btn--default {\n          background-color: transparent;\n          color: #F5F5F5; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:focus {\n            background-color: transparent;\n            color: #F5F5F5; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--default:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--default:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary {\n          background-color: transparent;\n          color: #5ea9c8; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:focus {\n            background-color: transparent;\n            color: #5ea9c8; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--primary:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--primary:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success, .btn.btn--ui-dark.btn--text-only[disabled].btn--success {\n          background-color: transparent;\n          color: #46a546; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:focus {\n            background-color: transparent;\n            color: #46a546; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--success:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--success:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning {\n          background-color: transparent;\n          color: #dd8200; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:focus {\n            background-color: transparent;\n            color: #dd8200; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--warning:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--warning:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert {\n          background-color: transparent;\n          color: #E51C23; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:focus {\n            background-color: transparent;\n            color: #E51C23; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--alert:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--alert:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight {\n          background-color: transparent;\n          color: #bf00e0; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:focus {\n            background-color: transparent;\n            color: #bf00e0; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--highlight:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--highlight:active {\n            box-shadow: none;\n            border-color: transparent; }\n        .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green {\n          background-color: transparent;\n          color: #1eb06c; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:focus {\n            background-color: transparent;\n            color: #1eb06c; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:active {\n            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.4);\n            border-style: solid;\n            border-color: rgba(0, 0, 0, 0.4) rgba(0, 0, 0, 0.4) transparent rgba(0, 0, 0, 0.4);\n            border-width: 1px; }\n          .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark.btn--text-only.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:hover, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:focus, .btn.btn--ui-dark.btn--text-only[disabled].btn--sd-green:active {\n            box-shadow: none;\n            border-color: transparent; }\n    .btn.btn--ui-dark.btn--hollow {\n      border: 1px solid rgba(245, 245, 245, 0.28);\n      color: rgba(245, 245, 245, 0.7);\n      box-shadow: none; }\n      .btn.btn--ui-dark.btn--hollow, .btn.btn--ui-dark.btn--hollow:hover, .btn.btn--ui-dark.btn--hollow:focus {\n        background-color: transparent; }\n      .btn.btn--ui-dark.btn--hollow:hover, .btn.btn--ui-dark.btn--hollow:focus {\n        border-color: rgba(245, 245, 245, 0.63);\n        color: rgba(245, 245, 245, 0.63); }\n      .btn.btn--ui-dark.btn--hollow:active {\n        box-shadow: inset 0 1px 0 0 rgba(245, 245, 245, 0.7); }\n      .btn.btn--ui-dark.btn--hollow.btn--default {\n        border: 1px solid rgba(245, 245, 245, 0.4);\n        color: #F5F5F5;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--default:hover, .btn.btn--ui-dark.btn--hollow.btn--default:focus {\n          border-color: rgba(245, 245, 245, 0.9);\n          color: rgba(245, 245, 245, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--default:active {\n          box-shadow: inset 0 1px 0 0 #F5F5F5; }\n      .btn.btn--ui-dark.btn--hollow.btn--primary {\n        border: 1px solid rgba(94, 169, 200, 0.4);\n        color: #5ea9c8;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--primary:hover, .btn.btn--ui-dark.btn--hollow.btn--primary:focus {\n          border-color: rgba(94, 169, 200, 0.9);\n          color: rgba(94, 169, 200, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--primary:active {\n          box-shadow: inset 0 1px 0 0 #5ea9c8; }\n      .btn.btn--ui-dark.btn--hollow.btn--success {\n        border: 1px solid rgba(70, 165, 70, 0.4);\n        color: #46a546;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--success:hover, .btn.btn--ui-dark.btn--hollow.btn--success:focus {\n          border-color: rgba(70, 165, 70, 0.9);\n          color: rgba(70, 165, 70, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--success:active {\n          box-shadow: inset 0 1px 0 0 #46a546; }\n      .btn.btn--ui-dark.btn--hollow.btn--warning {\n        border: 1px solid rgba(221, 130, 0, 0.4);\n        color: #dd8200;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--warning:hover, .btn.btn--ui-dark.btn--hollow.btn--warning:focus {\n          border-color: rgba(221, 130, 0, 0.9);\n          color: rgba(221, 130, 0, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--warning:active {\n          box-shadow: inset 0 1px 0 0 #dd8200; }\n      .btn.btn--ui-dark.btn--hollow.btn--alert {\n        border: 1px solid rgba(229, 28, 35, 0.4);\n        color: #E51C23;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--alert:hover, .btn.btn--ui-dark.btn--hollow.btn--alert:focus {\n          border-color: rgba(229, 28, 35, 0.9);\n          color: rgba(229, 28, 35, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--alert:active {\n          box-shadow: inset 0 1px 0 0 #E51C23; }\n      .btn.btn--ui-dark.btn--hollow.btn--highlight {\n        border: 1px solid rgba(191, 0, 224, 0.4);\n        color: #bf00e0;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--highlight:hover, .btn.btn--ui-dark.btn--hollow.btn--highlight:focus {\n          border-color: rgba(191, 0, 224, 0.9);\n          color: rgba(191, 0, 224, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--highlight:active {\n          box-shadow: inset 0 1px 0 0 #bf00e0; }\n      .btn.btn--ui-dark.btn--hollow.btn--sd-green {\n        border: 1px solid rgba(30, 176, 108, 0.4);\n        color: #1eb06c;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--sd-green:hover, .btn.btn--ui-dark.btn--hollow.btn--sd-green:focus {\n          border-color: rgba(30, 176, 108, 0.9);\n          color: rgba(30, 176, 108, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--sd-green:active {\n          box-shadow: inset 0 1px 0 0 #1eb06c; }\n      .btn.btn--ui-dark.btn--hollow.btn--disabled, .btn.btn--ui-dark.btn--hollow[disabled] {\n        border: 1px solid 0;\n        color: #F5F5F5;\n        box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled, .btn.btn--ui-dark.btn--hollow.btn--disabled:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled:focus, .btn.btn--ui-dark.btn--hollow[disabled], .btn.btn--ui-dark.btn--hollow[disabled]:hover, .btn.btn--ui-dark.btn--hollow[disabled]:focus {\n          background-color: transparent; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled:focus, .btn.btn--ui-dark.btn--hollow[disabled]:hover, .btn.btn--ui-dark.btn--hollow[disabled]:focus {\n          border-color: rgba(245, 245, 245, 0.9);\n          color: rgba(245, 245, 245, 0.9); }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled:active, .btn.btn--ui-dark.btn--hollow[disabled]:active {\n          box-shadow: inset 0 1px 0 0 #F5F5F5; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled:active, .btn.btn--ui-dark.btn--hollow[disabled]:hover, .btn.btn--ui-dark.btn--hollow[disabled]:focus, .btn.btn--ui-dark.btn--hollow[disabled]:active {\n          box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default, .btn.btn--ui-dark.btn--hollow[disabled].btn--default {\n          border: 1px solid 0;\n          color: #F5F5F5;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:focus {\n            border-color: rgba(245, 245, 245, 0.9);\n            color: rgba(245, 245, 245, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:active {\n            box-shadow: inset 0 1px 0 0 #F5F5F5; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--default:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--default:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary {\n          border: 1px solid 0;\n          color: #5ea9c8;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:focus {\n            border-color: rgba(94, 169, 200, 0.9);\n            color: rgba(94, 169, 200, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:active {\n            box-shadow: inset 0 1px 0 0 #5ea9c8; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--primary:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--primary:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success, .btn.btn--ui-dark.btn--hollow[disabled].btn--success {\n          border: 1px solid 0;\n          color: #46a546;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:focus {\n            border-color: rgba(70, 165, 70, 0.9);\n            color: rgba(70, 165, 70, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:active {\n            box-shadow: inset 0 1px 0 0 #46a546; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--success:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--success:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning {\n          border: 1px solid 0;\n          color: #dd8200;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:focus {\n            border-color: rgba(221, 130, 0, 0.9);\n            color: rgba(221, 130, 0, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:active {\n            box-shadow: inset 0 1px 0 0 #dd8200; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--warning:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--warning:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert {\n          border: 1px solid 0;\n          color: #E51C23;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:focus {\n            border-color: rgba(229, 28, 35, 0.9);\n            color: rgba(229, 28, 35, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:active {\n            box-shadow: inset 0 1px 0 0 #E51C23; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--alert:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--alert:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight {\n          border: 1px solid 0;\n          color: #bf00e0;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:focus {\n            border-color: rgba(191, 0, 224, 0.9);\n            color: rgba(191, 0, 224, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:active {\n            box-shadow: inset 0 1px 0 0 #bf00e0; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--highlight:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--highlight:active {\n            box-shadow: none; }\n        .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green {\n          border: 1px solid 0;\n          color: #1eb06c;\n          box-shadow: none; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:focus {\n            border-color: rgba(30, 176, 108, 0.9);\n            color: rgba(30, 176, 108, 0.9); }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:active {\n            box-shadow: inset 0 1px 0 0 #1eb06c; }\n          .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:hover, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:focus, .btn.btn--ui-dark.btn--hollow.btn--disabled.btn--sd-green:active, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:hover, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:focus, .btn.btn--ui-dark.btn--hollow[disabled].btn--sd-green:active {\n            box-shadow: none; }\n  .btn + .btn {\n    margin-left: 4px; }\n  .btn [class^=\"icon-\"], .btn [class*=\" icon-\"] {\n    margin: -0.6rem 0.6rem -0.3rem -0.3rem;\n    line-height: 1;\n    vertical-align: middle; }\n  .btn.btn--icon-only {\n    padding: 0.5rem 0.8rem; }\n    .btn.btn--icon-only [class^=\"icon-\"], .btn.btn--icon-only [class*=\" icon-\"] {\n      display: inline-block;\n      margin: 0;\n      vertical-align: middle; }\n    .btn.btn--icon-only.btn--large {\n      padding: 0.9rem 1.4rem; }\n    .btn.btn--icon-only.btn--small {\n      padding: 0.2rem 0.4rem; }\n  .btn.btn--icon-only-circle {\n    padding: 0.5rem 0.5rem;\n    border-radius: 50%; }\n    .btn.btn--icon-only-circle [class^=\"icon-\"], .btn.btn--icon-only-circle [class*=\" icon-\"] {\n      display: inline-block;\n      margin: 0;\n      vertical-align: middle; }\n    .btn.btn--icon-only-circle.btn--large {\n      padding: 0.9rem 0.9rem; }\n    .btn.btn--icon-only-circle.btn--small {\n      padding: 0.2rem 0.2rem; }\n    .btn.btn--icon-only-circle.btn--text-only {\n      background-color: transparent;\n      color: #333;\n      transition: background-color 0.2s ease-out, color 0.1s ease-out, opacity 0.1s ease-out;\n      opacity: 0.5; }\n      .btn.btn--icon-only-circle.btn--text-only:hover, .btn.btn--icon-only-circle.btn--text-only:focus {\n        background-color: rgba(51, 51, 51, 0.125);\n        color: #333;\n        box-shadow: none; }\n      .btn.btn--icon-only-circle.btn--text-only:active {\n        box-shadow: inset 0 1px 0 0 rgba(51, 51, 51, 0.4);\n        border-color: rgba(51, 51, 51, 0.4) transparent transparent transparent;\n        background-color: rgba(51, 51, 51, 0.2125); }\n      .btn.btn--icon-only-circle.btn--text-only [class^=\"icon-\"], .btn.btn--icon-only-circle.btn--text-only [class*=\" icon-\"] {\n        color: inherit; }\n      .btn.btn--icon-only-circle.btn--text-only:hover, .btn.btn--icon-only-circle.btn--text-only:focus, .btn.btn--icon-only-circle.btn--text-only:active {\n        box-shadow: none;\n        opacity: 1;\n        border-color: transparent; }\n      .btn.btn--icon-only-circle.btn--text-only:hover {\n        background-color: rgba(35, 35, 35, 0); }\n      .btn.btn--icon-only-circle.btn--text-only:focus, .btn.btn--icon-only-circle.btn--text-only:active {\n        background-color: rgba(35, 35, 35, 0.2); }\n      .btn.btn--icon-only-circle.btn--text-only.btn--ui-dark [class^=\"icon-\"], .btn.btn--icon-only-circle.btn--text-only.btn--ui-dark [class*=\" icon-\"] {\n        color: #fff; }\n\n.sd-create-btn {\n  width: 4.8rem;\n  height: 4.8rem;\n  line-height: 4.8rem;\n  padding: 0 !important;\n  overflow: hidden;\n  position: relative;\n  background: #fff;\n  vertical-align: top; }\n  .sd-create-btn i {\n    position: absolute;\n    z-index: 1;\n    display: block;\n    top: 50%;\n    margin-top: -0.8rem;\n    left: 50%;\n    margin-left: -0.8rem;\n    opacity: 1 !important;\n    color: #fff !important;\n    line-height: 1.6rem !important; }\n  .sd-create-btn .circle {\n    box-sizing: border-box;\n    display: inline-block;\n    text-align: center;\n    width: 2.6rem;\n    height: 2.6rem;\n    margin: 0;\n    padding: 0;\n    margin-top: 1.1rem;\n    border-radius: 50%;\n    background-color: #5ea9c8;\n    color: #fff;\n    position: relative;\n    -webkit-transition: all 60ms ease-in;\n    -moz-transition: all 60ms ease-in;\n    -ms-transition: all 60ms ease-in;\n    -o-transition: all 60ms ease-in;\n    transition: all 60ms ease-in; }\n  .sd-create-btn:hover .circle {\n    width: 3.4rem;\n    height: 3.4rem;\n    margin-top: 0.7rem;\n    margin-left: 0; }\n  .sd-create-btn:active .circle {\n    width: 6.8rem;\n    height: 6.8rem;\n    margin: -1rem 0 0 -1rem;\n    -webkit-transition: all 30ms ease-in;\n    -moz-transition: all 30ms ease-in;\n    -ms-transition: all 30ms ease-in;\n    -o-transition: all 30ms ease-in;\n    transition: all 30ms ease-in; }\n\n.icn-btn {\n  line-height: 1;\n  font-size: 1.6rem;\n  transition: background-color .2s ease-out, color .1s ease-out, opacity .1s ease-out;\n  padding: .6rem;\n  height: 1.75em;\n  width: 1.75em;\n  border-radius: 50%;\n  background-color: transparent;\n  opacity: 0.75;\n  background-color: rgba(55, 55, 55, 0);\n  color: inherit;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer; }\n  .icn-btn [class^=\"icon-\"], .icn-btn [class*=\" icon-\"] {\n    color: inherit;\n    vertical-align: baseline !important; }\n  .icn-btn:hover {\n    opacity: 1;\n    text-decoration: none; }\n  .icn-btn:focus {\n    opacity: 1;\n    background-color: rgba(155, 155, 155, 0.25); }\n  .icn-btn:active {\n    opacity: 1;\n    background-color: rgba(155, 155, 155, 0.25); }\n    .icn-btn:active [class^=\"icon-\"], .icn-btn:active [class*=\" icon-\"] {\n      color: #5ea9c8;\n      opacity: 1; }\n  .icn-btn--overlay {\n    opacity: 0.90;\n    background-color: rgba(35, 35, 35, 0.3); }\n    .icn-btn--overlay:hover {\n      opacity: 1;\n      background-color: rgba(35, 35, 35, 0.7); }\n    .icn-btn--overlay:active {\n      opacity: 1;\n      background-color: rgba(35, 35, 35, 0.8); }\n\n.btn__check {\n  position: relative;\n  color: #fff;\n  padding: 0.7rem 1.6rem;\n  background: #546E7A;\n  border: none;\n  font-size: 1.3rem;\n  border-radius: 3px;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .btn__check:hover {\n    cursor: pointer;\n    background: #5a7683; }\n  .btn__check.btn__check--active, .btn__check:active {\n    background: #2c7694;\n    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.2); }\n    .btn__check.btn__check--active:after, .btn__check:active:after {\n      content: \"\";\n      width: 4.2rem;\n      position: absolute;\n      background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI0MnB4IiBoZWlnaHQ9IjQycHgiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNDIgNDIiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBvcGFjaXR5PSIwLjU4IiBmaWxsPSIjRkZGRkZGIiBkPSJNMjEsMEM5LjQsMCwwLDkuNCwwLDIxYzAsMTEuNiw5LjQsMjEsMjEsMjFzMjEtOS40LDIxLTIxQzQyLDkuNCwzMi42LDAsMjEsMHogTTE3LDMzTDcsMjMKCWw0LTRsNiw2bDE0LTE0bDQsNEwxNywzM3oiLz4KPC9zdmc+Cg==) no-repeat;\n      background-size: 4.2rem;\n      background-position: 0 -0.2rem;\n      top: 0;\n      bottom: 0;\n      right: 0.8rem;\n      opacity: 0.3; }\n  .btn__check.btn__check--active {\n    cursor: default; }\n  .btn__check:active {\n    background: #5a7683;\n    box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.2); }\n    .btn__check:active:after {\n      opacity: 0.05; }\n  .btn__check.btn__check--active:disabled {\n    opacity: 0.5;\n    background-color: rgba(123, 123, 123, 0.5); }\n    .btn__check.btn__check--active:disabled:after {\n      opacity: 0.15; }\n  .btn__check:disabled {\n    opacity: 0.5;\n    color: rgba(255, 255, 255, 0.5);\n    background-color: rgba(123, 123, 123, 0.5); }\n    .btn__check:disabled:hover {\n      cursor: not-allowed; }\n\n.button-nav {\n  display: flex;\n  flex-direction: row;\n  align-content: center; }\n  .button-nav .button-nav__btn {\n    margin: 0 0.5rem; }\n\n.button-nav__btn {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0;\n  padding: 0.7rem 1.8rem;\n  background: transparent;\n  -webkit-appearance: none;\n  border: none;\n  border-radius: 1em;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out;\n  font-size: 1.4rem;\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  cursor: pointer; }\n  .button-nav__btn:hover {\n    background: rgba(123, 123, 123, 0.2); }\n  .button-nav__btn:active, .button-nav__btn--active, .button-nav__btn--active:hover {\n    color: rgba(255, 255, 255, 0.8);\n    background: rgba(0, 0, 0, 0.35);\n    box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.25); }\n\n.btn-icon-group {\n  display: flex;\n  align-items: center; }\n  .btn-icon-group .btn + .btn {\n    margin-left: 6px; }\n  .btn-icon-group [class^=\"icon-\"], .btn-icon-group [class*=\" icon-\"] {\n    opacity: 0.6; }\n\n.dark-ui .btn.btn--ui-dark.btn--hollow.btn--active,\n[class^=\"--dark-ui\"] .btn.btn--ui-dark.btn--hollow.btn--active,\n[class*=\"--dark-ui\"] .btn.btn--ui-dark.btn--hollow.btn--active {\n  color: #5ea9c8;\n  background-color: rgba(0, 0, 0, 0.3);\n  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.8); }\n  .dark-ui .btn.btn--ui-dark.btn--hollow.btn--active i,\n  [class^=\"--dark-ui\"] .btn.btn--ui-dark.btn--hollow.btn--active i,\n  [class*=\"--dark-ui\"] .btn.btn--ui-dark.btn--hollow.btn--active i {\n    color: inherit; }\n\n.dark-ui .btn.btn--hollow,\n[class^=\"--dark-ui\"] .btn.btn--hollow,\n[class*=\"--dark-ui\"] .btn.btn--hollow {\n  border: 1px solid rgba(245, 245, 245, 0.28);\n  color: rgba(245, 245, 245, 0.7);\n  box-shadow: none; }\n  .dark-ui .btn.btn--hollow, .dark-ui .btn.btn--hollow:hover, .dark-ui .btn.btn--hollow:focus,\n  [class^=\"--dark-ui\"] .btn.btn--hollow,\n  [class^=\"--dark-ui\"] .btn.btn--hollow:hover,\n  [class^=\"--dark-ui\"] .btn.btn--hollow:focus,\n  [class*=\"--dark-ui\"] .btn.btn--hollow,\n  [class*=\"--dark-ui\"] .btn.btn--hollow:hover,\n  [class*=\"--dark-ui\"] .btn.btn--hollow:focus {\n    background-color: transparent; }\n  .dark-ui .btn.btn--hollow:hover, .dark-ui .btn.btn--hollow:focus,\n  [class^=\"--dark-ui\"] .btn.btn--hollow:hover,\n  [class^=\"--dark-ui\"] .btn.btn--hollow:focus,\n  [class*=\"--dark-ui\"] .btn.btn--hollow:hover,\n  [class*=\"--dark-ui\"] .btn.btn--hollow:focus {\n    border-color: rgba(245, 245, 245, 0.63);\n    color: rgba(245, 245, 245, 0.63); }\n  .dark-ui .btn.btn--hollow:active,\n  [class^=\"--dark-ui\"] .btn.btn--hollow:active,\n  [class*=\"--dark-ui\"] .btn.btn--hollow:active {\n    box-shadow: inset 0 1px 0 0 rgba(245, 245, 245, 0.7); }\n  .dark-ui .btn.btn--hollow.btn--default,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--default,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--default {\n    border: 1px solid rgba(245, 245, 245, 0.4);\n    color: #F5F5F5;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--default:hover, .dark-ui .btn.btn--hollow.btn--default:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--default:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--default:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--default:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--default:focus {\n      border-color: rgba(245, 245, 245, 0.9);\n      color: rgba(245, 245, 245, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--default:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--default:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--default:active {\n      box-shadow: inset 0 1px 0 0 #F5F5F5; }\n  .dark-ui .btn.btn--hollow.btn--primary,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--primary,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--primary {\n    border: 1px solid rgba(94, 169, 200, 0.4);\n    color: #5ea9c8;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--primary:hover, .dark-ui .btn.btn--hollow.btn--primary:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--primary:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--primary:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--primary:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--primary:focus {\n      border-color: rgba(94, 169, 200, 0.9);\n      color: rgba(94, 169, 200, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--primary:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--primary:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--primary:active {\n      box-shadow: inset 0 1px 0 0 #5ea9c8; }\n  .dark-ui .btn.btn--hollow.btn--success,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--success,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--success {\n    border: 1px solid rgba(70, 165, 70, 0.4);\n    color: #46a546;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--success:hover, .dark-ui .btn.btn--hollow.btn--success:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--success:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--success:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--success:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--success:focus {\n      border-color: rgba(70, 165, 70, 0.9);\n      color: rgba(70, 165, 70, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--success:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--success:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--success:active {\n      box-shadow: inset 0 1px 0 0 #46a546; }\n  .dark-ui .btn.btn--hollow.btn--warning,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--warning,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--warning {\n    border: 1px solid rgba(221, 130, 0, 0.4);\n    color: #dd8200;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--warning:hover, .dark-ui .btn.btn--hollow.btn--warning:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--warning:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--warning:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--warning:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--warning:focus {\n      border-color: rgba(221, 130, 0, 0.9);\n      color: rgba(221, 130, 0, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--warning:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--warning:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--warning:active {\n      box-shadow: inset 0 1px 0 0 #dd8200; }\n  .dark-ui .btn.btn--hollow.btn--alert,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--alert,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--alert {\n    border: 1px solid rgba(229, 28, 35, 0.4);\n    color: #E51C23;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--alert:hover, .dark-ui .btn.btn--hollow.btn--alert:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--alert:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--alert:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--alert:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--alert:focus {\n      border-color: rgba(229, 28, 35, 0.9);\n      color: rgba(229, 28, 35, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--alert:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--alert:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--alert:active {\n      box-shadow: inset 0 1px 0 0 #E51C23; }\n  .dark-ui .btn.btn--hollow.btn--highlight,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--highlight,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--highlight {\n    border: 1px solid rgba(191, 0, 224, 0.4);\n    color: #bf00e0;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--highlight:hover, .dark-ui .btn.btn--hollow.btn--highlight:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:focus {\n      border-color: rgba(191, 0, 224, 0.9);\n      color: rgba(191, 0, 224, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--highlight:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--highlight:active {\n      box-shadow: inset 0 1px 0 0 #bf00e0; }\n  .dark-ui .btn.btn--hollow.btn--sd-green,\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green,\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green {\n    border: 1px solid rgba(30, 176, 108, 0.4);\n    color: #1eb06c;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--sd-green:hover, .dark-ui .btn.btn--hollow.btn--sd-green:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:focus {\n      border-color: rgba(30, 176, 108, 0.9);\n      color: rgba(30, 176, 108, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--sd-green:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--sd-green:active {\n      box-shadow: inset 0 1px 0 0 #1eb06c; }\n  .dark-ui .btn.btn--hollow.btn--disabled, .dark-ui .btn.btn--hollow[disabled],\n  [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled,\n  [class^=\"--dark-ui\"] .btn.btn--hollow[disabled],\n  [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled,\n  [class*=\"--dark-ui\"] .btn.btn--hollow[disabled] {\n    border: 1px solid 0;\n    color: #F5F5F5;\n    box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled, .dark-ui .btn.btn--hollow.btn--disabled:hover, .dark-ui .btn.btn--hollow.btn--disabled:focus, .dark-ui .btn.btn--hollow[disabled], .dark-ui .btn.btn--hollow[disabled]:hover, .dark-ui .btn.btn--hollow[disabled]:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled],\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled],\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus {\n      background-color: transparent; }\n    .dark-ui .btn.btn--hollow.btn--disabled:hover, .dark-ui .btn.btn--hollow.btn--disabled:focus, .dark-ui .btn.btn--hollow[disabled]:hover, .dark-ui .btn.btn--hollow[disabled]:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus {\n      border-color: rgba(245, 245, 245, 0.9);\n      color: rgba(245, 245, 245, 0.9); }\n    .dark-ui .btn.btn--hollow.btn--disabled:active, .dark-ui .btn.btn--hollow[disabled]:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:active {\n      box-shadow: inset 0 1px 0 0 #F5F5F5; }\n    .dark-ui .btn.btn--hollow.btn--disabled:hover, .dark-ui .btn.btn--hollow.btn--disabled:focus, .dark-ui .btn.btn--hollow.btn--disabled:active, .dark-ui .btn.btn--hollow[disabled]:hover, .dark-ui .btn.btn--hollow[disabled]:focus, .dark-ui .btn.btn--hollow[disabled]:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:active,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled]:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled:active,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:hover,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:focus,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled]:active {\n      box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--default, .dark-ui .btn.btn--hollow[disabled].btn--default,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default {\n      border: 1px solid 0;\n      color: #F5F5F5;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--default:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--default:focus, .dark-ui .btn.btn--hollow[disabled].btn--default:hover, .dark-ui .btn.btn--hollow[disabled].btn--default:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:focus {\n        border-color: rgba(245, 245, 245, 0.9);\n        color: rgba(245, 245, 245, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--default:active, .dark-ui .btn.btn--hollow[disabled].btn--default:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:active {\n        box-shadow: inset 0 1px 0 0 #F5F5F5; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--default:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--default:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--default:active, .dark-ui .btn.btn--hollow[disabled].btn--default:hover, .dark-ui .btn.btn--hollow[disabled].btn--default:focus, .dark-ui .btn.btn--hollow[disabled].btn--default:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--default:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--default:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--primary, .dark-ui .btn.btn--hollow[disabled].btn--primary,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary {\n      border: 1px solid 0;\n      color: #5ea9c8;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:focus, .dark-ui .btn.btn--hollow[disabled].btn--primary:hover, .dark-ui .btn.btn--hollow[disabled].btn--primary:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:focus {\n        border-color: rgba(94, 169, 200, 0.9);\n        color: rgba(94, 169, 200, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:active, .dark-ui .btn.btn--hollow[disabled].btn--primary:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:active {\n        box-shadow: inset 0 1px 0 0 #5ea9c8; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--primary:active, .dark-ui .btn.btn--hollow[disabled].btn--primary:hover, .dark-ui .btn.btn--hollow[disabled].btn--primary:focus, .dark-ui .btn.btn--hollow[disabled].btn--primary:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--primary:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--primary:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--success, .dark-ui .btn.btn--hollow[disabled].btn--success,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success {\n      border: 1px solid 0;\n      color: #46a546;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--success:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--success:focus, .dark-ui .btn.btn--hollow[disabled].btn--success:hover, .dark-ui .btn.btn--hollow[disabled].btn--success:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:focus {\n        border-color: rgba(70, 165, 70, 0.9);\n        color: rgba(70, 165, 70, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--success:active, .dark-ui .btn.btn--hollow[disabled].btn--success:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:active {\n        box-shadow: inset 0 1px 0 0 #46a546; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--success:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--success:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--success:active, .dark-ui .btn.btn--hollow[disabled].btn--success:hover, .dark-ui .btn.btn--hollow[disabled].btn--success:focus, .dark-ui .btn.btn--hollow[disabled].btn--success:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--success:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--success:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--warning, .dark-ui .btn.btn--hollow[disabled].btn--warning,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning {\n      border: 1px solid 0;\n      color: #dd8200;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:focus, .dark-ui .btn.btn--hollow[disabled].btn--warning:hover, .dark-ui .btn.btn--hollow[disabled].btn--warning:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:focus {\n        border-color: rgba(221, 130, 0, 0.9);\n        color: rgba(221, 130, 0, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:active, .dark-ui .btn.btn--hollow[disabled].btn--warning:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:active {\n        box-shadow: inset 0 1px 0 0 #dd8200; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--warning:active, .dark-ui .btn.btn--hollow[disabled].btn--warning:hover, .dark-ui .btn.btn--hollow[disabled].btn--warning:focus, .dark-ui .btn.btn--hollow[disabled].btn--warning:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--warning:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--warning:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--alert, .dark-ui .btn.btn--hollow[disabled].btn--alert,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert {\n      border: 1px solid 0;\n      color: #E51C23;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:focus, .dark-ui .btn.btn--hollow[disabled].btn--alert:hover, .dark-ui .btn.btn--hollow[disabled].btn--alert:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:focus {\n        border-color: rgba(229, 28, 35, 0.9);\n        color: rgba(229, 28, 35, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:active, .dark-ui .btn.btn--hollow[disabled].btn--alert:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:active {\n        box-shadow: inset 0 1px 0 0 #E51C23; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--alert:active, .dark-ui .btn.btn--hollow[disabled].btn--alert:hover, .dark-ui .btn.btn--hollow[disabled].btn--alert:focus, .dark-ui .btn.btn--hollow[disabled].btn--alert:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--alert:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--alert:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight, .dark-ui .btn.btn--hollow[disabled].btn--highlight,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight {\n      border: 1px solid 0;\n      color: #bf00e0;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:focus, .dark-ui .btn.btn--hollow[disabled].btn--highlight:hover, .dark-ui .btn.btn--hollow[disabled].btn--highlight:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:focus {\n        border-color: rgba(191, 0, 224, 0.9);\n        color: rgba(191, 0, 224, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:active, .dark-ui .btn.btn--hollow[disabled].btn--highlight:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:active {\n        box-shadow: inset 0 1px 0 0 #bf00e0; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--highlight:active, .dark-ui .btn.btn--hollow[disabled].btn--highlight:hover, .dark-ui .btn.btn--hollow[disabled].btn--highlight:focus, .dark-ui .btn.btn--hollow[disabled].btn--highlight:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--highlight:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--highlight:active {\n        box-shadow: none; }\n    .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green, .dark-ui .btn.btn--hollow[disabled].btn--sd-green,\n    [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green,\n    [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green,\n    [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green,\n    [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green {\n      border: 1px solid 0;\n      color: #1eb06c;\n      box-shadow: none; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:focus, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:hover, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:focus {\n        border-color: rgba(30, 176, 108, 0.9);\n        color: rgba(30, 176, 108, 0.9); }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:active, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:active {\n        box-shadow: inset 0 1px 0 0 #1eb06c; }\n      .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:hover, .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:focus, .dark-ui .btn.btn--hollow.btn--disabled.btn--sd-green:active, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:hover, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:focus, .dark-ui .btn.btn--hollow[disabled].btn--sd-green:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:active,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:hover,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:focus,\n      [class^=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow.btn--disabled.btn--sd-green:active,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:hover,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:focus,\n      [class*=\"--dark-ui\"] .btn.btn--hollow[disabled].btn--sd-green:active {\n        box-shadow: none; }\n\n.label {\n  display: inline-block;\n  padding: 0 0.8rem;\n  vertical-align: middle;\n  border-radius: 8px;\n  text-transform: uppercase;\n  line-height: 1.4rem;\n  letter-spacing: 0.125em;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  cursor: default;\n  border: 1px solid transparent;\n  font-weight: 500;\n  background: #666;\n  color: #fff; }\n  .label.label--large {\n    font-size: 1.2rem;\n    padding: 0.4rem 1.2rem;\n    line-height: 1;\n    border-radius: 11px; }\n  .label.label--default {\n    background: #333; }\n  .label.label--primary {\n    background: #5ea9c8; }\n  .label.label--success {\n    background: #46a546; }\n  .label.label--warning {\n    background: #dd8200; }\n  .label.label--alert {\n    background: #E51C23; }\n  .label.label--highlight {\n    background: #9c27b0; }\n  .label.label--success2 {\n    background: #56812e; }\n  .label.label--yellow2 {\n    background: #d2a800; }\n  .label.label--orange2 {\n    background: #da7200; }\n  .label.label--red2 {\n    background: #be1600; }\n  .label.label--highlight2 {\n    background: #e30083; }\n  .label.label--highlight3 {\n    background: #8b008b; }\n  .label.label--highlight4 {\n    background: #7300ab; }\n  .label.label--darkBlue2 {\n    background: #000080; }\n  .label.label--sd-green {\n    background: #1eb06c; }\n  .label.label--hollow {\n    border: 1px solid #666;\n    background-color: transparent;\n    color: #666; }\n    .label.label--hollow.label--default {\n      border: 1px solid #333;\n      background-color: transparent;\n      color: #333; }\n    .label.label--hollow.label--primary {\n      border: 1px solid #5ea9c8;\n      background-color: transparent;\n      color: #5ea9c8; }\n    .label.label--hollow.label--success {\n      border: 1px solid #46a546;\n      background-color: transparent;\n      color: #46a546; }\n    .label.label--hollow.label--warning {\n      border: 1px solid #dd8200;\n      background-color: transparent;\n      color: #dd8200; }\n    .label.label--hollow.label--alert {\n      border: 1px solid #E51C23;\n      background-color: transparent;\n      color: #E51C23; }\n    .label.label--hollow.label--highlight {\n      border: 1px solid #9c27b0;\n      background-color: transparent;\n      color: #9c27b0; }\n    .label.label--hollow.label--success2 {\n      border: 1px solid #56812e;\n      background-color: transparent;\n      color: #56812e; }\n    .label.label--hollow.label--yellow2 {\n      border: 1px solid #d2a800;\n      background-color: transparent;\n      color: #d2a800; }\n    .label.label--hollow.label--orange2 {\n      border: 1px solid #da7200;\n      background-color: transparent;\n      color: #da7200; }\n    .label.label--hollow.label--red2 {\n      border: 1px solid #be1600;\n      background-color: transparent;\n      color: #be1600; }\n    .label.label--hollow.label--highlight2 {\n      border: 1px solid #e30083;\n      background-color: transparent;\n      color: #e30083; }\n    .label.label--hollow.label--highlight3 {\n      border: 1px solid #8b008b;\n      background-color: transparent;\n      color: #8b008b; }\n    .label.label--hollow.label--highlight4 {\n      border: 1px solid #7300ab;\n      background-color: transparent;\n      color: #7300ab; }\n    .label.label--hollow.label--darkBlue2 {\n      border: 1px solid #000080;\n      background-color: transparent;\n      color: #000080; }\n    .label.label--hollow.label--sd-green {\n      border: 1px solid #1eb06c;\n      background-color: transparent;\n      color: #1eb06c; }\n  .label--annotation {\n    background-color: #a2df56;\n    color: #444; }\n  .label--comment {\n    background-color: #fff16f;\n    color: #444; }\n  .label--no-transform {\n    text-transform: none;\n    letter-spacing: 0.04em; }\n\n.label-icon {\n  display: inline-flex;\n  padding: 0 0.6rem 0 0;\n  vertical-align: middle;\n  align-items: center;\n  line-height: 1.4rem;\n  font-size: 13px;\n  white-space: nowrap;\n  cursor: default;\n  background: transparent;\n  color: #666; }\n  .label-icon [class^=\"icon-\"], .label-icon [class*=\" icon-\"] {\n    color: #666;\n    margin-right: .6rem; }\n  .label-icon.label-icon--default {\n    color: #333; }\n    .label-icon.label-icon--default [class^=\"icon-\"], .label-icon.label-icon--default [class*=\" icon-\"] {\n      color: #333; }\n  .label-icon.label-icon--primary {\n    color: #5ea9c8; }\n    .label-icon.label-icon--primary [class^=\"icon-\"], .label-icon.label-icon--primary [class*=\" icon-\"] {\n      color: #5ea9c8; }\n  .label-icon.label-icon--success {\n    color: #46a546; }\n    .label-icon.label-icon--success [class^=\"icon-\"], .label-icon.label-icon--success [class*=\" icon-\"] {\n      color: #46a546; }\n  .label-icon.label-icon--warning {\n    color: #dd8200; }\n    .label-icon.label-icon--warning [class^=\"icon-\"], .label-icon.label-icon--warning [class*=\" icon-\"] {\n      color: #dd8200; }\n  .label-icon.label-icon--alert {\n    color: #E51C23; }\n    .label-icon.label-icon--alert [class^=\"icon-\"], .label-icon.label-icon--alert [class*=\" icon-\"] {\n      color: #E51C23; }\n  .label-icon.label-icon--highlight {\n    color: #9c27b0; }\n    .label-icon.label-icon--highlight [class^=\"icon-\"], .label-icon.label-icon--highlight [class*=\" icon-\"] {\n      color: #9c27b0; }\n  .label-icon.label-icon--sd-green {\n    color: #1eb06c; }\n    .label-icon.label-icon--sd-green [class^=\"icon-\"], .label-icon.label-icon--sd-green [class*=\" icon-\"] {\n      color: #1eb06c; }\n\n.badge {\n  display: inline-block;\n  min-width: 1.8em;\n  padding: 0.4em 0.5em 0.3em;\n  border-radius: 1em;\n  font-size: 1rem;\n  line-height: 1.1em;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 400;\n  background: #666;\n  color: #fff; }\n  .badge.badge--default {\n    background: #333; }\n  .badge.badge--primary {\n    background: #5ea9c8; }\n  .badge.badge--success {\n    background: #46a546; }\n  .badge.badge--warning {\n    background: #dd8200; }\n  .badge.badge--alert {\n    background: #E51C23; }\n  .badge.badge--highlight {\n    background: #9c27b0; }\n  .badge.badge--sd-green {\n    background: #1eb06c; }\n  .badge--light {\n    background-color: #ddd;\n    background-color: rgba(123, 123, 123, 0.2);\n    color: #333;\n    font-weight: 500; }\n  .badge--square {\n    border-radius: 2px; }\n\n.sd-alert {\n  padding: 1.8rem 3rem 1.8rem 2rem;\n  vertical-align: middle;\n  border-radius: 4px;\n  line-height: 1.4em;\n  font-size: 1.4rem;\n  border: 1px solid transparent;\n  font-weight: 400;\n  position: relative;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2), 0 0 1px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n  background: rgba(153, 153, 153, 0.2);\n  color: inherit;\n  max-height: 20rem;\n  max-width: 100%;\n  height: auto;\n  transition: all linear 100ms;\n  display: flex; }\n  .sd-alert strong {\n    font-weight: 500; }\n  .sd-alert.sd-alert--default {\n    background: #333;\n    color: white; }\n  .sd-alert.sd-alert--primary {\n    background: #5ea9c8;\n    color: white; }\n  .sd-alert.sd-alert--success {\n    background: #46a546;\n    color: white; }\n  .sd-alert.sd-alert--warning {\n    background: #dd8200;\n    color: white; }\n  .sd-alert.sd-alert--alert {\n    background: #E51C23;\n    color: white; }\n  .sd-alert.sd-alert--highlight {\n    background: #9c27b0;\n    color: white; }\n  .sd-alert.sd-alert--success2 {\n    background: #56812e;\n    color: white; }\n  .sd-alert.sd-alert--yellow2 {\n    background: #d2a800;\n    color: white; }\n  .sd-alert.sd-alert--orange2 {\n    background: #da7200;\n    color: white; }\n  .sd-alert.sd-alert--red2 {\n    background: #be1600;\n    color: white; }\n  .sd-alert.sd-alert--highlight2 {\n    background: #e30083;\n    color: white; }\n  .sd-alert.sd-alert--highlight3 {\n    background: #8b008b;\n    color: white; }\n  .sd-alert.sd-alert--highlight4 {\n    background: #7300ab;\n    color: white; }\n  .sd-alert.sd-alert--darkBlue2 {\n    background: #000080;\n    color: white; }\n  .sd-alert.sd-alert--sd-green {\n    background: #1eb06c;\n    color: white; }\n  .sd-alert.sd-alert--hollow {\n    border: 1px solid #7b7b7b;\n    background-color: rgba(123, 123, 123, 0.05);\n    color: #7b7b7b; }\n    .sd-alert.sd-alert--hollow.sd-alert--default {\n      border: 1px solid #333;\n      background-color: rgba(51, 51, 51, 0.05);\n      color: #333; }\n    .sd-alert.sd-alert--hollow.sd-alert--primary {\n      border: 1px solid #5ea9c8;\n      background-color: rgba(94, 169, 200, 0.05);\n      color: #5ea9c8; }\n    .sd-alert.sd-alert--hollow.sd-alert--success {\n      border: 1px solid #46a546;\n      background-color: rgba(70, 165, 70, 0.05);\n      color: #46a546; }\n    .sd-alert.sd-alert--hollow.sd-alert--warning {\n      border: 1px solid #dd8200;\n      background-color: rgba(221, 130, 0, 0.05);\n      color: #dd8200; }\n    .sd-alert.sd-alert--hollow.sd-alert--alert {\n      border: 1px solid #E51C23;\n      background-color: rgba(229, 28, 35, 0.05);\n      color: #E51C23; }\n    .sd-alert.sd-alert--hollow.sd-alert--highlight {\n      border: 1px solid #9c27b0;\n      background-color: rgba(156, 39, 176, 0.05);\n      color: #9c27b0; }\n    .sd-alert.sd-alert--hollow.sd-alert--success2 {\n      border: 1px solid #56812e;\n      background-color: rgba(86, 129, 46, 0.05);\n      color: #56812e; }\n    .sd-alert.sd-alert--hollow.sd-alert--yellow2 {\n      border: 1px solid #d2a800;\n      background-color: rgba(210, 168, 0, 0.05);\n      color: #d2a800; }\n    .sd-alert.sd-alert--hollow.sd-alert--orange2 {\n      border: 1px solid #da7200;\n      background-color: rgba(218, 114, 0, 0.05);\n      color: #da7200; }\n    .sd-alert.sd-alert--hollow.sd-alert--red2 {\n      border: 1px solid #be1600;\n      background-color: rgba(190, 22, 0, 0.05);\n      color: #be1600; }\n    .sd-alert.sd-alert--hollow.sd-alert--highlight2 {\n      border: 1px solid #e30083;\n      background-color: rgba(227, 0, 131, 0.05);\n      color: #e30083; }\n    .sd-alert.sd-alert--hollow.sd-alert--highlight3 {\n      border: 1px solid #8b008b;\n      background-color: rgba(139, 0, 139, 0.05);\n      color: #8b008b; }\n    .sd-alert.sd-alert--hollow.sd-alert--highlight4 {\n      border: 1px solid #7300ab;\n      background-color: rgba(115, 0, 171, 0.05);\n      color: #7300ab; }\n    .sd-alert.sd-alert--hollow.sd-alert--darkBlue2 {\n      border: 1px solid #000080;\n      background-color: rgba(0, 0, 128, 0.05);\n      color: #000080; }\n    .sd-alert.sd-alert--hollow.sd-alert--sd-green {\n      border: 1px solid #1eb06c;\n      background-color: rgba(30, 176, 108, 0.05);\n      color: #1eb06c; }\n  .sd-alert p {\n    font-size: 1.4rem;\n    color: inherit;\n    margin-bottom: 1em; }\n  .sd-alert p:last-child,\n  .sd-alert p:only-child {\n    margin-bottom: 0; }\n  .sd-alert--hidden {\n    opacity: 0;\n    max-height: 0.1rem;\n    max-width: 10%;\n    padding: 0;\n    overflow: hidden;\n    font-size: 0.1rem;\n    transition: font-size ease-out 300ms, padding ease-out 300ms, max-width ease-out 200ms, max-height ease-out 300ms, opacity ease-out 200ms; }\n  .sd-alert--small {\n    font-size: 1.3rem;\n    padding: 0.8rem 2.4rem 0.8rem 1.2rem;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.08);\n    transition: font-size ease-out 20ms, padding ease-out 200ms, max-width ease-out 100ms, max-height ease-out 80ms, opacity ease-out 160ms; }\n  .sd-alert--marg-b12 {\n    margin-bottom: 1.2rem; }\n  .sd-alert--no-margin {\n    margin-bottom: 0; }\n\n.sd-alert__close {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  width: 2.1rem;\n  height: 2.1rem;\n  padding: 0;\n  z-index: 1;\n  opacity: .2;\n  line-height: 2.1rem;\n  color: inherit;\n  border-radius: 50%; }\n  .sd-alert__close::after {\n    font-family: sd_icons;\n    font-size: 16px;\n    content: \"\\E647\";\n    width: 16px;\n    height: 16px;\n    position: absolute;\n    top: 0;\n    left: 0.3rem;\n    line-height: inherit;\n    color: inherit;\n    font-style: normal;\n    font-weight: 400;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased; }\n  .sd-alert__close:hover {\n    opacity: .8;\n    background-color: rgba(255, 255, 255, 0.3); }\n  .sd-alert__close:active {\n    opacity: 1;\n    background-color: rgba(255, 255, 255, 0.5); }\n\n.sd-alert--small .sd-alert__close {\n  top: 0.4rem; }\n\n.sd-alert__container {\n  position: relative;\n  min-height: 3rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end; }\n\n.sd-alert__icon {\n  margin: 0.1rem 1.2rem 0 -0.5rem;\n  flex-shrink: 0; }\n\n.sd-alert--small .sd-alert__icon {\n  margin-left: 0; }\n\n.sd-alert__info-btn {\n  cursor: pointer;\n  height: 2.2rem;\n  width: 2.2rem;\n  font-family: 'Merriweather', Georgia, 'Times New Roman', Times, serif;\n  font-weight: 500;\n  font-style: italic;\n  line-height: 2.4rem;\n  font-size: 1.4rem;\n  letter-spacing: 0.1rem;\n  color: white;\n  text-align: center;\n  display: inline-block;\n  border-radius: 50%;\n  flex-grow: 0;\n  flex-shrink: 1;\n  transition: all linear 100ms 0.2s, background ease-in 200ms;\n  background: #7b7b7b; }\n  .sd-alert__info-btn [class^=\"icon-\"], .sd-alert__info-btn [class*=\" icon-\"] {\n    color: inherit;\n    margin-top: 0.3rem; }\n  .sd-alert__info-btn:hover {\n    background: #626262; }\n  .sd-alert__info-btn.sd-alert__info-btn--default {\n    background: #333;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--default:hover {\n      background: #292929; }\n  .sd-alert__info-btn.sd-alert__info-btn--primary {\n    background: #5ea9c8;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--primary:hover {\n      background: #3c8eaf; }\n  .sd-alert__info-btn.sd-alert__info-btn--success {\n    background: #46a546;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--success:hover {\n      background: #388438; }\n  .sd-alert__info-btn.sd-alert__info-btn--warning {\n    background: #dd8200;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--warning:hover {\n      background: #b16800; }\n  .sd-alert__info-btn.sd-alert__info-btn--alert {\n    background: #E51C23;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--alert:hover {\n      background: #b8151b; }\n  .sd-alert__info-btn.sd-alert__info-btn--highlight {\n    background: #9c27b0;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--highlight:hover {\n      background: #7d1f8d; }\n  .sd-alert__info-btn.sd-alert__info-btn--success2 {\n    background: #56812e;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--success2:hover {\n      background: #456725; }\n  .sd-alert__info-btn.sd-alert__info-btn--yellow2 {\n    background: #d2a800;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--yellow2:hover {\n      background: #a88600; }\n  .sd-alert__info-btn.sd-alert__info-btn--orange2 {\n    background: #da7200;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--orange2:hover {\n      background: #ae5b00; }\n  .sd-alert__info-btn.sd-alert__info-btn--red2 {\n    background: #be1600;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--red2:hover {\n      background: #981200; }\n  .sd-alert__info-btn.sd-alert__info-btn--highlight2 {\n    background: #e30083;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--highlight2:hover {\n      background: #b60069; }\n  .sd-alert__info-btn.sd-alert__info-btn--highlight3 {\n    background: #8b008b;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--highlight3:hover {\n      background: #6f006f; }\n  .sd-alert__info-btn.sd-alert__info-btn--highlight4 {\n    background: #7300ab;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--highlight4:hover {\n      background: #5c0089; }\n  .sd-alert__info-btn.sd-alert__info-btn--darkBlue2 {\n    background: #000080;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--darkBlue2:hover {\n      background: #000066; }\n  .sd-alert__info-btn.sd-alert__info-btn--sd-green {\n    background: #1eb06c;\n    color: white; }\n    .sd-alert__info-btn.sd-alert__info-btn--sd-green:hover {\n      background: #188d56; }\n  .sd-alert__info-btn--hidden {\n    opacity: 0;\n    height: 1px;\n    width: 1px;\n    flex-shrink: 1;\n    transition: all linear 100ms; }\n\n.sd-alert__container .sd-alert {\n  flex-grow: 1; }\n\n@font-face {\n  font-family: 'sd_icons';\n  src: url(" + escape(__webpack_require__(255)) + ");\n  src: url(" + escape(__webpack_require__(255)) + "?#iefix-r9v51w) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(607)) + ") format(\"woff\"), url(" + escape(__webpack_require__(608)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(609)) + "#sd_icons) format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  line-height: 16px;\n  font-size: 16px;\n  font-family: 'sd_icons';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  color: #333;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.icon--2x {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  font-size: 32px; }\n\n.icon--light {\n  opacity: 0.5; }\n\n.icon--blue {\n  color: #5ea9c8 !important; }\n\n.icon--white {\n  color: #fff !important; }\n\n.icon--light-blue {\n  color: #68abc8 !important;\n  opacity: 1 !important; }\n\n.icon--dark-blue-grey {\n  color: #31728e !important;\n  opacity: 1 !important; }\n\n[class*=icon-].red,\n.icon--red {\n  color: #be1600 !important; }\n\n.icon--orange {\n  color: #dd8200 !important; }\n\n.icon--green {\n  color: #46a546 !important; }\n\n.icon--rotate-180 {\n  transform: rotate(180deg); }\n\n.icon--rotate-90 {\n  transform: rotate(90deg); }\n\n.icon--full-opacity {\n  opacity: 1 !important; }\n\n.icon--disabled {\n  opacity: 0.2 !important; }\n\n.icon-photo:before {\n  content: \"\\E600\"; }\n\n.icon-video:before {\n  content: \"\\E601\"; }\n\n.icon-map-marker:before {\n  content: \"\\E602\"; }\n\n.icon-slideshow:before {\n  content: \"\\E603\"; }\n\n.icon-text:before {\n  content: \"\\E604\"; }\n\n.icon-file:before {\n  content: \"\\E605\"; }\n\n.icon-calendar:before {\n  content: \"\\E606\"; }\n\n.icon-composite:before {\n  content: \"\\E607\"; }\n\n.icon-audio:before {\n  content: \"\\E608\"; }\n\n.icon-stream:before {\n  content: \"\\E609\"; }\n\n.icon-ingest:before {\n  content: \"\\E60A\"; }\n\n.icon-archive:before {\n  content: \"\\E60B\"; }\n\n.icon-time:before {\n  content: \"\\E60C\"; }\n\n.icon-pin:before {\n  content: \"\\E60D\"; }\n\n.icon-expand:before {\n  content: \"\\E60E\"; }\n\n.icon-ascending:before {\n  content: \"\\E60F\"; }\n\n.icon-descending:before {\n  content: \"\\E60F\"; }\n\n.icon-descending {\n  transform: rotate(180deg); }\n\n.icon-th:before {\n  content: \"\\E610\"; }\n\n.icon-grid-view:before {\n  content: \"\\E610\"; }\n\n.icon-th-list:before {\n  content: \"\\E611\"; }\n\n.icon-list-view:before {\n  content: \"\\E611\"; }\n\n.icon-pencil:before {\n  content: \"\\E612\"; }\n\n.icon-lock:before {\n  content: \"\\E613\"; }\n\n.icon-retweet:before {\n  content: \"\\E614\"; }\n\n.icon-unspike:before {\n  content: \"\\E615\"; }\n\n.icon-fullscreen:before {\n  content: \"\\E616\"; }\n\n.icon-fetch-as:before {\n  content: \"\\E617\"; }\n\n.icon-search:before {\n  content: \"\\E618\"; }\n\n.icon-star:before {\n  content: \"\\E619\"; }\n\n.icon-star-empty:before {\n  content: \"\\E61A\"; }\n\n.icon-multi-star:before {\n  content: \"\\E61B\"; }\n\n.icon-th-large:before {\n  content: \"\\E61C\"; }\n\n.icon-grid-view-large:before {\n  content: \"\\E61C\"; }\n\n.icon-ok:before {\n  content: \"\\E61D\"; }\n\n.icon-zoom-in:before {\n  content: \"\\E61E\"; }\n\n.icon-zoom-out:before {\n  content: \"\\E61F\"; }\n\n.icon-signal:before {\n  content: \"\\E620\"; }\n\n.icon-filter-large:before {\n  content: \"\\E621\"; }\n\n.icon-trash:before {\n  content: \"\\E622\"; }\n\n.icon-user:before {\n  content: \"\\E623\"; }\n\n.icon-download:before {\n  content: \"\\E624\"; }\n\n.icon-upload:before {\n  content: \"\\E625\"; }\n\n.icon-repeat:before {\n  content: \"\\E626\"; }\n\n.icon-refresh:before {\n  content: \"\\E627\"; }\n\n.icon-list-alt:before {\n  content: \"\\E628\"; }\n\n.icon-plus-large:before {\n  content: \"\\E629\"; }\n\n.icon-picture:before {\n  content: \"\\E62A\"; }\n\n.icon-question-sign:before {\n  content: \"\\E62B\"; }\n\n.icon-info-sign:before {\n  content: \"\\E62C\"; }\n\n.icon-plus-sign:before {\n  content: \"\\E62D\"; }\n\n.icon-minus-sign:before {\n  content: \"\\E62E\"; }\n\n.icon-remove-sign:before {\n  content: \"\\E62F\"; }\n\n.icon-share-alt:before {\n  content: \"\\E630\"; }\n\n.icon-exclamation-sign:before {\n  content: \"\\E631\"; }\n\n.icon-eye-open:before {\n  content: \"\\E632\"; }\n\n.icon-copy:before {\n  content: \"\\E633\"; }\n\n.icon-comment:before {\n  content: \"\\E634\"; }\n\n.icon-warning-sign:before {\n  content: \"\\E635\"; }\n\n.icon-adjust:before {\n  content: \"\\E636\"; }\n\n.icon-folder-close:before {\n  content: \"\\E637\"; }\n\n.icon-folder-open:before {\n  content: \"\\E638\"; }\n\n.icon-download-alt:before {\n  content: \"\\E639\"; }\n\n.icon-tasks:before {\n  content: \"\\E63A\"; }\n\n.icon-globe:before {\n  content: \"\\E63B\"; }\n\n.icon-link:before {\n  content: \"\\E63C\"; }\n\n.icon-expand-thin:before {\n  content: \"\\E63D\"; }\n\n.icon-assign:before {\n  content: \"\\E63E\"; }\n\n.icon-dots:before {\n  content: \"\\E63F\"; }\n\n.icon-dots-vertical:before {\n  content: \"\\E63F\"; }\n\n.icon-dots-vertical {\n  transform: rotate(90deg); }\n\n.icon-backward-thin:before {\n  content: \"\\E640\"; }\n\n.icon-forward-thin:before {\n  content: \"\\E641\"; }\n\n.icon-chevron-left-thin:before {\n  content: \"\\E642\"; }\n\n.icon-chevron-right-thin:before {\n  content: \"\\E643\"; }\n\n.icon-switches:before {\n  content: \"\\E644\"; }\n\n.icon-plus-small:before {\n  content: \"\\E645\"; }\n\n.icon-minus-small:before {\n  content: \"\\E646\"; }\n\n.icon-close-small:before {\n  content: \"\\E647\"; }\n\n.icon-post:before {\n  content: \"\\E648\"; }\n\n.icon-external:before {\n  content: \"\\E649\"; }\n\n.icon-chevron-up-thin:before {\n  content: \"\\E64A\"; }\n\n.icon-chevron-down-thin:before {\n  content: \"\\E64B\"; }\n\n.icon-pick:before {\n  content: \"\\E64C\"; }\n\n.icon-revert:before {\n  content: \"\\E64D\"; }\n\n.icon-package-plus:before {\n  content: \"\\E64E\"; }\n\n.icon-list-plus:before {\n  content: \"\\E64F\"; }\n\n.icon-envelope:before {\n  content: \"\\E650\"; }\n\n.icon-heart:before {\n  content: \"\\E651\"; }\n\n.icon-home:before {\n  content: \"\\E652\"; }\n\n.icon-print:before {\n  content: \"\\E653\"; }\n\n.icon-font:before {\n  content: \"\\E654\"; }\n\n.icon-bold:before {\n  content: \"\\E655\"; }\n\n.icon-italic:before {\n  content: \"\\E656\"; }\n\n.icon-underline:before {\n  content: \"\\E657\"; }\n\n.icon-strikethrough:before {\n  content: \"\\E658\"; }\n\n.icon-align-left:before {\n  content: \"\\E659\"; }\n\n.icon-align-center:before {\n  content: \"\\E65A\"; }\n\n.icon-align-right:before {\n  content: \"\\E65B\"; }\n\n.icon-align-justify:before {\n  content: \"\\E65C\"; }\n\n.icon-unordered-list:before {\n  content: \"\\E65D\"; }\n\n.icon-indent-left:before {\n  content: \"\\E65E\"; }\n\n.icon-indent-right:before {\n  content: \"\\E65F\"; }\n\n.icon-ban-circle:before {\n  content: \"\\E660\"; }\n\n.icon-bell:before {\n  content: \"\\E661\"; }\n\n.icon-random:before {\n  content: \"\\E662\"; }\n\n.icon-settings:before {\n  content: \"\\E663\"; }\n\n.icon-package-create:before {\n  content: \"\\E664\"; }\n\n.icon-list-menu:before {\n  content: \"\\E665\"; }\n\n.icon-new-doc:before {\n  content: \"\\E666\"; }\n\n.icon-edit-line:before {\n  content: \"\\E667\"; }\n\n.icon-calendar-list:before {\n  content: \"\\E668\"; }\n\n.icon-collapse:before {\n  content: \"\\E669\"; }\n\n.icon-broadcast:before {\n  content: \"\\E66A\"; }\n\n.icon-broadcast-create:before {\n  content: \"\\E66B\"; }\n\n.icon-kill:before {\n  content: \"\\E66C\"; }\n\n.icon-graphic:before {\n  content: \"\\E66D\"; }\n\n.icon-close-thick:before {\n  content: \"\\E66E\"; }\n\n.icon-move:before {\n  content: \"\\E66F\"; }\n\n.icon-takes-package:before {\n  content: \"\\E670\"; }\n\n.icon-highlight-package:before {\n  content: \"\\E671\"; }\n\n.icon-preview-mode:before {\n  content: \"\\E672\"; }\n\n.icon-unlocked:before {\n  content: \"\\E673\"; }\n\n.icon-code:before {\n  content: \"\\E674\"; }\n\n.icon-cut:before {\n  content: \"\\E675\"; }\n\n.icon-paste:before {\n  content: \"\\E676\"; }\n\n.icon-arrow-left:before {\n  content: \"\\E677\"; }\n\n.icon-arrow-right:before {\n  content: \"\\E678\"; }\n\n.icon-info-large:before {\n  content: \"\\E679\"; }\n\n.icon-help-large:before {\n  content: \"\\E67A\"; }\n\n.icon-attachment:before {\n  content: \"\\E67B\"; }\n\n.icon-attachment-large:before {\n  content: \"\\E67C\"; }\n\n.icon-table:before {\n  content: \"\\E67D\"; }\n\n.icon-ordered-list:before {\n  content: \"\\E67E\"; }\n\n.icon-heading-1:before {\n  content: \"\\E67F\"; }\n\n.icon-heading-2:before {\n  content: \"\\E680\"; }\n\n.icon-heading-3:before {\n  content: \"\\E681\"; }\n\n.icon-heading-4:before {\n  content: \"\\E682\"; }\n\n.icon-heading-5:before {\n  content: \"\\E683\"; }\n\n.icon-heading-6:before {\n  content: \"\\E684\"; }\n\n.icon-quote:before {\n  content: \"\\E685\"; }\n\n.icon-multiedit:before {\n  content: \"\\E686\"; }\n\n.icon-phone:before {\n  content: \"\\E687\"; }\n\n.icon-mobile:before {\n  content: \"\\E688\"; }\n\n.icon-twitter:before {\n  content: \"\\E689\"; }\n\n.icon-facebook:before {\n  content: \"\\E68A\"; }\n\n.icon-linked-in:before {\n  content: \"\\E68B\"; }\n\n.icon-twitter-circle:before {\n  content: \"\\E68C\"; }\n\n.icon-facebook-circle:before {\n  content: \"\\E68D\"; }\n\n.icon-linked-in-circle:before {\n  content: \"\\E68E\"; }\n\n.icon-recurring:before {\n  content: \"\\E68F\"; }\n\n.icon-paragraph:before {\n  content: \"\\E690\"; }\n\n.icon-suggestion:before {\n  content: \"\\E691\"; }\n\n.icon-event:before {\n  content: \"\\E692\"; }\n\n.icon-kanban-view:before {\n  content: \"\\E693\"; }\n\n.icon-subscript:before {\n  content: \"\\E694\"; }\n\n.icon-superscript:before {\n  content: \"\\E695\"; }\n\n.icon-clear-format:before {\n  content: \"\\E696\"; }\n\n.icon-preformatted:before {\n  content: \"\\E697\"; }\n\n.icon-crop:before {\n  content: \"\\E698\"; }\n\n.icon-flip-horizontal:before {\n  content: \"\\E699\"; }\n\n.icon-flip-vertical:before {\n  content: \"\\E69A\"; }\n\n.icon-rotate-right:before {\n  content: \"\\E69B\"; }\n\n.icon-rotate-left:before {\n  content: \"\\E69C\"; }\n\n.icon-business:before {\n  content: \"\\E69D\"; }\n\n.icon-paywall:before {\n  content: \"\\E69E\"; }\n\n.icon-analytics:before {\n  content: \"\\E69F\"; }\n\n.icon-amp:before {\n  content: \"\\E6A0\"; }\n\n.icon-undo:before {\n  content: \"\\E6A1\"; }\n\n.icon-redo:before {\n  content: \"\\E6A2\"; }\n\n.icon-instagram:before {\n  content: \"\\E6A3\"; }\n\n.icn-mix {\n  position: relative;\n  display: inline-block;\n  font-size: 16px;\n  height: 16px; }\n  .icn-mix .icn-mix__icn {\n    opacity: 0.6; }\n  .icn-mix .icn-mix__sub-icn {\n    position: absolute;\n    font-size: 1.1rem;\n    box-sizing: content-box;\n    line-height: 100%;\n    color: #9c27b0;\n    right: -0.5rem;\n    bottom: -0.7rem;\n    height: 1em;\n    width: 1em;\n    background-color: #fff;\n    border-radius: 50%;\n    padding: 1px;\n    z-index: 1;\n    opacity: 1 !important; }\n  .icn-mix--2x {\n    font-size: 32px;\n    height: 32px; }\n    .icn-mix--2x .icn-mix__icn {\n      opacity: 0.6;\n      width: 32px;\n      height: 32px;\n      line-height: 32px;\n      font-size: 32px; }\n    .icn-mix--2x .icn-mix__sub-icn {\n      font-size: 1.6rem;\n      right: -0.6rem;\n      bottom: -0.3rem; }\n\n.double-size-icn {\n  display: inline-block;\n  height: 3.2rem;\n  width: 3.2rem; }\n  .double-size-icn [class^=\"icon-\"],\n  .double-size-icn [class*=\" icon-\"] {\n    width: 32px;\n    height: 32px;\n    line-height: 32px;\n    font-size: 32px; }\n  .double-size-icn--light [class^=\"icon-\"],\n  .double-size-icn--light [class*=\" icon-\"] {\n    opacity: 0.5; }\n\n.subnav .icn-mix__sub-icn {\n  background-color: #F5F5F5; }\n\n.subnav--darker .icn-mix__sub-icn {\n  background-color: #dedede; }\n\n.subnav--dark-blue-grey .icn-mix__sub-icn {\n  background-color: #59727d;\n  color: #d786e4; }\n\n.subnav--dark-blue-grey .icn-mix__icn {\n  color: inherit;\n  opacity: 1; }\n\n.side-panel__top-tools .icn-mix__sub-icn {\n  background-color: #f0f0f0; }\n\n.side-panel__top-tools--dark-blue-grey .icn-mix__sub-icn {\n  background-color: #59727d;\n  color: #d786e4; }\n\n.side-panel__top-tools--dark-blue-grey .icn-mix__icn {\n  color: inherit;\n  opacity: 1; }\n\n@font-face {\n  font-family: 'sd_big-icons';\n  src: url(" + escape(__webpack_require__(256)) + ");\n  src: url(" + escape(__webpack_require__(256)) + "#iefix) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(610)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(611)) + ") format(\"woff\"), url(" + escape(__webpack_require__(612)) + "#sd_big-icons) format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n[class^=\"big-icon--\"],\n[class*=\" big-icon--\"] {\n  display: inline-block;\n  width: 26px;\n  height: 26px;\n  line-height: 26px;\n  font-family: 'sd_big-icons';\n  font-size: 26px;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  color: #333;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n\n.big-icon--blue {\n  color: #5ea9c8; }\n\n.big-icon--white {\n  color: #fff !important; }\n\n[class*=big-icon--].red,\n.big-icon--red {\n  color: #be1600; }\n\n.big-icon--dashboard:before {\n  content: \"\\E600\"; }\n\n.big-icon--view:before {\n  content: \"\\E601\"; }\n\n.big-icon--tasks:before {\n  content: \"\\E602\"; }\n\n.big-icon--calendar:before {\n  content: \"\\E603\"; }\n\n.big-icon--marked-star:before {\n  content: \"\\E604\"; }\n\n.big-icon--archive:before {\n  content: \"\\E605\"; }\n\n.big-icon--spike:before {\n  content: \"\\E606\"; }\n\n.big-icon--unspike:before {\n  content: \"\\E607\"; }\n\n.big-icon--personal:before {\n  content: \"\\E608\"; }\n\n.big-icon--global-search:before {\n  content: \"\\E609\"; }\n\n.big-icon--analytics:before {\n  content: \"\\E60A\"; }\n\n.big-icon--web:before {\n  content: \"\\E60B\"; }\n\n.big-icon--cog:before {\n  content: \"\\E60C\"; }\n\n.big-icon--send-to:before {\n  content: \"\\E60D\"; }\n\n.big-icon--info:before {\n  content: \"\\E60E\"; }\n\n.big-icon--find-replace:before {\n  content: \"\\E60F\"; }\n\n.big-icon--comments:before {\n  content: \"\\E610\"; }\n\n.big-icon--history:before {\n  content: \"\\E611\"; }\n\n.big-icon--package:before {\n  content: \"\\E612\"; }\n\n.big-icon--create-package:before {\n  content: \"\\E613\"; }\n\n.big-icon--add-to-package:before {\n  content: \"\\E614\"; }\n\n.big-icon--fetch:before {\n  content: \"\\E615\"; }\n\n.big-icon--fetch-as:before {\n  content: \"\\E616\"; }\n\n.big-icon--macro:before {\n  content: \"\\E617\"; }\n\n.big-icon--related:before {\n  content: \"\\E618\"; }\n\n.big-icon--minimize:before {\n  content: \"\\E619\"; }\n\n.big-icon--settings:before {\n  content: \"\\E61A\"; }\n\n.big-icon--multiedit:before {\n  content: \"\\E61B\"; }\n\n.big-icon--export:before {\n  content: \"\\E61C\"; }\n\n.big-icon--create-list:before {\n  content: \"\\E61D\"; }\n\n.big-icon--add-to-list:before {\n  content: \"\\E61E\"; }\n\n.big-icon--text:before {\n  content: \"\\E61F\"; }\n\n.big-icon--desk:before {\n  content: \"\\E620\"; }\n\n.big-icon--chevron-left:before {\n  content: \"\\E621\"; }\n\n.big-icon--chevron-right:before {\n  content: \"\\E622\"; }\n\n.big-icon--dashboard-alt:before {\n  content: \"\\E623\"; }\n\n.big-icon--master:before {\n  content: \"\\E624\"; }\n\n.big-icon--attachment:before {\n  content: \"\\E625\"; }\n\n.big-icon--upload-alt:before {\n  content: \"\\E626\"; }\n\n.big-icon--document-default:before {\n  content: \"\\E627\"; }\n\n.big-icon--document-pdf:before {\n  content: \"\\E628\"; }\n\n.big-icon--document-doc:before {\n  content: \"\\E629\"; }\n\n.big-icon--semantics:before {\n  content: \"\\E62A\"; }\n\n.big-icon--picture:before {\n  content: \"\\E62B\"; }\n\n.big-icon--manage-package:before {\n  content: \"\\E62C\"; }\n\n.big-icon--live:before {\n  content: \"\\E62D\"; }\n\n.big-icon--live-alt:before {\n  content: \"\\E62E\"; }\n\n.big-icon--meta-search:before {\n  content: \"\\E62F\"; }\n\n.big-icon--chat:before {\n  content: \"\\E630\"; }\n\n.big-icon--annotation:before {\n  content: \"\\E631\"; }\n\n.big-icon--suggestion:before {\n  content: \"\\E632\"; }\n\n.big-icon--publisher:before {\n  content: \"\\E633\"; }\n\n.modal-open {\n  overflow: hidden; }\n  .modal-open .dropdown__menu {\n    z-index: 2050; }\n  .modal-open .dropdown.open {\n    *z-index: 2050; }\n  .modal-open .popover {\n    z-index: 2060; }\n  .modal-open .tooltip {\n    z-index: 2090; }\n\n.modal {\n  position: fixed;\n  left: 40px;\n  right: 40px;\n  top: 40px;\n  bottom: 40px;\n  align-items: flex-start;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 1050;\n  display: none; }\n  .modal.in {\n    display: flex !important; }\n  .modal .modal__dialog {\n    display: flex;\n    max-height: 100%;\n    flex: 0 1 auto;\n    margin: 0 auto;\n    max-width: 480px;\n    width: 100%; }\n  .modal .modal__content {\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    margin: 10px 0;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    border-radius: 4px;\n    -webkit-box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.3);\n    box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.3);\n    flex: 0 0 100%; }\n    .modal .modal__content .modal__header, .modal .modal__content .modal__footer {\n      flex: 0 0 auto;\n      width: 100%; }\n    .modal .modal__content .modal__header {\n      padding: 1.2rem 2rem;\n      border-bottom: 1px solid #e4e4e4;\n      min-height: 48px;\n      position: relative; }\n      .modal .modal__content .modal__header--padding-20 {\n        padding: 10px 20px; }\n      .modal .modal__content .modal__header--flex {\n        display: flex;\n        flex-direction: row;\n        align-items: center; }\n        .modal .modal__content .modal__header--flex .modal__heading {\n          flex-grow: 1; }\n          .modal .modal__content .modal__header--flex .modal__heading--no-grow {\n            flex-grow: 0; }\n    .modal .modal__content .modal__sliding-toolbar {\n      position: absolute;\n      display: flex;\n      align-items: center;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      z-index: 3;\n      padding: 0 16px;\n      color: #333;\n      animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n      background-color: #d2e5ed;\n      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n      max-height: 5.4rem; }\n      .modal .modal__content .modal__sliding-toolbar--right {\n        text-align: right;\n        justify-content: flex-end; }\n      .modal .modal__content .modal__sliding-toolbar .sliding-toolbar__inner {\n        flex-grow: 1;\n        display: flex;\n        align-items: center; }\n        .modal .modal__content .modal__sliding-toolbar .sliding-toolbar__inner--right {\n          text-align: right; }\n      .modal .modal__content .modal__sliding-toolbar .sliding-toolbar__info-text {\n        font-weight: 300;\n        opacity: 0.75; }\n      .modal .modal__content .modal__sliding-toolbar .btn + .sliding-toolbar__info-text {\n        margin-left: 1rem; }\n    .modal .modal__content .modal__header-element-grow {\n      flex-grow: 1; }\n    .modal .modal__content .modal__header-buttons {\n      display: flex;\n      align-content: center; }\n      .modal .modal__content .modal__header-buttons--right {\n        justify-content: right; }\n        .modal .modal__content .modal__header-buttons--right .btn, .modal .modal__content .modal__header-buttons--right .dropdown {\n          margin: 0 0 0 1rem; }\n      .modal .modal__content .modal__header-buttons--center {\n        justify-content: center; }\n      .modal .modal__content .modal__header-buttons--grow {\n        flex-grow: 1; }\n    .modal .modal__content .modal__footer {\n      padding: 1.2rem 2rem;\n      text-align: right;\n      border-top: 1px solid #e4e4e4;\n      min-height: 48px;\n      *zoom: 1; }\n      .modal .modal__content .modal__footer:before, .modal .modal__content .modal__footer:after {\n        display: table;\n        content: \"\"; }\n      .modal .modal__content .modal__footer:after {\n        clear: both; }\n    .modal .modal__content .modal__body {\n      background: #f8f8f8;\n      overflow-y: auto;\n      padding: 2rem;\n      position: relative;\n      flex: 0 1 auto;\n      width: 100%;\n      max-width: 480px; }\n      .modal .modal__content .modal__body--add-min-height {\n        min-height: 300px; }\n        @media (max-height: 500px) {\n          .modal .modal__content .modal__body--add-min-height {\n            min-height: auto; } }\n      .modal .modal__content .modal__body--no-padding {\n        padding: 0; }\n    .modal .modal__content .modal__body-heading {\n      font-size: 1.8rem;\n      color: #333;\n      font-weight: 400;\n      margin-bottom: 2rem;\n      line-height: 100%; }\n      .modal .modal__content .modal__body-heading--inactive {\n        color: #adadad; }\n      .modal .modal__content .modal__body-heading .badge {\n        vertical-align: bottom;\n        margin-right: 0.6rem; }\n  .modal--large .modal__dialog {\n    max-width: 680px; }\n  .modal--large .modal__body {\n    max-width: 680px !important; }\n  .modal--x-large .modal__dialog {\n    max-width: 1000px; }\n  .modal--x-large .modal__body {\n    max-width: 1000px !important; }\n  .modal--fill {\n    position: fixed;\n    left: 30px;\n    right: 30px;\n    top: 30px;\n    bottom: 30px;\n    align-items: flex-start;\n    flex-direction: column;\n    overflow: hidden;\n    z-index: 1050;\n    display: none;\n    align-items: initial;\n    flex-direction: initial;\n    padding: 10px; }\n    .modal--fill .modal__content {\n      margin: 0 !important; }\n    .modal--fill .modal__body {\n      flex: 1 1 auto !important; }\n  .modal--fill .modal__dialog {\n    max-width: 100%; }\n  .modal--fill .modal__body {\n    max-width: 100% !important; }\n  .modal--fullscreen {\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    top: 0px;\n    bottom: 0px;\n    align-items: flex-start;\n    flex-direction: column;\n    overflow: hidden;\n    z-index: 1050;\n    display: none; }\n    .modal--fullscreen .modal__dialog {\n      width: 100%;\n      height: 100%; }\n    .modal--fullscreen .modal__content {\n      flex: 0 0 100%;\n      margin: 0;\n      -webkit-border-radius: 0;\n      -moz-border-radius: 0;\n      -ms-border-radius: 0;\n      border-radius: 0; }\n    .modal--fullscreen .modal__body {\n      max-height: none;\n      flex: 1 1 auto !important;\n      display: flex;\n      flex-direction: column; }\n  .modal--fullscreen .modal__dialog {\n    max-width: 100%; }\n  .modal--fullscreen .modal__body {\n    max-width: 100% !important; }\n  .modal.modal--white .modal__body {\n    background: #fff !important; }\n  .modal.modal--double {\n    z-index: 1060; }\n    .modal.modal--double + .modal__backdrop {\n      z-index: 1055; }\n  .modal.modal--tabs .modal__body {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    background: transparent; }\n    .modal.modal--tabs .modal__body > form {\n      display: flex;\n      flex-direction: column; }\n  .modal.modal--tabs .modal__body-header {\n    height: 48px;\n    width: 100%;\n    background: #fff;\n    border-bottom: 1px solid #e4e4e4;\n    padding: 0; }\n    .modal.modal--tabs .modal__body-header--add-padding {\n      padding: 1rem 2rem;\n      height: auto;\n      min-height: 48px; }\n    .modal.modal--tabs .modal__body-header--flex {\n      display: flex;\n      align-items: center; }\n  .modal.modal--tabs .modal__body-content {\n    flex: 1 1 auto;\n    width: 100%;\n    overflow-y: auto;\n    padding: 2rem;\n    background: #f8f8f8;\n    min-height: 60px; }\n  .modal.modal--tabs .modal__body-footer {\n    flex: 0 0 auto;\n    padding: 1.2rem 2rem;\n    border-top: 1px solid #e4e4e4;\n    text-align: right;\n    min-height: 48px; }\n  .modal p {\n    margin: 0 0 1em 0; }\n  .modal.modal--dark-ui .modal__content {\n    background-color: #333;\n    color: #fff; }\n    .modal.modal--dark-ui .modal__content .modal__body-header {\n      background-color: #333;\n      color: #fff; }\n    .modal.modal--dark-ui .modal__content .modal__body-content, .modal.modal--dark-ui .modal__content .modal__body {\n      background-color: #444;\n      color: #fff; }\n    .modal.modal--dark-ui .modal__content .modal__header {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.3); }\n    .modal.modal--dark-ui .modal__content .modal__footer {\n      border-top: 1px solid rgba(0, 0, 0, 0.12); }\n    .modal.modal--dark-ui .modal__content .subnav {\n      background-color: #292929;\n      color: #fff;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35), 0 1px 0 0 rgba(0, 0, 0, 0.3); }\n\n.modal__content .subnav {\n  flex-shrink: 0; }\n\n.modal__close {\n  margin: 2px -6px 0;\n  border: 0;\n  background: 0;\n  padding: 0px 4px;\n  opacity: 0.3;\n  filter: \"alpha(opacity=30)\"; }\n  .modal__close:hover {\n    opacity: 0.7;\n    filter: \"alpha(opacity=70)\";\n    cursor: pointer; }\n\n.modal__heading {\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 27px; }\n\n.modal__backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1045;\n  background-color: #000; }\n  .modal__backdrop.fade {\n    opacity: 0; }\n\n.modal__backdrop,\n.modal__backdrop.fade.in {\n  opacity: 0.3;\n  filter: \"alpha(opacity=30)\"; }\n\n.nav-tabs {\n  *zoom: 1;\n  height: 48px;\n  display: flex;\n  flex-shrink: 0;\n  padding: 0 1rem;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1); }\n  .nav-tabs:before, .nav-tabs:after {\n    display: table;\n    content: \"\"; }\n  .nav-tabs:after {\n    clear: both; }\n  .nav-tabs__tab {\n    margin-bottom: -1px; }\n    .nav-tabs__tab--active .nav-tabs__link, .nav-tabs__tab--active:hover .nav-tabs__link {\n      background: none;\n      cursor: default;\n      border-bottom-color: #5ea9c8;\n      color: #333; }\n  .nav-tabs__pane--padding {\n    padding: 2rem; }\n  .nav-tabs__pane .subnav {\n    margin-top: 1px; }\n  .nav-tabs__link {\n    display: block;\n    margin: 0 1rem;\n    padding: 0.8rem 0;\n    height: 48px;\n    line-height: 30px;\n    font-size: 1.4rem;\n    color: #747474;\n    background: none;\n    border: 0;\n    border-bottom: 3px solid transparent;\n    text-decoration: none; }\n    .nav-tabs__link:hover {\n      border-bottom-color: #d8d8d8;\n      background: none;\n      text-decoration: none; }\n  .nav-tabs--ui-dark {\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n    background-color: rgba(94, 169, 200, 0.03); }\n    .nav-tabs--ui-dark .nav-tabs__tab--active .nav-tabs__link, .nav-tabs--ui-dark .nav-tabs__tab--active:hover .nav-tabs__link {\n      background: none;\n      cursor: default;\n      border-bottom-color: #5ea9c8;\n      color: #fff; }\n    .nav-tabs--ui-dark .nav-tabs__link {\n      display: block;\n      margin: 0 1rem;\n      padding: 0.8rem 0;\n      height: 48px;\n      line-height: 30px;\n      font-size: 1.4rem;\n      color: rgba(255, 255, 255, 0.6);\n      background: none;\n      border: 0;\n      border-bottom: 3px solid transparent;\n      text-decoration: none; }\n      .nav-tabs--ui-dark .nav-tabs__link:hover {\n        border-bottom-color: #5ea9c8;\n        background: none;\n        text-decoration: none; }\n  .nav-tabs--small {\n    padding: 0 .4rem; }\n    .nav-tabs--small .nav-tabs__link {\n      font-size: 1.3rem;\n      margin: 0 .8rem; }\n  .nav-tabs--big .nav-tabs__link {\n    font-size: 2rem; }\n  .nav-tabs__content {\n    padding: 2rem;\n    overflow: auto; }\n    .nav-tabs__content--ui-dark {\n      color: #fff; }\n    .nav-tabs__content--small {\n      padding: 1.2rem; }\n\n.nav-tabs-vertical {\n  width: 2rem;\n  border-right: 1px solid #ccc;\n  transition: all .2s ease-out .3s;\n  opacity: 1; }\n  .nav-tabs-vertical__list {\n    width: 2rem;\n    list-style: none;\n    margin: 0;\n    padding: 0; }\n  .nav-tabs-vertical__tab {\n    display: inline-block;\n    width: 2rem;\n    line-height: 2rem; }\n    .nav-tabs-vertical__tab--active .nav-tabs-vertical__link {\n      color: #222; }\n  .nav-tabs-vertical__link {\n    display: inline-block;\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: #747474;\n    text-transform: uppercase;\n    white-space: nowrap;\n    margin: 10px 0;\n    padding: 0;\n    -webkit-transform: translateX(19px) rotate(90deg);\n    transform: translateX(20px) rotate(90deg);\n    transform-origin: 0 0; }\n    .nav-tabs-vertical__link:hover {\n      color: #222; }\n    .nav-tabs-vertical__link:after {\n      content: \"\";\n      float: left;\n      margin-top: 100%; }\n  .nav-tabs-vertical--closed {\n    width: 0;\n    border: none;\n    opacity: 0;\n    transition: all .01s ease-out; }\n\ntable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0px;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  table th, table td {\n    padding: 1.2rem 0.8rem;\n    text-align: left;\n    vertical-align: top;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  table tr:last-child td {\n    border-bottom: none; }\n  table th {\n    font-weight: 600;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.15); }\n  table thead th {\n    vertical-align: bottom; }\n\n.sd-table--shadowed {\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  border: none; }\n\n/* Thanks to Jase Smith - codepen.io/jasesmith */\n[sd-tooltip],\n[data-sd-tooltip] {\n  position: relative;\n  /* Applies to all sd-tooltips */\n  /* Make the sd-tooltips respond to hover */ }\n  [sd-tooltip]::before, [sd-tooltip]::after,\n  [data-sd-tooltip]::before,\n  [data-sd-tooltip]::after {\n    text-transform: none;\n    font-size: 1.2rem;\n    line-height: 1;\n    user-select: none;\n    pointer-events: none;\n    position: absolute;\n    display: none;\n    opacity: 0; }\n  [sd-tooltip]::before,\n  [data-sd-tooltip]::before {\n    content: '';\n    border: 5px solid transparent;\n    z-index: 1001; }\n  [sd-tooltip]::after,\n  [data-sd-tooltip]::after {\n    text-align: center;\n    /* Let the content set the size of the sd-tooltips */\n    min-width: 3em;\n    max-width: 21em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 0.8rem 1.2rem 0.9rem;\n    border-radius: 2px;\n    box-shadow: 0 8px 18px -5px rgba(0, 0, 0, 0.45);\n    background: #333;\n    color: #fff;\n    font-weight: 400;\n    z-index: 1000; }\n  [sd-tooltip]:hover::before, [sd-tooltip]:hover::after,\n  [data-sd-tooltip]:hover::before,\n  [data-sd-tooltip]:hover::after {\n    display: block; }\n\n[sd-tooltip] {\n  /* FLOW: UP */\n  /* FLOW: DOWN */\n  /* FLOW: LEFT */\n  /* FLOW: RIGHT */\n  /* FX All The Things */ }\n  [sd-tooltip]:not([flow])::before, [sd-tooltip][flow^=\"up\"]::before {\n    bottom: 100%;\n    border-bottom-width: 0;\n    border-top-color: #333; }\n  [sd-tooltip]:not([flow])::after, [sd-tooltip][flow^=\"up\"]::after {\n    bottom: calc(100% + 5px); }\n  [sd-tooltip]:not([flow])::before, [sd-tooltip]:not([flow])::after, [sd-tooltip][flow^=\"up\"]::before, [sd-tooltip][flow^=\"up\"]::after {\n    left: 50%;\n    transform: translate(-50%, -0.5em); }\n  [sd-tooltip][flow^=\"down\"]::before {\n    top: 100%;\n    border-top-width: 0;\n    border-bottom-color: #333; }\n  [sd-tooltip][flow^=\"down\"]::after {\n    top: calc(100% + 5px); }\n  [sd-tooltip][flow^=\"down\"]::before, [sd-tooltip][flow^=\"down\"]::after {\n    left: 50%;\n    transform: translate(-50%, 0.5em); }\n  [sd-tooltip][flow^=\"left\"]::before {\n    top: 50%;\n    border-right-width: 0;\n    border-left-color: #333;\n    left: calc(0em - 5px);\n    transform: translate(-0.5em, -50%); }\n  [sd-tooltip][flow^=\"left\"]::after {\n    top: 50%;\n    right: calc(100% + 5px);\n    transform: translate(-0.5em, -50%); }\n  [sd-tooltip][flow^=\"right\"]::before {\n    top: 50%;\n    border-left-width: 0;\n    border-right-color: #333;\n    right: calc(0em - 5px);\n    transform: translate(0.5em, -50%); }\n  [sd-tooltip][flow^=\"right\"]::after {\n    top: 50%;\n    left: calc(100% + 5px);\n    transform: translate(0.5em, -50%); }\n  [sd-tooltip]:not([flow]):hover::before, [sd-tooltip]:not([flow]):hover::after, [sd-tooltip][flow^=\"up\"]:hover::before, [sd-tooltip][flow^=\"up\"]:hover::after, [sd-tooltip][flow^=\"down\"]:hover::before, [sd-tooltip][flow^=\"down\"]:hover::after {\n    animation: tooltips-vert 200ms ease-out forwards; }\n  [sd-tooltip][flow^=\"left\"]:hover::before, [sd-tooltip][flow^=\"left\"]:hover::after, [sd-tooltip][flow^=\"right\"]:hover::before, [sd-tooltip][flow^=\"right\"]:hover::after {\n    animation: tooltips-horz 200ms ease-out forwards; }\n\n[data-sd-tooltip] {\n  /* FLOW: UP */\n  /* FLOW: DOWN */\n  /* FLOW: LEFT */\n  /* FLOW: RIGHT */\n  /* FX All The Things */ }\n  [data-sd-tooltip]:not([data-flow])::before, [data-sd-tooltip][data-flow^=\"up\"]::before {\n    bottom: 100%;\n    border-bottom-width: 0;\n    border-top-color: #333; }\n  [data-sd-tooltip]:not([data-flow])::after, [data-sd-tooltip][data-flow^=\"up\"]::after {\n    bottom: calc(100% + 5px); }\n  [data-sd-tooltip]:not([data-flow])::before, [data-sd-tooltip]:not([data-flow])::after, [data-sd-tooltip][data-flow^=\"up\"]::before, [data-sd-tooltip][data-flow^=\"up\"]::after {\n    left: 50%;\n    transform: translate(-50%, -0.5em); }\n  [data-sd-tooltip][data-flow^=\"down\"]::before {\n    top: 100%;\n    border-top-width: 0;\n    border-bottom-color: #333; }\n  [data-sd-tooltip][data-flow^=\"down\"]::after {\n    top: calc(100% + 5px); }\n  [data-sd-tooltip][data-flow^=\"down\"]::before, [data-sd-tooltip][data-flow^=\"down\"]::after {\n    left: 50%;\n    transform: translate(-50%, 0.5em); }\n  [data-sd-tooltip][data-flow^=\"left\"]::before {\n    top: 50%;\n    border-right-width: 0;\n    border-left-color: #333;\n    left: calc(0em - 5px);\n    transform: translate(-0.5em, -50%); }\n  [data-sd-tooltip][data-flow^=\"left\"]::after {\n    top: 50%;\n    right: calc(100% + 5px);\n    transform: translate(-0.5em, -50%); }\n  [data-sd-tooltip][data-flow^=\"right\"]::before {\n    top: 50%;\n    border-left-width: 0;\n    border-right-color: #333;\n    right: calc(0em - 5px);\n    transform: translate(0.5em, -50%); }\n  [data-sd-tooltip][data-flow^=\"right\"]::after {\n    top: 50%;\n    left: calc(100% + 5px);\n    transform: translate(0.5em, -50%); }\n  [data-sd-tooltip]:not([data-flow]):hover::before, [data-sd-tooltip]:not([data-flow]):hover::after, [data-sd-tooltip][data-flow^=\"up\"]:hover::before, [data-sd-tooltip][data-flow^=\"up\"]:hover::after, [data-sd-tooltip][data-flow^=\"down\"]:hover::before, [data-sd-tooltip][data-flow^=\"down\"]:hover::after {\n    animation: tooltips-vert 200ms ease-out forwards; }\n  [data-sd-tooltip][data-flow^=\"left\"]:hover::before, [data-sd-tooltip][data-flow^=\"left\"]:hover::after, [data-sd-tooltip][data-flow^=\"right\"]:hover::before, [data-sd-tooltip][data-flow^=\"right\"]:hover::after {\n    animation: tooltips-horz 200ms ease-out forwards; }\n\n/* magic! */\n[sd-tooltip]::after {\n  content: attr(sd-tooltip); }\n\n[data-sd-tooltip]::after {\n  content: attr(data-sd-tooltip); }\n\n/* don't show empty sd-tooltips */\n[sd-tooltip='']::before,\n[sd-tooltip='']::after,\n[data-sd-tooltip='']::before,\n[data-sd-tooltip='']::after {\n  display: none !important; }\n\n/* KEYFRAMES */\n@keyframes tooltips-vert {\n  to {\n    opacity: .95;\n    transform: translate(-50%, 0); } }\n\n@keyframes tooltips-horz {\n  to {\n    opacity: .95;\n    transform: translate(0, -50%); } }\n\n[class^=\"--dark-ui\"] [sd-tooltip]::after,\n[class^=\"--dark-ui\"] [data-sd-tooltip]::after,\n[class*=\"--dark-ui\"] [sd-tooltip]::after,\n[class*=\"--dark-ui\"] [data-sd-tooltip]::after {\n  box-shadow: 0 8px 18px -5px rgba(0, 0, 0, 0.75);\n  background: #222; }\n\n[class^=\"--dark-ui\"] [sd-tooltip],\n[class*=\"--dark-ui\"] [sd-tooltip] {\n  /* FLOW: UP */\n  /* FLOW: DOWN */\n  /* FLOW: LEFT */\n  /* FLOW: RIGHT */ }\n  [class^=\"--dark-ui\"] [sd-tooltip]:not([flow])::before, [class^=\"--dark-ui\"] [sd-tooltip][flow^=\"up\"]::before,\n  [class*=\"--dark-ui\"] [sd-tooltip]:not([flow])::before,\n  [class*=\"--dark-ui\"] [sd-tooltip][flow^=\"up\"]::before {\n    border-top-color: #222; }\n  [class^=\"--dark-ui\"] [sd-tooltip][flow^=\"down\"]::before,\n  [class*=\"--dark-ui\"] [sd-tooltip][flow^=\"down\"]::before {\n    border-bottom-color: #222; }\n  [class^=\"--dark-ui\"] [sd-tooltip][flow^=\"left\"]::before,\n  [class*=\"--dark-ui\"] [sd-tooltip][flow^=\"left\"]::before {\n    border-left-color: #222; }\n  [class^=\"--dark-ui\"] [sd-tooltip][flow^=\"right\"]::before,\n  [class*=\"--dark-ui\"] [sd-tooltip][flow^=\"right\"]::before {\n    border-right-color: #222; }\n\n[class^=\"--dark-ui\"] [data-sd-tooltip],\n[class*=\"--dark-ui\"] [data-sd-tooltip] {\n  /* FLOW: UP */\n  /* FLOW: DOWN */\n  /* FLOW: LEFT */\n  /* FLOW: RIGHT */ }\n  [class^=\"--dark-ui\"] [data-sd-tooltip]:not([data-flow])::before, [class^=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"up\"]::before,\n  [class*=\"--dark-ui\"] [data-sd-tooltip]:not([data-flow])::before,\n  [class*=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"up\"]::before {\n    border-top-color: #222; }\n  [class^=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"down\"]::before,\n  [class*=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"down\"]::before {\n    border-bottom-color: #222; }\n  [class^=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"left\"]::before,\n  [class*=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"left\"]::before {\n    border-left-color: #222; }\n  [class^=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"right\"]::before,\n  [class*=\"--dark-ui\"] [data-sd-tooltip][data-flow^=\"right\"]::before {\n    border-right-color: #222; }\n\n[disabled]:hover[sd-tooltip]::before, [disabled]:hover[data-sd-tooltip]::before, [disabled]:hover[sd-tooltip]::after, [disabled]:hover[data-sd-tooltip]::after {\n  display: none !important; }\n\n.sd-carousel {\n  position: fixed;\n  left: 40px;\n  right: 40px;\n  top: 40px;\n  bottom: 40px;\n  align-items: center;\n  flex-direction: row;\n  z-index: 1050;\n  display: flex; }\n\n.sd-carousel__dialog {\n  display: flex;\n  max-height: 100%;\n  flex: 0 1 auto;\n  margin: 0 auto;\n  max-width: 680px;\n  width: 100%;\n  position: relative; }\n\n.sd-carousel__content {\n  background: #fff;\n  background-clip: padding-box;\n  outline: 0;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2), 0 10px 28px rgba(0, 0, 0, 0.35);\n  border-radius: 1rem 1rem 0.8rem 0.8rem;\n  min-height: 40rem;\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 100%;\n  max-height: 80rem; }\n\n.sd-carousel__page {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1; }\n\n.sd-carousel__page-header {\n  width: 100%;\n  height: 200px;\n  border-radius: 0.8rem 0.8rem 0 0;\n  background-color: #303E55;\n  flex-grow: 0;\n  position: relative;\n  overflow: hidden; }\n  .sd-carousel__page-header--color-2 {\n    background-color: #856CA1; }\n  .sd-carousel__page-header--color-3 {\n    background-color: #6DBEC4; }\n\n.sd-carousel__page-header-illustration {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  opacity: 0.65; }\n\n.sd-carousel__page-heading {\n  font-family: 'Merriweather', Georgia, 'Times New Roman', Times, serif;\n  font-weight: 700;\n  letter-spacing: .03em;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  z-index: 2;\n  color: #fff;\n  font-size: 3.2rem;\n  line-height: 1;\n  top: calc(50% - 1.6rem); }\n\n.sd-carousel__page-text {\n  padding: 3rem;\n  flex-grow: 1;\n  font-size: 1.6rem;\n  line-height: 140%;\n  font-weight: 300; }\n  .sd-carousel__page-text p {\n    margin-bottom: 1em; }\n    .sd-carousel__page-text p:last-child, .sd-carousel__page-text p:only-child {\n      margin-bottom: 0; }\n  .sd-carousel__page-text h3 {\n    font-family: 'Merriweather', Georgia, 'Times New Roman', Times, serif;\n    font-size: 2rem;\n    margin-bottom: 0.8em;\n    font-weight: 700; }\n\n.sd-carousel__page-footer {\n  text-align: center;\n  padding: 0 3rem 3rem;\n  flex-grow: 0; }\n\n.sd-carousel__nav-button {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 5.6rem;\n  line-height: 5.6rem;\n  position: absolute;\n  top: calc(50% - 2.8rem);\n  width: 5.6rem;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2), 0 10px 28px rgba(0, 0, 0, 0.35);\n  color: #1eb06c;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out;\n  background-color: #fff; }\n  .sd-carousel__nav-button:hover {\n    background-color: #e6e6e6; }\n  .sd-carousel__nav-button:active {\n    background-color: #cccccc; }\n  .sd-carousel__nav-button::after {\n    content: \" \";\n    font-family: 'sd_icons';\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: absolute;\n    top: 0;\n    text-align: center;\n    z-index: 2;\n    color: #1eb06c;\n    width: 5.6rem;\n    font-size: 2.4rem; }\n  .sd-carousel__nav-button--next {\n    right: -88px;\n    color: inherit; }\n    .sd-carousel__nav-button--next::after {\n      content: \"\\E643\"; }\n  .sd-carousel__nav-button--prev {\n    left: -88px;\n    color: inherit; }\n    .sd-carousel__nav-button--prev::after {\n      content: \"\\E642\"; }\n  .sd-carousel__nav-button--end {\n    right: -88px;\n    border-radius: 50%;\n    cursor: pointer;\n    height: 5.6rem;\n    line-height: 5.6rem;\n    position: absolute;\n    top: calc(50% - 2.8rem);\n    width: 5.6rem;\n    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2), 0 10px 28px rgba(0, 0, 0, 0.35);\n    color: #1eb06c;\n    transition: background-color 0.2s ease-out, color 0.1s ease-out;\n    background-color: #1eb06c; }\n    .sd-carousel__nav-button--end:hover {\n      background-color: #1b9e61; }\n    .sd-carousel__nav-button--end:active {\n      background-color: #188d56; }\n    .sd-carousel__nav-button--end::after {\n      content: \" \";\n      font-family: 'sd_icons';\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      position: absolute;\n      top: 0;\n      text-align: center;\n      z-index: 2;\n      color: #1eb06c;\n      width: 5.6rem;\n      font-size: 2.4rem; }\n    .sd-carousel__nav-button--end::after {\n      content: \"\\E61D\";\n      color: #fff; }\n\n.sd-carousel__page-indication-bar {\n  bottom: -3.6rem;\n  height: 2.6rem;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.sd-carousel__page-indicator {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 1.4rem;\n  width: 1.4rem;\n  margin: 0.6rem;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .sd-carousel__page-indicator--selected {\n    background-color: rgba(255, 255, 255, 0.8);\n    border-color: rgba(0, 0, 0, 0.6); }\n\n.sd-carousel__backdrop {\n  z-index: 1045;\n  background: rgba(0, 0, 0, 0.45);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0; }\n\n.panel-info {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 5rem 0 0;\n  text-align: center;\n  color: #888; }\n  .panel-info__icon {\n    display: block;\n    box-sizing: border-box;\n    padding-top: 1.6rem;\n    height: 9rem;\n    width: 9rem;\n    background-color: #fff;\n    border-radius: 50%;\n    margin: 0 auto;\n    -webkit-box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08);\n    -moz-box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08);\n    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08); }\n    .panel-info__icon i {\n      display: block;\n      width: 56px;\n      height: 48px;\n      opacity: .2;\n      margin: 14px auto 0;\n      font-size: 5.2rem; }\n  .panel-info__heading {\n    font-size: 1.8rem;\n    font-weight: 400;\n    margin: 12px 0 0;\n    line-height: 27px; }\n  .panel-info__description {\n    margin: 4px 0 0;\n    font-weight: 300; }\n\n.simple-list {\n  padding: 2rem 0; }\n  .simple-list .simple-list__item {\n    padding: 0.5rem 0; }\n    .simple-list .simple-list__item--with-icon {\n      display: flex;\n      flex-direction: row; }\n      .simple-list .simple-list__item--with-icon [class^=\"icon-\"], .simple-list .simple-list__item--with-icon [class*=\" icon-\"] {\n        flex-grow: 0;\n        flex-shrink: 0;\n        margin-right: 1rem;\n        opacity: .75; }\n    .simple-list .simple-list__item--flex {\n      display: flex;\n      flex-direction: row;\n      align-items: center; }\n    .simple-list .simple-list__item--stacked {\n      display: flex;\n      flex-direction: column;\n      align-items: stretch; }\n      .simple-list .simple-list__item--stacked .simple-list__item-data {\n        text-align: left; }\n      .simple-list .simple-list__item--stacked .simple-list__item-label {\n        padding: 0 0 0.6rem 0; }\n    .simple-list .simple-list__item .label-icon {\n      margin-right: 4px; }\n  .simple-list .simple-list__item-label {\n    flex-grow: 0;\n    font-size: 1.1rem;\n    line-height: 100%;\n    text-transform: uppercase;\n    padding-right: 1rem;\n    margin: 0;\n    color: inherit;\n    opacity: 0.65;\n    font-weight: 500; }\n  .simple-list .simple-list__item-data {\n    flex-grow: 1;\n    text-align: right; }\n  .simple-list--dotted .simple-list__item {\n    padding: 0.8rem 0;\n    border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n    .simple-list--dotted .simple-list__item:first-child {\n      border-top: 1px dotted rgba(123, 123, 123, 0.5); }\n  .simple-list--dotted.simple-list--no-border-b .simple-list__item:last-child {\n    border-bottom: none; }\n  .simple-list--dotted.simple-list--no-border-t .simple-list__item:first-child {\n    border-top: none; }\n  .simple-list--comfortable .simple-list__item {\n    padding: 1.2rem 0; }\n  .simple-list [class^=\"icon-\"], .simple-list [class*=\" icon-\"] {\n    vertical-align: middle; }\n  .simple-list--no-padding {\n    padding: 0 0 2rem 0; }\n  .simple-list--no-padding-b {\n    padding-bottom: 0; }\n\n.toggle-box {\n  position: relative;\n  margin-bottom: 30px; }\n  .toggle-box.hidden .toggle-box__chevron i {\n    transform: rotate(0); }\n  .toggle-box.hidden .toggle-box__chevron--circle {\n    padding: 2px;\n    background-color: #747474;\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    border-radius: 50%; }\n    .toggle-box.hidden .toggle-box__chevron--circle i {\n      color: #fff; }\n  .toggle-box.hidden .toggle-box__content-wraper {\n    max-height: 0;\n    transition: all ease-out .5s; }\n  .toggle-box.hidden .toggle-box__header {\n    margin-bottom: 0; }\n  .toggle-box.toggle-box--dark .toggle-box__chevron i {\n    color: #fff; }\n  .toggle-box.toggle-box--dark .toggle-box__label {\n    color: rgba(255, 255, 255, 0.65); }\n  .toggle-box.toggle-box--dark .toggle-box__line {\n    background: rgba(123, 123, 123, 0.5); }\n  .toggle-box.toggle-box--circle .toggle-box__chevron {\n    background-color: rgba(123, 123, 123, 0.5);\n    height: 2rem;\n    width: 2rem;\n    text-align: center;\n    border-radius: 50%; }\n    .toggle-box.toggle-box--circle .toggle-box__chevron i {\n      color: #fff; }\n  .toggle-box.toggle-box--marg-b10 {\n    margin-bottom: 1rem; }\n\n.toggle-box__header {\n  display: flex;\n  cursor: pointer;\n  margin-bottom: 1.8rem;\n  align-items: center; }\n  .toggle-box__header .toggle-box__chevron {\n    padding: 2px; }\n    .toggle-box__header .toggle-box__chevron i {\n      transition: all .3s;\n      transform: rotate(90deg); }\n  .toggle-box__header .toggle-box__label {\n    font-size: 1.2rem;\n    padding: 0 1rem 0 0.8rem;\n    color: #666;\n    text-transform: uppercase; }\n  .toggle-box__header .toggle-box__line {\n    flex: 1;\n    height: 1px;\n    margin: auto 0.4rem auto 0;\n    background: rgba(123, 123, 123, 0.5); }\n\n.toggle-box__content-wraper {\n  transition: all ease-out .5s; }\n\n.toggle-box__content {\n  animation: fadeIn 0.3s ease-in 0s 1; }\n\n.toggle-box__button {\n  color: #999;\n  cursor: pointer; }\n  .toggle-box__button i {\n    color: #999;\n    margin-right: 0.5rem;\n    vertical-align: text-bottom; }\n  .toggle-box__button:hover {\n    text-decoration: none;\n    color: #fff; }\n    .toggle-box__button:hover i {\n      color: #fff; }\n\n[class^=\"--dark-ui\"] .toggle-box__header .toggle-box__label,\n[class*=\"--dark-ui\"] .toggle-box__header .toggle-box__label {\n  color: rgba(255, 255, 255, 0.5); }\n\n[class^=\"--dark-ui\"] .toggle-box--circle .toggle-box__chevron,\n[class*=\"--dark-ui\"] .toggle-box--circle .toggle-box__chevron {\n  background-color: rgba(123, 123, 123, 0.5); }\n\n.basic-drag-block {\n  border: 2px dashed #cacaca;\n  background-color: #f8f8f8;\n  position: relative;\n  padding: 1.2rem;\n  color: #747474;\n  text-align: center;\n  border-radius: 2px; }\n  .basic-drag-block i {\n    opacity: 0.4;\n    vertical-align: bottom;\n    margin: -4px 4px -2px 0; }\n  .basic-drag-block a {\n    display: inline-block; }\n  .basic-drag-block .basic-drag-block__text {\n    display: inline-block; }\n\n.tag-label {\n  display: inline-flex;\n  align-items: center;\n  min-width: 1.8em;\n  padding: 0em 1em 0em 1em;\n  border-radius: 1em;\n  font-size: 1.3rem;\n  line-height: 1em;\n  position: relative;\n  text-align: center;\n  font-weight: 400;\n  transition: background-color .2s ease-out, opacity .1s ease-out;\n  margin: 0.2rem 0;\n  height: 2em;\n  background: rgba(123, 123, 123, 0.25);\n  color: inherit; }\n  .tag-label.tag-label--default {\n    background: rgba(123, 123, 123, 0.25); }\n  .tag-label.tag-label--darker {\n    background: rgba(123, 123, 123, 0.45); }\n  .tag-label.tag-label--highlight1 {\n    background: rgba(94, 169, 200, 0.3); }\n  .tag-label.tag-label--highlight2 {\n    background: rgba(94, 169, 200, 0.65); }\n  .tag-label--square {\n    border-radius: 2px; }\n  .tag-label .tag-label__remove {\n    height: 1.5385em;\n    width: 1.5385em;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: inherit;\n    line-height: 1;\n    text-decoration: none;\n    text-align: center;\n    vertical-align: middle;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.35);\n    color: inherit;\n    cursor: pointer;\n    transition: background-color .2s ease-out, color .1s ease-out, opacity .1s ease-out;\n    opacity: 0.2;\n    margin-right: -0.7695em;\n    margin-left: 0.4rem; }\n    .tag-label .tag-label__remove i {\n      font-size: 1.6rem;\n      flex-grow: 0;\n      flex-shrink: 0;\n      margin-left: 1px; }\n    .tag-label .tag-label__remove:hover {\n      opacity: 0.75;\n      text-decoration: none;\n      background-color: rgba(255, 255, 255, 0.65); }\n    .tag-label .tag-label__remove:active {\n      opacity: 1;\n      background-color: rgba(255, 255, 255, 0.85); }\n      .tag-label .tag-label__remove:active [class^=\"icon-\"], .tag-label .tag-label__remove:active [class*=\" icon-\"] {\n        color: #5ea9c8;\n        opacity: 1; }\n\n.tag-label + .tag-label {\n  margin-left: 0.3rem; }\n\nsd-tag-input {\n  display: block;\n  padding-bottom: 3rem; }\n  sd-tag-input[data-label] {\n    position: relative;\n    padding-top: 1rem; }\n\n.tags-input__label {\n  position: absolute;\n  display: inline-block;\n  font-size: 1.1rem;\n  margin: 0;\n  top: 0;\n  line-height: 100%;\n  color: #747474;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.08em; }\n\ntags-input {\n  display: block; }\n  tags-input .tags-input__host {\n    position: relative;\n    margin-top: 0.5rem;\n    margin-bottom: 0;\n    height: 100%; }\n    tags-input .tags-input__host:active {\n      outline: none; }\n  tags-input .tags-input__tags {\n    padding: 0.1rem;\n    overflow: hidden;\n    word-wrap: break-word;\n    cursor: text;\n    background-color: transparent;\n    border: none;\n    transition: border linear 0.2s, box-shadow linear 0.2s;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    height: 100%; }\n    tags-input .tags-input__tags:hover {\n      border-color: rgba(0, 0, 0, 0.3); }\n    tags-input .tags-input__tags.focused {\n      outline: none;\n      border-bottom: 1px solid #5ea9c8;\n      box-shadow: 0 1px 0 #5ea9c8; }\n      tags-input .tags-input__tags.focused .tags-input__input {\n        width: auto; }\n    tags-input .tags-input__tags .tags-input__tag-list {\n      margin: 0;\n      padding: 0;\n      list-style-type: none; }\n    tags-input .tags-input__tags .tags-input__tag-item {\n      margin: 2px;\n      display: inline-flex;\n      align-items: center;\n      min-width: 1.8em;\n      padding: 0em 1em 0em 1em;\n      border-radius: 1em;\n      font-size: 1.3rem;\n      line-height: 1em;\n      position: relative;\n      text-align: center;\n      font-weight: 400;\n      transition: background-color .2s ease-out, opacity .1s ease-out;\n      margin: 0.2rem 0;\n      height: 2em;\n      margin: 2px 4px 2px 0;\n      float: left;\n      transition: background-color .2s ease-out, color .1s ease-out, opacity .1s ease-out;\n      background: rgba(123, 123, 123, 0.25);\n      color: currentColor; }\n      tags-input .tags-input__tags .tags-input__tag-item.selected {\n        background-color: rgba(94, 169, 200, 0.65); }\n      tags-input .tags-input__tags .tags-input__tag-item .tags-input__remove-button {\n        height: 1.5385em;\n        width: 1.5385em;\n        padding: 0;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        font-size: inherit;\n        line-height: 1;\n        text-decoration: none;\n        text-align: center;\n        vertical-align: middle;\n        border-radius: 50%;\n        background-color: rgba(255, 255, 255, 0.35);\n        color: inherit;\n        cursor: pointer;\n        transition: background-color .2s ease-out, color .1s ease-out, opacity .1s ease-out;\n        opacity: 0.2;\n        margin-right: -0.7695em;\n        margin-left: 0.4rem; }\n        tags-input .tags-input__tags .tags-input__tag-item .tags-input__remove-button:hover {\n          opacity: 0.75;\n          text-decoration: none;\n          background-color: rgba(255, 255, 255, 0.65); }\n        tags-input .tags-input__tags .tags-input__tag-item .tags-input__remove-button:active {\n          opacity: 1;\n          background-color: rgba(255, 255, 255, 0.85); }\n          tags-input .tags-input__tags .tags-input__tag-item .tags-input__remove-button:active [class^=\"icon-\"], tags-input .tags-input__tags .tags-input__tag-item .tags-input__remove-button:active [class*=\" icon-\"] {\n            color: #5ea9c8;\n            opacity: 1; }\n      tags-input .tags-input__tags .tags-input__tag-item ti-tag-item {\n        display: flex;\n        flex-direction: row;\n        align-items: center; }\n        tags-input .tags-input__tags .tags-input__tag-item ti-tag-item .tags-input__helper-box {\n          display: flex;\n          flex-direction: row;\n          align-items: center; }\n          tags-input .tags-input__tags .tags-input__tag-item ti-tag-item .tags-input__helper-box span {\n            flex-grow: 1; }\n    tags-input .tags-input__tags .tags-input__input {\n      border: 0;\n      outline: none;\n      margin: 0.2rem;\n      padding: 0;\n      float: left;\n      height: 26px;\n      color: currentColor;\n      background-color: transparent;\n      width: 20px; }\n      tags-input .tags-input__tags .tags-input__input.invalid-tag {\n        color: #E51C23; }\n      tags-input .tags-input__tags .tags-input__input::-ms-clear {\n        display: none; }\n      tags-input .tags-input__tags .tags-input__input:focus {\n        box-shadow: unset !important; }\n      tags-input .tags-input__tags .tags-input__input::placeholder {\n        opacity: 0.8;\n        font-weight: 300;\n        font-style: italic; }\n    tags-input .tags-input__tags--boxed {\n      background-color: rgba(0, 0, 0, 0.05);\n      padding-left: 0.4rem;\n      border-radius: 2px; }\n      tags-input .tags-input__tags--boxed:hover {\n        background-color: rgba(0, 0, 0, 0.1); }\n  tags-input.ng-invalid .tags-input__tags {\n    border-bottom: 1px solid #E51C23 !important;\n    box-shadow: 0 1px 0 #E51C23 !important; }\n  tags-input[disabled] .tags-input__host:focus {\n    outline: none; }\n  tags-input[disabled] .tags-input__tags {\n    background-color: #eee;\n    cursor: default; }\n    tags-input[disabled] .tags-input__tags .tags-input__tag-item {\n      opacity: 0.65; }\n      tags-input[disabled] .tags-input__tags .tags-input__tag-item .tags-input__remove-button {\n        cursor: default; }\n        tags-input[disabled] .tags-input__tags .tags-input__tag-item .tags-input__remove-button:active {\n          color: #585858; }\n    tags-input[disabled] .tags-input__tags .tags-input__input {\n      background-color: #eee;\n      cursor: default; }\n  tags-input .tags-input__add-button {\n    float: left;\n    height: 2.6rem;\n    width: 2.6rem;\n    background-color: #5ea9c8;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 0.2rem 0.4rem 0.2rem 0;\n    transition: all 0.3s;\n    border-radius: 2px;\n    opacity: 0.5;\n    padding: 0;\n    justify-content: center; }\n    tags-input .tags-input__add-button i {\n      color: inherit; }\n    tags-input .tags-input__add-button:hover {\n      opacity: 1; }\n    tags-input .tags-input__add-button[disabled], tags-input .tags-input__add-button [disabled]:hover, tags-input .tags-input__add-button [disabled]:active {\n      opacity: 0.5;\n      background-color: rgba(123, 123, 123, 0.4);\n      cursor: default;\n      cursor: not-allowed;\n      color: rgba(255, 255, 255, 0.8); }\n  tags-input .autocomplete {\n    margin-top: 0.5rem;\n    position: absolute;\n    padding: 0.5rem 0;\n    z-index: 999;\n    width: 100%;\n    background-color: #fff;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1); }\n    tags-input .autocomplete .suggestion-list {\n      margin: 0;\n      padding: 0;\n      list-style-type: none;\n      max-height: 28rem;\n      overflow-y: auto;\n      position: relative; }\n    tags-input .autocomplete .suggestion-item {\n      padding: 0.5rem 1rem;\n      cursor: pointer;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      color: #333;\n      background-color: #fff;\n      transition: all ease-in-out 0.1s; }\n      tags-input .autocomplete .suggestion-item.selected {\n        background-color: rgba(94, 169, 200, 0.3); }\n        tags-input .autocomplete .suggestion-item.selected:active {\n          background-color: rgba(94, 169, 200, 0.75);\n          color: #fff; }\n      tags-input .autocomplete .suggestion-item[disabled], tags-input .autocomplete .suggestion-item[disabled]:hover, tags-input .autocomplete .suggestion-item[disabled]:active {\n        background-color: transparent;\n        opacity: 0.45;\n        cursor: default;\n        pointer-events: none; }\n\n.dark-ui tags-input .tags-input__tags,\n[class^=\"--dark-ui\"] tags-input .tags-input__tags,\n[class*=\"--dark-ui\"] tags-input .tags-input__tags {\n  border-bottom-color: rgba(255, 255, 255, 0.2); }\n  .dark-ui tags-input .tags-input__tags:hover,\n  [class^=\"--dark-ui\"] tags-input .tags-input__tags:hover,\n  [class*=\"--dark-ui\"] tags-input .tags-input__tags:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4); }\n  .dark-ui tags-input .tags-input__tags.focused,\n  [class^=\"--dark-ui\"] tags-input .tags-input__tags.focused,\n  [class*=\"--dark-ui\"] tags-input .tags-input__tags.focused {\n    border-bottom-color: #5ea9c8; }\n  .dark-ui tags-input .tags-input__tags .tags-input__tag-item,\n  [class^=\"--dark-ui\"] tags-input .tags-input__tags .tags-input__tag-item,\n  [class*=\"--dark-ui\"] tags-input .tags-input__tags .tags-input__tag-item {\n    background: rgba(255, 255, 255, 0.2); }\n    .dark-ui tags-input .tags-input__tags .tags-input__tag-item.selected,\n    [class^=\"--dark-ui\"] tags-input .tags-input__tags .tags-input__tag-item.selected,\n    [class*=\"--dark-ui\"] tags-input .tags-input__tags .tags-input__tag-item.selected {\n      background-color: rgba(94, 169, 200, 0.75); }\n  .dark-ui tags-input .tags-input__tags--boxed,\n  [class^=\"--dark-ui\"] tags-input .tags-input__tags--boxed,\n  [class*=\"--dark-ui\"] tags-input .tags-input__tags--boxed {\n    background-color: rgba(255, 255, 255, 0.05); }\n    .dark-ui tags-input .tags-input__tags--boxed:hover,\n    [class^=\"--dark-ui\"] tags-input .tags-input__tags--boxed:hover,\n    [class*=\"--dark-ui\"] tags-input .tags-input__tags--boxed:hover {\n      background-color: rgba(255, 255, 255, 0.1); }\n\n.dark-ui tags-input .tags-input__add-button[disabled], .dark-ui tags-input .tags-input__add-button [disabled]:hover, .dark-ui tags-input .tags-input__add-button [disabled]:active,\n[class^=\"--dark-ui\"] tags-input .tags-input__add-button[disabled],\n[class^=\"--dark-ui\"] tags-input .tags-input__add-button [disabled]:hover,\n[class^=\"--dark-ui\"] tags-input .tags-input__add-button [disabled]:active,\n[class*=\"--dark-ui\"] tags-input .tags-input__add-button[disabled],\n[class*=\"--dark-ui\"] tags-input .tags-input__add-button [disabled]:hover,\n[class*=\"--dark-ui\"] tags-input .tags-input__add-button [disabled]:active {\n  background-color: rgba(123, 123, 123, 0.6);\n  color: rgba(255, 255, 255, 0.3); }\n\n.dark-ui .tags-input__label,\n[class^=\"--dark-ui\"] .tags-input__label,\n[class*=\"--dark-ui\"] .tags-input__label {\n  color: rgba(255, 255, 255, 0.4); }\n\n.side-panel {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr auto;\n  grid-gap: 0;\n  height: 100%;\n  position: relative;\n  background-color: #fff; }\n  .side-panel .side-panel__header {\n    grid-column: 1/2;\n    grid-row: 1/2;\n    z-index: 1;\n    position: relative;\n    min-height: 4.8rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center; }\n    .side-panel .side-panel__header--border-b {\n      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12); }\n    .side-panel .side-panel__header .nav-tabs {\n      flex-grow: 1; }\n    .side-panel .side-panel__header--dark-blue-grey {\n      background-color: #59727d;\n      color: #fff; }\n    .side-panel .side-panel__header--border-bottom {\n      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1); }\n  .side-panel .side-panel__sliding-toolbar {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    padding: 0 16px;\n    color: #333;\n    animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n    background-color: #d2e5ed;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n    .side-panel .side-panel__sliding-toolbar--right {\n      text-align: right;\n      justify-content: flex-end; }\n    .side-panel .side-panel__sliding-toolbar .sliding-toolbar__inner {\n      flex-grow: 1;\n      display: flex;\n      align-items: center; }\n      .side-panel .side-panel__sliding-toolbar .sliding-toolbar__inner--right {\n        text-align: right; }\n    .side-panel .side-panel__sliding-toolbar .sliding-toolbar__info-text {\n      font-weight: 300;\n      opacity: 0.75; }\n    .side-panel .side-panel__sliding-toolbar .btn + .sliding-toolbar__info-text {\n      margin-left: 1rem; }\n  .side-panel .side-panel__heading {\n    padding: 0 2rem 0 2rem;\n    margin: 0;\n    font-size: 1.5rem;\n    color: inherit;\n    opacity: 0.8;\n    font-weight: 300;\n    letter-spacing: 0.02em; }\n    .side-panel .side-panel__heading--big {\n      color: #333;\n      font-weight: 400;\n      font-size: 1.8rem;\n      letter-spacing: 0.01em; }\n  .side-panel .side-panel__close {\n    position: absolute;\n    right: 1rem;\n    top: 1.1rem;\n    z-index: 2;\n    color: #666; }\n  .side-panel .side-panel__tools {\n    position: absolute;\n    right: 1rem;\n    top: 1.1rem;\n    z-index: 2;\n    color: inherit; }\n    .side-panel .side-panel__tools .icn-btn {\n      margin-left: 0.2rem; }\n  .side-panel .side-panel__content {\n    grid-column: 1/2;\n    grid-row: 2/3;\n    z-index: 1;\n    overflow: auto; }\n    .side-panel .side-panel__content--flex {\n      display: flex;\n      flex-direction: column; }\n    .side-panel .side-panel__content--split {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      grid-template-rows: 1fr; }\n      .side-panel .side-panel__content--split .side-panel__content-block--left {\n        grid-column: 1/2;\n        grid-row: 1/2;\n        overflow-y: auto;\n        background-color: rgba(0, 0, 0, 0.1); }\n      .side-panel .side-panel__content--split .side-panel__content-block--right {\n        grid-column: 2/3;\n        grid-row: 1/2;\n        overflow-y: auto; }\n  .side-panel .side-panel__content-tab-nav {\n    min-height: 4.8rem;\n    flex-grow: 0;\n    flex-shrink: 0; }\n  .side-panel .side-panel__content-tab-content {\n    flex-grow: 1;\n    overflow: auto; }\n  .side-panel .side-panel__image-actions {\n    position: absolute;\n    top: 1.8rem;\n    right: 0.5rem;\n    z-index: 2; }\n  .side-panel .side-panel__content-block {\n    padding: 2rem; }\n    .side-panel .side-panel__content-block--pad-top-0 {\n      padding-top: 0; }\n    .side-panel .side-panel__content-block--boxed {\n      padding: 1.6rem;\n      border-radius: 3px;\n      margin-bottom: 1rem; }\n    .side-panel .side-panel__content-block--pad-small {\n      padding: 1.4rem 2rem 0.6rem; }\n    .side-panel .side-panel__content-block--flex {\n      display: flex;\n      align-items: flex-start; }\n    .side-panel .side-panel__content-block--image {\n      padding: 1rem 0 0 0;\n      position: relative; }\n      .side-panel .side-panel__content-block--image .side-panel__image-actions {\n        visibility: hidden; }\n      .side-panel .side-panel__content-block--image img {\n        display: block;\n        max-width: 100%;\n        max-height: 100%;\n        height: auto;\n        margin: auto; }\n      .side-panel .side-panel__content-block--image:hover .side-panel__image-actions {\n        visibility: visible; }\n    .side-panel .side-panel__content-block--space-between {\n      justify-content: space-between; }\n    .side-panel .side-panel__content-block .side-panel__heading {\n      padding: 0; }\n  .side-panel .side-panel-collapsible-header {\n    position: relative;\n    padding: .8rem 2rem;\n    box-shadow: 0px 1px 3px -1px rgba(0, 0, 0, 0.2);\n    margin-bottom: 1rem;\n    min-height: 40px; }\n    .side-panel .side-panel-collapsible-header__fixed {\n      padding: 0;\n      display: flex;\n      justify-content: space-between;\n      align-items: center; }\n    .side-panel .side-panel-collapsible-header__collapsible {\n      height: 0;\n      padding: 0;\n      overflow: hidden;\n      opacity: 0;\n      transition: opacity 0.3s 0.4s; }\n    .side-panel .side-panel-collapsible-header__toggle {\n      position: absolute;\n      width: 21px;\n      height: 21px;\n      border: 0;\n      padding: 0;\n      left: 50%;\n      margin-left: -10.5px;\n      bottom: -11px;\n      background-color: #fff;\n      z-index: 3;\n      line-height: 0;\n      border-radius: 50%;\n      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.4);\n      transition: transform 0.5s; }\n      .side-panel .side-panel-collapsible-header__toggle.active {\n        -webkit-transform: rotate(180deg);\n        transform: rotate(180deg); }\n    .side-panel .side-panel-collapsible-header.active {\n      min-height: 150px; }\n      .side-panel .side-panel-collapsible-header.active .side-panel-collapsible-header__collapsible {\n        height: auto;\n        opacity: 1;\n        padding: .8rem 0; }\n  .side-panel .side-panel__content-block-heading {\n    font-size: 1.9rem;\n    line-height: 120%;\n    font-weight: 500;\n    margin: 2rem 0; }\n    .side-panel .side-panel__content-block-heading--small-margin {\n      margin: 1rem 0; }\n  .side-panel .side-panel__content-block-text {\n    font-size: 1.5rem;\n    line-height: 140%;\n    font-weight: 300;\n    word-wrap: break-word;\n    padding-bottom: 1rem; }\n  .side-panel .side-panel__content-block-inner {\n    flex-grow: 0; }\n    .side-panel .side-panel__content-block-inner--right {\n      text-align: right; }\n    .side-panel .side-panel__content-block-inner--grow {\n      flex-grow: 1; }\n    .side-panel .side-panel__content-block-inner .double-size-icn {\n      margin: 0.1rem 1rem 0 0; }\n  .side-panel .side-panel__content-block-overlay {\n    position: absolute;\n    top: 4.8rem;\n    bottom: 6.4rem;\n    right: -34rem;\n    width: 34rem;\n    background-color: #222;\n    transition: all .2s ease; }\n    .side-panel .side-panel__content-block-overlay .side-panel {\n      opacity: 0;\n      transition: all 0.2s ease-out;\n      transition-delay: .1s; }\n    .side-panel .side-panel__content-block-overlay--open {\n      right: 0; }\n      .side-panel .side-panel__content-block-overlay--open .side-panel {\n        opacity: 1; }\n  .side-panel .side-panel__top-tools {\n    padding: 2rem;\n    background-color: rgba(0, 0, 0, 0.06);\n    padding: 1.2rem 1rem 1.2rem 2rem;\n    display: flex;\n    align-items: center; }\n    .side-panel .side-panel__top-tools .side-panel__top-tools-left {\n      text-align: left;\n      flex-grow: 1; }\n    .side-panel .side-panel__top-tools .side-panel__top-tools-right {\n      text-align: right;\n      flex-grow: 1; }\n    .side-panel .side-panel__top-tools--dark-blue-grey {\n      background: #59727d;\n      color: #fff; }\n  .side-panel .side-panel__footer {\n    grid-column: 1/2;\n    grid-row: 3/4;\n    z-index: 2; }\n    .side-panel .side-panel__footer--button-box, .side-panel .side-panel__footer--button-box-large {\n      padding: 1rem 2rem;\n      position: relative; }\n      .side-panel .side-panel__footer--button-box::before, .side-panel .side-panel__footer--button-box-large::before {\n        position: absolute;\n        content: '';\n        top: -0.4rem;\n        left: 0;\n        right: 0;\n        height: 0.4rem;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.05) 0%, transparent 100%); }\n    .side-panel .side-panel__footer--button-box-large {\n      padding: 1.4rem 2rem; }\n      .side-panel .side-panel__footer--button-box-large .btn + .btn, .side-panel .side-panel__footer--button-box-large .side-panel__footer-buttons--flex + .btn {\n        margin-top: 1rem;\n        margin-left: 0; }\n    .side-panel .side-panel__footer .side-panel__footer-buttons--flex {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      flex-basis: 0; }\n      .side-panel .side-panel__footer .side-panel__footer-buttons--flex .btn + .btn {\n        margin-left: 0.8rem;\n        margin-top: 0; }\n  .side-panel.side-panel--shadow-left::after {\n    display: block;\n    top: 0;\n    bottom: 0;\n    content: '';\n    width: 4px;\n    position: absolute;\n    right: 0;\n    z-index: 80;\n    background-image: linear-gradient(to left, rgba(0, 0, 0, 0.12) 0%, transparent 100%); }\n  .side-panel.side-panel--shadow-right::after {\n    display: block;\n    top: 0;\n    bottom: 0;\n    content: '';\n    width: 4px;\n    position: absolute;\n    left: 0;\n    z-index: 80;\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.12) 0%, transparent 100%); }\n  .side-panel.side-panel--transparent {\n    background-color: transparent; }\n    .side-panel.side-panel--transparent .side-panel__header {\n      background-color: rgba(255, 255, 255, 0.2); }\n  .side-panel--dark-ui {\n    background-color: #3a3a3a;\n    color: #fff; }\n    .side-panel--dark-ui .side-panel__heading {\n      color: rgba(255, 255, 255, 0.5); }\n      .side-panel--dark-ui .side-panel__heading--big {\n        color: rgba(255, 255, 255, 0.8); }\n    .side-panel--dark-ui .side-panel__footer--button-box, .side-panel--dark-ui .side-panel__footer--button-box-large {\n      background-color: rgba(94, 169, 200, 0.03); }\n      .side-panel--dark-ui .side-panel__footer--button-box::before, .side-panel--dark-ui .side-panel__footer--button-box-large::before {\n        background-image: linear-gradient(to top, rgba(0, 0, 0, 0.14) 0%, transparent 100%); }\n    .side-panel--dark-ui .dropdown__caret {\n      border-top: 4px solid #FFF;\n      opacity: .6; }\n\n.dark-ui .side-panel,\n[class^=\"--dark-ui\"] .side-panel,\n[class*=\"--dark-ui\"] .side-panel {\n  background-color: #3a3a3a;\n  color: #fff; }\n  .dark-ui .side-panel.side-panel--transparent,\n  [class^=\"--dark-ui\"] .side-panel.side-panel--transparent,\n  [class*=\"--dark-ui\"] .side-panel.side-panel--transparent {\n    background-color: transparent; }\n    .dark-ui .side-panel.side-panel--transparent .side-panel__header,\n    [class^=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__header,\n    [class*=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__header {\n      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n      background-color: rgba(94, 169, 200, 0.03); }\n    .dark-ui .side-panel.side-panel--transparent .side-panel__footer--button-box, .dark-ui .side-panel.side-panel--transparent .side-panel__footer--button-box-large,\n    [class^=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__footer--button-box,\n    [class^=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__footer--button-box-large,\n    [class*=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__footer--button-box,\n    [class*=\"--dark-ui\"] .side-panel.side-panel--transparent .side-panel__footer--button-box-large {\n      background-color: rgba(94, 169, 200, 0.1); }\n\n.flex-grid {\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n  overflow-x: auto; }\n  .flex-grid .flex-grid__item {\n    position: relative; }\n    .flex-grid .flex-grid__item--d-flex {\n      display: flex; }\n    .flex-grid .flex-grid__item--column {\n      flex-direction: column; }\n  .flex-grid--wrap-items {\n    flex-wrap: wrap; }\n  .flex-grid--content-center {\n    justify-content: center; }\n  .flex-grid--grow {\n    flex-grow: 1; }\n  .flex-grid--boxed {\n    margin-left: -1rem;\n    margin-right: -1rem; }\n    .flex-grid--boxed .flex-grid__item {\n      margin: 1rem; }\n  .flex-grid--boxed-small {\n    margin-left: -0.4rem;\n    margin-right: -0.4rem; }\n    .flex-grid--boxed-small .flex-grid__item, .flex-grid--boxed-small .sd-check__wrapper, .flex-grid--boxed-small .btn, .flex-grid--boxed-small .toggle-button {\n      margin: 0.4rem !important; }\n  .flex-grid--plain .flex-grid__item {\n    margin: 1rem;\n    padding: 0; }\n  .flex-grid--small-6 .flex-grid__item {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .flex-grid--small-5 .flex-grid__item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid--small-4 .flex-grid__item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid--small-3 .flex-grid__item {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .flex-grid--small-2 .flex-grid__item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid--small-1 .flex-grid__item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .flex-grid--boxed.flex-grid--small-6 .flex-grid__item {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    max-width: calc(16.66667% - 2rem); }\n  .flex-grid--boxed.flex-grid--small-5 .flex-grid__item {\n    -webkit-flex: 0 0 calc(20% - 2rem);\n    -ms-flex: 0 0 calc(20% - 2rem);\n    flex: 0 0 calc(20% - 2rem);\n    max-width: calc(20% - 2rem); }\n  .flex-grid--boxed.flex-grid--small-4 .flex-grid__item {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    max-width: calc(25% - 2rem); }\n  .flex-grid--boxed.flex-grid--small-3 .flex-grid__item {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    max-width: calc(33.33333% - 2rem); }\n  .flex-grid--boxed.flex-grid--small-2 .flex-grid__item {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    max-width: calc(50% - 2rem); }\n  .flex-grid--boxed.flex-grid--small-1 .flex-grid__item {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    max-width: calc(100% - 2rem); }\n  .flex-grid--boxed-small.flex-grid--small-6 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-6 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-6 .btn, .flex-grid--boxed-small.flex-grid--small-6 .toggle-button {\n    -webkit-flex: 0 0 calc(16.66667% - 0.8rem);\n    -ms-flex: 0 0 calc(16.66667% - 0.8rem);\n    flex: 0 0 calc(16.66667% - 0.8rem);\n    max-width: calc(16.66667% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-6 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--small-5 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-5 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-5 .btn, .flex-grid--boxed-small.flex-grid--small-5 .toggle-button {\n    -webkit-flex: 0 0 calc(20% - 0.8rem);\n    -ms-flex: 0 0 calc(20% - 0.8rem);\n    flex: 0 0 calc(20% - 0.8rem);\n    max-width: calc(20% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-5 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--small-4 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-4 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-4 .btn, .flex-grid--boxed-small.flex-grid--small-4 .toggle-button {\n    -webkit-flex: 0 0 calc(25% - 0.8rem);\n    -ms-flex: 0 0 calc(25% - 0.8rem);\n    flex: 0 0 calc(25% - 0.8rem);\n    max-width: calc(25% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-4 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--small-3 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-3 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-3 .btn, .flex-grid--boxed-small.flex-grid--small-3 .toggle-button {\n    -webkit-flex: 0 0 calc(33.33333% - 0.8rem);\n    -ms-flex: 0 0 calc(33.33333% - 0.8rem);\n    flex: 0 0 calc(33.33333% - 0.8rem);\n    max-width: calc(33.33333% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-3 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--small-2 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-2 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-2 .btn, .flex-grid--boxed-small.flex-grid--small-2 .toggle-button {\n    -webkit-flex: 0 0 calc(50% - 0.8rem);\n    -ms-flex: 0 0 calc(50% - 0.8rem);\n    flex: 0 0 calc(50% - 0.8rem);\n    max-width: calc(50% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-2 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--small-1 .flex-grid__item, .flex-grid--boxed-small.flex-grid--small-1 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--small-1 .btn, .flex-grid--boxed-small.flex-grid--small-1 .toggle-button {\n    -webkit-flex: 0 0 calc(100% - 0.8rem);\n    -ms-flex: 0 0 calc(100% - 0.8rem);\n    flex: 0 0 calc(100% - 0.8rem);\n    max-width: calc(100% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--small-1 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--small-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--small-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--padding {\n    padding: 2rem; }\n  .flex-grid--scroll {\n    overflow-y: auto; }\n\n@media only screen and (min-width: 40em) {\n  .flex-grid--medium-6 .flex-grid__item {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .flex-grid--medium-5 .flex-grid__item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid--medium-4 .flex-grid__item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid--medium-3 .flex-grid__item {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .flex-grid--medium-2 .flex-grid__item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid--medium-1 .flex-grid__item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .flex-grid--boxed.flex-grid--medium-6 .flex-grid__item {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    max-width: calc(16.66667% - 2rem); }\n  .flex-grid--boxed.flex-grid--medium-5 .flex-grid__item {\n    -webkit-flex: 0 0 calc(20% - 2rem);\n    -ms-flex: 0 0 calc(20% - 2rem);\n    flex: 0 0 calc(20% - 2rem);\n    max-width: calc(20% - 2rem); }\n  .flex-grid--boxed.flex-grid--medium-4 .flex-grid__item {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    max-width: calc(25% - 2rem); }\n  .flex-grid--boxed.flex-grid--medium-3 .flex-grid__item {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    max-width: calc(33.33333% - 2rem); }\n  .flex-grid--boxed.flex-grid--medium-2 .flex-grid__item {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    max-width: calc(50% - 2rem); }\n  .flex-grid--boxed.flex-grid--medium-1 .flex-grid__item {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    max-width: calc(100% - 2rem); }\n  .flex-grid--boxed-small.flex-grid--medium-6 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-6 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-6 .btn, .flex-grid--boxed-small.flex-grid--medium-6 .toggle-button {\n    -webkit-flex: 0 0 calc(16.66667% - 0.8rem);\n    -ms-flex: 0 0 calc(16.66667% - 0.8rem);\n    flex: 0 0 calc(16.66667% - 0.8rem);\n    max-width: calc(16.66667% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-6 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--medium-5 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-5 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-5 .btn, .flex-grid--boxed-small.flex-grid--medium-5 .toggle-button {\n    -webkit-flex: 0 0 calc(20% - 0.8rem);\n    -ms-flex: 0 0 calc(20% - 0.8rem);\n    flex: 0 0 calc(20% - 0.8rem);\n    max-width: calc(20% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-5 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--medium-4 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-4 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-4 .btn, .flex-grid--boxed-small.flex-grid--medium-4 .toggle-button {\n    -webkit-flex: 0 0 calc(25% - 0.8rem);\n    -ms-flex: 0 0 calc(25% - 0.8rem);\n    flex: 0 0 calc(25% - 0.8rem);\n    max-width: calc(25% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-4 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--medium-3 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-3 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-3 .btn, .flex-grid--boxed-small.flex-grid--medium-3 .toggle-button {\n    -webkit-flex: 0 0 calc(33.33333% - 0.8rem);\n    -ms-flex: 0 0 calc(33.33333% - 0.8rem);\n    flex: 0 0 calc(33.33333% - 0.8rem);\n    max-width: calc(33.33333% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-3 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--medium-2 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-2 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-2 .btn, .flex-grid--boxed-small.flex-grid--medium-2 .toggle-button {\n    -webkit-flex: 0 0 calc(50% - 0.8rem);\n    -ms-flex: 0 0 calc(50% - 0.8rem);\n    flex: 0 0 calc(50% - 0.8rem);\n    max-width: calc(50% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-2 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--medium-1 .flex-grid__item, .flex-grid--boxed-small.flex-grid--medium-1 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--medium-1 .btn, .flex-grid--boxed-small.flex-grid--medium-1 .toggle-button {\n    -webkit-flex: 0 0 calc(100% - 0.8rem);\n    -ms-flex: 0 0 calc(100% - 0.8rem);\n    flex: 0 0 calc(100% - 0.8rem);\n    max-width: calc(100% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--medium-1 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--medium-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--medium-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; } }\n\n@media only screen and (min-width: 60em) {\n  .flex-grid--large-6 .flex-grid__item {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .flex-grid--large-5 .flex-grid__item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid--large-4 .flex-grid__item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid--large-3 .flex-grid__item {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .flex-grid--large-2 .flex-grid__item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid--large-1 .flex-grid__item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .flex-grid--boxed.flex-grid--large-6 .flex-grid__item {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    max-width: calc(16.66667% - 2rem); }\n  .flex-grid--boxed.flex-grid--large-5 .flex-grid__item {\n    -webkit-flex: 0 0 calc(20% - 2rem);\n    -ms-flex: 0 0 calc(20% - 2rem);\n    flex: 0 0 calc(20% - 2rem);\n    max-width: calc(20% - 2rem); }\n  .flex-grid--boxed.flex-grid--large-4 .flex-grid__item {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    max-width: calc(25% - 2rem); }\n  .flex-grid--boxed.flex-grid--large-3 .flex-grid__item {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    max-width: calc(33.33333% - 2rem); }\n  .flex-grid--boxed.flex-grid--large-2 .flex-grid__item {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    max-width: calc(50% - 2rem); }\n  .flex-grid--boxed.flex-grid--large-1 .flex-grid__item {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    max-width: calc(100% - 2rem); }\n  .flex-grid--boxed-small.flex-grid--large-6 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-6 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-6 .btn, .flex-grid--boxed-small.flex-grid--large-6 .toggle-button {\n    -webkit-flex: 0 0 calc(16.66667% - 0.8rem);\n    -ms-flex: 0 0 calc(16.66667% - 0.8rem);\n    flex: 0 0 calc(16.66667% - 0.8rem);\n    max-width: calc(16.66667% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-6 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--large-5 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-5 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-5 .btn, .flex-grid--boxed-small.flex-grid--large-5 .toggle-button {\n    -webkit-flex: 0 0 calc(20% - 0.8rem);\n    -ms-flex: 0 0 calc(20% - 0.8rem);\n    flex: 0 0 calc(20% - 0.8rem);\n    max-width: calc(20% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-5 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--large-4 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-4 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-4 .btn, .flex-grid--boxed-small.flex-grid--large-4 .toggle-button {\n    -webkit-flex: 0 0 calc(25% - 0.8rem);\n    -ms-flex: 0 0 calc(25% - 0.8rem);\n    flex: 0 0 calc(25% - 0.8rem);\n    max-width: calc(25% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-4 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--large-3 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-3 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-3 .btn, .flex-grid--boxed-small.flex-grid--large-3 .toggle-button {\n    -webkit-flex: 0 0 calc(33.33333% - 0.8rem);\n    -ms-flex: 0 0 calc(33.33333% - 0.8rem);\n    flex: 0 0 calc(33.33333% - 0.8rem);\n    max-width: calc(33.33333% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-3 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--large-2 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-2 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-2 .btn, .flex-grid--boxed-small.flex-grid--large-2 .toggle-button {\n    -webkit-flex: 0 0 calc(50% - 0.8rem);\n    -ms-flex: 0 0 calc(50% - 0.8rem);\n    flex: 0 0 calc(50% - 0.8rem);\n    max-width: calc(50% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-2 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--large-1 .flex-grid__item, .flex-grid--boxed-small.flex-grid--large-1 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--large-1 .btn, .flex-grid--boxed-small.flex-grid--large-1 .toggle-button {\n    -webkit-flex: 0 0 calc(100% - 0.8rem);\n    -ms-flex: 0 0 calc(100% - 0.8rem);\n    flex: 0 0 calc(100% - 0.8rem);\n    max-width: calc(100% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--large-1 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--large-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--large-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; } }\n\n@media only screen and (min-width: 100em) {\n  .flex-grid--xlarge-6 .flex-grid__item {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%; }\n  .flex-grid--xlarge-5 .flex-grid__item {\n    -webkit-flex: 0 0 20%;\n    -ms-flex: 0 0 20%;\n    flex: 0 0 20%;\n    max-width: 20%; }\n  .flex-grid--xlarge-4 .flex-grid__item {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%; }\n  .flex-grid--xlarge-3 .flex-grid__item {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%; }\n  .flex-grid--xlarge-2 .flex-grid__item {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%; }\n  .flex-grid--xlarge-1 .flex-grid__item {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%; }\n  .flex-grid--boxed.flex-grid--xlarge-6 .flex-grid__item {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    max-width: calc(16.66667% - 2rem); }\n  .flex-grid--boxed.flex-grid--xlarge-5 .flex-grid__item {\n    -webkit-flex: 0 0 calc(20% - 2rem);\n    -ms-flex: 0 0 calc(20% - 2rem);\n    flex: 0 0 calc(20% - 2rem);\n    max-width: calc(20% - 2rem); }\n  .flex-grid--boxed.flex-grid--xlarge-4 .flex-grid__item {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    max-width: calc(25% - 2rem); }\n  .flex-grid--boxed.flex-grid--xlarge-3 .flex-grid__item {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    max-width: calc(33.33333% - 2rem); }\n  .flex-grid--boxed.flex-grid--xlarge-2 .flex-grid__item {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    max-width: calc(50% - 2rem); }\n  .flex-grid--boxed.flex-grid--xlarge-1 .flex-grid__item {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    max-width: calc(100% - 2rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-6 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-6 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-6 .btn, .flex-grid--boxed-small.flex-grid--xlarge-6 .toggle-button {\n    -webkit-flex: 0 0 calc(16.66667% - 0.8rem);\n    -ms-flex: 0 0 calc(16.66667% - 0.8rem);\n    flex: 0 0 calc(16.66667% - 0.8rem);\n    max-width: calc(16.66667% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-6 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-6 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--xlarge-5 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-5 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-5 .btn, .flex-grid--boxed-small.flex-grid--xlarge-5 .toggle-button {\n    -webkit-flex: 0 0 calc(20% - 0.8rem);\n    -ms-flex: 0 0 calc(20% - 0.8rem);\n    flex: 0 0 calc(20% - 0.8rem);\n    max-width: calc(20% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-5 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-5 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--xlarge-4 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-4 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-4 .btn, .flex-grid--boxed-small.flex-grid--xlarge-4 .toggle-button {\n    -webkit-flex: 0 0 calc(25% - 0.8rem);\n    -ms-flex: 0 0 calc(25% - 0.8rem);\n    flex: 0 0 calc(25% - 0.8rem);\n    max-width: calc(25% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-4 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-4 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--xlarge-3 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-3 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-3 .btn, .flex-grid--boxed-small.flex-grid--xlarge-3 .toggle-button {\n    -webkit-flex: 0 0 calc(33.33333% - 0.8rem);\n    -ms-flex: 0 0 calc(33.33333% - 0.8rem);\n    flex: 0 0 calc(33.33333% - 0.8rem);\n    max-width: calc(33.33333% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-3 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-3 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--xlarge-2 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-2 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-2 .btn, .flex-grid--boxed-small.flex-grid--xlarge-2 .toggle-button {\n    -webkit-flex: 0 0 calc(50% - 0.8rem);\n    -ms-flex: 0 0 calc(50% - 0.8rem);\n    flex: 0 0 calc(50% - 0.8rem);\n    max-width: calc(50% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-2 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-2 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; }\n  .flex-grid--boxed-small.flex-grid--xlarge-1 .flex-grid__item, .flex-grid--boxed-small.flex-grid--xlarge-1 .sd-check__wrapper, .flex-grid--boxed-small.flex-grid--xlarge-1 .btn, .flex-grid--boxed-small.flex-grid--xlarge-1 .toggle-button {\n    -webkit-flex: 0 0 calc(100% - 0.8rem);\n    -ms-flex: 0 0 calc(100% - 0.8rem);\n    flex: 0 0 calc(100% - 0.8rem);\n    max-width: calc(100% - 0.8rem); }\n  .flex-grid--boxed-small.flex-grid--xlarge-1 .sd-check__wrapper {\n    display: flex; }\n    .flex-grid--boxed-small.flex-grid--xlarge-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n      display: flex;\n      flex-grow: 1; }\n      .flex-grid--boxed-small.flex-grid--xlarge-1 .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style label {\n        flex-grow: 1; } }\n\n.grid {\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  padding: 0 1rem;\n  flex-wrap: wrap; }\n  .grid .grid__item {\n    flex: 1 1 auto;\n    padding: 0 1rem; }\n    .grid .grid__item.grid__item--col-1 {\n      -webkit-flex: 0 0 8.33333%;\n      -ms-flex: 0 0 8.33333%;\n      flex: 0 0 8.33333%;\n      max-width: 8.33333%; }\n    .grid .grid__item.grid__item--col-2 {\n      -webkit-flex: 0 0 16.66667%;\n      -ms-flex: 0 0 16.66667%;\n      flex: 0 0 16.66667%;\n      max-width: 16.66667%; }\n    .grid .grid__item.grid__item--col-3 {\n      -webkit-flex: 0 0 25%;\n      -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n      max-width: 25%; }\n    .grid .grid__item.grid__item--col-4 {\n      -webkit-flex: 0 0 33.33333%;\n      -ms-flex: 0 0 33.33333%;\n      flex: 0 0 33.33333%;\n      max-width: 33.33333%; }\n    .grid .grid__item.grid__item--col-5 {\n      -webkit-flex: 0 0 41.66667%;\n      -ms-flex: 0 0 41.66667%;\n      flex: 0 0 41.66667%;\n      max-width: 41.66667%; }\n    .grid .grid__item.grid__item--col-6 {\n      -webkit-flex: 0 0 50%;\n      -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n      max-width: 50%; }\n    .grid .grid__item.grid__item--col-7 {\n      -webkit-flex: 0 0 58.33333%;\n      -ms-flex: 0 0 58.33333%;\n      flex: 0 0 58.33333%;\n      max-width: 58.33333%; }\n    .grid .grid__item.grid__item--col-8 {\n      -webkit-flex: 0 0 66.66667%;\n      -ms-flex: 0 0 66.66667%;\n      flex: 0 0 66.66667%;\n      max-width: 66.66667%; }\n    .grid .grid__item.grid__item--col-9 {\n      -webkit-flex: 0 0 75%;\n      -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n      max-width: 75%; }\n    .grid .grid__item.grid__item--col-10 {\n      -webkit-flex: 0 0 83.33333%;\n      -ms-flex: 0 0 83.33333%;\n      flex: 0 0 83.33333%;\n      max-width: 83.33333%; }\n    .grid .grid__item.grid__item--col-11 {\n      -webkit-flex: 0 0 91.66667%;\n      -ms-flex: 0 0 91.66667%;\n      flex: 0 0 91.66667%;\n      max-width: 91.66667%; }\n    .grid .grid__item.grid__item--col-12 {\n      -webkit-flex: 0 0 100%;\n      -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n      max-width: 100%; }\n    .grid .grid__item > .grid {\n      margin-left: -1rem;\n      margin-right: -1rem;\n      padding: 0; }\n  .grid--padding-fix {\n    margin-left: -1rem;\n    margin-right: -1rem;\n    padding: 0; }\n  .grid--margin {\n    margin-top: 1rem;\n    margin-bottom: 1rem; }\n  .grid--wrap {\n    flex-wrap: wrap; }\n  .grid--boxed {\n    margin-left: -1rem;\n    margin-right: -1rem; }\n    .grid--boxed .grid__item {\n      margin: 1rem;\n      padding: 0; }\n    .grid--boxed-styled .grid__item {\n      background-color: white;\n      border-radius: 2px;\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12); }\n  .grid + .grid {\n    margin-top: 1rem; }\n\n@media only screen and (min-width: 0) {\n  .grid .grid__item.gi-xsmall-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-xsmall-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-xsmall-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-xsmall-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-xsmall-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-xsmall-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-xsmall-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-xsmall-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-xsmall-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-xsmall-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-xsmall-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-xsmall-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-xsmall-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xsmall-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n@media only screen and (min-width: 40em) {\n  .grid .grid__item.gi-small-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-small-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-small-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-small-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-small-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-small-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-small-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-small-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-small-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-small-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-small-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-small-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-small-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-small-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-small-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-small-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-small-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-small-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-small-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-small-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-small-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-small-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-small-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-small-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n@media only screen and (min-width: 60em) {\n  .grid .grid__item.gi-medium-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-medium-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-medium-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-medium-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-medium-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-medium-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-medium-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-medium-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-medium-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-medium-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-medium-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-medium-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-medium-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-medium-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n@media only screen and (min-width: 64em) {\n  .grid .grid__item.gi-large-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-large-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-large-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-large-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-large-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-large-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-large-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-large-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-large-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-large-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-large-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-large-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-large-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-large-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-large-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-large-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-large-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-large-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-large-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-large-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-large-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-large-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-large-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-large-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n@media only screen and (min-width: 75em) {\n  .grid .grid__item.gi-xlarge-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-xlarge-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-xlarge-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-xlarge-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-xlarge-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-xlarge-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-xlarge-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-xlarge-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-xlarge-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-xlarge-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-xlarge-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-xlarge-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-xlarge-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xlarge-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n@media only screen and (min-width: 90em) {\n  .grid .grid__item.gi-xxlarge-1 {\n    -webkit-flex: 0 0 8.33333%;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    min-width: 8.33333%; }\n  .grid .grid__item.gi-xxlarge-2 {\n    -webkit-flex: 0 0 16.66667%;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    min-width: 16.66667%; }\n  .grid .grid__item.gi-xxlarge-3 {\n    -webkit-flex: 0 0 25%;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    min-width: 25%; }\n  .grid .grid__item.gi-xxlarge-4 {\n    -webkit-flex: 0 0 33.33333%;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    min-width: 33.33333%; }\n  .grid .grid__item.gi-xxlarge-5 {\n    -webkit-flex: 0 0 41.66667%;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    min-width: 41.66667%; }\n  .grid .grid__item.gi-xxlarge-6 {\n    -webkit-flex: 0 0 50%;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    min-width: 50%; }\n  .grid .grid__item.gi-xxlarge-7 {\n    -webkit-flex: 0 0 58.33333%;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    min-width: 58.33333%; }\n  .grid .grid__item.gi-xxlarge-8 {\n    -webkit-flex: 0 0 66.66667%;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    min-width: 66.66667%; }\n  .grid .grid__item.gi-xxlarge-9 {\n    -webkit-flex: 0 0 75%;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    min-width: 75%; }\n  .grid .grid__item.gi-xxlarge-10 {\n    -webkit-flex: 0 0 83.33333%;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    min-width: 83.33333%; }\n  .grid .grid__item.gi-xxlarge-11 {\n    -webkit-flex: 0 0 91.66667%;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    min-width: 91.66667%; }\n  .grid .grid__item.gi-xxlarge-12 {\n    -webkit-flex: 0 0 100%;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    min-width: 100%; }\n  .grid--boxed .grid__item.gi-xxlarge-1 {\n    -webkit-flex: 0 0 calc(8.33333% - 2rem);\n    -ms-flex: 0 0 calc(8.33333% - 2rem);\n    flex: 0 0 calc(8.33333% - 2rem);\n    min-width: calc(8.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-2 {\n    -webkit-flex: 0 0 calc(16.66667% - 2rem);\n    -ms-flex: 0 0 calc(16.66667% - 2rem);\n    flex: 0 0 calc(16.66667% - 2rem);\n    min-width: calc(16.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-3 {\n    -webkit-flex: 0 0 calc(25% - 2rem);\n    -ms-flex: 0 0 calc(25% - 2rem);\n    flex: 0 0 calc(25% - 2rem);\n    min-width: calc(25% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-4 {\n    -webkit-flex: 0 0 calc(33.33333% - 2rem);\n    -ms-flex: 0 0 calc(33.33333% - 2rem);\n    flex: 0 0 calc(33.33333% - 2rem);\n    min-width: calc(33.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-5 {\n    -webkit-flex: 0 0 calc(41.66667% - 2rem);\n    -ms-flex: 0 0 calc(41.66667% - 2rem);\n    flex: 0 0 calc(41.66667% - 2rem);\n    min-width: calc(41.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-6 {\n    -webkit-flex: 0 0 calc(50% - 2rem);\n    -ms-flex: 0 0 calc(50% - 2rem);\n    flex: 0 0 calc(50% - 2rem);\n    min-width: calc(50% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-7 {\n    -webkit-flex: 0 0 calc(58.33333% - 2rem);\n    -ms-flex: 0 0 calc(58.33333% - 2rem);\n    flex: 0 0 calc(58.33333% - 2rem);\n    min-width: calc(58.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-8 {\n    -webkit-flex: 0 0 calc(66.66667% - 2rem);\n    -ms-flex: 0 0 calc(66.66667% - 2rem);\n    flex: 0 0 calc(66.66667% - 2rem);\n    min-width: calc(66.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-9 {\n    -webkit-flex: 0 0 calc(75% - 2rem);\n    -ms-flex: 0 0 calc(75% - 2rem);\n    flex: 0 0 calc(75% - 2rem);\n    min-width: calc(75% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-10 {\n    -webkit-flex: 0 0 calc(83.33333% - 2rem);\n    -ms-flex: 0 0 calc(83.33333% - 2rem);\n    flex: 0 0 calc(83.33333% - 2rem);\n    min-width: calc(83.33333% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-11 {\n    -webkit-flex: 0 0 calc(91.66667% - 2rem);\n    -ms-flex: 0 0 calc(91.66667% - 2rem);\n    flex: 0 0 calc(91.66667% - 2rem);\n    min-width: calc(91.66667% - 2rem); }\n  .grid--boxed .grid__item.gi-xxlarge-12 {\n    -webkit-flex: 0 0 calc(100% - 2rem);\n    -ms-flex: 0 0 calc(100% - 2rem);\n    flex: 0 0 calc(100% - 2rem);\n    min-width: calc(100% - 2rem); } }\n\n.sd-css-grid {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 20rem 1fr;\n  grid-template-rows: 4.8rem 1fr auto auto;\n  grid-gap: 0;\n  height: 100vh;\n  position: relative;\n  background-color: aquamarine; }\n  .sd-css-grid .sd-top-menu {\n    grid-column: 1/3;\n    grid-row: 1/2;\n    z-index: 2;\n    position: static; }\n  .sd-css-grid .sd-left-nav {\n    grid-column: 1/2;\n    grid-row: 2/4;\n    z-index: 2; }\n  .sd-css-grid .sd-content {\n    grid-column: 2/3;\n    grid-row: 2/3;\n    z-index: 1;\n    background-color: red;\n    overflow: auto; }\n  .sd-css-grid .bottom-bar {\n    height: 3rem;\n    background-color: #222;\n    grid-column: 1/3;\n    grid-row: 4/5;\n    z-index: 2; }\n\n.sd-page-grid--basic {\n  margin: 0;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: 4.8rem 1fr auto auto;\n  grid-gap: 0;\n  height: 100vh;\n  position: relative;\n  background-color: aquamarine; }\n  .sd-page-grid--basic .sd-main-menu {\n    grid-column: 1/2;\n    grid-row: 1/5;\n    background-color: #272727;\n    width: 30rem;\n    box-shadow: inset -4px 0 12px rgba(0, 0, 0, 0.9);\n    display: none; }\n    .sd-page-grid--basic .sd-main-menu .sd-left-nav__btn {\n      color: rgba(255, 255, 255, 0.75); }\n    .sd-page-grid--basic .sd-main-menu .sd-left-nav__group-header {\n      border-top: 1px solid rgba(255, 255, 255, 0.14); }\n  .sd-page-grid--basic .sd-top-menu {\n    grid-column: 2/3;\n    grid-row: 1/2;\n    z-index: 2;\n    position: static; }\n  .sd-page-grid--basic .sd-content {\n    grid-column: 2/3;\n    grid-row: 2/3;\n    z-index: 1;\n    background-color: #f8f8f8;\n    overflow: auto; }\n  .sd-page-grid--basic .bottom-bar {\n    height: 3rem;\n    background-color: #222;\n    grid-column: 2/3;\n    grid-row: 4/5;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    color: rgba(255, 255, 255, 0.75);\n    padding: 0 10px; }\n\n.sd-page-content__left-tabs,\n.sd-page-content__right-tabs {\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative; }\n  .sd-page-content__left-tabs::after,\n  .sd-page-content__right-tabs::after {\n    display: block;\n    bottom: 0;\n    content: '';\n    width: 4px;\n    position: absolute;\n    z-index: 80;\n    top: 0; }\n\n.sd-page-content__left-tabs::after {\n  right: -4px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.25) 0, transparent 100%); }\n\n.sd-page-content__right-tabs::after {\n  left: -4px;\n  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.25) 0, transparent 100%); }\n\n.sd-column-box--3, .sd-column-box--2 {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  overflow-x: hidden;\n  overflow-y: auto; }\n\n.sd-column-box__main-column {\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow: auto; }\n  .sd-column-box__main-column--padded {\n    padding: 2rem; }\n  .sd-column-box__main-column--20 {\n    width: 20%; }\n  .sd-column-box__main-column--30 {\n    width: 30%; }\n  .sd-column-box__main-column--40 {\n    width: 40%; }\n  .sd-column-box__main-column--60 {\n    width: 60%; }\n  .sd-column-box__main-column--70 {\n    width: 70%; }\n  .sd-column-box__main-column--80 {\n    width: 80%; }\n  .sd-column-box__main-column--photo-preview {\n    display: flex;\n    flex-direction: column;\n    background-color: #212121;\n    position: relative; }\n    .sd-column-box__main-column--photo-preview .sd-photo-preview {\n      flex-grow: 1; }\n  .sd-column-box__main-column--left {\n    border-right: 1px solid #BEBCBC; }\n  .sd-column-box__main-column--border-right {\n    border-right: 2px solid #8f8f8f; }\n  .sd-column-box__main-column--flex {\n    display: flex;\n    flex-direction: column; }\n\n.sd-column-box__main-column-inner {\n  overflow-y: auto;\n  padding: 2rem; }\n\n.sd-column-box__slide-in-column {\n  width: 26rem;\n  transition: all .2s ease-out;\n  display: flex;\n  flex-direction: column;\n  border-left: 1px solid rgba(0, 0, 0, 0.27);\n  overflow-x: hidden;\n  position: relative; }\n  .sd-column-box__slide-in-column::before {\n    display: block;\n    top: 0;\n    bottom: 0;\n    content: '';\n    width: 4px;\n    position: absolute;\n    left: 0;\n    z-index: 80;\n    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.12) 0%, transparent 100%); }\n  .sd-column-box__slide-in-column .sd-column-box__slide-in-column-inner {\n    opacity: 1;\n    transition: all 0.1s ease-out;\n    transition-delay: 0.2s;\n    background-color: rgba(255, 255, 255, 0.7); }\n  .sd-column-box__slide-in-column--large {\n    width: 40rem; }\n  .sd-column-box__slide-in-column--dark-ui {\n    background-color: #3b3b3b; }\n    .sd-column-box__slide-in-column--dark-ui .sd-column-box__slide-in-column-inner {\n      background-color: #3b3b3b; }\n    .sd-column-box__slide-in-column--dark-ui .sd-slide-in-panel__heading {\n      color: rgba(255, 255, 255, 0.75); }\n  .sd-column-box__slide-in-column--closed {\n    width: 0;\n    border-left: 1px solid rgba(187, 187, 187, 0);\n    overflow: hidden; }\n    .sd-column-box__slide-in-column--closed .sd-column-box__slide-in-column-inner {\n      opacity: 0;\n      transition: all 0.1s ease-out;\n      transition-delay: 0; }\n\n.sd-slide-in-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%; }\n\n.sd-slide-in-panel__header {\n  flex-grow: 0;\n  flex-shrink: 0;\n  z-index: 2;\n  position: relative;\n  min-height: 4.8rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12); }\n\n.sd-slide-in-panel__heading {\n  padding: 0 2rem 0 1.6rem;\n  margin: 0;\n  font-size: 1.5rem;\n  color: #666;\n  font-weight: 300;\n  letter-spacing: 0.02em; }\n  .sd-slide-in-panel__heading--marg-b10 {\n    margin-bottom: 1rem; }\n  .sd-slide-in-panel__heading--marg-b16 {\n    margin-bottom: 1.6rem; }\n  .sd-slide-in-panel__heading--marg-b20 {\n    margin-bottom: 2rem; }\n\n.sd-slide-in-panel__close {\n  position: absolute;\n  right: 1rem;\n  top: 1.1rem;\n  z-index: 2;\n  color: #666; }\n\n.sd-slide-in-panel__content {\n  flex-grow: 1;\n  overflow-y: auto; }\n\n.sd-slide-in-panel__content-block {\n  padding: 1.6rem; }\n  .sd-slide-in-panel__content-block--first {\n    padding-top: 3.2rem; }\n  .sd-slide-in-panel__content-block .sd-slide-in-panel__heading {\n    padding: 0; }\n\n.sd-page-content__content-block {\n  transition: all 0.2s ease-out;\n  transition-delay: 0.1s;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  overflow-x: hidden;\n  flex-grow: 1;\n  position: relative; }\n  .sd-page-content__content-block .subnav {\n    flex-shrink: 0;\n    flex-grow: 0; }\n  .sd-page-content__content-block .sd-list-item-group {\n    margin: 2.4rem;\n    opacity: 1;\n    transition: opacity 0.2s ease-in;\n    transition-delay: 0.1s; }\n  .sd-page-content__content-block .sd-column-box--3 {\n    opacity: 1;\n    transition: opacity 0.2s ease-in;\n    transition-delay: 0.1s; }\n  .sd-page-content__content-block .sd-list-header {\n    margin: 2.4rem 2.4rem -2rem 2.4rem; }\n  .sd-page-content__content-block--double-sidebar {\n    width: calc(100vw - 9.6rem); }\n\n.sd-page-content__content-block--right::before {\n  border-left: 3px solid #6C6C6C;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.2) 0, transparent 100%);\n  display: block;\n  bottom: 0;\n  content: '';\n  width: 6px;\n  position: absolute;\n  z-index: 8000;\n  top: 0; }\n\n.sd-edit-panel {\n  background-color: #fff;\n  transition: all .2s ease-out;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden; }\n\n.sd-page-content--split {\n  width: 100%;\n  display: flex;\n  flex-direction: row; }\n  .sd-page-content--split .sd-sidebar-menu {\n    position: relative;\n    top: 0;\n    bottom: auto; }\n  .sd-page-content--split .sd-page-content__content-block--100 {\n    width: calc(100vw - 4.8rem); }\n  .sd-page-content--split .sd-page-content__content-block--70 {\n    width: calc(70vw - 4.8rem); }\n  .sd-page-content--split .sd-page-content__content-block--50 {\n    width: calc(50vw - 4.8rem); }\n  .sd-page-content--split .sd-page-content__content-block--30 {\n    width: calc(30vw - 4.8rem); }\n\n.sd-page-content--slide-in {\n  display: flex;\n  flex-direction: row; }\n  .sd-page-content--slide-in .sd-sidebar-menu {\n    position: relative;\n    top: 0;\n    bottom: auto; }\n  .sd-page-content--slide-in .sd-page-content__content-block--main {\n    width: calc(100vw - 4.8rem); }\n  .sd-page-content--slide-in .sd-page-content__content-block--30-slide {\n    width: 0; }\n    .sd-page-content--slide-in .sd-page-content__content-block--30-slide .side-panel {\n      opacity: 0;\n      transition: opacity 0.2s ease-in;\n      transition-delay: 0s; }\n  .sd-page-content--slide-in--open .sd-page-content__content-block--main {\n    width: calc(100vw - 57.8rem); }\n  .sd-page-content--slide-in--open .sd-page-content__content-block--30-slide {\n    width: 53rem; }\n    .sd-page-content--slide-in--open .sd-page-content__content-block--30-slide .side-panel {\n      opacity: 1;\n      transition-delay: 0.2s; }\n\n.sd-page-content--split.edit-closed #leftContent.sd-page-content__content-block {\n  width: calc(100vw - 4.8rem); }\n\n.sd-page-content--split.edit-closed #editPane.sd-page-content__content-block {\n  width: 0;\n  opacity: 0; }\n\n.sd-page-content--split.edit-closed .open-preview .sd-preview-panel {\n  width: 50rem; }\n\n.sd-page-content--split.sd-page-content--split-left #leftContent.sd-page-content__content-block {\n  width: 0;\n  opacity: 0; }\n  .sd-page-content--split.sd-page-content--split-left #leftContent.sd-page-content__content-block .sd-list-item-group {\n    opacity: 0;\n    transition-delay: 0s; }\n  .sd-page-content--split.sd-page-content--split-left #leftContent.sd-page-content__content-block .sd-column-box--3 {\n    opacity: 0;\n    transition-delay: 0s; }\n  .sd-page-content--split.sd-page-content--split-left #leftContent.sd-page-content__content-block .sd-list-header {\n    opacity: 0;\n    transition-delay: 0s; }\n\n.sd-page-content--split.sd-page-content__content-block.shift-to-left #editPane.sd-page-content__content-block {\n  width: calc(100vw - 4.8rem); }\n\n.sd-page-content--split.sd-page-content__content-block.shift-to-left #leftContent.sd-page-content__content-block {\n  width: 0; }\n\n.sd-sidebar-menu__btn--closed .sd-sidebar-menu__helper-icon {\n  transform: rotate(180deg); }\n\n.sd-filters-panel, .sd-preview-panel, .sd-publish-panel {\n  width: 0;\n  transition: all .2s ease-out;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden; }\n  .sd-filters-panel .side-panel, .sd-preview-panel .side-panel, .sd-publish-panel .side-panel {\n    opacity: 0;\n    transition: all 0.1s ease-out;\n    transition-delay: 0; }\n\n.sd-filters-panel {\n  background-color: #ededed;\n  border-right: 0px solid transparent; }\n\n.sd-preview-panel {\n  background-color: #fff;\n  border-left: 0px solid transparent; }\n  .sd-preview-panel--dark-ui {\n    background-color: #2b2b2b; }\n\n.open-filters .sd-filters-panel {\n  width: 36rem;\n  border-right: 2px solid rgba(0, 0, 0, 0.25); }\n  .open-filters .sd-filters-panel--border-left {\n    border-right: none;\n    border-left: 2px solid rgba(0, 0, 0, 0.25); }\n  .open-filters .sd-filters-panel .side-panel {\n    opacity: 1;\n    transition: all 0.2s ease-out;\n    transition-delay: .2s; }\n\n.open-preview .sd-preview-panel {\n  width: 36rem;\n  border-left: 1px solid rgba(0, 0, 0, 0.25);\n  flex-shrink: 0; }\n  .open-preview .sd-preview-panel--dark-ui {\n    border-left-color: rgba(0, 0, 0, 0.4); }\n  .open-preview .sd-preview-panel .side-panel {\n    opacity: 1;\n    transition: all 0.2s ease-out;\n    transition-delay: .2s; }\n\n.authoring .open-preview .sd-preview-panel {\n  width: auto;\n  max-width: 32rem;\n  flex-shrink: 1; }\n\n.sd-filters-panel .side-panel, .sd-preview-panel .side-panel {\n  opacity: 0; }\n\n.text-label {\n  display: inline-block;\n  min-width: 4rem;\n  color: #666;\n  font-weight: 300; }\n  .text-label--auto {\n    min-width: auto; }\n\n.sd-content-navigation-panel {\n  width: 20rem;\n  background-color: #f0f0f0;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  overflow-x: hidden;\n  border-right-color: #999;\n  border-right-style: solid;\n  border-right-width: 0;\n  transition: all .2s ease-out .1s; }\n  .sd-content-navigation-panel--border-right {\n    border-right-width: 2px; }\n  .sd-content-navigation-panel .subnav {\n    flex-shrink: 0; }\n  .content-nav-closed .sd-content-navigation-panel {\n    width: 0; }\n    .content-nav-closed .sd-content-navigation-panel .sd-content-nav {\n      opacity: 0;\n      transition: all .1s ease-out; }\n    .content-nav-closed .sd-content-navigation-panel.sd-content-navigation-panel--border-right {\n      border-right-width: 0; }\n\n.open-publish .sd-publish-panel {\n  width: 40rem;\n  flex-shrink: 0; }\n  .open-publish .sd-publish-panel .side-panel {\n    opacity: 1;\n    transition: all 0.2s ease-out;\n    transition-delay: .2s; }\n\n.authoring .open-publish .sd-publish-panel {\n  width: auto;\n  max-width: 32rem;\n  flex-grow: 1;\n  flex-shrink: 1; }\n\n.dark-ui .sd-filters-panel,\n[class^=\"--dark-ui\"] .sd-filters-panel,\n[class*=\"--dark-ui\"] .sd-filters-panel {\n  background-color: #333; }\n\n.sd-main-content-grid {\n  margin: 0;\n  display: grid;\n  grid-template-columns: [slideInLeft] auto [mainContent] 1fr [slideInRight] auto [overlayContainer] 0;\n  grid-template-rows: [headerToolbar] auto [contentBlock] 1fr; }\n\n.sd-main-content-grid__header {\n  grid-column: 1/4;\n  grid-row: headerToolbar;\n  display: flex;\n  flex-direction: column; }\n\n.sd-main-content-grid__content {\n  grid-column: mainContent;\n  grid-row: contentBlock;\n  overflow-y: auto; }\n\n.sd-main-content-grid__filter {\n  grid-column: slideInLeft;\n  grid-row: contentBlock;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr; }\n\n.sd-main-content-grid__preview {\n  grid-column: slideInRight;\n  grid-row: contentBlock;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr; }\n\n.sd-main-content-grid__overlay {\n  grid-column: overlayContainer;\n  grid-row: 1/-1;\n  overflow: visible;\n  width: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  position: relative; }\n\n.side-panel__container {\n  grid-column: 1/2;\n  width: 0;\n  overflow: hidden;\n  transition: all ease-in-out 0.1s; }\n  .side-panel__container .side-panel {\n    opacity: 0;\n    transition: opacity ease-in-out 0.4s; }\n\n.sd-main-content-grid__preview.open-preview .side-panel__container {\n  width: 460px;\n  overflow-y: auto; }\n  .sd-main-content-grid__preview.open-preview .side-panel__container .side-panel {\n    opacity: 1; }\n\n.sd-main-content-grid__filter.open-filters .side-panel__container {\n  width: 360px;\n  overflow-y: auto; }\n  .sd-main-content-grid__filter.open-filters .side-panel__container .side-panel {\n    opacity: 1; }\n\n.sd-content-wrapper {\n  margin: 0;\n  display: grid;\n  grid-template-columns: [sideTabsLeft] auto [contentArea] 1fr [contentSplitter] auto [authoringArea] auto;\n  grid-template-rows: 1fr; }\n\n.sd-content-wrapper__left-tabs {\n  grid-column: sideTabsLeft; }\n  .sd-content-wrapper__left-tabs.sd-sidebar-menu {\n    position: static;\n    box-shadow: 1px 0 0 rgba(0, 0, 0, 0.08), 1px 0 4px rgba(0, 0, 0, 0.16);\n    z-index: 10; }\n\n.sd-content-wrapper__main-content-area {\n  grid-column: contentArea;\n  overflow: auto; }\n\n.sd-content-wrapper__content-splitter {\n  grid-column: contentSplitter;\n  width: 3px;\n  background-color: #666;\n  cursor: col-resize; }\n\n.sd-content-wrapper__authoring-content-area {\n  grid-column: authoringArea;\n  display: grid; }\n\n.sd-page-grid--test {\n  margin: 0;\n  display: grid;\n  grid-template-columns: [slideInNavigation] auto [contentContainer] 1fr;\n  grid-template-rows: [mainToolbar] 4.8rem [contentContainer] 1fr [footerBar] auto;\n  grid-gap: 0;\n  height: 100vh;\n  position: relative;\n  background-color: aquamarine; }\n  .sd-page-grid--test .sd-main-menu {\n    grid-column: slideInNavigation;\n    grid-row: 1/-1;\n    background-color: #272727;\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr; }\n    .sd-page-grid--test .sd-main-menu .sd-main-menu__inner {\n      display: grid;\n      grid-template-columns: 1fr;\n      grid-template-rows: 1fr;\n      width: 0;\n      overflow: hidden;\n      transition: opacity ease-in-out 0.2s, width ease-in-out 0.1s;\n      opacity: 0;\n      box-shadow: inset -8px 0px 12px -4px rgba(0, 0, 0, 0.6); }\n    .sd-page-grid--test .sd-main-menu.sd-main-menu--open .sd-main-menu__inner {\n      width: 30rem;\n      opacity: 1; }\n  .sd-page-grid--test .sd-top-menu {\n    grid-column: contentContainer;\n    grid-row: mainToolbar;\n    z-index: 2;\n    position: static; }\n  .sd-page-grid--test .sd-content {\n    grid-column: contentContainer;\n    grid-row: contentContainer;\n    z-index: 1;\n    background-color: #f8f8f8;\n    overflow: auto; }\n  .sd-page-grid--test .bottom-bar {\n    grid-column: contentContainer;\n    grid-row: footerBar;\n    height: 3rem;\n    background-color: #222;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    color: rgba(255, 255, 255, 0.75);\n    padding: 0 10px; }\n\n.sd-authoring-page {\n  display: grid;\n  grid-template-columns: [authoringMain] 1fr [authoringSideTabs] auto [publishContainer] 0px;\n  grid-template-rows: [authoringHeader] auto [authoringMainRow] 1fr; }\n\n.sd-authoring-page__header {\n  grid-column: 1/3;\n  grid-row: authoringHeader;\n  display: flex;\n  flex-direction: column; }\n\n.sd-authoring-page__main-container {\n  grid-column: authoringMain;\n  grid-row: authoringMainRow;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  position: relative;\n  min-width: 60rem; }\n\n.sd-authoring-page__side-tabs {\n  grid-column: authoringSideTabs;\n  grid-row: authoringMainRow; }\n\n.sd-authoring-page__publish-container {\n  grid-column: publishContainer;\n  grid-row: 1/-1;\n  position: relative;\n  overflow: visible;\n  width: 0 !important; }\n\n.sd-overlay-panel-2 {\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 0;\n  background: #ededed;\n  color: #333;\n  overflow: hidden;\n  transition: all 0.1s ease-out; }\n  .sd-overlay-panel-2 .side-panel {\n    opacity: 0;\n    transition: all 0s ease-out;\n    transition-delay: 0; }\n  .sd-overlay-panel-2--left {\n    box-shadow: 2px 0px 0px 0px #666666, 2px 0px 12px 0px rgba(0, 0, 0, 0.3);\n    left: 0; }\n  .sd-overlay-panel-2--right {\n    box-shadow: -2px 0px 0px 0px #666666, -2px 0px 12px 0px rgba(0, 0, 0, 0.3);\n    right: 0; }\n  .sd-overlay-panel-2--dark-ui {\n    background-color: #3b3b3b;\n    color: #fff; }\n    .sd-overlay-panel-2--dark-ui.sd-overlay-panel-2--left {\n      box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.3); }\n    .sd-overlay-panel-2--dark-ui.sd-overlay-panel-2--right {\n      box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.3); }\n  .sd-overlay-panel-2--open {\n    width: 32.8rem;\n    overflow: auto; }\n    .sd-overlay-panel-2--open .side-panel {\n      opacity: 1;\n      transition: all 0.2s ease-out;\n      transition-delay: .1s; }\n    .sd-overlay-panel-2--open.sd-overlay-panel--medium {\n      width: 40rem; }\n    .sd-overlay-panel-2--open.sd-overlay-panel--large {\n      width: 68rem; }\n\n.sd-authoring-page__publish-container .sd-overlay-panel,\n.sd-main-content-grid__overlay .sd-overlay-panel {\n  top: 0;\n  bottom: 0;\n  z-index: 10; }\n\n.sd-kanban-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding: 1rem;\n  padding-bottom: 0;\n  height: 100%; }\n  .sd-kanban-list ::-webkit-scrollbar {\n    border-left: 4px solid transparent !important;\n    border-right: 1px solid transparent !important;\n    width: 6px !important;\n    background: transparent !important; }\n  .sd-kanban-list ::-webkit-scrollbar-track {\n    background: transparent !important;\n    border-left: 3px solid transparent !important; }\n    .sd-kanban-list ::-webkit-scrollbar-track:hover {\n      background: rgba(0, 0, 0, 0.05) !important; }\n  .sd-kanban-list ::-webkit-scrollbar-thumb {\n    border-left: 3px solid transparent !important; }\n\n.sd-kanban-list__board {\n  flex: 1 1 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n  margin: 0 1rem;\n  height: 100%;\n  min-width: 20rem; }\n  .sd-kanban-list__board .sd-list-item-group {\n    margin: 0; }\n  .sd-kanban-list__board--wide {\n    min-width: 36rem; }\n\n.sd-kanban-list__board-header {\n  grid-column: 1/2;\n  grid-row: 1/2;\n  z-index: 1;\n  position: relative;\n  min-height: 2rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 4px solid #4d4d4d;\n  padding: 0 0 0.4rem 0;\n  margin: 0 0.1rem; }\n  .sd-kanban-list__board-header .sd-list-header {\n    margin: 0 !important;\n    flex-grow: 1;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 100%; }\n  .sd-kanban-list__board-header .sd-list-header__name {\n    flex-grow: 1; }\n\n.sd-kanban-list__board-content {\n  grid-column: 1/2;\n  grid-row: 2/3;\n  z-index: 1;\n  overflow: auto;\n  padding: 0.6rem 0.3rem 0.6rem 0.3rem; }\n\n[class^=\"--dark-ui\"] .sd-kanban-list__board-header,\n[class*=\"--dark-ui\"] .sd-kanban-list__board-header,\n.dark-ui .sd-kanban-list__board-header {\n  border-bottom: 4px solid #566e77 !important; }\n\n.subnav {\n  position: relative;\n  display: flex;\n  height: 4.8rem;\n  background: #F5F5F5;\n  border-bottom: 0px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 0 0 rgba(0, 0, 0, 0.1);\n  -webkit-transition: all 0.3s ease;\n  -moz-transition: all 0.3s ease;\n  -ms-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  z-index: 3;\n  align-items: center;\n  color: #333;\n  flex-shrink: 0; }\n  .subnav--padded {\n    padding: 10px 20px; }\n  .subnav--darker {\n    background: #dedede; }\n  .subnav--dark-blue-grey {\n    background: #59727d;\n    color: #fff; }\n    .subnav--dark-blue-grey .navbtn:hover {\n      background: rgba(255, 255, 255, 0.2); }\n  .subnav--mid-blue-grey {\n    background: #747c87;\n    color: #fff; }\n  .subnav--absolute {\n    position: absolute;\n    top: 48px;\n    left: 0;\n    right: 0; }\n  .subnav--dark-ui {\n    background: #404040;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 0 0 rgba(0, 0, 0, 0.1);\n    color: #fff; }\n  .subnav + .subnav, .subnav--lower-z-index {\n    z-index: 2 !important; }\n  .subnav .sd-check__group {\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center; }\n\n.subnav__element-grow {\n  flex-grow: 1; }\n\n.subnav__page-title {\n  padding: 1rem 2rem;\n  color: inherit;\n  font-size: 1.8rem;\n  line-height: 2.8rem;\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-weight: 400; }\n  .subnav__page-title--no-grow {\n    flex-grow: 0; }\n\n.subnav__desk-stage {\n  flex-grow: 1; }\n\n.subnav.subnav--level2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  box-shadow: none; }\n\n.subnav__sliding-toolbar {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  padding: 0 16px;\n  color: #333;\n  animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n  background-color: #d2e5ed;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .subnav__sliding-toolbar--right {\n    text-align: right;\n    justify-content: flex-end; }\n  .subnav__sliding-toolbar .sliding-toolbar__inner {\n    flex-grow: 1;\n    display: flex;\n    align-items: center; }\n    .subnav__sliding-toolbar .sliding-toolbar__inner--right {\n      text-align: right; }\n  .subnav__sliding-toolbar .sliding-toolbar__info-text {\n    font-weight: 300;\n    opacity: 0.75; }\n  .subnav__sliding-toolbar .btn + .sliding-toolbar__info-text {\n    margin-left: 1rem; }\n\n.button-stack {\n  height: 4.8rem !important;\n  position: relative;\n  margin: 0 20px 0 0;\n  float: left; }\n  .button-stack > .btn {\n    margin-left: 20px;\n    margin-top: 10px; }\n  .button-stack.right-stack, .button-stack--right {\n    float: right;\n    margin: 0 0 0 5px; }\n    .button-stack.right-stack .navbtn, .button-stack--right .navbtn {\n      border-left: 1px solid rgba(0, 0, 0, 0.1) !important;\n      border-right: 0 !important; }\n    .button-stack.right-stack > .btn, .button-stack--right > .btn {\n      margin-right: 12px;\n      margin-left: 0; }\n\n.navbtn {\n  position: relative;\n  display: inline-block;\n  height: 4.8rem;\n  width: 4.8rem;\n  padding: 0 10px;\n  background: transparent;\n  color: inherit;\n  text-align: center;\n  line-height: 5.6rem;\n  text-decoration: none;\n  border: 0;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .navbtn i {\n    opacity: 0.75;\n    vertical-align: baseline !important;\n    transition: opacity 0.2s ease-out; }\n  .navbtn [class^=\"big-icon--\"],\n  .navbtn [class*=\" big-icon--\"] {\n    line-height: 1;\n    color: currentColor;\n    display: block; }\n  .navbtn .big-icon--send-to {\n    margin-left: 0.3rem; }\n  .navbtn [class^=\"icon-\"],\n  .navbtn [class*=\" icon-\"] {\n    color: currentColor; }\n  .navbtn:hover {\n    background: rgba(255, 255, 255, 0.5); }\n    .navbtn:hover > i {\n      opacity: 1; }\n  .navbtn.navbtn--left {\n    border-left: none;\n    border-right: 1px solid rgba(0, 0, 0, 0.1); }\n  .navbtn.navbtn--blue {\n    background: #5ea9c8;\n    border-left: 1px solid #84bdd5;\n    color: #fff; }\n    .navbtn.navbtn--blue.disabled {\n      background: #898989; }\n  .navbtn.navbtn--text-only {\n    width: auto;\n    line-height: 4.8rem;\n    padding: 0 20px;\n    border-left: none;\n    font-size: 1.5rem; }\n  .navbtn.navbtn--border-r {\n    border-right: 1px solid rgba(0, 0, 0, 0.1) !important; }\n  .navbtn.navbtn--highlighted {\n    background-color: #9c27b0 !important;\n    transition: all 0.3s;\n    padding: 0 0 0 9px;\n    color: #fff; }\n    .navbtn.navbtn--highlighted:hover {\n      background-color: #771e86; }\n  .navbtn.navbtn--darker {\n    background-color: rgba(0, 0, 0, 0.05); }\n  .navbtn.navbtn--active {\n    background-color: #5ea9c8; }\n    .navbtn.navbtn--active > i {\n      opacity: 1;\n      color: #fff; }\n  .navbtn.navbtn--publish {\n    background-color: rgba(0, 0, 0, 0.05); }\n\n.subnav--dark-ui .navbtn:hover {\n  background-color: rgba(255, 255, 255, 0.06); }\n\n.dropdown.open .navbtn {\n  background: white;\n  box-shadow: -2px -1px 5px -2px rgba(0, 0, 0, 0.2), 3px -1px 5px -2px rgba(0, 0, 0, 0.2);\n  z-index: 1001; }\n  .dropdown.open .navbtn > i {\n    opacity: 1;\n    color: #5ea9c8; }\n\n.dropdown.open .sd-create-btn i {\n  color: #fff; }\n\n.subnav__stretch-bar {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  margin: 0 16px;\n  align-items: center; }\n  .subnav__stretch-bar.subnav__stretch-bar--right {\n    text-align: right;\n    justify-content: flex-end; }\n\n.subnav__content-bar {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 0;\n  flex-shrink: 1;\n  margin: 0 16px;\n  align-items: center; }\n  .subnav__content-bar.subnav__content-bar--right {\n    text-align: right;\n    justify-content: flex-end; }\n\n.subnav__spacer {\n  width: 1px;\n  height: 4.8rem;\n  flex-grow: 0;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  margin: auto 2rem; }\n  .subnav__spacer--dotted {\n    border-left: 1px dotted rgba(0, 0, 0, 0.3);\n    height: 2.4rem; }\n  .subnav__spacer--no-r-margin {\n    margin-right: -0.1rem; }\n  .subnav__spacer--no-l-margin {\n    margin-left: 0; }\n  .subnav__spacer--no-margin {\n    margin-left: 0;\n    margin-right: 0; }\n\n.subnav__button-stack {\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center; }\n  .subnav__button-stack--square-buttons {\n    height: 48px;\n    margin: 0 0 0 16px;\n    display: flex;\n    flex-wrap: nowrap;\n    flex-grow: 0;\n    flex-shrink: 1;\n    max-width: 100%; }\n  .subnav__button-stack--custom-buttons {\n    margin: 0 auto;\n    padding: 10px 12px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-width: 0 1px;\n    box-sizing: border-box;\n    display: flex;\n    max-width: 100%; }\n    .subnav__button-stack--custom-buttons .btn {\n      flex-grow: 0;\n      margin: 0 4px; }\n    .subnav__button-stack--custom-buttons .btn__text--short {\n      display: none; }\n    .subnav__button-stack--custom-buttons .btn__text {\n      display: inline; }\n  .subnav__button-stack--right {\n    text-align: right;\n    padding-right: 2rem; }\n  .subnav__button-stack--padded {\n    padding: 0 1rem;\n    flex-shrink: 0; }\n\n.subnav__button-stack--custom-buttons .btn__text--short {\n  display: none; }\n\n.subnav__button-stack--custom-buttons .btn__text {\n  display: inline; }\n\n.compact .subnav__button-stack--custom-buttons .btn__text--short {\n  display: inline; }\n\n.compact .subnav__button-stack--custom-buttons .btn__text {\n  display: none; }\n\n.subnav__button-stack--default {\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-end;\n  padding: 10px 0; }\n  .subnav__button-stack--default .btn {\n    flex-grow: 0;\n    margin: 0 4px; }\n  .subnav__button-stack--default .btn--close .btn__text--alt-icon {\n    display: none; }\n  .subnav__button-stack--default .btn--close .btn__text {\n    display: inline; }\n\n.subnav__button-stack--default.compact .btn--close {\n  padding: 0 3px 0 6px; }\n  .subnav__button-stack--default.compact .btn--close .btn__text--alt-icon {\n    display: inline;\n    opacity: 0.7; }\n  .subnav__button-stack--default.compact .btn--close .btn__text {\n    display: none; }\n\na.text-link {\n  text-decoration: none;\n  color: #3d8fb1;\n  transition: all 0.1s ease-in;\n  display: inline-block;\n  cursor: pointer; }\n  a.text-link:hover {\n    color: #30708b;\n    text-decoration: underline; }\n  a.text-link [class^=\"icon-\"], a.text-link [class*=\" icon-\"] {\n    color: currentColor;\n    vertical-align: middle;\n    margin-right: 0.3rem;\n    position: relative;\n    top: -0.2rem; }\n  a.text-link.text-link--white {\n    color: rgba(255, 255, 255, 0.4); }\n    a.text-link.text-link--white:hover {\n      color: rgba(255, 255, 255, 0.75);\n      text-decoration: none; }\n    a.text-link.text-link--white:active {\n      color: white; }\n\n.subnav--responsive .navbtn.navbtn--text-only {\n  font-size: 1.4rem; }\n\n.subnav--responsive .subnav__stretch-bar {\n  margin-right: 0; }\n\n.subnav--responsive .subnav__spacer {\n  margin-left: 1.2rem; }\n\n.subnav--responsive #planning-dropdown {\n  display: none;\n  margin-left: -1.2rem; }\n\n.subnav--responsive .dropdown__toggle {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-right: 2.6rem !important; }\n  .subnav--responsive .dropdown__toggle .dropdown__caret {\n    position: absolute;\n    top: 50%;\n    right: 1rem; }\n\n.subnav--responsive .navbtn {\n  flex-shrink: 0; }\n\n.subnav--responsive .navbtn.navbtn--text-only {\n  flex-shrink: 1;\n  padding: 0 1.2rem; }\n\n.sd-page-content--slide-in--open .subnav--responsive .sd-check__wrapper + .sd-check__wrapper {\n  margin-left: 0.4rem; }\n\n.sd-page-content--slide-in--open .subnav--responsive .subnav__stretch-bar {\n  margin: 0 1.2rem;\n  margin-right: 0; }\n\n.sd-page-content--slide-in--open .subnav--responsive .subnav__button-stack--padded {\n  padding: 0 0.6rem; }\n\n.sd-page-content--slide-in--open .subnav--responsive .navbtn.navbtn--text-only {\n  font-size: 1.3rem; }\n\n@media only screen and (max-width: 1366px) {\n  .sd-page-content--slide-in--open .sd-page-content__content-block--30-slide {\n    width: 50rem; }\n  .sd-page-content--slide-in--open .sd-page-content__content-block--main {\n    width: calc(100vw - 54.8rem); } }\n\n@media only screen and (max-width: 800px) {\n  .subnav--responsive #planning-dropdown {\n    display: block; }\n  .subnav--responsive #planning-buttons {\n    display: none; }\n  .subnav--responsive .dropdown__toggle {\n    max-width: 160px; }\n  .subnav--responsive.compact--level-1 .dropdown__toggle {\n    max-width: 160px; } }\n\n@media only screen and (max-width: 1024px) {\n  .subnav--responsive.compact--level-1 #planning-dropdown {\n    display: block; }\n  .subnav--responsive.compact--level-1 #planning-buttons {\n    display: none; } }\n\n@media only screen and (max-width: 1480px) {\n  .sd-page-content--slide-in--open .subnav--responsive.compact--level-1 #planning-dropdown {\n    display: block; }\n  .sd-page-content--slide-in--open .subnav--responsive.compact--level-1 #planning-buttons {\n    display: none; } }\n\n@media only screen and (max-width: 1250px) {\n  .sd-page-content--slide-in--open .subnav--responsive #planning-dropdown {\n    display: block; }\n  .sd-page-content--slide-in--open .subnav--responsive #planning-buttons {\n    display: none; }\n  .sd-page-content--slide-in--open .subnav--responsive .dropdown__toggle {\n    max-width: 160px; } }\n\n.sd-page {\n  position: absolute;\n  top: 48px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  overflow: hidden; }\n\n.sd-page__sidebar {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0; }\n\n.sd-page__main-content {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #f8f8f8;\n  display: flex;\n  flex-direction: column; }\n  .sd-page__main-content--double-left-nav {\n    left: 400px; }\n\n.sd-page__sidebar + .sd-page__main-content {\n  left: 200px; }\n\n.sd-page__sidebar + .sd-content-navigation-panel {\n  left: 200px;\n  top: 0;\n  bottom: 0;\n  position: absolute; }\n\n.sd-page__header {\n  height: 48px;\n  flex-shrink: 0;\n  border-bottom: 1px solid #dedede;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 20px;\n  z-index: 2; }\n  .sd-page__header--white {\n    background-color: #fff; }\n  .sd-page__header--justify-space-between {\n    justify-content: space-between; }\n\n.sd-page__element-grow {\n  flex-grow: 1;\n  display: inline-block; }\n  .sd-page__element-grow--x-padding {\n    padding: 0 20px; }\n\n.sd-page__page-heading {\n  font-size: 1.6rem;\n  color: #333;\n  font-weight: 500; }\n\n.sd-page__content {\n  flex-grow: 1;\n  padding: 20px;\n  overflow: auto; }\n\n.sd-page__flex-helper {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  min-height: 0; }\n\n.sd-overlay-panel {\n  z-index: 2;\n  position: absolute;\n  top: 4.8rem;\n  right: 0;\n  bottom: 3rem;\n  width: 0;\n  background-color: #fff;\n  color: #333;\n  box-shadow: -2px 0 12px 0 rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  transition: all 0.1s ease-out; }\n  .sd-overlay-panel .side-panel {\n    opacity: 0;\n    transition: all 0.2s ease-out;\n    transition-delay: .1s; }\n  .sd-overlay-panel--dark-ui {\n    background-color: #3b3b3b;\n    color: #fff; }\n  .sd-overlay-panel--open {\n    width: 40rem;\n    overflow: auto; }\n    .sd-overlay-panel--open .side-panel {\n      opacity: 1; }\n    .sd-overlay-panel--open.sd-overlay-panel--large {\n      width: 68rem; }\n\n.dark-ui .sd-page__content {\n  background-color: #444;\n  color: #fff; }\n\n.sd-list-item {\n  display: flex;\n  position: relative;\n  min-height: 3.8rem;\n  flex-direction: row;\n  background-color: #fff;\n  transition: background-color 0.2s linear; }\n  .sd-list-item:hover {\n    background-color: #f4f4f4;\n    cursor: pointer; }\n  .sd-list-item--active, .sd-list-item.active {\n    background-color: #e3f1f6; }\n  .sd-list-item--selected, .sd-list-item--selected:hover, .sd-list-item.selected, .sd-list-item.selected:hover {\n    background-color: #c8e4ee;\n    outline: 1px solid rgba(94, 169, 200, 0.5); }\n  .sd-list-item--activated, .sd-list-item--activated:hover {\n    background-color: #e3f1f6; }\n  .sd-list-item--no-bg {\n    background-color: transparent; }\n  .sd-list-item--no-hover:hover {\n    background-color: #fff;\n    cursor: default; }\n  .sd-list-item--inactive {\n    background-color: transparent;\n    color: rgba(123, 123, 123, 0.75); }\n  .sd-list-item--draggable:hover {\n    cursor: move;\n    /* fallback if grab is unsupported */\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab; }\n  .sd-list-item--draggable:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing; }\n  .sd-list-item.actioning::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 3;\n    background-image: url(" + escape(__webpack_require__(127)) + ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 45px;\n    background-color: rgba(255, 255, 255, 0.65); }\n  .sd-list-item.locked .sd-list-item__border {\n    background: #E51C23; }\n  .sd-list-item.archived:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 20%;\n    width: 10rem;\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTYiIGhlaWdodD0iMTE2IiB2aWV3Qm94PSIwIDAgMTE2IDExNiI+PHBhdGggZmlsbD0iIzdCN0I3QiIgZD0iTTU4IDBDMjYgMCAwIDI2IDAgNThzMjYgNTggNTggNTggNTgtMjYgNTgtNThTOTAgMCA1OCAwem0zNy4xIDM4LjhMNDYuMyA4Ny42Yy0uNS41LTEuMi41LTEuNyAwTDE4LjkgNjEuOGMtLjUtLjUtLjUtMS4yIDAtMS43bDguMi04LjJjLjUtLjUgMS4yLS41IDEuNyAwTDQ1IDY4LjFjLjMuMy44LjMgMS4xIDBsMzkuMi0zOS4yYy41LS41IDEuMi0uNSAxLjcgMGw4LjIgOC4yYy40LjUuNCAxLjItLjEgMS43eiIvPjwvc3ZnPg==);\n    background-repeat: no-repeat;\n    background-size: 6rem;\n    background-position: center center;\n    opacity: 0.16; }\n  .sd-list-item .avatar {\n    flex-shrink: 0; }\n\n.sd-list-item__border {\n  width: 0.4rem;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background: transparent; }\n  .sd-list-item__border--locked, .sd-list-item__border--error {\n    background: #E51C23; }\n  .sd-list-item__border--success, .sd-list-item__border--active {\n    background: #46a546; }\n  .sd-list-item__border--success, .sd-list-item__border--active {\n    background: #46a546; }\n  .sd-list-item__border--idle {\n    background: #dd8200; }\n  .sd-list-item__border--dark-blue {\n    background: #4d646f; }\n\n.sd-list-item__column {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-right: 1px solid rgba(123, 123, 123, 0.18);\n  padding: 0 0.8rem;\n  overflow: hidden;\n  flex-shrink: 0; }\n  .sd-list-item__column:last-child, .sd-list-item__column:last-of-type, .sd-list-item__column:only-child {\n    border: none; }\n  .sd-list-item__column--no-border {\n    border: none; }\n  .sd-list-item__column--large-padding {\n    padding: 0.8rem 1.6rem; }\n  .sd-list-item__column--no-right-padding {\n    padding-right: 0; }\n  .sd-list-item__column--grow {\n    flex-grow: 1;\n    flex-shrink: 1; }\n  .sd-list-item__column--shrink {\n    flex-shrink: 1; }\n  .sd-list-item__column--has-check {\n    position: relative; }\n    .sd-list-item__column--has-check .sd-list-item__item-type {\n      opacity: 1;\n      margin-top: -0.2rem;\n      transition: opacity 0.1s linear; }\n    .sd-list-item__column--has-check .sd-list-item__checkbox-container {\n      position: absolute;\n      padding: 0 0.8rem;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      z-index: 2;\n      opacity: 0;\n      transition: opacity 0.2s linear; }\n      .sd-list-item__column--has-check .sd-list-item__checkbox-container .sd-check__wrapper {\n        height: 1.6rem;\n        width: 1.6rem; }\n        .sd-list-item__column--has-check .sd-list-item__checkbox-container .sd-check__wrapper .sd-checkbox {\n          display: block; }\n    .sd-list-item__column--has-check:hover .sd-list-item__item-type {\n      opacity: 0; }\n    .sd-list-item__column--has-check:hover .sd-list-item__checkbox-container {\n      opacity: 1; }\n    .sd-list-item__column--has-check.sd-list-item__column--checked .sd-list-item__item-type, .sd-list-item__column--has-check.sd-list-item__column--checked:hover .sd-list-item__item-type {\n      opacity: 0; }\n    .sd-list-item__column--has-check.sd-list-item__column--checked .sd-list-item__checkbox-container, .sd-list-item__column--has-check.sd-list-item__column--checked:hover .sd-list-item__checkbox-container {\n      opacity: 1; }\n\n.sd-list-item__row {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  overflow: hidden; }\n  .sd-list-item__row:first-child {\n    margin: 0.8rem 0 0.2rem; }\n  .sd-list-item__row:last-child {\n    margin: 0.2rem 0 0.8rem; }\n  .sd-list-item__row:only-child {\n    margin: 0.2rem 0; }\n  .sd-list-item__row--only-child {\n    margin: 0.2rem 0 !important; }\n  .sd-list-item__row--wrap {\n    flex-wrap: wrap; }\n\n.sd-list-item__action-menu {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 0;\n  justify-content: center;\n  padding: 0 0.6rem;\n  width: 0;\n  padding: 0;\n  overflow: hidden;\n  opacity: 0;\n  transition: all ease-in 0.1s;\n  align-items: center; }\n  .sd-list-item__action-menu--direction-row {\n    flex-direction: row; }\n  .sd-list-item__action-menu > .dropdown__toggle {\n    line-height: 0; }\n\n.sd-list-item__thumbnail {\n  max-width: 56px;\n  max-height: 42px;\n  margin: .6rem 0; }\n\n.sd-list-item__serial-number {\n  font-size: 2rem;\n  font-weight: 300;\n  color: #999; }\n\n.sd-list-item:hover .sd-list-item__action-menu, .sd-list-item--activated .sd-list-item__action-menu {\n  padding: 0 0.6rem;\n  width: auto;\n  overflow: visible;\n  opacity: 1; }\n\n.sd-list-item--element-grow {\n  flex-grow: 1; }\n\n.sd-list-item .label {\n  margin-right: 0.6rem; }\n\n.sd-list-item .badge {\n  margin: 0.2rem; }\n\n.sd-list-item [class^=\"icon-\"],\n.sd-list-item [class*=\" icon-\"] {\n  opacity: 0.6;\n  vertical-align: middle; }\n\n.sd-list-item time [class^=\"icon-\"],\n.sd-list-item time [class*=\" icon-\"] {\n  vertical-align: top;\n  margin-right: 0.2rem; }\n\n.sd-list-item time {\n  color: #747474;\n  font-size: 1.2rem;\n  letter-spacing: 0.025em;\n  flex-shrink: 0;\n  padding-left: 1em; }\n\n.sd-list-item .sd-list-item__slugline {\n  color: #005b7f;\n  font-weight: 500;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  margin-right: 1rem; }\n\n.sd-list-item .sd-list-item__headline {\n  color: #333;\n  font-weight: 500;\n  font-size: 1.3rem;\n  margin-right: 1rem; }\n\n.sd-list-item .sd-list-item__normal {\n  color: #333;\n  font-weight: 300;\n  margin-right: 1rem; }\n\n.sd-list-item .sd-list-item__strong {\n  color: #333;\n  font-weight: 500;\n  margin-right: 1rem; }\n\n.sd-list-item .sd-list-item__text-label {\n  color: #333;\n  opacity: 0.7;\n  font-weight: 300;\n  font-style: italic;\n  margin-right: 0.3rem; }\n  .sd-list-item .sd-list-item__text-label--normal {\n    font-style: normal; }\n\n.sd-list-item .sd-list-item__inline-icon,\n.sd-list-item .sd-list-item__inline-text {\n  margin-right: 0.6rem; }\n\n.sd-list-item .sd-list-item__text-strong {\n  font-weight: 500;\n  color: #333; }\n\n.sd-list-item .sd-list-item__element-rm-10 {\n  margin-right: 1rem; }\n\n.sd-list-item .sd-list-item__element-lm-10 {\n  margin-left: 1rem; }\n\n.sd-list-item .sd-list-item__location {\n  padding-left: 1.6rem;\n  position: relative; }\n  .sd-list-item .sd-list-item__location::before {\n    position: absolute;\n    left: 0;\n    top: 0.1rem;\n    font-family: 'sd_icons';\n    content: \"\\E602\";\n    display: inline-block;\n    width: 1.4rem;\n    height: 1.4rem;\n    line-height: 1.4rem;\n    font-size: 1.4rem;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    color: rgba(153, 153, 153, 0.8); }\n\n.avatar {\n  display: inline-block;\n  height: 3rem;\n  width: 3rem;\n  background-color: #67afa1;\n  border-radius: 50%;\n  margin-right: 0.6rem;\n  color: #fff;\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 1.2rem;\n  line-height: 3.2rem;\n  letter-spacing: -0.03em;\n  vertical-align: middle; }\n  .avatar--small {\n    height: 2.4rem;\n    width: 2.4rem;\n    font-size: 1rem;\n    line-height: 2.5rem; }\n  .avatar--large {\n    height: 4.8rem;\n    width: 4.8rem;\n    font-size: 1.8rem;\n    line-height: 5rem; }\n  .avatar--no-margin {\n    margin: 0; }\n  .avatar--empty {\n    background-color: rgba(0, 0, 0, 0.1); }\n  .avatar--on-right {\n    margin-right: 0;\n    margin-left: 0.6rem; }\n\n.dropdown__toggle:hover [class^=\"icon-\"],\n.dropdown__toggle:hover [class*=\" icon-\"] {\n  opacity: 1; }\n\n.dropdown__toggle:active [class^=\"icon-\"],\n.dropdown__toggle:active [class*=\" icon-\"] {\n  opacity: 1;\n  color: #5ea9c8; }\n\n.sd-list-item--activated .dropdown__toggle [class^=\"icon-\"],\n.sd-list-item--activated .dropdown__toggle [class*=\" icon-\"] {\n  opacity: 1;\n  color: #5ea9c8; }\n\n.sd-list-item-nested {\n  display: flex;\n  flex-direction: column;\n  margin-top: .8rem; }\n\n.sd-list-item-nested__childs {\n  position: relative;\n  z-index: 0;\n  display: flex;\n  flex-direction: column;\n  margin-left: 1rem;\n  margin-bottom: 0.8rem; }\n  .sd-list-item-nested__childs .sd-list-item {\n    margin-top: 0;\n    border-top: 1px solid #e6e6e6; }\n\n.sd-list-item-nested__parent {\n  position: relative;\n  z-index: 1; }\n\n.sd-list-item-nested--collapsed .sd-list-item-nested__childs {\n  transition: all ease-in 0.2s;\n  max-height: 0;\n  opacity: 0;\n  margin-bottom: 0;\n  overflow: hidden; }\n\n.sd-list-item-nested--expanded .sd-list-item-nested__childs {\n  transition: all ease-in 0.2s;\n  max-height: 114rem;\n  opacity: 1; }\n\n.sd-list-item-group .sd-list-item + .sd-list-item {\n  border-top: 1px solid rgba(123, 123, 123, 0.2); }\n\n.sd-list-item-group--space-between-items .sd-list-item + .sd-list-item {\n  margin-top: .8rem;\n  border-top: none; }\n\n.sd-list-item-group--space-between-items .sd-list-item-nested + .sd-list-item {\n  margin-top: .8rem;\n  border-top: none; }\n\n.sd-list-item-group--space-between-items .sd-list-item-nested__childs .sd-list-item {\n  margin-top: 0;\n  border-top: 1px solid rgba(123, 123, 123, 0.2); }\n\n.sd-list-item-group--margin {\n  margin: 2rem; }\n\n.sd-list-header {\n  display: flex;\n  height: 2rem;\n  margin-bottom: 0.8rem;\n  align-items: center; }\n  .sd-list-header .sd-list-header__name {\n    font-size: 1.1rem;\n    letter-spacing: .08em;\n    font-weight: 500;\n    text-transform: uppercase;\n    color: #666; }\n    .sd-list-header .sd-list-header__name a {\n      color: #5ea9c8;\n      text-decoration: none;\n      display: inline-block;\n      line-height: 1; }\n      .sd-list-header .sd-list-header__name a:hover {\n        color: #3c8eaf;\n        border-bottom: 1px dotted currentColor; }\n  .sd-list-header .sd-list-header__number {\n    margin-left: 1rem; }\n  .sd-list-header .sd-list-header__stretch-bar {\n    flex-grow: 1;\n    height: 1px;\n    background: transparent;\n    margin: auto 0; }\n  .sd-list-header--m-top {\n    margin-top: 2.4rem; }\n\n.dark-ui .sd-list-header .sd-list-header__name {\n  color: rgba(255, 255, 255, 0.4); }\n\n.sd-list-item-group--dark-ui .sd-list-item,\n[class^=\"--dark-ui\"] .sd-list-item,\n[class*=\"--dark-ui\"] .sd-list-item {\n  color: rgba(255, 255, 255, 0.5);\n  background-color: #333; }\n  .sd-list-item-group--dark-ui .sd-list-item:hover,\n  [class^=\"--dark-ui\"] .sd-list-item:hover,\n  [class*=\"--dark-ui\"] .sd-list-item:hover {\n    background-color: #383838; }\n  .sd-list-item-group--dark-ui .sd-list-item [class^=\"icon-\"], .sd-list-item-group--dark-ui .sd-list-item [class*=\" icon-\"],\n  [class^=\"--dark-ui\"] .sd-list-item [class^=\"icon-\"],\n  [class^=\"--dark-ui\"] .sd-list-item [class*=\" icon-\"],\n  [class*=\"--dark-ui\"] .sd-list-item [class^=\"icon-\"],\n  [class*=\"--dark-ui\"] .sd-list-item [class*=\" icon-\"] {\n    color: rgba(255, 255, 255, 0.4); }\n  .sd-list-item-group--dark-ui .sd-list-item .sd-list-item__slugline,\n  [class^=\"--dark-ui\"] .sd-list-item .sd-list-item__slugline,\n  [class*=\"--dark-ui\"] .sd-list-item .sd-list-item__slugline {\n    color: #678b98; }\n  .sd-list-item-group--dark-ui .sd-list-item .sd-list-item__text-strong,\n  [class^=\"--dark-ui\"] .sd-list-item .sd-list-item__text-strong,\n  [class*=\"--dark-ui\"] .sd-list-item .sd-list-item__text-strong {\n    color: #fff; }\n  .sd-list-item-group--dark-ui .sd-list-item .sd-list-item__text-label,\n  [class^=\"--dark-ui\"] .sd-list-item .sd-list-item__text-label,\n  [class*=\"--dark-ui\"] .sd-list-item .sd-list-item__text-label {\n    color: currentColor; }\n  .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--activated,\n  [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--activated,\n  [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--activated {\n    background-color: #35393b;\n    outline: 1px solid rgba(94, 169, 200, 0.2); }\n    .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--activated:hover,\n    [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--activated:hover,\n    [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--activated:hover {\n      background-color: #303436; }\n  .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--selected,\n  [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--selected,\n  [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--selected {\n    background-color: #283237;\n    outline: 1px solid rgba(94, 169, 200, 0.8); }\n    .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--selected:hover,\n    [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--selected:hover,\n    [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--selected:hover {\n      background-color: #242d31; }\n  .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--no-hover:hover,\n  [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--no-hover:hover,\n  [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--no-hover:hover {\n    background-color: #333; }\n  .sd-list-item-group--dark-ui .sd-list-item.sd-list-item--no-bg,\n  [class^=\"--dark-ui\"] .sd-list-item.sd-list-item--no-bg,\n  [class*=\"--dark-ui\"] .sd-list-item.sd-list-item--no-bg {\n    background-color: transparent !important; }\n  .sd-list-item-group--dark-ui .sd-list-item.actioning::before,\n  [class^=\"--dark-ui\"] .sd-list-item.actioning::before,\n  [class*=\"--dark-ui\"] .sd-list-item.actioning::before {\n    background-color: rgba(51, 51, 51, 0.7); }\n\n.sd-list-item-group--dark-ui .sd-shadow--z1,\n[class^=\"--dark-ui\"] .sd-shadow--z1,\n[class*=\"--dark-ui\"] .sd-shadow--z1 {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.36), 0 0 1px rgba(0, 0, 0, 0.8) !important; }\n\n.sd-list-item-group--dark-ui .sd-shadow--z2,\n[class^=\"--dark-ui\"] .sd-shadow--z2,\n[class*=\"--dark-ui\"] .sd-shadow--z2 {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 8px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.06) !important; }\n\n.sd-card {\n  position: relative;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  -ms-border-radius: 2px;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.16);\n  background-color: #fff;\n  color: #333;\n  min-height: 12rem;\n  display: flex;\n  flex-direction: column; }\n  .sd-card--with-click {\n    -webkit-transition: all 100ms ease-in;\n    -moz-transition: all 100ms ease-in;\n    -ms-transition: all 100ms ease-in;\n    -o-transition: all 100ms ease-in;\n    transition: all 100ms ease-in;\n    cursor: pointer; }\n    .sd-card--with-click:hover {\n      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16), 0 2px 8px rgba(0, 0, 0, 0.26); }\n    .sd-card--with-click:active {\n      box-shadow: 0 0 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.16); }\n  .sd-card--flex-grow {\n    flex-grow: 1; }\n  .sd-card--auto-height {\n    min-height: 0; }\n  .sd-card .sd-card__actions {\n    margin: 0.4rem 0.4rem 0 0;\n    visibility: hidden; }\n  .sd-card:hover .sd-card__actions {\n    visibility: visible; }\n  .sd-card .sd-card__actions-group {\n    display: flex;\n    align-items: center;\n    margin-right: .3rem; }\n    .sd-card .sd-card__actions-group a + a {\n      margin-left: .6rem; }\n  .sd-card .sd-card__header {\n    position: relative;\n    flex-grow: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: #607d8b;\n    padding: 0;\n    min-height: 4rem;\n    color: #fff;\n    -webkit-border-radius: 2px 2px 0 0;\n    -moz-border-radius: 2px 2px 0 0;\n    -ms-border-radius: 2px 2px 0 0;\n    border-radius: 2px 2px 0 0; }\n    .sd-card .sd-card__header::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 4px;\n      background-color: rgba(0, 0, 0, 0.2);\n      -webkit-border-radius: 2px 2px 0 0;\n      -moz-border-radius: 2px 2px 0 0;\n      -ms-border-radius: 2px 2px 0 0;\n      border-radius: 2px 2px 0 0; }\n    .sd-card .sd-card__header--empty {\n      height: 8px; }\n    .sd-card .sd-card__header--light {\n      background-color: #bfbfbf; }\n    .sd-card .sd-card__header--white {\n      background-color: #fff;\n      color: #333;\n      box-shadow: 0 1px 0 rgba(136, 136, 136, 0.25); }\n    .sd-card .sd-card__header--with-thumb {\n      position: relative;\n      flex-direction: column; }\n      .sd-card .sd-card__header--with-thumb .sd-card__actions {\n        position: absolute;\n        top: 0.4rem;\n        right: 0;\n        z-index: 2; }\n    .sd-card .sd-card__header--padding {\n      padding: 1rem 0; }\n    .sd-card .sd-card__header--secondary-color {\n      background-color: #747c87; }\n  .sd-card--active .sd-card__header {\n    background-color: #3d8fb1; }\n  .sd-card--inactive .sd-card__header {\n    background-color: #b1b1b1; }\n  .sd-card .sd-card__heading {\n    padding: 0.4rem 1.6rem 0;\n    flex-grow: 1;\n    font-size: 1.2rem;\n    line-height: 100%;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    color: inherit; }\n    .sd-card .sd-card__heading--editable {\n      padding: 1rem 1.6rem 1rem;\n      text-transform: initial; }\n      .sd-card .sd-card__heading--editable:hover {\n        cursor: text; }\n      .sd-card .sd-card__heading--editable > input {\n        margin-top: 6px; }\n  .sd-card .sd-card__sub-header {\n    background-color: #9daeb7;\n    color: #fff;\n    font-size: 1.1rem;\n    font-weight: 400;\n    line-height: 100%;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    padding: 0.6rem 1.6rem; }\n    .sd-card .sd-card__sub-header--success {\n      background-color: #46a546; }\n  .sd-card .sd-card__btn-group {\n    margin: 14px 6px 0 0; }\n    .sd-card .sd-card__btn-group--right {\n      float: right; }\n    .sd-card .sd-card__btn-group .btn {\n      background: transparent;\n      padding: 10px 2px;\n      color: #fff;\n      opacity: 0.4; }\n      .sd-card .sd-card__btn-group .btn:focus, .sd-card .sd-card__btn-group .btn:hover {\n        box-shadow: none;\n        opacity: 1; }\n      .sd-card .sd-card__btn-group .btn [class^=\"icon-\"],\n      .sd-card .sd-card__btn-group .btn [class*=\" icon-\"] {\n        color: #fff; }\n  .sd-card .sd-card__thumbnail {\n    padding-top: 0.4rem;\n    line-height: 0; }\n    .sd-card .sd-card__thumbnail + .sd-card__heading {\n      background-color: #fff;\n      font-weight: 500;\n      text-align: center;\n      color: #333;\n      padding: 1rem 1.6rem;\n      width: 100%;\n      box-shadow: 0 1px 0 rgba(136, 136, 136, 0.25); }\n  .sd-card .sd-card__content {\n    padding: 1.6rem;\n    flex-grow: 1; }\n    .sd-card .sd-card__content h4 {\n      text-transform: uppercase;\n      font-size: 11px;\n      color: rgba(0, 0, 0, 0.5);\n      letter-spacing: 0.04em;\n      margin-bottom: 4px; }\n      .sd-card .sd-card__content h4.with-value {\n        margin-bottom: 0; }\n      .sd-card .sd-card__content h4 .label {\n        float: right;\n        height: 15px;\n        margin: auto 0;\n        padding: 3px 5px 0;\n        border-radius: 8px;\n        color: white;\n        background: rgba(0, 0, 0, 0.25);\n        font-size: 10px;\n        line-height: 100%;\n        letter-spacing: .06em;\n        font-weight: 400; }\n      .sd-card .sd-card__content h4 .value-label {\n        float: right;\n        font-size: 13px;\n        color: #333;\n        font-weight: 400;\n        text-transform: none;\n        letter-spacing: 0em; }\n      .sd-card .sd-card__content h4.sd-card__h4--normal-case {\n        font-size: 12px;\n        text-transform: initial; }\n    .sd-card .sd-card__content--scrollable {\n      min-height: 20vh;\n      max-height: 30vh;\n      overflow-y: auto; }\n    .sd-card .sd-card__content--padd-10 {\n      padding: 1rem; }\n  .sd-card .sd-card__placeholder {\n    padding: 16px;\n    flex-grow: 1;\n    height: calc(100% - 48px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n    font-weight: 300;\n    font-size: 1.2rem; }\n    .sd-card .sd-card__placeholder--cursorPointer {\n      cursor: pointer; }\n  .sd-card .sd-card__content-list {\n    margin: -16px;\n    padding: 0;\n    list-style: none; }\n    .sd-card .sd-card__content-list li, .sd-card .sd-card__content-list .sd-card__content-list-item {\n      padding: 16px;\n      border-bottom: 1px solid #ebebeb; }\n      .sd-card .sd-card__content-list li--inline, .sd-card .sd-card__content-list .sd-card__content-list-item--inline {\n        display: flex; }\n        .sd-card .sd-card__content-list li--inline h4, .sd-card .sd-card__content-list .sd-card__content-list-item--inline h4 {\n          flex: 1 1; }\n        .sd-card .sd-card__content-list li--inline span, .sd-card .sd-card__content-list .sd-card__content-list-item--inline span {\n          flex: 1 1;\n          text-align: right; }\n      .sd-card .sd-card__content-list li .sd-card__content-list-inline-span, .sd-card .sd-card__content-list .sd-card__content-list-item .sd-card__content-list-inline-span {\n        display: inline-block; }\n      .sd-card .sd-card__content-list li:last-child, .sd-card .sd-card__content-list .sd-card__content-list-item:last-child {\n        border: none; }\n      .sd-card .sd-card__content-list li--border-bottom:last-child, .sd-card .sd-card__content-list .sd-card__content-list-item--border-bottom:last-child {\n        border-bottom: 1px solid #ebebeb; }\n      .sd-card .sd-card__content-list li--small, .sd-card .sd-card__content-list .sd-card__content-list-item--small {\n        padding: 7px 16px; }\n        .sd-card .sd-card__content-list li--small h4, .sd-card .sd-card__content-list .sd-card__content-list-item--small h4 {\n          margin: 0; }\n      .sd-card .sd-card__content-list li--no-padding, .sd-card .sd-card__content-list .sd-card__content-list-item--no-padding {\n        padding: 0; }\n    .sd-card .sd-card__content-list .creation-time {\n      display: block;\n      font-size: 12px;\n      color: #999; }\n      .sd-card .sd-card__content-list .creation-time i {\n        display: inline-block;\n        opacity: 0.5;\n        margin-top: -2px; }\n    .sd-card .sd-card__content-list .button__view-all {\n      border-bottom: 1px dotted #5598B4;\n      color: #5598B4;\n      cursor: pointer; }\n    .sd-card .sd-card__content-list .sd-card__content-list-block-link {\n      display: block;\n      padding: .8rem 1.6rem;\n      color: #666;\n      text-decoration: none; }\n      .sd-card .sd-card__content-list .sd-card__content-list-block-link:hover {\n        color: #222; }\n      .sd-card .sd-card__content-list .sd-card__content-list-block-link--icon-hover {\n        display: flex;\n        justify-content: space-between; }\n        .sd-card .sd-card__content-list .sd-card__content-list-block-link--icon-hover i {\n          display: none; }\n        .sd-card .sd-card__content-list .sd-card__content-list-block-link--icon-hover:hover {\n          background-color: rgba(94, 169, 200, 0.15); }\n          .sd-card .sd-card__content-list .sd-card__content-list-block-link--icon-hover:hover i {\n            display: inline-flex; }\n  .sd-card .sd-card__article-header {\n    padding: 16px; }\n  .sd-card .sd-card__time-date {\n    font-size: 11px;\n    color: #ababab;\n    font-weight: 300; }\n    .sd-card .sd-card__time-date--reverse-color {\n      color: rgba(255, 255, 255, 0.6); }\n  .sd-card .sd-card__footer {\n    padding: 0 1.6rem;\n    min-height: 4.7rem;\n    align-items: center;\n    border-top: 1px solid #dedede;\n    background-color: #f8f8f8;\n    display: flex;\n    flex-direction: row;\n    -webkit-border-radius: 0 0 2px 2px;\n    -moz-border-radius: 0 0 2px 2px;\n    -ms-border-radius: 0 0 2px 2px;\n    border-radius: 0 0 2px 2px; }\n    .sd-card .sd-card__footer--light {\n      background-color: #fff; }\n    .sd-card .sd-card__footer--right-align {\n      justify-content: flex-end; }\n    .sd-card .sd-card__footer--spread {\n      justify-content: space-between; }\n  .sd-card .sd-card__full-click {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 2; }\n  .sd-card .sd-card__thumbnail {\n    width: 100%;\n    position: relative;\n    height: 20rem;\n    overflow: hidden;\n    text-align: center; }\n    .sd-card .sd-card__thumbnail img {\n      width: 100%;\n      height: auto; }\n  .sd-card .sd-card__file-type-icn {\n    color: #fff;\n    font-size: 5.2rem;\n    height: 5.2rem;\n    width: 5.2rem;\n    padding-top: 8.5rem;\n    opacity: 0.5; }\n\n.sd-grid-item {\n  position: relative;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  -ms-border-radius: 2px;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.16);\n  background-color: #fff;\n  color: #333;\n  display: flex;\n  flex-direction: column;\n  -webkit-transition: all 100ms ease-in;\n  -moz-transition: all 100ms ease-in;\n  -ms-transition: all 100ms ease-in;\n  -o-transition: all 100ms ease-in;\n  transition: all 100ms ease-in; }\n  .sd-grid-item--with-click {\n    -webkit-transition: all 100ms ease-in;\n    -moz-transition: all 100ms ease-in;\n    -ms-transition: all 100ms ease-in;\n    -o-transition: all 100ms ease-in;\n    transition: all 100ms ease-in;\n    cursor: pointer; }\n    .sd-grid-item--with-click:hover {\n      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.16), 0 2px 8px rgba(0, 0, 0, 0.26);\n      background-color: #fafafa; }\n    .sd-grid-item--with-click:active {\n      box-shadow: 0 0 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.16); }\n  .sd-grid-item--activated, .sd-grid-item--active, .sd-grid-item.active {\n    outline: 1px solid rgba(94, 169, 200, 0.4);\n    background-color: #e3f1f6; }\n    .sd-grid-item--activated:hover, .sd-grid-item--active:hover, .sd-grid-item.active:hover {\n      background-color: #dbedf4; }\n  .sd-grid-item.actioning::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 3;\n    background-image: url(" + escape(__webpack_require__(127)) + ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 60px;\n    background-color: rgba(255, 255, 255, 0.85); }\n  .sd-grid-item--selected, .sd-grid-item.selected {\n    outline: 2px solid #5ea9c8; }\n  .sd-grid-item .sd-grid-item__actions {\n    margin: 0;\n    visibility: hidden; }\n    .sd-grid-item .sd-grid-item__actions--top {\n      position: absolute;\n      top: 0.8rem;\n      right: 0.5rem;\n      z-index: 2; }\n  .sd-grid-item .sd-grid-item__remove {\n    margin: 0;\n    position: absolute;\n    top: 0.3rem;\n    right: 0.3rem;\n    z-index: 2;\n    opacity: 0;\n    height: 2.8rem;\n    width: 2.8rem;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: opacity ease-in-out 0.2; }\n  .sd-grid-item .sd-grid-item__checkbox {\n    visibility: hidden;\n    position: absolute;\n    top: 0.8rem;\n    left: 0.8rem;\n    padding: 0.2rem;\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 2px;\n    z-index: 2;\n    height: 1.6rem;\n    width: 1.6rem;\n    border: 2px solid rgba(255, 255, 255, 0.4);\n    outline: 2px solid rgba(0, 0, 0, 0.25); }\n    .sd-grid-item .sd-grid-item__checkbox .sd-check__wrapper {\n      position: absolute;\n      height: 1.6rem;\n      width: 1.6rem;\n      margin: 0;\n      position: absolute;\n      top: -4px;\n      left: -2px; }\n    .sd-grid-item .sd-grid-item__checkbox > .sd-checkbox {\n      position: absolute;\n      height: 1.6rem;\n      width: 1.6rem;\n      margin: 0;\n      top: -2px;\n      left: -2px; }\n  .sd-grid-item:hover .sd-grid-item__actions,\n  .sd-grid-item:hover .sd-grid-item__checkbox {\n    visibility: visible; }\n  .sd-grid-item:hover .sd-grid-item__remove {\n    opacity: 0.5; }\n    .sd-grid-item:hover .sd-grid-item__remove:hover {\n      opacity: 1; }\n  .sd-grid-item.sd-grid-item--selected .sd-grid-item__checkbox, .sd-grid-item.selected .sd-grid-item__checkbox {\n    visibility: visible; }\n  .sd-grid-item.sd-grid-item--selected:hover .sd-grid-item__checkbox, .sd-grid-item.selected:hover .sd-grid-item__checkbox {\n    visibility: visible; }\n  .sd-grid-item.sd-grid-item--overflow-v {\n    overflow: visible; }\n    .sd-grid-item.sd-grid-item--overflow-v .sd-grid-item__thumb {\n      overflow: visible; }\n  .sd-grid-item .sd-grid-item__thumb {\n    position: relative;\n    flex-grow: 0;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #2c2c2c;\n    padding: 0;\n    min-height: 4rem;\n    color: #fff;\n    -webkit-border-radius: 2px 2px 0 0;\n    -moz-border-radius: 2px 2px 0 0;\n    -ms-border-radius: 2px 2px 0 0;\n    border-radius: 2px 2px 0 0;\n    width: 100%;\n    position: relative;\n    height: 14rem;\n    overflow: hidden;\n    text-align: center; }\n    .sd-grid-item .sd-grid-item__thumb img {\n      max-width: 100%;\n      max-height: 100%;\n      height: auto;\n      margin: auto;\n      pointer-events: none;\n      transition: filter ease-in-out 0.3s; }\n    .sd-grid-item .sd-grid-item__thumb .sd-grid-item__type-icon {\n      margin: auto;\n      height: 4.8rem;\n      width: 4.8rem;\n      font-size: 4.8rem;\n      line-height: 4.8rem;\n      color: currentColor;\n      opacity: 0.25; }\n    .sd-grid-item .sd-grid-item__thumb--white {\n      background-color: #fff;\n      color: #333;\n      box-shadow: 0 1px 0 rgba(136, 136, 136, 0.25); }\n    .sd-grid-item .sd-grid-item__thumb:hover img {\n      filter: brightness(40%); }\n    .sd-grid-item .sd-grid-item__thumb--uploading img {\n      filter: brightness(40%); }\n  .sd-grid-item .sd-grid-item__progress {\n    z-index: 2;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 0.4rem;\n    background-color: rgba(0, 0, 0, 0.4); }\n  .sd-grid-item .sd-grid-item__progress-circle {\n    z-index: 2;\n    position: absolute;\n    height: 5.6rem;\n    width: 5.6rem;\n    top: 50%;\n    margin-top: -2.8rem;\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.3);\n    padding: 0.2rem; }\n  .sd-grid-item .sd-grid-item__progress-bar {\n    display: block;\n    height: 0.4rem;\n    width: 0%;\n    background-color: #46a546;\n    top: 50; }\n  .sd-grid-item .sd-grid-item--element-grow {\n    flex-grow: 1; }\n  .sd-grid-item .sd-grid-item__content-block {\n    flex-grow: 0; }\n  .sd-grid-item .sd-grid-item__content {\n    padding: 1.2rem;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative; }\n    .sd-grid-item .sd-grid-item__content h4 {\n      text-transform: uppercase;\n      font-size: 11px;\n      color: rgba(0, 0, 0, 0.5);\n      letter-spacing: 0.04em;\n      margin-bottom: 4px; }\n      .sd-grid-item .sd-grid-item__content h4.with-value {\n        margin-bottom: 0; }\n      .sd-grid-item .sd-grid-item__content h4 .label {\n        float: right;\n        height: 15px;\n        margin: auto 0;\n        padding: 3px 5px 0;\n        border-radius: 8px;\n        color: white;\n        background: rgba(0, 0, 0, 0.25);\n        font-size: 10px;\n        line-height: 100%;\n        letter-spacing: .06em;\n        font-weight: 400; }\n      .sd-grid-item .sd-grid-item__content h4 .value-label {\n        float: right;\n        font-size: 13px;\n        color: #333;\n        font-weight: 400;\n        text-transform: none;\n        letter-spacing: 0em; }\n      .sd-grid-item .sd-grid-item__content h4.sd-grid-item__h4--normal-case {\n        font-size: 12px;\n        text-transform: initial; }\n    .sd-grid-item .sd-grid-item__content--scrollable {\n      max-height: 20vh;\n      overflow-y: auto; }\n  .sd-grid-item .sd-grid-item__placeholder {\n    padding: 16px;\n    flex-grow: 1;\n    height: calc(100% - 48px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n    font-weight: 300;\n    font-size: 1.2rem; }\n    .sd-grid-item .sd-grid-item__placeholder--cursorPointer {\n      cursor: pointer; }\n  .sd-grid-item .sd-grid-item__article-header {\n    padding: 1.6rem; }\n  .sd-grid-item .sd-grid-item__time-date {\n    font-size: 11px;\n    color: #ababab;\n    font-weight: 300; }\n    .sd-grid-item .sd-grid-item__time-date--reverse-color {\n      color: rgba(255, 255, 255, 0.6); }\n  .sd-grid-item .sd-grid-item__footer {\n    padding: 0.4rem 0.2rem;\n    border-top: 1px solid #dedede8c;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: 3.7rem;\n    flex-shrink: 0;\n    -webkit-border-radius: 0 0 2px 2px;\n    -moz-border-radius: 0 0 2px 2px;\n    -ms-border-radius: 0 0 2px 2px;\n    border-radius: 0 0 2px 2px; }\n    .sd-grid-item .sd-grid-item__footer--light {\n      background-color: #fff; }\n    .sd-grid-item .sd-grid-item__footer--right-align {\n      justify-content: flex-end; }\n    .sd-grid-item .sd-grid-item__footer--spread {\n      justify-content: space-between; }\n    .sd-grid-item .sd-grid-item__footer--padded {\n      padding: 0.4rem 1.2rem; }\n    .sd-grid-item .sd-grid-item__footer .sd-grid-item__footer-block--multi-l {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      padding-left: 0.4rem; }\n    .sd-grid-item .sd-grid-item__footer .sd-grid-item__footer-block--multi-r {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: flex-end;\n      padding-right: 0.4rem; }\n    .sd-grid-item .sd-grid-item__footer .sd-grid-item__footer-block--single-r {\n      flex-grow: 0; }\n    .sd-grid-item .sd-grid-item__footer .sd-grid-item__footer-block-item {\n      margin: 0 0.4rem;\n      flex-shrink: 0; }\n    .sd-grid-item .sd-grid-item__footer time {\n      display: inline-block; }\n  .sd-grid-item .sd-grid-item__full-click {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 2; }\n  .sd-grid-item .sd-grid-item__file-type-icn {\n    color: #fff;\n    font-size: 5.2rem;\n    height: 5.2rem;\n    width: 5.2rem;\n    padding-top: 8.5rem;\n    opacity: 0.5; }\n  .sd-grid-item .sd-grid-item__type-icn {\n    opacity: 0.4; }\n  .sd-grid-item .sd-grid-item__slugline {\n    color: #005b7f;\n    font-weight: 500;\n    font-size: 1.1rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    margin-right: 1rem; }\n  .sd-grid-item .sd-grid-item__title {\n    font-weight: 400;\n    letter-spacing: 0.03em;\n    font-size: 1.4rem;\n    margin-bottom: 1rem; }\n  .sd-grid-item .sd-grid-item__text-light {\n    font-weight: 300;\n    font-size: 1.2rem;\n    letter-spacing: 0.04em;\n    opacity: 0.7; }\n  .sd-grid-item time {\n    display: block;\n    color: #747474;\n    font-size: 1.2rem;\n    letter-spacing: 0.025em;\n    flex-shrink: 0; }\n  .sd-grid-item p {\n    margin-bottom: 1rem; }\n    .sd-grid-item p.error {\n      margin: auto;\n      padding: 1.2rem;\n      opacity: 0.75;\n      color: #E51C23; }\n  .sd-grid-item--small .sd-grid-item__thumb {\n    height: 10rem; }\n  .sd-grid-item .sd-grid-item__state-border {\n    height: 3px;\n    flex-grow: 0;\n    flex-shrink: 0;\n    background: none; }\n  .sd-grid-item.locked .sd-grid-item__state-border, .sd-grid-item--locked .sd-grid-item__state-border {\n    background: #E51C23; }\n  .sd-grid-item.archived .sd-grid-item__content:after, .sd-grid-item--archived .sd-grid-item__content:after {\n    content: \"\";\n    width: 9.2rem;\n    height: 9.2rem;\n    position: absolute;\n    background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTYiIGhlaWdodD0iMTE2IiB2aWV3Qm94PSIwIDAgMTE2IDExNiI+PHBhdGggZmlsbD0iIzdCN0I3QiIgZD0iTTU4IDBDMjYgMCAwIDI2IDAgNThzMjYgNTggNTggNTggNTgtMjYgNTgtNThTOTAgMCA1OCAwem0zNy4xIDM4LjhMNDYuMyA4Ny42Yy0uNS41LTEuMi41LTEuNyAwTDE4LjkgNjEuOGMtLjUtLjUtLjUtMS4yIDAtMS43bDguMi04LjJjLjUtLjUgMS4yLS41IDEuNyAwTDQ1IDY4LjFjLjMuMy44LjMgMS4xIDBsMzkuMi0zOS4yYy41LS41IDEuMi0uNSAxLjcgMGw4LjIgOC4yYy40LjUuNCAxLjItLjEgMS43eiIvPjwvc3ZnPg==) no-repeat;\n    background-size: 11.6rem;\n    background-position: 0 0;\n    bottom: 0;\n    right: 0rem;\n    opacity: 0.14; }\n\n.sd-grid-item__text-label {\n  font-weight: 300;\n  font-style: italic;\n  margin-right: 0.3rem;\n  opacity: 0.7; }\n\n.sd-grid-item__text-strong {\n  font-weight: 400; }\n\n.sd-grid-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));\n  grid-gap: 2rem;\n  margin: 2.4rem; }\n  .sd-grid-list--small {\n    grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));\n    grid-gap: 1.6rem;\n    margin: 2rem; }\n  .sd-grid-list--large {\n    grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr)); }\n  .sd-grid-list--no-rl-margin {\n    margin-left: 0;\n    margin-right: 0; }\n  .sd-grid-list--small-margin {\n    margin: 1rem; }\n  .sd-grid-list--no-margin {\n    margin: 0; }\n\n.dark-ui.sd-column-box__main-column {\n  background-color: #444; }\n\n.dark-ui .sd-column-box__main-column {\n  background-color: #444; }\n\n.dark-ui .sd-grid-item {\n  background-color: #333;\n  color: rgba(255, 255, 255, 0.6);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.6), 0 1px 5px rgba(0, 0, 0, 0.36); }\n  .dark-ui .sd-grid-item .sd-grid-item__thumb {\n    background-color: #212121; }\n  .dark-ui .sd-grid-item .sd-grid-item__footer {\n    border-top: 1px solid rgba(255, 255, 255, 0.03);\n    color: rgba(255, 255, 255, 0.6); }\n  .dark-ui .sd-grid-item .sd-grid-item__content {\n    color: rgba(255, 255, 255, 0.6); }\n  .dark-ui .sd-grid-item .sd-grid-item__slugline {\n    color: #678b98; }\n  .dark-ui .sd-grid-item .sd-grid-item__type-icn {\n    color: #fff; }\n  .dark-ui .sd-grid-item .sd-grid-item__text-label {\n    color: #fff;\n    opacity: 0.4; }\n  .dark-ui .sd-grid-item .sd-grid-item__text-strong {\n    color: #fff;\n    opacity: 0.5; }\n  .dark-ui .sd-grid-item--activated {\n    background-color: #35393b; }\n    .dark-ui .sd-grid-item--activated:hover {\n      background-color: #303436; }\n  .dark-ui .sd-grid-item--with-click:hover {\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.8), 0 1px 10px rgba(0, 0, 0, 0.46);\n    background-color: #383838; }\n  .dark-ui .sd-grid-item--with-click.sd-grid-item--activated:hover {\n    background-color: #303436; }\n  .dark-ui .sd-grid-item--with-click.sd-grid-item--selected, .dark-ui .sd-grid-item--with-click.selected {\n    background-color: #283237; }\n    .dark-ui .sd-grid-item--with-click.sd-grid-item--selected:hover, .dark-ui .sd-grid-item--with-click.selected:hover {\n      background-color: #242d31; }\n  .dark-ui .sd-grid-item--with-click:active {\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.36); }\n  .dark-ui .sd-grid-item.actioning::before {\n    background-color: rgba(51, 51, 51, 0.85); }\n\n.sd-grid-item-wrapper {\n  display: flex;\n  flex-direction: column; }\n\n.sd-grid-item-header {\n  padding: 4px 0;\n  margin-bottom: 6px;\n  border-bottom: 5px solid #4d4d4d;\n  display: flex; }\n  .sd-grid-item-header__heading {\n    color: #222;\n    font-size: 15px;\n    font-weight: 500;\n    flex-grow: 1; }\n    .sd-grid-item-header__heading + div {\n      margin-left: 8px; }\n    .sd-grid-item-header__heading a {\n      text-decoration: none;\n      color: inherit; }\n      .sd-grid-item-header__heading a span {\n        border-bottom: 1px dotted #3d8fb1; }\n      .sd-grid-item-header__heading a [class^=\"icon-\"],\n      .sd-grid-item-header__heading a [class*=\" icon-\"] {\n        color: #3d8fb1;\n        margin-left: 8px; }\n      .sd-grid-item-header__heading a:hover span {\n        border-bottom-style: solid; }\n\n.sd-searchbar {\n  flex-grow: 1;\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  background-color: transparent;\n  transition: background-color 0.2s ease-out;\n  height: 100%;\n  max-height: 4.8rem; }\n  .sd-searchbar--focused {\n    background-color: #fff; }\n  .sd-searchbar--border-r {\n    border-right: 1px solid #dfdfdf; }\n  .sd-searchbar--border-l {\n    border-left: 1px solid #dfdfdf; }\n  .sd-searchbar--border-l-r {\n    border-right: 1px solid #dfdfdf;\n    border-left: 1px solid #dfdfdf; }\n  .sd-searchbar--border-bottom {\n    border-bottom: 1px solid rgba(123, 123, 123, 0.2); }\n  .sd-searchbar--small {\n    height: 3.6rem; }\n\n.sd-searchbar__input, input[type=\"text\"].sd-searchbar__input, input[type=\"search\"].sd-searchbar__input {\n  flex-grow: 1;\n  flex-shrink: 1;\n  font-size: 1.4rem;\n  padding: 0;\n  color: inherit;\n  align-self: auto;\n  background-color: transparent;\n  border: 0;\n  box-shadow: none !important;\n  padding-right: 1rem;\n  height: auto; }\n  .sd-searchbar__input::placeholder, input[type=\"text\"].sd-searchbar__input::placeholder, input[type=\"search\"].sd-searchbar__input::placeholder {\n    color: #999;\n    font-weight: 300;\n    letter-spacing: 0.03rem; }\n\n.sd-searchbar__icon {\n  flex-grow: 0;\n  flex-shrink: 1;\n  align-self: auto;\n  width: 4.8rem;\n  position: relative;\n  opacity: 0.4;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .sd-searchbar__icon::after {\n    content: \"\\E618\";\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    font-family: 'sd_icons';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale; }\n\n.sd-searchbar__search-btn {\n  height: 3rem;\n  width: 3rem;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: center;\n  margin: 0 0.7rem 0 0;\n  padding: 0;\n  opacity: 0.6;\n  transition: all 0.2s ease-out;\n  background-color: rgba(0, 0, 0, 0.08);\n  border-radius: 50%; }\n  .sd-searchbar__search-btn i {\n    margin-top: 0.2rem;\n    transition: color 0.2s ease-out; }\n  .sd-searchbar__search-btn:hover {\n    opacity: 0.8;\n    background-color: rgba(0, 0, 0, 0.1); }\n  .sd-searchbar__search-btn:active {\n    opacity: 1;\n    background-color: rgba(0, 0, 0, 0.12); }\n    .sd-searchbar__search-btn:active i {\n      color: #5ea9c8; }\n\n.sd-searchbar__cancel {\n  height: 1.6rem;\n  width: 1.6rem;\n  align-self: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin: 0 1.2rem 0 0;\n  padding: 0;\n  opacity: 0.35;\n  transition: opacity 0.2s ease-out; }\n  .sd-searchbar__cancel:hover {\n    opacity: 0.7; }\n  .sd-searchbar__cancel:active {\n    opacity: 1; }\n\n.subnav--dark-ui .sd-searchbar--focused {\n  background-color: #4E4E4E; }\n\n.subnav--dark-ui .sd-searchbar__search-btn [class^=\"big-icon--\"],\n.subnav--dark-ui .sd-searchbar__search-btn [class*=\" big-icon--\"] {\n  color: #fff; }\n\n.subnav--dark-ui .sd-searchbar__cancel {\n  color: #fff; }\n  .subnav--dark-ui .sd-searchbar__cancel i {\n    color: #fff; }\n\n.sd-collapse-box {\n  display: flex;\n  flex-direction: column;\n  border-radius: 2px;\n  position: relative;\n  margin-bottom: 1rem; }\n  .sd-collapse-box .sd-collapse-box__header {\n    display: block;\n    flex-grow: 0;\n    position: relative;\n    min-height: 3.8rem;\n    animation: fadeIn 0.3s ease-in 0s 1; }\n  .sd-collapse-box .sd-collapse-box__tools {\n    position: absolute;\n    right: 1rem;\n    top: 0.8rem;\n    z-index: 2;\n    color: #666; }\n    .sd-collapse-box .sd-collapse-box__tools--flex {\n      position: relative;\n      right: 0;\n      top: 0;\n      display: flex;\n      flex-direction: row;\n      margin: -1.4rem -1rem; }\n    .sd-collapse-box .sd-collapse-box__tools .sd-collapse-box__collapse-btn {\n      flex-grow: 1;\n      color: #666; }\n      .sd-collapse-box .sd-collapse-box__tools .sd-collapse-box__collapse-btn:hover .icn-btn {\n        background-color: rgba(155, 155, 155, 0.25);\n        color: #fff;\n        opacity: 1; }\n      .sd-collapse-box .sd-collapse-box__tools .sd-collapse-box__collapse-btn:active .icn-btn {\n        background-color: rgba(155, 155, 155, 0.35);\n        color: #5ea9c8;\n        opacity: 1; }\n  .sd-collapse-box .sd-collapse-box__content-wraper {\n    flex-grow: 1;\n    position: relative;\n    transition: all ease-in-out .4s;\n    max-height: 0; }\n  .sd-collapse-box .sd-collapse-box__content {\n    padding: 2rem;\n    display: none;\n    animation: fadeIn 0.3s ease-in 0s 1; }\n    .sd-collapse-box .sd-collapse-box__content--border-locked {\n      border-left: 4px solid #E51C23; }\n    .sd-collapse-box .sd-collapse-box__content--border-success {\n      border-left: 4px solid #46a546; }\n  .sd-collapse-box .sd-collapse-box__content-block {\n    padding: 1rem;\n    margin: 0 -2rem 3rem -2rem; }\n    .sd-collapse-box .sd-collapse-box__content-block--top {\n      margin-top: 2.2rem;\n      background-color: rgba(0, 0, 0, 0.04); }\n  .sd-collapse-box--open .sd-collapse-box__content-wraper {\n    max-height: 80rem; }\n  .sd-collapse-box--open .sd-collapse-box__content {\n    display: block;\n    animation: fadeIn 0.3s ease-in 0s 1; }\n  .sd-collapse-box--open .sd-collapse-box__header {\n    display: none;\n    animation: fadeIn 0.3s ease-in 0s 1; }\n  .sd-collapse-box--margin-small {\n    margin-bottom: 0.5rem; }\n\n.sd-collapse-box__content .form__row:last-of-type, .sd-collapse-box__content-block .form__row:last-of-type {\n  padding-bottom: 0; }\n\n.sd-collapse-box__sliding-toolbar-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4.6rem;\n  overflow: hidden;\n  border-radius: 2px 2px 0 0; }\n\n.sd-collapse-box__sliding-toolbar {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  top: 0;\n  height: 4.2rem;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  padding: 0 16px;\n  color: #333;\n  animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n  background-color: #d2e5ed;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .sd-collapse-box__sliding-toolbar .sliding-toolbar__inner {\n    flex-grow: 1;\n    display: flex;\n    align-items: center; }\n\n[class^=\"--dark-ui\"] .sd-collapse-box .sd-collapse-box__content-block--top,\n[class*=\"--dark-ui\"] .sd-collapse-box .sd-collapse-box__content-block--top {\n  background-color: rgba(0, 0, 0, 0.14); }\n\n[class^=\"--dark-ui\"] .sd-collapse-box__sliding-toolbar,\n[class*=\"--dark-ui\"] .sd-collapse-box__sliding-toolbar {\n  background-color: #364449; }\n\n[class^=\"--dark-ui\"] .sd-collapse-box--open .sd-collapse-box__content,\n[class*=\"--dark-ui\"] .sd-collapse-box--open .sd-collapse-box__content {\n  background-color: rgba(94, 169, 200, 0.03);\n  box-shadow: 0 0 0 1px rgba(94, 169, 200, 0.3);\n  border-radius: 2px; }\n\n[class^=\"--dark-ui\"] .sd-collapse-box--lighter .sd-list-item,\n[class*=\"--dark-ui\"] .sd-collapse-box--lighter .sd-list-item {\n  background-color: rgba(141, 161, 167, 0.14); }\n\n[class^=\"--dark-ui\"] .sd-collapse-box--lighter.sd-collapse-box--open .sd-collapse-box__content,\n[class*=\"--dark-ui\"] .sd-collapse-box--lighter.sd-collapse-box--open .sd-collapse-box__content {\n  background-color: rgba(141, 161, 167, 0.14); }\n\n.sd-photo-preview {\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr auto;\n  grid-gap: 0;\n  height: 100vh;\n  position: relative;\n  overflow: hidden; }\n  .sd-photo-preview--grid-only {\n    grid-template-rows: 0 1fr; }\n    .sd-photo-preview--grid-only .sd-photo-preview__image {\n      height: 0;\n      overflow: hidden; }\n    .sd-photo-preview--grid-only .sd-photo-preview__thumb-strip {\n      overflow-y: auto; }\n      .sd-photo-preview--grid-only .sd-photo-preview__thumb-strip--with-controls {\n        padding-top: 4.8rem; }\n\n.sd-photo-preview__thumb-controls {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  min-height: 4.8rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);\n  z-index: 2;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  background-color: rgba(32, 32, 32, 0.9);\n  padding: 0 2rem; }\n\n.sd-photo-preview__image {\n  position: relative;\n  grid-column: 1/2;\n  grid-row: 1/2;\n  text-align: center;\n  background-color: #111;\n  max-height: 100%; }\n  .sd-photo-preview__image.actioning::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 999;\n    background-image: url(" + escape(__webpack_require__(127)) + ");\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 60px;\n    background-color: rgba(0, 0, 0, 0.85); }\n\n.sd-photo-preview__image img {\n  max-width: 100%;\n  max-height: 100%;\n  height: auto;\n  margin: auto; }\n\n.sd-photo-preview__thumb-strip {\n  grid-column: 1/2;\n  grid-row: 2/3;\n  min-height: 16rem;\n  background-color: rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.2);\n  position: relative;\n  overflow-y: auto; }\n\n.sd-photo-preview__slide-in-button {\n  position: absolute;\n  top: 2.4rem;\n  right: 0;\n  z-index: 2;\n  background-color: rgba(255, 255, 255, 0.1);\n  height: 4.8rem;\n  width: 4.8rem;\n  color: #fff;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 0 0 1.6rem;\n  border-radius: 6px 0 0 6px;\n  opacity: 0.5;\n  cursor: pointer;\n  text-decoration: none !important;\n  transition: all 0.2s ease-out; }\n  .sd-photo-preview__slide-in-button [class^=\"icon-\"],\n  .sd-photo-preview__slide-in-button [class*=\" icon-\"] {\n    color: #fff;\n    flex-shrink: 0; }\n  .sd-photo-preview__slide-in-button:hover {\n    opacity: 1; }\n  .sd-photo-preview__slide-in-button:active {\n    background-color: #5ea9c8;\n    opacity: 1; }\n\n.sd-photo-preview__nav-button {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 5.6rem;\n  line-height: 5.6rem;\n  position: absolute;\n  top: calc(50% - 2.8rem);\n  width: 5.6rem;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2), 0 10px 28px rgba(0, 0, 0, 0.35);\n  color: #fff;\n  transition: all 0.2s ease-out;\n  background-color: rgba(0, 0, 0, 0.8);\n  opacity: 0.3; }\n  .sd-photo-preview__nav-button:hover {\n    opacity: 0.6;\n    background-color: rgba(0, 0, 0, 0.9); }\n  .sd-photo-preview__nav-button:active {\n    opacity: 0.8;\n    background-color: #5ea9c8; }\n  .sd-photo-preview__nav-button::after {\n    content: \" \";\n    font-family: 'sd_icons';\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: absolute;\n    top: 0;\n    left: 0;\n    text-align: center;\n    z-index: 2;\n    color: #fff;\n    width: 5.6rem;\n    font-size: 3.2rem; }\n  .sd-photo-preview__nav-button--next {\n    right: 0.8rem;\n    color: inherit; }\n    .sd-photo-preview__nav-button--next::after {\n      content: \"\\E643\"; }\n  .sd-photo-preview__nav-button--prev {\n    left: 0.8rem;\n    color: inherit; }\n    .sd-photo-preview__nav-button--prev::after {\n      content: \"\\E642\"; }\n\n.upload__target {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 0;\n  border: 2px dashed #5ea9c8;\n  background-color: rgba(94, 169, 200, 0.1); }\n\n.upload__info {\n  margin: 0 auto;\n  max-width: 40rem;\n  position: relative;\n  top: 50%;\n  margin-top: -10.6rem;\n  z-index: 1; }\n\n.upload__info-icon {\n  margin: 0 auto;\n  height: 7.4rem;\n  width: 9rem;\n  background-image: url(" + escape(__webpack_require__(613)) + ");\n  opacity: 0.25;\n  text-align: center; }\n\n.upload__info-heading {\n  margin: 0 auto;\n  opacity: 0.5;\n  text-align: center;\n  padding-top: 3rem;\n  text-align: center;\n  color: #a0a0a0;\n  font-size: 2.4rem;\n  font-weight: 300; }\n\n.upload__info-label {\n  position: relative;\n  text-align: center;\n  font-style: italic;\n  margin: 2.2rem auto;\n  color: inherit;\n  opacity: 0.5; }\n  .upload__info-label::after, .upload__info-label::before {\n    content: \"___________\";\n    position: absolute;\n    top: -0.5rem;\n    color: inherit;\n    opacity: 0.25; }\n  .upload__info-label::after {\n    margin-left: 1.5rem; }\n  .upload__info-label::before {\n    margin-left: -7.8rem; }\n\n.upload__info-button {\n  display: block;\n  margin: 0 auto;\n  text-align: center;\n  opacity: 0.75; }\n\n.sd-photo-preview__thumb-strip:hover .upload-target {\n  display: block; }\n\n.sd-media-carousel {\n  position: relative;\n  align-items: center;\n  flex-direction: row;\n  display: flex; }\n\n.sd-media-carousel__dialog {\n  display: flex;\n  max-height: 100%;\n  flex: 0 1 auto;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: 900px;\n  width: 100%;\n  position: relative; }\n\n.sd-media-carousel__content {\n  background-clip: padding-box;\n  outline: 0;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25), 0 0 1px 1px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 100%;\n  position: relative; }\n\n.sd-media-carousel__page {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-items: center;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: center; }\n  .sd-media-carousel__page img, .sd-media-carousel__page video {\n    max-height: 40em;\n    width: auto !important;\n    margin: 0 auto !important; }\n\n.sd-media-carousel__page-media {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.12);\n  color: #fff;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: center; }\n  .sd-media-carousel__page-media img {\n    max-width: 100%;\n    max-height: 100%;\n    height: auto;\n    margin: auto; }\n\n.sd-media-carousel__nav-button {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 3.6rem;\n  line-height: 3.6rem;\n  position: absolute;\n  top: calc(50% - 6.5rem);\n  width: 3.6rem;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25), 0 0 1px 1px rgba(0, 0, 0, 0.12);\n  color: #333;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 3;\n  transition: opacity 0.2s ease-out;\n  opacity: 0; }\n  .sd-media-carousel__nav-button:hover {\n    background-color: rgba(255, 255, 255, 0.65); }\n  .sd-media-carousel__nav-button:active {\n    background-color: white; }\n  .sd-media-carousel__nav-button::after {\n    content: \" \";\n    font-family: 'sd_icons';\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    position: absolute;\n    top: 0;\n    text-align: center;\n    z-index: 2;\n    color: inherit;\n    width: 3.6rem;\n    font-size: 2.4rem; }\n  .sd-media-carousel__nav-button--next {\n    right: -18px;\n    color: inherit; }\n    .sd-media-carousel__nav-button--next::after {\n      content: \"\\E643\"; }\n  .sd-media-carousel__nav-button--prev {\n    left: -18px;\n    color: inherit; }\n    .sd-media-carousel__nav-button--prev::after {\n      content: \"\\E642\"; }\n  .sd-media-carousel__nav-button--next-inner {\n    right: 0;\n    color: #333;\n    border-radius: 50% 0 0 50%;\n    box-shadow: none; }\n    .sd-media-carousel__nav-button--next-inner::after {\n      content: \"\\E643\"; }\n  .sd-media-carousel__nav-button--prev-inner {\n    left: 0;\n    color: #333;\n    border-radius: 0 50% 50% 0;\n    box-shadow: none; }\n    .sd-media-carousel__nav-button--prev-inner::after {\n      content: \"\\E642\"; }\n  .sd-media-carousel__nav-button--next-inner::after, .sd-media-carousel__nav-button--prev-inner::after {\n    opacity: 0.5;\n    transition: opacity 0.2s ease-out; }\n  .sd-media-carousel__nav-button--next-inner:hover::after, .sd-media-carousel__nav-button--prev-inner:hover::after {\n    opacity: 1;\n    color: #333; }\n  .sd-media-carousel__nav-button--next-inner:active::after, .sd-media-carousel__nav-button--prev-inner:active::after {\n    color: #5ea9c8; }\n  .sd-media-carousel__nav-button--disabled {\n    background-color: rgba(255, 255, 255, 0.4) !important;\n    cursor: default;\n    opacity: 0.2; }\n    .sd-media-carousel__nav-button--disabled::after {\n      opacity: 0.75;\n      color: #333 !important; }\n\n.sd-media-carousel__dialog:hover .sd-media-carousel__nav-button {\n  opacity: 1; }\n\n.sd-media-carousel__page-indication-bar {\n  bottom: -3.6rem;\n  height: 2.6rem;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.sd-media-carousel__page-indicator {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 1.4rem;\n  width: 1.4rem;\n  margin: 0.6rem;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .sd-media-carousel__page-indicator--selected {\n    background-color: rgba(255, 255, 255, 0.8);\n    border-color: rgba(0, 0, 0, 0.6); }\n\n.sd-media-carousel__thumb-strip {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(9rem, 1fr));\n  grid-gap: 1rem;\n  margin: 1.4rem 0; }\n  .sd-media-carousel__thumb-strip i {\n    margin: auto;\n    color: inherit; }\n\n.sd-media-carousel__thumb-strip-item {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: inherit;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  transition: all ease-in 0.2s; }\n  .sd-media-carousel__thumb-strip-item:hover {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35), 0 0 1px 1px rgba(0, 0, 0, 0.4);\n    border: 1px solid rgba(255, 255, 255, 0.4); }\n  .sd-media-carousel__thumb-strip-item--active {\n    outline: 1px solid #5ea9c8;\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35), 0 0 1px 1px rgba(0, 0, 0, 0.4);\n    cursor: default; }\n    .sd-media-carousel__thumb-strip-item--active .sd-media-carousel__thumb img {\n      filter: brightness(1) grayscale(100%); }\n\n.sd-media-carousel__thumb {\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-direction: column;\n  align-items: center;\n  height: 6rem;\n  padding: 0;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  background-color: #2c2c2c; }\n  .sd-media-carousel__thumb--add {\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    transition: all ease-in 0.2s; }\n    .sd-media-carousel__thumb--add:hover {\n      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35), 0 0 1px 1px rgba(0, 0, 0, 0.4);\n      border: 1px solid white; }\n  .sd-media-carousel__thumb img {\n    max-width: 100%;\n    max-height: 6rem;\n    object-fit: cover;\n    object-position: 50% 50%; }\n  .sd-media-carousel__thumb i {\n    font-size: 3.2rem;\n    line-height: 3.2rem;\n    width: 3.2rem;\n    height: 3.2rem;\n    margin: auto;\n    color: #fff;\n    opacity: .35; }\n\n.sd-media-carousel__media-caption, .sd-media-carousel__media-title {\n  color: inherit;\n  position: relative;\n  padding: 1.2rem;\n  width: 100%;\n  font-size: 1.4rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 140%;\n  border: 1px solid transparent;\n  transition: all ease-in-out 0.2s; }\n  .sd-media-carousel__media-caption[contenteditable=\"true\"]:hover, .sd-media-carousel__media-title[contenteditable=\"true\"]:hover {\n    border-color: rgba(94, 169, 200, 0.4); }\n  .sd-media-carousel__media-caption[contenteditable=\"true\"]:focus, .sd-media-carousel__media-title[contenteditable=\"true\"]:focus {\n    border-color: #5ea9c8;\n    box-shadow: inset 0 -1px 0 0 #5ea9c8; }\n  .sd-media-carousel__media-caption[contenteditable=\"true\"]:empty:before, .sd-media-carousel__media-title[contenteditable=\"true\"]:empty:before {\n    position: absolute;\n    content: attr(sd-placeholder) \" \";\n    opacity: 0.55;\n    color: inherit;\n    font-weight: 300;\n    cursor: text; }\n\n.sd-media-carousel__media-caption {\n  min-height: 4rem; }\n\n.sd-media-carousel__media-title {\n  font-size: 1.5rem;\n  font-weight: 500; }\n\n.sd-editor--theme-blue .sd-media-carousel__content, .sd-editor--theme-dark .sd-media-carousel__content {\n  outline: 1px solid rgba(255, 255, 255, 0.2); }\n\n.editor-popup {\n  display: none;\n  position: fixed; }\n  .editor-popup--open {\n    display: inline-block;\n    z-index: 1040; }\n  .editor-popup--annotation {\n    border-top: 3px solid #a2df56; }\n  .editor-popup--comment {\n    border-top: 3px solid #fff16f; }\n\n.editor-popup__main {\n  display: flex;\n  color: #333;\n  width: 32rem;\n  max-height: 100%; }\n  .editor-popup__main.editor-popup__main--floating {\n    background-color: #fff;\n    z-index: 2;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1); }\n\n.editor-popup__header {\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  padding: 1.6rem;\n  padding-bottom: 1rem; }\n\n.editor-popup__author-name {\n  display: block;\n  margin: 0 0 0.2rem;\n  font-weight: 500;\n  line-height: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.editor-popup__time {\n  font-size: 1.1rem;\n  font-weight: 400; }\n\n.editor-popup__header-text {\n  flex-grow: 1;\n  flex-shrink: 1;\n  overflow: hidden; }\n\n.editor-popup__header-tools {\n  margin: -2rem -1rem 0 0.4rem; }\n  .editor-popup__header-tools .icn-btn {\n    opacity: 0.2; }\n  .editor-popup__header-tools:hover .icn-btn {\n    opacity: 1; }\n\n.editor-popup__content-block {\n  padding: 1.6rem;\n  position: relative; }\n  .editor-popup__content-block--scrollable {\n    max-height: 20rem; }\n  .editor-popup__content-block p + p {\n    margin-top: 1rem; }\n\n.editor-popup__info-bar {\n  margin-bottom: 0.4rem; }\n\n.editor-popup__header + .editor-popup__content-block {\n  padding-top: 0; }\n\n.editor-popup__secondary-content {\n  background-color: rgba(123, 123, 123, 0.1);\n  border-top: 1px solid rgba(123, 123, 123, 0.2); }\n\n.comment-box__reply-item {\n  border-bottom: 1px solid rgba(123, 123, 123, 0.2); }\n\n.comment-box__input {\n  padding: 0.4rem;\n  border-radius: 2px;\n  border: 1px solid rgba(123, 123, 123, 0.4);\n  height: 2.8rem;\n  resize: none; }\n\n.comment-box__reply-toolbar {\n  display: none;\n  padding-top: 1rem; }\n  .comment-box__reply-toolbar--active {\n    display: block; }\n\n.comment-box__button-toolbar {\n  margin-top: 1.2rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start; }\n  .comment-box__button-toolbar--right {\n    justify-content: flex-end; }\n  .comment-box__button-toolbar--small {\n    margin-top: 0.6rem; }\n\n.sd-slider__range, input[type=\"range\"] {\n  width: 100%;\n  position: relative;\n  height: 0.2rem;\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n  background-color: rgba(123, 123, 123, 0.5);\n  cursor: pointer;\n  user-select: none;\n  touch-action: none;\n  border: 0;\n  padding: 0;\n  min-height: 0;\n  -webkit-appearance: none; }\n  .sd-slider__range::-webkit-slider-thumb, input[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 1.6rem;\n    height: 1.6rem;\n    transform: scale(1);\n    border-radius: 50%;\n    background-color: #5ea9c8;\n    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    touch-action: manipulation;\n    cursor: pointer;\n    cursor: -webkit-grab;\n    cursor: grab; }\n    .sd-slider__range::-webkit-slider-thumb:hover, input[type=\"range\"]::-webkit-slider-thumb:hover {\n      background-color: #489dc1; }\n    .sd-slider__range::-webkit-slider-thumb:active, input[type=\"range\"]::-webkit-slider-thumb:active {\n      transform: scale(1.4);\n      cursor: -webkit-grabbing;\n      cursor: grabbing; }\n  .sd-slider__range:focus, input[type=\"range\"]:focus {\n    box-shadow: 0 0 0 1px rgba(123, 123, 123, 0.3); }\n    .sd-slider__range:focus::-webkit-slider-thumb, input[type=\"range\"]:focus::-webkit-slider-thumb {\n      background-color: #489dc1; }\n\n.sd-slider {\n  position: relative;\n  height: 0.2rem;\n  margin-top: 1.25rem;\n  margin-bottom: 2.25rem;\n  background-color: rgba(123, 123, 123, 0.5);\n  cursor: pointer;\n  user-select: none;\n  touch-action: none;\n  -webkit-appearance: none; }\n\n.sd-slider__handle {\n  position: absolute;\n  top: -0.7rem;\n  left: 0;\n  z-index: 1;\n  display: inline-block;\n  width: 1.6rem;\n  height: 1.6rem;\n  transform: scale(1);\n  border-radius: 50%;\n  background-color: #5ea9c8;\n  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  touch-action: manipulation;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab; }\n  .sd-slider__handle:hover {\n    background-color: #489dc1; }\n  .sd-slider__handle:active, .sd-slider__handle--active {\n    transform: scale(1.4);\n    cursor: -webkit-grabbing;\n    cursor: grabbing; }\n\n.sd-slider__focus-ring {\n  position: absolute;\n  top: -1.4rem;\n  left: 0;\n  z-index: 0;\n  margin-left: -0.7rem;\n  display: inline-block;\n  width: 3rem;\n  height: 3rem;\n  transform: scale(0);\n  border-radius: 50%;\n  background-color: rgba(94, 169, 200, 0.3);\n  opacity: 0;\n  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1); }\n  .sd-slider__focus-ring:focus {\n    transform: scale(1);\n    opacity: 1;\n    background-color: #489dc1; }\n\n.sd-slider__fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: inline-block;\n  max-width: 100%;\n  height: 0.2rem;\n  background-color: #5ea9c8;\n  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1); }\n\n.sd-loader {\n  content: '';\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99999;\n  background-image: url(" + escape(__webpack_require__(127)) + ");\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 60px;\n  background-color: rgba(255, 255, 255, 0.85); }\n  .sd-loader.sd-loader--dark-ui {\n    background-color: rgba(51, 51, 51, 0.85) !important; }\n\n.dark-ui .sd-loader,\n[class^=\"--dark-ui\"] .sd-loader,\n[class*=\"--dark-ui\"] .sd-loader {\n  background-color: rgba(51, 51, 51, 0.85); }\n\n.red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.progress-bar-container {\n  display: inline-block;\n  position: relative; }\n  .progress-bar-container .progress-text {\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    font-size: 1.8rem;\n    font-family: arial;\n    color: #666;\n    z-index: 1;\n    line-height: 1; }\n  .progress-bar-container .progress-text em {\n    font-size: 1rem;\n    font-style: normal; }\n\n.progress-svg {\n  width: 20px;\n  height: 20px;\n  transform: rotate(-90deg);\n  display: block; }\n  .progress-svg circle {\n    stroke: rgba(123, 123, 123, 0.4);\n    stroke-width: 2;\n    fill: transparent; }\n  .progress-svg .progressbar {\n    stroke: #46a546;\n    fill: transparent; }\n  .error .progress-svg .progressbar {\n    stroke: transparent !important; }\n\n.progress-done {\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  color: #46a546;\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0 currentColor;\n  transition: box-shadow 0.3s ease-in-out;\n  z-index: 2; }\n  .progress-done i {\n    color: #fff;\n    text-align: center;\n    margin: auto;\n    align-content: center;\n    transform: scale(0);\n    opacity: 0;\n    transition: all .14s ease-in;\n    transition-delay: .2s; }\n  .progress-done.progress-done--completed {\n    box-shadow: inset 0 0 0 50px currentColor; }\n    .progress-done.progress-done--completed i {\n      transform: scale(1);\n      opacity: 1; }\n  .progress-done.progress-done--error {\n    color: #E51C23;\n    box-shadow: inset 0 0 0 50px currentColor; }\n    .progress-done.progress-done--error i {\n      transform: scale(1);\n      opacity: 1; }\n\n.sd-circular-progress--xs .progress-svg {\n  width: 20px;\n  height: 20px; }\n  .sd-circular-progress--xs .progress-svg circle {\n    stroke-width: 2; }\n\n.sd-circular-progress--xs .progress-text {\n  display: none; }\n\n.sd-circular-progress--xs .progress-done {\n  margin: 1px; }\n  .sd-circular-progress--xs .progress-done i {\n    transition-duration: .12s; }\n  .sd-circular-progress--xs .progress-done.progress-done--completed, .sd-circular-progress--xs .progress-done.progress-done--error {\n    box-shadow: inset 0 0 0 10px currentColor; }\n    .sd-circular-progress--xs .progress-done.progress-done--completed i, .sd-circular-progress--xs .progress-done.progress-done--error i {\n      transform: scale(0.8); }\n\n.sd-circular-progress--s .progress-svg {\n  width: 28px;\n  height: 28px; }\n  .sd-circular-progress--s .progress-svg circle {\n    stroke-width: 2; }\n\n.sd-circular-progress--s .progress-text {\n  display: none; }\n\n.sd-circular-progress--s .progress-done {\n  margin: 1px; }\n  .sd-circular-progress--s .progress-done i {\n    transition-duration: .12s; }\n  .sd-circular-progress--s .progress-done.progress-done--completed, .sd-circular-progress--s .progress-done.progress-done--error {\n    box-shadow: inset 0 0 0 16px currentColor; }\n\n.sd-circular-progress--m .progress-svg {\n  width: 52px;\n  height: 52px; }\n  .sd-circular-progress--m .progress-svg circle {\n    stroke-width: 4; }\n\n.sd-circular-progress--m .progress-done {\n  margin: 3px; }\n  .sd-circular-progress--m .progress-done.progress-done--completed, .sd-circular-progress--m .progress-done.progress-done--error {\n    box-shadow: inset 0 0 0 26px currentColor; }\n    .sd-circular-progress--m .progress-done.progress-done--completed i, .sd-circular-progress--m .progress-done.progress-done--error i {\n      transform: scale(1.4); }\n\n.sd-circular-progress--l .progress-svg {\n  width: 68px;\n  height: 68px; }\n  .sd-circular-progress--l .progress-svg circle {\n    stroke-width: 4; }\n\n.sd-circular-progress--l .progress-done {\n  margin: 3px; }\n  .sd-circular-progress--l .progress-done.progress-done--completed i, .sd-circular-progress--l .progress-done.progress-done--error i {\n    transform: scale(2); }\n\n.sd-circular-progress--xl .progress-svg {\n  width: 102px;\n  height: 102px; }\n  .sd-circular-progress--xl .progress-svg circle {\n    stroke-width: 6; }\n\n.sd-circular-progress--xl .progress-done {\n  margin: 5px; }\n  .sd-circular-progress--xl .progress-done.progress-done--completed i, .sd-circular-progress--xl .progress-done.progress-done--error i {\n    transform: scale(2.4); }\n\n.sd-toast__container {\n  display: flex !important;\n  flex-direction: column;\n  align-items: center;\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: 40;\n  overflow: hidden;\n  padding: 0 20px 20px;\n  pointer-events: none; }\n  .sd-toast__container.sd-toast__container--top {\n    top: 0;\n    bottom: auto; }\n  .sd-toast__container.sd-toast__container--bottom {\n    flex-direction: column-reverse;\n    top: auto;\n    bottom: 0; }\n  .sd-toast__container.sd-toast__container--left {\n    align-items: flex-start; }\n  .sd-toast__container.sd-toast__container--right {\n    align-items: flex-end; }\n\n.sd-toast {\n  display: flex;\n  align-items: flex-start;\n  position: relative !important;\n  margin: 2rem 0 0;\n  padding: 1.2rem;\n  border-radius: 3px;\n  overflow: hidden;\n  box-shadow: 0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2);\n  background-color: #fff;\n  min-width: 32rem;\n  max-width: 56rem;\n  pointer-events: all; }\n  .sd-toast--appear, .sd-toast--enter {\n    transform: translateY(-40px); }\n  .sd-toast--appear-active, .sd-toast--enter-active {\n    transform: translateY(0);\n    transition: transform cubic-bezier(0.54, 1.12, 0.38, 1.11) 0.3s;\n    transition-delay: 0; }\n  .sd-toast.sd-toast--appear ~ .sd-toast,\n  .sd-toast.sd-toast--enter ~ .sd-toast {\n    transform: translateY(-40px); }\n  .sd-toast .sd-toast__icon [class^=\"icon-\"] {\n    color: inherit;\n    display: block;\n    margin: 0.6rem 0.4rem 0.6rem 0.6rem; }\n  .sd-toast.sd-toast--default::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #333; }\n  .sd-toast.sd-toast--default .sd-toast__icon {\n    color: #333; }\n  .sd-toast.sd-toast--primary::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #5ea9c8; }\n  .sd-toast.sd-toast--primary .sd-toast__icon {\n    color: #5ea9c8; }\n  .sd-toast.sd-toast--success::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #46a546; }\n  .sd-toast.sd-toast--success .sd-toast__icon {\n    color: #46a546; }\n  .sd-toast.sd-toast--warning::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #dd8200; }\n  .sd-toast.sd-toast--warning .sd-toast__icon {\n    color: #dd8200; }\n  .sd-toast.sd-toast--alert::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #E51C23; }\n  .sd-toast.sd-toast--alert .sd-toast__icon {\n    color: #E51C23; }\n  .sd-toast.sd-toast--highlight::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #9c27b0; }\n  .sd-toast.sd-toast--highlight .sd-toast__icon {\n    color: #9c27b0; }\n  .sd-toast.sd-toast--sd-green::before {\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    background-color: #1eb06c; }\n  .sd-toast.sd-toast--sd-green .sd-toast__icon {\n    color: #1eb06c; }\n  .sd-toast.sd-toast--fixed-s {\n    width: 32rem; }\n  .sd-toast.sd-toast--fixed-m {\n    width: 40rem; }\n  .sd-toast.sd-toast--fixed-l {\n    width: 48rem; }\n  .sd-toast.sd-toast--fixed-xl {\n    width: 56rem; }\n\n.sd-toast__message {\n  flex: 1 1 auto;\n  padding: 0.4rem 1rem 0.4rem 1rem;\n  font-size: 1.4rem;\n  line-height: 150%;\n  color: #747474; }\n  .sd-toast__message p + p {\n    margin-top: 0.8rem; }\n\n.sd-toast__message-header {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 0.2rem; }\n  .sd-toast__message-header time {\n    font-size: 1.2rem;\n    color: #999;\n    margin-right: 0.2rem; }\n  .sd-toast__message-header .sd-toast__heading {\n    flex-grow: 1; }\n\n.sd-toast__heading, h4 {\n  font-size: inherit;\n  font-weight: 600; }\n\n.sd-toast__actions {\n  flex: 0 0 auto;\n  opacity: 0.4; }\n\n.sd-toast__icon {\n  flex: 0 0 auto; }\n\n.sd-toast__avatar {\n  flex: 0 0 auto;\n  margin: 0.6rem 0.4rem 0.6rem 0.6rem; }\n\n.sd-toast__container--bottom .sd-toast.sd-toast--enter:not(.sd-toast--enter-active),\n.sd-toast__container--bottom .sd-toast.sd-toast--enter:not(.sd-toast--enter-active) ~ .sd-toast,\n.sd-toast__container--bottom .sd-toast.sd-toast--leave-active ~ .sd-toast {\n  transform: translateY(6rem); }\n\n.form__row {\n  width: 100%;\n  padding-bottom: 2rem; }\n  .form__row--flex {\n    display: flex;\n    align-items: baseline; }\n  .form__row--no-padding {\n    padding-bottom: 0; }\n  .form__row--small-padding, .form__row--s-padding {\n    padding-bottom: 0.8rem; }\n  .form__row--l-padding {\n    padding-bottom: 3rem; }\n  .form__row--xl-padding {\n    padding-bottom: 4rem; }\n  .form__row--inner {\n    padding-bottom: 0;\n    padding-top: 1rem; }\n  .form__row--bordered {\n    padding: 1rem 0;\n    border-bottom: 1px solid rgba(123, 123, 123, 0.3); }\n    .form__row--bordered:first-child, .form__row--bordered:only-child {\n      border-top: 1px solid rgba(123, 123, 123, 0.3); }\n\n.form__row--flex .sd-line-input {\n  flex-grow: 1; }\n\n.form__row--flex .sd-line-input + .btn {\n  flex-grow: 0;\n  vertical-align: bottom;\n  margin: 0 0 0 1.2rem; }\n\n.form__row--flex .sd-line-input + .sd-line-input {\n  margin-left: 1.2rem; }\n\n.form__row--flex .form__row-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  margin: 0 0.6rem; }\n  .form__row--flex .form__row-item:first-child {\n    margin-left: 0; }\n  .form__row--flex .form__row-item:last-child {\n    margin-right: 0; }\n  .form__row--flex .form__row-item:only-child {\n    margin: 0; }\n  .form__row--flex .form__row-item--no-grow {\n    flex-basis: auto;\n    flex-grow: 0; }\n\n.form__row label,\n.form__row-item label {\n  vertical-align: middle;\n  line-height: 100%;\n  margin-right: 0.6rem;\n  -webkit-transition: color 0.15s ease-in;\n  -moz-transition: color 0.15s ease-in;\n  -ms-transition: color 0.15s ease-in;\n  -o-transition: color 0.15s ease-in;\n  transition: color 0.15s ease-in; }\n  .form__row label.form__row-label.form-label,\n  .form__row-item label.form__row-label.form-label {\n    display: block;\n    width: 100%;\n    margin-bottom: 1rem;\n    margin-right: 0; }\n  .form__row label + div,\n  .form__row-item label + div {\n    margin-top: .4rem; }\n    .form__row label + div .label,\n    .form__row-item label + div .label {\n      margin-bottom: .3rem; }\n\n.label--active {\n  color: #479dc0; }\n\n.form__block {\n  display: block;\n  margin-bottom: 1rem;\n  padding: 2rem;\n  border-radius: 2px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .form__block--light {\n    background-color: #fff;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n\n.form__heading {\n  font-size: 1.6rem;\n  padding-bottom: 1.2rem;\n  line-height: 120%; }\n\n.form-label {\n  display: inline-block;\n  font-size: 1.1rem;\n  margin: 0 0.5rem 0 0;\n  line-height: 2.6rem;\n  color: #747474;\n  text-transform: uppercase;\n  font-weight: 500;\n  letter-spacing: 0.08em;\n  min-width: 75px; }\n  .form-label--light {\n    color: #999;\n    font-weight: 400; }\n  .form-label--marg-b10 {\n    margin-bottom: 10px; }\n  .form-label--block {\n    display: block; }\n  .form-label--required {\n    position: relative; }\n    .form-label--required::after {\n      color: #E51C23;\n      content: \"*\";\n      vertical-align: top;\n      font-size: 1.2rem;\n      padding-left: 0.3rem; }\n\n.form-label__container {\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  .form-label__container .form-label {\n    flex-grow: 1; }\n\n.form-label__info-block {\n  color: inherit;\n  font-size: 1.2rem;\n  text-align: right;\n  font-weight: 300; }\n\n.sd-line-input {\n  margin: 0 0 1.8em 0;\n  padding-top: 1.4rem;\n  position: relative; }\n  .sd-line-input--flex-row {\n    display: inline-flex;\n    align-items: center;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    width: 100%; }\n  .sd-line-input__value {\n    margin-right: 6px;\n    text-transform: uppercase; }\n  .sd-line-input input.sd-line-input__input, .sd-line-input textarea.sd-line-input__input {\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0;\n    border: 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    background-color: transparent;\n    padding: 0;\n    font-size: 1.4rem;\n    height: 2.4rem;\n    transition: border linear 0.2s, box-shadow linear 0.2s; }\n    .sd-line-input input.sd-line-input__input:hover, .sd-line-input textarea.sd-line-input__input:hover {\n      border-color: rgba(0, 0, 0, 0.3);\n      background-color: transparent; }\n    .sd-line-input input.sd-line-input__input:focus, .sd-line-input textarea.sd-line-input__input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8;\n      background-color: transparent; }\n    .sd-line-input input.sd-line-input__input--center, .sd-line-input textarea.sd-line-input__input--center {\n      text-align: center; }\n  .sd-line-input input.sd-line-input__color, .sd-line-input textarea.sd-line-input__color {\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0;\n    border: 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    background-color: transparent;\n    padding: 0;\n    font-size: 1.4rem;\n    height: 2.4rem;\n    transition: border linear 0.2s, box-shadow linear 0.2s;\n    width: 26px;\n    height: 26px;\n    border: none;\n    outline: none; }\n    .sd-line-input input.sd-line-input__color:hover, .sd-line-input textarea.sd-line-input__color:hover {\n      border-color: rgba(0, 0, 0, 0.3);\n      background-color: transparent; }\n    .sd-line-input input.sd-line-input__color:focus, .sd-line-input textarea.sd-line-input__color:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8;\n      background-color: transparent; }\n    .sd-line-input input.sd-line-input__color ::-webkit-color-swatch, .sd-line-input textarea.sd-line-input__color ::-webkit-color-swatch {\n      border: none;\n      outline: none;\n      -webkit-appearance: none; }\n    .sd-line-input input.sd-line-input__color ::-webkit-color-swatch-wrapper, .sd-line-input textarea.sd-line-input__color ::-webkit-color-swatch-wrapper {\n      padding: 0; }\n  .sd-line-input input[type=\"file\"].sd-line-input__input {\n    height: 3rem;\n    padding-top: 0.6rem;\n    font-size: 1.3rem; }\n    .sd-line-input input[type=\"file\"].sd-line-input__input:focus {\n      outline: none; }\n  .sd-line-input select {\n    cursor: pointer; }\n    .sd-line-input select.sd-line-input__select {\n      width: 100%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-radius: 0;\n      border: 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n      background-color: transparent;\n      padding: 0;\n      font-size: 1.4rem;\n      height: 2.4rem;\n      transition: border linear 0.2s, box-shadow linear 0.2s;\n      display: block;\n      position: relative;\n      z-index: 2; }\n      .sd-line-input select.sd-line-input__select:hover {\n        border-color: rgba(0, 0, 0, 0.3);\n        background-color: transparent; }\n      .sd-line-input select.sd-line-input__select:focus {\n        box-shadow: 0 1px 0 0 #5ea9c8;\n        border-color: #5ea9c8;\n        background-color: transparent; }\n      .sd-line-input select.sd-line-input__select option {\n        color: #333;\n        font-size: 1.4rem;\n        line-height: 2rem; }\n  .sd-line-input textarea.sd-line-input__input {\n    padding-top: 3px;\n    display: block; }\n  .sd-line-input .sd-line-input__info-left, .sd-line-input .sd-line-input__info-right {\n    position: absolute;\n    top: 2.5rem;\n    opacity: 0.3;\n    font-size: 1.5rem;\n    font-weight: 300; }\n  .sd-line-input .sd-line-input__info-right {\n    right: 0.8rem; }\n  .sd-line-input .sd-line-input__info-left {\n    left: 0.8rem; }\n  .sd-line-input .sd-line-input__icon-left, .sd-line-input .sd-line-input__icon-right {\n    position: absolute;\n    top: 0.8rem;\n    cursor: pointer; }\n  .sd-line-input .sd-line-input__icon-right {\n    right: 0; }\n  .sd-line-input .sd-line-input__icon-left {\n    left: 0; }\n  .sd-line-input--boxed {\n    padding-top: 1.8rem; }\n    .sd-line-input--boxed input.sd-line-input__input, .sd-line-input--boxed textarea.sd-line-input__input {\n      width: 100%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-radius: 0;\n      border: 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n      background-color: transparent;\n      padding: 0;\n      font-size: 1.4rem;\n      height: 2.4rem;\n      transition: border linear 0.2s, box-shadow linear 0.2s;\n      border-radius: 2px;\n      background-color: rgba(0, 0, 0, 0.05);\n      padding: 0 1rem;\n      height: 3.2rem;\n      transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n      .sd-line-input--boxed input.sd-line-input__input:hover, .sd-line-input--boxed textarea.sd-line-input__input:hover {\n        border-color: rgba(0, 0, 0, 0.3);\n        background-color: transparent; }\n      .sd-line-input--boxed input.sd-line-input__input:focus, .sd-line-input--boxed textarea.sd-line-input__input:focus {\n        box-shadow: 0 1px 0 0 #5ea9c8;\n        border-color: #5ea9c8;\n        background-color: transparent; }\n      .sd-line-input--boxed input.sd-line-input__input:hover, .sd-line-input--boxed textarea.sd-line-input__input:hover {\n        background-color: rgba(0, 0, 0, 0.1); }\n      .sd-line-input--boxed input.sd-line-input__input:focus, .sd-line-input--boxed textarea.sd-line-input__input:focus {\n        background-color: rgba(0, 0, 0, 0.05); }\n    .sd-line-input--boxed textarea.sd-line-input__input {\n      padding-top: 0.6rem; }\n    .sd-line-input--boxed select.sd-line-input__select {\n      width: 100%;\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      appearance: none;\n      border-radius: 0;\n      border: 0;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n      background-color: transparent;\n      padding: 0;\n      font-size: 1.4rem;\n      height: 2.4rem;\n      transition: border linear 0.2s, box-shadow linear 0.2s;\n      border-radius: 2px;\n      background-color: rgba(0, 0, 0, 0.05);\n      padding: 0 1rem;\n      height: 3.2rem;\n      transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n      .sd-line-input--boxed select.sd-line-input__select:hover {\n        border-color: rgba(0, 0, 0, 0.3);\n        background-color: transparent; }\n      .sd-line-input--boxed select.sd-line-input__select:focus {\n        box-shadow: 0 1px 0 0 #5ea9c8;\n        border-color: #5ea9c8;\n        background-color: transparent; }\n      .sd-line-input--boxed select.sd-line-input__select:hover {\n        background-color: rgba(0, 0, 0, 0.1); }\n      .sd-line-input--boxed select.sd-line-input__select:focus {\n        background-color: rgba(0, 0, 0, 0.05); }\n    .sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input, .sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input {\n      background-color: rgba(0, 0, 0, 0.03);\n      border-bottom: 1px dotted #999 !important; }\n    .sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select, .sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover {\n      background-color: rgba(0, 0, 0, 0.03);\n      border-bottom: 1px dotted #999 !important; }\n    .sd-line-input--boxed .sd-line-input__icon-right, .sd-line-input--boxed .sd-line-input__icon-left {\n      top: 1.6rem; }\n    .sd-line-input--boxed .sd-line-input__icon-left {\n      left: 0.2rem; }\n    .sd-line-input--boxed .sd-line-input__icon-right {\n      right: 0.2rem; }\n  .sd-line-input.sd-line-input--indent-l30 input.sd-line-input__input, .sd-line-input.sd-line-input--indent-l30 textarea.sd-line-input__input {\n    padding-left: 3rem; }\n  .sd-line-input.sd-line-input--indent-r30 input.sd-line-input__input, .sd-line-input.sd-line-input--indent-r30 textarea.sd-line-input__input {\n    padding-right: 3rem; }\n  .sd-line-input .sd-line-input__label {\n    display: inline-block;\n    font-size: 1.1rem;\n    margin: 0 0.5rem 0 0;\n    line-height: 2.6rem;\n    color: #747474;\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: 0.08em;\n    position: absolute;\n    line-height: 100%;\n    margin: 0;\n    top: 0; }\n    .sd-line-input .sd-line-input__label--required::after {\n      color: #E51C23;\n      content: \"*\";\n      vertical-align: top;\n      font-size: 1.2rem;\n      padding-left: 0.3rem; }\n  .sd-line-input .sd-line-input__hint,\n  .sd-line-input .sd-line-input__message,\n  .sd-line-input .sd-line-input__char-count {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\n    color: grey;\n    font-weight: 300;\n    letter-spacing: 0.03em; }\n  .sd-line-input .sd-line-input__hint {\n    position: absolute;\n    left: 1px;\n    right: auto;\n    padding-right: 5.5rem;\n    margin-top: 0.4rem; }\n  .sd-line-input .sd-line-input__char-count {\n    position: absolute;\n    right: 1px;\n    left: auto;\n    margin-top: 0.5rem;\n    font-size: 1.1rem;\n    font-weight: 400;\n    font-style: italic; }\n  .sd-line-input .sd-line-input__message {\n    padding-top: 0.4rem; }\n  .sd-line-input.sd-line-input--invalid .sd-line-input__label,\n  .sd-line-input.sd-line-input--invalid .sd-line-input__message {\n    color: #E51C23; }\n  .sd-line-input.sd-line-input--invalid input.sd-line-input__input, .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input {\n    border-color: #E51C23; }\n    .sd-line-input.sd-line-input--invalid input.sd-line-input__input:focus, .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input:focus {\n      box-shadow: 0 1px 0 0 #E51C23; }\n  .sd-line-input.sd-line-input--invalid select.sd-line-input__select {\n    border-color: #E51C23; }\n    .sd-line-input.sd-line-input--invalid select.sd-line-input__select:focus {\n      box-shadow: 0 1px 0 0 #E51C23; }\n  .sd-line-input.sd-line-input--disabled input.sd-line-input__input, .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input {\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.15);\n    cursor: not-allowed; }\n  .sd-line-input.sd-line-input--disabled select.sd-line-input__select {\n    border-bottom: 1px dotted rgba(0, 0, 0, 0.15);\n    cursor: not-allowed; }\n  .sd-line-input.sd-line-input--is-select::after {\n    position: absolute;\n    top: 2.6rem;\n    right: 0.4rem;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    border-left: 0.4rem solid transparent;\n    border-right: 0.4rem solid transparent;\n    border-top: 0.4rem solid #000;\n    opacity: 0.3;\n    filter: \"alpha(opacity=30)\";\n    content: \"\";\n    z-index: 0; }\n  .sd-line-input.sd-line-input--is-select:hover::after {\n    opacity: 0.6;\n    filter: \"alpha(opacity=60)\"; }\n  .sd-line-input.sd-line-input--is-select.sd-line-input--disabled:hover::after {\n    opacity: 0.3;\n    filter: \"alpha(opacity=30)\"; }\n  .sd-line-input.sd-line-input--is-select.sd-line-input--boxed::after {\n    top: 3.2rem;\n    right: 0.8rem; }\n  .sd-line-input.sd-line-input--is-select.sd-line-input--no-label::after {\n    top: 1.2rem; }\n  .sd-line-input.sd-line-input--is-select.sd-line-input--no-label.sd-line-input--boxed::after {\n    top: 1.4rem; }\n  .sd-line-input.sd-line-input--is-color .sd-line-input__label {\n    line-height: 140%; }\n  .sd-line-input--dark-ui input.sd-line-input__input, .sd-line-input--dark-ui textarea.sd-line-input__input, .sd-line-input--dark-ui textarea.sd-line-input__input {\n    border-bottom-color: rgba(255, 255, 255, 0.2);\n    color: rgba(255, 255, 255, 0.8); }\n    .sd-line-input--dark-ui input.sd-line-input__input:hover, .sd-line-input--dark-ui textarea.sd-line-input__input:hover, .sd-line-input--dark-ui textarea.sd-line-input__input:hover {\n      border-bottom-color: rgba(255, 255, 255, 0.4); }\n    .sd-line-input--dark-ui input.sd-line-input__input:focus, .sd-line-input--dark-ui textarea.sd-line-input__input:focus, .sd-line-input--dark-ui textarea.sd-line-input__input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n  .sd-line-input--dark-ui select.sd-line-input__select {\n    border-bottom-color: rgba(255, 255, 255, 0.2);\n    color: rgba(255, 255, 255, 0.8); }\n    .sd-line-input--dark-ui select.sd-line-input__select:hover {\n      border-bottom-color: rgba(255, 255, 255, 0.4); }\n    .sd-line-input--dark-ui select.sd-line-input__select:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n  .sd-line-input--dark-ui .sd-line-input__label {\n    color: rgba(255, 255, 255, 0.4); }\n  .sd-line-input--dark-ui.sd-line-input--disabled input.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--disabled textarea.sd-line-input__input {\n    border-bottom: 1px dotted rgba(255, 255, 255, 0.2); }\n    .sd-line-input--dark-ui.sd-line-input--disabled input.sd-line-input__input:focus, .sd-line-input--dark-ui.sd-line-input--disabled input.sd-line-input__input:hover, .sd-line-input--dark-ui.sd-line-input--disabled textarea.sd-line-input__input:focus, .sd-line-input--dark-ui.sd-line-input--disabled textarea.sd-line-input__input:hover {\n      border-bottom: 1px dotted rgba(255, 255, 255, 0.2);\n      box-shadow: none; }\n  .sd-line-input--dark-ui.sd-line-input--disabled select.sd-line-input__select {\n    border-bottom: 1px dotted rgba(255, 255, 255, 0.2); }\n    .sd-line-input--dark-ui.sd-line-input--disabled select.sd-line-input__select:focus, .sd-line-input--dark-ui.sd-line-input--disabled select.sd-line-input__select:hover {\n      border-bottom: 1px dotted rgba(255, 255, 255, 0.2);\n      box-shadow: none; }\n  .sd-line-input--dark-ui.sd-line-input--boxed input.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--boxed textarea.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--boxed textarea.sd-line-input__input {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .sd-line-input--dark-ui.sd-line-input--boxed input:hover, .sd-line-input--dark-ui.sd-line-input--boxed textarea:hover, .sd-line-input--dark-ui.sd-line-input--boxed textarea:hover {\n    background-color: rgba(255, 255, 255, 0.1); }\n  .sd-line-input--dark-ui.sd-line-input--boxed input:focus, .sd-line-input--dark-ui.sd-line-input--boxed textarea:focus, .sd-line-input--dark-ui.sd-line-input--boxed textarea:focus {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .sd-line-input--dark-ui.sd-line-input--boxed select.sd-line-input__select {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .sd-line-input--dark-ui.sd-line-input--boxed select:hover {\n    background-color: rgba(255, 255, 255, 0.1); }\n  .sd-line-input--dark-ui.sd-line-input--boxed select:focus {\n    background-color: rgba(255, 255, 255, 0.05); }\n  .sd-line-input--dark-ui.sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input {\n    background-color: rgba(255, 255, 255, 0.03);\n    border-bottom-color: rgba(255, 255, 255, 0.2) !important; }\n  .sd-line-input--dark-ui.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select, .sd-line-input--dark-ui.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover {\n    background-color: rgba(255, 255, 255, 0.03);\n    border-bottom-color: rgba(255, 255, 255, 0.2) !important; }\n  .sd-line-input--dark-ui.sd-line-input--invalid input.sd-line-input__input, .sd-line-input--dark-ui.sd-line-input--invalid textarea.sd-line-input__input {\n    border-color: #E51C23; }\n  .sd-line-input--dark-ui.sd-line-input--invalid select.sd-line-input__select {\n    border-color: #E51C23; }\n  .sd-line-input--dark-ui.sd-line-input--is-select::after {\n    border-top-color: #fff; }\n  .sd-line-input.sd-line-input--required .sd-line-input__label::after {\n    color: #E51C23;\n    content: \"*\";\n    vertical-align: top;\n    font-size: 1.2rem;\n    padding-left: 0.3rem; }\n  .sd-line-input.sd-line-input--no-label {\n    padding-top: 0; }\n  .sd-line-input.sd-line-input--no-margin {\n    margin-bottom: 0; }\n  .sd-line-input--label-left, .sd-line-input--label-left-auto {\n    padding-top: 0;\n    margin: 0;\n    display: grid;\n    grid-template-columns: auto 1rem 1fr auto;\n    grid-template-rows: auto auto;\n    grid-gap: 0; }\n    .sd-line-input--label-left .sd-line-input__label, .sd-line-input--label-left-auto .sd-line-input__label {\n      margin-top: 0.8rem;\n      grid-column: 1/2;\n      grid-row: 1/2;\n      position: static;\n      min-width: 7.6rem;\n      max-width: 12rem; }\n    .sd-line-input--label-left .sd-line-input__input, .sd-line-input--label-left-auto .sd-line-input__input {\n      grid-row: 1/2;\n      grid-column: 3/5; }\n    .sd-line-input--label-left .sd-line-input__hint, .sd-line-input--label-left .sd-line-input__message, .sd-line-input--label-left-auto .sd-line-input__hint, .sd-line-input--label-left-auto .sd-line-input__message {\n      position: static;\n      grid-row: 2/3;\n      grid-column: 3/4;\n      padding-right: 0; }\n    .sd-line-input--label-left .sd-line-input__char-count, .sd-line-input--label-left-auto .sd-line-input__char-count {\n      position: static;\n      grid-row: 2/3;\n      grid-column: 5/4;\n      text-align: right;\n      padding-left: 1.6rem; }\n  .sd-line-input--label-left-auto .sd-line-input__label {\n    min-width: auto;\n    max-width: none; }\n  .sd-line-input--with-button input.sd-line-input__input, .sd-line-input--with-button textarea.sd-line-input__input {\n    height: 3rem;\n    text-indent: 2.8rem; }\n  .sd-line-input--with-icon-l input.sd-line-input__input, .sd-line-input--with-icon-l textarea.sd-line-input__input {\n    padding-right: 3rem; }\n  .sd-line-input .sd-line-input__plus-btn {\n    position: absolute;\n    top: 1.8rem;\n    left: 0;\n    height: 2.2rem;\n    width: 2.2rem;\n    background-color: rgba(94, 169, 200, 0.75);\n    transition: background-color 0.2s ease-out, color 0.1s ease-out;\n    border-radius: 2px;\n    cursor: pointer;\n    text-align: center; }\n    .sd-line-input .sd-line-input__plus-btn::before {\n      margin-top: 0.2rem;\n      content: \"\\E629\";\n      display: inline-block;\n      width: 16px;\n      height: 16px;\n      line-height: 16px;\n      font-size: 16px;\n      font-family: 'sd_icons';\n      speak: none;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      color: #fff;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale; }\n    .sd-line-input .sd-line-input__plus-btn:hover {\n      background-color: #5ea9c8; }\n\n[class^=\"--dark-ui\"] .form-label,\n[class*=\"--dark-ui\"] .form-label,\n[class^=\"dark-ui\"] .form-label,\n[class*=\"dark-ui\"] .form-label {\n  color: inherit;\n  opacity: 0.4; }\n\n[class^=\"--dark-ui\"] .sd-line-input input.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input input.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input input.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input input.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input {\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.8); }\n  [class^=\"--dark-ui\"] .sd-line-input input.sd-line-input__input:hover, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class*=\"--dark-ui\"] .sd-line-input input.sd-line-input__input:hover,\n  [class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class^=\"dark-ui\"] .sd-line-input input.sd-line-input__input:hover,\n  [class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class*=\"dark-ui\"] .sd-line-input input.sd-line-input__input:hover,\n  [class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover,\n  [class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4); }\n  [class^=\"--dark-ui\"] .sd-line-input input.sd-line-input__input:focus, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus, [class^=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class*=\"--dark-ui\"] .sd-line-input input.sd-line-input__input:focus,\n  [class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class*=\"--dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class^=\"dark-ui\"] .sd-line-input input.sd-line-input__input:focus,\n  [class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class^=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class*=\"dark-ui\"] .sd-line-input input.sd-line-input__input:focus,\n  [class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus,\n  [class*=\"dark-ui\"] .sd-line-input textarea.sd-line-input__input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[class^=\"--dark-ui\"] .sd-line-input select.sd-line-input__select,\n[class*=\"--dark-ui\"] .sd-line-input select.sd-line-input__select,\n[class^=\"dark-ui\"] .sd-line-input select.sd-line-input__select,\n[class*=\"dark-ui\"] .sd-line-input select.sd-line-input__select {\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.8); }\n  [class^=\"--dark-ui\"] .sd-line-input select.sd-line-input__select:hover,\n  [class*=\"--dark-ui\"] .sd-line-input select.sd-line-input__select:hover,\n  [class^=\"dark-ui\"] .sd-line-input select.sd-line-input__select:hover,\n  [class*=\"dark-ui\"] .sd-line-input select.sd-line-input__select:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4); }\n  [class^=\"--dark-ui\"] .sd-line-input select.sd-line-input__select:focus,\n  [class*=\"--dark-ui\"] .sd-line-input select.sd-line-input__select:focus,\n  [class^=\"dark-ui\"] .sd-line-input select.sd-line-input__select:focus,\n  [class*=\"dark-ui\"] .sd-line-input select.sd-line-input__select:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[class^=\"--dark-ui\"] .sd-line-input .sd-line-input__label,\n[class*=\"--dark-ui\"] .sd-line-input .sd-line-input__label,\n[class^=\"dark-ui\"] .sd-line-input .sd-line-input__label,\n[class*=\"dark-ui\"] .sd-line-input .sd-line-input__label {\n  color: rgba(255, 255, 255, 0.4); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input {\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:focus, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:hover, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:focus, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:hover,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:focus,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:hover,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:focus,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:hover,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:focus,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:hover,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:focus,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:hover,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:focus,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled input.sd-line-input__input:hover,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:focus,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled textarea.sd-line-input__input:hover {\n    border-bottom: 1px dotted rgba(255, 255, 255, 0.2);\n    box-shadow: none; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select {\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:focus, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:hover,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:focus,\n  [class*=\"--dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:hover,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:focus,\n  [class^=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:hover,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:focus,\n  [class*=\"dark-ui\"] .sd-line-input.sd-line-input--disabled select.sd-line-input__select:hover {\n    border-bottom: 1px dotted rgba(255, 255, 255, 0.2);\n    box-shadow: none; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea.sd-line-input__input {\n  background-color: rgba(255, 255, 255, 0.05); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input:hover, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input:hover,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input:hover,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input:hover,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:hover {\n  background-color: rgba(255, 255, 255, 0.1); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input:focus, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed input:focus,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input:focus,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed input:focus,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed textarea:focus {\n  background-color: rgba(255, 255, 255, 0.05); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select.sd-line-input__select,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select.sd-line-input__select,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select.sd-line-input__select,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select.sd-line-input__select {\n  background-color: rgba(255, 255, 255, 0.05); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select:hover,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select:hover,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select:hover,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select:hover {\n  background-color: rgba(255, 255, 255, 0.1); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select:focus,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed select:focus,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select:focus,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed select:focus {\n  background-color: rgba(255, 255, 255, 0.05); }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled input.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled textarea.sd-line-input__input {\n  background-color: rgba(255, 255, 255, 0.03);\n  border-bottom-color: rgba(255, 255, 255, 0.2) !important; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--boxed.sd-line-input--disabled select.sd-line-input__select:hover {\n  background-color: rgba(255, 255, 255, 0.03);\n  border-bottom-color: rgba(255, 255, 255, 0.2) !important; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid input.sd-line-input__input, [class^=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid input.sd-line-input__input,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--invalid input.sd-line-input__input,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--invalid input.sd-line-input__input,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--invalid textarea.sd-line-input__input {\n  border-color: #E51C23; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid select.sd-line-input__select,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--invalid select.sd-line-input__select,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--invalid select.sd-line-input__select,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--invalid select.sd-line-input__select {\n  border-color: #E51C23; }\n\n[class^=\"--dark-ui\"] .sd-line-input.sd-line-input--is-select::after,\n[class*=\"--dark-ui\"] .sd-line-input.sd-line-input--is-select::after,\n[class^=\"dark-ui\"] .sd-line-input.sd-line-input--is-select::after,\n[class*=\"dark-ui\"] .sd-line-input.sd-line-input--is-select::after {\n  border-top-color: #fff; }\n\n.sd-line-input-NEW {\n  padding-top: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto auto;\n  grid-gap: 0;\n  position: relative; }\n  .sd-line-input-NEW input.sd-line-input__input, .sd-line-input-NEW textarea.sd-line-input__input, .sd-line-input-NEW select.sd-line-input__input {\n    width: 100%;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: 0;\n    border: 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    background-color: transparent;\n    padding: 0;\n    font-size: 1.4rem;\n    height: 2.4rem;\n    transition: border linear 0.2s, box-shadow linear 0.2s;\n    grid-row: 2/3;\n    grid-column: 1/3; }\n    .sd-line-input-NEW input.sd-line-input__input:hover, .sd-line-input-NEW textarea.sd-line-input__input:hover, .sd-line-input-NEW select.sd-line-input__input:hover {\n      border-color: rgba(0, 0, 0, 0.3);\n      background-color: transparent; }\n    .sd-line-input-NEW input.sd-line-input__input:focus, .sd-line-input-NEW textarea.sd-line-input__input:focus, .sd-line-input-NEW select.sd-line-input__input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8;\n      background-color: transparent; }\n  .sd-line-input-NEW input[type=\"file\"].sd-line-input__input {\n    height: 3rem;\n    padding-top: 0.6rem;\n    font-size: 1.3rem; }\n    .sd-line-input-NEW input[type=\"file\"].sd-line-input__input:focus {\n      outline: none; }\n  .sd-line-input-NEW select {\n    cursor: pointer; }\n    .sd-line-input-NEW select.sd-line-input__select {\n      display: block;\n      position: relative;\n      z-index: 2; }\n      .sd-line-input-NEW select.sd-line-input__select option {\n        color: #333;\n        font-size: 1.4rem;\n        line-height: 2rem; }\n  .sd-line-input-NEW .sd-line-input__message-box {\n    grid-row: 3/4;\n    grid-column: 1/2; }\n  .sd-line-input-NEW .sd-line-input__hint,\n  .sd-line-input-NEW .sd-line-input__message,\n  .sd-line-input-NEW .sd-line-input__char-count {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\n    color: grey;\n    font-weight: 300;\n    margin: 0.5rem 0;\n    letter-spacing: 0.03em; }\n  .sd-line-input-NEW .sd-line-input__char-count {\n    font-size: 1.1rem;\n    font-weight: 400;\n    font-style: italic;\n    grid-row: 3/4;\n    grid-column: 2/3; }\n  .sd-line-input-NEW .sd-line-input__label {\n    display: inline-block;\n    font-size: 1.1rem;\n    margin: 0 0.5rem 0 0;\n    line-height: 2.6rem;\n    color: #747474;\n    text-transform: uppercase;\n    font-weight: 500;\n    letter-spacing: 0.08em;\n    position: relative;\n    min-height: 1.4rem;\n    line-height: 100%;\n    margin: 0;\n    grid-row: 1/2;\n    grid-column: 1/3; }\n    .sd-line-input-NEW .sd-line-input__label--required::after {\n      color: #E51C23;\n      content: \"*\";\n      vertical-align: top;\n      font-size: 1.2rem;\n      padding-left: 0.3rem; }\n\n.sd-toggle {\n  display: inline-block;\n  width: 4.0rem;\n  height: 1.8rem;\n  background: rgba(185, 185, 185, 0.5);\n  position: relative;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-border-radius: 0.9rem;\n  -moz-border-radius: 0.9rem;\n  -ms-border-radius: 0.9rem;\n  border-radius: 0.9rem;\n  overflow: hidden;\n  -webkit-box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 1px 0 0 rgba(0, 0, 0, 0.15); }\n  .sd-toggle .inner {\n    position: absolute;\n    left: 0.2rem;\n    width: 1.4rem;\n    top: 0.2rem;\n    height: 1.4rem;\n    background: #fff;\n    -webkit-border-radius: 0.8rem;\n    -moz-border-radius: 0.8rem;\n    -ms-border-radius: 0.8rem;\n    border-radius: 0.8rem;\n    -webkit-box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);\n    -moz-box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);\n    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);\n    -webkit-transition: all 0.2s ease-out;\n    -moz-transition: all 0.2s ease-out;\n    -ms-transition: all 0.2s ease-out;\n    -o-transition: all 0.2s ease-out;\n    transition: all 0.2s ease-out; }\n  .sd-toggle.checked {\n    background: #5ea9c8; }\n    .sd-toggle.checked .inner {\n      left: 2.4rem; }\n  .sd-toggle input[type=\"checkbox\"] {\n    display: none; }\n\nlabel + .sd-toggle {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 1rem 0 0.2rem; }\n\n.sd-toggle + label {\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 1rem; }\n\n.sd-checkbox {\n  width: 1.6rem;\n  height: 1.6rem;\n  display: inline-block;\n  position: relative;\n  background: transparent;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  vertical-align: middle;\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  -webkit-transition: all 0.2s ease-out;\n  -moz-transition: all 0.2s ease-out;\n  -ms-transition: all 0.2s ease-out;\n  -o-transition: all 0.2s ease-out;\n  transition: all 0.2s ease-out;\n  -webkit-border-radius: 2px;\n  -moz-border-radius: 2px;\n  -ms-border-radius: 2px;\n  border-radius: 2px; }\n  .sd-checkbox::after {\n    font-family: 'sd_icons';\n    content: '\\E61D';\n    font-weight: 400;\n    font-size: 1.2rem;\n    line-height: 1.2rem;\n    height: 1.2rem;\n    width: 1.2rem;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: #fff;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\";\n    -webkit-transition: all 0.2s ease-in;\n    -moz-transition: all 0.2s ease-in;\n    -ms-transition: all 0.2s ease-in;\n    -o-transition: all 0.2s ease-in;\n    transition: all 0.2s ease-in;\n    transform: scale(0.25, 0.25); }\n  .sd-checkbox:hover {\n    border-color: rgba(0, 0, 0, 0.4);\n    cursor: pointer; }\n  .sd-checkbox.checked, .sd-checkbox[checked=\"checked\"] {\n    border-color: #5ea9c8;\n    background: #5ea9c8; }\n    .sd-checkbox.checked::after, .sd-checkbox[checked=\"checked\"]::after {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\";\n      transform: scale(1, 1); }\n    .sd-checkbox.checked:hover, .sd-checkbox[checked=\"checked\"]:hover {\n      border-color: #3e92b5;\n      background-color: #3e92b5; }\n  .sd-checkbox--radio {\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    border-radius: 50%; }\n    .sd-checkbox--radio::after {\n      height: 0.8rem;\n      width: 0.8rem;\n      -webkit-border-radius: 50%;\n      -moz-border-radius: 50%;\n      -ms-border-radius: 50%;\n      border-radius: 50%;\n      content: ' ';\n      position: absolute;\n      background-color: #5ea9c8;\n      top: 0.2rem;\n      left: 0.2rem;\n      opacity: 0;\n      filter: \"alpha(opacity=0)\";\n      -webkit-transition: all 0.1s ease-in;\n      -moz-transition: all 0.1s ease-in;\n      -ms-transition: all 0.1s ease-in;\n      -o-transition: all 0.1s ease-in;\n      transition: all 0.1s ease-in;\n      transform: scale(0.25, 0.25); }\n    .sd-checkbox--radio.checked, .sd-checkbox--radio[checked=\"checked\"] {\n      border-color: #5ea9c8;\n      background: transparent; }\n      .sd-checkbox--radio.checked::after, .sd-checkbox--radio[checked=\"checked\"]::after {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\";\n        transform: scale(1, 1); }\n      .sd-checkbox--radio.checked:hover, .sd-checkbox--radio[checked=\"checked\"]:hover {\n        background: transparent; }\n  .sd-checkbox--button-style {\n    width: auto;\n    padding: 0 1.2rem;\n    line-height: 1;\n    color: #5a5a5a;\n    border: 1px solid rgba(140, 140, 140, 0.5);\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    -ms-border-radius: 2px;\n    border-radius: 2px;\n    -webkit-transition: all 0.2s ease-out;\n    -moz-transition: all 0.2s ease-out;\n    -ms-transition: all 0.2s ease-out;\n    -o-transition: all 0.2s ease-out;\n    transition: all 0.2s ease-out;\n    display: inline-flex;\n    align-items: center;\n    text-align: center;\n    height: 2.8rem;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .sd-checkbox--button-style label {\n      margin: 0;\n      display: inline;\n      cursor: pointer;\n      transition: none;\n      text-align: center;\n      line-height: 16px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n      .sd-checkbox--button-style label [class^=\"icon-\"], .sd-checkbox--button-style label [class*=\" icon-\"] {\n        vertical-align: middle; }\n    .sd-checkbox--button-style [class^=\"icon-\"], .sd-checkbox--button-style [class*=\" icon-\"] {\n      color: currentColor; }\n    .sd-checkbox--button-style i + label {\n      margin-left: 8px; }\n    .sd-checkbox--button-style::after {\n      content: '';\n      display: none; }\n    .sd-checkbox--button-style:hover {\n      color: #0e0e0e;\n      border-color: rgba(140, 140, 140, 0.95);\n      -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n      -moz-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n    .sd-checkbox--button-style.checked, .sd-checkbox--button-style[checked=\"checked\"] {\n      background-color: #3d8fb1;\n      border-color: #3d8fb1;\n      border-top-color: #245569;\n      -webkit-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n      -moz-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n      box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n      color: #fff; }\n      .sd-checkbox--button-style.checked:hover, .sd-checkbox--button-style[checked=\"checked\"]:hover {\n        color: #fff;\n        border-color: #2a647c;\n        background-color: #3986a6;\n        -webkit-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n        -moz-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n        box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2); }\n      .sd-checkbox--button-style.checked label, .sd-checkbox--button-style[checked=\"checked\"] label {\n        color: #fff; }\n    .sd-checkbox--button-style .sd-label--disabled {\n      opacity: 1 !important;\n      cursor: not-allowed !important; }\n  .sd-checkbox--disabled, .sd-checkbox[disabled=\"disabled\"] {\n    opacity: 0.40;\n    cursor: not-allowed !important; }\n    .sd-checkbox--disabled:hover, .sd-checkbox[disabled=\"disabled\"]:hover {\n      color: #5a5a5a;\n      border-color: rgba(140, 140, 140, 0.5);\n      box-shadow: none; }\n\n.sd-checkbox + label {\n  display: inline-block;\n  vertical-align: middle; }\n\n.sd-check__wrapper + .sd-check__wrapper {\n  margin-left: 0.8rem; }\n\n.sd-check__wrapper:first-child, .sd-check__wrapper:only-of-type {\n  margin-left: 0; }\n\n.sd-check__wrapper {\n  margin-left: 0.8rem;\n  display: inline-block; }\n  .sd-check__wrapper .sd-checkbox + label {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 0 0 0.6rem; }\n    .sd-check__wrapper .sd-checkbox + label i {\n      margin: 0 0.4rem 0 0.8rem; }\n  .sd-check__wrapper .sd-label--disabled {\n    opacity: 0.40; }\n\n.sd-check__group {\n  padding: 0.6rem 0 1.2rem; }\n  .sd-check__group--grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));\n    grid-gap: 0.6rem; }\n    .sd-check__group--grid .sd-check__wrapper {\n      display: block; }\n      .sd-check__group--grid .sd-check__wrapper .sd-checkbox.sd-checkbox--button-style {\n        display: flex;\n        align-items: center;\n        justify-content: center; }\n\n[class^=\"--dark-ui\"] .sd-checkbox,\n[class*=\"--dark-ui\"] .sd-checkbox,\n.dark-ui .sd-checkbox {\n  border-color: rgba(255, 255, 255, 0.4); }\n  [class^=\"--dark-ui\"] .sd-checkbox:hover,\n  [class*=\"--dark-ui\"] .sd-checkbox:hover,\n  .dark-ui .sd-checkbox:hover {\n    border-color: rgba(255, 255, 255, 0.6); }\n  [class^=\"--dark-ui\"] .sd-checkbox.checked, [class^=\"--dark-ui\"] .sd-checkbox[checked=\"checked\"],\n  [class*=\"--dark-ui\"] .sd-checkbox.checked,\n  [class*=\"--dark-ui\"] .sd-checkbox[checked=\"checked\"],\n  .dark-ui .sd-checkbox.checked,\n  .dark-ui .sd-checkbox[checked=\"checked\"] {\n    border-color: #5ea9c8; }\n    [class^=\"--dark-ui\"] .sd-checkbox.checked:hover, [class^=\"--dark-ui\"] .sd-checkbox[checked=\"checked\"]:hover,\n    [class*=\"--dark-ui\"] .sd-checkbox.checked:hover,\n    [class*=\"--dark-ui\"] .sd-checkbox[checked=\"checked\"]:hover,\n    .dark-ui .sd-checkbox.checked:hover,\n    .dark-ui .sd-checkbox[checked=\"checked\"]:hover {\n      border-color: #3e92b5;\n      background-color: #3e92b5; }\n\n[class^=\"--dark-ui\"] .sd-checkbox--button-style,\n[class*=\"--dark-ui\"] .sd-checkbox--button-style,\n.dark-ui .sd-checkbox--button-style {\n  color: rgba(255, 255, 255, 0.65); }\n  [class^=\"--dark-ui\"] .sd-checkbox--button-style:hover,\n  [class*=\"--dark-ui\"] .sd-checkbox--button-style:hover,\n  .dark-ui .sd-checkbox--button-style:hover {\n    color: white; }\n  [class^=\"--dark-ui\"] .sd-checkbox--button-style.checked, [class^=\"--dark-ui\"] .sd-checkbox--button-style[checked=\"checked\"],\n  [class*=\"--dark-ui\"] .sd-checkbox--button-style.checked,\n  [class*=\"--dark-ui\"] .sd-checkbox--button-style[checked=\"checked\"],\n  .dark-ui .sd-checkbox--button-style.checked,\n  .dark-ui .sd-checkbox--button-style[checked=\"checked\"] {\n    border-color: #3e92b5;\n    border-top-color: #31748f;\n    -webkit-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n    -moz-box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2);\n    box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.2); }\n    [class^=\"--dark-ui\"] .sd-checkbox--button-style.checked:hover, [class^=\"--dark-ui\"] .sd-checkbox--button-style[checked=\"checked\"]:hover,\n    [class*=\"--dark-ui\"] .sd-checkbox--button-style.checked:hover,\n    [class*=\"--dark-ui\"] .sd-checkbox--button-style[checked=\"checked\"]:hover,\n    .dark-ui .sd-checkbox--button-style.checked:hover,\n    .dark-ui .sd-checkbox--button-style[checked=\"checked\"]:hover {\n      border-color: #2a647c; }\n\n.sd-radio {\n  width: 1.6rem;\n  height: 1.6rem;\n  display: inline-block;\n  position: relative;\n  background: transparent;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: 0.8rem;\n  -webkit-transition: all 0.2s ease-out;\n  -moz-transition: all 0.2s ease-out;\n  -ms-transition: all 0.2s ease-out;\n  -o-transition: all 0.2s ease-out;\n  transition: all 0.2s ease-out; }\n  .sd-radio::after {\n    height: 0.8rem;\n    width: 0.8rem;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    border-radius: 50%;\n    content: ' ';\n    position: absolute;\n    background-color: #5ea9c8;\n    top: 0.2rem;\n    left: 0.2rem;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\";\n    -webkit-transition: all 0.2s ease-in;\n    -moz-transition: all 0.2s ease-in;\n    -ms-transition: all 0.2s ease-in;\n    -o-transition: all 0.2s ease-in;\n    transition: all 0.2s ease-in;\n    transform: scale(0.25, 0.25); }\n  .sd-radio:hover {\n    border-color: rgba(0, 0, 0, 0.4);\n    cursor: pointer; }\n  .sd-radio.checked, .sd-radio[checked=\"checked\"] {\n    border-color: #5ea9c8; }\n    .sd-radio.checked::after, .sd-radio[checked=\"checked\"]::after {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\";\n      transform: scale(1, 1); }\n    .sd-radio.checked:hover, .sd-radio[checked=\"checked\"]:hover {\n      border-color: #3e92b5; }\n      .sd-radio.checked:hover::after, .sd-radio[checked=\"checked\"]:hover::after {\n        background-color: #3e92b5; }\n\nlabel + .sd-radio {\n  display: inline-block; }\n\n.sd-radio + label {\n  display: inline-block;\n  vertical-align: middle; }\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n  vertical-align: top; }\n  .dropdown a {\n    color: #333; }\n  .dropdown a:hover {\n    text-decoration: none; }\n  .dropdown button {\n    -webkit-appearance: none; }\n\n.dropdown__toggle {\n  cursor: pointer; }\n  .dropdown__toggle i {\n    vertical-align: sub; }\n\n.dropdown.dropdown--hover:hover .dropdown__menu {\n  display: block; }\n\n.dropdown__toggle:active,\n.dropdown.open .dropdown__toggle {\n  outline: 0;\n  color: #5ea9c8; }\n\n.dropdown.open .dropdown .dropdown__toggle {\n  color: #333; }\n\n.dropdown__more-actions .dropdown__toggle > i {\n  opacity: 0.3; }\n\n.dropdown__more-actions .dropdown__toggle:hover > i,\n.dropdown__more-actions.open .dropdown__toggle > i {\n  opacity: 1; }\n\n.dropdown__caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  margin-top: -2px;\n  margin-left: 4px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #000;\n  opacity: .3;\n  content: \"\";\n  -webkit-transition: all 0.1s ease-in;\n  -moz-transition: all 0.1s ease-in;\n  -ms-transition: all 0.1s ease-in;\n  -o-transition: all 0.1s ease-in;\n  transition: all 0.1s ease-in; }\n  .dropdown__caret.dropdown__caret--white, .dropdown__caret.white {\n    border-top-color: #fff; }\n\n.dropdown:hover .dropdown__caret,\n.dropdown.open .dropdown__caret {\n  opacity: 1; }\n\n.dropdown.open .dropdown__caret {\n  border-top-color: #5ea9c8; }\n\n.dropdown__menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  min-width: 200px;\n  padding: 1rem 0;\n  margin: 0;\n  list-style: none;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 0;\n  text-align: left; }\n  .dropdown__menu li a:not(.btn), .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button), .dropdown__menu .dropdown__menu-item a:not(.btn), .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) {\n    display: block;\n    font-weight: normal;\n    line-height: 1.8rem;\n    white-space: nowrap;\n    width: 100%;\n    min-width: 200px;\n    position: relative;\n    color: #333;\n    background: none;\n    padding: .6rem 1.6rem;\n    margin-bottom: .2rem;\n    font-size: 1.3rem;\n    text-decoration: none;\n    text-align: left; }\n    .dropdown__menu li a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu li a:not(.btn) i[class*=\" icon-\"], .dropdown__menu li a:not(.btn) i[class^=\"filetype-icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class*=\" icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) i[class*=\" icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) i[class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class*=\" icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class^=\"filetype-icon-\"] {\n      margin-right: 1rem;\n      margin-top: -0.3rem;\n      min-width: 1.9rem;\n      vertical-align: middle; }\n    .dropdown__menu li a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"] {\n      margin-right: 1rem;\n      margin-top: -0.3rem;\n      min-width: 1.9rem;\n      vertical-align: middle; }\n    .dropdown__menu li a:not(.btn).disabled, .dropdown__menu li a:not(.btn)[disabled], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled], .dropdown__menu .dropdown__menu-item a:not(.btn).disabled, .dropdown__menu .dropdown__menu-item a:not(.btn)[disabled], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled] {\n      opacity: .5; }\n  .dropdown__menu li a:not(.btn):hover, .dropdown__menu li a:not(.btn):focus, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):focus, .dropdown__menu .dropdown__menu-item a:not(.btn):hover, .dropdown__menu .dropdown__menu-item a:not(.btn):focus, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):focus {\n    background: #eff7fa;\n    text-decoration: none;\n    cursor: pointer; }\n  .dropdown__menu li a:not(.btn):active, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):active, .dropdown__menu .dropdown__menu-item a:not(.btn):active, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):active {\n    background: #c8e4ee; }\n  .dropdown__menu li a:not(.btn).disabled:hover, .dropdown__menu li a:not(.btn)[disabled]:hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled:hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled]:hover, .dropdown__menu .dropdown__menu-item a:not(.btn).disabled:hover, .dropdown__menu .dropdown__menu-item a:not(.btn)[disabled]:hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled:hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled]:hover {\n    background: none;\n    cursor: default; }\n  .dropdown__menu li .preferred-desk, .dropdown__menu .dropdown__menu-item .preferred-desk {\n    background-color: #d0e6ef !important; }\n  .dropdown__menu.dropdown__menu--plain li, .dropdown__menu.dropdown__menu--plain .dropdown__menu-item {\n    padding: .5rem .7rem; }\n    .dropdown__menu.dropdown__menu--plain li:hover, .dropdown__menu.dropdown__menu--plain .dropdown__menu-item:hover {\n      background: #eff7fa;\n      cursor: pointer; }\n  .dropdown__menu--has-head-foot {\n    padding: 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-label {\n      margin: 0.4rem 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-header {\n      flex: 0 0;\n      padding: 0.6rem 0;\n      margin: 0; }\n      .dropdown__menu--has-head-foot .dropdown__menu-header .dropdown__menu-label {\n        margin: 0.6rem 0 0.4rem; }\n    .dropdown__menu--has-head-foot .dropdown__menu-body {\n      overflow-y: auto;\n      flex: 0 1;\n      padding: 0.6rem 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-body:first-child .dropdown__menu-label {\n      margin: 0.6rem 0 0.4rem; }\n    .dropdown__menu--has-head-foot .dropdown__menu-footer {\n      flex: 0 0;\n      padding: 0.6rem 0;\n      margin: 0; }\n    .dropdown__menu--has-head-foot.open {\n      display: flex; }\n\n.dropdown__menu-divider {\n  height: 1px;\n  margin: 0.8rem 0;\n  overflow: hidden;\n  background-color: #e5e5e5; }\n\n.dropdown__menu .dropdown__menu-item--active button, .dropdown__menu .dropdown__menu-item--active button:hover {\n  background-color: #84bdd5 !important;\n  color: white !important; }\n  .dropdown__menu .dropdown__menu-item--active button [class^=\"icon-\"], .dropdown__menu .dropdown__menu-item--active button [class*=\" icon-\"],\n  .dropdown__menu .dropdown__menu-item--active button [class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button [class*=\" filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class^=\"icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class*=\" icon-\"],\n  .dropdown__menu .dropdown__menu-item--active button:hover [class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class*=\" filetype-icon-\"] {\n    color: white !important; }\n\n.dropdown__menu .dropdown__menu-item--active button:hover {\n  background-color: #5ea9c8 !important; }\n\n.dropdown__menu .dropdown__menu-item--highlighted {\n  background-color: #c245ff; }\n\n.dropdown__menu .dropdown__menu-item--no-link {\n  font-weight: 400;\n  line-height: 1.8rem;\n  position: relative;\n  color: #747474;\n  padding: .6rem 1.6rem;\n  margin-bottom: .2rem;\n  font-size: 1.3rem;\n  text-align: left; }\n\n.dropdown__menu label {\n  display: inline-block;\n  margin: 0; }\n  .dropdown__menu label + .dropdown__menu-info {\n    margin-left: 4px; }\n\n.dropdown__menu-label {\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  color: #999;\n  font-weight: 500;\n  padding-left: 1.6rem;\n  margin-bottom: .6rem; }\n  .dropdown__menu-label .dropdown__menu-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    width: auto;\n    opacity: .3;\n    background-color: transparent;\n    cursor: pointer; }\n    .dropdown__menu-label .dropdown__menu-close i {\n      margin-right: 0 !important; }\n    .dropdown__menu-label .dropdown__menu-close:hover, .dropdown__menu-label .dropdown__menu-close:focus {\n      background-color: transparent;\n      opacity: 1; }\n\n.dropdown__menu-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 0.6rem; }\n\n.dropdown__menu-footer {\n  padding: 1rem;\n  margin-top: 0.6rem;\n  border-top: 1px solid #e5e5e5; }\n  .dropdown__menu-footer--align-right {\n    text-align: right; }\n  .dropdown__menu-footer--has-list {\n    padding: 0.6rem 0 0 0;\n    margin-bottom: -0.4rem; }\n\n.dropdown__menu-info {\n  color: #999;\n  font-style: italic;\n  vertical-align: middle; }\n\n.dropdown__menu-item {\n  padding: 0; }\n  .dropdown__menu-item--left-10 {\n    padding-left: 1rem; }\n\n.dropdown__menu--padded-l10 > li {\n  padding-left: 1rem; }\n\n.dropdown__menu--padded-l10 .dropdown__menu-item {\n  padding: 0; }\n\n.dropdown__menu--right {\n  right: 0;\n  left: auto; }\n\n.dropdown__menu .menu-item--active button, .dropdown__menu .menu-item--active button:hover {\n  background-color: #84bdd5;\n  color: white; }\n  .dropdown__menu .menu-item--active button [class^=\"icon-\"], .dropdown__menu .menu-item--active button [class*=\" icon-\"],\n  .dropdown__menu .menu-item--active button [class^=\"filetype-icon-\"], .dropdown__menu .menu-item--active button [class*=\" filetype-icon-\"], .dropdown__menu .menu-item--active button:hover [class^=\"icon-\"], .dropdown__menu .menu-item--active button:hover [class*=\" icon-\"],\n  .dropdown__menu .menu-item--active button:hover [class^=\"filetype-icon-\"], .dropdown__menu .menu-item--active button:hover [class*=\" filetype-icon-\"] {\n    color: white; }\n\n.dropdown__menu .menu-item--active button:hover {\n  background-color: #5ea9c8; }\n\n.dropdown.open > .dropdown__menu {\n  display: block; }\n  .dropdown.open > .dropdown__menu.dropdown__menu--scrollable {\n    max-height: 36rem;\n    overflow: auto;\n    overflow-x: hidden; }\n  .dropdown.open > .dropdown__menu.dropdown__menu--has-head-foot {\n    display: flex;\n    flex-direction: column;\n    max-height: 36rem; }\n\n.dropdown--align-right .dropdown__menu, .dropdown--align-right.dropdown__menu {\n  left: auto;\n  right: 0; }\n  .dropdown--align-right .dropdown__menu:before, .dropdown--align-right.dropdown__menu:before {\n    left: auto;\n    right: 10px; }\n\n.dropdown--dropup .dropdown__caret {\n  border-top: 0;\n  border-bottom: 4px solid #000;\n  content: \"\\2191\";\n  -webkit-transition: all 0.2s eas-in;\n  -moz-transition: all 0.2s eas-in;\n  -ms-transition: all 0.2s eas-in;\n  -o-transition: all 0.2s eas-in;\n  transition: all 0.2s eas-in; }\n\n.dropdown--dropup .dropdown__menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 4px; }\n\n.dropdown--dropup.open .dropdown__caret {\n  border-bottom-color: #5ea9c8 !important; }\n\n.dropdown--dropleft {\n  display: inline-block;\n  vertical-align: middle; }\n  .dropdown--dropleft .dropdown__menu {\n    top: -2.3rem;\n    left: auto;\n    right: calc(100% + 0.3rem); }\n\n.dropdown--dropright {\n  display: inline-block;\n  vertical-align: middle; }\n  .dropdown--dropright .dropdown__menu {\n    top: -2.3rem;\n    left: 100%; }\n\n.dropdown--dropright.open .dropdown__caret {\n  transform: rotate(-90deg); }\n\n.dropdown--dropleft.open .dropdown__caret {\n  transform: rotate(90deg); }\n\n.dropdown--dropright.dropdown--dropup .dropdown__menu, .dropdown--dropleft.dropdown--dropup .dropdown__menu {\n  bottom: -2.3rem;\n  top: auto; }\n\n.dropdown--noarrow {\n  display: inline-block; }\n  .dropdown--noarrow .dropdown__menu {\n    margin: 0;\n    max-height: 250px;\n    overflow: auto; }\n  .dropdown--noarrow .dropdown__menu:before {\n    display: none; }\n  .dropdown--noarrow .dropdown .dropdown__toggle {\n    display: block;\n    padding: 3px 15px;\n    clear: both;\n    font-weight: normal;\n    line-height: 18px;\n    white-space: nowrap; }\n  .dropdown--noarrow.open li > .dropdown .dropdown__toggle {\n    display: block;\n    padding: 5px 7px;\n    margin: 0;\n    clear: both;\n    font-weight: normal;\n    line-height: 18px;\n    white-space: nowrap; }\n\n.dropdown--noarrow.dropdown--no-scroll .dropdown__menu {\n  max-height: none;\n  overflow: visible; }\n\n.dropdown--bigger .dropdown__menu {\n  min-width: 238px; }\n\n.dropdown--bigger-500 .dropdown__menu {\n  min-width: 300px; }\n\n.dropdown--more-activity .dropdown__menu {\n  min-width: 0;\n  padding: 5px;\n  border-radius: 0px;\n  border: 0;\n  z-index: 1;\n  margin-top: -1px; }\n  .dropdown--more-activity .dropdown__menu:before {\n    display: none; }\n  .dropdown--more-activity .dropdown__menu li {\n    display: inline-block;\n    vertical-align: middle; }\n    .dropdown--more-activity .dropdown__menu li a {\n      padding: 0; }\n      .dropdown--more-activity .dropdown__menu li a i {\n        margin-right: 0; }\n      .dropdown--more-activity .dropdown__menu li a span {\n        display: none; }\n\n.dropdown__button-label {\n  display: inline-block;\n  color: inherit;\n  font-weight: 300;\n  opacity: 0.65;\n  padding-right: 0.5rem;\n  letter-spacing: 0.02rem; }\n\n.dropdown.dropdown--dark .dropdown__toggle {\n  text-align: left;\n  background: rgba(127, 127, 127, 0.5);\n  padding: 0.7rem 1.5rem;\n  border-radius: 2px;\n  color: #fff; }\n  .dropdown.dropdown--dark .dropdown__toggle .dropdown__caret {\n    border-top-color: #fff;\n    margin-left: 1rem; }\n  .dropdown.dropdown--dark .dropdown__toggle--small {\n    padding: 0.5rem 1.5rem; }\n  .dropdown.dropdown--dark .dropdown__toggle--hollow {\n    border: 1px solid rgba(127, 127, 127, 0.75);\n    background: none; }\n  .dropdown.dropdown--dark .dropdown__toggle--line {\n    background-color: rgba(255, 255, 255, 0.05);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n    .dropdown.dropdown--dark .dropdown__toggle--line:hover {\n      border-bottom-color: rgba(255, 255, 255, 0.4);\n      background-color: rgba(255, 255, 255, 0.1); }\n    .dropdown.dropdown--dark .dropdown__toggle--line:focus {\n      border-color: #5ea9c8;\n      background-color: rgba(255, 255, 255, 0.1);\n      box-shadow: 0 1px 0 0 #5ea9c8; }\n\n.dropdown.dropdown--dark.open .dropdown__toggle--hollow {\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background-color: rgba(255, 255, 255, 0.1); }\n\n.dropdown.dropdown--dark.open .dropdown__toggle--line {\n  background-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 1px 0 0 #5ea9c8, inset 0 0px 0 1px rgba(89, 169, 201, 0.4); }\n\n.dropdown.dropdown--full-width {\n  width: 100%; }\n  .dropdown.dropdown--full-width .dropdown__toggle .dropdown__caret {\n    float: right;\n    margin-top: 6px; }\n\n.dropdown__menu--multiedit {\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--multiedit li {\n    margin-bottom: 4px; }\n  .dropdown__menu--multiedit li button {\n    width: 300px !important;\n    padding-right: 30px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n    border-radius: 0; }\n    .dropdown__menu--multiedit li button i {\n      position: absolute;\n      right: -5px;\n      top: 9px; }\n    .dropdown__menu--multiedit li button.disabled, .dropdown__menu--multiedit li button.disabled:hover {\n      background: #f0f0f0; }\n      .dropdown__menu--multiedit li button.disabled i, .dropdown__menu--multiedit li button.disabled:hover i {\n        opacity: .2; }\n  .dropdown__menu--multiedit li .msg {\n    padding: 0 20px; }\n\n.dark-ui .dropdown__caret {\n  border-top-color: #fff; }\n\n.dark-ui .dropdown.open .dropdown__caret {\n  border-top-color: #5ea9c8; }\n\n.dropdown.open li .dropdown {\n  display: block;\n  float: none; }\n  .dropdown.open li .dropdown .dropdown__toggle {\n    padding-right: 2.4rem; }\n    .dropdown.open li .dropdown .dropdown__toggle::after {\n      position: absolute;\n      right: 0.8rem;\n      top: 22%;\n      display: block;\n      width: 1.6rem;\n      height: 1.6rem;\n      line-height: 1.6rem;\n      font-family: 'sd_icons';\n      content: \"\\E643\";\n      font-size: 1.6rem;\n      font-style: normal;\n      font-weight: normal;\n      font-variant: normal;\n      text-transform: none;\n      opacity: .4; }\n  .dropdown.open li .dropdown:not(.open) .dropdown__menu {\n    display: none; }\n  .dropdown.open li .dropdown > .dropdown__menu {\n    left: 100%;\n    right: auto;\n    top: 0;\n    min-width: 160px;\n    z-index: 10; }\n    .dropdown.open li .dropdown > .dropdown__menu.dropdown__menu--submenu-left {\n      left: auto;\n      right: 100%; }\n    .dropdown.open li .dropdown > .dropdown__menu.upward {\n      top: auto;\n      bottom: -16px; }\n    .dropdown.open li .dropdown > .dropdown__menu.dropdown--align-right {\n      left: auto;\n      right: 100%; }\n  .dropdown.open li .dropdown.dropdown--dropup > .dropdown__menu {\n    top: auto;\n    bottom: 0; }\n  .dropdown.open li .dropdown:hover > .dropdown__menu {\n    display: block; }\n\n.dropdown.dropdown--dropup.open li .dropdown > .dropdown__menu {\n  top: auto;\n  bottom: -16px; }\n\n.dropdown.dropdown--input-addon {\n  position: absolute;\n  right: 12px;\n  margin-top: -1px; }\n  .dropdown.dropdown--input-addon > .dropdown__toggle {\n    height: 22px;\n    line-height: 0;\n    padding: 2px 6px;\n    box-shadow: none;\n    margin-bottom: 2px;\n    background-color: transparent;\n    box-shadow: none; }\n    .dropdown.dropdown--input-addon > .dropdown__toggle .dropdown__caret {\n      padding: 0px;\n      margin-left: 0; }\n  .dropdown.dropdown--input-addon.open > .dropdown__toggle {\n    background-color: transparent; }\n\n.dropdown.dropdown--big > .dropdown__toggle,\n.navbtn.dropdown > .dropdown__toggle {\n  padding: 0 15px;\n  display: block;\n  color: #333;\n  height: 4.8rem;\n  text-align: center;\n  line-height: 4.8rem;\n  font-size: 15px;\n  position: relative;\n  z-index: 2;\n  background: transparent; }\n  .dropdown.dropdown--big > .dropdown__toggle:hover,\n  .navbtn.dropdown > .dropdown__toggle:hover {\n    background: rgba(255, 255, 255, 0); }\n  .dropdown.dropdown--big > .dropdown__toggle.condensed,\n  .navbtn.dropdown > .dropdown__toggle.condensed {\n    padding: 0 14px; }\n\n.dropdown.dropdown--big.open > .dropdown__toggle,\n.navbtn.dropdown.open > .dropdown__toggle {\n  background: #fff;\n  color: #333;\n  box-shadow: -3px 0px 1px -2px #999,3px 0px 1px -2px #999;\n  z-index: 3; }\n  .dropdown.dropdown--big.open > .dropdown__toggle.sd-create-btn .circle,\n  .navbtn.dropdown.open > .dropdown__toggle.sd-create-btn .circle {\n    width: 32px;\n    height: 32px;\n    margin-top: 8px;\n    margin-left: 0; }\n\n.dropdown.dropdown--big .caret,\n.navbtn.dropdown .caret {\n  margin-left: 15px; }\n\n.dropdown.dropdown--big .dropdown__menu,\n.navbtn.dropdown .dropdown__menu {\n  -webkit-border-radius: 0px;\n  -moz-border-radius: 0px;\n  -ms-border-radius: 0px;\n  border-radius: 0px;\n  border: 0;\n  z-index: 2;\n  margin-top: -1px;\n  min-width: 200px;\n  box-shadow: 0px 1px 2px 1px rgba(0, 0, 0, 0.35);\n  padding: 10px 0; }\n  .dropdown.dropdown--big .dropdown__menu:before,\n  .navbtn.dropdown .dropdown__menu:before {\n    display: none; }\n  .dropdown.dropdown--big .dropdown__menu li > a, .dropdown.dropdown--big .dropdown__menu li > button, .dropdown.dropdown--big .dropdown__menu li > span,\n  .navbtn.dropdown .dropdown__menu li > a,\n  .navbtn.dropdown .dropdown__menu li > button,\n  .navbtn.dropdown .dropdown__menu li > span {\n    margin: 0;\n    min-width: 225px;\n    padding: 6px 16px;\n    line-height: 19px; }\n  .dropdown.dropdown--big .dropdown__menu li > span,\n  .navbtn.dropdown .dropdown__menu li > span {\n    display: block; }\n    .dropdown.dropdown--big .dropdown__menu li > span:hover,\n    .navbtn.dropdown .dropdown__menu li > span:hover {\n      background: none; }\n  .dropdown.dropdown--big .dropdown__menu li > .dropdown__menu-label,\n  .navbtn.dropdown .dropdown__menu li > .dropdown__menu-label {\n    min-width: 205px; }\n  .dropdown.dropdown--big .dropdown__menu li button.full,\n  .navbtn.dropdown .dropdown__menu li button.full {\n    width: 100%;\n    margin: 0;\n    height: 41px;\n    padding: 10px 10px;\n    border-top: 1px solid #e0e0e0;\n    -webkit-border-radius: 0px;\n    -moz-border-radius: 0px;\n    -ms-border-radius: 0px;\n    border-radius: 0px; }\n    .dropdown.dropdown--big .dropdown__menu li button.full i,\n    .navbtn.dropdown .dropdown__menu li button.full i {\n      margin-right: 10px; }\n    .dropdown.dropdown--big .dropdown__menu li button.full:hover,\n    .navbtn.dropdown .dropdown__menu li button.full:hover {\n      background: #5ea9c8;\n      color: #fff; }\n  .dropdown.dropdown--big .dropdown__menu li:active > button,\n  .navbtn.dropdown .dropdown__menu li:active > button {\n    background: #5ea9c8;\n    color: #fff; }\n  .dropdown.dropdown--big .dropdown__menu .fieldset button,\n  .navbtn.dropdown .dropdown__menu .fieldset button {\n    display: inline-block;\n    text-align: center;\n    width: auto;\n    min-width: 50px;\n    clear: none;\n    margin-right: 10px;\n    float: right; }\n\n.navbtn.dropdown {\n  padding: 0; }\n\n.dropdown2 {\n  background: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1); }\n\n.sd-sidebar-menu {\n  position: absolute;\n  bottom: 0;\n  width: 4.8rem;\n  top: 48px;\n  background-color: #dedede;\n  z-index: 1029;\n  transition: all .3s ease; }\n  .sd-sidebar-menu--left {\n    left: 0;\n    box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.25); }\n    .sd-sidebar-menu--left.main-menu__open {\n      left: 30rem; }\n  .sd-sidebar-menu--second-level {\n    background-color: #b7bec1;\n    z-index: 1028; }\n\n.sd-sidebar-menu__spacer {\n  width: 2.4rem;\n  margin: 1.8rem auto;\n  border-top: 1px dotted #9b9b9b;\n  border-bottom: 0; }\n\n.sd-sidebar-menu__btn {\n  display: block;\n  margin: 0.6rem auto;\n  border-radius: 50%;\n  height: 3.6rem;\n  width: 3.6rem;\n  opacity: .7;\n  overflow: hidden;\n  transition: opacity 0.2s, background-color 0.2s;\n  position: relative; }\n  .sd-sidebar-menu__btn:hover {\n    opacity: 1;\n    background-color: rgba(255, 255, 255, 0.6); }\n  .sd-sidebar-menu__btn:active {\n    background-color: #5ea9c8;\n    opacity: 1; }\n  .sd-sidebar-menu__btn--active, .sd-sidebar-menu__btn--active:hover {\n    background-color: #3d8fb1;\n    opacity: 1; }\n    .sd-sidebar-menu__btn--active .sd-sidebar-menu__main-icon, .sd-sidebar-menu__btn--active:hover .sd-sidebar-menu__main-icon {\n      color: #fff; }\n\n.sd-sidebar-menu__main-icon {\n  position: absolute;\n  top: 0.5rem;\n  left: 0.5rem;\n  transition: left 0.2s ease-out; }\n\n.sd-sidebar-menu__helper-icon {\n  position: absolute;\n  top: 0.5rem;\n  left: 3rem;\n  transition: left 0.2s ease-out, transform 0.2s; }\n\n.authoring-active .sd-sidebar-menu__btn--active .sd-sidebar-menu__main-icon, .authoring-active .sd-sidebar-menu__btn--active .sd-sidebar-menu__helper-icon {\n  color: #fff; }\n\n.authoring-active .sd-sidebar-menu__btn--active:hover .sd-sidebar-menu__main-icon {\n  left: -3rem; }\n\n.authoring-active .sd-sidebar-menu__btn--active:hover .sd-sidebar-menu__helper-icon {\n  left: 0.5rem; }\n\n.authoring-active.list-hidden .sd-sidebar-menu__btn--active .sd-sidebar-menu__helper-icon {\n  transform: rotate(180deg);\n  left: -3rem; }\n\n.authoring-active.list-hidden .sd-sidebar-menu__btn--active:hover .sd-sidebar-menu__main-icon {\n  left: 4rem; }\n\n.authoring-active.list-hidden .sd-sidebar-menu__btn--active:hover .sd-sidebar-menu__helper-icon {\n  left: 0.5rem; }\n\n.sd-sidetab-menu {\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  width: 4.8rem;\n  top: 48px;\n  background-color: #a1a1a1;\n  z-index: 16;\n  transition: all .3s ease; }\n  .sd-sidetab-menu--right {\n    right: 0;\n    box-shadow: inset 4px 0 5px -3px rgba(0, 0, 0, 0.25); }\n  .sd-sidetab-menu--static {\n    position: static; }\n\n.sd-sidetab-menu__btn {\n  display: block;\n  position: relative;\n  width: 100%;\n  height: 4.8rem;\n  text-align: center;\n  padding: 0;\n  margin: 0;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.12);\n  border-width: 0 0 1px 0;\n  background: none; }\n  .sd-sidetab-menu__btn:hover {\n    background: rgba(255, 255, 255, 0.15);\n    cursor: pointer; }\n\n.sd-sidetab-menu__helper-icon,\n.sd-sidetab-menu__main-icon {\n  position: absolute;\n  top: 10px;\n  left: 10px; }\n\n.sd-sidetab-menu__helper-icon {\n  opacity: 0;\n  margin: 0;\n  left: 1.2rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  font-size: 2.4rem;\n  line-height: 2.4rem;\n  z-index: 2;\n  transition: all 0.4s 0s, transform 0.3s 0s; }\n\n.sd-sidetab-menu__main-icon {\n  opacity: 1;\n  transition: all 0.2s, transform 0.2s; }\n\n.sd-sidetab-menu__info-label {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  text-shadow: none;\n  z-index: 3;\n  margin: 0; }\n\n.active .sd-sidetab-menu__btn {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(0, 0, 0, 0.18); }\n\n.active .sd-sidetab-menu__btn:hover .sd-sidetab-menu__helper-icon {\n  opacity: 1;\n  transform: rotate(180deg);\n  transition: all 0.3s 0.2s, transform 0.2s 0.2s; }\n\n.active .sd-sidetab-menu__btn:hover .sd-sidetab-menu__main-icon {\n  opacity: 0;\n  height: 0.8rem;\n  width: 0.8rem;\n  left: 2.0rem;\n  font-size: 8px; }\n\n.sd-sidetab-menu__btn--active {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(0, 0, 0, 0.18); }\n  .sd-sidetab-menu__btn--active .sd-sidetab-menu__main-icon {\n    color: #36809e !important; }\n  .sd-sidetab-menu__btn--active:hover .sd-sidetab-menu__helper-icon {\n    opacity: 1;\n    transform: rotate(180deg);\n    transition: all 0.3s 0.2s, transform 0.2s 0.2s; }\n  .sd-sidetab-menu__btn--active:hover .sd-sidetab-menu__main-icon {\n    opacity: 0;\n    height: 0.8rem;\n    width: 0.8rem;\n    left: 2.0rem;\n    font-size: 8px; }\n\n.sd-side-menu__btn {\n  display: block;\n  margin: 0.6rem auto;\n  border-radius: 50%;\n  height: 3.6rem;\n  width: 3.6rem;\n  opacity: .7;\n  overflow: hidden;\n  transition: opacity 0.2s, background-color 0.2s;\n  position: relative; }\n  .sd-side-menu__btn:hover {\n    opacity: 1;\n    background-color: rgba(255, 255, 255, 0.6); }\n  .sd-side-menu__btn:active {\n    background-color: #5ea9c8;\n    opacity: 1; }\n  .sd-side-menu__btn--active, .sd-side-menu__btn--active:hover {\n    background-color: #3d8fb1;\n    opacity: 1; }\n\n.sd-side-menu__helper-icon,\n.sd-side-menu__main-icon {\n  position: absolute;\n  top: 0.5rem;\n  left: 0.5rem; }\n\n.sd-side-menu__helper-icon {\n  opacity: 0;\n  margin: 0;\n  left: 0.6rem;\n  width: 2.4rem;\n  height: 2.4rem;\n  font-size: 2.4rem;\n  line-height: 2.4rem;\n  z-index: 2;\n  transition: all 0.4s 0s, transform 0.3s 0s; }\n\n.sd-side-menu__main-icon {\n  opacity: 1;\n  transition: all 0.2s, transform 0.2s; }\n\n.sd-side-menu__info-label {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.3rem;\n  text-shadow: none;\n  z-index: 3;\n  margin: 0; }\n\n.sd-side-menu__btn--active .sd-side-menu__helper-icon, .sd-side-menu__btn--active .sd-side-menu__main-icon {\n  color: #fff; }\n\n.sd-side-menu__btn--active:hover .sd-side-menu__helper-icon {\n  opacity: 1;\n  transform: rotate(180deg);\n  transition: all 0.3s 0.2s, transform 0.2s 0.2s; }\n\n.sd-side-menu__btn--active:hover .sd-side-menu__main-icon {\n  opacity: 0;\n  height: 0.8rem;\n  width: 0.8rem;\n  left: 2.0rem;\n  font-size: 8px; }\n\n.sd-top-menu {\n  background: #2c2c2c;\n  height: 48px;\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  z-index: 1030;\n  margin-bottom: 0;\n  transition: all 0.3s ease; }\n\n.sd-top-menu__collapse-nav {\n  display: inline-block;\n  height: 48px;\n  line-height: 51px;\n  width: 4.8rem;\n  text-align: center;\n  padding: 0;\n  background-color: #101010;\n  box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.35); }\n  .sd-top-menu__collapse-nav:hover {\n    background: #000;\n    cursor: pointer; }\n\n.sd-top-menu__header {\n  display: inline-block;\n  height: 48px;\n  line-height: 48px;\n  font-size: 1.5rem;\n  text-align: center;\n  padding: 0 2rem;\n  color: #aaa;\n  margin: 0; }\n\n.sd-top-menu__current-user {\n  width: 48px;\n  position: relative;\n  padding: 0 10px;\n  width: 48px; }\n  .sd-top-menu__current-user .avatar {\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    border-radius: 50%; }\n  .sd-top-menu__current-user .label {\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    text-shadow: none; }\n\n.sd-left-nav {\n  background: #fff;\n  border-right: 1px solid #dedede;\n  display: block;\n  width: 20rem;\n  overflow: auto; }\n  .sd-left-nav--absolute {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0; }\n\n.sd-left-nav__btn {\n  display: block;\n  font-size: 1.3rem;\n  line-height: 100%;\n  text-decoration: none;\n  color: #333;\n  background-color: rgba(94, 169, 200, 0);\n  padding: 1.6rem 0 1.6rem 3rem;\n  border-right: 4px solid rgba(94, 169, 200, 0);\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .sd-left-nav__btn:hover {\n    background-color: rgba(94, 169, 200, 0.2);\n    color: #333;\n    text-decoration: none; }\n  .sd-left-nav__btn:active, .sd-left-nav__btn--active {\n    background-color: rgba(94, 169, 200, 0.1);\n    color: #5ea9c8; }\n  .sd-left-nav__btn--active {\n    border-right: 4px solid #5ea9c8; }\n\n.sd-left-nav__group-header {\n  display: block;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 100%;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #747474;\n  padding: 2.6rem 0 0.9rem 1.6rem;\n  border-top: 1px solid #dedede;\n  margin-top: 1rem; }\n  .sd-left-nav__group-header--first, .sd-left-nav__group-header:first-child {\n    border: none;\n    margin-top: 0; }\n\n.sd-content-nav {\n  background: transparent;\n  display: block;\n  overflow: auto;\n  padding: 1rem 0;\n  opacity: 1;\n  transition: all .2s ease-out .3s; }\n\n.sd-content-nav__btn {\n  display: block;\n  font-size: 1.4rem;\n  line-height: 100%;\n  text-decoration: none;\n  color: #222;\n  padding: 1.6rem 2rem;\n  transition: background-color 0.2s ease-out, color 0.1s ease-out; }\n  .sd-content-nav__btn:hover {\n    background-color: rgba(94, 169, 200, 0.2);\n    color: #333;\n    text-decoration: none; }\n  .sd-content-nav__btn:active, .sd-content-nav__btn--active {\n    background-color: white;\n    color: #5ea9c8; }\n\n.sd-content-nav-title {\n  font-size: 1.5rem;\n  font-weight: 300; }\n  .sd-content-nav-title--uppercase {\n    font-size: 1.3rem;\n    font-weight: 400;\n    text-transform: uppercase; }\n\n.color-swatch__list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(6.8rem, 6.8rem));\n  grid-gap: 0.9rem;\n  margin: 0.4rem 0 2.4rem 0; }\n\n.color-swatch {\n  height: 6.8rem;\n  width: 6.8rem;\n  padding: 0.2rem;\n  border-radius: 50%;\n  border: 2px solid rgba(94, 169, 200, 0); }\n  .color-swatch--selected {\n    border-color: #5ea9c8; }\n    .color-swatch--selected .color-swatch__inner {\n      box-shadow: none !important; }\n  .color-swatch.sd-editor--theme-default .color-swatch__inner {\n    background-color: #fff;\n    color: #333; }\n  .color-swatch.sd-editor--theme-dark .color-swatch__inner {\n    background-color: #222;\n    color: #AACCD1; }\n  .color-swatch.sd-editor--theme-blue .color-swatch__inner {\n    background-color: #06356A;\n    color: #fff; }\n  .color-swatch.sd-editor--theme-turquoise .color-swatch__inner {\n    background-color: #5AC7C3;\n    color: #122235; }\n  .color-swatch.sd-editor--theme-military .color-swatch__inner {\n    background-color: #949E5F;\n    color: #252818; }\n  .color-swatch.sd-editor--theme-natural .color-swatch__inner {\n    background-color: #EFE9C5;\n    color: #1D1414; }\n\n.color-swatch__inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 6rem;\n  width: 6rem;\n  border-radius: 50%;\n  background-color: #fff;\n  color: #333;\n  text-align: center;\n  font-size: 2rem;\n  line-height: 6rem;\n  text-transform: uppercase;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16), 0 0 1px rgba(0, 0, 0, 0.1);\n  cursor: pointer; }\n  .color-swatch__inner:hover {\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.2); }\n\n.text-field__headline {\n  font-weight: 500;\n  min-height: 6rem; }\n\n.text-field__abstract {\n  font-weight: 400;\n  font-style: italic;\n  min-height: 9.2rem; }\n\n.text-field__body {\n  font-weight: 300;\n  min-height: 9.2rem; }\n\n.theme-preview {\n  margin: 0 -2rem -2rem -2rem;\n  padding: 2rem;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2); }\n  .theme-preview .theme-preview__label {\n    opacity: 0.7;\n    transition: opacity 0.3s ease-out; }\n  .theme-preview:hover .theme-preview__label {\n    opacity: 1; }\n  .theme-preview.sd-editor--font-sans {\n    font-family: \"Roboto\", sans-serif; }\n  .theme-preview.sd-editor--font-serif {\n    font-family: \"Merriweather\", serif; }\n  .theme-preview.sd-editor--font-mono {\n    font-family: \"Roboto Mono\", monospace; }\n  .theme-preview.sd-editor--theme-default {\n    background-color: #fff;\n    color: #333; }\n  .theme-preview.sd-editor--theme-dark {\n    background-color: #222;\n    color: #AACCD1; }\n  .theme-preview.sd-editor--theme-blue {\n    background-color: #06356A;\n    color: #fff; }\n  .theme-preview.sd-editor--theme-turquoise {\n    background-color: #5AC7C3;\n    color: #122235; }\n  .theme-preview.sd-editor--theme-military {\n    background-color: #949E5F;\n    color: #252818; }\n  .theme-preview.sd-editor--theme-natural {\n    background-color: #EFE9C5;\n    color: #1D1414; }\n  .theme-preview.sd-editor--headline-small .text-field__headline {\n    font-size: 2.3rem; }\n  .theme-preview.sd-editor--headline-medium .text-field__headline {\n    font-size: 2.8rem; }\n  .theme-preview.sd-editor--headline-large .text-field__headline {\n    font-size: 3.2rem; }\n  .theme-preview.sd-editor--abstract-small .text-field__abstract {\n    font-size: 1.4rem; }\n  .theme-preview.sd-editor--abstract-medium .text-field__abstract {\n    font-size: 1.6rem; }\n  .theme-preview.sd-editor--abstract-large .text-field__abstract {\n    font-size: 1.8rem; }\n  .theme-preview.sd-editor--body-small .text-field__body {\n    font-size: 1.4rem; }\n  .theme-preview.sd-editor--body-medium .text-field__body {\n    font-size: 1.6rem; }\n  .theme-preview.sd-editor--body-large .text-field__body {\n    font-size: 1.8rem; }\n\n.theme-preview__block {\n  margin-bottom: 1.2rem; }\n  .theme-preview__block:last-child {\n    margin-bottom: 0; }\n\n.theme-preview__label {\n  display: inline-block;\n  padding: 0.4rem 0.7rem 0.3rem 0.7rem;\n  vertical-align: middle;\n  border-radius: 2px;\n  text-transform: uppercase;\n  line-height: 1rem;\n  letter-spacing: 0.05em;\n  font-size: 1rem;\n  white-space: nowrap;\n  font-weight: 500;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #fff;\n  font-family: \"Roboto\"; }\n\n.theme-preview__text-field {\n  display: flex;\n  line-height: 140%;\n  color: inherit;\n  font-family: inherit;\n  border-bottom: 1px dotted rgba(123, 123, 123, 0.5);\n  margin-bottom: 0.8rem;\n  padding: 1rem 0 0.5rem;\n  flex-direction: column;\n  justify-content: flex-end; }\n\n.theme-preview__media-field {\n  display: flex;\n  color: inherit;\n  font-family: inherit;\n  margin-bottom: 0.8rem;\n  padding: 1rem 0 0.5rem;\n  flex-direction: column; }\n\n.theme-preview__button-bar {\n  text-align: right; }\n  .theme-preview__button-bar .sd-check__wrapper + .sd-check__wrapper {\n    margin-left: 0.2rem; }\n\n.main-article.sd-editor--theme-default {\n  background-color: #fff;\n  color: #333; }\n  .main-article.sd-editor--theme-default .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #333; }\n\n.main-article.sd-editor--theme-dark {\n  background-color: #222;\n  color: #AACCD1; }\n  .main-article.sd-editor--theme-dark .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #AACCD1; }\n\n.main-article.sd-editor--theme-blue {\n  background-color: #06356A;\n  color: #fff; }\n  .main-article.sd-editor--theme-blue .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #fff; }\n\n.main-article.sd-editor--theme-turquoise {\n  background-color: #5AC7C3;\n  color: #122235; }\n  .main-article.sd-editor--theme-turquoise .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #122235; }\n\n.main-article.sd-editor--theme-military {\n  background-color: #949E5F;\n  color: #252818; }\n  .main-article.sd-editor--theme-military .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #252818; }\n\n.main-article.sd-editor--theme-natural {\n  background-color: #EFE9C5;\n  color: #1D1414; }\n  .main-article.sd-editor--theme-natural .Editor3-root .DraftEditor-editorContainer blockquote {\n    border-left-color: #1D1414; }\n\n.main-article.sd-editor--font-sans {\n  font-family: \"Roboto\", sans-serif; }\n\n.main-article.sd-editor--font-serif {\n  font-family: \"Merriweather\", serif; }\n\n.main-article.sd-editor--font-mono {\n  font-family: \"Roboto Mono\", monospace; }\n\n.main-article.sd-editor--headline-small .headline .Editor3-root .DraftEditor-editorContainer {\n  font-size: 2.3rem; }\n\n.main-article.sd-editor--headline-small .headline .text-editor, .main-article.sd-editor--headline-small .headline p .text-editor, .main-article.sd-editor--headline-small .headline div .text-editor {\n  font-size: 2.3rem; }\n\n.main-article.sd-editor--headline-medium .headline .Editor3-root .DraftEditor-editorContainer {\n  font-size: 2.8rem; }\n\n.main-article.sd-editor--headline-medium .headline .text-editor, .main-article.sd-editor--headline-medium .headline p .text-editor, .main-article.sd-editor--headline-medium .headline div .text-editor {\n  font-size: 2.8rem; }\n\n.main-article.sd-editor--headline-large .headline .Editor3-root .DraftEditor-editorContainer {\n  font-size: 3.2rem; }\n\n.main-article.sd-editor--headline-large .headline .text-editor, .main-article.sd-editor--headline-large .headline p .text-editor, .main-article.sd-editor--headline-large .headline div .text-editor {\n  font-size: 3.2rem; }\n\n.main-article.sd-editor--abstract-small .abstract .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.4rem; }\n\n.main-article.sd-editor--abstract-small .abstract, .main-article.sd-editor--abstract-small .abstract p, .main-article.sd-editor--abstract-small .abstract div {\n  font-size: 1.4rem; }\n\n.main-article.sd-editor--abstract-medium .abstract .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.6rem; }\n\n.main-article.sd-editor--abstract-medium .abstract, .main-article.sd-editor--abstract-medium .abstract p, .main-article.sd-editor--abstract-medium .abstract div {\n  font-size: 1.6rem; }\n\n.main-article.sd-editor--abstract-large .abstract .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.8rem; }\n\n.main-article.sd-editor--abstract-large .abstract, .main-article.sd-editor--abstract-large .abstract p, .main-article.sd-editor--abstract-large .abstract div {\n  font-size: 1.8rem; }\n\n.main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.4rem; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h1 {\n    font-size: 2em; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h2 {\n    font-size: 1.5em;\n    line-height: 140%; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h3 {\n    font-size: 1.125em; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h4 {\n    font-size: 0.875em; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h5 {\n    font-size: 0.75em; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h6 {\n    font-size: 0.6875em;\n    color: inherit;\n    opacity: 0.7;\n    letter-spacing: 0.03em; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h1, .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h2, .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h3, .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h4, .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h5, .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer h6 {\n    line-height: 140%; }\n  .main-article.sd-editor--body-small .Editor3-root .DraftEditor-editorContainer blockquote {\n    margin-left: 0;\n    padding-left: 1em;\n    border-left: 4px solid;\n    font-style: italic; }\n\n.main-article.sd-editor--body-small .body-text .text-editor {\n  font-size: 1.4rem; }\n  .main-article.sd-editor--body-small .body-text .text-editor p {\n    font-size: 1.4rem; }\n\n.main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.6rem; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h1 {\n    font-size: 2em; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h2 {\n    font-size: 1.5em;\n    line-height: 140%; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h3 {\n    font-size: 1.125em; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h4 {\n    font-size: 0.875em; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h5 {\n    font-size: 0.75em; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h6 {\n    font-size: 0.6875em;\n    color: inherit;\n    opacity: 0.7;\n    letter-spacing: 0.03em; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h1, .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h2, .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h3, .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h4, .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h5, .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer h6 {\n    line-height: 140%; }\n  .main-article.sd-editor--body-medium .Editor3-root .DraftEditor-editorContainer blockquote {\n    margin-left: 0;\n    padding-left: 1em;\n    border-left: 4px solid;\n    font-style: italic; }\n\n.main-article.sd-editor--body-medium .body-text .text-editor {\n  font-size: 1.6rem; }\n  .main-article.sd-editor--body-medium .body-text .text-editor p {\n    font-size: 1.6rem; }\n\n.main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer {\n  font-size: 1.8rem; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h1 {\n    font-size: 2em; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h2 {\n    font-size: 1.5em;\n    line-height: 140%; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h3 {\n    font-size: 1.125em; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h4 {\n    font-size: 0.875em; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h5 {\n    font-size: 0.75em; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h6 {\n    font-size: 0.6875em;\n    color: inherit;\n    opacity: 0.7;\n    letter-spacing: 0.03em; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h1, .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h2, .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h3, .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h4, .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h5, .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer h6 {\n    line-height: 140%; }\n  .main-article.sd-editor--body-large .Editor3-root .DraftEditor-editorContainer blockquote {\n    margin-left: 0;\n    padding-left: 1em;\n    border-left: 4px solid;\n    font-style: italic; }\n\n.main-article.sd-editor--body-large .body-text .text-editor {\n  font-size: 1.8rem; }\n  .main-article.sd-editor--body-large .body-text .text-editor p {\n    font-size: 1.8rem; }\n", ""]);

// exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "61f366c68d08a6b86be1ab7180420d48.woff";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6cc7f069345cca151d9db92df4c098c4.ttf";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06bc6fd51548f5bb42f45f30e2118c5c.svg";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a42be37032ae31a5c36e9a497cec3f23.ttf";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "32f7d3abad6ee18bc20e5e2489a67ae4.woff";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e23ce1279e353673dd549e19216c893d.svg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "269567460c8f69d08fb089f576d381eb.svg";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9b2bbd9d10bc49388aeee18c536be4f8.png";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e728acd059d8bbb656ca8b18531886f8.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "74a459f6e1c7b87e9fd4b6caad913022.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "98b4de057ec51a608a851751be931e08.png";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac0937f0d9650f7b80a67ed66ae22c28.svg";

/***/ }),
/* 619 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(2);
__webpack_require__(624);
__webpack_require__(259);
__webpack_require__(638);
__webpack_require__(640);
__webpack_require__(642);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(650);
__webpack_require__(165);
__webpack_require__(379);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(59);


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery UI - v1.11.4 - 2015-03-11
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, button.js, datepicker.js, dialog.js, draggable.js, droppable.js, effect.js, effect-blind.js, effect-bounce.js, effect-clip.js, effect-drop.js, effect-explode.js, effect-fade.js, effect-fold.js, effect-highlight.js, effect-puff.js, effect-pulsate.js, effect-scale.js, effect-shake.js, effect-size.js, effect-slide.js, effect-transfer.js, menu.js, progressbar.js, resizable.js, selectable.js, selectmenu.js, slider.js, sortable.js, spinner.js, tabs.js, tooltip.js
* Copyright 2015 jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
	if ( true ) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(14) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {
/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */


// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
	version: "1.11.4",

	keyCode: {
		BACKSPACE: 8,
		COMMA: 188,
		DELETE: 46,
		DOWN: 40,
		END: 35,
		ENTER: 13,
		ESCAPE: 27,
		HOME: 36,
		LEFT: 37,
		PAGE_DOWN: 34,
		PAGE_UP: 33,
		PERIOD: 190,
		RIGHT: 39,
		SPACE: 32,
		TAB: 9,
		UP: 38
	}
});

// plugins
$.fn.extend({
	scrollParent: function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
			}).eq( 0 );

		return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
	},

	uniqueId: (function() {
		var uuid = 0;

		return function() {
			return this.each(function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			});
		};
	})(),

	removeUniqueId: function() {
		return this.each(function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		});
	}
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
	var map, mapName, img,
		nodeName = element.nodeName.toLowerCase();
	if ( "area" === nodeName ) {
		map = element.parentNode;
		mapName = map.name;
		if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
			return false;
		}
		img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
		return !!img && visible( img );
	}
	return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
		!element.disabled :
		"a" === nodeName ?
			element.href || isTabIndexNotNaN :
			isTabIndexNotNaN) &&
		// the element and all of its ancestors must be visible
		visible( element );
}

function visible( element ) {
	return $.expr.filters.visible( element ) &&
		!$( element ).parents().addBack().filter(function() {
			return $.css( this, "visibility" ) === "hidden";
		}).length;
}

$.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo(function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		}) :
		// support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		},

	focusable: function( element ) {
		return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
	},

	tabbable: function( element ) {
		var tabIndex = $.attr( element, "tabindex" ),
			isTabIndexNaN = isNaN( tabIndex );
		return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
	}
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
	$.each( [ "Width", "Height" ], function( i, name ) {
		var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
			type = name.toLowerCase(),
			orig = {
				innerWidth: $.fn.innerWidth,
				innerHeight: $.fn.innerHeight,
				outerWidth: $.fn.outerWidth,
				outerHeight: $.fn.outerHeight
			};

		function reduce( elem, size, border, margin ) {
			$.each( side, function() {
				size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
				if ( border ) {
					size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
				}
				if ( margin ) {
					size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
				}
			});
			return size;
		}

		$.fn[ "inner" + name ] = function( size ) {
			if ( size === undefined ) {
				return orig[ "inner" + name ].call( this );
			}

			return this.each(function() {
				$( this ).css( type, reduce( this, size ) + "px" );
			});
		};

		$.fn[ "outer" + name] = function( size, margin ) {
			if ( typeof size !== "number" ) {
				return orig[ "outer" + name ].call( this, size );
			}

			return this.each(function() {
				$( this).css( type, reduce( this, size, true, margin ) + "px" );
			});
		};
	});
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
	$.fn.removeData = (function( removeData ) {
		return function( key ) {
			if ( arguments.length ) {
				return removeData.call( this, $.camelCase( key ) );
			} else {
				return removeData.call( this );
			}
		};
	})( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
	focus: (function( orig ) {
		return function( delay, fn ) {
			return typeof delay === "number" ?
				this.each(function() {
					var elem = this;
					setTimeout(function() {
						$( elem ).focus();
						if ( fn ) {
							fn.call( elem );
						}
					}, delay );
				}) :
				orig.apply( this, arguments );
		};
	})( $.fn.focus ),

	disableSelection: (function() {
		var eventType = "onselectstart" in document.createElement( "div" ) ?
			"selectstart" :
			"mousedown";

		return function() {
			return this.bind( eventType + ".ui-disableSelection", function( event ) {
				event.preventDefault();
			});
		};
	})(),

	enableSelection: function() {
		return this.unbind( ".ui-disableSelection" );
	},

	zIndex: function( zIndex ) {
		if ( zIndex !== undefined ) {
			return this.css( "zIndex", zIndex );
		}

		if ( this.length ) {
			var elem = $( this[ 0 ] ), position, value;
			while ( elem.length && elem[ 0 ] !== document ) {
				// Ignore z-index if position is set to a value where z-index is ignored by the browser
				// This makes behavior of this function consistent across browsers
				// WebKit always returns auto if the element is positioned
				position = elem.css( "position" );
				if ( position === "absolute" || position === "relative" || position === "fixed" ) {
					// IE returns 0 when zIndex is not specified
					// other browsers return a string
					// we ignore the case of nested elements with an explicit value of 0
					// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
					value = parseInt( elem.css( "zIndex" ), 10 );
					if ( !isNaN( value ) && value !== 0 ) {
						return value;
					}
				}
				elem = elem.parent();
			}
		}

		return 0;
	}
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
	add: function( module, option, set ) {
		var i,
			proto = $.ui[ module ].prototype;
		for ( i in set ) {
			proto.plugins[ i ] = proto.plugins[ i ] || [];
			proto.plugins[ i ].push( [ option, set[ i ] ] );
		}
	},
	call: function( instance, name, args, allowDisconnected ) {
		var i,
			set = instance.plugins[ name ];

		if ( !set ) {
			return;
		}

		if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
			return;
		}

		for ( i = 0; i < set.length; i++ ) {
			if ( instance.options[ set[ i ][ 0 ] ] ) {
				set[ i ][ 1 ].apply( instance.element, args );
			}
		}
	}
};


/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */


var widget_uuid = 0,
	widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; (elem = elems[i]) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
})( $.cleanData );

$.widget = function( name, base, prototype ) {
	var fullName, existingConstructor, constructor, basePrototype,
		// proxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		proxiedPrototype = {},
		namespace = name.split( "." )[ 0 ];

	name = name.split( "." )[ 1 ];
	fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	// create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {
		// allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};
	// extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,
		// copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),
		// track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	});

	basePrototype = new base();
	// we need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = (function() {
			var _super = function() {
					return base.prototype[ prop ].apply( this, arguments );
				},
				_superApply = function( args ) {
					return base.prototype[ prop ].apply( this, args );
				};
			return function() {
				var __super = this._super,
					__superApply = this._superApply,
					returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		})();
	});
	constructor.prototype = $.widget.extend( basePrototype, {
		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	});

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
		});
		// remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widget_slice.call( arguments, 1 ),
		inputIndex = 0,
		inputLength = input.length,
		key,
		value;
	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :
						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );
				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string",
			args = widget_slice.call( arguments, 1 ),
			returnValue = this;

		if ( isMethodCall ) {
			this.each(function() {
				var methodValue,
					instance = $.data( this, fullName );
				if ( options === "instance" ) {
					returnValue = instance;
					return false;
				}
				if ( !instance ) {
					return $.error( "cannot call methods on " + name + " prior to initialization; " +
						"attempted to call method '" + options + "'" );
				}
				if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
					return $.error( "no such method '" + options + "' for " + name + " widget instance" );
				}
				methodValue = instance[ options ].apply( instance, args );
				if ( methodValue !== instance && methodValue !== undefined ) {
					returnValue = methodValue && methodValue.jquery ?
						returnValue.pushStack( methodValue.get() ) :
						methodValue;
					return false;
				}
			});
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat(args) );
			}

			this.each(function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			});
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",
	options: {
		disabled: false,

		// callbacks
		create: null
	},
	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widget_uuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			});
			this.document = $( element.style ?
				// element within the document
				element.ownerDocument :
				// element is window or document
				element.document || element );
			this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();
		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},
	_getCreateOptions: $.noop,
	_getCreateEventData: $.noop,
	_create: $.noop,
	_init: $.noop,

	destroy: function() {
		this._destroy();
		// we can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.unbind( this.eventNamespace )
			.removeData( this.widgetFullName )
			// support: jquery <1.6.3
			// http://bugs.jquery.com/ticket/9413
			.removeData( $.camelCase( this.widgetFullName ) );
		this.widget()
			.unbind( this.eventNamespace )
			.removeAttr( "aria-disabled" )
			.removeClass(
				this.widgetFullName + "-disabled " +
				"ui-state-disabled" );

		// clean up events and states
		this.bindings.unbind( this.eventNamespace );
		this.hoverable.removeClass( "ui-state-hover" );
		this.focusable.removeClass( "ui-state-focus" );
	},
	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key,
			parts,
			curOption,
			i;

		if ( arguments.length === 0 ) {
			// don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {
			// handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},
	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},
	_setOption: function( key, value ) {
		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this.widget()
				.toggleClass( this.widgetFullName + "-disabled", !!value );

			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this.hoverable.removeClass( "ui-state-hover" );
				this.focusable.removeClass( "ui-state-focus" );
			}
		}

		return this;
	},

	enable: function() {
		return this._setOptions({ disabled: false });
	},
	disable: function() {
		return this._setOptions({ disabled: true });
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement,
			instance = this;

		// no suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// no element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {
				// allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
				eventName = match[1] + instance.eventNamespace,
				selector = match[2];
			if ( selector ) {
				delegateElement.delegate( selector, eventName, handlerProxy );
			} else {
				element.bind( eventName, handlerProxy );
			}
		});
	},

	_off: function( element, eventName ) {
		eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.unbind( eventName ).undelegate( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-hover" );
			},
			mouseleave: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-hover" );
			}
		});
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				$( event.currentTarget ).addClass( "ui-state-focus" );
			},
			focusout: function( event ) {
				$( event.currentTarget ).removeClass( "ui-state-focus" );
			}
		});
	},

	_trigger: function( type, event, data ) {
		var prop, orig,
			callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();
		// the original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}
		var hasOptions,
			effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}
		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;
		if ( options.delay ) {
			element.delay( options.delay );
		}
		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue(function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			});
		}
	};
});

var widget = $.widget;


/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */


var mouseHandled = false;
$( document ).mouseup( function() {
	mouseHandled = false;
});

var mouse = $.widget("ui.mouse", {
	version: "1.11.4",
	options: {
		cancel: "input,textarea,button,select,option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.bind("mousedown." + this.widgetName, function(event) {
				return that._mouseDown(event);
			})
			.bind("click." + this.widgetName, function(event) {
				if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
					$.removeData(event.target, that.widgetName + ".preventClickEvent");
					event.stopImmediatePropagation();
					return false;
				}
			});

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.unbind("." + this.widgetName);
		if ( this._mouseMoveDelegate ) {
			this.document
				.unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
				.unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
		}
	},

	_mouseDown: function(event) {
		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// we may have missed mouseup (out of window)
		(this._mouseStarted && this._mouseUp(event));

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = (event.which === 1),
			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
		if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if (!this.mouseDelayMet) {
			this._mouseDelayTimer = setTimeout(function() {
				that.mouseDelayMet = true;
			}, this.options.delay);
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted = (this._mouseStart(event) !== false);
			if (!this._mouseStarted) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
			$.removeData(event.target, this.widgetName + ".preventClickEvent");
		}

		// these delegates are required to keep context
		this._mouseMoveDelegate = function(event) {
			return that._mouseMove(event);
		};
		this._mouseUpDelegate = function(event) {
			return that._mouseUp(event);
		};

		this.document
			.bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function(event) {
		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {
			// IE mouseup check - mouseup happened when mouse was out of window
			if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
				return this._mouseUp(event);

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {
				return this._mouseUp( event );
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if (this._mouseStarted) {
			this._mouseDrag(event);
			return event.preventDefault();
		}

		if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
			this._mouseStarted =
				(this._mouseStart(this._mouseDownEvent, event) !== false);
			(this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
		}

		return !this._mouseStarted;
	},

	_mouseUp: function(event) {
		this.document
			.unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if (this._mouseStarted) {
			this._mouseStarted = false;

			if (event.target === this._mouseDownEvent.target) {
				$.data(event.target, this.widgetName + ".preventClickEvent", true);
			}

			this._mouseStop(event);
		}

		mouseHandled = false;
		return false;
	},

	_mouseDistanceMet: function(event) {
		return (Math.max(
				Math.abs(this._mouseDownEvent.pageX - event.pageX),
				Math.abs(this._mouseDownEvent.pageY - event.pageY)
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function(/* event */) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function(/* event */) {},
	_mouseDrag: function(/* event */) {},
	_mouseStop: function(/* event */) {},
	_mouseCapture: function(/* event */) { return true; }
});


/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
	max = Math.max,
	abs = Math.abs,
	round = Math.round,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[0];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[0];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[0].clientWidth;
		}

		div.remove();

		return (cachedScrollbarWidth = w1 - w2);
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[0].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[0] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: withinElement.offset() || { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),

			// support: jQuery 1.6.x
			// jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
			width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
			height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[0].preventDefault ) {
		// force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;
	// clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	});

	// normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each(function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		// if the browser doesn't support fractions, then round for consistent results
		if ( !supportsOffsetFractions ) {
			position.left = round( position.left );
			position.top = round( position.top );
		}

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				});
			}
		});

		if ( options.using ) {
			// adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	});
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// element is wider than within
			if ( data.collisionWidth > outerWidth ) {
				// element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
					position.left += overLeft - newOverRight;
				// element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;
				// element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}
			// too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;
			// too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;
			// adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// element is taller than within
			if ( data.collisionHeight > outerHeight ) {
				// element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
					position.top += overTop - newOverBottom;
				// element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;
				// element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}
			// too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;
			// too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;
			// adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

// fraction support test
(function() {
	var testElement, testElementParent, testElementStyle, offsetLeft, i,
		body = document.getElementsByTagName( "body" )[ 0 ],
		div = document.createElement( "div" );

	//Create a "fake body" for testing based on method used in jQuery.support
	testElement = document.createElement( body ? "div" : "body" );
	testElementStyle = {
		visibility: "hidden",
		width: 0,
		height: 0,
		border: 0,
		margin: 0,
		background: "none"
	};
	if ( body ) {
		$.extend( testElementStyle, {
			position: "absolute",
			left: "-1000px",
			top: "-1000px"
		});
	}
	for ( i in testElementStyle ) {
		testElement.style[ i ] = testElementStyle[ i ];
	}
	testElement.appendChild( div );
	testElementParent = body || document.documentElement;
	testElementParent.insertBefore( testElement, testElementParent.firstChild );

	div.style.cssText = "position: absolute; left: 10.7432222px;";

	offsetLeft = $( div ).offset().left;
	supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

	testElement.innerHTML = "";
	testElementParent.removeChild( testElement );
})();

})();

var position = $.ui.position;


/*!
 * jQuery UI Accordion 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/accordion/
 */


var accordion = $.widget( "ui.accordion", {
	version: "1.11.4",
	options: {
		active: 0,
		animate: {},
		collapsible: false,
		event: "click",
		header: "> li > :first-child,> :not(li):even",
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;
		this.prevShow = this.prevHide = $();
		this.element.addClass( "ui-accordion ui-widget ui-helper-reset" )
			// ARIA
			.attr( "role", "tablist" );

		// don't allow collapsible: false and active: false / null
		if ( !options.collapsible && (options.active === false || options.active == null) ) {
			options.active = 0;
		}

		this._processPanels();
		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icons = this.options.icons;
		if ( icons ) {
			$( "<span>" )
				.addClass( "ui-accordion-header-icon ui-icon " + icons.header )
				.prependTo( this.headers );
			this.active.children( ".ui-accordion-header-icon" )
				.removeClass( icons.header )
				.addClass( icons.activeHeader );
			this.headers.addClass( "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this.headers
			.removeClass( "ui-accordion-icons" )
			.children( ".ui-accordion-header-icon" )
				.remove();
	},

	_destroy: function() {
		var contents;

		// clean up main element
		this.element
			.removeClass( "ui-accordion ui-widget ui-helper-reset" )
			.removeAttr( "role" );

		// clean up headers
		this.headers
			.removeClass( "ui-accordion-header ui-accordion-header-active ui-state-default " +
				"ui-corner-all ui-state-active ui-state-disabled ui-corner-top" )
			.removeAttr( "role" )
			.removeAttr( "aria-expanded" )
			.removeAttr( "aria-selected" )
			.removeAttr( "aria-controls" )
			.removeAttr( "tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// clean up content panels
		contents = this.headers.next()
			.removeClass( "ui-helper-reset ui-widget-content ui-corner-bottom " +
				"ui-accordion-content ui-accordion-content-active ui-state-disabled" )
			.css( "display", "" )
			.removeAttr( "role" )
			.removeAttr( "aria-hidden" )
			.removeAttr( "aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {
			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}

		// #5332 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		if ( key === "disabled" ) {
			this.element
				.toggleClass( "ui-state-disabled", !!value )
				.attr( "aria-disabled", value );
			this.headers.add( this.headers.next() )
				.toggleClass( "ui-state-disabled", !!value );
		}
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
			case keyCode.RIGHT:
			case keyCode.DOWN:
				toFocus = this.headers[ ( currentIndex + 1 ) % length ];
				break;
			case keyCode.LEFT:
			case keyCode.UP:
				toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
				break;
			case keyCode.SPACE:
			case keyCode.ENTER:
				this._eventHandler( event );
				break;
			case keyCode.HOME:
				toFocus = this.headers[ 0 ];
				break;
			case keyCode.END:
				toFocus = this.headers[ length - 1 ];
				break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			toFocus.focus();
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().focus();
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) || !this.headers.length ) {
			options.active = false;
			this.active = $();
		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );
		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find(".ui-state-disabled").length ) {
				options.active = false;
				this.active = $();
			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}
		// was active, active panel still exists
		} else {
			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		this.headers = this.element.find( this.options.header )
			.addClass( "ui-accordion-header ui-state-default ui-corner-all" );

		this.panels = this.headers.next()
			.addClass( "ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom" )
			.filter( ":not(.ui-accordion-content-active)" )
			.hide();

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active )
			.addClass( "ui-accordion-header-active ui-state-active ui-corner-top" )
			.removeClass( "ui-corner-all" );
		this.active.next()
			.addClass( "ui-accordion-content-active" )
			.show();

		this.headers
			.attr( "role", "tab" )
			.each(function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			})
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
			.attr({
				"aria-selected": "false",
				"aria-expanded": "false",
				tabIndex: -1
			})
			.next()
				.attr({
					"aria-hidden": "true"
				})
				.hide();

		// make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr({
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			})
			.next()
				.attr({
					"aria-hidden": "false"
				});
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each(function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			});

			this.headers.each(function() {
				maxHeight -= $( this ).outerHeight( true );
			});

			this.headers.next()
				.each(function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				})
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each(function() {
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
				})
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler({
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		});
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			});
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" });
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (
				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||
				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// when the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// switch classes
		// corner classes on the previously active header stay after the animation
		active.removeClass( "ui-accordion-header-active ui-state-active" );
		if ( options.icons ) {
			active.children( ".ui-accordion-header-icon" )
				.removeClass( options.icons.activeHeader )
				.addClass( options.icons.header );
		}

		if ( !clickedIsActive ) {
			clicked
				.removeClass( "ui-corner-all" )
				.addClass( "ui-accordion-header-active ui-state-active ui-corner-top" );
			if ( options.icons ) {
				clicked.children( ".ui-accordion-header-icon" )
					.removeClass( options.icons.header )
					.addClass( options.icons.activeHeader );
			}

			clicked
				.next()
				.addClass( "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr({
			"aria-hidden": "true"
		});
		toHide.prev().attr({
			"aria-selected": "false",
			"aria-expanded": "false"
		});
		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr({
				"tabIndex": -1,
				"aria-expanded": "false"
			});
		} else if ( toShow.length ) {
			this.headers.filter(function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			})
			.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr({
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				});
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}
		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		});
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			});
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel;

		toHide
			.removeClass( "ui-accordion-content-active" )
			.prev()
				.removeClass( "ui-corner-top" )
				.addClass( "ui-corner-all" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
});


/*!
 * jQuery UI Menu 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/menu/
 */


var menu = $.widget( "ui.menu", {
	version: "1.11.4",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-carat-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left-1 top",
			at: "right top"
		},
		role: "menu",

		// callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.addClass( "ui-menu ui-widget ui-widget-content" )
			.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
			.attr({
				role: this.options.role,
				tabIndex: 0
			});

		if ( this.options.disabled ) {
			this.element
				.addClass( "ui-state-disabled" )
				.attr( "aria-disabled", "true" );
		}

		this._on({
			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) && $( this.document[ 0 ].activeElement ).closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {
				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}
				var target = $( event.currentTarget );
				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				target.siblings( ".ui-state-active" ).removeClass( "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {
				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay(function() {
					if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
						this.collapseAll( event );
					}
				});
			},
			keydown: "_keydown"
		});

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		});
	},

	_destroy: function() {
		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeClass( "ui-menu ui-widget ui-widget-content ui-menu-icons ui-front" )
				.removeAttr( "role" )
				.removeAttr( "tabIndex" )
				.removeAttr( "aria-labelledby" )
				.removeAttr( "aria-expanded" )
				.removeAttr( "aria-hidden" )
				.removeAttr( "aria-disabled" )
				.removeUniqueId()
				.show();

		// Destroy menu items
		this.element.find( ".ui-menu-item" )
			.removeClass( "ui-menu-item" )
			.removeAttr( "role" )
			.removeAttr( "aria-disabled" )
			.removeUniqueId()
			.removeClass( "ui-state-hover" )
			.removeAttr( "tabIndex" )
			.removeAttr( "role" )
			.removeAttr( "aria-haspopup" )
			.children().each( function() {
				var elem = $( this );
				if ( elem.data( "ui-menu-submenu-carat" ) ) {
					elem.remove();
				}
			});

		// Destroy menu dividers
		this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			character = String.fromCharCode( event.keyCode );
			skip = false;

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay(function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.is( "[aria-haspopup='true']" ) ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this.element.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		submenus.filter( ":not(.ui-menu)" )
			.addClass( "ui-menu ui-widget ui-widget-content ui-front" )
			.hide()
			.attr({
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			})
			.each(function() {
				var menu = $( this ),
					item = menu.parent(),
					submenuCarat = $( "<span>" )
						.addClass( "ui-menu-icon ui-icon " + icon )
						.data( "ui-menu-submenu-carat", true );

				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCarat );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			});

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each(function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				item.addClass( "ui-widget-content ui-menu-divider" );
			}
		});

		// Don't refresh list items that are already adapted
		items.not( ".ui-menu-item, .ui-menu-divider" )
			.addClass( "ui-menu-item" )
			.uniqueId()
			.attr({
				tabIndex: -1,
				role: this._itemRole()
			});

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			this.element.find( ".ui-menu-icon" )
				.removeClass( this.options.icons.submenu )
				.addClass( value.submenu );
		}
		if ( key === "disabled" ) {
			this.element
				.toggleClass( "ui-state-disabled", !!value )
				.attr( "aria-disabled", value );
		}
		this._super( key, value );
	},

	focus: function( event, item ) {
		var nested, focused;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();
		focused = this.active.addClass( "ui-state-focus" ).removeClass( "ui-state-active" );
		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		this.active
			.parent()
			.closest( ".ui-menu-item" )
			.addClass( "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay(function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening(nested);
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this.active.removeClass( "ui-state-focus" );
		this.active = null;

		this._trigger( "blur", event, { item: this.active } );
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the carat icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay(function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend({
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay(function() {
			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );
			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu
			.find( ".ui-menu" )
				.hide()
				.attr( "aria-hidden", "true" )
				.attr( "aria-expanded", "false" )
			.end()
			.find( ".ui-state-active" ).not( ".ui-state-focus" )
				.removeClass( "ui-state-active" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
				.find( this.options.items )
				.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay(function() {
				this.focus( event, newItem );
			});
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each(function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			});

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {
		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function(character) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

			// Only match on items, not dividers or other content (#10571)
			.filter( ".ui-menu-item" )
			.filter(function() {
				return regex.test( $.trim( $( this ).text() ) );
			});
	}
});


/*!
 * jQuery UI Autocomplete 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/autocomplete/
 */


$.widget( "ui.autocomplete", {
	version: "1.11.4",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {
		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		this.isMultiLine =
			// Textareas are always multi-line
			isTextarea ? true :
			// Inputs are always single-line, even if inside a contentEditable element
			// IE also treats inputs as contentEditable
			isInput ? false :
			// All other element types are determined by whether or not they're contentEditable
			this.element.prop( "isContentEditable" );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this.element
			.addClass( "ui-autocomplete-input" )
			.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:
					// when menu is open and has focus
					if ( this.menu.active ) {
						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );
						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;
					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		});

		this._initSource();
		this.menu = $( "<ul>" )
			.addClass( "ui-autocomplete ui-front" )
			.appendTo( this._appendTo() )
			.menu({
				// disable ARIA support, the live region takes care of that
				role: null
			})
			.hide()
			.menu( "instance" );

		this._on( this.menu.element, {
			mousedown: function( event ) {
				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay(function() {
					delete this.cancelBlur;
				});

				// clicking on the scrollbar causes focus to shift to the body
				// but we can't detect a mouseup or a click immediately afterward
				// so we have to track the next mousedown and close the menu if
				// the user clicks somewhere outside of the autocomplete
				var menuElement = this.menu.element[ 0 ];
				if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
					this._delay(function() {
						var that = this;
						this.document.one( "mousedown", function( event ) {
							if ( event.target !== that.element[ 0 ] &&
									event.target !== menuElement &&
									!$.contains( menuElement, event.target ) ) {
								that.close();
							}
						});
					});
				}
			},
			menufocus: function( event, ui ) {
				var label, item;
				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						});

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {
					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
					this.element.focus();
					this.previous = previous;
					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay(function() {
						this.previous = previous;
						this.selectedItem = item;
					});
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}
				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		});

		this.liveRegion = $( "<span>", {
				role: "status",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			})
			.addClass( "ui-helper-hidden-accessible" )
			.appendTo( this.document[ 0 ].body );

		// turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		});
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element
			.removeClass( "ui-autocomplete-input" )
			.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax({
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response([]);
					}
				});
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay(function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this.element.addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy(function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this.element.removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {
			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {
		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {
		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			});
		});
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend({
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(
			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		});
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" ).text( item.label ).appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	}
});

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		});
	}
});

// live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
});

var autocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Button 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/button/
 */


var lastActive,
	baseClasses = "ui-button ui-widget ui-state-default ui-corner-all",
	typeClasses = "ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",
	formResetHandler = function() {
		var form = $( this );
		setTimeout(function() {
			form.find( ":ui-button" ).button( "refresh" );
		}, 1 );
	},
	radioGroup = function( radio ) {
		var name = radio.name,
			form = radio.form,
			radios = $( [] );
		if ( name ) {
			name = name.replace( /'/g, "\\'" );
			if ( form ) {
				radios = $( form ).find( "[name='" + name + "'][type=radio]" );
			} else {
				radios = $( "[name='" + name + "'][type=radio]", radio.ownerDocument )
					.filter(function() {
						return !this.form;
					});
			}
		}
		return radios;
	};

$.widget( "ui.button", {
	version: "1.11.4",
	defaultElement: "<button>",
	options: {
		disabled: null,
		text: true,
		label: null,
		icons: {
			primary: null,
			secondary: null
		}
	},
	_create: function() {
		this.element.closest( "form" )
			.unbind( "reset" + this.eventNamespace )
			.bind( "reset" + this.eventNamespace, formResetHandler );

		if ( typeof this.options.disabled !== "boolean" ) {
			this.options.disabled = !!this.element.prop( "disabled" );
		} else {
			this.element.prop( "disabled", this.options.disabled );
		}

		this._determineButtonType();
		this.hasTitle = !!this.buttonElement.attr( "title" );

		var that = this,
			options = this.options,
			toggleButton = this.type === "checkbox" || this.type === "radio",
			activeClass = !toggleButton ? "ui-state-active" : "";

		if ( options.label === null ) {
			options.label = (this.type === "input" ? this.buttonElement.val() : this.buttonElement.html());
		}

		this._hoverable( this.buttonElement );

		this.buttonElement
			.addClass( baseClasses )
			.attr( "role", "button" )
			.bind( "mouseenter" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				if ( this === lastActive ) {
					$( this ).addClass( "ui-state-active" );
				}
			})
			.bind( "mouseleave" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return;
				}
				$( this ).removeClass( activeClass );
			})
			.bind( "click" + this.eventNamespace, function( event ) {
				if ( options.disabled ) {
					event.preventDefault();
					event.stopImmediatePropagation();
				}
			});

		// Can't use _focusable() because the element that receives focus
		// and the element that gets the ui-state-focus class are different
		this._on({
			focus: function() {
				this.buttonElement.addClass( "ui-state-focus" );
			},
			blur: function() {
				this.buttonElement.removeClass( "ui-state-focus" );
			}
		});

		if ( toggleButton ) {
			this.element.bind( "change" + this.eventNamespace, function() {
				that.refresh();
			});
		}

		if ( this.type === "checkbox" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
			});
		} else if ( this.type === "radio" ) {
			this.buttonElement.bind( "click" + this.eventNamespace, function() {
				if ( options.disabled ) {
					return false;
				}
				$( this ).addClass( "ui-state-active" );
				that.buttonElement.attr( "aria-pressed", "true" );

				var radio = that.element[ 0 ];
				radioGroup( radio )
					.not( radio )
					.map(function() {
						return $( this ).button( "widget" )[ 0 ];
					})
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			});
		} else {
			this.buttonElement
				.bind( "mousedown" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).addClass( "ui-state-active" );
					lastActive = this;
					that.document.one( "mouseup", function() {
						lastActive = null;
					});
				})
				.bind( "mouseup" + this.eventNamespace, function() {
					if ( options.disabled ) {
						return false;
					}
					$( this ).removeClass( "ui-state-active" );
				})
				.bind( "keydown" + this.eventNamespace, function(event) {
					if ( options.disabled ) {
						return false;
					}
					if ( event.keyCode === $.ui.keyCode.SPACE || event.keyCode === $.ui.keyCode.ENTER ) {
						$( this ).addClass( "ui-state-active" );
					}
				})
				// see #8559, we bind to blur here in case the button element loses
				// focus between keydown and keyup, it would be left in an "active" state
				.bind( "keyup" + this.eventNamespace + " blur" + this.eventNamespace, function() {
					$( this ).removeClass( "ui-state-active" );
				});

			if ( this.buttonElement.is("a") ) {
				this.buttonElement.keyup(function(event) {
					if ( event.keyCode === $.ui.keyCode.SPACE ) {
						// TODO pass through original event correctly (just as 2nd argument doesn't work)
						$( this ).click();
					}
				});
			}
		}

		this._setOption( "disabled", options.disabled );
		this._resetButton();
	},

	_determineButtonType: function() {
		var ancestor, labelSelector, checked;

		if ( this.element.is("[type=checkbox]") ) {
			this.type = "checkbox";
		} else if ( this.element.is("[type=radio]") ) {
			this.type = "radio";
		} else if ( this.element.is("input") ) {
			this.type = "input";
		} else {
			this.type = "button";
		}

		if ( this.type === "checkbox" || this.type === "radio" ) {
			// we don't search against the document in case the element
			// is disconnected from the DOM
			ancestor = this.element.parents().last();
			labelSelector = "label[for='" + this.element.attr("id") + "']";
			this.buttonElement = ancestor.find( labelSelector );
			if ( !this.buttonElement.length ) {
				ancestor = ancestor.length ? ancestor.siblings() : this.element.siblings();
				this.buttonElement = ancestor.filter( labelSelector );
				if ( !this.buttonElement.length ) {
					this.buttonElement = ancestor.find( labelSelector );
				}
			}
			this.element.addClass( "ui-helper-hidden-accessible" );

			checked = this.element.is( ":checked" );
			if ( checked ) {
				this.buttonElement.addClass( "ui-state-active" );
			}
			this.buttonElement.prop( "aria-pressed", checked );
		} else {
			this.buttonElement = this.element;
		}
	},

	widget: function() {
		return this.buttonElement;
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-helper-hidden-accessible" );
		this.buttonElement
			.removeClass( baseClasses + " ui-state-active " + typeClasses )
			.removeAttr( "role" )
			.removeAttr( "aria-pressed" )
			.html( this.buttonElement.find(".ui-button-text").html() );

		if ( !this.hasTitle ) {
			this.buttonElement.removeAttr( "title" );
		}
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "disabled" ) {
			this.widget().toggleClass( "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			if ( value ) {
				if ( this.type === "checkbox" || this.type === "radio" ) {
					this.buttonElement.removeClass( "ui-state-focus" );
				} else {
					this.buttonElement.removeClass( "ui-state-focus ui-state-active" );
				}
			}
			return;
		}
		this._resetButton();
	},

	refresh: function() {
		//See #8237 & #8828
		var isDisabled = this.element.is( "input, button" ) ? this.element.is( ":disabled" ) : this.element.hasClass( "ui-button-disabled" );

		if ( isDisabled !== this.options.disabled ) {
			this._setOption( "disabled", isDisabled );
		}
		if ( this.type === "radio" ) {
			radioGroup( this.element[0] ).each(function() {
				if ( $( this ).is( ":checked" ) ) {
					$( this ).button( "widget" )
						.addClass( "ui-state-active" )
						.attr( "aria-pressed", "true" );
				} else {
					$( this ).button( "widget" )
						.removeClass( "ui-state-active" )
						.attr( "aria-pressed", "false" );
				}
			});
		} else if ( this.type === "checkbox" ) {
			if ( this.element.is( ":checked" ) ) {
				this.buttonElement
					.addClass( "ui-state-active" )
					.attr( "aria-pressed", "true" );
			} else {
				this.buttonElement
					.removeClass( "ui-state-active" )
					.attr( "aria-pressed", "false" );
			}
		}
	},

	_resetButton: function() {
		if ( this.type === "input" ) {
			if ( this.options.label ) {
				this.element.val( this.options.label );
			}
			return;
		}
		var buttonElement = this.buttonElement.removeClass( typeClasses ),
			buttonText = $( "<span></span>", this.document[0] )
				.addClass( "ui-button-text" )
				.html( this.options.label )
				.appendTo( buttonElement.empty() )
				.text(),
			icons = this.options.icons,
			multipleIcons = icons.primary && icons.secondary,
			buttonClasses = [];

		if ( icons.primary || icons.secondary ) {
			if ( this.options.text ) {
				buttonClasses.push( "ui-button-text-icon" + ( multipleIcons ? "s" : ( icons.primary ? "-primary" : "-secondary" ) ) );
			}

			if ( icons.primary ) {
				buttonElement.prepend( "<span class='ui-button-icon-primary ui-icon " + icons.primary + "'></span>" );
			}

			if ( icons.secondary ) {
				buttonElement.append( "<span class='ui-button-icon-secondary ui-icon " + icons.secondary + "'></span>" );
			}

			if ( !this.options.text ) {
				buttonClasses.push( multipleIcons ? "ui-button-icons-only" : "ui-button-icon-only" );

				if ( !this.hasTitle ) {
					buttonElement.attr( "title", $.trim( buttonText ) );
				}
			}
		} else {
			buttonClasses.push( "ui-button-text-only" );
		}
		buttonElement.addClass( buttonClasses.join( " " ) );
	}
});

$.widget( "ui.buttonset", {
	version: "1.11.4",
	options: {
		items: "button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"
	},

	_create: function() {
		this.element.addClass( "ui-buttonset" );
	},

	_init: function() {
		this.refresh();
	},

	_setOption: function( key, value ) {
		if ( key === "disabled" ) {
			this.buttons.button( "option", key, value );
		}

		this._super( key, value );
	},

	refresh: function() {
		var rtl = this.element.css( "direction" ) === "rtl",
			allButtons = this.element.find( this.options.items ),
			existingButtons = allButtons.filter( ":ui-button" );

		// Initialize new buttons
		allButtons.not( ":ui-button" ).button();

		// Refresh existing buttons
		existingButtons.button( "refresh" );

		this.buttons = allButtons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-all ui-corner-left ui-corner-right" )
				.filter( ":first" )
					.addClass( rtl ? "ui-corner-right" : "ui-corner-left" )
				.end()
				.filter( ":last" )
					.addClass( rtl ? "ui-corner-left" : "ui-corner-right" )
				.end()
			.end();
	},

	_destroy: function() {
		this.element.removeClass( "ui-buttonset" );
		this.buttons
			.map(function() {
				return $( this ).button( "widget" )[ 0 ];
			})
				.removeClass( "ui-corner-left ui-corner-right" )
			.end()
			.button( "destroy" );
	}
});

var button = $.ui.button;


/*!
 * jQuery UI Datepicker 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/datepicker/
 */


$.extend($.ui, { datepicker: { version: "1.11.4" } });

var datepicker_instActive;

function datepicker_getZindex( elem ) {
	var position, value;
	while ( elem.length && elem[ 0 ] !== document ) {
		// Ignore z-index if position is set to a value where z-index is ignored by the browser
		// This makes behavior of this function consistent across browsers
		// WebKit always returns auto if the element is positioned
		position = elem.css( "position" );
		if ( position === "absolute" || position === "relative" || position === "fixed" ) {
			// IE returns 0 when zIndex is not specified
			// other browsers return a string
			// we ignore the case of nested elements with an explicit value of 0
			// <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
			value = parseInt( elem.css( "zIndex" ), 10 );
			if ( !isNaN( value ) && value !== 0 ) {
				return value;
			}
		}
		elem = elem.parent();
	}

	return 0;
}
/* Date picker manager.
   Use the singleton instance of this class, $.datepicker, to interact with the date picker.
   Settings for (groups of) date pickers are maintained in an instance object,
   allowing multiple different settings on the same page. */

function Datepicker() {
	this._curInst = null; // The current instance in use
	this._keyEvent = false; // If the last event was a key event
	this._disabledInputs = []; // List of date picker inputs that have been disabled
	this._datepickerShowing = false; // True if the popup picker is showing , false if not
	this._inDialog = false; // True if showing within a "dialog", false if not
	this._mainDivId = "ui-datepicker-div"; // The ID of the main datepicker division
	this._inlineClass = "ui-datepicker-inline"; // The name of the inline marker class
	this._appendClass = "ui-datepicker-append"; // The name of the append marker class
	this._triggerClass = "ui-datepicker-trigger"; // The name of the trigger marker class
	this._dialogClass = "ui-datepicker-dialog"; // The name of the dialog marker class
	this._disableClass = "ui-datepicker-disabled"; // The name of the disabled covering marker class
	this._unselectableClass = "ui-datepicker-unselectable"; // The name of the unselectable cell marker class
	this._currentClass = "ui-datepicker-current-day"; // The name of the current day marker class
	this._dayOverClass = "ui-datepicker-days-cell-over"; // The name of the day hover marker class
	this.regional = []; // Available regional settings, indexed by language code
	this.regional[""] = { // Default regional settings
		closeText: "Done", // Display text for close link
		prevText: "Prev", // Display text for previous month link
		nextText: "Next", // Display text for next month link
		currentText: "Today", // Display text for current month link
		monthNames: ["January","February","March","April","May","June",
			"July","August","September","October","November","December"], // Names of months for drop-down and formatting
		monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // For formatting
		dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], // For formatting
		dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // For formatting
		dayNamesMin: ["Su","Mo","Tu","We","Th","Fr","Sa"], // Column headings for days starting at Sunday
		weekHeader: "Wk", // Column header for week of the year
		dateFormat: "mm/dd/yy", // See format options on parseDate
		firstDay: 0, // The first day of the week, Sun = 0, Mon = 1, ...
		isRTL: false, // True if right-to-left language, false if left-to-right
		showMonthAfterYear: false, // True if the year select precedes month, false for month then year
		yearSuffix: "" // Additional text to append to the year in the month headers
	};
	this._defaults = { // Global defaults for all the date picker instances
		showOn: "focus", // "focus" for popup on focus,
			// "button" for trigger button, or "both" for either
		showAnim: "fadeIn", // Name of jQuery animation for popup
		showOptions: {}, // Options for enhanced animations
		defaultDate: null, // Used when field is blank: actual date,
			// +/-number for offset from today, null for today
		appendText: "", // Display text following the input box, e.g. showing the format
		buttonText: "...", // Text for trigger button
		buttonImage: "", // URL for trigger button image
		buttonImageOnly: false, // True if the image appears alone, false if it appears on a button
		hideIfNoPrevNext: false, // True to hide next/previous month links
			// if not applicable, false to just disable them
		navigationAsDateFormat: false, // True if date formatting applied to prev/today/next links
		gotoCurrent: false, // True if today link goes back to current selection instead
		changeMonth: false, // True if month can be selected directly, false if only prev/next
		changeYear: false, // True if year can be selected directly, false if only prev/next
		yearRange: "c-10:c+10", // Range of years to display in drop-down,
			// either relative to today's year (-nn:+nn), relative to currently displayed year
			// (c-nn:c+nn), absolute (nnnn:nnnn), or a combination of the above (nnnn:-n)
		showOtherMonths: false, // True to show dates in other months, false to leave blank
		selectOtherMonths: false, // True to allow selection of dates in other months, false for unselectable
		showWeek: false, // True to show week of the year, false to not show it
		calculateWeek: this.iso8601Week, // How to calculate the week of the year,
			// takes a Date and returns the number of the week for it
		shortYearCutoff: "+10", // Short year values < this are in the current century,
			// > this are in the previous century,
			// string value starting with "+" for current year + value
		minDate: null, // The earliest selectable date, or null for no limit
		maxDate: null, // The latest selectable date, or null for no limit
		duration: "fast", // Duration of display/closure
		beforeShowDay: null, // Function that takes a date and returns an array with
			// [0] = true if selectable, false if not, [1] = custom CSS class name(s) or "",
			// [2] = cell title (optional), e.g. $.datepicker.noWeekends
		beforeShow: null, // Function that takes an input field and
			// returns a set of custom settings for the date picker
		onSelect: null, // Define a callback function when a date is selected
		onChangeMonthYear: null, // Define a callback function when the month or year is changed
		onClose: null, // Define a callback function when the datepicker is closed
		numberOfMonths: 1, // Number of months to show at a time
		showCurrentAtPos: 0, // The position in multipe months at which to show the current month (starting at 0)
		stepMonths: 1, // Number of months to step back/forward
		stepBigMonths: 12, // Number of months to step back/forward for the big links
		altField: "", // Selector for an alternate field to store selected dates into
		altFormat: "", // The date format to use for the alternate field
		constrainInput: true, // The input is constrained by the current date format
		showButtonPanel: false, // True to show button panel, false to not show it
		autoSize: false, // True to size the input for the date format, false to leave as is
		disabled: false // The initial disabled state
	};
	$.extend(this._defaults, this.regional[""]);
	this.regional.en = $.extend( true, {}, this.regional[ "" ]);
	this.regional[ "en-US" ] = $.extend( true, {}, this.regional.en );
	this.dpDiv = datepicker_bindHover($("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"));
}

$.extend(Datepicker.prototype, {
	/* Class name added to elements to indicate already configured with a date picker. */
	markerClassName: "hasDatepicker",

	//Keep track of the maximum number of rows displayed (see #7043)
	maxRows: 4,

	// TODO rename to "widget" when switching to widget factory
	_widgetDatepicker: function() {
		return this.dpDiv;
	},

	/* Override the default settings for all instances of the date picker.
	 * @param  settings  object - the new settings to use as defaults (anonymous object)
	 * @return the manager object
	 */
	setDefaults: function(settings) {
		datepicker_extendRemove(this._defaults, settings || {});
		return this;
	},

	/* Attach the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 * @param  settings  object - the new settings to use for this date picker instance (anonymous)
	 */
	_attachDatepicker: function(target, settings) {
		var nodeName, inline, inst;
		nodeName = target.nodeName.toLowerCase();
		inline = (nodeName === "div" || nodeName === "span");
		if (!target.id) {
			this.uuid += 1;
			target.id = "dp" + this.uuid;
		}
		inst = this._newInst($(target), inline);
		inst.settings = $.extend({}, settings || {});
		if (nodeName === "input") {
			this._connectDatepicker(target, inst);
		} else if (inline) {
			this._inlineDatepicker(target, inst);
		}
	},

	/* Create a new instance object. */
	_newInst: function(target, inline) {
		var id = target[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1"); // escape jQuery meta chars
		return {id: id, input: target, // associated target
			selectedDay: 0, selectedMonth: 0, selectedYear: 0, // current selection
			drawMonth: 0, drawYear: 0, // month being drawn
			inline: inline, // is datepicker inline or not
			dpDiv: (!inline ? this.dpDiv : // presentation div
			datepicker_bindHover($("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")))};
	},

	/* Attach the date picker to an input field. */
	_connectDatepicker: function(target, inst) {
		var input = $(target);
		inst.append = $([]);
		inst.trigger = $([]);
		if (input.hasClass(this.markerClassName)) {
			return;
		}
		this._attachments(input, inst);
		input.addClass(this.markerClassName).keydown(this._doKeyDown).
			keypress(this._doKeyPress).keyup(this._doKeyUp);
		this._autoSize(inst);
		$.data(target, "datepicker", inst);
		//If disabled option is true, disable the datepicker once it has been attached to the input (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
	},

	/* Make attachments based on settings. */
	_attachments: function(input, inst) {
		var showOn, buttonText, buttonImage,
			appendText = this._get(inst, "appendText"),
			isRTL = this._get(inst, "isRTL");

		if (inst.append) {
			inst.append.remove();
		}
		if (appendText) {
			inst.append = $("<span class='" + this._appendClass + "'>" + appendText + "</span>");
			input[isRTL ? "before" : "after"](inst.append);
		}

		input.unbind("focus", this._showDatepicker);

		if (inst.trigger) {
			inst.trigger.remove();
		}

		showOn = this._get(inst, "showOn");
		if (showOn === "focus" || showOn === "both") { // pop-up date picker when in the marked field
			input.focus(this._showDatepicker);
		}
		if (showOn === "button" || showOn === "both") { // pop-up date picker when button clicked
			buttonText = this._get(inst, "buttonText");
			buttonImage = this._get(inst, "buttonImage");
			inst.trigger = $(this._get(inst, "buttonImageOnly") ?
				$("<img/>").addClass(this._triggerClass).
					attr({ src: buttonImage, alt: buttonText, title: buttonText }) :
				$("<button type='button'></button>").addClass(this._triggerClass).
					html(!buttonImage ? buttonText : $("<img/>").attr(
					{ src:buttonImage, alt:buttonText, title:buttonText })));
			input[isRTL ? "before" : "after"](inst.trigger);
			inst.trigger.click(function() {
				if ($.datepicker._datepickerShowing && $.datepicker._lastInput === input[0]) {
					$.datepicker._hideDatepicker();
				} else if ($.datepicker._datepickerShowing && $.datepicker._lastInput !== input[0]) {
					$.datepicker._hideDatepicker();
					$.datepicker._showDatepicker(input[0]);
				} else {
					$.datepicker._showDatepicker(input[0]);
				}
				return false;
			});
		}
	},

	/* Apply the maximum length for the date format. */
	_autoSize: function(inst) {
		if (this._get(inst, "autoSize") && !inst.inline) {
			var findMax, max, maxI, i,
				date = new Date(2009, 12 - 1, 20), // Ensure double digits
				dateFormat = this._get(inst, "dateFormat");

			if (dateFormat.match(/[DM]/)) {
				findMax = function(names) {
					max = 0;
					maxI = 0;
					for (i = 0; i < names.length; i++) {
						if (names[i].length > max) {
							max = names[i].length;
							maxI = i;
						}
					}
					return maxI;
				};
				date.setMonth(findMax(this._get(inst, (dateFormat.match(/MM/) ?
					"monthNames" : "monthNamesShort"))));
				date.setDate(findMax(this._get(inst, (dateFormat.match(/DD/) ?
					"dayNames" : "dayNamesShort"))) + 20 - date.getDay());
			}
			inst.input.attr("size", this._formatDate(inst, date).length);
		}
	},

	/* Attach an inline date picker to a div. */
	_inlineDatepicker: function(target, inst) {
		var divSpan = $(target);
		if (divSpan.hasClass(this.markerClassName)) {
			return;
		}
		divSpan.addClass(this.markerClassName).append(inst.dpDiv);
		$.data(target, "datepicker", inst);
		this._setDate(inst, this._getDefaultDate(inst), true);
		this._updateDatepicker(inst);
		this._updateAlternate(inst);
		//If disabled option is true, disable the datepicker before showing it (see ticket #5665)
		if( inst.settings.disabled ) {
			this._disableDatepicker( target );
		}
		// Set display:block in place of inst.dpDiv.show() which won't work on disconnected elements
		// http://bugs.jqueryui.com/ticket/7552 - A Datepicker created on a detached div has zero height
		inst.dpDiv.css( "display", "block" );
	},

	/* Pop-up the date picker in a "dialog" box.
	 * @param  input element - ignored
	 * @param  date	string or Date - the initial date to display
	 * @param  onSelect  function - the function to call when a date is selected
	 * @param  settings  object - update the dialog date picker instance's settings (anonymous object)
	 * @param  pos int[2] - coordinates for the dialog's position within the screen or
	 *					event - with x/y coordinates or
	 *					leave empty for default (screen centre)
	 * @return the manager object
	 */
	_dialogDatepicker: function(input, date, onSelect, settings, pos) {
		var id, browserWidth, browserHeight, scrollX, scrollY,
			inst = this._dialogInst; // internal instance

		if (!inst) {
			this.uuid += 1;
			id = "dp" + this.uuid;
			this._dialogInput = $("<input type='text' id='" + id +
				"' style='position: absolute; top: -100px; width: 0px;'/>");
			this._dialogInput.keydown(this._doKeyDown);
			$("body").append(this._dialogInput);
			inst = this._dialogInst = this._newInst(this._dialogInput, false);
			inst.settings = {};
			$.data(this._dialogInput[0], "datepicker", inst);
		}
		datepicker_extendRemove(inst.settings, settings || {});
		date = (date && date.constructor === Date ? this._formatDate(inst, date) : date);
		this._dialogInput.val(date);

		this._pos = (pos ? (pos.length ? pos : [pos.pageX, pos.pageY]) : null);
		if (!this._pos) {
			browserWidth = document.documentElement.clientWidth;
			browserHeight = document.documentElement.clientHeight;
			scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
			scrollY = document.documentElement.scrollTop || document.body.scrollTop;
			this._pos = // should use actual width/height below
				[(browserWidth / 2) - 100 + scrollX, (browserHeight / 2) - 150 + scrollY];
		}

		// move input on screen for focus, but hidden behind dialog
		this._dialogInput.css("left", (this._pos[0] + 20) + "px").css("top", this._pos[1] + "px");
		inst.settings.onSelect = onSelect;
		this._inDialog = true;
		this.dpDiv.addClass(this._dialogClass);
		this._showDatepicker(this._dialogInput[0]);
		if ($.blockUI) {
			$.blockUI(this.dpDiv);
		}
		$.data(this._dialogInput[0], "datepicker", inst);
		return this;
	},

	/* Detach a datepicker from its control.
	 * @param  target	element - the target input field or division or span
	 */
	_destroyDatepicker: function(target) {
		var nodeName,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		$.removeData(target, "datepicker");
		if (nodeName === "input") {
			inst.append.remove();
			inst.trigger.remove();
			$target.removeClass(this.markerClassName).
				unbind("focus", this._showDatepicker).
				unbind("keydown", this._doKeyDown).
				unbind("keypress", this._doKeyPress).
				unbind("keyup", this._doKeyUp);
		} else if (nodeName === "div" || nodeName === "span") {
			$target.removeClass(this.markerClassName).empty();
		}

		if ( datepicker_instActive === inst ) {
			datepicker_instActive = null;
		}
	},

	/* Enable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_enableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = false;
			inst.trigger.filter("button").
				each(function() { this.disabled = false; }).end().
				filter("img").css({opacity: "1.0", cursor: ""});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().removeClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", false);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
	},

	/* Disable the date picker to a jQuery selection.
	 * @param  target	element - the target input field or division or span
	 */
	_disableDatepicker: function(target) {
		var nodeName, inline,
			$target = $(target),
			inst = $.data(target, "datepicker");

		if (!$target.hasClass(this.markerClassName)) {
			return;
		}

		nodeName = target.nodeName.toLowerCase();
		if (nodeName === "input") {
			target.disabled = true;
			inst.trigger.filter("button").
				each(function() { this.disabled = true; }).end().
				filter("img").css({opacity: "0.5", cursor: "default"});
		} else if (nodeName === "div" || nodeName === "span") {
			inline = $target.children("." + this._inlineClass);
			inline.children().addClass("ui-state-disabled");
			inline.find("select.ui-datepicker-month, select.ui-datepicker-year").
				prop("disabled", true);
		}
		this._disabledInputs = $.map(this._disabledInputs,
			function(value) { return (value === target ? null : value); }); // delete entry
		this._disabledInputs[this._disabledInputs.length] = target;
	},

	/* Is the first field in a jQuery collection disabled as a datepicker?
	 * @param  target	element - the target input field or division or span
	 * @return boolean - true if disabled, false if enabled
	 */
	_isDisabledDatepicker: function(target) {
		if (!target) {
			return false;
		}
		for (var i = 0; i < this._disabledInputs.length; i++) {
			if (this._disabledInputs[i] === target) {
				return true;
			}
		}
		return false;
	},

	/* Retrieve the instance data for the target control.
	 * @param  target  element - the target input field or division or span
	 * @return  object - the associated instance data
	 * @throws  error if a jQuery problem getting data
	 */
	_getInst: function(target) {
		try {
			return $.data(target, "datepicker");
		}
		catch (err) {
			throw "Missing instance data for this datepicker";
		}
	},

	/* Update or retrieve the settings for a date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 * @param  name	object - the new settings to update or
	 *				string - the name of the setting to change or retrieve,
	 *				when retrieving also "all" for all instance settings or
	 *				"defaults" for all global defaults
	 * @param  value   any - the new value for the setting
	 *				(omit if above is an object or to retrieve a value)
	 */
	_optionDatepicker: function(target, name, value) {
		var settings, date, minDate, maxDate,
			inst = this._getInst(target);

		if (arguments.length === 2 && typeof name === "string") {
			return (name === "defaults" ? $.extend({}, $.datepicker._defaults) :
				(inst ? (name === "all" ? $.extend({}, inst.settings) :
				this._get(inst, name)) : null));
		}

		settings = name || {};
		if (typeof name === "string") {
			settings = {};
			settings[name] = value;
		}

		if (inst) {
			if (this._curInst === inst) {
				this._hideDatepicker();
			}

			date = this._getDateDatepicker(target, true);
			minDate = this._getMinMaxDate(inst, "min");
			maxDate = this._getMinMaxDate(inst, "max");
			datepicker_extendRemove(inst.settings, settings);
			// reformat the old minDate/maxDate values if dateFormat changes and a new minDate/maxDate isn't provided
			if (minDate !== null && settings.dateFormat !== undefined && settings.minDate === undefined) {
				inst.settings.minDate = this._formatDate(inst, minDate);
			}
			if (maxDate !== null && settings.dateFormat !== undefined && settings.maxDate === undefined) {
				inst.settings.maxDate = this._formatDate(inst, maxDate);
			}
			if ( "disabled" in settings ) {
				if ( settings.disabled ) {
					this._disableDatepicker(target);
				} else {
					this._enableDatepicker(target);
				}
			}
			this._attachments($(target), inst);
			this._autoSize(inst);
			this._setDate(inst, date);
			this._updateAlternate(inst);
			this._updateDatepicker(inst);
		}
	},

	// change method deprecated
	_changeDatepicker: function(target, name, value) {
		this._optionDatepicker(target, name, value);
	},

	/* Redraw the date picker attached to an input field or division.
	 * @param  target  element - the target input field or division or span
	 */
	_refreshDatepicker: function(target) {
		var inst = this._getInst(target);
		if (inst) {
			this._updateDatepicker(inst);
		}
	},

	/* Set the dates for a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  date	Date - the new date
	 */
	_setDateDatepicker: function(target, date) {
		var inst = this._getInst(target);
		if (inst) {
			this._setDate(inst, date);
			this._updateDatepicker(inst);
			this._updateAlternate(inst);
		}
	},

	/* Get the date(s) for the first entry in a jQuery selection.
	 * @param  target element - the target input field or division or span
	 * @param  noDefault boolean - true if no default date is to be used
	 * @return Date - the current date
	 */
	_getDateDatepicker: function(target, noDefault) {
		var inst = this._getInst(target);
		if (inst && !inst.inline) {
			this._setDateFromField(inst, noDefault);
		}
		return (inst ? this._getDate(inst) : null);
	},

	/* Handle keystrokes. */
	_doKeyDown: function(event) {
		var onSelect, dateStr, sel,
			inst = $.datepicker._getInst(event.target),
			handled = true,
			isRTL = inst.dpDiv.is(".ui-datepicker-rtl");

		inst._keyEvent = true;
		if ($.datepicker._datepickerShowing) {
			switch (event.keyCode) {
				case 9: $.datepicker._hideDatepicker();
						handled = false;
						break; // hide on tab out
				case 13: sel = $("td." + $.datepicker._dayOverClass + ":not(." +
									$.datepicker._currentClass + ")", inst.dpDiv);
						if (sel[0]) {
							$.datepicker._selectDay(event.target, inst.selectedMonth, inst.selectedYear, sel[0]);
						}

						onSelect = $.datepicker._get(inst, "onSelect");
						if (onSelect) {
							dateStr = $.datepicker._formatDate(inst);

							// trigger custom callback
							onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);
						} else {
							$.datepicker._hideDatepicker();
						}

						return false; // don't submit the form
				case 27: $.datepicker._hideDatepicker();
						break; // hide on escape
				case 33: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							-$.datepicker._get(inst, "stepBigMonths") :
							-$.datepicker._get(inst, "stepMonths")), "M");
						break; // previous month/year on page up/+ ctrl
				case 34: $.datepicker._adjustDate(event.target, (event.ctrlKey ?
							+$.datepicker._get(inst, "stepBigMonths") :
							+$.datepicker._get(inst, "stepMonths")), "M");
						break; // next month/year on page down/+ ctrl
				case 35: if (event.ctrlKey || event.metaKey) {
							$.datepicker._clearDate(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // clear on ctrl or command +end
				case 36: if (event.ctrlKey || event.metaKey) {
							$.datepicker._gotoToday(event.target);
						}
						handled = event.ctrlKey || event.metaKey;
						break; // current on ctrl or command +home
				case 37: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? +1 : -1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// -1 day on ctrl or command +left
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								-$.datepicker._get(inst, "stepBigMonths") :
								-$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +left on Mac
						break;
				case 38: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, -7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // -1 week on ctrl or command +up
				case 39: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, (isRTL ? -1 : +1), "D");
						}
						handled = event.ctrlKey || event.metaKey;
						// +1 day on ctrl or command +right
						if (event.originalEvent.altKey) {
							$.datepicker._adjustDate(event.target, (event.ctrlKey ?
								+$.datepicker._get(inst, "stepBigMonths") :
								+$.datepicker._get(inst, "stepMonths")), "M");
						}
						// next month/year on alt +right
						break;
				case 40: if (event.ctrlKey || event.metaKey) {
							$.datepicker._adjustDate(event.target, +7, "D");
						}
						handled = event.ctrlKey || event.metaKey;
						break; // +1 week on ctrl or command +down
				default: handled = false;
			}
		} else if (event.keyCode === 36 && event.ctrlKey) { // display the date picker on ctrl+home
			$.datepicker._showDatepicker(this);
		} else {
			handled = false;
		}

		if (handled) {
			event.preventDefault();
			event.stopPropagation();
		}
	},

	/* Filter entered characters - based on date format. */
	_doKeyPress: function(event) {
		var chars, chr,
			inst = $.datepicker._getInst(event.target);

		if ($.datepicker._get(inst, "constrainInput")) {
			chars = $.datepicker._possibleChars($.datepicker._get(inst, "dateFormat"));
			chr = String.fromCharCode(event.charCode == null ? event.keyCode : event.charCode);
			return event.ctrlKey || event.metaKey || (chr < " " || !chars || chars.indexOf(chr) > -1);
		}
	},

	/* Synchronise manual entry and field/alternate field. */
	_doKeyUp: function(event) {
		var date,
			inst = $.datepicker._getInst(event.target);

		if (inst.input.val() !== inst.lastVal) {
			try {
				date = $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
					(inst.input ? inst.input.val() : null),
					$.datepicker._getFormatConfig(inst));

				if (date) { // only if valid
					$.datepicker._setDateFromField(inst);
					$.datepicker._updateAlternate(inst);
					$.datepicker._updateDatepicker(inst);
				}
			}
			catch (err) {
			}
		}
		return true;
	},

	/* Pop-up the date picker for a given input field.
	 * If false returned from beforeShow event handler do not show.
	 * @param  input  element - the input field attached to the date picker or
	 *					event - if triggered by focus
	 */
	_showDatepicker: function(input) {
		input = input.target || input;
		if (input.nodeName.toLowerCase() !== "input") { // find from button/image trigger
			input = $("input", input.parentNode)[0];
		}

		if ($.datepicker._isDisabledDatepicker(input) || $.datepicker._lastInput === input) { // already here
			return;
		}

		var inst, beforeShow, beforeShowSettings, isFixed,
			offset, showAnim, duration;

		inst = $.datepicker._getInst(input);
		if ($.datepicker._curInst && $.datepicker._curInst !== inst) {
			$.datepicker._curInst.dpDiv.stop(true, true);
			if ( inst && $.datepicker._datepickerShowing ) {
				$.datepicker._hideDatepicker( $.datepicker._curInst.input[0] );
			}
		}

		beforeShow = $.datepicker._get(inst, "beforeShow");
		beforeShowSettings = beforeShow ? beforeShow.apply(input, [input, inst]) : {};
		if(beforeShowSettings === false){
			return;
		}
		datepicker_extendRemove(inst.settings, beforeShowSettings);

		inst.lastVal = null;
		$.datepicker._lastInput = input;
		$.datepicker._setDateFromField(inst);

		if ($.datepicker._inDialog) { // hide cursor
			input.value = "";
		}
		if (!$.datepicker._pos) { // position below input
			$.datepicker._pos = $.datepicker._findPos(input);
			$.datepicker._pos[1] += input.offsetHeight; // add the height
		}

		isFixed = false;
		$(input).parents().each(function() {
			isFixed |= $(this).css("position") === "fixed";
			return !isFixed;
		});

		offset = {left: $.datepicker._pos[0], top: $.datepicker._pos[1]};
		$.datepicker._pos = null;
		//to avoid flashes on Firefox
		inst.dpDiv.empty();
		// determine sizing offscreen
		inst.dpDiv.css({position: "absolute", display: "block", top: "-1000px"});
		$.datepicker._updateDatepicker(inst);
		// fix width for dynamic number of date pickers
		// and adjust position before showing
		offset = $.datepicker._checkOffset(inst, offset, isFixed);
		inst.dpDiv.css({position: ($.datepicker._inDialog && $.blockUI ?
			"static" : (isFixed ? "fixed" : "absolute")), display: "none",
			left: offset.left + "px", top: offset.top + "px"});

		if (!inst.inline) {
			showAnim = $.datepicker._get(inst, "showAnim");
			duration = $.datepicker._get(inst, "duration");
			inst.dpDiv.css( "z-index", datepicker_getZindex( $( input ) ) + 1 );
			$.datepicker._datepickerShowing = true;

			if ( $.effects && $.effects.effect[ showAnim ] ) {
				inst.dpDiv.show(showAnim, $.datepicker._get(inst, "showOptions"), duration);
			} else {
				inst.dpDiv[showAnim || "show"](showAnim ? duration : null);
			}

			if ( $.datepicker._shouldFocusInput( inst ) ) {
				inst.input.focus();
			}

			$.datepicker._curInst = inst;
		}
	},

	/* Generate the date picker content. */
	_updateDatepicker: function(inst) {
		this.maxRows = 4; //Reset the max number of rows being displayed (see #7043)
		datepicker_instActive = inst; // for delegate hover events
		inst.dpDiv.empty().append(this._generateHTML(inst));
		this._attachHandlers(inst);

		var origyearshtml,
			numMonths = this._getNumberOfMonths(inst),
			cols = numMonths[1],
			width = 17,
			activeCell = inst.dpDiv.find( "." + this._dayOverClass + " a" );

		if ( activeCell.length > 0 ) {
			datepicker_handleMouseover.apply( activeCell.get( 0 ) );
		}

		inst.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width("");
		if (cols > 1) {
			inst.dpDiv.addClass("ui-datepicker-multi-" + cols).css("width", (width * cols) + "em");
		}
		inst.dpDiv[(numMonths[0] !== 1 || numMonths[1] !== 1 ? "add" : "remove") +
			"Class"]("ui-datepicker-multi");
		inst.dpDiv[(this._get(inst, "isRTL") ? "add" : "remove") +
			"Class"]("ui-datepicker-rtl");

		if (inst === $.datepicker._curInst && $.datepicker._datepickerShowing && $.datepicker._shouldFocusInput( inst ) ) {
			inst.input.focus();
		}

		// deffered render of the years select (to avoid flashes on Firefox)
		if( inst.yearshtml ){
			origyearshtml = inst.yearshtml;
			setTimeout(function(){
				//assure that inst.yearshtml didn't change.
				if( origyearshtml === inst.yearshtml && inst.yearshtml ){
					inst.dpDiv.find("select.ui-datepicker-year:first").replaceWith(inst.yearshtml);
				}
				origyearshtml = inst.yearshtml = null;
			}, 0);
		}
	},

	// #6694 - don't focus the input if it's already focused
	// this breaks the change event in IE
	// Support: IE and jQuery <1.9
	_shouldFocusInput: function( inst ) {
		return inst.input && inst.input.is( ":visible" ) && !inst.input.is( ":disabled" ) && !inst.input.is( ":focus" );
	},

	/* Check positioning to remain on screen. */
	_checkOffset: function(inst, offset, isFixed) {
		var dpWidth = inst.dpDiv.outerWidth(),
			dpHeight = inst.dpDiv.outerHeight(),
			inputWidth = inst.input ? inst.input.outerWidth() : 0,
			inputHeight = inst.input ? inst.input.outerHeight() : 0,
			viewWidth = document.documentElement.clientWidth + (isFixed ? 0 : $(document).scrollLeft()),
			viewHeight = document.documentElement.clientHeight + (isFixed ? 0 : $(document).scrollTop());

		offset.left -= (this._get(inst, "isRTL") ? (dpWidth - inputWidth) : 0);
		offset.left -= (isFixed && offset.left === inst.input.offset().left) ? $(document).scrollLeft() : 0;
		offset.top -= (isFixed && offset.top === (inst.input.offset().top + inputHeight)) ? $(document).scrollTop() : 0;

		// now check if datepicker is showing outside window viewport - move to a better place if so.
		offset.left -= Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
			Math.abs(offset.left + dpWidth - viewWidth) : 0);
		offset.top -= Math.min(offset.top, (offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
			Math.abs(dpHeight + inputHeight) : 0);

		return offset;
	},

	/* Find an object's position on the screen. */
	_findPos: function(obj) {
		var position,
			inst = this._getInst(obj),
			isRTL = this._get(inst, "isRTL");

		while (obj && (obj.type === "hidden" || obj.nodeType !== 1 || $.expr.filters.hidden(obj))) {
			obj = obj[isRTL ? "previousSibling" : "nextSibling"];
		}

		position = $(obj).offset();
		return [position.left, position.top];
	},

	/* Hide the date picker from view.
	 * @param  input  element - the input field attached to the date picker
	 */
	_hideDatepicker: function(input) {
		var showAnim, duration, postProcess, onClose,
			inst = this._curInst;

		if (!inst || (input && inst !== $.data(input, "datepicker"))) {
			return;
		}

		if (this._datepickerShowing) {
			showAnim = this._get(inst, "showAnim");
			duration = this._get(inst, "duration");
			postProcess = function() {
				$.datepicker._tidyDialog(inst);
			};

			// DEPRECATED: after BC for 1.8.x $.effects[ showAnim ] is not needed
			if ( $.effects && ( $.effects.effect[ showAnim ] || $.effects[ showAnim ] ) ) {
				inst.dpDiv.hide(showAnim, $.datepicker._get(inst, "showOptions"), duration, postProcess);
			} else {
				inst.dpDiv[(showAnim === "slideDown" ? "slideUp" :
					(showAnim === "fadeIn" ? "fadeOut" : "hide"))]((showAnim ? duration : null), postProcess);
			}

			if (!showAnim) {
				postProcess();
			}
			this._datepickerShowing = false;

			onClose = this._get(inst, "onClose");
			if (onClose) {
				onClose.apply((inst.input ? inst.input[0] : null), [(inst.input ? inst.input.val() : ""), inst]);
			}

			this._lastInput = null;
			if (this._inDialog) {
				this._dialogInput.css({ position: "absolute", left: "0", top: "-100px" });
				if ($.blockUI) {
					$.unblockUI();
					$("body").append(this.dpDiv);
				}
			}
			this._inDialog = false;
		}
	},

	/* Tidy up after a dialog display. */
	_tidyDialog: function(inst) {
		inst.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar");
	},

	/* Close date picker if clicked elsewhere. */
	_checkExternalClick: function(event) {
		if (!$.datepicker._curInst) {
			return;
		}

		var $target = $(event.target),
			inst = $.datepicker._getInst($target[0]);

		if ( ( ( $target[0].id !== $.datepicker._mainDivId &&
				$target.parents("#" + $.datepicker._mainDivId).length === 0 &&
				!$target.hasClass($.datepicker.markerClassName) &&
				!$target.closest("." + $.datepicker._triggerClass).length &&
				$.datepicker._datepickerShowing && !($.datepicker._inDialog && $.blockUI) ) ) ||
			( $target.hasClass($.datepicker.markerClassName) && $.datepicker._curInst !== inst ) ) {
				$.datepicker._hideDatepicker();
		}
	},

	/* Adjust one of the date sub-fields. */
	_adjustDate: function(id, offset, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		if (this._isDisabledDatepicker(target[0])) {
			return;
		}
		this._adjustInstDate(inst, offset +
			(period === "M" ? this._get(inst, "showCurrentAtPos") : 0), // undo positioning
			period);
		this._updateDatepicker(inst);
	},

	/* Action for current link. */
	_gotoToday: function(id) {
		var date,
			target = $(id),
			inst = this._getInst(target[0]);

		if (this._get(inst, "gotoCurrent") && inst.currentDay) {
			inst.selectedDay = inst.currentDay;
			inst.drawMonth = inst.selectedMonth = inst.currentMonth;
			inst.drawYear = inst.selectedYear = inst.currentYear;
		} else {
			date = new Date();
			inst.selectedDay = date.getDate();
			inst.drawMonth = inst.selectedMonth = date.getMonth();
			inst.drawYear = inst.selectedYear = date.getFullYear();
		}
		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a new month/year. */
	_selectMonthYear: function(id, select, period) {
		var target = $(id),
			inst = this._getInst(target[0]);

		inst["selected" + (period === "M" ? "Month" : "Year")] =
		inst["draw" + (period === "M" ? "Month" : "Year")] =
			parseInt(select.options[select.selectedIndex].value,10);

		this._notifyChange(inst);
		this._adjustDate(target);
	},

	/* Action for selecting a day. */
	_selectDay: function(id, month, year, td) {
		var inst,
			target = $(id);

		if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0])) {
			return;
		}

		inst = this._getInst(target[0]);
		inst.selectedDay = inst.currentDay = $("a", td).html();
		inst.selectedMonth = inst.currentMonth = month;
		inst.selectedYear = inst.currentYear = year;
		this._selectDate(id, this._formatDate(inst,
			inst.currentDay, inst.currentMonth, inst.currentYear));
	},

	/* Erase the input field and hide the date picker. */
	_clearDate: function(id) {
		var target = $(id);
		this._selectDate(target, "");
	},

	/* Update the input field with the selected date. */
	_selectDate: function(id, dateStr) {
		var onSelect,
			target = $(id),
			inst = this._getInst(target[0]);

		dateStr = (dateStr != null ? dateStr : this._formatDate(inst));
		if (inst.input) {
			inst.input.val(dateStr);
		}
		this._updateAlternate(inst);

		onSelect = this._get(inst, "onSelect");
		if (onSelect) {
			onSelect.apply((inst.input ? inst.input[0] : null), [dateStr, inst]);  // trigger custom callback
		} else if (inst.input) {
			inst.input.trigger("change"); // fire the change event
		}

		if (inst.inline){
			this._updateDatepicker(inst);
		} else {
			this._hideDatepicker();
			this._lastInput = inst.input[0];
			if (typeof(inst.input[0]) !== "object") {
				inst.input.focus(); // restore focus
			}
			this._lastInput = null;
		}
	},

	/* Update any alternate field to synchronise with the main field. */
	_updateAlternate: function(inst) {
		var altFormat, date, dateStr,
			altField = this._get(inst, "altField");

		if (altField) { // update alternate field too
			altFormat = this._get(inst, "altFormat") || this._get(inst, "dateFormat");
			date = this._getDate(inst);
			dateStr = this.formatDate(altFormat, date, this._getFormatConfig(inst));
			$(altField).each(function() { $(this).val(dateStr); });
		}
	},

	/* Set as beforeShowDay function to prevent selection of weekends.
	 * @param  date  Date - the date to customise
	 * @return [boolean, string] - is this date selectable?, what is its CSS class?
	 */
	noWeekends: function(date) {
		var day = date.getDay();
		return [(day > 0 && day < 6), ""];
	},

	/* Set as calculateWeek to determine the week of the year based on the ISO 8601 definition.
	 * @param  date  Date - the date to get the week for
	 * @return  number - the number of the week within the year that contains this date
	 */
	iso8601Week: function(date) {
		var time,
			checkDate = new Date(date.getTime());

		// Find Thursday of this week starting on Monday
		checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));

		time = checkDate.getTime();
		checkDate.setMonth(0); // Compare with Jan 1
		checkDate.setDate(1);
		return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	},

	/* Parse a string value into a date object.
	 * See formatDate below for the possible formats.
	 *
	 * @param  format string - the expected format of the date
	 * @param  value string - the date in the above format
	 * @param  settings Object - attributes include:
	 *					shortYearCutoff  number - the cutoff year for determining the century (optional)
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  Date - the extracted date value or null if value is blank
	 */
	parseDate: function (format, value, settings) {
		if (format == null || value == null) {
			throw "Invalid arguments";
		}

		value = (typeof value === "object" ? value.toString() : value + "");
		if (value === "") {
			return null;
		}

		var iFormat, dim, extra,
			iValue = 0,
			shortYearCutoffTemp = (settings ? settings.shortYearCutoff : null) || this._defaults.shortYearCutoff,
			shortYearCutoff = (typeof shortYearCutoffTemp !== "string" ? shortYearCutoffTemp :
				new Date().getFullYear() % 100 + parseInt(shortYearCutoffTemp, 10)),
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			year = -1,
			month = -1,
			day = -1,
			doy = -1,
			literal = false,
			date,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Extract a number from the string value
			getNumber = function(match) {
				var isDoubled = lookAhead(match),
					size = (match === "@" ? 14 : (match === "!" ? 20 :
					(match === "y" && isDoubled ? 4 : (match === "o" ? 3 : 2)))),
					minSize = (match === "y" ? size : 1),
					digits = new RegExp("^\\d{" + minSize + "," + size + "}"),
					num = value.substring(iValue).match(digits);
				if (!num) {
					throw "Missing number at position " + iValue;
				}
				iValue += num[0].length;
				return parseInt(num[0], 10);
			},
			// Extract a name from the string value and convert to an index
			getName = function(match, shortNames, longNames) {
				var index = -1,
					names = $.map(lookAhead(match) ? longNames : shortNames, function (v, k) {
						return [ [k, v] ];
					}).sort(function (a, b) {
						return -(a[1].length - b[1].length);
					});

				$.each(names, function (i, pair) {
					var name = pair[1];
					if (value.substr(iValue, name.length).toLowerCase() === name.toLowerCase()) {
						index = pair[0];
						iValue += name.length;
						return false;
					}
				});
				if (index !== -1) {
					return index + 1;
				} else {
					throw "Unknown name at position " + iValue;
				}
			},
			// Confirm that a literal character matches the string value
			checkLiteral = function() {
				if (value.charAt(iValue) !== format.charAt(iFormat)) {
					throw "Unexpected literal at position " + iValue;
				}
				iValue++;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					checkLiteral();
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d":
						day = getNumber("d");
						break;
					case "D":
						getName("D", dayNamesShort, dayNames);
						break;
					case "o":
						doy = getNumber("o");
						break;
					case "m":
						month = getNumber("m");
						break;
					case "M":
						month = getName("M", monthNamesShort, monthNames);
						break;
					case "y":
						year = getNumber("y");
						break;
					case "@":
						date = new Date(getNumber("@"));
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "!":
						date = new Date((getNumber("!") - this._ticksTo1970) / 10000);
						year = date.getFullYear();
						month = date.getMonth() + 1;
						day = date.getDate();
						break;
					case "'":
						if (lookAhead("'")){
							checkLiteral();
						} else {
							literal = true;
						}
						break;
					default:
						checkLiteral();
				}
			}
		}

		if (iValue < value.length){
			extra = value.substr(iValue);
			if (!/^\s+/.test(extra)) {
				throw "Extra/unparsed characters found in date: " + extra;
			}
		}

		if (year === -1) {
			year = new Date().getFullYear();
		} else if (year < 100) {
			year += new Date().getFullYear() - new Date().getFullYear() % 100 +
				(year <= shortYearCutoff ? 0 : -100);
		}

		if (doy > -1) {
			month = 1;
			day = doy;
			do {
				dim = this._getDaysInMonth(year, month - 1);
				if (day <= dim) {
					break;
				}
				month++;
				day -= dim;
			} while (true);
		}

		date = this._daylightSavingAdjust(new Date(year, month - 1, day));
		if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) {
			throw "Invalid date"; // E.g. 31/02/00
		}
		return date;
	},

	/* Standard date formats. */
	ATOM: "yy-mm-dd", // RFC 3339 (ISO 8601)
	COOKIE: "D, dd M yy",
	ISO_8601: "yy-mm-dd",
	RFC_822: "D, d M y",
	RFC_850: "DD, dd-M-y",
	RFC_1036: "D, d M y",
	RFC_1123: "D, d M yy",
	RFC_2822: "D, d M yy",
	RSS: "D, d M y", // RFC 822
	TICKS: "!",
	TIMESTAMP: "@",
	W3C: "yy-mm-dd", // ISO 8601

	_ticksTo1970: (((1970 - 1) * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) +
		Math.floor(1970 / 400)) * 24 * 60 * 60 * 10000000),

	/* Format a date object into a string value.
	 * The format can be combinations of the following:
	 * d  - day of month (no leading zero)
	 * dd - day of month (two digit)
	 * o  - day of year (no leading zeros)
	 * oo - day of year (three digit)
	 * D  - day name short
	 * DD - day name long
	 * m  - month of year (no leading zero)
	 * mm - month of year (two digit)
	 * M  - month name short
	 * MM - month name long
	 * y  - year (two digit)
	 * yy - year (four digit)
	 * @ - Unix timestamp (ms since 01/01/1970)
	 * ! - Windows ticks (100ns since 01/01/0001)
	 * "..." - literal text
	 * '' - single quote
	 *
	 * @param  format string - the desired format of the date
	 * @param  date Date - the date value to format
	 * @param  settings Object - attributes include:
	 *					dayNamesShort	string[7] - abbreviated names of the days from Sunday (optional)
	 *					dayNames		string[7] - names of the days from Sunday (optional)
	 *					monthNamesShort string[12] - abbreviated names of the months (optional)
	 *					monthNames		string[12] - names of the months (optional)
	 * @return  string - the date in the above format
	 */
	formatDate: function (format, date, settings) {
		if (!date) {
			return "";
		}

		var iFormat,
			dayNamesShort = (settings ? settings.dayNamesShort : null) || this._defaults.dayNamesShort,
			dayNames = (settings ? settings.dayNames : null) || this._defaults.dayNames,
			monthNamesShort = (settings ? settings.monthNamesShort : null) || this._defaults.monthNamesShort,
			monthNames = (settings ? settings.monthNames : null) || this._defaults.monthNames,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			},
			// Format a number, with leading zero if necessary
			formatNumber = function(match, value, len) {
				var num = "" + value;
				if (lookAhead(match)) {
					while (num.length < len) {
						num = "0" + num;
					}
				}
				return num;
			},
			// Format a name, short or long as requested
			formatName = function(match, value, shortNames, longNames) {
				return (lookAhead(match) ? longNames[value] : shortNames[value]);
			},
			output = "",
			literal = false;

		if (date) {
			for (iFormat = 0; iFormat < format.length; iFormat++) {
				if (literal) {
					if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
						literal = false;
					} else {
						output += format.charAt(iFormat);
					}
				} else {
					switch (format.charAt(iFormat)) {
						case "d":
							output += formatNumber("d", date.getDate(), 2);
							break;
						case "D":
							output += formatName("D", date.getDay(), dayNamesShort, dayNames);
							break;
						case "o":
							output += formatNumber("o",
								Math.round((new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - new Date(date.getFullYear(), 0, 0).getTime()) / 86400000), 3);
							break;
						case "m":
							output += formatNumber("m", date.getMonth() + 1, 2);
							break;
						case "M":
							output += formatName("M", date.getMonth(), monthNamesShort, monthNames);
							break;
						case "y":
							output += (lookAhead("y") ? date.getFullYear() :
								(date.getYear() % 100 < 10 ? "0" : "") + date.getYear() % 100);
							break;
						case "@":
							output += date.getTime();
							break;
						case "!":
							output += date.getTime() * 10000 + this._ticksTo1970;
							break;
						case "'":
							if (lookAhead("'")) {
								output += "'";
							} else {
								literal = true;
							}
							break;
						default:
							output += format.charAt(iFormat);
					}
				}
			}
		}
		return output;
	},

	/* Extract all possible characters from the date format. */
	_possibleChars: function (format) {
		var iFormat,
			chars = "",
			literal = false,
			// Check whether a format character is doubled
			lookAhead = function(match) {
				var matches = (iFormat + 1 < format.length && format.charAt(iFormat + 1) === match);
				if (matches) {
					iFormat++;
				}
				return matches;
			};

		for (iFormat = 0; iFormat < format.length; iFormat++) {
			if (literal) {
				if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
					literal = false;
				} else {
					chars += format.charAt(iFormat);
				}
			} else {
				switch (format.charAt(iFormat)) {
					case "d": case "m": case "y": case "@":
						chars += "0123456789";
						break;
					case "D": case "M":
						return null; // Accept anything
					case "'":
						if (lookAhead("'")) {
							chars += "'";
						} else {
							literal = true;
						}
						break;
					default:
						chars += format.charAt(iFormat);
				}
			}
		}
		return chars;
	},

	/* Get a setting value, defaulting if necessary. */
	_get: function(inst, name) {
		return inst.settings[name] !== undefined ?
			inst.settings[name] : this._defaults[name];
	},

	/* Parse existing date and initialise date picker. */
	_setDateFromField: function(inst, noDefault) {
		if (inst.input.val() === inst.lastVal) {
			return;
		}

		var dateFormat = this._get(inst, "dateFormat"),
			dates = inst.lastVal = inst.input ? inst.input.val() : null,
			defaultDate = this._getDefaultDate(inst),
			date = defaultDate,
			settings = this._getFormatConfig(inst);

		try {
			date = this.parseDate(dateFormat, dates, settings) || defaultDate;
		} catch (event) {
			dates = (noDefault ? "" : dates);
		}
		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		inst.currentDay = (dates ? date.getDate() : 0);
		inst.currentMonth = (dates ? date.getMonth() : 0);
		inst.currentYear = (dates ? date.getFullYear() : 0);
		this._adjustInstDate(inst);
	},

	/* Retrieve the default date shown on opening. */
	_getDefaultDate: function(inst) {
		return this._restrictMinMax(inst,
			this._determineDate(inst, this._get(inst, "defaultDate"), new Date()));
	},

	/* A date may be specified as an exact value or a relative one. */
	_determineDate: function(inst, date, defaultDate) {
		var offsetNumeric = function(offset) {
				var date = new Date();
				date.setDate(date.getDate() + offset);
				return date;
			},
			offsetString = function(offset) {
				try {
					return $.datepicker.parseDate($.datepicker._get(inst, "dateFormat"),
						offset, $.datepicker._getFormatConfig(inst));
				}
				catch (e) {
					// Ignore
				}

				var date = (offset.toLowerCase().match(/^c/) ?
					$.datepicker._getDate(inst) : null) || new Date(),
					year = date.getFullYear(),
					month = date.getMonth(),
					day = date.getDate(),
					pattern = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,
					matches = pattern.exec(offset);

				while (matches) {
					switch (matches[2] || "d") {
						case "d" : case "D" :
							day += parseInt(matches[1],10); break;
						case "w" : case "W" :
							day += parseInt(matches[1],10) * 7; break;
						case "m" : case "M" :
							month += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
						case "y": case "Y" :
							year += parseInt(matches[1],10);
							day = Math.min(day, $.datepicker._getDaysInMonth(year, month));
							break;
					}
					matches = pattern.exec(offset);
				}
				return new Date(year, month, day);
			},
			newDate = (date == null || date === "" ? defaultDate : (typeof date === "string" ? offsetString(date) :
				(typeof date === "number" ? (isNaN(date) ? defaultDate : offsetNumeric(date)) : new Date(date.getTime()))));

		newDate = (newDate && newDate.toString() === "Invalid Date" ? defaultDate : newDate);
		if (newDate) {
			newDate.setHours(0);
			newDate.setMinutes(0);
			newDate.setSeconds(0);
			newDate.setMilliseconds(0);
		}
		return this._daylightSavingAdjust(newDate);
	},

	/* Handle switch to/from daylight saving.
	 * Hours may be non-zero on daylight saving cut-over:
	 * > 12 when midnight changeover, but then cannot generate
	 * midnight datetime, so jump to 1AM, otherwise reset.
	 * @param  date  (Date) the date to check
	 * @return  (Date) the corrected date
	 */
	_daylightSavingAdjust: function(date) {
		if (!date) {
			return null;
		}
		date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
		return date;
	},

	/* Set the date(s) directly. */
	_setDate: function(inst, date, noChange) {
		var clear = !date,
			origMonth = inst.selectedMonth,
			origYear = inst.selectedYear,
			newDate = this._restrictMinMax(inst, this._determineDate(inst, date, new Date()));

		inst.selectedDay = inst.currentDay = newDate.getDate();
		inst.drawMonth = inst.selectedMonth = inst.currentMonth = newDate.getMonth();
		inst.drawYear = inst.selectedYear = inst.currentYear = newDate.getFullYear();
		if ((origMonth !== inst.selectedMonth || origYear !== inst.selectedYear) && !noChange) {
			this._notifyChange(inst);
		}
		this._adjustInstDate(inst);
		if (inst.input) {
			inst.input.val(clear ? "" : this._formatDate(inst));
		}
	},

	/* Retrieve the date(s) directly. */
	_getDate: function(inst) {
		var startDate = (!inst.currentYear || (inst.input && inst.input.val() === "") ? null :
			this._daylightSavingAdjust(new Date(
			inst.currentYear, inst.currentMonth, inst.currentDay)));
			return startDate;
	},

	/* Attach the onxxx handlers.  These are declared statically so
	 * they work with static code transformers like Caja.
	 */
	_attachHandlers: function(inst) {
		var stepMonths = this._get(inst, "stepMonths"),
			id = "#" + inst.id.replace( /\\\\/g, "\\" );
		inst.dpDiv.find("[data-handler]").map(function () {
			var handler = {
				prev: function () {
					$.datepicker._adjustDate(id, -stepMonths, "M");
				},
				next: function () {
					$.datepicker._adjustDate(id, +stepMonths, "M");
				},
				hide: function () {
					$.datepicker._hideDatepicker();
				},
				today: function () {
					$.datepicker._gotoToday(id);
				},
				selectDay: function () {
					$.datepicker._selectDay(id, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this);
					return false;
				},
				selectMonth: function () {
					$.datepicker._selectMonthYear(id, this, "M");
					return false;
				},
				selectYear: function () {
					$.datepicker._selectMonthYear(id, this, "Y");
					return false;
				}
			};
			$(this).bind(this.getAttribute("data-event"), handler[this.getAttribute("data-handler")]);
		});
	},

	/* Generate the HTML for the current state of the date picker. */
	_generateHTML: function(inst) {
		var maxDraw, prevText, prev, nextText, next, currentText, gotoDate,
			controls, buttonPanel, firstDay, showWeek, dayNames, dayNamesMin,
			monthNames, monthNamesShort, beforeShowDay, showOtherMonths,
			selectOtherMonths, defaultDate, html, dow, row, group, col, selectedDate,
			cornerClass, calender, thead, day, daysInMonth, leadDays, curRows, numRows,
			printDate, dRow, tbody, daySettings, otherMonth, unselectable,
			tempDate = new Date(),
			today = this._daylightSavingAdjust(
				new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate())), // clear time
			isRTL = this._get(inst, "isRTL"),
			showButtonPanel = this._get(inst, "showButtonPanel"),
			hideIfNoPrevNext = this._get(inst, "hideIfNoPrevNext"),
			navigationAsDateFormat = this._get(inst, "navigationAsDateFormat"),
			numMonths = this._getNumberOfMonths(inst),
			showCurrentAtPos = this._get(inst, "showCurrentAtPos"),
			stepMonths = this._get(inst, "stepMonths"),
			isMultiMonth = (numMonths[0] !== 1 || numMonths[1] !== 1),
			currentDate = this._daylightSavingAdjust((!inst.currentDay ? new Date(9999, 9, 9) :
				new Date(inst.currentYear, inst.currentMonth, inst.currentDay))),
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			drawMonth = inst.drawMonth - showCurrentAtPos,
			drawYear = inst.drawYear;

		if (drawMonth < 0) {
			drawMonth += 12;
			drawYear--;
		}
		if (maxDate) {
			maxDraw = this._daylightSavingAdjust(new Date(maxDate.getFullYear(),
				maxDate.getMonth() - (numMonths[0] * numMonths[1]) + 1, maxDate.getDate()));
			maxDraw = (minDate && maxDraw < minDate ? minDate : maxDraw);
			while (this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1)) > maxDraw) {
				drawMonth--;
				if (drawMonth < 0) {
					drawMonth = 11;
					drawYear--;
				}
			}
		}
		inst.drawMonth = drawMonth;
		inst.drawYear = drawYear;

		prevText = this._get(inst, "prevText");
		prevText = (!navigationAsDateFormat ? prevText : this.formatDate(prevText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth - stepMonths, 1)),
			this._getFormatConfig(inst)));

		prev = (this._canAdjustMonth(inst, -1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click'" +
			" title='" + prevText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+ prevText +"'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "e" : "w") + "'>" + prevText + "</span></a>"));

		nextText = this._get(inst, "nextText");
		nextText = (!navigationAsDateFormat ? nextText : this.formatDate(nextText,
			this._daylightSavingAdjust(new Date(drawYear, drawMonth + stepMonths, 1)),
			this._getFormatConfig(inst)));

		next = (this._canAdjustMonth(inst, +1, drawYear, drawMonth) ?
			"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click'" +
			" title='" + nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>" :
			(hideIfNoPrevNext ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+ nextText + "'><span class='ui-icon ui-icon-circle-triangle-" + ( isRTL ? "w" : "e") + "'>" + nextText + "</span></a>"));

		currentText = this._get(inst, "currentText");
		gotoDate = (this._get(inst, "gotoCurrent") && inst.currentDay ? currentDate : today);
		currentText = (!navigationAsDateFormat ? currentText :
			this.formatDate(currentText, gotoDate, this._getFormatConfig(inst)));

		controls = (!inst.inline ? "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" +
			this._get(inst, "closeText") + "</button>" : "");

		buttonPanel = (showButtonPanel) ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (isRTL ? controls : "") +
			(this._isInRange(inst, gotoDate) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'" +
			">" + currentText + "</button>" : "") + (isRTL ? "" : controls) + "</div>" : "";

		firstDay = parseInt(this._get(inst, "firstDay"),10);
		firstDay = (isNaN(firstDay) ? 0 : firstDay);

		showWeek = this._get(inst, "showWeek");
		dayNames = this._get(inst, "dayNames");
		dayNamesMin = this._get(inst, "dayNamesMin");
		monthNames = this._get(inst, "monthNames");
		monthNamesShort = this._get(inst, "monthNamesShort");
		beforeShowDay = this._get(inst, "beforeShowDay");
		showOtherMonths = this._get(inst, "showOtherMonths");
		selectOtherMonths = this._get(inst, "selectOtherMonths");
		defaultDate = this._getDefaultDate(inst);
		html = "";
		dow;
		for (row = 0; row < numMonths[0]; row++) {
			group = "";
			this.maxRows = 4;
			for (col = 0; col < numMonths[1]; col++) {
				selectedDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, inst.selectedDay));
				cornerClass = " ui-corner-all";
				calender = "";
				if (isMultiMonth) {
					calender += "<div class='ui-datepicker-group";
					if (numMonths[1] > 1) {
						switch (col) {
							case 0: calender += " ui-datepicker-group-first";
								cornerClass = " ui-corner-" + (isRTL ? "right" : "left"); break;
							case numMonths[1]-1: calender += " ui-datepicker-group-last";
								cornerClass = " ui-corner-" + (isRTL ? "left" : "right"); break;
							default: calender += " ui-datepicker-group-middle"; cornerClass = ""; break;
						}
					}
					calender += "'>";
				}
				calender += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + cornerClass + "'>" +
					(/all|left/.test(cornerClass) && row === 0 ? (isRTL ? next : prev) : "") +
					(/all|right/.test(cornerClass) && row === 0 ? (isRTL ? prev : next) : "") +
					this._generateMonthYearHeader(inst, drawMonth, drawYear, minDate, maxDate,
					row > 0 || col > 0, monthNames, monthNamesShort) + // draw month headers
					"</div><table class='ui-datepicker-calendar'><thead>" +
					"<tr>";
				thead = (showWeek ? "<th class='ui-datepicker-week-col'>" + this._get(inst, "weekHeader") + "</th>" : "");
				for (dow = 0; dow < 7; dow++) { // days of the week
					day = (dow + firstDay) % 7;
					thead += "<th scope='col'" + ((dow + firstDay + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" +
						"<span title='" + dayNames[day] + "'>" + dayNamesMin[day] + "</span></th>";
				}
				calender += thead + "</tr></thead><tbody>";
				daysInMonth = this._getDaysInMonth(drawYear, drawMonth);
				if (drawYear === inst.selectedYear && drawMonth === inst.selectedMonth) {
					inst.selectedDay = Math.min(inst.selectedDay, daysInMonth);
				}
				leadDays = (this._getFirstDayOfMonth(drawYear, drawMonth) - firstDay + 7) % 7;
				curRows = Math.ceil((leadDays + daysInMonth) / 7); // calculate the number of rows to generate
				numRows = (isMultiMonth ? this.maxRows > curRows ? this.maxRows : curRows : curRows); //If multiple months, use the higher number of rows (see #7043)
				this.maxRows = numRows;
				printDate = this._daylightSavingAdjust(new Date(drawYear, drawMonth, 1 - leadDays));
				for (dRow = 0; dRow < numRows; dRow++) { // create date picker rows
					calender += "<tr>";
					tbody = (!showWeek ? "" : "<td class='ui-datepicker-week-col'>" +
						this._get(inst, "calculateWeek")(printDate) + "</td>");
					for (dow = 0; dow < 7; dow++) { // create date picker days
						daySettings = (beforeShowDay ?
							beforeShowDay.apply((inst.input ? inst.input[0] : null), [printDate]) : [true, ""]);
						otherMonth = (printDate.getMonth() !== drawMonth);
						unselectable = (otherMonth && !selectOtherMonths) || !daySettings[0] ||
							(minDate && printDate < minDate) || (maxDate && printDate > maxDate);
						tbody += "<td class='" +
							((dow + firstDay + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + // highlight weekends
							(otherMonth ? " ui-datepicker-other-month" : "") + // highlight days from other months
							((printDate.getTime() === selectedDate.getTime() && drawMonth === inst.selectedMonth && inst._keyEvent) || // user pressed key
							(defaultDate.getTime() === printDate.getTime() && defaultDate.getTime() === selectedDate.getTime()) ?
							// or defaultDate is current printedDate and defaultDate is selectedDate
							" " + this._dayOverClass : "") + // highlight selected day
							(unselectable ? " " + this._unselectableClass + " ui-state-disabled": "") +  // highlight unselectable days
							(otherMonth && !showOtherMonths ? "" : " " + daySettings[1] + // highlight custom dates
							(printDate.getTime() === currentDate.getTime() ? " " + this._currentClass : "") + // highlight selected day
							(printDate.getTime() === today.getTime() ? " ui-datepicker-today" : "")) + "'" + // highlight today (if different)
							((!otherMonth || showOtherMonths) && daySettings[2] ? " title='" + daySettings[2].replace(/'/g, "&#39;") + "'" : "") + // cell title
							(unselectable ? "" : " data-handler='selectDay' data-event='click' data-month='" + printDate.getMonth() + "' data-year='" + printDate.getFullYear() + "'") + ">" + // actions
							(otherMonth && !showOtherMonths ? "&#xa0;" : // display for other months
							(unselectable ? "<span class='ui-state-default'>" + printDate.getDate() + "</span>" : "<a class='ui-state-default" +
							(printDate.getTime() === today.getTime() ? " ui-state-highlight" : "") +
							(printDate.getTime() === currentDate.getTime() ? " ui-state-active" : "") + // highlight selected day
							(otherMonth ? " ui-priority-secondary" : "") + // distinguish dates from other months
							"' href='#'>" + printDate.getDate() + "</a>")) + "</td>"; // display selectable date
						printDate.setDate(printDate.getDate() + 1);
						printDate = this._daylightSavingAdjust(printDate);
					}
					calender += tbody + "</tr>";
				}
				drawMonth++;
				if (drawMonth > 11) {
					drawMonth = 0;
					drawYear++;
				}
				calender += "</tbody></table>" + (isMultiMonth ? "</div>" +
							((numMonths[0] > 0 && col === numMonths[1]-1) ? "<div class='ui-datepicker-row-break'></div>" : "") : "");
				group += calender;
			}
			html += group;
		}
		html += buttonPanel;
		inst._keyEvent = false;
		return html;
	},

	/* Generate the month and year header. */
	_generateMonthYearHeader: function(inst, drawMonth, drawYear, minDate, maxDate,
			secondary, monthNames, monthNamesShort) {

		var inMinYear, inMaxYear, month, years, thisYear, determineYear, year, endYear,
			changeMonth = this._get(inst, "changeMonth"),
			changeYear = this._get(inst, "changeYear"),
			showMonthAfterYear = this._get(inst, "showMonthAfterYear"),
			html = "<div class='ui-datepicker-title'>",
			monthHtml = "";

		// month selection
		if (secondary || !changeMonth) {
			monthHtml += "<span class='ui-datepicker-month'>" + monthNames[drawMonth] + "</span>";
		} else {
			inMinYear = (minDate && minDate.getFullYear() === drawYear);
			inMaxYear = (maxDate && maxDate.getFullYear() === drawYear);
			monthHtml += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>";
			for ( month = 0; month < 12; month++) {
				if ((!inMinYear || month >= minDate.getMonth()) && (!inMaxYear || month <= maxDate.getMonth())) {
					monthHtml += "<option value='" + month + "'" +
						(month === drawMonth ? " selected='selected'" : "") +
						">" + monthNamesShort[month] + "</option>";
				}
			}
			monthHtml += "</select>";
		}

		if (!showMonthAfterYear) {
			html += monthHtml + (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "");
		}

		// year selection
		if ( !inst.yearshtml ) {
			inst.yearshtml = "";
			if (secondary || !changeYear) {
				html += "<span class='ui-datepicker-year'>" + drawYear + "</span>";
			} else {
				// determine range of years to display
				years = this._get(inst, "yearRange").split(":");
				thisYear = new Date().getFullYear();
				determineYear = function(value) {
					var year = (value.match(/c[+\-].*/) ? drawYear + parseInt(value.substring(1), 10) :
						(value.match(/[+\-].*/) ? thisYear + parseInt(value, 10) :
						parseInt(value, 10)));
					return (isNaN(year) ? thisYear : year);
				};
				year = determineYear(years[0]);
				endYear = Math.max(year, determineYear(years[1] || ""));
				year = (minDate ? Math.max(year, minDate.getFullYear()) : year);
				endYear = (maxDate ? Math.min(endYear, maxDate.getFullYear()) : endYear);
				inst.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";
				for (; year <= endYear; year++) {
					inst.yearshtml += "<option value='" + year + "'" +
						(year === drawYear ? " selected='selected'" : "") +
						">" + year + "</option>";
				}
				inst.yearshtml += "</select>";

				html += inst.yearshtml;
				inst.yearshtml = null;
			}
		}

		html += this._get(inst, "yearSuffix");
		if (showMonthAfterYear) {
			html += (secondary || !(changeMonth && changeYear) ? "&#xa0;" : "") + monthHtml;
		}
		html += "</div>"; // Close datepicker_header
		return html;
	},

	/* Adjust one of the date sub-fields. */
	_adjustInstDate: function(inst, offset, period) {
		var year = inst.drawYear + (period === "Y" ? offset : 0),
			month = inst.drawMonth + (period === "M" ? offset : 0),
			day = Math.min(inst.selectedDay, this._getDaysInMonth(year, month)) + (period === "D" ? offset : 0),
			date = this._restrictMinMax(inst, this._daylightSavingAdjust(new Date(year, month, day)));

		inst.selectedDay = date.getDate();
		inst.drawMonth = inst.selectedMonth = date.getMonth();
		inst.drawYear = inst.selectedYear = date.getFullYear();
		if (period === "M" || period === "Y") {
			this._notifyChange(inst);
		}
	},

	/* Ensure a date is within any min/max bounds. */
	_restrictMinMax: function(inst, date) {
		var minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			newDate = (minDate && date < minDate ? minDate : date);
		return (maxDate && newDate > maxDate ? maxDate : newDate);
	},

	/* Notify change of month/year. */
	_notifyChange: function(inst) {
		var onChange = this._get(inst, "onChangeMonthYear");
		if (onChange) {
			onChange.apply((inst.input ? inst.input[0] : null),
				[inst.selectedYear, inst.selectedMonth + 1, inst]);
		}
	},

	/* Determine the number of months to show. */
	_getNumberOfMonths: function(inst) {
		var numMonths = this._get(inst, "numberOfMonths");
		return (numMonths == null ? [1, 1] : (typeof numMonths === "number" ? [1, numMonths] : numMonths));
	},

	/* Determine the current maximum date - ensure no time components are set. */
	_getMinMaxDate: function(inst, minMax) {
		return this._determineDate(inst, this._get(inst, minMax + "Date"), null);
	},

	/* Find the number of days in a given month. */
	_getDaysInMonth: function(year, month) {
		return 32 - this._daylightSavingAdjust(new Date(year, month, 32)).getDate();
	},

	/* Find the day of the week of the first of a month. */
	_getFirstDayOfMonth: function(year, month) {
		return new Date(year, month, 1).getDay();
	},

	/* Determines if we should allow a "next/prev" month display change. */
	_canAdjustMonth: function(inst, offset, curYear, curMonth) {
		var numMonths = this._getNumberOfMonths(inst),
			date = this._daylightSavingAdjust(new Date(curYear,
			curMonth + (offset < 0 ? offset : numMonths[0] * numMonths[1]), 1));

		if (offset < 0) {
			date.setDate(this._getDaysInMonth(date.getFullYear(), date.getMonth()));
		}
		return this._isInRange(inst, date);
	},

	/* Is the given date in the accepted range? */
	_isInRange: function(inst, date) {
		var yearSplit, currentYear,
			minDate = this._getMinMaxDate(inst, "min"),
			maxDate = this._getMinMaxDate(inst, "max"),
			minYear = null,
			maxYear = null,
			years = this._get(inst, "yearRange");
			if (years){
				yearSplit = years.split(":");
				currentYear = new Date().getFullYear();
				minYear = parseInt(yearSplit[0], 10);
				maxYear = parseInt(yearSplit[1], 10);
				if ( yearSplit[0].match(/[+\-].*/) ) {
					minYear += currentYear;
				}
				if ( yearSplit[1].match(/[+\-].*/) ) {
					maxYear += currentYear;
				}
			}

		return ((!minDate || date.getTime() >= minDate.getTime()) &&
			(!maxDate || date.getTime() <= maxDate.getTime()) &&
			(!minYear || date.getFullYear() >= minYear) &&
			(!maxYear || date.getFullYear() <= maxYear));
	},

	/* Provide the configuration settings for formatting/parsing. */
	_getFormatConfig: function(inst) {
		var shortYearCutoff = this._get(inst, "shortYearCutoff");
		shortYearCutoff = (typeof shortYearCutoff !== "string" ? shortYearCutoff :
			new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10));
		return {shortYearCutoff: shortYearCutoff,
			dayNamesShort: this._get(inst, "dayNamesShort"), dayNames: this._get(inst, "dayNames"),
			monthNamesShort: this._get(inst, "monthNamesShort"), monthNames: this._get(inst, "monthNames")};
	},

	/* Format the given date for display. */
	_formatDate: function(inst, day, month, year) {
		if (!day) {
			inst.currentDay = inst.selectedDay;
			inst.currentMonth = inst.selectedMonth;
			inst.currentYear = inst.selectedYear;
		}
		var date = (day ? (typeof day === "object" ? day :
			this._daylightSavingAdjust(new Date(year, month, day))) :
			this._daylightSavingAdjust(new Date(inst.currentYear, inst.currentMonth, inst.currentDay)));
		return this.formatDate(this._get(inst, "dateFormat"), date, this._getFormatConfig(inst));
	}
});

/*
 * Bind hover events for datepicker elements.
 * Done via delegate so the binding only occurs once in the lifetime of the parent div.
 * Global datepicker_instActive, set by _updateDatepicker allows the handlers to find their way back to the active picker.
 */
function datepicker_bindHover(dpDiv) {
	var selector = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
	return dpDiv.delegate(selector, "mouseout", function() {
			$(this).removeClass("ui-state-hover");
			if (this.className.indexOf("ui-datepicker-prev") !== -1) {
				$(this).removeClass("ui-datepicker-prev-hover");
			}
			if (this.className.indexOf("ui-datepicker-next") !== -1) {
				$(this).removeClass("ui-datepicker-next-hover");
			}
		})
		.delegate( selector, "mouseover", datepicker_handleMouseover );
}

function datepicker_handleMouseover() {
	if (!$.datepicker._isDisabledDatepicker( datepicker_instActive.inline? datepicker_instActive.dpDiv.parent()[0] : datepicker_instActive.input[0])) {
		$(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover");
		$(this).addClass("ui-state-hover");
		if (this.className.indexOf("ui-datepicker-prev") !== -1) {
			$(this).addClass("ui-datepicker-prev-hover");
		}
		if (this.className.indexOf("ui-datepicker-next") !== -1) {
			$(this).addClass("ui-datepicker-next-hover");
		}
	}
}

/* jQuery extend now ignores nulls! */
function datepicker_extendRemove(target, props) {
	$.extend(target, props);
	for (var name in props) {
		if (props[name] == null) {
			target[name] = props[name];
		}
	}
	return target;
}

/* Invoke the datepicker functionality.
   @param  options  string - a command, optionally followed by additional parameters or
					Object - settings for attaching new datepicker functionality
   @return  jQuery object */
$.fn.datepicker = function(options){

	/* Verify an empty collection wasn't passed - Fixes #6976 */
	if ( !this.length ) {
		return this;
	}

	/* Initialise the date picker. */
	if (!$.datepicker.initialized) {
		$(document).mousedown($.datepicker._checkExternalClick);
		$.datepicker.initialized = true;
	}

	/* Append datepicker main container to body if not exist. */
	if ($("#"+$.datepicker._mainDivId).length === 0) {
		$("body").append($.datepicker.dpDiv);
	}

	var otherArgs = Array.prototype.slice.call(arguments, 1);
	if (typeof options === "string" && (options === "isDisabled" || options === "getDate" || options === "widget")) {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	if (options === "option" && arguments.length === 2 && typeof arguments[1] === "string") {
		return $.datepicker["_" + options + "Datepicker"].
			apply($.datepicker, [this[0]].concat(otherArgs));
	}
	return this.each(function() {
		typeof options === "string" ?
			$.datepicker["_" + options + "Datepicker"].
				apply($.datepicker, [this].concat(otherArgs)) :
			$.datepicker._attachDatepicker(this, options);
	});
};

$.datepicker = new Datepicker(); // singleton instance
$.datepicker.initialized = false;
$.datepicker.uuid = new Date().getTime();
$.datepicker.version = "1.11.4";

var datepicker = $.datepicker;


/*!
 * jQuery UI Draggable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/draggable/
 */


$.widget("ui.draggable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "drag",
	options: {
		addClasses: true,
		appendTo: "parent",
		axis: false,
		connectToSortable: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		grid: false,
		handle: false,
		helper: "original",
		iframeFix: false,
		opacity: false,
		refreshPositions: false,
		revert: false,
		revertDuration: 500,
		scope: "default",
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		snap: false,
		snapMode: "both",
		snapTolerance: 20,
		stack: false,
		zIndex: false,

		// callbacks
		drag: null,
		start: null,
		stop: null
	},
	_create: function() {

		if ( this.options.helper === "original" ) {
			this._setPositionRelative();
		}
		if (this.options.addClasses){
			this.element.addClass("ui-draggable");
		}
		if (this.options.disabled){
			this.element.addClass("ui-draggable-disabled");
		}
		this._setHandleClassName();

		this._mouseInit();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "handle" ) {
			this._removeHandleClassName();
			this._setHandleClassName();
		}
	},

	_destroy: function() {
		if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
			this.destroyOnClear = true;
			return;
		}
		this.element.removeClass( "ui-draggable ui-draggable-dragging ui-draggable-disabled" );
		this._removeHandleClassName();
		this._mouseDestroy();
	},

	_mouseCapture: function(event) {
		var o = this.options;

		this._blurActiveElement( event );

		// among others, prevent a drag on a resizable-handle
		if (this.helper || o.disabled || $(event.target).closest(".ui-resizable-handle").length > 0) {
			return false;
		}

		//Quit if we're not on a valid handle
		this.handle = this._getHandle(event);
		if (!this.handle) {
			return false;
		}

		this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );

		return true;

	},

	_blockFrames: function( selector ) {
		this.iframeBlocks = this.document.find( selector ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css( "position", "absolute" )
				.appendTo( iframe.parent() )
				.outerWidth( iframe.outerWidth() )
				.outerHeight( iframe.outerHeight() )
				.offset( iframe.offset() )[ 0 ];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_blurActiveElement: function( event ) {
		var document = this.document[ 0 ];

		// Only need to blur if the event occurred on the draggable itself, see #10527
		if ( !this.handleElement.is( event.target ) ) {
			return;
		}

		// support: IE9
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {

			// Support: IE9, IE10
			// If the <body> is blurred, IE will switch windows, see #9520
			if ( document.activeElement && document.activeElement.nodeName.toLowerCase() !== "body" ) {

				// Blur any element that currently has focus, see #4261
				$( document.activeElement ).blur();
			}
		} catch ( error ) {}
	},

	_mouseStart: function(event) {

		var o = this.options;

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		this.helper.addClass("ui-draggable-dragging");

		//Cache the helper size
		this._cacheHelperProportions();

		//If ddmanager is used for droppables, set the global draggable
		if ($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Store the helper's css position
		this.cssPosition = this.helper.css( "position" );
		this.scrollParent = this.helper.scrollParent( true );
		this.offsetParent = this.helper.offsetParent();
		this.hasFixedAncestor = this.helper.parents().filter(function() {
				return $( this ).css( "position" ) === "fixed";
			}).length > 0;

		//The element's absolute position on the page minus margins
		this.positionAbs = this.element.offset();
		this._refreshOffsets( event );

		//Generate the original position
		this.originalPosition = this.position = this._generatePosition( event, false );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Set a containment if given in the options
		this._setContainment();

		//Trigger event + callbacks
		if (this._trigger("start", event) === false) {
			this._clear();
			return false;
		}

		//Recache the helper size
		this._cacheHelperProportions();

		//Prepare the droppable offsets
		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		// Reset helper's right/bottom css if they're set and set explicit width/height instead
		// as this prevents resizing of elements with right/bottom set (see #7772)
		this._normalizeRightBottom();

		this._mouseDrag(event, true); //Execute the drag once - this causes the helper not to be visible before getting its correct position

		//If the ddmanager is used for droppables, inform the manager that dragging has started (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStart(this, event);
		}

		return true;
	},

	_refreshOffsets: function( event ) {
		this.offset = {
			top: this.positionAbs.top - this.margins.top,
			left: this.positionAbs.left - this.margins.left,
			scroll: false,
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset()
		};

		this.offset.click = {
			left: event.pageX - this.offset.left,
			top: event.pageY - this.offset.top
		};
	},

	_mouseDrag: function(event, noPropagation) {
		// reset any necessary cached properties (see #5009)
		if ( this.hasFixedAncestor ) {
			this.offset.parent = this._getParentOffset();
		}

		//Compute the helpers position
		this.position = this._generatePosition( event, true );
		this.positionAbs = this._convertPositionTo("absolute");

		//Call plugins and callbacks and use the resulting position if something is returned
		if (!noPropagation) {
			var ui = this._uiHash();
			if (this._trigger("drag", event, ui) === false) {
				this._mouseUp({});
				return false;
			}
			this.position = ui.position;
		}

		this.helper[ 0 ].style.left = this.position.left + "px";
		this.helper[ 0 ].style.top = this.position.top + "px";

		if ($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		return false;
	},

	_mouseStop: function(event) {

		//If we are using droppables, inform the manager about the drop
		var that = this,
			dropped = false;
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			dropped = $.ui.ddmanager.drop(this, event);
		}

		//if a drop comes from outside (a sortable)
		if (this.dropped) {
			dropped = this.dropped;
			this.dropped = false;
		}

		if ((this.options.revert === "invalid" && !dropped) || (this.options.revert === "valid" && dropped) || this.options.revert === true || ($.isFunction(this.options.revert) && this.options.revert.call(this.element, dropped))) {
			$(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function() {
				if (that._trigger("stop", event) !== false) {
					that._clear();
				}
			});
		} else {
			if (this._trigger("stop", event) !== false) {
				this._clear();
			}
		}

		return false;
	},

	_mouseUp: function( event ) {
		this._unblockFrames();

		//If the ddmanager is used for droppables, inform the manager that dragging has stopped (see #5003)
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.dragStop(this, event);
		}

		// Only need to focus if the event occurred on the draggable itself, see #10527
		if ( this.handleElement.is( event.target ) ) {
			// The interaction is over; whether or not the click resulted in a drag, focus the element
			this.element.focus();
		}

		return $.ui.mouse.prototype._mouseUp.call(this, event);
	},

	cancel: function() {

		if (this.helper.is(".ui-draggable-dragging")) {
			this._mouseUp({});
		} else {
			this._clear();
		}

		return this;

	},

	_getHandle: function(event) {
		return this.options.handle ?
			!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
			true;
	},

	_setHandleClassName: function() {
		this.handleElement = this.options.handle ?
			this.element.find( this.options.handle ) : this.element;
		this.handleElement.addClass( "ui-draggable-handle" );
	},

	_removeHandleClassName: function() {
		this.handleElement.removeClass( "ui-draggable-handle" );
	},

	_createHelper: function(event) {

		var o = this.options,
			helperIsFunction = $.isFunction( o.helper ),
			helper = helperIsFunction ?
				$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
				( o.helper === "clone" ?
					this.element.clone().removeAttr( "id" ) :
					this.element );

		if (!helper.parents("body").length) {
			helper.appendTo((o.appendTo === "parent" ? this.element[0].parentNode : o.appendTo));
		}

		// http://bugs.jqueryui.com/ticket/9446
		// a helper function can return the original element
		// which wouldn't have been set to relative in _create
		if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
			this._setPositionRelative();
		}

		if (helper[0] !== this.element[0] && !(/(fixed|absolute)/).test(helper.css("position"))) {
			helper.css("position", "absolute");
		}

		return helper;

	},

	_setPositionRelative: function() {
		if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
			this.element[ 0 ].style.position = "relative";
		}
	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = { left: +obj[0], top: +obj[1] || 0 };
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_isRootNode: function( element ) {
		return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		var po = this.offsetParent.offset(),
			document = this.document[ 0 ];

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if (this.cssPosition === "absolute" && this.scrollParent[0] !== document && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
		};

	},

	_getRelativeOffset: function() {
		if ( this.cssPosition !== "relative" ) {
			return { top: 0, left: 0 };
		}

		var p = this.element.position(),
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: p.top - ( parseInt(this.helper.css( "top" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
			left: p.left - ( parseInt(this.helper.css( "left" ), 10) || 0 ) + ( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
		};

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.element.css("marginLeft"), 10) || 0),
			top: (parseInt(this.element.css("marginTop"), 10) || 0),
			right: (parseInt(this.element.css("marginRight"), 10) || 0),
			bottom: (parseInt(this.element.css("marginBottom"), 10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var isUserScrollable, c, ce,
			o = this.options,
			document = this.document[ 0 ];

		this.relativeContainer = null;

		if ( !o.containment ) {
			this.containment = null;
			return;
		}

		if ( o.containment === "window" ) {
			this.containment = [
				$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
				$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
				$( window ).scrollLeft() + $( window ).width() - this.helperProportions.width - this.margins.left,
				$( window ).scrollTop() + ( $( window ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment === "document") {
			this.containment = [
				0,
				0,
				$( document ).width() - this.helperProportions.width - this.margins.left,
				( $( document ).height() || document.body.parentNode.scrollHeight ) - this.helperProportions.height - this.margins.top
			];
			return;
		}

		if ( o.containment.constructor === Array ) {
			this.containment = o.containment;
			return;
		}

		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}

		c = $( o.containment );
		ce = c[ 0 ];

		if ( !ce ) {
			return;
		}

		isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );

		this.containment = [
			( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
			( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) + ( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
			( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
				( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
				this.helperProportions.width -
				this.margins.left -
				this.margins.right,
			( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
				( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
				( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
				this.helperProportions.height -
				this.margins.top -
				this.margins.bottom
		];
		this.relativeContainer = c;
	},

	_convertPositionTo: function(d, pos) {

		if (!pos) {
			pos = this.position;
		}

		var mod = d === "absolute" ? 1 : -1,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod)
			)
		};

	},

	_generatePosition: function( event, constrainPosition ) {

		var containment, co, top, left,
			o = this.options,
			scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
			pageX = event.pageX,
			pageY = event.pageY;

		// Cache the scroll
		if ( !scrollIsRootNode || !this.offset.scroll ) {
			this.offset.scroll = {
				top: this.scrollParent.scrollTop(),
				left: this.scrollParent.scrollLeft()
			};
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		// If we are not dragging yet, we won't check for options
		if ( constrainPosition ) {
			if ( this.containment ) {
				if ( this.relativeContainer ){
					co = this.relativeContainer.offset();
					containment = [
						this.containment[ 0 ] + co.left,
						this.containment[ 1 ] + co.top,
						this.containment[ 2 ] + co.left,
						this.containment[ 3 ] + co.top
					];
				} else {
					containment = this.containment;
				}

				if (event.pageX - this.offset.click.left < containment[0]) {
					pageX = containment[0] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top < containment[1]) {
					pageY = containment[1] + this.offset.click.top;
				}
				if (event.pageX - this.offset.click.left > containment[2]) {
					pageX = containment[2] + this.offset.click.left;
				}
				if (event.pageY - this.offset.click.top > containment[3]) {
					pageY = containment[3] + this.offset.click.top;
				}
			}

			if (o.grid) {
				//Check for grid elements set to 0 to prevent divide by 0 error causing invalid argument errors in IE (see ticket #6950)
				top = o.grid[1] ? this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY;
				pageY = containment ? ((top - this.offset.click.top >= containment[1] || top - this.offset.click.top > containment[3]) ? top : ((top - this.offset.click.top >= containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = o.grid[0] ? this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX;
				pageX = containment ? ((left - this.offset.click.left >= containment[0] || left - this.offset.click.left > containment[2]) ? left : ((left - this.offset.click.left >= containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

			if ( o.axis === "y" ) {
				pageX = this.originalPageX;
			}

			if ( o.axis === "x" ) {
				pageY = this.originalPageY;
			}
		}

		return {
			top: (
				pageY -																	// The absolute mouse position
				this.offset.click.top	-												// Click offset (relative to the element)
				this.offset.relative.top -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.top : ( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
			),
			left: (
				pageX -																	// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left -												// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( this.cssPosition === "fixed" ? -this.offset.scroll.left : ( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
			)
		};

	},

	_clear: function() {
		this.helper.removeClass("ui-draggable-dragging");
		if (this.helper[0] !== this.element[0] && !this.cancelHelperRemoval) {
			this.helper.remove();
		}
		this.helper = null;
		this.cancelHelperRemoval = false;
		if ( this.destroyOnClear ) {
			this.destroy();
		}
	},

	_normalizeRightBottom: function() {
		if ( this.options.axis !== "y" && this.helper.css( "right" ) !== "auto" ) {
			this.helper.width( this.helper.width() );
			this.helper.css( "right", "auto" );
		}
		if ( this.options.axis !== "x" && this.helper.css( "bottom" ) !== "auto" ) {
			this.helper.height( this.helper.height() );
			this.helper.css( "bottom", "auto" );
		}
	},

	// From now on bulk stuff - mainly helpers

	_trigger: function( type, event, ui ) {
		ui = ui || this._uiHash();
		$.ui.plugin.call( this, type, [ event, ui, this ], true );

		// Absolute position and offset (see #6884 ) have to be recalculated after plugins
		if ( /^(drag|start|stop)/.test( type ) ) {
			this.positionAbs = this._convertPositionTo( "absolute" );
			ui.offset = this.positionAbs;
		}
		return $.Widget.prototype._trigger.call( this, type, event, ui );
	},

	plugins: {},

	_uiHash: function() {
		return {
			helper: this.helper,
			position: this.position,
			originalPosition: this.originalPosition,
			offset: this.positionAbs
		};
	}

});

$.ui.plugin.add( "draggable", "connectToSortable", {
	start: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.sortables = [];
		$( draggable.options.connectToSortable ).each(function() {
			var sortable = $( this ).sortable( "instance" );

			if ( sortable && !sortable.options.disabled ) {
				draggable.sortables.push( sortable );

				// refreshPositions is called at drag start to refresh the containerCache
				// which is used in drag. This ensures it's initialized and synchronized
				// with any changes that might have happened on the page since initialization.
				sortable.refreshPositions();
				sortable._trigger("activate", event, uiSortable);
			}
		});
	},
	stop: function( event, ui, draggable ) {
		var uiSortable = $.extend( {}, ui, {
			item: draggable.element
		});

		draggable.cancelHelperRemoval = false;

		$.each( draggable.sortables, function() {
			var sortable = this;

			if ( sortable.isOver ) {
				sortable.isOver = 0;

				// Allow this sortable to handle removing the helper
				draggable.cancelHelperRemoval = true;
				sortable.cancelHelperRemoval = false;

				// Use _storedCSS To restore properties in the sortable,
				// as this also handles revert (#9675) since the draggable
				// may have modified them in unexpected ways (#8809)
				sortable._storedCSS = {
					position: sortable.placeholder.css( "position" ),
					top: sortable.placeholder.css( "top" ),
					left: sortable.placeholder.css( "left" )
				};

				sortable._mouseStop(event);

				// Once drag has ended, the sortable should return to using
				// its original helper, not the shared helper from draggable
				sortable.options.helper = sortable.options._helper;
			} else {
				// Prevent this Sortable from removing the helper.
				// However, don't set the draggable to remove the helper
				// either as another connected Sortable may yet handle the removal.
				sortable.cancelHelperRemoval = true;

				sortable._trigger( "deactivate", event, uiSortable );
			}
		});
	},
	drag: function( event, ui, draggable ) {
		$.each( draggable.sortables, function() {
			var innermostIntersecting = false,
				sortable = this;

			// Copy over variables that sortable's _intersectsWith uses
			sortable.positionAbs = draggable.positionAbs;
			sortable.helperProportions = draggable.helperProportions;
			sortable.offset.click = draggable.offset.click;

			if ( sortable._intersectsWith( sortable.containerCache ) ) {
				innermostIntersecting = true;

				$.each( draggable.sortables, function() {
					// Copy over variables that sortable's _intersectsWith uses
					this.positionAbs = draggable.positionAbs;
					this.helperProportions = draggable.helperProportions;
					this.offset.click = draggable.offset.click;

					if ( this !== sortable &&
							this._intersectsWith( this.containerCache ) &&
							$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
						innermostIntersecting = false;
					}

					return innermostIntersecting;
				});
			}

			if ( innermostIntersecting ) {
				// If it intersects, we use a little isOver variable and set it once,
				// so that the move-in stuff gets fired only once.
				if ( !sortable.isOver ) {
					sortable.isOver = 1;

					// Store draggable's parent in case we need to reappend to it later.
					draggable._parent = ui.helper.parent();

					sortable.currentItem = ui.helper
						.appendTo( sortable.element )
						.data( "ui-sortable-item", true );

					// Store helper option to later restore it
					sortable.options._helper = sortable.options.helper;

					sortable.options.helper = function() {
						return ui.helper[ 0 ];
					};

					// Fire the start events of the sortable with our passed browser event,
					// and our own helper (so it doesn't create a new one)
					event.target = sortable.currentItem[ 0 ];
					sortable._mouseCapture( event, true );
					sortable._mouseStart( event, true, true );

					// Because the browser event is way off the new appended portlet,
					// modify necessary variables to reflect the changes
					sortable.offset.click.top = draggable.offset.click.top;
					sortable.offset.click.left = draggable.offset.click.left;
					sortable.offset.parent.left -= draggable.offset.parent.left -
						sortable.offset.parent.left;
					sortable.offset.parent.top -= draggable.offset.parent.top -
						sortable.offset.parent.top;

					draggable._trigger( "toSortable", event );

					// Inform draggable that the helper is in a valid drop zone,
					// used solely in the revert option to handle "valid/invalid".
					draggable.dropped = sortable.element;

					// Need to refreshPositions of all sortables in the case that
					// adding to one sortable changes the location of the other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});

					// hack so receive/update callbacks work (mostly)
					draggable.currentItem = draggable.element;
					sortable.fromOutside = draggable;
				}

				if ( sortable.currentItem ) {
					sortable._mouseDrag( event );
					// Copy the sortable's position because the draggable's can potentially reflect
					// a relative position, while sortable is always absolute, which the dragged
					// element has now become. (#8809)
					ui.position = sortable.position;
				}
			} else {
				// If it doesn't intersect with the sortable, and it intersected before,
				// we fake the drag stop of the sortable, but make sure it doesn't remove
				// the helper by using cancelHelperRemoval.
				if ( sortable.isOver ) {

					sortable.isOver = 0;
					sortable.cancelHelperRemoval = true;

					// Calling sortable's mouseStop would trigger a revert,
					// so revert must be temporarily false until after mouseStop is called.
					sortable.options._revert = sortable.options.revert;
					sortable.options.revert = false;

					sortable._trigger( "out", event, sortable._uiHash( sortable ) );
					sortable._mouseStop( event, true );

					// restore sortable behaviors that were modfied
					// when the draggable entered the sortable area (#9481)
					sortable.options.revert = sortable.options._revert;
					sortable.options.helper = sortable.options._helper;

					if ( sortable.placeholder ) {
						sortable.placeholder.remove();
					}

					// Restore and recalculate the draggable's offset considering the sortable
					// may have modified them in unexpected ways. (#8809, #10669)
					ui.helper.appendTo( draggable._parent );
					draggable._refreshOffsets( event );
					ui.position = draggable._generatePosition( event, true );

					draggable._trigger( "fromSortable", event );

					// Inform draggable that the helper is no longer in a valid drop zone
					draggable.dropped = false;

					// Need to refreshPositions of all sortables just in case removing
					// from one sortable changes the location of other sortables (#9675)
					$.each( draggable.sortables, function() {
						this.refreshPositions();
					});
				}
			}
		});
	}
});

$.ui.plugin.add("draggable", "cursor", {
	start: function( event, ui, instance ) {
		var t = $( "body" ),
			o = instance.options;

		if (t.css("cursor")) {
			o._cursor = t.css("cursor");
		}
		t.css("cursor", o.cursor);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._cursor) {
			$("body").css("cursor", o._cursor);
		}
	}
});

$.ui.plugin.add("draggable", "opacity", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;
		if (t.css("opacity")) {
			o._opacity = t.css("opacity");
		}
		t.css("opacity", o.opacity);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;
		if (o._opacity) {
			$(ui.helper).css("opacity", o._opacity);
		}
	}
});

$.ui.plugin.add("draggable", "scroll", {
	start: function( event, ui, i ) {
		if ( !i.scrollParentNotHidden ) {
			i.scrollParentNotHidden = i.helper.scrollParent( false );
		}

		if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] && i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
			i.overflowOffset = i.scrollParentNotHidden.offset();
		}
	},
	drag: function( event, ui, i  ) {

		var o = i.options,
			scrolled = false,
			scrollParent = i.scrollParentNotHidden[ 0 ],
			document = i.document[ 0 ];

		if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
			if ( !o.axis || o.axis !== "x" ) {
				if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
				} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
					scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
				}
			}

			if ( !o.axis || o.axis !== "y" ) {
				if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
					scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
				}
			}

		} else {

			if (!o.axis || o.axis !== "x") {
				if (event.pageY - $(document).scrollTop() < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() - o.scrollSpeed);
				} else if ($(window).height() - (event.pageY - $(document).scrollTop()) < o.scrollSensitivity) {
					scrolled = $(document).scrollTop($(document).scrollTop() + o.scrollSpeed);
				}
			}

			if (!o.axis || o.axis !== "y") {
				if (event.pageX - $(document).scrollLeft() < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() - o.scrollSpeed);
				} else if ($(window).width() - (event.pageX - $(document).scrollLeft()) < o.scrollSensitivity) {
					scrolled = $(document).scrollLeft($(document).scrollLeft() + o.scrollSpeed);
				}
			}

		}

		if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(i, event);
		}

	}
});

$.ui.plugin.add("draggable", "snap", {
	start: function( event, ui, i ) {

		var o = i.options;

		i.snapElements = [];

		$(o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap).each(function() {
			var $t = $(this),
				$o = $t.offset();
			if (this !== i.element[0]) {
				i.snapElements.push({
					item: this,
					width: $t.outerWidth(), height: $t.outerHeight(),
					top: $o.top, left: $o.left
				});
			}
		});

	},
	drag: function( event, ui, inst ) {

		var ts, bs, ls, rs, l, r, t, b, i, first,
			o = inst.options,
			d = o.snapTolerance,
			x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
			y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;

		for (i = inst.snapElements.length - 1; i >= 0; i--){

			l = inst.snapElements[i].left - inst.margins.left;
			r = l + inst.snapElements[i].width;
			t = inst.snapElements[i].top - inst.margins.top;
			b = t + inst.snapElements[i].height;

			if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d || !$.contains( inst.snapElements[ i ].item.ownerDocument, inst.snapElements[ i ].item ) ) {
				if (inst.snapElements[i].snapping) {
					(inst.options.snap.release && inst.options.snap.release.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
				}
				inst.snapElements[i].snapping = false;
				continue;
			}

			if (o.snapMode !== "inner") {
				ts = Math.abs(t - y2) <= d;
				bs = Math.abs(b - y1) <= d;
				ls = Math.abs(l - x2) <= d;
				rs = Math.abs(r - x1) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t - inst.helperProportions.height, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l - inst.helperProportions.width }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r }).left;
				}
			}

			first = (ts || bs || ls || rs);

			if (o.snapMode !== "outer") {
				ts = Math.abs(t - y1) <= d;
				bs = Math.abs(b - y2) <= d;
				ls = Math.abs(l - x1) <= d;
				rs = Math.abs(r - x2) <= d;
				if (ts) {
					ui.position.top = inst._convertPositionTo("relative", { top: t, left: 0 }).top;
				}
				if (bs) {
					ui.position.top = inst._convertPositionTo("relative", { top: b - inst.helperProportions.height, left: 0 }).top;
				}
				if (ls) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: l }).left;
				}
				if (rs) {
					ui.position.left = inst._convertPositionTo("relative", { top: 0, left: r - inst.helperProportions.width }).left;
				}
			}

			if (!inst.snapElements[i].snapping && (ts || bs || ls || rs || first)) {
				(inst.options.snap.snap && inst.options.snap.snap.call(inst.element, event, $.extend(inst._uiHash(), { snapItem: inst.snapElements[i].item })));
			}
			inst.snapElements[i].snapping = (ts || bs || ls || rs || first);

		}

	}
});

$.ui.plugin.add("draggable", "stack", {
	start: function( event, ui, instance ) {
		var min,
			o = instance.options,
			group = $.makeArray($(o.stack)).sort(function(a, b) {
				return (parseInt($(a).css("zIndex"), 10) || 0) - (parseInt($(b).css("zIndex"), 10) || 0);
			});

		if (!group.length) { return; }

		min = parseInt($(group[0]).css("zIndex"), 10) || 0;
		$(group).each(function(i) {
			$(this).css("zIndex", min + i);
		});
		this.css("zIndex", (min + group.length));
	}
});

$.ui.plugin.add("draggable", "zIndex", {
	start: function( event, ui, instance ) {
		var t = $( ui.helper ),
			o = instance.options;

		if (t.css("zIndex")) {
			o._zIndex = t.css("zIndex");
		}
		t.css("zIndex", o.zIndex);
	},
	stop: function( event, ui, instance ) {
		var o = instance.options;

		if (o._zIndex) {
			$(ui.helper).css("zIndex", o._zIndex);
		}
	}
});

var draggable = $.ui.draggable;


/*!
 * jQuery UI Resizable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/resizable/
 */


$.widget("ui.resizable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "resize",
	options: {
		alsoResize: false,
		animate: false,
		animateDuration: "slow",
		animateEasing: "swing",
		aspectRatio: false,
		autoHide: false,
		containment: false,
		ghost: false,
		grid: false,
		handles: "e,s,se",
		helper: false,
		maxHeight: null,
		maxWidth: null,
		minHeight: 10,
		minWidth: 10,
		// See #7960
		zIndex: 90,

		// callbacks
		resize: null,
		start: null,
		stop: null
	},

	_num: function( value ) {
		return parseInt( value, 10 ) || 0;
	},

	_isNumber: function( value ) {
		return !isNaN( parseInt( value, 10 ) );
	},

	_hasScroll: function( el, a ) {

		if ( $( el ).css( "overflow" ) === "hidden") {
			return false;
		}

		var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
			has = false;

		if ( el[ scroll ] > 0 ) {
			return true;
		}

		// TODO: determine which cases actually cause this to happen
		// if the element doesn't have the scroll set, see if it's possible to
		// set the scroll
		el[ scroll ] = 1;
		has = ( el[ scroll ] > 0 );
		el[ scroll ] = 0;
		return has;
	},

	_create: function() {

		var n, i, handle, axis, hname,
			that = this,
			o = this.options;
		this.element.addClass("ui-resizable");

		$.extend(this, {
			_aspectRatio: !!(o.aspectRatio),
			aspectRatio: o.aspectRatio,
			originalElement: this.element,
			_proportionallyResizeElements: [],
			_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
		});

		// Wrap the element if it cannot hold child nodes
		if (this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)) {

			this.element.wrap(
				$("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
					position: this.element.css("position"),
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					top: this.element.css("top"),
					left: this.element.css("left")
				})
			);

			this.element = this.element.parent().data(
				"ui-resizable", this.element.resizable( "instance" )
			);

			this.elementIsWrapper = true;

			this.element.css({
				marginLeft: this.originalElement.css("marginLeft"),
				marginTop: this.originalElement.css("marginTop"),
				marginRight: this.originalElement.css("marginRight"),
				marginBottom: this.originalElement.css("marginBottom")
			});
			this.originalElement.css({
				marginLeft: 0,
				marginTop: 0,
				marginRight: 0,
				marginBottom: 0
			});
			// support: Safari
			// Prevent Safari textarea resize
			this.originalResizeStyle = this.originalElement.css("resize");
			this.originalElement.css("resize", "none");

			this._proportionallyResizeElements.push( this.originalElement.css({
				position: "static",
				zoom: 1,
				display: "block"
			}) );

			// support: IE9
			// avoid IE jump (hard set the margin)
			this.originalElement.css({ margin: this.originalElement.css("margin") });

			this._proportionallyResize();
		}

		this.handles = o.handles ||
			( !$(".ui-resizable-handle", this.element).length ?
				"e,s,se" : {
					n: ".ui-resizable-n",
					e: ".ui-resizable-e",
					s: ".ui-resizable-s",
					w: ".ui-resizable-w",
					se: ".ui-resizable-se",
					sw: ".ui-resizable-sw",
					ne: ".ui-resizable-ne",
					nw: ".ui-resizable-nw"
				} );

		this._handles = $();
		if ( this.handles.constructor === String ) {

			if ( this.handles === "all") {
				this.handles = "n,e,s,w,se,sw,ne,nw";
			}

			n = this.handles.split(",");
			this.handles = {};

			for (i = 0; i < n.length; i++) {

				handle = $.trim(n[i]);
				hname = "ui-resizable-" + handle;
				axis = $("<div class='ui-resizable-handle " + hname + "'></div>");

				axis.css({ zIndex: o.zIndex });

				// TODO : What's going on here?
				if ("se" === handle) {
					axis.addClass("ui-icon ui-icon-gripsmall-diagonal-se");
				}

				this.handles[handle] = ".ui-resizable-" + handle;
				this.element.append(axis);
			}

		}

		this._renderAxis = function(target) {

			var i, axis, padPos, padWrapper;

			target = target || this.element;

			for (i in this.handles) {

				if (this.handles[i].constructor === String) {
					this.handles[i] = this.element.children( this.handles[ i ] ).first().show();
				} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
					this.handles[ i ] = $( this.handles[ i ] );
					this._on( this.handles[ i ], { "mousedown": that._mouseDown });
				}

				if (this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)) {

					axis = $(this.handles[i], this.element);

					padWrapper = /sw|ne|nw|se|n|s/.test(i) ? axis.outerHeight() : axis.outerWidth();

					padPos = [ "padding",
						/ne|nw|n/.test(i) ? "Top" :
						/se|sw|s/.test(i) ? "Bottom" :
						/^e$/.test(i) ? "Right" : "Left" ].join("");

					target.css(padPos, padWrapper);

					this._proportionallyResize();
				}

				this._handles = this._handles.add( this.handles[ i ] );
			}
		};

		// TODO: make renderAxis a prototype function
		this._renderAxis(this.element);

		this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
		this._handles.disableSelection();

		this._handles.mouseover(function() {
			if (!that.resizing) {
				if (this.className) {
					axis = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i);
				}
				that.axis = axis && axis[1] ? axis[1] : "se";
			}
		});

		if (o.autoHide) {
			this._handles.hide();
			$(this.element)
				.addClass("ui-resizable-autohide")
				.mouseenter(function() {
					if (o.disabled) {
						return;
					}
					$(this).removeClass("ui-resizable-autohide");
					that._handles.show();
				})
				.mouseleave(function() {
					if (o.disabled) {
						return;
					}
					if (!that.resizing) {
						$(this).addClass("ui-resizable-autohide");
						that._handles.hide();
					}
				});
		}

		this._mouseInit();
	},

	_destroy: function() {

		this._mouseDestroy();

		var wrapper,
			_destroy = function(exp) {
				$(exp)
					.removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing")
					.removeData("resizable")
					.removeData("ui-resizable")
					.unbind(".resizable")
					.find(".ui-resizable-handle")
						.remove();
			};

		// TODO: Unwrap at same DOM position
		if (this.elementIsWrapper) {
			_destroy(this.element);
			wrapper = this.element;
			this.originalElement.css({
				position: wrapper.css("position"),
				width: wrapper.outerWidth(),
				height: wrapper.outerHeight(),
				top: wrapper.css("top"),
				left: wrapper.css("left")
			}).insertAfter( wrapper );
			wrapper.remove();
		}

		this.originalElement.css("resize", this.originalResizeStyle);
		_destroy(this.originalElement);

		return this;
	},

	_mouseCapture: function(event) {
		var i, handle,
			capture = false;

		for (i in this.handles) {
			handle = $(this.handles[i])[0];
			if (handle === event.target || $.contains(handle, event.target)) {
				capture = true;
			}
		}

		return !this.options.disabled && capture;
	},

	_mouseStart: function(event) {

		var curleft, curtop, cursor,
			o = this.options,
			el = this.element;

		this.resizing = true;

		this._renderProxy();

		curleft = this._num(this.helper.css("left"));
		curtop = this._num(this.helper.css("top"));

		if (o.containment) {
			curleft += $(o.containment).scrollLeft() || 0;
			curtop += $(o.containment).scrollTop() || 0;
		}

		this.offset = this.helper.offset();
		this.position = { left: curleft, top: curtop };

		this.size = this._helper ? {
				width: this.helper.width(),
				height: this.helper.height()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.originalSize = this._helper ? {
				width: el.outerWidth(),
				height: el.outerHeight()
			} : {
				width: el.width(),
				height: el.height()
			};

		this.sizeDiff = {
			width: el.outerWidth() - el.width(),
			height: el.outerHeight() - el.height()
		};

		this.originalPosition = { left: curleft, top: curtop };
		this.originalMousePosition = { left: event.pageX, top: event.pageY };

		this.aspectRatio = (typeof o.aspectRatio === "number") ?
			o.aspectRatio :
			((this.originalSize.width / this.originalSize.height) || 1);

		cursor = $(".ui-resizable-" + this.axis).css("cursor");
		$("body").css("cursor", cursor === "auto" ? this.axis + "-resize" : cursor);

		el.addClass("ui-resizable-resizing");
		this._propagate("start", event);
		return true;
	},

	_mouseDrag: function(event) {

		var data, props,
			smp = this.originalMousePosition,
			a = this.axis,
			dx = (event.pageX - smp.left) || 0,
			dy = (event.pageY - smp.top) || 0,
			trigger = this._change[a];

		this._updatePrevProperties();

		if (!trigger) {
			return false;
		}

		data = trigger.apply(this, [ event, dx, dy ]);

		this._updateVirtualBoundaries(event.shiftKey);
		if (this._aspectRatio || event.shiftKey) {
			data = this._updateRatio(data, event);
		}

		data = this._respectSize(data, event);

		this._updateCache(data);

		this._propagate("resize", event);

		props = this._applyChanges();

		if ( !this._helper && this._proportionallyResizeElements.length ) {
			this._proportionallyResize();
		}

		if ( !$.isEmptyObject( props ) ) {
			this._updatePrevProperties();
			this._trigger( "resize", event, this.ui() );
			this._applyChanges();
		}

		return false;
	},

	_mouseStop: function(event) {

		this.resizing = false;
		var pr, ista, soffseth, soffsetw, s, left, top,
			o = this.options, that = this;

		if (this._helper) {

			pr = this._proportionallyResizeElements;
			ista = pr.length && (/textarea/i).test(pr[0].nodeName);
			soffseth = ista && this._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height;
			soffsetw = ista ? 0 : that.sizeDiff.width;

			s = {
				width: (that.helper.width()  - soffsetw),
				height: (that.helper.height() - soffseth)
			};
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null;
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

			if (!o.animate) {
				this.element.css($.extend(s, { top: top, left: left }));
			}

			that.helper.height(that.size.height);
			that.helper.width(that.size.width);

			if (this._helper && !o.animate) {
				this._proportionallyResize();
			}
		}

		$("body").css("cursor", "auto");

		this.element.removeClass("ui-resizable-resizing");

		this._propagate("stop", event);

		if (this._helper) {
			this.helper.remove();
		}

		return false;

	},

	_updatePrevProperties: function() {
		this.prevPosition = {
			top: this.position.top,
			left: this.position.left
		};
		this.prevSize = {
			width: this.size.width,
			height: this.size.height
		};
	},

	_applyChanges: function() {
		var props = {};

		if ( this.position.top !== this.prevPosition.top ) {
			props.top = this.position.top + "px";
		}
		if ( this.position.left !== this.prevPosition.left ) {
			props.left = this.position.left + "px";
		}
		if ( this.size.width !== this.prevSize.width ) {
			props.width = this.size.width + "px";
		}
		if ( this.size.height !== this.prevSize.height ) {
			props.height = this.size.height + "px";
		}

		this.helper.css( props );

		return props;
	},

	_updateVirtualBoundaries: function(forceAspectRatio) {
		var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
			o = this.options;

		b = {
			minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
			maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : Infinity,
			minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
			maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : Infinity
		};

		if (this._aspectRatio || forceAspectRatio) {
			pMinWidth = b.minHeight * this.aspectRatio;
			pMinHeight = b.minWidth / this.aspectRatio;
			pMaxWidth = b.maxHeight * this.aspectRatio;
			pMaxHeight = b.maxWidth / this.aspectRatio;

			if (pMinWidth > b.minWidth) {
				b.minWidth = pMinWidth;
			}
			if (pMinHeight > b.minHeight) {
				b.minHeight = pMinHeight;
			}
			if (pMaxWidth < b.maxWidth) {
				b.maxWidth = pMaxWidth;
			}
			if (pMaxHeight < b.maxHeight) {
				b.maxHeight = pMaxHeight;
			}
		}
		this._vBoundaries = b;
	},

	_updateCache: function(data) {
		this.offset = this.helper.offset();
		if (this._isNumber(data.left)) {
			this.position.left = data.left;
		}
		if (this._isNumber(data.top)) {
			this.position.top = data.top;
		}
		if (this._isNumber(data.height)) {
			this.size.height = data.height;
		}
		if (this._isNumber(data.width)) {
			this.size.width = data.width;
		}
	},

	_updateRatio: function( data ) {

		var cpos = this.position,
			csize = this.size,
			a = this.axis;

		if (this._isNumber(data.height)) {
			data.width = (data.height * this.aspectRatio);
		} else if (this._isNumber(data.width)) {
			data.height = (data.width / this.aspectRatio);
		}

		if (a === "sw") {
			data.left = cpos.left + (csize.width - data.width);
			data.top = null;
		}
		if (a === "nw") {
			data.top = cpos.top + (csize.height - data.height);
			data.left = cpos.left + (csize.width - data.width);
		}

		return data;
	},

	_respectSize: function( data ) {

		var o = this._vBoundaries,
			a = this.axis,
			ismaxw = this._isNumber(data.width) && o.maxWidth && (o.maxWidth < data.width),
			ismaxh = this._isNumber(data.height) && o.maxHeight && (o.maxHeight < data.height),
			isminw = this._isNumber(data.width) && o.minWidth && (o.minWidth > data.width),
			isminh = this._isNumber(data.height) && o.minHeight && (o.minHeight > data.height),
			dw = this.originalPosition.left + this.originalSize.width,
			dh = this.position.top + this.size.height,
			cw = /sw|nw|w/.test(a), ch = /nw|ne|n/.test(a);
		if (isminw) {
			data.width = o.minWidth;
		}
		if (isminh) {
			data.height = o.minHeight;
		}
		if (ismaxw) {
			data.width = o.maxWidth;
		}
		if (ismaxh) {
			data.height = o.maxHeight;
		}

		if (isminw && cw) {
			data.left = dw - o.minWidth;
		}
		if (ismaxw && cw) {
			data.left = dw - o.maxWidth;
		}
		if (isminh && ch) {
			data.top = dh - o.minHeight;
		}
		if (ismaxh && ch) {
			data.top = dh - o.maxHeight;
		}

		// Fixing jump error on top/left - bug #2330
		if (!data.width && !data.height && !data.left && data.top) {
			data.top = null;
		} else if (!data.width && !data.height && !data.top && data.left) {
			data.left = null;
		}

		return data;
	},

	_getPaddingPlusBorderDimensions: function( element ) {
		var i = 0,
			widths = [],
			borders = [
				element.css( "borderTopWidth" ),
				element.css( "borderRightWidth" ),
				element.css( "borderBottomWidth" ),
				element.css( "borderLeftWidth" )
			],
			paddings = [
				element.css( "paddingTop" ),
				element.css( "paddingRight" ),
				element.css( "paddingBottom" ),
				element.css( "paddingLeft" )
			];

		for ( ; i < 4; i++ ) {
			widths[ i ] = ( parseInt( borders[ i ], 10 ) || 0 );
			widths[ i ] += ( parseInt( paddings[ i ], 10 ) || 0 );
		}

		return {
			height: widths[ 0 ] + widths[ 2 ],
			width: widths[ 1 ] + widths[ 3 ]
		};
	},

	_proportionallyResize: function() {

		if (!this._proportionallyResizeElements.length) {
			return;
		}

		var prel,
			i = 0,
			element = this.helper || this.element;

		for ( ; i < this._proportionallyResizeElements.length; i++) {

			prel = this._proportionallyResizeElements[i];

			// TODO: Seems like a bug to cache this.outerDimensions
			// considering that we are in a loop.
			if (!this.outerDimensions) {
				this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
			}

			prel.css({
				height: (element.height() - this.outerDimensions.height) || 0,
				width: (element.width() - this.outerDimensions.width) || 0
			});

		}

	},

	_renderProxy: function() {

		var el = this.element, o = this.options;
		this.elementOffset = el.offset();

		if (this._helper) {

			this.helper = this.helper || $("<div style='overflow:hidden;'></div>");

			this.helper.addClass(this._helper).css({
				width: this.element.outerWidth() - 1,
				height: this.element.outerHeight() - 1,
				position: "absolute",
				left: this.elementOffset.left + "px",
				top: this.elementOffset.top + "px",
				zIndex: ++o.zIndex //TODO: Don't modify option
			});

			this.helper
				.appendTo("body")
				.disableSelection();

		} else {
			this.helper = this.element;
		}

	},

	_change: {
		e: function(event, dx) {
			return { width: this.originalSize.width + dx };
		},
		w: function(event, dx) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { left: sp.left + dx, width: cs.width - dx };
		},
		n: function(event, dx, dy) {
			var cs = this.originalSize, sp = this.originalPosition;
			return { top: sp.top + dy, height: cs.height - dy };
		},
		s: function(event, dx, dy) {
			return { height: this.originalSize.height + dy };
		},
		se: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		sw: function(event, dx, dy) {
			return $.extend(this._change.s.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		},
		ne: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.e.apply(this, [ event, dx, dy ]));
		},
		nw: function(event, dx, dy) {
			return $.extend(this._change.n.apply(this, arguments),
				this._change.w.apply(this, [ event, dx, dy ]));
		}
	},

	_propagate: function(n, event) {
		$.ui.plugin.call(this, n, [ event, this.ui() ]);
		(n !== "resize" && this._trigger(n, event, this.ui()));
	},

	plugins: {},

	ui: function() {
		return {
			originalElement: this.originalElement,
			element: this.element,
			helper: this.helper,
			position: this.position,
			size: this.size,
			originalSize: this.originalSize,
			originalPosition: this.originalPosition
		};
	}

});

/*
 * Resizable Extensions
 */

$.ui.plugin.add("resizable", "animate", {

	stop: function( event ) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			pr = that._proportionallyResizeElements,
			ista = pr.length && (/textarea/i).test(pr[0].nodeName),
			soffseth = ista && that._hasScroll(pr[0], "left") ? 0 : that.sizeDiff.height,
			soffsetw = ista ? 0 : that.sizeDiff.width,
			style = { width: (that.size.width - soffsetw), height: (that.size.height - soffseth) },
			left = (parseInt(that.element.css("left"), 10) +
				(that.position.left - that.originalPosition.left)) || null,
			top = (parseInt(that.element.css("top"), 10) +
				(that.position.top - that.originalPosition.top)) || null;

		that.element.animate(
			$.extend(style, top && left ? { top: top, left: left } : {}), {
				duration: o.animateDuration,
				easing: o.animateEasing,
				step: function() {

					var data = {
						width: parseInt(that.element.css("width"), 10),
						height: parseInt(that.element.css("height"), 10),
						top: parseInt(that.element.css("top"), 10),
						left: parseInt(that.element.css("left"), 10)
					};

					if (pr && pr.length) {
						$(pr[0]).css({ width: data.width, height: data.height });
					}

					// propagating resize, and updating values for each animation step
					that._updateCache(data);
					that._propagate("resize", event);

				}
			}
		);
	}

});

$.ui.plugin.add( "resizable", "containment", {

	start: function() {
		var element, p, co, ch, cw, width, height,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			el = that.element,
			oc = o.containment,
			ce = ( oc instanceof $ ) ? oc.get( 0 ) : ( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;

		if ( !ce ) {
			return;
		}

		that.containerElement = $( ce );

		if ( /document/.test( oc ) || oc === document ) {
			that.containerOffset = {
				left: 0,
				top: 0
			};
			that.containerPosition = {
				left: 0,
				top: 0
			};

			that.parentData = {
				element: $( document ),
				left: 0,
				top: 0,
				width: $( document ).width(),
				height: $( document ).height() || document.body.parentNode.scrollHeight
			};
		} else {
			element = $( ce );
			p = [];
			$([ "Top", "Right", "Left", "Bottom" ]).each(function( i, name ) {
				p[ i ] = that._num( element.css( "padding" + name ) );
			});

			that.containerOffset = element.offset();
			that.containerPosition = element.position();
			that.containerSize = {
				height: ( element.innerHeight() - p[ 3 ] ),
				width: ( element.innerWidth() - p[ 1 ] )
			};

			co = that.containerOffset;
			ch = that.containerSize.height;
			cw = that.containerSize.width;
			width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
			height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;

			that.parentData = {
				element: ce,
				left: co.left,
				top: co.top,
				width: width,
				height: height
			};
		}
	},

	resize: function( event ) {
		var woset, hoset, isParent, isOffsetRelative,
			that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cp = that.position,
			pRatio = that._aspectRatio || event.shiftKey,
			cop = {
				top: 0,
				left: 0
			},
			ce = that.containerElement,
			continueResize = true;

		if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
			cop = co;
		}

		if ( cp.left < ( that._helper ? co.left : 0 ) ) {
			that.size.width = that.size.width +
				( that._helper ?
					( that.position.left - co.left ) :
					( that.position.left - cop.left ) );

			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
			that.position.left = o.helper ? co.left : 0;
		}

		if ( cp.top < ( that._helper ? co.top : 0 ) ) {
			that.size.height = that.size.height +
				( that._helper ?
					( that.position.top - co.top ) :
					that.position.top );

			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
			that.position.top = that._helper ? co.top : 0;
		}

		isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
		isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );

		if ( isParent && isOffsetRelative ) {
			that.offset.left = that.parentData.left + that.position.left;
			that.offset.top = that.parentData.top + that.position.top;
		} else {
			that.offset.left = that.element.offset().left;
			that.offset.top = that.element.offset().top;
		}

		woset = Math.abs( that.sizeDiff.width +
			(that._helper ?
				that.offset.left - cop.left :
				(that.offset.left - co.left)) );

		hoset = Math.abs( that.sizeDiff.height +
			(that._helper ?
				that.offset.top - cop.top :
				(that.offset.top - co.top)) );

		if ( woset + that.size.width >= that.parentData.width ) {
			that.size.width = that.parentData.width - woset;
			if ( pRatio ) {
				that.size.height = that.size.width / that.aspectRatio;
				continueResize = false;
			}
		}

		if ( hoset + that.size.height >= that.parentData.height ) {
			that.size.height = that.parentData.height - hoset;
			if ( pRatio ) {
				that.size.width = that.size.height * that.aspectRatio;
				continueResize = false;
			}
		}

		if ( !continueResize ) {
			that.position.left = that.prevPosition.left;
			that.position.top = that.prevPosition.top;
			that.size.width = that.prevSize.width;
			that.size.height = that.prevSize.height;
		}
	},

	stop: function() {
		var that = $( this ).resizable( "instance" ),
			o = that.options,
			co = that.containerOffset,
			cop = that.containerPosition,
			ce = that.containerElement,
			helper = $( that.helper ),
			ho = helper.offset(),
			w = helper.outerWidth() - that.sizeDiff.width,
			h = helper.outerHeight() - that.sizeDiff.height;

		if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}

		if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
			$( this ).css({
				left: ho.left - cop.left - co.left,
				width: w,
				height: h
			});
		}
	}
});

$.ui.plugin.add("resizable", "alsoResize", {

	start: function() {
		var that = $(this).resizable( "instance" ),
			o = that.options;

		$(o.alsoResize).each(function() {
			var el = $(this);
			el.data("ui-resizable-alsoresize", {
				width: parseInt(el.width(), 10), height: parseInt(el.height(), 10),
				left: parseInt(el.css("left"), 10), top: parseInt(el.css("top"), 10)
			});
		});
	},

	resize: function(event, ui) {
		var that = $(this).resizable( "instance" ),
			o = that.options,
			os = that.originalSize,
			op = that.originalPosition,
			delta = {
				height: (that.size.height - os.height) || 0,
				width: (that.size.width - os.width) || 0,
				top: (that.position.top - op.top) || 0,
				left: (that.position.left - op.left) || 0
			};

			$(o.alsoResize).each(function() {
				var el = $(this), start = $(this).data("ui-resizable-alsoresize"), style = {},
					css = el.parents(ui.originalElement[0]).length ?
							[ "width", "height" ] :
							[ "width", "height", "top", "left" ];

				$.each(css, function(i, prop) {
					var sum = (start[prop] || 0) + (delta[prop] || 0);
					if (sum && sum >= 0) {
						style[prop] = sum || null;
					}
				});

				el.css(style);
			});
	},

	stop: function() {
		$(this).removeData("resizable-alsoresize");
	}
});

$.ui.plugin.add("resizable", "ghost", {

	start: function() {

		var that = $(this).resizable( "instance" ), o = that.options, cs = that.size;

		that.ghost = that.originalElement.clone();
		that.ghost
			.css({
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			})
			.addClass("ui-resizable-ghost")
			.addClass(typeof o.ghost === "string" ? o.ghost : "");

		that.ghost.appendTo(that.helper);

	},

	resize: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost) {
			that.ghost.css({
				position: "relative",
				height: that.size.height,
				width: that.size.width
			});
		}
	},

	stop: function() {
		var that = $(this).resizable( "instance" );
		if (that.ghost && that.helper) {
			that.helper.get(0).removeChild(that.ghost.get(0));
		}
	}

});

$.ui.plugin.add("resizable", "grid", {

	resize: function() {
		var outerDimensions,
			that = $(this).resizable( "instance" ),
			o = that.options,
			cs = that.size,
			os = that.originalSize,
			op = that.originalPosition,
			a = that.axis,
			grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
			gridX = (grid[0] || 1),
			gridY = (grid[1] || 1),
			ox = Math.round((cs.width - os.width) / gridX) * gridX,
			oy = Math.round((cs.height - os.height) / gridY) * gridY,
			newWidth = os.width + ox,
			newHeight = os.height + oy,
			isMaxWidth = o.maxWidth && (o.maxWidth < newWidth),
			isMaxHeight = o.maxHeight && (o.maxHeight < newHeight),
			isMinWidth = o.minWidth && (o.minWidth > newWidth),
			isMinHeight = o.minHeight && (o.minHeight > newHeight);

		o.grid = grid;

		if (isMinWidth) {
			newWidth += gridX;
		}
		if (isMinHeight) {
			newHeight += gridY;
		}
		if (isMaxWidth) {
			newWidth -= gridX;
		}
		if (isMaxHeight) {
			newHeight -= gridY;
		}

		if (/^(se|s|e)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
		} else if (/^(ne)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.top = op.top - oy;
		} else if (/^(sw)$/.test(a)) {
			that.size.width = newWidth;
			that.size.height = newHeight;
			that.position.left = op.left - ox;
		} else {
			if ( newHeight - gridY <= 0 || newWidth - gridX <= 0) {
				outerDimensions = that._getPaddingPlusBorderDimensions( this );
			}

			if ( newHeight - gridY > 0 ) {
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else {
				newHeight = gridY - outerDimensions.height;
				that.size.height = newHeight;
				that.position.top = op.top + os.height - newHeight;
			}
			if ( newWidth - gridX > 0 ) {
				that.size.width = newWidth;
				that.position.left = op.left - ox;
			} else {
				newWidth = gridX - outerDimensions.width;
				that.size.width = newWidth;
				that.position.left = op.left + os.width - newWidth;
			}
		}
	}

});

var resizable = $.ui.resizable;


/*!
 * jQuery UI Dialog 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/dialog/
 */


var dialog = $.widget( "ui.dialog", {
	version: "1.11.4",
	options: {
		appendTo: "body",
		autoOpen: true,
		buttons: [],
		closeOnEscape: true,
		closeText: "Close",
		dialogClass: "",
		draggable: true,
		hide: null,
		height: "auto",
		maxHeight: null,
		maxWidth: null,
		minHeight: 150,
		minWidth: 150,
		modal: false,
		position: {
			my: "center",
			at: "center",
			of: window,
			collision: "fit",
			// Ensure the titlebar is always visible
			using: function( pos ) {
				var topOffset = $( this ).css( pos ).offset().top;
				if ( topOffset < 0 ) {
					$( this ).css( "top", pos.top - topOffset );
				}
			}
		},
		resizable: true,
		show: null,
		title: null,
		width: 300,

		// callbacks
		beforeClose: null,
		close: null,
		drag: null,
		dragStart: null,
		dragStop: null,
		focus: null,
		open: null,
		resize: null,
		resizeStart: null,
		resizeStop: null
	},

	sizeRelatedOptions: {
		buttons: true,
		height: true,
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true,
		width: true
	},

	resizableRelatedOptions: {
		maxHeight: true,
		maxWidth: true,
		minHeight: true,
		minWidth: true
	},

	_create: function() {
		this.originalCss = {
			display: this.element[ 0 ].style.display,
			width: this.element[ 0 ].style.width,
			minHeight: this.element[ 0 ].style.minHeight,
			maxHeight: this.element[ 0 ].style.maxHeight,
			height: this.element[ 0 ].style.height
		};
		this.originalPosition = {
			parent: this.element.parent(),
			index: this.element.parent().children().index( this.element )
		};
		this.originalTitle = this.element.attr( "title" );
		this.options.title = this.options.title || this.originalTitle;

		this._createWrapper();

		this.element
			.show()
			.removeAttr( "title" )
			.addClass( "ui-dialog-content ui-widget-content" )
			.appendTo( this.uiDialog );

		this._createTitlebar();
		this._createButtonPane();

		if ( this.options.draggable && $.fn.draggable ) {
			this._makeDraggable();
		}
		if ( this.options.resizable && $.fn.resizable ) {
			this._makeResizable();
		}

		this._isOpen = false;

		this._trackFocus();
	},

	_init: function() {
		if ( this.options.autoOpen ) {
			this.open();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;
		if ( element && (element.jquery || element.nodeType) ) {
			return $( element );
		}
		return this.document.find( element || "body" ).eq( 0 );
	},

	_destroy: function() {
		var next,
			originalPosition = this.originalPosition;

		this._untrackInstance();
		this._destroyOverlay();

		this.element
			.removeUniqueId()
			.removeClass( "ui-dialog-content ui-widget-content" )
			.css( this.originalCss )
			// Without detaching first, the following becomes really slow
			.detach();

		this.uiDialog.stop( true, true ).remove();

		if ( this.originalTitle ) {
			this.element.attr( "title", this.originalTitle );
		}

		next = originalPosition.parent.children().eq( originalPosition.index );
		// Don't try to place the dialog next to itself (#8613)
		if ( next.length && next[ 0 ] !== this.element[ 0 ] ) {
			next.before( this.element );
		} else {
			originalPosition.parent.append( this.element );
		}
	},

	widget: function() {
		return this.uiDialog;
	},

	disable: $.noop,
	enable: $.noop,

	close: function( event ) {
		var activeElement,
			that = this;

		if ( !this._isOpen || this._trigger( "beforeClose", event ) === false ) {
			return;
		}

		this._isOpen = false;
		this._focusedElement = null;
		this._destroyOverlay();
		this._untrackInstance();

		if ( !this.opener.filter( ":focusable" ).focus().length ) {

			// support: IE9
			// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
			try {
				activeElement = this.document[ 0 ].activeElement;

				// Support: IE9, IE10
				// If the <body> is blurred, IE will switch windows, see #4520
				if ( activeElement && activeElement.nodeName.toLowerCase() !== "body" ) {

					// Hiding a focused element doesn't trigger blur in WebKit
					// so in case we have nothing to focus on, explicitly blur the active element
					// https://bugs.webkit.org/show_bug.cgi?id=47182
					$( activeElement ).blur();
				}
			} catch ( error ) {}
		}

		this._hide( this.uiDialog, this.options.hide, function() {
			that._trigger( "close", event );
		});
	},

	isOpen: function() {
		return this._isOpen;
	},

	moveToTop: function() {
		this._moveToTop();
	},

	_moveToTop: function( event, silent ) {
		var moved = false,
			zIndices = this.uiDialog.siblings( ".ui-front:visible" ).map(function() {
				return +$( this ).css( "z-index" );
			}).get(),
			zIndexMax = Math.max.apply( null, zIndices );

		if ( zIndexMax >= +this.uiDialog.css( "z-index" ) ) {
			this.uiDialog.css( "z-index", zIndexMax + 1 );
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}
		return moved;
	},

	open: function() {
		var that = this;
		if ( this._isOpen ) {
			if ( this._moveToTop() ) {
				this._focusTabbable();
			}
			return;
		}

		this._isOpen = true;
		this.opener = $( this.document[ 0 ].activeElement );

		this._size();
		this._position();
		this._createOverlay();
		this._moveToTop( null, true );

		// Ensure the overlay is moved to the top with the dialog, but only when
		// opening. The overlay shouldn't move after the dialog is open so that
		// modeless dialogs opened after the modal dialog stack properly.
		if ( this.overlay ) {
			this.overlay.css( "z-index", this.uiDialog.css( "z-index" ) - 1 );
		}

		this._show( this.uiDialog, this.options.show, function() {
			that._focusTabbable();
			that._trigger( "focus" );
		});

		// Track the dialog immediately upon openening in case a focus event
		// somehow occurs outside of the dialog before an element inside the
		// dialog is focused (#10152)
		this._makeFocusTarget();

		this._trigger( "open" );
	},

	_focusTabbable: function() {
		// Set focus to the first match:
		// 1. An element that was focused previously
		// 2. First element inside the dialog matching [autofocus]
		// 3. Tabbable element inside the content element
		// 4. Tabbable element inside the buttonpane
		// 5. The close button
		// 6. The dialog itself
		var hasFocus = this._focusedElement;
		if ( !hasFocus ) {
			hasFocus = this.element.find( "[autofocus]" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.element.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogButtonPane.find( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialogTitlebarClose.filter( ":tabbable" );
		}
		if ( !hasFocus.length ) {
			hasFocus = this.uiDialog;
		}
		hasFocus.eq( 0 ).focus();
	},

	_keepFocus: function( event ) {
		function checkFocus() {
			var activeElement = this.document[0].activeElement,
				isActive = this.uiDialog[0] === activeElement ||
					$.contains( this.uiDialog[0], activeElement );
			if ( !isActive ) {
				this._focusTabbable();
			}
		}
		event.preventDefault();
		checkFocus.call( this );
		// support: IE
		// IE <= 8 doesn't prevent moving focus even with event.preventDefault()
		// so we check again later
		this._delay( checkFocus );
	},

	_createWrapper: function() {
		this.uiDialog = $("<div>")
			.addClass( "ui-dialog ui-widget ui-widget-content ui-corner-all ui-front " +
				this.options.dialogClass )
			.hide()
			.attr({
				// Setting tabIndex makes the div focusable
				tabIndex: -1,
				role: "dialog"
			})
			.appendTo( this._appendTo() );

		this._on( this.uiDialog, {
			keydown: function( event ) {
				if ( this.options.closeOnEscape && !event.isDefaultPrevented() && event.keyCode &&
						event.keyCode === $.ui.keyCode.ESCAPE ) {
					event.preventDefault();
					this.close( event );
					return;
				}

				// prevent tabbing out of dialogs
				if ( event.keyCode !== $.ui.keyCode.TAB || event.isDefaultPrevented() ) {
					return;
				}
				var tabbables = this.uiDialog.find( ":tabbable" ),
					first = tabbables.filter( ":first" ),
					last = tabbables.filter( ":last" );

				if ( ( event.target === last[0] || event.target === this.uiDialog[0] ) && !event.shiftKey ) {
					this._delay(function() {
						first.focus();
					});
					event.preventDefault();
				} else if ( ( event.target === first[0] || event.target === this.uiDialog[0] ) && event.shiftKey ) {
					this._delay(function() {
						last.focus();
					});
					event.preventDefault();
				}
			},
			mousedown: function( event ) {
				if ( this._moveToTop( event ) ) {
					this._focusTabbable();
				}
			}
		});

		// We assume that any existing aria-describedby attribute means
		// that the dialog content is marked up properly
		// otherwise we brute force the content as the description
		if ( !this.element.find( "[aria-describedby]" ).length ) {
			this.uiDialog.attr({
				"aria-describedby": this.element.uniqueId().attr( "id" )
			});
		}
	},

	_createTitlebar: function() {
		var uiDialogTitle;

		this.uiDialogTitlebar = $( "<div>" )
			.addClass( "ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix" )
			.prependTo( this.uiDialog );
		this._on( this.uiDialogTitlebar, {
			mousedown: function( event ) {
				// Don't prevent click on close button (#8838)
				// Focusing a dialog that is partially scrolled out of view
				// causes the browser to scroll it into view, preventing the click event
				if ( !$( event.target ).closest( ".ui-dialog-titlebar-close" ) ) {
					// Dialog isn't getting focus when dragging (#8063)
					this.uiDialog.focus();
				}
			}
		});

		// support: IE
		// Use type="button" to prevent enter keypresses in textboxes from closing the
		// dialog in IE (#9312)
		this.uiDialogTitlebarClose = $( "<button type='button'></button>" )
			.button({
				label: this.options.closeText,
				icons: {
					primary: "ui-icon-closethick"
				},
				text: false
			})
			.addClass( "ui-dialog-titlebar-close" )
			.appendTo( this.uiDialogTitlebar );
		this._on( this.uiDialogTitlebarClose, {
			click: function( event ) {
				event.preventDefault();
				this.close( event );
			}
		});

		uiDialogTitle = $( "<span>" )
			.uniqueId()
			.addClass( "ui-dialog-title" )
			.prependTo( this.uiDialogTitlebar );
		this._title( uiDialogTitle );

		this.uiDialog.attr({
			"aria-labelledby": uiDialogTitle.attr( "id" )
		});
	},

	_title: function( title ) {
		if ( !this.options.title ) {
			title.html( "&#160;" );
		}
		title.text( this.options.title );
	},

	_createButtonPane: function() {
		this.uiDialogButtonPane = $( "<div>" )
			.addClass( "ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" );

		this.uiButtonSet = $( "<div>" )
			.addClass( "ui-dialog-buttonset" )
			.appendTo( this.uiDialogButtonPane );

		this._createButtons();
	},

	_createButtons: function() {
		var that = this,
			buttons = this.options.buttons;

		// if we already have a button pane, remove it
		this.uiDialogButtonPane.remove();
		this.uiButtonSet.empty();

		if ( $.isEmptyObject( buttons ) || ($.isArray( buttons ) && !buttons.length) ) {
			this.uiDialog.removeClass( "ui-dialog-buttons" );
			return;
		}

		$.each( buttons, function( name, props ) {
			var click, buttonOptions;
			props = $.isFunction( props ) ?
				{ click: props, text: name } :
				props;
			// Default to a non-submitting button
			props = $.extend( { type: "button" }, props );
			// Change the context for the click callback to be the main element
			click = props.click;
			props.click = function() {
				click.apply( that.element[ 0 ], arguments );
			};
			buttonOptions = {
				icons: props.icons,
				text: props.showText
			};
			delete props.icons;
			delete props.showText;
			$( "<button></button>", props )
				.button( buttonOptions )
				.appendTo( that.uiButtonSet );
		});
		this.uiDialog.addClass( "ui-dialog-buttons" );
		this.uiDialogButtonPane.appendTo( this.uiDialog );
	},

	_makeDraggable: function() {
		var that = this,
			options = this.options;

		function filteredUi( ui ) {
			return {
				position: ui.position,
				offset: ui.offset
			};
		}

		this.uiDialog.draggable({
			cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
			handle: ".ui-dialog-titlebar",
			containment: "document",
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-dragging" );
				that._blockFrames();
				that._trigger( "dragStart", event, filteredUi( ui ) );
			},
			drag: function( event, ui ) {
				that._trigger( "drag", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var left = ui.offset.left - that.document.scrollLeft(),
					top = ui.offset.top - that.document.scrollTop();

				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-dragging" );
				that._unblockFrames();
				that._trigger( "dragStop", event, filteredUi( ui ) );
			}
		});
	},

	_makeResizable: function() {
		var that = this,
			options = this.options,
			handles = options.resizable,
			// .ui-resizable has position: relative defined in the stylesheet
			// but dialogs have to use absolute or fixed positioning
			position = this.uiDialog.css("position"),
			resizeHandles = typeof handles === "string" ?
				handles	:
				"n,e,s,w,se,sw,ne,nw";

		function filteredUi( ui ) {
			return {
				originalPosition: ui.originalPosition,
				originalSize: ui.originalSize,
				position: ui.position,
				size: ui.size
			};
		}

		this.uiDialog.resizable({
			cancel: ".ui-dialog-content",
			containment: "document",
			alsoResize: this.element,
			maxWidth: options.maxWidth,
			maxHeight: options.maxHeight,
			minWidth: options.minWidth,
			minHeight: this._minHeight(),
			handles: resizeHandles,
			start: function( event, ui ) {
				$( this ).addClass( "ui-dialog-resizing" );
				that._blockFrames();
				that._trigger( "resizeStart", event, filteredUi( ui ) );
			},
			resize: function( event, ui ) {
				that._trigger( "resize", event, filteredUi( ui ) );
			},
			stop: function( event, ui ) {
				var offset = that.uiDialog.offset(),
					left = offset.left - that.document.scrollLeft(),
					top = offset.top - that.document.scrollTop();

				options.height = that.uiDialog.height();
				options.width = that.uiDialog.width();
				options.position = {
					my: "left top",
					at: "left" + (left >= 0 ? "+" : "") + left + " " +
						"top" + (top >= 0 ? "+" : "") + top,
					of: that.window
				};
				$( this ).removeClass( "ui-dialog-resizing" );
				that._unblockFrames();
				that._trigger( "resizeStop", event, filteredUi( ui ) );
			}
		})
		.css( "position", position );
	},

	_trackFocus: function() {
		this._on( this.widget(), {
			focusin: function( event ) {
				this._makeFocusTarget();
				this._focusedElement = $( event.target );
			}
		});
	},

	_makeFocusTarget: function() {
		this._untrackInstance();
		this._trackingInstances().unshift( this );
	},

	_untrackInstance: function() {
		var instances = this._trackingInstances(),
			exists = $.inArray( this, instances );
		if ( exists !== -1 ) {
			instances.splice( exists, 1 );
		}
	},

	_trackingInstances: function() {
		var instances = this.document.data( "ui-dialog-instances" );
		if ( !instances ) {
			instances = [];
			this.document.data( "ui-dialog-instances", instances );
		}
		return instances;
	},

	_minHeight: function() {
		var options = this.options;

		return options.height === "auto" ?
			options.minHeight :
			Math.min( options.minHeight, options.height );
	},

	_position: function() {
		// Need to show the dialog to get the actual offset in the position plugin
		var isVisible = this.uiDialog.is( ":visible" );
		if ( !isVisible ) {
			this.uiDialog.show();
		}
		this.uiDialog.position( this.options.position );
		if ( !isVisible ) {
			this.uiDialog.hide();
		}
	},

	_setOptions: function( options ) {
		var that = this,
			resize = false,
			resizableOptions = {};

		$.each( options, function( key, value ) {
			that._setOption( key, value );

			if ( key in that.sizeRelatedOptions ) {
				resize = true;
			}
			if ( key in that.resizableRelatedOptions ) {
				resizableOptions[ key ] = value;
			}
		});

		if ( resize ) {
			this._size();
			this._position();
		}
		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", resizableOptions );
		}
	},

	_setOption: function( key, value ) {
		var isDraggable, isResizable,
			uiDialog = this.uiDialog;

		if ( key === "dialogClass" ) {
			uiDialog
				.removeClass( this.options.dialogClass )
				.addClass( value );
		}

		if ( key === "disabled" ) {
			return;
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.uiDialog.appendTo( this._appendTo() );
		}

		if ( key === "buttons" ) {
			this._createButtons();
		}

		if ( key === "closeText" ) {
			this.uiDialogTitlebarClose.button({
				// Ensure that we always pass a string
				label: "" + value
			});
		}

		if ( key === "draggable" ) {
			isDraggable = uiDialog.is( ":data(ui-draggable)" );
			if ( isDraggable && !value ) {
				uiDialog.draggable( "destroy" );
			}

			if ( !isDraggable && value ) {
				this._makeDraggable();
			}
		}

		if ( key === "position" ) {
			this._position();
		}

		if ( key === "resizable" ) {
			// currently resizable, becoming non-resizable
			isResizable = uiDialog.is( ":data(ui-resizable)" );
			if ( isResizable && !value ) {
				uiDialog.resizable( "destroy" );
			}

			// currently resizable, changing handles
			if ( isResizable && typeof value === "string" ) {
				uiDialog.resizable( "option", "handles", value );
			}

			// currently non-resizable, becoming resizable
			if ( !isResizable && value !== false ) {
				this._makeResizable();
			}
		}

		if ( key === "title" ) {
			this._title( this.uiDialogTitlebar.find( ".ui-dialog-title" ) );
		}
	},

	_size: function() {
		// If the user has resized the dialog, the .ui-dialog and .ui-dialog-content
		// divs will both have width and height set, so we need to reset them
		var nonContentHeight, minContentHeight, maxContentHeight,
			options = this.options;

		// Reset content sizing
		this.element.show().css({
			width: "auto",
			minHeight: 0,
			maxHeight: "none",
			height: 0
		});

		if ( options.minWidth > options.width ) {
			options.width = options.minWidth;
		}

		// reset wrapper sizing
		// determine the height of all the non-content elements
		nonContentHeight = this.uiDialog.css({
				height: "auto",
				width: options.width
			})
			.outerHeight();
		minContentHeight = Math.max( 0, options.minHeight - nonContentHeight );
		maxContentHeight = typeof options.maxHeight === "number" ?
			Math.max( 0, options.maxHeight - nonContentHeight ) :
			"none";

		if ( options.height === "auto" ) {
			this.element.css({
				minHeight: minContentHeight,
				maxHeight: maxContentHeight,
				height: "auto"
			});
		} else {
			this.element.height( Math.max( 0, options.height - nonContentHeight ) );
		}

		if ( this.uiDialog.is( ":data(ui-resizable)" ) ) {
			this.uiDialog.resizable( "option", "minHeight", this._minHeight() );
		}
	},

	_blockFrames: function() {
		this.iframeBlocks = this.document.find( "iframe" ).map(function() {
			var iframe = $( this );

			return $( "<div>" )
				.css({
					position: "absolute",
					width: iframe.outerWidth(),
					height: iframe.outerHeight()
				})
				.appendTo( iframe.parent() )
				.offset( iframe.offset() )[0];
		});
	},

	_unblockFrames: function() {
		if ( this.iframeBlocks ) {
			this.iframeBlocks.remove();
			delete this.iframeBlocks;
		}
	},

	_allowInteraction: function( event ) {
		if ( $( event.target ).closest( ".ui-dialog" ).length ) {
			return true;
		}

		// TODO: Remove hack when datepicker implements
		// the .ui-front logic (#8989)
		return !!$( event.target ).closest( ".ui-datepicker" ).length;
	},

	_createOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		// We use a delay in case the overlay is created from an
		// event that we're going to be cancelling (#2804)
		var isOpening = true;
		this._delay(function() {
			isOpening = false;
		});

		if ( !this.document.data( "ui-dialog-overlays" ) ) {

			// Prevent use of anchors and inputs
			// Using _on() for an event handler shared across many instances is
			// safe because the dialogs stack and must be closed in reverse order
			this._on( this.document, {
				focusin: function( event ) {
					if ( isOpening ) {
						return;
					}

					if ( !this._allowInteraction( event ) ) {
						event.preventDefault();
						this._trackingInstances()[ 0 ]._focusTabbable();
					}
				}
			});
		}

		this.overlay = $( "<div>" )
			.addClass( "ui-widget-overlay ui-front" )
			.appendTo( this._appendTo() );
		this._on( this.overlay, {
			mousedown: "_keepFocus"
		});
		this.document.data( "ui-dialog-overlays",
			(this.document.data( "ui-dialog-overlays" ) || 0) + 1 );
	},

	_destroyOverlay: function() {
		if ( !this.options.modal ) {
			return;
		}

		if ( this.overlay ) {
			var overlays = this.document.data( "ui-dialog-overlays" ) - 1;

			if ( !overlays ) {
				this.document
					.unbind( "focusin" )
					.removeData( "ui-dialog-overlays" );
			} else {
				this.document.data( "ui-dialog-overlays", overlays );
			}

			this.overlay.remove();
			this.overlay = null;
		}
	}
});


/*!
 * jQuery UI Droppable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/droppable/
 */


$.widget( "ui.droppable", {
	version: "1.11.4",
	widgetEventPrefix: "drop",
	options: {
		accept: "*",
		activeClass: false,
		addClasses: true,
		greedy: false,
		hoverClass: false,
		scope: "default",
		tolerance: "intersect",

		// callbacks
		activate: null,
		deactivate: null,
		drop: null,
		out: null,
		over: null
	},
	_create: function() {

		var proportions,
			o = this.options,
			accept = o.accept;

		this.isover = false;
		this.isout = true;

		this.accept = $.isFunction( accept ) ? accept : function( d ) {
			return d.is( accept );
		};

		this.proportions = function( /* valueToWrite */ ) {
			if ( arguments.length ) {
				// Store the droppable's proportions
				proportions = arguments[ 0 ];
			} else {
				// Retrieve or derive the droppable's proportions
				return proportions ?
					proportions :
					proportions = {
						width: this.element[ 0 ].offsetWidth,
						height: this.element[ 0 ].offsetHeight
					};
			}
		};

		this._addToManager( o.scope );

		o.addClasses && this.element.addClass( "ui-droppable" );

	},

	_addToManager: function( scope ) {
		// Add the reference and positions to the manager
		$.ui.ddmanager.droppables[ scope ] = $.ui.ddmanager.droppables[ scope ] || [];
		$.ui.ddmanager.droppables[ scope ].push( this );
	},

	_splice: function( drop ) {
		var i = 0;
		for ( ; i < drop.length; i++ ) {
			if ( drop[ i ] === this ) {
				drop.splice( i, 1 );
			}
		}
	},

	_destroy: function() {
		var drop = $.ui.ddmanager.droppables[ this.options.scope ];

		this._splice( drop );

		this.element.removeClass( "ui-droppable ui-droppable-disabled" );
	},

	_setOption: function( key, value ) {

		if ( key === "accept" ) {
			this.accept = $.isFunction( value ) ? value : function( d ) {
				return d.is( value );
			};
		} else if ( key === "scope" ) {
			var drop = $.ui.ddmanager.droppables[ this.options.scope ];

			this._splice( drop );
			this._addToManager( value );
		}

		this._super( key, value );
	},

	_activate: function( event ) {
		var draggable = $.ui.ddmanager.current;
		if ( this.options.activeClass ) {
			this.element.addClass( this.options.activeClass );
		}
		if ( draggable ){
			this._trigger( "activate", event, this.ui( draggable ) );
		}
	},

	_deactivate: function( event ) {
		var draggable = $.ui.ddmanager.current;
		if ( this.options.activeClass ) {
			this.element.removeClass( this.options.activeClass );
		}
		if ( draggable ){
			this._trigger( "deactivate", event, this.ui( draggable ) );
		}
	},

	_over: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
			if ( this.options.hoverClass ) {
				this.element.addClass( this.options.hoverClass );
			}
			this._trigger( "over", event, this.ui( draggable ) );
		}

	},

	_out: function( event ) {

		var draggable = $.ui.ddmanager.current;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
			this._trigger( "out", event, this.ui( draggable ) );
		}

	},

	_drop: function( event, custom ) {

		var draggable = custom || $.ui.ddmanager.current,
			childrenIntersection = false;

		// Bail if draggable and droppable are same element
		if ( !draggable || ( draggable.currentItem || draggable.element )[ 0 ] === this.element[ 0 ] ) {
			return false;
		}

		this.element.find( ":data(ui-droppable)" ).not( ".ui-draggable-dragging" ).each(function() {
			var inst = $( this ).droppable( "instance" );
			if (
				inst.options.greedy &&
				!inst.options.disabled &&
				inst.options.scope === draggable.options.scope &&
				inst.accept.call( inst.element[ 0 ], ( draggable.currentItem || draggable.element ) ) &&
				$.ui.intersect( draggable, $.extend( inst, { offset: inst.element.offset() } ), inst.options.tolerance, event )
			) { childrenIntersection = true; return false; }
		});
		if ( childrenIntersection ) {
			return false;
		}

		if ( this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
			if ( this.options.activeClass ) {
				this.element.removeClass( this.options.activeClass );
			}
			if ( this.options.hoverClass ) {
				this.element.removeClass( this.options.hoverClass );
			}
			this._trigger( "drop", event, this.ui( draggable ) );
			return this.element;
		}

		return false;

	},

	ui: function( c ) {
		return {
			draggable: ( c.currentItem || c.element ),
			helper: c.helper,
			position: c.position,
			offset: c.positionAbs
		};
	}

});

$.ui.intersect = (function() {
	function isOverAxis( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	}

	return function( draggable, droppable, toleranceMode, event ) {

		if ( !droppable.offset ) {
			return false;
		}

		var x1 = ( draggable.positionAbs || draggable.position.absolute ).left + draggable.margins.left,
			y1 = ( draggable.positionAbs || draggable.position.absolute ).top + draggable.margins.top,
			x2 = x1 + draggable.helperProportions.width,
			y2 = y1 + draggable.helperProportions.height,
			l = droppable.offset.left,
			t = droppable.offset.top,
			r = l + droppable.proportions().width,
			b = t + droppable.proportions().height;

		switch ( toleranceMode ) {
		case "fit":
			return ( l <= x1 && x2 <= r && t <= y1 && y2 <= b );
		case "intersect":
			return ( l < x1 + ( draggable.helperProportions.width / 2 ) && // Right Half
				x2 - ( draggable.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( draggable.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( draggable.helperProportions.height / 2 ) < b ); // Top Half
		case "pointer":
			return isOverAxis( event.pageY, t, droppable.proportions().height ) && isOverAxis( event.pageX, l, droppable.proportions().width );
		case "touch":
			return (
				( y1 >= t && y1 <= b ) || // Top edge touching
				( y2 >= t && y2 <= b ) || // Bottom edge touching
				( y1 < t && y2 > b ) // Surrounded vertically
			) && (
				( x1 >= l && x1 <= r ) || // Left edge touching
				( x2 >= l && x2 <= r ) || // Right edge touching
				( x1 < l && x2 > r ) // Surrounded horizontally
			);
		default:
			return false;
		}
	};
})();

/*
	This manager tracks offsets of draggables and droppables
*/
$.ui.ddmanager = {
	current: null,
	droppables: { "default": [] },
	prepareOffsets: function( t, event ) {

		var i, j,
			m = $.ui.ddmanager.droppables[ t.options.scope ] || [],
			type = event ? event.type : null, // workaround for #2317
			list = ( t.currentItem || t.element ).find( ":data(ui-droppable)" ).addBack();

		droppablesLoop: for ( i = 0; i < m.length; i++ ) {

			// No disabled and non-accepted
			if ( m[ i ].options.disabled || ( t && !m[ i ].accept.call( m[ i ].element[ 0 ], ( t.currentItem || t.element ) ) ) ) {
				continue;
			}

			// Filter out elements in the current dragged item
			for ( j = 0; j < list.length; j++ ) {
				if ( list[ j ] === m[ i ].element[ 0 ] ) {
					m[ i ].proportions().height = 0;
					continue droppablesLoop;
				}
			}

			m[ i ].visible = m[ i ].element.css( "display" ) !== "none";
			if ( !m[ i ].visible ) {
				continue;
			}

			// Activate the droppable if used directly from draggables
			if ( type === "mousedown" ) {
				m[ i ]._activate.call( m[ i ], event );
			}

			m[ i ].offset = m[ i ].element.offset();
			m[ i ].proportions({ width: m[ i ].element[ 0 ].offsetWidth, height: m[ i ].element[ 0 ].offsetHeight });

		}

	},
	drop: function( draggable, event ) {

		var dropped = false;
		// Create a copy of the droppables in case the list changes during the drop (#9116)
		$.each( ( $.ui.ddmanager.droppables[ draggable.options.scope ] || [] ).slice(), function() {

			if ( !this.options ) {
				return;
			}
			if ( !this.options.disabled && this.visible && $.ui.intersect( draggable, this, this.options.tolerance, event ) ) {
				dropped = this._drop.call( this, event ) || dropped;
			}

			if ( !this.options.disabled && this.visible && this.accept.call( this.element[ 0 ], ( draggable.currentItem || draggable.element ) ) ) {
				this.isout = true;
				this.isover = false;
				this._deactivate.call( this, event );
			}

		});
		return dropped;

	},
	dragStart: function( draggable, event ) {
		// Listen for scrolling so that if the dragging causes scrolling the position of the droppables can be recalculated (see #5003)
		draggable.element.parentsUntil( "body" ).bind( "scroll.droppable", function() {
			if ( !draggable.options.refreshPositions ) {
				$.ui.ddmanager.prepareOffsets( draggable, event );
			}
		});
	},
	drag: function( draggable, event ) {

		// If you have a highly dynamic page, you might try this option. It renders positions every time you move the mouse.
		if ( draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}

		// Run through all droppables and check their positions based on specific tolerance options
		$.each( $.ui.ddmanager.droppables[ draggable.options.scope ] || [], function() {

			if ( this.options.disabled || this.greedyChild || !this.visible ) {
				return;
			}

			var parentInstance, scope, parent,
				intersects = $.ui.intersect( draggable, this, this.options.tolerance, event ),
				c = !intersects && this.isover ? "isout" : ( intersects && !this.isover ? "isover" : null );
			if ( !c ) {
				return;
			}

			if ( this.options.greedy ) {
				// find droppable parents with same scope
				scope = this.options.scope;
				parent = this.element.parents( ":data(ui-droppable)" ).filter(function() {
					return $( this ).droppable( "instance" ).options.scope === scope;
				});

				if ( parent.length ) {
					parentInstance = $( parent[ 0 ] ).droppable( "instance" );
					parentInstance.greedyChild = ( c === "isover" );
				}
			}

			// we just moved into a greedy child
			if ( parentInstance && c === "isover" ) {
				parentInstance.isover = false;
				parentInstance.isout = true;
				parentInstance._out.call( parentInstance, event );
			}

			this[ c ] = true;
			this[c === "isout" ? "isover" : "isout"] = false;
			this[c === "isover" ? "_over" : "_out"].call( this, event );

			// we just moved out of a greedy child
			if ( parentInstance && c === "isout" ) {
				parentInstance.isout = false;
				parentInstance.isover = true;
				parentInstance._over.call( parentInstance, event );
			}
		});

	},
	dragStop: function( draggable, event ) {
		draggable.element.parentsUntil( "body" ).unbind( "scroll.droppable" );
		// Call prepareOffsets one final time since IE does not fire return scroll events when overflow was caused by drag (see #5003)
		if ( !draggable.options.refreshPositions ) {
			$.ui.ddmanager.prepareOffsets( draggable, event );
		}
	}
};

var droppable = $.ui.droppable;


/*!
 * jQuery UI Effects 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/effects-core/
 */


var dataSpace = "ui-effects-",

	// Create a local jQuery because jQuery Color relies on it and the
	// global may not exist with AMD and a custom build (#10199)
	jQuery = $;

$.effects = {
	effect: {}
};

/*!
 * jQuery Color Animations v2.1.2
 * https://github.com/jquery/jquery-color
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Date: Wed Jan 16 08:47:09 2013 -0600
 */
(function( jQuery, undefined ) {

	var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",

	// plusequals test for += 100 -= 100
	rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
	// a set of RE's that can match strings and generate color tuples.
	stringParsers = [ {
			re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ],
					execResult[ 3 ],
					execResult[ 4 ]
				];
			}
		}, {
			re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			parse: function( execResult ) {
				return [
					execResult[ 1 ] * 2.55,
					execResult[ 2 ] * 2.55,
					execResult[ 3 ] * 2.55,
					execResult[ 4 ]
				];
			}
		}, {
			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ], 16 )
				];
			}
		}, {
			// this regex ignores A-F because it's compared against an already lowercased string
			re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
			parse: function( execResult ) {
				return [
					parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
					parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
					parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
				];
			}
		}, {
			re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
			space: "hsla",
			parse: function( execResult ) {
				return [
					execResult[ 1 ],
					execResult[ 2 ] / 100,
					execResult[ 3 ] / 100,
					execResult[ 4 ]
				];
			}
		} ],

	// jQuery.Color( )
	color = jQuery.Color = function( color, green, blue, alpha ) {
		return new jQuery.Color.fn.parse( color, green, blue, alpha );
	},
	spaces = {
		rgba: {
			props: {
				red: {
					idx: 0,
					type: "byte"
				},
				green: {
					idx: 1,
					type: "byte"
				},
				blue: {
					idx: 2,
					type: "byte"
				}
			}
		},

		hsla: {
			props: {
				hue: {
					idx: 0,
					type: "degrees"
				},
				saturation: {
					idx: 1,
					type: "percent"
				},
				lightness: {
					idx: 2,
					type: "percent"
				}
			}
		}
	},
	propTypes = {
		"byte": {
			floor: true,
			max: 255
		},
		"percent": {
			max: 1
		},
		"degrees": {
			mod: 360,
			floor: true
		}
	},
	support = color.support = {},

	// element for support tests
	supportElem = jQuery( "<p>" )[ 0 ],

	// colors = jQuery.Color.names
	colors,

	// local aliases of functions called often
	each = jQuery.each;

// determine rgba support immediately
supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;

// define cache name and alpha properties
// for rgba and hsla spaces
each( spaces, function( spaceName, space ) {
	space.cache = "_" + spaceName;
	space.props.alpha = {
		idx: 3,
		type: "percent",
		def: 1
	};
});

function clamp( value, prop, allowEmpty ) {
	var type = propTypes[ prop.type ] || {};

	if ( value == null ) {
		return (allowEmpty || !prop.def) ? null : prop.def;
	}

	// ~~ is an short way of doing floor for positive numbers
	value = type.floor ? ~~value : parseFloat( value );

	// IE will pass in empty strings as value for alpha,
	// which will hit this case
	if ( isNaN( value ) ) {
		return prop.def;
	}

	if ( type.mod ) {
		// we add mod before modding to make sure that negatives values
		// get converted properly: -10 -> 350
		return (value + type.mod) % type.mod;
	}

	// for now all property types without mod have min and max
	return 0 > value ? 0 : type.max < value ? type.max : value;
}

function stringParse( string ) {
	var inst = color(),
		rgba = inst._rgba = [];

	string = string.toLowerCase();

	each( stringParsers, function( i, parser ) {
		var parsed,
			match = parser.re.exec( string ),
			values = match && parser.parse( match ),
			spaceName = parser.space || "rgba";

		if ( values ) {
			parsed = inst[ spaceName ]( values );

			// if this was an rgba parse the assignment might happen twice
			// oh well....
			inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
			rgba = inst._rgba = parsed._rgba;

			// exit each( stringParsers ) here because we matched
			return false;
		}
	});

	// Found a stringParser that handled it
	if ( rgba.length ) {

		// if this came from a parsed string, force "transparent" when alpha is 0
		// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
		if ( rgba.join() === "0,0,0,0" ) {
			jQuery.extend( rgba, colors.transparent );
		}
		return inst;
	}

	// named colors
	return colors[ string ];
}

color.fn = jQuery.extend( color.prototype, {
	parse: function( red, green, blue, alpha ) {
		if ( red === undefined ) {
			this._rgba = [ null, null, null, null ];
			return this;
		}
		if ( red.jquery || red.nodeType ) {
			red = jQuery( red ).css( green );
			green = undefined;
		}

		var inst = this,
			type = jQuery.type( red ),
			rgba = this._rgba = [];

		// more than 1 argument specified - assume ( red, green, blue, alpha )
		if ( green !== undefined ) {
			red = [ red, green, blue, alpha ];
			type = "array";
		}

		if ( type === "string" ) {
			return this.parse( stringParse( red ) || colors._default );
		}

		if ( type === "array" ) {
			each( spaces.rgba.props, function( key, prop ) {
				rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
			});
			return this;
		}

		if ( type === "object" ) {
			if ( red instanceof color ) {
				each( spaces, function( spaceName, space ) {
					if ( red[ space.cache ] ) {
						inst[ space.cache ] = red[ space.cache ].slice();
					}
				});
			} else {
				each( spaces, function( spaceName, space ) {
					var cache = space.cache;
					each( space.props, function( key, prop ) {

						// if the cache doesn't exist, and we know how to convert
						if ( !inst[ cache ] && space.to ) {

							// if the value was null, we don't need to copy it
							// if the key was alpha, we don't need to copy it either
							if ( key === "alpha" || red[ key ] == null ) {
								return;
							}
							inst[ cache ] = space.to( inst._rgba );
						}

						// this is the only case where we allow nulls for ALL properties.
						// call clamp with alwaysAllowEmpty
						inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
					});

					// everything defined but alpha?
					if ( inst[ cache ] && jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
						// use the default of 1
						inst[ cache ][ 3 ] = 1;
						if ( space.from ) {
							inst._rgba = space.from( inst[ cache ] );
						}
					}
				});
			}
			return this;
		}
	},
	is: function( compare ) {
		var is = color( compare ),
			same = true,
			inst = this;

		each( spaces, function( _, space ) {
			var localCache,
				isCache = is[ space.cache ];
			if (isCache) {
				localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
				each( space.props, function( _, prop ) {
					if ( isCache[ prop.idx ] != null ) {
						same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
						return same;
					}
				});
			}
			return same;
		});
		return same;
	},
	_space: function() {
		var used = [],
			inst = this;
		each( spaces, function( spaceName, space ) {
			if ( inst[ space.cache ] ) {
				used.push( spaceName );
			}
		});
		return used.pop();
	},
	transition: function( other, distance ) {
		var end = color( other ),
			spaceName = end._space(),
			space = spaces[ spaceName ],
			startColor = this.alpha() === 0 ? color( "transparent" ) : this,
			start = startColor[ space.cache ] || space.to( startColor._rgba ),
			result = start.slice();

		end = end[ space.cache ];
		each( space.props, function( key, prop ) {
			var index = prop.idx,
				startValue = start[ index ],
				endValue = end[ index ],
				type = propTypes[ prop.type ] || {};

			// if null, don't override start value
			if ( endValue === null ) {
				return;
			}
			// if null - use end
			if ( startValue === null ) {
				result[ index ] = endValue;
			} else {
				if ( type.mod ) {
					if ( endValue - startValue > type.mod / 2 ) {
						startValue += type.mod;
					} else if ( startValue - endValue > type.mod / 2 ) {
						startValue -= type.mod;
					}
				}
				result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
			}
		});
		return this[ spaceName ]( result );
	},
	blend: function( opaque ) {
		// if we are already opaque - return ourself
		if ( this._rgba[ 3 ] === 1 ) {
			return this;
		}

		var rgb = this._rgba.slice(),
			a = rgb.pop(),
			blend = color( opaque )._rgba;

		return color( jQuery.map( rgb, function( v, i ) {
			return ( 1 - a ) * blend[ i ] + a * v;
		}));
	},
	toRgbaString: function() {
		var prefix = "rgba(",
			rgba = jQuery.map( this._rgba, function( v, i ) {
				return v == null ? ( i > 2 ? 1 : 0 ) : v;
			});

		if ( rgba[ 3 ] === 1 ) {
			rgba.pop();
			prefix = "rgb(";
		}

		return prefix + rgba.join() + ")";
	},
	toHslaString: function() {
		var prefix = "hsla(",
			hsla = jQuery.map( this.hsla(), function( v, i ) {
				if ( v == null ) {
					v = i > 2 ? 1 : 0;
				}

				// catch 1 and 2
				if ( i && i < 3 ) {
					v = Math.round( v * 100 ) + "%";
				}
				return v;
			});

		if ( hsla[ 3 ] === 1 ) {
			hsla.pop();
			prefix = "hsl(";
		}
		return prefix + hsla.join() + ")";
	},
	toHexString: function( includeAlpha ) {
		var rgba = this._rgba.slice(),
			alpha = rgba.pop();

		if ( includeAlpha ) {
			rgba.push( ~~( alpha * 255 ) );
		}

		return "#" + jQuery.map( rgba, function( v ) {

			// default to 0 when nulls exist
			v = ( v || 0 ).toString( 16 );
			return v.length === 1 ? "0" + v : v;
		}).join("");
	},
	toString: function() {
		return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
	}
});
color.fn.parse.prototype = color.fn;

// hsla conversions adapted from:
// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021

function hue2rgb( p, q, h ) {
	h = ( h + 1 ) % 1;
	if ( h * 6 < 1 ) {
		return p + ( q - p ) * h * 6;
	}
	if ( h * 2 < 1) {
		return q;
	}
	if ( h * 3 < 2 ) {
		return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
	}
	return p;
}

spaces.hsla.to = function( rgba ) {
	if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
		return [ null, null, null, rgba[ 3 ] ];
	}
	var r = rgba[ 0 ] / 255,
		g = rgba[ 1 ] / 255,
		b = rgba[ 2 ] / 255,
		a = rgba[ 3 ],
		max = Math.max( r, g, b ),
		min = Math.min( r, g, b ),
		diff = max - min,
		add = max + min,
		l = add * 0.5,
		h, s;

	if ( min === max ) {
		h = 0;
	} else if ( r === max ) {
		h = ( 60 * ( g - b ) / diff ) + 360;
	} else if ( g === max ) {
		h = ( 60 * ( b - r ) / diff ) + 120;
	} else {
		h = ( 60 * ( r - g ) / diff ) + 240;
	}

	// chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
	// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
	if ( diff === 0 ) {
		s = 0;
	} else if ( l <= 0.5 ) {
		s = diff / add;
	} else {
		s = diff / ( 2 - add );
	}
	return [ Math.round(h) % 360, s, l, a == null ? 1 : a ];
};

spaces.hsla.from = function( hsla ) {
	if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
		return [ null, null, null, hsla[ 3 ] ];
	}
	var h = hsla[ 0 ] / 360,
		s = hsla[ 1 ],
		l = hsla[ 2 ],
		a = hsla[ 3 ],
		q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
		p = 2 * l - q;

	return [
		Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
		Math.round( hue2rgb( p, q, h ) * 255 ),
		Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
		a
	];
};

each( spaces, function( spaceName, space ) {
	var props = space.props,
		cache = space.cache,
		to = space.to,
		from = space.from;

	// makes rgba() and hsla()
	color.fn[ spaceName ] = function( value ) {

		// generate a cache for this space if it doesn't exist
		if ( to && !this[ cache ] ) {
			this[ cache ] = to( this._rgba );
		}
		if ( value === undefined ) {
			return this[ cache ].slice();
		}

		var ret,
			type = jQuery.type( value ),
			arr = ( type === "array" || type === "object" ) ? value : arguments,
			local = this[ cache ].slice();

		each( props, function( key, prop ) {
			var val = arr[ type === "object" ? key : prop.idx ];
			if ( val == null ) {
				val = local[ prop.idx ];
			}
			local[ prop.idx ] = clamp( val, prop );
		});

		if ( from ) {
			ret = color( from( local ) );
			ret[ cache ] = local;
			return ret;
		} else {
			return color( local );
		}
	};

	// makes red() green() blue() alpha() hue() saturation() lightness()
	each( props, function( key, prop ) {
		// alpha is included in more than one space
		if ( color.fn[ key ] ) {
			return;
		}
		color.fn[ key ] = function( value ) {
			var vtype = jQuery.type( value ),
				fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
				local = this[ fn ](),
				cur = local[ prop.idx ],
				match;

			if ( vtype === "undefined" ) {
				return cur;
			}

			if ( vtype === "function" ) {
				value = value.call( this, cur );
				vtype = jQuery.type( value );
			}
			if ( value == null && prop.empty ) {
				return this;
			}
			if ( vtype === "string" ) {
				match = rplusequals.exec( value );
				if ( match ) {
					value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
				}
			}
			local[ prop.idx ] = value;
			return this[ fn ]( local );
		};
	});
});

// add cssHook and .fx.step function for each named hook.
// accept a space separated string of properties
color.hook = function( hook ) {
	var hooks = hook.split( " " );
	each( hooks, function( i, hook ) {
		jQuery.cssHooks[ hook ] = {
			set: function( elem, value ) {
				var parsed, curElem,
					backgroundColor = "";

				if ( value !== "transparent" && ( jQuery.type( value ) !== "string" || ( parsed = stringParse( value ) ) ) ) {
					value = color( parsed || value );
					if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
						curElem = hook === "backgroundColor" ? elem.parentNode : elem;
						while (
							(backgroundColor === "" || backgroundColor === "transparent") &&
							curElem && curElem.style
						) {
							try {
								backgroundColor = jQuery.css( curElem, "backgroundColor" );
								curElem = curElem.parentNode;
							} catch ( e ) {
							}
						}

						value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
							backgroundColor :
							"_default" );
					}

					value = value.toRgbaString();
				}
				try {
					elem.style[ hook ] = value;
				} catch ( e ) {
					// wrapped to prevent IE from throwing errors on "invalid" values like 'auto' or 'inherit'
				}
			}
		};
		jQuery.fx.step[ hook ] = function( fx ) {
			if ( !fx.colorInit ) {
				fx.start = color( fx.elem, hook );
				fx.end = color( fx.end );
				fx.colorInit = true;
			}
			jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
		};
	});

};

color.hook( stepHooks );

jQuery.cssHooks.borderColor = {
	expand: function( value ) {
		var expanded = {};

		each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
			expanded[ "border" + part + "Color" ] = value;
		});
		return expanded;
	}
};

// Basic color names only.
// Usage of any of the other color names requires adding yourself or including
// jquery.color.svg-names.js.
colors = jQuery.Color.names = {
	// 4.1. Basic color keywords
	aqua: "#00ffff",
	black: "#000000",
	blue: "#0000ff",
	fuchsia: "#ff00ff",
	gray: "#808080",
	green: "#008000",
	lime: "#00ff00",
	maroon: "#800000",
	navy: "#000080",
	olive: "#808000",
	purple: "#800080",
	red: "#ff0000",
	silver: "#c0c0c0",
	teal: "#008080",
	white: "#ffffff",
	yellow: "#ffff00",

	// 4.2.3. "transparent" color keyword
	transparent: [ null, null, null, 0 ],

	_default: "#ffffff"
};

})( jQuery );

/******************************************************************************/
/****************************** CLASS ANIMATIONS ******************************/
/******************************************************************************/
(function() {

var classAnimationActions = [ "add", "remove", "toggle" ],
	shorthandStyles = {
		border: 1,
		borderBottom: 1,
		borderColor: 1,
		borderLeft: 1,
		borderRight: 1,
		borderTop: 1,
		borderWidth: 1,
		margin: 1,
		padding: 1
	};

$.each([ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ], function( _, prop ) {
	$.fx.step[ prop ] = function( fx ) {
		if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
			jQuery.style( fx.elem, prop, fx.end );
			fx.setAttr = true;
		}
	};
});

function getElementStyles( elem ) {
	var key, len,
		style = elem.ownerDocument.defaultView ?
			elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
			elem.currentStyle,
		styles = {};

	if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
		len = style.length;
		while ( len-- ) {
			key = style[ len ];
			if ( typeof style[ key ] === "string" ) {
				styles[ $.camelCase( key ) ] = style[ key ];
			}
		}
	// support: Opera, IE <9
	} else {
		for ( key in style ) {
			if ( typeof style[ key ] === "string" ) {
				styles[ key ] = style[ key ];
			}
		}
	}

	return styles;
}

function styleDifference( oldStyle, newStyle ) {
	var diff = {},
		name, value;

	for ( name in newStyle ) {
		value = newStyle[ name ];
		if ( oldStyle[ name ] !== value ) {
			if ( !shorthandStyles[ name ] ) {
				if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
					diff[ name ] = value;
				}
			}
		}
	}

	return diff;
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
	$.fn.addBack = function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	};
}

$.effects.animateClass = function( value, duration, easing, callback ) {
	var o = $.speed( duration, easing, callback );

	return this.queue( function() {
		var animated = $( this ),
			baseClass = animated.attr( "class" ) || "",
			applyClassChange,
			allAnimations = o.children ? animated.find( "*" ).addBack() : animated;

		// map the animated objects to store the original styles.
		allAnimations = allAnimations.map(function() {
			var el = $( this );
			return {
				el: el,
				start: getElementStyles( this )
			};
		});

		// apply class change
		applyClassChange = function() {
			$.each( classAnimationActions, function(i, action) {
				if ( value[ action ] ) {
					animated[ action + "Class" ]( value[ action ] );
				}
			});
		};
		applyClassChange();

		// map all animated objects again - calculate new styles and diff
		allAnimations = allAnimations.map(function() {
			this.end = getElementStyles( this.el[ 0 ] );
			this.diff = styleDifference( this.start, this.end );
			return this;
		});

		// apply original class
		animated.attr( "class", baseClass );

		// map all animated objects again - this time collecting a promise
		allAnimations = allAnimations.map(function() {
			var styleInfo = this,
				dfd = $.Deferred(),
				opts = $.extend({}, o, {
					queue: false,
					complete: function() {
						dfd.resolve( styleInfo );
					}
				});

			this.el.animate( this.diff, opts );
			return dfd.promise();
		});

		// once all animations have completed:
		$.when.apply( $, allAnimations.get() ).done(function() {

			// set the final class
			applyClassChange();

			// for each animated element,
			// clear all css properties that were animated
			$.each( arguments, function() {
				var el = this.el;
				$.each( this.diff, function(key) {
					el.css( key, "" );
				});
			});

			// this is guarnteed to be there if you use jQuery.speed()
			// it also handles dequeuing the next anim...
			o.complete.call( animated[ 0 ] );
		});
	});
};

$.fn.extend({
	addClass: (function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return speed ?
				$.effects.animateClass.call( this,
					{ add: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	})( $.fn.addClass ),

	removeClass: (function( orig ) {
		return function( classNames, speed, easing, callback ) {
			return arguments.length > 1 ?
				$.effects.animateClass.call( this,
					{ remove: classNames }, speed, easing, callback ) :
				orig.apply( this, arguments );
		};
	})( $.fn.removeClass ),

	toggleClass: (function( orig ) {
		return function( classNames, force, speed, easing, callback ) {
			if ( typeof force === "boolean" || force === undefined ) {
				if ( !speed ) {
					// without speed parameter
					return orig.apply( this, arguments );
				} else {
					return $.effects.animateClass.call( this,
						(force ? { add: classNames } : { remove: classNames }),
						speed, easing, callback );
				}
			} else {
				// without force parameter
				return $.effects.animateClass.call( this,
					{ toggle: classNames }, force, speed, easing );
			}
		};
	})( $.fn.toggleClass ),

	switchClass: function( remove, add, speed, easing, callback) {
		return $.effects.animateClass.call( this, {
			add: add,
			remove: remove
		}, speed, easing, callback );
	}
});

})();

/******************************************************************************/
/*********************************** EFFECTS **********************************/
/******************************************************************************/

(function() {

$.extend( $.effects, {
	version: "1.11.4",

	// Saves a set of properties in a data storage
	save: function( element, set ) {
		for ( var i = 0; i < set.length; i++ ) {
			if ( set[ i ] !== null ) {
				element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
			}
		}
	},

	// Restores a set of previously saved properties from a data storage
	restore: function( element, set ) {
		var val, i;
		for ( i = 0; i < set.length; i++ ) {
			if ( set[ i ] !== null ) {
				val = element.data( dataSpace + set[ i ] );
				// support: jQuery 1.6.2
				// http://bugs.jquery.com/ticket/9917
				// jQuery 1.6.2 incorrectly returns undefined for any falsy value.
				// We can't differentiate between "" and 0 here, so we just assume
				// empty string since it's likely to be a more common value...
				if ( val === undefined ) {
					val = "";
				}
				element.css( set[ i ], val );
			}
		}
	},

	setMode: function( el, mode ) {
		if (mode === "toggle") {
			mode = el.is( ":hidden" ) ? "show" : "hide";
		}
		return mode;
	},

	// Translates a [top,left] array into a baseline value
	// this should be a little more flexible in the future to handle a string & hash
	getBaseline: function( origin, original ) {
		var y, x;
		switch ( origin[ 0 ] ) {
			case "top": y = 0; break;
			case "middle": y = 0.5; break;
			case "bottom": y = 1; break;
			default: y = origin[ 0 ] / original.height;
		}
		switch ( origin[ 1 ] ) {
			case "left": x = 0; break;
			case "center": x = 0.5; break;
			case "right": x = 1; break;
			default: x = origin[ 1 ] / original.width;
		}
		return {
			x: x,
			y: y
		};
	},

	// Wraps the element around a wrapper that copies position properties
	createWrapper: function( element ) {

		// if the element is already wrapped, return it
		if ( element.parent().is( ".ui-effects-wrapper" )) {
			return element.parent();
		}

		// wrap the element
		var props = {
				width: element.outerWidth(true),
				height: element.outerHeight(true),
				"float": element.css( "float" )
			},
			wrapper = $( "<div></div>" )
				.addClass( "ui-effects-wrapper" )
				.css({
					fontSize: "100%",
					background: "transparent",
					border: "none",
					margin: 0,
					padding: 0
				}),
			// Store the size in case width/height are defined in % - Fixes #5245
			size = {
				width: element.width(),
				height: element.height()
			},
			active = document.activeElement;

		// support: Firefox
		// Firefox incorrectly exposes anonymous content
		// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
		try {
			active.id;
		} catch ( e ) {
			active = document.body;
		}

		element.wrap( wrapper );

		// Fixes #7595 - Elements lose focus when wrapped.
		if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
			$( active ).focus();
		}

		wrapper = element.parent(); //Hotfix for jQuery 1.4 since some change in wrap() seems to actually lose the reference to the wrapped element

		// transfer positioning properties to the wrapper
		if ( element.css( "position" ) === "static" ) {
			wrapper.css({ position: "relative" });
			element.css({ position: "relative" });
		} else {
			$.extend( props, {
				position: element.css( "position" ),
				zIndex: element.css( "z-index" )
			});
			$.each([ "top", "left", "bottom", "right" ], function(i, pos) {
				props[ pos ] = element.css( pos );
				if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
					props[ pos ] = "auto";
				}
			});
			element.css({
				position: "relative",
				top: 0,
				left: 0,
				right: "auto",
				bottom: "auto"
			});
		}
		element.css(size);

		return wrapper.css( props ).show();
	},

	removeWrapper: function( element ) {
		var active = document.activeElement;

		if ( element.parent().is( ".ui-effects-wrapper" ) ) {
			element.parent().replaceWith( element );

			// Fixes #7595 - Elements lose focus when wrapped.
			if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
				$( active ).focus();
			}
		}

		return element;
	},

	setTransition: function( element, list, factor, value ) {
		value = value || {};
		$.each( list, function( i, x ) {
			var unit = element.cssUnit( x );
			if ( unit[ 0 ] > 0 ) {
				value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
			}
		});
		return value;
	}
});

// return an effect options object for the given parameters:
function _normalizeArguments( effect, options, speed, callback ) {

	// allow passing all options as the first parameter
	if ( $.isPlainObject( effect ) ) {
		options = effect;
		effect = effect.effect;
	}

	// convert to an object
	effect = { effect: effect };

	// catch (effect, null, ...)
	if ( options == null ) {
		options = {};
	}

	// catch (effect, callback)
	if ( $.isFunction( options ) ) {
		callback = options;
		speed = null;
		options = {};
	}

	// catch (effect, speed, ?)
	if ( typeof options === "number" || $.fx.speeds[ options ] ) {
		callback = speed;
		speed = options;
		options = {};
	}

	// catch (effect, options, callback)
	if ( $.isFunction( speed ) ) {
		callback = speed;
		speed = null;
	}

	// add options to effect
	if ( options ) {
		$.extend( effect, options );
	}

	speed = speed || options.duration;
	effect.duration = $.fx.off ? 0 :
		typeof speed === "number" ? speed :
		speed in $.fx.speeds ? $.fx.speeds[ speed ] :
		$.fx.speeds._default;

	effect.complete = callback || options.complete;

	return effect;
}

function standardAnimationOption( option ) {
	// Valid standard speeds (nothing, number, named speed)
	if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
		return true;
	}

	// Invalid strings - treat as "normal" speed
	if ( typeof option === "string" && !$.effects.effect[ option ] ) {
		return true;
	}

	// Complete callback
	if ( $.isFunction( option ) ) {
		return true;
	}

	// Options hash (but not naming an effect)
	if ( typeof option === "object" && !option.effect ) {
		return true;
	}

	// Didn't match any standard API
	return false;
}

$.fn.extend({
	effect: function( /* effect, options, speed, callback */ ) {
		var args = _normalizeArguments.apply( this, arguments ),
			mode = args.mode,
			queue = args.queue,
			effectMethod = $.effects.effect[ args.effect ];

		if ( $.fx.off || !effectMethod ) {
			// delegate to the original method (e.g., .show()) if possible
			if ( mode ) {
				return this[ mode ]( args.duration, args.complete );
			} else {
				return this.each( function() {
					if ( args.complete ) {
						args.complete.call( this );
					}
				});
			}
		}

		function run( next ) {
			var elem = $( this ),
				complete = args.complete,
				mode = args.mode;

			function done() {
				if ( $.isFunction( complete ) ) {
					complete.call( elem[0] );
				}
				if ( $.isFunction( next ) ) {
					next();
				}
			}

			// If the element already has the correct final state, delegate to
			// the core methods so the internal tracking of "olddisplay" works.
			if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
				elem[ mode ]();
				done();
			} else {
				effectMethod.call( elem[0], args, done );
			}
		}

		return queue === false ? this.each( run ) : this.queue( queue || "fx", run );
	},

	show: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "show";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.show ),

	hide: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "hide";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.hide ),

	toggle: (function( orig ) {
		return function( option ) {
			if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
				return orig.apply( this, arguments );
			} else {
				var args = _normalizeArguments.apply( this, arguments );
				args.mode = "toggle";
				return this.effect.call( this, args );
			}
		};
	})( $.fn.toggle ),

	// helper functions
	cssUnit: function(key) {
		var style = this.css( key ),
			val = [];

		$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
			if ( style.indexOf( unit ) > 0 ) {
				val = [ parseFloat( style ), unit ];
			}
		});
		return val;
	}
});

})();

/******************************************************************************/
/*********************************** EASING ***********************************/
/******************************************************************************/

(function() {

// based on easing equations from Robert Penner (http://www.robertpenner.com/easing)

var baseEasings = {};

$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
	baseEasings[ name ] = function( p ) {
		return Math.pow( p, i + 2 );
	};
});

$.extend( baseEasings, {
	Sine: function( p ) {
		return 1 - Math.cos( p * Math.PI / 2 );
	},
	Circ: function( p ) {
		return 1 - Math.sqrt( 1 - p * p );
	},
	Elastic: function( p ) {
		return p === 0 || p === 1 ? p :
			-Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
	},
	Back: function( p ) {
		return p * p * ( 3 * p - 2 );
	},
	Bounce: function( p ) {
		var pow2,
			bounce = 4;

		while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
		return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
	}
});

$.each( baseEasings, function( name, easeIn ) {
	$.easing[ "easeIn" + name ] = easeIn;
	$.easing[ "easeOut" + name ] = function( p ) {
		return 1 - easeIn( 1 - p );
	};
	$.easing[ "easeInOut" + name ] = function( p ) {
		return p < 0.5 ?
			easeIn( p * 2 ) / 2 :
			1 - easeIn( p * -2 + 2 ) / 2;
	};
});

})();

var effect = $.effects;


/*!
 * jQuery UI Effects Blind 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/blind-effect/
 */


var effectBlind = $.effects.effect.blind = function( o, done ) {
	// Create element
	var el = $( this ),
		rvertical = /up|down|vertical/,
		rpositivemotion = /up|left|vertical|horizontal/,
		props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
		mode = $.effects.setMode( el, o.mode || "hide" ),
		direction = o.direction || "up",
		vertical = rvertical.test( direction ),
		ref = vertical ? "height" : "width",
		ref2 = vertical ? "top" : "left",
		motion = rpositivemotion.test( direction ),
		animation = {},
		show = mode === "show",
		wrapper, distance, margin;

	// if already wrapped, the wrapper's properties are my property. #6245
	if ( el.parent().is( ".ui-effects-wrapper" ) ) {
		$.effects.save( el.parent(), props );
	} else {
		$.effects.save( el, props );
	}
	el.show();
	wrapper = $.effects.createWrapper( el ).css({
		overflow: "hidden"
	});

	distance = wrapper[ ref ]();
	margin = parseFloat( wrapper.css( ref2 ) ) || 0;

	animation[ ref ] = show ? distance : 0;
	if ( !motion ) {
		el
			.css( vertical ? "bottom" : "right", 0 )
			.css( vertical ? "top" : "left", "auto" )
			.css({ position: "absolute" });

		animation[ ref2 ] = show ? margin : distance + margin;
	}

	// start at 0 if we are showing
	if ( show ) {
		wrapper.css( ref, 0 );
		if ( !motion ) {
			wrapper.css( ref2, margin + distance );
		}
	}

	// Animate
	wrapper.animate( animation, {
		duration: o.duration,
		easing: o.easing,
		queue: false,
		complete: function() {
			if ( mode === "hide" ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		}
	});
};


/*!
 * jQuery UI Effects Bounce 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/bounce-effect/
 */


var effectBounce = $.effects.effect.bounce = function( o, done ) {
	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "height", "width" ],

		// defaults:
		mode = $.effects.setMode( el, o.mode || "effect" ),
		hide = mode === "hide",
		show = mode === "show",
		direction = o.direction || "up",
		distance = o.distance,
		times = o.times || 5,

		// number of internal animations
		anims = times * 2 + ( show || hide ? 1 : 0 ),
		speed = o.duration / anims,
		easing = o.easing,

		// utility:
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ),
		i,
		upAnim,
		downAnim,

		// we will need to re-assemble the queue to stack our animations in place
		queue = el.queue(),
		queuelen = queue.length;

	// Avoid touching opacity to prevent clearType and PNG issues in IE
	if ( show || hide ) {
		props.push( "opacity" );
	}

	$.effects.save( el, props );
	el.show();
	$.effects.createWrapper( el ); // Create Wrapper

	// default distance for the BIGGEST bounce is the outer Distance / 3
	if ( !distance ) {
		distance = el[ ref === "top" ? "outerHeight" : "outerWidth" ]() / 3;
	}

	if ( show ) {
		downAnim = { opacity: 1 };
		downAnim[ ref ] = 0;

		// if we are showing, force opacity 0 and set the initial position
		// then do the "first" animation
		el.css( "opacity", 0 )
			.css( ref, motion ? -distance * 2 : distance * 2 )
			.animate( downAnim, speed, easing );
	}

	// start at the smallest distance if we are hiding
	if ( hide ) {
		distance = distance / Math.pow( 2, times - 1 );
	}

	downAnim = {};
	downAnim[ ref ] = 0;
	// Bounces up/down/left/right then back to 0 -- times * 2 animations happen here
	for ( i = 0; i < times; i++ ) {
		upAnim = {};
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		el.animate( upAnim, speed, easing )
			.animate( downAnim, speed, easing );

		distance = hide ? distance * 2 : distance / 2;
	}

	// Last Bounce when Hiding
	if ( hide ) {
		upAnim = { opacity: 0 };
		upAnim[ ref ] = ( motion ? "-=" : "+=" ) + distance;

		el.animate( upAnim, speed, easing );
	}

	el.queue(function() {
		if ( hide ) {
			el.hide();
		}
		$.effects.restore( el, props );
		$.effects.removeWrapper( el );
		done();
	});

	// inject all the animations we just queued to be first in line (after "inprogress")
	if ( queuelen > 1) {
		queue.splice.apply( queue,
			[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
	}
	el.dequeue();

};


/*!
 * jQuery UI Effects Clip 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/clip-effect/
 */


var effectClip = $.effects.effect.clip = function( o, done ) {
	// Create element
	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
		mode = $.effects.setMode( el, o.mode || "hide" ),
		show = mode === "show",
		direction = o.direction || "vertical",
		vert = direction === "vertical",
		size = vert ? "height" : "width",
		position = vert ? "top" : "left",
		animation = {},
		wrapper, animate, distance;

	// Save & Show
	$.effects.save( el, props );
	el.show();

	// Create Wrapper
	wrapper = $.effects.createWrapper( el ).css({
		overflow: "hidden"
	});
	animate = ( el[0].tagName === "IMG" ) ? wrapper : el;
	distance = animate[ size ]();

	// Shift
	if ( show ) {
		animate.css( size, 0 );
		animate.css( position, distance / 2 );
	}

	// Create Animation Object:
	animation[ size ] = show ? distance : 0;
	animation[ position ] = show ? 0 : distance / 2;

	// Animate
	animate.animate( animation, {
		queue: false,
		duration: o.duration,
		easing: o.easing,
		complete: function() {
			if ( !show ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		}
	});

};


/*!
 * jQuery UI Effects Drop 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/drop-effect/
 */


var effectDrop = $.effects.effect.drop = function( o, done ) {

	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "opacity", "height", "width" ],
		mode = $.effects.setMode( el, o.mode || "hide" ),
		show = mode === "show",
		direction = o.direction || "left",
		ref = ( direction === "up" || direction === "down" ) ? "top" : "left",
		motion = ( direction === "up" || direction === "left" ) ? "pos" : "neg",
		animation = {
			opacity: show ? 1 : 0
		},
		distance;

	// Adjust
	$.effects.save( el, props );
	el.show();
	$.effects.createWrapper( el );

	distance = o.distance || el[ ref === "top" ? "outerHeight" : "outerWidth" ]( true ) / 2;

	if ( show ) {
		el
			.css( "opacity", 0 )
			.css( ref, motion === "pos" ? -distance : distance );
	}

	// Animation
	animation[ ref ] = ( show ?
		( motion === "pos" ? "+=" : "-=" ) :
		( motion === "pos" ? "-=" : "+=" ) ) +
		distance;

	// Animate
	el.animate( animation, {
		queue: false,
		duration: o.duration,
		easing: o.easing,
		complete: function() {
			if ( mode === "hide" ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		}
	});
};


/*!
 * jQuery UI Effects Explode 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/explode-effect/
 */


var effectExplode = $.effects.effect.explode = function( o, done ) {

	var rows = o.pieces ? Math.round( Math.sqrt( o.pieces ) ) : 3,
		cells = rows,
		el = $( this ),
		mode = $.effects.setMode( el, o.mode || "hide" ),
		show = mode === "show",

		// show and then visibility:hidden the element before calculating offset
		offset = el.show().css( "visibility", "hidden" ).offset(),

		// width and height of a piece
		width = Math.ceil( el.outerWidth() / cells ),
		height = Math.ceil( el.outerHeight() / rows ),
		pieces = [],

		// loop
		i, j, left, top, mx, my;

	// children animate complete:
	function childComplete() {
		pieces.push( this );
		if ( pieces.length === rows * cells ) {
			animComplete();
		}
	}

	// clone the element for each row and cell.
	for ( i = 0; i < rows ; i++ ) { // ===>
		top = offset.top + i * height;
		my = i - ( rows - 1 ) / 2 ;

		for ( j = 0; j < cells ; j++ ) { // |||
			left = offset.left + j * width;
			mx = j - ( cells - 1 ) / 2 ;

			// Create a clone of the now hidden main element that will be absolute positioned
			// within a wrapper div off the -left and -top equal to size of our pieces
			el
				.clone()
				.appendTo( "body" )
				.wrap( "<div></div>" )
				.css({
					position: "absolute",
					visibility: "visible",
					left: -j * width,
					top: -i * height
				})

			// select the wrapper - make it overflow: hidden and absolute positioned based on
			// where the original was located +left and +top equal to the size of pieces
				.parent()
				.addClass( "ui-effects-explode" )
				.css({
					position: "absolute",
					overflow: "hidden",
					width: width,
					height: height,
					left: left + ( show ? mx * width : 0 ),
					top: top + ( show ? my * height : 0 ),
					opacity: show ? 0 : 1
				}).animate({
					left: left + ( show ? 0 : mx * width ),
					top: top + ( show ? 0 : my * height ),
					opacity: show ? 1 : 0
				}, o.duration || 500, o.easing, childComplete );
		}
	}

	function animComplete() {
		el.css({
			visibility: "visible"
		});
		$( pieces ).remove();
		if ( !show ) {
			el.hide();
		}
		done();
	}
};


/*!
 * jQuery UI Effects Fade 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/fade-effect/
 */


var effectFade = $.effects.effect.fade = function( o, done ) {
	var el = $( this ),
		mode = $.effects.setMode( el, o.mode || "toggle" );

	el.animate({
		opacity: mode
	}, {
		queue: false,
		duration: o.duration,
		easing: o.easing,
		complete: done
	});
};


/*!
 * jQuery UI Effects Fold 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/fold-effect/
 */


var effectFold = $.effects.effect.fold = function( o, done ) {

	// Create element
	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
		mode = $.effects.setMode( el, o.mode || "hide" ),
		show = mode === "show",
		hide = mode === "hide",
		size = o.size || 15,
		percent = /([0-9]+)%/.exec( size ),
		horizFirst = !!o.horizFirst,
		widthFirst = show !== horizFirst,
		ref = widthFirst ? [ "width", "height" ] : [ "height", "width" ],
		duration = o.duration / 2,
		wrapper, distance,
		animation1 = {},
		animation2 = {};

	$.effects.save( el, props );
	el.show();

	// Create Wrapper
	wrapper = $.effects.createWrapper( el ).css({
		overflow: "hidden"
	});
	distance = widthFirst ?
		[ wrapper.width(), wrapper.height() ] :
		[ wrapper.height(), wrapper.width() ];

	if ( percent ) {
		size = parseInt( percent[ 1 ], 10 ) / 100 * distance[ hide ? 0 : 1 ];
	}
	if ( show ) {
		wrapper.css( horizFirst ? {
			height: 0,
			width: size
		} : {
			height: size,
			width: 0
		});
	}

	// Animation
	animation1[ ref[ 0 ] ] = show ? distance[ 0 ] : size;
	animation2[ ref[ 1 ] ] = show ? distance[ 1 ] : 0;

	// Animate
	wrapper
		.animate( animation1, duration, o.easing )
		.animate( animation2, duration, o.easing, function() {
			if ( hide ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		});

};


/*!
 * jQuery UI Effects Highlight 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/highlight-effect/
 */


var effectHighlight = $.effects.effect.highlight = function( o, done ) {
	var elem = $( this ),
		props = [ "backgroundImage", "backgroundColor", "opacity" ],
		mode = $.effects.setMode( elem, o.mode || "show" ),
		animation = {
			backgroundColor: elem.css( "backgroundColor" )
		};

	if (mode === "hide") {
		animation.opacity = 0;
	}

	$.effects.save( elem, props );

	elem
		.show()
		.css({
			backgroundImage: "none",
			backgroundColor: o.color || "#ffff99"
		})
		.animate( animation, {
			queue: false,
			duration: o.duration,
			easing: o.easing,
			complete: function() {
				if ( mode === "hide" ) {
					elem.hide();
				}
				$.effects.restore( elem, props );
				done();
			}
		});
};


/*!
 * jQuery UI Effects Size 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/size-effect/
 */


var effectSize = $.effects.effect.size = function( o, done ) {

	// Create element
	var original, baseline, factor,
		el = $( this ),
		props0 = [ "position", "top", "bottom", "left", "right", "width", "height", "overflow", "opacity" ],

		// Always restore
		props1 = [ "position", "top", "bottom", "left", "right", "overflow", "opacity" ],

		// Copy for children
		props2 = [ "width", "height", "overflow" ],
		cProps = [ "fontSize" ],
		vProps = [ "borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom" ],
		hProps = [ "borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight" ],

		// Set options
		mode = $.effects.setMode( el, o.mode || "effect" ),
		restore = o.restore || mode !== "effect",
		scale = o.scale || "both",
		origin = o.origin || [ "middle", "center" ],
		position = el.css( "position" ),
		props = restore ? props0 : props1,
		zero = {
			height: 0,
			width: 0,
			outerHeight: 0,
			outerWidth: 0
		};

	if ( mode === "show" ) {
		el.show();
	}
	original = {
		height: el.height(),
		width: el.width(),
		outerHeight: el.outerHeight(),
		outerWidth: el.outerWidth()
	};

	if ( o.mode === "toggle" && mode === "show" ) {
		el.from = o.to || zero;
		el.to = o.from || original;
	} else {
		el.from = o.from || ( mode === "show" ? zero : original );
		el.to = o.to || ( mode === "hide" ? zero : original );
	}

	// Set scaling factor
	factor = {
		from: {
			y: el.from.height / original.height,
			x: el.from.width / original.width
		},
		to: {
			y: el.to.height / original.height,
			x: el.to.width / original.width
		}
	};

	// Scale the css box
	if ( scale === "box" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			props = props.concat( vProps );
			el.from = $.effects.setTransition( el, vProps, factor.from.y, el.from );
			el.to = $.effects.setTransition( el, vProps, factor.to.y, el.to );
		}

		// Horizontal props scaling
		if ( factor.from.x !== factor.to.x ) {
			props = props.concat( hProps );
			el.from = $.effects.setTransition( el, hProps, factor.from.x, el.from );
			el.to = $.effects.setTransition( el, hProps, factor.to.x, el.to );
		}
	}

	// Scale the content
	if ( scale === "content" || scale === "both" ) {

		// Vertical props scaling
		if ( factor.from.y !== factor.to.y ) {
			props = props.concat( cProps ).concat( props2 );
			el.from = $.effects.setTransition( el, cProps, factor.from.y, el.from );
			el.to = $.effects.setTransition( el, cProps, factor.to.y, el.to );
		}
	}

	$.effects.save( el, props );
	el.show();
	$.effects.createWrapper( el );
	el.css( "overflow", "hidden" ).css( el.from );

	// Adjust
	if (origin) { // Calculate baseline shifts
		baseline = $.effects.getBaseline( origin, original );
		el.from.top = ( original.outerHeight - el.outerHeight() ) * baseline.y;
		el.from.left = ( original.outerWidth - el.outerWidth() ) * baseline.x;
		el.to.top = ( original.outerHeight - el.to.outerHeight ) * baseline.y;
		el.to.left = ( original.outerWidth - el.to.outerWidth ) * baseline.x;
	}
	el.css( el.from ); // set top & left

	// Animate
	if ( scale === "content" || scale === "both" ) { // Scale the children

		// Add margins/font-size
		vProps = vProps.concat([ "marginTop", "marginBottom" ]).concat(cProps);
		hProps = hProps.concat([ "marginLeft", "marginRight" ]);
		props2 = props0.concat(vProps).concat(hProps);

		el.find( "*[width]" ).each( function() {
			var child = $( this ),
				c_original = {
					height: child.height(),
					width: child.width(),
					outerHeight: child.outerHeight(),
					outerWidth: child.outerWidth()
				};
			if (restore) {
				$.effects.save(child, props2);
			}

			child.from = {
				height: c_original.height * factor.from.y,
				width: c_original.width * factor.from.x,
				outerHeight: c_original.outerHeight * factor.from.y,
				outerWidth: c_original.outerWidth * factor.from.x
			};
			child.to = {
				height: c_original.height * factor.to.y,
				width: c_original.width * factor.to.x,
				outerHeight: c_original.height * factor.to.y,
				outerWidth: c_original.width * factor.to.x
			};

			// Vertical props scaling
			if ( factor.from.y !== factor.to.y ) {
				child.from = $.effects.setTransition( child, vProps, factor.from.y, child.from );
				child.to = $.effects.setTransition( child, vProps, factor.to.y, child.to );
			}

			// Horizontal props scaling
			if ( factor.from.x !== factor.to.x ) {
				child.from = $.effects.setTransition( child, hProps, factor.from.x, child.from );
				child.to = $.effects.setTransition( child, hProps, factor.to.x, child.to );
			}

			// Animate children
			child.css( child.from );
			child.animate( child.to, o.duration, o.easing, function() {

				// Restore children
				if ( restore ) {
					$.effects.restore( child, props2 );
				}
			});
		});
	}

	// Animate
	el.animate( el.to, {
		queue: false,
		duration: o.duration,
		easing: o.easing,
		complete: function() {
			if ( el.to.opacity === 0 ) {
				el.css( "opacity", el.from.opacity );
			}
			if ( mode === "hide" ) {
				el.hide();
			}
			$.effects.restore( el, props );
			if ( !restore ) {

				// we need to calculate our new positioning based on the scaling
				if ( position === "static" ) {
					el.css({
						position: "relative",
						top: el.to.top,
						left: el.to.left
					});
				} else {
					$.each([ "top", "left" ], function( idx, pos ) {
						el.css( pos, function( _, str ) {
							var val = parseInt( str, 10 ),
								toRef = idx ? el.to.left : el.to.top;

							// if original was "auto", recalculate the new value from wrapper
							if ( str === "auto" ) {
								return toRef + "px";
							}

							return val + toRef + "px";
						});
					});
				}
			}

			$.effects.removeWrapper( el );
			done();
		}
	});

};


/*!
 * jQuery UI Effects Scale 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/scale-effect/
 */


var effectScale = $.effects.effect.scale = function( o, done ) {

	// Create element
	var el = $( this ),
		options = $.extend( true, {}, o ),
		mode = $.effects.setMode( el, o.mode || "effect" ),
		percent = parseInt( o.percent, 10 ) ||
			( parseInt( o.percent, 10 ) === 0 ? 0 : ( mode === "hide" ? 0 : 100 ) ),
		direction = o.direction || "both",
		origin = o.origin,
		original = {
			height: el.height(),
			width: el.width(),
			outerHeight: el.outerHeight(),
			outerWidth: el.outerWidth()
		},
		factor = {
			y: direction !== "horizontal" ? (percent / 100) : 1,
			x: direction !== "vertical" ? (percent / 100) : 1
		};

	// We are going to pass this effect to the size effect:
	options.effect = "size";
	options.queue = false;
	options.complete = done;

	// Set default origin and restore for show/hide
	if ( mode !== "effect" ) {
		options.origin = origin || [ "middle", "center" ];
		options.restore = true;
	}

	options.from = o.from || ( mode === "show" ? {
		height: 0,
		width: 0,
		outerHeight: 0,
		outerWidth: 0
	} : original );
	options.to = {
		height: original.height * factor.y,
		width: original.width * factor.x,
		outerHeight: original.outerHeight * factor.y,
		outerWidth: original.outerWidth * factor.x
	};

	// Fade option to support puff
	if ( options.fade ) {
		if ( mode === "show" ) {
			options.from.opacity = 0;
			options.to.opacity = 1;
		}
		if ( mode === "hide" ) {
			options.from.opacity = 1;
			options.to.opacity = 0;
		}
	}

	// Animate
	el.effect( options );

};


/*!
 * jQuery UI Effects Puff 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/puff-effect/
 */


var effectPuff = $.effects.effect.puff = function( o, done ) {
	var elem = $( this ),
		mode = $.effects.setMode( elem, o.mode || "hide" ),
		hide = mode === "hide",
		percent = parseInt( o.percent, 10 ) || 150,
		factor = percent / 100,
		original = {
			height: elem.height(),
			width: elem.width(),
			outerHeight: elem.outerHeight(),
			outerWidth: elem.outerWidth()
		};

	$.extend( o, {
		effect: "scale",
		queue: false,
		fade: true,
		mode: mode,
		complete: done,
		percent: hide ? percent : 100,
		from: hide ?
			original :
			{
				height: original.height * factor,
				width: original.width * factor,
				outerHeight: original.outerHeight * factor,
				outerWidth: original.outerWidth * factor
			}
	});

	elem.effect( o );
};


/*!
 * jQuery UI Effects Pulsate 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/pulsate-effect/
 */


var effectPulsate = $.effects.effect.pulsate = function( o, done ) {
	var elem = $( this ),
		mode = $.effects.setMode( elem, o.mode || "show" ),
		show = mode === "show",
		hide = mode === "hide",
		showhide = ( show || mode === "hide" ),

		// showing or hiding leaves of the "last" animation
		anims = ( ( o.times || 5 ) * 2 ) + ( showhide ? 1 : 0 ),
		duration = o.duration / anims,
		animateTo = 0,
		queue = elem.queue(),
		queuelen = queue.length,
		i;

	if ( show || !elem.is(":visible")) {
		elem.css( "opacity", 0 ).show();
		animateTo = 1;
	}

	// anims - 1 opacity "toggles"
	for ( i = 1; i < anims; i++ ) {
		elem.animate({
			opacity: animateTo
		}, duration, o.easing );
		animateTo = 1 - animateTo;
	}

	elem.animate({
		opacity: animateTo
	}, duration, o.easing);

	elem.queue(function() {
		if ( hide ) {
			elem.hide();
		}
		done();
	});

	// We just queued up "anims" animations, we need to put them next in the queue
	if ( queuelen > 1 ) {
		queue.splice.apply( queue,
			[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
	}
	elem.dequeue();
};


/*!
 * jQuery UI Effects Shake 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/shake-effect/
 */


var effectShake = $.effects.effect.shake = function( o, done ) {

	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "height", "width" ],
		mode = $.effects.setMode( el, o.mode || "effect" ),
		direction = o.direction || "left",
		distance = o.distance || 20,
		times = o.times || 3,
		anims = times * 2 + 1,
		speed = Math.round( o.duration / anims ),
		ref = (direction === "up" || direction === "down") ? "top" : "left",
		positiveMotion = (direction === "up" || direction === "left"),
		animation = {},
		animation1 = {},
		animation2 = {},
		i,

		// we will need to re-assemble the queue to stack our animations in place
		queue = el.queue(),
		queuelen = queue.length;

	$.effects.save( el, props );
	el.show();
	$.effects.createWrapper( el );

	// Animation
	animation[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance;
	animation1[ ref ] = ( positiveMotion ? "+=" : "-=" ) + distance * 2;
	animation2[ ref ] = ( positiveMotion ? "-=" : "+=" ) + distance * 2;

	// Animate
	el.animate( animation, speed, o.easing );

	// Shakes
	for ( i = 1; i < times; i++ ) {
		el.animate( animation1, speed, o.easing ).animate( animation2, speed, o.easing );
	}
	el
		.animate( animation1, speed, o.easing )
		.animate( animation, speed / 2, o.easing )
		.queue(function() {
			if ( mode === "hide" ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		});

	// inject all the animations we just queued to be first in line (after "inprogress")
	if ( queuelen > 1) {
		queue.splice.apply( queue,
			[ 1, 0 ].concat( queue.splice( queuelen, anims + 1 ) ) );
	}
	el.dequeue();

};


/*!
 * jQuery UI Effects Slide 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slide-effect/
 */


var effectSlide = $.effects.effect.slide = function( o, done ) {

	// Create element
	var el = $( this ),
		props = [ "position", "top", "bottom", "left", "right", "width", "height" ],
		mode = $.effects.setMode( el, o.mode || "show" ),
		show = mode === "show",
		direction = o.direction || "left",
		ref = (direction === "up" || direction === "down") ? "top" : "left",
		positiveMotion = (direction === "up" || direction === "left"),
		distance,
		animation = {};

	// Adjust
	$.effects.save( el, props );
	el.show();
	distance = o.distance || el[ ref === "top" ? "outerHeight" : "outerWidth" ]( true );

	$.effects.createWrapper( el ).css({
		overflow: "hidden"
	});

	if ( show ) {
		el.css( ref, positiveMotion ? (isNaN(distance) ? "-" + distance : -distance) : distance );
	}

	// Animation
	animation[ ref ] = ( show ?
		( positiveMotion ? "+=" : "-=") :
		( positiveMotion ? "-=" : "+=")) +
		distance;

	// Animate
	el.animate( animation, {
		queue: false,
		duration: o.duration,
		easing: o.easing,
		complete: function() {
			if ( mode === "hide" ) {
				el.hide();
			}
			$.effects.restore( el, props );
			$.effects.removeWrapper( el );
			done();
		}
	});
};


/*!
 * jQuery UI Effects Transfer 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/transfer-effect/
 */


var effectTransfer = $.effects.effect.transfer = function( o, done ) {
	var elem = $( this ),
		target = $( o.to ),
		targetFixed = target.css( "position" ) === "fixed",
		body = $("body"),
		fixTop = targetFixed ? body.scrollTop() : 0,
		fixLeft = targetFixed ? body.scrollLeft() : 0,
		endPosition = target.offset(),
		animation = {
			top: endPosition.top - fixTop,
			left: endPosition.left - fixLeft,
			height: target.innerHeight(),
			width: target.innerWidth()
		},
		startPosition = elem.offset(),
		transfer = $( "<div class='ui-effects-transfer'></div>" )
			.appendTo( document.body )
			.addClass( o.className )
			.css({
				top: startPosition.top - fixTop,
				left: startPosition.left - fixLeft,
				height: elem.innerHeight(),
				width: elem.innerWidth(),
				position: targetFixed ? "fixed" : "absolute"
			})
			.animate( animation, o.duration, o.easing, function() {
				transfer.remove();
				done();
			});
};


/*!
 * jQuery UI Progressbar 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/progressbar/
 */


var progressbar = $.widget( "ui.progressbar", {
	version: "1.11.4",
	options: {
		max: 100,
		value: 0,

		change: null,
		complete: null
	},

	min: 0,

	_create: function() {
		// Constrain initial value
		this.oldValue = this.options.value = this._constrainedValue();

		this.element
			.addClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
			.attr({
				// Only set static values, aria-valuenow and aria-valuemax are
				// set inside _refreshValue()
				role: "progressbar",
				"aria-valuemin": this.min
			});

		this.valueDiv = $( "<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>" )
			.appendTo( this.element );

		this._refreshValue();
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-progressbar ui-widget ui-widget-content ui-corner-all" )
			.removeAttr( "role" )
			.removeAttr( "aria-valuemin" )
			.removeAttr( "aria-valuemax" )
			.removeAttr( "aria-valuenow" );

		this.valueDiv.remove();
	},

	value: function( newValue ) {
		if ( newValue === undefined ) {
			return this.options.value;
		}

		this.options.value = this._constrainedValue( newValue );
		this._refreshValue();
	},

	_constrainedValue: function( newValue ) {
		if ( newValue === undefined ) {
			newValue = this.options.value;
		}

		this.indeterminate = newValue === false;

		// sanitize value
		if ( typeof newValue !== "number" ) {
			newValue = 0;
		}

		return this.indeterminate ? false :
			Math.min( this.options.max, Math.max( this.min, newValue ) );
	},

	_setOptions: function( options ) {
		// Ensure "value" option is set after other values (like max)
		var value = options.value;
		delete options.value;

		this._super( options );

		this.options.value = this._constrainedValue( value );
		this._refreshValue();
	},

	_setOption: function( key, value ) {
		if ( key === "max" ) {
			// Don't allow a max less than min
			value = Math.max( this.min, value );
		}
		if ( key === "disabled" ) {
			this.element
				.toggleClass( "ui-state-disabled", !!value )
				.attr( "aria-disabled", value );
		}
		this._super( key, value );
	},

	_percentage: function() {
		return this.indeterminate ? 100 : 100 * ( this.options.value - this.min ) / ( this.options.max - this.min );
	},

	_refreshValue: function() {
		var value = this.options.value,
			percentage = this._percentage();

		this.valueDiv
			.toggle( this.indeterminate || value > this.min )
			.toggleClass( "ui-corner-right", value === this.options.max )
			.width( percentage.toFixed(0) + "%" );

		this.element.toggleClass( "ui-progressbar-indeterminate", this.indeterminate );

		if ( this.indeterminate ) {
			this.element.removeAttr( "aria-valuenow" );
			if ( !this.overlayDiv ) {
				this.overlayDiv = $( "<div class='ui-progressbar-overlay'></div>" ).appendTo( this.valueDiv );
			}
		} else {
			this.element.attr({
				"aria-valuemax": this.options.max,
				"aria-valuenow": value
			});
			if ( this.overlayDiv ) {
				this.overlayDiv.remove();
				this.overlayDiv = null;
			}
		}

		if ( this.oldValue !== value ) {
			this.oldValue = value;
			this._trigger( "change" );
		}
		if ( value === this.options.max ) {
			this._trigger( "complete" );
		}
	}
});


/*!
 * jQuery UI Selectable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/selectable/
 */


var selectable = $.widget("ui.selectable", $.ui.mouse, {
	version: "1.11.4",
	options: {
		appendTo: "body",
		autoRefresh: true,
		distance: 0,
		filter: "*",
		tolerance: "touch",

		// callbacks
		selected: null,
		selecting: null,
		start: null,
		stop: null,
		unselected: null,
		unselecting: null
	},
	_create: function() {
		var selectees,
			that = this;

		this.element.addClass("ui-selectable");

		this.dragged = false;

		// cache selectee children based on filter
		this.refresh = function() {
			selectees = $(that.options.filter, that.element[0]);
			selectees.addClass("ui-selectee");
			selectees.each(function() {
				var $this = $(this),
					pos = $this.offset();
				$.data(this, "selectable-item", {
					element: this,
					$element: $this,
					left: pos.left,
					top: pos.top,
					right: pos.left + $this.outerWidth(),
					bottom: pos.top + $this.outerHeight(),
					startselected: false,
					selected: $this.hasClass("ui-selected"),
					selecting: $this.hasClass("ui-selecting"),
					unselecting: $this.hasClass("ui-unselecting")
				});
			});
		};
		this.refresh();

		this.selectees = selectees.addClass("ui-selectee");

		this._mouseInit();

		this.helper = $("<div class='ui-selectable-helper'></div>");
	},

	_destroy: function() {
		this.selectees
			.removeClass("ui-selectee")
			.removeData("selectable-item");
		this.element
			.removeClass("ui-selectable ui-selectable-disabled");
		this._mouseDestroy();
	},

	_mouseStart: function(event) {
		var that = this,
			options = this.options;

		this.opos = [ event.pageX, event.pageY ];

		if (this.options.disabled) {
			return;
		}

		this.selectees = $(options.filter, this.element[0]);

		this._trigger("start", event);

		$(options.appendTo).append(this.helper);
		// position helper (lasso)
		this.helper.css({
			"left": event.pageX,
			"top": event.pageY,
			"width": 0,
			"height": 0
		});

		if (options.autoRefresh) {
			this.refresh();
		}

		this.selectees.filter(".ui-selected").each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.startselected = true;
			if (!event.metaKey && !event.ctrlKey) {
				selectee.$element.removeClass("ui-selected");
				selectee.selected = false;
				selectee.$element.addClass("ui-unselecting");
				selectee.unselecting = true;
				// selectable UNSELECTING callback
				that._trigger("unselecting", event, {
					unselecting: selectee.element
				});
			}
		});

		$(event.target).parents().addBack().each(function() {
			var doSelect,
				selectee = $.data(this, "selectable-item");
			if (selectee) {
				doSelect = (!event.metaKey && !event.ctrlKey) || !selectee.$element.hasClass("ui-selected");
				selectee.$element
					.removeClass(doSelect ? "ui-unselecting" : "ui-selected")
					.addClass(doSelect ? "ui-selecting" : "ui-unselecting");
				selectee.unselecting = !doSelect;
				selectee.selecting = doSelect;
				selectee.selected = doSelect;
				// selectable (UN)SELECTING callback
				if (doSelect) {
					that._trigger("selecting", event, {
						selecting: selectee.element
					});
				} else {
					that._trigger("unselecting", event, {
						unselecting: selectee.element
					});
				}
				return false;
			}
		});

	},

	_mouseDrag: function(event) {

		this.dragged = true;

		if (this.options.disabled) {
			return;
		}

		var tmp,
			that = this,
			options = this.options,
			x1 = this.opos[0],
			y1 = this.opos[1],
			x2 = event.pageX,
			y2 = event.pageY;

		if (x1 > x2) { tmp = x2; x2 = x1; x1 = tmp; }
		if (y1 > y2) { tmp = y2; y2 = y1; y1 = tmp; }
		this.helper.css({ left: x1, top: y1, width: x2 - x1, height: y2 - y1 });

		this.selectees.each(function() {
			var selectee = $.data(this, "selectable-item"),
				hit = false;

			//prevent helper from being selected if appendTo: selectable
			if (!selectee || selectee.element === that.element[0]) {
				return;
			}

			if (options.tolerance === "touch") {
				hit = ( !(selectee.left > x2 || selectee.right < x1 || selectee.top > y2 || selectee.bottom < y1) );
			} else if (options.tolerance === "fit") {
				hit = (selectee.left > x1 && selectee.right < x2 && selectee.top > y1 && selectee.bottom < y2);
			}

			if (hit) {
				// SELECT
				if (selectee.selected) {
					selectee.$element.removeClass("ui-selected");
					selectee.selected = false;
				}
				if (selectee.unselecting) {
					selectee.$element.removeClass("ui-unselecting");
					selectee.unselecting = false;
				}
				if (!selectee.selecting) {
					selectee.$element.addClass("ui-selecting");
					selectee.selecting = true;
					// selectable SELECTING callback
					that._trigger("selecting", event, {
						selecting: selectee.element
					});
				}
			} else {
				// UNSELECT
				if (selectee.selecting) {
					if ((event.metaKey || event.ctrlKey) && selectee.startselected) {
						selectee.$element.removeClass("ui-selecting");
						selectee.selecting = false;
						selectee.$element.addClass("ui-selected");
						selectee.selected = true;
					} else {
						selectee.$element.removeClass("ui-selecting");
						selectee.selecting = false;
						if (selectee.startselected) {
							selectee.$element.addClass("ui-unselecting");
							selectee.unselecting = true;
						}
						// selectable UNSELECTING callback
						that._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
				}
				if (selectee.selected) {
					if (!event.metaKey && !event.ctrlKey && !selectee.startselected) {
						selectee.$element.removeClass("ui-selected");
						selectee.selected = false;

						selectee.$element.addClass("ui-unselecting");
						selectee.unselecting = true;
						// selectable UNSELECTING callback
						that._trigger("unselecting", event, {
							unselecting: selectee.element
						});
					}
				}
			}
		});

		return false;
	},

	_mouseStop: function(event) {
		var that = this;

		this.dragged = false;

		$(".ui-unselecting", this.element[0]).each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.$element.removeClass("ui-unselecting");
			selectee.unselecting = false;
			selectee.startselected = false;
			that._trigger("unselected", event, {
				unselected: selectee.element
			});
		});
		$(".ui-selecting", this.element[0]).each(function() {
			var selectee = $.data(this, "selectable-item");
			selectee.$element.removeClass("ui-selecting").addClass("ui-selected");
			selectee.selecting = false;
			selectee.selected = true;
			selectee.startselected = true;
			that._trigger("selected", event, {
				selected: selectee.element
			});
		});
		this._trigger("stop", event);

		this.helper.remove();

		return false;
	}

});


/*!
 * jQuery UI Selectmenu 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/selectmenu
 */


var selectmenu = $.widget( "ui.selectmenu", {
	version: "1.11.4",
	defaultElement: "<select>",
	options: {
		appendTo: null,
		disabled: null,
		icons: {
			button: "ui-icon-triangle-1-s"
		},
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		width: null,

		// callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		select: null
	},

	_create: function() {
		var selectmenuId = this.element.uniqueId().attr( "id" );
		this.ids = {
			element: selectmenuId,
			button: selectmenuId + "-button",
			menu: selectmenuId + "-menu"
		};

		this._drawButton();
		this._drawMenu();

		if ( this.options.disabled ) {
			this.disable();
		}
	},

	_drawButton: function() {
		var that = this;

		// Associate existing label with the new button
		this.label = $( "label[for='" + this.ids.element + "']" ).attr( "for", this.ids.button );
		this._on( this.label, {
			click: function( event ) {
				this.button.focus();
				event.preventDefault();
			}
		});

		// Hide original select element
		this.element.hide();

		// Create button
		this.button = $( "<span>", {
			"class": "ui-selectmenu-button ui-widget ui-state-default ui-corner-all",
			tabindex: this.options.disabled ? -1 : 0,
			id: this.ids.button,
			role: "combobox",
			"aria-expanded": "false",
			"aria-autocomplete": "list",
			"aria-owns": this.ids.menu,
			"aria-haspopup": "true"
		})
			.insertAfter( this.element );

		$( "<span>", {
			"class": "ui-icon " + this.options.icons.button
		})
			.prependTo( this.button );

		this.buttonText = $( "<span>", {
			"class": "ui-selectmenu-text"
		})
			.appendTo( this.button );

		this._setText( this.buttonText, this.element.find( "option:selected" ).text() );
		this._resizeButton();

		this._on( this.button, this._buttonEvents );
		this.button.one( "focusin", function() {

			// Delay rendering the menu items until the button receives focus.
			// The menu may have already been rendered via a programmatic open.
			if ( !that.menuItems ) {
				that._refreshMenu();
			}
		});
		this._hoverable( this.button );
		this._focusable( this.button );
	},

	_drawMenu: function() {
		var that = this;

		// Create menu
		this.menu = $( "<ul>", {
			"aria-hidden": "true",
			"aria-labelledby": this.ids.button,
			id: this.ids.menu
		});

		// Wrap menu
		this.menuWrap = $( "<div>", {
			"class": "ui-selectmenu-menu ui-front"
		})
			.append( this.menu )
			.appendTo( this._appendTo() );

		// Initialize menu widget
		this.menuInstance = this.menu
			.menu({
				role: "listbox",
				select: function( event, ui ) {
					event.preventDefault();

					// support: IE8
					// If the item was selected via a click, the text selection
					// will be destroyed in IE
					that._setSelection();

					that._select( ui.item.data( "ui-selectmenu-item" ), event );
				},
				focus: function( event, ui ) {
					var item = ui.item.data( "ui-selectmenu-item" );

					// Prevent inital focus from firing and check if its a newly focused item
					if ( that.focusIndex != null && item.index !== that.focusIndex ) {
						that._trigger( "focus", event, { item: item } );
						if ( !that.isOpen ) {
							that._select( item, event );
						}
					}
					that.focusIndex = item.index;

					that.button.attr( "aria-activedescendant",
						that.menuItems.eq( item.index ).attr( "id" ) );
				}
			})
			.menu( "instance" );

		// Adjust menu styles to dropdown
		this.menu
			.addClass( "ui-corner-bottom" )
			.removeClass( "ui-corner-all" );

		// Don't close the menu on mouseleave
		this.menuInstance._off( this.menu, "mouseleave" );

		// Cancel the menu's collapseAll on document click
		this.menuInstance._closeOnDocumentClick = function() {
			return false;
		};

		// Selects often contain empty items, but never contain dividers
		this.menuInstance._isDivider = function() {
			return false;
		};
	},

	refresh: function() {
		this._refreshMenu();
		this._setText( this.buttonText, this._getSelectedItem().text() );
		if ( !this.options.width ) {
			this._resizeButton();
		}
	},

	_refreshMenu: function() {
		this.menu.empty();

		var item,
			options = this.element.find( "option" );

		if ( !options.length ) {
			return;
		}

		this._parseOptions( options );
		this._renderMenu( this.menu, this.items );

		this.menuInstance.refresh();
		this.menuItems = this.menu.find( "li" ).not( ".ui-selectmenu-optgroup" );

		item = this._getSelectedItem();

		// Update the menu to have the correct item focused
		this.menuInstance.focus( null, item );
		this._setAria( item.data( "ui-selectmenu-item" ) );

		// Set disabled state
		this._setOption( "disabled", this.element.prop( "disabled" ) );
	},

	open: function( event ) {
		if ( this.options.disabled ) {
			return;
		}

		// If this is the first time the menu is being opened, render the items
		if ( !this.menuItems ) {
			this._refreshMenu();
		} else {

			// Menu clears focus on close, reset focus to selected item
			this.menu.find( ".ui-state-focus" ).removeClass( "ui-state-focus" );
			this.menuInstance.focus( null, this._getSelectedItem() );
		}

		this.isOpen = true;
		this._toggleAttr();
		this._resizeMenu();
		this._position();

		this._on( this.document, this._documentClick );

		this._trigger( "open", event );
	},

	_position: function() {
		this.menuWrap.position( $.extend( { of: this.button }, this.options.position ) );
	},

	close: function( event ) {
		if ( !this.isOpen ) {
			return;
		}

		this.isOpen = false;
		this._toggleAttr();

		this.range = null;
		this._off( this.document );

		this._trigger( "close", event );
	},

	widget: function() {
		return this.button;
	},

	menuWidget: function() {
		return this.menu;
	},

	_renderMenu: function( ul, items ) {
		var that = this,
			currentOptgroup = "";

		$.each( items, function( index, item ) {
			if ( item.optgroup !== currentOptgroup ) {
				$( "<li>", {
					"class": "ui-selectmenu-optgroup ui-menu-divider" +
						( item.element.parent( "optgroup" ).prop( "disabled" ) ?
							" ui-state-disabled" :
							"" ),
					text: item.optgroup
				})
					.appendTo( ul );

				currentOptgroup = item.optgroup;
			}

			that._renderItemData( ul, item );
		});
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-selectmenu-item", item );
	},

	_renderItem: function( ul, item ) {
		var li = $( "<li>" );

		if ( item.disabled ) {
			li.addClass( "ui-state-disabled" );
		}
		this._setText( li, item.label );

		return li.appendTo( ul );
	},

	_setText: function( element, value ) {
		if ( value ) {
			element.text( value );
		} else {
			element.html( "&#160;" );
		}
	},

	_move: function( direction, event ) {
		var item, next,
			filter = ".ui-menu-item";

		if ( this.isOpen ) {
			item = this.menuItems.eq( this.focusIndex );
		} else {
			item = this.menuItems.eq( this.element[ 0 ].selectedIndex );
			filter += ":not(.ui-state-disabled)";
		}

		if ( direction === "first" || direction === "last" ) {
			next = item[ direction === "first" ? "prevAll" : "nextAll" ]( filter ).eq( -1 );
		} else {
			next = item[ direction + "All" ]( filter ).eq( 0 );
		}

		if ( next.length ) {
			this.menuInstance.focus( event, next );
		}
	},

	_getSelectedItem: function() {
		return this.menuItems.eq( this.element[ 0 ].selectedIndex );
	},

	_toggle: function( event ) {
		this[ this.isOpen ? "close" : "open" ]( event );
	},

	_setSelection: function() {
		var selection;

		if ( !this.range ) {
			return;
		}

		if ( window.getSelection ) {
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange( this.range );

		// support: IE8
		} else {
			this.range.select();
		}

		// support: IE
		// Setting the text selection kills the button focus in IE, but
		// restoring the focus doesn't kill the selection.
		this.button.focus();
	},

	_documentClick: {
		mousedown: function( event ) {
			if ( !this.isOpen ) {
				return;
			}

			if ( !$( event.target ).closest( ".ui-selectmenu-menu, #" + this.ids.button ).length ) {
				this.close( event );
			}
		}
	},

	_buttonEvents: {

		// Prevent text selection from being reset when interacting with the selectmenu (#10144)
		mousedown: function() {
			var selection;

			if ( window.getSelection ) {
				selection = window.getSelection();
				if ( selection.rangeCount ) {
					this.range = selection.getRangeAt( 0 );
				}

			// support: IE8
			} else {
				this.range = document.selection.createRange();
			}
		},

		click: function( event ) {
			this._setSelection();
			this._toggle( event );
		},

		keydown: function( event ) {
			var preventDefault = true;
			switch ( event.keyCode ) {
				case $.ui.keyCode.TAB:
				case $.ui.keyCode.ESCAPE:
					this.close( event );
					preventDefault = false;
					break;
				case $.ui.keyCode.ENTER:
					if ( this.isOpen ) {
						this._selectFocusedItem( event );
					}
					break;
				case $.ui.keyCode.UP:
					if ( event.altKey ) {
						this._toggle( event );
					} else {
						this._move( "prev", event );
					}
					break;
				case $.ui.keyCode.DOWN:
					if ( event.altKey ) {
						this._toggle( event );
					} else {
						this._move( "next", event );
					}
					break;
				case $.ui.keyCode.SPACE:
					if ( this.isOpen ) {
						this._selectFocusedItem( event );
					} else {
						this._toggle( event );
					}
					break;
				case $.ui.keyCode.LEFT:
					this._move( "prev", event );
					break;
				case $.ui.keyCode.RIGHT:
					this._move( "next", event );
					break;
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.PAGE_UP:
					this._move( "first", event );
					break;
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_DOWN:
					this._move( "last", event );
					break;
				default:
					this.menu.trigger( event );
					preventDefault = false;
			}

			if ( preventDefault ) {
				event.preventDefault();
			}
		}
	},

	_selectFocusedItem: function( event ) {
		var item = this.menuItems.eq( this.focusIndex );
		if ( !item.hasClass( "ui-state-disabled" ) ) {
			this._select( item.data( "ui-selectmenu-item" ), event );
		}
	},

	_select: function( item, event ) {
		var oldIndex = this.element[ 0 ].selectedIndex;

		// Change native select element
		this.element[ 0 ].selectedIndex = item.index;
		this._setText( this.buttonText, item.label );
		this._setAria( item );
		this._trigger( "select", event, { item: item } );

		if ( item.index !== oldIndex ) {
			this._trigger( "change", event, { item: item } );
		}

		this.close( event );
	},

	_setAria: function( item ) {
		var id = this.menuItems.eq( item.index ).attr( "id" );

		this.button.attr({
			"aria-labelledby": id,
			"aria-activedescendant": id
		});
		this.menu.attr( "aria-activedescendant", id );
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			this.button.find( "span.ui-icon" )
				.removeClass( this.options.icons.button )
				.addClass( value.button );
		}

		this._super( key, value );

		if ( key === "appendTo" ) {
			this.menuWrap.appendTo( this._appendTo() );
		}

		if ( key === "disabled" ) {
			this.menuInstance.option( "disabled", value );
			this.button
				.toggleClass( "ui-state-disabled", value )
				.attr( "aria-disabled", value );

			this.element.prop( "disabled", value );
			if ( value ) {
				this.button.attr( "tabindex", -1 );
				this.close();
			} else {
				this.button.attr( "tabindex", 0 );
			}
		}

		if ( key === "width" ) {
			this._resizeButton();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_toggleAttr: function() {
		this.button
			.toggleClass( "ui-corner-top", this.isOpen )
			.toggleClass( "ui-corner-all", !this.isOpen )
			.attr( "aria-expanded", this.isOpen );
		this.menuWrap.toggleClass( "ui-selectmenu-open", this.isOpen );
		this.menu.attr( "aria-hidden", !this.isOpen );
	},

	_resizeButton: function() {
		var width = this.options.width;

		if ( !width ) {
			width = this.element.show().outerWidth();
			this.element.hide();
		}

		this.button.outerWidth( width );
	},

	_resizeMenu: function() {
		this.menu.outerWidth( Math.max(
			this.button.outerWidth(),

			// support: IE10
			// IE10 wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping
			this.menu.width( "" ).outerWidth() + 1
		) );
	},

	_getCreateOptions: function() {
		return { disabled: this.element.prop( "disabled" ) };
	},

	_parseOptions: function( options ) {
		var data = [];
		options.each(function( index, item ) {
			var option = $( item ),
				optgroup = option.parent( "optgroup" );
			data.push({
				element: option,
				index: index,
				value: option.val(),
				label: option.text(),
				optgroup: optgroup.attr( "label" ) || "",
				disabled: optgroup.prop( "disabled" ) || option.prop( "disabled" )
			});
		});
		this.items = data;
	},

	_destroy: function() {
		this.menuWrap.remove();
		this.button.remove();
		this.element.show();
		this.element.removeUniqueId();
		this.label.attr( "for", this.ids.element );
	}
});


/*!
 * jQuery UI Slider 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/
 */


var slider = $.widget( "ui.slider", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "slide",

	options: {
		animate: false,
		distance: 0,
		max: 100,
		min: 0,
		orientation: "horizontal",
		range: false,
		step: 1,
		value: 0,
		values: null,

		// callbacks
		change: null,
		slide: null,
		start: null,
		stop: null
	},

	// number of pages in a slider
	// (how many times can you page up/down to go through the whole range)
	numPages: 5,

	_create: function() {
		this._keySliding = false;
		this._mouseSliding = false;
		this._animateOff = true;
		this._handleIndex = null;
		this._detectOrientation();
		this._mouseInit();
		this._calculateNewMax();

		this.element
			.addClass( "ui-slider" +
				" ui-slider-" + this.orientation +
				" ui-widget" +
				" ui-widget-content" +
				" ui-corner-all");

		this._refresh();
		this._setOption( "disabled", this.options.disabled );

		this._animateOff = false;
	},

	_refresh: function() {
		this._createRange();
		this._createHandles();
		this._setupEvents();
		this._refreshValue();
	},

	_createHandles: function() {
		var i, handleCount,
			options = this.options,
			existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
			handle = "<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>",
			handles = [];

		handleCount = ( options.values && options.values.length ) || 1;

		if ( existingHandles.length > handleCount ) {
			existingHandles.slice( handleCount ).remove();
			existingHandles = existingHandles.slice( 0, handleCount );
		}

		for ( i = existingHandles.length; i < handleCount; i++ ) {
			handles.push( handle );
		}

		this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

		this.handle = this.handles.eq( 0 );

		this.handles.each(function( i ) {
			$( this ).data( "ui-slider-handle-index", i );
		});
	},

	_createRange: function() {
		var options = this.options,
			classes = "";

		if ( options.range ) {
			if ( options.range === true ) {
				if ( !options.values ) {
					options.values = [ this._valueMin(), this._valueMin() ];
				} else if ( options.values.length && options.values.length !== 2 ) {
					options.values = [ options.values[0], options.values[0] ];
				} else if ( $.isArray( options.values ) ) {
					options.values = options.values.slice(0);
				}
			}

			if ( !this.range || !this.range.length ) {
				this.range = $( "<div></div>" )
					.appendTo( this.element );

				classes = "ui-slider-range" +
				// note: this isn't the most fittingly semantic framework class for this element,
				// but worked best visually with a variety of themes
				" ui-widget-header ui-corner-all";
			} else {
				this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
					// Handle range switching from true to min/max
					.css({
						"left": "",
						"bottom": ""
					});
			}

			this.range.addClass( classes +
				( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
		} else {
			if ( this.range ) {
				this.range.remove();
			}
			this.range = null;
		}
	},

	_setupEvents: function() {
		this._off( this.handles );
		this._on( this.handles, this._handleEvents );
		this._hoverable( this.handles );
		this._focusable( this.handles );
	},

	_destroy: function() {
		this.handles.remove();
		if ( this.range ) {
			this.range.remove();
		}

		this.element
			.removeClass( "ui-slider" +
				" ui-slider-horizontal" +
				" ui-slider-vertical" +
				" ui-widget" +
				" ui-widget-content" +
				" ui-corner-all" );

		this._mouseDestroy();
	},

	_mouseCapture: function( event ) {
		var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
			that = this,
			o = this.options;

		if ( o.disabled ) {
			return false;
		}

		this.elementSize = {
			width: this.element.outerWidth(),
			height: this.element.outerHeight()
		};
		this.elementOffset = this.element.offset();

		position = { x: event.pageX, y: event.pageY };
		normValue = this._normValueFromMouse( position );
		distance = this._valueMax() - this._valueMin() + 1;
		this.handles.each(function( i ) {
			var thisDistance = Math.abs( normValue - that.values(i) );
			if (( distance > thisDistance ) ||
				( distance === thisDistance &&
					(i === that._lastChangedValue || that.values(i) === o.min ))) {
				distance = thisDistance;
				closestHandle = $( this );
				index = i;
			}
		});

		allowed = this._start( event, index );
		if ( allowed === false ) {
			return false;
		}
		this._mouseSliding = true;

		this._handleIndex = index;

		closestHandle
			.addClass( "ui-state-active" )
			.focus();

		offset = closestHandle.offset();
		mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
		this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
			left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
			top: event.pageY - offset.top -
				( closestHandle.height() / 2 ) -
				( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
				( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
				( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
		};

		if ( !this.handles.hasClass( "ui-state-hover" ) ) {
			this._slide( event, index, normValue );
		}
		this._animateOff = true;
		return true;
	},

	_mouseStart: function() {
		return true;
	},

	_mouseDrag: function( event ) {
		var position = { x: event.pageX, y: event.pageY },
			normValue = this._normValueFromMouse( position );

		this._slide( event, this._handleIndex, normValue );

		return false;
	},

	_mouseStop: function( event ) {
		this.handles.removeClass( "ui-state-active" );
		this._mouseSliding = false;

		this._stop( event, this._handleIndex );
		this._change( event, this._handleIndex );

		this._handleIndex = null;
		this._clickOffset = null;
		this._animateOff = false;

		return false;
	},

	_detectOrientation: function() {
		this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
	},

	_normValueFromMouse: function( position ) {
		var pixelTotal,
			pixelMouse,
			percentMouse,
			valueTotal,
			valueMouse;

		if ( this.orientation === "horizontal" ) {
			pixelTotal = this.elementSize.width;
			pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
		} else {
			pixelTotal = this.elementSize.height;
			pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
		}

		percentMouse = ( pixelMouse / pixelTotal );
		if ( percentMouse > 1 ) {
			percentMouse = 1;
		}
		if ( percentMouse < 0 ) {
			percentMouse = 0;
		}
		if ( this.orientation === "vertical" ) {
			percentMouse = 1 - percentMouse;
		}

		valueTotal = this._valueMax() - this._valueMin();
		valueMouse = this._valueMin() + percentMouse * valueTotal;

		return this._trimAlignValue( valueMouse );
	},

	_start: function( event, index ) {
		var uiHash = {
			handle: this.handles[ index ],
			value: this.value()
		};
		if ( this.options.values && this.options.values.length ) {
			uiHash.value = this.values( index );
			uiHash.values = this.values();
		}
		return this._trigger( "start", event, uiHash );
	},

	_slide: function( event, index, newVal ) {
		var otherVal,
			newValues,
			allowed;

		if ( this.options.values && this.options.values.length ) {
			otherVal = this.values( index ? 0 : 1 );

			if ( ( this.options.values.length === 2 && this.options.range === true ) &&
					( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
				) {
				newVal = otherVal;
			}

			if ( newVal !== this.values( index ) ) {
				newValues = this.values();
				newValues[ index ] = newVal;
				// A slide can be canceled by returning false from the slide callback
				allowed = this._trigger( "slide", event, {
					handle: this.handles[ index ],
					value: newVal,
					values: newValues
				} );
				otherVal = this.values( index ? 0 : 1 );
				if ( allowed !== false ) {
					this.values( index, newVal );
				}
			}
		} else {
			if ( newVal !== this.value() ) {
				// A slide can be canceled by returning false from the slide callback
				allowed = this._trigger( "slide", event, {
					handle: this.handles[ index ],
					value: newVal
				} );
				if ( allowed !== false ) {
					this.value( newVal );
				}
			}
		}
	},

	_stop: function( event, index ) {
		var uiHash = {
			handle: this.handles[ index ],
			value: this.value()
		};
		if ( this.options.values && this.options.values.length ) {
			uiHash.value = this.values( index );
			uiHash.values = this.values();
		}

		this._trigger( "stop", event, uiHash );
	},

	_change: function( event, index ) {
		if ( !this._keySliding && !this._mouseSliding ) {
			var uiHash = {
				handle: this.handles[ index ],
				value: this.value()
			};
			if ( this.options.values && this.options.values.length ) {
				uiHash.value = this.values( index );
				uiHash.values = this.values();
			}

			//store the last changed value index for reference when handles overlap
			this._lastChangedValue = index;

			this._trigger( "change", event, uiHash );
		}
	},

	value: function( newValue ) {
		if ( arguments.length ) {
			this.options.value = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, 0 );
			return;
		}

		return this._value();
	},

	values: function( index, newValue ) {
		var vals,
			newValues,
			i;

		if ( arguments.length > 1 ) {
			this.options.values[ index ] = this._trimAlignValue( newValue );
			this._refreshValue();
			this._change( null, index );
			return;
		}

		if ( arguments.length ) {
			if ( $.isArray( arguments[ 0 ] ) ) {
				vals = this.options.values;
				newValues = arguments[ 0 ];
				for ( i = 0; i < vals.length; i += 1 ) {
					vals[ i ] = this._trimAlignValue( newValues[ i ] );
					this._change( null, i );
				}
				this._refreshValue();
			} else {
				if ( this.options.values && this.options.values.length ) {
					return this._values( index );
				} else {
					return this.value();
				}
			}
		} else {
			return this._values();
		}
	},

	_setOption: function( key, value ) {
		var i,
			valsLength = 0;

		if ( key === "range" && this.options.range === true ) {
			if ( value === "min" ) {
				this.options.value = this._values( 0 );
				this.options.values = null;
			} else if ( value === "max" ) {
				this.options.value = this._values( this.options.values.length - 1 );
				this.options.values = null;
			}
		}

		if ( $.isArray( this.options.values ) ) {
			valsLength = this.options.values.length;
		}

		if ( key === "disabled" ) {
			this.element.toggleClass( "ui-state-disabled", !!value );
		}

		this._super( key, value );

		switch ( key ) {
			case "orientation":
				this._detectOrientation();
				this.element
					.removeClass( "ui-slider-horizontal ui-slider-vertical" )
					.addClass( "ui-slider-" + this.orientation );
				this._refreshValue();

				// Reset positioning from previous orientation
				this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
				break;
			case "value":
				this._animateOff = true;
				this._refreshValue();
				this._change( null, 0 );
				this._animateOff = false;
				break;
			case "values":
				this._animateOff = true;
				this._refreshValue();
				for ( i = 0; i < valsLength; i += 1 ) {
					this._change( null, i );
				}
				this._animateOff = false;
				break;
			case "step":
			case "min":
			case "max":
				this._animateOff = true;
				this._calculateNewMax();
				this._refreshValue();
				this._animateOff = false;
				break;
			case "range":
				this._animateOff = true;
				this._refresh();
				this._animateOff = false;
				break;
		}
	},

	//internal value getter
	// _value() returns value trimmed by min and max, aligned by step
	_value: function() {
		var val = this.options.value;
		val = this._trimAlignValue( val );

		return val;
	},

	//internal values getter
	// _values() returns array of values trimmed by min and max, aligned by step
	// _values( index ) returns single value trimmed by min and max, aligned by step
	_values: function( index ) {
		var val,
			vals,
			i;

		if ( arguments.length ) {
			val = this.options.values[ index ];
			val = this._trimAlignValue( val );

			return val;
		} else if ( this.options.values && this.options.values.length ) {
			// .slice() creates a copy of the array
			// this copy gets trimmed by min and max and then returned
			vals = this.options.values.slice();
			for ( i = 0; i < vals.length; i += 1) {
				vals[ i ] = this._trimAlignValue( vals[ i ] );
			}

			return vals;
		} else {
			return [];
		}
	},

	// returns the step-aligned value that val is closest to, between (inclusive) min and max
	_trimAlignValue: function( val ) {
		if ( val <= this._valueMin() ) {
			return this._valueMin();
		}
		if ( val >= this._valueMax() ) {
			return this._valueMax();
		}
		var step = ( this.options.step > 0 ) ? this.options.step : 1,
			valModStep = (val - this._valueMin()) % step,
			alignValue = val - valModStep;

		if ( Math.abs(valModStep) * 2 >= step ) {
			alignValue += ( valModStep > 0 ) ? step : ( -step );
		}

		// Since JavaScript has problems with large floats, round
		// the final value to 5 digits after the decimal point (see #4124)
		return parseFloat( alignValue.toFixed(5) );
	},

	_calculateNewMax: function() {
		var max = this.options.max,
			min = this._valueMin(),
			step = this.options.step,
			aboveMin = Math.floor( ( +( max - min ).toFixed( this._precision() ) ) / step ) * step;
		max = aboveMin + min;
		this.max = parseFloat( max.toFixed( this._precision() ) );
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_valueMin: function() {
		return this.options.min;
	},

	_valueMax: function() {
		return this.max;
	},

	_refreshValue: function() {
		var lastValPercent, valPercent, value, valueMin, valueMax,
			oRange = this.options.range,
			o = this.options,
			that = this,
			animate = ( !this._animateOff ) ? o.animate : false,
			_set = {};

		if ( this.options.values && this.options.values.length ) {
			this.handles.each(function( i ) {
				valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
				_set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
				$( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
				if ( that.options.range === true ) {
					if ( that.orientation === "horizontal" ) {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
						}
					} else {
						if ( i === 0 ) {
							that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
						}
						if ( i === 1 ) {
							that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
						}
					}
				}
				lastValPercent = valPercent;
			});
		} else {
			value = this.value();
			valueMin = this._valueMin();
			valueMax = this._valueMax();
			valPercent = ( valueMax !== valueMin ) ?
					( value - valueMin ) / ( valueMax - valueMin ) * 100 :
					0;
			_set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
			this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

			if ( oRange === "min" && this.orientation === "horizontal" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
			}
			if ( oRange === "max" && this.orientation === "horizontal" ) {
				this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
			}
			if ( oRange === "min" && this.orientation === "vertical" ) {
				this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
			}
			if ( oRange === "max" && this.orientation === "vertical" ) {
				this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
			}
		}
	},

	_handleEvents: {
		keydown: function( event ) {
			var allowed, curVal, newVal, step,
				index = $( event.target ).data( "ui-slider-handle-index" );

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
				case $.ui.keyCode.END:
				case $.ui.keyCode.PAGE_UP:
				case $.ui.keyCode.PAGE_DOWN:
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					event.preventDefault();
					if ( !this._keySliding ) {
						this._keySliding = true;
						$( event.target ).addClass( "ui-state-active" );
						allowed = this._start( event, index );
						if ( allowed === false ) {
							return;
						}
					}
					break;
			}

			step = this.options.step;
			if ( this.options.values && this.options.values.length ) {
				curVal = newVal = this.values( index );
			} else {
				curVal = newVal = this.value();
			}

			switch ( event.keyCode ) {
				case $.ui.keyCode.HOME:
					newVal = this._valueMin();
					break;
				case $.ui.keyCode.END:
					newVal = this._valueMax();
					break;
				case $.ui.keyCode.PAGE_UP:
					newVal = this._trimAlignValue(
						curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
					);
					break;
				case $.ui.keyCode.PAGE_DOWN:
					newVal = this._trimAlignValue(
						curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
					break;
				case $.ui.keyCode.UP:
				case $.ui.keyCode.RIGHT:
					if ( curVal === this._valueMax() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal + step );
					break;
				case $.ui.keyCode.DOWN:
				case $.ui.keyCode.LEFT:
					if ( curVal === this._valueMin() ) {
						return;
					}
					newVal = this._trimAlignValue( curVal - step );
					break;
			}

			this._slide( event, index, newVal );
		},
		keyup: function( event ) {
			var index = $( event.target ).data( "ui-slider-handle-index" );

			if ( this._keySliding ) {
				this._keySliding = false;
				this._stop( event, index );
				this._change( event, index );
				$( event.target ).removeClass( "ui-state-active" );
			}
		}
	}
});


/*!
 * jQuery UI Sortable 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/sortable/
 */


var sortable = $.widget("ui.sortable", $.ui.mouse, {
	version: "1.11.4",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return (/left|right/).test(item.css("float")) || (/inline|table-cell/).test(item.css("display"));
	},

	_create: function() {
		this.containerCache = {};
		this.element.addClass("ui-sortable");

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		this.element.find( ".ui-sortable-handle" ).removeClass( "ui-sortable-handle" );
		$.each( this.items, function() {
			( this.instance.options.handle ?
				this.item.find( this.instance.options.handle ) : this.item )
				.addClass( "ui-sortable-handle" );
		});
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-sortable ui-sortable-disabled" )
			.find( ".ui-sortable-handle" )
				.removeClass( "ui-sortable-handle" );
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[i].item.removeData(this.widgetName + "-item");
		}

		return this;
	},

	_mouseCapture: function(event, overrideHandle) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if (this.reverting) {
			return false;
		}

		if(this.options.disabled || this.options.type === "static") {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems(event);

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$(event.target).parents().each(function() {
			if($.data(this, that.widgetName + "-item") === that) {
				currentItem = $(this);
				return false;
			}
		});
		if($.data(event.target, that.widgetName + "-item") === that) {
			currentItem = $(event.target);
		}

		if(!currentItem) {
			return false;
		}
		if(this.options.handle && !overrideHandle) {
			$(this.options.handle, currentItem).find("*").addBack().each(function() {
				if(this === event.target) {
					validHandle = true;
				}
			});
			if(!validHandle) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function(event, overrideHandle, noActivation) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper(event);

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend(this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),
			relative: this._getRelativeOffset() //This is a relative to absolute position minus the actual position calculation - only used for relative positioned helper
		});

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css("position", "absolute");
		this.cssPosition = this.helper.css("position");

		//Generate the original position
		this.originalPosition = this._generatePosition(event);
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		(o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt));

		//Cache the former DOM position
		this.domPosition = { prev: this.currentItem.prev()[0], parent: this.currentItem.parent()[0] };

		//If the helper is not the original, hide the original so it's not playing any role during the drag, won't cause anything bad this way
		if(this.helper[0] !== this.currentItem[0]) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if(o.containment) {
			this._setContainment();
		}

		if( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet = $( "<style>*{ cursor: "+o.cursor+" !important; }</style>" ).appendTo( body );
		}

		if(o.opacity) { // opacity option
			if (this.helper.css("opacity")) {
				this._storedOpacity = this.helper.css("opacity");
			}
			this.helper.css("opacity", o.opacity);
		}

		if(o.zIndex) { // zIndex option
			if (this.helper.css("zIndex")) {
				this._storedZIndex = this.helper.css("zIndex");
			}
			this.helper.css("zIndex", o.zIndex);
		}

		//Prepare scrolling
		if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger("start", event, this._uiHash());

		//Recache the helper size
		if(!this._preserveHelperProportions) {
			this._cacheHelperProportions();
		}


		//Post "activate" events to possible containers
		if( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if($.ui.ddmanager) {
			$.ui.ddmanager.current = this;
		}

		if ($.ui.ddmanager && !o.dropBehaviour) {
			$.ui.ddmanager.prepareOffsets(this, event);
		}

		this.dragging = true;

		this.helper.addClass("ui-sortable-helper");
		this._mouseDrag(event); //Execute the drag once - this causes the helper not to be visible before getting its correct position
		return true;

	},

	_mouseDrag: function(event) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition(event);
		this.positionAbs = this._convertPositionTo("absolute");

		if (!this.lastPositionAbs) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if(this.options.scroll) {
			if(this.scrollParent[0] !== this.document[0] && this.scrollParent[0].tagName !== "HTML") {

				if((this.overflowOffset.top + this.scrollParent[0].offsetHeight) - event.pageY < o.scrollSensitivity) {
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop + o.scrollSpeed;
				} else if(event.pageY - this.overflowOffset.top < o.scrollSensitivity) {
					this.scrollParent[0].scrollTop = scrolled = this.scrollParent[0].scrollTop - o.scrollSpeed;
				}

				if((this.overflowOffset.left + this.scrollParent[0].offsetWidth) - event.pageX < o.scrollSensitivity) {
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft + o.scrollSpeed;
				} else if(event.pageX - this.overflowOffset.left < o.scrollSensitivity) {
					this.scrollParent[0].scrollLeft = scrolled = this.scrollParent[0].scrollLeft - o.scrollSpeed;
				}

			} else {

				if(event.pageY - this.document.scrollTop() < o.scrollSensitivity) {
					scrolled = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed);
				} else if(this.window.height() - (event.pageY - this.document.scrollTop()) < o.scrollSensitivity) {
					scrolled = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed);
				}

				if(event.pageX - this.document.scrollLeft() < o.scrollSensitivity) {
					scrolled = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed);
				} else if(this.window.width() - (event.pageX - this.document.scrollLeft()) < o.scrollSensitivity) {
					scrolled = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed);
				}

			}

			if(scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
				$.ui.ddmanager.prepareOffsets(this, event);
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo("absolute");

		//Set the helper position
		if(!this.options.axis || this.options.axis !== "y") {
			this.helper[0].style.left = this.position.left+"px";
		}
		if(!this.options.axis || this.options.axis !== "x") {
			this.helper[0].style.top = this.position.top+"px";
		}

		//Rearrange
		for (i = this.items.length - 1; i >= 0; i--) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[i];
			itemElement = item.item[0];
			intersection = this._intersectsWithPointer(item);
			if (!intersection) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if (item.instance !== this.currentContainer) {
				continue;
			}

			// cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if (itemElement !== this.currentItem[0] &&
				this.placeholder[intersection === 1 ? "next" : "prev"]()[0] !== itemElement &&
				!$.contains(this.placeholder[0], itemElement) &&
				(this.options.type === "semi-dynamic" ? !$.contains(this.element[0], itemElement) : true)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
					this._rearrange(event, item);
				} else {
					break;
				}

				this._trigger("change", event, this._uiHash());
				break;
			}
		}

		//Post events to containers
		this._contactContainers(event);

		//Interconnect with droppables
		if($.ui.ddmanager) {
			$.ui.ddmanager.drag(this, event);
		}

		//Call callbacks
		this._trigger("sort", event, this._uiHash());

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function(event, noPropagation) {

		if(!event) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ($.ui.ddmanager && !this.options.dropBehaviour) {
			$.ui.ddmanager.drop(this, event);
		}

		if(this.options.revert) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop);
			}
			this.reverting = true;
			$(this.helper).animate( animation, parseInt(this.options.revert, 10) || 500, function() {
				that._clear(event);
			});
		} else {
			this._clear(event, noPropagation);
		}

		return false;

	},

	cancel: function() {

		if(this.dragging) {

			this._mouseUp({ target: null });

			if(this.options.helper === "original") {
				this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for (var i = this.containers.length - 1; i >= 0; i--){
				this.containers[i]._trigger("deactivate", null, this._uiHash(this));
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", null, this._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}

		if (this.placeholder) {
			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
			if(this.placeholder[0].parentNode) {
				this.placeholder[0].parentNode.removeChild(this.placeholder[0]);
			}
			if(this.options.helper !== "original" && this.helper && this.helper[0].parentNode) {
				this.helper.remove();
			}

			$.extend(this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			});

			if(this.domPosition.prev) {
				$(this.domPosition.prev).after(this.currentItem);
			} else {
				$(this.domPosition.parent).prepend(this.currentItem);
			}
		}

		return this;

	},

	serialize: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected),
			str = [];
		o = o || {};

		$(items).each(function() {
			var res = ($(o.item || this).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[\-=_](.+)/));
			if (res) {
				str.push((o.key || res[1]+"[]")+"="+(o.key && o.expression ? res[1] : res[2]));
			}
		});

		if(!str.length && o.key) {
			str.push(o.key + "=");
		}

		return str.join("&");

	},

	toArray: function(o) {

		var items = this._getItemsAsjQuery(o && o.connected),
			ret = [];

		o = o || {};

		items.each(function() { ret.push($(o.item || this).attr(o.attribute || "id") || ""); });
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function(item) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t && ( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l && ( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			(this.options.tolerance !== "pointer" && this.helperProportions[this.floating ? "width" : "height"] > item[this.floating ? "width" : "height"])
		) {
			return isOverElement;
		} else {

			return (l < x1 + (this.helperProportions.width / 2) && // Right Half
				x2 - (this.helperProportions.width / 2) < r && // Left Half
				t < y1 + (this.helperProportions.height / 2) && // Bottom Half
				y2 - (this.helperProportions.height / 2) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function(item) {

		var isOverElementHeight = (this.options.axis === "x") || this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top, item.height),
			isOverElementWidth = (this.options.axis === "y") || this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left, item.width),
			isOverElement = isOverElementHeight && isOverElementWidth,
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (!isOverElement) {
			return false;
		}

		return this.floating ?
			( ((horizontalDirection && horizontalDirection === "right") || verticalDirection === "down") ? 2 : 1 )
			: ( verticalDirection && (verticalDirection === "down" ? 2 : 1) );

	},

	_intersectsWithSides: function(item) {

		var isOverBottomHalf = this._isOverAxis(this.positionAbs.top + this.offset.click.top, item.top + (item.height/2), item.height),
			isOverRightHalf = this._isOverAxis(this.positionAbs.left + this.offset.click.left, item.left + (item.width/2), item.width),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if (this.floating && horizontalDirection) {
			return ((horizontalDirection === "right" && isOverRightHalf) || (horizontalDirection === "left" && !isOverRightHalf));
		} else {
			return verticalDirection && ((verticalDirection === "down" && isOverBottomHalf) || (verticalDirection === "up" && !isOverBottomHalf));
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && (delta > 0 ? "down" : "up");
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && (delta > 0 ? "right" : "left");
	},

	refresh: function(event) {
		this._refreshItems(event);
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ? [options.connectWith] : options.connectWith;
	},

	_getItemsAsjQuery: function(connected) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if(connectWith && connected) {
			for (i = connectWith.length - 1; i >= 0; i--){
				cur = $(connectWith[i], this.document[0]);
				for ( j = cur.length - 1; j >= 0; j--){
					inst = $.data(cur[j], this.widgetFullName);
					if(inst && inst !== this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element) : $(inst.options.items, inst.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), inst]);
					}
				}
			}
		}

		queries.push([$.isFunction(this.options.items) ? this.options.items.call(this.element, null, { options: this.options, item: this.currentItem }) : $(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]);

		function addItems() {
			items.push( this );
		}
		for (i = queries.length - 1; i >= 0; i--){
			queries[i][0].each( addItems );
		}

		return $(items);

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find(":data(" + this.widgetName + "-item)");

		this.items = $.grep(this.items, function (item) {
			for (var j=0; j < list.length; j++) {
				if(list[j] === item.item[0]) {
					return false;
				}
			}
			return true;
		});

	},

	_refreshItems: function(event) {

		this.items = [];
		this.containers = [this];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [[$.isFunction(this.options.items) ? this.options.items.call(this.element[0], event, { item: this.currentItem }) : $(this.options.items, this.element), this]],
			connectWith = this._connectWith();

		if(connectWith && this.ready) { //Shouldn't be run the first time through due to massive slow-down
			for (i = connectWith.length - 1; i >= 0; i--){
				cur = $(connectWith[i], this.document[0]);
				for (j = cur.length - 1; j >= 0; j--){
					inst = $.data(cur[j], this.widgetFullName);
					if(inst && inst !== this && !inst.options.disabled) {
						queries.push([$.isFunction(inst.options.items) ? inst.options.items.call(inst.element[0], event, { item: this.currentItem }) : $(inst.options.items, inst.element), inst]);
						this.containers.push(inst);
					}
				}
			}
		}

		for (i = queries.length - 1; i >= 0; i--) {
			targetData = queries[i][1];
			_queries = queries[i][0];

			for (j=0, queriesLength = _queries.length; j < queriesLength; j++) {
				item = $(_queries[j]);

				item.data(this.widgetName + "-item", targetData); // Data for target checking (mouse manager)

				items.push({
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				});
			}
		}

	},

	refreshPositions: function(fast) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent, the offsetParent's position will change
		if(this.offsetParent && this.helper) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for (i = this.items.length - 1; i >= 0; i--){
			item = this.items[i];

			//We ignore calculating positions of all connected containers when we're not over them
			if(item.instance !== this.currentContainer && this.currentContainer && item.item[0] !== this.currentItem[0]) {
				continue;
			}

			t = this.options.toleranceElement ? $(this.options.toleranceElement, item.item) : item.item;

			if (!fast) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if(this.options.custom && this.options.custom.refreshContainers) {
			this.options.custom.refreshContainers.call(this);
		} else {
			for (i = this.containers.length - 1; i >= 0; i--){
				p = this.containers[i].element.offset();
				this.containers[i].containerCache.left = p.left;
				this.containers[i].containerCache.top = p.top;
				this.containers[i].containerCache.width = this.containers[i].element.outerWidth();
				this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function(that) {
		that = that || this;
		var className,
			o = that.options;

		if(!o.placeholder || o.placeholder.constructor === String) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[0].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[0] )
							.addClass(className || that.currentItem[0].className+" ui-sortable-placeholder")
							.removeClass("ui-sortable-helper");

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function(container, p) {

					// 1. If a className is set as 'placeholder option, we don't force sizes - the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a class name is specified
					if(className && !o.forcePlaceholderSize) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming from a stylesheet), it receives the inline height from the dragged item
					if(!p.height()) { p.height(that.currentItem.innerHeight() - parseInt(that.currentItem.css("paddingTop")||0, 10) - parseInt(that.currentItem.css("paddingBottom")||0, 10)); }
					if(!p.width()) { p.width(that.currentItem.innerWidth() - parseInt(that.currentItem.css("paddingLeft")||0, 10) - parseInt(that.currentItem.css("paddingRight")||0, 10)); }
				}
			};
		}

		//Create the placeholder
		that.placeholder = $(o.placeholder.element.call(that.element, that.currentItem));

		//Append it after the actual current item
		that.currentItem.after(that.placeholder);

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update(that, that.placeholder);

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each(function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		});
	},

	_contactContainers: function(event) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom, floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// get innermost container that intersects with item
		for (i = this.containers.length - 1; i >= 0; i--) {

			// never consider a container that's located within the item itself
			if($.contains(this.currentItem[0], this.containers[i].element[0])) {
				continue;
			}

			if(this._intersectsWith(this.containers[i].containerCache)) {

				// if we've already found a container and it's more "inner" than this, then continue
				if(innermostContainer && $.contains(this.containers[i].element[0], innermostContainer.element[0])) {
					continue;
				}

				innermostContainer = this.containers[i];
				innermostIndex = i;

			} else {
				// container doesn't intersect. trigger "out" event if necessary
				if(this.containers[i].containerCache.over) {
					this.containers[i]._trigger("out", event, this._uiHash(this));
					this.containers[i].containerCache.over = 0;
				}
			}

		}

		// if no intersecting containers found, return
		if(!innermostContainer) {
			return;
		}

		// move the item into the container if it's not there already
		if(this.containers.length === 1) {
			if (!this.containers[innermostIndex].containerCache.over) {
				this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
				this.containers[innermostIndex].containerCache.over = 1;
			}
		} else {

			//When entering a new container, we will find the item with the least distance and append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating(this.currentItem);
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "clientX" : "clientY";

			for (j = this.items.length - 1; j >= 0; j--) {
				if(!$.contains(this.containers[innermostIndex].element[0], this.items[j].item[0])) {
					continue;
				}
				if(this.items[j].item[0] === this.currentItem[0]) {
					continue;
				}

				cur = this.items[j].item.offset()[posProperty];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up": "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if(!itemWithLeastDistance && !this.options.dropOnEmpty) {
				return;
			}

			if(this.currentContainer === this.containers[innermostIndex]) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ? this._rearrange(event, itemWithLeastDistance, null, true) : this._rearrange(event, null, this.containers[innermostIndex].element, true);
			this._trigger("change", event, this._uiHash());
			this.containers[innermostIndex]._trigger("change", event, this._uiHash(this));
			this.currentContainer = this.containers[innermostIndex];

			//Update the placeholder
			this.options.placeholder.update(this.currentContainer, this.placeholder);

			this.containers[innermostIndex]._trigger("over", event, this._uiHash(this));
			this.containers[innermostIndex].containerCache.over = 1;
		}


	},

	_createHelper: function(event) {

		var o = this.options,
			helper = $.isFunction(o.helper) ? $(o.helper.apply(this.element[0], [event, this.currentItem])) : (o.helper === "clone" ? this.currentItem.clone() : this.currentItem);

		//Add the helper to the DOM if that didn't happen already
		if(!helper.parents("body").length) {
			$(o.appendTo !== "parent" ? o.appendTo : this.currentItem[0].parentNode)[0].appendChild(helper[0]);
		}

		if(helper[0] === this.currentItem[0]) {
			this._storedCSS = { width: this.currentItem[0].style.width, height: this.currentItem[0].style.height, position: this.currentItem.css("position"), top: this.currentItem.css("top"), left: this.currentItem.css("left") };
		}

		if(!helper[0].style.width || o.forceHelperSize) {
			helper.width(this.currentItem.width());
		}
		if(!helper[0].style.height || o.forceHelperSize) {
			helper.height(this.currentItem.height());
		}

		return helper;

	},

	_adjustOffsetFromHelper: function(obj) {
		if (typeof obj === "string") {
			obj = obj.split(" ");
		}
		if ($.isArray(obj)) {
			obj = {left: +obj[0], top: +obj[1] || 0};
		}
		if ("left" in obj) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ("right" in obj) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ("top" in obj) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ("bottom" in obj) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {


		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't the document, which means that
		//    the scroll is included in the initial calculation of the offset of the parent, and never recalculated upon drag
		if(this.cssPosition === "absolute" && this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this information
		// with an ugly IE fix
		if( this.offsetParent[0] === this.document[0].body || (this.offsetParent[0].tagName && this.offsetParent[0].tagName.toLowerCase() === "html" && $.ui.ie)) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + (parseInt(this.offsetParent.css("borderTopWidth"),10) || 0),
			left: po.left + (parseInt(this.offsetParent.css("borderLeftWidth"),10) || 0)
		};

	},

	_getRelativeOffset: function() {

		if(this.cssPosition === "relative") {
			var p = this.currentItem.position();
			return {
				top: p.top - (parseInt(this.helper.css("top"),10) || 0) + this.scrollParent.scrollTop(),
				left: p.left - (parseInt(this.helper.css("left"),10) || 0) + this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: (parseInt(this.currentItem.css("marginLeft"),10) || 0),
			top: (parseInt(this.currentItem.css("marginTop"),10) || 0)
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if(o.containment === "parent") {
			o.containment = this.helper[0].parentNode;
		}
		if(o.containment === "document" || o.containment === "window") {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left,
				(o.containment === "document" ? this.document.width() : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top
			];
		}

		if(!(/^(document|window|parent)$/).test(o.containment)) {
			ce = $(o.containment)[0];
			co = $(o.containment).offset();
			over = ($(ce).css("overflow") !== "hidden");

			this.containment = [
				co.left + (parseInt($(ce).css("borderLeftWidth"),10) || 0) + (parseInt($(ce).css("paddingLeft"),10) || 0) - this.margins.left,
				co.top + (parseInt($(ce).css("borderTopWidth"),10) || 0) + (parseInt($(ce).css("paddingTop"),10) || 0) - this.margins.top,
				co.left+(over ? Math.max(ce.scrollWidth,ce.offsetWidth) : ce.offsetWidth) - (parseInt($(ce).css("borderLeftWidth"),10) || 0) - (parseInt($(ce).css("paddingRight"),10) || 0) - this.helperProportions.width - this.margins.left,
				co.top+(over ? Math.max(ce.scrollHeight,ce.offsetHeight) : ce.offsetHeight) - (parseInt($(ce).css("borderTopWidth"),10) || 0) - (parseInt($(ce).css("paddingBottom"),10) || 0) - this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function(d, pos) {

		if(!pos) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent,
			scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		return {
			top: (
				pos.top	+																// The absolute mouse position
				this.offset.relative.top * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top * mod -											// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod)
			),
			left: (
				pos.left +																// The absolute mouse position
				this.offset.relative.left * mod +										// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left * mod	-										// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ) * mod)
			)
		};

	},

	_generatePosition: function(event) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" && !(this.scrollParent[0] !== this.document[0] && $.contains(this.scrollParent[0], this.offsetParent[0])) ? this.offsetParent : this.scrollParent, scrollIsRootNode = (/(html|body)/i).test(scroll[0].tagName);

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if(this.cssPosition === "relative" && !(this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0])) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if(this.originalPosition) { //If we are not dragging yet, we won't check for options

			if(this.containment) {
				if(event.pageX - this.offset.click.left < this.containment[0]) {
					pageX = this.containment[0] + this.offset.click.left;
				}
				if(event.pageY - this.offset.click.top < this.containment[1]) {
					pageY = this.containment[1] + this.offset.click.top;
				}
				if(event.pageX - this.offset.click.left > this.containment[2]) {
					pageX = this.containment[2] + this.offset.click.left;
				}
				if(event.pageY - this.offset.click.top > this.containment[3]) {
					pageY = this.containment[3] + this.offset.click.top;
				}
			}

			if(o.grid) {
				top = this.originalPageY + Math.round((pageY - this.originalPageY) / o.grid[1]) * o.grid[1];
				pageY = this.containment ? ( (top - this.offset.click.top >= this.containment[1] && top - this.offset.click.top <= this.containment[3]) ? top : ((top - this.offset.click.top >= this.containment[1]) ? top - o.grid[1] : top + o.grid[1])) : top;

				left = this.originalPageX + Math.round((pageX - this.originalPageX) / o.grid[0]) * o.grid[0];
				pageX = this.containment ? ( (left - this.offset.click.left >= this.containment[0] && left - this.offset.click.left <= this.containment[2]) ? left : ((left - this.offset.click.left >= this.containment[0]) ? left - o.grid[0] : left + o.grid[0])) : left;
			}

		}

		return {
			top: (
				pageY -																// The absolute mouse position
				this.offset.click.top -													// Click offset (relative to the element)
				this.offset.relative.top	-											// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.top +												// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollTop() : ( scrollIsRootNode ? 0 : scroll.scrollTop() ) ))
			),
			left: (
				pageX -																// The absolute mouse position
				this.offset.click.left -												// Click offset (relative to the element)
				this.offset.relative.left	-											// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.parent.left +												// The offsetParent's offset without borders (offset + border)
				( ( this.cssPosition === "fixed" ? -this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 : scroll.scrollLeft() ))
			)
		};

	},

	_rearrange: function(event, i, a, hardRefresh) {

		a ? a[0].appendChild(this.placeholder[0]) : i.item[0].parentNode.insertBefore(this.placeholder[0], (this.direction === "down" ? i.item[0] : i.item[0].nextSibling));

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout, if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay(function() {
			if(counter === this.counter) {
				this.refreshPositions(!hardRefresh); //Precompute after each DOM insertion, NOT on mousemove
			}
		});

	},

	_clear: function(event, noPropagation) {

		this.reverting = false;
		// We delay all events that have to be triggered to after the point where the placeholder has been removed and
		// everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets reappended (see #4088)
		if(!this._noFinalSort && this.currentItem.parent().length) {
			this.placeholder.before(this.currentItem);
		}
		this._noFinalSort = null;

		if(this.helper[0] === this.currentItem[0]) {
			for(i in this._storedCSS) {
				if(this._storedCSS[i] === "auto" || this._storedCSS[i] === "static") {
					this._storedCSS[i] = "";
				}
			}
			this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper");
		} else {
			this.currentItem.show();
		}

		if(this.fromOutside && !noPropagation) {
			delayedTriggers.push(function(event) { this._trigger("receive", event, this._uiHash(this.fromOutside)); });
		}
		if((this.fromOutside || this.domPosition.prev !== this.currentItem.prev().not(".ui-sortable-helper")[0] || this.domPosition.parent !== this.currentItem.parent()[0]) && !noPropagation) {
			delayedTriggers.push(function(event) { this._trigger("update", event, this._uiHash()); }); //Trigger update callback if the DOM position has changed
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if (this !== this.currentContainer) {
			if(!noPropagation) {
				delayedTriggers.push(function(event) { this._trigger("remove", event, this._uiHash()); });
				delayedTriggers.push((function(c) { return function(event) { c._trigger("receive", event, this._uiHash(this)); };  }).call(this, this.currentContainer));
				delayedTriggers.push((function(c) { return function(event) { c._trigger("update", event, this._uiHash(this));  }; }).call(this, this.currentContainer));
			}
		}


		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for (i = this.containers.length - 1; i >= 0; i--){
			if (!noPropagation) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if(this.containers[i].containerCache.over) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[i].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if(this._storedOpacity) {
			this.helper.css("opacity", this._storedOpacity);
		}
		if(this._storedZIndex) {
			this.helper.css("zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex);
		}

		this.dragging = false;

		if(!noPropagation) {
			this._trigger("beforeStop", event, this._uiHash());
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately, it unbinds ALL events from the original node!
		this.placeholder[0].parentNode.removeChild(this.placeholder[0]);

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if(!noPropagation) {
			for (i=0; i < delayedTriggers.length; i++) {
				delayedTriggers[i].call(this, event);
			} //Trigger all delayed events
			this._trigger("stop", event, this._uiHash());
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ($.Widget.prototype._trigger.apply(this, arguments) === false) {
			this.cancel();
		}
	},

	_uiHash: function(_inst) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $([]),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

});


/*!
 * jQuery UI Spinner 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/spinner/
 */


function spinner_modifier( fn ) {
	return function() {
		var previous = this.element.val();
		fn.apply( this, arguments );
		this._refresh();
		if ( previous !== this.element.val() ) {
			this._trigger( "change" );
		}
	};
}

var spinner = $.widget( "ui.spinner", {
	version: "1.11.4",
	defaultElement: "<input>",
	widgetEventPrefix: "spin",
	options: {
		culture: null,
		icons: {
			down: "ui-icon-triangle-1-s",
			up: "ui-icon-triangle-1-n"
		},
		incremental: true,
		max: null,
		min: null,
		numberFormat: null,
		page: 10,
		step: 1,

		change: null,
		spin: null,
		start: null,
		stop: null
	},

	_create: function() {
		// handle string values that need to be parsed
		this._setOption( "max", this.options.max );
		this._setOption( "min", this.options.min );
		this._setOption( "step", this.options.step );

		// Only format if there is a value, prevents the field from being marked
		// as invalid in Firefox, see #9573.
		if ( this.value() !== "" ) {
			// Format the value, but don't constrain.
			this._value( this.element.val(), true );
		}

		this._draw();
		this._on( this._events );
		this._refresh();

		// turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		});
	},

	_getCreateOptions: function() {
		var options = {},
			element = this.element;

		$.each( [ "min", "max", "step" ], function( i, option ) {
			var value = element.attr( option );
			if ( value !== undefined && value.length ) {
				options[ option ] = value;
			}
		});

		return options;
	},

	_events: {
		keydown: function( event ) {
			if ( this._start( event ) && this._keydown( event ) ) {
				event.preventDefault();
			}
		},
		keyup: "_stop",
		focus: function() {
			this.previous = this.element.val();
		},
		blur: function( event ) {
			if ( this.cancelBlur ) {
				delete this.cancelBlur;
				return;
			}

			this._stop();
			this._refresh();
			if ( this.previous !== this.element.val() ) {
				this._trigger( "change", event );
			}
		},
		mousewheel: function( event, delta ) {
			if ( !delta ) {
				return;
			}
			if ( !this.spinning && !this._start( event ) ) {
				return false;
			}

			this._spin( (delta > 0 ? 1 : -1) * this.options.step, event );
			clearTimeout( this.mousewheelTimer );
			this.mousewheelTimer = this._delay(function() {
				if ( this.spinning ) {
					this._stop( event );
				}
			}, 100 );
			event.preventDefault();
		},
		"mousedown .ui-spinner-button": function( event ) {
			var previous;

			// We never want the buttons to have focus; whenever the user is
			// interacting with the spinner, the focus should be on the input.
			// If the input is focused then this.previous is properly set from
			// when the input first received focus. If the input is not focused
			// then we need to set this.previous based on the value before spinning.
			previous = this.element[0] === this.document[0].activeElement ?
				this.previous : this.element.val();
			function checkFocus() {
				var isActive = this.element[0] === this.document[0].activeElement;
				if ( !isActive ) {
					this.element.focus();
					this.previous = previous;
					// support: IE
					// IE sets focus asynchronously, so we need to check if focus
					// moved off of the input because the user clicked on the button.
					this._delay(function() {
						this.previous = previous;
					});
				}
			}

			// ensure focus is on (or stays on) the text field
			event.preventDefault();
			checkFocus.call( this );

			// support: IE
			// IE doesn't prevent moving focus even with event.preventDefault()
			// so we set a flag to know when we should ignore the blur event
			// and check (again) if focus moved off of the input.
			this.cancelBlur = true;
			this._delay(function() {
				delete this.cancelBlur;
				checkFocus.call( this );
			});

			if ( this._start( event ) === false ) {
				return;
			}

			this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		"mouseup .ui-spinner-button": "_stop",
		"mouseenter .ui-spinner-button": function( event ) {
			// button will add ui-state-active if mouse was down while mouseleave and kept down
			if ( !$( event.currentTarget ).hasClass( "ui-state-active" ) ) {
				return;
			}

			if ( this._start( event ) === false ) {
				return false;
			}
			this._repeat( null, $( event.currentTarget ).hasClass( "ui-spinner-up" ) ? 1 : -1, event );
		},
		// TODO: do we really want to consider this a stop?
		// shouldn't we just stop the repeater and wait until mouseup before
		// we trigger the stop event?
		"mouseleave .ui-spinner-button": "_stop"
	},

	_draw: function() {
		var uiSpinner = this.uiSpinner = this.element
			.addClass( "ui-spinner-input" )
			.attr( "autocomplete", "off" )
			.wrap( this._uiSpinnerHtml() )
			.parent()
				// add buttons
				.append( this._buttonHtml() );

		this.element.attr( "role", "spinbutton" );

		// button bindings
		this.buttons = uiSpinner.find( ".ui-spinner-button" )
			.attr( "tabIndex", -1 )
			.button()
			.removeClass( "ui-corner-all" );

		// IE 6 doesn't understand height: 50% for the buttons
		// unless the wrapper has an explicit height
		if ( this.buttons.height() > Math.ceil( uiSpinner.height() * 0.5 ) &&
				uiSpinner.height() > 0 ) {
			uiSpinner.height( uiSpinner.height() );
		}

		// disable spinner if element was already disabled
		if ( this.options.disabled ) {
			this.disable();
		}
	},

	_keydown: function( event ) {
		var options = this.options,
			keyCode = $.ui.keyCode;

		switch ( event.keyCode ) {
		case keyCode.UP:
			this._repeat( null, 1, event );
			return true;
		case keyCode.DOWN:
			this._repeat( null, -1, event );
			return true;
		case keyCode.PAGE_UP:
			this._repeat( null, options.page, event );
			return true;
		case keyCode.PAGE_DOWN:
			this._repeat( null, -options.page, event );
			return true;
		}

		return false;
	},

	_uiSpinnerHtml: function() {
		return "<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>";
	},

	_buttonHtml: function() {
		return "" +
			"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'>" +
				"<span class='ui-icon " + this.options.icons.up + "'>&#9650;</span>" +
			"</a>" +
			"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>" +
				"<span class='ui-icon " + this.options.icons.down + "'>&#9660;</span>" +
			"</a>";
	},

	_start: function( event ) {
		if ( !this.spinning && this._trigger( "start", event ) === false ) {
			return false;
		}

		if ( !this.counter ) {
			this.counter = 1;
		}
		this.spinning = true;
		return true;
	},

	_repeat: function( i, steps, event ) {
		i = i || 500;

		clearTimeout( this.timer );
		this.timer = this._delay(function() {
			this._repeat( 40, steps, event );
		}, i );

		this._spin( steps * this.options.step, event );
	},

	_spin: function( step, event ) {
		var value = this.value() || 0;

		if ( !this.counter ) {
			this.counter = 1;
		}

		value = this._adjustValue( value + step * this._increment( this.counter ) );

		if ( !this.spinning || this._trigger( "spin", event, { value: value } ) !== false) {
			this._value( value );
			this.counter++;
		}
	},

	_increment: function( i ) {
		var incremental = this.options.incremental;

		if ( incremental ) {
			return $.isFunction( incremental ) ?
				incremental( i ) :
				Math.floor( i * i * i / 50000 - i * i / 500 + 17 * i / 200 + 1 );
		}

		return 1;
	},

	_precision: function() {
		var precision = this._precisionOf( this.options.step );
		if ( this.options.min !== null ) {
			precision = Math.max( precision, this._precisionOf( this.options.min ) );
		}
		return precision;
	},

	_precisionOf: function( num ) {
		var str = num.toString(),
			decimal = str.indexOf( "." );
		return decimal === -1 ? 0 : str.length - decimal - 1;
	},

	_adjustValue: function( value ) {
		var base, aboveMin,
			options = this.options;

		// make sure we're at a valid step
		// - find out where we are relative to the base (min or 0)
		base = options.min !== null ? options.min : 0;
		aboveMin = value - base;
		// - round to the nearest step
		aboveMin = Math.round(aboveMin / options.step) * options.step;
		// - rounding is based on 0, so adjust back to our base
		value = base + aboveMin;

		// fix precision from bad JS floating point math
		value = parseFloat( value.toFixed( this._precision() ) );

		// clamp the value
		if ( options.max !== null && value > options.max) {
			return options.max;
		}
		if ( options.min !== null && value < options.min ) {
			return options.min;
		}

		return value;
	},

	_stop: function( event ) {
		if ( !this.spinning ) {
			return;
		}

		clearTimeout( this.timer );
		clearTimeout( this.mousewheelTimer );
		this.counter = 0;
		this.spinning = false;
		this._trigger( "stop", event );
	},

	_setOption: function( key, value ) {
		if ( key === "culture" || key === "numberFormat" ) {
			var prevValue = this._parse( this.element.val() );
			this.options[ key ] = value;
			this.element.val( this._format( prevValue ) );
			return;
		}

		if ( key === "max" || key === "min" || key === "step" ) {
			if ( typeof value === "string" ) {
				value = this._parse( value );
			}
		}
		if ( key === "icons" ) {
			this.buttons.first().find( ".ui-icon" )
				.removeClass( this.options.icons.up )
				.addClass( value.up );
			this.buttons.last().find( ".ui-icon" )
				.removeClass( this.options.icons.down )
				.addClass( value.down );
		}

		this._super( key, value );

		if ( key === "disabled" ) {
			this.widget().toggleClass( "ui-state-disabled", !!value );
			this.element.prop( "disabled", !!value );
			this.buttons.button( value ? "disable" : "enable" );
		}
	},

	_setOptions: spinner_modifier(function( options ) {
		this._super( options );
	}),

	_parse: function( val ) {
		if ( typeof val === "string" && val !== "" ) {
			val = window.Globalize && this.options.numberFormat ?
				Globalize.parseFloat( val, 10, this.options.culture ) : +val;
		}
		return val === "" || isNaN( val ) ? null : val;
	},

	_format: function( value ) {
		if ( value === "" ) {
			return "";
		}
		return window.Globalize && this.options.numberFormat ?
			Globalize.format( value, this.options.numberFormat, this.options.culture ) :
			value;
	},

	_refresh: function() {
		this.element.attr({
			"aria-valuemin": this.options.min,
			"aria-valuemax": this.options.max,
			// TODO: what should we do with values that can't be parsed?
			"aria-valuenow": this._parse( this.element.val() )
		});
	},

	isValid: function() {
		var value = this.value();

		// null is invalid
		if ( value === null ) {
			return false;
		}

		// if value gets adjusted, it's invalid
		return value === this._adjustValue( value );
	},

	// update the value without triggering change
	_value: function( value, allowAny ) {
		var parsed;
		if ( value !== "" ) {
			parsed = this._parse( value );
			if ( parsed !== null ) {
				if ( !allowAny ) {
					parsed = this._adjustValue( parsed );
				}
				value = this._format( parsed );
			}
		}
		this.element.val( value );
		this._refresh();
	},

	_destroy: function() {
		this.element
			.removeClass( "ui-spinner-input" )
			.prop( "disabled", false )
			.removeAttr( "autocomplete" )
			.removeAttr( "role" )
			.removeAttr( "aria-valuemin" )
			.removeAttr( "aria-valuemax" )
			.removeAttr( "aria-valuenow" );
		this.uiSpinner.replaceWith( this.element );
	},

	stepUp: spinner_modifier(function( steps ) {
		this._stepUp( steps );
	}),
	_stepUp: function( steps ) {
		if ( this._start() ) {
			this._spin( (steps || 1) * this.options.step );
			this._stop();
		}
	},

	stepDown: spinner_modifier(function( steps ) {
		this._stepDown( steps );
	}),
	_stepDown: function( steps ) {
		if ( this._start() ) {
			this._spin( (steps || 1) * -this.options.step );
			this._stop();
		}
	},

	pageUp: spinner_modifier(function( pages ) {
		this._stepUp( (pages || 1) * this.options.page );
	}),

	pageDown: spinner_modifier(function( pages ) {
		this._stepDown( (pages || 1) * this.options.page );
	}),

	value: function( newVal ) {
		if ( !arguments.length ) {
			return this._parse( this.element.val() );
		}
		spinner_modifier( this._value ).call( this, newVal );
	},

	widget: function() {
		return this.uiSpinner;
	}
});


/*!
 * jQuery UI Tabs 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tabs/
 */


var tabs = $.widget( "ui.tabs", {
	version: "1.11.4",
	delay: 300,
	options: {
		active: null,
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: (function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			// support: IE7
			// IE7 doesn't normalize the href property when set via script (#9317)
			anchor = anchor.cloneNode( false );

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	})(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this.element
			.addClass( "ui-tabs ui-widget ui-widget-content ui-corner-all" )
			.toggleClass( "ui-tabs-collapsible", options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( $.isArray( options.disabled ) ) {
			options.disabled = $.unique( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				})
			) ).sort();
		}

		// check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 );

		if ( active === null ) {
			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each(function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				});
			}

			// check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// no active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( this.document[0].activeElement ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
			case $.ui.keyCode.RIGHT:
			case $.ui.keyCode.DOWN:
				selectedIndex++;
				break;
			case $.ui.keyCode.UP:
			case $.ui.keyCode.LEFT:
				goingForward = false;
				selectedIndex--;
				break;
			case $.ui.keyCode.END:
				selectedIndex = this.anchors.length - 1;
				break;
			case $.ui.keyCode.HOME:
				selectedIndex = 0;
				break;
			case $.ui.keyCode.SPACE:
				// Activate only, no collapsing
				event.preventDefault();
				clearTimeout( this.activating );
				this._activate( selectedIndex );
				return;
			case $.ui.keyCode.ENTER:
				// Toggle (cancel delayed activation, allow collapsing)
				event.preventDefault();
				clearTimeout( this.activating );
				// Determine if we should collapse or activate
				this._activate( selectedIndex === this.options.active ? false : selectedIndex );
				return;
			default:
				return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay(function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.focus();
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).focus();
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {
			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "disabled" ) {
			// don't use the widget factory's disabled handling
			this._setupDisabled( value );
			return;
		}

		this._super( key, value);

		if ( key === "collapsible" ) {
			this.element.toggleClass( "ui-tabs-collapsible", value );
			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	_sanitizeSelector: function( hash ) {
		return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		});

		this._processTabs();

		// was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();
		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {
			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();
			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}
		// was active, active tab still exists
		} else {
			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setupDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr({
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		});
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr({
				"aria-hidden": "true"
			});

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.addClass( "ui-tabs-active ui-state-active" )
				.attr({
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				});
			this._getPanelForTab( this.active )
				.show()
				.attr({
					"aria-hidden": "false"
				});
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList()
			.addClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
			.attr( "role", "tablist" )

			// Prevent users from focusing disabled tabs via click
			.delegate( "> li", "mousedown" + this.eventNamespace, function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			})

			// support: IE <9
			// Preventing the default action in mousedown doesn't prevent IE
			// from focusing the element, so if the anchor gets focused, blur.
			// We don't have to worry about focusing the previously focused
			// element since clicking on a non-focusable element should focus
			// the body anyway.
			.delegate( ".ui-tabs-anchor", "focus" + this.eventNamespace, function() {
				if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
					this.blur();
				}
			});

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.addClass( "ui-state-default ui-corner-top" )
			.attr({
				role: "tab",
				tabIndex: -1
			});

		this.anchors = this.tabs.map(function() {
				return $( "a", this )[ 0 ];
			})
			.addClass( "ui-tabs-anchor" )
			.attr({
				role: "presentation",
				tabIndex: -1
			});

		this.panels = $();

		this.anchors.each(function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// inline tab
			if ( that._isLocal( anchor ) ) {
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( that._sanitizeSelector( selector ) );
			// remote tab
			} else {
				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr({
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			});
			panel.attr( "aria-labelledby", anchorId );
		});

		this.panels
			.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
			.attr( "role", "tabpanel" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol,ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
			.data( "ui-tabs-destroy", true );
	},

	_setupDisabled: function( disabled ) {
		if ( $.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// disable tabs
		for ( var i = 0, li; ( li = this.tabs[ i ] ); i++ ) {
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				$( li )
					.addClass( "ui-state-disabled" )
					.attr( "aria-disabled", "true" );
			} else {
				$( li )
					.removeClass( "ui-state-disabled" )
					.removeAttr( "aria-disabled" );
			}
		}

		this.options.disabled = disabled;
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split(" "), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			});
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );
		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		});
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each(function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			});

			this.element.children().not( this.panels ).each(function() {
				maxHeight -= $( this ).outerHeight( true );
			});

			this.panels.each(function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			})
			.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each(function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			}).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||
				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||
				// can't switch durning an animation
				this.running ||
				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||
				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
		}

		function show() {
			eventData.newTab.closest( "li" ).addClass( "ui-tabs-active ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
				show();
			});
		} else {
			eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr({
			"aria-selected": "false",
			"aria-expanded": "false"
		});
		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter(function() {
				return $( this ).attr( "tabIndex" ) === 0;
			})
			.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr({
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		});
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );

		// trying to activate the already active panel
		if ( active[ 0 ] === this.active[ 0 ] ) {
			return;
		}

		// trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler({
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		});
	},

	_findActive: function( index ) {
		return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {
		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" + index + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.element.removeClass( "ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible" );

		this.tablist
			.removeClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
			.removeAttr( "role" );

		this.anchors
			.removeClass( "ui-tabs-anchor" )
			.removeAttr( "role" )
			.removeAttr( "tabIndex" )
			.removeUniqueId();

		this.tablist.unbind( this.eventNamespace );

		this.tabs.add( this.panels ).each(function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this )
					.removeClass( "ui-state-default ui-state-active ui-state-disabled " +
						"ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel" )
					.removeAttr( "tabIndex" )
					.removeAttr( "aria-live" )
					.removeAttr( "aria-busy" )
					.removeAttr( "aria-selected" )
					.removeAttr( "aria-labelledby" )
					.removeAttr( "aria-hidden" )
					.removeAttr( "aria-expanded" )
					.removeAttr( "role" );
			}
		});

		this.tabs.each(function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		});

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( $.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				});
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				});
			}
		}
		this._setupDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( $.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setupDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				tab.removeClass( "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		// support: jQuery <1.8
		// jQuery <1.8 returns false if the request is canceled in beforeSend,
		// but as of 1.8, $.ajax() always returns a jqXHR object.
		if ( this.xhr && this.xhr.statusText !== "canceled" ) {
			tab.addClass( "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done(function( response, status, jqXHR ) {
					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout(function() {
						panel.html( response );
						that._trigger( "load", event, eventData );

						complete( jqXHR, status );
					}, 1 );
				})
				.fail(function( jqXHR, status ) {
					// support: jQuery <1.8
					// http://bugs.jquery.com/ticket/11778
					setTimeout(function() {
						complete( jqXHR, status );
					}, 1 );
				});
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {
			url: anchor.attr( "href" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( this._sanitizeSelector( "#" + id ) );
	}
});


/*!
 * jQuery UI Tooltip 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 */


var tooltip = $.widget( "ui.tooltip", {
	version: "1.11.4",
	options: {
		content: function() {
			// support: IE<9, Opera in jQuery <1.7
			// .text() can't accept undefined, so coerce to a string
			var title = $( this ).attr( "title" ) || "";
			// Escape title, since we're going from an attribute to raw HTML
			return $( "<a>" ).text( title ).html();
		},
		hide: true,
		// Disabled elements have inconsistent behavior across browsers (#8661)
		items: "[title]:not([disabled])",
		position: {
			my: "left top+15",
			at: "left bottom",
			collision: "flipfit flip"
		},
		show: true,
		tooltipClass: null,
		track: false,

		// callbacks
		close: null,
		open: null
	},

	_addDescribedBy: function( elem, id ) {
		var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
		describedby.push( id );
		elem
			.data( "ui-tooltip-id", id )
			.attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
	},

	_removeDescribedBy: function( elem ) {
		var id = elem.data( "ui-tooltip-id" ),
			describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
			index = $.inArray( id, describedby );

		if ( index !== -1 ) {
			describedby.splice( index, 1 );
		}

		elem.removeData( "ui-tooltip-id" );
		describedby = $.trim( describedby.join( " " ) );
		if ( describedby ) {
			elem.attr( "aria-describedby", describedby );
		} else {
			elem.removeAttr( "aria-describedby" );
		}
	},

	_create: function() {
		this._on({
			mouseover: "open",
			focusin: "open"
		});

		// IDs of generated tooltips, needed for destroy
		this.tooltips = {};

		// IDs of parent tooltips where we removed the title attribute
		this.parents = {};

		if ( this.options.disabled ) {
			this._disable();
		}

		// Append the aria-live region so tooltips announce correctly
		this.liveRegion = $( "<div>" )
			.attr({
				role: "log",
				"aria-live": "assertive",
				"aria-relevant": "additions"
			})
			.addClass( "ui-helper-hidden-accessible" )
			.appendTo( this.document[ 0 ].body );
	},

	_setOption: function( key, value ) {
		var that = this;

		if ( key === "disabled" ) {
			this[ value ? "_disable" : "_enable" ]();
			this.options[ key ] = value;
			// disable element style changes
			return;
		}

		this._super( key, value );

		if ( key === "content" ) {
			$.each( this.tooltips, function( id, tooltipData ) {
				that._updateContent( tooltipData.element );
			});
		}
	},

	_disable: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			var event = $.Event( "blur" );
			event.target = event.currentTarget = tooltipData.element[ 0 ];
			that.close( event, true );
		});

		// remove title attributes to prevent native tooltips
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.is( "[title]" ) ) {
				element
					.data( "ui-tooltip-title", element.attr( "title" ) )
					.removeAttr( "title" );
			}
		});
	},

	_enable: function() {
		// restore title attributes
		this.element.find( this.options.items ).addBack().each(function() {
			var element = $( this );
			if ( element.data( "ui-tooltip-title" ) ) {
				element.attr( "title", element.data( "ui-tooltip-title" ) );
			}
		});
	},

	open: function( event ) {
		var that = this,
			target = $( event ? event.target : this.element )
				// we need closest here due to mouseover bubbling,
				// but always pointing at the same event target
				.closest( this.options.items );

		// No element to show a tooltip for or the tooltip is already open
		if ( !target.length || target.data( "ui-tooltip-id" ) ) {
			return;
		}

		if ( target.attr( "title" ) ) {
			target.data( "ui-tooltip-title", target.attr( "title" ) );
		}

		target.data( "ui-tooltip-open", true );

		// kill parent tooltips, custom or native, for hover
		if ( event && event.type === "mouseover" ) {
			target.parents().each(function() {
				var parent = $( this ),
					blurEvent;
				if ( parent.data( "ui-tooltip-open" ) ) {
					blurEvent = $.Event( "blur" );
					blurEvent.target = blurEvent.currentTarget = this;
					that.close( blurEvent, true );
				}
				if ( parent.attr( "title" ) ) {
					parent.uniqueId();
					that.parents[ this.id ] = {
						element: this,
						title: parent.attr( "title" )
					};
					parent.attr( "title", "" );
				}
			});
		}

		this._registerCloseHandlers( event, target );
		this._updateContent( target, event );
	},

	_updateContent: function( target, event ) {
		var content,
			contentOption = this.options.content,
			that = this,
			eventType = event ? event.type : null;

		if ( typeof contentOption === "string" ) {
			return this._open( event, target, contentOption );
		}

		content = contentOption.call( target[0], function( response ) {

			// IE may instantly serve a cached response for ajax requests
			// delay this call to _open so the other call to _open runs first
			that._delay(function() {

				// Ignore async response if tooltip was closed already
				if ( !target.data( "ui-tooltip-open" ) ) {
					return;
				}

				// jQuery creates a special event for focusin when it doesn't
				// exist natively. To improve performance, the native event
				// object is reused and the type is changed. Therefore, we can't
				// rely on the type being correct after the event finished
				// bubbling, so we set it back to the previous value. (#8740)
				if ( event ) {
					event.type = eventType;
				}
				this._open( event, target, response );
			});
		});
		if ( content ) {
			this._open( event, target, content );
		}
	},

	_open: function( event, target, content ) {
		var tooltipData, tooltip, delayedShow, a11yContent,
			positionOption = $.extend( {}, this.options.position );

		if ( !content ) {
			return;
		}

		// Content can be updated multiple times. If the tooltip already
		// exists, then just update the content and bail.
		tooltipData = this._find( target );
		if ( tooltipData ) {
			tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
			return;
		}

		// if we have a title, clear it to prevent the native tooltip
		// we have to check first to avoid defining a title if none exists
		// (we don't want to cause an element to start matching [title])
		//
		// We use removeAttr only for key events, to allow IE to export the correct
		// accessible attributes. For mouse events, set to empty string to avoid
		// native tooltip showing up (happens only when removing inside mouseover).
		if ( target.is( "[title]" ) ) {
			if ( event && event.type === "mouseover" ) {
				target.attr( "title", "" );
			} else {
				target.removeAttr( "title" );
			}
		}

		tooltipData = this._tooltip( target );
		tooltip = tooltipData.tooltip;
		this._addDescribedBy( target, tooltip.attr( "id" ) );
		tooltip.find( ".ui-tooltip-content" ).html( content );

		// Support: Voiceover on OS X, JAWS on IE <= 9
		// JAWS announces deletions even when aria-relevant="additions"
		// Voiceover will sometimes re-read the entire log region's contents from the beginning
		this.liveRegion.children().hide();
		if ( content.clone ) {
			a11yContent = content.clone();
			a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
		} else {
			a11yContent = content;
		}
		$( "<div>" ).html( a11yContent ).appendTo( this.liveRegion );

		function position( event ) {
			positionOption.of = event;
			if ( tooltip.is( ":hidden" ) ) {
				return;
			}
			tooltip.position( positionOption );
		}
		if ( this.options.track && event && /^mouse/.test( event.type ) ) {
			this._on( this.document, {
				mousemove: position
			});
			// trigger once to override element-relative positioning
			position( event );
		} else {
			tooltip.position( $.extend({
				of: target
			}, this.options.position ) );
		}

		tooltip.hide();

		this._show( tooltip, this.options.show );
		// Handle tracking tooltips that are shown with a delay (#8644). As soon
		// as the tooltip is visible, position the tooltip using the most recent
		// event.
		if ( this.options.show && this.options.show.delay ) {
			delayedShow = this.delayedShow = setInterval(function() {
				if ( tooltip.is( ":visible" ) ) {
					position( positionOption.of );
					clearInterval( delayedShow );
				}
			}, $.fx.interval );
		}

		this._trigger( "open", event, { tooltip: tooltip } );
	},

	_registerCloseHandlers: function( event, target ) {
		var events = {
			keyup: function( event ) {
				if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
					var fakeEvent = $.Event(event);
					fakeEvent.currentTarget = target[0];
					this.close( fakeEvent, true );
				}
			}
		};

		// Only bind remove handler for delegated targets. Non-delegated
		// tooltips will handle this in destroy.
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			events.remove = function() {
				this._removeTooltip( this._find( target ).tooltip );
			};
		}

		if ( !event || event.type === "mouseover" ) {
			events.mouseleave = "close";
		}
		if ( !event || event.type === "focusin" ) {
			events.focusout = "close";
		}
		this._on( true, target, events );
	},

	close: function( event ) {
		var tooltip,
			that = this,
			target = $( event ? event.currentTarget : this.element ),
			tooltipData = this._find( target );

		// The tooltip may already be closed
		if ( !tooltipData ) {

			// We set ui-tooltip-open immediately upon open (in open()), but only set the
			// additional data once there's actually content to show (in _open()). So even if the
			// tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
			// the period between open() and _open().
			target.removeData( "ui-tooltip-open" );
			return;
		}

		tooltip = tooltipData.tooltip;

		// disabling closes the tooltip, so we need to track when we're closing
		// to avoid an infinite loop in case the tooltip becomes disabled on close
		if ( tooltipData.closing ) {
			return;
		}

		// Clear the interval for delayed tracking tooltips
		clearInterval( this.delayedShow );

		// only set title if we had one before (see comment in _open())
		// If the title attribute has changed since open(), don't restore
		if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
			target.attr( "title", target.data( "ui-tooltip-title" ) );
		}

		this._removeDescribedBy( target );

		tooltipData.hiding = true;
		tooltip.stop( true );
		this._hide( tooltip, this.options.hide, function() {
			that._removeTooltip( $( this ) );
		});

		target.removeData( "ui-tooltip-open" );
		this._off( target, "mouseleave focusout keyup" );

		// Remove 'remove' binding only on delegated targets
		if ( target[ 0 ] !== this.element[ 0 ] ) {
			this._off( target, "remove" );
		}
		this._off( this.document, "mousemove" );

		if ( event && event.type === "mouseleave" ) {
			$.each( this.parents, function( id, parent ) {
				$( parent.element ).attr( "title", parent.title );
				delete that.parents[ id ];
			});
		}

		tooltipData.closing = true;
		this._trigger( "close", event, { tooltip: tooltip } );
		if ( !tooltipData.hiding ) {
			tooltipData.closing = false;
		}
	},

	_tooltip: function( element ) {
		var tooltip = $( "<div>" )
				.attr( "role", "tooltip" )
				.addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
					( this.options.tooltipClass || "" ) ),
			id = tooltip.uniqueId().attr( "id" );

		$( "<div>" )
			.addClass( "ui-tooltip-content" )
			.appendTo( tooltip );

		tooltip.appendTo( this.document[0].body );

		return this.tooltips[ id ] = {
			element: element,
			tooltip: tooltip
		};
	},

	_find: function( target ) {
		var id = target.data( "ui-tooltip-id" );
		return id ? this.tooltips[ id ] : null;
	},

	_removeTooltip: function( tooltip ) {
		tooltip.remove();
		delete this.tooltips[ tooltip.attr( "id" ) ];
	},

	_destroy: function() {
		var that = this;

		// close open tooltips
		$.each( this.tooltips, function( id, tooltipData ) {
			// Delegate to close method to handle common cleanup
			var event = $.Event( "blur" ),
				element = tooltipData.element;
			event.target = event.currentTarget = element[ 0 ];
			that.close( event, true );

			// Remove immediately; destroying an open tooltip doesn't use the
			// hide animation
			$( "#" + id ).remove();

			// Restore the title
			if ( element.data( "ui-tooltip-title" ) ) {
				// If the title attribute has changed since open(), don't restore
				if ( !element.attr( "title" ) ) {
					element.attr( "title", element.data( "ui-tooltip-title" ) );
				}
				element.removeData( "ui-tooltip-title" );
			}
		});
		this.liveRegion.remove();
	}
});



}));

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.Jcrop.js v0.9.12
 * jQuery Image Cropping Plugin - released under MIT License
 * Author: Kelly Hallman <khallman@gmail.com>
 * http://github.com/tapmodo/Jcrop
 * Copyright (c) 2008-2013 Tapmodo Interactive LLC {{{
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * }}}
 */

(function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(root.jQuery || root.$ || require('jquery'));
    } else {
        root.Jcrop = factory();
    }
}(this, function($) {
    var Jcrop = function (obj, opt) {
        var options = $.extend({}, Jcrop.defaults),
            docOffset,
            _ua = navigator.userAgent.toLowerCase(),
            is_msie = /msie/.test(_ua),
            ie6mode = /msie [1-6]\./.test(_ua);

        // Internal Methods {{{
        function px(n) {
            return Math.round(n) + 'px';
        }

        function cssClass(cl) {
            return options.baseClass + '-' + cl;
        }

        function supportsColorFade() {
            return $.fx.step.hasOwnProperty('backgroundColor');
        }

        function getPos(obj) //{{{
        {
            var pos = $(obj).offset();
            return [pos.left, pos.top];
        }

        //}}}
        function mouseAbs(e) //{{{
        {
            return [(e.pageX - docOffset[0]), (e.pageY - docOffset[1])];
        }

        //}}}
        function setOptions(opt) //{{{
        {
            if (typeof(opt) !== 'object') opt = {};
            options = $.extend(options, opt);

            $.each(['onChange', 'onSelect', 'onRelease', 'onDblClick'], function (i, e) {
                if (typeof(options[e]) !== 'function') options[e] = function () {
                };
            });
        }

        //}}}
        function startDragMode(mode, pos, touch) //{{{
        {
            docOffset = getPos($img);
            Tracker.setCursor(mode === 'move' ? mode : mode + '-resize');

            if (mode === 'move') {
                return Tracker.activateHandlers(createMover(pos), doneSelect, touch);
            }

            var fc = Coords.getFixed();
            var opp = oppLockCorner(mode);
            var opc = Coords.getCorner(oppLockCorner(opp));

            Coords.setPressed(Coords.getCorner(opp));
            Coords.setCurrent(opc);

            Tracker.activateHandlers(dragmodeHandler(mode, fc), doneSelect, touch);
        }

        //}}}
        function dragmodeHandler(mode, f) //{{{
        {
            return function (pos) {
                if (!options.aspectRatio) {
                    switch (mode) {
                        case 'e':
                            pos[1] = f.y2;
                            break;
                        case 'w':
                            pos[1] = f.y2;
                            break;
                        case 'n':
                            pos[0] = f.x2;
                            break;
                        case 's':
                            pos[0] = f.x2;
                            break;
                    }
                } else {
                    switch (mode) {
                        case 'e':
                            pos[1] = f.y + 1;
                            break;
                        case 'w':
                            pos[1] = f.y + 1;
                            break;
                        case 'n':
                            pos[0] = f.x + 1;
                            break;
                        case 's':
                            pos[0] = f.x + 1;
                            break;
                    }
                }
                Coords.setCurrent(pos);
                Selection.update();
            };
        }

        //}}}
        function createMover(pos) //{{{
        {
            var lloc = pos;
            KeyManager.watchKeys();

            return function (pos) {
                Coords.moveOffset([pos[0] - lloc[0], pos[1] - lloc[1]]);
                lloc = pos;

                Selection.update();
            };
        }

        //}}}
        function oppLockCorner(ord) //{{{
        {
            switch (ord) {
                case 'n':
                    return 'sw';
                case 's':
                    return 'nw';
                case 'e':
                    return 'nw';
                case 'w':
                    return 'ne';
                case 'ne':
                    return 'sw';
                case 'nw':
                    return 'se';
                case 'se':
                    return 'nw';
                case 'sw':
                    return 'ne';
            }
        }

        //}}}
        function createDragger(ord) //{{{
        {
            return function (e) {
                if (options.disabled) {
                    return false;
                }
                if ((ord === 'move') && !options.allowMove) {
                    return false;
                }

                // Fix position of crop area when dragged the very first time.
                // Necessary when crop image is in a hidden element when page is loaded.
                docOffset = getPos($img);

                btndown = true;
                startDragMode(ord, mouseAbs(e));
                e.stopPropagation();
                e.preventDefault();
                return false;
            };
        }

        //}}}
        function presize($obj, w, h) //{{{
        {
            var nw = $obj.width(),
                nh = $obj.height();
            if ((nw > w) && w > 0) {
                nw = w;
                nh = (w / $obj.width()) * $obj.height();
            }
            if ((nh > h) && h > 0) {
                nh = h;
                nw = (h / $obj.height()) * $obj.width();
            }
            xscale = $obj.width() / nw;
            yscale = $obj.height() / nh;
            $obj.width(nw).height(nh);
        }

        //}}}
        function unscale(c) //{{{
        {
            return {
                x: c.x * xscale,
                y: c.y * yscale,
                x2: c.x2 * xscale,
                y2: c.y2 * yscale,
                w: c.w * xscale,
                h: c.h * yscale
            };
        }

        //}}}
        function doneSelect(pos) //{{{
        {
            var c = Coords.getFixed();
            if ((c.w > options.minSelect[0]) && (c.h > options.minSelect[1])) {
                Selection.enableHandles();
                Selection.done();
            } else {
                Selection.release();
            }
            Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
        }

        //}}}
        function newSelection(e) //{{{
        {
            if (options.disabled) {
                return;
            }
            if (!options.allowSelect) {
                return;
            }
            btndown = true;
            docOffset = getPos($img);
            Selection.disableHandles();
            Tracker.setCursor('crosshair');
            var pos = mouseAbs(e);
            Coords.setPressed(pos);
            Selection.update();
            Tracker.activateHandlers(selectDrag, doneSelect, e.type.substring(0, 5) === 'touch');
            KeyManager.watchKeys();

            e.stopPropagation();
            e.preventDefault();
            return false;
        }

        //}}}
        function selectDrag(pos) //{{{
        {
            Coords.setCurrent(pos);
            Selection.update();
        }

        //}}}
        function newTracker() //{{{
        {
            var trk = $('<div></div>').addClass(cssClass('tracker'));
            if (is_msie) {
                trk.css({
                    opacity: 0,
                    backgroundColor: 'white'
                });
            }
            return trk;
        }

        //}}}

        // }}}
        // Initialization {{{
        // Sanitize some options {{{
        if (typeof(obj) !== 'object') {
            obj = $(obj)[0];
        }
        if (typeof(opt) !== 'object') {
            opt = {};
        }
        // }}}
        setOptions(opt);
        // Initialize some jQuery objects {{{
        // The values are SET on the image(s) for the interface
        // If the original image has any of these set, they will be reset
        // However, if you destroy() the Jcrop instance the original image's
        // character in the DOM will be as you left it.
        var img_css = {
            border: 'none',
            visibility: 'visible',
            margin: 0,
            padding: 0,
            position: 'absolute',
            top: 0,
            left: 0
        };

        var $origimg = $(obj),
            img_mode = true;

        if (obj.tagName == 'IMG') {
            // Fix size of crop image.
            // Necessary when crop image is within a hidden element when page is loaded.
            if ($origimg[0].width != 0 && $origimg[0].height != 0) {
                // Obtain dimensions from contained img element.
                $origimg.width($origimg[0].width);
                $origimg.height($origimg[0].height);
            } else {
                // Obtain dimensions from temporary image in case the original is not loaded yet (e.g. IE 7.0).
                var tempImage = new Image();
                tempImage.src = $origimg[0].src;
                $origimg.width(tempImage.width);
                $origimg.height(tempImage.height);
            }

            var $img = $origimg.clone().removeAttr('id').css(img_css).show();

            $img.width($origimg.width());
            $img.height($origimg.height());
            $origimg.after($img).hide();

        } else {
            $img = $origimg.css(img_css).show();
            img_mode = false;
            if (options.shade === null) {
                options.shade = true;
            }
        }

        presize($img, options.boxWidth, options.boxHeight);

        var boundx = $img.width(),
            boundy = $img.height(),


            $div = $('<div />').width(boundx).height(boundy).addClass(cssClass('holder')).css({
                position: 'relative',
                backgroundColor: options.bgColor
            }).insertAfter($origimg).append($img);

        if (options.addClass) {
            $div.addClass(options.addClass);
        }

        var $img2 = $('<div />'),

            $img_holder = $('<div />')
                .width('100%').height('100%').css({
                    zIndex: 310,
                    position: 'absolute',
                    overflow: 'hidden'
                }),

            $hdl_holder = $('<div />')
                .width('100%').height('100%').css('zIndex', 320),

            $sel = $('<div />')
                .css({
                    position: 'absolute',
                    zIndex: 600
                }).dblclick(function () {
                    var c = Coords.getFixed();
                    options.onDblClick.call(api, c);
                }).insertBefore($img).append($img_holder, $hdl_holder);

        if (img_mode) {

            $img2 = $('<img />')
                .attr('src', $img.attr('src')).css(img_css).width(boundx).height(boundy),

                $img_holder.append($img2);

        }

        if (ie6mode) {
            $sel.css({
                overflowY: 'hidden'
            });
        }

        var bound = options.boundary;
        var $trk = newTracker().width(boundx + (bound * 2)).height(boundy + (bound * 2)).css({
            position: 'absolute',
            top: px(-bound),
            left: px(-bound),
            zIndex: 290
        }).mousedown(newSelection);

        /* }}} */
        // Set more variables {{{
        var bgcolor = options.bgColor,
            bgopacity = options.bgOpacity,
            xlimit, ylimit, xmin, ymin, xscale, yscale, enabled = true,
            btndown, animating, shift_down;

        docOffset = getPos($img);
        // }}}
        // }}}
        // Internal Modules {{{
        // Touch Module {{{
        var Touch = (function () {
            // Touch support detection function adapted (under MIT License)
            // from code by Jeffrey Sambells - http://github.com/iamamused/
            function hasTouchSupport() {
                var support = {}, events = ['touchstart', 'touchmove', 'touchend'],
                    el = document.createElement('div'), i;

                try {
                    for (i = 0; i < events.length; i++) {
                        var eventName = events[i];
                        eventName = 'on' + eventName;
                        var isSupported = (eventName in el);
                        if (!isSupported) {
                            el.setAttribute(eventName, 'return;');
                            isSupported = typeof el[eventName] == 'function';
                        }
                        support[events[i]] = isSupported;
                    }
                    return support.touchstart && support.touchend && support.touchmove;
                }
                catch (err) {
                    return false;
                }
            }

            function detectSupport() {
                if ((options.touchSupport === true) || (options.touchSupport === false)) return options.touchSupport;
                else return hasTouchSupport();
            }

            return {
                createDragger: function (ord) {
                    return function (e) {
                        if (options.disabled) {
                            return false;
                        }
                        if ((ord === 'move') && !options.allowMove) {
                            return false;
                        }
                        docOffset = getPos($img);
                        btndown = true;
                        startDragMode(ord, mouseAbs(Touch.cfilter(e)), true);
                        e.stopPropagation();
                        e.preventDefault();
                        return false;
                    };
                },
                newSelection: function (e) {
                    return newSelection(Touch.cfilter(e));
                },
                cfilter: function (e) {
                    e.pageX = e.originalEvent.changedTouches[0].pageX;
                    e.pageY = e.originalEvent.changedTouches[0].pageY;
                    return e;
                },
                isSupported: hasTouchSupport,
                support: detectSupport()
            };
        }());
        // }}}
        // Coords Module {{{
        var Coords = (function () {
            var x1 = 0,
                y1 = 0,
                x2 = 0,
                y2 = 0,
                ox, oy;

            function setPressed(pos) //{{{
            {
                pos = rebound(pos);
                x2 = x1 = pos[0];
                y2 = y1 = pos[1];
            }

            //}}}
            function setCurrent(pos) //{{{
            {
                pos = rebound(pos);
                ox = pos[0] - x2;
                oy = pos[1] - y2;
                x2 = pos[0];
                y2 = pos[1];
            }

            //}}}
            function getOffset() //{{{
            {
                return [ox, oy];
            }

            //}}}
            function moveOffset(offset) //{{{
            {
                var ox = offset[0],
                    oy = offset[1];

                if (0 > x1 + ox) {
                    ox -= ox + x1;
                }
                if (0 > y1 + oy) {
                    oy -= oy + y1;
                }

                if (boundy < y2 + oy) {
                    oy += boundy - (y2 + oy);
                }
                if (boundx < x2 + ox) {
                    ox += boundx - (x2 + ox);
                }

                x1 += ox;
                x2 += ox;
                y1 += oy;
                y2 += oy;
            }

            //}}}
            function getCorner(ord) //{{{
            {
                var c = getFixed();
                switch (ord) {
                    case 'ne':
                        return [c.x2, c.y];
                    case 'nw':
                        return [c.x, c.y];
                    case 'se':
                        return [c.x2, c.y2];
                    case 'sw':
                        return [c.x, c.y2];
                }
            }

            //}}}
            function getFixed() //{{{
            {
                if (!options.aspectRatio) {
                    return getRect();
                }
                // This function could use some optimization I think...
                var aspect = options.aspectRatio,
                    min_x = options.minSize[0] / xscale,


                //min_y = options.minSize[1]/yscale,
                    max_x = options.maxSize[0] / xscale,
                    max_y = options.maxSize[1] / yscale,
                    rw = x2 - x1,
                    rh = y2 - y1,
                    rwa = Math.abs(rw),
                    rha = Math.abs(rh),
                    real_ratio = rwa / rha,
                    xx, yy, w, h;

                if (max_x === 0) {
                    max_x = boundx * 10;
                }
                if (max_y === 0) {
                    max_y = boundy * 10;
                }
                if (real_ratio < aspect) {
                    yy = y2;
                    w = rha * aspect;
                    xx = rw < 0 ? x1 - w : w + x1;

                    if (xx < 0) {
                        xx = 0;
                        h = Math.abs((xx - x1) / aspect);
                        yy = rh < 0 ? y1 - h : h + y1;
                    } else if (xx > boundx) {
                        xx = boundx;
                        h = Math.abs((xx - x1) / aspect);
                        yy = rh < 0 ? y1 - h : h + y1;
                    }
                } else {
                    xx = x2;
                    h = rwa / aspect;
                    yy = rh < 0 ? y1 - h : y1 + h;
                    if (yy < 0) {
                        yy = 0;
                        w = Math.abs((yy - y1) * aspect);
                        xx = rw < 0 ? x1 - w : w + x1;
                    } else if (yy > boundy) {
                        yy = boundy;
                        w = Math.abs(yy - y1) * aspect;
                        xx = rw < 0 ? x1 - w : w + x1;
                    }
                }

                // Magic %-)
                if (xx > x1) { // right side
                    if (xx - x1 < min_x) {
                        xx = x1 + min_x;
                    } else if (xx - x1 > max_x) {
                        xx = x1 + max_x;
                    }
                    if (yy > y1) {
                        yy = y1 + (xx - x1) / aspect;
                    } else {
                        yy = y1 - (xx - x1) / aspect;
                    }
                } else if (xx < x1) { // left side
                    if (x1 - xx < min_x) {
                        xx = x1 - min_x;
                    } else if (x1 - xx > max_x) {
                        xx = x1 - max_x;
                    }
                    if (yy > y1) {
                        yy = y1 + (x1 - xx) / aspect;
                    } else {
                        yy = y1 - (x1 - xx) / aspect;
                    }
                }

                if (xx < 0) {
                    x1 -= xx;
                    xx = 0;
                } else if (xx > boundx) {
                    x1 -= xx - boundx;
                    xx = boundx;
                }

                if (yy < 0) {
                    y1 -= yy;
                    yy = 0;
                } else if (yy > boundy) {
                    y1 -= yy - boundy;
                    yy = boundy;
                }

                return makeObj(flipCoords(x1, y1, xx, yy));
            }

            //}}}
            function rebound(p) //{{{
            {
                if (p[0] < 0) p[0] = 0;
                if (p[1] < 0) p[1] = 0;

                if (p[0] > boundx) p[0] = boundx;
                if (p[1] > boundy) p[1] = boundy;

                return [Math.round(p[0]), Math.round(p[1])];
            }

            //}}}
            function flipCoords(x1, y1, x2, y2) //{{{
            {
                var xa = x1,
                    xb = x2,
                    ya = y1,
                    yb = y2;
                if (x2 < x1) {
                    xa = x2;
                    xb = x1;
                }
                if (y2 < y1) {
                    ya = y2;
                    yb = y1;
                }
                return [xa, ya, xb, yb];
            }

            //}}}
            function getRect() //{{{
            {
                var xsize = x2 - x1,
                    ysize = y2 - y1,
                    delta;

                if (xlimit && (Math.abs(xsize) > xlimit)) {
                    x2 = (xsize > 0) ? (x1 + xlimit) : (x1 - xlimit);
                }
                if (ylimit && (Math.abs(ysize) > ylimit)) {
                    y2 = (ysize > 0) ? (y1 + ylimit) : (y1 - ylimit);
                }

                if (ymin / yscale && (Math.abs(ysize) < ymin / yscale)) {
                    y2 = (ysize > 0) ? (y1 + ymin / yscale) : (y1 - ymin / yscale);
                }
                if (xmin / xscale && (Math.abs(xsize) < xmin / xscale)) {
                    x2 = (xsize > 0) ? (x1 + xmin / xscale) : (x1 - xmin / xscale);
                }

                if (x1 < 0) {
                    x2 -= x1;
                    x1 -= x1;
                }
                if (y1 < 0) {
                    y2 -= y1;
                    y1 -= y1;
                }
                if (x2 < 0) {
                    x1 -= x2;
                    x2 -= x2;
                }
                if (y2 < 0) {
                    y1 -= y2;
                    y2 -= y2;
                }
                if (x2 > boundx) {
                    delta = x2 - boundx;
                    x1 -= delta;
                    x2 -= delta;
                }
                if (y2 > boundy) {
                    delta = y2 - boundy;
                    y1 -= delta;
                    y2 -= delta;
                }
                if (x1 > boundx) {
                    delta = x1 - boundy;
                    y2 -= delta;
                    y1 -= delta;
                }
                if (y1 > boundy) {
                    delta = y1 - boundy;
                    y2 -= delta;
                    y1 -= delta;
                }

                return makeObj(flipCoords(x1, y1, x2, y2));
            }

            //}}}
            function makeObj(a) //{{{
            {
                return {
                    x: a[0],
                    y: a[1],
                    x2: a[2],
                    y2: a[3],
                    w: a[2] - a[0],
                    h: a[3] - a[1]
                };
            }

            //}}}

            return {
                flipCoords: flipCoords,
                setPressed: setPressed,
                setCurrent: setCurrent,
                getOffset: getOffset,
                moveOffset: moveOffset,
                getCorner: getCorner,
                getFixed: getFixed
            };
        }());

        //}}}
        // Shade Module {{{
        var Shade = (function () {
            var enabled = false,
                holder = $('<div />').css({
                    position: 'absolute',
                    zIndex: 240,
                    opacity: 0
                }),
                shades = {
                    top: createShade(),
                    left: createShade().height(boundy),
                    right: createShade().height(boundy),
                    bottom: createShade()
                };

            function resizeShades(w, h) {
                shades.left.css({height: px(h)});
                shades.right.css({height: px(h)});
            }

            function updateAuto() {
                return updateShade(Coords.getFixed());
            }

            function updateShade(c) {
                shades.top.css({
                    left: px(c.x),
                    width: px(c.w),
                    height: px(c.y)
                });
                shades.bottom.css({
                    top: px(c.y2),
                    left: px(c.x),
                    width: px(c.w),
                    height: px(boundy - c.y2)
                });
                shades.right.css({
                    left: px(c.x2),
                    width: px(boundx - c.x2)
                });
                shades.left.css({
                    width: px(c.x)
                });
            }

            function createShade() {
                return $('<div />').css({
                    position: 'absolute',
                    backgroundColor: options.shadeColor || options.bgColor
                }).appendTo(holder);
            }

            function enableShade() {
                if (!enabled) {
                    enabled = true;
                    holder.insertBefore($img);
                    updateAuto();
                    Selection.setBgOpacity(1, 0, 1);
                    $img2.hide();

                    setBgColor(options.shadeColor || options.bgColor, 1);
                    if (Selection.isAwake()) {
                        setOpacity(options.bgOpacity, 1);
                    }
                    else setOpacity(1, 1);
                }
            }

            function setBgColor(color, now) {
                colorChangeMacro(getShades(), color, now);
            }

            function disableShade() {
                if (enabled) {
                    holder.remove();
                    $img2.show();
                    enabled = false;
                    if (Selection.isAwake()) {
                        Selection.setBgOpacity(options.bgOpacity, 1, 1);
                    } else {
                        Selection.setBgOpacity(1, 1, 1);
                        Selection.disableHandles();
                    }
                    colorChangeMacro($div, 0, 1);
                }
            }

            function setOpacity(opacity, now) {
                if (enabled) {
                    if (options.bgFade && !now) {
                        holder.animate({
                            opacity: 1 - opacity
                        }, {
                            queue: false,
                            duration: options.fadeTime
                        });
                    }
                    else holder.css({opacity: 1 - opacity});
                }
            }

            function refreshAll() {
                options.shade ? enableShade() : disableShade();
                if (Selection.isAwake()) setOpacity(options.bgOpacity);
            }

            function getShades() {
                return holder.children();
            }

            return {
                update: updateAuto,
                updateRaw: updateShade,
                getShades: getShades,
                setBgColor: setBgColor,
                enable: enableShade,
                disable: disableShade,
                resize: resizeShades,
                refresh: refreshAll,
                opacity: setOpacity
            };
        }());
        // }}}
        // Selection Module {{{
        var Selection = (function () {
            var awake,
                hdep = 370,
                borders = {},
                handle = {},
                dragbar = {},
                seehandles = false;

            // Private Methods
            function insertBorder(type) //{{{
            {
                var jq = $('<div />').css({
                    position: 'absolute',
                    opacity: options.borderOpacity
                }).addClass(cssClass(type));
                $img_holder.append(jq);
                return jq;
            }

            //}}}
            function dragDiv(ord, zi) //{{{
            {
                var jq = $('<div />').mousedown(createDragger(ord)).css({
                    cursor: ord + '-resize',
                    position: 'absolute',
                    zIndex: zi
                }).addClass('ord-' + ord);

                if (Touch.support) {
                    jq.bind('touchstart.jcrop', Touch.createDragger(ord));
                }

                $hdl_holder.append(jq);
                return jq;
            }

            //}}}
            function insertHandle(ord) //{{{
            {
                var hs = options.handleSize,

                    div = dragDiv(ord, hdep++).css({
                        opacity: options.handleOpacity
                    }).addClass(cssClass('handle'));

                if (hs) {
                    div.width(hs).height(hs);
                }

                return div;
            }

            //}}}
            function insertDragbar(ord) //{{{
            {
                return dragDiv(ord, hdep++).addClass('jcrop-dragbar');
            }

            //}}}
            function createDragbars(li) //{{{
            {
                var i;
                for (i = 0; i < li.length; i++) {
                    dragbar[li[i]] = insertDragbar(li[i]);
                }
            }

            //}}}
            function createBorders(li) //{{{
            {
                var cl, i;
                for (i = 0; i < li.length; i++) {
                    switch (li[i]) {
                        case'n':
                            cl = 'hline';
                            break;
                        case's':
                            cl = 'hline bottom';
                            break;
                        case'e':
                            cl = 'vline right';
                            break;
                        case'w':
                            cl = 'vline';
                            break;
                    }
                    borders[li[i]] = insertBorder(cl);
                }
            }

            //}}}
            function createHandles(li) //{{{
            {
                var i;
                for (i = 0; i < li.length; i++) {
                    handle[li[i]] = insertHandle(li[i]);
                }
            }

            //}}}
            function moveto(x, y) //{{{
            {
                if (!options.shade) {
                    $img2.css({
                        top: px(-y),
                        left: px(-x)
                    });
                }
                $sel.css({
                    top: px(y),
                    left: px(x)
                });
            }

            //}}}
            function resize(w, h) //{{{
            {
                $sel.width(Math.round(w)).height(Math.round(h));
            }

            //}}}
            function refresh() //{{{
            {
                var c = Coords.getFixed();

                Coords.setPressed([c.x, c.y]);
                Coords.setCurrent([c.x2, c.y2]);

                updateVisible();
            }

            //}}}

            // Internal Methods
            function updateVisible(select) //{{{
            {
                if (awake) {
                    return update(select);
                }
            }

            //}}}
            function update(select) //{{{
            {
                var c = Coords.getFixed();

                resize(c.w, c.h);
                moveto(c.x, c.y);
                if (options.shade) Shade.updateRaw(c);

                awake || show();

                if (select) {
                    options.onSelect.call(api, unscale(c));
                } else {
                    options.onChange.call(api, unscale(c));
                }
            }

            //}}}
            function setBgOpacity(opacity, force, now) //{{{
            {
                if (!awake && !force) return;
                if (options.bgFade && !now) {
                    $img.animate({
                        opacity: opacity
                    }, {
                        queue: false,
                        duration: options.fadeTime
                    });
                } else {
                    $img.css('opacity', opacity);
                }
            }

            //}}}
            function show() //{{{
            {
                $sel.show();

                if (options.shade) Shade.opacity(bgopacity);
                else setBgOpacity(bgopacity, true);

                awake = true;
            }

            //}}}
            function release() //{{{
            {
                disableHandles();
                $sel.hide();

                if (options.shade) Shade.opacity(1);
                else setBgOpacity(1);

                awake = false;
                options.onRelease.call(api);
            }

            //}}}
            function showHandles() //{{{
            {
                if (seehandles) {
                    $hdl_holder.show();
                }
            }

            //}}}
            function enableHandles() //{{{
            {
                seehandles = true;
                if (options.allowResize) {
                    $hdl_holder.show();
                    return true;
                }
            }

            //}}}
            function disableHandles() //{{{
            {
                seehandles = false;
                $hdl_holder.hide();
            }

            //}}}
            function animMode(v) //{{{
            {
                if (v) {
                    animating = true;
                    disableHandles();
                } else {
                    animating = false;
                    enableHandles();
                }
            }

            //}}}
            function done() //{{{
            {
                animMode(false);
                refresh();
            }

            //}}}
            // Insert draggable elements {{{
            // Insert border divs for outline

            if (options.dragEdges && $.isArray(options.createDragbars))
                createDragbars(options.createDragbars);

            if ($.isArray(options.createHandles))
                createHandles(options.createHandles);

            if (options.drawBorders && $.isArray(options.createBorders))
                createBorders(options.createBorders);

            //}}}

            // This is a hack for iOS5 to support drag/move touch functionality
            $(document).bind('touchstart.jcrop-ios', function (e) {
                if ($(e.currentTarget).hasClass('jcrop-tracker')) e.stopPropagation();
            });

            var $track = newTracker().mousedown(createDragger('move')).css({
                cursor: 'move',
                position: 'absolute',
                zIndex: 360
            });

            if (Touch.support) {
                $track.bind('touchstart.jcrop', Touch.createDragger('move'));
            }

            $img_holder.append($track);
            disableHandles();

            return {
                updateVisible: updateVisible,
                update: update,
                release: release,
                refresh: refresh,
                isAwake: function () {
                    return awake;
                },
                setCursor: function (cursor) {
                    $track.css('cursor', cursor);
                },
                enableHandles: enableHandles,
                enableOnly: function () {
                    seehandles = true;
                },
                showHandles: showHandles,
                disableHandles: disableHandles,
                animMode: animMode,
                setBgOpacity: setBgOpacity,
                done: done
            };
        }());

        //}}}
        // Tracker Module {{{
        var Tracker = (function () {
            var onMove = function () {
                },
                onDone = function () {
                },
                trackDoc = options.trackDocument;

            function toFront(touch) //{{{
            {
                $trk.css({
                    zIndex: 450
                });

                if (touch)
                    $(document)
                        .bind('touchmove.jcrop', trackTouchMove)
                        .bind('touchend.jcrop', trackTouchEnd);

                else if (trackDoc)
                    $(document)
                        .bind('mousemove.jcrop', trackMove)
                        .bind('mouseup.jcrop', trackUp);
            }

            //}}}
            function toBack() //{{{
            {
                $trk.css({
                    zIndex: 290
                });
                $(document).unbind('.jcrop');
            }

            //}}}
            function trackMove(e) //{{{
            {
                onMove(mouseAbs(e));
                return false;
            }

            //}}}
            function trackUp(e) //{{{
            {
                e.preventDefault();
                e.stopPropagation();

                if (btndown) {
                    btndown = false;

                    onDone(mouseAbs(e));

                    if (Selection.isAwake()) {
                        options.onSelect.call(api, unscale(Coords.getFixed()));
                    }

                    toBack();
                    onMove = function () {
                    };
                    onDone = function () {
                    };
                }

                return false;
            }

            //}}}
            function activateHandlers(move, done, touch) //{{{
            {
                btndown = true;
                onMove = move;
                onDone = done;
                toFront(touch);
                return false;
            }

            //}}}
            function trackTouchMove(e) //{{{
            {
                onMove(mouseAbs(Touch.cfilter(e)));
                return false;
            }

            //}}}
            function trackTouchEnd(e) //{{{
            {
                return trackUp(Touch.cfilter(e));
            }

            //}}}
            function setCursor(t) //{{{
            {
                $trk.css('cursor', t);
            }

            //}}}

            if (!trackDoc) {
                $trk.mousemove(trackMove).mouseup(trackUp).mouseout(trackUp);
            }

            $img.before($trk);
            return {
                activateHandlers: activateHandlers,
                setCursor: setCursor
            };
        }());
        //}}}
        // KeyManager Module {{{
        var KeyManager = (function () {
            var $keymgr = $('<input type="radio" />').css({
                    position: 'fixed',
                    left: '-120px',
                    width: '12px'
                }).addClass('jcrop-keymgr'),

                $keywrap = $('<div />').css({
                    position: 'absolute',
                    overflow: 'hidden'
                }).append($keymgr);

            function watchKeys() //{{{
            {
                if (options.keySupport) {
                    $keymgr.show();
                    $keymgr.focus();
                }
            }

            //}}}
            function onBlur(e) //{{{
            {
                $keymgr.hide();
            }

            //}}}
            function doNudge(e, x, y) //{{{
            {
                if (options.allowMove) {
                    Coords.moveOffset([x, y]);
                    Selection.updateVisible(true);
                }
                e.preventDefault();
                e.stopPropagation();
            }

            //}}}
            function parseKey(e) //{{{
            {
                if (e.ctrlKey || e.metaKey) {
                    return true;
                }
                shift_down = e.shiftKey ? true : false;
                var nudge = shift_down ? 10 : 1;

                switch (e.keyCode) {
                    case 37:
                        doNudge(e, -nudge, 0);
                        break;
                    case 39:
                        doNudge(e, nudge, 0);
                        break;
                    case 38:
                        doNudge(e, 0, -nudge);
                        break;
                    case 40:
                        doNudge(e, 0, nudge);
                        break;
                    case 27:
                        if (options.allowSelect) Selection.release();
                        break;
                    case 9:
                        return true;
                }

                return false;
            }

            //}}}

            if (options.keySupport) {
                $keymgr.keydown(parseKey).blur(onBlur);
                if (ie6mode || !options.fixedSupport) {
                    $keymgr.css({
                        position: 'absolute',
                        left: '-20px'
                    });
                    $keywrap.append($keymgr).insertBefore($img);
                } else {
                    $keymgr.insertBefore($img);
                }
            }


            return {
                watchKeys: watchKeys
            };
        }());
        //}}}
        // }}}
        // API methods {{{
        function setClass(cname) //{{{
        {
            $div.removeClass().addClass(cssClass('holder')).addClass(cname);
        }

        //}}}
        function animateTo(a, callback) //{{{
        {
            var x1 = a[0] / xscale,
                y1 = a[1] / yscale,
                x2 = a[2] / xscale,
                y2 = a[3] / yscale;

            if (animating) {
                return;
            }

            var animto = Coords.flipCoords(x1, y1, x2, y2),
                c = Coords.getFixed(),
                initcr = [c.x, c.y, c.x2, c.y2],
                animat = initcr,
                interv = options.animationDelay,
                ix1 = animto[0] - initcr[0],
                iy1 = animto[1] - initcr[1],
                ix2 = animto[2] - initcr[2],
                iy2 = animto[3] - initcr[3],
                pcent = 0,
                velocity = options.swingSpeed;

            x1 = animat[0];
            y1 = animat[1];
            x2 = animat[2];
            y2 = animat[3];

            Selection.animMode(true);
            var anim_timer;

            function queueAnimator() {
                window.setTimeout(animator, interv);
            }

            var animator = (function () {
                return function () {
                    pcent += (100 - pcent) / velocity;

                    animat[0] = Math.round(x1 + ((pcent / 100) * ix1));
                    animat[1] = Math.round(y1 + ((pcent / 100) * iy1));
                    animat[2] = Math.round(x2 + ((pcent / 100) * ix2));
                    animat[3] = Math.round(y2 + ((pcent / 100) * iy2));

                    if (pcent >= 99.8) {
                        pcent = 100;
                    }
                    if (pcent < 100) {
                        setSelectRaw(animat);
                        queueAnimator();
                    } else {
                        Selection.done();
                        Selection.animMode(false);
                        if (typeof(callback) === 'function') {
                            callback.call(api);
                        }
                    }
                };
            }());
            queueAnimator();
        }

        //}}}
        function setSelect(rect) //{{{
        {
            setSelectRaw([rect[0] / xscale, rect[1] / yscale, rect[2] / xscale, rect[3] / yscale]);
            options.onSelect.call(api, unscale(Coords.getFixed()));
            Selection.enableHandles();
        }

        //}}}
        function setSelectRaw(l) //{{{
        {
            Coords.setPressed([l[0], l[1]]);
            Coords.setCurrent([l[2], l[3]]);
            Selection.update();
        }

        //}}}
        function tellSelect() //{{{
        {
            return unscale(Coords.getFixed());
        }

        //}}}
        function tellScaled() //{{{
        {
            return Coords.getFixed();
        }

        //}}}
        function setOptionsNew(opt) //{{{
        {
            setOptions(opt);
            interfaceUpdate();
        }

        //}}}
        function disableCrop() //{{{
        {
            options.disabled = true;
            Selection.disableHandles();
            Selection.setCursor('default');
            Tracker.setCursor('default');
        }

        //}}}
        function enableCrop() //{{{
        {
            options.disabled = false;
            interfaceUpdate();
        }

        //}}}
        function cancelCrop() //{{{
        {
            Selection.done();
            Tracker.activateHandlers(null, null);
        }

        //}}}
        function destroy() //{{{
        {
            $div.remove();
            $origimg.show();
            $origimg.css('visibility', 'visible');
            $(obj).removeData('Jcrop');
        }

        //}}}
        function setImage(src, callback) //{{{
        {
            Selection.release();
            disableCrop();
            var img = new Image();
            img.onload = function () {
                var iw = img.width;
                var ih = img.height;
                var bw = options.boxWidth;
                var bh = options.boxHeight;
                $img.width(iw).height(ih);
                $img.attr('src', src);
                $img2.attr('src', src);
                presize($img, bw, bh);
                boundx = $img.width();
                boundy = $img.height();
                $img2.width(boundx).height(boundy);
                $trk.width(boundx + (bound * 2)).height(boundy + (bound * 2));
                $div.width(boundx).height(boundy);
                Shade.resize(boundx, boundy);
                enableCrop();

                if (typeof(callback) === 'function') {
                    callback.call(api);
                }
            };
            img.src = src;
        }

        //}}}
        function colorChangeMacro($obj, color, now) {
            var mycolor = color || options.bgColor;
            if (options.bgFade && supportsColorFade() && options.fadeTime && !now) {
                $obj.animate({
                    backgroundColor: mycolor
                }, {
                    queue: false,
                    duration: options.fadeTime
                });
            } else {
                $obj.css('backgroundColor', mycolor);
            }
        }

        function interfaceUpdate(alt) //{{{
        // This method tweaks the interface based on options object.
        // Called when options are changed and at end of initialization.
        {
            if (options.allowResize) {
                if (alt) {
                    Selection.enableOnly();
                } else {
                    Selection.enableHandles();
                }
            } else {
                Selection.disableHandles();
            }

            Tracker.setCursor(options.allowSelect ? 'crosshair' : 'default');
            Selection.setCursor(options.allowMove ? 'move' : 'default');

            if (options.hasOwnProperty('trueSize')) {
                xscale = options.trueSize[0] / boundx;
                yscale = options.trueSize[1] / boundy;
            }

            if (options.hasOwnProperty('setSelect')) {
                setSelect(options.setSelect);
                Selection.done();
                delete(options.setSelect);
            }

            Shade.refresh();

            if (options.bgColor != bgcolor) {
                colorChangeMacro(
                    options.shade ? Shade.getShades() : $div,
                    options.shade ?
                        (options.shadeColor || options.bgColor) :
                        options.bgColor
                );
                bgcolor = options.bgColor;
            }

            if (bgopacity != options.bgOpacity) {
                bgopacity = options.bgOpacity;
                if (options.shade) Shade.refresh();
                else Selection.setBgOpacity(bgopacity);
            }

            xlimit = options.maxSize[0] || 0;
            ylimit = options.maxSize[1] || 0;
            xmin = options.minSize[0] || 0;
            ymin = options.minSize[1] || 0;

            if (options.hasOwnProperty('outerImage')) {
                $img.attr('src', options.outerImage);
                delete(options.outerImage);
            }

            Selection.refresh();
        }

        //}}}
        //}}}

        if (Touch.support) $trk.bind('touchstart.jcrop', Touch.newSelection);

        $hdl_holder.hide();
        interfaceUpdate(true);

        var api = {
            setImage: setImage,
            animateTo: animateTo,
            setSelect: setSelect,
            setOptions: setOptionsNew,
            tellSelect: tellSelect,
            tellScaled: tellScaled,
            setClass: setClass,

            disable: disableCrop,
            enable: enableCrop,
            cancel: cancelCrop,
            release: Selection.release,
            destroy: destroy,

            focus: KeyManager.watchKeys,

            getBounds: function () {
                return [boundx * xscale, boundy * yscale];
            },
            getWidgetSize: function () {
                return [boundx, boundy];
            },
            getScaleFactor: function () {
                return [xscale, yscale];
            },
            getOptions: function () {
                // careful: internal values are returned
                return options;
            },

            ui: {
                holder: $div,
                selection: $sel
            }
        };

        if (is_msie) $div.bind('selectstart', function () {
            return false;
        });

        $origimg.data('Jcrop', api);
        return api;
    };

    $.fn.Jcrop = function (options, callback) //{{{
    {
        var api;
        // Iterate over each object, attach Jcrop
        this.each(function () {
            // If we've already attached to this object
            if ($(this).data('Jcrop')) {
                // The API can be requested this way (undocumented)
                if (options === 'api') return $(this).data('Jcrop');
                // Otherwise, we just reset the options...
                else $(this).data('Jcrop').setOptions(options);
            }
            // If we haven't been attached, preload and attach
            else {
                if (this.tagName == 'IMG')
                    Jcrop.Loader(this, function () {
                        $(this).css({display: 'block', visibility: 'hidden'});
                        api = Jcrop(this, options);
                        if ($.isFunction(callback)) callback.call(api);
                    });
                else {
                    $(this).css({display: 'block', visibility: 'hidden'});
                    api = Jcrop(this, options);
                    if ($.isFunction(callback)) callback.call(api);
                }
            }
        });

        // Return "this" so the object is chainable (jQuery-style)
        return this;
    };
    //}}}
    // $.Jcrop.Loader - basic image loader {{{

    Jcrop.Loader = function (imgobj, success, error) {
        var $img = $(imgobj), img = $img[0];

        function completeCheck() {
            if (img.complete) {
                $img.unbind('.jcloader');
                if ($.isFunction(success)) success.call(img);
            }
            else window.setTimeout(completeCheck, 50);
        }

        $img
            .bind('load.jcloader', completeCheck)
            .bind('error.jcloader', function (e) {
                $img.unbind('.jcloader');
                if ($.isFunction(error)) error.call(img);
            });

        if (img.complete && $.isFunction(success)) {
            $img.unbind('.jcloader');
            success.call(img);
        }
    };

    //}}}
    // Global Defaults {{{
    Jcrop.defaults = {

        // Basic Settings
        allowSelect: true,
        allowMove: true,
        allowResize: true,

        trackDocument: true,

        // Styling Options
        baseClass: 'jcrop',
        addClass: null,
        bgColor: 'black',
        bgOpacity: 0.6,
        bgFade: false,
        borderOpacity: 0.4,
        handleOpacity: 0.5,
        handleSize: null,

        aspectRatio: 0,
        keySupport: true,
        createHandles: ['n', 's', 'e', 'w', 'nw', 'ne', 'se', 'sw'],
        createDragbars: ['n', 's', 'e', 'w'],
        createBorders: ['n', 's', 'e', 'w'],
        drawBorders: true,
        dragEdges: true,
        fixedSupport: true,
        touchSupport: null,

        shade: null,

        boxWidth: 0,
        boxHeight: 0,
        boundary: 2,
        fadeTime: 400,
        animationDelay: 20,
        swingSpeed: 3,

        minSelect: [0, 0],
        maxSize: [0, 0],
        minSize: [0, 0],

        // Callbacks / Event Handlers
        onChange: function () {
        },
        onSelect: function () {
        },
        onDblClick: function () {
        },
        onRelease: function () {
        }
    };

    return Jcrop;
}));

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_0__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_1__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_LOCAL_MODULE_2__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! gridster.js - v0.5.6 - 2014-09-25 - * http://gridster.net/ - Copyright (c) 2014 ducksboard; Licensed MIT */ (function(t,i){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_LOCAL_MODULE_0__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):t.GridsterCoords=i(t.$||t.jQuery)})(this,function(t){function i(i){return i[0]&&t.isPlainObject(i[0])?this.data=i[0]:this.el=i,this.isCoords=!0,this.coords={},this.init(),this}var e=i.prototype;return e.init=function(){this.set(),this.original_coords=this.get()},e.set=function(t,i){var e=this.el;if(e&&!t&&(this.data=e.offset(),this.data.width=e.width(),this.data.height=e.height()),e&&t&&!i){var s=e.offset();this.data.top=s.top,this.data.left=s.left}var r=this.data;return r.left===void 0&&(r.left=r.x1),r.top===void 0&&(r.top=r.y1),this.coords.x1=r.left,this.coords.y1=r.top,this.coords.x2=r.left+r.width,this.coords.y2=r.top+r.height,this.coords.cx=r.left+r.width/2,this.coords.cy=r.top+r.height/2,this.coords.width=r.width,this.coords.height=r.height,this.coords.el=e||!1,this},e.update=function(i){if(!i&&!this.el)return this;if(i){var e=t.extend({},this.data,i);return this.data=e,this.set(!0,!0)}return this.set(!0),this},e.get=function(){return this.coords},e.destroy=function(){this.el.removeData("coords"),delete this.el},t.fn.coords=function(){if(this.data("coords"))return this.data("coords");var t=new i(this,arguments[0]);return this.data("coords",t),t},i}),function(t,i){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14),__WEBPACK_LOCAL_MODULE_0__], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_LOCAL_MODULE_1__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):t.GridsterCollision=i(t.$||t.jQuery,t.GridsterCoords)}(this,function(t){function i(i,s,r){this.options=t.extend(e,r),this.$element=i,this.last_colliders=[],this.last_colliders_coords=[],this.set_colliders(s),this.init()}var e={colliders_context:document.body,overlapping_region:"C"};i.defaults=e;var s=i.prototype;return s.init=function(){this.find_collisions()},s.overlaps=function(t,i){var e=!1,s=!1;return(i.x1>=t.x1&&i.x1<=t.x2||i.x2>=t.x1&&i.x2<=t.x2||t.x1>=i.x1&&t.x2<=i.x2)&&(e=!0),(i.y1>=t.y1&&i.y1<=t.y2||i.y2>=t.y1&&i.y2<=t.y2||t.y1>=i.y1&&t.y2<=i.y2)&&(s=!0),e&&s},s.detect_overlapping_region=function(t,i){var e="",s="";return t.y1>i.cy&&t.y1<i.y2&&(e="N"),t.y2>i.y1&&t.y2<i.cy&&(e="S"),t.x1>i.cx&&t.x1<i.x2&&(s="W"),t.x2>i.x1&&t.x2<i.cx&&(s="E"),e+s||"C"},s.calculate_overlapped_area_coords=function(i,e){var s=Math.max(i.x1,e.x1),r=Math.max(i.y1,e.y1),o=Math.min(i.x2,e.x2),a=Math.min(i.y2,e.y2);return t({left:s,top:r,width:o-s,height:a-r}).coords().get()},s.calculate_overlapped_area=function(t){return t.width*t.height},s.manage_colliders_start_stop=function(i,e,s){for(var r=this.last_colliders_coords,o=0,a=r.length;a>o;o++)-1===t.inArray(r[o],i)&&e.call(this,r[o]);for(var n=0,h=i.length;h>n;n++)-1===t.inArray(i[n],r)&&s.call(this,i[n])},s.find_collisions=function(i){for(var e=this,s=this.options.overlapping_region,r=[],o=[],a=this.colliders||this.$colliders,n=a.length,h=e.$element.coords().update(i||!1).get();n--;){var _=e.$colliders?t(a[n]):a[n],d=_.isCoords?_:_.coords(),l=d.get(),c=e.overlaps(h,l);if(c){var p=e.detect_overlapping_region(h,l);if(p===s||"all"===s){var g=e.calculate_overlapped_area_coords(h,l),u=e.calculate_overlapped_area(g),f={area:u,area_coords:g,region:p,coords:l,player_coords:h,el:_};e.options.on_overlap&&e.options.on_overlap.call(this,f),r.push(d),o.push(f)}}}return(e.options.on_overlap_stop||e.options.on_overlap_start)&&this.manage_colliders_start_stop(r,e.options.on_overlap_start,e.options.on_overlap_stop),this.last_colliders_coords=r,o},s.get_closest_colliders=function(t){var i=this.find_collisions(t);return i.sort(function(t,i){return"C"===t.region&&"C"===i.region?t.coords.y1<i.coords.y1||t.coords.x1<i.coords.x1?-1:1:t.area<i.area?1:1}),i},s.set_colliders=function(i){"string"==typeof i||i instanceof t?this.$colliders=t(i,this.options.colliders_context).not(this.$element):this.colliders=t(i)},t.fn.collision=function(t,e){return new i(this,t,e)},i}),function(t){t.delay=function(t,i){var e=Array.prototype.slice.call(arguments,2);return setTimeout(function(){return t.apply(null,e)},i)},t.debounce=function(t,i,e){var s;return function(){var r=this,o=arguments,a=function(){s=null,e||t.apply(r,o)};e&&!s&&t.apply(r,o),clearTimeout(s),s=setTimeout(a,i)}},t.throttle=function(t,i){var e,s,r,o,a,n,h=debounce(function(){a=o=!1},i);return function(){e=this,s=arguments;var _=function(){r=null,a&&t.apply(e,s),h()};return r||(r=setTimeout(_,i)),o?a=!0:n=t.apply(e,s),h(),o=!0,n}}}(window),function(t,i){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_LOCAL_MODULE_2__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__)):t.GridsterDraggable=i(t.$||t.jQuery)}(this,function(t){function i(i,s){this.options=t.extend({},e,s),this.$document=t(document),this.$container=t(i),this.$dragitems=t(this.options.items,this.$container),this.is_dragging=!1,this.player_min_left=0+this.options.offset_left,this.id=h(),this.ns=".gridster-draggable-"+this.id,this.init()}var e={items:"li",distance:1,limit:!0,offset_left:0,autoscroll:!0,ignore_dragging:["INPUT","TEXTAREA","SELECT","BUTTON"],handle:null,container_width:0,move_element:!0,helper:!1,remove_helper:!0},s=t(window),r={x:"left",y:"top"},o=!!("ontouchstart"in window),a=function(t){return t.charAt(0).toUpperCase()+t.slice(1)},n=0,h=function(){return++n+""};i.defaults=e;var _=i.prototype;return _.init=function(){var i=this.$container.css("position");this.calculate_dimensions(),this.$container.css("position","static"===i?"relative":i),this.disabled=!1,this.events(),t(window).bind(this.nsEvent("resize"),throttle(t.proxy(this.calculate_dimensions,this),200))},_.nsEvent=function(t){return(t||"")+this.ns},_.events=function(){this.pointer_events={start:this.nsEvent("touchstart")+" "+this.nsEvent("mousedown"),move:this.nsEvent("touchmove")+" "+this.nsEvent("mousemove"),end:this.nsEvent("touchend")+" "+this.nsEvent("mouseup")},this.$container.on(this.nsEvent("selectstart"),t.proxy(this.on_select_start,this)),this.$container.on(this.pointer_events.start,this.options.items,t.proxy(this.drag_handler,this)),this.$document.on(this.pointer_events.end,t.proxy(function(t){this.is_dragging=!1,this.disabled||(this.$document.off(this.pointer_events.move),this.drag_start&&this.on_dragstop(t))},this))},_.get_actual_pos=function(t){var i=t.position();return i},_.get_mouse_pos=function(t){if(t.originalEvent&&t.originalEvent.touches){var i=t.originalEvent;t=i.touches.length?i.touches[0]:i.changedTouches[0]}return{left:t.clientX,top:t.clientY}},_.get_offset=function(i){i.preventDefault();var e=this.get_mouse_pos(i),s=Math.round(e.left-this.mouse_init_pos.left),r=Math.round(e.top-this.mouse_init_pos.top),o=Math.round(this.el_init_offset.left+s-this.baseX+t(window).scrollLeft()-this.win_offset_x),a=Math.round(this.el_init_offset.top+r-this.baseY+t(window).scrollTop()-this.win_offset_y);return this.options.limit&&(o>this.player_max_left?o=this.player_max_left:this.player_min_left>o&&(o=this.player_min_left)),{position:{left:o,top:a},pointer:{left:e.left,top:e.top,diff_left:s+(t(window).scrollLeft()-this.win_offset_x),diff_top:r+(t(window).scrollTop()-this.win_offset_y)}}},_.get_drag_data=function(t){var i=this.get_offset(t);return i.$player=this.$player,i.$helper=this.helper?this.$helper:this.$player,i},_.set_limits=function(t){return t||(t=this.$container.width()),this.player_max_left=t-this.player_width+-this.options.offset_left,this.options.container_width=t,this},_.scroll_in=function(i,e){var o,n=r[i],h=50,_=30,d="x"===i,l=d?this.window_width:this.window_height,c=d?t(document).width():t(document).height(),p=d?this.$player.width():this.$player.height(),g=s["scroll"+a(n)](),u=g,f=u+l,w=f-h,m=u+h,y=u+e.pointer[n],v=c-l+p;return y>=w&&(o=g+_,v>o&&(s["scroll"+a(n)](o),this["scroll_offset_"+i]+=_)),m>=y&&(o=g-_,o>0&&(s["scroll"+a(n)](o),this["scroll_offset_"+i]-=_)),this},_.manage_scroll=function(t){this.scroll_in("x",t),this.scroll_in("y",t)},_.calculate_dimensions=function(){this.window_height=s.height(),this.window_width=s.width()},_.drag_handler=function(i){if(i.target.nodeName,!this.disabled&&(1===i.which||o)&&!this.ignore_drag(i)){var e=this,s=!0;return this.$player=t(i.currentTarget),this.el_init_pos=this.get_actual_pos(this.$player),this.mouse_init_pos=this.get_mouse_pos(i),this.offsetY=this.mouse_init_pos.top-this.el_init_pos.top,this.$document.on(this.pointer_events.move,function(t){var i=e.get_mouse_pos(t),r=Math.abs(i.left-e.mouse_init_pos.left),o=Math.abs(i.top-e.mouse_init_pos.top);return r>e.options.distance||o>e.options.distance?s?(s=!1,e.on_dragstart.call(e,t),!1):(e.is_dragging===!0&&e.on_dragmove.call(e,t),!1):!1}),o?void 0:!1}},_.on_dragstart=function(i){if(i.preventDefault(),this.is_dragging)return this;this.drag_start=this.is_dragging=!0;var e=this.$container.offset();return this.baseX=Math.round(e.left),this.baseY=Math.round(e.top),this.initial_container_width=this.options.container_width||this.$container.width(),"clone"===this.options.helper?(this.$helper=this.$player.clone().appendTo(this.$container).addClass("helper"),this.helper=!0):this.helper=!1,this.win_offset_y=t(window).scrollTop(),this.win_offset_x=t(window).scrollLeft(),this.scroll_offset_y=0,this.scroll_offset_x=0,this.el_init_offset=this.$player.offset(),this.player_width=this.$player.width(),this.player_height=this.$player.height(),this.set_limits(this.options.container_width),this.options.start&&this.options.start.call(this.$player,i,this.get_drag_data(i)),!1},_.on_dragmove=function(t){var i=this.get_drag_data(t);this.options.autoscroll&&this.manage_scroll(i),this.options.move_element&&(this.helper?this.$helper:this.$player).css({position:"absolute",left:i.position.left,top:i.position.top});var e=this.last_position||i.position;return i.prev_position=e,this.options.drag&&this.options.drag.call(this.$player,t,i),this.last_position=i.position,!1},_.on_dragstop=function(t){var i=this.get_drag_data(t);return this.drag_start=!1,this.options.stop&&this.options.stop.call(this.$player,t,i),this.helper&&this.options.remove_helper&&this.$helper.remove(),!1},_.on_select_start=function(t){return this.disabled||this.ignore_drag(t)?void 0:!1},_.enable=function(){this.disabled=!1},_.disable=function(){this.disabled=!0},_.destroy=function(){this.disable(),this.$container.off(this.ns),this.$document.off(this.ns),t(window).off(this.ns),t.removeData(this.$container,"drag")},_.ignore_drag=function(i){return this.options.handle?!t(i.target).is(this.options.handle):t.isFunction(this.options.ignore_dragging)?this.options.ignore_dragging(i):t(i.target).is(this.options.ignore_dragging.join(", "))},t.fn.drag=function(t){return new i(this,t)},i}),function(t,i){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14),__WEBPACK_LOCAL_MODULE_2__,__WEBPACK_LOCAL_MODULE_1__], __WEBPACK_AMD_DEFINE_FACTORY__ = (i),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t.Gridster=i(t.$||t.jQuery,t.GridsterDraggable,t.GridsterCollision)}(this,function(t,i){function e(i,e){this.options=t.extend(!0,{},s,e),this.$el=t(i),this.$wrapper=this.$el.parent(),this.$widgets=this.$el.children(this.options.widget_selector).addClass("gs-w"),this.widgets=[],this.$changed=t([]),this.wrapper_width=this.$wrapper.width(),this.min_widget_width=2*this.options.widget_margins[0]+this.options.widget_base_dimensions[0],this.min_widget_height=2*this.options.widget_margins[1]+this.options.widget_base_dimensions[1],this.generated_stylesheets=[],this.$style_tags=t([]),this.options.auto_init&&this.init()}var s={namespace:"",widget_selector:"li",widget_margins:[10,10],widget_base_dimensions:[400,225],extra_rows:0,extra_cols:0,min_cols:1,max_cols:1/0,min_rows:15,max_size_x:!1,autogrow_cols:!1,autogenerate_stylesheet:!0,avoid_overlapped_widgets:!0,auto_init:!0,serialize_params:function(t,i){return{col:i.col,row:i.row,size_x:i.size_x,size_y:i.size_y}},collision:{},draggable:{items:".gs-w",distance:4,ignore_dragging:i.defaults.ignore_dragging.slice(0)},resize:{enabled:!1,axes:["both"],handle_append_to:"",handle_class:"gs-resize-handle",max_size:[1/0,1/0],min_size:[1,1]}};e.defaults=s,e.generated_stylesheets=[],e.sort_by_row_asc=function(i){return i=i.sort(function(i,e){return i.row||(i=t(i).coords().grid,e=t(e).coords().grid),i.row>e.row?1:-1})},e.sort_by_row_and_col_asc=function(t){return t=t.sort(function(t,i){return t.row>i.row||t.row===i.row&&t.col>i.col?1:-1})},e.sort_by_col_asc=function(t){return t=t.sort(function(t,i){return t.col>i.col?1:-1})},e.sort_by_row_desc=function(t){return t=t.sort(function(t,i){return t.row+t.size_y<i.row+i.size_y?1:-1})};var r=e.prototype;return r.init=function(){this.options.resize.enabled&&this.setup_resize(),this.generate_grid_and_stylesheet(),this.get_widgets_from_DOM(),this.set_dom_grid_height(),this.set_dom_grid_width(),this.$wrapper.addClass("ready"),this.draggable(),this.options.resize.enabled&&this.resizable(),t(window).bind("resize.gridster",throttle(t.proxy(this.recalculate_faux_grid,this),200))},r.disable=function(){return this.$wrapper.find(".player-revert").removeClass("player-revert"),this.drag_api.disable(),this},r.enable=function(){return this.drag_api.enable(),this},r.disable_resize=function(){return this.$el.addClass("gs-resize-disabled"),this.resize_api.disable(),this},r.enable_resize=function(){return this.$el.removeClass("gs-resize-disabled"),this.resize_api.enable(),this},r.add_widget=function(i,e,s,r,o,a,n){var h;e||(e=1),s||(s=1),!r&!o?h=this.next_position(e,s):(h={col:r,row:o,size_x:e,size_y:s},this.empty_cells(r,o,e,s));var _=t(i).attr({"data-col":h.col,"data-row":h.row,"data-sizex":e,"data-sizey":s}).addClass("gs-w").appendTo(this.$el).hide();return this.$widgets=this.$widgets.add(_),this.register_widget(_),this.add_faux_rows(h.size_y),a&&this.set_widget_max_size(_,a),n&&this.set_widget_min_size(_,n),this.set_dom_grid_width(),this.set_dom_grid_height(),this.drag_api.set_limits(this.cols*this.min_widget_width),_.fadeIn()},r.set_widget_min_size=function(t,i){if(t="number"==typeof t?this.$widgets.eq(t):t,!t.length)return this;var e=t.data("coords").grid;return e.min_size_x=i[0],e.min_size_y=i[1],this},r.set_widget_max_size=function(t,i){if(t="number"==typeof t?this.$widgets.eq(t):t,!t.length)return this;var e=t.data("coords").grid;return e.max_size_x=i[0],e.max_size_y=i[1],this},r.add_resize_handle=function(i){var e=this.options.resize.handle_append_to;return t(this.resize_handle_tpl).appendTo(e?t(e,i):i),this},r.resize_widget=function(t,i,e,s){var r=t.coords().grid,o=r.col,a=this.options.max_cols,n=r.size_y,h=r.col,_=h;i||(i=r.size_x),e||(e=r.size_y),1/0!==a&&(i=Math.min(i,a-o+1)),e>n&&this.add_faux_rows(Math.max(e-n,0));var d=o+i-1;d>this.cols&&this.add_faux_cols(d-this.cols);var l={col:_,row:r.row,size_x:i,size_y:e};return this.mutate_widget_in_gridmap(t,r,l),this.set_dom_grid_height(),this.set_dom_grid_width(),s&&s.call(this,l.size_x,l.size_y),t},r.mutate_widget_in_gridmap=function(i,e,s){e.size_x;var r=e.size_y,o=this.get_cells_occupied(e),a=this.get_cells_occupied(s),n=[];t.each(o.cols,function(i,e){-1===t.inArray(e,a.cols)&&n.push(e)});var h=[];t.each(a.cols,function(i,e){-1===t.inArray(e,o.cols)&&h.push(e)});var _=[];t.each(o.rows,function(i,e){-1===t.inArray(e,a.rows)&&_.push(e)});var d=[];if(t.each(a.rows,function(i,e){-1===t.inArray(e,o.rows)&&d.push(e)}),this.remove_from_gridmap(e),h.length){var l=[s.col,s.row,s.size_x,Math.min(r,s.size_y),i];this.empty_cells.apply(this,l)}if(d.length){var c=[s.col,s.row,s.size_x,s.size_y,i];this.empty_cells.apply(this,c)}if(e.col=s.col,e.row=s.row,e.size_x=s.size_x,e.size_y=s.size_y,this.add_to_gridmap(s,i),i.removeClass("player-revert"),i.data("coords").update({width:s.size_x*this.options.widget_base_dimensions[0]+2*(s.size_x-1)*this.options.widget_margins[0],height:s.size_y*this.options.widget_base_dimensions[1]+2*(s.size_y-1)*this.options.widget_margins[1]}),i.attr({"data-col":s.col,"data-row":s.row,"data-sizex":s.size_x,"data-sizey":s.size_y}),n.length){var p=[n[0],s.row,n.length,Math.min(r,s.size_y),i];this.remove_empty_cells.apply(this,p)}if(_.length){var g=[s.col,s.row,s.size_x,s.size_y,i];this.remove_empty_cells.apply(this,g)}return this.move_widget_up(i),this},r.empty_cells=function(i,e,s,r,o){var a=this.widgets_below({col:i,row:e-r,size_x:s,size_y:r});return a.not(o).each(t.proxy(function(i,s){var o=t(s).coords().grid;if(e+r-1>=o.row){var a=e+r-o.row;this.move_widget_down(t(s),a)}},this)),this.set_dom_grid_height(),this},r.remove_empty_cells=function(i,e,s,r,o){var a=this.widgets_below({col:i,row:e,size_x:s,size_y:r});return a.not(o).each(t.proxy(function(i,e){this.move_widget_up(t(e),r)},this)),this.set_dom_grid_height(),this},r.next_position=function(t,i){t||(t=1),i||(i=1);for(var s,r=this.gridmap,o=r.length,a=[],n=1;o>n;n++){s=r[n].length;for(var h=1;s>=h;h++){var _=this.can_move_to({size_x:t,size_y:i},n,h);_&&a.push({col:n,row:h,size_y:i,size_x:t})}}return a.length?e.sort_by_row_and_col_asc(a)[0]:!1},r.remove_widget=function(i,e,s){var r=i instanceof t?i:t(i),o=r.coords().grid;t.isFunction(e)&&(s=e,e=!1),this.cells_occupied_by_placeholder={},this.$widgets=this.$widgets.not(r);var a=this.widgets_below(r);return this.remove_from_gridmap(o),r.fadeOut(t.proxy(function(){r.remove(),e||a.each(t.proxy(function(i,e){this.move_widget_up(t(e),o.size_y)},this)),this.set_dom_grid_height(),s&&s.call(this,i)},this)),this},r.remove_all_widgets=function(i){return this.$widgets.each(t.proxy(function(t,e){this.remove_widget(e,!0,i)},this)),this},r.serialize=function(i){return i||(i=this.$widgets),i.map(t.proxy(function(i,e){var s=t(e);return this.options.serialize_params(s,s.coords().grid)},this)).get()},r.serialize_changed=function(){return this.serialize(this.$changed)},r.dom_to_coords=function(t){return{col:parseInt(t.attr("data-col"),10),row:parseInt(t.attr("data-row"),10),size_x:parseInt(t.attr("data-sizex"),10)||1,size_y:parseInt(t.attr("data-sizey"),10)||1,max_size_x:parseInt(t.attr("data-max-sizex"),10)||!1,max_size_y:parseInt(t.attr("data-max-sizey"),10)||!1,min_size_x:parseInt(t.attr("data-min-sizex"),10)||!1,min_size_y:parseInt(t.attr("data-min-sizey"),10)||!1,el:t}},r.register_widget=function(i){var e=i instanceof jQuery,s=e?this.dom_to_coords(i):i,r=!1;e||(i=s.el);var o=this.can_go_widget_up(s);return o&&(s.row=o,i.attr("data-row",o),this.$el.trigger("gridster:positionchanged",[s]),r=!0),this.options.avoid_overlapped_widgets&&!this.can_move_to({size_x:s.size_x,size_y:s.size_y},s.col,s.row)&&(t.extend(s,this.next_position(s.size_x,s.size_y)),i.attr({"data-col":s.col,"data-row":s.row,"data-sizex":s.size_x,"data-sizey":s.size_y}),r=!0),i.data("coords",i.coords()),i.data("coords").grid=s,this.add_to_gridmap(s,i),this.options.resize.enabled&&this.add_resize_handle(i),r},r.update_widget_position=function(t,i){return this.for_each_cell_occupied(t,function(t,e){return this.gridmap[t]?(this.gridmap[t][e]=i,void 0):this}),this},r.remove_from_gridmap=function(t){return this.update_widget_position(t,!1)},r.add_to_gridmap=function(i,e){if(this.update_widget_position(i,e||i.el),i.el){var s=this.widgets_below(i.el);s.each(t.proxy(function(i,e){this.move_widget_up(t(e))},this))}},r.draggable=function(){var i=this,e=t.extend(!0,{},this.options.draggable,{offset_left:this.options.widget_margins[0],offset_top:this.options.widget_margins[1],container_width:this.cols*this.min_widget_width,limit:!0,start:function(e,s){i.$widgets.filter(".player-revert").removeClass("player-revert"),i.$player=t(this),i.$helper=t(s.$helper),i.helper=!i.$helper.is(i.$player),i.on_start_drag.call(i,e,s),i.$el.trigger("gridster:dragstart")},stop:function(t,e){i.on_stop_drag.call(i,t,e),i.$el.trigger("gridster:dragstop")},drag:throttle(function(t,e){i.on_drag.call(i,t,e),i.$el.trigger("gridster:drag")},60)});return this.drag_api=this.$el.drag(e),this},r.resizable=function(){return this.resize_api=this.$el.drag({items:"."+this.options.resize.handle_class,offset_left:this.options.widget_margins[0],container_width:this.container_width,move_element:!1,resize:!0,limit:this.options.autogrow_cols?!1:!0,start:t.proxy(this.on_start_resize,this),stop:t.proxy(function(i,e){delay(t.proxy(function(){this.on_stop_resize(i,e)},this),120)},this),drag:throttle(t.proxy(this.on_resize,this),60)}),this},r.setup_resize=function(){this.resize_handle_class=this.options.resize.handle_class;var i=this.options.resize.axes,e='<span class="'+this.resize_handle_class+" "+this.resize_handle_class+'-{type}" />';return this.resize_handle_tpl=t.map(i,function(t){return e.replace("{type}",t)}).join(""),t.isArray(this.options.draggable.ignore_dragging)&&this.options.draggable.ignore_dragging.push("."+this.resize_handle_class),this},r.on_start_drag=function(i,e){this.$helper.add(this.$player).add(this.$wrapper).addClass("dragging"),this.highest_col=this.get_highest_occupied_cell().col,this.$player.addClass("player"),this.player_grid_data=this.$player.coords().grid,this.placeholder_grid_data=t.extend({},this.player_grid_data),this.set_dom_grid_height(this.$el.height()+this.player_grid_data.size_y*this.min_widget_height),this.set_dom_grid_width(this.cols);var s=this.player_grid_data.size_x,r=this.cols-this.highest_col;this.options.autogrow_cols&&s>=r&&this.add_faux_cols(Math.min(s-r,1));var o=this.faux_grid,a=this.$player.data("coords").coords;this.cells_occupied_by_player=this.get_cells_occupied(this.player_grid_data),this.cells_occupied_by_placeholder=this.get_cells_occupied(this.placeholder_grid_data),this.last_cols=[],this.last_rows=[],this.collision_api=this.$helper.collision(o,this.options.collision),this.$preview_holder=t("<"+this.$player.get(0).tagName+" />",{"class":"preview-holder","data-row":this.$player.attr("data-row"),"data-col":this.$player.attr("data-col"),css:{width:a.width,height:a.height}}).appendTo(this.$el),this.options.draggable.start&&this.options.draggable.start.call(this,i,e)},r.on_drag=function(t,i){if(null===this.$player)return!1;var e={left:i.position.left+this.baseX,top:i.position.top+this.baseY};if(this.options.autogrow_cols){var s=this.placeholder_grid_data.col+this.placeholder_grid_data.size_x-1;s>=this.cols-1&&this.options.max_cols>=this.cols+1&&(this.add_faux_cols(1),this.set_dom_grid_width(this.cols+1),this.drag_api.set_limits(this.container_width)),this.collision_api.set_colliders(this.faux_grid)}this.colliders_data=this.collision_api.get_closest_colliders(e),this.on_overlapped_column_change(this.on_start_overlapping_column,this.on_stop_overlapping_column),this.on_overlapped_row_change(this.on_start_overlapping_row,this.on_stop_overlapping_row),this.helper&&this.$player&&this.$player.css({left:i.position.left,top:i.position.top}),this.options.draggable.drag&&this.options.draggable.drag.call(this,t,i)},r.on_stop_drag=function(t,i){this.$helper.add(this.$player).add(this.$wrapper).removeClass("dragging"),i.position.left=i.position.left+this.baseX,i.position.top=i.position.top+this.baseY,this.colliders_data=this.collision_api.get_closest_colliders(i.position),this.on_overlapped_column_change(this.on_start_overlapping_column,this.on_stop_overlapping_column),this.on_overlapped_row_change(this.on_start_overlapping_row,this.on_stop_overlapping_row),this.$player.addClass("player-revert").removeClass("player").attr({"data-col":this.placeholder_grid_data.col,"data-row":this.placeholder_grid_data.row}).css({left:"",top:""}),this.$changed=this.$changed.add(this.$player),this.cells_occupied_by_player=this.get_cells_occupied(this.placeholder_grid_data),this.set_cells_player_occupies(this.placeholder_grid_data.col,this.placeholder_grid_data.row),this.$player.coords().grid.row=this.placeholder_grid_data.row,this.$player.coords().grid.col=this.placeholder_grid_data.col,this.options.draggable.stop&&this.options.draggable.stop.call(this,t,i),this.$preview_holder.remove(),this.$player=null,this.$helper=null,this.placeholder_grid_data={},this.player_grid_data={},this.cells_occupied_by_placeholder={},this.cells_occupied_by_player={},this.set_dom_grid_height(),this.set_dom_grid_width(),this.options.autogrow_cols&&this.drag_api.set_limits(this.cols*this.min_widget_width)},r.on_start_resize=function(i,e){this.$resized_widget=e.$player.closest(".gs-w"),this.resize_coords=this.$resized_widget.coords(),this.resize_wgd=this.resize_coords.grid,this.resize_initial_width=this.resize_coords.coords.width,this.resize_initial_height=this.resize_coords.coords.height,this.resize_initial_sizex=this.resize_coords.grid.size_x,this.resize_initial_sizey=this.resize_coords.grid.size_y,this.resize_initial_col=this.resize_coords.grid.col,this.resize_last_sizex=this.resize_initial_sizex,this.resize_last_sizey=this.resize_initial_sizey,this.resize_max_size_x=Math.min(this.resize_wgd.max_size_x||this.options.resize.max_size[0],this.options.max_cols-this.resize_initial_col+1),this.resize_max_size_y=this.resize_wgd.max_size_y||this.options.resize.max_size[1],this.resize_min_size_x=this.resize_wgd.min_size_x||this.options.resize.min_size[0]||1,this.resize_min_size_y=this.resize_wgd.min_size_y||this.options.resize.min_size[1]||1,this.resize_initial_last_col=this.get_highest_occupied_cell().col,this.set_dom_grid_width(this.cols),this.resize_dir={right:e.$player.is("."+this.resize_handle_class+"-x"),bottom:e.$player.is("."+this.resize_handle_class+"-y")},this.$resized_widget.css({"min-width":this.options.widget_base_dimensions[0],"min-height":this.options.widget_base_dimensions[1]});var s=this.$resized_widget.get(0).tagName;this.$resize_preview_holder=t("<"+s+" />",{"class":"preview-holder resize-preview-holder","data-row":this.$resized_widget.attr("data-row"),"data-col":this.$resized_widget.attr("data-col"),css:{width:this.resize_initial_width,height:this.resize_initial_height}}).appendTo(this.$el),this.$resized_widget.addClass("resizing"),this.options.resize.start&&this.options.resize.start.call(this,i,e,this.$resized_widget),this.$el.trigger("gridster:resizestart")},r.on_stop_resize=function(i,e){this.$resized_widget.removeClass("resizing").css({width:"",height:""}),delay(t.proxy(function(){this.$resize_preview_holder.remove().css({"min-width":"","min-height":""}),this.options.resize.stop&&this.options.resize.stop.call(this,i,e,this.$resized_widget),this.$el.trigger("gridster:resizestop")},this),300),this.set_dom_grid_width(),this.options.autogrow_cols&&this.drag_api.set_limits(this.cols*this.min_widget_width)},r.on_resize=function(t,i){var e,s=i.pointer.diff_left,r=i.pointer.diff_top,o=this.options.widget_base_dimensions[0],a=this.options.widget_base_dimensions[1],n=this.options.widget_margins[0],h=this.options.widget_margins[1],_=this.resize_max_size_x,d=this.resize_min_size_x,l=this.resize_max_size_y,c=this.resize_min_size_y,p=this.options.autogrow_cols,g=1/0,u=1/0,f=Math.ceil(s/(o+2*n)-.2),w=Math.ceil(r/(a+2*h)-.2),m=Math.max(1,this.resize_initial_sizex+f),y=Math.max(1,this.resize_initial_sizey+w),v=this.container_width/this.min_widget_width-this.resize_initial_col+1,z=v*this.min_widget_width-2*n;if(m=Math.max(Math.min(m,_),d),m=Math.min(v,m),e=_*o+2*(m-1)*n,g=Math.min(e,z),min_width=d*o+2*(m-1)*n,y=Math.max(Math.min(y,l),c),u=l*a+2*(y-1)*h,min_height=c*a+2*(y-1)*h,this.resize_dir.right?y=this.resize_initial_sizey:this.resize_dir.bottom&&(m=this.resize_initial_sizex),p){var x=this.resize_initial_col+m-1;p&&x>=this.resize_initial_last_col&&(this.set_dom_grid_width(Math.max(x+1,this.cols)),x>this.cols&&this.add_faux_cols(x-this.cols))}var $={};!this.resize_dir.bottom&&($.width=Math.max(Math.min(this.resize_initial_width+s,g),min_width)),!this.resize_dir.right&&($.height=Math.max(Math.min(this.resize_initial_height+r,u),min_height)),this.$resized_widget.css($),(m!==this.resize_last_sizex||y!==this.resize_last_sizey)&&(this.resize_widget(this.$resized_widget,m,y),this.set_dom_grid_width(this.cols),this.$resize_preview_holder.css({width:"",height:""}).attr({"data-row":this.$resized_widget.attr("data-row"),"data-sizex":m,"data-sizey":y})),this.options.resize.resize&&this.options.resize.resize.call(this,t,i,this.$resized_widget),this.$el.trigger("gridster:resize"),this.resize_last_sizex=m,this.resize_last_sizey=y},r.on_overlapped_column_change=function(i,e){if(!this.colliders_data.length)return this;var s,r=this.get_targeted_columns(this.colliders_data[0].el.data.col),o=this.last_cols.length,a=r.length;for(s=0;a>s;s++)-1===t.inArray(r[s],this.last_cols)&&(i||t.noop).call(this,r[s]);for(s=0;o>s;s++)-1===t.inArray(this.last_cols[s],r)&&(e||t.noop).call(this,this.last_cols[s]);return this.last_cols=r,this},r.on_overlapped_row_change=function(i,e){if(!this.colliders_data.length)return this;var s,r=this.get_targeted_rows(this.colliders_data[0].el.data.row),o=this.last_rows.length,a=r.length;for(s=0;a>s;s++)-1===t.inArray(r[s],this.last_rows)&&(i||t.noop).call(this,r[s]);for(s=0;o>s;s++)-1===t.inArray(this.last_rows[s],r)&&(e||t.noop).call(this,this.last_rows[s]);this.last_rows=r},r.set_player=function(t,i,e){var s=this;e||this.empty_cells_player_occupies();var r=e?{col:t}:s.colliders_data[0].el.data,o=r.col,a=i||r.row;this.player_grid_data={col:o,row:a,size_y:this.player_grid_data.size_y,size_x:this.player_grid_data.size_x},this.cells_occupied_by_player=this.get_cells_occupied(this.player_grid_data);var n=this.get_widgets_overlapped(this.player_grid_data),h=this.widgets_constraints(n);if(this.manage_movements(h.can_go_up,o,a),this.manage_movements(h.can_not_go_up,o,a),!n.length){var _=this.can_go_player_up(this.player_grid_data);_!==!1&&(a=_),this.set_placeholder(o,a)}return{col:o,row:a}},r.widgets_constraints=function(i){var s,r=t([]),o=[],a=[];return i.each(t.proxy(function(i,e){var s=t(e),n=s.coords().grid;this.can_go_widget_up(n)?(r=r.add(s),o.push(n)):a.push(n)},this)),s=i.not(r),{can_go_up:e.sort_by_row_asc(o),can_not_go_up:e.sort_by_row_desc(a)}},r.manage_movements=function(i,e,s){return t.each(i,t.proxy(function(t,i){var r=i,o=r.el,a=this.can_go_widget_up(r);if(a)this.move_widget_to(o,a),this.set_placeholder(e,a+r.size_y);else{var n=this.can_go_player_up(this.player_grid_data);if(!n){var h=s+this.player_grid_data.size_y-r.row;this.move_widget_down(o,h),this.set_placeholder(e,s)}}},this)),this},r.is_player=function(t,i){if(i&&!this.gridmap[t])return!1;var e=i?this.gridmap[t][i]:t;return e&&(e.is(this.$player)||e.is(this.$helper))},r.is_player_in=function(i,e){var s=this.cells_occupied_by_player||{};return t.inArray(i,s.cols)>=0&&t.inArray(e,s.rows)>=0},r.is_placeholder_in=function(i,e){var s=this.cells_occupied_by_placeholder||{};return this.is_placeholder_in_col(i)&&t.inArray(e,s.rows)>=0},r.is_placeholder_in_col=function(i){var e=this.cells_occupied_by_placeholder||[];return t.inArray(i,e.cols)>=0},r.is_empty=function(t,i){return this.gridmap[t]!==void 0?this.gridmap[t][i]!==void 0&&this.gridmap[t][i]===!1?!0:!1:!0},r.is_occupied=function(t,i){return this.gridmap[t]?this.gridmap[t][i]?!0:!1:!1},r.is_widget=function(t,i){var e=this.gridmap[t];return e?(e=e[i],e?e:!1):!1},r.is_widget_under_player=function(t,i){return this.is_widget(t,i)?this.is_player_in(t,i):!1},r.get_widgets_under_player=function(i){i||(i=this.cells_occupied_by_player||{cols:[],rows:[]});var e=t([]);return t.each(i.cols,t.proxy(function(s,r){t.each(i.rows,t.proxy(function(t,i){this.is_widget(r,i)&&(e=e.add(this.gridmap[r][i]))},this))},this)),e},r.set_placeholder=function(i,e){var s=t.extend({},this.placeholder_grid_data),r=this.widgets_below({col:s.col,row:s.row,size_y:s.size_y,size_x:s.size_x}),o=i+s.size_x-1;o>this.cols&&(i-=o-i);var a=e>this.placeholder_grid_data.row,n=this.placeholder_grid_data.col!==i;this.placeholder_grid_data.col=i,this.placeholder_grid_data.row=e,this.cells_occupied_by_placeholder=this.get_cells_occupied(this.placeholder_grid_data),this.$preview_holder.attr({"data-row":e,"data-col":i}),(a||n)&&r.each(t.proxy(function(e,r){this.move_widget_up(t(r),this.placeholder_grid_data.col-i+s.size_y)},this));var h=this.get_widgets_under_player(this.cells_occupied_by_placeholder);h.length&&h.each(t.proxy(function(i,r){var o=t(r);this.move_widget_down(o,e+s.size_y-o.data("coords").grid.row)},this))},r.can_go_player_up=function(t){var i=t.row+t.size_y-1,e=!0,s=[],r=1e4,o=this.get_widgets_under_player();return this.for_each_column_occupied(t,function(t){var a=this.gridmap[t],n=i+1;for(s[t]=[];--n>0&&(this.is_empty(t,n)||this.is_player(t,n)||this.is_widget(t,n)&&a[n].is(o));)s[t].push(n),r=r>n?n:r;return 0===s[t].length?(e=!1,!0):(s[t].sort(function(t,i){return t-i
}),void 0)}),e?this.get_valid_rows(t,s,r):!1},r.can_go_widget_up=function(t){var i=t.row+t.size_y-1,e=!0,s=[],r=1e4;return this.for_each_column_occupied(t,function(o){var a=this.gridmap[o];s[o]=[];for(var n=i+1;--n>0&&(!this.is_widget(o,n)||this.is_player_in(o,n)||a[n].is(t.el));)this.is_player(o,n)||this.is_placeholder_in(o,n)||this.is_player_in(o,n)||s[o].push(n),r>n&&(r=n);return 0===s[o].length?(e=!1,!0):(s[o].sort(function(t,i){return t-i}),void 0)}),e?this.get_valid_rows(t,s,r):!1},r.get_valid_rows=function(i,e,s){for(var r=i.row,o=i.row+i.size_y-1,a=i.size_y,n=s-1,h=[];o>=++n;){var _=!0;if(t.each(e,function(i,e){t.isArray(e)&&-1===t.inArray(n,e)&&(_=!1)}),_===!0&&(h.push(n),h.length===a))break}var d=!1;return 1===a?h[0]!==r&&(d=h[0]||!1):h[0]!==r&&(d=this.get_consecutive_numbers_index(h,a)),d},r.get_consecutive_numbers_index=function(t,i){for(var e=t.length,s=[],r=!0,o=-1,a=0;e>a;a++){if(r||t[a]===o+1){if(s.push(a),s.length===i)break;r=!1}else s=[],r=!0;o=t[a]}return s.length>=i?t[s[0]]:!1},r.get_widgets_overlapped=function(){var i=t([]),e=[],s=this.cells_occupied_by_player.rows.slice(0);return s.reverse(),t.each(this.cells_occupied_by_player.cols,t.proxy(function(r,o){t.each(s,t.proxy(function(s,r){if(!this.gridmap[o])return!0;var a=this.gridmap[o][r];this.is_occupied(o,r)&&!this.is_player(a)&&-1===t.inArray(a,e)&&(i=i.add(a),e.push(a))},this))},this)),i},r.on_start_overlapping_column=function(t){this.set_player(t,!1)},r.on_start_overlapping_row=function(t){this.set_player(!1,t)},r.on_stop_overlapping_column=function(t){this.set_player(t,!1);var i=this;this.for_each_widget_below(t,this.cells_occupied_by_player.rows[0],function(){i.move_widget_up(this,i.player_grid_data.size_y)})},r.on_stop_overlapping_row=function(t){this.set_player(!1,t);for(var i=this,e=this.cells_occupied_by_player.cols,s=0,r=e.length;r>s;s++)this.for_each_widget_below(e[s],t,function(){i.move_widget_up(this,i.player_grid_data.size_y)})},r.move_widget_to=function(i,e){var s=this,r=i.coords().grid;e-r.row;var o=this.widgets_below(i),a=this.can_move_to(r,r.col,e,i);return a===!1?!1:(this.remove_from_gridmap(r),r.row=e,this.add_to_gridmap(r),i.attr("data-row",e),this.$changed=this.$changed.add(i),o.each(function(i,e){var r=t(e),o=r.coords().grid,a=s.can_go_widget_up(o);a&&a!==o.row&&s.move_widget_to(r,a)}),this)},r.move_widget_up=function(i,e){var s=i.coords().grid,r=s.row,o=[];return e||(e=1),this.can_go_up(i)?(this.for_each_column_occupied(s,function(s){if(-1===t.inArray(i,o)){var a=i.coords().grid,n=r-e;if(n=this.can_go_up_to_row(a,s,n),!n)return!0;var h=this.widgets_below(i);this.remove_from_gridmap(a),a.row=n,this.add_to_gridmap(a),i.attr("data-row",a.row),this.$changed=this.$changed.add(i),o.push(i),h.each(t.proxy(function(i,s){this.move_widget_up(t(s),e)},this))}}),void 0):!1},r.move_widget_down=function(i,e){var s,r,o,a;if(0>=e)return!1;if(s=i.coords().grid,r=s.row,o=[],a=e,!i)return!1;if(-1===t.inArray(i,o)){var n=i.coords().grid,h=r+e,_=this.widgets_below(i);this.remove_from_gridmap(n),_.each(t.proxy(function(i,e){var s=t(e),r=s.coords().grid,o=this.displacement_diff(r,n,a);o>0&&this.move_widget_down(s,o)},this)),n.row=h,this.update_widget_position(n,i),i.attr("data-row",n.row),this.$changed=this.$changed.add(i),o.push(i)}},r.can_go_up_to_row=function(i,e,s){var r,o=this.gridmap,a=!0,n=[],h=i.row;if(this.for_each_column_occupied(i,function(t){for(o[t],n[t]=[],r=h;r--&&this.is_empty(t,r)&&!this.is_placeholder_in(t,r);)n[t].push(r);return n[t].length?void 0:(a=!1,!0)}),!a)return!1;for(r=s,r=1;h>r;r++){for(var _=!0,d=0,l=n.length;l>d;d++)n[d]&&-1===t.inArray(r,n[d])&&(_=!1);if(_===!0){a=r;break}}return a},r.displacement_diff=function(t,i,e){var s=t.row,r=[],o=i.row+i.size_y;this.for_each_column_occupied(t,function(t){for(var i=0,e=o;s>e;e++)this.is_empty(t,e)&&(i+=1);r.push(i)});var a=Math.max.apply(Math,r);return e-=a,e>0?e:0},r.widgets_below=function(i){var s=t.isPlainObject(i)?i:i.coords().grid,r=this;this.gridmap;var o=s.row+s.size_y-1,a=t([]);return this.for_each_column_occupied(s,function(i){r.for_each_widget_below(i,o,function(){return r.is_player(this)||-1!==t.inArray(this,a)?void 0:(a=a.add(this),!0)})}),e.sort_by_row_asc(a)},r.set_cells_player_occupies=function(t,i){return this.remove_from_gridmap(this.placeholder_grid_data),this.placeholder_grid_data.col=t,this.placeholder_grid_data.row=i,this.add_to_gridmap(this.placeholder_grid_data,this.$player),this},r.empty_cells_player_occupies=function(){return this.remove_from_gridmap(this.placeholder_grid_data),this},r.can_go_up=function(t){var i=t.coords().grid,e=i.row,s=e-1;this.gridmap;var r=!0;return 1===e?!1:(this.for_each_column_occupied(i,function(t){return this.is_widget(t,s),this.is_occupied(t,s)||this.is_player(t,s)||this.is_placeholder_in(t,s)||this.is_player_in(t,s)?(r=!1,!0):void 0}),r)},r.can_move_to=function(t,i,e,s){this.gridmap;var r=t.el,o={size_y:t.size_y,size_x:t.size_x,col:i,row:e},a=!0,n=i+t.size_x-1;return n>this.cols?!1:s&&e+t.size_y-1>s?!1:(this.for_each_cell_occupied(o,function(i,e){var s=this.is_widget(i,e);!s||t.el&&!s.is(r)||(a=!1)}),a)},r.get_targeted_columns=function(t){for(var i=(t||this.player_grid_data.col)+(this.player_grid_data.size_x-1),e=[],s=t;i>=s;s++)e.push(s);return e},r.get_targeted_rows=function(t){for(var i=(t||this.player_grid_data.row)+(this.player_grid_data.size_y-1),e=[],s=t;i>=s;s++)e.push(s);return e},r.get_cells_occupied=function(i){var e,s={cols:[],rows:[]};for(arguments[1]instanceof t&&(i=arguments[1].coords().grid),e=0;i.size_x>e;e++){var r=i.col+e;s.cols.push(r)}for(e=0;i.size_y>e;e++){var o=i.row+e;s.rows.push(o)}return s},r.for_each_cell_occupied=function(t,i){return this.for_each_column_occupied(t,function(e){this.for_each_row_occupied(t,function(t){i.call(this,e,t)})}),this},r.for_each_column_occupied=function(t,i){for(var e=0;t.size_x>e;e++){var s=t.col+e;i.call(this,s,t)}},r.for_each_row_occupied=function(t,i){for(var e=0;t.size_y>e;e++){var s=t.row+e;i.call(this,s,t)}},r._traversing_widgets=function(i,e,s,r,o){var a=this.gridmap;if(a[s]){var n,h,_=i+"/"+e;if(arguments[2]instanceof t){var d=arguments[2].coords().grid;s=d.col,r=d.row,o=arguments[3]}var l=[],c=r,p={"for_each/above":function(){for(;c--&&!(c>0&&this.is_widget(s,c)&&-1===t.inArray(a[s][c],l)&&(n=o.call(a[s][c],s,c),l.push(a[s][c]),n)););},"for_each/below":function(){for(c=r+1,h=a[s].length;h>c&&(!this.is_widget(s,c)||-1!==t.inArray(a[s][c],l)||(n=o.call(a[s][c],s,c),l.push(a[s][c]),!n));c++);}};p[_]&&p[_].call(this)}},r.for_each_widget_above=function(t,i,e){return this._traversing_widgets("for_each","above",t,i,e),this},r.for_each_widget_below=function(t,i,e){return this._traversing_widgets("for_each","below",t,i,e),this},r.get_highest_occupied_cell=function(){for(var t,i=this.gridmap,e=i[1].length,s=[],r=[],o=i.length-1;o>=1;o--)for(t=e-1;t>=1;t--)if(this.is_widget(o,t)){s.push(t),r.push(o);break}return{col:Math.max.apply(Math,r),row:Math.max.apply(Math,s)}},r.get_widgets_from=function(i,e){this.gridmap;var s=t();return i&&(s=s.add(this.$widgets.filter(function(){var e=t(this).attr("data-col");return e===i||e>i}))),e&&(s=s.add(this.$widgets.filter(function(){var i=t(this).attr("data-row");return i===e||i>e}))),s},r.set_dom_grid_height=function(t){if(t===void 0){var i=this.get_highest_occupied_cell().row;t=i*this.min_widget_height}return this.container_height=t,this.$el.css("height",this.container_height),this},r.set_dom_grid_width=function(t){t===void 0&&(t=this.get_highest_occupied_cell().col);var i=this.options.autogrow_cols?this.options.max_cols:this.cols;return t=Math.min(i,Math.max(t,this.options.min_cols)),this.container_width=t*this.min_widget_width,this.$el.css("width",this.container_width),this},r.generate_stylesheet=function(i){var s,r="",o=this.options.max_size_x||this.cols;i||(i={}),i.cols||(i.cols=this.cols),i.rows||(i.rows=this.rows),i.namespace||(i.namespace=this.options.namespace),i.widget_base_dimensions||(i.widget_base_dimensions=this.options.widget_base_dimensions),i.widget_margins||(i.widget_margins=this.options.widget_margins),i.min_widget_width=2*i.widget_margins[0]+i.widget_base_dimensions[0],i.min_widget_height=2*i.widget_margins[1]+i.widget_base_dimensions[1];var a=t.param(i);if(t.inArray(a,e.generated_stylesheets)>=0)return!1;for(this.generated_stylesheets.push(a),e.generated_stylesheets.push(a),s=i.cols;s>=0;s--)r+=i.namespace+' [data-col="'+(s+1)+'"] { left:'+(s*i.widget_base_dimensions[0]+s*i.widget_margins[0]+(s+1)*i.widget_margins[0])+"px; }\n";for(s=i.rows;s>=0;s--)r+=i.namespace+' [data-row="'+(s+1)+'"] { top:'+(s*i.widget_base_dimensions[1]+s*i.widget_margins[1]+(s+1)*i.widget_margins[1])+"px; }\n";for(var n=1;i.rows>=n;n++)r+=i.namespace+' [data-sizey="'+n+'"] { height:'+(n*i.widget_base_dimensions[1]+(n-1)*2*i.widget_margins[1])+"px; }\n";for(var h=1;o>=h;h++)r+=i.namespace+' [data-sizex="'+h+'"] { width:'+(h*i.widget_base_dimensions[0]+(h-1)*2*i.widget_margins[0])+"px; }\n";return this.remove_style_tags(),this.add_style_tag(r)},r.add_style_tag=function(t){var i=document,e=i.createElement("style");return i.getElementsByTagName("head")[0].appendChild(e),e.setAttribute("type","text/css"),e.styleSheet?e.styleSheet.cssText=t:e.appendChild(document.createTextNode(t)),this.$style_tags=this.$style_tags.add(e),this},r.remove_style_tags=function(){var i=e.generated_stylesheets,s=this.generated_stylesheets;this.$style_tags.remove(),e.generated_stylesheets=t.map(i,function(i){return-1===t.inArray(i,s)?i:void 0})},r.generate_faux_grid=function(t,i){this.faux_grid=[],this.gridmap=[];var e,s;for(e=i;e>0;e--)for(this.gridmap[e]=[],s=t;s>0;s--)this.add_faux_cell(s,e);return this},r.add_faux_cell=function(i,e){var s=t({left:this.baseX+(e-1)*this.min_widget_width,top:this.baseY+(i-1)*this.min_widget_height,width:this.min_widget_width,height:this.min_widget_height,col:e,row:i,original_col:e,original_row:i}).coords();return t.isArray(this.gridmap[e])||(this.gridmap[e]=[]),this.gridmap[e][i]=!1,this.faux_grid.push(s),this},r.add_faux_rows=function(t){for(var i=this.rows,e=i+(t||1),s=e;s>i;s--)for(var r=this.cols;r>=1;r--)this.add_faux_cell(s,r);return this.rows=e,this.options.autogenerate_stylesheet&&this.generate_stylesheet(),this},r.add_faux_cols=function(t){var i=this.cols,e=i+(t||1);e=Math.min(e,this.options.max_cols);for(var s=i+1;e>=s;s++)for(var r=this.rows;r>=1;r--)this.add_faux_cell(r,s);return this.cols=e,this.options.autogenerate_stylesheet&&this.generate_stylesheet(),this},r.recalculate_faux_grid=function(){var i=this.$wrapper.width();return this.baseX=(t(window).width()-i)/2,this.baseY=this.$wrapper.offset().top,t.each(this.faux_grid,t.proxy(function(t,i){this.faux_grid[t]=i.update({left:this.baseX+(i.data.col-1)*this.min_widget_width,top:this.baseY+(i.data.row-1)*this.min_widget_height})},this)),this},r.get_widgets_from_DOM=function(){var i=this.$widgets.map(t.proxy(function(i,e){var s=t(e);return this.dom_to_coords(s)},this));i=e.sort_by_row_and_col_asc(i);var s=t(i).map(t.proxy(function(t,i){return this.register_widget(i)||null},this));return s.length&&this.$el.trigger("gridster:positionschanged"),this},r.generate_grid_and_stylesheet=function(){var i=this.$wrapper.width(),e=this.options.max_cols,s=Math.floor(i/this.min_widget_width)+this.options.extra_cols,r=this.$widgets.map(function(){return t(this).attr("data-col")}).get();r.length||(r=[0]);var o=Math.max.apply(Math,r);this.cols=Math.max(o,s,this.options.min_cols),1/0!==e&&e>=o&&this.cols>e&&(this.cols=e);var a=this.options.extra_rows;return this.$widgets.each(function(i,e){a+=+t(e).attr("data-sizey")}),this.rows=Math.max(a,this.options.min_rows),this.baseX=(t(window).width()-i)/2,this.baseY=this.$wrapper.offset().top,this.options.autogenerate_stylesheet&&this.generate_stylesheet(),this.generate_faux_grid(this.rows,this.cols)},r.destroy=function(i){return this.$el.removeData("gridster"),t(window).unbind(".gridster"),this.drag_api&&this.drag_api.destroy(),this.remove_style_tags(),i&&this.$el.remove(),this},t.fn.gridster=function(i){return this.each(function(){t(this).data("gridster")||t(this).data("gridster",new e(this,i))})},e});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(625)
__webpack_require__(626)
__webpack_require__(627)
__webpack_require__(628)
__webpack_require__(629)
__webpack_require__(630)
__webpack_require__(631)
__webpack_require__(632)
__webpack_require__(633)
__webpack_require__(634)
__webpack_require__(635)
__webpack_require__(636)

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/* exported
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth
*/

var minErrConfig = {
  objectMaxDepth: 5
};

/**
 * @ngdoc function
 * @name angular.errorHandlingConfig
 * @module ng
 * @kind function
 *
 * @description
 * Configure several aspects of error handling in AngularJS if used as a setter or return the
 * current configuration if used as a getter. The following options are supported:
 *
 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
 *
 * Omitted or undefined options will leave the corresponding configuration values unchanged.
 *
 * @param {Object=} config - The configuration object. May only contain the options that need to be
 *     updated. Supported keys:
 *
 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
 *   non-positive or non-numeric value, removes the max depth limit.
 *   Default: 5
 */
function errorHandlingConfig(config) {
  if (isObject(config)) {
    if (isDefined(config.objectMaxDepth)) {
      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
    }
  } else {
    return minErrConfig;
  }
}

/**
 * @private
 * @param {Number} maxDepth
 * @return {boolean}
 */
function isValidObjectMaxDepth(maxDepth) {
  return isNumber(maxDepth) && maxDepth > 0;
}

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * AngularJS. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function() {
    var code = arguments[0],
      template = arguments[1],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
      paramPrefix, i;

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1);

      if (index < templateArgs.length) {
        return templateArgs[index];
      }

      return match;
    });

    message += '\nhttp://errors.angularjs.org/1.6.9/' +
      (module ? module + '/' : '') + code;

    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  minErrConfig,
  errorHandlingConfig,
  isValidObjectMaxDepth,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  manualLowercase,
  manualUppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isError,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  simpleCompare,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @ngdoc function
 * @name angular.lowercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @ngdoc function
 * @name angular.uppercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
  /* eslint-enable */
};
var manualUppercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
  /* eslint-enable */
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) &&
    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
          baseExtend(dst[key], [src], true);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @deprecated
* sinceVersion="1.6.5"
* This function is deprecated, but will not be removed in the 1.x lifecycle.
* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
* supported by this function. We suggest
* using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
*
* @knownIssue
* This is a list of (known) object types that are not handled correctly by this function:
* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
* - AngularJS {@link $rootScope.Scope scopes};
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`. Alias of Array.isArray.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @description
 * Determines if a reference is an `Error`.
 * Loosely based on https://www.npmjs.com/package/iserror
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Error`.
 */
function isError(value) {
  var tag = toString.call(value);
  switch (tag) {
    case '[object Error]': return true;
    case '[object Exception]': return true;
    case '[object DOMException]': return true;
    default: return value instanceof Error;
  }
}

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>leader = {{leader | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.leader = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.leader);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.leader);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination, maxDepth) {
  var stackSource = [];
  var stackDest = [];
  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination, maxDepth);
  }

  return copyElement(source, maxDepth);

  function copyRecurse(source, destination, maxDepth) {
    maxDepth--;
    if (maxDepth < 0) {
      return '...';
    }
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i], maxDepth));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key], maxDepth);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source, maxDepth) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination, maxDepth)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


// eslint-disable-next-line no-self-compare
function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return simpleCompare(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since AngularJS uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-15+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone().empty();
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;

  if (!script) {
    // Support: IE 9-11 only
    // IE does not have `document.currentScript`
    return true;
  }

  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
    return false;
  }

  var attributes = script.attributes;
  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

  return srcs.every(function(src) {
    if (!src) {
      return true;
    }
    if (!src.value) {
      return false;
    }

    var link = document.createElement('a');
    link.href = src.value;

    if (document.location.origin === link.origin) {
      // Same-origin resources are always allowed, even for non-whitelisted schemes.
      return true;
    }
    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
    // content security policy in web pages and other browser extensions.
    switch (link.protocol) {
      case 'http:':
      case 'https:':
      case 'ftp:':
      case 'blob:':
      case 'file:':
      case 'data:':
        return true;
      default:
        return false;
    }
  });
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * @example
 *
 * ### Simple Usage
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * @example
 *
 * ### With `ngStrictDi`
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up AngularJS application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of AngularJS try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of AngularJS on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of AngularJS application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? __webpack_provided_window_dot_jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: /** @type {?} */ (JQLitePrototype).controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
        events = jQuery._data(elem, 'events');
        if (events && events.$destroy) {
          jQuery(elem).triggerHandler('$destroy');
        }
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring AngularJS {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
     * modules.
     * All modules (AngularJS core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {

      var info = {};

      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc method
           * @name angular.Module#info
           * @module ng
           *
           * @param {Object=} info Information about the module
           * @returns {Object|Module} The current info object for this module if called as a getter,
           *                          or `this` if called as a setter.
           *
           * @description
           * Read and write custom information about this module.
           * For example you could put the version of the module in here.
           *
           * ```js
           * angular.module('myModule', []).info({ version: '1.0.0' });
           * ```
           *
           * The version could then be read back out by accessing the module elsewhere:
           *
           * ```
           * var version = angular.module('myModule').info().version;
           * ```
           *
           * You can also retrieve this information during runtime via the
           * {@link $injector#modules `$injector.modules`} property:
           *
           * ```js
           * var version = $injector.modules['myModule'].info().version;
           * ```
           */
          info: function(value) {
            if (isDefined(value)) {
              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
              info = value;
              return this;
            }
            return info;
          },

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to configure services by injecting their
           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
           * {@link ngRoute.$routeProvider $routeProvider}.
           *
           * Note that you can only inject {@link angular.Module#provider `providers`} and
           * {@link angular.Module#constant `constants`} into this function.
           *
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* exported toDebugString */

function serializeObject(obj, maxDepth) {
  var seen = [];

  // There is no direct way to stringify object until reaching a specific depth
  // and a very deep object can cause a performance issue, so we copy the object
  // based on this specific depth and then stringify it.
  if (isValidObjectMaxDepth(maxDepth)) {
    // This file is also included in `angular-loader`, so `copy()` might not always be available in
    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
    obj = angular.copy(obj, null, maxDepth);
  }
  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj, maxDepth) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj, maxDepth);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $$MapProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.6.9',
  major: 1,
  minor: 6,
  dot: 9,
  codeName: 'fiery-basilisk'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'errorHandlingConfig': errorHandlingConfig,
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$stringify': stringify
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ])
  .info({ angularVersion: '1.6.9' });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## AngularJS's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, '', '']
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

  if (element.querySelectorAll) {
    jqLite.cleanData(element.querySelectorAll('*'));
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');
    var newClasses = existingClasses;

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
        newClasses += cssClass + ' ';
      }
    });

    if (newClasses !== existingClasses) {
      element.setAttribute('class', trim(newClasses));
    }
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: function jqLiteCleanData(nodes) {
    for (var i = 0, ii = nodes.length; i < ii; i++) {
      jqLiteRemoveData(nodes[i]);
    }
  }
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

// A minimal ES2015 Map implementation.
// Should be bug/feature equivalent to the native implementations of supported browsers
// (for the features required in Angular).
// See https://kangax.github.io/compat-table/es6/#test-Map
var nanKey = Object.create(null);
function NgMapShim() {
  this._keys = [];
  this._values = [];
  this._lastKey = NaN;
  this._lastIndex = -1;
}
NgMapShim.prototype = {
  _idx: function(key) {
    if (key === this._lastKey) {
      return this._lastIndex;
    }
    this._lastKey = key;
    this._lastIndex = this._keys.indexOf(key);
    return this._lastIndex;
  },
  _transformKey: function(key) {
    return isNumberNaN(key) ? nanKey : key;
  },
  get: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx !== -1) {
      return this._values[idx];
    }
  },
  set: function(key, value) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      idx = this._lastIndex = this._keys.length;
    }
    this._keys[idx] = key;
    this._values[idx] = value;

    // Support: IE11
    // Do not `return this` to simulate the partial IE11 implementation
  },
  delete: function(key) {
    key = this._transformKey(key);
    var idx = this._idx(key);
    if (idx === -1) {
      return false;
    }
    this._keys.splice(idx, 1);
    this._values.splice(idx, 1);
    this._lastKey = NaN;
    this._lastIndex = -1;
    return true;
  }
};

// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
// implementations get more stable, we can reconsider switching to `window.Map` (when available).
var NgMap = NgMapShim;

var $$MapProvider = [/** @this */function() {
  this.$get = [function() {
    return NgMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running AngularJS app
 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  return Function.prototype.toString.call(fn);
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * ## Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ### Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ### `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ### Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc property
 * @name $injector#modules
 * @type {Object}
 * @description
 * A hash containing all the modules that have been loaded into the
 * $injector.
 *
 * You can use this property to find out information about a module via the
 * {@link angular.Module#info `myModule.info(...)`} method.
 *
 * For example:
 *
 * ```
 * var info = $injector.modules['ngAnimate'].info();
 * ```
 *
 * **Do not use this property to attempt to modify the modules after the application
 * has been bootstrapped.**
 */


/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * #### Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * #### The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * #### The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */
/**
 * @ngdoc method
 * @name $injector#loadNewModules
 *
 * @description
 *
 * **This is a dangerous API, which you use at your own risk!**
 *
 * Add the specified modules to the current injector.
 *
 * This method will add each of the injectables to the injector and execute all of the config and run
 * blocks for each module passed to the method.
 *
 * If a module has already been loaded into the injector then it will not be loaded again.
 *
 * * The application developer is responsible for loading the code containing the modules; and for
 * ensuring that lazy scripts are not downloaded and executed more often that desired.
 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
 * * Modules cannot be unloaded.
 *
 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
 * into the injector, which may indicate whether the script has been executed already.
 *
 * @example
 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
 *
 * ```javascript
 * app.factory('loadModule', function($injector) {
 *   return function loadModule(moduleName, bundleUrl) {
 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
 *   };
 * })
 * ```
 *
 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 */


/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * It is possible to inject other providers into the provider function,
 * but the injected provider must have been defined before the one that requires it.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  instanceInjector.modules = providerInjector.modules = createMap();
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  instanceInjector.loadNewModules = function(mods) {
    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
  };


  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.set(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          instanceInjector.modules[module] = moduleFn;
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        // Support: Edge 12-13 only
        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new NgMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.delete(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.set(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;
  var classNameFilter = null;
  var customFilter = null;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#customFilter
   *
   * @description
   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
   * determine if an animation is allowed or not. When no filter is specified (the default), no
   * animation will be blocked. Setting the `customFilter` value will only allow animations for
   * which the filter function's return value is truthy.
   *
   * This allows to easily create arbitrarily complex rules for filtering animations, such as
   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
   * Filtering animations can also boost performance for low-powered devices, as well as
   * applications containing a lot of structural operations.
   *
   * <div class="alert alert-success">
   *   **Best Practice:**
   *   Keep the filtering function as lean as possible, because it will be called for each DOM
   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
   *   directives that support animations.
   *   Performing computationally expensive or time-consuming operations on each call of the
   *   filtering function can make your animations sluggish.
   * </div>
   *
   * **Note:** If present, `customFilter` will be checked before
   * {@link $animateProvider#classNameFilter classNameFilter}.
   *
   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
   *   If a falsy value is returned, no animation will be performed. The function will be called
   *   with the following arguments:
   *   - **node** `{DOMElement}` - The DOM element to be animated.
   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
   *     etc).
   *   - **options** `{Object}` - A collection of options/styles used for the animation.
   * @return {Function} The current filter function or `null` if there is none set.
   */
  this.customFilter = function(filterFn) {
    if (arguments.length === 1) {
      customFilter = isFunction(filterFn) ? filterFn : null;
    }

    return customFilter;
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   *
   * **Note:** If present, `classNameFilter` will be checked after
   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
   * false, `classNameFilter` will not be checked.
   *
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (classNameFilter) {
        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
        if (reservedRegex.test(classNameFilter.toString())) {
          classNameFilter = null;
          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
      cancel: function(runner) {
        if (runner.end) {
          runner.end();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while (outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index);
  }

  /**
   * @private
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return pendingLocation || location.href.replace(/%27/g,'\'');
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    fireStateOrUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }

    lastCachedState = cachedState;
    lastHistoryState = cachedState;
  }

  function fireStateOrUrlChange() {
    var prevLastHistoryState = lastHistoryState;
    cacheState();

    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of AngularJS:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers don't
      // fire popstate when user changes the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of AngularJS.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireStateOrUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
       * directive to cache templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
 * {@link ng.$cacheFactory $cacheFactory}.
 *
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
 * or by consuming the `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
 * element with {@link ngApp} attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
 *   also be called when your bindings are initialized.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with life-cycle hooks in the new Angular
 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
 *
 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
 *   `ngDoCheck` in Angular.
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
 * The 'isolate' scope differs from normal scope in that it does not prototypically
 * inherit from its parent scope. This is useful when creating reusable components, which should not
 * accidentally read or modify data in the parent scope. Note that an isolate scope
 * directive without a `template` or `templateUrl` will not apply the isolate scope
 * to its children elements.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * <div class="alert alert-warning">
 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
 * </div>
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` (*DEPRECATED*)
 *
 * `replace` will be removed in next major release - i.e. v2.0).
 *
 * Specifies what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'AngularJS';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello AngularJS'.
       expect(output.getText()).toBe('Hello AngularJS');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('AngularJS!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * AngularJS automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.
 *
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
   *    or an object map of components where the keys are the names and the values are the component definition objects.
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    if (!isString(name)) {
      forEach(name, reverseParams(bind(this, registerComponent)));
      return this;
    }

    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `ng-scope` and `ng-isolated-scope` CSS classes
   * * `$binding` data property containing an array of the binding expressions
   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
   *   the element's scope.
   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
   *   E.g. `<!-- ngIf: shouldShow() -->`.
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#preAssignBindingsEnabled
   *
   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
   * current preAssignBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable whether directive controllers are assigned bindings before
   * calling the controller's constructor.
   * If enabled (true), the compiler assigns the value of each of the bindings to the
   * properties of the controller object before the constructor of this object is called.
   *
   * If disabled (false), the compiler calls the constructor first before assigning bindings.
   *
   * The default value is false.
   *
   * @deprecated
   * sinceVersion="1.6.0"
   * removeVersion="1.7.0"
   *
   * This method and the option to assign the bindings before calling the controller's constructor
   * will be removed in v1.7.0.
   */
  var preAssignBindingsEnabled = false;
  this.preAssignBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      preAssignBindingsEnabled = enabled;
      return this;
    }
    return preAssignBindingsEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#strictComponentBindingsEnabled
   *
   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
   * current strictComponentBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
   * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
   * on the component's HTML tag.
   *
   * The default value is false.
   */
  var strictComponentBindingsEnabled = false;
  this.strictComponentBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      strictComponentBindingsEnabled = enabled;
      return this;
    }
    return strictComponentBindingsEnabled;
  };

  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          var errors = [];
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              errors.push(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
          if (errors.length) {
            throw errors;
          }
        });
      } finally {
        onChangesTtl++;
      }
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
          // sanitize img[srcset] values
          var result = '';

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i = 0; i < nbrUrisWith2parts; i++) {
            var innerIdx = i * 2;
            // sanitize the uri
            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
            // add the descriptor
            result += (' ' + trim(rawUris[innerIdx + 1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i * 2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if (lastTuple.length === 2) {
            result += (' ' + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              this.$$element.attr(attrName, value);
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
            if (isNgAttr) {
              name = name.replace(PREFIX_REGEXP, '')
                .substr(8).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });
            }

            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            // Support: Chrome < 50
            // https://github.com/angular/angular.js/issues/14041

            // In the versions of V8 prior to Chrome 50, the document fragment that is created
            // in the `replaceWith` function is improperly garbage collected despite still
            // being referenced by the `parentNode` property of all of the child nodes.  By adding
            // a reference to the fragment via a different property, we can avoid that incorrect
            // behavior.
            // TODO: remove this line after Chrome 50 has been released
            $template[0].$$parentNode = $template[0].parentNode;

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = [];

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || [];
                  slots[slotName].push(node);
                } else {
                  $template.push(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                }
              }
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          if (preAssignBindingsEnabled) {
            if (bindings) {
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            } else {
              controller.bindingInfo = {};
            }

            var controllerResult = controller();
            if (controllerResult !== controller.instance) {
              // If the controller constructor has a return value, overwrite the instance
              // from setupControllers
              controller.instance = controllerResult;
              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
              if (controller.bindingInfo.removeWatches) {
                controller.bindingInfo.removeWatches();
              }
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            }
          } else {
            controller.instance = controller();
            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
            controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }
        }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';
          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // All tags with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media tags.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
          return $sce.RESOURCE_URL;
        }
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      } else if (attrNormalizedName === 'xlinkHref' ||
          (tag === 'form' && attrNormalizedName === 'action') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (tag === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var trustedContext = getTrustedContext(node, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName_(node) === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents',
            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
                'ng- versions (such as ng-click instead of onclick) instead.');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }

    function strictBindingsCheck(attrName, directiveName) {
      if (strictComponentBindingsEnabled) {
        throw $compileMinErr('missingattr',
          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
          attrName, directiveName);
      }
    }

    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;

      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
              destination[scopeName] = attrs[attrName] = undefined;

            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              compare = simpleCompare;
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              strictBindingsCheck(attrName, directive.name);
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var deepWatch = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            }, deepWatch);

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              strictBindingsCheck(attrName, directive.name);
            }
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in AngularJS:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by AngularJS to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false;

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   *
   * @deprecated
   * sinceVersion="v1.3.0"
   * removeVersion="v1.7.0"
   * This method of finding controllers has been deprecated.
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (deprecated, not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in AngularJS expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   * */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value) || isFunction(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   * */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (toSerialize === null || isUndefined(toSerialize)) return;
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);

      if (hasJsonContentType || isJsonLike(tempData)) {
        try {
          data = fromJson(tempData);
        } catch (e) {
          if (!hasJsonContentType) {
            return data;
          }
          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
          'Parse error: "{1}"', data, e);
        }
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.transformRequest`** -
   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
   * An array of functions (or a single function) which are applied to the request data.
   * By default, this is an array with one request transformation function:
   *
   *   - If the `data` property of the request configuration object contains an object, serialize it
   *     into JSON format.
   *
   * - **`defaults.transformResponse`** -
   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
   * An array of functions (or a single function) which are applied to the response data. By default,
   * this is an array which applies one response transformation function that does two things:
   *
   *  - If XSRF prefix is detected, strip it
   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *    deserialize it using a JSON parser.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   **/
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core AngularJS service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
     *
     * A response status code between 200 and 299 is considered a success status and will result in
     * the success callback being called. Any response status code outside of that range is
     * considered an error status and will result in the error callback being called.
     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
     * aborted, e.g. using a `config.timeout`.
     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
     * that the outcome (success or error) will be determined by the final response status code.
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * AngularJS provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
     * an array with one function that does the following:
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
     * an array with one function that does the following:
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
   *      deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * AngularJS will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * AngularJS will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
     * The header will not be set for cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple AngularJS apps share the
     * same domain or subdomain, we recommend that each application uses unique cookie name.
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
     *                        when the request succeeds or fails.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must whitelist the JSONP endpoint that we are using to show that we trust it
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount();

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop);
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the whitelist via
     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * You should avoid generating the URL for the JSONP request from user provided data.
     * Provide additional query parameters via `params` property of the `config` parameter, rather than
     * modifying the URL itself.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
            : isObject(/** @type {?} */ (defaults).cache)
              ? /** @type {?} */ (defaults).cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText, xhrStatus) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText, xhrStatus);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText, xhrStatus) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText,
          xhrStatus: xhrStatus
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, cbKey) {
      var parts = url.split('?');
      if (parts.length > 2) {
        // Throw if the url contains more than one `?` query indicator
        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
      }
      var params = parseKeyValue(parts[1]);
      forEach(params, function(value, key) {
        if (value === 'JSON_CALLBACK') {
          // Throw if the url already contains a reference to JSON_CALLBACK
          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
        }
        if (key === cbKey) {
          // Throw if the callback param was already provided
          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
        }
      });

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text, 'complete');
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText,
            'complete');
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'error');
      };

      var requestAborted = function() {
        completeRequest(callback, -1, null, null, '', 'abort');
      };

      var requestTimeout = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '', 'timeout');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestAborted;
      xhr.ontimeout = requestTimeout;

      forEach(eventHandlers, function(value, key) {
          xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText, xhrStatus);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'AngularJS';
     *   expect(exp(context)).toEqual('Hello AngularJS!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        var constantInterp;
        if (!mustHaveExpression) {
          var unescapedText = unescapeText(text);
          constantInterp = valueFn(unescapedText);
          constantInterp.exp = text;
          constantInterp.expressions = [];
          constantInterp.$$watchDelegate = constantWatchDelegate;
        }
        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function(value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          value = getValue(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

/** @this */
function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
       function($rootScope,   $window,   $q,   $$q,   $browser) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
      *   are passed (see below), the function is called with the current iteration count.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
      *
      * @example
      * <example module="intervalExample" name="interval-service">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *             stop = $interval(function() {
      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *                 $scope.blood_1 = $scope.blood_1 - 3;
      *                 $scope.blood_2 = $scope.blood_2 - 4;
      *               } else {
      *                 $scope.stopFight();
      *               }
      *             }, 100);
      *           };
      *
      *           $scope.stopFight = function() {
      *             if (angular.isDefined(stop)) {
      *               $interval.cancel(stop);
      *               stop = undefined;
      *             }
      *           };
      *
      *           $scope.resetFight = function() {
      *             $scope.blood_1 = 100;
      *             $scope.blood_2 = 120;
      *           };
      *
      *           $scope.$on('$destroy', function() {
      *             // Make sure that the interval is destroyed too
      *             $scope.stopFight();
      *           });
      *         }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       <label>Date format: <input ng-model="format"></label> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var hasParams = arguments.length > 4,
          args = hasParams ? sliceArgs(arguments, 4) : [],
          setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.$$intervalId = setInterval(function tick() {
        if (skipApply) {
          $browser.defer(callback);
        } else {
          $rootScope.$evalAsync(callback);
        }
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;

      function callback() {
        if (!hasParams) {
          fn(iteration);
        } else {
          fn.apply(null, args);
        }
      }
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {Promise=} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        // Interval cancels should not report as unhandled promise.
        markQExceptionHandled(intervals[promise.$$intervalId].promise);
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = function() {
    var callbacks = angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  };
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various AngularJS components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    // decode forward slashes to prevent them from being double encoded
    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
  }

  return segments.join('/');
}

function decodePath(path, html5Mode) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = decodeURIComponent(segments[i]);
    if (html5Mode) {
      // encode forward slashes to prevent them from being mistaken for path separators
      segments[i] = segments[i].replace(/\//g, '%2F');
    }
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj, html5Mode) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
  locationObj.$$path = decodePath(path, html5Mode);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function trimEmptyHash(url) {
  return url.replace(/(#.+)|#$/, '$1');
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this, true);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'

    this.$$urlUpdatedByLocation = true;
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          /** @type {?} */ (this).replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this, false);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of AngularJS, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang URL and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');

    this.$$urlUpdatedByLocation = true;
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;

    this.$$urlUpdatedByLocation = true;
  };

}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;
    this.$$urlUpdatedByLocation = true;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the AngularJS application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            $window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        newUrl = trimEmptyHash(newUrl);
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      if (initializing || $location.$$urlUpdatedByLocation) {
        $location.$$urlUpdatedByLocation = false;

        var oldUrl = trimEmptyHash($browser.url());
        var newUrl = trimEmptyHash($location.absUrl());
        var oldState = $browser.state();
        var currentReplace = $location.$$replace;
        var urlOrStateChanged = oldUrl !== newUrl ||
          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

        if (initializing || urlOrStateChanged) {
          initializing = false;

          $rootScope.$evalAsync(function() {
            var newUrl = $location.absUrl();
            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
                $location.$$state, oldState).defaultPrevented;

            // if the location was changed by a `$locationChangeStart` handler then stop
            // processing this location change
            if ($location.absUrl() !== newUrl) return;

            if (defaultPrevented) {
              $location.$$parse(oldUrl);
              $location.$$state = oldState;
            } else {
              if (urlOrStateChanged) {
                setBrowserUrlWithFallback(newUrl, currentReplace,
                                          oldState === $location.$$state ? null : $location.$$state);
              }
              afterLocationChange(oldUrl, oldState);
            }
          });
        }
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * To reveal the location of the calls to `$log` in the JavaScript console,
 * you can "blackbox" the AngularJS source in your browser:
 *
 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
 *
 * Note: Not all browsers support blackboxing.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    // Support: IE 9-11, Edge 12-14+
    // IE/Edge display errors in such a way that it requires the user to click in 4 places
    // to see the stack trace. There is no way to feature-detect it so there's a chance
    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
    // break apps. Other browsers display errors in a sensible way and some of them map stack
    // traces along source maps if available so it makes sense to let browsers display it
    // as they want.
    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (isError(arg)) {
        if (arg.stack && formatStackTrace) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop;

      return function() {
        var args = [];
        forEach(arguments, function(arg) {
          args.push(formatError(arg));
        });
        // Support: IE 9 only
        // console methods don't inherit from Function.prototype in IE 9 so we can't
        // call `logFn.apply(console, args)` directly.
        return Function.prototype.apply.call(logFn, console, args);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing AngularJS Expressions
// ------------------------------
// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following AngularJS expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

var PURITY_ABSOLUTE = 1;
var PURITY_RELATIVE = 2;

// Detect nodes which could depend on non-shallow state of objects
function isPure(node, parentIsPure) {
  switch (node.type) {
    // Computed members might invoke a stateful toString()
    case AST.MemberExpression:
      if (node.computed) {
        return false;
      }
      break;

    // Unary always convert to primative
    case AST.UnaryExpression:
      return PURITY_ABSOLUTE;

    // The binary + operator can invoke a stateful toString().
    case AST.BinaryExpression:
      return node.operator !== '+' ? PURITY_ABSOLUTE : false;

    // Functions / filters probably read state from within objects
    case AST.CallExpression:
      return false;
  }

  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
}

function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;

  var astIsPure = ast.isPure = isPure(ast, parentIsPure);

  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter, astIsPure);
      allConstants = allConstants && expr.constant;
      argsToWatch.push.apply(argsToWatch, expr.toWatch);
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
      allConstants = allConstants && property.value.constant;
      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      if (property.computed) {
        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
        allConstants = allConstants && property.key.constant;
        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler($filter) {
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(ast) {
    var self = this;
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var inputs = this.state.inputs;
    var self = this;
    forEach(inputs, function(input) {
      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
      if (input.isPure) {
        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
      }
    });
    if (inputs.length) {
      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter($filter) {
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(ast) {
    var self = this;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        input.isPure = watch.isPure;
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
function Parser(lexer, $filter, options) {
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
                                   new ASTCompiler($filter);
}

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    var ast = this.getAst(text);
    var fn = this.astCompiler.compile(ast.ast);
    fn.literal = isLiteral(ast.ast);
    fn.constant = isConstant(ast.ast);
    fn.oneTime = ast.oneTime;
    return fn;
  },

  getAst: function(exp) {
    var oneTime = false;
    exp = exp.trim();

    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
      oneTime = true;
      exp = exp.substring(2);
    }
    return {
      ast: this.ast.ast(exp),
      oneTime: oneTime
    };
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts AngularJS {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'AngularJS'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('AngularJS');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    $parse.$$getAst = $$getAst;
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);
            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (parsedExpression.oneTime) {
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }
            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function $$getAst(exp) {
      var lexer = new Lexer($parseOptions);
      var parser = new Parser(lexer, $filter, $parseOptions);
      return parser.getAst(exp).ast;
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object' && !compareObjectIdentity) {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var unwatch, lastValue;
      if (parsedExpression.inputs) {
        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
      } else {
        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
      }
      return unwatch;

      function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }
      function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener(value, old, scope);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function() {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener(value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function() {
            if (isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      return unwatch;

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function(val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;
      var watchDelegate = parsedExpression.$$watchDelegate;
      var useInputs = false;

      var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value, scope, locals);
      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      useInputs = !parsedExpression.inputs;
      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = watchDelegate;
        fn.inputs = parsedExpression.inputs;
      } else if (!interceptorFn.$stateful) {
        // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
        fn.$$watchDelegate = inputsWatchDelegate;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
      }

      if (fn.inputs) {
        fn.inputs = fn.inputs.map(function(e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // potentially non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) { return e(s); };
              }
              return e;
            });
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * ## $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * ## The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * ## The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * ## Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * ## Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * ## Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        markQStateExceptionHandled(state);
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
          // This error is explicitly marked for being passed to the $exceptionHandler
          if (e && e.$$passToExceptionHandler === true) {
            exceptionHandler(e);
          }
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!isStateExceptionHandled(toCheck)) {
        markQStateExceptionHandled(toCheck);
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (isError(toCheck.value)) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

function isStateExceptionHandled(state) {
  return !!state.pur;
}
function markQStateExceptionHandled(state) {
  state.pur = true;
}
function markQExceptionHandled(q) {
  markQStateExceptionHandled(q.$$state);
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * ## Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are
       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * @example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);
        var fn = isFunction(listener) ? listener : noop;

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * `$watchGroup` is more performant than watching each expression individually, and should be
       * used when the listener does not need to know which expression has changed.
       * If the listener needs to know which expression has changed,
       * {@link ng.$rootScope.Scope#$watch $watch()} or
       * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`.
       *
       *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
       *    expression, and not the difference of the values between each call of the listener.
       *    That means the difference between `newValues` and `oldValues` cannot be used to determine
       *    which expression has changed / remained stable:
       *
       *    ```js
       *
       *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
       *      console.log(newValues, oldValues);
       *    });
       *
       *    // newValues, oldValues initially
       *    // [undefined, undefined], [undefined, undefined]
       *
       *    $scope.v1 = 'a';
       *    $scope.v2 = 'a';
       *
       *    // ['a', 'a'], [undefined, undefined]
       *
       *    $scope.v2 = 'b'
       *
       *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
       *    // ['a', 'b'], [undefined, 'a']
       *
       *    ```
       *
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * @example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * @example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              fn = asyncTask.fn;
              fn(asyncTask.scope, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;

        // Check for changes to browser url that happened during the $digest
        // (for which no event is fired; e.g. via `history.pushState()`)
        $browser.$$checkUrlChange();
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
       * expressions.
       *
       * @example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the AngularJS framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * **Life cycle: Pseudo-Code of `$apply()`**
       *
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An AngularJS expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            // Use delete in the hope of the browser deallocating the memory for the array entry,
            // while not shifting the array indexes of other listeners.
            // See issue https://github.com/angular/angular.js/issues/16135
            delete namedListeners[indexOfListener];
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            break;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of AngularJS application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri && uri.trim()).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
  HTML: 'html',

  // Style statements or stylesheets. Currently unused in AngularJS.
  CSS: 'css',

  // An URL used in a context where it does not refer to a resource that loads code. Currently
  // unused in AngularJS.
  URL: 'url',

  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
  // code. (e.g. ng-include, script src binding, templateUrl)
  RESOURCE_URL: 'resourceUrl',

  // Script. Currently unused in AngularJS.
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * For an overview of this service and the functionnality it provides in AngularJS, see the main
 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
 * SCE works in their application, which shouldn't be needed in most cases.
 *
 * <div class="alert alert-danger">
 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
 * changes to this service will also influence users, so be extra careful and document your changes.
 * </div>
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
 *
 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
 * places that use the `$sce.RESOURCE_URL` context). See
 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
 * and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
 *
 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 * Note that an empty whitelist will block every resource URL from being loaded, and will require
 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
 * requested by {@link ng.$templateRequest $templateRequest} that are present in
 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
 * for instance attacker-controlled `ng-includes`.
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.
   *
   * @return {Array} The currently set whitelist array.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * <div class="alert alert-warning">
   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
   * with other apps! It is a good idea to limit it to only your application's directory.
   * </div>
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *     provided.  This must be an array or null.  A snapshot of this array is used so further
   *     changes to the array are ignored.</p><p>
   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *     allowed in this array.</p><p>
   *     The typical usage for the blacklist is to **block
   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *     these would otherwise be trusted but actually return content from the redirected domain.
   *     </p><p>
   *     Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} The currently set blacklist array.
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns a trusted representation of the parameter for the specified context. This trusted
     * object will later on be used as-is, without any security check, by bindings or directives
     * that require this security context.
     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
     * security risk.
     *
     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
     * escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that should be considered trusted.
     * @return {*} A trusted representation of value, that can be used in the given context.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *     call or anything else.
     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes any input, and either returns a value that's safe to use in the specified context, or
     * throws an exception.
     *
     * In practice, there are several cases. When given a string, this function runs checks
     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
     * value if that value's context is valid for this call's context. Finally, this function can
     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
     * is available or possible.)
     *
     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
      // as-is.
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
      // has no corresponding sinks.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        // RESOURCE_URL uses a whitelist.
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        // htmlSanitizer throws its own error when no sanitizer is available.
        return htmlSanitizer(maybeTrusted);
      }
      // Default error when the $sce service has no way to make the input safe.
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * ## Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * ### Overview
 *
 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
 * can be sanitized, but template URLs cannot, for instance.
 *
 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
 * render the input as-is, you will need to mark it as trusted for that context before attempting
 * to bind it.
 *
 * As of version 1.2, AngularJS ships with SCE enabled by default.
 *
 * ### In practice
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
 * controlled input creates security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
 * any similar validation process, unless there's a good reason to trust the given value in this
 * context.  That trust is formalized with a function call. This means that as a developer, you
 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
 * you just need to ensure the values you mark as trusted indeed are safe - because they were
 * received from your server, sanitized by your library, etc. You can organize your codebase to
 * help with this - perhaps allowing only the files in a specific directory to do this.
 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
 * becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * build the trusted versions of your values.
 *
 * ### How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
 * a way to enforce the required security context in your data sink. Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
 * when binding without directives, AngularJS will understand the context of your bindings
 * automatically.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ### Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, AngularJS only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ### This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
 * also use the `$sanitize` service if it is available when binding untrusted values to
 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
 * your application.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ### What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
 *
 *
 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
 * might evolve.
 *
 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ### Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
 * you are writing a library, you will cause security bugs applications using it.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects or libraries.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
   * @return {boolean} True if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way. In some future, we may not use
   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
   * be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
     * wrapped object that represents your value, and the trust you have in its safety for the given
     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
     *
     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
     *
     * @param {*} value The value that that should be considered trusted.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in the context you specified.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.HTML` context (like `ng-bind-html`).
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsCss
     *
     * @description
     * Shorthand method.  `$sce.trustAsCss(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant
     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
     *     almost no reasons to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
     *     to use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
     *     bindings, ...)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to mark as trusted for `$sce.JS` context.
     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
     *     use this function so far.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes any input, and either returns a value that's safe to use in the specified context,
     * or throws an exception. This function is aware of trusted values created by the `trustAs`
     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
     * safe value (e.g., no sanitization is available or possible.)
     *
     * @param {string} type The context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
     * @return {*} A version of the value that's safe to use in the given context, or throws an
     *     exception if this is impossible.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @return {function(context, locals)} A function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the
     *      strings are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
     *      in `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp =
            !isNw &&
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

var $templateRequestMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
   * as {@link ngInclude} to download and cache templates.
   *
   * 3rd party modules should use `$templateRequest` if their services or directives are loading
   * templates.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through whitelisting again for keys that already
        // are included in there. This also makes AngularJS accept any script
        // directive, no matter its name. However, we still need to unwrap trusted
        // types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            $templateCache.put(tpl, response.data);
            return response.data;
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of calling `$timeout` is a promise, which will be resolved when
      * the delay has passed and the timeout function, if provided, is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * If you only want a promise that will be resolved after some specified delay
      * then you can call `$timeout` without the `fn` function.
      *
      * @param {function()=} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
      *   will be resolved with the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        // Timeout cancels should not report an unhandled promise.
        markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+ etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url) {
  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In AngularJS we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how AngularJS filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the AngularJS Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services. AngularJS comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * <div class="alert alert-info">
 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
 * </div>
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if values retrieved using `expression` (when it is not a function) should be
 *     considered a match based on the expected value (from the filter expression) and actual
 *     value (from the object in the array).
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
          // See: https://github.com/angular/angular.js/issues/15644
          if (key.charAt && (key.charAt(0) !== '$') &&
              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // If the currency symbol is empty, trim whitespace around the symbol
    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(currencySymbolRe, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 *   Any other characters in the `format` string will be output as-is.
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 *
 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
 *
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @example
   <example module="uppercaseFilterExample" name="filter-uppercase">
     <file name="index.html">
       <script>
         angular.module('uppercaseFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.title = 'This is a title';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <!-- This title should be formatted normally -->
         <h1>{{title}}</h1>
         <!-- This title should be capitalized -->
         <h1>{{title | uppercase}}</h1>
       </div>
     </file>
   </example>
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * If a custom comparator still can't distinguish between two items, then they will be sorted based
 * on their index using the built-in comparator.
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, and sorts values of different types by type.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types, compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
 *           other values.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'string';
      value = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = type1 < type2 ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * AngularJS has a chance to replace the `{{hash}}` markup with its
 * value. Until AngularJS replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an AngularJS page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until AngularJS replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element (typically a form control,
 * e.g. `input`, `button`, `select` etc.) if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
          element(by.model('leader')).click();
          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Internet Explorer and Edge do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>List</summary>
            <ul>
              <li>Apple</li>
              <li>Orange</li>
              <li>Durian</li>
            </ul>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $pending An object hash, containing references to controls or forms with
 *  pending validators, where:
 *
 *  - keys are validations tokens (error names).
 *  - values are arrays of controls or forms that have a pending validator for the given error name.
 *
 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
 *
 * @property {Object} $error An object hash, containing references to controls or forms with failing
 *  validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for the given error name.
 *
 *  Built-in validation tokens:
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  $setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    this.$$parentForm.$setSubmitted();
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Change the validity state of the form, and notify the parent form (if any).
 *
 * Application developers will rarely need to call this method directly. It is used internally, by
 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
 * control's validity state to the parent `FormController`.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
 *        class name. Example: `myError` will result in `ng-valid-my-error` and
 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
 *        `$asyncValidators` do not run because any of the `$validators` failed.
 * @param {NgModelController | FormController} controller - The controller whose validity state is
 *        triggering the change.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * ## Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * ## CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * ## Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side AngularJS applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * @animations
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise AngularJS will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise AngularJS will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise AngularJS will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for AngularJS:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, AngularJS will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
   *                  to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut drop', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options.getOption('timezone');
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        if (previousDate && timezone) {
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      return validity.badInput || validity.typeMismatch ? undefined : value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  var isNonIntegerValue = !isNumberInteger(value);
  var isNonIntegerStepBase = !isNumberInteger(stepBase);
  var isNonIntegerStep = !isNumberInteger(step);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;

    if (isNonIntegerValue) value = Math.round(value);
    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
    if (isNonIntegerStep) step = Math.round(step);
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var minVal;
  var maxVal;

  if (isDefined(attr.min) || attr.ngMin) {
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      minVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      maxVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal;
    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
             isValidForStep(viewValue, minVal || 0, stepVal);
    };

    attr.$observe('step', function(val) {
      stepVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    attr.$observe(htmlAttrName, changeFn);
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (supportsRange && ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 * @restrict A
 * @priority 100
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element ANY
 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    // Support: IE9 only
    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
    element.prop('value', propValue);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 * @restrict A
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element ANY
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var expression = attr[name].trim();
        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');

        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
        var watchExpression = $parse(expression, watchInterceptor);
        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;

        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch(watchExpression, watchAction, isOneTime);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClass[OneTime]WatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassOneTimeWatchAction(newClassValue) {
          var newClassString = toClassString(newClassValue);

          if (newClassString !== oldClassString) {
            ngClassWatchAction(newClassString);
          }
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    }

    return classString;
  }

  function toFlatValue(classValue) {
    var flatValue = classValue;

    if (isArray(classValue)) {
      flatValue = classValue.map(toFlatValue);
    } else if (isObject(classValue)) {
      var hasUndefined = false;

      flatValue = Object.keys(classValue).filter(function(key) {
        var value = classValue[key];

        if (!hasUndefined && isUndefined(value)) {
          hasUndefined = true;
        }

        return value;
      });

      if (hasUndefined) {
        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
        // the watcher, by including at least one `undefined` value.
        flatValue.push(undefined);
      }
    }

    return flatValue;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 * @element ANY
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * ### ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 *
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example
 * ### Basic
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   @example
   ### Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (deprecated, not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the AngularJS community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * AngularJS has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect AngularJS:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related AngularJS features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of AngularJS.
 *
 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 *
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```

  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
  <example name="example.csp" module="cspExample" ng-csp="true">
    <file name="index.html">
      <div ng-controller="MainController as ctrl">
        <div>
          <button ng-click="ctrl.inc()" id="inc">Increment</button>
          <span id="counter">
            {{ctrl.counter}}
          </span>
        </div>

        <div>
          <button ng-click="ctrl.evil()" id="evil">Evil</button>
          <span id="evilError">
            {{ctrl.evilError}}
          </span>
        </div>
      </div>
    </file>
    <file name="script.js">
       angular.module('cspExample', [])
         .controller('MainController', function MainController() {
            this.counter = 0;
            this.inc = function() {
              this.counter++;
            };
            this.evil = function() {
              try {
                eval('1+2'); // eslint-disable-line no-eval
              } catch (e) {
                this.evilError = e.message;
              }
            };
          });
    </file>
    <file name="protractor.js" type="protractor">
      var util, webdriver;

      var incBtn = element(by.id('inc'));
      var counter = element(by.id('counter'));
      var evilBtn = element(by.id('evil'));
      var evilError = element(by.id('evilError'));

      function getAndClearSevereErrors() {
        return browser.manage().logs().get('browser').then(function(browserLog) {
          return browserLog.filter(function(logEntry) {
            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
          });
        });
      }

      function clearErrors() {
        getAndClearSevereErrors();
      }

      function expectNoErrors() {
        getAndClearSevereErrors().then(function(filteredLog) {
          expect(filteredLog.length).toEqual(0);
          if (filteredLog.length) {
            console.log('browser console errors: ' + util.inspect(filteredLog));
          }
        });
      }

      function expectError(regex) {
        getAndClearSevereErrors().then(function(filteredLog) {
          var found = false;
          filteredLog.forEach(function(log) {
            if (log.message.match(regex)) {
              found = true;
            }
          });
          if (!found) {
            throw new Error('expected an error that matches ' + regex);
          }
        });
      }

      beforeEach(function() {
        util = require('util');
        webdriver = require('selenium-webdriver');
      });

      // For now, we only test on Chrome,
      // as Safari does not load the page with Protractor's injected scripts,
      // and Firefox webdriver always disables content security policy (#6358)
      if (browser.params.browser !== 'chrome') {
        return;
      }

      it('should not report errors when the page is loaded', function() {
        // clear errors so we are not dependent on previous tests
        clearErrors();
        // Need to reload the page as the page is already loaded when
        // we come here
        browser.driver.getCurrentUrl().then(function(url) {
          browser.get(url);
        });
        expectNoErrors();
      });

      it('should evaluate expressions', function() {
        expect(counter.getText()).toEqual('0');
        incBtn.click();
        expect(counter.getText()).toEqual('1');
        expectNoErrors();
      });

      it('should throw and report an error when using "eval"', function() {
        evilBtn.click();
        expect(evilError.getText()).toMatch(/Content Security Policy/);
        expectError(/Content Security Policy/);
      });
    </file>
  </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * AngularJS expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          // NOTE:
          // We expose the powerful `$event` object on the scope that provides access to the Window,
          // etc. This is OK, because expressions are not sandboxed any more (and the expression
          // sandbox was never meant to be a security feature anyway).
          var fn = $parse(attr[directiveName]);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event: event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 * @restrict A
 * @element ANY
 * @priority 0
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 * @restrict A
 * @element ANY
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 * @restrict A
 * @element form
 * @priority 0
 *
 * @description
 * Enables binding AngularJS expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 * @restrict A
 * @element window, input, select, textarea, a
 * @priority 0
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 * @scope
 * @priority -400
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 * @priority 450
 * @element ANY
 *
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`:
 * <ul>
 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
 *     as seen in the demo below.</li>
 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
 *   <li>injecting data via server side scripting.</li>
 * </ul>
 *
 * Besides these few cases, you should use {@link guide/component Components} or
 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 * @restrict A
 * @priority 100
 *
 * @param {string=} ngList optional delimiter that should be used to split the value.
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * @example
 * ### Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * @example
 * ### Splitting on newline
 *
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 *
 * @property {*} $modelValue The value in the model that the control is bound to.
 *
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
    `$viewValue`} from the DOM, usually via user input.
    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.

  The functions are called in array order, each passing
    its return value through to the next. The last return value is forwarded to the
    {@link ngModel.NgModelController#$validators `$validators`} collection.

  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
    `$viewValue`}.

  Returning `undefined` from a parser means a parse error occurred. In that case,
    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
    is set to `true`. The parse error is stored in `ngModel.$error.parse`.

  This simple example shows a parser that would convert text input value to lowercase:
 * ```js
 * function parse(value) {
 *   if (value) {
 *     return value.toLowerCase();
 *   }
 * }
 * ngModelController.$parsers.push(parse);
 * ```

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
    value of the control is changed by user interaction.

  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
    `$modelValue`} for display in the control.

  The functions are called in reverse array order, each passing the value through to the
    next. The last return value is used as the actual DOM value.

  This simple example shows a formatter that would convert the model value to uppercase:

 * ```js
 * function format(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(format);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
 *     It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * AngularJS provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;
  this.$$updateEvents = '';
  // Attach the correct context to the event handler function for updateOn
  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;

  this.$$currentValidationRunId = 0;

  // https://github.com/angular/angular.js/issues/15833
  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
  Object.defineProperty(this, '$$scope', {value: $scope});
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * @example
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {
    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName || 'parse';
      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }
        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
   * `$asyncValidators` are called and the value is applied to `$modelValue`.
   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
   * all the registered change listeners, in the `$viewChangeListeners` list are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default'])) {
      debounceDelay = debounceDelay['default'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$scope.$root.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  },

  /**
   * @ngdoc method
   *
   * @name ngModel.NgModelController#$overrideModelOptions
   *
   * @description
   *
   * Override the current model options settings programmatically.
   *
   * The previous `ModelOptions` value will not be modified. Instead, a
   * new `ModelOptions` object will inherit from the previous one overriding
   * or inheriting settings that are defined in the given parameter.
   *
   * See {@link ngModelOptions} for information about what options can be specified
   * and how model option inheritance works.
   *
   * <div class="alert alert-warning">
   * **Note:** this function only affects the options set on the `ngModelController`,
   * and not the options on the {@link ngModelOptions} directive from which they might have been
   * obtained initially.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** it is not possible to override the `getterSetter` option.
   * </div>
   *
   * @param {Object} options a hash of settings to override the previous options
   *
   */
  $overrideModelOptions: function(options) {
    this.$options = this.$options.createChild(options);
    this.$$setUpdateOnEvents();
  },

  /**
   * @ngdoc method
   *
   * @name  ngModel.NgModelController#$processModelValue

   * @description
   *
   * Runs the model -> view pipeline on the current
   * {@link ngModel.NgModelController#$modelValue $modelValue}.
   *
   * The following actions are performed by this method:
   *
   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
   * - the `ng-empty` or `ng-not-empty` class is set on the element
   * - if the `$viewValue` has changed:
   *   - {@link ngModel.NgModelController#$render $render} is called on the control
   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
   *   the validation status is set.
   *
   * This method is called by ngModel internally when the bound scope value changes.
   * Application developers usually do not have to call this function themselves.
   *
   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
   * formatted and the `$modelValue` must be run through the `$formatters` again.
   *
   * @example
   * Consider a text input with an autocomplete list (for fruit), where the items are
   * objects with a name and an id.
   * A user enters `ap` and then selects `Apricot` from the list.
   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
   * but the rendered value will still be `ap`.
   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
   * pipeline again, which formats the object to the string `Apricot`,
   * then updates the `$viewValue`, and finally renders it in the DOM.
   *
   * <example module="inputExample" name="ng-model-process">
     <file name="index.html">
      <div ng-controller="inputController" style="display: flex;">
        <div style="margin-right: 30px;">
          Search Fruit:
          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
        </div>
        <div>
          Model:<br>
          <pre>{{selectedFruit | json}}</pre>
        </div>
      </div>
     </file>
     <file name="app.js">
      angular.module('inputExample', [])
        .controller('inputController', function($scope) {
          $scope.items = [
            {name: 'Apricot', id: 443},
            {name: 'Clementine', id: 972},
            {name: 'Durian', id: 169},
            {name: 'Jackfruit', id: 982},
            {name: 'Strawberry', id: 863}
          ];
        })
        .component('basicAutocomplete', {
          bindings: {
            items: '<',
            onSelect: '&'
          },
          templateUrl: 'autocomplete.html',
          controller: function($element, $scope) {
            var that = this;
            var ngModel;

            that.$postLink = function() {
              ngModel = $element.find('input').controller('ngModel');

              ngModel.$formatters.push(function(value) {
                return (value && value.name) || value;
              });

              ngModel.$parsers.push(function(value) {
                var match = value;
                for (var i = 0; i < that.items.length; i++) {
                  if (that.items[i].name === value) {
                    match = that.items[i];
                    break;
                  }
                }

                return match;
              });
            };

            that.selectItem = function(item) {
              ngModel.$setViewValue(item);
              ngModel.$processModelValue();
              that.onSelect({item: item});
            };
          }
        });
     </file>
     <file name="autocomplete.html">
       <div>
         <input type="search" ng-model="$ctrl.searchTerm" />
         <ul>
           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
           </li>
         </ul>
       </div>
     </file>
   * </example>
   *
   */
  $processModelValue: function() {
    var viewValue = this.$$format();

    if (this.$viewValue !== viewValue) {
      this.$$updateEmptyClasses(viewValue);
      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
      this.$render();
      // It is possible that model and view value have been updated during render
      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
    }
  },

  /**
   * This method is called internally to run the $formatters on the $modelValue
   */
  $$format: function() {
    var formatters = this.$formatters,
        idx = formatters.length;

    var viewValue = this.$modelValue;
    while (idx--) {
      viewValue = formatters[idx](viewValue);
    }

    return viewValue;
  },

  /**
   * This method is called internally when the bound scope value changes.
   */
  $$setModelValue: function(modelValue) {
    this.$modelValue = this.$$rawModelValue = modelValue;
    this.$$parserValid = undefined;
    this.$processModelValue();
  },

  $$setUpdateOnEvents: function() {
    if (this.$$updateEvents) {
      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
    }

    this.$$updateEvents = this.$options.getOption('updateOn');
    if (this.$$updateEvents) {
      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    }
  },

  $$updateEventHandler: function(ev) {
    this.$$debounceViewValueCommit(ev && ev.type);
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch(scope) {
    var modelValue = ctrl.$$ngModelGet(scope);

    // if scope model value and ngModel value are out of sync
    // This cannot be moved to the action function, because it would not catch the
    // case where the model is changed in the ngChange function or the model setter
    if (modelValue !== ctrl.$modelValue &&
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$$setModelValue(modelValue);
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 * @restrict A
 * @priority 1
 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * ## CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * @animations
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * ### Basic Usage
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * @example
 * ### Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          modelCtrl.$$setUpdateOnEvents();

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /* @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 * @restrict A
 * @priority 10
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ### Overriding immediate updates
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * ### Debouncing updates
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 *
 * ## Programmatically changing options
 *
 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
 * watched for changes. However, it is possible to override the options on a single
 * {@link ngModel.NgModelController} instance with
 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
 *
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control. These are the events that are bound to
 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
 *
 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
 *     since different control types use different default events.
 *
 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
 *     Triggering and debouncing model updates}.
 *
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur click',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *
 *     "default" also applies to all events that are listed in `updateOn` but are not
 *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
 *
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 * @element ANY
 *
 * @description
 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
 * DOM element, including directives on the element itself that have a lower priority than
 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
 * that displays snippets of code, for instance.
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
  <example name="ng-non-bindable">
    <file name="index.html">
      <div>Normal: {{1 + 2}}</div>
      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
    </file>
    <file name="protractor.js" type="protractor">
     it('should check ng-non-bindable', function() {
       expect(element(by.binding('1 + 2')).getText()).toContain('3');
       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
     });
    </file>
  </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {comprehension_expression} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * ## Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in AngularJS's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * ## Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * AngularJS expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * ## Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 * @restrict A
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * ## Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so AngularJS relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * ## Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * All different types of tracking functions, their syntax, and and their support for duplicate
 * items in collections can be found in the
 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
 *
 * <div class="alert alert-success">
 * **Best Practice:** If you are working with objects that have a unique identifier property, you
 * should track by this identifier instead of the object instance,
 * e.g. `item in items track by item.id`.
 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
 * it has already rendered, even if the JavaScript objects in the collection have been substituted
 * for new ones. For large collections, this significantly improves rendering performance.
 * </div>
 *
 * ### Effects of DOM Element re-use
 *
 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
 * automatically update any active bindings on the template. However, other
 * functionality will not be updated, because the element is not re-created:
 *
 * - Directives are not re-compiled
 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
 * updated if they have stabilized.
 *
 * The above affects all kinds of element re-use due to tracking, but may be especially visible
 * when tracking by `$index` due to the way ngRepeat re-uses elements.
 *
 * The following example shows the effects of different actions with tracking:

  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        var friends = [
          {name:'John', age:25},
          {name:'Mary', age:40},
          {name:'Peter', age:85}
        ];

        $scope.removeFirst = function() {
          $scope.friends.shift();
        };

        $scope.updateAge = function() {
          $scope.friends.forEach(function(el) {
            el.age = el.age + 5;
          });
        };

        $scope.copy = function() {
          $scope.friends = angular.copy($scope.friends);
        };

        $scope.reset = function() {
          $scope.friends = angular.copy(friends);
        };

        $scope.reset();
      });
    </file>
    <file name="index.html">
      <div ng-controller="repeatController">
        <ol>
          <li>When you click "Update Age", only the first list updates the age, because all others have
          a one-time binding on the age property. If you then click "Copy", the current friend list
          is copied, and now the second list updates the age, because the identity of the collection items
          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
          items are already known according to their tracking functions.
          </li>
          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
          DOM element for the new first collection item, and so on. Since the age property is one-time
          bound, the value remains from the collection item which was previously at this index.
          </li>
        </ol>

        <button ng-click="removeFirst()">Remove First</button>
        <button ng-click="updateAge()">Update Age</button>
        <button ng-click="copy()">Copy</button>
        <br><button ng-click="reset()">Reset List</button>
        <br>
        <code>track by $id(friend)</code> (default):
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{friend.age}} years old.
          </li>
        </ul>
        <code>track by $id(friend)</code> (default), with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by friend.name</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
            {{friend.name}}  is {{::friend.age}} years old.
          </li>
        </ul>
        <code>track by $index</code>, with age one-time binding:
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
            {{friend.name}} is {{::friend.age}} years old.
          </li>
        </ul>
      </div>
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
  </example>

 *
 * ## Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
 *     This implies that the DOM elements will be associated by item identity in the collection.
 *
 *     The built-in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the collection by identity. Moving the same object would move
 *     the DOM element in the same way in the DOM.
 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
 *
 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
 *     id, for example with a function, or using a property on the collection items.
 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
 *     equivalent as long as their `id` property is same.
 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
 *
 *     *$index*: This special property tracks the collection items by their index, and
 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
 *     be used for a performance improvement if no unique identfier is available and the identity of
 *     the collection items cannot be easily computed. It also allows duplicates.
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
 *       more info.
 *     </div>
 *
 *     <div class="alert alert-warning">
 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
 *       `item in items | filter:searchText as results  track by item.id`
 *     </div>
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - clone: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function setOptionSelectedStatus(optionEl, value) {
  optionEl.prop('selected', value);
  /**
   * When unselecting an option, setting the property to null / false should be enough
   * However, screenreaders might react to the selected attribute instead, see
   * https://github.com/angular/angular.js/issues/14419
   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
   * or null
   */
  optionEl.attr('selected', value);
}

/**
 * @ngdoc type
 * @name  select.SelectController
 *
 * @description
 * The controller for the {@link ng.select select} directive. The controller exposes
 * a few utility methods that can be used to augment the behavior of a regular or an
 * {@link ng.ngOptions ngOptions} select element.
 *
 * @example
 * ### Set a custom error when the unknown option is selected
 *
 * This example sets a custom error "unknownValue" on the ngModelController
 * when the select element's unknown option is selected, i.e. when the model is set to a value
 * that is not matched by any option.
 *
 * <example name="select-unknown-value-error" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Single select: </label><br>
 *     <select name="testSelect" ng-model="selected" unknown-value-error>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
 *       Error: The current model doesn't match any option</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueError', function() {
 *     return {
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
 *           if (selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return true;
 *         };
 *       }
 *
 *     };
 *   });
 * </file>
 *</example>
 *
 *
 * @example
 * ### Set the "required" error when the unknown option is selected.
 *
 * By default, the "required" error on the ngModelController is only set on a required select
 * when the empty option is selected. This example adds a custom directive that also sets the
 * error when the unknown option is selected.
 *
 * <example name="select-unknown-value-required" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="testSelect"> Select: </label><br>
 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
 *
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.selected = null;
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.selected = 'nonsense';
 *      };
 *   }])
 *   .directive('unknownValueRequired', function() {
 *     return {
 *       priority: 1, // This directive must run after the required directive has added its validator
 *       require: ['ngModel', 'select'],
 *       link: function(scope, element, attrs, ctrls) {
 *         var ngModelCtrl = ctrls[0];
 *         var selectCtrl = ctrls[1];
 *
 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
 *
 *         ngModelCtrl.$validators.required = function() {
 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
 *             return false;
 *           }
 *
 *           return originalRequiredValidator.apply(this, arguments);
 *         };
 *       }
 *     };
 *   });
 * </file>
 * <file name="protractor.js" type="protractor">
 *  it('should show the error message when the unknown option is selected', function() {

      var error = element(by.className('error'));

      expect(error.getText()).toBe('Error: Please select a value');

      element(by.cssContainingText('option', 'Option 1')).click();

      expect(error.isPresent()).toBe(false);

      element(by.tagName('button')).click();

      expect(error.getText()).toBe('Error: Please select a value');
    });
 * </file>
 *</example>
 *
 *
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new NgMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // Support: IE 9 only
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that the application developer can
  // provide inside the select. It is always selectable and indicates that a "null" selection has
  // been made by the user.
  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
  // the empty option is selected.
  // If the model is set to a different unmatched value, the unknown option is rendered and
  // selected, i.e both are present, because a "null" selection and an unknown value are different.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionSelectedStatus(self.unknownOption, true);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionSelectedStatus(self.emptyOption, true);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      setOptionSelectedStatus(self.emptyOption, false);
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionSelectedStatus(jqLite(selectedOption), true);
    } else {
      self.selectUnknownOrEmptyOption(value);
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.set(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.delete(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.set(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$hasEmptyOption
   *
   * @description
   *
   * Returns `true` if the select element currently has an empty option
   * element, i.e. an option that signifies that the select is empty / the selection is null.
   *
   */
  self.$hasEmptyOption = function() {
    return self.hasEmptyOption;
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isUnknownOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element's unknown option is selected. The unknown option is added
   * and automatically selected whenever the select model doesn't match any option.
   *
   */
  self.$isUnknownOptionSelected = function() {
    // Presence of the unknown option means it is selected
    return $element[0].options[0] === self.unknownOption[0];
  };

  /**
   * @ngdoc method
   * @name select.SelectController#$isEmptyOptionSelected
   *
   * @description
   *
   * Returns `true` if the select element has an empty option and this empty option is currently
   * selected. Returns `false` if the select element has no empty option or it is not selected.
   *
   */
  self.$isEmptyOptionSelected = function() {
    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
  };

  self.selectUnknownOrEmptyOption = function(value) {
    if (value == null && self.emptyOption) {
      self.removeUnknownOption();
      self.selectEmptyOption();
    } else if (self.unknownOption.parent().length) {
      self.updateUnknownOption(value);
    } else {
      self.renderUnknownOption(value);
    }
  };

  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal = NaN;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      scheduleRender();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with AngularJS data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * The {@link select.SelectController select controller} exposes utility functions that can be used
 * to manipulate the select's behavior.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
 *
 *
 * @knownIssue
 *
 * In Firefox, the select model is only updated when the select element is blurred. For example,
 * when switching between options with the keyboard, the select model is only set to the
 * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
 * outside the select.
 *
 * This is due to an ambiguity in the select element specification. See the
 * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
 * for more information, and this
 * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 * @example
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function(option) {
            var shouldBeSelected = !!value && (includes(value, option.value) ||
                                               includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }

          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
 *                                `required` attribute to the element and adds the `required`
 *                                {@link ngModel.NgModelController#$validators `validator`}.
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the AngularJS expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};

/**
 * @ngdoc directive
 * @name ngPattern
 * @restrict A
 *
 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
 *                                      more details.
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
 * - the value is an AngularJS expression:
 *   - If the expression evaluates to a RegExp object, then this is used directly.
 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMaxlength
 * @restrict A
 *
 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `maxlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNumberNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMinlength
 * @restrict A
 *
 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
 *                                 parsable into a `Number`. Used as value for the `minlength`
 *                                 {@link ngModel.NgModelController#$validators validator}.
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load AngularJS more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(639);
module.exports = 'ngResource';


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var $resourceMinErr = angular.$$minErr('$resource');

// Helper functions and regex to lookup a dotted path on an object
// stopping at undefined/null.  The path must be composed of ASCII
// identifiers (just like $parse)
var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;

function isValidDottedPath(path) {
  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
      MEMBER_NAME_REGEX.test('.' + path));
}

function lookupDottedPath(obj, path) {
  if (!isValidDottedPath(path)) {
    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
  }
  var keys = path.split('.');
  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
    var key = keys[i];
    obj = (obj !== null) ? obj[key] : undefined;
  }
  return obj;
}

/**
 * Create a shallow copy of an object and clear other fields from the destination
 */
function shallowClearAndCopy(src, dst) {
  dst = dst || {};

  angular.forEach(dst, function(value, key) {
    delete dst[key];
  });

  for (var key in src) {
    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
      dst[key] = src[key];
    }
  }

  return dst;
}

/**
 * @ngdoc module
 * @name ngResource
 * @description
 *
 * The `ngResource` module provides interaction support with RESTful services
 * via the $resource service.
 *
 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
 */

/**
 * @ngdoc provider
 * @name $resourceProvider
 *
 * @description
 *
 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
 * service.
 *
 * ## Dependencies
 * Requires the {@link ngResource } module to be installed.
 *
 */

/**
 * @ngdoc service
 * @name $resource
 * @requires $http
 * @requires ng.$log
 * @requires $q
 * @requires ng.$timeout
 *
 * @description
 * A factory which creates a resource object that lets you interact with
 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
 *
 * The returned resource object has action methods which provide high-level behaviors without
 * the need to interact with the low level {@link ng.$http $http} service.
 *
 * Requires the {@link ngResource `ngResource`} module to be installed.
 *
 * By default, trailing slashes will be stripped from the calculated URLs,
 * which can pose problems with server backends that do not expect that
 * behavior.  This can be disabled by configuring the `$resourceProvider` like
 * this:
 *
 * ```js
     app.config(['$resourceProvider', function($resourceProvider) {
       // Don't strip trailing slashes from calculated URLs
       $resourceProvider.defaults.stripTrailingSlashes = false;
     }]);
 * ```
 *
 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
 *   `/user/:username`. If you are using a URL with a port number (e.g.
 *   `http://example.com:8080/api`), it will be respected.
 *
 *   If you are using a url with a suffix, just add the suffix, like this:
 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
 *   can escape it with `/\.`.
 *
 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
 *   `actions` methods. If a parameter value is a function, it will be called every time
 *   a param value needs to be obtained for a request (unless the param was overridden). The function
 *   will be passed the current data value as an argument.
 *
 *   Each key value in the parameter object is first bound to url template if present and then any
 *   excess keys are appended to the url search query after the `?`.
 *
 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
 *   URL `/path/greet?salutation=Hello`.
 *
 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
 *   extracted from the corresponding property on the `data` object (provided when calling actions
 *   with a request body).
 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
 *   `someParam` will be `data.someProp`.
 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
 *   method that does not accept a request body)
 *
 * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
 *   in addition to the default set of resource actions (see below). If a custom action has the same
 *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
 *   extended.
 *
 *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
 *
 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
 *        ...}
 *
 *   Where:
 *
 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
 *     your resource object.
 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
 *     `DELETE`, `JSONP`, etc).
 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
 *     the parameter value is a function, it will be called every time when a param value needs to
 *     be obtained for a request (unless the param was overridden). The function will be passed the
 *     current data value as an argument.
 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
 *     like for the resource-level urls.
 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
 *     see `returns` section.
 *   - **`transformRequest`** –
 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     request body and headers and returns its transformed (typically serialized) version.
 *     By default, transformRequest will contain one function that checks if the request data is
 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
 *     `transformRequest` to an empty array: `transformRequest: []`
 *   - **`transformResponse`** –
 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     response body, headers and status and returns its transformed (typically deserialized)
 *     version.
 *     By default, transformResponse will contain one function that checks if the response looks
 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
 *     set `transformResponse` to an empty array: `transformResponse: []`
 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
 *     GET request, otherwise if a cache instance built with
 *     {@link ng.$cacheFactory $cacheFactory} is supplied, this cache will be used for
 *     caching.
 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
 *     **not** supported in $resource, because the same value would be used for multiple requests.
 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
 *     completed/cancelled request will have no effect.<br />
 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
 *     XHR object. See
 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
 *     for more information.
 *   - **`responseType`** - `{string}` - see
 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
 *     with `http response` object. See {@link ng.$http $http interceptors}. In addition, the
 *     resource instance or array object is accessible by the `resource` property of the
 *     `http response` object.
 *     Keep in mind that the associated promise will be resolved with the value returned by the
 *     response interceptor, if one is specified. The default response interceptor returns
 *     `response.resource` (i.e. the resource instance or array).
 *   - **`hasBody`** - `{boolean}` - allows to specify if a request body should be included or not.
 *     If not specified only POST, PUT and PATCH requests will have a body.
 *
 * @param {Object} options Hash with custom settings that should extend the
 *   default `$resourceProvider` behavior.  The supported options are:
 *
 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
 *   slashes from any calculated URL will be stripped. (Defaults to true.)
 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
 *   This can be overwritten per action. (Defaults to false.)
 *
 * @returns {Object} A resource "class" object with methods for the default set of resource actions
 *   optionally extended with custom `actions`. The default set contains these actions:
 *   ```js
 *   { 'get':    {method:'GET'},
 *     'save':   {method:'POST'},
 *     'query':  {method:'GET', isArray:true},
 *     'remove': {method:'DELETE'},
 *     'delete': {method:'DELETE'} };
 *   ```
 *
 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
 *   destination and parameters. When the data is returned from the server then the object is an
 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
 *   read, update, delete) on server-side data like this:
 *   ```js
 *   var User = $resource('/user/:userId', {userId:'@id'});
 *   var user = User.get({userId:123}, function() {
 *     user.abc = true;
 *     user.$save();
 *   });
 *   ```
 *
 *   It is important to realize that invoking a $resource object method immediately returns an
 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
 *   server the existing reference is populated with the actual data. This is a useful trick since
 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
 *   object results in no rendering, once the data arrives from the server then the object is
 *   populated with the data and the view automatically re-renders itself showing the new data. This
 *   means that in most cases one never has to write a callback function for the action methods.
 *
 *   The action methods on the class object or instance object can be invoked with the following
 *   parameters:
 *
 *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
 *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
 *   - instance actions: `instance.$action([parameters], [success], [error])`
 *
 *
 *   When calling instance methods, the instance itself is used as the request body (if the action
 *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
 *   bodies, but you can use the `hasBody` configuration option to specify whether an action
 *   should have a body or not (regardless of its HTTP method).
 *
 *
 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
 *   status (number), statusText (string)) arguments, where the value is the populated resource
 *   instance or collection object. The error callback is called with (httpResponse) argument.
 *
 *   Class actions return empty instance (with additional properties below).
 *   Instance actions return promise of the action.
 *
 *   The Resource instances and collections have these additional properties:
 *
 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
 *     instance or collection.
 *
 *     On success, the promise is resolved with the same resource instance or collection object,
 *     updated with data from server. This makes it easy to use in
 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
 *     rendering until the resource(s) are loaded.
 *
 *     On failure, the promise is rejected with the {@link ng.$http http response} object.
 *
 *     If an interceptor object was provided, the promise will instead be resolved with the value
 *     returned by the interceptor.
 *
 *   - `$resolved`: `true` after first server interaction is completed (either with success or
 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
 *      data-binding.
 *
 *   The Resource instances and collections have these additional methods:
 *
 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
 *      collection, calling this method will abort the request.
 *
 *   The Resource instances have these additional methods:
 *
 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
 *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
 *     `angular.toJson`) automatically use this method when serializing a Resource instance
 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
 *
 * @example
 *
 * ### Credit card resource
 *
 * ```js
     // Define CreditCard class
     var CreditCard = $resource('/user/:userId/card/:cardId',
      {userId:123, cardId:'@id'}, {
       charge: {method:'POST', params:{charge:true}}
      });

     // We can retrieve a collection from the server
     var cards = CreditCard.query(function() {
       // GET: /user/123/card
       // server returns: [ {id:456, number:'1234', name:'Smith'} ];

       var card = cards[0];
       // each item is an instance of CreditCard
       expect(card instanceof CreditCard).toEqual(true);
       card.name = "J. Smith";
       // non GET methods are mapped onto the instances
       card.$save();
       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
       // server returns: {id:456, number:'1234', name: 'J. Smith'};

       // our custom method is mapped as well.
       card.$charge({amount:9.99});
       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
     });

     // we can create an instance as well
     var newCard = new CreditCard({number:'0123'});
     newCard.name = "Mike Smith";
     newCard.$save();
     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
     expect(newCard.id).toEqual(789);
 * ```
 *
 * The object returned from this function execution is a resource "class" which has "static" method
 * for each action in the definition.
 *
 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
 * `headers`.
 *
 * @example
 *
 * ### User resource
 *
 * When the data is returned from the server then the object is an instance of the resource type and
 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
 * operations (create, read, update, delete) on server-side data.

   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user) {
       user.abc = true;
       user.$save();
     });
   ```
 *
 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
 * in the response that came from the server as well as $http header getter function, so one
 * could rewrite the above example and get access to http headers as:
 *
   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user, getResponseHeaders){
       user.abc = true;
       user.$save(function(user, putResponseHeaders) {
         //user => saved user object
         //putResponseHeaders => $http header getter
       });
     });
   ```
 *
 * You can also access the raw `$http` promise via the `$promise` property on the object returned
 *
   ```
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123})
         .$promise.then(function(user) {
           $scope.user = user;
         });
   ```
 *
 * @example
 *
 * ### Creating a custom 'PUT' request
 *
 * In this example we create a custom method on our resource to make a PUT request
 * ```js
 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
 *
 *    // Some APIs expect a PUT request in the format URL/object/ID
 *    // Here we are creating an 'update' method
 *    app.factory('Notes', ['$resource', function($resource) {
 *    return $resource('/notes/:id', null,
 *        {
 *            'update': { method:'PUT' }
 *        });
 *    }]);
 *
 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
 *    // We pass in $routeParams and our Notes factory along with $scope
 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
                                      function($scope, $routeParams, Notes) {
 *    // First get a note object from the factory
 *    var note = Notes.get({ id:$routeParams.id });
 *    $id = note.id;
 *
 *    // Now call update passing in the ID first then the object you are updating
 *    Notes.update({ id:$id }, note);
 *
 *    // This will PUT /notes/ID with the note object in the request payload
 *    }]);
 * ```
 *
 * @example
 *
 * ### Cancelling requests
 *
 * If an action's configuration specifies that it is cancellable, you can cancel the request related
 * to an instance or collection (as long as it is a result of a "non-instance" call):
 *
   ```js
     // ...defining the `Hotel` resource...
     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
       // Let's make the `query()` method cancellable
       query: {method: 'get', isArray: true, cancellable: true}
     });

     // ...somewhere in the PlanVacationController...
     ...
     this.onDestinationChanged = function onDestinationChanged(destination) {
       // We don't care about any pending request for hotels
       // in a different destination any more
       this.availableHotels.$cancelRequest();

       // Let's query for hotels in '<destination>'
       // (calls: /api/hotel?location=<destination>)
       this.availableHotels = Hotel.query({location: destination});
     };
   ```
 *
 */
angular.module('ngResource', ['ng']).
  info({ angularVersion: '1.6.9' }).
  provider('$resource', function ResourceProvider() {
    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;

    var provider = this;

    /**
     * @ngdoc property
     * @name $resourceProvider#defaults
     * @description
     * Object containing default options used when creating `$resource` instances.
     *
     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
     * them to further customize your instances. The available properties are:
     *
     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
     *   calculated URL will be stripped.<br />
     *   (Defaults to true.)
     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
     *   resource class or action.<br />
     *   (Defaults to false.)
     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
     *   object or a collection (array) of objects etc. For more details, see
     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
     *   class.<br />
     *   The default actions are:
     *   ```js
     *   {
     *     get: {method: 'GET'},
     *     save: {method: 'POST'},
     *     query: {method: 'GET', isArray: true},
     *     remove: {method: 'DELETE'},
     *     delete: {method: 'DELETE'}
     *   }
     *   ```
     *
     * #### Example
     *
     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions.update = {
     *         method: 'PUT'
     *       };
     *     }]);
     * ```
     *
     * Or you can even overwrite the whole `actions` list and specify your own:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions = {
     *         create: {method: 'POST'},
     *         get:    {method: 'GET'},
     *         getAll: {method: 'GET', isArray:true},
     *         update: {method: 'PUT'},
     *         delete: {method: 'DELETE'}
     *       };
     *     });
     * ```
     *
     */
    this.defaults = {
      // Strip slashes by default
      stripTrailingSlashes: true,

      // Make non-instance requests cancellable (via `$cancelRequest()`)
      cancellable: false,

      // Default actions configuration
      actions: {
        'get': {method: 'GET'},
        'save': {method: 'POST'},
        'query': {method: 'GET', isArray: true},
        'remove': {method: 'DELETE'},
        'delete': {method: 'DELETE'}
      }
    };

    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {

      var noop = angular.noop,
          forEach = angular.forEach,
          extend = angular.extend,
          copy = angular.copy,
          isArray = angular.isArray,
          isDefined = angular.isDefined,
          isFunction = angular.isFunction,
          isNumber = angular.isNumber,
          encodeUriQuery = angular.$$encodeUriQuery,
          encodeUriSegment = angular.$$encodeUriSegment;

      function Route(template, defaults) {
        this.template = template;
        this.defaults = extend({}, provider.defaults, defaults);
        this.urlParams = {};
      }

      Route.prototype = {
        setUrlParams: function(config, params, actionUrl) {
          var self = this,
            url = actionUrl || self.template,
            val,
            encodedVal,
            protocolAndIpv6 = '';

          var urlParams = self.urlParams = Object.create(null);
          forEach(url.split(/\W/), function(param) {
            if (param === 'hasOwnProperty') {
              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
            }
            if (!(new RegExp('^\\d+$').test(param)) && param &&
              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
              urlParams[param] = {
                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
              };
            }
          });
          url = url.replace(/\\:/g, ':');
          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function(match) {
            protocolAndIpv6 = match;
            return '';
          });

          params = params || {};
          forEach(self.urlParams, function(paramInfo, urlParam) {
            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
            if (isDefined(val) && val !== null) {
              if (paramInfo.isQueryParamValue) {
                encodedVal = encodeUriQuery(val, true);
              } else {
                encodedVal = encodeUriSegment(val);
              }
              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
                return encodedVal + p1;
              });
            } else {
              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
                  leadingSlashes, tail) {
                if (tail.charAt(0) === '/') {
                  return tail;
                } else {
                  return leadingSlashes + tail;
                }
              });
            }
          });

          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
          if (self.defaults.stripTrailingSlashes) {
            url = url.replace(/\/+$/, '') || '/';
          }

          // Collapse `/.` if found in the last URL path segment before the query.
          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
          // Replace escaped `/\.` with `/.`.
          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');


          // set params - delegate param encoding to $http
          forEach(params, function(value, key) {
            if (!self.urlParams[key]) {
              config.params = config.params || {};
              config.params[key] = value;
            }
          });
        }
      };


      function resourceFactory(url, paramDefaults, actions, options) {
        var route = new Route(url, options);

        actions = extend({}, provider.defaults.actions, actions);

        function extractParams(data, actionParams) {
          var ids = {};
          actionParams = extend({}, paramDefaults, actionParams);
          forEach(actionParams, function(value, key) {
            if (isFunction(value)) { value = value(data); }
            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
              lookupDottedPath(data, value.substr(1)) : value;
          });
          return ids;
        }

        function defaultResponseInterceptor(response) {
          return response.resource;
        }

        function Resource(value) {
          shallowClearAndCopy(value || {}, this);
        }

        Resource.prototype.toJSON = function() {
          var data = extend({}, this);
          delete data.$promise;
          delete data.$resolved;
          delete data.$cancelRequest;
          return data;
        };

        forEach(actions, function(action, name) {
          var hasBody = action.hasBody === true || (action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method));
          var numericTimeout = action.timeout;
          var cancellable = isDefined(action.cancellable) ?
              action.cancellable : route.defaults.cancellable;

          if (numericTimeout && !isNumber(numericTimeout)) {
            $log.debug('ngResource:\n' +
                       '  Only numeric values are allowed as `timeout`.\n' +
                       '  Promises are not supported in $resource, because the same value would ' +
                       'be used for multiple requests. If you are looking for a way to cancel ' +
                       'requests, you should use the `cancellable` option.');
            delete action.timeout;
            numericTimeout = null;
          }

          Resource[name] = function(a1, a2, a3, a4) {
            var params = {}, data, success, error;

            switch (arguments.length) {
              case 4:
                error = a4;
                success = a3;
                // falls through
              case 3:
              case 2:
                if (isFunction(a2)) {
                  if (isFunction(a1)) {
                    success = a1;
                    error = a2;
                    break;
                  }

                  success = a2;
                  error = a3;
                  // falls through
                } else {
                  params = a1;
                  data = a2;
                  success = a3;
                  break;
                }
                // falls through
              case 1:
                if (isFunction(a1)) success = a1;
                else if (hasBody) data = a1;
                else params = a1;
                break;
              case 0: break;
              default:
                throw $resourceMinErr('badargs',
                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
                  arguments.length);
            }

            var isInstanceCall = this instanceof Resource;
            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
            var httpConfig = {};
            var responseInterceptor = action.interceptor && action.interceptor.response ||
              defaultResponseInterceptor;
            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
              undefined;
            var hasError = !!error;
            var hasResponseErrorInterceptor = !!responseErrorInterceptor;
            var timeoutDeferred;
            var numericTimeoutPromise;

            forEach(action, function(value, key) {
              switch (key) {
                default:
                  httpConfig[key] = copy(value);
                  break;
                case 'params':
                case 'isArray':
                case 'interceptor':
                case 'cancellable':
                  break;
              }
            });

            if (!isInstanceCall && cancellable) {
              timeoutDeferred = $q.defer();
              httpConfig.timeout = timeoutDeferred.promise;

              if (numericTimeout) {
                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
              }
            }

            if (hasBody) httpConfig.data = data;
            route.setUrlParams(httpConfig,
              extend({}, extractParams(data, action.params || {}), params),
              action.url);

            var promise = $http(httpConfig).then(function(response) {
              var data = response.data;

              if (data) {
                // Need to convert action.isArray to boolean in case it is undefined
                if (isArray(data) !== (!!action.isArray)) {
                  throw $resourceMinErr('badcfg',
                      'Error in resource configuration for action `{0}`. Expected response to ' +
                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
                }
                if (action.isArray) {
                  value.length = 0;
                  forEach(data, function(item) {
                    if (typeof item === 'object') {
                      value.push(new Resource(item));
                    } else {
                      // Valid JSON values may be string literals, and these should not be converted
                      // into objects. These items will not have access to the Resource prototype
                      // methods, but unfortunately there
                      value.push(item);
                    }
                  });
                } else {
                  var promise = value.$promise;     // Save the promise
                  shallowClearAndCopy(data, value);
                  value.$promise = promise;         // Restore the promise
                }
              }
              response.resource = value;

              return response;
            }, function(response) {
              response.resource = value;
              return $q.reject(response);
            });

            promise = promise['finally'](function() {
              value.$resolved = true;
              if (!isInstanceCall && cancellable) {
                value.$cancelRequest = noop;
                $timeout.cancel(numericTimeoutPromise);
                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
              }
            });

            promise = promise.then(
              function(response) {
                var value = responseInterceptor(response);
                (success || noop)(value, response.headers, response.status, response.statusText);
                return value;
              },
              (hasError || hasResponseErrorInterceptor) ?
                function(response) {
                  if (hasError && !hasResponseErrorInterceptor) {
                    // Avoid `Possibly Unhandled Rejection` error,
                    // but still fulfill the returned promise with a rejection
                    promise.catch(noop);
                  }
                  if (hasError) error(response);
                  return hasResponseErrorInterceptor ?
                    responseErrorInterceptor(response) :
                    $q.reject(response);
                } :
                undefined);

            if (!isInstanceCall) {
              // we are creating instance / collection
              // - set the initial promise
              // - return the instance / collection
              value.$promise = promise;
              value.$resolved = false;
              if (cancellable) value.$cancelRequest = cancelRequest;

              return value;
            }

            // instance call
            return promise;

            function cancelRequest(value) {
              promise.catch(noop);
              if (timeoutDeferred !== null) {
                timeoutDeferred.resolve(value);
              }
            }
          };


          Resource.prototype['$' + name] = function(params, success, error) {
            if (isFunction(params)) {
              error = success; success = params; params = {};
            }
            var result = Resource[name].call(this, params, this, success, error);
            return result.$promise || result;
          };
        });

        return Resource;
      }

      return resourceFactory;
    }];
  });


})(window, window.angular);


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(641);
module.exports = 'ngRoute';


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global shallowCopy: false */

// `isArray` and `isObject` are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
var isArray;
var isObject;
var isDefined;
var noop;

/**
 * @ngdoc module
 * @name ngRoute
 * @description
 *
 * The `ngRoute` module provides routing and deeplinking services and directives for AngularJS apps.
 *
 * ## Example
 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
 *
 */
/* global -ngRouteModule */
var ngRouteModule = angular.
  module('ngRoute', []).
  info({ angularVersion: '1.6.9' }).
  provider('$route', $RouteProvider).
  // Ensure `$route` will be instantiated in time to capture the initial `$locationChangeSuccess`
  // event (unless explicitly disabled). This is necessary in case `ngView` is included in an
  // asynchronously loaded template.
  run(instantiateRoute);
var $routeMinErr = angular.$$minErr('ngRoute');
var isEagerInstantiationEnabled;


/**
 * @ngdoc provider
 * @name $routeProvider
 * @this
 *
 * @description
 *
 * Used for configuring routes.
 *
 * ## Example
 * See {@link ngRoute.$route#examples $route} for an example of configuring and using `ngRoute`.
 *
 * ## Dependencies
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 */
function $RouteProvider() {
  isArray = angular.isArray;
  isObject = angular.isObject;
  isDefined = angular.isDefined;
  noop = angular.noop;

  function inherit(parent, extra) {
    return angular.extend(Object.create(parent), extra);
  }

  var routes = {};

  /**
   * @ngdoc method
   * @name $routeProvider#when
   *
   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
   *    contains redundant trailing slash or is missing one, the route will still match and the
   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
   *    route definition.
   *
   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
   *        to the next slash are matched and stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain named groups starting with a colon and ending with a star:
   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
   *
   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
   *
   *    * `color: brown`
   *    * `largecode: code/with/slashes`.
   *
   *
   * @param {Object} route Mapping information to be assigned to `$route.current` on route
   *    match.
   *
   *    Object properties:
   *
   *    - `controller` – `{(string|Function)=}` – Controller fn that should be associated with
   *      newly created scope or the name of a {@link angular.Module#controller registered
   *      controller} if passed as a string.
   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *    - `template` – `{(string|Function)=}` – html template as a string or a function that
   *      returns an html template as a string which should be used by {@link
   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
   *      This property takes precedence over `templateUrl`.
   *
   *      If `template` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *      One of `template` or `templateUrl` is required.
   *
   *    - `templateUrl` – `{(string|Function)=}` – path or function that returns a path to an html
   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
   *
   *      If `templateUrl` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *      One of `templateUrl` or `template` is required.
   *
   *    - `resolve` - `{Object.<string, Function>=}` - An optional map of dependencies which should
   *      be injected into the controller. If any of these dependencies are promises, the router
   *      will wait for them all to be resolved or one to be rejected before the controller is
   *      instantiated.
   *      If all the promises are resolved successfully, the values of the resolved promises are
   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
   *      fired. If any of the promises are rejected the
   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
   *      For easier access to the resolved dependencies from the template, the `resolve` map will
   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
   *      working with {@link angular.Module#component components} as route templates.<br />
   *      <div class="alert alert-warning">
   *        **Note:** If your scope already contains a property with this name, it will be hidden
   *        or overwritten. Make sure, you specify an appropriate name for this property, that
   *        does not collide with other properties on the scope.
   *      </div>
   *      The map object is:
   *
   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
   *      - `factory` - `{string|Function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
   *        and the return value is treated as the dependency. If the result is a promise, it is
   *        resolved before its value is injected into the controller. Be aware that
   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
   *
   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
   *      the scope of the route. If omitted, defaults to `$resolve`.
   *
   *    - `redirectTo` – `{(string|Function)=}` – value to update
   *      {@link ng.$location $location} path with and trigger route redirection.
   *
   *      If `redirectTo` is a function, it will be called with the following parameters:
   *
   *      - `{Object.<string>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route templateUrl.
   *      - `{string}` - current `$location.path()`
   *      - `{Object}` - current `$location.search()`
   *
   *      The custom `redirectTo` function is expected to return a string which will be used
   *      to update `$location.url()`. If the function throws an error, no further processing will
   *      take place and the {@link ngRoute.$route#$routeChangeError $routeChangeError} event will
   *      be fired.
   *
   *      Routes that specify `redirectTo` will not have their controllers, template functions
   *      or resolves called, the `$location` will be changed to the redirect url and route
   *      processing will stop. The exception to this is if the `redirectTo` is a function that
   *      returns `undefined`. In this case the route transition occurs as though there was no
   *      redirection.
   *
   *    - `resolveRedirectTo` – `{Function=}` – a function that will (eventually) return the value
   *      to update {@link ng.$location $location} URL with and trigger route redirection. In
   *      contrast to `redirectTo`, dependencies can be injected into `resolveRedirectTo` and the
   *      return value can be either a string or a promise that will be resolved to a string.
   *
   *      Similar to `redirectTo`, if the return value is `undefined` (or a promise that gets
   *      resolved to `undefined`), no redirection takes place and the route transition occurs as
   *      though there was no redirection.
   *
   *      If the function throws an error or the returned promise gets rejected, no further
   *      processing will take place and the
   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event will be fired.
   *
   *      `redirectTo` takes precedence over `resolveRedirectTo`, so specifying both on the same
   *      route definition, will cause the latter to be ignored.
   *
   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
   *      or `$location.hash()` changes.
   *
   *      If the option is set to `false` and url in the browser changes, then
   *      `$routeUpdate` event is broadcasted on the root scope.
   *
   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
   *
   *      If the option is set to `true`, then the particular route can be matched without being
   *      case sensitive
   *
   * @returns {Object} self
   *
   * @description
   * Adds a new route definition to the `$route` service.
   */
  this.when = function(path, route) {
    //copy original route object to preserve params inherited from proto chain
    var routeCopy = shallowCopy(route);
    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
      routeCopy.reloadOnSearch = true;
    }
    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
    }
    routes[path] = angular.extend(
      routeCopy,
      path && pathRegExp(path, routeCopy)
    );

    // create redirection for trailing slashes
    if (path) {
      var redirectPath = (path[path.length - 1] === '/')
            ? path.substr(0, path.length - 1)
            : path + '/';

      routes[redirectPath] = angular.extend(
        {redirectTo: path},
        pathRegExp(redirectPath, routeCopy)
      );
    }

    return this;
  };

  /**
   * @ngdoc property
   * @name $routeProvider#caseInsensitiveMatch
   * @description
   *
   * A boolean property indicating if routes defined
   * using this provider should be matched using a case insensitive
   * algorithm. Defaults to `false`.
   */
  this.caseInsensitiveMatch = false;

   /**
    * @param path {string} path
    * @param opts {Object} options
    * @return {?Object}
    *
    * @description
    * Normalizes the given path, returning a regular expression
    * and the original path.
    *
    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
    */
  function pathRegExp(path, opts) {
    var insensitive = opts.caseInsensitiveMatch,
        ret = {
          originalPath: path,
          regexp: path
        },
        keys = ret.keys = [];

    path = path
      .replace(/([().])/g, '\\$1')
      .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
        var optional = (option === '?' || option === '*?') ? '?' : null;
        var star = (option === '*' || option === '*?') ? '*' : null;
        keys.push({ name: key, optional: !!optional });
        slash = slash || '';
        return ''
          + (optional ? '' : slash)
          + '(?:'
          + (optional ? slash : '')
          + (star && '(.+?)' || '([^/]+)')
          + (optional || '')
          + ')'
          + (optional || '');
      })
      .replace(/([/$*])/g, '\\$1');

    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
    return ret;
  }

  /**
   * @ngdoc method
   * @name $routeProvider#otherwise
   *
   * @description
   * Sets route definition that will be used on route change when no other route definition
   * is matched.
   *
   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
   * If called with a string, the value maps to `redirectTo`.
   * @returns {Object} self
   */
  this.otherwise = function(params) {
    if (typeof params === 'string') {
      params = {redirectTo: params};
    }
    this.when(null, params);
    return this;
  };

  /**
   * @ngdoc method
   * @name $routeProvider#eagerInstantiationEnabled
   * @kind function
   *
   * @description
   * Call this method as a setter to enable/disable eager instantiation of the
   * {@link ngRoute.$route $route} service upon application bootstrap. You can also call it as a
   * getter (i.e. without any arguments) to get the current value of the
   * `eagerInstantiationEnabled` flag.
   *
   * Instantiating `$route` early is necessary for capturing the initial
   * {@link ng.$location#$locationChangeStart $locationChangeStart} event and navigating to the
   * appropriate route. Usually, `$route` is instantiated in time by the
   * {@link ngRoute.ngView ngView} directive. Yet, in cases where `ngView` is included in an
   * asynchronously loaded template (e.g. in another directive's template), the directive factory
   * might not be called soon enough for `$route` to be instantiated _before_ the initial
   * `$locationChangeSuccess` event is fired. Eager instantiation ensures that `$route` is always
   * instantiated in time, regardless of when `ngView` will be loaded.
   *
   * The default value is true.
   *
   * **Note**:<br />
   * You may want to disable the default behavior when unit-testing modules that depend on
   * `ngRoute`, in order to avoid an unexpected request for the default route's template.
   *
   * @param {boolean=} enabled - If provided, update the internal `eagerInstantiationEnabled` flag.
   *
   * @returns {*} The current value of the `eagerInstantiationEnabled` flag if used as a getter or
   *     itself (for chaining) if used as a setter.
   */
  isEagerInstantiationEnabled = true;
  this.eagerInstantiationEnabled = function eagerInstantiationEnabled(enabled) {
    if (isDefined(enabled)) {
      isEagerInstantiationEnabled = enabled;
      return this;
    }

    return isEagerInstantiationEnabled;
  };


  this.$get = ['$rootScope',
               '$location',
               '$routeParams',
               '$q',
               '$injector',
               '$templateRequest',
               '$sce',
               '$browser',
      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce, $browser) {

    /**
     * @ngdoc service
     * @name $route
     * @requires $location
     * @requires $routeParams
     *
     * @property {Object} current Reference to the current route definition.
     * The route definition contains:
     *
     *   - `controller`: The controller constructor as defined in the route definition.
     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
     *     controller instantiation. The `locals` contain
     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
     *
     *     - `$scope` - The current route scope.
     *     - `$template` - The current route template HTML.
     *
     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
     *     the property name, using `resolveAs` in the route definition. See
     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
     *
     * @property {Object} routes Object with all route configuration Objects as its properties.
     *
     * @description
     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
     * It watches `$location.url()` and tries to map the path to an existing route definition.
     *
     * Requires the {@link ngRoute `ngRoute`} module to be installed.
     *
     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
     *
     * The `$route` service is typically used in conjunction with the
     * {@link ngRoute.directive:ngView `ngView`} directive and the
     * {@link ngRoute.$routeParams `$routeParams`} service.
     *
     * @example
     * This example shows how changing the URL hash causes the `$route` to match a route against the
     * URL, and the `ngView` pulls in the partial.
     *
     * <example name="$route-service" module="ngRouteExample"
     *          deps="angular-route.js" fixBase="true">
     *   <file name="index.html">
     *     <div ng-controller="MainController">
     *       Choose:
     *       <a href="Book/Moby">Moby</a> |
     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
     *       <a href="Book/Gatsby">Gatsby</a> |
     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
     *
     *       <div ng-view></div>
     *
     *       <hr />
     *
     *       <pre>$location.path() = {{$location.path()}}</pre>
     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
     *       <pre>$route.current.params = {{$route.current.params}}</pre>
     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
     *       <pre>$routeParams = {{$routeParams}}</pre>
     *     </div>
     *   </file>
     *
     *   <file name="book.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *   </file>
     *
     *   <file name="chapter.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *     Chapter Id: {{params.chapterId}}
     *   </file>
     *
     *   <file name="script.js">
     *     angular.module('ngRouteExample', ['ngRoute'])
     *
     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
     *          $scope.$route = $route;
     *          $scope.$location = $location;
     *          $scope.$routeParams = $routeParams;
     *      })
     *
     *      .controller('BookController', function($scope, $routeParams) {
     *          $scope.name = 'BookController';
     *          $scope.params = $routeParams;
     *      })
     *
     *      .controller('ChapterController', function($scope, $routeParams) {
     *          $scope.name = 'ChapterController';
     *          $scope.params = $routeParams;
     *      })
     *
     *     .config(function($routeProvider, $locationProvider) {
     *       $routeProvider
     *        .when('/Book/:bookId', {
     *         templateUrl: 'book.html',
     *         controller: 'BookController',
     *         resolve: {
     *           // I will cause a 1 second delay
     *           delay: function($q, $timeout) {
     *             var delay = $q.defer();
     *             $timeout(delay.resolve, 1000);
     *             return delay.promise;
     *           }
     *         }
     *       })
     *       .when('/Book/:bookId/ch/:chapterId', {
     *         templateUrl: 'chapter.html',
     *         controller: 'ChapterController'
     *       });
     *
     *       // configure html5 to get links working on jsfiddle
     *       $locationProvider.html5Mode(true);
     *     });
     *
     *   </file>
     *
     *   <file name="protractor.js" type="protractor">
     *     it('should load and compile correct template', function() {
     *       element(by.linkText('Moby: Ch1')).click();
     *       var content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: ChapterController/);
     *       expect(content).toMatch(/Book Id: Moby/);
     *       expect(content).toMatch(/Chapter Id: 1/);
     *
     *       element(by.partialLinkText('Scarlet')).click();
     *
     *       content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: BookController/);
     *       expect(content).toMatch(/Book Id: Scarlet/);
     *     });
     *   </file>
     * </example>
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a route change. At this  point the route services starts
     * resolving all of the dependencies needed for the route change to occur.
     * Typically this involves fetching the view template as well as any dependencies
     * defined in `resolve` route property. Once  all of the dependencies are resolved
     * `$routeChangeSuccess` is fired.
     *
     * The route change (and the `$location` change that triggered it) can be prevented
     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
     * for more details about event object.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} next Future route information.
     * @param {Route} current Current route information.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a route change has happened successfully.
     * The `resolve` dependencies are now available in the `current.locals` property.
     *
     * {@link ngRoute.directive:ngView ngView} listens for the directive
     * to instantiate the controller and render the view.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} current Current route information.
     * @param {Route|Undefined} previous Previous route information, or undefined if current is
     * first route entered.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeError
     * @eventType broadcast on root scope
     * @description
     * Broadcasted if a redirection function fails or any redirection or resolve promises are
     * rejected.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current route information.
     * @param {Route} previous Previous route information.
     * @param {Route} rejection The thrown error or the rejection reason of the promise. Usually
     * the rejection reason is the error that caused the promise to get rejected.
     */

    /**
     * @ngdoc event
     * @name $route#$routeUpdate
     * @eventType broadcast on root scope
     * @description
     * The `reloadOnSearch` property has been set to false, and we are reusing the same
     * instance of the Controller.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current/previous route information.
     */

    var forceReload = false,
        preparedRoute,
        preparedRouteIsUpdateOnly,
        $route = {
          routes: routes,

          /**
           * @ngdoc method
           * @name $route#reload
           *
           * @description
           * Causes `$route` service to reload the current route even if
           * {@link ng.$location $location} hasn't changed.
           *
           * As a result of that, {@link ngRoute.directive:ngView ngView}
           * creates new scope and reinstantiates the controller.
           */
          reload: function() {
            forceReload = true;

            var fakeLocationEvent = {
              defaultPrevented: false,
              preventDefault: function fakePreventDefault() {
                this.defaultPrevented = true;
                forceReload = false;
              }
            };

            $rootScope.$evalAsync(function() {
              prepareRoute(fakeLocationEvent);
              if (!fakeLocationEvent.defaultPrevented) commitRoute();
            });
          },

          /**
           * @ngdoc method
           * @name $route#updateParams
           *
           * @description
           * Causes `$route` service to update the current URL, replacing
           * current route parameters with those specified in `newParams`.
           * Provided property names that match the route's path segment
           * definitions will be interpolated into the location's path, while
           * remaining properties will be treated as query params.
           *
           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
           */
          updateParams: function(newParams) {
            if (this.current && this.current.$$route) {
              newParams = angular.extend({}, this.current.params, newParams);
              $location.path(interpolate(this.current.$$route.originalPath, newParams));
              // interpolate modifies newParams, only query params are left
              $location.search(newParams);
            } else {
              throw $routeMinErr('norout', 'Tried updating route when with no current route');
            }
          }
        };

    $rootScope.$on('$locationChangeStart', prepareRoute);
    $rootScope.$on('$locationChangeSuccess', commitRoute);

    return $route;

    /////////////////////////////////////////////////////

    /**
     * @param on {string} current url
     * @param route {Object} route regexp to match the url against
     * @return {?Object}
     *
     * @description
     * Check if the route matches the current url.
     *
     * Inspired by match in
     * visionmedia/express/lib/router/router.js.
     */
    function switchRouteMatcher(on, route) {
      var keys = route.keys,
          params = {};

      if (!route.regexp) return null;

      var m = route.regexp.exec(on);
      if (!m) return null;

      for (var i = 1, len = m.length; i < len; ++i) {
        var key = keys[i - 1];

        var val = m[i];

        if (key && val) {
          params[key.name] = val;
        }
      }
      return params;
    }

    function prepareRoute($locationEvent) {
      var lastRoute = $route.current;

      preparedRoute = parseRoute();
      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
          && !preparedRoute.reloadOnSearch && !forceReload;

      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
          if ($locationEvent) {
            $locationEvent.preventDefault();
          }
        }
      }
    }

    function commitRoute() {
      var lastRoute = $route.current;
      var nextRoute = preparedRoute;

      if (preparedRouteIsUpdateOnly) {
        lastRoute.params = nextRoute.params;
        angular.copy(lastRoute.params, $routeParams);
        $rootScope.$broadcast('$routeUpdate', lastRoute);
      } else if (nextRoute || lastRoute) {
        forceReload = false;
        $route.current = nextRoute;

        var nextRoutePromise = $q.resolve(nextRoute);

        $browser.$$incOutstandingRequestCount();

        nextRoutePromise.
          then(getRedirectionData).
          then(handlePossibleRedirection).
          then(function(keepProcessingRoute) {
            return keepProcessingRoute && nextRoutePromise.
              then(resolveLocals).
              then(function(locals) {
                // after route change
                if (nextRoute === $route.current) {
                  if (nextRoute) {
                    nextRoute.locals = locals;
                    angular.copy(nextRoute.params, $routeParams);
                  }
                  $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
                }
              });
          }).catch(function(error) {
            if (nextRoute === $route.current) {
              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
            }
          }).finally(function() {
            // Because `commitRoute()` is called from a `$rootScope.$evalAsync` block (see
            // `$locationWatch`), this `$$completeOutstandingRequest()` call will not cause
            // `outstandingRequestCount` to hit zero.  This is important in case we are redirecting
            // to a new route which also requires some asynchronous work.

            $browser.$$completeOutstandingRequest(noop);
          });
      }
    }

    function getRedirectionData(route) {
      var data = {
        route: route,
        hasRedirection: false
      };

      if (route) {
        if (route.redirectTo) {
          if (angular.isString(route.redirectTo)) {
            data.path = interpolate(route.redirectTo, route.params);
            data.search = route.params;
            data.hasRedirection = true;
          } else {
            var oldPath = $location.path();
            var oldSearch = $location.search();
            var newUrl = route.redirectTo(route.pathParams, oldPath, oldSearch);

            if (angular.isDefined(newUrl)) {
              data.url = newUrl;
              data.hasRedirection = true;
            }
          }
        } else if (route.resolveRedirectTo) {
          return $q.
            resolve($injector.invoke(route.resolveRedirectTo)).
            then(function(newUrl) {
              if (angular.isDefined(newUrl)) {
                data.url = newUrl;
                data.hasRedirection = true;
              }

              return data;
            });
        }
      }

      return data;
    }

    function handlePossibleRedirection(data) {
      var keepProcessingRoute = true;

      if (data.route !== $route.current) {
        keepProcessingRoute = false;
      } else if (data.hasRedirection) {
        var oldUrl = $location.url();
        var newUrl = data.url;

        if (newUrl) {
          $location.
            url(newUrl).
            replace();
        } else {
          newUrl = $location.
            path(data.path).
            search(data.search).
            replace().
            url();
        }

        if (newUrl !== oldUrl) {
          // Exit out and don't process current next value,
          // wait for next location change from redirect
          keepProcessingRoute = false;
        }
      }

      return keepProcessingRoute;
    }

    function resolveLocals(route) {
      if (route) {
        var locals = angular.extend({}, route.resolve);
        angular.forEach(locals, function(value, key) {
          locals[key] = angular.isString(value) ?
              $injector.get(value) :
              $injector.invoke(value, null, null, key);
        });
        var template = getTemplateFor(route);
        if (angular.isDefined(template)) {
          locals['$template'] = template;
        }
        return $q.all(locals);
      }
    }

    function getTemplateFor(route) {
      var template, templateUrl;
      if (angular.isDefined(template = route.template)) {
        if (angular.isFunction(template)) {
          template = template(route.params);
        }
      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
        if (angular.isFunction(templateUrl)) {
          templateUrl = templateUrl(route.params);
        }
        if (angular.isDefined(templateUrl)) {
          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
          template = $templateRequest(templateUrl);
        }
      }
      return template;
    }

    /**
     * @returns {Object} the current active route, by matching it against the URL
     */
    function parseRoute() {
      // Match a route
      var params, match;
      angular.forEach(routes, function(route, path) {
        if (!match && (params = switchRouteMatcher($location.path(), route))) {
          match = inherit(route, {
            params: angular.extend({}, $location.search(), params),
            pathParams: params});
          match.$$route = route;
        }
      });
      // No route matched; fallback to "otherwise" route
      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
    }

    /**
     * @returns {string} interpolation of the redirect path with the parameters
     */
    function interpolate(string, params) {
      var result = [];
      angular.forEach((string || '').split(':'), function(segment, i) {
        if (i === 0) {
          result.push(segment);
        } else {
          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
          var key = segmentMatch[1];
          result.push(params[key]);
          result.push(segmentMatch[2] || '');
          delete params[key];
        }
      });
      return result.join('');
    }
  }];
}

instantiateRoute.$inject = ['$injector'];
function instantiateRoute($injector) {
  if (isEagerInstantiationEnabled) {
    // Instantiate `$route`
    $injector.get('$route');
  }
}

ngRouteModule.provider('$routeParams', $RouteParamsProvider);


/**
 * @ngdoc service
 * @name $routeParams
 * @requires $route
 * @this
 *
 * @description
 * The `$routeParams` service allows you to retrieve the current set of route parameters.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * The route parameters are a combination of {@link ng.$location `$location`}'s
 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
 *
 * In case of parameter name collision, `path` params take precedence over `search` params.
 *
 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
 * (but its properties will likely change) even when a route change occurs.
 *
 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
 * Instead you can use `$route.current.params` to access the new route's parameters.
 *
 * @example
 * ```js
 *  // Given:
 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
 *  // Route: /Chapter/:chapterId/Section/:sectionId
 *  //
 *  // Then
 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
 * ```
 */
function $RouteParamsProvider() {
  this.$get = function() { return {}; };
}

ngRouteModule.directive('ngView', ngViewFactory);
ngRouteModule.directive('ngView', ngViewFillContentFactory);


/**
 * @ngdoc directive
 * @name ngView
 * @restrict ECA
 *
 * @description
 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
 * including the rendered template of the current route into the main layout (`index.html`) file.
 * Every time the current route changes, the included view changes with it according to the
 * configuration of the `$route` service.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the view is updated.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
 *                    as an expression yields a truthy value.
 * @example
    <example name="ngView-directive" module="ngViewExample"
             deps="angular-route.js;angular-animate.js"
             animations="true" fixBase="true">
      <file name="index.html">
        <div ng-controller="MainCtrl as main">
          Choose:
          <a href="Book/Moby">Moby</a> |
          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
          <a href="Book/Gatsby">Gatsby</a> |
          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
          <a href="Book/Scarlet">Scarlet Letter</a><br/>

          <div class="view-animate-container">
            <div ng-view class="view-animate"></div>
          </div>
          <hr />

          <pre>$location.path() = {{main.$location.path()}}</pre>
          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
          <pre>$route.current.params = {{main.$route.current.params}}</pre>
          <pre>$routeParams = {{main.$routeParams}}</pre>
        </div>
      </file>

      <file name="book.html">
        <div>
          controller: {{book.name}}<br />
          Book Id: {{book.params.bookId}}<br />
        </div>
      </file>

      <file name="chapter.html">
        <div>
          controller: {{chapter.name}}<br />
          Book Id: {{chapter.params.bookId}}<br />
          Chapter Id: {{chapter.params.chapterId}}
        </div>
      </file>

      <file name="animations.css">
        .view-animate-container {
          position:relative;
          height:100px!important;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }

        .view-animate {
          padding:10px;
        }

        .view-animate.ng-enter, .view-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;

          display:block;
          width:100%;
          border-left:1px solid black;

          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          padding:10px;
        }

        .view-animate.ng-enter {
          left:100%;
        }
        .view-animate.ng-enter.ng-enter-active {
          left:0;
        }
        .view-animate.ng-leave.ng-leave-active {
          left:-100%;
        }
      </file>

      <file name="script.js">
        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
          .config(['$routeProvider', '$locationProvider',
            function($routeProvider, $locationProvider) {
              $routeProvider
                .when('/Book/:bookId', {
                  templateUrl: 'book.html',
                  controller: 'BookCtrl',
                  controllerAs: 'book'
                })
                .when('/Book/:bookId/ch/:chapterId', {
                  templateUrl: 'chapter.html',
                  controller: 'ChapterCtrl',
                  controllerAs: 'chapter'
                });

              $locationProvider.html5Mode(true);
          }])
          .controller('MainCtrl', ['$route', '$routeParams', '$location',
            function MainCtrl($route, $routeParams, $location) {
              this.$route = $route;
              this.$location = $location;
              this.$routeParams = $routeParams;
          }])
          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
            this.name = 'BookCtrl';
            this.params = $routeParams;
          }])
          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
            this.name = 'ChapterCtrl';
            this.params = $routeParams;
          }]);

      </file>

      <file name="protractor.js" type="protractor">
        it('should load and compile correct template', function() {
          element(by.linkText('Moby: Ch1')).click();
          var content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: ChapterCtrl/);
          expect(content).toMatch(/Book Id: Moby/);
          expect(content).toMatch(/Chapter Id: 1/);

          element(by.partialLinkText('Scarlet')).click();

          content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: BookCtrl/);
          expect(content).toMatch(/Book Id: Scarlet/);
        });
      </file>
    </example>
 */


/**
 * @ngdoc event
 * @name ngView#$viewContentLoaded
 * @eventType emit on the current ngView scope
 * @description
 * Emitted every time the ngView content is reloaded.
 */
ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
function ngViewFactory($route, $anchorScroll, $animate) {
  return {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    link: function(scope, $element, attr, ctrl, $transclude) {
        var currentScope,
            currentElement,
            previousLeaveAnimation,
            autoScrollExp = attr.autoscroll,
            onloadExp = attr.onload || '';

        scope.$on('$routeChangeSuccess', update);
        update();

        function cleanupLastView() {
          if (previousLeaveAnimation) {
            $animate.cancel(previousLeaveAnimation);
            previousLeaveAnimation = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            previousLeaveAnimation = $animate.leave(currentElement);
            previousLeaveAnimation.done(function(response) {
              if (response !== false) previousLeaveAnimation = null;
            });
            currentElement = null;
          }
        }

        function update() {
          var locals = $route.current && $route.current.locals,
              template = locals && locals.$template;

          if (angular.isDefined(template)) {
            var newScope = scope.$new();
            var current = $route.current;

            // Note: This will also link all children of ng-view that were contained in the original
            // html. If that content contains controllers, ... they could pollute/change the scope.
            // However, using ng-view on an element with additional content does not make sense...
            // Note: We can't remove them in the cloneAttchFn of $transclude as that
            // function is called before linking the content, which would apply child
            // directives to non existing elements.
            var clone = $transclude(newScope, function(clone) {
              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
                if (response !== false && angular.isDefined(autoScrollExp)
                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                  $anchorScroll();
                }
              });
              cleanupLastView();
            });

            currentElement = clone;
            currentScope = current.scope = newScope;
            currentScope.$emit('$viewContentLoaded');
            currentScope.$eval(onloadExp);
          } else {
            cleanupLastView();
          }
        }
    }
  };
}

// This directive is called during the $transclude call of the first `ngView` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngView
// is called.
ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
function ngViewFillContentFactory($compile, $controller, $route) {
  return {
    restrict: 'ECA',
    priority: -400,
    link: function(scope, $element) {
      var current = $route.current,
          locals = current.locals;

      $element.html(locals.$template);

      var link = $compile($element.contents());

      if (current.controller) {
        locals.$scope = scope;
        var controller = $controller(current.controller, locals);
        if (current.controllerAs) {
          scope[current.controllerAs] = controller;
        }
        $element.data('$ngControllerController', controller);
        $element.children().data('$ngControllerController', controller);
      }
      scope[current.resolveAs || '$resolve'] = locals;

      link(scope);
    }
  };
}


})(window, window.angular);


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(643);
module.exports = 'gettext';


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/**
 * @ngdoc module
 * @name gettext
 * @packageName angular-gettext
 * @description Super simple Gettext for Angular.JS
 *
 * A sample application can be found at https://github.com/rubenv/angular-gettext-example.
 * This is an adaptation of the [TodoMVC](http://todomvc.com/) example. You can use this as a guideline while adding {@link angular-gettext angular-gettext} to your own application.
 */
/**
 * @ngdoc factory
 * @module gettext
 * @name gettextPlurals
 * @param {String} [langCode=en] language code
 * @param {Number} [n=0] number to calculate form for
 * @returns {Number} plural form number
 * @description Provides correct plural form id for the given language
 *
 * Example
 * ```js
 * gettextPlurals('ru', 10); // 1
 * gettextPlurals('en', 1);  // 0
 * gettextPlurals();         // 1
 * ```
 */
angular.module('gettext', []);
/**
 * @ngdoc object
 * @module gettext
 * @name gettext
 * @kind function
 * @param {String} str annotation key
 * @description Gettext constant function for annotating strings
 *
 * ```js
 * angular.module('myApp', ['gettext']).config(function(gettext) {
 *   /// MyApp document title
 *   gettext('my-app.title');
 *   ...
 * })
 * ```
 */
angular.module('gettext').constant('gettext', function (str) {
    /*
     * Does nothing, simply returns the input string.
     *
     * This function serves as a marker for `grunt-angular-gettext` to know that
     * this string should be extracted for translations.
     */
    return str;
});

/**
 * @ngdoc service
 * @module gettext
 * @name gettextCatalog
 * @requires gettextPlurals
 * @requires gettextFallbackLanguage
 * @requires https://docs.angularjs.org/api/ng/service/$http $http
 * @requires https://docs.angularjs.org/api/ng/service/$cacheFactory $cacheFactory
 * @requires https://docs.angularjs.org/api/ng/service/$interpolate $interpolate
 * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
 * @description Provides set of method to translate strings
 */
angular.module('gettext').factory('gettextCatalog', ["gettextPlurals", "gettextFallbackLanguage", "$http", "$cacheFactory", "$interpolate", "$rootScope", function (gettextPlurals, gettextFallbackLanguage, $http, $cacheFactory, $interpolate, $rootScope) {
    var catalog;
    var noContext = '$$noContext';

    // IE8 returns UPPER CASE tags, even though the source is lower case.
    // This can causes the (key) string in the DOM to have a different case to
    // the string in the `po` files.
    // IE9, IE10 and IE11 reorders the attributes of tags.
    var test = '<span id="test" title="test" class="tested">test</span>';
    var isHTMLModified = (angular.element('<span>' + test + '</span>').html() !== test);

    var prefixDebug = function (string) {
        if (catalog.debug && catalog.currentLanguage !== catalog.baseLanguage) {
            return catalog.debugPrefix + string;
        } else {
            return string;
        }
    };

    var addTranslatedMarkers = function (string) {
        if (catalog.showTranslatedMarkers) {
            return catalog.translatedMarkerPrefix + string + catalog.translatedMarkerSuffix;
        } else {
            return string;
        }
    };

    function broadcastUpdated() {
        /**
         * @ngdoc event
         * @name gettextCatalog#gettextLanguageChanged
         * @eventType broadcast on $rootScope
         * @description Fires language change notification without any additional parameters.
         */
        $rootScope.$broadcast('gettextLanguageChanged');
    }

    catalog = {
        /**
         * @ngdoc property
         * @name gettextCatalog#debug
         * @public
         * @type {Boolean} false
         * @see gettextCatalog#debug
         * @description Whether or not to prefix untranslated strings with `[MISSING]:` or a custom prefix.
         */
        debug: false,
        /**
         * @ngdoc property
         * @name gettextCatalog#debugPrefix
         * @public
         * @type {String} [MISSING]:
         * @description Custom prefix for untranslated strings when {@link gettextCatalog#debug gettextCatalog#debug} set to `true`.
         */
        debugPrefix: '[MISSING]: ',
        /**
         * @ngdoc property
         * @name gettextCatalog#showTranslatedMarkers
         * @public
         * @type {Boolean} false
         * @description Whether or not to wrap all processed text with markers.
         *
         * Example output: `[Welcome]`
         */
        showTranslatedMarkers: false,
        /**
         * @ngdoc property
         * @name gettextCatalog#translatedMarkerPrefix
         * @public
         * @type {String} [
         * @description Custom prefix to mark strings that have been run through {@link angular-gettext angular-gettext}.
         */
        translatedMarkerPrefix: '[',
        /**
         * @ngdoc property
         * @name gettextCatalog#translatedMarkerSuffix
         * @public
         * @type {String} ]
         * @description Custom suffix to mark strings that have been run through {@link angular-gettext angular-gettext}.
         */
        translatedMarkerSuffix: ']',
        /**
         * @ngdoc property
         * @name gettextCatalog#strings
         * @private
         * @type {Object}
         * @description An object of loaded translation strings. Shouldn't be used directly.
         */
        strings: {},
        /**
         * @ngdoc property
         * @name gettextCatalog#baseLanguage
         * @protected
         * @deprecated
         * @since 2.0
         * @type {String} en
         * @description The default language, in which you're application is written.
         *
         * This defaults to English and it's generally a bad idea to use anything else:
         * if your language has different pluralization rules you'll end up with incorrect translations.
         */
        baseLanguage: 'en',
        /**
         * @ngdoc property
         * @name gettextCatalog#currentLanguage
         * @public
         * @type {String}
         * @description Active language.
         */
        currentLanguage: 'en',
        /**
         * @ngdoc property
         * @name gettextCatalog#cache
         * @public
         * @type {String} en
         * @description Language cache for lazy load
         */
        cache: $cacheFactory('strings'),

        /**
         * @ngdoc method
         * @name gettextCatalog#setCurrentLanguage
         * @public
         * @param {String} lang language name
         * @description Sets the current language and makes sure that all translations get updated correctly.
         */
        setCurrentLanguage: function (lang) {
            this.currentLanguage = lang;
            broadcastUpdated();
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#getCurrentLanguage
         * @public
         * @returns {String} current language
         * @description Returns the current language.
         */
        getCurrentLanguage: function () {
            return this.currentLanguage;
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#setStrings
         * @public
         * @param {String} language language name
         * @param {Object.<String>} strings set of strings where the key is the translation `key` and `value` is the translated text
         * @description Processes an object of string definitions. {@link guide:manual-setstrings More details here}.
         */
        setStrings: function (language, strings) {
            if (!this.strings[language]) {
                this.strings[language] = {};
            }

            var defaultPlural = gettextPlurals(language, 1);
            for (var key in strings) {
                var val = strings[key];

                if (isHTMLModified) {
                    // Use the DOM engine to render any HTML in the key (#131).
                    key = angular.element('<span>' + key + '</span>').html();
                }

                if (angular.isString(val) || angular.isArray(val)) {
                    // No context, wrap it in $$noContext.
                    var obj = {};
                    obj[noContext] = val;
                    val = obj;
                }

                if (!this.strings[language][key]) {
                    this.strings[language][key] = {};
                }

                for (var context in val) {
                    var str = val[context];
                    if (!angular.isArray(str)) {
                        // Expand single strings
                        this.strings[language][key][context] = [];
                        this.strings[language][key][context][defaultPlural] = str;
                    } else {
                        this.strings[language][key][context] = str;
                    }
                }
            }

            broadcastUpdated();
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#getStringFormFor
         * @protected
         * @param {String} language language name
         * @param {String} string translation key
         * @param {Number=} n number to build string form for
         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
         * @returns {String|Null} translated or annotated string or null if language is not set
         * @description Translate a string with the given language, count and context.
         */
        getStringFormFor: function (language, string, n, context) {
            if (!language) {
                return null;
            }
            var stringTable = this.strings[language] || {};
            var contexts = stringTable[string] || {};
            var plurals = contexts[context || noContext] || [];
            return plurals[gettextPlurals(language, n)];
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#getString
         * @public
         * @param {String} string translation key
         * @param {$rootScope.Scope=} scope scope to do interpolation against
         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
         * @returns {String} translated or annotated string
         * @description Translate a string with the given scope and context.
         *
         * First it tries {@link gettextCatalog#currentLanguage gettextCatalog#currentLanguage} (e.g. `en-US`) then {@link gettextFallbackLanguage fallback} (e.g. `en`).
         *
         * When `scope` is supplied it uses Angular.JS interpolation, so something like this will do what you expect:
         * ```js
         * var hello = gettextCatalog.getString("Hello {{name}}!", { name: "Ruben" });
         * // var hello will be "Hallo Ruben!" in Dutch.
         * ```
         * Avoid using scopes - this skips interpolation and is a lot faster.
         */
        getString: function (string, scope, context) {
            var fallbackLanguage = gettextFallbackLanguage(this.currentLanguage);
            string = this.getStringFormFor(this.currentLanguage, string, 1, context) ||
                     this.getStringFormFor(fallbackLanguage, string, 1, context) ||
                     prefixDebug(string);
            string = scope ? $interpolate(string)(scope) : string;
            return addTranslatedMarkers(string);
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#getPlural
         * @public
         * @param {Number} n number to build string form for
         * @param {String} string translation key
         * @param {String} stringPlural plural translation key
         * @param {$rootScope.Scope=} scope scope to do interpolation against
         * @param {String=} context translation key context, e.g. {@link doc:context Verb, Noun}
         * @returns {String} translated or annotated string
         * @see {@link gettextCatalog#getString gettextCatalog#getString} for details
         * @description Translate a plural string with the given context.
         */
        getPlural: function (n, string, stringPlural, scope, context) {
            var fallbackLanguage = gettextFallbackLanguage(this.currentLanguage);
            string = this.getStringFormFor(this.currentLanguage, string, n, context) ||
                     this.getStringFormFor(fallbackLanguage, string, n, context) ||
                     prefixDebug(n === 1 ? string : stringPlural);
            if (scope) {
                scope.$count = n;
                string = $interpolate(string)(scope);
            }
            return addTranslatedMarkers(string);
        },

        // Synchronous alternative to gettextCatalog#loadRemote
        // Delays rendering until translations have loaded
        // so no default strings are shown/cached while loading
        loadRemoteSync: function (url) {
            var xhr = new XMLHttpRequest();

            xhr.addEventListener('load', function () {
                var data = JSON.parse(this.responseText);
                for (var lang in data) {
                    catalog.setStrings(lang, data[lang]);
                }
            });

            xhr.open('GET', url, false);
            xhr.send();
        },

        /**
         * @ngdoc method
         * @name gettextCatalog#loadRemote
         * @public
         * @param {String} url location of the translations
         * @description Load a set of translation strings from a given URL.
         *
         * This should be a JSON catalog generated with [angular-gettext-tools](https://github.com/rubenv/angular-gettext-tools).
         * {@link guide:lazy-loading More details here}.
         */
        loadRemote: function (url) {
            return $http({
                method: 'GET',
                url: url,
                cache: catalog.cache
            }).then(function (response) {
                var data = response.data;
                for (var lang in data) {
                    catalog.setStrings(lang, data[lang]);
                }
                return response;
            });
        }
    };

    return catalog;
}]);

/**
 * @ngdoc directive
 * @module gettext
 * @name translate
 * @requires gettextCatalog
 * @requires gettextUtil
 * @requires https://docs.angularjs.org/api/ng/service/$parse $parse
 * @requires https://docs.angularjs.org/api/ng/service/$animate $animate
 * @requires https://docs.angularjs.org/api/ng/service/$compile $compile
 * @requires https://docs.angularjs.org/api/ng/service/$window $window
 * @restrict AE
 * @param {String} [translatePlural] plural form
 * @param {Number} translateN value to watch to substitute correct plural form
 * @param {String} translateContext context value, e.g. {@link doc:context Verb, Noun}
 * @description Annotates and translates text inside directive
 *
 * Full interpolation support is available in translated strings, so the following will work as expected:
 * ```js
 * <div translate>Hello {{name}}!</div>
 * ```
 *
 * You can also use custom context parameters while interpolating. This approach allows usage
 * of angular filters as well as custom logic inside your translated messages without unnecessary impact on translations.
 *
 * So for example when you have message like this:
 * ```js
 * <div translate>Last modified {{modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'}} by {{author}}.</div>
 * ```
 * you will have it extracted in exact same version so it would look like this:
 * `Last modified {{modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'}} by {{author}}`.
 * To start with it might be too complicated to read and handle by non technical translator. It's easy to make mistake
 * when copying format for example. Secondly if you decide to change format by some point of the project translation will broke
 * as it won't be the same string anymore.
 *
 * Instead your translator should only be concerned to place {{modificationDate}} correctly and you should have a free hand
 * to modify implementation details on how to present the results. This is how you can achieve the goal:
 * ```js
 * <div translate translate-params-modification-date="modificationDate | date:'yyyy-MM-dd HH:mm:ss Z'">Last modified {{modificationDate}} by {{author}}.</div>
 * ```
 *
 * There's a few more things worth to point out:
 * 1. You can use as many parameters as you want. Each parameter begins with `translate-params-` followed by snake-case parameter name.
 * Each parameter will be available for interpolation in camelCase manner (just like angular directive works by default).
 * ```js
 * <div translate translate-params-my-custom-param="param1" translate-params-name="name">Param {{myCustomParam}} has been changed by {{name}}.</div>
 * ```
 * 2. You can rename your variables from current scope to simple ones if you like.
 * ```js
 * <div translate translate-params-date="veryUnintuitiveNameForDate">Today's date is: {{date}}.</div>
 * ```
 * 3. You can use translate-params only for some interpolations. Rest would be treated as usual.
 * ```js
 * <div translate translate-params-cost="cost | currency">This product: {{product}} costs {{cost}}.</div>
 * ```
 */
angular.module('gettext').directive('translate', ["gettextCatalog", "$parse", "$animate", "$compile", "$window", "gettextUtil", function (gettextCatalog, $parse, $animate, $compile, $window, gettextUtil) {
    var lowercase = angular.$$lowercase || angular.lowercase;
    var msie = parseInt((/msie (\d+)/.exec(lowercase($window.navigator.userAgent)) || [])[1], 10);
    var PARAMS_PREFIX = 'translateParams';

    function getCtxAttr(key) {
        return gettextUtil.lcFirst(key.replace(PARAMS_PREFIX, ''));
    }

    function handleInterpolationContext(scope, attrs, update) {
        var attributes = Object.keys(attrs).filter(function (key) {
            return gettextUtil.startsWith(key, PARAMS_PREFIX) && key !== PARAMS_PREFIX;
        });

        if (!attributes.length) {
            return null;
        }

        var interpolationContext = angular.extend({}, scope);
        var unwatchers = [];
        attributes.forEach(function (attribute) {
            var unwatch = scope.$watch(attrs[attribute], function (newVal) {
                var key = getCtxAttr(attribute);
                interpolationContext[key] = newVal;
                update(interpolationContext);
            });
            unwatchers.push(unwatch);
        });
        scope.$on('$destroy', function () {
            unwatchers.forEach(function (unwatch) {
                unwatch();
            });
        });
        return interpolationContext;
    }

    return {
        restrict: 'AE',
        terminal: true,
        compile: function compile(element, attrs) {
            // Validate attributes
            gettextUtil.assert(!attrs.translatePlural || attrs.translateN, 'translate-n', 'translate-plural');
            gettextUtil.assert(!attrs.translateN || attrs.translatePlural, 'translate-plural', 'translate-n');

            var msgid = gettextUtil.trim(element.html());
            var translatePlural = attrs.translatePlural;
            var translateContext = attrs.translateContext;

            if (msie <= 8) {
                // Workaround fix relating to angular adding a comment node to
                // anchors. angular/angular.js/#1949 / angular/angular.js/#2013
                if (msgid.slice(-13) === '<!--IE fix-->') {
                    msgid = msgid.slice(0, -13);
                }
            }

            return {
                post: function (scope, element, attrs) {
                    var countFn = $parse(attrs.translateN);
                    var pluralScope = null;
                    var linking = true;

                    function update(interpolationContext) {
                        interpolationContext = interpolationContext || null;

                        // Fetch correct translated string.
                        var translated;
                        if (translatePlural) {
                            scope = pluralScope || (pluralScope = scope.$new());
                            scope.$count = countFn(scope);
                            translated = gettextCatalog.getPlural(scope.$count, msgid, translatePlural, interpolationContext, translateContext);
                        } else {
                            translated = gettextCatalog.getString(msgid, interpolationContext, translateContext);
                        }
                        var oldContents = element.contents();

                        if (!oldContents && !translated){
                            return;
                        }

                        // Avoid redundant swaps
                        if (translated === gettextUtil.trim(oldContents.html())){
                            // Take care of unlinked content
                            if (linking){
                                $compile(oldContents)(scope);
                            }
                            return;
                        }

                        // Swap in the translation
                        var newWrapper = angular.element('<span>' + translated + '</span>');
                        $compile(newWrapper.contents())(scope);
                        var newContents = newWrapper.contents();

                        $animate.enter(newContents, element);
                        $animate.leave(oldContents);
                    }

                    var interpolationContext = handleInterpolationContext(scope, attrs, update);
                    update(interpolationContext);
                    linking = false;

                    if (attrs.translateN) {
                        scope.$watch(attrs.translateN, function () {
                            update(interpolationContext);
                        });
                    }

                    /**
                     * @ngdoc event
                     * @name translate#gettextLanguageChanged
                     * @eventType listen on scope
                     * @description Listens for language updates and changes translation accordingly
                     */
                    scope.$on('gettextLanguageChanged', function () {
                        update(interpolationContext);
                    });

                }
            };
        }
    };
}]);

/**
 * @ngdoc factory
 * @module gettext
 * @name gettextFallbackLanguage
 * @param {String} langCode language code
 * @returns {String|Null} fallback language
 * @description Strips regional code and returns language code only
 *
 * Example
 * ```js
 * gettextFallbackLanguage('ru');     // "null"
 * gettextFallbackLanguage('en_GB');  // "en"
 * gettextFallbackLanguage();         // null
 * ```
 */
angular.module("gettext").factory("gettextFallbackLanguage", function () {
    var cache = {};
    var pattern = /([^_]+)_[^_]+$/;

    return function (langCode) {
        if (cache[langCode]) {
            return cache[langCode];
        }

        var matches = pattern.exec(langCode);
        if (matches) {
            cache[langCode] = matches[1];
            return matches[1];
        }

        return null;
    };
});
/**
 * @ngdoc filter
 * @module gettext
 * @name translate
 * @requires gettextCatalog
 * @param {String} input translation key
 * @param {String} context context to evaluate key against
 * @returns {String} translated string or annotated key
 * @see {@link doc:context Verb, Noun}
 * @description Takes key and returns string
 *
 * Sometimes it's not an option to use an attribute (e.g. when you want to annotate an attribute value).
 * There's a `translate` filter available for this purpose.
 *
 * ```html
 * <input type="text" placeholder="{{'Username'|translate}}" />
 * ```
 * This filter does not support plural strings.
 *
 * You may want to use {@link guide:custom-annotations custom annotations} to avoid using the `translate` filter all the time. * Is
 */
angular.module('gettext').filter('translate', ["gettextCatalog", function (gettextCatalog) {
    function filter(input, context) {
        return gettextCatalog.getString(input, null, context);
    }
    filter.$stateful = true;
    return filter;
}]);

// Do not edit this file, it is autogenerated using genplurals.py!
angular.module("gettext").factory("gettextPlurals", function () {
    var languageCodes = {
        "pt_BR": "pt_BR",
        "pt-BR": "pt_BR"
    };
    return function (langCode, n) {
        switch (getLanguageCode(langCode)) {
            case "ay":  // Aymará
            case "bo":  // Tibetan
            case "cgg": // Chiga
            case "dz":  // Dzongkha
            case "fa":  // Persian
            case "id":  // Indonesian
            case "ja":  // Japanese
            case "jbo": // Lojban
            case "ka":  // Georgian
            case "kk":  // Kazakh
            case "km":  // Khmer
            case "ko":  // Korean
            case "ky":  // Kyrgyz
            case "lo":  // Lao
            case "ms":  // Malay
            case "my":  // Burmese
            case "sah": // Yakut
            case "su":  // Sundanese
            case "th":  // Thai
            case "tt":  // Tatar
            case "ug":  // Uyghur
            case "vi":  // Vietnamese
            case "wo":  // Wolof
            case "zh":  // Chinese
                // 1 form
                return 0;
            case "is":  // Icelandic
                // 2 forms
                return (n%10!=1 || n%100==11) ? 1 : 0;
            case "jv":  // Javanese
                // 2 forms
                return n!=0 ? 1 : 0;
            case "mk":  // Macedonian
                // 2 forms
                return n==1 || n%10==1 ? 0 : 1;
            case "ach": // Acholi
            case "ak":  // Akan
            case "am":  // Amharic
            case "arn": // Mapudungun
            case "br":  // Breton
            case "fil": // Filipino
            case "fr":  // French
            case "gun": // Gun
            case "ln":  // Lingala
            case "mfe": // Mauritian Creole
            case "mg":  // Malagasy
            case "mi":  // Maori
            case "oc":  // Occitan
            case "pt_BR":  // Brazilian Portuguese
            case "tg":  // Tajik
            case "ti":  // Tigrinya
            case "tr":  // Turkish
            case "uz":  // Uzbek
            case "wa":  // Walloon
            case "zh":  // Chinese
                // 2 forms
                return n>1 ? 1 : 0;
            case "lv":  // Latvian
                // 3 forms
                return (n%10==1 && n%100!=11 ? 0 : n != 0 ? 1 : 2);
            case "lt":  // Lithuanian
                // 3 forms
                return (n%10==1 && n%100!=11 ? 0 : n%10>=2 && (n%100<10 || n%100>=20) ? 1 : 2);
            case "be":  // Belarusian
            case "bs":  // Bosnian
            case "hr":  // Croatian
            case "ru":  // Russian
            case "sr":  // Serbian
            case "uk":  // Ukrainian
                // 3 forms
                return (n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
            case "mnk": // Mandinka
                // 3 forms
                return (n==0 ? 0 : n==1 ? 1 : 2);
            case "ro":  // Romanian
                // 3 forms
                return (n==1 ? 0 : (n==0 || (n%100 > 0 && n%100 < 20)) ? 1 : 2);
            case "pl":  // Polish
                // 3 forms
                return (n==1 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);
            case "cs":  // Czech
            case "sk":  // Slovak
                // 3 forms
                return (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
            case "sl":  // Slovenian
                // 4 forms
                return (n%100==1 ? 1 : n%100==2 ? 2 : n%100==3 || n%100==4 ? 3 : 0);
            case "mt":  // Maltese
                // 4 forms
                return (n==1 ? 0 : n==0 || ( n%100>1 && n%100<11) ? 1 : (n%100>10 && n%100<20 ) ? 2 : 3);
            case "gd":  // Scottish Gaelic
                // 4 forms
                return (n==1 || n==11) ? 0 : (n==2 || n==12) ? 1 : (n > 2 && n < 20) ? 2 : 3;
            case "cy":  // Welsh
                // 4 forms
                return (n==1) ? 0 : (n==2) ? 1 : (n != 8 && n != 11) ? 2 : 3;
            case "kw":  // Cornish
                // 4 forms
                return (n==1) ? 0 : (n==2) ? 1 : (n == 3) ? 2 : 3;
            case "ga":  // Irish
                // 5 forms
                return n==1 ? 0 : n==2 ? 1 : n<7 ? 2 : n<11 ? 3 : 4;
            case "ar":  // Arabic
                // 6 forms
                return (n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 ? 4 : 5);
            default: // Everything else
                return n != 1 ? 1 : 0;
        }
    };

    /**
     * Method extracts iso639-2 language code from code with locale e.g. pl_PL, en_US, etc.
     * If it's provided with standalone iso639-2 language code it simply returns it.
     * @param {String} langCode
     * @returns {String} iso639-2 language Code
     */
    function getLanguageCode(langCode) {
        if (!languageCodes[langCode]) {
            languageCodes[langCode] = langCode.split(/\-|_/).shift();
        }
        return languageCodes[langCode];
    }
});

/**
 * @ngdoc factory
 * @module gettext
 * @name gettextUtil
 * @description Utility service for common operations and polyfills.
 */
angular.module('gettext').factory('gettextUtil', function gettextUtil() {
    /**
     * @ngdoc method
     * @name gettextUtil#trim
     * @public
     * @param {string} value String to be trimmed.
     * @description Trim polyfill for old browsers (instead of jQuery). Based on AngularJS-v1.2.2 (angular.js#620).
     *
     * Example
     * ```js
     * gettextUtil.assert('  no blanks  '); // "no blanks"
     * ```
     */
    var trim = (function () {
        if (!String.prototype.trim) {
            return function (value) {
                return (typeof value === 'string') ? value.replace(/^\s*/, '').replace(/\s*$/, '') : value;
            };
        }
        return function (value) {
            return (typeof value === 'string') ? value.trim() : value;
        };
    })();

    /**
     * @ngdoc method
     * @name gettextUtil#assert
     * @public
     * @param {bool} condition condition to check
     * @param {String} missing name of the directive missing attribute
     * @param {String} found name of attribute that has been used with directive
     * @description Throws error if condition is not met, which means that directive was used with certain parameter
     * that requires another one (which is missing).
     *
     * Example
     * ```js
     * gettextUtil.assert(!attrs.translatePlural || attrs.translateN, 'translate-n', 'translate-plural');
     * //You should add a translate-n attribute whenever you add a translate-plural attribute.
     * ```
     */
    function assert(condition, missing, found) {
        if (!condition) {
            throw new Error('You should add a ' + missing + ' attribute whenever you add a ' + found + ' attribute.');
        }
    }

    /**
     * @ngdoc method
     * @name gettextUtil#startsWith
     * @public
     * @param {string} target String on which checking will occur.
     * @param {string} query String expected to be at the beginning of target.
     * @returns {boolean} Returns true if object has no ownProperties. For arrays returns true if length == 0.
     * @description Checks if string starts with another string.
     *
     * Example
     * ```js
     * gettextUtil.startsWith('Home sweet home.', 'Home'); //true
     * gettextUtil.startsWith('Home sweet home.', 'sweet'); //false
     * ```
     */
    function startsWith(target, query) {
        return target.indexOf(query) === 0;
    }

    /**
     * @ngdoc method
     * @name gettextUtil#lcFirst
     * @public
     * @param {string} target String to transform.
     * @returns {string} Strings beginning with lowercase letter.
     * @description Makes first letter of the string lower case
     *
     * Example
     * ```js
     * gettextUtil.lcFirst('Home Sweet Home.'); //'home Sweet Home'
     * gettextUtil.lcFirst('ShouldBeCamelCase.'); //'shouldBeCamelCase'
     * ```
     */
    function lcFirst(target) {
        var first = target.charAt(0).toLowerCase();
        return first + target.substr(1);
    }

    return {
        trim: trim,
        assert: assert,
        startsWith: startsWith,
        lcFirst: lcFirst
    };
});


/***/ }),
/* 644 */
/***/ (function(module, exports) {

var angularEmbedly=angular.module("angular-embedly",[]);!function(e){e.provider("embedlyService",function(){function e(){return d?"https":"https"}function t(t){this.embed=function(d,o,r){var a=encodeURIComponent(d),i=e()+"://api.embed.ly/1/oembed?key="+n+"&url="+a;return"undefined"!=typeof o&&(i=i+"&maxwidth="+o),"undefined"!=typeof r&&(i=i+"&scheme="+r),t({method:"GET",url:i})},this.extract=function(d){var o=encodeURIComponent(d),r=e()+"://api.embed.ly/1/extract?key="+n+"&url="+o;return t({method:"GET",url:r})}}var n,d;this.setKey=function(e){return n=e},this.getKey=function(){return n},this.secure=function(e){return e?(d=e,void 0):d},this.$get=["$http",function(e){return new t(e)}]})}(angularEmbedly),function(e){e.controller("emEmbedCtrl",["$scope",function(e){e.embedCode=""}])}(angularEmbedly),function(e){e.directive("emEmbed",["embedlyService",function(e){return{restrict:"E",scope:{urlsearch:"@",maxwidth:"@",scheme:"@",onempty:"&"},controller:"emEmbedCtrl",link:function(t,n){function d(){void 0!=t.onempty&&"function"==typeof t.onempty&&t.onempty()}t.$parent.loading_embedly=!1,t.$watch("urlsearch",function(o){var r=t.embedCode;o&&(t.$parent.loading_embedly=!0,e.embed(o,t.maxwidth,t.scheme).then(function(e){switch(t.$parent.loading_embedly=!1,e.data.type){case"video":void 0==e.data.html?d():t.embedCode=e.data.html;break;case"rich":void 0==e.data.html?d():t.embedCode=e.data.html;break;case"photo":void 0==e.data.url?d():t.embedCode='<img src="'+e.data.url+'">';break;default:d(),t.embedCode=""}r!==t.embedCode&&n.html("<div>"+t.embedCode+"</div>")},function(){t.$parent.loading_embedly=!1;var e=t.embedCode;t.embedCode="",e!==t.embedCode&&n.html("<div>"+t.embedCode+"</div>")}))})}}}])}(angularEmbedly);

/***/ }),
/* 645 */
/***/ (function(module, exports) {

!function(){"use strict";angular.module("noEmbed",["ngResource"]),angular.module("iframely",["ngResource"]);var e=["noEmbed","iframely"];try{angular.module("angular-embedly"),e.push("angular-embedly")}catch(t){}angular.module("angular-embed.services",e),angular.module("angular-embed",["angular-embed.services"]),angular.module("angular-embed.handlers",["angular-embed"]),angular.module("angular-embed").config(["$sceDelegateProvider",function(e){e.resourceUrlWhitelist(["self","https://iframe.ly/api/iframely?**","https://noembed.com/embed?**","https://noembed.com/providers","https://api.embed.ly/1/**?**"])}])}(),function(){"use strict";angular.module("angular-embed").directive("ngEmbed",["embedService",function(e){return{restrict:"AEC",controller:function(t,r,n){e.get(n.url?n.url:n.ngEmbed).then(function(e){r.html(e.html)})}}}])}(),function(){"use strict";function e(e,t,r){return{name:"Facebook",patterns:["https?://(www\\.)facebook.com/.*"],embed:function(n,a){var i=t.defer();return e.embed(n,a).then(function(e){var t="_"+Math.random().toString(36).substr(2,9),n=e.data;"Facebook"===n.provider_name&&n.html&&void 0!==a&&(n.html=n.html.replace('class="fb-post"','class="fb-post" data-width="'+a+'"'),n.html=n.html.replace('<div id="fb-root"></div>',""),n.html=n.html.replace("</script>",'</script><div id="'+t+'">'),n.html+="</div>",n.html+=["<script>","  if(window.FB !== undefined) {",'    window.FB.XFBML.parse(document.getElementById("'+t+'"));',"  }","</script>"].join(""),void 0!==r.getConfig("facebookAppId")&&(n.html=n.html.replace("js#xfbml=1","js#xfbml=1&status=0&appId="+r.getConfig("facebookAppId")))),i.resolve(n)},function(e){i.reject(e.error_message||e.data.error_message)}),i.promise}}}angular.module("angular-embed.handlers").service("ngEmbedFacebookHandler",["embedlyService","$q","embedService",e])}(),function(){"use strict";function e(e,t){return{name:"Instagram",patterns:["(?:(?:http|https)://)?(?:www.)?(?:instagr(?:.am|am.com))/p/.+"],embed:function(r,n){var a=t.defer();return e.embed(r,n).then(function(e){delete e.data.description,a.resolve(e.data)},function(e){a.reject(e.error_message||e.data.error_message)}),a.promise}}}angular.module("angular-embed.handlers").service("ngEmbedInstagramHandler",["embedlyService","$q",e])}(),function(){"use strict";function e(e,t){return{patterns:["(?:([^:/?#]+):)?(?://([^/?#]*))?([^?#]*\\.(?:jpg|gif|png))(?:\\?([^#]*))?(?:#(.*))?"],embed:function(r,n){var a=t.defer();return e.embed(r,n).then(function(e){var t=e.data;"photo"!==t.type||t.thumbnail_url||(t.thumbnail_url=t.url,t.thumbnail_width=t.width,t.thumbnail_height=t.height),a.resolve(t)},function(e){a.reject(e.error_message||e.data.error_message)}),a.promise}}}angular.module("angular-embed.handlers").service("ngEmbedPictureHandler",["embedlyService","$q",e])}(),function(){"use strict";function e(e,t){return{name:"Twitter",patterns:["https?://(?:www|mobile\\.)?twitter\\.com/(?:#!/)?[^/]+/status(?:es)?/(\\d+)/?$","https?://t\\.co/[a-zA-Z0-9]+"],embed:function(r){var n=t.defer();return e.embed(r).then(function(e){var t="_"+Math.random().toString(36).substr(2,9),a=e.data;a.element_id=t,"Twitter"===a.provider_name&&(a.html=['<div id="'+t+'">','     <blockquote class="twitter-tweet">',"         <p>",a.description,"         </p>&mdash; ","         "+a.title+" (@"+a.author_name+")",'         <a href="'+r+'">'+r+"</a>","     </blockquote>","</div>","<script>","    window.twttr = (function(d, s, id) {","        var js, fjs = d.getElementsByTagName(s)[0],t = window.twttr || {};","        if (d.getElementById(id)) return t; js = d.createElement(s);js.id = id;",'        js.src = "https://platform.twitter.com/widgets.js";',"        fjs.parentNode.insertBefore(js, fjs); t._e = [];",'        t.ready = function(f) {t._e.push(f);}; return t;}(document, "script", "twitter-wjs"));',"    window.twttr.ready(function(){",'        window.twttr.widgets.load(document.getElementById("'+t+'"));',"    });","</script>"].join("\n")),n.resolve(a)},function(e){n.reject(e.error_message||e.data.error_message)}),n.promise}}}angular.module("angular-embed.handlers").service("ngEmbedTwitterHandler",["embedlyService","$q",e])}(),function(){"use strict";function e(e,t){return{name:"Youtube",patterns:["https?://(?:[^\\.]+\\.)?youtube\\.com/watch/?\\?(?:.+&)?v=([^&]+)","https?://youtu\\.be/([a-zA-Z0-9_-]+)"],embed:function(r,n){var a=t.defer();return e.embed(r,n).then(function(e){a.resolve(e.data)},function(e){a.reject(e.error_message||e.data.error_message)}),a.promise}}}angular.module("angular-embed.handlers").service("ngEmbedYoutubeHandler",["embedlyService","$q",e])}(),function(){"use strict";function e(){function e(e,r,n,a){function i(e,t){return e.some(function(e){return e.patterns.some(function(e){var r=new RegExp(e);return r.test(t)})})}var o=n.when();return t.getConfig("useOnlyFallback",!1)||(o=e.providers()),{registerHandler:t.registerHandler,setConfig:t.setConfig,getConfig:t.getConfig,get:function(u,s){function d(){var e=a.get("embedlyService");e.embed(u,s).then(function(e){l.resolve(e.data)},function(e){var t=e.error_message||e.data?e.data.error_message:void 0;l.reject(t)})}function m(){e.embed(u).then(function(e){void 0!==e.error?l.reject(e.error):l.resolve(e)})}function c(){r.embed(u).then(function(e){l.resolve(e)},function(e){var t=e.error_message;l.reject(t)})}var l=n.defer();return t.specialHandlers.some(function(e){return e.patterns.some(function(t){var r=new RegExp(t);return r.test(u)?(n.when(e.embed(u,s)).then(function(e){l.resolve(e)}),!0):!1})})||o.then(function(e){if(!t.getConfig("useOnlyFallback",!1)&&i(e,u))m();else{var r={embedly:d,iframely:c};r[t.getConfig("fallbackService","embedly")]()}},function(){d()}),l.promise}}}var t=this;t.$get=["noEmbedService","iframelyService","$q","$injector",e],t.specialHandlers=[],t.registerHandler=function(e){t.specialHandlers.push(e)},t.config={},t.setConfig=function(e,r){t.config[e]=r},t.getConfig=function(e,r){var n=t.config[e];return angular.isDefined(n)||(n=r),n}}angular.module("angular-embed.services").provider("embedService",e)}(),function(){"use strict";function e(){function e(e){return{embed:function(r){var n=t.getKey(),a=e("https://iframe.ly/api/iframely?api_key="+n+"&url="+r);return a.get().$promise.then(function(e){return e.title=e.meta.title,e.provider_name=e.meta.site,e})}}}var t=this;angular.extend(t,{$get:["$resource",e],setKey:function(e){t.key=e},getKey:function(){return t.key}})}angular.module("iframely").provider("iframelyService",e)}(),function(){"use strict";function e(e){return{embed:function(t){var r=e("https://noembed.com/embed?url="+t,{},{get:{method:"JSONP"}});return r.get().$promise},providers:function(){var t=e("https://noembed.com/providers",{},{query:{method:"JSONP",isArray:!0}});return t.query().$promise}}}angular.module("noEmbed").service("noEmbedService",["$resource",e])}();

/***/ }),
/* 646 */
/***/ (function(module, exports) {

/**
 * @see http://docs.angularjs.org/guide/concepts
 * @see http://docs.angularjs.org/api/ng.directive:ngModel.NgModelController
 * @see https://github.com/angular/angular.js/issues/528#issuecomment-7573166
 */

angular.module('contenteditable', [])
  .directive('contenteditable', ['$timeout', function($timeout) { return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, element, attrs, ngModel) {
      // don't do anything unless this is actually bound to a model
      if (!ngModel) {
        return
      }

      // options
      var opts = {}
      angular.forEach([
        'stripBr',
        'noLineBreaks',
        'selectNonEditable',
        'moveCaretToEndOnChange',
        'stripTags'
      ], function(opt) {
        var o = attrs[opt]
        opts[opt] = o && o !== 'false'
      })

      // view -> model
      element.bind('input', function(e) {
        scope.$apply(function() {
          var html, html2, rerender
          html = element.html()
          rerender = false
          if (opts.stripBr) {
            html = html.replace(/<br>$/, '')
          }
          if (opts.noLineBreaks) {
            html2 = html.replace(/<div>/g, '').replace(/<br>/g, '').replace(/<\/div>/g, '')
            if (html2 !== html) {
              rerender = true
              html = html2
            }
          }
          if (opts.stripTags) {
            rerender = true
            html = html.replace(/<\S[^><]*>/g, '')
          }
          ngModel.$setViewValue(html)
          if (rerender) {
            ngModel.$render()
          }
          if (html === '') {
            // the cursor disappears if the contents is empty
            // so we need to refocus
            $timeout(function(){
              element[0].blur()
              element[0].focus()
            })
          }
        })
      })

      // model -> view
      var oldRender = ngModel.$render
      ngModel.$render = function() {
        var el, el2, range, sel
        if (!!oldRender) {
          oldRender()
        }
        var html = ngModel.$viewValue || ''
        if (opts.stripTags) {
          html = html.replace(/<\S[^><]*>/g, '')
        }

        element.html(html)
        if (opts.moveCaretToEndOnChange) {
          el = element[0]
          range = document.createRange()
          sel = window.getSelection()
          if (el.childNodes.length > 0) {
            el2 = el.childNodes[el.childNodes.length - 1]
            range.setStartAfter(el2)
          } else {
            range.setStartAfter(el)
          }
          range.collapse(true)
          sel.removeAllRanges()
          sel.addRange(range)
        }
      }
      if (opts.selectNonEditable) {
        element.bind('click', function(e) {
          var range, sel, target
          target = e.toElement
          if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
            range = document.createRange()
            sel = window.getSelection()
            range.setStartBefore(target)
            range.setEndAfter(target)
            sel.removeAllRanges()
            sel.addRange(range)
          }
        })
      }
    }
  }}]);


/***/ }),
/* 647 */
/***/ (function(module, exports) {

//
// Copyright Kamil Pękala http://github.com/kamilkp
// Angular Virtual Scroll Repeat v1.1.7 2016/03/08
//

(function(window, angular) {
    'use strict';
    /* jshint eqnull:true */
    /* jshint -W038 */

    // DESCRIPTION:
    // vsRepeat directive stands for Virtual Scroll Repeat. It turns a standard ngRepeated set of elements in a scrollable container
    // into a component, where the user thinks he has all the elements rendered and all he needs to do is scroll (without any kind of
    // pagination - which most users loath) and at the same time the browser isn't overloaded by that many elements/angular bindings etc.
    // The directive renders only so many elements that can fit into current container's clientHeight/clientWidth.

    // LIMITATIONS:
    // - current version only supports an Array as a right-hand-side object for ngRepeat
    // - all rendered elements must have the same height/width or the sizes of the elements must be known up front

    // USAGE:
    // In order to use the vsRepeat directive you need to place a vs-repeat attribute on a direct parent of an element with ng-repeat
    // example:
    // <div vs-repeat>
    //      <div ng-repeat="item in someArray">
    //          <!-- content -->
    //      </div>
    // </div>
    //
    // or:
    // <div vs-repeat>
    //      <div ng-repeat-start="item in someArray">
    //          <!-- content -->
    //      </div>
    //      <div>
    //         <!-- something in the middle -->
    //      </div>
    //      <div ng-repeat-end>
    //          <!-- content -->
    //      </div>
    // </div>
    //
    // You can also measure the single element's height/width (including all paddings and margins), and then speficy it as a value
    // of the attribute 'vs-repeat'. This can be used if one wants to override the automatically computed element size.
    // example:
    // <div vs-repeat="50"> <!-- the specified element height is 50px -->
    //      <div ng-repeat="item in someArray">
    //          <!-- content -->
    //      </div>
    // </div>
    //
    // IMPORTANT!
    //
    // - the vsRepeat directive must be applied to a direct parent of an element with ngRepeat
    // - the value of vsRepeat attribute is the single element's height/width measured in pixels. If none provided, the directive
    //      will compute it automatically

    // OPTIONAL PARAMETERS (attributes):
    // vs-repeat-container="selector" - selector for element containing ng-repeat. (defaults to the current element)
    // vs-scroll-parent="selector" - selector to the scrollable container. The directive will look for a closest parent matching
    //                              the given selector (defaults to the current element)
    // vs-horizontal - stack repeated elements horizontally instead of vertically
    // vs-offset-before="value" - top/left offset in pixels (defaults to 0)
    // vs-offset-after="value" - bottom/right offset in pixels (defaults to 0)
    // vs-excess="value" - an integer number representing the number of elements to be rendered outside of the current container's viewport
    //                      (defaults to 2)
    // vs-size - a property name of the items in collection that is a number denoting the element size (in pixels)
    // vs-autoresize - use this attribute without vs-size and without specifying element's size. The automatically computed element style will
    //              readjust upon window resize if the size is dependable on the viewport size
    // vs-scrolled-to-end="callback" - callback will be called when the last item of the list is rendered
    // vs-scrolled-to-end-offset="integer" - set this number to trigger the scrolledToEnd callback n items before the last gets rendered

    // EVENTS:
    // - 'vsRepeatTrigger' - an event the directive listens for to manually trigger reinitialization
    // - 'vsRepeatReinitialized' - an event the directive emits upon reinitialization done

    var dde = document.documentElement,
        matchingFunction = dde.matches ? 'matches' :
                            dde.matchesSelector ? 'matchesSelector' :
                            dde.webkitMatches ? 'webkitMatches' :
                            dde.webkitMatchesSelector ? 'webkitMatchesSelector' :
                            dde.msMatches ? 'msMatches' :
                            dde.msMatchesSelector ? 'msMatchesSelector' :
                            dde.mozMatches ? 'mozMatches' :
                            dde.mozMatchesSelector ? 'mozMatchesSelector' : null;

    var closestElement = angular.element.prototype.closest || function (selector) {
        var el = this[0].parentNode;
        while (el !== document.documentElement && el != null && !el[matchingFunction](selector)) {
            el = el.parentNode;
        }

        if (el && el[matchingFunction](selector)) {
            return angular.element(el);
        }
        else {
            return angular.element();
        }
    };

    function getWindowScroll() {
        if ('pageYOffset' in window) {
            return {
                scrollTop: pageYOffset,
                scrollLeft: pageXOffset
            };
        }
        else {
            var sx, sy, d = document, r = d.documentElement, b = d.body;
            sx = r.scrollLeft || b.scrollLeft || 0;
            sy = r.scrollTop || b.scrollTop || 0;
            return {
                scrollTop: sy,
                scrollLeft: sx
            };
        }
    }

    function getClientSize(element, sizeProp) {
        if (element === window) {
            return sizeProp === 'clientWidth' ? window.innerWidth : window.innerHeight;
        }
        else {
            return element[sizeProp];
        }
    }

    function getScrollPos(element, scrollProp) {
        return element === window ? getWindowScroll()[scrollProp] : element[scrollProp];
    }

    function getScrollOffset(vsElement, scrollElement, isHorizontal) {
        var vsPos = vsElement.getBoundingClientRect()[isHorizontal ? 'left' : 'top'];
        var scrollPos = scrollElement === window ? 0 : scrollElement.getBoundingClientRect()[isHorizontal ? 'left' : 'top'];
        var correction = vsPos - scrollPos +
            (scrollElement === window ? getWindowScroll() : scrollElement)[isHorizontal ? 'scrollLeft' : 'scrollTop'];

        return correction;
    }

    var vsRepeatModule = angular.module('vs-repeat', []).directive('vsRepeat', ['$compile', '$parse', function($compile, $parse) {
        return {
            restrict: 'A',
            scope: true,
            compile: function($element, $attrs) {
                var repeatContainer = angular.isDefined($attrs.vsRepeatContainer) ? angular.element($element[0].querySelector($attrs.vsRepeatContainer)) : $element,
                    ngRepeatChild = repeatContainer.children().eq(0),
                    ngRepeatExpression,
                    childCloneHtml = ngRepeatChild[0].outerHTML,
                    expressionMatches,
                    lhs,
                    rhs,
                    rhsSuffix,
                    originalNgRepeatAttr,
                    collectionName = '$vs_collection',
                    isNgRepeatStart = false,
                    attributesDictionary = {
                        'vsRepeat': 'elementSize',
                        'vsOffsetBefore': 'offsetBefore',
                        'vsOffsetAfter': 'offsetAfter',
                        'vsScrolledToEndOffset': 'scrolledToEndOffset',
                        'vsExcess': 'excess'
                    };

                if (ngRepeatChild.attr('ng-repeat')) {
                    originalNgRepeatAttr = 'ng-repeat';
                    ngRepeatExpression = ngRepeatChild.attr('ng-repeat');
                }
                else if (ngRepeatChild.attr('data-ng-repeat')) {
                    originalNgRepeatAttr = 'data-ng-repeat';
                    ngRepeatExpression = ngRepeatChild.attr('data-ng-repeat');
                }
                else if (ngRepeatChild.attr('ng-repeat-start')) {
                    isNgRepeatStart = true;
                    originalNgRepeatAttr = 'ng-repeat-start';
                    ngRepeatExpression = ngRepeatChild.attr('ng-repeat-start');
                }
                else if (ngRepeatChild.attr('data-ng-repeat-start')) {
                    isNgRepeatStart = true;
                    originalNgRepeatAttr = 'data-ng-repeat-start';
                    ngRepeatExpression = ngRepeatChild.attr('data-ng-repeat-start');
                }
                else {
                    throw new Error('angular-vs-repeat: no ng-repeat directive on a child element');
                }

                expressionMatches = /^\s*(\S+)\s+in\s+([\S\s]+?)(track\s+by\s+\S+)?$/.exec(ngRepeatExpression);
                lhs = expressionMatches[1];
                rhs = expressionMatches[2];
                rhsSuffix = expressionMatches[3];

                if (isNgRepeatStart) {
                    var index = 0;
                    var repeaterElement = repeatContainer.children().eq(0);
                    while(repeaterElement.attr('ng-repeat-end') == null && repeaterElement.attr('data-ng-repeat-end') == null) {
                        index++;
                        repeaterElement = repeatContainer.children().eq(index);
                        childCloneHtml += repeaterElement[0].outerHTML;
                    }
                }

                repeatContainer.empty();
                return {
                    pre: function($scope, $element, $attrs) {
                        var repeatContainer = angular.isDefined($attrs.vsRepeatContainer) ? angular.element($element[0].querySelector($attrs.vsRepeatContainer)) : $element,
                            childClone = angular.element(childCloneHtml),
                            childTagName = childClone[0].tagName.toLowerCase(),
                            originalCollection = [],
                            originalLength,
                            $$horizontal = typeof $attrs.vsHorizontal !== 'undefined',
                            $beforeContent = angular.element('<' + childTagName + ' class="vs-repeat-before-content"></' + childTagName + '>'),
                            $afterContent = angular.element('<' + childTagName + ' class="vs-repeat-after-content"></' + childTagName + '>'),
                            autoSize = !$attrs.vsRepeat,
                            sizesPropertyExists = !!$attrs.vsSize || !!$attrs.vsSizeProperty,
                            $scrollParent = $attrs.vsScrollParent ?
                                $attrs.vsScrollParent === 'window' ? angular.element(window) :
                                closestElement.call(repeatContainer, $attrs.vsScrollParent) : repeatContainer,
                            $$options = 'vsOptions' in $attrs ? $scope.$eval($attrs.vsOptions) : {},
                            clientSize = $$horizontal ? 'clientWidth' : 'clientHeight',
                            offsetSize = $$horizontal ? 'offsetWidth' : 'offsetHeight',
                            scrollPos = $$horizontal ? 'scrollLeft' : 'scrollTop';

                        $scope.totalSize = 0;
                        if (!('vsSize' in $attrs) && 'vsSizeProperty' in $attrs) {
                            console.warn('vs-size-property attribute is deprecated. Please use vs-size attribute which also accepts angular expressions.');
                        }

                        if ($scrollParent.length === 0) {
                            throw 'Specified scroll parent selector did not match any element';
                        }
                        $scope.$scrollParent = $scrollParent;

                        if (sizesPropertyExists) {
                            $scope.sizesCumulative = [];
                        }

                        //initial defaults
                        $scope.elementSize = (+$attrs.vsRepeat) || getClientSize($scrollParent[0], clientSize) || 50;
                        $scope.offsetBefore = 0;
                        $scope.offsetAfter = 0;
                        $scope.excess = 2;

                        if ($$horizontal) {
                            $beforeContent.css('height', '100%');
                            $afterContent.css('height', '100%');
                        }
                        else {
                            $beforeContent.css('width', '100%');
                            $afterContent.css('width', '100%');
                        }

                        Object.keys(attributesDictionary).forEach(function(key) {
                            if ($attrs[key]) {
                                $attrs.$observe(key, function(value) {
                                    // '+' serves for getting a number from the string as the attributes are always strings
                                    $scope[attributesDictionary[key]] = +value;
                                    reinitialize();
                                });
                            }
                        });


                        $scope.$watchCollection(rhs, function(coll) {
                            originalCollection = coll || [];
                            refresh();
                        });

                        function refresh() {
                            if (!originalCollection || originalCollection.length < 1) {
                                $scope[collectionName] = [];
                                originalLength = 0;
                                $scope.sizesCumulative = [0];
                            }
                            else {
                                originalLength = originalCollection.length;
                                if (sizesPropertyExists) {
                                    $scope.sizes = originalCollection.map(function(item) {
                                        var s = $scope.$new(false);
                                        angular.extend(s, item);
                                        s[lhs] = item;
                                        var size = ($attrs.vsSize || $attrs.vsSizeProperty) ?
                                                        s.$eval($attrs.vsSize || $attrs.vsSizeProperty) :
                                                        $scope.elementSize;
                                        s.$destroy();
                                        return size;
                                    });
                                    var sum = 0;
                                    $scope.sizesCumulative = $scope.sizes.map(function(size) {
                                        var res = sum;
                                        sum += size;
                                        return res;
                                    });
                                    $scope.sizesCumulative.push(sum);
                                }
                                else {
                                    setAutoSize();
                                }
                            }

                            reinitialize();
                        }

                        function setAutoSize() {
                            if (autoSize) {
                                $scope.$$postDigest(function() {
                                    if (repeatContainer[0].offsetHeight || repeatContainer[0].offsetWidth) { // element is visible
                                        var children = repeatContainer.children(),
                                            i = 0,
                                            gotSomething = false,
                                            insideStartEndSequence = false;

                                        while (i < children.length) {
                                            if (children[i].attributes[originalNgRepeatAttr] != null || insideStartEndSequence) {
                                                if (!gotSomething) {
                                                    $scope.elementSize = 0;
                                                }

                                                gotSomething = true;
                                                if (children[i][offsetSize]) {
                                                    $scope.elementSize += children[i][offsetSize];
                                                }

                                                if (isNgRepeatStart) {
                                                    if (children[i].attributes['ng-repeat-end'] != null || children[i].attributes['data-ng-repeat-end'] != null) {
                                                        break;
                                                    }
                                                    else {
                                                        insideStartEndSequence = true;
                                                    }
                                                }
                                                else {
                                                    break;
                                                }
                                            }
                                            i++;
                                        }

                                        if (gotSomething) {
                                            reinitialize();
                                            autoSize = false;
                                            if ($scope.$root && !$scope.$root.$$phase) {
                                                $scope.$apply();
                                            }
                                        }
                                    }
                                    else {
                                        var dereg = $scope.$watch(function() {
                                            if (repeatContainer[0].offsetHeight || repeatContainer[0].offsetWidth) {
                                                dereg();
                                                setAutoSize();
                                            }
                                        });
                                    }
                                });
                            }
                        }

                        function getLayoutProp() {
                            var layoutPropPrefix = childTagName === 'tr' ? '' : 'min-';
                            var layoutProp = $$horizontal ? layoutPropPrefix + 'width' : layoutPropPrefix + 'height';
                            return layoutProp;
                        }

                        childClone.eq(0).attr(originalNgRepeatAttr, lhs + ' in ' + collectionName + (rhsSuffix ? ' ' + rhsSuffix : ''));
                        childClone.addClass('vs-repeat-repeated-element');

                        repeatContainer.append($beforeContent);
                        repeatContainer.append(childClone);
                        $compile(childClone)($scope);
                        repeatContainer.append($afterContent);

                        $scope.startIndex = 0;
                        $scope.endIndex = 0;

                        function scrollHandler() {
                            if (updateInnerCollection()) {
                                $scope.$digest();
                            }
                        }

                        $scrollParent.on('scroll', scrollHandler);

                        function onWindowResize() {
                            if (typeof $attrs.vsAutoresize !== 'undefined') {
                                autoSize = true;
                                setAutoSize();
                                if ($scope.$root && !$scope.$root.$$phase) {
                                    $scope.$apply();
                                }
                            }
                            if (updateInnerCollection()) {
                                $scope.$apply();
                            }
                        }

                        angular.element(window).on('resize', onWindowResize);
                        $scope.$on('$destroy', function() {
                            angular.element(window).off('resize', onWindowResize);
                            $scrollParent.off('scroll', scrollHandler);
                        });

                        $scope.$on('vsRepeatTrigger', refresh);

                        $scope.$on('vsRepeatResize', function() {
                            autoSize = true;
                            setAutoSize();
                        });

                        var _prevStartIndex,
                            _prevEndIndex,
                            _minStartIndex,
                            _maxEndIndex;

                        $scope.$on('vsRenderAll', function() {//e , quantum) {
                            if($$options.latch) {
                                setTimeout(function() {
                                    // var __endIndex = Math.min($scope.endIndex + (quantum || 1), originalLength);
                                    var __endIndex = originalLength;
                                    _maxEndIndex = Math.max(__endIndex, _maxEndIndex);
                                    $scope.endIndex = $$options.latch ? _maxEndIndex : __endIndex;
                                    $scope[collectionName] = originalCollection.slice($scope.startIndex, $scope.endIndex);
                                    _prevEndIndex = $scope.endIndex;

                                    $scope.$$postDigest(function() {
                                        $beforeContent.css(getLayoutProp(), 0);
                                        $afterContent.css(getLayoutProp(), 0);
                                    });

                                    $scope.$apply(function() {
                                        $scope.$emit('vsRenderAllDone');
                                    });
                                });
                            }
                        });

                        function reinitialize() {
                            _prevStartIndex = void 0;
                            _prevEndIndex = void 0;
                            _minStartIndex = originalLength;
                            _maxEndIndex = 0;
                            updateTotalSize(sizesPropertyExists ?
                                                $scope.sizesCumulative[originalLength] :
                                                $scope.elementSize * originalLength
                                            );
                            updateInnerCollection();

                            $scope.$emit('vsRepeatReinitialized', $scope.startIndex, $scope.endIndex);
                        }

                        function updateTotalSize(size) {
                            $scope.totalSize = $scope.offsetBefore + size + $scope.offsetAfter;
                        }

                        var _prevClientSize;
                        function reinitOnClientHeightChange() {
                            var ch = getClientSize($scrollParent[0], clientSize);
                            if (ch !== _prevClientSize) {
                                reinitialize();
                                if ($scope.$root && !$scope.$root.$$phase) {
                                    $scope.$apply();
                                }
                            }
                            _prevClientSize = ch;
                        }

                        $scope.$watch(function() {
                            if (typeof window.requestAnimationFrame === 'function') {
                                window.requestAnimationFrame(reinitOnClientHeightChange);
                            }
                            else {
                                reinitOnClientHeightChange();
                            }
                        });

                        function updateInnerCollection() {
                            var $scrollPosition = getScrollPos($scrollParent[0], scrollPos);
                            var $clientSize = getClientSize($scrollParent[0], clientSize);

                            var scrollOffset = repeatContainer[0] === $scrollParent[0] ? 0 : getScrollOffset(
                                                    repeatContainer[0],
                                                    $scrollParent[0],
                                                    $$horizontal
                                                );

                            var __startIndex = $scope.startIndex;
                            var __endIndex = $scope.endIndex;

                            if (sizesPropertyExists) {
                                __startIndex = 0;
                                while ($scope.sizesCumulative[__startIndex] < $scrollPosition - $scope.offsetBefore - scrollOffset) {
                                    __startIndex++;
                                }
                                if (__startIndex > 0) { __startIndex--; }

                                // Adjust the start index according to the excess
                                __startIndex = Math.max(
                                    Math.floor(__startIndex - $scope.excess / 2),
                                    0
                                );

                                __endIndex = __startIndex;
                                while ($scope.sizesCumulative[__endIndex] < $scrollPosition - $scope.offsetBefore - scrollOffset + $clientSize) {
                                    __endIndex++;
                                }

                                // Adjust the end index according to the excess
                                __endIndex = Math.min(
                                    Math.ceil(__endIndex + $scope.excess / 2),
                                    originalLength
                                );
                            }
                            else {
                                __startIndex = Math.max(
                                    Math.floor(
                                        ($scrollPosition - $scope.offsetBefore - scrollOffset) / $scope.elementSize
                                    ) - $scope.excess / 2,
                                    0
                                );

                                __endIndex = Math.min(
                                    __startIndex + Math.ceil(
                                        $clientSize / $scope.elementSize
                                    ) + $scope.excess,
                                    originalLength
                                );
                            }

                            _minStartIndex = Math.min(__startIndex, _minStartIndex);
                            _maxEndIndex = Math.max(__endIndex, _maxEndIndex);

                            $scope.startIndex = $$options.latch ? _minStartIndex : __startIndex;
                            $scope.endIndex = $$options.latch ? _maxEndIndex : __endIndex;

                            var digestRequired = false;
                            if (_prevStartIndex == null) {
                                digestRequired = true;
                            }
                            else if (_prevEndIndex == null) {
                                digestRequired = true;
                            }

                            if (!digestRequired) {
                                if ($$options.hunked) {
                                    if (Math.abs($scope.startIndex - _prevStartIndex) >= $scope.excess / 2 ||
                                        ($scope.startIndex === 0 && _prevStartIndex !== 0)) {
                                        digestRequired = true;
                                    }
                                    else if (Math.abs($scope.endIndex - _prevEndIndex) >= $scope.excess / 2 ||
                                        ($scope.endIndex === originalLength && _prevEndIndex !== originalLength)) {
                                        digestRequired = true;
                                    }
                                }
                                else {
                                    digestRequired = $scope.startIndex !== _prevStartIndex ||
                                                        $scope.endIndex !== _prevEndIndex;
                                }
                            }

                            if (digestRequired) {
                                $scope[collectionName] = originalCollection.slice($scope.startIndex, $scope.endIndex);

                                // Emit the event
                                $scope.$emit('vsRepeatInnerCollectionUpdated', $scope.startIndex, $scope.endIndex, _prevStartIndex, _prevEndIndex);

                                if ($attrs.vsScrolledToEnd) {
                                    var triggerIndex = originalCollection.length - ($scope.scrolledToEndOffset || 0);
                                    if (($scope.endIndex >= triggerIndex && _prevEndIndex < triggerIndex) || (originalCollection.length && $scope.endIndex === originalCollection.length)) {
                                        $scope.$eval($attrs.vsScrolledToEnd);
                                    }
                                }

                                _prevStartIndex = $scope.startIndex;
                                _prevEndIndex = $scope.endIndex;

                                var offsetCalculationString = sizesPropertyExists ?
                                    '(sizesCumulative[$index + startIndex] + offsetBefore)' :
                                    '(($index + startIndex) * elementSize + offsetBefore)';

                                var parsed = $parse(offsetCalculationString);
                                var o1 = parsed($scope, {$index: 0});
                                var o2 = parsed($scope, {$index: $scope[collectionName].length});
                                var total = $scope.totalSize;

                                $beforeContent.css(getLayoutProp(), o1 + 'px');
                                $afterContent.css(getLayoutProp(), (total - o2) + 'px');
                            }

                            return digestRequired;
                        }
                    }
                };
            }
        };
    }]);

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = vsRepeatModule.name;
    }
})(window, window.angular);


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.2.0 / (c) 2013, 2014, 2015, 2016, 2017 Uri Shaked / MIT Licence */

'format amd';
/* global define */

(function () {
	'use strict';

	function isUndefinedOrNull(val) {
		return angular.isUndefined(val) || val === null;
	}

	function requireMoment() {
		try {
			return __webpack_require__(5); // Using nw.js or browserify?
		} catch (e) {
			throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
		}
	}

	function angularMoment(angular, moment) {

		if(typeof moment === 'undefined') {
			if(true) {
				moment = requireMoment();
			}else{
				throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}

		/**
		 * @ngdoc overview
		 * @name angularMoment
		 *
		 * @description
		 * angularMoment module provides moment.js functionality for angular.js apps.
		 */
		angular.module('angularMoment', [])

		/**
		 * @ngdoc object
		 * @name angularMoment.config:angularMomentConfig
		 *
		 * @description
		 * Common configuration of the angularMoment module
		 */
			.constant('angularMomentConfig', {
				/**
				 * @ngdoc property
				 * @name angularMoment.config.angularMomentConfig#preprocess
				 * @propertyOf angularMoment.config:angularMomentConfig
				 * @returns {function} A preprocessor function that will be applied on all incoming dates
				 *
				 * @description
				 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
				 * `amCalendar`, etc.). The function must return a `moment` object.
				 *
				 * @example
				 *   // Causes angular-moment to always treat the input values as unix timestamps
				 *   angularMomentConfig.preprocess = function(value) {
				 * 	   return moment.unix(value);
				 *   }
				 */
				preprocess: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.angularMomentConfig#timezone
				 * @propertyOf angularMoment.config:angularMomentConfig
				 * @returns {string} The default timezone
				 *
				 * @description
				 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
				 * any timezone shift).
				 *
				 * NOTE: This option requires moment-timezone >= 0.3.0.
				 */
				timezone: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.angularMomentConfig#format
				 * @propertyOf angularMoment.config:angularMomentConfig
				 * @returns {string} The pre-conversion format of the date
				 *
				 * @description
				 * Specify the format of the input date. Essentially it's a
				 * default and saves you from specifying a format in every
				 * element. Overridden by element attr. Null by default.
				 */
				format: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.angularMomentConfig#statefulFilters
				 * @propertyOf angularMoment.config:angularMomentConfig
				 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
				 *
				 * @description
				 * Specifies whether the filters included with angular-moment are stateful.
				 * Stateful filters will automatically re-evaluate whenever you change the timezone
				 * or locale settings, but may negatively impact performance. true by default.
				 */
				statefulFilters: true
			})

		/**
		 * @ngdoc object
		 * @name angularMoment.object:moment
		 *
		 * @description
		 * moment global (as provided by the moment.js library)
		 */
			.constant('moment', moment)

		/**
		 * @ngdoc object
		 * @name angularMoment.config:amTimeAgoConfig
		 * @module angularMoment
		 *
		 * @description
		 * configuration specific to the amTimeAgo directive
		 */
			.constant('amTimeAgoConfig', {
				/**
				 * @ngdoc property
				 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
				 * @propertyOf angularMoment.config:amTimeAgoConfig
				 * @returns {boolean} Whether to include a suffix in am-time-ago directive
				 *
				 * @description
				 * Defaults to false.
				 */
				withoutSuffix: false,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.amTimeAgoConfig#serverTime
				 * @propertyOf angularMoment.config:amTimeAgoConfig
				 * @returns {number} Server time in milliseconds since the epoch
				 *
				 * @description
				 * If set, time ago will be calculated relative to the given value.
				 * If null, local time will be used. Defaults to null.
				 */
				serverTime: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.amTimeAgoConfig#titleFormat
				 * @propertyOf angularMoment.config:amTimeAgoConfig
				 * @returns {string} The format of the date to be displayed in the title of the element. If null,
				 *        the directive set the title of the element.
				 *
				 * @description
				 * The format of the date used for the title of the element. null by default.
				 */
				titleFormat: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
				 * @propertyOf angularMoment.config:amTimeAgoConfig
				 * @returns {number} The minimum number of days for showing a full date instead of relative time
				 *
				 * @description
				 * The threshold for displaying a full date. The default is null, which means the date will always
				 * be relative, and full date will never be displayed.
				 */
				fullDateThreshold: null,

				/**
				 * @ngdoc property
				 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
				 * @propertyOf angularMoment.config:amTimeAgoConfig
				 * @returns {string} The format to use when displaying a full date.
				 *
				 * @description
				 * Specify the format of the date when displayed as full date. null by default.
				 */
				fullDateFormat: null,

				fullDateThresholdUnit: 'day'
			})

		/**
		 * @ngdoc directive
		 * @name angularMoment.directive:amTimeAgo
		 * @module angularMoment
		 *
		 * @restrict A
		 */
			.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {

				return function (scope, element, attr) {
					var activeTimeout = null;
					var currentValue;
					var withoutSuffix = amTimeAgoConfig.withoutSuffix;
					var titleFormat = amTimeAgoConfig.titleFormat;
					var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
					var fullDateFormat = amTimeAgoConfig.fullDateFormat;
					var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;

					var localDate = new Date().getTime();
					var modelName = attr.amTimeAgo;
					var currentFrom;
					var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
					var setTitleTime = !element.attr('title');

					function getNow() {
						var now;
						if (currentFrom) {
							now = currentFrom;
						} else if (amTimeAgoConfig.serverTime) {
							var localNow = new Date().getTime();
							var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
							now = moment(nowMillis);
						}
						else {
							now = moment();
						}
						return now;
					}

					function cancelTimer() {
						if (activeTimeout) {
							$window.clearTimeout(activeTimeout);
							activeTimeout = null;
						}
					}

					function updateTime(momentInstance) {
						var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
						var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;

						if (showFullDate) {
							element.text(momentInstance.format(fullDateFormat));
						} else {
							element.text(momentInstance.from(getNow(), withoutSuffix));
						}

						if (titleFormat && setTitleTime) {
							element.attr('title', momentInstance.format(titleFormat));
						}

						if (!showFullDate) {
							var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
							var secondsUntilUpdate = 3600;
							if (howOld < 1) {
								secondsUntilUpdate = 1;
							} else if (howOld < 60) {
								secondsUntilUpdate = 30;
							} else if (howOld < 180) {
								secondsUntilUpdate = 300;
							}

							activeTimeout = $window.setTimeout(function () {
								updateTime(momentInstance);
							}, secondsUntilUpdate * 1000);
						}
					}

					function updateDateTimeAttr(value) {
						if (isTimeElement) {
							element.attr('datetime', value);
						}
					}

					function updateMoment() {
						cancelTimer();
						if (currentValue) {
							var momentValue = amMoment.preprocessDate(currentValue);
							updateTime(momentValue);
							updateDateTimeAttr(momentValue.toISOString());
						}
					}

					scope.$watch(modelName, function (value) {
						if (isUndefinedOrNull(value) || (value === '')) {
							cancelTimer();
							if (currentValue) {
								element.text('');
								updateDateTimeAttr('');
								currentValue = null;
							}
							return;
						}

						currentValue = value;
						updateMoment();
					});

					if (angular.isDefined(attr.amFrom)) {
						scope.$watch(attr.amFrom, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								currentFrom = null;
							} else {
								currentFrom = moment(value);
							}
							updateMoment();
						});
					}

					if (angular.isDefined(attr.amWithoutSuffix)) {
						scope.$watch(attr.amWithoutSuffix, function (value) {
							if (typeof value === 'boolean') {
								withoutSuffix = value;
								updateMoment();
							} else {
								withoutSuffix = amTimeAgoConfig.withoutSuffix;
							}
						});
					}

					attr.$observe('amFullDateThreshold', function (newValue) {
						fullDateThreshold = newValue;
						updateMoment();
					});

					attr.$observe('amFullDateFormat', function (newValue) {
						fullDateFormat = newValue;
						updateMoment();
					});

					attr.$observe('amFullDateThresholdUnit', function (newValue) {
						fullDateThresholdUnit = newValue;
						updateMoment();
					});

					scope.$on('$destroy', function () {
						cancelTimer();
					});

					scope.$on('amMoment:localeChanged', function () {
						updateMoment();
					});
				};
			}])

		/**
		 * @ngdoc service
		 * @name angularMoment.service.amMoment
		 * @module angularMoment
		 */
			.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
				var defaultTimezone = null;

				/**
				 * @ngdoc function
				 * @name angularMoment.service.amMoment#changeLocale
				 * @methodOf angularMoment.service.amMoment
				 *
				 * @description
				 * Changes the locale for moment.js and updates all the am-time-ago directive instances
				 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
				 *
				 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
				 * @param {object} customization object of locale strings to override
				 */
				this.changeLocale = function (locale, customization) {
					var result = moment.locale(locale, customization);
					if (angular.isDefined(locale)) {
						$rootScope.$broadcast('amMoment:localeChanged');

					}
					return result;
				};

				/**
				 * @ngdoc function
				 * @name angularMoment.service.amMoment#changeTimezone
				 * @methodOf angularMoment.service.amMoment
				 *
				 * @description
				 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
				 * `amMoment:timezoneChanged` event on $rootScope.
				 *
				 * Note: this method works only if moment-timezone > 0.3.0 is loaded
				 *
				 * @param {string} timezone Timezone name (e.g. UTC)
				 */
				this.changeTimezone = function (timezone) {
					if (moment.tz && moment.tz.setDefault) {
						moment.tz.setDefault(timezone);
						$rootScope.$broadcast('amMoment:timezoneChanged');
					} else {
						$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
					}
					angularMomentConfig.timezone = timezone;
					defaultTimezone = timezone;
				};

				/**
				 * @ngdoc function
				 * @name angularMoment.service.amMoment#preprocessDate
				 * @methodOf angularMoment.service.amMoment
				 *
				 * @description
				 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
				 * am-time-ago directive and the filters. The behavior of this function can be overriden by
				 * setting `angularMomentConfig.preprocess`.
				 *
				 * @param {*} value The value to be preprocessed
				 * @return {Moment} A `moment` object
				 */
				this.preprocessDate = function (value) {
					// Configure the default timezone if needed
					if (defaultTimezone !== angularMomentConfig.timezone) {
						this.changeTimezone(angularMomentConfig.timezone);
					}

					if (angularMomentConfig.preprocess) {
						return angularMomentConfig.preprocess(value);
					}

					if (!isNaN(parseFloat(value)) && isFinite(value)) {
						// Milliseconds since the epoch
						return moment(parseInt(value, 10));
					}

					// else just returns the value as-is.
					return moment(value);
				};
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amParse
		 * @module angularMoment
		 */
			.filter('amParse', ['moment', function (moment) {
				return function (value, format) {
					return moment(value, format);
				};
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amFromUnix
		 * @module angularMoment
		 */
			.filter('amFromUnix', ['moment', function (moment) {
				return function (value) {
					return moment.unix(value);
				};
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amUtc
		 * @module angularMoment
		 */
			.filter('amUtc', ['moment', function (moment) {
				return function (value) {
					return moment.utc(value);
				};
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amUtcOffset
		 * @module angularMoment
		 *
		 * @description
		 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
		 * '+0300', '-0300' or 'Z'.
		 */
			.filter('amUtcOffset', ['amMoment', function (amMoment) {
				function amUtcOffset(value, offset) {
					return amMoment.preprocessDate(value).utcOffset(offset);
				}

				return amUtcOffset;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amLocal
		 * @module angularMoment
		 */
			.filter('amLocal', ['moment', function (moment) {
				return function (value) {
					return moment.isMoment(value) ? value.local() : null;
				};
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amTimezone
		 * @module angularMoment
		 *
		 * @description
		 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
		 *
		 * You need to include moment-timezone.js for timezone support.
		 */
			.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
				function amTimezone(value, timezone) {
					var aMoment = amMoment.preprocessDate(value);

					if (!timezone) {
						return aMoment;
					}

					if (aMoment.tz) {
						return aMoment.tz(timezone);
					} else {
						$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
						return aMoment;
					}
				}

				return amTimezone;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amCalendar
		 * @module angularMoment
		 */
			.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amCalendarFilter(value, referenceTime, formats) {
					if (isUndefinedOrNull(value)) {
						return '';
					}

					var date = amMoment.preprocessDate(value);
					return date.isValid() ? date.calendar(referenceTime, formats) : '';
				}

				// Since AngularJS 1.3, filters have to explicitly define being stateful
				// (this is no longer the default).
				amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;

				return amCalendarFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amDifference
		 * @module angularMoment
		 */
			.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amDifferenceFilter(value, otherValue, unit, usePrecision) {
					if (isUndefinedOrNull(value)) {
						return '';
					}

					var date = amMoment.preprocessDate(value);
					var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();

					if (!date.isValid() || !date2.isValid()) {
						return '';
					}

					return date.diff(date2, unit, usePrecision);
				}

				amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;

				return amDifferenceFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amDateFormat
		 * @module angularMoment
		 * @function
		 */
			.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amDateFormatFilter(value, format) {
					if (isUndefinedOrNull(value)) {
						return '';
					}

					var date = amMoment.preprocessDate(value);
					if (!date.isValid()) {
						return '';
					}

					return date.format(format);
				}

				amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;

				return amDateFormatFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amDurationFormat
		 * @module angularMoment
		 * @function
		 */
			.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amDurationFormatFilter(value, format, suffix) {
					if (isUndefinedOrNull(value)) {
						return '';
					}

					return moment.duration(value, format).humanize(suffix);
				}

				amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;

				return amDurationFormatFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amTimeAgo
		 * @module angularMoment
		 * @function
		 */
			.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
				function amTimeAgoFilter(value, suffix, from) {
					var date, dateFrom;

					if (isUndefinedOrNull(value)) {
						return '';
					}

					value = amMoment.preprocessDate(value);
					date = moment(value);
					if (!date.isValid()) {
						return '';
					}

					dateFrom = moment(from);
					if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
						return date.from(dateFrom, suffix);
					}

					return date.fromNow(suffix);
				}

				amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;

				return amTimeAgoFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amSubtract
		 * @module angularMoment
		 * @function
		 */
			.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amSubtractFilter(value, amount, type) {

					if (isUndefinedOrNull(value)) {
						return '';
					}

					return moment(value).subtract(parseInt(amount, 10), type);
				}

				amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;

				return amSubtractFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amAdd
		 * @module angularMoment
		 * @function
		 */
			.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amAddFilter(value, amount, type) {

					if (isUndefinedOrNull(value)) {
						return '';
					}

					return moment(value).add(parseInt(amount, 10), type);
				}

				amAddFilter.$stateful = angularMomentConfig.statefulFilters;

				return amAddFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amStartOf
		 * @module angularMoment
		 * @function
		 */
			.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amStartOfFilter(value, type) {

					if (isUndefinedOrNull(value)) {
						return '';
					}

					return moment(value).startOf(type);
				}

				amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;

				return amStartOfFilter;
			}])

		/**
		 * @ngdoc filter
		 * @name angularMoment.filter:amEndOf
		 * @module angularMoment
		 * @function
		 */
			.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
				function amEndOfFilter(value, type) {

					if (isUndefinedOrNull(value)) {
						return '';
					}

					return moment(value).endOf(type);
				}

				amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;

				return amEndOfFilter;
 			}]);

		return 'angularMoment';
	}

	var isElectron = window && window.process && window.process.type;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(259), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
		module.exports = angularMoment(require('angular'), require('moment'));
	} else {
		angularMoment(angular, (typeof global !== 'undefined' && typeof global.moment !== 'undefined' ? global : window).moment);
	}
})();


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 260,
	"./af.js": 260,
	"./ar": 261,
	"./ar-dz": 262,
	"./ar-dz.js": 262,
	"./ar-kw": 263,
	"./ar-kw.js": 263,
	"./ar-ly": 264,
	"./ar-ly.js": 264,
	"./ar-ma": 265,
	"./ar-ma.js": 265,
	"./ar-sa": 266,
	"./ar-sa.js": 266,
	"./ar-tn": 267,
	"./ar-tn.js": 267,
	"./ar.js": 261,
	"./az": 268,
	"./az.js": 268,
	"./be": 269,
	"./be.js": 269,
	"./bg": 270,
	"./bg.js": 270,
	"./bm": 271,
	"./bm.js": 271,
	"./bn": 272,
	"./bn.js": 272,
	"./bo": 273,
	"./bo.js": 273,
	"./br": 274,
	"./br.js": 274,
	"./bs": 275,
	"./bs.js": 275,
	"./ca": 276,
	"./ca.js": 276,
	"./cs": 277,
	"./cs.js": 277,
	"./cv": 278,
	"./cv.js": 278,
	"./cy": 279,
	"./cy.js": 279,
	"./da": 280,
	"./da.js": 280,
	"./de": 281,
	"./de-at": 282,
	"./de-at.js": 282,
	"./de-ch": 283,
	"./de-ch.js": 283,
	"./de.js": 281,
	"./dv": 284,
	"./dv.js": 284,
	"./el": 285,
	"./el.js": 285,
	"./en-au": 286,
	"./en-au.js": 286,
	"./en-ca": 287,
	"./en-ca.js": 287,
	"./en-gb": 288,
	"./en-gb.js": 288,
	"./en-ie": 289,
	"./en-ie.js": 289,
	"./en-nz": 290,
	"./en-nz.js": 290,
	"./eo": 291,
	"./eo.js": 291,
	"./es": 292,
	"./es-do": 293,
	"./es-do.js": 293,
	"./es-us": 294,
	"./es-us.js": 294,
	"./es.js": 292,
	"./et": 295,
	"./et.js": 295,
	"./eu": 296,
	"./eu.js": 296,
	"./fa": 297,
	"./fa.js": 297,
	"./fi": 298,
	"./fi.js": 298,
	"./fo": 299,
	"./fo.js": 299,
	"./fr": 300,
	"./fr-ca": 301,
	"./fr-ca.js": 301,
	"./fr-ch": 302,
	"./fr-ch.js": 302,
	"./fr.js": 300,
	"./fy": 303,
	"./fy.js": 303,
	"./gd": 304,
	"./gd.js": 304,
	"./gl": 305,
	"./gl.js": 305,
	"./gom-latn": 306,
	"./gom-latn.js": 306,
	"./gu": 307,
	"./gu.js": 307,
	"./he": 308,
	"./he.js": 308,
	"./hi": 309,
	"./hi.js": 309,
	"./hr": 310,
	"./hr.js": 310,
	"./hu": 311,
	"./hu.js": 311,
	"./hy-am": 312,
	"./hy-am.js": 312,
	"./id": 313,
	"./id.js": 313,
	"./is": 314,
	"./is.js": 314,
	"./it": 315,
	"./it.js": 315,
	"./ja": 316,
	"./ja.js": 316,
	"./jv": 317,
	"./jv.js": 317,
	"./ka": 318,
	"./ka.js": 318,
	"./kk": 319,
	"./kk.js": 319,
	"./km": 320,
	"./km.js": 320,
	"./kn": 321,
	"./kn.js": 321,
	"./ko": 322,
	"./ko.js": 322,
	"./ky": 323,
	"./ky.js": 323,
	"./lb": 324,
	"./lb.js": 324,
	"./lo": 325,
	"./lo.js": 325,
	"./lt": 326,
	"./lt.js": 326,
	"./lv": 327,
	"./lv.js": 327,
	"./me": 328,
	"./me.js": 328,
	"./mi": 329,
	"./mi.js": 329,
	"./mk": 330,
	"./mk.js": 330,
	"./ml": 331,
	"./ml.js": 331,
	"./mr": 332,
	"./mr.js": 332,
	"./ms": 333,
	"./ms-my": 334,
	"./ms-my.js": 334,
	"./ms.js": 333,
	"./mt": 335,
	"./mt.js": 335,
	"./my": 336,
	"./my.js": 336,
	"./nb": 337,
	"./nb.js": 337,
	"./ne": 338,
	"./ne.js": 338,
	"./nl": 339,
	"./nl-be": 340,
	"./nl-be.js": 340,
	"./nl.js": 339,
	"./nn": 341,
	"./nn.js": 341,
	"./pa-in": 342,
	"./pa-in.js": 342,
	"./pl": 343,
	"./pl.js": 343,
	"./pt": 344,
	"./pt-br": 345,
	"./pt-br.js": 345,
	"./pt.js": 344,
	"./ro": 346,
	"./ro.js": 346,
	"./ru": 347,
	"./ru.js": 347,
	"./sd": 348,
	"./sd.js": 348,
	"./se": 349,
	"./se.js": 349,
	"./si": 350,
	"./si.js": 350,
	"./sk": 351,
	"./sk.js": 351,
	"./sl": 352,
	"./sl.js": 352,
	"./sq": 353,
	"./sq.js": 353,
	"./sr": 354,
	"./sr-cyrl": 355,
	"./sr-cyrl.js": 355,
	"./sr.js": 354,
	"./ss": 356,
	"./ss.js": 356,
	"./sv": 357,
	"./sv.js": 357,
	"./sw": 358,
	"./sw.js": 358,
	"./ta": 359,
	"./ta.js": 359,
	"./te": 360,
	"./te.js": 360,
	"./tet": 361,
	"./tet.js": 361,
	"./th": 362,
	"./th.js": 362,
	"./tl-ph": 363,
	"./tl-ph.js": 363,
	"./tlh": 364,
	"./tlh.js": 364,
	"./tr": 365,
	"./tr.js": 365,
	"./tzl": 366,
	"./tzl.js": 366,
	"./tzm": 367,
	"./tzm-latn": 368,
	"./tzm-latn.js": 368,
	"./tzm.js": 367,
	"./uk": 369,
	"./uk.js": 369,
	"./ur": 370,
	"./ur.js": 370,
	"./uz": 371,
	"./uz-latn": 372,
	"./uz-latn.js": 372,
	"./uz.js": 371,
	"./vi": 373,
	"./vi.js": 373,
	"./x-pseudo": 374,
	"./x-pseudo.js": 374,
	"./yo": 375,
	"./yo.js": 375,
	"./zh-cn": 376,
	"./zh-cn.js": 376,
	"./zh-hk": 377,
	"./zh-hk.js": 377,
	"./zh-tw": 378,
	"./zh-tw.js": 378
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(651);
module.exports = 'ngFileUpload';

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**!
 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * FileAPI Flash shim for old browsers not supporting FormData
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

(function () {
  /** @namespace FileAPI.noContentTimeout */

  function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
  }

  function redefineProp(xhr, prop, fn) {
    try {
      Object.defineProperty(xhr, prop, {get: fn});
    } catch (e) {/*ignore*/
    }
  }

  if (!window.FileAPI) {
    window.FileAPI = {};
  }

  if (!window.XMLHttpRequest) {
    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
  }

  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
  if (FileAPI.shouldLoad) {
    var initializeUploadListener = function (xhr) {
      if (!xhr.__listeners) {
        if (!xhr.upload) xhr.upload = {};
        xhr.__listeners = [];
        var origAddEventListener = xhr.upload.addEventListener;
        xhr.upload.addEventListener = function (t, fn) {
          xhr.__listeners[t] = fn;
          if (origAddEventListener) origAddEventListener.apply(this, arguments);
        };
      }
    };

    patchXHR('open', function (orig) {
      return function (m, url, b) {
        initializeUploadListener(this);
        this.__url = url;
        try {
          orig.apply(this, [m, url, b]);
        } catch (e) {
          if (e.message.indexOf('Access is denied') > -1) {
            this.__origError = e;
            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
          }
        }
      };
    });

    patchXHR('getResponseHeader', function (orig) {
      return function (h) {
        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
      };
    });

    patchXHR('getAllResponseHeaders', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
      };
    });

    patchXHR('abort', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
      };
    });

    patchXHR('setRequestHeader', function (orig) {
      return function (header, value) {
        if (header === '__setXHR_') {
          initializeUploadListener(this);
          var val = value(this);
          // fix for angular < 1.2.0
          if (val instanceof Function) {
            val(this);
          }
        } else {
          this.__requestHeaders = this.__requestHeaders || {};
          this.__requestHeaders[header] = value;
          orig.apply(this, arguments);
        }
      };
    });

    patchXHR('send', function (orig) {
      return function () {
        var xhr = this;
        if (arguments[0] && arguments[0].__isFileAPIShim) {
          var formData = arguments[0];
          var config = {
            url: xhr.__url,
            jsonp: false, //removes the callback form param
            cache: true, //removes the ?fileapiXXX in the url
            complete: function (err, fileApiXHR) {
              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
                // this error seems to be fine the file is being uploaded properly.
                err = null;
              }
              xhr.__completed = true;
              if (!err && xhr.__listeners.load)
                xhr.__listeners.load({
                  type: 'load',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (!err && xhr.__listeners.loadend)
                xhr.__listeners.loadend({
                  type: 'loadend',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (err === 'abort' && xhr.__listeners.abort)
                xhr.__listeners.abort({
                  type: 'abort',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
              });
              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
                return fileApiXHR.statusText;
              });
              redefineProp(xhr, 'readyState', function () {
                return 4;
              });
              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
                return fileApiXHR.response;
              });
              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
              redefineProp(xhr, 'responseText', function () {
                return resp;
              });
              redefineProp(xhr, 'response', function () {
                return resp;
              });
              if (err) redefineProp(xhr, 'err', function () {
                return err;
              });
              xhr.__fileApiXHR = fileApiXHR;
              if (xhr.onreadystatechange) xhr.onreadystatechange();
              if (xhr.onload) xhr.onload();
            },
            progress: function (e) {
              e.target = xhr;
              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
              xhr.__total = e.total;
              xhr.__loaded = e.loaded;
              if (e.total === e.loaded) {
                // fix flash issue that doesn't call complete if there is no response text from the server
                var _this = this;
                setTimeout(function () {
                  if (!xhr.__completed) {
                    xhr.getAllResponseHeaders = function () {
                    };
                    _this.complete(null, {status: 204, statusText: 'No Content'});
                  }
                }, FileAPI.noContentTimeout || 10000);
              }
            },
            headers: xhr.__requestHeaders
          };
          config.data = {};
          config.files = {};
          for (var i = 0; i < formData.data.length; i++) {
            var item = formData.data[i];
            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
              config.files[item.key] = item.val;
            } else {
              config.data[item.key] = item.val;
            }
          }

          setTimeout(function () {
            if (!FileAPI.hasFlash) {
              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
            }
            xhr.__fileApiXHR = FileAPI.upload(config);
          }, 1);
        } else {
          if (this.__origError) {
            throw this.__origError;
          }
          orig.apply(xhr, arguments);
        }
      };
    });
    window.XMLHttpRequest.__isFileAPIShim = true;
    window.FormData = FormData = function () {
      return {
        append: function (key, val, name) {
          if (val.__isFileAPIBlobShim) {
            val = val.data[0];
          }
          this.data.push({
            key: key,
            val: val,
            name: name
          });
        },
        data: [],
        __isFileAPIShim: true
      };
    };

    window.Blob = Blob = function (b) {
      return {
        data: b,
        __isFileAPIBlobShim: true
      };
    };
  }

})();

(function () {
  /** @namespace FileAPI.forceLoad */
  /** @namespace window.FileAPI.jsUrl */
  /** @namespace window.FileAPI.jsPath */

  function isInputTypeFile(elem) {
    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
  }

  function hasFlash() {
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) return true;
    } catch (e) {
      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
    }
    return false;
  }

  function getOffset(obj) {
    var left = 0, top = 0;

    if (__webpack_provided_window_dot_jQuery) {
      return jQuery(obj).offset();
    }

    if (obj.offsetParent) {
      do {
        left += (obj.offsetLeft - obj.scrollLeft);
        top += (obj.offsetTop - obj.scrollTop);
        obj = obj.offsetParent;
      } while (obj);
    }
    return {
      left: left,
      top: top
    };
  }

  if (FileAPI.shouldLoad) {
    FileAPI.hasFlash = hasFlash();

    //load FileAPI
    if (FileAPI.forceLoad) {
      FileAPI.html5 = false;
    }

    if (!FileAPI.upload) {
      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
      if (window.FileAPI.jsUrl) {
        jsUrl = window.FileAPI.jsUrl;
      } else if (window.FileAPI.jsPath) {
        basePath = window.FileAPI.jsPath;
      } else {
        for (i = 0; i < allScripts.length; i++) {
          src = allScripts[i].src;
          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
          if (index > -1) {
            basePath = src.substring(0, index + 1);
            break;
          }
        }
      }

      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
      if (!hasFlash()) {
        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
      }
      var fixInputStyle = function () {
        var label = fileElem.parent();
        if (elem.attr('disabled')) {
          if (label) label.removeClass('js-fileapi-wrapper');
        } else {
          if (!fileElem.attr('__ngf_flash_')) {
            fileElem.unbind('change');
            fileElem.unbind('click');
            fileElem.bind('change', function (evt) {
              fileApiChangeFn.apply(this, [evt]);
              changeFn.apply(this, [evt]);
            });
            fileElem.attr('__ngf_flash_', 'true');
          }
          label.addClass('js-fileapi-wrapper');
          if (!isInputTypeFile(elem)) {
            label.css('position', 'absolute')
              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
              .css('overflow', 'hidden').css('z-index', '900000')
              .css('visibility', 'visible');
            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
              .css('position', 'absolute').css('top', '0px').css('left', '0px');
          }
        }
      };

      elem.bind('mouseenter', fixInputStyle);

      var fileApiChangeFn = function (evt) {
        var files = FileAPI.getFiles(evt);
        //just a double check for #233
        for (var i = 0; i < files.length; i++) {
          if (files[i].size === undefined) files[i].size = 0;
          if (files[i].name === undefined) files[i].name = 'file';
          if (files[i].type === undefined) files[i].type = 'undefined';
        }
        if (!evt.target) {
          evt.target = {};
        }
        evt.target.files = files;
        // if evt.target.files is not writable use helper field
        if (evt.target.files !== files) {
          evt.__files_ = files;
        }
        (evt.__files_ || evt.target.files).item = function (i) {
          return (evt.__files_ || evt.target.files)[i] || null;
        };
      };
    };

    FileAPI.disableFileInput = function (elem, disable) {
      if (disable) {
        elem.removeClass('js-fileapi-wrapper');
      } else {
        elem.addClass('js-fileapi-wrapper');
      }
    };
  }
})();

if (!window.FileReader) {
  window.FileReader = function () {
    var _this = this, loadStarted = false;
    this.listeners = {};
    this.addEventListener = function (type, fn) {
      _this.listeners[type] = _this.listeners[type] || [];
      _this.listeners[type].push(fn);
    };
    this.removeEventListener = function (type, fn) {
      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
    };
    this.dispatchEvent = function (evt) {
      var list = _this.listeners[evt.type];
      if (list) {
        for (var i = 0; i < list.length; i++) {
          list[i].call(_this, evt);
        }
      }
    };
    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;

    var constructEvent = function (type, evt) {
      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
      if (evt.result != null) e.target.result = evt.result;
      return e;
    };
    var listener = function (evt) {
      if (!loadStarted) {
        loadStarted = true;
        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
      }
      var e;
      if (evt.type === 'load') {
        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
        e = constructEvent('load', evt);
        if (_this.onload) _this.onload(e);
        _this.dispatchEvent(e);
      } else if (evt.type === 'progress') {
        e = constructEvent('progress', evt);
        if (_this.onprogress) _this.onprogress(e);
        _this.dispatchEvent(e);
      } else {
        e = constructEvent('error', evt);
        if (_this.onerror) _this.onerror(e);
        _this.dispatchEvent(e);
      }
    };
    this.readAsDataURL = function (file) {
      FileAPI.readAsDataURL(file, listener);
    };
    this.readAsText = function (file) {
      FileAPI.readAsText(file, listener);
    };
  };
}

/**!
 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
    return function (header, value) {
      if (header === '__setXHR_') {
        var val = value(this);
        // fix for angular < 1.2.0
        if (val instanceof Function) {
          val(this);
        }
      } else {
        orig.apply(this, arguments);
      }
    };
  })(window.XMLHttpRequest.prototype.setRequestHeader);
}

var ngFileUpload = angular.module('ngFileUpload', []);

ngFileUpload.version = '12.2.13';

ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
  var upload = this;
  upload.promisesCount = 0;

  this.isResumeSupported = function () {
    return window.Blob && window.Blob.prototype.slice;
  };

  var resumeSupported = this.isResumeSupported();

  function sendHttp(config) {
    config.method = config.method || 'POST';
    config.headers = config.headers || {};

    var deferred = config._deferred = config._deferred || $q.defer();
    var promise = deferred.promise;

    function notifyProgress(e) {
      if (deferred.notify) {
        deferred.notify(e);
      }
      if (promise.progressFunc) {
        $timeout(function () {
          promise.progressFunc(e);
        });
      }
    }

    function getNotifyEvent(n) {
      if (config._start != null && resumeSupported) {
        return {
          loaded: n.loaded + config._start,
          total: (config._file && config._file.size) || n.total,
          type: n.type, config: config,
          lengthComputable: true, target: n.target
        };
      } else {
        return n;
      }
    }

    if (!config.disableProgress) {
      config.headers.__setXHR_ = function () {
        return function (xhr) {
          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
          config.__XHR = xhr;
          if (config.xhrFn) config.xhrFn(xhr);
          xhr.upload.addEventListener('progress', function (e) {
            e.config = config;
            notifyProgress(getNotifyEvent(e));
          }, false);
          //fix for firefox not firing upload progress end, also IE8-9
          xhr.upload.addEventListener('load', function (e) {
            if (e.lengthComputable) {
              e.config = config;
              notifyProgress(getNotifyEvent(e));
            }
          }, false);
        };
      };
    }

    function uploadWithAngular() {
      $http(config).then(function (r) {
          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
            var fileSize = config._file && config._file.size || 0;
            notifyProgress({
                loaded: Math.min(config._end, fileSize),
                total: fileSize,
                config: config,
                type: 'progress'
              }
            );
            upload.upload(config, true);
          } else {
            if (config._finished) delete config._finished;
            deferred.resolve(r);
          }
        }, function (e) {
          deferred.reject(e);
        }, function (n) {
          deferred.notify(n);
        }
      );
    }

    if (!resumeSupported) {
      uploadWithAngular();
    } else if (config._chunkSize && config._end && !config._finished) {
      config._start = config._end;
      config._end += config._chunkSize;
      uploadWithAngular();
    } else if (config.resumeSizeUrl) {
      $http.get(config.resumeSizeUrl).then(function (resp) {
        if (config.resumeSizeResponseReader) {
          config._start = config.resumeSizeResponseReader(resp.data);
        } else {
          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
        }
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else if (config.resumeSize) {
      config.resumeSize().then(function (size) {
        config._start = size;
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else {
      if (config._chunkSize) {
        config._start = 0;
        config._end = config._start + config._chunkSize;
      }
      uploadWithAngular();
    }


    promise.success = function (fn) {
      promise.then(function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.error = function (fn) {
      promise.then(null, function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.progress = function (fn) {
      promise.progressFunc = fn;
      promise.then(null, null, function (n) {
        fn(n);
      });
      return promise;
    };
    promise.abort = promise.pause = function () {
      if (config.__XHR) {
        $timeout(function () {
          config.__XHR.abort();
        });
      }
      return promise;
    };
    promise.xhr = function (fn) {
      config.xhrFn = (function (origXhrFn) {
        return function () {
          if (origXhrFn) origXhrFn.apply(promise, arguments);
          fn.apply(promise, arguments);
        };
      })(config.xhrFn);
      return promise;
    };

    upload.promisesCount++;
    if (promise['finally'] && promise['finally'] instanceof Function) {
      promise['finally'](function () {
        upload.promisesCount--;
      });
    }
    return promise;
  }

  this.isUploadInProgress = function () {
    return upload.promisesCount > 0;
  };

  this.rename = function (file, name) {
    file.ngfName = name;
    return file;
  };

  this.jsonBlob = function (val) {
    if (val != null && !angular.isString(val)) {
      val = JSON.stringify(val);
    }
    var blob = new window.Blob([val], {type: 'application/json'});
    blob._ngfBlob = true;
    return blob;
  };

  this.json = function (val) {
    return angular.toJson(val);
  };

  function copy(obj) {
    var clone = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = obj[key];
      }
    }
    return clone;
  }

  this.isFile = function (file) {
    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
  };

  this.upload = function (config, internal) {
    function toResumeFile(file, formData) {
      if (file._ngfBlob) return file;
      config._file = config._file || file;
      if (config._start != null && resumeSupported) {
        if (config._end && config._end >= file.size) {
          config._finished = true;
          config._end = file.size;
        }
        var slice = file.slice(config._start, config._end || file.size);
        slice.name = file.name;
        slice.ngfName = file.ngfName;
        if (config._chunkSize) {
          formData.append('_chunkSize', config._chunkSize);
          formData.append('_currentChunkSize', config._end - config._start);
          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
          formData.append('_totalSize', config._file.size);
        }
        return slice;
      }
      return file;
    }

    function addFieldToFormData(formData, val, key) {
      if (val !== undefined) {
        if (angular.isDate(val)) {
          val = val.toISOString();
        }
        if (angular.isString(val)) {
          formData.append(key, val);
        } else if (upload.isFile(val)) {
          var file = toResumeFile(val, formData);
          var split = key.split(',');
          if (split[1]) {
            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
            key = split[0];
          }
          config._fileKey = config._fileKey || key;
          formData.append(key, file, file.ngfName || file.name);
        } else {
          if (angular.isObject(val)) {
            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

            val.$$ngfCircularDetection = true;
            try {
              for (var k in val) {
                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
                  if (val.length && parseInt(k) > -1) {
                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
                  }
                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
                }
              }
            } finally {
              delete val.$$ngfCircularDetection;
            }
          } else {
            formData.append(key, val);
          }
        }
      }
    }

    function digestConfig() {
      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

      config.headers = config.headers || {};
      config.headers['Content-Type'] = undefined;
      config.transformRequest = config.transformRequest ?
        (angular.isArray(config.transformRequest) ?
          config.transformRequest : [config.transformRequest]) : [];
      config.transformRequest.push(function (data) {
        var formData = new window.FormData(), key;
        data = data || config.fields || {};
        if (config.file) {
          data.file = config.file;
        }
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            var val = data[key];
            if (config.formDataAppender) {
              config.formDataAppender(formData, key, val);
            } else {
              addFieldToFormData(formData, val, key);
            }
          }
        }

        return formData;
      });
    }

    if (!internal) config = copy(config);
    if (!config._isDigested) {
      config._isDigested = true;
      digestConfig();
    }

    return sendHttp(config);
  };

  this.http = function (config) {
    config = copy(config);
    config.transformRequest = config.transformRequest || function (data) {
        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
          return data;
        }
        return $http.defaults.transformRequest[0].apply(this, arguments);
      };
    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

    return sendHttp(config);
  };

  this.translateScalars = function (str) {
    if (angular.isString(str)) {
      if (str.search(/kb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1024);
      } else if (str.search(/mb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1048576);
      } else if (str.search(/gb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
      } else if (str.search(/b/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/s/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/m/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 60);
      } else if (str.search(/h/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 3600);
      }
    }
    return str;
  };

  this.urlToBlob = function(url) {
    var defer = $q.defer();
    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
      var arrayBufferView = new Uint8Array(resp.data);
      var type = resp.headers('content-type') || 'image/WebP';
      var blob = new window.Blob([arrayBufferView], {type: type});
      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
      if (matches.length > 1) {
        blob.name = matches[1];
      }
      defer.resolve(blob);
    }, function (e) {
      defer.reject(e);
    });
    return defer.promise;
  };

  this.setDefaults = function (defaults) {
    this.defaults = defaults || {};
  };

  this.defaults = {};
  this.version = ngFileUpload.version;
}

]);

ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
  var upload = UploadExif;
  upload.getAttrWithDefaults = function (attr, name) {
    if (attr[name] != null) return attr[name];
    var def = upload.defaults[name];
    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
  };

  upload.attrGetter = function (name, attr, scope, params) {
    var attrVal = this.getAttrWithDefaults(attr, name);
    if (scope) {
      try {
        if (params) {
          return $parse(attrVal)(scope, params);
        } else {
          return $parse(attrVal)(scope);
        }
      } catch (e) {
        // hangle string value without single qoute
        if (name.search(/min|max|pattern/i)) {
          return attrVal;
        } else {
          throw e;
        }
      }
    } else {
      return attrVal;
    }
  };

  upload.shouldUpdateOn = function (type, attr, scope) {
    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
    if (modelOptions && modelOptions.updateOn) {
      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
    }
    return true;
  };

  upload.emptyPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.resolve.apply(d, args);
    });
    return d.promise;
  };

  upload.rejectPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.reject.apply(d, args);
    });
    return d.promise;
  };

  upload.happyPromise = function (promise, data) {
    var d = $q.defer();
    promise.then(function (result) {
      d.resolve(result);
    }, function (error) {
      $timeout(function () {
        throw error;
      });
      d.resolve(data);
    });
    return d.promise;
  };

  function applyExifRotations(files, attr, scope) {
    var promises = [upload.emptyPromise()];
    angular.forEach(files, function (f, i) {
      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
          files.splice(i, 1, fixedFile);
        }));
      }
    });
    return $q.all(promises);
  }

  function resizeFile(files, attr, scope, ngModel) {
    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
    if (resizeVal instanceof Function) {
      var defer = $q.defer();
      return resizeVal(files).then(function (p) {
        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
          defer.resolve(r);
        }, function (e) {
          defer.reject(e);
        });
      }, function (e) {
        defer.reject(e);
      });
    } else {
      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
    }
  }

  function resizeWithParams(params, files, attr, scope, ngModel) {
    var promises = [upload.emptyPromise()];

    function handleFile(f, i) {
      if (f.type.indexOf('image') === 0) {
        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
        params.resizeIf = function (width, height) {
          return upload.attrGetter('ngfResizeIf', attr, scope,
            {$width: width, $height: height, $file: f});
        };
        var promise = upload.resize(f, params);
        promises.push(promise);
        promise.then(function (resizedFile) {
          files.splice(i, 1, resizedFile);
        }, function (e) {
          f.$error = 'resize';
          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
          ngModel.$ngfValidations.push({name: 'resize', valid: false});
          upload.applyModelValidation(ngModel, files);
        });
      }
    }

    for (var i = 0; i < files.length; i++) {
      handleFile(files[i], i);
    }
    return $q.all(promises);
  }

  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
      attr.$$ngfPrevValidFiles = files;
      attr.$$ngfPrevInvalidFiles = invalidFiles;
      var file = files && files.length ? files[0] : null;
      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

      if (ngModel) {
        upload.applyModelValidation(ngModel, files);
        ngModel.$setViewValue(isSingleModel ? file : files);
      }

      if (fileChange) {
        $parse(fileChange)(scope, {
          $files: files,
          $file: file,
          $newFiles: newFiles,
          $duplicateFiles: dupFiles,
          $invalidFiles: invalidFiles,
          $invalidFile: invalidFile,
          $event: evt
        });
      }

      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
      if (invalidModel) {
        $timeout(function () {
          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
        });
      }
      $timeout(function () {
        // scope apply changes
      });
    }

    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
      invalids = [], valids = [];

    function removeDuplicates() {
      function equals(f1, f2) {
        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
          f1.type === f2.type;
      }

      function isInPrevFiles(f) {
        var j;
        for (j = 0; j < prevValidFiles.length; j++) {
          if (equals(f, prevValidFiles[j])) {
            return true;
          }
        }
        for (j = 0; j < prevInvalidFiles.length; j++) {
          if (equals(f, prevInvalidFiles[j])) {
            return true;
          }
        }
        return false;
      }

      if (files) {
        allNewFiles = [];
        dupFiles = [];
        for (var i = 0; i < files.length; i++) {
          if (isInPrevFiles(files[i])) {
            dupFiles.push(files[i]);
          } else {
            allNewFiles.push(files[i]);
          }
        }
      }
    }

    function toArray(v) {
      return angular.isArray(v) ? v : [v];
    }

    function resizeAndUpdate() {
      function updateModel() {
        $timeout(function () {
          update(keep ? prevValidFiles.concat(valids) : valids,
            keep ? prevInvalidFiles.concat(invalids) : invalids,
            files, dupFiles, isSingleModel);
        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
      }

      var resizingFiles = validateAfterResize ? allNewFiles : valids;
      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
        if (validateAfterResize) {
          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
            .then(function (validationResult) {
              valids = validationResult.validsFiles;
              invalids = validationResult.invalidsFiles;
              updateModel();
            });
        } else {
          updateModel();
        }
      }, function () {
        for (var i = 0; i < resizingFiles.length; i++) {
          var f = resizingFiles[i];
          if (f.$error === 'resize') {
            var index = valids.indexOf(f);
            if (index > -1) {
              valids.splice(index, 1);
              invalids.push(f);
            }
            updateModel();
          }
        }
      });
    }

    prevValidFiles = attr.$$ngfPrevValidFiles || [];
    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
    if (ngModel && ngModel.$modelValue) {
      prevValidFiles = toArray(ngModel.$modelValue);
    }

    var keep = upload.attrGetter('ngfKeep', attr, scope);
    allNewFiles = (files || []).slice(0);
    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
      removeDuplicates(attr, scope);
    }

    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

    if (keep && !allNewFiles.length) return;

    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
      $files: files,
      $file: files && files.length ? files[0] : null,
      $newFiles: allNewFiles,
      $duplicateFiles: dupFiles,
      $event: evt
    });

    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

    var options = upload.attrGetter('ngfModelOptions', attr, scope);
    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
      .then(function (validationResult) {
      if (noDelay) {
        update(allNewFiles, [], files, dupFiles, isSingleModel);
      } else {
        if ((!options || !options.allowInvalid) && !validateAfterResize) {
          valids = validationResult.validFiles;
          invalids = validationResult.invalidFiles;
        } else {
          valids = allNewFiles;
        }
        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
          applyExifRotations(valids, attr, scope).then(function () {
            resizeAndUpdate();
          });
        } else {
          resizeAndUpdate();
        }
      }
    });
  };

  return upload;
}]);

ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
  var generatedElems = [];

  function isDelayedClickSupported(ua) {
    // fix for android native browser < 4.4 and safari windows
    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
    if (m && m.length > 2) {
      var v = Upload.defaults.androidFixMinorVersion || 4;
      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
    }

    // safari on windows
    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
  }

  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
    /** @namespace attr.ngfSelect */
    /** @namespace attr.ngfChange */
    /** @namespace attr.ngModel */
    /** @namespace attr.ngfModelOptions */
    /** @namespace attr.ngfMultiple */
    /** @namespace attr.ngfCapture */
    /** @namespace attr.ngfValidate */
    /** @namespace attr.ngfKeep */
    var attrGetter = function (name, scope) {
      return upload.attrGetter(name, attr, scope);
    };

    function isInputTypeFile() {
      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
    }

    function fileChangeAttr() {
      return attrGetter('ngfChange') || attrGetter('ngfSelect');
    }

    function changeFn(evt) {
      if (upload.shouldUpdateOn('change', attr, scope)) {
        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
        /* Handle duplicate call in  IE11 */
        if (!fileList) return;
        for (var i = 0; i < fileList.length; i++) {
          files.push(fileList[i]);
        }
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
          files.length ? files : null, evt);
      }
    }

    upload.registerModelChangeValidator(ngModel, attr, scope);

    var unwatches = [];
    if (attrGetter('ngfMultiple')) {
      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
      }));
    }
    if (attrGetter('ngfCapture')) {
      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
        fileElem.attr('capture', attrGetter('ngfCapture', scope));
      }));
    }
    if (attrGetter('ngfAccept')) {
      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
        fileElem.attr('accept', attrGetter('ngfAccept', scope));
      }));
    }
    unwatches.push(attr.$observe('accept', function () {
      fileElem.attr('accept', attrGetter('accept'));
    }));
    function bindAttrToFileInput(fileElem, label) {
      function updateId(val) {
        fileElem.attr('id', 'ngf-' + val);
        label.attr('id', 'ngf-label-' + val);
      }

      for (var i = 0; i < elem[0].attributes.length; i++) {
        var attribute = elem[0].attributes[i];
        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
          if (attribute.name === 'id') {
            updateId(attribute.value);
            unwatches.push(attr.$observe('id', updateId));
          } else {
            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
            attribute.name === 'multiple')) ? attribute.name : attribute.value);
          }
        }
      }
    }

    function createFileInput() {
      if (isInputTypeFile()) {
        return elem;
      }

      var fileElem = angular.element('<input type="file">');

      var label = angular.element('<label>upload</label>');
      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
        .css('width', '0px').css('height', '0px').css('border', 'none')
        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
      bindAttrToFileInput(fileElem, label);

      generatedElems.push({el: elem, ref: label});

      document.body.appendChild(label.append(fileElem)[0]);

      return fileElem;
    }

    function clickHandler(evt) {
      if (elem.attr('disabled')) return false;
      if (attrGetter('ngfSelectDisabled', scope)) return;

      var r = detectSwipe(evt);
      // prevent the click if it is a swipe
      if (r != null) return r;

      resetModel(evt);

      // fix for md when the element is removed from the DOM and added back #460
      try {
        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
          generatedElems.push({el: elem, ref: fileElem.parent()});
          document.body.appendChild(fileElem.parent()[0]);
          fileElem.bind('change', changeFn);
        }
      } catch (e) {/*ignore*/
      }

      if (isDelayedClickSupported(navigator.userAgent)) {
        setTimeout(function () {
          fileElem[0].click();
        }, 0);
      } else {
        fileElem[0].click();
      }

      return false;
    }


    var initialTouchStartY = 0;
    var initialTouchStartX = 0;

    function detectSwipe(evt) {
      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
      if (touches) {
        if (evt.type === 'touchstart') {
          initialTouchStartX = touches[0].clientX;
          initialTouchStartY = touches[0].clientY;
          return true; // don't block event default
        } else {
          // prevent scroll from triggering event
          if (evt.type === 'touchend') {
            var currentX = touches[0].clientX;
            var currentY = touches[0].clientY;
            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
              (Math.abs(currentY - initialTouchStartY) > 20)) {
              evt.stopPropagation();
              evt.preventDefault();
              return false;
            }
          }
          return true;
        }
      }
    }

    var fileElem = elem;

    function resetModel(evt) {
      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
        fileElem.val(null);
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
      }
    }

    if (!isInputTypeFile()) {
      fileElem = createFileInput();
    }
    fileElem.bind('change', changeFn);

    if (!isInputTypeFile()) {
      elem.bind('click touchstart touchend', clickHandler);
    } else {
      elem.bind('click', resetModel);
    }

    function ie10SameFileSelectFix(evt) {
      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
        if (!fileElem[0].parentNode) {
          fileElem = null;
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        fileElem.unbind('click');
        var clone = fileElem.clone();
        fileElem.replaceWith(clone);
        fileElem = clone;
        fileElem.attr('__ngf_ie10_Fix_', 'true');
        fileElem.bind('change', changeFn);
        fileElem.bind('click', ie10SameFileSelectFix);
        fileElem[0].click();
        return false;
      } else {
        fileElem.removeAttr('__ngf_ie10_Fix_');
      }
    }

    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
      fileElem.bind('click', ie10SameFileSelectFix);
    }

    if (ngModel) ngModel.$formatters.push(function (val) {
      if (val == null || val.length === 0) {
        if (fileElem.val()) {
          fileElem.val(null);
        }
      }
      return val;
    });

    scope.$on('$destroy', function () {
      if (!isInputTypeFile()) fileElem.parent().remove();
      angular.forEach(unwatches, function (unwatch) {
        unwatch();
      });
    });

    $timeout(function () {
      for (var i = 0; i < generatedElems.length; i++) {
        var g = generatedElems[i];
        if (!document.body.contains(g.el[0])) {
          generatedElems.splice(i, 1);
          g.ref.remove();
        }
      }
    });

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
    }
  }

  return {
    restrict: 'AEC',
    require: '?ngModel',
    link: function (scope, elem, attr, ngModel) {
      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
    }
  };
}]);

(function () {

  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
    var upload = UploadBase;
    upload.base64DataUrl = function (file) {
      if (angular.isArray(file)) {
        var d = $q.defer(), count = 0;
        angular.forEach(file, function (f) {
          upload.dataUrl(f, true)['finally'](function () {
            count++;
            if (count === file.length) {
              var urls = [];
              angular.forEach(file, function (ff) {
                urls.push(ff.$ngfDataUrl);
              });
              d.resolve(urls, file);
            }
          });
        });
        return d.promise;
      } else {
        return upload.dataUrl(file, true);
      }
    };
    upload.dataUrl = function (file, disallowObjectUrl) {
      if (!file) return upload.emptyPromise(file, file);
      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
      }
      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
      if (p) return p;

      var deferred = $q.defer();
      $timeout(function () {
        if (window.FileReader && file &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
          //prefer URL.createObjectURL for handling refrences to files of all sizes
          //since it doesn´t build a large string in memory
          var URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL && !disallowObjectUrl) {
            var url;
            try {
              url = URL.createObjectURL(file);
            } catch (e) {
              $timeout(function () {
                file.$ngfBlobUrl = '';
                deferred.reject();
              });
              return;
            }
            $timeout(function () {
              file.$ngfBlobUrl = url;
              if (url) {
                deferred.resolve(url, file);
                upload.blobUrls = upload.blobUrls || [];
                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
                upload.blobUrls.push({url: url, size: file.size});
                upload.blobUrlsTotalSize += file.size || 0;
                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
                  var obj = upload.blobUrls.splice(0, 1)[0];
                  URL.revokeObjectURL(obj.url);
                  upload.blobUrlsTotalSize -= obj.size;
                }
              }
            });
          } else {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
              $timeout(function () {
                file.$ngfDataUrl = e.target.result;
                deferred.resolve(e.target.result, file);
                $timeout(function () {
                  delete file.$ngfDataUrl;
                }, 1000);
              });
            };
            fileReader.onerror = function () {
              $timeout(function () {
                file.$ngfDataUrl = '';
                deferred.reject();
              });
            };
            fileReader.readAsDataURL(file);
          }
        } else {
          $timeout(function () {
            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
            deferred.reject();
          });
        }
      });

      if (disallowObjectUrl) {
        p = file.$$ngfDataUrlPromise = deferred.promise;
      } else {
        p = file.$$ngfBlobUrlPromise = deferred.promise;
      }
      p['finally'](function () {
        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
      });
      return p;
    };
    return upload;
  }]);

  function getTagType(el) {
    if (el.tagName.toLowerCase() === 'img') return 'image';
    if (el.tagName.toLowerCase() === 'audio') return 'audio';
    if (el.tagName.toLowerCase() === 'video') return 'video';
    return /./;
  }

  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
    function constructDataUrl(file) {
      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
        $timeout(function () {
          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
          if (isBackground) {
            elem.css('background-image', 'url(\'' + (src || '') + '\')');
          } else {
            elem.attr('src', src);
          }
          if (src) {
            elem.removeClass('ng-hide');
          } else {
            elem.addClass('ng-hide');
          }
        });
      });
    }

    $timeout(function () {
      var unwatch = scope.$watch(attr[directiveName], function (file) {
        var size = resizeParams;
        if (directiveName === 'ngfThumbnail') {
          if (!size) {
            size = {
              width: elem[0].naturalWidth || elem[0].clientWidth,
              height: elem[0].naturalHeight || elem[0].clientHeight
            };
          }
          if (size.width === 0 && window.getComputedStyle) {
            var style = getComputedStyle(elem[0]);
            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
              size = {
                width: parseInt(style.width.slice(0, -2)),
                height: parseInt(style.height.slice(0, -2))
              };
            }
          }
        }

        if (angular.isString(file)) {
          elem.removeClass('ng-hide');
          if (isBackground) {
            return elem.css('background-image', 'url(\'' + file + '\')');
          } else {
            return elem.attr('src', file);
          }
        }
        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
          (!isBackground || file.type.indexOf('image') === 0)) {
          if (size && Upload.isResizeSupported()) {
            size.resizeIf = function (width, height) {
              return Upload.attrGetter('ngfResizeIf', attr, scope,
                {$width: width, $height: height, $file: file});
            };
            Upload.resize(file, size).then(
              function (f) {
                constructDataUrl(f);
              }, function (e) {
                throw e;
              }
            );
          } else {
            constructDataUrl(file);
          }
        } else {
          elem.addClass('ng-hide');
        }
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    });
  }


  /** @namespace attr.ngfSrc */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
          Upload.attrGetter('ngfResize', attr, scope), false);
      }
    };
  }]);

  /** @namespace attr.ngfBackground */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
          Upload.attrGetter('ngfResize', attr, scope), true);
      }
    };
  }]);

  /** @namespace attr.ngfThumbnail */
  /** @namespace attr.ngfAsBackground */
  /** @namespace attr.ngfSize */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        var size = Upload.attrGetter('ngfSize', attr, scope);
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
          Upload.attrGetter('ngfAsBackground', attr, scope));
      }
    };
  }]);

  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
  }]);

  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
    return function (file, disallowObjectUrl, trustedUrl) {
      if (angular.isString(file)) {
        return $sce.trustAsResourceUrl(file);
      }
      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
      if (file && !src) {
        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
          file.$ngfDataUrlFilterInProgress = true;
          UploadDataUrl.dataUrl(file, disallowObjectUrl);
        }
        return '';
      }
      if (file) delete file.$ngfDataUrlFilterInProgress;
      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
    };
  }]);

})();

ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
  var upload = UploadDataUrl;

  function globStringToRegex(str) {
    var regexp = '', excludes = [];
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
      regexp = str.substring(1, str.length - 1);
    } else {
      var split = str.split(',');
      if (split.length > 1) {
        for (var i = 0; i < split.length; i++) {
          var r = globStringToRegex(split[i]);
          if (r.regexp) {
            regexp += '(' + r.regexp + ')';
            if (i < split.length - 1) {
              regexp += '|';
            }
          } else {
            excludes = excludes.concat(r.excludes);
          }
        }
      } else {
        if (str.indexOf('!') === 0) {
          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
        } else {
          if (str.indexOf('.') === 0) {
            str = '*' + str;
          }
          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
        }
      }
    }
    return {regexp: regexp, excludes: excludes};
  }

  upload.validatePattern = function (file, val) {
    if (!val) {
      return true;
    }
    var pattern = globStringToRegex(val), valid = true;
    if (pattern.regexp && pattern.regexp.length) {
      var regexp = new RegExp(pattern.regexp, 'i');
      valid = (file.type != null && regexp.test(file.type)) ||
        (file.name != null && regexp.test(file.name));
    }
    var len = pattern.excludes.length;
    while (len--) {
      var exclude = new RegExp(pattern.excludes[len], 'i');
      valid = valid && (file.type == null || exclude.test(file.type)) &&
        (file.name == null || exclude.test(file.name));
    }
    return valid;
  };

  upload.ratioToFloat = function (val) {
    var r = val.toString(), xIndex = r.search(/[x:]/i);
    if (xIndex > -1) {
      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
    } else {
      r = parseFloat(r);
    }
    return r;
  };

  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
    if (ngModel) {
      ngModel.$formatters.push(function (files) {
        if (ngModel.$dirty) {
          var filesArray = files;
          if (files && !angular.isArray(files)) {
            filesArray = [files];
          }
          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
            upload.applyModelValidation(ngModel, filesArray);
          });
        }
        return files;
      });
    }
  };

  function markModelAsDirty(ngModel, files) {
    if (files != null && !ngModel.$dirty) {
      if (ngModel.$setDirty) {
        ngModel.$setDirty();
      } else {
        ngModel.$dirty = true;
      }
    }
  }

  upload.applyModelValidation = function (ngModel, files) {
    markModelAsDirty(ngModel, files);
    angular.forEach(ngModel.$ngfValidations, function (validation) {
      ngModel.$setValidity(validation.name, validation.valid);
    });
  };

  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
    var val = upload.attrGetter(dName, attr, scope, {$file: file});
    if (val == null) {
      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
      if (val) {
        var split = (validationName || name).split('.');
        val = val[split[0]];
        if (split.length > 1) {
          val = val && val[split[1]];
        }
      }
    }
    return val;
  };

  upload.validate = function (files, prevLength, ngModel, attr, scope) {
    ngModel = ngModel || {};
    ngModel.$ngfValidations = ngModel.$ngfValidations || [];

    angular.forEach(ngModel.$ngfValidations, function (v) {
      v.valid = true;
    });

    var attrGetter = function (name, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

    if (files == null || files.length === 0) {
      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
    }

    files = files.length === undefined ? [files] : files.slice(0);
    var invalidFiles = [];

    function validateSync(name, validationName, fn) {
      if (files) {
        var i = files.length, valid = null;
        while (i--) {
          var file = files[i];
          if (file) {
            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
            if (val != null) {
              if (!fn(file, val, i)) {
                if (ignoredErrors.indexOf(name) === -1) {
                  file.$error = name;
                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
                  file.$errorParam = val;
                  if (invalidFiles.indexOf(file) === -1) {
                    invalidFiles.push(file);
                  }
                  if (!runAllValidation) {
                    files.splice(i, 1);
                  }
                  valid = false;
                } else {
                  files.splice(i, 1);
                }
              }
            }
          }
        }
        if (valid !== null) {
          ngModel.$ngfValidations.push({name: name, valid: valid});
        }
      }
    }

    validateSync('pattern', null, upload.validatePattern);
    validateSync('minSize', 'size.min', function (file, val) {
      return file.size + 0.1 >= upload.translateScalars(val);
    });
    validateSync('maxSize', 'size.max', function (file, val) {
      return file.size - 0.1 <= upload.translateScalars(val);
    });
    var totalSize = 0;
    validateSync('maxTotalSize', null, function (file, val) {
      totalSize += file.size;
      if (totalSize > upload.translateScalars(val)) {
        files.splice(0, files.length);
        return false;
      }
      return true;
    });

    validateSync('validateFn', null, function (file, r) {
      return r === true || r === null || r === '';
    });

    if (!files.length) {
      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
    }

    function validateAsync(name, validationName, type, asyncFn, fn) {
      function resolveResult(defer, file, val) {
        function resolveInternal(fn) {
          if (fn()) {
            if (ignoredErrors.indexOf(name) === -1) {
              file.$error = name;
              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
              file.$errorParam = val;
              if (invalidFiles.indexOf(file) === -1) {
                invalidFiles.push(file);
              }
              if (!runAllValidation) {
                var i = files.indexOf(file);
                if (i > -1) files.splice(i, 1);
              }
              defer.resolve(false);
            } else {
              var j = files.indexOf(file);
              if (j > -1) files.splice(j, 1);
              defer.resolve(true);
            }
          } else {
            defer.resolve(true);
          }
        }

        if (val != null) {
          asyncFn(file, val).then(function (d) {
            resolveInternal(function () {
              return !fn(d, val);
            });
          }, function () {
            resolveInternal(function () {
              return attrGetter('ngfValidateForce', {$file: file});
            });
          });
        } else {
          defer.resolve(true);
        }
      }

      var promises = [upload.emptyPromise(true)];
      if (files) {
        files = files.length === undefined ? [files] : files;
        angular.forEach(files, function (file) {
          var defer = $q.defer();
          promises.push(defer.promise);
          if (type && (file.type == null || file.type.search(type) !== 0)) {
            defer.resolve(true);
            return;
          }
          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
            upload.imageDimensions(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
            }, function () {
              defer.resolve(false);
            });
          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
            upload.mediaDuration(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDuration', {$file: file, $duration: d}));
            }, function () {
              defer.resolve(false);
            });
          } else {
            resolveResult(defer, file,
              upload.getValidationAttr(attr, scope, name, validationName, file));
          }
        });
      }
      var deffer = $q.defer();
      $q.all(promises).then(function (values) {
        var isValid = true;
        for (var i = 0; i < values.length; i++) {
          if (!values[i]) {
            isValid = false;
            break;
          }
        }
        ngModel.$ngfValidations.push({name: name, valid: isValid});
        deffer.resolve(isValid);
      });
      return deffer.promise;
    }

    var deffer = $q.defer();
    var promises = [];

    promises.push(validateAsync('maxHeight', 'height.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.height <= val;
      }));
    promises.push(validateAsync('minHeight', 'height.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.height >= val;
      }));
    promises.push(validateAsync('maxWidth', 'width.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.width <= val;
      }));
    promises.push(validateAsync('minWidth', 'width.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.width >= val;
      }));
    promises.push(validateAsync('dimensions', null, /image/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));
    promises.push(validateAsync('ratio', null, /image/,
      this.imageDimensions, function (d, val) {
        var split = val.toString().split(','), valid = false;
        for (var i = 0; i < split.length; i++) {
          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
            valid = true;
          }
        }
        return valid;
      }));
    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
      }));
    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
      }));
    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d <= upload.translateScalars(val);
      }));
    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d >= upload.translateScalars(val);
      }));
    promises.push(validateAsync('duration', null, /audio|video/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));

    promises.push(validateAsync('validateAsyncFn', null, null,
      function (file, val) {
        return val;
      }, function (r) {
        return r === true || r === null || r === '';
      }));

    $q.all(promises).then(function () {

      if (runAllValidation) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          if (file.$error) {
            files.splice(i--, 1);
          }
        }
      }

      runAllValidation = false;
      validateSync('maxFiles', null, function (file, val, i) {
        return prevLength + i < val;
      });

      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
    });
    return deffer.promise;
  };

  upload.imageDimensions = function (file) {
    if (file.$ngfWidth && file.$ngfHeight) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
      });
      return d.promise;
    }
    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('image') !== 0) {
        deferred.reject('not image');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var img = angular.element('<img>').attr('src', dataUrl)
          .css('visibility', 'hidden').css('position', 'fixed')
          .css('max-width', 'none !important').css('max-height', 'none !important');

        function success() {
          var width = img[0].naturalWidth || img[0].clientWidth;
          var height = img[0].naturalHeight || img[0].clientHeight;
          img.remove();
          file.$ngfWidth = width;
          file.$ngfHeight = height;
          deferred.resolve({width: width, height: height});
        }

        function error() {
          img.remove();
          deferred.reject('load error');
        }

        img.on('load', success);
        img.on('error', error);

        var secondsCounter = 0;
        function checkLoadErrorInCaseOfNoCallback() {
          $timeout(function () {
            if (img[0].parentNode) {
              if (img[0].clientWidth) {
                success();
              } else if (secondsCounter++ > 10) {
                error();
              } else {
                checkLoadErrorInCaseOfNoCallback();
              }
            }
          }, 1000);
        }

        checkLoadErrorInCaseOfNoCallback();

        angular.element(document.getElementsByTagName('body')[0]).append(img);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDimensionPromise = deferred.promise;
    file.$ngfDimensionPromise['finally'](function () {
      delete file.$ngfDimensionPromise;
    });
    return file.$ngfDimensionPromise;
  };

  upload.mediaDuration = function (file) {
    if (file.$ngfDuration) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve(file.$ngfDuration);
      });
      return d.promise;
    }
    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
        deferred.reject('not media');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

        function success() {
          var duration = el[0].duration;
          file.$ngfDuration = duration;
          el.remove();
          deferred.resolve(duration);
        }

        function error() {
          el.remove();
          deferred.reject('load error');
        }

        el.on('loadedmetadata', success);
        el.on('error', error);
        var count = 0;

        function checkLoadError() {
          $timeout(function () {
            if (el[0].parentNode) {
              if (el[0].duration) {
                success();
              } else if (count > 10) {
                error();
              } else {
                checkLoadError();
              }
            }
          }, 1000);
        }

        checkLoadError();

        angular.element(document.body).append(el);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDurationPromise = deferred.promise;
    file.$ngfDurationPromise['finally'](function () {
      delete file.$ngfDurationPromise;
    });
    return file.$ngfDurationPromise;
  };
  return upload;
}
]);

ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
  var upload = UploadValidate;

  /**
   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
   * images to fit into a certain area.
   * Source:  http://stackoverflow.com/a/14731922
   *
   * @param {Number} srcWidth Source area width
   * @param {Number} srcHeight Source area height
   * @param {Number} maxWidth Nestable area maximum available width
   * @param {Number} maxHeight Nestable area maximum available height
   * @return {Object} { width, height }
   */
  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio, height: srcHeight * ratio,
      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
    };
  };

  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
    var deferred = $q.defer();
    var canvasElement = document.createElement('canvas');
    var imageElement = document.createElement('img');
    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
    document.body.appendChild(imageElement);

    imageElement.onload = function () {
      var imgWidth = imageElement.width, imgHeight = imageElement.height;
      imageElement.parentNode.removeChild(imageElement);
      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
        deferred.reject('resizeIf');
        return;
      }
      try {
        if (ratio) {
          var ratioFloat = upload.ratioToFloat(ratio);
          var imgRatio = imgWidth / imgHeight;
          if (imgRatio < ratioFloat) {
            width = imgWidth;
            height = width / ratioFloat;
          } else {
            height = imgHeight;
            width = height * ratioFloat;
          }
        }
        if (!width) {
          width = imgWidth;
        }
        if (!height) {
          height = imgHeight;
        }
        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
        canvasElement.width = Math.min(dimensions.width, width);
        canvasElement.height = Math.min(dimensions.height, height);
        var context = canvasElement.getContext('2d');
        context.drawImage(imageElement,
          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
          dimensions.width, dimensions.height);
        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
      } catch (e) {
        deferred.reject(e);
      }
    };
    imageElement.onerror = function () {
      imageElement.parentNode.removeChild(imageElement);
      deferred.reject();
    };
    imageElement.src = imagen;
    return deferred.promise;
  };

  upload.dataUrltoBlob = function (dataurl, name, origSize) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var blob = new window.Blob([u8arr], {type: mime});
    blob.name = name;
    blob.$ngfOrigSize = origSize;
    return blob;
  };

  upload.isResizeSupported = function () {
    var elem = document.createElement('canvas');
    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
  };

  if (upload.isResizeSupported()) {
    // add name getter to the blob constructor prototype
    Object.defineProperty(window.Blob.prototype, 'name', {
      get: function () {
        return this.$ngfName;
      },
      set: function (v) {
        this.$ngfName = v;
      },
      configurable: true
    });
  }

  upload.resize = function (file, options) {
    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

    var deferred = $q.defer();
    upload.dataUrl(file, true).then(function (url) {
      resize(url, options.width, options.height, options.quality, options.type || file.type,
        options.ratio, options.centerCrop, options.resizeIf)
        .then(function (dataUrl) {
          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
            try {
              dataUrl = upload.restoreExif(url, dataUrl);
            } catch (e) {
              setTimeout(function () {throw e;}, 1);
            }
          }
          try {
            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
            deferred.resolve(blob);
          } catch (e) {
            deferred.reject(e);
          }
        }, function (r) {
          if (r === 'resizeIf') {
            deferred.resolve(file);
          }
          deferred.reject(r);
        });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  return upload;
}]);

(function () {
  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
    function ($parse, $timeout, $window, Upload, $http, $q) {
      return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
        }
      };
    }]);

  ngFileUpload.directive('ngfNoFileDrop', function () {
    return function (scope, elem) {
      if (dropAvailable()) elem.css('display', 'none');
    };
  });

  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
    return function (scope, elem, attr) {
      if (dropAvailable()) {
        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
        $timeout(function () {
          model(scope);
          if (model.assign) {
            model.assign(scope, true);
          }
        });
      }
    };
  }]);

  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
    var available = dropAvailable();

    var attrGetter = function (name, scope, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    if (attrGetter('dropAvailable')) {
      $timeout(function () {
        if (scope[attrGetter('dropAvailable')]) {
          scope[attrGetter('dropAvailable')].value = available;
        } else {
          scope[attrGetter('dropAvailable')] = available;
        }
      });
    }
    if (!available) {
      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
        elem.css('display', 'none');
      }
      return;
    }

    function isDisabled() {
      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
    }

    if (attrGetter('ngfSelect') == null) {
      upload.registerModelChangeValidator(ngModel, attr, scope);
    }

    var leaveTimeout = null;
    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
    var dragOverDelay = 1;
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      // handling dragover events from the Chrome download bar
      if (navigator.userAgent.indexOf('Chrome') > -1) {
        var b = evt.dataTransfer.effectAllowed;
        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
      }
      $timeout.cancel(leaveTimeout);
      if (!actualDragOverClass) {
        actualDragOverClass = 'C';
        calculateDragOverClass(scope, attr, evt, function (clazz) {
          actualDragOverClass = clazz;
          elem.addClass(actualDragOverClass);
          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
        });
      }
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      leaveTimeout = $timeout(function () {
        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
      }, dragOverDelay || 100);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
      actualDragOverClass = null;
      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
    }, false);
    elem[0].addEventListener('paste', function (evt) {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
        attrGetter('ngfEnableFirefoxPaste', scope)) {
        evt.preventDefault();
      }
      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
    }, false);

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
      attrGetter('ngfEnableFirefoxPaste', scope)) {
      elem.attr('contenteditable', true);
      elem.on('keypress', function (e) {
        if (!e.metaKey && !e.ctrlKey) {
          e.preventDefault();
        }
      });
    }

    function extractFilesAndUpdateModel(source, evt, updateOnType) {
      if (!source) return;
      // html needs to be calculated on the same process otherwise the data will be wiped
      // after promise resolve or setTimeout.
      var html;
      try {
        html = source && source.getData && source.getData('text/html');
      } catch (e) {/* Fix IE11 that throw error calling getData */
      }
      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
        if (files.length) {
          updateModel(files, evt);
        } else {
          extractFilesFromHtml(updateOnType, html).then(function (files) {
            updateModel(files, evt);
          });
        }
      });
    }

    function updateModel(files, evt) {
      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
    }

    function extractFilesFromHtml(updateOn, html) {
      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
      var urls = [];
      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
        urls.push(src);
      });
      var promises = [], files = [];
      if (urls.length) {
        angular.forEach(urls, function (url) {
          promises.push(upload.urlToBlob(url).then(function (blob) {
            files.push(blob);
          }));
        });
        var defer = $q.defer();
        $q.all(promises).then(function () {
          defer.resolve(files);
        }, function (e) {
          defer.reject(e);
        });
        return defer.promise;
      }
      return upload.emptyPromise();
    }

    function calculateDragOverClass(scope, attr, evt, callback) {
      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
      if (angular.isString(obj)) {
        dClass = obj;
      } else if (obj) {
        if (obj.delay) dragOverDelay = obj.delay;
        if (obj.accept || obj.reject) {
          var items = evt.dataTransfer.items;
          if (items == null || !items.length) {
            dClass = obj.accept;
          } else {
            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
            var len = items.length;
            while (len--) {
              if (!upload.validatePattern(items[len], pattern)) {
                dClass = obj.reject;
                break;
              } else {
                dClass = obj.accept;
              }
            }
          }
        }
      }
      callback(dClass);
    }

    function extractFiles(items, fileList, allowDir, multiple) {
      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
      if (maxFiles == null) {
        maxFiles = Number.MAX_VALUE;
      }
      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
      if (maxTotalSize == null) {
        maxTotalSize = Number.MAX_VALUE;
      }
      var includeDir = attrGetter('ngfIncludeDir', scope);
      var files = [], totalSize = 0;

      function traverseFileTree(entry, path) {
        var defer = $q.defer();
        if (entry != null) {
          if (entry.isDirectory) {
            var promises = [upload.emptyPromise()];
            if (includeDir) {
              var file = {type: 'directory'};
              file.name = file.path = (path || '') + entry.name;
              files.push(file);
            }
            var dirReader = entry.createReader();
            var entries = [];
            var readEntries = function () {
              dirReader.readEntries(function (results) {
                try {
                  if (!results.length) {
                    angular.forEach(entries.slice(0), function (e) {
                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
                      }
                    });
                    $q.all(promises).then(function () {
                      defer.resolve();
                    }, function (e) {
                      defer.reject(e);
                    });
                  } else {
                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                    readEntries();
                  }
                } catch (e) {
                  defer.reject(e);
                }
              }, function (e) {
                defer.reject(e);
              });
            };
            readEntries();
          } else {
            entry.file(function (file) {
              try {
                file.path = (path ? path : '') + file.name;
                if (includeDir) {
                  file = upload.rename(file, file.path);
                }
                files.push(file);
                totalSize += file.size;
                defer.resolve();
              } catch (e) {
                defer.reject(e);
              }
            }, function (e) {
              defer.reject(e);
            });
          }
        }
        return defer.promise;
      }

      var promises = [upload.emptyPromise()];

      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
        for (var i = 0; i < items.length; i++) {
          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
            var entry = items[i].webkitGetAsEntry();
            if (entry.isDirectory && !allowDir) {
              continue;
            }
            if (entry != null) {
              promises.push(traverseFileTree(entry));
            }
          } else {
            var f = items[i].getAsFile();
            if (f != null) {
              files.push(f);
              totalSize += f.size;
            }
          }
          if (files.length > maxFiles || totalSize > maxTotalSize ||
            (!multiple && files.length > 0)) break;
        }
      } else {
        if (fileList != null) {
          for (var j = 0; j < fileList.length; j++) {
            var file = fileList.item(j);
            if (file.type || file.size > 0) {
              files.push(file);
              totalSize += file.size;
            }
            if (files.length > maxFiles || totalSize > maxTotalSize ||
              (!multiple && files.length > 0)) break;
          }
        }
      }

      var defer = $q.defer();
      $q.all(promises).then(function () {
        if (!multiple && !includeDir && files.length) {
          var i = 0;
          while (files[i] && files[i].type === 'directory') i++;
          defer.resolve([files[i]]);
        } else {
          defer.resolve(files);
        }
      }, function (e) {
        defer.reject(e);
      });

      return defer.promise;
    }
  }

  function dropAvailable() {
    var div = document.createElement('div');
    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
  }

})();

// customized version of https://github.com/exif-js/exif-js
ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
  var upload = UploadResize;

  upload.isExifSupported = function () {
    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
  };

  function applyTransform(ctx, orientation, width, height) {
    switch (orientation) {
      case 2:
        return ctx.transform(-1, 0, 0, 1, width, 0);
      case 3:
        return ctx.transform(-1, 0, 0, -1, width, height);
      case 4:
        return ctx.transform(1, 0, 0, -1, 0, height);
      case 5:
        return ctx.transform(0, 1, 1, 0, 0, 0);
      case 6:
        return ctx.transform(0, 1, -1, 0, height, 0);
      case 7:
        return ctx.transform(0, -1, -1, 0, height, width);
      case 8:
        return ctx.transform(0, -1, 1, 0, 0, width);
    }
  }

  upload.readOrientation = function (file) {
    var defer = $q.defer();
    var reader = new FileReader();
    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
    reader.readAsArrayBuffer(slicedFile);
    reader.onerror = function (e) {
      return defer.reject(e);
    };
    reader.onload = function (e) {
      var result = {orientation: 1};
      var view = new DataView(this.result);
      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

      var length = view.byteLength,
        offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              var orientation = view.getUint16(offset + (i * 12) + 8, little);
              if (orientation >= 2 && orientation <= 8) {
                view.setUint16(offset + (i * 12) + 8, 1, little);
                result.fixedArrayBuffer = e.target.result;
              }
              result.orientation = orientation;
              return defer.resolve(result);
            }
        } else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return defer.resolve(result);
    };
    return defer.promise;
  };

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  upload.applyExifRotation = function (file) {
    if (file.type.indexOf('image/jpeg') !== 0) {
      return upload.emptyPromise(file);
    }

    var deferred = $q.defer();
    upload.readOrientation(file).then(function (result) {
      if (result.orientation < 2 || result.orientation > 8) {
        return deferred.resolve(file);
      }
      upload.dataUrl(file, true).then(function (url) {
        var canvas = document.createElement('canvas');
        var img = document.createElement('img');

        img.onload = function () {
          try {
            canvas.width = result.orientation > 4 ? img.height : img.width;
            canvas.height = result.orientation > 4 ? img.width : img.height;
            var ctx = canvas.getContext('2d');
            applyTransform(ctx, result.orientation, img.width, img.height);
            ctx.drawImage(img, 0, 0);
            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
            var blob = upload.dataUrltoBlob(dataUrl, file.name);
            deferred.resolve(blob);
          } catch (e) {
            return deferred.reject(e);
          }
        };
        img.onerror = function () {
          deferred.reject();
        };
        img.src = url;
      }, function (e) {
        deferred.reject(e);
      });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  upload.restoreExif = function (orig, resized) {
    var ExifRestorer = {};

    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
      'QRSTUVWXYZabcdef' +
      'ghijklmnopqrstuv' +
      'wxyz0123456789+/' +
      '=';

    ExifRestorer.encode64 = function (input) {
      var output = '',
        chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0;

      do {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output +
          this.KEY_STR.charAt(enc1) +
          this.KEY_STR.charAt(enc2) +
          this.KEY_STR.charAt(enc3) +
          this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    };

    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
      if (origFileBase64.match('data:image/jpeg;base64,')) {
        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
      }

      var rawImage = this.decode64(origFileBase64);
      var segments = this.slice2Segments(rawImage);

      var image = this.exifManipulation(resizedFileBase64, segments);

      return 'data:image/jpeg;base64,' + this.encode64(image);
    };


    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments),
        newImageArray = this.insertExif(resizedFileBase64, exifArray);
      return new Uint8Array(newImageArray);
    };


    ExifRestorer.getExifArray = function (segments) {
      var seg;
      for (var x = 0; x < segments.length; x++) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
        {
          return seg;
        }
      }
      return [];
    };


    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
        buf = this.decode64(imageData),
        separatePoint = buf.indexOf(255, 3),
        mae = buf.slice(0, separatePoint),
        ato = buf.slice(separatePoint),
        array = mae;

      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    };


    ExifRestorer.slice2Segments = function (rawImageArray) {
      var head = 0,
        segments = [];

      while (1) {
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        }
        else {
          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
            endPoint = head + length + 2,
            seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }

      return segments;
    };


    ExifRestorer.decode64 = function (input) {
      var chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0,
        buf = [];

      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.log('There were invalid base64 characters in the input text.\n' +
          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
          'Expect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        buf.push(chr1);

        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';

      } while (i < input.length);

      return buf;
    };

    return ExifRestorer.restore(orig, resized);  //<= EXIF
  };

  return upload;
}]);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(14)))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(653);
var stringify = __webpack_require__(654);
var RavenConfigError = __webpack_require__(655);

var utils = __webpack_require__(166);
var isError = utils.isError;
var isObject = utils.isObject;
var isErrorEvent = utils.isErrorEvent;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;

var wrapConsoleMethod = __webpack_require__(656).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    maxMessageLength: 0,

    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1
  };
  this._fetchDefaults = {
    method: 'POST',
    keepalive: true,
    referrerPolicy: 'origin'
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.22.3',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = undefined;
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});
    // Cases for sending ex as a message, rather than an exception
    var isNotError = !isError(ex);
    var isNotErrorEvent = !isErrorEvent(ex);
    var isErrorEventWithoutError = isErrorEvent(ex) && !ex.error;

    if ((isNotError && isNotErrorEvent) || isErrorEventWithoutError) {
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Get actual Error from ErrorEvent
    if (isErrorEvent(ex)) ex = ex.error;

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};

    var data = objectMerge(
      {
        message: msg + '' // Make sure it's actually a string
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];
    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
      options = objectMerge(
        {
          // fingerprint on msg, not stack trace (legacy behavior, could be
          // revisited)
          fingerprint: msg,
          // since we know this is a synthetic trace, the top N-most frames
          // MUST be from Raven.js, so mark them as in_app later by setting
          // trimHeadFrames
          trimHeadFrames: (options.trimHeadFrames || 0) + 1
        },
        options
      );

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = options || {};

    var lastEventId = options.eventId || this.lastEventId();
    if (!lastEventId) {
      throw new RavenConfigError('Missing eventId');
    }

    var dsn = options.dsn || this._dsn;
    if (!dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var qs = '';
    qs += '?eventId=' + encode(lastEventId);
    qs += '&dsn=' + encode(dsn);

    var user = options.user || this._globalContext.user;
    if (user) {
      if (user.name) qs += '&name=' + encode(user.name);
      if (user.email) qs += '&email=' + encode(user.email);
    }

    var globalServer = this._getGlobalServer(this._parseDSN(dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/' + qs;
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(fn, undefined, before),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(self.wrap(cb));
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(orig, undefined, onreadystatechangeHandler);
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch.apply(this, args).then(function(response) {
              fetchData.status_code = response.status;

              self.captureBreadcrumb({
                type: 'http',
                category: 'fetch',
                data: fetchData
              });

              return response;
            });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      history.pushState &&
      history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function() {
    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo.apply(this, arguments);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        culprit: fileurl
      },
      options
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.culprit !== last.culprit // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    if (this._originalConsoleMethods[level] && this.debug) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(166);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';

  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
     * Add a crash handler.
     * @param {Function} handler
     */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
     * Remove a crash handler.
     * @param {Function} handler
     */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
     * Remove all crash handlers.
     */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} msg Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
      gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
      winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
      // Used to additionally parse URL/line/column from eval frames
      geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
      chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,
      lines = ex.stack.split('\n'),
      stack = [],
      submatch,
      parts,
      element,
      reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 654 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 655 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(166);

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Selection save and restore module for Rangy.
 * Saves and restores user selections using marker invisible elements in the DOM.
 *
 * Part of Rangy, a cross-browser JavaScript range and selection library
 * https://github.com/timdown/rangy
 *
 * Depends on Rangy core.
 *
 * Copyright 2015, Tim Down
 * Licensed under the MIT license.
 * Version: 1.3.0
 * Build date: 10 May 2015
 */
(function(factory, root) {
    if (true) {
        // AMD. Register as an anonymous module with a dependency on Rangy.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(379)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module != "undefined" && typeof exports == "object") {
        // Node/CommonJS style
        module.exports = factory( require("rangy") );
    } else {
        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
        factory(root.rangy);
    }
})(function(rangy) {
    rangy.createModule("SaveRestore", ["WrappedRange"], function(api, module) {
        var dom = api.dom;
        var removeNode = dom.removeNode;
        var isDirectionBackward = api.Selection.isDirectionBackward;
        var markerTextChar = "\ufeff";

        function gEBI(id, doc) {
            return (doc || document).getElementById(id);
        }

        function insertRangeBoundaryMarker(range, atStart) {
            var markerId = "selectionBoundary_" + (+new Date()) + "_" + ("" + Math.random()).slice(2);
            var markerEl;
            var doc = dom.getDocument(range.startContainer);

            // Clone the Range and collapse to the appropriate boundary point
            var boundaryRange = range.cloneRange();
            boundaryRange.collapse(atStart);

            // Create the marker element containing a single invisible character using DOM methods and insert it
            markerEl = doc.createElement("span");
            markerEl.id = markerId;
            markerEl.style.lineHeight = "0";
            markerEl.style.display = "none";
            markerEl.className = "rangySelectionBoundary";
            markerEl.appendChild(doc.createTextNode(markerTextChar));

            boundaryRange.insertNode(markerEl);
            return markerEl;
        }

        function setRangeBoundary(doc, range, markerId, atStart) {
            var markerEl = gEBI(markerId, doc);
            if (markerEl) {
                range[atStart ? "setStartBefore" : "setEndBefore"](markerEl);
                removeNode(markerEl);
            } else {
                module.warn("Marker element has been removed. Cannot restore selection.");
            }
        }

        function compareRanges(r1, r2) {
            return r2.compareBoundaryPoints(r1.START_TO_START, r1);
        }

        function saveRange(range, direction) {
            var startEl, endEl, doc = api.DomRange.getRangeDocument(range), text = range.toString();
            var backward = isDirectionBackward(direction);

            if (range.collapsed) {
                endEl = insertRangeBoundaryMarker(range, false);
                return {
                    document: doc,
                    markerId: endEl.id,
                    collapsed: true
                };
            } else {
                endEl = insertRangeBoundaryMarker(range, false);
                startEl = insertRangeBoundaryMarker(range, true);

                return {
                    document: doc,
                    startMarkerId: startEl.id,
                    endMarkerId: endEl.id,
                    collapsed: false,
                    backward: backward,
                    toString: function() {
                        return "original text: '" + text + "', new text: '" + range.toString() + "'";
                    }
                };
            }
        }

        function restoreRange(rangeInfo, normalize) {
            var doc = rangeInfo.document;
            if (typeof normalize == "undefined") {
                normalize = true;
            }
            var range = api.createRange(doc);
            if (rangeInfo.collapsed) {
                var markerEl = gEBI(rangeInfo.markerId, doc);
                if (markerEl) {
                    markerEl.style.display = "inline";
                    var previousNode = markerEl.previousSibling;

                    // Workaround for issue 17
                    if (previousNode && previousNode.nodeType == 3) {
                        removeNode(markerEl);
                        range.collapseToPoint(previousNode, previousNode.length);
                    } else {
                        range.collapseBefore(markerEl);
                        removeNode(markerEl);
                    }
                } else {
                    module.warn("Marker element has been removed. Cannot restore selection.");
                }
            } else {
                setRangeBoundary(doc, range, rangeInfo.startMarkerId, true);
                setRangeBoundary(doc, range, rangeInfo.endMarkerId, false);
            }

            if (normalize) {
                range.normalizeBoundaries();
            }

            return range;
        }

        function saveRanges(ranges, direction) {
            var rangeInfos = [], range, doc;
            var backward = isDirectionBackward(direction);

            // Order the ranges by position within the DOM, latest first, cloning the array to leave the original untouched
            ranges = ranges.slice(0);
            ranges.sort(compareRanges);

            for (var i = 0, len = ranges.length; i < len; ++i) {
                rangeInfos[i] = saveRange(ranges[i], backward);
            }

            // Now that all the markers are in place and DOM manipulation over, adjust each range's boundaries to lie
            // between its markers
            for (i = len - 1; i >= 0; --i) {
                range = ranges[i];
                doc = api.DomRange.getRangeDocument(range);
                if (range.collapsed) {
                    range.collapseAfter(gEBI(rangeInfos[i].markerId, doc));
                } else {
                    range.setEndBefore(gEBI(rangeInfos[i].endMarkerId, doc));
                    range.setStartAfter(gEBI(rangeInfos[i].startMarkerId, doc));
                }
            }

            return rangeInfos;
        }

        function saveSelection(win) {
            if (!api.isSelectionValid(win)) {
                module.warn("Cannot save selection. This usually happens when the selection is collapsed and the selection document has lost focus.");
                return null;
            }
            var sel = api.getSelection(win);
            var ranges = sel.getAllRanges();
            var backward = (ranges.length == 1 && sel.isBackward());

            var rangeInfos = saveRanges(ranges, backward);

            // Ensure current selection is unaffected
            if (backward) {
                sel.setSingleRange(ranges[0], backward);
            } else {
                sel.setRanges(ranges);
            }

            return {
                win: win,
                rangeInfos: rangeInfos,
                restored: false
            };
        }

        function restoreRanges(rangeInfos) {
            var ranges = [];

            // Ranges are in reverse order of appearance in the DOM. We want to restore earliest first to avoid
            // normalization affecting previously restored ranges.
            var rangeCount = rangeInfos.length;

            for (var i = rangeCount - 1; i >= 0; i--) {
                ranges[i] = restoreRange(rangeInfos[i], true);
            }

            return ranges;
        }

        function restoreSelection(savedSelection, preserveDirection) {
            if (!savedSelection.restored) {
                var rangeInfos = savedSelection.rangeInfos;
                var sel = api.getSelection(savedSelection.win);
                var ranges = restoreRanges(rangeInfos), rangeCount = rangeInfos.length;

                if (rangeCount == 1 && preserveDirection && api.features.selectionHasExtend && rangeInfos[0].backward) {
                    sel.removeAllRanges();
                    sel.addRange(ranges[0], true);
                } else {
                    sel.setRanges(ranges);
                }

                savedSelection.restored = true;
            }
        }

        function removeMarkerElement(doc, markerId) {
            var markerEl = gEBI(markerId, doc);
            if (markerEl) {
                removeNode(markerEl);
            }
        }

        function removeMarkers(savedSelection) {
            var rangeInfos = savedSelection.rangeInfos;
            for (var i = 0, len = rangeInfos.length, rangeInfo; i < len; ++i) {
                rangeInfo = rangeInfos[i];
                if (rangeInfo.collapsed) {
                    removeMarkerElement(savedSelection.doc, rangeInfo.markerId);
                } else {
                    removeMarkerElement(savedSelection.doc, rangeInfo.startMarkerId);
                    removeMarkerElement(savedSelection.doc, rangeInfo.endMarkerId);
                }
            }
        }

        api.util.extend(api, {
            saveRange: saveRange,
            restoreRange: restoreRange,
            saveRanges: saveRanges,
            restoreRanges: restoreRanges,
            saveSelection: saveSelection,
            restoreSelection: restoreSelection,
            removeMarkerElement: removeMarkerElement,
            removeMarkers: removeMarkers
        });
    });
    
    return rangy;
}, this);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('mentio', [])
    .directive('mentio', ['mentioUtil', '$document', '$compile', '$log', '$timeout',
        function (mentioUtil, $document, $compile, $log, $timeout) {
        return {
            restrict: 'A',
            scope: {
                macros: '=mentioMacros',
                search: '&mentioSearch',
                select: '&mentioSelect',
                items: '=mentioItems',
                typedTerm: '=mentioTypedTerm',
                altId: '=mentioId',
                iframeElement: '=mentioIframeElement',
                requireLeadingSpace: '=mentioRequireLeadingSpace',
                selectNotFound: '=mentioSelectNotFound',
                trimTerm: '=mentioTrimTerm',
                ngModel: '='
            },
            controller: ["$scope", "$timeout", "$attrs", function($scope, $timeout, $attrs) {

                $scope.query = function (triggerChar, triggerText) {
                    var remoteScope = $scope.triggerCharMap[triggerChar];

                    if ($scope.trimTerm === undefined || $scope.trimTerm) {
                        triggerText = triggerText.trim();
                    }

                    remoteScope.showMenu();

                    remoteScope.search({
                        term: triggerText
                    });

                    remoteScope.typedTerm = triggerText;
                };

                $scope.defaultSearch = function(locals) {
                    var results = [];
                    angular.forEach($scope.items, function(item) {
                        if (item.label.toUpperCase().indexOf(locals.term.toUpperCase()) >= 0) {
                            results.push(item);
                        }
                    });
                    $scope.localItems = results;
                };

                $scope.bridgeSearch = function(termString) {
                    var searchFn = $attrs.mentioSearch ? $scope.search : $scope.defaultSearch;
                    searchFn({
                        term: termString
                    });
                };

                $scope.defaultSelect = function(locals) {
                    return $scope.defaultTriggerChar + locals.item.label;
                };

                $scope.bridgeSelect = function(itemVar) {
                    var selectFn = $attrs.mentioSelect ? $scope.select : $scope.defaultSelect;
                    return selectFn({
                        item: itemVar
                    });
                };

                $scope.setTriggerText = function(text) {
                    if ($scope.syncTriggerText) {
                        $scope.typedTerm = ($scope.trimTerm === undefined || $scope.trimTerm) ? text.trim() : text;
                    }
                };

                $scope.context = function() {
                    if ($scope.iframeElement) {
                        return {iframe: $scope.iframeElement};
                    }
                };

                $scope.replaceText = function (text, hasTrailingSpace) {
                    $scope.hideAll();

                    mentioUtil.replaceTriggerText($scope.context(), $scope.targetElement, $scope.targetElementPath,
                        $scope.targetElementSelectedOffset, $scope.triggerCharSet, text, $scope.requireLeadingSpace,
                        hasTrailingSpace);

                    if (!hasTrailingSpace) {
                        $scope.setTriggerText('');
                        angular.element($scope.targetElement).triggerHandler('change');
                        if ($scope.isContentEditable()) {
                            $scope.contentEditableMenuPasted = true;
                            var timer = $timeout(function() {
                                $scope.contentEditableMenuPasted = false;
                            }, 200);
                            $scope.$on('$destroy', function() {
                                $timeout.cancel(timer);
                            });
                        }
                    }
                };

                $scope.hideAll = function () {
                    for (var key in $scope.triggerCharMap) {
                        if ($scope.triggerCharMap.hasOwnProperty(key)) {
                            $scope.triggerCharMap[key].hideMenu();
                        }
                    }
                };

                $scope.getActiveMenuScope = function () {
                    for (var key in $scope.triggerCharMap) {
                        if ($scope.triggerCharMap.hasOwnProperty(key)) {
                            if ($scope.triggerCharMap[key].visible) {
                                return $scope.triggerCharMap[key];
                            }
                        }
                    }
                    return null;
                };

                $scope.selectActive = function () {
                    for (var key in $scope.triggerCharMap) {
                        if ($scope.triggerCharMap.hasOwnProperty(key)) {
                            if ($scope.triggerCharMap[key].visible) {
                                $scope.triggerCharMap[key].selectActive();
                            }
                        }
                    }
                };

                $scope.isActive = function () {
                    for (var key in $scope.triggerCharMap) {
                        if ($scope.triggerCharMap.hasOwnProperty(key)) {
                            if ($scope.triggerCharMap[key].visible) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

                $scope.isContentEditable = function() {
                    return ($scope.targetElement.nodeName !== 'INPUT' && $scope.targetElement.nodeName !== 'TEXTAREA');
                };

                $scope.replaceMacro = function(macro, hasTrailingSpace) {
                    if (!hasTrailingSpace) {
                        $scope.replacingMacro = true;
                        $scope.timer = $timeout(function() {
                            mentioUtil.replaceMacroText($scope.context(), $scope.targetElement,
                                $scope.targetElementPath, $scope.targetElementSelectedOffset,
                                $scope.macros, $scope.macros[macro]);
                            angular.element($scope.targetElement).triggerHandler('change');
                            $scope.replacingMacro = false;
                        }, 300);
                        $scope.$on('$destroy', function() {
                            $timeout.cancel($scope.timer);
                        });
                    } else {
                        mentioUtil.replaceMacroText($scope.context(), $scope.targetElement, $scope.targetElementPath,
                            $scope.targetElementSelectedOffset, $scope.macros, $scope.macros[macro]);
                    }
                };

                $scope.addMenu = function(menuScope) {
                    if (menuScope.parentScope && $scope.triggerCharMap.hasOwnProperty(menuScope.triggerChar)) {
                        return;
                    }
                    $scope.triggerCharMap[menuScope.triggerChar] = menuScope;
                    if ($scope.triggerCharSet === undefined) {
                        $scope.triggerCharSet = [];
                    }
                    $scope.triggerCharSet.push(menuScope.triggerChar);
                    menuScope.setParent($scope);
                };

                $scope.$on(
                    'menuCreated', function (event, data) {
                        if (
                            $attrs.id !== undefined ||
                            $attrs.mentioId !== undefined
                        )
                        {
                            if (
                                $attrs.id === data.targetElement ||
                                (
                                    $attrs.mentioId !== undefined &&
                                    $scope.altId === data.targetElement
                                )
                            )
                            {
                                $scope.addMenu(data.scope);
                            }
                        }
                    }
                );

                $document.on(
                    'click', function () {
                        if ($scope.isActive()) {
                            $scope.$apply(function () {
                                $scope.hideAll();
                            });
                        }
                    }
                );

                $document.on(
                    'keydown keypress paste', function (event) {
                        var activeMenuScope = $scope.getActiveMenuScope();
                        if (activeMenuScope) {
                            if (event.which === 9 || event.which === 13) {
                                event.preventDefault();
                                activeMenuScope.selectActive();
                            }

                            if (event.which === 27) {
                                event.preventDefault();
                                activeMenuScope.$apply(function () {
                                    activeMenuScope.hideMenu();
                                });
                            }

                            if (event.which === 40) {
                                event.preventDefault();
                                activeMenuScope.$apply(function () {
                                    activeMenuScope.activateNextItem();
                                });
                                activeMenuScope.adjustScroll(1);
                            }

                            if (event.which === 38) {
                                event.preventDefault();
                                activeMenuScope.$apply(function () {
                                    activeMenuScope.activatePreviousItem();
                                });
                                activeMenuScope.adjustScroll(-1);
                            }

                            if (event.which === 37 || event.which === 39) {
                                event.preventDefault();
                             }
                        }
                    }
                );
            }],
            link: function (scope, element, attrs) {
                scope.triggerCharMap = {};

                scope.targetElement = element;
                attrs.$set('autocomplete','off');

                if (attrs.mentioItems) {
                    scope.localItems = [];
                    scope.parentScope = scope;
                    var itemsRef = attrs.mentioSearch ? ' mentio-items="items"' : ' mentio-items="localItems"';

                    scope.defaultTriggerChar = attrs.mentioTriggerChar ? scope.$eval(attrs.mentioTriggerChar) : '@';

                    var html = '<mentio-menu' +
                        ' mentio-search="bridgeSearch(term)"' +
                        ' mentio-select="bridgeSelect(item)"' +
                        itemsRef;

                    if (attrs.mentioTemplateUrl) {
                        html = html + ' mentio-template-url="' + attrs.mentioTemplateUrl + '"';
                    }
                    html = html + ' mentio-trigger-char="\'' + scope.defaultTriggerChar + '\'"' +
                        ' mentio-parent-scope="parentScope"' +
                        '/>';
                    var linkFn = $compile(html);
                    var el = linkFn(scope);

                    element.parent().append(el);

                    scope.$on('$destroy', function() {
                      el.remove();
                    });
                }

                if (attrs.mentioTypedTerm) {
                    scope.syncTriggerText = true;
                }

                function keyHandler(event) {
                    function stopEvent(event) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                    var activeMenuScope = scope.getActiveMenuScope();
                    if (activeMenuScope) {
                        if (event.which === 9 || event.which === 13) {
                            stopEvent(event);
                            activeMenuScope.selectActive();
                            return false;
                        }

                        if (event.which === 27) {
                            stopEvent(event);
                            activeMenuScope.$apply(function () {
                                activeMenuScope.hideMenu();
                            });
                            return false;
                        }

                        if (event.which === 40) {
                            stopEvent(event);
                            activeMenuScope.$apply(function () {
                                activeMenuScope.activateNextItem();
                            });
                            activeMenuScope.adjustScroll(1);
                            return false;
                        }

                        if (event.which === 38) {
                            stopEvent(event);
                            activeMenuScope.$apply(function () {
                                activeMenuScope.activatePreviousItem();
                            });
                            activeMenuScope.adjustScroll(-1);
                            return false;
                        }

                        if (event.which === 37 || event.which === 39) {
                            stopEvent(event);
                            return false;
                        }
                    }
                }

                scope.$watch(
                    'iframeElement', function(newValue) {
                        if (newValue) {
                            var iframeDocument = newValue.contentWindow.document;
                            iframeDocument.addEventListener('click',
                                function () {
                                    if (scope.isActive()) {
                                        scope.$apply(function () {
                                            scope.hideAll();
                                        });
                                    }
                                }
                            );


                            iframeDocument.addEventListener('keydown', keyHandler, true /*capture*/);

                            scope.$on ( '$destroy', function() {
                                iframeDocument.removeEventListener ( 'keydown', keyHandler );
                            });
                        }
                    }
                );

                scope.$watch(
                    'ngModel',
                    function (newValue) {
                        /*jshint maxcomplexity:14 */
                        /*jshint maxstatements:39 */
                        // yes this function needs refactoring
                        if ((!newValue || newValue === '') && !scope.isActive()) {
                            // ignore while setting up
                            return;
                        }
                        if (scope.triggerCharSet === undefined) {
                            $log.error('Error, no mentio-items attribute was provided, ' +
                                'and no separate mentio-menus were specified.  Nothing to do.');
                            return;
                        }

                        if (scope.contentEditableMenuPasted) {
                            // don't respond to changes from insertion of the menu content
                            scope.contentEditableMenuPasted = false;
                            return;
                        }

                        if (scope.replacingMacro) {
                            $timeout.cancel(scope.timer);
                            scope.replacingMacro = false;
                        }

                        var isActive = scope.isActive();
                        var isContentEditable = scope.isContentEditable();

                        var mentionInfo = mentioUtil.getTriggerInfo(scope.context(), scope.triggerCharSet,
                            scope.requireLeadingSpace, isActive);

                        if (mentionInfo !== undefined &&
                                (
                                    !isActive ||
                                    (isActive &&
                                        (
                                            /* content editable selection changes to local nodes which
                                            modifies the start position of the selection over time,
                                            just consider triggerchar changes which
                                            will have the odd effect that deleting a trigger char pops
                                            the menu for a previous
                                            trigger char sequence if one exists in a content editable */
                                            (isContentEditable && mentionInfo.mentionTriggerChar ===
                                                scope.currentMentionTriggerChar) ||
                                            (!isContentEditable && mentionInfo.mentionPosition ===
                                                scope.currentMentionPosition)
                                        )
                                    )
                                )
                            )
                        {
                            /** save selection info about the target control for later re-selection */
                            if (mentionInfo.mentionSelectedElement) {
                                scope.targetElement = mentionInfo.mentionSelectedElement;
                                scope.targetElementPath = mentionInfo.mentionSelectedPath;
                                scope.targetElementSelectedOffset = mentionInfo.mentionSelectedOffset;
                            }

                            /* publish to external ngModel */
                            scope.setTriggerText(mentionInfo.mentionText);
                            /* remember current position */
                            scope.currentMentionPosition = mentionInfo.mentionPosition;
                            scope.currentMentionTriggerChar = mentionInfo.mentionTriggerChar;
                            /* perform query */
                            scope.query(mentionInfo.mentionTriggerChar, mentionInfo.mentionText);
                        } else {
                            var currentTypedTerm = scope.typedTerm;
                            scope.setTriggerText('');
                            scope.hideAll();

                            var macroMatchInfo = mentioUtil.getMacroMatch(scope.context(), scope.macros);

                            if (macroMatchInfo !== undefined) {
                                scope.targetElement = macroMatchInfo.macroSelectedElement;
                                scope.targetElementPath = macroMatchInfo.macroSelectedPath;
                                scope.targetElementSelectedOffset = macroMatchInfo.macroSelectedOffset;
                                scope.replaceMacro(macroMatchInfo.macroText, macroMatchInfo.macroHasTrailingSpace);
                            } else if (scope.selectNotFound && currentTypedTerm && currentTypedTerm !== '') {
                                var lastScope = scope.triggerCharMap[scope.currentMentionTriggerChar];
                                if (lastScope) {
                                    // just came out of typeahead state
                                    var text = lastScope.select({
                                        item: {label: currentTypedTerm}
                                    });
                                    if (typeof text.then === 'function') {
                                        /* text is a promise, at least our best guess */
                                        text.then(scope.replaceText);
                                    } else {
                                        scope.replaceText(text, true);
                                    }
                                }
                            }
                        }
                    }
                );
            }
        };
    }])

    .directive('mentioMenu', ['mentioUtil', '$rootScope', '$log', '$window', '$document',
        function (mentioUtil, $rootScope, $log, $window, $document) {
        return {
            restrict: 'E',
            scope: {
                search: '&mentioSearch',
                select: '&mentioSelect',
                items: '=mentioItems',
                triggerChar: '=mentioTriggerChar',
                forElem: '=mentioFor',
                parentScope: '=mentioParentScope'
            },
            templateUrl: function(tElement, tAttrs) {
                return tAttrs.mentioTemplateUrl !== undefined ? tAttrs.mentioTemplateUrl : 'mentio-menu.tpl.html';
            },
            controller: ["$scope", function ($scope) {
                $scope.visible = false;

                // callable both with controller (menuItem) and without controller (local)
                this.activate = $scope.activate = function (item) {
                    $scope.activeItem = item;
                };

                // callable both with controller (menuItem) and without controller (local)
                this.isActive = $scope.isActive = function (item) {
                    return $scope.activeItem === item;
                };

                // callable both with controller (menuItem) and without controller (local)
                this.selectItem = $scope.selectItem = function (item) {
                    var text = $scope.select({
                        item: item
                    });
                    if (typeof text.then === 'function') {
                        /* text is a promise, at least our best guess */
                        text.then($scope.parentMentio.replaceText);
                    } else {
                        $scope.parentMentio.replaceText(text);
                    }
                };

                $scope.activateNextItem = function () {
                    var index = $scope.items.indexOf($scope.activeItem);
                    this.activate($scope.items[(index + 1) % $scope.items.length]);
                };

                $scope.activatePreviousItem = function () {
                    var index = $scope.items.indexOf($scope.activeItem);
                    this.activate($scope.items[index === 0 ? $scope.items.length - 1 : index - 1]);
                };

                $scope.isFirstItemActive = function () {
                    var index = $scope.items.indexOf($scope.activeItem);

                    return index === 0;
                };

                $scope.isLastItemActive = function () {
                    var index = $scope.items.indexOf($scope.activeItem);

                    return index === ($scope.items.length - 1);
                };

                $scope.selectActive = function () {
                    $scope.selectItem($scope.activeItem);
                };

                $scope.isVisible = function () {
                    return $scope.visible;
                };

                $scope.showMenu = function () {
                    if (!$scope.visible) {
                        $scope.requestVisiblePendingSearch = true;
                    }
                };

                $scope.setParent = function (scope) {
                    $scope.parentMentio = scope;
                    $scope.targetElement = scope.targetElement;
                };
            }],

            link: function (scope, element) {
                element[0].parentNode.removeChild(element[0]);
                $document[0].body.appendChild(element[0]);
                scope.menuElement = element; // for testing

                if (scope.parentScope) {
                    scope.parentScope.addMenu(scope);
                } else {
                    if (!scope.forElem) {
                        $log.error('mentio-menu requires a target element in tbe mentio-for attribute');
                        return;
                    }
                    if (!scope.triggerChar) {
                        $log.error('mentio-menu requires a trigger char');
                        return;
                    }
                    // send own scope to mentio directive so that the menu
                    // becomes attached
                    $rootScope.$broadcast('menuCreated',
                        {
                            targetElement : scope.forElem,
                            scope : scope
                        });
                }

                angular.element($window).bind(
                    'resize', function () {
                        if (scope.isVisible()) {
                            var triggerCharSet = [];
                            triggerCharSet.push(scope.triggerChar);
                            mentioUtil.popUnderMention(scope.parentMentio.context(),
                                triggerCharSet, element, scope.requireLeadingSpace);
                        }
                    }
                );

                scope.$watch('items', function (items) {
                    if (items && items.length > 0) {
                        scope.activate(items[0]);
                        if (!scope.visible && scope.requestVisiblePendingSearch) {
                            scope.visible = true;
                            scope.requestVisiblePendingSearch = false;
                        }
                    } else {
                        scope.hideMenu();
                    }
                });

                scope.$watch('isVisible()', function (visible) {
                    // wait for the watch notification to show the menu
                    if (visible) {
                        var triggerCharSet = [];
                        triggerCharSet.push(scope.triggerChar);
                        mentioUtil.popUnderMention(scope.parentMentio.context(),
                            triggerCharSet, element, scope.requireLeadingSpace);
                    }
                });

                scope.parentMentio.$on('$destroy', function () {
                    element.remove();
                });

                scope.hideMenu = function () {
                    scope.visible = false;
                    element.css('display', 'none');
                };

                scope.adjustScroll = function (direction) {
                    var menuEl = element[0];
                    var menuItemsList = menuEl.querySelector('ul');
                    var menuItem = menuEl.querySelector('[mentio-menu-item].active');

                    if (scope.isFirstItemActive()) {
                        return menuItemsList.scrollTop = 0;
                    } else if(scope.isLastItemActive()) {
                        return menuItemsList.scrollTop = menuItemsList.scrollHeight;
                    }

                    if (direction === 1) {
                        menuItemsList.scrollTop += menuItem.offsetHeight;
                    } else {
                        menuItemsList.scrollTop -= menuItem.offsetHeight;
                    }
                };

            }
        };
    }])

    .directive('mentioMenuItem', function () {
        return {
            restrict: 'A',
            scope: {
                item: '=mentioMenuItem'
            },
            require: '^mentioMenu',
            link: function (scope, element, attrs, controller) {

                scope.$watch(function () {
                    return controller.isActive(scope.item);
                }, function (active) {
                    if (active) {
                        element.addClass('active');
                    } else {
                        element.removeClass('active');
                    }
                });

                element.bind('mouseenter', function () {
                    scope.$apply(function () {
                        controller.activate(scope.item);
                    });
                });

                element.bind('click', function () {
                    controller.selectItem(scope.item);
                    return false;
                });
            }
        };
    })
    .filter('unsafe', ["$sce", function($sce) {
        return function (val) {
            return $sce.trustAsHtml(val);
        };
    }])
    .filter('mentioHighlight', function() {
        function escapeRegexp (queryToEscape) {
            return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
        }

        return function (matchItem, query, hightlightClass) {
            if (query) {
                var replaceText = hightlightClass ?
                                 '<span class="' + hightlightClass + '">$&</span>' :
                                 '<strong>$&</strong>';
                return ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), replaceText);
            } else {
                return matchItem;
            }
        };
    });

'use strict';

angular.module('mentio')
    .factory('mentioUtil', ["$window", "$location", "$anchorScroll", "$timeout", function ($window, $location, $anchorScroll, $timeout) {

        // public
        function popUnderMention (ctx, triggerCharSet, selectionEl, requireLeadingSpace) {
            var coordinates;
            var mentionInfo = getTriggerInfo(ctx, triggerCharSet, requireLeadingSpace, false);

            if (mentionInfo !== undefined) {

                if (selectedElementIsTextAreaOrInput(ctx)) {
                    coordinates = getTextAreaOrInputUnderlinePosition(ctx, getDocument(ctx).activeElement,
                        mentionInfo.mentionPosition);
                } else {
                    coordinates = getContentEditableCaretPosition(ctx, mentionInfo.mentionPosition);
                }

                // Move the button into place.
                selectionEl.css({
                    top: coordinates.top + 'px',
                    left: coordinates.left + 'px',
                    position: 'absolute',
                    zIndex: 100,
                    display: 'block'
                });

                $timeout(function(){
                    scrollIntoView(ctx, selectionEl);
                },0);
            } else {
                selectionEl.css({
                    display: 'none'
                });
            }
        }

        function scrollIntoView(ctx, elem)
        {
            // cheap hack in px - need to check styles relative to the element
            var reasonableBuffer = 20;
            var maxScrollDisplacement = 100;
            var clientRect;
            var e = elem[0];
            while (clientRect === undefined || clientRect.height === 0) {
                clientRect = e.getBoundingClientRect();
                if (clientRect.height === 0) {
                    e = e.childNodes[0];
                    if (e === undefined || !e.getBoundingClientRect) {
                        return;
                    }
                }
            }
            var elemTop = clientRect.top;
            var elemBottom = elemTop + clientRect.height;
            if(elemTop < 0) {
                $window.scrollTo(0, $window.pageYOffset + clientRect.top - reasonableBuffer);
            } else if (elemBottom > $window.innerHeight) {
                var maxY = $window.pageYOffset + clientRect.top - reasonableBuffer;
                if (maxY - $window.pageYOffset > maxScrollDisplacement) {
                    maxY = $window.pageYOffset + maxScrollDisplacement;
                }
                var targetY = $window.pageYOffset - ($window.innerHeight - elemBottom);
                if (targetY > maxY) {
                    targetY = maxY;
                }
                $window.scrollTo(0, targetY);
            }
        }

        function selectedElementIsTextAreaOrInput (ctx) {
            var element = getDocument(ctx).activeElement;
            if (element !== null) {
                var nodeName = element.nodeName;
                var type = element.getAttribute('type');
                return (nodeName === 'INPUT' && type === 'text') || nodeName === 'TEXTAREA';
            }
            return false;
        }

        function selectElement (ctx, targetElement, path, offset) {
            var range;
            var elem = targetElement;
            if (path) {
                for (var i = 0; i < path.length; i++) {
                    elem = elem.childNodes[path[i]];
                    if (elem === undefined) {
                        return;
                    }
                    while (elem.length < offset) {
                        offset -= elem.length;
                        elem = elem.nextSibling;
                    }
                    if (elem.childNodes.length === 0 && !elem.length) {
                        elem = elem.previousSibling;
                    }
                }
            }
            var sel = getWindowSelection(ctx);

            range = getDocument(ctx).createRange();
            range.setStart(elem, offset);
            range.setEnd(elem, offset);
            range.collapse(true);
            try{sel.removeAllRanges();}catch(error){}
            sel.addRange(range);
            targetElement.focus();
        }

        function pasteHtml (ctx, html, startPos, endPos) {
            var range, sel;
            sel = getWindowSelection(ctx);
            range = getDocument(ctx).createRange();
            range.setStart(sel.anchorNode, startPos);
            range.setEnd(sel.anchorNode, endPos);
            range.deleteContents();

            var el = getDocument(ctx).createElement('div');
            el.innerHTML = html;
            var frag = getDocument(ctx).createDocumentFragment(),
                node, lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }

        function resetSelection (ctx, targetElement, path, offset) {
            var nodeName = targetElement.nodeName;
            if (nodeName === 'INPUT' || nodeName === 'TEXTAREA') {
                if (targetElement !== getDocument(ctx).activeElement) {
                    targetElement.focus();
                }
            } else {
                selectElement(ctx, targetElement, path, offset);
            }
        }

        // public
        function replaceMacroText (ctx, targetElement, path, offset, macros, text) {
            resetSelection(ctx, targetElement, path, offset);

            var macroMatchInfo = getMacroMatch(ctx, macros);

            if (macroMatchInfo.macroHasTrailingSpace) {
                macroMatchInfo.macroText = macroMatchInfo.macroText + '\xA0';
                text = text + '\xA0';
            }

            if (macroMatchInfo !== undefined) {
                var element = getDocument(ctx).activeElement;
                if (selectedElementIsTextAreaOrInput(ctx)) {
                    var startPos = macroMatchInfo.macroPosition;
                    var endPos = macroMatchInfo.macroPosition + macroMatchInfo.macroText.length;
                    element.value = element.value.substring(0, startPos) + text +
                        element.value.substring(endPos, element.value.length);
                    element.selectionStart = startPos + text.length;
                    element.selectionEnd = startPos + text.length;
                } else {
                    pasteHtml(ctx, text, macroMatchInfo.macroPosition,
                            macroMatchInfo.macroPosition + macroMatchInfo.macroText.length);
                }
            }
        }

        // public
        function replaceTriggerText (ctx, targetElement, path, offset, triggerCharSet, 
                text, requireLeadingSpace, hasTrailingSpace) {
            resetSelection(ctx, targetElement, path, offset);

            var mentionInfo = getTriggerInfo(ctx, triggerCharSet, requireLeadingSpace, true, hasTrailingSpace);

            if (mentionInfo !== undefined) {
                if (selectedElementIsTextAreaOrInput()) {
                    var myField = getDocument(ctx).activeElement;
                    text = text + ' ';
                    var startPos = mentionInfo.mentionPosition;
                    var endPos = mentionInfo.mentionPosition + mentionInfo.mentionText.length + 1;
                    myField.value = myField.value.substring(0, startPos) + text +
                        myField.value.substring(endPos, myField.value.length);
                    myField.selectionStart = startPos + text.length;
                    myField.selectionEnd = startPos + text.length;
                } else {
                    // add a space to the end of the pasted text
                    text = text + '\xA0';
                    pasteHtml(ctx, text, mentionInfo.mentionPosition,
                            mentionInfo.mentionPosition + mentionInfo.mentionText.length + 1);
                }
            }
        }

        function getNodePositionInParent (ctx, elem) {
            if (elem.parentNode === null) {
                return 0;
            }
            for (var i = 0; i < elem.parentNode.childNodes.length; i++) {
                var node = elem.parentNode.childNodes[i];
                if (node === elem) {
                    return i;
                }
            }
        }

        // public
        function getMacroMatch (ctx, macros) {
            var selected, path = [], offset;

            if (selectedElementIsTextAreaOrInput(ctx)) {
                selected = getDocument(ctx).activeElement;
            } else {
                // content editable
                var selectionInfo = getContentEditableSelectedPath(ctx);
                if (selectionInfo) {
                    selected = selectionInfo.selected;
                    path = selectionInfo.path;
                    offset = selectionInfo.offset;
                }
            }
            var effectiveRange = getTextPrecedingCurrentSelection(ctx);
            if (effectiveRange !== undefined && effectiveRange !== null) {

                var matchInfo;

                var hasTrailingSpace = false;

                if (effectiveRange.length > 0 &&
                    (effectiveRange.charAt(effectiveRange.length - 1) === '\xA0' ||
                        effectiveRange.charAt(effectiveRange.length - 1) === ' ')) {
                    hasTrailingSpace = true;
                    // strip space
                    effectiveRange = effectiveRange.substring(0, effectiveRange.length-1);
                }

                angular.forEach(macros, function (macro, c) {
                    var idx = effectiveRange.toUpperCase().lastIndexOf(c.toUpperCase());

                    if (idx >= 0 && c.length + idx === effectiveRange.length) {
                        var prevCharPos = idx - 1;
                        if (idx === 0 || effectiveRange.charAt(prevCharPos) === '\xA0' ||
                            effectiveRange.charAt(prevCharPos) === ' ' ) {

                            matchInfo = {
                                macroPosition: idx,
                                macroText: c,
                                macroSelectedElement: selected,
                                macroSelectedPath: path,
                                macroSelectedOffset: offset,
                                macroHasTrailingSpace: hasTrailingSpace
                            };
                        }
                    }
                });
                if (matchInfo) {
                    return matchInfo;
                }
            }
        }

        function getContentEditableSelectedPath(ctx) {
            // content editable
            var sel = getWindowSelection(ctx);
            var selected = sel.anchorNode;
            var path = [];
            var offset;
            if (selected != null) {
                var i;
                var ce = selected.contentEditable;
                while (selected !== null && ce !== 'true') {
                    i = getNodePositionInParent(ctx, selected);
                    path.push(i);
                    selected = selected.parentNode;
                    if (selected !== null) {
                        ce = selected.contentEditable;
                    }
                }
                path.reverse();
                // getRangeAt may not exist, need alternative
                offset = sel.getRangeAt(0).startOffset;
                return {
                    selected: selected,
                    path: path,
                    offset: offset
                };
            }
        }

        // public
        function getTriggerInfo (ctx, triggerCharSet, requireLeadingSpace, menuAlreadyActive, hasTrailingSpace) {
            /*jshint maxcomplexity:11 */
            // yes this function needs refactoring 
            var selected, path, offset;
            if (selectedElementIsTextAreaOrInput(ctx)) {
                selected = getDocument(ctx).activeElement;
            } else {
                // content editable
                var selectionInfo = getContentEditableSelectedPath(ctx);
                if (selectionInfo) {
                    selected = selectionInfo.selected;
                    path = selectionInfo.path;
                    offset = selectionInfo.offset;
                }
            }
            var effectiveRange = getTextPrecedingCurrentSelection(ctx);

            if (effectiveRange !== undefined && effectiveRange !== null) {
                var mostRecentTriggerCharPos = -1;
                var triggerChar;
                triggerCharSet.forEach(function(c) {
                    var idx = effectiveRange.lastIndexOf(c);
                    if (idx > mostRecentTriggerCharPos) {
                        mostRecentTriggerCharPos = idx;
                        triggerChar = c;
                    }
                });
                if (mostRecentTriggerCharPos >= 0 &&
                        (
                            mostRecentTriggerCharPos === 0 ||
                            !requireLeadingSpace ||
                            /[\xA0\s]/g.test
                            (
                                effectiveRange.substring(
                                    mostRecentTriggerCharPos - 1,
                                    mostRecentTriggerCharPos)
                            )
                        )
                    )
                {
                    var currentTriggerSnippet = effectiveRange.substring(mostRecentTriggerCharPos + 1,
                        effectiveRange.length);

                    triggerChar = effectiveRange.substring(mostRecentTriggerCharPos, mostRecentTriggerCharPos+1);
                    var firstSnippetChar = currentTriggerSnippet.substring(0,1);
                    var leadingSpace = currentTriggerSnippet.length > 0 &&
                        (
                            firstSnippetChar === ' ' ||
                            firstSnippetChar === '\xA0'
                        );
                    if (hasTrailingSpace) {
                        currentTriggerSnippet = currentTriggerSnippet.trim();
                    }
                    if (!leadingSpace && (menuAlreadyActive || !(/[\xA0\s]/g.test(currentTriggerSnippet)))) {
                        return {
                            mentionPosition: mostRecentTriggerCharPos,
                            mentionText: currentTriggerSnippet,
                            mentionSelectedElement: selected,
                            mentionSelectedPath: path,
                            mentionSelectedOffset: offset,
                            mentionTriggerChar: triggerChar
                        };
                    }
                }
            }
        }

        function getWindowSelection(ctx) {
            if (!ctx) {
                return window.getSelection();
            } else {
                return ctx.iframe.contentWindow.getSelection();
            }
        }

        function getDocument(ctx) {
            if (!ctx) {
                return document;
            } else {
                return ctx.iframe.contentWindow.document;
            }
        }

        function getTextPrecedingCurrentSelection (ctx) {
            var text;
            if (selectedElementIsTextAreaOrInput(ctx)) {
                var textComponent = getDocument(ctx).activeElement;
                var startPos = textComponent.selectionStart;
                text = textComponent.value.substring(0, startPos);

            } else {
                var selectedElem = getWindowSelection(ctx).anchorNode;
                if (selectedElem != null) {
                    var workingNodeContent = selectedElem.textContent;
                    var selectStartOffset = getWindowSelection(ctx).getRangeAt(0).startOffset;
                    if (selectStartOffset >= 0) {
                        text = workingNodeContent.substring(0, selectStartOffset);
                    }
                }
            }
            return text;
        }

        function getContentEditableCaretPosition (ctx, selectedNodePosition) {
            var markerTextChar = '\ufeff';
            var markerEl, markerId = 'sel_' + new Date().getTime() + '_' + Math.random().toString().substr(2);

            var range;
            var sel = getWindowSelection(ctx);
            var prevRange = sel.getRangeAt(0);
            range = getDocument(ctx).createRange();

            range.setStart(sel.anchorNode, selectedNodePosition);
            range.setEnd(sel.anchorNode, selectedNodePosition);

            range.collapse(false);

            // Create the marker element containing a single invisible character using DOM methods and insert it
            markerEl = getDocument(ctx).createElement('span');
            markerEl.id = markerId;
            markerEl.appendChild(getDocument(ctx).createTextNode(markerTextChar));
            range.insertNode(markerEl);
            sel.removeAllRanges();
            sel.addRange(prevRange);

            var coordinates = {
                left: 0,
                top: markerEl.offsetHeight
            };

            localToGlobalCoordinates(ctx, markerEl, coordinates);

            markerEl.parentNode.removeChild(markerEl);
            return coordinates;
        }

        function localToGlobalCoordinates(ctx, element, coordinates) {
            var obj = element;
            var iframe = ctx ? ctx.iframe : null;
            while(obj) {
                coordinates.left += obj.offsetLeft;
                coordinates.top += obj.offsetTop;
                if (obj !== getDocument().body) {
                    coordinates.top -= obj.scrollTop;
                    coordinates.left -= obj.scrollLeft;
                }
                obj = obj.offsetParent;
                if (!obj && iframe) {
                    obj = iframe;
                    iframe = null;
                }
            }            
        }

        function getTextAreaOrInputUnderlinePosition (ctx, element, position) {
            var properties = [
                'direction',
                'boxSizing',
                'width',
                'height',
                'overflowX',
                'overflowY',
                'borderTopWidth',
                'borderRightWidth',
                'borderBottomWidth',
                'borderLeftWidth',
                'paddingTop',
                'paddingRight',
                'paddingBottom',
                'paddingLeft',
                'fontStyle',
                'fontVariant',
                'fontWeight',
                'fontStretch',
                'fontSize',
                'fontSizeAdjust',
                'lineHeight',
                'fontFamily',
                'textAlign',
                'textTransform',
                'textIndent',
                'textDecoration',
                'letterSpacing',
                'wordSpacing'
            ];

            var isFirefox = (window.mozInnerScreenX !== null);

            var div = getDocument(ctx).createElement('div');
            div.id = 'input-textarea-caret-position-mirror-div';
            getDocument(ctx).body.appendChild(div);

            var style = div.style;
            var computed = window.getComputedStyle ? getComputedStyle(element) : element.currentStyle;

            style.whiteSpace = 'pre-wrap';
            if (element.nodeName !== 'INPUT') {
                style.wordWrap = 'break-word';
            }

            // position off-screen
            style.position = 'absolute';
            style.visibility = 'hidden';

            // transfer the element's properties to the div
            properties.forEach(function (prop) {
                style[prop] = computed[prop];
            });

            if (isFirefox) {
                style.width = (parseInt(computed.width) - 2) + 'px';
                if (element.scrollHeight > parseInt(computed.height))
                    style.overflowY = 'scroll';
            } else {
                style.overflow = 'hidden';
            }

            div.textContent = element.value.substring(0, position);

            if (element.nodeName === 'INPUT') {
                div.textContent = div.textContent.replace(/\s/g, '\u00a0');
            }

            var span = getDocument(ctx).createElement('span');
            span.textContent = element.value.substring(position) || '.';
            div.appendChild(span);

            var coordinates = {
                top: span.offsetTop + parseInt(computed.borderTopWidth) + parseInt(computed.fontSize),
                left: span.offsetLeft + parseInt(computed.borderLeftWidth)
            };

            localToGlobalCoordinates(ctx, element, coordinates);

            getDocument(ctx).body.removeChild(div);

            return coordinates;
        }

        return {
            // public
            popUnderMention: popUnderMention,
            replaceMacroText: replaceMacroText,
            replaceTriggerText: replaceTriggerText,
            getMacroMatch: getMacroMatch,
            getTriggerInfo: getTriggerInfo,
            selectElement: selectElement,




            // private: for unit testing only
            getTextAreaOrInputUnderlinePosition: getTextAreaOrInputUnderlinePosition,
            getTextPrecedingCurrentSelection: getTextPrecedingCurrentSelection,
            getContentEditableSelectedPath: getContentEditableSelectedPath,
            getNodePositionInParent: getNodePositionInParent,
            getContentEditableCaretPosition: getContentEditableCaretPosition,
            pasteHtml: pasteHtml,
            resetSelection: resetSelection,
            scrollIntoView: scrollIntoView
        };
    }]);

angular.module("mentio").run(["$templateCache", function($templateCache) {$templateCache.put("mentio-menu.tpl.html","<style>\n.scrollable-menu {\n    height: auto;\n    max-height: 300px;\n    overflow: auto;\n}\n\n.menu-highlighted {\n    font-weight: bold;\n}\n</style>\n<ul class=\"dropdown-menu scrollable-menu\" style=\"display:block\">\n    <li mentio-menu-item=\"item\" ng-repeat=\"item in items track by $index\">\n        <a class=\"text-primary\" ng-bind-html=\"item.label | mentioHighlight:typedTerm:\'menu-highlighted\' | unsafe\"></a>\n    </li>\n</ul>");}]);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
__webpack_require__(660);
__webpack_require__(662);
__webpack_require__(667);
__webpack_require__(669);
__webpack_require__(677);
__webpack_require__(685);
__webpack_require__(687);
__webpack_require__(695);
__webpack_require__(697);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(728);
__webpack_require__(752);
__webpack_require__(762);
__webpack_require__(764);
__webpack_require__(1346);
__webpack_require__(1348);
__webpack_require__(1351);
__webpack_require__(1353);
__webpack_require__(1355);
__webpack_require__(1357);
__webpack_require__(1359);
__webpack_require__(1365);
__webpack_require__(1369);
__webpack_require__(1371);
__webpack_require__(167);
__webpack_require__(1381);
__webpack_require__(1382);
__webpack_require__(1383);
var ng_1 = __importDefault(__webpack_require__(18));
/* globals __SUPERDESK_CONFIG__: true */
var appConfig = {"defaultRoute":"/workspace/personal","view":{"timeformat":"HH:mm","dateformat":"DD.MM.YYYY"},"features":{"preview":1,"swimlane":{"columnsLimit":4},"noTakes":true,"editor3":true,"validatePointOfInterestForImages":false,"editorHighlights":true,"noPublishOnAuthoringDesk":true,"noMissingLink":true,"useTansaProofing":false,"onlyEditor3":false},"version":"e58c527","raven":{"dsn":""},"server":{"url":"http://localhost/api","ws":"ws://localhost/ws"},"iframely":{"key":""},"google":{"key":""},"analytics":{"piwik":{"url":"","id":""},"ga":{"id":""}},"editor":{},"defaultTimezone":"Europe/London","model":{"dateformat":"DD/MM/YYYY","timeformat":"HH:mm:ss"},"isTestEnvironment":false,"langOverride":{},"tansa":{"profile":{"nb":1,"nn":2}},"workspace":{"ingest":false,"content":false,"tasks":false,"analytics":false},"ingest":{"PROVIDER_DASHBOARD_DEFAULTS":{"show_log_messages":true,"show_ingest_count":true,"show_time":true,"log_messages":"error","show_status":true},"DEFAULT_SCHEDULE":{"minutes":5,"seconds":0},"DEFAULT_IDLE_TIME":{"hours":0,"minutes":0}},"profileLanguages":["en","el","en_GB","es","da","ar","de_DE","ru_RU","nb","uk_UA","pt_BR","pl"]};
// This module gets overwritten when building for production to create template
// cache. For more information, see the `grunt ngtemplates:core` task.
angular.module('superdesk.templates-cache', []);
var core = angular.module('superdesk.core', [
    'ngRoute',
    'ngResource',
    'ngFileUpload',
    'superdesk-ui',
    'superdesk.core.activity',
    'superdesk.core.analytics',
    'superdesk.core.api',
    'superdesk.core.auth',
    'superdesk.core.datetime',
    'superdesk.core.elastic',
    'superdesk.core.error',
    'superdesk.core.notify',
    'superdesk.core.ui',
    'superdesk.core.upload',
    'superdesk.core.menu',
    'superdesk.core.filters',
    'superdesk.core.preferences',
    'superdesk.core.translate',
    'superdesk.core.workflow',
    'superdesk.core.loading',
    'superdesk.core.editor3',
    'superdesk.core.form',
    'superdesk.core.services',
    'superdesk.core.directives',
    'superdesk.templates-cache',
]);
core.constant('lodash', lodash_1.default);
core.config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/', {
            redirectTo: appConfig.defaultRoute,
        });
    }]);
// due to angular 1.6
core.config(['$locationProvider', function ($locationProvider) { return $locationProvider.hashPrefix(''); }]);
core.config(['$qProvider', function ($qProvider) { return $qProvider.errorOnUnhandledRejections(true); }]);
core.config(['$compileProvider', function ($compileProvider) { return $compileProvider.preAssignBindingsEnabled(true); }]);
core.run(['$injector', ng_1.default.register]);
core.run(['$document', function ($document) {
        if (window.navigator.userAgent.toLowerCase().includes('firefox')) {
            // workaround for firefox drag event not reporting mouse coordinates
            $document.on('dragover', function (event) {
                window.dragPageY = event.pageY;
            });
        }
    }]);
exports.default = core;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(661);


/***/ }),
/* 661 */
/***/ (function(module, exports) {

function isLinkExternal(href) {
    try {
        var url = new URL(href);
        // Check if the hosts are different and protocol is http or https
        return url.host !== window.location.host && ['http:', 'https:'].includes(url.protocol);
    }
    catch (e) {
        // will throw if string is not a valid link
        return false;
    }
}
document.addEventListener('click', function (event) {
    if (event != null) {
        var target = event.target;
        if (target && target.tagName === 'A' && isLinkExternal(target.href)) {
            event.preventDefault();
            event.stopPropagation();
            // security https://mathiasbynens.github.io/rel-noopener/
            var nextWindow = window.open();
            nextWindow.opener = null;
            nextWindow.location.href = target.href;
        }
    }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(36);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* jshint ignore:start */
// from github:mozilla/language-mapping-list
exports.default = {
    ach: {
        nativeName: 'Lwo',
        englishName: 'Acholi',
    },
    ady: {
        nativeName: 'Адыгэбзэ',
        englishName: 'Adyghe',
    },
    af: {
        nativeName: 'Afrikaans',
        englishName: 'Afrikaans',
    },
    'af-NA': {
        nativeName: 'Afrikaans (Namibia)',
        englishName: 'Afrikaans (Namibia)',
    },
    'af-ZA': {
        nativeName: 'Afrikaans (South Africa)',
        englishName: 'Afrikaans (South Africa)',
    },
    ak: {
        nativeName: 'Tɕɥi',
        englishName: 'Akan',
    },
    ar: {
        nativeName: 'العربية',
        englishName: 'Arabic',
    },
    'ar-AR': {
        nativeName: 'العربية',
        englishName: 'Arabic',
    },
    'ay-BO': {
        nativeName: 'Aymar aru',
        englishName: 'Aymara',
    },
    'az-AZ': {
        nativeName: 'Azərbaycan dili',
        englishName: 'Azerbaijani',
    },
    'be-BY': {
        nativeName: 'Беларуская',
        englishName: 'Belarusian',
    },
    'bg-BG': {
        nativeName: 'Български',
        englishName: 'Bulgarian',
    },
    bn: {
        nativeName: 'বাংলা',
        englishName: 'Bengali',
    },
    'bn-IN': {
        nativeName: 'বাংলা (ভারত)',
        englishName: 'Bengali (India)',
    },
    'bn-BD': {
        nativeName: 'বাংলা(বাংলাদেশ)',
        englishName: 'Bengali (Bangladesh)',
    },
    'bs-BA': {
        nativeName: 'Bosanski',
        englishName: 'Bosnian',
    },
    ca: {
        nativeName: 'Català',
        englishName: 'Catalan',
    },
    'ca-ES': {
        nativeName: 'Català',
        englishName: 'Catalan',
    },
    'ck-US': {
        nativeName: 'ᏣᎳᎩ (tsalagi)',
        englishName: 'Cherokee',
    },
    cs: {
        nativeName: 'Čeština',
        englishName: 'Czech',
    },
    'cs-CZ': {
        nativeName: 'Čeština',
        englishName: 'Czech',
    },
    'cy-GB': {
        nativeName: 'Cymraeg',
        englishName: 'Welsh',
    },
    'da-DK': {
        nativeName: 'Dansk',
        englishName: 'Danish',
    },
    de: {
        nativeName: 'Deutsch',
        englishName: 'German',
    },
    'de-AT': {
        nativeName: 'Deutsch (Austria)',
        englishName: 'German (Austria)',
    },
    'de-DE': {
        nativeName: 'Deutsch (German)',
        englishName: 'German (German)',
    },
    'de-CH': {
        nativeName: 'Deutsch (Switzerland)',
        englishName: 'German (Switzerland)',
    },
    el: {
        nativeName: 'Ελληνικά',
        englishName: 'Greek',
    },
    'el-GR': {
        nativeName: 'Ελληνικά',
        englishName: 'Greek (Greece)',
    },
    en: {
        nativeName: 'English',
        englishName: 'English',
    },
    'en-GB': {
        nativeName: 'English (UK)',
        englishName: 'English (UK)',
    },
    'en-CA': {
        nativeName: 'English (Canada)',
        englishName: 'English (Canada)',
    },
    'en-IN': {
        nativeName: 'English (India)',
        englishName: 'English (India)',
    },
    'en-PI': {
        nativeName: 'English (Pirate)',
        englishName: 'English (Pirate)',
    },
    'en-UD': {
        nativeName: 'English (Upside Down)',
        englishName: 'English (Upside Down)',
    },
    'en-US': {
        nativeName: 'English (US)',
        englishName: 'English (US)',
    },
    'en@pirate': {
        nativeName: 'English (Pirate)',
        englishName: 'English (Pirate)',
    },
    eo: {
        nativeName: 'Esperanto',
        englishName: 'Esperanto',
    },
    'eo-EO': {
        nativeName: 'Esperanto',
        englishName: 'Esperanto',
    },
    es: {
        nativeName: 'Español',
        englishName: 'Spanish',
    },
    'es-AR': {
        nativeName: 'Español (Argentine)',
        englishName: 'Spanish (Argentina)',
    },
    'es-419': {
        nativeName: 'Español (Latino America)',
        englishName: 'Spanish (Latin America)',
    },
    'es-CL': {
        nativeName: 'Español (Chile)',
        englishName: 'Spanish (Chile)',
    },
    'es-CO': {
        nativeName: 'Español (Colombia)',
        englishName: 'Spanish (Colombia)',
    },
    'es-EC': {
        nativeName: 'Español (Ecuador)',
        englishName: 'Spanish (Ecuador)',
    },
    'es-ES': {
        nativeName: 'Español (España)',
        englishName: 'Spanish (Spain)',
    },
    'es-LA': {
        nativeName: 'Español',
        englishName: 'Spanish (Latin)',
    },
    'es-NI': {
        nativeName: 'Español Nicaragüense',
        englishName: 'Spanish (Nicaragua)',
    },
    'es-MX': {
        nativeName: 'Español (México)',
        englishName: 'Spanish (Mexico)',
    },
    'es-VE': {
        nativeName: 'Español (Venezuela)',
        englishName: 'Spanish (Venezuela)',
    },
    et: {
        nativeName: 'eesti keel',
        englishName: 'Estonian',
    },
    'et-EE': {
        nativeName: 'Eesti (Estonia)',
        englishName: 'Estonian (Estonia)',
    },
    eu: {
        nativeName: 'Euskara',
        englishName: 'Basque',
    },
    'eu-ES': {
        nativeName: 'Euskara',
        englishName: 'Basque',
    },
    fa: {
        nativeName: 'فارسی',
        englishName: 'Persian',
    },
    'fa-IR': {
        nativeName: 'فارسی',
        englishName: 'Persian',
    },
    'fb-LT': {
        nativeName: 'Leet Speak',
        englishName: 'Leet',
    },
    ff: {
        nativeName: 'Fulah',
        englishName: 'Fulah',
    },
    fi: {
        nativeName: 'Suomi',
        englishName: 'Finnish',
    },
    'fi-FI': {
        nativeName: 'Suomi',
        englishName: 'Finnish',
    },
    'fo-FO': {
        nativeName: 'Føroyskt',
        englishName: 'Faroese',
    },
    fr: {
        nativeName: 'Français',
        englishName: 'French',
    },
    'fr-CA': {
        nativeName: 'Français (Canada)',
        englishName: 'French (Canada)',
    },
    'fr-FR': {
        nativeName: 'Français (France)',
        englishName: 'French (France)',
    },
    'fy-NL': {
        nativeName: 'Frysk',
        englishName: 'Frisian (West)',
    },
    ga: {
        nativeName: 'Gaeilge',
        englishName: 'Irish',
    },
    'ga-IE': {
        nativeName: 'Gaeilge (Gaelic)',
        englishName: 'Irish (Gaelic)',
    },
    gl: {
        nativeName: 'Galego',
        englishName: 'Galician',
    },
    'gl-ES': {
        nativeName: 'Galego',
        englishName: 'Galician',
    },
    'gn-PY': {
        nativeName: 'Avañe\'ẽ',
        englishName: 'Guarani',
    },
    'gu-IN': {
        nativeName: 'ગુજરાતી',
        englishName: 'Gujarati',
    },
    'gx-GR': {
        nativeName: 'Ἑλληνική ἀρχαία',
        englishName: 'Classical Greek',
    },
    he: {
        nativeName: 'עברית‏',
        englishName: 'Hebrew',
    },
    'he-IL': {
        nativeName: 'עברית‏',
        englishName: 'Hebrew',
    },
    hi: {
        nativeName: 'हिन्दी',
        englishName: 'Hindi',
    },
    'hi-IN': {
        nativeName: 'हिन्दी',
        englishName: 'Hindi',
    },
    'hr-HR': {
        nativeName: 'Hrvatski',
        englishName: 'Croatian',
    },
    hu: {
        nativeName: 'Magyar',
        englishName: 'Hungarian',
    },
    'hu-HU': {
        nativeName: 'Magyar',
        englishName: 'Hungarian',
    },
    'hy-AM': {
        nativeName: 'Հայերեն',
        englishName: 'Armenian',
    },
    id: {
        nativeName: 'Bahasa Indonesia',
        englishName: 'Indonesian',
    },
    'id-ID': {
        nativeName: 'Bahasa Indonesia',
        englishName: 'Indonesian',
    },
    is: {
        nativeName: 'Íslenska',
        englishName: 'Icelandic',
    },
    'is-IS': {
        nativeName: 'Íslenska (Iceland)',
        englishName: 'Icelandic (Iceland)',
    },
    it: {
        nativeName: 'Italiano',
        englishName: 'Italian',
    },
    'it-IT': {
        nativeName: 'Italiano',
        englishName: 'Italian',
    },
    ja: {
        nativeName: '日本語',
        englishName: 'Japanese',
    },
    'ja-JP': {
        nativeName: '日本語',
        englishName: 'Japanese',
    },
    'jv-ID': {
        nativeName: 'Basa Jawa',
        englishName: 'Javanese',
    },
    'ka-GE': {
        nativeName: 'ქართული',
        englishName: 'Georgian',
    },
    'kk-KZ': {
        nativeName: 'Қазақша',
        englishName: 'Kazakh',
    },
    km: {
        nativeName: 'ភាសាខ្មែរ',
        englishName: 'Khmer',
    },
    'km-KH': {
        nativeName: 'ភាសាខ្មែរ',
        englishName: 'Khmer',
    },
    kn: {
        nativeLanguage: 'ಕನ್ನಡ',
        englishName: 'Kannada',
    },
    'kn-IN': {
        nativeName: 'ಕನ್ನಡ (India)',
        englishName: 'Kannada (India)',
    },
    ko: {
        nativeName: '한국어',
        englishName: 'Korean',
    },
    'ko-KR': {
        nativeName: '한국어 (韩国)',
        englishName: 'Korean (Korea)',
    },
    'ku-TR': {
        nativeName: 'Kurdî',
        englishName: 'Kurdish',
    },
    la: {
        nativeName: 'Latin',
        englishName: 'Latin',
    },
    'la-VA': {
        nativeName: 'Latin',
        englishName: 'Latin',
    },
    'li-NL': {
        nativeName: 'Lèmbörgs',
        englishName: 'Limburgish',
    },
    'lt-LT': {
        nativeName: 'Lietuvių',
        englishName: 'Lithuanian',
    },
    'lv-LV': {
        nativeName: 'Latviešu',
        englishName: 'Latvian',
    },
    mai: {
        nativeName: 'मैथिली, মৈথিলী',
        englishName: 'Maithili',
    },
    'mg-MG': {
        nativeName: 'Malagasy',
        englishName: 'Malagasy',
    },
    mk: {
        nativeName: 'Македонски',
        englishName: 'Macedonian',
    },
    'mk-MK': {
        nativeName: 'Македонски (Македонски)',
        englishName: 'Macedonian (Macedonian)',
    },
    ml: {
        nativeName: 'മലയാളം',
        englishName: 'Malayalam',
    },
    'ml-IN': {
        nativeName: 'മലയാളം',
        englishName: 'Malayalam',
    },
    'mn-MN': {
        nativeName: 'Монгол',
        englishName: 'Mongolian',
    },
    mr: {
        nativeName: 'मराठी',
        englishName: 'Marathi',
    },
    'mr-IN': {
        nativeName: 'मराठी',
        englishName: 'Marathi',
    },
    ms: {
        nativeName: 'Bahasa Melayu',
        englishName: 'Malay',
    },
    'ms-MY': {
        nativeName: 'Bahasa Melayu',
        englishName: 'Malay',
    },
    'mt-MT': {
        nativeName: 'Malti',
        englishName: 'Maltese',
    },
    my: {
        nativeName: 'ဗမာစကာ',
        englishName: 'Burmese',
    },
    nb: {
        nativeName: 'Norsk (bokmål)',
        englishName: 'Norwegian (bokmal)',
    },
    'nb-NO': {
        nativeName: 'Norsk (bokmål)',
        englishName: 'Norwegian (bokmal)',
    },
    ne: {
        nativeName: 'नेपाली',
        englishName: 'Nepali',
    },
    'ne-NP': {
        nativeName: 'नेपाली',
        englishName: 'Nepali',
    },
    nl: {
        nativeName: 'Nederlands',
        englishName: 'Dutch',
    },
    'nl-BE': {
        nativeName: 'Nederlands (België)',
        englishName: 'Dutch (België)',
    },
    'nl-NL': {
        nativeName: 'Nederlands, Dutch',
        englishName: 'Netherlands, Dutch',
    },
    'nn-NO': {
        nativeName: 'Norsk (nynorsk)',
        englishName: 'Norwegian (nynorsk)',
    },
    oc: {
        nativeName: 'Occitan',
        englishName: 'Occitan',
    },
    'or-IN': {
        nativeName: 'ଓଡ଼ିଆ',
        englishName: 'Oriya',
    },
    pa: {
        nativeName: 'ਪੰਜਾਬੀ',
        englishName: 'Punjabi',
    },
    'pa-IN': {
        nativeName: 'ਪੰਜਾਬੀ (ਭਾਰਤ ਨੂੰ)',
        englishName: 'Punjabi (India)',
    },
    'pl-PL': {
        nativeName: 'Polski',
        englishName: 'Polish',
    },
    'ps-AF': {
        nativeName: 'پښتو',
        englishName: 'Pashto',
    },
    pt: {
        nativeName: 'Português',
        englishName: 'Portuguese',
    },
    'pt-BR': {
        nativeName: 'Português (Brasil)',
        englishName: 'Portuguese (Brazil)',
    },
    'pt-PT': {
        nativeName: 'Português (Portugal)',
        englishName: 'Portuguese (Portugal)',
    },
    'qu-PE': {
        nativeName: 'Qhichwa',
        englishName: 'Quechua',
    },
    'rm-CH': {
        nativeName: 'Rumantsch',
        englishName: 'Romansh',
    },
    ro: {
        nativeName: 'Română',
        englishName: 'Romanian',
    },
    'ro-RO': {
        nativeName: 'Română',
        englishName: 'Romanian',
    },
    ru: {
        nativeName: 'Русский',
        englishName: 'Russian',
    },
    'ru-RU': {
        nativeName: 'Русский',
        englishName: 'Russian',
    },
    'sa-IN': {
        nativeName: 'संस्कृतम्',
        englishName: 'Sanskrit',
    },
    'se-NO': {
        nativeName: 'Davvisámegiella',
        englishName: 'Northern Sámi',
    },
    'si-LK': {
        nativeName: 'පළාත',
        englishName: 'Sinhala (Sri Lanka)',
    },
    sk: {
        nativeName: 'Slovenčina',
        englishName: 'Slovak',
    },
    'sk-SK': {
        nativeName: 'Slovenčina (Slovakia)',
        englishName: 'Slovak (Slovakia)',
    },
    sl: {
        nativeName: 'Slovenščina',
        englishName: 'Slovenian',
    },
    'sl-SI': {
        nativeName: 'Slovenščina',
        englishName: 'Slovenian',
    },
    'so-SO': {
        nativeName: 'Soomaaliga',
        englishName: 'Somali',
    },
    sq: {
        nativeName: 'Shqip',
        englishName: 'Albanian',
    },
    'sq-AL': {
        nativeName: 'Shqip',
        englishName: 'Albanian',
    },
    sr: {
        nativeName: 'Српски',
        englishName: 'Serbian',
    },
    'sr-RS': {
        nativeName: 'Српски (Serbia)',
        englishName: 'Serbian (Serbia)',
    },
    su: {
        nativeName: 'Basa Sunda',
        englishName: 'Sundanese',
    },
    sv: {
        nativeName: 'Svenska',
        englishName: 'Swedish',
    },
    'sv-SE': {
        nativeName: 'Svenska',
        englishName: 'Swedish',
    },
    sw: {
        nativeName: 'Kiswahili',
        englishName: 'Swahili',
    },
    'sw-KE': {
        nativeName: 'Kiswahili',
        englishName: 'Swahili (Kenya)',
    },
    ta: {
        nativeName: 'தமிழ்',
        englishName: 'Tamil',
    },
    'ta-IN': {
        nativeName: 'தமிழ்',
        englishName: 'Tamil',
    },
    te: {
        nativeName: 'తెలుగు',
        englishName: 'Telugu',
    },
    'te-IN': {
        nativeName: 'తెలుగు',
        englishName: 'Telugu',
    },
    'tg-TJ': {
        nativeName: 'тоҷикӣ',
        englishName: 'Tajik',
    },
    th: {
        nativeName: 'ภาษาไทย',
        englishName: 'Thai',
    },
    'th-TH': {
        nativeName: 'ภาษาไทย (ประเทศไทย)',
        englishName: 'Thai (Thailand)',
    },
    tl: {
        nativeName: 'Filipino',
        englishName: 'Filipino',
    },
    'tl-PH': {
        nativeName: 'Filipino',
        englishName: 'Filipino',
    },
    'tl-ST': {
        nativeName: 'tlhIngan-Hol',
        englishName: 'Klingon',
    },
    'tr-TR': {
        nativeName: 'Türkçe',
        englishName: 'Turkish',
    },
    'tt-RU': {
        nativeName: 'татарча',
        englishName: 'Tatar',
    },
    uk: {
        nativeName: 'Українська',
        englishName: 'Ukrainian',
    },
    'uk-UA': {
        nativeName: 'Українська',
        englishName: 'Ukrainian',
    },
    ur: {
        nativeName: 'اردو',
        englishName: 'Urdu',
    },
    'ur-PK': {
        nativeName: 'اردو',
        englishName: 'Urdu',
    },
    uz: {
        nativeName: 'O\'zbek',
        englishName: 'Uzbek',
    },
    'uz-UZ': {
        nativeName: 'O\'zbek',
        englishName: 'Uzbek',
    },
    'vi-VN': {
        nativeName: 'Tiếng Việt',
        englishName: 'Vietnamese',
    },
    'xh-ZA': {
        nativeName: 'isiXhosa',
        englishName: 'Xhosa',
    },
    yi: {
        nativeName: 'ייִדיש',
        englishName: 'Yiddish',
    },
    'yi-DE': {
        nativeName: 'ייִדיש (German)',
        englishName: 'Yiddish (German)',
    },
    'zh-CN': {
        nativeName: '中文(简体)',
        englishName: 'Simplified Chinese (China)',
    },
    'zh-HK': {
        nativeName: '中文(香港)',
        englishName: 'Traditional Chinese (Hong Kong)',
    },
    'zh-TW': {
        nativeName: '中文(台灣)',
        englishName: 'Traditional Chinese (Taiwan)',
    },
    'zu-ZA': {
        nativeName: 'isiZulu',
        englishName: 'Zulu',
    },
};
/* jshint ignore:end */


/***/ }),
/* 664 */
/***/ (function(module, exports) {

angular.module('superdesk.core.activity.chooser', [])
    .directive('sdActivityChooser', ['activityChooser', 'keyboardManager', 'asset', 'lodash',
    function (activityChooser, keyboardManager, asset, _) {
        return {
            scope: {},
            templateUrl: asset.templateUrl('core/activity/views/activity-chooser.html'),
            link: function (scope, elem, attrs) {
                var UP = -1, DOWN = 1;
                scope.chooser = activityChooser;
                scope.selected = null;
                function move(diff, items) {
                    var index = _.indexOf(items, scope.selected), next = _.max([0, _.min([items.length - 1, index + diff])]);
                    scope.selected = items[next];
                }
                scope.$watch(function watchActivities() {
                    return activityChooser.activities;
                }, function (activities, prev) {
                    scope.selected = activities ? _.head(activities) : null;
                    if (activities) {
                        keyboardManager.push('up', function () {
                            move(UP, activities);
                        });
                        keyboardManager.push('down', function () {
                            move(DOWN, activities);
                        });
                        keyboardManager.push('enter', function () {
                            activityChooser.resolve(scope.selected);
                        });
                    }
                    else if (prev) {
                        keyboardManager.pop('up');
                        keyboardManager.pop('down');
                        keyboardManager.pop('enter');
                    }
                });
                scope.select = function (activity) {
                    scope.selected = activity;
                };
            },
        };
    }]);


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
angular.module('superdesk.core.activity.list', [])
    .directive('sdActivityList', ['superdesk', 'activityService', 'workflowService', 'asset', 'notify', 'lodash',
    function (superdesk, activityService, workflowService, asset, notify, _) {
        return {
            scope: {
                item: '=',
                type: '@',
                action: '@',
                done: '&',
                single: '=',
                preview: '@',
            },
            templateUrl: asset.templateUrl('core/activity/views/activity-list.html'),
            link: function (scope, elem, attrs) {
                scope.item.actioning = {};
                var intent = {
                    action: scope.action,
                };
                if (scope.type) {
                    intent.type = scope.type;
                }
                else {
                    return;
                }
                var initializeActivities = function (item) {
                    if (!item) {
                        return;
                    }
                    scope.activities = _.filter(superdesk.findActivities(intent, scope.item), function (activity) {
                        if (activity.monitor) {
                            scope.item.actioning = {};
                            scope.item.actioning[activity._id] = false;
                            scope.$watchCollection('item.actioning', function (newValue, oldValue) {
                                if (scope.item.actioning &&
                                    !scope.item.actioning[activity._id] &&
                                    oldValue &&
                                    newValue[activity._id] !== oldValue[activity._id]) {
                                    if (scope.item.error && scope.item.error.data
                                        && scope.item.error.data._message) {
                                        notify.error(utils_1.gettext(scope.item.error.data._message));
                                        delete scope.item.error;
                                    }
                                }
                            });
                        }
                        return workflowService.isActionAllowed(scope.item, activity.action);
                    });
                    if (scope.preview) {
                        scope.limit = scope.activities.length;
                    }
                    else {
                        scope.limit = scope.activities.length > 6 ? 5 : 6;
                    }
                    // register key shortcuts for single instance of activity list - in preview sidebar
                    if (scope.single) {
                        angular.forEach(scope.activities, function (activity) {
                            if (activity.key) {
                                if (activity.unbind) {
                                    activity.unbind();
                                }
                                activity.unbind = scope.$on('key:' + activity.key, function () {
                                    scope.run(activity);
                                });
                            }
                        });
                    }
                };
                scope.run = function runActivity(activity, e) {
                    if (scope.$root.link(activity._id, scope.item)) {
                        return; // don't try to run it, just let it change url
                    }
                    if (activity.monitor) {
                        scope.item.actioning[activity._id] = true;
                    }
                    if (!_.isNil(e)) {
                        e.stopPropagation();
                    }
                    activityService.start(activity, { data: { item: scope.item } })
                        .then(function () {
                        if (typeof scope.done === 'function') {
                            scope.done(scope.data);
                        }
                    });
                };
                scope.$watch('item', initializeActivities, true);
            },
        };
    }]);


/***/ }),
/* 666 */
/***/ (function(module, exports) {

angular.module('superdesk.core.activity.modal', [])
    .directive('sdActivityModal', ['activityService', 'asset', function (activityService, asset) {
        return {
            scope: true,
            templateUrl: asset.templateUrl('core/activity/views/activity-modal.html'),
            link: function (scope, elem) {
                scope.stack = activityService.activityStack;
                scope.$watch('stack.length', function (len) {
                    scope.activity = null;
                    if (len) {
                        var config = scope.stack[len - 1];
                        scope.activity = config.activity;
                        scope.locals = config.locals;
                        scope.reject = function (reason) {
                            return config.defer.reject(reason);
                        };
                        scope.resolve = function (result) {
                            return config.defer.resolve(result);
                        };
                        config.defer.promise.finally(function () {
                            scope.stack.pop();
                        });
                    }
                });
            },
        };
    }]);


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(668);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

function NoopTracking() {
    this.track = angular.noop;
}
function PiwikTracking(config) {
    window._paq = window._paq || [];
    (function () {
        window._paq.push(['setSiteId', config.id]);
        window._paq.push(['setTrackerUrl', config.url + '/piwik.php']);
        var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.defer = true;
        g.async = true;
        g.src = config.url + '/piwik.js';
        s.parentNode.insertBefore(g, s);
    })();
    this.track = function (activity) {
        window._paq.push(['trackPageView', activity.label]);
    };
}
function GoogleTracking(config) {
    (function (i, s, o, g, r, a, m) {
        var el = a;
        var tag = m;
        i.GoogleAnalyticsObject = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        };
        i[r].l = 1 * Number(new Date());
        el = s.createElement(o);
        tag = s.getElementsByTagName(o)[0];
        el.async = 1;
        el.src = g;
        tag.parentNode.insertBefore(el, tag);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    window.ga('create', config.id, 'sourcefabric.org');
    this.track = function (activity) {
        window.ga('send', 'pageview', {
            page: activity._id,
            title: activity.label,
        });
    };
}
/**
 * @ngdoc module
 * @module superdesk.core.analytics
 * @name superdesk.core.analytics
 * @packageName superdesk.core
 * @description Superdesk core analytics functions.
 */
angular.module('superdesk.core.analytics', [])
    .service('analytics', ['config', function (config) {
        if (config.analytics.piwik.url) {
            PiwikTracking.call(this, config.analytics.piwik);
        }
        else if (config.analytics.ga.id) {
            GoogleTracking.call(this, config.analytics.ga);
        }
        else {
            NoopTracking.call(this);
        }
    }])
    .run(['$rootScope', 'analytics', function ($rootScope, analytics) {
        $rootScope.$on('$routeChangeSuccess', function (ev, route) {
            if (angular.isDefined(route)) {
                analytics.track(route);
            }
        });
    }]);


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * @ngdoc module
 * @module superdesk.core.api
 * @name superdesk.core.api
 * @packageName superdesk.core
 * @description Superdesk core API utilities.
 */
angular.module('superdesk.core.api', [
    'superdesk.core.api.http',
    'superdesk.core.api.service',
    'superdesk.core.api.request',
    'superdesk.core.api.urls',
    'superdesk.core.api.timeout',
    'superdesk.core.api.allowed',
])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('timeoutInterceptor');
    }]);


/***/ }),
/* 671 */
/***/ (function(module, exports) {

/**
 * @ngdoc provider
 * @name apiProvider
 * @module superdesk.core.api
 * @description This provider allows registering API configuration.
 */
function APIProvider() {
    var apis = {};
    /**
     * @ngdoc method
     * @name apiProvider#api_
     * @public
     * @param {string} name
     * @param {Object} config
     * @description
     * > **WARNING** This method is actually called `api` but can not named that
     *  because of a bug in dgeni. So replace `api_` with `api` when calling.
     *
     * Register an api.
     */
    this.api = function (name, config) {
        apis[name] = config;
        return this;
    };
    /**
     * @ngdoc service
     * @name api
     * @module superdesk.core.api
     * @requires $injector
     * @requires $q
     * @requires $http
     * @requires urls
     * @requires lodash
     * @requires HttpEndpointFactory
     * @description Raw API operations.
     */
    this.$get = apiServiceFactory;
    apiServiceFactory.$inject = ['$injector', '$q', '$http', 'urls', 'lodash', 'HttpEndpointFactory'];
    function apiServiceFactory($injector, $q, $http, urls, _, HttpEndpointFactory) {
        var CACHE_TTL = 100;
        var endpoints = {
            http: HttpEndpointFactory,
        };
        function isOK(response) {
            function isErrData(data) {
                return data && data._status && data._status === 'ERR';
            }
            return response.status >= 200 && response.status < 300 && !isErrData(response.data);
        }
        var cache = {};
        /**
         * Call $http once url is resolved
         *
         * Detect duplicate requests and serve these from cache.
         */
        function http(config) {
            return $q.when(config.url)
                .then(function (url) {
                config.url = url;
                if (config.method !== 'GET') {
                    return $http(config);
                }
                var now = Date.now();
                var key = config.url + angular.toJson(config.params || {});
                var last = cache[key] || null;
                if (last && now - last.now < CACHE_TTL) {
                    console.warn('duplicate request', config.url, 'after', now - last.now, 'ms', config.params);
                    return last.promise;
                }
                var promise = $http(config);
                cache[key] = {
                    now: now,
                    promise: promise,
                };
                return promise;
            })
                .then(function (response) { return isOK(response) ? response.data : $q.reject(response); });
        }
        /**
         * Remove keys prefixed with '_'
         */
        function clean(data, keepId) {
            var blacklist = {
                _type: 1,
                _status: 1,
                _updated: 1,
                _created: 1,
                _etag: 1,
                _links: 1,
                _id: keepId ? 0 : 1,
            }, cleanData = {};
            angular.forEach(data, function (val, key) {
                if (!blacklist[key]) {
                    cleanData[key] = val;
                }
            });
            return cleanData;
        }
        /**
         * Get headers for given item
         */
        function getHeaders(item) {
            var headers = {};
            if (item && item._etag) {
                headers['If-Match'] = item._etag;
            }
            return headers;
        }
        /**
         * API Resource instance
         */
        function Resource(resource, parent) {
            /**
             * @ngdoc property
             * @name api#resource
             * @type {string}
             * @public
             * @description API resource
             */
            this.resource = resource;
            /**
             * @ngdoc property
             * @name api#parent
             * @public
             * @type {string}
             * @description Resource parent.
             */
            this.parent = parent;
        }
        /**
         * @ngdoc method
         * @name api#url
         * @public
         * @description
         * Get resource url.
         */
        Resource.prototype.url = function (_id) {
            function resolve(urlTemplate, data) {
                return urlTemplate.replace(/<.*>/, data._id);
            }
            return urls.resource(this.resource)
                .then(angular.bind(this, function (url) {
                var addr = url;
                if (this.parent) {
                    var newUrl = resolve(url, this.parent);
                    if (newUrl !== addr) {
                        return newUrl;
                    }
                }
                if (_id) {
                    addr = url + '/' + _id;
                }
                return addr;
            }));
        };
        /**
         * @ngdoc method
         * @name api#save
         * @public
         * @description
         * Save an item
         */
        Resource.prototype.save = function (item, diff, params) {
            if (diff && diff._etag) {
                item._etag = diff._etag;
            }
            return http({
                method: item._links ? 'PATCH' : 'POST',
                url: item._links ? urls.item(item._links.self.href) : this.url(),
                data: diff ? clean(diff, !item._links) : clean(item, !item._links),
                params: params,
                headers: getHeaders(item),
            }).then(function (data) {
                delete data._type;
                angular.extend(item, diff || {});
                angular.extend(item, data);
                return item;
            });
        };
        /**
         * @ngdoc method
         * @name api#replace
         * @public
         * @description
         * Replace an item
         */
        Resource.prototype.replace = function (item) {
            return http({
                method: 'PUT',
                url: this.url(item._id),
                data: clean(item),
            });
        };
        /**
         * @ngdoc method
         * @name api#query
         * @public
         * @param {Object} params
         * @param {bool} cache
         * @description
         * Query resource
         */
        Resource.prototype.query = function (params, _cache) {
            return http({
                method: 'GET',
                url: this.url(),
                params: params,
                cache: _cache,
            });
        };
        /**
         * @ngdoc method
         * @name api#getAll
         * @public
         * @param {Object} params
         * @description
         * Retrieve all items of a query
         */
        Resource.prototype.getAll = function (params) {
            function _getAll(page, items) {
                var _this = this;
                if (page === void 0) { page = 1; }
                if (items === void 0) { items = []; }
                return this.query(Object.assign({ max_results: 199, page: page }, params))
                    .then(function (result) {
                    var pg = page;
                    var merged = items.concat(result._items);
                    if (result._links.next) {
                        pg++;
                        // p = p.then(_getAll.call(this, pg, merged));
                        return _getAll.call(_this, pg, merged);
                    }
                    else {
                        // deferred.resolve(merged);
                        return merged;
                    }
                });
            }
            return _getAll.call(this);
        };
        /**
         * @ngdoc method
         * @name api#getById
         * @public
         *
         * @param {String} _id
         * @param {Object} params
         * @param {bool} cache
         *
         * @description
         * Get an item by _id
         */
        Resource.prototype.getById = function (_id, params, _cache) {
            return http({
                method: 'GET',
                url: this.url(_id),
                params: params,
                cache: _cache,
            });
        };
        /**
         * @ngdoc method
         * @name api#remove
         * @public
         *
         * @param {Object} item
         * @param {Object} params
         *
         * @description Remove an item
         */
        Resource.prototype.remove = function (item, params) {
            return http({
                method: 'DELETE',
                url: urls.item(item._links.self.href),
                params: params,
                headers: getHeaders(item),
            });
        };
        // api service
        var api = function apiService(resource, parent) {
            return new Resource(resource, parent);
        };
        /**
         * @alias api(resource).getById(id)
         */
        api.find = function apiFind(resource, id, params, _cache) {
            return api(resource).getById(id, params, _cache);
        };
        /**
         * @alias api(resource).save(dest, diff)
         */
        api.save = function apiSave(resource, dest, diff, parent, params) {
            return api(resource, parent).save(dest, diff, params);
        };
        /**
         * Remove a given item.
         */
        api.remove = function apiRemove(item, params, resource) {
            var url = resource ? getResourceUrl(resource, item, item._id) : urls.item(item._links.self.href);
            return http({
                method: 'DELETE',
                url: url,
                params: params,
                headers: getHeaders(item),
            });
        };
        /**
         * Update item via given resource
         *
         * @param {string} resource
         * @param {Object} item
         * @param {Object} updates
         * @param {Object} params
         */
        api.update = function apiUpdate(resource, item, updates, params) {
            return http({
                method: 'PATCH',
                url: getResourceUrl(resource, item, item._id),
                data: updates,
                params: params,
                headers: getHeaders(item),
            });
        };
        /**
         * Query qiven resource
         *
         * @param {string} resource
         * @param {Object} query
         * @param {Object} parent
         * @param {boolean} cache
         */
        api.query = function apiQuery(resource, query, parent, _cache) {
            return api(resource, parent).query(query, _cache);
        };
        function getResourceUrl(resource, item, id) {
            return api(resource, item).url(id);
        }
        /**
         * @ngdoc method
         * @name api#get
         * @public
         *
         * @param {string} url
         *
         * @description Get on a given url
         */
        api.get = function apiGet(url, params) {
            return http({
                method: 'GET',
                url: urls.item(url),
                params: params,
            });
        };
        api.getAll = function apiGetAll(resource, params) {
            return api(resource).getAll(params);
        };
        angular.forEach(apis, function (config, apiName) {
            var service = config.service || _.noop;
            service.prototype = new endpoints[config.type](apiName, config.backend);
            api[apiName] = $injector.instantiate(service, { resource: service.prototype });
        });
        return api;
    }
}
angular.module('superdesk.core.api.service', [])
    .provider('api', APIProvider);


/***/ }),
/* 672 */
/***/ (function(module, exports) {

/**
 * @ngdoc factory
 * @name HttpEndpointFactory
 * @module superdesk.core.api
 * @description Http endpoint factory
 */
HttpEndpointFactory.$inject = ['$http', '$q', 'urls', 'lodash'];
function HttpEndpointFactory($http, $q, urls, _) {
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getUrl
     * @private
     *
     * @param {Object} resource
     * @returns {Promise}
     *
     * @description Get url for given resource
     */
    function getUrl(resource) {
        return urls.resource(resource.rel);
    }
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getHeaders
     * @private
     *
     * @param {Object} resource
     * @param {Object} item
     * @returns {Object}
     *
     * @description Get headers for given resource
     */
    function getHeaders(resource, item) {
        var headers = _.extend({}, resource.config.headers || {});
        if (item && item._etag) {
            headers['If-Match'] = item._etag;
        }
        return headers;
    }
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#http
     * @private
     *
     * @param {Object} config
     * @returns {Promise}
     *
     * @description Wrap $http call
     */
    function http(config) {
        return $q.when(config.url)
            .then(function (url) {
            config.url = url;
            return $http(config);
        })
            .then(function (response) {
            if (response.status >= 200 && response.status < 300 &&
                (!response.data || !response.data._status || response.data._status !== 'ERR')) {
                return response;
            }
            return $q.reject(response);
        });
    }
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#clean
     * @private
     * @description
     * Remove keys prefixed with '_'
     */
    function clean(data, keepId) {
        var blacklist = {
            _status: 1,
            _updated: 1,
            _created: 1,
            _etag: 1,
            _links: 1,
            _id: keepId ? 0 : 1,
        }, cleanData = {};
        angular.forEach(data, function (val, key) {
            if (!blacklist[key]) {
                cleanData[key] = val;
            }
        });
        return cleanData;
    }
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#HttpEndpoint
     * @private
     * @description
     * Http Endpoint
     */
    function HttpEndpoint(name, config) {
        this.name = name;
        this.config = config;
        this.rel = config.rel;
    }
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getByUrl
     * @public
     *
     * @param {string} url
     * @returns {Promise}
     *
     * @description
     * Get entity by url
     */
    HttpEndpoint.prototype.getByUrl = function (url, cache) {
        return http({
            method: 'GET',
            url: urls.item(url),
            cache: cache,
        }).then(function (response) { return response.data; });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getById
     * @public
     *
     * @param {string} id
     * @returns {Promise}
     *
     * @description
     * Get entity by given id
     */
    HttpEndpoint.prototype.getById = function (id, params, cache) {
        return getUrl(this).then(_.bind(function (resourceUrl) {
            var url = resourceUrl.replace(/\/+$/, '') + '/' + id;
            return http({
                method: 'GET',
                url: url,
                params: params,
                cache: cache,
            }).then(function (response) { return response.data; });
        }, this));
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#query
     * @public
     *
     * @param {Object} params
     *
     * @description
     * Resource query method
     */
    HttpEndpoint.prototype.query = function (params, cache) {
        return http({
            method: 'GET',
            params: params,
            url: getUrl(this),
            headers: getHeaders(this),
            cache: cache,
        }).then(function (response) { return response.data; });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#update
     * @public
     *
     * @param {Object} item
     * @param {Object} diff
     * @param {Object} params
     * @returns {Promise}
     *
     * @description
     * Update item
     */
    HttpEndpoint.prototype.update = function (item, diff, params) {
        var diff2 = diff || angular.extend({}, item);
        if (diff2._etag) {
            item._etag = diff2._etag;
        }
        var url = item._links.self.href;
        return http({
            method: 'PATCH',
            url: urls.item(url),
            data: clean(diff2, !item._links),
            params: params,
            headers: getHeaders(this, item),
        }).then(function (response) {
            _.extend(item, response.data);
            return item;
        });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#create
     * @public
     *
     * @param {Object} itemData
     * @returns {Promise}
     *
     * @description
     * Create new item
     */
    HttpEndpoint.prototype.create = function (itemData) {
        return http({
            method: 'POST',
            url: getUrl(this),
            data: itemData,
            headers: getHeaders(this),
        }).then(function (response) {
            delete response.data._status;
            _.extend(itemData, response.data);
            return itemData;
        });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#save
     * @public
     *
     * @param {Object} item
     * @param {Object} diff
     * @returns {Promise}
     *
     * @description
     * Save item
     */
    HttpEndpoint.prototype.save = function (item, diff) {
        return item._id ? this.update(item, diff) : this.create(_.extend(item, diff));
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#replace
     * @public
     *
     * @param {Object} dest
     * @param {Object} item
     * @returns {Promise}
     *
     * @description
     * Replace item
     */
    HttpEndpoint.prototype.replace = function (dest, item) {
        return http({
            method: 'PUT',
            url: urls.item(dest),
            data: item,
            headers: getHeaders(this, item),
        }).then(function (response) {
            _.extend(item, response.data);
            return item;
        });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#remove
     * @public
     *
     * @param {Object} item
     * @returns {Promise}
     *
     * @description
     * Remove item
     */
    HttpEndpoint.prototype.remove = function (item) {
        return http({
            method: 'DELETE',
            url: urls.item(item._links.self.href),
            headers: getHeaders(this, item),
        }).then(null, function (response) { return response.status === 404 ? $q.when(response) : $q.reject(response); });
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getUrl
     * @public
     *
     * @returns {Promise}
     *
     * @description
     * Get resource url
     */
    HttpEndpoint.prototype.getUrl = function () {
        return getUrl(this);
    };
    /**
     * @ngdoc method
     * @name HttpEndpointFactory#getHeaders
     * @public
     *
     * @return {Object}
     *
     * @description
     * Get headers
     */
    HttpEndpoint.prototype.getHeaders = function () {
        return getHeaders(this) || {};
    };
    return HttpEndpoint;
}
angular.module('superdesk.core.api.http', [])
    .factory('HttpEndpointFactory', HttpEndpointFactory);


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/**
 * Service for re-sending requests
 */
RequestService.$inject = ['$injector'];
function RequestService($injector) {
    // using $injector to avoid circular dependency on $http
    /**
     * @link upload:isUpload
     */
    this.isUpload = function (config) { return $injector.get('upload').isUpload(config); };
    /**
     * Request again using given config
     *
     * @param {Object} config
     * @returns {Promise}
     */
    this.resend = function (config) {
        return this.isUpload(config) ? $injector.get('upload').restart(config) : $injector.get('$http')(config);
    };
}
angular.module('superdesk.core.api.request', [])
    .service('request', RequestService);


/***/ }),
/* 674 */
/***/ (function(module, exports) {

/**
 * Set timeout for requests and notify $rootScope when it is triggered
 */
TimeoutInterceptor.$inject = ['$timeout', '$q', '$rootScope', 'request'];
function TimeoutInterceptor($timeout, $q, $rootScope, request) {
    var TIMEOUT = 3000, TIMEOUT_MAX = 60000, STATUS = {
        OK: 0,
    };
    var IS_VIEW_REGEXP = /\.html?$/;
    $rootScope.serverStatus = STATUS.OK;
    return {
        // set timeout for every request but upload
        xrequest: function (config) {
            if (!IS_VIEW_REGEXP.test(config.url) && !request.isUpload(config)) {
                config._ttl = config._ttl ? Math.min(TIMEOUT_MAX, config._ttl * 2) : TIMEOUT;
                config.timeout = $timeout(function () {
                    config._isTimeout = true;
                }, config._ttl);
            }
            return config;
        },
        // reset server status on success
        xresponse: function (response) {
            if (response.config.timeout) {
                $timeout.cancel(response.config.timeout);
                $rootScope.serverStatus = STATUS.OK;
            }
            return response;
        },
        // repeat request with higher timeout
        xresponseError: function (rejection) {
            if (!rejection.status && !request.isUpload(rejection.config)) {
                $rootScope.serverStatus += 1;
                return request.resend(rejection.config);
            }
            $timeout.cancel(rejection.config.timeout);
            $rootScope.serverStatus = STATUS.OK;
            return $q.reject(rejection);
        },
    };
}
angular.module('superdesk.core.api.timeout', []).factory('timeoutInterceptor', TimeoutInterceptor);


/***/ }),
/* 675 */
/***/ (function(module, exports) {

URLResolver.$inject = ['$http', '$q', '$log', 'config'];
function URLResolver($http, $q, $log, config) {
    var _links, baseUrl = config.server.url;
    function basejoin(path) {
        return baseUrl + (path.indexOf('/') === 0 ? path : '/' + path);
    }
    /**
     * Get url for given resource
     *
     * @param {String} resource
     * @returns Promise
     */
    this.resource = function (resource) {
        return this.links().then(function () {
            if (_links[resource]) {
                return _links[resource];
            }
            $log.warn('resource url not found', resource);
            return $q.reject({ status: 404, resource: resource });
        });
    };
    /**
     * Get server url for given item
     *
     * @param {String} item
     * @returns {String}
     */
    this.item = function (item) {
        return basejoin(item);
    };
    /**
     * Get resource links
     */
    this.links = function () {
        if (_links) {
            return $q.when(_links);
        }
        return fetchResourceLinks();
    };
    /**
     * Get url for media field
     *
     * @param {Object} media
     * @param {String} resource
     * @return {String}
     */
    this.media = function (media, resource) {
        var url = basejoin('upload-raw/' + media._id);
        return resource ? url + '?resource=' + resource : url;
    };
    /**
     * Fetch resource links via root url
     *
     * @returns {Promise}
     */
    function fetchResourceLinks() {
        if (!baseUrl) {
            return $q.reject();
        }
        return $http({
            method: 'GET',
            url: baseUrl,
            cache: true,
        }).then(function (response) {
            _links = {};
            if (response.status === 200) {
                _.each(response.data._links.child, function (link) {
                    _links[link.title] = basejoin(link.href);
                });
            }
            else {
                $q.reject(response);
            }
            return _links;
        });
    }
}
angular.module('superdesk.core.api.urls', [])
    .service('urls', URLResolver);


/***/ }),
/* 676 */
/***/ (function(module, exports) {

angular.module('superdesk.core.api.allowed', [])
    .service('allowed', AllowedService);
AllowedService.$inject = ['lodash', 'api', '$q'];
function AllowedService(_, api, $q) {
    var _this = this;
    var values;
    function fetch() {
        if (values) {
            return $q.when(values);
        }
        return api.get('allowed_values')
            .then(function (response) {
            values = {};
            response._items.forEach(function (item) {
                values[item._id] = item.items;
            });
            return values;
        });
    }
    /**
     * Get allowed values for resource.field
     *
     * @param {String} resource
     * @param {String} field
     * @return {Promise}
     */
    this.get = function (resource, field) {
        return fetch().then(function () { return values[resource + '.' + field] || []; });
    };
    /**
     * Filter object keys using allowed values
     *
     * @param {Object} all
     * @param {String} resource
     * @param {String} field
     * @return {Promise}
     */
    this.filterKeys = function (all, resource, field) {
        return _this.get(resource, field).then(function (allowed) {
            var filtered = {};
            Object.keys(all).forEach(function (key) {
                var isAllowed = _.find(allowed, function (val) { return key.indexOf(val) === 0; });
                if (isAllowed) {
                    filtered[key] = all[key];
                }
            });
            return filtered;
        });
    };
}


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(678);
// scripts
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(679);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./auth.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./auth.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.login-screen {\n  position: fixed;\n  z-index: 9000;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background-color: #323232; }\n  .login-screen .logo-handler {\n    margin-bottom: 60px; }\n  .login-screen .login-form-container {\n    box-sizing: border-box;\n    width: 320px;\n    height: 600px;\n    padding: 0 15px;\n    position: absolute;\n    top: 50%;\n    margin-top: -300px;\n    left: 50%;\n    margin-left: -125px;\n    padding-top: 80px; }\n    .login-screen .login-form-container .session-error {\n      position: absolute;\n      top: 0;\n      width: 240px;\n      padding-top: 10px;\n      padding-bottom: 10px;\n      border-radius: 3px;\n      color: #fff;\n      font-size: 11px;\n      background-color: #bc7c0e;\n      text-align: center;\n      margin: 0; }\n    .login-screen .login-form-container .form-handler {\n      width: 240px; }\n      .login-screen .login-form-container .form-handler .avatar {\n        width: 160px;\n        height: 160px;\n        margin: 0 auto 35px;\n        float: none; }\n      .login-screen .login-form-container .form-handler form .inputs input {\n        margin-bottom: 18px;\n        height: 38px;\n        border-radius: 4px !important;\n        border: 1px solid #000 !important;\n        box-shadow: inset 0 2px 0 0 #ccc, 0 1px 0 0 #656565 !important;\n        font-size: 13px;\n        line-height: 25px; }\n      .login-screen .login-form-container .form-handler form .buttons button {\n        width: 100%;\n        position: relative; }\n      .login-screen .login-form-container .form-handler .links {\n        border-top: 1px solid #484848;\n        padding-top: 10px; }\n      .login-screen .login-form-container .form-handler .text {\n        color: #898989;\n        margin-bottom: 10px;\n        display: block; }\n        .login-screen .login-form-container .form-handler .text:hover {\n          text-decoration: underline;\n          cursor: pointer; }\n      .login-screen .login-form-container .form-handler .reset-info {\n        color: #ccc;\n        margin-bottom: 20px; }\n        .login-screen .login-form-container .form-handler .reset-info i {\n          vertical-align: sub; }\n      .login-screen .login-form-container .form-handler .transition-id {\n        color: #f5f5f5;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        display: block;\n        font-size: 50px;\n        font-weight: bold;\n        text-align: center; }\n      .login-screen .login-form-container .form-handler .validation-info {\n        margin: -10px 0 10px; }\n        .login-screen .login-form-container .form-handler .validation-info span {\n          color: #f4c78b;\n          font-size: 12px; }\n      .login-screen .login-form-container .form-handler .error-handler .error {\n        background: #9d0202;\n        padding: 12px;\n        color: #fff;\n        font-size: 12px;\n        line-height: 18px;\n        border-radius: 4px; }\n      .login-screen .login-form-container .form-handler .error-handler .network-error {\n        height: 44px;\n        border-radius: 3px; }\n        .login-screen .login-form-container .form-handler .error-handler .network-error span {\n          width: 46px;\n          height: 44px;\n          float: left;\n          border-radius: 3px 0 0 3px;\n          background-repeat: no-repeat;\n          background-position: 8px 7px;\n          opacity: 0.6;\n          filter: \"alpha(opacity=60)\"; }\n        .login-screen .login-form-container .form-handler .error-handler .network-error p {\n          margin-left: 46px;\n          color: #fff;\n          padding: 6px;\n          line-height: 16px;\n          font-size: 12px; }\n        .login-screen .login-form-container .form-handler .error-handler .network-error.red {\n          background-color: #7a1212; }\n          .login-screen .login-form-container .form-handler .error-handler .network-error.red span {\n            background-color: #910707; }\n        .login-screen .login-form-container .form-handler .error-handler .network-error.yellow {\n          background-color: #bc7c0e; }\n          .login-screen .login-form-container .form-handler .error-handler .network-error.yellow span {\n            background-color: #de8f05; }\n        .login-screen .login-form-container .form-handler .error-handler .network-error.green {\n          background-color: #157310; }\n          .login-screen .login-form-container .form-handler .error-handler .network-error.green span {\n            background-color: #0c8507; }\n  .login-screen .spinner {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    text-align: center;\n    right: 9px;\n    top: 6px;\n    -webkit-animation: rotate 2.0s infinite linear;\n    animation: rotate 2.0s infinite linear; }\n  .login-screen .dot1, .login-screen .dot2 {\n    width: 60%;\n    height: 60%;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    background-color: #fff;\n    border-radius: 100%;\n    -webkit-animation: bounce 2.0s infinite ease-in-out;\n    animation: bounce 2.0s infinite ease-in-out; }\n  .login-screen .dot2 {\n    top: auto;\n    bottom: 0px;\n    -webkit-animation-delay: -1.0s;\n    animation-delay: -1.0s; }\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n    -webkit-transform: rotate(360deg); } }\n\n@keyframes bounce {\n  0%, 100% {\n    transform: scale(0);\n    -webkit-transform: scale(0); }\n  50% {\n    transform: scale(1);\n    -webkit-transform: scale(1); } }\n", ""]);

// exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Expire session on 401 server response
 */
AuthExpiredInterceptor.$inject = ['session', '$q', '$injector', '$browser', 'config', 'lodash'];
function AuthExpiredInterceptor(session, $q, $injector, $browser, config, _) {
    function handleAuthExpired(response) {
        $browser.$$completeOutstandingRequest(angular.noop);
        session.expire();
        return session.getIdentity().then(function () {
            var $http = $injector.get('$http');
            $browser.$$incOutstandingRequestCount();
            $http.defaults.headers.common.Authorization = session.token;
            response.config.headers.Authorization = session.token;
            return $injector.get('request').resend(response.config);
        });
    }
    return {
        response: function (response) {
            if (_.startsWith(response.config.url, config.server.url) && response.status === 401) {
                return handleAuthExpired(response);
            }
            return response;
        },
        responseError: function (response) {
            if (_.startsWith(response.config.url, config.server.url) && response.status === 401) {
                if (!((response.data || {})._issues || {}).credentials) {
                    return handleAuthExpired(response);
                }
            }
            return $q.reject(response);
        },
    };
}
angular.module('superdesk.core.auth.interceptor', ['superdesk.core.api', 'superdesk.core.auth.session'])
    .service('AuthExpiredInterceptor', AuthExpiredInterceptor);
ResetPassworController.$inject = ['$scope', '$location', 'api', 'notify'];
function ResetPassworController($scope, $location, api, notify) {
    $scope.isSending = false;
    $scope.isReseting = false;
    var resetForm = function () {
        $scope.email = '';
        $scope.token = '';
        $scope.password = '';
        $scope.passwordConfirm = '';
    };
    $scope.sendToken = function () {
        $scope.sendTokenError = null;
        api.resetPassword.create({ email: $scope.email })
            .then(function (result) {
            notify.success(utils_1.gettext('Link sent. Please check your email inbox.'));
            $scope.flowStep = 2;
        }, function (rejection) {
            $scope.sendTokenError = rejection.status;
        });
        resetForm();
    };
    $scope.resetPassword = function () {
        $scope.setPasswordError = null;
        api.resetPassword.create({ token: $scope.token, password: $scope.password })
            .then(function (result) {
            notify.success(utils_1.gettext('Password was changed. You can login using your new password.'));
            $location.path('/').search({});
        }, function (rejection) {
            $scope.setPasswordError = rejection.status;
        });
        resetForm();
    };
    resetForm();
    var query = $location.search();
    if (query.token) {
        api.resetPassword.create({ token: query.token })
            .then(function (result) {
            $scope.token = query.token;
            $scope.flowStep = 3;
        }, function (rejection) {
            $scope.setPasswordError = rejection.status;
            $scope.flowStep = 1;
        });
    }
    else {
        $scope.flowStep = 1;
    }
}
/**
 * @ngdoc controller
 * @module superdesk.core.auth
 * @name SecureLoginController
 * @description this controller handles XMPP auth (aka secure login), it create
 * transaction ID (which will be sent to XMPP client) and redirect page on success.
 */
SecureLoginController.$inject = ['$scope', 'auth', '$route', '$window'];
function SecureLoginController(scope, auth, $route, $window) {
    var random = Math.floor(Math.random() * 10000 + 1);
    scope.transactionId = random.toString();
    scope.authenticateXMPP = function () {
        scope.isLoading = true;
        scope.loginError = null;
        auth.loginXMPP(scope.jid || '', scope.transactionId || '')
            .then(function () {
            scope.isLoading = false;
            $window.location.replace('/'); // reset page for new user
        }, function (rejection) {
            scope.isLoading = false;
            scope.loginError = rejection.status;
        });
    };
}
angular.module('superdesk.core.auth.session', [])
    .constant('SESSION_EVENTS', {
    LOGIN: 'login',
    LOGOUT: 'logout',
    IDENTITY_LOADED: 'identity_loaded',
});
/**
 * @ngdoc module
 * @module superdesk.core.auth
 * @name superdesk.core.auth
 * @packageName superdesk.core
 * @description Superdesk core authentication and session related functionalities.
 */
exports.default = angular.module('superdesk.core.auth', [
    'superdesk.core.features',
    'superdesk.core.activity',
    'superdesk.core.auth.session',
    'superdesk.core.services.asset',
    'superdesk.config',
    'superdesk.core.auth.auth',
    'superdesk.core.auth.basic',
    'superdesk.core.auth.login',
    'superdesk.core.auth.interceptor',
])
    .config(['$httpProvider', 'superdeskProvider', 'assetProvider', function ($httpProvider, superdesk, asset) {
        $httpProvider.interceptors.push('AuthExpiredInterceptor');
        superdesk
            .activity('/reset-password/', {
            controller: ResetPassworController,
            templateUrl: asset.templateUrl('core/auth/reset-password.html'),
            auth: false,
        });
        superdesk
            .activity('/secure-login/', {
            controller: SecureLoginController,
            templateUrl: asset.templateUrl('core/auth/secure-login.html'),
            auth: false,
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('resetPassword', {
            type: 'http',
            backend: {
                rel: 'reset_user_password',
            },
        });
        apiProvider.api('auth', {
            type: 'http',
            backend: {
                rel: 'auth',
            },
        });
    }])
    // watch session token, identity
    .run(['$rootScope', '$http', '$window', 'session', 'api', 'superdeskFlags', 'authoringWorkspace',
    'modal', 'SESSION_EVENTS',
    function ($rootScope, $http, $window, session, api, superdeskFlags, authoringWorkspace, modal, SESSION_EVENTS) {
        $rootScope.logout = function () {
            function replace() {
                session.clear();
                $window.location.replace('/'); // reset page for new user
            }
            var canLogout = true;
            if (superdeskFlags.flags.authoring) {
                var item = authoringWorkspace.getItem();
                if (item && item._autosaved) {
                    canLogout = false;
                    modal.confirm(utils_1.gettext('There are some unsaved changes. Please save them before signing out.'), utils_1.gettext('Warning'), utils_1.gettext('OK'), '');
                }
            }
            if (canLogout) {
                api.auth.getById(session.sessionId).then(function (sessionData) {
                    api.auth.remove(sessionData).then(replace, replace);
                });
            }
        };
        // populate current user
        $rootScope.$watch(function watchSessionIdentity() {
            return session.identity;
        }, function (identity) {
            $rootScope.currentUser = session.identity;
            $rootScope.$broadcast(SESSION_EVENTS.IDENTITY_LOADED);
        });
        // set auth header
        $rootScope.$watch(function watchSessionToken() {
            return session.token;
        }, function (token) {
            if (token) {
                $http.defaults.headers.common.Authorization = token;
                $rootScope.sessionId = session.sessionId;
            }
            else {
                delete $http.defaults.headers.common.Authorization;
                $rootScope.sessionId = null;
            }
        });
    }]);


/***/ }),
/* 681 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @module superdesk.core.auth
 * @name auth
 * @description auth-service handles the authentication by sending crendentials
 * to backend endpoints.
 */
angular.module('superdesk.core.auth.auth', []).service('auth', ['api', 'session', 'authAdapter',
    function (api, session, authAdapter) {
        /**
         * @ngdoc method
         * @name auth#login
         * @param {string} username User's login
         * @param {string} password Users's password
         * @returns {Promise} If successful, session identity is returned
         * @description authenticate user using database auth
         */
        this.login = function (username, password) {
            return authAdapter.authenticate(username, password)
                .then(function (sessionData) { return api.users.getById(sessionData.user)
                .then(function (userData) {
                session.start(sessionData, userData);
                return session.identity;
            }); });
        };
        /**
         * @ngdoc method
         * @name auth#loginOAuth
         * @param {Object} data
         * @return {Promise}
         */
        this.loginOAuth = function (response) {
            authAdapter.setToken(response);
            return api.users.getById(response.data.user)
                .then(function (userData) {
                session.start(response.data, userData);
                return session.identity;
            });
        };
        /**
         * @ngdoc method
         * @name auth#loginXMPP
         * @param {string} jid XMPP identified (Jabber ID)
         * @param {string} transactionId ID which will be sent to the device, to check transaction
         * @returns {Promise} If successful, session identity is returned
         * @description authenticate user using XMPP auth (aka secure login)
         */
        this.loginXMPP = function (jid, transactionId) {
            return authAdapter.authenticateXMPP(jid, transactionId)
                .then(function (sessionData) { return api.users.getById(sessionData.user)
                .then(function (userData) {
                session.start(sessionData, userData);
                return session.identity;
            }); });
        };
    }]);


/***/ }),
/* 682 */
/***/ (function(module, exports) {

/**
 * Session Service stores current user data
 */
angular.module('superdesk.core.auth.session').service('session', [
    '$q',
    '$rootScope',
    'storage',
    'SESSION_EVENTS',
    function ($q, $rootScope, storage, SESSION_EVENTS) {
        var TOKEN_KEY = 'sess:token';
        var TOKEN_HREF = 'sess:href';
        var IDENTITY_KEY = 'sess:user';
        var SESSION_ID = 'sess:id';
        var IDENTITY_BLACKLIST = [
            'session_preferences',
            'user_preferences',
            'allowed_actions',
            'workspace',
        ];
        var defer;
        this.token = null;
        this.identity = null;
        this.sessionId = null;
        /**
     * Get identity when available
     *
     * @returns {object} promise
     */
        this.getIdentity = function () {
            if (this.identity && this.token) {
                return $q.when(this.identity);
            }
            defer = defer ? defer : $q.defer();
            return defer.promise;
        };
        /**
     * Update identity
     *
     * @param {object} updates
     * @returns {object} identity
     */
        this.updateIdentity = function (updates) {
            var identity = this.identity || {};
            _.extend(identity, updates);
            this.identity = _.omit(identity, IDENTITY_BLACKLIST);
            storage.setItem(IDENTITY_KEY, this.identity);
            return this.identity;
        };
        /**
     * Start a new session
     *
     * @param {object} session
     * @param {object} identity
     */
        this.start = function (session, identity) {
            this.token = session.token;
            this.sessionId = session._id;
            setToken(session.token);
            setSessionId(session._id);
            setSessionHref(session._links && session._links.self.href);
            this.identity = null;
            resolveIdentity(this.updateIdentity(identity));
            $rootScope.$broadcast(SESSION_EVENTS.LOGIN);
        };
        function resolveIdentity(identity) {
            if (defer) {
                defer.resolve(identity);
                defer = null;
            }
        }
        /**
     * Set current session expired
     */
        this.expire = function () {
            this.token = null;
            this.sessionId = null;
            setToken(null);
            setSessionId(null);
            $rootScope.$broadcast(SESSION_EVENTS.LOGOUT);
        };
        /**
     * Clear session info
     */
        this.clear = function () {
            this.expire();
            this.identity = null;
            setSessionHref(null);
            setSessionId(null);
            storage.clear();
        };
        /**
     * Return session url for delete
     *
     * @returns {string}
     */
        this.getSessionHref = function () {
            return localStorage.getItem(TOKEN_HREF);
        };
        /**
     * Setup test user with given id.
     *
     * @param {string} _id
     */
        this.testUser = function (_id) {
            this.token = 1;
            this.identity = { _id: _id };
            this.sessionId = 's' + _id;
        };
        $rootScope.$watch(getToken, angular.bind(this, function (token) {
            this.token = token;
            this.identity = storage.getItem(IDENTITY_KEY);
            this.sessionId = localStorage.getItem(SESSION_ID);
            if (this.identity && this.token) {
                resolveIdentity(this.identity);
            }
        }));
        /**
     * Save token into local storage
     *
     * @param {string} token
     */
        function setToken(token) {
            if (token) {
                localStorage.setItem(TOKEN_KEY, token);
            }
            else {
                localStorage.removeItem(TOKEN_KEY);
            }
        }
        /**
     * Save session id into local storage
     *
     * @param {string} sessionId
     */
        function setSessionId(sessionId) {
            if (sessionId) {
                localStorage.setItem(SESSION_ID, sessionId);
            }
            else {
                localStorage.removeItem(SESSION_ID);
            }
        }
        function setSessionHref(href) {
            if (href) {
                localStorage.setItem(TOKEN_HREF, href);
            }
            else {
                localStorage.removeItem(TOKEN_HREF);
            }
        }
        /**
     * Get token from local storage
     *
     * it's used via watch so it skips json serialization withing storage service
     *
     * @returns string
     */
        function getToken() {
            return localStorage.getItem(TOKEN_KEY) || null;
        }
    }
]);


/***/ }),
/* 683 */
/***/ (function(module, exports) {

/**
 * @ngdoc service
 * @module superdesk.core.auth
 * @name authAdapter
 * @description auth-service handles the authentication by sending crendentials
 * to backend endpoints.
 */
angular.module('superdesk.core.auth.basic', [])
    .service('authAdapter', ['$http', 'urls', function ($http, urls) {
        var _this = this;
        /**
         * Set token using response object
         *
         * @param {Object} response
         * @return {Object} response.data
         */
        this.setToken = function (response) {
            response.data.token = formatToken(response.data.token);
            $http.defaults.headers.common.Authorization = response.data.token;
            return response.data;
        };
        /**
         * @ngdoc method
         * @name authAdapter#authenticate
         * @param {string} username User's login
         * @param {string} password Users's password
         * @returns {Promise} If successful, session data is returned, including session token
         * @description authenticate user using database auth
         */
        this.authenticate = function (username, password) { return urls.resource('auth_db')
            .then(function (url) { return $http.post(url, { username: username, password: password }); })
            .then(_this.setToken); };
        /**
         * @ngdoc method
         * @name authAdapter#authenticateXMPP
         * @param {string} jid XMPP identified (Jabber ID)
         * @param {string} transactionId ID which will be sent to the device, to check transaction
         * @returns {Promise} If successful, session data is returned, including session token
         * @description authenticate user using XMPP auth (aka secure login)
         */
        this.authenticateXMPP = function (jid, transactionId) { return urls.resource('auth_xmpp')
            .then(function (url) { return $http.post(url, { jid: jid, transactionId: transactionId }); })
            .then(_this.setToken); };
        /**
         * Format token for basic auth
         *
         * @param {string} token
         * @return {string}
         */
        function formatToken(token) {
            return token.startsWith('Basic') ? token : 'Basic ' + btoa(token + ':');
        }
    }]);


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * Login modal is watching session token and displays modal when needed
 */
angular.module('superdesk.core.auth.login', []).directive('sdLoginModal', [
    'session',
    'auth',
    'features',
    'config',
    'deployConfig',
    'usersService',
    'notify',
    '$route',
    function (session, auth, features, config, deployConfig, usersService, notify, $route) {
        return {
            replace: true,
            // login template can be overriden (like on superdesk-fi)
            templateUrl: 'scripts/core/auth/login-modal.html',
            link: function (scope, element, attrs) {
                scope.features = features;
                scope.changePassword = false;
                deployConfig.all({
                    xmpp: 'xmpp_auth',
                    saml: 'saml_auth',
                    google: 'google_auth',
                }).then(function (methods) {
                    scope.methods = methods;
                });
                deployConfig.all({
                    saml: 'saml_label',
                }).then(function (labels) {
                    scope.labels = labels;
                });
                scope.authenticate = function () {
                    scope.isLoading = true;
                    scope.loginError = null;
                    auth.login(scope.username || '', scope.password || '')
                        .then(function () {
                        scope.isLoading = false;
                        scope.password = null;
                        reloadRoute();
                    }, function (rejection) {
                        scope.isLoading = false;
                        if (rejection.data._issues.password_is_expired) {
                            scope.changePassword = true;
                            scope.oldPassword = scope.password;
                            scope.password = null;
                            scope.passwordConfirm = null;
                        }
                        scope.loginError = rejection.status;
                        if (scope.loginError === 401) {
                            scope.password = null;
                        }
                    });
                };
                scope.changeUserPassword = function () {
                    scope.isLoading = true;
                    usersService.changePassword(scope.username, scope.oldPassword, scope.password)
                        .then(function () {
                        scope.isLoading = false;
                        scope.changePassword = false;
                        scope.password = null;
                        scope.loginError = null;
                        notify.success(utils_1.gettext('The password has been changed.'), 3000);
                    }, function (response) {
                        scope.isLoading = false;
                        scope.changePassword = null;
                        scope.passwordConfirm = null;
                        notify.success(utils_1.gettext('Failed to change the password.'), 3000);
                    });
                };
                scope.openLoginPopup = function (service) {
                    window.open(apiUrl + '/login/' + service);
                };
                var apiUrl = lodash_1.default.get(config, 'server.url', '')
                    .replace('api/', 'api'); // make sure there is no trailing /
                var handleAuthMessage = function (event) {
                    if (event.origin === apiUrl.replace('/api', '') && event.data.type === 'oauth') {
                        var message_1 = event.data;
                        if (message_1.data.token) {
                            auth.loginOAuth(message_1);
                            reloadRoute();
                        }
                        else {
                            scope.$apply(function () {
                                scope.loginError = message_1.data.error;
                            });
                        }
                    }
                    return false;
                };
                window.addEventListener('message', handleAuthMessage);
                scope.$on('$destroy', function () {
                    window.removeEventListener('message', handleAuthMessage);
                });
                function reloadRoute() {
                    if ($route.current && $route.current.redirectTo) {
                        $route.reload();
                    }
                }
                scope.$watchGroup([function getSessionToken() {
                        return session.token;
                    }, 'requiredLogin'], function showLogin(triggerLogin) {
                    scope.isLoading = false;
                    scope.identity = session.identity;
                    scope.sessionId = session.sessionId;
                    scope.username = session.identity ? session.identity.UserName : null;
                    scope.password = null;
                    if (!triggerLogin[0] && triggerLogin[1] === true) {
                        scope.active = true;
                        var focusElem = scope.username ? 'password' : 'username';
                        element.find('#login-' + focusElem).focus();
                    }
                    else {
                        scope.active = false;
                    }
                });
            },
        };
    }
]);


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(686);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
angular.module('superdesk.core.services.beta', ['superdesk.core.preferences'])
    /**
     * Superdesk service for enabling/disabling beta preview in app
     */
    .service('betaService', ['$window', '$rootScope', '$q', 'preferencesService',
    function ($window, $rootScope, $q, preferencesService) {
        $rootScope.beta = null;
        this.toggleBeta = function () {
            var update = {
                'feature:preview': {
                    default: false,
                    enabled: !$rootScope.beta,
                    label: 'Enable Feature Preview',
                    type: 'bool',
                    category: 'feature',
                },
            };
            preferencesService.update(update, 'feature:preview').then(function () {
                $rootScope.beta = !$rootScope.beta;
                $window.location.reload();
            });
        };
        this.isBeta = function () {
            if (lodash_1.default.isNil($rootScope.beta)) {
                return preferencesService.get('feature:preview').then(function (result) {
                    $rootScope.beta = result && result.enabled;
                    return $rootScope.beta;
                }, function () { return $q.when(false); });
            }
            return $q.resolve($rootScope.beta);
        };
    }])
    .config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push(BetaTemplateInterceptor);
    }]);
/**
 * Detect beta elements in phase of loading html templates and prevent rendering of those
 */
BetaTemplateInterceptor.$inject = ['$q', '$templateCache', 'betaService'];
function BetaTemplateInterceptor($q, $templateCache, betaService) {
    var modifiedTemplates = {};
    var HAS_FLAGS_EXP = /sd-beta/, IS_HTML_PAGE = /\.html$|\.html\?/i;
    return {
        response: function (response) {
            var url = response.config.url;
            if (!modifiedTemplates[url] && IS_HTML_PAGE.test(url) && HAS_FLAGS_EXP.test(response.data)) {
                var template = $('<div>').append(response.data);
                return betaService.isBeta().then(function (beta) {
                    if (!beta) {
                        template.find('[sd-beta]').each(function () {
                            $(this).remove();
                        });
                    }
                    response.data = template.html();
                    $templateCache.put(url, response.data);
                    modifiedTemplates[url] = true;
                    return response;
                }, function () {
                    response.data = template.html();
                    $templateCache.put(url, response.data);
                    modifiedTemplates[url] = true;
                    return response;
                });
            }
            return response;
        },
    };
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(381);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
var moment_timezone_1 = __importDefault(__webpack_require__(380));
DateTimeDirective.$inject = ['datetime', 'moment'];
function DateTimeDirective(datetime, moment) {
    return {
        scope: { date: '=', fromNow: '=' },
        link: function datetimeLink(scope, elem) {
            scope.$watch('date', renderDate);
            /**
             * Render relative date within given directive
             *
             * @param {string} date iso date
             */
            function renderDate(date) {
                var momentDate = moment(date);
                var txt = scope.fromNow ? momentDate.fromNow() : datetime.shortFormat(momentDate);
                elem.text(txt);
                elem.attr('title', momentDate.format('LLLL'));
            }
        },
    };
}
ShortDateDirective.$inject = ['config', 'moment'];
function ShortDateDirective(config, moment) {
    var DATE_FORMAT = config.view.dateformat || config.model.dateformat;
    return {
        scope: { date: '=' },
        link: function dateLink(scope, elem) {
            scope.$watch('date', renderDate);
            /**
             * Render short date within given directive
             *
             * @param {string} date iso date
             */
            function renderDate(date) {
                var momentDate = moment(date);
                var text = momentDate.format(DATE_FORMAT);
                if (momentDate) {
                    elem.text(text);
                    elem.attr('title', text);
                }
            }
        },
    };
}
DateTimeService.$inject = ['moment', 'config'];
function DateTimeService(moment, config) {
    var ISO_DATE_FORMAT = 'YYYY-MM-DD';
    var ISO_WEEK_FORMAT = 'YYYY-W';
    var ISO_YEAR_FORMAT = 'YYYY';
    var LONG_FORMAT = config.longDateFormat || 'LLL';
    var TIME_FORMAT = config.shortTimeFormat || 'hh:mm';
    var DATE_FORMAT = config.shortDateFormat || 'MM/DD';
    var WEEK_FORMAT = config.shortWeekFormat || 'dddd, ' + TIME_FORMAT;
    var ARCHIVE_FORMAT = config.ArchivedDateFormat || DATE_FORMAT;
    /**
     * Get short representation of given datetime
     *
     * It returns time for current day, day + time for current week, date otherwise.
     *
     * @param {String} d iso format datetime
     * @return {String}
     */
    this.shortFormat = function (d) {
        var m = moment(d);
        var now = moment();
        if (isSameDay(m, now)) {
            return m.format(TIME_FORMAT);
        }
        else if (isSameWeek(m, now)) {
            return m.format(WEEK_FORMAT);
        }
        else if (isArchiveYear(m, now)) {
            return m.format(ARCHIVE_FORMAT);
        }
        return m.format(DATE_FORMAT);
    };
    /**
     * Get long representation of given datetime
     *
     * @param {String} d iso format datetime
     * @return {String}
     */
    this.longFormat = function (d) {
        return moment(d).format(LONG_FORMAT);
    };
    function isSameDay(a, b) {
        return a.format(ISO_DATE_FORMAT) === b.format(ISO_DATE_FORMAT);
    }
    function isSameWeek(a, b) {
        return a.format(ISO_WEEK_FORMAT) === b.format(ISO_WEEK_FORMAT);
    }
    function isArchiveYear(a, b) {
        return (config.ArchivedDateOnCalendarYear === 1) ?
            a.format(ISO_YEAR_FORMAT) !== b.format(ISO_YEAR_FORMAT) : b.diff(a, 'years') >= 1;
    }
}
DateTimeHelperService.$inject = ['moment', 'config'];
function DateTimeHelperService(moment, config) {
    /*
    * @param timestring 2016-03-01T04:45:00+0000
    * @param timezone Europe/London
    */
    this.splitDateTime = function (timestring, timezone) {
        var momentTS = moment.tz(timestring, timezone);
        return {
            date: momentTS.format(config.model.dateformat),
            time: momentTS.format(config.model.timeformat),
        };
    };
    this.isValidTime = function (value, format) {
        var timeFormat = format || config.model.timeformat;
        return moment(value, timeFormat, true).isValid();
    };
    this.isValidDate = function (value, format) {
        var dateFormat = format || config.model.dateformat;
        return moment(value, dateFormat, true).isValid();
    };
    this.mergeDateTime = function (dateStr, timeStr, timezone) {
        var tz = timezone || config.defaultTimezone;
        var mergeStr = dateStr + ' ' + timeStr;
        var formatter = config.model.dateformat + ' ' + config.model.timeformat;
        // return without timezone information, which is stored separately
        return moment.tz(mergeStr, formatter, tz).format('YYYY-MM-DD[T]HH:mm:ss');
    };
    /*
    * @param timestring 2016-03-01T04:45:00+0000.
    */
    this.greaterThanUTC = function (timestring) {
        return moment(timestring, 'YYYY-MM-DDTHH:mm:ssZZ') > moment.utc();
    };
    /**
     * Remove tz info from given datetime
     *
     * it's added automatically on server for every datetime like values
     *
     * @param {String} datetime
     * @return {String}
     */
    this.removeTZ = function (datetime) {
        if (datetime) {
            return datetime.replace('+0000', '').replace('+00:00', '');
        }
    };
}
/**
 * @ngdoc module
 * @module superdesk.core.datetime
 * @name superdesk.core.datetime
 * @packageName superdesk.core
 * @description Superdesk core date & time module.
 */
exports.default = angular.module('superdesk.core.datetime', [
    'superdesk.config',
    'ngResource',
    'superdesk.core.datetime.absdate',
    'superdesk.core.datetime.groupdates',
    'superdesk.core.datetime.relativeDate',
    'superdesk.core.datetime.reldatecomplex',
    'superdesk.core.datetime.reldate',
    'superdesk.core.translate',
])
    .config(['defaultConfigProvider', function (defaultConfig) {
        defaultConfig.set('shortTimeFormat', 'HH:mm'); // 24h format
    }])
    .directive('sdDatetime', DateTimeDirective)
    .directive('sdShortDate', ShortDateDirective)
    .filter('reldate', ['moment', function reldateFactory(moment) {
        return function reldate(date) {
            return moment(date).fromNow();
        };
    }])
    /**
     * Returns the difference between given date and the
     * current datetime in hours
     *
     * @param {Datetime} date iso format datetime
     * @return {Int} hours
     */
    .filter('hoursFromNow', ['moment', function hoursFromNowFactory(moment) {
        return function hoursFromNow(date) {
            var difference = moment().diff(moment(date));
            var d = moment.duration(difference);
            var s = Math.floor(d.asHours());
            return s;
        };
    }])
    // format datetime obj to time string
    .filter('time', ['config', 'moment', function timeFilterFactory(config, moment) {
        var TIME_FORMAT = config.view ? config.view.timeformat : 'h:mm';
        return function timeFilter(time) {
            var m = moment(time, 'HH:mm:ss');
            return m.format(TIME_FORMAT);
        };
    }])
    .constant('moment', moment_timezone_1.default)
    .factory('weekdays', [function () {
        return Object.freeze({
            MON: utils_1.gettext('Monday'),
            TUE: utils_1.gettext('Tuesday'),
            WED: utils_1.gettext('Wednesday'),
            THU: utils_1.gettext('Thursday'),
            FRI: utils_1.gettext('Friday'),
            SAT: utils_1.gettext('Saturday'),
            SUN: utils_1.gettext('Sunday'),
        });
    }])
    /**
     *   A service that automatically fetches the time zone data from the
     *   server upon instantiaton and stores it internally for future use,
     *   avoiding the need to fetch it again every time when needed.
     */
    .factory('tzdata', ['$resource', function ($resource) {
        var filename = 'scripts/apps/dashboard/world-clock/timezones-all.json', tzResource = $resource(filename);
        /**
         * Returns a sorted list of all time zone names. If time zone data
         * has not yet been fetched from the server, an empty list is
         * returned.
         * To determine whether or not the data has been fetched yet, the
         * $promise property should be examined.
         *
         * @method getTzNames
         * @return {Array} a list of time zone names
         */
        tzResource.prototype.getTzNames = function () {
            return lodash_1.default.union(lodash_1.default.keys(this.zones), lodash_1.default.keys(this.links)).sort();
        };
        // return an array that will contain the fetched data when
        // it arrives from the server
        return tzResource.get();
    }])
    .service('datetime', DateTimeService)
    .service('datetimeHelper', DateTimeHelperService);


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__(5));
/**
 * sdGroupDates directive will group list items by a date provided as a param.
 *
 * Usage:
 * <li ng-repeat="item in items" ng-model="item" sd-group-dates="updated">
 *
 * Params:
 * @scope {object} ngModel
 * @scope {string} sdGroupDates - model field to group by
 */
angular.module('superdesk.core.datetime.groupdates', []).directive('sdGroupDates', [function () {
        var lastDate = null;
        var COMPARE_FORMAT = 'YYYY-M-D';
        var DISPLAY_DATE_FORMAT = 'D. MMMM YYYY';
        var DISPLAY_CDATE_FORMAT = 'D. MMMM';
        var DISPLAY_DAY_FORMAT = 'dddd, ';
        var DISPLAY_TODAY_FORMAT = '[Today], ';
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$render = function () {
                    var date = moment_1.default.utc(ngModel.$viewValue[attrs.sdGroupDates]);
                    if (scope.$first || lastDate.format(COMPARE_FORMAT) !== date.format(COMPARE_FORMAT)) {
                        var fdate;
                        var fday;
                        if (moment_1.default().format(COMPARE_FORMAT) === date.format(COMPARE_FORMAT)) {
                            fday = date.format(DISPLAY_TODAY_FORMAT);
                        }
                        else {
                            fday = date.format(DISPLAY_DAY_FORMAT);
                        }
                        if (moment_1.default().format('YYYY') === date.format('YYYY')) {
                            fdate = date.format(DISPLAY_CDATE_FORMAT);
                        }
                        else {
                            fdate = date.format(DISPLAY_DATE_FORMAT);
                        }
                        element.prepend('<div class="date"><span>' + fday + fdate + '</span></div>');
                        element.addClass('with-date');
                        lastDate = date;
                    }
                };
            },
        };
    }]);


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(691),n=__webpack_require__(382),p=__webpack_require__(76),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 692 */
/***/ (function(module, exports) {

/**
 * Display relative date in <time> element
 *
 * Usage:
 * <span sd-reldate datetime="user._created"></span>
 *
 * Params:
 * @param {object} datetime - datetime string in utc
 */
angular.module('superdesk.core.datetime.reldate', []).directive('sdReldate', [function () {
        return {
            scope: { datetime: '=' },
            template: '<sd-relative-date datetime="datetime"></sd-relative-date>',
        };
    }]);


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var moment_1 = __importDefault(__webpack_require__(5));
/**
 * Display relative date in <time> element
 *
 * Usage:
 * <span sd-reldate-complex data-useutc="false" datetime="user._created"></span>
 *
 * Params:
 * @param {object} datetime - datetime string in utc
 * @param {boolean} useutc - if true vlues are converted to local datetime
 */
ReldateComplex.$inject = ['config'];
function ReldateComplex(config) {
    var COMPARE_FORMAT = config.model.dateformat;
    var DATE_FORMAT = config.view.dateformat || config.model.dateformat;
    var TIME_FORMAT = config.view.timeformat || config.model.timeformat;
    var DISPLAY_DATE_FORMAT = DATE_FORMAT + ' ' + TIME_FORMAT;
    var DISPLAY_DAY_FORMAT = 'dddd ';
    var DISPLAY_TODAY_FORMAT = '[Today]';
    return {
        scope: {
            datetime: '=',
            useutc: '=',
        },
        template: '<time datetime="{{ datetimeIso }}"><span>{{rday}}, &nbsp;{{ rdate }}</span></time>',
        link: function (scope, element, attrs, ngModel) {
            var useutc = angular.isUndefined(scope.useutc) ? true : !!scope.useutc;
            scope.$watch('datetime', function (datetime) {
                var date = moment_1.default.utc(scope.datetime);
                if (useutc) {
                    date.local(); // switch to local time zone
                }
                scope.datetimeIso = date.toISOString();
                if (moment_1.default().format(COMPARE_FORMAT) === date.format(COMPARE_FORMAT)) {
                    scope.rday = utils_1.gettext(date.format(DISPLAY_TODAY_FORMAT));
                }
                else {
                    scope.rday = date.format(DISPLAY_DAY_FORMAT);
                }
                scope.rdate = date.format(DISPLAY_DATE_FORMAT);
            });
        },
    };
}
angular.module('superdesk.core.datetime.reldatecomplex', []).directive('sdReldateComplex', ReldateComplex);


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var moment_1 = __importDefault(__webpack_require__(5));
/**
 * Display absolute date in <time> element
 *
 * Usage:
 * <span sd-absdate datetime="user._created"></span>
 *
 * Params:
 * @param {object} datetime - datetime string in utc
 */
angular.module('superdesk.core.datetime.absdate', []).directive('sdAbsdate', [
    function () {
        var COMPARE_FORMAT = 'YYYY-M-D';
        var DISPLAY_DATE_FORMAT = 'D. MMMM YYYY HH:mm';
        var DISPLAY_CDATE_FORMAT = 'D. MMMM HH:mm';
        var DISPLAY_DAY_FORMAT = 'dddd, ';
        var DISPLAY_TODAY_FORMAT = '[' + utils_1.gettext('Today') + '], ';
        return {
            scope: {
                datetime: '=',
            },
            template: '<time datetime="{{ datetimeIso }}"><span>{{ rday }}{{ rdate }}</span></time>',
            link: function (scope) {
                scope.$watch('datetime', function (datetime) {
                    var date = moment_1.default.utc(scope.datetime);
                    date.local(); // switch to local time zone
                    scope.datetimeIso = date.toISOString();
                    if (moment_1.default().format(COMPARE_FORMAT) === date.format(COMPARE_FORMAT)) {
                        scope.rday = date.format(DISPLAY_TODAY_FORMAT);
                    }
                    else {
                        scope.rday = date.format(DISPLAY_DAY_FORMAT);
                    }
                    if (moment_1.default().format('YYYY') === date.format('YYYY')) {
                        scope.rdate = date.format(DISPLAY_CDATE_FORMAT);
                    }
                    else {
                        scope.rdate = date.format(DISPLAY_DATE_FORMAT);
                    }
                });
            },
        };
    },
]);


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(696);


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var raven_js_1 = __importDefault(__webpack_require__(165));
ErrorHttpInterceptorFactory.$inject = ['$q'];
function ErrorHttpInterceptorFactory($q) {
    return {
        responseError: function responseError(rejection) {
            if (rejection.status >= 500 && rejection.status < 600) {
                raven_js_1.default.captureException(new Error('HTTP response error'), {
                    tags: { component: 'server' },
                    extra: {
                        status: rejection.status,
                        request: rejection.config,
                        response: rejection.data,
                    },
                });
            }
            return $q.reject(rejection);
        },
    };
}
/**
 * @ngdoc module
 * @module superdesk.core.error
 * @name superdesk.core.error
 * @packageName superdesk.core
 * @description Superdesk error reporting module.
 */
angular.module('superdesk.core.error', [])
    .config(['config', '$httpProvider', '$provide', function (config, $httpProvider, $provide) {
        if (config.raven && config.raven.dsn) {
            raven_js_1.default.config(config.raven.dsn, {
                logger: 'javascript-client',
                release: config.version,
            }).install();
            $httpProvider.interceptors.push(ErrorHttpInterceptorFactory);
            $provide.factory('$exceptionHandler', function () { return function errorCatcherHandler(exception, cause) {
                raven_js_1.default.captureException(exception, { tags: { component: 'ui' }, extra: exception });
            }; });
        }
    }]);


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(698);
__webpack_require__(699);


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.elastic
 * @name superdesk.core.elastic
 * @packageName superdesk.core
 * @description Superdesk ES-related UI interactions.
 */
exports.default = angular.module('superdesk.core.elastic', []);


/***/ }),
/* 699 */
/***/ (function(module, exports) {

/**
 * Elastic search query builder service
 */
angular.module('superdesk.core.elastic').service('es', [function () {
        var SIZE_DEFAULT = 25;
        /**
         * Set from/size for given query and params
         *
         * @param {Object} query
         * @param {Object} params
         * @returns {Object}
         */
        function paginate(query, params) {
            var page = params.page || 1;
            query.size = params.size || SIZE_DEFAULT;
            query.from = (page - 1) * query.size;
            return query;
        }
        /**
         * Build query using elastic query dsl
         *
         * @param {Object} params
         * @param {Array} filters
         * @returns {Object}
         */
        function buildQuery(params, filters) {
            var query = { filtered: {} };
            if (filters && filters.length) {
                query.filtered.filter = { and: filters };
            }
            if (params.q) {
                query.filtered.query = { query_string: { query: params.q } };
            }
            return paginate({ query: query }, params);
        }
        return buildQuery;
    }]);


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.core.filters', [])
    .filter('body', function () { return function (content) {
    var lines = $(content);
    var texts = [];
    for (var i = 0; i < lines.length; i++) {
        var el = $(lines[i]);
        if (el.is('p')) {
            texts.push(el[0].outerHTML);
        }
    }
    return texts.join('\n');
}; })
    .filter('mergeWords', [function () {
        return function (array, propertyName, schemeName, returnArray) {
            var subjectMerged = [];
            lodash_1.default.forEach(array, function (item) {
                var value = lodash_1.default.isNil(propertyName) ? item : item[propertyName];
                if (value) {
                    subjectMerged.push(value);
                    if (schemeName && item.scheme !== schemeName) {
                        subjectMerged.pop();
                    }
                }
            });
            if (returnArray) {
                return subjectMerged;
            }
            return subjectMerged.join(', ');
        };
    }])
    .filter('splitWords', function () { return function (word) {
    var split = [];
    lodash_1.default.forEach(word.split(','), function (w) {
        var trim = w.replace(/^\s+|\s+$/g, '');
        split.push({ name: trim });
    });
    return split;
}; })
    .filter('trusted', ['$sce', function ($sce) {
        return function (value) {
            return $sce.trustAsResourceUrl(value);
        };
    }])
    .filter('filterObject', ['$filter', function ($filter) {
        return function (items, fields) {
            var filtered = [];
            angular.forEach(items, function (item) {
                filtered.push(item);
            });
            return $filter('filter')(filtered, fields);
        };
    }])
    .filter('menuGroup', function () { return function (input) {
    if (!input || !input.category) {
        return '#/';
    }
    return '#' + input.href;
}; })
    .filter('truncateString', function () { return function (inputString, limit, postfix) {
    return lodash_1.default.truncate(inputString, { length: limit, omission: postfix || '...' });
}; })
    .filter('formatDateTimeString', ['moment', function (moment) {
        return function (input, formatString) {
            var momentTimestamp = angular.isDefined(input) ? moment(input).utc() : moment.utc();
            return angular.isDefined(formatString) ? momentTimestamp.format(formatString)
                : momentTimestamp.format();
        };
    }])
    .filter('formatLocalDateTimeString', ['moment', function (moment) {
        return function (input, formatString) {
            var momentTimestamp = angular.isDefined(input) ? moment(input).utc() : moment.utc();
            return angular.isDefined(formatString) ? momentTimestamp.local().format(formatString) :
                momentTimestamp.local().format();
        };
    }])
    .filter('dateTimeString', ['$filter', function ($filter) {
        return function (input) {
            if (input !== null) {
                return $filter('date')(input, 'dd.MM.yyyy HH:mm');
            }
        };
    }])
    .filter('dateTimeStringWithSecs', ['$filter', function ($filter) {
        return function (input) {
            if (input !== null) {
                return $filter('date')(input, 'dd.MM.yyyy HH:mm:ss');
            }
        };
    }])
    .filter('queueStatus', function () {
    return function (input) {
        if (input === 'pending') {
            return 'warning';
        }
        else if (input === 'success') {
            return 'success';
        }
        else if (input === 'error') {
            return 'danger';
        }
    };
})
    .filter('mergeTargets', function () { return function (array) {
    var merged = [];
    lodash_1.default.forEach(array, function (item) {
        if ('allow' in item) {
            merged.push(item.allow === false ? 'Not ' + item.name : item.name);
        }
        else {
            merged.push(item.name);
        }
    });
    return merged.join(', ');
}; })
    .filter('previewDateline', ['$filter', 'moment', function ($filter, moment) {
        return function (located, source, datelineDate) {
            if (lodash_1.default.isObject(located) && angular.isDefined(located.city)) {
                var momentizedTimestamp = angular.isDefined(datelineDate) ? moment.utc(datelineDate) : moment.utc();
                var _month = '';
                if (angular.isDefined(located) && located.tz !== 'UTC') {
                    momentizedTimestamp = momentizedTimestamp.tz(located.tz);
                }
                var currentMonth = momentizedTimestamp.month() + 1;
                if (currentMonth === 9) {
                    _month = 'Sept ';
                }
                else if (currentMonth >= 3 && currentMonth <= 7) {
                    _month = momentizedTimestamp.format('MMMM');
                }
                else {
                    _month = momentizedTimestamp.format('MMM');
                }
                return $filter('formatDatelineText')(located, _month, momentizedTimestamp.format('D'), source);
            }
            return '';
        };
    }])
    .filter('daysInAMonth', ['moment', function (moment) { return function (month) {
        var _timeStamp = Number.isInteger(month) ? moment(month + 1, 'MM') : moment();
        return Array.from({ length: _timeStamp.daysInMonth() }, function (value, index) { return (index + 1).toString(); });
    }; }])
    .filter('parseDateline', ['moment', function (moment) { return function (dateToFormat, located) {
        var momentizedTimestamp = dateToFormat ? moment.utc(dateToFormat) : moment.utc();
        if (angular.isDefined(located) && located.tz !== 'UTC') {
            momentizedTimestamp = momentizedTimestamp.tz(located.tz);
        }
        return { month: momentizedTimestamp.month().toString(), day: momentizedTimestamp.format('D') };
    }; }])
    .filter('formatDatelineText', function () { return function (located, month, date, source) {
    if (source === void 0) { source = ''; }
    var dateline = located.city_code;
    var datelineFields = located.dateline.split(',');
    if (lodash_1.default.indexOf(datelineFields, 'state')) {
        dateline.concat(', ', located.state_code);
    }
    if (lodash_1.default.indexOf(datelineFields, 'country')) {
        dateline.concat(', ', located.country_code);
    }
    return dateline.toUpperCase().concat(', ', month, ' ', date, ' ', source, ' -');
}; })
    .filter('relativeUTCTimestamp', ['moment', function (moment) { return function (located, month, date) {
        var currentTSInLocated = located.tz === 'UTC' ? moment.utc() : moment().tz(located.tz);
        currentTSInLocated.month(month).date(date);
        return currentTSInLocated.toISOString();
    }; }])
    .filter('sortByName', function () { return function (_collection, propertyName) {
    if (propertyName === void 0) { propertyName = 'name'; }
    return lodash_1.default.sortBy(_collection, function (_entry) { return _entry[propertyName] ?
        _entry[propertyName].toLowerCase()
        : _entry.name.toLowerCase(); });
}; })
    .filter('formatFilterCondition', function () { return function (filterCondition, valueLookup) {
    var labels = [];
    if (filterCondition.field === 'anpa_category' || filterCondition.field === 'subject') {
        var values = filterCondition.value.split(',');
        lodash_1.default.each(values, function (value) {
            var v = lodash_1.default.find(valueLookup, function (val) { return val.qcode.toString() === value; });
            labels.push(v.name);
        });
    }
    var conditionValue = labels.length > 0 ? labels.join(', ') : filterCondition.value;
    return '(' + filterCondition.field + ' ' + filterCondition.operator + ' ' + conditionValue + ')';
}; })
    .filter('removeLodash', function () { return function (value) {
    var cleanedValue = value || '';
    return cleanedValue.replace('_', ' ');
}; })
    .filter('stripHtmlTags', function () { return function (value) {
    return utils_1.stripHtmlTags(value);
}; })
    .filter('join', function () { return function (value, separator) {
    if (separator === void 0) { separator = ', '; }
    return value.filter(angular.identity).join(separator);
}; });

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.services
 * @name superdesk.core.services
 * @packageName superdesk.core
 * @description Various core services that can be used with Superdesk.
 */
__webpack_require__(702);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
var serverConfig_1 = __webpack_require__(727);
angular.module('superdesk.core.services', [
    'superdesk.core.services.beta',
    'superdesk.core.services.data',
    'superdesk.core.services.modal',
    'superdesk.core.services.dragdrop',
    'superdesk.core.services.server',
    'superdesk.core.services.entity',
    'superdesk.core.services.permissions',
    'superdesk.core.services.storage',
    'superdesk.core.services.pageTitle',
])
    .service('serverConfig', serverConfig_1.ServerConfigService);


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(703);
var lang_1 = __webpack_require__(167);
var moment_1 = __importDefault(__webpack_require__(5));
/**
 * Translate module
 *
 * This module provides localization support.
 * It's using angular-gettext.
 */
exports.default = angular.module('superdesk.core.translate', [
    'gettext',
    'superdesk.core.auth.session',
    'tmh.dynamicLocale',
    'ngLocale',
])
    .config(['tmhDynamicLocaleProvider', function (tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern('locales/angular-locale_{{locale}}.js');
    }])
    .run(['gettextCatalog', 'config', '$location', '$rootScope', 'SESSION_EVENTS', 'tmhDynamicLocale',
    function (gettextCatalog, config, $location, $rootScope, SESSION_EVENTS, tmhDynamicLocale) {
        $rootScope.$on(SESSION_EVENTS.IDENTITY_LOADED, function (event) {
            if ($rootScope.$root.currentUser
                && config.profileLanguages.includes($rootScope.$root.currentUser.language)) {
                // if the current logged in user has a saved language preference that is available
                gettextCatalog.setCurrentLanguage($rootScope.$root.currentUser.language);
            }
            else if (config.language) {
                gettextCatalog.setCurrentLanguage(config.language);
            }
            else if (config.profileLanguages.includes(window.navigator.language)) {
                // no saved preference but browser language is available
                gettextCatalog.setCurrentLanguage(window.navigator.language);
            }
            else {
                // no other options available go with baseLanguage
                gettextCatalog.setCurrentLanguage(gettextCatalog.baseLanguage);
            }
            // load translations synchronously(blocking) in order to prevent caching of default strings
            if (gettextCatalog.currentLanguage !== 'en') {
                gettextCatalog.loadRemoteSync('languages/' + gettextCatalog.currentLanguage + '.json');
            }
            // add lang override strings
            $rootScope.$applyAsync(function () { return lang_1.addLangOverride(gettextCatalog, gettextCatalog.currentLanguage); });
            // set locale for date/time management
            moment_1.default.locale(gettextCatalog.currentLanguage);
            // set locale for angular-i18n
            tmhDynamicLocale.set(gettextCatalog.currentLanguage.replace('_', '-').toLowerCase());
        });
        var params = $location.search();
        if ('lang' in params) {
            gettextCatalog.currentLanguage = params.lang;
            gettextCatalog.debug = true;
        }
    }])
    /**
     * @ngdoc factory
     * @module superdesk.core.services
     * @name gettext
     *
     * @description
     * Gettext service to be used in controllers/services/directives.
     *
     * Usage:
     * ```js
     * function($scope, gettext) { $scope.translatedMessage = gettext("Translate Me"); }
     * ```
     *
     * This way "Translate Me" can be found by the string extractor and it will return
     * translated string if appropriet.
     */
    .factory('gettext', ['gettextCatalog', function (gettextCatalog) {
        return function (input) {
            return gettextCatalog.getString(input);
        };
    }]);


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return (factory());
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {
'use strict';
angular.module('tmh.dynamicLocale', []).config(['$provide', function($provide) {
  function makeStateful($delegate) {
    $delegate.$stateful = true;
    return $delegate;
  }

  $provide.decorator('dateFilter', ['$delegate', makeStateful]);
  $provide.decorator('numberFilter', ['$delegate', makeStateful]);
  $provide.decorator('currencyFilter', ['$delegate', makeStateful]);

}])
.constant('tmhDynamicLocale.STORAGE_KEY', 'tmhDynamicLocale.locale')
.provider('tmhDynamicLocale', ['tmhDynamicLocale.STORAGE_KEY', function(STORAGE_KEY) {

  var defaultLocale,
    localeLocationPattern = 'angular/i18n/angular-locale_{{locale}}.js',
    nodeToAppend,
    storageFactory = 'tmhDynamicLocaleStorageCache',
    storage,
    storageKey = STORAGE_KEY,
    promiseCache = {},
    activeLocale,
    extraProperties = {};

  /**
   * Loads a script asynchronously
   *
   * @param {string} url The url for the script
   @ @param {function} callback A function to be called once the script is loaded
   */
  function loadScript(url, callback, errorCallback, $timeout) {
    var script = document.createElement('script'),
      element = nodeToAppend ? nodeToAppend : document.getElementsByTagName("body")[0],
      removed = false;

    script.type = 'text/javascript';
    if (script.readyState) { // IE
      script.onreadystatechange = function () {
        if (script.readyState === 'complete' ||
            script.readyState === 'loaded') {
          script.onreadystatechange = null;
          $timeout(
            function () {
              if (removed) return;
              removed = true;
              element.removeChild(script);
              callback();
            }, 30, false);
        }
      };
    } else { // Others
      script.onload = function () {
        if (removed) return;
        removed = true;
        element.removeChild(script);
        callback();
      };
      script.onerror = function () {
        if (removed) return;
        removed = true;
        element.removeChild(script);
        errorCallback();
      };
    }
    script.src = url;
    script.async = true;
    element.appendChild(script);
  }

  /**
   * Loads a locale and replaces the properties from the current locale with the new locale information
   *
   * @param {string} localeUrl The path to the new locale
   * @param {Object} $locale The locale at the curent scope
   * @param {string} localeId The locale id to load
   * @param {Object} $rootScope The application $rootScope
   * @param {Object} $q The application $q
   * @param {Object} localeCache The current locale cache
   * @param {Object} $timeout The application $timeout
   */
  function loadLocale(localeUrl, $locale, localeId, $rootScope, $q, localeCache, $timeout) {

    function overrideValues(oldObject, newObject) {
      if (activeLocale !== localeId) {
        return;
      }
      angular.forEach(oldObject, function(value, key) {
        if (!newObject[key]) {
          delete oldObject[key];
        } else if (angular.isArray(newObject[key])) {
          oldObject[key].length = newObject[key].length;
        }
      });
      angular.forEach(newObject, function(value, key) {
        if (angular.isArray(newObject[key]) || angular.isObject(newObject[key])) {
          if (!oldObject[key]) {
            oldObject[key] = angular.isArray(newObject[key]) ? [] : {};
          }
          overrideValues(oldObject[key], newObject[key]);
        } else {
          oldObject[key] = newObject[key];
        }
      });
    }


    if (promiseCache[localeId]) {
      activeLocale = localeId;
      return promiseCache[localeId];
    }

    var cachedLocale,
      deferred = $q.defer();
    if (localeId === activeLocale) {
      deferred.resolve($locale);
    } else if ((cachedLocale = localeCache.get(localeId))) {
      activeLocale = localeId;
      $rootScope.$evalAsync(function() {
        overrideValues($locale, cachedLocale);
        storage.put(storageKey, localeId);
        $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
        deferred.resolve($locale);
      });
    } else {
      activeLocale = localeId;
      promiseCache[localeId] = deferred.promise;
      loadScript(localeUrl, function() {
        // Create a new injector with the new locale
        var localInjector = angular.injector(['ngLocale']),
          externalLocale = localInjector.get('$locale');

        overrideValues($locale, externalLocale);
        localeCache.put(localeId, externalLocale);
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          storage.put(storageKey, localeId);
          $rootScope.$broadcast('$localeChangeSuccess', localeId, $locale);
          deferred.resolve($locale);
        });
      }, function() {
        delete promiseCache[localeId];

        $rootScope.$applyAsync(function() {
          if (activeLocale === localeId) {
            activeLocale = $locale.id;
          }
          $rootScope.$broadcast('$localeChangeError', localeId);
          deferred.reject(localeId);
        });
      }, $timeout);
    }
    return deferred.promise;
  }

  this.localeLocationPattern = function(value) {
    if (value) {
      localeLocationPattern = value;
      return this;
    } else {
      return localeLocationPattern;
    }
  };

  this.appendScriptTo = function(nodeElement) {
    nodeToAppend = nodeElement;
  };

  this.useStorage = function(storageName) {
    storageFactory = storageName;
  };

  this.useCookieStorage = function() {
    this.useStorage('$cookieStore');
  };

  this.defaultLocale = function(value) {
    defaultLocale = value;
  };

  this.storageKey = function(value) {
    if (value) {
      storageKey = value;
      return this;
    } else {
      return storageKey;
    }
  };

  this.addLocalePatternValue = function(key, value) {
    extraProperties[key] = value;
  };

  this.$get = ['$rootScope', '$injector', '$interpolate', '$locale', '$q', 'tmhDynamicLocaleCache', '$timeout', function($rootScope, $injector, interpolate, locale, $q, tmhDynamicLocaleCache, $timeout) {
    var localeLocation = interpolate(localeLocationPattern);

    storage = $injector.get(storageFactory);
    $rootScope.$evalAsync(function() {
      var initialLocale;
      if ((initialLocale = (storage.get(storageKey) || defaultLocale))) {
        loadLocaleFn(initialLocale);
      }
    });
    return {
      /**
       * @ngdoc method
       * @description
       * @param {string} value Sets the locale to the new locale. Changing the locale will trigger
       *    a background task that will retrieve the new locale and configure the current $locale
       *    instance with the information from the new locale
       */
      set: loadLocaleFn,
      /**
       * @ngdoc method
       * @description Returns the configured locale
       */
      get: function() {
        return activeLocale;
      }
    };

    function loadLocaleFn(localeId) {
      var baseProperties = {locale: localeId, angularVersion: angular.version.full};
      return loadLocale(localeLocation(angular.extend({}, extraProperties, baseProperties)), locale, localeId, $rootScope, $q, tmhDynamicLocaleCache, $timeout);
    }
  }];
}]).provider('tmhDynamicLocaleCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales');
  }];
}).provider('tmhDynamicLocaleStorageCache', function() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('tmh.dynamicLocales.store');
  }];
}).run(['tmhDynamicLocale', angular.noop]);

return 'tmh.dynamicLocale';

}));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.preferences', ['superdesk.core.notify', 'superdesk.core.auth.session'])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name preferencesService
     *
     * @requires https://docs.angularjs.org/api/ng/service/$injector $injector
     * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
     * @requires https://docs.angularjs.org/api/ng/service/$q $q
     * @requires session
     * @requires notify
     *
     * @description Preferences Service (TODO)
     */
    .service('preferencesService', ['$injector', '$rootScope', '$q', 'session', 'notify', 'lodash',
    function PreferencesService($injector, $rootScope, $q, session, notify, _) {
        var USER_PREFERENCES = 'user_preferences', SESSION_PREFERENCES = 'session_preferences', ACTIVE_PRIVILEGES = 'active_privileges', ACTIONS = 'allowed_actions', userPreferences = {
            'feature:preview': 1,
            'archive:view': 1,
            'email:notification': 1,
            'desktop:notification': 1,
            'slack:notification': 1,
            'workqueue:items': 1,
            'dashboard:ingest': 1,
            'agg:view': 1,
            'workspace:active': 1,
            'categories:preferred': 1,
            'desks:preferred': 1,
            'destination:active': 1,
            'spellchecker:status': 1,
            'singleline:view': 1,
            'contacts:view': 1,
            'monitoring:view': 1,
            'cvs:preferred_items': 1,
        }, preferences, preferencesPromise;
        $rootScope.$watch(function () { return session.token; }, resetPreferences);
        /**
         * @ngdoc method
         * @name preferencesService#getPrivileges
         * @public
         * @returns {Promise}
         *
         * @description Get privileges for current user.
         */
        this.getPrivileges = function getPrivileges() {
            return this.get().then(function () { return preferences[ACTIVE_PRIVILEGES] || {}; });
        };
        /**
         * @ngdoc method
         * @name preferencesService#getActions
         * @public
         *
         * @returns {Promise}
         *
         * @description Get available content actions for current user.
         */
        this.getActions = function getActions() {
            return this.get().then(function () { return preferences[ACTIONS] || []; });
        };
        /**
         * @ngdoc object
         * @name preferencesService#desktopNotification
         * @public
         *
         * @returns {object}
         *
         * @description All the methods related to desktop notifications
         */
        var desktopNotification = {
            // ask for permission
            requestPermission: function () {
                if ('Notification' in window) {
                    Notification.requestPermission();
                }
            },
            // ask for permission and send a desktop notification
            send: function (msg) {
                if (_.get(preferences, 'user_preferences.desktop:notification.enabled')) {
                    if ('Notification' in window && Notification.permission !== 'denied') {
                        Notification.requestPermission(function (permission) {
                            if (permission === 'granted') {
                                // tslint:disable-next-line:no-unused-expression
                                new Notification(msg);
                            }
                        });
                    }
                }
            },
        };
        this.desktopNotification = desktopNotification;
        /**
         * @ngdoc method
         * @name preferencesService#getPreferences
         * @private
         *
         * @description Fetch preferences from server and store local copy.
         * On next call it will remove local copy and fetch again.
         */
        function getPreferences(cached) {
            var api = $injector.get('api');
            preferences = null;
            preferencesPromise = session.getIdentity()
                .then(fetchPreferences)
                .then(null, function (response) {
                if (response && response.status === 404) {
                    return fetchPreferences();
                }
                return $q.reject(response);
            })
                .then(setPreferences);
            /**
             * Fetch preferences for current session
             *
             * @return {Promise}
             */
            function fetchPreferences() {
                return api.find('preferences', session.sessionId, null, cached);
            }
            /**
             * Set preferences to memory for further usage
             */
            function setPreferences(_preferences) {
                preferences = _preferences;
                initPreferences(preferences);
                return preferences;
            }
        }
        /**
         * Get preference value from user or session preferences based on key.
         *
         * @param {string} key
         * @returns {Object}
         */
        function getValue(key) {
            if (!key) {
                return preferences[USER_PREFERENCES];
            }
            else if (userPreferences[key]) {
                return preferences[USER_PREFERENCES][key];
            }
            return preferences[SESSION_PREFERENCES][key];
        }
        /**
         * @ngdoc method
         * @name preferencesService#get
         * @private
         * @returns {Promise}
         *
         * @param {string} key
         * @param {boolean} force
         *
         * @description Get preference value, in case preferences are not
         * loaded yet it will fetch it. Parameter force is used to bypass
         * the cache.
         */
        this.get = function (key, force) {
            if (!preferencesPromise || force) {
                getPreferences(!force);
            }
            return preferencesPromise.then(returnValue);
            function returnValue() {
                return getValue(key);
            }
        };
        this.registerUserPreference = function (key) {
            userPreferences[key] = 1;
        };
        /**
         * @ngdoc method
         * @name preferencesService#update
         * @private
         *
         * @param {object} updatesObject
         * @param {string} key
         *
         * @description
         * Update preferences
         *
         * It's done in 2 steps - schedule and commit. Schedule caches the changes
         * and calls commit async. Following calls to update in same $digest will
         * only cache changes. In next $digest those changes are pushed to api.
         * This way we can update multiple preferences without getting etag conflicts.
         */
        this.update = function (updatesObject, key) {
            if (!key || userPreferences[key]) {
                return scheduleUpdate(USER_PREFERENCES, updatesObject);
            }
            return scheduleUpdate(SESSION_PREFERENCES, updatesObject);
        };
        var updates, deferUpdate;
        /**
         * Schedule an update.
         *
         * Cache the changes and schedule a commit if it's first update in currect $digest.
         *
         * @param {string} type
         * @param {object} _updates
         */
        function scheduleUpdate(type, _updates) {
            angular.extend(preferences[type], _updates);
            // schedule commit
            if (!updates) {
                updates = {};
                deferUpdate = $q.defer();
                $rootScope.$applyAsync(commitUpdates);
            }
            // adding updates to current schedule
            updates[type] = updates[type] || {};
            angular.extend(updates[type], _updates);
            return deferUpdate.promise;
        }
        /**
         * Commit updates.
         */
        function commitUpdates() {
            var api = $injector.get('api'), serverUpdates = updates;
            updates = null;
            return api.save('preferences', preferences, serverUpdates)
                .then(function (result) {
                preferences._etag = result._etag;
                deferUpdate.resolve(result);
                return result;
            }, function (response) {
                console.error(response);
                deferUpdate.reject(response);
            })
                .finally(function () {
                deferUpdate = null;
            });
        }
        /**
         * Make preferences reload after session expiry - token is set from something to null.
         */
        function resetPreferences(newId, oldId) {
            if (oldId && !newId) {
                preferencesPromise = null;
            }
        }
        /**
         * Make sure all segments are presented in preferences.
         */
        function initPreferences(prefs) {
            if (_.get(prefs, 'user_preferences.desktop:notification.enabled')) {
                desktopNotification.requestPermission();
            }
            angular.forEach([
                USER_PREFERENCES,
                SESSION_PREFERENCES,
                ACTIVE_PRIVILEGES,
                ACTIONS,
            ], function (key) {
                if (_.isNil(prefs[key])) {
                    prefs[key] = {};
                }
            });
        }
    }]);


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc service
 * @module superdesk.core.services
 * @name permissionsService
 *
 * @description
 * #### Permissions service
 *
 * Permissions service checks if a given user or role is able to perform given actions.
 *
 * Usage:
 *
 * Checking user/permissions:
 *
 * ```js
 * permissionsService.isUserAllowed(permissions, user);
 * ```
 *
 * Params:
 *
 * {Object} permissions - permissions object in {resource: {action: true/false, ...}, ...}
 * format.
 *
 * {Object} user - user object as returned from server.
 *
 * If no user is given, current logged in user will be assumed.
 *
 * Checking role/permissions:
 *
 * ```js
 * permissionsService.isRoleAllowed(permissions, role);
 * ```
 *
 * {Object} permissions - permissions object in {resource: {action: true/false, ...}, ...}
 * format.
 *
 * {Object} role - role object as returned from server.
 */
exports.default = angular.module('superdesk.core.services.permissions', [])
    .service('permissionsService', ['$q', '$rootScope', 'em', function ($q, $rootScope, em) {
        this.isUserAllowed = function (permissions, user) {
            var self = this;
            var delay = $q.defer();
            var usr = user || $rootScope.currentUser;
            if (usr.role) {
                if (typeof usr.role === 'string') {
                    em.repository('user_roles')
                        .find(usr.role)
                        .then(function (role) {
                        delay.resolve(self.isRoleAllowed(permissions, role));
                    });
                }
                else {
                    delay.resolve(this.isRoleAllowed(permissions, usr.role));
                }
            }
            else {
                delay.resolve(false);
            }
            return delay.promise;
        };
        this._isRoleAllowedSingle = function (resource, method, role) {
            var self = this;
            var delay = $q.defer();
            if (role.permissions && role.permissions[resource] && role.permissions[resource][method]) {
                delay.resolve(true);
            }
            else if (role.extends) {
                em.repository('user_roles')
                    .find(role.extends)
                    .then(function (extendedFrom) {
                    delay.resolve(self._isRoleAllowedSingle(resource, method, extendedFrom));
                });
            }
            return delay.promise;
        };
        this.isRoleAllowed = function (permissions, role) {
            var self = this;
            var delay = $q.defer();
            var promises = [];
            lodash_1.default.forEach(permissions, function (methods, resource) {
                lodash_1.default.forEach(methods, function (status, method) {
                    promises.push(self._isRoleAllowedSingle(resource, method, role));
                });
            });
            $q.all(promises).then(function (results) {
                if (results.indexOf(false) === -1) {
                    delay.resolve(true);
                }
                else {
                    delay.resolve(false);
                }
            });
            return delay.promise;
        };
    }]);


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.services.data', [])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name LocationStateAdapter
     *
     * @requires https://docs.angularjs.org/api/ng/service/$location $location
     *
     * @description Location State Adapter for Data Layer.
     */
    .service('LocationStateAdapter', ['$location', function ($location) {
        this.get = function (key) {
            return arguments.length ? $location.search()[key] : $location.search();
        };
        this.set = function (key, val) {
            return $location.search(key, val);
        };
    }])
    /**
     * @ngdoc factory
     * @module superdesk.core.services
     * @name DataAdapter
     *
     * @requires em
     * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
     * @requires LocationStateAdapter
     *
     * @param {Object} resource Resource.
     * @param {Object} params Paramters.
     *
     * @description Returns a data provider for a given resource.
     */
    .factory('DataAdapter', ['$rootScope', 'em', 'LocationStateAdapter',
    function ($rootScope, em, LocationStateAdapter) {
        return function DataAdapter(resource, params) {
            var self = this;
            var state = LocationStateAdapter; // @todo implement storage state adapter
            var cancelWatch = angular.noop;
            var defaultParams = { page: 1 };
            /**
             * Get query criteria - extend default params with current search
             */
            function getQueryCriteria() {
                var criteria = angular.extend({}, defaultParams, state.get());
                angular.extend(criteria.where, lodash_1.default.pick(state.get(), defaultParams.filters));
                if (criteria.hasOwnProperty('_id')) {
                    // prevent reload on preview
                    delete criteria._id;
                }
                return criteria;
            }
            /**
             * Log slow query into console
             *
             * @param {Object} query
             */
            function slowQueryLog(query) {
                query.time = Date.now() - query.start;
                if (query.time > 500) {
                    console.info('Slow query', query);
                }
            }
            /**
             * @ngdoc method
             * @name DataAdapter#query
             * @public
             * @returns {Promise} Promise.
             *
             * @param {Object} criteria
             *
             * @description Execute query.
             */
            this.query = function (criteria) {
                self.loading = true;
                var query = { resource: resource, criteria: criteria, start: Date.now() };
                var promise = em.getRepository(resource).matching(criteria);
                return promise.then(function (data) {
                    self.loading = false;
                    slowQueryLog(query);
                    angular.extend(self, data);
                    return data;
                });
            };
            /**
             * @ngdoc method
             * @name DataAdapter#page
             * @public
             *
             * @param {Integer} page
             *
             * @description Get/set current page.
             */
            this.page = function (page) {
                switch (arguments.length) {
                    case 0:
                        return state.get('page') || defaultParams.page;
                    case 1:
                        if (this._items) {
                            state.set('page', page !== defaultParams.page ? page : null);
                        }
                }
            };
            /**
             * @ngdoc method
             * @name DataAdapter#search
             * @public
             * @returns {Object} chainable
             *
             * @param {String} q
             * @param {String} df
             *
             * @description Get/set current search query.
             */
            this.search = function (q, df) {
                switch (arguments.length) {
                    case 0:
                        return state.get('q');
                    case 1:
                        if (this._items) {
                            state.set('q', q);
                            state.set('df', df);
                            state.set('page', null);
                        }
                }
                return this;
            };
            /**
             * @ngdoc method
             * @name DataAdapter#where
             * @public
             *
             * @param {String} key
             * @param {String} val
             *
             * @description Get/set filter
             */
            this.where = function (key, val) {
                switch (arguments.length) {
                    case 1:
                        return state.get(key) || null;
                    case 2:
                        state.set(key, val || null);
                        state.set('page', null);
                }
                return this;
            };
            /**
             * @ngdoc method
             * @name DataAdapter#find
             * @public
             *
             * @param {Object} id ID
             *
             * @description Get single item by ID.
             */
            this.find = function (id) {
                return em.find(resource, id);
            };
            /**
             * @ngdoc method
             * @name DataAdapter#reset
             * @public
             *
             * @param {Object} paramsObject Paramters.
             *
             * @description Reset default params
             */
            this.reset = function (paramsObject) {
                cancelWatch();
                defaultParams = angular.extend({
                    max_results: 25,
                    page: 1,
                    where: {},
                    sort: [],
                    filters: [],
                    ttl: 0,
                }, paramsObject);
                // main loop - update when query criteria change
                cancelWatch = $rootScope.$watchCollection(function () { return getQueryCriteria(); }, function (criteria) {
                    self.query(criteria);
                });
            };
            /**
             * @ngdoc method
             * @name DataAdapter#reset
             * @public
             *
             * @description Force reload with same params
             */
            this.reload = function () {
                self.query(getQueryCriteria());
            };
            if (params) {
                this.reset(params);
            }
        };
    }]);


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.services.entity', [])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name locationParams
     *
     * @requires https://docs.angularjs.org/api/ng/service/$location $location
     * @requires https://docs.angularjs.org/api/ng/service/$route $route
     *
     * @description Location Params service holds default params for given page
     * and combines those with current params.
     */
    .service('locationParams', ['$location', '$route', function ($location, $route) {
        return {
            defaults: {},
            /**
             * @ngdoc method
             * @name locationParams#query
             * @public
             * @return {Object} defaults + current
             *
             * @param {Object} defaults
             *
             * @description Set default params
             */
            reset: function (defaults) {
                this.defaults = lodash_1.default.extend(defaults, { page: 1 });
                this.params = lodash_1.default.extend({}, this.defaults, $route.current.params);
                return this.params;
            },
            /**
             * @ngdoc method
             * @name locationParams#get
             * @public
             *
             * @param {string} key
             * @return {Object|null}
             *
             * @description Get parameter
             */
            get: function (key) {
                return this.params && this.params[key] ? this.params[key] : null;
            },
            /**
             * @ngdoc method
             * @name locationParams#set
             * @public
             * @return {Object} locationParams
             *
             * @param {string} key
             * @param {mixed} val
             *
             * @description Set location parameter and hits the $location.search
             * if parameter value is same as default one it will remove it from $location
             */
            set: function (key, val) {
                var locVar = key in this.defaults && angular.equals(this.defaults[key], val) ? null : val;
                $location.search(key, locVar);
                return this;
            },
            /**
             * @ngdoc method
             * @name locationParams#getQuery
             * @public
             * @return {String}
             *
             * @description Returns query string compiled from current params
             * if parameter value is same as default one it will remove it from query
             *
             */
            getQuery: function () {
                return this.makeQuery(this.params, this.defaults);
            },
            /**
             * @ngdoc method
             * @name locationParams#makeQuery
             * @public
             * @return {String}
             *
             * @description Returns query string compiled from given params if
             * parameter value is same as default one it will remove it from query
             */
            makeQuery: function (params, defaults) {
                if (defaults === void 0) { defaults = {}; }
                var parts = [];
                lodash_1.default.forEach(params, function (val, key) {
                    if (!angular.equals(defaults[key], val)) {
                        lodash_1.default.forEach(lodash_1.default.isArray(val) ? val : [val], function (item) {
                            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(item));
                        });
                    }
                });
                var query = parts.length === 0 ? '' : '?' + parts.join('&');
                return query;
            },
            /**
             * @ngdoc method
             * @name locationParams#path
             * @public
             *
             * @param {String} path
             *
             * @description Updates url with given path, keeping parameters
             * if parameter value is same as default one it will remove it
             * from query.
             */
            path: function (path) {
                $location.path(path);
            },
            /**
             * @ngdoc method
             * @name locationParams#reload
             * @public
             * @description Activates controller based on current url. Does not refresh the page.
             */
            reload: function () {
                $route.reload();
            },
            /**
             * @ngdoc method
             * @name locationParams#replace
             * @public
             * @description Replace history
             */
            replace: function () {
                $location.replace();
            },
        };
    }])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name em
     *
     * @requires server
     *
     * @description Entity manager service.
     */
    .service('em', ['server', function (server) {
        /**
         * Entity repository
         */
        function Repository(entity) {
            /**
             * @ngdoc method
             * @name em#find
             * @private
             * @return {Object}
             *
             * @param {String} id
             *
             * @description Find entity by given id
             */
            this.find = function (id) {
                return server.readById(entity, id);
            };
            /**
             * @ngdoc method
             * @name em#matching
             * @private
             * @return {Object}
             *
             * @param {Object} criteria
             *
             * @description Find entities matching given criteria
             */
            this.matching = function (criteria) {
                if (criteria === void 0) { criteria = {}; }
                return server.list(entity, criteria);
            };
            /**
             * @ngdoc method
             * @name em#all
             * @private
             *
             * @return {Object}
             *
             * @description Find all entities.
             */
            this.all = function () {
                return this.matching();
            };
        }
        var repos = {};
        /**
         * @ngdoc method
         * @name em#getRepository
         * @public
         * @return {Object} Repository
         *
         * @param {String} entity
         *
         * @description Get repository for given entity
         */
        this.getRepository = function (entity) {
            if (!(entity in repos)) {
                repos[entity] = new Repository(entity);
            }
            return repos[entity];
        };
        /**
         * Shortcut for getRepository
         */
        this.repository = this.getRepository;
        /**
         * @ngdoc method
         * @name em#delete
         * @public
         * @return {Object}
         *
         * @param {Object} item
         *
         * @description Remove given item.
         */
        this.delete = function (item) {
            return server.delete(item);
        };
        /**
         * @ngdoc method
         * @name em#update
         * @public
         *
         * @param {Object} item
         * @param {Object} updates
         * @return {Object}
         *
         * @description Update given item
         */
        this.update = function (item, updates) {
            return server.update(item, updates);
        };
        /**
         * @ngdoc method
         * @name em#create
         * @public
         *
         * @param {string} resource
         * @param {Object} item
         * @return {Object}
         *
         * @description Persist given item
         */
        this.create = function (resource, item) {
            return server.create(resource, item);
        };
        /**
         * @ngdoc method
         * @name em#remove
         * @public
         *
         * @param {Object} item
         * @return {Object}
         *
         * @description Remove given item from repository
         */
        this.remove = function (item) {
            return this.delete(item);
        };
        /**
         * @ngdoc method
         * @name em#save
         * @public
         *
         * @param {string} resource
         * @param {Object} item
         * @return {Object}
         *
         * @description Save item
         */
        this.save = function (resource, item) {
            if ('_etag' in item) {
                return this.update(item);
            }
            return this.create(resource, item);
        };
        /**
         * @ngdoc method
         * @name em#save
         * @public
         * @return {Object}
         *
         * @param {String} resource
         * @param {String} id
         *
         * @description Shortcut for em.repository(resource).find(id)
         */
        this.find = function (resource, id) {
            return this.repository(resource).find(id);
        };
    }]);


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.services.server', [])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name server
     *
     * @requires https://docs.angularjs.org/api/ng/service/$q $q
     * @requires https://docs.angularjs.org/api/ng/service/$http $http
     * @requires config
     *
     * @description TODO
     */
    .service('server', ['$q', '$http', 'config', function ($q, $http, config) {
        return {
            _makeUrl: function () {
                var url = config.server.url;
                for (var i = 0; i < arguments.length; i++) {
                    url += '/' + arguments[i];
                }
                return url;
            },
            _wrapUrl: function (url) {
                if (config.server.url.indexOf('https') === 0) {
                    return 'https://' + url;
                }
                return 'http://' + url;
            },
            _cleanData: function (item) {
                var data = lodash_1.default.cloneDeep(item);
                var fields = ['_id', '_links', 'etag', 'updated', 'created'];
                lodash_1.default.forEach(fields, function (field) {
                    delete data[field];
                });
                return data;
            },
            _all: function (functionName, items, datas) {
                var self = this;
                var resource;
                // to make it usable with createAll
                if (datas !== undefined) {
                    resource = items;
                }
                var promises = [];
                lodash_1.default.forEach(items, function (item) {
                    if (resource !== undefined) {
                        promises.push(self[functionName](resource, item));
                    }
                    else {
                        promises.push(self[functionName](item));
                    }
                });
                return $q.all(promises);
            },
            _http: function (method, url, params, data) {
                var created;
                var options = {
                    method: method.toLowerCase(),
                    url: url,
                    params: params,
                    cache: false,
                };
                if (method === 'PATCH') {
                    created = data.created;
                }
                if (method === 'DELETE' || method === 'PATCH') {
                    options.headers = { 'If-Match': data.etag };
                }
                if (method === 'POST' || method === 'PATCH') {
                    options.data = this._cleanData(data);
                }
                return $http(options)
                    .then(function (response) {
                    var responseData = response.data;
                    if (method === 'POST') {
                        return responseData;
                    }
                    else if (method === 'PATCH') {
                        var fields = ['_id', '_links', 'etag', 'updated'];
                        lodash_1.default.forEach(fields, function (field) {
                            data[field] = responseData[field];
                        });
                        data.created = created;
                        return data;
                    }
                    return responseData;
                });
            },
            /**
             * @ngdoc method
             * @name server#createAll
             * @public
             *
             * @param {String} resource
             * @param {Array} datas
             * @return {Array} promise
             *
             * @description Create multiple items.
             */
            createAll: function (resource, datas) {
                return this._all('create', resource, datas);
            },
            /**
             * @ngdoc method
             * @name server#readAll
             * @public
             *
             * @param {Array} items
             * @return {Array} promise
             *
             * @description Read multiple items
             */
            readAll: function (items) {
                return this._all('read', items);
            },
            /**
             * @ngdoc method
             * @name server#updateAll
             * @public
             *
             * @param {Array} items
             * @return {Array} promise
             *
             * @description Update multiple items
             */
            updateAll: function (items) {
                return this._all('update', items);
            },
            /**
             * @ngdoc method
             * @name server#deleteAll
             * @public
             *
             * @param {Array} items
             * @return {Array} promise
             *
             * @description Delete multiple items
             */
            deleteAll: function (items) {
                return this._all('delete', items);
            },
            /**
             * @ngdoc method
             * @name server#create
             * @public
             *
             * @param {string} resource
             * @param {Object} data
             * @return {Object} promise
             *
             * @description Create single item
             */
            create: function (resource, data) {
                return this._http('post', this._makeUrl(resource), null, data);
            },
            /**
             * @ngdoc method
             * @name server#list
             * @public
             *
             * @param {String} resource
             * @param {Object} params
             * @return {Object} promise
             *
             * @description List items
             */
            list: function (resource, params) {
                return this._http('get', this._makeUrl(resource), this._convertParams(params));
            },
            // transfer url params to server params
            _convertParams: function (params) {
                var serverParams = lodash_1.default.extend({}, lodash_1.default.pick(params, [
                    'filter',
                    'max_results',
                    'page',
                    'embedded',
                    'where',
                    'q',
                    'df',
                ]));
                if ('sort' in params) {
                    serverParams.sort = '[(' + angular.toJson(params.sort[0]) + ','
                        + (params.sort[1] === 'asc' ? 1 : -1) + ')]';
                }
                if ('perPage' in params) {
                    serverParams.max_results = params.perPage;
                }
                if (params.search) {
                    var search = {};
                    search[params.searchField] = params.search;
                    angular.extend(serverParams.where, search);
                }
                return serverParams;
            },
            /**
             * @ngdoc method
             * @name server#read
             * @public
             *
             * @param {Object} item
             * @return {Object} promise
             *
             * @description Read single item
             */
            read: function (item) {
                return this._http('get', this._wrapUrl(item._links.self.href));
            },
            /**
             * @ngdoc method
             * @name server#readById
             * @public
             *
             * @param {String} resource
             * @param {String} id
             * @return {Object} promise
             *
             * @description Read single item by given id
             */
            readById: function (resource, id) {
                return this._http('get', this._makeUrl(resource, id));
            },
            /**
             * @ngdoc method
             * @name server#update
             * @public
             *
             * @param {Object} item
             * @param {Object} data to be updated, if not provided will send item data
             * @return {Object} promise
             *
             * @description Update single item
             */
            update: function (item, data) {
                if (data) {
                    data._id = item._id;
                    data.created = item.created;
                    data.updated = item.updated;
                    data.etag = item.etag;
                }
                return this._http('patch', this._wrapUrl(item._links.self.href), {}, item);
            },
            /**
             * @ngdoc method
             * @name server#delete
             * @public
             *
             * @param {Object} item
             * @return {Object} promise
             *
             * @description Delete single item
             */
            delete: function (item) {
                return this._http('delete', this._wrapUrl(item._links.self.href), {}, item);
            },
        };
    }]);


/***/ }),
/* 709 */
/***/ (function(module, exports) {

angular.module('superdesk.core.services.storage', [])
    /**
     * @ngdoc service
     * @module superdesk.core.services
     * @name storage
     *
     * @description
     * LocalStorage wrapper
     *
     * it stores data as json to keep its type
     */
    .service('storage', function () {
    /**
     * @ngdoc method
     * @name storage#getItem
     * @public
     *
     * @param {String} key
     * @returns {Object}
     *
     * @description Get item from storage
     */
    this.getItem = function (key) {
        return angular.fromJson(localStorage.getItem(key));
    };
    /**
     * @ngdoc method
     * @name storage#setItem
     * @public
     *
     * @param {String} key
     * @param {Object} data
     *
     * @description Set storage item
     */
    this.setItem = function (key, data) {
        localStorage.setItem(key, angular.toJson(data));
    };
    /**
     * @ngdoc method
     * @name storage#removeItem
     * @public
     *
     * @param {String} key
     *
     * @description Remove item from storage.
     */
    this.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    /**
     * @ngdoc method
     * @name storage#clear
     * @public
     *
     * @description Remove all items from storage.
     */
    this.clear = function () {
        localStorage.clear();
    };
});


/***/ }),
/* 710 */
/***/ (function(module, exports) {

angular.module('superdesk.core.services.dragdrop', [])
    .service('dragDropService', [function () {
        this.item = null;
    }]);


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var ModalPrompt_1 = __webpack_require__(720);
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.core.services.modal', [
    'superdesk-ui',
    'superdesk.core.services.asset',
    'superdesk.core.translate',
])
    .service('modal', ['$q', '$modal', '$sce', 'asset', function ($q, $modal, $sce, asset) {
        var defaults = {
            bodyText: '',
            headerText: utils_1.gettext('Confirm'),
            okText: utils_1.gettext('OK'),
            cancelText: utils_1.gettext('Cancel'),
            additionalCancelText: null,
        };
        function confirmArgumentsList(bodyText, headerText, okText, cancelText, additionalCancelText) {
            if (bodyText === void 0) { bodyText = defaults.bodyText; }
            if (headerText === void 0) { headerText = defaults.headerText; }
            if (okText === void 0) { okText = defaults.okText; }
            if (cancelText === void 0) { cancelText = defaults.cancelText; }
            if (additionalCancelText === void 0) { additionalCancelText = defaults.additionalCancelText; }
            return confirmBase(bodyText, headerText, okText, cancelText, additionalCancelText);
        }
        function confirmConfigurationObject(options) {
            var nextOptions = __assign({}, defaults, options);
            return confirmBase(nextOptions.bodyText, nextOptions.headerText, nextOptions.okText, nextOptions.cancelText, nextOptions.additionalCancelText);
        }
        function confirmBase(bodyText, headerText, okText, cancelText, additionalCancelText) {
            var delay = $q.defer();
            $modal.open({
                templateUrl: asset.templateUrl('core/views/confirmation-modal.html'),
                controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                        $scope.headerText = $sce.trustAsHtml(headerText);
                        $scope.bodyText = $sce.trustAsHtml(bodyText);
                        $scope.okText = okText;
                        $scope.cancelText = cancelText;
                        $scope.additionalCancelText = additionalCancelText;
                        $scope.ok = function () {
                            delay.resolve(true);
                            $modalInstance.close();
                        };
                        $scope.cancel = function () {
                            delay.reject();
                            $modalInstance.dismiss();
                        };
                        $scope.additionalCancel = function () {
                            $modalInstance.dismiss();
                        };
                        $scope.close = function () {
                            $modalInstance.dismiss();
                        };
                    }],
            });
            return delay.promise;
        }
        this.confirm = function () {
            if (typeof arguments[0] === 'object' && arguments.length === 1) {
                return confirmConfigurationObject.apply(this, arguments);
            }
            else {
                return confirmArgumentsList.apply(this, arguments);
            }
        };
        this.alert = function (options) {
            return confirmConfigurationObject.call(this, __assign({}, options, { cancelText: null }));
        };
        this.createCustomModal = function () {
            return new Promise(function (resolve) {
                $modal.open({
                    template: '<div id="custom-modal-placeholder"></div>',
                    controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                            resolve({
                                openModal: function (reactComponent) {
                                    setTimeout(function () {
                                        react_dom_1.default.render(reactComponent, document.querySelector('#custom-modal-placeholder'));
                                    });
                                },
                                closeModal: function () {
                                    $modalInstance.close();
                                    react_dom_1.default.unmountComponentAtNode(document.querySelector('#custom-modal-placeholder'));
                                },
                            });
                        }],
                });
            });
        };
        this.prompt = function (title, initialValue) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                _this.createCustomModal()
                    .then(function (_a) {
                    var openModal = _a.openModal, closeModal = _a.closeModal;
                    openModal(react_1.default.createElement(ModalPrompt_1.ModalPrompt, { title: title, initialValue: initialValue, onSubmit: function (value) {
                            closeModal();
                            resolve(value);
                        }, close: closeModal }));
                });
            });
        };
    }]);


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(713),B=__webpack_require__(714),C=__webpack_require__(76),ba=__webpack_require__(715),da=__webpack_require__(168),ea=__webpack_require__(716),fa=__webpack_require__(128),ia=__webpack_require__(719),D=__webpack_require__(382);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(76);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(718);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_textarea_autosize_1 = __importDefault(__webpack_require__(169));
var Modal_1 = __webpack_require__(383);
var ModalHeader_1 = __webpack_require__(170);
var ModalBody_1 = __webpack_require__(171);
var ModalFooter_1 = __webpack_require__(172);
var utils_1 = __webpack_require__(3);
var ModalPrompt = /** @class */ (function (_super) {
    __extends(ModalPrompt, _super);
    function ModalPrompt(props) {
        var _this = _super.call(this, props) || this;
        _this.updateValue = _this.updateValue.bind(_this);
        _this.submitValue = _this.submitValue.bind(_this);
        _this.state = {
            value: _this.props.initialValue || '',
        };
        return _this;
    }
    ModalPrompt.prototype.updateValue = function (event) {
        this.setState({
            value: event.target.value,
        });
    };
    ModalPrompt.prototype.submitValue = function () {
        this.props.onSubmit(this.state.value);
    };
    ModalPrompt.prototype.render = function () {
        return (react_1.default.createElement(Modal_1.Modal, null,
            react_1.default.createElement(ModalHeader_1.ModalHeader, null, this.props.title),
            react_1.default.createElement(ModalBody_1.ModalBody, null,
                react_1.default.createElement(react_textarea_autosize_1.default, { value: this.state.value, onChange: this.updateValue, style: { maxHeight: 400, resize: 'none' } })),
            react_1.default.createElement(ModalFooter_1.ModalFooter, null,
                react_1.default.createElement("button", { className: "btn", onClick: this.props.close }, utils_1.gettext('Cancel')),
                react_1.default.createElement("button", { className: "btn btn--primary", onClick: this.submitValue }, utils_1.gettext('Submit')))));
    };
    return ModalPrompt;
}(react_1.default.Component));
exports.ModalPrompt = ModalPrompt;
ModalPrompt.propTypes = {
    title: prop_types_1.default.string.isRequired,
    initialValue: prop_types_1.default.string,
    onSubmit: prop_types_1.default.func.isRequired,
    close: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(76);
var invariant = __webpack_require__(17);
var ReactPropTypesSecret = __webpack_require__(722);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.workflow', [])
    .run(['workflowService', angular.noop]) // make sure it's loaded
    .service('workflowService', ['preferencesService', '$rootScope', function (preferencesService, $rootScope) {
        var _actions = [];
        this.isActionAllowed = function isActionAllowed(item, actionName) {
            if (lodash_1.default.isUndefined(actionName) || lodash_1.default.isUndefined(item.state)) {
                return true;
            }
            var action = lodash_1.default.find(_actions, function (actionItem) { return actionItem.name === actionName; });
            if (action) {
                if (!lodash_1.default.isEmpty(action.include_states)) {
                    return lodash_1.default.findIndex(action.include_states, function (state) { return item.state === state; }) >= 0;
                }
                else if (!lodash_1.default.isEmpty(action.exclude_states)) {
                    return lodash_1.default.findIndex(action.exclude_states, function (state) { return item.state === state; }) === -1;
                }
            }
            return false;
        };
        this.setActions = function (actions) {
            _actions = actions;
        };
        preferencesService.getActions().then(this.setActions);
        $rootScope.isActionAllowed = angular.bind(this, this.isActionAllowed);
    }]);


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.services.asset', [])
    /**
     * @ngdoc provider
     * @module superdesk.core.services
     * @name assetProvider
     *
     * @requires https://docs.angularjs.org/api/ng/service/$injector $injector
     *
     * @description Asset module. This module provides urls for static assets.
     */
    .provider('asset', ['$injector', function ($injector) {
        this.templateUrl = function (path) {
            var config = $injector.get('config'), ret = path;
            if (!/^(https?:\/\/|\/\/|\/|.\/|..\/)/.test(path)) {
                ret = 'scripts/' + ret;
            }
            if (!/^(https?:\/\/|\/\/)/.test(path) && config.paths && config.paths.superdesk) {
                ret = config.paths.superdesk + ret;
            }
            ret = ret.replace(/[^\/]+\/+\.\.\//g, '')
                .replace(/\.\//g, '')
                .replace(/(\w)\/\/(\w)/g, '$1/$2');
            return ret;
        };
        this.imageUrl = this.templateUrl;
        /**
         * @ngdoc service
         * @module superdesk.core.services
         * @name asset
         * @description The asset service has no accessible methods and is only
         * available at provider level.
         */
        this.$get = function () {
            return this;
        };
    }]);


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
* @ngdoc factory
* @module superdesk.core.services
* @name imageFactory
*
* @description Factory for creating Image objects. Allows for easier mocking in tests.
*/
exports.default = angular.module('superdesk.core.services.imageFactory', []).factory('imageFactory', function () { return ({
    makeInstance: function () {
        return new Image();
    },
}); });


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc service
 * @module superdesk.core.services
 * @name pageTitle
 *
 * @description
 * PageTitle service
 *
 * PageTitle service is used to save and update the title of the page.
 * The title will be 'Superdesk {- Url} {-Desk/Workspace}
 * Url can be: Dashboard, Monitoring, Spike, Highlights, Search, Settings
 * If Url is search then there won't be desk
 */
exports.default = angular.module('superdesk.core.services.pageTitle', [])
    .service('pageTitle', function () {
    this.title = 'Superdesk';
    this.url = '';
    this.workspace = '';
    this.setUrl = function (url) {
        this.url = url;
        setTitle(this.url, this.workspace);
    };
    this.setWorkspace = function (activeWorkspace) {
        this.workspace = activeWorkspace;
        setTitle(this.url, this.workspace);
    };
    function setTitle(url, activeWorkspace) {
        document.title = 'Superdesk' + (url ? ' - ' + url : '') + (activeWorkspace ? ' - ' + activeWorkspace : '');
    }
    this.clear = function () {
        document.title = this.title;
    };
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc service
 * @name serverConfig
 * @module superdesk.core.services
 * @requires api
 * @description Server config service.
 */
var ServerConfigService = /** @class */ (function () {
    function ServerConfigService(api) {
        this.api = api;
    }
    /**
         * @ngdoc method
         * @name api#save
         * @public
         * @description
         * Save an item
         */
    /**
     * @ngdoc method
     * @name serverConfig#get
     * @public
     * @description
     * Get config value
     *
     * @param {String} key
     * @param {String} path
     * @return {Promise}
     */
    ServerConfigService.prototype.get = function (key, path) {
        return this.api.find('config', key).then(function (config) { return lodash_1.default.get(config.val, path); });
    };
    /**
     * @ngdoc method
     * @name serverConfig#set
     * @public
     * @description
     * Set config
     *
     * @param {String} key
     * @param {Object} val
     * @return {Promise}
     */
    ServerConfigService.prototype.set = function (key, val) {
        return this.api.save('config', { _id: key, val: val });
    };
    return ServerConfigService;
}());
exports.ServerConfigService = ServerConfigService;
ServerConfigService.$inject = ['api'];


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
var PhoneHomeModalDirective_1 = __webpack_require__(750);
/**
 * @ngdoc module
 * @module superdesk.core.directives
 * @name superdesk.core.directives
 * @packageName superdesk.core
 * @description Superdesk core directives collection. Contains a set of modules
 *  that implement various UI components and helpers.
 */
exports.default = angular.module('superdesk.core.directives', [
    'superdesk.core.directives.autofocus',
    'superdesk.core.directives.debounce',
    'superdesk.core.directives.throttle',
    'superdesk.core.directives.sort',
    'superdesk.core.directives.passwordStrength',
    'superdesk.core.directives.searchList',
    'superdesk.core.directives.searchListSingle',
    'superdesk.core.directives.filetypeIcon',
    'superdesk.core.directives.checkAll',
    'superdesk.core.directives.switchInverted',
    'superdesk.core.directives.confirm',
    'superdesk.core.directives.select',
    'superdesk.core.directives.selectPopup',
    'superdesk.core.directives.permissions',
    'superdesk.core.directives.sortable',
    'superdesk.core.directives.draggable',
    'superdesk.core.directives.droppable',
    'superdesk.core.directives.typeahead',
    'superdesk.core.directives.slider',
    'superdesk.core.directives.avatar',
    'superdesk.core.directives.withParams',
])
    .directive('sdPhoneHomeModal', PhoneHomeModalDirective_1.PhoneHomeModalDirective);


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.autofocus', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdAutoFocus
     * @description sdAutoFocus automatically focuses on an element on page render.
     */
    .directive('sdAutoFocus', function () { return ({
    link: function ($scope, element, attrs) {
        element.focus();
    },
}); });


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.directives.throttle', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdThrottle
     *
     * @param {Number} interval
     * @param {Object} ngModel
     *
     * @description Throttles model update.
     */
    .directive('sdThrottle', function () { return ({
    require: 'ngModel',
    link: function ($scope, element, attrs, ngModel) {
        var interval = 1000;
        if (attrs.interval !== '' && attrs.interval !== undefined) {
            interval = attrs.interval;
        }
        element.off('input')
            .off('keydown')
            .off('change');
        element.on('input', lodash_1.default.throttle(function () {
            $scope.$apply(function () {
                ngModel.$setViewValue(element.val());
            });
        }, interval));
    },
}); });


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.directives.debounce', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdDebounce
     *
     * @param {Number} interval
     * @param {Object} ngModel
     *
     * @description Debounces model update.
     */
    .directive('sdDebounce', function () { return ({
    require: 'ngModel',
    link: function ($scope, element, attrs, ngModel) {
        var interval = 1000;
        if (attrs.interval !== '' && attrs.interval !== undefined) {
            interval = attrs.interval;
        }
        element.off('input')
            .off('keydown')
            .off('change');
        element.on('input', lodash_1.default.debounce(function () {
            $scope.$apply(function () {
                ngModel.$setViewValue(element.val());
            });
        }, interval));
    },
}); });


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.sort', ['superdesk.core.services.asset'])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSort
     *
     * @requires https://docs.angularjs.org/api/ng/service/$location $location
     * @requires asset
     *
     * @param {String} label User friendly text for sort field.
     * @param {String} field Field name for sort field.
     *
     * @description Inserts sort links based on current sort field and direction.
     */
    .directive('sdSort', ['$location', 'asset', function ($location, asset) {
        return {
            scope: {
                label: '@',
                field: '@',
            },
            templateUrl: asset.templateUrl('core/views/sdSort.html'),
            link: function (scope, element, attrs) {
                scope.loc = $location;
                scope.sort = scope.loc.search().sort;
                scope.$watch('(loc.search()).sort', function (val) {
                    scope.sort = val;
                });
                element.click(function () {
                    scope.$apply(function () {
                        if (scope.sort && scope.field === scope.sort[0]) {
                            // switch sort direction
                            $location.search('sort', [scope.field, scope.sort[1] === 'asc' ? 'desc' : 'asc']);
                        }
                        else {
                            // set sort field
                            $location.search('sort', [scope.field, 'asc']);
                        }
                    });
                });
                element.addClass('sortable');
            },
        };
    }]);


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
// config holds the default configuration for the password strength calculator.
var config = {
    MIN_LENGTH: 8,
    ONE_LOWER: /^(?=.*[a-z])/g,
    ONE_UPPER: /^(?=.*[A-Z])/g,
    ONE_NUMBER: /^(?=.*[0-9])/g,
    ONE_OTHER: /^(?=.*[^0-9^a-z^A-Z])/g,
    MIN_STRENGTH: 3,
};
/**
 * @ngdoc directive
 * @module superdesk.core.directives
 * @name sdPasswordStrength
 *
 * @param {Object} ngModel - model that the input is bound to
 *
 * @description Appends a strength indicator to the input that it is
 * added to. Strength is computed in the following way:
 *
 *   - If the length of the password is less than 8, strength will be set
 *     to 'Short'.
 *
 *   - Strength is increased whenever one of the following is found:
 *        - a lower-case letter
 *        - an upper-case letter
 *        - a number
 *        - another character
 */
PasswordStrength.$inject = [];
function PasswordStrength() {
    // styles holds each of the strength labels by index along with the class
    // to be added to the indicator.
    var styles = [
        { txt: utils_1.gettext('Short'), cls: 'red' },
        { txt: utils_1.gettext('Weak'), cls: 'red' },
        { txt: utils_1.gettext('Better'), cls: 'yellow' },
        { txt: utils_1.gettext('OK'), cls: 'green' },
        { txt: utils_1.gettext('Strong'), cls: 'green' },
    ];
    // helpText holds the text that will be shown when the user hovers over the
    // informational icon.
    var helpText = utils_1.gettext('Must be {{MIN_LENGTH}} characters long and contain {{MIN_STRENGTH}} out of 4 of the following:', config) +
        '<ul>' +
        '<li>' + utils_1.gettext('a lower case letter (a-z)') + '</li>' +
        '<li>' + utils_1.gettext('an upper case letter (A-Z)') + '</li>' +
        '<li>' + utils_1.gettext('a number (0-9)') + '</li>' +
        '<li>' + utils_1.gettext('a special character (!@#$%^&...)') + '</li>' +
        '</ul>';
    return {
        require: 'ngModel',
        scope: {
            password: '=ngModel',
        },
        link: function ($scope, el, attr, ngModel) {
            var indicator = angular.element('<div class="password-strength">' +
                utils_1.gettext('Strength') + ': <span class="label"></span>' +
                '<div class="icon-question-sign"></div>' +
                '</div>');
            indicator.find('.icon-question-sign').tooltip({
                title: helpText,
                html: true,
            });
            ngModel.$error.weakPass = utils_1.gettext('Password is too weak.');
            /*
             * @description updateStrength updates the indicator's state to
             * reflect the strength of the given password.
             * @param {string} pass the password to compute the strength of
             */
            var updateStrength = function (pass) {
                var strength = 0;
                if (typeof pass === 'string') {
                    strength = pass.length >= config.MIN_LENGTH ?
                        (config.ONE_LOWER.test(pass) ? 1 : 0) +
                            (config.ONE_UPPER.test(pass) ? 1 : 0) +
                            (config.ONE_NUMBER.test(pass) ? 1 : 0) +
                            (config.ONE_OTHER.test(pass) ? 1 : 0) : 0;
                }
                indicator.find('.label')
                    .text(styles[strength].txt)
                    .removeClass('red yellow green')
                    .addClass(styles[strength].cls);
                ngModel.$setValidity('weakPass', strength >= config.MIN_STRENGTH);
            };
            updateStrength(ngModel.$modelValue || '');
            $scope.$watch('password', updateStrength);
            indicator.insertAfter(el);
        },
    };
}
exports.default = angular
    .module('superdesk.core.directives.passwordStrength', [])
    .directive('sdPasswordStrength', PasswordStrength);


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.directives.searchList', ['superdesk.core.services.asset'])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSearchList
     *
     * @requires asset
     * @requires api
     *
     * @param {String} endpoint API endpoint to send queries
     * @param {Integer} pageSize Number of items per page
     * @param {String} labelKey Object key to display items by
     * @param {String} searchKey Object key to search keyword in
     * @param {Object} criteria Base criteria object to use in queries
     * @param {Integer} maxSelectedItems Maximum number of items to select
     * @param {Array} disabledItems Items that will be disabled
     * @param {Array} selectedItems Target to populate with selected items
     * @param {String} selectedItemsHelperTemplate Additional template to
     *      display for each selected item
     * @param {Object} selectedItemsHelperData Additional data to use in
     *      helper template, which can be accessed by data variable
     *
     * @description Displays a searchable paginated list of items from
     * given endpoint, allows selecting multiple items.
     *
     * Example:
     * ```html
     * <div sd-search-list
     *     data-endpoint="subscribers"
     *     data-page-size="5"
     *     data-label-key="name"
     *     data-search-key="name"
     *     data-criteria="criteria"
     *     data-max-selected-items="1"
     *     data-disabled-items="disabledItems"
     *     data-selected-items="selectedItems"
     *     data-selected-items-helper-template="helperTemplate.html"
     *     data-selected-items-helper-data="data">
     * </div>
     * ```
     */
    .directive('sdSearchList', ['asset', 'api', function (asset, api) {
        var defaults = {
            pageSize: 25,
        };
        return {
            scope: {
                endpoint: '@',
                pageSize: '@',
                labelKey: '@',
                searchKey: '@',
                maxSelectedItems: '=',
                criteria: '=',
                disabledItems: '=',
                selectedItems: '=',
                selectedItemsHelperTemplate: '=',
                selectedItemsHelperData: '=',
            },
            templateUrl: asset.templateUrl('core/views/sdSearchList.html'),
            link: function (scope, element, attrs) {
                scope.open = false;
                scope.page = 1;
                scope.maxPage = 0;
                scope.items = null;
                scope.keyword = null;
                scope.editable = true;
                if (!lodash_1.default.isNil(scope.$parent._editable)) {
                    scope.editable = scope.$parent._editable;
                }
                var _update = function () {
                    var criteria = scope.criteria || {};
                    if (scope.keyword && scope.searchKey) {
                        var search = {};
                        search[scope.searchKey] = { $regex: scope.keyword, $options: '-i' };
                        criteria.where = JSON.stringify({ $or: [search] });
                    }
                    api[scope.endpoint].query(lodash_1.default.assign({}, criteria, {
                        max_results: scope.pageSize,
                        page: scope.page,
                    }))
                        .then(function (result) {
                        var pageSize = scope.pageSize || defaults.pageSize;
                        scope.maxPage = Math.ceil(result._meta.total / pageSize) || 0;
                        scope.items = result._items;
                    });
                };
                var update = lodash_1.default.debounce(_update, 500);
                scope.$watch('keyword', function () {
                    scope.page = 1;
                    update();
                });
                scope.$watch('page', update);
                scope.selectItem = function (item) {
                    scope.selectedItems = scope.selectedItems || [];
                    scope.selectedItems.push(item);
                    scope.selectedItems = lodash_1.default.uniq(scope.selectedItems);
                    if (scope.maxSelectedItems === 1) {
                        scope.open = false;
                    }
                };
                scope.unselectItem = function (item) {
                    lodash_1.default.remove(scope.selectedItems, function (i) { return i._id === item._id; });
                };
                scope.isSelected = function (item) {
                    return scope.selectedItems ?
                        lodash_1.default.findIndex(scope.selectedItems, function (i) { return i._id === item._id; }) !== -1
                        : false;
                };
                scope.isDisabled = function (item) {
                    return scope.disabledItems ?
                        lodash_1.default.findIndex(scope.disabledItems, function (i) { return i._id === item._id; }) !== -1
                        : false;
                };
            },
        };
    }]);


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.directives.searchListSingle', ['superdesk.core.services.asset'])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSearchListSingle
     *
     * @requires asset
     *
     * @param {String} endpoint API endpoint to send queries.
     * @param {Integer} pageSize Number of items per page.
     * @param {String} labelKey Object key to display items by.
     * @param {String} searchKey Object key to search keyword in.
     * @param {Object} criteria Base criteria object to use in queries.
     * @param {Integer} maxSelectedItems Maximum number of items to select.
     * @param {Array} disabledItems Items that will be disabled.
     * @param {Object} selectedItem Target to populate with selected item.
     *
     * @description
     * SearchListSingle directive is a proxy directive for SearchList,
     * limiting it to a single item for ease of use.
     *
     * Example:
     * ```html
     * <div sd-search-list
     *     data-endpoint="subscribers"
     *     data-page-size="5"
     *     data-label-key="name"
     *     data-search-key="name"
     *     data-criteria="criteria"
     *     data-disabled-items="disabledItems"
     *     data-selected-item="selectedItem">
     * </div>
     * ```
     */
    .directive('sdSearchListSingle', ['asset', function (asset) {
        return {
            scope: {
                endpoint: '@',
                pageSize: '@',
                labelKey: '@',
                searchKey: '@',
                criteria: '=',
                disabledItems: '=',
                selectedItem: '=',
            },
            templateUrl: asset.templateUrl('core/views/sdSearchListSingle.html'),
            link: function (scope, element, attrs) {
                scope.selectedItems = [];
                scope.$watch('selectedItems', function () {
                    if (Array.isArray(scope.selectedItems)) {
                        scope.selectedItem = lodash_1.default.last(scope.selectedItems);
                    }
                });
            },
        };
    }]);


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.core.directives.filetypeIcon', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdFiletypeIcon
     *
     * @param {Object} item Item from ItemList provider.
     *
     * @description Adds the "filetype-icon-*" class based on the item.
     */
    .directive('sdFiletypeIcon', [function () { return ({
        scope: { item: '=' },
        link: function (scope, element, attrs) {
            var oldClass = null;
            scope.$watch('item', function (item) {
                if (item != null) {
                    setIcon(item);
                }
                else {
                    oldClass = null;
                }
            });
            function setIcon(item) {
                var cls = 'filetype-icon-';
                if (item.type === 'composite' && item.highlight) {
                    cls += 'highlight-pack';
                }
                else {
                    cls += item.type;
                }
                if (oldClass === cls) {
                    return;
                }
                element.attr('title', utils_1.gettext('Article Type: {{type}}', { type: item.type }));
                element.addClass(cls);
                element.removeClass(oldClass);
                oldClass = cls;
            }
        },
    }); }]);


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var render = function (element, value) {
    element.toggleClass('checked', !!value);
    element.attr('checked', !!value);
};
exports.default = angular.module('superdesk.core.directives.checkAll', [])
    /**
     * sdCheckAll creates a custom-styled checkbox managing other checkboxes in the same group.
     *
     * Usage:
     * <input sd-check-all ng-model="users" data-check-attribute="_checked">
     *
     * Params:
     * @scope {array} ngModel - array of objects managed by checkboxes
     * @scope {string} checkAttribute - name of attribute to set in model elements
     *
     */
    .directive('sdCheckAll', function () {
    var checkAttribute = '_checked';
    return {
        require: 'ngModel',
        replace: true,
        template: '<span class="sd-checkbox"></span>',
        link: function ($scope, element, attrs, ngModel) {
            var checked = false;
            if (attrs.checkAttribute !== undefined) {
                checkAttribute = attrs.checkAttribute;
            }
            $scope.$watch(attrs.ngModel, function (model) {
                if (model) {
                    checked = lodash_1.default.every(ngModel.$viewValue, checkAttribute) && ngModel.$viewValue.length > 0;
                    render(element, checked);
                }
            }, true);
            element.on('click', function () {
                checked = !checked;
                var model = ngModel.$viewValue;
                lodash_1.default.forEach(model, function (item) {
                    item[checkAttribute] = checked;
                });
                $scope.$apply(function () {
                    ngModel.$setViewValue(model);
                });
                render(element, checked);
            });
        },
    };
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var render = function (element, value) {
    element.toggleClass('checked', !!value);
    element.attr('checked', !!value);
};
exports.default = angular.module('superdesk.core.directives.switchInverted', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSwitchInverted
     *
     * @param {Boolean} ngModel Model for checkbox value.
     *
     * @description sdSwitchInverted is sdCheck directive with inverted functionality.
     * e.g: useful in case when we want to display switch ON (means provider is open)
     *  for model like `provider.is_closed = false` and vice versa.
     *
     * Example:
     * ```html
     * <input sd-switch-inverted ng-model="provider.is_closed">
     * ```
     */
    .directive('sdSwitchInverted', function () { return ({
    require: 'ngModel',
    replace: true,
    template: [
        '<span class="sd-toggle">',
        '<span class="inner"></span>',
        '</span>',
    ].join(''),
    link: function ($scope, element, attrs, ngModel) {
        ngModel.$render = function () {
            render(element, ngModel.$viewValue);
        };
        $scope.$watch(attrs.ngModel, function () {
            render(element, !ngModel.$viewValue);
        });
        element.on('click', function (e) {
            $scope.$apply(function () {
                ngModel.$setViewValue(!ngModel.$viewValue);
            });
            return false;
        });
    },
}); });


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.confirm', [])
    .directive('sdConfirm', ['$window', function ($window) {
        return {
            scope: {
                msg: '@sdConfirm',
                confirmAction: '&',
            },
            link: function (scope, element, attrs) {
                element.click(function (e) {
                    if ($window.confirm(scope.msg)) {
                        scope.confirmAction();
                    }
                });
            },
        };
    }]);


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.select', ['superdesk.core.services.asset'])
    .factory('optionParser', ['$parse', function ($parse) {
        var TYPEAHEAD_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;
        return {
            parse: function (input) {
                var match = input.match(TYPEAHEAD_REGEXP);
                if (!match) {
                    throw new Error('Expected typeahead specification in form of _modelValue_ ' +
                        '(as _label_)? for _item_ in _collection_' +
                        ' but got ' + input + '.');
                }
                return {
                    itemName: match[3],
                    source: $parse(match[4]),
                    viewMapper: $parse(match[2] || match[1]),
                    modelMapper: $parse(match[1]),
                };
            },
        };
    }])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSelect
     *
     * @requires https://docs.angularjs.org/api/ng/service/$parse $parse
     * @requires https://docs.angularjs.org/api/ng/service/$compile $compile
     * @requires optionParser
     *
     * @description Renders custom input type select with ability to select multiple items.
     *
     * Example:
     * ```html
     * <sd-select multiple="true" ng-model="model" options="c.name for c in collection" change="action()"></sd-multiselect>
     * ```
     */
    .directive('sdSelect', ['$parse', '$compile', 'optionParser',
    function ($parse, $compile, optionParser) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (originalScope, element, attrs, modelCtrl) {
                var exp = attrs.options, parsedResult = optionParser.parse(exp), isMultiple = !!attrs.multiple, required = false, scope = originalScope.$new(), changeHandler = attrs.change || angular.noop;
                scope.items = [];
                scope.header = 'Select';
                scope.multiple = isMultiple;
                scope.disabled = false;
                scope.showfilter = !!attrs.showfilter;
                originalScope.$on('$destroy', function () {
                    scope.$destroy();
                });
                var popUpEl = angular.element('<div sd-select-popup></div>');
                // required validator
                if (attrs.required || attrs.ngRequired) {
                    required = true;
                }
                attrs.$observe('required', function (newVal) {
                    required = newVal;
                });
                // watch disabled state
                scope.$watch(function () { return $parse(attrs.disabled)(originalScope); }, function (newVal) {
                    scope.disabled = newVal;
                });
                // watch single/multiple state for dynamically change single to multiple
                scope.$watch(function () { return $parse(attrs.multiple)(originalScope); }, function (newVal) {
                    isMultiple = newVal || false;
                });
                // watch option changes for options that are populated dynamically
                scope.$watch(function () { return parsedResult.source(originalScope); }, function (newVal) {
                    if (angular.isDefined(newVal)) {
                        parseModel();
                    }
                }, true);
                // watch model change
                scope.$watch(function () { return modelCtrl.$modelValue; }, function (newVal, oldVal) {
                    // when directive initialize, newVal usually undefined. Also, if model
                    // value already set in the controller for preselected list then we need
                    // to mark checked in our scope item. But we don't want to do this every
                    // time model changes. We need to do this only if it is done outside
                    // directive scope, from controller, for example.
                    if (angular.isDefined(newVal)) {
                        markChecked(newVal);
                        scope.$eval(changeHandler);
                    }
                    getHeaderText();
                    modelCtrl.$setValidity('required', scope.valid());
                }, true);
                function parseModel() {
                    scope.items.length = 0;
                    var model = parsedResult.source(originalScope);
                    if (!angular.isDefined(model)) {
                        return;
                    }
                    for (var i = 0; i < model.length; i++) {
                        var local = {};
                        local[parsedResult.itemName] = model[i];
                        scope.items.push({
                            label: parsedResult.viewMapper(local),
                            model: parsedResult.modelMapper(local),
                            checked: false,
                        });
                    }
                }
                parseModel();
                element.append($compile(popUpEl)(scope));
                function getHeaderText() {
                    if (isEmpty(modelCtrl.$modelValue)) {
                        scope.header = 'Select';
                        return scope.header;
                    }
                    if (isMultiple) {
                        scope.header = modelCtrl.$modelValue.length + ' selected';
                    }
                    else {
                        var local = {};
                        local[parsedResult.itemName] = modelCtrl.$modelValue;
                        scope.header = parsedResult.viewMapper(local);
                    }
                }
                function isEmpty(obj) {
                    if (!obj) {
                        return true;
                    }
                    if (obj.length && obj.length > 0) {
                        return false;
                    }
                    for (var prop in obj) {
                        if (obj[prop]) {
                            return false;
                        }
                    }
                    return true;
                }
                scope.valid = function validModel() {
                    if (!required) {
                        return true;
                    }
                    var value = modelCtrl.$modelValue;
                    return angular.isArray(value) && value.length > 0 || !angular.isArray(value) && value !== null;
                };
                function selectSingle(item) {
                    if (item.checked) {
                        scope.uncheckAll();
                    }
                    else {
                        scope.uncheckAll();
                        item.checked = !item.checked;
                    }
                    setModelValue(false);
                }
                function selectMultiple(item) {
                    item.checked = !item.checked;
                    setModelValue(true);
                }
                function setModelValue(_isMultiple) {
                    var value;
                    if (_isMultiple) {
                        value = [];
                        angular.forEach(scope.items, function (item) {
                            if (item.checked) {
                                value.push(item.model);
                            }
                        });
                    }
                    else {
                        angular.forEach(scope.items, function (item) {
                            if (item.checked) {
                                value = item.model;
                                return false;
                            }
                        });
                    }
                    modelCtrl.$setViewValue(value);
                }
                function markChecked(newVal) {
                    if (!angular.isArray(newVal)) {
                        angular.forEach(scope.items, function (item) {
                            if (angular.equals(item.model, newVal)) {
                                item.checked = true;
                                return false;
                            }
                        });
                    }
                    else {
                        angular.forEach(newVal, function (i) {
                            angular.forEach(scope.items, function (item) {
                                if (angular.equals(item.model, i)) {
                                    item.checked = true;
                                }
                            });
                        });
                    }
                }
                scope.checkAll = function () {
                    if (!isMultiple) {
                        return;
                    }
                    angular.forEach(scope.items, function (item) {
                        item.checked = true;
                    });
                    setModelValue(true);
                };
                scope.uncheckAll = function () {
                    angular.forEach(scope.items, function (item) {
                        item.checked = false;
                    });
                    setModelValue(true);
                };
                scope.select = function (item) {
                    if (isMultiple === false) {
                        selectSingle(item);
                        scope.toggleSelect();
                    }
                    else {
                        selectMultiple(item);
                    }
                };
            },
        };
    }]);


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.selectPopup', ['superdesk.core.services.asset'])
    .directive('sdSelectPopup', ['asset', function (asset) {
        return {
            restrict: 'A',
            scope: false,
            replace: true,
            templateUrl: asset.templateUrl('core/views/sdselect.html'),
            link: function (scope, element, attrs) {
                scope.open = false;
                scope.toggleSelect = function () {
                    scope.open = !scope.open;
                    if (scope.open) {
                        scope.focus();
                    }
                };
                scope.focus = function focus() {
                    var searchBox = element.find('input')[0];
                    searchBox.focus();
                };
            },
        };
    }]);


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.permissions', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdPermissions
     *
     * @param {Object} dataModel Model to assign permission to
     * @param {String} dataPermission ID of required permission.
     * @param {Object} dataRole Role to check.
     * @param {Object} dataUser User to check.
     *
     * @description Checks if user has specified permissions and assigns
     * to specified model to use in displaying/hiding/disabling elements.
     *
     * Checking for a user:
     * ```js
     * <div sd-permissions data-permission="users-manage" data-user="user" data-model="model" ng-show="model"></div>
     * ```
     *
     * Checking for a role:
     * ```js
     * <div sd-permissions data-permission="users-manage" data-role="role" data-model="model" ng-show="model"></div>
     * ```
     *
     * Checking for current user (default if no user/role specified):
     * ```js
     * <div sd-permissions data-permission="users-manage" data-model="model" ng-show="model"></div>
     * ```
     */
    .directive('sdPermissions', ['permissions', 'permissionsService', function (permissions, permissionsService) {
        return {
            scope: {
                model: '=',
                permission: '@',
                role: '=',
                user: '=',
            },
            link: function (scope, element, attrs) {
                scope.model = false;
                if (permissions[scope.permission]) {
                    var requiredPermissions = permissions[scope.permission].permissions;
                    if (scope.role) {
                        scope.model = permissionsService.isRoleAllowed(requiredPermissions, scope.role);
                    }
                    else if (scope.user) {
                        permissionsService.isUserAllowed(requiredPermissions, scope.user).then(function (result) {
                            scope.model = result;
                        });
                    }
                    else {
                        permissionsService.isUserAllowed(requiredPermissions).then(function (result) {
                            scope.model = result;
                        });
                    }
                }
            },
        };
    }]);


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.sortable', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSortable
     *
     * @param {Function} update Function to call when sort is updated.
     * This function should accept an array of item indexes.
     * @param {String} placeholder CSS class name for placeholder box
     * displayed during sorting.
     *
     * @description Creates a container in which contained items can be sortable by drag/drop.
     */
    .directive('sdSortable', [function () {
        return {
            scope: { update: '=', placeholder: '=' },
            link: function (scope, element, attrs) {
                element.sortable({
                    tolerance: 'intersect',
                    placeholder: scope.placeholder,
                    start: function (event, ui) {
                        $(event.target).data('ui-sortable').floating = true;
                    },
                    update: function (event, ui) {
                        scope.update();
                    },
                });
                element.disableSelection();
            },
        };
    }]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.droppable', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdDroppable
     *
     * @param {Function} update Function to be called when an item is dropped.
     *
     * @description Marks a drop area for sdDraggable items.
     */
    .directive('sdDroppable', ['dragDropService', function (dragDropService) {
        return {
            scope: { update: '=' },
            link: function (scope, element, attrs) {
                element.droppable({
                    accept: ':not(.ui-sortable-helper)',
                    drop: function (event, ui) {
                        scope.update(dragDropService.item);
                        dragDropService.item = null;
                    },
                });
            },
        };
    }]);


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.draggable', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdDraggable
     *
     * @param {Object} item Data to be carried.
     * @param {String} container css selector to attach dragged item to.
     * @param {Boolean} cursor - enable/disable stucking drag object to cursor
     *
     * @description Creates a draggable item. Works with sdDroppable.
     */
    .directive('sdDraggable', ['dragDropService', function (dragDropService) {
        return {
            scope: { item: '=', container: '=', cursor: '=' },
            link: function (scope, element, attrs) {
                element.draggable({
                    helper: 'clone',
                    appendTo: scope.container,
                    start: function (event, ui) {
                        dragDropService.item = scope.item;
                    },
                });
                scope.$watch('cursor', function (val) {
                    if (val) {
                        element.draggable('option', 'cursorAt', {
                            left: 5,
                            top: 5,
                        });
                    }
                    else {
                        element.draggable('option', 'cursorAt', false);
                    }
                });
            },
        };
    }]);


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
exports.default = angular.module('superdesk.core.directives.typeahead', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdTypeahead
     *
     * @requires https://docs.angularjs.org/api/ng/service/$timeout $timeout
     * @requires Keys
     * @requires https://docs.angularjs.org/api/ng/service/$document $document
     *
     * @param {Object} items Choice list.
     * @param {Object} term Search term.
     * @param {Boolen} alwaysVisible List of posible choices always stay visible.
     * @param {Function} search Callback for filtering choice action.
     * @param {Function} select Callback for select item aciton.
     * @param {Boolean} keepinput if true, the input text after selecting an item-selection will not be deleted/nulled
     *
     * @description Typeahead directive.
     *
     * Example:
     * ```html
     *  <ul sd-typeahead items="subjects" term="subjectTerm" search="searchSubjects(term)" select="selectSubject(item)">
     *      <li typeahead-item="s" ng-repeat="s in subjects">
     *          {{s.term}}
     *      </li>
     *  </ul>
     * ```
     */
    .directive('sdTypeahead', ['$timeout', 'Keys', '$document', function ($timeout, Keys, $document) {
        return {
            restrict: 'A',
            transclude: true,
            replace: true,
            templateUrl: 'scripts/core/views/sdTypeahead.html',
            scope: {
                search: '&',
                select: '&',
                items: '=',
                term: '=',
                alwaysVisible: '=',
                disabled: '=',
                blur: '&',
                placeholder: '@',
                tabindex: '=',
                style: '=',
                keepinput: '=',
                debounce: '@',
            },
            controller: ['$scope', function ($scope) {
                    $scope.hide = true;
                    this.activate = function (item) {
                        $scope.active = item;
                    };
                    this.activateNextItem = function () {
                        var index = $scope.items.indexOf($scope.active);
                        this.activate($scope.items[(index + 1) % $scope.items.length]);
                    };
                    this.activatePreviousItem = function () {
                        var index = $scope.items.indexOf($scope.active);
                        this.activate($scope.items[index === 0 ? $scope.items.length - 1 : index - 1]);
                    };
                    this.isActive = function (item) {
                        return $scope.active === item;
                    };
                    this.selectActive = function () {
                        this.select($scope.active);
                    };
                    this.select = function (item) {
                        if (!$scope.hide) {
                            $scope.hide = true;
                            $scope.focused = false;
                            $scope.select({ item: item });
                            $scope.active = null;
                            // triggers closing of dropdown when adding item on search by pressing enter
                            if (item) {
                                $document.triggerHandler('click');
                                // Clear text input
                                if (!$scope.keepinput) {
                                    $scope.term = null;
                                }
                            }
                        }
                    };
                    $scope.isVisible = function () {
                        return !$scope.hide && ($scope.focused || $scope.mousedOver)
                            && ($scope.items && $scope.items.length > 0);
                    };
                    $scope.query = lodash_1.debounce(function () {
                        $scope.$applyAsync(function () {
                            $scope.hide = false;
                            $scope.search({ term: $scope.term });
                        });
                    }, parseInt($scope.debounce || '0', 10));
                }],
            link: function (scope, element, attrs, controller) {
                var $input = element.find('.input-term > input');
                var $list = element.find('.item-list');
                $input.on('focus', function () {
                    scope.$apply(function () {
                        scope.focused = true;
                    });
                });
                $input.on('blur', function () {
                    scope.$apply(function () {
                        scope.focused = false;
                        if (typeof scope.blur === 'function' && !scope.hide) {
                            scope.blur({ item: scope.active });
                        }
                    });
                });
                $list.on('mouseover', function () {
                    scope.$apply(function () {
                        scope.mousedOver = true;
                    });
                });
                $list.on('mouseleave', function () {
                    scope.$apply(function () {
                        scope.mousedOver = false;
                    });
                });
                $input.on('keydown', function (e) {
                    if (e.keyCode === Keys.enter) {
                        scope.$apply(function () {
                            controller.selectActive();
                        });
                        e.preventDefault();
                    }
                    if (e.keyCode === Keys.escape) {
                        scope.$apply(function () {
                            scope.hide = true;
                        });
                    }
                    var list = element.find('.item-list')[0];
                    var active = element.find('.active')[0];
                    if (e.keyCode === Keys.down) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (list && list.children.length) {
                            scope.$apply(function () {
                                controller.activateNextItem();
                                scrollToActive(list, active);
                            });
                        }
                    }
                    if (e.keyCode === Keys.up) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (list && list.children.length) {
                            scope.$apply(function () {
                                controller.activatePreviousItem();
                                scrollToActive(list, active);
                            });
                        }
                    }
                });
                scope.$on('$destroy', function () {
                    $input.off();
                    $list.off();
                });
                function scrollToActive(list, active) {
                    $timeout(function () {
                        if (list && active) {
                            list.scrollTop = Math.max(0, active.offsetTop - 2 * active.clientHeight);
                        }
                    }, 10, false); // requires a timeout to scroll once the active item gets its class
                }
                scope.$watch('focused', function (focused) {
                    if (focused) {
                        $timeout(function () {
                            $input.focus();
                        }, 0, false);
                    }
                    else {
                        scope.active = null;
                    }
                });
                scope.$watch('isVisible()', function (visible) {
                    if (visible || scope.alwaysVisible) {
                        scope.hide = false;
                    }
                    else {
                        scope.active = null;
                    }
                });
            },
        };
    }])
    .directive('typeaheadItem', function () { return ({
    require: '^sdTypeahead',
    link: function (scope, element, attrs, controller) {
        var item = scope.$eval(attrs.typeaheadItem);
        scope.$watch(function () { return controller.isActive(item); }, function (active) {
            if (active) {
                element.addClass('active');
            }
            else {
                element.removeClass('active');
            }
        });
        element.on('mouseenter', function (e) {
            scope.$apply(function () {
                controller.activate(item);
            });
        });
        element.on('click', function (e) {
            scope.$apply(function () {
                controller.select(item);
            });
        });
        scope.$on('$destroy', function () {
            element.off();
        });
    },
}); });


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.slider', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdSlider
     *
     * @param {Object} value Current selected value, if nothing is selected it will use min value
     * @param {Object} list List of options
     * @param {Boolen} disabled Disable or enable slider functionality
     * @param {Object} invert Inverts min and max value
     * @param {Function} update Callback when slider value is changed
     *
     * @description Regular slider.
     */
    .directive('sdSlider', function () { return ({
    transclude: true,
    templateUrl: 'scripts/core/views/sdSlider.html',
    scope: {
        value: '=',
        list: '=',
        unique: '@',
        field: '@',
        disabled: '=',
        invert: '=',
        update: '&',
    },
    link: function (scope, element, attrs, controller) {
        scope.$watch('list', function (list) {
            if (!list) {
                return false;
            }
            var value = scope.invert ?
                -Math.abs(parseInt(scope.value, 10)) :
                parseInt(scope.value, 10), minValue = scope.invert ?
                -Math.abs(parseInt(scope.list[scope.list.length - 1][scope.unique], 10)) :
                parseInt(scope.list[0][scope.unique], 10), maxValue = scope.invert ?
                -Math.abs(parseInt(scope.list[0][scope.unique], 10)) :
                parseInt(scope.list[scope.list.length - 1][scope.unique], 10);
            if (!value) {
                value = minValue;
            }
            $('[sd-slider][data-field="' + scope.field + '"]').slider({
                range: 'max',
                min: minValue,
                max: maxValue,
                value: value,
                disabled: scope.disabled,
                create: function () {
                    $(this).find('.ui-slider-thumb')
                        .css('left', (value - minValue) * 100 / (maxValue - minValue) + '%')
                        .text(scope.invert ? Math.abs(value) : value);
                },
                slide: function (event, ui) {
                    $(this).find('.ui-slider-thumb')
                        .css('left', (ui.value - minValue) * 100 / (maxValue - minValue) + '%')
                        .text(scope.invert ? Math.abs(ui.value) : ui.value);
                    scope.update({
                        item: scope.invert ? scope.list[Math.abs(ui.value) - 1] : scope.list[ui.value] - 1,
                        field: scope.field,
                    });
                },
                start: function () {
                    $(this).find('.ui-slider-thumb')
                        .addClass('ui-slider-thumb-active');
                },
                stop: function () {
                    $(this).find('.ui-slider-thumb')
                        .removeClass('ui-slider-thumb-active');
                },
            });
        });
    },
}); });

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.directives.avatar', [])
    .directive('sdUserAvatar', function () { return ({
    scope: { user: '=' },
    link: function (scope, element, attrs) {
        scope.$watch('user', function (user) {
            if (user) {
                initAvatar(user);
            }
        }, true);
        var figure = element.parents('figure');
        element.on('error', function (e) {
            showInitials(scope.user.display_name);
        });
        function initAvatar(user) {
            if (user.picture_url) {
                showPicture(user.picture_url);
            }
            else if (user.display_name) {
                showInitials(user.display_name);
            }
            else {
                element.hide();
                figure.children('span').hide();
                figure.removeClass('no-bg initials');
            }
        }
        function showPicture(url) {
            figure.children('span').hide();
            figure.addClass('no-bg');
            figure.removeClass('initials');
            element.attr('src', url).show();
        }
        function showInitials(name) {
            var initials = name.replace(/\W*(\w)\w*/g, '$1').toUpperCase();
            element.hide();
            figure.addClass('initials');
            figure.removeClass('no-bg');
            if (figure.has('> span').length) {
                figure.children('span')
                    .text(initials)
                    .show();
            }
            else {
                figure.prepend('<span>' + initials + '</span>');
            }
        }
    },
}); });


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
exports.default = angular.module('superdesk.core.directives.withParams', [])
    /**
     * @ngdoc directive
     * @module superdesk.core.directives
     * @name sdWithParams
     *
     * @requires locationParams
     *
     * @param {String} exclude URL parameters to exclude (separated by comma).
     *
     * @description Manipulates href attribute to include current parameters.
     *
     * Example:
     * ```html
     * <a href="#/users/{{ user._id }}" sd-with-params data-exclude="id,date"></a>
     * ```
     */
    .directive('sdWithParams', ['locationParams', function (locationParams) {
        return {
            compile: function (element, attrs, transclude) {
                if (attrs.exclude) {
                    var excludes = attrs.exclude.split(',');
                    var query = locationParams.makeQuery(lodash_1.default.omit(locationParams.params, excludes), locationParams.defaults);
                    attrs.$set('href', attrs.href.trim() + query);
                }
                else {
                    attrs.$set('href', attrs.href.trim() + locationParams.getQuery());
                }
            },
        };
    }]);


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PhoneHomeModalDirective.$inject = ['serverConfig', 'api', 'session'];
function PhoneHomeModalDirective(serverConfig, api, session) {
    var template = __webpack_require__(751);
    var PhoneController = /** @class */ (function () {
        function PhoneController() {
            var _this = this;
            this.data = {};
            session.getIdentity().then(function (identity) {
                if (identity.username === 'admin') {
                    serverConfig.get('phone_home', 'done').then(function (isDone) {
                        _this.enabled = !isDone;
                    });
                }
            });
        }
        PhoneController.prototype.close = function () {
            this.enabled = false;
        };
        PhoneController.prototype.submit = function () {
            var _this = this;
            serverConfig.set('phone_home', { done: 1 }).then(function () {
                _this.close();
            });
        };
        return PhoneController;
    }());
    return {
        scope: true,
        template: template,
        controller: PhoneController,
        controllerAs: 'phone',
    };
}
exports.PhoneHomeModalDirective = PhoneHomeModalDirective;


/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "<div sd-modal data-model=\"phone.enabled\" data-close=\"phone.close()\" class=\"modal-big\">\n    <div class=\"modal__header\">\n        <button class=\"close\" ng-click=\"phone.close()\"><i class=\"icon-close-small\"></i></button>\n        <h3 class=\"modal__heading\" translate>Welcome to Superdesk</h3>\n    </div>\n    <div class=\"modal__body\">\n        <p translate>Before you start using your new newsroom, please tell us a little about yourself:</p>\n\n        <!-- Begin MailChimp Signup Form -->\n        <div id=\"mc_embed_signup\" ng-show=\"!phone.done\">\n        <form action=\"//sourcefabric.us2.list-manage.com/subscribe/post?u=6b1ad01fc31dc6604968e6439&amp;id=d915449cb0\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"phoneForm\" class=\"validate\" target=\"_blank\" novalidate ng-submit=\"phone.submit()\">\n            <fieldset id=\"mc_embed_signup_scroll\">\n        <div class=\"field\">\n            <label for=\"mce-EMAIL\">{{ :: 'Email Address' | translate }} <span class=\"asterisk\">*</span>\n        </label>\n            <input type=\"email\" ng-model=\"email\" name=\"EMAIL\" class=\"required email\" id=\"mce-EMAIL\" ng-required=\"required\">\n        </div>\n        <div class=\"field\">\n            <label for=\"mce-FNAME\">{{ :: 'First Name' | translate }} <span class=\"asterisk\">*</span>\n        </label>\n            <input type=\"text\" ng-model=\"firstName\" name=\"FNAME\" class=\"required\" id=\"mce-FNAME\" ng-required=\"required\">\n        </div>\n        <div class=\"field\">\n            <label for=\"mce-LNAME\">{{ :: 'Last Name' | translate }} <span class=\"asterisk\">*</span>\n        </label>\n            <input type=\"text\" ng-model=\"lastName\" name=\"LNAME\" class=\"required\" id=\"mce-LNAME\" ng-required=\"required\">\n        </div>\n        <div class=\"field\">\n            <label for=\"mce-MMERGE3\">{{ :: 'Company/Organisation' | translate }} <span class=\"asterisk\">*</span>\n        </label>\n            <input type=\"text\" ng-model=\"org\" name=\"MMERGE3\" class=\"required\" id=\"mce-MMERGE3\" ng-required=\"required\">\n        </div>\n            <div id=\"mce-responses\" class=\"clear\">\n                <div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div>\n                <div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div>\n            </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->\n            <div style=\"position: absolute; left: -5000px;\" aria-hidden=\"true\"><input type=\"text\" name=\"b_6b1ad01fc31dc6604968e6439_d915449cb0\" tabindex=\"-1\" value=\"\"></div>\n            <div class=\"field\">\n                <button type=\"submit\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"btn btn--primary\"\n                    ng-disabled=\"phoneForm.$invalid\" translate>Send</button>\n                <button type=\"button\" class=\"btn\" ng-click=\"phone.submit()\" translate>Skip</button>\n            </div>\n            </form>\n        </form>\n        </div>\n        <!--End mc_embed_signup-->\n\n        <p translate>We will send occasional updates on Superdesk developments to the email address you have provided. Your data will be kept secure and it won't be used for any other purpose. You may opt-out of receiving further email communications at any time.</p>\n\n        <p translate>Learn more about Superdesk at <a href=\"https://www.superdesk.org/\" title=\"Superdesk\" target=\"_blank\">www.superdesk.org</a>. For help and support, join the discussion on <a href=\"https://forum.sourcefabric.org/categories/superdesk-dev\" title=\"Superdesk forum\" target=\"_blank\">Superdesk forums</a>.</p>\n\n        <p translate>The Superdesk project is developed and maintained on <a href=\"https://github.com/superdesk\" title=\"Superdesk GitHub\" target=\"_blank\">GitHub</a> by <a href=\"https://www.sourcefabric.org/\" title=\"Sourcefabric\" target=\"_blank\">Sourcefabric</a>.</p>\n    </div>\n    <div class=\"modal__footer\">\n        <button class=\"btn\" ng-click=\"phone.close()\">Close</button>\n    </div>\n</div>\n";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.editor2
 * @name superdesk.core.editor2
 * @packageName superdesk.core
 * @description Superdesk core editor version 2.
 */
__webpack_require__(753);
__webpack_require__(755);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(761);


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(754);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./editor.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./editor.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  margin: -1px 0;\n  position: fixed;\n  right: 10px; }\n\n::-webkit-scrollbar:hover {\n  background-color: #e8e8e8;\n  cursor: pointer; }\n\n::-webkit-scrollbar-thumb {\n  background: #bbb; }\n\n::-webkit-scrollbar-thumb:hover {\n  background: #777;\n  cursor: pointer; }\n\n/*\n    ----------------------------------------------------------------------\n    INPUT ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.sdselect {\n  width: 210px;\n  position: relative; }\n  .sdselect.open {\n    box-shadow: 0px 0px 5px 0px #d0d0d0 !important; }\n    .sdselect.open .sdselect-btn {\n      border-bottom: 0 !important; }\n  .sdselect:hover .sdselect-btn {\n    cursor: pointer; }\n  .sdselect .sdselect-btn {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 2px;\n    border: 1px solid #d0d0d0;\n    padding: 6px;\n    height: 27px;\n    outline: none !important;\n    box-shadow: inset 0 0 0 #000 !important;\n    box-shadow: none !important;\n    text-decoration: none;\n    color: #333;\n    line-height: 15px;\n    font-size: 12px; }\n    .sdselect .sdselect-btn .caret {\n      margin: 5px 3px 0 0; }\n  .sdselect .sdselect-menu {\n    position: absolute;\n    background: #fff;\n    z-index: 10;\n    top: 26px;\n    left: 0;\n    right: 0;\n    height: auto;\n    border: 1px solid #d0d0d0;\n    border-radius: 0 0 2px 2px; }\n    .sdselect .sdselect-menu .sdselect-filter {\n      padding: 2px 7px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"] {\n        height: 21px !important;\n        padding: 3px !important;\n        border: 0 !important;\n        min-height: 0;\n        box-shadow: 0 0 0 0 #000; }\n        .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"]:focus {\n          box-shadow: 0 0 0 0 #000 !important; }\n    .sdselect .sdselect-menu .sdselect-all {\n      padding: 4px 9px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-all a {\n        text-decoration: none;\n        font-size: 9px;\n        text-transform: uppercase;\n        color: #989898;\n        margin-right: 10px; }\n        .sdselect .sdselect-menu .sdselect-all a:hover {\n          cursor: pointer;\n          color: #666; }\n    .sdselect .sdselect-menu .list-holder {\n      height: auto;\n      max-height: 150px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      margin: 7px 0; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar {\n        border-left: 5px solid #fff;\n        border-right: 5px solid #fff;\n        width: 13px;\n        background: #fff; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar:hover {\n          background: #e8e8e8; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb {\n        border-left: 4px solid #fff;\n        border-right: 4px solid #fff;\n        background: #bbb; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb:hover {\n          background: #787878; }\n    .sdselect .sdselect-menu ul li a {\n      display: block;\n      padding: 3px 7px;\n      font-size: 12px;\n      color: #333;\n      text-decoration: none; }\n      .sdselect .sdselect-menu ul li a:hover {\n        cursor: pointer;\n        color: #fff;\n        background: #0083c4; }\n      .sdselect .sdselect-menu ul li a i {\n        margin-right: 5px;\n        vertical-align: middle;\n        margin-top: -4px;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n\n.searchbar {\n  border-radius: 2px !important;\n  background: url(" + escape(__webpack_require__(75)) + ") no-repeat 9px 4px #ffffff !important;\n  padding: 0 0 0 35px !important; }\n  .searchbar.searchbar-large {\n    background-position: 9px 7px !important;\n    height: 32px !important;\n    font-size: 15px;\n    line-height: 26px; }\n\n.flat-searchbar {\n  flex-grow: 0; }\n  .flat-searchbar .search-handler {\n    min-width: 48px;\n    height: 48px;\n    padding: 10px 10px 10px 14px;\n    box-sizing: border-box;\n    background: none;\n    display: flex;\n    border-right: 1px solid #e0e0e0;\n    white-space: nowrap;\n    transition: all 0.3s ease; }\n    .flat-searchbar .search-handler input {\n      height: 28px;\n      line-height: 100%;\n      font-size: 14px;\n      border: 0 !important;\n      width: 0;\n      padding: 0;\n      background-color: rgba(255, 255, 255, 0);\n      transition: all 0.3s ease; }\n      .flat-searchbar .search-handler input:focus {\n        box-shadow: none !important; }\n    .flat-searchbar .search-handler .trigger-icon {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -o-user-select: none;\n      user-select: none;\n      -webkit-touch-callout: none;\n      -khtml-user-select: none;\n      -ms-user-select: none;\n      float: left;\n      width: 28px;\n      height: 28px;\n      display: inline-block;\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\"; }\n      .flat-searchbar .search-handler .trigger-icon:hover {\n        cursor: pointer;\n        opacity: 0.8;\n        filter: \"alpha(opacity=80)\"; }\n      .flat-searchbar .search-handler .trigger-icon i {\n        padding: 7px 3px 4px 6px; }\n  .flat-searchbar .separator-handler {\n    margin: 9px 0 0 5px;\n    border-right: 2px dotted #bcbcbc;\n    height: 30px;\n    float: left; }\n  .flat-searchbar .search-close {\n    border: 0;\n    background: none;\n    display: none;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n    .flat-searchbar .search-close.visible {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n      .flat-searchbar .search-close.visible:hover {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n  .flat-searchbar.extended {\n    flex-grow: 1; }\n    .flat-searchbar.extended .search-handler {\n      border-right: 1px solid #e0e0e0; }\n      .flat-searchbar.extended .search-handler input {\n        width: auto;\n        padding: 0 6px; }\n    .flat-searchbar.extended .separator-handler {\n      margin-left: 14px; }\n    .flat-searchbar.extended .search-close {\n      display: inline-block; }\n\n.ui-responsive-small .flat-searchbar.extended {\n  position: absolute;\n  z-index: 2; }\n\n.monitoring-backlink .separator-handler {\n  margin-top: 0;\n  margin-right: 10px; }\n\n.filter-type {\n  white-space: nowrap; }\n  .filter-type__item {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 3px 2px;\n    cursor: pointer; }\n    .filter-type__item i {\n      height: auto;\n      color: #999;\n      padding: 2px 8px 1px 8px;\n      background: rgba(255, 255, 255, 0.5);\n      border: 1px solid rgba(215, 215, 215, 0.7);\n      border-radius: 2px;\n      box-sizing: border-box; }\n    .filter-type__item a {\n      height: 21px;\n      font-size: 11px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n      line-height: 21px;\n      text-decoration: none;\n      padding: 4px 10px;\n      border-radius: 2px;\n      border: 1px solid #999;\n      box-sizing: border-box;\n      text-transform: uppercase;\n      background: #fff !important;\n      color: #333;\n      opacity: 0.7; }\n      .filter-type__item a:hover {\n        color: #000;\n        opacity: 1; }\n      .filter-type__item a.filter-type__link--blue {\n        border-color: #5ea9c8;\n        color: #5ea9c8; }\n      .filter-type__item a.filter-type__link--dark-blue {\n        border-color: #216278;\n        color: #216278; }\n    .filter-type__item:hover i {\n      background: rgba(255, 255, 255, 0.8);\n      border: 1px solid #aaaaaa;\n      color: #666; }\n    .filter-type__item--active i {\n      opacity: 1;\n      color: #F5F5F5;\n      background: #505050;\n      border-color: #505050;\n      box-shadow: inset 0 1px 0px #373737 !important; }\n    .filter-type__item--active a {\n      opacity: 1;\n      background: #505050 !important;\n      border-color: #373737 #505050 #505050 !important;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0px #373737 !important; }\n    .filter-type__item--active:hover i {\n      border-color: rgba(80, 80, 80, 0.8);\n      background-color: rgba(80, 80, 80, 0.8);\n      color: #F5F5F5; }\n    .filter-type__item--active:hover a {\n      opacity: 0.8; }\n\n.filter-type--padded {\n  padding: 10px 0 10px 20px; }\n\n.result-type {\n  margin-left: 10px; }\n\n.dropdown__menu .filter-type {\n  padding: 0 10px; }\n\n.dropdown__menu--compare-versions {\n  max-height: 400px;\n  min-width: 250px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--compare-versions li {\n    margin-bottom: 2px;\n    line-height: 14px !important; }\n    .dropdown__menu--compare-versions li .dropdown.open li .dropdown .dropdown__toggle:hover {\n      display: none; }\n    .dropdown__menu--compare-versions li button {\n      width: 300px;\n      padding-right: 30px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      position: relative;\n      border-radius: 0;\n      line-height: 14px !important;\n      box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.15); }\n      .dropdown__menu--compare-versions li button i {\n        position: absolute;\n        right: -5px;\n        top: 9px; }\n      .dropdown__menu--compare-versions li button.disabled, .dropdown__menu--compare-versions li button.disabled:hover {\n        background: #f0f0f0; }\n        .dropdown__menu--compare-versions li button.disabled i, .dropdown__menu--compare-versions li button.disabled:hover i {\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\"; }\n      .dropdown__menu--compare-versions li button .headline {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-size: 11px;\n        font-weight: 500;\n        width: 240px;\n        display: inline-block; }\n      .dropdown__menu--compare-versions li button .desk-details {\n        display: flex;\n        font-size: 10px;\n        margin: 4px 0; }\n        .dropdown__menu--compare-versions li button .desk-details span:first-of-type {\n          flex-grow: 1; }\n      .dropdown__menu--compare-versions li button em {\n        font-size: 10px;\n        font-weight: 500;\n        color: #888;\n        float: left;\n        padding-right: 10px; }\n    .dropdown__menu--compare-versions li .msg {\n      padding: 0 20px; }\n\n.dropdown__menu .fieldset button {\n  text-align: center;\n  width: auto;\n  min-width: 50px;\n  clear: none;\n  margin-right: 10px;\n  float: right; }\n\n.online-users {\n  float: left;\n  height: 48px;\n  padding-left: 15px;\n  margin-left: 5px; }\n  .online-users > * {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    padding: 16px 0;\n    line-height: 13px; }\n\n[sd-timezone] .timezone-label {\n  margin-bottom: 1rem; }\n\n[sd-timezone] .input-term input {\n  height: 3.2rem;\n  margin-bottom: 5px;\n  width: 100%;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  border: none;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.3rem;\n  color: inherit;\n  padding-left: 1rem; }\n  [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(0, 0, 0, 0.3);\n    background-color: rgba(0, 0, 0, 0.1); }\n  [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[sd-timezone] .item-list {\n  width: 100%;\n  color: #333; }\n\n[sd-timezone] .pills-list li {\n  padding: 0.7rem 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 1.3rem; }\n  [sd-timezone] .pills-list li .icon-remove-sign {\n    color: inherit; }\n  [sd-timezone] .pills-list li #timezone {\n    padding-right: 2.5rem;\n    flex-grow: 1; }\n\n[class^=\"--dark-ui\"] [sd-timezone] .input-term input,\n[class*=\"--dark-ui\"] [sd-timezone] .input-term input {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:hover,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:focus,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input, .timepicker-input {\n  position: relative;\n  width: auto;\n  min-width: 130px; }\n  .datepicker-input input, .timepicker-input input {\n    width: 100%;\n    transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n    padding-right: 3.2rem;\n    padding-left: 1rem;\n    min-height: 2.8rem;\n    border: none;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    font-size: 1.3rem;\n    color: inherit; }\n    .datepicker-input input:hover, .timepicker-input input:hover {\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n      background-color: rgba(0, 0, 0, 0.1); }\n    .datepicker-input input:focus, .timepicker-input input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n    .datepicker-input input.ng-invalid, .timepicker-input input.ng-invalid {\n      color: #d10000;\n      border-color: #b61818 !important;\n      box-shadow: 0 1px 0 0 #b61818 !important; }\n  .datepicker-input .icn-btn, .timepicker-input .icn-btn {\n    position: absolute;\n    right: 2px;\n    top: 0; }\n\n.datepicker-input--dark input, .timepicker-input--dark input {\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 1.3rem;\n  line-height: 1.8rem;\n  color: inherit;\n  min-height: 32px; }\n  .datepicker-input--dark input:hover, .timepicker-input--dark input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  .datepicker-input--dark input:focus, .timepicker-input--dark input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input--dark .icn-btn, .timepicker-input--dark .icn-btn {\n  background: transparent;\n  top: 50%;\n  margin-top: -14px; }\n\n.datepicker-input--dark .name, .timepicker-input--dark .name {\n  background-color: #4f4f4f;\n  height: 24px;\n  font-size: 12px;\n  color: #fff; }\n\n.datepicker-input--dark ul > li, .timepicker-input--dark ul > li {\n  width: 90%; }\n\n.datepicker-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 260px;\n  box-sizing: border-box; }\n  .datepicker-wrapper .btn {\n    height: 28px; }\n    .datepicker-wrapper .btn:hover {\n      box-shadow: none; }\n  .datepicker-wrapper .btn--mini {\n    padding: 4px 6px;\n    font-size: 11px;\n    line-height: 11px !important;\n    height: auto; }\n  .datepicker-wrapper table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 0; }\n    .datepicker-wrapper table td, .datepicker-wrapper table th {\n      padding: 1px;\n      border: 0; }\n  .datepicker-wrapper .datepicker-additional {\n    margin-bottom: 5px; }\n    .datepicker-wrapper .datepicker-additional table {\n      width: 100%; }\n    .datepicker-wrapper .datepicker-additional .btn {\n      width: 100%; }\n  .datepicker-wrapper .datepicker-core table {\n    width: 100%; }\n    .datepicker-wrapper .datepicker-core table thead tr th .btn {\n      background: none;\n      padding: 0; }\n    .datepicker-wrapper .datepicker-core table thead tr:last-child th small {\n      font-weight: 500; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn strong {\n      font-weight: normal;\n      font-size: 14px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn i {\n      display: inline-block;\n      width: 14px;\n      height: 14px;\n      background-repeat: no-repeat; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:first-child .btn i {\n      margin-left: 3px;\n      background-position: -189px -165px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:last-child .btn i {\n      margin-right: 3px;\n      background-position: -213px -165px; }\n    .datepicker-wrapper .datepicker-core table tbody tr:first-child td {\n      padding-top: 5px; }\n    .datepicker-wrapper .datepicker-core table tbody td {\n      padding: 0 2px; }\n      .datepicker-wrapper .datepicker-core table tbody td .btn {\n        width: 100% !important;\n        min-width: 28px !important;\n        padding: 0;\n        background: none;\n        color: #333;\n        box-shadow: none; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn .text-muted {\n          color: #999; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn:hover, .datepicker-wrapper .datepicker-core table tbody td .btn.active {\n          color: #333;\n          box-shadow: inset 0 0 1px 0 #5ea9c8;\n          background: #eff7fa; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active {\n          color: #fff;\n          background: #5ea9c8; }\n          .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary .text-muted, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active .text-muted {\n            color: #fff; }\n\n.timepicker-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 200px;\n  height: 310px;\n  box-sizing: border-box; }\n  .timepicker-popup .timepicker-additional {\n    margin-bottom: 5px; }\n    .timepicker-popup .timepicker-additional table {\n      width: 100%;\n      border-collapse: collapse;\n      border: 0; }\n      .timepicker-popup .timepicker-additional table td, .timepicker-popup .timepicker-additional table th {\n        padding: 1px; }\n    .timepicker-popup .timepicker-additional .btn {\n      width: 100%;\n      letter-spacing: 0; }\n    .timepicker-popup .timepicker-additional .btn--mini {\n      padding: 4px 6px;\n      font-size: 11px;\n      line-height: 11px !important;\n      height: 20px; }\n  .timepicker-popup .timepicker-core .select-area {\n    margin-top: 15px;\n    border-top: 1px solid #ddd; }\n    .timepicker-popup .timepicker-core .select-area .header {\n      margin-top: -10px;\n      float: left;\n      background: #fff;\n      text-transform: uppercase;\n      color: #adadad;\n      font-size: 11px;\n      padding-right: 10px; }\n    .timepicker-popup .timepicker-core .select-area ul {\n      padding-top: 15px;\n      *zoom: 1; }\n      .timepicker-popup .timepicker-core .select-area ul:before, .timepicker-popup .timepicker-core .select-area ul:after {\n        display: table;\n        content: \"\"; }\n      .timepicker-popup .timepicker-core .select-area ul:after {\n        clear: both; }\n      .timepicker-popup .timepicker-core .select-area ul > li {\n        float: left;\n        box-sizing: border-box;\n        width: 28px;\n        height: 28px;\n        line-height: 28px;\n        text-align: center;\n        margin: 0 2px 2px 0;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none;\n        border-radius: 2px; }\n        .timepicker-popup .timepicker-core .select-area ul > li:hover {\n          background: #eff7fa;\n          cursor: pointer; }\n        .timepicker-popup .timepicker-core .select-area ul > li.active {\n          background: #5ea9c8;\n          color: #fff; }\n\n.pills-list.line-input > li {\n  width: 100%;\n  border-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background-color: transparent;\n  padding: 0;\n  height: 24px;\n  box-shadow: none; }\n  .pills-list.line-input > li .actions {\n    top: -9px; }\n  .pills-list.line-input > li:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: transparent !important;\n    box-shadow: none; }\n  .pills-list.line-input > li:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important;\n    background-color: transparent !important; }\n\n/*\n    ----------------------------------------------------------------------\n    OTHER CUSTOM ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.backlink, a.backlink {\n  text-decoration: none !important;\n  color: #333;\n  border: 0;\n  transition: all ease 0.2s;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  padding: 0;\n  margin: 0;\n  cursor: pointer; }\n  .backlink:before, a.backlink:before {\n    font-family: 'sd_icons';\n    font-weight: normal;\n    font-style: normal;\n    content: \"\\E677\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n    flex-grow: 0;\n    margin: -1px 8px 0 0;\n    text-decoration: none !important;\n    transition: all ease 0.2s;\n    opacity: 0.7; }\n  .backlink.white, a.backlink.white {\n    color: #fff; }\n  .backlink:hover, a.backlink:hover {\n    color: #5ea9c8;\n    text-decoration: none !important; }\n    .backlink:hover:before, a.backlink:hover:before {\n      text-decoration: none !important;\n      margin: -1px 10px 0 -2px;\n      opacity: 1; }\n\n.stage-header__name a {\n  transition: all ease 0.2s; }\n\n.widget-content .stage-header__name a {\n  text-decoration: none !important; }\n\n.activity-log {\n  margin-top: 10px; }\n  .activity-log ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; }\n    .activity-log ul li.activity .activity-content {\n      padding-left: 45px;\n      margin-top: -3px;\n      padding-right: 20px;\n      color: #555; }\n      .activity-log ul li.activity .activity-content b {\n        font-weight: 500; }\n    .activity-log ul li.activity .activity-date {\n      padding-left: 45px;\n      font-size: 11px;\n      color: #999;\n      margin-top: -5px; }\n    .activity-log ul li.activity.with-date {\n      margin-top: 35px; }\n      .activity-log ul li.activity.with-date .date {\n        border-top: 1px solid #ebebeb;\n        top: -17px;\n        position: absolute;\n        right: 0;\n        left: 0; }\n        .activity-log ul li.activity.with-date .date span {\n          font-size: 12px;\n          color: #999;\n          margin-top: -10px;\n          display: block;\n          float: left;\n          background: #f8f8f8;\n          padding-right: 5px; }\n    .activity-log ul li.activity:hover {\n      cursor: default; }\n\n.activity-load-more {\n  width: 100%;\n  font-size: 12px;\n  margin: 20px 0; }\n\n.notification-list {\n  margin: 0;\n  margin-bottom: 20px;\n  list-style-type: none; }\n  .notification-list li {\n    background: #393939;\n    padding: 10px 5px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    width: 100%;\n    min-height: 45px;\n    margin: 10px 0;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5); }\n    .notification-list li .content {\n      padding-left: 40px; }\n      .notification-list li .content .text {\n        margin: 0;\n        font-size: 12px;\n        overflow: hidden;\n        color: #d7d7d7; }\n      .notification-list li .content .date, .notification-list li .content .date time, .notification-list li .content time {\n        font-size: 11px;\n        color: #848484;\n        margin-top: -3px;\n        display: block; }\n      .notification-list li .content a {\n        cursor: pointer;\n        color: #5ea9c8; }\n        .notification-list li .content a:hover {\n          text-decoration: none;\n          color: #97c7db; }\n    .notification-list li.unread {\n      border-color: #545454;\n      background: #2c2c2c; }\n    .notification-list li.important {\n      border: 1px solid #a60101 !important;\n      box-shadow: inset 0px 0px 1px 1px #e4b2b2, 0px 2px 2px 0px #d8d8d8 !important; }\n    .notification-list li.personal, .notification-list li.important {\n      border: 1px solid #c8c8c8;\n      border-radius: 3px;\n      background: #fff;\n      padding: 5px;\n      margin-bottom: 7px;\n      box-shadow: 0px 2px 2px 0 #d8d8d8; }\n      .notification-list li.personal + li, .notification-list li.important + li {\n        border-top-width: 0; }\n        .notification-list li.personal + li.personal, .notification-list li.personal + li.important, .notification-list li.important + li.personal, .notification-list li.important + li.important {\n          border-top-width: 1px; }\n    .notification-list li .info {\n      color: #e0e0e0; }\n  .notification-list.white li {\n    background: #fff;\n    border-color: #dedede;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12); }\n    .notification-list.white li .content .text {\n      color: #333; }\n    .notification-list.white li.active {\n      border-color: #999;\n      box-shadow: 0 1px 2px 0 #666; }\n\n.notification-pane ::-webkit-scrollbar:hover {\n  background-color: #4a4a4a; }\n\n.notification-pane ::-webkit-scrollbar-thumb {\n  background: #5a5a5a; }\n\n.notification-pane ::-webkit-scrollbar-thumb:hover {\n  background: #666; }\n\n.hard-error {\n  position: fixed;\n  top: 0;\n  right: 200px;\n  z-index: 9999;\n  width: auto;\n  max-width: 400px; }\n  .hard-error .alert {\n    border-radius: 0;\n    border: 0;\n    box-sizing: border-box;\n    height: 40px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n    padding: 0 15px; }\n  .hard-error .alert-error {\n    background-color: #612525;\n    color: #cc7c7b;\n    text-shadow: none; }\n  .hard-error:hover .alert {\n    height: auto;\n    line-height: 20px;\n    padding: 10px 15px;\n    overflow: visible;\n    white-space: pre-wrap; }\n\n.sd-pagination {\n  padding: 7px 20px; }\n  .sd-pagination .btn {\n    padding: 10px; }\n    .sd-pagination .btn i {\n      margin-right: 0; }\n  .sd-pagination .page-info {\n    margin-right: 20px;\n    display: inline-block; }\n    .sd-pagination .page-info input {\n      display: inline-block;\n      width: 30px;\n      text-align: center;\n      margin-top: -1px;\n      padding: 6px 3px !important;\n      border-radius: 5px;\n      margin: 0 5px;\n      box-shadow: inset 0 5px 5px -5px #acacac; }\n  .sd-pagination .btn-group, .sd-pagination .btn-group > .btn {\n    display: inline-block;\n    vertical-align: middle;\n    float: none; }\n  .sd-pagination .btn-group > .btn + .btn {\n    margin-left: 0px; }\n\n.assignment-menu .assignment-box {\n  width: 270px; }\n  .assignment-menu .assignment-box h5 {\n    border: 0; }\n  .assignment-menu .assignment-box .assignment-content .assignment-result-list {\n    margin-top: 10px;\n    height: 140px;\n    overflow: auto; }\n    .assignment-menu .assignment-box .assignment-content .assignment-result-list ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li {\n        height: 32px;\n        margin-bottom: 3px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li .avatar-small {\n          width: 24px;\n          height: 24px;\n          border: 0;\n          padding: 0;\n          margin: 0;\n          background-size: 24px 24px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li span {\n          font-size: 13px;\n          color: #4f4f4f;\n          line-height: 24px;\n          margin-left: 10px; }\n\n.sortbar {\n  white-space: nowrap;\n  margin: 0 5px;\n  padding: 0 10px; }\n  .sortbar > * {\n    display: inline-block !important;\n    vertical-align: middle; }\n  .sortbar > .dropdown {\n    margin-right: 10px; }\n  .sortbar .lab {\n    margin-right: 10px; }\n  .sortbar .dropdown__toggle {\n    color: #808080;\n    min-width: auto !important; }\n  .sortbar .direction {\n    background: none;\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.selectionlist {\n  list-style-type: none;\n  padding: 2px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  overflow: auto; }\n  .selectionlist li {\n    line-height: 16px;\n    height: 16px;\n    padding: 4px;\n    margin-bottom: 3px;\n    border-radius: 3px;\n    background: #e8e8e8; }\n  .selectionlist .sf-toggle-custom {\n    margin-top: -1px;\n    float: right; }\n\n.plain-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n  .plain-list.plain-border-top {\n    border-top: 1px solid #e5e5e5; }\n  .plain-list > li {\n    border-bottom: 1px solid #e5e5e5;\n    height: 41px;\n    line-height: 40px;\n    cursor: pointer;\n    position: relative;\n    padding: 0 5px;\n    box-sizing: border-box; }\n    .plain-list > li:hover {\n      background: #eff7fa; }\n    .plain-list > li .btn--mini {\n      margin-top: 10px; }\n\n.plain-small > li {\n  height: 31px;\n  line-height: 30px; }\n\n.users-list > li .avatar {\n  margin-top: 5px;\n  margin-right: 15px; }\n\n.users-list > li .name {\n  font-size: 13px;\n  color: #3599b6; }\n\n.plain-small.users-list > li .avatar {\n  margin-top: 3px; }\n\n.users-list-embed {\n  position: relative; }\n  .users-list-embed > li {\n    height: 32px;\n    line-height: 32px;\n    margin-right: -5px; }\n    .users-list-embed > li .avatar {\n      margin: 3px 10px 4px 4px; }\n    .users-list-embed > li:hover, .users-list-embed > li.active {\n      cursor: pointer;\n      color: #fff; }\n    .users-list-embed > li:hover {\n      background: #84bdd5; }\n    .users-list-embed > li:active {\n      background: #97c7db; }\n    .users-list-embed > li.active {\n      background: #5ea9c8; }\n    .users-list-embed > li.inactive {\n      color: #ccc; }\n\n.mentio-menu {\n  padding: 5px;\n  border: 1px solid #ddd;\n  max-height: 126px;\n  z-index: 9999 !important;\n  overflow: auto;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);\n  width: 190px;\n  bottom: 5px; }\n  .mentio-menu ul li {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.card-list > li, .card {\n  display: block;\n  padding: 10px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  margin-bottom: 7px;\n  position: relative; }\n  .card-list > li:not([disabled]):hover, .card:not([disabled]):hover {\n    cursor: pointer;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li:not([disabled]):hover .action, .card:not([disabled]):hover .action {\n      display: block !important; }\n  .card-list > li.selected, .card.selected {\n    background-color: #eff7fa;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li.selected:hover, .card.selected:hover {\n      box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n  .card-list > li[disabled], .card[disabled] {\n    cursor: default !important;\n    background-color: rgba(255, 255, 255, 0.45); }\n  .card-list > li .action, .card .action {\n    display: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    min-width: 200px; }\n    .card-list > li .action ul, .card .action ul {\n      height: 100%;\n      text-align: right; }\n    .card-list > li .action .item-field, .card .action .item-field {\n      height: 100%; }\n      .card-list > li .action .item-field span, .card .action .item-field span {\n        display: none; }\n      .card-list > li .action .item-field a, .card .action .item-field a {\n        padding: 0 23px;\n        line-height: 62px;\n        display: block; }\n\n.active .card {\n  background-color: #eff7fa;\n  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n  .active .card:hover {\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n\n.pills-list {\n  max-width: 650px; }\n  .pills-list > li {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    background: #fff;\n    margin-bottom: 6px;\n    margin-right: 2px;\n    border-radius: 2px;\n    padding: 10px 16px;\n    min-height: 18px;\n    color: inherit;\n    position: relative;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.08);\n    transition: all ease-in-out 0.2s; }\n    .pills-list > li:hover {\n      box-shadow: 0 0px 3px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.2); }\n    .pills-list > li.active {\n      background: #5ea9c8;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0 #3e92b5; }\n    .pills-list > li.inactive {\n      opacity: 0.5; }\n    .pills-list > li.empty-info {\n      background: transparent;\n      border: 1px dotted rgba(123, 123, 123, 0.5);\n      opacity: 0.75;\n      box-shadow: none !important; }\n    .pills-list > li .dropdown {\n      margin-top: -3px; }\n    .pills-list > li .actions {\n      display: none;\n      position: absolute;\n      top: 0px;\n      right: 4px; }\n      .pills-list > li .actions button {\n        transition: opacity ease-in-out 0.2s;\n        border: 0;\n        height: 30px;\n        width: 30px;\n        margin: 3px;\n        background: none;\n        text-align: center;\n        display: block;\n        float: left;\n        line-height: 0;\n        opacity: 0.4; }\n        .pills-list > li .actions button:hover {\n          cursor: pointer;\n          opacity: 1; }\n        .pills-list > li .actions button i {\n          margin-top: -2px; }\n    .pills-list > li h6 {\n      text-transform: none;\n      color: inherit;\n      font-size: 14px;\n      font-weight: 300;\n      float: left;\n      max-width: 99%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .pills-list > li .label-group {\n      display: inline-block; }\n      .pills-list > li .label-group.label-group--right {\n        float: right; }\n    .pills-list > li .label {\n      font-size: 9px;\n      font-weight: 700;\n      padding: 2px 5px;\n      line-height: 12px;\n      margin-left: 5px;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n      font-weight: 400; }\n    .pills-list > li:hover .actions {\n      display: block !important; }\n    .pills-list > li:hover h6 {\n      max-width: 550px; }\n    .pills-list > li .avatar {\n      display: inline-block;\n      float: none; }\n    .pills-list > li h5 {\n      display: inline-block; }\n  .pills-list.pills-editable li.editable {\n    padding: 0;\n    height: auto;\n    background: transparent; }\n    .pills-list.pills-editable li.editable input {\n      height: 30px;\n      line-height: 30px;\n      border-radius: 3px; }\n\n[class^=\"--dark-ui\"] .pills-list > li,\n[class*=\"--dark-ui\"] .pills-list > li {\n  background: #4f4f4f; }\n\n.pill-small {\n  width: 200px;\n  margin: 4px; }\n\n.item-field {\n  border-left: 1px solid #d8d8d8;\n  display: inline-block; }\n  .item-field span {\n    display: none; }\n  .item-field button {\n    border: 0;\n    padding: 0;\n    background: none;\n    vertical-align: text-top; }\n  .item-field:hover {\n    background: rgba(0, 0, 0, 0.1);\n    border-color: #e0e0e0; }\n  .item-field.disabled {\n    cursor: default; }\n    .item-field.disabled i {\n      opacity: 0.3;\n      filter: \"alpha(opacity=30)\"; }\n    .item-field.disabled:hover {\n      background: #e8e8e8; }\n\n.dropdown .item-field {\n  display: block;\n  border-left: 0; }\n  .dropdown .item-field span {\n    display: inline-block; }\n\n.dropdown .item-field:hover {\n  background: none; }\n\n.or-label {\n  position: relative;\n  text-align: center;\n  font-style: italic; }\n  .or-label:before {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: -75px; }\n  .or-label:after {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: 15px; }\n\n.list-group {\n  box-sizing: border-box;\n  width: 300px; }\n  .list-group .list-group-item {\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-width: 0 1px 1px 1px;\n    background-color: #fff; }\n    .list-group .list-group-item:first-child {\n      border-width: 1px;\n      border-radius: 5px 5px 0 0; }\n    .list-group .list-group-item:last-child {\n      border-radius: 0 0 5px 5px; }\n    .list-group .list-group-item:hover {\n      background-color: #f4f4f4;\n      cursor: pointer; }\n    .list-group .list-group-item a {\n      text-decoration: none;\n      color: #444; }\n\n.shadow-list-holder {\n  overflow-y: auto;\n  width: 100%;\n  max-height: 100%;\n  min-height: 100%;\n  box-sizing: border-box; }\n\n.scroll-shadow {\n  height: 0; }\n  .scroll-shadow .inner {\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(transparent));\n    height: 4px;\n    position: relative;\n    z-index: 503;\n    transition: linear 0.1s all;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n  .scroll-shadow.shadow .inner {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n\n.toggle-box__button {\n  transition: color ease-in-out 0.2s;\n  color: #999;\n  cursor: pointer; }\n  .toggle-box__button i {\n    color: inherit;\n    margin-right: 5px;\n    vertical-align: text-bottom; }\n  .toggle-box__button:hover {\n    text-decoration: none;\n    color: #fff; }\n\n.fade {\n  transition: opacity 0.15s linear;\n  opacity: 0; }\n  .fade.in {\n    opacity: 1; }\n\n.close {\n  float: right;\n  line-height: 18px;\n  opacity: 0.2;\n  filter: \"alpha(opacity=20)\"; }\n  .close:hover {\n    text-decoration: none;\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\";\n    cursor: pointer; }\n  .close i {\n    vertical-align: middle; }\n\n.draggable-list__item {\n  background-color: #fff;\n  padding: 18px 14px 19px 25px;\n  margin-bottom: 10px;\n  cursor: move;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  position: relative; }\n  .draggable-list__item.placeholder {\n    background: none;\n    box-shadow: none;\n    border: 2px dashed #ebebeb; }\n  .draggable-list__item:after {\n    content: \"\";\n    width: 10px;\n    top: 0;\n    bottom: 0;\n    left: 2px;\n    background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 3px top 3px;\n    opacity: 0.2;\n    position: absolute;\n    display: block; }\n  .draggable-list__item:hover {\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4); }\n    .draggable-list__item:hover:after {\n      opacity: 0.8; }\n  .draggable-list__item--small {\n    padding: 10px 14px 10px 25px; }\n  .draggable-list__item--no-padding {\n    padding: 0 0 0 8px; }\n    .draggable-list__item--no-padding:after {\n      width: 6px;\n      left: 2px;\n      background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 0px top 3px; }\n\n.draggable-list.serial-decimal {\n  list-style-type: decimal !important;\n  padding-top: 0px;\n  margin-left: 5px; }\n  .draggable-list.serial-decimal > li {\n    word-spacing: 2px;\n    line-height: 0px; }\n  .draggable-list.serial-decimal .sort-item.active {\n    background-color: #eee; }\n\n.ui-resizable-e {\n  cursor: col-resize !important; }\n\n.spinner-big {\n  background-image: url(" + escape(__webpack_require__(34)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  vertical-align: middle;\n  text-align: center; }\n\n.spinner-alt {\n  background-image: url(" + escape(__webpack_require__(106)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  line-height: 32px;\n  vertical-align: middle;\n  text-align: center; }\n\n.sd-check__wrapper .sd-checkbox + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: inherit;\n  height: auto;\n  text-transform: none; }\n  .sd-check__wrapper .sd-checkbox + label.label--active {\n    color: #479dc0; }\n\n.sd-toggle + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: #333;\n  height: auto;\n  text-transform: none; }\n\n.definition-list .definition-list__term {\n  font-size: 1.6rem;\n  margin-bottom: 0.6rem;\n  font-weight: 400; }\n\n.definition-list .definition-list__item {\n  padding: 0.3rem 0;\n  margin-left: 0;\n  font-size: 1.4rem;\n  font-weight: 300; }\n\n.definition-list .definition-list__item + .definition-list__term {\n  margin-top: 2rem; }\n\n.nav-button-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 0; }\n  .nav-button-bar .btn {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.modal__header--flex .icn-btn.close, .modal__header--flex .icn-btn.close-modal, .modal__header--flex .icn-btn.modal__close {\n  margin: 0 -0.6rem 0;\n  border: 0;\n  padding: .6rem;\n  opacity: 0.5; }\n  .modal__header--flex .icn-btn.close:hover, .modal__header--flex .icn-btn.close-modal:hover, .modal__header--flex .icn-btn.modal__close:hover {\n    opacity: 0.8; }\n  .modal__header--flex .icn-btn.close:active, .modal__header--flex .icn-btn.close-modal:active, .modal__header--flex .icn-btn.modal__close:active {\n    opacity: 1; }\n\n.sd-line-input__message--with-char-count {\n  padding-right: 10rem; }\n\n.sd-list-item.inactive {\n  background-color: transparent;\n  color: rgba(123, 123, 123, 0.75); }\n\n.sd-toggle + label {\n  letter-spacing: 0; }\n\n.sd-list-item__text-label time {\n  padding: 0;\n  font-style: normal; }\n\n[sd-meta-terms] {\n  min-height: 2.8rem; }\n\n.line-input--boxed .input-term input[type=\"text\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.4rem;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 0 1rem;\n  height: 3.2rem;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  .line-input--boxed .input-term input[type=\"text\"]:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: rgba(0, 0, 0, 0.1) !important; }\n  .line-input--boxed .input-term input[type=\"text\"]:focus {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important; }\n\n.line-input--boxed .terms-list {\n  width: 100%;\n  margin-top: 0.8rem; }\n\nsd-tag-input + .sd-line-input__message {\n  margin-top: -2rem; }\n\nsd-multi-image-edit {\n  height: 100vh;\n  display: flex;\n  flex-direction: column; }\n\n.sd-wrap-helper {\n  display: contents !important; }\n\n.subnav {\n  z-index: 5; }\n\n.subnav + .subnav {\n  z-index: 4; }\n\n.editor-type-html:before {\n  display: block;\n  /* For Firefox */ }\n\n.editor-type-html:empty:before {\n  content: attr(placeholder);\n  display: block;\n  /* For Firefox */\n  color: rgba(150, 150, 150, 0.5); }\n\n.editor-type-html:focus:before {\n  display: none; }\n\n.editor-type-html span, .editor-type-html p, .editor-type-html h1, .editor-type-html h2, .editor-type-html h3, .editor-type-html h4 {\n  background-color: transparent;\n  font-family: inherit; }\n\n.editor-type-html span, .editor-type-html h3 {\n  font-size: inherit;\n  line-height: 150%; }\n\n.editor-type-html pre {\n  font-size: inherit;\n  line-height: 150%; }\n  .editor-type-html pre span, .editor-type-html pre h3 {\n    font-size: inherit;\n    line-height: 150%; }\n\n.headline .editor-type-html span {\n  font-size: inherit;\n  line-height: 120%;\n  font-weight: 500; }\n\n.dropdown__menu--suggestions {\n  font-size: 14px;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif; }\n\n.medium-editor-toolbar {\n  z-index: 1020; }\n  .medium-editor-toolbar li .medium-editor-button-disabled {\n    background-color: gray;\n    cursor: default;\n    pointer-events: none; }\n\n.block--not-alone-and-empty .text-editor:not(.medium-editor-dragover) {\n  opacity: 0;\n  transition: opacity 0.25s; }\n  .block--not-alone-and-empty .text-editor:not(.medium-editor-dragover):focus, .block--not-alone-and-empty .text-editor:not(.medium-editor-dragover):hover {\n    opacity: 1; }\n\n.block__container {\n  position: relative; }\n  .block__container .text-editor {\n    padding: 0;\n    margin-top: 6px; }\n    .block__container .text-editor.medium-editor-dragover, .block__container .text-editor .medium-editor-dragover {\n      background: #eff7fa;\n      border: 2px dashed #5ea9c8; }\n  .block__container .preview--caption, .block__container .editor--caption {\n    margin: 0;\n    border: 1px solid rgba(150, 150, 150, 0.15); }\n    .block__container .preview--caption input, .block__container .preview--caption select, .block__container .preview--caption textarea, .block__container .editor--caption input, .block__container .editor--caption select, .block__container .editor--caption textarea {\n      color: inherit; }\n  .block__container .editor--caption [contenteditable] {\n    padding: 8px;\n    min-height: 18px; }\n  .block__container .editor--embed {\n    min-height: 200px; }\n\n.block__actions {\n  position: absolute;\n  right: -38px;\n  top: 0;\n  cursor: pointer;\n  opacity: .1; }\n  .block__actions i {\n    color: inherit; }\n  .block__actions > div {\n    display: inline-block; }\n\n.block__container:hover .block__actions {\n  opacity: 1; }\n\n.add-content {\n  position: absolute;\n  z-index: 1;\n  transform: translate(-48px, -12px);\n  -moz-transform: translate(-48px, -12px);\n  -wekit-transform: translate(-48px, -12px); }\n  .add-content--expanded .add-content__plus-btn {\n    opacity: 1; }\n    .add-content--expanded .add-content__plus-btn i {\n      transform: rotate(45deg); }\n  .add-content--expanded .add-content__actions span {\n    transform: scale(1); }\n    .add-content--expanded .add-content__actions span:hover {\n      z-index: 1; }\n  .add-content__plus-btn {\n    position: absolute;\n    opacity: .7; }\n    .add-content__plus-btn:hover {\n      opacity: 1; }\n    .add-content__plus-btn i {\n      transition: transform 0.25s; }\n  .add-content__actions {\n    position: relative;\n    top: 10px;\n    left: 50px; }\n    .add-content__actions.ng-hide:not(.ng-hide-animate) {\n      display: block !important;\n      position: absolute;\n      pointer-events: none;\n      width: 200px; }\n    .add-content__actions span {\n      display: inline-block;\n      transform: scale(0);\n      transition: transform 0.25s;\n      border-radius: 24px;\n      border: 2px solid #5ea9c8;\n      padding: 5px 5px 0px;\n      background-color: #fff; }\n      .add-content__actions span:nth-of-type(2) {\n        transition-delay: .1s;\n        -moz-transition-delay: .1s;\n        -webkit-transition-delay: .1s; }\n      .add-content__actions span i {\n        color: #5ea9c8; }\n      .add-content__actions span:hover {\n        cursor: pointer;\n        background-color: #5ea9c8; }\n        .add-content__actions span:hover i {\n          color: #fff; }\n\n.add-embed__body {\n  margin: 10px 0;\n  padding: 10px;\n  border: 1px solid #5ea9c8;\n  border-radius: 3px; }\n  .add-embed__body form {\n    position: relative; }\n\n.add-embed__input {\n  margin-right: 100px; }\n\n.add-embed__actions {\n  position: absolute;\n  top: 0;\n  right: 0; }\n  .add-embed__actions i {\n    left: 2px;\n    position: relative; }\n\n.block__container .preview--embed,\n.add-embed__body .preview {\n  text-align: center;\n  margin: 10px 0 0; }\n  .block__container .preview--embed--loading,\n  .add-embed__body .preview--loading {\n    min-height: 100px; }\n    .block__container .preview--embed--loading img,\n    .add-embed__body .preview--loading img {\n      opacity: .3; }\n    .block__container .preview--embed--loading:before,\n    .add-embed__body .preview--loading:before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      left: 0;\n      background-image: url(" + escape(__webpack_require__(34)) + ");\n      background-repeat: no-repeat;\n      background-position: center;\n      display: inline-block;\n      width: 100%;\n      height: 40px;\n      line-height: 40px;\n      vertical-align: middle;\n      text-align: center; }\n  .block__container .preview--embed .instagram-media,\n  .add-embed__body .preview .instagram-media {\n    margin: auto !important; }\n  .block__container .preview--embed iframe, .block__container .preview--embed video,\n  .add-embed__body .preview iframe,\n  .add-embed__body .preview video {\n    max-width: 100%; }\n  .block__container .preview--embed img,\n  .add-embed__body .preview img {\n    max-width: 100%;\n    height: auto; }\n    .block__container .preview--embed img:hover,\n    .add-embed__body .preview img:hover {\n      cursor: pointer; }\n  .block__container .preview--embed .embed--link__title,\n  .add-embed__body .preview .embed--link__title {\n    font-size: 1.75em;\n    line-height: 1.25em;\n    margin-bottom: .50em; }\n", ""]);

// exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
var medium_editor_1 = __importDefault(__webpack_require__(173));
var medium_editor_tables_1 = __importDefault(__webpack_require__(756));
var lodash_1 = __importDefault(__webpack_require__(2));
var lodash_2 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
__webpack_require__(757);
var TYPING_CLASS = 'typing';
/**
 * History stack
 *
 * It supports undo/redo operations
 *
 * @param {string} initialValue
 */
function HistoryStack(initialValue) {
    var stack = [];
    var index = -1;
    /**
     * Add a new value to stack and remove all furhter redo values
     * so after manual change there is no way to redo.
     *
     * @param {string} value
     */
    this.add = function (value) {
        index = index + 1;
        stack[index] = value;
        stack.splice(index + 1, stack.length);
    };
    /**
     * Select previous value (undo)
     */
    this.selectPrev = function () {
        index = Math.max(-1, index - 1);
    };
    /**
     * Select next value (redo)
     */
    this.selectNext = function () {
        index = !lodash_1.default.isNil(stack[index + 1]) ? index + 1 : index;
    };
    /**
     * Get current value
     */
    this.get = function () {
        var state = index > -1 ? stack[index] : initialValue;
        return state;
    };
    /**
     * Get current index
     *
     * @return {Number}
     */
    this.getIndex = function () {
        return index;
    };
}
EditorService.$inject = ['spellcheck', '$q', 'renditions', 'editorUtils'];
function EditorService(spellcheck, $q, renditionsService, utils) {
    this.settings = { spellcheck: true };
    this.version = function () { return '2'; };
    this.KEY_CODES = Object.freeze({
        Y: 'Y'.charCodeAt(0),
        Z: 'Z'.charCodeAt(0),
        UP: 38,
        DOWN: 40,
        F3: 114,
    });
    this.ARROWS = Object.freeze({
        33: 1,
        34: 1,
        35: 1,
        36: 1,
        37: 1,
        38: 1,
        39: 1,
        40: 1,
    });
    this.META = Object.freeze({
        16: 1,
        17: 1,
        18: 1,
        20: 1,
        91: 1,
        93: 1,
        224: 1,
    });
    /**
     * Test if given keyboard event should be ignored as it's not changing content.
     *
     * @param {Event} event
     * @return {boolen}
     */
    this.shouldIgnore = function (event) {
        // ignore arrows
        if (self.ARROWS[event.keyCode]) {
            return true;
        }
        // ignore meta keys (ctrl, shift or meta only)
        if (self.META[event.keyCode]) {
            return true;
        }
        // ignore shift + ctrl/meta + something
        if (event.shiftKey && (event.ctrlKey || event.metaKey)) {
            return true;
        }
        return false;
    };
    var ERROR_CLASS = 'sderror';
    var HILITE_CLASS = 'sdhilite';
    var ACTIVE_CLASS = 'sdactive';
    var FINDREPLACE_CLASS = 'sdfindreplace';
    var self = this;
    var scopes = [];
    /**
     * Register given scope - it adds history stack to it and keeps reference
     *
     * @param {Scope} scope
     */
    this.registerScope = function (scope) {
        scopes.push(scope);
        scope.history = new HistoryStack(scope.model.$viewValue || '');
        scope.$on('$destroy', function () {
            var index = scopes.indexOf(scope);
            scopes.splice(index, 1);
        });
    };
    /**
     * Render highlights for given scope based on settings
     *
     * @param {Scope} scope
     * @param {Scope} force force rendering manually - eg. via keyboard
     */
    this.renderScope = function (scope, force, preventStore) {
        if (self.settings.findreplace) {
            renderFindreplace(scope.node);
        }
        else if (self.settings.spellcheck || force) {
            spellcheck.getDictionary(scope.language).then(function (dictionaries) {
                if (dictionaries && dictionaries.length) {
                    renderSpellcheck(scope.node, preventStore);
                }
            });
        }
        else {
            utils.removeHilites(scope.node);
        }
    };
    /**
     * Render highlights in all registered scopes
     *
     * @param {Boolean} force rendering
     */
    this.render = function (force) {
        scopes.forEach(function (scope) {
            self.renderScope(scope, force);
        });
    };
    /**
     * Highlight find&replace matches in given node
     *
     * @param {Node} node
     */
    function renderFindreplace(node) {
        var tokens = utils.getFindReplaceTokens(node, self.settings);
        utils.hilite(node, tokens, FINDREPLACE_CLASS);
    }
    /**
     * Highlight spellcheck errors in given node
     *
     * @param {Node} node
     */
    function renderSpellcheck(node, preventStore) {
        spellcheck.errors(node).then(function (tokens) {
            utils.hilite(node, tokens, ERROR_CLASS, preventStore);
        });
    }
    /**
     * Set next highlighted node active.
     *
     * In case there is no node selected select first one.
     */
    this.selectNext = function () {
        var nodes = document.body.getElementsByClassName(HILITE_CLASS);
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes.item(i);
            if (node.classList.contains(ACTIVE_CLASS)) {
                node.classList.remove(ACTIVE_CLASS);
                var nextNode = nodes.item((i + 1) % nodes.length);
                nextNode.classList.add(ACTIVE_CLASS);
                scrollHighlightedNodeToTop();
                return node;
            }
        }
        if (nodes.length) {
            nodes.item(0).classList.add(ACTIVE_CLASS);
            scrollHighlightedNodeToTop();
        }
    };
    function scrollHighlightedNodeToTop() {
        var containerElem = angular.element('.page-content-container');
        if (containerElem.offset()) {
            // This offset is to make visible what the top section of the document will hide when scrolled
            var baseOffset = angular.element('.subnav__button-stack').prop('clientHeight') +
                angular.element('.authoring-sticky').prop('clientHeight') +
                angular.element('#top-menu').prop('clientHeight');
            var classList = '.' + FINDREPLACE_CLASS + '.' + ACTIVE_CLASS + '.' + HILITE_CLASS;
            var nodeElem = angular.element(classList);
            if (nodeElem.length > 0) {
                // All set, scroll to the highlighted element
                containerElem.scrollTop(nodeElem.offset().top - containerElem.offset().top +
                    containerElem.scrollTop() - baseOffset);
            }
        }
    }
    /**
     * Set previous highlighted node active.
     */
    this.selectPrev = function () {
        var nodes = document.body.getElementsByClassName(HILITE_CLASS);
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes.item(i);
            if (node.classList.contains(ACTIVE_CLASS)) {
                node.classList.remove(ACTIVE_CLASS);
                nodes.item(i === 0 ? nodes.length - 1 : i - 1).classList.add(ACTIVE_CLASS);
                scrollHighlightedNodeToTop();
                return;
            }
        }
    };
    function replaceText(scope, text, className) {
        if (className === void 0) { className = ACTIVE_CLASS; }
        var nodes = scope.node.parentNode.getElementsByClassName(className);
        var nodesLength = nodes.length;
        var replacementOffset = self.replaceNodes(nodes, text, scope);
        if (replacementOffset && className === ACTIVE_CLASS) {
            updateIndexOnReplace(scope.node, replacementOffset);
        }
        return nodesLength;
    }
    // updates the data-index of remaining find-replace candidates subsequent to just replaced active node
    function updateIndexOnReplace(node, replacementOffset) {
        var nodes = node.parentNode.getElementsByClassName(HILITE_CLASS);
        var nextElem, newIndex, activeIndex;
        for (var i = 0; i < nodes.length; i++) {
            var currentNode = nodes.item(i);
            if (currentNode.classList.contains(ACTIVE_CLASS)) {
                currentNode.classList.remove(FINDREPLACE_CLASS);
                activeIndex = i;
            }
        }
        if (!lodash_1.default.isNil(activeIndex)) {
            for (var j = activeIndex + 1; j < nodes.length; j++) {
                nextElem = nodes.item(j);
                newIndex = parseInt(nextElem.getAttribute('data-index'), 10) + replacementOffset;
                nextElem.setAttribute('data-index', newIndex);
            }
        }
    }
    /**
     * Replace active node with given text.
     *
     * @param {string} text
     */
    this.replace = function (text) {
        var _this = this;
        scopes.forEach(function (scope) {
            if (replaceText(scope, text)) {
                _this.commitScope(scope);
            }
        });
    };
    /**
     * Replace all highlighted nodes with given text.
     *
     * @param {string} text
     */
    this.replaceAll = function (text) {
        var _this = this;
        scopes.forEach(function (scope) {
            var nodes = scope.node.parentNode.getElementsByClassName(HILITE_CLASS);
            _this.replaceNodes(nodes, text, scope);
            _this.commitScope(scope);
        });
    };
    /**
     * Replace text at given index with word
     *
     * @param {Object} scope
     * @param {Number} index
     * @param {Number} length
     * @param {String} word
     */
    this.replaceWord = function (scope, index, length, word) {
        var node = scope.node;
        var start = utils.findWordNode(node, index, length);
        var characters = start.node.textContent.split('');
        characters.splice(start.offset, length, word);
        start.node.textContent = characters.join('');
    };
    /**
     * Replace all nodes with text
     *
     * @param {HTMLCollection} nodes
     * @param {string} text
     */
    this.replaceNodes = function (nodes, text, scope) {
        var index, replacementOffset = 0;
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes.item(i);
            var word = node.dataset.word;
            index = parseInt(node.dataset.index, 10) + replacementOffset;
            this.replaceWord(scope, index, word.length, text);
            replacementOffset += text.length - word.length;
        }
        return replacementOffset;
    };
    /**
     * Update settings
     *
     * @param {Object} settings
     */
    this.setSettings = function (settings) {
        self.settings = angular.extend({}, self.settings, settings);
    };
    /**
     * Test if given elem is a spellcheck error node
     *
     * @param {Node} elem
     * @return {boolean}
     */
    this.isErrorNode = function (elem) {
        return elem.classList.contains(ERROR_CLASS);
    };
    /**
     * Commit changes in all scopes
     */
    this.commit = function () {
        scopes.forEach(self.commitScope);
    };
    /**
     * Replace abbreviations.
     * @param {Scope} scope
     */
    function replaceAbbreviations(scope) {
        if (!scope.node.parentNode.classList.contains(TYPING_CLASS)) {
            return $q.when({});
        }
        if (scope.node.innerText !== '') {
            return spellcheck.getAbbreviationsDict().then(function (abbreviations) {
                if (lodash_1.default.keys(abbreviations).length) {
                    var pattern = '\\b('
                        + lodash_1.default.map(lodash_1.default.keys(abbreviations), function (item) { return utils_1.escapeRegExp(item); }).join('|') + ')(\\*)';
                    var found = scope.node.innerText.match(new RegExp(pattern, 'g'));
                    if (found) {
                        // store old settings
                        var oldSettings = angular.extend({}, self.settings);
                        var caretPosition = scope.medium.exportSelection();
                        lodash_1.default.forEach(lodash_1.default.uniq(found), function (val) {
                            var replacementValue = abbreviations[val.replace('*', '')];
                            if (replacementValue) {
                                var diff = {};
                                diff[val] = replacementValue;
                                self.setSettings({ findreplace: { diff: diff, caseSensitive: true } });
                                renderFindreplace(scope.node);
                                var nodesLength = replaceText(scope, replacementValue, FINDREPLACE_CLASS);
                                if (nodesLength > 0) {
                                    var incrementCaretPosition = (replacementValue.length - val.length) * nodesLength;
                                    caretPosition.start += incrementCaretPosition;
                                    caretPosition.end += incrementCaretPosition;
                                }
                            }
                        });
                        scope.medium.importSelection(caretPosition);
                        // apply old settings
                        self.setSettings({ findreplace: oldSettings.findreplace ? oldSettings.findreplace : null });
                    }
                }
            });
        }
        return $q.when({});
    }
    /**
     * Commit changes in given scope to its model
     *
     * @param {Scope} scope
     */
    this.commitScope = function (scope) {
        replaceAbbreviations(scope).then(function () {
            var nodeValue = scope.node.innerHTML;
            if (nodeValue !== scope.model.$viewValue) {
                scope.model.$setViewValue(nodeValue);
                scope.history.add(scope.model.$viewValue);
            }
        });
    };
    /**
     * Returns the cleaned node text
     *
     * @return {string}
     */
    this.getNodeText = function (scope) {
        return scope.node.innerHTML;
    };
    /**
     * Get active node text
     *
     * @return {string}
     */
    this.getActiveText = function () {
        var active;
        scopes.forEach(function (scope) {
            var nodes = scope.node.parentNode.getElementsByClassName(ACTIVE_CLASS);
            active = nodes.length ? nodes.item(0) : active;
        });
        return active ? active.textContent : null;
    };
    /**
     * Return html code to represent an embedded link
     *
     * @param {string} url
     * @param {string} titleg
     * @param {string} description
     * @param {string} illustration
     * @return {string} html
     */
    this.generateLinkTag = function (_a) {
        var url = _a.url, title = _a.title, description = _a.description, illustration = _a.illustration;
        return [
            '<div class="embed--link">',
            angular.isDefined(illustration) ?
                '  <img src="' + illustration + '" class="embed--link__illustration"/>' : '',
            '  <div class="embed--link__title">',
            '      <a href="' + url + '" target="_blank">' + title + '</a>',
            '  </div>',
            angular.isDefined(description) ?
                '  <div class="embed--link__description">' + description + '</div>' : '',
            '</div>',
        ].join('\n');
    };
    this.generateMediaTag = function (data) {
        var mediaTypes = {
            video: function () {
                var videoTag = ['<video controls="controls">'];
                angular.forEach(data.renditions, function (rendition, name) {
                    if (lodash_1.default.some(['.mp4', '.webm', '.ogv'], function (ext) { return lodash_1.default.endsWith(rendition.href, ext); })) {
                        videoTag.push('<source src="' + rendition.href + '">');
                    }
                });
                videoTag.push('</video>');
                return videoTag.join('');
            },
            picture: function () {
                var url = data.url, altText = data.altText;
                var promiseFinished;
                // if this is a SD archive, we use its properties
                if (data._type === 'archive' || data.type === 'picture' || data.type === 'graphic') {
                    // get expected renditions list
                    promiseFinished = renditionsService.get().then(function (renditionsList) {
                        // ]use the first rendtion as default
                        var firstRendition = data.renditions[renditionsList[0].name];
                        if (angular.isDefined(firstRendition)) {
                            url = firstRendition.href;
                        }
                        else {
                            // use "viewImage" rendition as fallback
                            url = data.renditions.viewImage.href;
                        }
                        // if a `alt_text` exists, otherwise we fill w/ `description_text`
                        altText = data.alt_text || data.description_text;
                        return renditionsList;
                    });
                }
                // when previous promise is finished, compose the html
                return $q.when(promiseFinished, function (renditionsList) {
                    var html = ['<img',
                        'src="' + url + '"',
                        'alt="' + lodash_1.default.escape(altText || '') + '"'];
                    // add a `srcset` attribute if renditions are availables
                    // NOTE: if renditions from renditionsService are not available For
                    // this picture, we should maybe use its own renditons
                    if (renditionsList && data.renditions) {
                        var renditionsHtml = [];
                        renditionsList.forEach(function (r) {
                            if (r.width) {
                                var rendition = data.renditions[r.name];
                                if (angular.isDefined(rendition)) {
                                    renditionsHtml.push(rendition.href.replace('http://', '//')
                                        + ' ' + rendition.width + 'w');
                                }
                            }
                        });
                        if (renditionsHtml.length > 0) {
                            html.push('srcset="' + renditionsHtml.join(', ') + '"');
                        }
                    }
                    html.push('/>');
                    return html.join(' ');
                });
            },
        };
        mediaTypes.graphic = mediaTypes.picture;
        return $q.when(mediaTypes[data.type]());
    };
    this.getSelectedText = function () {
        var text = '';
        if (window.getSelection) {
            text = window.getSelection().toString();
        }
        else if (document['selection'] && document['selection'].type !== 'Control') {
            text = document['selection'].createRange().text;
        }
        return text;
    };
}
SdTextEditorBlockEmbedController.$inject = ['$timeout', 'editor', 'renditions', 'config'];
function SdTextEditorBlockEmbedController($timeout, editor, renditions, config) {
    var self = this;
    angular.extend(self, {
        embedCode: undefined,
        caption: undefined,
        title: undefined,
        editable: false,
        toggleEdition: function () {
            self.editable = !self.editable;
        },
        saveEmbedCode: function () {
            // update the block's model
            angular.extend(self.model, {
                body: self.embedCode,
            });
            // on change callback
            self.onBlockChange();
        },
        cancel: function () {
            self.embedCode = self.model.body;
        },
        saveCaption: function (caption, title) {
            // if block is a superdesk image (with association), we update the description_text and headline
            if (self.model.association) {
                self.model.association.description_text = caption;
                self.model.association.headline = title;
            }
            // update the caption in the model
            self.model.caption = caption;
            self.model.title = title;
            // update the caption in the view
            self.caption = caption;
            self.title = title;
            // on change callback
            $timeout(function () {
                self.onBlockChange();
            });
        },
        handlePaste: function (e) {
            e.preventDefault();
            e.stopPropagation();
            var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
            var pastedData = clipboardData.getData('Text');
            $timeout(function () {
                document.execCommand('insertHTML', false, pastedData);
            });
        },
        isEditable: function (picture) {
            return picture._type !== 'externalsource';
        },
        editPicture: function (picture) {
            // only for SD images (with association)
            if (!self.model.association) {
                return false;
            }
            self.model.loading = true;
            renditions.crop(picture).then(function (croppedPicture) {
                // update block
                self.model.association = croppedPicture;
                editor.generateMediaTag(croppedPicture).then(function (img) {
                    self.model.body = img;
                });
                // update caption
                self.saveCaption(self.model.association.description_text, self.model.association.headline);
            })
                .finally(function () {
                self.model.loading = false;
            });
        },
    });
    $timeout(function () {
        angular.extend(self, {
            embedCode: self.model.body,
            caption: self.model.caption,
            // model.association has no value when embed source is not superdesk
            title: lodash_2.get(self, 'model.association.headline', ''),
        });
    });
}
angular.module('superdesk.apps.editor2', [
    'superdesk.apps.editor2.ctrl',
    'superdesk.apps.editor2.embed',
    'superdesk.apps.editor2.content',
    'superdesk.apps.editor2.utils',
    'superdesk.apps.spellcheck',
    'superdesk.apps.authoring',
    'angular-embed',
])
    .service('editor', EditorService)
    .constant('EMBED_PROVIDERS', {
    custom: 'Custom',
    twitter: 'Twitter',
    youtube: 'YouTube',
    vidible: 'Vidible',
})
    .directive('sdAddEmbed', ['$timeout', function ($timeout) {
        return {
            scope: { addToPosition: '=', extended: '=', onClose: '&' },
            require: ['sdAddEmbed', '^sdTextEditor'],
            templateUrl: 'scripts/core/editor2/views/add-embed.html',
            controllerAs: 'vm',
            controller: 'SdAddEmbedController',
            bindToController: true,
            link: function (scope, element, attrs, controllers) {
                var vm = controllers[0];
                angular.extend(vm, {
                    editorCtrl: controllers[1],
                });
                // listen to the escape touch to close the field when pressed
                element.bind('keyup', function (e) {
                    if (e.keyCode === 27) { // escape
                        $timeout(function () {
                            vm.extended = false;
                        });
                    }
                });
            },
        };
    }])
    .directive('sdTextEditorDropZone', ['embedService', 'EMBED_PROVIDERS', 'editor', '$timeout', '$q',
    function (embedService, EMBED_PROVIDERS, editor, $timeout, $q) {
        var dragOverClass = 'medium-editor-dragover';
        return {
            require: '^sdTextEditorBlockText',
            scope: { sdTextEditorDropZone: '@' },
            link: function (scope, element, attrs, ctrl) {
                if (scope.sdTextEditorDropZone === 'false') {
                    return;
                }
                var MEDIA_TYPES = [
                    'application/superdesk.item.picture',
                    'application/superdesk.item.graphic',
                    'application/superdesk.item.video',
                    'application/superdesk.item.audio',
                    'text/html',
                ];
                var getType = function (event) { return MEDIA_TYPES.find(function (_type) { return event.originalEvent.dataTransfer.types.indexOf(_type) >= 0; }); };
                element.on('drop dragdrop', function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    var mediaType = getType(event);
                    var paragraph = angular.element(event.target);
                    var item = event.originalEvent.dataTransfer.getData(mediaType);
                    // we want to ensure that the field is empty before inserting something
                    if (paragraph.text() !== '') {
                        return false;
                    }
                    // remove the UI state
                    paragraph.removeClass(dragOverClass);
                    // select paragraph element in order to register position
                    ctrl.selectElement(paragraph.get(0));
                    // assume this is an item in json format when it comes from superdesk
                    if (mediaType.indexOf('application/superdesk') === 0) {
                        item = angular.fromJson(item);
                        // insert the item
                        ctrl.insertMedia(item);
                    }
                    else if (mediaType === 'text/html' && typeof item === 'string') {
                        $q.when((function () {
                            // if it's a link (<a>...</a>), create an embed by using iframely
                            // if not, create an embed based on the item content
                            var urlMatch = /<a href="(.+?)".+<\/a>/.exec(item);
                            if (urlMatch) {
                                return embedService.get(urlMatch[1]).then(function (data) { return ({
                                    blockType: 'embed',
                                    embedType: data.provider_name || EMBED_PROVIDERS.custom,
                                    body: data.html || editor.generateLinkTag({
                                        url: data.url,
                                        title: data.meta.title,
                                        description: data.meta.description,
                                        illustration: data.thumbnail_url,
                                    }),
                                }); });
                            }
                            return {
                                blockType: 'embed',
                                embedType: EMBED_PROVIDERS.custom,
                                body: item,
                            };
                        })())
                            // split the current block and insert the new block, then commit changes
                            .then(function (block) {
                            ctrl.sdEditorCtrl.splitAndInsert(ctrl, block)
                                .then(function () { return $timeout(ctrl.sdEditorCtrl.commitChanges); });
                        });
                    }
                })
                    .on('dragover', function (event) {
                    var paragraph = angular.element(event.target);
                    var matching = getType(event);
                    if (matching) {
                        // allow to overwite the drop binder (see above)
                        event.preventDefault();
                        event.stopPropagation();
                        // if dragged element is a picture and if the paragraph is empty,
                        // highlight the paragraph
                        if (paragraph.text() === '') {
                            return paragraph.addClass(dragOverClass);
                        }
                    }
                    // otherwise, remove the style
                    paragraph.removeClass(dragOverClass);
                })
                    .on('dragleave', function (event) {
                    var paragraph = angular.element(event.target);
                    paragraph.removeClass(dragOverClass);
                });
            },
        };
    }])
    .directive('sdTextEditor', ['$timeout', function ($timeout) {
        return {
            scope: { type: '=', config: '=', editorformat: '=', language: '=', associations: '=?' },
            require: ['sdTextEditor', 'ngModel'],
            templateUrl: 'scripts/core/editor2/views/editor.html',
            controllerAs: 'vm',
            controller: 'SdTextEditorController',
            bindToController: true,
            link: function (scope, element, attr, controllers) {
                var controller = controllers[0];
                var ngModel = controllers[1];
                function init() {
                    scope.$applyAsync(function () {
                        if (controller.config.multiBlockEdition) {
                            controller.initEditorWithMultipleBlock(ngModel);
                        }
                        else {
                            controller.initEditorWithOneBlock(ngModel);
                        }
                    });
                }
                // init editor based on model
                init();
                // when the model changes from outside, updates the editor
                scope.$watch(function outsideModelChange() {
                    return ngModel.$viewValue;
                }, function () {
                    $timeout(function () {
                        // if controller is ready and the value has changed
                        if (controller.blocks.length > 0 && ngModel.$viewValue !== controller.serializeBlock()) {
                            // if blocks are not loading
                            if (!lodash_1.default.some(controller.blocks, function (block) { return block.loading; })) {
                                init();
                            }
                        }
                    }, 250, false);
                });
            },
        };
    }])
    .directive('sdTextEditorBlockEmbed', function () {
    return ({
        scope: { type: '=', config: '=', language: '=', model: '=sdTextEditorBlockEmbed', onBlockChange: '&' },
        templateUrl: 'scripts/core/editor2/views/block-embed.html',
        controllerAs: 'vm',
        bindToController: true,
        controller: SdTextEditorBlockEmbedController,
    });
})
    .directive('sdTextEditorBlockText', ['editor', 'spellcheck', '$timeout',
    '$q', 'config', '$rootScope',
    function (editor, spellcheck, $timeout, $q, config, $rootScope) {
        var TOP_OFFSET = 134; // header height
        var EDITOR_CONFIG = {
            toolbar: {
                static: true,
                align: 'left',
                sticky: true,
                stickyTopOffset: TOP_OFFSET,
                updateOnEmptySelection: true,
            },
            paste: {
                // Both are disabled because it overwrites the `ctrl`+`v` binding
                // and we need it for the block paste feature
                forcePlainText: false,
                cleanPastedHTML: false,
                // SDESK-714 chrome will replace <p/> by <div/>. This line reverts it (SDESK-714)
                cleanReplacements: [[new RegExp(/<div.*?>/gi), '<p>'], [new RegExp(/<\/div>/gi), '</p>']],
            },
            anchor: {
                placeholderText: utils_1.gettext('Paste or type a full link'),
                linkValidation: true,
            },
            anchorPreview: {
                showWhenToolbarIsVisible: true,
            },
            placeholder: false,
            disableReturn: false,
            spellcheck: false,
            targetBlank: true,
        };
        if (config.editor) {
            angular.extend(EDITOR_CONFIG, config.editor);
        }
        /**
     * Get number of lines for all p nodes before given node withing same parent.
     */
        function getLinesBeforeNode(p) {
            function getLineCount(text) {
                return text.split('\n').length;
            }
            var lines = 0;
            var pos = p;
            while (pos) {
                if (pos.childNodes.length && pos.childNodes[0].nodeType === Node.TEXT_NODE) {
                    lines += getLineCount(pos.childNodes[0].wholeText);
                }
                else if (pos.childNodes.length) {
                    lines += 1; // empty paragraph
                }
                pos = pos.previousSibling;
            }
            return lines;
        }
        /**
     * Get line/column coordinates for given cursor position.
     */
        function getLineColumn() {
            var column, lines, selection = window.getSelection();
            if (selection.anchorNode.nodeType === Node.TEXT_NODE) {
                var text = selection.anchorNode['wholeText'].substring(0, selection.anchorOffset);
                var node = selection.anchorNode;
                column = text.length + 1;
                while (node.nodeName !== 'P') {
                    if (node.previousSibling) {
                        column += node.previousSibling['wholeText'] ?
                            node.previousSibling['wholeText'].length :
                            node.previousSibling.textContent.length;
                        node = node.previousSibling;
                    }
                    else {
                        node = node.parentNode;
                    }
                }
                lines = 0 + getLinesBeforeNode(node);
            }
            else {
                lines = 0 + getLinesBeforeNode(selection.anchorNode);
                column = 1;
            }
            return {
                line: lines,
                column: column,
            };
        }
        function extractBlockContentsFromCaret() {
            function getBlockContainer(node) {
                var pos = node;
                while (pos) {
                    if (pos.nodeType === 1 && /^(DIV)$/i.test(pos.nodeName)) {
                        return pos;
                    }
                    pos = pos.parentNode;
                }
            }
            var sel = window.getSelection();
            if (sel.rangeCount) {
                var selRange = sel.getRangeAt(0);
                var blockEl = getBlockContainer(selRange.endContainer);
                if (blockEl) {
                    var range = selRange.cloneRange();
                    range.selectNodeContents(blockEl);
                    range.setStart(selRange.endContainer, selRange.endOffset);
                    var remaining = range.extractContents();
                    var $blockEl = $(blockEl);
                    // clear if empty of text
                    if ($blockEl.text() === '') {
                        $blockEl.html('');
                    }
                    // remove empty last line
                    $blockEl.find('p:last').each(function () {
                        if ($(this).text() === '') {
                            this.remove();
                        }
                    });
                    return remaining;
                }
            }
        }
        function setEditorFormatOptions(editorConfig, editorFormat, scope) {
            function addButton(format) {
                editorConfig.toolbar.buttons.push({
                    h1: {
                        name: 'h1',
                        action: 'append-h2',
                        aria: utils_1.gettext('header type 1'),
                        tagNames: ['h2'],
                        contentDefault: '<b>' + utils_1.gettext('H1') + '</b>',
                        classList: ['custom-class-h1'],
                        attrs: {
                            'data-custom-attr': 'attr-value-h1',
                        },
                    },
                    h2: {
                        name: 'h2',
                        action: 'append-h3',
                        aria: utils_1.gettext('header type 2'),
                        tagNames: ['h3'],
                        contentDefault: '<b>' + utils_1.gettext('H2') + '</b>',
                        classList: ['custom-class-h2'],
                        attrs: {
                            'data-custom-attr': 'attr-value-h2',
                        },
                    },
                    bold: {
                        name: 'bold',
                        action: 'bold',
                        aria: utils_1.gettext('bold'),
                        tagNames: ['b'],
                        contentDefault: '<b>' + utils_1.gettext('B') + '</b>',
                    },
                    underline: {
                        name: 'underline',
                        action: 'underline',
                        aria: utils_1.gettext('underline'),
                        tagNames: ['u'],
                    },
                    italic: {
                        name: 'italic',
                        action: 'italic',
                        aria: utils_1.gettext('italic'),
                        tagNames: ['i'],
                        contentDefault: '<b>' + utils_1.gettext('I') + '</b>',
                    },
                    quote: {
                        name: 'quote',
                        action: 'append-blockquote',
                        aria: utils_1.gettext('quote'),
                    },
                    removeFormat: {
                        name: 'removeFormat',
                        action: 'removeFormat',
                        aria: utils_1.gettext('remove formatting'),
                    },
                    link: {
                        name: 'anchor',
                        action: 'createLink',
                        aria: utils_1.gettext('link'),
                    },
                }[format] || format);
            }
            lodash_1.default.each(editorFormat, addButton);
        }
        return {
            scope: { type: '=', config: '=', language: '=', sdTextEditorBlockText: '=' },
            require: ['ngModel', '^sdTextEditor', 'sdTextEditorBlockText'],
            templateUrl: 'scripts/core/editor2/views/block-text.html',
            link: function (scope, elem, attrs, controllers) {
                var ngModel = controllers[0];
                var sdTextEditor = controllers[1];
                scope.model = ngModel;
                // give the block model and the editor controller to the text block controller
                var vm = controllers[2];
                angular.extend(vm, {
                    block: scope.sdTextEditorBlockText,
                    sdEditorCtrl: sdTextEditor,
                });
                vm.block = scope.sdTextEditorBlockText;
                var editorElem;
                var updateTimeout;
                var renderTimeout;
                ngModel.$viewChangeListeners.push(changeListener);
                ngModel.$render = function () {
                    editor.registerScope(scope);
                    var editorConfig = angular.merge({}, EDITOR_CONFIG, scope.config || {});
                    if (editorConfig.toolbar) {
                        editorConfig.toolbar.buttons = [];
                        setEditorFormatOptions(editorConfig, sdTextEditor.editorformat, scope);
                        // if config.multiBlockEdition is true, add Embed and Image button to the toolbar
                        if (scope.config.multiBlockEdition) {
                            // this dummy imageDragging stop preventing drag & drop events
                            editorConfig.extensions = { imageDragging: {} };
                            if (editorConfig.toolbar.buttons.indexOf('table') !== -1
                                && angular.isDefined(medium_editor_tables_1.default)) {
                                editorConfig.extensions.table = new medium_editor_tables_1.default({
                                    aria: utils_1.gettext('insert table'),
                                });
                            }
                        }
                    }
                    spellcheck.setLanguage(scope.language);
                    editorElem = elem.find(scope.type === 'preformatted' ? '.editor-type-text'
                        : '.editor-type-html');
                    // events could be attached already, so remove these
                    editorElem.off('mouseup keydown keyup click contextmenu');
                    editorElem.empty();
                    editorElem.html(ngModel.$viewValue || '');
                    scope.node = editorElem[0];
                    scope.model = ngModel;
                    // destroy exiting instance
                    if (scope.medium) {
                        scope.medium.destroy();
                    }
                    // create a new instance of the medium editor binded to this node
                    scope.medium = new medium_editor_1.default(scope.node, editorConfig);
                    // restore the selection if exist
                    if (scope.sdTextEditorBlockText.caretPosition) {
                        scope.node.focus();
                        vm.restoreSelection();
                        // clear the saved position
                        scope.sdTextEditorBlockText.caretPosition = undefined;
                    }
                    // listen for paste event and insert a block if exists in clipboard
                    scope.medium.subscribe('editablePaste', function (e) {
                        var clipboard = vm.sdEditorCtrl.getCutBlock(true);
                        if (clipboard) {
                            e.preventDefault();
                            vm.sdEditorCtrl.splitAndInsert(vm, clipboard);
                        }
                    });
                    // listen caret moves in order to show or hide the (+) button beside the caret
                    function updateAddContentButton(e) {
                        scope.$emit('sdAddContent::updateState', e, editorElem);
                    }
                    editorElem.on('mouseup', updateAddContentButton);
                    ['editableInput', 'focus', 'blur', 'editableClick', 'editableKeyup']
                        .forEach(function (eventName) {
                        scope.medium.subscribe(eventName, updateAddContentButton);
                    });
                    // listen updates by medium editor to update the model
                    scope.medium.subscribe('editableInput', function (e, element) {
                        element.querySelectorAll('span[style]').forEach(function (span) {
                            span.before(span.firstChild);
                            span.remove();
                        });
                        cancelTimeout();
                        updateTimeout = $timeout(vm.updateModel, 200, false);
                    });
                    scope.medium.subscribe('blur', function () {
                        // save latest know caret position
                        vm.savePosition();
                        vm.updateModel();
                    });
                    // update the toolbar, bc it can be displayed at the
                    // wrong place if offset of block has changed
                    scope.medium.subscribe('focus', function () {
                        var toolbar = scope.medium.getExtensionByName('toolbar');
                        if (toolbar) {
                            toolbar.positionStaticToolbar(scope.medium.getFocusedElement());
                        }
                    });
                    // hide toolbar if element is under header
                    scope.medium.subscribe('positionedToolbar', function (e, element) {
                        var toolbar = scope.medium.getExtensionByName('toolbar'), elemPosition = element.getBoundingClientRect();
                        if (toolbar) {
                            toolbar.toolbar.hidden = elemPosition.top + elemPosition.height < TOP_OFFSET;
                        }
                    });
                    function cancelTimeout(event) {
                        $timeout.cancel(updateTimeout);
                        startTyping();
                    }
                    function changeSelectedParagraph(direction) {
                        var selectedParagraph = angular.element(scope.medium.getSelectedParentElement());
                        var paragraphToBeSelected = selectedParagraph[direction > 0 ? 'next' : 'prev']('p');
                        if (paragraphToBeSelected.length > 0) {
                            // select the paragraph
                            scope.medium.selectElement(paragraphToBeSelected.get(0));
                            // scroll to the paragraph
                            var $scrollableParent = $('.page-content-container');
                            var offset = $scrollableParent.scrollTop();
                            offset += paragraphToBeSelected.position().top;
                            offset += paragraphToBeSelected.closest('.block__container').offset().top;
                            offset -= 100; //  margin to prevent the top bar to hide the selected paragraph
                            $scrollableParent.scrollTop(offset);
                        }
                    }
                    function toggleCase() {
                        var selectedText = editor.getSelectedText();
                        if (selectedText.length > 0) {
                            // looks the first character, and inverse the case of the all selection
                            if (selectedText[0].toUpperCase() === selectedText[0]) {
                                selectedText = selectedText.toLowerCase();
                            }
                            else {
                                selectedText = selectedText.toUpperCase();
                            }
                            scope.medium.saveSelection();
                            // replace the selected text
                            scope.medium.cleanPaste(selectedText);
                            scope.medium.restoreSelection();
                        }
                    }
                    var ctrlOperations = {}, shiftOperations = {};
                    ctrlOperations[editor.KEY_CODES.UP] = changeSelectedParagraph.bind(null, -1);
                    ctrlOperations[editor.KEY_CODES.DOWN] = changeSelectedParagraph.bind(null, 1);
                    shiftOperations[editor.KEY_CODES.F3] = toggleCase;
                    editorElem.on('keydown', function (event) {
                        if (editor.shouldIgnore(event)) {
                            return;
                        }
                        // prevent default behaviour for ctrl or shift operations
                        if (event.ctrlKey && ctrlOperations[event.keyCode] ||
                            event.shiftKey && shiftOperations[event.keyCode]) {
                            event.preventDefault();
                        }
                        cancelTimeout(event);
                    });
                    editorElem.on('keyup', function (event) {
                        if (editor.shouldIgnore(event)) {
                            return;
                        }
                        if (event.ctrlKey && ctrlOperations[event.keyCode]) {
                            ctrlOperations[event.keyCode]();
                            return;
                        }
                        if (event.shiftKey && shiftOperations[event.keyCode]) {
                            shiftOperations[event.keyCode]();
                            return;
                        }
                        cancelTimeout(event);
                        updateTimeout = $timeout(vm.updateModel, 200, false);
                    });
                    /**
                 * Test if given point {x, y} is in given bouding rectangle.
                 */
                    function isPointInRect(point, rect) {
                        return rect.left < point.x && rect.right > point.x && rect.top < point.y
                            && rect.bottom > point.y;
                    }
                    editorElem.on('contextmenu', function (event) {
                        var err, pos;
                        var point = { x: event.clientX, y: event.clientY };
                        var errors = elem[0].parentNode.getElementsByClassName('sderror');
                        for (var i = 0, l = errors.length; i < l; i++) {
                            err = errors.item(i);
                            pos = err.getBoundingClientRect();
                            if (isPointInRect(point, pos)) {
                                event.preventDefault();
                                event.stopPropagation();
                                renderContextMenu(err);
                                return false;
                            }
                        }
                    });
                    function renderContextMenu(node) {
                        // close previous menu (if any)
                        scope.$apply(function () {
                            scope.suggestions = null;
                            scope.openDropdown = false;
                        });
                        // set data needed for replacing
                        scope.replaceWord = node.dataset.word;
                        scope.replaceIndex = parseInt(node.dataset.index, 10);
                        scope.sentenceWord = node.dataset.sentenceWord === 'true';
                        spellcheck.suggest(node.textContent).then(function (suggestions) {
                            if (scope.sentenceWord) {
                                suggestions.push({
                                    key: scope.replaceWord[0].toUpperCase() + scope.replaceWord.slice(1),
                                    value: scope.replaceWord[0].toUpperCase() + scope.replaceWord.slice(1),
                                });
                                scope.suggestions = suggestions.filter(function (suggestion) {
                                    return suggestion.key !== scope.replaceWord;
                                });
                            }
                            else {
                                scope.suggestions = suggestions;
                            }
                            scope.replaceTarget = node;
                            scope.$applyAsync(function () {
                                var menu = elem[0].getElementsByClassName('dropdown__menu')[0];
                                menu.style.left = node.offsetLeft + 'px';
                                menu.style.top = node.offsetTop + node.offsetHeight + 'px';
                                menu.style.position = 'absolute';
                                scope.openDropdown = true;
                            });
                        });
                        return false;
                    }
                    if (scope.type === 'preformatted') {
                        editorElem.on('keydown keyup click', function () {
                            scope.$apply(function () {
                                angular.extend(scope.cursor, getLineColumn());
                            });
                        });
                    }
                    scope.$on('$destroy', function () {
                        scope.medium.destroy();
                        editorElem.off();
                    });
                    scope.cursor = {};
                    render(null, null, true);
                };
                scope.removeBlock = function () {
                    sdTextEditor.removeBlock(scope.sdTextEditorBlockText);
                };
                scope.$on('spellcheck:run', render);
                scope.$on('key:ctrl:shift:s', render);
                function render($event, event, preventStore) {
                    if (!$rootScope.config.features || !$rootScope.config.features.useTansaProofing) {
                        stopTyping();
                        editor.renderScope(scope, $event, preventStore);
                        if (event) {
                            event.preventDefault();
                        }
                    }
                }
                scope.replace = function (text) {
                    editor.replaceWord(scope, scope.replaceIndex, scope.replaceWord.length, text);
                    editor.commitScope(scope);
                };
                scope.addWordToDictionary = function () {
                    var word = scope.replaceTarget.textContent;
                    spellcheck.addWordToUserDictionary(word);
                    editor.render();
                };
                scope.ignoreWord = function () {
                    var word = scope.replaceTarget.textContent;
                    spellcheck.ignoreWord(word);
                    editor.render();
                };
                function changeListener() {
                    $timeout.cancel(renderTimeout);
                    renderTimeout = $timeout(render, 0, false);
                }
                function startTyping() {
                    scope.node.parentNode.classList.add(TYPING_CLASS);
                }
                function stopTyping() {
                    scope.node.parentNode.classList.remove(TYPING_CLASS);
                }
            },
            controller: ['$scope', 'api', 'superdesk', 'renditions',
                function (scope, api, superdesk, renditions) {
                    var self = this;
                    angular.extend(self, {
                        block: undefined,
                        sdEditorCtrl: undefined,
                        selectElement: function (element) {
                            scope.medium.selectElement(element);
                            // save position
                            self.savePosition();
                        },
                        restoreSelection: function () {
                            scope.medium.importSelection(self.block.caretPosition);
                            // put the caret at end of the selection
                            scope.medium.options.ownerDocument.getSelection().collapseToEnd();
                        },
                        savePosition: function () {
                            self.block.caretPosition = scope.medium.exportSelection();
                        },
                        extractEndOfBlock: function () {
                            // it can happen that user lost the focus on the block when this fct in called
                            // so we restore the latest known position
                            self.restoreSelection();
                            // extract the text after the cursor
                            var remainingElementsContainer = document.createElement('div');
                            remainingElementsContainer.appendChild(extractBlockContentsFromCaret().cloneNode(true));
                            // remove the first line if empty
                            $(remainingElementsContainer).find('p:first')
                                .each(function () {
                                if ($(this).text() === '') {
                                    this.remove();
                                }
                            });
                            return remainingElementsContainer;
                        },
                        updateModel: function () {
                            editor.commitScope(scope);
                        },
                        insertMedia: function (media) {
                            var mediaType = {
                                picture: 'Image',
                                graphic: 'Image',
                                video: 'Video',
                            };
                            var imageBlock = {
                                blockType: 'embed',
                                embedType: mediaType[media.type],
                                caption: media.description_text,
                                loading: true,
                                association: media,
                            };
                            self.sdEditorCtrl.splitAndInsert(self, imageBlock).then(function (block) {
                                // load the media and update the block
                                $q.when((function () {
                                    if (config.features && 'editFeaturedImage' in config.features &&
                                        !config.features.editFeaturedImage && media._type === 'externalsource') {
                                        return media;
                                    }
                                    return renditions.ingest(media);
                                })()).then(function (mediaObject) {
                                    editor.generateMediaTag(mediaObject).then(function (imgTag) {
                                        angular.extend(block, {
                                            body: imgTag,
                                            association: mediaObject,
                                            loading: false,
                                        });
                                        $timeout(self.sdEditorCtrl.commitChanges);
                                    });
                                });
                            });
                        },
                    });
                }],
        };
    }])
    .run(['embedService', 'iframelyService', function (embedService, iframelyService) {
        var playBuzzPattern = 'https?:\/\/(?:www)\.playbuzz\.com(.*)$';
        var playBuzzlLoader = '//snappa.embed.pressassociation.io/playbuzz.js';
        var playBuzzEmbed = [
            '<script type="text/javascript" src="$_LOADER"></script>',
            '<div class="pb_feed" data-game="$_URL" data-recommend="false" ',
            'data-game-info="false" data-comments="false" data-shares="false" ></div>',
        ].join('');
        embedService.registerHandler({
            name: 'PlayBuzz',
            patterns: [playBuzzPattern],
            embed: function (url) {
                return iframelyService.embed(url)
                    .then(function (result) {
                    result.html = playBuzzEmbed
                        .replace('$_LOADER', playBuzzlLoader)
                        .replace('$_URL', url.match(playBuzzPattern)[1]);
                    return result;
                });
            },
        });
        var samdeskEmbed = [
            '<script>(function(d, s, id) { var fjs = d.getElementsByTagName(s)[0];',
            'var js = d.createElement(s); js.id = id; js.src = \'https://embed.samdesk.io/js/2/embed.js\';',
            'fjs.parentNode.insertBefore(js, fjs); }(document, \'script\', \'sam-embed-js\'));</script>',
            '<div class="sam-embed" data-href="embed.samdesk.io/embed/$_ID"></div>',
        ].join('');
        var samDeskPattern = 'https?://embed.samdesk.io/(?:embed|preview)/(.+)';
        embedService.registerHandler({
            name: 'SAMDesk',
            patterns: [samDeskPattern],
            embed: function (url) {
                var embed = samdeskEmbed.replace('$_ID', url.match(samDeskPattern)[1]);
                return {
                    provider_name: 'SAMDesk',
                    html: embed,
                    url: url,
                    type: 'rich',
                };
            },
        });
    }])
    .config(['embedServiceProvider', 'iframelyServiceProvider', '$injector',
    function (embedServiceProvider, iframelyServiceProvider, $injector) {
        var config = $injector.get('config');
        // iframe.ly private key
        iframelyServiceProvider.setKey(config.iframely.key);
        // don't use noembed as first choice
        embedServiceProvider.setConfig('useOnlyFallback', true);
        // iframely respect the original embed for more services than 'embedly'
        embedServiceProvider.setConfig('fallbackService', 'iframely');
    }]);
function EditorUtilsFactory() {
    var CLONE_CLASS = 'clone';
    var HILITE_CLASS = 'sdhilite';
    var ACTIVE_CLASS = 'sdactive';
    var FINDREPLACE_CLASS = 'sdfindreplace';
    /**
     * Function for sorting array of strings from longest to shortest
     *
     * @param {string} a
     * @param {string} b
     * @return {number}
     */
    function reverseLengthSort(a, b) {
        return b.length - a.length;
    }
    /**
     * Find text node within given node for given character offset
     *
     * This will find text node within given node that contains character on given offset
     *
     * @param {Node} node
     * @param {numeric} offset
     * @return {Object} {node: {Node}, offset: {numeric}}
     */
    function findOffsetNode(node, offset) {
        var tree = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
        var currentLength;
        var currentOffset = 0;
        var ZERO_WIDTH_SPACE = String.fromCharCode(65279);
        while (tree.nextNode()) {
            tree.currentNode.textContent = tree.currentNode.textContent.replace(ZERO_WIDTH_SPACE, '');
            currentLength = tree.currentNode.textContent.length;
            if (currentOffset + currentLength >= offset) {
                return { node: tree.currentNode, offset: offset - currentOffset };
            }
            currentOffset += currentLength;
        }
    }
    return {
        /**
         * Find all matches for current find&replace needle in given node
         *
         * Each match is {word: {string}, offset: {number}} in given node,
         * we can't return nodes here because those will change when we start
         * highlighting and offsets wouldn't match
         *
         * @param {Node} node
         * @param {Object} settings
         * @return {Array} list of matches
         */
        getFindReplaceTokens: function (node, settings) {
            var tokens = [];
            var diff = settings.findreplace.diff || {};
            var pattern = Object.keys(diff)
                .sort(reverseLengthSort)
                .map(utils_1.escapeRegExp)
                .join('|');
            if (!pattern) {
                return tokens;
            }
            var flags = settings.findreplace.caseSensitive ? 'm' : 'im';
            var re = new RegExp(pattern, flags);
            var nodeOffset = 0;
            var text, match, offset;
            var isActive, elementClone, elementFindReplace;
            elementClone = node.parentNode.getElementsByClassName(CLONE_CLASS);
            if (elementClone && elementClone.length) {
                elementFindReplace = elementClone.item(0).getElementsByClassName(FINDREPLACE_CLASS);
            }
            function isTokenActive(index) {
                var active, matched;
                if (elementFindReplace && elementFindReplace.length) {
                    matched = lodash_1.default.filter(elementFindReplace, function (elem) { return parseInt(elem.getAttribute('data-index'), 10) === index; });
                    active = matched && matched.length ? matched[0].classList.contains(ACTIVE_CLASS) : false;
                }
                return active;
            }
            var tree = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
            while (tree.nextNode()) {
                text = tree.currentNode.textContent;
                while (!lodash_1.default.isNil(match = text.match(re))) {
                    isActive = isTokenActive(nodeOffset + match.index);
                    tokens.push({
                        word: match[0],
                        index: nodeOffset + match.index,
                        title: diff[match[0]] || '',
                        active: isActive,
                    });
                    offset = match.index + match[0].length;
                    text = text.substr(offset);
                    nodeOffset += offset;
                }
                nodeOffset += text.length;
            }
            return tokens;
        },
        /**
         * Hilite all tokens within node using span with given className
         *
         * This first stores caret position, updates markup, and then restores the caret.
         *
         * @param {Node} node
         * @param {Array} tokens
         * @param {string} className
         * @param {Boolean} preventStore
         */
        hilite: function (node, tokens, className, preventStore) {
            var _this = this;
            // remove old hilites
            this.removeHilites(node);
            // create a clone
            var hiliteNode = node.cloneNode(true);
            hiliteNode.classList.add(CLONE_CLASS);
            // generate hilite markup in clone
            tokens.forEach(function (token) {
                _this.hiliteToken(hiliteNode, token, className);
            });
            // render clone
            node.parentNode.appendChild(hiliteNode);
        },
        /**
         * Highlight single `token` via putting it into a span with given class
         *
         * @param {Node} node
         * @param {Object} token
         * @param {string} className
         */
        hiliteToken: function (node, token, className) {
            var start = this.findWordNode(node, token.index, token.word.length);
            var replace = start.node.splitText(start.offset);
            var span = document.createElement('span');
            span.classList.add(className);
            span.classList.add(HILITE_CLASS);
            if (token.active) {
                span.classList.add(ACTIVE_CLASS);
            }
            replace.splitText(token.word.length);
            span.textContent = replace.textContent;
            span.dataset.word = token.word;
            span.dataset.index = token.index;
            if (token.sentenceWord) {
                span.dataset.sentenceWord = 'true';
                span.classList.add('sdCapitalize');
            }
            replace.parentNode.replaceChild(span, replace);
        },
        /**
         * Remove hilites node from nodes parent
         *
         * @param {Node} node
         */
        removeHilites: function (node) {
            var parentNode = node.parentNode;
            var clones = parentNode.getElementsByClassName(CLONE_CLASS);
            if (clones.length) {
                parentNode.removeChild(clones.item(0));
            }
        },
        /**
         * Find text node within given node where word is located
         *
         * It will find text type node where the whole word is located
         *
         * @param {Node} node
         * @param {Number} index
         * @param {Number} length
         * @return {Object} {node: {Node}, offset: {Number}}
         */
        findWordNode: function (node, index, length) {
            var start = findOffsetNode(node, index);
            var end = findOffsetNode(node, index + length);
            // correction for linebreaks - first node on a new line is set to
            // linebreak text node which is not even visible in dom, maybe dom bug?
            if (start.node !== end.node) {
                start.node = end.node;
                start.offset = 0;
            }
            return start;
        },
    };
}
angular.module('superdesk.apps.editor2.utils', [])
    .factory('editorUtils', EditorUtilsFactory);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, MediumEditor, process) {var __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict';
  var isElectron = typeof module === 'object' && process && process.versions && process.versions.electron;
  if (!isElectron && typeof module === 'object') {
    module.exports = factory;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return factory;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    root.MediumEditorTable = factory;
  }
}(this, function () {

  'use strict';

function extend(dest, source) {
    var prop;
    dest = dest || {};
    for (prop in source) {
        if (source.hasOwnProperty(prop) && !dest.hasOwnProperty(prop)) {
            dest[prop] = source[prop];
        }
    }
    return dest;
}

function getSelectionText(doc) {
    if (doc.getSelection) {
        return doc.getSelection().toString();
    }
    if (doc.selection && doc.selection.type !== 'Control') {
        return doc.selection.createRange().text;
    }
    return '';
}

function getSelectionStart(doc) {
    var node = doc.getSelection().anchorNode,
        startNode = (node && node.nodeType === 3 ? node.parentNode : node);

    return startNode;
}

function placeCaretAtNode(doc, node, before) {
    if (doc.getSelection !== undefined && node) {
        var range = doc.createRange(),
            selection = doc.getSelection();

        if (before) {
            range.setStartBefore(node);
        } else {
            range.setStartAfter(node);
        }

        range.collapse(true);

        selection.removeAllRanges();
        selection.addRange(range);
    }
}

function isInsideElementOfTag(node, tag) {
    if (!node) {
        return false;
    }

    var parentNode = node.parentNode,
        tagName = parentNode.tagName.toLowerCase();

    while (tagName !== 'body') {
        if (tagName === tag) {
            return true;
        }
        parentNode = parentNode.parentNode;

        if (parentNode && parentNode.tagName) {
            tagName = parentNode.tagName.toLowerCase();
        } else {
            return false;
        }
    }

    return false;
}

function getParentOf(el, tagTarget) {
    var tagName = el && el.tagName ? el.tagName.toLowerCase() : false;

    if (!tagName) {
        return false;
    }
    while (tagName && tagName !== 'body') {
        if (tagName === tagTarget) {
            return el;
        }
        el = el.parentNode;
        tagName = el && el.tagName ? el.tagName.toLowerCase() : false;
    }
}

function Grid(el, callback, rows, columns) {
    return this.init(el, callback, rows, columns);
}

Grid.prototype = {
    init: function (el, callback, rows, columns) {
        this._root = el;
        this._callback = callback;
        this.rows = rows;
        this.columns = columns;
        return this._render();
    },

    setCurrentCell: function (cell) {
        this._currentCell = cell;
    },

    markCells: function () {
        [].forEach.call(this._cellsElements, function (el) {
            var cell = {
                    column: parseInt(el.dataset.column, 10),
                    row: parseInt(el.dataset.row, 10)
                },
                active = this._currentCell &&
                         cell.row <= this._currentCell.row &&
                         cell.column <= this._currentCell.column;

            if (active === true) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        }.bind(this));
    },

    _generateCells: function () {
        var row = -1;

        this._cells = [];

        for (var i = 0; i < this.rows * this.columns; i++) {
            var column = i % this.columns;

            if (column === 0) {
                row++;
            }

            this._cells.push({
                column: column,
                row: row,
                active: false
            });
        }
    },

    _html: function () {
        var width = this.columns * COLUMN_WIDTH + BORDER_WIDTH * 2,
            height = this.rows * COLUMN_WIDTH + BORDER_WIDTH * 2,
            html = '<div class="medium-editor-table-builder-grid clearfix" style="width:' + width + 'px;height:' + height + 'px;">';
        html += this._cellsHTML();
        html += '</div>';
        return html;
    },

    _cellsHTML: function () {
        var html = '';
        this._generateCells();
        this._cells.map(function (cell) {
            html += '<a href="#" class="medium-editor-table-builder-cell' +
                    (cell.active === true ? ' active' : '') +
                    '" ' + 'data-row="' + cell.row +
                    '" data-column="' + cell.column + '">';
            html += '</a>';
        });
        return html;
    },

    _render: function () {
        this._root.innerHTML = this._html();
        this._cellsElements = this._root.querySelectorAll('a');
        this._bindEvents();
    },

    _bindEvents: function () {
        [].forEach.call(this._cellsElements, function (el) {
            this._onMouseEnter(el);
            this._onClick(el);
        }.bind(this));
    },

    _onMouseEnter: function (el) {
        var self = this,
            timer;

        el.addEventListener('mouseenter', function () {
            clearTimeout(timer);

            var dataset = this.dataset;

            timer = setTimeout(function () {
                self._currentCell = {
                    column: parseInt(dataset.column, 10),
                    row: parseInt(dataset.row, 10)
                };
                self.markCells();
            }, 50);
        });
    },

    _onClick: function (el) {
        var self = this;
        el.addEventListener('click', function (e) {
            e.preventDefault();
            self._callback(this.dataset.row, this.dataset.column);
        });
    }
};

function Builder(options) {
    return this.init(options);
}

Builder.prototype = {
    init: function (options) {
        this.options = options;
        this._doc = options.ownerDocument || document;
        this._root = this._doc.createElement('div');
        this._root.className = 'medium-editor-table-builder';
        this.grid = new Grid(
          this._root,
          this.options.onClick,
          this.options.rows,
          this.options.columns
        );

        this._range = null;
        this._toolbar = this._doc.createElement('div');
        this._toolbar.className = 'medium-editor-table-builder-toolbar';

        var spanRow = this._doc.createElement('span');
        spanRow.innerHTML = 'Row:';
        this._toolbar.appendChild(spanRow);
        var addRowBefore = this._doc.createElement('button');
        addRowBefore.title = 'Add row before';
        addRowBefore.innerHTML = '<i class="fa fa-long-arrow-up"></i>';
        addRowBefore.onclick = this.addRow.bind(this, true);
        this._toolbar.appendChild(addRowBefore);

        var addRowAfter = this._doc.createElement('button');
        addRowAfter.title = 'Add row after';
        addRowAfter.innerHTML = '<i class="fa fa-long-arrow-down"></i>';
        addRowAfter.onclick = this.addRow.bind(this, false);
        this._toolbar.appendChild(addRowAfter);

        var remRow = this._doc.createElement('button');
        remRow.title = 'Remove row';
        remRow.innerHTML = '<i class="fa fa-close"></i>';
        remRow.onclick = this.removeRow.bind(this);
        this._toolbar.appendChild(remRow);

        var spanCol = this._doc.createElement('span');
        spanCol.innerHTML = 'Column:';
        this._toolbar.appendChild(spanCol);
        var addColumnBefore = this._doc.createElement('button');
        addColumnBefore.title = 'Add column before';
        addColumnBefore.innerHTML = '<i class="fa fa-long-arrow-left"></i>';
        addColumnBefore.onclick = this.addColumn.bind(this, true);
        this._toolbar.appendChild(addColumnBefore);

        var addColumnAfter = this._doc.createElement('button');
        addColumnAfter.title = 'Add column after';
        addColumnAfter.innerHTML = '<i class="fa fa-long-arrow-right"></i>';
        addColumnAfter.onclick = this.addColumn.bind(this, false);
        this._toolbar.appendChild(addColumnAfter);

        var remColumn = this._doc.createElement('button');
        remColumn.title = 'Remove column';
        remColumn.innerHTML = '<i class="fa fa-close"></i>';
        remColumn.onclick = this.removeColumn.bind(this);
        this._toolbar.appendChild(remColumn);

        var remTable = this._doc.createElement('button');
        remTable.title = 'Remove table';
        remTable.innerHTML = '<i class="fa fa-trash-o"></i>';
        remTable.onclick = this.removeTable.bind(this);
        this._toolbar.appendChild(remTable);

        var grid = this._root.childNodes[0];
        this._root.insertBefore(this._toolbar, grid);
    },

    getElement: function () {
        return this._root;
    },

    hide: function () {
        this._root.style.display = '';
        this.grid.setCurrentCell({ column: -1, row: -1 });
        this.grid.markCells();
    },

    show: function (left) {
        this._root.style.display = 'block';
        this._root.style.left = left + 'px';
    },

    setEditor: function (range, restrictNestedTable) {
        this._range = range;
        this._toolbar.style.display = 'block';
        if (restrictNestedTable) {
            var elements = this._doc.getElementsByClassName('medium-editor-table-builder-grid');
            elements[0].style.display = 'none';
        }
    },

    setBuilder: function () {
        this._range = null;
        this._toolbar.style.display = 'none';
        var elements = this._doc.getElementsByClassName('medium-editor-table-builder-grid');
        elements[0].style.display = 'block';
        for (var i = 0; i < elements.length; i++) {
            elements[i].style.height = (COLUMN_WIDTH * this.rows + BORDER_WIDTH * 2) + 'px';
            elements[i].style.width = (COLUMN_WIDTH * this.columns + BORDER_WIDTH * 2) + 'px';
        }
    },

    getParentType: function (el, targetNode) {
        var nodeName = el && el.nodeName ? el.nodeName.toLowerCase() : false;
        if (!nodeName) {
            return false;
        }
        while (nodeName && nodeName !== 'body') {
            if (nodeName === targetNode) {
                return el;
            }
            el = el.parentNode;
            nodeName = el && el.nodeName ? el.nodeName.toLowerCase() : false;
        }
    },

    addRow: function (before, e) {
        e.preventDefault();
        e.stopPropagation();
        var tbody = this.getParentType(this._range, 'tbody'),
            selectedTR = this.getParentType(this._range, 'tr'),
            tr = this._doc.createElement('tr'),
            td;
        for (var i = 0; i < selectedTR.childNodes.length; i++) {
            td = this._doc.createElement('td');
            td.appendChild(this._doc.createElement('br'));
            tr.appendChild(td);
        }
        if (before !== true && selectedTR.nextSibling) {
            tbody.insertBefore(tr, selectedTR.nextSibling);
        } else if (before === true) {
            tbody.insertBefore(tr, selectedTR);
        } else {
            tbody.appendChild(tr);
        }
        this.options.onClick(0, 0);
    },

    removeRow: function (e) {
        e.preventDefault();
        e.stopPropagation();
        var tbody = this.getParentType(this._range, 'tbody'),
            selectedTR = this.getParentType(this._range, 'tr');
        tbody.removeChild(selectedTR);
        this.options.onClick(0, 0);
    },

    addColumn: function (before, e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedTR = this.getParentType(this._range, 'tr'),
            selectedTD = this.getParentType(this._range, 'td'),
            cell = Array.prototype.indexOf.call(selectedTR.childNodes, selectedTD),
            tbody = this.getParentType(this._range, 'tbody'),
            td;

        for (var i = 0; i < tbody.childNodes.length; i++) {
            td = this._doc.createElement('td');
            td.appendChild(this._doc.createElement('br'));
            if (before === true) {
                tbody.childNodes[i].insertBefore(td, tbody.childNodes[i].childNodes[cell]);
            } else if (tbody.childNodes[i].childNodes[cell].nextSibling) {
                tbody.childNodes[i].insertBefore(td, tbody.childNodes[i].childNodes[cell].nextSibling);
            } else {
                tbody.childNodes[i].appendChild(td);
            }
        }

        this.options.onClick(0, 0);
    },

    removeColumn: function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedTR = this.getParentType(this._range, 'tr'),
            selectedTD = this.getParentType(this._range, 'td'),
            cell = Array.prototype.indexOf.call(selectedTR.childNodes, selectedTD),
            tbody = this.getParentType(this._range, 'tbody'),
            rows = tbody.childNodes.length;

        for (var i = 0; i < rows; i++) {
            tbody.childNodes[i].removeChild(tbody.childNodes[i].childNodes[cell]);
        }
        this.options.onClick(0, 0);
    },

    removeTable: function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selectedTR = this.getParentType(this._range, 'tr'),
            selectedTD = this.getParentType(this._range, 'td'),
            cell = Array.prototype.indexOf.call(selectedTR.childNodes, selectedTD),
            table = this.getParentType(this._range, 'table');

        table.parentNode.removeChild(table);
        this.options.onClick(0, 0);
    }
};

function Table(editor) {
    return this.init(editor);
}

var TAB_KEY_CODE = 9;

Table.prototype = {
    init: function (editor) {
        this._editor = editor;
        this._doc = this._editor.options.ownerDocument;
        this._bindTabBehavior();
    },

    insert: function (rows, cols) {
        var html = this._html(rows, cols);

        this._editor.pasteHTML(
            '<table class="medium-editor-table" id="medium-editor-table"' +
            ' width="100%">' +
            '<tbody id="medium-editor-table-tbody">' +
            html +
            '</tbody>' +
            '</table>', {
                cleanAttrs: [],
                cleanTags: []
            }
        );

        var table = this._doc.getElementById('medium-editor-table'),
            tbody = this._doc.getElementById('medium-editor-table-tbody');
        if (0 === $(table).find('#medium-editor-table-tbody').length) {
            //Edge case, where tbody gets appended outside table tag
            $(tbody).detach().appendTo(table);
        }
        tbody.removeAttribute('id');
        table.removeAttribute('id');
        placeCaretAtNode(this._doc, table.querySelector('td'), true);

        this._editor.checkSelection();
    },

    _html: function (rows, cols) {
        var html = '',
            x, y,
            text = getSelectionText(this._doc);

        for (x = 0; x <= rows; x++) {
            html += '<tr>';
            for (y = 0; y <= cols; y++) {
                html += '<td>' + (x === 0 && y === 0 ? text : '<br />') + '</td>';
            }
            html += '</tr>';
        }
        return html;
    },

    _bindTabBehavior: function () {
        var self = this;
        [].forEach.call(this._editor.elements, function (el) {
            el.addEventListener('keydown', function (e) {
                self._onKeyDown(e);
            });
        });
    },

    _onKeyDown: function (e) {
        var el = getSelectionStart(this._doc),
            table;

        if (e.which === TAB_KEY_CODE && isInsideElementOfTag(el, 'table')) {
            e.preventDefault();
            e.stopPropagation();
            table = this._getTableElements(el);
            if (e.shiftKey) {
                this._tabBackwards(el.previousSibling, table.row);
            } else {
                if (this._isLastCell(el, table.row, table.root)) {
                    this._insertRow(getParentOf(el, 'tbody'), table.row.cells.length);
                }
                placeCaretAtNode(this._doc, el);
            }
        }
    },

    _getTableElements: function (el) {
        return {
            cell: getParentOf(el, 'td'),
            row: getParentOf(el, 'tr'),
            root: getParentOf(el, 'table')
        };
    },

    _tabBackwards: function (el, row) {
        el = el || this._getPreviousRowLastCell(row);
        placeCaretAtNode(this._doc, el, true);
    },

    _insertRow: function (tbody, cols) {
        var tr = document.createElement('tr'),
            html = '',
            i;

        for (i = 0; i < cols; i += 1) {
            html += '<td><br /></td>';
        }
        tr.innerHTML = html;
        tbody.appendChild(tr);
    },

    _isLastCell: function (el, row, table) {
        return (
          (row.cells.length - 1) === el.cellIndex &&
          (table.rows.length - 1) === row.rowIndex
        );
    },

    _getPreviousRowLastCell: function (row) {
        row = row.previousSibling;
        if (row) {
            return row.cells[row.cells.length - 1];
        }
    }
};

var COLUMN_WIDTH = 16,
    BORDER_WIDTH = 1,
    MediumEditorTable;

MediumEditorTable = MediumEditor.extensions.form.extend({
    name: 'table',

    aria: 'create table',
    action: 'table',
    contentDefault: 'TBL',
    contentFA: '<i class="fa fa-table"></i>',

    handleClick: function (event) {
        event.preventDefault();
        event.stopPropagation();

        this[this.isActive() === true ? 'hide' : 'show']();
    },

    hide: function () {
        this.setInactive();
        this.builder.hide();
    },

    show: function () {
        this.setActive();

        var range = MediumEditor.selection.getSelectionRange(this.document);
        if (range.startContainer.nodeName.toLowerCase() === 'td' ||
          range.endContainer.nodeName.toLowerCase() === 'td' ||
          MediumEditor.util.getClosestTag(MediumEditor.selection.getSelectedParentElement(range), 'td')) {
            this.builder.setEditor(MediumEditor.selection.getSelectedParentElement(range), this.restrictNestedTable);
        } else {
            this.builder.setBuilder();
        }
        this.builder.show(this.button.offsetLeft);
    },

    getForm: function () {
        if (!this.builder) {
            this.builder = new Builder({
                onClick: function (rows, columns) {
                    if (rows > 0 || columns > 0) {
                        this.table.insert(rows, columns);
                    }
                    this.hide();
                }.bind(this),
                ownerDocument: this.document,
                rows: this.rows || 10,
                columns: this.columns || 10
            });

            this.table = new Table(this.base);
        }

        return this.builder.getElement();
    }
});

  return MediumEditorTable;
}()));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(173), __webpack_require__(174)))

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This module extends (and overrides) MediumEditor's anchor button to disallow
 * malformed URLs when the 'linkValidation: true' option is set.
 *
 * It additionally introduces the possibility to set the validation pattern
 * using the 'pattern' option when configuring the editor.
 */
var medium_editor_1 = __importDefault(__webpack_require__(173));
var CustomAnchorButton = /** @class */ (function (_super) {
    __extends(CustomAnchorButton, _super);
    function CustomAnchorButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomAnchorButton.prototype.createForm = function () {
        var form = _super.prototype.createForm.call(this);
        if (!this.linkValidation) {
            return form;
        }
        var input = form.getElementsByTagName('input')[0];
        input.setAttribute('type', 'url');
        input.setAttribute('required', '');
        if (this.pattern) {
            input.setAttribute('pattern', this.pattern);
        }
        return form;
    };
    CustomAnchorButton.prototype.doFormSave = function () {
        var input = this.getForm().getElementsByTagName('input')[0];
        // prevent double encoding; medium editor don't detect if the url is already encoded
        input.value = decodeURIComponent(input.value);
        var isValid = input.checkValidity();
        if (isValid) {
            _super.prototype.doFormSave.call(this);
        }
    };
    return CustomAnchorButton;
}(medium_editor_1.default.extensions.anchor));
// override default anchor
medium_editor_1.default.extensions.anchor = CustomAnchorButton;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {angular.module('superdesk.apps.editor2.ctrl', []).controller('SdTextEditorController', SdTextEditorController);
SdTextEditorController.$inject = ['lodash', 'EMBED_PROVIDERS', '$timeout', 'editor', 'config', '$q'];
function SdTextEditorController(_, EMBED_PROVIDERS, $timeout, editor, config, $q) {
    var self = this;
    function Block(attrs) {
        if (attrs === void 0) { attrs = {}; }
        // eslint-disable-next-line consistent-this
        var BlockFnThis = this;
        angular.extend(BlockFnThis, _.defaults({
            body: attrs.body,
            loading: attrs.loading,
            caption: attrs.caption,
            blockType: attrs.blockType,
            embedType: attrs.embedType,
            association: attrs.association,
            lowerAddEmbedIsExtended: undefined,
            showAndFocusLowerAddAnEmbedBox: function () {
                BlockFnThis.lowerAddEmbedIsExtended = true;
            },
        }, {
            body: '<p><br></p>',
            loading: false,
            blockType: 'text',
        }));
    }
    /**
     * For the given blocks, merge text blocks when there are following each other
     * and add empty text block arround embeds if needed
     */
    function prepareBlocks(blocks) {
        var newBlocks = [];
        blocks.forEach(function (block, i) {
            // if not the first block and there is a text block following another one
            if (i > 0 && block.blockType === 'text' && blocks[i - 1].blockType === 'text') {
                // we merge the content with the previous block
                newBlocks[newBlocks.length - 1].body += block.body;
            }
            else {
                // otherwise we add the full block
                newBlocks.push(block);
            }
            // add emtpy text block if block is between 2 embed blocks or at the end
            if (blocks[i].blockType === 'embed') {
                if (i === blocks.length - 1 || blocks[i + 1].blockType === 'embed') {
                    newBlocks.push(new Block());
                }
            }
        });
        // add emtpy text block at the top if needed
        if (newBlocks[0].blockType === 'embed') {
            newBlocks.unshift(new Block());
        }
        return newBlocks;
    }
    function splitIntoBlock(bodyHtml) {
        var blocks = [], block;
        /**
         * push the current block into the blocks collection if it is not empty
         */
        function commitBlock() {
            if (block !== undefined && block.body.trim() !== '') {
                blocks.push(block);
                block = undefined;
            }
        }
        function handleParagraph(element) {
            commitBlock();
            if (angular.isDefined(element.innerHTML) && element.textContent !== ''
                && element.textContent !== '\n') {
                blocks.push(new Block({ body: element.outerHTML.trim() }));
            }
        }
        $('<div>' + bodyHtml + '</div>')
            .contents()
            .toArray()
            .forEach(function (element) {
            // if we get a <p>, we push the current block and create a new one
            // for the paragraph content
            if (element.nodeName === 'P') {
                handleParagraph(element);
                // detect if it's an embed
            }
            else if (element.nodeName === '#comment') {
                if (element.nodeValue.indexOf('EMBED START') > -1) {
                    commitBlock();
                    // retrieve the embed type following the comment
                    var embedType;
                    var embedTypeRegex = /EMBED START ([\w-]+)/;
                    var match;
                    if ((match = embedTypeRegex.exec(angular.copy(element.nodeValue).trim())) !== null) {
                        embedType = match[1];
                    }
                    else {
                        embedType = EMBED_PROVIDERS.custom;
                    }
                    // retrieve the association reference
                    var association;
                    var embedAssoKey = /{id: "(embedded\d+)"}/;
                    if ((match = embedAssoKey.exec(angular.copy(element.nodeValue).trim())) !== null
                        && self.associations) {
                        association = angular.copy(self.associations[match[1]]);
                    }
                    // create the embed block
                    block = new Block({
                        blockType: 'embed',
                        embedType: embedType,
                        association: association,
                        body: '',
                    });
                }
                if (element.nodeValue.indexOf('EMBED END') > -1) {
                    commitBlock();
                }
                // if it's not a paragraph or an embed, we update the current block
            }
            else {
                if (block === undefined) {
                    block = new Block({ body: '' });
                }
                // we want the outerHTML (ex: '<b>text</b>') or the node value for text and comment
                block.body += (element.outerHTML || element.nodeValue || '').trim();
            }
        });
        // at the end of the loop, we push the last current block
        if (block !== undefined && block.body.trim() !== '') {
            blocks.push(block);
        }
        // Complete embeds with metadata (from association datadata or html)
        blocks.forEach(function (blockObject) {
            if (blockObject.blockType === 'embed') {
                // for images that come from Superdesk, we use the association
                if (blockObject.association && blockObject.embedType === 'Image') {
                    blockObject.caption = blockObject.association.description_text;
                    blockObject.body = '';
                    editor.generateMediaTag(blockObject.association).then(function (img) {
                        blockObject.body = img;
                    });
                }
                else {
                    // extract body and caption from embed blockObject html
                    var originalBody = angular.element(angular.copy(blockObject.body));
                    if (originalBody.get(0).nodeName === 'FIGURE') {
                        blockObject.body = '';
                        originalBody.contents()
                            .toArray()
                            .forEach(function (element) {
                            if (element.nodeName === 'FIGCAPTION') {
                                blockObject.caption = element.innerHTML;
                            }
                            else {
                                blockObject.body += element.outerHTML || element.nodeValue || '';
                            }
                        });
                    }
                }
            }
        });
        // if no block, create an empty one to start
        if (blocks.length === 0) {
            blocks.push(new Block());
        }
        return blocks;
    }
    angular.extend(self, {
        configuration: angular.extend({ embeds: true }, config.editor || {}),
        blocks: [],
        initEditorWithOneBlock: function (model) {
            self.model = model;
            self.blocks = [new Block({ body: model.$modelValue })];
        },
        initEditorWithMultipleBlock: function (model) {
            // save the model to update it later
            self.model = model;
            // parse the given model and create blocks per paragraph and embed
            var content = model.$modelValue || '';
            // update the actual blocks value at the end to prevent more digest cycle as needed
            self.blocks = splitIntoBlock(content);
            self.renderBlocks();
        },
        serializeBlock: function (blocks) {
            if (blocks === void 0) { blocks = self.blocks; }
            // in case blocks are not ready
            if (blocks.length === 0) {
                return '';
            }
            var newBody = '';
            if (self.config.multiBlockEdition) {
                blocks.forEach(function (block) {
                    if (angular.isDefined(block.body) && block.body.trim() !== '') {
                        if (block.blockType === 'embed') {
                            var blockName = block.embedType.trim();
                            // add an id to the image in order to retrieve it in `assocations` field
                            if (block.association) {
                                blockName += ' {id: "embedded' + self.generateBlockId(block) + '"}';
                            }
                            newBody += [
                                '<!-- EMBED START ' + blockName + ' -->\n',
                                '<figure>',
                                block.body,
                                '<figcaption>',
                                block.caption,
                                '</figcaption>',
                                '</figure>',
                                '\n<!-- EMBED END ' + blockName + ' -->\n'
                            ].join('');
                        }
                        else {
                            newBody += block.body + '\n';
                        }
                    }
                });
            }
            else {
                newBody = blocks.length > 0 ? blocks[0].body : '';
            }
            // strip <br> and <p>
            newBody = newBody.trim().replace(/<p><br><\/p>$/, '');
            newBody = newBody.replace(/<br>$/, '');
            return newBody;
        },
        commitChanges: function () {
            var associations = angular.copy(self.associations);
            // initialize associations if doesn't exist
            if (typeof associations !== 'object') {
                associations = {};
            }
            // remove older associations
            angular.forEach(associations, function (value, key) {
                if (_.startsWith(key, 'embedded')) {
                    associations[key] = null;
                }
            });
            if (Object.keys(associations).length || self.associations) {
                // update associations with the ones stored in blocks
                self.associations = angular.extend({}, associations, self.getAssociations());
            }
            // save model with latest state of blocks
            var serialized = self.serializeBlock();
            if (serialized !== self.model.$viewValue) {
                self.model.$setViewValue(serialized);
            }
        },
        /**
         * Return an object that contains the embedded images in the story
         */
        getAssociations: function () {
            var association = {};
            self.blocks.forEach(function (block) {
                // we keep the association only for Superdesk images
                if (block.association) {
                    // add the association
                    association['embedded' + self.generateBlockId(block)] = angular.copy(block.association);
                }
            });
            return association;
        },
        getBlockPosition: function (block) {
            return _.indexOf(self.blocks, block);
        },
        splitAndInsert: function (textBlockCtrl, blocksToInsert) {
            // index where to add the new block
            var index = self.getBlockPosition(textBlockCtrl.block) + 1;
            if (index === 0) {
                throw new Error('Block to split not found');
            }
            // cut the text that is after the caret in the block and save it in order to add it after the embed later
            var after = textBlockCtrl.extractEndOfBlock().innerHTML;
            return $q.when((function () {
                if (after) {
                    // save the blocks (with removed leading text)
                    textBlockCtrl.updateModel();
                    // add new text block for the remaining text
                    return self.insertNewBlock(index, {
                        body: after,
                    }, true);
                }
            })()).then(function () {
                if (angular.isDefined(blocksToInsert)) {
                    var isArray = true;
                    var arrayBlocks = blocksToInsert;
                    if (!angular.isArray(arrayBlocks)) {
                        isArray = false;
                        arrayBlocks = [arrayBlocks];
                    }
                    var waitFor = $q.when();
                    var createdBlocks = [];
                    arrayBlocks.forEach(function (bti) {
                        waitFor = waitFor.then(function () {
                            var newBlock = self.insertNewBlock(index, bti);
                            createdBlocks.push(newBlock);
                            return newBlock;
                        });
                    });
                    return waitFor.then(function () {
                        if (isArray) {
                            return $q.all(createdBlocks);
                        }
                        return createdBlocks[0];
                    });
                }
            });
        },
        /**
         ** Merge text blocks when there are following each other and add empty text block arround embeds if needed
         ** @param {Integer} position
         ** @param {Object} block ; block attributes
         ** @param {boolean} doNotRenderBlocks ; if true, it won't merge text blocks and
         ** add empty text block if needed through the `renderBlocks()` function.
         ** @returns {object} this
         */
        insertNewBlock: function (position, attrs, doNotRenderBlocks) {
            var newBlock = new Block(attrs);
            return $q(function (resolve) {
                $timeout(function () {
                    self.blocks.splice(position, 0, newBlock);
                    $timeout(function () {
                        self.commitChanges();
                        if (!doNotRenderBlocks) {
                            $timeout(function () {
                                self.renderBlocks();
                                resolve(newBlock);
                            }, 0, false);
                        }
                        else {
                            resolve(newBlock);
                        }
                    }, 0, false);
                });
            });
        },
        /**
         * Merge text blocks when there are following each other and add empty text block arround embeds if needed
         */
        renderBlocks: function () {
            self.blocks = prepareBlocks(self.blocks);
        },
        removeBlock: function (block) {
            // remove block only if it's not the only one
            var blockPosition = self.getBlockPosition(block);
            if (self.blocks.length > 1) {
                self.blocks.splice(blockPosition, 1);
            }
            else {
                // if it's the first block, just remove the content
                block.body = '';
            }
            self.renderBlocks();
            return $timeout(self.commitChanges);
        },
        clipboard: undefined,
        cutBlock: function (block) {
            self.clipboard = angular.copy(block);
            return self.removeBlock(block);
        },
        getCutBlock: function (remove) {
            var block = self.clipboard;
            if (remove) {
                self.clipboard = undefined;
            }
            return block;
        },
        /**
         * Compute an id for the block with its content and its position.
         * Used as `track by` value, it allows the blocks to be well rendered.
         */
        generateBlockId: function (block) {
            function hashCode(string) {
                var hash = 0, i, chr, len;
                if (string.length === 0) {
                    return hash;
                }
                for (i = 0, len = string.length; i < len; i++) {
                    chr = string.charCodeAt(i);
                    // tslint:disable-next-line:no-bitwise
                    hash = (hash << 5) - hash + chr;
                    // tslint:disable-next-line:no-bitwise
                    hash |= 0; // Convert to 32bit integer
                }
                return hash;
            }
            return String(Math.abs(hashCode(block.body))) + String(self.getBlockPosition(block));
        },
    });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var embedCodeHandlers_1 = __importDefault(__webpack_require__(760));
angular.module('superdesk.apps.editor2.embed', []).controller('SdAddEmbedController', SdAddEmbedController);
SdAddEmbedController.$inject = ['embedService', '$element', '$timeout', '$q', 'lodash',
    'EMBED_PROVIDERS', '$scope', 'editor', '$injector'];
function SdAddEmbedController(embedService, $element, $timeout, $q, _, EMBED_PROVIDERS, $scope, editor, $injector) {
    var self = this;
    angular.extend(self, {
        editorCtrl: undefined,
        previewLoading: false,
        toggle: function (close) {
            // use parameter or toggle
            self.extended = angular.isDefined(close) ? !close : !self.extended;
        },
        retrieveEmbed: function () {
            function retrieveEmbedFromUrl() {
                return embedService.get(self.input).then(function (data) {
                    var embed = data.html;
                    if (!angular.isDefined(embed)) {
                        if (data.type === 'link') {
                            embed = editor.generateLinkTag({
                                url: data.url,
                                title: data.meta.title,
                                description: data.meta.description,
                                illustration: data.thumbnail_url,
                            });
                        }
                        else {
                            embed = editor.generateMediaTag({ url: data.url, altText: data.description });
                        }
                    }
                    return $q.when(embed).then(function (embedElement) { return ({
                        body: embedElement,
                        provider: data.provider_name || EMBED_PROVIDERS.custom,
                    }); });
                });
            }
            function parseRawEmbedCode() {
                var waitFor = [];
                var embedBlock = {
                    body: self.input,
                    provider: EMBED_PROVIDERS.custom,
                };
                function updateEmbedBlock(partialUpdate) {
                    angular.extend(embedBlock, partialUpdate);
                }
                // try to guess the provider of the custom embed
                for (var i = 0; i < embedCodeHandlers_1.default.length; i++) {
                    var provider = $injector.invoke(embedCodeHandlers_1.default[i]);
                    if (angular.isDefined(provider.condition)) {
                        if (!provider.condition()) {
                            continue;
                        }
                    }
                    var match = provider.pattern.exec(self.input);
                    if (match) {
                        updateEmbedBlock({ provider: provider.name });
                        if (provider.callback) {
                            waitFor.push(provider.callback(match).then(updateEmbedBlock));
                        }
                        break;
                    }
                }
                return $q.all(waitFor).then(function () { return embedBlock; });
            }
            var embedCode;
            // if it's an url, use embedService to retrieve the embed code
            if (_.startsWith(self.input, 'http')) {
                embedCode = retrieveEmbedFromUrl();
                // otherwise we use the content of the field directly
            }
            else {
                embedCode = parseRawEmbedCode();
            }
            return $q.when(embedCode);
        },
        updatePreview: function () {
            self.previewLoading = true;
            self.retrieveEmbed().then(function (embed) {
                angular.element($element)
                    .find('.preview')
                    .html(embed.body.replace('\\n', ''));
                self.previewLoading = false;
            });
        },
        createFigureBlock: function (data) {
            // create a new block containing the embed
            data.blockType = 'embed';
            return self.editorCtrl.insertNewBlock(self.addToPosition, data);
        },
        createBlockFromEmbed: function () {
            self.retrieveEmbed().then(function (embed) {
                self.createFigureBlock({
                    embedType: embed.provider,
                    body: embed.body,
                    association: embed.association,
                });
                // close the addEmbed form
                self.toggle(true);
            });
        },
        closeEmbed: function () {
            // put block back together on embed form close.
            self.toggle();
        },
    });
    // toggle when the `extended` directive attribute changes
    $scope.$watch(function () { return self.extended; }, function (extended, wasExtended) {
        // on enter, focus on input
        if (angular.isDefined(extended)) {
            if (extended) {
                $timeout(function () {
                    angular.element($element)
                        .find('input')
                        .focus();
                }, 500, false); // positive timeout because of a chrome issue
                // on leave, clear field
            }
            else if (wasExtended) {
                self.input = '';
                if (typeof self.onClose === 'function') {
                    $timeout(self.onClose);
                }
            }
        }
    });
}


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    ['EMBED_PROVIDERS', function (EMBED_PROVIDERS) {
            return {
                pattern: /twitter\.com\/widgets\.js/g,
                name: EMBED_PROVIDERS.twitter,
            };
        }],
    ['EMBED_PROVIDERS', function (EMBED_PROVIDERS) {
            return {
                pattern: /www\.youtube\.com/g,
                name: EMBED_PROVIDERS.youtube,
            };
        }],
    ['EMBED_PROVIDERS', 'api', 'config', function (EMBED_PROVIDERS, api, config) {
            return {
                pattern: /src=".*vidible\.tv.*pid=(.+)\/(.+).js/g,
                name: EMBED_PROVIDERS.vidible,
                condition: function () { return config.editor && config.editor.vidible; },
                callback: function (match) { return api.get("vidible/bcid/" + match[2] + "/pid/" + match[1])
                    .then(function (data) { return ({ association: data }); }); },
            };
        }],
];


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {angular.module('superdesk.apps.editor2.content', []).directive('sdAddContent', ['$window',
    function ($window) {
        return {
            // the scope is not isolated because we require the medium instance
            controller: AddContentCtrl,
            require: ['sdAddContent', '^sdTextEditorBlockText', '^sdTextEditor'],
            templateUrl: 'scripts/core/editor2/views/add-content.html',
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, element, attrs, ctrls) {
                var vm = ctrls[0];
                angular.extend(vm, {
                    textBlockCtrl: ctrls[1],
                    sdEditorCtrl: ctrls[2],
                });
                if (!vm.config.embeds) {
                    return;
                }
                // initialize state
                vm.updateState();
                // listen for update state signals
                var unbindListener = scope.$parent.$on('sdAddContent::updateState', function (signal, event, editorElem) {
                    vm.updateState(event, editorElem);
                });
                // update on resize
                angular.element($window).on('resize', vm.updateState);
                scope.$on('$destroy', function () {
                    angular.element($window).off('resize', vm.updateState);
                    unbindListener();
                });
            },
        };
    }]);
AddContentCtrl.$inject = ['$scope', '$element', 'superdesk', 'editor', '$timeout', 'config', '$q'];
function AddContentCtrl(scope, element, superdesk, editor, $timeout, config, $q) {
    var elementHolder = element.find('div:first-child').first();
    var self = this;
    /** Return true if the event come from this directive's element */
    function elementContainsEventTarget(event) {
        if (!angular.isDefined(event)) {
            return false;
        }
        return $.contains(element.get(0), event.target);
    }
    angular.extend(self, {
        expanded: false,
        config: angular.extend({ embeds: true }, config.editor || {}),
        // update the (+) vertical position on the left and his visibility (hidden/shown)
        updateState: function (event, editorElem) {
            // hide if medium is not defined yett (can happen at initialization) or
            // hide if the text input is not selected and if it was not a click on the (+) button
            if (!angular.isDefined(scope.medium)
                || !angular.element(editorElem).is(':focus') && !elementContainsEventTarget(event)) {
                return self.hide();
            }
            var currentParagraph;
            try {
                currentParagraph = angular.element(scope.medium.getSelectedParentElement());
            }
            catch (e) {
                return;
            }
            var position = currentParagraph.position().top;
            // move the (+) button at the caret position
            elementHolder.css('top', position > 0 ? position : 0);
            // handle resize: Do nothing, only positioning was needed
            if (event && event.type === 'resize') {
                return;
            }
            var isFocusEvent = event && event.type === 'focus';
            var isClickEvent = event && event.type === 'click';
            var containsTarget = elementContainsEventTarget(event) && currentParagraph.text() === '';
            var isFocused = editorElem.is(':focus') && currentParagraph.text() === '';
            var isEmptyLine = currentParagraph.text() === '';
            var shouldShow = isFocusEvent && containsTarget || isClickEvent && isFocused || isEmptyLine;
            return shouldShow ? self.show() : self.hide();
        },
        hide: function () {
            $timeout(function () {
                elementHolder.css({
                    display: 'none',
                });
                self.expanded = false;
            });
        },
        show: function () {
            $timeout(function () {
                elementHolder.css({
                    display: 'block',
                });
            });
        },
        toogleExpand: function () {
            self.expanded = !self.expanded;
        },
        isSomethingInClipboard: function () {
            return angular.isDefined(self.sdEditorCtrl.getCutBlock());
        },
        triggerAction: function (action) {
            self.hide();
            self.actions[action]();
        },
        actions: {
            addEmbed: function () {
                self.sdEditorCtrl.splitAndInsert(self.textBlockCtrl).then(function () {
                    // show the add-embed form
                    self.textBlockCtrl.block.showAndFocusLowerAddAnEmbedBox();
                });
            },
            addPicture: function () {
                superdesk.intent('upload', 'media', { uniqueUpload: true }).then(function (images) {
                    $q.all(images.map(function (image) { return editor.generateMediaTag(image).then(function (imgTag) { return ({
                        blockType: 'embed',
                        embedType: 'Image',
                        body: imgTag,
                        caption: image.description_text,
                        association: image,
                    }); }); })).then(function (renderedImages) {
                        self.sdEditorCtrl.splitAndInsert(self.textBlockCtrl, renderedImages);
                    });
                }, function () {
                    scope.node.focus();
                    self.textBlockCtrl.restoreSelection();
                });
            },
            pasteBlock: function () {
                if (!self.sdEditorCtrl.getCutBlock()) {
                    return false;
                }
                self.sdEditorCtrl.splitAndInsert(self.textBlockCtrl, self.sdEditorCtrl.getCutBlock(true));
            },
        },
    });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.spellcheck
 * @name superdesk.core.spellcheck
 * @packageName superdesk.core
 * @description Spellchecker.
 */
__webpack_require__(763);


/***/ }),
/* 763 */
/***/ (function(module, exports) {

/**
 * Spellcheck module
 */
SpellcheckService.$inject = ['$q', 'api', 'dictionaries', '$rootScope', '$location', 'lodash', 'preferencesService'];
function SpellcheckService($q, api, dictionaries, $rootScope, $location, _, preferencesService) {
    var PREFERENCES_KEY = 'spellchecker:status', lang, dict = {}, ignored = {}, abbreviationList = [], self;
    var _activeCache = {};
    self = this;
    self.abbreviationsDict = null;
    self.isAutoSpellchecker = false;
    /**
     * Set current language
     *
     * @param {string} _lang
     */
    this.setLanguage = function (_lang) {
        if (lang !== _lang) {
            lang = _lang;
            dict = {};
        }
    };
    /**
     * Gets the base language (en) of different culture
     * specific (en-AU) language
     *
     * @param {string} language
     * @return {string}
     */
    function getBaseLanguage(language) {
        if (language && language.indexOf('-') > 0) {
            return language.split('-')[0];
        }
        return null;
    }
    /**
     * Get dictionary for spellchecking
     *
     * @return {Promise}
     */
    this.getDict = getDict;
    function getDict() {
        if (!lang) {
            return $q.reject();
        }
        var baseLang = getBaseLanguage(lang);
        if (Object.keys(dict).length === 0) {
            dict = dictionaries.getActive(lang, baseLang).then(function (items) {
                dict = dict || {};
                dict.content = {};
                var langItems = items;
                if (baseLang && _.find(items, { language_id: lang }) && _.find(items, { language_id: baseLang })) {
                    langItems = _.filter(items, { language_id: lang });
                }
                angular.forEach(langItems, addDict);
                // Abbreviations found in dictionary.
                var re = /\w+(?:\.\w*)+/g;
                abbreviationList = _.words(Object.keys(dict.content), re);
                return dict.content;
            });
        }
        return dict;
    }
    /*
     * Return dictionaries for requested language
     *
     * @param {Object} language
     * @returns {Object} List of dictionaries
     */
    this.getDictionary = function (language) {
        if (!_activeCache[language]) {
            _activeCache[language] = dictionaries.getActive(language, getBaseLanguage(language));
        }
        return _activeCache[language];
    };
    /**
     * Get abbreviations for replacement
     *
     * @return {Promise}
     */
    this.getAbbreviationsDict = function (force) {
        if (!lang) {
            // here it shouldn't reject like in getDict, where it would stop only spellchecking
            // if there is no dictionary, while here it would stop scope commit in editor
            return $q.when({});
        }
        var baseLang = getBaseLanguage(lang);
        if (!self.abbreviationsDict || force) {
            return dictionaries.getUserAbbreviations(lang, baseLang).then(function (items) {
                self.abbreviationsDict = self.abbreviationsDict || {};
                self.abbreviationsDict.content = {};
                var langItems = items;
                if (baseLang && _.find(items, { language_id: lang }) && _.find(items, { language_id: baseLang })) {
                    langItems = _.filter(items, { language_id: lang });
                }
                angular.forEach(langItems, function (item) {
                    angular.extend(self.abbreviationsDict.content, JSON.parse(item.content) || {});
                });
                return self.abbreviationsDict.content;
            });
        }
        return $q.when(self.abbreviationsDict.content);
    };
    function updateAbbreviations(data) {
        if (self.abbreviationsDict && self.abbreviationsDict.content) {
            angular.extend(self.abbreviationsDict.content, data || {});
        }
    }
    $rootScope.$on('abbreviations:updated', angular.bind(self, function (evt, data) {
        updateAbbreviations(data);
    }));
    /**
     * Reset active dictionary cache
     *
     * When it gets langauge info, only reset it for given langauge,
     * otherwise reset it for all languages.
     *
     * @param {Event} event
     * @param {Object} data
     */
    var _resetActiveCache = function (event, data) {
        if (data.language) {
            _activeCache[data.language] = null;
        }
        else {
            _activeCache = {};
        }
    };
    $rootScope.$on('dictionary:created', _resetActiveCache);
    $rootScope.$on('dictionary:updated', _resetActiveCache);
    /**
     * Add dictionary content to spellcheck
     *
     * @param {Object} item
     */
    function addDict(item, _lang) {
        angular.extend(dict.content, item.content || {});
    }
    /**
     * Get words that come after an abbreviation.
     *
     * @param {string} textContent
     * @param {integer} currentOffset
     * @return {Object} - list of non sentence words.
     *     {
     *       index: word
     *     }
     */
    function getNonSentenceWords(textContent, currentOffset) {
        // words contains one or more periods in content. e.g., E.N.T., Aborig. or etc.
        var reAbbreviations = /\w+(?:\.\w*)+/g;
        var abbreviationWords = _.words(textContent, reAbbreviations);
        // consider only abbreviations in content that found in dictionary
        var _abbrevArr = [];
        _.forEach(abbreviationWords, function (abbrevWord) {
            _.filter(abbreviationList, function (item) {
                if (item === abbrevWord) {
                    _abbrevArr.push(abbrevWord);
                }
            });
        });
        var _abbreviationString = _abbrevArr.join('|');
        // Prepare non sentence words
        var match, wordIndex;
        var nonSentenceWords = [];
        // Words that come after an abbreviation in content.
        var _reNonSentenceWords = '\\s+(?:' + _abbreviationString + ')(\\s+\\w+)';
        var reNonSentenceWords = new RegExp(_reNonSentenceWords, 'g');
        while (!_.isNil(match = reNonSentenceWords.exec(textContent))) {
            wordIndex = match.index + match[0].indexOf(_.trim(match[1]));
            nonSentenceWords[currentOffset + wordIndex] = _.trim(match[1]);
        }
        return nonSentenceWords;
    }
    /**
     * Get words that contributing beginning of sentences.
     * excluding words that come after an abbreviation.
     *
     * @param {string} textContent
     * @param {integer} currentOffset
     * @return {Object} - list of sentence words.
     *     {
     *       index: word
     *     }
     */
    function getSentenceWords(textContent, currentOffset) {
        var reSentenceWords = /(?:^\s*|(?:[.|?|!|:]\s*))(\w+)/g; // words come after by .|?|!|:
        var match, wordIndex;
        var sentenceWords = {};
        // Replace quotes (",“,”,‘,’,'), that might occur at start/end of sentence/paragraph before applying regex.
        while (!_.isNil(match = reSentenceWords.exec(textContent.replace(/["“”‘’']/g, ' ')))) {
            wordIndex = match.index + match[0].indexOf(match[1]);
            sentenceWords[currentOffset + wordIndex] = match[1];
        }
        // Excluding the words from sentence word if come after an abbreviation.
        var nonSentenceWords = getNonSentenceWords(textContent, currentOffset);
        sentenceWords = _.omit(sentenceWords, Object.keys(nonSentenceWords));
        return sentenceWords;
    }
    /**
     * Test if word exists in dictionary
     *
     * @param {String} word
     * @param {Boolean} i - if true tests case in-sensitive
     * @return {Boolean}
     */
    function wordExistInDict(word, i) {
        if (i) {
            var lowerCaseWord = word.toLowerCase();
            return _.find(Object.keys(dict.content), function (val) { return val.toLowerCase() === lowerCaseWord; });
        }
        return dict.content[word];
    }
    /**
     * Test if word is a spelling mistake
     *
     * @param {String} word
     * @param {Boolean} sentenceWord - it's first word in a sentence
     * @return {Boolean}
     */
    function isSpellingMistake(word, sentenceWord) {
        if (isFirstLetterCapital(word)) {
            // first word, maybe it is in dict with capital, maybe not, check both
            var lowercase = word[0].toLowerCase() + word.slice(1);
            return !wordExistInDict(word) && !wordExistInDict(lowercase);
        }
        else if (sentenceWord) {
            return true;
        }
        // check it as it is
        return !wordExistInDict(word);
    }
    /**
     * Test if first letter of word is uppercase
     *
     * @param {String} word
     * @return {Boolean}
     */
    function isFirstLetterCapital(word) {
        return word[0] === word[0].toUpperCase();
    }
    /**
     * Find errors in given node
     *
     * @param {Node} node
     */
    this.errors = function check(node) {
        return getDict().then(function (d) {
            var errors = [], regexp = /[0-9a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF]+/g, dblSpacesRegExp = /\S(\s{2,})\S/g, match, dblSpacesMatch, currentOffset = 0, tree = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
            var objSentenceWords = getSentenceWords(node.textContent, currentOffset);
            while (tree.nextNode()) {
                while (!_.isNil(dblSpacesMatch = dblSpacesRegExp.exec(tree.currentNode.textContent))) {
                    var dblSpace = dblSpacesMatch[1];
                    errors.push({
                        word: dblSpace,
                        index: currentOffset + dblSpacesMatch.index + 1,
                        sentenceWord: false,
                    });
                }
                while (!_.isNil(match = regexp.exec(tree.currentNode.textContent))) {
                    var word = match[0];
                    var isSentenceWord = !!objSentenceWords[currentOffset + match.index];
                    if (isNaN(word) && !isIgnored(word) && isSpellingMistake(word, isSentenceWord)) {
                        errors.push({
                            word: word,
                            index: currentOffset + match.index,
                            sentenceWord: isSentenceWord,
                        });
                    }
                }
                currentOffset += tree.currentNode['length'];
            }
            return errors;
        });
    };
    /**
     * Get suggested corrections for given word
     *
     * @param {string} word
     */
    this.suggest = function suggest(word) {
        if (word.match(/^\s+$/i)) {
            return Promise.resolve([{ key: ' ', value: 'Add single space' }]);
        }
        return api.save('spellcheck', {
            word: word,
            language_id: lang,
        }).then(function (result) {
            var allDict = getDict();
            var wordFoundInDict = _.pick(allDict.content, function (value, key) {
                if (key.toLowerCase() === word.toLowerCase()) {
                    return key;
                }
            });
            angular.extend(result.corrections, Object.keys(wordFoundInDict));
            return result.corrections.map(function (key) { return ({ key: key, value: key }); });
        });
    };
    /**
     * Add word to user dictionary
     *
     * @param {String} word
     */
    this.addWordToUserDictionary = addWordToUserDictionary;
    function addWordToUserDictionary(word) {
        dictionaries.addWordToUserDictionary(word, lang);
        dict.content[word] = dict.content[word] ? dict.content[word] + 1 : 1;
    }
    /**
     * Ignore word when spellchecking
     *
     * @param {String} word
     */
    this.ignoreWord = ignoreWord;
    function ignoreWord(word) {
        getItemIgnored()[word] = 1;
    }
    /**
     * Test if given word is in ingored
     *
     * @param {String} word
     * @return {Boolean}
     */
    function isIgnored(word) {
        return !!getItemIgnored()[word];
    }
    /**
     * Get ignored collection for current item
     *
     * @return {Object}
     */
    function getItemIgnored() {
        var item = $location.search().item || '';
        ignored[item] = ignored[item] || {};
        return ignored[item];
    }
    /**
     * Add word to regular or ignored dictionary
     *
     * @param {String} word
     * @param {String} isBeingIgnored
     */
    this.addWord = function addWord(word, isBeingIgnored) {
        if (isBeingIgnored) {
            ignoreWord(word);
        }
        else {
            addWordToUserDictionary(word);
        }
    };
    /**
     * Check if the current word is correct
     *
     * @param {String} text
     */
    this.isCorrectWord = function isCorrectWord(word) {
        // TODO: calculate isSentenceWord
        var isSentenceWord = false;
        return !isNaN(word) || !dict.content || isIgnored(word) || !isSpellingMistake(word, isSentenceWord);
    };
    // reset ignore list for an item if it was unlocked
    $rootScope.$on('item:unlock', function (event, data) {
        if (ignored.hasOwnProperty(data.item)) {
            ignored[data.item] = {};
        }
    });
    /**
     * Get the spell checker status
     */
    this.getSpellcheckerStatus = function getSpellcheckerStatus() {
        var status = true;
        return preferencesService.get(PREFERENCES_KEY).then(function (result) {
            if (angular.isDefined(result)) {
                status = result.enabled;
            }
            return status;
        }, function (error) { return status; });
    };
    /**
     * Set the spell checker status
     */
    this.setSpellcheckerStatus = function setSpellcheckerStatus(status) {
        var updates = {};
        self.isAutoSpellchecker = status;
        updates[PREFERENCES_KEY] = {
            type: 'bool',
            enabled: status,
            default: true,
        };
        preferencesService.update(updates, PREFERENCES_KEY);
    };
    this.getSpellcheckerStatus().then(function (status) {
        self.isAutoSpellchecker = status;
    });
}
SpellcheckMenuController.$inject = ['$rootScope', 'editorResolver', 'spellcheck', 'notify', '$scope'];
function SpellcheckMenuController($rootScope, editorResolver, spellcheck, notify, $scope) {
    this.isAuto = false;
    this.isActiveDictionary = false;
    this.runSpellchecker = runSpellchecker;
    this.pushSettings = pushSettings;
    var self = this;
    /**
     * Force spell ckecking
     */
    function runSpellchecker() {
        if (!self.isActiveDictionary) {
            notify.error(gettext('No dictionary available for spell checking.'));
            return;
        }
        var editor = editorResolver.get();
        if (editor && editor.version() === '3') {
            // on editor3 set auto spellcheck when the spellcheck is run
            self.isAuto = true && !useTansaProofing();
            pushSettings();
        }
        else {
            editor.render(true);
        }
    }
    /**
     * render the editor based on the spell check settings.
     */
    function render() {
        var editor = editorResolver.get();
        editor.setSettings({ spellcheck: self.isAuto });
        editor.render();
    }
    /**
     * update the editor and preferences
     */
    function pushSettings() {
        render();
        spellcheck.setSpellcheckerStatus(self.isAuto);
    }
    /**
     * check if tansa is activated
     */
    function useTansaProofing() {
        return $rootScope.config.features && $rootScope.config.features.useTansaProofing;
    }
    spellcheck.getDictionary($scope.item.language).then(function (dict) {
        self.isActiveDictionary = !!dict.length;
        if (!self.isActiveDictionary) {
            spellcheck.setSpellcheckerStatus(self.isActiveDictionary);
        }
        else {
            spellcheck.getSpellcheckerStatus().then(function (status) {
                self.isAuto = status && !useTansaProofing() && self.isActiveDictionary;
                render();
            });
        }
    });
}
angular.module('superdesk.apps.spellcheck', ['superdesk.apps.dictionaries'])
    .service('spellcheck', SpellcheckService)
    .controller('SpellcheckMenu', SpellcheckMenuController);


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(765);
var service_1 = __webpack_require__(768);
var directive_1 = __webpack_require__(882);
var ng_1 = __importDefault(__webpack_require__(18));
/**
 * @ngdoc module
 * @module superdesk.core.editor3
 * @name superdesk.core.editor3
 * @packageName superdesk.core
 * @description Editor as an Angular directive.
 */
exports.default = angular.module('superdesk.core.editor3', ['superdesk.apps.spellcheck'])
    .service('editor3', service_1.EditorService)
    .service('editorResolver', ['editor', 'editor3', 'config', function (editor2, editor3, config) {
        // Enables the use of editor2 and editor3 in parallel.
        // Resolves to old editor in case editor3 is inactive.
        this.get = function () {
            var authoring = ng_1.default.get('authoring');
            var editor3Active = authoring.editor && authoring.editor.body_html && authoring.editor.body_html.editor3;
            return config.features.onlyEditor3 || editor3Active ? editor3 : editor2;
        };
    }])
    .directive('sdEditor3', directive_1.sdEditor3);


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(766);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../css-loader/index.js!../../../../sass-loader/lib/loader.js!./styles.scss", function() {
		var newContent = require("!!../../../../css-loader/index.js!../../../../sass-loader/lib/loader.js!./styles.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports
exports.i(__webpack_require__(767), "");

// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n.main-article .abstract div.Editor3-root div.link-toolbar {\n  font-size: 13px !important;\n  font-style: normal;\n  padding: 0 10px;\n  border-top: 1px solid rgba(150, 150, 150, 0.4);\n  height: 0;\n  min-height: auto;\n  opacity: 0;\n  transition: all .2s ease-out; }\n  .main-article .abstract div.Editor3-root div.link-toolbar.is-link {\n    height: 26px;\n    padding: 5px 10px;\n    opacity: 1; }\n\n.Editor3-root {\n  border: 1px solid rgba(150, 150, 150, 0.4);\n  font-weight: 300;\n  padding: 0;\n  position: relative; }\n  .Editor3-root iframe {\n    width: 97%; }\n  .Editor3-root.no-toolbar {\n    padding-top: 5px; }\n  .Editor3-root .link-toolbar {\n    font-size: 13px;\n    color: rgba(123, 123, 123, 0.8);\n    padding: 0 10px;\n    border-top: 1px solid rgba(150, 150, 150, 0.25);\n    height: 0;\n    opacity: 0;\n    transition: all .2s ease-out; }\n    .Editor3-root .link-toolbar.is-link {\n      height: 26px;\n      padding: 5px 10px;\n      opacity: 1; }\n    .Editor3-root .link-toolbar a {\n      margin-left: 10px;\n      cursor: pointer;\n      color: rgba(123, 123, 123, 0.8); }\n      .Editor3-root .link-toolbar a:hover {\n        color: #969696;\n        border-bottom: 1px dotted #5ea9c8; }\n  .Editor3-root audio {\n    width: 100%; }\n  .Editor3-root .Editor3-controls.floating-toolbar {\n    position: fixed;\n    top: 132px;\n    left: auto;\n    right: auto;\n    z-index: 10;\n    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);\n    background-color: #f8f8f8; }\n    .Editor3-root .Editor3-controls.floating-toolbar .link-toolbar.empty {\n      display: none; }\n  .Editor3-root.read-only {\n    cursor: not-allowed; }\n    .Editor3-root.read-only .Editor3-controls {\n      opacity: 0.98; }\n      .Editor3-root.read-only .Editor3-controls * {\n        pointer-events: none; }\n      .Editor3-root.read-only .Editor3-controls.table-controls {\n        opacity: 1; }\n        .Editor3-root.read-only .Editor3-controls.table-controls * {\n          pointer-events: all; }\n        .Editor3-root.read-only .Editor3-controls.table-controls .Editor3-styleButton:hover {\n          color: #555; }\n          .Editor3-root.read-only .Editor3-controls.table-controls .Editor3-styleButton:hover [class*=\"icon-\"] {\n            color: #555; }\n        .Editor3-root.read-only .Editor3-controls.table-controls [class*=\"icon-\"] {\n          color: #999;\n          position: relative;\n          top: 3px; }\n          .Editor3-root.read-only .Editor3-controls.table-controls [class*=\"icon-\"]:hover {\n            color: #555; }\n      .Editor3-root.read-only .Editor3-controls [class*=\"icon-\"] {\n        color: #ddd; }\n        .Editor3-root.read-only .Editor3-controls [class*=\"icon-\"]:hover {\n          color: #ddd; }\n  .Editor3-root .image-block, .Editor3-root .embed-block {\n    cursor: default;\n    position: relative;\n    padding: 1.4rem 1rem 1rem;\n    border-radius: 2px;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(123, 123, 123, 0.3) !important;\n    transition: 0.3s linear box-shadow; }\n    .Editor3-root .image-block:hover, .Editor3-root .embed-block:hover {\n      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.46), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(123, 123, 123, 0.6) !important; }\n      .Editor3-root .image-block:hover .image-block__remove, .Editor3-root .embed-block:hover .image-block__remove {\n        visibility: visible; }\n      .Editor3-root .image-block:hover .embed-block__remove, .Editor3-root .embed-block:hover .embed-block__remove {\n        visibility: visible; }\n      .Editor3-root .image-block:hover .embed-block__edit, .Editor3-root .embed-block:hover .embed-block__edit {\n        visibility: visible; }\n  .Editor3-root .image-block__title, .Editor3-root .image-block__description {\n    border: 1px solid rgba(123, 123, 123, 0);\n    border-bottom-color: rgba(123, 123, 123, 0.3);\n    padding: 0;\n    border-radius: 0;\n    background-color: transparent;\n    color: inherit;\n    font-size: 1.4rem;\n    resize: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    box-shadow: none !important;\n    outline: none;\n    padding: 0 0 0 0.2rem; }\n    .Editor3-root .image-block__title:hover, .Editor3-root .image-block__description:hover {\n      border-bottom-color: rgba(123, 123, 123, 0.6); }\n    .Editor3-root .image-block__title:focus, .Editor3-root .image-block__description:focus {\n      border-width: 1px !important;\n      border-color: rgba(94, 169, 200, 0.3) !important;\n      border-bottom-color: #5ea9c8 !important;\n      box-shadow: 0 1px 0 #5ea9c8 !important; }\n  .Editor3-root .image-block__title {\n    margin-bottom: 1.6rem;\n    font-size: 1.5rem;\n    font-weight: 500; }\n  .Editor3-root .image-block__description {\n    margin-top: 1rem;\n    margin-bottom: 0.2rem;\n    font-weight: 300; }\n  .Editor3-root .image-block__remove, .Editor3-root .embed-block__remove, .Editor3-root .embed-block__edit {\n    z-index: 6;\n    position: absolute;\n    top: -1rem;\n    right: -1rem;\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.36), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(123, 123, 123, 0.3) !important;\n    background-color: #fff !important;\n    color: #333;\n    visibility: hidden;\n    opacity: 1 !important; }\n  .Editor3-root .embed-block__edit {\n    top: 3rem; }\n  .Editor3-root .image-block__image {\n    position: relative;\n    background-color: #252525;\n    margin: 0 -1rem; }\n    .Editor3-root .image-block__image:hover .image-block__image-overlay {\n      opacity: 1; }\n    .Editor3-root .image-block__image video, .Editor3-root .image-block__image audio {\n      display: block; }\n  .Editor3-root .image-block__image-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background-color: rgba(0, 0, 0, 0.5);\n    transition: 0.2s linear opacity;\n    z-index: 1;\n    opacity: 0;\n    color: #fff; }\n  .Editor3-root .image-block__metadata {\n    padding: 0.4rem 0 0.2rem 0;\n    color: inherit;\n    font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n    font-size: 1.3rem;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));\n    grid-gap: 0 1.6rem;\n    z-index: 2;\n    transition: 0.2s linear opacity;\n    text-align: left;\n    margin: 1.6rem 1.6rem 0; }\n    .Editor3-root .image-block__metadata span {\n      display: block;\n      padding: 0.6rem 0;\n      border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n      .Editor3-root .image-block__metadata span em {\n        font-style: normal;\n        color: inherit;\n        opacity: 0.75;\n        font-weight: 300;\n        padding-right: 0.4rem;\n        font-size: 1.1rem;\n        text-transform: uppercase;\n        letter-spacing: 0.05em; }\n      .Editor3-root .image-block__metadata span:nth-child(1), .Editor3-root .image-block__metadata span:nth-child(2) {\n        border-top: 1px dotted rgba(123, 123, 123, 0.5); }\n    .Editor3-root .image-block__metadata--top-overlay {\n      padding: 0.2rem 0 0.6rem 0;\n      margin-top: 0;\n      background: none;\n      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, transparent 100%); }\n      .Editor3-root .image-block__metadata--top-overlay span {\n        padding-bottom: 0.4rem;\n        border: none !important; }\n    .Editor3-root .image-block__metadata--bottom-overlay {\n      background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.12) 2%, rgba(0, 0, 0, 0.6) 100%); }\n    .Editor3-root .image-block__metadata--side-marg0 {\n      margin-left: 0;\n      margin-right: 0; }\n  .Editor3-root .image-block__action-bar {\n    text-align: right;\n    padding: 0.6rem 0 0; }\n  .Editor3-root .image-block__icons-block {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1; }\n  .Editor3-root .image-block__image-action {\n    flex-grow: 0;\n    flex-shrink: 0;\n    color: #fff;\n    width: 5.6rem;\n    height: 5.6rem;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    transition: 0.2s linear all;\n    cursor: pointer;\n    text-decoration: none;\n    background-color: transparent; }\n    .Editor3-root .image-block__image-action i {\n      color: #fff;\n      height: 2.4rem;\n      width: 2.4rem;\n      font-size: 2.4rem;\n      line-height: 1;\n      opacity: 0.5;\n      transition: 0.2s linear all; }\n    .Editor3-root .image-block__image-action:hover {\n      border-color: white;\n      background-color: rgba(0, 0, 0, 0.4);\n      text-decoration: none; }\n      .Editor3-root .image-block__image-action:hover i {\n        opacity: 1; }\n    .Editor3-root .image-block__image-action:active {\n      border-color: #5ea9c8;\n      background-color: rgba(0, 0, 0, 0.6); }\n      .Editor3-root .image-block__image-action:active i {\n        color: #5ea9c8; }\n    .Editor3-root .image-block__image-action + .image-block__image-action {\n      margin-left: 2rem; }\n  .Editor3-root [class^=\"__image-overlay\"] .image-block__metadata span,\n  .Editor3-root [class*=\"__image-overlay\"] .image-block__metadata span {\n    border-color: rgba(255, 255, 255, 0.5) !important; }\n    .Editor3-root [class^=\"__image-overlay\"] .image-block__metadata span:last-child,\n    .Editor3-root [class*=\"__image-overlay\"] .image-block__metadata span:last-child {\n      border-bottom: none; }\n  .Editor3-root .table-block.table-header tr:first-child td {\n    background-color: rgba(150, 150, 150, 0.2); }\n  .Editor3-root .table-block__controls {\n    margin-bottom: 6px; }\n    .Editor3-root .table-block__controls span {\n      background: #000;\n      color: #fff;\n      padding: 5px 10px;\n      cursor: pointer;\n      font-size: 13px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif; }\n      .Editor3-root .table-block__controls span:hover {\n        background: #444; }\n      .Editor3-root .table-block__controls span:first-child {\n        border-radius: 5px 0 0 5px;\n        border-right: 1px solid #999; }\n      .Editor3-root .table-block__controls span:last-child {\n        border-radius: 0 5px 5px 0; }\n  .Editor3-root .table-block table td {\n    position: relative;\n    border: 1px solid rgba(150, 150, 150, 0.25);\n    padding: 5px;\n    min-width: 20px; }\n    .Editor3-root .table-block table td .public-DraftEditor-content {\n      margin: 0;\n      padding: 0; }\n  .Editor3-root .word-typo:not(.ignored) {\n    border-bottom-width: 1px;\n    border-bottom-style: dotted;\n    border-bottom-color: red;\n    position: relative; }\n  .Editor3-root .suggestions-dropdown {\n    font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n    display: block;\n    position: absolute;\n    top: 24px;\n    left: -10px; }\n  .Editor3-root .qumu-embed {\n    white-space: initial; }\n  .Editor3-root .media-block {\n    text-align: left;\n    font-family: \"Roboto\", Helvetica, Arial, sans-serif; }\n    .Editor3-root .media-block__wrapper {\n      display: inline-block; }\n    .Editor3-root .media-block__title {\n      resize: none;\n      font-size: 16px;\n      line-height: 140%;\n      padding: 5px 5px 5px 0;\n      margin-bottom: 5px;\n      min-height: 28px;\n      background-color: transparent;\n      border: none; }\n    .Editor3-root .media-block__description {\n      font-size: 13px;\n      line-height: 140%;\n      resize: none;\n      padding: 5px 5px 5px 0;\n      min-height: 28px;\n      color: #747474;\n      background-color: transparent;\n      border: none; }\n    .Editor3-root .media-block img, .Editor3-root .media-block video, .Editor3-root .media-block audio {\n      display: inline-block;\n      cursor: pointer; }\n  .Editor3-root ul.public-DraftStyleDefault-ul, .Editor3-root ol.public-DraftStyleDefault-ol {\n    margin: 0 0 0 20px;\n    padding: 0 0 0 20px; }\n    .Editor3-root ul.public-DraftStyleDefault-ul .public-DraftStyleDefault-depth1, .Editor3-root ol.public-DraftStyleDefault-ol .public-DraftStyleDefault-depth1 {\n      margin-left: 40px; }\n    .Editor3-root ul.public-DraftStyleDefault-ul .public-DraftStyleDefault-depth2, .Editor3-root ol.public-DraftStyleDefault-ol .public-DraftStyleDefault-depth2 {\n      margin-left: 60px; }\n    .Editor3-root ul.public-DraftStyleDefault-ul .public-DraftStyleDefault-depth3, .Editor3-root ol.public-DraftStyleDefault-ol .public-DraftStyleDefault-depth3 {\n      margin-left: 80px; }\n    .Editor3-root ul.public-DraftStyleDefault-ul .public-DraftStyleDefault-depth4, .Editor3-root ol.public-DraftStyleDefault-ol .public-DraftStyleDefault-depth4 {\n      margin-left: 100px; }\n  .Editor3-root ul.public-DraftStyleDefault-ul > li {\n    list-style-type: disc; }\n\n.Editor3-editor {\n  cursor: text;\n  font-size: 16px;\n  line-height: 140%;\n  word-break: break-word; }\n\n.Editor3-editor-single-line {\n  border-bottom: 1px solid #ddd;\n  cursor: text;\n  font-size: 16px;\n  margin-bottom: 10px; }\n\n.Editor3-editor .public-DraftEditorPlaceholder-root,\n.Editor3-editor .public-DraftEditor-content {\n  padding: 10px 15px 0 15px; }\n\n.Editor3-editor.unstyled__block--invisibles [data-block]:after {\n  content: '\\E690';\n  font-family: 'sd_icons';\n  font-size: 16px;\n  color: #5ea9c8; }\n\n.Editor3-editor .public-DraftEditor-content {\n  min-height: 20px; }\n  .Editor3-editor .public-DraftEditor-content [data-block=\"true\"] {\n    border-bottom: 1.5em solid transparent; }\n    .Editor3-editor .public-DraftEditor-content [data-block=\"true\"].unstyled__block--over {\n      border-bottom-color: rgba(93, 155, 192, 0.3); }\n    .Editor3-editor .public-DraftEditor-content [data-block=\"true\"]:only-child {\n      border-bottom-width: 0.6em; }\n  .Editor3-editor .public-DraftEditor-content h1, .Editor3-editor .public-DraftEditor-content h2, .Editor3-editor .public-DraftEditor-content h3, .Editor3-editor .public-DraftEditor-content h4, .Editor3-editor .public-DraftEditor-content h5, .Editor3-editor .public-DraftEditor-content h6 {\n    z-index: 1; }\n    .Editor3-editor .public-DraftEditor-content h1[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content h2[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content h3[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content h4[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content h5[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content h6[data-block=\"true\"] {\n      border-bottom-width: 0.5em; }\n  .Editor3-editor .public-DraftEditor-content .unstyled {\n    padding-top: 0.4em; }\n  .Editor3-editor .public-DraftEditor-content .unstyled:first-child {\n    padding-top: 0.6em; }\n  .Editor3-editor .public-DraftEditor-content .unstyled:last-child {\n    padding-bottom: 1em; }\n  .Editor3-editor .public-DraftEditor-content .unstyled--over {\n    padding-top: 0;\n    border-top: 1.5em solid rgba(93, 155, 192, 0.3); }\n  .Editor3-editor .public-DraftEditor-content .unstyled + h3[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content .unstyled + h4[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content .unstyled + h5[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content .unstyled + h6[data-block=\"true\"] {\n    padding-top: .4em; }\n  .Editor3-editor .public-DraftEditor-content .unstyled + h1[data-block=\"true\"], .Editor3-editor .public-DraftEditor-content .unstyled + h2[data-block=\"true\"] {\n    padding-top: 0.2em; }\n\n.Editor3-hidePlaceholder .public-DraftEditorPlaceholder-root {\n  display: none; }\n\n.Editor3-editor .Editor3-blockquote {\n  border-left: 5px solid #eee;\n  font-style: italic;\n  margin: 16px 0;\n  padding: 10px 20px; }\n\n.Editor3-editor .public-DraftStyleDefault-pre {\n  background-color: rgba(0, 0, 0, 0.05);\n  font-family: 'Roboto Mono', monospace;\n  padding: 20px; }\n  .Editor3-editor .public-DraftStyleDefault-pre [data-block=\"true\"] {\n    border-bottom: none;\n    margin: 0 0 0.5; }\n\n.Editor3-controls {\n  width: 100%;\n  min-width: 300px;\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 14px !important;\n  user-select: none;\n  background-color: rgba(150, 150, 150, 0.075);\n  border-bottom: 1px solid;\n  border-bottom-color: rgba(150, 150, 150, 0.2);\n  line-height: 100% !important; }\n  .Editor3-controls.disabled * {\n    pointer-events: none; }\n  .Editor3-controls .embed-dialog {\n    color: #333;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 2000;\n    display: flex;\n    align-content: center;\n    flex-direction: row;\n    background-color: #fff;\n    width: 100%;\n    border: 1px solid #dedede;\n    margin: -1px 0px;\n    padding: 4px;\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35); }\n    .Editor3-controls .embed-dialog__error {\n      padding: 3px;\n      font-size: 13px;\n      color: #a80000;\n      font-weight: 400; }\n    .Editor3-controls .embed-dialog input {\n      height: 30px;\n      padding: 8px 47px 8px 15px; }\n  .Editor3-controls .input-controls {\n    flex-grow: 0;\n    display: flex; }\n  .Editor3-controls .link-input {\n    display: block;\n    background: #fff;\n    flex-grow: 1;\n    position: relative; }\n    .Editor3-controls .link-input input[type=\"url\"] {\n      padding: 0px 47px 0px 5px; }\n\n.Editor3-styleButton {\n  color: inherit;\n  cursor: pointer;\n  margin: 0.4rem 0.2rem;\n  height: 3rem;\n  min-width: 3rem;\n  padding: 0.6rem;\n  display: inline-block;\n  border-radius: 1.5rem;\n  text-align: center;\n  line-height: 1.6rem; }\n  .Editor3-styleButton--short {\n    padding-right: 0.2rem;\n    margin-right: -1rem; }\n  .Editor3-styleButton [class*=\"icon-\"] {\n    color: inherit;\n    opacity: 0.5;\n    vertical-align: middle; }\n  .Editor3-styleButton:hover [class*=\"icon-\"] {\n    color: inherit;\n    opacity: 0.9; }\n  .Editor3-styleButton .inactive [class*=\"icon-\"] {\n    opacity: 0.2; }\n  .Editor3-styleButton .inactive:hover [class*=\"icon-\"] {\n    opacity: 0.2; }\n  .Editor3-styleButton.Editor3-activeButton, .Editor3-styleButton.Editor3-activeButton:hover {\n    color: #5890ff;\n    background-color: rgba(0, 0, 0, 0.075); }\n    .Editor3-styleButton.Editor3-activeButton [class*=\"icon-\"], .Editor3-styleButton.Editor3-activeButton:hover [class*=\"icon-\"] {\n      opacity: 1; }\n\n.main-article .dropdown__menu {\n  color: #333; }\n\n.annotation-input .dropdown__menu {\n  width: 465px; }\n\n.annotation-input .Editor3-editor {\n  font-size: 13px;\n  margin-bottom: 10px; }\n  .annotation-input .Editor3-editor .public-DraftEditor-content {\n    padding: 5px 10px 0 10px; }\n    .annotation-input .Editor3-editor .public-DraftEditor-content [data-block=\"true\"] {\n      margin-bottom: 0.7em; }\n    .annotation-input .Editor3-editor .public-DraftEditor-content [data-block=\"true\"]:last-child {\n      margin-bottom: 0.3em; }\n  .annotation-input .Editor3-editor .DraftEditor-root {\n    max-height: 15rem;\n    min-height: 3.6rem;\n    overflow-y: auto; }\n\n/** COMMENTS **/\n.comment-input .dropdown a, .annotation-input .dropdown a {\n  color: #5ea9c8; }\n\n.comment-input .dropdown__menu, .annotation-input .dropdown__menu {\n  padding: 15px; }\n  .comment-input .dropdown__menu label, .annotation-input .dropdown__menu label {\n    margin-bottom: 5px; }\n  .comment-input .dropdown__menu textarea, .annotation-input .dropdown__menu textarea {\n    margin-bottom: 10px; }\n\n.mentions-input {\n  width: 300px;\n  max-width: 100%;\n  margin-bottom: 10px; }\n  .mentions-input__suggestions__item {\n    height: 33px;\n    width: 240px; }\n    .mentions-input__suggestions__item__display {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 175px;\n      white-space: nowrap; }\n  .mentions-input .entry .avatar.initials {\n    width: 21px;\n    height: 21px;\n    margin: 0 5px 0 0;\n    line-height: 21px;\n    font-size: 10px; }\n  .mentions-input .entry .icon-tasks {\n    margin: 0 5px 0 2px;\n    position: relative;\n    top: 2px; }\n\n.comment-textarea {\n  position: relative;\n  overflow: visible; }\n\n.main-article .btn {\n  font-family: 'Roboto', Helvetica, sans-serif; }\n\n.main-article .sd-editor__default-input {\n  border: 1px solid rgba(123, 123, 123, 0.3);\n  border-bottom-color: rgba(123, 123, 123, 0.3);\n  padding: 0;\n  border-radius: 0;\n  background-color: transparent;\n  color: inherit;\n  font-size: 1.4rem;\n  resize: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  box-shadow: none !important;\n  outline: none;\n  padding: 0 0.3rem; }\n  .main-article .sd-editor__default-input--embed {\n    font-size: 1.3rem;\n    font-family: 'Roboto', Helvetica, sans-serif; }\n  .main-article .sd-editor__default-input:hover {\n    border-bottom-color: rgba(123, 123, 123, 0.6); }\n  .main-article .sd-editor__default-input:focus {\n    border-width: 1px !important;\n    border-color: rgba(94, 169, 200, 0.3) !important;\n    border-bottom-color: #5ea9c8 !important;\n    box-shadow: 0 1px 0 #5ea9c8 !important; }\n\n.main-article .sd-editor__info-text {\n  font-size: 1.3rem;\n  font-family: 'Roboto', Helvetica, sans-serif;\n  font-weight: 300;\n  color: inherit;\n  opacity: 0.7;\n  margin: 0.6rem 0; }\n\n.dropdown--link-input .dropdown__menu {\n  padding: 0;\n  max-width: 400px;\n  color: #333; }\n\n.dropdown--link-input .nav-tabs--small {\n  padding: 0 !important; }\n\n.dropdown--link-input .nav-tabs__tab {\n  flex-grow: 1; }\n  .dropdown--link-input .nav-tabs__tab.nav-tabs-small {\n    padding: 0; }\n  .dropdown--link-input .nav-tabs__tab button.nav-tabs__link {\n    text-align: center !important;\n    background-color: transparent !important;\n    margin: 0 !important;\n    cursor: pointer;\n    color: #747474 !important; }\n  .dropdown--link-input .nav-tabs__tab.nav-tabs__tab--active button.nav-tabs__link {\n    cursor: default !important;\n    color: #333 !important; }\n\n.dropdown--link-input .nav-tabs__content {\n  font-weight: 400; }\n  .dropdown--link-input .nav-tabs__content p {\n    font-size: 1.4rem;\n    line-height: 140%;\n    margin-bottom: 0; }\n\n.sd-editor--theme-turquoise .Editor3-controls, .sd-editor--theme-turquoise .item-association, .sd-editor--theme-military .Editor3-controls, .sd-editor--theme-military .item-association {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-bottom-color: rgba(0, 0, 0, 0.1); }\n\n.sd-editor--theme-turquoise .Editor3-root, .sd-editor--theme-turquoise .item-association, .sd-editor--theme-military .Editor3-root, .sd-editor--theme-military .item-association {\n  border-color: rgba(0, 0, 0, 0.1); }\n\n.sd-editor--theme-turquoise .Editor3-styleButton.Editor3-activeButton,\n.sd-editor--theme-turquoise .Editor3-styleButton.Editor3-activeButton:hover, .sd-editor--theme-military .Editor3-styleButton.Editor3-activeButton,\n.sd-editor--theme-military .Editor3-styleButton.Editor3-activeButton:hover {\n  color: #9c27b0; }\n\n.sd-editor--theme-turquoise .Editor3-root .Editor3-controls.floating-toolbar, .sd-editor--theme-military .Editor3-root .Editor3-controls.floating-toolbar {\n  background-color: rgba(255, 255, 255, 0.85); }\n\n.sd-editor--theme-turquoise .DraftEditor-root a, .sd-editor--theme-military .DraftEditor-root a {\n  color: #9c27b0; }\n\n.sd-editor--theme-dark .Editor3-styleButton.Editor3-activeButton,\n.sd-editor--theme-dark .Editor3-styleButton.Editor3-activeButton:hover, .sd-editor--theme-blue .Editor3-styleButton.Editor3-activeButton,\n.sd-editor--theme-blue .Editor3-styleButton.Editor3-activeButton:hover {\n  background-color: rgba(0, 0, 0, 0.3); }\n\n.sd-editor--theme-dark .Editor3-root .Editor3-controls.floating-toolbar, .sd-editor--theme-blue .Editor3-root .Editor3-controls.floating-toolbar {\n  background-color: rgba(51, 51, 51, 0.95); }\n\n.sd-editor--theme-blue .Editor3-root .Editor3-controls.floating-toolbar {\n  background-color: rgba(27, 68, 115, 0.95); }\n\n.sd-editor--theme-turquoise .btn.btn--hollow,\n.sd-editor--theme-military .btn.btn--hollow,\n.sd-editor--theme-dark .btn.btn--hollow,\n.sd-editor--theme-blue .btn.btn--hollow {\n  color: inherit; }\n\n.sd-editor--theme-dark .btn.btn--hollow {\n  border-color: rgba(170, 204, 209, 0.5); }\n  .sd-editor--theme-dark .btn.btn--hollow:hover {\n    border-color: #aaccd1; }\n\n.sd-editor--theme-blue .btn.btn--hollow {\n  border-color: rgba(255, 255, 255, 0.5); }\n  .sd-editor--theme-blue .btn.btn--hollow:hover {\n    border-color: white; }\n\n.sd-editor--theme-blue .Editor3-root .image-block, .sd-editor--theme-blue .Editor3-root .embed-block, .sd-editor--theme-dark .Editor3-root .image-block, .sd-editor--theme-dark .Editor3-root .embed-block {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.25) !important; }\n  .sd-editor--theme-blue .Editor3-root .image-block:hover, .sd-editor--theme-blue .Editor3-root .embed-block:hover, .sd-editor--theme-dark .Editor3-root .image-block:hover, .sd-editor--theme-dark .Editor3-root .embed-block:hover {\n    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.5) !important; }\n\n.sd-editor--theme-blue .media-container, .sd-editor--theme-dark .media-container {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.25) !important; }\n\n.authoring-header__input-editor3 .Editor3-editor .public-DraftEditorPlaceholder-root,\n.authoring-header__input-editor3 .Editor3-editor .public-DraftEditor-content {\n  padding: 3px 0 2px; }\n\n.authoring-header__input-editor3 .Editor3-root {\n  border: none !important; }\n\n.authoring-header__input-editor3 .DraftEditor-root {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  .authoring-header__input-editor3 .DraftEditor-root:hover {\n    border-color: rgba(0, 0, 0, 0.3); }\n  .authoring-header__input-editor3 .DraftEditor-root:focus-within {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important; }\n\n.authoring-header__input-editor3 .Editor3-editor {\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-size: 13px; }\n  .authoring-header__input-editor3 .Editor3-editor.no-toolbar {\n    padding-top: 0; }\n\n.authoring-header__input-editor3 .Editor3-editor .public-DraftEditor-content [data-block=\"true\"] {\n  border-bottom: none; }\n", ""]);

// exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/**\n * Draft v0.10.5\n *\n * Copyright (c) 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:rgba(255,255,255,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:1}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}", ""]);

// exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var action = __importStar(__webpack_require__(24));
var find_replace_1 = __webpack_require__(176);
var find_replace_2 = __webpack_require__(176);
var tansa_1 = __webpack_require__(412);
var editor3StateToHtml_1 = __webpack_require__(88);
/**
 * @type {Object} Redux stores
 * @description Holds the store of the find and replace target
 * of the open article.
 * @private
 */
var store = null;
/**
 * @type {array} Redux stores
 * @description Holds the stores of the editors on the open article
 * if they are spellchecker targets
 * @private
 */
var spellcheckerStores = [];
/**
 * @ngdoc service
 * @module superdesk.core.editor3
 * @name editor3
 * @description editor3 is the service that allows interacting with the editor from
 * the outside. It uses the same interface as the editor service of core/editor2/editor.js
 * to allow plugging one or the other based on the editor of the item being edited.
 */
var EditorService = /** @class */ (function () {
    function EditorService() {
    }
    /**
     * @ngdoc method
     * @name editor3#setStore
     * @param {Object} redux store
     * @description Registers the passed redux store with the service.
     */
    EditorService.prototype.setStore = function (s) {
        if (store !== null) {
            console.warn('You\'ve overwritten the find & replace target.');
        }
        store = s;
    };
    /**
     * @ngdoc method
     * @name editor3#addSpellcheckerStore
     * @param {Object} redux store
     * @description Registers the passed redux store with the spellchecker service
     * @returns {Integer}
     */
    EditorService.prototype.addSpellcheckerStore = function (s) {
        spellcheckerStores.push(s);
        return spellcheckerStores.length - 1;
    };
    /**
     * @ngdoc method
     * @name editor3#version
     * @description Returns the editor version (this is for when using editorResolver).
     * @returns {string}
     */
    EditorService.prototype.version = function () {
        return '3';
    };
    /**
     * @ngdoc method
     * @name editor3#unsetStore
     * @description Clears the find and replace store.
     */
    EditorService.prototype.unsetStore = function () {
        store = null;
    };
    /**
     * @ngdoc method
     * @name editor3#removeSpellcheckerStore
     * @param {Integer}
     * @description Clears a spellchecker store
     */
    EditorService.prototype.removeSpellcheckerStore = function (i) {
        spellcheckerStores.slice(i, 1);
    };
    /**
     * @ngdoc method
     * @name editor3#selectNext
     * @description Triggers the action to select the next occurence of the search
     * criteria in the editor.
     */
    EditorService.prototype.selectNext = function () {
        if (ok()) {
            store.dispatch(action.findNext());
        }
    };
    /**
     * @ngdoc method
     * @name editor3#selectPrev
     * @description Triggers the action to select the previous occurence of the search
     * criteria in the editor.
     */
    EditorService.prototype.selectPrev = function () {
        if (ok()) {
            store.dispatch(action.findPrev());
        }
    };
    /**
     * @ngdoc method
     * @name editor3#replace
     * @param {string} txt
     * @description Replaces the currently highlighted search criteria with the given text.
     */
    EditorService.prototype.replace = function (txt) {
        if (ok()) {
            store.dispatch(action.replace(txt));
        }
    };
    /**
     * @ngdoc method
     * @name editor3#replace
     * @param {string} txt
     * @description Replaces all the search criteria with the given text.
     */
    EditorService.prototype.replaceAll = function (txt) {
        if (ok()) {
            store.dispatch(action.replaceAll(txt));
        }
    };
    /**
     * @ngdoc method
     * @name editor3#setSettings
     * @param {Object} The setting can be findreplace or spellcheck; findreplace is an object containing the keys
     * caseSensitive (boolean) and diff (object having one or multiple keys that is the diff).
     * @description Updates the settings for editor3.
     */
    EditorService.prototype.setSettings = function (_a) {
        var findreplace = _a.findreplace, spellcheck = _a.spellcheck;
        if (!ok()) {
            return;
        }
        if (typeof findreplace !== 'undefined') {
            store.dispatch(action.setHighlightCriteria(findreplace || {}));
        }
        if (typeof spellcheck !== 'undefined') {
            spellcheckerStores.map(function (s) { return s.dispatch(action.setAutoSpellchecker(spellcheck)); });
        }
    };
    /**
     * @ngdoc method
     * @name editor3#render
     * @description Highlights the current search criteria in the editor.
     */
    EditorService.prototype.render = function () {
        if (ok()) {
            store.dispatch(action.renderHighlights());
        }
    };
    /**
     * @ngdoc method
     * @name editor3#getActiveText
     * @description Gets the text under the current selection.
     */
    EditorService.prototype.getActiveText = function () {
        if (!ok()) {
            return;
        }
        var state = store.getState();
        var editorState = state.editorState, searchTerm = state.searchTerm;
        var index = searchTerm.index, pattern = searchTerm.pattern, caseSensitive = searchTerm.caseSensitive;
        var content = editorState.getCurrentContent();
        var txt = pattern;
        // find the active match
        find_replace_1.forEachMatch(content, pattern, caseSensitive, function (i, selection, block, newContent) {
            if (i === index) {
                var start = selection.getStartOffset();
                var end = selection.getEndOffset();
                txt = block.getText().slice(start, end);
            }
            return newContent;
        });
        return txt;
    };
    /**
     * @ngdoc method
     * @name editor3#getHTML
     * @description Gets the content of the editor as HTML.
     * @returns {string} HTML
     */
    EditorService.prototype.getHTML = function () {
        if (!ok()) {
            return '';
        }
        var state = store.getState();
        var content = state.editorState.getCurrentContent();
        var cleanedContent = find_replace_2.clearHighlights(content).content;
        return editor3StateToHtml_1.editor3StateToHtml(cleanedContent);
    };
    /**
     * @ngdoc method
     * @name editor3#getHtmlForTansa
     * @description Gets the content of the editor as custom(simplified) html for Tansa.
     * @returns {string} HTML
     */
    EditorService.prototype.getHtmlForTansa = function () {
        if (!ok()) {
            return '';
        }
        var state = store.getState();
        var editorState = state.editorState;
        return tansa_1.getTansaHtml(editorState);
    };
    /**
     * @ngdoc method
     * @name editor3#setHtmlFromTansa
     * @param {string} html
     * @param {string} simpleReplace
     * @description For every block from editor content merge the changes received from tansa.
     * If the simpleReplace is true try to preserve the existing inline styles and entities
     */
    EditorService.prototype.setHtmlFromTansa = function (html, simpleReplace) {
        if (simpleReplace === void 0) { simpleReplace = false; }
        console.info('set', html, ok());
        if (ok()) {
            store.dispatch(action.setHtmlFromTansa(html, simpleReplace));
        }
    };
    return EditorService;
}());
exports.EditorService = EditorService;
function ok() {
    if (store === null) {
        console.error('No editor set as target in service.');
    }
    return store !== null;
}


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc method
 * @name replaceWord
 * @param {String} word
 * @return {String} action
 * @description Creates the replace word action
 */
function replaceWord(word) {
    return {
        type: 'SPELLCHECKER_REPLACE_WORD',
        payload: word,
    };
}
exports.replaceWord = replaceWord;
/**
 * @ngdoc method
 * @name refreshWord
 * @param {String} word
 * @return {String} action
 * @description Refreshes the passed word (usually after having being added
 * to the dictionary).
 */
function refreshWord(word) {
    return {
        type: 'SPELLCHECKER_REFRESH_WORD',
        payload: word,
    };
}
exports.refreshWord = refreshWord;
/**
 * @ngdoc method
 * @name setAutoSpellchecker
 * @param {Boolean} enabled True if the autospellchecker should be enabled
 * @return {String} action
 * @description Enable/disable auto mode for spellchecker.
 */
function setAutoSpellchecker(enabled) {
    return {
        type: 'SPELLCHECKER_AUTO',
        payload: enabled,
    };
}
exports.setAutoSpellchecker = setAutoSpellchecker;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.waitUntil = function (precondition, timeoutAt) {
    if (timeoutAt === void 0) { timeoutAt = 1000 * 60; }
    return new Promise(function (resolve, reject) {
        function checkNow() {
            if (precondition() === true) {
                window.clearInterval(interval);
                resolve();
                return true;
            }
        }
        var interval;
        if (checkNow() === true) {
            // make sure it doesn't register an interval if it resolves on the first go
            return;
        }
        interval = setInterval(checkNow, 100);
        setTimeout(function () {
            clearInterval(interval);
            reject('timed out while trying to resolve a service');
        }, timeoutAt);
    });
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc method
 * @name findNext
 * @param {String} txt Text to find
 * @description Creates the action to find the next occurence of txt.
 */
function findNext() {
    return { type: 'HIGHLIGHTS_FIND_NEXT' };
}
exports.findNext = findNext;
/**
 * @ngdoc method
 * @name findPrev
 * @param {String} txt Text to find
 * @description Creates the action to find the previous occurence of txt.
 */
function findPrev() {
    return { type: 'HIGHLIGHTS_FIND_PREV' };
}
exports.findPrev = findPrev;
/**
 * @ngdoc method
 * @name replace
 * @param {String} from Text to replace from
 * @param {String} to Text to replace to
 * @description Creates the action to replace the current highlight from from to to.
 */
function replace(withTxt) {
    return {
        type: 'HIGHLIGHTS_REPLACE',
        payload: withTxt,
    };
}
exports.replace = replace;
/**
 * @ngdoc method
 * @name replaceAll
 * @param {String} from Text to replace from
 * @param {String} to Text to replace to
 * @description Creates the action to replace all occurences of from to to.
 */
function replaceAll(withTxt) {
    return {
        type: 'HIGHLIGHTS_REPLACE_ALL',
        payload: withTxt,
    };
}
exports.replaceAll = replaceAll;
/**
 * @ngdoc method
 * @name renderHighlights
 * @description Creates the action to re-render all the highlights.
 */
function renderHighlights() {
    return { type: 'HIGHLIGHTS_RENDER' };
}
exports.renderHighlights = renderHighlights;
/**
 * @ngdoc method
 * @name setSearchSettings
 * @description Creates the action to set new search settings
 */
function setHighlightCriteria(opts) {
    return {
        type: 'HIGHLIGHTS_CRITERIA',
        payload: opts,
    };
}
exports.setHighlightCriteria = setHighlightCriteria;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc method
 * @name addTable
 * @param {Number} numRows
 * @param {Number} numCols
 * @description Dispatches the action that adds a table into the content.
 */
function addTable(numRows, numCols) {
    if (numRows === void 0) { numRows = 1; }
    if (numCols === void 0) { numCols = 2; }
    var cells = [];
    var withHeader = false;
    return {
        type: 'TOOLBAR_ADD_TABLE',
        payload: { numRows: numRows, numCols: numCols, cells: cells, withHeader: withHeader },
    };
}
exports.addTable = addTable;
/**
 * @ngdoc method
 * @name addRowAfter
 * @description Dispatches the action to add a row after the currently active one.
 */
function addRowAfter() {
    return { type: 'TOOLBAR_ADD_ROW_AFTER' };
}
exports.addRowAfter = addRowAfter;
/**
 * @ngdoc method
 * @name addColAfter
 * @description Dispatches the action to add a column after the currently active one.
 */
function addColAfter() {
    return { type: 'TOOLBAR_ADD_COL_AFTER' };
}
exports.addColAfter = addColAfter;
/**
 * @ngdoc method
 * @name removeRow
 * @description Dispatches the action to remove the current row.
 */
function removeRow() {
    return { type: 'TOOLBAR_REMOVE_ROW' };
}
exports.removeRow = removeRow;
/**
 * @ngdoc method
 * @name removeCol
 * @description Dispatches the action to remove the current column.
 */
function removeCol() {
    return { type: 'TOOLBAR_REMOVE_COL' };
}
exports.removeCol = removeCol;
/**
 * @ngdoc method
 * @name toggleTableHeader
 * @description Toggles the tables header (enabled or disables the rendering of a header).
 * When exporting HTML, thead/th & tbody are used, if on.
 */
function toggleTableHeader() {
    return { type: 'TOOLBAR_TABLE_HEADER' };
}
exports.toggleTableHeader = toggleTableHeader;
/**
 * @ngdoc method
 * @name toggleTableStyle
 * @description Toggles the style on current cell.
 */
function toggleTableStyle(inlineStyle) {
    return {
        type: 'TOOLBAR_TABLE_STYLE',
        payload: inlineStyle,
    };
}
exports.toggleTableStyle = toggleTableStyle;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
function getAuthorInfo() {
    var date = new Date();
    var _a = ng_1.default.get('session').identity, authorId = _a._id, author = _a.display_name, email = _a.email, avatar = _a.picture_url;
    return {
        authorId: authorId,
        author: author,
        email: email,
        date: date,
        avatar: avatar,
    };
}
exports.getAuthorInfo = getAuthorInfo;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @typedef PopupMeta
 * @property {Key<PopupType>} type Popup type
 * @property {Object} data Information required by this popup type (for example
 * a selection for adding the comment or annotation too)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupTypes = {
    Hidden: 'NONE',
    Annotation: 'ANNOTATION',
    Comment: 'COMMENT',
    Link: 'LINK',
    Embed: 'EMBED',
};
/**
 * @name showPopup
 * @param {PopupTypes} type The type of pop-up to show.
 * @param {Object} data Data to pass to the popup.
 * @description Triggers the action to show the popup of the given type having the
 * given data attached.
 * @return {Object}
 */
function showPopup(type, data) {
    return {
        type: 'TOOLBAR_SET_POPUP',
        payload: { type: type, data: data },
    };
}
exports.showPopup = showPopup;
/**
 * @name hidePopup
 * @description Hides any active toolbar popup.
 * @return {Object}
 */
function hidePopups() {
    return showPopup(exports.PopupTypes.Hidden);
}
exports.hidePopups = hidePopups;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BlockMapBuilder = __webpack_require__(108);
var CharacterMetadata = __webpack_require__(40);
var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var DraftFeatureFlags = __webpack_require__(65);
var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var Immutable = __webpack_require__(19);
var SelectionState = __webpack_require__(85);

var generateRandomKey = __webpack_require__(60);
var moveBlockInContentState = __webpack_require__(790);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _extends({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'move-block');
  }
};

module.exports = AtomicBlockUtils;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */



var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

module.exports = DraftFeatureFlags;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(40);

var _require = __webpack_require__(19),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(19);

var applyEntityToContentBlock = __webpack_require__(779);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(40);

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @format
 * 
 */



var DraftEntitySegments = __webpack_require__(781);

var getRangesForDraftEntity = __webpack_require__(782);
var invariant = __webpack_require__(17);

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */



/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

module.exports = DraftEntitySegments;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @format
 * 
 */



var invariant = __webpack_require__(17);

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;

  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(108);
var ContentBlockNode = __webpack_require__(45);
var Immutable = __webpack_require__(19);

var insertIntoList = __webpack_require__(388);
var invariant = __webpack_require__(17);
var randomizeBlockMapKeys = __webpack_require__(386);

var List = Immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(19);

var insertIntoList = __webpack_require__(388);
var invariant = __webpack_require__(17);

var Repeat = Immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(19);

var Map = Immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(45);
var Immutable = __webpack_require__(19);

var getNextDelimiterBlockKey = __webpack_require__(389);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(45);
var Immutable = __webpack_require__(19);

var generateRandomKey = __webpack_require__(60);
var invariant = __webpack_require__(17);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update original next block
    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;

    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @format
 * 
 */



var Immutable = __webpack_require__(19);
var UnicodeBidiService = __webpack_require__(789);

var nullthrows = __webpack_require__(47);

var OrderedMap = Immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

module.exports = EditorBidiService;

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnicodeBidi = __webpack_require__(392);
var UnicodeBidiDirection = __webpack_require__(179);

var invariant = __webpack_require__(17);

var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(45);
var Immutable = __webpack_require__(19);

var getNextDelimiterBlockKey = __webpack_require__(389);
var invariant = __webpack_require__(17);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Immutable = __webpack_require__(19);

var List = Immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @format
 * 
 * @preventMunge
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(180);
var DefaultDraftInlineStyle = __webpack_require__(393);
var DraftEditorCompositionHandler = __webpack_require__(793);
var DraftEditorContents = __webpack_require__(794);
var DraftEditorDragHandler = __webpack_require__(814);
var DraftEditorEditHandler = __webpack_require__(817);
var DraftEditorPlaceholder = __webpack_require__(850);
var EditorState = __webpack_require__(20);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var Scroll = __webpack_require__(396);
var Style = __webpack_require__(183);
var UserAgent = __webpack_require__(50);

var cx = __webpack_require__(86);
var emptyFunction = __webpack_require__(76);
var generateRandomKey = __webpack_require__(60);
var getDefaultKeyBinding = __webpack_require__(409);
var getScrollPosition = __webpack_require__(184);
var invariant = __webpack_require__(17);
var nullthrows = __webpack_require__(47);

var isIE = UserAgent.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck(this, DraftEditor);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React.createElement(
        'div',
        {
          className: cx('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React.createElement(DraftEditorContents, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: emptyFunction.thatReturnsNull,
  blockStyleFn: emptyFunction.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


module.exports = DraftEditor;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(65);
var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var Keys = __webpack_require__(181);

var getEntityKeyForSelection = __webpack_require__(182);
var isEventHandled = __webpack_require__(110);
var isSelectionAtLeafStart = __webpack_require__(394);

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */



var DraftEditorContents = __webpack_require__(795);

module.exports = DraftEditorContents;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents-core.react
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(395);
var DraftOffsetKey = __webpack_require__(131);
var EditorState = __webpack_require__(20);
var React = __webpack_require__(0);

var cx = __webpack_require__(86);
var joinClasses = __webpack_require__(813);
var nullthrows = __webpack_require__(47);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck(this, DraftEditorContents);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @format
 * 
 */



var _assign = __webpack_require__(44);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorTextNode = __webpack_require__(797);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);

var invariant = __webpack_require__(17);
var setDraftEditorSelection = __webpack_require__(803);

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck(this, DraftEditorLeaf);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = ReactDOM.findDOMNode(this);
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React.createElement(
        DraftEditorTextNode,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(15);
var UserAgent = __webpack_require__(50);

var invariant = __webpack_require__(17);

// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */



var UAParser = __webpack_require__(799);

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new UAParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

module.exports = uaData;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.20',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ], [NAME, VERSION], [

            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
            ], [[NAME, 'Konqueror'], VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
            ], [[NAME, 'Sailfish Browser'], VERSION], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
            ], [[TYPE, SMARTTV]], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)/i                                  // Blink
            ], [[NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var invariant = __webpack_require__(17);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

module.exports = VersionRange;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @format
 * 
 */



var DraftJsDebugLogging = __webpack_require__(804);

var containsNode = __webpack_require__(128);
var getActiveElement = __webpack_require__(168);
var invariant = __webpack_require__(17);

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode(document.documentElement, node)) {
    return;
  }

  var selection = global.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  if (selection.extend && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

module.exports = setDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */



module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var camelize = __webpack_require__(806);
var hyphenate = __webpack_require__(807);

function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name)]);
  }
  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getElementRect = __webpack_require__(809);

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var containsNode = __webpack_require__(128);

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @format
 * 
 */



var DataTransfer = __webpack_require__(397);
var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);

var findAncestorOffsetKey = __webpack_require__(185);
var getTextContentFromFiles = __webpack_require__(399);
var getUpdatedSelectionState = __webpack_require__(400);
var isEventHandled = __webpack_require__(110);
var nullthrows = __webpack_require__(47);

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));

  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(17);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * @format
 * 
 */



var onBeforeInput = __webpack_require__(818);
var onBlur = __webpack_require__(821);
var onCompositionStart = __webpack_require__(822);
var onCopy = __webpack_require__(823);
var onCut = __webpack_require__(824);
var onDragOver = __webpack_require__(825);
var onDragStart = __webpack_require__(826);
var onFocus = __webpack_require__(827);
var onInput = __webpack_require__(828);
var onKeyDown = __webpack_require__(829);
var onPaste = __webpack_require__(843);
var onSelect = __webpack_require__(848);

var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect
};

module.exports = DraftEditorEditHandler;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * @format
 * 
 */



var BlockTree = __webpack_require__(390);
var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var UserAgent = __webpack_require__(50);

var getEntityKeyForSelection = __webpack_require__(182);
var isEventHandled = __webpack_require__(110);
var isSelectionAtLeafStart = __webpack_require__(394);
var nullthrows = __webpack_require__(47);
var setImmediate = __webpack_require__(819);

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = global.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(820);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29), __webpack_require__(174)))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

var containsNode = __webpack_require__(128);
var getActiveElement = __webpack_require__(168);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement() === document.body) {
    var _selection = global.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * @format
 * 
 */



var getFragmentFromSelection = __webpack_require__(401);

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var Style = __webpack_require__(183);

var getFragmentFromSelection = __webpack_require__(401);
var getScrollPosition = __webpack_require__(184);

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition(Style.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */



/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */



/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * @format
 * 
 */



var EditorState = __webpack_require__(20);
var UserAgent = __webpack_require__(50);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(65);
var DraftModifier = __webpack_require__(37);
var DraftOffsetKey = __webpack_require__(131);
var EditorState = __webpack_require__(20);
var UserAgent = __webpack_require__(50);

var findAncestorOffsetKey = __webpack_require__(185);
var nullthrows = __webpack_require__(47);

var isGecko = UserAgent.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = global.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);
var KeyBindingUtil = __webpack_require__(186);
var Keys = __webpack_require__(181);
var SecondaryClipboard = __webpack_require__(830);
var UserAgent = __webpack_require__(50);

var isEventHandled = __webpack_require__(110);
var keyCommandBackspaceToStartOfLine = __webpack_require__(831);
var keyCommandBackspaceWord = __webpack_require__(833);
var keyCommandDeleteWord = __webpack_require__(835);
var keyCommandInsertNewline = __webpack_require__(836);
var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(837);
var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(838);
var keyCommandPlainBackspace = __webpack_require__(839);
var keyCommandPlainDelete = __webpack_require__(840);
var keyCommandTransposeCharacters = __webpack_require__(841);
var keyCommandUndo = __webpack_require__(842);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;

var isChrome = UserAgent.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete(editorState);
    case 'delete-word':
      return keyCommandDeleteWord(editorState);
    case 'backspace':
      return keyCommandPlainBackspace(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState);
    case 'split-block':
      return keyCommandInsertNewline(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);

var getContentStateFragment = __webpack_require__(129);
var nullthrows = __webpack_require__(47);

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange);
    clipboard = getContentStateFragment(content, targetRange);

    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};

module.exports = SecondaryClipboard;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

var expandRangeToStartOfLine = __webpack_require__(832);
var getDraftEditorSelectionWithNodes = __webpack_require__(403);
var moveSelectionBackward = __webpack_require__(187);
var removeTextWithStrategy = __webpack_require__(111);

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var domSelection = global.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);

    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

var UnicodeUtils = __webpack_require__(78);

var getRangeClientRects = __webpack_require__(402);
var invariant = __webpack_require__(17);

/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(404);
var EditorState = __webpack_require__(20);

var moveSelectionBackward = __webpack_require__(187);
var removeTextWithStrategy = __webpack_require__(111);

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */



// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(404);
var EditorState = __webpack_require__(20);

var moveSelectionForward = __webpack_require__(405);
var removeTextWithStrategy = __webpack_require__(111);

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * @format
 * 
 */



var EditorState = __webpack_require__(20);
var UnicodeUtils = __webpack_require__(78);

var moveSelectionBackward = __webpack_require__(187);
var removeTextWithStrategy = __webpack_require__(111);

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * @format
 * 
 */



var EditorState = __webpack_require__(20);
var UnicodeUtils = __webpack_require__(78);

var moveSelectionForward = __webpack_require__(405);
var removeTextWithStrategy = __webpack_require__(111);

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * @format
 * 
 */



var DraftModifier = __webpack_require__(37);
var EditorState = __webpack_require__(20);

var getContentStateFragment = __webpack_require__(129);

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');

  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * @format
 * 
 */



var EditorState = __webpack_require__(20);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(108);
var CharacterMetadata = __webpack_require__(40);
var DataTransfer = __webpack_require__(397);
var DraftModifier = __webpack_require__(37);
var DraftPasteProcessor = __webpack_require__(844);
var EditorState = __webpack_require__(20);
var RichTextEditorUtil = __webpack_require__(408);

var getEntityKeyForSelection = __webpack_require__(182);
var getTextContentFromFiles = __webpack_require__(399);
var isEventHandled = __webpack_require__(110);
var splitTextIntoTextBlocks = __webpack_require__(847);

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);

        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CharacterMetadata = __webpack_require__(40);
var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var DraftFeatureFlags = __webpack_require__(65);
var Immutable = __webpack_require__(19);

var convertFromHTMLtoContentBlocks = __webpack_require__(406);
var generateRandomKey = __webpack_require__(60);
var getSafeBodyFromHTML = __webpack_require__(407);
var sanitizeDraftText = __webpack_require__(178);

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));

      return acc;
    }, []);
  }
};

module.exports = DraftPasteProcessor;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */



function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */



var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * @format
 * 
 */



var EditorState = __webpack_require__(20);
var ReactDOM = __webpack_require__(15);

var getDraftEditorSelection = __webpack_require__(849);
var invariant = __webpack_require__(17);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @format
 * 
 */



var getDraftEditorSelectionWithNodes = __webpack_require__(403);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = global.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

module.exports = getDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(86);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        'div',
        {
          className: cx('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var DraftStringKey = __webpack_require__(410);

var encodeEntityRanges = __webpack_require__(852);
var encodeInlineStyleRanges = __webpack_require__(853);
var invariant = __webpack_require__(17);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @format
 * 
 */



var DraftStringKey = __webpack_require__(410);
var UnicodeUtils = __webpack_require__(78);

var strlen = UnicodeUtils.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(78);

var findRangesImmutable = __webpack_require__(109);

var areEqual = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable(filteredInlines, areEqual,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * @format
 * 
 */



var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(77);
var ContentBlockNode = __webpack_require__(45);
var ContentState = __webpack_require__(177);
var DraftEntity = __webpack_require__(130);
var DraftFeatureFlags = __webpack_require__(65);
var DraftTreeAdapter = __webpack_require__(855);
var Immutable = __webpack_require__(19);
var SelectionState = __webpack_require__(85);

var createCharacterList = __webpack_require__(856);
var decodeEntityRanges = __webpack_require__(857);
var decodeInlineStyleRanges = __webpack_require__(858);
var generateRandomKey = __webpack_require__(60);
var invariant = __webpack_require__(17);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends({}, block, {
    key: block.key || generateRandomKey()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());

  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(44);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var invariant = __webpack_require__(17);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

module.exports = DraftTreeAdapter;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(40);
var Immutable = __webpack_require__(19);

var List = Immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({ style: style, entity: entity });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(78);

var substr = UnicodeUtils.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @format
 * 
 */



var _require = __webpack_require__(19),
    OrderedSet = _require.OrderedSet;

var UnicodeUtils = __webpack_require__(78);

var substr = UnicodeUtils.substr;


var EMPTY_SET = OrderedSet();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @format
 * 
 */



var getRangeBoundingClientRect = __webpack_require__(860);

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @format
 * 
 */



var getRangeClientRects = __webpack_require__(402);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockKeys = function (contentState, start, end) { return contentState
    .getBlockMap()
    .keySeq()
    .skipUntil(function (k) { return k === start; })
    .takeUntil(function (k) { return k === end; }).concat([
    end,
]); };


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(87);
exports.getSelectedBlocks = function (editorState) {
    var selectionState = editorState.getSelection();
    return _1.getBlockKeys(editorState.getCurrentContent(), selectionState.getStartKey(), selectionState.getEndKey());
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(87);
exports.blockInsideSelection = function (editorState, key) {
    return _1.getSelectedBlocks(editorState)
        .includes(key);
};


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
/**
 * @ngdoc method
 * @name initSelectionIterator
 * @param {Object} editorState
 * @return {Object} returns new state
 * @description Change selection to point at the beginning of existent selection.
 */
function initSelectionIterator(editorState, backward) {
    if (backward === void 0) { backward = false; }
    var selection = editorState.getSelection();
    var newSelection;
    if (backward) {
        newSelection = selection.merge({
            anchorOffset: selection.getEndOffset(),
            anchorKey: selection.getEndKey(),
            focusOffset: selection.getEndOffset(),
            focusKey: selection.getEndKey(),
            isBackward: false,
        });
    }
    else {
        newSelection = selection.merge({
            anchorOffset: selection.getStartOffset(),
            anchorKey: selection.getStartKey(),
            focusOffset: selection.getStartOffset(),
            focusKey: selection.getStartKey(),
            isBackward: false,
        });
    }
    return draft_js_1.EditorState.acceptSelection(editorState, newSelection);
}
exports.initSelectionIterator = initSelectionIterator;
/**
 * @ngdoc method
 * @name hasNextSelection
 * @param {Object} editorState
 * @param {Object} selection - the selection to compare with
 * @return {Boolean} returns true if selection has the same end
 * @description Check if the current selection and the received one has the same end/start.
 */
function hasNextSelection(editorState, selection, backward) {
    if (backward === void 0) { backward = false; }
    var currentSelection = editorState.getSelection();
    var content = editorState.getCurrentContent();
    var startBlock = content.getBlockForKey(selection.getStartKey());
    var endBlock = content.getBlockForKey(selection.getEndKey());
    if (startBlock == null && backward || endBlock == null && !backward) {
        throw new Error('The following selection is invalid: ' + selection);
    }
    if (backward) {
        return selection.getStartOffset() < currentSelection.getStartOffset() ||
            selection.getStartKey() !== currentSelection.getStartKey();
    }
    else {
        return selection.getEndOffset() > currentSelection.getEndOffset() ||
            selection.getEndKey() !== currentSelection.getEndKey();
    }
}
exports.hasNextSelection = hasNextSelection;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Collapse selection to the start
 *
 * @param {SelectionState} selection
 * @returns {SelectionState}
 */
function collapseSelection(selection) {
    if (selection.isCollapsed()) {
        return selection;
    }
    return selection.merge({
        isBackward: false,
        anchorKey: selection.getStartKey(),
        anchorOffset: selection.getStartOffset(),
        focusKey: selection.getStartKey(),
        focusOffset: selection.getStartOffset(),
    });
}
exports.collapseSelection = collapseSelection;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Create a selection that contains the block
 *
 * @param {EditorState} editorState
 * @param {Block} block
 * @returns {SelectionState}
 */
function createBlockSelection(editorState, block) {
    var selection = editorState.getSelection();
    return selection.merge({
        anchorKey: block.getKey(),
        anchorOffset: 0,
        focusKey: block.getKey(),
        focusOffset: block.getLength(),
        isBackward: false,
    });
}
exports.createBlockSelection = createBlockSelection;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AtomicBlockParser_1 = __webpack_require__(868);
exports.AtomicBlockParser = AtomicBlockParser_1.AtomicBlockParser;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var QumuWidget_1 = __webpack_require__(414);
var logger_1 = __webpack_require__(415);
var tableHelpers = __importStar(__webpack_require__(112));
var editor3StateToHtml_1 = __webpack_require__(88);
/**
 * @ngdoc class
 * @name AtomicBlockParser
 * @description AtomicBlockParser is a helper class for `editor3StateToHtml`. It parses
 * Editor3 atomic blocks (image, table, embed, etc.).
 * @param {Object} contentState
 * @param {Array=} disabled A set of disabled elements (ie. ['table'] will ignore tables.
 */
var AtomicBlockParser = /** @class */ (function () {
    function AtomicBlockParser(contentState, disabled) {
        if (disabled === void 0) { disabled = []; }
        this.contentState = contentState;
        this.disabled = disabled;
        this.rawState = draft_js_1.convertToRaw(contentState);
    }
    /**
     * @ngdoc method
     * @name AtomicBlockParser#parse
     * @param {Object} contentBlock
     * @returns {string} HTML
     * @description Returns the HTML representation of the passed contentBlock.
     */
    AtomicBlockParser.prototype.parse = function (contentBlock) {
        var entityKey = contentBlock.getEntityAt(0);
        if (!entityKey) {
            return;
        }
        var entity = this.contentState.getEntity(entityKey);
        var data = entity.getData();
        var rawKey = this.getRawKey(data);
        switch (entity.getType()) {
            case 'MEDIA':
                return this.parseMedia(data, rawKey).trim();
            case 'EMBED':
                return this.parseEmbed(data).trim();
            case 'TABLE':
                return this.parseTable(tableHelpers.getData(this.contentState, contentBlock.getKey())).trim();
            default:
                logger_1.logger.warn("Editor3: Cannot generate HTML for entity type of " + entity.getType(), data);
        }
    };
    /**
     * Get entity key from raw state, which will be sent to backend and which is used for associations
     *
     * @param {Object} data
     * @return Number
     */
    AtomicBlockParser.prototype.getRawKey = function (data) {
        var _this = this;
        return Object.keys(this.rawState.entityMap).find(function (key) { return _this.rawState.entityMap[key].data === data; });
    };
    /**
     * @ngdoc method
     * @name AtomicBlockParser#parseEmbed
     * @param {Object} data Entity data.
     * @returns {string} HTML
     * @description Returns the HTML representation of an atomic 'EMBED' block having
     * the passed entity data.
     */
    AtomicBlockParser.prototype.parseEmbed = function (_a) {
        var data = _a.data, description = _a.description;
        var html = data.html;
        var descriptionHtml = typeof description === 'string' && description.length > 0
            ? "<p>" + description + "</p>"
            : '';
        var finalHtml = QumuWidget_1.isQumuWidget(html) ? QumuWidget_1.postProccessQumuEmbed(html) : data.html;
        return "<div class=\"embed-block\">" + finalHtml + descriptionHtml + "</div>";
    };
    /**
     * @ngdoc method
     * @name AtomicBlockParser#parseMedia
     * @param {Object} data Entity data.
     * @param {String} rawKey Entity output key.
     * @returns {string} HTML
     * @description Returns the HTML representation of an atomic 'MEDIA' block having
     * the passed entity data.
     */
    AtomicBlockParser.prototype.parseMedia = function (data, rawKey) {
        var media = data.media;
        var rendition = media.renditions.original || media.renditions.viewImage;
        var href = rendition.href;
        var alt = media.alt_text || '';
        var mediaType = media.type;
        var type, content, desc = media.description_text;
        switch (mediaType) {
            case 'video':
                type = 'Video';
                content = "<video controls src=\"" + href + "\" alt=\"" + alt + "\" width=\"100%\" height=\"100%\" />";
                break;
            case 'audio':
                type = 'Audio';
                content = "<audio controls src=\"" + href + "\" alt=\"" + alt + "\" width=\"100%\" height=\"100%\" />";
                break;
            default:
                type = 'Image';
                content = "<img src=\"" + href + "\" alt=\"" + alt + "\" />";
        }
        return this.formatEmbed(type, rawKey, content, desc);
    };
    AtomicBlockParser.prototype.formatEmbed = function (type, key, content, desc) {
        var id = type + " {id: \"editor_" + key + "\"}";
        if (desc) {
            // eslint-disable-next-line
            content += "\n    <figcatpion>" + desc + "</figcaption>";
        }
        return "\n<!-- EMBED START " + id + " -->\n<figure>\n    " + content + "\n</figure>\n<!-- EMBED END " + id + " -->\n";
    };
    /**
     * @ngdoc method
     * @name AtomicBlockParser#parseTable
     * @param {Object} data Entity data.
     * @returns {string} HTML
     * @description Returns the HTML representation of an atomic 'TABLE' block having
     * the passed entity data.
     */
    AtomicBlockParser.prototype.parseTable = function (data) {
        if (this.disabled.indexOf('table') > -1) {
            return '';
        }
        var numRows = data.numRows, numCols = data.numCols, cells = data.cells, withHeader = data.withHeader;
        var getCell = function (i, j) {
            var cellContentState = cells[i] && cells[i][j]
                ? draft_js_1.convertFromRaw(cells[i][j])
                : draft_js_1.ContentState.createFromText('');
            return editor3StateToHtml_1.editor3StateToHtml(cellContentState, ['table']);
        };
        var html = '<table>';
        var startRow = 0;
        if (withHeader) {
            html += '<thead><tr>';
            for (var j = 0; j < numCols; j++) {
                html += "<th>" + getCell(0, j) + "</th>";
            }
            html += '</tr></thead>';
            startRow = 1;
        }
        if (!withHeader || withHeader && numRows > 1) {
            html += '<tbody>';
            for (var i = startRow; i < numRows; i++) {
                html += '<tr>';
                for (var j = 0; j < numCols; j++) {
                    html += "<td>" + getCell(i, j) + "</td>";
                }
                html += '</tr>';
            }
            html += '</tbody>';
        }
        html += '</table>';
        return html;
    };
    return AtomicBlockParser;
}());
exports.AtomicBlockParser = AtomicBlockParser;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// json5.js
// Modern JSON. See README.md for details.
//
// This file is based directly off of Douglas Crockford's json_parse.js:
// https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js

var JSON5 = ( true ? exports : {});

JSON5.parse = (function () {
    "use strict";

// This is a function that can parse a JSON5 text, producing a JavaScript
// data structure. It is a simple, recursive descent parser. It does not use
// eval or regular expressions, so it can be used as a model for implementing
// a JSON5 parser in other languages.

// We are defining the function inside of another function to avoid creating
// global variables.

    var at,           // The index of the current character
        lineNumber,   // The current line number
        columnNumber, // The current column number
        ch,           // The current character
        escapee = {
            "'":  "'",
            '"':  '"',
            '\\': '\\',
            '/':  '/',
            '\n': '',       // Replace escaped newlines in strings w/ empty string
            b:    '\b',
            f:    '\f',
            n:    '\n',
            r:    '\r',
            t:    '\t'
        },
        ws = [
            ' ',
            '\t',
            '\r',
            '\n',
            '\v',
            '\f',
            '\xA0',
            '\uFEFF'
        ],
        text,

        renderChar = function (chr) {
            return chr === '' ? 'EOF' : "'" + chr + "'";
        },

        error = function (m) {

// Call error when something is wrong.

            var error = new SyntaxError();
            // beginning of message suffix to agree with that provided by Gecko - see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse
            error.message = m + " at line " + lineNumber + " column " + columnNumber + " of the JSON5 data. Still to read: " + JSON.stringify(text.substring(at - 1, at + 19));
            error.at = at;
            // These two property names have been chosen to agree with the ones in Gecko, the only popular
            // environment which seems to supply this info on JSON.parse
            error.lineNumber = lineNumber;
            error.columnNumber = columnNumber;
            throw error;
        },

        next = function (c) {

// If a c parameter is provided, verify that it matches the current character.

            if (c && c !== ch) {
                error("Expected " + renderChar(c) + " instead of " + renderChar(ch));
            }

// Get the next character. When there are no more characters,
// return the empty string.

            ch = text.charAt(at);
            at++;
            columnNumber++;
            if (ch === '\n' || ch === '\r' && peek() !== '\n') {
                lineNumber++;
                columnNumber = 0;
            }
            return ch;
        },

        peek = function () {

// Get the next character without consuming it or
// assigning it to the ch varaible.

            return text.charAt(at);
        },

        identifier = function () {

// Parse an identifier. Normally, reserved words are disallowed here, but we
// only use this for unquoted object keys, where reserved words are allowed,
// so we don't check for those here. References:
// - http://es5.github.com/#x7.6
// - https://developer.mozilla.org/en/Core_JavaScript_1.5_Guide/Core_Language_Features#Variables
// - http://docstore.mik.ua/orelly/webprog/jscript/ch02_07.htm
// TODO Identifiers can have Unicode "letters" in them; add support for those.

            var key = ch;

            // Identifiers must start with a letter, _ or $.
            if ((ch !== '_' && ch !== '$') &&
                    (ch < 'a' || ch > 'z') &&
                    (ch < 'A' || ch > 'Z')) {
                error("Bad identifier as unquoted key");
            }

            // Subsequent characters can contain digits.
            while (next() && (
                    ch === '_' || ch === '$' ||
                    (ch >= 'a' && ch <= 'z') ||
                    (ch >= 'A' && ch <= 'Z') ||
                    (ch >= '0' && ch <= '9'))) {
                key += ch;
            }

            return key;
        },

        number = function () {

// Parse a number value.

            var number,
                sign = '',
                string = '',
                base = 10;

            if (ch === '-' || ch === '+') {
                sign = ch;
                next(ch);
            }

            // support for Infinity (could tweak to allow other words):
            if (ch === 'I') {
                number = word();
                if (typeof number !== 'number' || isNaN(number)) {
                    error('Unexpected word for number');
                }
                return (sign === '-') ? -number : number;
            }

            // support for NaN
            if (ch === 'N' ) {
              number = word();
              if (!isNaN(number)) {
                error('expected word to be NaN');
              }
              // ignore sign as -NaN also is NaN
              return number;
            }

            if (ch === '0') {
                string += ch;
                next();
                if (ch === 'x' || ch === 'X') {
                    string += ch;
                    next();
                    base = 16;
                } else if (ch >= '0' && ch <= '9') {
                    error('Octal literal');
                }
            }

            switch (base) {
            case 10:
                while (ch >= '0' && ch <= '9' ) {
                    string += ch;
                    next();
                }
                if (ch === '.') {
                    string += '.';
                    while (next() && ch >= '0' && ch <= '9') {
                        string += ch;
                    }
                }
                if (ch === 'e' || ch === 'E') {
                    string += ch;
                    next();
                    if (ch === '-' || ch === '+') {
                        string += ch;
                        next();
                    }
                    while (ch >= '0' && ch <= '9') {
                        string += ch;
                        next();
                    }
                }
                break;
            case 16:
                while (ch >= '0' && ch <= '9' || ch >= 'A' && ch <= 'F' || ch >= 'a' && ch <= 'f') {
                    string += ch;
                    next();
                }
                break;
            }

            if(sign === '-') {
                number = -string;
            } else {
                number = +string;
            }

            if (!isFinite(number)) {
                error("Bad number");
            } else {
                return number;
            }
        },

        string = function () {

// Parse a string value.

            var hex,
                i,
                string = '',
                delim,      // double quote or single quote
                uffff;

// When parsing for string values, we must look for ' or " and \ characters.

            if (ch === '"' || ch === "'") {
                delim = ch;
                while (next()) {
                    if (ch === delim) {
                        next();
                        return string;
                    } else if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (ch === '\r') {
                            if (peek() === '\n') {
                                next();
                            }
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else if (ch === '\n') {
                        // unescaped newlines are invalid; see:
                        // https://github.com/aseemk/json5/issues/24
                        // TODO this feels special-cased; are there other
                        // invalid unescaped chars?
                        break;
                    } else {
                        string += ch;
                    }
                }
            }
            error("Bad string");
        },

        inlineComment = function () {

// Skip an inline comment, assuming this is one. The current character should
// be the second / character in the // pair that begins this inline comment.
// To finish the inline comment, we look for a newline or the end of the text.

            if (ch !== '/') {
                error("Not an inline comment");
            }

            do {
                next();
                if (ch === '\n' || ch === '\r') {
                    next();
                    return;
                }
            } while (ch);
        },

        blockComment = function () {

// Skip a block comment, assuming this is one. The current character should be
// the * character in the /* pair that begins this block comment.
// To finish the block comment, we look for an ending */ pair of characters,
// but we also watch for the end of text before the comment is terminated.

            if (ch !== '*') {
                error("Not a block comment");
            }

            do {
                next();
                while (ch === '*') {
                    next('*');
                    if (ch === '/') {
                        next('/');
                        return;
                    }
                }
            } while (ch);

            error("Unterminated block comment");
        },

        comment = function () {

// Skip a comment, whether inline or block-level, assuming this is one.
// Comments always begin with a / character.

            if (ch !== '/') {
                error("Not a comment");
            }

            next('/');

            if (ch === '/') {
                inlineComment();
            } else if (ch === '*') {
                blockComment();
            } else {
                error("Unrecognized comment");
            }
        },

        white = function () {

// Skip whitespace and comments.
// Note that we're detecting comments by only a single / character.
// This works since regular expressions are not valid JSON(5), but this will
// break if there are other valid values that begin with a / character!

            while (ch) {
                if (ch === '/') {
                    comment();
                } else if (ws.indexOf(ch) >= 0) {
                    next();
                } else {
                    return;
                }
            }
        },

        word = function () {

// true, false, or null.

            switch (ch) {
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
            case 'I':
                next('I');
                next('n');
                next('f');
                next('i');
                next('n');
                next('i');
                next('t');
                next('y');
                return Infinity;
            case 'N':
              next( 'N' );
              next( 'a' );
              next( 'N' );
              return NaN;
            }
            error("Unexpected " + renderChar(ch));
        },

        value,  // Place holder for the value function.

        array = function () {

// Parse an array value.

            var array = [];

            if (ch === '[') {
                next('[');
                white();
                while (ch) {
                    if (ch === ']') {
                        next(']');
                        return array;   // Potentially empty array
                    }
                    // ES5 allows omitting elements in arrays, e.g. [,] and
                    // [,null]. We don't allow this in JSON5.
                    if (ch === ',') {
                        error("Missing array element");
                    } else {
                        array.push(value());
                    }
                    white();
                    // If there's no comma after this value, this needs to
                    // be the end of the array.
                    if (ch !== ',') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error("Bad array");
        },

        object = function () {

// Parse an object value.

            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                while (ch) {
                    if (ch === '}') {
                        next('}');
                        return object;   // Potentially empty object
                    }

                    // Keys can be unquoted. If they are, they need to be
                    // valid JS identifiers.
                    if (ch === '"' || ch === "'") {
                        key = string();
                    } else {
                        key = identifier();
                    }

                    white();
                    next(':');
                    object[key] = value();
                    white();
                    // If there's no comma after this pair, this needs to be
                    // the end of the object.
                    if (ch !== ',') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error("Bad object");
        };

    value = function () {

// Parse a JSON value. It could be an object, an array, a string, a number,
// or a word.

        white();
        switch (ch) {
        case '{':
            return object();
        case '[':
            return array();
        case '"':
        case "'":
            return string();
        case '-':
        case '+':
        case '.':
            return number();
        default:
            return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

// Return the json_parse function. It will have access to all of the above
// functions and variables.

    return function (source, reviver) {
        var result;

        text = String(source);
        at = 0;
        lineNumber = 1;
        columnNumber = 1;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error("Syntax error");
        }

// If there is a reviver function, we recursively walk the new structure,
// passing each name/value pair to the reviver function for possible
// transformation, starting with a temporary root object that holds the result
// in an empty key. If there is not a reviver function, we simply return the
// result.

        return typeof reviver === 'function' ? (function walk(holder, key) {
            var k, v, value = holder[key];
            if (value && typeof value === 'object') {
                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = walk(value, k);
                        if (v !== undefined) {
                            value[k] = v;
                        } else {
                            delete value[k];
                        }
                    }
                }
            }
            return reviver.call(holder, key, value);
        }({'': result}, '')) : result;
    };
}());

// JSON5 stringify will not quote keys where appropriate
JSON5.stringify = function (obj, replacer, space) {
    if (replacer && (typeof(replacer) !== "function" && !isArray(replacer))) {
        throw new Error('Replacer must be a function or an array');
    }
    var getReplacedValueOrUndefined = function(holder, key, isTopLevel) {
        var value = holder[key];

        // Replace the value with its toJSON value first, if possible
        if (value && value.toJSON && typeof value.toJSON === "function") {
            value = value.toJSON();
        }

        // If the user-supplied replacer if a function, call it. If it's an array, check objects' string keys for
        // presence in the array (removing the key/value pair from the resulting JSON if the key is missing).
        if (typeof(replacer) === "function") {
            return replacer.call(holder, key, value);
        } else if(replacer) {
            if (isTopLevel || isArray(holder) || replacer.indexOf(key) >= 0) {
                return value;
            } else {
                return undefined;
            }
        } else {
            return value;
        }
    };

    function isWordChar(c) {
        return (c >= 'a' && c <= 'z') ||
            (c >= 'A' && c <= 'Z') ||
            (c >= '0' && c <= '9') ||
            c === '_' || c === '$';
    }

    function isWordStart(c) {
        return (c >= 'a' && c <= 'z') ||
            (c >= 'A' && c <= 'Z') ||
            c === '_' || c === '$';
    }

    function isWord(key) {
        if (typeof key !== 'string') {
            return false;
        }
        if (!isWordStart(key[0])) {
            return false;
        }
        var i = 1, length = key.length;
        while (i < length) {
            if (!isWordChar(key[i])) {
                return false;
            }
            i++;
        }
        return true;
    }

    // export for use in tests
    JSON5.isWord = isWord;

    // polyfills
    function isArray(obj) {
        if (Array.isArray) {
            return Array.isArray(obj);
        } else {
            return Object.prototype.toString.call(obj) === '[object Array]';
        }
    }

    function isDate(obj) {
        return Object.prototype.toString.call(obj) === '[object Date]';
    }

    var objStack = [];
    function checkForCircular(obj) {
        for (var i = 0; i < objStack.length; i++) {
            if (objStack[i] === obj) {
                throw new TypeError("Converting circular structure to JSON");
            }
        }
    }

    function makeIndent(str, num, noNewLine) {
        if (!str) {
            return "";
        }
        // indentation no more than 10 chars
        if (str.length > 10) {
            str = str.substring(0, 10);
        }

        var indent = noNewLine ? "" : "\n";
        for (var i = 0; i < num; i++) {
            indent += str;
        }

        return indent;
    }

    var indentStr;
    if (space) {
        if (typeof space === "string") {
            indentStr = space;
        } else if (typeof space === "number" && space >= 0) {
            indentStr = makeIndent(" ", space, true);
        } else {
            // ignore space parameter
        }
    }

    // Copied from Crokford's implementation of JSON
    // See https://github.com/douglascrockford/JSON-js/blob/e39db4b7e6249f04a195e7dd0840e610cc9e941e/json2.js#L195
    // Begin
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        meta = { // table of character substitutions
        '\b': '\\b',
        '\t': '\\t',
        '\n': '\\n',
        '\f': '\\f',
        '\r': '\\r',
        '"' : '\\"',
        '\\': '\\\\'
    };
    function escapeString(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.
        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string' ?
                c :
                '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }
    // End

    function internalStringify(holder, key, isTopLevel) {
        var buffer, res;

        // Replace the value, if necessary
        var obj_part = getReplacedValueOrUndefined(holder, key, isTopLevel);

        if (obj_part && !isDate(obj_part)) {
            // unbox objects
            // don't unbox dates, since will turn it into number
            obj_part = obj_part.valueOf();
        }
        switch(typeof obj_part) {
            case "boolean":
                return obj_part.toString();

            case "number":
                if (isNaN(obj_part) || !isFinite(obj_part)) {
                    return "null";
                }
                return obj_part.toString();

            case "string":
                return escapeString(obj_part.toString());

            case "object":
                if (obj_part === null) {
                    return "null";
                } else if (isArray(obj_part)) {
                    checkForCircular(obj_part);
                    buffer = "[";
                    objStack.push(obj_part);

                    for (var i = 0; i < obj_part.length; i++) {
                        res = internalStringify(obj_part, i, false);
                        buffer += makeIndent(indentStr, objStack.length);
                        if (res === null || typeof res === "undefined") {
                            buffer += "null";
                        } else {
                            buffer += res;
                        }
                        if (i < obj_part.length-1) {
                            buffer += ",";
                        } else if (indentStr) {
                            buffer += "\n";
                        }
                    }
                    objStack.pop();
                    if (obj_part.length) {
                        buffer += makeIndent(indentStr, objStack.length, true)
                    }
                    buffer += "]";
                } else {
                    checkForCircular(obj_part);
                    buffer = "{";
                    var nonEmpty = false;
                    objStack.push(obj_part);
                    for (var prop in obj_part) {
                        if (obj_part.hasOwnProperty(prop)) {
                            var value = internalStringify(obj_part, prop, false);
                            isTopLevel = false;
                            if (typeof value !== "undefined" && value !== null) {
                                buffer += makeIndent(indentStr, objStack.length);
                                nonEmpty = true;
                                key = isWord(prop) ? prop : escapeString(prop);
                                buffer += key + ":" + (indentStr ? ' ' : '') + value + ",";
                            }
                        }
                    }
                    objStack.pop();
                    if (nonEmpty) {
                        buffer = buffer.substring(0, buffer.length-1) + makeIndent(indentStr, objStack.length) + "}";
                    } else {
                        buffer = '{}';
                    }
                }
                return buffer;
            default:
                // functions and undefined should be ignored
                return undefined;
        }
    }

    // special case...when undefined is used inside of
    // a compound object/array, return null.
    // but when top-level, return undefined
    var topLevelHolder = {"":obj};
    if (obj === undefined) {
        return getReplacedValueOrUndefined(topLevelHolder, '', true);
    }
    return internalStringify(topLevelHolder, '', true);
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:no-bitwise */
// https://gist.github.com/jed/982883
function uuid(a) {
    return a // if the placeholder was passed, return
        ? ( // a random number from 0 to 15
        a ^ // unless b is 8,
            Math.random() // in which case
                * 16 // a random number from
                >> a / 4 // 8 to 11
        ).toString(16) // in hexadecimal
        : ( // or otherwise a concatenated string:
        "" + 1e7 + // 10000000 +
            -1e3 + // -1000 +
            -4e3 + // -4000 +
            -8e3 + // -80000000 +
            -1e11 // -100000000000,
        ).replace(// replacing
        /[018]/g, // zeroes, ones, and eights with
        uuid);
}
exports.uuid = uuid;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
function clearInlineStyles(editorState, selection, stylesArray) {
    var currentSelectionToPreserve = editorState.getSelection();
    var contentWithoutStyles = stylesArray.reduce(function (newContentState, style) { return (draft_js_1.Modifier.removeInlineStyle(newContentState, selection, style)); }, editorState.getCurrentContent());
    var editorStateWithInlineStylesCleared = draft_js_1.EditorState.push(editorState, contentWithoutStyles, 'change-inline-style');
    var editorStateWithSelectionRestored = draft_js_1.EditorState.forceSelection(editorStateWithInlineStylesCleared, currentSelectionToPreserve);
    return editorStateWithSelectionRestored;
}
exports.clearInlineStyles = clearInlineStyles;


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var getDraftCharacterListForSelection_1 = __webpack_require__(188);
exports.getUniqueStyleNamesInDraftSelection = function (editorState, selection) { return Object.keys(getDraftCharacterListForSelection_1.getDraftCharacterListForSelection(editorState, selection)
    .reduce(function (obj, item) {
    item.getStyle().forEach(function (styleName) {
        obj[styleName] = true;
    });
    return obj;
}, {})); };


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateToHTML = __webpack_require__(874);

Object.defineProperty(exports, 'stateToHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateToHTML).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR;

exports.default = stateToHTML;

var _combineOrderedStyles3 = __webpack_require__(875);

var _combineOrderedStyles4 = _interopRequireDefault(_combineOrderedStyles3);

var _normalizeAttributes = __webpack_require__(876);

var _normalizeAttributes2 = _interopRequireDefault(_normalizeAttributes);

var _styleToCSS = __webpack_require__(877);

var _styleToCSS2 = _interopRequireDefault(_styleToCSS);

var _draftJsUtils = __webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BOLD = _draftJsUtils.INLINE_STYLE.BOLD,
    CODE = _draftJsUtils.INLINE_STYLE.CODE,
    ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC,
    STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH,
    UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;


var INDENT = '  ';
var BREAK = '<br>';
var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;

var DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, _defineProperty(_DEFAULT_STYLE_MAP, BOLD, { element: 'strong' }), _defineProperty(_DEFAULT_STYLE_MAP, CODE, { element: 'code' }), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, { element: 'em' }), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, { element: 'del' }), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, { element: 'u' }), _DEFAULT_STYLE_MAP);

// Order: inner-most style to outer-most.
// Examle: <em><strong>foo</strong></em>
var DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE];

// Map entity data to element attributes.
var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, {
  url: 'href',
  href: 'href',
  rel: 'rel',
  target: 'target',
  title: 'title',
  className: 'class'
}), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, {
  src: 'src',
  height: 'height',
  width: 'width',
  alt: 'alt',
  className: 'class'
}), _ENTITY_ATTR_MAP);

// Map entity data to element attributes.
var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var dataKey = _step.value;

      var dataValue = data[dataKey];
      if (attrMap.hasOwnProperty(dataKey)) {
        var attrKey = attrMap[dataKey];
        attrs[attrKey] = dataValue;
      } else if (DATA_ATTRIBUTE.test(dataKey)) {
        attrs[dataKey] = dataValue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return attrs;
}), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.keys(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var dataKey = _step2.value;

      var dataValue = data[dataKey];
      if (attrMap.hasOwnProperty(dataKey)) {
        var attrKey = attrMap[dataKey];
        attrs[attrKey] = dataValue;
      } else if (DATA_ATTRIBUTE.test(dataKey)) {
        attrs[dataKey] = dataValue;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return attrs;
}), _DATA_TO_ATTR);

// The reason this returns an array is because a single block might get wrapped
// in two tags.
function getTags(blockType, defaultBlockTag) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
      return ['h1'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
      return ['h2'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
      return ['h3'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
      return ['h4'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
      return ['h5'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
      return ['h6'];
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return ['li'];
    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
      return ['blockquote'];
    case _draftJsUtils.BLOCK_TYPE.CODE:
      return ['pre', 'code'];
    case _draftJsUtils.BLOCK_TYPE.ATOMIC:
      return ['figure'];
    default:
      if (defaultBlockTag === null) {
        return [];
      }
      return [defaultBlockTag || 'p'];
  }
}

function getWrapperTag(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
      return 'ul';
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return 'ol';
    default:
      return null;
  }
}

var MarkupGenerator = function () {
  // These are related to user-defined options.
  function MarkupGenerator(contentState, options) {
    _classCallCheck(this, MarkupGenerator);

    if (options == null) {
      options = {};
    }
    this.contentState = contentState;
    this.options = options;

    var _combineOrderedStyles = (0, _combineOrderedStyles4.default)(options.inlineStyles, [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER]),
        _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2),
        inlineStyles = _combineOrderedStyles2[0],
        styleOrder = _combineOrderedStyles2[1];

    this.inlineStyles = inlineStyles;
    this.inlineStyleFn = options.inlineStyleFn;
    this.styleOrder = styleOrder;
  }
  // These are related to state.


  _createClass(MarkupGenerator, [{
    key: 'generate',
    value: function generate() {
      this.output = [];
      this.blocks = this.contentState.getBlocksAsArray();
      this.totalBlocks = this.blocks.length;
      this.currentBlock = 0;
      this.indentLevel = 0;
      this.wrapperTag = null;
      while (this.currentBlock < this.totalBlocks) {
        this.processBlock();
      }
      this.closeWrapperTag();
      return this.output.join('').trim();
    }
  }, {
    key: 'processBlock',
    value: function processBlock() {
      var _options = this.options,
          blockRenderers = _options.blockRenderers,
          defaultBlockTag = _options.defaultBlockTag;

      var block = this.blocks[this.currentBlock];
      var blockType = block.getType();
      var newWrapperTag = getWrapperTag(blockType);
      if (this.wrapperTag !== newWrapperTag) {
        if (this.wrapperTag) {
          this.closeWrapperTag();
        }
        if (newWrapperTag) {
          this.openWrapperTag(newWrapperTag);
        }
      }
      this.indent();
      // Allow blocks to be rendered using a custom renderer.
      var customRenderer = blockRenderers != null && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null;
      var customRendererOutput = customRenderer ? customRenderer(block) : null;
      // Renderer can return null, which will cause processing to continue as normal.
      if (customRendererOutput != null) {
        this.output.push(customRendererOutput);
        this.output.push('\n');
        this.currentBlock += 1;
        return;
      }
      this.writeStartTag(block, defaultBlockTag);
      this.output.push(this.renderBlockContent(block));
      // Look ahead and see if we will nest list.
      var nextBlock = this.getNextBlock();
      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
        this.output.push('\n');
        // This is a litle hacky: temporarily stash our current wrapperTag and
        // render child list(s).
        var thisWrapperTag = this.wrapperTag;
        this.wrapperTag = null;
        this.indentLevel += 1;
        this.currentBlock += 1;
        this.processBlocksAtDepth(nextBlock.getDepth());
        this.wrapperTag = thisWrapperTag;
        this.indentLevel -= 1;
        this.indent();
      } else {
        this.currentBlock += 1;
      }
      this.writeEndTag(block, defaultBlockTag);
    }
  }, {
    key: 'processBlocksAtDepth',
    value: function processBlocksAtDepth(depth) {
      var block = this.blocks[this.currentBlock];
      while (block && block.getDepth() === depth) {
        this.processBlock();
        block = this.blocks[this.currentBlock];
      }
      this.closeWrapperTag();
    }
  }, {
    key: 'getNextBlock',
    value: function getNextBlock() {
      return this.blocks[this.currentBlock + 1];
    }
  }, {
    key: 'writeStartTag',
    value: function writeStartTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);

      var attrString = void 0;
      if (this.options.blockStyleFn) {
        var _ref = this.options.blockStyleFn(block) || {},
            _attributes = _ref.attributes,
            _style = _ref.style;
        // Normalize `className` -> `class`, etc.


        _attributes = (0, _normalizeAttributes2.default)(_attributes);
        if (_style != null) {
          var styleAttr = (0, _styleToCSS2.default)(_style);
          _attributes = _attributes == null ? { style: styleAttr } : _extends({}, _attributes, { style: styleAttr });
        }
        attrString = stringifyAttrs(_attributes);
      } else {
        attrString = '';
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = tags[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var tag = _step3.value;

          this.output.push('<' + tag + attrString + '>');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'writeEndTag',
    value: function writeEndTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);
      if (tags.length === 1) {
        this.output.push('</' + tags[0] + '>\n');
      } else {
        var output = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = tags[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var tag = _step4.value;

            output.unshift('</' + tag + '>');
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        this.output.push(output.join('') + '\n');
      }
    }
  }, {
    key: 'openWrapperTag',
    value: function openWrapperTag(wrapperTag) {
      this.wrapperTag = wrapperTag;
      this.indent();
      this.output.push('<' + wrapperTag + '>\n');
      this.indentLevel += 1;
    }
  }, {
    key: 'closeWrapperTag',
    value: function closeWrapperTag() {
      var wrapperTag = this.wrapperTag;

      if (wrapperTag) {
        this.indentLevel -= 1;
        this.indent();
        this.output.push('</' + wrapperTag + '>\n');
        this.wrapperTag = null;
      }
    }
  }, {
    key: 'indent',
    value: function indent() {
      this.output.push(INDENT.repeat(this.indentLevel));
    }
  }, {
    key: 'withCustomInlineStyles',
    value: function withCustomInlineStyles(content, styleSet) {
      if (!this.inlineStyleFn) {
        return content;
      }

      var renderConfig = this.inlineStyleFn(styleSet);
      if (!renderConfig) {
        return content;
      }

      var _renderConfig$element = renderConfig.element,
          element = _renderConfig$element === undefined ? 'span' : _renderConfig$element,
          attributes = renderConfig.attributes,
          style = renderConfig.style;

      var attrString = stringifyAttrs(_extends({}, attributes, {
        style: style && (0, _styleToCSS2.default)(style)
      }));

      return '<' + element + attrString + '>' + content + '</' + element + '>';
    }
  }, {
    key: 'renderBlockContent',
    value: function renderBlockContent(block) {
      var _this = this;

      var blockType = block.getType();
      var text = block.getText();
      if (text === '') {
        // Prevent element collapse if completely empty.
        return BREAK;
      }
      text = this.preserveWhitespace(text);
      var charMetaList = block.getCharacterList();
      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
      return entityPieces.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            entityKey = _ref3[0],
            stylePieces = _ref3[1];

        var content = stylePieces.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              text = _ref5[0],
              styleSet = _ref5[1];

          var content = encodeContent(text);
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = _this.styleOrder[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _styleName = _step5.value;

              // If our block type is CODE then don't wrap inline code elements.
              if (_styleName === CODE && blockType === _draftJsUtils.BLOCK_TYPE.CODE) {
                continue;
              }
              if (styleSet.has(_styleName)) {
                var _inlineStyles$_styleN = _this.inlineStyles[_styleName],
                    _element = _inlineStyles$_styleN.element,
                    _attributes2 = _inlineStyles$_styleN.attributes,
                    _style2 = _inlineStyles$_styleN.style;

                if (_element == null) {
                  _element = 'span';
                }
                // Normalize `className` -> `class`, etc.
                _attributes2 = (0, _normalizeAttributes2.default)(_attributes2);
                if (_style2 != null) {
                  var styleAttr = (0, _styleToCSS2.default)(_style2);
                  _attributes2 = _attributes2 == null ? { style: styleAttr } : _extends({}, _attributes2, { style: styleAttr });
                }
                var attrString = stringifyAttrs(_attributes2);
                content = '<' + _element + attrString + '>' + content + '</' + _element + '>';
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          return _this.withCustomInlineStyles(content, styleSet);
        }).join('');
        var entity = entityKey ? _this.contentState.getEntity(entityKey) : null;
        // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
        var entityType = entity == null ? null : entity.getType().toUpperCase();
        var entityStyle = void 0;
        if (entity != null && _this.options.entityStyleFn && (entityStyle = _this.options.entityStyleFn(entity))) {
          var _entityStyle = entityStyle,
              _element2 = _entityStyle.element,
              _attributes3 = _entityStyle.attributes,
              _style3 = _entityStyle.style;

          if (_element2 == null) {
            _element2 = 'span';
          }
          // Normalize `className` -> `class`, etc.
          _attributes3 = (0, _normalizeAttributes2.default)(_attributes3);
          if (_style3 != null) {
            var styleAttr = (0, _styleToCSS2.default)(_style3);
            _attributes3 = _attributes3 == null ? { style: styleAttr } : _extends({}, _attributes3, { style: styleAttr });
          }
          var attrString = stringifyAttrs(_attributes3);
          return '<' + _element2 + attrString + '>' + content + '</' + _element2 + '>';
        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.LINK) {
          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
          var _attrString = stringifyAttrs(attrs);
          return '<a' + _attrString + '>' + content + '</a>';
        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE) {
          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
          var _attrString2 = stringifyAttrs(_attrs);
          return '<img' + _attrString2 + '/>';
        } else {
          return content;
        }
      }).join('');
    }
  }, {
    key: 'preserveWhitespace',
    value: function preserveWhitespace(text) {
      var length = text.length;
      // Prevent leading/trailing/consecutive whitespace collapse.
      var newText = new Array(length);
      for (var i = 0; i < length; i++) {
        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
          newText[i] = '\xA0';
        } else {
          newText[i] = text[i];
        }
      }
      return newText.join('');
    }
  }]);

  return MarkupGenerator;
}();

function stringifyAttrs(attrs) {
  if (attrs == null) {
    return '';
  }
  var parts = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = Object.keys(attrs)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var name = _step6.value;

      var value = attrs[name];
      if (value != null) {
        parts.push(' ' + name + '="' + encodeAttr(value + '') + '"');
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return parts.join('');
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return true;
    default:
      return false;
  }
}

function encodeContent(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
}

function encodeAttr(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
}

function stateToHTML(content, options) {
  return new MarkupGenerator(content, options).generate();
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function combineOrderedStyles(customMap, defaults) {
  if (customMap == null) {
    return defaults;
  }

  var _defaults = _slicedToArray(defaults, 2),
      defaultStyleMap = _defaults[0],
      defaultStyleOrder = _defaults[1];

  var styleMap = _extends({}, defaultStyleMap);
  var styleOrder = [].concat(_toConsumableArray(defaultStyleOrder));
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(customMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _styleName = _step.value;

      if (defaultStyleMap.hasOwnProperty(_styleName)) {
        var defaultStyles = defaultStyleMap[_styleName];
        styleMap[_styleName] = _extends({}, defaultStyles, customMap[_styleName]);
      } else {
        styleMap[_styleName] = customMap[_styleName];
        styleOrder.push(_styleName);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [styleMap, styleOrder];
}

exports.default = combineOrderedStyles;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
var ATTR_NAME_MAP = {
  acceptCharset: 'accept-charset',
  className: 'class',
  htmlFor: 'for',
  httpEquiv: 'http-equiv'
};

function normalizeAttributes(attributes) {
  if (attributes == null) {
    return attributes;
  }
  var normalized = {};
  var didNormalize = false;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;

      var newName = name;
      if (ATTR_NAME_MAP.hasOwnProperty(name)) {
        newName = ATTR_NAME_MAP[name];
        didNormalize = true;
      }
      normalized[newName] = attributes[name];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return didNormalize ? normalized : attributes;
}

exports.default = normalizeAttributes;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;

var NUMERIC_STRING = /^\d+$/;
var UPPERCASE_PATTERN = /([A-Z])/g;

// Lifted from:
// https://github.com/facebook/react/blob/ab4ddf64939aebbbc8d31be1022efd56e834c95c/src/renderers/dom/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
function processStyleName(name) {
  return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
}

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
function processStyleValue(name, value) {
  var isNumeric = void 0;
  if (typeof value === 'string') {
    isNumeric = NUMERIC_STRING.test(value);
  } else {
    isNumeric = true;
    value = String(value);
  }
  if (!isNumeric || value === '0' || isUnitlessNumber[name] === true) {
    return value;
  } else {
    return value + 'px';
  }
}

function styleToCSS(styleDescr) {
  return Object.keys(styleDescr).map(function (name) {
    var styleValue = processStyleValue(name, styleDescr[name]);
    var styleName = processStyleName(name);
    return styleName + ': ' + styleValue;
  }).join('; ');
}

exports.default = styleToCSS;

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(418);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BLOCK_TYPE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ENTITY_TYPE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "INLINE_STYLE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__ = __webpack_require__(879);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityRanges", function() { return __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSelectedBlocks__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedBlocks", function() { return __WEBPACK_IMPORTED_MODULE_2__getSelectedBlocks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectionContainsEntity__ = __webpack_require__(880);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectionContainsEntity", function() { return __WEBPACK_IMPORTED_MODULE_3__selectionContainsEntity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__callModifierForSelectedBlocks__ = __webpack_require__(881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "callModifierForSelectedBlocks", function() { return __WEBPACK_IMPORTED_MODULE_4__callModifierForSelectedBlocks__["a"]; });







/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMPTY_SET */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEntityRanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);

var EMPTY_SET = new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"]();
function getEntityRanges(text, charMetaList) {
  var charEntity = null;
  var prevCharEntity = null;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharEntity = charEntity;
    var meta = charMetaList.get(i);
    charEntity = meta ? meta.getEntity() : null;

    if (i > 0 && charEntity !== prevCharEntity) {
      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
      rangeStart = i;
    }
  }

  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
  return ranges;
}

function getStyleRanges(text, charMetaList) {
  var charStyle = EMPTY_SET;
  var prevCharStyle = EMPTY_SET;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharStyle = charStyle;
    var meta = charMetaList.get(i);
    charStyle = meta ? meta.getStyle() : EMPTY_SET;

    if (i > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["is"])(charStyle, prevCharStyle)) {
      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
      rangeStart = i;
    }
  }

  ranges.push([text.slice(rangeStart), charStyle]);
  return ranges;
}

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__ = __webpack_require__(189);

/* harmony default export */ __webpack_exports__["a"] = (function (strategy) {
  return function (editorState, selection) {
    var contentState = editorState.getCurrentContent();
    var currentSelection = selection || editorState.getSelection();
    var startKey = currentSelection.getStartKey();
    var endKey = currentSelection.getEndKey();
    var startOffset = currentSelection.getStartOffset();
    var endOffset = currentSelection.getEndOffset();
    var isSameBlock = startKey === endKey;
    var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
    var entityFound = false; // We have to shift the offset to not get false positives when selecting
    // a character just before or after an entity

    var finalStartOffset = startOffset + 1;
    var finalEndOffset = endOffset - 1;
    selectedBlocks.forEach(function (block) {
      strategy(block, function (start, end) {
        if (entityFound) {
          return;
        }

        var blockKey = block.getKey();

        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
          return;
        } else if (blockKey === startKey && end < finalStartOffset) {
          return;
        } else if (blockKey === endKey && start > finalEndOffset) {
          return;
        }

        entityFound = true;
      }, contentState);
    });
    return entityFound;
  };
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__ = __webpack_require__(189);


/**
 * Calls a provided `modifier` function with a selection for each
 * selected block in the current editor selection. Passes through additional
 * arguments to the modifier.
 *
 * Note: At the moment it will retain the original selection and override
 * possible selection changes from modifiers
 *
 * @param  {object} editorState The current draft.js editor state object
 *
 * @param  {function} modifier  A modifier function to be executed.
 *                              Must have the signature (editorState, selection, ...)
 *
 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
 *
 * @return {object} The new editor state
 */

/* harmony default export */ __webpack_exports__["a"] = (function (editorState, modifier) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var contentState = editorState.getCurrentContent();
  var currentSelection = editorState.getSelection();
  var startKey = currentSelection.getStartKey();
  var endKey = currentSelection.getEndKey();
  var startOffset = currentSelection.getStartOffset();
  var endOffset = currentSelection.getEndOffset();
  var isSameBlock = startKey === endKey;
  var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
  var finalEditorState = editorState;
  selectedBlocks.forEach(function (block) {
    var currentBlockKey = block.getKey();
    var selectionStart = startOffset;
    var selectionEnd = endOffset;

    if (currentBlockKey === startKey) {
      selectionStart = startOffset;
      selectionEnd = isSameBlock ? endOffset : block.getText().length;
    } else if (currentBlockKey === endKey) {
      selectionStart = isSameBlock ? startOffset : 0;
      selectionEnd = endOffset;
    } else {
      selectionStart = 0;
      selectionEnd = block.getText().length;
    }

    var selection = new __WEBPACK_IMPORTED_MODULE_0_draft_js__["SelectionState"]({
      anchorKey: currentBlockKey,
      anchorOffset: selectionStart,
      focusKey: currentBlockKey,
      focusOffset: selectionEnd
    });
    finalEditorState = modifier.apply(void 0, [finalEditorState, selection].concat(args));
  });
  return __WEBPACK_IMPORTED_MODULE_0_draft_js__["EditorState"].forceSelection(finalEditorState, currentSelection);
});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var react_redux_1 = __webpack_require__(25);
var draft_js_1 = __webpack_require__(16);
var components_1 = __webpack_require__(428);
var store_1 = __importDefault(__webpack_require__(157));
var store_2 = __webpack_require__(157);
var from_html_1 = __webpack_require__(124);
var actions_1 = __webpack_require__(24);
var ng_1 = __importDefault(__webpack_require__(18));
/**
 * @ngdoc directive
 * @module superdesk.core.editor3
 * @name sdEditor3
 * @param {Array} editorFormat the formating settings available for editor
 * @param {String} value the model for editor value
 * @param {Boolean} readOnly true if the editor is read only
 * @param {Function} onChange the callback executed when the editor value is changed
 * @param {String} language the current language used for spellchecker
 * @description sdEditor3 integrates react Editor3 component with superdesk app.
 */
exports.sdEditor3 = function () { return new Editor3Directive(); };
var Editor3Directive = /** @class */ (function () {
    function Editor3Directive() {
        this.scope = {};
        this.controllerAs = 'vm';
        this.controller = ['config', '$element', 'editor3', '$scope', '$rootScope', this.initialize];
        this.bindToController = {
            /**
             * @type {String}
             * @description If set, it will be used to make sure the toolbar is always
             * visible when scrolling. If not set, window object is used as reference.
             * Any valid jQuery selector will do.
             */
            scrollContainer: '@',
            /**
             * @type {Boolean}
             * @description Whether this editor is the target for find & replace
             * operations. The Find & Replace service can only have one editor as
             * target.
             */
            findReplaceTarget: '@',
            /**
             * @type {Object}
             * @description Editor format options that are enabled and should be displayed
             * in the toolbar.
             */
            editorFormat: '=?',
            /**
             * @type {Object}
             * @description A JSON object representing the Content State of the Draft
             * editor. When available, it is used to show content, using `convertFromRaw`.
             * Either this, or value have to be set. Use this for most accurate behavior.
             */
            editorState: '=?',
            /**
             * @type {String}
             * @description HTML value of editor. Used by the outside world.
             */
            value: '=',
            /**
             * @type {String}
             * @description required for editor3 to be able to set metadata for fields. Mainly editor_state
             */
            pathToValue: '=',
            /**
             * @type {Boolean}
             * @description If true, editor is read-only.
             */
            readOnly: '=?',
            /**
             * @type {Boolean}
             * @description If true, the value prop is being watched for changes,
             * and the changes are applied to the editor. Experimental feature used
             * in compare versions.
             */
            bindToValue: '=?',
            /**
             * @type {Number}
             * @description If changed the editor will reload the editor state from item.
             */
            refreshTrigger: '=?',
            /**
             * @type {Function}
             * @description Function that gets called on every content change.
             */
            onChange: '&',
            /**
             * @type {String}
             * @description Spellchecker's language.
             */
            language: '=?',
            /**
             * @type {Boolean}
             * @description Disables the Enter key if the attribute is set.
             */
            singleLine: '=?',
            /**
             * @type {String}
             * @description Number indicating the debounce in ms for the on-change
             * event.
             */
            debounce: '@',
            /**
             * @type {Boolean}
             * @description Disable internal spellchecker.
             */
            disableSpellchecker: '=?',
            /**

             * @type {Object}
             * @description Item which is being edited
             */
            item: '=',
            /**
             * @type {Number}
             * @description Tabindex value.
             */
            tabindex: '=?',
            /**
             * @type {Boolean}
             * @description Show image title.
             */
            showTitle: '=?',
        };
    }
    Editor3Directive.prototype.initialize = function (config, $element, editor3, $scope, $rootScope) {
        var _this = this;
        if (this.item == null) {
            throw new Error('Item must be provided in order to be able to save editor_state on it');
        }
        // defaults
        this.language = this.language || 'en';
        this.readOnly = this.readOnly || false;
        this.findReplaceTarget = typeof this.findReplaceTarget !== 'undefined';
        this.singleLine = this.singleLine || false;
        this.debounce = parseInt(this.debounce || '100', 10);
        this.disableSpellchecker = this.disableSpellchecker || false;
        this.bindToValue = this.bindToValue || false;
        this.tabindex = this.tabindex || 0;
        this.refreshTrigger = this.refreshTrigger || 0;
        this.showTitle = this.showTitle || false;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.svc = {};
        var store = store_1.default(this, ng_1.default.get('spellcheck'));
        // bind the directive value attribute bi-directionally between Angular and Redux.
        if (this.bindToValue) {
            $scope.$watch('vm.value', function (newValue, oldValue) {
                var text = (newValue || '')
                    .replace(/<ins/g, '<code')
                    .replace(/<\/ins>/g, '</code>');
                var content = from_html_1.getContentStateFromHtml(text);
                var state = store.getState();
                var editorState = draft_js_1.EditorState.push(state.editorState, content, 'insert-characters');
                store.dispatch(actions_1.changeEditorState(editorState));
            });
        }
        // bind the directive refreshTrigger attribute bi-directionally between Angular and Redux.
        $scope.$watch('vm.refreshTrigger', function (val, old) {
            if (val === 0) {
                return;
            }
            var props = {
                item: _this.item,
                pathToValue: _this.pathToValue,
            };
            var content = store_2.getInitialContent(props);
            var state = store.getState();
            var editorState = draft_js_1.EditorState.push(state.editorState, content, 'change-block-data');
            store.dispatch(actions_1.changeEditorState(editorState, true, true));
        });
        // this is triggered from MacrosController.call
        // if the current editor is for 'field' replace the current content with 'value'
        $scope.$on('macro:refreshField', function (evt, field, value) {
            if (field === _this.pathToValue) {
                var content = from_html_1.getContentStateFromHtml(value);
                var state = store.getState();
                var editorState = draft_js_1.EditorState.push(state.editorState, content, 'spellcheck-change');
                store.dispatch(actions_1.changeEditorState(editorState, true, true));
            }
        });
        // bind the directive readOnly attribute bi-directionally between Angular and Redux.
        $scope.$watch('vm.readOnly', function (val, old) {
            if (val !== old) {
                store.dispatch(actions_1.setReadOnly(val));
            }
        });
        // if this editor is the find & replace target, expose the store in the editor3
        // find & replace service.
        if (this.findReplaceTarget) {
            editor3.setStore(store);
            $scope.$on('$destroy', editor3.unsetStore);
        }
        // Expose the store in the editor3 spellchecker service
        var storeIndex = editor3.addSpellcheckerStore(store);
        $scope.$on('$destroy', function () { return editor3.removeSpellcheckerStore(storeIndex); });
        ng_1.default.waitForServicesToBeAvailable()
            .then(function () {
            react_dom_1.default.render(react_1.default.createElement(react_redux_1.Provider, { store: store },
                react_1.default.createElement(components_1.Editor3, { scrollContainer: _this.scrollContainer, singleLine: _this.singleLine })), $element.get(0));
        });
    };
    return Editor3Directive;
}());


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(190);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(905);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(426);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(893);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(891);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(423);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(895);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(899);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29), __webpack_require__(898)(module)))

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(424);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(425);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(426);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(427);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(906);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(190);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var BlockStyleButtons_1 = __importDefault(__webpack_require__(908));
var InlineStyleButtons_1 = __importDefault(__webpack_require__(909));
var TableControls_1 = __importDefault(__webpack_require__(910));
var StyleButton_1 = __importDefault(__webpack_require__(132));
var SelectionButton_1 = __webpack_require__(911);
var IconButton_1 = __webpack_require__(912);
var ToolbarPopup_1 = __webpack_require__(913);
var react_redux_1 = __webpack_require__(25);
var links_1 = __webpack_require__(195);
var classnames_1 = __importDefault(__webpack_require__(4));
var actions = __importStar(__webpack_require__(24));
var actions_1 = __webpack_require__(24);
var highlightsConfig_1 = __webpack_require__(46);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name Toolbar
 * @param {boolean} disabled Disables clicking on the toolbar, if true.
 * @description Holds the editor's toolbar.
 */
var ToolbarComponent = /** @class */ (function (_super) {
    __extends(ToolbarComponent, _super);
    function ToolbarComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollContainer = $(props.scrollContainer || window);
        _this.onScroll = _this.onScroll.bind(_this);
        _this.state = {
            // When true, the toolbar is floating at the top of the item. This
            // helps the toolbar continue to be visible when it goes out of view
            // because of scrolling.
            floating: false,
            width: 'auto',
        };
        return _this;
    }
    ToolbarComponent.prototype.shouldComponentUpdate = function (nextProps) {
        var _this = this;
        if (nextProps.popup.type === 'NONE' && this.props.popup.type !== 'NONE') {
            // restoring editor focus after closing the popup
            var scrollableElement_1 = document.querySelector('.page-content-container');
            setTimeout(function () {
                var editorWrapperElement = _this.props.editorWrapperElement;
                if (editorWrapperElement instanceof Element !== true) {
                    return;
                }
                var draftjsContentEditable = editorWrapperElement.querySelector('.public-DraftEditor-content');
                if (draftjsContentEditable instanceof Element !== true) {
                    return;
                }
                draftjsContentEditable.focus();
                if (scrollableElement_1 != null) {
                    // prevent fousing from changing scroll position
                    scrollableElement_1.scrollTop = scrollableElement_1.scrollTop;
                    scrollableElement_1.scrollLeft = scrollableElement_1.scrollLeft;
                }
            });
        }
        return true;
    };
    /**
     * @ngdoc method
     * @name Toolbar#onScroll
     * @description Triggered when the authoring page is scrolled. It adjusts toolbar
     * style, based on the location of the editor within the scroll container.
     */
    ToolbarComponent.prototype.onScroll = function (e) {
        if (!this.props.editorNode) {
            return;
        }
        var editorRect = this.props.editorNode.getBoundingClientRect();
        var pageRect = this.scrollContainer[0].getBoundingClientRect();
        if (!editorRect || !pageRect) {
            return;
        }
        var isToolbarOut = editorRect.top < pageRect.top + 50;
        var isBottomOut = editorRect.bottom < pageRect.top + 60;
        var floating = isToolbarOut && !isBottomOut;
        var width = floating ? editorRect.width : 'auto';
        if (floating !== this.state.floating) {
            this.setState({ floating: floating, width: width });
        }
    };
    ToolbarComponent.prototype.componentDidMount = function () {
        this.scrollContainer.on('scroll', this.onScroll);
    };
    ToolbarComponent.prototype.componentWillUnmount = function () {
        this.scrollContainer.off('scroll', this.onScroll);
    };
    /* eslint-disable complexity */
    ToolbarComponent.prototype.render = function () {
        var _this = this;
        var floating = this.state.floating;
        var _a = this.props, disabled = _a.disabled, popup = _a.popup, editorFormat = _a.editorFormat, activeCell = _a.activeCell, addTable = _a.addTable, insertMedia = _a.insertMedia, suggestingMode = _a.suggestingMode, toggleSuggestingMode = _a.toggleSuggestingMode, invisibles = _a.invisibles, toggleInvisibles = _a.toggleInvisibles, removeFormat = _a.removeFormat;
        var has = function (opt) { return editorFormat.indexOf(opt) > -1; };
        var showPopup = function (type) { return function (data) { return _this.props.showPopup(type, data); }; };
        var cx = classnames_1.default({
            'Editor3-controls': true,
            'floating-toolbar': floating,
            disabled: disabled && activeCell === null,
        });
        return activeCell !== null ? react_1.default.createElement(TableControls_1.default, { className: cx }) :
            react_1.default.createElement("div", { className: cx, style: { width: this.state.width } },
                react_1.default.createElement(BlockStyleButtons_1.default, null),
                react_1.default.createElement(InlineStyleButtons_1.default, null),
                has('link') &&
                    react_1.default.createElement(SelectionButton_1.SelectionButton, { onClick: showPopup(actions_1.PopupTypes.Link), iconName: "link", tooltip: utils_1.gettext('Link') }),
                has('embed') &&
                    react_1.default.createElement(IconButton_1.IconButton, { onClick: showPopup(actions_1.PopupTypes.Embed), iconName: "code", tooltip: "Embed" }),
                has('media') &&
                    react_1.default.createElement(IconButton_1.IconButton, { onClick: insertMedia, tooltip: utils_1.gettext('Media'), iconName: "picture" }),
                has('table') &&
                    react_1.default.createElement(IconButton_1.IconButton, { onClick: addTable, tooltip: utils_1.gettext('Table'), iconName: "table" }),
                has('remove format') &&
                    react_1.default.createElement(SelectionButton_1.SelectionButton, { onClick: removeFormat, precondition: !suggestingMode, key: "remove-format-button", iconName: "clear-format", tooltip: utils_1.gettext('Remove format') }),
                has('comments') &&
                    react_1.default.createElement(SelectionButton_1.SelectionButton, { onClick: showPopup(actions_1.PopupTypes.Comment), precondition: this.props.highlightsManager.canAddHighlight(highlightsConfig_1.highlightsConfig.COMMENT.type), key: "comment-button", iconName: "comment", tooltip: utils_1.gettext('Comment') }),
                has('annotation') &&
                    react_1.default.createElement(SelectionButton_1.SelectionButton, { onClick: showPopup(actions_1.PopupTypes.Annotation), precondition: this.props.highlightsManager.canAddHighlight(highlightsConfig_1.highlightsConfig.ANNOTATION.type), key: "annotation-button", iconName: "edit-line", tooltip: utils_1.gettext('Annotation') }),
                has('suggestions') &&
                    react_1.default.createElement(StyleButton_1.default, { active: suggestingMode, label: 'suggestions', style: 'suggestions', onToggle: toggleSuggestingMode }),
                has('formatting marks') &&
                    react_1.default.createElement(StyleButton_1.default, { active: invisibles, label: 'invisibles', style: 'invisibles', onToggle: toggleInvisibles }),
                react_1.default.createElement(ToolbarPopup_1.ToolbarPopup, { type: popup.type, data: popup.data, editorState: this.props.editorState, highlightsManager: this.props.highlightsManager }),
                react_1.default.createElement(links_1.LinkToolbar, { onEdit: showPopup(actions_1.PopupTypes.Link) }));
    };
    return ToolbarComponent;
}(react_1.default.Component));
ToolbarComponent.propTypes = {
    disabled: prop_types_1.default.bool,
    editorFormat: prop_types_1.default.array,
    activeCell: prop_types_1.default.any,
    suggestingMode: prop_types_1.default.bool,
    invisibles: prop_types_1.default.bool,
    addTable: prop_types_1.default.func,
    insertMedia: prop_types_1.default.func,
    showPopup: prop_types_1.default.func,
    toggleSuggestingMode: prop_types_1.default.func,
    toggleInvisibles: prop_types_1.default.func,
    removeFormat: prop_types_1.default.func,
    popup: prop_types_1.default.object,
    editorState: prop_types_1.default.object,
    editorNode: prop_types_1.default.object,
    scrollContainer: prop_types_1.default.string.isRequired,
    highlightsManager: prop_types_1.default.object.isRequired,
    editorWrapperElement: prop_types_1.default.object,
};
var mapStateToProps = function (_a) {
    var editorFormat = _a.editorFormat, activeCell = _a.activeCell, popup = _a.popup, editorState = _a.editorState, suggestingMode = _a.suggestingMode, invisibles = _a.invisibles;
    return ({
        editorFormat: editorFormat,
        activeCell: activeCell,
        popup: popup,
        editorState: editorState,
        suggestingMode: suggestingMode,
        invisibles: invisibles,
    });
};
var mapDispatchToProps = function (dispatch) { return ({
    insertMedia: function () { return dispatch(actions.insertMedia()); },
    showPopup: function (type, data) { return dispatch(actions.showPopup(type, data)); },
    addTable: function () { return dispatch(actions.addTable()); },
    toggleSuggestingMode: function () { return dispatch(actions.toggleSuggestingMode()); },
    toggleInvisibles: function () { return dispatch(actions.toggleInvisibles()); },
    removeFormat: function () { return dispatch(actions.removeFormat()); },
}); };
var Toolbar = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ToolbarComponent);
exports.default = Toolbar;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var StyleButton_1 = __importDefault(__webpack_require__(132));
var actions = __importStar(__webpack_require__(24));
var react_redux_1 = __webpack_require__(25);
var Suggestions = __importStar(__webpack_require__(133));
var author_1 = __webpack_require__(134);
/**
 * @type {Object}
 * @description Maps server 'editorFormat' options to Draft styles.
 */
var blockStyles = {
    h1: 'header-one',
    h2: 'header-two',
    h3: 'header-three',
    h4: 'header-four',
    h5: 'header-five',
    h6: 'header-six',
    quote: 'blockquote',
    'unordered list': 'unordered-list-item',
    'ordered list': 'ordered-list-item',
    pre: 'code-block',
};
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name BlockStyleControl
 * @description Blocks style controls (h1, h2, h3, ...)
 */
var BlockStyleButtonsComponent = /** @class */ (function (_super) {
    __extends(BlockStyleButtonsComponent, _super);
    function BlockStyleButtonsComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    BlockStyleButtonsComponent.prototype.onToggle = function (type, active) {
        var author = author_1.getCurrentAuthor();
        var _a = this.props, editorState = _a.editorState, suggestingMode = _a.suggestingMode, toggleBlockStyle = _a.toggleBlockStyle, createChangeBlockStyleSuggestion = _a.createChangeBlockStyleSuggestion;
        if (suggestingMode) {
            // select the whole paragraph(s) and then check if
            // no other user has a suggestion on that selection
            if (!Suggestions.allowEditSuggestionOnBlock(editorState, author)) {
                return;
            }
            createChangeBlockStyleSuggestion(type, active);
        }
        else {
            toggleBlockStyle(type);
        }
    };
    BlockStyleButtonsComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, editorState = _a.editorState, editorFormat = _a.editorFormat;
        var selection = editorState.getSelection();
        var blockStyleKeys = Object.keys(blockStyles);
        var blockType = editorState
            .getCurrentContent()
            .getBlockForKey(selection.getStartKey())
            .getType();
        return (react_1.default.createElement("span", null, blockStyleKeys.filter(function (type) { return editorFormat.indexOf(type) > -1; }).map(function (type) {
            return react_1.default.createElement(StyleButton_1.default, { key: type, active: blockStyles[type] === blockType, label: type, onToggle: _this.onToggle, style: blockStyles[type] });
        })));
    };
    return BlockStyleButtonsComponent;
}(react_1.default.Component));
exports.BlockStyleButtonsComponent = BlockStyleButtonsComponent;
BlockStyleButtonsComponent.propTypes = {
    editorState: prop_types_1.default.object,
    suggestingMode: prop_types_1.default.bool,
    editorFormat: prop_types_1.default.array,
    toggleBlockStyle: prop_types_1.default.func,
    createChangeBlockStyleSuggestion: prop_types_1.default.func,
};
var mapStateToProps = function (state) { return ({
    editorState: state.editorState,
    editorFormat: state.editorFormat,
    suggestingMode: state.suggestingMode,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    toggleBlockStyle: function (blockType) { return dispatch(actions.toggleBlockStyle(blockType)); },
    createChangeBlockStyleSuggestion: function (type, active) { return dispatch(actions.createChangeBlockStyleSuggestion(type, active)); },
}); };
var BlockStyleButtons = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(BlockStyleButtonsComponent);
exports.default = BlockStyleButtons;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var StyleButton_1 = __importDefault(__webpack_require__(132));
var actions = __importStar(__webpack_require__(24));
var react_redux_1 = __webpack_require__(25);
var inlineStyles_1 = __webpack_require__(113);
var Suggestions = __importStar(__webpack_require__(133));
var author_1 = __webpack_require__(134);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name InlineStyleButtons
 * @description Inline style functional component, will manage the inline style related toolbar buttons
 */
var InlineStyleButtonsComponent = /** @class */ (function (_super) {
    __extends(InlineStyleButtonsComponent, _super);
    function InlineStyleButtonsComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggle = _this.onToggle.bind(_this);
        return _this;
    }
    InlineStyleButtonsComponent.prototype.onToggle = function (type, active) {
        var author = author_1.getCurrentAuthor();
        var _a = this.props, editorState = _a.editorState, suggestingMode = _a.suggestingMode, toggleInlineStyle = _a.toggleInlineStyle, createChangeStyleSuggestion = _a.createChangeStyleSuggestion;
        var selection = editorState.getSelection();
        if (suggestingMode && !selection.isCollapsed()) {
            if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)
                && !Suggestions.allowEditSuggestionOnRight(editorState, author)) {
                return;
            }
            createChangeStyleSuggestion(type, active);
        }
        else {
            toggleInlineStyle(type);
        }
    };
    InlineStyleButtonsComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, editorFormat = _a.editorFormat, editorState = _a.editorState;
        var currentStyle = editorState.getCurrentInlineStyle();
        return (react_1.default.createElement("span", null, editorFormat.filter(function (type) { return type in inlineStyles_1.inlineStyles; }).map(function (type) {
            return react_1.default.createElement(StyleButton_1.default, { key: type, active: currentStyle.has(inlineStyles_1.inlineStyles[type]), label: type, onToggle: _this.onToggle, style: inlineStyles_1.inlineStyles[type] });
        })));
    };
    return InlineStyleButtonsComponent;
}(react_1.default.Component));
exports.InlineStyleButtonsComponent = InlineStyleButtonsComponent;
InlineStyleButtonsComponent.propTypes = {
    editorState: prop_types_1.default.object,
    editorFormat: prop_types_1.default.array,
    suggestingMode: prop_types_1.default.bool,
    toggleInlineStyle: prop_types_1.default.func,
    createChangeStyleSuggestion: prop_types_1.default.func,
};
var mapStateToProps = function (state) { return ({
    editorState: state.editorState,
    editorFormat: state.editorFormat,
    suggestingMode: state.suggestingMode,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    toggleInlineStyle: function (type) { return dispatch(actions.toggleInlineStyle(type)); },
    createChangeStyleSuggestion: function (type, active) { return dispatch(actions.createChangeStyleSuggestion(type, active)); },
}); };
var InlineStyleButtons = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(InlineStyleButtonsComponent);
exports.default = InlineStyleButtons;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var StyleButton_1 = __importDefault(__webpack_require__(132));
var actions = __importStar(__webpack_require__(24));
var inlineStyles_1 = __webpack_require__(113);
var table_1 = __webpack_require__(112);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name TableControlsComponent
 * @param {Function} addRowAfter
 * @param {Function} addColAfter
 * @param {Function} removeRow
 * @param {Function} removeCol
 * @description Holds the toolbar for table operations.
 */
var TableControlsComponent = function (_a) {
    var addRowAfter = _a.addRowAfter, addColAfter = _a.addColAfter, removeRow = _a.removeRow, removeCol = _a.removeCol, activeCell = _a.activeCell, editorState = _a.editorState, editorFormat = _a.editorFormat, toggleTableHead = _a.toggleTableHead, toggleTableStyle = _a.toggleTableStyle, className = _a.className;
    var i = activeCell.i, j = activeCell.j, key = activeCell.key, currentStyle = activeCell.currentStyle, selection = activeCell.selection;
    var contentState = editorState.getCurrentContent();
    var data = table_1.getData(contentState, key);
    var withHeader = data.withHeader;
    var cellEditorState = table_1.getCell(data, i, j, currentStyle, selection);
    var currentInlineStyle = cellEditorState.getCurrentInlineStyle();
    return react_1.default.createElement("div", { className: 'table-controls ' + className },
        react_1.default.createElement(StyleButton_1.default, { active: withHeader, label: 'TH', onToggle: toggleTableHead }),
        react_1.default.createElement("span", { className: "Editor3-styleButton Editor3-styleButton--short", onClick: removeRow },
            react_1.default.createElement("i", { className: "icon-minus-sign" })),
        react_1.default.createElement("span", { className: "Editor3-styleButton", onClick: addRowAfter },
            react_1.default.createElement("i", { className: "icon-plus-sign" }),
            " row"),
        react_1.default.createElement("span", { className: "Editor3-styleButton Editor3-styleButton--short", onClick: removeCol },
            react_1.default.createElement("i", { className: "icon-minus-sign" })),
        react_1.default.createElement("span", { className: "Editor3-styleButton", onClick: addColAfter },
            react_1.default.createElement("i", { className: "icon-plus-sign" }),
            " col"),
        editorFormat.filter(function (type) { return type in inlineStyles_1.inlineStyles; })
            .map(function (type) {
            return react_1.default.createElement(StyleButton_1.default, { key: type, active: currentInlineStyle.has(inlineStyles_1.inlineStyles[type]), label: type, onToggle: toggleTableStyle, style: inlineStyles_1.inlineStyles[type] });
        }));
};
TableControlsComponent.propTypes = {
    addRowAfter: prop_types_1.default.func,
    addColAfter: prop_types_1.default.func,
    removeRow: prop_types_1.default.func,
    removeCol: prop_types_1.default.func,
    activeCell: prop_types_1.default.object.isRequired,
    editorState: prop_types_1.default.object,
    editorFormat: prop_types_1.default.array,
    toggleTableHead: prop_types_1.default.func,
    toggleTableStyle: prop_types_1.default.func,
    className: prop_types_1.default.string,
};
var mapDispatchToProps = function (dispatch) { return ({
    addRowAfter: function () { return dispatch(actions.addRowAfter()); },
    addColAfter: function () { return dispatch(actions.addColAfter()); },
    removeRow: function () { return dispatch(actions.removeRow()); },
    removeCol: function () { return dispatch(actions.removeCol()); },
    toggleTableHead: function () { return dispatch(actions.toggleTableHeader()); },
    toggleTableStyle: function (inlineStyle) { return dispatch(actions.toggleTableStyle(inlineStyle)); },
}); };
var mapStateToProps = function (state) { return ({
    activeCell: state.activeCell,
    editorState: state.editorState,
    editorFormat: state.editorFormat,
}); };
var TableControls = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TableControlsComponent);
exports.default = TableControls;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var react_redux_1 = __webpack_require__(25);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name SelectionButton
 * @param {Object} editorState The editor state object.
 * @description SelectionButton is a button that can be added to the toolbar, which only
 * becomes active and clickable when a selection is made in the editor. This is for actions
 * that are bound exclusively to having text selected in the editor, such as: links, comments,
 * annotations, etc. Note that a precondition prop may be supplied which precedes any other condition.
 */
var SelectionButtonComponent = function (_a) {
    var editorState = _a.editorState, onClick = _a.onClick, tooltip = _a.tooltip, iconName = _a.iconName, precondition = _a.precondition;
    var isCollapsed = editorState.getSelection().isCollapsed();
    var inactive = !precondition || isCollapsed;
    var cx = classnames_1.default({ inactive: inactive });
    var clickHandler = function () {
        if (!inactive) {
            onClick({
                selection: editorState.getSelection(),
            });
        }
    };
    return (react_1.default.createElement("div", { "data-flow": 'down', "data-sd-tooltip": tooltip, className: "Editor3-styleButton" },
        react_1.default.createElement("span", { className: cx, onClick: clickHandler },
            react_1.default.createElement("i", { className: "icon-" + iconName }))));
};
SelectionButtonComponent.propTypes = {
    iconName: prop_types_1.default.string.isRequired,
    editorState: prop_types_1.default.object.isRequired,
    tooltip: prop_types_1.default.string,
    precondition: prop_types_1.default.bool,
    onClick: prop_types_1.default.func.isRequired,
};
SelectionButtonComponent.defaultProps = {
    precondition: true,
};
var mapStateToProps = function (state) { return ({
    editorState: state.editorState,
    options: state.editorFormat,
}); };
exports.SelectionButton = react_redux_1.connect(mapStateToProps, null)(SelectionButtonComponent);


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name IconButton
 * @description IconButton displays a button with an icon on the toolbar.
 */
exports.IconButton = function (_a) {
    var onClick = _a.onClick, iconName = _a.iconName, tooltip = _a.tooltip;
    return react_1.default.createElement("div", { "data-flow": 'down', "data-sd-tooltip": tooltip, className: "Editor3-styleButton" },
        react_1.default.createElement("span", { onClick: onClick },
            react_1.default.createElement("i", { className: "icon-" + iconName })));
};
exports.IconButton.propTypes = {
    onClick: prop_types_1.default.func.isRequired,
    tooltip: prop_types_1.default.string,
    iconName: prop_types_1.default.string.isRequired,
};


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var links_1 = __webpack_require__(195);
var comments_1 = __webpack_require__(494);
var annotations_1 = __webpack_require__(528);
var embeds_1 = __webpack_require__(540);
var actions_1 = __webpack_require__(24);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @param {Function} onCancel
 * @param {PopupTypes} type Popup type.
 * @param {Object} data Metadata to pass to the pop-up (generally the SelectionState in the editor at
 * the time).
 * @description ToolbarPopupComponent renders the popup specified by the type property and passes it
 * the onCancel value along with the given prop data.
 */
var ToolbarPopup = /** @class */ (function (_super) {
    __extends(ToolbarPopup, _super);
    function ToolbarPopup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolbarPopup.prototype.render = function () {
        var _a = this.props, type = _a.type, data = _a.data;
        switch (type) {
            case actions_1.PopupTypes.Annotation:
                return (react_1.default.createElement(annotations_1.AnnotationInput, { data: data, editorState: this.props.editorState, highlightsManager: this.props.highlightsManager }));
            case actions_1.PopupTypes.Comment:
                return react_1.default.createElement(comments_1.CommentInput, { data: data, highlightsManager: this.props.highlightsManager });
            case actions_1.PopupTypes.Link:
                return react_1.default.createElement(links_1.LinkInput, { data: data });
            case actions_1.PopupTypes.Embed:
                return react_1.default.createElement(embeds_1.EmbedInput, null);
        }
        return null;
    };
    return ToolbarPopup;
}(react_1.default.Component));
exports.ToolbarPopup = ToolbarPopup;
ToolbarPopup.propTypes = {
    type: prop_types_1.default.string,
    data: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object.isRequired,
    editorState: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var draft_js_1 = __webpack_require__(16);
var entityUtils_1 = __webpack_require__(79);
var components_1 = __webpack_require__(23);
var AttachmentList_1 = __webpack_require__(1193);
var actions_1 = __webpack_require__(24);
var ReactRenderAsync_1 = __webpack_require__(54);
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name LinkInput
 * @param {Object} editorState The editor state object.
 * @param {string} data The default value for the input.
 * @description This components holds the input form for entering a new URL.
 */
var linkTypes = {
    href: 'href',
    attachement: 'attachement',
};
var LinkInputComponent = /** @class */ (function (_super) {
    __extends(LinkInputComponent, _super);
    function LinkInputComponent(props) {
        var _this = _super.call(this, props) || this;
        // when non-null, holds the entity whos URL is being edited
        _this.entity = null;
        _this.tabs = [
            { label: utils_1.gettext('URL'), render: _this.renderURL.bind(_this) },
        ];
        if (props.item) {
            _this.tabs.push({ label: utils_1.gettext('Attachment'), render: _this.renderAttachment.bind(_this) });
        }
        _this.activeTab = 0;
        var selectedAttachment;
        if (props.data) {
            // if a value has been passed, it is safe to assume that it
            // is coming from the currently selected entity
            _this.entity = entityUtils_1.getSelectedEntity(props.editorState);
            if (props.data.attachment) {
                _this.activeTab = 1;
                selectedAttachment = props.data.attachment;
            }
        }
        var initialValue = 'https://';
        _this.state = {
            url: _this.props.data ? _this.props.data.href || initialValue : initialValue,
            selected: selectedAttachment,
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.selectAttachment = _this.selectAttachment.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name LinkInput#onSubmit
     * @description Callback when submitting the form.
     */
    LinkInputComponent.prototype.onSubmit = function (linkType) {
        var link;
        var _a = this.props, suggestingMode = _a.suggestingMode, localDomains = _a.localDomains;
        var _createLinkSuggestion = this.props.createLinkSuggestion;
        var _applyLink = this.props.applyLink;
        var _changeLinkSuggestion = this.props.changeLinkSuggestion;
        if (linkType === linkTypes.href) {
            var url_1 = this.state.url;
            var isLocalDomain = (localDomains || []).some(function (item) { return url_1.includes(item.domain); });
            link = { href: url_1 };
            if (!isLocalDomain && localDomains != null) {
                link.target = '_blank';
            }
        }
        else if (linkType === linkTypes.attachement) {
            link = { attachment: this.state.selected };
        }
        else {
            throw new Error('link type not recognized');
        }
        if (!link.href && !link.attachment) {
            return;
        }
        if (suggestingMode) {
            if (this.entity) {
                _changeLinkSuggestion(link, this.entity);
            }
            else {
                _createLinkSuggestion(link);
            }
        }
        else {
            _applyLink(link, this.entity);
        }
        this.props.hidePopups();
    };
    /**
     * @ngdoc method
     * @name LinkInput#onKeyUp
     * @description Handles key up events in the editor. Cancells input when
     * Esc is pressed.
     */
    LinkInputComponent.prototype.onKeyUp = function (e) {
        if (e.key === 'Escape') {
            this.props.hidePopups();
        }
    };
    LinkInputComponent.prototype.componentDidMount = function () {
        if (this.inputElement != null) {
            this.inputElement.focus();
            var savedValue = this.inputElement.value;
            // re-apply the value so cursor is at the end, not the start
            // related https://stackoverflow.com/q/511088/1175593
            this.inputElement.value = '';
            this.inputElement.value = savedValue;
        }
    };
    LinkInputComponent.prototype.selectAttachment = function (file) {
        this.setState({ selected: file._id });
    };
    LinkInputComponent.prototype.render = function () {
        return (react_1.default.createElement(components_1.Dropdown, { open: true, className: "dropdown--link-input" },
            react_1.default.createElement(components_1.NavTabs, { tabs: this.tabs, active: this.activeTab })));
    };
    LinkInputComponent.prototype.renderURL = function () {
        var _this = this;
        return (react_1.default.createElement("form", { onSubmit: function () {
                _this.onSubmit(linkTypes.href);
            }, className: "link-input", onKeyUp: this.onKeyUp },
            react_1.default.createElement("div", { style: { padding: '3.4rem 2rem' } },
                react_1.default.createElement("input", { type: "url", ref: function (el) {
                        _this.inputElement = el;
                    }, className: "sd-line-input__input", value: this.state.url, onChange: function (e) {
                        _this.setState({ url: e.target.value });
                    }, placeholder: utils_1.gettext('Insert URL') })),
            react_1.default.createElement("div", { className: "dropdown__menu-footer dropdown__menu-footer--align-right" },
                react_1.default.createElement("button", { className: "btn btn--cancel", onClick: this.props.hidePopups }, utils_1.gettext('Cancel')),
                react_1.default.createElement("button", { className: "btn btn--primary", type: "submit", disabled: this.state.url.length < 1 }, utils_1.gettext('Insert')))));
    };
    LinkInputComponent.prototype.renderAttachment = function () {
        var _this = this;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(AttachmentList_1.AttachmentList, { item: this.props.item, onClick: this.selectAttachment, selected: this.state.selected }),
            react_1.default.createElement("div", { className: "dropdown__menu-footer dropdown__menu-footer--align-right" },
                react_1.default.createElement("button", { className: "btn btn--cancel", onClick: this.props.hidePopups }, utils_1.gettext('Cancel')),
                react_1.default.createElement("button", { className: "btn btn--primary", disabled: this.state.selected == null, onClick: function () {
                        _this.onSubmit(linkTypes.attachement);
                    } }, utils_1.gettext('Insert')))));
    };
    return LinkInputComponent;
}(react_1.default.Component));
exports.LinkInputComponent = LinkInputComponent;
LinkInputComponent.propTypes = {
    editorState: prop_types_1.default.instanceOf(draft_js_1.EditorState).isRequired,
    applyLink: prop_types_1.default.func.isRequired,
    hidePopups: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.object,
    item: prop_types_1.default.object,
    suggestingMode: prop_types_1.default.bool,
    createLinkSuggestion: prop_types_1.default.func,
    changeLinkSuggestion: prop_types_1.default.func,
    localDomains: prop_types_1.default.array,
};
var mapStateToProps = function (state) { return ({
    item: state.item,
    editorState: state.editorState,
    suggestingMode: state.suggestingMode,
}); };
var LinkInputComponentWithDependenciesLoaded = ReactRenderAsync_1.connectPromiseResults(function () { return ({
    localDomains: ng_1.default.get('metadata').initialize()
        .then(function () { return ng_1.default.get('metadata').values.local_domains; }),
}); })(LinkInputComponent);
exports.LinkInput = react_redux_1.connect(mapStateToProps, {
    applyLink: actions_1.applyLink,
    hidePopups: actions_1.hidePopups,
    createLinkSuggestion: actions_1.createLinkSuggestion,
    changeLinkSuggestion: actions_1.changeLinkSuggestion,
})(LinkInputComponentWithDependenciesLoaded);


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Group
 * @description Component to group a list of items
 */
exports.Group = function (_a) {
    var className = _a.className, children = _a.children, spaceBetween = _a.spaceBetween, verticalScroll = _a.verticalScroll, style = _a.style, onScroll = _a.onScroll, refNode = _a.refNode, shadow = _a.shadow;
    return (react_1.default.createElement("div", { className: classnames_1.default(className, 'sd-list-item-group', shadow ? "sd-shadow--z" + shadow : null, {
            'sd-list-item-group--space-between-items': spaceBetween,
            'sd-list-item-group--vertical-scroll': verticalScroll,
        }), style: style, onScroll: onScroll, ref: refNode }, children));
};
exports.Group.propTypes = {
    className: prop_types_1.default.string,
    children: prop_types_1.default.node.isRequired,
    spaceBetween: prop_types_1.default.bool,
    verticalScroll: prop_types_1.default.bool,
    style: prop_types_1.default.object,
    onScroll: prop_types_1.default.func,
    refNode: prop_types_1.default.func,
    shadow: prop_types_1.default.oneOf([1, 2, 3, 4]),
};
exports.Group.defaultProps = {
    spaceBetween: false,
    verticalScroll: false,
    style: {},
};


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Item
 * @description Component to encapsulate a list item
 */
exports.Item = function (_a) {
    var children = _a.children, noBg = _a.noBg, noHover = _a.noHover, shadow = _a.shadow, activated = _a.activated, className = _a.className, onClick = _a.onClick, margin = _a.margin;
    return (react_1.default.createElement("div", { className: classnames_1.default(className, 'sd-list-item', { 'sd-list-item--no-bg': noBg }, { 'sd-list-item--no-hover': noHover }, { 'sd-list-item--margin': margin }, shadow ? "sd-shadow--z" + shadow : null, { 'sd-list-item--activated': activated }), onClick: onClick }, children));
};
exports.Item.propTypes = {
    children: prop_types_1.default.node.isRequired,
    noBg: prop_types_1.default.bool,
    noHover: prop_types_1.default.bool,
    shadow: prop_types_1.default.oneOf([1, 2, 3, 4]),
    activated: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    margin: prop_types_1.default.bool,
};
exports.Item.defaultProps = {
    noBg: false,
    noHover: false,
    margin: false,
};


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Border
 * @description Component to show border for a list item. Eg. red border for locked item
 */
exports.Border = function (_a) {
    var state = _a.state;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-item__border', state ? "sd-list-item__border--" + state : null) }));
};
exports.Border.propTypes = {
    state: prop_types_1.default.oneOf([
        false,
        'success',
        'error',
        'locked',
        'active',
        'idle',
    ]),
};
exports.Border.defaultProps = { state: false };


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Row
 * @description Row Component in a list of item where each item is a row
 */
exports.Row = function (_a) {
    var children = _a.children, classes = _a.classes, paddingBottom = _a.paddingBottom;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-item__row', classes, {
            'sd-list-item__row--padding-b5': paddingBottom,
        }) }, children));
};
exports.Row.propTypes = {
    children: prop_types_1.default.node.isRequired,
    classes: prop_types_1.default.string,
    margin: prop_types_1.default.bool,
    marginTop: prop_types_1.default.bool,
    paddingBottom: prop_types_1.default.bool,
};
exports.Row.defaultProps = {
    classes: '',
    margin: true,
    marginTop: false,
};


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name ActionMenu
 * @description Component to encapsulate three-dot action menu in list a item
 */
exports.ActionMenu = function (_a) {
    var children = _a.children, row = _a.row;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-item__action-menu', { 'sd-list-item__action-menu--direction-row': row }) }, children));
};
exports.ActionMenu.propTypes = {
    children: prop_types_1.default.node.isRequired,
    row: prop_types_1.default.bool,
};
exports.ActionMenu.defaultProps = { row: true };


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(28);
var Column_1 = __webpack_require__(196);
var Form_1 = __webpack_require__(30);
/**
 * @ngdoc react
 * @name ItemType
 * @description Component to show item type - generally left of the item with select checkbox
 */
exports.ItemType = function (_a) {
    var hasCheck = _a.hasCheck, checked = _a.checked, onCheckToggle = _a.onCheckToggle;
    return (react_1.default.createElement(Column_1.Column, { hasCheck: hasCheck, checked: checked }, hasCheck && (react_1.default.createElement("div", { className: "sd-list-item__checkbox-container" },
        react_1.default.createElement(Form_1.Checkbox, { value: checked, onChange: function (field, value) {
                onCheckToggle(value);
            } })))));
};
exports.ItemType.propTypes = {
    onCheckToggle: prop_types_1.default.func,
    item: prop_types_1.default.object.isRequired,
    checked: prop_types_1.default.bool,
    hasCheck: prop_types_1.default.bool,
    color: prop_types_1.default.oneOf(lodash_1.values(constants_1.ICON_COLORS)),
};


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.file-input .sd-line-input__input {\n  padding-right: 25px !important; }\n\n.file-input--hidden {\n  display: none; }\n\n.link-input .sd-line-input__input {\n  padding-right: 35px !important; }\n\n.no-padding {\n  padding: 0; }\n\n.form__row--half-width {\n  max-width: 50%; }\n\n.sd-line-input .sd-line-input__icon-bottom-right {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  cursor: pointer; }\n\n.sd-line-input .sd-line-input__input--auto-height {\n  resize: none;\n  overflow: hidden;\n  min-height: 2.4rem; }\n\n.sd-line-input .sd-line-input__input--padding-right-60 {\n  padding-right: 60px !important; }\n\n.sd-line-input--invalid, .form-label--invalid {\n  color: #E51C23; }\n  .sd-line-input--invalid .sd-line-input__icon-bottom-right, .form-label--invalid .sd-line-input__icon-bottom-right {\n    bottom: 18px; }\n", ""]);

// exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name RowItem
 * @description Component to encapsulate a component in row-item style
 */
exports.RowItem = function (_a) {
    var children = _a.children, noGrow = _a.noGrow, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('form__row-item', { 'form__row-item--no-grow': noGrow }, className) }, children));
};
exports.RowItem.propTypes = {
    children: prop_types_1.default.node,
    noGrow: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.RowItem.defaultProps = { noGrow: false };


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name Select
 * @description Component to select a list from dropdown
 */
exports.Select = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, options = _a.options, readOnly = _a.readOnly, clearable = _a.clearable, autoFocus = _a.autoFocus, onFocus = _a.onFocus, refNode = _a.refNode;
    return (react_1.default.createElement("select", { className: "sd-line-input__select", value: value, onChange: function (e) { return onChange(field, e.target.value); }, name: field, disabled: !!readOnly, autoFocus: autoFocus, ref: refNode, onFocus: onFocus },
        clearable && (react_1.default.createElement("option", { value: "" })),
        options.map(function (opt) { return (react_1.default.createElement("option", { key: opt.key, value: opt.key }, opt.label)); })));
};
exports.Select.propTypes = {
    field: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
    ]),
    onChange: prop_types_1.default.func.isRequired,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.number,
        ]),
        label: prop_types_1.default.string,
    })),
    readOnly: prop_types_1.default.bool,
    clearable: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
    refNode: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
exports.Select.defaultProps = {
    readOnly: false,
    clearable: false,
    autoFocus: false,
};


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(30);
var LineInput_1 = __webpack_require__(197);
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc react
 * @name TextInput
 * @description Component to recieve text input in
 */
exports.TextInput = function (_a) {
    var field = _a.field, label = _a.label, value = _a.value, onChange = _a.onChange, maxLength = _a.maxLength, invalid = _a.invalid, readOnly = _a.readOnly, type = _a.type, inputClassName = _a.inputClassName, refNode = _a.refNode, autoFocus = _a.autoFocus, onFocus = _a.onFocus, props = __rest(_a, ["field", "label", "value", "onChange", "maxLength", "invalid", "readOnly", "type", "inputClassName", "refNode", "autoFocus", "onFocus"]);
    return (react_1.default.createElement(_1.LineInput, __assign({}, props, { invalid: invalid, readOnly: readOnly }),
        react_1.default.createElement(_1.Label, { text: label }),
        react_1.default.createElement(_1.Input, { field: field, value: value, onChange: onChange, type: type, readOnly: readOnly, refNode: refNode, className: inputClassName, autoFocus: autoFocus, onFocus: onFocus }),
        maxLength > 0 &&
            react_1.default.createElement("div", { className: "sd-line-input__char-count" },
                lodash_1.get(value, 'length', 0),
                "/",
                maxLength)));
};
exports.TextInput.propTypes = __assign({ field: prop_types_1.default.string, label: prop_types_1.default.string, value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
    ]), onChange: prop_types_1.default.func, maxLength: prop_types_1.default.number, type: prop_types_1.default.string, refNode: prop_types_1.default.func, inputClassName: prop_types_1.default.string, autoFocus: prop_types_1.default.bool }, LineInput_1.LineInputProps);
exports.TextInput.defaultProps = __assign({ maxLength: 0, type: 'text', value: '' }, LineInput_1.LineInputDefaultProps);


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var _1 = __webpack_require__(30);
__webpack_require__(90);
/**
 * @ngdoc react
 * @name TextAreaInput
 * @description Component to multi-line text input with Field Label
 */
exports.TextAreaInput = function (_a) {
    var field = _a.field, value = _a.value, label = _a.label, onChange = _a.onChange, autoHeight = _a.autoHeight, autoHeightTimeout = _a.autoHeightTimeout, nativeOnChange = _a.nativeOnChange, placeholder = _a.placeholder, readOnly = _a.readOnly, maxLength = _a.maxLength, onFocus = _a.onFocus, props = __rest(_a, ["field", "value", "label", "onChange", "autoHeight", "autoHeightTimeout", "nativeOnChange", "placeholder", "readOnly", "maxLength", "onFocus"]);
    return (react_1.default.createElement(_1.LineInput, __assign({}, props, { readOnly: readOnly }),
        react_1.default.createElement(_1.Label, { text: label }),
        react_1.default.createElement(_1.TextArea, { field: field, value: value, onChange: onChange, autoHeight: autoHeight, autoHeightTimeout: autoHeightTimeout, nativeOnChange: nativeOnChange, placeholder: placeholder, readOnly: readOnly, onFocus: onFocus }),
        maxLength > 0 &&
            react_1.default.createElement("div", { className: "sd-line-input__char-count" },
                lodash_1.get(value, 'length', 0),
                "/",
                maxLength)));
};
exports.TextAreaInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    maxLength: prop_types_1.default.number,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noLabel: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    autoHeight: prop_types_1.default.bool,
    autoHeightTimeout: prop_types_1.default.number,
    nativeOnChange: prop_types_1.default.bool,
    placeholder: prop_types_1.default.string,
    onFocus: prop_types_1.default.func,
};
exports.TextAreaInput.defaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
    autoHeight: true,
    autoHeightTimeout: 50,
    nativeOnChange: false,
    maxLength: 0,
};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(30);
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc react
 * @name SelectInput
 * @description Component to select a list from dropdown with field label
 */
exports.SelectInput = function (_a) {
    var field = _a.field, label = _a.label, value = _a.value, options = _a.options, keyField = _a.keyField, labelField = _a.labelField, onChange = _a.onChange, readOnly = _a.readOnly, clearable = _a.clearable, autoFocus = _a.autoFocus, refNode = _a.refNode, onFocus = _a.onFocus, props = __rest(_a, ["field", "label", "value", "options", "keyField", "labelField", "onChange", "readOnly", "clearable", "autoFocus", "refNode", "onFocus"]);
    var key = clearable ?
        lodash_1.get(value, keyField, '') :
        lodash_1.get(value, keyField, lodash_1.get(options, "[0]." + keyField));
    var opts = options.map(function (opt) { return ({
        key: lodash_1.get(opt, keyField),
        label: lodash_1.get(opt, labelField),
    }); });
    var onChangeHandler = function (_field, _key) {
        var _value = options.find(function (option) { return lodash_1.get(option, keyField) === _key; }) || null;
        onChange(_field, _value);
    };
    return (react_1.default.createElement(_1.LineInput, __assign({}, props, { isSelect: true, readOnly: readOnly }),
        react_1.default.createElement(_1.Label, { text: label }),
        react_1.default.createElement(_1.Select, { field: field, value: key, onChange: onChangeHandler, options: opts, readOnly: readOnly, clearable: clearable, autoFocus: autoFocus, refNode: refNode, onFocus: onFocus })));
};
exports.SelectInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.object,
    onChange: prop_types_1.default.func.isRequired,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.string,
        label: prop_types_1.default.string,
        value: prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.object,
            prop_types_1.default.number,
        ]),
    })).isRequired,
    keyField: prop_types_1.default.string,
    labelField: prop_types_1.default.string,
    clearable: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
    refNode: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
exports.SelectInput.defaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
    keyField: 'qcode',
    labelField: 'label',
    clearable: false,
    autoFocus: false,
};


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(30);
var __1 = __webpack_require__(23);
var utils_1 = __webpack_require__(32);
var utils_2 = __webpack_require__(3);
var lodash_1 = __webpack_require__(2);
__webpack_require__(90);
/**
 * @ngdoc react
 * @name FileInput
 * @description Component to sattach files as input
 */
var FileInput = /** @class */ (function (_super) {
    __extends(FileInput, _super);
    function FileInput(props) {
        var _this = _super.call(this, props) || this;
        _this.dom = { fileInput: null };
        _this.onAdd = _this.onAdd.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.getComponent = _this.getComponent.bind(_this);
        _this.onBrowseClick = _this.onBrowseClick.bind(_this);
        _this.onRemove = _this.onRemove.bind(_this);
        _this.onDragEnter = _this.onDragEnter.bind(_this);
        return _this;
    }
    FileInput.prototype.onBrowseClick = function () {
        if (this.dom.fileInput) {
            this.handleOnFocus();
            this.dom.fileInput.click();
        }
    };
    FileInput.prototype.onDragEnter = function (e) {
        e.dataTransfer.dropEffect = 'copy';
    };
    FileInput.prototype.handleOnFocus = function () {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    };
    FileInput.prototype.onDrop = function (event) {
        utils_1.onEventCapture(event);
        if (lodash_1.get(event, 'dataTransfer.files')) {
            this.handleOnFocus();
            this.onAdd(null, event.dataTransfer.files);
        }
    };
    FileInput.prototype.onAdd = function (field, fileList) {
        var files = Array.from(fileList).map(function (f) { return [f]; });
        this.props.onChange(this.props.field, this.props.value.concat(files));
    };
    FileInput.prototype.onRemove = function (index) {
        this.handleOnFocus();
        this.props.value.splice(index, 1);
        this.props.onChange(this.props.field, this.props.value.slice());
    };
    FileInput.prototype.getComponent = function (val, index) {
        if (index === void 0) { index = 0; }
        var _a = this.props, readOnly = _a.readOnly, onFocus = _a.onFocus, field = _a.field, createLink = _a.createLink;
        return readOnly ? (react_1.default.createElement(_1.Row, { key: index, noPadding: true }, lodash_1.get(val, 'media') && (react_1.default.createElement(_1.LineInput, { noMargin: true },
            react_1.default.createElement(_1.Label, { text: val.media.content_type + " (" + Math.round(val.media.length / 1024) + "kB)" }),
            react_1.default.createElement("a", { href: createLink(val), target: "_blank", rel: "noopener noreferrer" }, val.media.name))))) : (react_1.default.createElement(_1.Row, { className: "file-input", key: index, noPadding: true }, lodash_1.get(val, 'media') && (react_1.default.createElement(_1.LineInput, null,
            react_1.default.createElement("a", { className: "icn-btn sd-line-input__icon-right", onClick: this.onRemove.bind(null, index) },
                react_1.default.createElement("i", { className: "icon-trash" })),
            react_1.default.createElement("a", { href: createLink(val), target: "_blank", rel: "noopener noreferrer", onFocus: onFocus },
                val.media.name,
                "\u00A0 (",
                Math.round(val.media.length / 1024),
                "kB)"))) ||
            (react_1.default.createElement(_1.LineInput, { readOnly: readOnly, noMargin: true },
                react_1.default.createElement(_1.TextArea, { field: field, value: lodash_1.get(val, 'name'), readOnly: true, paddingRight60: true, autoFocus: true, tabIndex: 0, multiLine: false, onFocus: onFocus }),
                react_1.default.createElement("span", { className: "sd-line-input__icon-bottom-right" },
                    react_1.default.createElement(__1.IconButton, { onClick: this.onRemove.bind(null, index), tabIndex: 0, icon: "icon-trash", enterKeyIsClick: true }))))));
    };
    FileInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, field = _a.field, value = _a.value, readOnly = _a.readOnly, onFocus = _a.onFocus;
        return (react_1.default.createElement(_1.Row, null,
            value && Array.isArray(value) &&
                (value.map(function (val, index) { return (_this.getComponent(lodash_1.get(val, '[0]', val), index)); })) ||
                (value && (this.getComponent(value))),
            !readOnly && react_1.default.createElement("div", { onDrop: this.onDrop, onDragEnter: this.onDragEnter, className: "basic-drag-block" },
                react_1.default.createElement("i", { className: "big-icon--upload-alt" }),
                react_1.default.createElement("span", { className: "basic-drag-block__text" }, utils_2.gettext('Drag files here or ')),
                react_1.default.createElement("a", { className: "text-link link", onClick: this.onBrowseClick },
                    "\u00A0",
                    utils_2.gettext('browse'),
                    react_1.default.createElement(_1.Input, { className: "file-input--hidden", field: field, onChange: this.onAdd, type: "file", onFocus: onFocus, autoFocus: true, refNode: function (node) {
                            _this.dom.fileInput = node;
                        } })))));
    };
    return FileInput;
}(react_1.default.Component));
exports.FileInput = FileInput;
FileInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.array,
    onChange: prop_types_1.default.func,
    createLink: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
};


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
__webpack_require__(929);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var _1 = __webpack_require__(30);
var __1 = __webpack_require__(23);
__webpack_require__(90);
/**
 * @ngdoc react
 * @name LinkInput
 * @description Component to attach links as input
 */
var LinkInput = /** @class */ (function (_super) {
    __extends(LinkInput, _super);
    function LinkInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: props.value };
        _this.errorTitle = utils_1.gettext('Could not load title');
        return _this;
    }
    LinkInput.prototype.componentWillMount = function () {
        this.setTitle(this.props.value);
    };
    LinkInput.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setTitle(nextProps.value);
        }
    };
    LinkInput.prototype.extractHostname = function (link) {
        var hostname;
        // Find & remove protocol (http, ftp, etc.) and get hostname
        if (link.indexOf('://') > -1) {
            hostname = link.split('/')[2];
        }
        else {
            hostname = link.split('/')[0];
        }
        // Find & remove port number
        hostname = hostname.split(':')[0];
        // Find & remove "?"
        hostname = hostname.split('?')[0];
        return hostname.replace('www.', '');
    };
    LinkInput.prototype.getAbsoulteURL = function (link) {
        var hostname = this.extractHostname(link);
        var protocol = link.indexOf('://') > -1 ? link.split('/')[0] : 'http:';
        var resource = link.substr(link.indexOf(hostname) + hostname.length);
        // Only add 'www.' back in if the original link has 'www.' in it
        if (link.indexOf('://www.') > -1) {
            hostname = 'www.' + hostname;
        }
        return protocol + "//" + hostname + resource;
    };
    LinkInput.prototype.setTitle = function (link) {
        var _this = this;
        if (!link) {
            return;
        }
        if (!this.props.iframelyKey) {
            this.setState({ title: 'www.' + this.extractHostname(link) });
            return;
        }
        var url = 'https://iframe.ly/api/iframely?url=' + link + '&api_key=' + this.props.iframelyKey;
        fetch(url).then(function (response) {
            // Need to do HTTP response status check manually for whatwg-fetch
            // refer: https://www.npmjs.com/package/whatwg-fetch
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            }
            else {
                _this.setState({ title: _this.errorTitle });
            }
        })
            .then(function (json) {
            _this.setState({ title: json.meta.title });
        })
            .catch(function () {
            // This is in cases of network failure issues
            // refer: https://www.npmjs.com/package/whatwg-fetch
            _this.setState({ title: _this.errorTitle });
        });
    };
    LinkInput.prototype.render = function () {
        var _a = this.props, value = _a.value, field = _a.field, remove = _a.remove, onChange = _a.onChange, label = _a.label, readOnly = _a.readOnly, iframelyKey = _a.iframelyKey, onFocus = _a.onFocus, props = __rest(_a, ["value", "field", "remove", "onChange", "label", "readOnly", "iframelyKey", "onFocus"]);
        var showLink = this.state.title &&
            !props.message &&
            lodash_1.get(value, 'length', 0) > 0;
        return readOnly ? (react_1.default.createElement(_1.Row, null,
            react_1.default.createElement(_1.LineInput, { noMargin: true },
                react_1.default.createElement(_1.Label, { text: this.state.title }),
                react_1.default.createElement("a", { href: this.getAbsoulteURL(value), target: "_blank", rel: "noopener noreferrer" }, value)))) : (react_1.default.createElement(_1.Row, { className: "link-input" },
            react_1.default.createElement(_1.LineInput, __assign({}, props, { readOnly: readOnly, noMargin: true }),
                react_1.default.createElement(_1.Label, { text: label }),
                react_1.default.createElement(_1.TextArea, { field: field, value: value, onChange: onChange, placeholder: "Paste link", readOnly: readOnly, paddingRight60: true, autoFocus: true, tabIndex: 0, multiLine: false, onFocus: onFocus }),
                showLink && iframelyKey && (react_1.default.createElement("a", { href: this.getAbsoulteURL(value), target: "_blank", rel: "noopener noreferrer" }, this.state.title)),
                react_1.default.createElement("span", { className: "sd-line-input__icon-bottom-right" },
                    showLink && (react_1.default.createElement(__1.IconButton, { href: this.getAbsoulteURL(value), target: "_blank", icon: "icon-link" })),
                    react_1.default.createElement(__1.IconButton, { onClick: remove, tabIndex: 0, icon: "icon-trash", enterKeyIsClick: true })))));
    };
    return LinkInput;
}(react_1.default.Component));
exports.LinkInput = LinkInput;
LinkInput.propTypes = {
    remove: prop_types_1.default.func,
    field: prop_types_1.default.string,
    value: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    iframelyKey: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    message: prop_types_1.default.string,
    onFocus: prop_types_1.default.func,
};
LinkInput.defaultProps = {
    readOnly: false,
    value: '',
};


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var SelectFieldPopup_1 = __webpack_require__(931);
var lodash_1 = __webpack_require__(2);
var __1 = __webpack_require__(30);
var __2 = __webpack_require__(23);
__webpack_require__(434);
/**
 * @ngdoc react
 * @name SelectMetaTermsInput
 * @description Component to select metadata terms like Subjects/Category
 */
var SelectMetaTermsInput = /** @class */ (function (_super) {
    __extends(SelectMetaTermsInput, _super);
    function SelectMetaTermsInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            multiLevel: false,
            openSelectPopup: false,
        };
        _this.removeValue = _this.removeValue.bind(_this);
        _this.toggleOpenSelectPopup = _this.toggleOpenSelectPopup.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    SelectMetaTermsInput.prototype.componentWillMount = function () {
        // There is at least one parent or multi-level option
        this.setState({ multiLevel: this.props.options.filter(function (o) { return (o.parent); }).length > 0 });
    };
    SelectMetaTermsInput.prototype.toggleOpenSelectPopup = function () {
        this.setState({ openSelectPopup: !this.state.openSelectPopup });
        this.addBtn.focus();
    };
    SelectMetaTermsInput.prototype.removeValue = function (index) {
        var _a = this.props, value = _a.value, field = _a.field, onChange = _a.onChange;
        var newValue = lodash_1.cloneDeep(value);
        newValue.splice(index, 1);
        onChange(field, newValue);
    };
    SelectMetaTermsInput.prototype.removeValuesFromOptions = function () {
        if (!this.state.multiLevel) {
            return lodash_1.differenceBy(this.props.options, this.props.value, this.props.valueKey);
        }
        else {
            return this.props.options;
        }
    };
    SelectMetaTermsInput.prototype.onChange = function (opt) {
        var _a = this.props, value = _a.value, valueKey = _a.valueKey, onChange = _a.onChange, field = _a.field;
        // Check if it's duplicate
        if (value && value.length > 0) {
            if (value.find(function (v) { return (v[valueKey] === opt[valueKey]); })) {
                return;
            }
            onChange(field, value.concat([opt]));
        }
        else {
            onChange(field, [opt]);
        }
    };
    SelectMetaTermsInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, label = _a.label, labelKey = _a.labelKey, searchKey = _a.searchKey, valueKey = _a.valueKey, popupContainer = _a.popupContainer, readOnly = _a.readOnly, onFocus = _a.onFocus, props = __rest(_a, ["value", "label", "labelKey", "searchKey", "valueKey", "popupContainer", "readOnly", "onFocus"]);
        var options = this.removeValuesFromOptions();
        return (react_1.default.createElement(__1.LineInput, __assign({}, props, { withButton: true, readOnly: readOnly, className: classnames_1.default('dropdown-terms', 'select__meta-terms', { 'select__meta-terms--disabled': readOnly }) }),
            !readOnly && (react_1.default.createElement("button", { className: classnames_1.default('dropdown__toggle', 'sd-line-input__plus-btn', { 'sd-line-input__plus-btn--disabled': options.length === 0 }), onClick: options.length > 0 ? this.toggleOpenSelectPopup : null, onFocus: onFocus, ref: function (ref) {
                    _this.addBtn = ref;
                } })),
            react_1.default.createElement(__1.Label, { text: label }),
            react_1.default.createElement("div", { className: "sd-line-input__input" }, lodash_1.get(value, 'length', 0) > 0 && (react_1.default.createElement(__2.TermsList, { terms: value, displayField: labelKey, onClick: this.removeValue, readOnly: readOnly }))),
            this.state.openSelectPopup &&
                react_1.default.createElement(SelectFieldPopup_1.SelectFieldPopup, { value: value, multiLevel: this.state.multiLevel, options: options, onCancel: this.toggleOpenSelectPopup, target: "sd-line-input__plus-btn", onChange: function (opt) {
                        _this.onChange(opt);
                        _this.toggleOpenSelectPopup();
                    }, labelKey: labelKey, valueKey: valueKey, searchKey: searchKey, popupContainer: popupContainer })));
    };
    return SelectMetaTermsInput;
}(react_1.default.Component));
exports.SelectMetaTermsInput = SelectMetaTermsInput;
SelectMetaTermsInput.propTypes = {
    options: prop_types_1.default.array.isRequired,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.array,
        prop_types_1.default.shape(undefined),
        prop_types_1.default.shape({
            label: prop_types_1.default.string,
            value: prop_types_1.default.object,
        }),
    ]),
    label: prop_types_1.default.string,
    labelKey: prop_types_1.default.string,
    valueKey: prop_types_1.default.string,
    searchKey: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    required: prop_types_1.default.bool,
    field: prop_types_1.default.string,
    popupContainer: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
SelectMetaTermsInput.defaultProps = {
    required: false,
    labelKey: 'name',
    valueKey: 'qcode',
    searchKey: 'name',
};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var __1 = __webpack_require__(23);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(32);
var classnames_1 = __importDefault(__webpack_require__(4));
__webpack_require__(434);
var Popup_1 = __webpack_require__(80);
var constants_1 = __webpack_require__(28);
/**
 * @ngdoc react
 * @name SelectFieldPopup
 * @description Popup component for SelectMetaTermsInput
 */
var SelectFieldPopup = /** @class */ (function (_super) {
    __extends(SelectFieldPopup, _super);
    function SelectFieldPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentParent: null,
            selectedAncestry: [],
            search: false,
            activeOptionIndex: -1,
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.filterSearchResults = _this.filterSearchResults.bind(_this);
        _this.popParent = _this.popParent.bind(_this);
        _this.chooseEntireCategory = _this.chooseEntireCategory.bind(_this);
        _this.dom = {
            root: null,
            list: null,
            search: null,
        };
        return _this;
    }
    /**
     * @ngdoc method
     * @name SelectFieldPopup#onKeyDown
     * @description onKeyDown method to handle keyboard selection of options
     */
    SelectFieldPopup.prototype.onKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                    utils_1.onEventCapture(event);
                    this.handleEnterKey();
                    break;
                case constants_1.KEYCODES.DOWN:
                    utils_1.onEventCapture(event);
                    this.handleDownArrowKey(event);
                    break;
                case constants_1.KEYCODES.UP:
                    utils_1.onEventCapture(event);
                    this.handleUpArrowKey();
                    break;
                case constants_1.KEYCODES.LEFT:
                    utils_1.onEventCapture(event);
                    if (this.state.selectedAncestry.length > 0) {
                        this.popParent(true);
                    }
                    break;
                case constants_1.KEYCODES.RIGHT:
                    utils_1.onEventCapture(event);
                    if (this.state.activeOptionIndex !== -1) {
                        this.onMutiLevelSelect(this.state.filteredList[this.state.activeOptionIndex], true);
                    }
                    break;
            }
        }
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#handleEnterKey
     * @description handleEnterKey method to handle enter-key press on a selected option
     */
    SelectFieldPopup.prototype.handleEnterKey = function () {
        if (this.props.multiLevel) {
            if (this.state.activeOptionIndex !== -1) {
                this.onSelect(this.state.filteredList[this.state.activeOptionIndex]);
            }
            else {
                this.onSelect(this.state.currentParent);
            }
        }
        else if (this.state.activeOptionIndex !== -1) {
            this.onSelect(this.state.filteredList[this.state.activeOptionIndex]);
        }
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#handleDownArrowKey
     * @description handleDownArrowKey method to handle down-key press to select options
     */
    SelectFieldPopup.prototype.handleDownArrowKey = function (event) {
        if (event.target.id && event.target.id.indexOf('SearchBar') >= 0) {
            // Lose focus on SearchBar
            event.target.blur();
            this.setState({ activeOptionIndex: 0 });
        }
        else if (this.state.activeOptionIndex < this.state.filteredList.length - 1) {
            this.setState({ activeOptionIndex: this.state.activeOptionIndex + 1 });
            utils_1.scrollListItemIfNeeded(this.state.activeOptionIndex, this.dom.list);
        }
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#handleUpArrowKey
     * @description handleUpArrowKey method to handle up-key press to select options
     */
    SelectFieldPopup.prototype.handleUpArrowKey = function () {
        if (this.state.activeOptionIndex === 0) {
            if (this.state.selectedAncestry.length === 0) {
                // Search bar handle
                // Focus the searchBar input
                this.dom.search.dom.searchIcon.focus();
                this.setState({ activeOptionIndex: -1 });
            }
            else {
                // Choose entire category
                this.setState({ activeOptionIndex: -1 });
            }
        }
        else {
            this.setState({ activeOptionIndex: this.state.activeOptionIndex - 1 });
            utils_1.scrollListItemIfNeeded(this.state.activeOptionIndex, this.dom.list);
        }
    };
    SelectFieldPopup.prototype.componentWillMount = function () {
        this.setState({ filteredList: this.getFilteredOptionList() });
    };
    SelectFieldPopup.prototype.componentDidMount = function () {
        this.dom.search.dom.searchIcon.focus();
    };
    SelectFieldPopup.prototype.onSelect = function (opt) {
        this.props.onChange(opt);
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#getFilteredOptionList
     * @description getFilteredOptionList method to filter options list based on search text input
     */
    SelectFieldPopup.prototype.getFilteredOptionList = function (currentParent, searchList) {
        var _this = this;
        if (this.props.multiLevel) {
            var filteredList = void 0;
            if (searchList) {
                filteredList = searchList;
            }
            else {
                filteredList = currentParent ?
                    this.props.options.filter(function (option) { return (option.parent === lodash_1.get(currentParent, _this.props.valueKey)); }, this) :
                    this.props.options.filter(function (option) { return !option.parent; });
            }
            return filteredList;
        }
        else {
            return searchList ? searchList : this.props.options;
        }
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#onMutiLevelSelect
     * @description onMutiLevelSelect method handle selection of a parent option
     */
    SelectFieldPopup.prototype.onMutiLevelSelect = function (opt, keyDown) {
        var _this = this;
        if (keyDown === void 0) { keyDown = false; }
        if (opt && !this.state.searchList && this.isOptionAParent(opt)) {
            if (!this.state.selectedAncestry.find(function (o) { return (opt[_this.props.valueKey] === o[_this.props.valueKey]); })) {
                this.setState({
                    currentParent: opt,
                    selectedAncestry: this.state.selectedAncestry.concat([opt]),
                    filteredList: this.getFilteredOptionList(opt, null),
                    activeOptionIndex: 0,
                });
            }
        }
        else if (!keyDown) {
            this.onSelect(opt);
        }
    };
    SelectFieldPopup.prototype.isOptionAParent = function (opt) {
        var _this = this;
        return this.props.options.filter(function (option) { return (option.parent === lodash_1.get(opt, _this.props.valueKey)); }).length > 0;
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#chooseEntireCategory
     * @description chooseEntireCategory method choose selection of an entire parent option
     */
    SelectFieldPopup.prototype.chooseEntireCategory = function () {
        this.onSelect(this.state.currentParent);
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#popParent
     * @description popParent method traverse up a parent level of options
     */
    SelectFieldPopup.prototype.popParent = function (keydown) {
        var len = this.state.selectedAncestry.length;
        var opt = len > 1 ? this.state.selectedAncestry[len - 2] : null;
        var activeOption = keydown === true ? 0 : -1;
        utils_1.onEventCapture(keydown);
        this.setState({
            currentParent: opt,
            selectedAncestry: this.state.selectedAncestry.splice(0, len - 1),
            filteredList: this.getFilteredOptionList(opt, null),
            activeOptionIndex: activeOption,
        });
        return true;
    };
    SelectFieldPopup.prototype.filterSearchResults = function (val) {
        var _this = this;
        if (!val) {
            this.setState({
                search: false,
                filteredList: this.getFilteredOptionList(null),
            });
            return;
        }
        var valueNoCase = val.toLowerCase();
        var searchResults = this.props.options.filter(function (opt) { return (opt[_this.props.searchKey].toLowerCase().substr(0, val.length) === valueNoCase ||
            opt[_this.props.searchKey].toLowerCase().indexOf(valueNoCase) >= 0); });
        if (this.props.multiLevel && this.props.value) {
            searchResults = lodash_1.differenceBy(searchResults, this.props.value, this.props.valueKey);
        }
        this.setState({
            search: true,
            filteredList: this.getFilteredOptionList(null, searchResults),
        });
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#renderSingleLevelSelect
     * @description renderSingleLevelSelect method to render a single level options list
     * @returns {JSX}
     */
    SelectFieldPopup.prototype.renderSingleLevelSelect = function () {
        var _this = this;
        return (react_1.default.createElement(Popup_1.Popup, { close: this.props.onCancel, target: this.props.target, onKeyDown: this.onKeyDown, popupContainer: this.props.popupContainer },
            react_1.default.createElement("div", { className: "Select__popup", ref: function (node) { return _this.dom.root = node; } },
                react_1.default.createElement("div", { className: "Select__popup__search" },
                    react_1.default.createElement(__1.SearchBar, { onSearch: this.filterSearchResults, minLength: 1, extendOnOpen: true, ref: function (node) { return _this.dom.search = node; }, timeout: 100, allowCollapsed: false })),
                react_1.default.createElement("ul", { className: "Select__popup__list", ref: function (node) { return _this.dom.list = node; } }, this.state.filteredList.map(function (opt, index) { return (react_1.default.createElement("li", { key: index, className: classnames_1.default('Select__popup__item', { 'Select__popup__item--active': index === _this.state.activeOptionIndex }) },
                    react_1.default.createElement("button", { type: "button", onClick: _this.onSelect.bind(_this, _this.state.filteredList[index]) },
                        react_1.default.createElement("span", null, lodash_1.get(opt, _this.props.labelKey))))); })))));
    };
    /**
     * @ngdoc method
     * @name SelectFieldPopup#renderMultiLevelSelect
     * @description renderMultiLevelSelect method to render a multi level options list
     * @returns {JSX}
     */
    SelectFieldPopup.prototype.renderMultiLevelSelect = function () {
        var _this = this;
        return (react_1.default.createElement(Popup_1.Popup, { close: this.props.onCancel, target: this.props.target, onKeyDown: this.onKeyDown, popupContainer: this.props.popupContainer },
            react_1.default.createElement("div", { className: "Select__popup", ref: function (node) { return _this.dom.root = node; } },
                react_1.default.createElement("div", { className: "Select__popup__search" }, this.state.currentParent && (react_1.default.createElement("div", { className: "search-handler" },
                    react_1.default.createElement("i", { className: "backlink", onClick: this.popParent }),
                    react_1.default.createElement("button", { type: "button", className: classnames_1.default('Select__popup__category', { 'Select__popup__item--active': this.state.activeOptionIndex === -1 }), onClick: this.chooseEntireCategory },
                        react_1.default.createElement("div", { className: "Select__popup__parent" }, lodash_1.get(this.state.currentParent, this.props.labelKey)),
                        react_1.default.createElement("div", { className: "Select__popup__parent--choose" }, "Choose entire category")))) || (react_1.default.createElement(__1.SearchBar, { onSearch: this.filterSearchResults, minLength: 1, extendOnOpen: true, ref: function (node) { return _this.dom.search = node; }, timeout: 100, allowCollapsed: false }))),
                react_1.default.createElement("ul", { className: "dropdown-menu Select__popup__list", ref: function (node) { return _this.dom.list = node; } }, this.state.filteredList.map(function (opt, index) { return (react_1.default.createElement("li", { key: index, className: classnames_1.default('Select__popup__item', { 'Select__popup__item--active': index === _this.state.activeOptionIndex }) },
                    react_1.default.createElement("button", { type: "button", onClick: _this.onMutiLevelSelect.bind(_this, _this.state.filteredList[index], false) },
                        react_1.default.createElement("span", null, lodash_1.get(opt, _this.props.labelKey)),
                        !_this.state.search && _this.isOptionAParent(opt) && (react_1.default.createElement("i", { className: "icon-chevron-right-thin" }))))); })))));
    };
    SelectFieldPopup.prototype.render = function () {
        return this.props.multiLevel ? this.renderMultiLevelSelect() : this.renderSingleLevelSelect();
    };
    return SelectFieldPopup;
}(react_1.default.Component));
exports.SelectFieldPopup = SelectFieldPopup;
SelectFieldPopup.propTypes = {
    options: prop_types_1.default.array.isRequired,
    onCancel: prop_types_1.default.func.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    labelKey: prop_types_1.default.string,
    valueKey: prop_types_1.default.string,
    searchKey: prop_types_1.default.string,
    multiLevel: prop_types_1.default.bool,
    value: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        value: prop_types_1.default.object,
    })),
    target: prop_types_1.default.string,
    popupContainer: prop_types_1.default.func,
};
SelectFieldPopup.defaultProps = {
    labelKey: 'name',
    valueKey: 'qcode',
    searchKey: 'name',
};


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.Select__dropdownToggle {\n  width: 24px;\n  height: 24px;\n  background-color: #5ea9c8;\n  opacity: 0.5;\n  filter: \"alpha(opacity=50)\";\n  border-radius: 2px;\n  padding: 0; }\n  .Select__dropdownToggle i {\n    margin-bottom: 2px; }\n  .Select__dropdownToggle:hover:enabled, .Select__dropdownToggle:focus:enabled {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n\n.Select__button {\n  background-color: #5ea9c8; }\n\n.Select__popup {\n  z-index: 2000;\n  width: 280px;\n  box-sizing: border-box; }\n  .Select__popup__search {\n    margin-top: 15px; }\n  .Select__popup__category:hover .Select__popup__parent {\n    display: none; }\n  .Select__popup__category:hover .Select__popup__parent--choose {\n    display: block; }\n  .Select__popup__list {\n    overflow-y: scroll;\n    overflow-x: hidden;\n    max-height: 200px;\n    padding: 5px 10px; }\n    .Select__popup__list li {\n      margin: 5px 0; }\n    .Select__popup__list span, .Select__popup__list i {\n      float: left;\n      text-align: left; }\n  .Select__popup__item {\n    margin: 5px; }\n    .Select__popup__item button {\n      width: 100%;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap; }\n    .Select__popup__item:hover {\n      background: #eff7fa; }\n    .Select__popup__item--active {\n      background: #eff7fa; }\n  .Select__popup__parent {\n    display: block;\n    vertical-align: top;\n    position: relative;\n    font-size: 12px;\n    color: #000;\n    background-color: rgba(0, 0, 0, 0.05);\n    margin-right: 3px;\n    margin-bottom: 3px;\n    padding: 3px 10px;\n    cursor: pointer;\n    border-radius: 2px;\n    -webkit-transition: color 0.2s ease;\n    -moz-transition: color 0.2s ease;\n    -ms-transition: color 0.2s ease;\n    -o-transition: color 0.2s ease;\n    transition: color 0.2s ease;\n    max-width: 200px; }\n    .Select__popup__parent--choose {\n      background-color: rgba(0, 0, 0, 0.05);\n      margin-right: 3px;\n      margin-bottom: 3px;\n      padding: 3px 10px;\n      display: none; }\n  .Select__popup .search-handler {\n    padding: 0;\n    height: 47px;\n    box-shadow: inset 0px -7px 10px -7px rgba(0, 0, 0, 0.5) !important; }\n    .Select__popup .search-handler .backlink {\n      cursor: pointer;\n      margin-left: 5px; }\n  .Select__popup .trigger-icon {\n    margin-top: 0; }\n  .Select__popup .search-close {\n    height: 30px; }\n\n.SearchBar--narrow, .SearchBar.extended {\n  margin: 0; }\n\n.select__meta-terms div.sd-line-input__input {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  height: auto;\n  min-height: 3rem;\n  padding-left: 2.8rem; }\n\n.select__meta-terms--disabled div.sd-line-input__input {\n  padding-left: 0; }\n\n.sd-line-input__plus-btn--disabled {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n  cursor: default !important; }\n", ""]);

// exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Content
 * @description Component to hold contents of a popup
 */
var Content = function (_a) {
    var children = _a.children, className = _a.className, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-content', { 'popup__menu-content--no-padding': noPadding }, className) }, children));
};
Content.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noPadding: prop_types_1.default.bool,
};
Content.defaultProps = { noPadding: false };
exports.default = Content;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Footer
 * @description Footer Component of a popup
 */
var Footer = function (_a) {
    var children = _a.children, className = _a.className, noBorder = _a.noBorder, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-footer', {
            'popup__menu-footer--no-border': noBorder,
            'popup__menu-footer--no-padding': noPadding,
        }, className) }, children));
};
Footer.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noBorder: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
};
exports.default = Footer;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Label_1 = __importDefault(__webpack_require__(435));
/**
 * @ngdoc react
 * @name Header
 * @description Header Component of a popup
 */
var Header = function (_a) {
    var text = _a.text, onClose = _a.onClose, children = _a.children, className = _a.className, noBorder = _a.noBorder, noPadding = _a.noPadding, centerText = _a.centerText;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-header', {
            'popup__menu-header--no-border': noBorder,
            'popup__menu-header--no-padding': noPadding,
        }, className) },
        text && (react_1.default.createElement(Label_1.default, { text: text, centerText: centerText }, onClose && (react_1.default.createElement("button", { className: "popup__menu-close", onClick: onClose },
            react_1.default.createElement("i", { className: "icon-close-small" }))))),
        children));
};
Header.propTypes = {
    text: prop_types_1.default.string,
    onClose: prop_types_1.default.func,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noBorder: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
    centerText: prop_types_1.default.bool,
};
exports.default = Header;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_portal_1 = __webpack_require__(437);
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var Menu_1 = __importDefault(__webpack_require__(436));
__webpack_require__(941);
/**
 * @ngdoc react
 * @name Popup
 * @description Main Popup Component which holds the entire popup
 */
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.setPortalNodes = _this.setPortalNodes.bind(_this);
        _this.setParentNode = _this.setParentNode.bind(_this);
        _this.dom = {
            portal: null,
            child: null,
            root: null,
            parent: null,
        };
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleClickOutside);
        if (this.dom.root) {
            // First render it somewhere not visible
            this.dom.root.style.zIndex = -1;
            // Make sure it's rendered
            this.dom.child.style.display = 'block';
            if (this.props.inheritWidth) {
                this.dom.child.style.width = this.dom.parent.getBoundingClientRect().width + 'px';
            }
            var _a = this.dom.child.getBoundingClientRect(), width = _a.width, height = _a.height;
            var ACTION_MENU_FROM_TOP = 100; // top-menu + search bar
            var MENU_MARGIN_HEIGHT = 16;
            var LEFT_BAR_WIDTH = 48;
            var BOTTOM_BAR_HEIGHT = 30;
            var BUFFER = 5;
            // Get target position
            var target = this.dom.parent.getElementsByClassName(this.props.target)[0];
            var targetRect = target.getBoundingClientRect();
            // Get the workspace
            var workspace = document.getElementById(this.props.workspaceId) || document.body;
            // Compute menu position
            var top = targetRect.top + targetRect.height;
            var left = targetRect.left + targetRect.width - width;
            // Menu goes off on the right side
            if (left + width + BUFFER > workspace.clientWidth) {
                left -= width;
                left += targetRect.width;
            }
            // Menu goes off on the left side
            if (left - LEFT_BAR_WIDTH < 0) {
                left = targetRect.left;
            }
            // Menu goes out on the bottom side
            if (top + height + BOTTOM_BAR_HEIGHT + BUFFER > workspace.clientHeight) {
                top -= height;
                top -= targetRect.height;
                top -= MENU_MARGIN_HEIGHT;
                top = top < ACTION_MENU_FROM_TOP ? ACTION_MENU_FROM_TOP : top;
            }
            this.dom.child.style.top = top.toFixed() + 'px';
            this.dom.child.style.left = left.toFixed() + 'px';
            this.dom.child.style.position = 'absolute';
            this.dom.child.style.zIndex = 2100;
            this.dom.root.style.zIndex = 2000;
            this.dom.root.style.position = 'fixed';
            this.dom.root.style.top = 0;
            this.dom.root.style.left = 0;
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleClickOutside);
    };
    Popup.prototype.handleClickOutside = function (event) {
        if (!this.dom.root || this.dom.root.contains(event.target) || !document.contains(event.target)) {
            return;
        }
        this.props.close();
    };
    Popup.prototype.handleKeydown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ESCAPE) {
            event.preventDefault();
            this.props.close();
        }
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
    };
    Popup.prototype.setParentNode = function (node) {
        if (node && node.parentNode) {
            this.dom.parent = node.parentNode;
        }
        else {
            this.dom.parent = null;
        }
    };
    Popup.prototype.setPortalNodes = function (node) {
        this.dom.portal = node;
        if (this.dom.portal) {
            this.dom.root = this.dom.portal.defaultNode || this.dom.portal.props.node;
        }
        else {
            this.dom.root = this.dom.child = null;
        }
    };
    Popup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, noPadding = _a.noPadding, popupContainer = _a.popupContainer;
        return (react_1.default.createElement("div", { ref: this.setParentNode },
            react_1.default.createElement(react_portal_1.Portal, { ref: this.setPortalNodes, node: popupContainer && popupContainer() },
                react_1.default.createElement("div", { ref: function (node) { return _this.dom.child = node; }, className: classnames_1.default('popup', className) },
                    react_1.default.createElement(Menu_1.default, { noPadding: noPadding }, children)))));
    };
    return Popup;
}(react_1.default.Component));
exports.default = Popup;
Popup.propTypes = {
    children: prop_types_1.default.node.isRequired,
    target: prop_types_1.default.string.isRequired,
    close: prop_types_1.default.func.isRequired,
    onKeyDown: prop_types_1.default.func,
    workspaceId: prop_types_1.default.string,
    className: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
    ]),
    noPadding: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    inheritWidth: prop_types_1.default.bool,
};
Popup.defaultProps = {
    workspaceId: 'main-container',
    noPadding: false,
    inheritWidth: false,
};


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(938);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* canUseDOM */]) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      } else {
        // Unmount the children rendered in custom node
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.props.node);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children);
      }

      this.portal = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Portal);


Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PortalCompat__ = __webpack_require__(438);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck(this, PortalWithState);

    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__PortalCompat__["a" /* default */],
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode.props.node || this.portalNode.defaultNode;
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWithState.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  openByClickOn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  closeOnOutsideClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

/* harmony default export */ __webpack_exports__["a"] = (PortalWithState);

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(942);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n  vertical-align: top; }\n  .dropdown a {\n    color: #333; }\n  .dropdown a:hover {\n    text-decoration: none; }\n  .dropdown button {\n    -webkit-appearance: none; }\n\n.dropdown__toggle {\n  cursor: pointer; }\n  .dropdown__toggle i {\n    vertical-align: sub; }\n\n.dropdown.dropdown--hover:hover .dropdown__menu {\n  display: block; }\n\n.dropdown__toggle:active,\n.dropdown.open .dropdown__toggle {\n  outline: 0;\n  color: #5ea9c8; }\n\n.dropdown.open .dropdown .dropdown__toggle {\n  color: #333; }\n\n.dropdown__more-actions .dropdown__toggle > i {\n  opacity: 0.3; }\n\n.dropdown__more-actions .dropdown__toggle:hover > i,\n.dropdown__more-actions.open .dropdown__toggle > i {\n  opacity: 1; }\n\n.dropdown__caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  margin-top: -2px;\n  margin-left: 4px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid #000;\n  opacity: .3;\n  content: \"\";\n  -webkit-transition: all 0.1s ease-in;\n  -moz-transition: all 0.1s ease-in;\n  -ms-transition: all 0.1s ease-in;\n  -o-transition: all 0.1s ease-in;\n  transition: all 0.1s ease-in; }\n  .dropdown__caret.dropdown__caret--white, .dropdown__caret.white {\n    border-top-color: #fff; }\n\n.dropdown:hover .dropdown__caret,\n.dropdown.open .dropdown__caret {\n  opacity: 1; }\n\n.dropdown.open .dropdown__caret {\n  border-top-color: #5ea9c8; }\n\n.dropdown__menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  min-width: 200px;\n  padding: 1rem 0;\n  margin: 0;\n  list-style: none;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 0;\n  text-align: left; }\n  .dropdown__menu li a:not(.btn), .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button), .dropdown__menu .dropdown__menu-item a:not(.btn), .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) {\n    display: block;\n    font-weight: normal;\n    line-height: 140%;\n    white-space: nowrap;\n    width: 100%;\n    min-width: 200px;\n    position: relative;\n    color: #333;\n    background: none;\n    padding: .6rem 1.6rem;\n    margin-bottom: .2rem;\n    font-size: 1.3rem;\n    text-decoration: none;\n    text-align: left; }\n    .dropdown__menu li a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu li a:not(.btn) i[class*=\" icon-\"], .dropdown__menu li a:not(.btn) i[class^=\"filetype-icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class*=\" icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) i[class*=\" icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) i[class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class*=\" icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) i[class^=\"filetype-icon-\"] {\n      margin-right: 1rem;\n      margin-top: -0.3rem;\n      min-width: 1.9rem;\n      vertical-align: middle; }\n    .dropdown__menu li a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item a:not(.btn) > i[class^=\"icon-\"], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button) > i[class^=\"icon-\"] {\n      margin-right: 1rem;\n      margin-top: -0.3rem;\n      min-width: 1.9rem;\n      vertical-align: middle; }\n    .dropdown__menu li a:not(.btn).disabled, .dropdown__menu li a:not(.btn)[disabled], .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled], .dropdown__menu .dropdown__menu-item a:not(.btn).disabled, .dropdown__menu .dropdown__menu-item a:not(.btn)[disabled], .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled] {\n      opacity: .5; }\n  .dropdown__menu li a:not(.btn):hover, .dropdown__menu li a:not(.btn):focus, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):focus, .dropdown__menu .dropdown__menu-item a:not(.btn):hover, .dropdown__menu .dropdown__menu-item a:not(.btn):focus, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):focus {\n    background: #eff7fa;\n    text-decoration: none;\n    cursor: pointer; }\n  .dropdown__menu li a:not(.btn):active, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):active, .dropdown__menu .dropdown__menu-item a:not(.btn):active, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button):active {\n    background: #c8e4ee; }\n  .dropdown__menu li a:not(.btn).disabled:hover, .dropdown__menu li a:not(.btn)[disabled]:hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled:hover, .dropdown__menu li button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled]:hover, .dropdown__menu .dropdown__menu-item a:not(.btn).disabled:hover, .dropdown__menu .dropdown__menu-item a:not(.btn)[disabled]:hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button).disabled:hover, .dropdown__menu .dropdown__menu-item button:not(.btn):not(.dropdown__menu-close):not(.toggle-button)[disabled]:hover {\n    background: none;\n    cursor: default; }\n  .dropdown__menu li .preferred-desk, .dropdown__menu .dropdown__menu-item .preferred-desk {\n    background-color: #d0e6ef !important; }\n  .dropdown__menu.dropdown__menu--plain li, .dropdown__menu.dropdown__menu--plain .dropdown__menu-item {\n    padding: .5rem .7rem; }\n    .dropdown__menu.dropdown__menu--plain li:hover, .dropdown__menu.dropdown__menu--plain .dropdown__menu-item:hover {\n      background: #eff7fa;\n      cursor: pointer; }\n  .dropdown__menu--has-head-foot {\n    padding: 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-label {\n      margin: 0.4rem 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-header {\n      flex: 0 0;\n      padding: 0.6rem 0;\n      margin: 0; }\n      .dropdown__menu--has-head-foot .dropdown__menu-header .dropdown__menu-label {\n        margin: 0.6rem 0 0.4rem; }\n    .dropdown__menu--has-head-foot .dropdown__menu-body {\n      overflow-y: auto;\n      flex: 0 1;\n      padding: 0.6rem 0; }\n    .dropdown__menu--has-head-foot .dropdown__menu-body:first-child .dropdown__menu-label {\n      margin: 0.6rem 0 0.4rem; }\n    .dropdown__menu--has-head-foot .dropdown__menu-footer {\n      flex: 0 0;\n      padding: 0.6rem 0;\n      margin: 0; }\n    .dropdown__menu--has-head-foot.open {\n      display: flex; }\n\n.dropdown__menu-divider {\n  height: 1px;\n  margin: 0.8rem 0;\n  overflow: hidden;\n  background-color: #e5e5e5; }\n\n.dropdown__menu .dropdown__menu-item--active button, .dropdown__menu .dropdown__menu-item--active button:hover {\n  background-color: #84bdd5 !important;\n  color: white !important; }\n  .dropdown__menu .dropdown__menu-item--active button [class^=\"icon-\"], .dropdown__menu .dropdown__menu-item--active button [class*=\" icon-\"],\n  .dropdown__menu .dropdown__menu-item--active button [class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button [class*=\" filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class^=\"icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class*=\" icon-\"],\n  .dropdown__menu .dropdown__menu-item--active button:hover [class^=\"filetype-icon-\"], .dropdown__menu .dropdown__menu-item--active button:hover [class*=\" filetype-icon-\"] {\n    color: white !important; }\n\n.dropdown__menu .dropdown__menu-item--active button:hover {\n  background-color: #5ea9c8 !important; }\n\n.dropdown__menu .dropdown__menu-item--highlighted {\n  background-color: #c245ff; }\n\n.dropdown__menu .dropdown__menu-item--no-link {\n  font-weight: 400;\n  line-height: 1.8rem;\n  position: relative;\n  color: #747474;\n  padding: .6rem 1.6rem;\n  margin-bottom: .2rem;\n  font-size: 1.3rem;\n  text-align: left; }\n\n.dropdown__menu label {\n  display: inline-block;\n  margin: 0; }\n  .dropdown__menu label + .dropdown__menu-info {\n    margin-left: 4px; }\n\n.dropdown__menu-label {\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  color: #999;\n  font-weight: 500;\n  padding-left: 1.6rem;\n  margin-bottom: .6rem; }\n  .dropdown__menu-label .dropdown__menu-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    width: auto;\n    opacity: .3;\n    background-color: transparent;\n    cursor: pointer; }\n    .dropdown__menu-label .dropdown__menu-close i {\n      margin-right: 0 !important; }\n    .dropdown__menu-label .dropdown__menu-close:hover, .dropdown__menu-label .dropdown__menu-close:focus {\n      background-color: transparent;\n      opacity: 1; }\n\n.dropdown__menu-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin-bottom: 0.6rem; }\n\n.dropdown__menu-footer {\n  padding: 1rem;\n  margin-top: 0.6rem;\n  border-top: 1px solid #e5e5e5; }\n  .dropdown__menu-footer--align-right {\n    text-align: right; }\n  .dropdown__menu-footer--has-list {\n    padding: 0.6rem 0 0 0;\n    margin-bottom: -0.4rem; }\n\n.dropdown__menu-info {\n  color: #999;\n  font-style: italic;\n  vertical-align: middle; }\n\n.dropdown__menu-item {\n  padding: 0; }\n  .dropdown__menu-item--left-10 {\n    padding-left: 1rem; }\n\n.dropdown__menu--padded-l10 > li {\n  padding-left: 1rem; }\n\n.dropdown__menu--padded-l10 .dropdown__menu-item {\n  padding: 0; }\n\n.dropdown__menu--right {\n  right: 0;\n  left: auto; }\n\n.dropdown__menu .menu-item--active button, .dropdown__menu .menu-item--active button:hover {\n  background-color: #84bdd5;\n  color: white; }\n  .dropdown__menu .menu-item--active button [class^=\"icon-\"], .dropdown__menu .menu-item--active button [class*=\" icon-\"],\n  .dropdown__menu .menu-item--active button [class^=\"filetype-icon-\"], .dropdown__menu .menu-item--active button [class*=\" filetype-icon-\"], .dropdown__menu .menu-item--active button:hover [class^=\"icon-\"], .dropdown__menu .menu-item--active button:hover [class*=\" icon-\"],\n  .dropdown__menu .menu-item--active button:hover [class^=\"filetype-icon-\"], .dropdown__menu .menu-item--active button:hover [class*=\" filetype-icon-\"] {\n    color: white; }\n\n.dropdown__menu .menu-item--active button:hover {\n  background-color: #5ea9c8; }\n\n.dropdown.open > .dropdown__menu {\n  display: block; }\n  .dropdown.open > .dropdown__menu.dropdown__menu--scrollable {\n    max-height: 36rem;\n    overflow: auto;\n    overflow-x: hidden; }\n  .dropdown.open > .dropdown__menu.dropdown__menu--has-head-foot {\n    display: flex;\n    flex-direction: column;\n    max-height: 36rem; }\n\n.dropdown--align-right .dropdown__menu, .dropdown--align-right.dropdown__menu {\n  left: auto;\n  right: 0; }\n  .dropdown--align-right .dropdown__menu:before, .dropdown--align-right.dropdown__menu:before {\n    left: auto;\n    right: 10px; }\n\n.dropdown--dropup .dropdown__caret {\n  border-top: 0;\n  border-bottom: 4px solid #000;\n  content: \"\\2191\";\n  -webkit-transition: all 0.2s eas-in;\n  -moz-transition: all 0.2s eas-in;\n  -ms-transition: all 0.2s eas-in;\n  -o-transition: all 0.2s eas-in;\n  transition: all 0.2s eas-in; }\n\n.dropdown--dropup .dropdown__menu {\n  top: auto;\n  bottom: 100%;\n  margin-bottom: 4px; }\n\n.dropdown--dropup.open .dropdown__caret {\n  border-bottom-color: #5ea9c8 !important; }\n\n.dropdown--dropleft {\n  display: inline-block;\n  vertical-align: middle; }\n  .dropdown--dropleft .dropdown__menu {\n    top: -2.3rem;\n    left: auto;\n    right: calc(100% + 0.3rem); }\n\n.dropdown--dropright {\n  display: inline-block;\n  vertical-align: middle; }\n  .dropdown--dropright .dropdown__menu {\n    top: -2.3rem;\n    left: 100%; }\n\n.dropdown--dropright.open .dropdown__caret {\n  transform: rotate(-90deg); }\n\n.dropdown--dropleft.open .dropdown__caret {\n  transform: rotate(90deg); }\n\n.dropdown--dropright.dropdown--dropup .dropdown__menu, .dropdown--dropleft.dropdown--dropup .dropdown__menu {\n  bottom: -2.3rem;\n  top: auto; }\n\n.dropdown--noarrow {\n  display: inline-block; }\n  .dropdown--noarrow .dropdown__menu {\n    margin: 0;\n    max-height: 250px;\n    overflow: auto; }\n  .dropdown--noarrow .dropdown__menu:before {\n    display: none; }\n  .dropdown--noarrow .dropdown .dropdown__toggle {\n    display: block;\n    padding: 3px 15px;\n    clear: both;\n    font-weight: normal;\n    line-height: 18px;\n    white-space: nowrap; }\n  .dropdown--noarrow.open li > .dropdown .dropdown__toggle {\n    display: block;\n    padding: 5px 7px;\n    margin: 0;\n    clear: both;\n    font-weight: normal;\n    line-height: 18px;\n    white-space: nowrap; }\n\n.dropdown--noarrow.dropdown--no-scroll .dropdown__menu {\n  max-height: none;\n  overflow: visible; }\n\n.dropdown--bigger .dropdown__menu {\n  min-width: 238px; }\n\n.dropdown--bigger-500 .dropdown__menu {\n  min-width: 300px; }\n\n.dropdown--more-activity .dropdown__menu {\n  min-width: 0;\n  padding: 5px;\n  border-radius: 0px;\n  border: 0;\n  z-index: 1;\n  margin-top: -1px; }\n  .dropdown--more-activity .dropdown__menu:before {\n    display: none; }\n  .dropdown--more-activity .dropdown__menu li {\n    display: inline-block;\n    vertical-align: middle; }\n    .dropdown--more-activity .dropdown__menu li a {\n      padding: 0; }\n      .dropdown--more-activity .dropdown__menu li a i {\n        margin-right: 0; }\n      .dropdown--more-activity .dropdown__menu li a span {\n        display: none; }\n\n.dropdown__button-label {\n  display: inline-block;\n  color: inherit;\n  font-weight: 300;\n  opacity: 0.65;\n  padding-right: 0.5rem;\n  letter-spacing: 0.02rem; }\n\n.dropdown.dropdown--dark .dropdown__toggle {\n  text-align: left;\n  background: rgba(127, 127, 127, 0.5);\n  padding: 0.7rem 1.5rem;\n  border-radius: 2px;\n  color: #fff; }\n  .dropdown.dropdown--dark .dropdown__toggle .dropdown__caret {\n    border-top-color: #fff;\n    margin-left: 1rem; }\n  .dropdown.dropdown--dark .dropdown__toggle--small {\n    padding: 0.5rem 1.5rem; }\n  .dropdown.dropdown--dark .dropdown__toggle--hollow {\n    border: 1px solid rgba(127, 127, 127, 0.75);\n    background: none; }\n  .dropdown.dropdown--dark .dropdown__toggle--line {\n    background-color: rgba(255, 255, 255, 0.05);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n    .dropdown.dropdown--dark .dropdown__toggle--line:hover {\n      border-bottom-color: rgba(255, 255, 255, 0.4);\n      background-color: rgba(255, 255, 255, 0.1); }\n    .dropdown.dropdown--dark .dropdown__toggle--line:focus {\n      border-color: #5ea9c8;\n      background-color: rgba(255, 255, 255, 0.1);\n      box-shadow: 0 1px 0 0 #5ea9c8; }\n\n.dropdown.dropdown--dark.open .dropdown__toggle--hollow {\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  background-color: rgba(255, 255, 255, 0.1); }\n\n.dropdown.dropdown--dark.open .dropdown__toggle--line {\n  background-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 1px 0 0 #5ea9c8, inset 0 0px 0 1px rgba(89, 169, 201, 0.4); }\n\n.dropdown.dropdown--full-width {\n  width: 100%; }\n  .dropdown.dropdown--full-width .dropdown__toggle .dropdown__caret {\n    float: right;\n    margin-top: 6px; }\n\n.dropdown__menu--multiedit {\n  max-height: 400px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--multiedit li {\n    margin-bottom: 4px; }\n  .dropdown__menu--multiedit li button {\n    width: 300px !important;\n    padding-right: 30px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    position: relative;\n    border-radius: 0; }\n    .dropdown__menu--multiedit li button i {\n      position: absolute;\n      right: -5px;\n      top: 9px; }\n    .dropdown__menu--multiedit li button.disabled, .dropdown__menu--multiedit li button.disabled:hover {\n      background: #f0f0f0; }\n      .dropdown__menu--multiedit li button.disabled i, .dropdown__menu--multiedit li button.disabled:hover i {\n        opacity: .2; }\n  .dropdown__menu--multiedit li .msg {\n    padding: 0 20px; }\n\n.dark-ui .dropdown__caret {\n  border-top-color: #fff; }\n\n.dark-ui .dropdown.open .dropdown__caret {\n  border-top-color: #5ea9c8; }\n\n.popup__menu {\n  z-index: 1000;\n  min-width: 100px;\n  padding-top: 1rem;\n  margin: 0;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 2px;\n  text-align: left; }\n  .popup__menu--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-divider {\n  height: 1px;\n  margin: 0.8rem 0;\n  overflow: hidden;\n  background-color: #e5e5e5; }\n\n.popup__menu-label {\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  color: #999;\n  font-weight: 500;\n  padding-left: 1.6rem;\n  margin-bottom: .6rem; }\n  .popup__menu-label .popup__menu-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    width: auto;\n    opacity: .3;\n    background-color: transparent;\n    cursor: pointer; }\n    .popup__menu-label .popup__menu-close i {\n      margin-right: 0 !important; }\n    .popup__menu-label .popup__menu-close:hover, .popup__menu-label .popup__menu-close:focus {\n      background-color: transparent;\n      opacity: 1; }\n  .popup__menu-label--center {\n    padding-left: 0;\n    text-align: center;\n    display: inline-block;\n    width: 100%; }\n\n.popup__menu-header {\n  font-weight: 300;\n  font-size: 1.5rem;\n  color: #999;\n  padding: 1rem 1rem 0 1rem;\n  border-bottom: 1px solid #e5e5e5; }\n  .popup__menu-header--no-border {\n    border-bottom: none; }\n  .popup__menu-header--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-footer {\n  padding: 1rem;\n  margin-top: 0.6rem;\n  border-top: 1px solid #e5e5e5;\n  display: inline-block;\n  width: 100%; }\n  .popup__menu-footer--no-border {\n    border-top: none; }\n  .popup__menu-footer--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-content {\n  padding: 1rem;\n  min-width: 100px; }\n  .popup__menu-content--no-padding {\n    padding: 0 !important; }\n", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var __1 = __webpack_require__(30);
var UserAvatar_1 = __webpack_require__(91);
var SelectUserPopup_1 = __webpack_require__(944);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
/**
 * @ngdoc react
 * @name SelectUserInput
 * @description Component to select users from a list
 */
var SelectUserInput = /** @class */ (function (_super) {
    __extends(SelectUserInput, _super);
    function SelectUserInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            filteredUserList: _this.props.users,
            searchText: '',
            openFilterList: false,
        };
        _this.openPopup = _this.openPopup.bind(_this);
        _this.closePopup = _this.closePopup.bind(_this);
        _this.filterUserList = _this.filterUserList.bind(_this);
        _this.onUserChange = _this.onUserChange.bind(_this);
        return _this;
    }
    SelectUserInput.prototype.openPopup = function () {
        this.setState({ openFilterList: true });
    };
    SelectUserInput.prototype.closePopup = function () {
        this.setState({ openFilterList: false });
    };
    SelectUserInput.prototype.filterUserList = function (field, value) {
        if (!value) {
            this.setState({
                filteredUserList: this.props.users,
                searchText: '',
                openFilterList: true,
            });
            return;
        }
        var filterTextNoCase = value.toLowerCase();
        var newUserList = this.props.users.filter(function (user) { return (user.display_name.toLowerCase().substr(0, value.length) === filterTextNoCase ||
            user.display_name.toLowerCase().indexOf(filterTextNoCase) >= 0); });
        this.setState({
            filteredUserList: newUserList,
            searchText: value,
            openFilterList: true,
        });
    };
    SelectUserInput.prototype.onUserChange = function (newUserId) {
        this.props.onChange(this.props.field, newUserId);
        this.setState({
            openFilterList: false,
            searchText: '',
        });
    };
    SelectUserInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, users = _a.users, popupContainer = _a.popupContainer, label = _a.label, readOnly = _a.readOnly;
        var userList = this.state.searchText ? this.state.filteredUserList : users;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(__1.Row, { noPadding: true },
                react_1.default.createElement(__1.LineInput, { noMargin: true },
                    react_1.default.createElement(__1.Label, { text: label }),
                    value && (react_1.default.createElement("div", { className: "user-search__popup-user" },
                        react_1.default.createElement(UserAvatar_1.UserAvatar, { user: value }),
                        react_1.default.createElement("div", { className: "user-search__popup-item-label" }, value.display_name),
                        !readOnly && react_1.default.createElement("button", { type: "button", onClick: this.onUserChange.bind(null, null) },
                            react_1.default.createElement("i", { className: "icon-close-small" })))))),
            !readOnly && react_1.default.createElement(__1.Row, null,
                react_1.default.createElement(__1.LineInput, { isSelect: true, noLabel: !!value, onClick: this.openPopup },
                    react_1.default.createElement(__1.Input, { className: "sd-line-input--no-label", value: this.state.searchText, onChange: this.filterUserList, onClick: this.openPopup, placeholder: "Search", onKeyDown: function (event) {
                            if (event.keyCode === constants_1.KEYCODES.ENTER ||
                                event.keyCode === constants_1.KEYCODES.DOWN) {
                                utils_1.onEventCapture(event);
                                _this.openPopup();
                            }
                        } }),
                    this.state.openFilterList && (react_1.default.createElement(SelectUserPopup_1.SelectUserPopup, { onClose: this.closePopup, target: "sd-line-input__input", popupContainer: popupContainer, users: userList, onChange: this.onUserChange }))))));
    };
    return SelectUserInput;
}(react_1.default.Component));
exports.SelectUserInput = SelectUserInput;
SelectUserInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.object,
    onChange: prop_types_1.default.func,
    users: prop_types_1.default.array,
    popupContainer: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
};


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
var utils_2 = __webpack_require__(3);
var Popup_1 = __webpack_require__(80);
var UserAvatar_1 = __webpack_require__(91);
__webpack_require__(945);
/**
 * @ngdoc react
 * @name SelectUserPopup
 * @description Pop-up component of SelectUserList
 */
var SelectUserPopup = /** @class */ (function (_super) {
    __extends(SelectUserPopup, _super);
    function SelectUserPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.state = { activeIndex: -1 };
        _this.dom = { itemList: null };
        return _this;
    }
    /**
     * @ngdoc method
     * @name SelectUserPopup#onKeyDown
     * @description onKeyDown method to handle keyboard selection of options
     */
    SelectUserPopup.prototype.onKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                    utils_1.onEventCapture(event);
                    this.handleEnterKey(event);
                    break;
                case constants_1.KEYCODES.DOWN:
                    utils_1.onEventCapture(event);
                    this.handleDownArrowKey(event);
                    break;
                case constants_1.KEYCODES.UP:
                    utils_1.onEventCapture(event);
                    this.handleUpArrowKey(event);
                    break;
            }
        }
    };
    /**
     * @ngdoc method
     * @name SelectUserPopup#handleEnterKey
     * @description handleEnterKey method to handle enter-key press on a selected option
     */
    SelectUserPopup.prototype.handleEnterKey = function (event) {
        this.props.onChange(this.props.users[this.state.activeIndex]);
    };
    /**
     * @ngdoc method
     * @name SelectUserPopup#handleDownArrowKey
     * @description handleDownArrowKey method to handle down-key press to select options
     */
    SelectUserPopup.prototype.handleDownArrowKey = function (event) {
        if (lodash_1.get(this.props, 'users.length', 0) - 1 > this.state.activeIndex) {
            this.setState({ activeIndex: this.state.activeIndex + 1 });
            utils_1.scrollListItemIfNeeded(this.state.activeIndex, this.dom.itemList);
        }
    };
    /**
     * @ngdoc method
     * @name SelectUserPopup#handleUpArrowKey
     * @description handleUpArrowKey method to handle up-key press to select options
     */
    SelectUserPopup.prototype.handleUpArrowKey = function (event) {
        if (this.state.activeIndex > 0) {
            this.setState({ activeIndex: this.state.activeIndex - 1 });
            utils_1.scrollListItemIfNeeded(this.state.activeIndex, this.dom.itemList);
        }
    };
    SelectUserPopup.prototype.handleOnChange = function (user, event) {
        utils_1.onEventCapture(event);
        this.props.onChange(user);
    };
    SelectUserPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, target = _a.target, popupContainer = _a.popupContainer, users = _a.users;
        return (react_1.default.createElement(Popup_1.Popup, { close: onClose, target: target, popupContainer: popupContainer, className: "user-search__popup", noPadding: true, onKeyDown: this.onKeyDown, inheritWidth: true },
            react_1.default.createElement(Popup_1.Content, { noPadding: true },
                react_1.default.createElement("ul", { className: "user-search__popup-list", ref: function (ref) { return _this.dom.itemList = ref; } },
                    users.length > 0 && users.map(function (user, index) { return (react_1.default.createElement("li", { key: index, className: classnames_1.default('user-search__popup-item', { 'user-search__popup-item--active': index === _this.state.activeIndex }) },
                        react_1.default.createElement("button", { type: "button", onClick: _this.handleOnChange.bind(null, user) },
                            react_1.default.createElement(UserAvatar_1.UserAvatar, { user: user }),
                            react_1.default.createElement("div", { className: "user-search__popup-item-label" }, user.display_name)))); }),
                    users.length === 0 && (react_1.default.createElement("li", { className: "user-search__popup-item" },
                        react_1.default.createElement("button", { disabled: true },
                            react_1.default.createElement(UserAvatar_1.UserAvatar, { empty: true, initials: false }),
                            react_1.default.createElement("div", { className: "user-search__popup-item-label" }, utils_2.gettext('No users found')))))))));
    };
    return SelectUserPopup;
}(react_1.default.Component));
exports.SelectUserPopup = SelectUserPopup;
SelectUserPopup.propTypes = {
    onClose: prop_types_1.default.func,
    target: prop_types_1.default.string,
    popupContainer: prop_types_1.default.func,
    users: prop_types_1.default.array,
    onChange: prop_types_1.default.func,
};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(946);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.user-search__popup {\n  margin-top: 1px; }\n  .user-search__popup-list {\n    overflow-y: scroll;\n    max-height: 250px; }\n    .user-search__popup-list li {\n      margin: 5px 0; }\n  .user-search__popup-item {\n    margin: 5px; }\n    .user-search__popup-item:hover {\n      background: #eff7fa; }\n    .user-search__popup-item button {\n      width: 100%;\n      text-align: left; }\n    .user-search__popup-item--active {\n      background: #eff7fa; }\n  .user-search__popup-item-label {\n    padding-top: 5px;\n    display: inline-block;\n    width: 200px;\n    text-align: left; }\n  .user-search__popup-user {\n    display: inline-block;\n    margin: 10px 0;\n    width: 100%; }\n    .user-search__popup-user button {\n      float: right; }\n", ""]);

// exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var __1 = __webpack_require__(30);
var __2 = __webpack_require__(23);
var SelectTagPopup_1 = __webpack_require__(948);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
__webpack_require__(439);
/**
 * @ngdoc react
 * @name SelectTagInput
 * @description Component to select tags like Keyword of a news story
 */
var SelectTagInput = /** @class */ (function (_super) {
    __extends(SelectTagInput, _super);
    function SelectTagInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            popupOpened: false,
            inputText: '',
            filteredOptions: _this.props.options,
        };
        _this.togglePopup = _this.togglePopup.bind(_this);
        _this.addTag = _this.addTag.bind(_this);
        _this.removeTag = _this.removeTag.bind(_this);
        _this.filterOptions = _this.filterOptions.bind(_this);
        _this.openPopUp = _this.openPopUp.bind(_this);
        return _this;
    }
    SelectTagInput.prototype.togglePopup = function () {
        this.setState({ popupOpened: !this.state.popupOpened });
    };
    SelectTagInput.prototype.openPopUp = function () {
        if (!this.state.popupOpened) {
            this.setState({ popupOpened: true });
        }
    };
    SelectTagInput.prototype.addTag = function (tag) {
        if (tag) {
            var valueText = lodash_1.get(tag, this.props.valueKey, tag);
            // If the tag is not currently in the list of tags
            // Then call onChange with the new set of tags
            if (this.props.value.indexOf(valueText) === -1) {
                var newValue = this.props.value ? this.props.value.concat([valueText]) :
                    [valueText];
                this.props.onChange(this.props.field, newValue);
                this.setState({
                    inputText: '',
                    popupOpened: false,
                    filteredOptions: this.getFilteredOptions(newValue),
                });
            }
            else {
                this.setState({
                    inputText: '',
                    popupOpened: false,
                    filteredOptions: this.getFilteredOptions(this.props.value),
                });
            }
        }
    };
    SelectTagInput.prototype.removeTag = function (index) {
        var newValue = this.props.value.slice();
        newValue.splice(index, 1);
        this.props.onChange(this.props.field, newValue);
        this.setState({
            filteredOptions: this.getFilteredOptions(newValue),
        });
    };
    SelectTagInput.prototype.getFilteredOptions = function (tags, inputText) {
        var _this = this;
        if (inputText === void 0) { inputText = ''; }
        var numTags = lodash_1.get(tags, 'length', 0);
        var filteredOptions = this.props.options.slice();
        // Remove selected values from options
        if (numTags > 0) {
            tags.forEach(function (v) { return lodash_1.remove(filteredOptions, function (o) { return lodash_1.get(o, _this.props.valueKey) === v; }); });
        }
        if (inputText) {
            var inputNoCase_1 = inputText.toLowerCase();
            // Filter those substrings according to inputText
            filteredOptions = filteredOptions.filter(function (o) {
                var optionName = lodash_1.get(o, _this.props.searchKey, '').toLowerCase();
                return optionName.substr(0, inputText.length) === inputNoCase_1 ||
                    optionName.indexOf(inputNoCase_1) >= 0;
            });
        }
        return filteredOptions;
    };
    SelectTagInput.prototype.filterOptions = function (field, value) {
        this.setState({
            inputText: value,
            popupOpened: true,
            filteredOptions: this.getFilteredOptions(this.props.value, value),
        });
    };
    SelectTagInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, value = _a.value, labelKey = _a.labelKey, allowCustom = _a.allowCustom, readOnly = _a.readOnly, invalid = _a.invalid, required = _a.required, onFocus = _a.onFocus, props = __rest(_a, ["label", "value", "labelKey", "allowCustom", "readOnly", "invalid", "required", "onFocus"]);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(__1.Row, { noPadding: true },
                react_1.default.createElement(__1.LineInput, { noMargin: true, invalid: invalid, required: required },
                    react_1.default.createElement(__1.Label, { text: label }),
                    react_1.default.createElement("div", { className: "sd-line-input__input" }, lodash_1.get(value, 'length', 0) > 0 && (react_1.default.createElement(__2.TermsList, { terms: value, onClick: this.removeTag }))))),
            react_1.default.createElement(__1.Row, null,
                react_1.default.createElement(__1.LineInput, __assign({ isSelect: true, readOnly: readOnly, noLabel: lodash_1.get(value, 'length', 0) > 0, invalid: invalid }, props),
                    react_1.default.createElement(__1.Input, { value: this.state.inputText, onChange: !readOnly ? this.filterOptions : null, onClick: !readOnly ? this.togglePopup : null, className: "select-tag__input", readOnly: readOnly, onKeyDown: function (event) {
                            if (event.keyCode === constants_1.KEYCODES.ENTER ||
                                event.keyCode === constants_1.KEYCODES.DOWN) {
                                utils_1.onEventCapture(event);
                                _this.openPopUp();
                            }
                        }, onFocus: onFocus }),
                    this.state.popupOpened && (react_1.default.createElement(SelectTagPopup_1.SelectTagPopup, { value: value, options: this.state.filteredOptions, onClose: this.togglePopup, target: "select-tag__input", onChange: this.addTag, labelKey: labelKey, allowCustom: allowCustom }))))));
    };
    return SelectTagInput;
}(react_1.default.Component));
exports.SelectTagInput = SelectTagInput;
SelectTagInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.arrayOf(prop_types_1.default.string),
    onChange: prop_types_1.default.func,
    options: prop_types_1.default.array,
    labelKey: prop_types_1.default.string,
    valueKey: prop_types_1.default.string,
    searchKey: prop_types_1.default.string,
    allowCustom: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    onFocus: prop_types_1.default.func,
};
SelectTagInput.defaultProps = {
    labelKey: 'name',
    valueKey: 'qcode',
    searchKey: 'name',
    allowCustom: true,
    readOnly: false,
    required: false,
};


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
var Popup_1 = __webpack_require__(80);
__webpack_require__(439);
/**
 * @ngdoc react
 * @name SelectTagPopup
 * @description Popup component to SelectTagInput
 */
var SelectTagPopup = /** @class */ (function (_super) {
    __extends(SelectTagPopup, _super);
    function SelectTagPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { activeOptionIndex: -1 };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name SelectTagPopup#onKeyDown
     * @description onKeyDown method to handle keyboard selection of options
     */
    SelectTagPopup.prototype.onKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                    utils_1.onEventCapture(event);
                    this.handleEnterKey(event);
                    break;
                case constants_1.KEYCODES.DOWN:
                    utils_1.onEventCapture(event);
                    this.handleDownKey(event);
                    break;
                case constants_1.KEYCODES.UP:
                    utils_1.onEventCapture(event);
                    this.handleUpKey(event);
                    break;
            }
        }
    };
    /**
     * @ngdoc method
     * @name SelectTagPopup#handleEnterKey
     * @description handleEnterKey method to handle enter-key press on a selected option
     */
    SelectTagPopup.prototype.handleEnterKey = function (event) {
        var newTag;
        if (this.state.activeOptionIndex > -1) {
            newTag = this.props.options[this.state.activeOptionIndex];
        }
        else if (this.props.options.length === 1) {
            newTag = this.props.options[0];
        }
        else if (this.props.allowCustom) {
            newTag = lodash_1.get(event, 'target.value');
        }
        this.props.onChange(newTag);
    };
    /**
     * @ngdoc method
     * @name SelectTagPopup#handleDownArrowKey
     * @description handleDownArrowKey method to handle down-key press to select options
     */
    SelectTagPopup.prototype.handleDownKey = function (event) {
        if (this.state.activeOptionIndex < this.props.options.length - 1) {
            this.setState({ activeOptionIndex: this.state.activeOptionIndex + 1 });
        }
    };
    /**
     * @ngdoc method
     * @name SelectTagPopup#handleUpArrowKey
     * @description handleUpArrowKey method to handle up-key press to select options
     */
    SelectTagPopup.prototype.handleUpKey = function (event) {
        if (this.state.activeOptionIndex > -1) {
            this.setState({ activeOptionIndex: this.state.activeOptionIndex - 1 });
        }
    };
    SelectTagPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, target = _a.target, popupContainer = _a.popupContainer, options = _a.options, labelKey = _a.labelKey;
        return (react_1.default.createElement(Popup_1.Popup, { close: onClose, target: target, popupContainer: popupContainer, onKeyDown: this.onKeyDown, noPadding: true, className: "select-tag__popup", inheritWidth: true },
            react_1.default.createElement(Popup_1.Content, { noPadding: true }, options.length > 0 && (react_1.default.createElement("ul", { className: "select-tag__popup-list" }, options.map(function (o, index) { return (react_1.default.createElement("li", { key: index, className: classnames_1.default('select-tag__popup-item', { 'select-tag__popup-item--active': index === _this.state.activeOptionIndex }) },
                react_1.default.createElement("button", { onClick: _this.props.onChange.bind(null, o) },
                    react_1.default.createElement("span", null,
                        "\u00A0\u00A0",
                        lodash_1.get(o, labelKey, ''))))); }))))));
    };
    return SelectTagPopup;
}(react_1.default.Component));
exports.SelectTagPopup = SelectTagPopup;
SelectTagPopup.propTypes = {
    value: prop_types_1.default.array,
    options: prop_types_1.default.array,
    onClose: prop_types_1.default.func,
    target: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    labelKey: prop_types_1.default.string,
    popupContainer: prop_types_1.default.func,
    allowCustom: prop_types_1.default.bool,
};


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.select-tag__popup {\n  margin-top: 1px; }\n  .select-tag__popup-list {\n    overflow-y: scroll;\n    overflow-x: hidden;\n    max-height: 200px;\n    padding: 5px 10px; }\n    .select-tag__popup-list li {\n      margin: 5px 0; }\n    .select-tag__popup-list span, .select-tag__popup-list i {\n      float: left;\n      text-align: left; }\n  .select-tag__popup-item {\n    margin: 5px; }\n    .select-tag__popup-item button {\n      width: 100%;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap; }\n    .select-tag__popup-item:hover {\n      background: #eff7fa; }\n    .select-tag__popup-item--active {\n      background: #eff7fa; }\n", ""]);

// exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
// Component to show checkbox input in styles including radiobutton
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.render = function () {
        var _a = this.props, field = _a.field, value = _a.value, checkedValue = _a.checkedValue, label = _a.label, labelPosition = _a.labelPosition, readOnly = _a.readOnly, onChange = _a.onChange, type = _a.type;
        var isRadio = type === 'radio';
        var onClick = readOnly ?
            null :
            function (event) {
                event.stopPropagation();
                onChange(field, isRadio ? checkedValue : !value);
            };
        var className = classnames_1.default('sd-checkbox', {
            'sd-checkbox--disabled': readOnly,
            'sd-checkbox--button-style': labelPosition === 'inside',
            'sd-checkbox--radio': isRadio,
            checked: isRadio ? value === checkedValue : value,
        });
        var checkbox;
        if (labelPosition === 'inside') {
            checkbox = (react_1.default.createElement("a", { className: "sd-check__wrapper", onClick: onClick },
                react_1.default.createElement("span", { className: className },
                    react_1.default.createElement("label", { className: readOnly ? 'sd-label--disabled' : '' }, label))));
        }
        else if (labelPosition === 'left') {
            checkbox = (react_1.default.createElement("a", { className: "sd-check__wrapper", onClick: onClick },
                react_1.default.createElement("label", { className: readOnly ? 'sd-label--disabled' : '' }, label),
                react_1.default.createElement("span", { className: className })));
        }
        else {
            checkbox = (react_1.default.createElement("a", { className: "sd-check__wrapper", onClick: onClick },
                react_1.default.createElement("span", { className: className }),
                react_1.default.createElement("label", { className: readOnly ? 'sd-label--disabled' : '' }, label)));
        }
        return checkbox;
    };
    Checkbox.defaultProps = {
        value: false,
        checkedValue: '',
        readOnly: false,
        labelPosition: 'right',
        type: 'checkbox',
    };
    return Checkbox;
}(react_1.default.Component));
exports.Checkbox = Checkbox;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var __1 = __webpack_require__(30);
var LineInput_1 = __webpack_require__(197);
var __2 = __webpack_require__(23);
__webpack_require__(952);
/**
 * @ngdoc react
 * @name ToggleInput
 * @description Component to toggle input values
 */
exports.ToggleInput = function (_a) {
    var field = _a.field, label = _a.label, value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly, className = _a.className, labelLeftAuto = _a.labelLeftAuto, onFocus = _a.onFocus, props = __rest(_a, ["field", "label", "value", "onChange", "readOnly", "className", "labelLeftAuto", "onFocus"]);
    return (react_1.default.createElement(__1.LineInput, __assign({}, props, { readOnly: readOnly, labelLeftAuto: labelLeftAuto, className: "sd-line-input__toggle" }),
        react_1.default.createElement(__1.Label, { text: label }),
        react_1.default.createElement(__2.Toggle, { value: value, onChange: function (e) { return onChange(field, e.target.value); }, readOnly: readOnly, className: className, onFocus: onFocus })));
};
exports.ToggleInput.propTypes = __assign({ field: prop_types_1.default.string.isRequired, label: prop_types_1.default.string, value: prop_types_1.default.bool, onChange: prop_types_1.default.func.isRequired, className: prop_types_1.default.string, labelLeftAuto: prop_types_1.default.bool }, LineInput_1.LineInputProps);
exports.ToggleInput.defaultProps = __assign({ value: false, labelLeftAuto: false }, LineInput_1.LineInputDefaultProps);


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(953);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.sd-line-input__toggle .sd-line-input__label {\n  margin-top: 4px;\n  max-width: none; }\n", ""]);

// exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var __1 = __webpack_require__(30);
var ColouredValuePopup_1 = __webpack_require__(955);
/**
 * @ngdoc react
 * @name ColouredValueInput
 * @description Component to show color coded values. Eg. Urgency / Priority
 */
var ColouredValueInput = /** @class */ (function (_super) {
    __extends(ColouredValueInput, _super);
    function ColouredValueInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { openPopup: false };
        _this.togglePopup = _this.togglePopup.bind(_this);
        _this.getIconClasses = _this.getIconClasses.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    /**
    * @ngdoc method
    * @name ColouredValueInput#togglePopup
    * @description togglePopup method to toggle open state of opop-up component
    */
    ColouredValueInput.prototype.togglePopup = function () {
        this.setState({ openPopup: !this.state.openPopup });
    };
    /**
     * @ngdoc method
     * @name ColouredValueInput#getIconClasses
     * @description getIconClasses returns appropriate icon class for a given value.
     * @returns {string} Icon class-name
     */
    ColouredValueInput.prototype.getIconClasses = function (val) {
        return val ? classnames_1.default('line-input', this.props.iconName, this.props.iconName + '--' + lodash_1.get(val, this.props.valueKey, lodash_1.get(val, this.props.labelKey))) : 'line-input';
    };
    ColouredValueInput.prototype.onChange = function (value) {
        this.props.onChange(this.props.field, lodash_1.get(value, this.props.valueKey) ? value : null);
        this.togglePopup();
    };
    ColouredValueInput.prototype.render = function () {
        var _a = this.props, required = _a.required, value = _a.value, label = _a.label, readOnly = _a.readOnly, labelLeft = _a.labelLeft, clearable = _a.clearable, options = _a.options, labelKey = _a.labelKey, valueKey = _a.valueKey, noMargin = _a.noMargin, popupContainer = _a.popupContainer, row = _a.row, noValueString = _a.noValueString, onFocus = _a.onFocus, props = __rest(_a, ["required", "value", "label", "readOnly", "labelLeft", "clearable", "options", "labelKey", "valueKey", "noMargin", "popupContainer", "row", "noValueString", "onFocus"]);
        return (react_1.default.createElement(__1.LineInput, __assign({ className: "select-coloured-value", required: required, readOnly: readOnly, labelLeft: labelLeft, noMargin: noMargin }, props),
            react_1.default.createElement(__1.Label, { text: label, row: row, light: row && readOnly }),
            readOnly ? (react_1.default.createElement(__1.LineInput, { labelLeft: labelLeft, className: "select-coloured-value__input" },
                react_1.default.createElement("span", { className: this.getIconClasses(value) }, lodash_1.get(value, valueKey, lodash_1.get(value, labelKey, noValueString || utils_1.gettext('None')))),
                react_1.default.createElement("span", null,
                    "\u00A0\u00A0",
                    lodash_1.get(value, labelKey, '')))) : (react_1.default.createElement("button", { type: "button", className: "dropdown__toggle select-coloured-value__input line-input", onClick: this.togglePopup, onFocus: onFocus },
                react_1.default.createElement("span", { className: this.getIconClasses(value) }, lodash_1.get(value, valueKey, lodash_1.get(value, labelKey, noValueString || utils_1.gettext('None')))),
                "\u00A0\u00A0",
                lodash_1.get(value, labelKey, ''),
                react_1.default.createElement("b", { className: "dropdown__caret" }))),
            this.state.openPopup && (react_1.default.createElement(ColouredValuePopup_1.ColouredValuePopup, { title: label, options: options, getClassNamesForOption: this.getIconClasses, onChange: this.onChange, onCancel: this.togglePopup, clearable: clearable, target: "dropdown__caret", labelKey: labelKey, valueKey: valueKey, popupContainer: popupContainer }))));
    };
    return ColouredValueInput;
}(react_1.default.Component));
exports.ColouredValueInput = ColouredValueInput;
ColouredValueInput.propTypes = {
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        value: prop_types_1.default.object,
    })).isRequired,
    readOnly: prop_types_1.default.bool,
    iconName: prop_types_1.default.string.isRequired,
    required: prop_types_1.default.bool,
    labelLeft: prop_types_1.default.bool,
    clearable: prop_types_1.default.bool,
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.object,
    onChange: prop_types_1.default.func,
    labelKey: prop_types_1.default.string,
    valueKey: prop_types_1.default.string,
    noMargin: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    row: prop_types_1.default.bool,
    noValueString: prop_types_1.default.string,
    onFocus: prop_types_1.default.func,
};
ColouredValueInput.defaultProps = {
    required: false,
    labelLeft: false,
    clearable: true,
    labelKey: 'name',
    valueKey: 'qcode',
    noMargin: false,
    readOnly: false,
    row: false,
};


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var classnames_1 = __importDefault(__webpack_require__(4));
var utils_1 = __webpack_require__(32);
var constants_1 = __webpack_require__(28);
var Popup_1 = __webpack_require__(80);
var utils_2 = __webpack_require__(3);
__webpack_require__(956);
/**
 * @ngdoc react
 * @name ColouredValuePopup
 * @description Popup component to show color coded options
 */
var ColouredValuePopup = /** @class */ (function (_super) {
    __extends(ColouredValuePopup, _super);
    function ColouredValuePopup(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.state = { activeIndex: -1 };
        return _this;
    }
    /**
     * @ngdoc method
     * @name ColouredValuePopup#onKeyDown
     * @description onKeyDown method to handle keyboard selection of options
     */
    ColouredValuePopup.prototype.onKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                    utils_1.onEventCapture(event);
                    this.handleEnterKey(event);
                    break;
                case constants_1.KEYCODES.DOWN:
                    utils_1.onEventCapture(event);
                    this.handleDownArrowKey(event);
                    break;
                case constants_1.KEYCODES.UP:
                    utils_1.onEventCapture(event);
                    this.handleUpArrowKey(event);
                    break;
            }
        }
    };
    /**
     * @ngdoc method
     * @name ColouredValuePopup#handleEnterKey
     * @description handleEnterKey method to handle enter-key press on a selected option
     */
    ColouredValuePopup.prototype.handleEnterKey = function (event) {
        this.props.onChange(this.props.options[this.state.activeIndex]);
    };
    /**
     * @ngdoc method
     * @name ColouredValuePopup#handleDownArrowKey
     * @description handleDownArrowKey method to handle down-key press to select options
     */
    ColouredValuePopup.prototype.handleDownArrowKey = function (event) {
        if (lodash_1.get(this.props, 'options.length', 0) - 1 > this.state.activeIndex) {
            this.setState({ activeIndex: this.state.activeIndex + 1 });
        }
    };
    /**
     * @ngdoc method
     * @name ColouredValuePopup#handleUpArrowKey
     * @description handleUpArrowKey method to handle up-key press to select options
     */
    ColouredValuePopup.prototype.handleUpArrowKey = function (event) {
        if (this.state.activeIndex > 0) {
            this.setState({ activeIndex: this.state.activeIndex - 1 });
        }
    };
    ColouredValuePopup.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, target = _b.target, onCancel = _b.onCancel, title = _b.title, clearable = _b.clearable, onChange = _b.onChange, getClassNamesForOption = _b.getClassNamesForOption, options = _b.options, labelKey = _b.labelKey, valueKey = _b.valueKey, popupContainer = _b.popupContainer;
        return (react_1.default.createElement(Popup_1.Popup, { target: target, close: onCancel, className: "select-coloured-value__popup", popupContainer: popupContainer, onKeyDown: this.onKeyDown },
            title && (react_1.default.createElement(Popup_1.Header, { noPadding: true },
                react_1.default.createElement(Popup_1.Label, { text: title, centerText: true }))),
            react_1.default.createElement(Popup_1.Content, { noPadding: true },
                react_1.default.createElement("ul", null,
                    clearable && (react_1.default.createElement("li", null,
                        react_1.default.createElement("button", { type: "button", onClick: onChange.bind(null, (_a = {},
                                _a[labelKey] = 'None',
                                _a[valueKey] = null,
                                _a)) },
                            react_1.default.createElement("span", null, utils_2.gettext('None'))))),
                    options.map(function (opt, index) { return (react_1.default.createElement("li", { key: index },
                        react_1.default.createElement("button", { type: "button", onClick: onChange.bind(null, opt), className: classnames_1.default({
                                'select-coloured-value__popup--activeElement': _this.state.activeIndex === index,
                            }) },
                            react_1.default.createElement("span", { className: getClassNamesForOption(opt) }, lodash_1.get(opt, valueKey, '')),
                            "\u00A0\u00A0",
                            lodash_1.get(opt, labelKey, '')))); })))));
    };
    return ColouredValuePopup;
}(react_1.default.PureComponent));
exports.ColouredValuePopup = ColouredValuePopup;
ColouredValuePopup.propTypes = {
    onChange: prop_types_1.default.func,
    onCancel: prop_types_1.default.func,
    title: prop_types_1.default.string,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        value: prop_types_1.default.object,
    })).isRequired,
    getClassNamesForOption: prop_types_1.default.func,
    clearable: prop_types_1.default.bool,
    target: prop_types_1.default.string.isRequired,
    labelKey: prop_types_1.default.string,
    valueKey: prop_types_1.default.string,
    popupContainer: prop_types_1.default.func,
};
ColouredValuePopup.defaultProps = {
    labelKey: 'name',
    valueKey: 'qcode',
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(957);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.select-coloured-value__input {\n  padding-top: 4px;\n  height: 2.4rem;\n  font-size: 1.4rem; }\n  .select-coloured-value__input span {\n    vertical-align: middle; }\n\n.select-coloured-value__popup {\n  width: 200px; }\n  .select-coloured-value__popup button {\n    padding: .6rem 1.6rem;\n    width: 100%;\n    text-align: left; }\n    .select-coloured-value__popup button:hover {\n      background: #eff7fa; }\n  .select-coloured-value__popup--activeElement {\n    background: #eff7fa; }\n", ""]);

// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var momentAlias = __importStar(__webpack_require__(5));
var __1 = __webpack_require__(30);
var TimeInputPopup_1 = __webpack_require__(959);
var __2 = __webpack_require__(23);
var constants_1 = __webpack_require__(28);
__webpack_require__(440);
var moment = momentAlias;
/**
 * @ngdoc react
 * @name TimeInput
 * @description Component to pick time in hours and minutes
 */
var TimeInput = /** @class */ (function (_super) {
    __extends(TimeInput, _super);
    function TimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            openTimePicker: false,
            invalid: false,
            viewValue: '',
            previousValidValue: '',
        };
        _this.dom = { inputField: null };
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.validateTimeText = _this.validateTimeText.bind(_this);
        _this.toggleOpenTimePicker = _this.toggleOpenTimePicker.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    TimeInput.prototype.componentWillReceiveProps = function (nextProps) {
        var val = nextProps.value && moment.isMoment(nextProps.value) ?
            nextProps.value.format(this.props.timeFormat) : '';
        this.setState({
            viewValue: val,
            previousValidValue: val,
        });
    };
    TimeInput.prototype.componentDidMount = function () {
        // After first render, set the value
        var value = this.props.value;
        var viewValue = value && moment.isMoment(value) ? value.format(this.props.timeFormat) : '';
        this.setState({ viewValue: viewValue });
    };
    TimeInput.prototype.toggleOpenTimePicker = function () {
        this.setState({ openTimePicker: !this.state.openTimePicker });
        if (this.state.openTimePicker) {
            // Keep the focus to enable tab navigation
            this.dom.inputField.focus();
        }
    };
    TimeInput.prototype.validateTimeText = function (field, val) {
        var regex = new RegExp('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$', 'i');
        if (!val.match(regex)) {
            this.setState({
                invalid: true,
                viewValue: val,
            });
        }
        else {
            this.setState({
                invalid: false,
                viewValue: val,
                previousValidValue: val,
            });
            this.onChange(val);
        }
    };
    /**
    * @ngdoc method
    * @name TimeInput#handleInputBlur
    * @description handleInputBlur resets view-value incase of invalid time input
    */
    TimeInput.prototype.handleInputBlur = function () {
        if (this.state.invalid) {
            this.setState({
                viewValue: this.state.previousValidValue,
                invalid: false,
            });
        }
    };
    TimeInput.prototype.onChange = function (newValue) {
        var _a = this.props, value = _a.value, onChange = _a.onChange, field = _a.field, timeFormat = _a.timeFormat;
        // Takes the time as a string (based on the configured time format)
        // Then parses it and calls parents onChange with new moment object
        var newTime = moment(newValue, timeFormat);
        var newMoment = value && moment.isMoment(value) ? moment(value) : moment();
        newMoment.hour(newTime.hour());
        newMoment.minute(newTime.minute());
        newMoment.second(0);
        if (!newMoment.isSame(value) || !value) {
            onChange(field, newMoment);
        }
    };
    TimeInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, field = _a.field, label = _a.label, value = _a.value, readOnly = _a.readOnly, popupContainer = _a.popupContainer, onFocus = _a.onFocus, props = __rest(_a, ["placeholder", "field", "label", "value", "readOnly", "popupContainer", "onFocus"]);
        return (react_1.default.createElement(__1.LineInput, __assign({}, props, { readOnly: readOnly }),
            react_1.default.createElement(__1.Label, { text: label }),
            react_1.default.createElement(__2.IconButton, { className: "sd-line-input__icon-right", icon: "icon-time", onFocus: onFocus, onClick: !readOnly ? this.toggleOpenTimePicker : null }),
            react_1.default.createElement(__1.Input, { field: field, value: this.state.viewValue, onChange: this.validateTimeText, type: "text", placeholder: placeholder, onBlur: this.handleInputBlur, readOnly: readOnly, onFocus: onFocus, onKeyDown: function (event) {
                    if (event.keyCode === constants_1.KEYCODES.ENTER) {
                        _this.setState({ openTimePicker: true });
                    }
                }, refNode: function (ref) { return _this.dom.inputField = ref; } }),
            this.state.openTimePicker && (react_1.default.createElement(TimeInputPopup_1.TimeInputPopup, { value: value, onChange: this.onChange, close: this.toggleOpenTimePicker, target: "icon-time", popupContainer: popupContainer }))));
    };
    return TimeInput;
}(react_1.default.Component));
exports.TimeInput = TimeInput;
TimeInput.propTypes = {
    field: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.instanceOf(moment),
    ]),
    onChange: prop_types_1.default.func.isRequired,
    placeholder: prop_types_1.default.string,
    timeFormat: prop_types_1.default.string.isRequired,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
TimeInput.defaultProps = {
    placeholder: 'Time',
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
};


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var Popup_1 = __webpack_require__(80);
var __1 = __webpack_require__(23);
__webpack_require__(440);
/**
 * @ngdoc react
 * @name TimeInputPopup
 * @description Main Popup Component of TimePicker
 */
var TimeInputPopup = /** @class */ (function (_super) {
    __extends(TimeInputPopup, _super);
    function TimeInputPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedHourIndex: 0,
            selectedMinuteIndex: 0,
            currentTime: moment_1.default(),
        };
        _this.hours = lodash_1.range(0, 24);
        _this.minutes = lodash_1.range(0, 60, 5);
        return _this;
    }
    TimeInputPopup.prototype.componentWillMount = function () {
        var value = this.props.value;
        var hourIndex;
        var minuteIndex;
        var inputDateTime = value && moment_1.default.isMoment(value) ? moment_1.default(value) : this.state.currentTime;
        // Round it to nearest 5 minutes mark if needed
        var diffMins = 5 - inputDateTime.minute() % 5;
        if (diffMins !== 5) {
            inputDateTime = inputDateTime.add(diffMins, 'm');
        }
        hourIndex = inputDateTime.hour();
        minuteIndex = inputDateTime.minute() / 5;
        this.setState({
            selectedHourIndex: hourIndex,
            selectedMinuteIndex: minuteIndex,
        });
    };
    TimeInputPopup.prototype.setselectedHourIndex = function (val) {
        this.setState({ selectedHourIndex: val });
    };
    TimeInputPopup.prototype.setselectedMinuteIndex = function (val) {
        this.setState({ selectedMinuteIndex: val });
    };
    TimeInputPopup.prototype.handleConfirm = function (addMinutes) {
        var _a = this.props, onChange = _a.onChange, close = _a.close;
        if (addMinutes) {
            this.state.currentTime.add(addMinutes, 'm');
            onChange(this.state.currentTime.format('HH:mm'));
        }
        else {
            onChange(this.state.selectedHourIndex + ':' + (this.state.selectedMinuteIndex * 5));
        }
        // Close the timepicker
        close();
    };
    TimeInputPopup.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(Popup_1.Popup, { close: this.props.close, target: this.props.target, className: "time-popup", noPadding: true, popupContainer: this.props.popupContainer },
            react_1.default.createElement(Popup_1.Header, { noBorder: true },
                react_1.default.createElement("div", { className: "time-popup__header-row" },
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 30), text: utils_1.gettext('in 30 min') }),
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 60), text: utils_1.gettext('in 1 hr') }),
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 120), text: utils_1.gettext('in 2 hrs') }))),
            react_1.default.createElement(Popup_1.Content, null,
                react_1.default.createElement("div", { className: "time-popup__select-area" },
                    react_1.default.createElement("div", { className: "header" }, "Hours"),
                    react_1.default.createElement("ul", null, this.hours.map(function (hour, index) { return (react_1.default.createElement("li", { key: index, className: index === _this.state.selectedHourIndex ? 'active' : '', onClick: _this.setselectedHourIndex.bind(_this, index) }, hour < 10 ? '0' + hour : hour)); }))),
                react_1.default.createElement("div", { className: "time-popup__select-area" },
                    react_1.default.createElement("div", { className: "header" }, "Minutes"),
                    react_1.default.createElement("ul", null, this.minutes.map(function (minute, index) { return (react_1.default.createElement("li", { key: index, className: index === _this.state.selectedMinuteIndex ? 'active' : '', onClick: _this.setselectedMinuteIndex.bind(_this, index) }, minute < 10 ? '0' + minute : minute)); })))),
            react_1.default.createElement(Popup_1.Footer, { className: "time-popup__footer" },
                react_1.default.createElement(__1.Button, { text: utils_1.gettext('Confirm'), color: "primary", size: "small", pullRight: true, onClick: this.handleConfirm.bind(this, 0) }),
                react_1.default.createElement(__1.Button, { text: utils_1.gettext('Cancel'), size: "small", pullRight: true, onClick: this.props.close }))));
    };
    return TimeInputPopup;
}(react_1.default.Component));
exports.TimeInputPopup = TimeInputPopup;
TimeInputPopup.propTypes = {
    value: prop_types_1.default.object,
    onChange: prop_types_1.default.func.isRequired,
    close: prop_types_1.default.func.isRequired,
    target: prop_types_1.default.string.isRequired,
    popupContainer: prop_types_1.default.func,
};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.time-popup {\n  width: 200px; }\n  .time-popup__header-row {\n    display: flex;\n    flex-direction: row; }\n    .time-popup__header-row .btn {\n      flex: 1;\n      padding: 4px 6px;\n      font-size: 11px; }\n  .time-popup__footer .btn {\n    height: 28px; }\n  .time-popup__select-area {\n    margin-top: 15px;\n    border-top: 1px solid #ddd; }\n    .time-popup__select-area .header {\n      margin-top: -10px;\n      float: left;\n      background: #fff;\n      text-transform: uppercase;\n      color: #adadad;\n      font-size: 11px;\n      padding-right: 10px; }\n    .time-popup__select-area ul {\n      padding-top: 15px;\n      *zoom: 1; }\n      .time-popup__select-area ul:before, .time-popup__select-area ul:after {\n        display: table;\n        content: \"\"; }\n      .time-popup__select-area ul:after {\n        clear: both; }\n      .time-popup__select-area ul > li {\n        float: left;\n        box-sizing: border-box;\n        width: 28px;\n        height: 28px;\n        line-height: 28px;\n        text-align: center;\n        margin: 0 2px 2px 0;\n        -webkit-border-radius: 2px;\n        -moz-border-radius: 2px;\n        -ms-border-radius: 2px;\n        border-radius: 2px; }\n        .time-popup__select-area ul > li:hover {\n          background: #eff7fa;\n          cursor: pointer; }\n        .time-popup__select-area ul > li.active {\n          background: #5ea9c8;\n          color: #fff; }\n", ""]);

// exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var momentAlias = __importStar(__webpack_require__(5));
var __1 = __webpack_require__(30);
var __2 = __webpack_require__(23);
var DateInputPopup_1 = __webpack_require__(962);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
__webpack_require__(114);
var moment = momentAlias;
/**
 * @ngdoc react
 * @name DateInput
 * @description Component to pick dates in calendar view
 */
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            openDatePicker: false,
            invalid: false,
            viewValue: '',
            previousValidValue: '',
        };
        _this.dom = { inputField: null };
        _this.validateDateText = _this.validateDateText.bind(_this);
        _this.handleInputBlur = _this.handleInputBlur.bind(_this);
        _this.toggleOpenDatePicker = _this.toggleOpenDatePicker.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    DateInput.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, value = _a.value, dateFormat = _a.dateFormat;
        var val = nextProps.value && moment.isMoment(nextProps.value) ? nextProps.value.format(dateFormat) : '';
        this.setState({
            viewValue: val,
            previousValidValue: value,
        });
    };
    DateInput.prototype.componentDidMount = function () {
        // After first render, set value
        var _a = this.props, value = _a.value, dateFormat = _a.dateFormat;
        var viewValue = value && moment.isMoment(value) ? value.format(dateFormat) : '';
        this.setState({ viewValue: viewValue });
    };
    /**
    * @ngdoc method
    * @name DateInput#toggleOpenDatePicker
    * @description toggleOpenDatePicker toggles open state of date-picker pop-up
    */
    DateInput.prototype.toggleOpenDatePicker = function () {
        this.setState({ openDatePicker: !this.state.openDatePicker });
        if (this.state.openDatePicker) {
            // Keep the focus to enable tab navigation
            this.dom.inputField.focus();
        }
    };
    /**
    * @ngdoc method
    * @name DateInput#validateDateText
    * @description validateDateText sets validate-state after text-input of dates
    */
    DateInput.prototype.validateDateText = function (field, val) {
        var regex = new RegExp('[0-9][0-9]/[0-9][0-9]/[0-9][0-9][0-9][0-9]', 'i');
        var valMoment = moment(val, this.props.dateFormat);
        if (val.match(regex) && valMoment.isValid()) {
            this.setState({
                invalid: false,
                viewValue: valMoment,
                previousValidValue: valMoment,
            });
            this.onChange(valMoment);
        }
        else {
            this.setState({
                invalid: true,
                viewValue: val,
            });
        }
    };
    /**
    * @ngdoc method
    * @name DateInput#handleInputBlur
    * @description handleInputBlur resets view-value incase of invalid date input
    * @returns {string} Icon class-name
    */
    DateInput.prototype.handleInputBlur = function () {
        if (this.state.invalid) {
            this.setState({
                viewValue: this.state.previousValidValue.format(this.props.dateFormat),
                invalid: false,
            });
        }
    };
    DateInput.prototype.onChange = function (newValue) {
        var _a = this.props, value = _a.value, onChange = _a.onChange, field = _a.field;
        var newMoment = newValue;
        if (!moment.isMoment(newMoment)) {
            newMoment = moment(newValue);
        }
        if (newMoment.isValid() && (!newMoment.isSame(value)) || !value) {
            onChange(field, newMoment);
        }
    };
    DateInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, field = _a.field, label = _a.label, placeholder = _a.placeholder, value = _a.value, readOnly = _a.readOnly, popupContainer = _a.popupContainer, onFocus = _a.onFocus, props = __rest(_a, ["field", "label", "placeholder", "value", "readOnly", "popupContainer", "onFocus"]);
        return (react_1.default.createElement(__1.LineInput, __assign({}, props, { readOnly: readOnly }),
            react_1.default.createElement(__1.Label, { text: label }),
            react_1.default.createElement(__2.IconButton, { className: "sd-line-input__icon-right", icon: "icon-calendar", onFocus: onFocus, onClick: readOnly ? undefined : this.toggleOpenDatePicker }),
            react_1.default.createElement(__1.Input, { field: field, value: this.state.viewValue, placeholder: placeholder, onChange: this.validateDateText, onFocus: onFocus, onBlur: this.handleInputBlur, type: "text", readOnly: readOnly, onKeyDown: function (event) {
                    if (event.keyCode === constants_1.KEYCODES.ENTER) {
                        utils_1.onEventCapture(event);
                        _this.setState({ openDatePicker: true });
                    }
                }, refNode: function (ref) { return _this.dom.inputField = ref; } }),
            this.state.openDatePicker && (react_1.default.createElement(DateInputPopup_1.DateInputPopup, { value: value, onChange: this.onChange, close: this.toggleOpenDatePicker, target: "icon-calendar", popupContainer: popupContainer }))));
    };
    return DateInput;
}(react_1.default.Component));
exports.DateInput = DateInput;
DateInput.propTypes = {
    field: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.instanceOf(moment),
    ]),
    onChange: prop_types_1.default.func.isRequired,
    placeholder: prop_types_1.default.string,
    className: prop_types_1.default.string,
    dateFormat: prop_types_1.default.string.isRequired,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
DateInput.defaultProps = {
    placeholder: 'Date',
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
};


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var momentAlias = __importStar(__webpack_require__(5));
var Popup_1 = __webpack_require__(80);
var __1 = __webpack_require__(23);
var DayPicker_1 = __webpack_require__(963);
var MonthPicker_1 = __webpack_require__(965);
var YearPicker_1 = __webpack_require__(966);
var moment = momentAlias;
var utils_1 = __webpack_require__(3);
__webpack_require__(114);
/**
 * @ngdoc react
 * @name DateInputPopup
 * @description Main Popup Component of DatePicker
 */
var DateInputPopup = /** @class */ (function (_super) {
    __extends(DateInputPopup, _super);
    function DateInputPopup(props) {
        var _this = _super.call(this, props) || this;
        var currentDate = moment();
        _this.state = {
            mode: 'day',
            modeTitle: _this.getModeTitle(currentDate, 'day'),
            currentDate: currentDate,
            selectedDate: currentDate,
        };
        _this.handleModeChange = _this.handleModeChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        return _this;
    }
    DateInputPopup.prototype.componentWillMount = function () {
        var value = this.props.value;
        if (value && moment.isMoment(value)) {
            this.setState({
                mode: 'day',
                modeTitle: this.getModeTitle(value, 'day'),
                selectedDate: value.clone(),
            });
        }
    };
    /**
    * @ngdoc method
    * @name DateInputPopup#handleModeChange
    * @description handleModeChange changes selection mode from days-months-years
    */
    DateInputPopup.prototype.handleModeChange = function () {
        var maxMode = this.props.maxMode || 'year';
        if (this.state.mode === 'day' && maxMode !== 'month') {
            this.setState({
                mode: 'month',
                modeTitle: this.getModeTitle(this.state.selectedDate, 'month'),
            });
        }
        else if (this.state.mode === 'month') {
            this.setState({
                mode: 'year',
                modeTitle: this.getModeTitle(this.state.selectedDate, 'year'),
            });
        }
    };
    /**
    * @ngdoc method
    * @name DateInputPopup#getFurtherValues
    * @description getFurtherValues gets next set-list of options when left/right arrows are clicked
    */
    DateInputPopup.prototype.getFurtherValues = function (direction) {
        var diff = 1;
        var diffType = '';
        switch (this.state.mode) {
            case 'day':
                // Have to change the month to previous value
                diffType = 'months';
                break;
            case 'month':
                // Have to change the year to previous value
                diffType = 'years';
                break;
            case 'year':
                diff = 20;
                diffType = 'years';
                break;
        }
        var newDate = direction ?
            this.state.selectedDate.clone().add(diff, diffType) :
            this.state.selectedDate.clone().subtract(diff, diffType);
        this.setState({
            modeTitle: this.getModeTitle(newDate, this.state.mode),
            selectedDate: newDate,
        });
    };
    DateInputPopup.prototype.handleConfirm = function (toolSelect /* 0-Today, 1-Tomorrow, 2-In two days*/) {
        var _a = this.props, onChange = _a.onChange, close = _a.close;
        var currentDate = this.state.currentDate;
        switch (toolSelect) {
            case 0:
                onChange(currentDate);
                break;
            case 1:
                onChange(currentDate.clone().add(1, 'days'));
                break;
            case 2:
                onChange(currentDate.clone().add(2, 'days'));
                break;
        }
        close();
    };
    /**
    * @ngdoc method
    * @name DateInputPopup#getStartingYearForYearPicker
    * @description getStartingYearForYearPicker returns starting year option in Year-picker
    */
    DateInputPopup.prototype.getStartingYearForYearPicker = function (date) {
        var yearRange = this.props.yearRange || 20;
        return parseInt("" + (date.year() - 1) / yearRange, 10) * yearRange + 1;
    };
    DateInputPopup.prototype.getModeTitle = function (date, mode) {
        var yearRange = this.props.yearRange || 20;
        switch (mode) {
            case 'day': return date.format('MMMM YYYY');
            case 'month': return date.format('YYYY');
            case 'year':
                return this.getStartingYearForYearPicker(date) + '-' +
                    (this.getStartingYearForYearPicker(date) + yearRange - 1);
        }
    };
    /**
    * @ngdoc method
    * @name DateInputPopup#handleSelectChange
    * @description handleSelectChange changes mode from days-months-year
    */
    DateInputPopup.prototype.handleSelectChange = function (newDate) {
        var nextMode = '';
        switch (this.state.mode) {
            case 'month':
                nextMode = 'day';
                break;
            case 'year':
                nextMode = 'month';
                break;
        }
        if (this.state.mode === 'day') {
            this.props.onChange(newDate);
            this.props.close();
        }
        else {
            this.setState({
                selectedDate: newDate,
                mode: nextMode,
                modeTitle: this.getModeTitle(newDate, nextMode),
            });
        }
    };
    DateInputPopup.prototype.render = function () {
        return (react_1.default.createElement(Popup_1.Popup, { close: this.props.close, target: this.props.target, noPadding: true, popupContainer: this.props.popupContainer, className: "date-popup" },
            react_1.default.createElement(Popup_1.Header, { noBorder: true, className: "date-popup__header" },
                react_1.default.createElement("div", { className: "date-popup__header-row" },
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 0), text: utils_1.gettext('Today') }),
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 1), text: utils_1.gettext('Tomorrow') }),
                    react_1.default.createElement(__1.Button, { onClick: this.handleConfirm.bind(this, 2), text: utils_1.gettext('In 2 days') })),
                react_1.default.createElement("div", { className: "date-popup__header-row date-popup__header-row--tools" },
                    react_1.default.createElement(__1.Button, { color: "default", icon: "icon-chevron-left-thin", onClick: this.getFurtherValues.bind(this, 0) }),
                    react_1.default.createElement(__1.Button, { color: "default", className: "btn--mode", "aria-live": "assertive", "aria-atomic": "true", onClick: this.handleModeChange },
                        react_1.default.createElement("strong", null, this.state.modeTitle)),
                    react_1.default.createElement(__1.Button, { color: "default", icon: "icon-chevron-right-thin", onClick: this.getFurtherValues.bind(this, 1) }))),
            react_1.default.createElement(Popup_1.Content, null,
                react_1.default.createElement("div", { className: "date-popup__content" },
                    this.state.mode === 'day' && (react_1.default.createElement(DayPicker_1.DayPicker, { selectedDate: this.state.selectedDate, onChange: this.handleSelectChange })),
                    this.state.mode === 'month' && (react_1.default.createElement(MonthPicker_1.MonthPicker, { selectedDate: this.state.selectedDate, onChange: this.handleSelectChange })),
                    this.state.mode === 'year' && (react_1.default.createElement(YearPicker_1.YearPicker, { startingYear: this.getStartingYearForYearPicker(this.state.selectedDate), selectedDate: this.state.selectedDate, onChange: this.handleSelectChange })))),
            react_1.default.createElement(Popup_1.Footer, null,
                react_1.default.createElement(__1.Button, { size: "small", pullRight: true, onClick: this.props.close, text: utils_1.gettext('Cancel') }))));
    };
    return DateInputPopup;
}(react_1.default.Component));
exports.DateInputPopup = DateInputPopup;
DateInputPopup.propTypes = {
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.instanceOf(moment),
    ]),
    onChange: prop_types_1.default.func.isRequired,
    close: prop_types_1.default.func.isRequired,
    target: prop_types_1.default.string.isRequired,
    maxMode: prop_types_1.default.string,
    yearRange: prop_types_1.default.number,
    popupContainer: prop_types_1.default.func,
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
var lodash_1 = __webpack_require__(2);
var classnames_1 = __importDefault(__webpack_require__(4));
var __1 = __webpack_require__(23);
__webpack_require__(114);
/**
 * @ngdoc react
 * @name DayPicker
 * @description Component to Pick days of DatePicker
 */
var DayPicker = /** @class */ (function (_super) {
    __extends(DayPicker, _super);
    function DayPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            dates: [],
            selectedDateIndex: -1,
            monthStartIndex: -1,
            monthEndIndex: -1,
        };
        return _this;
    }
    DayPicker.prototype.componentWillMount = function () {
        this.setDatesForProps(this.props);
    };
    DayPicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props !== nextProps) {
            this.setDatesForProps(nextProps);
        }
    };
    DayPicker.prototype.setDatesForProps = function (props) {
        var firstDayOfMonth = moment_1.default().year(props.selectedDate.year())
            .month(props.selectedDate.month())
            .date(1)
            .isoWeekday();
        var daysInCurrentMonth = lodash_1.range(1, props.selectedDate.daysInMonth() + 1);
        var prevMonthDates = [];
        if (firstDayOfMonth !== 7) { // In this case, need to also have dates of previous month in the view
            var previousYear = props.selectedDate.month() === 0 ? props.selectedDate.year() - 1 :
                props.selectedDate.year();
            var previousMonth = props.selectedDate.month() === 0 ? 11 :
                props.selectedDate.month() - 1;
            var daysOfPreviousMonth = this.getDaysInMonth(previousYear, previousMonth);
            prevMonthDates = lodash_1.range(daysOfPreviousMonth - firstDayOfMonth + 1, daysOfPreviousMonth + 1);
        }
        var nextMonthDates = lodash_1.range(1, 43 - (prevMonthDates.length + daysInCurrentMonth.length));
        this.setState({
            dates: prevMonthDates.concat(daysInCurrentMonth, nextMonthDates),
            selectedDateIndex: daysInCurrentMonth.indexOf(props.selectedDate.date())
                + prevMonthDates.length,
            monthStartIndex: prevMonthDates.length,
            monthEndIndex: prevMonthDates.length + daysInCurrentMonth.length - 1,
        });
    };
    DayPicker.prototype.getDaysInMonth = function (year, month) {
        var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        return ((month === 1) && (year % 4 === 0) &&
            ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
    };
    DayPicker.prototype.onDateChange = function (index) {
        // Form new moment object and inform the parent component
        var newMoment = this.props.selectedDate.clone();
        if (index < this.state.monthStartIndex) {
            // Date selected was of previous month
            newMoment.subtract(1, 'months').date(this.state.dates[index]);
        }
        else if (index > this.state.monthEndIndex) {
            // Date selected was of next month
            newMoment.add(1, 'months').date(this.state.dates[index]);
        }
        else {
            newMoment.date(this.state.dates[index]);
        }
        this.props.onChange(newMoment);
    };
    DayPicker.prototype.render = function () {
        var _this = this;
        var dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var rows = lodash_1.chunk(this.state.dates, 7);
        return (react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, dayNames.map(function (day, index) { return (react_1.default.createElement("th", { key: index, className: "text-center" },
                    react_1.default.createElement("small", null, day))); }))),
            react_1.default.createElement("tbody", null, rows.map(function (row, rowIndex) { return (react_1.default.createElement("tr", { key: rowIndex }, row.map(function (date, index) { return (react_1.default.createElement("td", { key: index, className: "text-center" },
                react_1.default.createElement(__1.Button, { className: (rowIndex * 7 + index) === _this.state.selectedDateIndex ?
                        'active' :
                        null, onClick: _this.onDateChange.bind(_this, (rowIndex * 7 + index)) },
                    react_1.default.createElement("span", { className: classnames_1.default({
                            'text-muted': (rowIndex * 7 + index) < _this.state.monthStartIndex ||
                                (rowIndex * 7 + index) > _this.state.monthEndIndex,
                        }) }, date)))); }))); }))));
    };
    return DayPicker;
}(react_1.default.Component));
exports.DayPicker = DayPicker;
DayPicker.propTypes = {
    selectedDate: prop_types_1.default.object.isRequired,
    onChange: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.date-popup {\n  width: 260px; }\n  .date-popup__header {\n    width: 100%; }\n  .date-popup__header-row {\n    display: flex;\n    flex-direction: row; }\n    .date-popup__header-row .btn {\n      flex: 1;\n      padding: 4px 6px;\n      font-size: 11px; }\n      .date-popup__header-row .btn--mode {\n        flex: 2; }\n    .date-popup__header-row--tools {\n      margin-top: 5px; }\n      .date-popup__header-row--tools .btn {\n        background: none; }\n        .date-popup__header-row--tools .btn:hover, .date-popup__header-row--tools .btn:focus {\n          -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);\n          -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);\n          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);\n          background: none; }\n  .date-popup__content table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 0; }\n    .date-popup__content table td, .date-popup__content table th {\n      padding: 1px;\n      border: 0; }\n    .date-popup__content table thead tr th .btn {\n      background: none;\n      padding: 0; }\n    .date-popup__content table thead tr th small {\n      font-weight: 500; }\n    .date-popup__content table tbody tr:first-child td {\n      padding-top: 5px; }\n    .date-popup__content table tbody td {\n      padding: 0 2px; }\n      .date-popup__content table tbody td .btn {\n        width: 100% !important;\n        min-width: 28px !important;\n        min-height: 28px !important;\n        padding: 0;\n        background: none;\n        color: #333;\n        -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);\n        -moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25);\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25); }\n        .date-popup__content table tbody td .btn .text-muted {\n          color: #999; }\n        .date-popup__content table tbody td .btn:hover, .date-popup__content table tbody td .btn.active {\n          color: #333;\n          -webkit-box-shadow: inset 0 0 1px 0 #5ea9c8;\n          -moz-box-shadow: inset 0 0 1px 0 #5ea9c8;\n          box-shadow: inset 0 0 1px 0 #5ea9c8;\n          background: #eff7fa; }\n        .date-popup__content table tbody td .btn.btn--primary, .date-popup__content table tbody td .btn.btn--primary.active {\n          color: #fff;\n          background: #5ea9c8; }\n          .date-popup__content table tbody td .btn.btn--primary .text-muted, .date-popup__content table tbody td .btn.btn--primary.active .text-muted {\n            color: #fff; }\n", ""]);

// exports


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
var lodash_1 = __webpack_require__(2);
var __1 = __webpack_require__(23);
__webpack_require__(114);
/**
 * @ngdoc react
 * @name MonthPicker
 * @description Component to Pick months of DatePicker
 */
exports.MonthPicker = function (_a) {
    var selectedDate = _a.selectedDate, onChange = _a.onChange;
    var monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY',
        'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];
    var rows = lodash_1.chunk(monthNames, 3);
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, rows.map(function (row, rowIndex) { return (react_1.default.createElement("tr", { key: rowIndex }, row.map(function (date, index) { return (react_1.default.createElement("td", { key: index, className: "text-center" },
            react_1.default.createElement(__1.Button, { className: (rowIndex * 3 + index) === selectedDate.month() ? 'active' : null, onClick: onChange.bind(_this, (moment_1.default(selectedDate).month((rowIndex * 3 + index)))) },
                react_1.default.createElement("span", null, date)))); }))); }))));
};
exports.MonthPicker.propTypes = {
    selectedDate: prop_types_1.default.object.isRequired,
    onChange: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
var lodash_1 = __webpack_require__(2);
var __1 = __webpack_require__(23);
__webpack_require__(114);
/**
 * @ngdoc react
 * @name YearPicker
 * @description Component to Pick years of DatePicker
 */
exports.YearPicker = function (_a) {
    var selectedDate = _a.selectedDate, onChange = _a.onChange, startingYear = _a.startingYear, yearRange = _a.yearRange;
    var yRange = yearRange || 20;
    var years = lodash_1.range(startingYear, startingYear + yRange); // plus one to include the last number as welln
    var rows = lodash_1.chunk(years, 5);
    return (react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null, rows.map(function (row, rowIndex) { return (react_1.default.createElement("tr", { key: rowIndex }, row.map(function (year, index) { return (react_1.default.createElement("td", { key: index, className: "text-center" },
            react_1.default.createElement(__1.Button, { className: (startingYear + (rowIndex * 5 + index)) === selectedDate.year() ?
                    'active' :
                    null, onClick: onChange.bind(_this, (moment_1.default(selectedDate).year((startingYear + (rowIndex * 5 + index))))) },
                react_1.default.createElement("span", null, year)))); }))); }))));
};
exports.YearPicker.propTypes = {
    selectedDate: prop_types_1.default.object.isRequired,
    startingYear: prop_types_1.default.number.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    yearRange: prop_types_1.default.number,
};


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var momentAlias = __importStar(__webpack_require__(5));
var __1 = __webpack_require__(30);
__webpack_require__(968);
var Button_1 = __importDefault(__webpack_require__(441));
var utils_1 = __webpack_require__(3);
var moment = momentAlias;
/**
 * @ngdoc react
 * @name DateTimeInput
 * @description One Component packaging DatePicker and TimePicker to pick date and time
 */
exports.DateTimeInput = function (_a) {
    var field = _a.field, label = _a.label, value = _a.value, onChange = _a.onChange, required = _a.required, invalid = _a.invalid, timeFormat = _a.timeFormat, dateFormat = _a.dateFormat, readOnly = _a.readOnly, canClear = _a.canClear, item = _a.item, diff = _a.diff, errors = _a.errors, showErrors = _a.showErrors, popupContainer = _a.popupContainer, onFocus = _a.onFocus, props = __rest(_a, ["field", "label", "value", "onChange", "required", "invalid", "timeFormat", "dateFormat", "readOnly", "canClear", "item", "diff", "errors", "showErrors", "popupContainer", "onFocus"]);
    return (react_1.default.createElement(__1.Row, { flex: true, noPadding: !!invalid, className: {
            'date-time-input__row': true,
            'date-time-input__row--required': required,
            'date-time-input__row--invalid': invalid,
        } },
        react_1.default.createElement(__1.Field, { row: false, component: __1.DateInput, field: field + ".date", value: value, item: item, diff: diff, readOnly: readOnly, onChange: onChange, errors: errors, showErrors: showErrors, noMargin: !invalid, dateFormat: dateFormat, label: label, required: required, popupContainer: popupContainer, onFocus: onFocus }),
        react_1.default.createElement(__1.Field, { row: false, component: __1.TimeInput, field: field + ".time", value: value, item: item, diff: diff, readOnly: readOnly, onChange: onChange, errors: errors, showErrors: showErrors, noMargin: !invalid, timeFormat: timeFormat, popupContainer: popupContainer, onFocus: onFocus }),
        canClear && react_1.default.createElement(Button_1.default, { onClick: function () { return onChange(field, null); }, icon: "icon-close-small", size: "small", iconOnly: true, title: utils_1.gettext('Clear date and time'), className: "btn--icon-only-circle" })));
};
exports.DateTimeInput.propTypes = {
    field: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.instanceOf(moment),
    ]),
    onChange: prop_types_1.default.func.isRequired,
    timeFormat: prop_types_1.default.string.isRequired,
    dateFormat: prop_types_1.default.string.isRequired,
    hint: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    canClear: prop_types_1.default.bool,
    item: prop_types_1.default.object,
    diff: prop_types_1.default.object,
    errors: prop_types_1.default.object,
    showErrors: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
};
exports.DateTimeInput.defaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
    canClear: false,
    showErrors: false,
};


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(969);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.date-time-input__row--required .form-label::after {\n  color: #E51C23;\n  content: \"*\";\n  vertical-align: top;\n  font-size: 1.2rem;\n  padding-left: 0.3rem; }\n\n.date-time-input__row--invalid .form-label {\n  color: #E51C23; }\n", ""]);

// exports


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-multi-comp */
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var __1 = __webpack_require__(23);
var __2 = __webpack_require__(30);
__webpack_require__(971);
/**
 * @ngdoc react
 * @name InputArray
 * @description Component to create an array of input components
 */
exports.InputArray = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, addButtonComponent = _a.addButtonComponent, addButtonText = _a.addButtonText, maxCount = _a.maxCount, addOnly = _a.addOnly, originalCount = _a.originalCount, element = _a.element, defaultElement = _a.defaultElement, readOnly = _a.readOnly, message = _a.message, invalid = _a.invalid, row = _a.row, buttonWithLabel = _a.buttonWithLabel, label = _a.label, labelClassName = _a.labelClassName, props = __rest(_a, ["field", "value", "onChange", "addButtonComponent", "addButtonText", "maxCount", "addOnly", "originalCount", "element", "defaultElement", "readOnly", "message", "invalid", "row", "buttonWithLabel", "label", "labelClassName"]);
    var add = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var newElement = typeof defaultElement === 'function' ? defaultElement.apply(void 0, args) : defaultElement;
        value.push(lodash_1.cloneDeep(newElement));
        onChange(field, value.slice());
    };
    var remove = function (index) {
        value.splice(index, 1);
        onChange(field, value.slice());
    };
    var Component = element;
    var showAddButton = (maxCount ? value.length < maxCount : true) && !readOnly;
    var isIndexReadOnly = function (index) { return (addOnly && index === originalCount) ? false : readOnly; };
    var customButton = addButtonComponent ? react_1.default.createElement(addButtonComponent, { onAdd: add }) : false;
    var addButton = row ? (customButton || react_1.default.createElement(__1.Button, { onClick: add, text: addButtonText })) :
        (customButton || react_1.default.createElement(__1.Button, { onClick: add, text: addButtonText, tabIndex: 0, enterKeyIsClick: true }));
    var labelComponent = label ?
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: classnames_1.default('InputArray__label', labelClassName) }, label),
            buttonWithLabel && showAddButton && addButton) : null;
    var getComponent = function (val, index, _row) {
        var indexReadOnly = isIndexReadOnly(index);
        return _row ?
            (react_1.default.createElement(Component, __assign({ key: index, index: index, field: field + "[" + index + "]", onChange: onChange, value: val, remove: remove.bind(null, index), readOnly: indexReadOnly, message: lodash_1.get(message, "[" + index + "]"), invalid: !!lodash_1.get(message, "[" + index + "]"), openComponent: addOnly && !indexReadOnly }, props))) :
            (react_1.default.createElement(Component, __assign({ key: index, index: index, field: field + "[" + index + "]", onChange: onChange, value: val, remove: remove.bind(null, index), readOnly: indexReadOnly, message: lodash_1.get(message, "[" + index + "]"), invalid: !!lodash_1.get(message, "[" + index + "]"), openComponent: addOnly && !indexReadOnly }, props)));
    };
    return (react_1.default.createElement(__2.Row, { noPadding: !!message },
        labelComponent,
        lodash_1.get(message, field) && (react_1.default.createElement(__2.LineInput, { invalid: true, message: lodash_1.get(message, field), readOnly: true, noLabel: true })),
        value && value.map(function (val, index) { return (getComponent(val, index, row)); }),
        !buttonWithLabel && showAddButton && addButton));
};
exports.InputArray.propTypes = {
    field: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    value: prop_types_1.default.array,
    onChange: prop_types_1.default.func.isRequired,
    addButtonText: prop_types_1.default.string.isRequired,
    maxCount: prop_types_1.default.number,
    addOnly: prop_types_1.default.bool,
    originalCount: prop_types_1.default.number,
    element: prop_types_1.default.func.isRequired,
    defaultElement: prop_types_1.default.any,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
    ]),
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    buttonWithLabel: prop_types_1.default.bool,
    item: prop_types_1.default.object,
    diff: prop_types_1.default.object,
    formProfile: prop_types_1.default.object,
    errors: prop_types_1.default.object,
    showErrors: prop_types_1.default.bool,
    row: prop_types_1.default.bool,
    addButtonComponent: prop_types_1.default.oneOfType([
        prop_types_1.default.func,
        prop_types_1.default.object,
    ]),
    labelClassName: prop_types_1.default.string,
};
exports.InputArray.defaultProps = {
    value: [],
    defaultElement: {},
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: true,
    maxCount: 0,
    row: true,
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(972);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".InputArray__label {\n  display: inline-block;\n  padding-top: 13px !important;\n  padding-bottom: 18px !important; }\n", ""]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(30);
/**
 * @ngdoc react
 * @name RadioButtonInput
 * @description Component to show radio-button
 */
exports.RadioButtonInput = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, label = _a.label, options = _a.options, readOnly = _a.readOnly;
    return (react_1.default.createElement(_1.LineInput, null,
        react_1.default.createElement(_1.Label, { text: label }),
        react_1.default.createElement("div", { className: "flex-grid flex-grid--boxed-small flex-grid--wrap-items flex-grid--small-2" }, options.map(function (state) {
            return react_1.default.createElement(_1.Checkbox, { key: state.value, field: field, label: state.label, value: value, checkedValue: state.value, onChange: function (_field, _value) { return onChange(_field, _value); }, type: "radio", labelPosition: "inside", readOnly: readOnly });
        }))));
};
exports.RadioButtonInput.propTypes = {
    field: prop_types_1.default.string,
    value: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onChange: prop_types_1.default.func.isRequired,
    options: prop_types_1.default.array.isRequired,
    readOnly: prop_types_1.default.bool,
};
exports.RadioButtonInput.defaultProps = {
    value: '',
    options: [],
    readOnly: false,
};


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var Row_1 = __webpack_require__(431);
/**
 * @ngdoc react
 * @name Field
 * @description Component to encapsulate an input component in a form as a Field
 */
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    function Field(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { dirty: false };
        return _this;
    }
    Field.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, field = _a.field, formProfile = _a.formProfile;
        // If this field is disabled, then no need to perform checks
        if (!nextProps.enabled || !lodash_1.get(formProfile, "editor." + field + ".enabled", true)) {
            return;
        }
        // If the initial value changes, then we assume the form input object has changed too
        // i.e. changed to a different Event instance
        // In that case, set the dirty flag back to false
        if (lodash_1.get(nextProps.item, field) !== lodash_1.get(this.props.item, field)) {
            this.setState({ dirty: false });
        }
        else if (lodash_1.get(nextProps.diff, field) !== lodash_1.get(this.props.diff, field) ||
            lodash_1.get(nextProps, 'value') !== lodash_1.get(this.props, 'value')) {
            this.setState({ dirty: true });
        }
    };
    Field.prototype.render = function () {
        var _a = this.props, component = _a.component, field = _a.field, profileName = _a.profileName, diff = _a.diff, onChange = _a.onChange, defaultValue = _a.defaultValue, formProfile = _a.formProfile, errors = _a.errors, error = _a.error, row = _a.row, enabled = _a.enabled, showErrors = _a.showErrors, value = _a.value, onFocus = _a.onFocus, props = __rest(_a, ["component", "field", "profileName", "diff", "onChange", "defaultValue", "formProfile", "errors", "error", "row", "enabled", "showErrors", "value", "onFocus"]);
        var profileField = profileName || field;
        if (!enabled || !lodash_1.get(formProfile, "editor[\"" + profileField + "\"].enabled", true)) {
            return null;
        }
        var schema = lodash_1.get(formProfile, "schema[\"" + profileField + "\"]") || {};
        var currentError = (this.state.dirty || showErrors) ? (error || lodash_1.get(errors, field)) : null;
        var currentValue = value || lodash_1.get(diff, field);
        var Component = component;
        var child = react_1.default.createElement(Component, __assign({ field: field, profileField: profileField, value: currentValue || defaultValue, diff: diff, onChange: onChange, maxLength: schema.validate_on_post ? 0 : schema.maxlength, required: schema.validate_on_post ? false : schema.required, message: currentError, invalid: !!currentError, errors: errors, showErrors: showErrors, dirty: this.state.dirty, formProfile: formProfile, row: row, onFocus: onFocus }, props));
        return row ? react_1.default.createElement(Row_1.Row, null, child) : child;
    };
    return Field;
}(react_1.default.Component));
exports.Field = Field;
Field.propTypes = {
    component: prop_types_1.default.func.isRequired,
    field: prop_types_1.default.string.isRequired,
    profileName: prop_types_1.default.string,
    label: prop_types_1.default.string,
    item: prop_types_1.default.object,
    diff: prop_types_1.default.object,
    onChange: prop_types_1.default.func.isRequired,
    defaultValue: prop_types_1.default.any,
    formProfile: prop_types_1.default.object,
    errors: prop_types_1.default.object,
    error: prop_types_1.default.string,
    row: prop_types_1.default.bool,
    enabled: prop_types_1.default.bool,
    showErrors: prop_types_1.default.bool,
    value: prop_types_1.default.any,
    onFocus: prop_types_1.default.func,
};
Field.defaultProps = {
    defaultValue: '',
    row: true,
    enabled: true,
    showErrors: false,
};


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_bootstrap_1 = __webpack_require__(135);
var prop_types_1 = __importDefault(__webpack_require__(1));
var Column_1 = __webpack_require__(196);
var utils_1 = __webpack_require__(32);
var utils_2 = __webpack_require__(3);
/**
 * @ngdoc react
 * @name PubStatus
 * @description Component to show published status of an item
 */
exports.PubStatus = function (_a) {
    var item = _a.item, isPublic = _a.isPublic;
    var badge;
    var title = null;
    if (isPublic) {
        title = utils_2.gettext('Posted');
        badge = react_1.default.createElement("span", { className: "badge badge--success" }, "P");
    }
    else if (utils_1.isNotForPublication(item)) {
        title = utils_2.gettext('Not for publication');
        badge = react_1.default.createElement("i", { className: "icon-ban-circle icon--red", style: {
                width: '22px',
                height: '22px',
                fontSize: '22px',
            } });
    }
    else {
        badge = react_1.default.createElement("span", { className: "badge badge--light" }, "\u00A0");
    }
    return (react_1.default.createElement(Column_1.Column, null,
        title &&
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "right", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "badge_pub_status" }, title) }, badge),
        !title && (badge)));
};
exports.PubStatus.propTypes = {
    item: prop_types_1.default.object.isRequired,
    isPublic: prop_types_1.default.bool,
};


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(454);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(978);
module.exports = __webpack_require__(38).Object.assign;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(52);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(980) });


/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(61);
var getKeys = __webpack_require__(116);
var gOPS = __webpack_require__(206);
var pIE = __webpack_require__(117);
var toObject = __webpack_require__(118);
var IObject = __webpack_require__(446);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(95)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(82);
var toLength = __webpack_require__(447);
var toAbsoluteIndex = __webpack_require__(982);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(202);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(984), __esModule: true };

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(448);
__webpack_require__(989);
module.exports = __webpack_require__(210).f('iterator');


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(202);
var defined = __webpack_require__(201);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(208);
var descriptor = __webpack_require__(115);
var setToStringTag = __webpack_require__(209);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(92)(IteratorPrototype, __webpack_require__(53)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(68);
var anObject = __webpack_require__(93);
var getKeys = __webpack_require__(116);

module.exports = __webpack_require__(61) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(67).document;
module.exports = document && document.documentElement;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(990);
var global = __webpack_require__(67);
var hide = __webpack_require__(92);
var Iterators = __webpack_require__(119);
var TO_STRING_TAG = __webpack_require__(53)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(991);
var step = __webpack_require__(992);
var Iterators = __webpack_require__(119);
var toIObject = __webpack_require__(82);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(449)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(994), __esModule: true };

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(995);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
module.exports = __webpack_require__(38).Symbol;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(67);
var has = __webpack_require__(81);
var DESCRIPTORS = __webpack_require__(61);
var $export = __webpack_require__(52);
var redefine = __webpack_require__(450);
var META = __webpack_require__(996).KEY;
var $fails = __webpack_require__(95);
var shared = __webpack_require__(204);
var setToStringTag = __webpack_require__(209);
var uid = __webpack_require__(137);
var wks = __webpack_require__(53);
var wksExt = __webpack_require__(210);
var wksDefine = __webpack_require__(211);
var enumKeys = __webpack_require__(997);
var isArray = __webpack_require__(998);
var anObject = __webpack_require__(93);
var isObject = __webpack_require__(94);
var toObject = __webpack_require__(118);
var toIObject = __webpack_require__(82);
var toPrimitive = __webpack_require__(199);
var createDesc = __webpack_require__(115);
var _create = __webpack_require__(208);
var gOPNExt = __webpack_require__(999);
var $GOPD = __webpack_require__(453);
var $GOPS = __webpack_require__(206);
var $DP = __webpack_require__(68);
var $keys = __webpack_require__(116);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(452).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(117).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(136)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(92)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(137)('meta');
var isObject = __webpack_require__(94);
var has = __webpack_require__(81);
var setDesc = __webpack_require__(68).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(95)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(116);
var gOPS = __webpack_require__(206);
var pIE = __webpack_require__(117);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(200);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(82);
var gOPN = __webpack_require__(452).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1000 */
/***/ (function(module, exports) {



/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(211)('asyncIterator');


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(211)('observable');


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1004), __esModule: true };

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1005);
module.exports = __webpack_require__(38).Object.setPrototypeOf;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(52);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1006).set });


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(94);
var anObject = __webpack_require__(93);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(198)(Function.call, __webpack_require__(453).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1008), __esModule: true };

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1009);
var $Object = __webpack_require__(38).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(208) });


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(1011);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1013);
module.exports = __webpack_require__(38).Object.entries;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(52);
var $entries = __webpack_require__(456)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(212);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], { onClick: onDismiss, label: closeLabel }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('alert', Alert)));

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1016);
module.exports = __webpack_require__(38).Object.values;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(52);
var $values = __webpack_require__(456)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('badge', Badge));

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('breadcrumb', Breadcrumb));

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(39);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('carousel', Carousel));

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('carousel-caption', CarouselCaption));

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(1024));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(214));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(214));

var _style = _interopRequireDefault(__webpack_require__(121));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1027));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(461));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('checkbox', Checkbox));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(35);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('clearfix', Clearfix));

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('control-label', ControlLabel));

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(35);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('col', Col));

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1036);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(464));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(39);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: Object(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('dropdown-menu', DropdownMenu));

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(448);
__webpack_require__(1041);
module.exports = __webpack_require__(38).Array.from;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(198);
var $export = __webpack_require__(52);
var toObject = __webpack_require__(118);
var call = __webpack_require__(1042);
var isArrayIter = __webpack_require__(1043);
var toLength = __webpack_require__(447);
var createProperty = __webpack_require__(1044);
var getIterFn = __webpack_require__(1045);

$export($export.S + $export.F * !__webpack_require__(1047)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(93);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(119);
var ITERATOR = __webpack_require__(53)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(68);
var createDesc = __webpack_require__(115);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1046);
var ITERATOR = __webpack_require__(53)('iterator');
var Iterators = __webpack_require__(119);
module.exports = __webpack_require__(38).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(200);
var TAG = __webpack_require__(53)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(53)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(142);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { bsSize: bsSize, bsStyle: bsStyle }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (DropdownButton);

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('form', Form));

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(35);
















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["getClassSet"])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["prefix"])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsClass"])('form-control', Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('form-control-static', FormControlStatic));

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(39);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('form-group', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('help-block', HelpBlock));

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('img', Image));

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(35);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('input-group', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('input-group-addon', InputGroupAddon));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('input-group-btn', InputGroupButton));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes) }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('jumbotron', Jumbotron));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(35);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes) }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('label', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(39);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('list-group', ListGroup));

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Media__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);













var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),

  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_9__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('media-body', MediaBody));

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('media-heading', MediaHeading));

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('media-left', MediaLeft));

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('media-list', MediaList));

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('media', MediaListItem));

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('media-right', MediaRight));

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(31);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["prefix"])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["bsClass"])('dropdown', MenuItem));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(35);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

/* eslint-disable no-use-before-define, react/no-multi-comp */
function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { timeout: Modal.TRANSITION_DURATION }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, { timeout: Modal.BACKDROP_TRANSITION_DURATION }));
}

/* eslint-enable no-use-before-define */

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
    _this.setModalRef = _this.setModalRef.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: this.setModalRef,
        show: show,
        containerClassName: Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["prefix"])(props, 'open'),
        transition: animation ? DialogTransition : undefined,
        backdrop: backdrop,
        backdropTransition: animation ? BackdropTransition : undefined,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["prefix"])(props, 'backdrop'), backdropClassName, inClassName),
        onEntering: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: Object(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["bsClass"])('modal', Object(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(218));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(219));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1071));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1073));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(98));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1072));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(69));

var _on = _interopRequireDefault(__webpack_require__(218));

var _off = _interopRequireDefault(__webpack_require__(219));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(465);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(98);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(69);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(145);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1075);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(21);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(42);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1076);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(475);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1082);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(468);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1083);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(147);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(42);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1077);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(121);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(472);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(474);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1080);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1078));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1079));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(473));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(473));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(145);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(147);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(35);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('modal', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(31);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["splitBsPropsAndOmit"])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["bsClass"])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["prefix"])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["bsStyles"])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(39);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavDropdown);

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(21);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(475);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1091);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(467);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(145);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1092);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(147);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(484);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1093);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(485);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(99);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(1094));

var _offset = _interopRequireDefault(__webpack_require__(484));

var _offsetParent = _interopRequireDefault(__webpack_require__(1095));

var _scrollTop = _interopRequireDefault(__webpack_require__(485));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1096));

var _style = _interopRequireDefault(__webpack_require__(121));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(97));

var _style = _interopRequireDefault(__webpack_require__(121));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(26);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(146));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(31);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;
      _this2.hide();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;
      _this3.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('page-header', PageHeader));

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(1100);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(39);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('pager', Pager));

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaginationItem__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      children
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('pagination', Pagination);

Pagination.First = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_7__PaginationItem__["c" /* Last */];

/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);





/* eslint-disable react/no-multi-comp */






var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired
};

var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};

function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['active', 'disabled', 'className', 'style', 'activeLabel', 'children']);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'li',
    { style: style, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }) },
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ disabled: disabled }, props),
      children,
      active && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        activeLabel
      )
    )
  );
}

PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue) {
  var _class, _temp;

  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : name;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(_class, _React$Component);

    function _class() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
    }

    _class.prototype.render = function render() {
      var _props = this.props,
          disabled = _props.disabled,
          children = _props.children,
          className = _props.className,
          props = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['disabled', 'children', 'className']);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */];

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'li',
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
          'aria-label': label,
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled })
        }, props),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          Component,
          null,
          children || defaultValue
        )
      );
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.displayName = name, _class.propTypes = { disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool }, _temp;
}

var First = createButton('First', '\xAB');
var Prev = createButton('Prev', '\u2039');
var Ellipsis = createButton('Ellipsis', '\u2026', 'More');
var Next = createButton('Next', '\u203A');
var Last = createButton('Last', '\xBB');

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelBody__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelHeading__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelTitle__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelFooter__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PanelToggle__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PanelCollapse__ = __webpack_require__(487);





















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + '--' + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  })
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Panel.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        eventKey = _props.eventKey,
        id = _props.id;

    var idKey = eventKey == null ? id : eventKey;

    var ids = void 0;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;

      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  Panel.prototype.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;

      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  Panel.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        children = _props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["splitBsPropsAndOmit"])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["getClassSet"])(bsProps)) }),
      children
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Panel.propTypes = propTypes;

Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;

var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["bsClass"])('panel', Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["bsStyles"])([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["d" /* State */]), [__WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_12__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), { expanded: 'onToggle' });

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_14__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_15__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_13__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_16__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_17__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_18__PanelCollapse__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledPanel);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelCollapse__ = __webpack_require__(487);










var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired
};

var defaultProps = {
  collapsible: false
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};

var PanelBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelBody, _React$Component);

  function PanelBody() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelBody);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelBody.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        collapsible = _props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsPropsAndOmit"])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    var body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["prefix"])(bsProps, 'body')) }),
      children
    );

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__PanelCollapse__["a" /* default */],
        null,
        body
      );
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('panel', PanelBody));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var PanelHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelHeading, _React$Component);

  function PanelHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelHeading.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        Component = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'className', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'heading'))
      }),
      children
    );
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('panel', PanelHeading));

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PanelToggle__ = __webpack_require__(488);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_react_prop_types_lib_elementType___default.a,
  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
  })
};

var defaultProps = {
  componentClass: 'div'
};

var PanelTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PanelTitle, _React$Component);

  function PanelTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PanelTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelTitle.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        toggle = _props.toggle,
        Component = _props.componentClass,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'className', 'toggle', 'componentClass']);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__PanelToggle__["a" /* default */],
        null,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'title'))
      }),
      children
    );
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('panel', PanelTitle));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);









var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};

var PanelFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PanelFooter, _React$Component);

  function PanelFooter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PanelFooter);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PanelFooter.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["prefix"])(bsProps, 'footer'))
      }),
      children
    );
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('panel', PanelFooter));

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('popover', Popover));

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(39);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    // eslint-disable-next-line no-use-before-define
    if (child.type === ProgressBar) return;

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress') }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min,
        now: now,
        max: max,
        label: label,
        srOnly: srOnly,
        striped: striped,
        active: active,
        bsClass: bsClass,
        bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsStyles"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        {
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes),
          style: style,
          title: title
        },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('radio', Radio));

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('row', Row));

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(142);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, { bsSize: bsSize, bsStyle: bsStyle }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SplitButton);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(469);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { useAnchor: false, noCaret: false }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(489);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(12);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["prefix"])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["bsClass"])('table', Table));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(39);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      { eventKey: eventKey, disabled: disabled, className: tabClassName },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { role: 'tablist' }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

Object(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["bsClass"])('tab', Tabs);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);





/* eslint-disable jsx-a11y/alt-text */








var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('thumbnail', Thumbnail));

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ToggleButton__ = __webpack_require__(490);















var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};

var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_7_invariant___default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { 'data-toggle': 'buttons' }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;

var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_12__ToggleButton__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(12);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["getClassSet"])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["prefix"])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["bsClass"])('tooltip', Tooltip));

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(35);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["splitBsProps"])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["getClassSet"])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes) }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsClass"])('well', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["bsSizes"])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(12);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "bootstrapUtils", function() { return __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(31);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(39);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ValidComponentChildren", function() { return __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a"]; });







/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Header
 * @description Header Component of a list
 */
exports.Header = function (_a) {
    var children = _a.children, title = _a.title, marginTop = _a.marginTop;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-header', { 'sd-list-header--m-top': marginTop }) },
        title && react_1.default.createElement("span", { className: "sd-list-header__name" }, title),
        children));
};
exports.Header.propTypes = {
    title: prop_types_1.default.string,
    marginTop: prop_types_1.default.bool,
    children: prop_types_1.default.node,
};


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name NestedItem
 * @description Component to have two items nested
 */
exports.NestedItem = function (_a) {
    var collapsed = _a.collapsed, expanded = _a.expanded, parentItem = _a.parentItem, nestedChildren = _a.nestedChildren;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-list-item-nested', { 'sd-list-item-nested--collapsed': collapsed }, { 'sd-list-item-nested--expanded': expanded }) },
        parentItem,
        react_1.default.createElement("div", { className: "sd-list-item-nested__childs sd-shadow--z1" }, nestedChildren)));
};
exports.NestedItem.propTypes = {
    collapsed: prop_types_1.default.bool,
    expanded: prop_types_1.default.bool,
    parentItem: prop_types_1.default.element.isRequired,
    nestedChildren: prop_types_1.default.arrayOf(prop_types_1.default.node),
};
exports.NestedItem.defaultProps = {
    collapsed: true,
    expanded: false,
};


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SidePanel_1 = __webpack_require__(1128);
exports.SidePanel = SidePanel_1.SidePanel;
var Header_1 = __webpack_require__(1129);
exports.Header = Header_1.Header;
var SubHeader_1 = __webpack_require__(1130);
exports.SubHeader = SubHeader_1.SubHeader;
var Footer_1 = __webpack_require__(1131);
exports.Footer = Footer_1.Footer;
var Tools_1 = __webpack_require__(1132);
exports.Tools = Tools_1.Tools;
var Content_1 = __webpack_require__(1133);
exports.Content = Content_1.Content;
var ContentBlock_1 = __webpack_require__(1134);
exports.ContentBlock = ContentBlock_1.ContentBlock;
var ContentBlockInner_1 = __webpack_require__(1135);
exports.ContentBlockInner = ContentBlockInner_1.ContentBlockInner;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name SidePanel
 * @description SidePanel Component used usually for Advanced Search panels
 */
exports.SidePanel = function (_a) {
    var children = _a.children, shadowRight = _a.shadowRight, shadowLeft = _a.shadowLeft, transparent = _a.transparent, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel', { 'side-panel--shadow-right': shadowRight }, { 'side-panel--transparent': transparent }, { 'side-panel--shadow-left': shadowLeft }, className) }, children));
};
exports.SidePanel.propTypes = {
    children: prop_types_1.default.node,
    shadowRight: prop_types_1.default.bool,
    shadowLeft: prop_types_1.default.bool,
    transparent: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.SidePanel.defaultProps = {
    shadowRight: false,
    shadowLeft: false,
    transparent: false,
    className: '',
};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Header
 * @description Header Component of a side panel
 */
exports.Header = function (_a) {
    var children = _a.children, className = _a.className, darkBlue = _a.darkBlue, darker = _a.darker;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__header', {
            'subnav--dark-blue-grey': darkBlue,
            'subnav--darker': darker,
        }, className) }, children));
};
exports.Header.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    darkBlue: prop_types_1.default.bool,
    darker: prop_types_1.default.bool,
};
exports.Header.defaultProps = {
    darkBlue: false,
    darker: false,
};


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name SubHeader
 * @description SubHeader of a side panel
 */
exports.SubHeader = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__header', className) }, children));
};
exports.SubHeader.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
};
exports.SubHeader.defaultProps = {
    className: '',
};


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Footer
 * @description Footer Component of a side panel
 */
exports.Footer = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__footer', className) }, children));
};
exports.Footer.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
};
exports.Footer.defaultProps = {
    className: '',
};


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var __1 = __webpack_require__(23);
/**
 * @ngdoc react
 * @name Tools
 * @description Header tools of a side panel
 */
exports.Tools = function (_a) {
    var className = _a.className, tools = _a.tools, children = _a.children, topTools = _a.topTools;
    return (react_1.default.createElement("div", { className: classnames_1.default({
            'side-panel__tools': !topTools,
            'side-panel__top-tools': topTools,
        }, className) },
        tools.map(function (tool) { return (react_1.default.createElement(__1.IconButton, { key: tool.icon, icon: tool.icon, onClick: tool.onClick, "data-sd-tooltip": tool.title, "data-flow": "left" })); }),
        children));
};
exports.Tools.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    tools: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        icon: prop_types_1.default.string,
        onClick: prop_types_1.default.func,
        title: prop_types_1.default.string,
    })).isRequired,
    topTools: prop_types_1.default.bool,
};
exports.Tools.defaultProps = {
    tools: [],
    topTools: false,
};


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Content
 * @description Component to hold contents of a side panel
 */
exports.Content = function (_a) {
    var children = _a.children, className = _a.className, flex = _a.flex;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__content', { 'side-panel__content--flex': flex }, className) }, children));
};
exports.Content.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    flex: prop_types_1.default.bool,
};
exports.Content.defaultProps = {
    flex: false,
};


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name ContentBlock
 * @description Component to hold a single block of content
 */
exports.ContentBlock = function (_a) {
    var children = _a.children, className = _a.className, padSmall = _a.padSmall, flex = _a.flex;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__content-block', className, {
            'side-panel__content-block--pad-small': padSmall,
            'side-panel__content-block--flex': flex,
        }) }, children));
};
exports.ContentBlock.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    padSmall: prop_types_1.default.bool,
    flex: prop_types_1.default.bool,
};
exports.ContentBlock.defaultProps = {
    padSmall: false,
    flex: false,
};


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name ContentBlockInner
 * @description Inner Component to hold content block of a side panel
 */
exports.ContentBlockInner = function (_a) {
    var children = _a.children, className = _a.className, right = _a.right, grow = _a.grow;
    return (react_1.default.createElement("div", { className: classnames_1.default('side-panel__content-block-inner', className, {
            'side-panel__content-block-inner--right': right,
            'side-panel__content-block-inner--grow': grow,
        }) }, children));
};
exports.ContentBlockInner.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    right: prop_types_1.default.bool,
    grow: prop_types_1.default.bool,
};
exports.ContentBlockInner.defaultProps = {
    right: false,
    grow: false,
};


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Tabs
 * @description Tabs Component for a NavBar
 */
exports.Tabs = function (_a) {
    var tabs = _a.tabs, active = _a.active, setActive = _a.setActive, className = _a.className, darkUi = _a.darkUi;
    return (react_1.default.createElement("ul", { className: classnames_1.default('nav-tabs', { 'nav-tabs--ui-dark': darkUi }, className) }, tabs.map(function (tab, index) { return (!lodash_1.get(tab, 'enabled', true) ?
        null :
        react_1.default.createElement("li", { key: tab.label, className: 'nav-tabs__tab' + (active === index ? ' nav-tabs__tab--active' : '') },
            react_1.default.createElement("button", { className: "nav-tabs__link", onClick: function () { return setActive(index); } }, tab.label))); })));
};
exports.Tabs.propTypes = {
    tabs: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        enabled: prop_types_1.default.bool,
        label: prop_types_1.default.string.isRequired,
    })),
    active: prop_types_1.default.number.isRequired,
    setActive: prop_types_1.default.func.isRequired,
    className: prop_types_1.default.string,
    darkUi: prop_types_1.default.bool,
};
exports.Tabs.defaultProps = { darkUi: false };


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
__webpack_require__(1138);
/**
 * @ngdoc react
 * @name Button
 * @description Button Component for a NavBar
 */
exports.Button = function (_a) {
    var className = _a.className, onClick = _a.onClick, icon = _a.icon, tooltip = _a.tooltip, tooltipDirection = _a.tooltipDirection, children = _a.children, dropdown = _a.dropdown, textWithIcon = _a.textWithIcon, left = _a.left, darker = _a.darker, active = _a.active, props = __rest(_a, ["className", "onClick", "icon", "tooltip", "tooltipDirection", "children", "dropdown", "textWithIcon", "left", "darker", "active"]);
    return (react_1.default.createElement("button", __assign({ className: classnames_1.default('navbtn', {
            'navbtn--left': left,
            'navbtn--darker': darker,
            'navbtn--active': active,
            'navbtn--text-with-icon': textWithIcon,
            'dropdown-toggle': dropdown,
            dropdown__toggle: dropdown,
        }, className), onClick: onClick || null, "data-sd-tooltip": tooltip, "data-flow": tooltipDirection }, props),
        icon && react_1.default.createElement("i", { className: icon }),
        children));
};
exports.Button.propTypes = {
    className: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    icon: prop_types_1.default.string,
    tooltip: prop_types_1.default.string,
    tooltipDirection: prop_types_1.default.oneOf(['top', 'down', 'left', 'right']),
    children: prop_types_1.default.node,
    dropdown: prop_types_1.default.bool,
    textWithIcon: prop_types_1.default.bool,
    left: prop_types_1.default.bool,
    darker: prop_types_1.default.bool,
    active: prop_types_1.default.bool,
};
exports.Button.defaultProps = {
    tooltipDirection: 'top',
    dropdown: false,
    textWithIcon: false,
    left: false,
    darker: false,
    active: false,
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1139);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".navbtn--text-with-icon {\n  width: auto;\n  line-height: 4.8rem;\n  padding: 0 20px;\n  font-size: 1.5rem;\n  border: 0;\n  border-left: 1px solid rgba(0, 0, 0, 0.1) !important; }\n  .navbtn--text-with-icon i {\n    vertical-align: text-top !important;\n    margin-right: 0.6rem; }\n", ""]);

// exports


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubNav_1 = __webpack_require__(1141);
exports.SubNav = SubNav_1.SubNav;
var StretchBar_1 = __webpack_require__(1142);
exports.StretchBar = StretchBar_1.StretchBar;
var Dropdown_1 = __webpack_require__(1143);
exports.Dropdown = Dropdown_1.Dropdown;
var Spacer_1 = __webpack_require__(1149);
exports.Spacer = Spacer_1.Spacer;
var ButtonStack_1 = __webpack_require__(492);
exports.ButtonStack = ButtonStack_1.ButtonStack;
var Button_1 = __webpack_require__(1150);
exports.Button = Button_1.Button;
var SlidingToolBar_1 = __webpack_require__(1151);
exports.SlidingToolBar = SlidingToolBar_1.SlidingToolBar;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Subnav
 * @description Main Sub Nav component
 */
exports.SubNav = function (_a) {
    var children = _a.children, className = _a.className, darkBlue = _a.darkBlue, darker = _a.darker;
    return (react_1.default.createElement("div", { className: classnames_1.default('subnav', {
            'subnav--dark-blue-grey': darkBlue,
            'subnav--darker': darker,
        }, className) }, children));
};
exports.SubNav.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    darkBlue: prop_types_1.default.bool,
    darker: prop_types_1.default.bool,
};
exports.SubNav.defaultProps = {
    darkBlue: false,
    darker: false,
};


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name StretchBar
 * @description Stretch Bar of a Sub Nav bar
 */
exports.StretchBar = function (_a) {
    var children = _a.children, className = _a.className, right = _a.right;
    return (react_1.default.createElement("div", { className: classnames_1.default('subnav__stretch-bar', { 'subnav__stretch-bar--right': right }, className) }, children));
};
exports.StretchBar.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    right: prop_types_1.default.bool,
};
exports.StretchBar.defaultProps = {
    right: false,
};


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_bootstrap_1 = __webpack_require__(135);
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(32);
var Dropdown_1 = __webpack_require__(1144);
/**
 * @ngdoc react
 * @name Dropdown
 * @description Dropdown of a Sub Nav bar
 */
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        _this.toggle = _this.toggle.bind(_this);
        _this.close = _this.close.bind(_this);
        return _this;
    }
    Dropdown.prototype.toggle = function () {
        var _this = this;
        // change state only when click event handling is over
        this.inToggle = true;
        lodash_1.defer(function () {
            _this.setState({ open: !_this.state.open }, function () {
                if (_this.state.open) {
                    document.addEventListener('click', _this.close);
                }
                else {
                    document.removeEventListener('click', _this.close);
                }
            });
            _this.inToggle = false;
        });
    };
    Dropdown.prototype.close = function () {
        if (!this.inToggle && this.state.open) {
            this.setState({ open: false });
        }
    };
    Dropdown.prototype.componentWillUnmount = function () {
        if (this.state.open) {
            document.removeEventListener('click', this.close);
        }
    };
    Dropdown.prototype.render = function () {
        var isCreate = this.props.icon === 'icon-plus-large';
        var buttonClassName = classnames_1.default('dropdown-toggle', 'dropdown__toggle', this.props.buttonLabelClassName, {
            navbtn: this.props.navbtn,
            'sd-create-btn': isCreate,
            'navbtn--text-only': this.props.buttonLabel,
        });
        var buttonDropMenu = (react_1.default.createElement("button", { className: buttonClassName, onClick: this.props.disableSelection ? this.props.defaultAction : this.toggle },
            this.props.icon && (react_1.default.createElement("i", { className: this.props.icon })),
            this.props.buttonLabel && this.props.buttonLabel,
            this.props.buttonLabel && (react_1.default.createElement("span", { className: "dropdown__caret" })),
            isCreate && (react_1.default.createElement("span", { className: "circle" }))));
        return (react_1.default.createElement(Dropdown_1.Dropdown, { isOpen: this.state.open, alignRight: this.props.alignRight, dropUp: this.props.dropUp, className: this.props.className },
            this.props.tooltip ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "left", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "create_new_btn" }, this.props.tooltip) },
                react_1.default.createElement("span", null, buttonDropMenu))) :
                buttonDropMenu,
            react_1.default.createElement(Dropdown_1.Menu, { isOpen: this.state.open, alignRight: false, scrollable: this.props.scrollable },
                this.props.label && (react_1.default.createElement(Dropdown_1.Label, null, this.props.label)),
                this.props.label && (react_1.default.createElement(Dropdown_1.Divider, null)),
                this.props.items.map(function (item, index) {
                    if (item.divider) {
                        return react_1.default.createElement(Dropdown_1.Divider, { key: index });
                    }
                    else {
                        return (react_1.default.createElement("li", { key: index },
                            react_1.default.createElement("button", { onClick: function () { return item.action(); } },
                                item.icon && (react_1.default.createElement("i", { className: classnames_1.default({ 'icon--gray': item.disabled }, item.icon) })),
                                react_1.default.createElement("span", { className: classnames_1.default({ 'dropdown__menu-item--disabled': item.disabled }, item.className) }, utils_1.firstCharUpperCase(item.label)))));
                    }
                }))));
    };
    return Dropdown;
}(react_1.default.Component));
exports.Dropdown = Dropdown;
Dropdown.propTypes = {
    icon: prop_types_1.default.string,
    buttonLabel: prop_types_1.default.string,
    buttonLabelClassName: prop_types_1.default.string,
    label: prop_types_1.default.string,
    items: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        label: prop_types_1.default.string,
        divider: prop_types_1.default.bool,
        icon: prop_types_1.default.string,
        action: prop_types_1.default.func,
        className: prop_types_1.default.string,
        disabled: prop_types_1.default.bool,
    })),
    alignRight: prop_types_1.default.bool,
    disableSelection: prop_types_1.default.bool,
    defaultAction: prop_types_1.default.func,
    dropUp: prop_types_1.default.bool,
    navbtn: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    tooltip: prop_types_1.default.string,
    scrollable: prop_types_1.default.bool,
};
Dropdown.defaultProps = {
    alignRight: false,
    navbtn: true,
    scrollable: false,
};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Menu_1 = __webpack_require__(1145);
exports.Menu = Menu_1.Menu;
var Label_1 = __webpack_require__(1146);
exports.Label = Label_1.Label;
var Divider_1 = __webpack_require__(1147);
exports.Divider = Divider_1.Divider;
var Dropdown_1 = __webpack_require__(1148);
exports.Dropdown = Dropdown_1.Dropdown;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Menu
 * @description Menu container of dropdown component
 */
exports.Menu = function (_a) {
    var children = _a.children, className = _a.className, isOpen = _a.isOpen, alignRight = _a.alignRight, scrollable = _a.scrollable;
    return (!isOpen ? null :
        react_1.default.createElement("ul", { className: classnames_1.default('dropdown__menu', {
                'dropdown--align-right': alignRight,
                'dropdown__menu--scrollable': scrollable,
            }, className) }, children));
};
exports.Menu.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    isOpen: prop_types_1.default.bool,
    alignRight: prop_types_1.default.bool,
    scrollable: prop_types_1.default.bool,
};
exports.Menu.defaultProps = {
    isOpen: false,
    alignRight: false,
    scrollable: false,
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Label
 * @description Label styling for dropdown optins
 */
exports.Label = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("li", { className: classnames_1.default('dropdown__menu-label', className) }, children));
};
exports.Label.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
/**
 * @ngdoc react
 * @name Divider
 * @description Divider to separate options in a dropdown
 */
exports.Divider = function () { return (react_1.default.createElement("li", { className: "dropdown__menu-divider" })); };


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Dropdown
 * @description Main dropdown component
 */
exports.Dropdown = function (_a) {
    var children = _a.children, className = _a.className, isOpen = _a.isOpen, alignRight = _a.alignRight, dropUp = _a.dropUp;
    return (react_1.default.createElement("div", { className: classnames_1.default('dropdown', {
            'dropdown--align-right': alignRight,
            open: isOpen,
        }, { 'dropdown--dropup': dropUp }, className) }, children));
};
exports.Dropdown.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    isOpen: prop_types_1.default.bool,
    alignRight: prop_types_1.default.bool,
    dropUp: prop_types_1.default.bool,
};


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
/**
 * @ngdoc react
 * @name Spacer
 * @description Spacer used between divs in a Sub Nav bar
 */
exports.Spacer = function () { return (react_1.default.createElement("div", { className: "subnav__spacer subnav__spacer--dotted subnav__spacer--no-r-margin" })); };


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ButtonStack_1 = __webpack_require__(492);
/**
 * @ngdoc react
 * @name Button
 * @description Button of a Sub Nav bar
 */
exports.Button = function (_a) {
    var children = _a.children, className = _a.className, right = _a.right, buttonClassName = _a.buttonClassName, onClick = _a.onClick, padded = _a.padded;
    return (react_1.default.createElement(ButtonStack_1.ButtonStack, { right: right, padded: padded, className: className },
        react_1.default.createElement("button", { className: buttonClassName, onClick: onClick }, children)));
};
exports.Button.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    right: prop_types_1.default.bool,
    buttonClassName: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    padded: prop_types_1.default.bool,
};
exports.Button.defaultProps = {
    right: false,
    padded: false,
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var index_1 = __webpack_require__(23);
var utils_1 = __webpack_require__(3);
__webpack_require__(1152);
/**
 * @ngdoc react
 * @name SlidingToolBar
 * @description Top sliding toolbar of a Sub Nav bar
 */
exports.SlidingToolBar = function (_a) {
    var hide = _a.hide, innerInfo = _a.innerInfo, innerTools = _a.innerTools, tools = _a.tools, onCancel = _a.onCancel;
    return (react_1.default.createElement("div", { className: classnames_1.default('subnav__sliding-toolbar', { 'ng-hide': hide }) },
        react_1.default.createElement("div", { className: "sliding-toolbar__inner" },
            react_1.default.createElement(index_1.Button, { onClick: onCancel, text: utils_1.gettext('Cancel') }),
            react_1.default.createElement("span", { className: "sliding-toolbar__info-text" },
                innerInfo,
                "\u00A0"),
            react_1.default.createElement("span", { className: "sliding-toolbar__info-tools" }, innerTools)),
        tools));
};
exports.SlidingToolBar.propTypes = {
    hide: prop_types_1.default.bool,
    onCancel: prop_types_1.default.func,
    innerInfo: prop_types_1.default.string,
    innerTools: prop_types_1.default.node,
    tools: prop_types_1.default.node,
};
exports.SlidingToolBar.defaultProps = { hide: true };


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1153);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.sliding-toolbar__info-tools a {\n  cursor: pointer; }\n\n.dropdown .dropdown__menu-item--disabled {\n  color: #999; }\n", ""]);

// exports


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Row_1 = __webpack_require__(1155);
exports.Row = Row_1.Row;
var Panel_1 = __webpack_require__(1156);
exports.Panel = Panel_1.Panel;


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Row
 * @description Row Component to be used in an item preview to show an item's detail
 */
exports.Row = function (_a) {
    var label = _a.label, value = _a.value, className = _a.className, children = _a.children, noPadding = _a.noPadding, enabled = _a.enabled, flex = _a.flex, rowItem = _a.rowItem;
    return (enabled ?
        react_1.default.createElement("div", { className: classnames_1.default({
                form__row: !rowItem,
                'form__row-item': rowItem,
                'no-padding': noPadding,
                'form__row--flex': flex,
            }) },
            label && react_1.default.createElement("label", { className: "form-label form-label--light" }, label),
            value && react_1.default.createElement("p", { className: 'sd-text__' + className }, value),
            children) :
        null);
};
exports.Row.propTypes = {
    label: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
        prop_types_1.default.node,
    ]),
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    noPadding: prop_types_1.default.bool,
    enabled: prop_types_1.default.bool,
    flex: prop_types_1.default.bool,
    rowItem: prop_types_1.default.bool,
};
exports.Row.defaultProps = {
    noPadding: false,
    enabled: true,
    flex: false,
    rowItem: false,
};


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Panel
 * @description Panel Component to be used in a preview pane
 */
exports.Panel = function (_a) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-preview-panel', className) }, children));
};
exports.Panel.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
};


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __webpack_require__(1158);
exports.Box = Box_1.Box;
var MainColumn_1 = __webpack_require__(1159);
exports.MainColumn = MainColumn_1.MainColumn;
var SlideInColumn_1 = __webpack_require__(1160);
exports.SlideInColumn = SlideInColumn_1.SlideInColumn;


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name Box
 * @description UI component with column-box styling
 */
exports.Box = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "sd-column-box--2" }, children));
};
exports.Box.propTypes = { children: prop_types_1.default.node };


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name MainColumn
 * @description Main panel component of column box
 */
exports.MainColumn = function (_a) {
    var children = _a.children, padded = _a.padded;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-column-box__main-column', { 'sd-column-box__main-column--padded': padded }) }, children));
};
exports.MainColumn.propTypes = {
    children: prop_types_1.default.node,
    padded: prop_types_1.default.bool,
};


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name SlideInColumn
 * @description Vertical sliding panel component which can be used inside a column box
 */
exports.SlideInColumn = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "sd-column-box__slide-in-column" }, children));
};
exports.SlideInColumn.propTypes = { children: prop_types_1.default.node };


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Header_1 = __webpack_require__(1162);
exports.Header = Header_1.Header;
var Content_1 = __webpack_require__(1163);
exports.Content = Content_1.Content;
var Panel_1 = __webpack_require__(1164);
exports.Panel = Panel_1.Panel;
var Toolbar_1 = __webpack_require__(1165);
exports.Toolbar = Toolbar_1.Toolbar;


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name Header
 * @description Header of a slide-in panel
 */
exports.Header = function (_a) {
    var title = _a.title, tools = _a.tools, children = _a.children, onClose = _a.onClose;
    return (react_1.default.createElement("div", { className: "sd-slide-in-panel__header" },
        react_1.default.createElement("div", { className: "subnav__sliding-toolbar" },
            react_1.default.createElement("div", { className: "sliding-toolbar__inner" }),
            tools),
        react_1.default.createElement("h3", { className: "sd-slide-in-panel__heading" }, title),
        children));
};
exports.Header.propTypes = {
    title: prop_types_1.default.string,
    tools: prop_types_1.default.array,
    onClose: prop_types_1.default.func,
    children: prop_types_1.default.node,
};
exports.Header.defaultProps = { tools: [] };


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
/**
 * @ngdoc react
 * @name Content
 * @description Contents of a slide-in panel
 */
exports.Content = function (_a) {
    var children = _a.children, first = _a.first;
    return (react_1.default.createElement("div", { className: "sd-slide-in-panel__content" },
        react_1.default.createElement("div", { className: classnames_1.default('sd-slide-in-panel__content-block', { 'sd-slide-in-panel__content-block--first': first }) }, children)));
};
exports.Content.propTypes = {
    children: prop_types_1.default.node,
    first: prop_types_1.default.bool,
};
exports.Content.defaultProps = { first: true };


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name Panel
 * @description Main panel of a slide-in panel
 */
exports.Panel = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: "sd-column-box__slide-in-column-inner sd-slide-in-panel" }, children));
};
exports.Panel.propTypes = { children: prop_types_1.default.node };


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
__webpack_require__(1166);
/**
 * @ngdoc react
 * @name Toolbar
 * @description Top toolbar of a slide-in panel
 */
exports.Toolbar = function (_a) {
    var children = _a.children, className = _a.className, invalid = _a.invalid;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-slide-in-panel__header', { 'sd-slide-in-panel__header--invalid': invalid }, className) },
        react_1.default.createElement("div", { className: "subnav__sliding-toolbar" },
            react_1.default.createElement("div", { className: "sliding-toolbar__inner" }),
            children)));
};
exports.Toolbar.propTypes = {
    children: prop_types_1.default.oneOfType([
        prop_types_1.default.element,
        prop_types_1.default.arrayOf(prop_types_1.default.element),
    ]),
    className: prop_types_1.default.string,
    invalid: prop_types_1.default.bool,
};
exports.Toolbar.defaultProps = {
    children: [],
    invalid: false,
};


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1167);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".sd-slide-in-panel__header--invalid .subnav__sliding-toolbar {\n  background-color: #FEF4F4;\n  color: #E51C23; }\n  .sd-slide-in-panel__header--invalid .subnav__sliding-toolbar h3 {\n    font-weight: 500;\n    padding: 0 2rem 0 1.6rem; }\n\n.sd-slide-in-panel__footer {\n  padding: 2rem 1.6rem;\n  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12); }\n\n.btn-group--flex {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-basis: 0; }\n  .btn-group--flex .btn + .btn {\n    margin-left: 0.8rem;\n    margin-top: 0; }\n", ""]);

// exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc react
 * @name SearchBox
 * @description Search box with input to search
 */
var SearchBox = /** @class */ (function (_super) {
    __extends(SearchBox, _super);
    function SearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { inputValue: _this.props.value };
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.onKeyPressHandler = _this.onKeyPressHandler.bind(_this);
        return _this;
    }
    SearchBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.value !== nextProps.value &&
            this.props.activeFilter !== nextProps.activeFilter) {
            this.setState({ inputValue: nextProps.value });
        }
        if (this.state.inputValue !== '' && this.props.value !== '' &&
            nextProps.value === '' && this.props.activeFilter === nextProps.activeFilter) {
            this.setState({ inputValue: nextProps.value });
        }
    };
    SearchBox.prototype.onChangeHandler = function (evt) {
        this.setState({ inputValue: evt.target.value });
    };
    SearchBox.prototype.onKeyPressHandler = function (evt) {
        if (evt.charCode === constants_1.KEYCODES.ENTER) {
            this.props.search(this.state.inputValue);
        }
    };
    SearchBox.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "sd-searchbar sd-searchbar--focused" },
            react_1.default.createElement("label", { htmlFor: "search-input", className: "sd-searchbar__icon" }),
            react_1.default.createElement("input", { type: "text", id: "search-input", autoComplete: "off", className: "sd-searchbar__input", placeholder: utils_1.gettext(this.props.label), value: this.state.inputValue, onChange: this.onChangeHandler, onKeyPress: this.onKeyPressHandler }),
            react_1.default.createElement("button", { className: "sd-searchbar__search-btn", onClick: function () { return _this.props.search(_this.state.inputValue); } },
                react_1.default.createElement("i", { className: "big-icon--chevron-right" }))));
    };
    return SearchBox;
}(react_1.default.Component));
SearchBox.propTypes = {
    label: prop_types_1.default.string.isRequired,
    value: prop_types_1.default.string.isRequired,
    search: prop_types_1.default.func.isRequired,
    activeFilter: prop_types_1.default.string.isRequired,
};
exports.default = SearchBox;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
__webpack_require__(1170);
/**
 * @ngdoc react
 * @name DateTime
 * @description DateTime component to display text formatted date and time
 */
var DateTime = function (_a) {
    var date = _a.date, withTime = _a.withTime, withDate = _a.withDate, withYear = _a.withYear, dateFormat = _a.dateFormat, timeFormat = _a.timeFormat, padLeft = _a.padLeft;
    var format = withYear ? dateFormat : dateFormat.replace(/y/gi, '');
    var dateTimeFormat = [
        withDate ? format : null,
        withTime ? timeFormat : null,
    ].filter(function (d) { return d; }).join('\u00a0'); // &nbsp;
    return react_1.default.createElement("time", { className: !padLeft ? 'Datetime' : null, title: date.toString() }, moment_1.default(date).format(dateTimeFormat));
};
DateTime.defaultProps = {
    withTime: true,
    withDate: true,
    withYear: true,
    padLeft: false,
};
DateTime.propTypes = {
    date: prop_types_1.default.oneOfType([
        prop_types_1.default.object,
        prop_types_1.default.string,
    ]).isRequired,
    withTime: prop_types_1.default.bool,
    withYear: prop_types_1.default.bool,
    withDate: prop_types_1.default.bool,
    dateFormat: prop_types_1.default.string.isRequired,
    timeFormat: prop_types_1.default.string.isRequired,
    padLeft: prop_types_1.default.bool,
};
exports.default = DateTime;


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1171);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\ntime.Datetime {\n  padding-left: 0; }\n\n.link {\n  cursor: pointer !important; }\n\n.no-padding {\n  padding: 0 !important; }\n\n.sd-line-input--no-border-bottom .sd-line-input__input {\n  border-bottom: none !important; }\n\n.sd-line-input--is-select {\n  cursor: pointer !important; }\n\n.sd-list-item--margin {\n  margin: 0.8rem; }\n\n.sd-list-item-group--vertical-scroll {\n  overflow-y: auto; }\n\n.terms-list--disabled li {\n  cursor: not-allowed !important; }\n  .terms-list--disabled li:hover {\n    color: #000;\n    background-color: rgba(0, 0, 0, 0.05); }\n\n.sd-list-item__row--padding-b5 {\n  padding-bottom: 5px !important; }\n\n.sd-collapse-box--invalid .sd-collapse-box__header {\n  border: 1px solid #E51C23; }\n\n.sd-collapse-box--autoFocus:focus, .sd-collapse-box:focus {\n  background-color: #f4f4f4; }\n\n.sd-collapse-box__content-wrapper--no-max-height, .sd-collapse-box__content-wraper {\n  max-height: initial !important; }\n\n.sd-list-item:focus-within .sd-list-item__action-menu {\n  padding: 0 0.6rem;\n  width: auto;\n  overflow: visible;\n  opacity: 1; }\n", ""]);

// exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc react
 * @name PanelInfo
 * @description Information displayed in the middle of a panel
 */
var PanelInfo = function (_a) {
    var heading = _a.heading, description = _a.description;
    return (react_1.default.createElement("div", { className: "panel-info" },
        react_1.default.createElement("div", { className: "panel-info__icon" },
            react_1.default.createElement("i", { className: "big-icon--comments" })),
        heading &&
            react_1.default.createElement("h3", { className: "panel-info__heading" }, heading),
        description &&
            react_1.default.createElement("p", { className: "panel-info__description" }, description)));
};
PanelInfo.propTypes = {
    heading: prop_types_1.default.string,
    description: prop_types_1.default.string,
};
exports.default = PanelInfo;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
var _1 = __webpack_require__(23);
/**
 * @ngdoc react
 * @name CollapseBox
 * @description CollapseBox which has a closed and open view of an item
 */
var CollapseBox = /** @class */ (function (_super) {
    __extends(CollapseBox, _super);
    function CollapseBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isOpen: _this.props.isOpen };
        _this.scrollInView = _this.scrollInView.bind(_this);
        _this.handleOpenClick = _this.handleOpenClick.bind(_this);
        _this.openBox = _this.openBox.bind(_this);
        _this.closeBox = _this.closeBox.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.dom = { node: null };
        return _this;
    }
    CollapseBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.onOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    };
    CollapseBox.prototype.handleKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ENTER) {
            utils_1.onEventCapture(event);
            // If we closed it by keydown, keep focus to show the tab route
            if (this.state.isOpen) {
                this.closeBox();
                this.dom.node.focus();
            }
            else {
                this.openBox();
            }
        }
    };
    CollapseBox.prototype.openBox = function () {
        if (this.props.noOpen || this.state.isOpen) {
            return;
        }
        this.setState({ isOpen: true });
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    };
    CollapseBox.prototype.closeBox = function () {
        if (this.state.isOpen) {
            this.setState({ isOpen: false });
            if (this.props.onClose) {
                this.props.onClose();
            }
        }
    };
    CollapseBox.prototype.handleOpenClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
        this.openBox();
    };
    CollapseBox.prototype.scrollInView = function () {
        if (this.props.scrollInView &&
            (this.state.isOpen || this.props.noOpen) &&
            this.dom.node) {
            this.dom.node.scrollIntoView();
            // When just opened, lose focus to remove greyed background due to
            // initial collapsed view
            this.dom.node.blur();
        }
    };
    CollapseBox.prototype.componentDidMount = function () {
        // Upon first rendering, if the box is open then scroll it into view
        this.scrollInView();
    };
    CollapseBox.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Scroll into view only upon first opening
        if (prevState.isOpen !== this.state.isOpen ||
            (this.props.forceScroll && this.props.forceScroll !== prevProps.forceScroll)) {
            this.scrollInView();
        }
    };
    CollapseBox.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { role: "button", tabIndex: this.props.tabEnabled ? 0 : null, onKeyDown: !this.state.isOpen && this.props.tabEnabled ? this.handleKeyDown : null, className: classnames_1.default('sd-collapse-box', 'sd-shadow--z2', {
                'sd-collapse-box--open': this.state.isOpen,
                'sd-collapse-box--invalid': this.props.invalid,
            }), ref: function (node) { return _this.dom.node = node; }, onClick: this.handleOpenClick }, this.state.isOpen && (react_1.default.createElement("div", { className: "sd-collapse-box__content-wraper" },
            react_1.default.createElement("div", { className: "sd-collapse-box__content" },
                react_1.default.createElement("div", { className: "sd-collapse-box__tools" },
                    this.props.tools,
                    react_1.default.createElement(_1.IconButton, { icon: "icon-chevron-up-thin", tabIndex: this.props.tabEnabled ? 0 : null, onClick: this.closeBox, onKeyDown: this.props.tabEnabled ? this.handleKeyDown : null })),
                this.props.openItemTopBar &&
                    react_1.default.createElement("div", { className: "sd-collapse-box__content-block sd-collapse-box__content-block--top" }, this.props.openItemTopBar),
                this.props.openItem))) || (react_1.default.createElement("div", { className: "sd-collapse-box__header" }, this.props.collapsedItem))));
    };
    return CollapseBox;
}(react_1.default.Component));
exports.CollapseBox = CollapseBox;
CollapseBox.propTypes = {
    collapsedItem: prop_types_1.default.node.isRequired,
    openItem: prop_types_1.default.node.isRequired,
    openItemTopBar: prop_types_1.default.node,
    tools: prop_types_1.default.node,
    isOpen: prop_types_1.default.bool,
    scrollInView: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    tabEnabled: prop_types_1.default.bool,
    noOpen: prop_types_1.default.bool,
    onOpen: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    forceScroll: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
CollapseBox.defaultProps = {
    isOpen: false,
    scrollInView: false,
    invalid: false,
};


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc react
 * @name TermsList
 * @description Displays a list of terms: subject, categories
 */
var TermsList = function (_a) {
    var terms = _a.terms, displayField = _a.displayField, onClick = _a.onClick, readOnly = _a.readOnly;
    return (react_1.default.createElement("div", { className: classnames_1.default('terms-list', { 'terms-list--disabled': readOnly }) },
        react_1.default.createElement("ul", null, terms.map(function (term, index) { return (react_1.default.createElement("li", { key: index, onClick: (!readOnly && onClick) ? onClick.bind(null, index) : null },
            (!readOnly && onClick) && react_1.default.createElement("i", { className: "icon-close-small" }),
            lodash_1.get(term, displayField) || term)); }))));
};
TermsList.propTypes = {
    terms: prop_types_1.default.array.isRequired,
    displayField: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
};
TermsList.defaultProps = { readOnly: false };
exports.default = TermsList;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_debounce_input_1 = __webpack_require__(223);
var lodash_1 = __webpack_require__(2);
__webpack_require__(1178);
/**
 * @ngdoc react
 * @name SearchBar
 * @description Component to search by debounced input to fetch results from backend
 */
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            // initialize state from props
            searchBarExtended: !lodash_1.isNil(_this.props.value),
            searchInputValue: _this.props.value || '',
            uniqueId: lodash_1.uniqueId('SearchBar'),
        };
        _this.dom = { searchIcon: null };
        _this.toggleSearchBar = _this.toggleSearchBar.bind(_this);
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        _this.resetSearch = _this.resetSearch.bind(_this);
        return _this;
    }
    SearchBar.prototype.componentDidMount = function () {
        // Doing this to focus the input field
        // Sometimes, user doesn't want to click on the search icon to input search text
        if (this.props.extendOnOpen) {
            this.dom.searchIcon.click();
            this.dom.searchIcon.focus();
        }
    };
    SearchBar.prototype.toggleSearchBar = function () {
        if (this.props.allowCollapsed === false) {
            return;
        }
        this.setState({ searchBarExtended: !this.state.searchBarExtended });
    };
    /** Reset the field value, close the search bar and load events */
    SearchBar.prototype.resetSearch = function () {
        this.setState({
            searchBarExtended: false,
            searchInputValue: '',
        });
        this.props.onSearch();
    };
    /** Search events by keywords */
    SearchBar.prototype.onSearchChange = function (event) {
        var _this = this;
        var value = event.target.value;
        this.setState({ searchInputValue: value || '' }, 
        // update the input value since we are using the DebounceInput `value` prop
        function () { return _this.props.onSearch(value); });
    };
    SearchBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, timeout = _a.timeout, allowCollapsed = _a.allowCollapsed;
        var searchBarExtended = this.state.searchBarExtended;
        var _uniqueId = this.state.uniqueId;
        var minLength = this.props.minLength ? this.props.minLength : 2;
        return (react_1.default.createElement("div", { className: 'SearchBar flat-searchbar' + (searchBarExtended ? ' extended' : '') },
            react_1.default.createElement("div", { className: "search-handler" },
                react_1.default.createElement("label", { htmlFor: _uniqueId, className: "trigger-icon", onClick: this.toggleSearchBar, ref: function (node) { return _this.dom.searchIcon = node; } },
                    react_1.default.createElement("i", { className: "icon-search" })),
                react_1.default.createElement(react_debounce_input_1.DebounceInput, { minLength: minLength, debounceTimeout: timeout, value: this.state.searchInputValue, onChange: this.onSearchChange, id: _uniqueId, placeholder: "Search", type: "text" }),
                allowCollapsed && (react_1.default.createElement("button", { type: "button", className: "search-close visible", onClick: this.resetSearch },
                    react_1.default.createElement("i", { className: "icon-remove-sign" }))))));
    };
    return SearchBar;
}(react_1.default.Component));
exports.default = SearchBar;
SearchBar.propTypes = {
    onSearch: prop_types_1.default.func.isRequired,
    value: prop_types_1.default.string,
    minLength: prop_types_1.default.number,
    extendOnOpen: prop_types_1.default.bool,
    timeout: prop_types_1.default.number,
    allowCollapsed: prop_types_1.default.bool,
};
SearchBar.defaultProps = {
    timeout: 800,
    allowCollapsed: true,
};


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebounceInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(1177);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DebounceInput = exports.DebounceInput = function (_React$PureComponent) {
  _inherits(DebounceInput, _React$PureComponent);

  function DebounceInput(props) {
    _classCallCheck(this, DebounceInput);

    var _this = _possibleConstructorReturn(this, (DebounceInput.__proto__ || Object.getPrototypeOf(DebounceInput)).call(this, props));

    _this.onChange = function (event) {
      event.persist();

      var oldValue = _this.state.value;

      _this.setState({ value: event.target.value }, function () {
        var value = _this.state.value;


        if (value.length >= _this.props.minLength) {
          _this.notify(event);
          return;
        }

        // If user hits backspace and goes below minLength consider it cleaning the value
        if (oldValue.length > value.length) {
          _this.notify(_extends({}, event, { target: _extends({}, event.target, { value: '' }) }));
        }
      });
    };

    _this.onKeyDown = function (event) {
      var onKeyDown = _this.props.onKeyDown;


      if (event.key === 'Enter') {
        _this.forceNotify(event);
      }
      // Invoke original onKeyDown if present
      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    _this.onBlur = function (event) {
      var onBlur = _this.props.onBlur;


      _this.forceNotify(event);
      // Invoke original onBlur if present
      if (onBlur) {
        onBlur(event);
      }
    };

    _this.createNotifier = function (debounceTimeout) {
      if (debounceTimeout < 0) {
        _this.notify = function () {
          return null;
        };
      } else if (debounceTimeout === 0) {
        _this.notify = _this.doNotify;
      } else {
        var debouncedChangeFunc = (0, _lodash2.default)(function (event) {
          _this.isDebouncing = false;
          _this.doNotify(event);
        }, debounceTimeout);

        _this.notify = function (event) {
          _this.isDebouncing = true;
          debouncedChangeFunc(event);
        };

        _this.flush = function () {
          return debouncedChangeFunc.flush();
        };

        _this.cancel = function () {
          _this.isDebouncing = false;
          debouncedChangeFunc.cancel();
        };
      }
    };

    _this.doNotify = function () {
      var onChange = _this.props.onChange;


      onChange.apply(undefined, arguments);
    };

    _this.forceNotify = function (event) {
      if (!_this.isDebouncing) {
        return;
      }

      if (_this.cancel) {
        _this.cancel();
      }

      var value = _this.state.value;
      var minLength = _this.props.minLength;


      if (value.length >= minLength) {
        _this.doNotify(event);
      } else {
        _this.doNotify(_extends({}, event, { target: _extends({}, event.target, { value: value }) }));
      }
    };

    _this.state = {
      value: props.value || ''
    };

    _this.isDebouncing = false;
    return _this;
  }

  _createClass(DebounceInput, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.createNotifier(this.props.debounceTimeout);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value,
          debounceTimeout = _ref.debounceTimeout;

      if (this.isDebouncing) {
        return;
      }
      if (typeof value !== 'undefined' && this.state.value !== value) {
        this.setState({ value: value });
      }
      if (debounceTimeout !== this.props.debounceTimeout) {
        this.createNotifier(debounceTimeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.flush) {
        this.flush();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          element = _props.element,
          _onChange = _props.onChange,
          _value = _props.value,
          _minLength = _props.minLength,
          _debounceTimeout = _props.debounceTimeout,
          forceNotifyByEnter = _props.forceNotifyByEnter,
          forceNotifyOnBlur = _props.forceNotifyOnBlur,
          onKeyDown = _props.onKeyDown,
          onBlur = _props.onBlur,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['element', 'onChange', 'value', 'minLength', 'debounceTimeout', 'forceNotifyByEnter', 'forceNotifyOnBlur', 'onKeyDown', 'onBlur', 'inputRef']);

      var maybeOnKeyDown = void 0;
      if (forceNotifyByEnter) {
        maybeOnKeyDown = { onKeyDown: this.onKeyDown };
      } else if (onKeyDown) {
        maybeOnKeyDown = { onKeyDown: onKeyDown };
      } else {
        maybeOnKeyDown = {};
      }

      var maybeOnBlur = void 0;
      if (forceNotifyOnBlur) {
        maybeOnBlur = { onBlur: this.onBlur };
      } else if (onBlur) {
        maybeOnBlur = { onBlur: onBlur };
      } else {
        maybeOnBlur = {};
      }

      var maybeRef = inputRef ? { ref: inputRef } : {};

      return _react2.default.createElement(element, _extends({}, props, {
        onChange: this.onChange,
        value: this.state.value
      }, maybeOnKeyDown, maybeOnBlur, maybeRef));
    }
  }]);

  return DebounceInput;
}(_react2.default.PureComponent);

DebounceInput.defaultProps = {
  element: 'input',
  type: 'text',
  onKeyDown: undefined,
  onBlur: undefined,
  value: undefined,
  minLength: 0,
  debounceTimeout: 100,
  forceNotifyByEnter: true,
  forceNotifyOnBlur: true,
  inputRef: undefined
};

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1179);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".SearchBar.extended .search-handler {\n  display: flex;\n  height: 47px;\n  border-left: 1px solid #e0e0e0; }\n  .SearchBar.extended .search-handler input {\n    flex-grow: 1; }\n  .SearchBar.extended .search-handler .search-close {\n    opacity: .4; }\n    .SearchBar.extended .search-handler .search-close:hover {\n      opacity: .8; }\n\n.flat-searchbar .search-handler {\n  height: 47px !important; }\n", ""]);

// exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var utils_1 = __webpack_require__(32);
var constants_1 = __webpack_require__(28);
var utils_2 = __webpack_require__(3);
__webpack_require__(1181);
/**
 * @ngdoc react
 * @name ToggleBox
 * @description ToggleBox used to open/close a set of details
 */
var ToggleBox = /** @class */ (function (_super) {
    __extends(ToggleBox, _super);
    function ToggleBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isOpen: _this.props.isOpen };
        _this.scrollInView = _this.scrollInView.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.dom = { node: null };
        return _this;
    }
    ToggleBox.prototype.handleKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.RIGHT && !this.state.isOpen) {
            utils_1.onEventCapture(event);
            this.setState({ isOpen: true });
        }
        else if (event.keyCode === constants_1.KEYCODES.LEFT && this.state.isOpen) {
            utils_1.onEventCapture(event);
            this.setState({ isOpen: false });
        }
    };
    ToggleBox.prototype.toggle = function () {
        this.setState({ isOpen: !this.state.isOpen });
        if (this.state.isOpen && this.props.onClose) {
            this.props.onClose();
        }
        else if (this.props.onOpen) {
            this.props.onOpen();
        }
    };
    ToggleBox.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isOpen !== nextProps.isOpen) {
            this.setState({ isOpen: nextProps.isOpen });
        }
    };
    ToggleBox.prototype.scrollInView = function () {
        if (this.state.isOpen && this.dom.node) {
            this.dom.node.scrollIntoView();
        }
    };
    ToggleBox.prototype.componentDidUpdate = function (prevProps, prevState) {
        if ((prevState.isOpen !== this.state.isOpen && this.props.scrollInView) ||
            this.props.forceScroll && this.props.forceScroll !== prevProps.forceScroll) {
            this.scrollInView();
        }
    };
    ToggleBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, title = _a.title, children = _a.children, hideUsingCSS = _a.hideUsingCSS, invalid = _a.invalid, noMargin = _a.noMargin, paddingTop = _a.paddingTop;
        return (react_1.default.createElement("div", { className: classnames_1.default('toggle-box toggle-box--circle', style, {
                hidden: !this.state.isOpen,
                'toggle-box--invalid': invalid,
                'toggle-box--no-margin': noMargin,
                'toggle-box--padding-top': paddingTop,
            }), ref: function (node) { return _this.dom.node = node; } },
            react_1.default.createElement("a", { className: "toggle-box__header", onClick: this.toggle, role: "button", tabIndex: 0, onKeyDown: this.handleKeyDown },
                react_1.default.createElement("div", { className: "toggle-box__chevron" },
                    react_1.default.createElement("i", { className: "icon-chevron-right-thin" })),
                react_1.default.createElement("div", { className: "toggle-box__label" }, utils_2.gettext(title)),
                react_1.default.createElement("div", { className: "toggle-box__line" })),
            react_1.default.createElement("div", { className: "toggle-box__content-wraper" },
                this.state.isOpen && !hideUsingCSS && (react_1.default.createElement("div", { className: "toggle-box__content" }, children)),
                hideUsingCSS && (react_1.default.createElement("div", { className: classnames_1.default('toggle-box__content', { 'toggle-box__content--hidden': !this.state.isOpen }) }, children)))));
    };
    return ToggleBox;
}(react_1.default.Component));
exports.ToggleBox = ToggleBox;
ToggleBox.propTypes = {
    style: prop_types_1.default.string,
    isOpen: prop_types_1.default.bool,
    onOpen: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    refNode: prop_types_1.default.func,
    title: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node,
    scrollInView: prop_types_1.default.bool,
    hideUsingCSS: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    forceScroll: prop_types_1.default.bool,
    paddingTop: prop_types_1.default.bool,
};
ToggleBox.defaultProps = {
    isOpen: true,
    scrollInView: false,
    hideUsingCSS: false,
    invalid: false,
    noMargin: false,
};


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1182);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.toggle-box .toggle-box__header--focus:focus, .toggle-box .toggle-box__header:focus {\n  background: #eff7fa; }\n\n.toggle-box__content--hidden {\n  display: none; }\n\n.toggle-box--invalid .toggle-box__chevron {\n  background-color: #E51C23; }\n\n.toggle-box--invalid .toggle-box__label {\n  color: #E51C23; }\n\n.toggle-box--invalid .toggle-box__line {\n  background-color: #E51C23; }\n\n.toggle-box--no-margin {\n  margin: 0 !important; }\n\n.toggle-box--padding-top {\n  padding-top: 25px; }\n", ""]);

// exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
__webpack_require__(1184);
/**
 * @ngdoc react
 * @name Toggle
 * @description Toggle component used to togle check/uncheck status
 */
var Toggle = function (_a) {
    var value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly, onFocus = _a.onFocus, className = _a.className;
    var handleKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ENTER) {
            utils_1.onEventCapture(event);
            onChange({ target: { value: !value } });
        }
    };
    var onClick = function () { return onChange({ target: { value: !value } }); };
    var classes = classnames_1.default('sd-toggle', 'sd-line-input__input', {
        checked: value,
        disabled: readOnly,
        'sd-toggle--checked': value,
        'sd-toggle--disabled': readOnly,
    }, className);
    return (react_1.default.createElement("button", { type: "button", tabIndex: 0, className: classes, onClick: !readOnly && onChange ? onClick : null, onFocus: onFocus, onKeyDown: !readOnly ? handleKeyDown : null },
        react_1.default.createElement("span", { className: "inner" })));
};
Toggle.propTypes = {
    value: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
Toggle.defaultProps = {
    value: false,
    readOnly: false,
};
exports.default = Toggle;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1185);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".red--100 {\n  background-color: #fee6e4; }\n\n.red--900 {\n  background-color: #6c0d06; }\n\n.red--200 {\n  background-color: #fbbdb9; }\n\n.red--800 {\n  background-color: #981208; }\n\n.red--300 {\n  background-color: #f9948d; }\n\n.red--700 {\n  background-color: #c4170b; }\n\n.red--400 {\n  background-color: #f66c62; }\n\n.red--600 {\n  background-color: #ef1d0d; }\n\n.red--50 {\n  background-color: #fef2f1; }\n\n.red--500 {\n  background-color: #F44336; }\n\n.pink--100 {\n  background-color: #f9c5d7; }\n\n.pink--900 {\n  background-color: #48071d; }\n\n.pink--200 {\n  background-color: #f59bba; }\n\n.pink--800 {\n  background-color: #720b2e; }\n\n.pink--300 {\n  background-color: #f1729d; }\n\n.pink--700 {\n  background-color: #9c0f3f; }\n\n.pink--400 {\n  background-color: #ed4880; }\n\n.pink--600 {\n  background-color: #c61350; }\n\n.pink--50 {\n  background-color: #fbd2e0; }\n\n.pink--500 {\n  background-color: #E91E63; }\n\n.purple--100 {\n  background-color: #e0a4eb; }\n\n.purple--900 {\n  background-color: #17061a; }\n\n.purple--200 {\n  background-color: #d47ee2; }\n\n.purple--800 {\n  background-color: #380e3f; }\n\n.purple--300 {\n  background-color: #c759da; }\n\n.purple--700 {\n  background-color: #591665; }\n\n.purple--400 {\n  background-color: #bb33d2; }\n\n.purple--600 {\n  background-color: #7b1f8a; }\n\n.purple--50 {\n  background-color: #e4afed; }\n\n.purple--500 {\n  background-color: #9C27B0; }\n\n.deep-purple--100 {\n  background-color: #cebeea; }\n\n.deep-purple--900 {\n  background-color: #190e2c; }\n\n.deep-purple--200 {\n  background-color: #b49bdf; }\n\n.deep-purple--800 {\n  background-color: #2c194e; }\n\n.deep-purple--300 {\n  background-color: #9a78d4; }\n\n.deep-purple--700 {\n  background-color: #402471; }\n\n.deep-purple--400 {\n  background-color: #7f56c9; }\n\n.deep-purple--600 {\n  background-color: #532f94; }\n\n.deep-purple--50 {\n  background-color: #d6c9ee; }\n\n.deep-purple--500 {\n  background-color: #673AB7; }\n\n.indigo--100 {\n  background-color: #c2c8ea; }\n\n.indigo--900 {\n  background-color: #10142d; }\n\n.indigo--200 {\n  background-color: #a0a9de; }\n\n.indigo--800 {\n  background-color: #1b234f; }\n\n.indigo--300 {\n  background-color: #7e8bd2; }\n\n.indigo--700 {\n  background-color: #273371; }\n\n.indigo--400 {\n  background-color: #5c6cc6; }\n\n.indigo--600 {\n  background-color: #334293; }\n\n.indigo--50 {\n  background-color: #ccd1ed; }\n\n.indigo--500 {\n  background-color: #3F51B5; }\n\n.blue--100 {\n  background-color: #cfe8fc; }\n\n.blue--900 {\n  background-color: #053358; }\n\n.blue--200 {\n  background-color: #a4d4fa; }\n\n.blue--800 {\n  background-color: #074c83; }\n\n.blue--300 {\n  background-color: #78bff8; }\n\n.blue--700 {\n  background-color: #0966af; }\n\n.blue--400 {\n  background-color: #4dabf5; }\n\n.blue--600 {\n  background-color: #0c7fda; }\n\n.blue--50 {\n  background-color: #dceffd; }\n\n.blue--500 {\n  background-color: #2196F3; }\n\n.light-blue--100 {\n  background-color: #b1e6fe; }\n\n.light-blue--900 {\n  background-color: #012b3f; }\n\n.light-blue--200 {\n  background-color: #83d7fd; }\n\n.light-blue--800 {\n  background-color: #014b6c; }\n\n.light-blue--300 {\n  background-color: #56c9fd; }\n\n.light-blue--700 {\n  background-color: #026a99; }\n\n.light-blue--400 {\n  background-color: #29bafc; }\n\n.light-blue--600 {\n  background-color: #028ac7; }\n\n.light-blue--50 {\n  background-color: #beeafe; }\n\n.light-blue--500 {\n  background-color: #03A9F4; }\n\n.cyan--100 {\n  background-color: #8df2ff; }\n\n.cyan--900 {\n  background-color: #00191c; }\n\n.cyan--200 {\n  background-color: #5fedff; }\n\n.cyan--800 {\n  background-color: #00424a; }\n\n.cyan--300 {\n  background-color: #31e8ff; }\n\n.cyan--700 {\n  background-color: #006b78; }\n\n.cyan--400 {\n  background-color: #03e2ff; }\n\n.cyan--600 {\n  background-color: #0093a6; }\n\n.cyan--50 {\n  background-color: #9af4ff; }\n\n.cyan--500 {\n  background-color: #00BCD4; }\n\n.teal--100 {\n  background-color: #4fffef; }\n\n.teal--900 {\n  background-color: black; }\n\n.teal--200 {\n  background-color: #21ffea; }\n\n.teal--800 {\n  background-color: #000c0b; }\n\n.teal--300 {\n  background-color: #00f2db; }\n\n.teal--700 {\n  background-color: #003a35; }\n\n.teal--400 {\n  background-color: #00c4b2; }\n\n.teal--600 {\n  background-color: #00685e; }\n\n.teal--50 {\n  background-color: #5cfff0; }\n\n.teal--500 {\n  background-color: #009688; }\n\n.green--100 {\n  background-color: #cae8cc; }\n\n.green--900 {\n  background-color: #142f15; }\n\n.green--200 {\n  background-color: #aadaac; }\n\n.green--800 {\n  background-color: #224f24; }\n\n.green--300 {\n  background-color: #8acc8d; }\n\n.green--700 {\n  background-color: #306f33; }\n\n.green--400 {\n  background-color: #6abe6e; }\n\n.green--600 {\n  background-color: #3e8f41; }\n\n.green--50 {\n  background-color: #d4ecd5; }\n\n.green--500 {\n  background-color: #4CAF50; }\n\n.light-green--100 {\n  background-color: #e3f1d4; }\n\n.light-green--900 {\n  background-color: #2c4015; }\n\n.light-green--200 {\n  background-color: #cde5b1; }\n\n.light-green--800 {\n  background-color: #446321; }\n\n.light-green--300 {\n  background-color: #b7da8f; }\n\n.light-green--700 {\n  background-color: #5c852c; }\n\n.light-green--400 {\n  background-color: #a1ce6c; }\n\n.light-green--600 {\n  background-color: #74a838; }\n\n.light-green--50 {\n  background-color: #eaf4de; }\n\n.light-green--500 {\n  background-color: #8BC34A; }\n\n.lime--100 {\n  background-color: #f4f8d5; }\n\n.lime--900 {\n  background-color: #494f0e; }\n\n.lime--200 {\n  background-color: #ebf1ae; }\n\n.lime--800 {\n  background-color: #6d7615; }\n\n.lime--300 {\n  background-color: #e1ea87; }\n\n.lime--700 {\n  background-color: #919d1c; }\n\n.lime--400 {\n  background-color: #d7e360; }\n\n.lime--600 {\n  background-color: #b6c423; }\n\n.lime--50 {\n  background-color: #f7fae1; }\n\n.lime--500 {\n  background-color: #CDDC39; }\n\n.yellow--100 {\n  background-color: #fffef3; }\n\n.yellow--900 {\n  background-color: #827500; }\n\n.yellow--200 {\n  background-color: #fff9c5; }\n\n.yellow--800 {\n  background-color: #b09e00; }\n\n.yellow--300 {\n  background-color: #fff497; }\n\n.yellow--700 {\n  background-color: #dec800; }\n\n.yellow--400 {\n  background-color: #fff069; }\n\n.yellow--600 {\n  background-color: #ffe60d; }\n\n.yellow--50 {\n  background-color: white; }\n\n.yellow--500 {\n  background-color: #FFEB3B; }\n\n.amber--100 {\n  background-color: #ffefbf; }\n\n.amber--900 {\n  background-color: #4e3b00; }\n\n.amber--200 {\n  background-color: #ffe391; }\n\n.amber--800 {\n  background-color: #7c5d00; }\n\n.amber--300 {\n  background-color: #ffd863; }\n\n.amber--700 {\n  background-color: #aa8000; }\n\n.amber--400 {\n  background-color: #ffcc35; }\n\n.amber--600 {\n  background-color: #d8a200; }\n\n.amber--50 {\n  background-color: #fff2cc; }\n\n.amber--500 {\n  background-color: #FFC107; }\n\n.orange--100 {\n  background-color: #ffe2b8; }\n\n.orange--900 {\n  background-color: #472b00; }\n\n.orange--200 {\n  background-color: #ffd08a; }\n\n.orange--800 {\n  background-color: #754600; }\n\n.orange--300 {\n  background-color: #ffbd5c; }\n\n.orange--700 {\n  background-color: #a36100; }\n\n.orange--400 {\n  background-color: #ffab2e; }\n\n.orange--600 {\n  background-color: #d17d00; }\n\n.orange--50 {\n  background-color: #ffe8c5; }\n\n.orange--500 {\n  background-color: #FF9800; }\n\n.deep-orange--100 {\n  background-color: #ffe3da; }\n\n.deep-orange--900 {\n  background-color: #691900; }\n\n.deep-orange--200 {\n  background-color: #ffc0ac; }\n\n.deep-orange--800 {\n  background-color: #972400; }\n\n.deep-orange--300 {\n  background-color: #ff9d7e; }\n\n.deep-orange--700 {\n  background-color: #c52f00; }\n\n.deep-orange--400 {\n  background-color: #ff7a50; }\n\n.deep-orange--600 {\n  background-color: #f33a00; }\n\n.deep-orange--50 {\n  background-color: #ffede7; }\n\n.deep-orange--500 {\n  background-color: #FF5722; }\n\n.brown--100 {\n  background-color: #cdb4ab; }\n\n.brown--900 {\n  background-color: #060404; }\n\n.brown--200 {\n  background-color: #bc9b8f; }\n\n.brown--800 {\n  background-color: #231815; }\n\n.brown--300 {\n  background-color: #ab8172; }\n\n.brown--700 {\n  background-color: #3f2d26; }\n\n.brown--400 {\n  background-color: #966959; }\n\n.brown--600 {\n  background-color: #5c4137; }\n\n.brown--50 {\n  background-color: #d2bcb4; }\n\n.brown--500 {\n  background-color: #795548; }\n\n.grey--100 {\n  background-color: #fafafa; }\n\n.grey--900 {\n  background-color: #424242; }\n\n.grey--200 {\n  background-color: #e3e3e3; }\n\n.grey--800 {\n  background-color: #595959; }\n\n.grey--300 {\n  background-color: #cccccc; }\n\n.grey--700 {\n  background-color: #707070; }\n\n.grey--400 {\n  background-color: #b5b5b5; }\n\n.grey--600 {\n  background-color: #878787; }\n\n.grey--50 {\n  background-color: white; }\n\n.grey--500 {\n  background-color: #9E9E9E; }\n\n.blue-grey--100 {\n  background-color: #c9d4da; }\n\n.blue-grey--900 {\n  background-color: #151b1e; }\n\n.blue-grey--200 {\n  background-color: #aebfc7; }\n\n.blue-grey--800 {\n  background-color: #28343a; }\n\n.blue-grey--300 {\n  background-color: #93a9b4; }\n\n.blue-grey--700 {\n  background-color: #3a4c55; }\n\n.blue-grey--400 {\n  background-color: #7794a1; }\n\n.blue-grey--600 {\n  background-color: #4d6570; }\n\n.blue-grey--50 {\n  background-color: #d1dbdf; }\n\n.blue-grey--500 {\n  background-color: #607D8B; }\n\n.sd-toggle--disabled {\n  cursor: not-allowed; }\n\n.sd-toggle--checked {\n  background: #b0b0b0; }\n\n.sd-toggle:focus {\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  -ms-border-radius: 3px;\n  border-radius: 3px;\n  box-sizing: border-box; }\n", ""]);

// exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_debounce_input_1 = __webpack_require__(223);
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
/**
 * @ngdoc react
 * @name SearchField
 * @description Input Field Component with search capabiities
 */
var SearchField = /** @class */ (function (_super) {
    __extends(SearchField, _super);
    function SearchField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            // initialize state from props
            searchInputValue: _this.props.value || '',
            uniqueId: lodash_1.uniqueId('SearchField'),
        };
        return _this;
    }
    /** Reset the field value, close the search bar and load events */
    SearchField.prototype.resetSearch = function () {
        this.setState({
            searchInputValue: '',
        });
        this.props.onSearch();
    };
    /** Search events by keywords */
    SearchField.prototype.onSearchChange = function (event) {
        var _this = this;
        var value = event.target.value;
        this.setState({ searchInputValue: value || '' }, 
        // update the input value since we are using the DebounceInput `value` prop
        function () { return _this.props.onSearch(value); });
    };
    SearchField.prototype.onSearchClick = function () {
        var _this = this;
        this.setState(function () { return _this.props.onSearchClick(); });
    };
    SearchField.prototype.render = function () {
        var _this = this;
        var _uniqueId = this.state.uniqueId;
        var minLength = this.props.minLength ? this.props.minLength : 2;
        return (react_1.default.createElement(react_debounce_input_1.DebounceInput, { minLength: minLength, debounceTimeout: 800, value: this.state.searchInputValue, onChange: this.onSearchChange.bind(this), onClick: this.onSearchClick.bind(this), id: _uniqueId, placeholder: "Search", className: "sd-line-input__input", type: "text", onKeyDown: function (event) {
                if (event.keyCode === constants_1.KEYCODES.ENTER) {
                    utils_1.onEventCapture(event);
                    _this.onSearchClick();
                }
            }, onFocus: this.props.onFocus }));
    };
    return SearchField;
}(react_1.default.Component));
exports.default = SearchField;
SearchField.propTypes = {
    onSearch: prop_types_1.default.func.isRequired,
    onSearchClick: prop_types_1.default.func.isRequired,
    value: prop_types_1.default.string,
    minLength: prop_types_1.default.number,
    onFocus: prop_types_1.default.func,
};


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(23);
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
/**
 * @ngdoc react
 * @name ButtonList
 * @description List of buttons
 */
var ButtonList = /** @class */ (function (_super) {
    __extends(ButtonList, _super);
    function ButtonList(props) {
        var _this = _super.call(this, props) || this;
        _this.dom = {
            startButton: null,
            endButton: null,
        };
        return _this;
    }
    ButtonList.prototype.onKeyDown = function (index, event) {
        if (event.keyCode !== constants_1.KEYCODES.TAB) {
            return;
        }
        if (event.shiftKey === false && index === this.props.buttonList.length - 1) {
            // Last button, bring focus back to first button
            utils_1.onEventCapture(event);
            this.dom.startButton.focus();
        }
        else if (event.shiftKey === true && this.props.captureShiftTab && index === 0) {
            // First button, take focus back to last button
            utils_1.onEventCapture(event);
            this.dom.endButton.focus();
        }
    };
    ButtonList.prototype.render = function () {
        var _this = this;
        var buttonList = this.props.buttonList;
        return (react_1.default.createElement("div", null, buttonList.map(function (buttonProps, index) { return react_1.default.createElement(index_1.Button, __assign({ key: index, onKeyDown: _this.onKeyDown.bind(_this, index), refNode: function (ref) {
                if (index === 0) {
                    _this.dom.startButton = ref;
                }
                if (index === buttonList.length - 1) {
                    _this.dom.endButton = ref;
                }
            } }, buttonProps)); })));
    };
    return ButtonList;
}(react_1.default.PureComponent));
ButtonList.propTypes = {
    buttonList: prop_types_1.default.array,
    captureShiftTab: prop_types_1.default.bool,
};
ButtonList.defaultProps = {
    buttonList: [],
    captureShiftTab: true,
};
exports.default = ButtonList;


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var utils_1 = __webpack_require__(32);
var _1 = __webpack_require__(23);
/**
 * @ngdoc react
 * @name IconButton
 * @description Icon with Button component
 */
var IconButton = function (_a) {
    var onClick = _a.onClick, tabIndex = _a.tabIndex, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, enterKeyIsClick = _a.enterKeyIsClick, icon = _a.icon, useDefaultClass = _a.useDefaultClass, className = _a.className, label = _a.label, props = __rest(_a, ["onClick", "tabIndex", "onKeyDown", "onFocus", "enterKeyIsClick", "icon", "useDefaultClass", "className", "label"]);
    var handleKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ENTER) {
            utils_1.onEventCapture(event);
            onClick();
            return;
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    return (react_1.default.createElement("a", __assign({ className: classnames_1.default({ 'icn-btn': useDefaultClass }, className), onClick: onClick, onFocus: onFocus, tabIndex: tabIndex, onKeyDown: enterKeyIsClick ? handleKeyDown : onKeyDown }, props),
        react_1.default.createElement(_1.Icon, { icon: icon }),
        label));
};
IconButton.propTypes = {
    onClick: prop_types_1.default.func,
    tabIndex: prop_types_1.default.number,
    onKeyDown: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    enterKeyIsClick: prop_types_1.default.bool,
    icon: prop_types_1.default.string,
    useDefaultClass: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    label: prop_types_1.default.string,
};
IconButton.defaultProps = {
    enterKeyIsClick: false,
    useDefaultClass: true,
};
exports.default = IconButton;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var react_bootstrap_1 = __webpack_require__(135);
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(28);
var Icon_1 = __importDefault(__webpack_require__(493));
/**
 * @ngdoc react
 * @name IconMix
 * @description Mixing two icons
 */
var IconMix = function (_a) {
    var icon = _a.icon, subIcon = _a.subIcon, big = _a.big, doubleSize = _a.doubleSize, className = _a.className, tooltip = _a.tooltip, color = _a.color;
    var iconElement;
    if (subIcon) {
        if (big) {
            iconElement = (react_1.default.createElement("span", { className: classnames_1.default('icn-mix', className) },
                react_1.default.createElement(Icon_1.default, { className: "icn-mix__sub-icn", icon: subIcon, big: true, color: color }),
                react_1.default.createElement("span", { className: "double-size-icn double-size-icn--light" },
                    react_1.default.createElement(Icon_1.default, { icon: icon, color: color }))));
        }
        else if (doubleSize) {
            iconElement = (react_1.default.createElement("span", { className: classnames_1.default('icn-mix', 'icn-mix--2x', className) },
                react_1.default.createElement(Icon_1.default, { icon: subIcon, className: "icn-mix__sub-icn", color: color }),
                react_1.default.createElement(Icon_1.default, { icon: icon, doubleSize: doubleSize, big: big, color: color })));
        }
        else {
            iconElement = (react_1.default.createElement("span", { className: classnames_1.default('icn-mix', className) },
                react_1.default.createElement(Icon_1.default, { icon: subIcon, className: "icn-mix__sub-icn", color: color }),
                react_1.default.createElement(Icon_1.default, { icon: icon, doubleSize: doubleSize, big: big, color: color })));
        }
    }
    else if (big) {
        iconElement = (react_1.default.createElement("div", { className: classnames_1.default('double-size-icn', 'double-size-icn--light', className) },
            react_1.default.createElement(Icon_1.default, { icon: icon, color: color })));
    }
    else {
        iconElement = (react_1.default.createElement(Icon_1.default, { className: className, icon: icon, doubleSize: doubleSize, color: color }));
    }
    return tooltip ? (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "icon_list_item" }, tooltip) }, iconElement)) :
        iconElement;
};
IconMix.propTypes = {
    icon: prop_types_1.default.string,
    subIcon: prop_types_1.default.string,
    big: prop_types_1.default.bool,
    doubleSize: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    tooltip: prop_types_1.default.string,
    color: prop_types_1.default.oneOf(lodash_1.values(constants_1.ICON_COLORS)),
};
IconMix.defaultProps = {
    big: false,
    doubleSize: false,
};
exports.default = IconMix;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.Dropdown = function (props) {
    var className = props.open ? 'dropdown open ' + props.className : 'dropdown ' + props.className;
    var childClassNames = ['dropdown__menu'];
    if (props.scrollable !== false) {
        childClassNames.push('dropdown__menu--scrollable');
    }
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: childClassNames.join(' ') }, props.children)));
};
exports.Dropdown.propTypes = {
    open: prop_types_1.default.bool,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    scrollable: prop_types_1.default.bool,
};


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
exports.DropdownMenuDivider = function () { return react_1.default.createElement("div", { className: "dropdown__menu-divider" }); };


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var NavTabs = /** @class */ (function (_super) {
    __extends(NavTabs, _super);
    function NavTabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { tab: props.active != null ? props.tabs[props.active] : props.tabs[0] };
        _this.selectTab = _this.selectTab.bind(_this);
        _this.selectTabByIndex = _this.selectTabByIndex.bind(_this);
        return _this;
    }
    NavTabs.prototype.selectTabByIndex = function (index) {
        this.setState({ tab: this.props.tabs[index] });
    };
    NavTabs.prototype.selectTab = function (event, tab) {
        event.stopPropagation();
        this.setState({ tab: tab });
    };
    NavTabs.prototype.render = function () {
        var _this = this;
        var tabs = this.props.tabs.map(function (tab) {
            var className = classnames_1.default('nav-tabs__tab', {
                'nav-tabs__tab--active': _this.state.tab === tab,
            });
            return (react_1.default.createElement("li", { key: tab.label, className: className },
                react_1.default.createElement("button", { onClick: function (event) { return _this.selectTab(event, tab); }, className: "nav-tabs__link" }, tab.label)));
        });
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("ul", { className: "nav-tabs nav-tabs--small" }, tabs),
            react_1.default.createElement("div", null, this.state.tab.render())));
    };
    return NavTabs;
}(react_1.default.Component));
exports.NavTabs = NavTabs;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var ng_1 = __importDefault(__webpack_require__(18));
var ui_1 = __webpack_require__(148);
var utils_1 = __webpack_require__(3);
var AttachmentList = /** @class */ (function (_super) {
    __extends(AttachmentList, _super);
    function AttachmentList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    AttachmentList.prototype.componentDidMount = function () {
        var _this = this;
        ng_1.default.get('attachments').byItem(this.props.item)
            .then(function (attachments) {
            _this.setState({ attachments: attachments });
        });
    };
    AttachmentList.prototype.render = function () {
        var _this = this;
        if (!this.state.attachments) {
            return react_1.default.createElement("div", null); // wait for attachments
        }
        var attachments = this.state.attachments.map(function (file) {
            var fileicon = 'big-icon--' + ui_1.FileiconFilter()(file.mimetype);
            var filesize = ui_1.FilesizeFilter()(file.media.length);
            var className = classnames_1.default('sd-list-item', {
                'sd-list-item--active': file._id === _this.props.selected,
            });
            return (react_1.default.createElement("div", { key: file._id, className: className, onClick: function () { return _this.props.onClick(file); } },
                react_1.default.createElement("div", { className: "sd-list-item__column sd-list-item__column--no-border" },
                    react_1.default.createElement("i", { className: fileicon })),
                react_1.default.createElement("div", { className: "sd-list-item__column sd-list-item__column--grow" },
                    react_1.default.createElement("div", { className: "sd-list-item__row" },
                        react_1.default.createElement("h4", null, file.title)),
                    react_1.default.createElement("div", { className: "sd-list-item__row" },
                        react_1.default.createElement("h5", null,
                            file.filename,
                            " (",
                            filesize,
                            ")")),
                    react_1.default.createElement("div", { className: "sd-list-item__row" },
                        react_1.default.createElement("div", { className: "description" }, file.description)))));
        });
        if (attachments.length) {
            return react_1.default.createElement("div", null, attachments);
        }
        return (react_1.default.createElement("p", { style: { padding: 20, margin: 0 } }, utils_1.gettext('There are no attachments yet. Upload some first using Attachments widget.')));
    };
    return AttachmentList;
}(react_1.default.Component));
exports.AttachmentList = AttachmentList;
AttachmentList.propTypes = {
    item: prop_types_1.default.object.isRequired,
    selected: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
};


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var classnames_1 = __importDefault(__webpack_require__(4));
var actions = __importStar(__webpack_require__(24));
var entityUtils_1 = __webpack_require__(79);
var utils_1 = __webpack_require__(3);
var LinkToolbarComponent = /** @class */ (function (_super) {
    __extends(LinkToolbarComponent, _super);
    function LinkToolbarComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onRemove = _this.onRemove.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name LinkToolbar#onSubmit
     * @description Callback when delete link.
     */
    LinkToolbarComponent.prototype.onRemove = function (linkType) {
        var _a = this.props, suggestingMode = _a.suggestingMode, removeLinkSuggestion = _a.removeLinkSuggestion, removeLink = _a.removeLink;
        suggestingMode ? removeLinkSuggestion() : removeLink();
    };
    LinkToolbarComponent.prototype.render = function () {
        var _a = this.props, editorState = _a.editorState, onEdit = _a.onEdit;
        var link = entityUtils_1.getSelectedEntityData(editorState).link;
        var isLink = entityUtils_1.getSelectedEntityType(editorState) === 'LINK';
        var cx = classnames_1.default({
            dropdown: true,
            'link-toolbar': true,
            'is-link': isLink,
        });
        return react_1.default.createElement("div", { className: cx }, !isLink ? react_1.default.createElement("span", null, "\u00A0") :
            react_1.default.createElement("span", null,
                utils_1.gettext('Link controls:'),
                link && link.href
                    ? react_1.default.createElement("a", { href: link.href, target: "_blank", rel: "noopener noreferrer" }, utils_1.gettext('Open'))
                    : null,
                react_1.default.createElement("a", { onClick: function () { return onEdit(link); } }, utils_1.gettext('Edit')),
                react_1.default.createElement("a", { onClick: this.onRemove }, utils_1.gettext('Delete'))));
    };
    return LinkToolbarComponent;
}(react_1.default.Component));
exports.LinkToolbarComponent = LinkToolbarComponent;
LinkToolbarComponent.propTypes = {
    editorState: prop_types_1.default.object,
    suggestingMode: prop_types_1.default.bool,
    removeLink: prop_types_1.default.func,
    removeLinkSuggestion: prop_types_1.default.func,
    onEdit: prop_types_1.default.func,
};
var mapStateToProps = function (state) { return ({
    editorState: state.editorState,
    suggestingMode: state.suggestingMode,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    removeLink: function () { return dispatch(actions.removeLink()); },
    removeLinkSuggestion: function () { return dispatch(actions.removeLinkSuggestion()); },
}); };
exports.LinkToolbar = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(LinkToolbarComponent);


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(23);
var react_redux_1 = __webpack_require__(25);
var actions_1 = __webpack_require__(24);
var CommentTextArea_1 = __importDefault(__webpack_require__(224));
var highlightsConfig_1 = __webpack_require__(46);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name CommentInputBody
 * @param {Function} hidePopups
 * @description CommentInputBody holds the dropdown that is used to enter the text for a
 * comment.
 */
var CommentInputBody = /** @class */ (function (_super) {
    __extends(CommentInputBody, _super);
    function CommentInputBody(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { msg: props.data.msg || '' };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name CommentInputBody#onSubmit
     * @description onSubmit is called when the user clicks the Submit button in the UI.
     * Consequently, it calls the `onSubmit` prop, passing it the value of the text input.
     */
    CommentInputBody.prototype.onSubmit = function () {
        var msg = this.state.msg;
        var _hidePopups = this.props.hidePopups;
        var highlightId = this.props.data.highlightId;
        if (msg !== '') {
            if (highlightId === undefined) {
                this.props.highlightsManager.addHighlight(highlightsConfig_1.highlightsConfig.COMMENT.type, {
                    data: __assign({ msg: msg, replies: [], resolutionInfo: null }, actions_1.getAuthorInfo()),
                });
            }
            else {
                var highlightData = this.props.highlightsManager.getHighlightData(highlightId);
                var date = new Date();
                this.props.highlightsManager.updateHighlightData(highlightId, __assign({}, highlightData, { data: __assign({}, highlightData.data, { msg: msg, date: date }) }));
            }
            _hidePopups();
        }
    };
    /**
     * @ngdoc method
     * @name CommentInputBody#onChange
     * @description onChange is triggered when the Textarea content changes.
     */
    CommentInputBody.prototype.onChange = function (ev, value) {
        this.setState({ msg: value });
    };
    CommentInputBody.prototype.render = function () {
        var msg = this.state.msg;
        return (react_1.default.createElement("div", { className: "comment-input" },
            react_1.default.createElement(components_1.Dropdown, { open: true },
                react_1.default.createElement(CommentTextArea_1.default, { value: msg, onChange: this.onChange }),
                react_1.default.createElement("div", { className: "pull-right", style: { paddingTop: 20 } },
                    react_1.default.createElement("button", { className: "btn btn--cancel", onClick: this.props.hidePopups }, utils_1.gettext('Cancel')),
                    react_1.default.createElement("button", { className: "btn btn--primary", onClick: this.onSubmit, disabled: !msg }, utils_1.gettext('Submit'))))));
    };
    return CommentInputBody;
}(react_1.default.Component));
CommentInputBody.propTypes = {
    hidePopups: prop_types_1.default.func,
    data: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object.isRequired,
};
exports.CommentInput = react_redux_1.connect(null, {
    hidePopups: actions_1.hidePopups,
})(CommentInputBody);


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mention = exports.MentionsInput = undefined;

var _MentionsInput2 = __webpack_require__(1197);

var _MentionsInput3 = _interopRequireDefault(_MentionsInput2);

var _Mention2 = __webpack_require__(526);

var _Mention3 = _interopRequireDefault(_Mention2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MentionsInput = _MentionsInput3.default;
exports.Mention = _Mention3.default;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._getTriggerRegex = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(149);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(150);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(15);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _keys = __webpack_require__(100);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(1213);

var _values2 = _interopRequireDefault(_values);

var _omit = __webpack_require__(503);

var _omit2 = _interopRequireDefault(_omit);

var _isEqual = __webpack_require__(517);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _substyle = __webpack_require__(103);

var _utils = __webpack_require__(239);

var _utils2 = _interopRequireDefault(_utils);

var _SuggestionsOverlay = __webpack_require__(1308);

var _SuggestionsOverlay2 = _interopRequireDefault(_SuggestionsOverlay);

var _Highlighter = __webpack_require__(1311);

var _Highlighter2 = _interopRequireDefault(_Highlighter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getTriggerRegex = exports._getTriggerRegex = function _getTriggerRegex(trigger) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (trigger instanceof RegExp) {
    return trigger;
  } else {
    var allowSpaceInQuery = options.allowSpaceInQuery;

    var escapedTriggerChar = _utils2.default.escapeRegex(trigger);

    // first capture group is the part to be replaced on completion
    // second capture group is for extracting the search query
    return new RegExp('(?:^|\\s)(' + escapedTriggerChar + '([^' + (allowSpaceInQuery ? '' : '\\s') + escapedTriggerChar + ']*))$');
  }
};

var _getDataProvider = function _getDataProvider(data) {
  if (data instanceof Array) {
    // if data is an array, create a function to query that
    return function (query, callback) {
      var results = [];
      for (var i = 0, l = data.length; i < l; ++i) {
        var display = data[i].display || data[i].id;
        if (display.toLowerCase().indexOf(query.toLowerCase()) >= 0) {
          results.push(data[i]);
        }
      }
      return results;
    };
  } else {
    // expect data to be a query function
    return data;
  }
};

var KEY = { TAB: 9, RETURN: 13, ESC: 27, UP: 38, DOWN: 40 };

var isComposing = false;

var MentionsInput = function (_React$Component) {
  (0, _inherits3.default)(MentionsInput, _React$Component);

  function MentionsInput(props) {
    (0, _classCallCheck3.default)(this, MentionsInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MentionsInput.__proto__ || (0, _getPrototypeOf2.default)(MentionsInput)).call(this, props));

    _initialiseProps.call(_this);

    _this.suggestions = {};

    _this.state = {
      focusIndex: 0,

      selectionStart: null,
      selectionEnd: null,

      suggestions: {},

      caretPosition: null,
      suggestionsPosition: null
    };
    return _this;
  }

  (0, _createClass3.default)(MentionsInput, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ ref: 'container' }, this.props.style),
        this.renderControl(),
        this.renderSuggestionsOverlay()
      );
    }

    // Returns the text to set as the value of the textarea with all markups removed


    // Handle input element's change event


    // Handle input element's select event

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateSuggestionsPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateSuggestionsPosition();

      // maintain selection in case a mention is added/removed causing
      // the cursor to jump to the end
      if (this.state.setSelectionAfterMentionChange) {
        this.setState({ setSelectionAfterMentionChange: false });
        this.setSelection(this.state.selectionStart, this.state.selectionEnd);
      }
    }
  }]);
  return MentionsInput;
}(_react2.default.Component);

MentionsInput.propTypes = {
  /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */
  singleLine: _propTypes2.default.bool,

  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: _propTypes2.default.bool,

  markup: _propTypes2.default.string,
  value: _propTypes2.default.string,

  displayTransform: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,

  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]).isRequired
};
MentionsInput.defaultProps = {
  markup: "@[__display__](__id__)",
  singleLine: false,
  displayTransform: function displayTransform(id, display, type) {
    return display;
  },
  onKeyDown: function onKeyDown() {
    return null;
  },
  onSelect: function onSelect() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getInputProps = function (isTextarea) {
    var _props = _this2.props,
        readOnly = _props.readOnly,
        disabled = _props.disabled,
        style = _props.style;

    // pass all props that we don't use through to the input control

    var props = (0, _omit2.default)(_this2.props, 'style', (0, _keys2.default)(MentionsInput.propTypes));

    return (0, _extends3.default)({}, props, style("input"), {

      value: _this2.getPlainText()

    }, !readOnly && !disabled && {
      onChange: _this2.handleChange,
      onSelect: _this2.handleSelect,
      onKeyDown: _this2.handleKeyDown,
      onBlur: _this2.handleBlur,
      onCompositionStart: _this2.handleCompositionStart,
      onCompositionEnd: _this2.handleCompositionEnd
    });
  };

  this.renderControl = function () {
    var _props2 = _this2.props,
        singleLine = _props2.singleLine,
        style = _props2.style;

    var inputProps = _this2.getInputProps(!singleLine);

    return _react2.default.createElement(
      'div',
      style("control"),
      _this2.renderHighlighter(inputProps.style),
      singleLine ? _this2.renderInput(inputProps) : _this2.renderTextarea(inputProps)
    );
  };

  this.renderInput = function (props) {
    return _react2.default.createElement('input', (0, _extends3.default)({
      type: 'text',
      ref: 'input'
    }, props));
  };

  this.renderTextarea = function (props) {
    return _react2.default.createElement('textarea', (0, _extends3.default)({
      ref: 'input'
    }, props));
  };

  this.renderSuggestionsOverlay = function () {
    if (!_utils2.default.isNumber(_this2.state.selectionStart)) {
      // do not show suggestions when the input does not have the focus
      return null;
    }
    return _react2.default.createElement(_SuggestionsOverlay2.default, {
      style: _this2.props.style("suggestions"),
      position: _this2.state.suggestionsPosition,
      focusIndex: _this2.state.focusIndex,
      scrollFocusedIntoView: _this2.state.scrollFocusedIntoView,
      ref: 'suggestions',
      suggestions: _this2.state.suggestions,
      onSelect: _this2.addMention,
      onMouseDown: _this2.handleSuggestionsMouseDown,
      onMouseEnter: function onMouseEnter(focusIndex) {
        return _this2.setState({
          focusIndex: focusIndex,
          scrollFocusedIntoView: false
        });
      },
      isLoading: _this2.isLoading() });
  };

  this.renderHighlighter = function (inputStyle) {
    var _state = _this2.state,
        selectionStart = _state.selectionStart,
        selectionEnd = _state.selectionEnd;
    var _props3 = _this2.props,
        markup = _props3.markup,
        displayTransform = _props3.displayTransform,
        singleLine = _props3.singleLine,
        children = _props3.children,
        value = _props3.value,
        style = _props3.style;


    return _react2.default.createElement(
      _Highlighter2.default,
      {
        ref: 'highlighter',
        style: style("highlighter"),
        inputStyle: inputStyle,
        value: value,
        markup: markup,
        displayTransform: displayTransform,
        singleLine: singleLine,
        selection: {
          start: selectionStart,
          end: selectionEnd
        },
        onCaretPositionChange: function onCaretPositionChange(position) {
          return _this2.setState({ caretPosition: position });
        } },
      children
    );
  };

  this.getPlainText = function () {
    return _utils2.default.getPlainText(_this2.props.value || "", _this2.props.markup, _this2.props.displayTransform);
  };

  this.executeOnChange = function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (_this2.props.onChange) {
      var _props4;

      return (_props4 = _this2.props).onChange.apply(_props4, [event].concat(args));
    }

    if (_this2.props.valueLink) {
      var _props$valueLink;

      return (_props$valueLink = _this2.props.valueLink).requestChange.apply(_props$valueLink, [event.target.value].concat(args));
    }
  };

  this.handleChange = function (ev) {
    // if we are inside iframe, we need to find activeElement within its contentDocument
    var currentDocument = document.activeElement && document.activeElement.contentDocument || document;
    if (currentDocument.activeElement !== ev.target) {
      // fix an IE bug (blur from empty input element with placeholder attribute trigger "input" event)
      return;
    }

    var value = _this2.props.value || "";
    var newPlainTextValue = ev.target.value;

    // Derive the new value to set by applying the local change in the textarea's plain text
    var newValue = _utils2.default.applyChangeToValue(value, _this2.props.markup, newPlainTextValue, _this2.state.selectionStart, _this2.state.selectionEnd, ev.target.selectionEnd, _this2.props.displayTransform);

    // In case a mention is deleted, also adjust the new plain text value
    newPlainTextValue = _utils2.default.getPlainText(newValue, _this2.props.markup, _this2.props.displayTransform);

    // Save current selection after change to be able to restore caret position after rerendering
    var selectionStart = ev.target.selectionStart;
    var selectionEnd = ev.target.selectionEnd;
    var setSelectionAfterMentionChange = false;

    // Adjust selection range in case a mention will be deleted by the characters outside of the
    // selection range that are automatically deleted
    var startOfMention = _utils2.default.findStartOfMentionInPlainText(value, _this2.props.markup, selectionStart, _this2.props.displayTransform);

    if (startOfMention !== undefined && _this2.state.selectionEnd > startOfMention) {
      // only if a deletion has taken place
      selectionStart = startOfMention;
      selectionEnd = selectionStart;
      setSelectionAfterMentionChange = true;
    }

    _this2.setState({
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
      setSelectionAfterMentionChange: setSelectionAfterMentionChange
    });

    var mentions = _utils2.default.getMentions(newValue, _this2.props.markup);

    // Propagate change
    // let handleChange = this.getOnChange(this.props) || emptyFunction;
    var eventMock = { target: { value: newValue } };
    // this.props.onChange.call(this, eventMock, newValue, newPlainTextValue, mentions);
    _this2.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);
  };

  this.handleSelect = function (ev) {
    // do nothing while a IME composition session is active
    if (isComposing) return;

    // keep track of selection range / caret position
    _this2.setState({
      selectionStart: ev.target.selectionStart,
      selectionEnd: ev.target.selectionEnd
    });

    // refresh suggestions queries
    var el = _this2.refs.input;
    if (ev.target.selectionStart === ev.target.selectionEnd) {
      _this2.updateMentionsQueries(el.value, ev.target.selectionStart);
    } else {
      _this2.clearSuggestions();
    }

    // sync highlighters scroll position
    _this2.updateHighlighterScroll();

    _this2.props.onSelect(ev);
  };

  this.handleKeyDown = function (ev) {
    // do not intercept key events if the suggestions overlay is not shown
    var suggestionsCount = _utils2.default.countSuggestions(_this2.state.suggestions);

    var suggestionsComp = _this2.refs.suggestions;
    if (suggestionsCount === 0 || !suggestionsComp) {
      _this2.props.onKeyDown(ev);

      return;
    }

    if ((0, _values2.default)(KEY).indexOf(ev.keyCode) >= 0) {
      ev.preventDefault();
    }

    switch (ev.keyCode) {
      case KEY.ESC:
        {
          _this2.clearSuggestions();
          return;
        }
      case KEY.DOWN:
        {
          _this2.shiftFocus(+1);
          return;
        }
      case KEY.UP:
        {
          _this2.shiftFocus(-1);
          return;
        }
      case KEY.RETURN:
        {
          _this2.selectFocused();
          return;
        }
      case KEY.TAB:
        {
          _this2.selectFocused();
          return;
        }
    }
  };

  this.shiftFocus = function (delta) {
    var suggestionsCount = _utils2.default.countSuggestions(_this2.state.suggestions);

    _this2.setState({
      focusIndex: (suggestionsCount + _this2.state.focusIndex + delta) % suggestionsCount,
      scrollFocusedIntoView: true
    });
  };

  this.selectFocused = function () {
    var _state2 = _this2.state,
        suggestions = _state2.suggestions,
        focusIndex = _state2.focusIndex;

    var _utils$getSuggestion = _utils2.default.getSuggestion(suggestions, focusIndex),
        suggestion = _utils$getSuggestion.suggestion,
        descriptor = _utils$getSuggestion.descriptor;

    _this2.addMention(suggestion, descriptor);

    _this2.setState({
      focusIndex: 0
    });
  };

  this.handleBlur = function (ev) {
    var clickedSuggestion = _this2._suggestionsMouseDown;
    _this2._suggestionsMouseDown = false;

    // only reset selection if the mousedown happened on an element
    // other than the suggestions overlay
    if (!clickedSuggestion) {
      _this2.setState({
        selectionStart: null,
        selectionEnd: null
      });
    };

    window.setTimeout(function () {
      _this2.updateHighlighterScroll();
    }, 1);

    _this2.props.onBlur(ev, clickedSuggestion);
  };

  this.handleSuggestionsMouseDown = function (ev) {
    _this2._suggestionsMouseDown = true;
  };

  this.updateSuggestionsPosition = function () {
    var caretPosition = _this2.state.caretPosition;


    if (!caretPosition || !_this2.refs.suggestions) {
      return;
    }

    var container = _this2.refs.container;


    var suggestions = _reactDom2.default.findDOMNode(_this2.refs.suggestions);
    var highlighter = _reactDom2.default.findDOMNode(_this2.refs.highlighter);

    if (!suggestions) {
      return;
    }

    var left = caretPosition.left - highlighter.scrollLeft;
    var position = {};

    // guard for mentions suggestions list clipped by right edge of window
    if (left + suggestions.offsetWidth > container.offsetWidth) {
      position.right = 0;
    } else {
      position.left = left;
    }

    position.top = caretPosition.top - highlighter.scrollTop;

    if ((0, _isEqual2.default)(position, _this2.state.suggestionsPosition)) {
      return;
    }

    _this2.setState({
      suggestionsPosition: position
    });
  };

  this.updateHighlighterScroll = function () {
    if (!_this2.refs.input || !_this2.refs.highlighter) {
      // since the invocation of this function is deferred,
      // the whole component may have been unmounted in the meanwhile
      return;
    }
    var input = _this2.refs.input;
    var highlighter = _reactDom2.default.findDOMNode(_this2.refs.highlighter);
    highlighter.scrollLeft = input.scrollLeft;
  };

  this.handleCompositionStart = function () {
    isComposing = true;
  };

  this.handleCompositionEnd = function () {
    isComposing = false;
  };

  this.setSelection = function (selectionStart, selectionEnd) {
    if (selectionStart === null || selectionEnd === null) return;

    var el = _this2.refs.input;
    if (el.setSelectionRange) {
      el.setSelectionRange(selectionStart, selectionEnd);
    } else if (el.createTextRange) {
      var range = el.createTextRange();
      range.collapse(true);
      range.moveEnd('character', selectionEnd);
      range.moveStart('character', selectionStart);
      range.select();
    }
  };

  this.updateMentionsQueries = function (plainTextValue, caretPosition) {
    // Invalidate previous queries. Async results for previous queries will be neglected.
    _this2._queryId++;
    _this2.suggestions = {};
    _this2.setState({
      suggestions: {}
    });

    var value = _this2.props.value || "";
    var positionInValue = _utils2.default.mapPlainTextIndex(value, _this2.props.markup, caretPosition, 'NULL', _this2.props.displayTransform);

    // If caret is inside of mention, do not query
    if (positionInValue === null) {
      return;
    }

    // Extract substring in between the end of the previous mention and the caret
    var substringStartIndex = _utils2.default.getEndOfLastMention(value.substring(0, positionInValue), _this2.props.markup, _this2.props.displayTransform);
    var substring = plainTextValue.substring(substringStartIndex, caretPosition);

    // Check if suggestions have to be shown:
    // Match the trigger patterns of all Mention children on the extracted substring
    _react2.default.Children.forEach(_this2.props.children, function (child) {
      if (!child) {
        return;
      }

      var regex = _getTriggerRegex(child.props.trigger, _this2.props);
      var match = substring.match(regex);
      if (match) {
        var querySequenceStart = substringStartIndex + substring.indexOf(match[1], match.index);
        _this2.queryData(match[2], child, querySequenceStart, querySequenceStart + match[1].length, plainTextValue);
      }
    });
  };

  this.clearSuggestions = function () {
    // Invalidate previous queries. Async results for previous queries will be neglected.
    _this2._queryId++;
    _this2.suggestions = {};
    _this2.setState({
      suggestions: {},
      focusIndex: 0
    });
  };

  this.queryData = function (query, mentionDescriptor, querySequenceStart, querySequenceEnd, plainTextValue) {
    var provideData = _getDataProvider(mentionDescriptor.props.data);
    var snycResult = provideData(query, _this2.updateSuggestions.bind(null, _this2._queryId, mentionDescriptor, query, querySequenceStart, querySequenceEnd, plainTextValue));
    if (snycResult instanceof Array) {
      _this2.updateSuggestions(_this2._queryId, mentionDescriptor, query, querySequenceStart, querySequenceEnd, plainTextValue, snycResult);
    }
  };

  this.updateSuggestions = function (queryId, mentionDescriptor, query, querySequenceStart, querySequenceEnd, plainTextValue, suggestions) {
    // neglect async results from previous queries
    if (queryId !== _this2._queryId) return;

    var update = {};
    update[mentionDescriptor.props.type] = {
      query: query,
      mentionDescriptor: mentionDescriptor,
      querySequenceStart: querySequenceStart,
      querySequenceEnd: querySequenceEnd,
      results: suggestions,
      plainTextValue: plainTextValue
    };

    // save in property so that multiple sync state updates from different mentions sources
    // won't overwrite each other
    _this2.suggestions = _utils2.default.extend({}, _this2.suggestions, update);

    var focusIndex = _this2.state.focusIndex;

    var suggestionsCount = _utils2.default.countSuggestions(_this2.suggestions);
    _this2.setState({
      suggestions: _this2.suggestions,
      focusIndex: focusIndex >= suggestionsCount ? Math.max(suggestionsCount - 1, 0) : focusIndex
    });
  };

  this.addMention = function (suggestion, _ref2) {
    var mentionDescriptor = _ref2.mentionDescriptor,
        querySequenceStart = _ref2.querySequenceStart,
        querySequenceEnd = _ref2.querySequenceEnd,
        plainTextValue = _ref2.plainTextValue;

    // Insert mention in the marked up value at the correct position
    var value = _this2.props.value || "";
    var start = _utils2.default.mapPlainTextIndex(value, _this2.props.markup, querySequenceStart, 'START', _this2.props.displayTransform);
    var end = start + querySequenceEnd - querySequenceStart;
    var insert = _utils2.default.makeMentionsMarkup(_this2.props.markup, suggestion.id, suggestion.display, mentionDescriptor.props.type);
    if (mentionDescriptor.props.appendSpaceOnAdd) {
      insert = insert + ' ';
    }
    var newValue = _utils2.default.spliceString(value, start, end, insert);

    // Refocus input and set caret position to end of mention
    _this2.refs.input.focus();

    var displayValue = _this2.props.displayTransform(suggestion.id, suggestion.display, mentionDescriptor.props.type);
    if (mentionDescriptor.props.appendSpaceOnAdd) {
      displayValue = displayValue + ' ';
    }
    var newCaretPosition = querySequenceStart + displayValue.length;
    _this2.setState({
      selectionStart: newCaretPosition,
      selectionEnd: newCaretPosition,
      setSelectionAfterMentionChange: true
    });

    // Propagate change
    var eventMock = { target: { value: newValue } };
    var mentions = _utils2.default.getMentions(newValue, _this2.props.markup);
    var newPlainTextValue = _utils2.default.spliceString(plainTextValue, querySequenceStart, querySequenceEnd, displayValue);

    _this2.executeOnChange(eventMock, newValue, newPlainTextValue, mentions);

    var onAdd = mentionDescriptor.props.onAdd;
    if (onAdd) {
      onAdd(suggestion.id, suggestion.display);
    }

    // Make sure the suggestions overlay is closed
    _this2.clearSuggestions();
  };

  this.isLoading = function () {
    var isLoading = false;
    _react2.default.Children.forEach(_this2.props.children, function (child) {
      isLoading = isLoading || child && child.props.isLoading;
    });
    return isLoading;
  };

  this._queryId = 0;
};

var isMobileSafari = typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);

var styled = (0, _substyle.defaultStyle)({
  position: "relative",
  overflowY: "visible",

  input: {
    display: "block",
    position: "absolute",

    top: 0,

    boxSizing: "border-box",

    backgroundColor: "transparent",

    width: "inherit"
  },

  '&multiLine': {
    input: (0, _extends3.default)({
      width: "100%",
      height: "100%",
      bottom: 0,
      overflow: "hidden",
      resize: "none"

    }, isMobileSafari ? {
      marginTop: 1,
      marginLeft: -3
    } : null)
  }
}, function (_ref) {
  var singleLine = _ref.singleLine;
  return {
    "&singleLine": singleLine,
    "&multiLine": !singleLine
  };
});

exports.default = styled(MentionsInput);

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1199);
module.exports = __webpack_require__(38).Object.getPrototypeOf;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(118);
var $getPrototypeOf = __webpack_require__(451);

__webpack_require__(1200)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(52);
var core = __webpack_require__(38);
var fails = __webpack_require__(95);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1202), __esModule: true };

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1203);
var $Object = __webpack_require__(38).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(52);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(61), 'Object', { defineProperty: __webpack_require__(68).f });


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(101),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(101),
    isLength = __webpack_require__(499),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(228),
    nativeKeys = __webpack_require__(1212);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(500);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1214),
    keys = __webpack_require__(100);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(229);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(504),
    arrayEach = __webpack_require__(1242),
    assignValue = __webpack_require__(506),
    baseAssign = __webpack_require__(1243),
    baseAssignIn = __webpack_require__(1244),
    cloneBuffer = __webpack_require__(1247),
    copyArray = __webpack_require__(1248),
    copySymbols = __webpack_require__(1249),
    copySymbolsIn = __webpack_require__(1251),
    getAllKeys = __webpack_require__(512),
    getAllKeysIn = __webpack_require__(514),
    getTag = __webpack_require__(155),
    initCloneArray = __webpack_require__(1256),
    initCloneByTag = __webpack_require__(1257),
    initCloneObject = __webpack_require__(1262),
    isArray = __webpack_require__(71),
    isBuffer = __webpack_require__(225),
    isMap = __webpack_require__(1264),
    isObject = __webpack_require__(122),
    isSet = __webpack_require__(1266),
    keys = __webpack_require__(100);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(151),
    Map = __webpack_require__(231),
    MapCache = __webpack_require__(232);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(502),
    isMasked = __webpack_require__(1227),
    isObject = __webpack_require__(122),
    toSource = __webpack_require__(505);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1228);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(55);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1229 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1231),
    ListCache = __webpack_require__(151),
    Map = __webpack_require__(231);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1232),
    hashDelete = __webpack_require__(1233),
    hashGet = __webpack_require__(1234),
    hashHas = __webpack_require__(1235),
    hashSet = __webpack_require__(1236);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(153);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(153);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(153);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(153);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(154);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(154);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(154);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(154);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(123),
    keys = __webpack_require__(100);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(123),
    keysIn = __webpack_require__(509);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(122),
    isPrototype = __webpack_require__(228),
    nativeKeysIn = __webpack_require__(1246);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(55);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(123),
    getSymbols = __webpack_require__(233);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(123),
    getSymbolsIn = __webpack_require__(511);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(84),
    root = __webpack_require__(55);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(236),
    cloneDataView = __webpack_require__(1258),
    cloneRegExp = __webpack_require__(1259),
    cloneSymbol = __webpack_require__(1260),
    cloneTypedArray = __webpack_require__(1261);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(236);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(236);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1263),
    getPrototype = __webpack_require__(235),
    isPrototype = __webpack_require__(228);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(122);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1265),
    baseUnary = __webpack_require__(226),
    nodeUtil = __webpack_require__(227);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(155),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1267),
    baseUnary = __webpack_require__(226),
    nodeUtil = __webpack_require__(227);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(155),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(237),
    last = __webpack_require__(1275),
    parent = __webpack_require__(1276),
    toKey = __webpack_require__(516);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(71),
    isSymbol = __webpack_require__(238);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1271);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1272);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(232);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1274);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102),
    arrayMap = __webpack_require__(229),
    isArray = __webpack_require__(71),
    isSymbol = __webpack_require__(238);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1277),
    baseSlice = __webpack_require__(1278);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(237),
    toKey = __webpack_require__(516);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1278 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1280);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(101),
    getPrototype = __webpack_require__(235),
    isObjectLike = __webpack_require__(70);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1282),
    overRest = __webpack_require__(1285),
    setToString = __webpack_require__(1287);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1283);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(234),
    isFlattenable = __webpack_require__(1284);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102),
    isArguments = __webpack_require__(496),
    isArray = __webpack_require__(71);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1286);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 1286 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1288),
    shortOut = __webpack_require__(1291);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1289),
    defineProperty = __webpack_require__(508),
    identity = __webpack_require__(1290);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1290 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1293),
    isObjectLike = __webpack_require__(70);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(504),
    equalArrays = __webpack_require__(518),
    equalByTag = __webpack_require__(1299),
    equalObjects = __webpack_require__(1302),
    getTag = __webpack_require__(155),
    isArray = __webpack_require__(71),
    isBuffer = __webpack_require__(225),
    isTypedArray = __webpack_require__(498);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(232),
    setCacheAdd = __webpack_require__(1295),
    setCacheHas = __webpack_require__(1296);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 1295 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1297 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1298 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(102),
    Uint8Array = __webpack_require__(515),
    eq = __webpack_require__(230),
    equalArrays = __webpack_require__(518),
    mapToArray = __webpack_require__(1300),
    setToArray = __webpack_require__(1301);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1300 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1301 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(512);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coerceSelection = __webpack_require__(523);

var _coerceSelection2 = _interopRequireDefault(_coerceSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMPTY = {};


var memoize = function memoize(substyle) {
  return function (select, defaultStyle) {
    var cacheKey = defaultStyle || EMPTY;
    substyle.memoize = substyle.memoize || new WeakMap();
    var mapEntry = void 0;
    if (!substyle.memoize.has(cacheKey)) {
      mapEntry = {};
      substyle.memoize.set(cacheKey, mapEntry);
    } else {
      mapEntry = substyle.memoize.get(cacheKey);
    }
    var selectHash = (0, _coerceSelection2.default)(select).join(' ');
    return selectHash in mapEntry ? mapEntry[selectHash] : mapEntry[selectHash] = substyle(select || [], defaultStyle);
  };
};

exports.default = memoize;
module.exports = exports['default'];

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _hoistNonReactStatics = __webpack_require__(1305);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _warning = __webpack_require__(1306);

var _warning2 = _interopRequireDefault(_warning);

var _utils = __webpack_require__(156);

var _createSubstyle = __webpack_require__(519);

var _createSubstyle2 = _interopRequireDefault(_createSubstyle);

var _types = __webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isStatelessFunction = function isStatelessFunction(Component
// $FlowFixMe
) {
  return Component.prototype && !Component.prototype.render;
};

var createDefaultStyle = function createDefaultStyle(defaultStyle, getModifiers) {
  var shouldUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return true;
  };
  return function (WrappedComponent) {
    var WithDefaultStyle = function (_Component) {
      _inherits(WithDefaultStyle, _Component);

      function WithDefaultStyle(props, context) {
        _classCallCheck(this, WithDefaultStyle);

        var _this = _possibleConstructorReturn(this, (WithDefaultStyle.__proto__ || Object.getPrototypeOf(WithDefaultStyle)).call(this, props, context));

        _this.setWrappedInstance = function (ref) {
          _this.wrappedInstance = ref;
          var innerRef = _this.props.innerRef;

          if (typeof innerRef === 'function') {
            innerRef(ref);
          } else if (innerRef && typeof innerRef !== 'string') {
            innerRef.current = ref;
          }
        };

        var style = props.style,
            className = props.className,
            classNames = props.classNames,
            _ = props.innerRef,
            rest = _objectWithoutProperties(props, ['style', 'className', 'classNames', 'innerRef']);

        _this.substyle = (0, _createSubstyle2.default)({ style: style, className: className, classNames: classNames }, _this.context[_types.PROPS_DECORATOR_CONTEXT_NAME]);

        if (typeof defaultStyle === 'function') {
          _this.defaultStyle = defaultStyle(rest);
        }
        return _this;
      }

      _createClass(WithDefaultStyle, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
          var style = _ref.style,
              className = _ref.className,
              classNames = _ref.classNames,
              rest = _objectWithoutProperties(_ref, ['style', 'className', 'classNames']);

          var _props = this.props,
              prevStyle = _props.style,
              prevClassName = _props.className,
              prevClassNames = _props.classNames,
              _ = _props.innerRef,
              prevRest = _objectWithoutProperties(_props, ['style', 'className', 'classNames', 'innerRef']);

          if (style !== prevStyle || className !== prevClassName || classNames !== prevClassNames) {
            this.substyle = (0, _createSubstyle2.default)({ style: style, className: className, classNames: classNames }, this.context[_types.PROPS_DECORATOR_CONTEXT_NAME]);
          }

          if (typeof defaultStyle === 'function') {
            if (shouldUpdate(rest, prevRest)) {
              this.defaultStyle = defaultStyle(rest);
            }
          }

          return true;
        }
      }, {
        key: 'render',
        value: function render() {
          var _props2 = this.props,
              innerRef = _props2.innerRef,
              _0 = _props2.style,
              _1 = _props2.className,
              _2 = _props2.classNames,
              rest = _objectWithoutProperties(_props2, ['innerRef', 'style', 'className', 'classNames']);

          var EnhancedWrappedComponent = this.getWrappedComponent();
          var modifiers = getModifiers ? getModifiers(rest) : [];
          return (0, _react.createElement)(EnhancedWrappedComponent, _extends({
            style: this.substyle(modifiers, this.defaultStyle || defaultStyle),
            ref: isStatelessFunction(EnhancedWrappedComponent) ? undefined : // $FlowFixMe
            this.setWrappedInstance
          }, rest));
        }
      }, {
        key: 'getWrappedComponent',
        value: function getWrappedComponent() {
          var _context$ENHANCER_CON = this.context[_types.ENHANCER_CONTEXT_NAME],
              enhance = _context$ENHANCER_CON === undefined ? _utils.identity : _context$ENHANCER_CON;


          if (this.memoizedEnhance !== enhance) {
            this.memoizedEnhance = enhance;
            this.enhancedWrappedComponent = enhance(WrappedComponent);
            if (this.enhancedWrappedComponent.propTypes) {
              this.enhancedWrappedComponent.propTypes = _extends({}, this.enhancedWrappedComponent.propTypes, {
                style: _types.PropTypes.style
              });
            }
          }

          return this.enhancedWrappedComponent || WrappedComponent;
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          (0, _warning2.default)(true, '`getWrappedInstance()` is deprecated and will be removed with the next major release. ' + 'Instead, use the `innerRef` prop to get a ref to the wrapped instance.');
          return this.wrappedInstance;
        }
      }]);

      return WithDefaultStyle;
    }(_react.Component);

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name;
    WithDefaultStyle.displayName = 'withDefaultStyle(' + wrappedComponentName + ')';

    // define prop types based on WrappedComponent's prop types
    WithDefaultStyle.propTypes = _extends({}, WrappedComponent.propTypes, _types.PropTypes);

    WithDefaultStyle.contextTypes = _types.ContextTypes;

    // expose WrappedComponent, e.g., for testing purposes
    WithDefaultStyle.WrappedComponent = WrappedComponent;

    return (0, _hoistNonReactStatics2.default)(WithDefaultStyle, WrappedComponent);
  };
};

exports.default = createDefaultStyle;
module.exports = exports['default'];

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(459);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _types = __webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EnhancerProvider = function (_React$Component) {
  _inherits(EnhancerProvider, _React$Component);

  function EnhancerProvider() {
    _classCallCheck(this, EnhancerProvider);

    return _possibleConstructorReturn(this, (EnhancerProvider.__proto__ || Object.getPrototypeOf(EnhancerProvider)).apply(this, arguments));
  }

  _createClass(EnhancerProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, _types.ENHANCER_CONTEXT_NAME, this.props.enhancer), _defineProperty(_ref, _types.PROPS_DECORATOR_CONTEXT_NAME, this.props.propsDecorator), _ref;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);

  return EnhancerProvider;
}(React.Component);

exports.default = EnhancerProvider;


EnhancerProvider.propTypes = {
  enhancer: _propTypes2.default.func,
  propsDecorator: _propTypes2.default.func,
  children: _propTypes2.default.element.isRequired
};

EnhancerProvider.childContextTypes = _types.ContextTypes;

EnhancerProvider.displayName = 'EnhancerProvider';
module.exports = exports['default'];

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(525);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(149);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(150);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _substyle = __webpack_require__(103);

var _utils = __webpack_require__(239);

var _utils2 = _interopRequireDefault(_utils);

var _Suggestion = __webpack_require__(1309);

var _Suggestion2 = _interopRequireDefault(_Suggestion);

var _LoadingIndicator = __webpack_require__(1310);

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuggestionsOverlay = function (_Component) {
  (0, _inherits3.default)(SuggestionsOverlay, _Component);

  function SuggestionsOverlay() {
    (0, _classCallCheck3.default)(this, SuggestionsOverlay);
    return (0, _possibleConstructorReturn3.default)(this, (SuggestionsOverlay.__proto__ || (0, _getPrototypeOf2.default)(SuggestionsOverlay)).apply(this, arguments));
  }

  (0, _createClass3.default)(SuggestionsOverlay, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var suggestions = this.refs.suggestions;

      if (!suggestions || suggestions.offsetHeight >= suggestions.scrollHeight || !this.props.scrollFocusedIntoView) {
        return;
      }

      var scrollTop = suggestions.scrollTop;

      var _suggestions$children = suggestions.children[this.props.focusIndex].getBoundingClientRect(),
          top = _suggestions$children.top,
          bottom = _suggestions$children.bottom;

      var _suggestions$getBound = suggestions.getBoundingClientRect(),
          topContainer = _suggestions$getBound.top;

      top = top - topContainer + scrollTop;
      bottom = bottom - topContainer + scrollTop;

      if (top < scrollTop) {
        suggestions.scrollTop = top;
      } else if (bottom > suggestions.offsetHeight) {
        suggestions.scrollTop = bottom - suggestions.offsetHeight;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          suggestions = _props.suggestions,
          isLoading = _props.isLoading,
          style = _props.style,
          onMouseDown = _props.onMouseDown;

      // do not show suggestions until there is some data

      if (_utils2.default.countSuggestions(suggestions) === 0 && !isLoading) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, style, {
          onMouseDown: onMouseDown
        }),
        _react2.default.createElement(
          'ul',
          (0, _extends3.default)({
            ref: 'suggestions'
          }, style("list")),
          this.renderSuggestions()
        ),
        this.renderLoadingIndicator()
      );
    }
  }, {
    key: 'renderSuggestions',
    value: function renderSuggestions() {
      var _this2 = this;

      return _utils2.default.getSuggestions(this.props.suggestions).reduce(function (result, _ref) {
        var suggestions = _ref.suggestions,
            descriptor = _ref.descriptor;
        return [].concat((0, _toConsumableArray3.default)(result), (0, _toConsumableArray3.default)(suggestions.map(function (suggestion, index) {
          return _this2.renderSuggestion(suggestion, descriptor, result.length + index);
        })));
      }, []);
    }
  }, {
    key: 'renderSuggestion',
    value: function renderSuggestion(suggestion, descriptor, index) {
      var _this3 = this;

      var id = this.getID(suggestion);
      var isFocused = index === this.props.focusIndex;

      var mentionDescriptor = descriptor.mentionDescriptor,
          query = descriptor.query;


      return _react2.default.createElement(_Suggestion2.default, {
        style: this.props.style("item"),
        key: id,
        id: id,
        ref: isFocused ? "focused" : null,
        query: query,
        index: index,
        descriptor: mentionDescriptor,
        suggestion: suggestion,
        focused: isFocused,
        onClick: function onClick() {
          return _this3.select(suggestion, descriptor);
        },
        onMouseEnter: function onMouseEnter() {
          return _this3.handleMouseEnter(index);
        } });
    }
  }, {
    key: 'getID',
    value: function getID(suggestion) {
      if (suggestion instanceof String) {
        return suggestion;
      }

      return suggestion.id;
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      if (!this.props.isLoading) {
        return;
      }

      return _react2.default.createElement(_LoadingIndicator2.default, this.props.style("loadingIndicator"));
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(index, ev) {
      if (this.props.onMouseEnter) {
        this.props.onMouseEnter(index);
      }
    }
  }, {
    key: 'select',
    value: function select(suggestion, descriptor) {
      this.props.onSelect(suggestion, descriptor);
    }
  }]);
  return SuggestionsOverlay;
}(_react.Component);

SuggestionsOverlay.propTypes = {
  suggestions: _propTypes2.default.object.isRequired,
  focusIndex: _propTypes2.default.number,
  scrollFocusedIntoView: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  onSelect: _propTypes2.default.func
};
SuggestionsOverlay.defaultProps = {
  suggestions: {},
  onSelect: function onSelect() {
    return null;
  }
};


var styled = (0, _substyle.defaultStyle)(function (_ref2) {
  var position = _ref2.position;
  return (0, _extends3.default)({
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    marginTop: 14,
    minWidth: 100
  }, position, {

    list: {
      margin: 0,
      padding: 0,
      listStyleType: "none"
    }
  });
});

exports.default = styled(SuggestionsOverlay);

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(149);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(150);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _substyle = __webpack_require__(103);

var _omit = __webpack_require__(503);

var _omit2 = _interopRequireDefault(_omit);

var _keys = __webpack_require__(100);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Suggestion = function (_Component) {
  (0, _inherits3.default)(Suggestion, _Component);

  function Suggestion() {
    (0, _classCallCheck3.default)(this, Suggestion);
    return (0, _possibleConstructorReturn3.default)(this, (Suggestion.__proto__ || (0, _getPrototypeOf2.default)(Suggestion)).apply(this, arguments));
  }

  (0, _createClass3.default)(Suggestion, [{
    key: 'render',
    value: function render() {
      var rest = (0, _omit2.default)(this.props, 'style', (0, _keys2.default)(Suggestion.propTypes));

      return _react2.default.createElement(
        'li',
        (0, _extends3.default)({}, rest, this.props.style),
        this.renderContent()
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props = this.props,
          id = _props.id,
          query = _props.query,
          descriptor = _props.descriptor,
          suggestion = _props.suggestion,
          index = _props.index;


      var display = this.getDisplay();
      var highlightedDisplay = this.renderHighlightedDisplay(display, query);

      if (descriptor.props.renderSuggestion) {
        return descriptor.props.renderSuggestion(suggestion, query, highlightedDisplay, index);
      }

      return highlightedDisplay;
    }
  }, {
    key: 'getDisplay',
    value: function getDisplay() {
      var suggestion = this.props.suggestion;


      if (suggestion instanceof String) {
        return suggestion;
      }

      var id = suggestion.id,
          display = suggestion.display;


      if (!id || !display) {
        return id;
      }

      return display;
    }
  }, {
    key: 'renderHighlightedDisplay',
    value: function renderHighlightedDisplay(display) {
      var _props2 = this.props,
          query = _props2.query,
          style = _props2.style;


      var i = display.toLowerCase().indexOf(query.toLowerCase());

      if (i === -1) {
        return _react2.default.createElement(
          'span',
          style("display"),
          display
        );
      }

      return _react2.default.createElement(
        'span',
        style("display"),
        display.substring(0, i),
        _react2.default.createElement(
          'b',
          style("highlight"),
          display.substring(i, i + query.length)
        ),
        display.substring(i + query.length)
      );
    }
  }]);
  return Suggestion;
}(_react.Component);

Suggestion.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  query: _propTypes2.default.string.isRequired,
  index: _propTypes2.default.number.isRequired,

  suggestion: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    display: _propTypes2.default.string
  })]).isRequired,
  descriptor: _propTypes2.default.object.isRequired,

  focused: _propTypes2.default.bool
};


var styled = (0, _substyle.defaultStyle)({
  cursor: "pointer"
}, function (props) {
  return { "&focused": props.focused };
});

exports.default = styled(Suggestion);

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _substyle = __webpack_require__(103);

var _substyle2 = _interopRequireDefault(_substyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingIndicator(_ref) {
  var style = _ref.style;

  var spinnerStyle = style("spinner");
  return _react2.default.createElement(
    'div',
    style,
    _react2.default.createElement(
      'div',
      spinnerStyle,
      _react2.default.createElement('div', spinnerStyle(["element", "element1"])),
      _react2.default.createElement('div', spinnerStyle(["element", "element2"])),
      _react2.default.createElement('div', spinnerStyle(["element", "element3"])),
      _react2.default.createElement('div', spinnerStyle(["element", "element4"])),
      _react2.default.createElement('div', spinnerStyle(["element", "element5"]))
    )
  );
};

exports.default = (0, _substyle2.default)(LoadingIndicator);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(149);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(150);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(7);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(8);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _substyle = __webpack_require__(103);

var _isEqual = __webpack_require__(517);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = __webpack_require__(239);

var _utils2 = _interopRequireDefault(_utils);

var _Mention = __webpack_require__(526);

var _Mention2 = _interopRequireDefault(_Mention);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _generateComponentKey = function _generateComponentKey(usedKeys, id) {
  if (!usedKeys.hasOwnProperty(id)) {
    usedKeys[id] = 0;
  } else {
    usedKeys[id]++;
  }
  return id + "_" + usedKeys[id];
};

var Highlighter = function (_Component) {
  (0, _inherits3.default)(Highlighter, _Component);

  function Highlighter() {
    (0, _classCallCheck3.default)(this, Highlighter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Highlighter.__proto__ || (0, _getPrototypeOf2.default)(Highlighter)).apply(this, arguments));

    _this.state = { lastPosition: {} };
    return _this;
  }

  (0, _createClass3.default)(Highlighter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.notifyCaretPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.notifyCaretPosition();
    }
  }, {
    key: 'notifyCaretPosition',
    value: function notifyCaretPosition() {
      var caret = this.refs.caret;


      if (!caret) {
        return;
      }

      var position = {
        left: caret.offsetLeft,
        top: caret.offsetTop
      };

      var lastPosition = this.state.lastPosition;


      if ((0, _isEqual2.default)(lastPosition, position)) {
        return;
      }

      this.setState({
        lastPosition: position
      });

      this.props.onCaretPositionChange(position);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selection = _props.selection,
          value = _props.value,
          markup = _props.markup,
          displayTransform = _props.displayTransform,
          style = _props.style,
          inputStyle = _props.inputStyle;

      // If there's a caret (i.e. no range selection), map the caret position into the marked up value

      var caretPositionInMarkup;
      if (selection.start === selection.end) {
        caretPositionInMarkup = _utils2.default.mapPlainTextIndex(value, markup, selection.start, 'START', displayTransform);
      }

      var resultComponents = [];
      var componentKeys = {};

      // start by appending directly to the resultComponents
      var components = resultComponents;

      var substringComponentKey = 0;

      var textIteratee = function textIteratee(substr, index, indexInPlainText) {
        // check whether the caret element has to be inserted inside the current plain substring
        if (_utils2.default.isNumber(caretPositionInMarkup) && caretPositionInMarkup >= index && caretPositionInMarkup <= index + substr.length) {
          // if yes, split substr at the caret position and insert the caret component
          var splitIndex = caretPositionInMarkup - index;
          components.push(_this2.renderSubstring(substr.substring(0, splitIndex), substringComponentKey));

          // add all following substrings and mention components as children of the caret component
          components = [_this2.renderSubstring(substr.substring(splitIndex), substringComponentKey)];
        } else {
          // otherwise just push the plain text substring
          components.push(_this2.renderSubstring(substr, substringComponentKey));
        }

        substringComponentKey++;
      };

      var mentionIteratee = function (markup, index, indexInPlainText, id, display, type, lastMentionEndIndex) {
        // generate a component key based on the id
        var key = _generateComponentKey(componentKeys, id);
        components.push(this.getMentionComponentForMatch(id, display, type, key));
      }.bind(this);
      _utils2.default.iterateMentionsMarkup(value, markup, textIteratee, mentionIteratee, displayTransform);

      // append a span containing a space, to ensure the last text line has the correct height
      components.push(" ");

      if (components !== resultComponents) {
        // if a caret component is to be rendered, add all components that followed as its children
        resultComponents.push(this.renderHighlighterCaret(components));
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, style, {
          style: (0, _extends3.default)({}, inputStyle, style.style) }),
        resultComponents
      );
    }
  }, {
    key: 'renderSubstring',
    value: function renderSubstring(string, key) {
      // set substring span to hidden, so that Emojis are not shown double in Mobile Safari
      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({}, this.props.style("substring"), { key: key }),
        string
      );
    }

    // Returns a clone of the Mention child applicable for the specified type to be rendered inside the highlighter

  }, {
    key: 'getMentionComponentForMatch',
    value: function getMentionComponentForMatch(id, display, type, key) {
      var childrenCount = _react.Children.count(this.props.children);
      var props = { id: id, display: display, key: key };

      if (childrenCount > 1) {
        if (!type) {
          throw new Error("Since multiple Mention components have been passed as children, the markup has to define the __type__ placeholder");
        }

        // detect the Mention child to be cloned
        var foundChild = null;
        _react.Children.forEach(this.props.children, function (child) {
          if (!child) {
            return;
          }

          if (child.props.type === type) {
            foundChild = child;
          }
        });

        // clone the Mention child that is applicable for the given type
        return _react2.default.cloneElement(foundChild, props);
      }

      if (childrenCount === 1) {
        // clone single Mention child
        var child = this.props.children.length ? this.props.children[0] : _react.Children.only(this.props.children);
        return _react2.default.cloneElement(child, props);
      }

      // no children, use default configuration
      return (0, _Mention2.default)(props);
    }

    // Renders an component to be inserted in the highlighter at the current caret position

  }, {
    key: 'renderHighlighterCaret',
    value: function renderHighlighterCaret(children) {
      return _react2.default.createElement(
        'span',
        (0, _extends3.default)({}, this.props.style("caret"), { ref: 'caret', key: 'caret' }),
        children
      );
    }
  }]);
  return Highlighter;
}(_react.Component);

Highlighter.propTypes = {
  selection: _propTypes2.default.shape({
    start: _propTypes2.default.number,
    end: _propTypes2.default.number
  }).isRequired,

  markup: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,

  displayTransform: _propTypes2.default.func.isRequired,
  onCaretPositionChange: _propTypes2.default.func.isRequired,
  inputStyle: _propTypes2.default.object
};
Highlighter.defaultProps = {
  value: "",
  inputStyle: {}
};


var styled = (0, _substyle.defaultStyle)({
  position: 'relative',
  width: 'inherit',
  color: 'transparent',

  overflow: 'hidden',

  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',

  '&singleLine': {
    whiteSpace: 'pre',
    wordWrap: null
  },

  substring: {
    visibility: 'hidden'
  }
}, function (props) {
  return {
    '&singleLine': props.singleLine
  };
});

exports.default = styled(Highlighter);

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
// mentionRegexp matches mentions in the comment body. It captures $1(name), $2(type), $3(id)
// the format is: @[name](type:id)
var mentionRegexp = /@\[([^\]]+)\]\((desk|user):([^\)]+)\)/g;
/*
 * @ngdoc React
 * @module superdesk.apps.users
 * @name TextWithMentions
 * @description Displays a text containing mentions.
 */
exports.TextWithMentions = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var msg = children;
    var n = msg.length;
    var r = []; // array of components to render
    var m; // regexp match
    var lastEnd = 0; // end index of last match
    do {
        m = mentionRegexp.exec(msg);
        if (m) {
            var match = m[0], name = m[1], type = m[2], id = m[3];
            if (lastEnd < m.index) {
                // push the previous slice of plain text
                r.push(msg.slice(lastEnd, m.index));
            }
            if (type === 'user') {
                // push a user mention
                r.push(react_1.default.createElement("a", { key: id, href: '/#/users/' + id }, name));
            }
            else {
                // push a desk tag
                r.push(react_1.default.createElement("span", { key: id }, '#' + name.replace(' ', '_')));
            }
            // place lastEnd after last match
            lastEnd = m.index + match.length;
        }
    } while (m);
    if (lastEnd < n) {
        // push whatever is left
        r.push(msg.slice(lastEnd, n));
    }
    return react_1.default.createElement("div", __assign({ className: "text-with-mentions" }, props), r);
};
exports.TextWithMentions.propTypes = {
    children: prop_types_1.default.string.isRequired,
};


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({
    input: {
        margin: 0,
        control: {
            backgroundColor: '#fff',
            fontWeight: 'normal',
            width: '100%',
            margin: 0,
        },
        input: {
            margin: 0,
        },
        '&singleLine': {
            input: {
                height: '100%',
            },
            control: {
                padding: '4px 0',
            },
        },
        '&multiLine': {
            control: {
                border: '1px solid silver',
            },
            highlighter: {
                padding: '3px',
                paddingTop: '4px',
                overflowY: 'hidden',
            },
            input: {
                padding: '3px',
                paddingTop: '4px',
                overflowY: 'scroll',
                outline: 0,
                border: 0,
            },
        },
        suggestions: {
            list: {
                backgroundColor: 'white',
                border: '1px solid rgba(0,0,0,0.15)',
            },
            item: {
                padding: '5px 15px',
                borderBottom: '1px solid rgba(0,0,0,0.15)',
                '&focused': {
                    backgroundColor: '#5ea9c8',
                },
            },
        },
    },
    mention: {
        backgroundColor: '#cee4e5',
    },
});


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var draft_js_1 = __webpack_require__(16);
var prop_types_1 = __importDefault(__webpack_require__(1));
var ng_1 = __importDefault(__webpack_require__(18));
var Comment_1 = __webpack_require__(1315);
var CommentTextArea_1 = __importDefault(__webpack_require__(224));
var actions_1 = __webpack_require__(24);
var editor3CustomData_1 = __webpack_require__(48);
var Highlights = __importStar(__webpack_require__(41));
var HighlightsPopupPositioner_1 = __webpack_require__(243);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name CommentPopupComponent
 * @param {Comment} comment Comment to display.
 * @description CommentPopup renders the popup which displays the content of a comment along
 * with any replies.
 */
var initialCommentsState = { reply: '', index: null, replyFieldFocused: false };
var CommentPopup = /** @class */ (function (_super) {
    __extends(CommentPopup, _super);
    function CommentPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.currentUser = ng_1.default.get('session').identity.email;
        _this.state = initialCommentsState;
        return _this;
    }
    CommentPopup.prototype.resetReply = function () {
        this.setState(initialCommentsState);
    };
    CommentPopup.prototype.postReply = function (commentData, msg) {
        this.props.highlightsManager.updateHighlightData(this.props.highlightId, __assign({}, commentData, { data: __assign({}, commentData.data, { replies: commentData.data.replies.concat(__assign({ msg: msg }, actions_1.getAuthorInfo())) }) }));
        this.resetReply();
    };
    CommentPopup.prototype.editComment = function (commentData, msg) {
        this.props.highlightsManager.updateHighlightData(this.props.highlightId, __assign({}, commentData, { data: __assign({}, commentData.data, { msg: msg }) }));
    };
    CommentPopup.prototype.editReply = function (commentData, index, msg) {
        this.props.highlightsManager.updateHighlightData(this.props.highlightId, __assign({}, commentData, { data: __assign({}, commentData.data, { replies: commentData.data.replies.map(function (reply, i) { return i === index ? __assign({}, reply, { msg: msg }) : reply; }) }) }));
    };
    CommentPopup.prototype.removeReply = function (removeAtIndex) {
        var _a = this.props, highlightsManager = _a.highlightsManager, highlightId = _a.highlightId;
        var commentData = highlightsManager.getHighlightData(highlightId);
        highlightsManager.updateHighlightData(highlightId, __assign({}, commentData, { data: __assign({}, commentData.data, { replies: commentData.data.replies.filter(function (reply, i) { return i !== removeAtIndex; }) }) }));
    };
    CommentPopup.prototype.resolveComment = function () {
        var _a = this.props, highlightsManager = _a.highlightsManager, highlightId = _a.highlightId, editorState = _a.editorState;
        var commentData = highlightsManager.getHighlightData(highlightId);
        var highlightedText = Highlights.getRangeAndTextForStyle(editorState, highlightId).highlightedText;
        var editorStateWithCommentRemoved = Highlights.removeHighlight(editorState, highlightId);
        var resolvedCommentData = {
            data: __assign({}, commentData.data, { commentedText: highlightedText, resolutionInfo: {
                    resolverUserId: ng_1.default.get('session').identity._id,
                    date: new Date(),
                } }),
        };
        var allResolvedComments = editor3CustomData_1.getCustomDataFromEditor(editorState, editor3CustomData_1.editor3DataKeys.RESOLVED_COMMENTS_HISTORY);
        var editorStateWithResolvedCommentAdded = editor3CustomData_1.setCustomDataForEditor(editorStateWithCommentRemoved, editor3CustomData_1.editor3DataKeys.RESOLVED_COMMENTS_HISTORY, (allResolvedComments || []).concat(resolvedCommentData));
        this.props.onChange(editorStateWithResolvedCommentAdded);
    };
    CommentPopup.prototype.removeComment = function () {
        var _a = this.props, highlightsManager = _a.highlightsManager, highlightId = _a.highlightId;
        highlightsManager.removeHighlight(highlightId);
    };
    CommentPopup.prototype.manageFocusForReplyInput = function (event) {
        // using onblur handler doesn't work since the focus is lost when clicking a autocomplete option
        if (this.addReplyEl != null && this.addReplyEl.contains(event.target) === false) {
            this.setState({ replyFieldFocused: false });
        }
    };
    CommentPopup.prototype.render = function () {
        var _this = this;
        var comment = this.props.comment;
        var data = comment.data;
        var replies = data.replies, resolutionInfo = data.resolutionInfo;
        var isAuthor = data.email === this.currentUser;
        var removeCommentPromise = function () { return ng_1.default.get('modal')
            .confirm(utils_1.gettext('The comment will be deleted. Are you sure?'))
            .then(function () { return _this.removeComment(); }); };
        var removeReplyPromise = function (index) { return ng_1.default.get('modal')
            .confirm(utils_1.gettext('The reply will be deleted. Are you sure?'))
            .then(function () { return _this.removeReply(index); }); };
        return (react_1.default.createElement(HighlightsPopupPositioner_1.HighlightsPopupPositioner, { editorNode: this.props.editorNode },
            react_1.default.createElement(Comment_1.Comment, { data: data, updateComment: function (msg) { return _this.editComment(comment, msg); }, onRemove: removeCommentPromise, isAuthor: isAuthor, isReply: false, editorNode: this.props.editorNode, onClick: function (e) { return _this.manageFocusForReplyInput(e); }, inlineActions: resolutionInfo === null && (react_1.default.createElement("button", { className: "btn btn--hollow btn--small", onClick: function () { return _this.resolveComment(); } }, utils_1.gettext('Resolve'))), scrollableContent: (react_1.default.createElement("div", null, replies.map(function (reply, i) { return (react_1.default.createElement(Comment_1.Comment, { key: i, data: reply, updateComment: function (msg) { return _this.editReply(comment, i, msg); }, onRemove: function () { return removeReplyPromise(i); }, isAuthor: reply.email === _this.currentUser, isReply: true })); }))), stickyFooter: (react_1.default.createElement("div", { ref: function (el) {
                        _this.addReplyEl = el;
                    } },
                    react_1.default.createElement(CommentTextArea_1.default, { className: "comment-box__input", value: this.state.reply, onChange: function (event, value) { return _this.setState({ reply: value }); }, onFocus: function () {
                            _this.setState({ replyFieldFocused: true });
                        }, singleLine: false, placeholder: 'Reply', maxHeight: 189 }),
                    this.state.replyFieldFocused !== true ? null : (react_1.default.createElement("div", { className: "comment-box__reply-toolbar comment-box__reply-toolbar--active" },
                        react_1.default.createElement("button", { onClick: function () {
                                _this.postReply(comment, _this.state.reply);
                            }, className: "btn btn--primary" }, utils_1.gettext('Reply')),
                        react_1.default.createElement("button", { onClick: function () { return _this.resetReply(); }, className: "btn" }, utils_1.gettext('Cancel')))))) })));
    };
    return CommentPopup;
}(react_1.default.Component));
exports.CommentPopup = CommentPopup;
CommentPopup.propTypes = {
    comment: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    editorState: prop_types_1.default.instanceOf(draft_js_1.EditorState),
    highlightId: prop_types_1.default.string,
    editorNode: prop_types_1.default.object,
};


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var moment_1 = __importDefault(__webpack_require__(5));
var components_1 = __webpack_require__(527);
var CommentTextArea_1 = __importDefault(__webpack_require__(224));
var prop_types_1 = __importDefault(__webpack_require__(1));
var UserAvatar_1 = __webpack_require__(91);
var EditorHighlightsHeader_1 = __webpack_require__(240);
var fluid_rows_1 = __webpack_require__(241);
var fluid_row_1 = __webpack_require__(242);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name Comment
 * @description Comment is a component that displays the author information along with the timestamp
 * and the body of that comment. It is also used for displaying replies and can take an
 * additional class.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            actionsDropdownOpen: false,
            editMode: false,
            editModeValue: _this.props.data.msg,
        };
        return _this;
    }
    Comment.prototype.cancelEditing = function (event) {
        this.setState({
            editMode: false,
            editModeValue: this.props.data.msg,
        });
    };
    Comment.prototype.toggleActionsDropdown = function () {
        this.setState({
            actionsDropdownOpen: !this.state.actionsDropdownOpen,
        });
    };
    Comment.prototype.render = function () {
        var _this = this;
        var _a = this.props, onRemove = _a.onRemove, isAuthor = _a.isAuthor, isReply = _a.isReply;
        var _b = this.props.data, author = _b.author, avatar = _b.avatar, date = _b.date;
        var absoluteDateString = moment_1.default(date).format('MMMM Do YYYY, h:mm:ss a');
        var relativeDateString = moment_1.default(date).calendar();
        var isRoot = this.props.isReply === false;
        var availableActions = isAuthor !== true ? [] : [
            {
                text: utils_1.gettext('Edit'),
                icon: 'icon-pencil',
                onClick: function () { return _this.setState({ editMode: true }); },
            },
            {
                text: utils_1.gettext('Delete'),
                icon: 'icon-trash',
                onClick: onRemove,
            },
        ];
        return (react_1.default.createElement(fluid_rows_1.FluidRows, { onClick: this.props.onClick, className: isReply ? 'comment-box__reply-item' : null },
            react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: false },
                react_1.default.createElement(EditorHighlightsHeader_1.EditorHighlightsHeader, { availableActions: availableActions },
                    react_1.default.createElement(UserAvatar_1.UserAvatar, { displayName: author, pictureUrl: avatar }),
                    react_1.default.createElement("p", { className: "editor-popup__author-name" }, author),
                    react_1.default.createElement("time", { className: "editor-popup__time", title: relativeDateString }, absoluteDateString)),
                isReply !== false ? null : (react_1.default.createElement("div", { className: "editor-popup__content-block", style: { paddingBottom: 0 } },
                    react_1.default.createElement("div", { className: "space-between editor-popup__info-bar" },
                        react_1.default.createElement("span", { className: "label" }, utils_1.gettext('Comment')),
                        this.props.inlineActions || null)))),
            react_1.default.createElement(fluid_row_1.FluidRow, { className: "editor-popup__content-block", scrollable: !this.state.editMode }, this.state.editMode === true ?
                (react_1.default.createElement("div", null,
                    react_1.default.createElement(CommentTextArea_1.default, { className: "comment-box__input", value: this.state.editModeValue, onChange: function (event, value) { return _this.setState({ editModeValue: value }); }, singleLine: false, maxHeight: isRoot === true ? 300 : undefined }),
                    react_1.default.createElement("div", { className: 'comment-box__button-toolbar'
                            + ' comment-box__button-toolbar--right'
                            + ' comment-box__button-toolbar--small' },
                        react_1.default.createElement("button", { onClick: function (event) {
                                _this.cancelEditing(event);
                            }, className: "btn btn--icon-only btn--hollow" },
                            react_1.default.createElement("i", { className: "icon-close-small" })),
                        react_1.default.createElement("button", { onClick: function () {
                                _this.props.updateComment(_this.state.editModeValue);
                                _this.cancelEditing();
                            }, className: "btn btn--primary btn--icon-only" },
                            react_1.default.createElement("i", { className: "icon-ok" })))))
                : (react_1.default.createElement(components_1.TextWithMentions, null, this.props.data.msg))),
            this.props.scrollableContent == null ? null : (react_1.default.createElement(fluid_row_1.FluidRow, { className: "editor-popup__secondary-content", scrollable: true }, this.props.scrollableContent)),
            this.props.stickyFooter == null ? null : (react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: false },
                react_1.default.createElement("div", { className: "editor-popup__secondary-content" },
                    react_1.default.createElement("div", { className: "editor-popup__content-block" }, this.props.stickyFooter))))));
    };
    return Comment;
}(react_1.default.Component));
exports.Comment = Comment;
Comment.propTypes = {
    data: prop_types_1.default.shape({
        author: prop_types_1.default.string,
        date: prop_types_1.default.any,
        avatar: prop_types_1.default.string,
        msg: prop_types_1.default.string,
    }),
    onClick: prop_types_1.default.func,
    inlineActions: prop_types_1.default.object,
    replies: prop_types_1.default.object,
    className: prop_types_1.default.string,
    updateComment: prop_types_1.default.func.isRequired,
    onRemove: prop_types_1.default.func,
    isAuthor: prop_types_1.default.bool.isRequired,
    isReply: prop_types_1.default.bool.isRequired,
    position: prop_types_1.default.func,
    editorNode: prop_types_1.default.object,
    scrollableContent: prop_types_1.default.object,
    stickyFooter: prop_types_1.default.object,
};


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(23);
var react_redux_1 = __webpack_require__(25);
var draft_js_1 = __webpack_require__(16);
var highlightsConfig_1 = __webpack_require__(46);
var actions_1 = __webpack_require__(24);
var ReactRenderAsync_1 = __webpack_require__(54);
var actions_2 = __webpack_require__(24);
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
var react_2 = __webpack_require__(529);
var AnnotationInputDefault_1 = __webpack_require__(1325);
var from_html_1 = __webpack_require__(124);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @param {Function} hidePopups
 * @description AnnotationInput is the popup containing the fields needed to fill in information
 * about an annotation.
 */
var AnnotationInputBody = /** @class */ (function (_super) {
    __extends(AnnotationInputBody, _super);
    function AnnotationInputBody(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        var data = props.data, annotationTypes = props.annotationTypes;
        var editing = typeof data.annotation === 'object';
        var body = null;
        var isEmpty = true;
        var type = annotationTypes && annotationTypes.length > 0 ? annotationTypes[0].qcode : '';
        if (editing) {
            (_a = data.annotation.data, type = _a.annotationType, body = _a.msg);
            body = JSON.parse(body);
            isEmpty = false;
        }
        _this.state = {
            body: body != null ? body : draft_js_1.convertToRaw(draft_js_1.ContentState.createFromText('')),
            type: type,
            isEmpty: isEmpty,
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        _this.deleteAnnotation = _this.deleteAnnotation.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name AnnotationInput#onSubmit
     * @description onSubmit is called when the user clicks the Submit button in the UI.
     * Consequently, it calls the `onSubmit` prop, passing it the value of the text input.
     */
    AnnotationInputBody.prototype.onSubmit = function () {
        var _a = this.state, body = _a.body, type = _a.type;
        var _hidePopups = this.props.hidePopups;
        var highlightId = this.props.data.highlightId;
        if (body !== '') {
            var msg = JSON.stringify(body);
            var annotationType = type;
            if (highlightId === undefined) {
                this.props.highlightsManager.addHighlight(highlightsConfig_1.highlightsConfig.ANNOTATION.type, {
                    data: __assign({ msg: msg,
                        annotationType: annotationType }, actions_1.getAuthorInfo()),
                });
            }
            else {
                var highlightData = this.props.highlightsManager.getHighlightData(highlightId);
                var date = new Date();
                this.props.highlightsManager.updateHighlightData(highlightId, __assign({}, highlightData, { data: __assign({}, highlightData.data, { msg: msg, annotationType: annotationType, date: date }) }));
            }
            _hidePopups();
        }
    };
    AnnotationInputBody.prototype.onChange = function (rawDraftContentState, callback) {
        this.setState({
            body: rawDraftContentState,
            isEmpty: rawDraftContentState == null || !draft_js_1.convertFromRaw(rawDraftContentState).hasText(),
        }, callback);
    };
    /**
     * @ngdoc method
     * @name AnnotationInput#onSelect
     * @param {Event} e
     * @description onSelect is triggered when the annotation type is toggled.
     */
    AnnotationInputBody.prototype.onSelect = function (_a) {
        var target = _a.target;
        this.setState({ type: target.value });
    };
    AnnotationInputBody.prototype.componentDidMount = function () {
        $('.annotation-input textarea').focus();
    };
    AnnotationInputBody.prototype.deleteAnnotation = function () {
        var highlightsManager = this.props.highlightsManager;
        var _hidePopups = this.props.hidePopups;
        var highlightId = this.props.data.highlightId;
        ng_1.default.get('modal')
            .confirm(utils_1.gettext('The annotation will be deleted. Are you sure?'))
            .then(function () {
            highlightsManager.removeHighlight(highlightId);
        });
        _hidePopups();
    };
    AnnotationInputBody.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, spellcheckerEnabled = _a.spellcheckerEnabled, language = _a.language, annotationTypes = _a.annotationTypes;
        var _hidePopups = this.props.hidePopups;
        var annotation = data.annotation;
        var _b = this.state, type = _b.type, isEmpty = _b.isEmpty;
        var selection = data.selection;
        var blockKey = data.selection.getStartKey();
        var contentState = this.props.editorState.getCurrentContent();
        var block = contentState.getBlockForKey(blockKey);
        var text = block.getText().slice(selection.getStartOffset(), selection.getEndOffset());
        var annotationTypeSelect = annotationTypes == null ? null : (react_1.default.createElement("div", { className: "sd-line-input sd-line-input--is-select" },
            react_1.default.createElement("label", { className: "sd-line-input__label" }, utils_1.gettext('Annotation Type')),
            react_1.default.createElement("select", { className: "sd-line-input__select", onChange: this.onSelect, value: type }, annotationTypes.map(function (annotationType) {
                return react_1.default.createElement("option", { key: annotationType.qcode, value: annotationType.qcode }, annotationType.name);
            }))));
        var annotationInputComponent = (react_1.default.createElement("div", null,
            annotationTypeSelect,
            react_1.default.createElement("div", { className: "sd-line-input" },
                react_1.default.createElement("label", { className: "sd-line-input__label" }, utils_1.gettext('Annotation Body')),
                react_1.default.createElement(react_2.Editor3Standalone, { onChange: this.onChange, editorFormat: ['bold', 'italic', 'underline', 'link'], rawDraftContentState: this.state.body, language: language, disableSpellchecker: !spellcheckerEnabled, scrollContainer: 'body' })),
            react_1.default.createElement("div", { className: "pull-right" },
                typeof annotation === 'object' &&
                    react_1.default.createElement("button", { className: "btn btn--cancel", onClick: this.deleteAnnotation }, utils_1.gettext('Delete')),
                react_1.default.createElement("button", { className: "btn btn--cancel", onClick: _hidePopups }, utils_1.gettext('Cancel')),
                react_1.default.createElement("button", { className: "btn btn--primary", onClick: this.onSubmit, disabled: isEmpty }, utils_1.gettext('Submit')))));
        var annotationExtensionPoints = this.props.extensionPoints.get('authoring:editor3:annotations');
        var AnnotationInputComponent = annotationExtensionPoints[0] == null
            ? AnnotationInputDefault_1.AnnotationInputDefault
            : annotationExtensionPoints[0].componentClass;
        return (react_1.default.createElement("div", { className: "annotation-input" },
            react_1.default.createElement(components_1.Dropdown, { open: true, scrollable: false },
                react_1.default.createElement(AnnotationInputComponent, { annotationText: text, onCancel: _hidePopups, annotationTypeSelect: annotationTypeSelect, annotationInputComponent: annotationInputComponent, onApplyAnnotation: function (html) {
                        _this.onChange(draft_js_1.convertToRaw(from_html_1.getContentStateFromHtml(html)), _this.onSubmit);
                    } }))));
    };
    return AnnotationInputBody;
}(react_1.default.Component));
AnnotationInputBody.propTypes = {
    hidePopups: prop_types_1.default.func,
    data: prop_types_1.default.object,
    language: prop_types_1.default.string,
    spellcheckerEnabled: prop_types_1.default.bool,
    highlightsManager: prop_types_1.default.object.isRequired,
    annotationTypes: prop_types_1.default.array.isRequired,
};
var mapStateToProps = function (state) { return ({
    language: state.item.language,
    spellcheckerEnabled: state.spellcheckerEnabled,
}); };
var AnnotationInputBodyWithDependenciesLoaded = ReactRenderAsync_1.connectPromiseResults(function () { return ({
    annotationTypes: ng_1.default.get('metadata').initialize()
        .then(function () { return ng_1.default.get('metadata').values.annotation_types; }),
    extensionPoints: ng_1.default.getService('extensionPoints'),
}); })(AnnotationInputBody);
exports.AnnotationInput = react_redux_1.connect(mapStateToProps, {
    hidePopups: actions_2.hidePopups,
})(AnnotationInputBodyWithDependenciesLoaded);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// @flow

const docsSoap = __webpack_require__(1319);
const parseHTML = __webpack_require__(531);

module.exports = {
  default: docsSoap,
  docsSoap: docsSoap, //eslint-disable-line
  parseHTML: parseHTML //eslint-disable-line
};


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var constants = __webpack_require__(1320);
var parseHTML = __webpack_require__(531);

var docsId = constants.docsId,
    elements = constants.elements,
    headers = constants.headers,
    styles = constants.styles;


var wrapNodeAnchor = function wrapNodeAnchor(node, href) {
  var anchor = document.createElement(elements.ANCHOR);
  anchor.href = href;
  anchor.appendChild(node.cloneNode(true));
  return anchor;
};

var wrapNodeInline = function wrapNodeInline(node, style) {
  var el = document.createElement(style);
  el.appendChild(node.cloneNode(true));
  return el;
};

var wrapNode = function wrapNode(inner, result) {
  var newNode = result.cloneNode(true);
  if (!inner) {
    return newNode;
  }
  if (inner.style && inner.style.fontWeight === styles.BOLD) {
    newNode = wrapNodeInline(newNode, elements.BOLD);
  }
  if (inner.style && inner.style.fontStyle === styles.ITALIC) {
    newNode = wrapNodeInline(newNode, elements.ITALIC);
  }
  if (inner.style && inner.style.textDecoration === styles.UNDERLINE) {
    newNode = wrapNodeInline(newNode, elements.UNDERLINE);
  }
  if (inner.style && inner.style.textDecoration === styles.STRIKETHROUGH) {
    newNode = wrapNodeInline(newNode, elements.STRIKETHROUGH);
  }
  if (inner.style && inner.style.verticalAlign === styles.SUPERSCRIPT) {
    newNode = wrapNodeInline(newNode, elements.SUPERSCRIPT);
  }
  if (inner.style && inner.style.verticalAlign === styles.SUBSCRIPT) {
    newNode = wrapNodeInline(newNode, elements.SUBSCRIPT);
  }
  return newNode;
};

var applyBlockStyles = function applyBlockStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode = document.createTextNode('');
  if (node.childNodes[0] && node.childNodes[0].style) {
    styledNode = node.childNodes[0];
  }
  if (node.childNodes[0] && node.childNodes[0].nodeName === 'A') {
    // flow-ignore Flow doesn't recognize that a childNode can be an HTMLAnchorElement
    newNode = wrapNodeAnchor(newNode.cloneNode(true), node.childNodes[0].href);
    styledNode = node.childNodes[0].childNodes[0];
  }
  newNode = wrapNode(styledNode, newNode);
  return newNode;
};

var applyInlineStyles = function applyInlineStyles(dirty) {
  var node = dirty.cloneNode(true);
  var newNode = document.createTextNode(node.textContent);
  var styledNode = node;
  if (node.nodeName === 'A') {
    // flow-ignore Flow doesn't recognize that cloneNode() can return an HTMLAnchorElement
    newNode = wrapNodeAnchor(newNode, node.href);
    if (node.childNodes[0] && node.childNodes[0].style) {
      styledNode = node.childNodes[0];
    }
  }
  newNode = wrapNode(styledNode, newNode);
  return newNode;
};

var listTagNames = ['OL', 'UL', 'LI'];
var tableTagNames = ['TABLE', 'THEAD', 'TBODY', 'TFOOT', 'COLGROUP', 'COL', 'TR', 'TH', 'TD', 'CAPTION'];
var tagsToPreserve = [].concat(listTagNames, tableTagNames);

var getCleanNode = function getCleanNode(node) {
  if (node.childNodes && (node.childNodes.length <= 1 || tagsToPreserve.includes(node.nodeName))) {
    var newWrapper = null;
    var newNode = document.createTextNode(node.textContent);
    if (tagsToPreserve.includes(node.nodeName) || typeof node.querySelector === 'function' // querySelector is not available for text nodes
    && node.querySelector(tagsToPreserve.join(',')) != null) {
      newWrapper = document.createElement(node.nodeName);
      newNode = document.createDocumentFragment();
      var items = [];
      for (var i = 0; i < node.childNodes.length; i++) {
        items.push.apply(items, _toConsumableArray(getCleanNode(node.childNodes[i])));
      }
      items.map(function (i) {
        return newNode.appendChild(i);
      });
    } else if (headers.indexOf(node.nodeName) !== -1) {
      newWrapper = document.createElement(node.nodeName);
      newNode = applyInlineStyles(node.childNodes[0]);
    } else if (node.nodeName === 'P') {
      newWrapper = document.createElement('p');
      newNode = applyBlockStyles(node);
    } else if (node.nodeName === 'BR') {
      newNode = node;
    } else {
      newWrapper = document.createElement('span');
      newNode = applyInlineStyles(node);
    }
    if (newWrapper) {
      newWrapper.appendChild(newNode);
      return [newWrapper];
    }
    return [node.cloneNode(true)];
  }
  if (node.childNodes) {
    var nodes = [];
    for (var _i = 0; _i < node.childNodes.length; _i++) {
      nodes.push.apply(nodes, _toConsumableArray(getCleanNode(node.childNodes[_i])));
    }
    return nodes;
  }
  return [node];
};

/**
 * filter unwanted node
 * @param node
 * @returns {boolean}
 */
var filterNode = function filterNode(node) {
  return node.nodeType !== 8;
}; // Node.COMMENT_NODE = 8

/**
 * parses the given "dirty" clipboard content and returns a (mostly) clean
 * HTML document with only the HTML content you want
 * @param dirty
 * @returns {HTMLElement}
 */
var getCleanDocument = function getCleanDocument(dirty) {
  // create a new document to preserve the integrity of the original data
  var body = document.createElement('body');
  var nodes = dirty.childNodes;
  var filteredNodes = Array.from(nodes).filter(filterNode);
  var cleanNodes = [];

  // for each top level node, clean it up recursively
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = filteredNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var node = _step.value;

      cleanNodes.push.apply(cleanNodes, _toConsumableArray(getCleanNode(node)));
    }

    // append all of the clean nodes to the new document
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  for (var i = 0; i < cleanNodes.length; i++) {
    body.appendChild(cleanNodes[i].cloneNode(true));
  }

  // all clean
  return body;
};

module.exports = function (clipboardContent) {
  if (typeof clipboardContent !== 'string') {
    throw new Error('Expected \'clipboardContent\' to be a string of HTML, received ' + (typeof clipboardContent === 'undefined' ? 'undefined' : _typeof(clipboardContent)));
  }
  if (clipboardContent.length <= 0) {
    throw new Error('Expected clipboardContent to have content, received empty string');
  }
  if (!clipboardContent.match(docsId)) {
    return parseHTML(clipboardContent.replace(/(\r\n|\n|\r)/, '')).outerHTML;
  }
  return getCleanDocument(parseHTML(clipboardContent.replace(/(\r\n|\n|\r)/, ''))).outerHTML;
};

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var docsId = /id="docs\-internal\-guid/;

var styles = {
  BOLD: '700',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'line-through',
  SUPERSCRIPT: 'super',
  SUBSCRIPT: 'sub'
};

var elements = {
  ANCHOR: 'a',
  BOLD: 'strong',
  ITALIC: 'em',
  UNDERLINE: 'u',
  STRIKETHROUGH: 'del',
  SUPERSCRIPT: 'sup',
  SUBSCRIPT: 'sub'
};

var headers = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

module.exports = { docsId: docsId, styles: styles, elements: elements, headers: headers };

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var spellchecker_1 = __importDefault(__webpack_require__(533));
var editor3_1 = __importDefault(__webpack_require__(104));
var toolbar_1 = __importDefault(__webpack_require__(534));
var table_1 = __importDefault(__webpack_require__(1323));
var suggestions_1 = __importDefault(__webpack_require__(539));
var find_replace_1 = __importDefault(__webpack_require__(1324));
// Returns a new reducer which chains the state and action throught the given
// list of reducers.
var chainReduce = function () {
    var reducers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        reducers[_i] = arguments[_i];
    }
    return function (startState, action) {
        if (startState === void 0) { startState = {}; }
        return reducers.reduce(function (newState, r) { return r(newState, action); }, startState);
    };
};
var editorReducers = chainReduce(spellchecker_1.default, toolbar_1.default, table_1.default, editor3_1.default, find_replace_1.default, suggestions_1.default);
exports.default = editorReducers;


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
/**
 * @ngdoc method
 * @name removeBlock
 * @param {Object} editorState
 * @param {String} blockKey
 * @return {Object} returns new state
 * @description Delete the block with given key.
 */
exports.removeBlock = function (editorState, blockKey) {
    var contentState = editorState.getCurrentContent();
    var block = contentState.getBlockForKey(blockKey);
    var targetRange = new draft_js_1.SelectionState({
        anchorKey: blockKey,
        anchorOffset: 0,
        focusKey: blockKey,
        focusOffset: block.getLength(),
    });
    var newContentState = draft_js_1.Modifier.setBlockType(contentState, targetRange, 'unstyled');
    newContentState = draft_js_1.Modifier.removeRange(newContentState, targetRange, 'backward');
    return draft_js_1.EditorState.push(editorState, newContentState, 'remove-range');
};


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var editor3_1 = __webpack_require__(104);
var insertAtomicBlockWithoutEmptyLines_1 = __importDefault(__webpack_require__(537));
var table_1 = __webpack_require__(112);
/**
 * @description Contains the list of table related reducers.
 */
var table = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'TOOLBAR_ADD_TABLE':
            return addTable(state, action.payload);
        case 'TOOLBAR_ADD_ROW_AFTER':
            return addRowAfter(state);
        case 'TOOLBAR_ADD_COL_AFTER':
            return addColAfter(state);
        case 'TOOLBAR_REMOVE_ROW':
            return removeRow(state);
        case 'TOOLBAR_REMOVE_COL':
            return removeCol(state);
        case 'TOOLBAR_TABLE_HEADER':
            return toggleTableHeader(state);
        case 'TOOLBAR_TABLE_STYLE':
            return toggleTableStyle(state, action.payload);
        default:
            return state;
    }
};
/**
 * @ngdoc method
 * @name addTable
 * @param {Object} data Table data (numRows, numCols, cells).
 * @description Adds a table into the content.
 */
var addTable = function (state, data) {
    var contentState = state.editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity('TABLE', 'MUTABLE', { data: data });
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    var editorState = insertAtomicBlockWithoutEmptyLines_1.default(state.editorState, entityKey, ' ').editorState;
    return editor3_1.onChange(state, editorState);
};
/**
 * @ngdoc method
 * @name addRowAfter
 * @description Adds a row after the currently active one.
 */
var addRowAfter = function (state) {
    return processCells(state, function (prevCells, numCols, nRows, i, j, withHeader) {
        var numRows = nRows + 1;
        var cells = [];
        prevCells.forEach(function (row, index) {
            cells.push(row);
            if (index === i) {
                cells.push([]);
            }
        });
        return { data: { cells: cells, numRows: numRows, numCols: numCols, withHeader: withHeader } };
    });
};
/**
 * @ngdoc method
 * @name removeRow
 * @description Removes the currently active row.
 */
var removeRow = function (state) {
    return processCells(state, function (cells, numCols, nRows, i, j, withHeader) {
        var numRows = nRows;
        if (numRows > 1) {
            cells.splice(i, 1);
            numRows -= 1;
        }
        return { data: { cells: cells, numRows: numRows, numCols: numCols, withHeader: withHeader } };
    });
};
/**
 * @ngdoc method
 * @name addColAfter
 * @description Adds a column after the currently active one.
 */
var addColAfter = function (state) {
    return processCells(state, function (cells, numCols, numRows, i, j, withHeader) { return ({
        data: {
            numRows: numRows,
            numCols: numCols + 1,
            withHeader: withHeader,
            cells: cells.map(function (_, ii) {
                return Array.from(new Array(numCols + 1))
                    .map(function (__, jj) {
                    if (jj === j + 1) {
                        return null;
                    }
                    var orig = jj;
                    if (jj > j + 1) {
                        orig -= 1;
                    }
                    if (cells[ii] && cells[ii][orig]) {
                        return cells[ii][orig];
                    }
                    return null;
                });
            }),
        },
    }); });
};
/**
 * @ngdoc method
 * @name removeCol
 * @description Removes the currently active column.
 */
var removeCol = function (state) {
    return processCells(state, function (prevCells, nCols, numRows, i, j, withHeader) {
        var numCols = nCols;
        var cells = prevCells;
        if (numCols > 1) {
            numCols -= 1;
            cells = prevCells.map(function (cell) {
                cell.splice(j, 1);
                return cell;
            });
        }
        return { data: { cells: cells, numRows: numRows, numCols: numCols, withHeader: withHeader } };
    });
};
/**
 * @ngdoc method
 * @name processCells
 * @param {Function} fn Function that is called with parameters
 * (cells, numCols, numRows, i, j, withHeader) and is expected to return the new
 * data that should be placed on the table entity. The expected return
 * is an object with keys {cells, numRows, numCols}.
 * @description Helper function to help process the cells in the currently active
 * table and transform the entity data to a new form, using a callback function.
 */
var processCells = function (state, fn) {
    var activeCell = state.activeCell, editorState = state.editorState;
    if (activeCell === null) {
        return state;
    }
    var i = activeCell.i, j = activeCell.j, key = activeCell.key, currentStyle = activeCell.currentStyle, selection = activeCell.selection;
    var contentState = editorState.getCurrentContent();
    var block = contentState.getBlockForKey(key);
    var _a = table_1.getData(contentState, block.getKey()), cells = _a.cells, numRows = _a.numRows, numCols = _a.numCols, withHeader = _a.withHeader;
    var _b = fn(cells, numCols, numRows, i, j, withHeader, currentStyle, selection), data = _b.data, newCurrentStyle = _b.newCurrentStyle;
    var newEditorState = table_1.setData(editorState, block, data, 'change-block-data');
    var newState = state;
    if (newCurrentStyle !== null) {
        newState = __assign({}, state, { activeCell: __assign({}, activeCell, { currentStyle: newCurrentStyle, selection: selection }) });
    }
    return editor3_1.onChange(newState, newEditorState, true);
};
/**
 * @ngdoc method
 * @name toggleTableHeader
 * @description Toggles the table's header.
 */
var toggleTableHeader = function (state) {
    return processCells(state, function (cells, numCols, numRows, i, j, withHeader, currentStyle) {
        var newData = {
            cells: cells,
            numRows: numRows,
            numCols: numCols,
            withHeader: !withHeader,
            currentStyle: currentStyle,
        };
        return {
            data: newData,
            newCurrentStyle: currentStyle,
        };
    });
};
/**
 * @ngdoc method
 * @name toggleTableStyle
 * @description Toggles the table's style.
 */
var toggleTableStyle = function (state, inlineStyle) {
    return processCells(state, function (cells, numCols, numRows, i, j, withHeader, currentStyle, selection) {
        var data = { cells: cells, numRows: numRows, numCols: numCols, withHeader: withHeader };
        var cellStateEditor = table_1.getCell(data, i, j, currentStyle, selection);
        var newCellEditorState = draft_js_1.RichUtils.toggleInlineStyle(cellStateEditor, inlineStyle);
        var newCurrentStyle = newCellEditorState.getCurrentInlineStyle().toArray();
        var newData = table_1.setCell(data, i, j, newCellEditorState).data;
        return {
            data: newData,
            newCurrentStyle: newCurrentStyle,
        };
    });
};
exports.default = table;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint complains about imported types not being used
// eslint-disable-next-line no-unused-vars
var draft_js_1 = __webpack_require__(16);
var find_replace_1 = __webpack_require__(176);
var editor3_1 = __webpack_require__(104);
var utils_1 = __webpack_require__(3);
var findReplace = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'HIGHLIGHTS_FIND_NEXT':
            return findNext(state);
        case 'HIGHLIGHTS_FIND_PREV':
            return findPrev(state);
        case 'HIGHLIGHTS_REPLACE':
            return replaceHighlight(state, action.payload);
        case 'HIGHLIGHTS_REPLACE_ALL':
            return replaceHighlight(state, action.payload, true);
        case 'HIGHLIGHTS_RENDER':
            return render(state);
        case 'HIGHLIGHTS_CRITERIA':
            return setCriteria(state, action.payload);
        default:
            return state;
    }
};
/**
 * @name replaceHighlight
 * @param {Object} state
 * @param {string} txt The text to replace the highlight with
 * @param {boolean=} all If set to true, it replaces all occurences, otherwise it replaces
 * only the current one.
 * @description Replaces highlights with the given text.
 */
var replaceHighlight = function (state, txt, all) {
    if (all === void 0) { all = false; }
    var _a = state.searchTerm, index = _a.index, pattern = _a.pattern, caseSensitive = _a.caseSensitive, diff = _a.diff;
    var es = state.editorState;
    var contentChanged = false;
    var contentChangedInAll = true;
    var _b = find_replace_1.clearHighlights(es.getCurrentContent(), es), content = _b.content, editorState = _b.editorState;
    var regexp = getRegExp(diff, pattern, caseSensitive);
    // tries to replace the occurrence at position pos and returns true if successful.
    var replaceAt = function (pos, _content) {
        return find_replace_1.forEachMatch(_content, regexp, caseSensitive, function (i, selection, block, newContent) {
            if (i === pos) {
                // let's preserve styling and entities (such as links) on replacing
                var styleAt = block.getInlineStyleAt(selection.anchorOffset) || null;
                var entityAt = block.getEntityAt(selection.anchorOffset) || null;
                contentChanged = true;
                contentChangedInAll = true;
                return draft_js_1.Modifier.replaceText(newContent, selection, txt, styleAt, entityAt);
            }
            return newContent;
        });
    };
    if (all) {
        // each replace alters the content and changes text offsets, so we need to call this method repeatedly
        while (contentChangedInAll) {
            contentChangedInAll = false;
            content = replaceAt(0, content);
        }
    }
    else {
        content = replaceAt(index, content);
    }
    if (contentChanged) {
        editorState = draft_js_1.EditorState.push(editorState, content, 'insert-characters');
    }
    var editorStateChanged = editor3_1.onChange(state, editorState);
    return __assign({}, editorStateChanged, { searchTerm: __assign({}, state.searchTerm, { 
            // if we replaced the occurrence, index decreases
            index: contentChanged && !all ? index - 1 : index }) });
};
/**
 * @name findNext
 * @param {Object} state
 * @description Increases the highlighted ocurrence index.
 */
var findNext = function (state) {
    var matches = getMatches(state);
    var _a = state.searchTerm, index = _a.index, diff = _a.diff;
    if (++index >= matches.length) {
        index = 0;
    }
    var pattern = matches[index];
    return render(__assign({}, state, { searchTerm: __assign({}, state.searchTerm, { index: index, pattern: pattern, diff: diff }) }));
};
/**
 * @name findPrev
 * @param {Object} state
 * @description Decreases the highlighted ocurrence index.
 */
var findPrev = function (state) {
    var matches = getMatches(state);
    var _a = state.searchTerm, index = _a.index, diff = _a.diff;
    if (--index < 0) {
        index = matches.length - 1;
    }
    var pattern = matches[index];
    return render(__assign({}, state, { searchTerm: __assign({}, state.searchTerm, { index: index, pattern: pattern, diff: diff }) }));
};
/**
 * @name setCriteria
 * @param {Object} state
 * @param {Object} diff
 * @param {boolean} caseSensitive
 * @description Sets the highlight criteria diff and case sensitivity.
 */
var setCriteria = function (state, _a) {
    var diff = _a.diff, caseSensitive = _a.caseSensitive;
    // If a new pattern is entered, the FindReplaceDirective calls selectNext, so the
    // index needs to become -1. See apps/authoring/editor/find-replace.js.
    // Otherwise, if only the sensitivity is changed, we reset to 0.
    var pattern = diff == null ? '' : Object.keys(diff || {})[0] || '';
    var index = pattern !== state.searchTerm.pattern ? -1 : 0;
    return render(__assign({}, state, { searchTerm: { pattern: pattern, caseSensitive: caseSensitive, index: index, diff: diff } }));
};
/**
 * @name render
 * @param {Object} state
 * @description Renders the search criteria in the state.
 */
var render = function (state) {
    var _a = state.searchTerm, index = _a.index, caseSensitive = _a.caseSensitive, diff = _a.diff, pattern = _a.pattern;
    var es = state.editorState;
    var changedContent = false;
    var _b = find_replace_1.clearHighlights(es.getCurrentContent(), es), content = _b.content, editorState = _b.editorState;
    if (isEmptyDiff(diff) && !pattern) {
        return __assign({}, state, { editorState: editorState });
    }
    var reg = getRegExp(diff, pattern, caseSensitive);
    var newContent = find_replace_1.forEachMatch(content, reg, caseSensitive, function (i, selection, block, _newContent) {
        changedContent = true;
        return draft_js_1.Modifier.applyInlineStyle(_newContent, selection, i === index ? 'HIGHLIGHT_STRONG' : 'HIGHLIGHT');
    });
    if (changedContent) {
        editorState = find_replace_1.quietPush(editorState, newContent);
    }
    return __assign({}, state, { editorState: editorState });
};
exports.default = findReplace;
/**
 * @name getMatches
 * @param {Object} state
 * @description Returns the matching occurences of the search criteria inside the current editor content.
 */
var getMatches = function (state) {
    var content = state.editorState.getCurrentContent();
    var _a = state.searchTerm, caseSensitive = _a.caseSensitive, diff = _a.diff, pattern = _a.pattern;
    var matches = [];
    if (isEmptyDiff(diff) && !pattern) {
        return matches;
    }
    var combinedPattern = getRegExp(diff, pattern, caseSensitive);
    find_replace_1.forEachMatch(content, combinedPattern, caseSensitive, function (i, selection, block, newContent, match) {
        matches.push(match);
        return newContent;
    });
    return matches;
};
var getRegExp = function (diff, pattern, caseSensitive) {
    var reg = pattern ? utils_1.escapeRegExp(pattern) : '';
    // if there is diff make regexp for all keys at once
    // so it will highlight all matches
    if (!isEmptyDiff(diff)) {
        reg = Object.keys(diff)
            .filter(function (_pattern) { return _pattern.length > 0; }) // non empty
            .sort(function (a, b) { return b.length - a.length; }) // longest first
            .map(utils_1.escapeRegExp)
            .join('|');
    }
    return new RegExp(reg, 'g' + (caseSensitive ? '' : 'i'));
};
// test if diff has all keys empty
var isEmptyDiff = function (diff) { return Object.keys(diff || {}).filter(function (key) { return key.length; }).length === 0; };


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var AnnotationInputDefault = /** @class */ (function (_super) {
    __extends(AnnotationInputDefault, _super);
    function AnnotationInputDefault() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnotationInputDefault.prototype.render = function () {
        return this.props.annotationInputComponent;
    };
    return AnnotationInputDefault;
}(react_1.default.Component));
exports.AnnotationInputDefault = AnnotationInputDefault;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var moment_1 = __importDefault(__webpack_require__(5));
var react_redux_1 = __webpack_require__(25);
var actions_1 = __webpack_require__(24);
var draft_js_1 = __webpack_require__(16);
var ng_1 = __importDefault(__webpack_require__(18));
var HighlightsPopupPositioner_1 = __webpack_require__(243);
var UserAvatar_1 = __webpack_require__(91);
var ReactRenderAsync_1 = __webpack_require__(54);
var EditorHighlightsHeader_1 = __webpack_require__(240);
var fluid_rows_1 = __webpack_require__(241);
var fluid_row_1 = __webpack_require__(242);
var utils_1 = __webpack_require__(3);
var editor3StateToHtml_1 = __webpack_require__(88);
var Annotation = /** @class */ (function (_super) {
    __extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Annotation.prototype.render = function () {
        var _a = this.props, annotation = _a.annotation, editorNode = _a.editorNode, highlightId = _a.highlightId, highlightsManager = _a.highlightsManager, annotationTypes = _a.annotationTypes;
        var _showPopup = this.props.showPopup;
        var _b = annotation.data, author = _b.author, avatar = _b.avatar, date = _b.date, msg = _b.msg, annotationType = _b.annotationType;
        var type = annotationTypes.find(function (t) { return t.qcode === annotationType; }).name;
        var relativeDateString = moment_1.default(date).calendar();
        var absoluteDateString = moment_1.default(date).format('MMMM Do YYYY, h:mm:ss a');
        var html = editor3StateToHtml_1.editor3StateToHtml(draft_js_1.convertFromRaw(JSON.parse(msg)));
        var modal = ng_1.default.get('modal');
        var onEdit = function () { return _showPopup(actions_1.PopupTypes.Annotation, { annotation: annotation, highlightId: highlightId }); };
        var onDelete = function () { return modal
            .confirm(utils_1.gettext('The annotation will be deleted. Are you sure?'))
            .then(function () {
            highlightsManager.removeHighlight(highlightId);
        }); };
        var availableActions = [
            {
                text: utils_1.gettext('Edit'),
                icon: 'icon-pencil',
                onClick: onEdit,
            },
            {
                text: utils_1.gettext('Delete'),
                icon: 'icon-trash',
                onClick: onDelete,
            },
        ];
        return (react_1.default.createElement(HighlightsPopupPositioner_1.HighlightsPopupPositioner, { editorNode: editorNode },
            react_1.default.createElement(fluid_rows_1.FluidRows, null,
                react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: false },
                    react_1.default.createElement(EditorHighlightsHeader_1.EditorHighlightsHeader, { availableActions: availableActions },
                        react_1.default.createElement(UserAvatar_1.UserAvatar, { displayName: author, pictureUrl: avatar }),
                        react_1.default.createElement("p", { className: "editor-popup__author-name" }, author),
                        react_1.default.createElement("time", { className: "editor-popup__time", title: relativeDateString }, absoluteDateString)),
                    react_1.default.createElement("div", { className: "editor-popup__content-block" },
                        react_1.default.createElement("div", { className: "editor-popup__info-bar" },
                            react_1.default.createElement("span", { className: "label" }, utils_1.gettext('Annotation'))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("b", null,
                                utils_1.gettext('Annotation type'),
                                ": "),
                            type))),
                react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: true, className: "editor-popup__secondary-content" },
                    react_1.default.createElement("div", { style: { background: '#fff', padding: '1.6rem', paddingBottom: '1rem' } },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: html } }))))));
    };
    return Annotation;
}(react_1.default.Component));
Annotation.propTypes = {
    showPopup: prop_types_1.default.func,
    annotation: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object.isRequired,
    highlightId: prop_types_1.default.string,
    editorNode: prop_types_1.default.object,
    annotationTypes: prop_types_1.default.array.isRequired,
};
var AnnotationWithDependenciesLoaded = ReactRenderAsync_1.connectPromiseResults(function () { return ({
    annotationTypes: ng_1.default.get('metadata').initialize()
        .then(function () { return ng_1.default.get('metadata').values.annotation_types; }),
}); })(Annotation);
exports.AnnotationPopup = react_redux_1.connect(function () { return ({}); }, { showPopup: actions_1.showPopup })(AnnotationWithDependenciesLoaded);


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_textarea_autosize_1 = __importDefault(__webpack_require__(169));
var react_redux_1 = __webpack_require__(25);
var QumuWidget_1 = __webpack_require__(414);
var actions = __importStar(__webpack_require__(24));
var ng_1 = __importDefault(__webpack_require__(18));
var loadIframely_1 = __webpack_require__(541);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
// debounce to avoid multiple widget load calls on initial load
// when it gets executed for every embed block
var loadIframely = lodash_1.debounce(loadIframely_1.loadIframelyEmbedJs, 100);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name EmbedBlockComponent
 * @param {Object} block Information about the block where this component renders.
 * @description This component renders an embed block within the editor, using oEmbed data
 * retrieved from iframe.ly
 */
var EmbedBlockComponent = /** @class */ (function (_super) {
    __extends(EmbedBlockComponent, _super);
    function EmbedBlockComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickDelete = _this.onClickDelete.bind(_this);
        _this.editEmbedHtml = _this.editEmbedHtml.bind(_this);
        _this.onChangeDescription = _this.onChangeDescription.bind(_this);
        return _this;
    }
    /**
     * @name EmbedBlockComponent#runScripts
     * @param {string} html
     * @description Runs and imports all the scripts in the given HTML.
     */
    EmbedBlockComponent.prototype.runScripts = function (html) {
        var tree = $('<div />').html(html);
        tree.find('script').each(function (i, s) {
            if (s.hasAttribute('src')) {
                var url = s.getAttribute('src');
                var async = s.hasAttribute('async');
                if (url.startsWith('http')) {
                    url = url.substring(url.indexOf(':') + 1);
                }
                return $.ajax({ url: url, async: async, dataType: 'script' });
            }
            try {
                // eslint-disable-next-line no-eval
                eval(s.innerHTML);
            }
            catch (e) {
                /* carry on */
            }
        });
    };
    EmbedBlockComponent.prototype.getEntityKey = function () {
        var block = this.props.block;
        return block.getEntityAt(0);
    };
    EmbedBlockComponent.prototype.getBlockKey = function () {
        var block = this.props.block;
        return block.getKey();
    };
    EmbedBlockComponent.prototype.onChangeDescription = function (event) {
        var entityKey = this.getEntityKey();
        var blockKey = this.getBlockKey();
        this.props.mergeEntityDataByKey(blockKey, entityKey, {
            description: event.target.value,
        });
    };
    EmbedBlockComponent.prototype.editEmbedHtml = function () {
        var _this = this;
        var embed = this.data();
        var entityKey = this.getEntityKey();
        var blockKey = this.getBlockKey();
        var modal = ng_1.default.get('modal');
        modal.prompt(utils_1.gettext('Edit embed'), embed.data.html)
            .then(function (html) {
            _this.props.mergeEntityDataByKey(blockKey, entityKey, {
                data: __assign({}, embed.data, { html: html }),
            });
        });
    };
    EmbedBlockComponent.prototype.data = function () {
        var contentState = this.props.contentState;
        var entityKey = this.getEntityKey();
        var entity = contentState.getEntity(entityKey);
        return entity.getData();
    };
    EmbedBlockComponent.prototype.shouldComponentUpdate = function (nextProps) {
        var contentState = nextProps.contentState;
        var entityKey = this.getEntityKey();
        var entity = contentState.getEntity(entityKey);
        var data = entity.getData().data;
        var oldData = this.data();
        return data.html !== oldData.html;
    };
    EmbedBlockComponent.prototype.onClickDelete = function () {
        var _a = this.props, block = _a.block, removeBlock = _a.removeBlock;
        removeBlock(block.getKey());
    };
    EmbedBlockComponent.prototype.componentDidMount = function () {
        var embed = this.data();
        if (embed.data.html.includes('iframe.ly')) {
            loadIframely();
        }
    };
    EmbedBlockComponent.prototype.render = function () {
        var embed = this.data();
        var html = embed.data.html;
        var isQumu = QumuWidget_1.isQumuWidget(html);
        if (isQumu !== true) {
            this.runScripts(html);
        }
        return (react_1.default.createElement("div", { className: "embed-block" },
            react_1.default.createElement("a", { className: "icn-btn embed-block__remove", onMouseDown: this.onClickDelete },
                react_1.default.createElement("i", { className: "icon-close-small" })),
            react_1.default.createElement("a", { className: "icn-btn embed-block__edit", onMouseDown: this.editEmbedHtml },
                react_1.default.createElement("i", { className: "icon-pencil" })),
            isQumu
                ? react_1.default.createElement(QumuWidget_1.QumuWidget, { html: html })
                : react_1.default.createElement("div", { className: "embed-block__wrapper", dangerouslySetInnerHTML: { __html: html } }),
            react_1.default.createElement(react_textarea_autosize_1.default, { placeholder: utils_1.gettext('Description'), onFocus: this.props.setLocked, onClick: this.props.setLocked, className: "image-block__description", value: embed.description || '', onChange: this.onChangeDescription })));
    };
    return EmbedBlockComponent;
}(react_1.default.Component));
exports.EmbedBlockComponent = EmbedBlockComponent;
EmbedBlockComponent.propTypes = {
    block: prop_types_1.default.object.isRequired,
    contentState: prop_types_1.default.object.isRequired,
    removeBlock: prop_types_1.default.func.isRequired,
    mergeEntityDataByKey: prop_types_1.default.func.isRequired,
    setLocked: prop_types_1.default.func.isRequired,
};
var mapDispatchToProps = function (dispatch) { return ({
    removeBlock: function (blockKey) { return dispatch(actions.removeBlock(blockKey)); },
    setLocked: function () { return dispatch(actions.setLocked(true)); },
    mergeEntityDataByKey: function (blockKey, entityKey, valuesToMerge) {
        return dispatch(actions.mergeEntityDataByKey(blockKey, entityKey, valuesToMerge));
    },
}); };
exports.EmbedBlock = react_redux_1.connect(null, mapDispatchToProps)(EmbedBlockComponent);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpellcheckerContextMenu_1 = __webpack_require__(543);
exports.SpellcheckerContextMenu = SpellcheckerContextMenu_1.SpellcheckerContextMenu;
var SpellcheckerDecorator_1 = __webpack_require__(1332);
exports.SpellcheckerDecorator = SpellcheckerDecorator_1.SpellcheckerDecorator;


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var stickElements_1 = __webpack_require__(1330);
var onEveryAnimationFrame_1 = __webpack_require__(1331);
var StickElementsWithTracking = /** @class */ (function () {
    function StickElementsWithTracking(target, source) {
        var preferredPosition = {};
        this.animationManager = new onEveryAnimationFrame_1.OnEveryAnimationFrame(function () {
            var selectedPosition = stickElements_1.stickElements(target, source, preferredPosition);
            if (Object.keys(preferredPosition).length < 1) {
                preferredPosition = selectedPosition;
            }
        });
    }
    StickElementsWithTracking.prototype.destroy = function () {
        this.animationManager.destroy();
    };
    return StickElementsWithTracking;
}());
exports.StickElementsWithTracking = StickElementsWithTracking;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function stickElements(target, source, preferredPosition) {
    var targetRect = target.getBoundingClientRect();
    source.style.position = 'absolute';
    var _a = document.body, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
    // position horizontally
    var placeOnTheLeft = function () {
        source.style.right = '';
        source.style.left = targetRect.left + 'px';
    };
    var placeOnTheRight = function () {
        source.style.left = '';
        source.style.right = (clientWidth - targetRect.right) + 'px';
    };
    var enoughSpaceOnTheLeft = clientWidth > targetRect.left + source.offsetWidth;
    if (preferredPosition.x === 'left') {
        placeOnTheLeft();
    }
    else if (preferredPosition.x === 'right') {
        placeOnTheRight();
    }
    else if (enoughSpaceOnTheLeft) {
        placeOnTheLeft();
    }
    else {
        placeOnTheRight();
    }
    // position vertically
    var placeAtTheTop = function () {
        source.style.top = '';
        source.style.bottom = (clientHeight - targetRect.top) + 'px';
    };
    var placeAtTheBottom = function () {
        source.style.bottom = '';
        source.style.top = (targetRect.top + targetRect.height) + 'px';
    };
    var spaceBelowTarget = clientHeight - targetRect.bottom;
    var enoughSpaceAtTheBottom = spaceBelowTarget > source.offsetHeight;
    if (preferredPosition.y === 'bottom') {
        placeAtTheBottom();
    }
    else if (preferredPosition.y === 'top') {
        placeAtTheTop();
    }
    else if (enoughSpaceAtTheBottom) {
        placeAtTheBottom();
    }
    else {
        placeAtTheTop();
    }
    // return information about selected position
    // so it can be used in the next call
    return {
        x: source.style.left === '' ? 'right' : 'left',
        y: source.style.top === '' ? 'top' : 'bottom',
    };
}
exports.stickElements = stickElements;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OnEveryAnimationFrame = /** @class */ (function () {
    function OnEveryAnimationFrame(callback) {
        this.lastTimer = 0; // dummy value for initial check
        this.loop(callback);
    }
    OnEveryAnimationFrame.prototype.loop = function (callback) {
        var _this = this;
        callback();
        if (this.lastTimer != null) {
            this.lastTimer = window.requestAnimationFrame(function () {
                _this.loop(callback);
            });
        }
    };
    OnEveryAnimationFrame.prototype.destroy = function () {
        window.cancelAnimationFrame(this.lastTimer);
        this.lastTimer = null;
    };
    return OnEveryAnimationFrame;
}());
exports.OnEveryAnimationFrame = OnEveryAnimationFrame;


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(__webpack_require__(15));
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ng_1 = __importDefault(__webpack_require__(18));
var SpellcheckerContextMenu_1 = __webpack_require__(543);
function getElementForPortal() {
    var existingElement = document.querySelector('.spellchecker-suggestions');
    if (existingElement != null) {
        return existingElement;
    }
    else {
        var newElement = document.createElement('div');
        newElement.classList.add('spellchecker-suggestions');
        document.body.appendChild(newElement);
        return newElement;
    }
}
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name SpellcheckerError
 * @param {Array} children the children prop of the component
 * @description This is the component that decorates spellchecker typos.
 */
var SpellcheckerError = /** @class */ (function (_super) {
    __extends(SpellcheckerError, _super);
    function SpellcheckerError(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            menuShowing: false,
            suggestions: [],
        };
        _this.showContextMenu = _this.showContextMenu.bind(_this);
        _this.closeContextMenu = _this.closeContextMenu.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name SpellcheckerError#showContextMenu
     * @param {String} txt The word that suggestions are being showed for.
     * @returns {Function} The event listener
     * @description Creates a new event listener that shows the context menu
     * for the passed word.
     */
    SpellcheckerError.prototype.showContextMenu = function (txt) {
        var _this = this;
        var spellcheck = ng_1.default.get('spellcheck');
        return function (e) {
            e.preventDefault();
            spellcheck.suggest(txt).then(function (suggestions) {
                _this.setState({ menuShowing: true, suggestions: suggestions });
            });
        };
    };
    /**
     * @ngdoc method
     * @name SpellcheckerError#closeContextMenu
     * @description Closes the context menu.
     */
    SpellcheckerError.prototype.closeContextMenu = function () {
        this.setState({ menuShowing: false });
    };
    SpellcheckerError.prototype.componentDidUpdate = function (prevProps, prevState) {
        var menuShowing = this.state.menuShowing;
        if (prevState.menuShowing === menuShowing) {
            return;
        }
        var fn = menuShowing ? 'on' : 'off';
        $(window)[fn]('mousedown', this.closeContextMenu);
    };
    SpellcheckerError.prototype.componentWillUnmount = function () {
        $(window).off('mousedown', this.closeContextMenu);
    };
    SpellcheckerError.prototype.render = function () {
        var _this = this;
        var _a = this.state, menuShowing = _a.menuShowing, suggestions = _a.suggestions;
        var children = this.props.children;
        var word = { text: children[0].props.text, offset: children[0].props.start };
        return (react_1.default.createElement("span", { className: "word-typo", onContextMenu: this.showContextMenu(word.text), ref: function (el) { return _this.wordTypoElement = el; } },
            menuShowing ?
                react_dom_1.default.createPortal(react_1.default.createElement(SpellcheckerContextMenu_1.SpellcheckerContextMenu, { targetElement: this.wordTypoElement, suggestions: suggestions, word: word }), getElementForPortal())
                : null,
            this.props.children));
    };
    return SpellcheckerError;
}(react_1.default.Component));
SpellcheckerError.propTypes = {
    children: prop_types_1.default.array,
};
exports.SpellcheckerDecorator = {
    strategy: spellcheckStrategy,
    component: SpellcheckerError,
};
/**
 * @description The function that defines the strategy to identify ranges of text that
 * should be highlighted as spellchecker typos.
 */
function spellcheckStrategy(contentBlock, callback) {
    var spellcheck = ng_1.default.get('spellcheck');
    var WORD_REGEXP = /[0-9a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF]+/g;
    var text = contentBlock.getText();
    var matchArr;
    var start;
    var regex = WORD_REGEXP;
    // tslint:disable-next-line no-conditional-assignment
    while ((matchArr = regex.exec(text)) !== null) {
        start = matchArr.index;
        if (!spellcheck.isCorrectWord(matchArr[0])) {
            callback(start, start + matchArr[0].length);
        }
    }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var media_1 = __webpack_require__(1334);
var embeds_1 = __webpack_require__(540);
var tables_1 = __webpack_require__(544);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name MediaComponent
 * @param {Object} block The block being rendered.
 * @description Media block renderer component.
 */
var MediaComponent = function (props) {
    var block = props.block, contentState = props.contentState;
    var entityKey = block.getEntityAt(0);
    if (!entityKey) {
        return null;
    }
    var type = contentState.getEntity(entityKey).getType();
    switch (type) {
        case 'MEDIA':
            return react_1.default.createElement(media_1.MediaBlock, __assign({}, props));
        case 'EMBED':
            return react_1.default.createElement(embeds_1.EmbedBlock, __assign({}, props));
        case 'TABLE':
            return react_1.default.createElement(tables_1.TableBlock, __assign({}, props));
        default:
            return null;
    }
};
MediaComponent.propTypes = {
    block: prop_types_1.default.object.isRequired,
    contentState: prop_types_1.default.object.isRequired,
};
function getBlockRenderer(props) {
    return function blockRenderer(block) {
        return block.getType() !== 'atomic' ? null : {
            component: MediaComponent,
            editable: false,
            props: props,
        };
    };
}
exports.getBlockRenderer = getBlockRenderer;


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MediaBlock_1 = __webpack_require__(1335);
exports.MediaBlock = MediaBlock_1.MediaBlock;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var ng_1 = __importDefault(__webpack_require__(18));
var actions = __importStar(__webpack_require__(24));
var react_textarea_autosize_1 = __importDefault(__webpack_require__(169));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
function getTranslationForAssignRights(value) {
    if (value === 'single-usage') {
        return utils_1.gettext('Single Usage');
    }
    else if (value === 'time-restricted') {
        return utils_1.gettext('Time Restricted');
    }
    else if (value === 'indefinite-usage') {
        return utils_1.gettext('Indefinite Usage');
    }
    else {
        return '';
    }
}
var DRAG_SCROLL_BUFFER = 150; // px
var DRAG_SCROLL_BY = 50; // px
var DRAG_SCROLL_TIMEOUT = 200; // ms
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name MediaBlockComponent
 * @param {Function} cropImage Dispatches the crop image action.
 * @param {Object} block Information about the block where this component renders.
 * @description This component renders an image block within the editor.
 */
var MediaBlockComponent = /** @class */ (function (_super) {
    __extends(MediaBlockComponent, _super);
    function MediaBlockComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.onClickDelete = _this.onClickDelete.bind(_this);
        _this.data = _this.data.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.onDrag = _this.onDrag.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name MediaBlockComponent#data
     * @returns {Object} Image data
     * @description Returns the image data.
     */
    MediaBlockComponent.prototype.data = function () {
        var _a = this.props, block = _a.block, contentState = _a.contentState;
        var entityKey = block.getEntityAt(0);
        var entity = contentState.getEntity(entityKey);
        var media = entity.getData().media;
        return media;
    };
    /**
     * @ngdoc method
     * @name MediaBlockComponent#onClick
     * @description Handles clicking on the image event. Dispatches the crop image
     * action.
     */
    MediaBlockComponent.prototype.onClick = function (tab) {
        var _a = this.props, block = _a.block, cropImage = _a.cropImage, contentState = _a.contentState;
        var entityKey = block.getEntityAt(0);
        var entity = contentState.getEntity(entityKey);
        var data = entity.getData();
        var isNew = false;
        var showMetadata = true;
        var defaultTab = tab;
        cropImage(entityKey, data, { isNew: isNew, showMetadata: showMetadata, defaultTab: defaultTab });
    };
    /**
     * @ngdoc method
     * @name MediaBlockComponent#onClickDelete
     * @description Handles clicking on the delete button. Dispatches the
     * remove block action.
     */
    MediaBlockComponent.prototype.onClickDelete = function () {
        var _a = this.props, block = _a.block, removeBlock = _a.removeBlock;
        removeBlock(block.getKey());
    };
    /**
     * @ngdoc method
     * @name MediaBlockComponent#onChange
     * @description Triggered (debounced) when the image caption input is edited.
     */
    MediaBlockComponent.prototype.onChange = function (_a) {
        var target = _a.target;
        var _b = this.props, block = _b.block, changeCaption = _b.changeCaption;
        var entityKey = block.getEntityAt(0);
        changeCaption(entityKey, target.value, target.placeholder);
    };
    MediaBlockComponent.prototype.onDragStart = function (event) {
        event.dataTransfer.setData('superdesk/editor3-block', this.props.block.getKey());
    };
    MediaBlockComponent.prototype.componentDidMount = function () {
        this.container = document.getElementsByClassName('page-content-container')[0];
    };
    MediaBlockComponent.prototype.componentWillUnmount = function () {
        this.container = null;
    };
    MediaBlockComponent.prototype.onDrag = function (event) {
        var _this = this;
        var y = event.pageY;
        if (!this.scrollTimeout) {
            this.scrollTimeout = setTimeout(function () {
                // firefox does not provide pageY on drag event
                // so there is a window listener which populates the value
                // but it runs only after drag event so it must read it here
                if (!y && window['dragPageY']) {
                    y = window['dragPageY'];
                }
                if (y < DRAG_SCROLL_BUFFER) {
                    _this.container.scrollTop -= DRAG_SCROLL_BY;
                }
                else if (y + DRAG_SCROLL_BUFFER > $(window).height()) {
                    _this.container.scrollTop += DRAG_SCROLL_BY;
                }
                _this.scrollTimeout = null;
            }, DRAG_SCROLL_TIMEOUT);
        }
    };
    MediaBlockComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, setLocked = _a.setLocked, showTitle = _a.showTitle, readOnly = _a.readOnly;
        var data = this.data();
        var rendition = data.renditions.baseImage || data.renditions.viewImage || data.renditions.original;
        var alt = data.alt_text || data.description_text || data.caption;
        var mediaType = data.type;
        var features = ng_1.default.get('config').features;
        var editable = !readOnly && !data.fetch_endpoint &&
            (data._type !== 'externalsource'
                || lodash_1.get(features, 'editFeaturedImage', true));
        var removable = !readOnly;
        var draggable = removable;
        return (react_1.default.createElement("div", { className: "image-block", onClick: function (e) { return e.stopPropagation(); }, draggable: draggable, onDragStart: this.onDragStart, onDrag: this.onDrag },
            removable && (react_1.default.createElement("a", { className: "icn-btn image-block__remove", onClick: this.onClickDelete },
                react_1.default.createElement("i", { className: "icon-close-small" }))),
            react_1.default.createElement("div", { className: "image-block__wrapper" },
                showTitle ?
                    react_1.default.createElement(react_textarea_autosize_1.default, { placeholder: utils_1.gettext('Title'), onFocus: setLocked, onClick: setLocked, className: "image-block__title", value: data.headline, onChange: this.onChange }) : null,
                mediaType === 'picture' &&
                    react_1.default.createElement("div", { className: "image-block__image" },
                        react_1.default.createElement("div", { className: "image-block__image-overlay" },
                            react_1.default.createElement("div", { className: "image-block__metadata image-block__metadata--top-overlay" },
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Title:'),
                                        ' '),
                                    data.headline || utils_1.gettext('[No Value]'))),
                            editable && (react_1.default.createElement("div", { className: "image-block__icons-block" },
                                react_1.default.createElement("a", { className: "image-block__image-action", "data-sd-tooltip": utils_1.gettext('Edit metadata'), onClick: function () {
                                        _this.onClick('view');
                                    } },
                                    react_1.default.createElement("i", { className: "icon-pencil" })),
                                react_1.default.createElement("a", { className: "image-block__image-action", "data-sd-tooltip": utils_1.gettext('Edit image'), onClick: function () {
                                        _this.onClick('image-edit');
                                    } },
                                    react_1.default.createElement("i", { className: "icon-switches" })),
                                react_1.default.createElement("a", { className: "image-block__image-action", "data-sd-tooltip": utils_1.gettext('Edit crops'), onClick: function () {
                                        _this.onClick('crop');
                                    } },
                                    react_1.default.createElement("i", { className: "icon-crop" })))),
                            react_1.default.createElement("div", { className: "image-block__metadata image-block__metadata--bottom-overlay" },
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Alt text:'),
                                        ' '),
                                    data.alt_text || utils_1.gettext('[No Value]')),
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Credit:'),
                                        ' '),
                                    data.byline || utils_1.gettext('[No Value]')),
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Copyright holder:'),
                                        ' '),
                                    data.copyrightholder || utils_1.gettext('[No Value]')),
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Assign rights:'),
                                        ' '),
                                    getTranslationForAssignRights(data.usageterms)
                                        || utils_1.gettext('[No Value]')),
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("em", null,
                                        utils_1.gettext('Copyright notice:'),
                                        ' '),
                                    data.copyrightnotice || utils_1.gettext('[No Value]')))),
                        react_1.default.createElement("img", { src: rendition.href, alt: alt })),
                mediaType === 'video' &&
                    react_1.default.createElement("div", null,
                        showTitle === true ? null : (react_1.default.createElement(react_textarea_autosize_1.default, { placeholder: utils_1.gettext('Title'), onFocus: setLocked, onClick: setLocked, className: "image-block__title", value: data.headline, onChange: this.onChange })),
                        react_1.default.createElement("video", { controls: true, src: rendition.href, width: "100%", height: "100%" }),
                        react_1.default.createElement("div", { className: "image-block__metadata image-block__metadata--side-marg0" },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Credit:'),
                                    ' '),
                                data.byline || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Copyright holder:'),
                                    ' '),
                                data.copyrightholder || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Assign rights:'),
                                    ' '),
                                getTranslationForAssignRights(data.usageterms)
                                    || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Copyright notice:'),
                                    ' '),
                                data.copyrightnotice || utils_1.gettext('[No Value]')))),
                mediaType === 'audio' &&
                    react_1.default.createElement("div", null,
                        showTitle === true ? null : (react_1.default.createElement(react_textarea_autosize_1.default, { placeholder: utils_1.gettext('Title'), onFocus: setLocked, onClick: setLocked, className: "image-block__title", value: data.headline, onChange: this.onChange })),
                        react_1.default.createElement("audio", { controls: true, src: rendition.href, style: { width: '100%' } }),
                        react_1.default.createElement("div", { className: "image-block__metadata image-block__metadata--side-marg0" },
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Credit:'),
                                    ' '),
                                data.byline || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Copyright holder:'),
                                    ' '),
                                data.copyrightholder || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Assign rights:'),
                                    ' '),
                                getTranslationForAssignRights(data.usageterms)
                                    || utils_1.gettext('[No Value]')),
                            react_1.default.createElement("span", null,
                                react_1.default.createElement("em", null,
                                    utils_1.gettext('Copyright notice:'),
                                    ' '),
                                data.copyrightnotice || utils_1.gettext('[No Value]')))),
                react_1.default.createElement(react_textarea_autosize_1.default, { placeholder: utils_1.gettext('Caption'), onFocus: setLocked, onClick: setLocked, className: "image-block__description", value: data.description_text, onChange: this.onChange }),
                editable && (mediaType === 'audio' || mediaType === 'video') &&
                    react_1.default.createElement("div", { className: "image-block__action-bar" },
                        react_1.default.createElement("a", { className: "btn btn--hollow btn--small", onClick: this.onClick },
                            react_1.default.createElement("span", null, utils_1.gettext('Edit metadata')))))));
    };
    return MediaBlockComponent;
}(react_1.default.Component));
exports.MediaBlockComponent = MediaBlockComponent;
MediaBlockComponent.propTypes = {
    cropImage: prop_types_1.default.func.isRequired,
    removeBlock: prop_types_1.default.func.isRequired,
    changeCaption: prop_types_1.default.func.isRequired,
    setLocked: prop_types_1.default.func.isRequired,
    block: prop_types_1.default.object.isRequired,
    contentState: prop_types_1.default.object.isRequired,
    showTitle: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    blockProps: prop_types_1.default.object.isRequired,
};
var mapStateToProps = function (state) { return ({
    readOnly: state.readOnly,
    showTitle: state.showTitle,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    cropImage: function (entityKey, entityData, options) { return dispatch(actions.cropImage(entityKey, entityData, options)); },
    removeBlock: function (blockKey) { return dispatch(actions.removeBlock(blockKey)); },
    changeCaption: function (entityKey, newCaption, field) { return dispatch(actions.changeImageCaption(entityKey, newCaption, field)); },
    setLocked: function () { return dispatch(actions.setLocked(true)); },
}); };
exports.MediaBlock = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MediaBlockComponent);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var actions = __importStar(__webpack_require__(24));
var react_redux_1 = __webpack_require__(25);
var _1 = __webpack_require__(544);
var draft_js_1 = __webpack_require__(16);
var table_1 = __webpack_require__(112);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name TableBlockComponent
 * @description Handles a cell in the table, as well as the containing editor.
 */
var TableBlockComponent = /** @class */ (function (_super) {
    __extends(TableBlockComponent, _super);
    function TableBlockComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onCellChange = _this.onCellChange.bind(_this);
        _this.getCellEditorState = _this.getCellEditorState.bind(_this);
        _this.getData = _this.getData.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onHistoryAction = _this.onHistoryAction.bind(_this);
        _this.onRedo = _this.onRedo.bind(_this);
        _this.onUndo = _this.onUndo.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name TableBlockComponent#setCell
     * @param {Number} row The row of the cell in the table
     * @param {Number} col The column of the cell in the table
     * @param {Object} cellEditorState The state of the editor within the cell
     * @description Updates data about this cell inside the entity for this atomic
     * block.
     */
    TableBlockComponent.prototype.onCellChange = function (row, col, cellEditorState) {
        var lastChangeType = cellEditorState.getLastChangeType();
        var _a = this.props, block = _a.block, setActiveCell = _a.setActiveCell, editorState = _a.editorState, parentOnChange = _a.parentOnChange;
        var _b = table_1.setCell(this.getData(), row, col, cellEditorState), data = _b.data, needUpdate = _b.needUpdate, forceUpdate = _b.forceUpdate;
        var newEditorState = table_1.setData(editorState, block, data, lastChangeType);
        var currentStyle = cellEditorState.getCurrentInlineStyle().toArray();
        var selection = cellEditorState.getSelection();
        if (needUpdate) {
            parentOnChange(newEditorState, forceUpdate);
        }
        setActiveCell(row, col, block.getKey(), currentStyle, selection.toJS());
    };
    TableBlockComponent.prototype.getCellEditorState = function (data, i, j) {
        var _a = this.props.activeCell || {}, currentStyle = _a.currentStyle, selection = _a.selection;
        return table_1.getCell(data, i, j, currentStyle, selection);
    };
    /**
     * @ngdoc method
     * @name TableBlockComponent#data
     * @description Returns the data contained in the entity of this atomic block.
     * @return {Object}
     */
    TableBlockComponent.prototype.getData = function () {
        var _a = this.props, block = _a.block, editorState = _a.editorState;
        return table_1.getData(editorState.getCurrentContent(), block.getKey());
    };
    TableBlockComponent.prototype.onFocus = function (i, j, currentStyle, selection) {
        var _a = this.props, setActiveCell = _a.setActiveCell, block = _a.block;
        var newSelection = selection.merge({ hasFocus: true });
        setActiveCell(i, j, block.getKey(), currentStyle, newSelection.toJS());
    };
    // onMouseDown is used in the main editor to set focus and stop table editing
    TableBlockComponent.prototype.onMouseDown = function (event) {
        event.stopPropagation();
    };
    TableBlockComponent.prototype.onHistoryAction = function (action) {
        var _a = this.props, editorState = _a.editorState, parentOnChange = _a.parentOnChange, block = _a.block, setActiveCell = _a.setActiveCell, activeCell = _a.activeCell;
        var newEditorState = draft_js_1.EditorState[action](editorState);
        var data = table_1.getData(newEditorState.getCurrentContent(), block.getKey());
        var cellEditorState = this.getCellEditorState(data, activeCell.i, activeCell.j);
        var currentStyle = cellEditorState.getCurrentInlineStyle().toArray();
        var selection = cellEditorState.getSelection().toJS();
        var selectedBlock = cellEditorState.getCurrentContent().getBlockForKey(selection.anchorKey);
        var overflow = selection.anchorOffset > selectedBlock.getLength();
        if (overflow) {
            selection.anchorOffset = selection.focusOffset = selectedBlock.getLength();
        }
        parentOnChange(newEditorState, false);
        setActiveCell(activeCell.i, activeCell.j, block.getKey(), currentStyle, selection);
    };
    TableBlockComponent.prototype.onUndo = function () {
        this.onHistoryAction('undo');
    };
    TableBlockComponent.prototype.onRedo = function () {
        this.onHistoryAction('redo');
    };
    TableBlockComponent.prototype.render = function () {
        var _this = this;
        var data = this.getData();
        var numRows = data.numRows, numCols = data.numCols, withHeader = data.withHeader;
        var cx = classnames_1.default({
            'table-block': true,
            'table-header': withHeader,
        });
        return (react_1.default.createElement("div", { className: cx, onMouseDown: this.onMouseDown },
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null, Array.from(new Array(numRows)).map(function (_, i) {
                    return react_1.default.createElement("tr", { key: "col-" + i + "-" + numRows + "-" + numCols }, Array.from(new Array(numCols)).map(function (__, j) {
                        return react_1.default.createElement(_1.TableCell, { key: "cell-" + i + "-" + j + "-" + numRows + "-" + numCols, readOnly: _this.props.readOnly, editorState: _this.getCellEditorState(data, i, j), onChange: _this.onCellChange.bind(_this, i, j), onUndo: _this.onUndo.bind(_this), onRedo: _this.onRedo.bind(_this), onFocus: _this.onFocus.bind(_this, i, j) });
                    }));
                })))));
    };
    return TableBlockComponent;
}(react_1.default.Component));
exports.TableBlockComponent = TableBlockComponent;
var mapDispatchToProps = function (dispatch) { return ({
    parentOnChange: function (editorState, force) { return dispatch(actions.changeEditorState(editorState, force)); },
    setActiveCell: function (i, j, key, currentStyle, selection) { return dispatch(actions.setActiveCell(i, j, key, currentStyle, selection)); },
}); };
var mapStateToProps = function (state) { return ({
    editorState: state.editorState,
    readOnly: state.readOnly,
    activeCell: state.activeCell,
}); };
exports.TableBlock = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TableBlockComponent);


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var draft_js_1 = __webpack_require__(16);
var entityUtils_1 = __webpack_require__(79);
var customStyleMap_1 = __webpack_require__(545);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name TableCell
 * @param contentState {Object}
 * @param onChange {Function}
 * @param onFocus {Function}
 * @description Handles a cell in the table, as well as the containing editor.
 */
var TableCell = /** @class */ (function (_super) {
    __extends(TableCell, _super);
    function TableCell(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.handleKeyCommand = _this.handleKeyCommand.bind(_this);
        _this.keyBindingFn = _this.keyBindingFn.bind(_this);
        _this.state = { editorState: props.editorState };
        return _this;
    }
    /**
     * @ngdoc method
     * @name TableCell#keyBindingFn
     * @param {Event} e
     * @description DraftJS key binding function.
     */
    TableCell.prototype.keyBindingFn = function (e) {
        if (e.ctrlKey && e.key === 'z') {
            return 'parent-undo';
        }
        if (e.ctrlKey && e.key === 'y') {
            return 'parent-redo';
        }
        if (e.ctrlKey && e.key === 'l') {
            return 'toggle-link';
        }
        return draft_js_1.getDefaultKeyBinding(e);
    };
    TableCell.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            editorState: nextProps.editorState,
        });
    };
    /**
     * @ngdoc method
     * @name TableCell#handleKeyCommand
     * @param {string} command
     * @description DraftJS key command handler.
     */
    TableCell.prototype.handleKeyCommand = function (command) {
        var editorState = this.state.editorState;
        var newState;
        switch (command) {
            case 'parent-undo':
                this.props.onUndo();
                return 'handled';
            case 'parent-redo':
                this.props.onRedo();
                return 'handled';
            case 'toggle-link':
                newState = entityUtils_1.getSelectedEntityType(this.state.editorState) === 'LINK'
                    ? this.removeLink()
                    : this.addLink();
                break;
            default:
                newState = draft_js_1.RichUtils.handleKeyCommand(editorState, command);
                break;
        }
        if (newState) {
            this.onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };
    /**
     * @ngdoc method
     * @name TableCell#addLink
     * @description Adds a new link on top of the current selection. If the selection
     * is collapsed, no action is taken.
     */
    TableCell.prototype.addLink = function () {
        var editorState = this.state.editorState;
        // can't add a link if selection is collapsed
        if (editorState.getSelection().isCollapsed()) {
            return editorState;
        }
        // eslint-disable-next-line no-alert
        var url = prompt('Enter a URL');
        var contentState = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', { url: url });
        return draft_js_1.RichUtils.toggleLink(editorState, editorState.getSelection(), contentState.getLastCreatedEntityKey());
    };
    /**
     * @ngdoc method
     * @name TableCell#removeLink
     * @description Removes the link behind the selection focus.
     */
    TableCell.prototype.removeLink = function () {
        var editorState = this.state.editorState;
        var stateAfterChange = editorState;
        entityUtils_1.getSelectedEntityRange(editorState, function (start, end) {
            var selection = editorState.getSelection();
            var entitySelection = selection.merge({
                anchorOffset: start,
                focusOffset: end,
            });
            stateAfterChange = draft_js_1.RichUtils.toggleLink(editorState, entitySelection, null);
        });
        return stateAfterChange;
    };
    /**
     * @ngdoc method
     * @name TableCell#onChange
     * @param {Object} editorState the new editor state.
     * @description Triggered on changes to the cell's state.
     */
    TableCell.prototype.onChange = function (editorState) {
        var _this = this;
        var selection = editorState.getSelection();
        if (!selection.getHasFocus()) {
            this.setState({ editorState: editorState });
            return;
        }
        this.setState({ editorState: editorState }, function () { return _this.props.onChange(editorState); });
    };
    TableCell.prototype.onFocus = function (event) {
        var editorState = this.state.editorState;
        var selection = editorState.getSelection();
        var currentStyle = editorState.getCurrentInlineStyle().toArray();
        event.stopPropagation();
        this.props.onFocus(currentStyle, selection);
    };
    TableCell.prototype.render = function () {
        var editorState = this.state.editorState;
        var readOnly = this.props.readOnly;
        return (react_1.default.createElement("td", { onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement(draft_js_1.Editor, { onFocus: this.onFocus, editorState: editorState, customStyleMap: customStyleMap_1.customStyleMap, handleKeyCommand: this.handleKeyCommand, readOnly: readOnly, onChange: this.onChange, keyBindingFn: this.keyBindingFn })));
    };
    return TableCell;
}(react_1.default.Component));
exports.TableCell = TableCell;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable max-depth */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var immutable_1 = __webpack_require__(51);
var from_html_1 = __webpack_require__(124);
var Suggestions = __importStar(__webpack_require__(133));
var inlineStyles_1 = __webpack_require__(113);
var editor3CustomData_1 = __webpack_require__(48);
var author_1 = __webpack_require__(134);
var htmlComesFromDraftjsEditor_1 = __webpack_require__(1339);
var Editor3Component_1 = __webpack_require__(194);
function removeMediaFromHtml(htmlString) {
    var element = document.createElement('div');
    element.innerHTML = htmlString;
    Array.from(element.querySelectorAll('img,audio,video')).forEach(function (mediaElement) {
        mediaElement.remove();
    });
    return element.innerHTML;
}
function pasteContentFromOpenEditor(html, editorState, editorKey, onChange, editorFormat) {
    if (html.includes(editorKey)) { // comes from the same editor
        return 'not-handled';
    }
    var _loop_1 = function (key) {
        if (html.includes(key)) {
            var editor = window[Editor3Component_1.EDITOR_GLOBAL_REFS][key];
            if (editor) {
                var internalClipboard = editor.getClipboard();
                if (internalClipboard) {
                    var blocksArray_1 = [];
                    internalClipboard.forEach(function (b) { return blocksArray_1.push(b); });
                    var contentState = draft_js_1.ContentState.createFromBlockArray(blocksArray_1);
                    var editorWithContent = insertContentInState(editorState, contentState, editorFormat);
                    onChange(editorWithContent);
                    return { value: 'handled' };
                }
            }
        }
    };
    for (var key in window[Editor3Component_1.EDITOR_GLOBAL_REFS]) {
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return 'not-handled';
}
/**
 * @ngdoc method
 * @name handlePastedText
 * @param {string} text Text content of paste.
 * @param {string=} _html HTML content of paste.
 * @returns {Boolean} True if this method took paste into its own hands.
 * @description Handles pasting into the editor, in cases where the content contains
 * atomic blocks that need special handling in editor3.
 */
function handlePastedText(text, _html) {
    var author = author_1.getCurrentAuthor();
    var html = _html;
    if (typeof html === 'string') {
        html = removeMediaFromHtml(html);
    }
    var _a = this.props, editorState = _a.editorState, suggestingMode = _a.suggestingMode, onPasteFromSuggestingMode = _a.onPasteFromSuggestingMode, onChange = _a.onChange, editorFormat = _a.editorFormat;
    if (!html && !text) {
        return 'handled';
    }
    if (suggestingMode) {
        if (!Suggestions.allowEditSuggestionOnLeft(editorState, author)
            && !Suggestions.allowEditSuggestionOnRight(editorState, author)) {
            return 'handled';
        }
        var content = html ? from_html_1.getContentStateFromHtml(html) : draft_js_1.ContentState.createFromText(text);
        onPasteFromSuggestingMode(content);
        return 'handled';
    }
    if (html &&
        pasteContentFromOpenEditor(html, editorState, this.editorKey, onChange, editorFormat) === 'handled') {
        return 'handled';
    }
    if (htmlComesFromDraftjsEditor_1.htmlComesFromDraftjsEditor(html)) {
        return 'not-handled';
    }
    return processPastedHtml(html || text, editorState, onChange, editorFormat);
}
exports.handlePastedText = handlePastedText;
function insertContentInState(editorState, pastedContent, editorFormat) {
    var _pastedContent = pastedContent;
    var blockMap = _pastedContent.getBlockMap();
    var hasAtomicBlocks = blockMap.some(function (block) { return block.getType() === 'atomic'; });
    var acceptedInlineStyles = Object.keys(inlineStyles_1.inlineStyles)
        .filter(function (style) { return editorFormat.includes(style); })
        .map(function (style) { return inlineStyles_1.inlineStyles[style]; });
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var blocks = [];
    if (hasAtomicBlocks) {
        contentState = draft_js_1.Modifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
        selection = contentState.getSelectionAfter();
    }
    _pastedContent = inlineStyles_1.sanitizeContent(draft_js_1.EditorState.createWithContent(_pastedContent), acceptedInlineStyles)
        .getCurrentContent();
    blockMap.forEach(function (block) {
        if (!hasAtomicBlocks || block.getType() !== 'atomic') {
            return blocks.push(block);
        }
        var entityKey = block.getEntityAt(0);
        var entity = _pastedContent.getEntity(entityKey);
        contentState = contentState.addEntity(entity);
        blocks = blocks.concat(atomicBlock(block.getData(), contentState.getLastCreatedEntityKey()));
    });
    if (hasAtomicBlocks) {
        contentState = draft_js_1.Modifier.setBlockType(contentState, selection, 'atomic');
        blocks = blocks.concat(emptyBlock()); // add empty block to ensure writting afterwards
    }
    var newBlockMap = immutable_1.OrderedMap(blocks.map(function (b) { return ([b.getKey(), b]); }));
    var customData = editor3CustomData_1.getAllCustomDataFromEditor(editorState);
    // for the first block recover the initial block data because on replaceWithFragment the block data is
    // replaced with the data from pasted fragment
    var editorStateWithCustomData = editor3CustomData_1.setAllCustomDataForEditor(editorState, customData);
    var newContent = draft_js_1.Modifier.replaceWithFragment(editorStateWithCustomData.getCurrentContent(), editorState.getSelection(), newBlockMap);
    var nextEditorState = draft_js_1.EditorState.push(editorStateWithCustomData, newContent, 'insert-fragment');
    return nextEditorState;
}
exports.insertContentInState = insertContentInState;
// Checks if there are atomic blocks in the paste content. If there are, we need to set
// the 'atomic' block type using the Modifier tool and add these entities to the
// contentState.
function processPastedHtml(html, editorState, onChange, editorFormat) {
    var pastedContent = from_html_1.getContentStateFromHtml(html);
    var editorWithPastedText = insertContentInState(editorState, pastedContent, editorFormat);
    onChange(editorWithPastedText);
    return 'handled';
}
// Returns an empty block.
var emptyBlock = function () { return new draft_js_1.ContentBlock({
    key: draft_js_1.genKey(), type: 'unstyled', text: '', characterList: immutable_1.List(),
}); };
// Returns an atomic block with the given data, linked to the given entity key.
var atomicBlock = function (data, entity) { return new draft_js_1.ContentBlock({
    key: draft_js_1.genKey(), type: 'atomic', text: ' ',
    characterList: immutable_1.List([draft_js_1.CharacterMetadata.create({ entity: entity })]),
    data: data,
}); };


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlComesFromDraftjsEditor = function (html) { return new DOMParser().parseFromString(html, 'text/html')
    .body.querySelector('[data-offset-key]') != null; };


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var draft_js_1 = __webpack_require__(16);
var react_dom_1 = __webpack_require__(15);
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var immutable_1 = __webpack_require__(51);
var comments_1 = __webpack_require__(494);
var SuggestionPopup_1 = __webpack_require__(1341);
var annotations_1 = __webpack_require__(528);
var highlightsConfig_1 = __webpack_require__(46);
var Highlights = __importStar(__webpack_require__(41));
/**
 * @ngdoc react
 * @name HighlightsPopup
 * @description HighlightsPopup is a popup showing information about the highlight
 * that the cursor is on. Based on the highlight type, it renders the appropriate
 * component. Check the component() method for more information. HighlightsPopup
 * also handles positioning the popup relative to the editor's position and hiding
 * it when a user clicks outside the editor/popup context.
 */
var HighlightsPopup = /** @class */ (function (_super) {
    __extends(HighlightsPopup, _super);
    function HighlightsPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.createHighlight = _this.createHighlight.bind(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name HighlightsPopup#component
     * @description component returns the popup element to be rendered.
     * @returns {JSX}
     */
    HighlightsPopup.prototype.component = function () {
        var _this = this;
        var store = this.context.store;
        var highlightsAndSuggestions = [];
        var data;
        if (this.styleBasedHighlightsExist()) {
            this.getInlineStyleForCollapsedSelection()
                .filter(this.props.highlightsManager.styleNameBelongsToHighlight)
                .forEach(function (styleName) {
                var highlightType = _this.props.highlightsManager.getHighlightTypeFromStyleName(styleName);
                if (highlightsConfig_1.suggestionsTypes.indexOf(highlightType) !== -1) {
                    data = Highlights.getSuggestionData(_this.props.editorState, styleName);
                }
                else {
                    data = _this.props.highlightsManager.getHighlightData(styleName);
                }
                highlightsAndSuggestions = highlightsAndSuggestions.concat([
                    {
                        type: highlightType,
                        value: data,
                        highlightId: styleName,
                    },
                ]);
            });
        }
        // We need to create a new provider here because this component gets rendered
        // outside the editor tree and loses context.
        return (react_1.default.createElement(react_redux_1.Provider, { store: store },
            react_1.default.createElement("div", null, highlightsAndSuggestions
                .map(function (obj, i) { return (react_1.default.createElement("div", { key: i }, _this.createHighlight(obj.type, obj.value, obj.highlightId))); }))));
    };
    /**
     * @ngdoc method
     * @name HighlightsPopup#createHighlight
     * @param {String} type Highlight Type
     * @description Renders the active highlight of the given type
     * @returns {JSX}
     */
    HighlightsPopup.prototype.createHighlight = function (type, h, highlightId) {
        if (type === 'ANNOTATION') {
            return (react_1.default.createElement(annotations_1.AnnotationPopup, { annotation: h, highlightId: highlightId, highlightsManager: this.props.highlightsManager, editorNode: this.props.editorNode }));
        }
        else if (type === 'COMMENT') {
            return (react_1.default.createElement(comments_1.CommentPopup, { comment: h, highlightId: highlightId, highlightsManager: this.props.highlightsManager, onChange: this.props.onChange, editorState: this.props.editorState, editorNode: this.props.editorNode }));
        }
        else if (highlightsConfig_1.suggestionsTypes.indexOf(type) !== -1) {
            return (react_1.default.createElement(SuggestionPopup_1.SuggestionPopup, { suggestion: h, editorNode: this.props.editorNode }));
        }
        else {
            console.error('Invalid highlight type in HighlightsPopup: ', type);
        }
    };
    HighlightsPopup.prototype.styleBasedHighlightsExist = function () {
        return this.getInlineStyleForCollapsedSelection()
            .some(this.props.highlightsManager.styleNameBelongsToHighlight);
    };
    /**
     * @ngdoc method
     * @name HighlightsPopup#renderCustom
     * @description Renders the popup into the app's React popup placeholder
     * and creates a document click handler which will hide the popup when
     * clicks occur outside of it.
     */
    HighlightsPopup.prototype.renderCustom = function () {
        // force unmount the existing component so it's rendered again instead of being updated
        // when updating there are issues with positioning caused by
        // not being to determine the position of selected text
        // which may or may not be related to the implementation of draftjs' getVisibleSelectionRect
        react_dom_1.render(react_1.default.createElement("div", null), document.getElementById('react-placeholder'));
        react_dom_1.render(this.component(), document.getElementById('react-placeholder'));
        document.addEventListener('click', this.onDocumentClick, {
            // required in order to prevent closing the popup when you click an element which is INSIDE the popup
            // but is being removed after clicking
            capture: true,
        });
        this.rendered = true;
    };
    /**
     * @ngdoc method
     * @name HighlightsPopup#unmountCustom
     * @description Unmounts the popup.
     */
    HighlightsPopup.prototype.unmountCustom = function () {
        react_dom_1.unmountComponentAtNode(document.getElementById('react-placeholder'));
        document.removeEventListener('click', this.onDocumentClick);
        this.rendered = false;
    };
    /**
     * @ngdoc method
     * @name HighlightsPopup#onDocumentClick
     * @param {Event} e
     * @description Triggered when the document is clicked. It checks if the click
     * occurred on the popup or on the editor, and if it didn't, it unmounts the
     * component.
     */
    HighlightsPopup.prototype.onDocumentClick = function (e) {
        var t = $(e.target);
        var editorNode = this.props.editorNode;
        var onPopup = t.closest('.editor-popup').length || t.closest('.mentions-input__suggestions').length;
        var onEditor = t.closest(editorNode).length;
        var onModal = t.closest('.modal__dialog');
        if (!onPopup && !onEditor && !onModal) {
            // if the click occurred outside the editor, the popup and the modal, we close it
            this.unmountCustom();
        }
    };
    HighlightsPopup.prototype.shouldComponentUpdate = function (nextProps) {
        var nextSelection = nextProps.editorState.getSelection();
        var selection = this.props.editorState.getSelection();
        var hadHighlightsChanged = this.props.highlightsManager.hadHighlightsChanged(this.props.editorState, nextProps.editorState);
        var cursorMoved = nextSelection.getAnchorOffset() !== selection.getAnchorOffset() ||
            nextSelection.getAnchorKey() !== selection.getAnchorKey();
        return cursorMoved || hadHighlightsChanged;
    };
    HighlightsPopup.prototype.getInlineStyleForCollapsedSelection = function () {
        var editorState = this.props.editorState;
        var selection = editorState.getSelection();
        var content = editorState.getCurrentContent();
        if (selection.isCollapsed() === false) {
            return immutable_1.List();
        }
        var blockKey = selection.getStartKey();
        var block = content.getBlockForKey(blockKey);
        var offset = selection.getStartOffset();
        if (block.getLength() === offset) {
            return immutable_1.List();
        }
        var inlineStyle = block.getInlineStyleAt(offset);
        return inlineStyle;
    };
    HighlightsPopup.prototype.shouldRender = function () {
        if (this.styleBasedHighlightsExist()) {
            return true;
        }
        return false;
    };
    HighlightsPopup.prototype.componentDidUpdate = function () {
        var _this = this;
        // Waiting one cycle allows the selection to be rendered in the browser
        // so that we can correctly retrieve its position.
        setTimeout(function () { return _this.shouldRender() ? _this.renderCustom() : _this.unmountCustom(); }, 0);
    };
    HighlightsPopup.prototype.componentWillUnmount = function () {
        if (this.rendered) {
            this.unmountCustom();
        }
    };
    HighlightsPopup.prototype.render = function () {
        return null;
    };
    return HighlightsPopup;
}(react_1.default.Component));
exports.HighlightsPopup = HighlightsPopup;
HighlightsPopup.contextTypes = {
    store: prop_types_1.default.object,
};
HighlightsPopup.propTypes = {
    editorState: prop_types_1.default.instanceOf(draft_js_1.EditorState),
    editorNode: prop_types_1.default.object,
    highlightsManager: prop_types_1.default.object.isRequired,
    onChange: prop_types_1.default.func.isRequired,
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_redux_1 = __webpack_require__(25);
var lodash_1 = __webpack_require__(2);
var moment_1 = __importDefault(__webpack_require__(5));
var ng_1 = __importDefault(__webpack_require__(18));
var components_1 = __webpack_require__(23);
var actions_1 = __webpack_require__(24);
var Highlights = __importStar(__webpack_require__(41));
var HighlightsPopupPositioner_1 = __webpack_require__(243);
var UserAvatar_1 = __webpack_require__(91);
var fluid_rows_1 = __webpack_require__(241);
var fluid_row_1 = __webpack_require__(242);
var EditorHighlightsHeader_1 = __webpack_require__(240);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.core.editor3
 * @name SuggestionPopup
 * @param {Object} suggestion SuggestionPopup data.
 * @description Displays author, date and suggestion text. Allows accepting or declining a suggestion.
 */
var Suggestion = /** @class */ (function (_super) {
    __extends(Suggestion, _super);
    function Suggestion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            author: null,
            error: null,
        };
        _this.onAccept = _this.onAccept.bind(_this);
        _this.onReject = _this.onReject.bind(_this);
        return _this;
    }
    Suggestion.prototype.componentDidMount = function () {
        var _this = this;
        ng_1.default.get('api')('users').getById(this.props.suggestion.author)
            .then(function (author) {
            _this.setState({ author: author });
        })
            .catch(function (error) {
            _this.setState({ error: utils_1.gettext('An error occured, please try again.') });
        });
    };
    Suggestion.prototype.onAccept = function () {
        this.props.acceptSuggestion(this.props.suggestion);
    };
    Suggestion.prototype.onReject = function () {
        this.props.rejectSuggestion(this.props.suggestion);
    };
    Suggestion.prototype.truncateText = function (text) {
        if (text != null && text.length > 40) {
            return text.substr(0, 25) + '...' + text.substr(-15);
        }
        return text;
    };
    Suggestion.prototype.render = function () {
        if (this.state.error !== null) {
            return react_1.default.createElement(components_1.Dropdown, { open: true }, this.state.error);
        }
        if (this.state.author === null) {
            return null;
        }
        var author = this.state.author;
        var _a = this.props.suggestion, date = _a.date, suggestionText = _a.suggestionText, oldText = _a.oldText;
        var relativeDateString = moment_1.default(date).calendar();
        var absoluteDateString = moment_1.default(date).format('MMMM Do YYYY, h:mm:ss a');
        var description = Highlights.getHighlightDescription(this.props.suggestion.type);
        var blockStyleDescription = Highlights.getBlockStylesDescription(this.props.suggestion.blockType);
        var space = blockStyleDescription !== '' ? ' ' : '';
        var content;
        switch (this.props.suggestion.type) {
            case 'REPLACE_SUGGESTION':
                content = (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null,
                            utils_1.gettext('Replace'),
                            ": "),
                        this.truncateText(oldText)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null,
                            utils_1.gettext('with'),
                            ": "),
                        this.truncateText(suggestionText))));
                break;
            case 'CHANGE_LINK_SUGGESTION':
                content = (react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null,
                            utils_1.gettext('Replace link'),
                            ": "),
                        lodash_1.get(this.props.suggestion, 'from.href', '')),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null,
                            utils_1.gettext('with'),
                            ": "),
                        lodash_1.get(this.props.suggestion, 'to.href', ''))));
                break;
            default:
                content = (react_1.default.createElement("div", null,
                    react_1.default.createElement("strong", null,
                        description + space + blockStyleDescription,
                        ": "),
                    this.truncateText(suggestionText)));
        }
        return (react_1.default.createElement(HighlightsPopupPositioner_1.HighlightsPopupPositioner, { editorNode: this.props.editorNode },
            react_1.default.createElement(fluid_rows_1.FluidRows, null,
                react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: false },
                    react_1.default.createElement(EditorHighlightsHeader_1.EditorHighlightsHeader, { availableActions: [] },
                        react_1.default.createElement(UserAvatar_1.UserAvatar, { displayName: author.display_name, pictureUrl: author.picture_url }),
                        react_1.default.createElement("p", { className: "editor-popup__author-name" }, author.display_name),
                        react_1.default.createElement("time", { className: "editor-popup__time", title: relativeDateString }, absoluteDateString))),
                react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: true, className: "editor-popup__secondary-content" },
                    react_1.default.createElement("div", { style: { background: '#fff', padding: '1.6rem', paddingBottom: '1rem' } }, content)),
                react_1.default.createElement(fluid_row_1.FluidRow, { scrollable: true, className: "editor-popup__secondary-content" },
                    react_1.default.createElement("div", { className: "editor-popup__content-block" },
                        react_1.default.createElement("button", { className: "btn btn--small btn--hollow", onClick: this.onAccept }, utils_1.gettext('Accept')),
                        react_1.default.createElement("button", { className: "btn btn--small btn--hollow", onClick: this.onReject }, utils_1.gettext('Reject')))))));
    };
    return Suggestion;
}(react_1.default.Component));
Suggestion.propTypes = {
    suggestion: prop_types_1.default.shape({
        author: prop_types_1.default.string,
        date: prop_types_1.default.any,
        suggestionText: prop_types_1.default.string,
        oldText: prop_types_1.default.string,
        type: prop_types_1.default.string,
        blockType: prop_types_1.default.string,
        selection: prop_types_1.default.object,
    }),
    acceptSuggestion: prop_types_1.default.func,
    rejectSuggestion: prop_types_1.default.func,
    editorNode: prop_types_1.default.object,
};
exports.SuggestionPopup = react_redux_1.connect(null, {
    acceptSuggestion: actions_1.acceptSuggestion,
    rejectSuggestion: actions_1.rejectSuggestion,
})(Suggestion);


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var react_redux_1 = __webpack_require__(25);
var BaseUnstyledComponent_1 = __importDefault(__webpack_require__(546));
/**
 * This block is used by default for text content in editor.
 *
 * It handles drag events and lets editor blocks to be dropped on it.
 * There is dropzone indication after the text and on drop it will put
 * atom block after current block.
 */
var UnstyledBlock = /** @class */ (function (_super) {
    __extends(UnstyledBlock, _super);
    function UnstyledBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.dropInsertionMode = 'after';
        _this.getDropBlockKey = function () { return _this.props.children['key']; };
        return _this;
    }
    UnstyledBlock.prototype.render = function () {
        var _this = this;
        var className = this.props.className;
        var propsToTransfer = lodash_1.omit(this.props, ['className', 'invisibles', 'dispatch', 'editorProps']);
        return (react_1.default.createElement("div", __assign({ ref: function (div) { return _this.div = div; } }, propsToTransfer, { className: className + (this.state.over ? ' unstyled__block--over' : ' unstyled__block') }), this.props.children));
    };
    return UnstyledBlock;
}(BaseUnstyledComponent_1.default));
UnstyledBlock.propTypes = {
    children: prop_types_1.default.object,
    className: prop_types_1.default.string,
    editorProps: prop_types_1.default.object,
    dispatch: prop_types_1.default.func.isRequired,
};
// mapping state to props in `connect` might not work well for this component
// it was removed to fix SDESK-2886
exports.default = react_redux_1.connect()(UnstyledBlock);


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var BaseUnstyledComponent_1 = __importDefault(__webpack_require__(546));
/**
 * Custom wrapper for draft unstyled blocks.
 *
 * It allows moving block above existing blocks, adding a dropzone
 * above first unstyled block.
 */
var UnstyledWrapper = /** @class */ (function (_super) {
    __extends(UnstyledWrapper, _super);
    function UnstyledWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.dropInsertionMode = 'before';
        _this.getDropBlockKey = function () { return _this.props.children[0].key; };
        return _this;
    }
    UnstyledWrapper.prototype.render = function () {
        var _this = this;
        var className = 'unstyled ' + (this.state.over ? 'unstyled--over' : '');
        var children = this.props.children;
        var childrenWithProps = react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, { editorProps: _this.props.editorProps });
        });
        return (react_1.default.createElement("div", { className: className, ref: function (div) { return (_this.div = div); } }, childrenWithProps));
    };
    return UnstyledWrapper;
}(BaseUnstyledComponent_1.default));
UnstyledWrapper.propTypes = {
    dispatch: prop_types_1.default.func.isRequired,
    children: prop_types_1.default.array,
    editorProps: prop_types_1.default.object,
};
exports.default = UnstyledWrapper;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var draft_js_1 = __webpack_require__(16);
var immutable_1 = __webpack_require__(51);
var lodash_1 = __webpack_require__(2);
var getDraftCharacterListForSelection_1 = __webpack_require__(188);
var resizeDraftSelection_1 = __webpack_require__(417);
var highlights_1 = __webpack_require__(41);
/**
 * @ngdoc method
 * @name addCommentsForServer
 * @param {EditorState} editorState
 * @param {SelectionState} collapsedSelection
 * @return {List<CharacterMetadata>}
 */
function getRelevantCharactersForCollapsedSelection(editorState, collapsedSelection) {
    var characters = immutable_1.List();
    var selectionAtTheStartOfTheLine = editorState.getSelection().getStartOffset() === 0;
    var resizeLeft = selectionAtTheStartOfTheLine ? 2 : 1; // SDESK-2861
    var resizedSelection = resizeDraftSelection_1.resizeDraftSelection(resizeLeft, 1, collapsedSelection, editorState, false);
    var resizeLeftFailed = collapsedSelection.getStartOffset() === resizedSelection.getStartOffset();
    var resizeRightFailed = collapsedSelection.getEndOffset() === resizedSelection.getEndOffset();
    if (resizeLeftFailed === true) {
        characters = characters.push(draft_js_1.CharacterMetadata.create());
    }
    characters = characters.concat(getDraftCharacterListForSelection_1.getDraftCharacterListForSelection(editorState, resizedSelection));
    if (resizeRightFailed === true) {
        characters = characters.push(draft_js_1.CharacterMetadata.create());
    }
    return characters;
}
/**
 * @ngdoc method
 * @name handleBeforeInputHighlights
 * @description prevents inheriting of highlight styles
 */
function handleBeforeInputHighlights(onChange, chars, editorState) {
    // see handleBeforeInputHighlights.spec.gif
    var selection = editorState.getSelection();
    var characterList = selection.isCollapsed()
        ? getRelevantCharactersForCollapsedSelection(editorState, selection)
        : getDraftCharacterListForSelection_1.getDraftCharacterListForSelection(editorState, selection);
    var characterStyles = characterList.map(function (character) { return character.getStyle(); }).toJS();
    var allHighlightStyles = lodash_1.uniq(characterStyles.reduce(function (a, b) { return a.concat(b); }))
        .filter(highlights_1.styleNameBelongsToHighlight);
    if (allHighlightStyles.length < 1) {
        return 'not-handled';
    }
    var commonHighlightStyles = allHighlightStyles.filter(function (styleName) { return characterStyles.every(function (stylesAtPosition) { return stylesAtPosition.includes(styleName); }); });
    var nextInlineStyles = editorState.getCurrentInlineStyle()
        .filter(function (styleName) { return highlights_1.styleNameBelongsToHighlight(styleName) === false; })
        .concat(commonHighlightStyles);
    var nextContentstate = draft_js_1.Modifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), chars, nextInlineStyles);
    var nextEditorState = draft_js_1.EditorState.push(editorState, nextContentstate, 'insert-characters');
    onChange(nextEditorState);
    return 'handled';
}
exports.handleBeforeInputHighlights = handleBeforeInputHighlights;


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IMPORTANT NOTE: this component is agnostic about how highlights are persisted.
// Do not add persistence related code in this file.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var Highlights = __importStar(__webpack_require__(41));
var MultipleHighlights = /** @class */ (function (_super) {
    __extends(MultipleHighlights, _super);
    function MultipleHighlights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultipleHighlights.prototype.addHighlight = function (highlightType, highlightData) {
        var editorState = Highlights.addHighlight(this.props.editorState, highlightType, highlightData);
        this.props.onChange(editorState);
    };
    MultipleHighlights.prototype.removeHighlight = function (styleName) {
        var editorState = Highlights.removeHighlight(this.props.editorState, styleName);
        this.props.onChange(editorState);
    };
    MultipleHighlights.prototype.updateHighlightData = function (styleName, nextData) {
        var editorState = Highlights.updateHighlightData(this.props.editorState, styleName, nextData);
        this.props.onChange(editorState);
    };
    MultipleHighlights.prototype.canAddHighlight = function (highlightType) {
        return Highlights.canAddHighlight(this.props.editorState, highlightType);
    };
    MultipleHighlights.prototype.getHighlightData = function (styleName) {
        return Highlights.getHighlightData(this.props.editorState, styleName);
    };
    MultipleHighlights.prototype.getHighlightsCount = function (highlightType) {
        return Highlights.getHighlightsCount(this.props.editorState, highlightType);
    };
    MultipleHighlights.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, editorState = _a.editorState;
        var propsExcludingOwn = Object.keys(this.props)
            .filter(function (key) { return (key !== 'children'); })
            .reduce(function (obj, key) {
            obj[key] = _this.props[key];
            return obj;
        }, {});
        var childrenWithProps = react_1.default.Children.map(children, function (child) {
            return react_1.default.cloneElement(child, __assign({}, propsExcludingOwn, { highlightsManager: {
                    styleMap: Highlights.getHighlightsStyleMap(editorState),
                    addHighlight: _this.addHighlight.bind(_this),
                    removeHighlight: _this.removeHighlight.bind(_this),
                    getHighlightData: _this.getHighlightData.bind(_this),
                    updateHighlightData: _this.updateHighlightData.bind(_this),
                    canAddHighlight: _this.canAddHighlight.bind(_this),
                    styleNameBelongsToHighlight: Highlights.styleNameBelongsToHighlight,
                    getHighlightTypeFromStyleName: Highlights.getHighlightTypeFromStyleName,
                    getHighlightsCount: _this.getHighlightsCount.bind(_this),
                    hadHighlightsChanged: Highlights.hadHighlightsChanged,
                    availableHighlights: Highlights.availableHighlights,
                } }));
        });
        return react_1.default.createElement("div", null, childrenWithProps);
    };
    return MultipleHighlights;
}(react_1.default.Component));
exports.MultipleHighlights = MultipleHighlights;
MultipleHighlights.propTypes = {
    editorState: prop_types_1.default.object.isRequired,
    onChange: prop_types_1.default.func.isRequired,
    children: prop_types_1.default.node.isRequired,
};


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1347);


/***/ }),
/* 1347 */
/***/ (function(module, exports) {

Features.$inject = ['urls'];
function Features(urls) {
    var self = this;
    urls.links().then(function (links) {
        angular.extend(self, links);
    });
}
/**
 * @ngdoc module
 * @module superdesk.core.features
 * @name superdesk.core.features
 * @packageName superdesk.core
 * @description Superdesk features module provides information about features
 * that are enabled on the server.
 */
angular.module('superdesk.core.features', ['superdesk.core.api'])
    .service('features', Features);


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1349);


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
function ListItemDirectiveFactory() {
    return {
        link: function (scope, element, attrs, controller, $transclude) {
            var itemScope;
            scope.$watch('item', function () {
                destroyItemScope();
                itemScope = scope.$parent.$parent.$new();
                itemScope.item = scope.item;
                itemScope.items = scope.items;
                itemScope.extras = scope.extras;
                itemScope.$index = scope.$index;
                $transclude(itemScope, function (clone) {
                    element.empty();
                    element.append(clone);
                });
            });
            scope.$on('$destroy', destroyItemScope);
            function destroyItemScope() {
                if (itemScope) {
                    itemScope.$destroy();
                }
            }
        },
    };
}
/**
 * @ngdoc module
 * @module superdesk.core.list
 * @name superdesk.core.list
 * @packageName superdesk.core
 * @description The list module provides alternative listing functionalities.
 */
var mod = angular.module('superdesk.core.list', ['superdesk.core.keyboard', 'superdesk.core.services.asset']);
mod.directive('sdListView', ['$location', 'keyboardManager', 'asset', function ($location, keyboardManager, asset) {
        return {
            scope: {
                select: '&',
                extras: '=',
                items: '=',
            },
            replace: true,
            transclude: true,
            templateUrl: asset.templateUrl('core/list/views/list-view.html'),
            link: function (scope, elem, attrs) {
                var UP = -1, DOWN = 1;
                function fetchSelectedItem(itemId) {
                    if (!itemId) {
                        return;
                    }
                    var match = lodash_1.default.find(scope.items, { _id: itemId });
                    if (match) {
                        scope.clickItem(match);
                    }
                }
                function move(diff) {
                    return function () {
                        if (scope.items) {
                            var index = lodash_1.default.indexOf(scope.items, scope.selected);
                            if (index === -1) { // selected not in current items, select first
                                return scope.clickItem(lodash_1.default.head(scope.items));
                            }
                            var nextIndex = lodash_1.default.max([0, lodash_1.default.min([scope.items.length - 1, index + diff])]);
                            if (nextIndex < 0) {
                                return scope.clickItem(lodash_1.default.last(scope.items));
                            }
                            return scope.clickItem(scope.items[nextIndex]);
                        }
                    };
                }
                function onKey(dir, callback) {
                    keyboardManager.bind(dir, callback);
                }
                onKey('up', move(UP));
                onKey('left', move(UP));
                onKey('down', move(DOWN));
                onKey('right', move(DOWN));
                scope.clickItem = function (item, $event) {
                    scope.selected = item;
                    scope.select({ item: item });
                    if ($event) {
                        $event.stopPropagation();
                    }
                };
                scope.$watch('items', function () {
                    fetchSelectedItem($location.search()._id);
                    elem.find('.list-view').focus();
                });
            },
        };
    }]);
mod.directive('sdSearchbar', ['$location', 'asset', function ($location, asset) {
        return {
            scope: true,
            templateUrl: asset.templateUrl('core/list/views/searchbar.html'),
            link: function (scope, elem) {
                var input = elem.find('#search-input');
                scope.q = $location.search().q || null;
                scope.flags = { extended: !!scope.q };
                scope.search = function () {
                    $location.search('q', scope.q || null);
                    $location.search('page', null);
                };
                scope.close = function () {
                    scope.q = null;
                    scope.search();
                    input.focus();
                };
            },
        };
    }]);
mod.directive('sdListItem', ListItemDirectiveFactory);
mod.directive('sdUpdowns', ['$location', 'keyboardManager', '$anchorScroll',
    function ($location, keyboardManager, $anchorScroll) {
        return {
            transclude: true,
            template: '<div ng-transclude></div>',
            scope: {
                items: '=',
                select: '&',
            },
            link: function (scope, elem, attrs) {
                var UP = -1, DOWN = 1;
                function fetchSelectedItem(itemId) {
                    if (!itemId) {
                        return;
                    }
                    var match = lodash_1.default.find(scope.items, { _id: itemId });
                    if (match) {
                        clickItem(match);
                    }
                }
                function scrollList(id) {
                    $location.hash(id);
                    $anchorScroll();
                }
                function move(diff) {
                    return function () {
                        if (scope.items) {
                            var index = lodash_1.default.findIndex(scope.items, { _id: $location.search()._id });
                            if (index === -1) { // selected not in current items, select first
                                return clickItem(lodash_1.default.head(scope.items));
                            }
                            var nextIndex = lodash_1.default.max([0, lodash_1.default.min([scope.items.length - 1, index + diff])]);
                            if (nextIndex < 0) {
                                return clickItem(lodash_1.default.last(scope.items));
                            }
                            scrollList(scope.items[nextIndex]._id);
                            return clickItem(scope.items[nextIndex]);
                        }
                    };
                }
                function onKey(dir, callback) {
                    keyboardManager.bind(dir, callback);
                }
                onKey('up', move(UP));
                onKey('left', move(UP));
                onKey('down', move(DOWN));
                onKey('right', move(DOWN));
                function clickItem(item, $event) {
                    scope.select({ item: item });
                    if ($event) {
                        $event.stopPropagation();
                    }
                }
                scope.$watch('items', function () {
                    fetchSelectedItem($location.search()._id);
                    elem.find('.list-view').focus();
                });
            },
        };
    },
]);
/**
 * sdPagination inserts pagination controls for a given data set.
 *
 * Usage:
 * <div sd-pagination data-items="users" data-limit="maxResults"></div>
 *
 * Params:
 * @items {object} Item container as received from server, with _items and _meta.
 * @limit {number} Number of items per page.
 */
mod.directive('sdPagination', ['$location', 'asset', function ($location, asset) {
        return {
            template: __webpack_require__(1350),
            scope: {
                items: '=',
            },
            link: function (scope, element, attrs) {
                var SIZE = 25;
                scope.pgsizes = [SIZE, SIZE * 2, SIZE * 4];
                scope.$watch('items._meta', function (meta) {
                    scope.total = 0;
                    if (meta) {
                        scope.total = meta.total;
                        scope.page = Number($location.search().page) || 1;
                        scope.limit = Number(localStorage.getItem('pagesize'))
                            || Number($location.search().max_results) || SIZE;
                        scope.lastPage = scope.limit ? Math.ceil(scope.total / scope.limit) : scope.page;
                        scope.from = (scope.page - 1) * scope.limit + 1;
                        scope.to = Math.min(scope.total, scope.from + scope.limit - 1);
                        if (scope.pageChanged === true) {
                            scrollTop();
                            scope.pageChanged = null;
                        }
                    }
                });
                /**
                 * Set page
                 *
                 * @param {integer} page
                 */
                scope.setPage = function (page) {
                    $location.search('page', page > 1 ? page : null);
                    scope.pageChanged = true;
                };
                function scrollTop() {
                    window.scrollTo(0, 0);
                }
                /*
                * Set custom page size limit
                *@param {integer} page
                */
                scope.setLimit = function (pagesize) {
                    localStorage.setItem('pagesize', pagesize);
                    scope.setPage(0);
                    $location.search('max_results', !lodash_1.default.isNil(pagesize) ? pagesize : SIZE);
                };
            },
        };
    }]);
// Alternative sdPagination, doesn't use $location.
// Should replace sdPagination.
mod.directive('sdPaginationAlt', ['asset', function (asset) {
        return {
            templateUrl: asset.templateUrl('core/list/views/sdPaginationAlt.html'),
            scope: {
                page: '=',
                maxPage: '=',
            },
        };
    }]);
exports.default = mod;


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sd-pagination\" ng-if=\"total\">\n    <span class=\"page-info\" translate>Page Size:</span>\n    <div class=\"page-info\">\n        <!-- <select class=\"line-input\" ng-model=\"limit\" ng-options=\"item for item in pgsizes\" ng-change=\"setLimit(limit)\"></select> -->\n\n        <div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:50px;\">\n            <select class=\"sd-line-input__select\" \n                ng-model=\"limit\"\n                ng-options=\"item for item in pgsizes\"\n                ng-change=\"setLimit(limit)\">\n            </select>\n        </div>\n\n    </div>\n    <em class=\"page-info\" ng-show=\"page <= lastPage\">{{from}}-{{to}} {{'of'|translate }} {{total}}</em>\n    <div class=\"btn-group\">\n        <button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"setPage(0)\">\n            <i class=\"icon-backward-thin\"></i>\n        </button>\n\n        <button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"setPage(page - 1)\">\n            <i class=\"icon-chevron-left-thin\"></i>\n        </button>\n\n        <button class=\"btn btn--text-only\" ng-disabled=\"page >= lastPage\" ng-click=\"setPage(page + 1)\">\n            <i class=\"icon-chevron-right-thin\"></i>\n        </button>\n\n        <button class=\"btn btn--text-only\" ng-disabled=\"page >= lastPage\" ng-click=\"setPage(lastPage)\">\n            <i class=\"icon-forward-thin\"></i>\n        </button>\n    </div>\n</div>";

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.keyboard
 * @name superdesk.core.keyboard
 * @packageName superdesk.core
 * @description The keyboard module allows linking various keyboard shortcuts
 * to Superdesk functionalities.
 */
__webpack_require__(1352);


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.core.keyboard', [])
    .constant('Keys', Object.freeze({
    pageup: 33,
    pagedown: 34,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    enter: 13,
    escape: 27,
    space: 32,
    backspace: 8,
}))
    .constant('shiftNums', {
    '`': '~',
    1: '!',
    2: '@',
    3: '#',
    4: '$',
    5: '%',
    6: '^',
    7: '&',
    8: '*',
    9: '(',
    0: ')',
    '-': '_',
    '=': '+',
    ';': ':',
    '\'': '"',
    ',': '<',
    '.': '>',
    '/': '?',
    '\\': '|',
})
    // unbind all keyboard shortcuts when switching route
    .run(['$rootScope', 'keyboardManager', function ($rootScope, kb) {
        $rootScope.$on('$routeChangeStart', function () {
            angular.forEach(kb.keyboardEvent, function (e, key) {
                if (!e.opt.global) {
                    kb.unbind(key);
                }
            });
        });
    }])
    /**
     * Broadcast key:char events cought on body
     */
    .run(['$rootScope', '$document', 'Keys', 'shiftNums',
    function KeyEventBroadcast($rootScope, $document, Keys, shiftNums) {
        var ignoreNodes = {
            INPUT: true,
            TEXTAREA: true,
            BUTTON: true,
        };
        $document.on('keydown', function (e) {
            var ctrlKey = e.ctrlKey || e.metaKey, altKey = e.altKey, shiftKey = e.shiftKey, isGlobal = ctrlKey && shiftKey;
            if (isGlobal || !ignoreNodes[e.target.nodeName]) { // $document.body is empty when testing
                var character = String.fromCharCode(e.which).toLowerCase(), modifier = '';
                modifier += ctrlKey ? 'ctrl:' : '';
                modifier += altKey ? 'alt:' : '';
                modifier += shiftKey ? 'shift:' : '';
                // also handle arrows, enter/escape, etc.
                angular.forEach(Object.keys(Keys), function (key) {
                    if (e.which === Keys[key]) {
                        character = key;
                    }
                });
                // Emit the corresponding shift character the same way keyboardManager service emits
                if (shiftKey && shiftNums[character]) {
                    character = shiftNums[character];
                }
                $rootScope.$broadcast('key:' + modifier + character, e);
            }
        });
    }])
    .service('keyboardManager', ['$window', '$timeout', 'shiftNums', function ($window, $timeout, shiftNums) {
        var stack = [], defaultOpt = {
            type: 'keydown',
            propagate: true,
            inputDisabled: false,
            target: $window.document,
            keyCode: false,
            global: false,
        }, specialKeys = {
            esc: 27,
            escape: 27,
            tab: 9,
            space: 32,
            return: 13,
            enter: 13,
            backspace: 8,
            scrolllock: 145,
            scroll_lock: 145,
            scroll: 145,
            capslock: 20,
            caps_lock: 20,
            caps: 20,
            numlock: 144,
            num_lock: 144,
            num: 144,
            pause: 19,
            break: 19,
            insert: 45,
            home: 36,
            delete: 46,
            end: 35,
            pageup: 33,
            page_up: 33,
            pu: 33,
            pagedown: 34,
            page_down: 34,
            pd: 34,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            f1: 112,
            f2: 113,
            f3: 114,
            f4: 115,
            f5: 116,
            f6: 117,
            f7: 118,
            f8: 119,
            f9: 120,
            f10: 121,
            f11: 122,
            f12: 123,
        };
        // Store all keyboard combination shortcuts
        this.keyboardEvent = {};
        this.registry = {};
        this.register = function register(group, label, description) {
            this.registry[group] = this.registry[group] || {};
            this.registry[group][label] = description;
        };
        // Add a new keyboard combination shortcut
        this.bind = function bind(label, callback, opt) {
            var fct, elt, code, k;
            // Initialize options object
            var options = angular.extend({}, defaultOpt, opt);
            var lbl = label.toLowerCase();
            elt = options.target;
            if (typeof options.target === 'string') {
                elt = document.getElementById(options.target);
            }
            var inputDisabled = function (e) {
                if (options.inputDisabled) {
                    var elem;
                    if (e.target) {
                        elem = e.target;
                    }
                    else if (e.srcElement) {
                        elem = e.srcElement;
                    }
                    if (elem.nodeType === 3) {
                        elem = elem.parentNode;
                    }
                    return elem.tagName === 'INPUT' || elem.tagName === 'TEXTAREA' ||
                        elem.className.indexOf('editor-type-html') !== -1;
                }
            };
            var getCharacter = function (codeNumber) {
                var character = String.fromCharCode(codeNumber).toLowerCase();
                if (codeNumber === 188) {
                    character = ',';
                } // If the user presses , when the type is onkeydown
                if (codeNumber === 190) {
                    character = '.';
                } // If the user presses , when the type is onkeydown
                return character;
            };
            fct = function keyboardHandler(e) {
                if (e === void 0) { e = $window.event; }
                // Disable event handler when focus input and textarea
                if (inputDisabled(e)) {
                    return;
                }
                // Find out which key is pressed
                code = e.keyCode || e.which;
                var character = getCharacter(code);
                var keys = lbl.split('+');
                // Key Pressed - counts the number of valid keypresses
                // - if it is same as the number of keys, the shortcut function is invoked
                var kp = 0;
                // Some modifiers key
                var modifiers = {
                    shift: {
                        wanted: false,
                        pressed: !!e.shiftKey,
                    },
                    ctrl: {
                        wanted: false,
                        pressed: !!e.ctrlKey,
                    },
                    alt: {
                        wanted: false,
                        pressed: !!e.altKey,
                    },
                    meta: {
                        wanted: false,
                        pressed: !!e.metaKey,
                    },
                };
                var computeKeys = function () {
                    var isCtrl = function (key) { return key === 'ctrl' || key === 'control'; };
                    var isMeta = function (key) { return key === 'alt' || key === 'shift' || key === 'meta'; };
                    // Foreach keys in label (split on +)
                    for (var i = 0, l = keys.length; k = keys[i], i < l; i++) {
                        if (isCtrl(k)) {
                            kp++;
                            modifiers.ctrl.wanted = true;
                        }
                        else if (isMeta(k)) {
                            kp++;
                            modifiers[k].wanted = true;
                        }
                        var shouldIncrease = k.length > 1 && specialKeys[k] === code
                            || options.keyCode && options.keyCode === code || character === k;
                        if (shouldIncrease) {
                            kp++;
                        }
                        else if (shiftNums[character] && e.shiftKey) {
                            // Stupid Shift key bug created by using lowercase
                            character = shiftNums[character];
                            if (character === k) {
                                kp++;
                            }
                        }
                    }
                };
                computeKeys();
                if (kp === keys.length &&
                    modifiers.ctrl.pressed === modifiers.ctrl.wanted &&
                    modifiers.shift.pressed === modifiers.shift.wanted &&
                    modifiers.alt.pressed === modifiers.alt.wanted &&
                    modifiers.meta.pressed === modifiers.meta.wanted) {
                    $timeout(function () {
                        callback(e);
                    }, 1);
                    if (!options.propagate) { // Stop the event
                        // e.cancelBubble is supported by IE - this will kill the bubbling process.
                        e.cancelBubble = true;
                        e.returnValue = false;
                        // e.stopPropagation works in Firefox.
                        if (e.stopPropagation) {
                            e.stopPropagation();
                            e.preventDefault();
                        }
                        return false;
                    }
                }
            };
            // Store shortcut
            this.keyboardEvent[lbl] = {
                callback: fct,
                target: elt,
                event: options.type,
                _callback: callback,
                opt: options,
                label: lbl,
            };
            // Attach the function with the event
            if (elt.addEventListener) {
                elt.addEventListener(options.type, fct, false);
            }
            else if (elt.attachEvent) {
                elt.attachEvent('on' + options.type, fct);
            }
            else {
                elt['on' + options.type] = fct;
            }
        };
        this.push = function push(label, callback, options) {
            var e = this.keyboardEvent[label.toLowerCase()];
            if (e) {
                stack.push(e);
                this.unbind(label);
            }
            this.bind(label, callback, options);
        };
        this.pop = function pop(label) {
            this.unbind(label);
            var index = lodash_1.default.findLastIndex(stack, { label: label.toLowerCase() });
            if (index !== -1) {
                this.bind(label, stack[index]._callback, stack[index].opt);
                stack.splice(index, 0);
            }
        };
        // Remove the shortcut - just specify the shortcut and I will remove the binding
        this.unbind = function unbind(label) {
            var lbl = label.toLowerCase();
            var binding = this.keyboardEvent[lbl];
            delete this.keyboardEvent[lbl];
            if (!binding) {
                return;
            }
            var type = binding.event, elt = binding.target, callback = binding.callback;
            if (elt.detachEvent) {
                elt.detachEvent('on' + type, callback);
            }
            else if (elt.removeEventListener) {
                elt.removeEventListener(type, callback, false);
            }
            else {
                elt['on' + type] = false;
            }
        };
    }])
    .directive('sdHotkey', ['keyboardManager', '$timeout', function (keyboardManager, $timeout) {
        return {
            link: function (scope, elem, attrs, ctrl) {
                var hotkey = attrs.sdHotkey, callback = scope.$eval(attrs.sdHotkeyCallback), options = scope.$eval(attrs.sdHotkeyOptions);
                keyboardManager.bind(hotkey, function (e) {
                    e.preventDefault();
                    if (callback) {
                        callback();
                    }
                    else {
                        elem.click();
                    }
                }, options);
                /*
             * On scope $destroy unbind binded shortcuts
             */
                scope.$on('$destroy', function () {
                    keyboardManager.unbind(hotkey);
                });
                $timeout(function () {
                    if (elem.attr('title')) {
                        elem.attr('title', elem.attr('title') + ' (' + hotkey + ')');
                    }
                    else if (elem.attr('tooltip')) {
                        elem.attr('tooltip', elem.attr('tooltip') + ' (' + hotkey + ')');
                    }
                    else {
                        elem.attr('title', hotkey);
                    }
                }, 0, false);
            },
        };
    }])
    .directive('sdKeyboardModal', ['keyboardManager', function (keyboardManager) {
        return {
            scope: true,
            templateUrl: 'scripts/core/keyboard/views/keyboard-modal.html',
            link: function (scope) {
                scope.enabled = false;
                scope.data = {};
                keyboardManager.bind('alt+k', function () {
                    scope.enabled = true;
                    scope.data = keyboardManager.registry;
                }, {
                    global: true,
                    group: utils_1.gettext('General'),
                    description: utils_1.gettext('Displays active keyboard shortcuts'),
                });
                keyboardManager.bind('alt+k', function () {
                    scope.enabled = false;
                }, {
                    global: true,
                    type: 'keyup',
                    group: utils_1.gettext('General'),
                    description: utils_1.gettext('Displays active keyboard shortcuts'),
                });
                scope.close = function () {
                    scope.enabled = false;
                };
            },
        };
    }]);


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1354);


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

PrivilegesService.$inject = ['$rootScope', 'preferencesService'];
function PrivilegesService($rootScope, preferencesService) {
    var _privileges = {};
    this.privileges = _privileges;
    $rootScope.privileges = _privileges;
    /**
     * Check if current user has given privileges
     *
     * @param {Object} privileges
     */
    this.userHasPrivileges = function userHasPrivileges(privileges) {
        for (var privilege in privileges) {
            if (privileges[privilege] && !_privileges[privilege]) {
                return false;
            }
        }
        return true;
    };
    /**
     * Set current user privileges
     *
     * @param {Object} privileges
     */
    this.setUserPrivileges = function setUserPrivileges(privileges) {
        for (var privilege in privileges) {
            if (privileges[privilege]) {
                _privileges[privilege] = 1;
            }
            else {
                _privileges[privilege] = 0;
            }
        }
        return _privileges;
    };
    // start loading when used for first time
    this.loaded = preferencesService.getPrivileges().then(this.setUserPrivileges);
}
/**
 * @ngdoc module
 * @module superdesk.core.privileges
 * @name superdesk.core.privileges
 * @packageName superdesk.core
 * @description Superdesk privileges enables and helps manage user privileges.
 */
angular.module('superdesk.core.privileges', ['superdesk.core.preferences'])
    .service('privileges', PrivilegesService);


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1356);


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
* This file is part of Superdesk.
*
* Copyright 2015 Sourcefabric z.u. and contributors.
*
* For the full copyright and license information, please see the
* AUTHORS and LICENSE files distributed with this source code, or
* at https://www.sourcefabric.org/superdesk/license
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
WebSocketProxy.$inject = ['$rootScope', 'config', '$interval', 'session', 'SESSION_EVENTS'];
function WebSocketProxy($rootScope, config, $interval, session, SESSION_EVENTS) {
    var ws = null;
    var connectTimer = -1;
    var TIMEOUT = 5000;
    var ReloadEvents = [
        'user_disabled',
        'user_inactivated',
        'user_role_changed',
        'user_type_changed',
        'user_privileges_revoked',
        'role_privileges_revoked',
        'desk_membership_revoked',
        'desk',
        'stage',
        'stage_visibility_updated',
    ];
    var readyState = {
        CONNECTING: 0,
        OPEN: 1,
        CLOSING: 2,
        CLOSED: 3,
    };
    if (!config.server.ws) {
        return;
    }
    var connect = function () {
        if (!ws || ws.readyState === readyState.CLOSED) {
            ws = new WebSocket(config.server.ws);
            bindEvents();
        }
    };
    var disconnect = function () {
        if (ws) {
            ws.close();
            ws = null;
        }
    };
    var bindEvents = function () {
        ws.onmessage = function (event) {
            var msg = angular.fromJson(event.data);
            $rootScope.$broadcast(msg.event, msg.extra);
            if (lodash_1.default.includes(ReloadEvents, msg.event)) {
                $rootScope.$broadcast('reload', msg);
            }
        };
        ws.onerror = function (event) {
            console.error(event);
        };
        ws.onopen = function (event) {
            $interval.cancel(connectTimer);
            $rootScope.$broadcast('connected');
        };
        ws.onclose = function (event) {
            $rootScope.$broadcast('disconnected');
            $interval.cancel(connectTimer);
            connectTimer = $interval(function () {
                if (ws && session.sessionId) {
                    connect(); // Retry to connect for every TIMEOUT interval.
                }
            }, TIMEOUT, 0, false); // passed invokeApply = false to prevent triggering digest cycle
        };
    };
    connect();
    $rootScope.$on(SESSION_EVENTS.LOGOUT, disconnect);
    $rootScope.$on(SESSION_EVENTS.LOGIN, connect);
}
/**
 * Service for notifying user when websocket connection disconnected or connected.
 */
NotifyConnectionService.$inject = ['$rootScope', 'notify', '$timeout', 'session'];
function NotifyConnectionService($rootScope, notify, $timeout, session) {
    var self = this;
    self.message = null;
    $rootScope.$on('disconnected', function (event) {
        self.message = utils_1.gettext('Disconnected from Notification Server!');
        $rootScope.$applyAsync(function () {
            notify.warning(self.message);
        });
    });
    $rootScope.$on('connected', function (event) {
        self.message = utils_1.gettext('Connected to Notification Server!');
        $rootScope.$applyAsync(function () {
            notify.pop(); // removes disconnection warning, once connected.
            notify.success(self.message);
        });
    });
    $rootScope.$on('vocabularies:updated', function (event, data) {
        if (!data || !data.user || data.user !== session.identity._id) {
            self.message = data.vocabulary + utils_1.gettext(' vocabulary has been updated. Please re-login to see updated vocabulary values');
            $timeout(function () {
                notify.error(self.message);
            }, 100);
        }
    });
}
ReloadService.$inject = ['$window', '$rootScope', 'session', 'desks', 'superdeskFlags'];
function ReloadService($window, $rootScope, session, desks, superdeskFlags) {
    var self = this;
    self.userDesks = [];
    self.result = null;
    self.activeDesk = null;
    desks.fetchCurrentUserDesks().then(function (deskList) {
        self.userDesks = deskList;
        self.activeDesk = desks.active.desk;
    });
    var userEvents = {
        user_disabled: 'User is disabled',
        user_inactivated: 'User is inactivated',
        user_role_changed: 'User role is changed',
        user_type_changed: 'User type is changed',
        user_privileges_revoked: 'User privileges are revoked',
    };
    var roleEvents = {
        role_privileges_revoked: 'Role privileges are revoked',
    };
    var deskEvents = {
        desk_membership_revoked: 'User removed from desk',
        desk: 'Desk is deleted/updated',
    };
    var stageEvents = {
        stage: 'Stage is created/updated/deleted',
        stage_visibility_updated: 'Stage visibility change',
    };
    $rootScope.$on('reload', function (event, msg) {
        self.result = self.reloadIdentifier(msg);
        self.reload(self.result);
    });
    this.reload = function (result) {
        if (result.reload) {
            if (superdeskFlags.flags.authoring) {
                self.broadcast(utils_1.gettext(result.message));
            }
            else {
                this.forceReload();
            }
        }
    };
    this.forceReload = function () {
        return $window.location.reload(true);
    };
    this.broadcast = function (msg) {
        $rootScope.$broadcast('savework', msg);
    };
    this.reloadIdentifier = function (msg) {
        var result = {
            reload: false,
            message: null,
        };
        if (lodash_1.default.has(userEvents, msg.event) && !lodash_1.default.isNil(msg.extra.user_id) &&
            msg.extra.user_id.indexOf(session.identity._id) !== -1) {
            result.message = userEvents[msg.event];
            result.reload = true;
        }
        if (lodash_1.default.has(roleEvents, msg.event) &&
            msg.extra.role_id.indexOf(session.identity.role) !== -1) {
            result.message = roleEvents[msg.event];
            result.reload = true;
        }
        if (lodash_1.default.has(deskEvents, msg.event) &&
            !lodash_1.default.isNil(msg.extra.desk_id) && !lodash_1.default.isNil(msg.extra.user_ids) &&
            !lodash_1.default.isNil(lodash_1.default.find(self.userDesks, { _id: msg.extra.desk_id })) &&
            msg.extra.user_ids.indexOf(session.identity._id) !== -1) {
            result.message = deskEvents[msg.event];
            result.reload = true;
        }
        if (lodash_1.default.has(stageEvents, msg.event) && !lodash_1.default.isNil(msg.extra.desk_id)) {
            if (msg.event === 'stage_visibility_updated') {
                if (lodash_1.default.isNil(lodash_1.default.find(self.userDesks, { _id: msg.extra.desk_id })) &&
                    !lodash_1.default.isNil($window.location.hash.match('/search'))
                    || !lodash_1.default.isNil($window.location.hash.match('/authoring/'))) {
                    result.message = stageEvents[msg.event];
                    result.reload = true;
                }
            }
            else if (msg.event === 'stage') {
                if (!lodash_1.default.isNil(lodash_1.default.find(self.userDesks, { _id: msg.extra.desk_id }))
                    && self.activeDesk === msg.extra.desk_id) {
                    result.message = stageEvents[msg.event];
                    result.reload = true;
                }
            }
        }
        return result;
    };
}
/**
 * @ngdoc module
 * @module superdesk.core.notification
 * @name superdesk.core.notification
 * @packageName superdesk.core
 * @description The notification package holds various types of notifications.
 */
exports.default = angular.module('superdesk.apps.notification', ['superdesk.apps.desks', 'superdesk.core.menu'])
    .service('reloadService', ReloadService)
    .service('notifyConnectionService', NotifyConnectionService)
    .run(WebSocketProxy);


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.itemList
 * @name superdesk.core.itemList
 * @packageName superdesk.core
 * @description itemList allows users to display lists of archive items.
 */
__webpack_require__(1358);


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var lodash_1 = __webpack_require__(2);
angular.module('superdesk.core.itemList', ['superdesk.apps.search'])
    /**
     * @ngdoc directive
     * @module superdesk.core.itemList
     * @name sdRelatedItemListWidget
     * @param {object} options
     * @param {object} itemListOptions
     * @param {object} actions
     * @param {object} loading
     * @description Creates a list of stories to appear in related items widget.
     */
    .directive('sdRelatedItemListWidget', ['notify', 'familyService', 'desks',
    function (notify, familyService, desks) {
        return {
            scope: {
                options: '=',
                itemListOptions: '=',
                actions: '=',
                loading: '=',
            },
            templateUrl: 'scripts/core/itemList/views/relatedItem-list-widget.html',
            link: function (scope, element, attrs) {
                scope.items = null;
                scope.processedItems = null;
                scope.selected = null;
                var oldSearch = null;
                var itemListListener = null;
                var optionsListener = null;
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#refresh
             * @description Fetches and assigns relatable items
             */
                scope.refresh = function () {
                    if (scope.options.related && scope.hasKeywords()) {
                        scope.loading = true;
                        familyService.fetchRelatableItems(scope.itemListOptions.keyword, scope.itemListOptions.sluglineMatch, scope.options.item, scope.itemListOptions.modificationDateAfter).then(function (items) {
                            scope.processedItems = items._items;
                        })
                            .finally(function () {
                            scope.loading = false;
                        });
                    }
                };
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#canDisplayItem
             * @returns {Boolean}
             * @param {object} item
             * @description Checks if an item should be displayed in the list
             */
                scope.canDisplayItem = function (item) {
                    if (!scope.options.searchEnabled) {
                        return true;
                    }
                    return scope.actions.update && scope.actions.update.condition(item) ||
                        scope.actions.addTake && scope.actions.addTake.condition(item);
                };
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#deskName
             * @returns {String}
             * @param {object} item
             * @description Extracts the id of the desk the item is on and returns it's name
             */
                scope.deskName = function (item) { return desks.deskLookup[item.task.desk].name; };
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#deskStage
             * @returns {String}
             * @param {object} item
             * @description Extracts the id of the stage the item is on and returns it's name
             */
                scope.deskStage = function (item) { return desks.stageLookup[item.task.stage].name; };
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#setProcessedItems
             * @description Creates or removes listeners
             */
                var setProcessedItems = function () {
                    if (scope.loading) {
                        return;
                    }
                    if (scope.options.existingRelations) {
                        scope.processedItems = scope.options.existingRelations;
                        if (itemListListener) {
                            itemListListener();
                        }
                        if (optionsListener) {
                            optionsListener();
                        }
                    }
                    else {
                        optionsListener = scope.$watch('options.related', function () {
                            if (scope.options.related && scope.options.item) {
                                if (!scope.options.item.slugline) {
                                    notify.error(utils_1.gettext('Error: Slugline required.'));
                                }
                                else {
                                    oldSearch = scope.itemListOptions.keyword;
                                    scope.itemListOptions.keyword = scope.options.item.slugline;
                                    scope.refresh();
                                }
                            }
                            else {
                                scope.itemListOptions.keyword = oldSearch || null;
                            }
                        });
                    }
                };
                /**
             * @ngdoc method
             * @name sdRelatedItemListWidget#isPublished
             * @returns {Boolean}
             * @param {object} item
             * @description Checks if an item is in published state
             */
                scope.isPublished = function (item) { return lodash_1.includes(['published', 'killed', 'scheduled', 'corrected', 'recalled'], item.state); };
                scope.$watchGroup(['options.item.slugline', 'options.existingRelations'], setProcessedItems);
                scope.hasKeywords = function () { return scope.itemListOptions.keyword &&
                    scope.itemListOptions.keyword.trim().length >= 2; };
                scope.view = function (item) {
                    scope.selected = item;
                };
            },
        };
    }]);


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1360);
// scripts
__webpack_require__(1363);
__webpack_require__(1364);


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1361);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./menu.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./menu.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*\n====================================================\n    Main navigation\n====================================================\n*/\n.beta-switch {\n  background: none !important;\n  border-right: none !important; }\n  .beta-switch span {\n    height: 10px;\n    font-size: 10px;\n    padding: 2px 5px;\n    border-radius: 2px; }\n    .beta-switch span.stable {\n      background: #111;\n      color: #777; }\n    .beta-switch span.beta {\n      background: #009360;\n      color: #fff; }\n\n#top-menu {\n  background: #2c2c2c;\n  height: 48px;\n  position: fixed;\n  right: 0;\n  left: 0;\n  top: 0;\n  z-index: 1030;\n  margin-bottom: 0;\n  transition: all 0.3s ease; }\n  #top-menu.menu-open {\n    left: 300px !important;\n    right: 0 !important; }\n  #top-menu.test-environment {\n    background: #3783a2; }\n    #top-menu.test-environment:after {\n      content: attr(data-text);\n      color: black;\n      font-size: 47px;\n      color: black;\n      top: 13px;\n      position: absolute; }\n  #top-menu a, #top-menu button {\n    height: 48px;\n    display: inline-block;\n    line-height: 48px;\n    padding: 0 25px;\n    background: #202020;\n    border: 0;\n    font-weight: 400; }\n    #top-menu a:hover, #top-menu button:hover {\n      text-decoration: none;\n      background: #000; }\n    #top-menu a.main-link, #top-menu button.main-link {\n      font-size: 15px;\n      color: #aaa; }\n    #top-menu a.collapse-nav, #top-menu button.collapse-nav {\n      width: 48px !important;\n      text-align: center;\n      padding: 0;\n      line-height: 0; }\n      #top-menu a.collapse-nav:hover, #top-menu button.collapse-nav:hover {\n        background: #101010;\n        cursor: pointer; }\n    #top-menu a.current-user, #top-menu button.current-user {\n      width: 48px;\n      position: relative;\n      padding: 0 10px;\n      box-sizing: border-box;\n      width: 48px;\n      box-shadow: none; }\n      #top-menu a.current-user .avatar, #top-menu button.current-user .avatar {\n        border-radius: 50%; }\n      #top-menu a.current-user .badge, #top-menu button.current-user .badge {\n        position: absolute;\n        top: 3px;\n        left: 3px;\n        text-shadow: none; }\n  #top-menu .top-nav {\n    height: 48px;\n    float: left; }\n  #top-menu .dropdown {\n    position: relative;\n    float: left; }\n    #top-menu .dropdown.navbtn, #top-menu .dropdown button {\n      box-shadow: none;\n      border: none;\n      width: auto; }\n      #top-menu .dropdown.navbtn .name, #top-menu .dropdown button .name {\n        display: block;\n        float: left;\n        min-width: 155px;\n        max-width: 200px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        text-align: left;\n        text-transform: uppercase; }\n    #top-menu .dropdown.open .dropdown__toggle {\n      background-color: #fff;\n      color: #5aa1bf; }\n      #top-menu .dropdown.open .dropdown__toggle .dropdown__caret {\n        border-top-color: #595959; }\n      #top-menu .dropdown.open .dropdown__toggle.workspace {\n        background-color: #fff;\n        color: #9c5e96; }\n      #top-menu .dropdown.open .dropdown__toggle.desk--closed {\n        background-color: #fff;\n        color: #E51C23; }\n    #top-menu .dropdown .dropdown__toggle {\n      background-color: #5ea9c8;\n      color: #fff;\n      padding: 0 15px;\n      font-size: 12px;\n      overflow: hidden; }\n      #top-menu .dropdown .dropdown__toggle .dropdown__caret {\n        border-top-color: #fff; }\n      #top-menu .dropdown .dropdown__toggle.workspace {\n        background-color: #9c5e96; }\n      #top-menu .dropdown .dropdown__toggle.desk--closed {\n        background-color: #E51C23; }\n    #top-menu .dropdown .dropdown__menu {\n      min-width: 295px;\n      max-height: 550px;\n      overflow: auto;\n      margin: 0;\n      padding: 0;\n      z-index: 4; }\n      #top-menu .dropdown .dropdown__menu .dropdown__menu-label {\n        font-size: 10px;\n        color: #999;\n        padding: 5px 15px;\n        margin-top: 9px;\n        border-top: 1px solid #ebebeb; }\n        #top-menu .dropdown .dropdown__menu .dropdown__menu-label:first-of-type {\n          margin-top: 0;\n          border-top: 0; }\n      #top-menu .dropdown .dropdown__menu .no-desk {\n        width: 100%;\n        background-color: #fff;\n        color: #999;\n        border: none;\n        height: auto;\n        font-size: 12px;\n        line-height: 1.3em;\n        margin: 0;\n        padding: 10px 15px;\n        border-radius: 0; }\n      #top-menu .dropdown .dropdown__menu button {\n        width: 100%;\n        background-color: #fff;\n        color: #3599b6;\n        border: none;\n        height: auto;\n        font-size: 12px;\n        line-height: 1.3em;\n        margin: 0;\n        padding: 10px 15px;\n        border-radius: 0;\n        text-transform: uppercase;\n        position: relative; }\n        #top-menu .dropdown .dropdown__menu button[disabled]:hover {\n          cursor: default;\n          background-color: #fff; }\n        #top-menu .dropdown .dropdown__menu button.action-btn {\n          font-size: 13px;\n          margin-top: 9px;\n          padding: 12px 15px;\n          text-transform: none;\n          color: #757676;\n          border-top: 1px solid #ebebeb; }\n        #top-menu .dropdown .dropdown__menu button:hover {\n          background-color: #eef5f8; }\n      #top-menu .dropdown .dropdown__menu .workspace-item button {\n        color: #9c5e96; }\n      #top-menu .dropdown .dropdown__menu .desk-item--closed button::after, #top-menu .dropdown .dropdown__menu .desk-item--receiving button::after {\n        font-family: 'sd_icons';\n        position: absolute;\n        right: 8px;\n        top: 9px;\n        width: 16px;\n        height: 16px;\n        line-height: 16px;\n        font-size: 16px;\n        font-family: 'sd_icons';\n        font-style: normal;\n        font-weight: normal;\n        font-variant: normal;\n        text-transform: none;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale; }\n      #top-menu .dropdown .dropdown__menu .desk-item--closed button {\n        color: #E51C23;\n        background-color: rgba(229, 28, 35, 0.08); }\n        #top-menu .dropdown .dropdown__menu .desk-item--closed button::after {\n          content: \"\\E625\";\n          color: #E51C23; }\n        #top-menu .dropdown .dropdown__menu .desk-item--closed button:hover {\n          background-color: rgba(229, 28, 35, 0.16); }\n      #top-menu .dropdown .dropdown__menu .desk-item--receiving button::after {\n        content: \"\\E624\";\n        color: #46a546; }\n  #top-menu .top-menu__content-block {\n    display: flex;\n    align-items: center; }\n    #top-menu .top-menu__content-block--right {\n      margin-left: auto;\n      float: right; }\n  #top-menu .top-menu__info {\n    display: inline-flex;\n    height: 30px;\n    padding: 0 20px;\n    background-color: rgba(0, 0, 0, 0.5);\n    line-height: 1;\n    color: #fff;\n    font-size: 12px;\n    border-radius: 15px;\n    align-items: center; }\n  #top-menu .top-menu__info-label {\n    font-weight: 300;\n    color: rgba(255, 255, 255, 0.5);\n    padding-right: 5px; }\n  #top-menu .top-menu__info-text {\n    font-weight: 400; }\n  #top-menu .top-menu__info-icon {\n    margin-right: 6px;\n    color: inherit; }\n    #top-menu .top-menu__info-icon--green {\n      color: #46a546; }\n    #top-menu .top-menu__info-icon--red {\n      color: #E51C23; }\n\n#side-menu {\n  position: absolute;\n  width: 48px;\n  top: 48px;\n  left: 0;\n  bottom: 30px;\n  background-color: #dedede;\n  z-index: 1029;\n  box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.25);\n  transition: all 0.3s ease; }\n  #side-menu.menu-open {\n    left: 300px !important;\n    right: 0 !important; }\n  #side-menu hr {\n    width: 24px;\n    margin: 18px 12px;\n    border-top: 1px dotted #9b9b9b;\n    border-bottom: 0; }\n  #side-menu i {\n    opacity: 1; }\n  #side-menu li {\n    text-align: center;\n    line-height: 48px; }\n  #side-menu a, #side-menu .dropdown__toggle {\n    display: block;\n    margin: 6px auto;\n    border-radius: 50%;\n    height: 36px;\n    width: 36px;\n    overflow: hidden;\n    transition: opacity 0.2s, background-color 0.2s;\n    position: relative; }\n  #side-menu a:hover, #side-menu .dropdown__toggle:hover {\n    opacity: 1;\n    background-color: rgba(255, 255, 255, 0.6); }\n  #side-menu a:active, #side-menu .dropdown__toggle:active {\n    background-color: #5ea9c8;\n    opacity: 1; }\n  #side-menu .main-icon {\n    position: absolute;\n    top: 6px;\n    left: 4px;\n    transition: left 0.2s ease-out; }\n  #side-menu .helper-icon {\n    position: absolute;\n    top: 6px;\n    left: 30px;\n    transition: left 0.2s ease-out, transform 0.2s; }\n  #side-menu .active a, #side-menu .active .dropdown__toggle {\n    background-color: #3d8fb1;\n    opacity: 1; }\n  #side-menu .dropdown--dropright {\n    display: block; }\n    #side-menu .dropdown--dropright .dropdown__menu {\n      top: -10px; }\n\n#side-menu .authoring-active .active .sd-sidebar-menu__main-icon, #side-menu .authoring-active .active .sd-sidebar-menu__helper-icon {\n  color: #fff; }\n\n#side-menu .authoring-active .active:hover .sd-sidebar-menu__main-icon {\n  left: -3rem; }\n\n#side-menu .authoring-active .active:hover .sd-sidebar-menu__helper-icon {\n  left: 0.5rem; }\n\n#side-menu .authoring-active.list-hidden .active .sd-sidebar-menu__helper-icon {\n  transform: rotate(180deg);\n  left: -3rem; }\n\n#side-menu .authoring-active.list-hidden .active:hover .sd-sidebar-menu__helper-icon {\n  left: 0.5rem; }\n\n.side-menu-hidden #side-menu {\n  display: none; }\n\n.side-menu-hidden #main-container.hideMonitoring #authoring-container {\n  width: 100% !important; }\n\n.side-menu-hidden #workspace-container {\n  left: 0; }\n\n.sd-sidetab-menu,\n.sd-sidebar-menu {\n  top: 0; }\n\n#main-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 300px;\n  background: #272727;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-user-select: none;\n  box-shadow: inset -5px 0 6px 0px #181818; }\n  #main-menu .header {\n    height: 48px;\n    width: 100%;\n    box-sizing: border-box;\n    box-shadow: 0 2px 3px 0px #202020;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.5); }\n  #main-menu .content {\n    position: absolute;\n    bottom: 190px;\n    left: 0;\n    right: 0;\n    top: 48px;\n    box-sizing: border-box;\n    overflow: auto; }\n    #main-menu .content > ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      #main-menu .content > ul > li > a {\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none;\n        display: block;\n        position: relative;\n        height: 100%;\n        box-sizing: border-box;\n        padding-left: 35px;\n        height: 37px;\n        line-height: 36px;\n        font-size: 14px;\n        color: #f0f0f0;\n        text-decoration: none;\n        text-transform: capitalize; }\n        #main-menu .content > ul > li > a i {\n          position: absolute;\n          top: 8px;\n          right: 10px;\n          opacity: 0.3;\n          filter: \"alpha(opacity=30)\"; }\n        #main-menu .content > ul > li > a:hover {\n          background: #283032;\n          border-top-color: #283032;\n          color: #3299b7;\n          cursor: pointer; }\n      #main-menu .content > ul > li ul {\n        display: none; }\n      #main-menu .content > ul > li.open > a {\n        border-bottom: 1px solid #1b1b1b;\n        box-shadow: none; }\n        #main-menu .content > ul > li.open > a i {\n          background-position: -313px -119px; }\n      #main-menu .content > ul > li.open ul {\n        display: block;\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n        box-shadow: inset 0 7px 5px -5px #202020;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none; }\n        #main-menu .content > ul > li.open ul li a {\n          color: #9e9e9e;\n          font-size: 13px;\n          line-height: 32px;\n          height: 32px;\n          padding-left: 30px;\n          text-decoration: none;\n          display: block; }\n          #main-menu .content > ul > li.open ul li a:hover {\n            color: #c8c8c8; }\n      #main-menu .content > ul > li.open + li > a {\n        border-top-color: #353535;\n        box-shadow: inset 0 -1px 0px 0px #1b1b1b, 0 -2px 2px 0px #202020; }\n      #main-menu .content > ul > li.open + li.open > a {\n        box-shadow: 0 -2px 2px 0px #202020; }\n      #main-menu .content > ul > li.active > a {\n        background: #1f1f1f;\n        color: #3299b7; }\n      #main-menu .content > ul > li.main-menu_group-header {\n        font-size: 11px;\n        text-transform: uppercase;\n        padding: 20px 0 6px 20px;\n        color: rgba(255, 255, 255, 0.5);\n        letter-spacing: 0.06em; }\n  #main-menu .footer {\n    position: absolute;\n    height: 190px;\n    box-sizing: border-box;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-top: 1px solid #1f1f1f;\n    box-shadow: inset 0 1px 0px 0px #353535, 0 -2px 3px 0px #232323;\n    text-align: center; }\n    #main-menu .footer .icon-superdesk {\n      background: url(" + escape(__webpack_require__(1362)) + ") no-repeat 0 0;\n      width: 154px;\n      height: 48px;\n      margin-top: 20px; }\n    #main-menu .footer .powered {\n      display: block;\n      color: rgba(255, 255, 255, 0.3);\n      font-size: 11px;\n      margin-top: 8px;\n      font-weight: 300; }\n    #main-menu .footer .about {\n      display: block;\n      box-sizing: border-box;\n      color: rgba(255, 255, 255, 0.9);\n      background-color: rgba(0, 0, 0, 0.3);\n      font-size: 12px;\n      margin-top: 12px;\n      font-weight: 00;\n      padding: 16px 20px;\n      font-weight: 500;\n      letter-spacing: 0.1em; }\n      #main-menu .footer .about a {\n        color: rgba(255, 255, 255, 0.9);\n        cursor: pointer; }\n\n.about-content {\n  position: relative; }\n  .about-content .sf-logo {\n    width: 110px;\n    background-size: 110px;\n    opacity: 0.5;\n    position: absolute;\n    top: 0;\n    right: 0; }\n\n@media screen and (max-width: 1180px) {\n  .top-menu.menu-open {\n    left: 300px !important;\n    right: -300px !important; } }\n\n@media screen and (max-width: 320px) {\n  .sf-main-menu {\n    width: 260px; }\n  .top-menu {\n    max-height: 40px;\n    overflow: hidden; }\n    .top-menu.menu-open {\n      left: 260px !important;\n      right: -260px !important; } }\n", ""]);

// exports


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6494665ba33bdf4948db3814dc336e8d.svg";

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

SuperdeskFlagsService.$inject = ['config'];
function SuperdeskFlagsService(config) {
    this.flags = {
        menu: false,
        notifications: false,
    };
    angular.extend(this.flags, config.ui);
}
/**
 * @ngdoc module
 * @module superdesk.core.menu
 * @name superdesk.core.menu
 * @packageName superdesk.core
 * @description The Superdesk menu module enables a configurable left-side menu.
 */
angular.module('superdesk.core.menu', [
    'superdesk.core.menu.notifications',
    'superdesk.core.privileges',
    'superdesk.core.services.asset',
    'superdesk.core.api',
])
    .service('superdeskFlags', SuperdeskFlagsService)
    // set flags for other directives
    .directive('sdSuperdeskView', ['asset', function (asset) {
        SuperdeskViewController.$inject = ['superdeskFlags', 'superdesk'];
        function SuperdeskViewController(superdeskFlags, superdesk) {
            this.flags = superdeskFlags.flags;
            this.openUpload = function openUpload(files) {
                var uploadData = {
                    files: files,
                    deskSelectionAllowed: true,
                };
                superdesk.intent('upload', 'media', uploadData);
            };
        }
        return {
            templateUrl: asset.templateUrl('core/menu/views/superdesk-view.html'),
            controller: SuperdeskViewController,
            controllerAs: 'superdesk',
        };
    }])
    .directive('sdMenuWrapper', [
    '$route',
    'superdesk',
    'betaService',
    'userNotifications',
    'asset',
    'privileges',
    'config',
    'deployConfig',
    'lodash',
    function ($route, superdesk, betaService, userNotifications, asset, privileges, config, deployConfig, _) {
        return {
            require: '^sdSuperdeskView',
            templateUrl: asset.templateUrl('core/menu/views/menu.html'),
            link: function (scope, elem, attrs, ctrl) {
                scope.currentRoute = null;
                scope.flags = ctrl.flags;
                scope.menu = [];
                scope.isTestEnvironment = config.isTestEnvironment;
                scope.environmentName = config.environmentName;
                deployConfig.get('feedback_url').then(function (url) {
                    scope.feedback_url = url;
                });
                superdesk.getMenu(superdesk.MENU_MAIN)
                    .then(filterSettingsIfEmpty)
                    .then(function (menu) {
                    scope.menu = menu;
                    setActiveMenuItem($route.current);
                });
                function filterSettingsIfEmpty(menu) {
                    return superdesk.getMenu(superdesk.MENU_SETTINGS).then(function (settingsMenu) {
                        if (!settingsMenu.length) {
                            _.remove(menu, { _settings: 1 });
                        }
                        return menu;
                    });
                }
                scope.toggleMenu = function () {
                    ctrl.flags.menu = !ctrl.flags.menu;
                };
                scope.toggleNotifications = function () {
                    ctrl.flags.notifications = !ctrl.flags.notifications;
                };
                scope.toggleBeta = function () {
                    betaService.toggleBeta();
                };
                function setActiveMenuItem(route) {
                    _.each(scope.menu, function (activity) {
                        activity.isActive = route && route.href &&
                            route.href.substr(0, activity.href.length) === activity.href;
                    });
                }
                scope.$on('$locationChangeStart', function () {
                    ctrl.flags.menu = false;
                });
                scope.$watch(function currentRoute() {
                    return $route.current;
                }, function (route) {
                    if (!route) {
                        return;
                    }
                    scope.currentRoute = route;
                    setActiveMenuItem(scope.currentRoute);
                    ctrl.flags.workspace = !!route.sideTemplateUrl;
                    ctrl.flags.workqueue = ctrl.flags.workqueue || true;
                });
                scope.notifications = userNotifications;
                privileges.loaded.then(function () {
                    scope.privileges = privileges.privileges;
                });
                scope.openAbout = function () {
                    scope.aboutActive = true;
                };
                scope.closeAbout = function () {
                    scope.aboutActive = false;
                };
            },
        };
    }
])
    .directive('sdAbout', ['asset', 'config', 'api', function (asset, config, api) {
        return {
            templateUrl: asset.templateUrl('core/menu/views/about.html'),
            link: function (scope) {
                api.query('backend_meta', {}).then(function (metadata) {
                    scope.build_rev = config.version || metadata.meta_rev;
                    scope.modules = metadata.modules;
                });
                scope.version = config.version;
                scope.year = (new Date()).getUTCFullYear();
                scope.releaseDate = config.releaseDate;
            },
        };
    }]);


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
UserNotificationsService.$inject = [
    '$rootScope',
    '$timeout',
    'api',
    'session',
    'SESSION_EVENTS',
    'sdActivityMessage',
    'preferencesService',
];
function UserNotificationsService($rootScope, $timeout, api, session, SESSION_EVENTS, sdActivityMessage, preferencesService) {
    var _this = this;
    var UPDATE_TIMEOUT = 500;
    this._items = null;
    this.unread = 0;
    /**
     * Get notifications filter for current user based on his type
     *
     * for type 'user' it will only get content notifications,
     * for administrators it will get all notifications (eg. ingest).
     *
     * @return {Object}
     */
    function getFilter() {
        var filter = { 'recipients.user_id': session.identity._id };
        // filter out system messages for non-admin users
        if (session.identity.user_type === 'user') {
            filter.user = { $exists: true };
        }
        return filter;
    }
    // reload notifications
    this.reload = function () {
        if (!session.identity) {
            _this._items = null;
            _this.unread = 0;
            return;
        }
        var criteria = {
            where: getFilter(),
            max_results: 8,
            embedded: { user: 1 },
        };
        return api.query('activity', criteria)
            .then(function (response) {
            _this._items = response._items;
            _this.unread = 0;
            var identity = session.identity || {};
            lodash_1.default.each(_this._items, function (item) {
                var recipients = item.recipients || {};
                item._unread = !isRead(recipients, identity._id);
                _this.unread += item._unread ? 1 : 0;
                item.message = utils_1.gettext(item.message, item.data);
            });
        });
    };
    // mark an item as read
    this.markAsRead = function (notification) {
        var _this = this;
        var _notification = angular.extend({}, notification);
        var recipients = notification.recipients;
        var recipient = lodash_1.default.find(recipients, { user_id: session.identity._id });
        if (recipient && !recipient.read) {
            recipient.read = true;
            return api('activity', { embedded: { user: 1 } })
                .save(_notification, { recipients: recipients })
                .then(function () {
                _this.unread = lodash_1.default.max([0, _this.unread - 1]);
                notification._unread = null;
            });
        }
    };
    // Returns the filtered recipients for given user id
    function getFilteredRecipients(activity, userId) {
        return lodash_1.default.find(activity, { user_id: userId });
    }
    // Checks if the current message is read
    function isRead(activity, userId) {
        var userReadRecord = getFilteredRecipients(activity, userId);
        return userReadRecord && userReadRecord.read;
    }
    // Checks if the user in the message is the current user
    function isCurrentUser(extras) {
        var dest = extras._dest || [];
        return session.identity && getFilteredRecipients(dest, session.identity._id);
    }
    this.reload();
    session.getIdentity().then(function () {
        $rootScope.$on('user:mention', function (_e, extras) {
            if (isCurrentUser(extras)) {
                $timeout(_this.reload, UPDATE_TIMEOUT, false);
            }
        });
        $rootScope.$on('activity', function (_e, extras) {
            if (isCurrentUser(extras)) {
                $timeout(_this.reload, UPDATE_TIMEOUT, false);
                // check for permission and send a desktop notificiation
                preferencesService.desktopNotification.send(sdActivityMessage.format(extras.activity));
            }
        });
    });
    $rootScope.$on(SESSION_EVENTS.LOGIN, this.reload);
}
DeskNotificationsService.$inject = ['$rootScope', 'api', 'session'];
function DeskNotificationsService($rootScope, api, session) {
    this._items = {};
    this.unread = {};
    /**
     * Get notifications filter for current desk
     * Api will return the last 24 hours of notifications
     *
     * @return {Object}
     */
    function getFilter() {
        var filter = { 'recipients.desk_id': { $exists: true } };
        return filter;
    }
    this.getUnreadCount = function (deskId) {
        return this.unread[deskId] || 0;
    };
    this.getNotifications = function (deskId) {
        return this._items && this._items[deskId];
    };
    // reload notifications
    this.reload = function () {
        var _this = this;
        var criteria = {
            where: getFilter(),
            embedded: {
                item: 1,
                user: 1,
            },
            max_results: 20,
        };
        return api.query('activity', criteria)
            .then(function (response) {
            _this._items = {};
            _this.unread = {};
            lodash_1.default.each(response._items, function (item) {
                var recipients = item.recipients || {};
                lodash_1.default.each(recipients, function (recipient) {
                    if (recipient.desk_id) {
                        if (!(recipient.desk_id in _this.unread)) {
                            _this._items[recipient.desk_id] = [];
                            _this.unread[recipient.desk_id] = 0;
                        }
                        _this._items[recipient.desk_id].push(item);
                        _this.unread[recipient.desk_id] += !isRead(recipients, recipient.desk_id) ? 1 : 0;
                    }
                });
            });
        });
    };
    // mark an item as read
    this.markAsRead = function (notification, deskId) {
        var _this = this;
        var _notification = angular.extend({}, notification);
        var recipients = lodash_1.default.clone(notification.recipients);
        var recipient = lodash_1.default.find(recipients, { desk_id: deskId });
        if (recipient && !recipient.read) {
            recipient.read = true;
            recipient.user_id = session.identity._id;
            return api('activity', { embedded: { user: 1 } })
                .save(_notification, { recipients: recipients })
                .then(function () {
                _this.unread = lodash_1.default.max([0, _this.unread - 1]);
                notification._unread = null;
            });
        }
    };
    /**
     * Checks if the message for desk id is read
     *
     * @param {object} recipients: the list of recipients
     * @param {object} deskId: id of the desk mentioned
     * @return {boolean}
     */
    function isRead(recipients, deskId) {
        var deskReadRecord = lodash_1.default.find(recipients, { desk_id: deskId });
        return deskReadRecord && deskReadRecord.read;
    }
    this.reload();
    var reload = angular.bind(this, this.reload);
    $rootScope.$on('desk:mention', reload);
}
/**
 * Schedule marking an item as read. If the scope is destroyed before it will keep it unread.
 */
MarkAsReadDirective.$inject = ['userNotifications', '$timeout'];
function MarkAsReadDirective(userNotifications, $timeout) {
    var TIMEOUT = 1500;
    return {
        link: function (scope) {
            if (!scope.notification._unread) {
                return;
            }
            var timeout = $timeout(function () {
                userNotifications.markAsRead(scope.notification);
            }, TIMEOUT);
            scope.$on('$destroy', function () {
                $timeout.cancel(timeout);
            });
        },
    };
}
angular.module('superdesk.core.menu.notifications', ['superdesk.core.services.asset', 'superdesk.core.auth.session'])
    .service('userNotifications', UserNotificationsService)
    .service('deskNotifications', DeskNotificationsService)
    .directive('sdMarkAsRead', MarkAsReadDirective)
    .directive('sdNotifications', ['asset', 'authoringWorkspace', '$rootScope', function (asset, authoringWorkspace, $rootScope) {
        return {
            require: '^sdSuperdeskView',
            templateUrl: asset.templateUrl('core/menu/notifications/views/notifications.html'),
            link: function (scope, elem, attrs, ctrl) {
                scope.flags = ctrl.flags;
                scope.openArticle = function (notification) {
                    ctrl.flags.notifications = !ctrl.flags.notifications;
                    authoringWorkspace.edit({ _id: notification.item }, 'edit');
                };
                scope.onNotificationClick = function (notification) {
                    $rootScope.$broadcast('notification:click', { notification: notification });
                };
            },
        };
    }]);


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1366);
// scripts
__webpack_require__(1368);


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1367);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./notify.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./notify.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.notification-holder {\n  position: fixed;\n  z-index: 9050;\n  width: 340px;\n  top: -5px;\n  left: 50%;\n  margin-left: -170px;\n  overflow: hidden;\n  padding: 0 10px 10px; }\n  .notification-holder .alert {\n    box-sizing: border-box;\n    border-radius: 5px;\n    box-shadow: 0 2px 3px -2px #666;\n    padding: 15px 30px;\n    margin: 0 0 10px;\n    opacity: 0.98;\n    filter: \"alpha(opacity=98)\"; }\n    .notification-holder .alert.success {\n      border-color: #a6d5a2; }\n\n.zen-mode .notification-holder {\n  background: none; }\n", ""]);

// exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(__webpack_require__(15));
var react_1 = __importDefault(__webpack_require__(0));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var messageDisplayDurationsByType = {
    info: 3000,
    success: 3000,
    warning: 5000,
    error: 8000,
};
var NotifyComponent = /** @class */ (function (_super) {
    __extends(NotifyComponent, _super);
    function NotifyComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            messages: [],
        };
        return _this;
    }
    NotifyComponent.prototype.info = function (text, displayDuration, options) {
        this.addMessage('info', text, displayDuration, options);
    };
    NotifyComponent.prototype.success = function (text, displayDuration, options) {
        this.addMessage('success', text, displayDuration, options);
    };
    NotifyComponent.prototype.warning = function (text, displayDuration, options) {
        this.addMessage('warning', text, displayDuration, options);
    };
    NotifyComponent.prototype.error = function (text, displayDuration, options) {
        this.addMessage('error', text, displayDuration, options);
    };
    NotifyComponent.prototype.startSaving = function () {
        this.info(utils_1.gettext('Saving...'));
    };
    NotifyComponent.prototype.stopSaving = function () {
        this.pop();
    };
    NotifyComponent.prototype.removeMessage = function (indexToRemoveAt) {
        this.setState({
            messages: this.state.messages.filter(function (_, i) { return i !== indexToRemoveAt; }),
        });
    };
    // DEPRECATED (keeping for compatibility)
    // messages should be removed by text/id, not by index
    // since users can remove messages from any position from UI
    // when removing by index you are never sure which one you are removing
    NotifyComponent.prototype.pop = function () {
        this.setState({
            messages: this.state.messages.slice(0, this.state.messages.length - 1),
        });
    };
    NotifyComponent.prototype.addMessage = function (type, text, displayDuration, options) {
        var _this = this;
        if (displayDuration === void 0) { displayDuration = messageDisplayDurationsByType[type]; }
        if (options === void 0) { options = {}; }
        if (lodash_1.find(this.state.messages, lodash_1.matches({ msg: text })) !== undefined) {
            return; // add message, only if it's does not already exist
        }
        this.setState({
            messages: this.state.messages.concat({ type: type, msg: text, options: options }),
        }, function () {
            setTimeout(function () {
                _this.setState({
                    messages: _this.state.messages.filter(function (_a) {
                        var msg = _a.msg;
                        return msg !== text;
                    }),
                });
            }, displayDuration);
        });
    };
    NotifyComponent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "notification-holder" }, this.state.messages.map(function (msg, i) { return (react_1.default.createElement("div", { key: i, className: 'alert alert-' + msg.type, onClick: function () { return _this.removeMessage(i); } },
            utils_1.gettext(msg.msg),
            (msg.options == null || !msg.options.button) ? null : (react_1.default.createElement("div", { className: "pull-right" },
                react_1.default.createElement("button", { className: "btn btn--hollow btn--small", onClick: msg.options.button.onClick }, msg.options.button.label))))); })));
    };
    return NotifyComponent;
}(react_1.default.Component));
/**
 * @ngdoc module
 * @module superdesk.core.notify
 * @name superdesk.core.notify
 * @packageName superdesk.core
 * @description The notify package allows developers to display various
 * notifications for users.
 */
exports.default = angular.module('superdesk.core.notify', ['superdesk.core.translate'])
    .service('notify', [function () {
        var targetEl = document.createElement('div');
        document.body.appendChild(targetEl);
        // eslint-disable-next-line
        return react_dom_1.default.render(react_1.default.createElement(NotifyComponent, null), targetEl); // returns instance of NotifyComponent
    }]);


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(148);
__webpack_require__(1370);


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

/**
 * Gives auto height while typing on textarea elements
 *
 * Usage:
 * <div sd-auto-height></div>
 *
 * Source:
 * https://github.com/monospaced/angular-elastic/blob/master/elastic.js
 *
 */
angular.module('superdesk.core.ui.autoheight', []).directive('sdAutoHeight', ['$window', function ($window) {
        return {
            require: 'ngModel',
            restrict: 'A, C',
            link: function (scope, element, attrs, ngModel) {
                // cache a reference to the DOM element
                var ta = element[0], $ta = element;
                // ensure the element is a textarea, and browser is capable
                if (ta.nodeName !== 'TEXTAREA' || !$window.getComputedStyle) {
                    return;
                }
                // set these properties before measuring dimensions
                $ta.css({
                    overflow: 'hidden',
                    'overflow-y': 'hidden',
                    'word-wrap': 'break-word',
                });
                // force text reflow
                var text = ta.value;
                ta.value = '';
                ta.value = text;
                var $win = angular.element($window), mirrorStyle, mirrorStyleBasic = 'position: absolute; top: -999px; right: auto; bottom: auto; left: 0 ;' +
                    'overflow: hidden; -webkit-box-sizing: content-box;' +
                    '-moz-box-sizing: content-box; box-sizing: content-box;' +
                    'min-height: 0 !important; height: 0 !important; padding: 0;' +
                    'word-wrap: break-word; border: 0;', $mirror = angular.element('<textarea tabindex="-1" ' +
                    'style="' + mirrorStyleBasic + '"/>').attr('elastic', true), mirror = $mirror[0], taStyle, borderBox, boxOuter, minHeightValue, heightValue, minHeight, maxHeight, mirrored, active, copyStyle = ['font-family',
                    'font-size',
                    'font-weight',
                    'font-style',
                    'letter-spacing',
                    'line-height',
                    'text-transform',
                    'word-spacing',
                    'text-indent',
                ];
                // exit if elastic already applied (or is the mirror element)
                if ($ta.attr('elastic')) {
                    return;
                }
                // append mirror to the DOM
                if (mirror.parentNode !== document.body) {
                    angular.element(document.body).append(mirror);
                }
                // set resize and apply elastic
                $ta.css({
                    resize: 'none',
                });
                $ta.attr('elastic', true);
                /*
                 * methods
                 */
                function initMirror() {
                    mirrored = ta;
                    taStyle = $window.getComputedStyle(ta);
                    borderBox = taStyle.getPropertyValue('box-sizing') === 'border-box' ||
                        taStyle.getPropertyValue('-moz-box-sizing') === 'border-box' ||
                        taStyle.getPropertyValue('-webkit-box-sizing') === 'border-box';
                    boxOuter = !borderBox ? { width: 0, height: 0 } : {
                        width: parseInt(taStyle.getPropertyValue('border-right-width'), 10) +
                            parseInt(taStyle.getPropertyValue('padding-right'), 10) +
                            parseInt(taStyle.getPropertyValue('padding-left'), 10) +
                            parseInt(taStyle.getPropertyValue('border-left-width'), 10),
                        height: parseInt(taStyle.getPropertyValue('border-top-width'), 10) +
                            parseInt(taStyle.getPropertyValue('padding-top'), 10) +
                            parseInt(taStyle.getPropertyValue('padding-bottom'), 10) +
                            parseInt(taStyle.getPropertyValue('border-bottom-width'), 10),
                    };
                    minHeightValue = parseInt(taStyle.getPropertyValue('min-height'), 10);
                    heightValue = parseInt(taStyle.getPropertyValue('height'), 10);
                    minHeight = Math.max(minHeightValue, heightValue) - boxOuter.height;
                    maxHeight = parseInt(taStyle.getPropertyValue('max-height'), 10);
                }
                function setMirrorStyle() {
                    taStyle = $window.getComputedStyle(ta);
                    mirrorStyle = mirrorStyleBasic;
                    angular.forEach(copyStyle, function (val) {
                        mirrorStyle += val + ':' + taStyle[val] + ';';
                    });
                    mirror.setAttribute('style', mirrorStyle);
                }
                function adjust() {
                    var taHeight, taComputedStyleWidth, mirrorHeight, width, overflow;
                    if (mirrored !== ta) {
                        initMirror();
                    }
                    setMirrorStyle();
                    // active flag prevents actions in function from calling adjust again
                    if (!active) {
                        active = true;
                        mirror.value = ta.value; // optional whitespace to improve animation
                        mirror.style.overflowY = ta.style.overflowY;
                        taHeight = ta.style.height === '' ? 'auto' : parseInt(ta.style.height, 10);
                        taComputedStyleWidth = $window.getComputedStyle(ta).getPropertyValue('width');
                        // ensure getComputedStyle has returned a readable 'used value' pixel width
                        if (taComputedStyleWidth.substr(taComputedStyleWidth.length - 2, 2) === 'px') {
                            // update mirror width in case the textarea width has changed
                            width = parseInt(taComputedStyleWidth, 10) - boxOuter.width;
                            mirror.style.width = width + 'px';
                        }
                        mirrorHeight = mirror.scrollHeight;
                        if (mirrorHeight > maxHeight) {
                            mirrorHeight = maxHeight;
                            overflow = 'scroll';
                        }
                        else if (mirrorHeight < minHeight) {
                            mirrorHeight = minHeight;
                        }
                        mirrorHeight += boxOuter.height;
                        ta.style.overflowY = overflow || 'hidden';
                        if (taHeight !== mirrorHeight) {
                            ta.style.height = mirrorHeight + 'px';
                        }
                        // small delay to prevent an infinite loop
                        _.delay(function () {
                            active = false;
                        }, 1);
                    }
                }
                function forceAdjust() {
                    active = false;
                    adjust();
                }
                /*
                 * initialise
                 */
                // listen
                if ('onpropertychange' in ta && 'oninput' in ta) {
                    // IE9
                    ta.oninput = ta.onkeyup = adjust;
                }
                else {
                    ta.oninput = adjust;
                }
                $win.bind('resize', forceAdjust);
                scope.$watch(function () { return ngModel.$modelValue; }, function (newval, oldval) {
                    if (newval !== oldval) {
                        forceAdjust();
                    }
                });
                _.defer(adjust);
                /*
                 * destroy
                 */
                scope.$on('$destroy', function () {
                    $mirror.remove();
                    $win.unbind('resize', forceAdjust);
                });
            },
        };
    }]);


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc module
 * @module superdesk.core.upload
 * @name superdesk.core.upload
 * @packageName superdesk.core
 * @description The upload module provides functionality for uploading media
 * such as video or imagery.
 */
__webpack_require__(1372);
// scripts
__webpack_require__(1375);
__webpack_require__(1376);
__webpack_require__(547);
__webpack_require__(1377);
__webpack_require__(1378);
__webpack_require__(1379);
__webpack_require__(1380);


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1373);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./upload.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./upload.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  margin: -1px 0;\n  position: fixed;\n  right: 10px; }\n\n::-webkit-scrollbar:hover {\n  background-color: #e8e8e8;\n  cursor: pointer; }\n\n::-webkit-scrollbar-thumb {\n  background: #bbb; }\n\n::-webkit-scrollbar-thumb:hover {\n  background: #777;\n  cursor: pointer; }\n\n/*\n    ----------------------------------------------------------------------\n    INPUT ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.sdselect {\n  width: 210px;\n  position: relative; }\n  .sdselect.open {\n    box-shadow: 0px 0px 5px 0px #d0d0d0 !important; }\n    .sdselect.open .sdselect-btn {\n      border-bottom: 0 !important; }\n  .sdselect:hover .sdselect-btn {\n    cursor: pointer; }\n  .sdselect .sdselect-btn {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 2px;\n    border: 1px solid #d0d0d0;\n    padding: 6px;\n    height: 27px;\n    outline: none !important;\n    box-shadow: inset 0 0 0 #000 !important;\n    box-shadow: none !important;\n    text-decoration: none;\n    color: #333;\n    line-height: 15px;\n    font-size: 12px; }\n    .sdselect .sdselect-btn .caret {\n      margin: 5px 3px 0 0; }\n  .sdselect .sdselect-menu {\n    position: absolute;\n    background: #fff;\n    z-index: 10;\n    top: 26px;\n    left: 0;\n    right: 0;\n    height: auto;\n    border: 1px solid #d0d0d0;\n    border-radius: 0 0 2px 2px; }\n    .sdselect .sdselect-menu .sdselect-filter {\n      padding: 2px 7px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"] {\n        height: 21px !important;\n        padding: 3px !important;\n        border: 0 !important;\n        min-height: 0;\n        box-shadow: 0 0 0 0 #000; }\n        .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"]:focus {\n          box-shadow: 0 0 0 0 #000 !important; }\n    .sdselect .sdselect-menu .sdselect-all {\n      padding: 4px 9px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-all a {\n        text-decoration: none;\n        font-size: 9px;\n        text-transform: uppercase;\n        color: #989898;\n        margin-right: 10px; }\n        .sdselect .sdselect-menu .sdselect-all a:hover {\n          cursor: pointer;\n          color: #666; }\n    .sdselect .sdselect-menu .list-holder {\n      height: auto;\n      max-height: 150px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      margin: 7px 0; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar {\n        border-left: 5px solid #fff;\n        border-right: 5px solid #fff;\n        width: 13px;\n        background: #fff; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar:hover {\n          background: #e8e8e8; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb {\n        border-left: 4px solid #fff;\n        border-right: 4px solid #fff;\n        background: #bbb; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb:hover {\n          background: #787878; }\n    .sdselect .sdselect-menu ul li a {\n      display: block;\n      padding: 3px 7px;\n      font-size: 12px;\n      color: #333;\n      text-decoration: none; }\n      .sdselect .sdselect-menu ul li a:hover {\n        cursor: pointer;\n        color: #fff;\n        background: #0083c4; }\n      .sdselect .sdselect-menu ul li a i {\n        margin-right: 5px;\n        vertical-align: middle;\n        margin-top: -4px;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n\n.searchbar {\n  border-radius: 2px !important;\n  background: url(" + escape(__webpack_require__(75)) + ") no-repeat 9px 4px #ffffff !important;\n  padding: 0 0 0 35px !important; }\n  .searchbar.searchbar-large {\n    background-position: 9px 7px !important;\n    height: 32px !important;\n    font-size: 15px;\n    line-height: 26px; }\n\n.flat-searchbar {\n  flex-grow: 0; }\n  .flat-searchbar .search-handler {\n    min-width: 48px;\n    height: 48px;\n    padding: 10px 10px 10px 14px;\n    box-sizing: border-box;\n    background: none;\n    display: flex;\n    border-right: 1px solid #e0e0e0;\n    white-space: nowrap;\n    transition: all 0.3s ease; }\n    .flat-searchbar .search-handler input {\n      height: 28px;\n      line-height: 100%;\n      font-size: 14px;\n      border: 0 !important;\n      width: 0;\n      padding: 0;\n      background-color: rgba(255, 255, 255, 0);\n      transition: all 0.3s ease; }\n      .flat-searchbar .search-handler input:focus {\n        box-shadow: none !important; }\n    .flat-searchbar .search-handler .trigger-icon {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -o-user-select: none;\n      user-select: none;\n      -webkit-touch-callout: none;\n      -khtml-user-select: none;\n      -ms-user-select: none;\n      float: left;\n      width: 28px;\n      height: 28px;\n      display: inline-block;\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\"; }\n      .flat-searchbar .search-handler .trigger-icon:hover {\n        cursor: pointer;\n        opacity: 0.8;\n        filter: \"alpha(opacity=80)\"; }\n      .flat-searchbar .search-handler .trigger-icon i {\n        padding: 7px 3px 4px 6px; }\n  .flat-searchbar .separator-handler {\n    margin: 9px 0 0 5px;\n    border-right: 2px dotted #bcbcbc;\n    height: 30px;\n    float: left; }\n  .flat-searchbar .search-close {\n    border: 0;\n    background: none;\n    display: none;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n    .flat-searchbar .search-close.visible {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n      .flat-searchbar .search-close.visible:hover {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n  .flat-searchbar.extended {\n    flex-grow: 1; }\n    .flat-searchbar.extended .search-handler {\n      border-right: 1px solid #e0e0e0; }\n      .flat-searchbar.extended .search-handler input {\n        width: auto;\n        padding: 0 6px; }\n    .flat-searchbar.extended .separator-handler {\n      margin-left: 14px; }\n    .flat-searchbar.extended .search-close {\n      display: inline-block; }\n\n.ui-responsive-small .flat-searchbar.extended {\n  position: absolute;\n  z-index: 2; }\n\n.monitoring-backlink .separator-handler {\n  margin-top: 0;\n  margin-right: 10px; }\n\n.filter-type {\n  white-space: nowrap; }\n  .filter-type__item {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 3px 2px;\n    cursor: pointer; }\n    .filter-type__item i {\n      height: auto;\n      color: #999;\n      padding: 2px 8px 1px 8px;\n      background: rgba(255, 255, 255, 0.5);\n      border: 1px solid rgba(215, 215, 215, 0.7);\n      border-radius: 2px;\n      box-sizing: border-box; }\n    .filter-type__item a {\n      height: 21px;\n      font-size: 11px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n      line-height: 21px;\n      text-decoration: none;\n      padding: 4px 10px;\n      border-radius: 2px;\n      border: 1px solid #999;\n      box-sizing: border-box;\n      text-transform: uppercase;\n      background: #fff !important;\n      color: #333;\n      opacity: 0.7; }\n      .filter-type__item a:hover {\n        color: #000;\n        opacity: 1; }\n      .filter-type__item a.filter-type__link--blue {\n        border-color: #5ea9c8;\n        color: #5ea9c8; }\n      .filter-type__item a.filter-type__link--dark-blue {\n        border-color: #216278;\n        color: #216278; }\n    .filter-type__item:hover i {\n      background: rgba(255, 255, 255, 0.8);\n      border: 1px solid #aaaaaa;\n      color: #666; }\n    .filter-type__item--active i {\n      opacity: 1;\n      color: #F5F5F5;\n      background: #505050;\n      border-color: #505050;\n      box-shadow: inset 0 1px 0px #373737 !important; }\n    .filter-type__item--active a {\n      opacity: 1;\n      background: #505050 !important;\n      border-color: #373737 #505050 #505050 !important;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0px #373737 !important; }\n    .filter-type__item--active:hover i {\n      border-color: rgba(80, 80, 80, 0.8);\n      background-color: rgba(80, 80, 80, 0.8);\n      color: #F5F5F5; }\n    .filter-type__item--active:hover a {\n      opacity: 0.8; }\n\n.filter-type--padded {\n  padding: 10px 0 10px 20px; }\n\n.result-type {\n  margin-left: 10px; }\n\n.dropdown__menu .filter-type {\n  padding: 0 10px; }\n\n.dropdown__menu--compare-versions {\n  max-height: 400px;\n  min-width: 250px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--compare-versions li {\n    margin-bottom: 2px;\n    line-height: 14px !important; }\n    .dropdown__menu--compare-versions li .dropdown.open li .dropdown .dropdown__toggle:hover {\n      display: none; }\n    .dropdown__menu--compare-versions li button {\n      width: 300px;\n      padding-right: 30px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      position: relative;\n      border-radius: 0;\n      line-height: 14px !important;\n      box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.15); }\n      .dropdown__menu--compare-versions li button i {\n        position: absolute;\n        right: -5px;\n        top: 9px; }\n      .dropdown__menu--compare-versions li button.disabled, .dropdown__menu--compare-versions li button.disabled:hover {\n        background: #f0f0f0; }\n        .dropdown__menu--compare-versions li button.disabled i, .dropdown__menu--compare-versions li button.disabled:hover i {\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\"; }\n      .dropdown__menu--compare-versions li button .headline {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-size: 11px;\n        font-weight: 500;\n        width: 240px;\n        display: inline-block; }\n      .dropdown__menu--compare-versions li button .desk-details {\n        display: flex;\n        font-size: 10px;\n        margin: 4px 0; }\n        .dropdown__menu--compare-versions li button .desk-details span:first-of-type {\n          flex-grow: 1; }\n      .dropdown__menu--compare-versions li button em {\n        font-size: 10px;\n        font-weight: 500;\n        color: #888;\n        float: left;\n        padding-right: 10px; }\n    .dropdown__menu--compare-versions li .msg {\n      padding: 0 20px; }\n\n.dropdown__menu .fieldset button {\n  text-align: center;\n  width: auto;\n  min-width: 50px;\n  clear: none;\n  margin-right: 10px;\n  float: right; }\n\n.online-users {\n  float: left;\n  height: 48px;\n  padding-left: 15px;\n  margin-left: 5px; }\n  .online-users > * {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    padding: 16px 0;\n    line-height: 13px; }\n\n[sd-timezone] .timezone-label {\n  margin-bottom: 1rem; }\n\n[sd-timezone] .input-term input {\n  height: 3.2rem;\n  margin-bottom: 5px;\n  width: 100%;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  border: none;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.3rem;\n  color: inherit;\n  padding-left: 1rem; }\n  [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(0, 0, 0, 0.3);\n    background-color: rgba(0, 0, 0, 0.1); }\n  [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[sd-timezone] .item-list {\n  width: 100%;\n  color: #333; }\n\n[sd-timezone] .pills-list li {\n  padding: 0.7rem 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 1.3rem; }\n  [sd-timezone] .pills-list li .icon-remove-sign {\n    color: inherit; }\n  [sd-timezone] .pills-list li #timezone {\n    padding-right: 2.5rem;\n    flex-grow: 1; }\n\n[class^=\"--dark-ui\"] [sd-timezone] .input-term input,\n[class*=\"--dark-ui\"] [sd-timezone] .input-term input {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:hover,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:focus,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input, .timepicker-input {\n  position: relative;\n  width: auto;\n  min-width: 130px; }\n  .datepicker-input input, .timepicker-input input {\n    width: 100%;\n    transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n    padding-right: 3.2rem;\n    padding-left: 1rem;\n    min-height: 2.8rem;\n    border: none;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    font-size: 1.3rem;\n    color: inherit; }\n    .datepicker-input input:hover, .timepicker-input input:hover {\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n      background-color: rgba(0, 0, 0, 0.1); }\n    .datepicker-input input:focus, .timepicker-input input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n    .datepicker-input input.ng-invalid, .timepicker-input input.ng-invalid {\n      color: #d10000;\n      border-color: #b61818 !important;\n      box-shadow: 0 1px 0 0 #b61818 !important; }\n  .datepicker-input .icn-btn, .timepicker-input .icn-btn {\n    position: absolute;\n    right: 2px;\n    top: 0; }\n\n.datepicker-input--dark input, .timepicker-input--dark input {\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 1.3rem;\n  line-height: 1.8rem;\n  color: inherit;\n  min-height: 32px; }\n  .datepicker-input--dark input:hover, .timepicker-input--dark input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  .datepicker-input--dark input:focus, .timepicker-input--dark input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input--dark .icn-btn, .timepicker-input--dark .icn-btn {\n  background: transparent;\n  top: 50%;\n  margin-top: -14px; }\n\n.datepicker-input--dark .name, .timepicker-input--dark .name {\n  background-color: #4f4f4f;\n  height: 24px;\n  font-size: 12px;\n  color: #fff; }\n\n.datepicker-input--dark ul > li, .timepicker-input--dark ul > li {\n  width: 90%; }\n\n.datepicker-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 260px;\n  box-sizing: border-box; }\n  .datepicker-wrapper .btn {\n    height: 28px; }\n    .datepicker-wrapper .btn:hover {\n      box-shadow: none; }\n  .datepicker-wrapper .btn--mini {\n    padding: 4px 6px;\n    font-size: 11px;\n    line-height: 11px !important;\n    height: auto; }\n  .datepicker-wrapper table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 0; }\n    .datepicker-wrapper table td, .datepicker-wrapper table th {\n      padding: 1px;\n      border: 0; }\n  .datepicker-wrapper .datepicker-additional {\n    margin-bottom: 5px; }\n    .datepicker-wrapper .datepicker-additional table {\n      width: 100%; }\n    .datepicker-wrapper .datepicker-additional .btn {\n      width: 100%; }\n  .datepicker-wrapper .datepicker-core table {\n    width: 100%; }\n    .datepicker-wrapper .datepicker-core table thead tr th .btn {\n      background: none;\n      padding: 0; }\n    .datepicker-wrapper .datepicker-core table thead tr:last-child th small {\n      font-weight: 500; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn strong {\n      font-weight: normal;\n      font-size: 14px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn i {\n      display: inline-block;\n      width: 14px;\n      height: 14px;\n      background-repeat: no-repeat; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:first-child .btn i {\n      margin-left: 3px;\n      background-position: -189px -165px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:last-child .btn i {\n      margin-right: 3px;\n      background-position: -213px -165px; }\n    .datepicker-wrapper .datepicker-core table tbody tr:first-child td {\n      padding-top: 5px; }\n    .datepicker-wrapper .datepicker-core table tbody td {\n      padding: 0 2px; }\n      .datepicker-wrapper .datepicker-core table tbody td .btn {\n        width: 100% !important;\n        min-width: 28px !important;\n        padding: 0;\n        background: none;\n        color: #333;\n        box-shadow: none; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn .text-muted {\n          color: #999; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn:hover, .datepicker-wrapper .datepicker-core table tbody td .btn.active {\n          color: #333;\n          box-shadow: inset 0 0 1px 0 #5ea9c8;\n          background: #eff7fa; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active {\n          color: #fff;\n          background: #5ea9c8; }\n          .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary .text-muted, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active .text-muted {\n            color: #fff; }\n\n.timepicker-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 200px;\n  height: 310px;\n  box-sizing: border-box; }\n  .timepicker-popup .timepicker-additional {\n    margin-bottom: 5px; }\n    .timepicker-popup .timepicker-additional table {\n      width: 100%;\n      border-collapse: collapse;\n      border: 0; }\n      .timepicker-popup .timepicker-additional table td, .timepicker-popup .timepicker-additional table th {\n        padding: 1px; }\n    .timepicker-popup .timepicker-additional .btn {\n      width: 100%;\n      letter-spacing: 0; }\n    .timepicker-popup .timepicker-additional .btn--mini {\n      padding: 4px 6px;\n      font-size: 11px;\n      line-height: 11px !important;\n      height: 20px; }\n  .timepicker-popup .timepicker-core .select-area {\n    margin-top: 15px;\n    border-top: 1px solid #ddd; }\n    .timepicker-popup .timepicker-core .select-area .header {\n      margin-top: -10px;\n      float: left;\n      background: #fff;\n      text-transform: uppercase;\n      color: #adadad;\n      font-size: 11px;\n      padding-right: 10px; }\n    .timepicker-popup .timepicker-core .select-area ul {\n      padding-top: 15px;\n      *zoom: 1; }\n      .timepicker-popup .timepicker-core .select-area ul:before, .timepicker-popup .timepicker-core .select-area ul:after {\n        display: table;\n        content: \"\"; }\n      .timepicker-popup .timepicker-core .select-area ul:after {\n        clear: both; }\n      .timepicker-popup .timepicker-core .select-area ul > li {\n        float: left;\n        box-sizing: border-box;\n        width: 28px;\n        height: 28px;\n        line-height: 28px;\n        text-align: center;\n        margin: 0 2px 2px 0;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none;\n        border-radius: 2px; }\n        .timepicker-popup .timepicker-core .select-area ul > li:hover {\n          background: #eff7fa;\n          cursor: pointer; }\n        .timepicker-popup .timepicker-core .select-area ul > li.active {\n          background: #5ea9c8;\n          color: #fff; }\n\n.pills-list.line-input > li {\n  width: 100%;\n  border-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background-color: transparent;\n  padding: 0;\n  height: 24px;\n  box-shadow: none; }\n  .pills-list.line-input > li .actions {\n    top: -9px; }\n  .pills-list.line-input > li:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: transparent !important;\n    box-shadow: none; }\n  .pills-list.line-input > li:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important;\n    background-color: transparent !important; }\n\n/*\n    ----------------------------------------------------------------------\n    OTHER CUSTOM ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.backlink, a.backlink {\n  text-decoration: none !important;\n  color: #333;\n  border: 0;\n  transition: all ease 0.2s;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  padding: 0;\n  margin: 0;\n  cursor: pointer; }\n  .backlink:before, a.backlink:before {\n    font-family: 'sd_icons';\n    font-weight: normal;\n    font-style: normal;\n    content: \"\\E677\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n    flex-grow: 0;\n    margin: -1px 8px 0 0;\n    text-decoration: none !important;\n    transition: all ease 0.2s;\n    opacity: 0.7; }\n  .backlink.white, a.backlink.white {\n    color: #fff; }\n  .backlink:hover, a.backlink:hover {\n    color: #5ea9c8;\n    text-decoration: none !important; }\n    .backlink:hover:before, a.backlink:hover:before {\n      text-decoration: none !important;\n      margin: -1px 10px 0 -2px;\n      opacity: 1; }\n\n.stage-header__name a {\n  transition: all ease 0.2s; }\n\n.widget-content .stage-header__name a {\n  text-decoration: none !important; }\n\n.activity-log {\n  margin-top: 10px; }\n  .activity-log ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; }\n    .activity-log ul li.activity .activity-content {\n      padding-left: 45px;\n      margin-top: -3px;\n      padding-right: 20px;\n      color: #555; }\n      .activity-log ul li.activity .activity-content b {\n        font-weight: 500; }\n    .activity-log ul li.activity .activity-date {\n      padding-left: 45px;\n      font-size: 11px;\n      color: #999;\n      margin-top: -5px; }\n    .activity-log ul li.activity.with-date {\n      margin-top: 35px; }\n      .activity-log ul li.activity.with-date .date {\n        border-top: 1px solid #ebebeb;\n        top: -17px;\n        position: absolute;\n        right: 0;\n        left: 0; }\n        .activity-log ul li.activity.with-date .date span {\n          font-size: 12px;\n          color: #999;\n          margin-top: -10px;\n          display: block;\n          float: left;\n          background: #f8f8f8;\n          padding-right: 5px; }\n    .activity-log ul li.activity:hover {\n      cursor: default; }\n\n.activity-load-more {\n  width: 100%;\n  font-size: 12px;\n  margin: 20px 0; }\n\n.notification-list {\n  margin: 0;\n  margin-bottom: 20px;\n  list-style-type: none; }\n  .notification-list li {\n    background: #393939;\n    padding: 10px 5px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    width: 100%;\n    min-height: 45px;\n    margin: 10px 0;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5); }\n    .notification-list li .content {\n      padding-left: 40px; }\n      .notification-list li .content .text {\n        margin: 0;\n        font-size: 12px;\n        overflow: hidden;\n        color: #d7d7d7; }\n      .notification-list li .content .date, .notification-list li .content .date time, .notification-list li .content time {\n        font-size: 11px;\n        color: #848484;\n        margin-top: -3px;\n        display: block; }\n      .notification-list li .content a {\n        cursor: pointer;\n        color: #5ea9c8; }\n        .notification-list li .content a:hover {\n          text-decoration: none;\n          color: #97c7db; }\n    .notification-list li.unread {\n      border-color: #545454;\n      background: #2c2c2c; }\n    .notification-list li.important {\n      border: 1px solid #a60101 !important;\n      box-shadow: inset 0px 0px 1px 1px #e4b2b2, 0px 2px 2px 0px #d8d8d8 !important; }\n    .notification-list li.personal, .notification-list li.important {\n      border: 1px solid #c8c8c8;\n      border-radius: 3px;\n      background: #fff;\n      padding: 5px;\n      margin-bottom: 7px;\n      box-shadow: 0px 2px 2px 0 #d8d8d8; }\n      .notification-list li.personal + li, .notification-list li.important + li {\n        border-top-width: 0; }\n        .notification-list li.personal + li.personal, .notification-list li.personal + li.important, .notification-list li.important + li.personal, .notification-list li.important + li.important {\n          border-top-width: 1px; }\n    .notification-list li .info {\n      color: #e0e0e0; }\n  .notification-list.white li {\n    background: #fff;\n    border-color: #dedede;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12); }\n    .notification-list.white li .content .text {\n      color: #333; }\n    .notification-list.white li.active {\n      border-color: #999;\n      box-shadow: 0 1px 2px 0 #666; }\n\n.notification-pane ::-webkit-scrollbar:hover {\n  background-color: #4a4a4a; }\n\n.notification-pane ::-webkit-scrollbar-thumb {\n  background: #5a5a5a; }\n\n.notification-pane ::-webkit-scrollbar-thumb:hover {\n  background: #666; }\n\n.hard-error {\n  position: fixed;\n  top: 0;\n  right: 200px;\n  z-index: 9999;\n  width: auto;\n  max-width: 400px; }\n  .hard-error .alert {\n    border-radius: 0;\n    border: 0;\n    box-sizing: border-box;\n    height: 40px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n    padding: 0 15px; }\n  .hard-error .alert-error {\n    background-color: #612525;\n    color: #cc7c7b;\n    text-shadow: none; }\n  .hard-error:hover .alert {\n    height: auto;\n    line-height: 20px;\n    padding: 10px 15px;\n    overflow: visible;\n    white-space: pre-wrap; }\n\n.sd-pagination {\n  padding: 7px 20px; }\n  .sd-pagination .btn {\n    padding: 10px; }\n    .sd-pagination .btn i {\n      margin-right: 0; }\n  .sd-pagination .page-info {\n    margin-right: 20px;\n    display: inline-block; }\n    .sd-pagination .page-info input {\n      display: inline-block;\n      width: 30px;\n      text-align: center;\n      margin-top: -1px;\n      padding: 6px 3px !important;\n      border-radius: 5px;\n      margin: 0 5px;\n      box-shadow: inset 0 5px 5px -5px #acacac; }\n  .sd-pagination .btn-group, .sd-pagination .btn-group > .btn {\n    display: inline-block;\n    vertical-align: middle;\n    float: none; }\n  .sd-pagination .btn-group > .btn + .btn {\n    margin-left: 0px; }\n\n.assignment-menu .assignment-box {\n  width: 270px; }\n  .assignment-menu .assignment-box h5 {\n    border: 0; }\n  .assignment-menu .assignment-box .assignment-content .assignment-result-list {\n    margin-top: 10px;\n    height: 140px;\n    overflow: auto; }\n    .assignment-menu .assignment-box .assignment-content .assignment-result-list ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li {\n        height: 32px;\n        margin-bottom: 3px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li .avatar-small {\n          width: 24px;\n          height: 24px;\n          border: 0;\n          padding: 0;\n          margin: 0;\n          background-size: 24px 24px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li span {\n          font-size: 13px;\n          color: #4f4f4f;\n          line-height: 24px;\n          margin-left: 10px; }\n\n.sortbar {\n  white-space: nowrap;\n  margin: 0 5px;\n  padding: 0 10px; }\n  .sortbar > * {\n    display: inline-block !important;\n    vertical-align: middle; }\n  .sortbar > .dropdown {\n    margin-right: 10px; }\n  .sortbar .lab {\n    margin-right: 10px; }\n  .sortbar .dropdown__toggle {\n    color: #808080;\n    min-width: auto !important; }\n  .sortbar .direction {\n    background: none;\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.selectionlist {\n  list-style-type: none;\n  padding: 2px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  overflow: auto; }\n  .selectionlist li {\n    line-height: 16px;\n    height: 16px;\n    padding: 4px;\n    margin-bottom: 3px;\n    border-radius: 3px;\n    background: #e8e8e8; }\n  .selectionlist .sf-toggle-custom {\n    margin-top: -1px;\n    float: right; }\n\n.plain-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n  .plain-list.plain-border-top {\n    border-top: 1px solid #e5e5e5; }\n  .plain-list > li {\n    border-bottom: 1px solid #e5e5e5;\n    height: 41px;\n    line-height: 40px;\n    cursor: pointer;\n    position: relative;\n    padding: 0 5px;\n    box-sizing: border-box; }\n    .plain-list > li:hover {\n      background: #eff7fa; }\n    .plain-list > li .btn--mini {\n      margin-top: 10px; }\n\n.plain-small > li {\n  height: 31px;\n  line-height: 30px; }\n\n.users-list > li .avatar {\n  margin-top: 5px;\n  margin-right: 15px; }\n\n.users-list > li .name {\n  font-size: 13px;\n  color: #3599b6; }\n\n.plain-small.users-list > li .avatar {\n  margin-top: 3px; }\n\n.users-list-embed {\n  position: relative; }\n  .users-list-embed > li {\n    height: 32px;\n    line-height: 32px;\n    margin-right: -5px; }\n    .users-list-embed > li .avatar {\n      margin: 3px 10px 4px 4px; }\n    .users-list-embed > li:hover, .users-list-embed > li.active {\n      cursor: pointer;\n      color: #fff; }\n    .users-list-embed > li:hover {\n      background: #84bdd5; }\n    .users-list-embed > li:active {\n      background: #97c7db; }\n    .users-list-embed > li.active {\n      background: #5ea9c8; }\n    .users-list-embed > li.inactive {\n      color: #ccc; }\n\n.mentio-menu {\n  padding: 5px;\n  border: 1px solid #ddd;\n  max-height: 126px;\n  z-index: 9999 !important;\n  overflow: auto;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);\n  width: 190px;\n  bottom: 5px; }\n  .mentio-menu ul li {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.card-list > li, .card {\n  display: block;\n  padding: 10px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  margin-bottom: 7px;\n  position: relative; }\n  .card-list > li:not([disabled]):hover, .card:not([disabled]):hover {\n    cursor: pointer;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li:not([disabled]):hover .action, .card:not([disabled]):hover .action {\n      display: block !important; }\n  .card-list > li.selected, .card.selected {\n    background-color: #eff7fa;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li.selected:hover, .card.selected:hover {\n      box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n  .card-list > li[disabled], .card[disabled] {\n    cursor: default !important;\n    background-color: rgba(255, 255, 255, 0.45); }\n  .card-list > li .action, .card .action {\n    display: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    min-width: 200px; }\n    .card-list > li .action ul, .card .action ul {\n      height: 100%;\n      text-align: right; }\n    .card-list > li .action .item-field, .card .action .item-field {\n      height: 100%; }\n      .card-list > li .action .item-field span, .card .action .item-field span {\n        display: none; }\n      .card-list > li .action .item-field a, .card .action .item-field a {\n        padding: 0 23px;\n        line-height: 62px;\n        display: block; }\n\n.active .card {\n  background-color: #eff7fa;\n  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n  .active .card:hover {\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n\n.pills-list {\n  max-width: 650px; }\n  .pills-list > li {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    background: #fff;\n    margin-bottom: 6px;\n    margin-right: 2px;\n    border-radius: 2px;\n    padding: 10px 16px;\n    min-height: 18px;\n    color: inherit;\n    position: relative;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.08);\n    transition: all ease-in-out 0.2s; }\n    .pills-list > li:hover {\n      box-shadow: 0 0px 3px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.2); }\n    .pills-list > li.active {\n      background: #5ea9c8;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0 #3e92b5; }\n    .pills-list > li.inactive {\n      opacity: 0.5; }\n    .pills-list > li.empty-info {\n      background: transparent;\n      border: 1px dotted rgba(123, 123, 123, 0.5);\n      opacity: 0.75;\n      box-shadow: none !important; }\n    .pills-list > li .dropdown {\n      margin-top: -3px; }\n    .pills-list > li .actions {\n      display: none;\n      position: absolute;\n      top: 0px;\n      right: 4px; }\n      .pills-list > li .actions button {\n        transition: opacity ease-in-out 0.2s;\n        border: 0;\n        height: 30px;\n        width: 30px;\n        margin: 3px;\n        background: none;\n        text-align: center;\n        display: block;\n        float: left;\n        line-height: 0;\n        opacity: 0.4; }\n        .pills-list > li .actions button:hover {\n          cursor: pointer;\n          opacity: 1; }\n        .pills-list > li .actions button i {\n          margin-top: -2px; }\n    .pills-list > li h6 {\n      text-transform: none;\n      color: inherit;\n      font-size: 14px;\n      font-weight: 300;\n      float: left;\n      max-width: 99%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .pills-list > li .label-group {\n      display: inline-block; }\n      .pills-list > li .label-group.label-group--right {\n        float: right; }\n    .pills-list > li .label {\n      font-size: 9px;\n      font-weight: 700;\n      padding: 2px 5px;\n      line-height: 12px;\n      margin-left: 5px;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n      font-weight: 400; }\n    .pills-list > li:hover .actions {\n      display: block !important; }\n    .pills-list > li:hover h6 {\n      max-width: 550px; }\n    .pills-list > li .avatar {\n      display: inline-block;\n      float: none; }\n    .pills-list > li h5 {\n      display: inline-block; }\n  .pills-list.pills-editable li.editable {\n    padding: 0;\n    height: auto;\n    background: transparent; }\n    .pills-list.pills-editable li.editable input {\n      height: 30px;\n      line-height: 30px;\n      border-radius: 3px; }\n\n[class^=\"--dark-ui\"] .pills-list > li,\n[class*=\"--dark-ui\"] .pills-list > li {\n  background: #4f4f4f; }\n\n.pill-small {\n  width: 200px;\n  margin: 4px; }\n\n.item-field {\n  border-left: 1px solid #d8d8d8;\n  display: inline-block; }\n  .item-field span {\n    display: none; }\n  .item-field button {\n    border: 0;\n    padding: 0;\n    background: none;\n    vertical-align: text-top; }\n  .item-field:hover {\n    background: rgba(0, 0, 0, 0.1);\n    border-color: #e0e0e0; }\n  .item-field.disabled {\n    cursor: default; }\n    .item-field.disabled i {\n      opacity: 0.3;\n      filter: \"alpha(opacity=30)\"; }\n    .item-field.disabled:hover {\n      background: #e8e8e8; }\n\n.dropdown .item-field {\n  display: block;\n  border-left: 0; }\n  .dropdown .item-field span {\n    display: inline-block; }\n\n.dropdown .item-field:hover {\n  background: none; }\n\n.or-label {\n  position: relative;\n  text-align: center;\n  font-style: italic; }\n  .or-label:before {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: -75px; }\n  .or-label:after {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: 15px; }\n\n.list-group {\n  box-sizing: border-box;\n  width: 300px; }\n  .list-group .list-group-item {\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-width: 0 1px 1px 1px;\n    background-color: #fff; }\n    .list-group .list-group-item:first-child {\n      border-width: 1px;\n      border-radius: 5px 5px 0 0; }\n    .list-group .list-group-item:last-child {\n      border-radius: 0 0 5px 5px; }\n    .list-group .list-group-item:hover {\n      background-color: #f4f4f4;\n      cursor: pointer; }\n    .list-group .list-group-item a {\n      text-decoration: none;\n      color: #444; }\n\n.shadow-list-holder {\n  overflow-y: auto;\n  width: 100%;\n  max-height: 100%;\n  min-height: 100%;\n  box-sizing: border-box; }\n\n.scroll-shadow {\n  height: 0; }\n  .scroll-shadow .inner {\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(transparent));\n    height: 4px;\n    position: relative;\n    z-index: 503;\n    transition: linear 0.1s all;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n  .scroll-shadow.shadow .inner {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n\n.toggle-box__button {\n  transition: color ease-in-out 0.2s;\n  color: #999;\n  cursor: pointer; }\n  .toggle-box__button i {\n    color: inherit;\n    margin-right: 5px;\n    vertical-align: text-bottom; }\n  .toggle-box__button:hover {\n    text-decoration: none;\n    color: #fff; }\n\n.fade {\n  transition: opacity 0.15s linear;\n  opacity: 0; }\n  .fade.in {\n    opacity: 1; }\n\n.close {\n  float: right;\n  line-height: 18px;\n  opacity: 0.2;\n  filter: \"alpha(opacity=20)\"; }\n  .close:hover {\n    text-decoration: none;\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\";\n    cursor: pointer; }\n  .close i {\n    vertical-align: middle; }\n\n.draggable-list__item {\n  background-color: #fff;\n  padding: 18px 14px 19px 25px;\n  margin-bottom: 10px;\n  cursor: move;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  position: relative; }\n  .draggable-list__item.placeholder {\n    background: none;\n    box-shadow: none;\n    border: 2px dashed #ebebeb; }\n  .draggable-list__item:after {\n    content: \"\";\n    width: 10px;\n    top: 0;\n    bottom: 0;\n    left: 2px;\n    background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 3px top 3px;\n    opacity: 0.2;\n    position: absolute;\n    display: block; }\n  .draggable-list__item:hover {\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4); }\n    .draggable-list__item:hover:after {\n      opacity: 0.8; }\n  .draggable-list__item--small {\n    padding: 10px 14px 10px 25px; }\n  .draggable-list__item--no-padding {\n    padding: 0 0 0 8px; }\n    .draggable-list__item--no-padding:after {\n      width: 6px;\n      left: 2px;\n      background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 0px top 3px; }\n\n.draggable-list.serial-decimal {\n  list-style-type: decimal !important;\n  padding-top: 0px;\n  margin-left: 5px; }\n  .draggable-list.serial-decimal > li {\n    word-spacing: 2px;\n    line-height: 0px; }\n  .draggable-list.serial-decimal .sort-item.active {\n    background-color: #eee; }\n\n.ui-resizable-e {\n  cursor: col-resize !important; }\n\n.spinner-big {\n  background-image: url(" + escape(__webpack_require__(34)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  vertical-align: middle;\n  text-align: center; }\n\n.spinner-alt {\n  background-image: url(" + escape(__webpack_require__(106)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  line-height: 32px;\n  vertical-align: middle;\n  text-align: center; }\n\n.sd-check__wrapper .sd-checkbox + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: inherit;\n  height: auto;\n  text-transform: none; }\n  .sd-check__wrapper .sd-checkbox + label.label--active {\n    color: #479dc0; }\n\n.sd-toggle + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: #333;\n  height: auto;\n  text-transform: none; }\n\n.definition-list .definition-list__term {\n  font-size: 1.6rem;\n  margin-bottom: 0.6rem;\n  font-weight: 400; }\n\n.definition-list .definition-list__item {\n  padding: 0.3rem 0;\n  margin-left: 0;\n  font-size: 1.4rem;\n  font-weight: 300; }\n\n.definition-list .definition-list__item + .definition-list__term {\n  margin-top: 2rem; }\n\n.nav-button-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 0; }\n  .nav-button-bar .btn {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.modal__header--flex .icn-btn.close, .modal__header--flex .icn-btn.close-modal, .modal__header--flex .icn-btn.modal__close {\n  margin: 0 -0.6rem 0;\n  border: 0;\n  padding: .6rem;\n  opacity: 0.5; }\n  .modal__header--flex .icn-btn.close:hover, .modal__header--flex .icn-btn.close-modal:hover, .modal__header--flex .icn-btn.modal__close:hover {\n    opacity: 0.8; }\n  .modal__header--flex .icn-btn.close:active, .modal__header--flex .icn-btn.close-modal:active, .modal__header--flex .icn-btn.modal__close:active {\n    opacity: 1; }\n\n.sd-line-input__message--with-char-count {\n  padding-right: 10rem; }\n\n.sd-list-item.inactive {\n  background-color: transparent;\n  color: rgba(123, 123, 123, 0.75); }\n\n.sd-toggle + label {\n  letter-spacing: 0; }\n\n.sd-list-item__text-label time {\n  padding: 0;\n  font-style: normal; }\n\n[sd-meta-terms] {\n  min-height: 2.8rem; }\n\n.line-input--boxed .input-term input[type=\"text\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.4rem;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 0 1rem;\n  height: 3.2rem;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  .line-input--boxed .input-term input[type=\"text\"]:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: rgba(0, 0, 0, 0.1) !important; }\n  .line-input--boxed .input-term input[type=\"text\"]:focus {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important; }\n\n.line-input--boxed .terms-list {\n  width: 100%;\n  margin-top: 0.8rem; }\n\nsd-tag-input + .sd-line-input__message {\n  margin-top: -2rem; }\n\nsd-multi-image-edit {\n  height: 100vh;\n  display: flex;\n  flex-direction: column; }\n\n.sd-wrap-helper {\n  display: contents !important; }\n\n.subnav {\n  z-index: 5; }\n\n.subnav + .subnav {\n  z-index: 4; }\n\n/*\n======================================\nuser avatar uploader\n======================================\n*/\n.upload-avatar .modal-body {\n  position: relative; }\n\n.upload-avatar .sidebar {\n  width: 200px; }\n  .upload-avatar .sidebar ul li {\n    border-bottom: 1px solid #eee;\n    padding: 7px 10px 7px 20px;\n    height: 36px;\n    line-height: 22px;\n    font-size: 13px;\n    box-sizing: border-box; }\n    .upload-avatar .sidebar ul li a {\n      color: #3599b6;\n      text-decoration: none; }\n    .upload-avatar .sidebar ul li i {\n      float: right;\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\";\n      margin-top: 2px;\n      margin-right: 4px;\n      transition: margin-right ease 0.2s; }\n    .upload-avatar .sidebar ul li [class^=\"icon-\"] {\n      float: left;\n      margin-right: 10px; }\n    .upload-avatar .sidebar ul li:hover {\n      cursor: pointer;\n      background: #f4f4f4; }\n      .upload-avatar .sidebar ul li:hover i {\n        margin-right: 0; }\n      .upload-avatar .sidebar ul li:hover [class^=\"icon-\"] {\n        margin-right: 10px; }\n    .upload-avatar .sidebar ul li.active {\n      background-color: white;\n      border-right: 1px solid white;\n      margin-right: -1px; }\n      .upload-avatar .sidebar ul li.active a {\n        color: #333; }\n      .upload-avatar .sidebar ul li.active i {\n        margin-right: 0px; }\n      .upload-avatar .sidebar ul li.active [class^=\"icon-\"] {\n        margin-right: 10px;\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n      .upload-avatar .sidebar ul li.active:hover {\n        background: #fff; }\n  .upload-avatar .sidebar .remove-avatar {\n    padding: 7px 10px 7px 20px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-top: 1px solid #eee; }\n    .upload-avatar .sidebar .remove-avatar i {\n      opacity: 0.4;\n      float: left;\n      margin-right: 10px; }\n    .upload-avatar .sidebar .remove-avatar .sd-checkbox {\n      float: right;\n      margin: 2px 0 0 0; }\n    .upload-avatar .sidebar .remove-avatar span {\n      vertical-align: middle; }\n    .upload-avatar .sidebar .remove-avatar label {\n      font-size: 11px;\n      color: #999;\n      margin: 0; }\n    .upload-avatar .sidebar .remove-avatar:hover {\n      background: #f4f4f4; }\n    .upload-avatar .sidebar .remove-avatar.active i {\n      opacity: 1; }\n\n.upload-avatar .main {\n  padding: 20px;\n  overflow: visible;\n  overflow: auto;\n  background-color: white; }\n  .upload-avatar .main .computer {\n    height: 100%; }\n    .upload-avatar .main .computer .dropzone {\n      height: 100%;\n      box-sizing: border-box;\n      border: 2px dashed #e0e0e0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center; }\n      .upload-avatar .main .computer .dropzone .text {\n        text-align: center;\n        color: #ccc;\n        font-size: 30px;\n        font-weight: 300; }\n      .upload-avatar .main .computer .dropzone .input-holder {\n        text-align: center;\n        margin: 30px auto 0;\n        width: 170px; }\n        .upload-avatar .main .computer .dropzone .input-holder input {\n          width: 100%;\n          height: auto;\n          cursor: pointer !important; }\n        .upload-avatar .main .computer .dropzone .input-holder input::-webkit-file-upload-button {\n          visibility: hidden; }\n        .upload-avatar .main .computer .dropzone .input-holder input:before {\n          content: attr(label);\n          display: inline-block;\n          background: -webkit-linear-gradient(top, #f9f9f9, #fff);\n          border: 1px solid #d0d0d0;\n          border-radius: 2px;\n          padding: 0 10px;\n          outline: none;\n          white-space: nowrap;\n          -webkit-user-select: none;\n          text-shadow: 1px 1px #fff;\n          font-size: 12px;\n          color: #787878;\n          box-sizing: border-box;\n          width: 100%;\n          text-align: center;\n          cursor: pointer !important; }\n        .upload-avatar .main .computer .dropzone .input-holder input:focus {\n          outline: none !important; }\n        .upload-avatar .main .computer .dropzone .input-holder input:hover:before {\n          border-color: #c0c0c0;\n          cursor: pointer !important; }\n        .upload-avatar .main .computer .dropzone .input-holder input:active:before {\n          background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);\n          outline: none; }\n  .upload-avatar .main .camera video {\n    box-sizing: border-box;\n    width: 100%; }\n  .upload-avatar .main .preview .crop-area {\n    position: absolute;\n    top: 50px;\n    left: 20px;\n    right: 20px;\n    bottom: 20px; }\n    .upload-avatar .main .preview .crop-area .original {\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 300px; }\n      .upload-avatar .main .preview .crop-area .original img {\n        width: 100%; }\n    .upload-avatar .main .preview .crop-area .preview {\n      position: absolute;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      left: 300px; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large {\n        width: 120px;\n        height: 120px;\n        overflow: hidden;\n        margin: 0 15px 30px 15px; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-4-3-small {\n        width: 300px;\n        height: 225px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-4-3-medium {\n        width: 400px;\n        height: 300px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-4-3-large {\n        width: 800px;\n        height: 600px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-16-9-small {\n        width: 300px;\n        height: 169px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-16-9-medium {\n        width: 400px;\n        height: 225px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-large-16-9-large {\n        width: 1280px;\n        height: 720px;\n        overflow: hidden;\n        margin: 0 15px 30px 35px;\n        float: right; }\n      .upload-avatar .main .preview .crop-area .preview .preview-round {\n        width: 60px;\n        height: 60px;\n        overflow: hidden;\n        margin: 0 45px 30px 45px;\n        border-radius: 30px; }\n    .upload-avatar .main .preview .crop-area.image {\n      top: 200px; }\n      .upload-avatar .main .preview .crop-area.image .loading {\n        background: url(" + escape(__webpack_require__(34)) + ") no-repeat center; }\n  .upload-avatar .main .preview .cords-label {\n    color: #999; }\n\n.upload-progress {\n  position: absolute;\n  height: 2px;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n  background: #f0f0f0; }\n  .upload-progress .bar {\n    height: 2px;\n    background: #5ea9c8; }\n\n/*\n======================================\nmedia uploader\n======================================\n*/\n.upload-media .modal__body {\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden !important;\n  padding: 0 !important; }\n\n.upload-media .drag-area {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow-y: auto;\n  border: none !important;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-user-select: none; }\n\n.upload-media .upload-edit {\n  z-index: 1;\n  padding: 20px;\n  flex: 1 1 auto;\n  overflow-y: auto;\n  position: relative; }\n  .upload-media .upload-edit.error {\n    top: 40px; }\n  .upload-media .upload-edit .upload-thumbs .flex-grid__item {\n    min-height: 350px;\n    background: #fff; }\n    .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb {\n      border-radius: 3px 3px 0 0;\n      overflow: hidden;\n      position: relative; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .holder {\n        height: 200px;\n        background-color: #F5F5F5;\n        position: relative;\n        line-height: 205px; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .holder i {\n          position: absolute;\n          top: 50%;\n          margin-top: -25px;\n          left: 50%;\n          margin-left: -30px;\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\";\n          z-index: 1; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .holder img {\n          width: 100%;\n          position: relative;\n          z-index: 2;\n          display: inline-block;\n          vertical-align: middle; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .holder .failed {\n          position: absolute;\n          left: 0;\n          right: 0;\n          top: 0;\n          bottom: 0;\n          z-index: 2;\n          background: rgba(255, 255, 255, 0.7) url(" + escape(__webpack_require__(1374)) + ") no-repeat center center; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .remove {\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        height: 20px;\n        width: 20px;\n        background: #fff;\n        opacity: 0.4;\n        filter: \"alpha(opacity=40)\";\n        text-align: center;\n        line-height: 20px;\n        z-index: 2; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .remove:hover {\n          cursor: pointer;\n          opacity: 0.9;\n          filter: \"alpha(opacity=90)\"; }\n          .upload-media .upload-edit .upload-thumbs .flex-grid__item .thumb .remove:hover i {\n            opacity: 0.5;\n            filter: \"alpha(opacity=50)\"; }\n    .upload-media .upload-edit .upload-thumbs .flex-grid__item .info {\n      position: relative;\n      padding-top: 2px;\n      padding-bottom: 3px;\n      border-top: 1px solid #ebebeb;\n      border-radius: 0 0 3px 3px; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .upload-progress {\n        position: absolute;\n        height: 2px;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 1;\n        background: #f0f0f0;\n        top: -1px; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .upload-progress .bar {\n          height: 2px;\n          background: #5ea9c8; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info input[type=\"text\"] {\n        border: 0 !important;\n        height: 26px !important;\n        font-size: 13px;\n        padding: 2px 0 8px 0;\n        border-bottom: 1px solid #ebebeb !important;\n        border-radius: 0 !important; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info input[type=\"text\"]:hover {\n          border-bottom: 1px solid #ccc !important; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info input[type=\"text\"]:focus {\n          box-shadow: none !important;\n          border-bottom: 1px solid #5ea9c8 !important; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info label {\n        padding: 0;\n        line-height: 14px;\n        color: #999; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .btn--mini {\n        position: absolute;\n        right: 4px;\n        top: 4px;\n        border: 0;\n        background: none;\n        display: none;\n        width: 18px;\n        height: 18px;\n        padding: 2px; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .form__row {\n        line-height: 18px;\n        position: relative;\n        padding: 3px 6px; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .form__row:hover .btn--mini {\n          display: block; }\n      .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .other-info {\n        z-index: 5;\n        background: #fff; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .other-info .row.shadow {\n          background: #f4f4f4;\n          border-top-width: 2px; }\n        .upload-media .upload-edit .upload-thumbs .flex-grid__item .info .other-info .row .text {\n          color: #999;\n          font-size: 13px; }\n\n/*\n======================================\nedit image modal\n======================================\n*/\n.modal-body__flex {\n  display: flex;\n  flex-direction: column;\n  padding: 0 !important;\n  overflow-y: hidden !important; }\n  .modal-body__flex--disabled {\n    position: relative; }\n    .modal-body__flex--disabled:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      background-color: rgba(255, 255, 255, 0.8);\n      z-index: 999; }\n  .modal-body__flex-top {\n    display: flex;\n    flex: 1; }\n  .modal-body__flex-bottom {\n    background-color: #dedede;\n    border-top: 1px solid #d5d5d5;\n    padding: 15px 8px 0 8px;\n    box-sizing: border-box;\n    flex: 0 0 auto; }\n  .modal-body__flex-main {\n    flex: 1;\n    overflow: auto;\n    padding: 4px 20px 0px 20px;\n    box-sizing: border-box; }\n    .modal-body__flex-main label {\n      color: #808080; }\n      .modal-body__flex-main label span.size {\n        color: black;\n        font-weight: 500;\n        margin-left: 10px; }\n    .modal-body__flex-main button {\n      margin-top: 10px;\n      margin-right: 8px; }\n  .modal-body__flex-sidebar {\n    width: 335px;\n    overflow-y: auto;\n    background-color: #f0f0f0;\n    border-left: 1px solid #dfdfdf;\n    box-sizing: border-box;\n    padding: 15px; }\n  .modal-body__flex-loader:before {\n    content: '';\n    position: absolute;\n    top: 100px;\n    left: 100px;\n    transform: translateY(-50%);\n    background-position: left !important;\n    background-image: url(" + escape(__webpack_require__(34)) + ");\n    background-repeat: no-repeat;\n    background-position: center;\n    display: inline-block;\n    width: 100%;\n    height: 40px;\n    line-height: 40px;\n    vertical-align: middle;\n    text-align: center; }\n  .modal-body__flex-metadata > div {\n    margin-bottom: 25px; }\n  .modal-body__flex-metadata label {\n    font-size: 11px;\n    text-transform: uppercase;\n    color: #999;\n    line-height: 12px; }\n  .modal-body__flex-metadata .header {\n    font-size: 16px; }\n\n.crop-area__thumbnails {\n  max-height: 260px;\n  overflow-y: auto; }\n  .crop-area__thumbnails ul li {\n    margin: 0 7px 14px 7px;\n    max-width: 160px;\n    display: inline-block;\n    padding: 10px 10px 0px 10px;\n    background-color: #f0f0f0;\n    border: 1px solid #d6d6d6;\n    box-sizing: border-box;\n    box-shadow: 0 1px 0 #d6d6d6;\n    border-radius: 2px;\n    vertical-align: top; }\n    .crop-area__thumbnails ul li img {\n      max-width: 140px;\n      max-height: 140px; }\n    .crop-area__thumbnails ul li.active {\n      border: 1px solid #b3b3b3;\n      background-color: white;\n      box-shadow: 0 1px 0 #b3b3b3; }\n    .crop-area__thumbnails ul li label {\n      color: #808080; }\n\n.image-point__image, .crop-area img {\n  max-height: 55vh; }\n\n.image-point__poi {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  display: inline-block; }\n  .image-point__poi__overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3; }\n    .image-point__poi__overlay:hover {\n      cursor: crosshair; }\n  .image-point__poi__cursor {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    position: absolute;\n    z-index: 2;\n    border: 2px solid rgba(255, 255, 255, 0.7);\n    box-sizing: border-box; }\n  .image-point__poi__cross-left, .image-point__poi__cross-right, .image-point__poi__cross-top, .image-point__poi__cross-bottom {\n    background-color: rgba(255, 255, 255, 0.7);\n    position: absolute;\n    z-index: 2; }\n  .image-point__poi__cross-left, .image-point__poi__cross-right {\n    height: 2px;\n    left: 0; }\n  .image-point__poi__cross-top, .image-point__poi__cross-bottom {\n    width: 2px;\n    top: 0; }\n\n.crop-box {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-color: rgba(0, 0, 0, 0.5);\n  border-style: solid;\n  box-sizing: border-box;\n  z-index: 1200; }\n\n@media only screen and (min-width: 1900px) {\n  .crop-area__thumbnails {\n    max-height: 390px; }\n    .crop-area__thumbnails ul li {\n      width: 225px;\n      max-width: 225px;\n      height: 177px; }\n      .crop-area__thumbnails ul li img {\n        max-width: 200px;\n        max-height: 132px; } }\n", ""]);

// exports


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a2f2b54edee7b4c9c833d88670e40572.png";

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

/**
 * Populate audio/video sources using given renditions dict
 */
function SourcesDirective() {
    var typeMap = {
        'video/mpeg': 'video/mp4',
    };
    return {
        scope: {
            renditions: '=',
        },
        link: function (scope, elem, attrs) {
            function pause() {
                elem[0].pause();
            }
            function load() {
                elem[0].load();
            }
            function createSource(rendition) {
                angular.element('<source>')
                    .attr('src', rendition.href)
                    .attr('type', typeMap[rendition.mimetype] || rendition.mimetype)
                    .appendTo(elem);
            }
            scope.$watch('renditions', function (renditions) {
                pause();
                elem.empty();
                angular.forEach(renditions, createSource);
                load();
            });
            scope.$on('$destroy', pause);
        },
    };
}
function FileValidatorDirective() {
    function isAcceptedFileType(file, accept) {
        return file.type.indexOf(accept.replace('*', '')) === 0;
    }
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            ngModel.$validators.fileType = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return !value || !attrs.accept || isAcceptedFileType(value, attrs.accept);
            };
        },
    };
}
angular.module('superdesk.core.upload', [
    'ngFileUpload',
    'superdesk.core.services.imageFactory',
    'superdesk.core.upload.crop',
    'superdesk.core.upload.imagecrop',
    'superdesk.core.upload.imagepreview',
    'superdesk.core.upload.imagemodify',
    'superdesk.core.upload.upload',
])
    .directive('sdSources', SourcesDirective)
    .directive('sdFileTypeValidator', FileValidatorDirective);


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

angular.module('superdesk.core.upload.upload', []).service('upload', ['Upload', function (Upload) {
        /**
         * Start upload
         *
         * @param {Object} config
         * @returns Promise
         */
        this.start = function (config) {
            config.isUpload = true;
            return Upload.upload(config);
        };
        /**
         * Restart upload
         *
         * @param {Object} config
         * @returns {Promise}
         */
        this.restart = function (config) {
            return Upload.http(config);
        };
        /**
         * Test if given request config is an upload
         *
         * @param {Object} config
         * @returns {bool}
         */
        this.isUpload = function (config) {
            return config.isUpload || false;
        };
    }]);


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

angular.module('superdesk.core.upload').directive('sdVideoCapture', [function () {
        var URL = window.URL || window.webkitURL;
        navigator['getMedia'] = navigator.getUserMedia ||
            navigator['webkitGetUserMedia'] ||
            navigator['mozGetUserMedia'] ||
            navigator['msGetUserMedia'];
        return {
            scope: {
                sdVideoCapture: '=',
                file: '=',
            },
            link: function (scope, elem) {
                var localMediaStream = null, canvas = angular.element('<canvas style="display:none"></canvas>'), ctx = canvas[0].getContext('2d'), tooLate = false;
                elem.after(canvas);
                navigator['getMedia']({
                    video: true,
                    audio: false,
                }, function (stream) {
                    if (tooLate) {
                        stream.stop();
                        return;
                    }
                    localMediaStream = stream;
                    if (navigator['mozGetUserMedia']) {
                        elem[0].mozSrcObject = stream;
                    }
                    else {
                        elem[0].src = URL.createObjectURL(stream);
                    }
                }, function (err) {
                    console.error('There was an error when getting media: ' + err);
                });
                elem.click(function (e) {
                    var img = elem[0];
                    canvas[0].width = img.videoWidth;
                    canvas[0].height = img.videoHeight;
                    ctx.drawImage(img, 0, 0);
                    // todo(petr): use canvas.toBlog once available in chrome
                    scope.$apply(function () {
                        scope.sdVideoCapture = canvas[0].toDataURL('image/jpeg', 0.95);
                    });
                });
                scope.$on('$destroy', function () {
                    try {
                        tooLate = true;
                        elem[0].pause();
                        localMediaStream.stop();
                    }
                    catch (err) {
                        // no-op
                    }
                });
            },
        };
    }]);


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
angular.module('superdesk.core.upload.crop', [])
    .directive('sdCrop', ['notify', function (notify) {
        return {
            scope: {
                src: '=',
                file: '=',
                cords: '=',
                progressWidth: '=',
                maxFileSize: '=',
            },
            link: function (scope, elem) {
                var bounds, boundx, boundy;
                var updateScope = lodash_1.default.throttle(function (c) {
                    scope.$apply(function () {
                        scope.cords = c;
                        var rx = 120 / scope.cords.w;
                        var ry = 120 / scope.cords.h;
                        showPreview('.preview-target-1', rx, ry, boundx, boundy, scope.cords.x, scope.cords.y);
                        showPreview('.preview-target-2', rx / 2, ry / 2, boundx, boundy, scope.cords.x, scope.cords.y);
                    });
                }, 300);
                function showPreview(e, rx, ry, boundX, boundY, cordx, cordy) {
                    $(e).css({
                        width: Math.round(rx * boundX) + 'px',
                        height: Math.round(ry * boundY) + 'px',
                        marginLeft: '-' + Math.round(rx * cordx) + 'px',
                        marginTop: '-' + Math.round(ry * cordy) + 'px',
                    });
                }
                scope.$watch('src', function (src) {
                    elem.empty();
                    if (scope.file && scope.maxFileSize
                        && scope.file.size / 1048576 > parseInt(scope.maxFileSize, 10)) {
                        notify.info(utils_1.gettext('Image is bigger than {{maxFileSize}}MB, upload file size may be limited!', { maxFileSize: scope.maxFileSize }));
                    }
                    if (src) {
                        var img = new Image();
                        img.onload = function () {
                            scope.progressWidth = 80;
                            var size = [this['width'], this['height']];
                            if (size[0] < 200 || size[1] < 200) {
                                scope.$apply(function () {
                                    notify.pop();
                                    notify.error(utils_1.gettext('Sorry, but avatar must be at least 200x200 pixels big.'));
                                    scope.src = null;
                                    scope.progressWidth = 0;
                                });
                                return;
                            }
                            elem.append(img);
                            $(img).Jcrop({
                                aspectRatio: 1.0,
                                minSize: [200, 200],
                                trueSize: size,
                                boxWidth: 300,
                                boxHeight: 225,
                                setSelect: [0, 0, Math.min.apply(size), Math.min.apply(size)],
                                allowSelect: false,
                                onChange: updateScope,
                            }, function () {
                                bounds = this.getBounds();
                                boundx = bounds[0];
                                boundy = bounds[1];
                            });
                            scope.progressWidth = 0;
                        };
                        img.src = src;
                    }
                });
            },
        };
    }]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.core.upload.imagecrop', [
    'superdesk.core.translate',
])
    .directive('sdImageCropView', [function () {
        return {
            scope: {
                src: '=',
                cropData: '=',
                original: '=',
            },
            template: '<img ng-src="{{ src }}"/><div class="crop-box"></div>',
            link: function (scope, elem) {
                var img;
                var $cropBox = elem.find('.crop-box');
                var $img = elem.find('img');
                elem.css({
                    position: 'relative',
                });
                scope.$watch('src', function () {
                    img = new Image();
                    img.onload = function () {
                        $img.css({
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            'z-index': 1000,
                        });
                        updateCropBox();
                    };
                    img.src = scope.src;
                });
                scope.$watch('cropData', updateCropBox);
                function updateCropBox() {
                    if ($img && scope.original && scope.cropData) {
                        var ratio = $img.height() / scope.original.height;
                        var cTop = scope.cropData.CropTop * ratio;
                        var cLeft = scope.cropData.CropLeft * ratio;
                        var cBottom = $img.height() - scope.cropData.CropBottom * ratio;
                        var cRight = $img.width() - scope.cropData.CropRight * ratio;
                        $cropBox.css({
                            width: $img.width(),
                            height: $img.height(),
                            'border-top-width': cTop + 'px',
                            'border-left-width': cLeft + 'px',
                            'border-bottom-width': cBottom + 'px',
                            'border-right-width': cRight + 'px',
                        });
                    }
                }
            },
        };
    }])
    /**
     * sd-image-crop based on Jcrop tool and provides Image crop functionality for
     * provided Aspect ratio and other attributes.
     * For Complete Usage of Jcrop:
     * refer to http://deepliquid.com/content/Jcrop_Manual.html
     *
     * Example Usage:
     * <div sd-image-crop
     *  data-src="data.renditions.viewImage.href"
     *  data-show-Min-Size-Error="true"
     *  data-crop-init="{}"
     *  data-box-width="800"
     *  data-box-height="600"
     *  data-rendition="{width: 800, height: 600, name: '4-3'}"
     *  data-crop-data="{CropLeft: 0, CropTop: 0, CropRight: 800, CropBottom: 600}">
     * </div>
     */
    .directive('sdImageCrop', ['imageFactory', 'lodash',
    function (imageFactory, _) {
        return {
            scope: {
                src: '=',
                cropInit: '=',
                cropData: '=',
                onChange: '&',
                original: '=',
                rendition: '=',
                showMinSizeError: '=',
            },
            link: function (scope, elem) {
                var img, cropData, selectionWidth, selectionHeight, jcropApi;
                /**
            * Test if crop data a equals to crop data b
            *
            * @param {Object} a
            * @param {Object} b
            * @return {Boolean}
            */
                function isEqualCrop(a, b) {
                    return a && b &&
                        a.CropLeft === b.CropLeft &&
                        a.CropRight === b.CropRight &&
                        a.CropTop === b.CropTop &&
                        a.CropBottom === b.CropBottom;
                }
                /**
              * Updates crop coordinates scope
              *
              * @param {Array} cords
              */
                function updateScope(cords) {
                    var nextData = formatCoordinates(cords);
                    selectionWidth = nextData.CropRight - nextData.CropLeft;
                    selectionHeight = nextData.CropBottom - nextData.CropTop;
                    if (!isEqualCrop(nextData, scope.cropData)) {
                        angular.extend(scope.cropData, nextData);
                        scope.onChange({
                            renditionName: scope.rendition && scope.rendition.name || undefined,
                            cropData: nextData,
                        });
                    }
                }
                /**
              * Format jCrop coordinates into superdesk crop specs
              *
              * @param {Object} cords jCrop coordinates
              * @return {Object} superdesk crop specs
              */
                function formatCoordinates(cords) {
                    return {
                        CropLeft: Math.round(Math.min(cords.x, cords.x2)),
                        CropRight: Math.round(Math.max(cords.x, cords.x2)),
                        CropTop: Math.round(Math.min(cords.y, cords.y2)),
                        CropBottom: Math.round(Math.max(cords.y, cords.y2)),
                    };
                }
                /**
              * Parse superdesk crop specs into jCrop coordinates
              *
              * @param {Object} cropImage
              * @return {Array} [x0, y0, x1, y1]
              */
                function parseCoordinates(cropImage) {
                    if (!_.isNil(cropImage) && !_.isNil(cropImage.CropLeft)) {
                        return [
                            cropImage.CropLeft,
                            cropImage.CropTop,
                            cropImage.CropRight,
                            cropImage.CropBottom,
                        ];
                    }
                }
                scope.$watch('src', function (src) {
                    var cropSelect = parseCoordinates(scope.cropInit) ||
                        getDefaultCoordinates(scope.original, scope.rendition || {});
                    refreshImage(src, cropSelect);
                });
                scope.$watch('rendition.name', function () {
                    cropData = scope.cropData || {};
                    if (cropData && cropData.CropBottom) {
                        refreshImage(img.src, [
                            cropData.CropLeft,
                            cropData.CropTop,
                            cropData.CropRight,
                            cropData.CropBottom,
                        ]);
                    }
                }, true);
                scope.$watch('cropData', function (newVal, oldVal) {
                    if (newVal === oldVal) {
                        return;
                    }
                    cropData = scope.cropData || {};
                    if (cropData && cropData.CropBottom) {
                        if (!isEqualCrop(newVal, oldVal)) {
                            refreshImage(img.src, [
                                cropData.CropLeft,
                                cropData.CropTop,
                                cropData.CropRight,
                                cropData.CropBottom,
                            ]);
                        }
                    }
                }, true);
                scope.$on('poiUpdate', function (e, point) {
                    if (!jcropApi || !jcropApi.tellSelect()) {
                        return;
                    }
                    angular.element('.crop-area.thumbnails').css({
                        height: angular.element('.crop-area.thumbnails').height(),
                    });
                    var center = {
                        x: point.x * scope.original.width,
                        y: point.y * scope.original.height,
                    };
                    // query current crop selection values
                    var selectionData = jcropApi.tellSelect();
                    selectionWidth = Math.round(selectionData.w);
                    selectionHeight = Math.round(selectionData.h);
                    if (center.x < selectionWidth / 2) {
                        center.x = selectionWidth / 2;
                    }
                    if (center.y < selectionHeight / 2) {
                        center.y = selectionHeight / 2;
                    }
                    if (center.x > scope.original.width - selectionWidth / 2) {
                        center.x = scope.original.width - selectionWidth / 2;
                    }
                    if (center.y > scope.original.height - selectionHeight / 2) {
                        center.y = scope.original.height - selectionHeight / 2;
                    }
                    var crop = {
                        CropLeft: Math.round(center.x - selectionWidth / 2),
                        CropTop: Math.round(center.y - selectionHeight / 2),
                        CropRight: Math.round(center.x + selectionWidth / 2),
                        CropBottom: Math.round(center.y + selectionHeight / 2),
                    };
                    angular.extend(cropData, crop);
                    scope.$applyAsync(function () {
                        refreshImage(img.src, [
                            cropData.CropLeft,
                            cropData.CropTop,
                            cropData.CropRight,
                            cropData.CropBottom,
                        ]);
                    });
                });
                function refreshImage(src, setSelect) {
                    img = imageFactory.makeInstance();
                    img.onload = function () {
                        if (!src || scope.showMinSizeError
                            && !validateConstraints(scope.original, scope.rendition)) {
                            return;
                        }
                        if (jcropApi) {
                            jcropApi.destroy();
                        }
                        elem.empty();
                        elem.append(img);
                        var ratio, minSize;
                        if (angular.isDefined(scope.rendition)) {
                            if (angular.isDefined(scope.rendition.ratio)) {
                                ratio = scope.rendition.ratio.split(':');
                                ratio = parseInt(ratio[0], 10) / parseInt(ratio[1], 10);
                            }
                            else if (angular.isDefined(scope.rendition.width)
                                && angular.isDefined(scope.rendition.height)) {
                                ratio = scope.rendition.width / scope.rendition.height;
                            }
                            else {
                                ratio = scope.original.width / scope.original.height;
                            }
                            minSize = [scope.rendition.width, scope.rendition.height];
                        }
                        $(img).Jcrop({
                            aspectRatio: ratio,
                            minSize: minSize,
                            trueSize: [scope.original.width, scope.original.height],
                            setSelect: setSelect,
                            allowSelect: false,
                            addClass: 'jcrop-dark',
                        }, function () {
                            var self = this;
                            // Store the Jcrop API in the jcropApi variable
                            jcropApi = self;
                            // define onSelect once Jcrop initialized
                            jcropApi.setOptions({
                                onSelect: updateScope,
                            });
                            // Make initial crops selection available for new image.
                            if (_.isEmpty(scope.cropData)) {
                                updateScope(jcropApi.tellSelect());
                            }
                        });
                    };
                    img.src = src;
                }
                function validateConstraints(_img, rendition) {
                    if (!angular.isDefined(rendition)) {
                        return true;
                    }
                    if (_img.width < rendition.width || _img.height < rendition.height) {
                        var text = utils_1.gettext('Sorry, but image must be at least {{width}}x{{height}}.', { width: rendition.width, height: rendition.height }) + ' ' + utils_1.gettext('Currently the image size is {{width}}x{{height}}).', { width: _img.width, height: _img.height });
                        elem.append('<p class="error">' + text);
                        return false;
                    }
                    return true;
                }
                /**
            * Get the largest part of image matching required specs.
            *
            * @param {Object} img
            * @param {Object} rendition
            * @return {Array} [x0, y0, x1, y1]
            */
                function getDefaultCoordinates(_img, rendition) {
                    if (!rendition.width || !rendition.height) {
                        return [0, 0, _img.width, _img.height];
                    }
                    var ratio = Math.min(_img.width / rendition.width, _img.height / rendition.height);
                    var width = Math.floor(ratio * rendition.width);
                    var height = Math.floor(ratio * rendition.height);
                    var x0 = Math.floor((_img.width - width) / 2);
                    var y0 = Math.floor((_img.height - height) / 2);
                    return [x0, y0, x0 + width, y0 + height];
                }
                scope.$on('$destroy', function () {
                    if (jcropApi) {
                        jcropApi.destroy();
                    }
                });
            },
        };
    }])
    .directive('imageonload', function () { return ({
    restrict: 'A',
    link: function (scope, element, attrs) {
        element.bind('load', function () {
            // call the function that was passed
            scope.$apply(attrs.imageonload);
        });
    },
}); })
    .directive('sdImagePoint', ['$window', 'lodash', function ($window, _) {
        return {
            scope: {
                src: '=',
                poi: '=',
                onChange: '&',
            },
            templateUrl: 'scripts/apps/authoring/views/image-point.html',
            bindToController: true,
            controllerAs: 'vm',
            controller: ['$rootScope', function ($rootScope) {
                    var self = this;
                    angular.extend(self, {
                        updatePOI: function (poi) {
                            if (!_.isEqual(self.poi, poi)) {
                                angular.extend(self.poi, poi);
                                self.onChange();
                                $rootScope.$broadcast('poiUpdate', self.poi);
                            }
                        },
                    });
                }],
            link: function (scope, element, attrs, vm) {
                // init directive element style
                element.css({
                    position: 'relative',
                    display: 'block',
                });
                var circleRadius = 30 / 2;
                var lineThickness = 2;
                var $poiContainer = element.find('.image-point__poi');
                var $poiCursor = element.find('.image-point__poi__cursor');
                var $poiLeft = element.find('.image-point__poi__cross-left');
                var $poiRight = element.find('.image-point__poi__cross-right');
                var $poiTop = element.find('.image-point__poi__cross-top');
                var $poiBottom = element.find('.image-point__poi__cross-bottom');
                function drawPoint(img, poi) {
                    if (poi === void 0) { poi = vm.poi; }
                    var topOffset = poi.y * img.height - circleRadius;
                    var leftOffset = poi.x * img.width - circleRadius;
                    var verticalLeftOffset = leftOffset + circleRadius - lineThickness / 2;
                    var horizontalTopffset = topOffset + circleRadius - lineThickness / 2;
                    $poiContainer.css({
                        width: img.width,
                        height: img.height,
                    });
                    $poiCursor.css({
                        left: leftOffset,
                        top: topOffset,
                    });
                    $poiLeft.css({
                        width: leftOffset,
                        top: horizontalTopffset,
                    });
                    $poiRight.css({
                        width: img.width - (leftOffset + 2 * circleRadius),
                        top: horizontalTopffset,
                        left: leftOffset + 2 * circleRadius,
                    });
                    $poiTop.css({
                        height: topOffset,
                        left: verticalLeftOffset,
                    });
                    $poiBottom.css({
                        height: img.height - (topOffset + 2 * circleRadius),
                        left: verticalLeftOffset,
                        top: topOffset + 2 * circleRadius,
                    });
                }
                function updateWhenImageIsReady() {
                    var $img = element.find('.image-point__image').get(0);
                    function drawPointsFromModel() {
                        drawPoint($img);
                    }
                    // draws points
                    drawPointsFromModel();
                    // setup overlay to listen mouse events
                    (function onMouseEvents(_$img) {
                        var debouncedPoiUpdateModel = _.debounce(function (newPoi) {
                            vm.updatePOI(newPoi);
                        }, 500);
                        function updatePOIModel(e) {
                            var newPoi = {
                                x: Math.round(e.offsetX * 100 / _$img.width) / 100,
                                y: Math.round(e.offsetY * 100 / _$img.height) / 100,
                            };
                            // refresh the points
                            drawPoint(_$img, newPoi);
                            // and notice the controller that points have been moved
                            debouncedPoiUpdateModel(newPoi);
                        }
                        // binds overlay events
                        var overlay = element.find('.image-point__poi__overlay');
                        var mousedown = false;
                        /** enable drag mode */
                        function enableDragMode(e) {
                            mousedown = true;
                            updatePOIModel(e);
                        }
                        /** exit Drag Mode */
                        function exitDragMode(e) {
                            updateOnMouseDrag(e);
                            mousedown = false;
                        }
                        /** update Poi if mouse is clicked */
                        function updateOnMouseDrag(e) {
                            if (mousedown) {
                                updatePOIModel(e);
                            }
                        }
                        var onExistEvents = ['mouseleave', 'mouseup'];
                        overlay.off('mousedown').on('mousedown', enableDragMode);
                        overlay.off('mousemove').on('mousemove', updateOnMouseDrag);
                        onExistEvents.forEach(function (eventName) {
                            overlay.off(eventName).on(eventName, exitDragMode);
                        });
                        scope.$on('$destroy', function () {
                            overlay.off('mousedown', enableDragMode);
                            overlay.off('mousemove', updateOnMouseDrag);
                            onExistEvents.forEach(function (eventName) {
                                overlay.off(eventName, exitDragMode);
                            });
                        });
                    })($img);
                }
                // initialize points
                scope.onImageLoad = updateWhenImageIsReady;
                // draw when needed
                scope.$on('poiUpdate', updateWhenImageIsReady);
                angular.element($window).on('resize', updateWhenImageIsReady);
                // on destroy
                scope.$on('$destroy', function () {
                    angular.element($window).off('resize', updateWhenImageIsReady);
                });
            },
        };
    }]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = angular.module('superdesk.core.upload.imagemodify', [
    'superdesk.core.translate',
])
    .directive('sdImageModify', function () { return ({
    scope: {
        src: '=',
        original: '=',
        brightness: '=',
        contrast: '=',
        saturate: '=',
        rotate: '=',
        fliph: '=',
        flipv: '=',
    },
    template: '<canvas id="image"></canvas>',
    link: function (scope) {
        var canvas = document.getElementById('image'), context = canvas.getContext('2d'), baseImage = new Image(), filter = {
            brightness: scope.brightness ? 'brightness(' + scope.brightness + ') ' : '',
            contrast: scope.contrast ? 'contrast(' + scope.contrast + ') ' : '',
            saturate: scope.saturate ? 'saturate(' + scope.saturate + ') ' : '',
        }, transform = {
            rotate: scope.rotate ? 'rotateZ(' + scope.rotate + 'deg) ' : '',
            flipH: scope.flipH ? 'rotateY(' + scope.fliph + 'deg) ' : '',
            flipV: scope.flipV ? 'rotateX(' + scope.flipv + 'deg) ' : '',
        };
        baseImage.onload = function () {
            canvas.width = baseImage.width;
            canvas.height = baseImage.height;
            context['filter'] = filter.brightness + filter.contrast + filter.saturate;
            context.drawImage(baseImage, 0, 0);
        };
        scope.$watch('brightness', function (value, old) {
            filter.brightness = 'brightness(' + value + ') ';
            context['filter'] = filter.brightness + filter.contrast + filter.saturate;
            context.drawImage(baseImage, 0, 0);
        });
        scope.$watch('contrast', function (value, old) {
            filter.contrast = 'contrast(' + value + ') ';
            context['filter'] = filter.brightness + filter.contrast + filter.saturate;
            context.drawImage(baseImage, 0, 0);
        });
        scope.$watch('saturate', function (value, old) {
            filter.saturate = 'saturate(' + value + ') ';
            context['filter'] = filter.brightness + filter.contrast + filter.saturate;
            context.drawImage(baseImage, 0, 0);
        });
        scope.$watch('rotate', function (value, old) {
            var scale = (value / 90) % 2 ? (canvas.height / canvas.width) : 1;
            transform.rotate = 'scale(' + scale + ', ' + scale + ') rotateZ(' + value + 'deg) ';
            setTransform();
        });
        scope.$watch('fliph', function (value, old) {
            transform.flipH = 'rotateY(' + value + 'deg) ';
            setTransform();
        });
        scope.$watch('flipv', function (value, old) {
            transform.flipV = 'rotateX(' + value + 'deg) ';
            setTransform();
        });
        scope.$watch('src', function (value, old) {
            baseImage.src = scope.src;
        });
        function setTransform() {
            canvas.setAttribute('style', 'transform:' + transform.rotate + transform.flipH + transform.flipV +
                '; -webkit-transform:' + transform.rotate + transform.flipH + transform.flipV +
                '; -moz-transform:' + transform.rotate + transform.flipH + transform.flipV);
        }
    },
}); });


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
DeployConfigFactory.$inject = ['api', '$q'];
function DeployConfigFactory(api, $q) {
    /**
     * Deploy config service
     *
     * provides deployment related config from server
     */
    var DeployConfig = /** @class */ (function () {
        function DeployConfig() {
            this.config = null;
            this.promise = null;
        }
        /**
         * Get whole config
         *
         * @return {Promise}
         */
        DeployConfig.prototype.fetch = function () {
            var _this = this;
            if (this.config) {
                return $q.when(this.config);
            }
            if (!this.promise) {
                this.promise = api.query('client_config', {})
                    .then(function (response) {
                    _this.config = response.config;
                    return _this.config;
                });
            }
            return this.promise;
        };
        /**
         * Get specific key
         *
         * @param {string} key
         * @return {Promise}
         */
        DeployConfig.prototype.get = function (key) {
            var _this = this;
            return this.fetch().then(function () { return _this.getSync(key); });
        };
        /**
         * Get sync
         *
         * @param {string} key
         * @param {mixed} defaultValue
         * @return {mixed}
         */
        DeployConfig.prototype.getSync = function (key, defaultValue) {
            if (!this.config) {
                return defaultValue;
            }
            return lodash_1.default.get(this.config, key, defaultValue);
        };
        /**
         * Get multiple values at once
         *
         * @param {Object} spec
         * @return {Promise}
         */
        DeployConfig.prototype.all = function (spec) {
            var _this = this;
            return this.fetch().then(function (config) { return lodash_1.default.mapValues(spec, function (key) { return _this.getSync(key); }); });
        };
        return DeployConfig;
    }());
    return new DeployConfig();
}
angular.module('superdesk.config', ['superdesk.core.api'])
    .provider('defaultConfig', ['config', function (config) {
        /**
         * Set default config value for given key
         *
         * key can contain dots, eg. `editor.toolbar`
         *
         * @param {String} key
         * @param {String} val
         */
        this.set = function (key, val) {
            var dest = config;
            var keyPieces = key.split('.');
            for (var i = 0; i + 1 < keyPieces.length; i++) {
                var k = keyPieces[i];
                if (!dest.hasOwnProperty(k)) {
                    dest[k] = {};
                }
                dest = dest[k];
            }
            var lastKey = keyPieces[keyPieces.length - 1];
            if (!dest.hasOwnProperty(lastKey)) {
                dest[lastKey] = val;
            }
        };
        // used only to modify config, noting to return
        this.$get = angular.noop;
    }])
    .factory('deployConfig', DeployConfigFactory)
    .run(['$rootScope', 'config', 'deployConfig', function ($rootScope, config, deployConfig) {
        $rootScope.config = config || {};
        deployConfig.fetch();
    }]);


/***/ }),
/* 1382 */
/***/ (function(module, exports) {

angular.module('superdesk.core.loading', [])
    // prevent routing before there is auth token
    .run(['$rootScope', '$route', '$location', '$http', 'session', 'preferencesService',
    function ($rootScope, $route, $location, $http, session, preferencesService) {
        var stopListener = angular.noop;
        $rootScope.loading = true;
        // fetch preferences on load
        preferencesService.get().then(function () {
            stopListener();
            $http.defaults.headers.common.Authorization = session.token;
            $rootScope.loading = false;
            // do this in next $digest so that beta service can setup route redirects
            // for features that should not be available
            $rootScope.$applyAsync($route.reload);
        });
        // prevent routing when there is no token
        stopListener = $rootScope.$on('$locationChangeStart', function (e) {
            $rootScope.requiredLogin = requiresLogin($location.path());
            if ($rootScope.loading && $rootScope.requiredLogin) {
                e.preventDefault();
            }
        });
        /**
     * Finds out if there is a route matching given url that requires a login
     *
     * @param {string} url
     */
        function requiresLogin(url) {
            var routes = _.values($route.routes);
            for (var i = routes.length - 1; i >= 0; i--) {
                if (routes[i].regexp.test(url)) {
                    return routes[i].auth;
                }
            }
            return false;
        }
    }]);


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var InputDirective_1 = __importDefault(__webpack_require__(1384));
var SelectDirective_1 = __importDefault(__webpack_require__(1386));
var SwitchInvertedDirective_1 = __importDefault(__webpack_require__(1388));
var CheckboxDirective_1 = __importDefault(__webpack_require__(1390));
angular.module('superdesk.core.form', [])
    .directive('sdFormInput', InputDirective_1.default)
    .directive('sdFormSelect', SelectDirective_1.default)
    .directive('sdFormCheckbox', CheckboxDirective_1.default)
    .directive('sdFormSwitchInverted', SwitchInvertedDirective_1.default);


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function InputDirective() {
    return {
        scope: {
            id: '@',
            type: '@',
            label: '@',
            placeholder: '@',
            model: '=',
            required: '=',
        },
        template: __webpack_require__(1385),
        link: function (scope, element) {
            scope.ngModel = element.find('input').controller('ngModel');
        },
    };
}
exports.default = InputDirective;


/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sd-line-input\"\n    ng-class=\"{\n        'sd-line-input--required': required,\n        'sd-line-input--invalid': ngModel.$touched && ngModel.$invalid,\n    }\"\n>\n    <label\n        for=\"{{ id }}\"\n        class=\"sd-line-input__label\"\n    >{{ label }}</label>\n    <input\n        id=\"{{ id }}\"\n        type=\"{{ type || 'text' }}\"\n        class=\"sd-line-iput__input\"\n        ng-model=\"model\"\n        ng-required=\"required\"\n        placeholder=\"{{ placeholder }}\"\n    >\n</div>";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SelectDirective() {
    return {
        scope: {
            label: '@',
            model: '=',
            options: '=',
            optionLabel: '@',
            optionValue: '@',
            required: '=',
        },
        template: __webpack_require__(1387),
        link: function (scope, element) {
            scope.ngModel = element.find('select').controller('ngModel');
        },
    };
}
exports.default = SelectDirective;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sd-line-input sd-line-input--is-select\"\n    ng-class=\"{\n        'sd-line-input--required': required,\n        'sd-line-input--invalid': ngModel.$touched && ngModel.$invalid,\n    }\"\n>\n    <label class=\"sd-line-input__label\">{{ label }}</label>\n    <select class=\"sd-line-input__select\"\n        ng-model=\"model\"\n        ng-options=\"option[optionValue] as option[optionLabel] for option in options\"\n        ng-required=\"required\"\n    ></select>\n</div>\n";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SwitchInvertedDirective() {
    return {
        scope: {
            id: '@',
            label: '@',
            model: '=',
        },
        template: __webpack_require__(1389),
    };
}
exports.default = SwitchInvertedDirective;


/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form__row\">\n    <span ng-model=\"model\" sd-switch-inverted if=\"{{ id }}\"></span> <label for=\"{{ id }}\">{{ label }}</label>\n</div>";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function CheckboxDirective() {
    return {
        scope: {
            label: '@',
            model: '=',
        },
        template: __webpack_require__(1391),
    };
}
exports.default = CheckboxDirective;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form__row\">\n    <sd-check ng-model=\"model\">{{ label }}</sd-check>\n</div>";

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module("superdesk.templates-cache").run(['$templateCache', function ($templateCache) {
        'use strict';
        $templateCache.put('scripts/apps/archive/related-item-widget/relatedItem-configuration.html', "<div><fieldset><div class=\"field\"><label translate>Slugline Match</label><div class=\"control\"><select ng-model=\"configuration.sluglineMatch\" class=\"input-small\" selected><option value=\"EXACT\" selected translate>Exact</option><option value=\"ANY\" translate>Match Any</option><option value=\"PREFIX\" translate>Match Prefix</option></select></div></div><div class=\"field\"><label translate>Last Updated</label><div class=\"control\"><select ng-model=\"configuration.modificationDateAfter\" class=\"input-small\" selected><option value=\"now-6h\" translate>6 Hours</option><option value=\"now-12h\" translate>12 Hours</option><option value=\"today\" selected translate>Today</option><option value=\"now-24h\" translate>24 Hours</option><option value=\"now-48h\" translate>48 Hours</option></select></div></div></fieldset></div>");
        $templateCache.put('scripts/apps/archive/related-item-widget/relatedItem-list.html', "<div sd-related-item-list-widget data-options=\"options\" data-item-list-options=\"itemListOptions\" data-actions=\"actions\" data-loading=\"loading\"></div>");
        $templateCache.put('scripts/apps/archive/related-item-widget/widget-relatedItem.html', "<div ng-controller=\"relatedItemController\" ng-init=\"extras=widget\" ng-include=\"'scripts/apps/archive/related-item-widget/relatedItem-list.html'\"></div>");
        $templateCache.put('scripts/apps/archive/views/archived-kill.html', "<div sd-modal data-model=\"item\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\">{{ :: action === 'kill' && 'Kill Item' || 'Takedown Item' | translate}}</h3></div><div class=\"modal__body\"><form name=\"templateForm\"><div class=\"main-article\"><div class=\"fieldset\" sd-article-edit></div></div></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"kill()\">{{ :: action === 'kill' && 'Kill' || 'Takedown' | translate}}</button></div></div>");
        $templateCache.put('scripts/apps/archive/views/assignment-icon.html', "<span class=\"assignment-icon\" ng-if=\"item.assignment_id\" title=\"{{:: 'Coverage' | translate}}\"><i class=\"icon-calendar\"></span>");
        $templateCache.put('scripts/apps/archive/views/export-dropdown.html', "<div sd-export></div>");
        $templateCache.put('scripts/apps/archive/views/export.html', "<div sd-modal data-model=\"export\" data-close=\"closeExport()\"><div class=\"modal__header\"><a href=\"\" class=\"modal__close pull-right\" sd-hotkey=\"esc\" ng-click=\"closeExport()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Export</h3></div><div class=\"modal__body\" ng-loading=\"loading\"><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Formatters' | translate }}</label><select selected ng-model=\"selectedFormatter\" class=\"sd-line-input__select\"><option value=\"{{formatter}}\" ng-repeat=\"formatter in exportFormatters\">{{:: formatter.name}}</option></select></div></div><div class=\"form__row\"><label translate>Validate</label><span sd-switch ng-model=\"validate\">{{ 'Validate' | translate }}</span></div><div class=\"form__row\"><div ng-if=\"failures\" class=\"sd-line-input sd-line-input--invalid\"><div class=\"sd-line-input__message\">{{ :: failures + ' items failed.' | translate }}</div></div><div ng-if=\"error\"><div class=\"sd-line-input__message\">{{ :: err_msg | translate }}</div></div><a id=\"exportDownloadLink\" href=\"\" ng-show=\"!error\"></a></div></div><div class=\"modal__footer\"><button class=\"btn btn--primary btn--pull-right\" ng-disabled=\"!exportFormatters.length > 0\" ng-click=\"exportFile(selectedFormatter, validate)\" translate>Export</button> <button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button></div></div>");
        $templateCache.put('scripts/apps/archive/views/fetched-desks.html', "<dl ng-if=\"desks.length\"><dt translate>fetched in</dt><dd ng-repeat=\"desk in desks track by desk.desk._id\"><a ng-if=\"$first && desk.isUserDeskMember\" ng-click=\"selectFetched(desk)\">{{desk.desk.name.substring(0,10)}}{{desk.desk.name.length>10 ? '...' : ''}} ({{desk.count}})</a> <span ng-if=\"$first && !desk.isUserDeskMember\" class=\"container\">{{desk.desk.name.substring(0,10)}}{{desk.desk.name.length>10 ? '...' : ''}} ({{desk.count}})</span></dd><dd ng-if=\"desks.length>1\" class=\"dropdown dropdown--dropup more-actions\" dropdown-append-to-body dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><div class=\"dropdown__menu\"><ul><li ng-repeat=\"desk in desks track by desk.desk._id\"><a ng-if=\"!$first\" ng-click=\"selectFetched(desk)\" ng-disabled=\"!desk.isUserDeskMember\">{{desk.desk.name}} ({{desk.count}})</a></li></ul></div></dd></dl>");
        $templateCache.put('scripts/apps/archive/views/html-preview.html', "<div class=\"html-preview\" ng-bind-html=\"html\"></div><div class=\"annotations\" sd-toggle-box=\"\" data-title=\"{{ :: 'Annotations' | translate }}\" data-open=\"true\" ng-if=\"annotations.length > 0\"><ul class=\"simple-list simple-list--comfortable\"><li ng-repeat=\"annotation in annotations\" class=\"annotation-body simple-list__item\"><sup class=\"annotation-id\">{{annotation.id}}</sup> <span class=\"label label--primary label--hollow\">{{annotation.type_label}}</span> <span ng-bind-html=\"annotation.body\"></span></li></ul></div>");
        $templateCache.put('scripts/apps/archive/views/inline-meta.html', "<div class=\"row\"><input type=\"text\" placeholder=\"{{placeholder}}\" ng-model=\"item\" ng-focus=\"showmeta = true\" ng-blur=\"showmeta = false\"> <button class=\"btn--mini\" ng-focus=\"showmeta = true\" ng-blur=\"showmeta = false\" ng-show=\"item.length\" ng-click=\"setmeta()\"><i class=\"icon-expand-thin\"></i></button></div>");
        $templateCache.put('scripts/apps/archive/views/item-crops.html', "<div sd-toggle-box data-title=\"{{:: 'Show/hide crops' | translate}}\" data-open=\"true\" data-style=\"circle toggle-box--marg-b10\" ng-show=\"showCrops()\"><div class=\"cropItems\"><div ng-repeat=\"crop in crop_sizes track by crop.name\" ng-if=\"item.renditions[crop.name]\" class=\"cropItems__item\"><div class=\"rendition cropItems__item-rendition\" sd-item-rendition data-item=\"item\" data-rendition=\"{{ :: crop.name }}\"></div><span class=\"cropItems__item-label\">{{ :: crop.name | translate }}</span></div></div></div>");
        $templateCache.put('scripts/apps/archive/views/item-lock.html', "<div class=\"item-locked\" ng-if=\"lock.user && !lock.lockbyme\"><div class=\"locked-content\"><span class=\"lock-sign\"><i class=\"icon-lock red\"></i></span> <span class=\"text\"><em translate>Locked by</em> {{ lock.user | username }}</span> <button class=\"btn btn--light btn--pull-left\" ng-click=\"unlock()\" ng-if=\"can_unlock()\" translate>Unlock</button></div><time sd-datetime data-date=\"item.lock_time\"></time></div><div class=\"item-locked\" ng-if=\"lock.lockbyme\"><div class=\"locked-content\"><span class=\"lock-sign\"><i class=\"icon-lock red\"></i></span> <span class=\"text\"><em translate>Locked by you in another browser</em></span> <button class=\"btn btn--light btn--pull-left\" ng-click=\"unlock()\" translate>Unlock</button></div><time sd-datetime data-date=\"item.lock_time\"></time></div>");
        $templateCache.put('scripts/apps/archive/views/item-preview.html', "<div><div class=\"content-container\"><div class=\"composite-nav\" ng-if=\"item.type === 'composite'\"><i class=\"filetype-icon-large-composite\"></i> <span>{{ 'Package preview' | translate }}</span></div><div class=\"preview-state__row\"><span sd-item-state data-state=\"item.state\" data-embargo=\"item.embargo\"></span> <span ng-if=\"item.flags.marked_for_not_publication\" class=\"state-label not-for-publication\" translate>Not For Publication</span> <span class=\"state-label legal\" ng-if=\"item.flags.marked_for_legal\" translate>Legal</span> <span class=\"state-label sms\" ng-if=\"item.flags.marked_for_sms\" translate>Sms</span> <span class=\"state-label updated\" ng-if=\"item.rewritten_by\" translate>Updated</span></div><p class=\"title\" ng-if=\"item.headline\" sd-html-preview=\"item.headline\"></p><div class=\"core-content\"><p ng-if=\"item.is_spiked\" class=\"alert alert-warning expires\"><span translate>expires</span> <time sd-datetime data-date=\"item.expiry\"></time></p><div ng-if=\"item.type === 'picture' || item.type === 'graphic'\" class=\"picture-preview\"><div><span translate>Original</span><div sd-item-rendition data-item=\"item\" data-rendition=\"viewImage\"></div></div><div sd-item-crops data-item=\"item\"></div></div><div ng-if=\"item.type === 'audio'\"><audio controls sd-sources data-renditions=\"item.renditions\"></audio></div><div ng-if=\"item.type === 'video'\"><video controls sd-sources data-renditions=\"item.renditions\"></video></div><div ng-if=\"item.associations.featuremedia\" class=\"picture-preview\"><div sd-item-rendition data-item=\"item.associations.featuremedia\" data-rendition=\"viewImage\"></div><p class=\"nav-space description-text\">{{item.associations.featuremedia.description_text}}</p></div><div class=\"text abstract\" ng-show=\"item.abstract\" sd-html-preview=\"item.abstract\"></div><div class=\"text\" ng-show=\"item.body_html\" sd-html-preview=\"item.body_html\"></div><div class=\"composite-preview\" ng-if=\"item.type === 'composite'\"><div sd-package data-item=\"item\"></div></div></div></div></div>");
        $templateCache.put('scripts/apps/archive/views/item-rendition.html', "<figure class=\"media preview-overlay-on\" ng-if=\"item.renditions[rendition]\"><small ng-if=\"item.renditions[rendition].href\" title=\"{{ :: item.headline }}\">{{ :: item.headline | limitTo: 90}}</small> <span ng-if=\"item.renditions[rendition].href\" sd-item-container data-item=\"item\" class=\"container\"></span></figure>");
        $templateCache.put('scripts/apps/archive/views/item-state.html', "<span class=\"state-label state-{{state}}\">{{state|translate|removeLodash}}</span> <span class=\"state-label\" ng-if=\"embargo\" ng-class=\"{state_embargo: embargo}\" translate>embargo</span>");
        $templateCache.put('scripts/apps/archive/views/list.html', "<div class=\"subnav subnav--top\" ng-if=\"type !== 'ingest'\"><div class=\"subnav__desk-stage desk-stages subnav--padded\"><div class=\"toggle-list\" sd-desk-stages></div></div><div class=\"subnav__button-stack--square-buttons\"><div class=\"dropdown dropdown--align-right strict\" dropdown ng-if=\"type === 'archive'\"><button tooltip=\"{{ :: 'Create' | translate }}\" tooltip-placement=\"left\" class=\"navbtn dropdown__toggle sd-create-btn\" dropdown__toggle></button><div class=\"dropdown__menu dropdown__menu--has-head-foot pull-right\" sd-content-create></div></div></div></div><div class=\"subnav subnav--plain subnav--top\" ng-class=\"{'subnav--archive': type === 'archive'}\"><header class=\"search-page-header\"><div class=\"filter-trigger\" title=\"{{ :: 'Filters' | translate }}\" ng-click=\"flags.facets = !flags.facets\" ng-class=\"{'filter-trigger--active': flags.facets}\"><i class=\"icon-filter-large\"></i></div><div sd-item-searchbar data-repo=\"repo\" data-context=\"context\" class=\"searchbar-flex-handler\"></div><div sd-item-sortbar data-total=\"total\"></div><div class=\"view-select\"><button title=\"{{ :: 'Switch to grid view' | translate }}\" ng-show=\"view !== 'mgrid'\" ng-click=\"setview('mgrid')\"><i class=\"icon-th\"></i></button> <button title=\"{{ :: 'Switch to list view' | translate }}\" ng-show=\"view !== 'compact'\" ng-click=\"setview('compact')\"><i class=\"icon-th-list\"></i></button></div><div sd-multi-action-bar></div></header></div><section sd-search-container class=\"main-section search-page-container {{type}}-container\" ng-class=\"{'sidebar-open': flags.facets}\"><div sd-search-panel class=\"archive-sidebar\" data-items=\"items\" data-repo=\"repo\" data-desk=\"selected.desk\"></div><div sd-content-results class=\"archive-content\"></div></section>");
        $templateCache.put('scripts/apps/archive/views/marked_item_title.html', "<div class=\"highlights-list dropdown\" dropdown dropdown-append-to-body ng-if=\"marks.length>0\" ng-click=\"toggleClass(open, $event)\"><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"{{className}} icon-open\"></i></button><ul class=\"dropdown dropdown__menu highlights-list-menu\" ng-class=\"{open: open}\" ng-click=\"$event.stopPropagation()\"><li><div class=\"dropdown__menu-label\" translate>Marked For</div><button class=\"dropdown__menu-close\" dropdown-toggle><i class=\"icon-close-small icon--white\"></i></button></li><li ng-repeat=\"mark in markObjects | orderBy: 'name' track by mark._id\" title=\"{{ :: mark.name }}\">{{ :: mark.name }} <button class=\"btn btn--mini uppercase\" ng-if=\"hasMarkItemPrivilege\" ng-click=\"unmark(mark._id)\" translate>Remove</button></li><li class=\"none\" ng-show=\"marks.length === 0\" translate>None</li></ul></div>");
        $templateCache.put('scripts/apps/archive/views/media-used-view.html', "<div class=\"mediaUsed\"><ul><li ng-repeat=\"usedItem in usedItems._items\"><div class=\"mediaUsed--Item\" ng-click=\"open(usedItem)\"><i class=\"type-icon\" sd-filetype-icon data-item=\"usedItem\"></i> <span class=\"keyword\" ng-if=\"usedItem.slugline\">{{ usedItem.slugline }}</span> <span sd-item-container data-item=\"usedItem\" class=\"container\"></span> <span class=\"state-label state-{{usedItem.state}}\">{{ usedItem.state }}</span><div class=\"item\"><span ng-href=\"\" title=\"{{ usedItem.headline }}\" class=\"headline\">{{ usedItem.headline || usedItem.description_text }}</span></div></div></li></ul></div>");
        $templateCache.put('scripts/apps/archive/views/media-view.html', "<div class=\"modal lightbox-preview fade in\"><!-- package items list --><div class=\"lightbox-composite\" ng-show=\"packageItem\" ng-class=\"{'open': compositeOpen}\" ng-init=\"compositeOpen = true\"><div class=\"toggle-composite\" ng-click=\"compositeOpen = !compositeOpen\"><i class=\"svg-icon-right inverse\"></i></div><div class=\"header\" ng-click=\"setSingleItem(packageItem)\"><span ng-if=\"!nested()\"><i class=\"filetype-icon-large-composite icon--white\"></i> </span><span ng-if=\"nested()\" ng-click=\"previousPackage(); $event.stopPropagation();\"><i class=\"backlink white\"></i></span><h5>{{ packageItem.headline }}</h5></div><div class=\"content\"><ul ng-if=\"packageItem\"><div sd-package data-item=\"packageItem\" data-setitem=\"setPackageSingle(selected)\"></div></ul></div></div><!-- preview pane --><section class=\"lightbox-left\" ng-class=\"{'composite' : item.type === 'composite', 'open' : compositeOpen}\"><div sd-single-item data-item=\"singleItem\" data-setitem=\"setPackageSingle(selected)\"></div><button class=\"navigation left\" ng-click=\"prev()\" ng-if=\"prevEnabled\" title=\"{{ 'previous' | translate }}\"><i class=\"arrow-icon-large-left\"></i></button> <button class=\"navigation right\" ng-click=\"next()\" ng-if=\"nextEnabled\" title=\"{{ 'next' | translate }}\"><i class=\"arrow-icon-large-right\"></i></button></section><!-- end of preview pane --><section class=\"lightbox-right\"><header><h5 class=\"lightbox-title\">{{ singleItem.headline }}</h5><button class=\"lightbox-close\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></button> <span class=\"lightbox-modified-info\">{{ 'Created:'|translate }} {{ singleItem.firstcreated|date:'medium' }}</span> <span class=\"lightbox-modified-info\">{{ 'Modified:'|translate }} {{ singleItem.versioncreated|date:'medium' }}</span> <span class=\"lightbox-media-type filetype-icon-{{singleItem.type}}\"></span><div class=\"lightbox-actions\"><button class=\"btn pull-left\" ng-show><i class=\"icon-list-alt\"></i> {{ 'Edit metadata'|translate }}</button></div></header><div class=\"lightbox-media-data\"><div class=\"lightbox-descritpion\"></div><div sd-toggle-box data-title=\"{{ 'Details' | translate }}\" data-open=\"true\"><div sd-media-metadata data-item=\"singleItem\"></div></div></div></section></div>");
        $templateCache.put('scripts/apps/archive/views/metadata-associateditem-view.html', "<h4 translate>{{title}}</h4><dl ng-if=\"association.headline\"><dt translate>Title</dt><dd sd-html-preview=\"association.headline\"></dd></dl><dl ng-if=\"association.description_text\"><dt translate>Caption</dt><dd sd-html-preview=\"association.description_text\"></dd></dl><dl ng-if=\"association.archive_description\"><dt translate>Description</dt><dd sd-html-preview=\"association.archive_description\"></dd></dl><dl ng-if=\"association.alt_text\"><dt translate>Alt Text</dt><dd sd-html-preview=\"association.alt_text\"></dd></dl><dl ng-if=\"association.ednote\"><dt translate>Ed Note</dt><dd sd-html-preview=\"association.ednote\"></dd></dl><dl ng-if=\"association.source\"><dt translate>Source</dt><dd>{{ association.source }}</dd></dl><dl ng-if=\"association.original_source\"><dt translate>Original Source</dt><dd>{{ association.original_source }}</dd></dl><!-- copyright details details --><dl ng-if=\"association.copyrightholder\"><dt translate>Copyright holder</dt><dd>{{ association.copyrightholder }}</dd></dl><dl ng-if=\"association.copyrightnotice\"><dt translate>Copyright notice</dt><dd>{{ association.copyrightnotice }}</dd></dl><dl ng-if=\"association.usageterms\"><dt translate>Usage terms</dt><dd>{{ association.usageterms }}</dd></dl><dl ng-if=\"association.renditions\"><dt translate>Dimensions</dt><dd>{{ association.renditions.original.width }} x {{ association.renditions.original.height }}</dd></dl>");
        $templateCache.put('scripts/apps/archive/views/metadata-view.html', "<div class=\"metadata-view\"><div><dl><dt translate>Slugline</dt><dd sd-html-preview=\"item.slugline\"></dd></dl><dl><dt translate>Urgency</dt><dd>{{ item.urgency }}</dd></dl><dl><dt translate>Priority</dt><dd>{{ item.priority }}</dd></dl><dl><dt translate>Word Count</dt><dd>{{ item.word_count }}</dd></dl><dl ng-if=\"item.keywords && item.keywords.length\"><dt translate>Keywords</dt><dd>{{ item.keywords | mergeWords}}</dd></dl><dl ng-if=\"item.ingest_provider\"><dt translate>Ingest Provider</dt><dd sd-meta-ingest data-item=\"item\"></dd></dl><dl ng-if=\"item.original_source\"><dt translate>Original Source</dt><dd>{{ item.original_source }}</dd></dl><dl ng-if=\"item.source\"><dt translate>Source</dt><dd>{{ item.source }}</dd></dl><dl><dt translate>Take key</dt><dd>{{ item.anpa_take_key }}</dd></dl><dl ng-if=\"item.signal\"><dt translate>Signal</dt><dd>{{ item.signal }}</dd></dl><dl ng-if=\"item.anpa_category && item.anpa_category.length\"><dt translate>Service</dt><dd>{{ item.anpa_category | mergeWords:'name' }}</dd></dl><dl ng-repeat=\"cv in cvs track by cv._id\" ng-if=\"item[cv.schema_field] | mergeWords:'name' : cv._id\"><dt>{{ cv.display_name | translate }}</dt><dd>{{ getLocaleName(item[cv.schema_field], cv._id) }}</dd></dl><dl ng-if=\"item.genre  && item.genre.length > 0 && !genreInCvs\"><dt translate>Genre</dt><dd>{{ item.genre | mergeWords:'name'}}</dd></dl><dl ng-if=\"item.place && item.place.length > 0 && !placeInCvs\"><dt translate>Place</dt><dd>{{ item.place | mergeWords:'name'}}</dd></dl><dl ng-if=\"item.ednote\"><dt translate>Editorial Note</dt><dd>{{ item.ednote }}</dd></dl><dl><dt translate>Dateline</dt><dd>{{ item.dateline.text }}</dd></dl><dl><dt translate>Byline</dt><dd>{{ item.byline }}</dd></dl><dl><dt translate>Sign-Off</dt><dd>{{ item.sign_off }}</dd></dl></div><div><dl ng-if=\"item._current_version\"><dt translate>Version</dt><dd>{{ item._current_version }}</dd></dl><dl ng-if=\"item.firstcreated\"><dt translate>Created</dt><dd sd-reldate-complex datetime=\"item.firstcreated\"></dd></dl><dl ng-if=\"item.versioncreated\"><dt translate>Last updated</dt><dd sd-reldate-complex datetime=\"item.versioncreated\"></dd></dl><dl ng-if=\"item.expiry\"><dt translate>Expiry</dt><dd sd-reldate-complex datetime=\"item.expiry\"></dd></dl><dl ng-if=\"item.original_id\"><dt translate>Original ID</dt><dd>{{ item.original_id }}</dd></dl><dl ng-if=\"originalCreator\"><dt translate>Original creator</dt><dd>{{ originalCreator }}</dd></dl><dl ng-if=\"versionCreator\"><dt translate>Version creator</dt><dd>{{ versionCreator }}</dd></dl></div><div><!-- Story details --><dl ng-if=\"item.language\"><dt translate>Language</dt><dd>{{ item.language }}</dd></dl><dl><dt translate>PubStatus</dt><dd ng-if=\"item.pubstatus\">{{ item.pubstatus }}</dd></dl><dl ng-if=\"item.ingest_provider_sequence\"><dt translate>Ingest provider sequence</dt><dd>{{ item.ingest_provider_sequence }}</dd></dl><dl ng-if=\"item.embargo\"><dt translate>Embargo Timestamp</dt><dd sd-reldate-complex data-useutc=\"false\" datetime=\"item.embargo\"></dd></dl><!-- publish schedule data --><dl ng-if=\"item.publish_schedule\"><dt translate>Publish Schedule</dt><dd sd-reldate-complex data-useutc=\"false\" datetime=\"item.publish_schedule\"></dd></dl><dl ng-if=\"item.schedule_settings && (item.publish_schedule || item.embargo)\"><dt translate>Time Zone</dt><dd>{{ item.schedule_settings.time_zone || 'UTC'}}</dd></dl><dl ng-if=\"item.target_subscribers\"><dt translate>Target Subscribers</dt><dd>{{item.target_subscribers | mergeTargets}}</dd></dl><dl ng-if=\"item.target_regions && item.target_regions.length > 0\"><dt translate>Target Regions</dt><dd>{{item.target_regions | mergeTargets}}</dd></dl><dl ng-if=\"item.target_types && item.target_types.length > 0\"><dt translate>Target Subscriber Types</dt><dd>{{item.target_types | mergeTargets}}</dd></dl><!-- file specific data --><dl ng-if=\"item.FileMeta\"><dt translate>Aperture</dt><dd>{{ item.FileMeta.Aperture }}</dd><dt translate>Exposure time</dt><dd>{{ item.FileMeta['Exposure time'] }}</dd><dt translate>Focal length</dt><dd>{{ item.FileMeta['Focal length'] }}</dd><dt translate>Iso</dt><dd>{{ item.FileMeta['ISO speed'] }}</dd><dt translate>Flash</dt><dd>{{ item.FileMeta.Flash }}</dd></dl></div><div ng-if=\"item.copyrightholder || item.copyrightholder || item.usageterms\"><!-- copyright details details --><dl><dt translate>Copyright holder</dt><dd ng-if=\"item.copyrightholder\">{{ item.copyrightholder }}</dd></dl><dl><dt translate>Copyright notice</dt><dd ng-if=\"item.copyrightnotice\">{{ item.copyrightnotice }}</dd></dl><dl><dt translate>Usage terms</dt><dd ng-if=\"item.usageterms\">{{ item.usageterms }}</dd></dl></div><div><dl><dt translate>State</dt><dd><span sd-item-state data-state=\"item.state\" data-embargo=\"item.embargo\"></span> <span ng-if=\"item.flags.marked_for_not_publication\" class=\"state-label not-for-publication\" translate>Not For Publication</span> <span ng-if=\"item.flags.marked_for_legal\" class=\"state-label legal\" translate>Legal</span> <span ng-if=\"item.flags.marked_for_sms\" class=\"state-label sms\" translate>Sms</span> <span ng-if=\"item.rewritten_by\" class=\"state-label updated\" translate>Updated</span></dd></dl><dl ng-if=\"item.guid\"><dt translate>GUID</dt><dd>{{ item.guid }}</dd></dl><dl ng-if=\"item.unique_name\"><dt translate>Unique Name</dt><dd>{{ item.unique_name }}</dd></dl><dl><dt translate>Type</dt><dd>{{ item.type }}</dd></dl><dl ng-if=\"item.renditions\"><dt translate>Dimensions</dt><dd>{{ item.renditions.original.width }} x {{ item.renditions.original.height }}</dd></dl><dl ng-if=\"item.type == 'picture' && item.archive_description && item.archive_description !== item.description_text\"><dt translate>Description</dt><dd sd-html-preview=\"item.archive_description\"></dd></dl></div><div ng-if=\"item.associations && item.associations.featuremedia\" sd-associated-item-metadata data-association=\"item.associations.featuremedia\" data-title=\"Feature Media\"></div></div>");
        $templateCache.put('scripts/apps/archive/views/package_item_labels_dropdown_directive.html', "<ul><li ng-if=\"labels.length\"><button option=\"No label\" ng-click=\"setItemLabel(null);\" class=\"remove\"><i class=\"icon-remove\"></i>-- {{::'No label'|translate}} --</button></li><li ng-if=\"labels.length\" ng-repeat=\"label in labels track by label.qcode\"><button ng-disabled=\"isSetItemLabel(label)\" option=\"{{ label.name }}\" ng-click=\"setItemLabel(label);\"><i class=\"icon-label\"></i>{{ :: label.name | translate }}</button></li><li ng-if=\"!labels.length\"><button ng-disabled=\"true\">{{::'No available labels'|translate}}</button></li></ul>");
        $templateCache.put('scripts/apps/archive/views/package_item_labels_dropdown.html', "<div sd-package-item-labels-dropdown></div>");
        $templateCache.put('scripts/apps/archive/views/preview.html', "<div><div class=\"content-container\"><header class=\"preview-header\" ng-class=\"{active: previewState.toggleHeader}\"><div class=\"preview-header__timestamp\" title=\"{{userLookup[selected.preview.original_creator].display_name || selected.preview.original_creator}}\"><label translate>Created</label><time sd-datetime data-date=\"selected.preview.firstcreated\"></time><label ng-if=\"selected.preview.original_creator\" translate>by</label><b>{{userLookup[selected.preview.original_creator].display_name || selected.preview.original_creator}}</b><div ng-if=\"selected.preview.versioncreated\" class=\"preview-header__border-block\"><label translate>Modified</label><time sd-datetime data-date=\"selected.preview.versioncreated\"></time></div></div><div class=\"preview-header__flex-container\"><div class=\"preview-header__icon-block\"><div class=\"preview-header__flex-row\"><i class=\"filetype-icon-{{selected.preview.type }}\" title=\"{{'Article Type' | translate }}: {{selected.preview.type}}\"></i></div><div class=\"preview-header__flex-row\" sd-item-priority data-priority=\"selected.preview.priority\"></div><div class=\"preview-header__flex-row\" sd-item-urgency data-urgency=\"selected.preview.urgency\"></div></div><div class=\"preview-header__main-block\"><div class=\"preview-header__flex-row\"><span ng-if=\"selected.preview.slugline\" class=\"keyword\" title=\"{{selected.preview.slugline}}\" sd-html-preview=\"selected.preview.slugline\"></span></div><div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.anpa_take_key\"><span class=\"inline-label\">takekey:</span><span class=\"takekey\">{{selected.preview.anpa_take_key | translate}}</span></div><div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.ednote\"><span class=\"inline-label\">ednote:</span><span class=\"ednote\">{{selected.preview.ednote | translate}}</span></div><div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.company_codes.length\"><span class=\"inline-label\">company codes:</span><span class=\"company-codes\">{{getCompanyCodes()}}</span></div><div class=\"preview-header__flex-row\"><span sd-item-state data-state=\"selected.preview.state\" data-embargo=\"item.embargo\"></span> <span class=\"state-label not-for-publication\" ng-if=\"item.flags.marked_for_not_publication\" translate>Not For Publication</span> <span class=\"state-label legal\" ng-if=\"selected.preview.flags.marked_for_legal\" translate>Legal</span> <span class=\"state-label sms\" ng-if=\"selected.preview.flags.marked_for_sms\" translate>Sms</span> <span class=\"state-label updated\" ng-if=\"selected.preview.rewritten_by\" translate>Updated</span></div><div class=\"preview-header__flex-row preview-header__flex-row--single-line\"><span ng-if=\"item._type === 'archived'\" class=\"stage\" tooltip=\"{{:: 'Archived from' | translate}} {{deskName}} / {{ stage }}\" tooltip-placement=\"bottom\" ng-show=\"stage\"><b>{{:: 'Archived from' | translate}} {{deskName}}</b> / {{ stage }}</span> <span ng-if=\"item._type !== 'archived'\" class=\"stage\" tooltip=\"{{deskName}} / {{ stage }}\" tooltip-placement=\"bottom\" ng-show=\"stage\"><b>{{deskName}}</b> / {{ stage }}</span></div></div><div class=\"preview-header__side-block\"><div class=\"preview-header__flex-row\" ng-if=\"item.type === 'text'\"><span class=\"word-count\"><b>{{ selected.preview.word_count || 0 }}</b> <span translate translate-n=\"selected.preview.word_count\" translate-plural=\"WORDS\">WORD</span></span></div><div class=\"preview-header__flex-row\"><span class=\"data\">{{ item.source }}</span></div><div class=\"preview-header__flex-row\"><div sd-highlights-info data-item=\"selected.preview\"></div></div><div class=\"preview-header__flex-row\" sd-assignment-icon data-item=\"item\"></div></div><button class=\"preview-header__toggle\" ng-class=\"{active: previewState.toggleHeader}\" ng-click=\"togglePreviewHeader()\" tabindex=\"-1\"><i class=\"icon-chevron-down-thin\"></i></button></header><div class=\"composite-nav\" ng-if=\"selected.preview.type === 'composite'\"><i class=\"filetype-icon-large-composite\"></i><p class=\"title preview-headline\" ng-if=\"selected.preview.headline\" ng-class=\"{condensed: !lock}\" sd-html-preview=\"selected.preview.headline\"></p></div><div ng-hide=\"hideActions()\" class=\"action-menu\"><div sd-item-actions-menu data-item=\"selected.preview\" data-active=\"selected.preview\"></div></div><div id=\"locked\" class=\"clearfix\" sd-item-lock data-item=\"selected.preview\"></div><div class=\"rewrite\" ng-if=\"selected.preview.rewrite_id\">{{ :: 'This story has been rewritten by: ' | translate }}<a ng-click=\"previewRewriteStory()\" class=\"open-item\"><i class=\"icon-external\"></i></a></div><p class=\"title preview-headline\" ng-if=\"selected.preview.headline && selected.preview.type !== 'composite'\" ng-class=\"{condensed: !lock}\" sd-html-preview=\"selected.preview.headline\"></p><p class=\"nav-space\" ng-if=\"!selected.preview.headline && !lock\"></p><div class=\"core-content\"><p ng-if=\"selected.preview.is_spiked\" class=\"alert alert-warning expires\"><span translate>expires</span> <time sd-datetime data-date=\"selected.preview.expiry\"></time></p><!-- item rendition --><div ng-if=\"selected.preview.type === 'picture' || selected.preview.type === 'graphic'\" class=\"picture-preview\"><div><span translate>Original</span><div sd-item-rendition data-item=\"selected.preview\" data-rendition=\"viewImage\" ng-click=\"preview(item);\"></div><p class=\"nav-space description-text\" ng-if=\"selected.preview.headline !== selected.preview.description_text &&\n" +
            "                      selected.preview.description_text\">{{selected.preview.description_text}}</p></div></div><div ng-if=\"selected.preview.associations.featuremedia\"><div sd-item-rendition data-item=\"selected.preview.associations.featuremedia\" data-rendition=\"viewImage\"></div><p class=\"nav-space description-text\">{{selected.preview.associations.featuremedia.description_text}}</p></div><div ng-if=\"selected.preview.type === 'audio'\"><audio controls sd-sources data-renditions=\"selected.preview.renditions\"></audio></div><div ng-if=\"selected.preview.type === 'video'\"><video controls sd-sources data-renditions=\"selected.preview.renditions\"></video></div><div class=\"text abstract\" ng-show=\"selected.preview.abstract\" sd-html-preview=\"selected.preview.abstract\"></div><div class=\"text byline\" ng-show=\"selected.preview.byline\" sd-html-preview=\"selected.preview.byline\"></div><div class=\"text dateline\" ng-show=\"selected.preview.dateline\" sd-html-preview=\"selected.preview.dateline.text\"></div><div class=\"text body-text\" ng-show=\"selected.preview.body_html\" sd-html-preview=\"selected.preview.body_html\" item=\"selected.preview\"></div><div class=\"text body-footer\" ng-show=\"selected.preview.body_footer\" sd-html-preview=\"selected.preview.body_footer\" item=\"selected.preview\"></div><div class=\"text sign-off\" ng-show=\"selected.preview.sign_off\" sd-html-preview=\"selected.preview.sign_off\"></div><!-- custom date, text and url fields --><div ng-repeat=\"field in fields track by field._id\" order=\"{{editor[field._id].order}}\" ng-if=\"selected.preview.extra[field._id] && (field.field_type === 'text' || field.field_type === 'date' || field.field_type === 'urls')\"><div class=\"text body-text\" sd-short-date ng-if=\"field.field_type === 'date'\" data-date=\"selected.preview.extra[field._id]\"></div><div class=\"text body-text\" ng-if=\"field.field_type === 'text'\" sd-html-preview=\"selected.preview.extra[field._id]\"></div><ul class=\"text body-text\" ng-if=\"field.field_type === 'urls'\"><li ng-repeat=\"item in selected.preview.extra[field._id] track by $index\">{{item.url}}<br><p class=\"nav-space description-text\">{{item.description}}</p></li></ul></div><div class=\"composite-preview\" ng-if=\"selected.preview.type === 'composite'\"><div sd-package data-item=\"selected.preview\" data-setitem=\"openSingleItem(selected)\"></div></div></div></div></div>");
        $templateCache.put('scripts/apps/archive/views/provider-menu.html', "<button class=\"dropdown__toggle\" dropdown__toggle>{{ selected || 'Show all' | translate}} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu pull-right\"><li ng-repeat=\"provider in items._facets.provider.terms\"><a href=\"\" ng-click=\"setProvider(provider.term)\">{{ provider.term }} <i>({{ provider.count }})</i></a></li><li class=\"dropdown__menu-divider\" ng-show=\"selected\"></li><li ng-show=\"selected\"><a href=\"\" ng-click=\"setProvider(null)\" translate>Show All</a></li></ul>");
        $templateCache.put('scripts/apps/archive/views/related-view.html', "<div class=\"related-item-view\"><ul><li ng-repeat=\"relatedItem in relatedItems._items\"><div class=\"related-item\" ng-click=\"open(relatedItem)\"><i class=\"type-icon\" sd-filetype-icon data-item=\"relatedItem\"></i> <span class=\"keyword\" ng-if=\"relatedItem.slugline\">{{ relatedItem.slugline }}</span> <span sd-item-container data-item=\"relatedItem\" class=\"container\"></span> <span class=\"state-label state-{{relatedItem.state}}\">{{ relatedItem.state }}</span><div class=\"item\"><span ng-href=\"\" title=\"{{ relatedItem.headline }}\" class=\"headline\">{{ relatedItem.headline || relatedItem.description_text }}</span></div></div></li></ul></div>");
        $templateCache.put('scripts/apps/archive/views/resend-configuration.html', "<div sd-modal data-model=\"item\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a><h3 translate>Resend To</h3></div><div class=\"modal__body modal__body--add-min-height\"><fieldset><div class=\"field\" ng-show=\"customSubscribers\"><label class=\"form-label\" translate>Select Subscribers</label><div class=\"term-editor\" sd-meta-terms data-item=\"selectedSubscribers\" data-field=\"items\" data-unique=\"qcode\" data-list=\"customSubscribers\" data-header=\"true\" data-reload-list=\"true\"></div></div></fieldset></div><div class=\"modal__footer\"><button id=\"save-edit-btn\" type=\"submit\" class=\"btn btn--primary pull-right\" ng-click=\"resendItem()\" ng-disabled=\"selectedSubscribers.items.length == 0\" translate>Resend</button> <button id=\"cancel-edit-btn\" type=\"button\" class=\"btn pull-right\" ng-click=\"cancel()\" translate>Cancel</button></div></div>");
        $templateCache.put('scripts/apps/archive/views/single-item-preview.html', "<div class=\"condensed-preview\"><!-- audio preview --><div class=\"full-preview\" ng-if=\"item.type == 'audio'\"><audio controls sd-sources data-renditions=\"item.renditions\"></audio></div><!-- picture preview --><div class=\"full-preview\" ng-if=\"item.type == 'picture' || item.type == 'graphic'\" sd-ratio-calc><div class=\"rendition\" sd-item-rendition data-item=\"item\" data-ratio=\"ratio\" data-rendition=\"original\"></div></div><!-- text preview --><div class=\"lightbox-paper\" ng-show=\"item.type == 'text'\"><div class=\"lightbox-text\"><div class=\"lightbox-title\">{{ item.headline }}</div><div class=\"lightbox-fulltext\"><small ng-show=\"item.slugline\">{{ item.slugline || item.headline }}</small><div ng-show=\"item.body_html\" class=\"lightbox-fullcontent\" sd-html-preview=\"item.body_html\"></div></div></div></div><!-- composite preview --><div class=\"full-preview composite\" ng-show=\"item.type == 'composite'\"><div sd-package data-item=\"item\" data-mode=\"flat\" data-setitem=\"setitem({selected: selected})\"></div></div><div class=\"lightbox-caption\">{{ item.headline }}</div></div>");
        $templateCache.put('scripts/apps/archive/views/upload-attachments.html', "<div class=\"modal__header\"><button type=\"button\" class=\"modal__close pull-right\" ng-click=\"cancel()\" ng-hide=\"saving\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\">{{ activity.label | translate }}</h3></div><div class=\"modal__body\"><form name=\"attachmentsForm\"><div class=\"upload-edit\" ng-show=\"items.length\"><ul class=\"upload-thumbs flex-grid flex-grid--boxed flex-grid--wrap-items flex-grid--small-4\"><li ng-repeat=\"item in items\" class=\"flex-grid__item sd-shadow--z3 sd-card\"><div class=\"thumb sd-card__thumbnail\"><div class=\"holder\"><i class=\"big-icon--text\"></i></div><span class=\"remove\" ng-click=\"cancelItem(item)\"><i class=\"icon-close-small\"></i></span></div><div class=\"sd-card__content\"><div class=\"upload-progress\" ng-show=\"item.progress\"><div class=\"bar\" style=\"width:{{ item.progress }}%\"></div></div><div class=\"other-info\"><div class=\"form__row\"><label>Title *</label><input type=\"text\" required ng-model=\"item.meta.title\" class=\"contenteditable-input\"></div><div class=\"form__row\"><label>Description *</label><textarea class=\"contenteditable-input\" ng-model=\"item.meta.description\" sd-auto-height required></textarea></div><div class=\"form__row\"><label translate>File Name</label><div class=\"contenteditable-input\">{{ :: item.file.name }}</div></div><div class=\"form__row\"><label translate>File Size</label><div class=\"contenteditable-input\">{{ :: item.file.size | filesize }}</div></div></div></div></li></ul></div></form></div><div class=\"modal__footer\"><span class=\"pull-left\" translate>* fields are required</span> <button class=\"btn btn--primary pull-right\" ng-click=\"save()\" ng-disabled=\"attachmentsForm.$invalid || saving\" translate>Upload</button> <button class=\"btn pull-right\" ng-click=\"cancel()\" ng-disabled=\"saving\" translate>Cancel</button></div>");
        $templateCache.put('scripts/apps/archive/views/upload.html', "<sd-multi-image-edit data-is-upload=\"true\" data-images-original=\"imagesMetadata\" data-validator=\"validator\" data-hide-edit-pane=\"imagesMetadata.length < 1\" cancel-handler=\"cancel\" save-handler=\"handleImageMetadataEdit\" get-thumbnail-html=\"getThumbnailHtml\" get-icon-for-item-type=\"getIconForItemType\" get-progress=\"getProgress\" on-remove-item=\"onRemoveItem\" upload-in-progress=\"saving\"><sd-multi-edit-select-desk><div ng-if=\"deskSelectionAllowed === true && desks !== null\" class=\"dropdown dropdown--dark\" dropdown is-open=\"isOpen\"><button class=\"dropdown__toggle dropdown__toggle--small dropdown__toggle--hollow dropdown-toggle\" dropdown__toggle aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"dropdown__button-label\">Send to:</span> <span>{{selectedDesk.name}}</span> <b class=\"dropdown__caret white\"></b></button><!-- TODO: fix dropdown2 component so height adjusts according to available space--><ul class=\"dropdown__menu dropdown--align-right\" style=\"max-height: 400px; overflow: auto\"><li ng-repeat=\"desk in desks track by desk._id\"><button ng-click=\"selectDesk(desk)\">{{desk.name}}</button></li></ul></div></sd-multi-edit-select-desk><sd-multi-edit-additional-content><div class=\"drag-area\" ngf-drop=\"addFiles($files)\" ngf-multiple=\"!uniqueUpload\" ngf-drag=\"drag($isDragging, $class, $event)\"><div ng-if=\"isDragging\" class=\"upload__target\" style=\"display: block\"></div><div ng-if=\"(!items.length) && canUpload()\" class=\"upload__info\"><div class=\"upload__info-icon\"></div><h3 class=\"upload__info-heading\" translate>Drag Your Files Here</h3><div class=\"upload__info-label\" translate>or</div><button ng-click=\"invokeImagesInput()\" class=\"btn btn--hollow btn--ui-dark upload__info-button\" translate>Select them from folder</button> <input ng-if=\"uniqueUpload\" id=\"images-input\" type=\"file\" ngf-select=\"addFiles($files)\" class=\"hide\"> <input ng-if=\"!uniqueUpload\" id=\"images-input\" type=\"file\" ngf-select=\"addFiles($files)\" multiple class=\"hide\"></div></div></sd-multi-edit-additional-content></sd-multi-image-edit>");
        $templateCache.put('scripts/apps/authoring/attachments/attachments.html', "<div class=\"attachments-pane\" ng-controller=\"AttachmentsCtrl as ctrl\" ngf-drop=\"ctrl.selectFiles($files)\" ngf-stop-propagation=\"true\" ngf-multiple=\"true\"><sd-attachments-list store=\"store\"></sd-attachments-list><div class=\"attach-indicator\" ng-if=\"widget\" ng-show=\"ctrl.files.length < ctrl.maxFiles && ctrl.isLockedByMe\" ng-class=\"{empty: ctrl.files.length === 0}\"><div class=\"round-box\"><i class=\"big-icon--upload-alt icon\"></i></div><div class=\"subtext\" translate>Drag one or more files here to upload them, or just click the button below.</div><a class=\"btn btn--hollow\" ng-disabled=\"!ctrl.editable\" ngf-select=\"ctrl.selectFiles($files)\" ngf-multiple=\"true\">{{ :: 'Attach files' | translate }}</a></div><button ng-if=\"!widget\" class=\"item-association\" ng-disabled=\"!ctrl.editable\" ngf-select=\"ctrl.selectFiles($files)\" ngf-multiple=\"true\"><div class=\"subtext\"><i class=\"icon-attachment-large\"></i> <span translate>Drag one or more files here to upload them, or just click here.</span></div></button><div sd-modal data-model=\"ctrl.edit\" data-close=\"ctrl.closeEdit()\"><sd-attachments-editor-modal store=\"store\"></sd-attachments-editor-modal></div></div>");
        $templateCache.put('scripts/apps/authoring/authoring/directives/WordCount.html', "<span ng-if=\"!countOnly\" class=\"char-count words\" translate>{{numWords}} words</span> <span ng-if=\"countOnly\" class=\"char-count words\">{{numWords}}</span>");
        $templateCache.put('scripts/apps/authoring/comments/views/comments-widget.html', "<div ng-controller=\"CommentsWidgetCtrl\"><ul class=\"notification-list white\"><li ng-repeat=\"comment in comments\" ng-class=\"{active: comment._id === active}\"><figure class=\"avatar\"><img sd-user-avatar data-user=\"comment.user\"></figure><div class=\"content\"><div class=\"text\" sd-comment-text data-comment=\"comment\" data-name=\"{{comment.user.display_name || comment.user.username}}\" data-text=\"{{comment.text}}\"></div><span class=\"date\" sd-reldate datetime=\"comment._created\"></span></div></li><li class=\"no-comments\" ng-show=\"comments.length === 0\"><div class=\"round-box\"><i class=\"big-icon--chat\"></i></div><h3 translate>No comments so far.</h3><span translate>Be the first...</span></li><li class=\"loading-info\" ng-show=\"comments === null\" translate>Loading...</li></ul><div class=\"add-comment\"><form name=\"commentsForm\"><div sd-user-mentio></div><textarea class=\"new-comment\" sd-auto-height ng-model=\"text\" mentio id=\"mentio-users\" ng-keyup=\"saveOnEnter($event)\"></textarea><div class=\"actions\"><div class=\"pull-left post\"><input type=\"checkbox\" ng-model=\"saveEnterFlag\"> <span translate>Post on 'Enter'</span></div><button id=\"comment-post\" class=\"btn btn--primary pull-right\" ng-click=\"save()\" ng-show=\"!saveEnterFlag\" ng-disabled=\"!text\" translate>Post</button> <button class=\"btn pull-right\" ng-click=\"cancel()\" ng-show=\"!saveEnterFlag\" translate>Cancel</button></div></form></div></div>");
        $templateCache.put('scripts/apps/authoring/compare-versions/views/compare-versions.html', "<div class=\"subnav subnav--top\"><h3 class=\"page-nav-title\" translate>Compare Versions</h3><button class=\"close-compare-versions\" ng-click=\"closeScreen()\"><i class=\"icon-close-small\"></i></button></div><div class=\"compare-versions-screen main-section\"><div class=\"boards-list\"><div ng-repeat=\"board in boards\" class=\"board\" style=\"width:{{ 100 / boards.length }}%\"><div class=\"navbtn dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle title=\"{{ 'Select current version.' | translate }}\"><i class=\"icon-collapse\"></i></button><div class=\"dropdown__menu\"><ul class=\"dropdown__menu--compare-versions\" sd-compare-versions-inner-dropdown data-board=\"{{$index}}\"></ul></div></div><div ng-if=\"!board.article\" class=\"board__no-article\" translate>* choose article version from dropdown menu</div><div sd-compare-versions-article data-article=\"board.article\" data-compare-with=\"boards[1].article\" data-focus=\"$first\" class=\"board-article\" ng-if=\"board.article\"></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/compare-versions/views/sd-compare-versions-article.html', "<article class=\"main-article\" tabindex=\"0\" ng-class=\"{locked: isLocked}\"><div><div class=\"board-article-header\"><div class=\"board-article-header__metadata\"><span class=\"board-article-header__metadata-label\">{{ :: 'version' | translate }}: </span><span class=\"board-article-header__metadata-content\">{{ item._current_version }}</span> <span class=\"board-article-header__metadata-label\">{{ :: 'author' | translate }}: </span><span class=\"board-article-header__metadata-content\">{{ item.author.display_name }}</span></div><div class=\"state-label state-{{item.state}}\">{{item.state}}</div></div><div ng-disabled=\"true\" class=\"fieldset main-article__fieldset\" sd-article-edit></div></div></article>");
        $templateCache.put('scripts/apps/authoring/compare-versions/views/sd-compare-versions-dropdown.html', "<div class=\"dropdown__menu--compare-versions\"><ul><li ng-repeat=\"item in items\"><button ng-click=\"toggle({id: item._id, version: item._current_version}); $event.stopPropagation();\" ng-class=\"{disabled: item._current_version === current.version}\"><span class=\"headline\" ng-show=\"item.headline\">{{ item.headline }}</span> <span ng-show=\"!item.headline\">{{ :: 'Untitled' | translate }}</span> <i class=\"icon-ok\" ng-show=\"isSelected({id: item._id, version: item._current_version})\"></i> <span class=\"desk-details\"><span ng-show=\"item.desk\">{{ :: 'desk:' | translate }} {{item.desk}}</span> <span ng-show=\"item.stage\">{{ :: 'stage:' | translate }} {{item.stage}} </span></span><em>{{ :: 'version' | translate }}: {{ item._current_version }}</em> <span class=\"state-label state-{{ :: item.state}}\">{{ :: item.state | translate }}</span></button></li><li ng-if=\"items.length === 0\"><button translate>NO SUGGESTIONS.</button></li></ul></div><div class=\"fieldset dropdown__menu-footer\"><button class=\"btn btn--primary\" ng-click=\"open(); $event.stopPropagation();\" translate>Ok</button> <button class=\"btn\" translate>Cancel</button></div>");
        $templateCache.put('scripts/apps/authoring/compare-versions/views/sd-compare-versions-inner-dropdown.html', "<li ng-repeat=\"item in items\" ng-if=\"items.length\"><button ng-click=\"open({id: item._id, version: item._current_version});\"><span class=\"headline\" ng-show=\"item.headline\">{{ item.headline }}</span> <span ng-show=\"!item.headline\">{{ :: 'Untitled' | translate }}</span> <em>{{ :: 'version' | translate }}: {{ item._current_version }}, {{ :: 'author' | translate }}: {{ item.author.display_name }}</em></button></li><li ng-if=\"!items.length\" class=\"msg\" translate>No items to add!</li>");
        $templateCache.put('scripts/apps/authoring/editor/views/find-replace.html', "<div><form><fieldset sd-find-replace><div class=\"form-group field\"><label for=\"find-replace-what\" translate>Find</label><input type=\"text\" class=\"form-control\" id=\"find-replace-what\" ng-model=\"from\" sd-autofocus ng-trim=\"false\" ng-model-options=\"{debounce: 500}\"></div><div class=\"form-group field\"><label for=\"find-replace-with\" translate>Replace with</label><input type=\"text\" class=\"form-control\" id=\"find-replace-with\" ng-model=\"to\" ng-trim=\"false\"></div><div class=\"btn-group\" role=\"group\"><label class=\"pull-left\" translate>Case Sensitive</label><span class=\"pull-right\" sd-switch ng-model=\"caseSensitive\"></span></div><div class=\"field clearfix\"></div><div class=\"btn-group pull-right\" role=\"group\"><button type=\"button\" class=\"btn\" ng-click=\"prev()\" ng-disabled=\"!from\">&laquo;</button> <button class=\"btn\" ng-click=\"next()\" ng-disabled=\"!from\">&raquo;</button></div><div class=\"btn-group pull-left\" role=\"group\"><button type=\"button\" class=\"btn\" ng-click=\"replace()\" ng-disabled=\"!from\" translate>Replace</button> <button type=\"button\" class=\"btn\" ng-click=\"replaceAll()\" ng-disabled=\"!from\" translate>Replace All</button></div><div class=\"field clearfix\"></div><button type=\"button\" class=\"btn\" ng-click=\"closeWidget(widget)\" translate>Done</button></fieldset></form></div>");
        $templateCache.put('scripts/apps/authoring/macros/views/macros-replace.html', "<div id=\"macros-diff\" ng-show=\"diff\"><span ng-show=\"!preview\"><em translate>No matches found.</em></span> <button ng-show=\"!preview\" class=\"done-btn\" ng-click=\"close()\" translate>OK</button> <span ng-show=\"preview\"><em>{{ preview }}</em></span> <button ng-show=\"preview\" class=\"replace-btn\" ng-click=\"replace()\" translate>replace</button> <button ng-show=\"preview\" class=\"prev-btn\" ng-click=\"prev()\" translate>prev</button> <button ng-show=\"preview\" class=\"next-btn\" ng-click=\"next()\" translate>next</button> <button ng-show=\"preview\" class=\"done-btn\" ng-click=\"close()\" translate>done</button></div>");
        $templateCache.put('scripts/apps/authoring/macros/views/macros-widget.html', "<div class=\"widget\" ng-controller=\"Macros\"><div class=\"macro-option\" ng-show=\"groupedMacros\"><span translate>Group Macros</span> <span class=\"pull-right\" sd-switch ng-model=\"groupedList\"></span></div><div ng-show=\"!groupedList\"><ul class=\"link-list\" sd-loading=\"loading\"><li ng-repeat=\"macro in macros\"><button class=\"btn\" ng-click=\"call(macro)\">{{ macro.label | translate }}</button></li></ul></div><div ng-show=\"groupedList\"><div sd-toggle-box data-title=\"{{:: 'quick list' | translate }}\" data-open=\"true\"><ul class=\"link-list\" sd-loading=\"loading\"><li ng-repeat=\"macro in quickList | orderBy:'label'\"><button class=\"btn\" ng-click=\"call(macro)\">{{ macro.label | translate }}</button></li></ul></div><div ng-repeat=\"(key,value) in orderedGroupedMacros\"><div sd-toggle-box data-title=\"{{:: key | translate }}\" ng-click=\"setGroupStatus(key)\" data-open=\"{{getGroupStatus(key)}}\"><ul class=\"link-list\" sd-loading=\"loading\"><li ng-repeat=\"macro in value\"><button class=\"btn\" ng-click=\"call(macro)\">{{ macro.label | translate }}</button></li></ul></div></div><div sd-toggle-box data-title=\"{{:: 'miscellaneous' | translate }}\" ng-click=\"setGroupStatus('miscellaneous')\" data-open=\"{{getGroupStatus('miscellaneous')}}\"><ul class=\"link-list\" sd-loading=\"loading\"><li ng-repeat=\"macro in miscMacros | orderBy:'label'\"><button class=\"btn\" ng-click=\"call(macro)\">{{ macro.label | translate }}</button></li></ul></div></div></div>");
        $templateCache.put('scripts/apps/authoring/media/views/media-copy-metadata-directive.html', "<div class=\"btn-group--flex sd-margin-b--1\"><button type=\"button\" class=\"btn btn--hollow btn--primary btn--expanded\" ng-click=\"copyMetadata(metadata)\" translate>Copy metadata</button> <button type=\"button\" class=\"btn btn--hollow btn--expanded\" ng-click=\"pasteMetadata()\" ng-disabled=\"!metadataFromStorage\" translate>Paste metadata</button></div><a ng-click=\"clearSavedMetadata()\" class=\"text-link text-link--white pull-right\" ng-show=\"metadataFromStorage\" translate>Clear saved metadata</a>");
        $templateCache.put('scripts/apps/authoring/media/views/media-metadata-editor-directive.html', "<div class=\"form__row\" ng-repeat=\"field in fields track by field.field\"><sd-line-input class=\"sd-line-input--no-margin\" ng-if=\"field.type === 'string' || (!field.type && !field.cv)\" ng-model=\"item[field.field]\" data-sync=\"true\" data-dark=\"dark\" data-boxed=\"boxed\" data-label=\"{{ field.label }}\" data-required=\"field.required\" data-disabled=\"isDisabled(field)\" data-onchange=\"onChange({key: field.field})\" data-onblur=\"onBlur()\" data-maxlength=\"field.maxlength\" data-placeholder=\"{{ placeholder[field.field] }}\" data-textarea=\"field.textarea\"><sd-line-input class=\"sd-line-input--no-margin\" ng-if=\"field.type === 'text'\" data-sync=\"true\" ng-model=\"item.extra[field.field]\" data-dark=\"dark\" data-boxed=\"boxed\" data-label=\"{{ field.label }}\" data-required=\"field.required\" data-disabled=\"isDisabled(field)\" data-onchange=\"onChange({key: 'extra'})\" data-onblur=\"onBlur()\" data-maxlength=\"field.maxlength\" data-placeholder=\"{{ placeholder[field.field] }}\"><div ng-if=\"field.type === 'list' || field.cv\"><label class=\"form-label\">{{ field.label }}</label><div sd-meta-place ng-if=\"field.field === 'place' && features.places_autocomplete\" class=\"data sd-terms--boxed\" data-item=\"item\" data-field=\"place\" ng-disabled=\"isDisabled(field)\" data-change=\"onChange({key: field})\"></div><div sd-meta-words-list ng-if=\"field.field === 'keywords'\" class=\"data sd-terms--boxed sd-line-input--dark-ui sd-line-input--boxed\" data-item=\"item\" data-field=\"keywords\" data-change=\"onChange({key: field})\" data-list=\"metadata.keywords\" data-disabled=\"isDisabled(field)\" data-style=\"sd-line-input__input\" data-header=\"true\"></div><div sd-meta-terms ng-if=\"!(field.field === 'place' && features.places_autocomplete) && field.field !== 'keywords'\" class=\"data sd-terms--boxed\" data-item=\"item\" data-field=\"{{ field.cv.schema_field || 'subject'}}\" data-unique=\"qcode\" data-list=\"field.cv.items\" data-cv=\"field.cv\" ng-disabled=\"isDisabled(field)\" data-header=\"true\" data-change=\"onChange({key: field})\" data-include-parent=\"{{ field.includeparent }}\"></div></div><div ng-if=\"field.type === 'date'\"><label class=\"form-label\">{{ field.label }}</label><div sd-datepicker ng-disabled=\"isDisabled(field)\" ng-model=\"item.extra[field.field]\" data-format=\"YYYY-MM-DDT00:00:00+0000\" data-on-change=\"onChange({key: 'extra'})\"></div></div></div>");
        $templateCache.put('scripts/apps/authoring/media/views/media-metadata-view-directive.html', "<span ng-if=\"showAltText\"><em>{{:: 'Alt text:' | translate}}</em> {{item.alt_text || ('[No Value]' | translate)}} </span><span ng-if=\"validator.byline\"><em>{{:: 'Credit:' | translate}}</em> {{item.byline || ('[No Value]' | translate)}} </span><span ng-if=\"validator.copyrightholder\"><em>{{:: 'Copyright holder:' | translate}}</em> {{item.copyrightholder || ('[No Value]' | translate)}} </span><span ng-if=\"validator.usageterms\"><em>{{:: 'Assign rights:' | translate}}</em> {{item.usageterms || ('[No Value]' | translate)}} </span><span ng-if=\"validator.copyrightnotice\"><em>{{:: 'Copyright notice:' | translate}}</em> {{item.copyrightnotice || ('[No Value]' | translate)}}</span>");
        $templateCache.put('scripts/apps/authoring/metadata/views/meta-place-directive.html', "<div class=\"dropdown dropdown--dropright dropdown-terms\" dropdown sd-dropdown-focus sd-dropdown-position><button class=\"dropdown__toggle\" dropdown__toggle tabindex=\"{{ tabindex }}\" ng-disabled=\"disabled\" ng-if=\"!disabled\"><i class=\"icon--white icon-plus-large\"></i></button><div class=\"dropdown__menu nested-menu pull-right\" sd-loading=\"loading\"><div sd-typeahead items=\"terms\" term=\"selectedTerm\" search=\"searchTerms(term)\" select=\"selectTerm(item)\" always-visible=\"true\" data-disabled=\"disabled\" data-debounce=\"1000\"><ul class=\"item-list\"><li typeahead-item=\"t\" ng-repeat=\"t in terms track by t.code\" j><button>{{ :: t.name }} ({{ :: [t.state, t.country_code] | join }}) <span ng-if=\"t.feature_class === 'A'\"><small ng-show=\"t.state\" class=\"label label--hollow\" translate>state, region, ...</small> <small ng-show=\"!t.state\" class=\"label label--hollow\" translate>country</small></span></button></li></ul></div></div></div><div class=\"terms-list\" ng-if=\"item[field].length\"><ul><li ng-if=\"!disabled\" class=\"pull-left\" ng-repeat=\"t in item[field]\" ng-click=\"removeTerm(t)\">{{ t.name }} <i class=\"icon-close-small\"></i></li><li ng-if=\"disabled\" class=\"pull-left disabled\" ng-repeat=\"t in item[field]\">{{ t.name }}</li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-dropdown.html', "<div class=\"dropdown dropdown--noarrow dropdown--dropleft\" dropdown sd-metadropdown-focus><button ng-disabled=\"disabled\" class=\"dropdown__toggle line-input\" tabindex=\"{{tabindex}}\" dropdown__toggle ng-if=\"listFields.indexOf(field) === -1 && !icon\">{{ key && values[item[field]] && values[item[field]].name ? values[item[field]].name: (item[field].name || item[field] ? item[field].name || item[field] : \"none\") | translate }} <b class=\"dropdown__caret\"></b></button> <button ng-disabled=\"disabled\" class=\"dropdown__toggle line-input\" tabindex=\"{{tabindex}}\" dropdown__toggle ng-if=\"listFields.indexOf(field) > -1 && !icon\">{{ item[field].length > 0 ? item[field][0].name : \"none\" | translate }} <b class=\"dropdown__caret\"></b></button> <button ng-disabled=\"disabled\" class=\"dropdown__toggle line-input\" tabindex=\"{{tabindex}}\" dropdown__toggle ng-if=\"icon\"><span class=\"{{icon}}-{{item[field]}}\" ng-style=\"{backgroundColor: values[item[field]].color}\">{{ values[item[field]].short || item[field] || 0 }}</span> {{ values[item[field]].name }} <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu\"><li ng-if=\"label\"><div class=\"dropdown__menu-label\">{{ label }}</div></li><li ng-click=\"select()\"><button ng-disabled=\"disabled\" translate>None</button></li><li ng-repeat=\"item in list\" ng-click=\"select(item)\" ng-if=\"field !== 'place'\"><button ng-disabled=\"disabled\"><span ng-if=\"icon\" class=\"{{icon}}-{{item.name}}\" ng-style=\"{backgroundColor: item.color}\">{{item.short || item.name}}</span> {{::item.name}}</button></li><li class=\"place-dropdown\" ng-repeat=\"(region, placelist) in places\" ng-if=\"field === 'place'\"><span ng-if=\"region !== 'undefined'\">{{ ::region }}</span> <button ng-repeat=\"item in placelist\" ng-click=\"select(item)\">{{ ::item.name }}</button></li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-list-item.html', "<li class=\"basic-list__item\"><label class=\"basic-list__item-label\">{{label}}</label><div class=\"basic-list__item-data\" ng-transclude></div></li>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-locators.html', "<div class=\"term-editor data visible locators\" ng-show=\"!header\" sd-loading=\"loading\"><div sd-typeahead items=\"locators\" data-tabindex=\"tabindex\" term=\"$ctrl.selectedTerm\" search=\"searchLocator(term)\" select=\"selectLocator(item)\" data-blur=\"selectLocator(item)\" data-disabled=\"disabled\" data-keepinput=\"keepinput\" data-debounce=\"1000\"><li typeahead-item=\"t\" ng-repeat=\"t in locators\" class=\"typeahead-item--padded\">{{ :: t.city }}<div class=\"country_state_info\">{{:: t.state}}, {{:: t.country}}</div></li></div></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-tags.html', "<div class=\"dropdown dropdown--dropright dropdown--bigger dropdown-terms\"><input class=\"line-input\" type=\"text\" ng-show=\"adding\" ng-model=\"newTag\" ng-disabled=\"disabled\" ng-keyup=\"key($event)\"> <button class=\"dropdown__toggle\" ng-show=\"!adding\" ng-disabled=\"disabled\" ng-click=\"adding = true\"><i class=\"icon--white icon-plus-large\"></i></button></div><div class=\"terms\"><ul><li ng-class=\"{selected: isSelected(t)}\" ng-repeat=\"t in tags track by t\" ng-click=\"toggle(t)\">{{ t }}</li><li tooltip=\"{{:: 'Refresh suggestions' | translate}}\" tooltip-placement=\"left\" ng-click=\"refresh()\"><span ng-if=\"refreshing\" translate>Refreshing...</span> <i ng-if=\"!refreshing\" class=\"alt icon-refresh\"></i></li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-target-publishing.html', "<div class=\"form__row form__row--flex form__row--s-padding\"><div class=\"form__row-item form__row-item--no-grow\"><span sd-check ng-model=\"deny\" ng-show=\"!disabled\" label-position=\"inside\">{{:: 'Not' | translate }}</span></div><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\"><select ng-model=\"target\" ng-disabled=\"disabled\" class=\"sd-line-input__select\"><option value=\"\"></option><option value=\"{{t}}\" ng-repeat=\"t in list track by t.name\">{{:: t.name}}</option></select></div></div><div class=\"form__row-item form__row-item--no-grow\"><button class=\"btn btn--hollow btn--primary\" type=\"button\" ng-click=\"addTarget(target)\" ng-disabled=\"canAddTarget()\" translate>Add</button></div></div><div class=\"terms-list terms-list--full\" ng-if=\"targets.length\"><ul><li ng-repeat=\"t in targets\" ng-if=\"!disabled\" ng-click=\"removeTarget(t)\">{{ :: t['allow'] == false ? 'Not ' + t.name : t.name}}<i class=\"icon-close-small\"></i></li><li ng-repeat=\"t in targets\" ng-if=\"disabled\">{{ :: t['allow'] == false ? 'Not ' + t.name : t.name}}</li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-terms.html', "<div class=\"term-editor data visible\" ng-if=\"!header\" title=\"{{helperText}}\"><div sd-typeahead items=\"terms\" term=\"selectedTerm\" search=\"searchTerms(term)\" select=\"selectTerm(item)\" data-disabled=\"disabled\"><ul ng-if=\"activeTerm || activeList\"><li typeahead-item=\"t\" ng-repeat=\"t in terms track by t[uniqueField]\">{{getLocaleName(t)}}</li></ul></div></div><div class=\"dropdown dropdown--dropright dropdown-terms\" dropdown sd-dropdown-focus sd-dropdown-position title=\"{{ allSelected ? 'All items selected' : helperText  | translate }}\"><button class=\"dropdown__toggle\" dropdown__toggle tabindex=\"{{tabindex}}\" ng-disabled=\"disabled\" ng-if=\"header && !disabled\"><i class=\"icon--white icon-plus-large\"></i></button><ul class=\"dropdown__menu nested-menu pull-right\" style=\"{{ cv.popup_width ? 'min-width: 0; width: ' + cv.popup_width + 'px' : ''}}\"><li ng-show=\"!activeTerm && header\"><div sd-typeahead items=\"terms\" term=\"selectedTerm\" search=\"searchTerms(term)\" select=\"allowEntireCat && selectTerm(item, $event)\" always-visible=\"header\" data-disabled=\"disabled || allSelected\"><ul class=\"item-list\" vs-repeat vs-scroll-parent=\".item-list\" ng-if=\"!activeTree.length || activeList\"><li typeahead-item=\"t\" ng-repeat=\"t in terms track by t[uniqueField]\"><button ng-click=\"!allowEntireCat && openTree(t, $event)\" title=\"{{getLocaleName(t)}}\"><figure ng-if=\"t.user\" class=\"avatar\"><img sd-user-avatar data-user=\"t.user\" alt=\"{{getLocaleName(t)}}\"></figure>{{getLocaleName(t)}}</button></li></ul></div></li><li class=\"levelup\" ng-if=\"activeTerm && !preferredView\"><i class=\"backlink\" ng-click=\"openParent(activeTerm, $event)\"></i> <button ng-click=\"allowEntireCat && selectTerm(activeTerm, $event)\"><b class=\"category\">{{getLocaleName(activeTerm)}}</b> <b class=\"category-hover\" ng-if=\"allowEntireCat\">{{ :: \"Choose entire category\" | translate }}</b></button></li><li class=\"main-list\" ng-if=\"activeTree.length && !activeList && header\" ng-class=\"{active: activeTerm}\" ng-hide=\"allSelected\"><ul ng-if=\"userPreferredItems.length\"><li><button ng-click=\"setPreferredView('user', $event)\"><b translate>User</b></button></li><li ng-if=\"preferredView === 'user'\" ng-repeat=\"term in userPreferredItems track by term[uniqueField]\"><button ng-click=\"selectTerm(term, $event)\" ng-class=\"{'greyout': isSelected(term)}\" ng-disabled=\"isSelected(term)\">{{ getLocaleName(term) }}</button></li></ul><ul ng-if=\"deskPreferredItems.length\"><li><button ng-click=\"setPreferredView('desk', $event)\"><b translate>Desk</b></button></li><li ng-if=\"preferredView === 'desk'\" ng-repeat=\"term in deskPreferredItems track by term[uniqueField]\"><button ng-click=\"selectTerm(term, $event)\" ng-class=\"{'greyout': isSelected(term)}\" ng-disabled=\"isSelected(term)\">{{ getLocaleName(term) }}</button></li></ul><ul ng-if=\"userPreferredItems.length || deskPreferredItems.length\"><li><button ng-click=\"setPreferredView(null, $event)\"><b translate>All</b></button></li></ul><ul vs-repeat vs-scroll-parent=\".main-list\" ng-if=\"!preferredView\"><li ng-repeat=\"term in activeTree track by term[uniqueField]\"><button ng-if=\"tree[term[uniqueField]]\" class=\"nested-toggle\" ng-click=\"openTree(term, $event)\" title=\"{{getLocaleName(term)}}\"><figure ng-if=\"term.user\" class=\"avatar\"><img sd-user-avatar data-user=\"term.user\" alt=\"{{getLocaleName(term)}}\"></figure>{{getLocaleName(term)}} <i class=\"icon-chevron-right-thin\"></i></button> <button ng-if=\"!tree[term[uniqueField]]\" ng-click=\"selectTerm(term, $event)\" title=\"{{getLocaleName(term)}}\" ng-class=\"{'greyout': isSelected(term)}\" ng-disabled=\"isSelected(term)\">{{getLocaleName(term)}}</button></li></ul></li></ul></div><div class=\"terms-list\" ng-if=\"selectedItems.length\" title=\"{{helperText}}\"><ul><li ng-if=\"!disabled && !t.sub_label\" class=\"pull-left\" ng-repeat=\"t in selectedItems track by t[uniqueField]\" ng-click=\"removeTerm(t)\">{{getLocaleName(t)}}<i class=\"icon-close-small\"></i></li><li ng-if=\"!disabled && t.sub_label\" class=\"pull-left\" ng-repeat=\"t in selectedItems track by t[uniqueField]\" ng-click=\"removeTerm(t)\"><label>{{getLocaleName(t)}}:</label>{{t.sub_label}}<i class=\"icon-close-small\"></i></li><li class=\"pull-left\" ng-if=\"disabled && t.sub_label\" ng-repeat=\"t in selectedItems track by t[uniqueField]\"><label>{{getLocaleName(t)}}:</label>{{t.sub_label}}</li><li ng-if=\"disabled && !t.sub_label\" class=\"pull-left disabled\" ng-repeat=\"t in selectedItems track by t[uniqueField]\">{{getLocaleName(t)}}</li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-widget.html', "<ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'metadata' || !tab}\"><button ng-click=\"tab = 'metadata'\" translate>Metadata</button></li><!-- can't use ng-if due to https://stackoverflow.com/q/36357640/1175593 --><li ng-show=\"isAssigned(item)\" ng-class=\"{active: tab === 'assignment'}\"><button ng-click=\"tab = 'assignment'\" translate>Assignment</button></li></ul><div ng-controller=\"MetadataWidgetCtrl\"><div class=\"widget-content-padding\" ng-if=\"tab === 'metadata' || !tab\"><ul class=\"basic-list basic-list--dotted\"><li class=\"basic-list__item\" ng-if=\"_isInProductionStates\"><label class=\"basic-list__item-label\" ng-if=\"_editable\" translate>Not For Publication</label><span class=\"basic-list__item-data\" ng-if=\"_editable\"><span ng-if=\"_editable\" sd-switch ng-model=\"item.flags.marked_for_not_publication\"></span> </span><span ng-if=\"!_editable\"><span class=\"state-label not-for-publication\" ng-show=\"item.flags.marked_for_not_publication\" translate>Not For Publication</span> <span class=\"state-label for-publication\" ng-show=\"!item.flags.marked_for_not_publication\" translate>For Publication</span></span></li><li class=\"basic-list__item\" ng-if=\"_isInProductionStates\"><label class=\"basic-list__item-label\" ng-if=\"_editable\" translate>Legal</label><span class=\"basic-list__item-data\" ng-if=\"_editable\"><span sd-switch ng-model=\"item.flags.marked_for_legal\"></span> </span><span ng-if=\"!_editable\"><span class=\"state-label legal\" ng-show=\"item.flags.marked_for_legal\" translate>Legal</span></span></li><li sd-metadata-list-item data-label=\"'Usage terms' | translate\" ng-if=\"!isRemovedField('usageterms')\"><input class=\"basic-input\" type=\"text\" ng-model=\"item.usageterms\" ng-disabled=\"!_editable\" ng-change=\"autosave(item)\"></li><li class=\"basic-list__item basic-list__item--stacked\" ng-if=\"$root.config.features.alchemy\"><label translate>Tags</label><div sd-meta-tags data-item=\"item\" data-field=\"keywords\" data-source-field=\"body_html\" data-change=\"autosave(item)\" data-disabled=\"!_editable\"></div></li><li sd-metadata-list-item data-label=\"'Language' | translate\" ng-if=\"!isRemovedField('language')\"><input class=\"basic-input\" type=\"text\" ng-model=\"item.language\" ng-disabled=\"!_editable\" ng-change=\"autosave(item)\"></li><li sd-metadata-list-item data-label=\"'Pubstatus' | translate\" ng-if=\"item.pubstatus\">{{ item.pubstatus }}</li><li sd-metadata-list-item data-label=\"'Original source' | translate\" ng-if=\"item.original_source\">{{ item.original_source }}</li><li sd-metadata-list-item data-label=\"'Copyright' | translate\" ng-if=\"item.copyrightholder\">{{ item.copyrightholder }}</li><li sd-metadata-list-item data-label=\"'Copyright notice' | translate\" ng-if=\"item.copyrightnotice\">{{ item.copyrightnotice }}</li><li sd-metadata-list-item data-label=\"'Credit' | translate\" ng-if=\"item.creditline\">{{ item.creditline }}</li><li sd-metadata-list-item data-label=\"'State' | translate\"><span sd-item-state data-state=\"item.state\" data-embargo=\"item.embargo\"></span> <span ng-if=\"item.flags.marked_for_not_publication\" class=\"state-label not-for-publication\" translate>Not For Publication</span> <span ng-if=\"item.flags.marked_for_legal\" class=\"state-label legal\" translate>Legal</span> <span ng-if=\"item.flags.marked_for_sms\" class=\"state-label sms\" translate>Sms</span> <span ng-if=\"item.rewritten_by\" class=\"state-label updated\" translate>Updated</span></li><li sd-metadata-list-item data-label=\"'Ingest Provider' | translate\" ng-if=\"item.ingest_provider\"><div sd-meta-ingest data-item=\"item\"></div></li><li sd-metadata-list-item data-label=\"'Provider sequence' | translate\" ng-if=\"item.ingest_provider_sequence\">{{ item.ingest_provider_sequence }}</li><li sd-metadata-list-item data-label=\"'Expiry' | translate\" ng-if=\"item.expiry\"><div class=\"basic-list__item-data\" sd-reldate-complex datetime=\"item.expiry\"></div></li><li sd-metadata-list-item data-label=\"'Slugline' | translate\" ng-if=\"item.slugline\">{{ item.slugline }}</li><li sd-metadata-list-item data-label=\"'Urgency' | translate\" ng-if=\"item.urgency\">{{ item.urgency }}</li><li sd-metadata-list-item data-label=\"'Priority' | translate\" ng-if=\"item.priority\">{{ item.priority }}</li><li sd-metadata-list-item data-label=\"'Word Count' | translate\" ng-if=\"item.word_count\">{{ item.word_count }}</li><li sd-metadata-list-item data-label=\"'Word Count' | translate\" ng-if=\"item.keywords && item.keywords.length\">{{ item.keywords | mergeWords }}</li><li sd-metadata-list-item data-label=\"'Source' | translate\" ng-if=\"item.source\">{{ item.source }}</li><li sd-metadata-list-item data-label=\"'Take key' | translate\">{{ item.anpa_take_key }}</li><li sd-metadata-list-item data-label=\"'Signal' | translate\" ng-if=\"item.signal\">{{ item.signal }}</li><li sd-metadata-list-item data-label=\"'Service' | translate\" ng-if=\"item.anpa_category && item.anpa_category.length\">{{ item.anpa_category | mergeWords:'name' }}</li><li class=\"basic-list__item\" ng-repeat=\"cv in cvs track by cv._id\" ng-if=\"item[cv.schema_field] | mergeWords:'name' : cv._id\"><label class=\"basic-list__item-label\">{{ cv.display_name | translate }}</label><div class=\"basic-list__item-data\">{{getLocaleName(item[cv.schema_field], cv._id)}}</div></li><li sd-metadata-list-item data-label=\"'Genre' | translate\" ng-if=\"item.genre  && item.genre.length > 0 && !genreInCvs\">{{ item.genre | mergeWords:'name' }}</li><li sd-metadata-list-item data-label=\"'Service' | translate\" ng-if=\"item.place && item.place.length > 0 && !placeInCvs\">{{ item.place | mergeWords:'name' }}</li><li sd-metadata-list-item data-label=\"'Editorial Note' | translate\" ng-if=\"item.ednote\">{{ item.ednote }}</li><li sd-metadata-list-item data-label=\"'Dateline' | translate\">{{ item.dateline.text }}</li><li sd-metadata-list-item data-label=\"'Byline' | translate\">{{ item.byline }}</li><li sd-metadata-list-item data-label=\"'Sign-Off' | translate\">{{ item.sign_off }}</li><li sd-metadata-list-item data-label=\"'Version' | translate\" ng-if=\"item._current_version\">{{ item._current_version }}</li><li sd-metadata-list-item data-label=\"'Created' | translate\" ng-if=\"item.firstcreated\"><div sd-reldate-complex datetime=\"item.firstcreated\"></div></li><li sd-metadata-list-item data-label=\"'Last updated' | translate\" ng-if=\"item.versioncreated\"><div sd-reldate-complex datetime=\"item.versioncreated\"></div></li><li sd-metadata-list-item data-label=\"'Original ID' | translate\" ng-if=\"item.original_id\">{{ item.original_id }}</li><li sd-metadata-list-item data-label=\"'Original creator' | translate\" ng-if=\"item.originalCreator\">{{ item.originalCreator }}</li><li sd-metadata-list-item data-label=\"'Version creator' | translate\" ng-if=\"item.versionCreator\">{{ item.versionCreator }}</li><li class=\"basic-list__item basic-list__item--stacked\"><label class=\"basic-list__item-label basic-list__item-label--block\" translate>GUID</label><div class=\"basic-list__item-data\" id=\"guid\">{{item.guid}}</div></li><li sd-metadata-list-item data-label=\"'Unique name' | translate\"><input class=\"basic-input\" type=\"text\" ng-model=\"item.unique_name\" ng-change=\"autosave(item)\" ng-disabled=\"!_editable || !unique_name_editable\"></li><li sd-metadata-list-item data-label=\"'Type' | translate\">{{ item.type }}</li><li sd-metadata-list-item data-label=\"'Dimensions' | translate\" ng-if=\"item.renditions && item.renditions.original\">{{ item.renditions.original.width }} x {{ item.renditions.original.height }}</li><li sd-metadata-list-item data-label=\"'Description' | translate\" ng-if=\"item.type == 'picture' && item.archive_description && item.archive_description !== item.description_text\"><div sd-html-preview=\"item.archive_description\"></div></li></ul></div><div ng-if=\"tab === 'assignment'\" sd-assignment-preview data-item=\"item\" hide-avatar=\"true\"></div></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/metadata-words-list.html', "<div class=\"term-editor data visible\" ng-show=\"header\"><div sd-typeahead items=\"words\" term=\"selectedTerm\" search=\"search(term)\" select=\"select(item)\" data-disabled=\"disabled\" data-style=\"style\"><ul><li typeahead-item=\"t\" ng-repeat=\"t in words\">{{ :: t.name}}</li></ul></div></div><div class=\"terms terms-list\" ng-if=\"item[field].length\"><ul><li ng-if=\"!disabled\" ng-repeat=\"t in item[field] track by t\" ng-click=\"removeTerm(t)\">{{ t}}<i class=\"icon-close-small\"></i></li><li ng-if=\"disabled\" ng-repeat=\"t in item[field] track by t\">{{ t}}</li></ul></div>");
        $templateCache.put('scripts/apps/authoring/metadata/views/prefered-cv-items-config.html', "<div class=\"prefered-cv-items form__row\" ng-repeat=\"cv in cvs track by cv._id\"><label class=\"form-label\">{{ :: cv.display_name }}</label><div sd-meta-terms class=\"sd-line-input__select\" data-item=\"updates\" data-field=\"{{ cv._id }}\" data-list=\"cv.items\" data-unique=\"qcode\" data-header=\"true\" data-change=\"updateModel()\" data-reload-list=\"true\"></div><div ng-show=\"cvs.length === 0\" class=\"sd-alert sd-alert--hollow\"><p translate>There are no vocabularies configured.</p></div>");
        $templateCache.put('scripts/apps/authoring/multiedit/views/multiedit.html', "<div class=\"subnav\"><h3 class=\"page-nav-title\" translate>Multiedit</h3><button class=\"close-multiedit\" ng-click=\"closeMulti()\"><i class=\"icon-close-small\"></i></button></div><div class=\"multiedit-screen main-section\"><div class=\"boards-list\"><div ng-repeat=\"board in boards\" class=\"board\" style=\"width:{{ 100 / boards.length }}%\"><div class=\"navbtn dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-collapse\"></i></button><div class=\"dropdown__menu\"><ul class=\"dropdown__menu--multiedit\" sd-multiedit-inner-dropdown data-board=\"{{$index}}\"></ul><ul ng-if=\"boards.length > minBoards\"><li class=\"dropdown__menu-divider\"></li><li><button ng-click=\"closeBoard($index)\"><i class=\"icon-close-small\"></i> {{ 'Remove panel' | translate }}</button></li></ul></div></div><div sd-multiedit-article data-article=\"board.article\" data-focus=\"$first\" class=\"board-article\" ng-if=\"board.article\"></div></div></div><div class=\"boards-create\" ng-if=\"boards.length > 0\" sd-multiedit-float-menu><i class=\"icon-plus-small\"></i><div class=\"dropdown multiedit-float\"><ul class=\"dropdown__menu dropdown__menu--multiedit\" id=\"multiedit-float\" sd-multiedit-inner-dropdown data-board=\"{{boards.length}}\"></ul></div></div></div>");
        $templateCache.put('scripts/apps/authoring/multiedit/views/sd-multiedit-article.html', "<article class=\"main-article\" tabindex=\"0\" ng-class=\"{locked: isLocked}\"><form name=\"articleEdit\"><div class=\"editbar clearfix\"><button class=\"btn btn--primary pull-right\" type=\"button\" ng-hide=\"isPublished(item)\" ng-click=\"save(item, articleEdit)\" ng-disabled=\"articleEdit.$pristine && !item._autosave\" translate>Save</button> <button class=\"btn btn--light pull-right\" type=\"button\" ng-click=\"remove(item)\" translate>Remove Item</button></div><div><div class=\"state-label state-{{item.state}}\">{{item.state}}</div><fieldset ng-disabled=\"isPublished(item)\" sd-article-edit></fieldset></div></form></article>");
        $templateCache.put('scripts/apps/authoring/multiedit/views/sd-multiedit-dropdown.html', "<div class=\"dropdown__menu--multiedit\"><ul><li ng-repeat=\"item in items\"><button ng-click=\"toggle(item._id); $event.stopPropagation();\" ng-class=\"{disabled: item._id === current}\"><span ng-show=\"item.headline\">{{ item.headline }}</span> <span ng-show=\"!item.headline\">{{ :: 'Untitled' | translate }}</span> <i class=\"icon-ok\" ng-if=\"selected(item._id)\"></i></button></li><li ng-if=\"items.length === 0\"><button translate>NO SUGGESTIONS.</button></li></ul></div><div class=\"fieldset dropdown__menu-footer\"><button class=\"btn btn--primary\" ng-click=\"open(); $event.stopPropagation();\" translate>Ok</button> <button class=\"btn\" translate>Cancel</button></div>");
        $templateCache.put('scripts/apps/authoring/multiedit/views/sd-multiedit-inner-dropdown.html', "<li ng-repeat=\"item in items\" ng-if=\"items.length\"><button ng-click=\"open(item._id);\"><span ng-show=\"item.headline\">{{ item.headline }}</span> <span ng-show=\"!item.headline\">{{ :: 'Untitled' | translate }}</span></button></li><li ng-if=\"!items.length\" class=\"msg\"><button disabled translate>No items to add!</button></li>");
        $templateCache.put('scripts/apps/authoring/packages/views/packages-widget.html', "<div ng-controller=\"PackagesWidgetCtrl\"><div class=\"packages-content\"><ul><li ng-repeat=\"pitem in contentItems\" ng-if=\"pitem._id !== item._id\"><div class=\"package-preview\"><i class=\"filetype-icon-composite\"></i><div class=\"title\" ng-show=\"pitem.headline || pitem.slugline\"><a ng-click=\"openPackage(pitem)\" title=\"{{ pitem.headline || pitem.slugline}}\"><div ng-show=\"pitem.headline || pitem.slugline\">{{ pitem.headline || pitem.slugline | uppercase}}</div><div ng-hide=\"pitem.headline || pitem.slugline\" translate>Blank headline received</div></a></div></div></li></ul></div></div>");
        $templateCache.put('scripts/apps/authoring/suggest/SuggestView.html', "<div class=\"live-suggest\"><div ng-show=\"showItem === null\" class=\"item-list\"><div class=\"live-suggest__header subnav\"><h3 class=\"subnav__page-title\">Live Suggestions</h3><a class=\"close\" ng-click=\"ctrl.close()\"><i class=\"icon-close-small\"></i></a></div><div class=\"live-suggest__body\"><h6 class=\"no-suggestions\" ng-hide=\"items\">Suggestions will appear here once the article's body starts changing...</h6><ul sd-list-view class=\"list-view compact-view\" data-items=\"items\" ng-show=\"items\"><li class=\"media-box\" ng-click=\"ctrl.showItem(item)\"><div class=\"line item-info\"><i sd-filetype-icon data-item=\"item\"></i> <span class=\"keyword\">{{ item.slugline || '-' }}</span> <span class=\"word-count\"><b>{{ item.word_count || 0 }}</b> <span translate translate-n=\"item.word_count\" translate-plural=\"WORDS\">WORD</span></span><div class=\"item-info__right\"><label translate>Created</label>&nbsp; <span class=\"date\" sd-datetime data=\"item.firstcreated\"></span>&nbsp;<label translate>by</label>&nbsp;{{ctrl.displayName(item.original_creator)}}</div></div><div class=\"info\"><b>{{ item.headline }}</b> <span ng-show=\"item.duedate\"><i class=\"icon-time\"></i>{{item.duedate}} </span><span ng-show=\"item.tasks\"><i class=\"icon-tasks\"></i>{{item.tasks}} </span><span ng-show=\"item.attachments\"><i class=\"icon-attachment\"></i>{{item.attachments}} </span><span ng-show=\"item.links\"><i class=\"icon-link\"></i>{{item.links}} </span><span ng-show=\"item.comments\"><i class=\"icon-comment\"></i>{{item.comments}}</span><div sd-html-preview=\"item.body_html\"></div></div></li></ul></div></div><div ng-show=\"showItem !== null\" class=\"item-details\"><div class=\"live-suggest__header subnav\"><h3 class=\"subnav__page-title\" ng-click=\"ctrl.hideItem()\"><i class=\"backlink black\">Back</i></h3><a class=\"close\" ng-click=\"ngShow = false\"><i class=\"icon-close-small\"></i></a></div><div class=\"item-details__body\"><div class=\"line item-info\"><i sd-filetype-icon data-item=\"showItem\"></i> <span class=\"keyword\">{{ showItem.slugline || '-' }}</span> <span class=\"word-count\"><b>{{ showItem.word_count || 0 }}</b> <span translate translate-n=\"showItem.word_count\" translate-plural=\"WORDS\">WORD</span></span><div class=\"item-info__right\"><label translate>Created</label><span class=\"date\" sd-datetime data=\"showItem.firstcreated\"></span><label translate>by</label>{{ctrl.displayName(showItem.original_creator)}}</div></div><h3 class=\"headline\">{{ showItem.headline }}</h3><div class=\"abstract\" sd-html-preview=\"showItem.abstract\"></div><div class=\"body\" sd-html-preview=\"showItem.body_html\"></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/track-changes/views/inline-comments-widget.html', "<div class=\"widget\" ng-controller=\"InlineCommentsCtrl\"><div class=\"form__row\"><sd-check ng-model=\"resolvedFilter\" type=\"radio\" ng-value=\"UNRESOLVED\" label-position=\"inside\">{{ :: 'Unresolved' | translate }}</sd-check><sd-check ng-model=\"resolvedFilter\" type=\"radio\" ng-value=\"RESOLVED\" label-position=\"inside\">{{ :: 'Resolved' | translate }}</sd-check></div><ul ng-class=\"{ 'notification-list--empty' : items[resolvedFilter].length === 0 }\"><li ng-repeat=\"commentObj in items[resolvedFilter]\"><h4 class=\"label label--large\">{{commentObj.fieldName}}</h4><ul class=\"notification-list notification-list-fix white field\"><li ng-repeat=\"item in commentObj.comments\" class=\"item\"><figure class=\"avatar\"><img sd-user-avatar data-user=\"users[item.data.authorId]\"></figure><div class=\"content\"><div class=\"text\" sd-comment-text data-name=\"{{users[item.data.authorId].display_name || users[item.data.authorId].username}}\" data-text=\"{{item.data.msg}}\"></div><span class=\"date\" sd-absdate datetime=\"item.data.date\"></span></div><ul><li class=\"small\" ng-repeat=\"reply in item.data.replies\"><figure class=\"avatar\"><img sd-user-avatar data-user=\"users[reply.authorId]\"></figure><div class=\"content\"><div class=\"text\" sd-comment-text data-comment=\"comment\" data-name=\"{{users[reply.authorId].display_name || users[reply.authorId].username}}\" data-text=\"{{reply.msg}}\"></div><span class=\"date\" sd-absdate datetime=\"reply.date\"></span></div></li></ul><div class=\"commented-text\"><div translate>Selected text:</div><span class=\"text\" title=\"{{ item.data.commentedText }}\">\"{{ item.data.commentedText }}\"</span></div><div class=\"resolution\" ng-if=\"item.data.resolutionInfo\"><span>{{ :: 'Resolved by' | translate }} {{ users[item.data.resolutionInfo.resolverUserId].display_name || users[item.data.resolutionInfo.resolverUserId].username }} <span class=\"date\" sd-absdate datetime=\"item.data.resolutionInfo.date\"></span></span></div></li></ul></li><li class=\"no-comments\" ng-show=\"items[resolvedFilter].length === 0\"><div class=\"round-box\"><i class=\"big-icon--comments\"></i></div><h3 translate>No comments have been posted</h3></li></ul></div>");
        $templateCache.put('scripts/apps/authoring/track-changes/views/suggestions-widget.html', "<div class=\"widget\" ng-controller=\"SuggestionsCtrl\"><div class=\"notification-list white field\" ng-repeat=\"annotationObj in items\" class=\"item\"><h4 class=\"label label--large\">{{annotationObj.fieldName}}</h4><ul ng-class=\"{ 'notification-list--empty': items.length === 0 }\"><li class=\"item\" ng-repeat=\"item in annotationObj.suggestions\"><div class=\"accepted pull-right\"><span class=\"label label--success\" ng-show=\"item.resolutionInfo.accepted\" translate>Accepted</span> <span class=\"label label--alert\" ng-show=\"!item.resolutionInfo.accepted\" translate>Rejected</span></div><figure class=\"avatar\"><img sd-user-avatar data-user=\"users[item.suggestionInfo.author]\"></figure><div>{{users[item.suggestionInfo.author].display_name || users[item.suggestionInfo.author].username}}</div><div class=\"date\" sd-absdate datetime=\"item.suggestionInfo.date\"></div><div class=\"content\" ng-show=\"item.suggestionInfo.type!=='REPLACE_SUGGESTION'\"><div class=\"text\"><strong>{{getLocalizedTypeText(item.suggestionInfo.type, item.suggestionInfo.blockType)}}:</strong> <strong><em>\"{{item.suggestionText}}\"</em></strong> <strong ng-show=\"item.suggestionInfo.type=='ADD_LINK_SUGGESTION'\"><em>({{item.suggestionInfo.link.href}})</em></strong></div></div><div class=\"content\" ng-show=\"item.suggestionInfo.type==='REPLACE_SUGGESTION'\"><div class=\"text\"><strong translate>Replace: </strong><strong><em>\"{{item.oldText}}\"</em></strong> <strong translate>with: </strong><strong><em>\"{{item.suggestionText}}\"</em></strong></div></div><div class=\"resolution\"><span ng-show=\"item.resolutionInfo.accepted\" translate>Accepted by</span> <span ng-show=\"!item.resolutionInfo.accepted\" translate>Rejected by</span> <span>{{users[item.resolutionInfo.resolverUserId].display_name || users[item.resolutionInfo.resolverUserId].username}} <span class=\"date\" sd-absdate datetime=\"item.resolutionInfo.date\"></span></span></div></li><li class=\"no-suggestions\" ng-show=\"items.length === 0\"><div class=\"round-box\"><i class=\"big-icon--suggestion\"></i></div><h3 translate>No suggestions have been resolved</h3></li></ul></div></div>");
        $templateCache.put('scripts/apps/authoring/translations/views/translations-widget.html', "<translations-widget item=\"item\"></translations-widget>");
        $templateCache.put('scripts/apps/authoring/versioning/history/views/history.html', "<div class=\"article-versions\" ng-controller=\"HistoryWidgetCtrl\"><ul class=\"history-list\"><li class=\"item\" ng-repeat=\"historyItem in historyItems\"><div ng-if=\"historyItem.operation === 'create'\"><strong>{{ :: 'Created by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.desk\"><span translate>on</span> <span>{{:: historyItem.desk }} / {{ :: historyItem.stage }}</span></div></div><div ng-if=\"historyItem.operation === 'update'\"><strong ng-if=\"historyItem.update.operation === 'deschedule'\">{{ :: 'Descheduled by' | translate }}</strong> <strong ng-if=\"historyItem.update.operation !== 'deschedule'\">{{ :: 'Updated by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.fieldsUpdated\"><span translate>updated fields</span>:<span> {{ :: historyItem.fieldsUpdated }}</span></div></div><div ng-if=\"historyItem.operation === 'duplicated_from'\"><strong>{{ :: 'Duplicated by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.duplicate_id\"><span translate>from</span>:<a href=\"\" ng-click=\"open(historyItem.update.duplicate_id)\"> {{ :: historyItem.update.duplicate_id }}</a></div></div><div ng-if=\"historyItem.operation === 'translate'\"><strong>{{ :: 'Translated by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.duplicate_id\"><span translate>from</span>:<a href=\"\" ng-click=\"open(historyItem.update.duplicate_id)\"> {{ :: historyItem.update.duplicate_id }}</a></div></div><div ng-if=\"historyItem.operation === 'duplicate'\"><strong>{{ :: 'Duplicate created by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.duplicate_id\"><span translate>duplicate id</span>:<a href=\"\" ng-click=\"open(historyItem.update.duplicate_id)\"> {{:: historyItem.update.duplicate_id }}</a></div></div><div ng-if=\"historyItem.operation === 'spike'\"><strong>{{ :: 'Spiked by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.desk\"><span translate>from</span> <span>{{:: historyItem.desk }} / {{ :: historyItem.stage }}</span></div></div><div ng-if=\"['unspike', 'move', 'fetch'].includes(historyItem.operation)\"><strong ng-if=\"historyItem.operation === 'unspike'\">{{ :: 'Unspiked by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'move'\">{{ :: 'Moved by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'fetch'\">{{ :: 'Fetched by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.desk\"><span translate>to</span> <span>{{:: historyItem.desk }} / {{ :: historyItem.stage }}</span></div></div><div ng-if=\"historyItem.operation === 'mark'\"><strong>{{ :: 'Marked by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em><div ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></div><span class=\"more-description\" ng-if=\"historyItem.update.highlight_id\"><span translate>for highlight</span><span>: {{:: highlightsById[historyItem.update.highlight_id].name || historyItem.update.highlight_name }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.desk_id\"><span translate>for desk</span><span>: {{:: deskLookup[historyItem.update.desk_id].name }}</span></div></div><div ng-if=\"historyItem.operation === 'unmark'\"><strong>{{ :: 'Unmarked by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em><div ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></div><span class=\"more-description\" ng-if=\"historyItem.update.highlight_id\"><span translate>removed highlight</span><span>: {{:: highlightsById[historyItem.update.highlight_id].name || historyItem.update.highlight_name }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.desk_id\"><span translate>removed desk</span><span>: {{:: deskLookup[historyItem.update.desk_id].name }}</span></div></div><div ng-if=\"historyItem.operation === 'export_highlight'\"><strong>{{ :: 'Exported by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em><div ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></div><span class=\"more-description\" ng-if=\"historyItem.update.highlight_id\"><span class=\"more-description\" translate>from highlight</span><span>: {{:: highlightsById[historyItem.update.highlight_id].name || historyItem.update.highlight_name }}</span></span></div><div ng-if=\"historyItem.operation === 'create_highlight' && historyItem.update.highlight_id\"><span class=\"more-description\" translate>Created from highlight</span><span>: {{:: highlightsById[historyItem.update.highlight_id].name || historyItem.update.highlight_name }}</span></div><div ng-if=\"['link', 'take', 'reopen'].includes(historyItem.operation)\"><strong ng-if=\"historyItem.operation === 'link'\">{{ :: 'Linked by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'take'\">{{ :: 'Take created by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'reopen'\">{{ :: 'Reopened by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.rewrite_of\"><span translate>as rewrite of</span>:<a href=\"\" ng-click=\"open(historyItem.update.rewrite_of)\"> {{:: historyItem.update.rewrite_of }}</a></div><div class=\"more-description\" ng-if=\"historyItem.update.linked_to\"><span translate>linked to</span>:<a href=\"\" ng-click=\"open(historyItem.update.linked_to)\"> {{:: historyItem.update.linked_to }}</a></div></div><div ng-if=\"historyItem.operation === 'unlink'\"><strong>{{ :: 'Unlinked by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.hasOwnProperty('rewrite_of')\"><span translate>Rewrite link is removed</span></div><div class=\"more-description\" ng-if=\"historyItem.update.hasOwnProperty('rewritten_by')\"><span translate>Rewritten link is removed</span></div><div class=\"more-description\" ng-if=\"!historyItem.update || !historyItem.update.hasOwnProperty('rewrite_of') && !historyItem.update.hasOwnProperty('rewritten_by')\"><span translate>Take link is removed</span></div></div><div ng-if=\"historyItem.operation === 'rewrite'\"><strong>{{ :: 'Rewritten by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div class=\"more-description\" ng-if=\"historyItem.update.rewritten_by\"><span translate>rewrite id</span>:<a href=\"\" ng-click=\"open(historyItem.update.rewritten_by)\"> {{:: historyItem.update.rewritten_by }}</a></div></div><div ng-if=\"['publish', 'correct', 'kill', 'resend', 'takedown'].includes(historyItem.operation)\"><strong ng-if=\"historyItem.operation === 'publish' && historyItem.update.state === 'scheduled'\">{{ :: 'Scheduled by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'publish' && historyItem.update.state !== 'scheduled'\">{{ :: 'Published by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'correct'\">{{ :: 'Corrected by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'kill'\">{{ :: 'Killed by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'takedown'\">{{ :: 'Recalled by' | translate }}</strong> <strong ng-if=\"historyItem.operation === 'resend'\">{{ :: 'Resent by' | translate }}</strong> {{ :: historyItem.displayName }} <em><time sd-absdate datetime=\"historyItem._created\"></time></em> <span ng-if=\"historyItems[$index-1].version !== historyItem.version && historyItem.version !== 0\" class=\"version\"><span translate>version</span><span>: {{:: historyItem.version }}</span></span><div ng-if=\"['publish', 'correct', 'kill', 'takedown'].includes(historyItem.operation) && historyItem.update.state !== 'scheduled'\" sd-transmission-details data-item=\"historyItem\" data-type=\"item._type\" class=\"queued\"></div></div></li></ul></div>");
        $templateCache.put('scripts/apps/authoring/versioning/history/views/publish_queue.html', "<div><a ng-href=\"\" ng-if=\"!show_transmission_details\" ng-click=\"showOrHideTransmissionDetails()\"><i class=\"icon-plus-small true\"></i> {{ :: 'Show sent/queued items' | translate }} </a><a ng-href=\"\" ng-if=\"show_transmission_details\" ng-click=\"showOrHideTransmissionDetails()\"><i class=\"icon-minus-small true\"></i> {{ :: 'Hide sent/queued items' | translate }}</a><ul ng-if=\"show_transmission_details && queuedItems.length === 0\"><li class=\"alert-danger\"><div translate>Not been transmitted to any subscriber</div></li></ul><ul ng-if=\"show_transmission_details && queuedItems.length > 0\"><li ng-repeat=\"queuedItem in queuedItems track by queuedItem._id\" ng-click=\"showFormattedItem(queuedItem)\"><div ng-if=\"queuedItem.state !== 'error'\">{{ :: 'Sent/Queued as' | translate }} <b>{{ queuedItem.unique_name }}</b> {{ :: 'on' | translate }} {{ queuedItem.destination.name }} {{ :: 'at' | translate }} <em><time sd-absdate datetime=\"queuedItem.completed_at\"></time></em></div><div ng-if=\"queuedItem.state === 'error'\">{{ :: 'Error sending as' | translate }} <b>{{ queuedItem.unique_name }}</b> {{ :: 'on' | translate }} {{ queuedItem.destination.name }} {{ :: 'at' | translate }} <em><time sd-absdate datetime=\"queuedItem.completed_at\"></time></em></div></li></ul><div sd-modal data-model=\"transmitted_item\" class=\"modal--fill\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"hideFormattedItem()\"><i class=\"icon-close-small\"></i></a><h3 translate>Item sent to Subscriber</h3></div><div class=\"modal__body\">{{transmitted_item }}</div></div></div>");
        $templateCache.put('scripts/apps/authoring/versioning/versions/views/versions.html', "<div class=\"article-versions\" ng-controller=\"VersioningWidgetCtrl\"><ul class=\"versions-list card-list\"><li class=\"item\" ng-class=\"{selected: selected === version}\" ng-repeat=\"version in versions\" ng-click=\"openVersion(version)\" ng-disabled=\"dirty\"><div class=\"header\"><time sd-absdate title=\"{{ :: version._created | date:'medium' }}\" datetime=\"version._created\"></time> <span class=\"user\">{{ :: 'by' | translate }} {{ version.creator }}</span></div><h6 ng-class=\"{'no-title': !version.headline }\">{{ :: version.headline || ('Untitled' | translate) }}</h6><div class=\"desk-details\"><span ng-show=\"version.desk\">{{ :: 'desk:' | translate }} {{version.desk}}</span> <span class=\"pull-right\" ng-show=\"version.stage\">{{ :: 'stage:' | translate }} {{version.stage}}</span></div><div class=\"footer\"><em>{{ :: 'version' | translate }}: {{ version._current_version }}</em><div class=\"state-label state-{{ :: version.state}}\">{{ :: version.state | translate }}</div><button class=\"btn btn--light btn--mini pull-right\" ng-show=\"canRevert && !$first && !dirty\" ng-click=\"revert(version)\" translate>revert</button></div></li></ul></div>");
        $templateCache.put('scripts/apps/authoring/versioning/views/versioning.html', "<ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'versions' || !tab}\"><button ng-click=\"tab = 'versions'\" translate>Versions</button></li><li ng-class=\"{active: tab === 'history'}\"><button ng-click=\"tab = 'history'\" translate>Item history</button></li></ul><div class=\"content\"><div ng-if=\"tab === 'versions' || !tab\" sd-versioning-version></div><div ng-if=\"tab === 'history'\" sd-versioning-history data-item=\"item\"></div></div>");
        $templateCache.put('scripts/apps/authoring/views/article-edit.html', "<div class=\"field\" sd-width=\"{{editor.headline.sdWidth|| 'full'}}\" ng-if=\"schema.headline && !(features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.headline.order}}\" sd-validation-error=\"error.headline\" data-required=\"schema.headline.required\"><label class=\"field__label\">{{label('headline')}}</label><span ng-if=\"schema.headline.maxlength\" sd-character-count data-item=\"item.headline\" data-html=\"true\" data-limit=\"schema.headline.maxlength\"></span><div id=\"title\" class=\"headline\" sd-text-editor data-config=\"{toolbar: false, imageDragging: false, disableReturn: true, disableEditing: isPublished(item), tabindex: editor.headline.order, paste: {cleanPastedHTML: editor.headline.cleanPastedHTML}}\" data-language=\"item.language\" ng-model=\"item.headline\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" ng-trim=\"false\"></div><div class=\"headline\" ng-if=\"!_editable\" sd-html-preview=\"item.headline\"></div></div><div class=\"field\" sd-width=\"{{editor.headline.sdWidth|| 'full'}}\" ng-if=\"schema.headline && (features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.headline.order}}\" sd-validation-error=\"error.headline\" data-required=\"schema.headline.required\"><label class=\"field__label\">{{label('headline')}}</label><span ng-if=\"schema.headline.maxlength\" sd-character-count data-item=\"item.headline\" data-html=\"true\" data-limit=\"schema.headline.maxlength\"></span><div id=\"title\" class=\"headline\" sd-editor3 data-path-to-value=\"'headline'\" data-single-line=\"true\" data-bind-to-value=\"compareView\" data-scroll-container=\".page-content-container\" data-language=\"item.language\" data-value=\"item.headline\" data-on-change=\"autosave(item)\" data-read-only=\"!_editable\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor.headline.order\"></div></div><div class=\"field\" ng-if=\"schema.sms && item._type !== 'archived' && !isMediaType\" sd-width=\"{{editor.sms.sdWidth|| 'full'}}\" order=\"{{editor.sms.order}}\" sd-validation-error=\"error.sms\" data-required=\"schema.sms.required\"><label class=\"field__label\" ng-if=\"_editable\">{{label('sms')}}</label><div ng-if=\"_editable\"><span ng-if=\"_editable\" sd-switch ng-model=\"item.flags.marked_for_sms\" class=\"sms-switch\" tabindex=\"{{editor.sms.order}}\" ng-change=\"toggleSMS()\"></span></div><div ng-if=\"item.flags.marked_for_sms\" style=\"margin-top: 27px\"><span sd-character-count data-item=\"item.sms_message\" data-html=\"true\" data-limit=\"160\"></span><label class=\"field__label\">{{label('sms_message')}}</label><input type=\"text\" sd-remove-tags class=\"byline\" id=\"sms_message\" ng-model=\"item.sms_message\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" placeholder=\"Add sms message here\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{editor.sms.order}}\"><div ng-if=\"!_editable\">{{item.sms_message}}</div></div></div><div ng-if=\"schema.feature_image\" class=\"field\" sd-width=\"{{editor.feature_image.sdWidth|| 'full'}}\" sd-validation-error=\"error.feature_image\" order=\"{{editor.feature_image.order}}\" data-required=\"schema.feature_image.required\"><label class=\"field__label\">{{label('feature_image')}}</label><div sd-item-association data-item=\"item\" data-rel=\"'featureimage'\" data-editable=\"_editable\" data-onchange=\"autosave(item)\" data-save=\"save()\" data-show-title=\"editor.feature_image.imageTitle\" data-tabindex=\"editor.feature_image.order\"></div></div><div ng-if=\"schema.feature_media\" class=\"field\" sd-width=\"{{editor.feature_media.sdWidth|| 'full'}}\" sd-validation-error=\"error.feature_media\" order=\"{{editor.feature_media.order}}\" data-required=\"schema.feature_media.required\"><label class=\"field__label\">{{label('feature_media')}}</label><div sd-item-association ng-class=\"{'item-association--marg-b10': editor.feature_media.showCrops}\" data-allow-picture=\"true\" data-allow-video=\"true\" data-allow-audio=\"true\" data-item=\"item\" data-rel=\"'featuremedia'\" data-editable=\"_editable\" data-onchange=\"autosave(item)\" data-save=\"save()\" data-show-title=\"editor.feature_media.imageTitle\" data-tabindex=\"editor.feature_media.order\"></div><div sd-item-crops data-item=\"item.associations['featuremedia']\" ng-if=\"editor.feature_media.showCrops && features.editFeaturedImage &&\n" +
            "         (item.associations['featuremedia'].type == 'picture' ||\n" +
            "         item.associations['featuremedia'].type == 'graphic')\"></div></div><div class=\"field abstract\" sd-width=\"{{editor.abstract.sdWidth|| 'full'}}\" ng-if=\"schema.abstract && !(features.onlyEditor3 || editor.body_html.editor3) && !isMediaType\" order=\"{{editor.abstract.order}}\" sd-validation-error=\"error.abstract\" data-required=\"schema.abstract.required\"><label class=\"field__label\">{{label('abstract')}}</label><span sd-character-count data-item=\"item.abstract\" data-html=\"true\" data-limit=\"schema.abstract.maxlength\"></span> <span sd-word-count data-item=\"item.abstract\" data-html=\"true\"></span><div id=\"abstract\" class=\"abstract\" sd-text-editor data-config=\"{disableToolbar: true, imageDragging: false, disableEditing: isPublished(item), tabindex: editor.abstract.order, paste: {cleanPastedHTML: editor.abstract.cleanPastedHTML}}\" data-editorformat=\"editor.abstract.formatOptions\" data-language=\"item.language\" ng-model=\"item.abstract\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" ng-trim=\"false\"></div><div class=\"abstract\" ng-if=\"!_editable\" sd-html-preview=\"item.abstract\"></div></div><div class=\"field abstract\" sd-width=\"{{editor.abstract.sdWidth|| 'full'}}\" ng-if=\"schema.abstract && (features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.abstract.order}}\" sd-validation-error=\"error.abstract\" data-required=\"schema.abstract.required\"><label class=\"field__label\">{{label('abstract')}}</label><span sd-character-count data-item=\"item.abstract\" data-html=\"true\" data-limit=\"schema.abstract.maxlength\"></span> <span sd-word-count data-item=\"item.abstract\" data-html=\"true\"></span><div id=\"abstract\" class=\"abstract\" sd-editor3 data-path-to-value=\"'abstract'\" data-editor-format=\"editor.abstract.formatOptions\" data-scroll-container=\".page-content-container\" data-bind-to-value=\"compareView\" data-language=\"item.language\" data-value=\"item.abstract\" data-on-change=\"autosave(item)\" data-read-only=\"!_editable\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor.abstract.order\"></div></div><div class=\"field\" ng-if=\"item._type !== 'archived' && schema.byline\" sd-width=\"{{editor.byline.sdWidth|| 'full'}}\" order=\"{{editor.byline.order}}\" sd-validation-error=\"error.byline\" data-required=\"schema.byline.required\"><label class=\"field__label\">{{label('byline')}}</label><input type=\"text\" sd-remove-tags class=\"byline\" id=\"byline\" ng-model=\"item.byline\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{editor.byline.order}}\"><div class=\"byline\" ng-if=\"!_editable\" sd-html-preview=\"item.byline\"></div></div><!--This article-edit view is used by templates as well.\n" +
            "    ng-if is used to hide dateline for the template create/edit screen.--><div class=\"field\" ng-show=\"item._type !== 'archived' && (!template || template.template_type !== 'kill') && schema.dateline && !isMediaType\" order=\"{{editor.dateline.order}}\" sd-validation-error=\"error.dateline\" data-required=\"schema.dateline.required\" sd-width=\"{{editor.dateline.sdWidth|| 'full'}}\"><label class=\"field__label\">{{label('dateline')}}</label><div class=\"dateline\"><div sd-meta-locators class=\"dateline-city\" data-tabindex=\"editor.dateline.order\" ng-disabled=\"!_editable\" data-item=\"item\" data-fieldprefix=\"dateline\" data-field=\"located\" placeholder=\"Add location\" data-postprocessing=\"updateDateline(item, city)\" sd-focus-element data-element=\"input\" data-append-element=\".field\" data-append-class=\"active\" data-keepinput=\"true\" tabindex=\"{{editor.dateline.order}}\"></div><div ng-show=\"!editor.dateline.hideDate\" class=\"dateline-date\"><select class=\"field__select\" id=\"datelineMonth\" tabindex=\"{{editor.dateline.order}}\" ng-options=\"monthName | translate for (monthName, monthValue) in monthNames\" ng-disabled=\"!item.dateline.located || !_editable\" ng-change=\"resetNumberOfDays(true, dateline.month)\" placeholder=\"Choose month\" ng-model=\"dateline.month\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{editor.dateline.order}}\"><option value=\"\"></option></select><select class=\"field__select\" id=\"datelineDay\" tabindex=\"{{editor.dateline.order}}\" ng-options=\"day for day in daysInMonth\" ng-disabled=\"!item.dateline.located || !_editable\" ng-change=\"modifyDatelineDate(dateline.day)\" placeholder=\"Choose day\" ng-model=\"dateline.day\" sd-focus-element tabindex=\"{{editor.dateline.order}}\" data-append-element=\".field\" data-append-class=\"active\"><option value=\"\"></option></select></div></div></div><div class=\"field body\" ng-if=\"!isMediaType && schema.body_html && !(features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.body_html.order}}\" sd-validation-error=\"error.body_html\" data-required=\"schema.body_html.required\" sd-width=\"{{editor.body_html.sdWidth|| 'full'}}\"><label class=\"field__label\">{{label('body_html')}}</label><span sd-reading-time data-item=\"item.body_html\" data-html=\"true\" data-language=\"item.language\"></span> <span sd-character-count data-item=\"item.body_html\" data-html=\"true\"></span> <span sd-word-count data-item=\"item.body_html\" data-html=\"true\"></span><div id=\"bodyhtml\" sd-text-editor data-config=\"{disableEditing: isPublished(item), multiBlockEdition: true, tabindex: editor.body_html.order, showTitle: editor.body_html.imageTitle, paste: {cleanPastedHTML: editor.body_html.cleanPastedHTML}}\" data-editorformat=\"editor.body_html.formatOptions\" ng-model=\"item.body_html\" ng-if=\"_editable\" ng-change=\"autosave(item)\" ng-model-options=\"{debounce: 100}\" data-associations=\"item.associations\" data-language=\"item.language\" data-type=\"item.type\" class=\"body-text\"></div><div class=\"text-editor\" sd-html-preview=\"item.body_html\" ng-if=\"!_editable\"></div></div><div contenteditable=\"true\" id=\"editor3Tansa\" tansa-proofing=\"true\" style=\"position: fixed; top: -1000px; left: -1000px; height: 150px; width: 500px; display: block\"></div><div class=\"field body\" ng-if=\"!isMediaType && schema.body_html && (features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.body_html.order}}\" sd-validation-error=\"error.body_html\" data-required=\"schema.body_html.required\" sd-width=\"{{editor.body_html.sdWidth|| 'full'}}\" tansa-proofing=\"false\"><label class=\"field__label\">{{label('body_html')}}</label><span sd-reading-time data-item=\"item.body_html\" data-html=\"true\" data-language=\"item.language\"></span> <span sd-character-count data-item=\"item.body_html\" data-html=\"true\"></span> <span sd-word-count data-item=\"item.body_html\" data-html=\"true\"></span><div id=\"bodyhtml\" sd-editor3 data-path-to-value=\"'body_html'\" data-find-replace-target data-bind-to-value=\"compareView\" data-scroll-container=\".page-content-container\" data-editor-format=\"editor.body_html.formatOptions\" data-value=\"item.body_html\" data-read-only=\"!_editable\" data-on-change=\"autosave(item, 0)\" data-debounce=\"500\" data-language=\"item.language\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-show-title=\"editor.body_html.imageTitle\" data-tabindex=\"editor.body_html.order\"></div></div><div class=\"field media-item\" ng-if=\"isMediaType\" ng-class=\"{'media-item--loading': mediaLoading}\" order=\"{{editor.media.order}}\" sd-validation-error=\"error.media\" data-required=\"schema.media.required\" tabindex=\"{{editor.media.order}}\" sd-width=\"{{editor.media.sdWidth|| 'full'}}\"><div ng-if=\"item.type == 'picture' || item.type == 'graphic'\" class=\"full-preview\" sd-ratio-calc><div class=\"media-item__item\"><div class=\"item-association item-association--preview\"><div class=\"item-association__image-container\" sd-item-rendition data-item=\"item\" data-rendition=\"baseImage\"></div><div class=\"item-association__image-overlay\" ng-if=\"_editable\"><div class=\"item-association__icons-block\"><a class=\"item-association__image-action\" sd-tooltip=\"Edit metadata\" ng-click=\"editMedia('view')\"><i class=\"icon-pencil\"></i></a> <a class=\"item-association__image-action\" sd-tooltip=\"Edit image\" ng-click=\"editMedia('image-edit')\"><i class=\"icon-switches\"></i></a> <a class=\"item-association__image-action\" sd-tooltip=\"Edit crops\" ng-click=\"editMedia('crop')\" ng-if=\"metadata.crop_sizes\"><i class=\"icon-crop\"></i></a></div></div></div><span class=\"media-item__item-label\" translate>Original ({{item.renditions.original.width}} x {{item.renditions.original.height}} px)</span><div sd-media-metadata-view class=\"media-container__metadata media-container__metadata--image\" data-item=\"item\"></div></div><div sd-item-crops data-item=\"item\"></div></div><div ng-if=\"item.type == 'audio'\"><div class=\"media-container\"><audio controls sd-sources data-renditions=\"item.renditions\"></audio><div sd-media-metadata-view class=\"media-container__metadata\" data-item=\"item\"></div><div class=\"media-container__action-bar\" ng-if=\"_editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"editMedia()\"><span translate>Edit metadata</span></a></div></div></div><div ng-if=\"item.type == 'video'\"><div class=\"media-container\"><video controls sd-sources data-renditions=\"item.renditions\"></video><div sd-media-metadata-view class=\"media-container__metadata\" data-item=\"item\"></div><div class=\"media-container__action-bar\" ng-if=\"_editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"editMedia()\"><span translate>Edit metadata</span></a></div></div></div></div><div ng-if=\"isMediaType && !(features.onlyEditor3 || editor.body_html.editor3)\" class=\"field abstract\" order=\"{{editor.media_description.order}}\" sd-validation-error=\"error.description_text\" sd-width=\"{{editor.media_description.sdWidth|| 'full'}}\" data-required=\"schema.media_description.required\"><label class=\"field__label\" translate>Caption</label><span ng-if=\"validator.description_text.maxlength\" sd-character-count data-item=\"item.description_text\" data-html=\"true\" data-limit=\"validator.description_text.maxlength\"></span><div id=\"title\" class=\"abstract\" sd-text-editor data-config=\"{disableToolbar: true, disableReturn: true, disableEditing: isPublished(item), tabindex: editor.description_text.order, paste: {cleanPastedHTML: editor.description_text.cleanPastedHTML}}\" data-editorformat=\"editor.description_text.formatOptions\" data-language=\"item.language\" ng-model=\"item.description_text\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" ng-trim=\"false\"></div><div class=\"abstract\" ng-if=\"!_editable\">{{item.description_text}}</div></div><div ng-if=\"isMediaType && (features.onlyEditor3 || editor.body_html.editor3)\" class=\"field abstract\" order=\"{{editor.media_description.order}}\" sd-validation-error=\"error.description_text\" sd-width=\"{{editor.media_description.sdWidth|| 'full'}}\" data-required=\"schema.media_description.required\"><label class=\"field__label\" translate>Caption</label><span ng-if=\"validator.description_text.maxlength\" sd-character-count data-item=\"item.description_text\" data-html=\"true\" data-limit=\"validator.description_text.maxlength\"></span><div id=\"title\" class=\"abstract\" sd-editor3 data-path-to-value=\"'description_text'\" data-editor-format=\"editor.description_text.formatOptions\" data-scroll-container=\".page-content-container\" data-bind-to-value=\"compareView\" data-value=\"item.description_text\" data-read-only=\"!_editable\" data-on-change=\"autosave(item)\" data-language=\"item.language\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor.media_description.order\"></div></div><div class=\"field\" ng-if=\"schema.footer && metadata.footers && item._type !== 'archived' && item.type !== 'composite' && !isMediaType\" sd-validation-error=\"error.body_footer_value\" data-required=\"schema.footer.required\" order=\"{{editor.footer.order}}\" sd-width=\"{{editor.media_description.sdWidth|| 'full'}}\"><label class=\"field__label\" translate>Helplines/Contact Information</label><select class=\"field__select\" id=\"helplines\" ng-model=\"extra.body_footer_value\" ng-disabled=\"!_editable\" tabindex=\"{{editor.footer.order}}\" ng-options=\"f.name for f in metadata.footers track by f.name\" ng-change=\"addHelplineToFooter()\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{editor.footer.order}}\"><option value=\"\"></option></select></div><div class=\"field\" ng-if=\"schema.body_footer && !(features.onlyEditor3 || editor.body_html.editor3) && !isMediaType\" order=\"{{editor.body_footer.order}}\" sd-validation-error=\"error.body_footer\" data-required=\"schema.body_footer.required\" sd-width=\"{{editor.body_footer.sdWidth|| 'full'}}\"><label class=\"field__label\">{{label('body_footer')}}</label><div id=\"body_footer\" class=\"body\" sd-text-editor data-config=\"{disableToolbar: true, disableEditing: isPublished(item), tabindex: editor.body_footer.order, paste: {cleanPastedHTML: editor.body_footer.cleanPastedHTML}}\" data-language=\"item.language\" ng-model=\"item.body_footer\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" ng-trim=\"false\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\"></div><div id=\"body_footer_preview\" class=\"abstract\" ng-if=\"!_editable\" sd-html-preview=\"item.body_footer\"></div></div><div class=\"field\" ng-if=\"schema.body_footer && (features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.body_footer.order}}\" sd-validation-error=\"error.body_footer\" data-required=\"schema.body_footer.required\" sd-width=\"{{editor.body_footer.sdWidth|| 'full'}}\"><label class=\"field__label\">{{label('body_footer')}}</label><div id=\"body_footer\" class=\"body\" sd-editor3 data-path-to-value=\"'body_footer'\" data-bind-to-value=\"compareView\" data-editor-format=\"editor.body_footer.formatOptions\" data-scroll-container=\".page-content-container\" data-value=\"item.body_footer\" data-read-only=\"!_editable\" data-on-change=\"autosave(item)\" data-language=\"item.language\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor.body_footer.order\"></div></div><div class=\"composite-preview\" ng-if=\"item.type === 'composite'\"><div sd-package-items-edit ng-model=\"item.groups\" ng-if=\"_editable\"></div><div sd-package data-item=\"item\" class=\"composite-preview\" ng-if=\"!_editable\"></div></div><div class=\"field pull-left\" ng-if=\"schema.sign_off && !isMediaType\" order=\"{{editor.sign_off.order}}\" sd-validation-error=\"error.sign_off\" data-required=\"schema.sign_off.required\" sd-width=\"{{editor.sign_off.sdWidth|| 'full'}}\"><label class=\"field__label\">{{label('sign_off')}}</label><button id=\"sign-off-unlock\" class=\"icn-btn btn-signOff\" ng-click=\"changeSignOffEdit()\" tabindex=\"{{editor.sign_off.order}}\" title=\"Unlock edit Sign-Off\" ng-if=\"_editable\"><i class=\"icon-lock\" ng-hide=\"editSignOff\"></i> <i class=\"icon-unlocked\" ng-show=\"editSignOff\"></i></button><div ng-hide=\"editSignOff\" class=\"text-field__non-editable\" id=\"sign-off\">{{item.sign_off}}</div><input type=\"text\" sd-remove-tags class=\"byline\" id=\"sign_off\" ng-model=\"item.sign_off\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable && editSignOff\" placeholder=\"Sign off\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{editor.sign_off.order}}\"><div ng-if=\"canListEditSignOff && _editable\" ng-show=\"editSignOff\" sd-user-select-list data-tabindex=\"editor.sign_off.order\" data-onchoose=\"modifySignOff(user)\" data-onsearch=\"searchSignOff(search)\" data-display-user=\"{{ getSignOffMapping()}}\"></div></div><div class=\"field\" ng-if=\"schema.usageterms\" sd-width=\"{{editor.usageterms.sdWidth || 'full'}}\" order=\"{{editor.usageterms.order}}\" sd-validation-error=\"error.usageterms\" data-required=\"schema.usageterms.required\"><label class=\"field__label\">{{label('usageterms')}}</label><input type=\"text\" sd-remove-tags class=\"usageterms\" id=\"usageterms\" ng-model=\"item.usageterms\" ng-model-options=\"{debounce: 100}\" ng-change=\"autosave(item)\" ng-if=\"_editable\" sd-focus-element data-append-class=\"active\" tabindex=\"{{editor.usageterms.order}}\"><div class=\"usageterms\" ng-if=\"!_editable\" sd-html-preview=\"item.usageterms\"></div></div><!-- custom text editor fields --><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'text' && editor[field._id].section !== 'header'\" sd-width=\"{{ editor[field._id].sdWidth || 'full' }}\" data-required=\"schema[field._id].required\" order=\"{{ editor[field._id].order }}\" sd-validation-error=\"error[field._id.toLowerCase()]\"><label class=\"field__label\">{{field.display_name}}</label><span ng-if=\"schema[field._id].maxlength || schema[field._id].minlength\" sd-character-count data-item=\"item.extra[field._id]\" data-html=\"true\" data-limit=\"schema[field._id].maxlength\"></span><div sd-editor3 data-path-to-value=\"'extra' + FIELD_KEY_SEPARATOR + field._id\" data-single-line=\"field.field_options.single\" data-value=\"item.extra[field._id]\" data-bind-to-value=\"compareView\" data-scroll-container=\".page-content-container\" data-language=\"item.language\" data-on-change=\"autosave(item)\" data-read-only=\"!_editable\" data-disable-spellchecker=\"useTansaProofing()\" data-editor-format=\"editor[field._id].formatOptions\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor[field._id].order\"></div><div class=\"sd-editor__info-text\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div><!-- custom date editor fields --><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'date' && editor[field._id].section !== 'header'\" sd-width=\"{{ editor[field._id].sdWidth || 'full' }}\" data-required=\"schema[field._id].required\" order=\"{{ editor[field._id].order }}\" sd-validation-error=\"error[field._id.toLowerCase()]\"><label class=\"field__label\">{{field.display_name}}</label><div sd-datepicker ng-disabled=\"!_editable\" data-tabindex=\"editor[field._id].order\" ng-model=\"item.extra[field._id]\" data-format=\"YYYY-MM-DDT00:00:00+0000\" data-on-change=\"autosave(item)\" shortcuts=\"field.date_shortcuts\"></div><div class=\"sd-editor__info-text\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'embed'\" sd-width=\"{{ editor[field._id].sdWidth || 'full' }}\" order=\"{{ editor[field._id].order }}\" sd-validation-error=\"error[field._id.toLowerCase()]\" data-required=\"schema[field._id].required\"><label class=\"field__label\" translate>{{field.display_name}}</label><span><button ng-disabled=\"!_editable\" id=\"clear-embed-btn\" type=\"button\" class=\"btn btn--small pull-right\" ng-click=\"clearEmbed(field._id)\" ng-show=\"item.extra[field._id].embed\" translate>Clear Embed</button> <button ng-disabled=\"!_editable\" type=\"button\" class=\"btn btn--small pull-right\" ng-click=\"processEmbed(field._id)\" ng-show=\"isURL(item.extra[field._id].embed)\" translate>Generate From URL</button> <button id=\"preview-embed-btn\" type=\"button\" class=\"btn btn--small pull-right\" ng-click=\"previewEmbed(field._id)\" ng-show=\"item.extra[field._id].embed && isValidEmbed[field._id] && !isPreviewOn(field._id)\" translate>Preview</button> <button id=\"hide-preview-embed-btn\" type=\"button\" class=\"btn btn--small pull-right\" ng-click=\"hideEmbedPreview(field._id)\" ng-show=\"isPreviewOn(field._id)\" translate>Hide Preview</button></span><textarea id=\"embed-field-{{ field._id }}\" type=\"text\" class=\"sd-editor__default-input sd-editor__default-input--embed\" ng-change=\"validateEmbed(field._id)\" ng-model=\"item.extra[field._id].embed\" ng-disabled=\"!_editable\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" sd-auto-height sd-validation-error=\"error.extra[field._id].embed\" tabindex=\"{{editor[field._id].order}}\"></textarea><input type=\"text\" class=\"sd-line-input__input\" style=\"margin-bottom: 6px\" ng-model=\"item.extra[field._id].description\" ng-disabled=\"!_editable\" sd-remove-tags ng-change=\"autosave(item)\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" placeholder=\"{{ 'Description' | translate }}\" tabindex=\"{{editor[field._id].order}}\"><div id=\"embed-preview-{{ field._id }}\" ng-show=\"embedPreviews[field._id]\"></div><div class=\"sd-editor__info-text\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'media'\" sd-width=\"{{editor[field._id].sdWidth || 'full'}}\" sd-validation-error=\"error[field._id.toLowerCase()]\" order=\"{{editor[field._id].order}}\" data-required=\"schema[field._id].required\"><label class=\"field__label\" translate>{{field.display_name}}</label><div sd-item-carousel data-item=\"item\" data-field=\"field\" data-items=\"mediaFieldVersions[field._id]\" data-editable=\"_editable\" data-onchange=\"autosave(item, 0)\" data-save=\"save()\" data-allow-picture=\"!!field.field_options.allowed_types.picture\" data-allow-video=\"!!field.field_options.allowed_types.video\" data-allow-audio=\"!!field.field_options.allowed_types.audio\" data-max-uploads=\"maxUploads(field.field_options)\" data-tabindex=\"editor[field._id].order\"></div><div class=\"sd-editor__info-text\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === mediaTypes.RELATED_CONTENT.id\" sd-width=\"{{editor[field._id].sdWidth || 'full'}}\" sd-validation-error=\"error[field._id.toLowerCase()]\" order=\"{{editor[field._id].order}}\" data-required=\"schema[field._id].required\"><label class=\"field__label\" translate>{{field.display_name}}</label><div sd-related_items data-item=\"item\" data-field=\"field\" data-editable=\"_editable\" data-onchange=\"autosave(item, 0)\"></div><div class=\"sd-editor__info-text\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div><!-- Custom Url fields --><div class=\"field\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'urls'\" sd-width=\"{{editor[field._id].sdWidth || 'full'}}\" sd-validation-error=\"error[field._id.toLowerCase()]\" order=\"{{editor[field._id].order}}\" data-required=\"schema[field._id].required\"><sd-article-url-fields editable=\"_editable\" label=\"field.display_name\" helper-text=\"helper_text[field._id]\" field-id=\"field._id\" urls=\"item.extra[field._id]\" on-change=\"handleUrlsChange\"></sd-article-url-fields></div><div class=\"field\" ng-if=\"schema.attachments && editor.attachments\" sd-width=\"{{ editor.attachments.sdWidth || 'full'}}\" sd-validation-error=\"error.attachments\" order=\"{{ editor.attachments.order }}\" data-required=\"schema.attachments.required\"><label class=\"field__label\" translate>{{ :: 'Attachments' | translate }}</label><div sd-attachments-editor></div></div><!-- Slugline --><div class=\"field\" sd-validation-error=\"error.slugline\" data-required=\"schema.slugline.required\" ng-if=\"schema.slugline && editor['slugline'].section === 'content' && !(features.onlyEditor3 || editor.body_html.editor3)\" sd-width=\"{{editor.slugline.sdWidth}}\" order=\"{{editor.slugline.order}}\"><label class=\"field__label\">{{label('slugline')}}</label><span ng-if=\"schema.slugline.maxlength\" sd-character-count data-item=\"item.slugline\" data-html=\"true\" data-limit=\"schema.slugline.maxlength\"></span> <input type=\"text\" class=\"slugline\" id=\"slugline\" data-language=\"item.language\" ng-model=\"item.slugline\" ng-model-options=\"{debounce: 500}\" ng-change=\"autosave(item)\" ng-disabled=\"!_editable\" ng-trim=\"false\" tabindex=\"{{editor.slugline.order}}\"></div><div class=\"field\" sd-width=\"{{editor.slugline.sdWidth|| 'full'}}\" ng-if=\"schema.slugline && editor['slugline'].section === 'content' && (features.onlyEditor3 || editor.body_html.editor3)\" order=\"{{editor.slugline.order}}\" sd-validation-error=\"error.slugline\" data-required=\"schema.slugline.required\"><label class=\"field__label\">{{label('slugline')}}</label><span ng-if=\"schema.slugline.maxlength\" sd-character-count data-item=\"item.slugline\" data-html=\"true\" data-limit=\"schema.slugline.maxlength\"></span><div id=\"title\" class=\"slugline\" sd-editor3 data-path-to-value=\"'slugline'\" data-single-line=\"true\" data-bind-to-value=\"compareView\" data-scroll-container=\".page-content-container\" data-language=\"item.language\" data-value=\"item.slugline\" data-on-change=\"autosave(item)\" data-read-only=\"!_editable\" data-disable-spellchecker=\"useTansaProofing()\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor.slugline.order\"></div></div>");
        $templateCache.put('scripts/apps/authoring/views/authoring-container.html', "<div class=\"authoring-embedded\" ng-class=\"authoring.state\"><sd-suggest ng-show=\"authoring.showingSuggestions\"></sd-suggest><div class=\"embedded-auth-view\" ng-if=\"authoring.item\"><div sd-authoring-embedded data-item=\"authoring.item\" data-action=\"authoring.action\"></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/authoring-header.html', "<div class=\"authoring-header\" ng-class=\"{active: !isCollapsed}\"><div class=\"authoring-header__holder\" ng-controller=\"MetadataWidgetCtrl\" ng-if=\"loaded\"><div class=\"authoring-header__general-info\"><div><i class=\"filetype-icon-{{ :: item.type}}\" title=\"{{'Article Type'| translate }}: {{ item.type}}\"></i></div><div ng-if=\"item.profile && !change_profile\"><span class=\"authoring-header__label\" translate>PROFILE</span><div class=\"authoring-header__value\" sd-item-profile data-profile=\"item.profile\"></div></div><div ng-if=\"change_profile && content_types.length\"><span class=\"authoring-header__label\" translate>PROFILE</span><div class=\"authoring-header__value\"><select id=\"item-profile\" ng-model=\"item.profile\" ng-change=\"changeProfile(item)\" style=\"padding: 0px; height: 16px; font-size: 11px\" ng-options=\"type._id as type.label for type in desk_content_types\"></select></div></div><div ng-if=\"item.type === 'text'\"><span class=\"authoring-header__value\"><strong sd-word-count data-item=\"item.body_html\" data-html=\"true\" data-count-only=\"true\"></strong> </span><span class=\"authoring-header__label\" translate translate-n=\"item.word_count\" translate-plural=\"WORDS\">WORD</span></div><div ng-if=\"item.signal\"><span class=\"signal\">{{ item.signal}}</span></div><div><span class=\"authoring-header__label\" translate>SOURCE</span><div class=\"authoring-header__value\" id=\"item-source\">{{ item.source}}</div></div><div ng-if=\"relatedItems._items.length > 0\"><span class=\"authoring-header__label\" translate>RELATED</span> <a href=\"\" class=\"authoring-header__value\" ng-click=\"activateWidget()\">{{relatedItems._items.length}}</a></div><div id=\"item-correction\" ng-if=\"item.correction_sequence\"><span class=\"authoring-header__label\" translate>UPDATE</span><div class=\"authoring-header__value\">{{item.correction_sequence}}</div></div><div ng-if=\"missing_link || item.flags.marked_for_legal || item.flags.marked_for_sms || item.flags.marked_for_not_publication || item.rewritten_by\"><span class=\"state-label missing-link\" ng-if=\"missing_link\" translate>Missing Link</span> <span class=\"state-label legal\" ng-if=\"item.flags.marked_for_legal\" translate>Legal</span> <span class=\"state-label sms\" ng-if=\"item.flags.marked_for_sms\" translate>Sms</span> <span class=\"state-label not-for-publication\" ng-if=\"item.flags.marked_for_not_publication\" translate>Not For Publication</span> <span class=\"state-label updated\" ng-if=\"item.rewritten_by\" translate>Updated</span></div><div ng-if=\"item.broadcast.master_id\"><span class=\"authoring-header__label text-red\" ng-class=\"{'broadcast-status': item.broadcast.status !== ''}\" title=\"{{item.broadcast.status| translate}}\"><span translate>MASTER</span><b style=\"font-size: 14px\" ng-if=\"item.broadcast.status\"> !</b></span><div><a id=\"preview-master\" ng-click=\"previewMasterStory()\" title=\"{{ :: 'Preview master story' | translate }}\" ng-app=\"\" class=\"open-item\"><i class=\"icon-external\"></i></a></div></div><div ng-if=\"translationService.translationsEnabled() && translationsInfo != null\"><span ng-if=\"item.translated_from != null\" class=\"authoring-header__label-2\" translate>Translated from</span> <span ng-if=\"item.translated_from != null\" class=\"label label--hollow\">{{translationsInfo.translatedFromReference.language}}</span> <span ng-if=\"item.translated_from == null\" class=\"label label--primary label--hollow\" translate>Original</span> <a href ng-click=\"activateTranslationsWidget()\"><strong>({{translationsInfo.count}})</strong> <span translate>translations</span></a></div></div><div class=\"authoring-header__detailed\" sd-media-query min-width=\"550\"><div class=\"authoring-header__item\" sd-validation-error=\"error.slugline\" data-required=\"schema.slugline.required\" ng-if=\"schema.slugline && editor['slugline'].section !== 'content'\" sd-width=\"{{editor.slugline.sdWidth}}\" order=\"{{editor.slugline.order}}\"><label class=\"authoring-header__item-label uppercase\" translate>SLUGLINE</label><div class=\"authoring-header__input-holder\"><input type=\"text\" tansa-scope-sync tabindex=\"{{editor.slugline.order}}\" class=\"line-input slugline\" id=\"slugline\" ng-model=\"item.slugline\" ng-model-options=\"{debounce: 500}\" ng-change=\"autosave(item)\" ng-disabled=\"!_editable\" ng-trim=\"false\" tabindex=\"{{editor.slugline.order}}\"> <span ng-if=\"schema.slugline.maxlength\" sd-character-count data-item=\"item.slugline\" data-html=\"true\" data-limit=\"schema.slugline.maxlength\"></span></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.keywords\" data-required=\"schema.keywords.required\" ng-if=\"schema.keywords\" sd-width=\"{{editor.keywords.sdWidth}}\" order=\"{{editor.keywords.order}}\"><label class=\"authoring-header__item-label\" translate>KEYWORDS</label><div class=\"authoring-header__input-holder\"><div sd-meta-words-list class=\"data terms-box\" data-item=\"item\" data-field=\"keywords\" data-change=\"autosave(item)\" data-header=\"_editable\" data-list=\"metadata.keywords\" data-disabled=\"!_editable\" data-style=\"line-input\" tabindex=\"{{editor.keywords.order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.keywords\">{{helper_text.keywords}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.genre\" data-required=\"schema.genre.required\" ng-if=\"schema.genre && editor.genre && !genreInCvs\" sd-width=\"{{editor.genre.sdWidth}}\" order=\"{{editor.genre.order}}\"><label class=\"authoring-header__item-label\" translate>GENRE</label><div class=\"authoring-header__input-holder\"><div sd-meta-dropdown class=\"data\" data-tabindex=\"editor.genre.order\" data-item=\"item\" data-field=\"genre\" data-list=\"metadata.genre\" ng-disabled=\"!_editable || item.broadcast.master_id\" data-change=\"autosave(item)\" tabindex=\"{{editor.genre.order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.genre\">{{helper_text.genre}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.anpa_take_key\" data-required=\"schema.anpa_take_key.required\" ng-if=\"schema.anpa_take_key\" sd-width=\"{{editor.anpa_take_key.sdWidth}}\" order=\"{{editor.anpa_take_key.order}}\"><label class=\"authoring-header__item-label\" translate>TAKEKEY</label><div class=\"authoring-header__input-holder\"><input type=\"text\" tabindex=\"{{editor.anpa_take_key.order}}\" class=\"line-input\" id=\"anpa_take_key\" ng-model=\"item.anpa_take_key\" ng-change=\"autosave(item)\" ng-disabled=\"!_editable\" ng-trim=\"false\" tabindex=\"{{editor.anpa_take_key.order}}\"></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.place\" data-required=\"schema.place.required\" ng-if=\"metadata.locators && schema.place && editor.place && !placeInCvs\" sd-width=\"{{editor.place.sdWidth}}\" order=\"{{editor.place.order}}\"><label class=\"authoring-header__item-label\" translate>PLACE</label><div class=\"authoring-header__input-holder\"><div sd-meta-terms ng-if=\"!features.places_autocomplete && !single_value.locators\" class=\"data\" data-tabindex=\"editor.place.order\" data-item=\"item\" data-field=\"place\" data-unique=\"qcode\" data-header=\"true\" data-list=\"metadata.locators\" ng-disabled=\"!_editable\" data-change=\"autosave(item)\"></div><div sd-meta-dropdown ng-if=\"!features.places_autocomplete && single_value.locators\" class=\"data\" data-tabindex=\"editor.place.order\" data-item=\"item\" data-field=\"place\" data-unique=\"qcode\" data-list=\"metadata.locators\" data-group=\"region\" ng-disabled=\"!_editable\" data-change=\"autosave(item)\"></div><div sd-meta-place ng-if=\"features.places_autocomplete\" class=\"data\" data-tabindex=\"editor.place.order\" data-item=\"item\" data-field=\"place\" ng-disabled=\"!_editable\" data-change=\"autosave(item)\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.locators\">{{helper_text.locators}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.language\" data-required=\"schema.language.required\" ng-if=\"metadata.languages && schema.language && editor.language\" sd-width=\"{{editor.language.sdWidth}}\" order=\"{{editor.language.order}}\"><label class=\"authoring-header__item-label\" translate>LANGUAGE</label><div class=\"authoring-header__input-holder\"><div sd-meta-dropdown class=\"data\" data-tabindex=\"editor.language.order\" data-item=\"item\" data-field=\"language\" data-key=\"qcode\" data-list=\"metadata.languages\" ng-disabled=\"!_editable\" data-change=\"autosave(item)\" tabindex=\"{{editor.language.order}}\"></div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.priority\" data-required=\"schema.priority.required\" ng-if=\"schema.priority\" sd-width=\"{{editor.priority.sdWidth}}\" order=\"{{editor.priority.order}}\"><label class=\"authoring-header__item-label\" translate>PRIORITY</label><div class=\"authoring-header__input-holder\"><div sd-meta-dropdown data-item=\"item\" data-tabindex=\"editor.priority.order\" data-field=\"priority\" data-list=\"metadata.priority\" data-icon=\"priority-label priority-label-\" data-label=\"Priority\" ng-disabled=\"!_editable\" data-key=\"qcode\" data-change=\"autosave(item)\" tabindex=\"{{editor.priority.order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.priority\">{{helper_text.priority}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.urgency\" data-required=\"schema.urgency.required\" ng-if=\"schema.urgency && shouldDisplayUrgency()\" sd-width=\"{{editor.urgency.sdWidth}}\" order=\"{{editor.urgency.order}}\"><label class=\"authoring-header__item-label\" translate>URGENCY</label><div class=\"authoring-header__input-holder\"><div sd-meta-dropdown data-item=\"item\" data-tabindex=\"editor.urgency.order\" data-field=\"urgency\" data-list=\"metadata.urgency\" data-icon=\"urgency-label urgency-label-\" data-label=\"{{ :: 'Urgency' | translate }}\" ng-disabled=\"!_editable\" data-key=\"qcode\" data-change=\"autosave(item)\" tabindex=\"{{editor.urgency.order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.urgency\">{{helper_text.urgency}}</div></div></div><div class=\"authoring-header__item\" id=\"category-setting\" sd-validation-error=\"error.anpa_category\" data-required=\"schema.anpa_category.required\" ng-if=\"metadata.categories && schema.anpa_category\" sd-width=\"{{editor.anpa_category.sdWidth}}\" order=\"{{editor.anpa_category.order}}\"><label class=\"authoring-header__item-label uppercase\" translate>ANPA Category</label><div class=\"authoring-header__input-holder\"><div sd-meta-terms class=\"data\" data-tabindex=\"editor.anpa_category.order\" ng-disabled=\"!_editable\" data-item=\"item\" data-field=\"anpa_category\" data-unique=\"qcode\" data-list=\"availableCategories\" data-header=\"true\" data-change=\"autosave(item)\" data-reload-list=\"false\" data-cv=\"{popup_width: popup_width.categories}\" data-set-language=\"true\" tabindex=\"{{editor.anpa_category.order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text.categories\">{{helper_text.categories}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.subject\" data-required=\"schema.subject.required\" ng-if=\"metadata.subjectcodes && schema.subject && editor.subject\" sd-width=\"{{editor.subject.sdWidth}}\" order=\"{{editor.subject.order}}\"><label class=\"authoring-header__item-label\" translate>SUBJECT</label><div class=\"authoring-header__input-holder\"><div id=\"subjects\" sd-meta-terms class=\"data\" data-tabindex=\"editor.subject.order\" data-item=\"item\" data-field=\"subject\" data-unique=\"qcode\" data-list=\"metadata.subjectcodes\" ng-disabled=\"!_editable\" data-header=\"true\" data-change=\"autosave(item)\" data-reload-list=\"true\" tabindex=\"{{editor.subject.order}}\"></div></div></div><div class=\"authoring-header__item\" ng-repeat=\"cv in cvs track by cv._id\" sd-validation-error=\"error[cv.display_name.toLowerCase()]\" data-required=\"editor[cv._id].required\" sd-width=\"{{editor[cv._id].sdWidth}}\" order=\"{{editor[cv._id].order}}\"><label class=\"authoring-header__item-label\"><span>{{ cv.display_name | translate }}</span></label><div class=\"authoring-header__input-holder\"><div sd-meta-terms class=\"data\" data-tabindex=\"editor[cv._id].order\" data-item=\"item\" data-field=\"{{cv.schema_field|| 'subject'}}\" data-unique=\"qcode\" data-list=\"cv.terms\" data-cv=\"cv\" ng-disabled=\"!_editable\" data-header=\"true\" data-change=\"autosave(item)\" data-reload-list=\"true\" data-include-parent=\"{{editor[cv._id].includeparent}}\" tabindex=\"{{editor[cv._id].order}}\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text[cv._id]\">{{helper_text[cv._id]}}</div></div></div><!-- custom text editor fields --><div class=\"authoring-header__item\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'text' && editor[field._id].section === 'header'\" sd-width=\"{{ editor[field._id].sdWidth || 'full' }}\" data-required=\"schema[field._id].required\" order=\"{{ editor[field._id].order }}\" sd-validation-error=\"error[field._id.toLowerCase()]\"><label class=\"authoring-header__item-label\">{{field.display_name}}</label><span ng-if=\"schema[field._id].maxlength || schema[field._id].minlength\" sd-character-count data-item=\"item.extra[field._id]\" data-html=\"true\" data-limit=\"schema[field._id].maxlength\"></span><div class=\"authoring-header__input-holder\"><div sd-editor3 class=\"authoring-header__input-editor3\" data-path-to-value=\"'extra' + FIELD_KEY_SEPARATOR + field._id\" data-single-line=\"field.field_options.single\" data-value=\"item.extra[field._id]\" data-bind-to-value=\"compareView\" data-scroll-container=\".page-content-container\" data-language=\"item.language\" data-on-change=\"autosave(item)\" data-read-only=\"!_editable\" data-disable-spellchecker=\"useTansaProofing()\" data-editor-format=\"editor[field._id].formatOptions\" data-item=\"item\" data-refresh-trigger=\"refreshTrigger\" data-tabindex=\"editor[field._id].order\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div></div><!-- custom date editor fields --><div class=\"authoring-header__item\" ng-repeat=\"field in fields track by field._id\" ng-if=\"field.field_type === 'date' && editor[field._id].section === 'header'\" sd-width=\"{{ editor[field._id].sdWidth || 'full' }}\" data-required=\"schema[field._id].required\" order=\"{{ editor[field._id].order }}\" sd-validation-error=\"error[field._id.toLowerCase()]\"><label class=\"authoring-header__item-label\">{{field.display_name}}</label><div class=\"authoring-header__input-holder\"><div sd-datepicker ng-disabled=\"!_editable\" data-tabindex=\"editor[field._id].order\" ng-model=\"item.extra[field._id]\" data-format=\"YYYY-MM-DDT00:00:00+0000\" data-on-change=\"autosave(item)\" shortcuts=\"field.date_shortcuts\"></div><div class=\"authoring-header__hint\" ng-if=\"helper_text[field._id]\">{{field.helper_text}}</div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.company_codes\" data-required=\"schema.company_codes.required\" ng-if=\"displayCompanyCodes && schema.company_codes\" sd-width=\"{{editor.company_codes.sdWidth}}\" order=\"{{editor.company_codes.order}}\"><label class=\"authoring-header__item-label\" translate>COMPANY</label><div class=\"authoring-header__input-holder\"><div sd-meta-terms class=\"data\" data-tabindex=\"editor.company_codes.order\" data-item=\"item\" data-field=\"company_codes\" data-unique=\"qcode\" data-list=\"availableCompanyCodes\" ng-disabled=\"!_editable\" data-header=\"true\" data-change=\"autosave(item)\" data-reload-list=\"false\" data-search-unique=\"true\" tabindex=\"{{editor.company_codes.order}}\"></div></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.ednote\" data-required=\"schema.ednote.required\" ng-if=\"schema.ednote\" sd-width=\"{{editor.ednote.sdWidth}}\" order=\"{{editor.ednote.order}}\"><label class=\"authoring-header__item-label\" translate>ED. NOTE</label><div class=\"authoring-header__input-holder\"><textarea id=\"ednote\" class=\"line-input ed-note\" sd-auto-height tansa-scope-sync tabindex=\"{{editor.ednote.order}}\" ng-model=\"item.ednote\" ng-disabled=\"!_editable\" ng-change=\"autosave(item)\" tabindex=\"{{editor.ednote.order}}\">\n" +
            "                    </textarea></div></div><div class=\"authoring-header__item\" sd-validation-error=\"error.authors\" data-required=\"schema.authors.required\" ng-if=\"schema.authors && editor.authors\" sd-width=\"{{editor.authors.sdWidth}}\" order=\"{{editor.authors.order}}\" ng-controller=\"PopulateAuthorsController\"><label class=\"authoring-header__item-label\" translate>AUTHORS</label><div class=\"authoring-header__input-holder\"><div id=\"authors\" sd-meta-terms class=\"data\" data-tabindex=\"editor.authors.order\" data-item=\"item\" data-field=\"authors\" data-unique=\"_id\" data-list=\"metadata.authors\" data-label=\"{{ :: 'Add author' | translate }}\" ng-disabled=\"!_editable\" data-header=\"true\" data-change=\"autosave(item)\" data-reload-list=\"true\" data-select-entire-category=\"false\" tabindex=\"{{editor.authors.order}}\"></div></div></div></div></div><button class=\"authoring-header__toggle\" ng-class=\"{active: !isCollapsed}\" ng-click=\"toggleCollapsed()\" tabindex=\"-1\"><i class=\"icon-chevron-up-thin\"></i></button></div>");
        $templateCache.put('scripts/apps/authoring/views/authoring-topbar.html', "<div id=\"subnav\" class=\"subnav subnav--authoring\" ng-class=\"{'auth-sendto': views.send}\" sd-media-query min-width=\"900\"><div class=\"dropdown dropdown--dropright lock-avatar pull-left\" ng-show=\"isLocked()\" dropdown><figure class=\"avatar small avatar-with-info\" dropdown__toggle><div class=\"logged-info\"></div><div class=\"user-image\"><img sd-user-avatar data-user=\"item.lock_user\"></div></figure><div class=\"dropdown__menu\"><div class=\"dropdown__menu-label\" translate>Locked by</div><figure class=\"avatar large\"><div class=\"user-image\"><img sd-user-avatar data-user=\"item.lock_user\"></div></figure><div class=\"lock-text\">{{ item.lock_user | username }}</div><button class=\"btn btn--medium\" ng-show=\"can_unlock()\" ng-click=\"unlock()\" ng-disabled=\"unlockClicked\" sd-hotkey=\"ctrl+shift+u\" sd-hotkey-options=\"{global: true}\" translate>Unlock</button></div></div><div class=\"subnav__authoring-topbar\" ng-class=\"{'enable-overflow': item.highlights || item._type === 'archived'}\"><span ng-if=\"item._type === 'archived'\" class=\"stage\" ng-style=\"{'overflow': 'visible'}\" tooltip=\"{{:: 'Archived from' | translate}} {{deskName}} / {{ stage.name}}\" tooltip-placement=\"bottom\" ng-show=\"stage\"><b>{{:: 'Archived from' | translate}} {{deskName}}</b> / {{ stage.name }}</span> <span ng-if=\"item._type !== 'archived'\" class=\"stage\" tooltip=\"{{deskName}} / {{ stage.name }}\" tooltip-placement=\"bottom\" ng-show=\"stage\" ng-if=\"item._type !== 'legal_archive'\"><b>{{deskName}}</b> / {{ stage.name }}</span> <span class=\"stage\" tooltip=\"{{deskName}} / {{ stage }}\" tooltip-placement=\"bottom\" ng-show=\"stage\" ng-if=\"item._type === 'legal_archive'\"><b>{{deskName}}</b> / {{ stage }}</span> <span sd-marked-item-title data-item=\"item\" data-field=\"highlights\"></span> <span sd-marked-item-title data-item=\"item\" data-field=\"marked_desks\"></span> <span sd-assignment-icon data-item=\"item\"><span class=\"label label--warning\" ng-show=\"item._type !== 'archived' && stage.local_readonly\" translate>Read-only</span></div><div class=\"subnav__stretch-bar\" ng-if=\"showCustomButtons(item)\"><div class=\"subnav__button-stack subnav__button-stack--custom-buttons\" ng-if=\"$root.config.features.customAuthoringTopbar\" ng-show=\"_editable && itemActions.save && action === 'edit'\"><button class=\"btn btn--custom\" ng-click=\"saveAndContinue(sendToNextStage, false)\" title=\"{{ :: 'To Desk' | translate }}\"><span class=\"btn__text\" translate>To Desk</span> <span class=\"btn__text--short\" translate>T D</span></button> <button class=\"btn btn--custom btn--publish\" type=\"submit\" ng-if=\"canPublishOnDesk()\" ng-click=\"saveAndContinue(publish, true)\" title=\"{{ :: 'Publish' | translate }}\"><span class=\"btn__text\" translate>Publish</span> <span class=\"btn__text--short\" translate>P</span></button> <button class=\"btn btn--custom btn--publish-plus\" ng-if=\"canPublishOnDesk()\" ng-click=\"saveAndContinue(publishAndContinue, true)\" title=\"{{ :: 'Publish and Continue' | translate }}\"><span class=\"btn__text\">{{ :: 'Publish and Continue' | translate }}</span> <span class=\"btn__text--short\">{{ :: 'P & C' | translate }}</span></button></div></div><div class=\"subnav__button-stack subnav__button-stack--default\" sd-media-query min-width=\"180\"><button id=\"Edit\" class=\"btn btn--medium btn--primary\" ng-if=\"item._type !== 'legal_archive'\" ng-show=\"action === 'view' && !item._editable && itemActions.edit\" ng-click=\"edit()\" translate>Edit</button> <button class=\"btn btn--primary\" ng-show=\"(action === 'view' || !item._editable) && itemActions.deschedule\" ng-click=\"deschedule()\" translate>Deschedule</button> <button class=\"btn btn--primary\" ng-if=\"item._type !== 'legal_archive' && !isLocked() && userHasPrivileges({rewrite: 1}) === true\" ng-show=\"(action === 'view' || !item._editable) && itemActions.re_write\" ng-click=\"openAction('rewrite')\" translate>Update</button> <button class=\"btn btn--primary\" ng-if=\"item._type !== 'legal_archive' && userHasPrivileges({correct: 1}) === true\" ng-show=\"(action === 'view' || !item._editable) && itemActions.correct\" ng-click=\"openAction('correct')\" translate>Correct</button> <button class=\"btn btn--primary\" ng-if=\"item._type !== 'legal_archive' && userHasPrivileges({takedown: 1}) === true\" ng-show=\"(action === 'view' || !item._editable) && itemActions.takedown\" ng-click=\"openAction('takedown')\" translate>Takedown</button> <button class=\"btn btn--primary\" ng-if=\"item._type !== 'legal_archive' && userHasPrivileges({kill: 1}) === true\" ng-show=\"(action === 'view' || !item._editable) && itemActions.kill\" ng-click=\"openAction('kill')\" translate>Kill</button> <button class=\"btn btn--close\" id=\"closeAuthoringBtn\" ng-click=\"close()\" ng-if=\"action !== 'correct' && action !== 'kill'\" title=\"{{ :: 'Close' | translate }}\" sd-hotkey=\"ctrl+shift+e\" sd-hotkey-options=\"{global: true}\"><span class=\"btn__text\" translate>Close</span><i class=\"icon-close-small btn__text--alt-icon\"></i></button> <button class=\"btn btn--primary\" type=\"submit\" ng-click=\"saveTopbar()\" ng-show=\"_editable\" ng-if=\"itemActions.save && action === 'edit'\" ng-disabled=\"!save_enabled() || saveDisabled\" sd-hotkey=\"ctrl+shift+s\" sd-hotkey-options=\"{global: true}\" translate>Save</button> <button class=\"btn btn--primary\" type=\"submit\" ng-click=\"previewFormattedItem()\" ng-show=\"_editable\" ng-if=\"itemActions.save && previewFormattedEnabled() && action === 'edit'\" ng-disabled=\"save_enabled() && !saveDisabled\" sd-hotkey=\"ctrl+shift+l\" sd-hotkey-options=\"{global: true}\" translate>Preview</button><div sd-preview-formatted ng-if=\"previewFormatted\"></div><button id=\"export\" class=\"btn btn--primary\" ng-click=\"exportHighlight(item)\" ng-disabled=\"!_editable\" ng-if=\"showExportButton\" translate>Export</button> <button class=\"btn btn--primary\" type=\"submit\" id=\"send-correction-btn\" ng-if=\"action === 'correct'\" ng-show=\"_editable\" ng-disabled=\"canSendAndPublish()\" ng-click=\"publish()\" translate>Send Correction</button> <button class=\"btn btn--primary\" type=\"submit\" id=\"send-kill-btn\" ng-if=\"action === 'kill'\" ng-show=\"_editable\" ng-disabled=\"canSendAndPublish()\" ng-click=\"publish()\" translate>Send Kill</button> <button class=\"btn btn--primary\" type=\"submit\" id=\"send-takedown-btn\" ng-if=\"action === 'takedown'\" ng-show=\"_editable\" ng-disabled=\"canSendAndPublish()\" ng-click=\"publish()\" translate>Send Takedown</button> <button class=\"btn btn--close\" id=\"cancelAuthoringBtn\" ng-if=\"action === 'correct' || action === 'kill'\" ng-click=\"close()\" translate>Cancel</button> <button ng-repeat=\"(_, btn) in additionalButtons\" ng-class=\"btn.class\" ng-click=\"btn.onClick(item)\">{{btn.label}}</button></div><div class=\"subnav__button-stack subnav__button-stack--square-buttons\"><button class=\"navbtn strict\" ng-if=\"!isLocked() && _editable && buttonsToHide['article-edit--topbar--minimize'] !== true\" title=\"{{ :: 'Minimize' | translate }}\" ng-click=\"minimize()\"><i class=\"big-icon--minimize\"></i></button><div id=\"authoring-extra-dropdown\" ng-if=\"item._type !== 'legal_archive' && item._type !== 'archived' && !highlight && item.state !== 'spiked' && buttonsToHide['article-edit--topbar--actions'] !== true\" class=\"dropdown pull-left strict\" dropdown><button id=\"more-actions\" class=\"navbtn dropdown__toggle\" title=\"{{ :: 'More actions' | translate }}\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><div class=\"dropdown__menu pull-right\"><ul ng-controller=\"TemplateMenu as templateMenu\" ng-show=\"canSaveTemplate()\"><li><button type=\"button\" ng-click=\"templateMenu.create(item)\" translate>Save as template</button></li></ul><ul ng-if=\"!hideLiveSuggestions()\"><li><button type=\"button\" ng-click=\"openSuggestions()\" class=\"live-suggest-menu-item\" translate>Live suggestions</button></li></ul><ul id=\"compare-versions\" ng-if=\"item.task.desk\"><li><button type=\"button\" ng-click=\"openCompareVersions(item)\" translate>Compare versions</button></li></ul><ul id=\"multiedit\" ng-if=\"item.task.desk && itemActions.multi_edit && !isLocked()\" ng-show=\"action !== 'kill'\"><li><div class=\"dropdown multiedit-toggle\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ :: 'Multiedit' | translate }}</button><ul class=\"dropdown__menu dropdown__menu--submenu-left\" sd-multiedit-dropdown></ul></div></li></ul><ul ng-if=\"canExport()\"><li><button type=\"button\" ng-click=\"openExport()\">{{ :: 'Export' | translate }} <i class=\"icon-download-right-thin dropdown__submenu-icon\"></i><div sd-export ng-if=\"export\"></div></button></li></ul><ul ng-if=\"item.task.desk && (itemActions.mark_item_for_desks || itemActions.mark_item_for_highlight)\"><li class=\"dropdown__menu-divider\"></li><li><span class=\"dropdown__menu-label\" translate>Mark item for</span></li><li ng-if=\"itemActions.mark_item_for_highlight\"><div class=\"dropdown highlights-toggle\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ :: 'Highlights' | translate }}</button><ul class=\"dropdown__menu dropdown__menu--submenu-left\" sd-mark-highlights-dropdown></ul></div></li><li ng-if=\"itemActions.mark_item_for_desks\"><div class=\"dropdown marks-toggle\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ :: 'Desks' | translate }}</button><ul class=\"dropdown__menu dropdown__menu--submenu-left\" sd-mark-desks-dropdown></ul></div></li></ul><span sd-item-action-by-intent sd-intent-action=\"external-app\"></span><ul ng-if=\"isTranslationAvailable()\"><li class=\"dropdown__menu-divider\"></li><li><span class=\"dropdown__menu-label\" translate>Translations</span></li><li><div class=\"dropdown highlights-toggle\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ :: 'Translate item to' | translate }}</button><ul class=\"dropdown__menu dropdown__menu--submenu-left\" sd-translation-dropdown></ul></div></li></ul><ul ng-if=\"_editable\" ng-controller=\"SpellcheckMenu as spellcheckMenu\"><li class=\"dropdown__menu-divider\"></li><li><span class=\"dropdown__menu-label\" translate>Spell Checker</span></li><li ng-if=\"!useTansaProofing()\" class=\"dropdown__menu-item--no-link\"><span class=\"pull-right\" sd-switch ng-model=\"spellcheckMenu.isAuto\" ng-change=\"spellcheckMenu.pushSettings()\" ng-hide=\"!spellcheckMenu.isActiveDictionary\" tooltip=\"{{ spellcheckMenu.isAuto ? 'Spell checking ON' : 'Spell checking OFF'  | translate }}\" tooltip-placement=\"left\"></span> <span translate>Run automatically</span></li><li ng-if=\"!useTansaProofing()\"><button type=\"button\" ng-click=\"spellcheckMenu.runSpellchecker()\" ng-disabled=\"spellcheckMenu.isAuto\" sd-hotkey=\"ctrl+shift+y\" sd-hotkey-options=\"{global: true}\"><span class=\"shortcut pull-right\">Ctrl+Shift+Y</span> <span translate>Check spelling</span></button></li><li ng-if=\"useTansaProofing()\"><button type=\"button\" ng-click=\"runTansa()\" sd-hotkey=\"ctrl+shift+y\" sd-hotkey-options=\"{global: true}\"><span class=\"shortcut pull-right\">Ctrl+Shift+Y</span> <span translate>Check spelling</span></button></li></ul><span sd-extension-point=\"authoring-topbar\"></span></div></div><button id=\"send-to-btn\" ng-show=\"_editable\" ng-if=\"action !== 'correct' && action !== 'kill' && buttonsToHide['article-edit--topbar--sendto-publish'] !== true\" class=\"navbtn navbtn--highlighted\" sd-tooltip=\"{{ :: 'Send to / Publish' | translate }}\" flow=\"left\" ng-click=\"views.send = !views.send\" ng-class=\"{'active': views.send}\"><i class=\"big-icon--send-to big-icon--white\"></i></button></div></div>");
        $templateCache.put('scripts/apps/authoring/views/authoring.html', "<div sd-authoring class=\"auth-screen\" ng-if=\"origItem\"><div sd-authoring-topbar></div><section class=\"main-section\" ng-class=\"{'auth-sendto': views.send, 'packaging-screen': item.type === 'composite'}\"><div sd-authoring-widgets data-item=\"item\"><div class=\"authoring-sticky\"><div class=\"authoring-sticky__detailed\"><label translate>Created</label><time sd-datetime data-date=\"item.firstcreated\"></time><label ng-if=\"userLookup[item.original_creator]\" translate>by</label><b>{{userLookup[item.original_creator].display_name}}</b><div ng-if=\"item.versioncreated\"><label translate>Modified</label><time sd-datetime data-date=\"item.versioncreated\"></time></div><span sd-extension-point=\"authoring-sticky-detailed\"></span></div><div class=\"authoring-sticky__theme-controls\"><div class=\"preview-modal-control\" ng-if=\"$root.config.features.preview\"><div sd-full-preview ng-if=\"fullPreview\" data-item=\"item\" data-close-action=\"closeFullPreview\"></div><button class=\"preview-toggle icn-btn\" ng-if=\"item.type === 'text'\" title=\"{{:: 'Preview' | translate}}\" ng-click=\"openFullPreview($event)\" ng-href=\"{{fullPreviewUrl}}\"><i class=\"icon-preview-mode\"></i></button></div><button class=\"proofread-toggle icn-btn\" ng-class=\"{active: proofread}\" ng-click=\"proofread = !proofread\" title=\"{{:: 'Toggle theme' | translate}}\"><i class=\"icon-adjust\"></i></button> <span sd-theme-select ng-if=\"proofread\" data-key=\"proofreadTheme\"></span> <span sd-theme-select ng-if=\"!proofread\" data-key=\"theme\"></span></div></div><div class=\"page-content-container\" ng-click=\"views.send = false\"><header sd-authoring-header></header><article class=\"main-article theme-container\" ng-class=\"{preview: !_editable}\"><div ng-if=\"item.type !== 'composite'\" class=\"fieldset main-article__fieldset\" sd-article-edit></div><div ng-if=\"item.type === 'composite'\" sd-package-edit></div></article></div></div><div sd-macros-replace></div></section><div sd-send-item id=\"send-item-container\" ng-if=\"views.send\" data-item=\"item\" data-orig=\"origItem\" data-view=\"views.send\" data-before-send=\"beforeSend(action)\" data-editable=\"_editable\" data-publish=\"publish()\" data-action=\"action\" data-autosave=\"autosave(item)\" data-mode=\"authoring\"></div></div>");
        $templateCache.put('scripts/apps/authoring/views/change-image.html', "<div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading modal__heading--no-grow\" ng-if=\"!nav || nav === 'view'\">{{ :: activity.label}}</h3><h3 class=\"modal__heading modal__heading--no-grow\" ng-if=\"nav === 'image-edit'\">{{ :: 'Edit image' | translate }}</h3><h3 class=\"modal__heading modal__heading--no-grow\" ng-if=\"nav === 'crop'\">{{ :: 'Edit Crops' | translate }}</h3><div class=\"modal__header-buttons modal__header-buttons--center modal__header-element-grow button-nav\"><button class=\"button-nav__btn\" ng-click=\"nav = 'view'; showMetadata = true\" ng-class=\"{'button-nav__btn--active' : !nav || nav === 'view'}\" ng-show=\"tabs.includes('view')\" ng-disabled=\"!isDoneEnabled()\" translate>Details / Metadata</button> <button class=\"button-nav__btn\" ng-click=\"nav = 'image-edit'; showMetadata = true\" ng-show=\"data.editable && tabs.includes('image-edit')\" ng-class=\"{'button-nav__btn--active': nav === 'image-edit'}\" ng-disabled=\"!isDoneEnabled()\" translate>Edit image</button> <button class=\"button-nav__btn\" ng-click=\"nav = 'crop'; showMetadata = false\" ng-show=\"data.editable && tabs.includes('crop')\" ng-class=\"{'button-nav__btn--active': nav === 'crop'}\" ng-disabled=\"!isDoneEnabled()\" translate>Edit crops</button></div><div class=\"modal__header-buttons modal__header-buttons--right\"><button class=\"btn btn--primary btn--hollow\" ng-click=\"done()\" ng-disabled=\"!isDoneEnabled() || isAoISelectionModeEnabled\">{{ 'Done ' | translate }}</button></div></div><div class=\"modal__body modal__body--no-padding\"><div class=\"sd-column-box--2\"><div class=\"sd-column-box__main-column sd-column-box__main-column--photo-preview\" ng-class=\"{'toolbar-offset': crops.isDirty}\"><a class=\"sd-photo-preview__slide-in-button\" ng-show=\"!showMetadata && nav !== 'crop'\" ng-click=\"showMetadata = !showMetadata\" data-sd-tooltip=\"Open metadata\" data-flow=\"left\"><i class=\"icon-backward-thin\"></i></a><div class=\"sd-photo-preview\" ng-if=\"!nav || nav === 'view'\"><div class=\"sd-photo-preview__image\"><img ng-if=\"data.item.type === 'picture' || data.item.type === 'image'\" ng-src=\"{{data.item.renditions.original.href}}\"><video controls ng-if=\"data.item.type === 'video'\" ng-src=\"{{data.item.renditions.original.href}}\"></video><audio controls ng-if=\"data.item.type === 'audio'\" ng-src=\"{{data.item.renditions.original.href}}\"></audio></div></div><div class=\"sd-photo-preview sd-photo-preview__edit-mode\" ng-if=\"nav === 'image-edit'\"><div class=\"sd-photo-preview__image sd-photo-preview__image--no-flex\" ng-class=\"{'actioning': loaderForAoI || loaderForMediaEdit}\"><div sd-image-crop data-show-min-size-error=\"true\" data-src=\"data.item.renditions.viewImage.href\" data-original=\"data.item.renditions.original\" data-crop-data=\"areaOfInterestData\" data-on-change=\"enableSaveAreaOfInterest()\" ng-if=\"isAoISelectionModeEnabled && !loaderForAoI\"></div><sd-image-modify data-src=\"data.item.renditions.original.href\" data-brightness=\"controls.brightness\" data-contrast=\"controls.contrast\" data-saturate=\"controls.saturation\" data-rotate=\"controls.rotate\" data-fliph=\"controls.fliph\" data-flipv=\"controls.flipv\" ng-class=\"{'disable-transition' : !controls.isDirty}\" ng-if=\"!isAoISelectionModeEnabled && !loaderForAoI\"></sd-image-modify></div></div><div class=\"sd-photo-preview sd-photo-preview__edit-mode\" ng-if=\"nav === 'crop'\"><div class=\"modal__sliding-toolbar\" ng-if=\"crops.isDirty\"><div class=\"sliding-toolbar__inner\"></div><a class=\"btn\" ng-click=\"cancelCrops()\" translate>Cancel</a> <a class=\"btn btn--primary\" ng-click=\"saveCrops()\" translate>Save</a></div><div class=\"sd-photo-preview__image--with-strip\" ng-if=\"!selectedRendition\"><sd-image-point data-src=\"data.item.renditions.viewImage.href\" data-poi=\"data.poi\" data-on-change=\"crops.isDirty = true\"></sd-image-point><div><label class=\"sd-photo-preview__label\"><span translate>Original</span> <span class=\"size\">{{ data.item.renditions.original.width}} x {{ data.item.renditions.original.height}}</span></label></div></div><div class=\"crop-area selected sd-photo-preview__image--with-strip\" ng-if=\"selectedRendition\"><div sd-image-crop data-show-min-size-error=\"true\" data-src=\"data.item.renditions.viewImage.href\" data-original=\"data.item.renditions.original\" data-rendition=\"selectedRendition\" data-crop-data=\"data.cropData[selectedRendition.name]\" data-on-change=\"onChange(renditionName, cropData)\"></div><div><label class=\"sd-photo-preview__label\">{{ selectedRendition.name}}</label></div></div><div class=\"sd-photo-preview__thumb-strip\"><div class=\"sd-grid-list dark-ui\"><div class=\"sd-grid-item sd-grid-item--with-click\" ng-click=\"selectRendition()\" ng-class=\"{active: selectedRendition === null}\"><div class=\"sd-grid-item__thumb\"><sd-image-point data-src=\"data.item.renditions.viewImage.href\" data-poi=\"data.poi\" data-on-change=\"crops.isDirty = true\"></sd-image-point></div><div class=\"sd-grid-item__content\"><span translate>Original</span></div></div><div class=\"sd-grid-item sd-grid-item--with-click sd-grid-item--overflow-v\" ng-repeat=\"rendition in data.renditions track by rendition.name\" ng-click=\"selectRendition(rendition)\" ng-class=\"{active: rendition === selectedRendition}\"><div class=\"sd-grid-item__thumb\"><div sd-image-crop data-show-min-size-error=\"true\" data-src=\"data.item.renditions.viewImage.href\" data-original=\"data.item.renditions.original\" data-rendition=\"rendition\" data-crop-init=\"data.item.renditions[rendition.name]\" data-crop-data=\"data.cropData[rendition.name]\" data-on-change=\"onChange(renditionName, cropData)\"></div></div><div class=\"sd-grid-item__content\"><span>{{rendition.name}}</span></div></div></div></div></div></div><div class=\"sd-column-box__slide-in-column sd-column-box__slide-in-column--large sd-column-box__slide-in-column--dark-ui\" ng-class=\"{'sd-column-box__slide-in-column--closed' : !showMetadata}\" ng-show=\"nav !== 'crop'\"><div class=\"sd-column-box__slide-in-column-inner sd-slide-in-panel\"><div class=\"sd-slide-in-panel__header\"><h3 class=\"sd-slide-in-panel__heading\" ng-if=\"nav !== 'image-edit'\" translate>Metadata</h3><h3 class=\"sd-slide-in-panel__heading\" ng-if=\"nav === 'image-edit'\" translate>Controls</h3><a class=\"icn-btn sd-slide-in-panel__close\" sd-tooltip=\"Close details\" flow=\"top\" ng-click=\"showMetadata = !showMetadata\"><i class=\"icon-close-small\"></i></a></div><div class=\"sd-slide-in-panel__content\" ng-if=\"nav !== 'image-edit'\"><div class=\"sd-slide-in-panel__content-block sd-slide-in-panel__content-block--first\"><div class=\"modal__sliding-toolbar\" ng-if=\"metadata.isDirty\"><div class=\"sliding-toolbar__inner\"></div><a class=\"btn\" ng-click=\"cancelMetadataChanges()\" translate>Cancel</a> <a class=\"btn btn--primary\" ng-click=\"applyMetadataChanges()\" translate>Apply</a></div><div sd-media-metadata-editor data-item=\"data.metadata\" data-validator=\"validator\" data-dark=\"true\" data-boxed=\"true\" data-on-change=\"metadata.isDirty = true\" data-disabled=\"!data.editable\" data-associated=\"data.isAssociated\"></div></div></div><div sd-media-copy-metadata class=\"sd-slide-in-panel__footer\" data-metadata=\"data.metadata\" data-on-change=\"metadata.isDirty = true\"></div><div class=\"sd-slide-in-panel__content\" ng-if=\"nav === 'image-edit'\"><div class=\"sd-slide-in-panel__content-block sd-slide-in-panel__content-block--first\"><div class=\"modal__sliding-toolbar\" ng-if=\"isAoISelectionModeEnabled && !loaderForAoI\"><div class=\"sliding-toolbar__inner\"></div><a class=\"btn\" ng-click=\"showAreaOfInterestView(false)\" translate>Cancel</a> <a class=\"btn btn--primary\" ng-click=\"saveAreaOfInterest(areaOfInterestData)\" ng-disabled=\"!isAoIDirty\" translate>Confirm crop</a></div><div class=\"modal__sliding-toolbar\" ng-if=\"controls.isDirty\"><div class=\"sliding-toolbar__inner\"></div><a class=\"btn\" ng-click=\"cancelImageChanges()\" translate>Cancel</a> <a class=\"btn btn--primary\" ng-click=\"applyImageChanges()\" translate>Apply</a></div><h3 class=\"sd-slide-in-panel__heading sd-slide-in-panel__heading--marg-b16\" translate>Change image settings</h3><div class=\"form__row\"><button class=\"btn btn--ui-dark btn--hollow btn--icon-only btn--large\" ng-click=\"showAreaOfInterestView()\" ng-class=\"{'btn--active' : isAoISelectionModeEnabled}\" sd-tooltip=\"Crop\" ng-disabled=\"controls.isDirty\"><i class=\"icon-crop icon--white\"></i></button> <button class=\"btn btn--ui-dark btn--hollow btn--icon-only btn--large\" ng-click=\"rotateImage('left')\" sd-tooltip=\"Rotate left\" ng-disabled=\"isAoISelectionModeEnabled\"><i class=\"icon-rotate-left icon--white\"></i></button> <button class=\"btn btn--ui-dark btn--hollow btn--icon-only btn--large\" ng-click=\"rotateImage('right')\" sd-tooltip=\"Rotate right\" ng-disabled=\"isAoISelectionModeEnabled\"><i class=\"icon-rotate-right icon--white\"></i></button> <button class=\"btn btn--ui-dark btn--hollow btn--icon-only btn--large\" ng-click=\"flipImage('horizontal')\" sd-tooltip=\"Flip horizontal\" ng-disabled=\"isAoISelectionModeEnabled\"><i class=\"icon-flip-horizontal icon--white\"></i></button> <button class=\"btn btn--ui-dark btn--hollow btn--icon-only btn--large\" ng-click=\"flipImage('vertical')\" sd-tooltip=\"Flip vertical\" ng-disabled=\"isAoISelectionModeEnabled\"><i class=\"icon-flip-vertical icon--white\"></i></button></div></div><div class=\"sd-slide-in-panel__content-block\" ng-if=\"isAoISelectionModeEnabled\"><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--dark-ui sd-line-input--boxed sd-line-input--indent-l30\"><span class=\"sd-line-input__info-left\">W</span><label class=\"sd-line-input__label\" translate>Image size</label><input ng-model=\"areaOfInterestData.CropRight\" ng-change=\"resizeImage()\" class=\"sd-line-input__input sd-line-input__input--center\" type=\"number\"></div></div><div class=\"form__row-item form__row-item--no-grow\"><span>x</span></div><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--dark-ui sd-line-input--boxed sd-line-input--indent-l30\"><span class=\"sd-line-input__info-left\">H</span> <input ng-model=\"areaOfInterestData.CropBottom\" class=\"sd-line-input__input sd-line-input__input--center\" type=\"number\"></div></div></div><div class=\"flex-grid flex-grid--boxed-small flex-grid--wrap-items flex-grid--small-2\"><button class=\"btn btn--hollow btn--ui-dark btn--large\" ng-click=\"setRatio()\" translate>Original</button> <button class=\"btn btn--hollow btn--ui-dark btn--large\" ng-click=\"setRatio('16:9')\">16 : 9</button> <button class=\"btn btn--hollow btn--ui-dark btn--large\" ng-click=\"setRatio('4:3')\">4 : 3</button> <button class=\"btn btn--hollow btn--ui-dark btn--large\" ng-click=\"setRatio('3:2')\">3 : 2</button></div></div><div class=\"sd-slide-in-panel__content-block\" ng-if=\"!isAoISelectionModeEnabled\"><h3 class=\"sd-slide-in-panel__heading sd-slide-in-panel__heading--marg-b20\" translate>Adjust colours</h3><div class=\"form__row form__row--small-padding\"><div class=\"form-label__container\"><label class=\"form-label\" translate>Brightness</label><span class=\"form-label__info-block\">{{controls.brightness * 100 - 100| number:0}}%</span></div><input type=\"range\" class=\"sd-slider__range\" min=\"0\" max=\"2\" step=\".05\" ng-model=\"controls.brightness\" ng-dblclick=\"controls.brightness = 1\" ng-change=\"controls.isDirty = true\"></div><div class=\"form__row form__row--small-padding\"><div class=\"form-label__container\"><label class=\"form-label\" translate>Contrast</label><span class=\"form-label__info-block\">{{controls.contrast * 100 - 100| number:0}}%</span></div><input type=\"range\" class=\"sd-slider__range\" min=\".5\" max=\"1.5\" step=\".05\" ng-model=\"controls.contrast\" ng-dblclick=\"controls.contrast = 1\" ng-change=\"controls.isDirty = true\"></div><div class=\"form__row form__row--small-padding\"><div class=\"form-label__container\"><label class=\"form-label\" translate>Saturation</label><span class=\"form-label__info-block\">{{controls.saturation * 100 - 100| number:0}}%</span></div><input type=\"range\" class=\"sd-slider__range\" min=\"0\" max=\"2\" step=\".05\" ng-model=\"controls.saturation\" ng-dblclick=\"controls.saturation = 1\" ng-change=\"controls.isDirty = true\"></div></div></div></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/confirm-media-associated.html', "<div><div class=\"modal__header\"><h3 class=\"modal__heading\" translate>Do you want to add an image to this update?</h3></div><div class=\"modal__body featuremedia-confirmation\"><div class=\"field\"><label translate>Featured Media</label><div ng-if=\"item.associations.featuremedia\" class=\"picture-preview\"><div sd-item-rendition data-item=\"item.associations.featuremedia\" data-rendition=\"viewImage\"></div><p class=\"nav-space description-text\">{{item.associations.featuremedia.description_text}}</p></div></div></div><div class=\"modal__footer\"><button type=\"button\" class=\"btn\" translate ng-click=\"useMedia()\">Use Media</button> <button type=\"button\" class=\"btn\" ng-click=\"publishWithoutMedia()\" translate>Publish Without Media</button> <button type=\"button\" class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button></div></div>");
        $templateCache.put('scripts/apps/authoring/views/dashboard-articles.html', "<div sd-modal data-model=\"active\" data-close=\"closeDashboard()\" class=\"modal--fullscreen animate-zoom__from-bottom-left\"><div class=\"modal__header\"><button ng-click=\"closeDashboard()\" title=\"{{ :: 'Close'|translate}}\" class=\"modal__close pull-right animate-slide-in__from-right\"><i class=\"icon-close-thick\"></i></button><h3 class=\"modal__heading\" translate>Currently working on</h3></div><div class=\"modal__body\"><div class=\"flex-grid box wrap-items small-2 medium-3 large-5 xlarge-6\"><div class=\"flex-item card-box card-box--with-click card-box--flex\" ng-repeat=\"article in items track by article._id\" ng-class=\"{active: article === active}\"><a class=\"card-box__full-click\" ng-click=\"edit(article, $event)\" ng-href=\"{{ :: link(article)}}\"></a> <span class=\"close cardbox__close\" ng-click=\"closeItem(article)\"><i class=\"icon-close-small icon--white\"></i></span><div class=\"card-box__header card-box__header--padded-flex\"><i title=\"{{article.type}}\" class=\"filetype-icon-{{article.type}} icon--white\"></i><time class=\"card-box__time-date card-box__time-date--reverse-color\" sd-reldate-complex datetime=\"article.versioncreated\"></time></div><div class=\"card-box__article-header\"><h4 ng-show=\"article.headline\">{{ article.headline}}</h4><h4 ng-show=\"!article.headline\">{{ :: 'Untitled' | translate }}</h4></div><div class=\"card-box__content card-box__content--article\"></div><div class=\"card-box__footer card-box__footer--light\"><span class=\"state-label state-{{article.state}}\">{{article.state}}</span> <span sd-item-container data-item=\"article\" class=\"container\"></span></div></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/dashboard.html', "<div class=\"subnav\"><h3 class=\"page-nav-title\" translate>Currently working on:</h3><div class=\"button-stack right-stack\"><div class=\"dropdown strict\" dropdown><button class=\"navbtn dropdown__toggle sd-create-btn\" dropdown__toggle></button><div class=\"dropdown__menu dropdown__menu--has-head-foot pull-right\" sd-content-create></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/full-preview.html', "<div sd-modal data-model=\"item\" data-full=\"true\" class=\"modal--fullscreen modal--preview-article modal--white\"><div class=\"modal__header modal__header--no-border\"><div class=\"btn-group pull-left\"><span sd-check ng-model=\"hide_images\" name=\"hide_images\"></span><label translate>Hide images</label></div><div class=\"btn-group pull-right\"><button ng-click=\"printPreview()\" title=\"{{'Print'|translate}}\"><i class=\"icon-print\"></i></button> <button ng-if=\"closeAction\" ng-click=\"closeAction()\" title=\"{{'Close'|translate}}\"><i class=\"icon-close-small\"></i></button></div></div><div class=\"modal__body modal-body--white\" sd-shadow><div class=\"preview-content\" ng-class=\"{'hide-images': hide_images}\"><div class=\"metadata\"><div ng-if=\"item.versioncreated\"><div class=\"preview-label\"><label translate>Last Modified</label></div><div class=\"preview-data\"><div sd-reldate-complex datetime=\"item.versioncreated\"></div></div></div><div ng-if=\"item.slugline && !editor.slugline.hideOnPrint\" order=\"{{editor.slugline.order}}\"><div class=\"preview-label\"><label translate>Slugline</label></div><div class=\"preview-data\"><span>{{item.slugline}}</span></div></div><div ng-if=\"item.anpa_category.length && !editor.anpa_category.hideOnPrint\" order=\"{{editor.anpa_category.order}}\"><div class=\"preview-label\"><label translate>Service</label></div><div class=\"preview-data\"><span ng-repeat=\"service in item.anpa_category\">{{getLocaleName(service)}}</span></div></div><div ng-if=\"item.genre.length && !editor.genre.hideOnPrint && editor.genre\" order=\"{{editor.genre.order}}\"><div class=\"preview-label\"><label translate>Genre</label></div><div class=\"preview-data\"><span ng-repeat=\"genre in item.genre\">{{getLocaleName(genre)}}</span></div></div><div ng-if=\"(item.subject | filter:{'scheme': field._id}).length && editor.subject && !editor.subject.hideOnPrint\" order=\"{{editor.subject.order}}\"><div class=\"preview-label\"><label translate>Subject</label></div><div class=\"preview-data\"><span ng-repeat=\"subject in item.subject | filter:{'scheme': field._id}\">{{getLocaleName(subject)}}</span></div></div><div ng-if=\"item.place.length && editor.place && !editor.place.hideOnPrint\" order=\"{{editor.place.order}}\"><div class=\"preview-label\"><label translate>Place</label></div><div class=\"preview-data\"><span ng-repeat=\"place in item.place\">{{getLocaleName(place)}}</span></div></div><div ng-if=\"item.ednote && !editor.ednote.hideOnPrint\" order=\"{{editor.ednote.order}}\"><div class=\"preview-label\"><label translate>Ed. Note</label></div><div class=\"preview-data\"><span>{{item.ednote}}</span></div></div><!-- custom dropdown fields saved on own field--><div ng-repeat=\"field in fields track by field._id\" ng-if=\"(item[field.schema_field] | filter:{'scheme': field._id}).length && isCustomList(field) && field.schema_field && !editor[field._id].hideOnPrint\" order=\"{{editor[field._id].order}}\"><div class=\"preview-label\"><label translate>{{field.display_name}}</label></div><div class=\"preview-data\"><span ng-repeat=\"value in item[field.schema_field] | filter:{'scheme': field._id}\">{{getLocaleName(value)}}</span></div></div><!-- custom dropdown fields saved on subject--><div ng-repeat=\"field in fields track by field._id\" ng-if=\"(item.subject | filter:{'scheme': field._id}).length && isCustomList(field) && !field.schema_field &&  !editor[field._id].hideOnPrint\" order=\"{{editor[field._id].order}}\"><div class=\"preview-label\"><label translate>{{field.display_name}}</label></div><div class=\"preview-data\"><span ng-repeat=\"value in item.subject | filter:{'scheme': field._id}\">{{getLocaleName(value)}}</span></div></div></div><div class=\"metadata\"><!-- custom date and text fields --><div ng-repeat=\"field in fields track by field._id\" ng-if=\"item.extra[field._id] && (field.field_type === 'text' || field.field_type === 'date') && !editor[field._id].hideOnPrint\" order=\"{{editor[field._id].order}}\"><div class=\"preview-label\"><label translate>{{field.display_name}}</label></div><div class=\"preview-data\" sd-short-date ng-if=\"field.field_type === 'date'\" data-date=\"item.extra[field._id]\"></div><div class=\"preview-data preview-editor\" ng-if=\"field.field_type === 'text'\" ng-bind-html=\"getHtml(item.extra[field._id])\"></div></div><div class=\"headline\" order=\"{{editor.headline.order}}\" ng-if=\"!editor.headline.hideOnPrint\">{{item.headline}}</div><!-- custom media and embed fields --><div ng-repeat=\"field in fields track by field._id\" ng-if=\"(field.field_type === 'media' && mediaExists(item.associations, field._id) || field.field_type === 'embed' && item.extra[field._id]) && !editor[field._id].hideOnPrint\" order=\"{{editor[field._id].order}}\" class=\"body preview-editor\"><div class=\"preview-label\"><label translate>{{field.display_name}}</label></div><div ng-if=\"field.field_type === 'embed' && !hide_images\" ng-bind-html=\"getHtml(item.extra[field._id].embed)\"></div><div ng-if=\"field.field_type === 'media' && !hide_images\" class=\"association\"><div ng-repeat=\"(mediaId, media) in getMediaItems(item.associations, field._id) track by mediaId\"><img src=\"{{media.renditions.viewImage.href}}\" ng-if=\"!hide_images\"><p><i class=\"icon-picture\" ng-if=\"hide_images\"></i>{{media.description_text}}</p></div></div></div><div order=\"{{editor.feature_media.order}}\" ng-if=\"!editor.feature_media.hideOnPrint\" class=\"association\"><img src=\"{{item.associations.featuremedia.renditions.viewImage.href}}\" ng-if=\"!hide_images\"><p><i class=\"icon-picture\" ng-if=\"hide_images\"></i>{{item.associations.featuremedia.description_text}}</p></div><div class=\"abstract\" order=\"{{editor.abstract.order}}\" ng-if=\"!editor.abstract.hideOnPrint\" sd-html-preview=\"item.abstract\"></div><div class=\"byline\" order=\"{{editor.byline.order}}\" ng-if=\"!editor.byline.hideOnPrint\">{{item.byline}}</div><div class=\"body preview-editor\" order=\"{{editor.dateline.order}}\" ng-if=\"!editor.dateline.hideOnPrint\">{{item.dateline.located.city}}</div><div class=\"body preview-editor\" order=\"{{editor.body_html.order}}\" ng-if=\"!editor.body_html.hideOnPrint\" sd-html-preview=\"item.body_html\" item=\"item\"></div><div class=\"body preview-editor\" order=\"{{editor.body_footer.order}}\" ng-if=\"!editor.body_footer.hideOnPrint\" sd-html-preview=\"item.body_footer\"></div><div class=\"body preview-editor\" order=\"{{editor.sign_off.order}}\" ng-if=\"!editor.sign_off.hideOnPrint\">{{item.sign_off}}</div></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/image-point.html', "<img class=\"image-point__image\" ng-src=\"{{ vm.src }}\" imageonload=\"onImageLoad()\"><div class=\"image-point__poi\"><div class=\"image-point__poi__cursor\"></div><div class=\"image-point__poi__cross-left\"></div><div class=\"image-point__poi__cross-top\"></div><div class=\"image-point__poi__cross-bottom\"></div><div class=\"image-point__poi__cross-right\"></div><div class=\"image-point__poi__overlay\"></div></div>");
        $templateCache.put('scripts/apps/authoring/views/item-actions-by-intent.html', "<ul ng-if=\"menuGroups.length\"><li ng-repeat-start=\"group in menuGroups\"></li><li class=\"dropdown__menu-divider\"></li><li><span class=\"dropdown__menu-label\" translate>{{::group._id}}</span></li><li ng-repeat=\"activity in group.actions\" sd-activity-item></li><li ng-repeat-end></li></ul>");
        $templateCache.put('scripts/apps/authoring/views/item-association.html', "<div class=\"\" ng-class=\"{'sd-media-carousel__content': related}\"><!-- if --> <button tabindex=\"{{tabindex}}\" ng-if=\"editable && associations.isMediaEditable() && !related\" ng-click=\"upload()\" ng-class=\"{'item-association--loading': loading}\" class=\"item-association\"><span class=\"item-association__text-label\">{{'Drop items here or click to upload' | translate}}</span></button><!-- else --><figure ng-if=\"!(editable && associations.isMediaEditable() && !related)\" class=\"item-association\" ng-class=\"{'item-association--preview': related, 'item-association--loading': loading}\"><a ng-if=\"related && editable\" class=\"item-association__remove-item\" ng-click=\"remove(related); $event.stopPropagation()\"><i class=\"icon-close-small\"></i> </a><!-- video --><div class=\"item-association__video-container\" ng-if=\"related && related.type === 'video'\"><video controls><source vsrc=\"{{ rendition.href}}\" ng-repeat=\"(key, rendition) in related.renditions\" ng-if=\"associations.isVideo(rendition)\" html5vfix></video><div class=\"item-association__metadata\" sd-media-metadata-view data-item=\"related\"></div><div class=\"item-association__action-bar\" ng-if=\"related && editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related); $event.stopPropagation()\"><span translate>Edit metadata</span></a></div></div><!-- audio --><div class=\"item-association__audio-container\" ng-if=\"related && related.type === 'audio'\"><audio controls><source vsrc=\"{{ rendition.href}}\" ng-repeat=\"(key, rendition) in related.renditions\" ng-if=\"associations.isAudio(rendition)\" html5vfix></audio><div class=\"item-association__metadata\" sd-media-metadata-view data-item=\"related\"></div><div class=\"item-association__action-bar\" ng-if=\"related && editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related); $event.stopPropagation()\"><span translate>Edit metadata</span></a></div></div><!-- image --><div class=\"item-association__image-container\" ng-if=\"related && (related.type === 'picture' || related.type === 'graphic')\"><div class=\"item-association__image-overlay\"><div class=\"item-association__metadata item-association__metadata--top-overlay\"><span><em>{{:: 'Title:' | translate}}</em> {{related.headline || ('[No Value]' | translate)}}</span></div><div ng-hide=\"related._type === 'externalsource' || related.fetch_endpoint\" class=\"item-association__icons-block\"><a ng-if=\"related && editable\" class=\"item-association__image-action\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related, {defaultTab: 'view'}); $event.stopPropagation()\" sd-tooltip=\"Edit metadata\"><i class=\"icon-pencil\"></i></a> <a ng-if=\"related && editable\" class=\"item-association__image-action\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related, {defaultTab: 'image-edit'}); $event.stopPropagation()\" sd-tooltip=\"Edit image\"><i class=\"icon-switches\"></i></a> <a ng-if=\"related && editable\" class=\"item-association__image-action\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related, {defaultTab: 'crop'}); $event.stopPropagation()\" sd-tooltip=\"Edit crops\"><i class=\"icon-crop\"></i></a></div><div sd-media-metadata-view data-item=\"related\" data-show-alt-text=\"true\" class=\"item-association__metadata item-association__metadata--bottom-overlay\" ng-if=\"related.type === 'picture' || related.type === 'graphic'\"></div></div><img ng-src=\"{{ related.renditions.viewImage.href}}\" ng-class=\"{'not-editable': !associations.isMediaEditable() || !editable}\" ng-click=\"associations.isMediaEditable() && associations.edit(this, related); $event.stopPropagation()\"></div></figure><!-- if/else end --><div contenteditable=\"{{editable}}\" sd-auto-height tansa-scope-sync ng-model=\"related.headline\" ng-model-options=\"{debounce: 1000}\" ng-change=\"onMetadataChange('headline')\" sd-placeholder=\"{{:: 'Add title' | translate}}\" ng-if=\"related && showTitle\" class=\"sd-media-carousel__media-title\"></div><div contenteditable=\"{{editable}}\" sd-auto-height tansa-scope-sync ng-model=\"related.description_text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"onMetadataChange('description_text')\" sd-placeholder=\"{{:: 'Add caption' | translate}}\" ng-if=\"related\" class=\"sd-media-carousel__media-caption\"></div></div>");
        $templateCache.put('scripts/apps/authoring/views/item-carousel.html', "<button tabindex=\"{{tabindex}}\" class=\"item-association\" ng-if=\"!carouselItems.length\" ng-class=\"{'item-association--preview': item[item.fieldId], 'item-association--loading': loading}\" ng-click=\"editable && associations.isMediaEditable() && !item[item.fieldId] && upload()\"><span class=\"item-association__text-label\">{{'Drop items here or click to upload' | translate}}</span></button><div class=\"sd-media-carousel\" ng-if=\"carouselItems.length\"><div class=\"sd-media-carousel__dialog\"><a ng-click=\"navPrev()\" class=\"sd-media-carousel__nav-button sd-media-carousel__nav-button--prev-inner\"></a> <a ng-click=\"navNext()\" class=\"sd-media-carousel__nav-button sd-media-carousel__nav-button--next-inner\"></a><div class=\"sd-media-carousel__content owl-carousel\"><div class=\"sd-media-carousel__page\" ng-repeat=\"item in carouselItems\"><figure class=\"item-association\" ng-class=\"{'item-association--preview': item[item.fieldId], 'item-association--loading': loading}\" ng-click=\"editable && associations.isMediaEditable() && !item[item.fieldId] && upload()\"><a ng-if=\"item[item.fieldId] && editable\" class=\"item-association__remove-item\" ng-click=\"remove(item); $event.stopPropagation()\"><i class=\"icon-close-small\"></i> </a><!-- video --><div class=\"item-association__video-container\" ng-if=\"item[item.fieldId] && item[item.fieldId].type === 'video'\"><video controls><source vsrc=\"{{rendition.href}}\" ng-repeat=\"(key, rendition) in item[item.fieldId].renditions\" ng-if=\"associations.isVideo(rendition)\" html5vfix></video><div class=\"item-association__metadata item-association__metadata--plain\"><span><em>{{:: 'Credit:' | translate}}</em> {{item[item.fieldId].byline || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright holder:' | translate}}</em> {{item[item.fieldId].copyrightholder || ('[No Value]' | translate)}} </span><span><em>{{:: 'Assign rights:' | translate}}</em> {{item[item.fieldId].usageterms || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright notice:' | translate}}</em> {{item[item.fieldId].copyrightnotice || ('[No Value]' | translate)}}</span></div><div class=\"item-association__action-bar\" ng-if=\"item[item.fieldId] && editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"associations.isMediaEditable() && associations.edit(this, item[item.fieldId]); $event.stopPropagation()\"><span translate>Edit metadata</span></a></div></div><!-- audio --><div class=\"item-association__audio-container\" ng-if=\"item[item.fieldId] && item[item.fieldId].type === 'audio'\"><audio controls><source vsrc=\"{{rendition.href}}\" ng-repeat=\"(key, rendition) in item[item.fieldId].renditions\" ng-if=\"associations.isAudio(rendition)\" html5vfix></audio><div class=\"item-association__metadata item-association__metadata--plain\"><span><em>{{:: 'Credit:' | translate}}</em> {{item[item.fieldId].byline || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright holder:' | translate}}</em> {{item[item.fieldId].copyrightholder || ('[No Value]' | translate)}} </span><span><em>{{:: 'Assign rights:' | translate}}</em> {{item[item.fieldId].usageterms || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright notice:' | translate}}</em> {{item[item.fieldId].copyrightnotice || ('[No Value]' | translate)}}</span></div><div class=\"item-association__action-bar\" ng-if=\"item[item.fieldId] && editable\"><a class=\"btn btn--hollow btn--small\" ng-click=\"associations.isMediaEditable() && associations.edit(this, item[item.fieldId]); $event.stopPropagation()\"><span translate>Edit metadata</span></a></div></div><!-- image --><div class=\"item-association__image-container\" ng-if=\"item[item.fieldId] && (item[item.fieldId].type === 'picture' || item[item.fieldId].type === 'graphic')\"><div class=\"item-association__image-overlay\" ng-if=\"item[item.fieldId]\"><div class=\"item-association__metadata item-association__metadata--top-overlay\"><span><em>{{:: 'Title:' | translate}}</em> {{item[item.fieldId].headline || ('[No Value]' | translate)}}</span></div><div class=\"item-association__icons-block\"><a class=\"item-association__image-action\" ng-if=\"item[item.fieldId] && editable\" ng-click=\"associations.isMediaEditable() && associations.edit(this, item[item.fieldId], {defaultTab: 'view'}); $event.stopPropagation()\" sd-tooltip=\"Edit metadata\"><i class=\"icon-pencil\"></i></a> <a class=\"item-association__image-action\" ng-if=\"item[item.fieldId] && editable\" ng-click=\"associations.isMediaEditable() && associations.edit(this, item[item.fieldId], {defaultTab: 'image-edit'}); $event.stopPropagation()\" sd-tooltip=\"Edit image\"><i class=\"icon-switches\"></i></a> <a class=\"item-association__image-action\" ng-if=\"item[item.fieldId] && editable\" ng-click=\"associations.isMediaEditable() && associations.edit(this, item[item.fieldId], {defaultTab: 'crop', showMetadata: false}); $event.stopPropagation()\" sd-tooltip=\"Edit crops\"><i class=\"icon-crop\"></i></a></div><div class=\"item-association__metadata item-association__metadata--bottom-overlay\"><span><em>{{:: 'Alt text:' | translate}}</em> {{item[item.fieldId].alt_text || ('[No Value]' | translate)}} </span><span><em>{{:: 'Credit:' | translate}}</em> {{item[item.fieldId].byline || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright holder:' | translate}}</em> {{item[item.fieldId].copyrightholder || ('[No Value]' | translate)}} </span><span><em>{{:: 'Assign rights:' | translate}}</em> {{item[item.fieldId].usageterms || ('[No Value]' | translate)}} </span><span><em>{{:: 'Copyright notice:' | translate}}</em> {{item[item.fieldId].copyrightnotice || ('[No Value]' | translate)}}</span></div></div><img ng-src=\"{{ item[item.fieldId].renditions.viewImage.href}}\" ng-class=\"{'not-editable': !associations.isMediaEditable() || !editable}\"></div></figure><div contenteditable=\"{{editable}}\" sd-auto-height tansa-scope-sync ng-model=\"item[item.fieldId].headline\" ng-model-options=\"{debounce: 1000}\" ng-change=\"onchange()\" sd-placeholder=\"Add title\" ng-if=\"item[item.fieldId] && showTitle\" class=\"sd-media-carousel__media-title\"></div><div contenteditable=\"{{editable}}\" sd-auto-height tansa-scope-sync ng-model=\"item[item.fieldId].description_text\" ng-model-options=\"{debounce: 1000}\" ng-change=\"onchange()\" sd-placeholder=\"Add caption\" ng-if=\"item[item.fieldId]\" class=\"sd-media-carousel__media-caption\"></div><div sd-item-crops data-item=\"item.associations[fieldVersion.fieldId]\" ng-if=\"editor[field._id].showCrops && features.editFeaturedImage &&\n" +
            "                                    !!field.field_options.allowed_types.picture\"></div></div></div><div class=\"sd-media-carousel__thumb-strip\"><div class=\"sd-media-carousel__thumb-strip-item\" ng-repeat=\"item in carouselItems\"><div class=\"sd-media-carousel__thumb\" ng-click=\"goTo($index)\" ng-if=\"item[item.fieldId] && item[item.fieldId].type === 'picture'\"><img ng-src=\"{{item[item.fieldId].renditions.thumbnail.href}}\"></div><div class=\"sd-media-carousel__thumb\" ng-click=\"goTo($index)\" ng-if=\"item[item.fieldId] && item[item.fieldId].type === 'audio'\"><i class=\"icon--2x icon-audio\"></i></div><div class=\"sd-media-carousel__thumb\" ng-click=\"goTo($index)\" ng-if=\"item[item.fieldId] && item[item.fieldId].type === 'video'\"><i class=\"icon--2x icon-video\" ng-if=\"!item[item.fieldId].renditions.thumbnail\"></i> <img ng-if=\"item[item.fieldId] && item[item.fieldId].renditions.thumbnail\" ng-src=\"{{item[item.fieldId].renditions.thumbnail.href}}\"></div></div><div class=\"sd-media-carousel__thumb sd-media-carousel__thumb--add\" ng-click=\"upload()\" data-rel=\"{{item.fieldId}}\" ng-if=\"carouselItems.length < maxUploads\"><i class=\"icon-plus-sign\"></i></div></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/opened-articles.html', "<div class=\"opened-articles\"><div class=\"quick-actions pull-left\"><button ng-click=\"openDashboard()\" title=\"{{ :: 'All opened items' | translate }}\"><i class=\"icon-th-large icon--white\"></i></button></div><ul ng-if=\"workqueue.items.length\" class=\"list\" ng-class=\"{'full-width': !multiEdit.items.length}\"><li ng-repeat=\"article in workqueue.items track by article._id\" ng-class=\"{active: article === active}\" style=\"width:{{ 100 / workqueue.items.length }}%\"><a class=\"title\" ng-click=\"edit(article, $event)\" ng-href=\"{{ :: link(article) }}\"><span ng-show=\"article.headline || article.slugline\">{{ (article.headline || article.slugline) | stripHtmlTags }}</span> <span ng-show=\"!article.headline && !article.slugline\" translate>Untitled</span> </a><button class=\"close\" ng-click=\"closeItem(article)\"><i class=\"icon-close-small icon--white\"></i></button></li></ul><ul ng-if=\"multiEdit.items.length\" class=\"multiedit-item\"><li ng-class=\"{active: isMultiedit}\"><a ng-href=\"\" class=\"title\" ng-click=\"openMulti()\"><span translate>Multiedit</span> </a><button class=\"close\" ng-click=\"closeMulti()\"><i class=\"icon-close-small icon--white\"></i></button></li></ul></div><div sd-dashboard-articles data-active=\"dashboardActive\" data-close-dashboard=\"closeDashboard()\" data-close-item=\"closeItem(item)\" data-edit=\"edit(item, event)\" data-link=\"link(item)\" data-items=\"workqueue.items\"></div>");
        $templateCache.put('scripts/apps/authoring/views/preview-formatted.html', "<div sd-modal data-model=\"previewFormatted\" data-close=\"closePreviewFormatted()\" class=\"modal--large\"><div class=\"modal__header\"><a href=\"\" class=\"modal__close pull-right\" ng-click=\"closePreviewFormatted()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Preview Formatted Story</h3></div><div class=\"modal__body\" ng-loading=\"loading\"><div class=\"form__row form__row--flex\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Formatters' | translate }}</label><select ng-model=\"selectedFormatter\" class=\"sd-line-input__select\"><option value=\"{{formatter}}\" ng-repeat=\"formatter in previewFormatters\">{{:: formatter.name}}</option></select></div><button class=\"btn btn--primary\" ng-click=\"format(selectedFormatter)\" translate>Format</button></div><div class=\"form__row form__row--flex\"><div class=\"sd-line-input\"><textarea rows=\"6\" ng-model=\"formattedItem\" class=\"sd-line-input__input sd-line-input__input--formatted-preview\"></textarea></div></div></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"closePreviewFormatted()\" translate>Close</button></div></div>");
        $templateCache.put('scripts/apps/authoring/views/sd-highlight-create.html', "<li ng-repeat=\"highlight_config in highlight_configs\"><button ng-click=\"content.createHighlight(highlight_config)\"><i class=\"icon-plus-small icon-round icon--white\"></i> {{ :: highlight_config.name }}</button></li>");
        $templateCache.put('scripts/apps/authoring/views/send-item.html', "<div class=\"sd-overlay-panel sd-overlay-panel--dark-ui\" ng-show=\"isActive && !isSendToNextStage\" ng-class=\"{'sd-overlay-panel--open': isActive, 'sd-overlay-panel--large' : currentUserAction === vm.userActions.publish && vm.userActions.publish_pane_two_columns}\"><div class=\"side-panel side-panel--shadow-right side-panel--dark-ui\"><div class=\"side-panel__header\"><ul class=\"nav-tabs nav-tabs--ui-dark nav-tabs--big\"><li id=\"panel-send\" class=\"nav-tabs__tab {{currentUserAction === vm.userActions.send_to ? 'nav-tabs__tab--active' : ''}}\" ng-show=\"canSendItem() && isSendEnabled() && currentUserAction !== vm.userActions.duplicate_to\"><button ng-click=\"setUserAction(vm.userActions.send_to)\" class=\"nav-tabs__link\" translate>Send to</button></li><li id=\"panel-publish\" class=\"nav-tabs__tab {{currentUserAction === vm.userActions.publish ? 'nav-tabs__tab--active' : ''}}\" ng-show=\"canPublishItem()\"><button ng-click=\"setUserAction(vm.userActions.publish)\" class=\"nav-tabs__link\" translate>Publish</button></li><li id=\"panel-fetch\" class=\"nav-tabs__tab {{currentUserAction === vm.userActions.send_to ? 'nav-tabs__tab--active' : ''}}\" ng-show=\"!canSendItem() && !canPublishItem() && currentUserAction === vm.userActions.send_to\"><button class=\"nav-tabs__link\" translate>Fetch To</button></li><li id=\"panel-duplicate\" class=\"nav-tabs__tab {{currentUserAction === vm.userActions.duplicate_to ? 'nav-tabs__tab--active' : ''}}\" ng-show=\"!canPublishItem() && currentUserAction === vm.userActions.duplicate_to\"><button class=\"nav-tabs__link\" translate>Duplicate To</button></li><li id=\"panel-externalsource\" class=\"nav-tabs__tab {{currentUserAction === vm.userActions.externalsource_to ? 'nav-tabs__tab--active' : ''}}\" ng-show=\"!canSendItem() && !canPublishItem() && currentUserAction === vm.userActions.externalsource_to\"><button class=\"nav-tabs__link\" translate>Fetch To</button></li></ul><div class=\"side-panel__tools\"><a class=\"icn-btn\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></a></div></div><!-- Content Send To--><div class=\"side-panel__content\" ng-if=\"currentUserAction === vm.userActions.send_to || currentUserAction === vm.userActions.duplicate_to || currentUserAction === vm.userActions.externalsource_to\"><div class=\"side-panel__content-block\"><div sd-toggle-box ng-if=\"showSendButtonAndDestination()\" data-title=\"{{ currentUserAction === vm.userActions.publish ? 'From' : 'Destination' | translate }}\" data-open=\"true\" data-style=\"circle\"><div class=\"form__row form__row--no-padding form__row--desk-select\"><div sd-desk-select data-desks=\"desks\" data-selected-desk=\"selectedDesk\" on-change=\"selectDesk(desk)\"></div></div><ul class=\"btn-list\" ng-if=\"stages && !(vm.userActions.publish === currentUserAction)\"><li ng-repeat=\"stage in stages track by stage._id\" ng-if=\"!disableFetchAndOpenButton() || stage.is_visible\"><button class=\"btn__check\" ng-class=\"{active: stage._id === selectedStage._id}\" ng-disabled=\"mode !== 'spike' && stage._id === item.task.stage\" ng-click=\"selectStage(stage)\">{{::stage.name}}</button></li></ul></div><div sd-toggle-box id=\"embargoTimestamp\" ng-if=\"mode === 'authoring' && showEmbargo()\" data-title=\"{{ 'Embargo' | translate }}\" data-open=\"true\" data-style=\"circle\"><ul class=\"btn-list\"><li class=\"datepicker-input--dark\"><div sd-datepicker ng-model=\"item.embargo_date\"></div></li><li class=\"timepicker-input--dark\"><div sd-timepicker ng-model=\"item.embargo_time\"></div></li></ul><a class=\"toggle-box__button\" ng-click=\"item.embargo_date=null; item.embargo_time=null;\" sd-hotkey=\"ctrl+shift+x\" ng-if=\"item.embargo_date || item.embargo_time\"><i class=\"icon-remove-sign icon--white\"></i>{{ :: 'Clear embargo' | translate }}</a></div><div sd-toggle-box id=\"publishScheduleTimestamp\" ng-if=\"mode === 'authoring' && showPublishSchedule()\" data-title=\"{{ 'Publishing Schedule' | translate }}\" data-open=\"true\" data-style=\"circle\"><ul class=\"btn-list\"><li class=\"datepicker-input--dark\"><div sd-datepicker ng-model=\"item.publish_schedule_date\" ng-disabled=\"!_editable\"></div></li><li class=\"timepicker-input--dark\"><div sd-timepicker ng-model=\"item.publish_schedule_time\" ng-disabled=\"!_editable\"></div></li></ul><a class=\"toggle-box__button\" ng-click=\"item.publish_schedule_date=null; item.publish_schedule_time=null;\" sd-hotkey=\"ctrl+shift+x\" ng-if=\"item.publish_schedule_date || item.publish_schedule_time\"><i class=\"icon-remove-sign\"></i>{{ :: 'Clear schedule' | translate }}</a></div><div sd-toggle-box id=\"timezoneTimestamp\" ng-if=\"mode === 'authoring' && showTimezone()\" data-title=\"Timezone\" data-open=\"true\" data-style=\"circle\"><div sd-timezone data-timezone=\"item.time_zone\" class=\"timezone-input--dark\"></div></div></div></div><!-- ///////////////// PUBLISH /////////////////////// --><!-- Content Publish--><div class=\"side-panel__content\" ng-if=\"currentUserAction === vm.userActions.publish\" ng-class=\"{'side-panel__content--split': vm.userActions.publish_pane_two_columns}\"><div class=\"side-panel__content-block side-panel__content-block--left\"><div sd-toggle-box ng-if=\"showSendButtonAndDestination()\" data-title=\"{{ currentUserAction === vm.userActions.publish ? 'From' : 'Destination' | translate }}\" data-open=\"true\" data-style=\"circle\"><div class=\"form__row form__row--no-padding form__row--desk-select\"><div sd-desk-select data-desks=\"desks\" data-selected-desk=\"selectedDesk\" on-change=\"selectDesk(desk)\"></div></div></div><div sd-toggle-box id=\"embargoTimestamp\" ng-if=\"mode === 'authoring' && showEmbargo()\" data-title=\"{{ 'Embargo' | translate }}\" data-open=\"true\" data-style=\"circle\"><ul class=\"btn-list\"><li class=\"datepicker-input--dark\"><div sd-datepicker ng-model=\"item.embargo_date\"></div></li><li class=\"timepicker-input--dark\"><div sd-timepicker ng-model=\"item.embargo_time\"></div></li></ul><a class=\"toggle-box__button\" ng-click=\"item.embargo_date=null; item.embargo_time=null;\" sd-hotkey=\"ctrl+shift+x\" ng-if=\"item.embargo_date || item.embargo_time\"><i class=\"icon-remove-sign\"></i>{{ :: 'Clear embargo' | translate }}</a></div><div sd-toggle-box id=\"publishScheduleTimestamp\" ng-if=\"mode === 'authoring' && showPublishSchedule()\" data-title=\"{{ 'Publish Schedule' | translate }}\" data-open=\"true\" data-style=\"circle\"><ul class=\"btn-list\"><li class=\"datepicker-input--dark\"><div sd-datepicker ng-model=\"item.publish_schedule_date\" ng-disabled=\"!_editable\"></div></li><li class=\"timepicker-input--dark\"><div sd-timepicker ng-model=\"item.publish_schedule_time\" ng-disabled=\"!_editable\"></div></li></ul><a class=\"toggle-box__button\" ng-click=\"item.publish_schedule_date=null; item.publish_schedule_time=null;\" sd-hotkey=\"ctrl+shift+x\" ng-if=\"item.publish_schedule_date || item.publish_schedule_time\"><i class=\"icon-remove-sign\"></i>{{ :: 'Clear schedule' | translate }}</a></div><div sd-toggle-box id=\"timezoneTimestamp\" ng-if=\"mode === 'authoring' && showTimezone()\" data-title=\"Timezone\" data-open=\"true\" data-style=\"circle\"><div sd-timezone data-timezone=\"item.time_zone\" class=\"timezone-input--dark\"></div></div><div sd-toggle-box id=\"target\" data-title=\"Target\" data-open=\"true\" data-style=\"circle\"><div class=\"form__row\"><label class=\"form-label\" translate>Target Subscribers</label><div class=\"term-editor\" sd-meta-terms data-item=\"item\" data-unique=\"_id\" data-list=\"metadata.customSubscribers\" data-field=\"target_subscribers\" data-header=\"true\" ng-disabled=\"!_editable\" data-change=\"autosave(item)\" data-reload-list=\"true\"></div></div><div class=\"form__row\"><label class=\"form-label\" translate>Target Regions</label><div sd-meta-target data-list=\"metadata.regions\" data-autosave=\"autosave(item)\" ng-disabled=\"!_editable\" data-targets=\"item.target_regions\"></div></div><div class=\"form__row\"><label class=\"form-label\" translate>Target Types</label><div sd-meta-target data-list=\"metadata.subscriberTypes\" data-autosave=\"autosave(item)\" ng-disabled=\"!_editable\" data-targets=\"item.target_types\"></div></div></div></div><div ng-if=\"vm.userActions.publish_pane_two_columns\" class=\"side-panel__content-block side-panel__content-block--right\"><div sd-extension-point=\"authoring:publish\" ng-if=\"canPublishItem() && currentUserAction === vm.userActions.publish\"></div></div></div><!-- Footer Send To--><div class=\"side-panel__footer side-panel__footer--button-box-large\" ng-if=\"currentUserAction === vm.userActions.send_to\"><button class=\"btn btn--large btn--primary btn--hollow btn--expanded\" ng-show=\"showSendButtonAndDestination() && mode !== 'spike' && mode !== 'authoring'\" ng-click=\"send(true)\" ng-disabled=\"disableFetchAndOpenButton()\">{{!canSendItem() ? 'fetch and open' : 'send and open' | translate}}</button> <button class=\"btn btn--large btn--primary btn--expanded\" ng-show=\"showSendButtonAndDestination()\" ng-click=\"send()\" ng-disabled=\"disableSendButton()\">{{!canSendItem() ? 'fetch' : 'send' | translate}}</button> <button class=\"btn btn--large btn--primary btn--expanded\" ng-if=\"showSendButtonAndDestination() && isPackage\" ng-click=\"send(false, true)\" ng-disabled=\"disableSendButton()\" translate>send package and items</button></div><!-- Footer Duplicate To--><div class=\"side-panel__footer side-panel__footer--button-box-large\" ng-if=\"currentUserAction === vm.userActions.duplicate_to\"><button id=\"duplicate-open-btn\" class=\"btn btn--large btn--hollow btn--expanded btn--ui-dark\" ng-show=\"showSendButtonAndDestination() && !canSendItem()\" ng-click=\"send(true)\" ng-disabled=\"disableFetchAndOpenButton()\" translate>duplicate and open</button> <button id=\"duplicate-btn\" class=\"btn btn--large btn--primary btn--expanded\" ng-show=\"showSendButtonAndDestination()\" ng-click=\"send()\" ng-disabled=\"disableSendButton()\" translate>duplicate</button></div><!-- Footer Fetch To--><div class=\"side-panel__footer side-panel__footer--button-box-large\" ng-if=\"currentUserAction === vm.userActions.externalsource_to\"><button id=\"externalsource-open-btn\" class=\"btn btn--large btn--primary btn--hollow btn--expanded\" ng-show=\"showSendButtonAndDestination() && !canSendItem()\" ng-click=\"send(true)\" ng-disabled=\"disableFetchAndOpenButton()\" translate>fetch and open</button> <button id=\"externalsource-btn\" class=\"btn btn--large btn--primary btn--expanded\" ng-show=\"showSendButtonAndDestination()\" ng-click=\"send()\" ng-disabled=\"disableSendButton()\" translate>fetch</button></div><!-- Footer Publish--><div class=\"side-panel__footer side-panel__footer--button-box-large\" ng-if=\"currentUserAction === vm.userActions.publish\"><div class=\"side-panel__footer-buttons--flex\"><button type=\"button\" class=\"btn btn--large btn--ui-dark btn--hollow btn--expanded\" ng-show=\"subscribersWithPreviewConfigured.length > 0\" ng-click=\"preview()\" translate>Preview</button> <button type=\"submit\" class=\"btn btn--large btn--primary btn--hollow btn--expanded btn--ui-dark\" ng-show=\"isSendEnabled() && showSendButtonAndDestination() && _editable\" ng-click=\"sendAndPublish()\" ng-disabled=\"!canSendAndPublish()\" translate>publish from</button></div><button type=\"submit\" class=\"btn btn--large btn--highlight btn--expanded\" ng-show=\"canSendItem() && canPublishItem() && _editable\" ng-click=\"publish()\" ng-disabled=\"canSendAndPublish()\">{{_action === 'edit' ? 'publish' : _action | translate}}</button></div></div></div>");
        $templateCache.put('scripts/apps/authoring/views/theme-select.html', "<button class=\"icn-btn\" ng-click=\"modalEditorConfig = true\"><i class=\"icon-switches\"></i></button><!-- Editor configuration modal --><div sd-modal data-model=\"modalEditorConfig\" class=\"modal--x-large\"><div class=\"modal__header\"><button class=\"modal__close pull-right icn-btn\" ng-click=\"closeModal()\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\">{{ :: 'Configure Editor themes' | translate }}</h3></div><div class=\"modal__body modal__body--no-padding\"><div class=\"sd-column-box--2\"><div class=\"sd-column-box__main-column sd-column-box__main-column--left sd-column-box__main-column--padded\"><h2 class=\"modal__body-heading\"><span class=\"badge badge--success\">&nbsp;</span>{{ :: 'Default Theme' | translate }}</h2><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--no-margin sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Font' | translate }}</label><select class=\"sd-line-input__select\" ng-model=\"themePref.font\"><option ng-repeat=\"font in themes.fonts track by font.key\" ng-value=\"font.key\">{{font.label}}</option></select></div></div><div class=\"color-swatch__list\"><div ng-repeat=\"color in themes.colors track by color.key\" class=\"color-swatch sd-editor--theme-{{color.key}}\" ng-click=\"pickTheme('themePref', color.key)\" ng-class=\"{'color-swatch--selected' : themePref.theme === color.key}\"><span class=\"color-swatch__inner\">a</span></div></div><div class=\"theme-preview sd-editor--theme-{{themePref.theme}} sd-editor--font-{{themePref.font}} sd-editor--headline-{{themePref.headline}} sd-editor--abstract-{{themePref.abstract}} sd-editor--body-{{themePref.body}}\"><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Headline' | translate }}</label><div class=\"theme-preview__text-field text-field__headline\">{{ :: 'This is the headline' | translate }}</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"themePref['headline']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Abstract' | translate }}</label><div class=\"theme-preview__text-field text-field__abstract\">{{ :: 'Abstract example' | translate }}. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Phasellus ullamcorper…</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"themePref['abstract']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Body' | translate }}</label><div class=\"theme-preview__text-field text-field__body\">{{ :: 'Body text example' | translate }}. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Phasellus ullamcorper…</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"themePref['body']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div></div></div><div class=\"sd-column-box__main-column sd-column-box__main-column--right sd-column-box__main-column--padded\"><h2 class=\"modal__body-heading modal__body-heading--inactive\"><span class=\"badge badge--light\">&nbsp;</span>{{ :: 'Proofread Theme' | translate }}</h2><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--no-margin sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Font' | translate }}</label><select class=\"sd-line-input__select\" ng-model=\"proofreadThemePref.font\"><option ng-repeat=\"font in themes.fonts track by font.key\" ng-value=\"font.key\">{{font.label}}</option></select></div></div><div class=\"color-swatch__list\"><div ng-repeat=\"color in themes.colors track by color.key\" class=\"color-swatch sd-editor--theme-{{color.key}}\" ng-click=\"pickTheme('proofreadThemePref', color.key)\" ng-class=\"{'color-swatch--selected' : proofreadThemePref.theme === color.key}\"><span class=\"color-swatch__inner\">a</span></div></div><div class=\"theme-preview sd-editor--theme-{{proofreadThemePref.theme}} sd-editor--font-{{proofreadThemePref.font}} sd-editor--headline-{{proofreadThemePref.headline}} sd-editor--abstract-{{proofreadThemePref.abstract}} sd-editor--body-{{proofreadThemePref.body}}\"><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Headline' | translate }}</label><div class=\"theme-preview__text-field text-field__headline\">{{ :: 'This is the headline' | translate }}</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"proofreadThemePref['headline']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Abstract' | translate }}</label><div class=\"theme-preview__text-field text-field__abstract\">{{ :: 'Abstract example' | translate }}. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Phasellus ullamcorper…</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"proofreadThemePref['abstract']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div><div class=\"theme-preview__block\"><label class=\"theme-preview__label\">{{ :: 'Body' | translate }}</label><div class=\"theme-preview__text-field text-field__body\">{{ :: 'Body text example' | translate }}. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce id purus. Phasellus ullamcorper…</div><div class=\"theme-preview__button-bar\"><sd-check type=\"radio\" ng-repeat=\"size in themes.sizes track by size.key\" ng-model=\"proofreadThemePref['body']\" label-position=\"inside\" ng-value=\"{{size.key}}\">{{size.label}}</sd-check></div></div></div></div></div></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"closeModal()\">{{ :: 'Cancel' | translate }}</button> <button class=\"btn btn--primary\" ng-click=\"saveTheme()\">{{ :: 'Save' | translate }}</button></div></div><!-- END Editor configuration modal -->");
        $templateCache.put('scripts/apps/authoring/widgets/views/authoring-widgets.html', "<div class=\"widget-wrapper\" ng-class=\"{\n" +
            "        'active-right': active,\n" +
            "        'right-extended': active.extended\n" +
            "    }\"><div class=\"sd-sidetab-menu sd-sidetab-menu--right\" ng-if=\"item\"><ul class=\"navigation-tabs\"><li ng-repeat=\"widget in widgets | orderBy:'order'\" ng-class=\"{active: widget === active}\"><a class=\"sd-sidetab-menu__btn\" type=\"submit\" ng-click=\"activate(widget)\" ng-disabled=\"isWidgetLocked(widget)\" id=\"{{ :: widget._id }}\" sd-tooltip=\"{{ :: widget.label | translate}} ({{generateHotkey($index+1, true)}})\" flow=\"left\" sd-hotkey=\"{{generateHotkey($index+1)}}\" sd-hotkey-options=\"{global: true}\"><span id=\"unread-count\" class=\"sd-sidetab-menu__info-label badge badge--primary\" ng-show=\"widget._id == 'comments' && comments.length\">{{ comments.length }}</span> <span class=\"sd-sidetab-menu__info-label badge badge--primary\" ng-if=\"badge(widget)\">{{ badge(widget) }}</span> <i class=\"sd-sidetab-menu__main-icon big-icon--{{ :: widget.icon }}\"></i> <i class=\"sd-sidetab-menu__helper-icon icon-close-small\"></i></a></li></ul></div><div class=\"tabpane right-tabpane open-tabpane widget-{{active._id}}\" ng-if=\"active && !isWidgetLocked(active)\"><section class=\"tabcontent\" ng-init=\"widget=active\"><div sd-widget data-widget=\"active\" data-configurable=\"active.configurable\" data-save=\"active.save()\"><div ng-include=\"active.template\"></div></div></section></div><div ng-transclude></div></div>");
        $templateCache.put('scripts/apps/contacts/views/list.html', "<div class=\"subnav subnav--top\"><header class=\"search-page-header\"><div sd-item-searchbar class=\"searchbar-flex-handler\"></div><div sd-contacts-sort-bar data-total=\"total\" class=\"sortbar-flex-handler\"></div><div class=\"view-select\"><button sd-tooltip=\"{{ :: 'Switch to grid view' | translate }}\" flow=\"left\" ng-show=\"view !== 'photogrid'\" ng-click=\"setView('photogrid')\"><i class=\"icon-th\"></i></button> <button sd-tooltip=\"{{ :: 'Switch to list view' | translate }}\" flow=\"left\" ng-show=\"view !== 'compact'\" ng-click=\"setView('compact')\"><i class=\"icon-th-list\"></i></button></div><div ng-if=\"privileges.contacts\" sd-tooltip=\"{{ :: 'Create contact' | translate }}\" flow=\"left\"><button class=\"navbtn dropdown__toggle sd-create-btn\" ng-click=\"createContact()\" dropdown__toggle></button></div></header></div><div class=\"subnav subnav--top\"><header class=\"search-page-header\"><div class=\"filter-trigger\" title=\"{{ :: 'Filters' | translate }}\" ng-click=\"openAdvanceSearch = !openAdvanceSearch\" ng-class=\"{'filter-trigger--active': openAdvanceSearch}\"><i class=\"icon-filter-large\"></i></div><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown__toggle>{{ :: 'Privacy Level:' | translate }} {{filters.selectedPrivacy.name}} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu\"><li ng-repeat=\"option in filters.privacyOptions track by option.value\"><button ng-click=\"filterContacts('public', option)\">{{option.name}}</button></li></ul></div><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown__toggle>{{ :: 'Status:' | translate }} {{filters.selectedStatus.name}} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu\"><li ng-repeat=\"option in filters.statusOptions track by option.value\"><button ng-click=\"filterContacts('is_active', option)\">{{option.name}}</button></li></ul></div></header></div><section class=\"main-section search-page-container contacts-section\" ng-class=\"{'sidebar-open': openAdvanceSearch}\"><div sd-contacts-search-panel data-items=\"items\" class=\"archive-sidebar\"></div><div sd-contacts-search-results class=\"archive-content\"></div></section>");
        $templateCache.put('scripts/apps/contacts/views/search-panel.html', "<div id=\"contacts-search-panel\"><div class=\"header\"><ul><li translate>Search</li></ul><div class=\"doopen\" ng-click=\"openAdvanceSearch = !openAdvanceSearch\"><i class=\"icon-close-small\"></i></div></div><div class=\"nav-tabs__content content\"><div class=\"nav-tabs__pane\"><form><fieldset class=\"search-parameters\"><div class=\"field multiple\"><div class=\"field\"><label for=\"search-fname\" translate>First Name</label><div class=\"control\"><input type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-fname\" ng-model=\"meta.first_name\"></div></div><div class=\"field\"><label for=\"search-lname\" translate>Last Name</label><div class=\"control\"><input type=\"text\" id=\"search-lname\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.last_name\"></div></div></div><div id=\"org-field\"></div><div class=\"field\"><label for=\"search-job_title\" translate>Job Title</label><select ng-model=\"meta.job_title\" name=\"job_title\" id=\"job_title\" ng-options=\"job.name as job.name for job in metadata.contact_job_titles | orderBy:'name'\"></select></div><div class=\"field\"><label for=\"search-postcode\" translate>Email</label><div class=\"control\"><input type=\"text\" id=\"search-email\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.contact_email\"></div></div><div class=\"field\"><label for=\"search-postcode\" translate>Post Code</label><div class=\"control\"><input type=\"text\" id=\"search-postcode\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.postcode\"></div></div><div class=\"field\"><label for=\"search-city\" translate>City</label><div class=\"control\"><input type=\"text\" id=\"search-city\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.city\"></div></div><div class=\"field\"><label for=\"search-state\" translate>State</label><div class=\"control\"><input type=\"text\" id=\"search-state\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.contact_state\"></div></div><div class=\"field\"><label for=\"search-country\" translate>Country</label><div class=\"control\"><input type=\"text\" id=\"search-country\" ng-keypress=\"keyPressed($event)\" ng-model=\"meta.country\"></div></div></fieldset></form></div></div><div class=\"float-search-btn\"><a id=\"clear_filters\" class=\"save-search__link\" ng-click=\"clear()\" translate>Clear filters</a> <button class=\"btn btn--primary btn--full searchItemsch\" ng-click=\"searchItems()\" translate>Search</button></div></div>");
        $templateCache.put('scripts/apps/contacts/views/search-results.html', "<div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\" ng-init=\"extras={view: view, activity: {type: type, action: 'list'}, api: api}\"><div class=\"list-pane {{ view || 'photogrid' }}-view\"><div id=\"content-list\" class=\"content\"><div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div><div class=\"search-tags\" sd-search-tags data-url-params=\"urlParams\"></div><div class=\"contacts-list__holder\" sd-contacts-list></div></div><div class=\"preview-pane content-item-preview\" ng-if=\"selected.preview\"><div class=\"contact-details-pane\"><div sd-contact-editor class=\"contact-editor\" data-contact=\"selected.preview\" data-oncancel=\"selected.preview = null\"></div></div></div></div></div>");
        $templateCache.put('scripts/apps/content-api/views/list.html', "<div class=\"subnav subnav--absolute\"><header class=\"search-page-header\"><div class=\"filter-trigger\" title=\"{{ :: 'Filters' | translate }}\" ng-click=\"flags.facets = !flags.facets\" ng-class=\"{'filter-trigger--active': flags.facets}\"><i class=\"icon-filter-large\"></i></div><div sd-item-searchbar data-repo=\"repo\" data-context=\"context\" class=\"searchbar-flex-handler\"></div><div sd-content-api-sort-bar data-total=\"total\" class=\"sortbar-flex-handler\"></div><div class=\"view-select\"><button title=\"{{ :: 'Switch to grid view' | translate }}\" ng-show=\"view !== 'mgrid'\" ng-click=\"setView('mgrid')\"><i class=\"icon-th\"></i></button> <button title=\"{{ :: 'Switch to list view' | translate }}\" ng-show=\"view !== 'compact'\" ng-click=\"setView('compact')\"><i class=\"icon-th-list\"></i></button></div></header></div><section class=\"search main-section search-page-container\" ng-class=\"{'sidebar-open': flags.facets}\"><div sd-content-api-search-panel data-items=\"items\" data-repo=\"repo\" data-context=\"context\" class=\"archive-sidebar\"></div><div sd-content-api-search-results class=\"archive-content\"></div></section>");
        $templateCache.put('scripts/apps/content-api/views/search-panel.html', "<div id=\"content-api-search-panel\"><div class=\"header\"><ul class=\"nav-tabs\"><li ng-class=\"{'nav-tabs__tab--active': !tab || tab === 'parameters'}\" class=\"nav-tabs__tab\"><button ng-click=\"tab = 'parameters'\" class=\"nav-tabs__link\"><span translate>Parameters</span></button></li><li ng-class=\"{'nav-tabs__tab--active': tab === 'filters'}\" class=\"nav-tabs__tab\"><button ng-click=\"tab = 'filters'\" class=\"nav-tabs__link\"><span translate>Filters</span></button></li></ul><div class=\"doopen\" ng-click=\"flags.facets = !flags.facets\"><i class=\"icon-close-small\"></i></div></div><div class=\"nav-tabs__content content\"><div ng-if=\"!tab || tab === 'parameters'\" class=\"nav-tabs__pane\"><div sd-search-parameters data-repo=\"repo\"></div></div><div ng-if=\"tab === 'filters'\" class=\"nav-tabs__pane\"><div sd-search-filters></div></div></div><div class=\"float-search-btn\" ng-if=\"tab==='parameters'\"><a id=\"clear_filters\" class=\"save-search__link\" ng-click=\"clear()\" translate>Clear filters</a> <button class=\"btn btn--primary btn--full search\" ng-click=\"searchItems()\" translate>Search</button></div></div>");
        $templateCache.put('scripts/apps/content-api/views/search-results.html', "<div class=\"preview-layout\" ng-class=\"{closed: !selected.preview && !selected.fetch}\" ng-init=\"extras={view: view, activity: {type: spike ? 'spike' : type, action: 'list'}, api: api}\"><div class=\"list-pane {{ view || 'mgrid' }}-view\"><div id=\"content-list\" class=\"content\"><div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div><div class=\"search-tags\" ng-class=\"{'refresh': showRefresh}\" sd-search-tags></div><div class=\"shadow-list-holder\" sd-items-list></div></div><div sd-item-preview data-item=\"selected.preview\" data-close=\"preview()\" data-open-single-item=\"openSingleItem\" data-hide-actions-menu=\"true\"></div></div></div>");
        $templateCache.put('scripts/apps/content-filters/views/filter-search-result.html', "<div class=\"flex-grid flex-grid--wrap-items flex-grid--small-4\"><div ng-if=\"searchResult.filter_conditions.length > 0 && !loading\" class=\"flex-grid__item padded--sides10\"><table><thead><tr><th translate>Filter Conditions</th></tr></thead><tbody><tr ng-repeat=\"fc in searchResult.filter_conditions track by fc._id\"><td class=\"column-width\">{{:: fc.name }}</td></tr></tbody></table></div><div ng-if=\"searchResult.content_filters.length > 0 && !loading\" class=\"flex-grid__item padded--sides10\"><table><thead><tr><th translate>Content Filters</th></tr></thead><tbody><tr ng-repeat=\"cf in searchResult.content_filters track by cf._id\"><td class=\"column-width\">{{:: cf.name }} <i ng-if=\"cf.is_global\">[Global]</i></td></tr></tbody></table></div><div ng-if=\"searchResult.selected_subscribers.length > 0 && !loading\" class=\"flex-grid__item padded--sides10\"><table><thead><tr><th translate>Subscribers</th></tr></thead><tbody><tr><td class=\"column-width\"><div sd-admin-pub-subscribers data-subscribers-list=\"searchResult.selected_subscribers\" data-hide-header=\"true\"></div></td></tr></tbody></table></div></div>");
        $templateCache.put('scripts/apps/content-filters/views/filter-search.html', "<div class=\"sd-page__content\" ng-controller=\"FilterSearchCtrl\"><div class=\"grid\" style=\"margin: 0 -2rem\"><div class=\"grid__item grid__item--col-3\"><div class=\"panel-search sd-shadow--z2\"><form name=\"searchForm\" ng-submit=\"search()\"><fieldset><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Field</label><select class=\"sd-line-input__select\" ng-change=\"resetValues()\" required ng-model=\"filterCondition.field\"><option value=\"{{parameter.field}}\" ng-selected=\"parameter.field === filterCondition.field\" ng-repeat=\"parameter in filterConditionParameters | orderBy: 'field' track by $index\">{{:: parameter.field}}</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Operator</label><select class=\"sd-line-input__select\" ng-change=\"resetValues()\" required ng-model=\"filterCondition.operator\"><option value=\"{{operator}}\" ng-selected=\"operator === filterCondition.operator\" ng-repeat=\"operator in operatorLookup[filterCondition.field] track by $index\">{{:: operator | translate}}</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input\" ng-if=\"!isListValue()\"><label class=\"sd-line-input__label\" translate>Values</label><input class=\"sd-line-input__input\" required ng-model=\"filterCondition.value\"></div><div ng-if=\"isListValue()\"><label class=\"form-label\" translate>Values</label><div class=\"term-editor\" sd-meta-terms data-item=\"filterCondition\" data-field=\"values\" data-unique=\"{{valueFieldLookup[filterCondition.field]}}\" data-list=\"valueLookup[filterCondition.field]\" data-header=\"true\" data-reload-list=\"true\"></div></div></div><div class=\"form__row\" style=\"text-align:right\"><button type=\"reset\" class=\"btn\" ng-disabled=\"!(filterCondition.value || filterCondition.values.length > 0)\" ng-click=\"clear()\" translate>Clear search</button> <button class=\"btn btn--primary\" ng-disabled=\"!(filterCondition.value || filterCondition.values.length > 0)\" ng-click=\"search()\" translate>Search</button></div></fieldset></form></div></div><div class=\"grid__item grid__item--col-9\"><div class=\"panel-search-result\" ng-if=\"searchResult\" ng-include=\"'scripts/apps/content-filters/views/filter-search-result.html'\"></div></div></div></div>");
        $templateCache.put('scripts/apps/content-filters/views/manage-filter-conditions.html', "<div ng-controller=\"FilterConditionsCtrl\" class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"edit()\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content\" ng-if=\"loadedFilters\"><ul class=\"pills-list wide\"><li ng-repeat=\"filterCondition in filterConditions | filter: query track by filterCondition._id\" class=\"clearfix\"><div class=\"header\"><div><h6>{{ filterCondition.name }}</h6><span class=\"pull-right-20\">{{ getFilterConditionSummary(filterCondition) }}</span></div><div class=\"actions\"><button ng-click=\"edit(filterCondition)\" title=\"{{:: 'Edit Filter Condition' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(filterCondition)\" title=\"{{:: 'Remove Filter Condition' | translate }}\"><i class=\"icon-trash\"></i></button></div></div></li></ul></div><!-- Modal - --><div sd-modal data-model=\"filterCondition\" class=\"filter-condition-modal modal--large\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" ng-show=\"filterCondition._id\"><span translate>Edit Filter Condition</span> \"{{ origFilterCondition.name }}\"</h3><h3 class=\"modal__heading\" translate ng-hide=\"filterCondition._id\" translate>Add New Filter Condition</h3></div><div class=\"modal__body\"><form name=\"editForm\"><fieldset><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--required\" ng-class=\"{'sd-line-input--invalid': editForm.label.$error.maxlength}\"><label class=\"sd-line-input__label\" translate>Name</label><input class=\"sd-line-input__input\" id=\"filterCondition-name\" name=\"label\" required ng-model=\"filterCondition.name\" ng-maxlength=\"80\"><div class=\"sd-line-input__message\" ng-show=\"editForm.label.$error.maxlength\" translate>Please use less than 80 characters.</div></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Field</label><select class=\"sd-line-input__select\" required ng-model=\"filterCondition.field\" ng-change=\"clearConditionValues()\"><option value=\"{{parameter.field}}\" ng-selected=\"parameter.field === filterCondition.field\" ng-repeat=\"parameter in filterConditionParameters | orderBy: 'field' track by $index\">{{:: label(parameter.field) }}</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Operator</label><select class=\"sd-line-input__select\" required ng-model=\"filterCondition.operator\"><option value=\"{{operator}}\" ng-selected=\"operator === filterCondition.operator\" ng-repeat=\"operator in operatorLookup[filterCondition.field]\">{{operator}}</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\" ng-if=\"isComparisonValue()\"><label class=\"sd-line-input__label\" translate>Values</label><select class=\"sd-line-input__select\" required ng-model=\"filterCondition.value\" ng-if=\"isComparisonValue()\"><option value=\"{{v[valueFieldLookup[filterCondition.field]]}}\" ng-selected=\"v[valueFieldLookup[filterCondition.field]] === filterCondition.value\" ng-repeat=\"v in valueLookup[filterCondition.field] | orderBy: 'name'\">{{:: v.name}}</option></select></div><div class=\"sd-line-input sd-line-input--required\" ng-if=\"!isListValue() && !isComparisonValue()\"><label class=\"sd-line-input__label\" translate>Values</label><input class=\"sd-line-input__input\" required ng-model=\"filterCondition.value\"></div><div ng-if=\"isListValue()\"><label class=\"form-label form-label--required\" translate>Values</label><div class=\"term-editor\" sd-meta-terms data-item=\"filterCondition\" data-field=\"values\" data-unique=\"{{valueFieldLookup[filterCondition.field]}}\" data-list=\"valueLookup[filterCondition.field]\" data-header=\"true\" data-reload-list=\"true\"></div></div></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!editForm.$valid || !editForm.$dirty\" translate>Save</button></div></div><!-- Close Modal --></div>");
        $templateCache.put('scripts/apps/content-filters/views/manage-filters.html', "<div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"editFilter()\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content manage-filters-page\"><ul class=\"pills-list wide\"><li ng-repeat=\"filter in contentFilters | filter:query track by filter._id\" class=\"clearfix\"><div class=\"header\"><h6>{{ filter.name }}</h6><span ng-if=\"filter.is_global\" class=\"label label--warning label--hollow\">Global Block</span> <span ng-if=\"filter.is_archived_filter\" class=\"label label--warning label--hollow\">Archived Block</span> <span ng-if=\"filter.api_block\" class=\"label label--warning label--hollow\">Block API</span><div class=\"actions\"><button ng-click=\"productionTest(filter)\" title=\"{{:: 'Test Filter Against Content' | translate }}\"><i class=\"icon-ok\"></i></button> <button ng-click=\"editFilter(filter)\" title=\"{{:: 'Edit Content Filter' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(filter)\" title=\"{{:: 'Remove Content Filter' | translate }}\"><i class=\"icon-trash\"></i></button></div></div></li></ul><div ng-if=\"productionTest\" ng-include=\"'scripts/apps/content-filters/views/production-test.html'\"></div></div><!-- Modal - --><div sd-modal data-model=\"contentFilter\" data-close=\"close()\" class=\"modal--large content-filter-modal\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" ng-show=\"contentFilter._id\"><span translate>Edit Content Filter</span> <span>\"{{:: origContentFilter.name }}\"</span></h3><h3 class=\"modal__heading\" translate ng-hide=\"contentFilter._id\">Add New Content Filter</h3></div><div class=\"modal__body\"><form name=\"editForm\" ng-submit=\"saveFilter()\"><fieldset><div class=\"form__row\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': editForm.label.$error.maxlength}\"><label class=\"sd-line-input__label\" translate>Name</label><input class=\"sd-line-input__input\" type=\"text\" id=\"contentFilter-name\" name=\"label\" required ng-model=\"contentFilter.name\" ng-maxlength=\"80\"><div class=\"sd-line-input__hint\" ng-show=\"!editForm.label.$error.maxlength\" translate>Maximum 80 characters.</div><div class=\"sd-line-input__message\" ng-show=\"editForm.label.$error.maxlength\" translate>Please use less than 80 characters</div></div></div><div class=\"form__row\"><div class=\"list-row list-row--small\"><span ng-model=\"contentFilter.is_global\" sd-switch title=\"{{ contentFilter.is_global ? 'Global Block Enabled' : 'Global Block Disabled'  | translate }}\"></span><label>{{:: 'Global Block' | translate }}</label></div><div class=\"list-row list-row--small\"><span ng-model=\"contentFilter.is_archived_filter\" sd-switch title=\"{{ contentFilter.is_archived_filter ? 'Archived Block Enabled' : 'Archived Block Disabled'  | translate }}\"></span><label>{{:: 'Archived Block' | translate }}</label></div><div class=\"list-row list-row--small\"><span ng-model=\"contentFilter.api_block\" sd-switch title=\"{{ contentFilter.api_block ? 'API Block Enabled' : 'API Block Disabled' | translate }}\"></span><label>{{:: 'Block API' | translate }}</label></div></div><div class=\"filter-tags\" ng-repeat=\"filterRow in contentFilter.content_filter\"><div class=\"flex-header\"><div class=\"flex-header-name\"><span translate>Filter Statement</span> <span class=\"lighten-text\">{{$index+1}}</span></div><div class=\"flex-space\"></div><a href=\"\" class=\"close\" ng-click=\"removeStatement($index)\"><i class=\"icon-close-small\"></i></a></div><div class=\"grid grid--padding-fix\"><div class=\"grid__item grid__item--col-6\"><div class=\"form__row form__row--flex form__row--no-margin\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">Filter Preview</label><select class=\"sd-line-input__select\" ng-model=\"filterRow.selected\"><option value=\"\"></option><option value=\"{{filter._id}}\" ng-repeat=\"filter in filterConditions track by filter._id\">{{:: filter.name}}</option></select></div><button class=\"btn\" type=\"button\" ng-click=\"addFilter(filterRow, 'fc')\" translate>Add</button></div></div><div class=\"grid__item grid__item--col-6\"><div class=\"form__row form__row--flex form__row--no-margin\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">Content Preview</label><select class=\"sd-line-input__select\" ng-model=\"filterRow.selected\"><option value=\"\"></option><option ng-if=\"filter._id!==contentFilter._id\" value=\"{{filter._id}}\" ng-repeat=\"filter in contentFilters track by filter._id\">{{:: filter.name}}</option></select></div><button class=\"btn\" type=\"button\" ng-click=\"addFilter(filterRow, 'pf')\" translate>Add</button></div></div></div><div class=\"inline-tag-list\"><ul><li ng-repeat=\"filter in filterRow.expression.fc\"><div class=\"inline-tag\" title=\"{{'Filter Condition' | translate}}: {{filterConditionLookup[filter].name}}\"><span>FC:</span>{{filterConditionLookup[filter].name}}<button type=\"button\" ng-click=\"removeFilter(filterRow, filter, 'fc')\"><i class=\"icon-close-small\"></i></button></div></li><li ng-repeat=\"filter in filterRow.expression.pf\"><div class=\"inline-tag tag-darker\" title=\"{{'Content Filter' | translate}}: {{contentFiltersLookup[filter].name}}\"><span>CF:</span>{{contentFiltersLookup[filter].name}}<button type=\"button\" ng-click=\"removeFilter(filterRow, filter, 'pf')\"><i class=\"icon-close-small\"></i></button></div></li></ul></div></div><div class=\"form__row\" style=\"text-align:right\"><button class=\"btn btn--hollow btn--primary\" type=\"button\" ng-click=\"addStatement()\" translate>Add Filter Statement</button></div></fieldset></form><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--disabled\"><label class=\"sd-line-input__label\">Filter Preview</label><textarea class=\"sd-line-input__input\" id=\"contentFilter-preview\" readonly ng-model=\"preview\" sd-auto-height disabled></textarea></div></div><div class=\"form__row form__row--flex\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': !test.article_id.$valid}\"><label class=\"sd-line-input__label\">Filter Test</label><input class=\"sd-line-input__input\" type=\"text\" id=\"contentFilter-test\" required ng-model=\"test.article_id\" ng-change=\"test.test_result=null\"><div class=\"sd-line-input__hint\" translate>Use the article GUID for testing.</div></div><button type=\"button\" class=\"btn\" ng-click=\"test()\" translate>Test</button></div><div class=\"form__row\"><div id=\"test-result\" class=\"sd-alert sd-alert--hollow\" ng-if=\"test.test_result\">{{test.test_result}}</div></div></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"close()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"saveFilter()\" ng-disabled=\"!editForm.$valid || !preview || !editForm.$dirty\" translate>Save</button></div></div><!-- Close Modal -->");
        $templateCache.put('scripts/apps/content-filters/views/production-test-view.html', "<section class=\"main-section.filter\"><div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\"><div class=\"list-pane\"><header><div class=\"sortbar pull-left\"><span class=\"result-type\" ng-repeat=\"type in resultType\"><input type=\"radio\" ng-click=\"fetchResults()\" name=\"type\" value=\"{{ :: type.value}}\" data-ng-model=\"model.selectedType\"> {{ :: type.id}}</span></div></header><div class=\"content\"><div sd-shadow><table class=\"table styled-table\"><thead><tr><th></th><th translate>State</th><th translate>Unique Name</th><th translate>Headline</th><th translate>Keywords</th><th translate>Source</th><th translate>ANPA Category</th></tr></thead><tbody><tr ng-class=\"{active: result_item === selectedItem, archived: result_item.archived || result_item.created,\n" +
            "                            locked: lock.isLocked}\" tabindex=\"1\" ng-keyup=\"handleKeyEvent($event)\" ng-repeat=\"result_item in testResult track by result_item._id\" ng-click=\"preview(result_item);\"><td><i class=\"filetype-icon-{{result_item.type}}\" ng-hide=\"hover || item.selected\"></i></td><td><div class=\"state-label state-{{result_item.state}}\">{{ :: result_item.state}}</div></td><td>{{ :: result_item.unique_name}}</td><td>{{ :: result_item.headline | limitTo: 60}} <span sd-item-container data-item=\"result_item\" title=\"{{ result_item.label }} {{ result_item.value }}\" class=\"container\"></span></td><td>{{ :: result_item.slugline | limitTo: 40}}</td><td>{{ :: result_item.source}}</td><td>{{ :: result_item['anpa_category'] | mergeWords:'name' }}</td></tr></tbody></table></div></div></div><div class=\"preview-pane content-item-preview\" ng-show=\"selected.preview\" ng-init=\"tab = 'content'\"><header><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'content'}\"><button ng-click=\"tab = 'content'\"><span translate>Content</span></button></li><li ng-class=\"{active: tab === 'metadata'}\"><button ng-click=\"tab = 'metadata'\"><span translate>Metadata</span></button></li></ul><button ng-click=\"preview(null)\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div class=\"content\" ng-if=\"selected.preview\"><div ng-if=\"tab === 'content'\" sd-media-preview></div><div ng-if=\"tab === 'metadata'\" sd-media-metadata data-item=\"selected.preview\"></div></div></div></div></section><div sd-media-view data-item=\"selected.view\" data-items=\"items._items\" ng-if=\"selected.view\" data-close=\"closeLightbox()\"></div>");
        $templateCache.put('scripts/apps/content-filters/views/production-test.html', "<div ng-controller=\"ProductionTestCtrl\"><div sd-modal data-model=\"testResult\" data-close=\"close()\" class=\"filter-result-modal modal--fill\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Filter Test Results</h3></div><div class=\"modal__body filter-result-body\"><div ng-if=\"productionTest\" ng-include=\"'scripts/apps/content-filters/views/production-test-view.html'\"></div></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"close()\" translate>Close</button></div></div></div>");
        $templateCache.put('scripts/apps/content-filters/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" id=\"content-filters-settings\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Content Filters</h2></div><div class=\"sd-page__header sd-page__header--white\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: ctrl.activeTab === 'filters'}\"><button ng-click=\"ctrl.changeTab('filters')\" translate>Filters</button></li><li ng-class=\"{active: ctrl.activeTab === 'filter_conditions'}\"><button ng-click=\"ctrl.changeTab('filter_conditions')\" translate>Filter Conditions</button></li><li ng-class=\"{active: ctrl.activeTab === 'filter_search'}\"><button ng-click=\"ctrl.changeTab('filter_search')\" translate>Filter Search</button></li></ul></div><div class=\"sd-page__flex-helper\" ng-switch=\"ctrl.activeTab\"><div class=\"sd-page__flex-helper\" ng-switch-when=\"filter_conditions\"><div class=\"sd-page__flex-helper\" ng-include=\"ctrl.TEMPLATES_DIR + '/manage-filter-conditions.html'\"></div></div><div ng-switch-when=\"filters\" class=\"sd-page__flex-helper\"><div class=\"sd-page__flex-helper\" sd-manage-filters-tab></div></div><div ng-switch-when=\"filter_search\" class=\"sd-page__flex-helper\"><div class=\"sd-page__flex-helper\" ng-include=\"ctrl.TEMPLATES_DIR + '/filter-search.html'\" data-search=\"search\"></div></div></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/dashboard/closed-desk/views/close-desk-widget.html', "<div class=\"close-desk-widget-content\" ng-controller=\"RoutingWidgetController as routing\"><div class=\"sd-line-input\" ng-if=\"routing.routedFrom.length\"><label class=\"sd-line-input__label\" translate>Routed from</label><div class=\"sd-list-item-group\"><div class=\"sd-list-item\" ng-repeat=\"desk in routing.routedFrom\"><div class=\"sd-list-item\"><div class=\"sd-list-item__border\" ng-class=\"{\n" +
            "                        'sd-list-item__border--locked': !desk.is_closed,\n" +
            "                        'sd-list-item__border--success': desk.is_closed,\n" +
            "                    }\"></div><div class=\"sd-list-item__column sd-list-item__column--grow\">{{ desk.name }}</div></div></div></div></div><div class=\"space-eater\"></div><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Route incoming content to</label><select class=\"sd-line-input__select\" ng-options=\"d._id as d.name for d in routing.desks\" ng-model=\"routing.destination\" ng-change=\"routing.updateDestination()\" ng-disabled=\"!routing.canManage\"></select></div><button class=\"btn btn--large btn--success btn--expanded\" ng-if=\"!routing.desk.is_closed\" ng-disabled=\"!routing.destination || !routing.canManage\" ng-click=\"routing.toggle()\" translate>Start routing</button> <button class=\"btn btn--large btn--alert btn--expanded\" ng-if=\"routing.desk.is_closed\" ng-disabled=\"!routing.canManage\" ng-click=\"routing.toggle()\" translate>Stop routing</button></div>");
        $templateCache.put('scripts/apps/dashboard/closed-desk/views/top-menu-info.html', "<div class=\"top-menu__info\" ng-show=\"routingTo || routingFrom\"><i class=\"top-menu__info-icon\" ng-class=\"{\n" +
            "        'top-menu__info-icon--green': routingFrom,\n" +
            "        'icon-download': routingFrom,\n" +
            "        'top-menu__info-icon--red': routingTo,\n" +
            "        'icon-upload': routingTo,\n" +
            "}\"></i> <span class=\"top-menu__info-label\" ng-show=\"routingFrom\" translate>Routed from:</span> <span class=\"top-menu__info-text\" ng-show=\"routingFrom\">{{ routingFrom }}</span> <span class=\"top-menu__info-label\" ng-show=\"routingTo\" translate>Routing to:</span> <span class=\"top-menu__info-text\" ng-show=\"routingTo\">{{ routingTo }}</span></div>");
        $templateCache.put('scripts/apps/dashboard/grid/views/grid-item.html', "<div class=\"widget-resize-width\" ng-show=\"status\"><div class=\"resize-left\" ng-click=\"resizeWidget(widget, 'left')\"></div><div class=\"resize-right\" ng-click=\"resizeWidget(widget, 'right')\"></div></div><div class=\"widget-resize-height\" ng-show=\"status\"><div class=\"resize-up\" ng-click=\"resizeWidget(widget, 'up')\"></div><div class=\"resize-down\" ng-click=\"resizeWidget(widget, 'down')\"></div></div><div class=\"widget-close\" ng-click=\"removeWidget()\" ng-show=\"status\"></div><div class=\"r{{widget.sizex}}{{widget.sizey}}\" ng-transclude></div>");
        $templateCache.put('scripts/apps/dashboard/grid/views/grid.html', "<div class=\"gridster\" ng-class=\"{editmode: status}\"><ul class=\"dash-grid\"><li ng-repeat=\"widget in widgets\" sd-grid-item class=\"gs_w\"><div sd-widget data-widget=\"widget\" data-configurable=\"configurable\" data-save=\"save()\"><div ng-include=\"widget.template\"></div></div></li></ul></div>");
        $templateCache.put('scripts/apps/dashboard/views/configuration.html', "<div ng-if=\"!widget.custom\" class=\"modal__header\"><a class=\"modal__close pull-right\" ng-click=\"$close()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\">{{ widget.label|translate }} {{ 'Configuration'|translate }}</h3></div><div ng-if=\"!widget.custom\" class=\"modal__body\"><div ng-include=\"widget.configurationTemplate\"></div></div><div ng-if=\"!widget.custom\" class=\"modal__footer\"><button class=\"btn\" ng-click=\"saveConfig()\"><span translate>Save</span></button></div><div ng-if=\"widget.custom\" ng-include=\"widget.configurationTemplate\"></div>");
        $templateCache.put('scripts/apps/dashboard/views/widget.html', "<div class=\"sd-widget {{ widget._id }} gs_w\" ng-class=\"{'remove-header': widget.removeHeader}\"><div class=\"widget-line\"></div><div class=\"widget-settings\" ng-if=\"widget.configurationTemplate && configurable\"><a class=\"single-btn icn-btn\" sd-tooltip=\"Widget settings\" flow=\"left\" ng-click=\"openConfiguration()\"><i class=\"icon-settings\"></i></a></div><div class=\"widget-header\" ng-if=\"!widget.removeHeader\"><div class=\"widget-title\">{{ widget.configuration.label || widget.label | translate}}</div></div><div class=\"widget-content\" ng-transclude></div></div>");
        $templateCache.put('scripts/apps/dashboard/views/workspace-topnav.html', "<div sd-desk-dropdown></div>");
        $templateCache.put('scripts/apps/dashboard/views/workspace.html', "<div class=\"subnav subnav--absolute\"><h3 class=\"page-nav-title\"><span translate>Dashboard</span> {{ dashboard.current.name | translate}}</h3><div class=\"subnav__button-stack--square-buttons\"><button ng-if=\"configurable\" class=\"navbtn\" ng-click=\"dashboard.edit = true\" ng-show=\"dashboard.widgets.length && !dashboard.edit\" sd-tooltip=\"{{ :: 'Rearrange widgets' | translate }}\" flow=\"left\"><i class=\"icon-switches\"></i></button> <button class=\"navbtn navbtn--blue\" ng-click=\"dashboard.save()\" ng-show=\"dashboard.edit\" sd-tooltip=\"{{ :: 'Accept' | translate }}\" flow=\"left\"><i class=\"svg-icon-ok inverse\"></i></button><div sd-tooltip=\"{{ :: 'Add widget' | translate }}\" flow=\"left\" ng-show=\"!dashboard.edit\"><button ng-if=\"configurable\" class=\"navbtn sd-create-btn\" ng-disabled=\"dashboard.edit\" ng-click=\"dashboard.add = true\"></button></div><div class=\"dropdown__menu pull-right\" sd-multiedit-dropdown ng-if=\"dashboard.current.name !== 'personal' && dashboard.current._id && !dashboard.current.desk\"></div><div class=\"dropdown\" dropdown ng-if=\"dashboard.current.name !== 'personal' && dashboard.current._id && !dashboard.current.desk\"><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><div class=\"dropdown__menu pull-right\"><ul><li><span class=\"dropdown__menu-label\" translate>Workspace</span></li><li><button type=\"button\" ng-click=\"dashboard.rename()\"><i class=\"icon-pencil\"></i> <span translate>Rename workspace</span></button></li><li><button type=\"button\" ng-click=\"dashboard.delete()\"><i class=\"icon-trash\"></i> <span translate>Delete workspace</span></button></li></ul></div></div></div></div><div sd-edit-workspace data-workspace=\"edited\" data-done=\"afterRename\"></div><div class=\"dashboard-container\" ng-if=\"dashboard.current\"><div class=\"content clearfix\"><div sd-grid data-status=\"dashboard.edit\" data-widgets=\"dashboard.widgets\" data-save=\"dashboard.save()\" data-configurable=\"configurable\"></div><div class=\"empty-dashboard\" ng-show=\"dashboard.widgets.length === 0\" translate>Dashboard is empty.</div><div class=\"empty-dashboard loading\" ng-show=\"dashboard.widgets == null\" translate>Loading...</div></div></div><div sd-modal data-model=\"dashboard.add\" class=\"modal--large modal--x-large modal--tabs\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" translate>Add new widget</h3><button class=\"modal__close icn-btn\" ng-click=\"dashboard.add = false\"><i class=\"icon-close-small\"></i></button></div><div class=\"modal__body\" ng-if=\"!dashboard.selectedWidget\"><div class=\"modal__body-content\"><ul class=\"widget-list\"><li ng-repeat=\"widget in dashboard.availableWidgets\" ng-click=\"dashboard.selectWidget(widget)\" ng-class=\"{selected: dashboard.isSelected(widget)}\" class=\"widget {{ widget._id }}\"><div class=\"thumbnail\"><img ng-src=\"{{ :: widget.thumbnail }}\"></div><div class=\"title\">{{ :: widget.label | translate}}</div></li></ul></div><div class=\"modal__body-footer\" ng-if=\"!dashboard.selectedWidget\"><button class=\"btn btn--primary btn--large\" ng-click=\"dashboard.add = false\" translate>Done</button></div></div><div class=\"modal__body\" ng-if=\"dashboard.selectedWidget\"><div class=\"modal__body-header modal__body-header--flex modal__body-header--add-padding\"><button class=\"backlink\" ng-click=\"dashboard.selectWidget()\" translate>Back</button></div><div class=\"modal__body-content widget-detail\"><div class=\"thumbnail-box {{ dashboard.selectedWidget._id }}\"><img ng-src=\"{{ :: dashboard.selectedWidget.thumbnail }}\"></div><div class=\"content-box\"><div class=\"title\">{{ :: dashboard.selectedWidget.label | translate }}</div><div class=\"description\">{{ :: dashboard.selectedWidget.description | translate }}</div><button class=\"btn btn--primary btn--large\" ng-click=\"dashboard.addWidget(dashboard.selectedWidget)\" ng-disabled=\"!dashboard.selectedWidget\" translate>Add This Widget</button></div></div><div class=\"modal__body-footer\" ng-if=\"dashboard.selectedWidget\"></div></div></div>");
        $templateCache.put('scripts/apps/dashboard/workspace-tasks/views/assignee-view.html', "<div><figure class=\"avatar {{avatarSize}}\"><img sd-user-avatar data-user=\"user\"></figure><div class=\"assignee-name\" ng-if=\"name\"><span ng-show=\"task.desk\">{{deskName}} / </span><span ng-show=\"task.user\">{{userName}}</span> <span ng-hide=\"task.user\" translate>Unassigned</span></div></div>");
        $templateCache.put('scripts/apps/dashboard/workspace-tasks/views/desk-stages.html', "<div class=\"button-list\"><a href=\"\" ng-click=\"stageSelect()\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': !stages.selected && !spike && !published}\" style=\"max-width:{{100/(stages.stages.length + 3)}}%\" ng-if=\"stages.stages.length\">{{:: 'Any' | translate}} </a><a href=\"\" ng-repeat=\"stage in stages.stages\" ng-click=\"stageSelect(stage)\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': stage == stages.selected && !spike && !published}\" style=\"max-width:{{100/(stages.stages.length + 3)}}%\" ng-if=\"stages.stages.length\">{{ stage.name }} </a><a href=\"\" ng-if=\"type === 'archive'\" ng-click=\"toggleSpike()\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': spike}\" style=\"max-width:{{100/(stages.stages.length + 3)}}%\">{{:: 'Spiked' | translate}} </a><a href=\"\" ng-if=\"type === 'archive' && stages.stages.length\" ng-click=\"togglePublished()\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': published}\" style=\"max-width:{{100/(stages.stages.length + 3)}}%\">{{:: 'Published' | translate}}</a></div>");
        $templateCache.put('scripts/apps/dashboard/workspace-tasks/views/kanban-board.html', "<div class=\"board\"><header class=\"{{ :: cssClass }}\">{{ label }}</header><ul class=\"card-list\"><li ng-repeat=\"item in items\" ng-class=\"{selected: item === selected.preview}\" ng-click=\"preview(item)\"><div sd-assignee-view data-task=\"item.task\" data-avatar-size=\"small\"></div><div class=\"title\">{{ item.slugline || item.headline }}</div><div class=\"info\"><ul class=\"task-labels clearfix\"><li ng-if=\"item.task.due_date\"><i class=\"icon-time\"></i> <time sd-datetime data-date=\"item.task.due_date\"></time></li><li ng-if=\"item.next_run\"><i class=\"icon-time\"></i> <time sd-datetime data-date=\"item.next_run\"></time></li></ul></div><div class=\"action\" ng-if=\"!item.next_run && item.state !== 'published'\"><ul class=\"item-functions\" sd-activity-list data-item=\"item\" data-type=\"task\" data-action=\"edit\"></ul></div></li><ul></ul></ul></div>");
        $templateCache.put('scripts/apps/dashboard/workspace-tasks/views/task-preview.html', "<header><p class=\"pull-left\">{{ :: 'Created on' | translate}} <span sd-reldate-complex datetime=\"task._created\"></span> {{ :: 'by' | translate}} {{ users[task.original_creator].display_name }}</p><button ng-click=\"close()\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div class=\"content\"><form name=\"taskForm\"><div class=\"action-bar clearfix\" ng-class=\"{show: editmode}\"><button class=\"btn btn--primary pull-right\" ng-click=\"save()\" translate>Save</button> <button class=\"btn pull-right\" ng-click=\"reset()\" translate>Cancel</button></div><div class=\"action-menu\"><button ng-click=\"edit()\" class=\"change\"><i class=\"icon-pencil\"></i></button><div class=\"dropdown dropdown--big pull-right\" dropdown><button class=\"dropdown__toggle condensed\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><div class=\"dropdown__menu pull-right\" sd-activity-list data-item=\"item\" data-type=\"task\" data-action=\"edit\"></div></div></div><ul class=\"task-labels clearfix\" ng-if=\"!editmode\"><li><i class=\"icon-time\"></i> <time sd-datetime data-date=\"task_details.due_date\"></time></li></ul><div ng-if=\"editmode\" class=\"time-edit\"><div class=\"field\"><label translate>Due date</label><div sd-datepicker ng-model=\"task_details.due_date\"></div></div><div class=\"field\"><label translate>Due time</label><div sd-timepicker ng-model=\"task_details.due_time\"></div></div></div><div class=\"assignee-container\" ng-if=\"!editmode\"><figure ng-if=\"!editmode\" class=\"avatar\"><img sd-user-avatar data-user=\"users[task_details.user]\"></figure><div class=\"assignee-name\"><span ng-show=\"task_details.desk\">{{desks[task_details.desk].name}} / </span><span ng-show=\"task_details.user\">{{users[task_details.user].display_name}}</span> <span ng-hide=\"task_details.user\" translate>Unassigned</span></div></div><div ng-if=\"editmode\" sd-assignee-box data-desk-id=\"task_details.desk\" data-user-id=\"task_details.user\"></div><div ng-if=\"!editmode\" class=\"title\">{{ task.slugline }}</div><textarea ng-if=\"editmode\" class=\"title\" sd-auto-height ng-model=\"task.slugline\" placeholder=\"{{ :: 'Add title' | translate }}\" required></textarea><textarea ng-if=\"editmode\" class=\"description\" sd-auto-height ng-model=\"task.description_text\" placeholder=\"{{ :: 'Add description' | translate }}\"></textarea><div ng-if=\"!editmode\" class=\"description\">{{ task.description_text }}</div></form></div>");
        $templateCache.put('scripts/apps/dashboard/workspace-tasks/views/workspace-tasks.html', "<div class=\"subnav\"><h3 class=\"page-nav-title\" translate>Tasks</h3><div class=\"subnav__button-stack--square-buttons\"><button class=\"navbtn sd-create-btn\" ng-click=\"create()\"></button></div></div><section class=\"main-section workspace-tasks\"><div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\"><div class=\"list-pane task-list\"><header></header><div class=\"content\"><div class=\"stages\"><div class=\"board-holder\" sd-task-kanban-board data-items=\"scheduled._items\" data-label=\"{{ :: 'UPCOMING' | translate }}\" data-css-class=\"todo\"></div><div class=\"board-holder\" ng-repeat=\"stage in stages track by stage._id\" sd-task-kanban-board data-items=\"stageItems[stage._id]\" data-label=\"{{ :: stage.name }}\" data-css-class=\"in_progress\" data-selected=\"selected\"></div><div class=\"board-holder\" sd-task-kanban-board data-items=\"published._items\" data-label=\"{{ :: 'DONE' | translate }}\" data-css-class=\"done\" data-selected=\"selected\"></div></div></div></div><div class=\"preview-pane\" ng-if=\"selected.preview\" sd-task-preview data-item=\"selected.preview\" data-onclose=\"preview()\"></div></div></section><div sd-modal data-model=\"newTask\" data-close=\"close()\"><div class=\"modal__header\"><button class=\"modal__close pull-right\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\" translate>Create New Task</h3></div><div class=\"modal__body\" ng-if=\"newTask\"><form><fieldset class=\"full\"><textarea sd-autoexpand class=\"title\" ng-model=\"newTask.slugline\" placeholder=\"{{ :: 'Add content slugline' | translate}}\" tabindex=\"1\" sd-autofocus></textarea></fieldset><fieldset><textarea sd-autoexpand class=\"description\" ng-model=\"newTask.description_text\" placeholder=\"{{ :: 'Add task description' | translate}}\" tabindex=\"2\"></textarea><div class=\"assignee-focus\" sd-assignee-box data-desk-id=\"newTask.task.desk\" data-user-id=\"newTask.task.user\" tabindex=\"3\"></div></fieldset><fieldset class=\"due\"><div class=\"break\"></div><label translate>Due</label><div class=\"clear field\"><div sd-datepicker ng-model=\"newTask.task.due_date\"></div></div><div class=\"field\"><div sd-timepicker ng-model=\"newTask.task.due_time\"></div></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"close()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-disabled=\"!newTask.task.desk || !newTask.slugline\" ng-click=\"save()\" translate>Save</button></div></div>");
        $templateCache.put('scripts/apps/dashboard/world-clock/configuration.html', "<div ng-controller=\"WorldClockConfigController\" class=\"widget-config world-clock\"><div sd-wizard><div sd-wizard-step data-title=\"Your clock\" data-code=\"your-clock\"><div class=\"grid grid--wrap grid--padding-fix\"><label class=\"form-label grid__item grid__item--col-12\">{{'Clock type'|translate}}</label><div class=\"grid__item grid__item--col-12\"><div class=\"btn-group\"><!--<sd-check ng-model=\"configuration.digital\" type=\"radio\" ng-value=\"false\" label-position=\"inside\">Analog</sd-check>\n" +
            "                        <sd-check ng-model=\"configuration.digital\" type=\"radio\" ng-value=\"true\" label-position=\"inside\">Digital</sd-check>--> <button type=\"button\" class=\"btn\" ng-class=\"{active: !configuration.digital}\" ng-click=\"configuration.digital = false\">Analog</button> <button type=\"button\" class=\"btn\" ng-class=\"{active: configuration.digital}\" ng-click=\"configuration.digital = true\">Digital</button></div></div></div><div class=\"grid grid--wrap grid--padding-fix\"><label class=\"form-label grid__item grid__item--col-12\">{{'Your clock'|translate}}</label><div class=\"grid__item grid__item--col-12\"><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"zone in configuration.zones\"><a href=\"\">{{ zone.replace('_', ' ')}}</a> <a href=\"\" class=\"pull-right\" ng-click=\"configuration.zones.splice($index, 1); notify('remove', zone)\"><i class=\"icon-close-small\"></i></a></li></ul><div class=\"alert alert-info\" ng-hide=\"configuration.zones.length\" translate>No clock here!</div></div></div></div><div sd-wizard-step data-title=\"Available clocks\" data-code=\"available-clocks\"><div class=\"grid grid--wrap grid--padding-fix\"><label class=\"form-label grid__item grid__item--col-12\">{{'Available clock'|translate}}</label><div class=\"grid__item grid__item--col-12\"><div class=\"input-append\" style=\"margin-bottom:10px\"><input type=\"text\" class=\"input-large\" ng-model=\"search\" placeholder=\"{{ 'Search for clock'|translate }}\"> <button class=\"btn\" ng-disabled=\"!search\" ng-click=\"search = ''\" translate>Clear</button></div><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"zone in availableZones|filter:notIn(configuration.zones)|filter:search\" ng-click=\"configuration.zones.push(zone); notify('add', zone)\"><a href=\"\">{{ zone.replace('_', ' ')}}</a></li></ul></div></div></div></div></div>");
        $templateCache.put('scripts/apps/dashboard/world-clock/widget-worldclock.html', "<div><div class=\"clock-container clearfix\" ng-controller=\"WorldClockController\"><div ng-repeat=\"zone in widget.configuration.zones track by $index\"><div class=\"clock-box\" ng-class=\"{digital: widget.configuration.digital}\"><header>{{ zone.split('/')[1].replace('_', ' ') }}</header><div class=\"wclock\" sd-clock data-utc=\"utc\" data-tz=\"{{ zone }}\" ng-if=\"!widget.configuration.digital\"></div><time>{{ utc.tz(zone).format('HH:mm') }}</time><div class=\"date\">{{ utc.tz(zone).format('dddd') }}</div></div></div></div><div class=\"widget-footer\"></div></div>");
        $templateCache.put('scripts/apps/desks/views/actionpicker.html', "<div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div sd-form-select label=\"{{ :: 'Desk' | translate }}\" model=\"desk\" options=\"desks\" option-label=\"name\" option-value=\"_id\" required></div></div><div class=\"form__row-item\"><div sd-form-select label=\"{{ :: 'Stage' | translate }}\" model=\"stage\" options=\"deskStages[desk]\" option-label=\"name\" option-value=\"_id\" required></div></div><div class=\"form__row-item\"><div sd-form-select label=\"{{ :: 'Macro' | translate }}\" model=\"macro\" options=\"deskMacros\" option-label=\"name\" option-value=\"name\" required></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/content-expiry.html', "<span ng-if=\"preview && contentExpiry.expire\"><span ng-if=\"!contentExpiry.actualExpiry\">{{contentExpiry.header | translate}} {{ contentExpiry.days}} <span class=\"helper-text\" translate>day</span> {{ contentExpiry.hours}} <span class=\"helper-text\" translate>hr</span> {{ contentExpiry.minutes}} <span class=\"helper-text\" translate>min</span> </span><span ng-if=\"contentExpiry.actualExpiry\">{{contentExpiry.actualExpiry.text | translate}} {{contentExpiry.actualExpiry.expiry | translate}}</span></span><label ng-if=\"preview && !contentExpiry.expire\">{{contentExpiry.header | translate}} {{contentExpiry.actualExpiry.text | translate}} {{contentExpiry.actualExpiry.expiry | translate}}</label><div ng-if=\"!preview && contentExpiry.expire\" class=\"form__row\"><div class=\"\"><span sd-switch ng-model=\"contentExpiry.expire\"></span><label class=\"inline-label\">{{contentExpiry.header | translate}} <span class=\"label label--primary label--hollow\" ng-if=\"contentExpiry.actualExpiry\" title=\"{{ contentExpiry.actualExpiry.expiry | translate}}\">{{ contentExpiry.actualExpiry.text | translate }}</span></label></div><div class=\"form__row form__row--flex form__row--no-padding\"><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--no-margin\"><input class=\"sd-line-input__input sd-line-input__input--mini\" type=\"number\" ng-model=\"contentExpiry.days\" min=\"0\" required></div></div><div class=\"form__row-item form__row-item--no-grow\"><span class=\"\" translate>days</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--no-margin\"><input class=\"sd-line-input__input sd-line-input__input--mini\" type=\"number\" ng-model=\"contentExpiry.hours\" min=\"0\" max=\"23\" required></div></div><div class=\"form__row-item form__row-item--no-grow\"><span class=\"\" translate>hr</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--no-margin\"><input class=\"sd-line-input__input sd-line-input__input--mini\" type=\"number\" ng-model=\"contentExpiry.minutes\" min=\"0\" max=\"59\" required></div></div><div class=\"form__row-item form__row-item--no-grow\"><span class=\"\" translate>min</span></div></div></div><div ng-if=\"!preview && !contentExpiry.expire\" class=\"form__row\"><div class=\"form__row-item\" style=\"padding-bottom: 1.4rem\"><span sd-switch ng-model=\"contentExpiry.expire\"></span><label class=\"inline-label\">{{contentExpiry.header | translate}} <span class=\"label label--primary label--hollow\" ng-if=\"contentExpiry.actualExpiry\" title=\"{{ contentExpiry.actualExpiry.expiry | translate}}\">{{ contentExpiry.actualExpiry.text | translate }}</span></label></div></div>");
        $templateCache.put('scripts/apps/desks/views/desk_users.html', "<div class=\"desk__header\"><div class=\"desk__name\">{{ desk.name }} <span class=\"desk__open\" ng-if=\"isMemberOf(desk)\" ng-click=\"openDeskView(desk, 'task')\" title=\"{{ :: 'Open desk content' | translate }}\"><i class=\"icon-external\"></i></span></div><div class=\"desk__action dropdown dropdown--align-right\" dropdown ng-if=\"privileges.desks\"><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><ul class=\"dropdown__menu pull-right\"><li><button ng-click=\"openDesk('general', desk)\"><i class=\"icon-pencil\"></i> {{ :: 'Edit desk' | translate }}</button></li></ul></div></div><div class=\"desk__content\"><div class=\"item-group\" ng-repeat=\"role in roles\" ng-show=\"total\"><div class=\"item-group__header\"><div class=\"item-group__name\">{{ :: role.name}}</div><span class=\"badge badge--light pull-right\">{{total}}</span></div><div class=\"item-group__content\" sd-user-role-items data-role=\"role._id\" data-desk=\"desk._id\" data-total=\"total\" data-online=\"online_users\" data-privilege=\"privileges.users\"></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/desk-config-modal.html', "<div sd-modal data-model=\"modalActive\" class=\"modal--tabs modal--large sd-wizard\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"!desk.edit._id\" translate>Add New Desk</h3><h3 class=\"modal__heading\" ng-show=\"desk.edit._id\" translate>Edit \"{{desk.edit.name}}\" Desk</h3><a href=\"\" class=\"icn-btn close-modal\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\" sd-wizard data-name=\"desks\" data-current-step=\"step.current\" data-finish=\"cancel()\"><div sd-wizard-step data-title=\"{{ 'General' | translate }}\" data-code=\"general\"><form sd-deskedit-basic name=\"generalStep\" class=\"content desk-content\"><fieldset><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Desk name</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"desk.edit.name\" ng-keyup=\"handleEdit($event);\" required><div class=\"sd-line-input__char-count\" sd-character-count data-item=\"desk.edit.name\" data-limit=\"limits.desk\"></div></div></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Desk description</label><textarea class=\"sd-line-input__input\" ng-model=\"desk.edit.description\"></textarea></div></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Source for User Created Articles</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"desk.edit.source\" ng-keyup=\"handleEdit($event);\" required></div></div></div><div class=\"form__row form__row--flex\" ng-hide=\"!$root.config.features.slackNotifications\"><div class=\"form__row-item\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Slack Channel Name</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"desk.edit.slack_channel_name\" ng-keyup=\"handleEdit($event);\"> <span class=\"sd-line-input__hint\" translate>The name of a Slack channel associated with this desk, the # is not required</span></div></div></div><div sd-content-expiry data-item=\"desk.edit\" data-preview=\"false\" data-expiryfield=\"content_expiry\" data-header=\"Content Expiry\" data-expiry-minutes=\"systemExpiry\" data-expiry-context=\"System\"></div><div class=\"form__row form__row--flex\" ng-if=\"isPublishedContentExpired()\"><div class=\"form__row-item\"><span title=\"{{:: 'If selected, content published from this desk will be not be expired' | translate}}\"><span sd-switch ng-model=\"desk.edit.preserve_published_content\"></span><label translate>Preserve Published Content</label></span></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Desk Type</label><select class=\"sd-line-input__select\" id=\"deskType\" ng-model=\"desk.edit.desk_type\" required><option value=\"\"></option><option id=\"{{type.qcode}}\" ng-repeat=\"type in deskTypes\" value=\"{{type.qcode}}\" ng-selected=\"desk.edit.desk_type === type.qcode\">{{ type.name | translate}}</option></select><div ng-show=\"showNoPublishOnAuthoringDesk(desk.edit.desk_type)\" class=\"column\"><i class=\"icon-info-sign icon--blue\"></i><span class=\"helper-text helper-text--after-icon\" translate>Authoring desks are for content creation, and items within it are protected from accidental publication. Publishing is only permitted from production desks.</span></div></div></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Desk language</label><select class=\"sd-line-input__select\" id=\"deskLanguage\" ng-model=\"desk.edit.desk_language\"><option value=\"\"></option><option ng-repeat=\"language in languages\" value=\"{{language.language}}\" ng-selected=\"desk.edit.desk_language === language.language\">{{ language.label | translate}}</option></select></div></div></div><div class=\"form__row\"><div class=\"form__row-item\"><label class=\"form-label form-label--marg-b10\" translate>Default monitoring view</label><div class=\"sd-alert sd-alert--hollow sd-alert--small sd-alert--marg-b12\"><i class=\"icon-info-sign icon--blue icon--2x sd-alert__icon\"></i> <span>{{ :: 'You can choose the default content view of your desk. Use only if you want to override individual users\\' monitoring view preferences. Select \"none\" if you want to let users decide.' | translate }}</span></div><div><sd-check ng-repeat=\"(viewId, view) in monitoringViews\" type=\"radio\" label-position=\"inside\" ng-model=\"desk.edit.monitoring_default_view\" ng-click=\"desk.edit.monitoring_default_view = viewId\" ng-value=\"{{viewId}}\" data-icon=\"{{view.icon}}\">{{ view.label }}</sd-check></div></div></div><div class=\"form__row\"><label translate class=\"form-label form-label--marg-b10\">Service</label><div sd-meta-terms class=\"data\" data-item=\"desk.edit.desk_metadata\" data-field=\"anpa_category\" data-unique=\"qcode\" data-list=\"metadata.categories\" data-header=\"true\"></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Default Content Template</label><select ng-model=\"desk.edit.default_content_template\" ng-options=\"template._id as template.template_name for template in templates\" class=\"sd-line-input__select\"><option value=\"\"></option></select></div></div><div class=\"form__row\" ng-show=\"profiles.length\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Default Content Profile</label><select ng-model=\"desk.edit.default_content_profile\" ng-options=\"profile._id as profile.label for profile in profiles | orderBy: 'label'\" class=\"sd-line-input__select\"><option value=\"\"></option></select></div></div><fieldset class=\"form__row\"><legend translate>Preferred values for vocabularies</legend><div sd-prefered-cv-items-config ng-model=\"desk.edit.preferred_cv_items\"></fieldset></fieldset><span ng-show=\"message\">{{ message}}</span> <span class=\"alert-danger\" ng-show=\"_errorLimits\" translate>Character limit exceeded, desk can not be created/updated.</span> <span class=\"alert-danger\" ng-show=\"_error\">{{ _errorMessage}}</span></form><div class=\"modal__footer\" ng-if=\"step.current === 'general'\"><button id=\"next-general\" class=\"btn btn--primary\" ng-click=\"save(desk.edit)\" ng-disabled=\"!generalStep.$valid || _errorLimits || saving || !generalStep.$dirty\">{{ 'Save & Continue' | translate }}</button> <button id=\"done-general\" class=\"btn btn--primary\" ng-click=\"save(desk.edit, true)\" ng-disabled=\"!generalStep.$valid || _errorLimits || saving || !generalStep.$dirty\" translate>Done</button></div></div><div sd-wizard-step data-title=\"{{ :: 'Stages' | translate }}\" data-code=\"stages\"><div sd-deskedit-stages class=\"content stages form-flat\"><div class=\"grid grid--padding-fix\"><div class=\"grid__item grid__item--col-5\"><div class=\"heading\" translate>Work stages</div><div class=\"column\"><ul class=\"pills-list\" ng-class=\"{'edit-mode': editStage}\"><li class=\"stage editable addnew\" ng-show=\"editStage && !editStage._id\"><div class=\"sd-line-input\"><input class=\"sd-line-input__input\" type=\"text\" id=\"insert-stage\" ng-model=\"editStage.name\" required ng-keyup=\"handleEdit($event);\" autofocus placeholder=\"{{ 'New stage' | translate }}\"><div sd-character-count class=\"sd-line-input__char-count\" data-item=\"editStage.name\" data-limit=\"limits.stage\"></div></div></li><li ng-repeat=\"stage in stages track by stage._id\" ng-click=\"select(stage)\" ng-class=\"{active: selected === stage, editable: isActive(stage)}\"><div ng-if=\"!isActive(stage)\">{{ stage.name}}<label class=\"global-label\" ng-if=\"!stage.is_visible\"><span translate>Global Read</span><span translate>: OFF</span></label><label class=\"global-label\" ng-if=\"stage.local_readonly\"><span translate>Local Readonly</span><span translate>: ON</span></label></div><div ng-if=\"isActive(stage)\"><div class=\"sd-line-input\"><input class=\"sd-line-input__input\" type=\"text\" id=\"edit-stage\" ng-model=\"editStage.name\" ng-keyup=\"handleEdit($event);\" required><div sd-character-count class=\"sd-line-input__char-count\" data-item=\"editStage.name\" data-limit=\"limits.stage\"></div></div></div><div class=\"actions\" ng-if=\"!editStage\"><button ng-click=\"edit(stage)\"><i class=\"icon-pencil\"></i></button> <button ng-if=\"!stage.working_stage && !stage.default_incoming\" ng-click=\"remove(stage)\"><i class=\"icon-trash\"></i></button></div></li></ul><div class=\"button-toolbar\" ng-if=\"editStage && editStage._id\"><button class=\"btn\" ng-click=\"cancel()\" ng-disabled=\"saving\" translate>Cancel</button> <button id=\"save-edited-stage\" class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!enableSave() || saving\" translate>Save</button></div><div class=\"button-toolbar\" ng-if=\"editStage && !editStage._id\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button id=\"save-new-stage\" class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!enableSave()\" translate>Save</button></div><div ng-show=\"message\" class=\"sd-alert sd-alert--hollow sd-alert--alert\">{{ message}}</div><div ng-show=\"_errorUniqueness\" class=\"sd-alert sd-alert--hollow sd-alert--alert\"><span translate>Stage with name</span> \"{{ editStage.name}}\"\" <span translate>already exists</span>.</div><div ng-show=\"_errorLimits\" class=\"sd-alert sd-alert--hollow sd-alert--alert\" translate>Character limit exceeded, stage can not be created/updated.</div><div ng-show=\"_error\" class=\"sd-alert sd-alert--hollow sd-alert--alert\" translate>There was a problem, stage not created/updated.</div><button ng-if=\"!editStage && !editStage._id\" style=\"margin-top: 1.6rem\" id=\"new-stage\" class=\"btn btn--large btn--expanded\" data-target=\"#insert-stage\" ng-click=\"edit({}); selected = null\" ng-disabled=\"editStage\" sd-tooltip=\"{{'Create new Stage' | translate}}\"><i class=\"icon-plus-large\"></i></button></div></div><div class=\"grid__item grid__item--col-7\"><div class=\"heading\" translate>Stage Details</div><div ng-if=\"!selected && !editStage\" class=\"column\"><i class=\"icon-info-sign icon--blue\"></i><span class=\"helper-text helper-text--after-icon\">Click on a Work stage on the left to view details.</span></div><div ng-if=\"selected && !editStage\" class=\"column\"><div class=\"list-row list-row--dotted\" ng-if=\"selected.working_stage || selected.default_incoming\"><span ng-if=\"selected.working_stage\">{{:: 'Working Stage' | translate}}</span> <span ng-if=\"selected.working_stage && selected.default_incoming\">, </span><span ng-if=\"selected.default_incoming\">{{:: 'Incoming Stage' | translate}}</span></div><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"selected.is_visible\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Global Read: </span><span class=\"list-row__item\" translate>{{selected.is_visible ? 'ON' : 'OFF'}}</span></div><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"selected.local_readonly\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Local Read Only: </span><span class=\"list-row__item\" translate>{{selected.local_readonly ? 'ON' : 'OFF'}}</span></div><div class=\"list-row list-row--dotted\" ng-if=\"selected.description\"><span class=\"text-label list-row__item list-row__item--block\" translate>Stage description: </span><span class=\"list-row__item list-row__item--block\">{{ selected.description}}</span></div><div class=\"list-row list-row--dotted list-row--flex\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Content expiry: </span><span class=\"list-row__item\" sd-content-expiry data-item=\"selected\" data-preview=\"true\" data-expiryfield=\"content_expiry\" data-expiry-minutes=\"desk.edit.content_expiry > 0 ? desk.edit.content_expiry : systemExpiry\" data-expiry-context=\"{{desk.edit.content_expiry > 0 ? 'Desk' : 'System'}}\"></span></div><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"selected.incoming_macro\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Incoming Rule: </span><span class=\"list-row__item\">{{ selected.incoming_macro}}</span></div><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"selected.onstage_macro\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Moved onto stage Rule: </span><span class=\"list-row__item\">{{ selected.onstage_macro}}</span></div><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"selected.outgoing_macro\"><span class=\"text-label list-row__item list-row__item--grow\" translate>Outgoing Rule: </span><span class=\"list-row__item\">{{ selected.outgoing_macro}}</span></div></div><div class=\"column column--mb24\" ng-if=\"editStage\"><div class=\"list-row list-row--small\" title=\"{{ editStage.default_incoming ? 'Global Read OFF is not allowed for Incoming stage' : null | translate }}\"><span class=\"\" ng-class=\"{'prevent-off' : editStage.default_incoming && editStage.is_visible}\" sd-switch ng-model=\"editStage.is_visible\"></span><label>{{ :: 'Global Read' | translate }}</label></div><div class=\"list-row list-row--small\"><span class=\"\" sd-switch ng-model=\"editStage.local_readonly\"></span><label>{{ :: 'Local Read Only' | translate }}</label></div><div class=\"list-row list-row--small\"><span class=\"\" sd-switch ng-model=\"editStage.working_stage\"></span><label>{{:: 'Working Stage' | translate }}</label></div><div class=\"list-row list-row--small\"><span class=\"\" ng-click=\"shouldVisible()\" sd-switch ng-model=\"editStage.default_incoming\"></span><label>{{:: 'Incoming Stage' | translate }}</label></div></div><div class=\"form__row form__row--flex\" ng-if=\"editStage\"><div class=\"form__row-item\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\">{{ :: 'Stage description' | translate }}</label><textarea class=\"sd-line-input__input\" ng-model=\"editStage.description\"></textarea></div></div></div><div sd-content-expiry data-item=\"editStage\" ng-if=\"editStage\" data-preview=\"false\" data-expiryfield=\"content_expiry\" data-header=\"Content Expiry\" data-expiry-minutes=\"desk.edit.content_expiry > 0 ? desk.edit.content_expiry : systemExpiry\" data-expiry-context=\"{{ desk.edit.content_expiry > 0 ? 'Desk' : 'System' }}\"></div><div ng-if=\"editStage\"><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Incoming Rule' | translate }}</label><select ng-model=\"editStage.incoming_macro\" class=\"sd-line-input__select\"><option value=\"\"></option><option ng-repeat=\"macro in macros\" ng-selected=\"editStage.incoming_macro === macro.name\" value=\"{{macro.name}}\">{{macro.label}}</option></select></div></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Moved onto stage Rule' | translate }}</label><select ng-model=\"editStage.onstage_macro\" class=\"sd-line-input__select\"><option value=\"\"></option><option ng-repeat=\"macro in macros\" ng-selected=\"editStage.onstage_macro === macro.name\" value=\"{{macro.name}}\">{{macro.label}}</option></select></div></div></div><div class=\"form__row form__row--flex\"><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Outgoing Rule' | translate }}</label><select ng-model=\"editStage.outgoing_macro\" class=\"sd-line-input__select\"><option value=\"\"></option><option ng-repeat=\"macro in macros\" ng-selected=\"editStage.outgoing_macro === macro.name\" value=\"{{macro.name}}\">{{macro.label}}</option></select></div></div></div></div></div></div></div><div class=\"modal__footer\" ng-if=\"step.current === 'stages'\"><button id=\"next-stages\" class=\"btn btn--primary\" ng-disabled=\"message != null || (editStage && editStage._id) || (editStage && !editStage._id)\" ng-click=\"next()\" translate>Continue</button> <button id=\"done-stages\" class=\"btn btn--primary\" ng-disabled=\"message != null || (editStage && editStage._id) || (editStage && !editStage._id)\" ng-click=\"next(true)\" translate>Done</button></div></div><div sd-wizard-step data-title=\"{{ 'People' | translate }}\" data-code=\"people\"><div sd-deskedit-people class=\"content people-stage\"><div class=\"header\" sd-user-select-list data-exclude=\"deskMembers\" data-onchoose=\"add(user)\"></div><div><p ng-show=\"message\">{{ message}}</p><div class=\"members-list\"><ul class=\"pills-list\"><li ng-repeat=\"user in deskMembers| orderBy: 'display_name' track by user._id\" ng-class=\"{'inactive' : !user.is_enabled || !user.is_active}\"><figure class=\"avatar\"><img sd-user-avatar data-user=\"user\"></figure><h5>{{:: user.display_name}}</h5><span class=\"user-email\">{{:: user.email}}</span><div class=\"actions\"><button ng-click=\"remove(user)\"><i class=\"icon-close-small\"></i></button></div></li></ul></div></div><span class=\"alert-danger\" ng-show=\"_errorMessage\">{{ _errorMessage}}</span></div><div class=\"modal__footer\" ng-if=\"step.current === 'people'\"><button id=\"next-people\" class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"message != null || saving\">{{ 'Save & Continue' | translate }}</button> <button id=\"done-people\" class=\"btn btn--primary\" ng-click=\"save(true)\" ng-disabled=\"message != null || saving\" translate>Done</button></div></div><div sd-wizard-step data-title=\"{{ 'Macros' | translate }}\" data-code=\"macros\"><div class=\"content macros\" sd-deskedit-macros><ul class=\"pills-list\"><li ng-repeat=\"macro in macros\" class=\"clearfix\"><h6 class=\"pull-left\">{{:: macro.name}}</h6><div class=\"label-group label-group--right\"><span class=\"label label--hollow\">{{:: macro.access_type}}</span><span class=\"label label--hollow\">{{:: macro.action_type}}</span></div></li></ul></div><div class=\"modal__footer\" ng-if=\"step.current === 'macros'\"><button id=\"save\" class=\"btn btn--primary\" ng-click=\"save()\" translate>Done</button></div></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/desk-select.html', "<div class=\"dropdown dropdown--noarrow dropdown--dark dropdown--full-width\" dropdown is-open=\"isOpen\" tabindex=\"\"><button class=\"dropdown__toggle dropdown__toggle--line\" dropdown__toggle><span ng-show=\"!selectedDesk\" translate>Select desk</span> <span ng-show=\"selectedDesk\">{{ defaultDesk && defaultDesk._id === selectedDesk._id ? 'Default' : selectedDesk.name | translate}}</span> <b class=\"dropdown__caret white\"></b></button><ul class=\"dropdown__menu\"><li ng-show=\"filter\"><span translate>filter: \"{{filter}}\"</span></li><li ng-repeat=\"desk in desks | orderBy:deskPreferenceOrdering track by desk._id\"><button ng-click=\"onChange({desk: desk})\" sd-desk-select-item>{{ :: desk.name }}</button></li></ul></div>");
        $templateCache.put('scripts/apps/desks/views/desk-tasks.html', "<div class=\"desk__header\"><div class=\"desk__name\">{{ desk.name }} <span class=\"desk__open\" ng-if=\"isMemberOf(desk)\" ng-click=\"openDeskView(desk, 'task')\" title=\"{{ 'Open desk content' | translate}}\"><i class=\"icon-external\"></i></span></div><div class=\"desk__action dropdown dropdown--align-right\" dropdown ng-if=\"privileges.desks\"><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><ul class=\"dropdown__menu pull-right\"><li><button ng-click=\"openDesk('general', desk)\"><i class=\"icon-pencil\"></i> {{ 'Edit desk' | translate }}</button></li></ul></div></div><div class=\"desk__content\"><div class=\"item-group\" ng-repeat=\"status in statuses\"><div class=\"item-group__header\"><div class=\"item-group__name item-group__name--{{status._id}}\">{{status.name}}</div><span class=\"badge badge--light pull-right\">{{total}}</span></div><div class=\"item-group__content\" sd-task-status-items data-status=\"status._id\" data-desk=\"desk._id\" data-total=\"total\"></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/desk.html', "<div class=\"desk__header\"><div class=\"desk__name\">{{ desk.name }} <span class=\"desk__open\" ng-if=\"isMemberOf(desk)\" ng-click=\"openDeskView(desk, 'content')\" title=\"{{ 'Open desk content' | translate}}\"><i class=\"icon-external\"></i></span></div><div class=\"desk__action dropdown dropdown--align-right\" dropdown ng-if=\"privileges.desks\"><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><ul class=\"dropdown__menu pull-right\"><li><button ng-click=\"openDesk('general', desk)\"><i class=\"icon-pencil\"></i> {{ 'Edit desk' | translate }}</button></li></ul></div></div><div class=\"desk__content\"><div class=\"item-group\" ng-repeat=\"stage in deskStages[desk._id]\"><div class=\"item-group__header\"><div class=\"item-group__name\">{{ :: stage.name}}</div><span class=\"badge badge--light pull-right\">{{ total }}</span></div><div class=\"item-group__content\" sd-widget-group data-stage=\"stage\" data-total=\"total\" data-allowed=\"isMemberOf(desk)\" data-show-empty=\"true\" data-selected=\"selected\"></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/main.html', "<div class=\"subnav subnav--absolute\"><div class=\"button-list button-list--padded desk-tabs\"><a href=\"\" ng-repeat=\"v in views\" ng-class=\"{'toggle-button--active': v === view}\" id=\"{{v}}\" ng-click=\"setView(v)\" class=\"toggle-button\">{{v | translate}}</a><div class=\"online-users\" ng-if=\"view === 'users'\"><p><span sd-check ng-model=\"online_users\" name=\"online_users\" id=\"online_users\" ng-change=\"changeOnlineUsers(online_users)\"></span></p><label translate>show only online users</label></div></div></div><section class=\"main-section master-desk-view\" sd-desk-config><div class=\"main-desk-container\"><div class=\"desk-container\" ng-if=\"view === 'content'\" ng-repeat=\"desk in desks._items | orderBy: 'name'\"><div class=\"desk\" ng-include=\"'scripts/apps/desks/views/desk.html'\"></div></div><div class=\"desk-container\" ng-if=\"view === 'tasks'\" ng-repeat=\"desk in desks._items | orderBy: 'name'\"><div class=\"desk\" ng-include=\"'scripts/apps/desks/views/desk-tasks.html'\"></div></div><div class=\"desk-container\" ng-if=\"view === 'users'\" ng-repeat=\"desk in desks._items | orderBy: 'name'\"><div class=\"desk\" ng-include=\"'scripts/apps/desks/views/desk_users.html'\"></div></div><div class=\"desk-container\" ng-if=\"view === 'sluglines'\" ng-repeat=\"desk in desks._items | orderBy: 'name'\"><div class=\"desk\" ng-include=\"'scripts/apps/desks/views/slugline.html'\"></div></div></div><div sd-desk-config-modal data-active=\"modalActive\" data-desk=\"desk\" data-desks=\"desks\" data-step=\"step\" data-cancel=\"cancel()\"></div></section>");
        $templateCache.put('scripts/apps/desks/views/mark_desks_dropdown_directive.html', "<ul><li ng-if=\"desks.length\" ng-repeat=\"d in desks track by d._id\"><button ng-disabled=\"isMarked(d)\" option=\"{{ d.name }}\" ng-click=\"markItem(d);\"><i class=\"icon-bell\"></i>{{ :: d.name | translate }}</button></li><li ng-if=\"!desks.length\"><button ng-disabled=\"true\">{{::'No available desks'|translate}}</button></li></ul>");
        $templateCache.put('scripts/apps/desks/views/mark_desks_dropdown.html', "<div sd-mark-desks-dropdown></div>");
        $templateCache.put('scripts/apps/desks/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" sd-desk-config><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Desk management</h2></div><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button id=\"add-new-desk\" class=\"btn btn--primary\" ng-click=\"openDesk('general')\"><i class=\"icon-plus-sign icon--white\"></i> {{ :: 'Add New' | translate }}</button></div><div class=\"sd-page__content desk-settings\"><div class=\"flex-grid box wrap-items small-1 medium-3 large-4 xlarge-6\"><div class=\"flex-item card-box\" ng-repeat=\"desk in desks._items | filter:query track by desk._id\"><div class=\"card-box__header\"><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu more-activity-menu pull-right\"><li><div class=\"dropdown__menu-label\" translate>Actions</div></li><li class=\"dropdown__menu-divider\"></li><li><button ng-click=\"openDesk('general', desk)\" title=\"{{:: 'Edit desk'| translate }}\"><i class=\"icon-pencil\"></i>{{:: 'Edit'| translate}}</button></li><li><button ng-click=\"openMonitoringSettings(desk)\" title=\"{{:: 'Monitoring settings'| translate }}\"><i class=\"icon-settings\"></i>{{:: 'Monitoring settings'| translate}}</button></li><li><button ng-click=\"remove(desk)\" title=\"{{:: 'Remove desk'| translate }}\"><i class=\"icon-trash\"></i>{{:: 'Remove'| translate}}</button></li></ul></div><div class=\"card-box__heading\">{{ desk.name }}</div></div><div class=\"card-box__content\"><ul class=\"card-box__content-list\"><li><h4>{{ :: 'Stages' | translate }}<span class=\"label\">{{getDeskStages(desk).length}}</span></h4><span ng-repeat=\"stage in getDeskStages(desk) track by stage._id\" class=\"card-box__content-list-inline-span\">{{stage.name}}<span ng-if=\"$index < getDeskStages(desk).length-1\">,&nbsp;</span></span></li><li><h4>{{ :: 'People' | translate }}<span class=\"label\">{{getDeskUsers(desk).length}}</span></h4><span ng-repeat=\"user in getDeskUsers(desk) track by user._id\" ng-if=\"$index < numberOfUsers\" class=\"card-box__content-list-inline-span\">{{user.display_name}}<span ng-if=\"$index < getDeskUsers(desk).length-1\">,&nbsp;</span> <span ng-if=\"getDeskUsers(desk).length > numberOfUsers && $index === numberOfUsers-1\" ng-click=\"openDesk('people', desk)\" class=\"button__view-all\">... {{ :: 'view all' | translate }}</span></span></li><li class=\"card-box__content-list-item--inline\"><h4>{{ :: 'Desk Type' | translate }}</h4><span>{{ desk.desk_type | translate }}</span></li><li ng-if=\"desk.preserve_published_content\"><h4>{{ :: 'Published Content' | translate }}</h4><span>{{ :: 'Not Expired' | translate }}</span></li><li class=\"card-box__content-list-item--inline\" ng-if=\"desk.desk_language\"><h4>{{ :: 'Language' | translate }}</h4><span>{{ desk.desk_language | translate }}</span></li></ul></div></div></div></div><div sd-aggregate-settings data-modal-active=\"agg.modalActive\" data-desks=\"agg.desks\" data-desk-stages=\"agg.deskStages\" data-searches=\"agg.searches\" data-desk-lookup=\"agg.deskLookup\" data-stage-lookup=\"agg.stageLookup\" data-search-lookup=\"agg.searchLookup\" data-groups=\"agg.groups\" data-edit-groups=\"agg.editGroups\" data-settings=\"agg.settings\"></div><div sd-desk-config-modal data-active=\"modalActive\" data-desk=\"desk\" data-desks=\"desks\" data-step=\"step\" data-cancel=\"cancel()\"></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/desks/views/slugline-items.html', "<div class=\"item-group\" ng-if=\"!items.length\"><div ng-if=\"loading\" class=\"item-group__loading\"></div><div ng-if=\"!loading && !items.length\" class=\"item-group__no-items\">{{:: 'No items published' |translate }}</div></div><div class=\"item-group\" ng-if=\"!loading && items.length\" ng-repeat=\"item_group in items\"><div class=\"item-group__header\"><div class=\"item-group__name\">{{ :: item_group.place}}</div><span class=\"badge badge--light pull-right\">{{ item_group.items.length }}</span></div><div class=\"item-group__content\"><ul class=\"inline-content-items\"><li ng-repeat=\"item in item_group.items\" class=\"slugline-item\"><div class=\"slugline-item__row slugline-item__row--main\"><time sd-datetime data-date=\"item.versioncreated\" class=\"pull-right\"></time> <span class=\"slugline\">{{::item.slugline}}</span></div><div ng-show=\"item.old_sluglines.length !== 0\" class=\"slugline-item__row\"><span class=\"oldslugline\">{{::item.old_sluglines}}</span></div><div class=\"slugline-item__row\"><span class=\"headline\">{{::item.headline}}</span></div></li></ul></div></div>");
        $templateCache.put('scripts/apps/desks/views/slugline.html', "<div class=\"desk__header\"><div class=\"desk__name\">{{ desk.name }} <span class=\"desk__open\" ng-if=\"isMemberOf(desk)\" ng-click=\"openDeskView(desk, 'content')\" title=\"{{ 'Open desk content' | translate}}\"><i class=\"icon-external\"></i></span></div><div class=\"desk__action dropdown dropdown--align-right\" dropdown ng-if=\"privileges.desks\"><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><ul class=\"dropdown__menu pull-right\"><li><button ng-click=\"openDesk('general', desk)\"><i class=\"icon-pencil\"></i> {{ 'Edit desk' | translate }}</button></li></ul></div></div><div class=\"desk__content\"><div sd-sluglines-items data-desk=\"desk._id\"></div></div>");
        $templateCache.put('scripts/apps/desks/views/stage-header.html', "<div class=\"stage-header\"><button class=\"stage-header__toggle\" ng-if=\"agg.state.solo._id !== group._id\" ng-class=\"{closed: !agg.getExpandedState(group._id)}\" ng-click=\"agg.switchExpandedState(group._id)\"><i class=\"icon-chevron-down-thin\"></i></button> <span class=\"stage-header__name\"><a class=\"stage-header__name-part\" href=\"\" ng-show=\"agg.state.solo._id !== group._id\" ng-click=\"agg.setSoloGroup(group)\"><span>{{ :: group.header }} </span><span>/</span> <span ng-show=\"group.subheader\">{{ :: group.subheader }}</span><span>{{ :: group.type | translate }}</span> </a><span class=\"stage-header__name-part\" ng-show=\"agg.state.solo._id === group._id\"><a ng-click=\"agg.setSoloGroup()\" class=\"backlink\"></a> <span>{{ :: group.header }} </span><span>/</span> <span ng-show=\"group.subheader\">{{ :: group.subheader }}</span><span>{{ :: group.type | translate }}</span></span></span><div class=\"stage-header__line\" ng-if=\"agg.state.solo._id !== group._id\"></div><span class=\"label-total stage-header__number\">{{ total}}</span></div>");
        $templateCache.put('scripts/apps/desks/views/task-status-items.html', "<div ng-if=\"loading\" class=\"item-group__loading\"></div><div ng-if=\"!loading && !items.length\" class=\"item-group__no-items\" translate>No items with this status</div><ul ng-if=\"!loading && items.length\" class=\"inline-content-items content-tasks\"><li ng-repeat=\"item in items\" class=\"content-item content-item--no-border\" ng-click=\"action({item: item})\"><div><figure class=\"avatar small\" title=\"{{users[item.task.user].display_name}}\"><img sd-user-avatar data-user=\"users[item.task.user]\"></figure></div><div class=\"content-item__text\">{{item.slugline}}</div></li></ul>");
        $templateCache.put('scripts/apps/desks/views/user-role-items.html', "<ul ng-if=\"!loading && items.length\" class=\"inline-content-items content-tasks\"><li ng-repeat=\"item in items track by item._id\" class=\"content-item content-item--no-border shifted\" ng-if=\"!online || isLoggedIn(item)\"><figure class=\"avatar avatar-with-info small\" title=\"{{item.display_name}}\" ng-class=\"{'user-logged': isLoggedIn(item)}\"><div class=\"logged-info\"></div><div class=\"user-image\"><img sd-user-avatar data-user=\"item\"></div></figure><div class=\"content-item__text\">{{item.display_name}}</div><div class=\"content-item__action\" ng-if=\"privilege\"><button ng-click=\"openEditUser(item)\" title=\"{{ :: 'Edit user' | translate }}\"><i class=\"icon-pencil\"></i></button></div></li></ul><div sd-modal data-model=\"user\" data-close=\"closeEditUser()\" class=\"user-profile-page\"><div class=\"modal__header\"><a href=\"\" class=\"modal__close pull-right\" ng-click=\"closeEditUser()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Edit user</h3></div><div class=\"modal__body\"><div class=\"user-details-pane\" sd-user-edit data-user=\"user\" data-oncancel=\"closeEditUser()\" data-onsave=\"closeEditUser()\"></div></div></div>");
        $templateCache.put('scripts/apps/desks/views/user-select.html', "<form><input type=\"text\" ng-model=\"search\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" tabindex=\"{{tabindex}}\" class=\"searchbar searchbar-large\"></form><div class=\"search-result\" ng-show=\"search\"><ul class=\"users-list-embed\"><li ng-repeat=\"user in users._items\" ng-class=\"{active: user === selected, 'inactive' : !user.is_enabled || !user.is_active}\" ng-click=\"choose(user)\"><figure class=\"avatar small\"><img sd-user-avatar data-user=\"user\"></figure><div class=\"name\">{{ getUserDisplay(user) }}</div></li></ul></div>");
        $templateCache.put('scripts/apps/dictionaries/views/dictionary-config-modal.html', "<form name=\"editForm\"><div sd-modal data-model=\"dictionary\" data-close=\"cancel()\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"!dictionary._id\" translate>Add New {{(isAbbreviations() ? 'Abbreviations' : '') | translate}} Dictionary</h3><h3 class=\"modal__heading\" ng-show=\"dictionary._id\" translate>Edit {{(isAbbreviations() ? 'Abbreviations' : '') | translate}} Dictionary</h3><a href=\"\" class=\"icn-btn close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><div class=\"upload-progress\" ng-if=\"progress.width\"><div class=\"bar\" style=\"width: {{ progress.width}}%\"></div></div><ng-form name=\"dictionaryForm\"><fieldset><div class=\"form__row\"><span sd-switch ng-model=\"dictionary.is_active\"></span><label>{{ :: 'Active' | translate }}</label></div><div class=\"sd-line-input sd-line-input--required sd-line-input--boxed\" ng-class=\"{'sd-line-input--invalid' : _errorUniqueness && !dictionary.user}\"><label for=\"dict-name\" class=\"sd-line-input__label\">{{'Dictionary name' | translate}}</label><input id=\"dict-name\" class=\"sd-line-input__input\" type=\"text\" ng-if=\"!dictionary.user\" ng-model=\"dictionary.name\" required> <input class=\"sd-line-input__input\" type=\"text\" ng-if=\"dictionary.user\" value=\"{{ :: (!isAbbreviations() ? 'Personal' : 'Abbreviations') | translate}}\" disabled><div ng-show=\"_errorUniqueness && !dictionary.user\" class=\"sd-line-input__message\"><span translate>Dictionary with name {{dictionary.name}} already exists.</span></div></div><div class=\"sd-line-input sd-line-input--required\" ng-class=\"{'sd-line-input--invalid' : _errorUniqueness && dictionary.user}\"><label class=\"sd-line-input__label\" for=\"dict-lang-code\">{{'Language code' | translate}}</label><input class=\"sd-line-input__input\" id=\"dict-lang-code\" type=\"text\" ng-model=\"dictionary.language_id\" required><div ng-show=\"_errorUniqueness && dictionary.user\" class=\"sd-line-input__message\"><span translate>Personal dictionary for language \"{{dictionary.language_id}}\" already exists.</span></div></div><div class=\"sd-line-input\" ng-if=\"!isAbbreviations()\"><label class=\"sd-line-input__label\" for=\"dict-file\">{{'Dictionary file' | translate}}</label><input id=\"dict-file\" name=\"upload\" type=\"file\" class=\"sd-line-input__input\" accept=\"text/plain\" file-upload ng-model=\"file\" sd-file-type-validator><div class=\"sd-line-input__message error\" ng-show=\"editForm.$error.fileType\">{{'Please use plain text dictionary. | translate'}}</div></div></fieldset><p ng-if=\"message\">{{ message}}</p><p ng-show=\"_errorLimits\" translate>Character limit exceeded, dictionary can not be created/updated.</p><span ng-show=\"_error\" translate>There was a problem, dictionary not created/updated.</span></ng-form><ng-form ng-if=\"dictionary._id && !isAbbreviations()\"><fieldset><label for=\"words-search\">{{ :: 'Search' | translate }} (<span translate translate-n=\"wordsCount\" translate-plural=\"{{ $count}} words\">{{ wordsCount}} word</span>)</label><div class=\"form__row form__row--flex form__row--no-padding\"><div class=\"sd-line-input sd-line-input--no-label sd-line-input--no-margin\"><input id=\"words-search\" type=\"text\" class=\"sd-line-input__input\" ng-model=\"search\" ng-model-options=\"{debounce: 500}\" ng-change=\"filterWords(search)\"></div><button class=\"btn flex-field no-shrink\" type=\"submit\" ng-disabled=\"!isNew\" ng-click=\"addWord(search)\" translate>ADD WORD</button></div><ul vs-repeat class=\"words-list\" ng-show=\"words.length\">{{words.length}}<li ng-repeat=\"word in words track by word\">{{ :: word}} <button class=\"icn-btn\" ng-click=\"removeWord(word, search)\"><i class=\"icon-trash\"></i></button></li></ul></fieldset></ng-form><ng-form name=\"abbreviationsForm\" ng-if=\"isAbbreviations()\"><fieldset class=\"form__block form__block--light\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"abbreviation\" translate>Abbreviation</label><input class=\"sd-line-input__input\" id=\"abbreviation\" type=\"text\" ng-model=\"abbreviation.key\" required></div><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"phrase\" translate>Phrase</label><input class=\"sd-line-input__input\" id=\"phrase\" type=\"text\" ng-model=\"abbreviation.phrase\" required></div><div class=\"sd-text__right\"><button class=\"btn btn--hollow btn--\" ng-click=\"addAbbreviation()\" ng-disabled=\"abbreviationsForm.$invalid\" translate>Add Abbreviation</button></div></fieldset><div class=\"abbreviations-list\" ng-if=\"abbreviationKeys.length\"><div class=\"abbreviations-list__item abbreviations-list__item--heading\"><div class=\"abbreviations-field\"><label>{{ :: 'Abbreviation' | translate}}</label></div><div class=\"abbreviations-field\"><label>{{ :: 'Phrase' | translate}}</label></div></div><div class=\"abbreviations-list__item\" ng-repeat=\"key in abbreviationKeys track by key\"><div class=\"abbreviations-field abbreviations-field--abbreviation\"><label>{{key}}</label></div><div class=\"abbreviations-field abbreviations-field--grow\"><div class=\"sd-line-input sd-line-input--no-margin sd-line-input--no-label sd-line-input--boxed sd-line-input--required\"><input type=\"text\" ng-model=\"dictionary.content[key]\" class=\"long-name sd-line-input__input\"></div></div><button class=\"icn-btn\" ng-click=\"removeAbbreviation(key)\"><i class=\"icon-small icon-trash\"></i></button></div></div></ng-form></div><div class=\"modal__footer\"><button id=\"save-edit-btn\" type=\"submit\" class=\"btn btn--primary pull-right\" ng-click=\"save()\" ng-disabled=\"editForm.$invalid || progress.width\" translate>Save</button> <button id=\"cancel-edit-btn\" type=\"button\" class=\"btn pull-right\" ng-click=\"cancel()\" translate>Cancel</button></div></div></form>");
        $templateCache.put('scripts/apps/dictionaries/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" sd-dictionary-config><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Dictionary management</h2></div><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span><div class=\"dropdown dropdown--align-right\" dropdown style=\"margin-right: -20px\" data-sd-tooltip=\"{{ :: 'Add new' | translate }}\" data-flow=\"left\"><button class=\"navbtn dropdown sd-create-btn\" dropdown__toggle><i class=\"icon-plus-large\"></i> <span class=\"circle\"></span></button><ul class=\"dropdown__menu\"><li><div class=\"dropdown__menu-label\">Add new</div></li><li class=\"dropdown__menu-divider\"></li><li><button id=\"createDictionary\" ng-if=\"isAdmin()\" ng-click=\"createDictionary()\"><i class=\"icon-plus-sign icon--blue\"></i>{{ :: 'Dictionary' | translate }}</button></li><li><button id=\"createPersonalDictionary\" ng-click=\"createPersonalDictionary()\"><i class=\"icon-plus-sign icon--blue\"></i>{{ :: 'Personal Dictionary' | translate }}</button></li><li><button id=\"createAbbreviations\" ng-click=\"createAbbreviationsDictionary()\"><i class=\"icon-plus-sign icon--blue\"></i>{{ :: 'Abbreviations Dictionary' | translate }}</button></li></ul></div></div><div class=\"sd-page__content dictionary-settings\" sd-loading=\"loading\"><ul class=\"pills-list\"><li ng-repeat=\"dictionary in dictionaries | filter:searchDictionary track by dictionary._id\" ng-class=\"{inactive: dictionary.is_active === 'false'}\"><div ng-if=\"!dictionary.user\"><h6>{{ dictionary.name }}</h6>&nbsp;<em><strong>({{ :: dictionary.language_id }})</strong></em></div><div ng-if=\"dictionary.user\"><h6 id=\"{{dictionary.language_id}}\">{{ :: 'Personal' | translate }}{{ :: (isAbbreviations(dictionary) ? ' - Abbreviations' : '') | translate }}</h6>&nbsp; <em><strong>({{ :: dictionary.language_id }})</strong></em></div><div class=\"actions\"><button ng-click=\"openDictionary(dictionary)\" title=\"{{:: 'Edit dictionary' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(dictionary)\" title=\"{{:: 'Remove dictionary' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul></div><div sd-dictionary-config-modal ng-if=\"dictionary\"></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/highlights/views/create_highlights_button_directive.html', "<span id=\"createHighlight\"><button id=\"create\" class=\"btn btn--primary pull-right\" ng-click=\"createHighlight(null)\" ng-if=\"hasMarkItemPrivilege\" tooltip=\"{{ :: 'Create highlight' | translate }}\" tooltip-placement=\"left\" translate>Create</button></span>");
        $templateCache.put('scripts/apps/highlights/views/highlights_config_modal.html', "<div sd-modal data-model=\"modalActive\" data-close=\"cancel()\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"!configEdit._id\" translate>Create highlight configuration</h3><h3 class=\"modal__heading\" ng-show=\"configEdit._id\" translate>Edit \"{{configEdit.name}}\" highlight</h3><a href=\"\" class=\"close icn-btn\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><form name=\"highlightForm\"><fieldset><div class=\"sd-line-input sd-line-input--required sd-line-input--boxed\" ng-class=\"{'sd-line-input--invalid' : _errorUniqueness || _errorLimits}\"><label class=\"sd-line-input__label\">{{'Configuration name' | translate}}</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"configEdit.name\" ng-keyup=\"handleEdit($event);\" required><div class=\"sd-line-input__char-count\" sd-character-count data-item=\"configEdit.name\" data-limit=\"limits.highlight\"></div><div ng-show=\"_errorLimits\" class=\"sd-line-input__message sd-line-input__message--with-char-count\"><span translate>Character limit exceeded, highlight can not be created/updated.</span></div><div ng-show=\"_errorUniqueness\" class=\"sd-line-input__message\"><span translate>Highlight with name</span> \"{{ configEdit.name }}\" <span translate>already exists</span>.</div></div><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{'Template' | translate}}</label><select class=\"sd-line-input__select\" ng-model=\"configEdit.template\" name=\"template\" id=\"template\"><option id=\"default\" value=\"\" ng-selected=\"!configEdit.template\" translate>default template</option><option id=\"{{template.template_name}}\" ng-repeat=\"template in templates\" value=\"{{template._id}}\" ng-selected=\"configEdit.template === template._id\">{{ template.template_name }}</option></select></div><div class=\"form__row\"><label class=\"form-label form__row-label\">{{'Assigned desks' | translate}}</label><div class=\"multi-select\"><ul class=\"simple-list simple-list--dotted simple-list--no-padding\"><li ng-repeat=\"desk in assignedDesks\" class=\"simple-list__item\"><span sd-check ng-model=\"desk.included\"></span> <span class=\"text\" ng-click=\"desk.included = !desk.included\">{{desk.name}}</span></li></ul></div></div><div class=\"sd-line-input sd-line-input--is-select\" title=\"{{ :: 'When creating a highlights package' | translate }}\"><label class=\"sd-line-input__label\">{{'Automatically insert items from' | translate}}</label><select class=\"sd-line-input__select\" ng-model=\"configEdit.auto_insert\"><option value=\"{{ :: auto.day }}\" ng-selected=\"configEdit.auto_insert === auto.day\" translate>Today</option><option value=\"{{ :: auto.week }}\" ng-selected=\"configEdit.auto_insert === auto.week\" translate>This week</option><option ng-repeat=\"hour in hours\" value=\"{{ :: getHourVal(hour) }}\" ng-selected=\"configEdit.auto_insert === getHourVal(hour)\"><span translate>Last</span> {{ hour }} <span translate>hours</span></option></select><span class=\"sd-line-input__hint\">{{ :: 'When creating a highlights package' | translate }}</span></div></fieldset><p ng-if=\"message\">{{ message }}</p></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!highlightForm.$valid || editingGroup || _errorLimits || !highlightForm.$dirty\" translate>Save</button></div></div>");
        $templateCache.put('scripts/apps/highlights/views/highlights_info_directive.html', "<div ng-if=\"!item.archive_item\" sd-marked-item-title data-item=\"item\" data-field=\"highlights\"></div><div ng-if=\"!item.archive_item\" sd-marked-item-title data-item=\"item\" data-field=\"marked_desks\"></div>");
        $templateCache.put('scripts/apps/highlights/views/mark_highlights_dropdown_directive.html', "<ul><li ng-if=\"highlights.length\" ng-repeat=\"h in highlights track by h._id\"><button ng-disabled=\"isMarked(h)\" option=\"{{ h.name }}\" ng-click=\"markItem(h);\"><i class=\"icon-star\"></i>{{ :: h.label | translate }}</button></li><li ng-if=\"!highlights.length\"><button ng-disabled=\"true\">{{::'No available highlights'|translate}}</button></li></ul>");
        $templateCache.put('scripts/apps/highlights/views/mark_highlights_dropdown.html', "<div sd-mark-highlights-dropdown></div>");
        $templateCache.put('scripts/apps/highlights/views/menu.html', "<div class=\"dropdown dropdown--dropright dropdown--hover highlights-dropdown\" title=\"{{ item.label | translate }}\" sd-hotkey=\"ctrl+alt+h\" sd-hotkey-options=\"{global: true}\" sd-hotkey-callback=\"highlightsHotkey\" dropdown sd-package-highlights-dropdown></div>");
        $templateCache.put('scripts/apps/highlights/views/package_highlights_dropdown_directive.html', "<div id=\"highlightPackage\"><button class=\"dropdown__toggle sd-sidebar-menu__btn\" ng-click=\"hideMonitoring(currentRoute.href === '/workspace/highlights', $event)\" dropdown__toggle><i class=\"sd-sidebar-menu__main-icon big-icon--marked-star\"></i> <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i></button><ul class=\"dropdown__menu pull-left\"><li><div class=\"dropdown__menu-label\" translate>Choose highlight list</div></li><li ng-if=\"hasHighlights\" ng-repeat=\"h in highlights track by h._id\"><button option=\"{{ :: h.name }}\" ng-click=\"listHighlight(h);\" title=\"{{ :: h.name }}\">{{ :: h.label | translate }}</button></li><li ng-if=\"!hasHighlights\"><button ng-disabled=\"true\">{{::'No available highlights'|translate}}</button></li></ul></div>");
        $templateCache.put('scripts/apps/highlights/views/search_highlights_dropdown_directive.html', "<div id=\"search-highlights\" ng-show=\"highlights\" ng-if=\"hasHighlights()\"><div class=\"dropdown more-actions\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu pull-right\"><li><button option=\"NO FILTER\" ng-click=\"selectHighlight();\" translate>No Filter</button></li><li ng-repeat=\"h in highlights\"><button option=\"{{ h.name }}\" ng-click=\"selectHighlight(h);\">{{ h.name }}</button></li></ul></div></div>");
        $templateCache.put('scripts/apps/highlights/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" sd-highlights-config><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Highlights configurations</h2></div><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary pull-right\" ng-click=\"edit({})\"><i class=\"icon-plus-sign icon--white\"></i>{{ 'Create configuration' | translate }}</button></div><div class=\"sd-page__content\"><ul class=\"pills-list\"><li ng-repeat=\"config in configurations._items | filter: query track by config._id\" class=\"clearfix\"><h6 class=\"pull-left\" title=\"{{ config.name }}\">{{ config.name }}</h6><div class=\"actions\"><button ng-click=\"edit(config)\" title=\"{{:: 'Edit configuration' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(config)\" title=\"{{:: 'Remove configuration' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul></div><div sd-highlights-config-modal></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/ingest/ingest-stats-widget/configuration.html', "<div ng-controller=\"IngestStatsConfigController\" class=\"widget-config\"><form class=\"form-horizontal\"><fieldset><div class=\"field\"><label translate>Select source</label><div class=\"control\"><select ng-model=\"configuration.source\" class=\"input-medium\"><option value=\"source\" translate>Source stats</option><option value=\"urgency\" translate>Urgency stats</option><option value=\"type\" translate>Item type stats</option></select></div></div><div class=\"field\"><label translate>Select color</label><div class=\"control\"><select class=\"input-medium\" ng-model=\"configuration.colorScheme\" ng-options=\"scheme.name as scheme.name for scheme in schemes\"></select></div></div></fieldset></form></div>");
        $templateCache.put('scripts/apps/ingest/ingest-stats-widget/widget-ingeststats.html', "<div><div ng-controller=\"IngestStatsController\"><div sd-pie-chart-dashboard data-terms=\"items._aggregations[widget.configuration.source].buckets\" data-colors=\"widget.configuration.colorScheme\"></div></div></div>");
        $templateCache.put('scripts/apps/ingest/views/dashboard/dashboard.html', "<div class=\"subnav subnav--absolute\"><h3 class=\"page-nav-title\" translate>Ingest Dashboard</h3><div class=\"button-stack right-stack\"><div id=\"ingest-dashboard-dropdown\" class=\"dropdown strict\" dropdown sd-tooltip=\"{{ :: 'Add Sources' | translate }}\" flow=\"left\"><button class=\"navbtn dropdown__toggle sd-create-btn\" dropdown__toggle></button><ul class=\"dropdown__menu dropdown__menu--scrollable pull-right source-list\" sd-user-ingest-dashboard-drop-down data-items=\"items\" data-set-user-preferences=\"setUserPreferences(true)\"></ul></div></div></div><section class=\"main-section ingest-dashboard\"><div sd-user-ingest-dashboard-list data-items=\"dashboard_items\" data-set-user-preferences=\"setUserPreferences()\"></section>");
        $templateCache.put('scripts/apps/ingest/views/dashboard/ingest-dashboard-widget-list.html', "<div class=\"ingest-dashboard-list\"><ul class=\"card-list\"><li ng-repeat=\"item in items track by item._id\"><div sd-user-ingest-dashboard data-item=\"item\" data-set-user-preferences=\"setUserPreferences()\"></div></li></ul></div>");
        $templateCache.put('scripts/apps/ingest/views/dashboard/ingest-dashboard-widget.html', "<div class=\"header\"><div class=\"title\">{{item.name}}</div><div class=\"sub-title\"><span translate>Source Type:</span> <span class=\"text\">{{item.source}}</span></div><div class=\"sub-title\"><span translate>Update Cycle:</span> <span class=\"text\">{{item.update_schedule | scheduleFilter}}</span></div></div><div ng-show=\"item.show_status\" class=\"status\" ng-class=\"{closed: item.is_closed, opened: !item.is_closed}\"><div ng-show=\"item.is_closed\"><div><span class=\"uppercase\" translate>Closed</span><span>by {{item.last_closed.display_name || 'System' | translate}}</span></div><div class=\"time\" ng-show=\"item.last_closed && item.last_closed.closed_at\"><span translate>on</span> {{item.last_closed.closed_at | dateTimeString}}</div><div ng-show=\"item.last_closed && item.last_closed.message\">{{item.last_closed.message}}</div></div><div ng-show=\"!item.is_closed\"><div><span class=\"uppercase\" translate>Opened</span><span>by {{item.last_opened.display_name || 'System' | translate}}</span></div><div class=\"time\" ng-show=\"item.last_opened && item.last_opened.opened_at\"><span translate>since</span> {{item.last_opened.opened_at | dateTimeString | translate}}</div></div></div><div ng-show=\"item.show_ingest_count\" class=\"ingested-count\"><div class=\"count\">{{ingested_count}}</div><div class=\"text\">items in last 24 hours.</div></div><div ng-show=\"item.show_time\" class=\"update-time\"><div ng-show=\"item.show_time\"><div class=\"text\" translate>Last Time Updated</div><div class=\"time\">{{item.last_updated | reldate}}</div></div><div ng-show=\"item.last_item_update\"><div class=\"text\" translate>Last Item Arrived</div><div class=\"time\">{{item.last_item_update | reldate}}</div></div><div ng-show=\"isIdle()\" class=\"error\"><em translate>Channel has gone strangely quiet.</em></div></div><div sd-toggle-box data-title=\"{{ 'Log Messages' | translate }}\" ng-if=\"item.show_log_messages\"><ul><li ng-repeat=\"message in log_messages track by message._id\"><div>{{message._created | reldate}}</div><div ng-class=\"{true:'error'}[message.name == 'error']\"><b>{{ message.user_name || 'System' }} </b><span sd-activity-message data-activity=\"message\"></span></div><div ng-if=\"!$last\" class=\"divider\"></div></li></ul></div><div class=\"dropdown dropdown--bigger card-list__controls\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon--white icon-dots-vertical\"></i></button><ul class=\"dropdown__menu\"><li><div class=\"dropdown__menu-label\">{{ :: 'Show' | translate }} <button class=\"dropdown__menu-close\"><i class=\"icon-close-small\"></i></button></div></li><li class=\"dropdown__menu-divider\"></li><li class=\"dropdown__menu-item--no-link\"><div><span class=\"pull-right\" sd-switch ng-model=\"item.show_status\" ng-click=\"setUserPreferences()\"></span><label translate>Status</label></div></li><li class=\"dropdown__menu-divider\"></li><li class=\"dropdown__menu-item--no-link\"><div><span class=\"pull-right\" sd-switch ng-model=\"item.show_ingest_count\" ng-click=\"setUserPreferences()\"></span><label translate>Number of items</label><span class=\"dropdown__menu-info\" translate>in the last 24 hours.</span></div></li><li class=\"dropdown__menu-divider\"></li><li class=\"dropdown__menu-item--no-link\"><div><span class=\"pull-right\" sd-switch ng-model=\"item.show_time\" ng-click=\"setUserPreferences()\"></span><label translate>Time</label><span class=\"dropdown__menu-info\" translate>last update and last item arrived.</span></div></li><li class=\"dropdown__menu-divider\"></li><li class=\"dropdown__menu-item--no-link\"><div><span class=\"pull-right\" sd-switch ng-model=\"item.show_log_messages\" ng-click=\"setUserPreferences()\"></span><label translate>Log Messages</label><ul><li><div><label><input type=\"radio\" name=\"{{item._id}}_messages\" value=\"all\" ng-model=\"item.log_messages\" ng-change=\"filterLogMessages()\"> <span translate>Show all messages</span></label></div></li><li><div><label><input type=\"radio\" name=\"{{item._id}}_messages\" value=\"error\" ng-model=\"item.log_messages\" ng-change=\"filterLogMessages()\"> <span translate>Show error messages</span></label></div></li></ul></div></li><li class=\"dropdown__menu-divider\"></li><li class=\"dropdown__menu-item\" ng-if=\"showIngest\"><a class=\"uppercase\" ng-href=\"#/settings/ingest?_id={{item._id}}\"><i class=\"icon-pencil\"></i><span translate>Edit Ingest Source</span></a></li></ul></div>");
        $templateCache.put('scripts/apps/ingest/views/dashboard/ingest-sources-list.html', "<li class=\"dropdown__menu-label\" translate>Add Ingest Sources</li><li ng-repeat=\"item in items\" class=\"dropdown__menu-item--no-link\"><span>{{item.name}} <span class=\"pull-right\" sd-switch ng-model=\"item.dashboard_enabled\" ng-click=\"setUserPreferences()\"></span></span></li><li class=\"dropdown__menu-divider\"></li><li ng-if=\"showIngest\"><a ng-href=\"#/settings/ingest\" class=\"uppercase\"><i class=\"icon-pencil\"></i><span translate>Edit Ingest Sources</span></a></li>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-config-errors.html', "<div ng-repeat=\"(errorCode, errorMessage) in field.errors\"><div class=\"error\" ng-show=\"error.code == errorCode\" translate>{{errorMessage|translate}}</div></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-routing-action.html', "<div class=\"form-block\"><h3 class=\"form-block__title\" translate>Actions</h3><div class=\"form-block__sub-section\"><label class=\"form-label\" translate>Fetch</label><div class=\"list-row list-row--dotted sd-margin-b--1\" ng-if=\"!rule.actions.fetch.length\"><span class=\"text-label\" translate=\"\">No Fetch actions defined</span></div><ul class=\"pills-list with-action\"><li ng-repeat=\"fetchAction in rule.actions.fetch\">{{ getActionString(fetchAction)}}<div class=\"actions\"><button ng-click=\"removeFetch(fetchAction)\" title=\"{{:: 'Remove fetch action' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul><div class=\"sd-card sd-card--auto-height action-panel action-panel\" ng-show=\"showNewFetch\"><div class=\"sd-card__content\"><div sd-action-picker data-desk=\"newFetch.desk\" data-stage=\"newFetch.stage\" data-macro=\"newFetch.macro\" class=\"split\"></div><div class=\"form__row form__row--inner sd-text__right\"><button class=\"btn\" ng-click=\"showNewFetch = false\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"addFetch();showNewFetch = false\" ng-disabled=\"!newFetch.desk || !newFetch.stage\" translate>Add</button></div></div></div><a class=\"btn btn--primary btn--hollow btn--expanded\" ng-click=\"showNewFetch = true;\" ng-show=\"!showNewFetch\"><i class=\"icon-plus-sign\"></i> Add Fetch action</a></div><div class=\"form-block__sub-section sd-margin-b--2\"><label class=\"form-label\" translate>Publish</label><div class=\"list-row list-row--dotted sd-margin-b--1\" ng-if=\"!rule.actions.publish.length\"><span class=\"text-label\" translate>No Publish actions defined</span></div><ul class=\"pills-list with-action\"><li ng-repeat=\"publishAction in rule.actions.publish\">{{ getActionString(publishAction)}}<div class=\"actions\"><button ng-click=\"removePublish(publishAction)\" title=\"{{:: 'Remove publish action' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul><div class=\"sd-card sd-card--auto-height action-panel\" ng-show=\"showNewPublish\"><div class=\"sd-card__content\"><div sd-action-picker data-desk=\"newPublish.desk\" data-stage=\"newPublish.stage\" data-macro=\"newPublish.macro\" class=\"split\"></div><div class=\"form__row\"><label class=\"form-label\" translate>Select Subscribers</label><div class=\"term-editor\" sd-meta-terms data-item=\"newPublish\" data-field=\"target_subscribers\" data-unique=\"_id\" data-list=\"customSubscribers\" data-header=\"true\" data-reload-list=\"true\"></div></div><div class=\"target-field\"><label class=\"form-label\" translate>Target Types</label><div sd-meta-target data-list=\"target_types\" data-targets=\"newPublish.target_types\"></div></div><div class=\"form__row form__row--inner sd-text__right\"><button class=\"btn\" ng-click=\"cancel();showNewPublish = false\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"addPublish();showNewPublish = false\" ng-disabled=\"!newPublish.desk || !newPublish.stage\" translate>Add</button></div></div></div><a class=\"btn btn--primary btn--hollow btn--expanded\" ng-click=\"showNewPublish = true;\" ng-show=\"!showNewPublish\"><i class=\"icon-plus-sign\"></i> Add Publish action</a></div><div class=\"form__row form__row--s-padding\"><span sd-switch ng-model=\"rule.actions.exit\"></span><label translate>Exit</label></div><div class=\"form__row form__row--s-padding\"><span sd-switch ng-model=\"rule.actions.preserve_desk\"></span><label translate>Preserve Desk</label></div></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-routing-content.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"edit({})\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content\"><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><li ng-repeat=\"scheme in schemes | filter:query\" class=\"sd-list-item sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\">{{scheme.name}}</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"edit(scheme)\" title=\"{{:: 'Edit scheme' | translate }}\"><i class=\"icon-pencil\"></i></button> <button class=\"icn-btn\" ng-click=\"remove(scheme)\" title=\"{{:: 'Remove scheme' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul></div></div><!-- Modal --><div sd-modal data-model=\"editScheme\" class=\"add-scheme-modal modal--tabs sd-wizard\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" translate ng-show=\"editScheme._id\" translate>Edit Scheme</h3><h3 class=\"modal__heading\" translate ng-hide=\"editScheme._id\" translate>Add New Scheme</h3><a href=\"\" class=\"icn-btn close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><form name=\"schemeForm\"><div class=\"modal__body-content\"><div style=\"padding: 0.8rem 2rem; border-bottom: 1px solid rgba(123, 123, 123, 0.2); flex-shrink: 0\"><div class=\"sd-line-input sd-line-input--required sd-line-input--boxed sd-line-input--no-margin sd-line-input--no-label\"><input class=\"sd-line-input__input\" type=\"text\" class=\"line-input input\" placeholder=\"{{ 'Scheme name'|translate }}\" ng-model=\"editScheme.name\" required autofocus></div></div><div><div class=\"content form-flat\"><div class=\"grid grid--padding-fix\"><div class=\"grid__item grid__item--col-4\"><div class=\"col-heading\" translate>Scheme rules</div><div class=\"column\"><div class=\"selected-field editable addnew\" ng-if=\"rule\"><div class=\"sd-line-input\"><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"rule.name\" placeholder=\"{{ 'Rule name' | translate }}\" required autofocus></div></div><ul class=\"pills-list\" ng-if=\"!rule && !editScheme.rules.length\"><li class=\"empty-info\" translate>No rules defined yet</li></ul><ul sd-sortrules class=\"pills-list pills-list--draggable\" ng-if=\"!rule\"><li ng-repeat=\"schemeRule in editScheme.rules\" ng-class=\"{active: selectedRule === schemeRule}\" ng-click=\"selectRule(schemeRule)\">{{schemeRule.name}}<div class=\"actions\"><button ng-click=\"editRule(schemeRule)\" sd-tooltip=\"{{ :: 'Edit Rule' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"removeRule(schemeRule)\" sd-tooltip=\"{{ :: 'Delete Rule' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul><button class=\"btn btn--primary btn--hollow btn--large btn--expanded\" ng-if=\"!rule\" ng-click=\"addRule()\" ng-disabled=\"!editScheme.name\" style=\"margin-top: 1.6rem\"><i class=\"icon-plus-sign\"></i><span translate>Add New Rule</span></button><div class=\"button-toolbar\" ng-if=\"rule\"><button class=\"btn\" ng-click=\"cancelRule(rule)\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!rule.name\" translate>Save</button></div></div></div><div class=\"grid__item grid__item--col-8\"><div class=\"col-heading\" ng-if=\"editScheme.rules.length\" translate>Scheme details</div><div class=\"column\" ng-if=\"!selectedRule && !rule && editScheme.rules.length\"><i class=\"icon-info-sign icon--blue\"></i><span class=\"helper-text helper-text--after-icon\">{{ :: 'Click on a Scheme rules on the left to view details.' | translate }}</span></div><div class=\"column\" ng-if=\"selectedRule && !rule\"><div sd-ingest-routing-general data-rule=\"selectedRule\"></div></div><div class=\"column\" ng-if=\"rule\"><div sd-ingest-routing-filter data-rule=\"rule\" data-content-filters=\"contentFilters\"></div><div sd-ingest-routing-action data-rule=\"rule\"></div><div sd-ingest-routing-schedule data-rule=\"rule\"></div></div></div></div></div></div></div><div class=\"modal__body-footer\"><button class=\"btn btn--primary\" ng-click=\"done()\" ng-disabled=\"rule\" translate>Done</button></div></form></div></div><!-- END Modal -->");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-routing-filter.html', "<div class=\"form-block\"><h3 class=\"form-block__title\" translate>Content Filter</h3><div ng-show=\"!showNewFilter\"><div class=\"list-row list-row--dotted sd-margin-b--1\" ng-show=\"!selectedFilter\"><span class=\"text-label\" translate=\"\">No content filter defined</span></div><a class=\"btn btn--primary btn--hollow btn--expanded\" ng-click=\"showNewFilter = true;\" ng-show=\"!selectedFilter\"><i class=\"icon-plus-sign\"></i> {{:: 'Add filter' | translate }}</a></div><ul class=\"pills-list with-action\" ng-if=\"selectedFilter\"><li>{{selectedFilter.name}}<div class=\"actions\"><button ng-click=\"clearSelectedFilter()\" title=\"{{:: 'Remove filter' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul><div class=\"sd-card sd-card--auto-height\" ng-show=\"showNewFilter\"><div class=\"sd-card__content\"><div sd-typeahead items=\"matchingFilters\" term=\"filterSearchTerm\" search=\"searchFilters(term)\" select=\"selectFilter(item); showNewFilter = false\"><li typeahead-item=\"filter\" ng-repeat=\"filter in matchingFilters track by filter._id\">{{::filter.name}}</li></div><div class=\"form__row form__row--inner sd-text__right\"><button class=\"btn\" ng-click=\"showNewFilter = false\" translate>Cancel</button></div></div></div></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-routing-general.html', "<fieldset class=\"\"><div class=\"form-block\"><h3 class=\"form-block__title\" translate>Content Filter</h3><div class=\"list-row list-row--dotted list-row--flex\" ng-if=\"rule.filter\"><span class=\"text-label list-row__item list-row__item--grow\">{{ :: 'Name' | translate }}:</span> <span class=\"list-row__item\">{{rule.filterName}}</span></div><div class=\"list-row list-row--dotted\" ng-if=\"!rule.filter\"><span class=\"text-label\" translate>No content filter defined</span></div></div><div class=\"form-block\"><h3 class=\"form-block__title\" translate>Action</h3><div class=\"form-block__sub-section\" ng-if=\"!rule.actions.fetch.length && !rule.actions.publish.length\"><div class=\"list-row list-row--dotted list-row--flex\"><span class=\"text-label\" translate>No fetch or publish actions defined</span></div></div><div class=\"form-block__sub-section\" ng-show=\"rule.actions.fetch && rule.actions.fetch.length\"><label class=\"form-label\">{{ :: 'Fetch' | translate }}</label><div class=\"list-row list-row--dotted list-row--flex\" ng-repeat=\"fetchAction in rule.actions.fetch\"><span class=\"list-row__item\">{{deskLookup[fetchAction.desk].name}} / {{stageLookup[fetchAction.stage].name}} / {{macroLookup[fetchAction.macro].label}}</span></div></div><div class=\"form-block__sub-section\" ng-show=\"rule.actions.publish && rule.actions.publish.length\"><label class=\"form-label\">{{ :: 'Publish' | translate }}</label><div class=\"list-row list-row--dotted list-row--flex\" ng-repeat=\"publishAction in rule.actions.publish\"><span class=\"list-row__item\">{{deskLookup[publishAction.desk].name}} / {{stageLookup[publishAction.stage].name}}</span></div></div><div class=\"list-row\"><span class=\"text-label text-label--auto\">{{ :: 'Exit' | translate }}:</span> <span class=\"list-row__item\" ng-show=\"rule.actions.exit\" translate>On</span> <span class=\"list-row__item\" ng-hide=\"rule.actions.exit\" translate>Off</span></div></div><div class=\"form-block\"><h3 class=\"form-block__title\" translate>Schedule</h3><div ng-show=\"rule.schedule.day_of_week\"><div class=\"list-row list-row--dotted\"><span class=\"list-row__item\"><span class=\"tag-label\" ng-repeat=\"day in rule.schedule.day_of_week\">{{dayLookup[day]| translate}}</span></span></div></div><div class=\"list-row\"><span ng-if=\"rule.schedule._allDay\"><span class=\"text-label text-label--auto\">{{ :: 'Duration' | translate }}:</span> <span translate>All Day</span> </span><span ng-if=\"!rule.schedule._allDay\"><span class=\"text-label text-label--auto\">{{ :: 'From' | translate }}:</span> <span>{{rule.schedule.hour_of_day_from || '00:00'}}</span> </span>&nbsp; <span ng-if=\"!rule.schedule._allDay\"><span class=\"text-label text-label--auto\">{{ :: 'to' | translate }}:</span> <span>{{rule.schedule.hour_of_day_to || '23:59'}}</span></span></div></div></fieldset>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-routing-schedule.html', "<div class=\"form-block\"><h3 class=\"form-block__title\" translate>Schedule</h3><div class=\"form__row\"><label class=\"form-label\" translate>Days</label><div class=\"day-filter-box clearfix\" sd-weekday-picker data-model=\"rule.schedule.day_of_week\"></div></div><div class=\"form__row\"><sd-check ng-model=\"rule.schedule._allDay\" label-position=\"right\" class=\"sd-checkbox--button-allDay\">{{'All Day' | translate}}</sd-check></div><div class=\"form__row form__row--flex\" ng-if=\"!rule.schedule._allDay\"><div class=\"form__row-item\"><label class=\"form-label\" translate>Start Time (inclusive)</label><span sd-timepicker ng-model=\"rule.schedule.hour_of_day_from\"></span></div><div class=\"form__row-item\"><label class=\"form-label\" translate>End Time (exclusive)</label><span sd-timepicker ng-model=\"rule.schedule.hour_of_day_to\"></span></div></div><div class=\"form__row\"><div sd-timezone data-timezone=\"rule.schedule.time_zone\"></div></div></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-rules-content.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"edit({})\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content\"><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><li ng-repeat=\"ruleset in rulesets | filter:query\" class=\"sd-list-item sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\">{{ruleset.name}}</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"edit(ruleset)\" title=\"{{:: 'Edit rule set' | translate }}\"><i class=\"icon-pencil\"></i></button> <button class=\"icn-btn\" ng-click=\"remove(ruleset)\" title=\"{{:: 'Remove rule set' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul></div></div><!-- Modal --><div sd-modal data-model=\"editRuleset\" class=\"modal--tabs\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" translate ng-show=\"editRuleset._id\" translate>Edit Rule set</h3><h3 class=\"modal__heading\" translate ng-hide=\"editRuleset._id\" translate>Add New Rule Set</h3><a href=\"\" class=\"icn-btn close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><form name=\"rulesetForm\" class=\"modal__body\"><div class=\"modal__body-content\"><div class=\"for__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--required\"><label class=\"sd-line-input__label\">{{'Rule set name'| translate}}</label><input class=\"sd-line-input__input\" type=\"text\" placeholder=\"{{ 'Rule set name'|translate }}\" ng-model=\"editRuleset.name\" required></div></div><div sd-sortrules><div class=\"form__row form__row--flex form__row--bordered\" ng-repeat=\"rule in editRuleset.rules\"><div class=\"form__row-item form__row-item--no-grow\"><span>#{{$index}}</span></div><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-label sd-line-input--no-margin\"><input class=\"sd-line-input__input\" type=\"text\" placeholder=\"old\" ng-model=\"rule.old\" required></div></div><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-label sd-line-input--no-margin\"><input class=\"sd-line-input__input\" type=\"text\" placeholder=\"new\" ng-model=\"rule.new\"></div></div><div class=\"form__row-item form__row-item--no-grow\"><button class=\"icn-btn\" ng-click=\"removeRule(rule)\"><i class=\"icon-trash\"></i></button></div></div></div><p ng-if=\"!editRuleset.rules\" translate>No rules defined in a set.</p><div class=\"for__row form__row--inner\"><button class=\"btn btn--primary btn--hollow btn--large btn--expanded\" ng-disabled=\"!rulesetForm.$valid\" ng-click=\"addRule()\"><i class=\"icon-plus-sign\"></i> {{:: 'Add rule' | translate}}</button></div></div><div class=\"modal__body-footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save(editRuleset)\" ng-disabled=\"!rulesetForm.$valid || !rulesetForm.$dirty\" translate>Save</button></div></form></div><!-- END Modal -->");
        $templateCache.put('scripts/apps/ingest/views/settings/ingest-sources-content.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><div class=\"flat-searchbar\" ng-class=\"{extended: queueSearch}\"><div class=\"search-handler\"><label for=\"search-input\" class=\"trigger-icon\" ng-click=\"queueSearch = !queueSearch\"><i class=\"icon-search\"></i></label><input id=\"search-input\" type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"query\" ng-model-options=\"{debounce: 500}\" ng-change=\"search(query)\"></div></div><div class=\"dropdown\" dropdown><button id=\"status_filter_button\" class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown__toggle><span translate translate-params-filter=\"activeStatusFilter.label\">Status: {{filter}}</span> <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu\"><li ng-repeat=\"filter in statusFilters track by filter.id\"><!-- dynamic id only for testing purpose ---> <button ng-click=\"filterIngestSources(filter.id)\" id=\"status--{{::filter.id}}-filter\">{{filter.label | translate}}</button></li></ul></div><div class=\"sd-page__element-grow\"><div sd-pagination items=\"providers\"></div></div><button class=\"btn btn--primary\" ng-click=\"edit()\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content\"><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><li class=\"sd-list-item sd-shadow--z1\" ng-repeat=\"provider in providers._items\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\">{{ provider.name}} <span class=\"last-updated\" ng-if=\"provider.last_updated\"><span translate>Last updated</span> {{ provider.last_updated | reldate }} </span></span><span class=\"label label--hollow label--alert\" ng-if=\"provider.is_closed\" translate>closed</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"gotoIngest(provider)\" title=\"{{:: 'Go to items' | translate }}\"><i class=\"icon-external\"></i></button> <button class=\"icn-btn\" ng-click=\"edit(provider)\" title=\"{{:: 'Edit source' | translate }}\"><i class=\"icon-pencil\"></i></button> <button class=\"icn-btn\" ng-click=\"remove(provider)\" ng-show=\"!provider.last_item_update\" title=\"{{:: 'Remove source' | translate }}\"><i class=\"icon-trash\"></i></button></div></li></ul></div></div><!-- Modal --><div sd-modal data-model=\"provider\" class=\"modal--tabs modal--large\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"provider._id\"><span translate>Edit Source</span> \"{{ provider.name}}\"</h3><h3 class=\"modal__heading\" translate ng-hide=\"provider._id\" translate>Add New Source</h3><a href=\"\" class=\"icn-btn close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><form name=\"editForm\" sd-wizard data-name=\"ingestSources\" data-current-step=\"step.current\" data-finish=\"cancel()\"><!-- XXX: The dummy text and password inputs below are here to avoid autocompletion in Firefox, as autocomplete=\"off\" is not working\n" +
            "                      and without it, superdesk login/password will be used as default /o\\ (cf. SDESK-2745) --> <input type=\"text\" style=\"display:none\"> <input type=\"password\" style=\"display:none\"><fieldset><div sd-wizard-step data-title=\"{{ 'General' | translate }}\" data-code=\"general\"><div class=\"form__row form__row--l-padding\"><span sd-switch-inverted ng-model=\"provider.is_closed\"></span><label>{{ provider.is_closed ? 'Closed' : 'Active' | translate }}</label></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--required\" ng-class=\"{'sd-line-input--invalid' : error._issues.name}\"><label class=\"sd-line-input__label\" for=\"provider-name\" translate>Provider Name</label><input class=\"sd-line-input__input\" type=\"text\" id=\"provider-name\" ng-model=\"provider.name\" required><div class=\"input__message\" ng-show=\"error._issues.name\" translate>Name is not unique.</div></div></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"source-name\" translate>Source Name</label><input class=\"sd-line-input__input\" type=\"text\" id=\"source-name\" ng-model=\"provider.source\" required></div></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"provider-feeding-service\" translate>Feeding Service</label><select class=\"sd-line-input__select\" id=\"provider-feeding-service\" ng-change=\"initProviderConfig()\" required ng-model=\"provider.feeding_service\" ng-options=\"fs.feeding_service as fs.label for fs in feedingServices\"></select></div></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--is-select\" ng-show=\"feedParsers.length > 1\"><label class=\"sd-line-input__label\" for=\"provider-feed-parser\" translate>Feed Parser</label><select class=\"sd-line-input__select\" id=\"provider-feed-parser\" ng-model=\"provider.feed_parser\" ng-options=\"fp.feed_parser as fp.label for fp in feedParsers\"><option value=\"\"></option></select></div></div><div class=\"form__row article-type\" ng-show=\"provider.feeding_service !== 'wufoo'\"><label class=\"form-label\" for=\"provider-content-types\" translate>Article Type(s)</label><div class=\"button-list\"><a href=\"\" ng-repeat=\"fileType in fileTypes\" title=\"{{fileType.type}}\" ng-click=\"addOrRemoveFileType(fileType.type, editForm)\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': hasFileType(fileType.type)}\"><i class=\"toggle-button__icon {{fileType.icon}}\"></i></a></div></div><div class=\"form__row form__row--s-padding\"><label class=\"form-label\" for=\"schedule-minutes\" translate>Update every</label><div class=\"form__row form__row--flex\"><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\"><select id=\"schedule-minutes\" class=\"sd-line-input__select sd-line-input__select--mini\" ng-model=\"provider.update_schedule.minutes\" ng-options=\"min as min for min in minutes\"></select></div></div><div class=\"form__row-item form__row-item--no-grow\"><span translate>min</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\"><select class=\"sd-line-input__select sd-line-input__select--mini\" ng-model=\"provider.update_schedule.seconds\" ng-options=\"sec as sec for sec in seconds\"></select></div></div><div class=\"form__row-item form__row-item--no-grow\"><span translate>sec</span></div></div></div><div class=\"form__row form__row--s-padding\"><label class=\"form-label\" for=\"idle-hours\" translate>Notify when idle for more than</label><div class=\"form__row form__row--flex\"><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\"><select id=\"idle-hours\" class=\"sd-line-input__select sd-line-input__select--mini\" ng-model=\"provider.idle_time.hours\" ng-options=\"hrs as hrs for hrs in hours\"></select></div></div><div class=\"form__row-item form__row-item--no-grow\"><span translate>hrs</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\"><select id=\"idle-minutes\" class=\"sd-line-input__select sd-line-input__select--mini\" ng-model=\"provider.idle_time.minutes\" ng-options=\"min as min for min in minutes\"></select></div></div><div class=\"form__row-item form__row-item--no-grow\"><span translate>min</span></div></div></div><div class=\"form__row form__row--s-padding\" sd-content-expiry data-item=\"provider\" data-preview=\"false\" data-expiryfield=\"content_expiry\" data-header=\"Content Expiry\" data-expiry-minutes=\"ingestExpiry\" data-expiry-context=\"System\"></div><div class=\"form__row form__row--l-padding\"><span sd-switch ng-model=\"provider.allow_remove_ingested\"></span><label>{{:: 'Allow Remove Ingested Items' | translate }}</label></div><div class=\"form__row credentials\"><div class=\"sd-alert sd-alert--hollow sd-alert--alert sd-alert--small\" ng-show=\"error\" translate>An error occured when testing config.</div><div sd-ingest-provider-config></div></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"ruleset\" translate>Ruleset</label><select class=\"sd-line-input__select\" id=\"ruleset\" ng-model=\"provider.rule_set\" ng-options=\"r._id as r.name for r in rulesets\"><option value=\"\"></option></select></div></div><div class=\"form__row form__row--s-padding\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"routing\" translate>Routing Scheme</label><select class=\"sd-line-input__select\" id=\"routing\" ng-model=\"provider.routing_scheme\" ng-options=\"rs._id as rs.name for rs in routingScheme\"><option value=\"\"></option></select></div></div></div><div sd-wizard-step data-title=\"{{ 'Notification' | translate }}\" data-code=\"notification\"><ul class=\"simple-list simple-list--dotted\"><div class=\"simple-list__item\"><span sd-switch ng-model=\"provider.notifications.on_update\"></span><label>{{ :: 'Update' | translate}}</label></div><div class=\"simple-list__item\"><span sd-switch ng-model=\"provider.notifications.on_close\"></span><label>{{ :: 'Close' | translate}}</label></div><div class=\"simple-list__item\"><span sd-switch ng-model=\"provider.notifications.on_open\"></span><label>{{ :: 'Open' | translate}}</label></div><div class=\"simple-list__item\"><span sd-switch ng-model=\"provider.notifications.on_error\"></span><label>{{ :: 'Error' | translate}}</label></div></ul></div><div sd-wizard-step data-title=\"{{ 'Critical Errors' | translate }}\" data-code=\"critial-errors\" ng-show=\"provider.feeding_service\" ng-init=\"fetchSourceErrors()\"><ul class=\"simple-list simple-list--dotted\"><li class=\"simple-list__item\" ng-repeat=\"(key, val) in provider.source_errors\"><span sd-switch ng-model=\"provider.critical_errors[key]\"></span><label>{{key}}: {{val}}</label></li></ul></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"!editForm.$valid || !editForm.$dirty\" translate>Save</button></div></div><!-- END Modal -->");
        $templateCache.put('scripts/apps/ingest/views/settings/searchConfig.html', "<div class=\"field\"><label for=\"reuters_username\" translate>Username</label><input type=\"text\" id=\"reuters_username\" placeholder=\"{{ 'username'|translate }}\" ng-model=\"provider.config.username\" ng-change=\"$parent.setConfig(provider)\"></div><div class=\"field\"><label for=\"reuters_password\" translate>Password</label><input type=\"text\" id=\"reuters_password\" placeholder=\"{{ 'password'|translate }}\" ng-model=\"provider.config.password\" ng-change=\"$parent.setConfig(provider)\" autocomplete=\"new-password\"></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/service-config.html', "<div class=\"form__row form__row--s-padding\" ng-repeat=\"field in currentFeedingService.fields track by field.id\"><div class=\"sd-line-input\" ng-if=\"field.type === 'text'\" ng-show=\"isConfigFieldVisible(field)\"><label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label><input class=\"sd-line-input__input\" type=\"{{field.type}}\" id=\"{{getConfigFieldId(field.id)}}\" placeholder=\"{{:: field.placeholder | translate}}\" ng-model=\"provider.config[field.id]\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\" ng-change=\"$parent.setConfig(provider)\" ng-show=\"isConfigFieldVisible(field)\"><div sd-ingest-config-errors></div></div><div class=\"sd-line-input\" ng-if=\"field.type === 'password'\" ng-show=\"isConfigFieldVisible(field)\"><label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label><input class=\"sd-line-input__input\" type=\"password\" id=\"{{getConfigFieldId(field.id)}}\" placeholder=\"{{:: field.placeholder | translate}}\" ng-model=\"provider.config[field.id]\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\" ng-change=\"$parent.setConfig(provider)\" ng-show=\"isConfigFieldVisible(field)\" autocomplete=\"new-password\"><div sd-ingest-config-errors></div></div><div class=\"form__row\" ng-if=\"field.type === 'boolean'\" ng-show=\"isConfigFieldVisible(field)\"><span sd-switch id=\"{{getConfigFieldId(field.id)}}\" ng-model=\"provider.config[field.id]\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\"></span><label for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label><div sd-ingest-config-errors></div></div><div class=\"sd-line-input sd-line-input--is-select\" ng-if=\"field.type === 'choices'\" ng-show=\"isConfigFieldVisible(field)\"><label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label><select id=\"{{getConfigFieldId(field.id)}}\" class=\"sd-line-input__select\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\" ng-options=\"r[0] as r[1] for r in field.choices\" ng-model=\"provider.config[field.id]\"></select></div><fieldset class=\"separated rss-config\" ng-if=\"field.type === 'mapping'\"><legend translate>{{field.label | translate}}</legend><div class=\"sd-alert sd-alert--hollow sd-alert--small sd-alert--no-margin\" ng-show=\"provider.config[field.id].length == 0\" ng-hide=\"fieldAliases[field.id].length > 0\">{{:: field.empty_label|translate }}</div><div class=\"form__row form__row--flex form__row--s-padding\" ng-show=\"fieldAliases[field.id].length > 0\"><div class=\"sd-line-input sd-line-input--no-margin\" style=\"max-width: 276px\"><label class=\"sd-line-input__label\">{{ field.first_field_options.label|translate}}</label></div><div class=\"sd-line-input sd-line-input--no-margin\"><label class=\"sd-line-input__label\">{{ field.second_field_options.label|translate}}</label></div></div><div class=\"form__row form__row--flex form__row--s-padding\" ng-repeat=\"item in fieldAliases[field.id]\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin sd-line-input--no-label\"><select class=\"sd-line-input__select\" ng-options=\"fieldName for fieldName in (availableFieldOptions(field.id, item.fieldName) | orderBy)\" ng-model=\"item.fieldName\" ng-change=\"fieldSelectionChanged(field)\"></select></div><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin sd-line-input--no-label\"><input class=\"sd-line-input__input\" type=\"text\" placeholder=\"{{:: field.second_field_options.placeholder|translate }}\" ng-model=\"item.alias\"></div><button style=\"margin-left: 8px\" type=\"button\" class=\"icn-btn\" ng-click=\"removeFieldAlias(field.id, $index)\" tooltip=\"{{:: field.remove_mapping_label|translate}}\" tooltip-placement=\"bottom\" tooltip-popup-delay=\"500\"><i class=\"icon-trash\"></i></button></div><div class=\"form__row form__row--inner\" ng-show=\"!fieldAliases[field.id] || fieldAliases[field.id].length < field.first_field_options.values.length\" style=\"text-align: right\"><button type=\"button\" class=\"btn btn--primary btn--hollow\" ng-click=\"addFieldAlias(field.id)\"><i class=\"icon-plus-sign\"></i> {{:: field.add_mapping_label|translate}}</button></div></fieldset></div>");
        $templateCache.put('scripts/apps/ingest/views/settings/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" id=\"ingest-settings\" ng-init=\"tab = 'sources'\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Ingest</h2></div><div class=\"sd-page__header sd-page__header--white\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'sources'}\" ng-show=\"showIngest\"><button ng-click=\"tab = 'sources'\" translate>Ingest Sources</button></li><li ng-class=\"{active: tab === 'rulesets'}\" ng-show=\"showRuleset\"><button ng-click=\"tab = 'rulesets'\" translate>Ingest Rule sets</button></li><li ng-class=\"{active: tab === 'routing'}\" ng-show=\"showRouting\"><button ng-click=\"tab = 'routing'\" translate>Ingest Routing</button></li></ul></div><div class=\"sd-page__flex-helper\" ng-if=\"tab === 'sources'\" sd-ingest-sources-content></div><div class=\"sd-page__flex-helper\" ng-if=\"tab === 'rulesets'\" sd-ingest-rules-content></div><div class=\"sd-page__flex-helper\" ng-if=\"tab === 'routing'\" sd-ingest-routing-content></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/internal-destinations/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\"><div classname=\"sd-page__content\" style=\"height: 100%; display: flex;flex-direction: column\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Internal Destinations</h2></div><sd-internal-destinations style=\"display: contents\"></sd-internal-destinations></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/legal-archive/views/legal_archive.html', "<div class=\"subnav legal-archive subnav--absolute\" sd-media-query min-width=\"700\"><div class=\"filter-trigger\" ng-click=\"openAdvanceSearch = !openAdvanceSearch\" ng-class=\"{'filter-trigger--active': openAdvanceSearch}\"><i class=\"icon-filter-large\"></i></div><div sd-pagination data-items=\"items\" ng-if=\"elementState !== 'compact'\"></div><div class=\"subnav__stretch-bar\"></div><div sd-legal-item-sortbar ng-if=\"elementState !== 'compact'\" class=\"sortbar-container\"></div><div class=\"view-select\"><button tooltip=\"{{ :: 'switch to grid view' | translate }}\" tooltip-placement=\"left\" ng-show=\"view !== 'mgrid'\" ng-click=\"setview('mgrid')\"><i class=\"icon-grid-view\"></i></button> <button tooltip=\"{{ :: 'switch to list view' | translate }}\" tooltip-placement=\"left\" ng-show=\"view !== 'compact'\" ng-click=\"setview('compact')\"><i class=\"icon-list-view\"></i></button></div><div class=\"button-stack right-stack\" ng-if=\"elementState === 'compact'\"><div class=\"dropdown dropdown--align-right dropdown--compact-state\" dropdown><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu\"><li><span class=\"dropdown__menu-label\">{{:: 'Pagination' | translate}}</span></li><li><span sd-pagination data-items=\"items\"></span></li><li class=\"dropdown__menu-divider\"></li><li><span class=\"dropdown__menu-label\">{{:: 'Sorting' | translate}}</span></li><li><span sd-legal-item-sortbar></span></li></ul></div></div></div><section class=\"search main-section search-page-container\" ng-class=\"{'sidebar-open': openAdvanceSearch}\"><div class=\"archive-sidebar\"><div class=\"header\"><ul><li translate>Search</li></ul><div class=\"doopen\" ng-click=\"openAdvanceSearch = false\"><i class=\"icon-close-small\"></i></div></div><div class=\"content\"><div data-context=\"context\"><form><fieldset><div class=\"field\"><label for=\"search-story-id\">{{:: 'GUID' | translate}}</label><div class=\"control\"><input type=\"text\" id=\"search-story-id\" ng-model=\"criteria._id\" tabindex=\"1\"></div></div><div class=\"field\"><label for=\"search-unique-id\">{{:: 'Unique Name' | translate}}</label><div class=\"control\"><input type=\"text\" id=\"search-unique-id\" ng-model=\"criteria.unique_name\" tabindex=\"1\"></div></div><div class=\"field\"><label for=\"search-headline\">{{:: 'Headline' | translate}}</label><div class=\"control\"><input type=\"text\" id=\"search-headline\" ng-model=\"criteria.headline\" tabindex=\"2\"></div></div><div class=\"field\"><label for=\"search-slugline\">{{:: 'Slugline' | translate}}</label><div class=\"control\"><input type=\"text\" id=\"search-slugline\" ng-model=\"criteria.slugline\" tabindex=\"3\"></div></div><div class=\"field\"><label for=\"search-storytext\">{{:: 'Story Text' | translate}}</label><div class=\"control\"><input type=\"text\" id=\"search-storytext\" ng-model=\"criteria.body_html\" tabindex=\"4\"></div></div><div class=\"field\" sd-date-param data-location=\"criteria.published_after\"><label for=\"published_after\" translate>Published From</label><div sd-datepicker id=\"published_after\" ng-model=\"criteria.published_after\"></div></div><div class=\"field\" sd-date-param data-location=\"criteria.published_before\"><label for=\"published_before\" translate>Published Until</label><div sd-datepicker id=\"published_before\" ng-model=\"criteria.published_before\"></div></div></fieldset></form><div class=\"actions\"><button class=\"btn btn--primary pull-right\" ng-click=\"search()\" tabindex=\"7\" translate>Go</button> <button class=\"btn btn--primary pull-right\" ng-click=\"clear()\" tabindex=\"8\" translate>Clear</button></div></div></div></div><div class=\"archive-content\"><div class=\"preview-layout\" ng-class=\"{\n" +
            "                    closed: !selected.preview\n" +
            "                }\"><div class=\"list-pane {{ view || 'list' }}-view\"><div id=\"content-list\" class=\"content\" sd-updown data-items=\"items._items\" data-select=\"preview(item)\"><div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div><div class=\"shadow-list-holder\" sd-items-list></div></div></div><div id=\"item-preview\" class=\"preview-pane content-item-preview\" ng-show=\"selected.preview\" ng-init=\"tab = 'content'\"><header><ul class=\"nav nav-tabs\"><li ng-class=\"{\n" +
            "                                    active: tab === 'content'\n" +
            "                                }\"><button ng-click=\"tab = 'content'\"><span translate>Content</span></button></li><li ng-class=\"{\n" +
            "                                    active: tab === 'metadata'\n" +
            "                                }\"><button ng-click=\"tab = 'metadata'\"><span translate>Metadata</span></button></li><li ng-class=\"{\n" +
            "                                    active: tab === 'history'}\"><button ng-click=\"tab = 'history'\"><span translate>Item history</span></button></li></ul><button ng-click=\"preview(null)\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div class=\"content\" ng-if=\"selected.preview\"><div ng-if=\"tab === 'content'\" sd-media-preview></div><div ng-if=\"tab === 'metadata'\" sd-media-metadata data-item=\"selected.preview\"></div><div ng-if=\"tab === 'history'\" sd-versioning-history data-item=\"selected.preview\"></div></div></div></div></div></section><div sd-media-view data-item=\"selected.view\" data-items=\"items._items\" ng-if=\"selected.view\" data-close=\"closeLightbox()\"></div>");
        $templateCache.put('scripts/apps/monitoring/aggregate-widget/aggregate-widget.html', "<div class=\"widget-container\" ng-controller=\"AggregateCtrl as agg\" ng-init=\"agg.setWidget(widget)\"><div class=\"widget-header\" style=\"margin-top: 3px\" ng-init=\"!searchOpen\"><button class=\"widget-header__search-button\" ng-click=\"searchOpen = !searchOpen; agg.search(); query = ''\" ng-class=\"{'widget-header__search-button--active': searchOpen}\"><i class=\"icon-search\"></i></button><div class=\"widget-title\">{{ widget.configuration.label || widget.label | translate}}</div></div><div class=\"main-list\" ng-class=\"{wrap: agg.selected && !$root.config.features.customMonitoringWidget, 'custom-widget': $root.config.features.customMonitoringWidget}\"><div class=\"search-box\" ng-class=\"{'search-box--hidden': !searchOpen}\"><form class=\"search-box__content\"><button type=\"reset\" class=\"search-cancel\" ng-click=\"agg.search()\" ng-if=\"query\"><i class=\"icon-remove-sign\"></i></button> <input type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"query\" ng-model-options=\"{debounce: 500}\" ng-change=\"agg.search(query)\"></form></div><div class=\"content-list-holder\"><div sd-shadow><div class=\"content-list\" ng-if=\"!agg.state.solo\"><div class=\"desk\" ng-repeat=\"group in agg.cards track by group._id\"><div class=\"stage\" ng-show=\"total\"><div sd-stage-header></div><div class=\"stage-content\" ng-style=\"agg.getMaxHeightStyle(group.max_items)\" ng-show=\"agg.getExpandedState(group._id) || agg.state.solo\" sd-widget-group data-stage=\"group\" data-total=\"total\" data-allowed=\"true\" data-show-empty=\"false\" data-max-items=\"group.max_items\" data-action=\"agg.preview(item)\" data-selected=\"agg.selected\" data-filter=\"group.query\"></div></div></div></div><div class=\"content-list\" ng-if=\"agg.state.solo\"><div class=\"desk\" ng-init=\"group = agg.state.solo\"><div class=\"stage\" ng-show=\"total\"><div sd-stage-header></div><div class=\"stage-content\" ng-show=\"agg.getExpandedState(group._id) || agg.state.solo\" sd-widget-group data-stage=\"group\" data-total=\"total\" data-allowed=\"true\" data-show-empty=\"false\" data-max-items=\"100\" data-action=\"agg.preview(item)\" data-selected=\"agg.selected\" data-filter=\"group.query\"></div></div></div></div></div></div></div><div class=\"preview preview-widget\" ng-init=\"contenttab = true\" ng-if=\"agg.selected\" ng-class=\"{wrap: !agg.selected && !$root.config.features.customMonitoringWidget, 'custom-widget': $root.config.features.customMonitoringWidget}\"><div class=\"nav\"><button class=\"backlink\" href=\"\" ng-if=\"!$root.config.features.customMonitoringWidget\" ng-click=\"agg.preview()\"><span class=\"ng-scope\" translate>Back</span></button></div><ul class=\"nav nav-tabs\"><li ng-class=\"{active: contenttab}\"><button ng-click=\"contenttab = true\" translate>Content</button></li><li ng-class=\"{active: !contenttab}\"><button ng-click=\"contenttab = false\" translate>Metadata</button></li></ul><div class=\"content-item-preview\" ng-if=\"agg.selected\"><div class=\"content\" ng-if=\"contenttab\" sd-media-preview-widget data-item=\"agg.selected\"></div><div ng-if=\"!contenttab\" sd-media-metadata data-item=\"agg.selected\"></div></div></div></div>");
        $templateCache.put('scripts/apps/monitoring/aggregate-widget/configuration.html', "<div ng-controller=\"AggregateCtrl as agg\" ng-init=\"agg.setWidget(widget)\"><div ng-if=\"!agg.loading\" ng-init=\"agg.edit()\" sd-aggregate-settings data-desks=\"agg.desks\" data-desk-stages=\"agg.deskStages\" data-searches=\"agg.searches\" data-desk-lookup=\"agg.deskLookup\" data-stage-lookup=\"agg.stageLookup\" data-search-lookup=\"agg.searchLookup\" data-groups=\"agg.groups\" data-edit-groups=\"agg.editGroups\" data-onclose=\"$close()\" data-widget=\"widget\"></div></div>");
        $templateCache.put('scripts/apps/monitoring/views/aggregate-settings-configuration.html', "<div class=\"aggregate-widget-config modal__wrapper\" ng-if=\"widget\" ng-include=\"'scripts/apps/monitoring/views/aggregate-settings.html'\"></div><div ng-if=\"!widget\" sd-modal data-model=\"modalActive\" data-close=\"closeModal()\" class=\"modal--tabs aggregate-widget-config\"><div class=\"modal__wrapper\" ng-include=\"'scripts/apps/monitoring/views/aggregate-settings.html'\"></div></div>");
        $templateCache.put('scripts/apps/monitoring/views/aggregate-settings.html', "<div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\">{{ :: 'Monitoring settings' | translate }} <span ng-if=\"settings.desk\" translate>for \"{{settings.desk.name}}\" Desk</span></h3><a href=\"\" class=\"modal__close icn-btn\" sd-hotkey=\"esc\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body aggregate-settings\" sd-wizard data-name=\"aggregatesettings\" data-current-step=\"step.current\" ng-init=\"setCurrentStep()\" data-finish=\"cancel()\"><div sd-wizard-step data-title=\"{{ :: 'Desks' | translate }}\" data-code=\"desks\" data-hide=\"shouldHideStep('desks')\"><div class=\"content\"><div ng-if=\"widget\"><div class=\"sd-line-input sd-line-input--required sd-line-input--boxed\"><label class=\"sd-line-input__label\" translate>View name</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"widget.configuration.label\" ng-keyup=\"handleEdit($event);\" required><div class=\"sd-line-input__char-count\" sd-character-count data-item=\"widget.configuration.label\" data-limit=\"30\"></div></div></div><div class=\"legend\" translate>Select desks for view</div><div class=\"desk-container\"><div class=\"desk\" ng-repeat=\"desk in desks | orderBy: 'name' track by desk._id\"><div class=\"desk-title\"><span sd-switch ng-model=\"editGroups[desk._id].selected\" ng-click=\"setDeskInfo(desk._id)\"></span> <span class=\"desk-title__text\">{{desk.name}}</span></div><ul class=\"stages\" ng-if=\"editGroups[desk._id].selected\"><li ng-repeat=\"stage in deskStages[desk._id]\"><span sd-check ng-model=\"editGroups[stage._id].selected\" ng-click=\"setStageInfo(stage._id)\" label-position=\"inside\">{{stage.name}}</span></li><li><span sd-check ng-model=\"editGroups[desk._id + ':scheduled'].selected\" ng-click=\"setScheduledDeskOutputInfo(desk._id + ':scheduled')\" label-position=\"inside\">{{'Output/Scheduled' | translate}}</span></li><li><span sd-check ng-model=\"editGroups[desk._id + ':output'].selected\" ng-click=\"setDeskOutputInfo(desk._id + ':output')\" label-position=\"inside\">{{'Output/Published' | translate}}</span></li></ul></div><div class=\"desk\"><div class=\"desk-title\"><span sd-switch ng-model=\"editGroups['personal'].selected\" ng-click=\"setPersonalInfo()\"></span> <span class=\"desk-title__text\" translate>Personal</span></div></div></div></div></div><div sd-wizard-step data-title=\"{{ :: 'Saved Searches' | translate }}\" data-code=\"searches\" data-hide=\"shouldHideStep('searches')\"><div class=\"content\"><div class=\"legend\" translate>Select saved searches for view</div><div sd-toggle-box data-title=\"{{ :: 'Global saved searches' | translate}}\" data-style=\"circle\" data-open=\"true\"><div class=\"desk\" ng-repeat=\"search in globalSavedSearches track by search._id | orderBy: 'name'\"><div class=\"desk-title desk-title--saved-search\"><div class=\"switch\"><span sd-switch ng-model=\"editGroups[search._id].selected\" ng-click=\"setSearchInfo(search._id)\"></span></div><div class=\"desk-title__text\">{{:: search.name}} <i>by {{:: userLookup[search.user].display_name}}</i><div class=\"search-description\">{{:: search.description}}</div></div></div></div></div><div sd-toggle-box data-title=\"{{ :: 'Private saved searches' | translate}}\" data-style=\"circle\" data-open=\"true\" ng-if=\"showPrivateSavedSearches\"><div class=\"desk\" ng-repeat=\"search in privateSavedSearches track by search._id | orderBy: 'name'\" ng-if=\"showPrivateSavedSearches\"><div class=\"desk-title desk-title--saved-search\"><div class=\"switch\"><span sd-switch ng-model=\"editGroups[search._id].selected\" ng-click=\"setSearchInfo(search._id)\"></span></div><div class=\"desk-title__text\">{{:: search.name}}<div class=\"search-description\">{{:: search.description}}</div></div></div></div></div></div></div><div sd-wizard-step data-title=\"{{ :: 'Reorder Sections' | translate }}\" data-code=\"reorder\" data-hide=\"shouldHideStep('reorder')\"><div class=\"content\"><div class=\"legend\" translate>Reorder stages and saved searches for view</div><ul class=\"groups draggable-list\" sd-sort-groups><li class=\"sort-item draggable-list__item draggable-list__item--small\" ng-class=\"{'active': item.order < columnsLimit}\" ng-repeat=\"item in getValues() track by item.order\"><div class=\"group-title\" ng-if=\"item.type === 'stage'\">{{deskLookup[stageLookup[item._id].desk].name}} : <span>{{stageLookup[item._id].name}}</span></div><div class=\"group-title\" ng-if=\"item.type === 'scheduledDeskOutput'\">{{item.name}} : <span translate>Desk Scheduled Output</span></div><div class=\"group-title\" ng-if=\"item.type === 'deskOutput'\">{{item.name}} : <span translate>Desk Output</span></div><div class=\"group-title\" ng-if=\"item.type === 'search'\">{{searchLookup[item._id].name}}</div><div class=\"group-title\" ng-if=\"item.type === 'personal'\" translate>Personal</div></li></ul></div></div><div sd-wizard-step data-title=\"{{ :: 'Items Count' | translate }}\" data-code=\"maxitems\" data-hide=\"shouldHideStep('maxitems')\"><div class=\"content\"><div class=\"legend\" translate>Set maximum items per stages and saved searches for view</div><div class=\"groups\"><div ng-repeat=\"max in getValues()\" class=\"desk desk--item-count\"><div class=\"desk-title\" ng-if=\"max.type === 'stage'\">{{deskLookup[stageLookup[max._id].desk].name}} : <span>{{stageLookup[max._id].name}}</span></div><div class=\"desk-title\" ng-if=\"max.type === 'scheduledDeskOutput'\">{{max.name}} : <span translate>Desk Scheduled Output</span></div><div class=\"desk-title\" ng-if=\"max.type === 'deskOutput'\">{{max.name}} : <span translate>Desk Output</span></div><div class=\"desk-title\" ng-if=\"max.type === 'search'\">{{searchLookup[max._id].name}}</div><div class=\"desk-title\" ng-if=\"max.type === 'personal'\" translate>Personal</div><div class=\"box-items-count sd-line-input sd-line-input--no-margin sd-line-input--no-label sd-line-input--boxed\"><input class=\"sd-line-input__input\" type=\"number\" id=\"maxItems\" ng-model=\"max.max_items\" min=\"1\" max=\"25\" required></div></div></div></div></div></div><div class=\"modal__footer\"><button id=\"previousBtn\" class=\"btn btn--hollow pull-left\" ng-if=\"step.current !== 'desks' && !displayOnlyCurrentStep\" ng-click=\"previous()\" translate>Previous</button> <button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" translate>Done</button> <button id=\"nextBtn\" class=\"btn btn--hollow\" ng-if=\"step.current !== 'maxitems' && !displayOnlyCurrentStep\" ng-click=\"next()\" translate>Next</button></div>");
        $templateCache.put('scripts/apps/monitoring/views/desk-notifications.html', "<div ng-if=\"notifications && default_incoming\" id=\"deskNotifications\" sd-tooltip=\"{{ :: 'Notifications' | translate }}\" flow=\"left\" class=\"dropdown monitoring-dropdown\" ng-class=\"{'dropdown--align-right': !viewColumn}\" dropdown><button class=\"notification-label\" dropdown__toggle><span class=\"notification-count\">{{ notificationCount }}</span></button><ul class=\"dropdown__menu desk-notification-list\"><div class=\"title\" translate>Notification list</div><li ng-repeat=\"n in notifications track by n._id\"><div class=\"article\"><a href=\"\" ng-click=\"open(n);\"><span class=\"slugline\" title=\"{{:: n.item.slugline }}\" ng-if=\"n.item.slugline\">{{:: n.item.slugline | limitTo: 40}}</span> <span class=\"headline\" title=\"{{:: item.headline }}\">{{:: n.item.headline | limitTo: 90 || item.type }}</span></a></div><div class=\"location\"><span class=\"desk\" title=\"{{:: deskLookup[n.item.task.desk].name }}\">{{:: deskLookup[n.item.task.desk].name }}</span> / <span class=\"stage\" title=\"{{:: stageLookup[n.item.task.stage].name }}\">{{:: stageLookup[n.item.task.stage].name }}</span></div><div class=\"buttons\"><button ng-if=\"!isRead(n)\" class=\"acknowledge btn btn--small pull-right\" ng-click=\"acknowledge(n)\" title=\"{{ :: 'Acknowledge' | translate }}\" class=\"open-item\" translate>Acknowledge</button></div><div class=\"sender\"><span>{{:: n.user_name }}:</span><blockquote>{{:: n.data.comment }}</blockquote></div><div class=\"pull-right read-by\" ng-if=\"isRead(n)\">{{ :: 'Opened by' | translate }} <i>\"{{ :: readBy(n) }}\"</i></div></li></ul></div>");
        $templateCache.put('scripts/apps/monitoring/views/highlights-view.html', "<div sd-monitoring-view data-type=\"'highlights'\"></div>");
        $templateCache.put('scripts/apps/monitoring/views/item-actions-menu.html', "<div class=\"dropdown dropdown--align-right dropdown--more-activity item-actions-menu\" dropdown dropdown-append-to-body is-open=\"open\" on-toggle=\"toggleActions(open)\"><button class=\"more-activity-toggle condensed dropdown__toggle\" ng-click=\"stopEvent($event)\" ng-dblclick=\"stopEvent($event)\" ng-show=\"active || open\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown dropdown--align-right dropdown__menu more-activity-menu\" ng-class=\"{open: open}\"><li><div class=\"dropdown__menu-label\">{{ :: 'Actions' | translate }} <button class=\"dropdown__menu-close\"><i class=\"icon-close-small\"></i></button></div></li><li ng-repeat-start=\"group in menuGroups\"></li><li class=\"dropdown__menu-divider\"></li><li ng-repeat=\"activity in group.actions\" sd-activity-item></li><li ng-if=\"group.concate\" sd-activity-dropdown-item data-group=\"{group.label}\"></li><li ng-if=\"!menuGroups.length\"><div class=\"info-block\" translate>You don't have the privileges to perform any action</div></li><li ng-repeat-end></li></ul></div>");
        $templateCache.put('scripts/apps/monitoring/views/monitoring-group-header.html', "<!-- list view --><div class=\"header-container\" ng-if=\"!viewColumn || viewType === 'spiked'\"><div class=\"stage-header\"><div class=\"stage-header__name\" ng-if=\"group.header && group.subheader && viewType !== 'single_monitoring'\"><a href=\"\" ng-click=\"viewSingleGroup(group, 'desk')\">{{ :: group.header }}</a> <span class=\"stage-header__separator\">/</span> <a href=\"\" ng-click=\"viewSingleGroup(group, 'stage')\">{{ :: group.subheader }} {{ :: group.type | translate }}</a></div><!-- Desk output stages--><div class=\"stage-header__name\" ng-if=\"group.header && !group.subheader && viewType !== 'single_monitoring'\"><span class=\"group-header\"><a href=\"\" ng-click=\"viewSingleGroup(group, 'single-stage')\">{{ :: group.header }} {{ :: group.type|splitText | translate }}</a></span></div><span class=\"stage-header__number label-total\">{{ total || '0' }}</span><div class=\"stage-header__stretch-bar\"></div><!-- desk notification section --><div class=\"stage-header__notification\" ng-if=\"!viewColumn\"><div ng-if=\"group.type === 'stage'\" sd-desk-notifications data-stage=\"group._id\"></div></div><!-- refresh button --> <button ng-if=\"showRefresh\" class=\"btn btn--primary btn--icon-only-circle btn--small\" ng-click=\"refreshGroup(group)\" tooltip=\"{{:: 'Refresh' | translate}}\" tooltip-placement=\"left\"><i class=\"icon-repeat\"></i></button></div></div><!-- swimlane view --><div class=\"header-container sd-list-header\" ng-if=\"viewColumn && viewType !== 'spiked'\"><div class=\"stage-header\" ng-if=\"group.header && group.subheader && viewType !== 'single_monitoring'\"><div class=\"stage-header__name\"><a href=\"\" ng-click=\"viewSingleGroup(group, 'desk')\">{{ :: group.header }}</a> <span class=\"stage-header__separator\">/</span> <a href=\"\" ng-click=\"viewSingleGroup(group, 'stage')\">{{ :: group.subheader }}</a></div><span class=\"stage-header__number label-total\">{{ total || '0' }}</span><div class=\"stage-header__notification\"><div ng-if=\"group.type === 'stage'\" class=\"\" sd-desk-notifications data-stage=\"group._id\"></div></div></div><!-- Desk output stages--><div class=\"stage-header\" ng-if=\"group.header && !group.subheader && viewType !== 'single_monitoring'\"><div class=\"stage-header__name\"><a href=\"\" ng-click=\"viewSingleGroup(group, 'single-stage')\">{{ :: group.header }} {{ :: group.type|splitText | translate }}</a></div><span class=\"stage-header__number label-total\">{{ total || '0' }}</span><div class=\"stage-header__notification\"><div ng-if=\"group.type === 'stage'\" class=\"\" sd-desk-notifications data-stage=\"group._id\"></div></div><button ng-if=\"showRefresh\" class=\"btn btn--text-only btn--icon-only-circle stage-header__refresh\" ng-click=\"refreshGroup(group)\" tooltip=\"{{:: 'Refresh' | translate}}\" tooltip-placement=\"left\"><i class=\"icon-repeat icon--blue\"></i></button></div></div>");
        $templateCache.put('scripts/apps/monitoring/views/monitoring-group.html', "<div ng-class=\"{\n" +
            "    stage: !viewColumn,\n" +
            "    'sd-kanban-list__board': viewColumn,\n" +
            "}\"><div sd-monitoring-group-header class=\"column-header\" ng-class=\"{'sd-kanban-list__board-header': viewColumn}\" ng-if=\"group.header && viewType !== 'single_monitoring'\"></div><div ng-class=\"{\n" +
            "        'sd-kanban-list__board-content': viewColumn,\n" +
            "    }\"><div sd-items-list class=\"group stage-content\" ng-class=\"{\n" +
            "                refresh: showRefresh,\n" +
            "                'sd-grid-group': view === 'photogrid',\n" +
            "                'sd-shadow--z1': viewColumn,\n" +
            "                'sd-list-item-group': viewColumn,\n" +
            "            }\" ng-style=\"style\" data-hide-actions-for-monitoring-items=\"hideActionsForMonitoringItems\" data-disable-monitoring-multi-select=\"disableMonitoringMultiSelect\" on-monitoring-item-select=\"onMonitoringItemSelect\" on-monitoring-item-double-click=\"onMonitoringItemDoubleClick\"></div></div></div>");
        $templateCache.put('scripts/apps/monitoring/views/monitoring-view.html', "<div class=\"monitoring\" ng-controller=\"AggregateCtrl as aggregate\"><section class=\"main-section\" ng-class=\"monitoring.state\"><div class=\"preview-layout monitoring-preview-layout\" sd-media-query min-width=\"700\" element-class=\"narrowList\"><div class=\"content-list monitoring__content\" ng-if=\"!aggregate.loading\"><div class=\"monitoring__toolbar-container\"><div class=\"subnav\" ng-if=\"hideMonitoringToolbar1 !== true\"><div class=\"flat-searchbar monitoring-backlink\" ng-if=\"monitoring.singleGroup\"><button sd-tooltip=\"{{ :: 'Back to original view' | translate }}\" flow=\"right\" class=\"navbtn navbtn--left\" ng-click=\"monitoring.viewMonitoringHome()\"><i class=\"icon-arrow-left\"></i></button></div><!-- search not implemented for usage with custom data source --><div ng-if=\"customDataSource == null\" class=\"flat-searchbar monitoring-flat-searchbar\" ng-class=\"{extended: aggregate.monitoringSearch}\"><div class=\"search-handler\"><label for=\"search-input\" class=\"trigger-icon\" ng-click=\"aggregate.monitoringSearch = !aggregate.monitoringSearch\"><i class=\"icon-search\"></i></label><input id=\"search-input\" type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"query\" ng-keyup=\"aggregate.searchOnEnter($event, query)\"> <button class=\"search-close\" ng-click=\"aggregate.search(query = null)\" ng-class=\"{visible: query}\"><i class=\"icon-remove-sign\"></i></button> <button class=\"search-close\" ng-click=\"aggregate.search(query);\" ng-class=\"{visible: query}\"><i class=\"svg-icon-right\"></i></button></div></div><div class=\"dropdown\" dropdown ng-if=\"!monitoring.singleGroup && type === 'monitoring'\"><button class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown-toggle>{{ :: 'Monitoring' | translate }} {{workspace.name}} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu scrollable\"><li><div class=\"dropdown__menu-label\">{{ :: 'Stages' | translate }}</div></li><li ng-repeat=\"card in aggregate.cards\"><button class=\"label-group\" ng-click=\"monitoring.viewSingleGroup(card, card.type === 'stage' ? card.type : 'single-stage')\" translate>{{:: monitoring.getGroupLabel(card, aggregate.settings.type)}}</button></li></ul></div><div class=\"subnav__stage-group\" ng-if=\"monitoring.singleGroup.singleViewType === 'stage' || monitoring.singleGroup && !monitoring.singleGroup.subheader\"><span class=\"stage-group__desk\">{{ monitoring.singleGroup.header }}</span> <span class=\"stage-group__split\">/</span><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle navbtn navbtn--text-only navbtn--padding-s\" dropdown-toggle>{{ monitoring.singleGroup.subheader}} {{ monitoring.singleGroup.type | splitText | translate }}<span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu scrollable\"><li><div class=\"dropdown__menu-label\">{{ :: 'Stages' | translate }}</div></li><li ng-repeat=\"card in aggregate.cards\" ng-class=\"{active: monitoring.singleGroup}\"><button class=\"label-group\" ng-click=\"monitoring.viewSingleGroup(card, card.type === 'stage' ? card.type : 'single-stage')\" ng-disabled=\"monitoring.singleGroup._id === card._id\" translate>{{:: monitoring.getGroupLabel(card, aggregate.settings.type)}}</button></li></ul></div><span class=\"stage-group__badge label label--large\">{{ monitoring.totalItems}}</span></div><h3 class=\"subnav__page-title\"><span ng-if=\"type === 'spike'\"><span translate>Spiked Items</span> <span ng-if=\"aggregate.spikeGroups.length === 1\" class=\"label-total\">{{ monitoring.totalItems}}</span></span> <span ng-if=\"type === 'personal'\" translate>Personal Items</span> <span ng-if=\"type === 'highlights'\" sd-highlight-label data-highlight=\"monitoring.queryParam.highlight\" data-total=\"monitoring.totalItems\"></span> <span ng-if=\"monitoring.singleGroup.subheader && monitoring.singleGroup.singleViewType == null\">{{ monitoring.singleGroup.header}} / {{ monitoring.singleGroup.subheader}} {{ monitoring.singleGroup.type}} <span class=\"label-total\">{{ monitoring.totalItems}}</span> </span><span ng-if=\"monitoring.singleGroup.singleViewType === 'desk'\">{{ monitoring.singleGroup.header }} {{ monitoring.singleGroup.singleViewType}} <span class=\"label-total\">{{ monitoring.totalItems}}</span></span></h3><div sd-multi-action-bar></div><div class=\"subnav__button-stack--square-buttons\"><div class=\"refresh-box pull-right\"><button ng-if=\"monitoring.showRefresh &&\n" +
            "                                                        (monitoring.singleGroup || type === 'spike' || type === 'highlights' || monitoring.viewColumn)\" ng-click=\"refreshGroup(monitoring.singleGroup)\" class=\"btn btn--primary btn--icon-only-circle btn--small\" sd-tooltip=\"{{:: 'Refresh' | translate}}\" flow=\"left\" class=\"navbtn\"><i class=\"icon-repeat\"></i></button></div><div class=\"pull-left-10x\" ng-if=\"type === 'highlights'\" sd-create-highlights-button data-highlight=\"monitoring.queryParam.highlight\"></div><button class=\"navbtn strict\" ng-if=\"type === 'monitoring' && aggregate.settings.type === 'workspace'\" ng-click=\"aggregate.edit()\"><i class=\"icon-settings\"></i></button><div ng-if=\"disableMonitoringCreateItem == null && (!state.opened && (type !== 'spike' && type !== 'highlights'))\" class=\"dropdown dropdown--align-right strict\" sd-tooltip=\"{{ :: 'Create new item' | translate }}\" flow=\"left\" dropdown><button class=\"navbtn dropdown__toggle sd-create-btn\" dropdown__toggle></button><div class=\"dropdown__menu dropdown__menu--has-head-foot pull-right\" sd-content-create></div></div></div></div><div ng-hide=\"hideMonitoringToolbar2 === true\" sd-media-query min-width=\"700\" class=\"subnav\"><!-- filtering by file type not implemented for usage with custom data source --><div ng-if=\"(!elementState || elementState === 'comfort') && customDataSource == null\" class=\"button-list button-list--padded\"><a href=\"\" ng-repeat=\"fileType in aggregate.fileTypes\" ng-click=\"aggregate.setFileType(fileType)\" class=\"toggle-button\" ng-class=\"{'toggle-button--active': aggregate.hasFileType(fileType)}\" title=\"{{fileType| translate}}\"><span ng-if=\"fileType === 'all'\" class=\"toggle-button__text toggle-button__text--all\">{{:: 'all' | translate}}</span> <i ng-if=\"fileType !== 'all' && fileType !== 'highlightsPackage'\" class=\"toggle-button__icon filetype-icon-{{fileType}}\"></i> <i ng-if=\"fileType === 'highlightsPackage'\" class=\"toggle-button__icon filetype-icon-highlight-pack\" title=\"{{ :: 'Highlight Package' | translate }}\"></i></a></div><div class=\"dropdown dropdown--align-left dropdown--compact-state\" dropdown ng-if=\"elementState === 'compact'\" sd-tooltip=\"{{:: 'Filter file types' | translate}}\" flow=\"right\"><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i class=\"icon-dots\"></i></button><ul class=\"dropdown__menu\"><li><span class=\"dropdown__menu-label\">{{:: 'File types' | translate}}</span></li><li ng-repeat=\"fileType in aggregate.fileTypes\" ng-click=\"aggregate.setFileType(fileType)\" ng-class=\"{'dropdown__menu-item--active': aggregate.hasFileType(fileType)}\" title=\"{{fileType| translate}}\"><button><span ng-if=\"fileType === 'all'\" class=\"toggle-button__text--all\">{{:: 'all' | translate}}</span> <span ng-if=\"fileType === 'highlightsPackage'\"><i class=\"filetype-icon-highlight-pack\"></i>&nbsp;{{ :: 'Highlight Package' | translate }}</span> <span ng-if=\"fileType !== 'all' && fileType !== 'highlightsPackage'\"><i class=\"filetype-icon-{{fileType}}\"></i>&nbsp;{{fileType}}</span></button></li></ul></div><div class=\"subnav__stretch-bar\"></div><!-- sorting not implemented for usage with custom data source --><div sd-item-sortbar class=\"sortbar-container\"></div><div class=\"dropdown dropdown--align-right\" dropdown ng-if=\"type === 'monitoring'\"><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i ng-class=\"{'icon-list-view': !monitoring.viewColumn && (!view || view === 'compact'), 'icon-grid-view': view === 'photogrid', 'icon-kanban-view': monitoring.viewColumn}\"></i></button><ul class=\"dropdown__menu\"><li><button ng-click=\"switchView('compact')\"><i class=\"icon-list-view\"></i>{{'List View' | translate}}</button></li><li ng-if=\"!monitoring.singleGroup && type === 'monitoring' && monitoring.hasSwimlaneView\"><button ng-click=\"switchView('swimlane2', true)\"><i class=\"icon-kanban-view\"></i>{{'Swimlane View' | translate}}</button></li><li><button ng-if=\"type !== 'spike'\" ng-click=\"switchView('photogrid')\"><i class=\"icon-grid-view\"></i>{{'Photo Grid View' | translate}}</button></li></ul></div><div ng-if=\"type === 'monitoring' && monitoring.viewColumn === true\" class=\"subnav__button-stack subnav__button-stack--padded\"><span class=\"sd-overflow-ellipsis\" translate>Columns:</span> <input class=\"line-input line-input--inline-mini sd-margin-l--1\" type=\"number\" min=\"2\" max=\"{{aggregate.groups.length}}\" ng-model=\"monitoring.columnsLimit\"></div><div class=\"dropdown dropdown--align-right dropdown--compact-state\" dropdown ng-if=\"type === 'monitoring'\"><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu\"><li ng-if=\"type === 'monitoring'\"><button ng-click=\"aggregate.edit('reorder', true)\"><i class=\"icon-switches\"></i> &nbsp;<span>{{:: 'Rearrange Groups' | translate}}</span></button></li></ul></div></div></div><div class=\"monitoring__main-content\"><div class=\"sd-column-box--3\"><div style=\"padding: 0 20px 20px\" class=\"sd-column-box__main-column\"><!-- list view --><div ng-if=\"!monitoring.viewColumn && type === 'monitoring'\" class=\"list\"><div ng-if=\"(!monitoring.singleGroup || monitoring.isDeskChanged()) && type === 'monitoring'\"><div ng-repeat=\"group in aggregate.groups track by group._id\" sd-monitoring-group data-group=\"group\" data-num-items=\"group.max_items\" data-view=\"view\" data-view-type=\"aggregate.isOutputType(group.type) ? group.type: 'monitoring'\"></div></div></div><!-- swimlane view --><div ng-if=\"monitoring.viewColumn && type === 'monitoring'\" class=\"sd-kanban-list-container\"><div class=\"sd-kanban-list\" ng-if=\"(!monitoring.singleGroup || monitoring.isDeskChanged()) && type === 'monitoring'\"><div ng-class=\"{active: isActiveGroup(group), inactive: !isActiveGroup(group)}\" ng-repeat=\"group in aggregate.groups| limitTo:monitoring.columnsLimit track by group._id\" sd-monitoring-group data-group=\"group\" data-num-items=\"group.max_items\" data-view=\"view\" data-view-type=\"aggregate.isOutputType(group.type) ? group.type: 'monitoring'\" class=\"fix-stage\"></div></div></div><div ng-if=\"type === 'spike'\" class=\"list\"><div ng-repeat=\"group in aggregate.spikeGroups track by group._id | orderBy: name\" sd-monitoring-group ng-class=\"{'single-group': aggregate.spikeGroups.length === 1}\" data-group=\"group\" data-view-type=\"'spiked'\" data-force-limited=\"{{ aggregate.spikeGroups.length > 1}}\"></div></div><div ng-if=\"monitoring.singleGroup && !monitoring.isDeskChanged()\" class=\"list\"><div sd-monitoring-group class=\"single-group\" data-group=\"monitoring.singleGroup\" data-view=\"view\" data-view-type=\"'single_monitoring'\"></div></div><div ng-if=\"type === 'personal'\" class=\"list\"><div sd-monitoring-group data-view=\"view\" data-group=\"{'type': 'personal', 'query': query, 'fileType': aggregate.getSelectedFileTypes()}\" view-type=\"'personal'\"></div></div><div ng-if=\"type === 'custom-monitoring-view'\" class=\"list\"><div sd-monitoring-group class=\"single-group\" custom-data-source=\"customDataSource\" data-hide-actions-for-monitoring-items=\"hideActionsForMonitoringItems\" data-disable-monitoring-multi-select=\"disableMonitoringMultiSelect\" on-monitoring-item-select=\"onMonitoringItemSelect\" on-monitoring-item-double-click=\"onMonitoringItemDoubleClick\"></div></div><div ng-if=\"type === 'highlights' && !monitoring.highlightsDeskChanged()\" class=\"list\"><div sd-monitoring-group class=\"single-group\" data-group=\"{'type': 'highlights', 'query': query, 'fileType': aggregate.getSelectedFileTypes()}\" data-view=\"view\" data-view-type=\"'highlights'\"></div></div></div><div class=\"sd-preview-panel\" style=\"position: relative\" ng-if=\"!narrowList\"><div sd-item-preview style=\"position: relative\" data-item=\"monitoring.previewItem\" data-close=\"monitoring.closePreview()\" data-show-history-tab=\"monitoring.showHistoryTab\"></div></div></div></div><!-- Overlay Preview Pane --><div sd-item-preview class=\"sd-preview--overlay\" ng-if=\"narrowList\" data-item=\"monitoring.previewItem\" data-close=\"monitoring.closePreview()\" data-show-history-tab=\"monitoring.showHistoryTab\"></div></div><div sd-send-item data-item=\"null\" data-mode=\"{{type}}\"></div></div><div sd-aggregate-settings data-modal-active=\"aggregate.modalActive\" data-desks=\"aggregate.desks\" data-desk-stages=\"aggregate.deskStages\" data-searches=\"aggregate.searches\" data-desk-lookup=\"aggregate.deskLookup\" data-stage-lookup=\"aggregate.stageLookup\" data-search-lookup=\"aggregate.searchLookup\" data-groups=\"aggregate.groups\" data-edit-groups=\"aggregate.editGroups\" data-settings=\"aggregate.settings\" data-onclose=\"aggregate.refreshGroups()\" data-current-step=\"aggregate.currentStep\" data-display-only-current-step=\"aggregate.displayOnlyCurrentStep\" data-columns-limit=\"monitoring.columnsLimit\"></div></section><div sd-archived-item-kill ng-if=\"archived_kill\" data-item=\"archived_kill\" data-action=\"archived_kill_action\"></div><div sd-resend-item data-item=\"resend\"></div></div>");
        $templateCache.put('scripts/apps/monitoring/views/monitoring.html', "<div sd-monitoring-view data-type=\"'monitoring'\" data-state=\"authoring.state\"></div>");
        $templateCache.put('scripts/apps/monitoring/views/personal.html', "<div sd-monitoring-view data-type=\"'personal'\"></div>");
        $templateCache.put('scripts/apps/monitoring/views/spike-monitoring.html', "<div sd-monitoring-view data-type=\"'spike'\"></div>");
        $templateCache.put('scripts/apps/packaging/views/add-to-package.html', "<div sd-add-package-dropdown></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-add-package-dropdown.html', "<ul><li ng-repeat=\"group in groupList track by $index\"><button data-option=\"{{group}}\" ng-click=\"select(group);\"><i class=\"icon-plus\"></i>{{group}}</button></li></ul>");
        $templateCache.put('scripts/apps/packaging/views/sd-package-edit.html', "<header class=\"package-header\"><div class=\"inputs\"><div class=\"field\"><label translate>Headline</label><span sd-character-count data-item=\"item.headline\" data-limit=\"schema.headline.maxlength\"></span><textarea class=\"title\" id=\"title\" sd-auto-height ng-model=\"item.headline\" ng-change=\"autosave(item)\" ng-if=\"_editable\" ng-trim=\"false\"></textarea><div class=\"title\" ng-if=\"!_editable\">{{item.headline}}</div></div></div></header><div class=\"field composite-preview\"><div sd-package-items-edit ng-model=\"item.groups\" ng-if=\"_editable\"></div><div sd-package data-item=\"item\" class=\"composite-preview\" ng-if=\"!_editable\"></div></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-package-item-preview.html', "<div class=\"package-item item {{ :: data.type }}\" ng-class=\"{locked: isLocked, published: isPublished, killed: isKilled}\"><div class=\"package-item__drag-handle\"></div><figure class=\"package-item__icon-holder\" ng-if=\"data.type === 'composite' || data.type === 'text'\"><i class=\"filetype-icon-large-{{ :: data.type }}\"></i></figure><div class=\"package-item__thumb-holder\" ng-if=\"data.type !== 'composite' && data.type !== 'text'\"><div class=\"alert-error\" ng-show=\"error\" translate>Problems occurred while fetching data.</div><div class=\"loading\" ng-show=\"data == null && error == null\"></div><div class=\"error-icon\" ng-show=\"error != null\"><i class=\"filetype-icon-large-{{data.type}}\"></i></div><div ng-if=\"data.type === 'picture' || data.type === 'graphic'\" sd-item-rendition data-item=\"data\" data-rendition=\"thumbnail\" ng-click=\"preview(data)\"></div><audio ng-if=\"data.type === 'audio'\" controls sd-sources data-renditions=\"data.renditions\" ng-show=\"data\"></audio><div ng-if=\"data.type === 'video'\"><i class=\"filetype-icon-large-video\"></i></div></div><div class=\"package-item__item-text-group\"><div class=\"package-item__item-headline\"><div ng-show=\":: data.headline || data.slugline || data.description_text\">{{ :: data.headline || data.slugline || data.description_text}}</div><div ng-show=\":: data.anpa_take_key\">{{ :: data.anpa_take_key}}</div><div ng-hide=\":: data.headline || data.slugline || data.description_text\" translate>Blank headline received</div></div><div><span ng-if=\"label\" class=\"state-label state-in_progress\" translate>label: <b>{{label.name}}</b></span> <span class=\"package-item__item-creator\">Created <time sd-datetime data-date=\"data.firstcreated\" data-from-now=\"true\"></time> <span ng-if=\"userLookup[data.original_creator]\" translate>by <b>{{userLookup[data.original_creator].display_name}}</b></span></span></div><div class=\"package-item__item-abstract\" ng-if=\"data.abstract\" ng-bind-html=\"data.abstract\"></div></div><div class=\"package-item__action-menu\" sd-item-actions-menu data-item=\"data\" data-active=\"data\"></div><div class=\"package-details\" ng-if=\"data.type === 'composite'\"><i class=\"svg-icon-right\"></i></div><div class=\"alert-error\" ng-show=\"error\" translate ng-if=\"data.type == 'composite' || data.type == 'text'\">Problems occurred while fetching data.</div></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-package-item.html', "<div ng-repeat=\"v in item\" ng-if=\"v.childId !== '_items'\"><div sd-package-item-proxy data-id=\"v.childId\" data-item=\"v.childData[0]\" data-setitem=\"setitem({selected: selected})\" data-mode=\"mode\"></div></div><div ng-if=\"id && id !== 'root' && mode === 'tree'\" sd-toggle-box data-title=\"{{id}}\" data-open=\"true\"><ul><li ng-repeat=\"child in item.childData\"><div sd-package-ref data-item=\"child\" data-setitem=\"setitem({selected: selected})\"></div></li></ul></div><div ng-if=\"id && id !== 'root' && mode === 'flat'\"><div ng-repeat=\"child in item.childData\"><div sd-package-ref data-item=\"child\" data-setitem=\"setitem({selected: selected})\"></div></div></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-package-items-edit.html', "<div class=\"package-edit-container\"><ul class=\"package-edit\" sd-sort-package-items><li ng-repeat=\"group in list\"><div class=\"group-info\"><h6>{{ group.id }}</h6></div><ul id=\"{{ group.id | uppercase}}\" class=\"package-edit-items clearfix\" data-group=\"{{group.id}}\"><li class=\"sort-item clearfix\" ng-repeat=\"item in group.items\"><div class=\"item-container\"><div sd-package-item-preview data-item=\"item\"></div><button class=\"remove\" ng-click=\"remove(group.id, item.residRef)\"><i class=\"icon-close-small\"></i></button></div></li><li class=\"fake clearfix\"><div></div></li></ul></li></ul><ul class=\"package-edit package-highlight-preview\" ng-if=\"highlight\"><li><div class=\"group-info\"><h6>Highlight Preview</h6></div><ul id=\"highlight-preview\" class=\"package-edit-items clearfix\"><li class=\"sort-item clearfix\"><div class=\"preview-container\" sd-html-preview=\"highlight_preview\"></div></li><li class=\"fake clearfix\"><div></div></li></ul></li></ul></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-package-ref.html', "<div ng-click=\"setitem({selected: item})\"><div sd-package-item-preview data-item=\"item\" data-readonly=\"true\"></div></div>");
        $templateCache.put('scripts/apps/packaging/views/sd-package.html', "<div sd-package-item data-id=\"'root'\" data-item=\"tree\" data-setitem=\"setitem({selected: selected})\" data-mode=\"mode\"></div>");
        $templateCache.put('scripts/apps/packaging/views/search-widget-preview.html', "<div class=\"preview-container\" ng-init=\"contenttab = true\"><header><ul class=\"nav nav-tabs\"><li ng-class=\"{active: contenttab}\"><button ng-click=\"contenttab = true\" translate>Content</button></li><li ng-class=\"{active: !contenttab}\"><button ng-click=\"contenttab = false\" translate>Metadata</button></li></ul><button ng-click=\"preview()\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div class=\"content-item-preview\" ng-if=\"selected\"><div class=\"content\" ng-if=\"contenttab\" sd-media-preview-widget data-item=\"selected\"></div><div ng-if=\"!contenttab\" sd-media-metadata data-item=\"selected\"></div></div></div>");
        $templateCache.put('scripts/apps/packaging/views/search.html', "<div class=\"content-search\" ng-class=\"{extended: selected}\" ng-controller=\"SearchWidgetCtrl\"><div class=\"search-container\"><div class=\"search-box\"><input type=\"text\" placeholder=\"{{ 'Search'|translate }}\" ng-model=\"query\"><div ng-show=\"highlight\" align=\"right\" left sd-search-highlights data-highlight=\"highlight\"></div></div><div class=\"filter-list\"><div class=\"dropdown group-select pull-right\" ng-if=\"multiSelected.length\" dropdown><div class=\"btn dropdown__toggle\" dropdown__toggle><i class=\"icon-package-plus\"></i> {{'Add items' | translate}}</div><ul class=\"dropdown__menu pull-right\"><li ng-repeat=\"t in groupList\"><button option=\"{{ t | uppercase  }}\" ng-click=\"addMultiItemsToGroup(t);\">{{ t | uppercase | translate }}</button></li></ul></div></div><div class=\"content-list\"><ul><li ng-repeat=\"pitem in contentItems\" ng-class=\"{active: pitem === selected, added: itemInPackage(pitem), 'multi-select': pitem.multi}\" ng-if=\"pitem._id !== item._id\" sd-widget-prevent-preview><div class=\"select-box\"><i class=\"filetype-icon-{{pitem.type}}\"></i> <span ng-if=\"!itemInPackage(pitem)\" ng-click=\"addToSelected(pitem)\" class=\"select\" sd-check ng-model=\"pitem.multi\"></span></div><div class=\"state-label state-{{pitem.state}}\">{{pitem.state}}</div><p><span class=\"keyword\" ng-if=\"pitem.slugline\">{{ pitem.slugline }}</span>{{pitem.headline || pitem.type}}</p><ul class=\"item-functions\" ng-if=\"!itemInPackage(pitem) && !pitem.multi\"><li class=\"dropdown group-select\" dropdown><button title=\"Add to package\" class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-package-plus\"></i></button><ul class=\"dropdown__menu pull-right\"><li ng-repeat=\"t in groupList\"><button option=\"{{ t | uppercase  }}\" ng-click=\"addItemToGroup(t, pitem);\">{{ t | uppercase }}</button></li></ul></li></ul></li></ul></div></div><div ng-include=\"'scripts/apps/packaging/views/search-widget-preview.html'\"></div></div>");
        $templateCache.put('scripts/apps/products/views/product-test.html', "<div class=\"sd-page__flex-helper products-content\" ng-controller=\"ProductsConfigCtrl\"><div class=\"sd-page__content\"><div class=\"grid\" style=\"margin: 0 -2rem\"><div class=\"grid__item grid__item--col-3\"><div class=\"panel-search sd-shadow--z2\"><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\">{{ :: 'Story GUID' | translate }}</label><input class=\"sd-line-input__input\" type=\"text\" id=\"story-id\" required ng-model=\"articleId\"></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{ :: 'Result Type' | translate }}</label><select class=\"sd-line-input__select\" ng-model=\"resultType\"><option value=\"All\">All</option><option value=\"Match\">Match</option><option value=\"No-Match\">No-Match</option></select></div></div><div class=\"form__row\" style=\"text-align:right\"><button class=\"btn btn--primary btn--pull-right\" ng-disabled=\"!articleId\" ng-click=\"test()\" translate>Test Products</button></div></div></div><div class=\"grid__item grid__item--col-9\"><div ng-if=\"loading\" class=\"loading-overlay\" ng-class=\"{active: loading}\" style=\"opacity: 0.5\"></div><div ng-if=\"!loading\"><ul class=\"pills-list\"><li ng-repeat=\"product in filteredProducts\" class=\"{{testLookup[product._id].matched ? 'match':'no-match'}}\"><h6>{{ product.name }} [{{ product.product_type || 'both'}}]</h6><div class=\"actions\"><button ng-click=\"edit(product)\" title=\"{{:: 'Edit product' | translate }}\"><i class=\"icon-pencil\"></i></button></div><div ng-if=\"testLookup[product._id]\"><br><div>Test Result: <span>{{ testLookup[product._id].matched ? 'Match':'No-Match' }}</span></div><div ng-if=\"!testLookup[product._id].matched\">Reason: <span>{{ testLookup[product._id].reason }}</span></div></div></li></ul></div></div></div></div><div sd-products-config-modal></div></div>");
        $templateCache.put('scripts/apps/products/views/products-config-modal.html', "<div sd-modal data-model=\"modalActive\" data-close=\"cancel()\" class=\"modal--large modal--tabs\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"!product.edit._id\" translate>Add New Product</h3><h3 class=\"modal__heading\" ng-show=\"product.edit._id\" translate>Edit \"{{product.edit.name}}\" Product</h3><a href=\"\" class=\"icn-btn close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><form name=\"editForm\"><div class=\"modal__body-header\"><ul class=\"nav-tabs\"><li ng-class=\"{'nav-tabs__tab--active': !tab || tab === 'products'}\" class=\"nav-tabs__tab\"><button ng-click=\"tab = 'products'\" class=\"nav-tabs__link\"><span translate>Product Details</span></button></li><li ng-class=\"{'nav-tabs__tab--active': tab === 'subscribers'}\" class=\"nav-tabs__tab\"><button ng-click=\"tab = 'subscribers'\" class=\"nav-tabs__link\"><span translate>Subscribers</span></button></li></ul></div><div class=\"modal__body-content\"><div ng-if=\"!tab || tab === 'products'\" class=\"nav-tabs__pane\"><fieldset><div class=\"form__row\" ng-if=\"product._id\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--disabled\"><label class=\"sd-line-input__label\" for=\"product-id\" translate>Product ID</label><input class=\"sd-line-input__input\" id=\"product-id\" type=\"text\" ng-model=\"product._id\" ng-disabled=\"true\"> <span class=\"sd-line-input__hint\" translate>The Product ID can be copied and used as Superdesk Newshub product query.</span></div></div><div class=\"sd-line-input sd-line-input--boxed sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"product-name\" translate>Product name</label><input class=\"sd-line-input__input\" id=\"product-name\" type=\"text\" ng-model=\"product.edit.name\" required></div><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Product description</label><textarea class=\"sd-line-input__input\" ng-model=\"product.edit.description\" sd-auto-height></textarea></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" translate>Product Type</label><select class=\"sd-line-input__select\" ng-model=\"product.edit.product_type\" ng-options=\"p.qcode as p.name for p in product_types\"><option value=\"\"></option></select></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Product codes</label><textarea class=\"sd-line-input__input\" ng-model=\"product.edit.codes\" sd-auto-height></textarea><span class=\"sd-line-input__hint\" translate>Comma separated values.</span></div></div><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" translate>Content Filter</label><select class=\"sd-line-input__select\" ng-model=\"product.edit.content_filter.filter_id\"><option value=\"\"></option><option value=\"{{filter._id}}\" ng-selected=\"filter._id === product.edit.content_filter.filter_id\" ng-repeat=\"filter in contentFilters track by filter._id\">{{:: filter.name}}</option></select></div><div class=\"form__row\" ng-if=\"product.edit.content_filter.filter_id\"><label class=\"form-label form-label--block form-label--marg-b10\" translate>Content Filter Type</label><div class=\"sd-check__group\"><sd-check ng-model=\"product.edit.content_filter.filter_type\" type=\"radio\" ng-value=\"permitting\">{{ :: 'Permitting' | translate }}</sd-check><sd-check ng-model=\"product.edit.content_filter.filter_type\" type=\"radio\" ng-value=\"blocking\">{{ :: 'Blocking' | translate }}</sd-check></div></div><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"geoRestrictions\" translate>Target Regions</label><select class=\"sd-line-input__select\" id=\"geoRestrictions\" ng-model=\"product.edit.geo_restrictions\" ng-options=\"g.qcode as g.name for g in geoRestrictions\"><option value=\"\"></option></select></div></fieldset></div><div ng-if=\"tab === 'subscribers'\" class=\"nav-tabs__pane\"><div class=\"sd-grid-list sd-grid-list--no-margin\"><div ng-repeat=\"subscriber in subscribers| orderBy:name\" class=\"sd-card sd-card--auto-height\" ng-if=\"subscriber.products.indexOf(product.edit._id) >= 0\"><span class=\"sd-card__content sd-card__content--padd-10\">{{::subscriber.name}}</span></div></div></div></div></form><div class=\"modal__body-footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"editForm.$invalid || !editForm.$dirty\" translate>Save</button></div></div></div>");
        $templateCache.put('scripts/apps/products/views/products.html', "<div class=\"sd-page__flex-helper products-content\" ng-controller=\"ProductsConfigCtrl\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"search.name\" data-debounce=\"200\"></sd-search-handler><div class=\"sortbar\"><span class=\"lab\" translate>Product Type:</span><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:120px\"><select class=\"sd-line-input__select\" ng-model=\"search.product_type\" ng-options=\"p.qcode as p.name for p in product_types\"><option value=\"\" translate>Select</option></select></div></div><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"newProduct()\"><i class=\"icon-plus-sign icon--white\"></i>{{ :: 'Add New' | translate }}</button></div><div class=\"sd-page__content\"><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><li ng-repeat=\"product in products| productsBy:search as filtered_products track by product._id\" class=\"sd-list-item sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\">{{ product.name}}</span> <span class=\"label label--hollow\">{{ product.product_type || 'both' }}</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"edit(product)\" title=\"{{:: 'Edit product' | translate }}\"><i class=\"icon-pencil\"></i></button> <button class=\"icn-btn\" ng-click=\"remove(product)\" title=\"{{:: 'Remove product' | translate }}\"><i class=\"icon-trash\"></i></button></div></li><li ng-show=\"products.length > 0 && !filtered_products.length\" class=\"sd-list-item sd-list-item--no-hover sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span translate>No Products Found</span></div></div></li></ul></div><div sd-products-config-modal></div></div>");
        $templateCache.put('scripts/apps/products/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" ng-init=\"tab = 'products'\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Products management</h2></div><div class=\"sd-page__header sd-page__header--white\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'products'}\"><button ng-click=\"tab = 'products'\" translate>Products</button></li><li ng-class=\"{active: tab === 'productTest'}\"><button ng-click=\"tab = 'productTest'\" translate>Product Test</button></li></ul></div><div class=\"sd-page__flex-helper\"><div class=\"sd-page__flex-helper\" ng-if=\"tab === 'products'\" ng-include=\"'scripts/apps/products/views/products.html'\"></div><div class=\"sd-page__flex-helper\" ng-if=\"tab === 'productTest'\" ng-include=\"'scripts/apps/products/views/product-test.html'\"></div></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/profiling/views/profiling.html', "<section class=\"main-section profiling-data\"><div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\"><div class=\"list-pane\"><header><div class=\"sortbar pull-left\"><span class=\"lab pull-left\" translate>Profile:</span><div class=\"dropdown pull-left\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ profile_names[current_profile] }} <span ng-if=\"!current_profile\">{{ :: 'none' | translate }}</span> <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu\"><li ng-repeat=\"profile in profiles\"><a href=\"\" ng-click=\"loadProfile(profile)\">{{ profile_names[profile] }}</a></li></ul></div></div><div class=\"refresh-box\"><button class=\"btn btn--primary pull-right\" ng-click=\"reset()\">{{ :: 'Reset' | translate}}</button> <button ng-click=\"reload()\" class=\"pull-right\" tooltip=\"{{:: 'Refresh' | translate}}\" tooltip-placement=\"left\"><i class=\"icon-refresh\"></i></button> <span class=\"pull-right\">{{ :: 'Last refreshed at' | translate}}: {{ lastRefreshedAt | date:'dd-MM-yyyy HH:mm:ss' }}</span></div></header><div class=\"content\"><div sd-shadow><table class=\"table styled-table\"><thead><tr><th translate>No of calls</th><th translate>Total time</th><th translate>Time per call</th><th translate>Cumulative time</th><th translate>Cumulative time per call</th><th translate>File name/line</th><th translate>Function</th></tr></thead><tbody><tr ng-repeat=\"profile_item in profiling_data\"><td>{{ profile_item.ncalls}}</td><td>{{ profile_item.tottime}}</td><td>{{ profile_item.percall}}</td><td>{{ profile_item.cumtime}}</td><td>{{ profile_item.percall_cumtime}}</td><td>{{ profile_item.filename_lineno}}</td><td>{{ profile_item.func_name}}</td></tr></tbody></table></div></div></div></div></section>");
        $templateCache.put('scripts/apps/publish/views/data-consistency.html', "<sd-settings-view><div id=\"data-consistency\" ng-init=\"tab = 'data-consistency'\"><button ng-click=\"reload()\">Refresh</button><i style=\"float:right\">Last refreshed at: {{ lastRefreshedAt | date:'dd-MM-yyyy HH:mm:ss' }}</i><hr><table class=\"table\"><thead><tr><th>Collection</th><th>Mongo Records</th><th>Elastic Records</th><th>Identical Records</th><th>Mongo Only</th><th>Elastic Only</th><th>Inconsistent</th><th>Started At</th><th>Completed At</th></tr></thead><tbody><tr ng-repeat=\"consistency_record in consistency_records\"><td>{{ consistency_record.resource_name }}</td><td>{{ consistency_record.mongo }}</td><td>{{ consistency_record.elastic }}</td><td>{{ consistency_record.identical }}</td><td>{{ consistency_record.mongo_only }}</td><td>{{ consistency_record.elastic_only }}</td><td>{{ consistency_record.inconsistent }}</td><td>{{ consistency_record.started_at | dateTimeStringWithSecs}}</td><td>{{ consistency_record.completed_at | dateTimeStringWithSecs }}</td></tr></tbody></table></div></sd-settings-view>");
        $templateCache.put('scripts/apps/publish/views/destination.html', "<div class=\"destination-box\"><fieldset><div class=\"sd-line-input sd-line-input--boxed sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"destination-name\" translate>Name</label><input class=\"sd-line-input__input\" type=\"text\" id=\"destination-name\" required ng-model=\"destination.name\"></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"destination-format\" translate>Format</label><select class=\"sd-line-input__select\" id=\"destination-format\" required ng-model=\"destination.format\"><option value=\"\"></option><option value=\"{{format.qcode}}\" ng-selected=\"format.qcode === destination.format\" ng-repeat=\"format in $parent.formats track by format.qcode\">{{:: format.name | translate}}</option></select></div><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"preview-endpoint-url\" translate>Preview endpoint URL</label><input class=\"sd-line-input__input\" type=\"url\" id=\"preview-endpoint-url\" ng-model=\"destination.preview_endpoint_url\"></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"destination-delivery-type\" translate>Delivery type</label><select class=\"sd-line-input__select\" id=\"destination-delivery-type\" required ng-model=\"destination.delivery_type\" ng-options=\"key as val.label for (key, val) in types\"></select></div><div class=\"form__row form__row--no-padding credentials\"><div ng-include=\"types[destination.delivery_type].templateUrl\"></div></div><div class=\"form__row\" ng-if=\"actions\" style=\"text-align:right\"><button type=\"button\" class=\"btn btn--hollow\" ng-class=\"{'btn--primary' : action.label === 'Save'}\" ng-repeat=\"action in actions\" ng-click=\"action.fn(destination)\"><span>{{:: action.label | translate}}</span></button></div></fieldset></div>");
        $templateCache.put('scripts/apps/publish/views/email-config.html', "<div class=\"field\"><label for=\"recipients\" translate>Recipients</label><i class=\"field-info\" translate>*at least one visible or hidden recipient needed</i> <input type=\"text\" id=\"recipients\" placeholder=\"{{:: 'Recipients (visible to everybody)'|translate }}\" ng-model=\"destination.config.recipients\" ng-change=\"$parent.setConfig(provider)\" ng-required=\"!(destination.config.recipients.length || destination.config.recipients_bcc.length)\"></div><div class=\"field\"><label for=\"recipients\" translate>Recipients (Bcc, hidden)</label><input type=\"text\" id=\"recipients_bcc\" placeholder=\"{{:: 'Hidden recipients (blind carbon copy)'|translate }}\" ng-model=\"destination.config.recipients_bcc\" ng-change=\"$parent.setConfig(provider)\" ng-required=\"!(destination.config.recipients.length || destination.config.recipients_bcc.length)\"></div><div class=\"field\"><label translate>Include Feature Media</label><span ng-model=\"destination.config.attach_media\" sd-switch=\"\"></span></div><div class=\"field\" ng-show=\"destination.config.attach_media\"><label translate>CID</label><i class=\"field-info\" translate>Identifier for the media within the email html template</i> <input type=\"text\" id=\"media_cid\" ng-model=\"destination.config.media_cid\" ng-change=\"$parent.setConfig(provider)\" ng-required=\"destination.config.attach_media\" placeholder=\"{{:: 'Identifier for the media in the email template'|translate}}\"></div><div class=\"field\" ng-show=\"destination.config.attach_media\"><label translate>Rendition</label><i class=\"field-info\" translate>Name of the rendition to attach to the email</i> <input type=\"text\" id=\"media_rendition\" ng-model=\"destination.config.media_rendition\" ng-change=\"$parent.setConfig(provider)\" ng-required=\"destination.config.attach_media\" placeholder=\"{{:: 'The rendition to attach to the email'|translate}}\"></div><div class=\"field\" ng-show=\"destination.config.attach_media\"><label translate>Apply watermark</label><span ng-model=\"destination.config.watermark\" sd-switch=\"\"></span></div>");
        $templateCache.put('scripts/apps/publish/views/file-config.html', "<div class=\"field\"><label for=\"file-path\" translate>Output file path</label><i class=\"field-info pull-right\">*</i> <input type=\"text\" id=\"file-path\" placeholder=\"{{:: 'Output file path'|translate }}\" ng-model=\"destination.config.file_path\" required ng-change=\"$parent.setConfig(file_path)\"></div><div class=\"field\"><label for=\"file-extension\" translate>File Extension</label><i class=\"field-info pull-right\">*</i> <input type=\"text\" id=\"file-extension\" placeholder=\"{{:: 'File Extension'|translate }}\" ng-model=\"destination.config.file_extension\" required ng-change=\"$parent.setConfig(file_extension)\"></div>");
        $templateCache.put('scripts/apps/publish/views/ftp-config.html', "<div class=\"field\"><label for=\"ftp_host\" translate>Host</label><i class=\"field-info pull-right\">*</i> <input type=\"text\" id=\"ftp_host\" placeholder=\"{{ :: 'FTP Server URL'|translate }}\" ng-model=\"destination.config.host\" required ng-change=\"$parent.setConfig(destination)\"></div><div class=\"field\"><label for=\"ftp_username\" translate>Username</label><input type=\"text\" id=\"ftp_username\" placeholder=\"{{ :: 'Username'|translate }}\" ng-model=\"destination.config.username\" ng-change=\"$parent.setConfig(destination)\"></div><div class=\"field\"><label for=\"ftp_password\" translate>Password</label><input type=\"password\" id=\"ftp_password\" placeholder=\"{{ :: 'Password'|translate }}\" ng-model=\"destination.config.password\" ng-change=\"$parent.setConfig(destination)\"></div><div class=\"field\"><label for=\"ftp_passive\" translate>Passive mode</label><input type=\"checkbox\" id=\"ftp_passive\" ng-model=\"destination.config.passive\" ng-change=\"$parent.setConfig(destination)\"></div><div class=\"field\"><label for=\"ftp_path\" translate>Path</label><input type=\"text\" id=\"ftp_path\" placeholder=\"{{ :: 'FTP Server Path'|translate }}\" ng-model=\"destination.config.path\" ng-change=\"$parent.setConfig(destination)\"></div><div class=\"field\"><label for=\"ftp_path\" translate>File Extension</label><i class=\"field-info pull-right\"><span translate>example</span>: txt</i> <input type=\"text\" id=\"ftp_file_extension\" placeholder=\"{{ :: 'FTP File Extension'|translate }}\" ng-model=\"destination.config.file_extension\" ng-change=\"$parent.setConfig(destination)\"></div>");
        $templateCache.put('scripts/apps/publish/views/http-push-config.html', "<div class=\"form__row\"><sd-check ng-model=\"destination.config.packaged\">{{ :: 'Package individual items' | translate }}</sd-check></div><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"resource_url\" translate>Resource URL</label><input class=\"sd-line-input__input\" type=\"text\" id=\"resource_url\" placeholder=\"{{ :: 'Resource URL'|translate }}\" ng-model=\"destination.config.resource_url\" required ng-change=\"$parent.setConfig(destination)\"></div><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"assets_url\" translate>Assets URL</label><input class=\"sd-line-input__input\" type=\"text\" id=\"assets_url\" placeholder=\"{{ :: 'Assets URL'|translate }}\" ng-model=\"destination.config.assets_url\" ng-change=\"$parent.setConfig(destination)\"></div><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"secret_token\" translate>Secret Token</label><input class=\"sd-line-input__input\" type=\"text\" id=\"secret_token\" placeholder=\"{{ :: 'Secret Token'|translate }}\" ng-model=\"destination.config.secret_token\" ng-change=\"$parent.setConfig(destination)\"></div>");
        $templateCache.put('scripts/apps/publish/views/odbc-config.html', "<div class=\"field\"><label for=\"connection-string\" translate>Connection string</label><i class=\"field-info pull-right\">*</i> <input type=\"text\" id=\"connection-string\" placeholder=\"{{:: 'Connection string'|translate }}\" ng-model=\"destination.config.connection_string\" required ng-change=\"$parent.setConfig(connection_string)\"></div><div class=\"field\"><label for=\"stored-procedure\" translate>Stored Procedure</label><i class=\"field-info pull-right\">*</i> <input type=\"text\" id=\"stored-procedure\" placeholder=\"{{:: 'Stored Procedure'|translate }}\" ng-model=\"destination.config.stored_procedure\" required ng-change=\"$parent.setConfig(stored_procedure)\"></div>");
        $templateCache.put('scripts/apps/publish/views/publish-queue.html', "<section class=\"main-section publish-queue\"><div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\"><header class=\"subnav\"><div class=\"flat-searchbar\" ng-class=\"{extended: queueSearch}\"><div class=\"search-handler\"><label for=\"search-input\" class=\"trigger-icon\" ng-click=\"queueSearch = !queueSearch\"><i class=\"icon-search\"></i></label><input id=\"search-input\" type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"query\" ng-model-options=\"{debounce: 500}\" ng-change=\"search(query)\"> <button class=\"search-close\" ng-click=\"search(query = null)\" ng-class=\"{visible: query}\"><i class=\"icon-close-small\"></i></button></div></div><div class=\"sortbar\"><span class=\"lab\" translate>Subscriber:</span><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ selectedFilterSubscriber.name }} <span ng-if=\"!selectedFilterSubscriber\" translate>none</span> <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu dropdown__menu--scrollable\"><li><a href=\"\" ng-click=\"filterPublishQueue(null, 'subscriber')\" translate>None</a></li><li ng-repeat=\"subscriber in subscribers track by subscriber._id\"><a href=\"\" ng-click=\"filterPublishQueue(subscriber, 'subscriber')\">{{ subscriber.name }}</a></li></ul></div><span class=\"lab\" translate>Ingest Provider:</span><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ selectedFilterIngestProvider.name }} <span ng-if=\"!selectedFilterIngestProvider\" translate>none</span> <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu dropdown__menu--scrollable\"><li><a href=\"\" ng-click=\"filterPublishQueue(null, 'ingest_provider')\" translate>None</a></li><li ng-repeat=\"provider in ingestProviders track by provider._id\"><a href=\"\" ng-click=\"filterPublishQueue(provider, 'ingest_provider')\">{{ provider.name }}</a></li></ul></div><span class=\"lab\" translate>Status:</span><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ selectedFilterStatus }} <span ng-if=\"!selectedFilterStatus\" translate>none</span> <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu\"><li><a href=\"\" ng-click=\"filterPublishQueue(null, 'status')\" translate>None</a></li><li ng-repeat=\"status in publish_queue_statuses track by $index\"><a href=\"\" ng-click=\"filterPublishQueue(status, 'status')\">{{ :: status | translate}}</a></li></ul></div><span class=\"lab\" translate>Content Type:</span><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle>{{ selectedFilterContentType.name }} <span ng-if=\"!selectedFilterContentType\" translate>none</span> <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu\"><li><a href=\"\" ng-click=\"filterPublishQueue(null, 'type')\" translate>None</a></li><li ng-repeat=\"type in contentTypes track by type.qcode\"><a href=\"\" ng-click=\"filterPublishQueue(type, 'type')\">{{ :: type.name | translate}}</a></li></ul></div></div><div sd-pagination-alt class=\"pagination-box subnav__element-grow\" data-page=\"page\" data-max-page=\"maxPage\"></div><div class=\"refresh-box\"><span>{{ :: 'Last refreshed at' | translate}}: {{ lastRefreshedAt | date:'dd-MM-yyyy HH:mm:ss' }}</span> <button class=\"navbtn\" ng-click=\"reload()\" tooltip=\"{{:: 'Refresh' | translate}}\" tooltip-placement=\"left\"><i class=\"icon-refresh\"></i></button></div><div class=\"multi-action-bar\" ng-show=\"multiSelectCount > 0\"><button class=\"btn\" ng-click=\"cancelSelection(false)\" ng-show=\"multiSelectCount > 0\">{{ :: 'Cancel Selection' | translate}}</button> <span id=\"multi-select-count\" ng-show=\"multiSelectCount > 0\" translate translate-n=\"multiSelectCount\" translate-plural=\"{{multiSelectCount}} Items selected\">{{multiSelectCount}} Item selected </span><button class=\"btn btn--primary pull-right\" ng-click=\"scheduleToSend()\" ng-show=\"multiSelectCount > 0 && showResendBtn\">{{ :: 'Resend' | translate}}</button> <button class=\"btn btn--primary pull-right\" ng-click=\"cancelSend()\" ng-show=\"multiSelectCount > 0 && showCancelBtn\">{{ :: 'Cancel' | translate}}</button></div></header><div class=\"list-pane\"><div class=\"content\"><div sd-shadow><table class=\"table styled-table\"><thead><tr><th></th><th translate>Sequence No</th><th translate>Unique Name</th><th translate>Headline</th><th class=\"align-right\" translate>Content Type</th><th class=\"align-right\" translate>Publishing Action</th><th class=\"align-right\" translate>Subscriber</th><th class=\"align-right\" translate>Ingest Provider</th><th class=\"align-right\" translate>Destination</th><th class=\"align-right\" translate>Queued at</th><th class=\"align-right\" translate>Scheduled at</th><th class=\"align-right\" translate>Transmitted at</th><th class=\"align-right\" translate>Status</th><th class=\"align-right\" translate>Message</th><th class=\"align-right\" translate>Action</th></tr></thead><tbody><tr ng-repeat=\"queue_item in publish_queue track by queue_item._id\" class=\"{{queue_item.state| queueStatus}}\" ng-click=\"preview(queue_item);\"><td><span sd-check ng-model=\"queue_item.selected\" ng-change=\"selectQueuedItem(queue_item)\"></span></td><td>{{ queue_item.published_seq_num}}</td><td>{{ queue_item.unique_name}}</td><td>{{ queue_item.headline}}</td><td class=\"align-right\">{{ queue_item.content_type}}</td><td class=\"align-right\">{{ queue_item.publishing_action}}</td><td class=\"align-right\">{{subscriberLookup[queue_item.subscriber_id].name}}</td><td class=\"align-right\">{{queue_item.ingest_provider ? ingestProvidersLookup[queue_item.ingest_provider].name : ''}}</td><td class=\"align-right\">{{queue_item.destination.name}}</td><td class=\"align-right\">{{queue_item._created| dateTimeStringWithSecs}}</td><td class=\"align-right\">{{queue_item.publish_schedule| dateTimeStringWithSecs}}</td><td class=\"align-right\">{{queue_item.completed_at| dateTimeStringWithSecs}}</td><td class=\"align-right\">{{queue_item.state}}</td><td class=\"align-right\">{{queue_item.error_message}}</td><td class=\"align-right\" ng-if=\"queue_item.state === 'pending' || queue_item.state === 'retrying'\"><button class=\"btn btn--small\" ng-click=\"cancelSend(queue_item); $event.stopPropagation()\">{{ :: 'Cancel' | translate}}</button></td><td class=\"align-right\" ng-if=\"queue_item.state === 'success' || queue_item.state === 'failed' || queue_item.state === 'canceled'\"><button class=\"btn btn--small\" ng-click=\"scheduleToSend(queue_item); $event.stopPropagation()\">{{ :: 'Resend' | translate}}</button></td></tr></tbody></table></div></div></div><div sd-item-preview data-item=\"selected.preview\" ng-if=\"selected.preview && !selected.extensionPoint\" data-hide-actions-menu=\"true\" data-show-history-tab=\"true\" data-close=\"preview(null)\"></div><div sd-extension-point=\"publish_queue:preview\" data-item=\"selected.preview\" class=\"open-preview\" ng-if=\"selected.preview && selected.extensionPoint\"></div></div></section>");
        $templateCache.put('scripts/apps/publish/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" id=\"publish-settings\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Subscribers</h2></div><div class=\"sd-page__flex-helper\" sd-admin-pub-subscribers></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/publish/views/subscribers.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\" ng-hide=\"hideHeader\"><sd-search-handler ng-model=\"search.name\" data-debounce=\"200\"></sd-search-handler><div class=\"sortbar\"><span class=\"lab\" translate>Target Type:</span><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:120px\"><select class=\"sd-line-input__select\" ng-model=\"search.subscriber_type\" ng-options=\"s.qcode as s.name for s in subTypes\"><option value=\"\" translate>Select</option></select></div></div><div class=\"sortbar\"><span class=\"lab\" translate>Status:</span><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:120px\"><select class=\"sd-line-input__select\" ng-model=\"search.subscriber_status\" ng-options=\"status.label for status in statusFilters track by status.id\"></select></div></div><span class=\"sd-page__element-grow\"></span> <button id=\"addSubscriber\" class=\"btn btn--primary\" ng-click=\"edit()\"><i class=\"icon-plus-sign icon-/white\"></i>{{ :: 'Add New' | translate }}</button></div><div class=\"sd-page__content\"><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><li ng-repeat=\"subscriber in subscribers | subscribersBy:search as filtered_subscribers track by subscriber._id\" class=\"sd-list-item sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\" id=\"subscriberName\">{{ subscriber.name }}</span> <span class=\"label label--hollow label--alert\" ng-if=\"!subscriber.is_active\" translate>Not Active</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"edit(subscriber)\" title=\"{{:: 'Edit Subscriber' | translate }}\"><i class=\"icon-pencil\"></i></button></div></li><li ng-show=\"subscribers.length > 0 && !filtered_subscribers.length\" class=\"sd-list-item sd-list-item--no-hover sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span translate>No Subscribers Found</span></div></div></li></ul></div></div><!-- Modal --><div sd-modal data-model=\"subscriber\" data-close=\"cancel()\" class=\"modal--large modal--tabs sd-wizard\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"subscriber._id\"><span translate>Edit Subscriber</span> \"{{ origSubscriber.name}}\"</h3><h3 class=\"modal__heading\" translate ng-hide=\"subscriber._id\">Add New Subscriber</h3><a href=\"\" class=\"icn-btn\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\" sd-wizard data-name=\"subscribers\" data-current-step=\"step.current\" data-finish=\"cancel()\"><form name=\"editForm\"><fieldset><div sd-wizard-step data-title=\"{{ 'General' | translate }}\" data-code=\"general\"><div class=\"content\"><div class=\"form__row\"><span title=\"{{ subscriber.is_active ? 'Deactivate' : 'Activate' | translate }}\"><span sd-switch ng-model=\"subscriber.is_active\"></span><label>{{:: 'Status' | translate }}</label></span></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"subscriber-name\" translate>Name</label><input class=\"sd-line-input__input\" id=\"subscriber-name\" type=\"text\" required ng-model=\"subscriber.name\"></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"subscriber-email\" ranslate>E-Mail to broadcast Kill Events</label><input type=\"text\" class=\"sd-line-input__input\" id=\"subscriber-email\" ng-model=\"subscriber.email\" required sd-multiple-emails></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"subType\" translate>Target Type</label><select class=\"sd-line-input__select\" id=\"subType\" ng-model=\"subscriber.subscriber_type\" ng-options=\"s.qcode as s.name for s in subTypes\" ng-change=\"changeFormats(subscriber.subscriber_type)\" required><option value=\"\"></option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"media-type\" translate>Media Type</label><select class=\"sd-line-input__select\" id=\"media-type\" ng-model=\"subscriber.media_type\"><option value=\"media\" translate>Media</option><option value=\"nonmedia\" translate>Non-media</option><option value=\"\" translate>Both</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Subscriber codes</label><textarea class=\"sd-line-input__input\" ng-model=\"subscriber.codes\" sd-auto-height></textarea><span class=\"sd-line-input__hint\" translate>Comma separated values</span></div></div><div class=\"form__row form__row--l-padding\"><span title=\"{{ subscriber.is_targetable ? 'Deactivate' : 'Activate' | translate }}\"><span sd-switch ng-model=\"subscriber.is_targetable\"></span><label>{{:: 'Targetable by users' | translate }}</label></span></div><div class=\"form__row form__row--l-padding\"><label class=\"form-label\" translate>Products</label><div sd-meta-terms class=\"subscriber-products\" data-reload-list=\"true\" data-item=\"subscriber\" data-field=\"products\" data-unique=\"_id\" data-list=\"directProducts\" data-header=\"true\"></div></div><div class=\"form__row\"><label class=\"form-label form-label--required\" translate>Sequence Number Settings</label><div class=\"form__row form__row--flex form__row--no-padding\"><div class=\"form__row-item form__row-item--no-grow\"><span translate>Minimum</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input\"><input type=\"number\" class=\"sd-line-input__input sd-line-input__input--mini\" ng-model=\"subscriber.sequence_num_settings.min\" min=\"1\" id=\"subscriber-seq_num_settings.min\" required></div></div><div class=\"form__row-item form__row-item--no-grow\"><span translate>Maximum</span></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"sd-line-input\"><input type=\"number\" class=\"sd-line-input__input sd-line-input__input--small\" ng-model=\"subscriber.sequence_num_settings.max\" min=\"2\" id=\"subscriber-seq_num_settings.max\" required></div></div></div><div class=\"form__row form__row--flex form__row--no-padding\"><div class=\"form__row-item form__row-item--no-grow\"><span sd-switch ng-model=\"subscriber.async\"></span><label>{{:: 'Parallel publishing' | translate }}</label><span class=\"sd-line-input__hint\" translate>When enabled it can send multiple items at the same time.</span></div></div></div><fieldset class=\"separated\"><legend translate>Destinations</legend><div class=\"sd-alert sd-alert--hollow sd-alert--primary sd-alert--small\"><span translate>For Content API only subscriber destinations are not required.</span></div><div sd-destination ng-repeat=\"destination in destinations\" data-destination=\"destination\" data-actions=\"[{label: 'Delete', fn: deleteDestination}]\"></div><div sd-destination ng-if=\"newDestination\" data-destination=\"newDestination\" data-actions=\"[{label: 'Cancel', fn: cancelNewDestination}, {label: 'Save', fn: saveNewDestination}]\"></div><div style=\"text-align:right\"><button type=\"button\" class=\"btn btn--primary btn--hollow btn--large btn--expanded\" ng-click=\"addNewDestination()\" ng-show=\"newDestination === null\"><i class=\"icon-plus-sign\"></i> <span translate>Add New Destination</span></button></div></fieldset></div></div><div sd-wizard-step data-title=\"{{ 'Critical Errors' | translate }}\" data-code=\"critical-errors\"><div class=\"content\"><ul class=\"simple-list simple-list--dotted\"><li ng-repeat=\"(key, val) in all_errors\" class=\"simple-list__item\"><span sd-switch ng-model=\"subscriber.critical_errors[key]\"></span><label>{{::key}}: {{::val}}</label></li></ul></div></div><div sd-wizard-step data-title=\"{{ 'Applied Global Block Filters' | translate }}\" data-code=\"global-block-filters\"><div class=\"content privileges-settings\"><ul class=\"simple-list simple-list--dotted\"><li ng-repeat=\"gf in globalFilters track by gf._id\" class=\"simple-list__item\"><span sd-switch ng-model=\"subscriber.global_filters[gf._id]\"></span><label>{{:: gf.name}}</label></li></ul></div></div><div sd-wizard-step data-title=\"{{ :: 'Content API' | translate }}\" data-code=\"content-api\" ng-if=\"subscriber._id\"><div class=\"content\"><div class=\"field\"><label translate>Products</label><div sd-meta-terms class=\"subscriber-products\" data-reload-list=\"true\" data-item=\"subscriber\" data-field=\"api_products\" data-unique=\"_id\" data-list=\"apiProducts\" data-header=\"true\"></div></div><div class=\"field\" ng-controller=\"SubscriberTokenCtrl as tokens\"><label translate>Authentication Token</label><ul class=\"sd-list-item-group sd-list-item-group--space-between-items\"><li ng-repeat=\"token in tokens.tokens track by token._id\" class=\"sd-list-item sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-overflow-ellipsis sd-list-item--element-grow\"><code contenteditable=\"true\" spellcheck=\"false\">{{ :: token._id}}</code></span> <span class=\"sd-list-item__text-label\">{{ :: 'expires:' | translate }} <time sd-datetime data-date=\"token.expiry\" data-from-now=\"true\"></time></span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-click=\"tokens.revoke(token)\" title=\"{{ :: 'Revoke' | translate }}\"><i class=\"icon-trash\"></i></button></div></li><li ng-show=\"tokens.tokens.length === 0\" class=\"sd-list-item sd-list-item--no-hover sd-shadow--z1\"><div class=\"sd-list-item__border\"></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span translate>There is no token for subscriber.</span></div></div></li></ul><fieldset ng-show=\"tokens.tokens.length < 5\"><div class=\"form__row form__row--flex\"><div class=\"form__row-item form__row-item--no-grow\"><span translate>Expire in:</span></div><div class=\"form__row-item\"><div class=\"sd-line-input sd-line-input--is-select\"><select class=\"sd-line-input__select\" ng-model=\"tokens.ttl\" title=\"{{ :: 'Token expiry' | translate }}\"><option value=\"7\" translate>1 week</option><option value=\"14\" translate>2 weeks</option><option value=\"30\" translate>1 month</option><option value=\"180\" translate>6 months</option><option value=\"365\" translate>1 year</option></select></div></div><div class=\"form__row-item\"></div><div class=\"form__row-item form__row-item--no-grow\"><button class=\"btn btn--hollow\" ng-click=\"tokens.generate(tokens.ttl)\" translate>Generate token</button></div></div></fieldset></div></div></div></fieldset></form><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"editForm.$invalid || (destinations.length === 0 && api_products.length === 0) || (destinations.length === 0 && products.length > 0) || !editForm.$dirty\" translate>Save</button></div></div></div>");
        $templateCache.put('scripts/apps/relations/views/related-items.html', "<button class=\"item-association item-association--no-click\" ng-if=\"isEmptyRelatedItems(field._id)\" ng-class=\"{'item-association--loading': loading}\"><span class=\"item-association__text-label\">{{'Drop items here' | translate}}</span></button><div class=\"related-items\" ng-if=\"!isEmptyRelatedItems(field._id)\"><div ng-if=\"loading\" class=\"loading-overlay\" ng-class=\"{active: loading}\" style=\"opacity: 0.5\"></div><ul class=\"groups draggable-list\" ng-if=\"!loading\" sd-sort-groups><li id=\"{{field._id}}\" class=\"sort-item draggable-list__item draggable-list__item--no-padding\" ng-repeat=\"(key, relatedItem) in relatedItems track by key\"><div class=\"sd-list-item sd-list-item--no-hover\"><div class=\"sd-list-item__column\"><i class=\"type-icon\" sd-filetype-icon data-item=\"relatedItem\"></i></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-list-item__slugline\" ng-if=\"relatedItem.slugline\">{{ relatedItem.slugline }}</span> <span class=\"sd-overflow-ellipsis sd-list-item--element-grow\" sd-item-container data-item=\"relatedItem\" class=\"container\"></span></div><div class=\"sd-list-item__row\"><span class=\"state-label state-{{relatedItem.state}}\">{{ relatedItem.state }}</span> <span class=\"sd-overflow-ellipsis sd-list-item--element-grow\" title=\"{{ relatedItem.headline }}\">{{ relatedItem.headline || relatedItem.description_text }}</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button class=\"icn-btn\" ng-if=\"relatedItem._type === 'archive'\" ng-click=\"openRelatedItem(relatedItem)\"><i class=\"icon-pencil\"></i></button> <button class=\"icn-btn\" ng-click=\"removeRelatedItem(key)\"><i class=\"icon-close-small\"></i></button></div></div></li></ul></div>");
        $templateCache.put('scripts/apps/search-providers/views/search-provider-config.html', "<div class=\"sd-page__flex-helper\" ng-hide=\"hideList\"><div class=\"sd-page__header\"><span class=\"sd-page__element-grow\"></span> <button id=\"addSearchProvider\" class=\"btn btn--primary\" ng-click=\"edit()\" ng-disabled=\"noProvidersAllowed\" title=\"{{ noProvidersAllowed ? 'There are no providers available.' : 'Add New Search Provider' | translate }}\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button></div><div class=\"sd-page__content\"><ul class=\"pills-list provider-list\"><li ng-repeat=\"provider in providers track by provider._id\" class=\"clearfix\"><div class=\"header\"><h6 id=\"providerType\">{{ providerLabels[provider.search_provider] }}</h6><span class=\"label offProvider\" ng-if=\"provider.is_closed\" translate>Closed</span><div class=\"actions\"><button ng-click=\"edit(provider)\" title=\"{{:: 'Edit Search Provider' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(provider)\" ng-show=\"!provider.last_item_update\" title=\"{{:: 'Remove Search Provider' | translate }}\"><i class=\"icon-trash\"></i></button></div></div></li></ul></div></div><div sd-modal data-model=\"provider\" data-close=\"cancel()\" class=\"subscriber-modal\"><div class=\"modal__header\"><a href=\"\" class=\"modal__close pull-right\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" ng-show=\"provider._id\"><span translate>Edit Search Provider</span> \"{{ origProvider.search_provider }}\"</h3><h3 class=\"modal__heading\" translate ng-hide=\"provider._id\">Add New Search Provider</h3></div><div class=\"modal__body\"><form name=\"editForm\"><fieldset><div sd-form-switch-inverted id=\"provider-status\" label=\"{{ :: 'Status' | translate }}\" title=\"{{ provider.is_closed ? 'Open' : 'Close'  | translate }}\" model=\"provider.is_closed\">></div><div sd-form-checkbox label=\"{{ :: 'Is Default' | translate }}\" title=\"{{ provider.is_default ? 'Default' : ''  | translate }}\" model=\"provider.is_default\"></div><div sd-form-checkbox label=\"{{ :: 'Open advanced search panel by default' | translate }}\" model=\"provider.advanced_search\"></div><div sd-form-select id=\"provider-type\" label=\"{{ :: 'Provider Type' | translate }}\" model=\"provider.search_provider\" options=\"providerTypesOptions\" option-label=\"label\" option-value=\"value\" required></div><div sd-form-input ng-if=\"!provider.search_provider.startsWith('scanpix')\" id=\"provider-name\" label=\"{{ :: 'Name' | translate }}\" model=\"provider.name\" required></div><div sd-form-input ng-if=\"!provider.search_provider.startsWith('scanpix')\" id=\"provider-source\" label=\"{{ :: 'Source' | translate }}\" placeholder=\"{{ :: 'source of the search provider' | translate }}\" model=\"provider.source\" required></div><div ng-if=\"provider.search_provider.startsWith('scanpix')\"><span ng-init=\"provider.source=provider.search_provider\"></span></div><div sd-form-input id=\"provider-username\" label=\"{{ :: 'Username' | translate }}\" placeholder=\"{{ :: 'search provider username' | translate }}\" model=\"provider.config.username\"></div><div sd-form-input type=\"password\" id=\"provider-password\" label=\"{{ :: 'Password' | translate }}\" placeholder=\"{{ :: 'search provider password' | translate }}\" model=\"provider.config.password\"></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"editForm.$invalid\" translate>Save</button></div></div>");
        $templateCache.put('scripts/apps/search-providers/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Search Providers</h2></div><div class=\"sd-page__flex-helper\" sd-search-provider-config></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/search/views/edit-time-interval.html', "<div class=\"form-label\" translate>Schedule</div><div class=\"form__row\"><sd-check type=\"radio\" ng-model=\"wrapper.everyDay\" ng-value=\"true\" label-position=\"inside\">{{'Every day' | translate}}</sd-check><sd-check type=\"radio\" ng-model=\"wrapper.everyDay\" ng-value=\"false\" label-position=\"inside\">{{'Select days' | translate}}</sd-check></div><div ng-if=\"wrapper.everyDay !== 'true'\" sd-weekday-picker data-short-weekday-labels=\"true\" data-model=\"wrapper.customWeekdays\" class=\"form__row\"></div><div class=\"form-label\" translate>Time</div><div class=\"form__row\"><sd-check type=\"radio\" ng-model=\"wrapper.everyHour\" ng-value=\"true\" label-position=\"inside\">{{'Every hour' | translate}}</sd-check><sd-check type=\"radio\" ng-model=\"wrapper.everyHour\" ng-value=\"false\" label-position=\"inside\">{{'Select hours' | translate}}</sd-check></div><div ng-if=\"wrapper.everyHour !== 'true'\" class=\"form__row\"><div sd-multi-select data-item=\"wrapper.customHours\" data-list=\"wrapper.hoursList\" data-change=\"setDirty(true)\"></div></div>");
        $templateCache.put('scripts/apps/search/views/item-globalsearch.html', "<div class=\"item-globalsearch\" ng-if=\"flags.enabled\"><div class=\"separator-handler\"></div><div class=\"popup advanced-globalsearch\"><div class=\"content dropdown\"><div class=\"advanced\" ng-click=\"$event.stopPropagation()\"><button class=\"close\" tabindex=\"4\" ng-click=\"close();\"><i class=\"icon-close-small\"></i></button><div class=\"content\"><form><fieldset><div class=\"field\"><label translate>Unique Name/ID/GUID</label><div class=\"control\" title=\"Prefix Unique Name with #\"><input type=\"text\" ng-keyup=\"openOnEnter($event)\" ng-model=\"meta.unique_name\" tabindex=\"1\" sd-autofocus ng-if=\"flags.enabled\"></div></div></fieldset></form><div class=\"actions\"><button class=\"btn btn--primary pull-right\" ng-click=\"search()\" tabindex=\"2\" id=\"searchItemByNameBtn\" translate>Go</button> <button class=\"btn pull-right\" ng-click=\"close();\" tabindex=\"3\" translate>Cancel</button></div></div></div></div></div></div>");
        $templateCache.put('scripts/apps/search/views/item-preview.html', "<div id=\"item-preview\" class=\"preview-pane content-item-preview\" ng-if=\"item\" ng-class=\"{shift: toggleLeft}\"><button class=\"shift-preview__toggle\" ng-class=\"{shift: toggleLeft}\" ng-click=\"shiftPreview()\"><i class=\"icon-chevron-left-thin\"></i></button><header><ul class=\"nav-tabs\" ng-class=\"{'nav-tabs--small': (showRelatedTab && showHistoryTab) || (showRelatedTab && isMediaUsed) || (showHistoryTab && isMediaUsed)}\"><li class=\"nav-tabs__tab\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'content'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'content'\"><span translate>Content</span></button></li><li class=\"nav-tabs__tab\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'metadata'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'metadata'\"><span translate>Metadata</span></button></li><li class=\"nav-tabs__tab\" ng-show=\"showRelatedTab\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'related'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'related'\"><span translate>Duplicates</span></button></li><li class=\"nav-tabs__tab\" ng-show=\"showHistoryTab\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'history'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'history'\" translate>Item history</button></li><li class=\"nav-tabs__tab\" ng-show=\"isMediaUsed\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'used'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'used'\" translate>Used</button></li><li class=\"nav-tabs__tab\" ng-show=\"isAssigned\" ng-class=\"{'nav-tabs__tab--active': vm.current_tab === 'assignment'}\"><button class=\"nav-tabs__link\" ng-click=\"vm.current_tab = 'assignment'\" translate>Assignment</button></li></ul><button ng-click=\"close()\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div class=\"content\"><div ng-if=\"vm.current_tab === 'content'\" sd-media-preview data-item=\"item\"></div><div ng-if=\"vm.current_tab === 'metadata'\" sd-media-metadata data-item=\"item\"></div><div ng-if=\"vm.current_tab === 'related' && showRelatedTab\" sd-media-related data-item=\"item\" data-related-items=\"relatedItems\"></div><div ng-if=\"vm.current_tab === 'history' && showHistoryTab\" sd-versioning-history data-item=\"item\"></div><div ng-if=\"vm.current_tab === 'used' && isMediaUsed\" sd-media-used data-item=\"item\"></div><div ng-if=\"vm.current_tab === 'assignment' && isAssigned\" sd-assignment-preview data-item=\"item\"></div></div></div>");
        $templateCache.put('scripts/apps/search/views/item-repo.html', "<fieldset ng-if=\"context\"><div class=\"superdeskRepos flex-grid flex-grid--boxed-small flex-grid--wrap-items flex-grid--small-2\" ng-show=\"repo.search === 'local'\"><button type=\"button\" id=\"ingest-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('ingest')\" ng-class=\"{'toggle-button--active': repo.ingest}\">{{:: 'Ingest' | translate}}</button> <button type=\"button\" id=\"archive-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('archive')\" ng-class=\"{'toggle-button--active': repo.archive}\">{{:: 'Production' | translate}}</button> <button type=\"button\" id=\"published-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('published')\" ng-class=\"{'toggle-button--active': repo.published}\">{{:: 'Published' | translate}}</button> <button type=\"button\" id=\"archived-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('archived')\" ng-class=\"{'toggle-button--active': repo.archived}\">{{:: 'Archived' | translate}}</button></div></fieldset>");
        $templateCache.put('scripts/apps/search/views/item-searchbar.html', "<div class=\"item-searchbar\" ng-class=\"{focused: focused}\" ng-click=\"$event.stopPropagation();\"><label for=\"search-input\" class=\"button search-icon\"></label><input id=\"search-input\" type=\"text\" placeholder=\"{{ 'Search'|translate }}\" ng-keyup=\"searchOnEnter($event)\" ng-model=\"query\" tabindex=\"1\" ng-focus=\"focused = true\"> <button class=\"search-cancel\" ng-click=\"cancel();\" ng-if=\"query\"><i class=\"icon-remove-sign\"></i></button> <button id=\"search-button\" ng-click=\"search();\" class=\"button trigger\" ng-if=\"focused\" tabindex=\"2\"><i class=\"svg-icon-right\"></i></button></div>");
        $templateCache.put('scripts/apps/search/views/item-sortbar.html', "<div class=\"sortbar\" ng-show=\"canSort()\"><span ng-show=\"total\" translate>Total:</span> <span ng-show=\"total\" class=\"label-total\">{{total}}</span><div class=\"dropdown dropdown--align-right dropdown--hover\" dropdown><button id=\"order_button\" class=\"dropdown__toggle\" dropdown__toggle>{{ active.label | translate }} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu\" id=\"order_selector\"><li ng-repeat=\"option in sortOptions\" ng-class=\"{active: option === selected}\"><a href=\"\" ng-click=\"sort(option.field)\">{{ option.label | translate }}</a></li></ul></div><button ng-click=\"toggleDir()\" class=\"icn-btn direction\" title=\"{{active.dir}}\"><i class=\"icon-ascending\" ng-if=\"active.dir === 'asc'\"></i> <i class=\"icon-descending\" ng-if=\"active.dir === 'desc'\"></i></button></div>");
        $templateCache.put('scripts/apps/search/views/menu.html', "<div class=\"dropdown dropdown--dropright dropdown--hover highlights-dropdown\" dropdown ng-controller=\"SearchMenuController as search\"><a href=\"#/search\" class=\"dropdown__toggle sd-sidebar-menu__btn\" title=\"{{ :: 'Search' | translate }}\" sd-hotkey=\"ctrl+alt+f\" sd-hotkey-options=\"{global: true}\" ng-click=\"hideMonitoring(currentRoute.href === '/search', $event)\"><i class=\"sd-sidebar-menu__main-icon big-icon--global-search\"></i> <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i></a><ul ng-if=\"search.providers.length > 1\" class=\"dropdown__menu pull-left\"><li ng-repeat=\"provider in search.providers track by provider._id\"><button ng-click=\"search.loadSearchShortcut(provider)\">{{ :: search.providerLabel(provider) }}</button></li></ul></div>");
        $templateCache.put('scripts/apps/search/views/multi-action-bar.html', "<div class=\"multi-action-bar\" ng-if=\"multi.count && display\"><button class=\"toggle\" ng-click=\"toggleDisplay()\"><i class=\"icon-chevron-up-thin\"></i></button> <button class=\"btn\" ng-click=\"multi.reset()\">cancel</button> <span id=\"multi-select-count\" translate translate-n=\"multi.count\" translate-plural=\"{{ multi.count}} Items selected\">{{ multi.count}} Item selected</span><div class=\"pull-right\" ng-if=\"action.canPackageItems() && (!elementState || elementState === 'comfort')\"><button class=\"navbtn strict\" ng-click=\"action.createPackage()\" title=\"{{ :: 'Create Package' | translate }}\"><i class=\"big-icon--create-package\"></i></button> <button class=\"navbtn strict\" ng-if=\"isOpenItemType('composite')\" ng-click=\"action.addToPackage()\" title=\"{{ :: 'Add to Current Package' | translate }}\"><i class=\"big-icon--add-to-package\"></i></button><div class=\"dropdown dropdown--align-right strict highlights-dropdown pull-right\" ng-if=\"action.canHighlightItems()\" title=\"{{ :: 'Mark item' | translate }}\" dropdown><button class=\"dropdown__toggle navbtn\" dropdown__toggle><i class=\"big-icon--marked-star\"></i></button><ul class=\"dropdown__menu pull-right\" sd-multi-mark-highlights-dropdown></ul></div></div><div class=\"pull-right\" ng-if=\"type === 'archive' && (!elementState || elementState === 'comfort')\"><button class=\"navbtn strict\" ng-if=\"action.canEditMetadata() && activity['edit.item']\" ng-click=\"action.multiImageEdit()\" title=\"{{ :: 'Edit metadata' | translate }}\"><i class=\"big-icon--annotation\"></i></button> <button class=\"navbtn strict\" ng-if=\"activity['export']\" ng-click=\"openExport()\" title=\"{{ :: 'Export' | translate }}\"><i class=\"icon-download\"></i><div sd-export ng-if=\"export\"></div></button> <button class=\"navbtn strict\" ng-if=\"activity['edit.item']\" ng-click=\"action.multiedit()\" title=\"{{ :: 'Multiedit' | translate }}\"><i class=\"big-icon--multiedit\"></i></button> <button class=\"navbtn strict\" ng-click=\"action.spikeItems()\" title=\"{{ :: 'Spike' | translate }}\" ng-if=\"!spike && !publish && activity['spike']\"><i class=\"big-icon--spike\"></i></button> <button class=\"navbtn strict\" ng-click=\"action.unspikeItems()\" title=\"{{ :: 'Unspike' | translate }}\" ng-if=\"state === 'spiked'\"><i class=\"big-icon--unspike\"></i></button> <button id=\"send-to-btn\" class=\"navbtn strict\" title=\"{{ :: 'Send to' | translate }}\" ng-if=\"activity['edit.item']\" ng-click=\"action.sendAs()\"><i class=\"big-icon--send-to\"></i></button> <button id=\"publish-btn\" class=\"navbtn strict\" title=\"{{ :: 'Publish' | translate }}\" ng-if=\"activity['edit.item']\" ng-click=\"action.publish()\"><i class=\"svg-icon-ok\"></i></button></div><div class=\"pull-right\" ng-if=\"type === 'ingest' && (!elementState || elementState === 'comfort')\"><button id=\"fetch-all-btn\" class=\"navbtn strict\" title=\"{{ :: 'Fetch' | translate }}\" ng-click=\"action.send()\"><i class=\"big-icon--fetch\"></i></button> <button id=\"fetch-all-as-btn\" class=\"navbtn strict\" title=\"{{ :: 'Fetch to' | translate }}\" ng-click=\"action.sendAs()\"><i class=\"big-icon--fetch-as\"></i></button> <button id=\"remove-all-as-btn\" class=\"navbtn strict\" class=\"navbtn strict\" title=\"{{ :: 'Remove' | translate }}\" ng-click=\"action.removeIngestItems()\" ng-if=\"action.canRemoveIngestItems()\"><i class=\"big-icon--spike\"></i></button></div><div class=\"button-stack right-stack\" ng-if=\"elementState || elementState === 'compact'\"><div class=\"dropdown dropdown--align-right dropdown--multi-action-bar\" dropdown><button class=\"navbtn dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu\"><li ng-if=\"action.canPackageItems()\"><button ng-click=\"action.createPackage()\"><i class=\"icon-package-create\"></i><span>{{ :: 'Create Package' | translate }}</span></button> <button ng-if=\"isOpenItemType('composite')\" ng-click=\"action.addToPackage()\"><i class=\"icon-package-plus\"></i><span>{{ :: 'Add to Current Package' | translate }}</span></button><div class=\"dropdown dropdown--align-right highlights-dropdown\" ng-if=\"action.canHighlightItems()\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-star\"></i><span>{{ :: 'Mark item' | translate }}</span></button><ul class=\"dropdown__menu\" sd-multi-mark-highlights-dropdown></ul></div></li><li ng-if=\"type === 'archive'\"><button ng-if=\"action.canEditMetadata() && activity['edit.item']\" ng-click=\"action.multiImageEdit()\"><i class=\"icon-edit-line\"></i><span>{{ :: 'Edit metadata' | translate }}</span></button> <button ng-if=\"activity['export']\" ng-click=\"openExport()\"><i class=\"icon-download\"></i><span>{{ :: 'Export' | translate }}</span><div sd-export ng-if=\"export\"></div></button> <button ng-if=\"activity['edit.item']\" ng-click=\"action.multiedit()\"><i class=\"icon-multiedit\"></i><span>{{ :: 'Multiedit' | translate }}</span></button> <button ng-click=\"action.spikeItems()\" ng-if=\"!spike && !publish && activity['spike']\"><i class=\"icon-trash\"></i><span>{{ :: 'Spike' | translate }}</span></button> <button ng-click=\"action.unspikeItems()\" ng-if=\"state === 'spiked'\"><i class=\"icon-unspike\"></i><span>{{ :: 'Unspike' | translate }}</span></button> <button id=\"send-to-btn\" ng-if=\"activity['edit.item']\" ng-click=\"action.sendAs()\"><i class=\"icon-expand-thin\"></i><span>{{ :: 'Send to' | translate }}</span></button> <button id=\"publish-btn\" ng-if=\"activity['edit.item']\" ng-click=\"action.publish()\"><i class=\"icon-ok\"></i><span>{{ :: 'Publish' | translate }}</span></button></li><li ng-if=\"type === 'ingest'\"><button id=\"fetch-all-btn\" ng-click=\"action.send()\"><i class=\"icon-archive\"></i><span>{{ :: 'Fetch' | translate }}</span></button> <button id=\"fetch-all-as-btn\" ng-click=\"action.sendAs()\"><i class=\"icon-fetch-as\"></i><span>{{ :: 'Fetch to' | translate }}</span></button> <button id=\"remove-all-as-btn\" ng-click=\"action.removeIngestItems()\" ng-if=\"action.canRemoveIngestItems()\"><i class=\"icon-trash\"></i><span>{{ :: 'Remove' | translate }}</span></button></li></ul></div></div></div>");
        $templateCache.put('scripts/apps/search/views/multi-image-edit-modal.html', "<sd-multi-image-edit data-images-original=\"imagesOriginal\" data-is-upload=\"false\" data-validator=\"validator\" cancel-handler=\"cancelHandler\" success-handler=\"successHandler\" save-handler=\"saveHandler\" get-thumbnail-html=\"getThumbnailHtml\" get-icon-for-item-type=\"getIconForItemType\"></sd-multi-image-edit>");
        $templateCache.put('scripts/apps/search/views/multi-image-edit.html', "<div ng-if=\"isUpload !== true\" class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading modal__heading--grow\" translate>Edit metadata</h3><div class=\"modal__header-buttons modal__header-buttons--right\"><button class=\"btn btn--ui-dark btn--hollow\" ng-click=\"close()\" translate>Close</button> <button class=\"btn btn--primary btn--hollow\" ng-click=\"save()\" ng-disabled=\"!isDirty()\" translate>Save</button> <button class=\"btn btn--primary btn--hollow\" ng-click=\"save(true)\" ng-disabled=\"!isDirty()\" translate>Save & Close</button></div></div><div ng-if=\"isUpload === true\" class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading modal__heading--grow\" translate>Upload media</h3><div class=\"modal__header-buttons modal__header-buttons--right\"><button class=\"btn btn--ui-dark btn--hollow\" ng-click=\"close()\" ng-disabled=\"uploadInProgress\" translate>Cancel</button><div ng-transclude=\"select-desk\"></div><button class=\"btn btn--primary btn--hollow\" ng-click=\"save(true)\" ng-disabled=\"!images.length\" translate>Upload</button></div></div><div class=\"modal__body modal__body--no-padding\"><div class=\"sd-column-box--2\"><div class=\"sd-column-box__main-column sd-column-box__main-column--photo-preview\"><div class=\"sd-photo-preview sd-photo-preview--grid-only\"><div class=\"sd-photo-preview__thumb-strip\"><div class=\"sd-grid-list dark-ui\"><div class=\"sd-grid-item sd-grid-item--with-click\" ng-click=\"handleItemClick($event, image)\" ng-repeat=\"image in images track by image._id\" ng-class=\"{'sd-grid-item--selected' : image.selected}\" style=\"z-index: 1\"><!--  // required so it's visible on top or drag-and-drop layer --><div class=\"sd-grid-item__thumb\"><div ng-bind-html=\"trustAsHtml(getThumbnailHtml(image))\" style=\"display: flex; align-items: center; justify-content: center\"></div><a ng-if=\"onRemoveItem\" class=\"icn-btn sd-grid-item__remove\" sd-tooltip=\"Remove item\" flow=\"left\"><i class=\"icon-close-small\"></i> </a><span ng-if=\"getProgress && getProgress(image) > 0\" class=\"sd-grid-item__progress-circle\"><sd-circular-progress value=\"getProgress(image)\" class=\"sd-circular-progress--m\"></sd-circular-progress></span></div><div class=\"sd-grid-item__content\"><time sd-absdate datetime=\"image.versioncreated\"></time><p class=\"sd-grid-item__title\">{{image.headline}}</p><p class=\"sd-grid-item--element-grow sd-grid-item__text-light\">{{image.description_text}}</p><div class=\"sd-grid-item__content-block\"><span class=\"sd-grid-item__text-label\" translate>Copyright:</span> <span class=\"sd-grid-item__text-strong\">{{image.copyrightnotice}}</span></div></div><div class=\"sd-grid-item__footer\"><div class=\"sd-grid-item__footer-block sd-grid-item__footer-block--multi-l\"><i class=\"sd-grid-item__type-icn sd-grid-item__footer-block-item\" ng-class=\"getIconForItemType(image)\"></i></div></div></div><div ng-transclude=\"additional-content\"></div></div></div></div></div><div class=\"sd-column-box__slide-in-column sd-column-box__slide-in-column--large sd-column-box__slide-in-column--dark-ui\"><div class=\"sd-column-box__slide-in-column-inner sd-slide-in-panel\"><div class=\"sd-slide-in-panel__header\"><h3 class=\"sd-slide-in-panel__heading\" translate>Metadata</h3></div><div class=\"sd-slide-in-panel__content\"><div class=\"sd-slide-in-panel__content-block sd-slide-in-panel__content-block--first\"><div class=\"sd-alert sd-alert--hollow sd-alert--primary sd-alert--small\" style=\"margin: -1rem 0 3rem\"><span translate>Currently editing: {{getSelectedImages().length}} items</span></div><div sd-media-metadata-editor data-item=\"metadata\" data-validator=\"validator\" data-disabled=\"!getSelectedImages().length\" data-dark=\"true\" data-boxed=\"true\" data-on-change=\"onChange(key)\" data-placeholder=\"placeholder\"></div></div></div><div sd-media-copy-metadata class=\"sd-slide-in-panel__footer\" data-metadata=\"metadata\" data-on-change=\"updateMetadata()\"></div></div></div></div></div>");
        $templateCache.put('scripts/apps/search/views/raw-search.html', "<div class=\"field\"><label class=\"saved-searches__group-title\" for=\"raw-query\">{{:: 'Query Text' | translate}}</label><textarea ng-keypress=\"keyPressed($event)\" id=\"raw-query\" ng-model=\"rawquery\" class=\"raw-search\"></textarea></div>");
        $templateCache.put('scripts/apps/search/views/repo-dropdown.html', "<div id=\"repo-dropdown\" class=\"dropdown\" dropdown ng-controller=\"SearchMenuController as search\"><button class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown__toggle>{{ search.providerLabel(activeProvider) || 'Superdesk' }} <span class=\"dropdown__caret\"></span></button><ul class=\"dropdown__menu\"><li ng-repeat=\"provider in search.providers track by provider._id\" ng-class=\"{active: isActive(provider)}\"><button ng-click=\"toggleProvider(provider._id ? provider : null)\">{{ :: search.providerLabel(provider) }}</button></li></ul></div>");
        $templateCache.put('scripts/apps/search/views/save-search-dialog.html', "<!-- <form name=\"viewsForm\"> --><fieldset><div class=\"field\" ng-hide=\"{{edit.filter.query.raw === undefined}}\"><input id=\"search_query\" type=\"text\" class=\"fullwidth-input line-input\" ng-model=\"edit.filter.query.raw\" placeholder=\"{{:: 'Query' | translate}}\"></div><div class=\"field\"><input id=\"search_name\" type=\"text\" class=\"fullwidth-input line-input\" ng-model=\"edit.name\" placeholder=\"{{:: 'Name' | translate}}\" required></div><div class=\"field\"><textarea id=\"search_description\" class=\"line-input\" sd-auto-height ng-model=\"edit.description\" placeholder=\"{{:: 'Description' | translate}}\"></textarea></div><div class=\"field\" ng-if=\"!wrapper.edit.subscribers.user_subscriptions.length\"><span id=\"search_global\" sd-switch ng-model=\"edit.is_global\"></span><label class=\"label--inline\" translate>Make global</label></div></fieldset><!-- </form> -->");
        $templateCache.put('scripts/apps/search/views/save-search.html', "<div class=\"float-search-btn\" ng-if=\"!editingSearch && sTab !== 'savedSearches' && innerTab==='parameters'\" ng-class=\"{'float-search-btn--shift': searching()}\"><button class=\"btn btn--primary btn--expanded search\" ng-click=\"search()\" translate>Search</button></div><div ng-if=\"searching() || innerTab==='parameters'\"><div class=\"save-search\" ng-if=\"searching() && !editingSearch && sTab !== 'savedSearches'\"><a id=\"clear_filters\" class=\"save-search__link\" ng-click=\"clear()\" translate>Clear filters</a> <button id=\"save_search_init\" class=\"btn btn--primary btn--hollow\" ng-click=\"editItem()\" ng-if=\"!editingSearch\" translate>Save Search</button></div><div class=\"save-search\" ng-if=\"editingSearch\"><button class=\"btn btn--primary btn--expanded btn--hollow search\" ng-click=\"search()\" ng-if=\"innerTab==='parameters'\" translate>Search</button><div class=\"save-search__button-split\"><button id=\"saveas_search_init\" class=\"btn btn\" ng-click=\"saveas()\" translate ng-if=\"editingSearch\">Save As</button> <button id=\"save_search_init\" class=\"btn btn--primary\" ng-click=\"save(edit)\" ng-disabled=\"!isValid(edit)\" ng-if=\"editingSearch\" translate>Save Changes</button> <button id=\"save_search_init\" class=\"btn btn--primary\" ng-click=\"editItem()\" ng-if=\"!editingSearch\" translate>Save Changes</button></div></div></div><div class=\"save-search-panel\" ng-if=\"edit && activateSearchPane\"><div class=\"save-search-panel__title\" translate>Save search</div><div class=\"search-content\"><form name=\"viewsForm\"><div ng-include=\"'scripts/apps/search/views/save-search-dialog.html'\"></div></form></div><div class=\"pull-right\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button id=\"search_save\" class=\"btn btn--primary\" ng-click=\"save(edit)\" ng-disabled=\"!viewsForm.$valid\" translate>Ok</button></div></div>");
        $templateCache.put('scripts/apps/search/views/saved-search-manage-subscribers.html', "<div sd-modal class=\"modal\" data-model=\"wrapper.modalOpen\" on-modal-close=\"onInternalModalClose\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"manageSubscriptions(false)\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\"><span translate>Manage: </span><strong>{{savedSearch.name}}</strong></h3></div><div class=\"modal__body\"><!-- if start --><div ng-if=\"wrapper.subscriptionInCreateOrEditMode == null\"><div class=\"space-between\" style=\"padding-bottom: 2rem; color: #898989\"><div><strong>{{getSubscriptionCount()}}</strong> <span translate>subscriptions</span></div><div><button id=\"saved-search-subscriptions--add-new\" class=\"btn btn--hollow btn--primary\"><i class=\"icon-plus-sign\"></i>Add new</button><sd-positioner placement=\"'bottom-end'\" class-name=\"'dropdown2'\" trigger-selector=\"'#saved-search-subscriptions--add-new'\" z-index=\"1050\"><div style=\"width: 439px\"><div class=\"flat-searchbar extended\"><div class=\"search-handler\" style=\"height: auto!important; padding: 4px 8px; padding-right: 0; border: 0\"><label for=\"saved-search-add-subscriber\" class=\"trigger-icon\"><i class=\"icon-search\"></i></label><input id=\"saved-search-add-subscriber\" type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"wrapper.newSubscriptionFilterText\" style=\"width: 100%\"></div></div><div ng-if=\"wrapper.newSubscriptionFilterText.length > 0\" style=\"border-top: 1px solid #F5F5F5; margin-bottom: 6px\"></div><div ng-if=\"wrapper.newSubscriptionFilterText.length > 0\" class=\"search-result\"><ul class=\"users-list-embed\"><li ng-click=\"subscribeDesk(desk)\" ng-repeat=\"desk in wrapper.desks.desks._items | filter: desksFilter\" style=\"padding-left: 6px;padding-right: 6px; margin-right: 0\"><figure class=\"avatar organisation small\"></figure><div class=\"name\">{{desk.name}}</div></li></ul></div><div ng-if=\"wrapper.newSubscriptionFilterText.length > 0\" class=\"search-result\"><ul class=\"users-list-embed\"><li ng-click=\"subscribeUser(user)\" ng-repeat=\"user in wrapper.users | filter: usersFilter\" style=\"padding-left: 6px;padding-right: 6px; margin-right: 0\"><figure class=\"avatar small\"><img sd-user-avatar data-user=\"user\"></figure><div class=\"name\">{{user.first_name}} {{user.last_name}}</div></li></ul></div><!-- getUserDisplay --><div ng-if=\"wrapper.newSubscriptionFilterText.length > 0\" style=\"padding-bottom: 4px\"></div></div></sd-positioner></div></div><div ng-repeat=\"deskSubscription in savedSearch.subscribers.desk_subscriptions track by deskSubscription.desk\" class=\"sd-list-item sd-shadow--z1\" ng-class=\"{&quot;sd-list-item--activated&quot;:itemActive2}\" style=\"margin-bottom: 6px\"><div class=\"sd-list-item__column\"><figure class=\"avatar organisation\" style=\"margin:0\"></figure></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><strong class=\"sd-overflow-ellipsis\">{{wrapper.desks.deskLookup[deskSubscription.desk].name}}</strong></div><div class=\"sd-list-item__row\"><span translate>Desk subscription</span></div></div><div class=\"sd-list-item__column\"><div class=\"actions\"><button ng-click=\"editDeskSubscription(wrapper.desks.deskLookup[deskSubscription.desk])\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"unsubscribeDesk(wrapper.desks.deskLookup[deskSubscription.desk])\"><i class=\"icon-trash\"></i></button></div></div></div><div ng-repeat=\"user in wrapper.userSubscribers track by user._id\" class=\"sd-list-item sd-shadow--z1\" ng-class=\"{&quot;sd-list-item--activated&quot;:itemActive2}\" style=\"margin-bottom: 6px\"><div class=\"sd-list-item__column\"><figure class=\"avatar\" style=\"margin:0\"><img sd-user-avatar data-user=\"user\"></figure></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><strong class=\"sd-overflow-ellipsis\">{{user.first_name}} {{user.last_name}}</strong></div><div class=\"sd-list-item__row\">{{user.username}}</div></div><div class=\"sd-list-item__column\"><div class=\"actions\"><button ng-click=\"editUserSubscription(user)\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"unsubscribeUser(user)\"><i class=\"icon-trash\"></i></button></div></div></div></div><!-- else --><div ng-if=\"wrapper.subscriptionInCreateOrEditMode != null\"><div style=\"margin: -20px -20px 10px -20px\"><div class=\"space-between\" style=\"background: #fff; padding: 9px 20px\"><button class=\"backlink\" ng-click=\"backToList()\" translate>Back</button> <button class=\"btn btn--primary\" ng-click=\"saveChanges()\" ng-disabled=\"!savingEnabled()\" translate>Save changes</button></div><div ng-if=\"editingUserSubscription()\" class=\"sd-list-item\" ng-class=\"{&quot;sd-list-item--activated&quot;:itemActive2}\" style=\"margin-bottom: 6px; padding: 0 10px; background-color: #E6EDEF!important; cursor: default\"><div class=\"sd-list-item__column\"><figure class=\"avatar\" style=\"margin:0\"><img sd-user-avatar data-user=\"wrapper.userLookup[wrapper.subscriptionInCreateOrEditMode.user]\"></figure></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><strong class=\"sd-overflow-ellipsis\">{{wrapper.userLookup[wrapper.subscriptionInCreateOrEditMode.user].first_name}} {{wrapper.userLookup[wrapper.subscriptionInCreateOrEditMode.user].last_name}}</strong></div><div class=\"sd-list-item__row\">{{wrapper.userLookup[wrapper.subscriptionInCreateOrEditMode.user].username}}</div></div></div><div ng-if=\"editingDeskSubscription()\" class=\"sd-list-item\" ng-class=\"{&quot;sd-list-item--activated&quot;:itemActive2}\" style=\"margin-bottom: 6px; padding: 0 10px; background-color: #E6EDEF!important; cursor: default\"><div class=\"sd-list-item__column\"><figure class=\"avatar organisation\" style=\"margin:0\"></figure></div><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><strong class=\"sd-overflow-ellipsis\">{{wrapper.desks.deskLookup[wrapper.subscriptionInCreateOrEditMode.desk].name}}</strong></div><div class=\"sd-list-item__row\"><span translate>Desk subscription</span></div></div></div></div><div sd-edit-time-interval data-initial-value=\"wrapper.subscriptionInCreateOrEditMode.scheduling\" on-change=\"handleIntervalChange\"></div></div><!-- if/else end--></div></div>");
        $templateCache.put('scripts/apps/search/views/saved-search-subscribe.html', "<div sd-modal class=\"modal--large\" ng-if=\"savedSearch != null\" data-model=\"true\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"closeModal()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\"><span ng-if=\"isAlreadySubscribed()\" translate>Manage subscription</span> <span ng-if=\"!isAlreadySubscribed()\" translate>New subscription</span></h3></div><div class=\"modal__body\"><div class=\"sd-alert sd-alert--hollow sd-alert--primary\"><p><span translate>You have chosen to subscribe to</span> <strong>{{savedSearch.name}}</strong>. <span translate>Please define the frequency and time of your email notifications below.</span></p></div><div sd-edit-time-interval data-initial-value=\"ownSubscription == null ? '' : ownSubscription.scheduling\" on-change=\"handleIntervalChange\"></div><p ng-if=\"ownSubscription != null\" style=\"margin: 0\"><span translate>Last report sent on: </span><span ng-if=\"ownSubscription.last_report != null\" sd-absdate datetime=\"ownSubscription.last_report\"></span> <span ng-if=\"ownSubscription.last_report == null\" translate>never</span></p></div><div class=\"modal__footer\"><button ng-if=\"isAlreadySubscribed()\" class=\"btn btn--hollow pull-left\" ng-click=\"unsubscribeUser()\" translate>Unsubscribe</button> <button class=\"btn\" ng-click=\"closeModal()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"saveOrUpdate()\" ng-disabled=\"savingEnabled() !== true\"><span ng-if=\"isAlreadySubscribed()\" translate>Update subscription</span> <span ng-if=\"!isAlreadySubscribed()\" translate>Subscribe</span></button></div></div>");
        $templateCache.put('scripts/apps/search/views/saved-searches.html', "<div class=\"search-filters\"><input id=\"search_saved_searches\" ng-model=\"searchText\" ng-keyup=\"filter()\" type=\"text\" placeholder=\"{{:: 'Search saved searches' | translate}}\"></div><div class=\"list saved-searches\"><div class=\"saved-searches__group-title\" translate>My Saved Searches</div><ul><li ng-repeat=\"search in userSavedSearches | orderBy:'name' \" ng-click=\"select(search)\" class=\"saved-search-item\" ng-class=\"{active: search == selected}\"><div class=\"search-item\"><div class=\"search-name\">{{:: search.name }} <i ng-if=\"search.is_global\" translate>[Global]</i></div><div class=\"search-description\">{{:: search.description }}</div></div><div class=\"search-button\"><button class=\"delete\" ng-click=\"edit(search)\" title=\"{{:: 'Edit search' | translate }}\"><i class=\"icon-pencil\"></i></button> <button class=\"delete\" ng-click=\"remove(search); $event.stopPropagation();\" title=\"{{:: 'Delete search' | translate }}\"><i class=\"icon-trash\"></i></button></div><div ng-if=\"userHasPrivileges({saved_searches_subscriptions: 1})\" class=\"saved-search-subscriptions\"><a ng-if=\"!isUserSubscribedToSavedSearch(search)\" class=\"saved-search-subscriptions--action\" ng-click=\"editSubscription($event, search)\" translate>Subscribe</a> <a ng-if=\"isUserSubscribedToSavedSearch(search)\" class=\"saved-search-subscriptions--action\" ng-click=\"editSubscription($event, search)\" translate>Manage subscription</a> <span ng-if=\"isUserSubscribedToSavedSearch(search)\" class=\"label label--success\">Subscribed</span></div></li></ul><div class=\"saved-searches__group-title\" translate>Global Saved Searches</div><ul><li ng-repeat=\"search in globalSavedSearches | orderBy:'name' \" ng-click=\"select(search)\" class=\"saved-search-item\" ng-class=\"{active: search == selected}\"><div class=\"search-item\"><div class=\"search-name\">{{:: search.name }} <i>by {{:: userLookup[search.user].display_name }}</i></div><div class=\"search-description\">{{:: search.description }}</div></div><div class=\"search-button\"><button class=\"delete\" ng-click=\"edit(search)\" title=\"{{:: 'Edit search' | translate }}\" ng-if=\"privileges.global_saved_searches\"><i class=\"icon-pencil\"></i></button> <button class=\"delete\" ng-click=\"remove(search); $event.stopPropagation();\" title=\"{{:: 'Delete search' | translate }}\" ng-if=\"privileges.global_saved_searches\"><i class=\"icon-trash\"></i></button></div><div ng-if=\"userHasPrivileges({saved_searches_subscriptions: 1})\" class=\"saved-search-subscriptions\"><a ng-if=\"!isUserSubscribedToSavedSearch(search)\" class=\"saved-search-subscriptions--action\" ng-click=\"editSubscription($event, search)\" translate>Subscribe</a> <a ng-if=\"isUserSubscribedToSavedSearch(search)\" class=\"saved-search-subscriptions--action\" ng-click=\"editSubscription($event, search)\" translate>Manage subscription</a> <span ng-if=\"isUserSubscribedToSavedSearch(search)\" class=\"label label--success\">Subscribed</span></div></li></ul></div><div ng-if=\"userHasPrivileges({saved_searches_subscriptions: 1})\" sd-saved-search-edit-own-subscription cancel-editing-subscription=\"cancelEditingSubscription\" data-saved-search=\"selectedForEditingSubscription\"></div>");
        $templateCache.put('scripts/apps/search/views/search-filters.html', "<div class=\"filter-content\" ng-class=\"{pull: showSaveSearch}\" style=\"width:100%\"><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Content types' | translate }}\" ng-hide=\"isEmpty('type')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.type\" ng-click=\"toggleFilter('type', key)\" ng-class=\"{checked: hasFilter('type',key)}\"><span class=\"filter-box__hover-box\"><i class=\"filetype-icon-{{key}}\"></i> <span id=\"filetype-icon-{{key}}\" class=\"sd-checkbox\" ng-checked=\"hasFilter('type',key)\"></span> </span><span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('type', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{ :: 'Languages' | translate }}\" ng-hide=\"isEmpty('language')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(code, count) in aggregations.language\" ng-click=\"toggleFilter('language', code)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('language', code)\"></span> <span class=\"filter-box__name\">{{ :: languageLabel[code] || code }} <i>{{ count }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('language', code, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Desks' | translate }}\" ng-hide=\"isEmpty('desk')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.desk\" ng-click=\"toggleFilter('desk', value.id)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('desk', value.id)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value.count }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('desk', value.id, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Sources' | translate }}\" ng-hide=\"isEmpty('source')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.source\" ng-click=\"toggleFilter('source', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('source',key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('source', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Credits' | translate }}\" ng-hide=\"isEmpty('credit')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.credit\" ng-click=\"toggleFilter('credit', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('credit', key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value.count }}</i></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Services' | translate }}\" ng-hide=\"isEmpty('category')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.category\" ng-click=\"toggleFilter('category', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('category',key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('category', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Genres' | translate }}\" ng-hide=\"isEmpty('genre')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.genre\" ng-click=\"toggleFilter('genre', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('genre',key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('genre', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Urgency' | translate }}\" ng-hide=\"isEmpty('urgency')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.urgency\" ng-click=\"toggleFilter('urgency', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('urgency',key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('urgency', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Priority' | translate }}\" ng-hide=\"isEmpty('priority')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.priority\" ng-click=\"toggleFilter('priority', key)\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('priority',key)\"></span> <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('priority', key, $event)\"></span></li></ul></div><div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Flags' | translate }}\" ng-hide=\"isEmpty('legal') && isEmpty('sms')\" data-open=\"true\"><ul class=\"filter-box\"><li class=\"filter-box__item\" ng-click=\"toggleFilter('legal', 'true')\" ng-hide=\"isEmpty('legal')\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('legal', 'true')\"></span> <span class=\"filter-box__name\">{{:: 'Legal' | translate}} <i>{{ aggregations.legal.count }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('legal', 'true', $event)\"></span></li><li class=\"filter-box__item\" ng-click=\"toggleFilter('sms', 'true')\" ng-hide=\"isEmpty('sms')\"><span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('sms', 'true')\"></span> <span class=\"filter-box__name\">{{:: 'Sms' | translate}} <i>{{ aggregations.sms.count }}</i></span> <span class=\"icon-ban-circle filter-box__negate-filter\" title=\"{{ :: 'Negate' | translate }}\" ng-if=\"repo.search === 'local'\" ng-click=\"excludeFacet('sms', 'true', $event)\"></span></li></ul></div><!-- ID only needed for E2E test --><div ng-repeat=\"dateFilter in dateFilters track by dateFilter.fieldname\" sd-toggle-box data-style=\"circle\" data-title=\"{{:: dateFilter.labelBlock }}\" data-open=\"false\" id=\"filter-{{dateFilter.fieldname}}\" ng-if=\"dateFilter.isEnabled(search_config)\"><form class=\"date-filter\"><div class=\"predefined-dates\"><button ng-repeat=\"predefinedFilter in dateFilter.predefinedFilters track by predefinedFilter.key\" ng-click=\"togglePredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key)\" class=\"toggle-button\" title=\"{{predefinedFilter.label}}\" ng-class=\"{'toggle-button--active': hasPredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key), 'toggle-button--active': hasPredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key)}\" id=\"filter-{{dateFilter.fieldname}}-{{predefinedFilter.key}}\">{{predefinedFilter.label}}</button></div><fieldset ng-show=\"(dateFilter.labelFrom != null && dateFilter.labelTo != null) && (repo.search === 'local' || providerType.startsWith('scanpix') || repo.search === 'content-api' || providerType === 'aapmm')\"><div class=\"form__row form__row--no-padding form__row--flex\"><div class=\"form__row-item\" sd-date-param data-location=\"{{dateFilter.fieldname}}from\"><label class=\"form-label\">{{dateFilter.labelFrom}}</label><div sd-datepicker on-change=\"clearPredefinedFilters(dateFilter.fieldname)\" ng-model=\"date\"></div></div><div class=\"form__row-item\" sd-date-param data-location=\"{{dateFilter.fieldname}}to\"><label class=\"form-label\">{{dateFilter.labelTo}}</label><div sd-datepicker on-change=\"clearPredefinedFilters(dateFilter.fieldname)\" ng-model=\"date\"></div></div></div></fieldset></form></div></div>");
        $templateCache.put('scripts/apps/search/views/search-panel.html', "<div><div class=\"header\"><div class=\"backlink-toolbar\" ng-show=\"editingSearch && !activateSearchPane\"><button ng-click=\"cancel()\" class=\"backlink\"><span translate>Back / Cancel</span></button></div><ul ng-show=\"!editingSearch || activateSearchPane\"><li ng-class=\"{active: sTab === 'advancedSearch'}\" ng-click=\"changeTab('advancedSearch')\" translate>Advanced Search</li><li id=\"saved_searches_tab\" ng-show=\"privileges.saved_searches == 1\" ng-class=\"{active: sTab === 'savedSearches'}\" ng-click=\"changeTab('savedSearches')\" translate>Saved</li><li id=\"raw_search_tab\" ng-if=\"isAdmin()\" ng-class=\"{active: sTab === 'rawSearch'}\" ng-click=\"changeTab('rawSearch')\" translate>Raw</li></ul><div class=\"doopen\" ng-click=\"closeFacets()\"><i class=\"icon-close-small\"></i></div></div><div class=\"content\" ng-if=\"sTab==='advancedSearch'\" ng-class=\"{pull: showSaveSearch || innerTab==='parameters', 'pull-heigher': innerTab==='parameters' && showSaveSearch}\"><div id=\"edit-search-name\" class=\"edit-search\" ng-show=\"editingSearch && !activateSearchPane\"><div ng-if=\"userHasPrivileges({saved_searches_subscriptions_admin: 1})\" class=\"saved-search-subscriptions--manage-toolbar\"><span><strong>{{wrapper.edit.subscribers == null ? '0' : wrapper.edit.subscribers.user_subscriptions.length}} </strong><span translate>subscriptions</span> </span><button class=\"btn btn--small btn--hollow\" ng-click=\"manageSubscriptions(true)\" translate>Manage</button></div><div ng-if=\"isManagingSubscriptions\" manage-subscriptions=\"manageSubscriptions\" sd-saved-search-manage-subscribers data-saved-search=\"wrapper.edit\"></div><form name=\"viewsForm\"><div ng-include=\"'scripts/apps/search/views/save-search-dialog.html'\"></div></form></div><div sd-item-repo data-repo=\"repo\" data-toggle-repo=\"toggleRepo\" data-context=\"context\"></div><div class=\"tab-box\"><button id=\"parameters-tab\" type=\"button\" class=\"tab-box__item\" ng-class=\"{'tab-box__item--active': innerTab==='parameters'}\" ng-click=\"display('parameters')\" translate>Parameters</button> <button id=\"filters-tab\" type=\"button\" class=\"tab-box__item\" ng-class=\"{'tab-box__item--active': innerTab==='filters'}\" ng-click=\"display('filters')\" translate>Filters</button></div><div sd-search-parameters ng-if=\"innerTab==='parameters'\" data-repo=\"repo\" data-context=\"context\" data-provider-type=\"providerType\"></div><div sd-search-filters ng-if=\"innerTab==='filters'\"></div></div><div class=\"content pull pull-heigher\" ng-if=\"sTab==='rawSearch'\"><div sd-raw-search></div></div><div sd-save-search></div><div class=\"content views\" ng-if=\"sTab==='savedSearches'\"><div sd-saved-searches></div></div></div>");
        $templateCache.put('scripts/apps/search/views/search-parameters.html', "<form><fieldset class=\"search-parameters\" ng-show=\"repo.search === 'local' || isContentApi()\"><div class=\"form__row form__row--flex sd-margin-t--2\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.slugline\"><label class=\"sd-line-input__label\" for=\"search-slugline\">{{:: 'Slugline' | translate}}</label><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-slugline\" ng-model=\"meta.slugline\"></div><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.headline\"><label class=\"sd-line-input__label\" for=\"search-headline\">{{:: 'Headline' | translate}}</label><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-headline\" ng-model=\"meta.headline\"></div></div><div class=\"form__row\" ng-if=\"search_config.story_text\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-storytext\">{{:: 'Story Text' | translate}}</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-storytext\" ng-model=\"meta.body_html\"></span></div></div><div class=\"form__row form__row--flex\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.unique_name\"><label class=\"sd-line-input__label\" for=\"search-storyname\">{{:: 'Unique Name' | translate}}</label><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-storyname\" ng-model=\"fields.unique_name\"></div><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.byline\"><label class=\"sd-line-input__label\" for=\"search-byline\">{{:: 'Byline' | translate}}</label><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-byline\" ng-model=\"meta.byline\"></div></div><div class=\"form__row\" ng-repeat=\"cv in cvs track by cv.id\"><label class=\"form-label form__row-label\" for=\"search-{{cv.name}}\">{{cv.name | translate}}</label><div id=\"search-{{cv.name}}\"><div id=\"{{cv.name}}\" sd-meta-terms data-item=\"selecteditems\" data-field=\"{{cv.id}}\" data-unique=\"qcode\" data-list=\"metadata[cv.list]\" data-reload-list=\"true\" data-header=\"true\" data-change=\"itemSearch(selecteditems, cv.id)\"></div></div></div><div class=\"form__row\" ng-if=\"search_config.marked_desks\"><label class=\"form-label form__row-label\" for=\"search-marked-desks\">{{:: 'Marked Desks' | translate}}</label><div id=\"search-marked-desks\"><div id=\"marked-desks\" sd-meta-terms data-item=\"selecteditems\" data-field=\"marked_desks\" data-unique=\"_id\" data-list=\"desks._items\" data-reload-list=\"true\" data-header=\"true\" data-change=\"itemSearch(selecteditems, 'marked_desks')\"></div></div></div><div class=\"field keywords\" ng-if=\"search_config.keywords\"><label for=\"search-keywords\">{{:: 'Keywords' | translate}}</label><div id=\"search-keywords\" sd-meta-words-list data-field=\"keywords\" data-header=\"true\" data-list=\"keywords\" data-item=\"meta\" class=\"line-input--boxed\"></div></div><div class=\"form__row form__row--flex\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.from_desk\"><label class=\"sd-line-input__label\" for=\"from-desk\">{{:: 'From Desk' | translate}}</label><select id=\"from-desk\" class=\"sd-line-input__select\" name=\"from-desk\" ng-options=\"d._id as d.name for d in desks._items\" ng-model=\"fields.from_desk\"><option value=\"\" label=\"\"></option></select></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"search_config.to_desk\"><label class=\"sd-line-input__label\" for=\"to-desk\">{{:: 'To Desk' | translate}}</label><select id=\"to-desk\" class=\"sd-line-input__select\" name=\"to-desk\" ng-options=\"d._id as d.name for d in desks._items\" ng-model=\"fields.to_desk\"><option value=\"\" label=\"\"></option></select></div></div><div class=\"form__row\" ng-if=\"repo.archive && search_config.creator\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-creator\">{{:: 'Creator' | translate}}</label><select id=\"search-creator\" class=\"sd-line-input__select\" ng-model=\"fields.original_creator\" ng-options=\"user._id as user.display_name for user in userList | orderBy:'display_name'\n" +
            "                        track by user._id\"><option value=\"\" label=\"\"></option></select></div></div><div class=\"form__row\" ng-if=\"search_config.spike\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"spike-options\">{{:: 'Spiked Content' | translate}}</label><select id=\"spike-options\" class=\"sd-line-input__select\" name=\"spike-options\" ng-model=\"fields.spike\"><option value=\"exclude\" label=\"{{:: 'Exclude spiked content' | translate }}\"></option><option value=\"include\" label=\"{{:: 'Include spiked content' | translate }}\"></option><option value=\"only\" label=\"{{:: 'Spiked only content' | translate }}\"></option></select></div></div><div class=\"form__row form__row--flex\" ng-if=\"search_config.ingest_provider\"><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-ingest-provider\">{{:: 'Provider' | translate}}</label><select id=\"search-ingest-provider\" class=\"sd-line-input__select\" ng-model=\"fields.ingest_provider\" ng-options=\"provider._id as provider.name for provider in providers\"><option value=\"\" label=\"\"></option></select></div></div><div class=\"form__row\" ng-if=\"search_config.featuremedia\"><span sd-switch ng-model=\"fields.featuremedia\"></span><label for=\"search-featuremedia\">{{:: 'Feature Media' | translate}}</label></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin\" ng-if=\"isContentApi() && search_config.subscribers\"><label class=\"sd-line-input__label\" for=\"search-subscriber\">{{:: 'Subscriber' | translate}}</label><select id=\"search-subscriber\" class=\"sd-line-input__select\" ng-model=\"fields.subscriber\" ng-options=\"subscriber._id as subscriber.name for subscriber in subscribers\"><option value=\"\" label=\"\"></option></select></div></fieldset><fieldset ng-show=\"providerType === 'aapmm'\"><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-objectname\">{{:: 'Object Name (Slugline)' | translate}}</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-objectname\" ng-model=\"meta.objectname\"></span></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-description\">{{:: 'Description' | translate}}</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-description\" ng-model=\"meta.description_text\"></span></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-aapkeyword\">{{:: 'AAP Image Keyword' | translate}}</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-aapkeyword\" ng-model=\"meta.aapkeyword\"></span></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"sd-line-input__label\" for=\"search-keywords\">{{:: 'Keywords'}}</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-keywords\" ng-model=\"meta.keywords\"></span></div></div></fieldset><fieldset ng-if=\"providerType.startsWith('scanpix')\"><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"search-label sd-line-input__label\" for=\"search-text\" translate>Search</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-text\" ng-model=\"meta.text\"></span></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin\"><label class=\"search-label sd-line-input__label\" for=\"search-id\" translate>Scanpix ID(s)</label><span class=\"control\"><input class=\"sd-line-input__input\" type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-id\" ng-model=\"meta.id\"></span></div></div><div><div class=\"form__row form__row--s-padding\"><sd-check id=\"search-bw\" ng-model=\"meta.bw\">{{:: 'Black&White' | translate}}</sd-check></div><div class=\"form__row form__row--s-padding\"><sd-check id=\"search-clear_edge\" ng-model=\"meta.clear_edge\">{{:: 'Clear Edge' | translate}}</sd-check></div></div></fieldset><div ng-if=\"hasTemplate(providerType)\" ng-include=\"getTemplate(providerType)\"></div></form>");
        $templateCache.put('scripts/apps/search/views/search-results.html', "<div class=\"preview-layout\" ng-class=\"{closed: !selected.preview && !selected.fetch}\" sd-media-query min-width=\"700\" element-class=\"narrowList\" ng-init=\"extras={view: view, activity: {type: spike ? 'spike' : type, action: 'list'}, api: api}\"><div class=\"list-pane {{ view || 'mgrid' }}-view\"><div id=\"content-list\" class=\"content search-content\"><div class=\"search-content__main\"><div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div><div ng-if=\"showtags || showRefresh\" class=\"search-tags\" ng-class=\"{'refresh': showRefresh}\" sd-search-tags></div><div class=\"shadow-list-holder\" ng-class=\"{'refresh': showRefresh}\" sd-items-list></div></div><div sd-item-preview class=\"search-preview\" ng-if=\"!narrowList\" data-item=\"selected.preview\" data-close=\"preview()\" data-open-single-item=\"openSingleItem\" data-show-history-tab=\"showHistoryTab\"></div></div><div sd-item-preview class=\"search-preview--overlay\" ng-if=\"narrowList\" data-item=\"selected.preview\" data-close=\"preview()\" data-open-single-item=\"openSingleItem\" data-show-history-tab=\"showHistoryTab\"></div><div sd-send-item data-item=\"selected.fetch\" data-mode=\"monitoring\"></div><div sd-archived-item-kill ng-if=\"selected.archived_kill\" data-item=\"selected.archived_kill\" data-action=\"selected.archived_kill_action\"></div><div sd-resend-item data-item=\"selected.resend\"></div></div></div>");
        $templateCache.put('scripts/apps/search/views/search-tags.html', "<ul class=\"search-tags__list\"><li ng-repeat=\"(type,keys) in tags.selectedFacets\"><div ng-repeat=\"key in keys\" class=\"tag-label tag-label--highlight2\"><span>{{type| translate}}:</span>{{key.label|| key}}<button class=\"tag-label__remove\" ng-click=\"removeFilter(type, key.value || key)\"><i class=\"icon-close-small\"></i></button></div></li><li ng-repeat=\"(type,keys) in tags.removedFacets\"><div ng-repeat=\"key in keys\" class=\"tag-label tag-label--highlight2\"><span>{{key.label| translate}}:</span>{{key.displayValue}}<button class=\"tag-label__remove\" ng-click=\"removeFilter(type, key.value)\"><i class=\"icon-close-small\"></i></button></div></li><li ng-repeat=\"parameter in tags.selectedParameters\"><div class=\"tag-label tag-label--highlight1\"><span>{{parameter.label}}</span><button class=\"tag-label__remove\" ng-click=\"removeParameter(parameter.value)\"><i class=\"icon-close-small\"></i></button></div></li><li ng-repeat=\"parameter in tags.selectedKeywords\"><div class=\"tag-label tag-label--highlight1\"><span>{{parameter}}</span><button class=\"tag-label__remove\" ng-click=\"removeParameter(parameter)\"><i class=\"icon-close-small\"></i></button></div></li></ul><div class=\"refresh-box\"><button class=\"btn btn--primary btn--icon-only-circle\" ng-click=\"refreshList()\" tooltip=\"{{:: 'Refresh' | translate}}\" tooltip-placement=\"left\"><i class=\"icon-repeat\"></i></button></div>");
        $templateCache.put('scripts/apps/search/views/search.html', "<div class=\"subnav subnav--absolute\"><header class=\"search-page-header\"><div class=\"filter-trigger\" title=\"{{ :: 'Filters' | translate }}\" ng-click=\"flags.facets = !flags.facets\" ng-class=\"{'filter-trigger--active': flags.facets}\"><i class=\"icon-filter-large\"></i></div><div sd-repo-dropdown class=\"sortbar-flex-handler\" data-active-provider=\"search.activeProvider\" data-toggle-provider=\"search.toggleProvider\" style=\"white-space: nowrap\"></div><div sd-item-searchbar data-context=\"context\" class=\"searchbar-flex-handler\"></div><div sd-item-sortbar data-total=\"total_records\" class=\"sortbar-flex-handler\"></div><div class=\"view-select\"><button title=\"{{ :: 'Switch to grid view' | translate }}\" ng-show=\"view !== 'photogrid'\" ng-click=\"setview('photogrid')\"><i class=\"icon-grid-view\"></i></button> <button title=\"{{ :: 'Switch to list view' | translate }}\" ng-show=\"view !== 'compact'\" ng-click=\"setview('compact')\"><i class=\"icon-list-view\"></i></button></div><div sd-multi-action-bar></div></header></div><section sd-search-container class=\"search main-section search-page-container\" ng-class=\"{'sidebar-open': flags.facets}\"><div sd-search-panel class=\"archive-sidebar\" data-items=\"items\" data-repo=\"search.repo\" data-providers=\"search.providers\" data-toggle-repo=\"search.toggleRepo\" data-provider-type=\"search.providerType\" data-context=\"context\" ng-if=\"flags.facets\"></div><div sd-search-results class=\"archive-content\"></div></section>");
        $templateCache.put('scripts/apps/settings/views/main.html', "<sd-settings-view></sd-settings-view>");
        $templateCache.put('scripts/apps/stream/views/activity-stream.html', "<div class=\"activity-log\"><ul class=\"activity-list card-list\"><li class=\"activity\" ng-class=\"{'with-date': showDateHeader(activity)}\" ng-repeat=\"activity in activities._items track by activity._id\"><div class=\"date\" ng-show=\"showDateHeader(activity)\"><span sd-datetime data-date=\"activity._created\"></span></div><div><figure class=\"avatar\"><img sd-user-avatar data-user=\"activity.user\"></figure><span ng-if=\"activity.name != 'user:mention' && activity.name != 'desk:mention'\"><div class=\"activity-content\"><p><b>{{ :: activity.user_name || 'System' }}</b> <span sd-activity-message data-activity=\"activity\"></span></p></div><div class=\"activity-date\"><time sd-datetime data-date=\"activity._created\"></time></div></span><span ng-if=\"activity.name == 'user:mention' || activity.name == 'desk:mention'\"><div class=\"activity-content\"><p><b>{{ :: activity.user_name || 'System' }}</b> <span>{{activity.name == 'user:mention'? 'mentioned you' : 'commented on' | translate}}</span> <i><a ng-click=\"openArticle(activity)\" title=\"{{ :: activity.item_slugline }}\">{{ :: activity.item_slugline }}</a> </i>:<br>{{ :: activity.data.comment }}</p></div><div class=\"activity-date\"><time sd-datetime date-date=\"activity._created\"></time></div></span></div></li></ul></div><button class=\"btn btn--large btn--hollow btn--expanded activity-load-more\" translate ng-click=\"loadMore()\" ng-show=\"activities._meta.total > max_results\">Load more</button>");
        $templateCache.put('scripts/apps/stream/views/workspace-stream.html', "<div class=\"subnav\"></div><section class=\"main-section workspace-stream\"><div class=\"activity-container\" sd-activity-stream data-activities=\"activities\" load-more=\"loadMore()\" data-max-results=\"max_results\"></div></section>");
        $templateCache.put('scripts/apps/templates/views/create-template.html', "<div class=\"modal__header\"><button type=\"button\" class=\"modal__close pull-right\" ng-click=\"$dismiss()\"><span class=\"icon-close-small\"></span></button><h3 class=\"modal__heading\" translate>Save as template</h3></div><div class=\"modal__body\"><form name=\"templateForm\"><fieldset><div class=\"field\"><label for=\"template-name\" translate>Name</label><div class=\"control\"><input type=\"text\" id=\"template-name\" name=\"name\" required ng-model=\"template.name\" ng-maxlength=\"40\"><div class=\"error\" ng-show=\"template._issues.template_name\" translate>Sorry, but template name must be unique.</div><em class=\"info\" ng-show=\"template.template && template.template.template_name === template.name\" translate>It will update existing template.</em> <em class=\"info\" ng-show=\"template.template && template.template.template_name !== template.name\" translate>It will create a new template.</em> <span class=\"error\" ng-show=\"templateForm.name.$error.maxlength\" translate>Please use less than 40 characters</span></div></div><div class=\"field\" ng-if=\"privileges.content_templates\"><div class=\"control\"><sd-check ng-model=\"template.is_public\">Desk template</sd-check></div></div><div class=\"field\" ng-if=\"template.is_public !== false\"><label for=\"template-desk\" translate>Desk</label><div class=\"control\"><select ng-model=\"template.desk\" ng-options=\"desk._id as desk.name for desk in template.desks\"></select></div></div></fieldset></form></div><div class=\"modal__footer\"><button type=\"button\" class=\"btn\" ng-click=\"$dismiss()\" translate>Cancel</button> <button type=\"button\" class=\"btn btn--primary\" ng-disabled=\"templateForm.$invalid\" ng-click=\"template.save().then($close)\" translate>Save</button></div>");
        $templateCache.put('scripts/apps/templates/views/sd-template-select.html', "<div sd-modal data-model=\"open\" data-close=\"close()\"><div class=\"modal__header\"><a href=\"\" class=\"modal__close pull-right\" ng-click=\"close()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Select template</h3></div><div class=\"modal__body\"><form><fieldset><div class=\"field\"><label for=\"templateName\" translate>Template Name</label><input type=\"text\" id=\"templateName\" autofocus ng-model=\"options.templateName\" ng-model-options=\"{debounce: 300}\"></div><div sd-loading=\"loading\"><div class=\"field\" ng-if=\"publicTemplates.length\"><label translate>Desk Templates</label><ul sd-template-list data-templates=\"publicTemplates\" data-select=\"select(template)\"></ul></div><div class=\"field\" ng-if=\"privateTemplates.length\"><label translate>My Templates</label><ul sd-template-list data-templates=\"privateTemplates\" data-select=\"select(template)\"></ul></div></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"close()\">Close</button></div></div>");
        $templateCache.put('scripts/apps/templates/views/settings.html', "<sd-settings-view><div id=\"templates-settings\"><div class=\"content\"><div sd-templates></div></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/templates/views/template-editor-modal.html', "<div sd-modal data-model=\"template\" data-close=\"cancel()\" class=\"modal--fill template-editor-modal\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" ng-show=\"template._id\">{{ :: 'Edit Template'}}: <span>{{ origTemplate.template_name}}</span></h3><h3 class=\"modal__heading\" ng-hide=\"template._id\" translate>Add New Template</h3></div><div class=\"modal__body\"><form class=\"template-content\" name=\"templateForm\"><div class=\"template-icon\"><i class=\"icon-text\"></i></div><div class=\"template-header\"><div sd-validation-error=\"error.template_name\" data-required=\"true\" class=\"authoring-header__item\" sd-width=\"full\"><input type=\"text\" id=\"template-name\" class=\"line-input\" name=\"name\" ng-model=\"template.template_name\" placeholder=\"{{ :: 'Template name' | translate }}\" required data-field=\"template_name\" ng-disabled=\"template.template_name && template.template_type === 'kill'\" ng-maxlength=\"40\"></div><div class=\"error\" ng-show=\"templateForm.name.$error.maxlength\" translate>Please use less than 40 characters</div><div class=\"authoring-header__item\" sd-width=\"full\" ng-if=\"template.template_type !== 'kill' && !content_types.length\"><label for=\"template-profile\" class=\"pull-left\" translate>Content Profile</label><input type=\"text\" class=\"line-input\" id=\"template-profile\" ng-model=\"item.profile\"></div><div class=\"authoring-header__item\" sd-width=\"half\" ng-if=\"template.template_type !== 'kill' && content_types.length\"><label for=\"template-profile\" translate>Content Profile</label><div class=\"authoring-header__input-holder\"><select id=\"template-profile\" class=\"dropdown__toggle line-input\" ng-model=\"item.profile\" ng-options=\"type._id as type.label for type in content_types | orderBy: 'label'\"><option value=\"\"></option></select><span class=\"arrow-down\"><b class=\"dropdown__caret\"></b></span></div></div><div sd-validation-error=\"error.template_type\" data-required=\"true\" class=\"authoring-header__item\" sd-width=\"half\"><label for=\"template-type\" translate>Template Type</label><div class=\"authoring-header__input-holder\"><select id=\"template-type\" class=\"dropdown__toggle line-input\" ng-model=\"template.template_type\" ng-change=\"resetDesks()\" ng-options=\"type._id as type.label | translate for type in types| filter:templatesFilter\" required></select><span class=\"arrow-down\"><b class=\"dropdown__caret\"></b></span></div></div><div ng-if=\"isAdmin()\" class=\"authoring-header__item\" sd-width=\"full\"><span sd-switch ng-model=\"template.is_public\"></span><label for=\"template-is-private\" translate>Make Public</label></div></div><div class=\"template-editor\"><header sd-authoring-header></header><div class=\"main-article\"><div class=\"fieldset\" sd-article-edit></div></div></div></form><form name=\"metadataForm\"><div class=\"template-metadata\"><div ng-if=\"showDesks()\"><div for=\"template-desk\" ng-if=\"template.template_type !== 'create'\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\">{{:: 'Desk' | translate }}</label><select id=\"template-desk\" ng-if=\"template.template_type !== 'create'\" ng-model=\"template_desk\" ng-change=\"setTemplateDesks(template_desk)\" class=\"sd-line-input__select\"><option value=\"\" translate>None</option><option ng-repeat=\"desk in desks._items track by desk._id\" value=\"{{ desk._id }}\" ng-selected=\"desk.selected\">{{ :: desk.name }}</option></select></div></div><div for=\"template-desks\" ng-if=\"template.template_type === 'create'\" sd-toggle-box data-title=\"{{:: 'Desks' | translate }}\" data-open=\"true\"><div class=\"multi-select\" ng-if=\"template.template_type === 'create'\"><ul><li ng-repeat=\"desk in desks._items track by desk._id\"><sd-check ng-model=\"desk.selected\" ng-click=\"onDeskToggle(desk)\" label-position=\"inside\">{{desk.name}}</sd-check></li></ul></div></div></div><div sd-toggle-box data-title=\"{{:: 'Metadata' | translate }}\" data-open=\"false\" id=\"template-editor-metadata\"><div class=\"field\"><span sd-switch ng-model=\"item.flags.marked_for_not_publication\"></span><label>Not For Publication</label></div><div class=\"field field--margin-double\"><span sd-switch ng-model=\"item.flags.marked_for_legal\"></span><label translate>Legal</label></div><div class=\"field field--margin-double\"><label translate>Usage terms</label><div class=\"data\"><input class=\"line-input\" type=\"text\" ng-model=\"item.usageterms\" ng-disabled=\"!_editable\" ng-change=\"autosave(item)\"></div></div><div class=\"field field--margin-double\"><label translate>Language</label><div class=\"data\"><input class=\"line-input\" type=\"text\" ng-model=\"item.language\" ng-disabled=\"!_editable\" ng-change=\"autosave(item)\"></div></div><div class=\"field target-field\"><label translate>Target Subscribers</label><div class=\"term-editor\" sd-meta-terms data-item=\"item\" data-unique=\"_id\" data-list=\"metadata.customSubscribers\" data-field=\"target_subscribers\" data-reload-list=\"true\"></div></div><div class=\"field target-field\"><label translate>Target Regions</label><div sd-meta-target data-list=\"metadata.regions\" data-targets=\"item.target_regions\"></div></div><div class=\"field target-field\"><label translate>Target Types</label><div sd-meta-target data-list=\"metadata.subscriberTypes\" data-targets=\"item.target_types\"></div></div></div><div class=\"field\" ng-if=\"showScheduling()\"><div class=\"toggle-box\"><div class=\"toggle-box__header\"><span class=\"toggle-box__chevron\" sd-switch ng-model=\"template.schedule.is_active\"></span><div class=\"toggle-box__label\">{{ :: 'Automatically create item' | translate }}</div><div class=\"toggle-box__line\"></div></div></div><div><div class=\"sd-line-input sd-line-input--required\" ng-if=\"template.schedule.is_active && template.template_type !== 'kill'\"><label class=\"sd-line-input__label\" translate>On</label><div class=\"day-filter-box clearfix sd-line-input__select\" sd-weekday-picker data-model=\"template.schedule.day_of_week\"></div></div><div ng-if=\"template.schedule.is_active && template.template_type !== 'kill'\"><div class=\"form__row\"><label class=\"sd-line-input__label--required\" translate>Scheduled at</label><div class=\"terms-list\"><ul><li ng-repeat=\"time in cron_times\" class=\"pull-left\" ng-click=\"removeCronTime(time)\">{{time}}<i class=\"icon-close-small\"></i></li></ul></div></div><div class=\"form__row form__row--flex sd-line-input\"><label class=\"sd-line-input__label\" translate>New schedule</label><span sd-timepicker ng-model=\"new_time.picked\" data-style=\"line-input\"></span> <button id=\"add_time\" class=\"btn pull-right\" ng-click=\"addCronTime()\" translate>Add</button></div><div><span sd-timezone data-timezone=\"template.schedule.time_zone\" data-style=\"line-input\"></span></div></div></div><div ng-if=\"showScheduling() && template.schedule.is_active\" class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label for=\"schedule-desk\" class=\"sd-line-input__label\" translate>Schedule Desk</label><select id=\"schedule-desk\" ng-model=\"template.schedule_desk\" ng-change=\"updateStages(template.schedule_desk)\" class=\"sd-line-input__select\"><option value=\"\" translate>None</option><option ng-repeat=\"desk in desks._items track by desk._id\" value=\"{{ desk._id }}\" ng-selected=\"desk._id === template.schedule_desk\">{{ :: desk.name }}</option></select></div><div ng-if=\"showStages() && template.schedule.is_active\" class=\"sd-line-input sd-line-input--is-select sd-line-input--required\"><label for=\"template-stage\" class=\"sd-line-input__label\" translate>Schedule Stage</label><select id=\"template-stage\" ng-model=\"template.schedule_stage\" class=\"sd-line-input__select\"><option ng-repeat=\"stage in stages track by stage._id\" value=\"{{ stage._id }}\" ng-selected=\"stage._id === template.schedule_stage\">{{ :: stage.name }}</option></select></div></div></div></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save()\" ng-disabled=\"templateForm.$invalid || !isScheduleValid() || !isDirty(templateForm, metadataForm)\" translate>Save</button></div></div>");
        $templateCache.put('scripts/apps/templates/views/template-list.html', "<li ng-repeat=\"template in templates track by template._id\"><button class=\"btn btn--text-only\" ng-click=\"select({template: template})\" ng-keypress=\"selectOnEnter($event, template)\"><span class=\"pull-left\">{{ :: template.template_name }}</span></button></li>");
        $templateCache.put('scripts/apps/templates/views/templates.html', "<div class=\"sd-page__main-content\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Templates</h2></div><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.template_name\" data-debounce=\"200\"></sd-search-handler><div class=\"sortbar\"><span class=\"lab\" translate>Filter:</span><div class=\"dropdown\" dropdown sd-dropdown-position><button id=\"order_button\" class=\"dropdown__toggle\" dropdown__toggle>{{ filters[activeFilter].label | translate }} <b class=\"dropdown__caret\"></b></button><ul class=\"dropdown__menu\" id=\"order_selector\" style=\"max-height: 400px;overflow-y: scroll\"><li ng-repeat=\"f in filters track by $index\" ng-class=\"{active: activeFilter === $index}\"><a href=\"\" ng-click=\"filterBy($index)\">{{ f.label | translate }}</a></li></ul></div></div><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"edit()\"><i class=\"icon-plus-sign icon--white\"></i><span translate>Add New</span></button></div><div class=\"sd-page__content\"><div class=\"flex-grid box wrap-items small-1 medium-3 large-4 xlarge-6\"><div class=\"flex-item card-box template-card\" ng-repeat=\"template in content_templates._items | filter:query | templatesBy:filters[activeFilter]\" ng-if=\"desks\"><div class=\"card-box__header\" ng-class=\"{'card-box__header--dark': !template.is_public}\"><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu more-activity-menu pull-right\"><li><div class=\"dropdown__menu-label\" translate>Actions</div></li><li class=\"dropdown__menu-divider\"></li><li><button ng-click=\"edit(template)\" title=\"{{:: 'Edit Template' | translate }}\"><i class=\"icon-pencil\"></i>{{:: 'Edit'| translate}}</button></li><li ng-if=\"template.template_type !== 'kill'\"><button ng-click=\"remove(template)\" title=\"{{:: 'Remove Template' | translate }}\"><i class=\"icon-trash\"></i>{{:: 'Remove'| translate}}</button></li></ul></div><div class=\"card-box__heading\">{{ template.template_name }}</div></div><div class=\"card-box__content\"><ul class=\"card-box__content-list\"><li><h4 class=\"with-value\">{{ :: 'Template type' | translate }} <span class=\"value-label\">{{ template.template_type | translate }}</span></h4></li><li ng-if=\"getTemplateDesks(template)\"><h4>{{ :: 'Desk(s)' | translate }}</h4><span>{{getTemplateDesks(template)}}</span></li><li ng-if=\"template.schedule_desk\"><h4>{{ :: 'Sched. Desk / Stage' | translate }}</h4><span>{{getScheduleDesk(template)}}</span> <span ng-if=\"getScheduleStage(template)\">/ {{getScheduleStage(template)}}</span></li><li ng-if=\"template.schedule.is_active\"><h4>{{ :: 'Automated item creation' | translate }}</h4><span ng-repeat=\"day in template.schedule.day_of_week\">{{ :: weekdays[day] | translate }} <span ng-if=\"$index < template.schedule.day_of_week.length-1\">,</span></span></li><li ng-if=\"template.schedule.cron_list.length\"><h4>{{ :: 'Scheduled Time(s)' | translate }}</h4><i class=\"icon-time\"></i> <span ng-repeat=\"cron in template.schedule.cron_list\" class=\"creation-time\">{{ cron.split(' ')[1] + ':' + cron.split(' ')[0] }}<span ng-if=\"!$last\">,&nbsp;</span><span></span></span></li></ul></div></div></div></div></div><div sd-template-editor-modal ng-if=\"template\"></div>");
        $templateCache.put('scripts/apps/translations/views/TranslationDropdown.html', "<ul><li ng-if=\"languages.length\" ng-repeat=\"language in languages track by language._id\"><button ng-disabled=\"isCurrentLanguage(language)\" option=\"{{ language.label}}\" ng-click=\"translateItem(language);\">{{ :: language.label | translate }}</button></li><li ng-if=\"!languages.length\"><button ng-disabled=\"true\">{{::'No available languages'|translate}}</button></li></ul>");
        $templateCache.put('scripts/apps/translations/views/TranslationDropdownTemplate.html', "<div sd-translation-dropdown></div>");
        $templateCache.put('scripts/apps/users/activity-widget/configuration.html', "<div ng-controller=\"ActivityConfigController\" class=\"widget-config\"><form class=\"form-horizontal\"><fieldset><div class=\"field\"><label translate>Number of items</label><div class=\"control\"><select ng-model=\"configuration.maxItems\" class=\"input-mini\"><option value=\"5\">5</option><option value=\"10\">10</option><option value=\"25\">25</option><option value=\"50\">50</option></select></div></div></fieldset></form></div>");
        $templateCache.put('scripts/apps/users/activity-widget/widget-activity.html', "<div ng-controller=\"ActivityController\"><div class=\"activity-holder\"><div sd-shadow><div sd-activity></div></div></div></div>");
        $templateCache.put('scripts/apps/users/import/views/import-user.html', "<form name=\"importForm\" ng-submit=\"importForm.$valid && importUser(model)\"><div class=\"modal__header\"><h3 class=\"modal__heading\">{{ activity.label | translate }}</h3><button type=\"button\" class=\"modal__close pull-right\" ng-click=\"reject()\"><i class=\"icon-close-small\"></i></button></div><div class=\"modal__body\"><div class=\"editmode\"><div class=\"details-info form-flat\" ng-class=\"{shifted : error}\"><div class=\"title\" translate>Your Credentials</div><fieldset><div sd-info-item><label for=\"username\" translate>username</label><input type=\"text\" name=\"username\" id=\"username\" ng-model=\"model.username\" required></div><div sd-info-item><label for=\"password\" translate>password</label><input type=\"password\" name=\"password\" id=\"password\" ng-model=\"model.password\" required></div><div class=\"error-holder\" ng-if=\"error.credentials\"><p class=\"alert alert-error\">{{error.message || 'Invalid credentials.' | translate}}</p></div></fieldset><div class=\"title\" translate>User Profile to Import</div><fieldset><div sd-info-item><label for=\"profile\" translate>profile</label><input type=\"text\" name=\"profile\" id=\"profile\" ng-model=\"model.profile_to_import\" required></div><div class=\"error-holder\" ng-if=\"error.profile_to_import\"><p class=\"alert alert-error\">{{error.message || 'Profile Not found' | translate}}</p></div></fieldset></div></div></div><div class=\"modal__footer\"><button type=\"submit\" class=\"btn submit\" ng-disabled=\"!importForm.$dirty || !importForm.$valid\" translate>Import</button></div></form>");
        $templateCache.put('scripts/apps/users/views/activity-feed.html', "<div class=\"profile-activity-container\"><div class=\"profile-activity\"><div class=\"activity-header\"><h6 translate>Activity Stream</h6></div><div sd-activity></div></div></div>");
        $templateCache.put('scripts/apps/users/views/activity-list.html', "<div class=\"activity-container\" sd-activity-stream data-activities=\"activityFeed\" load-more=\"loadMore()\" data-max-results=\"max_results\"></div>");
        $templateCache.put('scripts/apps/users/views/change-avatar.html', "<div class=\"modal__header\"><button type=\"button\" class=\"modal__close pull-right\" ng-click=\"reject()\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\">{{ activity.label|translate }}</h3></div><div class=\"modal__body split-popup no-padding\"><aside class=\"sidebar\"><ul><li ng-repeat=\"method in methods\" ng-click=\"activate(method)\" ng-class=\"{active: active === method}\"><i class=\"icon-{{ method.id }}\"></i> {{ method.label | translate }}</li></ul><div class=\"remove-avatar\" ng-click=\"removeImage()\" ng-show=\"locals.data.picture_url\"><i class=\"icon-trash\"></i><span class=\"ng-scope\" translate>No image</span><label translate>shows your initials instead</label></div></aside><section class=\"main\" sd-image-preview=\"preview.url\" data-file=\"preview.img\" data-progress-width=\"progress.width\"><div class=\"upload-progress\" ng-show=\"progress.width\"><div class=\"bar\" style=\"width: {{ progress.width }}%\"></div></div><div class=\"computer\" ng-if=\"active.id == 'upload' && !preview.url\" ng-hide=\"progress.width\"><div class=\"dropzone\" ngf-drop=\"preview.img = $files[0]\"><div class=\"text\" translate>Drop it here</div><div class=\"input-holder\"><input type=\"file\" accept=\"image/*;capture=camera\" ngf-select=\"preview.img = $files[0]\" label=\"{{ 'or Select from computer' | translate }}\"></div><div class=\"info\" translate>The minimum image resolution is 200x200 pixels.</div></div></div><div class=\"camera\" ng-if=\"active.id == 'photo' && !preview.url\"><label translate>Click to capture using camera. Be sure that you allow camera accessibility.</label><video autoplay sd-video-capture=\"preview.url\" data-file=\"preview.img\"></video></div><div class=\"web\" ng-if=\"active.id == 'globe' && (!preview.cords || progress.width)\"><label translate>Enter web url</label><input type=\"url\" ng-model=\"url\" ng-change=\"preview.url = url\"><label translate ng-if=\"url\">Provided image URL is not valid.</label></div><div class=\"preview\" ng-if=\"preview.url\" ng-hide=\"!preview.cords || progress.width\"><label translate>Make sure you're looking the best</label><div class=\"crop-area\"><div class=\"original\"><div sd-crop data-src=\"preview.url\" data-cords=\"preview.cords\" data-progress-width=\"progress.width\" data-file=\"preview.img\" data-max-file-size=\"2\"></div></div><div class=\"preview\"><div class=\"preview-large\"><img ng-src=\"{{preview.url}}\" class=\"preview-target-1\"></div><div class=\"preview-round\"><img ng-src=\"{{preview.url}}\" class=\"preview-target-2\"></div></div></div></div></section></div><div class=\"modal__footer\"><button type=\"button\" class=\"btn submit\" ng-click=\"upload(preview)\" ng-disabled=\"!preview.cords || progress.width\" translate>Done</button></div>");
        $templateCache.put('scripts/apps/users/views/edit-form.html', "<form name=\"userForm\"><div class=\"action-bar clearfix\" ng-class=\"{show:dirty}\"><button id=\"save-edit-btn\" type=\"submit\" class=\"btn btn--primary pull-right\" ng-click=\"userForm.$valid && save()\" ng-disabled=\"userForm.$invalid || !dirty\" translate>Save</button> <button id=\"cancel-edit-btn\" type=\"button\" class=\"btn pull-right\" ng-click=\"cancel()\" ng-disabled=\"!dirty\" translate>Cancel</button></div><div class=\"profile-info editmode\"><div class=\"header-info\"><div class=\"profile-pic\"><figure class=\"avatar\"><img sd-user-avatar data-user=\"user\" alt=\"{{ user.FullName}}\"> <a href=\"\" class=\"change-photo\" ng-click=\"editPicture()\" translate>Change Photo</a></figure><span class=\"disabled-label\" ng-if=\"user._id && !user.is_enabled\" translate>disabled</span> <span class=\"disabled-label\" ng-if=\"user._id && user.is_enabled && !user.is_active\" translate>inactive</span></div><h2>{{ user.display_name}}</h2><h5>{{ user.username}}</h5><div class=\"active\" ng-show=\"user.is_enabled\" ng-if=\"!profile && user._id && !dirty\" sd-tooltip=\"{{ _active ? 'Deactivate user' : 'Activate user' | translate }}\" flow=\"left\"><span sd-switch ng-model=\"user.is_active\" ng-click=\"toggleStatus(user.is_active)\"></span></div><ul class=\"nav-tabs\"><li ng-class=\"{'nav-tabs__tab--active': !tab || tab === 'general'}\" class=\"nav-tabs__tab\"><button ng-click=\"tab = 'general'\" class=\"nav-tabs__link\">{{ 'General info' | translate}}</button></li><li ng-class=\"{'nav-tabs__tab--active': tab === 'author'}\" class=\"nav-tabs__tab\" ng-show=\"user.is_author\"><button ng-click=\"tab = 'author'\" class=\"nav-tabs__link\">{{ 'Author info' | translate }}</button></li></ul></div><!-- General Tab content --><div class=\"details-info\" ng-show=\"!tab || tab === 'general'\"><div sd-info-item class=\"user_type form__row\" ng-if=\"privileges.users && isNetworkSubscription()\" style=\"margin-bottom: 20px\"><sd-check ng-true-value=\"administrator\" ng-false-value=\"user\" ng-model=\"user.user_type\" name=\"user_type\" id=\"user_type\">{{ :: 'Administrator'|translate }}</sd-check><sd-check ng-model=\"user.is_author\" name=\"user_author\" id=\"user_author\">{{ :: 'Author'|translate }}</sd-check></div><div class=\"form__row field__full_name\" sd-info-item ng-show=\"user._id\"><div class=\"sd-line-input sd-line-input--disabled\"><label class=\"sd-line-input__label\" for=\"display-name\" translate>full name</label><input class=\"sd-line-input__input\" type=\"text\" name=\"fullName\" id=\"display-name\" ng-model=\"user.display_name\" disabled></div></div><div class=\"form__row field__member_since\" sd-info-item ng-show=\"user._id\"><label class=\"form-label\" for=\"created\" translate>member since</label><span id=\"created\" class=\"info-value date-time\" sd-reldate datetime=\"user._created\"></span></div><div class=\"form__row field__first_name\" sd-info-item><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"first-name\" translate>first name</label><input class=\"sd-line-input__input\" type=\"text\" name=\"first_name\" id=\"first-name\" ng-model=\"user.first_name\" required ng-readonly=\"user._readonly && user._readonly.first_name\"><div ng-show=\"userForm.first_name.$error.required\" class=\"sd-line-input__message\" translate>This field is required.</div></div></div><div class=\"form__row field__last_name\" sd-info-item><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"last-name\" translate>last name</label><input class=\"sd-line-input__input\" type=\"text\" name=\"last_name\" id=\"last-name\" ng-model=\"user.last_name\" required ng-readonly=\"user._readonly && user._readonly.last_name\"><div class=\"sd-line-input__message\" ng-show=\"userForm.last_name.$error.required\" translate>This field is required.</div></div></div><div class=\"form__row field__username\" sd-info-item><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"username\" translate>username</label><input class=\"sd-line-input__input\" type=\"text\" name=\"username\" id=\"username\" ng-model=\"user.username\" ng-model-options=\"{\n" +
            "                               updateOn: 'default blur',\n" +
            "                                       debounce: {'default': 500, 'blur': 0} }\" ng-readonly=\"user._id\" ng-pattern=\"usernamePattern\" sd-user-unique data-unique-field=\"username\" data-exclude=\"user\" required><div class=\"sd-line-input__message\" ng-show=\"userForm.username.$error.required\" translate>This field is required.</div><div class=\"sd-line-input__message\" ng-show=\"userForm.username.$error.unique || error.username.conflict\" sd-valid-error translate>sorry, this username is already taken.</div><div class=\"sd-line-input__message\" ng-show=\"userForm.username.$error.pattern\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>please use only letters (a-z), numbers (0-9), dashes (&mdash;), underscores (_), apostrophes (') and periods (.)</span></div></div></div><div sd-info-item class=\"password form__row form__row--flex\" ng-if=\"features.reset_user_password && user._id && !profile && user.is_enabled && _active\" id=\"password-reset-trigger\" style=\"margin-bottom:2rem\"><div class=\"form__row-item\"><label class=\"form-label\" translate>password</label></div><div class=\"form__row-item\" style=\"text-align:right\"><span class=\"change-btn btn btn--hollow btn--primary btn--small\" ng-click=\"show.reset_password = !show.reset_password\" ng-show=\"!show.reset_password\">reset password</span></div></div><div sd-info-item class=\"password form__row form__row--flex\" ng-if=\"features.reset_user_password && user._id && profile\" id=\"password-change-trigger\" style=\"margin-bottom:2rem\"><div class=\"form__row-item\"><label class=\"form-label\" translate>password</label></div><div class=\"form__row-item\" style=\"text-align:right\"><span class=\"change-btn btn btn--hollow btn--primary btn--small\" ng-click=\"show.change_password = !show.change_password\" ng-show=\"!show.change_password\">change password</span></div></div><div class=\"form__row field__email\" sd-info-item><div class=\"sd-line-input sd-line-input--required\"><label class=\"sd-line-input__label\" for=\"email\" translate>email</label><input class=\"sd-line-input__input\" type=\"email\" name=\"email\" id=\"email\" ng-model=\"user.email\" sd-user-unique data-unique-field=\"email\" data-exclude=\"user\" ng-readonly=\"user._readonly && user._readonly.email\" required><div class=\"sd-line-input__message\" ng-show=\"userForm.email.$error.required\" translate>This field is required.</div><div class=\"sd-line-input__message\" ng-show=\"userForm.email.$error.email\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>please provide a valid email address</span></div><div class=\"sd-line-input__message\" ng-show=\"error.email\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>{{error.email}}</span></div><div class=\"sd-line-input__message\" ng-show=\"userForm.email.$error.unique || error.email.unique\" sd-valid-error translate>sorry, a user with this email already exists</div></div></div><div sd-info-item class=\"user_role field__language liveblog_hidden form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"user_language\" translate>Language</label><select class=\"sd-line-input__select\" ng-focus=\"focused()\" ng-model=\"user.language\" name=\"user_language\" id=\"user_language\" ng-options=\"lang.code as lang.nativeName for lang in languages\"></select><div class=\"sd-line-input__hint\"><a href=\"https://www.transifex.com/projects/p/superdesk/\" target=\"_blank\" class=\"sd-blue\">{{ :: \"Help us translate Superdesk\" | translate }}</a></div></div></div><div sd-info-item class=\"user_role field__role form__row\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"user_role\" translate>Role</label><select class=\"sd-line-input__select\" ng-focus=\"focused()\" ng-disabled=\"!privileges.users\" ng-model=\"user.role\" name=\"user_role\" id=\"user_role\" ng-options=\"role._id as role.name for role in roles\"></select></div></div><div sd-info-item class=\"user_role field__default_desk form__row\" ng-if=\"userDesks && userDesks.length > 0\"><div class=\"sd-line-input sd-line-input--is-select\"><label class=\"sd-line-input__label\" for=\"user_default_desk\" translate>Default Desk</label><select class=\"sd-line-input__select\" ng-model=\"user.desk\" name=\"user_default_desk\" id=\"user_default_desk\" ng-options=\"desk._id as desk.name for desk in userDesks\"><option value=\"\" ng-click=\"user.desk = null\" translate>No desk selected</option></select></div></div><div class=\"form__row field__phone_number\" sd-info-item ng-hide=\"profileConfig.phone === false\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"phone\" translate>phone number</label><input class=\"sd-line-input__input\" type=\"text\" name=\"phone\" id=\"phone\" ng-model=\"user.phone\"></div></div><div class=\"form__row\" sd-info-item ng-hide=\"profileConfig.jid === false || !xmppEnabled\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"jid\" translate>Jabber Identifier (JID)</label><input class=\"sd-line-input__input\" type=\"text\" name=\"jid\" id=\"jid\" ng-model=\"user.jid\"></div></div><div class=\"form__row\" sd-info-item ng-hide=\"!$root.config.features.slackNotifications\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"slack_username\">Slack Username</label><input class=\"sd-line-input__input\" type=\"text\" name=\"slack_username\" id=\"slack_username\" ng-model=\"user.slack_username\"> <span class=\"sd-line-input__hint\" translate>Your Slack user name without the leading @</span></div></div></div><!-- END General Tab content --><!-- Author Tab content --><div class=\"details-info\" ng-show=\"tab === 'author'\"><div class=\"form__row\" sd-info-item ng-if=\"!hideSignOff\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"sign_off\" translate>Sign-Off</label><input class=\"sd-line-input__input\" type=\"text\" name=\"sign_off\" id=\"sign_off\" ng-model=\"user.sign_off\" ng-pattern=\"signOffPattern\"><div class=\"sd-line-input__message\" ng-show=\"userForm.sign_off.$error.pattern || error.sign_off\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>Invalid format. Only Alphanumerics are allowed.</span></div></div></div><div class=\"form__row\" sd-info-item><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"byline\" translate>Byline</label><input class=\"sd-line-input__input\" type=\"text\" name=\"byline\" id=\"byline\" ng-model=\"user.byline\"></div></div><div sd-info-item class=\"form__row\" ng-if=\"privileges.users\"><div class=\"sd-line-input\" ng-disabled=\"!user.is_author\"><label class=\"sd-line-input__label\" for=\"job_title\" translate>Job Title</label><select class=\"sd-line-input__select\" ng-focus=\"focused()\" ng-model=\"user.job_title\" name=\"job_title\" id=\"job_title\" ng-options=\"job.qcode as job.name for job in metadata.job_titles\" ng-disabled=\"!user.is_author\"></select></div></div><div sd-info-item class=\"form__row\" ng-if=\"privileges.users\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"biography\">{{ :: 'Biography'|translate }}</label><textarea class=\"sd-line-input__input\" id=\"biography\" sd-auto-height ng-model=\"user.biography\" ng-disabled=\"!user.is_author\"></textarea></div></div><div sd-info-item class=\"form__row\" ng-if=\"privileges.users\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"facebook\">{{ :: 'Facebook'|translate }}</label><input id=\"facebook\" type=\"text\" name=\"facebook\" class=\"sd-line-input__input\" ng-model=\"user.facebook\" ng-disabled=\"!user.is_author\"><div class=\"sd-line-input__hint\">{{ :: 'e.g. superdeskman from https://www.facebook.com/superdeskman'|translate }}</div></div></div><div sd-info-item class=\"form__row\" ng-if=\"privileges.users\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"instagram\">{{ :: 'Instagram'|translate }}</label><input id=\"instagram\" type=\"text\" name=\"instagram\" class=\"sd-line-input__input\" ng-model=\"user.instagram\" ng-disabled=\"!user.is_author\"><div class=\"sd-line-input__hint\">{{ :: 'e.g. superdeskman from https://www.instagram.com/superdeskman'|translate }}</div></div></div><div sd-info-item class=\"form__row\" ng-if=\"privileges.users\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" for=\"twitter\">{{ :: 'Twitter'|translate }}</label><input id=\"twitter\" type=\"text\" name=\"twitter\" class=\"sd-line-input__input\" ng-model=\"user.twitter\" ng-disabled=\"!user.is_author\" ng-pattern=\"twitterPattern\"><div class=\"sd-line-input__hint\">{{ :: 'e.g. @superdeskman'|translate }}</div><div class=\"sd-line-input__message--add-padding\" ng-show=\"userForm.twitter.$error.pattern\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>Please provide a valid twitter account</span></div></div></div></div><!-- END Author Tab content --></div></form><div sd-modal data-model=\"features.reset_user_password && show.reset_password && user._id\" class=\"modal--tabs\"><div class=\"modal__header\"><button class=\"modal__close pull-right\" ng-click=\"show.reset_password = false\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\">Reset password</h3></div><div class=\"modal__body\" sd-reset-password><div class=\"modal__body-content\"><p translate>Do you want to reset the password for user {{user.full_name}} ?</p></div><div class=\"modal__body-footer\"><button class=\"btn\" ng-click=\"show.reset_password = false\">Cancel</button> <button class=\"btn btn--primary\" ng-click=\"resetPassword()\">Reset password</button></div></div></div><div sd-modal data-model=\"features.reset_user_password && show.change_password && user._id\" class=\"modal--tabs\"><div class=\"modal__header\"><button class=\"modal__close pull-right\" ng-click=\"show.change_password = false\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\">Change password</h3></div><div class=\"modal__body\" sd-change-password><div class=\"modal__body-content\"><form name=\"changePasswordForm\"><div class=\"content\"><div class=\"field\"><label translate>current</label><input name=\"old\" type=\"password\" ng-model=\"oldPwd\" required><p sd-valid-error ng-show=\"oldPasswordInvalid\">sorry, but this is not the original password.</p></div><div class=\"field\"><label translate>new</label><input sd-password-strength name=\"new\" type=\"password\" ng-model=\"newPwd\" required></div><div class=\"field\"><label translate>confirm</label><input name=\"confirm\" type=\"password\" ng-model=\"_confirm\" required sd-password-confirm ng-model=\"_confirm\" data-password=\"newPwd\"><p sd-valid-error ng-show=\"changePasswordForm.confirm.$error.confirm\">confirm doesn't match new password yet.</p></div></div></form></div><div class=\"modal__body-footer\"><button class=\"btn\" ng-click=\"show.change_password = false\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"changePasswordForm.$valid && changePassword(oldPwd, newPwd)\" ng-disabled=\"changePasswordForm.$invalid\" translate>Save password</button></div></div></div>");
        $templateCache.put('scripts/apps/users/views/edit.html', "<div class=\"subnav subnav--absolute\"><div class=\"flat-searchbar monitoring-backlink\" ng-if=\"privileges.users\"><div class=\"search-handler\"><button sd-tooltip=\"{{ :: 'Back to users list' | translate }}\" flow=\"right\" class=\"backlink\" ng-click=\"intent('list', 'user')\"></button></div></div><h3 class=\"page-nav-title\"><span translate>Users Profile</span>: <b>{{ user | username }}</b></h3></div><section class=\"main-section user-profile-page\"><div class=\"form-content\"><div class=\"user-details-pane\" ng-init=\"selectedTab = 'overview'\"><header><ul class=\"nav nav-tabs\"><li ng-class=\"{active: selectedTab === 'overview'}\" ng-click=\"selectedTab = 'overview'\"><button translate>Overview</button></li><li ng-class=\"{active: selectedTab === 'preferences'}\" ng-click=\"$parent.selectedTab = 'preferences'\" ng-if=\"profile\"><button translate>Personal preferences</button></li><li ng-class=\"{active: selectedTab === 'privileges'}\" ng-click=\"$parent.selectedTab = 'privileges'\" ng-if=\"privileges.users\"><button translate>Privileges</button></li></ul></header><div class=\"content\"><div sd-user-edit data-user=\"user\" ng-if=\"selectedTab === 'overview'\"></div><div sd-user-preferences data-user=\"user\" ng-if=\"selectedTab === 'preferences'\"></div><div sd-user-privileges data-user=\"user\" ng-if=\"selectedTab === 'privileges' && privileges.users\"></div></div></div></div><div class=\"other-content\"><div sd-user-activity data-user=\"user\"></div></div></section>");
        $templateCache.put('scripts/apps/users/views/list.html', "<div class=\"subnav subnav--absolute\"><h3 class=\"subnav__page-title\" translate>Users</h3><div class=\"subnav__button-stack--square-buttons\" sd-tooltip=\"{{ :: 'Create user' | translate }}\" flow=\"left\"><button class=\"navbtn sd-create-btn\" ng-click=\"createUser()\"></button></div></div><section class=\"main-section users\"><div class=\"preview-layout\" ng-class=\"{closed: !selected.user}\"><div class=\"list-pane\"><div class=\"subnav\"><div sd-searchbar></div><div class=\"button-list button-list--padded\"><button type=\"button\" class=\"toggle-button\" ng-click=\"authorOnlyFilter=!authorOnlyFilter\" ng-class=\"{'toggle-button--active': !authorOnlyFilter}\">{{:: 'All user types' | translate}}</button> <button type=\"button\" class=\"toggle-button\" ng-click=\"authorOnlyFilter=!authorOnlyFilter\" ng-class=\"{'toggle-button--active': authorOnlyFilter}\">{{:: 'Authors only' | translate}}</button></div><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:100px; margin:0 40px\"><select id=\"user-filter\" class=\"sd-line-input__select\" ng-model=\"userFilter\" ng-options=\"filter.id as filter.label | translate for filter in filterOptions\"></select></div><div class=\"subnav__element-grow\"></div><div sd-pagination data-items=\"users\" class=\"pull-right\"></div></div><div class=\"content\"><div sd-shadow><div class=\"alert alert-error\" ng-if=\"noRolesWarning\" translate>No user roles defined!</div><div class=\"users-table\"><ul class=\"table-header\"><li><div class=\"row-wrapper\"><div class=\"name\" sd-sort data-label=\"{{ 'Full name' | translate }}\" data-field=\"full_name\"></div><div class=\"username\" sd-sort data-label=\"{{ 'Username' | translate }}\" data-field=\"username\"></div><div class=\"role\" translate>Role</div><div class=\"email\" sd-sort data-label=\"{{ 'Email' | translate }}\" data-field=\"email\"></div><div class=\"created\" sd-sort data-label=\"{{ 'Created' | translate }}\" data-field=\"_created\"></div></div></li></ul><div class=\"table-title\" ng-show=\"createdUsers.length\" translate>Recently added</div><ul class=\"table-newest\" sd-user-list data-roles=\"roles\" data-users=\"createdUsers\" data-selected=\"selected.user\" data-done=\"afterDelete\" ng-if=\"createdUsers.length\"></ul><ul class=\"table-body\" sd-user-list data-roles=\"roles\" data-users=\"users._items\" data-author-only-filter=\"authorOnlyFilter\" data-selected=\"selected.user\" data-done=\"afterDelete\"></ul></div></div></div><div class=\"preview-pane\" ng-if=\"selected.user\"><header><button ng-click=\"intent('detail', 'user', selected.user)\" class=\"btn btn--text-only\" ng-show=\"selected.user._id\" id=\"open-user-profile\" translate>View full profile</button> <button ng-click=\"selected.user = null\" class=\"icn-btn close-preview\"><i class=\"icon-close-small\"></i></button></header><div sd-user-details-pane ng-if=\"selected.user\"><div id=\"user-profile-edit\" sd-user-edit data-user=\"selected.user\" data-onsave=\"render(user)\" data-oncancel=\"closePreview()\"></div></div></div></div></div></section>");
        $templateCache.put('scripts/apps/users/views/mentions-menu.html', "<ul class=\"users-list-embed\"><li mentio-menu-item=\"user\" ng-repeat=\"user in items\"><div ng-if=\"user.type == 'user'\"><figure class=\"avatar small\"><img sd-user-avatar data-user=\"user\" alt=\"user.item.display_name\"></figure><span class=\"name\">{{:: user.item.display_name }}</span></div><div ng-if=\"user.type == 'desk'\"><i class=\"icon-tasks\" title=\"Desk\"></i> <span class=\"name\">{{:: user.item.name }}</span></div></li></ul>");
        $templateCache.put('scripts/apps/users/views/mentions.html', "<mentio-menu class=\"mentio-menu\" mentio-for=\"'mentio-users'\" mentio-trigger-char=\"'@'\" mentio-items=\"users\" mentio-search=\"searchUsersAndDesks(term)\" mentio-select=\"select(item)\" mentio-template-url=\"scripts/apps/users/views/mentions-menu.html\"></mentio-menu>");
        $templateCache.put('scripts/apps/users/views/settings-privileges.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"saveAll(rolesForm)\" ng-disabled=\"!rolesForm.$dirty\" translate>Save</button></div><div class=\"sd-page__content privileges-settings\"><form name=\"rolesForm\"><table class=\"table table--fixed-header\"><thead><tr><th class=\"name\"></th><th ng-repeat=\"role in roles\">{{ :: role.name | translate }} <span class=\"label label--primary\" ng-if=\"role.is_default\" translate>default</span></th><th class=\"blank-field\"></th></tr></thead><tbody><tr ng-repeat=\"p in privileges\"><td class=\"name\">{{ :: p.label | translate }}</td><td ng-repeat=\"role in roles\"><input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"role.privileges[p.name]\"></td><td class=\"blank-field\"></td></tr></tbody></table></form></div></div>");
        $templateCache.put('scripts/apps/users/views/settings-roles.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"edit({})\"><i class=\"icon-plus-sign icon--white\"></i> {{:: 'Add New' | translate}}</button></div><div class=\"sd-page__content user-roles-settings\"><ul class=\"pills-list\"><li ng-repeat=\"role in roles | filter: query\" class=\"clearfix\"><div class=\"header\"><h6>{{role.name}}</h6><span class=\"label label--primary label--hollow\" ng-if=\"role.is_default\" translate>default</span><div class=\"actions\"><button ng-click=\"edit(role)\" title=\"{{:: 'Edit role' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(role)\" title=\"{{:: 'Remove role' | translate }}\"><i class=\"icon-trash\"></i></button></div></div></li><div ng-show=\"!roles.length\" class=\"alert alert-info\" translate>No roles created yet.</div></ul></div><div sd-modal data-model=\"editRole\"><div class=\"modal__header\"><button class=\"modal__close pull-right\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\" ng-show=\"editRole._id\" translate>Edit Role</h3><h3 class=\"modal__heading\" ng-show=\"!editRole._id\" translate>New Role</h3></div><div class=\"modal__body\"><form name=\"roleForm\"><fieldset><div class=\"form__row\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': roleForm.$error.unique}\"><label class=\"sd-line-input__label\">{{ 'Role Name'|translate }}</label><input class=\"sd-line-input__input\" type=\"text\" ng-model=\"editRole.name\" required sd-role-unique><div class=\"sd-line-input__message\" ng-show=\"roleForm.$error.unique\" sd-valid-error translate>Sorry, this role name already exists.</div></div></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\">{{ 'Role Description'|translate }}</label><textarea class=\"sd-line-input__input\" sd-auto-height ng-model=\"editRole.description\"></textarea></div></div><div class=\"form__row\"><sd-check ng-model=\"editRole.is_default\" id=\"is_default\" ng-disabled=\"defaultRole\">{{:: 'Set as default' | translate }}</sd-check></div></fieldset><fieldset><legend translate>Default author roles</legend><div class=\"form__row\" translate>If you select a default role for content creation or editing, Superdesk will prefill the Authors field with user's name and the role. The roles are managed in <b>Author roles</b> controlled vocabulary in the Metadata section.</div><div ng-show=\"!author_roles\" class=\"sd-alert sd-alert--hollow sd-alert--warning\" translate>Author roles controlled vocabullary is missing.</div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Content creation</label><select class=\"sd-line-input__select\" ng-model=\"editRole.author_role\" ng-options=\"role.qcode as role.name for role in author_roles\"><option value=\"\" translate>None</option></select></div></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Content editing</label><select class=\"sd-line-input__select\" ng-model=\"editRole.editor_role\" ng-options=\"role.qcode as role.name for role in author_roles\"><option value=\"\" translate>None</option></select></div></div></fieldset></form></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-click=\"save(editRole)\" ng-disabled=\"!roleForm.$valid || !roleForm.$dirty\" translate>Ok</button></div></div></div>");
        $templateCache.put('scripts/apps/users/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" ng-init=\"rolesTab = true\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>User Roles</h2></div><div class=\"sd-page__header\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: rolesTab}\"><button ng-click=\"rolesTab = true\" translate>Roles</button></li><li ng-class=\"{active: !rolesTab}\"><button ng-click=\"rolesTab = false\" translate>Roles privileges</button></li></ul></div><div class=\"sd-page__flex-helper\" sd-user-roles ng-if=\"rolesTab\"></div><div class=\"sd-page__flex-helper\" sd-roles-privileges ng-if=\"!rolesTab\"></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/users/views/user-details-pane.html', "<div class=\"user-details-pane\" ng-show=\"user\" ng-transclude></div>");
        $templateCache.put('scripts/apps/users/views/user-list-item.html', "<li ng-repeat=\"user in users track by user._id\" ng-click=\"select(user)\" ng-show=\"!authorOnlyFilter || authorOnlyFilter && user.is_author\" ng-class=\"{selected: user._id === selected._id, 'inactive' : !user.is_enabled || !user.is_active}\"><figure class=\"avatar avatar-with-info\" ng-class=\"{'user-logged': isLoggedIn(user)}\"><div class=\"logged-info\"></div><div class=\"user-image\"><img sd-user-avatar data-user=\"user\"></div></figure><i class=\"admin-label icon-settings\" ng-if=\"user.user_type == 'administrator'\" tooltip=\"{{ :: 'admin'|translate}}\" tooltip-placement=\"top\"></i><div class=\"row-wrapper\" sd-col-width><div class=\"name\">{{ user.display_name }} <span class=\"disabled-label\" ng-if=\"!user.is_enabled\" translate>disabled</span> <span class=\"disabled-label\" ng-if=\"user.is_enabled && !user.is_active\" translate>inactive</span> <span class=\"disabled-label\" ng-if=\"user.is_enabled && user.is_active && user.needs_activation\" translate>pending</span></div><div class=\"username\">{{ user.username }}</div><div class=\"role\">{{ roles[user.role].name }}</div><div class=\"email\">{{ user.email }}</div><div class=\"created\">{{ user._created | reldate}}</div></div><div class=\"action\"><ul class=\"item-functions\" sd-activity-list data-item=\"user\" data-type=\"user\" data-action=\"edit\" data-done=\"done\"></ul></div></li><li class=\"alert alert-info\" ng-show=\"users.length == null\"><p translate>Loading...</p></li><li class=\"alert alert-info\" ng-show=\"users.length == 0\"><p translate>Oops! There are no items.</p></li>");
        $templateCache.put('scripts/apps/users/views/user-preferences.html', "<form name=\"userPrefs\"><div class=\"action-bar clearfix\" ng-class=\"{show: userPrefs.$dirty }\"><button class=\"btn btn--primary pull-right\" ng-disabled=\"!userPrefs.$dirty\" ng-click=\"save()\" translate>Save</button> <button class=\"btn pull-right\" ng-click=\"cancel()\" ng-disabled=\"!userPrefs.$dirty\" translate>Cancel</button></div><div class=\"preferences form-flat inner-content\" ng-init=\"val = true\"><ul class=\"simple-list simple-list--comfortable simple-list--dotted simple-list--no-border-b simple-list--no-border-t simple-list--no-padding\"><li class=\"simple-list__item\" ng-repeat=\"(id, p) in preferences track by id\" ng-if=\"showCategory(p)\"><div class=\"user-preferences__heading\">{{ p.category | translate }}</div><div sd-info-item><div class=\"form__row form__row--s-padding\" ng-show=\"id === 'feature:preview' || id === 'singleline:view'\"><span sd-switch ng-hide=\"p.allowed\" ng-model=\"p.enabled\"></span><label class=\"form-label\">{{ :: p.label | translate }}</label></div><span ng-show=\"p.allowed\"><label class=\"form-label\">{{ :: p.label | translate }}</label><div class=\"sd-check__group\"><sd-check ng-repeat=\"i in p.allowed\" ng-model=\"p.view\" label-position=\"inside\" type=\"radio\" data-icon=\"{{getIcon(i)}}\" ng-value=\"{{i}}\">{{ valueLabel(i) }}</sd-check></div></span></div></li><li class=\"simple-list__item\"><div class=\"user-preferences__heading\" translate>Notifications</div><div class=\"form__row form__row--s-padding\" sd-info-item><span ng-hide=\"preferences['email:notification'].allowed\" sd-switch ng-model=\"preferences['email:notification'].enabled\"></span><label>{{ :: preferences['email:notification'].label | translate }}</label></div><div class=\"form__row form__row--s-padding\" sd-info-item><span ng-hide=\"preferences['desktop:notification'].allowed\" sd-switch ng-model=\"preferences['desktop:notification'].enabled\"></span><label>{{ :: preferences['desktop:notification'].label | translate }}</label></div><div class=\"form__row form__row--s-padding\" sd-info-item ng-hide=\"!$root.config.features.slackNotifications\"><span ng-hide=\"preferences['slack:notification'].allowed\" sd-switch ng-model=\"preferences['slack:notification'].enabled\"></span><label>{{ :: preferences['slack:notification'].label | translate }}</label></div></li><li class=\"simple-list__item terms-box\" ng-hide=\"profileConfig.defaults === false\"><div class=\"user-preferences__heading\" translate>Article Defaults</div><div class=\"form-label\">{{ 'Dateline' | translate}} / {{ :: preferences['dateline:located'].label | translate}}</div><div sd-info-item ng-if=\"preferencesLoaded === true\" ng-hide=\"profileConfig.located === false\"><div class=\"form__row\"><span sd-meta-locators data-item=\"preferences['dateline:located']\" data-field=\"located\" data-postprocessing=\"changeDatelinePreview(item, city)\" data-keepinput=\"true\"></span><div sd-info-item class=\"dateline_preview\" ng-hide=\"!datelinePreview\"><span>{{ datelinePreview | previewDateline:datelineSource}}</span></div></div></div><div sd-info-item ng-if=\"preferencesLoaded === true\" ng-hide=\"profileConfig.place === false\"><label class=\"form-label\">{{ :: preferences['article:default:place'].label | translate}}</label><div class=\"form__row form__row--s-padding\"><span sd-meta-dropdown data-item=\"preferences['article:default:place']\" data-field=\"place\" data-list=\"locators\" data-change=\"articleDefaultsChanged(item)\"></span></div></div></li><li class=\"simple-list__item\" ng-hide=\"profileConfig.category === false\"><div class=\"user-preferences__heading\">{{ :: preferences['categories:preferred'].category | translate }}</div><div sd-info-item><label>{{ :: preferences['categories:preferred'].label | translate}}</label><p class=\"discreet\" translate>By selecting the categories you are interested in, the system will only display these in a menu for setting the content item's categories (along with any of its existing categories).</p><div class=\"preferences__actions\"><a ng-click=\"checkAll()\" class=\"preferences__action-link\" title=\"{{:: 'Select all categories' | translate}}\" translate>all</a> <span class=\"preferences__action-spacer\"></span> <a ng-click=\"checkNone()\" class=\"preferences__action-link\" title=\"{{:: 'Clear all selected' | translate}}\" translate>none</a> <span class=\"preferences__action-spacer\"></span> <a ng-click=\"checkDefault()\" class=\"preferences__action-link\" title=\"{{:: 'Select default categories only' | translate}}\" translate>default</a></div><div class=\"sd-check__group\"><span ng-repeat=\"cat in categories track by cat.qcode\"><sd-check ng-model=\"cat.selected\" label-position=\"inside\" id=\"cat_{{::cat.qcode}}\" ng-value=\"{{cat.qcode}}\">{{:: cat.name | translate}}</sd-check></span></div></div></li><li class=\"simple-list__item\" ng-hide=\"profileConfig.desks === false\"><div class=\"user-preferences__heading\">{{ :: preferences['desks:preferred'].category | translate }}</div><div sd-info-item><label>{{ :: preferences['desks:preferred'].label | translate}}</label><p class=\"discreet\" translate>By selecting the desks as your preferred desks, they appear first in the order when sending or publishing items.</p><div class=\"sd-check__group sd-check__group--grid\"><div ng-repeat=\"desk in desks track by desk._id\"><sd-check ng-model=\"desk.selected\" label-position=\"inside\" id=\"{{desk._id}}\" ng-value=\"'{{desk._id}}'\">{{desk.name}}</sd-check></div></div></div></li><li class=\"simple-list__item\" ng-if=\"showPlanning()\"><div class=\"user-preferences__heading\" translate>Planning</div><div sd-info-item><label class=\"form-label\" translate>Default Calendar</label><div class=\"form__row form__row--s-padding\"><span sd-meta-dropdown data-item=\"preferences['planning:calendar'].calendar\" data-list=\"calendars\" data-key=\"qcode\" data-field=\"qcode\" data-change=\"articleDefaultsChanged(item)\"></span></div></div><div sd-info-item><label class=\"form-label\" translate>Default Agenda</label><div class=\"form__row form__row--s-padding\"><span sd-meta-dropdown data-item=\"preferences['planning:agenda'].agenda\" data-list=\"agendas\" data-key=\"name\" data-field=\"name\" data-change=\"articleDefaultsChanged(item)\"></span></div></div><div sd-info-item><label class=\"form-label\" translate>Default Events & Planning Filter</label><div class=\"form__row form__row--s-padding\"><span sd-meta-dropdown data-item=\"preferences['planning:events_planning_filter'].filter\" data-list=\"eventsPlanningFilters\" data-key=\"qcode\" data-field=\"qcode\" data-change=\"articleDefaultsChanged(item)\"></span></div></div></li><li class=\"simple-list__item terms-box\" ng-if=\"profileConfig.desks !== false\"><div class=\"user-preferences__heading\" translate>Preferred values for vocabularies</div><div sd-info-item sd-prefered-cv-items-config ng-model=\"preferences['cvs:preferred_items'].value\"></div></li></ul></div></form>");
        $templateCache.put('scripts/apps/users/views/user-privileges.html', "<form name=\"userPrivileges\"><div class=\"action-bar clearfix\" ng-class=\"{\n" +
            "        show: userPrivileges.$dirty\n" +
            "        }\"><button class=\"btn btn--primary pull-right\" ng-disabled=\"!userPrivileges.$dirty\" ng-click=\"save()\" translate>Save</button> <button class=\"btn pull-right\" ng-click=\"cancel()\" ng-disabled=\"!userPrivileges.$dirty\" translate>Cancel</button></div><div class=\"privileges-settings form-flat inner-content\"><table class=\"table table--fixed-header\"><thead><tr><th class=\"name\"></th><th class=\"td user-field\" translate>User</th><th class=\"td role-field\" translate>Role</th><th class=\"blank-field\"></th></tr></thead><tbody><tr ng-repeat=\"p in privileges track by p.name\"><td class=\"name\">{{ :: p.label | translate }}</td><td><input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"user.privileges[p.name]\" ng-if=\"!role.privileges[p.name]\"> <input type=\"checkbox\" ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"role.privileges[p.name]\" ng-disabled=\"true\" ng-if=\"role.privileges[p.name]\"></td><td><span ng-if=\"role.privileges[p.name]\" class=\"label\">{{:: role.name | translate }}</span></td><td class=\"blank-field\"></td></tr></tbody></table></div></form>");
        $templateCache.put('scripts/apps/vocabularies/views/settings.html', "<sd-settings-view><div class=\"sd-page__main-content\" ng-init=\"tab = 'vocabularies'\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Metadata management</h2></div><div class=\"sd-page__header sd-page__header--white\"><ul class=\"nav nav-tabs\"><li ng-class=\"{active: tab === 'vocabularies'}\"><button ng-click=\"tab = 'vocabularies'\" translate>Vocabularies</button></li><li ng-class=\"{active: tab === 'text-fields'}\"><button ng-click=\"tab = 'text-fields'\" translate>Custom text fields</button></li><li ng-class=\"{active: tab === 'date-fields'}\"><button ng-click=\"tab = 'date-fields'\" translate>Custom date fields</button></li><li ng-class=\"{active: tab === 'embed-fields'}\"><button ng-click=\"tab = 'embed-fields'\" translate>Custom embed fields</button></li><li ng-class=\"{active: tab === 'related-content-fields'}\"><button ng-click=\"tab = 'related-content-fields'\" translate>Related content</button></li><li ng-class=\"{active: tab === 'urls-fields'}\"><button ng-click=\"tab = 'urls-fields'\" translate>URLs</button></li></ul></div><div class=\"sd-page__flex-helper\" sd-vocabulary-config data-tab=\"tab\"></div></div></sd-settings-view>");
        $templateCache.put('scripts/apps/vocabularies/views/vocabulary-config-modal.html', "<form name=\"editForm\"><div sd-modal data-model=\"vocabulary\" class=\"modal--large\"><div class=\"modal__header modal__header--flex\"><h3 class=\"modal__heading\" ng-show=\"vocabulary._id\"><span translate>Edit</span> {{ vocabulary.display_name | translate }}</h3><h3 class=\"modal__heading\" ng-show=\"!vocabulary._id\"><span translate>Create</span></h3><a href=\"\" class=\"icn-btn close-modal\" ng-click=\"cancel()\"><i class=\"icon-close-small\"></i></a></div><div class=\"modal__body\"><ng-form name=\"vocabularyForm\" class=\"vocabularyForm\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': issues._id, 'sd-line-input--required': !vocabulary._id}\" ng-if=\"!vocabulary._links || !matchFieldTypeToTab('vocabularies', vocabulary.field_type)\"><label for=\"cv_id\" class=\"sd-line-input__label\" translate>ID</label><input id=\"cv_id\" class=\"sd-line-input__input\" type=\"text\" ng-model=\"vocabulary._id\" ng-pattern=\"idRegex\" ng-readonly=\"!!vocabulary._links\" required><div class=\"sd-line-input__message\" ng-show=\"issues._id.unique || issues._id.deleted\" translate>ID must be unique.</div><div class=\"sd-line-input__message\" ng-show=\"issues._id.conflict\" translate>ID conflicts with system field.</div><div class=\"sd-line-input__message\" ng-show=\"issues._id.indexOf('regex') >= 0\" translate>ID must contain only letters, digits and characters -, _.</div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--required sd-line-input--boxed sd-line-input--no-margin\"><label for=\"cv_display_name\" class=\"sd-line-input__label\" translate>Name</label><input id=\"cv_display_name\" class=\"sd-line-input__input\" type=\"text\" ng-model=\"vocabulary.display_name\" required></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--no-margin\"><label for=\"cv_description\" class=\"sd-line-input__label\" translate>Description</label><input id=\"cv_description\" class=\"sd-line-input__input\" type=\"text\" ng-model=\"vocabulary.description\"></div></div><div class=\"form__row\"><div class=\"sd-line-input sd-line-input--no-margin sd-line-input--no-label\"><sd-tag-input ng-model=\"vocabulary.tags\" data-max-items=\"1\" data-label=\"{{'Label' | translate}}\" data-items=\"tags\" data-field=\"text\" data-min-length=\"1\" placeholder=\"{{'Type to search or create a new label' | translate}}\" data-freetext=\"false\"></sd-tag-input><div class=\"sd-line-input__message\" translate>Choose existing labels or create new ones by typing. The labels are only used to organize the controlled vocabularies in the list. The CVs are grouped under each label. You can choose only one label.</div></div></div><div class=\"form__row\" ng-if=\"vocabulary.service && vocabulary.field_type === null || vocabulary._id === 'categories'\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': vocabularyForm.$error.min}\"><label for=\"cv_popup_width\" class=\"sd-line-input__label\" translate>Width of the popup window (in pixels)</label><input id=\"cv_popup_width\" class=\"sd-line-input__input\" type=\"number\" min=\"20\" placeholder=\"{{ :: '200 minimum' | translate}}\" ng-model=\"vocabulary.popup_width\"><div class=\"sd-line-input__hint\" translate>Defines the width of the pop-up in the artcle header. A minimal value of 200 is required.</div></div></div><div class=\"form__row\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': vocabularyForm.$error.maxlength}\"><label for=\"cv_helper_text\" class=\"sd-line-input__label\" translate>Helper text</label><input id=\"cv_helper_text\" class=\"sd-line-input__input\" type=\"text\" ng-model=\"vocabulary.helper_text\" ng-maxlength=\"120\"><div class=\"sd-line-input__hint\" translate>This will appear below the field in the Editor.</div><div class=\"sd-line-input__message\" ng-show=\"vocabularyForm.$error.maxlength\" translate>The helper text must not exceed 120 characters.</div></div></div><div class=\"sd-line-input sd-line-input--is-select\" ng-if=\"matchFieldTypeToTab('vocabularies', vocabulary.field_type)\"><label for=\"cv_selection_type\" class=\"sd-line-input__label\" translate>Show to users as</label><select id=\"cv_selection_type\" class=\"sd-line-input__select\" ng-model=\"vocabulary.selection_type\"><option value=\"{{type.id}}\" ng-repeat=\"type in selectionTypes\" translate>{{type.label}}</option></select></div><div class=\"sd-line-input\" ng-if=\"matchFieldTypeToTab('date-fields', vocabulary.field_type)\"><label class=\"sd-line-input__label\" translate>Shortcuts</label><ul class=\"date_shortcuts\"><li ng-repeat=\"shortcut in vocabulary.date_shortcuts\"><div class=\"form__row form__row--flex\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Label</label><input type=\"text\" class=\"sd-line-input__input\" ng-model=\"shortcut.label\"></div><div class=\"sd-line-input date_shortcuts--smaller\"><label class=\"sd-line-input__label\" translate>Value</label><input type=\"number\" min=\"0\" class=\"sd-line-input__input\" ng-model=\"shortcut.value\"></div><div class=\"sd-line-input sd-line-input--is-select\"><select class=\"sd-line-input__select\" ng-model=\"shortcut.term\"><option value=\"days\" translate>days</option><option value=\"weeks\" translate>weeks</option><option value=\"months\" translate>months</option><option value=\"years\" translate>years</option></select></div></div></li></ul></div><div class=\"sd-line-input\" ng-if=\"matchFieldTypeToTab('vocabularies', vocabulary.field_type)\"><sd-check ng-model=\"vocabulary.preffered_items\">{{ :: 'Available in user/desk preferences' | translate }}</sd-check></div><div class=\"form__row\" ng-show=\"matchFieldTypeToTab('text-fields', vocabulary.field_type)\"><sd-check id=\"field-text-single\" ng-model=\"vocabulary.field_options.single\">{{'Single line' | translate}}</sd-check></div><div class=\"form__row\" ng-show=\"matchFieldTypeToTab('related-content-fields', vocabulary.field_type)\"><label for=\"field-media-type\" class=\"form-label form__row-label\" translate>Content Type</label><div class=\"form__row form__row--inner form__row--flex\"><div class=\"form__row-item form__row-item--no-grow\"><select class=\"input-medium\" ng-model=\"vocabulary.field_type\"><option value=\"{{type.id}}\" ng-repeat=\"type in mediaTypes\">{{type.label}}</option></select></div><div class=\"form__row-item form__row-item--no-grow\"><div class=\"form__row\"><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.picture\" data-icon=\"photo\">{{'Image' | translate}}</sd-check><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.video\" data-icon=\"video\">{{'Video' | translate}}</sd-check><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.audio\" data-icon=\"audio\">{{'Audio' | translate}}</sd-check></div><div class=\"form__row\" ng-if=\"vocabulary.field_type === mediaTypes.RELATED_CONTENT.id\"><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.text\" data-icon=\"text\">{{'Text' | translate}}</sd-check><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.preformatted\" data-icon=\"text\">{{'Preformatted' | translate}}</sd-check><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.graphic\" data-icon=\"graphic\">{{'Graphic' | translate}}</sd-check><sd-check name=\"field_type\" ng-model=\"vocabulary.field_options.allowed_types.composite\" data-icon=\"composite\">{{'Composite' | translate}}</sd-check></div></div></div></div><div class=\"form__row\" ng-show=\"matchFieldTypeToTab('related-content-fields', vocabulary.field_type)\"><div class=\"form__row-item\"><span id=\"multiple_items\" sd-switch ng-model=\"vocabulary.field_options.multiple_items.enabled\"></span><label for=\"multiple_items\" translate>Allow Multiple Items</label></div><div class=\"form__row form__row--inner form__row--flex\" ng-show=\"vocabulary.field_options.multiple_items.enabled\"><div class=\"form__row-item form__row-item--no-grow\"><span translate>Max. number of items</span></div><div class=\"form__row-item form__row-item--no-grow\"><input id=\"max_items\" type=\"number\" min=\"0\" max=\"99\" class=\"input-small line-input\" ng-model=\"vocabulary.field_options.multiple_items.max_items\" style=\"width: 60px; text-align: center\"></div></div></div><div class=\"vocabulary-items__wrapper\" ng-if=\"matchFieldTypeToTab('vocabularies', vocabulary.field_type)\"><h3 class=\"sd-line-input__label\" translate>Items</h3><div sd-vocabulary-config-modal-items></div></div><div class=\"vocabulary-items__button-bar\" ng-show=\"matchFieldTypeToTab('vocabularies', vocabulary.field_type)\"><button id=\"add-new-btn\" class=\"btn btn--primary\" ng-click=\"addItem()\"><i class=\"icon-plus-sign\"></i> {{'Add Item' | translate}}</button></div><div ng-if=\"errorMessage\" class=\"sd-line-input sd-line-input--invalid\"><p class=\"sd-line-input__message\">{{ errorMessage }}</p></div></ng-form></div><div class=\"modal__footer\"><button id=\"save-edit-btn\" type=\"submit\" class=\"btn btn--primary pull-right\" ng-click=\"save()\" ng-disabled=\"!editForm.$dirty || editForm.$invalid || !itemsValidation.valid || requireAllowedTypesSelection()\" translate>Save</button> <button id=\"cancel-edit-btn\" type=\"button\" class=\"btn pull-right\" ng-click=\"cancel()\" translate>Cancel</button></div></div></form>");
        $templateCache.put('scripts/apps/vocabularies/views/vocabulary-config.html', "<div class=\"sd-page__flex-helper\"><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.display_name\" data-debounce=\"200\"></sd-search-handler><span class=\"sd-page__element-grow\"></span> <button class=\"btn btn--primary\" ng-click=\"createCustomField('text')\" ng-if=\"tab === 'text-fields'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button> <button class=\"btn btn--primary\" ng-click=\"createCustomField('date')\" ng-if=\"tab === 'date-fields'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button> <button class=\"btn btn--primary\" ng-click=\"createCustomField('media')\" ng-if=\"tab === 'related-content-fields'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button> <button class=\"btn btn--primary\" ng-click=\"createVocabulary()\" ng-if=\"tab === 'vocabularies'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button> <button class=\"btn btn--primary\" ng-click=\"createCustomField('embed')\" ng-if=\"tab === 'embed-fields'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button> <button class=\"btn btn--primary\" ng-click=\"createCustomField('urls')\" ng-if=\"tab === 'urls-fields'\"><i class=\"icon-plus-sign icon--white\"></i> <span translate>Add New</span></button></div><div class=\"sd-page__content\"><div ng-if=\"loading\" class=\"loading-overlay\" ng-class=\"{active: loading}\" style=\"opacity: 0.5\"></div><div ng-repeat=\"tag in tags\" ng-if=\"existsVocabulariesForTag(tag, tab)\"><div class=\"sd-list-header\" ng-if=\"canShowTag(tag, tab)\"><span class=\"sd-list-header__name\">{{tag.text}}</span></div><div class=\"sd-list-item-group sd-list-item-group--space-between-items\" style=\"max-width: 1000px\"><div class=\"sd-list-item sd-shadow--z1\" ng-repeat=\"vocabulary in getVocabulariesForTag(tag, tab) | orderBy:'display_name|translate' | filter: query track by vocabulary._id\"><div class=\"sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border\"><div class=\"sd-list-item__row\"><span class=\"sd-list-item__text-strong sd-list-item__element-rm-10\">{{ vocabulary.display_name | translate }}</span> <span class=\"badge badge--light sd-list-item__element-rm-10\" ng-if=\"tab === 'vocabularies'\">{{ vocabulary.items.length }}</span> <span class=\"sd-overflow-ellipsis\">{{ vocabulary.description | translate }}</span></div></div><div class=\"sd-list-item__action-menu sd-list-item__action-menu--direction-row\"><button ng-click=\"openVocabulary(vocabulary)\" sd-tooltip=\"{{:: 'Edit vocabulary' | translate }}\"><i class=\"icon-pencil\"></i></button> <button ng-click=\"remove(vocabulary)\" ng-if=\"tab !== 'vocabularies'\" sd-tooltip=\"{{:: 'Remove vocabulary' | translate }}\"><i class=\"icon-trash\"></i></button></div></div></div><br></div></div></div><div sd-vocabulary-config-modal ng-if=\"vocabulary\"></div>");
        $templateCache.put('scripts/apps/workspace/content/views/profile-settings.html', "<sd-settings-view><div class=\"sd-page__main-content\"><div class=\"sd-page__header sd-page__header--white\"><h2 class=\"sd-page__page-heading\" translate>Content Profiles</h2></div><div class=\"sd-page__header\"><sd-search-handler ng-model=\"query.label\" data-debounce=\"200\"></sd-search-handler><sd-check ng-model=\"active_only\" label-position=\"inside\" type=\"radio\" style=\"margin-left: 0\">{{:: 'All'| translate}}</sd-check><sd-check ng-model=\"active_only\" ng-value=\"true\" label-position=\"inside\" type=\"radio\" ng-checked=\"true\">{{:: 'Active only'| translate}}</sd-check><span class=\"sd-page__element-grow\"></span> <button id=\"add-new-content-profile\" class=\"btn btn--primary\" ng-click=\"ctrl.toggleCreate()\" data-close=\"cancel()\"><i class=\"icon-plus-sign icon--white\"></i>{{ :: 'Add New' | translate }}</button></div><div class=\"sd-page__content profile-settings desk-settings\"><div class=\"flex-grid box wrap-items small-1 medium-3 large-4 xlarge-6\"><div class=\"flex-item card-box\" ng-repeat=\"type in ctrl.items| orderBy: 'label' | filter: query track by type._id\" ng-class=\"{inactive: !type.enabled}\" ng-show=\"!active_only || (active_only && type.enabled)\"><div class=\"card-box__header\"><div class=\"dropdown\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><ul class=\"dropdown__menu more-activity-menu pull-right\"><li><div class=\"dropdown__menu-label\" translate>Actions</div></li><li class=\"dropdown__menu-divider\"></li><li><button ng-click=\"ctrl.toggleEdit(type)\" title=\"{{:: 'Edit Content Profile' | translate }}\"><i class=\"icon-pencil\"></i>{{:: 'Edit'| translate}}</button></li><li><button ng-click=\"ctrl.delete(type)\" ng-disabled=\"type.is_used\" title=\"{{:: type.is_used ? 'Sorry, but profile is in use.' : 'Remove Content Profile' | translate }}\"><i class=\"icon-trash\"></i>{{:: 'Remove'| translate}}</button></li></ul></div><div class=\"card-box__heading\">{{ type.label}}</div></div><div class=\"card-box__content\"><ul class=\"card-box__content-list\"><li><h4 translate>Status</h4><span ng-show=\"type.enabled\" translate>Active</span> <span ng-hide=\"type.enabled\" translate>Inactive</span></li><li><h4 translate>Updated</h4><span>{{ type._updated | reldate }}</span></li></ul></div></div></div></div></div></sd-settings-view><!-- Create profile modal --><div sd-modal class=\"modal--large\" data-model=\"creating\" data-close=\"ctrl.toggleCreate()\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"ctrl.toggleCreate()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\" translate>Add New Content Profile</h3></div><div class=\"modal__body\"><form name=\"createForm\"><fieldset><div class=\"form__row\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': createForm.label.$error.maxlength}\"><label class=\"sd-line-input__label\" translate>Label</label><input type=\"text\" name=\"label\" class=\"sd-line-input__input\" ng-model=\"new.label\" required ng-maxlength=\"40\"><div class=\"sd-line-input__message\" ng-show=\"createForm.label.$error.maxlength\" translate>Please use less than 40 characters</div></div></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Description</label><input type=\"text\" name=\"description\" class=\"sd-line-input__input\" ng-model=\"new.description\"></div></div></fieldset></form></div><div class=\"modal__footer\"><button id=\"profile-save\" class=\"btn btn--primary\" ng-disabled=\"createForm.$invalid\" ng-click=\"ctrl.save()\" translate>Save &amp; Continue</button> <button class=\"btn\" ng-click=\"ctrl.toggleCreate()\" translate>Cancel</button></div></div><!-- END Create profile modal --><!-- Edit profile modal --><div sd-modal class=\"modal--large\" data-model=\"editing\" data-close=\"ctrl.toggleEdit()\"><div class=\"modal__header\"><a href=\"\" class=\"close\" ng-click=\"ctrl.toggleEdit()\"><i class=\"icon-close-small\"></i></a><h3 class=\"modal__heading\">{{ :: 'Editing' | translate }} \"{{ editing.form.label}}\"</h3></div><div class=\"modal__body\"><form name=\"editForm\"><fieldset ng-init=\"setNgForm(editForm)\"><div class=\"form__row\"><div class=\"sd-line-input\" ng-class=\"{'sd-line-input--invalid': editForm.label.$error.maxlength}\"><label class=\"sd-line-input__label\" translate>Label</label><input type=\"text\" name=\"label\" class=\"sd-line-input__input\" ng-model=\"editing.form.label\" required ng-maxlength=\"40\"><div class=\"sd-line-input__message\" ng-show=\"editForm.label.$error.maxlength\" translate>Please use less than 40 characters</div></div></div><div class=\"form__row\"><div class=\"sd-line-input\"><label class=\"sd-line-input__label\" translate>Description</label><input type=\"text\" name=\"description\" class=\"sd-line-input__input\" ng-model=\"editing.form.description\"></div></div><div class=\"field\"><span ng-model=\"editing.form.enabled\" sd-switch></span><label>{{:: 'Active' | translate }}</label></div><div class=\"field\" ng-if=\"withEditor3\"><span ng-model=\"editing.form.editor.body_html.editor3\" sd-switch></span><label>{{:: 'Editor3' | translate }}</label></div><div class=\"field\" ng-if=\"editing\" ng-controller=\"ContentProfileFields as fields\"><div sd-wizard data-name=\"profile-settings-content-profiles\" data-current-step=\"'header'\" ng-if=\"fields.sections\"><div sd-wizard-step data-title=\"{{ 'Header fields' | translate }}\" data-code=\"header\"><sd-content-schema-editor data-model=\"fields.model\" data-fields=\"fields.fieldsById\" data-enabled=\"fields.sections.header.enabled\" data-available=\"fields.sections.header.available\" data-on-remove=\"fields.remove(key)\" data-on-toggle=\"fields.add(key, dest, position, 'header')\" data-on-order-update=\"fields.reorder(key)\" data-on-drag=\"fields.drag(start, end, key)\"></div><div sd-wizard-step data-title=\"{{ :: 'Content fields' | translate }}\" data-code=\"content\"><sd-content-schema-editor data-model=\"fields.model\" data-fields=\"fields.fieldsById\" data-enabled=\"fields.sections.content.enabled\" data-available=\"fields.sections.content.available\" data-on-remove=\"fields.remove(key)\" data-on-toggle=\"fields.add(key, dest, position, 'content')\" data-on-order-update=\"fields.reorder(key)\" data-on-drag=\"fields.drag(start, end, key)\"></div><div sd-wizard-step data-title=\"{{ :: 'Widgets' | translate }}\" data-code=\"widgets\"><sd-widgets-config initial-widgets-config=\"editing.form.widgets_config\" on-update=\"saveContentProfileWidgetsConfig\"></sd-widgets-config></div></div></div></fieldset></form></div><div class=\"modal__footer\"><button id=\"profile-update\" class=\"btn btn--primary\" ng-disabled=\"editForm.$invalid || !editForm.$dirty\" ng-click=\"ctrl.update()\" translate>Save</button> <button class=\"btn\" ng-click=\"ctrl.toggleEdit()\" translate>Cancel</button></div><!-- END Edit profile modal --></div>");
        $templateCache.put('scripts/apps/workspace/content/views/schema-editor-fields-dropdown.html', "<div class=\"dropdown dropdown--add-more dropdown--add-more__{{ $ctrl.bottom === 'true' ? 'bottom' : 'top' }} dropdown-terms\" dropdown><button class=\"btn btn--primary btn--icon-only-circle\" sd-tooltip=\"{{ :: 'Add Field' | translate }}\" flow=\"right\" ng-click=\"search = ''\" dropdown__toggle><i class=\"icon-plus-large\"></i></button><ul class=\"dropdown__menu nested-menu\"><li class=\"input-term\"><input ng-model=\"search\" type=\"text\" ng-click=\"$event.stopPropagation()\"></li><li class=\"main-list\"><ul><li ng-repeat=\"schema in $ctrl.fields | orderBy: 'name' | filter: search track by schema.key\"><button ng-click=\"$ctrl.onSelect({field: schema})\">{{schema.name | translate}} <span class=\"vocabulary-field-type\" ng-if=\"schema.type\">({{ schema.type }})</span></button></li></ul></li></ul></div>");
        $templateCache.put('scripts/apps/workspace/content/views/schema-editor.html', "<div class=\"schema-editor\" ng-if=\"fields\"><div ng-if=\"schemaKeysOrdering.length < 1\" style=\"display: flex; justify-content: center; margin: 20px 0\"><sd-schema-editor-fields-dropdown fields=\"available\" on-select=\"toggle(field, id, 'before')\"></sd-schema-editor-fields-dropdown></div><ul class=\"pills-list\" sd-sort-content-profiles><li class=\"schema-item\" ng-repeat=\"id in enabled track by id\" data-id=\"{{ id }}\"><sd-schema-editor-fields-dropdown fields=\"available\" on-select=\"toggle(field, id, 'before')\"></sd-schema-editor-fields-dropdown><div class=\"header\"><span class=\"title\">{{ :: model.editor[id].field_name || label(id) | translate}}</span> <button class=\"btn btn--icon-only btn--text-only pull-right remove-item\" ng-click=\"remove(id)\"><i class=\"icon-close-small\"></i></button></div><form><fieldset class=\"fieldset-flex\"><div class=\"field\" ng-if=\"id === 'dateline'\"><label translate>Hide Date</label><div sd-check ng-model=\"model.editor[id].hideDate\"></div></div><div class=\"field\"><label translate>Required</label><div sd-check ng-model=\"model.schema[id].required\" ng-click=\"model.editor[id].required = model.schema[id].required\"></div></div><div class=\"field\"><label translate>Order</label><input class=\"input-small line-input\" placeholder=\"{{ 'Default' | translate }}\" type=\"number\" ng-model=\"model.editor[id].order\" min=\"1\" max=\"99\" ng-change=\"updateOrder(id)\"></div><div class=\"field\" ng-show=\"model.schema[id].type === 'string' || fields[id].field_type === 'text'\"><label translate>Length</label><div class=\"controls\"><span translate>min</span>: <input placeholder=\"{{ :: 'Not set' | translate }}\" type=\"number\" class=\"input-small line-input\" ng-model=\"model.schema[id].minlength\" min=\"0\"> <span translate>max</span>: <input placeholder=\"{{ :: 'Not set' | translate }}\" type=\"number\" class=\"input-small line-input\" ng-model=\"model.schema[id].maxlength\" min=\"0\"> <span class=\"error\" ng-show=\"model.schema[id].minlength > model.schema[id].maxlength && model.schema[id].maxlength\" translate>Min length shouldn't be bigger than max length.</span> <span class=\"error\" ng-show=\"model.schema[id].maxlength === 0\" translate>Max length should be bigger than 0 or empty.</span></div></div><div class=\"field\"><label translate>Width</label><select class=\"dropdown__toggle line-input\" ng-model=\"model.editor[id].sdWidth\"><option value=\"full\" translate>Full</option><option value=\"half\" translate>Half</option><option value=\"quarter\" translate>Quarter</option></select></div><div class=\"field\" ng-if=\"model.schema[id].type === 'string' && !model.editor.body_html.editor3\"><label translate>Clean Pasted HTML</label><div sd-check ng-model=\"model.editor[id].cleanPastedHTML\"></div></div><div class=\"field\" ng-if=\":: hasFormatOptions(id)\"><label translate>Format options</label><div class=\"controls\" ng-if=\"model.editor.body_html.editor3\" sd-multi-select data-item=\"model.editor[id].formatOptions\" data-list=\"formattingOptionsEditor3\" data-change=\"setDirty()\"></div><div class=\"controls\" ng-if=\"!model.editor.body_html.editor3\" sd-multi-select data-item=\"model.editor[id].formatOptions\" data-list=\"formattingOptions\" data-change=\"setDirty()\"></div></div><div class=\"field\" ng-if=\"model.schema[id].type === 'media'\"><label translate>Show Crops</label><div sd-check ng-model=\"model.editor[id].showCrops\"></div></div><div class=\"field\" ng-if=\"model.schema[id].type === 'media' || hasImageSelected(id)\"><label translate>Show Image Title</label><div sd-check ng-model=\"model.editor[id].imageTitle\"></div></div><div class=\"field\" ng-if=\"id === 'sms'\"><label translate>Prefill the field with text from:</label>&nbsp;<select ng-model=\"model.editor[id].sourceField\"><option value=\"\" translate>Abstract</option><option value=\"headline\" translate>Headline</option></select></div></fieldset></form><div ng-if=\"$last\"><sd-schema-editor-fields-dropdown fields=\"available\" on-select=\"toggle(field, id, 'after')\" bottom=\"true\"></sd-schema-editor-fields-dropdown></div></li></ul></div>");
        $templateCache.put('scripts/apps/workspace/content/views/sd-content-create.html', "<ul class=\"dropdown__menu-header\"><li><div class=\"dropdown__menu-label\" translate>Create new item</div></li><li ng-if=\"!defaultTemplate\"><button id=\"create_text_article\" ng-click=\"create()\"><i class=\"icon-plus-sign icon--blue\"></i> {{ :: 'Plain text' | translate }}</button></li><li ng-if=\"defaultTemplate\"><button id=\"create_text_article\" ng-click=\"createFromTemplate(defaultTemplate)\"><i class=\"icon-plus-sign icon--blue\"></i> {{ defaultTemplate.template_name }}</button></li><li ng-if=\"item\"><button id=\"package_item\" ng-click=\"createPackage(item)\"><i class=\"icon-plus-sign icon--blue\"></i> {{ :: 'Package current item' | translate }}</button></li></ul><!-- <li class=\"dropdown__menu-divider\"></li> --><ul class=\"dropdown__menu-body\"><li><div class=\"dropdown__menu-label\" translate>Recent templates</div></li><li ng-repeat=\"template in contentTemplates | orderBy:'template_name'\"><button ng-click=\"createFromTemplate(template)\"><i class=\"icon-plus-sign icon--blue\"></i> {{ :: template.template_name }}</button></li><li ng-hide=\"contentTemplates.length\"><span class=\"dropdown__menu-item--no-link\"><em>No recent templates.</em></span></li><li><button id=\"more_templates\" ng-click=\"flags = {displayTemplateSelect: true}\" translate>More templates...</button></li></ul><!-- <li class=\"dropdown__menu-divider\" ng-if=\"openUpload\"></li> --><ul class=\"dropdown__menu-footer\"><li ng-if=\"canCreatePackage() && !$root.config.features.hideCreatePackage\"><button id=\"create_package\" ng-click=\"createPackage()\"><i class=\"icon-package-plus\"></i> {{ :: 'Create Package' | translate }}</button></li><li ng-if=\"openUpload\"><button ng-click=\"openUpload()\" id=\"start-upload-btn\"><i class=\"icon-upload\"></i> {{ :: 'Upload Media' | translate }}</button></li></ul><div ng-if=\"flags.displayTemplateSelect\" sd-template-select data-select-action=\"createFromTemplate\" data-open=\"flags.displayTemplateSelect\"></div>");
        $templateCache.put('scripts/apps/workspace/views/edit-workspace-modal.html', "<div sd-modal data-model=\"workspace\" data-close=\"cancel()\"><div class=\"modal__header\"><h3 class=\"modal__heading\" ng-hide=\"workspace._id\" translate>Create new Workspace</h3><h3 class=\"modal__heading\" ng-show=\"workspace._id\" translate>Rename Workspace</h3></div><div class=\"modal__body\"><fieldset><div class=\"field\"><label translate>Workspace name</label><input type=\"text\" class=\"fullwidth-input\" ng-class=\"{error: errors.name}\" ng-model=\"workspace.name\" required><div class=\"error\" ng-show=\"errors.name\" translate>Sorry, given workspace name is in use</div></div></fieldset></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" translate>Cancel</button> <button class=\"btn btn--primary\" ng-disabled=\"!workspace.name\" ng-click=\"save()\" translate>Save</button></div></div>");
        $templateCache.put('scripts/apps/workspace/views/workspace-dropdown.html', "<div id=\"workspace-dropdown\" class=\"dropdown navbtn\"><button id=\"selected-desk\" data-toggle=\"dropdown\" class=\"dropdown__toggle {{workspaceType}} pull-left\"><span class=\"name\" ng-if=\"selected.name\">{{ selected.name | uppercase }}</span> <span class=\"name\" ng-if=\"!selected\" translate>Select Workspace</span> <span class=\"name\" ng-if=\"selected && !selected.name && workspaceType\">{{ :: 'Untitled' | translate }}</span> <span class=\"dropdown__caret\"></span></button><ul id=\"select-desk-menu\" class=\"dropdown__menu\" role=\"menu\"><li class=\"dropdown__menu-label\"><div translate>DESKS</div></li><li class=\"desk-item\" ng-repeat=\"desk in desks track by desk._id\" id=\"desk-item-{{ :: desk._id }}\"><button ng-click=\"selectDesk(desk)\" ng-disabled=\"desk._id === selected._id\">{{ :: desk.name }}</button></li><li class=\"desk-item\" ng-show=\"desks.length === 0\"><i class=\"no-desk\">No Desks Assigned</i></li><li class=\"dropdown__menu-label\"><div translate>CUSTOM WORKSPACES</div></li><li class=\"workspace-item\" ng-repeat=\"workspace in wsList track by workspace._id\"><button ng-click=\"selectWorkspace(workspace)\" ng-disabled=\"workspace._id === selected._id\">{{ :: workspace.name }} <span ng-if=\"!workspace.name\">{{ :: 'Untitled' | translate }}</span></button></li><li><button class=\"action-btn\" ng-click=\"createWorkspace()\"><i class=\"icon-plus-sign icon--blue\"></i> <span class=\"circle\"></span> {{ :: 'CREATE NEW WORKSPACE' | translate }}</button></li></ul></div><div sd-edit-workspace data-workspace=\"edited\" data-done=\"afterSave\"></div>");
        $templateCache.put('scripts/apps/workspace/views/workspace-sidenav-items-default.html', "<a class=\"sd-sidebar-menu__btn\" title=\"{{ :: item.label | translate }}\" ng-href=\"#{{ :: item.href }}\" ng-click=\"hideMonitoring(currentRoute.href === item.href, $event)\" sd-hotkey=\"{{ item.shortcut }}\" sd-hotkey-options=\"{global: true}\" ng-class=\"{'sd-sidebar-menu__btn--active': currentRoute.href === item.href}\"><i class=\"sd-sidebar-menu__main-icon big-icon--{{ item.icon }}\"></i> <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i></a>");
        $templateCache.put('scripts/apps/workspace/views/workspace-sidenav-items-hr.html', "<hr>");
        $templateCache.put('scripts/apps/workspace/views/workspace-sidenav-items-html.html', "<a href=\"#{{ :: item.href }}\" ng-click=\"hideMonitoring(currentRoute.href === item.href, $event)\" title=\"{{ :: item.label }}\" sd-hotkey=\"{{ item.hotkey }}\" sd-hotkey-options=\"{global: true}\" class=\"sd-sidebar-menu__btn\" ng-class=\"{'sd-sidebar-menu__btn--active': currentRoute.href === item.href}\"><i class=\"sd-sidebar-menu__main-icon big-icon--{{ item.icon }}\"></i> <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i></a>");
        $templateCache.put('scripts/apps/workspace/views/workspace-sidenav-items.html', "<li ng-repeat=\"item in items track by $index\" ng-class=\"{active: currentRoute.href === item.href}\" ng-include=\"getTemplateUrl(item)\"></li><!-- this should be avoided, not sure where it's used --><li ng-if=\"extraItems.length > 0\"><hr></li><li ng-repeat=\"item in extraItems\" ng-class=\"{active: currentRoute.href === '/' + item.route}\"><a href=\"#/{{ item.route }}\" title=\"{{ item.title }}\" ng-click=\"item.onClick && item.onClick($event)\" class=\"sd-sidebar-menu__btn\"><i class=\"sd-sidebar-menu__main-icon {{ item.iconClass }}\"></i> <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i></a></li>");
        $templateCache.put('scripts/apps/workspace/views/workspace-sidenav.html', "<ul sd-workspace-sidenav ng-class=\"{'authoring-active': superdesk.flags.authoring, 'list-hidden': superdesk.flags.hideMonitoring}\"></ul>");
        $templateCache.put('scripts/core/activity/views/activity-chooser.html', "<div sd-modal ng-if=\"chooser-activities\" data-model=\"chooser.activities\" class=\"activity-choose-modal\"><ul class=\"list-group\" ng-if=\"selected\"><li class=\"list-group-item\" ng-repeat=\"activity in chooser.activities\" ng-click=\"chooser.resolve(activity)\" ng-class=\"{active: activity === selected}\"><a href=\"\">{{ activity.label }}</a></li></ul><div class=\"btn-group\"><button class=\"btn btn--inverse\" ng-click=\"chooser.reject()\"><i class=\"icon-close-small icon--white\"></i> {{ :: 'Cancel' | translate }}</button></div></div>");
        $templateCache.put('scripts/core/activity/views/activity-dropdown-item.html', "<div class=\"dropdown dropdown--noarrow\" ng-class=\"{open: groupDropdownOpen}\" ng-mouseenter=\"groupDropdownOpen = true\" ng-mouseleave=\"groupDropdownOpen = false\" ng-if=\"actions[group]\" dropdown><a class=\"dropdown__toggle\" title=\"{{ :: actions[group][0].groupLabel | translate }}\" dropdown__toggle><i class=\"icon-{{ :: actions[group][0].groupIcon}}\" ng-show=\":: actions[group][0].groupIcon\"></i> <span>{{ :: actions[group][0].groupLabel | translate }}</span></a><ul class=\"dropdown__menu dropdown__menu--submenu-left\"><li ng-repeat=\"activity in actions[group]\" sd-activity-item></li></ul></div>");
        $templateCache.put('scripts/core/activity/views/activity-item.html', "<a title=\"{{ :: activity.label | translate }}\" ng-href=\"{{ :: $root.link(activity._id, item) }}\" ng-if=\":: !activity.dropdown\" ng-click=\"run(activity, $event)\"><i class=\"icon-{{ :: activity.icon }} {{!activity.monitor|| !item.actioning[activity._id] || 'actioning'}}\" ng-show=\":: activity.icon\"></i> <span>{{ :: activity.label | translate }}</span></a><div ng-if=\":: activity.dropdown\" class=\"dropdown dropdown--noarrow\" ng-class=\"{open: dropdownOpen}\" ng-mouseenter=\"dropdownOpen=true\" ng-mouseleave=\"dropdownOpen=false\" dropdown><a class=\"dropdown__toggle\" title=\"{{ :: activity.label | translate }}\" dropdown__toggle><i class=\"icon-{{ :: activity.icon }}\" ng-show=\":: activity.icon\"></i> <span>{{ :: activity.label | translate }}</span></a><ul class=\"dropdown__menu dropdown__menu--submenu-left\"><div ng-include=\"activity.templateUrl\"></div></ul></div>");
        $templateCache.put('scripts/core/activity/views/activity-list.html', "<li class=\"item-field\" ng-repeat=\"activity in activities | limitTo:limit\" sd-activity-item></li><li ng-if=\"activities.length > 6 && !preview\" class=\"item-field\"><div class=\"dropdown dropdown--more-activity\" sd-dropdown-position dropdown><a class=\"dropdown__toggle more-activity-toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></a><ul class=\"dropdown__menu\"><li class=\"item-field\" ng-repeat=\"activity in activities | limitTo:-(activities.length-5)\" sd-activity-item></li></ul></div></li>");
        $templateCache.put('scripts/core/activity/views/activity-modal.html', "<div class=\"modal in {{activity.cssClass}}\" ng-if=\"activity\"><div class=\"modal__dialog\" ng-controller=\"activity.controller\"><div class=\"modal__content\" ng-include=\"activity.templateUrl\"></div></div></div><div class=\"modal__backdrop\" ng-if=\"activity\"></div>");
        $templateCache.put('scripts/core/auth/login-modal.html', "<div class=\"login-screen\" ng-show=\"active\"><div class=\"login-form-container\"><p ng-if=\"identity._id\" class=\"session-error\">{{ 'Your session has expired.'|translate }}<br>{{ 'Please log in again.'|translate }}</p><div class=\"logo-handler\" ng-show=\"!identity.Avatar\"><img src=\"/images/superdesk-logo.svg\" width=\"290\" alt=\"Superdesk Logo\"></div><div class=\"form-handler\" ng-show=\"!changePassword\"><figure class=\"avatar\" style=\"background-image:url('{{ identity.Avatar.href || 'images/avatar_200.png' }}')\" ng-show=\"identity.Avatar\"></figure><form name=\"loginForm\" ng-submit=\"authenticate()\"><fieldset class=\"inputs\"><input type=\"text\" id=\"login-username\" ng-model=\"username\" placeholder=\"{{ 'username'|translate }}\" class=\"fullwidth-input\" ng-disabled=\"identity.Id\" required> <input type=\"password\" id=\"login-password\" ng-model=\"password\" placeholder=\"{{ 'password'|translate }}\" class=\"fullwidth-input login-pass\" required></fieldset><fieldset class=\"buttons\"><button ng-disabled=\"isLoading\" id=\"login-btn\" type=\"submit\" class=\"btn btn--sd-green\">{{ 'Log In' | translate }}<div class=\"spinner\" ng-show=\"isLoading\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div></button></fieldset><fieldset class=\"buttons\" ng-show=\"methods.google\"><button class=\"btn btn--sd-green\" ng-click=\"openLoginPopup('google')\" translate>Log In with Google</button></fieldset><fieldset class=\"buttons\" ng-show=\"methods.saml\"><button class=\"btn btn--sd-green\" ng-click=\"openLoginPopup('saml')\" translate>{{labels.saml}}</button></fieldset></form><a href=\"/#/secure-login/\" class=\"text\" ng-show=\"methods.xmpp\" translate>Secure login</a><div class=\"error-handler\" ng-switch on=\"loginError\"><p class=\"error\" ng-switch-when=\"401\" translate>Oops! Invalid Username or Password.<br>Please try again.</p><p class=\"error\" ng-switch-when=\"403\" translate>Sorry, but your account has been suspended.</p><p class=\"error\" ng-switch-when=\"404\" translate>Sorry, user not found.</p><p class=\"error\" ng-show=\"loginError\" ng-switch-default translate>Sorry, but can't reach the server now.<br>Please try again later.</p><div class=\"network-error red\" ng-show=\"serverStatus == 1\"><span class=\"icon-unplug\"></span><p translate>No server response so far.<br>Let me try again.</p></div><div class=\"network-error yellow\" ng-show=\"serverStatus > 1\"><span class=\"icon-unplug\"></span><p translate>Trying to reconnect...<br>Please wait.</p></div></div><div class=\"links\"><a href=\"\" ng-click=\"logout()\" class=\"text\" ng-show=\"identity.Id\" translate>Sign in as a different user.</a> <a href=\"/#/reset-password/\" class=\"text\" ng-show=\"features.reset_user_password\" translate>Forgot password?</a></div></div><div class=\"form-handler\" ng-show=\"changePassword\"><figure class=\"avatar\" style=\"background-image:url('{{ identity.Avatar.href || 'images/avatar_200.png' }}')\" ng-show=\"identity.Avatar\"></figure><div class=\"error-handler\"><p class=\"error\" translate>Your password has expired. Please change your password.</p></div><form name=\"changePasswordForm\" ng-submit=\"changeUserPassword()\"><fieldset class=\"inputs\"><input type=\"password\" sd-password-strength name=\"password\" ng-model=\"password\" placeholder=\"{{ 'Enter new password'|translate }}\" class=\"fullwidth-input\" required></fieldset><fieldset class=\"inputs\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"passwordConfirm\" placeholder=\"{{ 'Confirm new password'|translate }}\" class=\"fullwidth-input\" sd-password-confirm data-password=\"password\" required> <i ng-show=\"changePasswordForm.passwordConfirm.$error.required\" class=\"required-asteriks\">*</i><div ng-show=\"changePasswordForm.passwordConfirm.$error.confirm\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>passwords must be same</span></div></fieldset><fieldset class=\"buttons\"><button type=\"submit\" ng-disabled=\"isLoading || changePasswordForm.$invalid\" class=\"btn btn--sd-green\">{{ 'Change password' | translate }}<div class=\"spinner\" ng-show=\"isLoading\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div></button></fieldset></form></div></div></div>");
        $templateCache.put('scripts/core/auth/reset-password.html', "<div class=\"login-screen\"><div class=\"login-form-container\"><div class=\"logo-handler\"><img src=\"images/superdesk-logo.svg\" width=\"290\" alt=\"Superdesk Logo\"></div><div class=\"form-handler\"><form name=\"sendTokenForm\" ng-submit=\"sendToken()\" ng-show=\"flowStep == 1\"><p class=\"reset-info\"><i class=\"icon-info-sign icon--white\"></i> <span translate>Provide your email in order to get 'Reset Token'. Once you get it, use it to reset your password.</span></p><fieldset class=\"inputs\"><input type=\"email\" id=\"user-email\" ng-model=\"email\" placeholder=\"{{ 'Email'|translate }}\" class=\"fullwidth-input\" required></fieldset><fieldset class=\"buttons\"><button ng-disabled=\"isSending || sendTokenForm.$invalid\" type=\"submit\" class=\"btn btn--sd-green\">{{ 'Get token' | translate }}<div class=\"spinner\" ng-show=\"isSending\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div></button></fieldset></form><div class=\"error-handler\" ng-switch on=\"sendTokenError\"><p class=\"error\" ng-switch-when=\"400\" translate>Oops! Invalid user Email.<br>Please try again.</p><p class=\"error\" ng-switch-when=\"403\" translate>Sorry, but your account has been suspended.</p><p class=\"error\" ng-show=\"sendTokenError\" ng-switch-default translate>Sorry, but can't reach the server now.<br>Please try again later.</p><div class=\"network-error red\" ng-show=\"serverStatus == 1\"><span class=\"icon-unplug\"></span><p translate>No server response so far.<br>Let me try again.</p></div><div class=\"network-error yellow\" ng-show=\"serverStatus > 1\"><span class=\"icon-unplug\"></span><p translate>Trying to reconnect...<br>Please wait.</p></div></div><div ng-show=\"flowStep == 2\"><p class=\"reset-info\"><i class=\"icon-info-sign icon--white\"></i> <span translate>A link was sent to the specified email address. Please use it to reset your password. It is valid a limited amount of time.</span></p></div><form name=\"resetForm\" ng-submit=\"resetPassword()\" ng-show=\"flowStep == 3\"><fieldset class=\"inputs\"><input type=\"password\" sd-password-strength name=\"password\" ng-model=\"password\" placeholder=\"{{ 'Enter new password'|translate }}\" class=\"fullwidth-input\" required></fieldset><fieldset class=\"inputs\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"passwordConfirm\" placeholder=\"{{ 'Confirm new password'|translate }}\" class=\"fullwidth-input\" sd-password-confirm data-password=\"password\" required> <i ng-show=\"userForm.passwordConfirm.$error.required\" class=\"required-asteriks\">*</i><div ng-show=\"resetForm.passwordConfirm.$error.confirm\" sd-valid-info><i class=\"icon-info-sign-warning\"></i> <span translate>passwords must be same</span></div></fieldset><fieldset class=\"buttons\"><button ng-disabled=\"isReseting || resetForm.$invalid\" type=\"submit\" class=\"btn btn--sd-green\">{{ 'Reset password' | translate }}<div class=\"spinner\" ng-show=\"isReseting\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div></button></fieldset></form><div class=\"links\"><a href=\"/#/\" class=\"text\" translate>Have password? Sign in.</a> <a href=\"\" ng-click=\"flowStep = 1\" class=\"text\" ng-show=\"flowStep === 2\" translate>Don't have token? Get it.</a></div><div class=\"error-handler\" ng-switch on=\"setPasswordError\"><p class=\"error\" ng-switch-when=\"400\" translate>The activation token is not valid.<br></p><p class=\"error\" ng-switch-when=\"403\" translate>Sorry, but your account has been suspended.</p><p class=\"error\" ng-show=\"setPasswordError\" ng-switch-default translate>Sorry, but can't reach the server now.<br>Please try again later.</p><div class=\"network-error red\" ng-show=\"serverStatus == 1\"><span class=\"icon-unplug\"></span><p translate>No server response so far.<br>Let me try again.</p></div><div class=\"network-error yellow\" ng-show=\"serverStatus > 1\"><span class=\"icon-unplug\"></span><p translate>Trying to reconnect...<br>Please wait.</p></div></div></div></div></div>");
        $templateCache.put('scripts/core/auth/secure-login.html', "<div class=\"login-screen\"><div class=\"login-form-container\"><div class=\"logo-handler\"><img src=\"images/superdesk-logo.svg\" width=\"290\" alt=\"Superdesk Logo\"></div><div class=\"form-handler\"><form name=\"xmppLoginForm\" ng-submit=\"authenticateXMPP()\"><fieldset class=\"inputs\"><input type=\"text\" id=\"jid\" ng-model=\"jid\" placeholder=\"JID\" class=\"fullwidth-input\" required> <input type=\"hidden\" id=\"transactionId\" ng-model=\"transactionId\" required></fieldset><p class=\"text\" translate>Please check that the following id is the same as on your device:</p><p class=\"transition-id\">{{transactionId}}</p><fieldset class=\"buttons\"><button ng-disabled=\"isLoading\" id=\"login-btn\" type=\"submit\" class=\"btn btn--sd-green\">{{ 'Secure Log In' | translate }}<div class=\"spinner\" ng-show=\"isLoading\"><div class=\"dot1\"></div><div class=\"dot2\"></div></div></button></fieldset></form><div class=\"error-handler\" ng-switch on=\"loginError\"><p class=\"error\" ng-switch-when=\"401\" translate>Oops! Authentication has been denied.</p><p class=\"error\" ng-switch-when=\"403\" translate>Sorry, but your account has been suspended.</p><p class=\"error\" ng-show=\"loginError\" ng-switch-default translate>Sorry, but can't reach the server now.<br>Please try again later.</p><div class=\"network-error red\" ng-show=\"serverStatus == 1\"><span class=\"icon-unplug\"></span><p translate>No server response so far.<br>Let me try again.</p></div><div class=\"network-error yellow\" ng-show=\"serverStatus > 1\"><span class=\"icon-unplug\"></span><p translate>Trying to reconnect...<br>Please wait.</p></div></div></div></div></div>");
        $templateCache.put('scripts/core/directives/views/phone-home-modal-directive.html', "<div sd-modal data-model=\"phone.enabled\" data-close=\"phone.close()\" class=\"modal-big\"><div class=\"modal__header\"><button class=\"close\" ng-click=\"phone.close()\"><i class=\"icon-close-small\"></i></button><h3 class=\"modal__heading\" translate>Welcome to Superdesk</h3></div><div class=\"modal__body\"><p translate>Before you start using your new newsroom, please tell us a little about yourself:</p><!-- Begin MailChimp Signup Form --><div id=\"mc_embed_signup\" ng-show=\"!phone.done\"><form action=\"//sourcefabric.us2.list-manage.com/subscribe/post?u=6b1ad01fc31dc6604968e6439&amp;id=d915449cb0\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"phoneForm\" class=\"validate\" target=\"_blank\" novalidate ng-submit=\"phone.submit()\"><fieldset id=\"mc_embed_signup_scroll\"><div class=\"field\"><label for=\"mce-EMAIL\">{{ :: 'Email Address' | translate }} <span class=\"asterisk\">*</span></label><input type=\"email\" ng-model=\"email\" name=\"EMAIL\" class=\"required email\" id=\"mce-EMAIL\" ng-required=\"required\"></div><div class=\"field\"><label for=\"mce-FNAME\">{{ :: 'First Name' | translate }} <span class=\"asterisk\">*</span></label><input type=\"text\" ng-model=\"firstName\" name=\"FNAME\" class=\"required\" id=\"mce-FNAME\" ng-required=\"required\"></div><div class=\"field\"><label for=\"mce-LNAME\">{{ :: 'Last Name' | translate }} <span class=\"asterisk\">*</span></label><input type=\"text\" ng-model=\"lastName\" name=\"LNAME\" class=\"required\" id=\"mce-LNAME\" ng-required=\"required\"></div><div class=\"field\"><label for=\"mce-MMERGE3\">{{ :: 'Company/Organisation' | translate }} <span class=\"asterisk\">*</span></label><input type=\"text\" ng-model=\"org\" name=\"MMERGE3\" class=\"required\" id=\"mce-MMERGE3\" ng-required=\"required\"></div><div id=\"mce-responses\" class=\"clear\"><div class=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" style=\"display:none\"></div></div><!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--><div style=\"position: absolute; left: -5000px\" aria-hidden=\"true\"><input type=\"text\" name=\"b_6b1ad01fc31dc6604968e6439_d915449cb0\" tabindex=\"-1\" value=\"\"></div><div class=\"field\"><button type=\"submit\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"btn btn--primary\" ng-disabled=\"phoneForm.$invalid\" translate>Send</button> <button type=\"button\" class=\"btn\" ng-click=\"phone.submit()\" translate>Skip</button></div></fieldset></form></div><!--End mc_embed_signup--><p translate>We will send occasional updates on Superdesk developments to the email address you have provided. Your data will be kept secure and it won't be used for any other purpose. You may opt-out of receiving further email communications at any time.</p><p translate>Learn more about Superdesk at <a href=\"https://www.superdesk.org/\" title=\"Superdesk\" target=\"_blank\">www.superdesk.org</a>. For help and support, join the discussion on <a href=\"https://forum.sourcefabric.org/categories/superdesk-dev\" title=\"Superdesk forum\" target=\"_blank\">Superdesk forums</a>.</p><p translate>The Superdesk project is developed and maintained on <a href=\"https://github.com/superdesk\" title=\"Superdesk GitHub\" target=\"_blank\">GitHub</a> by <a href=\"https://www.sourcefabric.org/\" title=\"Sourcefabric\" target=\"_blank\">Sourcefabric</a>.</p></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"phone.close()\">Close</button></div></div>");
        $templateCache.put('scripts/core/editor2/views/add-content.html', "<div ng-show=\"vm.config.embeds\" class=\"add-content\" ng-class=\"{'add-content--expanded': vm.expanded}\"><button class=\"add-content__plus-btn dropdown__toggle sd-create-btn\" ng-click=\"$event.preventDefault(); vm.toogleExpand()\"><i class=\"svg-icon-plus\"></i> <span class=\"circle\"></span></button><div class=\"add-content__actions\" ng-show=\"vm.expanded\"><span ng-click=\"vm.triggerAction('addEmbed')\" sd-tooltip=\"{{ :: 'add an embed' | translate }}\" flow=\"right\"><i class=\"icon-code\"></i> </span><span ng-click=\"vm.triggerAction('addPicture')\" sd-tooltip=\"{{ :: 'add a picture' | translate }}\" flow=\"right\"><i class=\"icon-photo\"></i> </span><span ng-click=\"vm.triggerAction('pasteBlock')\" sd-tooltip=\"{{ :: 'paste a block' | translate }}\" flow=\"right\" ng-if=\"vm.isSomethingInClipboard()\"><i class=\"icon-paste\"></i></span></div></div>");
        $templateCache.put('scripts/core/editor2/views/add-embed.html', "<div class=\"add-embed__body\" ng-if=\"vm.extended\"><form class=\"form-inline\"><div class=\"form-group add-embed__input\"><input type=\"text\" class=\"line-input\" placeholder=\"Paste url or embed code\" ng-change=\"vm.updatePreview()\" ng-model=\"vm.input\"></div><div class=\"form-group add-embed__actions\"><button type=\"reset\" class=\"btn btn--small\" ng-click=\"vm.closeEmbed()\"><i class=\"icon-close-small\"></i></button> <button type=\"submit\" class=\"btn btn--small btn--primary\" ng-click=\"vm.createBlockFromEmbed()\"><i class=\"icon--white icon-ok\"></i></button></div><div ng-if=\"vm.previewLoading\">{{:: 'loading' | translate }} ...</div><div class=\"preview\"></div></form></div>");
        $templateCache.put('scripts/core/editor2/views/block-embed.html', "<div class=\"editor\" ng-show=\"vm.editable\"><textarea ng-model=\"vm.embedCode\" class=\"editor--embed\"></textarea><a class=\"btn btn--small\" ng-click=\"vm.cancel(); vm.toggleEdition()\" translate>Cancel</a> <a class=\"btn btn--small\" ng-click=\"vm.saveEmbedCode(); vm.toggleEdition()\" translate>Save</a></div><div class=\"preview\" ng-show=\"!vm.editable\"><div class=\"preview--embed\" ng-click=\"vm.model.association && vm.isEditable(vm.model.association) && vm.editPicture(vm.model.association)\" ng-class=\"{'preview--embed--loading': vm.model.loading}\" sd-html-preview=\"vm.model.body\"></div><!-- TODO: find a new design for that --><!-- <a class=\"btn btn--small\" ng-click=\"vm.toggleEdition()\" translate>Edit the code</a> --></div><div class=\"editor--caption\"><textarea sd-remove-tags sd-auto-height tansa-scope-sync ng-if=\"vm.config.imageTitle\" placeholder=\"{{::'Title'|translate}}\" ng-model=\"vm.title\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.saveCaption(vm.caption, vm.title)\" ng-paste=\"vm.handlePaste($event)\" class=\"image-caption line-input\">\n" +
            "    </textarea><textarea sd-remove-tags sd-auto-height tansa-scope-sync placeholder=\"{{::'Description'|translate}}\" ng-model=\"vm.caption\" ng-model-options=\"{debounce: 1000}\" ng-change=\"vm.saveCaption(vm.caption, vm.title)\" ng-paste=\"vm.handlePaste($event)\" class=\"image-caption line-input\">\n" +
            "    </textarea></div>");
        $templateCache.put('scripts/core/editor2/views/block-text.html', "<div class=\"dropdown\" dropdown data-is-open=\"openDropdown\"><sd-add-content ng-if=\"config.multiBlockEdition\" class=\"text-editor__add-content\"></sd-add-content><pre class=\"text-editor editor-type-text\" ng-show=\"type=='preformatted'\" spellcheck=\"false\">\n" +
            "    </pre><!-- Placeholder text is temporary, ideally it should come from content type --><div class=\"text-editor editor-type-html\" tabindex=\"{{config.tabindex}}\" sd-text-editor-drop-zone=\"{{config.imageDragging !== false}}\" sd-focus-element data-append-element=\".field\" data-append-class=\"active\" placeholder=\"{{ ::'Add content here' | translate }}\" ng-show=\"type=='text' || !type\" spellcheck=\"false\"></div><code class=\"text-editor-info\" ng-if=\"cursor.line && type == 'preformatted'\"><small translate>Line: {{cursor.line}}, Column: {{cursor.column}}</small></code><ul class=\"dropdown__menu dropdown__menu--suggestions\"><li ng-repeat=\"word in suggestions\"><button ng-click=\"replace(word.key)\">{{ :: word.value }}</button></li><li ng-show=\"suggestions.length === 0\"><button translate>SORRY, NO SUGGESTIONS.</button></li><li class=\"dropdown__menu-divider\"></li><li><button ng-click=\"addWordToDictionary()\" translate>Add to dictionary</button></li><li><button ng-click=\"ignoreWord()\" translate>Ignore word</button></li></ul></div>");
        $templateCache.put('scripts/core/editor2/views/editor.html', "<div ng-repeat=\"block in vm.blocks\" class=\"block__container\" ng-class=\"{'block--not-alone-and-empty': vm.blocks.length > 1 && !block.body}\"><div class=\"block__actions\" ng-if=\"vm.config.multiBlockEdition && vm.configuration.embeds\"><div class=\"block__cut\" ng-click=\"vm.cutBlock(block)\"><i class=\"icon-cut\"></i></div><div class=\"block__remove\" ng-click=\"vm.removeBlock(block)\"><i class=\"icon-close-small\"></i></div></div><sd-add-embed ng-if=\"vm.config.multiBlockEdition && $first\" add-to-position=\"$index\" class=\"block__add-embed\"></sd-add-embed><div ng-switch=\"block.blockType\"><div ng-switch-when=\"embed\" sd-text-editor-block-embed=\"block\" config=\"vm.config\" on-block-change=\"vm.commitChanges()\"></div><div ng-switch-when=\"text\" sd-text-editor-block-text=\"block\" tansa-scope-sync type=\"vm.type\" config=\"vm.config\" language=\"vm.language\" ng-change=\"vm.commitChanges()\" ng-model-options=\"{debounce: 100}\" ng-model=\"block.body\"></div></div><sd-add-embed ng-if=\"vm.config.multiBlockEdition\" extended=\"block.lowerAddEmbedIsExtended\" add-to-position=\"$index + 1\" on-close=\"vm.renderBlocks()\" class=\"block__add-embed\"></sd-add-embed></div>");
        $templateCache.put('scripts/core/editor3/helpers/htmlComesFromDraftjsEditor.snapshot.input.html', "<meta http-equiv=\"content-type\" content=\"text/html; charset=utf-8\"><span class=\"word-typo\" style=\"box-sizing: border-box; border-bottom: 1px dotted red; position: relative; color: rgb(51, 51, 51); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 300; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: pre-wrap; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-style: initial; text-decoration-color: initial\"><span data-offset-key=\"iii9-0-0\" style=\"box-sizing: border-box\"><span data-text=\"true\" style=\"box-sizing: border-box\">Hello</span></span></span><span class=\"space-component\" style=\"box-sizing: border-box; color: rgb(51, 51, 51); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 300; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: pre-wrap; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-style: initial; text-decoration-color: initial\"><span data-offset-key=\"iii9-1-0\" style=\"box-sizing: border-box\"><span data-text=\"true\" style=\"box-sizing: border-box\"> </span></span></span><span class=\"word-typo\" style=\"box-sizing: border-box; border-bottom: 1px dotted red; position: relative; color: rgb(51, 51, 51); font-family: Roboto, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 300; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; white-space: pre-wrap; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; background-color: rgb(255, 255, 255); text-decoration-style: initial; text-decoration-color: initial\"><span data-offset-key=\"iii9-2-0\" style=\"box-sizing: border-box; vertical-align: super; font-size: smaller\"><span data-text=\"true\" style=\"box-sizing: border-box\">world</span></span></span>");
        $templateCache.put('scripts/core/editor3/html/tests/from-html-spec.snapshot.html', "<meta http-equiv=\"content-type\" content=\"text/html; charset=utf-8\"><meta charset=\"utf-8\"><b style=\"font-weight:normal\" id=\"docs-internal-guid-fa8638e2-bbc8-09b4-2745-1b3f082ff04f\"><h1 dir=\"ltr\" style=\"line-height:1.38;margin-top:20pt;margin-bottom:6pt\"><span style=\"font-size:20pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">A document for testing pasting WYSIWYG content from Google Docs</span></h1><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">This document can found </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">An image below</span></p><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\"></span></p><br><br><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">A table below</span></p><div dir=\"ltr\" style=\"margin-left:0pt\"><table style=\"border:none;border-collapse:collapse;width:468pt\"><colgroup><col width=\"*\"><col width=\"*\"><col width=\"*\"></colgroup><tbody><tr style=\"height:0pt\"><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">7</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">8</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">9</span></p></td></tr><tr style=\"height:0pt\"><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">4</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">5</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">6</span></p></td></tr><tr style=\"height:0pt\"><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">1</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">2</span></p></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.2;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">3</span></p></td></tr><tr style=\"height:0pt\"><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p><br></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p><br></td><td style=\"border-left:solid #000000 1pt;border-right:solid #000000 1pt;border-bottom:solid #000000 1pt;border-top:solid #000000 1pt;vertical-align:top;padding:5pt 5pt 5pt 5pt\"><br></td></tr></tbody></table></div><br><br><br><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Unordered nested lists</span></p><br><ul style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">First level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li><li dir=\"ltr\" style=\"list-style-type:disc;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here comes some nesting</span></p></li><ul style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:circle;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Second level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:circle;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:circle;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:circle;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:circle;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li><ul style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:square;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Third level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:square;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:square;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:square;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:square;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li></ul></ul></ul><br><br><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Ordered nested lists</span></p><br><ol style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">First level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here comes some nesting</span></p></li><ol style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Second level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li><ol style=\"margin-top:0pt;margin-bottom:0pt\"><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Third level item</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Link to the document again </span><a href=\"https://docs.google.com/document/d/1C0y0RFMcoJpNV1G6i1HPStzhadHy4JoOxKfVZdt4nkw/edit?usp=sharing\" style=\"text-decoration:none\"><span style=\"font-size:11pt;font-family:Arial;color:#1155cc;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">here</span></a><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">.</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Test for the same styles as above</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Bold</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">italic</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">underline</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">subscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">superscript</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">, </span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">strikethrough</span></p></li><li dir=\"ltr\" style=\"list-style-type:decimal;font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre\"><p dir=\"ltr\" style=\"line-height:1.38;margin-top:0pt;margin-bottom:0pt\"><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Here’s a sen</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ten</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">ce w</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:italic;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">it</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">h ove</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:underline line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">rlap</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">p</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:line-through;-webkit-text-decoration-skip:none;text-decoration-skip-ink:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\">ing</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:sub;white-space:pre;white-space:pre-wrap\"> sty</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">l</span><span style=\"font-size:6.6pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:super;white-space:pre;white-space:pre-wrap\">e</span><span style=\"font-size:11pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:700;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">s</span></p></li></ol></ol></ol><br><h1 dir=\"ltr\" style=\"line-height:1.38;margin-top:20pt;margin-bottom:6pt\"><span style=\"font-size:20pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Headling 1</span></h1><h2 dir=\"ltr\" style=\"line-height:1.38;margin-top:18pt;margin-bottom:6pt\"><span style=\"font-size:16pt;font-family:Arial;color:#000000;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Heading 2</span></h2><h3 dir=\"ltr\" style=\"line-height:1.38;margin-top:16pt;margin-bottom:4pt\"><span style=\"font-size:13.999999999999998pt;font-family:Arial;color:#434343;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Heading 3</span></h3><h4 dir=\"ltr\" style=\"line-height:1.38;margin-top:14pt;margin-bottom:4pt\"><span style=\"font-size:12pt;font-family:Arial;color:#666666;background-color:transparent;font-weight:400;font-style:normal;font-variant:normal;text-decoration:none;vertical-align:baseline;white-space:pre;white-space:pre-wrap\">Heading 4</span></h4></b>");
        $templateCache.put('scripts/core/form/views/checkbox-directive.html', "<div class=\"form__row\"><sd-check ng-model=\"model\">{{ label }}</sd-check></div>");
        $templateCache.put('scripts/core/form/views/input-directive.html', "<div class=\"sd-line-input\" ng-class=\"{\n" +
            "        'sd-line-input--required': required,\n" +
            "        'sd-line-input--invalid': ngModel.$touched && ngModel.$invalid,\n" +
            "    }\"><label for=\"{{ id }}\" class=\"sd-line-input__label\">{{ label }}</label><input id=\"{{ id }}\" type=\"{{ type || 'text' }}\" class=\"sd-line-iput__input\" ng-model=\"model\" ng-required=\"required\" placeholder=\"{{ placeholder }}\"></div>");
        $templateCache.put('scripts/core/form/views/select-directive.html', "<div class=\"sd-line-input sd-line-input--is-select\" ng-class=\"{\n" +
            "        'sd-line-input--required': required,\n" +
            "        'sd-line-input--invalid': ngModel.$touched && ngModel.$invalid,\n" +
            "    }\"><label class=\"sd-line-input__label\">{{ label }}</label><select class=\"sd-line-input__select\" ng-model=\"model\" ng-options=\"option[optionValue] as option[optionLabel] for option in options\" ng-required=\"required\"></select></div>");
        $templateCache.put('scripts/core/form/views/switch-inverted-directive.html', "<div class=\"form__row\"><span ng-model=\"model\" sd-switch-inverted if=\"{{ id }}\"></span><label for=\"{{ id }}\">{{ label }}</label></div>");
        $templateCache.put('scripts/core/itemList/views/relatedItem-list-widget.html', "<div class=\"main-list\" ng-class=\"{wrap: selected, 'existing-items': !options.searchEnabled}\" sd-loading=\"loading\"><div class=\"search-box\" ng-class=\"{blank: related}\" ng-show=\"options.searchEnabled\"><input type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-keypress=\"($event.which === 13)?refresh():null\" ng-model=\"itemListOptions.keyword\"> <button id=\"search-related-items\" type=\"button\" class=\"btn\" ng-click=\"refresh()\" ng-disabled=\"!hasKeywords()\" translate>Search</button></div><div class=\"ingest-list-holder\" ng-class=\"{'mode-detailed': options.mode === 'detailed'}\"><div sd-shadow><ul class=\"ingest-list list-view related-item-list\"><li ng-repeat=\"item in processedItems track by $index\" class=\"list-item-view\" ng-class=\"{'active': item._id === options.item._id}\" ng-if=\"canDisplayItem(item)\"><div class=\"dropdown more-actions pull-right\" ng-if=\"options.searchEnabled\" dropdown><button class=\"dropdown__toggle\" dropdown__toggle><i class=\"icon-dots-vertical\"></i></button><div class=\"dropdown__menu pull-right\"><ul><li ng-repeat=\"action in actions\"><button id=\"{{action.title | translate}}\" ng-if=\"action.condition(item)\" ng-click=\"action.method(item)\">{{ :: action.title | translate }}</button></li></ul></div></div><div class=\"basic item-block\" ng-click=\"view(item)\"><i sd-filetype-icon data-item=\"item\"></i><div class=\"content\"><span class=\"keyword\" ng-if=\"item.slugline\"><span class=\"relate-item-label\" ng-if=\"options.searchEnabled && actions.update && actions.update.condition(item)\" ng-class=\"{'update-item': actions.update && actions.update.condition(item)}\" title=\"{{ :: 'Can be associated as an update' | translate }}\">U</span> <span class=\"relate-item-label\" ng-if=\"options.searchEnabled && actions.addTake && actions.addTake.condition(item)\" ng-class=\"{'take-item': actions.addTake && actions.addTake.condition(item)}\" title=\"{{ :: 'Can be associated as a take' | translate }}\">T</span> {{ item.slugline }}</span> <span class=\"headline\">{{item.headline || item.type}}</span> <span class=\"takekey\">{{item.anpa_take_key}}</span> <time sd-datetime data-date=\"item.versioncreated\"></time> <span ng-if=\"item.takes && item.takes.sequence > 1\" class=\"state-label takes\" translate>Takes</span> <span class=\"state-label state-{{item.state}}\" translate>{{item.state | removeLodash}}</span> <span ng-if=\"item.flags.marked_for_legal\" class=\"state-label legal\" translate>Legal</span> <span ng-if=\"item.flags.marked_for_sms\" class=\"state-label sms\" translate>Sms</span> <span ng-if=\"item.rewritten_by\" class=\"state-label updated\" translate>Updated</span> <span class=\"headline\"><span ng-if=\"item.task.desk\">{{ :: 'desk:' | translate }} {{deskName(item)}}</span> <span ng-if=\"item.task.stage\" class=\"pull-right\">{{ :: 'stage:' | translate }} {{deskStage(item)}}</span> <span class=\"headline\" ng-show=\"item.genre  && item.genre.length > 0\">{{ :: 'genre:' | translate }} {{ item.genre | mergeWords:'name'}}</span></span></div><div sd-item-actions-menu data-item=\"item\" data-active=\"item\" ng-if=\"!options.searchEnabled\"></div></div></li></ul></div></div></div><div class=\"preview\" ng-class=\"{wrap: !selected}\" ng-show=\"selected\"><div class=\"nav\"><button class=\"backlink\" href=\"\" ng-click=\"view(null)\" translate>Back</button></div><div class=\"content-item-preview\"><div class=\"content\"><div sd-media-preview-widget data-item=\"selected\"></div></div></div></div>");
        $templateCache.put('scripts/core/keyboard/views/keyboard-modal.html', "<div sd-modal data-model=\"enabled\" class=\"modal--large\"><div class=\"modal__header\"><h3 class=\"modal__heading\" translate>Keyboard Shortcuts</h3></div><div class=\"modal__body\"><section ng-repeat=\"(group, items) in data\" class=\"keyboard-map\"><h4>{{group}}</h4><ul><li ng-repeat=\"(label, description) in items\"><span class=\"keyboard-map__description\">{{description}}</span> <span class=\"keyboard-map__shortcut\">{{label}}</span></li></ul></section></div><div class=\"modal__footer\"><p>&nbsp;</p></div></div>");
        $templateCache.put('scripts/core/list/views/list-view.html', "<ul class=\"list-view\"><li class=\"panel alert alert-info\" ng-show=\"!items\"><p translate>Loading...</p></li><li class=\"panel alert alert-info\" ng-show=\"items.length == 0\"><p translate>Oops! There are no items.</p></li><li class=\"list-item-view\" ng-repeat=\"item in items track by (item._id + item._type) || $index\" ng-click=\"clickItem(item, $event)\" ng-class=\"{active: item._id === selected._id}\"><div class=\"panel-body\" sd-list-item data-item=\"item\"></div></li></ul>");
        $templateCache.put('scripts/core/list/views/sdPagination.html', "<div class=\"sd-pagination\" ng-if=\"total\"><span class=\"page-info\" translate>Page Size:</span><div class=\"page-info\"><!-- <select class=\"line-input\" ng-model=\"limit\" ng-options=\"item for item in pgsizes\" ng-change=\"setLimit(limit)\"></select> --><div class=\"sd-line-input sd-line-input--is-select sd-line-input--no-label sd-line-input--no-margin\" style=\"min-width:50px\"><select class=\"sd-line-input__select\" ng-model=\"limit\" ng-options=\"item for item in pgsizes\" ng-change=\"setLimit(limit)\"></select></div></div><em class=\"page-info\" ng-show=\"page <= lastPage\">{{from}}-{{to}} {{'of'|translate }} {{total}}</em><div class=\"btn-group\"><button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"setPage(0)\"><i class=\"icon-backward-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"setPage(page - 1)\"><i class=\"icon-chevron-left-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page >= lastPage\" ng-click=\"setPage(page + 1)\"><i class=\"icon-chevron-right-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page >= lastPage\" ng-click=\"setPage(lastPage)\"><i class=\"icon-forward-thin\"></i></button></div></div>");
        $templateCache.put('scripts/core/list/views/sdPaginationAlt.html', "<div class=\"sd-pagination\"><em class=\"page-info\" ng-show=\"page <= maxPage\">{{'Page' | translate}} {{page}} {{'of' | translate}} {{maxPage}}</em><div class=\"btn-group\"><button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"page = 1\"><i class=\"icon-backward-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page <= 1\" ng-click=\"page = page - 1\"><i class=\"icon-chevron-left-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page >= maxPage\" ng-click=\"page = page + 1\"><i class=\"icon-chevron-right-thin\"></i></button> <button class=\"btn btn--text-only\" ng-disabled=\"page >= maxPage\" ng-click=\"page = maxPage\"><i class=\"icon-forward-thin\"></i></button></div></div>");
        $templateCache.put('scripts/core/list/views/searchbar.html', "<div class=\"flat-searchbar\" ng-class=\"{extended: flags.extended}\"><div class=\"search-handler\"><label for=\"search-input\" class=\"trigger-icon\" ng-click=\"flags.extended = !flags.extended\"><i class=\"icon-search\"></i></label><input id=\"search-input\" type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"q\" ng-model-options=\"{debounce: 500}\" ng-change=\"search()\"> <button class=\"search-close\" ng-click=\"close()\" ng-class=\"{visible: q}\"><i class=\"icon-close-small\"></i></button></div></div>");
        $templateCache.put('scripts/core/menu/notifications/views/notifications.html', "<div class=\"notification-pane\" ng-class=\"{show: flags.notifications}\"><div class=\"header\" ng-if=\"flags.notifications\"><figure class=\"avatar medium\"><img sd-user-avatar data-user=\"currentUser\"></figure><div class=\"user-info\"><span class=\"name\">{{currentUser.display_name }}</span> <span class=\"displayname\">{{currentUser.username }}</span></div><div class=\"actions\"><a href=\"#/profile/\" ng-click=\"flags.notifications = false\" translate>Profile</a> <button ng-click=\"logout()\" translate>SIGN OUT</button></div></div><div class=\"content\" ng-if=\"flags.notifications\"><section class=\"module\"><header class=\"title\" translate>Notifications</header><div class=\"notification-list\"><ul><li ng-repeat=\"notification in notifications._items track by notification._id\" ng-class=\"{unread: notification._unread}\" sd-mark-as-read><figure class=\"avatar\"><img sd-user-avatar data-user=\"notification.user\"></figure><div class=\"content\" ng-if=\"notification.name === 'notify'\"><time sd-datetime data-date=\"notification._created\"></time><p class=\"text\"><b>{{:: notification.user_name }}</b> <span translate>commented on</span> <i><a ng-href=\"#/authoring/{{ notification.item }}?_id={{ notification.item }}&comments={{ notification.data.comment_id }}\" title=\"{{ notification.item_slugline }}\">{{ :: notification.item_slugline }}</a></i>:<br>{{:: notification.data.comment }}</p></div><div class=\"content\" ng-if=\"notification.name === 'user:mention'\"><time sd-datetime data-date=\"notification._created\"></time><p class=\"text\"><b>{{:: notification.user_name }}</b> <span translate>mentioned you</span> <i><a title=\"{{ notification.item_slugline }}\" ng-click=\"openArticle(notification)\">{{:: notification.item_slugline}} </a></i>:<br>{{:: notification.data.comment }}</p></div><div class=\"content\" ng-if=\"notification.name === 'translated:changed'\"><time sd-datetime data-date=\"notification._created\"></time><p class=\"text\"><b>{{:: notification.user_name }}</b> <span translate>changed the following original item. Please make sure to update the corresponding translated item accordingly</span> <i><a title=\"{{ notification.item_slugline }}\" ng-click=\"openArticle(notification)\">{{ :: notification.item_slugline }}</a></i></p></div><div class=\"content\" ng-if=\"notification.name !== 'notify' && notification.name !== 'user:mention' && notification.name !== 'translated:changed' \" ng-click=\"onNotificationClick(notification)\"><time sd-datetime data-date=\"notification._created\"></time><p class=\"text\"><b>{{:: notification.user_name || \"System\" }}</b>: <span sd-activity-message data-activity=\"notification\"></span></p></div></li><div class=\"info\" ng-show=\"notifications._items.length === 0\" translate>All good so far.</div><div class=\"info\" ng-show=\"notifications._items == null\" translate>Loading...</div></ul></div></section></div></div>");
        $templateCache.put('scripts/core/menu/views/about.html', "<div sd-modal data-model=\"aboutActive\" data-close=\"closeAbout()\" class=\"modal modal--large modal--about\"><div class=\"modal__header modal__header--about\"><h3 class=\"modal__header-sd-logo\">Superdesk</h3><div class=\"btn-group pull-right\"><button ng-click=\"closeAbout()\" title=\"{{ :: 'Close' | translate }}\" class=\"modal__close\"><i class=\"icon-close-small\"></i></button></div></div><div class=\"modal__body\"><div class=\"about-content\"><span class=\"sf-logo\"></span><h4>Superdesk {{ :: version }}</h4><h5 ng-if=\"build_rev && build_rev !== ''\">Superdesk rev. <a href=\"https://github.com/superdesk/superdesk/tree/{{ :: build_rev }}\" rel=\"noopener noreferrer\">{{ :: build_rev }}</a></h5><h5 ng-repeat=\"module in modules track by module.name\">{{ module.name }}: <a ng-href=\"{{ module.href }}\" rel=\"noopener noreferrer\">{{ module.version }}</a></h5><p class=\"date-released\"><span ng-show=\"releaseDate\">Released on</span> {{ :: releaseDate }}</p><p><a href=\"https://www.superdesk.org\" target=\"_blank\"><b>Superdesk</b></a> is an open source end-to-end news creation, production, curation, distribution and publishing platform maintained by <a href=\"https://www.sourcefabric.org\">Sourcefabric z.u.</a>, a nonprofit organisation whose primary purpose is to make the best possible software for journalism.</p><p>Copyright (c) 2014 - {{ year }} Sourcefabric z.u. and contributors.<br>Superdesk is released under the <a href=\"https://www.gnu.org/licenses/agpl-3.0\" target=\"_blank\">open source license AGPLv3</a>.</p><p>Looking for help or support?<br><a href=\"https://forum.sourcefabric.org/categories/superdesk-dev\" target=\"_blank\">Forum</a>&nbsp;&nbsp; | &nbsp; <a href=\"https://www.superdesk.org/attachment/13/superdeskmastermanual.pdf?g_download=1\" target=\"_blank\">User Manual</a></p><p>Get in touch with us via direct email <a href=\"mailto:superdesk@sourcefabric.org\">superdesk@sourcefabric.org</a>.</p></div></div><div class=\"modal__footer\"><button ng-click=\"closeAbout()\" class=\"btn btn--primary pull-right\" translate>Close</button></div></div>");
        $templateCache.put('scripts/core/menu/views/menu.html', "<div><div id=\"top-menu\" ng-class=\"{'menu-open': flags.menu, 'test-environment': isTestEnvironment}\" data-text=\"{{environmentName}}\"><div class=\"pull-left\"><button class=\"collapse-nav pull-left\" ng-click=\"toggleMenu()\"><i class=\"icon-collapse icon--white\"></i></button><p class=\"sd-top-menu__header\" ng-if=\"currentRoute.category !== 'superdesk.core.menu.settings'\" ng-hide=\"currentRoute.topTemplateUrl\">{{ currentRoute.label | translate}}</p><p class=\"sd-top-menu__header\" ng-if=\"currentRoute.category === 'superdesk.core.menu.settings'\" ng-hide=\"currentRoute.topTemplateUrl\">{{ \"Settings\" | translate}}</p><div class=\"top-nav pull-left\" ng-include=\"currentRoute.topTemplateUrl\"></div></div><div class=\"top-menu__content-block top-menu__content-block--right\"><div sd-top-menu-info-placeholder></div><button ng-if=\"privileges.feature_preview\" ng-click=\"toggleBeta()\" class=\"beta-switch\"><span class=\"stable\" ng-hide=\"beta\" title=\"{{ :: 'Switch to feature preview' | translate }}\">stable</span> <span class=\"beta\" ng-show=\"beta\" sd-tooltip=\"{{ :: 'Turn off feature preview' | translate }}\" flow=\"down\">feature preview</span></button> <button class=\"current-user\" ng-click=\"toggleNotifications()\"><span id=\"unread-count\" class=\"badge badge--primary\" ng-show=\"notifications.unread\">{{ notifications.unread }}</span><figure class=\"avatar\"><img sd-user-avatar data-user=\"currentUser\" alt=\"{{currentUser.display_name || currentUser.username }}\"></figure></button></div></div><div id=\"side-menu\" ng-class=\"{'menu-open': flags.menu}\" ng-include=\"currentRoute.sideTemplateUrl\"></div><div id=\"main-menu\"><div class=\"header\"></div><div class=\"content\"><ul><li ng-repeat=\"item in menu | filter:{ adminTools: false } | orderBy:'priority'\" ng-class=\"{active: item.isActive}\"><a ng-href=\"#{{ :: item.href }}\" title=\"{{ :: item.description | translate }}\">{{ :: item.label | translate }}</a></li><li class=\"main-menu_group-header\" translate ng-if=\"adminOptions.length > 0\">Admin tools</li><li ng-repeat=\"item in menu | filter:{ adminTools: true } | orderBy:'priority' as adminOptions\" ng-class=\"{active: item.isActive}\"><a ng-href=\"#{{ :: item.href }}\" title=\"{{ :: item.description | translate }}\">{{ :: item.label | translate }} <sup class=\"btn-toggle-label\" ng-if=\"item.betaMark\">Beta</sup></a></li><li ng-if=\"feedback_url\" class=\"main-menu_group-header\" translate>Feedback</li><li ng-if=\"feedback_url\"><a ng-href=\"{{ feedback_url }}\" target=\"_blank\">Feedback/Suggestions</a></li></ul></div><div class=\"footer\"><i class=\"icon-superdesk\"></i> <span class=\"powered\">Powered by Superdesk technology</span> <span class=\"about\"><a ng-click=\"openAbout()\">About Superdesk</a></span></div></div><div sd-about data-active=\"aboutActive\"></div></div>");
        $templateCache.put('scripts/core/menu/views/superdesk-view.html', "<div sd-menu-wrapper></div><div sd-notifications></div><div class=\"loading\" ng-if=\"loading\"></div><div id=\"main-container\" ng-class=\"superdesk.flags\" ng-if=\"!popup && superdesk.flags.workspace === true\" ngf-drop=\"superdesk.openUpload($files)\" ngf-model-options=\"{updateOn: 'drop'}\"><div id=\"workspace-container\" ng-view sd-splitter-widget></div><div id=\"authoring-container\" ng-show=\"superdesk.flags.authoring\" ng-if=\"superdesk.flags.workspace\" sd-authoring-container></div><div id=\"superdesk-workqueue\" ng-if=\"superdesk.flags.workspace === true && superdesk.flags.workqueue === true\" sd-workqueue></div><div sd-item-preview-container></div></div><div id=\"main-container\" ng-class=\"superdesk.flags\" ng-if=\"popup\" ngf-drop=\"superdesk.openUpload($files)\" ngf-model-options=\"{updateOn: 'drop'}\"><div id=\"authoring-container\" sd-authoring-container></div><div sd-item-preview-container></div></div><div id=\"main-container\" ng-class=\"superdesk.flags\" ng-if=\"!popup && superdesk.flags.workspace === false\" ngf-drop=\"return;\" ngf-model-options=\"{updateOn: 'drop'}\" ng-view></div><div id=\"react-placeholder\"></div><div sd-activity-modal></div><div sd-login-modal></div><div sd-activity-chooser></div><div sd-phone-home-modal></div><div sd-item-globalsearch data-repo=\"repo\" data-context=\"context\" class=\"pull-left\"></div><div sd-keyboard-modal></div><div class=\"hard-error\" ng-if=\"serverStatus\"><div class=\"alert alert-error\" translate>Superdesk is experiencing network connection issues:/</div></div>");
        $templateCache.put('scripts/core/spellcheck/views/spellcheck-widget.html', "<div ng-controller=\"Spellcheck as spell\"><quote>{{ spell.currentError }}</quote></div>");
        $templateCache.put('scripts/core/ui/views/datepicker-wrapper.html', "<div class=\"datepicker-wrapper\" ng-show=\"open\" ng-keydown=\"keydown($event)\"><div class=\"datepicker-additional\" ng-if=\"shortcuts\"><table><tbody><tr><td ng-repeat=\"b in shortcuts\"><button class=\"btn btn--mini\" ng-click=\"selectShortcut(b.value, b.term)\">{{ b.label }}</button></td></tr></tbody></table></div><div class=\"datepicker-core\" ng-transclude></div><button class=\"btn btn--primary btn--small pull-right\" ng-click=\"dateSelection()\" translate>Confirm</button> <button class=\"btn btn--small pull-right\" ng-click=\"close()\" translate>Cancel</button></div>");
        $templateCache.put('scripts/core/ui/views/sd-datepicker.html', "<div class=\"datepicker-input\"><input type=\"text\" ng-model=\"dt\" ng-change=\"change()\" sd-datepicker-inner data-opened=\"state.opened\" data-format=\"format\" shortcuts=\"shortcuts\" ng-disabled=\"disabled\" tabindex=\"{{tabindex}}\"> <button type=\"button\" class=\"icn-btn\" ng-click=\"openCalendar($event)\" ng-disabled=\"disabled\"><i class=\"icon-calendar\"></i></button></div>");
        $templateCache.put('scripts/core/ui/views/sd-multi-select.html', "<div class=\"dropdown dropdown--dropright dropdown-terms\" dropdown sd-dropdown-focus sd-dropdown-position><button class=\"dropdown__toggle\" dropdown__toggle ng-disabled=\"disabled\" ng-if=\"!disabled\"><i class=\"icon--white icon-plus-large\"></i></button><ul class=\"dropdown__menu nested-menu pull-right\"><li><div sd-typeahead items=\"list\" term=\"selectedTerm\" search=\"searchTerms(term)\" select=\"selectItem(item)\" data-disabled=\"disabled\"><ul class=\"item-list\" vs-repeat vs-scroll-parent=\".item-list\" ng-if=\"activeList\"><li typeahead-item=\"t\" ng-repeat=\"t in terms\"><button>{{ :: t}}</button></li></ul></div></li><li class=\"main-list\" ng-if=\"!activeList\"><ul vs-repeat vs-scroll-parent=\".main-list\"><li ng-repeat=\"item in list\"><button ng-click=\"selectItem(item)\">{{ :: item}}</button></li></ul></li></ul></div><ul class=\"terms-list\" ng-if=\"selectedItems.length\"><li class=\"pull-left\" ng-repeat=\"item in selectedItems\" ng-click=\"removeItem(item)\">{{ :: item}} <i class=\"icon-close-small\"></i></li></ul>");
        $templateCache.put('scripts/core/ui/views/sd-timepicker-popup.html', "<div class=\"timepicker-popup\" ng-show=\"open\" ng-keydown=\"keydown({e: $event})\" tabindex=\"0\"><div class=\"timepicker-additional\"><table><tbody><tr><td><button class=\"btn btn--mini\" ng-click=\"submit(30)\" translate>in 30 min</button></td><td><button class=\"btn btn--mini\" ng-click=\"submit(60)\" translate>in 1 h</button></td><td><button class=\"btn btn--mini\" ng-click=\"submit(120)\" translate>in 2 h</button></td></tr></tbody></table></div><div class=\"timepicker-core\"><div class=\"select-area\"><div class=\"header\" translate>Hours</div><ul><li ng-repeat=\"h in hours\" ng-click=\"$parent.hour = h\" ng-class=\"{active: hour === h}\">{{h | leadingZero}}</li></ul></div><div class=\"select-area\"><div class=\"header\" translate>Minutes</div><ul><li ng-repeat=\"m in minutes\" ng-click=\"$parent.minute = m\" ng-class=\"{active: minute === m}\">{{m | leadingZero}}</li></ul></div><button class=\"btn btn--primary btn--small pull-right\" ng-click=\"submit()\" translate>Confirm</button> <button class=\"btn btn--small pull-right\" ng-click=\"cancel()\" translate>Cancel</button></div></div>");
        $templateCache.put('scripts/core/ui/views/sd-timepicker.html', "<div class=\"timepicker-input\" ng-init=\"opened = false\"><input type=\"text\" class=\"{{style}}\" ng-model=\"tt\" sd-timepicker-inner data-opened=\"opened\" ng-disabled=\"disabled\" data-view-time-format=\"viewTimeFormat\" data-model-time-format=\"modelTimeFormat\"> <button class=\"icn-btn\" ng-click=\"openTimePicker($event)\" ng-disabled=\"disabled\"><i class=\"icon-time\"></i></button></div>");
        $templateCache.put('scripts/core/ui/views/sd-timezone.html', "<label class=\"form-label timezone-label\" translate>Time Zone</label><div class=\"control\" ng-hide=\"timezone\"><ul sd-typeahead data-style=\"style\" items=\"matchingTimeZones\" term=\"tzSearchTerm\" search=\"searchTimeZones(term)\" select=\"selectTimeZone(item)\" always-visible=\"tzSearchTerm\" placeholder=\"ie. Europe/London\"><li class=\"typeahead-item--padded\" typeahead-item=\"tz\" ng-repeat=\"tz in matchingTimeZones track by tz\">{{ ::tz}}</li><li class=\"typeahead-item--padded\" ng-show=\"tzSearchTerm && matchingTimeZones.length === 0\" class=\"no-match\" translate>(no matches)</li></ul><p class=\"discreet\" translate>If not set, the UTC+0 time zone is assumed.</p></div><ul class=\"pills-list {{style}}\" ng-show=\"timezone\"><li><div id=\"timezone\" class=\"name right-pad\">{{timezone}}</div><div class=\"actions\"><button title=\"{{:: 'Clear' | translate }}\" ng-click=\"clearSelectedTimeZone()\"><i class=\"icon-remove-sign\"></i></button></div></li></ul>");
        $templateCache.put('scripts/core/ui/views/weekday-picker.html', "<span class=\"sd-check__wrapper\" ng-repeat=\"day in weekdayList\" ng-click=\"toggleDay(day)\"><span class=\"sd-checkbox sd-checkbox--button-style sd-checkbox--button-{{weekdays[day]}}\" ng-class=\"{'checked': isDayChecked(day)}\"><label>{{ weekdays[day] | translate }}</label></span></span>");
        $templateCache.put('scripts/core/ui/views/wizard.html', "<div class=\"modal__body-header\"><ul class=\"nav-tabs\"><li ng-repeat=\"step in steps\" ng-class=\"{'nav-tabs__tab--active': step.selected}\" class=\"nav-tabs__tab\"><button ng-click=\"goTo(step)\" ng-disabled=\"step.disabled\" ng-hide=\"step.hide\" class=\"nav-tabs__link\">{{ step.title | translate}}</button></li></ul></div><div class=\"modal__body-content\" ng-transclude></div>");
        $templateCache.put('scripts/core/ui/views/wizardStep.html', "<div ng-show=\"selected\" class=\"modal-screen\" ng-transclude></div>");
        $templateCache.put('scripts/core/views/confirmation-modal.html', "<div class=\"modal__header\"><h3 ng-bind-html=\"headerText\"></h3></div><div class=\"modal__body\" ng-bind-html=\"bodyText\"></div><div class=\"modal__footer\"><button class=\"btn\" ng-click=\"cancel()\" ng-show=\"cancelText\">{{ cancelText }}</button> <button class=\"btn\" ng-click=\"additionalCancel()\" ng-show=\"additionalCancelText\">{{ additionalCancelText }}</button> <button class=\"btn btn--primary\" ng-click=\"ok()\">{{ okText }}</button></div>");
        $templateCache.put('scripts/core/views/sdSearchList.html', "<div class=\"search-list\"><button ng-disabled=\"!editable\" type=\"button\" class=\"search-list-button\" ng-click=\"open = !open\"><span ng-show=\"selectedItems.length === 0\" translate>Select</span> <span ng-show=\"selectedItems.length === 1\">{{selectedItems[0][labelKey]}}</span> <span ng-show=\"selectedItems.length > 1\">{{selectedItems.length}} {{:: 'selected'|translate}}</span> <span class=\"dropdown__caret\"></span></button><div ng-show=\"open\" class=\"search-list-content\"><div><div class=\"selected-list\"><button type=\"button\" ng-click=\"open = !open\" class=\"close-list\">x</button><div ng-show=\"maxSelectedItems !== 1\"><label><span translate>Selected items</span> ({{selectedItems.length}} {{::'of'|translate}} <span ng-show=\"maxSelectedItems\">{{maxSelectedItems}}</span> <span ng-hide=\"maxSelectedItems\" translate>many</span>)</label></div><div ng-show=\"maxSelectedItems === 1\"><label translate>Selected item</label></div><ul ng-show=\"selectedItems.length\"><li ng-repeat=\"item in selectedItems\"><button type=\"button\" ng-click=\"unselectItem(item)\" class=\"select-button\">{{item[labelKey]}}</button><div class=\"selected-helper\"><div ng-if=\"selectedItemsHelperTemplate\" onload=\"data = selectedItemsHelperData\" ng-include=\"selectedItemsHelperTemplate\"></div></div></li></ul><button type=\"button\" ng-hide=\"selectedItems.length\" class=\"select-button\" translate>None</button></div><div class=\"unselected-list\"><div class=\"page-info\"><label translate>Items</label><span class=\"pagination\"><button type=\"button\" ng-disabled=\"page === 1\" ng-click=\"page = page - 1\">&lt;</button><label>{{page | translate}}/{{maxPage | translate}}</label><button type=\"button\" ng-disabled=\"page === maxPage\" ng-click=\"page = page + 1\">&gt;</button> </span><input type=\"text\" placeholder=\"{{ :: 'Search' | translate }}\" ng-model=\"keyword\" ng-model-options=\"{debounce: 500}\"></div><ul><li ng-repeat=\"item in items\"><button type=\"button\" ng-click=\"selectItem(item)\" ng-disabled=\"isSelected(item) || isDisabled(item) || selectedItems.length >= maxSelectedItems\" class=\"select-button\">{{item[labelKey]}}</button></li></ul></div></div></div></div>");
        $templateCache.put('scripts/core/views/sdSearchListSingle.html', "<div sd-search-list data-endpoint=\"{{endpoint}}\" data-page-size=\"{{pageSize}}\" data-label-key=\"{{labelKey}}\" data-search-key=\"{{searchKey}}\" data-criteria=\"criteria\" data-disable-items=\"disableItems\" data-max-selected-items=\"1\" data-selected-items=\"selectedItems\"></div>");
        $templateCache.put('scripts/core/views/sdselect.html', "<div class=\"sdselect\" ng-class=\"{'open': open}\"><a class=\"sdselect-btn\" ng-click=\"toggleSelect()\" ng-disabled=\"disabled\" ng-class=\"{'error': !valid()}\"><span class=\"pull-left\">{{header}}</span> <span class=\"caret pull-right\"></span></a><div class=\"sdselect-menu\" ng-show=\"open\"><div><div class=\"sdselect-filter\" ng-show=\"showfilter\"><input class=\"input-block-level\" type=\"text\" ng-model=\"searchText.label\" autofocus placeholder=\"{{ 'Filter' | translate }}\"></div><div class=\"sdselect-all\" ng-show=\"multiple\"><a ng-click=\"checkAll()\" translate>Check all</a> <a ng-click=\"uncheckAll()\" translate>Uncheck all</a></div></div><div class=\"list-holder\"><ul><li ng-repeat=\"i in items | filter:searchText\"><a ng-click=\"select(i); focus()\"><i ng-class=\"{'icon-ok': i.checked, 'icon-empty': !i.checked}\"></i>{{i.label}}</a></li></ul></div></div></div>");
        $templateCache.put('scripts/core/views/sdSlider.html', "<div class=\"ui-slider-thumb\">{{defaultValue}}</div><span class=\"ui-slider-label left\" translate>low</span> <span class=\"ui-slider-label right\" translate>high</span><div class=\"ui-slider-indicator\"><span style=\"width:{{100 / (list.length - 1)}}%\" ng-repeat=\"item in list\" ng-show=\"!$first\"></span></div>");
        $templateCache.put('scripts/core/views/sdSort.html', "{{ label }} <i class=\"icon-chevron-down-thin\" ng-show=\"sort[0] === field && sort[1] == 'desc'\"></i> <i class=\"icon-chevron-up-thin\" ng-show=\"sort[0] === field && sort[1] == 'asc'\"></i>");
        $templateCache.put('scripts/core/views/sdTypeahead.html', "<div class=\"sd-typeahead\"><div class=\"input-term\"><input ng-model=\"term\" class=\"{{style}}\" ng-change=\"query()\" tabindex=\"{{tabindex}}\" type=\"text\" ng-disabled=\"disabled\" autocomplete=\"off\" ng-click=\"$event.stopPropagation()\" placeholder=\"{{placeholder}}\"></div><ul class=\"item-list\" ng-show=\"isVisible()\" ng-transclude></ul></div>");
        $templateCache.put('scripts/apps/dashboard/closed-desk/thumbnail.svg', "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 232 144\"><path d=\"M29.2 114.2h-6.8l6.8-8.1v8.1zm60 0H96l-6.8-8.1v8.1z\" opacity=\".55\"/><path d=\"M100.3 116.3L89.2 103v3.1l6.8 8.1H22.3l6.9-8.1V103L18 116.3z\" opacity=\".35\"/><path d=\"M18 116.3v27.6h82.3v-27.6H18zm53.3 13c0 .6-.5 1.1-1.1 1.1h-22c-.6 0-1.1-.5-1.1-1.1V123c0-.6.5-1.1 1.1-1.1h22c.6 0 1.1.5 1.1 1.1v6.3z\" opacity=\".25\"/><path d=\"M70.2 128.4h-22c-.6 0-1.1-.5-1.1-1.1v2c0 .6.5 1.1 1.1 1.1h22c.6 0 1.1-.5 1.1-1.1v-2c0 .6-.5 1.1-1.1 1.1z\" opacity=\".35\"/><path fill=\"#FFF\" d=\"M70.2 121.9h-22c-.6 0-1.1.5-1.1 1.1v4.3c0 .6.5 1.1 1.1 1.1h22c.6 0 1.1-.5 1.1-1.1V123c0-.6-.5-1.1-1.1-1.1zM87.5 63.8H30.9c-.9 0-1.7.8-1.7 1.7v48.7h60V65.5c0-.9-.8-1.7-1.7-1.7zM36.2 81.1h24.4V98H36.2V81.1zm46 27h-46v-1.8h46v1.8zm0-5h-46v-1.8h46v1.8zm0-5.1H63.9v-1.8h18.3V98zm0-5H63.9v-1.8h18.3V93zm0-5.1H63.9v-1.8h18.3v1.8zm0-5.1H63.9V81h18.3v1.8zm0-5.9h-46v-5.1h46v5.1z\" opacity=\".5\"/><path d=\"M36.2 81.1h24.4V98H36.2z\" opacity=\".25\"/><path fill=\"#FFF\" d=\"M30.8 62.4h56.6c.6 0 1.2.2 1.7.5v-.3c0-.9-.8-1.7-1.7-1.7H30.8c-.9 0-1.7.8-1.7 1.7v.3c.6-.3 1.1-.5 1.7-.5z\" opacity=\".4\"/><path fill=\"#FFF\" d=\"M30.8 59.5h56.6c.6 0 1.2.2 1.7.5v-.3c0-.9-.8-1.7-1.7-1.7H30.8c-.9 0-1.7.8-1.7 1.7v.3c.6-.3 1.1-.5 1.7-.5z\" opacity=\".3\"/><g opacity=\".9\"><path d=\"M165.1 89.8h-5l5-5.9v5.9zm43.5 0h5l-5-5.9v5.9z\" opacity=\".55\"/><path d=\"M216.7 91.3l-8.1-9.7v2.3l5 5.9h-53.5l5-5.9v-2.3l-8.1 9.7z\" opacity=\".35\"/><path d=\"M157 91.3v20.5c0 .7.5 1.2 1.2 1.2h57.3c.7 0 1.2-.5 1.2-1.2V91.3H157zm38.7 9.5c0 .5-.4.8-.8.8h-16c-.5 0-.8-.4-.8-.8v-4.6c0-.5.4-.8.8-.8h16c.5 0 .8.4.8.8v4.6z\" opacity=\".25\"/><path d=\"M194.9 100.1h-16c-.5 0-.8-.4-.8-.8v1.5c0 .5.4.8.8.8h16c.5 0 .8-.4.8-.8v-1.5c0 .4-.4.8-.8.8z\" opacity=\".35\"/><path fill=\"#FFF\" d=\"M194.9 95.4h-16c-.5 0-.8.4-.8.8v3.1c0 .5.4.8.8.8h16c.5 0 .8-.4.8-.8v-3.1c0-.5-.4-.8-.8-.8zM207.4 53.2h-41.1c-.7 0-1.2.5-1.2 1.2v35.3h43.5V54.5c0-.7-.5-1.3-1.2-1.3zm-37.2 12.6h17.7V78h-17.7V65.8zm33.4 19.6h-33.4v-1.3h33.4v1.3zm0-3.7h-33.4v-1.3h33.4v1.3zm0-3.7h-13.3v-1.3h13.3V78zm0-3.6h-13.3v-1.3h13.3v1.3zm0-3.7h-13.3v-1.3h13.3v1.3zm0-3.7h-13.3v-1.3h13.3V67zm0-4.3h-33.4V59h33.4v3.7z\" opacity=\".5\"/><path d=\"M170.2 65.8h17.7v12.3h-17.7z\" opacity=\".25\"/><path fill=\"#FFF\" d=\"M166.3 52.2h41.1c.5 0 .9.1 1.2.4v-.2c0-.7-.5-1.2-1.2-1.2h-41.1c-.7 0-1.2.5-1.2 1.2v.2c.4-.3.8-.4 1.2-.4z\" opacity=\".4\"/><path fill=\"#FFF\" d=\"M166.3 50.1h41.1c.5 0 .9.1 1.2.4v-.2c0-.7-.5-1.2-1.2-1.2h-41.1c-.7 0-1.2.5-1.2 1.2v.2c.4-.3.8-.4 1.2-.4z\" opacity=\".3\"/></g><g opacity=\".7\"><path d=\"M107.2 36.4H104l3.2-3.8v3.8zm28.2 0h3.2l-3.2-3.8v3.8z\" opacity=\".55\"/><path d=\"M140.6 37.3l-5.2-6.2v1.4l3.2 3.9H104l3.2-3.9v-1.4l-5.2 6.2z\" opacity=\".35\"/><path d=\"M102 37.3v13.3c0 .4.4.8.8.8h37c.4 0 .8-.4.8-.8V37.3H102zm25 6.1c0 .3-.2.5-.5.5h-10.3c-.3 0-.5-.2-.5-.5v-3c0-.3.2-.5.5-.5h10.3c.3 0 .5.2.5.5v3z\" opacity=\".25\"/><path d=\"M126.5 43h-10.3c-.3 0-.5-.2-.5-.5v1c0 .3.2.5.5.5h10.3c.3 0 .5-.2.5-.5v-1c0 .3-.3.5-.5.5z\" opacity=\".35\"/><path fill=\"#FFF\" d=\"M126.5 39.9h-10.3c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h10.3c.3 0 .5-.2.5-.5v-2c0-.2-.3-.5-.5-.5zM134.6 12.7H108c-.4 0-.8.4-.8.8v22.8h28.1V13.5c.1-.4-.3-.8-.7-.8zm-24.1 8.1H122v7.9h-11.5v-7.9zm21.6 12.7h-21.6v-.8h21.6v.8zm0-2.4h-21.6v-.8h21.6v.8zm0-2.3h-8.6V28h8.6v.8zm0-2.4h-8.6v-.8h8.6v.8zm0-2.4h-8.6v-.8h8.6v.8zm0-2.4h-8.6v-.8h8.6v.8zm0-2.7h-21.6v-2.4h21.6v2.4z\" opacity=\".5\"/><path d=\"M110.5 20.8H122v7.9h-11.5z\" opacity=\".25\"/><path fill=\"#FFF\" d=\"M108 12.1h26.5c.3 0 .6.1.8.2v-.1c0-.4-.4-.8-.8-.8H108c-.4 0-.8.4-.8.8v.1c.3-.1.5-.2.8-.2z\" opacity=\".4\"/><path fill=\"#FFF\" d=\"M108 10.7h26.5c.3 0 .6.1.8.2v-.1c0-.4-.4-.8-.8-.8H108c-.4 0-.8.4-.8.8v.1c.3-.1.5-.2.8-.2z\" opacity=\".3\"/></g><path fill=\"#FFF\" d=\"M61.9 56.6c-.1 0-.3 0-.4-.1-.7-.2-1-1-.8-1.7.4-1.3.9-2.6 1.5-3.8.3-.7 1-1 1.7-.7.7.3 1 1 .7 1.7-.5 1.2-1 2.4-1.4 3.7-.2.5-.7.9-1.3.9zm3.6-8.3c-.2 0-.4 0-.6-.2-.6-.3-.9-1.1-.5-1.8.6-1.2 1.3-2.4 2-3.5.4-.6 1.2-.8 1.8-.4.6.4.8 1.2.4 1.8-.7 1.1-1.3 2.2-1.9 3.4-.3.5-.7.7-1.2.7zm4.8-7.6c-.3 0-.5-.1-.8-.3-.6-.4-.7-1.2-.3-1.8.8-1.1 1.7-2.2 2.5-3.2.5-.5 1.3-.6 1.8-.1s.6 1.3.1 1.8c-.8 1-1.7 2-2.4 3.1-.1.3-.5.5-.9.5zm5.9-6.8c-.3 0-.7-.1-.9-.4-.5-.5-.5-1.3 0-1.8 1-1 2-1.9 3-2.8.5-.5 1.4-.4 1.8.1.5.5.4 1.4-.1 1.8-1 .9-2 1.7-2.9 2.7-.3.3-.6.4-.9.4zm6.8-5.8c-.4 0-.8-.2-1.1-.5-.4-.6-.3-1.4.3-1.8 1.1-.8 2.2-1.6 3.4-2.3.6-.4 1.4-.2 1.8.4.4.6.2 1.4-.4 1.8-1.1.7-2.2 1.4-3.2 2.2-.2.1-.5.2-.8.2zm7.7-4.7c-.5 0-.9-.3-1.2-.7-.3-.6-.1-1.4.6-1.8 1.2-.6 2.4-1.2 3.7-1.8.7-.3 1.4 0 1.7.7.3.7 0 1.4-.7 1.7-1.2.5-2.4 1.1-3.5 1.7-.2.1-.4.2-.6.2zm8.3-3.5c-.5 0-1-.3-1.2-.9-.2-.7.1-1.4.8-1.6l3.9-1.2c.7-.2 1.4.2 1.6.9.2.7-.2 1.4-.9 1.6-1.3.3-2.5.7-3.7 1.1-.3 0-.4.1-.5.1z\" opacity=\".3\"/><g fill=\"#FFF\" opacity=\".7\"><path d=\"M160 115.2l-7.9-1.4c-.7-.1-1.3.3-1.4 1-.1.7.3 1.3 1 1.4l4.9.9c-.9.8-1.9 1.7-2.8 2.4-.6.4-.6 1.3-.2 1.8.3.3.6.5 1 .5.3 0 .6-.1.8-.3.9-.7 1.8-1.5 2.7-2.3l-.8 4.8c-.1.7.3 1.3 1 1.4.7.1 1.3-.3 1.4-1l1.4-7.9c0-.6-.4-1.2-1.1-1.3zM107.9 131.3c-1.3-.2-2.5-.5-3.8-.8-.7-.2-1.4.3-1.6 1-.2.7.3 1.4 1 1.6 1.3.3 2.6.6 3.9.8h.2c.6 0 1.2-.4 1.3-1.1.2-.7-.3-1.4-1-1.5zM125.4 131.6c-1.3.2-2.6.3-3.9.4-.7 0-1.3.7-1.2 1.4 0 .7.6 1.2 1.3 1.2h.1c1.4-.1 2.7-.2 4.1-.4.7-.1 1.2-.7 1.1-1.5-.1-.7-.8-1.2-1.5-1.1zM116.7 132.1c-1.3 0-2.6-.1-3.9-.2-.7-.1-1.3.5-1.4 1.2-.1.7.5 1.3 1.2 1.4 1.3.1 2.7.2 4.1.2.7 0 1.3-.6 1.3-1.3-.1-.6-.6-1.2-1.3-1.3zM149.9 122.4l-3.3 2.1c-.6.4-.8 1.2-.5 1.8.2.4.7.6 1.1.6.2 0 .4-.1.7-.2 1.2-.7 2.3-1.4 3.5-2.2.6-.4.8-1.2.4-1.8-.5-.6-1.3-.7-1.9-.3zM142.2 126.7c-1.2.6-2.4 1.1-3.6 1.5-.7.3-1 1-.7 1.7.2.5.7.8 1.2.8.2 0 .3 0 .5-.1 1.3-.5 2.5-1 3.8-1.6.6-.3.9-1.1.6-1.7-.3-.6-1.1-.9-1.8-.6zM134 129.8c-1.2.4-2.5.7-3.8 1-.7.2-1.1.8-1 1.6.1.6.7 1 1.3 1h.3c1.3-.3 2.7-.6 4-1 .7-.2 1.1-.9.9-1.6-.3-.8-1-1.2-1.7-1z\"/></g><g fill=\"#FFF\" opacity=\".7\"><path d=\"M155.6 27.6c-.6-.5-1.4-.4-1.8.2-.5.6-.4 1.4.2 1.8 1 .8 2 1.7 3 2.6.3.2.6.3.9.3.3 0 .7-.1 1-.4.5-.5.5-1.3-.1-1.8-1.1-1-2.2-1.9-3.2-2.7zM148 22.4c-.6-.4-1.4-.2-1.8.5-.4.6-.2 1.4.5 1.8 1.1.6 2.2 1.4 3.3 2.1.2.2.5.2.7.2.4 0 .8-.2 1.1-.6.4-.6.2-1.4-.3-1.8-1.2-.8-2.3-1.6-3.5-2.2zM147.2 16c-.2-.6-.8-1-1.5-.8l-7.7 2.2c-.6.2-1 .8-.8 1.5l2.2 7.7c.2.6.8 1 1.5.8.6-.2 1-.8.8-1.5l-1.2-4.4c.6.3 1.3.6 1.9.9.2.1.4.1.6.1.5 0 1-.3 1.2-.7.3-.6 0-1.4-.6-1.7-.8-.4-1.6-.7-2.4-1.1l5.2-1.5c.6-.2 1-.9.8-1.5zM170.1 44.6c-.7-1.2-1.4-2.3-2.1-3.5-.4-.6-1.2-.8-1.8-.4-.6.4-.8 1.2-.4 1.8l2.1 3.3c.2.4.7.7 1.1.7.2 0 .4-.1.6-.2.6-.3.8-1.1.5-1.7zM162.2 33.9c-.5-.5-1.3-.6-1.8-.1s-.6 1.3-.1 1.8c.9 1 1.7 2 2.5 3 .3.3.6.5 1 .5.3 0 .6-.1.8-.3.6-.4.7-1.3.2-1.8-.7-1.1-1.6-2.1-2.6-3.1z\"/></g></svg>");
        $templateCache.put('scripts/apps/dashboard/world-clock/thumbnail.svg', "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 232 144\" enable-background=\"new 0 0 232 144\"><defs><path id=\"1\" opacity=\".9\" d=\"m5.937 8.442v124.03h220.61v-124.03h-220.61m63.19 103.7c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947m90.47 0c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947\"/><path id=\"2\" opacity=\".75\" d=\"m116.37 63.44c2.77-16.191 14.226-29.409 29.399-34.705v-14h-117.61v115.26h117.61v-31.848c-15.173-5.296-26.629-18.514-29.398-34.708\"/><path id=\"3\" opacity=\".5\" d=\"m196.95 58.59v32.14h-49.91v18.46h58.26v-50.6z\"/><path id=\"4\" opacity=\".4\" d=\"m99.97 109.08c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-7.89h-69.28c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-36.496h-110.89c4.142 0 8.425 0 14.66 3.459 7.438 4.126 10.263 12.2 10.423 17.862.127 4.549-.448 8.302-.722 9.802 1.415.861 2.83 2.644 2.83 6.334 0 4.601-2.3 11.01-6.05 11.06-2.295 6.556-5.983 12.326-10.219 15.987v7.201l1.22 2.945c6.291 1.493 20.239 5.328 24.753 10.855 2.641 3.241 5.148 25.792 5.426 28.353l.011.1h68.55v-35.2h-69.28z\"/><clipPath><use xlink:href=\"#4\"/></clipPath><clipPath><use xlink:href=\"#3\"/></clipPath><clipPath id=\"0\"><use xlink:href=\"#1\"/></clipPath><clipPath><use xlink:href=\"#2\"/></clipPath></defs><g opacity=\".9\"><g clip-path=\"url(#0)\"><path opacity=\".15\" d=\"m44.541 72.25c.13.155.264.311.421.445.358.065.696-.128 1.054-.132-.247-.583-.991-.465-1.475-.313\"/><path opacity=\".15\" d=\"m83.84 36.469c-.299-.1-.539-.305-.716-.557-.087.014-.169.027-.252.039-.149-.104-.315-.183-.492-.228-.016.087-.051.256-.067.342-.13.043-.26.095-.354.203-.291-.031-.582.032-.87.077-.004.083-.012.248-.02.331-.15-.087-.299-.169-.448-.244.028.157.059.313.09.472-.142.039-.279.077-.417.116.004-.372-.331-.551-.653-.616l.098-.028c-.177-.02-.35-.031-.523-.039-.039.114-.079.228-.118.342-.083.201-.161.405-.24.608.354.122.681-.148 1.035-.167 0 .09.004.268.008.352-.126.051-.244.106-.366.159l-.083-.03c-.118.049-.232.1-.346.15.028.049.083.147.11.195.268-.057.535-.102.811-.118.138.13.252.291.358.453-.126.079-.252.161-.374.244.586-.167 1.149.016 1.7.189.24.096.484-.033.716-.087.059-.094.122-.189.189-.283.386-.114.669-.417 1.01-.622.264-.165.457-.425.582-.708-.003-.236-.125-.48-.365-.545\"/><path opacity=\".15\" d=\"m120.07 56.922c-.169-.14-.413.11-.276.275.138.082.355-.134.276-.275\"/><path opacity=\".15\" d=\"m118.91 58.03c-.142-.287-.512-.283-.783-.287-.393-.073-.775-.114-1.149-.24.008.075.024.224.031.301.378-.004.732.246 1.11.238.197-.002.595-.008.791-.012\"/><path opacity=\".15\" d=\"m158.92 79.25c-.146-.295-.46-.458-.763-.531.067.097.138.195.205.297-.02.519-.319 1.01-.169 1.543.043.457.154.913.311 1.346.405-.004.775-.181 1.118-.386.055-.272.209-.559.075-.83-.199-.509-.522-.967-.777-1.439\"/><path opacity=\".15\" d=\"m151.29 16.816c.413-.094.811-.248 1.165-.5-.047-.177-.098-.352-.154-.525-.417-.061-.818-.352-1.244-.158-.008-.084-.027-.254-.031-.34-.153-.016-.346-.169-.464-.012-.594.52-.366 1.448-.429 2.137.405-.164.72-.502 1.157-.602\"/><path opacity=\".15\" d=\"m174.78 19.706c-.142.254-.279.51-.417.762-.134.106-.256.226-.331.378.154-.055.311-.114.468-.171.299.254.665.454 1.07.443-.008-.295-.016-.59-.036-.885-.087-.215-.213-.409-.35-.596-.14-.027-.274.043-.404.069\"/><path opacity=\".15\" d=\"m189.56 44.24c-.09.083-.181.169-.268.254.059.081.122.159.189.242-.059.362-.039.732.059 1.088.106.053.22.108.334.167-.201.714.02 1.448.149 2.154.508.445.661 1.125.976 1.702.075.213.248.36.445.468-.303-.639.315-.649.649-.791-.429-.244-.901-.453-1.271-.783-.189-.396-.185-.844-.268-1.263.197-.059.397-.106.602-.15-.09-.46-.429-.891-.279-1.381-.024-.519-.039-1.039.016-1.558-.15-.165-.327-.301-.492-.449-.26-.22-.464-.649-.921-.382.095.193.315.24.492.331-.047.144-.086.287-.122.433-.097-.031-.196-.058-.29-.082\"/><path opacity=\".15\" d=\"m145.23 16.656c.335-.075.689-.097 1.019-.22.193-.254.279-.573.48-.824 0 .161 0 .323.004.486-.11.156-.22.307-.327.46.205-.029.413-.049.622-.065.095.104.201.205.323.291.453-.075.885-.24 1.362-.22.378-.043.893-.004 1.153-.366.051-.191-.201-.25-.303-.358-.055-.283-.106-.571-.181-.85-.142-.157-.358-.201-.543-.287-.138.156-.268.317-.39.484-.031-.071-.102-.213-.138-.279l.079-.026c-.09-.018-.268-.057-.358-.073-.114-.181-.248-.35-.327-.547.067-.15.153-.295.22-.445-.441-.053-.874-.087-1.294-.244-.315.382-.59.809-1.027 1.059-.043.165-.083.334-.118.504.043.02.126.057.169.077.031.297-.346.478-.468.738.11.02.323.059.429.079-.15.122-.303.244-.464.35.023.091.05.184.078.276\"/><path opacity=\".15\" d=\"m129.32 29.11c.13.016.264.035.401.055.134.126.271.374.492.268.016-.055.031-.157.043-.209.043.035.13.106.173.144.012.081.043.244.059.325.547.069 1.094.13 1.653.099-.291-.382-.724-.669-.854-1.151-.083-.624.46-1.053.555-1.629-.016-.171-.051-.508-.067-.677.146-.084.291-.171.437-.254-.028-.177-.059-.352-.09-.525.523-.356 1.114-.667 1.488-1.194.275-.374.673-.752.582-1.275-.354-.157-.815-.122-1.074.197-.315.201-.275.63-.519.881-.346.366-.893.362-1.33.527-.476.274-.83.712-1.196 1.118-.134.061-.275.122-.346.26.102.014.311.039.413.053.031.435-.063.901-.472 1.116.161.071.327.149.484.232-.15.067-.299.13-.445.193-.063.126-.126.256-.244.339.067.128.157.252.193.399-.189.104-.39.179-.578.281.002.175.144.293.242.427\"/><path opacity=\".15\" d=\"m128.75 31.423c-.165-.508-.787-.675-1.259-.539-.197.071-.22.342-.091.482.315.428.905.092 1.35.057\"/><path opacity=\".15\" d=\"m123.64 23.2c-.122.077-.212.185-.283.307.205.043.413.088.622.144.13-.049.264-.098.401-.142.106-.126.22-.244.331-.366.193-.096.464-.165.535-.399-.118-.124-.252-.234-.374-.352-.236.098-.468.209-.681.344.024.132.055.266.083.397-.122-.12-.236-.248-.35-.38-.429.106-.85.212-1.263.354.216.365.657.117.979.093\"/><path opacity=\".15\" d=\"m126.08 22.396c.287-.039.598-.031.866-.157.197-.146.224-.409.275-.632-.161-.045-.319-.092-.476-.144.106-.216.201-.441.256-.675-.165-.057-.327-.114-.488-.169-.11.346-.275.71-.146 1.074-.079-.002-.232-.004-.307-.006.004.177.016.532.02.709\"/><path opacity=\".15\" d=\"m178.5 17.977c-.138-.189-.268-.382-.39-.574-.079-.008-.236-.024-.315-.03-.008-.079-.028-.234-.039-.313-.11-.047-.22-.094-.33-.144-.051.033-.161.096-.217.13-.008-.1-.027-.299-.035-.397-.256.091-.22.4-.299.61.323.413.551.903.937 1.269.342.045.543-.296.688-.551\"/><path opacity=\".15\" d=\"m193.85 22.11c.622-.398 1.298-.693 1.964-1.019-.028-.161-.035-.331-.165-.437-.48-.039-.968.016-1.44.026-.193.122-.405.213-.586.356-.114.209-.185.437-.271.657.051.106.102.213.157.319.109.031.223.062.341.098\"/><path opacity=\".15\" d=\"m173.18 18.14c.106.092.154.299.327.287.457.303.657-.134.708-.448.047.028.142.079.189.106.232-.118.456-.254.704-.336.185 0 .327.159.496.226l-.02-.106c.449-.124.885-.458.881-.98.075-.126.126-.264.169-.402-.433-.22-.909-.354-1.401-.268-.15-.161-.37-.216-.575-.25-.095.234-.138.484-.051.728-.433-.161-.889-.258-1.334-.354-.205.207-.413.411-.618.612.024.183.059.37.102.551-.036.11-.071.22-.102.331.171.106.344.208.525.303m2.306-1.68c.212.122.079.46-.154.423-.004-.081-.004-.238-.004-.317.04-.028.119-.079.158-.106\"/><path opacity=\".15\" d=\"m106.62 54.12c-.228.342.083.596.315.718.012-.285.295-.254.504-.289.031-.378.094-.748.11-1.121-.043-.185-.153-.342-.232-.508-.177.043-.342.118-.488.222-.146.022-.287.039-.425.057.126.297.267.57.216.921\"/><path opacity=\".15\" d=\"m122.94 57.984c-.11.307.342.299.531.415.216-.155.441-.297.696-.372-.02-.045-.063-.138-.087-.185.028-.063.079-.187.106-.248-.424.103-.865.166-1.246.39\"/><path opacity=\".15\" d=\"m194.94 117.47c.051.053.149.151.197.203.453.079.917-.071 1.369-.118-.106-.055-.208-.102-.311-.15-.374-.319-.85-.035-1.255.065\"/><path opacity=\".15\" d=\"m206.74 116.53c.008-.018.018-.035.026-.053.086-.395.134-.809.354-1.155.079-.295.118-.614.315-.858.476-.708.76-1.542.87-2.388.11-.464.287-.917.52-1.334.134-.256.201-.551.142-.834.02-.106.043-.213.071-.315-.059-.043-.177-.126-.232-.169.232-.622.283-1.328.665-1.881.008-.075.027-.228.039-.307-.154.195-.323.386-.547.498-.028-.151-.059-.303-.083-.451-.177-.157-.252-.382-.35-.584-.091-.061-.177-.124-.264-.183-.051-.146-.095-.307-.248-.366-.024-.295-.032-.586-.036-.875-.047.02-.149.061-.201.081-.106-.108-.209-.216-.315-.321-.043.065-.126.191-.169.258-.201-.47-.09-1.029-.456-1.425.031-.11.067-.216.106-.323-.315-.187-.637-.378-.877-.657-.311-.12-.594-.295-.83-.525.086-.327.008-.659.008-.99-.008-.256-.04-.518-.181-.732-.319-.484-.173-1.106-.095-1.637-.145-.1-.291-.197-.433-.291-.012-.071-.028-.218-.036-.291-.185.079-.366.169-.555.22-.334-.403-.059-1.023-.157-1.487-.051-.045-.157-.132-.208-.173.024-.13.063-.256.094-.382-.378-.157-.236-.671-.354-1-.185.165-.397.332-.457.59-.079.276-.204.539-.413.748.161.527-.299.966-.24 1.488.008.98-.299 1.952-.885 2.739-.201.14-.476.214-.697.085-.268-.11-.405-.38-.578-.59-.492-.061-.716-.517-1.098-.765-.012-.085-.039-.256-.055-.342-.032.061-.091.185-.118.248-.315-.236-.63-.484-.933-.724.098-.403.398-.72.708-.984-.303-.016-.169-.331-.11-.508.063.032.181.097.244.132.13-.299.275-.588.37-.901-.157-.055-.315-.114-.472-.169-.012.102-.035.301-.043.403-.079-.157-.149-.319-.216-.476-.169.087-.334.26-.543.193-.413-.114-.811-.307-1.228-.397-.311-.205-.626-.515-1.043-.372.138.108.299.191.472.248.055.136.11.273.169.413-.346.242-.759.161-1.153.175-.346.12-.59.401-.822.671.016.045.051.132.071.173-.327.248-.547.59-.775.919.083.122.165.244.248.374-.374-.004-.74-.14-1.078.035-.228-.364-.457-.815-.913-.917-.169.146-.366.213-.586.136-.039.169-.079.34-.122.518-.154-.047-.303-.087-.453-.118-.063.15-.122.301-.169.456-.067.02-.197.057-.26.075-.122.114-.244.228-.366.342-.047.209-.09.421-.142.631-.189-.041-.378-.071-.563-.092-.039.106-.075.215-.11.323.067.079.134.167.197.256-.102.122-.213.24-.319.358-.09-.244-.177-.488-.272-.726-.421.344-.87.762-.716 1.381-.531.372-.7 1.119-1.369 1.31-.661.24-1.373.332-1.991.679-.366.244-.858.057-1.216.307-.35.228-.665.5-1.027.708-.272.15-.429.427-.614.661-.02-.173-.039-.346-.055-.515-.122.197-.303.372-.311.618.063.502-.287.862-.472 1.281.055.466.185.939.331 1.391-.043.104-.087.212-.122.319-.043-.018-.13-.055-.173-.075-.051.145-.094.307-.252.366.024.256.055.516.094.775-.031.466.228.866.327 1.306.02.295.063.889.083 1.19.067.338.232.655.287 1 .031.543-.118 1.078-.232 1.607-.157.006-.319.014-.476.026l.083.48c.24.268.488.543.791.752.275.067.567.09.866.098.382-.132.716-.382 1.114-.48.106-.098.216-.189.342-.264.791-.148 1.578.157 2.365.189.204-.185.366-.415.535-.635.433-.106.822-.34 1.251-.47.338.031.626.088.976.028.476-.047.897-.281 1.354-.392.421-.069.87-.098 1.283-.246.193.134.386.268.579.405.22-.063.453-.045.61.142.126-.026.256-.047.386-.071.114.142.236.281.366.413-.189.027-.209.201-.228.358.145.09.295.187.441.289.071.256.248.459.378.687.039.171-.024.342-.216.374.118.134.236.268.354.407.145-.002.299-.002.453-.004-.028-.102-.055-.203-.079-.299.421-.321.838-.643 1.306-.897.22-.248.437-.502.649-.758.055.033.165.096.224.13-.075.077-.15.158-.22.24.024.049.067.145.09.193-.079.098-.232.295-.307.393-.283.264-.189.7-.421.99-.138.022-.272.037-.405.053-.047.106-.09.214-.134.327.315-.035.559-.122.897-.142.13-.311.272-.622.409-.927.114.224.291.439.307.701-.079.269-.287.474-.457.692.334.03.701-.001 1.019.159.445.437.307 1.092.315 1.655.283.293.393.872.968.661.051.097.106.199.165.301.693-.201 1.299.443 1.995.317.311-.152.63-.313.972-.395.018.011.037.02.056.03.838-1.862 2.567-3.217 4.642-3.536\"/><path opacity=\".15\" d=\"m194.5 95.98c-.083.181-.165.358-.236.543.205 0 .602 0 .807 0 .075-.081.158-.161.24-.24.004-.079.012-.236.016-.315-.272.08-.559.122-.827.012\"/><path opacity=\".15\" d=\"m201.57 122.14c-.136-.043-.275-.072-.426-.052-.252.346-.197.761-.146 1.165-.051.035-.15.108-.201.146-.004.201-.012.602-.016.799.298.203.681.237 1.019.133-.163-.55-.254-1.131-.254-1.735.002-.154.013-.305.024-.456\"/><path opacity=\".15\" d=\"m112.32 21.3c.047.124.09.25.142.374l.098-.016c.276.185.567.34.886.435.205.047.327.222.452.374.26-.014.575-.001.85-.002.142-.169.303-.325.476-.462.008-.075.016-.224.02-.299-.327-.116-.626-.307-.842-.582-.118.027-.232.055-.342.086-.008-.11-.012-.216-.008-.327-.098-.051-.193-.102-.283-.149-.016.102-.047.303-.063.405-.386-.321-.803-.61-1.243-.842-.295.142-.555.398-.913.354.09.177.177.358.244.551.168.058.341.141.526.1\"/><path opacity=\".15\" d=\"m109.52 23.46c.016.148.028.295.043.443.197-.037.393-.081.594-.116-.016.205-.201.222-.362.258-.004.075-.012.228-.016.303.5.173.925.482 1.381.742.114-.266.205-.541.279-.82.134-.095.275-.189.413-.279.016-.134.028-.264.047-.392.22-.069.189-.311.228-.492.043-.043.142-.132.189-.175.083.02.244.055.327.075.177.275.405.516.606.775-.071.149-.157.287-.228.433.161.02.492.055.649.075.028.047.087.144.114.191.342-.1.716-.222.913-.549-.165-.02-.33-.035-.496-.051-.087-.145-.169-.291-.252-.437-.079-.008-.236-.024-.315-.031-.016-.071-.043-.213-.063-.283-.11-.087-.217-.183-.315-.279-.012-.041-.039-.126-.051-.167-.354-.234-.708-.462-1.066-.681-.075-.179-.146-.36-.208-.545-.067.002-.205.004-.272.006-.031-.183-.138-.344-.295-.435-.213-.018-.429-.008-.642-.018-.161.325-.118.687-.012 1.023-.165-.187-.323-.38-.5-.549-.299-.041-.366.397-.642.474.059-.136.126-.27.193-.403-.496.189-1.137.14-1.468.626 0 .224.169.417.248.626.165.384.601.552.979.652m.48-.281c.004-.079.016-.244.02-.327.083 0 .244-.004.323-.004.047.067.134.197.181.262-.24.218-.535.36-.866.319.11-.085.224-.168.342-.25\"/><path opacity=\".15\" d=\"m34.22 86.66c-.059.008-.181.016-.24.024.035.099.075.197.114.297-.059.037-.185.112-.244.151.13.016.268.031.401.045-.083.136-.173.266-.264.403.09.004.268.014.358.02.059-.037.181-.114.244-.151-.11-.159-.216-.321-.331-.474-.007-.076-.031-.234-.038-.315\"/><path opacity=\".15\" d=\"m215.34 92.58c-.083-.315-.248-.622-.578-.716.031.197.071.393.11.594.153.039.307.086.468.122\"/><path opacity=\".15\" d=\"m216.98 93.38c-.153-.303-.425-.517-.653-.757-.149-.001-.295-.016-.437-.022.24.256.508.498.748.771.086.003.255.005.342.008\"/><path opacity=\".15\" d=\"m214.62 93.06c.016.193.035.386.035.578.094.037.193.079.295.116-.024-.057-.079-.173-.11-.23.071-.012.212-.035.279-.047.086.108.169.22.26.331.145-.26-.15-.48-.217-.72-.145-.053-.291-.102-.429-.155l-.012-.108c-.102-.045-.205-.089-.303-.126-.051.195-.102.389-.15.586.116-.078.23-.154.352-.225\"/><path opacity=\".15\" d=\"m217.74 93.16c-.354.024-.295.58-.315.791.149.171.291.346.448.514-.07-.433-.192-.862-.133-1.305\"/><path opacity=\".15\" d=\"m216.38 94.55c.177.032.531.091.708.122.036-.144.075-.283.118-.425-.287-.047-.567-.099-.838-.15 0 .15 0 .3.012.453\"/><path opacity=\".15\" d=\"m217.55 95.12c.075.079.153.154.232.238.083.002.248.012.331.014-.004-.081-.016-.242-.02-.323-.193-.083-.382-.165-.567-.254.008.083.016.244.024.325\"/><path opacity=\".15\" d=\"m136.56 54.712c-.043.158.016.218.177.175.043-.165-.016-.222-.177-.175\"/><path opacity=\".15\" d=\"m106.98 83.76c-.055-.031-.161-.097-.217-.128-.09.148-.185.295-.271.449.094.004.279.008.37.008.036-.11.075-.22.118-.329\"/><path opacity=\".15\" d=\"m136.24 96.9c-.13.11-.256.228-.386.344.02.138.067.277.051.425-.11.199-.291.329-.453.482-.11-.037-.213-.071-.315-.1-.016.15-.027.299-.039.451-.051.039-.15.114-.201.154-.008.142-.016.283-.02.425-.098-.027-.193-.051-.287-.073-.165.279-.48.399-.732.578-.402.297-.933.301-1.385.466-.236.35-.319.781-.472 1.176-.11.669.287 1.318.165 1.999-.153.37-.315.752-.59 1.049-.154.364-.437.722-.217 1.143.122.586.138 1.196.295 1.783.228.242.563.417.889.482.421-.197.826-.427 1.263-.596.342-.692.641-1.401.897-2.127.468-1.013.917-2.036 1.346-3.067.153-.305.106-.681.169-.999.102-.197.291-.378.268-.618-.016-.187-.047-.557-.059-.744.126.169.244.344.366.52.118-.173.201-.37.275-.563-.315-.449-.201-1.035-.327-1.539-.123-.374-.328-.7-.501-1.051\"/><path opacity=\".15\" d=\"m112.89 40.15c.039-.153.087-.307.138-.456-.083.008-.24.027-.319.037-.079.069-.158.142-.232.212.043.148.083.301.126.455.094-.082.188-.165.287-.248\"/><path opacity=\".15\" d=\"m113.5 38.08c.216-.043.083-.382-.098-.327-.213.059-.091.366.098.327\"/><path opacity=\".15\" d=\"m52.47 72.24c.205 0 .606-.006.811-.008.122-.144.248-.287.37-.433-.33-.069-.673-.165-1.01-.13-.205.123-.15.371-.174.571\"/><path opacity=\".15\" d=\"m9.823 35.03c-.035.177-.106.535-.142.716.205-.106.409-.209.626-.289-.146-.159-.315-.297-.484-.427\"/><path opacity=\".15\" d=\"m13.844 41.707c-.071-.004-.209-.014-.276-.02-.086.116-.161.238-.244.356.04.11.083.22.122.335.342-.059.681-.124 1-.25.158.006.323.014.484.018 0-.155.004-.311.008-.466l.594-.001c-.055-.157-.11-.309-.161-.46-.507.17-1.014.345-1.53.497\"/><path opacity=\".15\" d=\"m9.933 38.773c.004-.157.004-.313.008-.468-.185.012-.555.027-.74.035.09.145.181.287.279.431.15 0 .303 0 .453.002\"/><path opacity=\".15\" d=\"m208.64 91.49c.425.307.976.49 1.507.364.425-.195.826-.447 1.279-.596.161-.051.165-.24.22-.37.275-.193.63-.464.46-.842-.205.049-.405.092-.602.13-.016.14-.028.279-.031.423-.48.266-.921.608-1.464.72-.031-.067-.094-.203-.122-.27-.016.063-.039.193-.055.26-.433-.067-.85-.055-1.271.03.02.037.059.111.079.151\"/><path opacity=\".15\" d=\"m200.26 93.1c-.157.201-.283.425-.401.647.287-.008.582-.018.878-.029.248-.203.484-.279.846-.216.193.246.393.494.594.744.035.047.114.138.153.181.299-.012.602-.008.901-.043.33.12.637-.008.909-.193.012-.079.028-.232.039-.313.047.02.134.061.181.083.059-.293.224-.541.421-.754.181-.043.362-.087.547-.132.374.124.744.23 1.133.354.145.372.326.738.555 1.072.161.149.303.321.437.5.496.118 1.031.124 1.495.362.13.055.264.15.417.12.11-.077.157-.181.142-.315-.181-.108-.382-.179-.571-.258.039-.11.079-.22.122-.329-.165-.014-.327-.018-.48-.026.031-.157.075-.313.114-.468-.165.031-.323.075-.476.12-.102-.285-.193-.58-.268-.872-.181-.13-.366-.26-.492-.441-.079-.209-.13-.425-.177-.637.181-.006.543-.02.72-.024-.004-.154-.004-.303-.004-.449-.433-.161-.815-.45-1.279-.516.035-.153.075-.301.126-.445-.145-.315-.409-.543-.712-.689.098-.216-.283-.36-.421-.222-.193-.222-.464-.474-.791-.411-.468-.108-.897-.35-1.338-.519-.346-.161-.72-.315-1.11-.287-.464-.283-.948-.551-1.456-.744-.24.001-.448.157-.665.238-.008.081-.028.238-.035.317-.213.061-.425.12-.634.177-.224.315-.507.582-.759.872-.083.006-.256.012-.342.016-.102-.22-.193-.445-.264-.675-.079-.008-.236-.033-.319-.043.035-.567.114-1.125.122-1.692-.346-.061-.551-.146-.846-.248l-.012-.102-.106-.063-.102.039c-.047.004-.153.012-.201.012l-.094-.043-.122.051-.024.098c-.036.028-.114.087-.15.112l-.083.008-.032.077-.071.047c-.055-.008-.169-.028-.224-.039l-.106.069-.016.086c-.067.026-.201.073-.268.095-.031-.159-.279-.173-.386-.092-.075.098.016.295.142.291.051.071.149.211.201.277.016.179.378.171.504.077.126.181.205.386.291.586.417.091.826.118 1.251.055-.043.095-.083.189-.122.285-.464-.222-.846.348-1.33.206.153.114.323.209.48.323.11.236.169.492.173.765.075.002.232.006.307.001.087-.157.173-.311.264-.464.295.199.586.403.889.602.279.193.63.224.944.346.398.15.787.344 1.145.582.26.22.189.586.295.878.047.043.142.13.189.171-.051.211-.102.419-.146.63-.165.063-.342.118-.492.212\"/><path opacity=\".15\" d=\"m212.85 90.22c.114-.319-.248-.488-.429-.675.004.372-.039.714.008 1.096.142-.136.291-.268.421-.421\"/><path opacity=\".15\" d=\"m213.84 91.03c.02-.146.039-.293.063-.439-.275.226-.244.612-.331.931.059.039.177.126.236.167-.035.1-.063.199-.09.297.071.083.146.161.22.248.157-.087.315-.169.472-.252-.086-.365-.326-.674-.57-.952\"/><path opacity=\".15\" d=\"m77.58 30.535c.035.144.087.285.138.423.299.087.586.197.885.272.02-.067.059-.201.083-.27 0-.183.02-.368.043-.549-.374.038-.838-.143-1.149.124\"/><path opacity=\".15\" d=\"m77.38 33c-.13.075-.26.145-.386.209.02-.209.212-.291.362-.401-.039-.185-.086-.366-.134-.547.15-.049.303-.094.461-.134.094.193.189.387.275.586.366.201.763.059 1.137-.001-.031-.297-.09-.59-.138-.885-.083-.008-.24-.022-.323-.031.024-.049.067-.148.09-.199-.366-.185-.728-.374-1.102-.531-.158-.268-.311-.539-.512-.779.146-.049.287-.098.433-.146.051-.102.102-.203.157-.303.299.201.61.415 1.01.346.043-.055.13-.165.173-.22.138-.012.279-.026.417-.035.047-.11.095-.217.146-.323-.099-.001-.291-.031-.386-.043.279-.256.657-.323 1-.45-.142-.116-.307-.201-.48-.258.02-.035.051-.108.071-.146-.134-.114-.264-.226-.362-.368.165.026.334.061.504.094-.059-.317-.079-.612-.13-.921-.201-.002-.606-.001-.807-.014.004-.083.008-.248.008-.331.197-.12.386-.256.594-.352.342-.047.834.199.586.675l.063.004c.032-.401.405-.781.15-1.177-.126.051-.252.104-.378.159-.158-.108-.315-.226-.457-.356.165.02.334.047.504.083-.012-.079-.031-.232-.039-.309-.217-.045-.429-.097-.646-.134-.106.144-.205.305-.378.374.11-.38.256-.749.264-1.153.063-.022.189-.065.252-.085.11-.126.228-.236.366-.333-.086-.167-.161-.34-.22-.517.165-.014.33-.028.496-.039.055-.132.11-.264.169-.398.153-.124.303-.256.449-.395-.185-.037-.547-.112-.728-.15l.004-.079c.331-.049.681-.088 1.019-.142.012-.077.035-.226.047-.301.287-.098.799-.201.767-.59-.61-.264-1.295-.429-1.948-.256-.047.145-.094.293-.134.441-.303-.075-.602-.142-.901-.207-.15.272-.346.517-.602.702.067-.236.181-.464.216-.708-.016-.158-.071-.307-.106-.457-.094-.118-.185-.232-.268-.354.094-.118.189-.232.287-.35-.378-.224-.787-.382-1.176-.586-.067-.244-.26-.443-.476-.563-.641-.244-1.255-.673-1.971-.602-.61.032-1.444-.094-1.865.474-.055.006-.173.018-.228.026.031.146.067.295.11.441-.047.11-.091.224-.134.339-.397.041-.724-.163-1.078-.287-.484-.075-.945.092-1.401.22-.244.036-.464.122-.661.264.13.083.26.161.39.244-.232.049-.46.106-.685.181-.008.047-.024.138-.032.185.468.272 1.063.364 1.428.799-.094.008-.279.022-.374.031-.134-.106-.26-.216-.402-.309-.441-.065-.87-.165-1.275-.342-.295-.128-.614.014-.909.061.153.24.346.461.508.701-.488-.006-.909-.321-1.397-.366.035.205.067.413.094.622-.181-.246-.327-.518-.567-.708-.858.283-1.775.323-2.664.464.028.273.059.547.083.824-.193-.081-.382-.167-.567-.256-.559.181-1.023.553-1.531.832.016.177.051.441.279.441.571-.271.559.264.677.559-.13.116-.256.236-.378.358-.315.026-.657.037-.964.073-.386.252-.87.287-1.314.325-.047.138-.099.277-.142.415.323.22.653.433.964.679.153.026.307.051.464.079-.327.214-.74.244-1.117.248.142.299.472.382.756.496-.13.083-.26.165-.386.254.287.124.582.333.905.317.027-.031.079-.098.102-.134.079 0 .158 0 .236 0 .028.035.075.102.102.134.283-.027.555-.134.846-.138.696-.039 1.326.287 1.893.657-.028.053-.083.163-.11.216.047.108.094.216.142.327.071.016.22.047.291.065.075.132.161.262.244.395-.157.108-.303.228-.448.344.161.047.327.102.488.159-.039.11-.079.224-.114.334.04.031.122.094.161.126-.051.264 0 .529.047.791-.106.055-.216.112-.323.165.016.043.051.13.071.173-.145.173-.287.35-.433.519.079.096.067.338.244.309.452.281.555-.124.72-.362.079.173.161.35.244.529l-.075.039c.161.018.323.032.488.045.134.183.311.388.122.6-.401-.224-.838-.405-1.314-.378.059.134.122.268.185.398-.043.001-.134.028-.177.035-.051-.016-.146-.043-.193-.059-.039.252-.095.5-.134.751.161.047.331.095.417.256.327-.028.696-.035.98-.224-.067-.287-.389-.398-.586-.59.036-.035.099-.104.13-.142.087.083.169.163.252.248l.102.012-.016.126c.086.004.248.016.334.024.051.262.106.527.134.799l-.122.004c-.004.085-.016.256-.016.343-.374-.016-.704.073-1.019.256-.004.079-.016.236-.02.315-.327.153-.291.618-.358.925.09.004.271.014.362.017-.094.215-.256.425-.228.675.055.106.118.205.197.303-.016.041-.055.126-.071.167.079.001.24.028.323.037.272.586.331 1.245.598 1.838.051.134.193.197.295.291.071.193.15.386.228.58.307.391.523.883.964 1.155-.024.099-.047.201-.071.303.398-.11.811-.11 1.208.028.236.272.425.649.811.724.201.102.405-.008.598-.075.039-.209.099-.413.185-.606.122-.555.398-1.09.252-1.677.173-.126.343-.256.508-.391.279-.352.287-.817.378-1.237-.134-.079-.264-.158-.394-.234l.61-.027c.004-.15.008-.301.016-.451.173.032.35.114.531.083.15-.083.268-.209.386-.331.012.098.024.293.035.392.161-.104.323-.218.48-.332.291-.085.566-.213.854-.317.331-.447.397-1.132.921-1.415.008-.063.024-.191.032-.256.244.026.492.039.744.043.146-.173.37-.218.571-.291.449-.154.913-.283 1.322-.531.476-.531 1.015-.999 1.554-1.468-.531.11-1.066.063-1.593-.078\"/><path opacity=\".15\" d=\"m119.96 70.23c-3.384 0-6.127-2.727-6.127-6.103 0-.827.164-1.613.456-2.332-.044.026-.083.06-.129.083-.208.097-.393-.087-.555-.181-.33-.203-.645-.521-1.054-.494-.043-.203-.429-.181-.559-.059-.11-.059-.212-.122-.311-.193-.216-.205-.224-.541-.429-.752-.622-.272-1.283-.573-1.979-.441-.165-.102-.346-.161-.535-.165v-.102c-.299-.055-.315-.391-.382-.622-.138.045-.217.142-.232.283-.153-.134-.492-.209-.409-.468.161-.156.354-.272.523-.421.122-.22.169-.464.138-.724-.106-.108-.212-.213-.307-.327-.118-.25.157-.413.299-.571.004-.079.016-.232.024-.311-.153.075-.303.151-.453.228-.091-.161-.181-.321-.268-.48-.319.067-.665.126-.901.372-.508-.144-1.023.024-1.523-.094-.224.116-.453.218-.685.321-.193-.085-.378-.226-.594-.232-.708.051-1.397.232-2.097.338-.405.051-.744.287-1.066.519-.224.036-.464.047-.645.201-.264.205-.523.425-.846.535-.157-.09-.319-.177-.472-.269-.417.029-.83.053-1.24.073-.142-.181-.283-.358-.401-.551-.13.04-.26.079-.382.116-.165.468-.39.915-.657 1.336-.429.453-1.137.523-1.515 1.041-.209.167-.268.435-.394.657-.126.226-.295.437-.338.701-.024.309.079.641.031.956-.303.604-.838 1.037-1.369 1.43-.323.246-.807.157-1.086.476l-.134.012.094.065c-.114.222-.209.453-.319.675-.09.199-.33.228-.508.317-.228.419-.516.832-.519 1.334-.213.214-.429.427-.626.651-.303.488-.425 1.074-.795 1.523-.154.177-.169.413-.185.637l.012.124h-.114c.004.096.012.289.016.388.035-.071.11-.209.15-.279.04.095.083.193.126.291.099.106.189.22.272.342.059.295-.102.574-.173.856.268.352.338.824.264 1.253-.083.339-.291.642-.299.996l-.106.02c.126.598-.244 1.094-.681 1.448.378.236.508.673.563 1.092l-.126-.008c0 .061 0 .183 0 .242.004.161.012.48.016.642.039.035.106.106.142.142l.098-.001c.067.134.146.262.224.394.15-.037.303-.077.453-.114 0 .142 0 .283.008.425.047.039.142.114.193.155.024.087.067.26.09.35.016-.049.043-.146.059-.193.291.612.905.982 1.2 1.597-.024.177-.039.354-.051.535.059.043.181.126.24.169.02.177.036.354.043.535.24.098.48.201.728.287.13.1.26.203.394.303l-.008.106c.409.283.846.547 1.196.909.413.431.905.807 1.503.944l.059-.008c.645-.216 1.244-.602 1.944-.63.476-.075.96.067 1.44.09.216.09.441.26.692.193.543-.216 1.066-.49 1.613-.708.248-.035.46-.14.637-.307.142-.051.287-.098.433-.134.236-.047.476-.091.72-.118.417-.031.83-.033 1.251.012.484.5.578 1.247 1.078 1.739.563-.112 1.129-.216 1.708-.291.035-.031.118-.09.157-.118.114.209.256.405.37.618.138.014.272.029.413.047-.02.039-.047.126-.063.169.24.37.213.795.169 1.228l.071.079c-.13.275-.275.543-.405.826l.114.014c-.024.183-.055.368-.083.553.067.063.138.128.205.197-.252.043-.213.311-.248.508-.138.094-.268.185-.405.277.197.433.327.907.598 1.308.346.407.7.807 1.023 1.243l.055-.059c.244.348.476.71.701 1.074.035.212.083.423.153.63.032.045.094.13.126.175l-.09.022c.323.594.516 1.239.744 1.873.086.273-.276.476-.169.756.118.468.346.897.5 1.358.114.319-.106.634-.114.948-.063.264-.303.401-.496.559-.279.551-.559 1.102-.602 1.735-.205.618-.283 1.259-.276 1.916.012.421.051.885.327 1.234.547.718.72 1.635 1.208 2.394.145.268.338.535.409.842.02.466-.11.933.02 1.399.284 1.021.197 2.2.87 3.079.118.09.35.275.464.368.075.254.189.498.279.751.13.372.185.769.405 1.112.24.448.618.891.425 1.452-.039.026-.126.083-.165.114-.146.327.185.598.311.874-.043.11-.087.218-.126.331.094-.026.197-.047.299-.065.091.118.224.189.358.258.063.102.126.209.193.315.05-.004.096-.019.144-.03-.345-.764-.542-1.61-.542-2.505 0-3.412 2.741-6.154 6.127-6.154 1.414 0 2.711.482 3.749 1.285.056-.118.14-.222.249-.294.527-.419 1.287-.403 1.739-.936.031-.496.09-.992.102-1.485-.153-.588-.161-1.251-.551-1.753.055-.138.106-.279.157-.417.693-.543 1.373-1.11 1.905-1.818.539-.362 1.255-.46 1.716-.96.315-.425.708-.834.822-1.373-.15-1.188-.205-2.408-.067-3.605l-.086.051c-.138-.157-.287-.299-.461-.417-.142-.614-.413-1.21-.33-1.85.008-.252.126-.484.177-.728-.158-.102-.311-.213-.468-.313.004-.502.15-.97.256-1.45.043-.012.134-.035.173-.049.22-.565.461-1.12.641-1.694.071-.02.205-.053.272-.071.15-.315.574-.409.653-.744.811-1.141 1.633-2.353 2.876-3.06.453-.27.767-.708 1.102-1.108.535-.653.98-1.385 1.326-2.156.244-.626.484-1.265.834-1.84.185-.336.37-.679.456-1.053.012-.268.079-.515.205-.746-.039-.36-.063-.728.02-1.082-.114-.041-.228-.085-.338-.126-.649.687-1.641.592-2.491.742-.15.085-.295.181-.46.224-.614-.028-1.173.291-1.779.307-.212-.236-.382-.504-.531-.781-.043-.002-.13-.002-.177-.004l-.012-.147c-.09-.004-.272-.008-.362-.012.181-.146.362-.295.535-.453-.094-.177-.197-.35-.35-.478l.055-.065c-.185-.099-.362-.209-.48-.374-.299-.394-.634-.765-.944-1.145-.252-.094-.496-.21-.748-.299-.016-.079-.047-.238-.059-.319-.102.03-.204.059-.307.092-.374-.701-.398-1.533-.85-2.194l.055-.063c-.279-.173-.543-.368-.819-.537-.228-.659-.342-1.346-.331-2.036-.161-.24-.275-.508-.334-.787-.279-.248-.547-.508-.834-.744-.028-.236-.319-.653.039-.748-.126-.154-.231-.322-.341-.486-.955 2.14-3.102 3.627-5.604 3.627m2.943 23.49c-.028.041-.087.128-.114.171-.055-.043-.153-.13-.204-.173l-.059-.069-.02-.088c-.067-.238-.142-.474-.205-.712l-.008-.077-.055-.043c-.13-.12-.264-.238-.39-.36-.004-.047-.012-.146-.012-.193l-.091-.051c-.106-.702-.094-1.417-.197-2.117.047.016.146.045.193.061l.031.088c.028.024.079.075.102.102l.031.108v.104c-.079.154-.047.283.087.386l-.008.122c.008.055.02.169.028.228l.019.098c.004.039.012.116.02.157-.004.039-.008.124-.012.167 0 .033-.004.096-.004.132 0 .039 0 .124 0 .165.138.159.291.309.441.464.016.03.043.094.055.126l.012.077c-.02.024.012.092.012.092l.024.102c.004.055.012.161.016.216l.087.067.031.094c.016.043.047.124.063.165.016.043.051.134.063.177.02.028.063.087.083.118l-.019.096m2.456 1.411c-.059.15-.024.279.102.382.008.059.024.177.035.24 0 0-.028.185.008.216.02.03.071.087.094.118.012.033.039.1.055.136l.012.092c-.004.047-.016.147-.024.197-.008.035-.031.104-.043.14-.012.033-.035.096-.047.132-.016.075-.047.228-.067.303l-.043.106.075.63.075.047.043.071c.024.028.067.079.091.102-.063.116-.106.24-.138.37-.039-.016-.122-.047-.161-.067-.142-.425-.248-.866-.323-1.306-.083-.327.075-.637.138-.95.134-.334.094-.604-.122-.805-.043-.205-.071-.405-.095-.606l.079.047c.027.02.083.059.11.079.028.029.083.081.11.106.008.052.028.165.036.22m-.787-8.551l.071-.039c.126.14.307.22.492.244l.024.09c.012.039.039.114.051.154l.039.075c-.016.043-.051.128-.067.167-.008.059-.024.175-.031.232l-.016.106-.012.097c-.027.031-.083.094-.11.126-.024.033-.071.094-.098.122l-.09.043c-.012.047-.039.144-.051.193-.02.028-.063.087-.083.116-.016.022-.04.065-.051.085l-.031.043.067.039c.012.071.039.216.055.287l-.095.012-.102.012-.11.008-.11-.016c-.095.004-.279.001-.37.012l-.004-.098-.09-.045c-.024.033-.083.1-.114.132-.028.016-.091.043-.118.055l-.071.028-.036-.087c.075-.202.071-.439-.051-.616.004-.057.024-.171.031-.226.036-.031.106-.095.142-.126l.004-.098c-.027-.04-.079-.114-.102-.154l-.043-.09.008-.095.036-.083c.024-.033.075-.095.102-.126.028-.039.083-.122.114-.161l-.031-.102c.035-.016.114-.043.153-.059.051-.016.154-.043.201-.061.158.051.283.006.378-.132.028-.017.087-.048.119-.064\"/><path opacity=\".15\" d=\"m115.64 59.752c-.028.006-.056.003-.084.012-.405.085-.736.356-.992.667-.002.225.027.445.058.666.278-.494.62-.948 1.018-1.345\"/><path opacity=\".15\" d=\"m111.87 51.32c.219.172.481.254.751.307-.229-.154-.442-.328-.647-.512-.03.058-.079.155-.104.205\"/><path opacity=\".15\" d=\"m169.98 72.7c.232.362.563.677.653 1.114.114.553.291 1.09.46 1.631.276.266.39.639.519.99-.086 0-.256.002-.342.002l.004.11c.083.006.252.014.334.02-.055.23-.122.462-.201.687.106-.035.22-.069.334-.102-.039.279.008.598-.201.822.043.23.075.464.114.7-.173.565-.157 1.155-.145 1.743.083-.171.161-.346.248-.518.146.215.283.441.362.691.043-.016.126-.051.173-.071.016.071.051.209.067.279.264.209.445.492.661.748.075.293.063.594.043.893.035.024.102.071.138.09-.012.039-.039.114-.051.154.039.047.126.138.165.183.016.561.378.993.626 1.47.35.618 1.086.834 1.542 1.354.161-.022.492-.061.661-.079-.169-.464-.441-.874-.685-1.299-.09-.47-.031-.952-.051-1.425-.146-.466-.515-.816-.815-1.18-.043-.001-.126-.024-.169-.031-.181-.183-.35-.374-.512-.569-.138-.02-.275-.039-.405-.059-.142-.12-.287-.234-.437-.34.047-.285-.032-.571-.106-.842-.232-.177-.264-.484-.334-.744-.146.031-.287.063-.425.098-.051-.348-.13-.716-.016-1.052.035-.179.118-.358.063-.541.327-.575.307-1.251.307-1.893.177 0 .358 0 .539.016.012.224.024.451.035.679.083.001.252.029.331.037.114-.045.228-.09.346-.136.134.163.272.325.409.492l-.099.028c.102.014.311.045.413.059.118.293.236.594.358.891.157.032.248-.039.271-.205.197.142.102.378.075.58.102-.033.209-.065.315-.097.118.051.236.098.358.15.134.104.279.201.429.299-.095.397-.102.797-.047 1.208.193-.114.354-.268.504-.441.189-.075.334-.214.445-.382.047.016.142.059.189.075.095-.252.161-.508.216-.771.126.008.272.077.386-.016.327-.207.634-.441.952-.665.161-.112.307-.299.26-.504-.059-.567.067-1.141-.138-1.692-.244-.757-.563-1.554-1.224-2.036-.437-.413-1.047-.722-1.216-1.344-.263-.206-.563-.429-.633-.775-.138-.448.197-.756.389-1.094.209-.417.618-.669.901-1.023.24.008.484.004.732-.012.11.256.405.053.61.047-.157.372.028.728.185 1.063.146-.036.291-.075.441-.118-.079-.151-.157-.303-.228-.454.208-.293.507-.506.881-.525.051-.035.142-.102.189-.138.409-.016.763-.238 1.122-.429-.039-.146-.071-.291-.114-.429.146.126.299.248.468.354.138-.071.252-.181.37-.279.421-.001.838-.065 1.24-.211.055-.175.114-.348.177-.521.299-.088.547-.279.759-.508-.035-.118-.071-.236-.098-.356.145.026.291.053.437.085.039-.262.161-.498.366-.665.09 0 .264.008.354.008-.004-.071-.012-.208-.016-.275-.055.012-.161.04-.213.053-.008-.167-.047-.331-.086-.49.102-.114.201-.234.307-.35-.028-.051-.079-.154-.102-.205l.087-.026c.067-.256.204-.765.271-1.023.079-.006.24-.018.319-.024-.122-.329-.039-.667-.02-.999-.094-.313-.413-.439-.649-.622-.126.041-.252.085-.374.124.106-.268.287-.52.606-.523-.153-.329-.468-.519-.732-.748.177.012.354.035.535.055-.232-.315-.59-.496-.87-.756-.35-.397-.602-.874-.956-1.255-.291-.205-.586-.378-.897-.535-.004-.228.039-.453.213-.618.004-.045.016-.138.024-.183.197.065.445-.222.338-.415.197-.126.382-.264.582-.393.055.035.177.106.232.142.004-.088.008-.269.008-.36-.512-.218-1.051-.376-1.598-.474-.063.165-.126.329-.181.496-.216-.024-.445-.043-.634-.161-.145-.209-.252-.445-.386-.661-.417-.031-.87.051-1.247-.146-.142-.157-.177-.37-.248-.559.358.073.72.063 1.043-.114-.035-.118-.075-.232-.11-.346.173-.126.35-.252.531-.374.047-.161.102-.315.165-.472.291.024.563.13.819.272-.035.23-.079.464-.122.696.067.026.197.081.264.106-.031.169-.039.608.256.441l.028-.063c.165-.197.331-.397.5-.594.193-.012.386-.02.582-.031.287.134.645.177.874.415.138.305.244.63.315.958.216.13.425.264.645.394 0-.053.004-.157.004-.212.067.016.201.041.268.055l.004.112c.279.081.578.173.767.409.039.146-.146.218-.213.325.102.053.201.104.303.158.118.228.271.443.37.685.051.362.11.736.153 1.104.102-.001.205-.018.311-.02.039-.033.11-.089.15-.12.429.063.803-.22 1.141-.448.019-.386-.177-.695-.315-1.031-.256-.712-.933-1.161-1.503-1.601-.271-.327-.708-.433-1.07-.608-.039-.14-.099-.274-.106-.417.185-.273.39-.533.579-.809-.158-.134-.468-.398-.626-.527.035-.181.087-.358.165-.525.158-.242.228-.527.224-.818.134.047.268.092.405.14.059.092.126.187.193.279.291.075.563.258.874.254.181-.088.539-.261.716-.346-.11-.734.468-1.248.669-1.895.067-.315-.138-.633-.027-.944-.004-.382.287-.647.378-.99-.095-.494-.26-.978-.362-1.468-.106-.35.008-.714.063-1.061.236-.122.386-.339.48-.582-.094-.012-.287-.031-.386-.039.031-.055.094-.161.126-.216l-.02-.102c-.051-.039-.145-.114-.189-.15.024-.098.047-.197.079-.295-.547-.201-1.176-.327-1.554-.807-.15-.067-.299-.142-.437-.216-.22.031-.445.028-.661-.022-.043.175-.09.352-.134.531-.153.002-.303.006-.448.008-.008-.085-.02-.25-.024-.336-.075-.012-.217-.035-.287-.047-.083-.087-.161-.169-.24-.248.016.146.036.291.051.437-.307-.165-.456-.496-.712-.718-.185-.033-.366.029-.539.071-.161-.041-.319-.081-.472-.116-.008-.504.421-.874.472-1.36-.004-.494.185-.954.429-1.371-.075-.087-.138-.175-.193-.268.095-.303.197-.604.24-.921.626-.116 1.267-.214 1.912-.181.122.041.244.098.366.151.024-.041.063-.128.087-.167.547-.132 1.129-.187 1.684-.037-.079-.155-.15-.311-.22-.466.685.063 1.416-.045 2.066.242.012.081.035.238.043.317.106.043.217.091.327.138.268-.163.547-.305.819-.468.055.032.173.102.232.134.122-.077.24-.153.362-.232-.22-.126-.46-.273-.72-.161-.118-.153-.236-.311-.311-.492-.035-.519.051-1.043-.035-1.562.366-.138.744-.244 1.122-.338.086.077.173.151.268.222.086-.083.169-.167.252-.25.035.167.102.504.138.677.071.079.146.161.225.246.043-.018.122-.053.165-.071.051.171.134.333.248.474.193-.338.323-.704.409-1.08.15.022.303.051.456.081-.271-.331-.488-.706-.622-1.118.236-.083.496-.161.732-.018-.047.12-.09.238-.13.36.165.331.263.72.535.995.138.449-.331.653-.386 1.035-.087.362-.149.73-.232 1.094.142.484.04.992-.268 1.385.051.039.154.122.205.161.008.929.559 1.727.744 2.625.165.63.161 1.33.559 1.883.268.455.504.954.909 1.31.15-.333.335-.653.445-1 .028-.214-.059-.423-.059-.635.027-.146.142-.246.216-.366.094-.008.283-.024.378-.031-.083-.224-.201-.433-.26-.665.063-.185.244-.303.366-.448.177-.035.523-.102.697-.134-.016-.079-.047-.23-.059-.307-.366-.22-.618-.645-.555-1.084.169.03.334.061.508.089-.118-.309-.366-.557-.701-.594-.264-.283-.338-.673-.527-.996-.213-.073-.433-.079-.645-.035-.126-.158-.252-.313-.334-.488-.043-.218.047-.431.055-.645-.075-.279-.248-.52-.315-.801.153-.112.354-.097.539-.126.079.073.158.144.244.218.028-.203.016-.427.165-.588.275-.002.358.321.531.492.012-.086.04-.261.055-.352.114-.11.232-.222.354-.336.256-.049.515-.098.779-.151.37.205.74.429 1.121.616-.039-.289-.169-.624.15-.85.209-.368.402-.751.649-1.1.165-.153.5-.456.669-.612.394-.384.689-.95 1.291-1.057.271-.001.815-.031 1.086-.039.043-.226.098-.453.158-.673-.15-.055-.295-.104-.441-.15-.016-.071-.043-.208-.059-.279-.213-.098-.429-.185-.606-.331-.291-.358-.578-.738-.984-.968-.161.063-.295.193-.464.206-.169-.059-.323-.146-.476-.224.004-.081.012-.246.016-.327.24-.061.614-.065.874-.175.212-.26.409-.543.543-.858.09-.216.252-.441.161-.687-.059-.167-.063-.388-.252-.454-.272-.09-.539-.177-.795-.303.146-.339.402-.602.701-.805-.295.494.177.616.448.769.205.091.398.228.622.283.394-.165.72-.464 1.102-.661.252-.081.567-.138.85-.114.366.203.665.559 1.094.645.413-.035.803-.142 1.232-.098.047.051.138.153.189.205.307-.028.653-.02.972.004.181-.215.374-.413.535-.645-.193-.014-.575-.043-.767-.057.04-.279.13-.541.256-.793-.165-.236-.315-.492-.362-.783.268-.098.59-.095.811-.293.26-.407-.031-.895.134-1.334-.071-.018-.212-.053-.283-.071-.236-.242-.594-.281-.901-.384-.476-.047-.893-.295-1.358-.376-.476.144-.952.327-1.436.421-.366.073-.626.364-.909.574.637-.185.83.443 1.074.848-.264-.055-.52-.108-.771-.163-.315-.329-.712-.577-.917-.986-.154.012-.315.024-.334.209-.161-.264-.445-.448-.76-.405-.744.108-1.499.094-2.243.126-.378-.039-.751-.205-1.129-.071-.04-.049-.118-.144-.158-.191-.952-.006-1.83-.342-2.699-.663-.917.059-1.85.114-2.719-.191-.063.112-.118.228-.173.342-.96.167-1.924.346-2.908.287.071.12.149.242.232.36.02.126.047.252.075.378.449.138.783.482 1.149.765-.087.189-.173.376-.26.561-.153-.004-.303-.008-.449-.012-.09-.146-.181-.291-.268-.435-.291-.041-.582-.092-.866-.171-.122-.122-.209-.272-.299-.415.169-.001.334-.022.508-.033-.043-.189-.098-.374-.142-.559-.307-.002-.606 0-.901.004-.047.268-.098.531-.145.797-.653-.026-1.366.295-1.96-.089-.035.047-.114.142-.149.189-.327.051-.681.106-.996.161-.039.051-.118.153-.157.205-.374-.086-.751-.154-1.118-.244-.079-.252-.118-.547-.35-.712-.523-.594-1.389-.698-2.129-.567-.756-.043-1.291.659-2.046.586-.291-.319-.598-.626-1.019-.752-.216-.197-.46-.382-.756-.437.09-.169.181-.334.264-.508-.26-.201-.496-.429-.779-.584-.177-.033-.358-.033-.531-.041-.197-.116-.39-.232-.582-.342-.634-.415-1.401-.5-2.074-.834.031.193.071.386.09.582-.149.161-.378.128-.571.153-.122.211-.224.431-.26.675.122-.029.252-.055.378-.083-.161.427-.036.86.098 1.281-.102.031-.205.047-.303.051-.067-.106-.13-.213-.185-.323-.055.031-.161.095-.216.124-.268.006-.527.049-.779.116-.441-.36-.724.402-1.149.344-.299-.281-.512-.618-.732-.954-.216.578-.098 1.216-.22 1.814-.756-.641-1.373-1.452-1.779-2.353.134.032.272.067.405.106.083-.228.039-.46-.031-.685-.087-.002-.26-.006-.343-.008.102-.177.193-.358.26-.555-.098-.001-.299-.031-.397-.041.083-.112.173-.22.26-.332-.46-.291-.98-.5-1.523-.578-.173-.02-.271.059-.291.238-.079-.065-.15-.132-.213-.203-.578.083-1.208.059-1.692-.291-.008.089-.016.27-.02.36-.11.049-.216.099-.327.148 0 .075-.004.22-.004.295.114.047.224.098.342.153-.008.077-.02.23-.028.307-.437.075-.842.271-1.279.358-.594.151-1.22.126-1.826.144-.008-.089-.02-.262-.024-.348-.37.037-.72.132-1.082.043-.642-.144-1.279.126-1.893.26-.11-.118-.228-.22-.354-.317-.366.167-.905.228-1.113-.187-.154.026-.464.075-.618.102-.059.106-.114.216-.165.323.201.004.405.008.614.012-.043.043-.13.122-.169.161-.567.165-1.051.551-1.661.58-.091.106-.181.213-.272.317 0-.086 0-.262-.004-.35.468-.342.897-.738 1.342-1.113.012-.069.047-.209.063-.279.405-.256.779-.555 1.157-.854-.035-.323-.126-.649-.185-.966-.216-.179-.386-.405-.555-.624-.039.012-.118.043-.157.057-.236-.348-.598-.588-.937-.817-.437-.209-.976-.004-1.428-.079-.004.088-.012.266-.02.354l-.598-.024c.083-.191.169-.378.26-.567-.354-.224-.771-.189-1.165-.232.102-.161.216-.315.338-.462-.386-.1-.756-.195-1.129-.305-.279.181-.614.299-.803.586-.177.39-.071.82-.035 1.228-.287.083-.653.124-.925.153.075.091.142.191.22.285-.252.088-.496.211-.622.462-.063.02-.193.059-.256.081-.295.124-.606-.069-.901.024-.134.039-.397.116-.531.156-.523-.092-.488.429-.76.657-.555.289-1.169.486-1.653.893-.205.165-.425.307-.681.34.016.181.126.415-.067.537-.11-.016-.224-.037-.33-.063-.032.047-.094.144-.126.191.161.006.323.014.484.018-.083.11-.169.22-.248.332.149.006.303.018.46.026.075.099.153.201.236.301-.634.136-1.248.348-1.881.464-.393.057-.763.156-1.133.279.008.132.016.268.031.403.236.122.327.386.468.598.393.175.96.134 1.153.594-.417 0-.822-.067-1.212-.201-.441-.218-.913-.106-1.357-.008-.043.114-.087.228-.126.342.083 0 .256 0 .342 0-.004.061-.008.181-.012.242-.252-.045-.508-.147-.767-.108-.264.096-.055.358-.028.545.401.122 1-.183 1.303.226-.531-.13-1.07.097-1.606.002-.086-.159-.181-.309-.264-.47.02-.116.047-.228.09-.338-.11-.193-.228-.38-.346-.563-.087 0-.256-.002-.342-.004.165.232.319.484.354.775-.193.097-.378.205-.563.311-.043.169-.087.336-.13.508.323.142.61.352.909.539-.02.283-.118.563-.079.846.087.11.189.209.287.311.012.081.036.242.051.323.26-.071.523-.145.771-.262.433-.224.929.004 1.385.049.11.126.224.248.35.364-.031.175-.063.352-.09.531l-.102-.02c-.035-.177-.075-.356-.153-.523-.213-.151-.445-.262-.681-.36-.327.037-.614.24-.917.346.008.134.016.272.028.403.145.092.299.189.425.313.075.262-.165.421-.319.582.024.134.055.264.083.397-.232.154-.456.327-.669.508-.012.083-.024.24-.031.321-.637-.053-1.255.183-1.889.112-.051-.047-.158-.136-.209-.181.61-.106 1.22-.256 1.731-.634.075-.287.236-.539.342-.811-.012-.232-.051-.464.016-.693-.252-.083-.511-.157-.76-.24-.024-.382-.189-.712-.295-1.066-.047-.203-.055-.413-.11-.61-.145-.232-.413-.319-.645-.421.114-.464.126-.976-.149-1.385-.661.008-1.306.13-1.952.264-.012.303-.035.909-.051 1.212-.098.334-.421.525-.641.775-.012.14-.024.283-.031.427.114-.037.236-.077.358-.108-.008.189-.024.567-.031.757-.165.067-.189.238-.22.392.189-.024.378-.098.567-.067.374.146.657.486 1.086.468-.024.224-.071.443-.122.661-1.46-.448-3.02-.574-4.533-.334-.205-.147-.413-.293-.606-.451-.102.033-.201.069-.299.1-.008.083-.016.248-.02.329.228.124.457.242.692.366.063.148.161.285.228.439-.134.106-.279.201-.421.293-.016.073-.035.222-.047.297-.091 0-.268-.004-.358-.004.035-.165.079-.327.126-.49-.429-.167-.724.295-.96.578-.26.026-.508.087-.744.179-.142.153-.212.348-.299.533-.138.014-.271.029-.401.045.067-.329.114-.661.173-.992-.189.128-.37.262-.543.405-.071.185-.122.374-.165.565-.028-.057-.083-.171-.106-.23-.484.099-.929.291-1.389.433-.295.031-.594-.028-.885-.075-.008.177-.027.531-.039.708-.33-.118-.661-.248-.968-.425-.252-.216-.468-.468-.712-.687-.008-.043-.027-.132-.035-.175.299-.132.63-.067.952-.059-.126-.252-.268-.496-.405-.74-.504-.124-1.01-.232-1.507-.362.157.134.323.256.5.37-.039.33-.161.637-.24.956.157.092.319.191.464.321-.028.261-.059.525-.094.789-.338-.268-.756-.39-1.169-.459-.26.474-.704.793-1.062 1.179.134.309.397.514.669.7.071.256-.252.205-.405.276-.236-.106-.547-.209-.783-.264-.189-.11-.472-.272-.634-.028-.028.244.228.366.362.531.193.031.405.035.563.167 0 .13-.047.238-.146.325-.346-.051-.649-.258-.96-.401-.531-.165-.661-.842-.661-1.32-.275-.206-.551-.399-.83-.58.775.035 1.551.142 2.326.193.464-.313.866-.744 1.074-1.267-.059-.386-.291-.791-.673-.94-.468-.205-.956-.362-1.428-.547-.405-.179-.846-.043-1.271-.077-.228.018-.46.022-.689.037-.004-.083-.012-.248-.016-.33-.338-.001-.582.151-.866.268-.201-.128-.421-.102-.642-.051.161-.177.323-.354.476-.535-.417-.089-.83-.189-1.251-.258-.024.061-.071.183-.099.242-.047-.167-.079-.342-.197-.474-.134-.012-.268-.001-.397.006-.11.122-.145.283-.189.439-.043.006-.134.018-.181.026-.008-.094-.024-.275-.027-.366-.228.201-.453.403-.673.602.008-.075.02-.226.027-.303.177-.122.268-.319.339-.519-.189.012-.397 0-.429.228-.098-.03-.193-.063-.291-.095-.047.092-.098.185-.138.279-.15-.004-.295-.002-.437.001-.004-.049-.016-.144-.019-.191-.213.091-.421.185-.618.303.11.024.334.071.441.094-.256.112-.578.193-.846.209.024.051.071.15.094.203-.122.063-.24.124-.358.191-.173-.008-.339-.004-.508 0-.071-.126-.212-.244-.35-.13-.327.181-.685.313-.98.545.024.155.319.33.106.456-.228-.041-.448-.092-.673-.134.028-.116.059-.23.091-.344-.13.102-.252.212-.378.323-.039-.016-.122-.043-.161-.057-.134.102-.268.201-.401.297.098.016.299.047.401.063-.299.13-.685.124-.913.382.433-.069.885-.108 1.318-.206l-.02.073c-.173.104-.366.181-.496.34-.059.14-.106.285-.154.427-.134.041-.256.102-.37.177l-.075.004-.019.075-.071.02-.004.071c-.248-.012-.456.34-.378.561-.275.24-.456.576-.791.75.024.094.051.193.083.291-.063-.03-.189-.087-.252-.118-.315.189-.578.445-.834.701-.134-.026-.264-.053-.393-.075-.071.114-.146.232-.22.346-.035-.075-.11-.218-.15-.291-.008.102-.024.299-.031.401-.197-.039-.398-.081-.594-.116.079.112.165.218.256.329-.433.029-.842.142-1.251.26.012.039.04.122.051.161-.036.024-.098.077-.134.102-.002.012 0 .025-.0001.037.761.821 1.304 1.849 1.527 2.997.604-.158 1.12-.613 1.626-.972.051.118.134.195.26.224.051.252.098.504.189.744.228.409.531.775.85 1.129-.067.15-.134.303-.201.455-.087-.006-.264-.02-.354-.024-.004.061-.008.183-.008.246-.051-.031-.161-.098-.216-.13-.114.045-.228.088-.334.13.039.142.075.287.114.433.079.008.244.026.327.031-.004.049-.012.146-.02.191-.039.018-.122.053-.165.069-.13-.102-.26-.201-.386-.299-.008-.071-.02-.215-.028-.287-.161-.036-.311-.075-.464-.118.193-.216.441-.366.649-.567-.106-.016-.311-.047-.417-.065.051-.309.11-.616.13-.927-.425.142-.752.492-1.212.535-.124.056-.188.156-.229.267.0001.043.006.084.006.127 0 .12-.011.237-.018.356.012.046.02.094.036.136-.023.07-.042.14-.061.209-.004.039-.012.076-.018.115.09.006.248.017.33.024.004.154.016.309.032.466.043.246.059.496.071.746-.087.086-.169.175-.248.269-.187-.026-.373-.049-.559-.073-.9 2.259-3.111 3.855-5.702 3.855-.078 0-.155-.009-.232-.012.005.033.006.064.012.098-.288-.018-.569.002-.784-.175-.061-.001-.123-.016-.184-.028-.265.058-.666.145-.886.191.032.059.091.177.122.236-.031.055-.09.169-.122.224.48.205.968.398 1.373.732.012.138.024.277.039.421.13.1.264.206.401.309.043.157.134.474.177.63-.327.429-.279.99-.374 1.497-.063.045-.189.138-.256.185-.61-.158-1.255-.122-1.877-.24-.598-.094-1.212-.077-1.814-.138-.22-.051-.366.145-.519.268-.181.055-.366.098-.523.204.02.238.138.453.201.681.016.311-.114.582-.09.901l.122.02c.02.783-.504 1.44-.701 2.18.154.057.303.12.46.181-.016.386 0 .787-.209 1.133.339-.004.637-.039.984-.043l.027-.097c.158.001.319.018.48.03.201.301.378.631.622.905.043 0 .134 0 .181.004.323-.185.618-.435.976-.559.484-.028.972.081 1.448-.03.161-.356.484-.545.815-.716.165-.331.37-.632.704-.807-.059-.234-.22-.431-.319-.647.319-.423.649-.842.952-1.275.539-.098 1.062-.291 1.479-.663l.024-.521-.094.029c-.016-.167-.028-.332-.039-.494.197-.104.397-.209.59-.317.531.081 1.059.218 1.59.299.283-.183.563-.388.858-.557.264-.071.48-.224.606-.47.378-.006.732.14 1.082.262.142.472.335.933.669 1.302.669.23.995 1.094 1.79 1.01.055.101.11.203.165.305.173.059.35.118.523.173.016.073.04.222.047.299.173.055.35.118.523.173.134.315.272.63.366.964-.146.075-.189.224-.236.37-.496.142-1 .323-1.527.201-.252-.027-.504.032-.752.063-.004.083-.02.252-.024.334.338.11.673.24.988.413.283.136.531.35.842.421.043-.122.087-.242.134-.362-.047-.181-.083-.366-.106-.551.118-.086.24-.173.354-.271l-.028.087c.087.006.272.018.358.022.154-.305.244-.675.567-.848.012-.136.028-.268.047-.401-.122-.055-.236-.11-.35-.161-.004-.138-.004-.272 0-.405.083-.09.165-.177.252-.266.165.045.334.092.504.155.13.13.22.293.327.449.114-.122.228-.272.173-.449-.488-.46-1.121-.696-1.727-.964.04-.108.075-.216.114-.323-.445-.006-.933-.065-1.2-.464-.354-.291-.319-.87-.795-1.059-.189-.134-.378-.268-.567-.394.02-.189.047-.374.083-.559-.028-.14-.051-.277-.071-.415.205-.069.405-.147.602-.226.059.026.173.081.232.11l-.063.049c.051.214.114.423.181.635.039-.051.122-.153.157-.203.083.099.169.201.252.303.031-.075.098-.222.134-.297.079.13.158.264.248.393.079.338.394.535.614.783.126.015.256.03.388.044-1.241-1.116-2.025-2.726-2.025-4.527 0-1.642.638-3.123 1.672-4.223-.291.115-.582.227-.885.304-.039.016-.11.043-.146.059l-.086.033c-.055-.008-.161-.022-.213-.029l-.102.004c-.043-.027-.165-.271-.161-.323l-.083-.063c-.051-.043-.157-.13-.213-.173-.024.024-.075.079-.098.102-.028.02-.087.055-.114.071-.067.016-.197.051-.264.067-.039.016-.114.041-.149.053l-.09.026c-.047.012-.146.031-.197.041l-.035.094c-.201.047-.401.088-.598.132.122-.167.248-.334.37-.504-.295.039-.586.073-.874.102.004-.055.016-.161.016-.215l.016-.096c.028-.035.087-.102.118-.136.201.045.389.132.571.228.039.029.114.088.153.116.232-.047.453-.147.677-.24-.063-.026-.193-.079-.256-.104.028-.039.083-.112.11-.151.039-.02.122-.059.161-.079l-.035-.083-.09-.02c.028-.037.087-.11.114-.148.035-.057.099-.171.134-.23.035.043.11.13.15.173.004.047.012.142.019.189l.004.067.075.012c.043.012.13.028.173.035.134.028.409.134.445-.071.028-.13.043-.26.059-.389.307-.179.653-.171 1-.165.051-.102.102-.205.154-.303.051.069.106.134.169.195.067-.136.13-.273.185-.413.083-.124.287-.27.181-.435-.201-.059-.228.228-.216.362l-.051-.067c-.016-.051-.047-.15-.063-.201 0-.161 0-.319 0-.476.181-.118.181-.37.122-.553.295-.1.594-.222.834-.433.02-.018.059-.057.079-.075.012-.014.035-.045.047-.061l-.047.004.043-.071c.067-.108.126-.216.181-.33-.063-.098-.134-.189-.208-.27-.024-.018-.071-.053-.095-.073-.228-.122-.48-.195-.724-.26-.004-.051-.012-.15-.016-.197.04-.417.142-.822.236-1.228.024-.018.071-.053.091-.071.299-.238.626-.443.968-.608.031-.014.09-.041.122-.053l.079-.031c.051-.002.15-.002.197-.004l.055-.085c.158-.171.319-.336.488-.498-.083-.106-.161-.214-.236-.323.181-.177.362-.354.555-.521.134-.006.268-.037.394-.092.051 0 .154 0 .201 0 .154.037.315.047.472.024.059-.006.181-.02.24-.024l.031.1c.051.012.15.031.201.041l.087.037c.024.026.079.077.102.104.02.039.055.116.075.157-.134.067-.26.149-.366.252-.201.169-.405.342-.61.508-.028.016-.075.055-.098.071-.169.128-.338.252-.508.384-.016.03-.059.083-.079.108-.165-.067-.275-.02-.334.145l-.036.083c-.027.026-.075.079-.102.104-.161.053-.193.297-.008.348.102.346.311.706.15 1.07.004.045.008.138.012.185l.083.051.047.083c.051.004.15.016.197.02l.099.012c-.035.149.027.236.189.26.126.032.256.067.386.102l-.039.087.047.085c.039-.02.122-.057.165-.077l.098.008c.047-.012.142-.031.189-.039l.039-.098c.145.004.287.008.437.012.051-.008.153-.024.205-.031l.047-.092h.102c.161.045.354.045.484-.089.051-.008.153-.024.204-.029.055-.002.15-.001.201-.014l.055-.086c.059-.008.185-.02.248-.028l.008.091.087.043c.039-.028.114-.083.149-.11l.094-.024c.071 0 .213.002.283.004.126.092.26.179.394.268.004.049.012.149.016.201-.264-.008-.484.138-.653.327-.138.012-.271.028-.401.035l-.051-.087c-.047-.001-.15-.024-.201-.031-.086 0-.248 0-.334-.002-.106-.183-.358-.183-.484-.022-.051.001-.158.028-.209.037l-.106.004-.106-.026c-.039.029-.122.091-.161.12l-.083.037c-.031.016-.098.049-.134.067-.059.033-.189.095-.256.126l-.09-.024c-.031.029-.098.083-.13.11.051.008.161.02.212.027 0 .051.004.156.008.209-.134.04-.264.049-.393.024.028-.104.087-.189.173-.26l-.079.012c-.031-.004-.098-.008-.13-.001-.063.014-.181.039-.24.053l-.063.014c.024.012.067.035.09.047.02.027.055.083.075.11-.106.067-.216.132-.323.197.032.136.067.272.098.407.268-.238.622-.334.948-.464.055.039.169.126.224.167.024.016.075.053.102.069l-.016-.059.098.008c.008.071.024.213.031.283.039.169.079.338.122.509-.146.073-.287.156-.445.197-.26-.159-.468-.391-.74-.529-.185.004-.358.039-.535.063-.095.239-.152.485-.192.736.536-.153 1.1-.24 1.686-.24 3.39 0 6.135 2.739 6.135 6.154 0 .944-.221 1.833-.604 2.63.057.014.117.022.165.018.055-.002.161-.006.216-.008.055-.008.165-.028.216-.037.209.041.409.1.61.183l-.083.002c-.032.016-.091.045-.122.059-.059.037-.181.116-.24.151-.268.116.043.362.22.26.027.022.086.065.114.087.051.004.157.008.213.001-.063.145-.047.419.169.417l.106.024.035.092.086.035c.032-.028.09-.094.118-.126.024-.026.067-.077.087-.102.028-.024.087-.067.114-.09l.098-.008c.051-.001.15-.028.201-.035l.051-.079c.02-.033.055-.098.075-.13.063-.002.189-.002.252-.002.086-.006.264-.02.35-.027l.102-.032.047-.096-.035-.094c.071.028.22.087.291.112l.075.049c.031.02.086.061.118.083.031.024.094.075.126.1l.035.065.083.016c.441.189.881.386 1.279.661.024.016.075.047.099.065.15.1.299.199.456.303.035.026.106.077.142.102.032.022.094.055.13.073.028.026.087.075.114.098.051.012.161.035.213.045l.095.041c.035.018.102.057.138.075.028.024.087.063.114.085l.071.049c.028.031.079.095.106.126.02.043.063.136.083.181.016.039.051.118.067.157l.035.081c.008.037.027.108.035.144l-.008.075c-.008.031-.016.094-.02.13l-.02.071c-.063.049-.197.146-.264.193-.031.022-.098.067-.13.087l-.075.035c-.028.018-.09.047-.122.063l-.071.035c-.04.012-.106.039-.142.051l-.094.026-.067-.081c-.051-.002-.157-.006-.209-.008l-.114.016-.024-.091-.087-.045-.086.045-.02.092c-.055-.006-.169-.016-.228-.026-.047.001-.153.024-.205.032l-.051.091-.106-.004-.055-.086c-.055-.006-.157-.012-.209-.018l-.098-.014-.008-.079-.071-.008-.024.077-.098-.006c-.043-.031-.126-.09-.165-.122l-.102.043c-.035-.02-.102-.059-.138-.077-.047-.006-.146-.014-.189-.018l-.098-.008c-.094-.087-.185-.173-.272-.26-.126-.177-.362-.179-.547-.122-.02-.02-.067-.059-.086-.079-.04-.012-.114-.037-.154-.051-.327-.033-.645-.059-.964-.083l-.11-.001c-.047.006-.146.029-.193.037l-.024.094-.106-.014c-.047.006-.149.02-.204.026l-.051.091c-.063.035-.189.11-.252.146-.028.02-.087.051-.114.067l-.063.037c-.028.02-.087.061-.114.081-.032.027-.095.09-.126.118-.161-.035-.315-.022-.464.039-.209-.008-.622-.02-.83-.028-.11-.169-.327-.161-.496-.118l-.083-.039c-.032-.014-.099-.051-.13-.067l-.075-.043c-.031-.02-.098-.055-.13-.075.035-.161-.012-.287-.15-.378-.027-.022-.075-.067-.098-.09-.02-.022-.059-.071-.079-.094l-.008-.083c.022-.093.046-.185.069-.278-.964.627-2.114.994-3.353.994-.86 0-1.678-.177-2.42-.495.084.053.167.108.262.139.059.466-.028.942.079 1.407.197.156.378.331.559.506.083.391.433.667.61 1.021.149.012.299.022.453.032-.114.083-.232.159-.334.256-.047.216.193.327.307.472-.02.094-.039.185-.059.279.028.063.083.193.11.26.102-.035.208-.075.315-.11.051.114.098.224.154.338.071-.067.142-.134.216-.199.059.016.177.047.236.065-.016-.252-.099-.482-.252-.681.189.047.386.094.578.128-.114-.159-.236-.311-.354-.468.149.004.295.001.445.016.083.077.161.151.248.226 0-.085 0-.26 0-.346.13.028.256.059.386.087-.208-.301-.46-.594-.822-.708-.043-.169-.15-.309-.24-.451-.149-.199-.291-.401-.445-.596.028-.1.063-.197.094-.297.287.167.606.238.921.088-.075-.11-.154-.216-.228-.327.193-.043.382-.094.575-.142-.024.067-.075.197-.102.264.122-.083.236-.175.366-.248.232.006.449.098.681.138l-.067.063c.173.008.346.016.519.028-.118.067-.197.236-.346.22 0 .094-.004.291-.004.389.012.085.031.256.043.342-.055.055-.165.167-.224.22.177.083.358.157.547.209-.012-.047-.028-.145-.04-.197-.094-.071-.161-.156-.185-.268.071.006.208.016.283.02-.028.063-.075.185-.099.248.083.067.161.134.244.205-.043.122-.075.244-.106.366-.043-.026-.13-.081-.173-.106-.031.049-.086.153-.114.205-.071-.116-.165-.205-.279-.273 0 .096 0 .289 0 .386.374-.073.732.022.952.334-.098.006-.291.02-.39.026l.024.098c.071.012.212.035.283.049.086.081.173.163.264.242-.027.106-.047.211-.071.319.177-.043.358-.092.539-.138-.036.108-.071.22-.102.33.145-.022.287-.059.437-.055.263.134.488.336.728.514.185-.041.366-.077.555-.104.012-.151.028-.303.043-.454.586-.145.976.293 1.409.58.315.008.657-.067.976-.13.09-.161.193-.315.295-.466.216.057.433.136.645.218.145-.134.303-.254.48-.346 0 .195.032.431-.236.421.055.154.114.305.185.457-.047.02-.142.057-.189.077.114.293-.028.75.323.901-.094.104-.185.207-.276.313-.063.342-.165.677-.252 1.013-.068.256-.136.512-.212.765.08.103.16.205.233.312-.005-.211-.013-.421-.005-.623.114.035.224.071.342.108-.012.236-.016.474-.016.71-.056.022-.109.042-.163.062.566.931.897 2.023.897 3.2 0 .229-.015.455-.04.678.238.352.472.705.695 1.067.15.23.169.512.272.762.26.287.669.415.877.756.433.58.366 1.34.527 2.02.22.535.764.791 1.173 1.165.409.604.512 1.436 1.177 1.845.216.437.468.862.421 1.381-.122.421.126.811.248 1.204.185.415.228.87.327 1.314.378.116.811.128 1.161-.087.209-.144.386-.327.61-.452.319-.075.661-.059.98-.165.181-.083.323-.256.52-.299.539.106.712-.472 1.141-.61.602-.25 1.228-.439 1.818-.728-.09-.334.134-.543.26-.797.094.006.279.006.374.001l-.047-.086c.22-.063.437-.142.661-.205.279-.09.618 0 .858-.209.012-.144.02-.289.024-.433.252-.106.508-.193.771-.271.09-.213.145-.449.295-.636.201-.102.421-.136.649-.163-.13-.409-.055-.834.008-1.251.11.039.22.083.334.122.185-.356.394-.702.634-1.025.126-.195.283-.443.165-.673-.248-.333-.543-.639-.795-.962-.378-.086-.744-.179-1.106-.279-.279-.218-.468-.504-.614-.818-.035-.181-.083-.358-.146-.527.059-.197.118-.393.173-.59-.145-.047-.264-.004-.358.134l.031.075c-.303.48-.803.822-1.031 1.356-.22.081-.433.197-.661.246-.272-.016-.567-.14-.807.047-.185-.033-.358-.1-.508-.201-.075-.016-.22-.045-.291-.059.028-.053.083-.165.106-.216.043-.213.134-.427.071-.643-.043-.187-.051-.734-.397-.635-.232.311-.283.712-.169 1.078-.201-.401-.606-.771-.484-1.257-.09-.112-.173-.226-.252-.34-.508-.4-.862-.94-1.216-1.468-.055-.134-.118-.26-.181-.384-.016-.069-.051-.207-.067-.273-.063-.031-.185-.09-.248-.122.106-.001.323-.035.433-.049-.008-.049-.02-.147-.027-.195l-.016-.099c.161-.067.319-.153.48-.23.126.033.24.096.354.153.099-.026.201-.049.303-.073.457.508.779 1.108 1.094 1.71.189.154.448.159.645.299.342.238.63.559 1.023.72.362.016.795.447 1.133.12.083.008.165.02.252.031.201-.279.401-.665.87-.457.216.364.248.819.508 1.153.728.224 1.499.323 2.263.325.212.128.445.246.697.293.031-.039.102-.116.134-.157l-.008.118c.626-.11 1.263-.14 1.897-.138.496-.031.988-.143 1.483-.195.055.144.106.295.161.446.122.059.252.124.378.189.059.167.114.342.201.502.138.248.437.297.685.384l.059-.024c.098.35.39.636.744.716.232.002.468-.055.697-.098-.11.266-.362.382-.606.496-.071-.279-.551-.047-.232.1.413.468.807.986 1.389 1.267.268-.132.543-.262.822-.384.114-.26.09-.539.031-.811l.075.031c.04-.024.122-.067.161-.09-.012.173-.083.419.157.458-.079.217-.039.427.122.596-.095 1.283.48 2.469.72 3.699.228.651.653 1.22.937 1.847.205.443.228.952.488 1.377.402.671.826 1.352 1.01 2.127.13.58.374 1.23.948 1.503.153-.086.311-.177.468-.264 0-.156.004-.307.008-.457.209-.098.421-.189.649-.256-.106-.323.043-.631.165-.921.118.037.236.079.358.12-.031-.482-.095-.962-.067-1.442.071-.232.173-.457.236-.691.059-.691-.287-1.338-.287-2.023.051-.169.142-.325.224-.482.15-.006.295-.012.449-.016.043-.145.095-.293.146-.441.055.029.165.088.22.116.15-.085.299-.169.453-.254.008-.146.016-.291.024-.433.389-.348.787-.693 1.169-1.047.276-.34.48-.738.704-1.114.26-.028.504-.11.748-.209.099-.209.217-.409.358-.596-.063-.132-.122-.266-.181-.395.032-.059.094-.177.126-.236.217-.083.437-.163.657-.24.031.039.098.124.13.165.189.008.37.026.563.043l.004-.118c.287-.079.578-.157.878-.169.114-.085.232-.157.354-.23.091-.205.142-.47.374-.565.012.098.031.297.043.397.051-.029.157-.086.205-.118.099.409.177.834.445 1.173.201.338.484.61.744.909.055-.027.161-.083.216-.11.205.193.374.417.512.663-.083-.001-.24-.033-.319-.045.169.258.413.45.622.675.142.297.378.631.303.984-.055.36-.098.706-.067 1.08.047-.014.142-.039.189-.055.146.246.445.26.701.289.185-.327.488-.551.815-.728.043-.14.09-.287.145-.429m-49.3-34.53c-.15-.02-.291-.043-.437-.051l-.095-.004c-.012.043-.031.132-.039.173-.303-.238-.571-.508-.767-.836-.008-.043-.024-.134-.031-.177l-.024-.089c.071-.031.217-.098.291-.132.433.222.956.364 1.239.797-.05.107-.094.213-.137.319m1.708-.315c-.102-.364-.46-.453-.783-.521l.02-.112c.008-.055.031-.167.043-.222.185.039.37.079.555.134.201.12.342.321.504.494-.115.078-.229.153-.339.227m3.073 10.957c.043.026.126.073.165.097l.091-.051-.051.079c-.083.134-.161.27-.24.407-.031.041-.09.12-.122.161l.039.096c-.055.004-.173.004-.232.004h-.11c-.055 0-.161-.008-.213-.001-.067-.159-.291-.179-.378-.031-.051.016-.153.049-.204.065-.114-.083-.244-.13-.386-.13l-.079-.037c-.039-.124-.075-.25-.106-.376.161.114.303-.065.346-.209.02-.026.059-.077.083-.104.169.077.287.033.346-.136.157.075.279.035.378-.114.035-.018.102-.057.138-.075l.067-.041c.024-.02.079-.059.102-.081.177.004.394.004.508-.161.079.004.228.001.307.012.039.031.114.095.157.126-.169.077-.334.153-.508.222-.188-.033-.271.199-.098.287m-8.976 6.621l-.016.055-.09.035-.083-.004-.11-.031c-.028-.012-.083-.033-.114-.043-.043-.031-.138-.094-.185-.124.177-.12.457-.033.598.112m3.849-1.784c-.354-.022-.685-.049-1.031-.033-.091-.059-.177-.118-.264-.169.236-.145.472-.307.744-.354.284.02.547.13.807.224l.028.095c-.09 0-.275-.004-.366-.004.019.058.062.18.082.241m16.971 2.835c-.051-.001-.146-.03-.197-.039-.051.004-.15.016-.201.02l-.051.094-.102-.008c-.051.001-.153.024-.205.031l-.047.095c-.193-.004-.382-.006-.571-.008-.095-.138-.217-.173-.374-.108l-.087-.035c-.031-.018-.098-.055-.13-.073-.055-.039-.161-.116-.216-.153-.028-.024-.083-.071-.11-.091-.031-.027-.095-.083-.126-.11l-.051-.067-.09-.012c-.138-.024-.272-.047-.405-.071-.036-.02-.11-.055-.142-.071-.039-.035-.11-.098-.146-.132-.004-.049-.012-.153-.016-.205l-.09-.057.016-.104c.055-.155.008-.256-.138-.301.004-.057.004-.171.008-.228l.094-.024c.035-.039.099-.124.13-.165l.051-.091c.024-.039.067-.114.09-.153l-.075-.057-.09.02.02-.1c.036-.179.075-.35.13-.519.024-.024.075-.071.098-.094.043-.016.13-.043.173-.059.04.031.114.087.15.114l.051-.075c-.032-.032-.102-.089-.134-.118-.031-.018-.098-.057-.13-.075-.047-.008-.149-.024-.201-.03l-.09-.033-.039-.079-.031-.071-.079.008c-.173-.22-.342-.445-.523-.655-.016-.022-.055-.065-.071-.085-.028-.022-.079-.059-.106-.079-.279-.295-.551-.594-.815-.893-.016-.031-.051-.092-.067-.122-.047-.169-.142-.512-.185-.681-.02-.031-.059-.092-.079-.122-.031-.028-.09-.079-.122-.104-.031-.02-.09-.061-.122-.083-.024-.037-.067-.112-.09-.149l-.098.016c.138-.34.307-.671.515-.974.047.004.138.02.185.024l.063-.073c.047-.043.153-.128.205-.171l.039.091.094.012c.012-.045.024-.138.031-.185.091-.079.181-.155.275-.232.028-.024.083-.077.11-.102.039-.02.118-.057.157-.077.028-.018.09-.049.122-.067.027-.022.091-.065.118-.088.055-.008.153-.03.205-.039l.047-.092.102-.029c.035-.014.114-.039.154-.051.043.002.13.006.173.001.035.006.11.018.146.026l.09.018c.035.033.106.1.138.136l.102-.02c.157-.024.323-.035.488-.031.027.014.083.041.114.055.02.024.055.077.075.102.043.055.13.169.173.224 0 .09-.008.272-.008.362-.012.083-.024.252-.035.334-.032.039-.091.118-.122.156l-.098.004c-.083-.006-.248-.018-.327-.022-.035-.035-.102-.106-.138-.14h-.094c-.031.03-.098.089-.13.12-.028.035-.083.1-.106.134-.032.026-.083.079-.11.106-.04.02-.114.069-.15.092l.043.084.094.02c.035.033.098.1.134.134l-.114.016c-.153.014-.307.028-.457.041l-.098.006-.051.079c.031.033.098.099.13.13.083.122.205.169.358.138.028.028.079.083.102.11.024.028.063.087.086.112l.047.067c.024.029.063.088.083.12.028.031.071.09.095.124.016.053.043.159.059.213l.035.1c.079.012.236.035.315.047.02.03.055.095.075.126.114.136.319.175.484.11.016.039.039.108.055.144.008.049.031.147.039.199-.031.033-.098.094-.134.13l.008.096c.035.028.106.085.142.112l.024.09c.02.035.055.1.071.136.031.041.098.114.134.151.012.047.035.142.043.189l.083.039c-.004-.059-.024-.177-.031-.24l.027-.118c0-.059 0-.175 0-.234l-.004-.108c.189.028.386.039.582.039l.031.085c.024.033.067.104.086.14l.051.075c.024.031.067.09.091.118.024.024.071.075.094.096.024.026.075.073.102.097l.059.053c.024.03.067.089.09.118l.032.073-.067.029-.079.022c-.161-.02-.252.047-.272.197l-.083-.02-.059-.065c-.071-.154-.264-.242-.413-.14-.059-.097-.138-.169-.24-.216-.004.145 0 .291.008.437-.067.155-.031.275.11.364l.035.097c.016.179.244.212.378.138l.035.092c-.016.047-.051.144-.067.195l-.016.087-.051.047c.016.008.055.024.075.033.016.006.051.024.067.033l.079.04c.031.024.098.067.134.086.035.031.102.089.134.118.028.022.083.057.11.075l.008.106c-.004.086-.008.262-.008.35-.043.173-.016.37.13.492l.024.1c0 .053-.004.151-.008.205l.071.071.063.077c-.039.062-.125.204-.165.271m2.121-7.123l-.027.085c-.028.069-.071.211-.095.279l-.028.098.047.094.098.035c-.012.071-.031.215-.039.287-.02.018-.059.055-.079.075-.039-.008-.114-.02-.154-.027l.04-.092c-.035-.037-.099-.106-.134-.142.028-.213.059-.425.11-.634.016-.043.043-.13.059-.173.024-.02.079-.059.102-.083.047-.002.138-.008.185-.012-.022.053-.061.155-.085.21m.638 1.24c-.024-.031-.071-.086-.098-.114-.016-.024-.055-.067-.075-.09-.012-.032-.043-.095-.059-.126-.016-.087-.055-.252-.071-.336l.09-.02.035-.09c-.035-.028-.11-.085-.146-.11l-.004-.09c-.012-.033-.035-.108-.047-.142l-.039-.092c.027-.035.09-.108.122-.142l.098-.001c-.016.159.063.244.232.256l.094.03c.016.069.051.212.067.279l.059.143.031.089c0 .059.008.173.008.23.004.059.008.175.016.236-.077.022-.234.073-.313.099m.405-1.72l-.028-.11c-.055.012-.161.032-.212.041-.059-.012-.173-.035-.228-.047.004-.047.004-.142.008-.187l.079-.031c.098.09.216.142.358.157l-.004.067c.063.032.189.091.252.124-.056-.002-.166-.001-.225-.014m9.259-.165c-.051.039-.161.118-.216.157-.11.224-.185.464-.224.708-.028.037-.083.11-.11.145-.035-.035-.106-.102-.142-.136-.016-.026-.043-.079-.059-.104-.024-.061-.079-.181-.106-.24.091-.152.173-.313.24-.478.024-.022.067-.069.086-.094.028-.022.079-.065.106-.089.087-.012.26-.037.342-.049l.146-.022c-.015.053-.047.151-.063.202m.146-.151c.087-.016.256-.047.342-.063l.098.045c-.058.228-.334.163-.44.018m2.263.265c-.22.024-.445.037-.661.043-.138.047-.244.028-.323-.063l-.094-.051c-.075-.002-.225-.004-.295-.004l-.051-.071c.083 0 .252 0 .334.004.059-.016.185-.041.244-.055l.079.049c.094-.001.279-.031.374-.041.083-.216.575-.081.449.177l-.056.012m12.635 19.05c.154-.043.213.018.177.177-.169.047-.228-.014-.177-.177m3.356-24.915c0 .085-.004.258-.008.344-.205.11-.405.228-.622.319-.043.016-.126.039-.169.053v.104c-.016.161-.027.325-.051.488-.02.014-.059.039-.079.051-.213.124-.441.338-.701.228-.039-.027-.11-.079-.15-.102l-.083.035c.079-.075.153-.153.22-.244l.086.036c.035-.024.114-.071.153-.095.051-.051.153-.153.208-.205.016-.138.032-.275.051-.411.102-.041.205-.085.315-.124.016-.181.039-.36.067-.539.02-.012.055-.04.071-.055.016-.024.047-.079.063-.104.016-.045.047-.14.059-.189.031-.041.095-.128.122-.171.138-.153.11-.374.094-.563-.02-.331-.071-.655-.11-.982.157.092.425.152.346.395.008.043.016.138.02.181l.075.057.008.097c-.032.13-.004.244.086.342.094.185.13.389.154.594-.051.004-.154.001-.201.012l-.043.09.035.095c.051.004.149.008.197.001.004.065.012.191.016.254-.055.0001-.173-.0001-.229-.0001\"/><path opacity=\".15\" d=\"m58.971 121.28c-.11.042-.216.089-.323.136.043.201.079.401.118.6.154-.039.311-.083.468-.126-.09-.205-.173-.408-.263-.61\"/><path opacity=\".15\" d=\"m189.5 78.997c.224-.22.354-.507.575-.736 0-.201 0-.608.004-.811-.177.378-.35.753-.563 1.109.058.147.055.292-.016.438\"/><path opacity=\".15\" d=\"m187.62 75.75c-.165-.006-.488-.012-.653-.016.248.354.48.712.72 1.074.358-.246.303-.846-.067-1.058\"/><path opacity=\".15\" d=\"m191.03 76.43c-.205.002-.614.001-.819.016.004.079.012.238.02.319.185.12.382.238.547.391.031.146-.106.232-.181.329-.079-.132-.157-.262-.24-.388-.016.248-.028.494-.035.744l.114-.073c.287.132.248.5.362.769.087-.002.264-.001.346-.016-.004-.146-.008-.295-.012-.441-.051-.039-.157-.116-.208-.155-.004-.075-.02-.228-.027-.303.185.045.378.081.574.116-.201-.421-.193-.915-.441-1.308\"/><path opacity=\".15\" d=\"m190.49 78.8c.169-.102.024-.411-.157-.38-.201.045-.354.199-.512.325.201.071.477.236.669.055\"/><path opacity=\".15\" d=\"m187.89 71.55c-.039.045-.122.14-.161.187-.307-.053-.752-.519-.98-.148-.169.691.024 1.387.079 2.082-.157-.081-.311-.167-.46-.25.071.374.161.746.275 1.118.11.138.244.26.374.386.063-.12.165-.205.295-.252-.083.228-.181.45-.252.685.216.106.433.22.673.268.035-.059.106-.183.142-.242.086.006.256.022.338.026.193.197.386.39.594.578-.039-.202-.075-.405-.098-.606.393.433.819.854 1.369 1.078 0-.086 0-.26 0-.346-.232-.155-.413-.372-.582-.588.102-.006.307-.014.405-.018-.244-.158-.527-.26-.815-.169-.134-.199-.327-.569-.669-.256-.055.225-.26.126-.413.095-.098-.327-.22-.643-.319-.966-.024-.301.122-.608.409-.728.071-.266.055-.569.114-.828-.106-.142-.213-.285-.283-.441-.019-.226.095-.466-.035-.665\"/><path opacity=\".15\" d=\"m190.22 75.51c0-.146-.071-.215-.205-.205-.028.049-.083.148-.11.199 0 .177.295.175.315.006\"/><path opacity=\".15\" d=\"m184.98 79.93c.338-.149.567-.448.838-.689.161-.153.185-.389.22-.598.228-.146.453-.293.685-.445-.039-.193-.122-.575-.161-.765-.248.14-.224.443-.244.687-.157.161-.299.348-.35.571-.358.385-.842.709-.988 1.239\"/><path opacity=\".15\" d=\"m188.28 76.99c.09.374.079.752.083 1.141.224-.063.457-.032.681.041.004.088.016.266.024.352-.13.035-.256.071-.378.116.059.092.118.191.181.285.146.114.272.256.362.421.134-.085.35-.146.272-.35-.122-.106-.213-.397.016-.437.012-.271.118-.523.24-.763-.181-.035-.362-.055-.539-.055-.024.087-.067.262-.09.346-.091-.285.09-.537.185-.795-.291-.001-.555-.092-.783-.244-.065-.013-.191-.044-.254-.058\"/><path opacity=\".15\" d=\"m192.04 79.78c.063-.492-.366-.846-.76-1.043.031.191.067.382.098.577-.122.043-.244.092-.358.14-.051-.026-.146-.073-.193-.098-.055.11-.106.216-.157.327-.079.002-.244.008-.326.012-.008.085-.016.256-.016.34-.083-.002-.252-.002-.335-.004-.008-.081-.027-.242-.035-.321-.055-.028-.165-.079-.22-.106-.146.033-.283.071-.421.102-.012.081-.031.24-.039.323-.153.002-.303.004-.453.008-.248.301-.315.692-.35 1.068.291-.112.319-.48.472-.72l.075.012c.059.297.421.22.649.293-.016-.039-.055-.118-.075-.157.043-.069.13-.201.173-.268.146.083.295.165.449.248-.047.346-.138.673-.149 1.031.311.112.61.332.956.358.012.148.122.256.209.376.094-.167.193-.333.256-.512-.047-.23-.161-.439-.22-.663.134-.075.287-.092.433-.122.071.197.146.393.224.592.016-.089.043-.27.055-.36.051-.041.153-.12.201-.161-.033-.426.006-.863-.143-1.272\"/><path opacity=\".15\" d=\"m190.12 77.12c-.114-.224-.256-.429-.393-.634-.138-.001-.275-.024-.405-.035l-.016.582c.075-.079.154-.157.232-.236.189.118.378.226.582.323\"/><path opacity=\".15\" d=\"m47.957 71.869c.153.104.303.096.449-.022.268.053.543.106.818.161.031.128.071.256.122.382.209-.205.405-.423.638-.606.02.051.067.142.09.189.193.13.338-.067.488-.165.307-.09.669.026.815.315.098-.177.264-.338.279-.547-.232-.228-.551-.315-.834-.456.094-.012.287-.033.382-.043l-.008-.102c-.15-.006-.303-.008-.453-.012-.008-.079-.02-.238-.028-.319-.523-.177-1.086-.315-1.621-.104-.138-.067-.256-.152-.374-.242-.24.063-.488.151-.583.405.173.022.346.039.523.065-.031.14-.067.277-.102.419.11.114.216.228.319.35-.496.065-.995.079-1.491.134-.008.089-.02.264-.028.35.157-.008.319-.018.48-.025.028-.033.091-.096.119-.127\"/><path opacity=\".15\" d=\"m190.09 60.15c.079.12.169.236.228.372-.024.114-.051.226-.083.339.118.224.205.462.366.661.126.063.268.118.413.169.13-.309.118-.642.039-.962.063-.415-.208-.687-.417-.988-.209-.041-.409-.098-.571-.238.311-.039.688-.026.901-.311.244.031.484-.001.704-.118.138-.069.272-.142.417-.201.031.126.067.252.106.378-.181-.057-.354-.118-.523-.177-.031.13-.059.264-.086.399-.146-.031-.291-.065-.433-.096-.028.177-.051.354-.087.535.079.106.158.211.24.319.094.051.193.106.291.163.051-.195.106-.384.157-.576.134.031.276.071.417.104.134-.309.055-.647.209-.952.016.165.035.332.059.5l.106-.008.004.114c.181.045.362.088.547.128.016-.146.035-.293.063-.437.161-.122.268-.417-.031-.433.303-.138.598-.283.901-.433.035-.157.087-.315.138-.464.106.079.216.165.327.248-.083-.376.157-.649.327-.937.075.165.158.329.248.492.083-.276.161-.549.244-.822-.15-.087-.295-.169-.421-.277-.102-.236-.169-.482-.189-.738-.205-.193-.382-.399-.539-.622.063-.091.126-.177.201-.262-.079-.35-.122-.789-.563-.887-.35-.205-.673-.441-1.035-.618.024.136.098.24.224.307-.024.043-.083.126-.11.167-.059-.022-.173-.073-.232-.092.012.155.031.468.043.624.126.266.405.454.437.762.145.531.059 1.084-.15 1.588-.15.167-.299.382-.535.4-.083-.159-.142-.327-.201-.492-.303.224.087.504.012.783-.031.24.008.48.047.72-.539-.035-1.074-.039-1.605-.075-.213.37-.405.791-.826.962.043.051.13.152.173.203-.208.157-.413.321-.63.464.122.183.236.368.35.555.108-.081.218-.159.328-.24\"/><path opacity=\".15\" d=\"m192.68 52.723c.106.031.209.063.319.094.146-.039.295-.081.453-.114.008-.195.028-.577.039-.769.177-.154.484-.242.547-.48-.217-.273-.492-.535-.48-.915h-.043c-.047.15-.09.311-.193.439-.283.014-.555-.006-.826-.053-.299-.106-.578-.268-.893-.303-.004.354.319.563.413.877.067.303.181.614.287.909-.161.016-.315.02-.468.016.035.095.075.191.118.289-.047.114-.09.23-.13.344.169.226.339.453.52.677.26.086.216-.268.311-.421-.181-.092-.394-.148-.504-.327.067.018.197.051.264.067.085-.11.176-.22.266-.33\"/><path opacity=\".15\" d=\"m178.5 70.4c-.114.165-.232.331-.35.494.024.254.051.51.09.765.185.047.37.12.567.114.244-.083.449-.248.673-.382.035-.307.193-.571.252-.868-.264-.454-.85-.131-1.232-.123\"/><path opacity=\".15\" d=\"m47.721 70.37c-.161-.142-.319-.287-.48-.429-.142.037-.287.075-.429.11-.016-.087-.039-.254-.055-.338-.5-.008-.897-.315-1.318-.541-.055-.14-.114-.277-.169-.415-.055.031-.161.087-.216.116-.236-.124-.504-.289-.779-.279-.11-.191-.189-.427-.405-.521-.87-.516-1.971-.386-2.849.039-.295.152-.453.46-.519.775.197-.059.39-.15.539-.293.547-.132.976-.63 1.598-.395-.091.114-.185.228-.279.338.185.077.551.23.736.307.531.201.905.763 1.543.661-.142.693.523.775.991.895-.031.297-.374.405-.531.632.578-.085 1.153-.173 1.735-.24.304-.115.588-.288.887-.422\"/><path opacity=\".15\" d=\"m218.26 121.97c-.094-.271-.216-.527-.307-.797-.13.045-.264.092-.382.156-.204.201-.193.512-.283.767-.083.008-.24.024-.319.031-.209.866-.712 1.639-1.342 2.263-.433.635-1.102 1.129-1.369 1.865.185.063.37.126.555.206.279.132.472.401.756.527.401-.035.673-.409.984-.631.252-.425.437-.885.637-1.338.083-.216.283-.358.496-.437.181-.039.366.039.555.067-.118-.234-.256-.472-.228-.74.398-.303.689-.712.976-1.118-.032-.256.02-.512.031-.767-.17-.274-.516-.073-.76-.054\"/><path opacity=\".15\" d=\"m221.89 119.06c-.417.193-.61-.14-.862-.344-.035-.405-.012-.828-.201-1.196l-.043.657c-.134-.102-.268-.209-.397-.307.047-.175.087-.352.13-.525-.087-.378.004-.773.028-1.147-.177-.144-.354-.285-.543-.409-.02-.138-.035-.275-.047-.413-.055 0-.161.002-.22.004.146.514-.071 1.051.177 1.55.165.555.154 1.133.201 1.712-.169.429-.409.822-.626 1.232-.197.047-.394.108-.586.169.043.488.539.724.85 1.051-.016.459-.228.874-.472 1.251.11.154.287.256.46.342.236-.086.362-.342.508-.535.299-.523.724-.995.822-1.613.114-.287.472-.295.732-.232.272-.504.637-.976.748-1.55-.083 0-.256 0-.342 0-.105.101-.207.207-.317.303\"/><path opacity=\".15\" d=\"m107.21 52.825c.071-.228.165-.457.209-.692-.012-.23-.063-.453-.095-.679-.185.169-.378.329-.574.482.028.258.083.512.142.761.106.043.212.085.318.128\"/><path opacity=\".15\" d=\"m190.54 86.42c.275-.327.555-.657.74-1.049-.063-.024-.185-.065-.248-.089-.26.158-.417.445-.606.673-.811-.033-1.641-.047-2.404-.344-.09.151-.177.305-.26.462-.055-.028-.161-.083-.216-.11-.122.228-.256.46-.299.724-.122.712-.307 1.415-.441 2.127-.189.238-.295.513-.213.846.165.014.331.024.5.035-.039.504-.02 1.029-.216 1.503.043.116.118.216.185.328.185-.055.378-.098.571-.142-.008-.72.157-1.438.071-2.164.063-.075.13-.147.201-.22.087-.002.264-.004.346-.008-.031.256-.11.508-.094.767.118.142.256.266.397.392-.039.183-.067.37-.09.561.142-.002.291-.004.437-.004.031-.067.094-.193.122-.26.09.02.268.053.358.069l.031.085c-.079.014-.236.047-.311.059-.024.169-.035.338-.047.507.11.091.224.177.339.27.106-.097.216-.187.334-.275-.027-.026-.071-.081-.098-.106.039-.232.083-.462.106-.696-.059.002-.169.006-.228.001.106-.086.201-.189.287-.295-.118.012-.232.024-.342.037-.122-.124-.252-.238-.378-.348.063-.138.126-.275.193-.405-.228-.315-.448-.63-.669-.937.327-.299.724-.545.952-.94.138.032.279.071.425.106-.004-.083-.004-.25-.008-.331-.11-.041-.217-.083-.319-.12-.039.047-.11.148-.15.195-.327.051-.681.098-.999.157-.138.14-.193.516-.449.409-.213-.228-.425-.451-.598-.704-.086-.307.102-.598.209-.874.958.027 1.918.064 2.879.099\"/><path opacity=\".15\" d=\"m191.5 93.29c.189-.004.378-.008.571-.008.032-.055.102-.165.134-.224-.24-.002-.476-.004-.708-.006-.0001.061.003.179.003.238\"/><path opacity=\".15\" d=\"m198.1 92.05c.004-.22.008-.657.012-.876-.118.092-.236.187-.35.281-.004.134.004.27.024.403.097.07.203.133.314.192\"/><path opacity=\".15\" d=\"m190.52 88.17c.248.433.822-.049 1.184.1.004.09.016.272.024.362l.063-.037c.063-.159.157-.305.271-.435-.511-.019-1.039-.113-1.542.001\"/><path opacity=\".15\" d=\"m189.53 88.03c.138-.026.275-.045.417-.065.035.057.098.169.134.226.004-.167.012-.329.024-.494l-.59.014c.003.081.011.238.015.319\"/><path opacity=\".15\" d=\"m195.35 92.96c-.008.15-.012.301-.008.457.146-.126.291-.254.437-.378.008-.079.028-.228.035-.307.059-.027.181-.092.24-.122-.091 0-.268 0-.354 0-.118.116-.236.234-.35.35\"/><path opacity=\".15\" d=\"m180.19 87.71c.02.063.059.183.083.244-.031.421.055.826.083 1.243.366.136.748.083 1.121.008.008.157.016.313.032.472.441-.083 1.05-.555 1.417-.061.181-.006.437-.144.508.112l.055.515c.295-.138.578-.323.893-.413.122.055.228.142.358.189.043-.163.149-.358-.008-.492.09-.181.197-.439.118-.638.193-.183.012-.46.047-.685.138-.348.488-.537.767-.763-.012-.275-.091-.584-.063-.85.114-.448.575-.704 1.047-.571-.22-.33-.571-.533-.862-.783.039-.112.079-.222.126-.33-.181-.279-.35-.567-.578-.809.059-.002.169-.006.224-.006-.027-.053-.079-.161-.106-.216.055-.004.169-.012.224-.02-.031-.053-.09-.165-.122-.222.035-.053.106-.155.145-.209.028-.033.079-.106.11-.14.181.043.339-.069.468-.185-.145-.106-.291-.209-.397-.35.244-.047.492-.094.728-.177-.008-.047-.028-.132-.039-.177-.248-.157-.512-.291-.791-.388-.051-.165-.157-.205-.307-.122-.016-.146-.032-.289-.043-.435-.158-.118-.315-.236-.464-.358-.134-.138-.421.02-.327.207-.232.39-.366.885-.811 1.092.028.097.055.201.087.299-.047.035-.153.104-.204.138-.169-.26-.362.075-.5.185-.083.022-.244.059-.327.079l.059.051c-.236.571-.618 1.137-1.216 1.354-.106-.122-.429-.122-.456.061-.047.014-.142.033-.189.045l-.059.118c.016.049.047.151.059.201-.063.189-.047.415-.217.551-.086.006-.244.02-.33.024-.047-.173-.39-.22-.555-.193-.024-.035-.071-.106-.094-.142l-.09.012c-.216.279-.374.632-.327.99.13.543.256 1.092.417 1.629.098-.029.2-.056.306-.084\"/><path opacity=\".15\" d=\"m195.05 89.25c-.543-.187-1.125-.085-1.684-.136-.122.13-.24.272-.154.457.063-.028.189-.085.256-.114.027.049.086.148.114.197-.173.028-.374.039-.362.264.185-.045.37-.094.559-.14 0-.1.004-.203.016-.301.362.15.775.071 1.121.266.134.065.272.128.417.183-.039-.239-.047-.548-.283-.676\"/><path opacity=\".15\" d=\"m193.81 84.9c.035-.112.075-.222.114-.331-.051-.031-.157-.096-.213-.126-.094.146-.189.295-.271.449.09.0001.275.008.37.008\"/><path opacity=\".15\" d=\"m194.58 88.37c.173.016.346.031.527.051-.012-.104-.032-.303-.043-.401-.181.087-.378.169-.484.35\"/><path opacity=\".15\" d=\"m195.08 86.65c.051.114.102.228.157.342.071.008.209.018.279.024l.004-.077c.102-.016.299-.045.398-.059.153-.238-.248-.246-.37-.356-.158.037-.315.078-.468.126\"/><path opacity=\".15\" d=\"m200.14 88.24c-.378-.112-.756-.205-1.129-.275.311.279.68.445 1.129.275\"/><path opacity=\".15\" d=\"m199.77 87.61c-.09-.161-.165-.331-.291-.46-.138-.063-.283-.11-.425-.156.063.089.134.177.205.266.008.086.035.26.047.342.149.008.307.012.464.008\"/><path opacity=\".15\" d=\"m177.06 91.66c.091-.626.149-1.257.177-1.887.004-.203.122-.38.189-.565.15.041.299.086.452.13-.024-.063-.079-.189-.098-.25.016-.045.055-.132.075-.175-.358-.134-.425-.519-.472-.85-.539-.315-.539.177-.685.441.169.004.331.008.504.001-.016.169-.031.342-.039.514-.024-.067-.071-.201-.09-.268-.154-.008-.307-.016-.453-.02-.24-.346-.398-.732-.492-1.137-.145-.014-.283-.026-.421-.035-.087-.083-.173-.165-.256-.24.063-.083.126-.161.197-.236-.012-.039-.032-.118-.04-.158.063-.092.126-.187.189-.279-.106-.165-.24-.307-.358-.453-.059.024-.177.067-.236.09.039-.114.079-.226.126-.339-.142-.053-.284-.106-.417-.154-.063-.096-.126-.189-.185-.279-.193-.035-.378-.079-.563-.124.04-.124.083-.246.122-.368-.118.032-.232.063-.342.099-.036-.051-.11-.158-.142-.209-.145.032-.287.071-.425.104-.331-.486-.622-1.017-1.165-1.293-.527-.254-.693-.866-1.102-1.236-.303-.043-.685-.053-.968-.059-.181-.201-.5-.476-.732-.177.051.584.555.97.972 1.326.429.319.779.752.94 1.271.205.09.409.195.594.334.264.384.287.874.425 1.314.736.498 1.055 1.373 1.31 2.184.244.5.661.885.988 1.334.236.34.61.543.889.854.205.252.413.504.63.759.043-.039.122-.122.165-.165.157-.004.315-.012.48-.018.084.068.167.137.257.21\"/><path opacity=\".15\" d=\"m178.82 89.41c.157-.041.071-.279.118-.398-.126-.142-.307-.138-.468-.153-.028.181-.031.368-.012.553.118-.006.24-.006.362-.002\"/><path opacity=\".15\" d=\"m171.94 87.62c.063.295.142.632.496.689-.039-.293-.126-.574-.224-.852-.068.041-.201.123-.272.163\"/><path opacity=\".15\" d=\"m193.01 87.68c-.059.158-.11.323-.153.488.209-.004.421-.006.633-.008-.158-.165-.315-.327-.48-.48\"/><path opacity=\".15\" d=\"m169.9 84.39c-.098.146.126.37.276.272.067-.138-.138-.339-.276-.272\"/><path opacity=\".15\" d=\"m170.91 85.63c.146.266.299.539.555.722.008-.165.012-.327.02-.488-.126-.118-.248-.232-.366-.348-.052.03-.158.087-.209.114\"/><path opacity=\".15\" d=\"m182.19 93.8c.354.11.704.264 1.051.411-.031-.161-.067-.325-.094-.484.201.116.386.26.492.47.146-.126.295-.254.445-.378-.106-.118-.224-.22-.346-.319-.161.055-.319.11-.48.165-.004-.098-.012-.293-.02-.39l-.169.067c-.012-.043-.035-.13-.047-.173-.319.051-.653.051-.96-.02.016-.083.043-.25.055-.334.315.031.614-.071.917-.136-.04-.045-.118-.132-.161-.175-.291.026-.579.067-.854.122-.035-.002-.11-.004-.146-.004-.449-.104-.862-.305-1.275-.508-.059.153-.114.307-.169.464-.441-.051-.881-.112-1.318-.145-.055-.146-.087-.307-.216-.402-.165-.049-.331-.079-.496-.11-.382-.169-.815-.087-1.196-.244-.102.323-.291.604-.582.781.291.029.618.077.925.124-.043.108-.079.216-.114.33.571.142 1.129.405 1.735.378.705-.106 1.22.5 1.909.492.367.047.733-.001 1.114.018\"/><path opacity=\".15\" d=\"m189.98 95.27c.35-.122.677-.346.807-.706.594-.289 1.322-.399 1.767-.919-.539.047-1.086.11-1.606.252-.114.091-.189.212-.264.332-.342.073-.649.238-.917.46-.039.205-.008.48-.271.529.157.086.299.273.484.052\"/><path opacity=\".15\" d=\"m184.72 94.1c.051.118.11.24.169.364.508-.199 1.035-.348 1.586-.368.012-.154.02-.305.031-.457-.354-.055-.622-.077-.952-.112.071.159.153.317.236.478-.283-.161-.622-.38-.917-.122-.032-.063-.094-.185-.126-.244-.087 0-.252-.004-.342-.004-.075.187-.146.378-.217.572.106.03.209.065.319.1.067-.072.142-.141.213-.207\"/><path opacity=\".15\" d=\"m187.1 95.27c.197-.024.394-.063.586-.122-.173-.258-.397-.569-.732-.585-.319-.085-.567-.001-.74.232.193.059.393.108.598.152.095.107.194.213.288.323\"/><path opacity=\".15\" d=\"m188.83 94c.079-.001.244-.03.323-.04.039-.049.114-.145.157-.193.295.051.602.039.905.067.043-.039.13-.112.173-.15.177.028.358.053.539.077-.004-.063-.012-.197-.02-.262-.15.016-.291.031-.437.055-.425.02-.846-.073-1.263-.13-.114.161-.244.317-.358.48-.157-.213-.409-.134-.614-.071-.319-.136-.681-.277-1.027-.22-.094.147-.185.299-.264.456.627.128 1.272.175 1.886-.069\"/><path opacity=\".15\" d=\"m193.22 87.24c-.035-.033-.106-.095-.142-.128l.047-.083.094.018c.0001.051.0001.144.0001.193.118.083.248.161.374.242-.095-.293-.209-.578-.358-.844.004-.079.012-.236.02-.313.173-.006.523-.022.701-.03-.134-.11-.268-.216-.386-.334.09-.11.228-.169.35-.248 0-.154 0-.307 0-.462-.149.061-.295.122-.437.189l-.043.073c-.055-.13-.11-.254-.161-.378.012-.114.031-.228.051-.343-.386.272-.594.746-.393 1.228l.098-.035c-.043.016-.13.051-.173.069.039.065.114.195.153.26-.012.191-.016.384-.016.577-.087.004-.264.012-.35.014 0 .144.008.293.016.439.204.027.409.059.614.098-.017-.053-.044-.151-.06-.202\"/><path opacity=\".15\" d=\"m192.62 89.37c-.102-.051-.209-.099-.307-.15-.153.051-.311.096-.46.142 0 .075 0 .22 0 .295.079.079.157.161.24.248.138-.004.275-.004.421-.004.075-.083.153-.161.24-.24-.047-.098-.091-.197-.134-.291\"/><path opacity=\".15\" d=\"m52.02 52.42c0 1.413-.485 2.707-1.292 3.74.348.025.694-.063 1.04-.088.004-.051.02-.154.024-.205-.291.028-.574.049-.862.067.425-.197.897-.22 1.358-.236.032-.039.091-.122.118-.163.279.128.578.167.878.092-.193-.185-.618-.494-.315-.756.169-.287.354-.567.551-.834.224-.004.445-.033.669-.061.047-.1.095-.203.15-.301.425.02.905.087 1.287-.157-.012-.039-.039-.126-.055-.165.311-.049.622-.094.937-.134.039-.016.114-.053.154-.069.13.061.224.159.283.289-.295.075-.563.23-.842.35-.047.14-.102.279-.134.425.079.154.224.26.354.366.389-.169.708-.464 1.078-.661.638-.201 1.291-.327 1.928-.519-.02-.047-.063-.142-.087-.189.358-.016.701-.163.925-.453-.122-.053-.24-.106-.358-.159-.012-.167-.024-.335-.04-.502-.37.185-.535.592-.708.944-.098-.018-.197-.031-.291-.049-.425.061-.94-.006-1.232-.34-.063-.02-.201-.057-.272-.077-.043-.216-.138-.427-.122-.651.051-.167.13-.319.201-.476-.319.012-.563-.071-.826-.209.201-.02.602-.059.807-.079.118-.077.236-.151.362-.22.008-.138.012-.279.02-.413-.264-.077-.519-.226-.795-.22-.85.15-1.688.382-2.456.779l-.106-.002c.429-.431.936-.844 1.586-.844.185-.248.346-.551.669-.634.984-.134 1.979.15 2.959.031.22.142.59.161.799-.016l-.012-.051c.46-.098.696-.628 1.177-.71.468-.1.933-.234 1.35-.49l-.024-.096.035.086c.059-.301.051-.612.004-.911.071-.169-.13-.303-.193-.441-.146.004-.295.016-.441.032.004-.22-.193-.319-.35-.415.079-.096.15-.199.228-.291-.22-.14-.48-.305-.74-.327-.232-.15-.496-.234-.759-.297.02-.047.063-.138.083-.181-.256-.205-.61-.362-.677-.718.02-.175.185-.283.217-.453-.099-.134-.209-.256-.311-.384.02-.089.035-.181.059-.268-.201-.303-.264-.669-.445-.978-.236-.419-.614-.793-.523-1.33-.457.384-.657.954-.984 1.436-.055-.027-.165-.084-.22-.112-.055.102-.106.209-.161.315-.177.047-.354.1-.531.15-.13-.187-.26-.378-.382-.571-.145-.006-.295-.014-.441-.02.028-.057.083-.173.11-.23-.024-.053-.071-.159-.098-.212.11-.427.146-.876.335-1.281-.047.016-.146.045-.193.061-.22-.14-.461-.242-.7-.346-.028-.506-.468-.832-.74-1.22-.602.329-1.251-.031-1.838-.23-.122.077-.24.153-.358.232.02.171.063.508.083.677-.126.161-.256.32-.39.474.059.285.051.551.032.852-.197.315-.441.602-.764.795 0 .075-.012.224-.012.297.146.128.437.386.578.515-.008.27-.024.809-.035 1.08-.334.813-1.244 1.129-2.023 1.373.146.677-.197 1.324-.063 2.01-.106.057-.213.12-.315.179-.002.043-.005.108-.008.173 1.281 1.128 2.096 2.778 2.096 4.63\"/><path opacity=\".15\" d=\"m49.744 57.16c.055.028.109.057.164.085.303-.205.563-.47.728-.799-.018-.036-.036-.071-.053-.106-.252.299-.533.574-.839.82\"/><path opacity=\".15\" d=\"m74.67 90.97c-.287-.008-.578-.026-.866-.047-.374-.138-.677-.409-.933-.708-.386-.496-.952-.799-1.483-1.098-.343-.037-.677.026-1.01.059-.083-.045-.165-.086-.244-.126-.346.061-.626-.183-.936-.271-.307.022-.61.081-.905-.004-.047-.154-.09-.307-.153-.449-.134-.193-.37-.268-.567-.37-.5-.228-1-.457-1.488-.706-.181.051-.362.092-.539.152-.173.157-.209.409-.331.606-.157.138-.346.224-.539.291.264-.405.531-.815.696-1.275-.252-.04-.504-.161-.759-.095-.055-.134-.114-.266-.169-.393-.153.004-.307.001-.457.018.02-.069.055-.207.075-.274-.047.008-.142.028-.185.033.051-.037.15-.11.201-.149.059-.25.118-.506.153-.758-.106-.059-.212-.114-.315-.165-.012-.106-.02-.209-.028-.311-.059.024-.177.067-.24.09-.173-.626-.217-1.291-.48-1.889-.055.051-.165.151-.22.205-.008-.087-.02-.256-.028-.342-.492-.35-.933-.799-1.535-.95l-.083.053c-.028-.043-.09-.126-.126-.165-.693-.059-1.385.067-2.082-.008-.122-.374-.551-.561-.822-.826-.055.024-.173.067-.228.09.043-.118.09-.236.138-.35-.22-.415-.547-.811-1.01-.95-.22-.138-.448-.258-.661-.398-.051.018-.153.045-.205.063.075-.175.177-.342.228-.529-.173-.116-.362-.212-.519-.346-.205-.039-.409-.075-.614-.089-.095-.169-.185-.334-.272-.504.063.026.201.081.264.106.114-.079.236-.156.354-.238-.46-.004-.94-.018-1.373.147-.307.097-.574.274-.846.437-.334-.128-.645-.301-.96-.458-.449-.051-.897.073-1.342.079.236-.63-.46-.817-.881-.85-.201-.043-.389.077-.574.132-.339.148-.72.222-.992.482-.039-.213-.146-.398-.264-.575.224-.165.492-.275.696-.476.091-.283-.303-.417-.488-.248-.354.269-.701.549-1.043.83-.189.012-.567.031-.756.043-.055.151-.118.303-.169.461-.079-.122-.154-.244-.228-.362-.169.134-.342.264-.5.411-.252.26-.205.651-.228.99-.067.004-.197.012-.264.012-.173.281-.37.559-.677.703.024.189.039.38.055.573-.051-.114-.098-.222-.145-.335-.098-.086-.189-.177-.287-.26-.307-.535-.925-.787-1.519-.801-.37.214-.716.472-1.11.647-.248.126-.421-.171-.602-.295-.036.057-.11.165-.146.216-.055-.151-.106-.307-.153-.46l-.102.004c-.303-.33-.63-.663-.716-1.116l-.071-.002c-.031-.13-.063-.26-.09-.39.094-.173.149-.362.142-.561.185-.415.209-.868.283-1.305.15-.391.268-.795.362-1.2-.134-.112-.287-.191-.453-.238-.102-.138-.197-.277-.295-.411-.256-.067-.519-.118-.787-.079-.704.024-1.44-.001-2.113.212.051-.181-.22-.281-.323-.155.087-.144.236-.38.307-.506.299-.386.189-.903.413-1.314.11-.087.228-.165.346-.236l-.083-.02c.181-.303.319-.637.339-.99.035-.549.574-.872.763-1.355-.028-.118-.059-.23-.098-.34-.189.041-.378.11-.575.077-.535-.11-1.039.193-1.558.244-.559.138-.52.828-.724 1.251-.083.319-.358.504-.622.661-.008.081-.031.236-.039.315-.791-.13-1.562.124-2.31.342-.051-.1-.098-.203-.142-.301-.256-.1-.512-.195-.767-.289-.189-.441-.279-.919-.519-1.338-.189-.323-.232-.703-.279-1.066-.098-.555.189-1.082.26-1.625.268-.15.468-.378.523-.689l.094.02c-.075-.291-.165-.614-.055-.909.102-.244.248-.472.354-.714.244-.183.484-.368.732-.541.016-.079.047-.236.063-.315.098.024.197.051.299.079.346-.197.704-.372 1.062-.555.004-.083.004-.252.008-.332l.11.002c0 .051 0 .15-.004.201.716-.301 1.464-.029 2.2-.043.114.13.236.26.358.384.181-.045.366-.049.551-.022.043-.136.138-.195.279-.177.047.114.087.23.134.346.106-.039.22-.077.331-.114-.039-.061-.11-.189-.146-.25-.055.002-.161.001-.216.001.075-.149.334-.334.114-.468.354-.313.858-.246 1.299-.323 0 .053 0 .157 0 .212.295-.039.602-.085.909-.092.303.022.496.293.649.529.37.032.704-.169 1.066-.193.228.26.413.547.598.834.047.334-.311.63-.181.972.209.582.578 1.086.834 1.647l.464-.026c.161-.287.319-.582.397-.903.016-.506-.228-.992-.142-1.491-.177-.596-.425-1.328.035-1.859.323-.679 1.184-.724 1.676-1.232.216-.228.488-.382.767-.519.051.028.153.083.205.11.173-.358.559-.496.917-.61.098.001.295.031.394.039.028-.047.079-.142.106-.189-.067-.043-.205-.136-.272-.179l.047-.065c.15-.02.303-.035.457-.051.071-.09.146-.181.22-.272-.083-.079-.158-.151-.232-.228.382-.039.283-.527.032-.677.043-.177.091-.35.142-.523.052-.104.106-.21.159-.316-.878.481-1.887.756-2.961.756-3.384 0-6.127-2.723-6.127-6.103 0-3.412 2.743-6.154 6.127-6.154.965 0 1.875.229 2.688.626-.028-.063-.061-.124-.083-.189l.106-.033c.209.087.425.175.642.254-.043-.138-.087-.272-.13-.409v-.048c-.201-.041-.512.024-.492-.275.13-.161.122-.358.087-.547.122-.216.256-.433.307-.677-.437-.126-.877-.256-1.33-.343-.37-.201-.728-.433-1.066-.681-.161-.189-.303-.398-.464-.579-.323-.189-.653-.37-.995-.504-.224.016-.445.073-.669.106.051-.464.083-.933.114-1.393l-.626-.039c.055-.423.177-.848.441-1.192.551-.759 1.287-1.397 2.109-1.846-.016-.049-.047-.15-.063-.197.11.035.216.067.323.106.145-.047.291-.09.437-.134.051-.11.102-.22.157-.329-.039-.022-.118-.065-.153-.085l-.079-.043.043-.083c.008.031.024.094.036.126.193-.059.39-.12.586-.177.043-.092.087-.187.13-.279.26.037.523.063.791.077.26-.283.665-.456.826-.824.157-.372.516-.588.83-.815-.079-.108-.149-.22-.228-.329.457-.203.606.218.834.448.039-.043.11-.132.149-.177.04.022.122.057.161.077.012-.094.031-.283.043-.376.031.069.095.201.126.266.527-.15 1.106-.37 1.362-.893-.095-.138-.189-.277-.279-.417.126-.12.157-.331.154-.496.153.012.303-.039.456-.067-.016-.173-.027-.343-.035-.514-.177-.144-.319-.317-.445-.498-.338-.055-.696-.118-1.035-.157-.087.224-.087.468-.032.704-.02.053-.059.163-.083.22-.051-.024-.15-.071-.201-.091-.094.173-.283.527-.378.702-.153-.033-.248-.151-.346-.254-.031.171-.094.516-.126.689-.142.047-.287.098-.433.15-.051-.271-.098-.543-.138-.815.095-.006.279-.024.374-.028-.012-.157-.028-.472-.039-.628-.102-.128-.205-.348-.402-.266-.216.256-.448.494-.704.708.047-.138.094-.272.142-.405-.071-.244.016-.476.154-.681-.244-.031-.515-.004-.704-.185.161-.114.323-.222.496-.323-.004-.211-.036-.421-.201-.571.028-.201.102-.407.059-.61-.098-.15-.216-.275-.323-.413.161-.15.35-.264.539-.382.047-.134.098-.268.146-.4.169.018.5.053.669.073.358-.315.736-.61 1.11-.901-.287-.083-.575-.169-.862-.22l.024-.128c-.342.002-.712-.001-1.047-.002l.028.132-.106.004c-.106.132-.224.254-.342.376-.232.409-.272.875-.421 1.314-.232.283-.575.441-.862.653-.138.232-.122.553-.358.712-.012.13-.024.26-.028.39.181.144.338.334.563.413.012.043.032.126.043.169-.122.161-.244.319-.358.484.09.008.268.02.354.028-.232.275-.555.657-.956.458-.138.242-.354.45-.232.783-.122-.049-.24-.092-.362-.14.102-.228.236-.445.354-.663-.106-.12-.228-.222-.342-.328.11.004.22.02.327.037.201-.077.401-.152.61-.214-.177-.4-.386-.777-.61-1.147-.279.13-.531.311-.689.578-.161.022-.323.043-.48.069.177.216.425.35.649.519-.157.063-.315.122-.472.177-.055.136-.11.268-.161.403-.09.001-.268.033-.358.043-.378-.136-.779-.026-1.161-.122-.197-.039-.33-.207-.48-.327-.122-.026-.248-.053-.37-.077-.051-.043-.142-.132-.189-.175.008-.203.016-.405.02-.608-.559.098-1.165.071-1.665.378.13.118.272.232.437.295-.13.086-.256.179-.378.271.075.212.154.478-.106.596-.028-.384-.335-.647-.531-.95-.224.037-.445.094-.653.171-.236-.136-.594-.14-.822.004-.303-.092-.59-.226-.858-.392.268-.114.555-.165.854-.157-.004-.138-.008-.279-.012-.417-.083-.077-.165-.157-.244-.234-.283-.016-.563-.037-.846-.061-.641-.303-1.149-.936-1.889-.984-.22.146-.433.315-.7.358.067-.244.142-.492.204-.736-.275.142-.504.35-.744.543-.11.126-.331-.055-.275-.189.024-.22.083-.439.09-.661-.106-.069-.213-.13-.319-.185-.016.088-.047.268-.063.358-.099.053-.197.106-.291.165-.095-.008-.283-.024-.378-.029.004-.057.008-.177.016-.236-.098.012-.287.033-.382.049l-.09-.035c-.464.165-.937.295-1.413.429-.157.04-.24-.027-.252-.197-.154.051-.307.11-.46.169-.173-.039-.35.045-.519.067l-.012.122c-.201.051-.401.09-.602.122-.279-.213-.421-.551-.61-.83-.142-.014-.279-.024-.421-.026-.244-.189-.464-.403-.744-.541-.287-.035-.574-.051-.862-.049-.047-.041-.146-.12-.193-.161-.457.026-.791-.289-1.181-.45-.405-.102-.818-.181-1.224-.272.043-.12.087-.238.13-.354-.311-.008-.622-.014-.933-.016-.004-.083-.016-.248-.02-.33-.075-.001-.224-.032-.303-.042-.13-.102-.22-.281-.397-.305-.311.031-.614.142-.925.181-.236-.059-.701-.173-.937-.232-.578.024-1.157.122-1.743.071-.815.112-1.436.754-2.204 1.015-.409.185-.842.075-1.259.035-.232.22-.488.421-.704.657.138.287.346.543.417.862-.008.327-.039.657-.067.988.079.002.24.004.319.004-.055.191-.146.452.11.537-.004.167-.008.336-.008.508-.063.014-.189.037-.252.053-.311.327-.744.087-1.114.039.126-.22.268-.433.378-.661-.24.004-.472.045-.689.14-.736.285-1.499.494-2.255.706.094.189.22.364.33.543-.161.242-.287.508-.33.799.492.142 1 .244 1.511.228.397-.134.775-.35 1.204-.329-.122.203-.346.246-.563.273-.043.209-.083.429-.189.622-.307.321-.744.474-1.192.443-.146.089-.287.179-.441.25-.209.022-.413-.047-.622-.047-.527.559-1.11 1.078-1.55 1.714-.224.293.157.73-.201.966.036.216.075.433.106.653.303-.035.614-.055.917-.094-.012.138-.024.279-.035.417-.24.213-.366.506-.448.811.149-.016.295-.027.448-.031.173-.149.378-.138.575-.035.047.158.102.319.157.476.079-.122.157-.242.244-.358.035.045.11.138.146.185.138.016.275.028.409.039-.268.274-.484.592-.712.895-.39.151-.76.344-1.153.478-.216.087-.492.142-.59.386-.398-.358-.94.004-1.303.244-.358-.11-.807.028-.913.417.449-.075.909-.122 1.318-.323.11-.022.22-.047.327-.075.099.063.197.128.299.191.094-.49.83-.081 1.106-.254l-.028-.116.102.002c.157-.461.862-.165 1.181-.366.094-.102.189-.201.283-.301.476-.065.952-.136 1.424-.199.193-.099.393-.165.606-.216.087-.067.177-.136.268-.205-.098-.173-.362-.317-.319-.531.264-.15.555-.24.85-.319.122-.114.244-.222.37-.329.02-.065.059-.193.079-.258.173-.118.311-.272.35-.48.448-.268.858-.777 1.428-.736.063.102.126.212.181.323-.165-.024-.323-.063-.488-.071-.193.051-.366.155-.547.244-.095.496-.405.905-.61 1.357.055.114.13.22.201.327-.287-.002-.516.189-.46.488.193-.039.382-.083.574-.136.578-.195.87-.866 1.499-.946.232-.401.453-.805.63-1.232.047.016.134.047.177.063.185-.079.37-.145.567-.189.185.405.571.696.999.791.693-.112 1.377.132 2.07.039-.079.108-.158.216-.228.334.098.095.205.177.315.266.036.191.016.423.209.539.036.38-.008.805-.26 1.106.016.095.032.189.051.283-.027.171-.134.387.091.472l.008.073.071-.004c.012.134.091.22.224.264-.118.165-.271.307-.448.411-.008.144-.012.287-.016.431.102-.13.204-.26.311-.386.02.106.059.323.079.429.138-.114.264-.242.382-.372.13.157.271.305.409.458-.098.122-.13.272-.173.421-.059-.02-.173-.061-.232-.083l.016.106c-.106.128-.216.258-.327.386.032.1.063.201.099.303.118-.035.236-.067.358-.097l-.024-.092c.051-.008.154-.024.201-.033l.059.097c-.177.116-.331.268-.496.405l-.063-.051c-.008.091-.024.275-.031.366.059-.002.177-.004.24-.008 0 .063.004.183.008.244l-.091.031c-.079.26-.161.518-.256.771l.11.004-.004.114c.087 0 .264 0 .35 0-.008.094-.02.287-.028.382-.236-.106-.46-.236-.669-.38-.118.049-.236.098-.35.148.031.812.575 1.554 1.259 1.964.118-.059.236-.114.358-.165.027-.153.165-.33.051-.476-.079-.163-.248-.236-.389-.334.087-.169.134-.374.311-.472.047.134.13.24.252.319-.028.043-.075.122-.098.165.086.008.268.024.358.032-.043.114-.083.228-.126.344l.106.006c-.008.073-.02.216-.027.289-.059.102-.114.21-.165.319-.413.065-.846.073-1.204-.159-.173.567-.343 1.143-.673 1.637-.025.039-.055.074-.081.113.021 0 .042-.003.063-.003 3.388 0 6.139 2.739 6.139 6.154 0 3.376-2.751 6.103-6.139 6.103-.033 0-.065-.004-.097-.005-.024.393-.036.785-.058 1.181-.075.118-.145.238-.216.362.09.016.264.043.35.055.027.313.153.598.287.878.098.043.197.087.295.138-.043.185-.079.372-.106.562.102.063.208.122.315.185.091.181.232.342.279.539-.043.203-.193.366-.228.575.071.321.401.458.642.641l.118.457c.413.645.791 1.31 1.149 1.985.161.332.216.754.547.972.323.211.586.496.862.765.311.197.677.268 1.027.37.508.563 1.22.838 1.905 1.121.472.246.956.468 1.472.622.421.063.87-.057 1.196-.334.067.008.201.027.268.035l-.012-.112c.232.081.464.157.7.23.311.413.693.76 1.051 1.133l-.012.106c.224.185.433.421.728.482.169.028.508.081.677.108.464.34 1.066.51 1.645.47l.012-.094c.114.065.224.14.342.211-.063.004-.185.012-.248.016.24.63.866 1.031 1.177 1.629.016.11.036.222.059.33-.071.12-.134.236-.201.356.209.163.382.486.681.448.004-.049.012-.155.016-.206.272.285.61.496.937.718-.047.148-.099.297-.146.447.177.049.358.094.543.13l-.043.065c.256-.001.512.014.767.045.153.144.26.397.496.413.098.134.197.264.291.401.224-.051.441-.14.653-.236-.122-.183-.24-.37-.35-.555.362-.177.567-.563.925-.732.267.144.433.425.657.626-.02.165-.063.332-.043.5.067.146.169.275.275.399.13.183.252.368.374.557-.067.189-.071.388-.035.584-.138.608.016 1.226.004 1.842-.134.238-.279.47-.445.691-.22.15-.46.258-.681.398.035.104.071.209.11.315-.122.051-.24.104-.358.159.047.045.138.136.181.181-.26.425-1.043.305-.929 1.01-.095.285-.252.549-.323.844-.09.047-.177.095-.268.146.114.346.035.7-.004 1.057.173.128.323.336.559.348l-.036.083.04.099.098.045c.035-.026.106-.079.142-.104-.087.153-.173.305-.232.472-.393.175-.693.516-.822.923-.028.151.114.262.177.391-.004.033-.012.098-.016.13.224.236.13.543.079.826.283.134.578.272.811.492.295.34.48.754.732 1.129.35.539.527 1.165.822 1.731.488.864 1.015 1.7 1.519 2.554-.024.815.638 1.346 1.22 1.8.815.616 1.861.852 2.601 1.58.228.242.433.551.783.633.213.74.437 1.484.519 2.255.15.87-.169 1.751.043 2.621.201 1.275.146 2.579.024 3.862-.035.218.118.395.177.592-.02.27-.063.594-.059.877.087.417.315.787.425 1.196.11.376.004.795.185 1.155-.063.828-.142 1.655-.228 2.481-.028.173.012.348.043.523-.083.004-.248.012-.331.016.126.295.26.594.37.901.118.354.382.635.574.948-.071.122-.142.242-.212.364.075.515.134 1.041.437 1.485-.22.405.145.86.118 1.279.15.004.303.008.453.014-.004-.152-.004-.301-.008-.447-.055-.039-.165-.122-.22-.163.024-.104.051-.203.079-.303-.063-.108-.122-.215-.177-.321.114-.097.224-.193.338-.287.043.146.087.295.126.449.091.016.264.043.346.059-.055.024-.169.071-.224.096.15.679.405 1.352.393 2.056.09.209.146.433.059.659-.146-.258-.24-.539-.283-.828-.091 0-.181.004-.272.006-.071.027-.216.083-.291.11.086.065.181.128.271.191.032.069.094.204.126.271l-.035-.037c-.075.189-.142.384-.209.58.016.051.051.153.071.205-.126.142-.331.252-.319.472.106.059.209.118.323.177-.024-.073-.063-.213-.086-.283.354.122.87.051 1.059.423-.287.002-.268.289-.244.498-.158.083-.311.169-.46.254.043.151.083.301.122.458.189.002.382.001.571 0-.051.301-.098.608-.13.917.059.004.173.012.228.016.075.256.197.498.346.72.031-.112.059-.22.094-.33.031-.016.106-.051.142-.071l.087.047c.047.104.094.212.142.321-.059.022-.173.065-.228.087.087.085.177.171.268.262-.059.114-.118.232-.169.354.126-.047.256-.092.386-.134-.027-.059-.091-.171-.118-.23.043-.037.134-.11.177-.144.134.112.272.222.413.334-.075.13-.157.256-.236.386.13.083.252.171.382.26l-.035.04c.118 0 .232 0 .354-.004-.043.112-.087.224-.13.342.138.006.283.008.425.008.031.057.098.165.13.22-.024.051-.075.161-.098.215.146.043.295.088.445.128-.059.065-.118.13-.177.197.142.126.291.246.433.374 0-.061-.004-.181-.004-.244.106.079.173.275.334.236.295.067.59.13.889.209-.189-.026-.287.057-.295.244.268-.024.535-.028.803.004-.028.067-.083.197-.11.262.185.045.374.085.567.12-.008-.059-.016-.181-.024-.244.035-.012.102-.032.142-.043.071.169.118.486.374.366.02.203.358.142.433.008l.043.063c.087.016.26.041.35.055.043.041.138.124.185.165-.016-.073-.047-.224-.063-.299.224-.016.453-.012.677-.006-.028-.053-.087-.151-.118-.203.268.006.539-.016.811-.061.051-.079.098-.155.149-.238-.582-.051-1.157-.197-1.641-.531-.354-.197-.637-.514-1.043-.59.02-.045.059-.136.079-.181-.118-.118-.236-.236-.346-.354-.102.037-.204.077-.303.12-.079-.053-.232-.152-.311-.203.02-.043.055-.124.071-.169.185.045.374.083.567.116-.354-.484-.949-.86-1.043-1.485.173-.161.374-.283.574-.405-.027-.25-.102-.498-.086-.75.193-.474.885-.651.692-1.305-.413-.264-.936-.266-1.31-.598l-.366-.228c.035-.323.086-.618.142-.927.252-.043.508-.085.763-.114-.028-.293-.012-.62.02-.899-.047-.043-.142-.122-.189-.161.047-.134.095-.268.146-.398.106-.088.212-.177.315-.266-.157-.037-.311-.081-.468-.124.039-.114.071-.228.095-.342-.311-.382-.622-.783-.712-1.279.334.079.657.201.988.303.342.104.637-.075.921-.217-.079-.161-.173-.315-.236-.48-.027-.161.051-.307.087-.455-.114-.222-.24-.435-.354-.655 1.027.122 2.125-.087 3.02-.622.024-.374.197-.708.366-1.031-.051-.138-.106-.276-.153-.415-.193-.073-.401-.149-.527-.323-.024-.187.035-.372.079-.549-.327-.315-.752-.468-1.137-.685.004-.098.016-.295.024-.394.26.252.61.37.96.46.275.073.531.266.834.228.268-.031.543.037.815.018.382-.163.751-.529.728-.972.161-.167.405-.297.46-.535-.008-.372.177-.671.338-.982-.142-.035-.209-.122-.205-.256.169-.287.433-.535.39-.907.142-.049.283-.098.429-.145-.008.143-.012.293-.016.439-.055.037-.165.11-.22.144.008.092.02.279.028.372.622-.637.354-1.844 1.212-2.288.256-.545.028-1.149-.035-1.71-.02-.338.004-.677-.024-1.01.079-.012.232-.028.311-.035.008-.079.028-.234.04-.311.46-.315.865-.724 1.385-.937.15.014.295.053.441.087-.024-.049-.067-.146-.09-.197.079-.079.161-.158.244-.232.079-.012.236-.026.315-.031-.024-.059-.063-.173-.086-.228.094.024.193.051.287.083.02-.035.063-.102.083-.134.488.004.964-.055 1.452-.083.004-.077.02-.236.027-.317.181-.132.362-.258.547-.384.039-.334.095-.651.173-.972.26-.145.315-.447.35-.714.095-.1.193-.199.291-.297-.031-.315-.083-.577-.075-.88.09-.403.374-.746.339-1.182.067-.441.122-.885.035-1.326-.075-.771-.083-1.552.075-2.31.043.075.134.222.177.299.504-.403.598-1.08.913-1.611.358-.454.807-.836 1.106-1.336.421-.58.563-1.33.429-2.028-.113-.529-.207-1.106-.553-1.551m-34.507-43.46l-.008.073c-.02.026-.055.077-.071.1-.043.031-.122.092-.161.122-.032-.028-.087-.083-.118-.11l.012-.087c.016-.028.043-.079.059-.102.047-.031.146-.09.197-.118l.079.047c.016-.012.043-.045.059-.059l.004.055-.063.004.011.075m-.365-1.767c-.024-.065-.079-.189-.102-.252l.063-.073c.02-.026.067-.081.087-.11.012-.026.043-.077.059-.104l.093-.016c.055-.008.169-.027.228-.035.027.039.086.12.114.161l.051.091c-.004.15 0 .303.012.456l-.004.118c0 .081-.004.242-.008.323l-.004.1c-.075.128-.149.254-.236.372l-.008-.092c-.031-.022-.09-.071-.122-.094-.024-.001-.067-.03-.087-.039l.02.051c-.079-.1-.157-.195-.244-.281-.004-.055-.024-.163-.028-.218.008-.049.028-.154.04-.203l.075-.065.086-.001c-.023-.023-.066-.06-.085-.08m-2.184-8.114c.043.004.134.008.181.014l-.016.092c-.043-.004-.138-.006-.185-.008l.02-.098m-.567.309c.016.045.047.136.063.183-.028.001-.094.031-.122.043l-.079.045c-.035.001-.102.029-.138.041l-.09.043c-.063.024-.193.073-.26.096l-.098.022c-.087-.146-.169-.142-.244.012l-.087.036c-.028.026-.083.075-.11.102l-.047.079c-.15-.008-.295.004-.445.032-.205-.008-.618-.016-.822-.02l-.087-.047c-.035-.014-.102-.035-.134-.047l.043-.083.094-.029c.051-.002.15-.012.201-.014.086.15.161.138.224-.028.043-.031.114-.09.154-.122.031-.02.086-.059.114-.079.028-.02.087-.063.114-.083.047-.012.146-.039.193-.051l.102-.027.087-.02.016-.083.024-.098c.012-.075.031-.224.047-.299l.075.002c.027.018.086.053.118.071.051.037.15.114.201.152.027.026.075.075.098.098l.071.045c.209.018.417.026.626.026l.098.002m-3.156-3.083c.024-.031.071-.09.091-.122.063-.043.181-.126.24-.165l.083-.012.031-.073c.067-.032.197-.092.264-.124.067-.027.201-.079.268-.106l-.024-.039c-.016-.02-.036-.053-.051-.071-.024-.02-.075-.059-.102-.077-.15-.094-.354-.085-.472.053l-.098-.022c-.031-.051-.098-.151-.13-.199.153.012.303.012.456-.002.146.03.272 0 .382-.092l.098-.018c.138.02.264-.014.37-.108.079-.004.244-.014.327-.018.153.014.311.014.464 0l-.032.073-.083.036c-.059.027-.181.083-.24.11l-.098.035-.102.004-.098.006-.064.081.051.086.095.016.094.014.095.022c.256.059.511.122.771.189-.075.039-.216.118-.291.157-.031.033-.094.098-.126.132l.031.089c-.13-.036-.256-.087-.37-.146-.09-.142-.283-.095-.346.043-.024.024-.071.071-.099.09-.031.031-.094.087-.13.118l.016.09-.079-.039-.059-.059-.008-.087-.012-.086-.079-.051c-.031.033-.094.102-.126.138l-.101-.008-.106-.008c-.031.037-.087.114-.114.153-.031.012-.094.039-.13.055-.161.057-.327.102-.492.146.008-.053.027-.153.035-.204m4.884 42.719c-.079-.075-.154-.15-.232-.22.004-.165.004-.327.012-.492.204.114.405.238.598.382l-.004.079.067.055c.004.081.012.242.02.325-.159-.047-.308-.086-.461-.129m9.92 1.778c-.087-.14-.177-.274-.268-.402-.004-.13-.004-.261 0-.389.138-.165.268-.338.409-.5.106.34.248.675.287 1.035-.141.087-.287.174-.428.256m2.089 20.695c-.039-.028-.122-.091-.165-.12-.043-.024-.13-.069-.173-.092.004-.067.004-.201.008-.27l.024-.092.094-.026.079.041c.028.028.079.085.102.11.024.024.071.073.094.094.024.024.067.071.091.09l.035.063c-.047.052-.142.154-.189.202m.331.236l-.039-.079c.028.016.079.047.106.063l-.067.016m2.18 24.13c.043-.051.122-.146.165-.193.028.016.087.051.114.071l.059.059c.004.075.012.228.016.301-.154-.012-.252-.144-.354-.238m2.329-28.848c-3.386 0-6.127-2.723-6.127-6.103 0-3.412 2.741-6.154 6.127-6.154 3.388 0 6.139 2.743 6.139 6.154 0 3.38-2.751 6.103-6.139 6.103m6.788-7.596c.079-.1.37-.104.354.061-.082.094-.37.104-.354-.061m1.086-1.36l.079.059.016.096c-.055-.002-.154-.008-.205-.012.032-.036.083-.107.11-.143m-.13.699l-.098-.028c-.016-.039-.047-.12-.063-.159.118-.122.307-.157.457-.075-.052.138-.15.224-.296.262\"/><path opacity=\".15\" d=\"m49.08 58.04c-.142.14-.275.293-.339.488.299-.209.555-.476.83-.716-.021-.16-.043-.317-.066-.475-.187.136-.38.263-.582.378.05.109.101.217.157.325\"/><path opacity=\".15\" d=\"m20.439 63.01c.295.309.398.73.551 1.118-.114.193-.228.393-.393.555-.154-.004-.303-.039-.456-.067.122.413.378.761.63 1.102.071.014.212.043.283.059.055.234.204.421.37.594.051.395-.142.744-.299 1.086.429.531 1.074 1.027 1.051 1.785.189-.045.374-.097.563-.148-.016-.374-.138-.736-.366-1.031-.055.028-.161.083-.216.11.177-.602-.11-1.187-.055-1.792.02-.427-.256-.789-.327-1.2-.106-.549-.146-1.106-.209-1.659.071.083.149.169.224.256 0-.16 0-.319 0-.476-.083-.004-.24-.018-.323-.024-.11-.234-.335-.468-.217-.744.025-.072.045-.146.067-.22-.297-.057-.584-.139-.863-.237-.002.311-.006.622-.015.933\"/><path opacity=\".15\" d=\"m186.08 66.25c-.256.462-.464.982-.362 1.521.079.277.276.494.492.677.047.146.095.305.279.329-.032-.126-.063-.248-.091-.368.161-.523.409-1.049.331-1.613.114-.382-.075-.596-.256-.856-.137.098-.291.179-.393.31\"/><path opacity=\".15\" d=\"m51.42 24.824c-.323-.193-.634-.421-1.01-.49-.067.232-.126.466-.169.706.071.001.216.026.287.035-.095.067-.185.138-.279.209l.122.004c.055.037.169.114.224.154.012.075.031.222.043.295.291.037.602.083.901.126.087-.114.177-.23.268-.346-.279-.092-.579-.159-.858-.216.086-.004.26-.012.346-.016.035-.155.078-.31.122-.461\"/><path opacity=\".15\" d=\"m51.2 26.819c.031.358-.027.696-.295.944 0 .145-.016.293-.031.441.374.213.799.177 1.212.136.027.159.126.226.287.201l-.012.12c.433 0 1.306 0 1.739 0l-.008-.108c.244.033.472.14.712.191.393-.03.759-.215 1.129-.35-.008-.036-.031-.114-.043-.15.071-.12.165-.232.185-.374-.232-.134-.472-.26-.724-.34-.63.001-1.259.03-1.877.142-.346.065-.689-.089-1.023-.151l-.087-.053c-.083-.14-.161-.281-.24-.419.153-.012.311-.02.464-.028-.031-.024-.106-.073-.142-.095.031-.059.09-.177.118-.234.547.333 1.216.285 1.83.285.138-.043.268-.098.401-.153.031.045.098.134.13.179.346-.002.689-.045 1.031-.088-.032.128-.059.252-.087.382.405-.075.807-.181 1.2-.311.177-.055.236-.24.319-.389-.169-.012-.338-.024-.508-.035.055-.102.106-.205.161-.307.177-.051.35-.106.531-.161.012-.15.024-.299.039-.449.334.039.673.039 1-.016.027-.071.075-.214.098-.287.15.053.378-.153.37-.303l-.051-.059c.13-.228.205-.476.102-.732.299.041.535-.051.704-.284.157.051.33.036.5.043.094-.244.22-.478.429-.641l.047-.071c.311-.15.594-.346.846-.578l.102-.028.039-.083.079.047c.051-.02.157-.063.208-.083l.008-.085.098.041.11-.039.051-.094-.036-.091.02-.142c.315-.063.61-.189.917-.272l-.028-.134c.071-.02.212-.061.279-.083-.004-.075-.012-.228-.016-.303-.535-.039-.885-.5-1.401-.582l.008-.112c-.279.014-.519-.069-.72-.246-.149 0-.299.002-.448.008-.26-.142-.531-.279-.815-.362-.343-.045-.685.032-1.019.063-.047-.024-.142-.071-.193-.092l.098-.045c-.401-.075-.811-.031-1.204.051l-.004-.136c-.256.045-.504.108-.751.173-.091.114-.177.228-.268.344-.15.11-.295.224-.449.33l-.039-.083c-.213-.055-.421-.11-.637-.149l-.028.104c-.362.161-.756.277-1.157.27l-.047.13-.075.012-.008.071-.075-.047c-.071.004-.209.016-.279.022l-.086.073.004.071-.102-.043-.11.059-.008.106c-.071-.006-.216-.014-.287-.016.004.081.02.246.027.327.11.043.22.09.331.134 0 .086 0 .264 0 .35l.118-.028c.26.27.575.482.952.535.059 0 .173-.004.232-.004l-.059.063c.008.061.024.181.031.244l-.11-.012c.012.049.035.15.047.199-.024.112-.071.333-.095.443-.035-.124-.067-.25-.098-.376l-.134.026c-.039-.201-.134-.382-.26-.535-.086.134-.173.268-.264.403-.004-.094-.02-.281-.024-.374-.083-.002-.244-.001-.327-.014-.228-.266-.421-.555-.614-.846l.071-.051c-.472-.248-.645.165-.905.389-.047-.008-.142-.031-.189-.043.024.15.055.299.09.448-.134.006-.268.012-.397.024-.095.11-.189.215-.283.323.059 0 .177 0 .236.004l.004.108c-.09.006-.268.012-.362.016.055.268.11.533.15.801.145 0 .287-.004.433-.016.028.063.09.193.122.256-.063.004-.189.012-.248.012.106.315.232.618.366.925.429.179.881-.09 1.307.092.012-.041.031-.12.043-.159.13-.024.26-.047.389-.069.004.089.008.266.008.356l.126-.035c.181-.002.366.008.547.033.028.165.067.329.122.49l-.012.108c.094-.006.287-.014.386-.018l-.028.144c-.535.195-.689-.319-.932-.62-.236.029-.464.081-.693.142.079.195.165.386.252.578-.338.085-.673.169-1.015.248l-.043.083c-.106-.047-.213-.091-.315-.138-.059.138-.114.273-.161.413-.024-.032-.075-.094-.102-.126-.189-.012-.578-.043-.771-.055-.055-.104-.11-.207-.165-.307-.386-.055-.783-.122-1.173-.114.043.181.09.366.169.537.274.267.687.263 1.029.163\"/><path opacity=\".15\" d=\"m50.704 23.588c.016-.175.031-.35.047-.523-.177.016-.35.031-.519.049.094.208.259.372.472.474\"/><path opacity=\".15\" d=\"m54.997 34.3c-.409.12-.429.644-.429.986.276-.035.701-.004.913-.264.102-.14.157-.307.232-.46l.031-.083c-.232-.102-.492-.346-.747-.179\"/><path opacity=\".15\" d=\"m40.52 26.22c.039-.028.126-.081.165-.106.051.205.252.22.429.262.036-.13.067-.26.106-.39.055.035.165.1.224.136.189-.128.378-.258.551-.403.012.059.031.173.039.232.464.043.917-.252 1.189-.618.079-.02.244-.059.327-.079-.118-.11-.216-.252-.366-.311-.099.055-.193.114-.279.177l-.055.014c-.311-.045-.657-.116-.94.039-.602.297-1.224.537-1.873.704-.033.279.306.245.483.343\"/><path opacity=\".15\" d=\"m52.832 25.634c-.157 0-.315.004-.468.004-.004.09-.008.268-.012.36.15.043.303.086.457.126.008-.163.015-.329.023-.49\"/><path opacity=\".15\" d=\"m22.285 44.495c.153-.152.299-.305.441-.462-.197-.047-.39-.1-.579-.151-.413.48-.504 1.145-.342 1.743.055-.035.169-.102.224-.134-.032-.104-.067-.209-.099-.311.099-.09.205-.179.307-.268.012-.14.032-.28.048-.417\"/><path opacity=\".15\" d=\"m42.04 26.12c-.315.061-.645.094-.925.26-.043.043-.134.134-.177.177.448.134.81-.161 1.102-.437\"/><path opacity=\".15\" d=\"m45.592 25.27c.138-.181.275-.358.405-.547-.472-.028-.944.031-1.405.12-.039.108-.079.214-.11.323.067.065.138.132.205.201.307-.048.582-.093.905-.097\"/><path opacity=\".15\" d=\"m43.821 25.729c.016-.169-.276-.161-.354-.063-.02.165.271.157.354.063\"/><path opacity=\".15\" d=\"m44.48 24.928c-.047-.114-.09-.226-.134-.336-.114.047-.228.095-.342.142.028.051.083.15.11.201.091-.003.272-.005.366-.007\"/><path opacity=\".15\" d=\"m62.55 48.654l.051.077c-.047.014-.134.033-.181.045-.327.358-.641.732-.866 1.165-.177.411-.496.72-.799 1.039.051.012.153.035.204.047-.134.126-.271.24-.421.342-.012.073-.031.22-.043.293.85-.006 1.708.092 2.565.073-.201.169-.409.331-.606.502.161.006.323.014.488.018.047-.1.098-.201.15-.299.106-.059.208-.122.315-.185l.083.001c.036-.053.11-.157.145-.21.032.055.094.167.13.224-.079.14-.157.287-.232.431.149.033.319.057.389.218.09.004.185.004.279.008.154-.232.224-.523.366-.771-.071-.033-.205-.102-.275-.138.016-.051.051-.15.071-.199-.142.024-.283.053-.421.081.13-.187.283-.354.433-.529-.177.029-.35.053-.523.077.035-.209.13-.397.24-.575-.272-.071-.539-.14-.807-.22 0 .055-.004.167-.004.22-.189-.049-.382-.098-.571-.144.035-.11.075-.218.11-.328-.118-.042-.236-.083-.35-.122-.035-.028-.102-.083-.134-.108.173-.187.358-.366.5-.58l-.034-.08c.098-.122.205-.24.303-.364-.185-.008-.37-.016-.555-.018\"/><path opacity=\".15\" d=\"m46.48 24.58c-.055-.116-.122-.228-.193-.334-.437-.02-.874.057-1.299.149-.028.036-.083.11-.11.145.536-.067 1.063.128 1.602.04\"/><path opacity=\".15\" d=\"m59.27 50.48c-.346-.5-1.043-.516-1.57-.659.409.423.929.787 1.57.659\"/><path opacity=\".15\" d=\"m57.36 52.36c.323.193.641.425 1.027.476.138-.097.252-.218.374-.331-.464.004-.921-.043-1.283-.362-.032.056-.087.162-.118.217\"/><path opacity=\".15\" d=\"m51.786 38.3c.157-.063.303-.142.456-.22-.043-.112-.086-.224-.13-.336-.055.029-.169.085-.22.114-.059-.187-.102-.374-.145-.563-.327-.25-.661-.494-.937-.797-.098.02-.197.043-.295.067 0-.059-.008-.173-.016-.232.09.002.268.008.354.012-.004-.099-.008-.297-.012-.398-.118.049-.236.102-.35.161l-.004-.118c-.543.354-.673 1.031-.968 1.566-.216.075-.397.216-.559.38.185.001.559.03.748.039-.043.12-.09.242-.134.364.425.177.752-.277 1.114-.431.071-.1.142-.199.22-.293.059.175.236.222.394.272-.024.043-.067.128-.091.169.075.02.22.051.295.071.091.061.181.118.28.173\"/><path opacity=\".15\" d=\"m50.42 44.12c0 .15-.012.297-.02.451.083.002.24.012.319.014.035-.053.095-.159.126-.214.102-.012.299-.037.402-.051-.091-.116-.193-.224-.323-.287-.173-.033-.339.05-.504.087\"/><path opacity=\".15\" d=\"m50.51 38.659c-.138.179-.275.362-.394.555.515.15.936-.165 1.216-.539-.205-.004-.618-.012-.822-.016\"/><path opacity=\".15\" d=\"m52.37 39.37c-.063-.043-.185-.126-.248-.169-.122.053-.244.106-.366.161.035.201.083.398.138.594.157-.198.315-.393.476-.586\"/><path opacity=\".15\" d=\"m36.758 29.516c.02.053.063.159.087.211 0 .143.008.287.024.433.37-.124.748-.22 1.133-.279.291-.059.398-.391.653-.515.228-.118.457-.228.681-.354.039.031.122.098.165.134-.232.232-.508.417-.748.635.197.14.398.329.665.25.039.031.126.092.165.122-.275.024-.551.067-.818.134-.004.09-.008.272-.012.362.531.216 1.09.232 1.645.106.24.138.48.283.716.437-.866-.02-1.747-.189-2.605.014.055.191.11.386.158.58.342.098.685.161 1.031.244-.055.228-.106.459-.138.691.634-.006 1.275.061 1.901-.083.453-.128.944-.161 1.33-.45.102.134.228.261.394.321.004.045.016.142.024.187l.118.065c.047-.014.15-.041.201-.057.224.173.492.224.807.161-.028.051-.075.157-.102.213.083 0 .248.004.33.004-.031-.102-.059-.205-.086-.303.047-.02.138-.059.185-.079.012-.226-.051-.447-.079-.669.24.069.476.148.712.232.035-.14.063-.281.095-.421-.315-.216-.626-.437-.94-.649.024-.189.063-.374.13-.555.153-.411.165-.858.224-1.291.275-.138.696-.299.696-.661-.224-.299-.637-.059-.952-.031.043.059.134.181.173.242-.032.026-.099.083-.134.108l-.024-.087c-.185-.041-.366-.091-.551-.136-.067.091-.142.179-.209.27-.09.37-.232.724-.303 1.1-.079.008-.232.026-.311.033.079-.244.146-.49.232-.728-.157-.224-.334-.437-.567-.584-.016.163-.028.33-.035.498-.071-.012-.216-.036-.287-.045-.134-.344-.504-.447-.838-.439-.043.065-.122.193-.165.256-.055-.027-.161-.083-.213-.112.161-.128.327-.277.374-.488l-.114.001c-.122-.116-.248-.236-.366-.352-.09-.22-.24-.407-.37-.6-.197.031-.39.067-.582.112-.275-.14-.531-.317-.818-.431-.311-.004-.933-.001-1.247-.012-.059.218-.114.439-.161.661-.555.413-1.098.846-1.676 1.228-.094.253.256.253.402.357\"/><path opacity=\".15\" d=\"m56.36 34.787c-.114-.126-.244-.24-.374-.344-.067.029-.205.092-.272.124.004.067.012.201.012.268.209-.017.422-.03.634-.048\"/><path opacity=\".15\" d=\"m52.95 38.28c.035.171.079.338.122.512.126-.055.252-.11.382-.165-.09-.205-.319-.262-.504-.347\"/><path opacity=\".15\" d=\"m49.21 27.846c.264.281.681.378 1.043.496.138-.279.437-.704.094-.948-.44-.09-.846.157-1.137.452\"/><path opacity=\".15\" d=\"m54.32 33.394c-.134.11-.295.206-.346.386.193-.073.374-.169.559-.266.039-.147.083-.309.244-.372.004-.047.012-.142.016-.189-.146.043-.295.094-.441.142-.009.075-.024.224-.032.299\"/><path opacity=\".15\" d=\"m53.56 38.22c-.138.161.126.421.283.285.134-.159-.125-.418-.283-.285\"/><path opacity=\".15\" d=\"m59.48 33.29c-.087-.191-.177-.376-.264-.561-.122.075-.244.152-.37.226.079-.159.169-.313.26-.464-.284-.156-.665-.161-.866-.431-.083.002-.244.002-.323.002l-.02.088c-.13.028-.228-.012-.291-.118.051-.001.157-.029.213-.039l.098.069c.051-.122.098-.244.15-.366-.153-.077-.303-.153-.452-.23-.118.122-.24.24-.358.358-.122-.307-.228-.622-.397-.909-.11-.213-.248-.433-.515-.425.063-.106.134-.206.189-.317-.079-.303-.307-.569-.614-.659-.362-.086-.732-.102-1.102-.157-.051.167-.106.334-.157.502-.047-.128-.09-.258-.13-.386.004-.199-.35-.191-.437-.061l-.087-.024-.095-.051-.118.043-.027.098c-.209.008-.413.059-.614.094-.169.114-.323.248-.472.386l-.084-.007c-.028.158-.197.358.012.461-.035.039-.102.118-.138.157l.031.092c-.063.026-.189.077-.252.104-.012.252.272.362.358.582-.319-.043-.512-.303-.598-.586.063-.098.134-.191.209-.277-.031-.136-.055-.272-.087-.403.331-.303.696-.557 1.059-.819l-.02-.134c-.342.004-.712-.008-1.047 0l.008.118c-.323.024-.594.252-.83.453-.393.449-.756.94-.948 1.511.334.13.756.154.972.476-.295-.033-.578-.126-.858-.224-.161.305.091.577.323.754.653.175 1.295.423 1.979.472.189.142.401.144.602.03.126.154.256.307.382.464.157-.047.315-.091.472-.13 0-.049-.004-.147-.004-.197.079.004.248.008.327.001.008-.163.016-.325.02-.486.15.094.299.189.453.277-.031.1-.059.203-.087.305.079.004.244.008.323.012-.024.051-.079.161-.106.217.145.088.291.173.433.268.012.049.028.153.036.205-.161-.002-.319-.004-.472-.004.004.096.016.287.016.386.208-.095.405-.197.61-.301.138.34.445.565.736.777.063.283.126.571.157.862-.386.264-.751.565-1.173.775.059.216.15.417.236.622-.268.059-.531.161-.803.126-.327-.004-.598-.102-.909-.075-.161.075-.311.165-.472.24-.059.175-.118.354-.161.535.161.071.331.142.508.189.228-.024.453-.088.677-.138.299.047.602.02.909-.006.134.254.264.51.382.769.083.006.244.016.327.024-.031.169-.067.342-.091.517l.087.041c.043.154.095.309.142.464.083.004.248.008.334.012l.059-.177c.193.118.307.319.441.492.445.157.889.334 1.338.496.035-.114.079-.224.122-.334-.303-.319-.598-.642-.921-.935-.134-.124-.173-.309-.236-.474.138.098.272.205.402.315.035-.012.106-.031.138-.043.232.437.779.519 1.078.889-.094.274.401.301.33.03-.075-.104-.165-.138-.275-.097.039-.051.126-.153.169-.205-.031-.177-.063-.356-.09-.533.079.071.161.144.24.213-.016-.218-.043-.435-.075-.651-.114-.079-.11-.214-.118-.338-.079-.108-.149-.22-.22-.331-.169-.14-.33-.285-.488-.439-.028-.214-.079-.431-.272-.561.09 0 .272-.004.366-.004-.043-.15-.086-.295-.126-.443.047.018.138.057.181.073.035-.047.11-.148.145-.199.11.156.213.317.323.478l.098-.006c-.039.128.028.376.161.429-.004.38.472.449.728.628.051-.193.099-.386.138-.578.134-.014.272-.028.413-.037.126-.215.244-.449.448-.608.087-.102.224-.171.264-.307-.067-.122-.149-.232-.228-.346-.193.041-.386.087-.578.12.035-.12.067-.24.106-.36-.15-.002-.299-.002-.445-.002-.012-.144-.027-.283-.039-.423-.094-.067-.185-.136-.272-.205-.48.094-.681-.323-.901-.63-.079-.012-.236-.039-.311-.053.106-.085.134-.183.075-.295l.102.004c-.012-.069-.028-.205-.039-.271.197.029.393.065.59.108-.051-.106-.102-.213-.149-.317-.157-.002-.307-.004-.46-.006 0-.057 0-.171 0-.228l.607-.027m-1.826 2.914c-.181-.012-.386-.012-.523.126-.031-.036-.094-.11-.126-.146l.004-.108c.004-.051.016-.156.016-.207l.043-.086c.008-.035.028-.102.035-.138l.071.043c.051.047.153.142.205.189l.02.092c.047.001.146.03.193.041l.106.006c-.013.048-.033.14-.044.188\"/><path opacity=\".15\" d=\"m46.44 27.637c.055-.035.169-.106.224-.142-.008-.094-.028-.287-.035-.386-.161.106-.311.224-.46.35.07.044.2.131.271.178\"/><path opacity=\".15\" d=\"m57.15 41.35l-.04.1.04.093.09.04.1-.04.04-.093-.04-.1-.1-.04z\"/><path opacity=\".15\" d=\"m48.4 28.542c-.275-.028-.512.035-.72.191-.157-.014-.472-.041-.63-.055-.134.108-.272.212-.394.332.067.091.138.177.209.264-.031.096-.067.195-.098.291-.079.008-.244.024-.327.035-.051-.122-.102-.24-.149-.358-.153.043-.303.095-.453.142.043.224.087.484.295.618.358.224.468.649.669.996.346-.185.724-.303 1.102-.397.118-.222.256-.435.374-.657-.122-.197-.272-.382-.449-.535.232-.138.484-.244.685-.419-.028-.153-.075-.302-.114-.448\"/><path opacity=\".15\" d=\"m47.17 27.22c.09.008.275.028.366.036l-.071-.079c.212-.002.637-.008.85-.012-.248.11-.559.216-.508.547.382.083.795.163 1.177.024-.024-.059-.079-.173-.102-.228.098-.055.197-.114.295-.165.145-.323.409-.675.161-1.019-.106.03-.212.057-.315.087-.22-.118-.464-.187-.712-.213.031.209.063.415.091.626-.095-.112-.185-.224-.268-.339-.075-.008-.22-.022-.295-.03-.004.142-.008.285-.012.429l-.102.026c-.051-.031-.154-.094-.201-.124.114-.254.004-.486-.161-.687-.083.006-.248.016-.331.024-.043.185-.091.368-.138.555.055.004.169.014.228.02.012.172.028.347.048.522\"/><path opacity=\".15\" d=\"m42.499 27.735c.472-.022.98.008 1.393-.268.13.106.504.122.539-.075.417.079.842.075 1.267.092.201-.199.401-.4.602-.604.055-.138-.063-.327-.22-.285-.193-.006-.425.14-.567-.051.043-.238.13-.468.201-.698-.319.032-.614.154-.897.288.02.094.039.193.059.289-.224.136-.071.329.024.498-.311-.047-.59-.083-.893-.134.02-.043.055-.138.075-.185-.122-.161-.236-.329-.346-.498-.106.033-.213.067-.315.1-.012-.059-.043-.177-.055-.234.012-.213-.527-.191-.492.03-.197.039-.382.096-.571.147-.114.169-.268.305-.461.366-.145.132-.287.262-.429.398.649.342 1.397.136 2.09.24l.016.1c-.429.032-.85.079-1.275.138.082.114.168.228.255.346\"/><path opacity=\".15\" d=\"m48.41 25.41c.193-.004.393-.008.59-.008-.035-.057-.098-.167-.134-.22-.15-.004-.303-.008-.453-.012-.003.059-.003.179-.003.24\"/><path opacity=\".15\" d=\"m47.16 25.13c-.02.211-.032.423-.043.637.098-.001.299-.028.397-.039-.067-.226-.118-.493-.354-.598\"/><path opacity=\".15\" d=\"m48.04 24.934c.189-.051.382-.091.578-.12l.039.118c.134.012.271.022.409.037.09.151.177.307.311.425.15.022.327.035.386-.14.02-.258.016-.515.047-.771-.13-.112-.26-.22-.382-.332-.071-.012-.217-.037-.291-.049-.094-.1-.193-.203-.299-.293-.268-.02-.535.079-.799.114.012.045.035.134.047.181.106.161.232.315.346.472-.169-.028-.334-.059-.5-.086.03.149.069.294.108.444\"/><path opacity=\".3\" d=\"m55.626 83.31c-3.386 0-6.127 2.743-6.127 6.154 0 3.38 2.741 6.103 6.127 6.103 3.388 0 6.139-2.723 6.139-6.103 0-3.412-2.751-6.154-6.139-6.154m.004 8.318c-1.212 0-2.192-.972-2.192-2.18 0-1.22.98-2.204 2.192-2.204 1.21 0 2.194.984 2.194 2.204 0 1.209-.984 2.18-2.194 2.18\"/><path opacity=\".3\" fill=\"#fff\" d=\"m55.63 87.24c-1.212 0-2.192.984-2.192 2.204 0 1.208.98 2.18 2.192 2.18 1.21 0 2.194-.972 2.194-2.18 0-1.22-.984-2.204-2.194-2.204m0 2.876c-.378 0-.681-.303-.681-.681 0-.378.303-.685.681-.685.378 0 .683.307.683.685 0 .378-.305.681-.683.681\"/><circle opacity=\".6\" cx=\"55.63\" cy=\"89.44\" r=\".683\"/><path opacity=\".3\" d=\"m28.626 56.32c0-3.416-2.751-6.154-6.139-6.154-.021 0-.042.003-.063.003-3.357.034-6.06 2.757-6.06 6.151 0 2.664 1.709 4.917 4.092 5.752.28.098.567.18.863.237.348.067.707.103 1.074.109.033.0001.064.005.097.005 3.389.0001 6.14-2.726 6.14-6.103m-8.326-.019c0-1.22.98-2.2 2.192-2.2 1.21 0 2.194.98 2.194 2.2 0 1.208-.984 2.184-2.194 2.184-1.213 0-2.192-.976-2.192-2.184\"/><path opacity=\".3\" fill=\"#fff\" d=\"m24.685 56.3c0-1.22-.984-2.2-2.194-2.2-1.212 0-2.192.98-2.192 2.2 0 1.208.98 2.184 2.192 2.184 1.21 0 2.194-.976 2.194-2.184m-2.874-.004c0-.382.305-.685.681-.685.378 0 .683.303.683.685 0 .374-.305.677-.683.677-.377 0-.681-.303-.681-.677\"/><path opacity=\".6\" d=\"m23.17 56.3c0-.382-.305-.685-.683-.685-.376 0-.681.303-.681.685 0 .374.305.677.681.677.378 0 .683-.303.683-.677\"/><path opacity=\".3\" d=\"m39.752 52.42c0 3.38 2.743 6.103 6.127 6.103 1.074 0 2.083-.275 2.961-.756.03-.016.057-.035.086-.052.202-.115.395-.242.582-.378.079-.058.16-.114.236-.175.305-.246.586-.521.839-.82.05-.059.095-.121.142-.181.807-1.032 1.292-2.327 1.292-3.74 0-1.852-.814-3.502-2.097-4.628-.407-.357-.862-.66-1.353-.9-.813-.397-1.723-.626-2.688-.626-3.384-.002-6.127 2.741-6.127 6.153m8.327-.016c0 1.208-.984 2.18-2.196 2.18s-2.192-.972-2.192-2.18c0-1.22.98-2.204 2.192-2.204s2.196.984 2.196 2.204\"/><path opacity=\".3\" fill=\"#fff\" d=\"m43.691 52.41c0 1.208.98 2.18 2.192 2.18s2.196-.972 2.196-2.18c0-1.22-.984-2.204-2.196-2.204s-2.192.984-2.192 2.204m2.877-.008c0 .378-.307.681-.685.681-.376 0-.681-.303-.681-.681 0-.378.305-.685.681-.685.378 0 .685.307.685.685\"/><path opacity=\".6\" d=\"m45.2 52.4c0 .378.305.681.681.681.378 0 .685-.303.685-.681 0-.378-.307-.685-.685-.685-.376 0-.681.307-.681.685\"/><path opacity=\".3\" d=\"m125.19 60.923c-.052-.086-.102-.175-.158-.259-.073-.108-.154-.21-.233-.312-1.122-1.451-2.874-2.384-4.848-2.384-1.685 0-3.211.68-4.319 1.784-.398.397-.74.851-1.018 1.346-.125.223-.237.454-.334.693-.292.718-.456 1.504-.456 2.332 0 3.376 2.743 6.103 6.127 6.103 2.502 0 4.649-1.487 5.605-3.622.251-.562.422-1.167.492-1.803.025-.223.04-.448.04-.678 0-1.177-.332-2.269-.898-3.2m-5.235 5.364c-1.212 0-2.192-.976-2.192-2.184 0-1.22.98-2.2 2.192-2.2 1.21 0 2.194.98 2.194 2.2 0 1.208-.984 2.184-2.194 2.184\"/><path opacity=\".3\" fill=\"#fff\" d=\"m119.96 61.903c-1.212 0-2.192.98-2.192 2.2 0 1.208.98 2.184 2.192 2.184 1.21 0 2.194-.976 2.194-2.184 0-1.22-.984-2.2-2.194-2.2m0 2.873c-.378 0-.681-.303-.681-.677 0-.382.303-.685.681-.685.378 0 .685.303.685.685 0 .374-.307.677-.685.677\"/><path opacity=\".6\" d=\"m119.96 63.41c-.378 0-.681.303-.681.685 0 .374.303.677.681.677.378 0 .685-.303.685-.677 0-.382-.307-.685-.685-.685\"/><path opacity=\".3\" d=\"m100.23 46.821c.078.003.154.012.232.012 2.592 0 4.802-1.596 5.702-3.855.181-.453.307-.933.374-1.433.005-.039.013-.076.018-.115.013-.114.019-.23.025-.345.007-.118.018-.236.018-.356 0-.043-.005-.084-.006-.127-.007-.364-.043-.72-.11-1.066-.223-1.149-.766-2.176-1.527-2.997-1.12-1.208-2.716-1.965-4.493-1.965-3.384 0-6.127 2.739-6.127 6.154 0 2.97 2.124 5.436 4.939 5.987.06.012.123.018.184.028.251.042.508.068.771.078m2.43-6.112c0 1.208-.984 2.184-2.194 2.184-1.212 0-2.192-.976-2.192-2.184 0-1.22.98-2.2 2.192-2.2 1.21 0 2.194.98 2.194 2.2\"/><path opacity=\".3\" fill=\"#fff\" d=\"m98.27 40.709c0 1.208.98 2.184 2.192 2.184 1.21 0 2.194-.976 2.194-2.184 0-1.22-.984-2.2-2.194-2.2-1.212 0-2.192.98-2.192 2.2m2.876-.004c0 .374-.307.677-.685.677-.378 0-.681-.303-.681-.677 0-.382.303-.685.681-.685.379 0 .685.304.685.685\"/><path opacity=\".6\" d=\"m99.78 40.705c0 .374.303.677.681.677.378 0 .685-.303.685-.677 0-.382-.307-.685-.685-.685-.378 0-.681.304-.681.685\"/><path opacity=\".3\" d=\"m119.41 51.686c.937-.609 1.692-1.467 2.178-2.479.383-.797.604-1.687.604-2.63 0-3.416-2.745-6.154-6.135-6.154-.585 0-1.15.087-1.686.24-1.074.307-2.025.898-2.771 1.691-1.034 1.1-1.672 2.581-1.672 4.223 0 1.8.784 3.41 2.025 4.527.006.005.012.011.018.016.205.183.419.357.647.512.319.215.66.401 1.018.554.743.318 1.56.495 2.42.495 1.24-.002 2.39-.369 3.354-.995m-5.541-5.129c0-1.22.98-2.2 2.192-2.2 1.21 0 2.194.98 2.194 2.2 0 1.208-.984 2.184-2.194 2.184-1.212 0-2.192-.976-2.192-2.184\"/><path opacity=\".3\" fill=\"#fff\" d=\"m118.26 46.557c0-1.22-.984-2.2-2.194-2.2-1.212 0-2.192.98-2.192 2.2 0 1.208.98 2.184 2.192 2.184 1.21 0 2.194-.976 2.194-2.184m-2.875-.004c0-.382.303-.685.681-.685s.683.303.683.685c0 .374-.305.677-.683.677s-.681-.303-.681-.677\"/><path opacity=\".6\" d=\"m116.75 46.553c0-.382-.305-.685-.683-.685s-.681.303-.681.685c0 .374.303.677.681.677s.683-.303.683-.677\"/><path opacity=\".3\" d=\"m207.97 54.37c0-3.416-2.745-6.154-6.135-6.154-3.386 0-6.129 2.739-6.129 6.154 0 3.376 2.743 6.103 6.129 6.103 3.39.0001 6.135-2.726 6.135-6.103m-8.323-.019c0-1.22.98-2.2 2.192-2.2 1.21 0 2.194.98 2.194 2.2 0 1.208-.984 2.184-2.194 2.184-1.212 0-2.192-.976-2.192-2.184\"/><path opacity=\".3\" fill=\"#fff\" d=\"m204.03 54.36c0-1.22-.984-2.2-2.194-2.2-1.212 0-2.192.98-2.192 2.2 0 1.208.98 2.184 2.192 2.184 1.21 0 2.194-.976 2.194-2.184m-2.875-.004c0-.382.303-.685.681-.685.378 0 .683.303.683.685 0 .374-.305.677-.683.677-.378 0-.681-.303-.681-.677\"/><path opacity=\".6\" d=\"m202.52 54.35c0-.382-.305-.685-.683-.685-.378 0-.681.303-.681.685 0 .374.303.677.681.677.378 0 .683-.303.683-.677\"/><path opacity=\".3\" d=\"m207.68 116.45c-.319 0-.63.032-.935.079-2.075.318-3.805 1.674-4.644 3.533-.291.644-.473 1.346-.527 2.087-.011.151-.023.302-.023.456 0 .604.091 1.185.254 1.735.75 2.53 3.094 4.369 5.875 4.369 3.39 0 6.135-2.723 6.135-6.103 0-3.414-2.744-6.156-6.135-6.156m.004 8.318c-1.212 0-2.192-.972-2.192-2.18 0-1.22.98-2.203 2.192-2.203 1.21 0 2.194.984 2.194 2.203 0 1.208-.983 2.18-2.194 2.18\"/><path opacity=\".3\" fill=\"#fff\" d=\"m207.68 120.38c-1.212 0-2.192.984-2.192 2.203 0 1.208.98 2.18 2.192 2.18 1.21 0 2.194-.972 2.194-2.18 0-1.22-.983-2.203-2.194-2.203m0 2.876c-.378 0-.681-.303-.681-.681 0-.378.303-.685.681-.685.378 0 .683.307.683.685 0 .378-.305.681-.683.681\"/><circle opacity=\".6\" cx=\"207.68\" cy=\"122.58\" r=\".683\"/><path opacity=\".3\" d=\"m113.83 112.85c0 .895.197 1.74.542 2.505.959 2.124 3.095 3.599 5.585 3.599 3.39 0 6.137-2.723 6.137-6.103 0-1.989-.937-3.746-2.388-4.869-1.037-.803-2.335-1.285-3.749-1.285-3.386-.002-6.127 2.741-6.127 6.153m8.325-.016c0 1.208-.984 2.18-2.194 2.18-1.212 0-2.192-.972-2.192-2.18 0-1.22.98-2.203 2.192-2.203 1.21 0 2.194.983 2.194 2.203\"/><path opacity=\".3\" fill=\"#fff\" d=\"m117.77 112.84c0 1.208.98 2.18 2.192 2.18 1.21 0 2.194-.972 2.194-2.18 0-1.22-.984-2.203-2.194-2.203-1.212 0-2.192.983-2.192 2.203m2.192-.692c.378 0 .681.307.681.685 0 .378-.303.681-.681.681-.378 0-.681-.303-.681-.681 0-.378.303-.685.681-.685\"/><circle opacity=\".6\" cx=\"119.96\" cy=\"112.83\" r=\".683\"/></g></g><path opacity=\".5\" d=\"m69.13 43.697c-18.496 0-33.491 14.994-33.491 33.496 0 18.503 14.996 33.496 33.491 33.496 18.504 0 33.496-14.993 33.496-33.496.0001-18.502-14.992-33.496-33.496-33.496m0 61.08c-15.231 0-27.581-12.349-27.581-27.582 0-15.233 12.35-27.583 27.581-27.583 15.24 0 27.585 12.35 27.585 27.583 0 15.233-12.344 27.582-27.585 27.582\"/><path opacity=\".1\" d=\"m71.52 79.11l-.726-.726c.243-.338.39-.748.39-1.195 0-1.134-.917-2.055-2.051-2.05-.446 0-.856.147-1.193.39l-.727-.727-10.516-10.517-.465.468 10.513 10.515.726.726c-.245.338-.394.749-.396 1.197 0 1.128.922 2.054 2.054 2.051.449 0 .861-.148 1.198-.392l.726.726.778.778.466-.467-.777-.777m-2.391-.899c-.562 0-1.021-.455-1.021-1.02 0-.57.458-1.028 1.021-1.028.566 0 1.031.458 1.031 1.028.0001.565-.465 1.02-1.031 1.02\"/><g opacity=\".85\"><path d=\"m69.13 79.24c-1.132.002-2.054-.923-2.054-2.051.002-.448.151-.859.396-1.197l-.726-.726c-.425.527-.69 1.189-.69 1.921 0 1.41.956 2.591 2.251 2.955v10.418h1.658v-10.421c.405-.115.772-.308 1.09-.565l-.726-.726c-.338.244-.749.392-1.199.392\"/><path d=\"m84.6 68.873l-.555-.955-12.563 7.303c-.565-.671-1.402-1.105-2.35-1.105-.729 0-1.39.264-1.917.688l.727.727c.337-.243.748-.39 1.193-.39 1.134-.005 2.051.916 2.051 2.05 0 .446-.147.857-.39 1.195l.726.726c.426-.529.691-1.192.691-1.921 0-.357-.073-.694-.184-1.012l12.571-7.306\"/><path d=\"m70.16 77.19c0-.57-.465-1.028-1.031-1.028-.562 0-1.021.458-1.021 1.028 0 .565.458 1.02 1.021 1.02.565 0 1.031-.455 1.031-1.02\"/></g><path opacity=\".5\" d=\"m159.6 43.697c-18.496 0-33.491 14.994-33.491 33.496 0 18.503 14.996 33.496 33.491 33.496 18.504 0 33.496-14.993 33.496-33.496 0-18.502-14.993-33.496-33.496-33.496m0 61.08c-15.231 0-27.581-12.349-27.581-27.582 0-15.233 12.35-27.583 27.581-27.583 15.24 0 27.585 12.35 27.585 27.583-.0001 15.233-12.345 27.582-27.585 27.582\"/><path opacity=\".8\" fill=\"#fff\" d=\"m159.6 49.61c-15.231 0-27.581 12.35-27.581 27.583 0 15.233 12.35 27.582 27.581 27.582 15.24 0 27.585-12.349 27.585-27.582-.0001-15.233-12.345-27.583-27.585-27.583m2.897 26.568c.111.318.184.655.184 1.012 0 .729-.266 1.392-.691 1.921l.778.778-.466.467-.778-.778c-.529.427-1.192.694-1.924.694-1.407 0-2.581-.957-2.946-2.249h-12.481v-1.658h12.479c.114-.407.307-.776.564-1.095l-10.514-10.514.465-.468 10.516 10.516c.527-.424 1.188-.688 1.917-.688.948 0 1.785.434 2.35 1.105l12.563-7.303.555.955-12.571 7.305\"/><path opacity=\".1\" d=\"m161.99 79.11l-.726-.726c.243-.338.39-.748.39-1.195 0-1.134-.917-2.055-2.051-2.05-.446 0-.856.147-1.193.39l-.727-.727-10.516-10.516-.465.468 10.514 10.514.727.726c-.245.338-.394.749-.396 1.197 0 1.128.922 2.054 2.054 2.051.449 0 .861-.148 1.198-.392l.726.726.778.778.466-.467-.779-.777m-2.39-.899c-.562 0-1.021-.455-1.021-1.02 0-.57.458-1.028 1.021-1.028.566 0 1.031.458 1.031 1.028 0 .565-.465 1.02-1.031 1.02\"/><g opacity=\".85\"><path d=\"m175.07 68.873l-.555-.955-12.563 7.303c-.565-.671-1.402-1.105-2.35-1.105-.729 0-1.39.264-1.917.688l.727.727c.337-.243.748-.39 1.193-.39 1.134-.005 2.051.916 2.051 2.05 0 .446-.147.857-.39 1.195l.726.726c.426-.529.691-1.192.691-1.921 0-.357-.073-.694-.184-1.012l12.571-7.306\"/><path d=\"m159.6 79.24c-1.132.002-2.054-.923-2.054-2.051.002-.448.151-.859.396-1.197l-.727-.726c-.258.32-.451.689-.564 1.095h-12.479v1.658h12.481c.365 1.292 1.539 2.249 2.946 2.249.732 0 1.396-.267 1.924-.694l-.726-.726c-.337.244-.748.392-1.197.392\"/><path d=\"m160.63 77.19c0-.57-.465-1.028-1.031-1.028-.562 0-1.021.458-1.021 1.028 0 .565.458 1.02 1.021 1.02.566 0 1.031-.455 1.031-1.02\"/></g><path opacity=\".8\" fill=\"#fff\" d=\"m69.13 49.61c-15.231 0-27.581 12.35-27.581 27.583 0 15.233 12.35 27.582 27.581 27.582 15.24 0 27.585-12.349 27.585-27.582 0-15.233-12.344-27.583-27.585-27.583m3.082 27.581c0 .729-.265 1.392-.691 1.921l.778.778-.466.467-.778-.778c-.318.257-.686.45-1.09.565v10.421h-1.658v-10.419c-1.295-.364-2.251-1.545-2.251-2.955 0-.732.265-1.394.69-1.921l-10.514-10.515.465-.468 10.516 10.516c.527-.424 1.188-.688 1.917-.688.948 0 1.785.434 2.35 1.105l12.563-7.303.555.955-12.57 7.305c.111.32.184.657.184 1.014\"/></svg>");
        $templateCache.put('scripts/apps/ingest/ingest-stats-widget/thumbnail.svg', "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 232 144\" enable-background=\"new 0 0 232 144\"><defs><path id=\"0\" opacity=\".9\" d=\"m5.937 8.442v124.03h220.61v-124.03h-220.61m63.19 103.7c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947m90.47 0c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947\"/><path id=\"1\" opacity=\".75\" d=\"m116.37 66.44c2.77-16.191 14.226-29.409 29.399-34.705v-14h-117.61v115.26h117.61v-31.848c-15.173-5.296-26.629-18.514-29.398-34.708\"/><path id=\"2\" opacity=\".5\" d=\"m196.95 61.59v32.14h-49.91v18.46h58.26v-50.6z\"/><path id=\"3\" opacity=\".4\" d=\"m99.97 109.08c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-7.89h-69.28c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-36.496h-110.89c4.142 0 8.425 0 14.66 3.459 7.438 4.126 10.263 12.2 10.423 17.862.127 4.549-.448 8.302-.722 9.802 1.415.861 2.83 2.644 2.83 6.334 0 4.601-2.3 11.01-6.05 11.06-2.295 6.556-5.983 12.326-10.219 15.987v7.201l1.22 2.945c6.291 1.493 20.239 5.328 24.753 10.855 2.641 3.241 5.148 25.792 5.426 28.353l.011.1h68.55v-35.2h-69.28z\"/><clipPath><use xlink:href=\"#3\"/></clipPath><clipPath><use xlink:href=\"#2\"/></clipPath><clipPath><use xlink:href=\"#0\"/></clipPath><clipPath><use xlink:href=\"#1\"/></clipPath></defs><path opacity=\".55\" fill=\"#fff\" d=\"m58.32 20.793v30.22h30.23c.0001-16.705-13.52-30.22-30.23-30.22\"/><path opacity=\".5\" d=\"m58.32 51.01v-30.22c-16.674 0-30.21 13.514-30.21 30.22 0 16.689 13.539 30.19 30.21 30.19 8.37 0 15.899-3.385 21.357-8.857l-21.357-21.333\"/><path opacity=\".3\" d=\"m58.32 51.01l21.357 21.332c5.422-5.441 8.87-12.993 8.87-21.332h-30.23\"/><g fill=\"#fff\"><path opacity=\".85\" d=\"m118.64 134.76h13.358v9.239h-13.358z\"/><path opacity=\".45\" d=\"m136.66 117.78h13.362v26.22h-13.362z\"/><path opacity=\".85\" d=\"m154.68 127.97h13.358v16.03h-13.358z\"/><path opacity=\".45\" d=\"m172.7 93.37h13.36v50.627h-13.36z\"/><path opacity=\".85\" d=\"m190.71 112.28h13.358v31.724h-13.358z\"/><path opacity=\".45\" d=\"m28.535 114.69h13.358v29.31h-13.358z\"/><path opacity=\".85\" d=\"m46.552 123.33h13.362v20.673h-13.362z\"/><path opacity=\".45\" d=\"m64.57 113.66h13.358v30.34h-13.358z\"/><path opacity=\".85\" d=\"m82.59 104.98h13.36v39.02h-13.36z\"/><path opacity=\".45\" d=\"m100.6 117.78h13.358v26.22h-13.358z\"/></g><path opacity=\".15\" d=\"m107.28 27.688h44.06v3.085h-44.06z\"/><path opacity=\".7\" fill=\"#fff\" d=\"m107.28 34.771h96.53v3.085h-96.53z\"/><path opacity=\".15\" d=\"m107.28 41.854h77.78v3.086h-77.78z\"/><path opacity=\".7\" fill=\"#fff\" d=\"m107.28 48.936h83.75v3.087h-83.75z\"/><path opacity=\".15\" d=\"m107.28 56.02h73.878v3.084h-73.878z\"/><path opacity=\".7\" fill=\"#fff\" d=\"m107.28 63.1h31.519v3.082h-31.519z\"/><path opacity=\".15\" d=\"m107.28 70.19h69.35v3.084h-69.35z\"/></svg>");
        $templateCache.put('scripts/apps/monitoring/aggregate-widget/thumbnail.svg', "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 232 144\" enable-background=\"new 0 0 232 144\"><defs><path id=\"1\" opacity=\".9\" d=\"m5.937 8.442v124.03h220.61v-124.03h-220.61m63.19 103.7c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947m90.47 0c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947\"/><path id=\"2\" opacity=\".75\" d=\"m116.37 66.44c2.77-16.191 14.226-29.409 29.399-34.705v-14h-117.61v115.26h117.61v-31.848c-15.173-5.296-26.629-18.514-29.398-34.708\"/><path id=\"3\" opacity=\".5\" d=\"m196.95 61.59v32.14h-49.91v18.46h58.26v-50.6z\"/><path id=\"4\" opacity=\".4\" d=\"m99.97 109.08c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-7.89h-69.28c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-36.496h-110.89c4.142 0 8.425 0 14.66 3.459 7.438 4.126 10.263 12.2 10.423 17.862.127 4.549-.448 8.302-.722 9.802 1.415.861 2.83 2.644 2.83 6.334 0 4.601-2.3 11.01-6.05 11.06-2.295 6.556-5.983 12.326-10.219 15.987v7.201l1.22 2.945c6.291 1.493 20.239 5.328 24.753 10.855 2.641 3.241 5.148 25.792 5.426 28.353l.011.1h68.55v-35.2h-69.28z\"/><clipPath><use xlink:href=\"#4\"/></clipPath><clipPath><use xlink:href=\"#3\"/></clipPath><clipPath><use xlink:href=\"#1\"/></clipPath><clipPath id=\"0\"><use xlink:href=\"#2\"/></clipPath></defs><g opacity=\".75\"><g clip-path=\"url(#0)\"><g fill=\"#231f20\"><path opacity=\".45\" d=\"m91.75 125.31v-3.422h-12.11v-32.993h-16.08c-1.269 0-2.439-.447-3.358-1.189-1.224-.983-2-2.493-2-4.173v-54.973c0-2.957-2.402-5.36-5.36-5.36-2.957 0-5.359 2.403-5.359 5.36v96.75c0 2.957-2.403 5.361-5.36 5.361h11.09 33.19c2.954 0 5.358-2.404 5.358-5.361\"/><path opacity=\".3\" d=\"m74.34 43.845h-.055c-2.957 0-5.36 2.403-5.36 5.36v34.33c0 2.958-2.394 5.361-5.36 5.361h16.08v-39.69c-.0001-2.944-2.372-5.329-5.309-5.358\"/></g><g opacity=\".7\" fill=\"#fff\"><path d=\"m36.756 125.31c0 2.957 2.403 5.361 5.362 5.361 2.957 0 5.36-2.404 5.36-5.361v-4.473h-4.558v-1.343h4.559v-2.515h-4.559v-1.343h4.559v-2.515h-4.559v-1.343h4.559v-2.515h-4.559v-1.343h4.559v-2.514h-4.559v-1.343h4.559v-2.515h-4.559v-1.346h4.559v-2.515h-4.559v-1.343h4.559v-2.515h-4.559v-1.343h4.559v-9.834h-10.723v42.658\"/><path d=\"m122.4 45.41c-1.046-1.047-2.418-1.57-3.79-1.57h-16.08v-15.284c0-1.372-.523-2.744-1.573-3.79-1.044-1.047-2.418-1.57-3.789-1.57h-5.362-38.964c2.958 0 5.36 2.403 5.36 5.36v54.974c0 1.68.779 3.19 2 4.173.92.741 2.09 1.189 3.358 1.189 2.966 0 5.36-2.403 5.36-5.361v-7.474h-4.611v-1.343h4.611v-2.515h-4.611v-1.343h4.611v-2.516h-4.611v-1.343h4.611v-2.519h-4.611v-1.343h4.611v-2.516h-4.611v-1.343h4.611v-2.515h-4.611v-1.343h4.611v-2.517h-4.611v-1.343h4.611v-2.355c0-.054.006-.106.008-.159h-4.619v-1.343h4.829c.289-.987.854-1.854 1.607-2.517h-6.436v-1.343h9.869v.007c-.001 0-.02.002-.03.002.045-.0001.088-.007.133-.007h.055c2.936.029 5.308 2.414 5.308 5.358v39.689 32.993h12.159 32.16v-72.68c.0001-1.371-.523-2.743-1.57-3.79m-58.09-13.147h32v1.343h-32v-1.343m0 3.859h32v1.343h-32v-1.343m0 5.203v-1.343h32v1.343h-32m21.497 20.46h19.812v16.779h-19.812v-16.779m32 51.51h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.343h32v1.343m0-3.859h-32v-1.344h32v1.344m0-3.859h-32v-1.343h32v1.343m0-3.859h-9.485v-1.343h9.485v1.343m0-3.859h-9.485v-1.343h9.485v1.343m0-3.859h-9.485v-1.343h9.485v1.343m0-3.859h-9.485v-1.343h9.485v1.343m0-3.859h-9.485v-1.343h9.485v1.343m0-4.531h-32v-3.859h32v3.859\"/></g><path opacity=\".3\" fill=\"#231f20\" d=\"m85.81 61.787h19.812v16.779h-19.812z\"/></g></g><g fill=\"#231f20\"><path opacity=\".25\" d=\"m160.53 29.24c-22.16 0-40.548 16.08-44.16 37.2 3.614 21.13 22.01 37.21 44.16 37.21 22.16 0 40.544-16.08 44.16-37.21-3.62-21.12-22-37.2-44.16-37.2m0 58.657c-18.332 0-34.34-8.631-42.9-21.455 8.559-12.814 24.568-21.445 42.9-21.445 18.327 0 34.34 8.631 42.906 21.445-8.564 12.824-24.579 21.455-42.906 21.455\"/><path opacity=\".2\" d=\"m151.72 45.677c.857-.133 1.722-.246 2.594-.341-.872.094-1.737.207-2.594.341\"/><path opacity=\".2\" d=\"m148.73 46.22c.877-.186 1.765-.347 2.66-.492-.895.145-1.783.307-2.66.492\"/><path opacity=\".2\" d=\"m157.73 45.07c.926-.045 1.857-.073 2.796-.073-.939 0-1.87.028-2.796.073\"/><path opacity=\".2\" d=\"m163.06 87.83c-.284.012-.568.028-.853.037.285-.009.568-.025.853-.037\"/><path opacity=\".2\" d=\"m154.74 45.29c.871-.088 1.749-.159 2.633-.207-.884.048-1.761.119-2.633.207\"/><path opacity=\".2\" d=\"m165.03 87.72c-.393.031-.786.062-1.181.085.395-.023.788-.054 1.181-.085\"/><path opacity=\".2\" d=\"m140.58 48.623c.831-.317 1.673-.615 2.527-.893-.854.278-1.696.576-2.527.893\"/><path opacity=\".2\" d=\"m157.2 87.8c-.394-.023-.786-.053-1.178-.084.391.03.783.061 1.178.084\"/><path opacity=\".2\" d=\"m152.4 87.32c-.523-.075-1.043-.157-1.561-.246.518.088 1.038.171 1.561.246\"/><path opacity=\".2\" d=\"m155.58 87.68c-.46-.04-.918-.087-1.375-.138.457.05.914.098 1.375.138\"/><path opacity=\".2\" d=\"m160.53 44.996c.939 0 1.871.028 2.798.073-.927-.045-1.858-.073-2.798-.073\"/><path opacity=\".2\" d=\"m143.27 47.678c1.76-.567 3.567-1.052 5.416-1.445-1.85.393-3.656.878-5.416 1.445\"/><path opacity=\".2\" d=\"m137.93 49.716c.821-.365 1.657-.71 2.504-1.036-.847.326-1.683.671-2.504 1.036\"/><path opacity=\".2\" d=\"m158.85 87.87c-.287-.008-.571-.024-.857-.037.286.013.57.029.857.037\"/><path opacity=\".2\" d=\"m153.98 87.52c-.5-.058-.998-.122-1.494-.193.495.07.993.135 1.494.193\"/><path opacity=\".2\" d=\"m177.94 47.73c.855.279 1.699.577 2.531.895-.833-.318-1.676-.617-2.531-.895\"/><path opacity=\".2\" d=\"m172.37 46.23c1.85.394 3.658.879 5.42 1.447-1.762-.568-3.57-1.054-5.42-1.447\"/><path opacity=\".2\" d=\"m168.57 87.33c-.496.071-.995.135-1.496.193.501-.057 1-.122 1.496-.193\"/></g><path fill=\"#fff\" d=\"m203.43 66.44c-5.221-7.813-13.216-14.07-22.812-17.76.848.326 1.684.671 2.506 1.037 2.41 3.982 3.797 8.651 3.797 13.643 0 9.938-5.493 18.584-13.605 23.09 12.829-2.965 23.617-10.276 30.11-20\"/><path opacity=\".2\" fill=\"#231f20\" d=\"m173.32 86.45c-1.526.353-3.082.644-4.662.871 1.581-.226 3.135-.519 4.662-.871\"/><path fill=\"#fff\" d=\"m134.13 63.36c0-4.993 1.389-9.662 3.799-13.645-8.482 3.774-15.545 9.601-20.303 16.725 7.01 10.504 19.02 18.19 33.21 20.63-1.044-.18-2.077-.388-3.097-.624-8.112-4.501-13.608-13.148-13.608-23.09\"/><g fill=\"#231f20\"><path opacity=\".2\" d=\"m166.85 87.54c-.457.051-.916.098-1.377.138.461-.039.92-.087 1.377-.138\"/><path opacity=\".2\" d=\"m169.66 45.731c.896.145 1.784.307 2.662.493-.877-.186-1.766-.348-2.662-.493\"/><path opacity=\".2\" d=\"m166.74 45.34c.872.095 1.738.208 2.595.341-.858-.133-1.723-.247-2.595-.341\"/><path opacity=\".2\" d=\"m163.68 45.09c.885.048 1.763.119 2.634.207-.872-.088-1.749-.159-2.634-.207\"/></g><g fill=\"#b9db92\"><path d=\"m165.47 87.68c-.147.013-.295.021-.442.033.148-.012.296-.02.442-.033\"/><path d=\"m156.03 87.72c-.148-.012-.296-.02-.444-.033.147.013.296.022.444.033\"/><path d=\"m163.85 87.8c-.264.015-.53.024-.795.035.265-.011.531-.019.795-.035\"/><path d=\"m160.53 87.9c-.561 0-1.119-.009-1.675-.025.556.016 1.114.025 1.675.025\"/><path d=\"m162.2 87.87c-.556.016-1.115.025-1.676.025.561 0 1.12-.009 1.676-.025\"/><path d=\"m158 87.83c-.264-.012-.529-.02-.793-.035.264.015.529.023.793.035\"/><path d=\"m168.66 87.32c-.028.004-.057.007-.085.011.028-.004.057-.007.085-.011\"/><path d=\"m167.08 87.52c-.074.009-.15.015-.224.023.074-.008.149-.014.224-.023\"/><path d=\"m166.31 45.29c.141.014.283.028.424.044-.141-.016-.282-.03-.424-.044\"/><path d=\"m169.33 45.677c.111.017.221.036.331.054-.11-.018-.22-.037-.331-.054\"/><path d=\"m163.33 45.07c.118.006.236.009.354.016-.118-.007-.236-.001-.354-.016\"/><path d=\"m157.37 45.09c.118-.006.238-.001.356-.016-.118.006-.237.009-.356.016\"/><path d=\"m172.33 46.22c.014.003.027.006.041.009-.014-.003-.027-.006-.041-.009\"/><path d=\"m154.21 87.55c-.075-.008-.151-.015-.225-.023.075.008.15.015.225.023\"/><path d=\"m154.32 45.34c.141-.015.283-.03.424-.044-.142.014-.283.028-.424.044\"/><path d=\"m177.79 47.68c.052.017.105.033.157.05-.053-.017-.105-.033-.157-.05\"/><path d=\"m180.47 48.624c.049.019.098.038.146.056-.048-.018-.097-.037-.146-.056\"/><path d=\"m150.84 87.07c0 0-.002 0-.003 0 .002 0 .003 0 .003 0\"/><path d=\"m152.49 87.33c-.029-.004-.058-.007-.086-.012.028.005.057.008.086.012\"/><path d=\"m151.39 45.731c.111-.018.223-.037.334-.055-.112.018-.223.037-.334.055\"/><path d=\"m140.44 48.68c.05-.019.099-.038.148-.057-.049.019-.099.038-.148.057\"/><path d=\"m148.69 46.23c.014-.003.028-.007.043-.001-.015.003-.029.007-.043.001\"/><path d=\"m143.11 47.73c.053-.017.107-.034.161-.051-.054.017-.108.033-.161.051\"/></g><path opacity=\".5\" fill=\"#fff\" d=\"m183.13 49.717c-.822-.366-1.658-.71-2.506-1.037-.049-.019-.097-.038-.146-.056-.832-.318-1.676-.616-2.531-.895-.052-.017-.105-.033-.157-.05-1.762-.568-3.57-1.053-5.42-1.447-.014-.003-.027-.006-.041-.009-.878-.186-1.767-.348-2.662-.493-.111-.018-.221-.037-.331-.054-.857-.134-1.723-.247-2.595-.341-.141-.015-.282-.029-.424-.044-.872-.088-1.749-.159-2.634-.207-.118-.006-.236-.001-.354-.016-.926-.045-1.858-.073-2.798-.073-.939 0-1.87.028-2.796.073-.119.006-.238.009-.356.016-.885.048-1.762.119-2.633.207-.142.014-.283.029-.424.044-.872.095-1.737.208-2.594.341-.112.017-.223.037-.334.055-.895.145-1.783.306-2.66.492-.014.003-.028.007-.043.001-1.848.393-3.655.878-5.416 1.445-.054.017-.108.034-.161.051-.854.278-1.697.576-2.527.893-.05.019-.099.038-.148.057-.847.326-1.682.67-2.504 1.036-2.41 3.982-3.799 8.652-3.799 13.645 0 9.939 5.496 18.585 13.609 23.09 1.02.236 2.052.444 3.097.624.0001 0 .002 0 .002 0 .518.089 1.039.171 1.562.247.029.004.058.007.086.012.496.07.994.135 1.494.193.075.009.15.015.225.023.457.051.914.098 1.375.138.147.013.296.021.444.033.392.031.784.061 1.178.084.263.015.528.023.793.035.286.013.57.028.857.037.556.016 1.114.025 1.675.025.561 0 1.119-.009 1.676-.025.286-.008.569-.024.853-.037.265-.012.531-.02.795-.035.395-.023.788-.054 1.181-.085.147-.012.295-.02.442-.033.461-.04.919-.087 1.377-.138.074-.008.15-.015.224-.023.501-.058 1-.122 1.496-.193.028-.004.057-.007.085-.011 1.58-.227 3.135-.519 4.662-.871h.0001c8.112-4.501 13.605-13.147 13.605-23.09-.003-4.993-1.39-9.662-3.8-13.644m-22.599 27.42c-7.595 0-13.768-6.177-13.768-13.776 0-7.6 6.173-13.771 13.768-13.771 7.601 0 13.771 6.171 13.771 13.771 0 7.598-6.17 13.776-13.771 13.776\"/><path opacity=\".65\" fill=\"#231f20\" d=\"m160.53 49.589c-7.595 0-13.768 6.171-13.768 13.771 0 7.599 6.173 13.776 13.768 13.776 7.601 0 13.771-6.177 13.771-13.776 0-7.6-6.17-13.771-13.771-13.771m-1.923 11.854c-1.434 1.439-3.58 1.645-4.771.449-1.199-1.199-.999-3.333.448-4.784 1.439-1.439 3.573-1.644 4.772-.442 1.199 1.196 1 3.336-.449 4.777\"/><path fill=\"#fff\" d=\"m154.28 57.11c-1.446 1.451-1.647 3.585-.448 4.784 1.192 1.196 3.337.99 4.771-.449 1.451-1.44 1.648-3.581.449-4.776-1.199-1.204-3.332-.998-4.772.441\"/></svg>");
        $templateCache.put('scripts/apps/users/activity-widget/thumbnail.svg', "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 232 144\" enable-background=\"new 0 0 232 144\"><defs><path id=\"1\" opacity=\".9\" d=\"m5.937 8.442v124.03h220.61v-124.03h-220.61m63.19 103.7c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947m90.47 0c-19.267 0-34.943-15.677-34.943-34.947s15.675-34.947 34.943-34.947c19.27 0 34.947 15.677 34.947 34.947s-15.677 34.947-34.947 34.947\"/><path id=\"2\" opacity=\".75\" d=\"m116.37 63.44c2.77-16.191 14.226-29.409 29.399-34.705v-14h-117.61v115.26h117.61v-31.848c-15.173-5.296-26.629-18.514-29.398-34.708\"/><path id=\"3\" opacity=\".5\" d=\"m196.95 58.59v32.14h-49.91v18.46h58.26v-50.6z\"/><path id=\"4\" opacity=\".4\" d=\"m99.97 109.08c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-7.89h-69.28c-.866 0-1.568-.702-1.568-1.568v-14.05c0-.866.702-1.568 1.568-1.568h69.28v-36.496h-110.89c4.142 0 8.425 0 14.66 3.459 7.438 4.126 10.263 12.2 10.423 17.862.127 4.549-.448 8.302-.722 9.802 1.415.861 2.83 2.644 2.83 6.334 0 4.601-2.3 11.01-6.05 11.06-2.295 6.556-5.983 12.326-10.219 15.987v7.201l1.22 2.945c6.291 1.493 20.239 5.328 24.753 10.855 2.641 3.241 5.148 25.792 5.426 28.353l.011.1h68.55v-35.2h-69.28z\"/><clipPath id=\"0\"><use xlink:href=\"#4\"/></clipPath><clipPath><use xlink:href=\"#3\"/></clipPath><clipPath><use xlink:href=\"#1\"/></clipPath><clipPath><use xlink:href=\"#2\"/></clipPath></defs><path fill=\"#f9fcfc\" d=\"m58.36 106.82l-.001.001h.001z\"/><g fill=\"#fff\"><path d=\"m58.36 106.82c3.157-.084 6-.436 7.845-1.393-6.976-1.638-13.154-5.34-17.844-10.434v7.331c.082 3.429 4.588 4.351 9.999 4.496\"/><path opacity=\".75\" d=\"m66.2 105.43c1.316-.683 2.119-1.675 2.153-3.103v-7.925c-3.02 2.512-6.414 4.03-10.01 4.03-3.586 0-6.976-1.517-9.99-4.02v.581c4.69 5.094 10.868 8.796 17.843 10.434\"/><path d=\"m37.765 61.58c-.878-.167-1.507-.105-1.945.009-.003.036-.005.073-.008.11.451-.105.928-.159 1.427-.159.178-.0001.353.013.526.04\"/><path d=\"m44.614 45.578c0 1.377-.689 7.313-1.246 8.528s-2.522 2.75-3.089 4.132c-.295.718-.567 2.526-.761 4.099-.179 1.454-.292 2.707-.292 2.707h-1.426l-.035-3.465c-.173-.026-.348-.041-.526-.041-.5 0-.976.054-1.427.159-2.201.512-3.737 2.333-3.737 6.087 0 4.523 2.227 10.135 5.164 10.135.205 0 .406-.022.604-.056 2.193 6.601 5.914 12.731 10.514 16.554 3.02 2.505 6.404 4.02 9.99 4.02v-45.63c-8.991-1.22-13.733-8.607-13.733-7.23\"/><path opacity=\".9\" d=\"m80.889 61.698c-.003-.038-.005-.076-.008-.114-.438-.112-1.062-.17-1.931-.006l-.035 3.467h-1.427c0 0-.486-5.424-1.053-6.806-.567-1.382-2.532-2.917-3.089-4.132-.557-1.215-8.321-.396-14.989-1.297-.003 0-.006-.0001-.001-.002v45.63c3.592 0 6.987-1.522 10.01-4.03 4.595-3.823 8.311-9.947 10.502-16.541.198.034.398.056.601.056 2.938 0 5.164-5.611 5.164-10.135.002-3.752-1.532-5.573-3.731-6.086\"/></g><path opacity=\".3\" d=\"m37.765 61.58l.035 3.466h1.427c0 0 .113-1.254.292-2.707.194-1.573.466-3.38.761-4.099.567-1.382 2.532-2.917 3.089-4.132s1.246-7.151 1.246-8.528c0-1.377 4.742 6.01 13.734 7.23.003 0 .006.0001.001.002 6.668.901 14.432.081 14.989 1.297.557 1.215 2.522 2.75 3.089 4.132.567 1.382 1.053 6.806 1.053 6.806h1.427l.035-3.467c.868-.164 1.492-.105 1.931.006.545.139.795.361.795.361s.999-4.517.837-10.27c-.162-5.753-3.053-13.253-9.945-17.08-6.02-3.338-10.05-3.342-14.21-3.342s-8.272.065-14.29 3.403c-6.892 3.823-9.703 11.262-9.865 17.02-.162 5.753.837 10.27.837 10.27s.246-.218.78-.357c.436-.114 1.065-.175 1.943-.001\"/><g fill=\"#fff\"><path opacity=\".65\" d=\"m94.54 116.42c-4.563-5.586-19.885-9.522-24.711-10.647l.0001.0001-3.573 8.79c0 0-1.227-1.602-3.056-3.507l-3.423 4.522c2.513 7.291 4.205 17.738 4.604 28.707h35.38c0 0-2.679-24.745-5.221-27.866\"/><path opacity=\".65\" d=\"m57.1 115.58l-3.568-4.547c-1.842 1.916-3.08 3.532-3.08 3.532l-3.573-8.79v-.002c-4.156.968-16.09 4.02-22.24 8.406-2.893 1.988-4.793 3.223-7.71 30.11h36.21c.259-11.382 1.208-22.278 3.96-28.706\"/></g><path opacity=\".25\" d=\"m64.38 144.29c-.399-10.968-2.091-21.416-4.604-28.707l3.423-4.522c-1.364-1.421-3.061-3.01-4.841-4.232h-.002c-1.77 1.216-3.457 2.793-4.817 4.208l3.568 4.547c-2.752 6.428-3.701 17.324-3.96 28.707h11.233z\"/><g fill=\"#fff\"><path opacity=\".45\" d=\"m50.46 114.56c0 0 1.238-1.616 3.08-3.532 1.36-1.414 3.047-2.992 4.817-4.208v-.0001c-5.411-.145-9.917-1.067-9.998-4.496-.0001-.031-.008-.059-.008-.091l-1.465 3.536v.002l3.574 8.79\"/><path opacity=\".45\" d=\"m66.2 105.43c-1.844.956-4.688 1.308-7.845 1.393v.0001c1.781 1.223 3.478 2.812 4.842 4.233 1.829 1.906 3.056 3.507 3.056 3.507l3.573-8.79-.0001-.0001-1.465-3.537c0 .032-.007.06-.008.092-.034 1.427-.837 2.42-2.153 3.102\"/><path opacity=\".9\" d=\"m215.94 16.997h-115.98c-.866 0-1.568.702-1.568 1.568v14.05c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-14.05c0-.866-.702-1.568-1.568-1.568m-84.76 4.454c0-.299.242-.541.541-.541h31.906c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-31.906c-.299 0-.541-.242-.541-.541v-.811m-14.86 0c0-.299.242-.541.541-.541h11.02c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-11.02c-.299 0-.541-.242-.541-.541v-.811m-9.03 9.378c-2.894 0-5.24-2.346-5.24-5.24s2.346-5.24 5.24-5.24 5.24 2.346 5.24 5.24-2.346 5.24-5.24 5.24m47.898-1.09c0 .283-.23.513-.513.513h-37.846c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h37.846c.283 0 .513.23.513.513v.116m48.861-3.359c0 .283-.23.513-.513.513h-86.71c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h86.71c.283 0 .513.23.513.513v.116\"/></g><path opacity=\".1\" d=\"m116.86 22.803h11.02c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-11.02c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><path opacity=\".1\" d=\"m131.72 22.803h31.906c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-31.906c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><g fill=\"#fff\"><path opacity=\".6\" d=\"m203.54 25.75h-86.71c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h86.71c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><path opacity=\".6\" d=\"m154.68 29.11h-37.846c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h37.846c.283 0 .513-.23.513-.513v-.116c0-.284-.23-.513-.513-.513\"/><circle opacity=\".4\" cx=\"107.29\" cy=\"25.589\" r=\"5.24\"/></g><path opacity=\".3\" d=\"m215.94 34.18h-115.98c-.866 0-1.568-.702-1.568-1.568v1.16c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-1.16c0 .866-.702 1.568-1.568 1.568\"/><path opacity=\".9\" fill=\"#fff\" d=\"m215.94 41.91h-115.98c-.866 0-1.568.702-1.568 1.568v14.05c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-14.05c0-.867-.702-1.569-1.568-1.569m-84.76 4.454c0-.299.242-.541.541-.541h31.906c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-31.906c-.299 0-.541-.242-.541-.541v-.811m-14.86 0c0-.299.242-.541.541-.541h11.02c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-11.02c-.299 0-.541-.242-.541-.541v-.811m-9.03 9.379c-2.894 0-5.24-2.346-5.24-5.24 0-2.894 2.346-5.24 5.24-5.24s5.24 2.346 5.24 5.24c0 2.894-2.346 5.24-5.24 5.24m47.898-1.091c0 .283-.23.513-.513.513h-37.846c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h37.846c.283 0 .513.23.513.513v.116m48.861-3.359c0 .283-.23.513-.513.513h-86.71c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h86.71c.283 0 .513.23.513.513v.116\"/><path opacity=\".1\" d=\"m116.86 47.717h11.02c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-11.02c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><path opacity=\".1\" d=\"m131.72 47.717h31.906c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-31.906c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><g fill=\"#fff\"><path opacity=\".6\" d=\"m203.54 50.664h-86.71c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h86.71c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><path opacity=\".6\" d=\"m154.68 54.02h-37.846c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h37.846c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><circle opacity=\".4\" cx=\"107.29\" cy=\"50.5\" r=\"5.24\"/></g><path opacity=\".3\" d=\"m215.94 59.1h-115.98c-.866 0-1.568-.702-1.568-1.568v1.16c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-1.16c0 .866-.702 1.568-1.568 1.568\"/><path opacity=\".9\" fill=\"#fff\" d=\"m215.94 66.824h-115.98c-.866 0-1.568.702-1.568 1.568v14.05c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-14.05c0-.866-.702-1.568-1.568-1.568m-84.76 4.454c0-.299.242-.541.541-.541h31.906c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-31.906c-.299 0-.541-.242-.541-.541v-.811m-14.86 0c0-.299.242-.541.541-.541h11.02c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-11.02c-.299 0-.541-.242-.541-.541v-.811m-9.03 9.378c-2.894 0-5.24-2.346-5.24-5.24 0-2.894 2.346-5.24 5.24-5.24s5.24 2.346 5.24 5.24c0 2.894-2.346 5.24-5.24 5.24m47.898-1.09c0 .283-.23.513-.513.513h-37.846c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h37.846c.283 0 .513.23.513.513v.116m48.861-3.359c0 .283-.23.513-.513.513h-86.71c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h86.71c.283 0 .513.23.513.513v.116\"/><path opacity=\".1\" d=\"m116.86 72.63h11.02c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-11.02c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><path opacity=\".1\" d=\"m131.72 72.63h31.906c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-31.906c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><g fill=\"#fff\"><path opacity=\".6\" d=\"m203.54 75.58h-86.71c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h86.71c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><path opacity=\".6\" d=\"m154.68 78.937h-37.846c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h37.846c.283 0 .513-.23.513-.513v-.116c0-.284-.23-.513-.513-.513\"/><circle opacity=\".4\" cx=\"107.29\" cy=\"75.42\" r=\"5.24\"/></g><path opacity=\".3\" d=\"m215.94 84.01h-115.98c-.866 0-1.568-.702-1.568-1.568v1.16c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-1.16c0 .866-.702 1.568-1.568 1.568\"/><path opacity=\".9\" fill=\"#fff\" d=\"m215.94 91.74h-115.98c-.866 0-1.568.702-1.568 1.568v14.05c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-14.05c0-.867-.702-1.569-1.568-1.569m-84.76 4.454c0-.299.242-.541.541-.541h31.906c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-31.906c-.299 0-.541-.242-.541-.541v-.811m-14.86 0c0-.299.242-.541.541-.541h11.02c.299 0 .541.242.541.541v.811c0 .299-.242.541-.541.541h-11.02c-.299 0-.541-.242-.541-.541v-.811m-9.03 9.379c-2.894 0-5.24-2.346-5.24-5.24 0-2.894 2.346-5.24 5.24-5.24s5.24 2.346 5.24 5.24c0 2.894-2.346 5.24-5.24 5.24m47.898-1.091c0 .283-.23.513-.513.513h-37.846c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h37.846c.283 0 .513.23.513.513v.116m48.861-3.359c0 .283-.23.513-.513.513h-86.71c-.283 0-.513-.23-.513-.513v-.116c0-.283.23-.513.513-.513h86.71c.283 0 .513.23.513.513v.116\"/><path opacity=\".1\" d=\"m116.86 97.54h11.02c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-11.02c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><path opacity=\".1\" d=\"m131.72 97.54h31.906c.299 0 .541-.242.541-.541v-.811c0-.299-.242-.541-.541-.541h-31.906c-.299 0-.541.242-.541.541v.811c0 .299.242.541.541.541\"/><g fill=\"#fff\"><path opacity=\".6\" d=\"m203.54 100.49h-86.71c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h86.71c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><path opacity=\".6\" d=\"m154.68 103.85h-37.846c-.283 0-.513.23-.513.513v.116c0 .283.23.513.513.513h37.846c.283 0 .513-.23.513-.513v-.116c0-.283-.23-.513-.513-.513\"/><circle opacity=\".4\" cx=\"107.29\" cy=\"100.33\" r=\"5.24\"/></g><path opacity=\".3\" d=\"m215.94 108.92h-115.98c-.866 0-1.568-.702-1.568-1.568v1.16c0 .866.702 1.568 1.568 1.568h115.98c.866 0 1.568-.702 1.568-1.568v-1.16c0 .866-.702 1.568-1.568 1.568\"/><g opacity=\".4\"><g clip-path=\"url(#0)\"><g fill=\"#fff\"><path d=\"m99.75 120.9v-.97c-7.718-.387-10.722-2.398-13.951-6.318v7.288h.0001c0 6.247 13.834 7.618 13.95 0\"/><path opacity=\".75\" d=\"m99.75 119.93v-6.733c-2.106 1.753-4.475 2.815-6.981 2.815-2.502 0-4.867-1.058-6.97-2.806v.405c3.229 3.921 6.233 5.932 13.951 6.319\"/><path d=\"m77.06 90.36c-.0001.009-.002.019-.002.028.251-.058.512-.095.785-.106-.297-.012-.565.025-.783.078\"/><path d=\"m86.49 79.937c-3.087 2.038-5.71 4.861-6.323 8.03-.073.379-.245 1.576-.433 2.932-.32 2.31-.685 5.085-.685 5.085l-1-5.687c-.069-.008-.136-.009-.203-.012-.273.011-.534.048-.785.106-1.537.357-2.615 1.615-2.615 4.236 0 3.156 1.553 7.07 3.603 7.07.143 0 .283-.015.422-.039 1.53 4.605 4.126 8.883 7.336 11.549 2.103 1.747 4.468 2.806 6.97 2.806v-30.936c-3.647-1.545-5.71-3.883-6.283-5.14\"/><path opacity=\".9\" d=\"m108.49 90.39c-.0001-.007-.0001-.014-.002-.021-.228-.052-.507-.099-.89-.105l-1.165 5.445c0 0-.249-5.97-.492-7.235-.223-1.701-.688-2.784-1.751-3.074-1.03-.271-3.571-.042-7.213-.865 1.455.683 2.094.89 3.357 1.127-.991.049-2.068.002-3.187-.148 1.73.532 3.488.923 5.08.997 0 .004-.002.008-.002.012-2.328.249-5.519-.099-7.956-.883-.528-.17-1.022-.361-1.496-.562v30.935c2.506 0 4.875-1.062 6.981-2.815 3.205-2.667 5.798-6.94 7.327-11.54.138.024.277.039.419.039 2.05 0 3.603-3.915 3.603-7.07-.0001-2.619-1.078-3.878-2.613-4.236\"/><path opacity=\".6\" d=\"m118.02 128.56c-3.795-4.646-18.262-7.657-18.268-7.659-.116 7.618-13.95 6.247-13.95 0h-.0001c-.011.002-11.297 2.349-16.545 6.095-2.02 1.387-3.344 2.249-5.379 21.01h57.786c0 .0001-1.869-17.263-3.643-19.441\"/></g><path opacity=\".3\" d=\"m77.84 90.28c.067.003.133.004.203.012l1 5.687c0 0 .365-2.775.685-5.085.188-1.356.36-2.553.433-2.932.613-3.167 3.236-5.991 6.323-8.03.573 1.257 2.636 3.596 6.283 5.141.474.201.968.392 1.496.562 2.437.783 5.628 1.131 7.956.883 0-.004.002-.008.002-.012-1.592-.073-3.35-.464-5.08-.997 1.12.15 2.196.198 3.187.148-1.263-.237-1.901-.444-3.357-1.127 3.642.822 6.184.593 7.213.865 1.064.29 1.528 1.373 1.751 3.074.244 1.265.492 7.235.492 7.235l1.165-5.445c.383.007.662.054.89.105.363.083.559.182.559.182s.697-3.151.584-7.165c-.113-4.01-2.13-9.246-6.938-11.914-2.23-1.237-4.068-1.815-5.737-2.087-.802-.604-2.02-1.017-3.388-1.07-1.283-.05-2.34.229-3.069.707-.211-.056-.442-.106-.713-.14-.855-.107-1.907.143-2.398.443.468-.141 1.063-.187 1.698-.104.103.013.188.048.286.067-1.896.225-3.977.791-6.564 2.226-4.808 2.667-6.769 7.858-6.882 11.871-.113 4.01.584 7.165.584 7.165s.216-.109.549-.19c.218-.05.486-.087.783-.076m16.53-21.375c.77.03 1.483.18 2.109.407-1.289-.171-2.488-.174-3.702-.174-.157 0-.314 0-.472.0001.621-.17 1.316-.263 2.065-.234\"/></g></g></svg>");
    }]);


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1394);
__webpack_require__(1418);
__webpack_require__(1444);
__webpack_require__(1489);
__webpack_require__(1497);
__webpack_require__(1514);
__webpack_require__(1528);
__webpack_require__(1531);
__webpack_require__(1561);
__webpack_require__(1690);
__webpack_require__(1796);
__webpack_require__(1803);
__webpack_require__(1810);
__webpack_require__(1835);
__webpack_require__(1854);
__webpack_require__(1860);
__webpack_require__(1872);
__webpack_require__(1883);
__webpack_require__(1899);
__webpack_require__(1950);
__webpack_require__(1972);
__webpack_require__(1980);
__webpack_require__(2014);
__webpack_require__(2018);
__webpack_require__(2055);
__webpack_require__(2066);
__webpack_require__(2071);
__webpack_require__(2129);
exports.default = angular.module('superdesk.apps', [
    'superdesk.apps.settings',
    'superdesk.apps.dashboard',
    'superdesk.apps.users',
    'superdesk.apps.users.import',
    'superdesk.apps.users.profile',
    'superdesk.apps.users.activity',
    'superdesk.apps.archive',
    'superdesk.apps.ingest',
    'superdesk.apps.desks',
    'superdesk.apps.products',
    'superdesk.apps.authoring',
    'superdesk.apps.packaging',
    'superdesk.apps.editor2',
    'superdesk.apps.spellcheck',
    'superdesk.apps.notification',
    'superdesk.apps.highlights',
    'superdesk.apps.translations',
    'superdesk.apps.content_filters',
    'superdesk.apps.dictionaries',
    'superdesk.apps.vocabularies',
    'superdesk.apps.searchProviders',
    'superdesk.apps.stream',
    'superdesk.apps.publish',
    'superdesk.apps.templates',
    'superdesk.apps.monitoring',
    'superdesk.apps.profiling',
    'superdesk.apps.internal-destinations',
    'superdesk.apps.content-api',
    'superdesk.apps.extension-points',
    'superdesk.apps.contacts',
    'superdesk.apps.relations',
]);


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1395);
// scripts
__webpack_require__(1397);
var services_1 = __webpack_require__(1410);
var WorkspaceMenuProvider_1 = __importDefault(__webpack_require__(1412));
var directive = __importStar(__webpack_require__(1413));
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.workspace.menu', [])
    .provider('workspaceMenu', WorkspaceMenuProvider_1.default);
/**
 * @ngdoc module
 * @module superdesk.apps.workspaces
 * @name superdesk.apps.workspaces
 * @packageName superdesk.apps
 * @description Superdesk workspaces.
 */
angular.module('superdesk.apps.workspace', [
    'superdesk.apps.workspace.content',
    'superdesk.apps.workspace.menu',
])
    .service('workspaces', services_1.WorkspaceService)
    .directive('sdDeskDropdown', directive.WorkspaceDropdownDirective)
    .directive('sdWorkspaceSidenav', directive.WorkspaceSidenavDirective)
    .directive('sdEditWorkspace', directive.EditWorkspaceDirective)
    .run(['keyboardManager', function (keyboardManager) {
        keyboardManager.register('General', 'ctrl + alt + b', utils_1.gettext('Open workspace / dashboard'));
        keyboardManager.register('General', 'alt + m', utils_1.gettext('Open monitoring'));
        keyboardManager.register('General', 'ctrl + alt + h', utils_1.gettext('Open highlights'));
        keyboardManager.register('General', 'alt + t', utils_1.gettext('Open tasks'));
        keyboardManager.register('General', 'ctrl + alt + k', utils_1.gettext('Open spike'));
        keyboardManager.register('General', 'alt + p', utils_1.gettext('Open personal'));
        keyboardManager.register('General', 'ctrl + alt + f', utils_1.gettext('Open search'));
        keyboardManager.register('General', 'x', utils_1.gettext('Multi-select (or deselect) an item'));
    }]);


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1396);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./profiles.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./profiles.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\nsd-content-schema-editor .schema-editor {\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  cursor: pointer; }\n  sd-content-schema-editor .schema-editor h4 {\n    padding: 5px; }\n  sd-content-schema-editor .schema-editor ul.pills-list {\n    padding-top: 10px; }\n    sd-content-schema-editor .schema-editor ul.pills-list .vocabulary-field-type {\n      font-weight: 300;\n      font-style: italic; }\n    sd-content-schema-editor .schema-editor ul.pills-list > li {\n      padding: 20px;\n      margin-bottom: 12px; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li .header {\n        margin-bottom: 10px; }\n        sd-content-schema-editor .schema-editor ul.pills-list > li .header button {\n          margin: -15px;\n          opacity: 0; }\n        sd-content-schema-editor .schema-editor ul.pills-list > li .header .title {\n          font-size: 16px;\n          font-weight: 500; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li fieldset {\n        padding-top: 10px; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li .dropdown--add-more > button {\n        opacity: .1;\n        z-index: 99;\n        transition: all 0.3s; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li .dropdown--add-more .dropdown__menu {\n        margin-top: 10px;\n        margin-left: -90px;\n        max-height: 253px;\n        overflow: auto;\n        z-index: 100; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li:hover .header button {\n        opacity: 1; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li:hover .dropdown--add-more > button {\n        opacity: 1; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li:first-of-type .dropdown--add-more__top {\n        top: -14px; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li:last-of-type .dropdown--add-more__bottom {\n        bottom: -14px; }\n      sd-content-schema-editor .schema-editor ul.pills-list > li.ui-sortable-helper .dropdown--add-more {\n        display: none; }\n    sd-content-schema-editor .schema-editor ul.pills-list .dropdown--add-more {\n      position: absolute;\n      margin-left: -14px;\n      left: 50%; }\n      sd-content-schema-editor .schema-editor ul.pills-list .dropdown--add-more__top {\n        top: -18px; }\n      sd-content-schema-editor .schema-editor ul.pills-list .dropdown--add-more__bottom {\n        bottom: -19px; }\n  sd-content-schema-editor .schema-editor .field {\n    margin-bottom: 15px; }\n    sd-content-schema-editor .schema-editor .field label {\n      min-width: 130px;\n      line-height: 23px; }\n    sd-content-schema-editor .schema-editor .field input, sd-content-schema-editor .schema-editor .field select, sd-content-schema-editor .schema-editor .field .input-medium {\n      width: 90px; }\n    sd-content-schema-editor .schema-editor .field .dropdown {\n      margin-top: 0; }\n    sd-content-schema-editor .schema-editor .field .sd-check__wrapper {\n      margin-left: 0; }\n      sd-content-schema-editor .schema-editor .field .sd-check__wrapper .sd-checkbox {\n        margin-top: 3px;\n        margin-left: 0; }\n    sd-content-schema-editor .schema-editor .field:last-of-type {\n      margin-bottom: 0; }\n", ""]);

// exports


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superdesk_ui_framework_1 = __webpack_require__(59);
var services_1 = __webpack_require__(1398);
var directive = __importStar(__webpack_require__(1400));
var ctrl = __importStar(__webpack_require__(1405));
var activity_1 = __webpack_require__(36);
var WidgetsConfig_1 = __webpack_require__(548);
var utils_1 = __webpack_require__(3);
var ContentProfileFields_1 = __importDefault(__webpack_require__(1407));
/**
 * @ngdoc module
 * @module superdesk.apps.content
 * @name superdesk.apps.content
 * @packageName superdesk.apps
 * @description Superdesk content.
 */
angular.module('superdesk.apps.workspace.content', [
    'superdesk.core.api',
    'superdesk.core.menu',
    'superdesk.apps.archive',
    'superdesk.apps.templates',
    'superdesk.apps.packaging',
])
    .service('content', services_1.ContentService)
    .directive('sdContentCreate', directive.ContentCreateDirective)
    .directive('sdContentSchemaEditor', directive.ContentProfileSchemaEditor)
    .directive('sdItemProfile', directive.ItemProfileDirective)
    .directive('sdSortContentProfiles', directive.SortContentProfiles)
    .component('sdWidgetsConfig', superdesk_ui_framework_1.reactToAngular1(WidgetsConfig_1.WidgetsConfig, ['initialWidgetsConfig', 'onUpdate']))
    .component('sdSchemaEditorFieldsDropdown', {
    template: __webpack_require__(1409),
    bindings: {
        bottom: '@',
        fields: '=',
        onSelect: '&',
    },
})
    .controller('ContentProfilesController', ctrl.ContentProfilesController)
    .controller('ContentProfileFields', ContentProfileFields_1.default)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/settings/content-profiles', {
            label: utils_1.gettext('Content Profiles'),
            controller: ctrl.ContentProfilesController,
            controllerAs: 'ctrl',
            templateUrl: 'scripts/apps/workspace/content/views/profile-settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            priority: 100,
            privileges: { content_type: 1 },
        });
    }])
    .run(['keyboardManager', function (keyboardManager) {
        keyboardManager.register('General', 'ctrl + m', utils_1.gettext('Create new item'));
    }]);


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentService_1 = __webpack_require__(1399);
exports.ContentService = ContentService_1.ContentService;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var constant = __importStar(__webpack_require__(244));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.content
 * @name content
 *
 * @requires api
 * @requires superdesk
 * @requires templates
 * @requires desks
 * @requires packages
 * @requires archiveService
 * @requires notify
 * @requires $filter
 * @requires $q
 * @requires $rootScope
 * @requires session
 * @requires deployConfig
 *
 * @description Content Service is responsible for creating packages or content items based
 * on templates or content types.
 * Also it is responsable for managing content types.
 */
ContentService.$inject = [
    'api',
    'superdesk',
    'templates',
    'desks',
    'packages',
    'archiveService',
    'notify',
    '$filter',
    '$q',
    '$rootScope',
    'session',
    'deployConfig',
];
function ContentService(api, superdesk, templates, desks, packages, archiveService, notify, $filter, $q, $rootScope, session, deployConfig) {
    var _this = this;
    var TEXT_TYPE = 'text';
    var self = this;
    function newItem(type) {
        return {
            type: type || TEXT_TYPE,
            version: 0,
        };
    }
    /**
     * Save data to content api
     *
     * @param {Object} data
     * @return {Promise}
     */
    function save(data) {
        return api.save('archive', data).catch(function (reason) {
            if (reason.status === 403) {
                if (lodash_1.get(reason, 'data.error.readonly')) {
                    notify.error(utils_1.gettext('You are not allowed to create article on readonly stage.'));
                }
                else {
                    notify.error(utils_1.gettext('You are not allowed to create an article there.'));
                }
            }
            return $q.reject(reason);
        });
    }
    /**
     * Create an item of given type
     *
     * @param {string} type
     * @return {Promise}
     */
    this.createItem = function (type) {
        var item = newItem(type);
        archiveService.addTaskToArticle(item);
        return save(item);
    };
    /**
     * Create a package containing given item
     *
     * @param {Object} item
     * @return {Promise}
     */
    this.createPackageItem = function (item) {
        var data = item ? { items: [item] } : {};
        return packages.createEmptyPackage(data);
    };
    /**
     * Create a package containing given item
     *
     * @param {Object} item
     * @return {Promise}
     */
    this.createPackageFromItems = function (item) {
        return packages.createPackageFromItems([item]);
    };
    /**
     * Create new item using given template
     *
     * @param {Object} template
     * @return {Promise}
     */
    this.createItemFromTemplate = function (template) {
        var item = newItem(template.data.type || null);
        angular.extend(item, templates.pickItemData(template.data || {}), { template: template._id });
        // set the dateline date to default utc date.
        if (item.dateline && item.dateline.located) {
            item.dateline = lodash_1.omit(item.dateline, 'text');
            item.dateline.date = $filter('formatDateTimeString')();
        }
        // set missing byline from user profile.
        if (!item.byline) {
            item.byline = session.identity.byline;
        }
        archiveService.addTaskToArticle(item);
        return save(item).then(function (_item) {
            templates.addRecentTemplate(desks.activeDeskId, template._id);
            return _item;
        });
    };
    /**
     * Create new item using given content type
     *
     * @param {Object} contentType
     * @return {Promise}
     */
    this.createItemFromContentType = function (contentType) {
        var item = {
            type: TEXT_TYPE,
            profile: contentType._id,
            version: 0,
        };
        archiveService.addTaskToArticle(item);
        return save(item);
    };
    /**
     * Creates a new content profile.
     *
     * @param {Object} data
     * @return {Promise}
     */
    this.createProfile = function (data) {
        return api.save('content_types', data);
    };
    /**
     * Creates a new content profile.
     *
     * @param {Object} item
     * @param {Object} updates
     * @return {Promise}
     */
    this.updateProfile = function (item, updates) {
        return api.update('content_types', item, updates);
    };
    /**
     * Creates a new content profile.
     *
     * @param {Object} item
     * @return {Promise}
     */
    this.removeProfile = function (item) {
        return api.remove(item, {}, 'content_types');
    };
    /**
     * Get content types from server
     *
     * @param {Boolean} includeDisabled
     * @return {Promise}
     */
    this.getTypes = function (includeDisabled) {
        // eslint-disable-next-line consistent-this
        var getTypesFnThis = this;
        var params = {};
        if (!includeDisabled) {
            params = { where: { enabled: true } };
        }
        // cache when fetching all types
        return api.getAll('content_types', params, !!includeDisabled).then(function (result) {
            getTypesFnThis.types = result.sort(function (a, b) { return b.priority - a.priority; });
            return getTypesFnThis.types;
        }, function (reason) {
            getTypesFnThis.types = [];
            return getTypesFnThis.types;
        });
    };
    /**
     * Get types lookup
     *
     * @return {Promise}
     */
    this.getTypesLookup = function () {
        return this.getTypes(true).then(function (profiles) {
            var lookup = {};
            profiles.forEach(function (profile) {
                lookup[profile._id] = profile;
            });
            return lookup;
        });
    };
    /**
     * Get content type by id
     *
     * @param {string} id
     * @return {Promise}
     */
    this.getType = function (id) {
        return getCustomFields()
            .then(function () { return api.find('content_types', id); });
    };
    /**
     * Get content type with metadata by id
     *
     * @param {string} id
     * @return {Promise}
     */
    this.getTypeMetadata = function (id) {
        return getCustomFields()
            .then(function () { return api.find('content_types', id, { edit: true }); });
    };
    /**
     * Get schema for given profile/content type
     *
     * @param {Object} profile
     * @param {String} contentType
     * @return {Object}
     */
    this.schema = function (profile, contentType) {
        var schema = lodash_1.get(profile, 'schema', lodash_1.get(deployConfig.getSync('schema'), contentType, constant.DEFAULT_SCHEMA));
        return angular.extend({}, schema);
    };
    /**
     * Get editor config for given profile/ content type
     *
     * @param {Object} profile
     * @param {String} contentType
     * @return {Object}
     */
    this.editor = function (profile, contentType) {
        var editor = lodash_1.get(profile, 'editor', lodash_1.get(deployConfig.getSync('editor'), contentType, constant.DEFAULT_EDITOR));
        return angular.extend({}, editor);
    };
    /**
     * Get custom fields enabled in given profile
     *
     * @param {Object} profile
     * @return {Array}
     */
    this.fields = function (contentType) {
        var editor = contentType.editor || {};
        return _this._fields.filter(function (field) { return !!editor[field._id]; });
    };
    /**
     * Get profiles selected for given desk
     *
     * @param {Object} desk
     * @param {string} profileId if profileId is set add such profile to the list
     * @return {Promise}
     */
    this.getDeskProfiles = function (desk, profileId) {
        return this.getTypes().then(function (profiles) { return !desk || lodash_1.isEmpty(desk.content_profiles) ?
            profiles :
            profiles.filter(function (profile) { return desk.content_profiles[profile._id] || profile._id === profileId; }); });
    };
    this.contentProfileSchema = angular.extend({}, constant.DEFAULT_SCHEMA, constant.EXTRA_SCHEMA_FIELDS);
    this.contentProfileEditor = angular.extend({}, constant.DEFAULT_EDITOR, constant.EXTRA_EDITOR_FIELDS);
    $rootScope.$on('vocabularies:updated', resetFields);
    /**
     * Fetch custom fields
     *
     * this is called before getting type info so it's ready for use
     */
    function getCustomFields() {
        if (self._fields) {
            return $q.when(self._fields);
        }
        if (!self._fieldsPromise) {
            self._fieldsPromise = api.getAll('vocabularies', {
                where: {
                    $or: [
                        { field_type: { $in: ['text', 'date', 'media', 'embed', 'urls'] } },
                        { service: { $exists: true } },
                    ],
                },
            })
                .then(function (response) {
                self._fields = response;
                self._fieldsPromise = null;
                return self._fields;
            });
        }
        return self._fieldsPromise;
    }
    this.getCustomFields = getCustomFields;
    this.fetchAssociations = function (item) {
        var associations = item.associations || {};
        var keys = Object.keys(associations);
        return Promise.all(keys.map(function (key) {
            // there is only _id, maybe _type for related items
            if (associations[key] && Object.keys(associations[key]).length <= 2) {
                return api.find('archive', associations[key]._id);
            }
            return Promise.resolve(associations[key]);
        })).then(function (values) { return lodash_1.zipObject(keys, values); });
    };
    /**
     * Reset custom fields info
     */
    function resetFields() {
        self._fields = null;
        self._fieldsPromise = null;
    }
}
exports.ContentService = ContentService;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentCreateDirective_1 = __webpack_require__(1401);
exports.ContentCreateDirective = ContentCreateDirective_1.ContentCreateDirective;
var ContentProfileSchemaEditor_1 = __webpack_require__(1402);
exports.ContentProfileSchemaEditor = ContentProfileSchemaEditor_1.ContentProfileSchemaEditor;
var ItemProfileDirective_1 = __webpack_require__(1403);
exports.ItemProfileDirective = ItemProfileDirective_1.ItemProfileDirective;
var SortContentProfiles_1 = __webpack_require__(1404);
exports.SortContentProfiles = SortContentProfiles_1.SortContentProfiles;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ContentCreateDirective.$inject = ['api', 'desks', 'templates', 'content', 'authoringWorkspace',
    'superdesk', 'keyboardManager', '$location'];
function ContentCreateDirective(api, desks, templates, content, authoringWorkspace, superdesk, keyboardManager, $location) {
    return {
        scope: true,
        templateUrl: 'scripts/apps/workspace/content/views/sd-content-create.html',
        link: function (scope) {
            /**
             * Start editing given item in sidebar editor
             *
             * @param {Object} item
             */
            function edit(item) {
                authoringWorkspace.edit(item);
            }
            function getRecentTemplates(deskId) {
                var NUM_ITEMS = 5;
                return templates.getRecentTemplates(desks.activeDeskId, NUM_ITEMS).then(function (result) {
                    scope.contentTemplates = result._items;
                });
            }
            /**
             * Create and start editing item of given type
             *
             * @param {string} type
             */
            scope.create = function (type) {
                content.createItem(type).then(edit);
            };
            /**
             * Create and start editing a package
             */
            scope.createPackage = function () {
                content.createPackageItem().then(edit);
            };
            /**
             * Do not allow packages to be created from personal workspace
            **/
            scope.canCreatePackage = function () {
                return $location.path() !== '/workspace/personal';
            };
            /**
             * Create and start editing an item based on given package
             *
             * @param {Object} template
             */
            scope.createFromTemplate = function (template) {
                content.createItemFromTemplate(template)
                    .then(edit)
                    .then(function () {
                    getRecentTemplates(desks.activeDeskId);
                });
            };
            /**
             * Start content upload modal
             */
            scope.openUpload = function openUpload() {
                superdesk.intent('upload', 'media', { deskSelectionAllowed: true });
            };
            scope.contentTemplates = null;
            desks.initialize().then(function () {
                scope.$watch(function () { return desks.active.desk; }, function (activeDeskId) {
                    getRecentTemplates(activeDeskId);
                    getDefaultTemplate();
                });
            });
            keyboardManager.bind('ctrl+m', function (e) {
                if (e) {
                    e.preventDefault();
                }
                scope.defaultTemplate ? scope.createFromTemplate(scope.defaultTemplate) : scope.create();
            });
            scope.$on('$destroy', function () {
                keyboardManager.unbind('ctrl+m');
            });
            function getDefaultTemplate() {
                var desk = desks.getCurrentDesk();
                scope.defaultTemplate = null;
                if (desk && desk.default_content_template) {
                    templates.find(desk.default_content_template).then(function (template) {
                        scope.defaultTemplate = template;
                    });
                }
            }
            /**
             * Create a new item using given type and start editing
             *
             * @param {Object} contentType
             */
            scope.createFromTemplate = function (template) {
                content.createItemFromTemplate(template).then(edit);
            };
        },
    };
}
exports.ContentCreateDirective = ContentCreateDirective;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(244);
var getLabelForFieldId_1 = __webpack_require__(62);
var FORMATTING_OPTIONS = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'justifyLeft',
    'justifyCenter',
    'justifyRight',
    'justifyFull',
    'outdent',
    'indent',
    'unordered list',
    'ordered list',
    'pre',
    'quote',
    'media',
    'link',
    'superscript',
    'subscript',
    'strikethrough',
    'underline',
    'italic',
    'bold',
    'table',
];
var FORMATTING_OPTIONS_EDITOR3 = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'ordered list',
    'unordered list',
    'quote',
    'media',
    'link',
    'embed',
    'underline',
    'italic',
    'bold',
    'table',
    'formatting marks',
    'remove format',
    'annotation',
    'comments',
    'suggestions',
    'pre',
    'superscript',
    'subscript',
    'strikethrough',
];
/**
 * @ngdoc directive
 * @module superdesk.apps.workspace
 * @name ContentProfileSchemaEditor
 *
 * @requires content
 *
 * @description Handles content profile schema editing
 */
ContentProfileSchemaEditor.$inject = ['vocabularies'];
function ContentProfileSchemaEditor(vocabularies) {
    return {
        restrict: 'E',
        templateUrl: 'scripts/apps/workspace/content/views/schema-editor.html',
        require: '^form',
        scope: {
            model: '=',
            fields: '=',
            available: '=',
            enabled: '=',
            onRemove: '&',
            onToggle: '&',
            onOrderUpdate: '&',
            onDrag: '&',
        },
        link: function (scope, elem, attr, form) {
            scope.formattingOptions = FORMATTING_OPTIONS;
            scope.formattingOptionsEditor3 = FORMATTING_OPTIONS_EDITOR3;
            scope.remove = function (key) {
                scope.onRemove({ key: key });
                scope.setDirty();
            };
            scope.toggle = function (schema, key, position) {
                scope.onToggle({ key: schema.key, dest: key, position: position });
                scope.setDirty();
            };
            scope.updateOrder = function (key) {
                scope.onOrderUpdate({ key: key });
                scope.setDirty();
            };
            scope.reorder = function (start, end, key) {
                scope.onDrag({ start: start, end: end, key: key });
                scope.setDirty();
            };
            scope.setDirty = function () {
                form.$setDirty();
            };
            /**
             * Test if given field should have format options config
             *
             * @param {string} field
             * @return {Boolean}
             */
            scope.hasFormatOptions = function (field) {
                return !!constants_1.HAS_FORMAT_OPTIONS[field] || hasCustomFieldFormatOptions(field);
            };
            /**
             * Test if given field should have format options config
             *
             * @param {string} field
             * @return {Boolean}
             */
            scope.hasImageSelected = function (field) { return scope.hasFormatOptions(field) &&
                lodash_1.includes(scope.model.editor[field].formatOptions, 'media'); };
            /**
             * Test if given field is custom field
             *
             * @param {string} field
             * @return {Boolean}
             */
            var hasCustomFieldFormatOptions = function (field) {
                return scope.fields[field] && scope.fields[field].field_type === 'text';
            };
            vocabularies.getVocabularies().then(function (vocabulariesCollection) {
                scope.label = function (id) { return getLabelForFieldId_1.getLabelForFieldId(id, vocabulariesCollection); };
            });
        },
    };
}
exports.ContentProfileSchemaEditor = ContentProfileSchemaEditor;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ItemProfileDirective.$inject = ['content'];
function ItemProfileDirective(content) {
    return {
        scope: { profileId: '=profile' },
        template: '{{ profile }}',
        link: function (scope) {
            content.getTypesLookup().then(function (lookup) {
                scope.profile = lookup[scope.profileId] ?
                    lookup[scope.profileId].label :
                    scope.profileId;
            });
        },
    };
}
exports.ItemProfileDirective = ItemProfileDirective;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
function SortContentProfiles() {
    return {
        link: function (scope, element) {
            var updated = false;
            element.sortable({
                items: '.schema-item:not(.schema-item__disabled)',
                cursor: 'move',
                containment: element,
                tolerance: 'pointer',
                placeholder: {
                    element: function (current) {
                        var height = current.height() - 20;
                        return $('<li class="placeholder" style="height:' + height + 'px"></li>')[0];
                    },
                    update: function () { },
                },
                start: function (event, ui) {
                    ui.item.data('start_index', ui.item
                        .parent()
                        .find('li.schema-item')
                        .index(ui.item));
                },
                stop: function (event, ui) {
                    if (updated) {
                        updated = false;
                        var start = ui.item.data('start_index'), end = ui.item.parent().find('li.schema-item')
                            .index(ui.item), key = ui.item.data('id');
                        scope.$applyAsync(function () {
                            scope.reorder(start, end, key);
                        });
                    }
                },
                update: function (event, ui) {
                    updated = true;
                },
            });
            scope.$on('$destroy', function () {
                element.sortable('destroy');
            });
        },
    };
}
exports.SortContentProfiles = SortContentProfiles;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentProfilesController_1 = __webpack_require__(1406);
exports.ContentProfilesController = ContentProfilesController_1.ContentProfilesController;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
ContentProfilesController.$inject = ['$scope', '$location', 'notify', 'content', 'modal', '$q', 'config'];
function ContentProfilesController($scope, $location, notify, content, modal, $q, config) {
    var self = this;
    // creating will be true while the modal for creating a new content
    // profile is visible.
    $scope.creating = false;
    // editing will hold data about the content profile being edited, as well
    // as the bind to the editing form. If no profile is being edited, it will
    // be null.
    $scope.editing = null;
    // if true, only active Content Profiles will be shown
    // can be changed with a button
    $scope.active_only = true;
    // required for being able to mark the form as dirty and enable the save button
    // after saving content profile widgets config
    $scope.setNgForm = function (ngForm) {
        $scope.ngForm = ngForm;
    };
    $scope.saveContentProfileWidgetsConfig = function (nextWidgetsConfig) {
        $scope.editing.form.widgets_config = nextWidgetsConfig;
        $scope.$applyAsync(function () {
            $scope.ngForm.$dirty = true;
        });
    };
    $scope.withEditor3 = config.features.editor3;
    /**
     * @description Refreshes the list of content profiles by fetching them.
     * @returns {Promise}
     * @private
     */
    function refreshList(callEditActive) {
        return content.getTypes(true).then(function (types) {
            self.items = types;
            if (callEditActive) {
                editActive();
            }
        });
    }
    /**
     * @description Start editing active profile
     * @private
     */
    function editActive() {
        $scope.editing = null;
        if ($location.search()._id) {
            var active_1 = self.items.find(function (p) { return p._id === $location.search()._id; });
            if (active_1) {
                content.getTypeMetadata(active_1._id).then(function (type) {
                    $scope.editing = {
                        form: lodash_1.cloneDeep(type),
                        original: lodash_1.cloneDeep(type),
                    };
                }, function () {
                    $scope.editing = {
                        form: lodash_1.cloneDeep(active_1),
                        original: active_1,
                    };
                });
            }
        }
    }
    /**
     * @description Reports that an error has occurred.
     * @private
     */
    function reportError(resp) {
        var message = lodash_1.get(resp, 'data._issues["validator exception"]') || '';
        notify.error("Operation failed " + message + " (check console for response).");
        console.error(resp);
        return $q.reject(resp);
    }
    /**
     * @description Middle-ware that checks an error response to verify whether
     * it is a duplication error.
     * @param {Function} next The function to be called when error is not a
     * duplication error.
     * @private
     */
    function uniqueError(next) {
        return function (resp) {
            if (angular.isObject(resp) &&
                angular.isObject(resp.data) &&
                angular.isObject(resp.data._issues) &&
                angular.isObject(resp.data._issues.label) &&
                resp.data._issues.label.unique) {
                notify.error(self.duplicateErrorTxt);
                return $q.reject(resp);
            }
            return next(resp);
        };
    }
    this.duplicateErrorTxt = utils_1.gettext('A content profile with this name already exists.');
    /**
     * @description Toggles the visibility of the creation modal.
     */
    this.toggleCreate = function () {
        $scope.new = {};
        $scope.creating = !$scope.creating;
    };
    /**
     * @description Toggles the visibility of the profile editing modal.
     * @param {Object} p the content profile being edited.
     */
    this.toggleEdit = function (p) {
        $location.search({ _id: p ? p._id : null });
        $scope.$applyAsync(editActive);
    };
    /**
     * @description Creates a new content profile.
     */
    this.save = function () {
        var onSuccess = function (resp) {
            refreshList(true);
            self.toggleCreate();
            return resp;
        };
        content.createProfile($scope.new)
            .then(onSuccess, uniqueError(reportError))
            .then(this.toggleEdit);
    };
    /**
     * @description Commits the changes made in the editing form for a profile
     * to the server.
     */
    this.update = function () {
        var e = $scope.editing;
        var diff = {};
        Object.keys(e.form).forEach(function (k) {
            if (!lodash_1.isEqual(e.form[k], e.original[k])) {
                diff[k] = e.form[k];
            }
        });
        content.updateProfile(e.original, diff)
            .then(refreshList.bind(this, false), reportError)
            .then(this.toggleEdit.bind(this, null));
    };
    /**
     * @description Queries the user for confirmation and deletes the content profile.
     */
    this.delete = function (item) {
        var _this = this;
        modal.confirm('Are you sure you want to delete this profile?').then(function () {
            content.removeProfile(item)
                .then(refreshList.bind(_this, false), reportError)
                .then(_this.toggleEdit.bind(_this, null));
        });
    };
    refreshList(true);
}
exports.ContentProfilesController = ContentProfilesController;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var getLabelForFieldId_1 = __webpack_require__(62);
var getTypeForFieldId_1 = __webpack_require__(1408);
var ARTICLE_HEADER_FIELDS = new Set([
    'keywords',
    'genre',
    'anpa_take_key',
    'place',
    'language',
    'priority',
    'urgency',
    'anpa_category',
    'subject',
    'company_codes',
    'ednote',
    'authors',
]);
var ARTICLE_COMMON_FIELDS = new Set([
    'slugline',
]);
ContentProfileFields.$inject = ['$scope', 'content', 'vocabularies', 'metadata'];
function ContentProfileFields($scope, content, vocabularies, metadata) {
    var _this = this;
    this.model = $scope.editing.form;
    this.fieldsById = {};
    this.fieldsBySection = {};
    var getOrder = function (field) { return lodash_1.get(_this.model.editor[field], 'order') || 99; };
    var isEnabled = function (field) { return lodash_1.get(_this.model.editor[field], 'enabled', false); };
    Promise.all([
        content.getCustomFields(),
        content.getTypeMetadata(this.model._id),
        vocabularies.getVocabularies(),
    ]).then(function (res) {
        var customFields = res[0], typeMetadata = res[1], vocabulariesCollection = res[2];
        var label = function (id) { return getLabelForFieldId_1.getLabelForFieldId(id, vocabulariesCollection); };
        var getArticleHeaderFields = function (customVocabulariesForArticleHeader) {
            var articleHeaderFields = new Set();
            ARTICLE_HEADER_FIELDS.forEach(function (id) {
                articleHeaderFields.add(id);
            });
            customVocabulariesForArticleHeader.forEach(function (filteredCustomField) {
                articleHeaderFields.add(filteredCustomField._id);
            });
            return articleHeaderFields;
        };
        var getArticleCommonFields = function (customTextAndDateVocabularies) {
            var articleCommonFields = new Set();
            ARTICLE_COMMON_FIELDS.forEach(function (id) {
                articleCommonFields.add(id);
            });
            customTextAndDateVocabularies.forEach(function (filteredCustomField) {
                articleCommonFields.add(filteredCustomField._id);
            });
            return articleCommonFields;
        };
        var initFields = function (customVocabulariesForArticleHeader, customTextAndDateVocabularies) {
            _this.articleHeaderFields = getArticleHeaderFields(customVocabulariesForArticleHeader);
            _this.articleCommonFields = getArticleCommonFields(customTextAndDateVocabularies);
            _this.enabled = Object.keys(_this.model.editor)
                .filter(isEnabled)
                .sort(function (a, b) { return getOrder(a) - getOrder(b); });
            updateSections();
        };
        _this.model.schema = angular.extend({}, content.contentProfileSchema);
        _this.model.editor = angular.extend({}, content.contentProfileEditor);
        _this.model.schema = angular.extend({}, typeMetadata.schema);
        _this.model.editor = angular.extend({}, typeMetadata.editor);
        _this.fieldsById = lodash_1.keyBy(customFields, '_id');
        metadata.getAllCustomVocabulariesForArticleHeader(_this.model.editor, _this.model.schema).then(function (_a) {
            var customVocabulariesForArticleHeader = _a.customVocabulariesForArticleHeader, customTextAndDateVocabularies = _a.customTextAndDateVocabularies;
            initFields(customVocabulariesForArticleHeader, customTextAndDateVocabularies);
        });
        var formatKey = function (key) { return ({
            key: key,
            name: _this.model.editor[key].field_name || label(key),
            type: getTypeForFieldId_1.getTypeForFieldId(key, vocabulariesCollection),
        }); };
        var updateSections = function () {
            _this.sections = {
                header: {
                    enabled: [],
                    available: [],
                },
                content: {
                    enabled: [],
                    available: [],
                },
            };
            _this.enabled.forEach(function (key, index) {
                var headerField = _this.articleHeaderFields.has(key) || _this.articleCommonFields.has(key);
                var section = _this.model.editor[key].section || (headerField ? 'header' : 'content');
                _this.sections[section].enabled.push(key);
                _this.model.editor[key].order = index + 1; // keep order in sync
            });
            Object.keys(_this.model.editor).filter(function (key) { return !isEnabled(key); }).forEach(function (key) {
                var headerField = _this.articleHeaderFields.has(key) || _this.articleCommonFields.has(key);
                var contentField = _this.articleCommonFields.has(key) || !headerField;
                if (headerField) {
                    _this.sections.header.available.push(formatKey(key));
                }
                if (contentField) {
                    _this.sections.content.available.push(formatKey(key));
                }
                _this.model.editor[key].order = null;
            });
        };
        var updateModel = function (key, editorUpdates, schemaUpdates) {
            var editor = __assign({}, _this.model.editor);
            var schema = __assign({}, _this.model.schema);
            editor[key] = Object.assign({}, editor[key], editorUpdates);
            schema[key] = Object.assign({}, schema[key], schemaUpdates);
            _this.model.editor = editor;
            _this.model.schema = schema;
        };
        /**
         * @description Disable field in content profile
         * @param {String} key the key of the field to toggle.
         */
        _this.remove = function (key) {
            updateModel(key, { enabled: false, section: null }, { enabled: false });
            _this.removeEnabled(key);
            updateSections();
        };
        _this.add = function (key, dest, position, section) {
            updateModel(key, { enabled: true, section: section }, { enabled: true });
            var destIndex = _this.enabled.indexOf(dest);
            if (position === 'after') {
                destIndex++;
            }
            _this.enabled.splice(destIndex, 0, key);
            updateSections();
        };
        _this.reorder = function (key) {
            _this.removeEnabled(key);
            _this.enabled.splice(_this.model.editor[key].order, 0, key);
            updateSections();
        };
        _this.drag = function (start, end, key) {
            var dest = _this.enabled.indexOf(key) + end - start;
            _this.removeEnabled(key);
            _this.enabled.splice(dest, 0, key);
            updateSections();
        };
        _this.removeEnabled = function (key) {
            _this.enabled = _this.enabled.filter(function (_key) { return _key !== key; });
        };
    });
}
exports.default = ContentProfileFields;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var TYPE_LABEL = {
    text: utils_1.gettext('text'),
    media: utils_1.gettext('related content'),
    date: utils_1.gettext('date'),
    embed: utils_1.gettext('embed'),
    related_content: utils_1.gettext('related content'),
};
exports.getLabelForType = function (fieldType) {
    if (TYPE_LABEL.hasOwnProperty(fieldType)) {
        return TYPE_LABEL[fieldType];
    }
    return utils_1.gettext('custom vocabulary');
};
exports.getTypeForFieldId = function (fieldId, vocabularies) {
    var vocabulary = vocabularies.find(function (obj) { return obj._id === fieldId; });
    if (vocabulary && vocabulary.field_type) {
        return exports.getLabelForType(vocabulary.field_type);
    }
    return '';
};


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown dropdown--add-more dropdown--add-more__{{ $ctrl.bottom === 'true' ? 'bottom' : 'top' }} dropdown-terms\" dropdown>\n    <button class=\"btn btn--primary btn--icon-only-circle\" sd-tooltip=\"{{ :: 'Add Field' | translate }}\" flow=\"right\" ng-click=\"search = ''\" dropdown__toggle>\n        <i class=\"icon-plus-large\"></i>\n    </button>\n    <ul class=\"dropdown__menu nested-menu\">\n        <li class=\"input-term\">\n            <input ng-model=\"search\" type=\"text\" ng-click=\"$event.stopPropagation()\">\n        </li>\n        <li class=\"main-list\">\n            <ul>\n                <li ng-repeat=\"schema in $ctrl.fields | orderBy: 'name' | filter: search track by schema.key\">\n                    <button ng-click=\"$ctrl.onSelect({field: schema})\">{{schema.name | translate}} <span class=\"vocabulary-field-type\" ng-if=\"schema.type\">({{ schema.type }})</span></button>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WorkspaceService_1 = __webpack_require__(1411);
exports.WorkspaceService = WorkspaceService_1.WorkspaceService;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
WorkspaceService.$inject = ['api', 'desks', 'session', 'preferencesService', '$q'];
function WorkspaceService(api, desks, session, preferences, $q) {
    this.active = null;
    this.save = save;
    this.delete = _delete;
    this.setActive = setActiveWorkspace;
    this.setActiveDesk = setActiveDesk;
    this.getActive = getActiveWorkspace;
    this.getActiveId = readActiveWorkspaceId;
    this.readActive = readActiveWorkspace;
    this.queryUserWorkspaces = queryUserWorkspaces;
    this.isCustom = isCustom;
    this.extraItems = [];
    this.registerExtraItem = registerExtraItem;
    var PREFERENCE_KEY = 'workspace:active', RESOURCE = 'workspaces', self = this;
    function registerExtraItem(item) {
        this.extraItems.push(item);
    }
    function save(workspace, diff) {
        if (diff) {
            return api.save(RESOURCE, workspace, diff).then(updateActive);
        }
        workspace.user = workspace.user || session.identity._id;
        return api.save(RESOURCE, workspace).then(updateActive);
    }
    function _delete(workspace) {
        return api.remove(workspace)
            .then(function () {
            if (!self.active || self.active._id !== workspace._id) {
                return $q.when();
            }
            return self.queryUserWorkspaces();
        })
            .then(function (items) {
            if (items && items.length) {
                self.setActive(items[0]);
            }
            else {
                self.setActive(null);
            }
            self.getActive();
        });
    }
    /**
     * Set active workspace for given desk
     *
     * @param {Object} desk
     * @return {Promise}
     */
    function setActiveDesk(desk) {
        var updates = {};
        updates[PREFERENCE_KEY] = { workspace: desk._id };
        preferences.update(updates, PREFERENCE_KEY);
        return getDeskWorkspace(desk._id).then(updateActive);
    }
    /**
     * Set active workspace
     *
     * @param {Object} workspace
     */
    function setActiveWorkspace(workspace) {
        updateActive(workspace);
        var updates = {};
        updates[PREFERENCE_KEY] = { workspace: workspace ? workspace._id : '' };
        preferences.update(updates, PREFERENCE_KEY);
    }
    /**
     * Set this.active to given workspace
     *
     * @param {Object} workspace
     * @return {object}
     */
    function updateActive(workspace) {
        self.active = workspace || null;
        return workspace;
    }
    /**
     * Returns true if the workspace is custom (not a desk).
     *
     * @return {bool}
     */
    function isCustom() {
        return angular.isDefined(self.workspaceType) && self.workspaceType === 'workspace';
    }
    /**
     * Get active workspace id
     *
     * @return {Promise}
     */
    function getActiveWorkspaceId() {
        return preferences.get(PREFERENCE_KEY).then(function (prefs) { return prefs && prefs.workspace ? prefs.workspace : null; });
    }
    /**
     * Get active workspace
     *
     * First it reads preferences to get last workspace id,
     * in case it's not set it opens workspace for active desk.
     *
     * @return {Promise}
     */
    function readActiveWorkspaceId() {
        return desks.initialize()
            .then(getActiveWorkspaceId)
            .then(function (activeId) {
            var type = null;
            var id = null;
            if (desks.activeDeskId && desks.deskLookup[desks.activeDeskId]) {
                type = 'desk';
                id = desks.activeDeskId;
            }
            else if (activeId && desks.deskLookup[activeId]) {
                type = 'desk';
                id = activeId;
                desks.setCurrentDeskId(activeId);
            }
            else if (activeId) {
                type = 'workspace';
                id = activeId;
            }
            else if (desks.getCurrentDeskId()) {
                type = 'desk';
                id = desks.getCurrentDeskId();
            }
            self.workspaceType = type;
            return { id: id, type: type };
        });
    }
    /**
     * Read active workspace
     *
     * First it reads preferences to get last workspace id,
     * in case it's not set it opens workspace for active desk.
     *
     * @return {Promise}
     */
    function readActiveWorkspace() {
        return readActiveWorkspaceId()
            .then(function (activeWorkspace) {
            if (activeWorkspace.type === 'desk') {
                return getDeskWorkspace(activeWorkspace.id);
            }
            else if (activeWorkspace.type === 'workspace') {
                return findWorkspace(activeWorkspace.id);
            }
        });
    }
    /**
     * Get active workspace
     *
     * First it reads preferences to get last workspace id,
     * in case it's not set it opens workspace for active desk.
     *
     * @return {Promise}
     */
    function getActiveWorkspace() {
        return readActiveWorkspaceId()
            .then(function (activeWorkspace) {
            if (activeWorkspace.type === 'desk') {
                return getDeskWorkspace(activeWorkspace.id);
            }
            else if (activeWorkspace.type === 'workspace') {
                return findWorkspace(activeWorkspace.id);
            }
            return createUserWorkspace();
        })
            .then(updateActive);
    }
    /**
     * Find workspace by given id
     *
     * @param {string} workspaceId
     * @return {Promise}
     */
    function findWorkspace(workspaceId) {
        return api.find(RESOURCE, workspaceId);
    }
    /**
     * Get workspace for given desk
     *
     * @param {string} deskId
     * @return {Promise}
     */
    function getDeskWorkspace(deskId) {
        return api.query('workspaces', { where: { desk: deskId } }).then(function (result) {
            if (result._items.length === 1) {
                return result._items[0];
            }
            return { desk: deskId, widgets: [] };
        });
    }
    /**
     * Create custom workspace for given user using old config
     *
     * @return {object}
     */
    function createUserWorkspace() {
        return {
            user: session.identity._id,
            // [BC] use old user workspace
            widgets: session.identity.workspace ? session.identity.workspace.widgets : [],
        };
    }
    /**
     * Get list of user workspaces
     *
     * @return {Promise}
     */
    function queryUserWorkspaces() {
        return session.getIdentity().then(function (identity) { return api.query(RESOURCE, { where: { user: identity._id } }); })
            .then(function (response) { return response._items; });
    }
}
exports.WorkspaceService = WorkspaceService;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
function WorkspaceMenuProvider() {
    var _this = this;
    var items = [];
    /**
     * Register workspace menu item
     *
     * @param {Object} config
     * @return {Object} WorkspaceMenuProvider
     */
    this.item = function (config) {
        items.push(Object.assign({ order: 1000 }, config));
        return _this; // allow chaining
    };
    /**
     * Get registered items
     */
    this.$get = function () { return lodash_1.sortBy(items, 'order'); };
}
exports.default = WorkspaceMenuProvider;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WorkspaceDropdownDirective_1 = __webpack_require__(1414);
exports.WorkspaceDropdownDirective = WorkspaceDropdownDirective_1.WorkspaceDropdownDirective;
var WorkspaceSidenavDirective_1 = __webpack_require__(1415);
exports.WorkspaceSidenavDirective = WorkspaceSidenavDirective_1.WorkspaceSidenavDirective;
var EditWorkspaceDirective_1 = __webpack_require__(1417);
exports.EditWorkspaceDirective = EditWorkspaceDirective_1.EditWorkspaceDirective;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
WorkspaceDropdownDirective.$inject = ['desks', 'workspaces', '$route', 'preferencesService', '$location',
    'reloadService', 'notifyConnectionService', 'deskNotifications', 'pageTitle'];
function WorkspaceDropdownDirective(desks, workspaces, $route, preferencesService, $location, reloadService, notifyConnectionService, deskNotifications, pageTitle) {
    return {
        templateUrl: 'scripts/apps/workspace/views/workspace-dropdown.html',
        link: function (scope) {
            scope.workspaces = workspaces;
            scope.wsList = null;
            scope.edited = null;
            scope.$watch('selected', function () {
                pageTitle.setWorkspace(scope.selected ? scope.selected.name || '' : '');
            });
            scope.$on('$destroy', function () {
                pageTitle.setWorkspace('');
            });
            scope.afterSave = function (workspace) {
                desks.setCurrentDeskId(null);
                workspaces.setActive(workspace);
                scope.selected = workspace;
            };
            scope.selectDesk = function (desk) {
                reset();
                scope.selected = desk;
                scope.workspaceType = 'desk';
                desks.setCurrentDeskId(desk._id);
                workspaces.setActiveDesk(desk);
                reloadService.activeDesk = desks.active.desk;
            };
            scope.selectWorkspace = function (workspace) {
                reset();
                scope.selected = workspace;
                scope.workspaceType = 'workspace';
                desks.setCurrentDeskId(null);
                workspaces.setActive(workspace);
            };
            scope.createWorkspace = function () {
                scope.edited = {};
            };
            function reset() {
                desks.changeDesk = true;
                $location.search('_id', null);
            }
            /**
             * Restore the last desk/current workspace selection
             */
            function initialize() {
                var activeWorkspace = null;
                workspaces.getActiveId()
                    .then(function (workspace) {
                    activeWorkspace = workspace;
                })
                    .then(angular.bind(desks, desks.fetchCurrentUserDesks))
                    .then(function (userDesks) {
                    scope.desks = userDesks;
                })
                    .then(workspaces.queryUserWorkspaces)
                    .then(function (_workspaces) {
                    scope.wsList = _workspaces;
                    scope.workspaceType = activeWorkspace.type;
                    if (activeWorkspace.type === 'desk') {
                        scope.selected = lodash_1.default.find(scope.desks, { _id: activeWorkspace.id }) || desks.getCurrentDesk();
                    }
                    else if (activeWorkspace.type === 'workspace') {
                        scope.selected = lodash_1.default.find(scope.wsList, { _id: activeWorkspace.id });
                    }
                    else {
                        scope.selected = null;
                    }
                })
                    .then(function () {
                    deskNotifications.reload();
                });
            }
            scope.$watch(function () { return workspaces.active; }, initialize, true);
        },
    };
}
exports.WorkspaceDropdownDirective = WorkspaceDropdownDirective;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HR_TEMPLATE = 'scripts/apps/workspace/views/workspace-sidenav-items-hr.html';
var DEFAULT_TEMPLATE = 'scripts/apps/workspace/views/workspace-sidenav-items-default.html';
WorkspaceSidenavDirective.$inject = ['superdeskFlags', 'workspaceMenu', 'Keys', 'config',
    '$rootScope', 'workspaces', 'privileges'];
function WorkspaceSidenavDirective(superdeskFlags, workspaceMenu, Keys, config, $rootScope, workspaces, privileges) {
    return {
        template: __webpack_require__(1416),
        link: function (scope, elem) {
            var group = null;
            scope.workspaceConfig = config.workspace || {}; // it's used in workspaceMenu.filter
            scope.items = [];
            workspaceMenu
                .filter(function (item) { return !item.if || scope.$eval(item.if); })
                .forEach(function (item) {
                var itemGroup = item.group || group;
                if (itemGroup !== group) {
                    scope.items.push({ hr: 1 });
                    group = itemGroup;
                }
                scope.items.push(item);
            });
            scope.getTemplateUrl = function (item) { return item.hr ? HR_TEMPLATE : (item.templateUrl || DEFAULT_TEMPLATE); };
            // Filter extraItems based on privileges
            if (workspaces.extraItems) {
                scope.extraItems = workspaces.extraItems.filter(function (item) { return privileges.userHasPrivileges(item.privilege); });
            }
            else {
                scope.extraItems = [];
            }
            /*
             * Function for showing and hiding monitoring list
             * while authoring view is opened.
             *
             * @param {boolean} state Gets the state of button
             * @param {object} e Gets $event from the element
             */
            scope.hideMonitoring = function (state, e) {
                if (superdeskFlags.flags.authoring && state) {
                    e.preventDefault();
                    superdeskFlags.flags.hideMonitoring = !superdeskFlags.flags.hideMonitoring;
                }
                else {
                    superdeskFlags.flags.hideMonitoring = false;
                }
            };
            /*
             * By using keyboard shortcuts, change the current showed view
             *
             */
            scope.highlightsHotkey = function () {
                var ddlhighlights = elem.find('.highlights-dropdown .dropdown__toggle');
                if (ddlhighlights.length > 0) {
                    ddlhighlights.first().click();
                    elem.find('.dropdown__menu button')[0].focus();
                }
            };
            elem.on('keydown', function WorkspaceKeyboard(event) {
                if (event.which === Keys.up) {
                    elem.find('.dropdown__menu button:focus')
                        .parent('li')
                        .prev()
                        .children('button')
                        .focus();
                    return false;
                }
                if (event.which === Keys.down) {
                    elem.find('.dropdown__menu button:focus')
                        .parent('li')
                        .next()
                        .children('button')
                        .focus();
                    return false;
                }
            });
            if ($rootScope.popup) {
                superdeskFlags.flags.hideMonitoring = true;
            }
        },
    };
}
exports.WorkspaceSidenavDirective = WorkspaceSidenavDirective;


/***/ }),
/* 1416 */
/***/ (function(module, exports) {

module.exports = "<li ng-repeat=\"item in items track by $index\"\n    ng-class=\"{active: currentRoute.href === item.href}\"\n    ng-include=\"getTemplateUrl(item)\">\n</li>\n\n<!-- this should be avoided, not sure where it's used -->\n<li ng-if=\"extraItems.length > 0\"><hr></li>\n<li ng-repeat=\"item in extraItems\" ng-class=\"{active: currentRoute.href === '/' + item.route}\">\n    <a href=\"#/{{ item.route }}\" title=\"{{ item.title }}\" ng-click=\"item.onClick && item.onClick($event)\" class=\"sd-sidebar-menu__btn\">\n      <i class=\"sd-sidebar-menu__main-icon {{ item.iconClass }}\"></i>\n      <i class=\"sd-sidebar-menu__helper-icon big-icon--chevron-left\"></i>\n    </a>\n</li>\n";

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
EditWorkspaceDirective.$inject = ['workspaces'];
function EditWorkspaceDirective(workspaces) {
    return {
        templateUrl: 'scripts/apps/workspace/views/edit-workspace-modal.html',
        scope: {
            workspace: '=',
            done: '=',
        },
        link: function (scope) {
            scope.workspaces = workspaces;
            /**
             * Trigger workspace.save and in case there is an error returned assign it to scope.
             */
            scope.save = function () {
                workspaces.save(scope.workspace)
                    .then(function () {
                    scope.errors = null;
                    var workspace = scope.workspace;
                    scope.workspace = null;
                    if (scope.done) {
                        return scope.done(workspace);
                    }
                }, function (response) {
                    scope.errors = response.data._issues;
                });
            };
            scope.cancel = function () {
                scope.workspace = null;
            };
        },
    };
}
exports.EditWorkspaceDirective = EditWorkspaceDirective;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
// styles
__webpack_require__(1419);
__webpack_require__(1423);
// scripts
__webpack_require__(1425);
__webpack_require__(1428);
__webpack_require__(1431);
__webpack_require__(1432);
var controllers_1 = __webpack_require__(551);
var directive = __importStar(__webpack_require__(1439));
var svc = __importStar(__webpack_require__(1441));
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.dashboard.widgets', [])
    .provider('dashboardWidgets', svc.DashboardWidgets);
angular.module('superdesk.apps.dashboard.widgets.base', ['superdesk.core.itemList'])
    .factory('BaseWidgetController', svc.BaseWidgetFactory);
/**
 * @ngdoc module
 * @module superdesk.apps.dashboard
 * @name superdesk.apps.dashboard
 * @packageName superdesk.apps
 * @description A module that includes the dashboard component.
 */
angular.module('superdesk.apps.dashboard', [
    'superdesk.core.activity',
    'superdesk.apps.dashboard.widgets',
    'superdesk.apps.dashboard.grid',
    'superdesk.apps.dashboard.world-clock',
    'superdesk.apps.workspace.tasks',
    'superdesk.core.itemList',
    'superdesk.apps.legal_archive',
    'superdesk.apps.workspace',
    'superdesk.apps.dashboard.closed-desk',
])
    .controller('DashboardController', controllers_1.DashboardController)
    .filter('wcodeFilter', function () { return function (input, values) { return lodash_1.default.pick(input, lodash_1.default.difference(lodash_1.default.keys(input), lodash_1.default.keys(values))); }; })
    .config(['superdeskProvider', 'workspaceMenuProvider', function (superdesk, workspaceMenuProvider) {
        superdesk.activity('/workspace', {
            label: utils_1.gettext('Workspace'),
            description: utils_1.gettext('Customize your widgets and views'),
            controller: 'DashboardController',
            controllerAs: 'dashboard',
            templateUrl: 'scripts/apps/dashboard/views/workspace.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            priority: -1000,
            adminTools: false,
            category: superdesk.MENU_MAIN,
        });
        workspaceMenuProvider.item({
            icon: 'dashboard',
            href: '/workspace',
            label: utils_1.gettext('Dashboard'),
            shortcut: 'ctrl+alt+b',
            order: 100,
        });
    }]);
angular.module('superdesk.apps.dashboard').directive('sdWidget', directive.Widget);


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1420);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dashboard.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dashboard.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.dashboard-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 96px;\n  overflow-y: auto; }\n  .dashboard-container > .content {\n    padding: 0 20px 70px 0; }\n  .dashboard-container .empty-dashboard {\n    position: absolute;\n    left: 50%;\n    top: 40%;\n    font-size: 22px;\n    font-weight: bold;\n    color: #aaa;\n    width: 300px;\n    margin-left: -150px; }\n\n.sd-widget {\n  background: #fff;\n  border-top: 0;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  width: 100%;\n  height: 100%; }\n  .sd-widget .widget-line {\n    border-radius: 1px 1px 0 0;\n    height: 3px;\n    background: #444; }\n  .sd-widget .widget-header {\n    display: flex;\n    align-items: center;\n    height: 34px;\n    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.12);\n    position: relative;\n    z-index: 2; }\n    .sd-widget .widget-header .widget-title {\n      color: #333;\n      padding-left: 8px; }\n  .sd-widget .widget-header__search-button {\n    display: flex;\n    align-items: center;\n    width: 36px;\n    justify-content: center;\n    height: 100%;\n    border-right: 1px solid rgba(123, 123, 123, 0.2);\n    transition: all ease-in-out 0.1s; }\n    .sd-widget .widget-header__search-button i {\n      opacity: 0.5;\n      transition: all ease-in-out 0.1s; }\n    .sd-widget .widget-header__search-button:hover i {\n      opacity: 1; }\n    .sd-widget .widget-header__search-button:active i {\n      opacity: 1;\n      color: #5ea9c8; }\n    .sd-widget .widget-header__search-button--active {\n      background-color: #5ea9c8; }\n      .sd-widget .widget-header__search-button--active i {\n        opacity: 0.5;\n        color: #fff; }\n  .sd-widget .widget-content {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 38px;\n    overflow-y: hidden; }\n    .sd-widget .widget-content .activity-list.card-list > li {\n      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.2);\n      border-radius: 2px; }\n      .sd-widget .widget-content .activity-list.card-list > li:hover {\n        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12), 0 0 1px 0 rgba(0, 0, 0, 0.2); }\n  .sd-widget .widget-footer {\n    border-top: 1px solid #e7e7e7;\n    height: 31px; }\n  .sd-widget .widget-settings {\n    position: absolute;\n    top: 6px;\n    right: 4px;\n    line-height: 14px;\n    width: 28px;\n    height: 28px;\n    text-align: center;\n    z-index: 3; }\n    .sd-widget .widget-settings .dropdown__toggle {\n      margin-top: 4px; }\n      .sd-widget .widget-settings .dropdown__toggle i {\n        opacity: 0.7;\n        filter: \"alpha(opacity=70)\"; }\n    .sd-widget .widget-settings .dropdown__menu {\n      margin-top: -7px;\n      margin-right: 4px; }\n  .sd-widget .slider .arrow {\n    width: 8px;\n    height: 12px;\n    background: url(" + escape(__webpack_require__(1421)) + ") no-repeat 0 0;\n    margin-top: 9px;\n    opacity: 0.85;\n    filter: \"alpha(opacity=85)\"; }\n    .sd-widget .slider .arrow.left {\n      float: left;\n      margin-left: 9px; }\n    .sd-widget .slider .arrow.right {\n      background-position: -10px 0px;\n      margin-right: 9px;\n      float: right; }\n    .sd-widget .slider .arrow:hover {\n      cursor: pointer;\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n    .sd-widget .slider .arrow.disable {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n  .sd-widget ::-webkit-scrollbar {\n    border-left: 4px solid #f8f8f8 !important;\n    border-right: 1px solid #f8f8f8 !important;\n    width: 8px !important;\n    background: #f8f8f8 !important; }\n  .sd-widget ::-webkit-scrollbar-track {\n    background: #f8f8f8 !important;\n    border-left: 3px solid #f8f8f8 !important; }\n    .sd-widget ::-webkit-scrollbar-track:hover {\n      background: rgba(0, 0, 0, 0.05) !important; }\n  .sd-widget ::-webkit-scrollbar-thumb {\n    border-left: 3px solid #f8f8f8 !important; }\n\n/*\n---------------------------------------------\nWidgets styles\n---------------------------------------------\n*/\n.d-widget.default .widget-content {\n  padding: 20px; }\n\n.sd-widget.ingest-stats .widget-content {\n  padding: 10px;\n  overflow: hidden; }\n\n.statistics .stats-container {\n  float: left; }\n  .statistics .stats-container.size1 {\n    width: 372px; }\n  .statistics .stats-container.size2 {\n    width: 744px; }\n\n.statistics .stats-block {\n  float: left;\n  border: 1px solid #ccc;\n  margin-right: 30px;\n  margin-bottom: 30px;\n  border-radius: 3px; }\n  .statistics .stats-block .title {\n    text-align: center;\n    margin-bottom: 5px;\n    margin-top: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #f0f0f0;\n    font-size: 18px;\n    color: #666;\n    letter-spacing: 1px; }\n  .statistics .stats-block .block {\n    padding: 10px; }\n  .statistics .stats-block.theme-dark {\n    background: #212121;\n    border-color: #000; }\n    .statistics .stats-block.theme-dark .title {\n      color: #a8a8a8;\n      border-color: #313131; }\n\n/*\n---------------------------------------------\nSTREAM PAGE\n---------------------------------------------\n*/\n.workspace-stream {\n  padding: 40px 35px 50px !important;\n  overflow: auto;\n  bottom: auto; }\n  .workspace-stream .activity-container {\n    width: 500px; }\n\n/*\n=============================================\nGridster library\n=============================================\n*/\n.gridster {\n  position: relative; }\n\n.gridster > * {\n  margin: 0 auto;\n  -webkit-transition: height .4s;\n  -moz-transition: height .4s;\n  -o-transition: height .4s;\n  -ms-transition: height .4s;\n  transition: height .4s; }\n\n.gridster .gs_w {\n  z-index: 2;\n  position: absolute; }\n\n.ready .gs_w:not(.preview-holder) {\n  -webkit-transition: opacity .3s, left .3s, top .3s;\n  -moz-transition: opacity .3s, left .3s, top .3s;\n  -o-transition: opacity .3s, left .3s, top .3s;\n  transition: opacity .3s, left .3s, top .3s; }\n\n.ready .gs_w:not(.preview-holder) {\n  -webkit-transition: opacity .3s, left .3s, top .3s, width .3s, height .3s;\n  -moz-transition: opacity .3s, left .3s, top .3s, width .3s, height .3s;\n  -o-transition: opacity .3s, left .3s, top .3s, width .3s, height .3s;\n  transition: opacity .3s, left .3s, top .3s, width .3s, height .3s; }\n\n.gridster .preview-holder {\n  z-index: 1;\n  position: absolute;\n  background-color: #f0f0f0;\n  border: 1px dashed #c8c8c8;\n  border-radius: 3px; }\n\n.gridster .player-revert {\n  z-index: 10 !important;\n  -webkit-transition: left .3s, top .3s !important;\n  -moz-transition: left .3s, top .3s !important;\n  -o-transition: left .3s, top .3s !important;\n  transition: left .3s, top .3s !important; }\n\n.gridster .dragging {\n  z-index: 10 !important;\n  transition: all 0s !important;\n  opacity: 0.8;\n  filter: \"alpha(opacity=80)\";\n  cursor: move; }\n\n.gridster .dash-grid {\n  list-style-type: none;\n  width: 100% !important; }\n  .gridster .dash-grid li .widget-close {\n    position: absolute;\n    width: 30px;\n    height: 30px;\n    background: url(" + escape(__webpack_require__(1422)) + ") no-repeat 0 0;\n    z-index: 100;\n    right: -15px;\n    top: -15px;\n    cursor: pointer; }\n  .gridster .dash-grid li .widget-resize-width, .gridster .dash-grid li .widget-resize-height {\n    cursor: pointer;\n    position: absolute; }\n  .gridster .dash-grid li .widget-resize-width {\n    width: 47px;\n    height: 43px;\n    z-index: 100;\n    right: -25px;\n    top: 50%;\n    margin-top: -22px; }\n    .gridster .dash-grid li .widget-resize-width .resize-left, .gridster .dash-grid li .widget-resize-width .resize-right {\n      width: 23px;\n      height: 43px;\n      float: left;\n      opacity: 0;\n      filter: \"alpha(opacity=0)\";\n      transition: all 0.3s linear;\n      background: url(" + escape(__webpack_require__(549)) + ") no-repeat 0 0; }\n    .gridster .dash-grid li .widget-resize-width .resize-right {\n      background-position: -23px 0;\n      float: right; }\n  .gridster .dash-grid li .widget-resize-height {\n    width: 43px;\n    height: 47px;\n    z-index: 100;\n    left: 50%;\n    bottom: -24px;\n    margin-left: -22px; }\n    .gridster .dash-grid li .widget-resize-height .resize-up, .gridster .dash-grid li .widget-resize-height .resize-down {\n      width: 43px;\n      height: 23px;\n      background: url(" + escape(__webpack_require__(549)) + ") no-repeat -47px 0;\n      opacity: 0;\n      filter: \"alpha(opacity=0)\";\n      transition: all 0.3s linear; }\n    .gridster .dash-grid li .widget-resize-height .resize-down {\n      background-position: -47px -23px;\n      margin-top: 1px; }\n\n.gridster.editmode .dash-grid li:hover .resize-left, .gridster.editmode .dash-grid li:hover .resize-right, .gridster.editmode .dash-grid li:hover .resize-up, .gridster.editmode .dash-grid li:hover .resize-down {\n  opacity: 0.5;\n  filter: \"alpha(opacity=50)\";\n  transition: all 0.3s linear; }\n  .gridster.editmode .dash-grid li:hover .resize-left:hover, .gridster.editmode .dash-grid li:hover .resize-right:hover, .gridster.editmode .dash-grid li:hover .resize-up:hover, .gridster.editmode .dash-grid li:hover .resize-down:hover {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\";\n    transition: all 0.3s linear; }\n\n.gridster.editmode .dash-grid li.dragging .widget-resize-width, .gridster.editmode .dash-grid li.dragging .widget-resize-height {\n  opacity: 0.3;\n  filter: \"alpha(opacity=30)\"; }\n\n.gridster.editmode .d-widget {\n  border-color: #999;\n  box-shadow: 0 0 4px 1px #b8b8b8;\n  transition: all 0.3s linear; }\n\n/*\n=============================================\nAdd new widget modal\n=============================================\n*/\n.widget-select .modal-screen {\n  top: 48px;\n  bottom: auto; }\n\n.widget-select .modal-body {\n  height: 500px;\n  max-height: 500px;\n  background-color: #f8f8f8; }\n  .widget-select .modal-body .nav-tabs {\n    line-height: 48px;\n    padding-left: 20px; }\n    .widget-select .modal-body .nav-tabs label {\n      display: inline-block;\n      color: #989898; }\n\n.widget-select .modal-footer {\n  min-height: 60px; }\n  .widget-select .modal-footer .center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center; }\n  .widget-select .modal-footer .btn-done {\n    float: right;\n    margin-top: -28px; }\n  .widget-select .modal-footer .btn-next i {\n    margin-left: 8px;\n    width: 8px; }\n\n.widget-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0px;\n  display: flex;\n  flex-flow: row wrap; }\n  .widget-list li {\n    width: calc(33% - 40px);\n    margin: 20px;\n    padding: 0;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n    box-sizing: border-box;\n    background-color: white;\n    position: relative; }\n    .widget-list li .thumbnail {\n      border-radius: 2px 2px 0 0;\n      position: relative;\n      padding-top: 6px;\n      min-height: 177px;\n      background-color: #dadada; }\n      .widget-list li .thumbnail::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 8px;\n        background-color: rgba(0, 0, 0, 0.2);\n        border-radius: 2px 2px 0 0; }\n      .widget-list li .thumbnail img {\n        max-width: 100%; }\n    .widget-list li .title {\n      text-align: center;\n      font-size: 12px;\n      font-weight: 500;\n      text-transform: uppercase;\n      letter-spacing: 1px;\n      color: #333;\n      padding: 8px 0; }\n    .widget-list li:hover {\n      cursor: pointer;\n      box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.5); }\n    .widget-list li.widget.world-clock .thumbnail {\n      background-color: #03a9f4; }\n    .widget-list li.widget.ingest-stats .thumbnail {\n      background-color: #00bcd4; }\n    .widget-list li.widget.aggregate .thumbnail {\n      background-color: #8bc34a; }\n    .widget-list li.widget.archive .thumbnail {\n      background-color: #3f51b5; }\n    .widget-list li.widget.ingest .thumbnail {\n      background-color: #673ab7; }\n    .widget-list li.widget.activity .thumbnail {\n      background-color: #009688; }\n    .widget-list li.widget.routing .thumbnail {\n      background-color: #e55028; }\n    .widget-list li.widget.analytics .thumbnail {\n      background-color: #d62776; }\n    .widget-list li.widget.stages-auto-publish .thumbnail {\n      background-color: #AE44BE; }\n    .widget-list li.widget.selected {\n      cursor: default;\n      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06); }\n      .widget-list li.widget.selected .thumbnail, .widget-list li.widget.selected .title {\n        opacity: 0.3;\n        filter: \"alpha(opacity=30)\"; }\n      .widget-list li.widget.selected::before {\n        content: \"\";\n        position: absolute;\n        width: 32px;\n        height: 32px;\n        background-color: #49b04b;\n        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNiAyMiIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjYgMjIiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Im0yNS4zMSAyLjU1NWMtLjgtLjgtMi4yLS42LTMgLjJsLTEyLjQgMTIuNC02LjI4OC02LjI4OWMtMS0xLTIuNC0xLTMtLjItLjguOC0uNiAyLjIuMiAzLjJsNy40ODkgNy40ODljMCAwIC44MDcuNiAxLjYuNnMxLjUwOS0uNTgxIDEuNTA5LS41ODFsMTMuNjktMTMuODE5YzEtLjggMS0yLjIuMi0zIi8+PC9zdmc+);\n        background-repeat: no-repeat;\n        background-size: 20px;\n        background-position: center center;\n        border-radius: 50%;\n        top: -16px;\n        right: -16px;\n        z-index: 1;\n        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.55); }\n\n.widget-detail {\n  padding: 40px !important;\n  display: flex; }\n  .widget-detail .thumbnail-box {\n    position: relative;\n    width: calc(60% - 30px);\n    margin-right: 30px;\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n    border-radius: 2px;\n    box-sizing: border-box; }\n    .widget-detail .thumbnail-box::before {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      height: 8px;\n      background-color: rgba(0, 0, 0, 0.2);\n      border-radius: 2px 2px 0 0; }\n    .widget-detail .thumbnail-box.world-clock {\n      background-color: #03a9f4; }\n    .widget-detail .thumbnail-box.ingest-stats {\n      background-color: #00bcd4; }\n    .widget-detail .thumbnail-box.aggregate {\n      background-color: #8bc34a; }\n    .widget-detail .thumbnail-box.archive {\n      background-color: #3f51b5; }\n    .widget-detail .thumbnail-box.ingest {\n      background-color: #673ab7; }\n    .widget-detail .thumbnail-box.activity {\n      background-color: #009688; }\n    .widget-detail .thumbnail-box.routing {\n      background-color: #e55028; }\n    .widget-detail .thumbnail-box.analytics {\n      background-color: #d62776; }\n  .widget-detail .content-box {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: calc(40%); }\n    .widget-detail .content-box .title {\n      font-size: 30px;\n      line-height: 110%;\n      font-weight: 700;\n      padding: 0 0 20px;\n      width: 100%; }\n    .widget-detail .content-box .description {\n      font-size: 14px;\n      width: 100%;\n      margin-bottom: 20px;\n      flex-grow: 1; }\n", ""]);

// exports


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cf5c71eac6ee6443c36859fd33e09492.png";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "900502ce15042f6509f53d837fca5888.png";

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1424);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widgets.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widgets.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.ingest .widget-header, .sd-widget.archive .widget-header, .sd-widget.related-item .widget-header, .sd-widget.aggregate .widget-header, .sd-widget.package-manager .widget-header, .sd-widget.packages .widget-header {\n  z-index: 2;\n  background: #fff;\n  box-sizing: border-box; }\n\n.sd-widget.ingest .widget-content, .sd-widget.archive .widget-content, .sd-widget.related-item .widget-content, .sd-widget.aggregate .widget-content, .sd-widget.package-manager .widget-content, .sd-widget.packages .widget-content {\n  overflow-x: hidden;\n  top: 0; }\n\n.sd-widget.ingest .widget-mode, .sd-widget.archive .widget-mode, .sd-widget.related-item .widget-mode, .sd-widget.aggregate .widget-mode, .sd-widget.package-manager .widget-mode, .sd-widget.packages .widget-mode {\n  float: right;\n  position: relative;\n  z-index: 1;\n  margin-right: 40px;\n  padding: 9px 0 0; }\n  .sd-widget.ingest .widget-mode .text, .sd-widget.archive .widget-mode .text, .sd-widget.related-item .widget-mode .text, .sd-widget.aggregate .widget-mode .text, .sd-widget.package-manager .widget-mode .text, .sd-widget.packages .widget-mode .text {\n    text-transform: uppercase;\n    font-size: 11px;\n    vertical-align: middle;\n    color: #999; }\n\n.sd-widget.ingest .search-box__content, .sd-widget.archive .search-box__content, .sd-widget.related-item .search-box__content, .sd-widget.aggregate .search-box__content, .sd-widget.package-manager .search-box__content, .sd-widget.packages .search-box__content {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  height: 100%;\n  transition: opacity ease-in-out 0.2s;\n  opacity: 1; }\n\n.sd-widget.ingest .search-cancel, .sd-widget.archive .search-cancel, .sd-widget.related-item .search-cancel, .sd-widget.aggregate .search-cancel, .sd-widget.package-manager .search-cancel, .sd-widget.packages .search-cancel {\n  position: absolute;\n  height: 24px;\n  width: 24px;\n  padding: 4px;\n  right: 6px;\n  margin: 0;\n  top: 5px;\n  transition: opacity ease-in-out 0.2s;\n  opacity: 0.5; }\n  .sd-widget.ingest .search-cancel:hover, .sd-widget.archive .search-cancel:hover, .sd-widget.related-item .search-cancel:hover, .sd-widget.aggregate .search-cancel:hover, .sd-widget.package-manager .search-cancel:hover, .sd-widget.packages .search-cancel:hover {\n    opacity: 1; }\n  .sd-widget.ingest .search-cancel:active i, .sd-widget.archive .search-cancel:active i, .sd-widget.related-item .search-cancel:active i, .sd-widget.aggregate .search-cancel:active i, .sd-widget.package-manager .search-cancel:active i, .sd-widget.packages .search-cancel:active i {\n    color: #5ea9c8; }\n\n.sd-widget.ingest .search-box, .sd-widget.archive .search-box, .sd-widget.related-item .search-box, .sd-widget.aggregate .search-box, .sd-widget.package-manager .search-box, .sd-widget.packages .search-box {\n  transition: all ease-in-out 0.2s;\n  height: 34px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);\n  background-color: #fff;\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  z-index: 1; }\n  .sd-widget.ingest .search-box input, .sd-widget.archive .search-box input, .sd-widget.related-item .search-box input, .sd-widget.aggregate .search-box input, .sd-widget.package-manager .search-box input, .sd-widget.packages .search-box input {\n    transition: all ease-in-out 0.16s;\n    flex-grow: 1;\n    height: 100%;\n    background-color: rgba(123, 123, 123, 0);\n    border-width: 0 0 1px 0 !important;\n    border-bottom: 1px solid transparent !important;\n    border-radius: 0;\n    padding: 0 30px 0 0.8rem;\n    margin: 0;\n    box-shadow: none; }\n    .sd-widget.ingest .search-box input:hover, .sd-widget.archive .search-box input:hover, .sd-widget.related-item .search-box input:hover, .sd-widget.aggregate .search-box input:hover, .sd-widget.package-manager .search-box input:hover, .sd-widget.packages .search-box input:hover {\n      border-bottom: 1px solid transparent !important;\n      box-shadow: none;\n      background-color: rgba(123, 123, 123, 0.06); }\n    .sd-widget.ingest .search-box input:focus, .sd-widget.archive .search-box input:focus, .sd-widget.related-item .search-box input:focus, .sd-widget.aggregate .search-box input:focus, .sd-widget.package-manager .search-box input:focus, .sd-widget.packages .search-box input:focus {\n      border-bottom: 1px solid #5ea9c8 !important;\n      background-color: rgba(123, 123, 123, 0); }\n  .sd-widget.ingest .search-box.blank, .sd-widget.archive .search-box.blank, .sd-widget.related-item .search-box.blank, .sd-widget.aggregate .search-box.blank, .sd-widget.package-manager .search-box.blank, .sd-widget.packages .search-box.blank {\n    background: #fff; }\n  .sd-widget.ingest .search-box .text, .sd-widget.archive .search-box .text, .sd-widget.related-item .search-box .text, .sd-widget.aggregate .search-box .text, .sd-widget.package-manager .search-box .text, .sd-widget.packages .search-box .text {\n    font-size: 14px;\n    font-style: italic;\n    color: #666;\n    padding: 10px;\n    background: #fff; }\n  .sd-widget.ingest .search-box .more-actions, .sd-widget.archive .search-box .more-actions, .sd-widget.related-item .search-box .more-actions, .sd-widget.aggregate .search-box .more-actions, .sd-widget.package-manager .search-box .more-actions, .sd-widget.packages .search-box .more-actions {\n    position: absolute;\n    right: 0px;\n    top: 6px; }\n  .sd-widget.ingest .search-box--hidden, .sd-widget.archive .search-box--hidden, .sd-widget.related-item .search-box--hidden, .sd-widget.aggregate .search-box--hidden, .sd-widget.package-manager .search-box--hidden, .sd-widget.packages .search-box--hidden {\n    height: 0;\n    box-shadow: 0 1px 0 0 rgba(123, 123, 123, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.2); }\n    .sd-widget.ingest .search-box--hidden .search-box__content, .sd-widget.archive .search-box--hidden .search-box__content, .sd-widget.related-item .search-box--hidden .search-box__content, .sd-widget.aggregate .search-box--hidden .search-box__content, .sd-widget.package-manager .search-box--hidden .search-box__content, .sd-widget.packages .search-box--hidden .search-box__content {\n      opacity: 0; }\n\n.sd-widget.ingest .content-list-holder, .sd-widget.archive .content-list-holder, .sd-widget.related-item .content-list-holder, .sd-widget.aggregate .content-list-holder, .sd-widget.package-manager .content-list-holder, .sd-widget.packages .content-list-holder {\n  position: static;\n  flex-grow: 1;\n  overflow-y: auto; }\n\n.sd-widget.ingest .filter-box, .sd-widget.archive .filter-box, .sd-widget.related-item .filter-box, .sd-widget.aggregate .filter-box, .sd-widget.package-manager .filter-box, .sd-widget.packages .filter-box {\n  height: 38px;\n  position: absolute;\n  top: 38px;\n  left: 0;\n  right: 0;\n  border-bottom: 1px solid #dcdcdc;\n  box-sizing: border-box; }\n  .sd-widget.ingest .filter-box .btn, .sd-widget.archive .filter-box .btn, .sd-widget.related-item .filter-box .btn, .sd-widget.aggregate .filter-box .btn, .sd-widget.package-manager .filter-box .btn, .sd-widget.packages .filter-box .btn {\n    margin: 5px 5px 0 0;\n    padding: 0 10px; }\n    .sd-widget.ingest .filter-box .btn i, .sd-widget.archive .filter-box .btn i, .sd-widget.related-item .filter-box .btn i, .sd-widget.aggregate .filter-box .btn i, .sd-widget.package-manager .filter-box .btn i, .sd-widget.packages .filter-box .btn i {\n      opacity: 0.75;\n      filter: \"alpha(opacity=75)\"; }\n  .sd-widget.ingest .filter-box .text, .sd-widget.archive .filter-box .text, .sd-widget.related-item .filter-box .text, .sd-widget.aggregate .filter-box .text, .sd-widget.package-manager .filter-box .text, .sd-widget.packages .filter-box .text {\n    margin-right: 10px;\n    float: left;\n    padding: 10px;\n    font-style: italic; }\n\n.sd-widget.ingest .pagination-box, .sd-widget.archive .pagination-box, .sd-widget.related-item .pagination-box, .sd-widget.aggregate .pagination-box, .sd-widget.package-manager .pagination-box, .sd-widget.packages .pagination-box {\n  height: 38px;\n  position: absolute;\n  top: 38px;\n  left: 0;\n  right: 0;\n  border-bottom: 1px solid #dcdcdc;\n  box-sizing: border-box; }\n  .sd-widget.ingest .pagination-box .sd-pagination, .sd-widget.archive .pagination-box .sd-pagination, .sd-widget.related-item .pagination-box .sd-pagination, .sd-widget.aggregate .pagination-box .sd-pagination, .sd-widget.package-manager .pagination-box .sd-pagination, .sd-widget.packages .pagination-box .sd-pagination {\n    padding: 5px 10px; }\n  .sd-widget.ingest .pagination-box.mode-detailed, .sd-widget.archive .pagination-box.mode-detailed, .sd-widget.related-item .pagination-box.mode-detailed, .sd-widget.aggregate .pagination-box.mode-detailed, .sd-widget.package-manager .pagination-box.mode-detailed, .sd-widget.packages .pagination-box.mode-detailed {\n    top: 76px; }\n  .sd-widget.ingest .pagination-box .page-info, .sd-widget.archive .pagination-box .page-info, .sd-widget.related-item .pagination-box .page-info, .sd-widget.aggregate .pagination-box .page-info, .sd-widget.package-manager .pagination-box .page-info, .sd-widget.packages .pagination-box .page-info {\n    float: left; }\n\n.sd-widget.ingest .pin-info, .sd-widget.archive .pin-info, .sd-widget.related-item .pin-info, .sd-widget.aggregate .pin-info, .sd-widget.package-manager .pin-info, .sd-widget.packages .pin-info {\n  font-size: 9px; }\n\n.sd-widget.ingest .ingest-list-holder, .sd-widget.archive .ingest-list-holder, .sd-widget.related-item .ingest-list-holder, .sd-widget.aggregate .ingest-list-holder, .sd-widget.package-manager .ingest-list-holder, .sd-widget.packages .ingest-list-holder {\n  position: absolute;\n  top: 76px;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n  .sd-widget.ingest .ingest-list-holder.mode-detailed, .sd-widget.archive .ingest-list-holder.mode-detailed, .sd-widget.related-item .ingest-list-holder.mode-detailed, .sd-widget.aggregate .ingest-list-holder.mode-detailed, .sd-widget.package-manager .ingest-list-holder.mode-detailed, .sd-widget.packages .ingest-list-holder.mode-detailed {\n    top: 114px; }\n\n.sd-widget.ingest .ingest-list, .sd-widget.archive .ingest-list, .sd-widget.related-item .ingest-list, .sd-widget.aggregate .ingest-list, .sd-widget.package-manager .ingest-list, .sd-widget.packages .ingest-list {\n  margin: 0;\n  list-style-type: none;\n  padding: 0;\n  /*overflow: hidden;*/ }\n  .sd-widget.ingest .ingest-list > li, .sd-widget.archive .ingest-list > li, .sd-widget.related-item .ingest-list > li, .sd-widget.aggregate .ingest-list > li, .sd-widget.package-manager .ingest-list > li, .sd-widget.packages .ingest-list > li {\n    position: relative; }\n    .sd-widget.ingest .ingest-list > li .item-block, .sd-widget.archive .ingest-list > li .item-block, .sd-widget.related-item .ingest-list > li .item-block, .sd-widget.aggregate .ingest-list > li .item-block, .sd-widget.package-manager .ingest-list > li .item-block, .sd-widget.packages .ingest-list > li .item-block {\n      cursor: pointer;\n      border-bottom: 1px solid #e5e5e5;\n      padding: 10px;\n      display: flex; }\n      .sd-widget.ingest .ingest-list > li .item-block .content, .sd-widget.archive .ingest-list > li .item-block .content, .sd-widget.related-item .ingest-list > li .item-block .content, .sd-widget.aggregate .ingest-list > li .item-block .content, .sd-widget.package-manager .ingest-list > li .item-block .content, .sd-widget.packages .ingest-list > li .item-block .content {\n        flex-grow: 1;\n        padding: 0 16px 0 8px; }\n      .sd-widget.ingest .ingest-list > li .item-block i, .sd-widget.archive .ingest-list > li .item-block i, .sd-widget.related-item .ingest-list > li .item-block i, .sd-widget.aggregate .ingest-list > li .item-block i, .sd-widget.package-manager .ingest-list > li .item-block i, .sd-widget.packages .ingest-list > li .item-block i {\n        color: #999;\n        margin-top: 1px; }\n      .sd-widget.ingest .ingest-list > li .item-block--basic, .sd-widget.archive .ingest-list > li .item-block--basic, .sd-widget.related-item .ingest-list > li .item-block--basic, .sd-widget.aggregate .ingest-list > li .item-block--basic, .sd-widget.package-manager .ingest-list > li .item-block--basic, .sd-widget.packages .ingest-list > li .item-block--basic {\n        border-bottom: none;\n        padding: 4px 0; }\n    .sd-widget.ingest .ingest-list > li .basic .legal, .sd-widget.archive .ingest-list > li .basic .legal, .sd-widget.related-item .ingest-list > li .basic .legal, .sd-widget.aggregate .ingest-list > li .basic .legal, .sd-widget.package-manager .ingest-list > li .basic .legal, .sd-widget.packages .ingest-list > li .basic .legal {\n      margin-left: 10px; }\n    .sd-widget.ingest .ingest-list > li .basic .keyword, .sd-widget.archive .ingest-list > li .basic .keyword, .sd-widget.related-item .ingest-list > li .basic .keyword, .sd-widget.aggregate .ingest-list > li .basic .keyword, .sd-widget.package-manager .ingest-list > li .basic .keyword, .sd-widget.packages .ingest-list > li .basic .keyword {\n      font-weight: 500;\n      color: #216278;\n      display: block; }\n    .sd-widget.ingest .ingest-list > li .basic .headline, .sd-widget.archive .ingest-list > li .basic .headline, .sd-widget.related-item .ingest-list > li .basic .headline, .sd-widget.aggregate .ingest-list > li .basic .headline, .sd-widget.package-manager .ingest-list > li .basic .headline, .sd-widget.packages .ingest-list > li .basic .headline {\n      display: inline-block; }\n    .sd-widget.ingest .ingest-list > li .basic .takekey, .sd-widget.archive .ingest-list > li .basic .takekey, .sd-widget.related-item .ingest-list > li .basic .takekey, .sd-widget.aggregate .ingest-list > li .basic .takekey, .sd-widget.package-manager .ingest-list > li .basic .takekey, .sd-widget.packages .ingest-list > li .basic .takekey {\n      color: #333;\n      font-weight: 500;\n      display: block; }\n    .sd-widget.ingest .ingest-list > li .top-line, .sd-widget.archive .ingest-list > li .top-line, .sd-widget.related-item .ingest-list > li .top-line, .sd-widget.aggregate .ingest-list > li .top-line, .sd-widget.package-manager .ingest-list > li .top-line, .sd-widget.packages .ingest-list > li .top-line {\n      margin: 0;\n      list-style-type: none;\n      padding: 0;\n      margin-bottom: 5px; }\n      .sd-widget.ingest .ingest-list > li .top-line > li, .sd-widget.archive .ingest-list > li .top-line > li, .sd-widget.related-item .ingest-list > li .top-line > li, .sd-widget.aggregate .ingest-list > li .top-line > li, .sd-widget.package-manager .ingest-list > li .top-line > li, .sd-widget.packages .ingest-list > li .top-line > li {\n        float: left;\n        padding-right: 7px;\n        margin-right: 7px;\n        border-right: 1px solid #e7e7e7;\n        font-size: 11px;\n        color: #626262;\n        line-height: 21px; }\n        .sd-widget.ingest .ingest-list > li .top-line > li em, .sd-widget.archive .ingest-list > li .top-line > li em, .sd-widget.related-item .ingest-list > li .top-line > li em, .sd-widget.aggregate .ingest-list > li .top-line > li em, .sd-widget.package-manager .ingest-list > li .top-line > li em, .sd-widget.packages .ingest-list > li .top-line > li em {\n          color: #aaa;\n          margin-right: 4px; }\n        .sd-widget.ingest .ingest-list > li .top-line > li .state-label, .sd-widget.archive .ingest-list > li .top-line > li .state-label, .sd-widget.related-item .ingest-list > li .top-line > li .state-label, .sd-widget.aggregate .ingest-list > li .top-line > li .state-label, .sd-widget.package-manager .ingest-list > li .top-line > li .state-label, .sd-widget.packages .ingest-list > li .top-line > li .state-label {\n          margin-top: 4px; }\n        .sd-widget.ingest .ingest-list > li .top-line > li .type-icon, .sd-widget.archive .ingest-list > li .top-line > li .type-icon, .sd-widget.related-item .ingest-list > li .top-line > li .type-icon, .sd-widget.aggregate .ingest-list > li .top-line > li .type-icon, .sd-widget.package-manager .ingest-list > li .top-line > li .type-icon, .sd-widget.packages .ingest-list > li .top-line > li .type-icon {\n          opacity: 0.5;\n          filter: \"alpha(opacity=50)\"; }\n        .sd-widget.ingest .ingest-list > li .top-line > li .urgency-label, .sd-widget.archive .ingest-list > li .top-line > li .urgency-label, .sd-widget.related-item .ingest-list > li .top-line > li .urgency-label, .sd-widget.aggregate .ingest-list > li .top-line > li .urgency-label, .sd-widget.package-manager .ingest-list > li .top-line > li .urgency-label, .sd-widget.packages .ingest-list > li .top-line > li .urgency-label {\n          margin-top: 2px; }\n        .sd-widget.ingest .ingest-list > li .top-line > li:last-child, .sd-widget.archive .ingest-list > li .top-line > li:last-child, .sd-widget.related-item .ingest-list > li .top-line > li:last-child, .sd-widget.aggregate .ingest-list > li .top-line > li:last-child, .sd-widget.package-manager .ingest-list > li .top-line > li:last-child, .sd-widget.packages .ingest-list > li .top-line > li:last-child {\n          border: 0; }\n        .sd-widget.ingest .ingest-list > li .top-line > li time, .sd-widget.archive .ingest-list > li .top-line > li time, .sd-widget.related-item .ingest-list > li .top-line > li time, .sd-widget.aggregate .ingest-list > li .top-line > li time, .sd-widget.package-manager .ingest-list > li .top-line > li time, .sd-widget.packages .ingest-list > li .top-line > li time {\n          color: #999; }\n    .sd-widget.ingest .ingest-list > li .main-line figure, .sd-widget.archive .ingest-list > li .main-line figure, .sd-widget.related-item .ingest-list > li .main-line figure, .sd-widget.aggregate .ingest-list > li .main-line figure, .sd-widget.package-manager .ingest-list > li .main-line figure, .sd-widget.packages .ingest-list > li .main-line figure {\n      float: left;\n      margin-right: 10px;\n      border: 1px solid #f0f0f0;\n      padding: 2px;\n      margin-top: 3px; }\n      .sd-widget.ingest .ingest-list > li .main-line figure img, .sd-widget.archive .ingest-list > li .main-line figure img, .sd-widget.related-item .ingest-list > li .main-line figure img, .sd-widget.aggregate .ingest-list > li .main-line figure img, .sd-widget.package-manager .ingest-list > li .main-line figure img, .sd-widget.packages .ingest-list > li .main-line figure img {\n        height: 55px; }\n    .sd-widget.ingest .ingest-list > li .main-line h5, .sd-widget.archive .ingest-list > li .main-line h5, .sd-widget.related-item .ingest-list > li .main-line h5, .sd-widget.aggregate .ingest-list > li .main-line h5, .sd-widget.package-manager .ingest-list > li .main-line h5, .sd-widget.packages .ingest-list > li .main-line h5 {\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 22px; }\n    .sd-widget.ingest .ingest-list > li.alert, .sd-widget.archive .ingest-list > li.alert, .sd-widget.related-item .ingest-list > li.alert, .sd-widget.aggregate .ingest-list > li.alert, .sd-widget.package-manager .ingest-list > li.alert, .sd-widget.packages .ingest-list > li.alert {\n      border: 0;\n      border-radius: 0; }\n    .sd-widget.ingest .ingest-list > li .pinned .content, .sd-widget.archive .ingest-list > li .pinned .content, .sd-widget.related-item .ingest-list > li .pinned .content, .sd-widget.aggregate .ingest-list > li .pinned .content, .sd-widget.package-manager .ingest-list > li .pinned .content, .sd-widget.packages .ingest-list > li .pinned .content {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n    .sd-widget.ingest .ingest-list > li .pinned.pinned-instance, .sd-widget.archive .ingest-list > li .pinned.pinned-instance, .sd-widget.related-item .ingest-list > li .pinned.pinned-instance, .sd-widget.aggregate .ingest-list > li .pinned.pinned-instance, .sd-widget.package-manager .ingest-list > li .pinned.pinned-instance, .sd-widget.packages .ingest-list > li .pinned.pinned-instance {\n      padding: 10px 5px 5px;\n      border-bottom: 0; }\n      .sd-widget.ingest .ingest-list > li .pinned.pinned-instance .content, .sd-widget.archive .ingest-list > li .pinned.pinned-instance .content, .sd-widget.related-item .ingest-list > li .pinned.pinned-instance .content, .sd-widget.aggregate .ingest-list > li .pinned.pinned-instance .content, .sd-widget.package-manager .ingest-list > li .pinned.pinned-instance .content, .sd-widget.packages .ingest-list > li .pinned.pinned-instance .content {\n        padding: 5px;\n        background: #fff;\n        opacity: 1;\n        filter: \"alpha(opacity=100)\";\n        border: 1px solid #d0d0d0;\n        border-radius: 3px; }\n    .sd-widget.ingest .ingest-list > li:first-child .pinned.pinned-instance, .sd-widget.archive .ingest-list > li:first-child .pinned.pinned-instance, .sd-widget.related-item .ingest-list > li:first-child .pinned.pinned-instance, .sd-widget.aggregate .ingest-list > li:first-child .pinned.pinned-instance, .sd-widget.package-manager .ingest-list > li:first-child .pinned.pinned-instance, .sd-widget.packages .ingest-list > li:first-child .pinned.pinned-instance {\n      margin-top: 10px; }\n    .sd-widget.ingest .ingest-list > li .basic.item-block .content p, .sd-widget.archive .ingest-list > li .basic.item-block .content p, .sd-widget.related-item .ingest-list > li .basic.item-block .content p, .sd-widget.aggregate .ingest-list > li .basic.item-block .content p, .sd-widget.package-manager .ingest-list > li .basic.item-block .content p, .sd-widget.packages .ingest-list > li .basic.item-block .content p {\n      padding-right: 15px; }\n      .sd-widget.ingest .ingest-list > li .basic.item-block .content p i, .sd-widget.archive .ingest-list > li .basic.item-block .content p i, .sd-widget.related-item .ingest-list > li .basic.item-block .content p i, .sd-widget.aggregate .ingest-list > li .basic.item-block .content p i, .sd-widget.package-manager .ingest-list > li .basic.item-block .content p i, .sd-widget.packages .ingest-list > li .basic.item-block .content p i {\n        margin-top: -2px;\n        height: 18px;\n        padding-left: 0;\n        margin-right: 4px;\n        background-position-x: 0px;\n        color: #999; }\n    .sd-widget.ingest .ingest-list > li .pin-info, .sd-widget.archive .ingest-list > li .pin-info, .sd-widget.related-item .ingest-list > li .pin-info, .sd-widget.aggregate .ingest-list > li .pin-info, .sd-widget.package-manager .ingest-list > li .pin-info, .sd-widget.packages .ingest-list > li .pin-info {\n      text-transform: uppercase;\n      font-size: 10px;\n      color: #999; }\n    .sd-widget.ingest .ingest-list > li .toggle-box, .sd-widget.archive .ingest-list > li .toggle-box, .sd-widget.related-item .ingest-list > li .toggle-box, .sd-widget.aggregate .ingest-list > li .toggle-box, .sd-widget.package-manager .ingest-list > li .toggle-box, .sd-widget.packages .ingest-list > li .toggle-box {\n      margin-bottom: 0; }\n  .sd-widget.ingest .ingest-list .active .item-block, .sd-widget.archive .ingest-list .active .item-block, .sd-widget.related-item .ingest-list .active .item-block, .sd-widget.aggregate .ingest-list .active .item-block, .sd-widget.package-manager .ingest-list .active .item-block, .sd-widget.packages .ingest-list .active .item-block {\n    background: #eff7fa; }\n  .sd-widget.ingest .ingest-list.simple-list, .sd-widget.archive .ingest-list.simple-list, .sd-widget.related-item .ingest-list.simple-list, .sd-widget.aggregate .ingest-list.simple-list, .sd-widget.package-manager .ingest-list.simple-list, .sd-widget.packages .ingest-list.simple-list {\n    margin-top: 1.6rem; }\n\n.sd-widget.ingest .main-list, .sd-widget.archive .main-list, .sd-widget.related-item .main-list, .sd-widget.aggregate .main-list, .sd-widget.package-manager .main-list, .sd-widget.packages .main-list {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 38px;\n  width: 100%;\n  transition: all ease 0.2s;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column; }\n  .sd-widget.ingest .main-list.wrap, .sd-widget.archive .main-list.wrap, .sd-widget.related-item .main-list.wrap, .sd-widget.aggregate .main-list.wrap, .sd-widget.package-manager .main-list.wrap, .sd-widget.packages .main-list.wrap {\n    left: -100%;\n    right: auto;\n    overflow: hidden; }\n    .sd-widget.ingest .main-list.wrap .scroll-shadow, .sd-widget.archive .main-list.wrap .scroll-shadow, .sd-widget.related-item .main-list.wrap .scroll-shadow, .sd-widget.aggregate .main-list.wrap .scroll-shadow, .sd-widget.package-manager .main-list.wrap .scroll-shadow, .sd-widget.packages .main-list.wrap .scroll-shadow {\n      display: none; }\n    .sd-widget.ingest .main-list.wrap .content-list-holder, .sd-widget.archive .main-list.wrap .content-list-holder, .sd-widget.related-item .main-list.wrap .content-list-holder, .sd-widget.aggregate .main-list.wrap .content-list-holder, .sd-widget.package-manager .main-list.wrap .content-list-holder, .sd-widget.packages .main-list.wrap .content-list-holder {\n      overflow: hidden !important; }\n  .sd-widget.ingest .main-list.custom-widget, .sd-widget.archive .main-list.custom-widget, .sd-widget.related-item .main-list.custom-widget, .sd-widget.aggregate .main-list.custom-widget, .sd-widget.package-manager .main-list.custom-widget, .sd-widget.packages .main-list.custom-widget {\n    bottom: 50%; }\n\n.sd-widget.ingest .preview, .sd-widget.archive .preview, .sd-widget.related-item .preview, .sd-widget.aggregate .preview, .sd-widget.package-manager .preview, .sd-widget.packages .preview {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  bottom: 0;\n  top: 38px;\n  transition: all ease 0.2s; }\n  .sd-widget.ingest .preview.custom-widget, .sd-widget.archive .preview.custom-widget, .sd-widget.related-item .preview.custom-widget, .sd-widget.aggregate .preview.custom-widget, .sd-widget.package-manager .preview.custom-widget, .sd-widget.packages .preview.custom-widget {\n    top: 50%; }\n  .sd-widget.ingest .preview .nav, .sd-widget.archive .preview .nav, .sd-widget.related-item .preview .nav, .sd-widget.aggregate .preview .nav, .sd-widget.package-manager .preview .nav, .sd-widget.packages .preview .nav {\n    height: 34px;\n    display: flex;\n    align-items: center;\n    background: #f4f4f4;\n    padding: 0 10px;\n    border-bottom: 1px solid #e7e7e7; }\n  .sd-widget.ingest .preview .open, .sd-widget.ingest .preview .associate, .sd-widget.archive .preview .open, .sd-widget.archive .preview .associate, .sd-widget.related-item .preview .open, .sd-widget.related-item .preview .associate, .sd-widget.aggregate .preview .open, .sd-widget.aggregate .preview .associate, .sd-widget.package-manager .preview .open, .sd-widget.package-manager .preview .associate, .sd-widget.packages .preview .open, .sd-widget.packages .preview .associate {\n    border: 0;\n    background: 0;\n    padding: 0 8px;\n    color: #333;\n    line-height: 34px;\n    box-sizing: border-box; }\n    .sd-widget.ingest .preview .open span, .sd-widget.ingest .preview .associate span, .sd-widget.archive .preview .open span, .sd-widget.archive .preview .associate span, .sd-widget.related-item .preview .open span, .sd-widget.related-item .preview .associate span, .sd-widget.aggregate .preview .open span, .sd-widget.aggregate .preview .associate span, .sd-widget.package-manager .preview .open span, .sd-widget.package-manager .preview .associate span, .sd-widget.packages .preview .open span, .sd-widget.packages .preview .associate span {\n      line-height: 24px; }\n    .sd-widget.ingest .preview .open i, .sd-widget.ingest .preview .associate i, .sd-widget.archive .preview .open i, .sd-widget.archive .preview .associate i, .sd-widget.related-item .preview .open i, .sd-widget.related-item .preview .associate i, .sd-widget.aggregate .preview .open i, .sd-widget.aggregate .preview .associate i, .sd-widget.package-manager .preview .open i, .sd-widget.package-manager .preview .associate i, .sd-widget.packages .preview .open i, .sd-widget.packages .preview .associate i {\n      margin-top: 3px;\n      margin-right: 5px;\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n    .sd-widget.ingest .preview .open:hover i, .sd-widget.ingest .preview .associate:hover i, .sd-widget.archive .preview .open:hover i, .sd-widget.archive .preview .associate:hover i, .sd-widget.related-item .preview .open:hover i, .sd-widget.related-item .preview .associate:hover i, .sd-widget.aggregate .preview .open:hover i, .sd-widget.aggregate .preview .associate:hover i, .sd-widget.package-manager .preview .open:hover i, .sd-widget.package-manager .preview .associate:hover i, .sd-widget.packages .preview .open:hover i, .sd-widget.packages .preview .associate:hover i {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .sd-widget.ingest .preview .state-label, .sd-widget.archive .preview .state-label, .sd-widget.related-item .preview .state-label, .sd-widget.aggregate .preview .state-label, .sd-widget.package-manager .preview .state-label, .sd-widget.packages .preview .state-label {\n    margin-top: 5px; }\n  .sd-widget.ingest .preview .content-item-preview .content-container, .sd-widget.archive .preview .content-item-preview .content-container, .sd-widget.related-item .preview .content-item-preview .content-container, .sd-widget.aggregate .preview .content-item-preview .content-container, .sd-widget.package-manager .preview .content-item-preview .content-container, .sd-widget.packages .preview .content-item-preview .content-container {\n    top: 36px; }\n    .sd-widget.ingest .preview .content-item-preview .content-container img, .sd-widget.archive .preview .content-item-preview .content-container img, .sd-widget.related-item .preview .content-item-preview .content-container img, .sd-widget.aggregate .preview .content-item-preview .content-container img, .sd-widget.package-manager .preview .content-item-preview .content-container img, .sd-widget.packages .preview .content-item-preview .content-container img {\n      max-width: 100%;\n      height: auto; }\n  .sd-widget.ingest .preview.wrap, .sd-widget.archive .preview.wrap, .sd-widget.related-item .preview.wrap, .sd-widget.aggregate .preview.wrap, .sd-widget.package-manager .preview.wrap, .sd-widget.packages .preview.wrap {\n    left: 100%; }\n    .sd-widget.ingest .preview.wrap .scroll-shadow, .sd-widget.archive .preview.wrap .scroll-shadow, .sd-widget.related-item .preview.wrap .scroll-shadow, .sd-widget.aggregate .preview.wrap .scroll-shadow, .sd-widget.package-manager .preview.wrap .scroll-shadow, .sd-widget.packages .preview.wrap .scroll-shadow {\n      display: none; }\n\n.sd-widget.related-item .preview .content-item-preview {\n  position: static;\n  width: 325px; }\n\n.widget-ingest .ingest-list-holder, .widget-archive .ingest-list-holder, .widget-related-item .ingest-list-holder {\n  background: #f8f8f8; }\n\n.widget-ingest .ingest-list, .widget-archive .ingest-list, .widget-related-item .ingest-list {\n  padding: 12px 12px 30px; }\n  .widget-ingest .ingest-list > li .item-block, .widget-archive .ingest-list > li .item-block, .widget-related-item .ingest-list > li .item-block {\n    border-color: #dedede;\n    padding: 12px 0; }\n    .widget-ingest .ingest-list > li .item-block.pinned.pinned-instance, .widget-archive .ingest-list > li .item-block.pinned.pinned-instance, .widget-related-item .ingest-list > li .item-block.pinned.pinned-instance {\n      padding: 0 0 12px 0; }\n  .widget-ingest .ingest-list > li.active .item-block.pinned, .widget-archive .ingest-list > li.active .item-block.pinned, .widget-related-item .ingest-list > li.active .item-block.pinned {\n    background: none; }\n    .widget-ingest .ingest-list > li.active .item-block.pinned .content, .widget-archive .ingest-list > li.active .item-block.pinned .content, .widget-related-item .ingest-list > li.active .item-block.pinned .content {\n      background: #eff7fa; }\n  .widget-ingest .ingest-list > li .top-line > li, .widget-archive .ingest-list > li .top-line > li, .widget-related-item .ingest-list > li .top-line > li {\n    border: 0; }\n  .widget-ingest .ingest-list > li .main-line h5, .widget-archive .ingest-list > li .main-line h5, .widget-related-item .ingest-list > li .main-line h5 {\n    font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n    color: #000;\n    font-size: 13px;\n    line-height: 20px; }\n\n.tabpane.widget-ingest .sd-widget .widget-mode, .tabpane.widget-archive .sd-widget .widget-mode, .tabpane.widget-related-item .sd-widget .widget-mode {\n  margin: 0;\n  padding: 10px 5px; }\n  .tabpane.widget-ingest .sd-widget .widget-mode time, .tabpane.widget-archive .sd-widget .widget-mode time, .tabpane.widget-related-item .sd-widget .widget-mode time {\n    font-size: 11px;\n    color: #999;\n    text-align: right;\n    display: inline-block;\n    margin: 4px 10px 0 0; }\n\n.tabpane.widget-ingest .sd-widget .main-list, .tabpane.widget-archive .sd-widget .main-list, .tabpane.widget-related-item .sd-widget .main-list {\n  top: 0px; }\n\n.tabpane.widget-ingest .sd-widget .existing-items, .tabpane.widget-archive .sd-widget .existing-items, .tabpane.widget-related-item .sd-widget .existing-items {\n  top: -70px; }\n\n.tabpane.widget-ingest .sd-widget .ingest-list-holder, .tabpane.widget-archive .sd-widget .ingest-list-holder, .tabpane.widget-related-item .sd-widget .ingest-list-holder {\n  bottom: 60px; }\n\n.tabpane.widget-ingest .sd-widget .preview, .tabpane.widget-archive .sd-widget .preview, .tabpane.widget-related-item .sd-widget .preview {\n  top: 44px; }\n", ""]);

// exports


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var moment_1 = __importDefault(__webpack_require__(5));
__webpack_require__(1426);
var utils_1 = __webpack_require__(3);
TasksService.$inject = ['desks', '$rootScope', 'api', 'datetimeHelper'];
function TasksService(desks, $rootScope, api, datetimeHelper) {
    this.statuses = [
        { _id: 'todo', name: utils_1.gettext('To Do') },
        { _id: 'in_progress', name: utils_1.gettext('In Progress') },
        { _id: 'done', name: utils_1.gettext('Done') },
    ];
    this.save = function (orig, task) {
        if (task.task.due_time) {
            task.task.due_date = datetimeHelper.mergeDateTime(task.task.due_date, task.task.due_time);
        }
        delete task.task.due_time;
        if (!task.task.user) {
            delete task.task.user;
        }
        return api('tasks').save(orig, task)
            .then(function (result) { return result; });
    };
    this.buildFilter = function (status) {
        var filters = [];
        var self = this;
        if (desks.getCurrentDeskId()) {
            // desk filter
            filters.push({ term: { 'task.desk': desks.getCurrentDeskId() } });
        }
        else {
            // user filter
            filters.push({ term: { 'task.user': $rootScope.currentUser._id } });
        }
        // status filter
        if (status) {
            filters.push({ term: { 'task.status': status } });
        }
        else {
            var allStatuses = [];
            lodash_1.default.each(self.statuses, function (s) {
                allStatuses.push({ term: { 'task.status': s._id } });
            });
            filters.push({ or: allStatuses });
        }
        var andFilter = { and: filters };
        return andFilter;
    };
    this.fetch = function (status, filter) {
        if (filter === void 0) { filter = this.buildFilter(status); }
        return api('tasks').query({
            source: {
                size: 200,
                sort: [{ _updated: 'desc' }],
                filter: filter,
            },
        });
    };
}
TasksController.$inject = ['$scope', '$timeout', 'api', 'notify', 'desks', 'tasks', '$filter', 'archiveService'];
function TasksController($scope, $timeout, api, notify, desks, tasks, $filter, archiveService) {
    var KANBAN_VIEW = 'kanban', timeout;
    $scope.selected = {};
    $scope.newTask = null;
    $scope.tasks = null;
    $scope.view = KANBAN_VIEW;
    $scope.statuses = tasks.statuses;
    $scope.activeStatus = $scope.statuses[0]._id;
    $scope.$watch(function () { return desks.getCurrentDeskId(); }, function (desk) {
        if (desk) {
            fetchTasks();
            fetchStages();
            fetchPublished();
            fetchScheduled();
        }
    });
    /**
     * Fetch stages of current desk
     */
    function fetchStages() {
        desks.fetchDeskStages(desks.getCurrentDeskId()).then(function (stages) {
            $scope.stages = stages;
        });
    }
    /**
     * Fetch items for current desk which are not published or spiked
     */
    function fetchTasks() {
        $timeout.cancel(timeout);
        timeout = $timeout(function () {
            var filter = { bool: {
                    must: {
                        term: { 'task.desk': desks.getCurrentDeskId() },
                    },
                    must_not: {
                        terms: { state: ['published', 'spiked', 'corrected', 'killed', 'recalled'] },
                    },
                } };
            var source = { source: {
                    size: 200,
                    sort: [{ _updated: 'desc' }],
                    filter: filter,
                } };
            api.query('tasks', source).then(function (result) {
                $scope.stageItems = lodash_1.default.groupBy(result._items, function (item) { return item.task.stage; });
            });
        }, 300, false);
    }
    /**
     * Fetch content published from a desk
     */
    function fetchPublished() {
        var filter = { bool: {
                must: {
                    term: { 'task.desk': desks.getCurrentDeskId() },
                },
            } };
        api.query('published', { source: { filter: filter } })
            .then(function (results) {
            $scope.published = results;
        });
    }
    /**
     * Fetch templates scheduled for today on current desk
     */
    function fetchScheduled() {
        var startTime = moment_1.default().hours(0)
            .minutes(0)
            .seconds(0);
        var endTime = moment_1.default().hours(23)
            .minutes(59)
            .seconds(59);
        var filter = {
            schedule_desk: desks.getCurrentDeskId(),
            next_run: { $gte: toServerTime(startTime), $lte: toServerTime(endTime) },
        };
        api.query('content_templates', { where: filter, sort: 'next_run' }).then(function (results) {
            $scope.scheduled = results;
        });
        /**
         * Get UTC datetime matching server format for given moment date object
         *
         * @param {Moment} d
         * @return {string}
         */
        function toServerTime(d) {
            d.milliseconds(0); // set it to zero so it will match in replace
            return d.toISOString().replace('.000Z', '+0000');
        }
    }
    $scope.preview = function (item) {
        $scope.selected.preview = item;
    };
    $scope.create = function () {
        $scope.newTask = {};
        archiveService.addTaskToArticle($scope.newTask, desks.getCurrentDesk());
        var taskDate = new Date();
        $scope.newTask.task.due_date = $filter('formatDateTimeString')(taskDate);
        $scope.newTask.task.due_time = $filter('formatDateTimeString')(taskDate, 'HH:mm:ss');
    };
    $scope.save = function () {
        tasks.save({}, $scope.newTask)
            .then(function (result) {
            notify.success(utils_1.gettext('Item saved.'));
            $scope.close();
        });
    };
    $scope.close = function () {
        $scope.newTask = null;
    };
    $scope.setView = function (view) {
        if ($scope.view !== view) {
            $scope.view = view;
            $scope.tasks = null;
            fetchTasks();
        }
    };
    $scope.selectStatus = function (status) {
        if ($scope.activeStatus !== status) {
            $scope.activeStatus = status;
            $scope.tasks = null;
            fetchTasks();
        }
    };
    $scope.$on('task:new', fetchTasks);
    $scope.$on('task:stage', function (event, data) {
        var deskId = desks.getCurrentDeskId();
        if (deskId === data.old_desk || deskId === data.new_desk) {
            fetchTasks();
        }
    });
}
TaskPreviewDirective.$inject = ['tasks', 'desks', 'notify', '$filter'];
function TaskPreviewDirective(tasks, desks, notify, $filter) {
    var promise = desks.initialize();
    return {
        templateUrl: 'scripts/apps/dashboard/workspace-tasks/views/task-preview.html',
        scope: {
            item: '=',
            close: '&onclose',
        },
        link: function (scope) {
            var _orig;
            scope.task = null;
            scope.task_details = null;
            scope.editmode = false;
            promise.then(function () {
                scope.desks = desks.deskLookup;
                scope.users = desks.userLookup;
            });
            scope.$watch('item._id', function (val) {
                if (val) {
                    scope.reset();
                }
            });
            scope.save = function () {
                scope.task.task = lodash_1.default.extend(scope.task.task, scope.task_details);
                tasks.save(_orig, scope.task)
                    .then(function (result) {
                    notify.success(utils_1.gettext('Item saved.'));
                    scope.editmode = false;
                });
            };
            scope.edit = function () {
                scope.editmode = true;
            };
            scope.reset = function () {
                scope.editmode = false;
                scope.task = lodash_1.default.create(scope.item);
                scope.task_details = lodash_1.default.extend({}, scope.item.task);
                scope.task_details.due_date = scope.task_details.due_date ?
                    $filter('formatDateTimeString')(scope.task_details.due_date) : null;
                scope.task_details.due_time = scope.task_details.due_time ?
                    $filter('formatDateTimeString')(scope.task_details.due_time, 'HH:mm:ss') : null;
                _orig = scope.item;
            };
        },
    };
}
TaskKanbanBoardDirective.$inject = [];
function TaskKanbanBoardDirective() {
    return {
        templateUrl: 'scripts/apps/dashboard/workspace-tasks/views/kanban-board.html',
        scope: {
            items: '=',
            label: '@',
            cssClass: '@',
            selected: '=',
        },
        link: function (scope) {
            scope.preview = function (item) {
                if (scope.selected) {
                    scope.selected.preview = item;
                }
            };
        },
    };
}
AssigneeViewDirective.$inject = ['desks'];
function AssigneeViewDirective(desks) {
    var promise = desks.initialize();
    return {
        templateUrl: 'scripts/apps/dashboard/workspace-tasks/views/assignee-view.html',
        scope: {
            task: '=',
            name: '=',
            avatarSize: '@',
        },
        link: function (scope) {
            promise.then(function setItemAssigne() {
                var task = angular.extend({ desk: null, user: null }, scope.task);
                var desk = desks.deskLookup[task.desk] || {};
                var user = desks.userLookup[task.user] || {};
                scope.deskName = desk.name || null;
                scope.userName = user.display_name || null;
                scope.user = user || null;
            });
        },
    };
}
// todo(petr): move to desks module
StagesCtrlFactory.$inject = ['desks'];
function StagesCtrlFactory(desks) {
    var promise = desks.initialize();
    return function StagesCtrl($scope) {
        var self = this;
        promise.then(function () {
            self.stages = null;
            self.selected = null;
            // select a stage as active
            self.select = function (stage) {
                var stageId = stage ? stage._id : null;
                self.selected = stage || null;
                desks.setCurrentStageId(stageId);
            };
            // reload list of stages
            self.reload = function (deskId) {
                self.stages = deskId ? desks.deskStages[deskId] : null;
                self.select(lodash_1.default.find(self.stages, { _id: desks.activeStageId }));
            };
            $scope.$watch(function () { return desks.getCurrentDeskId(); }, function () {
                self.reload(desks.getCurrentDeskId());
            });
        });
    };
}
function DeskStagesDirective() {
    return {
        templateUrl: 'scripts/apps/dashboard/workspace-tasks/views/desk-stages.html',
    };
}
angular.module('superdesk.apps.workspace.tasks', ['superdesk.apps.workspace.menu'])
    .factory('StagesCtrl', StagesCtrlFactory)
    .directive('sdTaskPreview', TaskPreviewDirective)
    .directive('sdAssigneeView', AssigneeViewDirective)
    .directive('sdDeskStages', DeskStagesDirective)
    .directive('sdTaskKanbanBoard', TaskKanbanBoardDirective)
    .controller('TasksController', TasksController)
    .service('tasks', TasksService)
    .config(['superdeskProvider', 'workspaceMenuProvider', function (superdesk, workspaceMenuProvider) {
        superdesk.activity('/workspace/tasks', {
            label: utils_1.gettext('Workspace'),
            controller: TasksController,
            templateUrl: 'scripts/apps/dashboard/workspace-tasks/views/workspace-tasks.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            filters: [{ action: 'view', type: 'task' }],
        });
        superdesk.activity('pick.task', {
            label: utils_1.gettext('Pick task'),
            icon: 'pick',
            controller: ['data', 'superdesk',
                /**
                 * Open given item using sidebar authoring
                 *
                 * @param {Object} data
                 * @param {Object} superdesk service
                 * @return {Promise}
                 */
                function pickTask(data, superdeskService) {
                    return superdeskService.intent('edit', 'item', data.item);
                },
            ],
            filters: [{ action: superdesk.ACTION_EDIT, type: 'task' }],
        });
        workspaceMenuProvider.item({
            href: '/workspace/tasks',
            icon: 'tasks',
            label: utils_1.gettext('Tasks'),
            shortcut: 'alt+t',
            order: 500,
            if: 'privileges.tasks && workspaceConfig.tasks',
        });
    }]);


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1427);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./tasks.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./tasks.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n/*\n---------------------------------------------\nTASK PAGE\n---------------------------------------------\n*/\n.task-labels {\n  list-style-type: none;\n  padding: 0;\n  margin: 5px 0 0; }\n\n.task-label, .task-labels > li {\n  float: left;\n  margin-right: 4px;\n  background: #eee;\n  border-radius: 3px;\n  height: 18px;\n  line-height: 18px;\n  color: #444;\n  padding: 2px 5px;\n  min-height: auto;\n  font-size: 10px; }\n  .task-label i, .task-labels > li i {\n    opacity: 0.7;\n    filter: \"alpha(opacity=70)\"; }\n  .task-label.urgent, .task-labels > li.urgent {\n    background-color: #ba7474; }\n  .task-label.critical, .task-labels > li.critical {\n    background-color: #8b0000; }\n  .task-label.done, .task-labels > li.done {\n    background-color: #288001; }\n\n.task-list > header {\n  padding: 10px; }\n  .task-list > header .card .header {\n    min-height: 24px; }\n  .task-list > header .card .avatar {\n    margin-right: 10px; }\n  .task-list > header .card .title {\n    padding: 3px 0;\n    line-height: 18px;\n    min-height: 18px; }\n  .task-list > header button {\n    border: 0;\n    background: none; }\n  .task-list > header .switch-view {\n    float: left;\n    margin-right: 30px; }\n    .task-list > header .switch-view button {\n      display: inline-block;\n      border-radius: 3px;\n      height: 30px;\n      box-sizing: border-box;\n      padding: 0 10px;\n      line-height: 30px;\n      color: #4f4f4f;\n      text-decoration: none;\n      text-transform: uppercase;\n      font-size: 12px; }\n      .task-list > header .switch-view button:hover {\n        background: #e4e4e4; }\n      .task-list > header .switch-view button.active {\n        background: #ddd;\n        color: #000;\n        box-shadow: inset 0 2px 0 #ccc; }\n  .task-list > header .status-tabs {\n    float: left;\n    margin: -10px 0; }\n    .task-list > header .status-tabs li button {\n      text-transform: uppercase;\n      font-size: 12px; }\n    .task-list > header .status-tabs li.active button {\n      border-bottom: 3px solid #666;\n      padding-bottom: 6px; }\n      .task-list > header .status-tabs li.active button.todo {\n        border-bottom-color: #b70000; }\n      .task-list > header .status-tabs li.active button.in_progress {\n        border-bottom-color: #cc7800; }\n      .task-list > header .status-tabs li.active button.done {\n        border-bottom-color: #288001; }\n\n.task-list {\n  white-space: nowrap; }\n  .task-list .content {\n    padding: 20px;\n    white-space: nowrap;\n    overflow: auto; }\n  .task-list .card .title {\n    font-weight: 500; }\n  .task-list .card .marker {\n    width: 4px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    border-radius: 2px 0 0 2px; }\n    .task-list .card .marker.todo {\n      background: #b70000; }\n    .task-list .card .marker.in_progress {\n      background: #cc7800; }\n    .task-list .card .marker.done {\n      background: #288001; }\n  .task-list .board-holder {\n    width: 300px;\n    display: inline-block;\n    vertical-align: top; }\n  .task-list .board {\n    min-height: 500px;\n    margin-right: 20px; }\n    .task-list .board header {\n      text-transform: uppercase;\n      font-size: 11px;\n      color: #333;\n      line-height: 24px;\n      font-weight: 500;\n      border-bottom: 4px solid #666; }\n      .task-list .board header.todo {\n        border-bottom-color: #b70000; }\n      .task-list .board header.in_progress {\n        border-bottom-color: #cc7800; }\n      .task-list .board header.done {\n        border-bottom-color: #288001; }\n    .task-list .board .card-list > li {\n      margin-top: 5px;\n      background: #fff;\n      padding: 5px;\n      min-height: 24px;\n      position: relative !important;\n      height: auto !important; }\n      .task-list .board .card-list > li .title {\n        padding: 0 10px;\n        font-size: 13px;\n        line-height: 20px;\n        max-height: 40px;\n        overflow: hidden;\n        color: #333;\n        min-height: 24px;\n        white-space: nowrap;\n        text-overflow: ellipsis; }\n      .task-list .board .card-list > li:hover .title {\n        padding: 0 45px 0 10px; }\n      .task-list .board .card-list > li .action .item-field a {\n        padding: 0 10px;\n        line-height: 40px; }\n\n.workspace-tasks .preview-pane .action-menu {\n  width: 94px !important; }\n  .workspace-tasks .preview-pane .action-menu .change {\n    border: 0;\n    background: 0;\n    padding: 14px;\n    float: left; }\n\n.workspace-tasks .preview-pane header p {\n  line-height: 48px;\n  color: #999;\n  max-width: 345px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.workspace-tasks .preview-pane .content {\n  padding: 20px; }\n\n.workspace-tasks .preview-pane textarea {\n  height: 32px;\n  border-color: #ddd !important; }\n  .workspace-tasks .preview-pane textarea:focus {\n    border-color: #ddd !important;\n    box-shadow: none !important; }\n\n.workspace-tasks .preview-pane .title {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #444;\n  margin: 0 0 15px 0; }\n\n.workspace-tasks .preview-pane .description {\n  font-size: 14px;\n  margin-bottom: 15px;\n  line-height: 22px;\n  color: #444; }\n\n.workspace-tasks .preview-pane .assignee-container {\n  background: #eee;\n  padding: 10px;\n  border-radius: 3px;\n  margin-bottom: 10px;\n  *zoom: 1; }\n  .workspace-tasks .preview-pane .assignee-container:before, .workspace-tasks .preview-pane .assignee-container:after {\n    display: table;\n    content: \"\"; }\n  .workspace-tasks .preview-pane .assignee-container:after {\n    clear: both; }\n  .workspace-tasks .preview-pane .assignee-container .avatar {\n    margin-right: 10px; }\n  .workspace-tasks .preview-pane .assignee-container .assignee-name {\n    margin: 0;\n    line-height: 30px;\n    float: left; }\n\n.workspace-tasks .preview-pane .assignee-box {\n  margin-bottom: 10px; }\n\n.workspace-tasks .preview-pane .task-labels {\n  margin-top: 0;\n  margin-bottom: 15px; }\n  .workspace-tasks .preview-pane .task-labels .icon-desk-time {\n    vertical-align: middle; }\n\n.workspace-tasks .preview-pane .time-edit {\n  margin-top: 5px;\n  margin-bottom: 10px;\n  *zoom: 1; }\n  .workspace-tasks .preview-pane .time-edit:before, .workspace-tasks .preview-pane .time-edit:after {\n    display: table;\n    content: \"\"; }\n  .workspace-tasks .preview-pane .time-edit:after {\n    clear: both; }\n  .workspace-tasks .preview-pane .time-edit .field {\n    float: left;\n    width: 50%;\n    box-sizing: border-box; }\n    .workspace-tasks .preview-pane .time-edit .field:first-child {\n      padding-right: 5px; }\n    .workspace-tasks .preview-pane .time-edit .field:last-child {\n      padding-left: 5px; }\n  .workspace-tasks .preview-pane .time-edit input {\n    box-sizing: border-box;\n    width: 100%; }\n\n.create-task-popup .modal-body textarea {\n  resize: none; }\n\n.create-task-popup .modal-body .title {\n  border: 0 !important;\n  border-bottom: 1px solid #e0e0e0 !important;\n  padding: 5px 20px;\n  font-weight: 400;\n  height: 40px;\n  font-size: 18px;\n  line-height: 28px; }\n  .create-task-popup .modal-body .title:focus {\n    box-shadow: none !important; }\n\n.create-task-popup .modal-body fieldset.full {\n  margin: -20px -20px 15px; }\n\n.create-task-popup .modal-body fieldset.due {\n  margin: -0 -15px;\n  position: relative; }\n  .create-task-popup .modal-body fieldset.due .break {\n    height: 1px;\n    background: #dcdcdc;\n    margin: 10px 15px 0; }\n  .create-task-popup .modal-body fieldset.due label {\n    float: left;\n    background: #f8f8f8;\n    padding: 0 10px 0 0;\n    margin: -10px 15px 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n    color: #666;\n    font-weight: 500; }\n  .create-task-popup .modal-body fieldset.due .field {\n    width: 50%;\n    float: left;\n    box-sizing: border-box;\n    padding: 0 15px; }\n    .create-task-popup .modal-body fieldset.due .field.clear {\n      clear: left; }\n\n.create-task-popup .modal-body .description {\n  height: 28px;\n  padding: 5px;\n  border: 1px solid #dfdfdf !important;\n  margin-bottom: 15px; }\n  .create-task-popup .modal-body .description:focus {\n    border-color: #ccc !important; }\n\n.create-task-popup .modal-body .assignee-box {\n  margin-bottom: 15px; }\n\n.stages-list {\n  float: none;\n  margin-top: 3px; }\n\n.stage-label a, .stage-label button {\n  background: #fff;\n  border-color: #d7d7d7 !important;\n  color: #333 !important; }\n  .stage-label a:hover, .stage-label button:hover {\n    border-color: #505050 !important;\n    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3); }\n\n.stage-label.active a {\n  background: #505050 !important;\n  border-color: #505050 !important;\n  border-top: 0 !important;\n  color: #fff !important;\n  box-shadow: inset 0 2px 0px #373737 !important; }\n  .stage-label.active a:hover {\n    background: #505050 !important; }\n\n/*\n\n.add-comment-box {\n    width: 100%;\n    @include box-sizing(border-box);\n    background: $background-main;\n    border: 1px solid #e1e1e1;\n    padding: 10px;\n    @include border-radius(5px);\n    margin-bottom: 15px;\n    text-align: right;\n\n    textarea {\n        width: 100%;\n        min-width: 100%;\n        max-width: 100%;\n        min-height: 62px;\n        line-height: 20px;\n        @include box-sizing(border-box);\n        @include border-radius(3px);\n        padding: 10px;\n        border-color: #adadad;\n        @include box-shadow(0px 1px 0px 0px #fff);\n        @include box-shadow(inset 0px 3px 6px -3px #a8a8a8);\n        font-size: 14px;\n        color: #444;\n        text-align: left;\n    }\n\n    .btn {\n        margin-left: 5px;\n        margin-top: 10px;\n        display: none;\n    }\n\n    &.focused {\n        .btn {\n            display: inline-block;\n        }\n    }\n\n}\n\n.comment-list {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    li {\n        padding-bottom: 15px;\n        margin-bottom: 8px;\n        position: relative;\n        .comment-info {\n            figure {\n                border: 1px solid #b9b9b9;\n                float: left;\n                margin-right: 10px;\n                    img {\n                        width: 30px;\n                        height: 30px;\n                    }\n            }\n            b {\n                font-size: 12px;\n                display: block;\n                line-height: 14px;\n                color: #007fb3;\n            }\n            time {\n                font-size: 11px;\n                color: #aeaeae;\n\n            }\n        }\n        .comment-text {\n            font-size: 13px;\n            color: #303030;\n            line-height: 18px;\n            border-top: 1px solid #ddd;\n            padding-top: 5px;\n            margin: 10px 0 3px 42px;\n            position: relative;\n            &:before {\n                content: \" \";\n                width: 9px;\n                height: 9px;\n                position: absolute;\n                background: url(~images/comment-ballon.png) no-repeat 0 0;\n                top: -9px;\n                left:15px;\n            }\n        }\n        .action-menu {\n            @include generic-inline-action-menu();\n        }\n        &:hover {\n            .action-menu {\n                display: block;\n            }\n        }\n    }\n\n}\n\n*/\n", ""]);

// exports


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
__webpack_require__(1429);
var d3_1 = __importDefault(__webpack_require__(550));
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.dashboard.world-clock', [
    'superdesk.apps.dashboard', 'superdesk.core.datetime',
])
    .directive('sdWorldclock', [function () {
        return {
            templateUrl: 'scripts/apps/dashboard/world-clock/worldClock.html',
            replace: true,
            restrict: 'A',
            controller: 'WorldClockController',
        };
    }])
    /**
     * @ngdoc controller
     * @module superdesk.apps.dashboard
     * @name WorldClockConfigController
     * @description
     *   Controller for the world clock widget configuration modal.
     */
    .controller('WorldClockConfigController', ['$scope', 'notify', 'tzdata',
    function ($scope, notify, tzdata) {
        $scope.availableZones = [];
        tzdata.$promise.then(function () {
            $scope.availableZones = tzdata.getTzNames();
        });
        $scope.notify = function (action, zone) {
            if (action === 'add') {
                notify.success(utils_1.gettext('World clock added: {{zone}}', { zone: zone }), 3000);
            }
            else if (action === 'remove') {
                notify.success(utils_1.gettext('World clock removed: {{zone}}', { zone: zone }), 3000);
            }
        };
        $scope.notIn = function (haystack) {
            return function (needle) {
                return haystack.indexOf(needle) === -1;
            };
        };
        $scope.configuration.zones = $scope.configuration.zones || [];
    }])
    /**
     * @ngdoc controller
     * @module superdesk.apps.dashboard
     * @name WorldClockController
     * @description
     *   Controller for the sdWorldclock directive - the one that creates
     *   a dashboard widget for displaying the current time in different
     *   time zones around the world.
     */
    .controller('WorldClockController', ['$scope', '$interval', 'tzdata', 'moment',
    function ($scope, $interval, tzdata, moment) {
        var interval, INTERVAL_DELAY = 500;
        function updateUTC() {
            $scope.utc = moment();
            $scope.$digest();
        }
        // XXX: a hack-ish workaround to expose the object loaded via
        // RequireJS to the testing code which does not use the latter
        this._moment = moment;
        tzdata.$promise.then(function () {
            moment.tz.add(lodash_1.default.pick(tzdata, ['zones', 'links']));
        });
        interval = $interval(updateUTC, INTERVAL_DELAY, 0, false);
        $scope.$on('$destroy', function stopTimeout() {
            $interval.cancel(interval);
        });
    }])
    /**
     * sdClock analog clock
     */
    .directive('sdClock', function () {
    var pi = Math.PI, scales = {
        s: d3_1.default.scale
            .linear()
            .domain([0, 59 + 999 / 1000])
            .range([0, 2 * pi]),
        m: d3_1.default.scale
            .linear()
            .domain([0, 59 + 59 / 60])
            .range([0, 2 * pi]),
        h: d3_1.default.scale
            .linear()
            .domain([0, 11 + 59 / 60])
            .range([0, 2 * pi]),
    };
    return {
        scope: {
            utc: '=',
            tz: '@',
        },
        link: function (scope, element, attrs) {
            var width = 105, height = 100, r = Math.min(width, height) * 0.8 * 0.5, dayBg = '#d8d8d8', dayClockhands = '#313131', dayNumbers = '#a0a0a0', nightBg = '#313131', nightClockhands = '#e0e0e0', nightNumbers = '#848484';
            var svg = d3_1.default.select(element[0])
                .append('svg')
                .attr('widgth', width)
                .attr('height', height);
            var clock = svg.append('g')
                .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
            // background circle
            clock.append('circle')
                .attr('r', r)
                .attr('class', 'clock-outer')
                .style('stroke-width', 1.5);
            // inner dot
            clock.append('circle')
                .attr('r', 1.5)
                .attr('class', 'clock-inner');
            // numbers
            clock.selectAll('.number-lines')
                .data(lodash_1.default.range(0, 59, 5))
                .enter()
                .append('path')
                .attr('d', function (d) {
                var angle = scales.m(d);
                var arc = d3_1.default.svg.arc()
                    .innerRadius(r * 0.7)
                    .outerRadius(r * 0.9)
                    .startAngle(angle)
                    .endAngle(angle);
                return arc();
            })
                .attr('class', 'number-lines')
                .style('stroke-width', 1.5);
            // format data for given time
            function getData(timeStr) {
                var time = timeStr.split(':');
                return [
                    { unit: 'h', val: parseInt(time[0], 10) + parseInt(time[1], 10) / 60, r: 0.5 },
                    { unit: 'm', val: parseInt(time[1], 10), r: 0.8 },
                ];
            }
            scope.$watch('utc', function (utc) {
                var time = utc ? utc.tz(scope.tz).format('HH:mm:ss') : '00:00:00';
                var data = getData(time);
                var isDay = data[0].val >= 8 && data[0].val < 20;
                if (isDay) {
                    clock.selectAll('.clock-outer').style('fill', dayBg);
                    clock.selectAll('.clock-inner').style('fill', dayBg);
                    clock.selectAll('.number-lines').style('stroke', dayNumbers);
                }
                else {
                    clock.selectAll('.clock-outer').style('fill', nightBg);
                    clock.selectAll('.clock-inner').style('fill', nightBg);
                    clock.selectAll('.number-lines').style('stroke', nightNumbers);
                }
                clock.selectAll('.clockhand').remove();
                clock.selectAll('.clockhand')
                    .data(data)
                    .enter()
                    .append('path')
                    .attr('d', function (d) {
                    var angle = scales[d.unit](d.val);
                    var arc = d3_1.default.svg.arc()
                        .innerRadius(r * 0)
                        .outerRadius(r * d.r)
                        .startAngle(angle)
                        .endAngle(angle);
                    return arc();
                })
                    .attr('class', 'clockhand')
                    .style('stroke-width', 2)
                    .style('stroke', isDay ? dayClockhands : nightClockhands);
            });
        },
    };
})
    .config(['dashboardWidgetsProvider', function (dashboardWidgets) {
        dashboardWidgets.addWidget('world-clock', {
            label: utils_1.gettext('World Clock'),
            multiple: true,
            icon: 'time',
            max_sizex: 2,
            max_sizey: 1,
            sizex: 1,
            sizey: 1,
            classes: 'tabs modal--nested-fix',
            thumbnail: 'scripts/apps/dashboard/world-clock/thumbnail.svg',
            template: 'scripts/apps/dashboard/world-clock/widget-worldclock.html',
            configurationTemplate: 'scripts/apps/dashboard/world-clock/configuration.html',
            configuration: { zones: ['Europe/London', 'Asia/Tokyo', 'Europe/Moscow'] },
            description: utils_1.gettext('World clock widget'),
        });
    }]);


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1430);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./world-clock.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./world-clock.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.world-clock .widget-content .clock-container {\n  height: 185px;\n  overflow: hidden; }\n  .world-clock .widget-content .clock-container > div:first-child .clock-box:first-child {\n    border-left: 0 !important; }\n\n.world-clock .widget-content .clock-box {\n  min-height: 185px;\n  box-sizing: border-box;\n  border-left: 1px solid #e7e7e7;\n  width: 106px;\n  text-align: center;\n  float: left; }\n  .world-clock .widget-content .clock-box header {\n    color: #686868;\n    font-size: 12px;\n    text-transform: uppercase;\n    padding: 10px 0px; }\n  .world-clock .widget-content .clock-box .wclock {\n    width: 100%;\n    height: 87px;\n    text-align: center; }\n  .world-clock .widget-content .clock-box time {\n    display: block;\n    font-size: 12px;\n    color: #555;\n    margin-top: 10px; }\n  .world-clock .widget-content .clock-box .date {\n    display: block;\n    color: #a8a8a8;\n    font-size: 11px; }\n  .world-clock .widget-content .clock-box.digital {\n    background-color: #313134;\n    color: #fff; }\n    .world-clock .widget-content .clock-box.digital header {\n      color: #fff; }\n    .world-clock .widget-content .clock-box.digital time {\n      padding-top: 27px;\n      margin-bottom: 15px;\n      font-size: 34px;\n      height: 45px;\n      vertical-align: middle;\n      color: #69e005; }\n\n.world-clock.widget-config .nav-tabs {\n  border-bottom: 1px solid #dedede; }\n\n.world-clock.widget-config .tab-content {\n  padding: 20px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 48px;\n  margin: 0;\n  padding: 20px;\n  display: block;\n  width: auto; }\n\n.world-clock.widget-config .list-group {\n  max-width: 100%;\n  max-height: 280px;\n  overflow: auto; }\n  .world-clock.widget-config .list-group::-webkit-scrollbar {\n    width: 10px;\n    border-left: 3px solid #fff; }\n  .world-clock.widget-config .list-group::-webkit-scrollbar-thumb {\n    border-radius: 2px;\n    border-left: 3px solid #fff;\n    background: #aaa; }\n", ""]);

// exports


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

angular.module('superdesk.apps.dashboard.grid', [])
    /**
     * sdGrid is directive which add functionality of dashboard. It is possible
     * to add, remove, move, edit, resize widgets within dashboard. It is working with gridster.js
     * library to enable all of this.
     *
     * Usage:
     * <div sd-grid
     *  class="gridster"
     *  ng-class="{editmode: widgetBoxStatus}"
     *  data-status="widgetBoxStatus"
     *  data-widgets="widgets"></div>
     *
     * Params:
     * @scope {Boolean} status - on/off switch for widget
     * @scope {List} widgets
     * @scope {Object} dashboard
     */
    .directive('sdGrid', function () { return ({
    scope: {
        status: '=',
        widgets: '=',
        save: '&',
        configurable: '=',
    },
    templateUrl: 'scripts/apps/dashboard/grid/views/grid.html',
    controller: ['$scope', function GridController($scope) {
            this.addWidget = function (widget, element) {
                widget.active = true;
                widget.el = $scope.gridster.add_widget(element, widget.sizex, widget.sizey, widget.col, widget.row);
            };
            this.removeWidget = function (widget, element) {
                $scope.gridster.remove_widget(element);
                widget.active = false;
                $scope.syncWidgets();
            };
            this.resizeWidget = function (element, sizex, sizey) {
                $scope.gridster.resize_widget(element, sizex, sizey);
                $scope.syncWidgets();
            };
        }],
    link: function (scope, element, attrs) {
        scope.syncWidgets = function () {
            angular.forEach(scope.widgets, function (widget) {
                if (widget.active) {
                    var sizes = scope.gridster.serialize(widget.el);
                    angular.extend(widget, {
                        row: sizes[0].row,
                        col: sizes[0].col,
                        sizex: sizes[0].size_x,
                        sizey: sizes[0].size_y,
                    });
                }
            });
        };
        var root = element.find('ul');
        scope.gridster = root.gridster({
            widget_margins: [20, 20],
            widget_base_dimensions: [320, 250],
            min_rows: 3,
            min_cols: 3,
            draggable: {
                stop: function (e, ui, $widget) {
                    scope.syncWidgets();
                },
            },
        }).data('gridster');
        scope.$watch('status', function (status) {
            if (scope.gridster) {
                if (status === true) {
                    scope.gridster.enable();
                }
                else {
                    scope.gridster.disable();
                }
            }
        });
        scope.$on('$destroy', function () {
            scope.gridster.remove_all_widgets();
            scope.gridster.destroy();
            scope.gridster = null;
        });
    },
}); })
    /**
     * sdGridItem is a widget wrapper. Adds resize/remove buttons.
     */
    .directive('sdGridItem', function () { return ({
    require: '^sdGrid',
    transclude: true,
    templateUrl: 'scripts/apps/dashboard/grid/views/grid-item.html',
    link: function (scope, element, attrs, sdGrid) {
        sdGrid.addWidget(scope.widget, element);
        scope.removeWidget = function () {
            sdGrid.removeWidget(scope.widget, element);
        };
        scope.resizeWidget = function (widget, direction) {
            switch (direction) {
                case 'left':
                    if (widget.sizex !== 1) {
                        widget.sizex--;
                    }
                    break;
                case 'right':
                    if (widget.sizex !== widget.max_sizex) {
                        widget.sizex++;
                    }
                    break;
                case 'up':
                    if (widget.sizey !== 1) {
                        widget.sizey--;
                    }
                    break;
                case 'down':
                    if (widget.sizey !== widget.max_sizey) {
                        widget.sizey++;
                    }
                    break;
            }
            sdGrid.resizeWidget(element, widget.sizex, widget.sizey);
        };
    },
}); });


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
__webpack_require__(1433);
RoutingWidgetController.$inject = ['desks', 'privileges', 'api', 'notify', '$scope'];
function RoutingWidgetController(desks, privileges, api, notify, $scope) {
    var _this = this;
    this.canManage = privileges.privileges.desk_routing;
    desks.initialize().then(function () {
        _this.desk = desks.getCurrentDesk();
        if (!_this.desk) { // only works in desk context
            return;
        }
        _this.desks = desks.desks._items.filter(function (desk) { return desk._id !== _this.desk._id; });
        _this.destination = _this.desk.closed_destination || null;
        _this.destinationName = _this.destination && _this.desks.find(function (desk) { return desk._id === _this.destination; }).name;
        _this.routedFrom = _this.desks.filter(function (desk) { return desk.closed_destination === _this.desk._id; });
    });
    var errorHandler = function (reason) {
        if (reason.status === 412) {
            notify.warning(utils_1.gettext('Desk status is outdated, please refresh.'));
        }
        else {
            console.error('unknown error', reason);
        }
    };
    var updateDesk = function (updates) {
        api.update('closed_desks', _this.desk, updates)
            .then(function (updated) {
            angular.extend(_this.desk, {
                _etag: updated._etag,
                is_closed: updated.is_closed,
                closed_destination: updated.closed_destination,
            });
        }, errorHandler);
    };
    this.toggle = function () {
        updateDesk({ is_closed: !_this.desk.is_closed });
    };
    this.updateDestination = function () {
        updateDesk({ closed_destination: _this.destination });
    };
    // update desk closed status
    $scope.$on('desks:closed', function (event, extra) {
        // update open/close status for routedFrom
        _this.routedFrom.forEach(function (desk) {
            if (desk._id === extra._id) {
                angular.extend(desk, { is_closed: extra.is_closed });
            }
        });
        // update open/close status for current desk
        if (extra._id === _this.desk._id) {
            angular.extend(_this.desk, extra);
        }
        // re-render
        $scope.$apply();
    });
}
TopMenuInfoDirective.$inject = ['desks', '$timeout'];
function TopMenuInfoDirective(desks, $timeout) {
    return {
        template: __webpack_require__(1435),
        link: function (scope) {
            var setup = lodash_1.debounce(function () {
                var desk = desks.getCurrentDesk();
                var selected = document.getElementById('selected-desk');
                if (selected) {
                    selected.classList.remove('desk--closed');
                }
                scope.routingFrom = scope.routingTo = null;
                if (!desk) {
                    return;
                }
                scope.$applyAsync(function () {
                    if (desk.is_closed) {
                        scope.routingTo = lodash_1.get(desks.deskLookup[desk.closed_destination], 'name', '');
                        if (selected) {
                            selected.classList.add('desk--closed');
                        }
                    }
                    else {
                        scope.routingFrom = getRoutingFrom(desk);
                    }
                });
                // it can only run when dropdown is rendered
                $timeout(setDeskItemDropdownStatus, 500, false);
            }, 200);
            function getRoutingFrom(desk) {
                return desks.desks._items
                    .filter(function (d) { return d.closed_destination === desk._id && d.is_closed; })
                    .map(function (d) { return d.name; })
                    .join(', ');
            }
            function setDeskItemDropdownStatus() {
                desks.desks._items.forEach(function (d) {
                    var btn = document.getElementById('desk-item-' + d._id);
                    if (!btn) { // user is not a member
                        return;
                    }
                    btn.classList.remove('desk-item--closed', 'desk-item--receiving');
                    if (d.is_closed) {
                        btn.classList.add('desk-item--closed');
                    }
                    else if (getRoutingFrom(d)) {
                        btn.classList.add('desk-item--receiving');
                    }
                });
            }
            desks.initialize().then(function () {
                scope.$watch(desks.getCurrentDeskId.bind(desks), setup);
                scope.$on('desks:closed', function (event, extra) {
                    desks.fetchDeskById(extra._id).then(function (desk) {
                        desks.desks._items = desks.desks._items
                            .map(function (d) { return d._id === desk._id ? angular.extend(d, desk) : d; });
                        desks.deskLookup[desk._id] = desk;
                        scope.$applyAsync(setup);
                    });
                });
                scope.$on('$routeChangeSuccess', setup);
            });
        },
    };
}
exports.default = angular.module('superdesk.apps.dashboard.closed-desk', [])
    .controller('RoutingWidgetController', RoutingWidgetController)
    .directive('sdTopMenuInfoPlaceholder', TopMenuInfoDirective)
    .config(['dashboardWidgetsProvider', function (dashboardWidgets) {
        dashboardWidgets.addWidget('close-desk', {
            label: utils_1.gettext('Desk Router'),
            icon: 'switches',
            max_sizex: 1,
            max_sizey: 2,
            sizex: 1,
            sizey: 1,
            template: 'scripts/apps/dashboard/closed-desk/views/close-desk-widget.html',
            description: utils_1.gettext('Close desk widget'),
            thumbnail: __webpack_require__(1436),
        });
    }]);


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1434);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".close-desk-widget-content {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  bottom: 8px;\n  left: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: auto; }\n  .close-desk-widget-content .space-eater {\n    flex-grow: 1; }\n  .close-desk-widget-content .simple-list {\n    padding: 0; }\n\n.widget-list li.widget.close-desk .thumbnail {\n  background-color: #e55028; }\n\n.widget-detail .thumbnail-box.close-desk {\n  background-color: #e55028; }\n", ""]);

// exports


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

module.exports = "<div class=\"top-menu__info\" ng-show=\"routingTo || routingFrom\">\n    <i class=\"top-menu__info-icon\" ng-class=\"{\n        'top-menu__info-icon--green': routingFrom,\n        'icon-download': routingFrom,\n        'top-menu__info-icon--red': routingTo,\n        'icon-upload': routingTo,\n}\"></i>\n\n    <span class=\"top-menu__info-label\" ng-show=\"routingFrom\" translate>Routed from:</span>\n    <span class=\"top-menu__info-text\" ng-show=\"routingFrom\">{{ routingFrom }}</span>\n\n    <span class=\"top-menu__info-label\" ng-show=\"routingTo\" translate>Routing to:</span>\n    <span class=\"top-menu__info-text\" ng-show=\"routingTo\">{{ routingTo }}</span>\n</div>";

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a0c6c4208a68a2061698f951448c8320.svg";

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
ConfigController.$inject = ['$scope'];
function ConfigController($scope) {
    $scope.configuration = lodash_1.cloneDeep($scope.widget.configuration);
    $scope.saveConfig = function () {
        $scope.widget.configuration = $scope.configuration;
        $scope.save();
        $scope.$close();
    };
}
exports.ConfigController = ConfigController;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DashboardController.$inject = ['$scope', 'desks', 'dashboardWidgets', 'api', 'session', 'workspaces',
    'modal', 'privileges', 'pageTitle'];
function DashboardController($scope, desks, dashboardWidgets, api, session, workspaces, modal, privileges, pageTitle) {
    var self = this;
    $scope.edited = null;
    $scope.workspaces = workspaces;
    $scope.$watch('workspaces.active', setupWorkspace);
    workspaces.getActive();
    pageTitle.setUrl(utils_1.gettext('Dashboard'));
    function setupWorkspace(workspace) {
        self.current = null;
        if (workspace) {
            // is the user allowed to configure widgets on this desk?
            $scope.configurable = workspaces.isCustom() || privileges.userHasPrivileges({ desks: 1 });
            // do this async so that it can clean up previous grid
            $scope.$applyAsync(function () {
                self.current = workspace;
                self.widgets = extendWidgets(workspace.widgets || []);
                self.availableWidgets = dashboardWidgets;
            });
        }
    }
    /**
     * Return the list of available widgets that can be added
     * to current dashboard
     *
     * @return {promise} list of widgets
     */
    function getAvailableWidgets(userWidgets) {
        return lodash_1.default.filter(dashboardWidgets, function (widget) { return widget.multiple || lodash_1.default.isNil(lodash_1.default.find(userWidgets, { _id: widget._id })); });
    }
    /**
     * Add widgets to current dashboard
     *
     * @param {object} widget
     */
    this.addWidget = function (widget) {
        var w = widget;
        if (widget.multiple) {
            w = angular.copy(widget);
            w.multiple_id = 0;
            angular.forEach(this.widgets, function (item) {
                if (item._id === w._id && item.multiple_id >= w.multiple_id) {
                    w.multiple_id = item.multiple_id + 1;
                }
            });
        }
        w.active = true;
        this.widgets.push(w);
        this.selectWidget();
        this.save();
    };
    /*
     * If widget is not selected, opens single view of specific widget
     * @param {object} widget
     */
    this.selectWidget = function (widget) {
        if (!this.isSelected(widget)) {
            this.selectedWidget = widget || null;
        }
    };
    /*
     * Checks if widget is already selected
     * @param {object} widget
     * @returns {boolean}
     */
    this.isSelected = function (widget) {
        return widget && !lodash_1.default.find(getAvailableWidgets(this.widgets), widget);
    };
    function extendWidgets(currentWidgets) {
        return lodash_1.default.map(currentWidgets, function (widget) {
            var original = lodash_1.default.find(dashboardWidgets, { _id: widget._id });
            return angular.extend({}, original, widget);
        });
    }
    /**
     * Prepare the widget to be saved. Filter any non-required data.
     *
     * @return {promise} widget
     */
    function pickWidgets(widgets) {
        return lodash_1.default.map(widgets, function (widget) {
            return lodash_1.default.pick(widget, [
                '_id',
                'configuration',
                'sizex',
                'sizey',
                'col',
                'row',
                'active',
                'multiple_id',
            ]);
        });
    }
    /*
     * Saves current workspace
     */
    this.save = function () {
        this.edit = false;
        var diff = angular.extend({}, this.current);
        this.widgets = lodash_1.default.filter(this.widgets, { active: true });
        diff.widgets = pickWidgets(this.widgets);
        api.save('workspaces', this.current, diff);
    };
    /*
     * Confirms and deletes current workspace
     */
    this.delete = function () {
        modal.confirm(utils_1.gettext('Are you sure you want to delete current workspace?'))
            .then(function () { return workspaces.delete(self.current); });
    };
    /*
     * Enables editing current workspace
     */
    this.rename = function () {
        $scope.edited = angular.copy(self.current);
    };
    /*
     * Updates workspaces after editing
     */
    this.afterRename = function () {
        workspaces.getActive();
    };
}
exports.DashboardController = DashboardController;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = __webpack_require__(1440);
exports.Widget = Widget_1.Widget;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(551);
Widget.$inject = ['asset', '$modal'];
/**
 * sdWidget give appropriate template to data assgined to it
 *
 * Usage:
 * <div sd-widget data-widget="widget"></div>
 *
 * Params:
 * @scope {Object} widget
 */
function Widget(asset, $modal) {
    return {
        templateUrl: asset.templateUrl('apps/dashboard/views/widget.html'),
        restrict: 'A',
        replace: true,
        transclude: true,
        scope: { widget: '=', save: '&', configurable: '=' },
        link: function (scope, element, attrs) {
            scope.openConfiguration = function () {
                $modal.open({
                    templateUrl: 'scripts/apps/dashboard/views/configuration.html',
                    controller: controllers_1.ConfigController,
                    scope: scope,
                    size: scope.widget.classes,
                });
            };
        },
    };
}
exports.Widget = Widget;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardWidgets_1 = __webpack_require__(1442);
exports.DashboardWidgets = DashboardWidgets_1.DashboardWidgets;
var BaseWidgetFactory_1 = __webpack_require__(1443);
exports.BaseWidgetFactory = BaseWidgetFactory_1.BaseWidgetFactory;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
function DashboardWidgets() {
    var privateWidgets = {};
    this.addWidget = function (id, widget, debug) {
        privateWidgets[id] = lodash_1.default.extend({ _id: id }, widget);
    };
    this.$get = function () {
        return lodash_1.default.values(privateWidgets);
    };
}
exports.DashboardWidgets = DashboardWidgets;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function BaseWidgetFactory() {
    return function BaseWidgetController($scope) {
        $scope.options = $scope.options || {};
        $scope.itemListOptions = $scope.itemListOptions || {};
        $scope.actions = $scope.actions || {};
        $scope.$watch('widget.configuration', function (config) {
            if (config) {
                $scope.itemListOptions.savedSearch = config.savedSearch;
                $scope.itemListOptions.pageSize = config.maxItems;
            }
        }, true);
        if ($scope.item) {
            $scope.options.item = $scope.item;
        }
    };
}
exports.BaseWidgetFactory = BaseWidgetFactory;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
// styles
__webpack_require__(1445);
__webpack_require__(1447);
__webpack_require__(1449);
__webpack_require__(1451);
__webpack_require__(1453);
__webpack_require__(1454);
var RolesService_1 = __importDefault(__webpack_require__(1455));
var controllers_1 = __webpack_require__(553);
var svc = __importStar(__webpack_require__(1463));
var directive = __importStar(__webpack_require__(1468));
var config = __importStar(__webpack_require__(1488));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.users
 * @name superdesk.apps.users
 * @packageName superdesk.apps
 * @description Superdesk user roles, privileges and profiles module.
 */
exports.default = angular.module('superdesk.apps.users', [
    'superdesk.core.activity',
    'superdesk.core.services.asset',
])
    .controller('UserEditController', controllers_1.UserEditController) // make it available to user.profile
    .service('usersService', svc.UsersService)
    .service('roles', RolesService_1.default)
    .factory('userList', svc.UserListService)
    .factory('userPopup', svc.UserPopupService)
    .directive('sdUserRoles', directive.UserRolesDirective)
    .directive('sdRolesPrivileges', directive.RolesPrivilegesDirective)
    .directive('sdInfoItem', directive.InfoItemDirective)
    .directive('sdValidError', directive.ValidErrorDirective)
    .directive('sdValidInfo', directive.ValidInfoDirective)
    .directive('sdUserDetailsPane', directive.UserDetailsPaneDirective)
    .directive('sdUserEdit', directive.UserEditDirective)
    .directive('sdUserPreferences', directive.UserPreferencesDirective)
    .directive('sdUserPrivileges', directive.UserPrivilegesDirective)
    .directive('sdChangePassword', directive.ChangePasswordDirective)
    .directive('sdResetPassword', directive.ResetPasswordDirective)
    .directive('sdUserUnique', directive.UserUniqueDirective)
    .directive('sdPasswordConfirm', directive.PasswordConfirmDirective)
    .directive('sdUserList', directive.UserListDirective)
    .directive('sdUserListItem', directive.UserListItemDirective)
    .directive('sdActivity', directive.ActivityDirective)
    .directive('sdUserMentio', directive.UserMentioDirective)
    .directive('sdUserInfo', directive.UserInfoDirective)
    .filter('username', function () { return function (user) { return user ?
    user.display_name || user.username : null; }; })
    .config(config.Permissions)
    .config(config.Activities)
    .config(config.API)
    .config(['$compileProvider', function ($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', ['$compile', function ($compile) {
                // directive factory creates a link function
                return function (scope, element, attrs) {
                    var value = scope.$eval(attrs.compile);
                    element.html(value);
                    var nscope = scope.$new(true);
                    lodash_1.default.each(scope.$eval(attrs.data), function (val, key) {
                        nscope[key] = val;
                    });
                    $compile(element.contents())(nscope);
                };
            }]);
    }])
    .run(config.KeyboardShortcuts);
angular.module('superdesk.apps.users.profile', ['superdesk.core.api', 'superdesk.apps.users'])
    .directive('sdUserActivity', directive.UserActivityDirective)
    .service('profileService', svc.ProfileService)
    .config(['superdeskProvider', 'assetProvider', function (superdeskProvider, asset) {
        superdeskProvider.activity('/profile/', {
            label: utils_1.gettext('My Profile'),
            controller: controllers_1.UserEditController,
            templateUrl: asset.templateUrl('apps/users/views/edit.html'),
            resolve: {
                user: ['session', 'api', function (session, api) {
                        return session.getIdentity().then(function (identity) { return api.get(identity._links.self.href); });
                    }],
            },
        });
    }]);


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1446);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widget-activity.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widget-activity.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.activity .activity-holder {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-color: #fafafa; }\n  .sd-widget.activity .activity-holder .shadow-list-holder {\n    padding: 0 10px; }\n\n.sd-widget.activity .activity-log li.with-date {\n  margin-top: 25px; }\n  .sd-widget.activity .activity-log li.with-date .date {\n    border-top: 0;\n    top: -15px; }\n    .sd-widget.activity .activity-log li.with-date .date span {\n      float: none;\n      padding: 3px 5px;\n      color: #333;\n      text-transform: uppercase;\n      font-size: 11px;\n      font-weight: 500; }\n\n.sd-widget.activity .activity-log li:hover {\n  box-shadow: none; }\n\n.sd-widget.activity .activity-load-more {\n  margin: 14px 0 12px; }\n\n.sd-widget.activity .activity-log ul li.activity .activity-content p {\n  font-weight: 300;\n  font-size: 12px; }\n  .sd-widget.activity .activity-log ul li.activity .activity-content p b {\n    font-weight: 600; }\n", ""]);

// exports


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1448);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./change-avatar.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./change-avatar.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.upload-avatar .modal-content {\n  flex: 0 0 750px !important; }\n\n.upload-avatar .main .computer .info {\n  font-size: 12px;\n  color: #5ea9c8;\n  padding: 10px;\n  text-align: center; }\n\n.upload-avatar .remove-avatar {\n  cursor: pointer; }\n", ""]);

// exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1450);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.user-roles-settings .new-role-modal {\n  width: 299px;\n  position: absolute;\n  top: 0;\n  left: 50%;\n  margin-left: -150px; }\n  .user-roles-settings .new-role-modal .content .field {\n    margin-bottom: 10px; }\n    .user-roles-settings .new-role-modal .content .field textarea {\n      height: 22px; }\n\n.user-roles-settings .label.default {\n  font-size: 9px;\n  font-weight: 600;\n  padding: 2px 5px;\n  line-height: 12px;\n  margin-left: 5px;\n  text-transform: uppercase; }\n\n.privileges-settings {\n  overflow: auto !important; }\n  .privileges-settings thead tr {\n    background: #f2f2f2; }\n    .privileges-settings thead tr .label {\n      position: absolute;\n      top: -6px;\n      left: 17%;\n      text-transform: uppercase;\n      font-weight: normal;\n      font-size: 9px;\n      line-height: 10px;\n      height: 13px;\n      letter-spacing: 0.1em;\n      box-sizing: border-box; }\n    .privileges-settings thead tr th {\n      position: relative;\n      font-size: 13px;\n      font-weight: normal;\n      word-wrap: break-word;\n      text-align: center;\n      border: 1px solid #f0f0f0 !important;\n      border-right: 0 !important;\n      border-color: #e5e5e5 !important;\n      padding: 10px 16px; }\n    .privileges-settings thead tr .name {\n      min-width: 270px; }\n  .privileges-settings td {\n    padding: 10px 16px;\n    border-bottom: 1px solid #f0f0f0;\n    border-left: 1px solid #f0f0f0;\n    border-top: 0;\n    text-align: center;\n    word-wrap: break-word;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none; }\n  .privileges-settings .name {\n    min-width: 270px;\n    font-size: 11px;\n    text-align: left;\n    border-left: 0 !important;\n    padding: 10px;\n    text-transform: uppercase;\n    font-weight: 500;\n    max-width: 270px;\n    color: #666; }\n  .privileges-settings .role-field {\n    min-width: 90px; }\n", ""]);

// exports


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1452);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./users.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./users.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.users .users-subnav .multiple-action {\n  margin-left: 30px;\n  float: left; }\n\n.disabled-label {\n  background: #c8a1a8;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n  height: 13px;\n  line-height: 13px;\n  padding: 0 8px;\n  border-radius: 2px;\n  margin-left: 10px; }\n\n.admin-label {\n  background-color: #fff;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  box-shadow: 0 0 0 1px #fff; }\n\n.users-table {\n  border-top: 2px solid #d7d7d7; }\n  .users-table .table-header {\n    background: #fff; }\n  .users-table .table-title {\n    height: 30px;\n    font-size: 11px;\n    color: #8a8a8a;\n    line-height: 30px;\n    font-weight: 300;\n    text-transform: uppercase; }\n  .users-table .table-newest {\n    margin: 0 0 30px;\n    background: #fafdf6;\n    border-top: 1px solid #d7d7d7; }\n  .users-table .table-body {\n    margin-top: -1px; }\n  .users-table .table-body {\n    background: #fff;\n    border-top: 1px solid #d7d7d7; }\n  .users-table .table-header > li, .users-table .table-newest > li, .users-table .table-body > li {\n    height: 40px;\n    border-bottom: 1px solid #ebebeb;\n    position: relative; }\n    .users-table .table-header > li .avatar, .users-table .table-newest > li .avatar, .users-table .table-body > li .avatar {\n      margin: 5px 5px 5px 8px; }\n    .users-table .table-header > li > div:not(.tooltip), .users-table .table-newest > li > div:not(.tooltip), .users-table .table-body > li > div:not(.tooltip) {\n      float: left;\n      height: 30px;\n      padding: 5px;\n      line-height: 30px; }\n      .users-table .table-header > li > div:not(.tooltip).chckbx, .users-table .table-newest > li > div:not(.tooltip).chckbx, .users-table .table-body > li > div:not(.tooltip).chckbx {\n        width: 25px;\n        text-align: center; }\n        .users-table .table-header > li > div:not(.tooltip).chckbx span, .users-table .table-newest > li > div:not(.tooltip).chckbx span, .users-table .table-body > li > div:not(.tooltip).chckbx span {\n          vertical-align: middle;\n          margin: 0; }\n      .users-table .table-header > li > div:not(.tooltip).row-wrapper, .users-table .table-newest > li > div:not(.tooltip).row-wrapper, .users-table .table-body > li > div:not(.tooltip).row-wrapper {\n        position: absolute;\n        left: 60px;\n        right: 92px;\n        top: 5px;\n        padding: 0;\n        box-sizing: border-box; }\n        .users-table .table-header > li > div:not(.tooltip).row-wrapper > div, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div {\n          color: #333;\n          float: left;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          box-sizing: border-box;\n          padding: 0 5px;\n          height: 30px; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.name, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.name, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.name {\n            font-weight: 500; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.email, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.email, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.email {\n            color: #3599b6;\n            font-weight: 300; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.created, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.created, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.created {\n            font-size: 11px;\n            color: #999; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.name, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.name, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.name {\n            width: 28%; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.role, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.role, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.role {\n            width: 16%; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.username, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.username, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.username {\n            width: 14%; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.email, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.email, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.email {\n            width: 30%; }\n          .users-table .table-header > li > div:not(.tooltip).row-wrapper > div.created, .users-table .table-newest > li > div:not(.tooltip).row-wrapper > div.created, .users-table .table-body > li > div:not(.tooltip).row-wrapper > div.created {\n            width: 12%; }\n      .users-table .table-header > li > div:not(.tooltip).action, .users-table .table-newest > li > div:not(.tooltip).action, .users-table .table-body > li > div:not(.tooltip).action {\n        float: right;\n        width: 82px;\n        line-height: 18px !important; }\n    .users-table .table-header > li.inactive .row-wrapper > div, .users-table .table-newest > li.inactive .row-wrapper > div, .users-table .table-body > li.inactive .row-wrapper > div {\n      color: #cccccc; }\n      .users-table .table-header > li.inactive .row-wrapper > div.email, .users-table .table-newest > li.inactive .row-wrapper > div.email, .users-table .table-body > li.inactive .row-wrapper > div.email {\n        color: #a1d4e3; }\n  .users-table .table-header > li > div, .users-table .table-header .name, .users-table .table-header .email, .users-table .table-header .created {\n    color: #000 !important;\n    font-size: 13px !important;\n    font-weight: 500; }\n  .users-table .table-header .sortable i {\n    margin: -2px 0 0 5px; }\n  .users-table .table-header .sortable:hover {\n    cursor: pointer; }\n  .users-table .table-body > li.selected, .users-table .table-newest > li.selected {\n    background: #eff7fa; }\n  .users-table .table-body > li:hover, .users-table .table-newest > li:hover {\n    background: #f4f4f4;\n    cursor: pointer; }\n  .users-table .table-body > li > div.action, .users-table .table-newest > li > div.action {\n    padding: 0;\n    height: 40px; }\n    .users-table .table-body > li > div.action .item-functions, .users-table .table-newest > li > div.action .item-functions {\n      display: none; }\n      .users-table .table-body > li > div.action .item-functions li, .users-table .table-newest > li > div.action .item-functions li {\n        height: 40px;\n        width: 40px;\n        line-height: 40px;\n        text-align: center;\n        border-left: 1px solid #d8d8d8; }\n        .users-table .table-body > li > div.action .item-functions li span, .users-table .table-newest > li > div.action .item-functions li span {\n          display: none; }\n        .users-table .table-body > li > div.action .item-functions li:hover, .users-table .table-newest > li > div.action .item-functions li:hover {\n          background-color: #e8e8e8; }\n  .users-table .table-body > li:hover > div.action .item-functions, .users-table .table-newest > li:hover > div.action .item-functions {\n    display: block; }\n  .users-table .alert {\n    height: auto !important;\n    border-radius: 0px;\n    border-width: 0 0 1px; }\n    .users-table .alert.alert-info {\n      border-color: #bce8f1; }\n      .users-table .alert.alert-info:hover {\n        background: #d9edf7; }\n\n/*\n====================================================\n    User detail pane\n====================================================\n*/\n.user-details-pane {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  height: calc(100% - 48px); }\n  .user-details-pane .profile-info {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: auto; }\n  .user-details-pane .header-info {\n    background-color: rgba(94, 169, 200, 0.11);\n    padding: 20px 0 0; }\n    .user-details-pane .header-info h2 {\n      text-align: center;\n      font-size: 18px;\n      line-height: 20px;\n      margin: 10px 0 4px 0;\n      padding: 0 20px; }\n    .user-details-pane .header-info h5 {\n      text-align: center;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 16px;\n      padding: 0 20px;\n      margin-bottom: 10px;\n      color: rgba(0, 0, 0, 0.75); }\n    .user-details-pane .header-info .active {\n      position: absolute;\n      top: 20px;\n      right: 15px; }\n    .user-details-pane .header-info .user-roles {\n      list-style-type: none;\n      margin: 15px 0;\n      padding: 0; }\n      .user-details-pane .header-info .user-roles li {\n        display: inline-block;\n        border-radius: 3px;\n        padding: 2px 10px;\n        background: #b2b2b2;\n        color: #fff;\n        font-size: 11px;\n        margin-right: 3px; }\n  .user-details-pane .date-time {\n    color: #999;\n    font-weight: 300; }\n  .user-details-pane .details-info {\n    flex-grow: 1;\n    overflow: auto;\n    padding: 20px;\n    position: relative; }\n  .user-details-pane .error-holder {\n    height: 40px;\n    margin: 0 -20px; }\n    .user-details-pane .error-holder .alert {\n      padding: 10px 20px; }\n  .user-details-pane .validation-error {\n    color: #ab3434;\n    font-size: 12px;\n    margin-top: 5px;\n    margin-bottom: 0; }\n  .user-details-pane .validation-info {\n    font-size: 11px;\n    color: #888; }\n  .user-details-pane .profile-pic {\n    width: 82px;\n    height: 82px;\n    position: relative;\n    margin: 0 auto; }\n    .user-details-pane .profile-pic .avatar {\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      position: relative;\n      background-image: url(" + escape(__webpack_require__(552)) + "); }\n      .user-details-pane .profile-pic .avatar.initials {\n        font-size: 24px;\n        line-height: 82px;\n        font-weight: 300; }\n    .user-details-pane .profile-pic .change-photo {\n      display: none;\n      background-color: rgba(55, 152, 180, 0.6);\n      color: #fff;\n      text-transform: uppercase;\n      font-size: 9px;\n      line-height: 15px;\n      text-decoration: none;\n      text-align: center;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 30px;\n      letter-spacing: normal; }\n    .user-details-pane .profile-pic:hover .change-photo {\n      display: block; }\n    .user-details-pane .profile-pic .disabled-label {\n      position: absolute;\n      bottom: 15%;\n      left: 40%;\n      border: 1px solid #fff; }\n  .user-details-pane .alert {\n    border-radius: 0px; }\n  .user-details-pane .ng-invalid-required .required-info {\n    display: inline-block !important; }\n\n.modal.user-profile-page .modal__body {\n  height: calc(100vh - 180px);\n  border-radius: 0 0 4px 4px; }\n\n.modal.user-profile-page .user-details-pane {\n  position: static; }\n  .modal.user-profile-page .user-details-pane ::-webkit-scrollbar {\n    border-left: 9px solid #f8f8f8; }\n  .modal.user-profile-page .user-details-pane ::-webkit-scrollbar-thumb {\n    border-left: 8px solid #f8f8f8; }\n\n.modal.user-profile-page .details-info {\n  bottom: 58px; }\n\n.modal.user-profile-page .action-bar {\n  top: auto !important;\n  bottom: 0;\n  border-top: 1px solid #e4e4e4;\n  border-bottom: 0; }\n\n/*\n==============================================\nProfile page styles\n==============================================\n*/\n.user-profile-page .user-details-pane {\n  top: 0;\n  padding: 0;\n  height: 100%; }\n\n.profile-activity-container {\n  position: absolute;\n  left: 0px;\n  right: 0;\n  top: 0;\n  bottom: 20px;\n  padding: 10px 30px 0;\n  background-color: #f8f8f8;\n  overflow-x: hidden;\n  overflow-y: auto; }\n  .profile-activity-container::-webkit-scrollbar {\n    width: 10px;\n    border-left: 0; }\n  .profile-activity-container::-webkit-scrollbar-thumb {\n    border-right: 2px solid #f8f8f8;\n    border-left: 0; }\n  .profile-activity-container > .btn {\n    margin: 10px 0 20px; }\n  .profile-activity-container .profile-activity {\n    height: 100%;\n    box-sizing: border-box;\n    overflow: auto;\n    max-width: 500px; }\n    .profile-activity-container .profile-activity .activity-header {\n      height: 40px;\n      border-bottom: 1px solid #ddd; }\n      .profile-activity-container .profile-activity .activity-header h6 {\n        line-height: 40px;\n        font-weight: normal;\n        font-size: 20px;\n        color: #444;\n        text-transform: none; }\n    .profile-activity-container .profile-activity .group-date {\n      margin-top: 20px;\n      margin-bottom: 16px;\n      color: #888;\n      font-size: 11px;\n      font-weight: 500;\n      height: 1px;\n      border-top: 1px solid #ddd;\n      position: relative; }\n      .profile-activity-container .profile-activity .group-date .day {\n        position: relative;\n        top: -.9em;\n        display: inline-block;\n        background-color: #f8f8f8; }\n      .profile-activity-container .profile-activity .group-date .date {\n        padding-left: 4px;\n        padding-right: 4px;\n        text-transform: lowercase;\n        position: relative;\n        top: -.9em;\n        display: inline-block;\n        background-color: #f8f8f8; }\n    .profile-activity-container .profile-activity .activity-entry {\n      border-bottom: 1px solid #ddd;\n      background: #fff;\n      margin-top: 4px;\n      clear: left; }\n      .profile-activity-container .profile-activity .activity-entry .activity-figure {\n        float: left; }\n      .profile-activity-container .profile-activity .activity-entry .activity-date {\n        color: #888;\n        font-size: 11px;\n        font-weight: 500; }\n  .profile-activity-container ::-webkit-scrollbar {\n    border-left: 9px solid #f8f8f8;\n    border-right: 1px solid #f8f8f8;\n    width: 13px;\n    background: #f8f8f8; }\n  .profile-activity-container ::-webkit-scrollbar-thumb {\n    border-left: 8px solid #f8f8f8; }\n\n.user-details-pane .action-bar {\n  background: #dfeef4;\n  box-shadow: 0 1px 2px 0 transparent;\n  border-bottom: none; }\n  .user-details-pane .action-bar.show {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2); }\n\n.user-profile-page {\n  overflow: auto; }\n  .user-profile-page .form-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 600px;\n    background: #fff;\n    border-right: 1px solid #ddd;\n    box-sizing: border-box;\n    box-shadow: 0 0 5px 0 #e0e0e0;\n    z-index: 2; }\n  .user-profile-page .user-details-pane > header {\n    height: 48px;\n    box-sizing: border-box;\n    border-bottom: 1px solid #dfdfdf; }\n    .user-profile-page .user-details-pane > header .nav-tabs {\n      padding: 0 10px; }\n  .user-profile-page .user-details-pane > .content {\n    position: absolute;\n    top: 48px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 0; }\n    .user-profile-page .user-details-pane > .content .inner-content {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      overflow: auto;\n      padding: 20px; }\n  .user-profile-page .user-details-pane .action-bar {\n    top: -96px; }\n    .user-profile-page .user-details-pane .action-bar.show {\n      top: -48px; }\n  .user-profile-page .profile-pic {\n    width: 160px;\n    height: 160px; }\n    .user-profile-page .profile-pic .avatar {\n      width: 160px;\n      height: 160px;\n      overflow: hidden; }\n      .user-profile-page .profile-pic .avatar img {\n        width: 160px;\n        max-width: 160px; }\n      .user-profile-page .profile-pic .avatar.initials {\n        font-size: 48px;\n        line-height: 160px;\n        font-weight: 300; }\n    .user-profile-page .profile-pic .change-photo {\n      line-height: 28px; }\n  .user-profile-page .other-content {\n    position: absolute;\n    top: 0;\n    left: 600px;\n    bottom: 0;\n    right: 0;\n    z-index: 1;\n    background: #f8f8f8; }\n    .user-profile-page .other-content .tablist-container {\n      width: 100%;\n      box-sizing: border-box;\n      height: 38px;\n      border-bottom: 1px solid #e5e5e5;\n      background: #efefef; }\n      .user-profile-page .other-content .tablist-container ul li {\n        float: left;\n        height: 38px;\n        line-height: 38px;\n        padding: 0 20px;\n        border-right: 1px solid #dfdfdf;\n        color: #218baa; }\n        .user-profile-page .other-content .tablist-container ul li.active {\n          background: #f8f8f8; }\n    .user-profile-page .other-content .tabcontent-container {\n      position: absolute;\n      top: 38px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      overflow: auto; }\n      .user-profile-page .other-content .tabcontent-container .profile-activity-container {\n        left: 0;\n        background: none; }\n        .user-profile-page .other-content .tabcontent-container .profile-activity-container .activity.with-date .date span {\n          background-color: #f8f8f8 !important; }\n\n.user-link {\n  color: #3599b6; }\n  .user-link:hover {\n    cursor: pointer; }\n\n.user-popup {\n  position: fixed;\n  min-width: 240px;\n  width: auto;\n  height: 150px;\n  top: 0px;\n  left: 0px;\n  display: none;\n  z-index: 1001;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15); }\n  .user-popup .avatar-holder {\n    height: 64px;\n    padding: 10px 20px; }\n    .user-popup .avatar-holder .avatar {\n      float: none;\n      margin: 0 auto; }\n  .user-popup .title {\n    height: 40px;\n    line-height: 40px;\n    padding: 0 20px;\n    font-size: 20px;\n    text-align: center;\n    text-transform: capitalize;\n    font-weight: 300; }\n  .user-popup .actions {\n    text-transform: uppercase;\n    text-align: center;\n    font-size: 12px; }\n    .user-popup .actions a:hover {\n      text-decoration: none; }\n\n.preferences .dateline_preview {\n  background-color: rgba(0, 0, 0, 0.06);\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  border-radius: 14px;\n  padding: 0.2rem 1.4rem;\n  margin-top: 1rem; }\n\n.preferences .preferences__actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 1.2rem 0 0.8rem; }\n  .preferences .preferences__actions .preferences__action-link {\n    cursor: pointer;\n    color: #5ea9c8;\n    display: inline-block;\n    padding: 0.2rem;\n    font-size: 1.1rem;\n    line-height: 100%;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    flex-grow: 0; }\n  .preferences .preferences__actions .preferences__action-spacer {\n    display: inline-block;\n    flex-grow: 0;\n    height: 1.2rem;\n    margin-right: 0.6rem;\n    padding-left: 0.6rem;\n    width: 0.1rem;\n    border: 1px dotted rgba(0, 0, 0, 0.65);\n    border-width: 0 1px 0 0; }\n\n.preferences .input-term input[type=\"text\"] {\n  border: 1px solid rgba(123, 123, 123, 0.5);\n  border-radius: 3px;\n  padding: 0 5px;\n  width: auto;\n  min-width: 100%; }\n  .preferences .input-term input[type=\"text\"]:hover {\n    border: 1px solid rgba(123, 123, 123, 0.8); }\n  .preferences .input-term input[type=\"text\"]:focus {\n    border: 1px solid #5ea9c8;\n    box-shadow: inset 0 0 0 1px #5ea9c8; }\n\n.preferences [sd-meta-dropdown] .dropdown__toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 0.2rem !important;\n  min-width: 240px; }\n  .preferences [sd-meta-dropdown] .dropdown__toggle .dropdown__caret {\n    display: block;\n    flex-grow: 0;\n    flex-shrink: 0;\n    margin: 0 !important; }\n\n.mini-modal {\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2), 0 6px 16px rgba(0, 0, 0, 0.3); }\n  .mini-modal .title {\n    font-size: 15px;\n    padding: 12px 20px;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1); }\n  .mini-modal .content {\n    padding: 10px 20px;\n    font-size: 14px; }\n  .mini-modal .footer {\n    padding: 10px 20px 20px; }\n  .mini-modal .close {\n    position: absolute;\n    top: 10px;\n    right: 10px; }\n\n.password-popup {\n  position: fixed;\n  min-width: 260px;\n  top: 150px;\n  left: 10%;\n  background-color: #fff;\n  z-index: 999; }\n\n.user-preferences__heading {\n  padding: 0.8rem 0 1.6rem;\n  margin: 0;\n  font-size: 1.6rem;\n  color: #333;\n  font-weight: 300;\n  letter-spacing: 0.02em;\n  text-transform: capitalize; }\n", ""]);

// exports


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

angular.module('superdesk.apps.users.activity', [
    'superdesk.apps.users',
    'superdesk.apps.dashboard.widgets',
    'superdesk.core.services.asset',
])
    .config(['dashboardWidgetsProvider', 'assetProvider', function (dashboardWidgets, asset) {
        dashboardWidgets.addWidget('activity', {
            label: 'Activity Stream',
            multiple: true,
            max_sizex: 2,
            max_sizey: 2,
            sizex: 1,
            sizey: 2,
            thumbnail: asset.imageUrl('apps/users/activity-widget/thumbnail.svg'),
            template: asset.templateUrl('apps/users/activity-widget/widget-activity.html'),
            configurationTemplate: asset.templateUrl('apps/users/activity-widget/configuration.html'),
            configuration: { maxItems: 5 },
            description: 'Activity stream widget',
            icon: 'stream',
        });
    }])
    .controller('ActivityController', ['$scope', 'profileService',
    function ($scope, profileService) {
        var page = 1;
        var currentConfig = null;
        $scope.max_results = 0;
        function refresh(config) {
            currentConfig = config;
            profileService.getAllUsersActivity(config.maxItems).then(function (list) {
                $scope.activityFeed = list;
                $scope.max_results = parseInt(config.maxItems, 10);
            });
            $scope.loadMore = function () {
                page++;
                profileService.getAllUsersActivity(config.maxItems, page).then(function (next) {
                    Array.prototype.push.apply($scope.activityFeed._items, next._items);
                    $scope.activityFeed._links = next._links;
                    $scope.max_results += parseInt(config.maxItems, 10);
                });
            };
        }
        $scope.$on('changes in activity', function () {
            if (currentConfig) {
                refresh(currentConfig);
            }
        });
        $scope.$watch('widget.configuration', function (config) {
            page = 1;
            if (config) {
                refresh(config);
            }
        }, true);
    }])
    .controller('ActivityConfigController', ['$scope',
    function ($scope) {
        $scope.notIn = function (haystack) {
            return function (needle) {
                return haystack.indexOf(needle) === -1;
            };
        };
    }]);


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
UserImportService.$inject = ['api', '$q'];
function UserImportService(api, $q) {
    function reject(key, message) {
        var error = {};
        error[key] = 1;
        error.message = message;
        return $q.reject(error);
    }
    this.importUser = function importUser(importUserData) {
        return api.save('import_profile', importUserData)
            .then(null, function handleErrorResponse(response) {
            var data = response.data;
            if (response.status === 404) {
                return reject('profile_to_import', data._message);
            }
            else if (response.status === 400) {
                return reject(data._issues.profile_to_import ? 'profile_to_import' : 'credentials', data._message);
            }
            return reject('credentials', data._message);
        });
    };
}
UserImportController.$inject = ['$scope', 'userImport'];
function UserImportController($scope, userImport) {
    $scope.model = {};
    $scope.error = null;
    $scope.importUser = function importUser(user) {
        $scope.error = null;
        userImport.importUser(user)
            .then(function finishImport(importedUser) {
            $scope.resolve(importedUser);
        }, function renderErrors(error) {
            $scope.error = error;
        });
    };
}
angular.module('superdesk.apps.users.import', ['superdesk.core.activity', 'superdesk.core.api'])
    .service('userImport', UserImportService)
    .config(['superdeskProvider', function (superdeskProvider) {
        superdeskProvider
            .activity('import.user', {
            label: utils_1.gettext('Import user'),
            modal: true,
            controller: UserImportController,
            templateUrl: 'scripts/apps/users/import/views/import-user.html',
            filters: [{ action: 'create', type: 'user' }],
            features: { import_profile: 1 },
        });
    }]);


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RolesService = /** @class */ (function () {
    function RolesService(api) {
        this._api = api;
    }
    /**
     * Get user role
     *
     * @param {string} roleId
     */
    RolesService.prototype.getUserRole = function (roleId) {
        return this._api.find('roles', roleId);
    };
    return RolesService;
}());
exports.default = RolesService;
RolesService.$inject = ['api'];


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
UserEditController.$inject = ['$scope', 'server', 'superdesk', 'user', 'session'];
function UserEditController($scope, server, superdesk, user, session) {
    $scope.user = user;
    $scope.profile = $scope.user._id === session.identity._id;
}
exports.UserEditController = UserEditController;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
UserListController.$inject = ['$scope', '$location', 'api', 'lodash', 'session', 'usersService'];
function UserListController($scope, $location, api, _, session, usersService) {
    var DEFAULT_SIZE = 25;
    $scope.selected = { user: null };
    $scope.createdUsers = [];
    $scope.online_users = false;
    $scope.authorOnlyFilter = false;
    api('roles')
        .query()
        .then(function (result) {
        $scope.roles = _.keyBy(result._items, '_id');
        $scope.noRolesWarning = result._items.length === 0;
    });
    $scope.preview = function (user) {
        $scope.selected.user = user;
    };
    $scope.createUser = function () {
        $scope.intent('create', 'user').then(fetchUsers);
    };
    $scope.$on('intent:create:user', function createUser() {
        // fallback if there is no other activity
        $scope.preview({});
    });
    $scope.closePreview = function () {
        $scope.preview(null);
    };
    $scope.afterDelete = function (data) {
        if ($scope.selected.user && data.item && data.item.href === $scope.selected.user.href) {
            $scope.selected.user = null;
        }
        fetchUsers(getCriteria());
    };
    // make sure saved user is presented in the list
    $scope.render = function (user) {
        if (!findUser($scope.users._items, user) && !findUser($scope.createdUsers, user)) {
            $scope.createdUsers.unshift(user);
        }
    };
    function findUser(list, user) {
        if (angular.isUndefined(user)) {
            return false;
        }
        return _.find(list, function (item) { return item._links.self.href === user._links.self.href; });
    }
    function getCriteria() {
        var params = $location.search(), criteria = {
            max_results: Number(params.max_results) || DEFAULT_SIZE,
        };
        criteria.where = initCriteria(params, $scope.userFilter);
        if (params.page) {
            criteria.page = parseInt(params.page, 10);
        }
        if (params.sort) {
            criteria.sort = formatSort(params.sort[0], params.sort[1]);
        }
        else {
            criteria.sort = formatSort('full_name', 'asc');
        }
        return criteria;
    }
    function initCriteria(search, filter) {
        var query = {};
        var canSeeSupportUsers = usersService.isSupport(session.identity);
        if (!canSeeSupportUsers) {
            query.is_support = { $ne: true };
        }
        if (search.q) {
            query.$or = [
                { username: { $regex: search.q, $options: '-i' } },
                { display_name: { $regex: search.q, $options: '-i' } },
                { email: { $regex: search.q, $options: '-i' } },
            ];
        }
        switch (filter) {
            case 'online':
                query.session_preferences = { $exists: true, $nin: [null, {}] };
                break;
            case 'pending':
                query.is_enabled = true;
                query.is_active = true;
                query.needs_activation = true;
                break;
            case 'inactive':
                query.is_enabled = true;
                query.is_active = false;
                break;
            case 'disabled':
                query.is_enabled = false;
                break;
            case 'all':
                break;
            default:
                query.is_active = true;
                query.is_enabled = true;
                query.needs_activation = false;
                break;
        }
        return JSON.stringify(query);
    }
    function fetchUsers(criteria) {
        api.users.query(criteria)
            .then(function (users) {
            $scope.users = users;
            $scope.createdUsers = [];
        });
    }
    function formatSort(key, dir) {
        var val = dir === 'asc' ? 1 : -1;
        switch (key) {
            case 'full_name':
                return '[("first_name", ' + val + '), ("last_name", ' + val + ')]';
            default:
                return '[("' + encodeURIComponent(key) + '", ' + val + ')]';
        }
    }
    $scope.filterOptions = [
        { id: null, label: utils_1.gettext('Active') },
        { id: 'online', label: utils_1.gettext('Online') },
        { id: 'pending', label: utils_1.gettext('Pending') },
        { id: 'inactive', label: utils_1.gettext('Inactive') },
        { id: 'disabled', label: utils_1.gettext('Disabled') },
        { id: 'all', label: utils_1.gettext('All') },
    ];
    $scope.userFilter = null;
    $scope.$watchCollection(getCriteria, fetchUsers);
}
exports.UserListController = UserListController;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
ChangeAvatarController.$inject = ['$scope', 'upload', 'session', 'urls', 'betaService', 'notify', 'lodash'];
function ChangeAvatarController($scope, upload, session, urls, beta, notify, _) {
    $scope.methods = [
        { id: 'upload', label: utils_1.gettext('Upload from computer') },
        { id: 'photo', label: utils_1.gettext('Take a picture') },
        { id: 'globe', label: utils_1.gettext('Use a Web URL') },
    ];
    beta.isBeta().then(function (isBeta) {
        if (!isBeta) {
            $scope.methods = _.reject($scope.methods, { beta: true });
        }
    });
    $scope.activate = function (method) {
        $scope.active = method;
        $scope.preview = {};
        $scope.progress = { width: 0 };
    };
    $scope.activate($scope.methods[0]);
    $scope.removeImage = function () {
        return $scope.resolve(null);
    };
    $scope.upload = function (config) {
        var form = {};
        form.CropLeft = Math.round(Math.min(config.cords.x, config.cords.x2));
        form.CropRight = Math.round(Math.max(config.cords.x, config.cords.x2));
        form.CropTop = Math.round(Math.min(config.cords.y, config.cords.y2));
        form.CropBottom = Math.round(Math.max(config.cords.y, config.cords.y2));
        if (config.img) {
            form.media = config.img;
        }
        else if (config.url) {
            form.URL = config.url;
        }
        else {
            return;
        }
        return urls.resource('upload').then(function (uploadUrl) { return upload.start({
            url: uploadUrl,
            method: 'POST',
            data: form,
        }).then(function (response) {
            if (response.data._status === 'ERR') {
                notify.error(utils_1.gettext('There was a problem with your upload'));
                return;
            }
            var pictureUrl = response.data.renditions.viewImage.href;
            $scope.locals.data.avatar = response.data._id;
            return $scope.resolve(pictureUrl);
        }, function (error) {
            notify.error(error.statusText !== '' ?
                error.statusText :
                utils_1.gettext('There was a problem with your upload'));
        }, function (update) {
            $scope.progress.width = Math.round(update.loaded / update.total * 100.0);
        }); });
    };
}
exports.ChangeAvatarController = ChangeAvatarController;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Enable user
 */
UserEnableCommand.$inject = ['api', 'data', '$q', 'notify', 'usersService', '$rootScope'];
function UserEnableCommand(api, data, $q, notify, usersService, $rootScope) {
    var user = data.item;
    return usersService.save(user, { is_enabled: true, is_active: true }).then(function (response) {
        $rootScope.$broadcast('user:updated', response);
    }, function (response) {
        if (angular.isDefined(response.data._issues) &&
            angular.isDefined(response.data._issues['validator exception'])) {
            notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
        }
        else if (angular.isDefined(response.data._message)) {
            notify.error(utils_1.gettext('Error: ' + response.data._message));
        }
        else {
            notify.error(utils_1.gettext('Error. User Profile cannot be enabled.'));
        }
    });
}
exports.UserEnableCommand = UserEnableCommand;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Disable user
 */
UserDeleteCommand.$inject = ['api', 'data', '$q', 'notify', '$rootScope'];
function UserDeleteCommand(api, data, $q, notify, $rootScope) {
    var user = data.item;
    return api.users.remove(user).then(function (response) { return api.users.getById(user._id)
        .then(function (newUser) {
        user = angular.extend(user, newUser);
        $rootScope.$broadcast('user:updated', user);
        return user;
    }); }, function (response) {
        if (angular.isDefined(response.data._issues) &&
            angular.isDefined(response.data._issues['validator exception'])) {
            notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
        }
        else if (angular.isDefined(response.data._message)) {
            notify.error(utils_1.gettext('Error: ' + response.data._message));
        }
        else {
            notify.error(utils_1.gettext('Error. User Profile cannot be disabled.'));
        }
    });
}
exports.UserDeleteCommand = UserDeleteCommand;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/*
 * Delete sessions of a user
 */
SessionsDeleteCommand.$inject = ['api', 'data', '$q', 'notify', '$rootScope'];
function SessionsDeleteCommand(api, data, $q, notify, $rootScope) {
    var user = data.item;
    api.remove(user, {}, 'clear_sessions')
        .then(function () {
        user.session_preferences = {};
        notify.success(utils_1.gettext('Sessions cleared'));
    }, function (response) {
        notify.error(utils_1.gettext('Error. Sessions could not be cleared.'));
    });
}
exports.SessionsDeleteCommand = SessionsDeleteCommand;


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * Resolve a user by route id and redirect to /users if such user does not exist
 */
UserResolver.$inject = ['api', '$route', 'notify', '$location'];
function UserResolver(api, $route, notify, $location) {
    return api.users.getById($route.current.params._id)
        .then(null, function (response) {
        if (response.status === 404) {
            $location.path('/users/');
            notify.error(utils_1.gettext('User was not found, sorry.'), 5000);
        }
        return response;
    });
}
exports.UserResolver = UserResolver;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UsersService_1 = __webpack_require__(1464);
exports.UsersService = UsersService_1.UsersService;
var UserListService_1 = __webpack_require__(1465);
exports.UserListService = UserListService_1.UserListService;
var UserPopupService_1 = __webpack_require__(1466);
exports.UserPopupService = UserPopupService_1.UserPopupService;
var ProfileService_1 = __webpack_require__(1467);
exports.ProfileService = ProfileService_1.ProfileService;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * Bussiness logic layer, should be used instead of resource
 */
UsersService.$inject = ['api', '$q', 'notify'];
function UsersService(api, $q, notify) {
    var usersService = {};
    usersService.usernamePattern = /^[A-Za-z0-9_.'-]+$/;
    usersService.phonePattern = /^(?:(?:0?[1-9][0-9]{8})|(?:(?:\+|00)[1-9][0-9]{9,11}))$/;
    usersService.signOffPattern = /^[a-zA-Z0-9]+$/;
    usersService.twitterPattern = /^@([A-Za-z0-9_]{1,15}$)/;
    /**
     * Save user with given data
     *
     * @param {Object} user
     * @param {Object} data
     * @returns {Promise}
     */
    usersService.save = function save(user, data) {
        return api.save('users', user, data).then(function (result) {
            lodash_1.default.assign(user, result);
            return result;
        });
    };
    /**
     * Change user password
     *
     * @param {string} username
     * @param {string} oldPassword
     * @param {string} newPassword
     * @returns {Promise}
     */
    usersService.changePassword = function changePassword(username, oldPassword, newPassword) {
        return api.changePassword.create({
            username: username,
            old_password: oldPassword,
            new_password: newPassword,
        });
    };
    /**
     * Reset reset password
     *
     * @param {Object} user
     * @returns {Promise}
     */
    usersService.resetPassword = function resetPassword(user) {
        return api.resetPassword.create({ email: user.email });
    };
    /**
     * Test if user is active
     */
    usersService.isActive = function isActive(user) {
        return user && user.is_active;
    };
    /**
     * Test if user is on pending state
     */
    usersService.isPending = function isPending(user) {
        return user && user.needs_activation;
    };
    /**
     * Test if user is of type support
     */
    usersService.isSupport = function isSupport(user) {
        return user && user.is_support;
    };
    /**
     * Toggle user status
     */
    usersService.toggleStatus = function toggleStatus(user, active) {
        return this.save(user, { is_active: active });
    };
    /**
     * Checks if the user is logged-in or not
     */
    usersService.isLoggedIn = function (user) {
        return user && lodash_1.default.size(user.session_preferences) > 0;
    };
    return usersService;
}
exports.UsersService = UsersService;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service for fetching users with caching.
 * Ideally, should be used app-wide.
 */
UserListService.$inject = ['api', '$q', '$cacheFactory'];
function UserListService(api, $q, $cacheFactory) {
    var userservice = {};
    var cache = $cacheFactory('userList');
    var DEFAULT_CACHE_KEY = '_nosearch';
    var DEFAULT_PAGE = 1;
    var DEFAULT_PER_PAGE = 20;
    userservice.getAll = function () { return api('users').getAll(); };
    /**
     * Fetches and caches users, or returns from the cache.
     *
     * @param {String} search
     * @param {Integer} page (Shouldn't be used at the moment)
     * @param {Integer} perPage
     * @returns {Promise}
     */
    userservice.get = function (search, page, perPage) {
        if (page === void 0) { page = DEFAULT_PAGE; }
        if (perPage === void 0) { perPage = DEFAULT_PER_PAGE; }
        var key = search || DEFAULT_CACHE_KEY;
        key = buildKey(key, page, perPage);
        var value = cache.get(key);
        if (value) {
            return $q.when(value);
        }
        var criteria = { max_results: page * perPage };
        if (search) {
            criteria.where = JSON.stringify({
                $or: [
                    { display_name: { $regex: search, $options: '-i' } },
                    { username: { $regex: search, $options: '-i' } },
                    { first_name: { $regex: search, $options: '-i' } },
                    { last_name: { $regex: search, $options: '-i' } },
                    { email: { $regex: search, $options: '-i' } },
                ],
            });
        }
        return api('users').query(criteria)
            .then(function (result) {
            cache.put(key, result);
            return result;
        });
    };
    /**
     * Fetch single user from default cache, or make new api call
     *
     * @param {String} id of user
     * @param {boolean} forced to bypass the cache
     * @returns {Promise}
     */
    userservice.getUser = function (id, forced) {
        return api('users').getById(id, undefined, !forced);
    };
    /**
     * Clear user cache
     */
    userservice.clearCache = function () {
        cache.removeAll();
    };
    function buildKey(key, page, perPage) {
        return key + '_' + page + '_' + perPage;
    }
    return userservice;
}
exports.UserListService = UserListService;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
UserPopupService.$inject = ['$compile', '$timeout', 'userList'];
function UserPopupService($compile, $timeout, userList) {
    var popover = {};
    var holdInterval = 300;
    // Create element
    popover.get = function (create) {
        if (!popover.element && create) {
            popover.element = $('<div class="user-popup"></div>');
            popover.element.appendTo('BODY');
            popover.element.hover(preventClose, triggerClose);
            popover.element.click(hide);
        }
        return popover.element;
    };
    // Set content
    popover.set = function (userId, el, scope) {
        preventClose();
        resetContent();
        // do box positioning
        var box = popover.get(true);
        var position = el.offset();
        box.css({
            left: position.left + el.outerWidth() - box.outerWidth() / 2,
            top: position.top + el.outerHeight(),
        });
        // get data
        userList.getUser(userId)
            .then(function (user) {
            buildTemplate(user, scope);
        }, function (response) {
            console.error(response);
        });
        box.show();
    };
    // Close element
    popover.close = function () {
        var box = popover.get();
        if (!box) {
            return;
        }
        triggerClose();
    };
    function hide() {
        var box = popover.get();
        if (!box) {
            return;
        }
        box.hide();
    }
    function resetContent() {
        var box = popover.get();
        if (!box) {
            return;
        }
        box.html('');
    }
    function preventClose() {
        $timeout.cancel(popover.status);
    }
    function triggerClose() {
        popover.status = $timeout(hide, holdInterval, false);
    }
    // build template
    function buildTemplate(user, scope) {
        var box = popover.get();
        box.html('<div class="avatar-holder">' +
            '<figure class="avatar big">' +
            '<img sd-user-avatar data-user="user">' +
            '</figure>' +
            '</div>' +
            '<div class="title">{{user.display_name}}</div>' +
            '<div class="actions">' +
            '<a href="#/users/{{user._id}}">go to profile</a>' +
            '</div>');
        var popupScope = scope.$new(true);
        popupScope.user = user;
        $compile(box)(popupScope);
    }
    return popover;
}
exports.UserPopupService = UserPopupService;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ProfileService.$inject = ['api'];
function ProfileService(api) {
    var RESOURCE = 'activity';
    /**
     * Get all activity of single user, being it content related or not
     *
     * @param {Object} user
     * @param {number} maxResults
     * @param {number} page
     * @return {Promise}
     */
    this.getUserActivity = function (user, maxResults, page) {
        var q = {
            where: { user: user._id },
            sort: '[(\'_created\',-1)]',
            embedded: { user: 1 },
        };
        if (maxResults) {
            q.max_results = maxResults;
        }
        if (page > 1) {
            q.page = page;
        }
        return api.query(RESOURCE, q);
    };
    /**
     * Get activity of all users related to content
     *
     * This will return activity like item created/updated, but not user.updated.
     *
     * @param {number} maxResults
     * @param {number} page
     * @return {Promise}
     */
    this.getAllUsersActivity = function (maxResults, page) {
        var q = {
            sort: '[(\'_created\',-1)]',
            where: { user: { $exists: true }, item: { $exists: true } },
            embedded: { user: 1 },
        };
        if (maxResults) {
            q.max_results = maxResults;
        }
        if (page > 1) {
            q.page = page;
        }
        return api.query(RESOURCE, q);
    };
}
exports.ProfileService = ProfileService;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserRolesDirective_1 = __webpack_require__(1469);
exports.UserRolesDirective = UserRolesDirective_1.UserRolesDirective;
var RolesPrivilegesDirective_1 = __webpack_require__(1470);
exports.RolesPrivilegesDirective = RolesPrivilegesDirective_1.RolesPrivilegesDirective;
var InfoItemDirective_1 = __webpack_require__(1471);
exports.InfoItemDirective = InfoItemDirective_1.InfoItemDirective;
var ValidErrorDirective_1 = __webpack_require__(1472);
exports.ValidErrorDirective = ValidErrorDirective_1.ValidErrorDirective;
var ValidInfoDirective_1 = __webpack_require__(1473);
exports.ValidInfoDirective = ValidInfoDirective_1.ValidInfoDirective;
var UserDetailsPaneDirective_1 = __webpack_require__(1474);
exports.UserDetailsPaneDirective = UserDetailsPaneDirective_1.UserDetailsPaneDirective;
var UserEditDirective_1 = __webpack_require__(1475);
exports.UserEditDirective = UserEditDirective_1.UserEditDirective;
var UserPreferencesDirective_1 = __webpack_require__(1476);
exports.UserPreferencesDirective = UserPreferencesDirective_1.UserPreferencesDirective;
var UserPrivilegesDirective_1 = __webpack_require__(1477);
exports.UserPrivilegesDirective = UserPrivilegesDirective_1.UserPrivilegesDirective;
var ChangePasswordDirective_1 = __webpack_require__(1478);
exports.ChangePasswordDirective = ChangePasswordDirective_1.ChangePasswordDirective;
var ResetPasswordDirective_1 = __webpack_require__(1479);
exports.ResetPasswordDirective = ResetPasswordDirective_1.ResetPasswordDirective;
var UserUniqueDirective_1 = __webpack_require__(1480);
exports.UserUniqueDirective = UserUniqueDirective_1.UserUniqueDirective;
var PasswordConfirmDirective_1 = __webpack_require__(1481);
exports.PasswordConfirmDirective = PasswordConfirmDirective_1.PasswordConfirmDirective;
var UserListDirective_1 = __webpack_require__(1482);
exports.UserListDirective = UserListDirective_1.UserListDirective;
var UserListItemDirective_1 = __webpack_require__(1483);
exports.UserListItemDirective = UserListItemDirective_1.UserListItemDirective;
var ActivityDirective_1 = __webpack_require__(1484);
exports.ActivityDirective = ActivityDirective_1.ActivityDirective;
var UserMentioDirective_1 = __webpack_require__(1485);
exports.UserMentioDirective = UserMentioDirective_1.UserMentioDirective;
var UserInfoDirective_1 = __webpack_require__(1486);
exports.UserInfoDirective = UserInfoDirective_1.UserInfoDirective;
var UserActivityDirective_1 = __webpack_require__(1487);
exports.UserActivityDirective = UserActivityDirective_1.UserActivityDirective;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
UserRolesDirective.$inject = ['api', 'notify', 'modal', '$filter', 'lodash', 'metadata'];
function UserRolesDirective(api, notify, modal, $filter, _, metadata) {
    return {
        scope: true,
        templateUrl: 'scripts/apps/users/views/settings-roles.html',
        link: function (scope) {
            var _orig = null;
            scope.editRole = null;
            api('roles').query()
                .then(function (result) {
                scope.roles = $filter('sortByName')(result._items);
            });
            metadata.fetchMetadataValues().then(function () {
                scope.author_roles = metadata.values.author_roles;
            });
            scope.edit = function (role) {
                scope.editRole = _.create(role);
                _orig = role;
                scope.defaultRole = role.is_default;
            };
            scope.save = function (role) {
                var _new = !role._id;
                api('roles').save(_orig, role)
                    .then(function () {
                    if (_new) {
                        scope.roles.push(_orig);
                        notify.success(utils_1.gettext('User role created.'));
                    }
                    else {
                        notify.success(utils_1.gettext('User role updated.'));
                    }
                    if (role.is_default) {
                        updatePreviousDefault(role);
                    }
                    scope.cancel();
                }, function (response) {
                    if (response.status === 400 && typeof response.data._issues.name !== 'undefined' &&
                        response.data._issues.name.unique === 1) {
                        notify.error(utils_1.gettext('I\'m sorry but a role with that name already exists.'));
                    }
                    else if (typeof response.data._issues['validator exception'] !== 'undefined') {
                        notify.error(response.data._issues['validator exception']);
                    }
                    else {
                        notify.error(utils_1.gettext('I\'m sorry but there was an error when saving the role.'));
                    }
                });
            };
            scope.cancel = function () {
                scope.editRole = null;
            };
            scope.remove = function (role) {
                confirm().then(function () {
                    api('roles').remove(role)
                        .then(function (result) {
                        _.remove(scope.roles, role);
                    }, function (response) {
                        if (angular.isDefined(response.data._message)) {
                            notify.error(utils_1.gettext('Error: ' + response.data._message));
                        }
                        else {
                            notify.error(utils_1.gettext('There was an error. Role cannot be deleted.'));
                        }
                    });
                });
            };
            function updatePreviousDefault(role) {
                // find previous role with flag 'default'
                var previous = _.find(scope.roles, function (r) { return r._id !== role._id && r.is_default; });
                // update it
                if (previous) {
                    api('roles')
                        .getById(previous._id)
                        .then(function (result) {
                        _.extend(previous, { _etag: result._etag, is_default: false });
                    });
                }
            }
            function confirm() {
                return modal.confirm(utils_1.gettext('Are you sure you want to delete user role?'));
            }
        },
    };
}
exports.UserRolesDirective = UserRolesDirective;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var helpers_1 = __importDefault(__webpack_require__(554));
var utils_1 = __webpack_require__(3);
RolesPrivilegesDirective.$inject = ['api', 'notify', '$q', '$filter'];
function RolesPrivilegesDirective(api, notify, $q, $filter) {
    return {
        scope: true,
        templateUrl: 'scripts/apps/users/views/settings-privileges.html',
        link: function (scope) {
            api('roles')
                .query()
                .then(function (result) {
                scope.roles = $filter('sortByName')(result._items);
            });
            api('privileges').query()
                .then(function (result) {
                scope.privileges = result._items;
            });
            scope.saveAll = function (rolesForm) {
                var promises = [];
                lodash_1.default.each(scope.roles, function (role) {
                    promises.push(api.save('roles', role, lodash_1.default.pick(role, 'privileges'))
                        .then(null, function (error) {
                        console.error(error);
                    }));
                });
                $q.all(promises).then(function () {
                    notify.success(utils_1.gettext('Privileges updated.'));
                    rolesForm.$setPristine();
                }, function (response) {
                    notify.error(utils_1.gettext(helpers_1.default(response)));
                });
            };
        },
    };
}
exports.RolesPrivilegesDirective = RolesPrivilegesDirective;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function InfoItemDirective() {
    return {
        link: function (scope, element) {
            element.addClass('item');
            element.find('input, select')
                .addClass('info-value info-editable');
        },
    };
}
exports.InfoItemDirective = InfoItemDirective;


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ValidErrorDirective() {
    return {
        link: function (scope, element) {
            element.addClass('validation-error');
        },
    };
}
exports.ValidErrorDirective = ValidErrorDirective;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ValidInfoDirective() {
    return {
        link: function (scope, element) {
            element.addClass('validation-info');
        },
    };
}
exports.ValidInfoDirective = ValidInfoDirective;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
UserDetailsPaneDirective.$inject = ['$timeout'];
function UserDetailsPaneDirective($timeout) {
    return {
        replace: true,
        transclude: true,
        template: '<div class="user-details-pane" ng-transclude></div>',
        link: function (scope, element, attrs) {
            $timeout(function () {
                $('.user-details-pane').addClass('open');
            }, 0, false);
            scope.closePane = function () {
                $('.user-details-pane').removeClass('open');
            };
        },
    };
}
exports.UserDetailsPaneDirective = UserDetailsPaneDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
UserEditDirective.$inject = ['api', 'notify', 'usersService', 'userList', 'session', 'lodash',
    'langmap', '$location', '$route', 'superdesk', 'features', 'asset', 'privileges',
    'desks', 'keyboardManager', 'gettextCatalog', 'config', 'metadata', 'deployConfig', 'modal'];
function UserEditDirective(api, notify, usersService, userList, session, _, langmap, $location, $route, superdesk, features, asset, privileges, desks, keyboardManager, gettextCatalog, config, metadata, deployConfig, modal) {
    return {
        templateUrl: asset.templateUrl('apps/users/views/edit-form.html'),
        scope: {
            origUser: '=user',
            onsave: '&',
            oncancel: '&',
            onupdate: '&',
        },
        link: function (scope, elem) {
            metadata.initialize().then(function () {
                scope.metadata = metadata.values;
            });
            scope.privileges = privileges.privileges;
            scope.features = features;
            scope.usernamePattern = usersService.usernamePattern;
            scope.twitterPattern = usersService.twitterPattern;
            scope.phonePattern = usersService.phonePattern;
            scope.signOffPattern = usersService.signOffPattern;
            scope.hideSignOff = config.user && config.user.sign_off_mapping;
            scope.dirty = false;
            scope.errorMessage = null;
            scope.xmppEnabled = deployConfig.getSync('xmpp_auth');
            scope.$watch('origUser', function () {
                scope.user = _.create(scope.origUser);
                if (scope.user.is_author === undefined) {
                    scope.user.is_author = true;
                }
            });
            resetUser(scope.origUser);
            scope.isNetworkSubscription = function () {
                return ['solo', 'team'].indexOf(config.subscriptionLevel) === -1;
            };
            scope.$watchCollection('user', function (user) {
                _.each(user, function (value, key) {
                    if (value === '') {
                        if (key !== 'phone' || key !== 'byline') {
                            user[key] = null;
                        }
                        else {
                            delete user[key];
                        }
                    }
                });
                scope.dirty = !angular.equals(user, scope.origUser);
            });
            api('roles').query()
                .then(function (result) {
                scope.roles = result._items;
            });
            // get available translation languages
            var noBaseLanguage = true;
            scope.languages = config.profileLanguages.map(function (lang) {
                if (lang === gettextCatalog.baseLanguage) {
                    noBaseLanguage = false;
                }
                var langCode = lang.replace('_', '-');
                if (langmap[langCode]) {
                    return { code: lang, nativeName: langmap[langCode].nativeName };
                }
                return { code: lang, nativeName: lang };
            });
            // add baseLanguage if needed
            if (noBaseLanguage) {
                scope.languages.unshift({
                    code: gettextCatalog.baseLanguage,
                    nativeName: langmap[gettextCatalog.baseLanguage].nativeName,
                });
            }
            scope.cancel = function () {
                resetUser(scope.origUser);
                if (!scope.origUser.Id) {
                    scope.oncancel();
                }
            };
            scope.focused = function () {
                keyboardManager.unbind('down');
                keyboardManager.unbind('up');
            };
            scope.editPicture = function () {
                superdesk.intent('edit', 'avatar', scope.user).then(function (avatar) {
                    scope.user.picture_url = avatar; // prevent replacing Avatar which would get into diff
                });
            };
            function validateField(response, field) {
                if (scope.userForm[field]) {
                    if (scope.error[field]) {
                        scope.error.message = null;
                    }
                    for (var constraint in response.data._issues[field]) {
                        if (response.data._issues[field][constraint]) {
                            scope.userForm[field].$setValidity(constraint, false);
                            scope.error.message = null;
                        }
                    }
                }
            }
            scope.save = function () {
                new Promise(function (resolve) {
                    if (scope.user._id !== session.identity._id // changing language for another user
                        || scope.user.language === scope.origUser.language) {
                        resolve(false);
                    }
                    else {
                        modal.confirm(utils_1.gettext('Do you want to reload the page now?'), utils_1.gettext('The page needs to be reloaded to change the language'))
                            .then(function () {
                            resolve(true);
                        });
                    }
                })
                    .then(function (reloadPage) {
                    scope.error = null;
                    notify.info(utils_1.gettext('Saving...'));
                    return usersService.save(scope.origUser, scope.user)
                        .then(function (response) {
                        scope.origUser = response;
                        resetUser(scope.origUser);
                        notify.pop();
                        notify.success(utils_1.gettext('user saved.'));
                        scope.onsave({ user: scope.origUser });
                        if (scope.user._id === session.identity._id) {
                            session.updateIdentity(scope.origUser);
                        }
                        userList.clearCache();
                        if (reloadPage === true) {
                            window.location.reload();
                        }
                    }, function (response) {
                        notify.pop();
                        if (response.status === 404) {
                            if ($location.path() === '/users/') {
                                $route.reload();
                            }
                            else {
                                $location.path('/users/');
                            }
                            notify.error(utils_1.gettext('User was not found. The account might have been deleted.'));
                        }
                        else {
                            var errorMessage = utils_1.gettext('There was an error when saving the user account. ');
                            if (response.data && response.data._issues) {
                                if (angular.isDefined(response.data._issues['validator exception'])) {
                                    errorMessage = utils_1.gettext('Error: {{error}}', { error: response.data._issues['validator exception'] });
                                }
                                scope.error = response.data._issues;
                                scope.error.message = errorMessage;
                                for (var field in response.data._issues) {
                                    validateField(response, field);
                                }
                            }
                            notify.error(errorMessage);
                        }
                    });
                });
            };
            scope.toggleStatus = function (active) {
                usersService.toggleStatus(scope.origUser, active).then(function () {
                    resetUser(scope.origUser);
                    scope.onupdate({ user: scope.origUser });
                });
            };
            function resetUser(user) {
                scope.dirty = false;
                if (angular.isDefined(user._id)) {
                    return userList.getUser(user._id, true).then(function (u) {
                        scope.error = null;
                        scope.origUser = u;
                        scope.user = _.create(u);
                        scope.confirm = { password: null };
                        scope.show = { password: false };
                        scope._active = usersService.isActive(u);
                        scope._pending = usersService.isPending(u);
                        scope.profile = scope.user._id === session.identity._id;
                        scope.userDesks = [];
                        if (angular.isDefined(u) && angular.isDefined(u._links)) {
                            desks.fetchUserDesks(u).then(function (response) {
                                scope.userDesks = response;
                            });
                        }
                    });
                }
            }
            scope.$on('user:updated', function (event, user) {
                resetUser(user);
            });
            scope.profileConfig = _.get(config, 'profile', {});
        },
    };
}
exports.UserEditDirective = UserEditDirective;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
/* tslint:disable:max-line-length */
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.users
 * @name sdUserPreferences
 * @description
 *   This directive creates the Preferences tab on the user profile
 *   panel, allowing users to set various system preferences for
 *   themselves.
 */
UserPreferencesDirective.$inject = ['session', 'preferencesService', 'notify', 'asset',
    'metadata', 'desks', 'modal', '$timeout', '$q', 'userList', 'lodash', 'config', 'search'];
function UserPreferencesDirective(session, preferencesService, notify, asset, metadata, desks, modal, $timeout, $q, userList, _, config, search) {
    // human readable labels for server values
    var LABELS = {
        mgrid: utils_1.gettext('Grid View'),
        compact: utils_1.gettext('List View'),
        photogrid: utils_1.gettext('Photo Grid View'),
        list: utils_1.gettext('List View'),
        swimlane: utils_1.gettext('Swimlane View'),
    };
    var ICONS = {
        mgrid: 'grid-view',
        compact: 'list-view',
        photogrid: 'grid-view',
        list: 'list-view',
        swimlane: 'kanban-view',
    };
    return {
        templateUrl: asset.templateUrl('apps/users/views/user-preferences.html'),
        link: function (scope, element, attrs) {
            /*
             * Set this to true after adding all the preferences to the scope. If done before, then the
             * directives which depend on scope variables might fail to load properly.
             */
            scope.preferencesLoaded = false;
            var orig; // original preferences, before any changes
            preferencesService.get(null, true).then(function (result) {
                orig = result;
                buildPreferences(orig);
                scope.datelineSource = session.identity.dateline_source;
                scope.datelinePreview = scope.preferences['dateline:located'].located;
            });
            scope.cancel = function () {
                scope.userPrefs.$setPristine();
                buildPreferences(orig);
                scope.datelinePreview = scope.preferences['dateline:located'].located;
            };
            userList.getUser(scope.user._id, true).then(function (u) {
                scope.user = u;
            });
            /**
            * Saves the preferences changes on the server. It also
            * invokes additional checks beforehand, namely the
            * preferred categories selection.
            *
            * @method save
            */
            scope.save = function () {
                preSaveCategoriesCheck()
                    .then(function () {
                    var update = createPatchObject();
                    return preferencesService.update(update).then(function () {
                        userList.getUser(scope.user._id, true).then(function (u) {
                            scope.user = u;
                        });
                        return update;
                    });
                }, function () { return $q.reject('canceledByModal'); })
                    .then(function (preferences) {
                    // ask for browser permission if desktop notification is enable
                    if (_.get(preferences, 'desktop:notification.enabled')) {
                        preferencesService.desktopNotification.requestPermission();
                    }
                    notify.success(utils_1.gettext('User preferences saved'));
                    scope.cancel();
                }, function (reason) {
                    if (reason !== 'canceledByModal') {
                        notify.error(utils_1.gettext('User preferences could not be saved...'));
                    }
                });
            };
            /**
             * Invoked by the directive after updating the property in item. This method is responsible for updating
             * the properties dependent on dateline.
             */
            scope.changeDatelinePreview = function (datelinePreference, city) {
                if (city === '') {
                    datelinePreference.located = null;
                }
                $timeout(function () {
                    scope.datelinePreview = datelinePreference.located;
                });
            };
            /**
            * Marks all categories in the preferred categories list
            * as selected.
            *
            * @method checkAll
            */
            scope.checkAll = function () {
                scope.categories.forEach(function (cat) {
                    cat.selected = true;
                });
                scope.userPrefs.$setDirty();
            };
            /**
            * Marks all categories in the preferred categories list
            * as *not* selected.
            *
            * @method checkNone
            */
            scope.checkNone = function () {
                scope.categories.forEach(function (cat) {
                    cat.selected = false;
                });
                scope.userPrefs.$setDirty();
            };
            /**
            * Marks the categories in the preferred categories list
            * that are considered default as selected, and all the
            * other categories as *not* selected.
            *
            * @method checkDefault
            */
            scope.checkDefault = function () {
                scope.categories.forEach(function (cat) {
                    cat.selected = !!scope.defaultCategories[cat.qcode];
                });
                scope.userPrefs.$setDirty();
            };
            /**
             * Sets the form as dirty when value is changed. This function should be used when one wants to set
             * form dirty for input controls created without using <input>.
             *
             * @method articleDefaultsChanged
             */
            scope.articleDefaultsChanged = function (item) {
                scope.userPrefs.$setDirty();
            };
            scope.showCategory = function (preference) {
                if (preference.category === 'rows') {
                    return _.get(config, 'list.singleLineView');
                }
                var noShowCategories = [
                    'article_defaults',
                    'categories',
                    'desks',
                    'notifications',
                    'planning',
                    'cvs',
                ];
                return _.indexOf(noShowCategories, preference.category) < 0;
            };
            scope.profileConfig = _.get(config, 'profile', {});
            /**
             * Determine if the planning related preferences should be shown based on the existance of the
             * Agenda endpoint.
             *
             * @method showPlanning
             */
            scope.showPlanning = function () {
                return !angular.isUndefined(scope.features.agenda);
            };
            scope.valueLabel = function (value) { return LABELS[value] || value; };
            scope.getIcon = function (value) { return ICONS[value] || 'list-view'; };
            /**
            * Builds a user preferences object in scope from the given
            * data.
            *
            * @function buildPreferences
            * @param {Object} data - user preferences data, arranged in
            *   logical groups. The keys represent these groups' names,
            *   while the corresponding values are objects containing
            *   user preferences settings for a particular group.
            */
            function buildPreferences(data) {
                var buckets, // names of the needed metadata buckets
                initNeeded; // metadata service init needed?
                scope.preferences = {};
                _.each(data, function (val, key) {
                    if (val.label && val.category) {
                        scope.preferences[key] = _.create(val);
                    }
                });
                // metadata service initialization is needed if its
                // values object is undefined or any of the needed
                // data buckets are missing in it
                buckets = [
                    'categories',
                    'default_categories',
                    'locators',
                    'calendars',
                    'agendas',
                    'eventsPlanningFilters',
                ];
                initNeeded = buckets.some(function (bucketName) {
                    var values = metadata.values || {};
                    return angular.isUndefined(values[bucketName]);
                });
                if (initNeeded) {
                    var initPromises = [];
                    initPromises.push(metadata.initialize(), desks.initialize());
                    $q.all(initPromises).then(function () {
                        updateScopeData(metadata.values, data);
                    });
                }
                else {
                    updateScopeData(metadata.values, data);
                }
            }
            /**
            * Updates auxiliary scope data, such as the lists of
            * available and content categories to choose from.
            *
            * @function updateScopeData
            * @param {Object} helperData - auxiliary data used by the
            *   preferences settings UI
            * @param {Object} userPrefs - user's personal preferences
            *   settings
            */
            function updateScopeData(helperData, userPrefs) {
                // If the planning module is installed we save a list of the available agendas
                if (scope.features.agenda) {
                    scope.agendas = helperData.agendas;
                }
                // If the planning module is installed we save a list of the available events_planning_filters
                if (scope.features.events_planning_filters) {
                    scope.eventsPlanningFilters = helperData.eventsPlanningFilters;
                }
                // A list of category codes that are considered
                // preferred by default, unless of course the user
                // changes this preference setting.
                scope.defaultCategories = {};
                helperData.default_categories.forEach(function (cat) {
                    scope.defaultCategories[cat.qcode] = true;
                });
                // Create a list of categories for the UI widgets to
                // work on. New category objects are created so that
                // objects in the existing category list are protected
                // from modifications on ng-model changes.
                scope.categories = [];
                helperData.categories.forEach(function (cat) {
                    var newObj = _.create(cat), selectedCats = userPrefs['categories:preferred'].selected;
                    newObj.selected = !!selectedCats[cat.qcode];
                    scope.categories.push(newObj);
                });
                /**
                 * @ngdoc property
                 * @name sdUserPreferences#desks
                 * @type {array}
                 * @private
                 * @description Create a list of desks for the UI widgets to
                 * work on. New desk objects are created so that
                 * objects in the existing desk list are protected
                 * from modifications on ng-model changes.
                 */
                scope.desks = [];
                _.each(desks.deskLookup, function (desk) {
                    var newObj = _.create(desk), selectedDesks = userPrefs['desks:preferred'].selected;
                    newObj.selected = !!selectedDesks[desk._id];
                    scope.desks.push(newObj);
                });
                scope.locators = helperData.locators;
                if (scope.preferences['singleline:view']) {
                    search.updateSingleLineStatus(scope.preferences['singleline:view'].enabled);
                }
                scope.calendars = helperData.event_calendars;
                scope.preferencesLoaded = true;
            }
            /**
            * Checks if at least one preferred category has been
            * selected, and if not, asks the user whether or not to
            * proceed with a default set of categories selected.
            *
            * Returns a promise that is resolved if saving the
            * preferences should continue, and rejected if it should be
            * aborted (e.g. when no categories are selected AND the
            * user does not confirm using a default set of categories).
            *
            * @function preSaveCategoriesCheck
            * @return {Object} - a promise object
            */
            function preSaveCategoriesCheck() {
                var modalResult, msg, someSelected;
                someSelected = scope.categories.some(function (cat) { return cat.selected; });
                if (someSelected) {
                    // all good, simply return a promise that resolves
                    return $q.when();
                }
                msg = utils_1.gettext('No preferred categories selected. Should you choose to proceed with your choice. A default set of categories will be selected for you.');
                modalResult = modal.confirm(msg).then(function () {
                    scope.checkDefault();
                });
                return modalResult;
            }
            /**
            * Creates and returns a user preferences object that can
            * be used as a parameter in a PATCH request to the server
            * when user preferences are saved.
            *
            * @function createPatchObject
            * @return {Object}
            */
            function createPatchObject() {
                var p = {};
                _.each(orig, function (val, key) {
                    if (key === 'dateline:located') {
                        var $input = element.find('.input-term > input');
                        scope.changeDatelinePreview(scope.preferences[key], $input[0].value);
                    }
                    if (key === 'categories:preferred') {
                        val.selected = {};
                        scope.categories.forEach(function (cat) {
                            val.selected[cat.qcode] = !!cat.selected;
                        });
                    }
                    if (key === 'desks:preferred') {
                        val.selected = {};
                        scope.desks.forEach(function (desk) {
                            val.selected[desk._id] = !!desk.selected;
                        });
                    }
                    p[key] = _.extend(val, scope.preferences[key]);
                });
                return p;
            }
        },
    };
}
exports.UserPreferencesDirective = UserPreferencesDirective;


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var helpers_1 = __importDefault(__webpack_require__(554));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.users
 * @name sdUserPrivileges
 * @description
 *   This directive creates the Privileges tab on the user profile
 *   panel, allowing users to set various system preferences for
 *   themselves.
 */
UserPrivilegesDirective.$inject = ['api', 'notify', 'userList', '$q'];
function UserPrivilegesDirective(api, notify, userList, $q) {
    return {
        scope: {
            user: '=',
        },
        templateUrl: 'scripts/apps/users/views/user-privileges.html',
        link: function (scope) {
            getUser()
                .then(getPrivileges)
                .then(getUserRole);
            function getUser() {
                return userList.getUser(scope.user._id, true).then(function (u) {
                    scope.user = u;
                    // the last user privileges that were saved on the server
                    scope.origPrivileges = angular.copy(scope.user.privileges);
                }, function (error) {
                    notify.error(utils_1.gettext('User not found.'));
                    console.error(error);
                    return $q.reject(error);
                });
            }
            function getPrivileges() {
                return api('privileges').query()
                    .then(function (result) {
                    scope.privileges = result._items;
                }, function (error) {
                    notify.error(utils_1.gettext('Privileges not found.'));
                    console.error(error);
                    return $q.reject(error);
                });
            }
            function getUserRole() {
                return api('roles')
                    .getById(scope.user.role)
                    .then(function (role) {
                    scope.role = role;
                }, function (error) {
                    notify.error(utils_1.gettext('User role not found.'));
                    console.error(error);
                    return $q.reject(error);
                });
            }
            /**
            * Saves selected user privileges on the server and marks
            * the corresponding HTML form as $pristine.
            *
            * @method save
            */
            scope.save = function () {
                api.save('users', scope.user, lodash_1.default.pick(scope.user, 'privileges'))
                    .then(function () {
                    scope.origPrivileges = angular.copy(scope.user.privileges);
                    scope.userPrivileges.$setPristine();
                    notify.success(utils_1.gettext('Privileges updated.'));
                }, function (response) {
                    notify.error(utils_1.gettext(helpers_1.default(response)));
                });
            };
            /**
            * Reverts all changes to user privileges settings since the
            * time they were last saved, and marks the corresponding
            * HTML form as $pristine.
            *
            * @method cancel
            */
            scope.cancel = function () {
                scope.user.privileges = angular.copy(scope.origPrivileges);
                scope.userPrivileges.$setPristine();
            };
        },
    };
}
exports.UserPrivilegesDirective = UserPrivilegesDirective;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
ChangePasswordDirective.$inject = ['usersService', 'notify'];
function ChangePasswordDirective(usersService, notify) {
    return {
        link: function (scope, element) {
            scope.$watch('user', function () {
                scope.oldPasswordInvalid = false;
            });
            /**
             * change user password
             *
             * @param {string} oldPassword
             * @param {string} newPassword
             */
            scope.changePassword = function (oldPassword, newPassword) {
                return usersService.changePassword(scope.user.username, oldPassword, newPassword)
                    .then(function (response) {
                    scope.oldPasswordInvalid = false;
                    notify.success(utils_1.gettext('The password has been changed.'), 3000);
                    scope.show.change_password = false;
                    // this is a workaround for change password api which updates etag on user
                    // and without updating it saving of user form fails
                    scope.user._etag = response._etag;
                }, function (response) {
                    scope.oldPasswordInvalid = true;
                });
            };
        },
    };
}
exports.ChangePasswordDirective = ChangePasswordDirective;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
ResetPasswordDirective.$inject = ['usersService', 'notify'];
function ResetPasswordDirective(usersService, notify) {
    return {
        link: function (scope, element) {
            scope.$watch('user', function () {
                scope.oldPasswordInvalid = false;
            });
            /**
             * reset user password
             */
            scope.resetPassword = function () {
                return usersService.resetPassword(scope.user)
                    .then(function (response) {
                    scope.oldPasswordInvalid = false;
                    notify.success(utils_1.gettext('The password has been reset.'), 3000);
                    scope.show.reset_password = false;
                }, function (response) {
                    scope.oldPasswordInvalid = true;
                });
            };
        },
    };
}
exports.ResetPasswordDirective = ResetPasswordDirective;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
UserUniqueDirective.$inject = ['$q', 'api'];
function UserUniqueDirective($q, api) {
    return {
        require: 'ngModel',
        scope: { exclude: '=' },
        link: function (scope, element, attrs, ctrl) {
            /**
             * Test if given value is unique for seleted field
             */
            function testUnique(modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (value && attrs.uniqueField) {
                    var criteria = { where: {} };
                    criteria.where[attrs.uniqueField] = value;
                    return api.users.query(criteria)
                        .then(function (users) {
                        if (users._items.length
                            && (!scope.exclude._id || users._items[0]._id !== scope.exclude._id)) {
                            return $q.reject(users);
                        }
                        return users;
                    });
                }
                // mark as ok
                return $q.when();
            }
            ctrl.$asyncValidators.unique = testUnique;
        },
    };
}
exports.UserUniqueDirective = UserUniqueDirective;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function PasswordConfirmDirective() {
    var NAME = 'confirm';
    return {
        require: 'ngModel',
        scope: { password: '=' },
        link: function (scope, element, attrs, ctrl) {
            function isMatch(password, confirm) {
                return !password || password === confirm;
            }
            ctrl.$validators[NAME] = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return isMatch(scope.password, value);
            };
            scope.$watch('password', function (password) {
                ctrl.$setValidity(NAME, isMatch(password, ctrl.$viewValue));
            });
        },
    };
}
exports.PasswordConfirmDirective = PasswordConfirmDirective;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
UserListDirective.$inject = ['keyboardManager', 'usersService', 'asset', 'session'];
function UserListDirective(keyboardManager, usersService, asset, session) {
    return {
        templateUrl: asset.templateUrl('apps/users/views/user-list-item.html'),
        scope: {
            roles: '=',
            users: '=',
            authorOnlyFilter: '=',
            selected: '=',
            done: '=',
        },
        link: function (scope, elem, attrs) {
            scope.active = function (user) {
                return usersService.isActive(user);
            };
            scope.pending = function (user) {
                return usersService.isPending(user);
            };
            scope.select = function (user) {
                scope.selected = user;
                bindKeys();
            };
            scope.$watch('selected', function (selected) {
                if (lodash_1.default.isNil(selected)) {
                    bindKeys();
                }
            });
            scope.isLoggedIn = function (user) {
                return usersService.isLoggedIn(user);
            };
            function bindKeys() {
                unbindKeys();
                keyboardManager.bind('down', moveDown);
                keyboardManager.bind('up', moveUp);
            }
            function unbindKeys() {
                keyboardManager.unbind('down');
                keyboardManager.unbind('up');
            }
            function moveDown() {
                var selectedIndex = getSelectedIndex();
                if (selectedIndex !== undefined && selectedIndex !== -1) {
                    scope.select(scope.users[lodash_1.default.min([scope.users.length - 1, selectedIndex + 1])]);
                }
            }
            function moveUp() {
                var selectedIndex = getSelectedIndex();
                if (selectedIndex !== undefined && selectedIndex !== -1) {
                    scope.select(scope.users[lodash_1.default.max([0, selectedIndex - 1])]);
                }
            }
            function getSelectedIndex() {
                if (!lodash_1.default.isEmpty(scope.selected)) {
                    return lodash_1.default.findIndex(scope.users, function (user) { return user._id === scope.selected._id; });
                }
            }
        },
    };
}
exports.UserListDirective = UserListDirective;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
UserListItemDirective.$inject = ['asset'];
function UserListItemDirective(asset) {
    return {
        templateUrl: asset.templateUrl('apps/users/views/user-list-item.html'),
    };
}
exports.UserListItemDirective = UserListItemDirective;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ActivityDirective.$inject = ['asset'];
function ActivityDirective(asset) {
    return {
        templateUrl: asset.templateUrl('apps/users/views/activity-list.html'),
    };
}
exports.ActivityDirective = ActivityDirective;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
UserMentioDirective.$inject = ['userList', 'desks', 'asset', '$q'];
function UserMentioDirective(userList, desks, asset, $q) {
    return {
        templateUrl: asset.templateUrl('apps/users/views/mentions.html'),
        link: function (scope, elem) {
            scope.users = [];
            scope.fetching = false;
            scope.prefix = '';
            var fetchedPages = [];
            var container = elem.children()[0];
            elem.children().bind('scroll', function () {
                if (container.scrollTop + container.offsetHeight >= container.scrollHeight - 3) {
                    container.scrollTop = container.scrollTop - 3;
                    scope.fetchNext();
                }
            });
            // Calculates the next page and calls fetchItems for new items
            scope.fetchNext = function () {
                var page = scope.users.length / 10 + 1;
                fetchItems(scope.prefix, page);
            };
            // Returns the next set of results
            function fetchItems(prefix, page) {
                if (!scope.fetching && !lodash_1.default.includes(fetchedPages, page)) {
                    var promises = [];
                    scope.fetching = true;
                    promises.push(getFilteredUsers(prefix, scope.users, page));
                    promises.push(getFilteredDesks(scope.prefix, scope.users, page));
                    $q.all(promises).then(function () {
                        scope.users = lodash_1.default.sortBy(scope.users, function (item) { return item.type === 'user' ?
                            item.item.username.toLowerCase()
                            : item.item.name.toLowerCase(); });
                        scope.fetching = false;
                        fetchedPages.push(page);
                    });
                }
            }
            // Returns the next set of users
            function getFilteredUsers(prefix, list, page) {
                return userList.get(prefix, page, 10).then(function (result) {
                    var filteredUsers = result._items.slice((page - 1) * 10, page * 10);
                    lodash_1.default.each(filteredUsers, function (user) {
                        list.push({ type: 'user', item: user });
                    });
                });
            }
            // Returns the next set of desks
            function getFilteredDesks(prefix, list, page) {
                return desks.initialize().then(function () {
                    var filteredDesks = desks.desks._items;
                    if (scope.prefix) {
                        filteredDesks = lodash_1.default.filter(desks.desks._items, function (item) { return lodash_1.default.startsWith(item.name.toLowerCase(), prefix.toLowerCase()); });
                    }
                    if (page) {
                        filteredDesks = filteredDesks.slice((page - 1) * 10, page * 10);
                    }
                    lodash_1.default.each(filteredDesks, function (item) {
                        list.push({ type: 'desk', item: item });
                    });
                });
            }
            // filter user by given prefix
            scope.searchUsersAndDesks = function (prefix) {
                scope.prefix = prefix;
                scope.users = [];
                fetchedPages = [];
                fetchItems(scope.prefix, 1);
            };
            scope.select = function (item) {
                return item.type === 'user' ? '@' + item.item.username : '#' + item.item.name.replace(' ', '_');
            };
            scope.$watchCollection(function () { return $('.users-list-embed>li.active'); }, function (newValue) {
                if (newValue.hasClass('active')) {
                    $('.mentio-menu').scrollTop(newValue.position().top);
                }
            });
        },
    };
}
exports.UserMentioDirective = UserMentioDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
UserInfoDirective.$inject = ['userPopup'];
function UserInfoDirective(userPopup) {
    return {
        link: function (scope, element, attrs) {
            element.addClass('user-link');
            element.hover(function () {
                userPopup.set(attrs.user, element, scope);
            }, function () {
                userPopup.close();
            });
        },
    };
}
exports.UserInfoDirective = UserInfoDirective;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
UserActivityDirective.$inject = ['profileService', 'asset'];
function UserActivityDirective(profileService, asset) {
    return {
        restrict: 'A',
        replace: true,
        templateUrl: asset.templateUrl('apps/users/views/activity-feed.html'),
        scope: {
            user: '=',
        },
        link: function (scope, element, attrs) {
            var page = 1;
            var maxResults = 5;
            scope.max_results = maxResults;
            scope.$watch('user', function () {
                profileService.getUserActivity(scope.user, maxResults).then(function (list) {
                    scope.activityFeed = list;
                });
            });
            scope.loadMore = function () {
                page++;
                profileService.getUserActivity(scope.user, maxResults, page).then(function (next) {
                    Array.prototype.push.apply(scope.activityFeed._items, next._items);
                    scope.activityFeed._links = next._links;
                    scope.max_results += maxResults;
                });
            };
        },
    };
}
exports.UserActivityDirective = UserActivityDirective;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(553);
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
API.$inject = ['apiProvider'];
function API(apiProvider) {
    apiProvider.api('users', {
        type: 'http',
        backend: { rel: 'users' },
    });
    apiProvider.api('roles', {
        type: 'http',
        backend: { rel: 'roles' },
    });
    apiProvider.api('resetPassword', {
        type: 'http',
        backend: { rel: 'reset_user_password' },
    });
    apiProvider.api('changePassword', {
        type: 'http',
        backend: { rel: 'change_user_password' },
    });
}
exports.API = API;
Activities.$inject = ['superdeskProvider', 'assetProvider'];
function Activities(superdesk, asset) {
    superdesk
        .activity('/users/', {
        label: utils_1.gettext('User management'),
        description: utils_1.gettext('Find your colleagues'),
        controller: controllers_1.UserListController,
        templateUrl: asset.templateUrl('apps/users/views/list.html'),
        category: superdesk.MENU_MAIN,
        adminTools: true,
        reloadOnSearch: false,
        filters: [
            {
                action: superdesk.ACTION_PREVIEW,
                type: 'user',
            },
            { action: 'list', type: 'user' },
        ],
        privileges: { users: 1 },
    })
        .activity('/users/:_id', {
        label: utils_1.gettext('Users Profile'),
        priority: 100,
        controller: controllers_1.UserEditController,
        templateUrl: asset.templateUrl('apps/users/views/edit.html'),
        resolve: { user: controllers_1.UserResolver },
        filters: [{ action: 'detail', type: 'user' }],
        privileges: { users: 1 },
    })
        .activity('/settings/user-roles', {
        label: utils_1.gettext('User Roles'),
        templateUrl: asset.templateUrl('apps/users/views/settings.html'),
        controller: controllers_1.UserRolesController,
        category: superdesk.MENU_SETTINGS,
        settings_menu_group: activity_1.coreMenuGroups.WORKFLOW,
        priority: -500,
        privileges: { roles: 1 },
    })
        .activity('delete/user', {
        label: utils_1.gettext('Disable user'),
        icon: 'trash',
        confirm: utils_1.gettext('Please confirm that you want to disable a user.'),
        controller: controllers_1.UserDeleteCommand,
        filters: [
            {
                action: superdesk.ACTION_EDIT,
                type: 'user',
            },
        ],
        condition: function (data) {
            return data.is_enabled;
        },
        privileges: { users: 1 },
    })
        .activity('clear/sessions', {
        label: utils_1.gettext('Clear sessions'),
        icon: 'kill',
        confirm: utils_1.gettext('Please confirm that you want to delete all the sessions for this user.'),
        controller: controllers_1.SessionsDeleteCommand,
        filters: [
            {
                action: superdesk.ACTION_EDIT,
                type: 'user',
            },
        ],
        condition: function (data) { return data.is_enabled; },
        privileges: { users: 1 },
    })
        .activity('restore/user', {
        label: utils_1.gettext('Enable user'),
        icon: 'revert',
        controller: controllers_1.UserEnableCommand,
        filters: [
            {
                action: superdesk.ACTION_EDIT,
                type: 'user',
            },
        ],
        condition: function (data) { return !data.is_enabled; },
        privileges: { users: 1 },
    })
        .activity('edit.avatar', {
        label: utils_1.gettext('Change avatar'),
        modal: true,
        cssClass: 'upload-avatar modal--large modal--z-index-fix',
        controller: controllers_1.ChangeAvatarController,
        templateUrl: asset.templateUrl('apps/users/views/change-avatar.html'),
        filters: [{ action: 'edit', type: 'avatar' }],
    });
}
exports.Activities = Activities;
Permissions.$inject = ['superdeskProvider'];
function Permissions(superdesk) {
    superdesk
        .permission('users-manage', {
        label: utils_1.gettext('Manage users'),
        permissions: { users: { write: true } },
    })
        .permission('users-read', {
        label: utils_1.gettext('Read users'),
        permissions: { users: { read: true } },
    })
        .permission('user-roles-manage', {
        label: utils_1.gettext('Manage user roles'),
        permissions: { user_roles: { write: true } },
    })
        .permission('user-roles-read', {
        label: utils_1.gettext('Read user roles'),
        permissions: { user_roles: { read: true } },
    });
}
exports.Permissions = Permissions;
exports.KeyboardShortcuts = ['keyboardManager',
    function (keyboardManager) {
        keyboardManager.register('Users', 'Up', utils_1.gettext('Previous user'));
        keyboardManager.register('Users', 'Down', utils_1.gettext('Next user'));
    },
];


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1490);
var filters_1 = __webpack_require__(1492);
var services_1 = __webpack_require__(1493);
var controllers_1 = __webpack_require__(1495);
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.products
 * @name superdesk.apps.products
 * @packageName superdesk.apps
 * @description Adds products support to Superdesk.
 */
exports.default = angular.module('superdesk.apps.products', ['superdesk.apps.users'])
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/settings/products', {
            label: utils_1.gettext('Products'),
            controller: controllers_1.ProductsConfigController,
            templateUrl: 'scripts/apps/products/views/settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_FLOW,
            privileges: { products: 1 },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('products', { type: 'http', backend: { rel: 'products' } });
    }])
    .filter('productsBy', filters_1.ProductsFilter)
    .controller('ProductsConfigCtrl', controllers_1.ProductsConfigController)
    .factory('products', services_1.ProductsFactory)
    .directive('sdProductsConfigModal', function () { return ({
    templateUrl: 'scripts/apps/products/views/products-config-modal.html',
}); });


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1491);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./products.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./products.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n/* \t============================\r\n\t\tPRODUCT CONFIG\r\n\t============================ */\n/* Product create/edit popup */\n.add-product-popup .modal-body {\n  bottom: 0;\n  height: 500px !important;\n  max-height: 500px !important;\n  border-radius: 0px 0px 4px 4px; }\n  .add-product-popup .modal-body .modal-screen {\n    top: 48px; }\n\n.product-search {\n  float: left;\n  max-width: 650px;\n  margin-left: 10px; }\n  .product-search input {\n    width: 505px;\n    float: left; }\n  .product-search select {\n    width: 100px; }\n\n.pills-list .match {\n  background-color: #c9e8ca; }\n\n.pills-list .no-match {\n  background-color: #fde9e9; }\n", ""]);

// exports


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc filter
 * @module superdesk.apps.products
 * @name ProductsFilter
 * @description Returns a function that allows filtering an array of
 * products by various criteria.
 */
function ProductsFilter() {
    /**
     * @description Returns a new array based on the passed filter.
     * @param {Array<Object>} items - Array of templates to filter.
     * @param {Object} search - The filter. search by name and product type.
     * @returns {Array<Object>} The filtered array.
     */
    return function (items, search) {
        if (!search) {
            return items;
        }
        var filteredItems = items;
        if (search.name && search.name !== '') {
            var regExp_1 = new RegExp(search.name, 'i');
            filteredItems = filteredItems.filter(function (item) { return item.name.match(regExp_1); });
        }
        if (search.product_type && search.product_type !== '') {
            filteredItems = filteredItems.filter(function (item) { return (item.product_type || 'both') === search.product_type; });
        }
        return filteredItems;
    };
}
exports.ProductsFilter = ProductsFilter;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProductsFactory_1 = __webpack_require__(1494);
exports.ProductsFactory = ProductsFactory_1.ProductsFactory;


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
ProductsFactory.$inject = ['$q', 'api', 'contentFilters', '$filter'];
function ProductsFactory($q, api, contentFilters, $filter) {
    /**
     * Recursivly returns all products
     *
     * @return {*}
     */
    var _getAllProducts = function (page, products) {
        if (page === void 0) { page = 1; }
        if (products === void 0) { products = []; }
        return api('products')
            .query({ max_results: 200, page: page })
            .then(function (result) {
            var pg = page;
            var merged = products.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAllProducts(pg, merged);
            }
            return $filter('sortByName')(merged);
        });
    };
    var productsService = {
        products: null,
        contentFilters: null,
        productLookup: {},
        fetchProducts: function () {
            var self = this;
            return _getAllProducts()
                .then(function (result) {
                self.products = result;
                lodash_1.default.each(result._items, function (product) {
                    self.productLookup[product._id] = product;
                });
            });
        },
        fetchAllProducts: function () {
            return _getAllProducts();
        },
        fetchContentFilters: function () {
            var self = this;
            return contentFilters.getAllContentFilters().then(function (filters) {
                self.contentFilters = $filter('sortByName')(filters);
            });
        },
        testProducts: function (diff) {
            return api.save('product_tests', {}, diff);
        },
        initialize: function () {
            return this.fetchProducts()
                .then(angular.bind(this, this.fetchContentFilters));
        },
    };
    return productsService;
}
exports.ProductsFactory = ProductsFactory;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProductsConfigController_1 = __webpack_require__(1496);
exports.ProductsConfigController = ProductsConfigController_1.ProductsConfigController;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.products
 * @name ProductsConfigCtrl
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires notify
 * @requires api
 * @requires products
 * @requires modal
 * @requires subscribersService
 * @requires metadata
 * @requires $filter
 * @description ProductsConfigController holds a set of convenience functions for product maintenance.
 */
ProductsConfigController.$inject = ['$scope', 'notify', 'api', 'products', 'modal',
    'subscribersService', 'metadata', '$filter'];
function ProductsConfigController($scope, notify, api, products, modal, subscribersService, metadata, $filter) {
    $scope.testLookup = {};
    $scope.productLookup = {};
    $scope.loading = false;
    $scope.resultType = 'All';
    $scope.products = [];
    /**
     * @ngdoc method
     * @private
     * @name ProductsConfigCtrl#initProducts
     * @description Initialize products and products lookup.
     */
    var initProducts = function () {
        products.initialize().then(function () {
            $scope.products = products.products;
            $scope.contentFilters = products.contentFilters;
            lodash_1.default.each(products.products, function (product) {
                $scope.productLookup[product._id] = product;
            });
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name ProductsConfigCtrl#initSubscribers
     * @description Initialize subscribers.
     */
    var initSubscribers = function () {
        if (!$scope.subscribers) {
            subscribersService.fetchSubscribers().then(function (items) {
                $scope.subscribers = items;
            });
        }
    };
    /**
     * @ngdoc method
     * @private
     * @name ProductsConfigCtrl#initRegions
     * @description Initialize regions.
     */
    var initRegions = function () {
        if (angular.isDefined(metadata.values.geographical_restrictions)) {
            $scope.geoRestrictions = $filter('sortByName')(metadata.values.geographical_restrictions);
        }
        else {
            metadata.fetchMetadataValues().then(function () {
                $scope.geoRestrictions = $filter('sortByName')(metadata.values.geographical_restrictions);
            });
        }
    };
    /**
     * @ngdoc method
     * @private
     * @name ProductsConfigCtrl#initProductTypes
     * @description Initialize product types.
     */
    var initProductTypes = function () {
        if (angular.isDefined(metadata.values.product_types)) {
            $scope.product_types = $filter('sortByName')(metadata.values.product_types);
        }
        else {
            metadata.fetchMetadataValues().then(function () {
                $scope.product_types = $filter('sortByName')(metadata.values.product_types);
            });
        }
    };
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#newProduct
     * @public
     * @description Initialize the modal to create new product.
     */
    $scope.newProduct = function () {
        $scope.product.edit = {};
        $scope.product.edit.content_filter = {};
        $scope.product.edit.content_filter.filter_type = 'permitting';
        $scope.modalActive = true;
    };
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#edit
     * @public
     * @description Edit a product.
     * @param {Object} product The product to be edited.
     */
    $scope.edit = function (product) {
        $scope.product = product;
        $scope.product.edit = lodash_1.default.create(product);
        $scope.product.edit.content_filter = lodash_1.default.create(product.content_filter || {});
        $scope.modalActive = true;
    };
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#cancel
     * @public
     * @description Close the modal and refresh products
     */
    $scope.cancel = function () {
        $scope.modalActive = false;
        $scope.product = {};
        $scope.product.edit = null;
        initProducts();
        initSubscribers();
        initRegions();
        initProductTypes();
    };
    $scope.cancel();
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#save
     * @public
     * @description Save the product.
     */
    $scope.save = function () {
        var product = lodash_1.default.omit($scope.product, 'edit');
        api.products.save(product, $scope.product.edit).then(function () {
            notify.success(utils_1.gettext('Product is saved.'));
            $scope.cancel();
        }, function (response) {
            if (angular.isDefined(response.data._issues) &&
                angular.isDefined(response.data._issues['validator exception'])) {
                notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
            }
            else if (angular.isDefined(response.data._issues)) {
                if (response.data._issues.name && response.data._issues.name.unique) {
                    notify.error(utils_1.gettext('Error: Name needs to be unique'));
                }
                else if (response.data._issues.product_type) {
                    notify.error(utils_1.gettext('Error: ' + utils_1.gettext('Product Type is required')));
                }
                else {
                    notify.error(utils_1.gettext('Error: ' + JSON.stringify(response.data._issues)));
                }
            }
        });
    };
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#remove
     * @public
     * @description Delete the product
     * @param {Object} product The product to be removed.
     */
    $scope.remove = function (product) {
        modal.confirm(utils_1.gettext('Are you sure you want to delete product?')).then(function () {
            var remove = api.products.remove(product).then(function () {
                notify.success(utils_1.gettext('Product deleted.'));
            }, function (response) {
                if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('Error: Failed to delete product.'));
                }
            });
            return remove;
        })
            .then($scope.cancel);
    };
    /**
     * @ngdoc method
     * @name ProductsConfigCtrl#test
     * @public
     * @description Test a given item is valid for product or not.
     */
    $scope.test = function () {
        if (!$scope.articleId) {
            notify.error(utils_1.gettext('Please provide an article id'));
            return;
        }
        $scope.loading = true;
        products.testProducts({ article_id: $scope.articleId }).then(function (results) {
            $scope.rawResults = results;
            $scope.filteredProducts = [];
            if ($scope.resultType === 'All') {
                $scope.filteredProducts = $scope.products;
            }
            lodash_1.default.each(results._items, function (result) {
                $scope.testLookup[result.product_id] = result;
                if (result.matched && $scope.resultType === 'Match' ||
                    !result.matched && $scope.resultType === 'No-Match') {
                    $scope.filteredProducts.push($scope.productLookup[result.product_id]);
                }
            });
        }, function (response) {
            var msg = response.data && response.data._message ? response.data._message : JSON.stringify(response);
            notify.error(utils_1.gettext('Error: ' + msg));
        })
            .finally(function () {
            $scope.loading = false;
        });
    };
}
exports.ProductsConfigController = ProductsConfigController;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1498);
var svc = __importStar(__webpack_require__(1500));
var ctrl = __importStar(__webpack_require__(1504));
var directive = __importStar(__webpack_require__(1510));
var filter = __importStar(__webpack_require__(1513));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.publish
 * @name superdesk.apps.publish
 * @packageName superdesk.apps
 * @description Superdesk publishing support.
 */
exports.default = angular.module('superdesk.apps.publish', ['superdesk.apps.users', 'superdesk.apps.content_filters'])
    .service('adminPublishSettingsService', svc.AdminPublishSettingsService)
    .service('subscribersService', svc.SubscribersService)
    .directive('sdAdminPubSubscribers', directive.SubscribersDirective)
    .directive('sdDestination', directive.DestinationDirective)
    .filter('subscribersBy', filter.SubscribersFilter)
    .controller('publishQueueCtrl', ctrl.PublishQueueController)
    .controller('SubscriberTokenCtrl', ctrl.SubscriberTokenController)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/settings/publish', {
            label: utils_1.gettext('Subscribers'),
            templateUrl: 'scripts/apps/publish/views/settings.html',
            controller: ctrl.AdminPublishSettingsController,
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_FLOW,
            privileges: { subscribers: 1 },
            priority: 2000,
        })
            .activity('/publish_queue', {
            label: utils_1.gettext('Publish Queue'),
            templateUrl: 'scripts/apps/publish/views/publish-queue.html',
            controller: ctrl.PublishQueueController,
            category: superdesk.MENU_MAIN,
            adminTools: false,
            privileges: { publish_queue: 1 },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('subscribers', {
            type: 'http',
            backend: { rel: 'subscribers' },
        });
        apiProvider.api('publish_queue', {
            type: 'http',
            backend: { rel: 'publish_queue' },
        });
        apiProvider.api('consistency', {
            type: 'http',
            backend: { rel: 'consistency' },
        });
        apiProvider.api('legal_publish_queue', {
            type: 'http',
            backend: { rel: 'legal_publish_queue' },
        });
        apiProvider.api('io_errors', {
            type: 'http',
            backend: { rel: 'io_errors' },
        });
    }]);


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1499);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./publish.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./publish.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\ndiv {\n  -webkit-column-rule: 4px outset #ff00ff;\n  /* Chrome, Safari, Opera */\n  -moz-column-rule: 4px outset #ff00ff;\n  /* Firefox */\n  column-rule: 4px outset #ff00ff; }\n\n.filter-result-modal {\n  position: absolute; }\n  .filter-result-modal .content .active {\n    background-color: #eff7fa !important;\n    border-right: 2px solid rgba(94, 169, 200, 0.75) !important; }\n    .filter-result-modal .content .active:hover .item-functions {\n      background-color: #eff7fa; }\n      .filter-result-modal .content .active:hover .item-functions .item-field:hover {\n        background-color: #d6e8ef; }\n      .filter-result-modal .content .active:hover .item-functions .item-field.disabled:hover {\n        background-color: #d6e8ef; }\n\n.destination-box {\n  margin: 0 0 12px 0;\n  padding: 12px 12px 0;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.12);\n  box-sizing: border-box; }\n\n.multi-action-bar .btn.btn--primary {\n  margin-top: 10px !important; }\n\n.subnav.active {\n  background-color: #fff; }\n\n.publish-queue {\n  top: 48px; }\n  .publish-queue header .refresh-box span {\n    font-style: italic;\n    padding: 16px 0;\n    margin-right: 20px; }\n  .publish-queue .preview-layout .list-pane > .content {\n    overflow: auto;\n    right: 400px; }\n  .publish-queue .preview-layout.closed .list-pane > .content {\n    right: 0; }\n  .publish-queue .shift-preview__toggle {\n    display: none; }\n\n.subscriber-modal .tab-content .tab-pane {\n  min-height: 400px; }\n\n.products-content .sortbar span, .subscribers-content .sortbar span {\n  margin-left: 5px; }\n", ""]);

// exports


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubscribersService_1 = __webpack_require__(1501);
exports.SubscribersService = SubscribersService_1.SubscribersService;
var AdminPublishSettingsService_1 = __webpack_require__(1502);
exports.AdminPublishSettingsService = AdminPublishSettingsService_1.AdminPublishSettingsService;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
SubscribersService.$inject = ['api', '$q', '$filter'];
function SubscribersService(api, $q, $filter) {
    /**
     * Recursively returns all subscribers
     *
     * @return {*}
     */
    var _getAllSubscribers = function (criteria, page, subscribers) {
        if (criteria === void 0) { criteria = {}; }
        if (page === void 0) { page = 1; }
        if (subscribers === void 0) { subscribers = []; }
        return api.query('subscribers', lodash_1.default.extend({ max_results: 200, page: page }, criteria))
            .then(function (result) {
            var pg = page;
            var merged = subscribers.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAllSubscribers(criteria, pg, merged);
            }
            return $filter('sortByName')(merged);
        });
    };
    var service = {
        fetched: null,
        subscribersLookup: {},
        subscribers: null,
        fetchSubscribers: function (criteria) {
            return _getAllSubscribers(criteria);
        },
        fetchActiveSubscribers: function (criteria) {
            return _getAllSubscribers(criteria).then(function (result) { return lodash_1.default.filter(result, { is_active: true }); });
        },
        fetchTargetableSubscribers: function (criteria) {
            return _getAllSubscribers(criteria)
                .then(function (result) {
                return lodash_1.default.filter(result, function (r) { return (!('is_targetable' in r) || r.is_targetable) && r.is_active; });
            });
        },
        fetchSubscribersByKeyword: function (keyword) {
            return this.fetchSubscribers({ $or: [{ name: { $regex: keyword, $options: '-i' } }] });
        },
        fetchSubscribersByIds: function (ids) {
            var parts = [];
            lodash_1.default.each(ids, function (id) {
                parts.push({ _id: id });
            });
            return this.fetchSubscribers({ $or: parts });
        },
        initialize: function () {
            var _this = this;
            if (!this.fetched) {
                this.fetched = _getAllSubscribers()
                    .then(function (subscribers) {
                    _this.subscribers = subscribers;
                    _this.subscribersLookup = lodash_1.default.keyBy(subscribers, '_id');
                });
            }
            return this.fetched;
        },
    };
    return service;
}
exports.SubscribersService = SubscribersService;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(1503);
AdminPublishSettingsService.$inject = ['api'];
function AdminPublishSettingsService(api) {
    var _fetch = function (endpoint, criteria) {
        return api[endpoint].query(criteria);
    };
    var service = {
        transmissionServicesMap: constants_1.transmissionTypes,
        fetchPublishErrors: function () {
            var criteria = { io_type: 'publish' };
            return _fetch('io_errors', criteria);
        },
        registerTransmissionService: function (name, props) {
            this.transmissionServicesMap[name] = {
                delivery_type: name,
                label: props.label ? props.label : name,
                templateUrl: props.templateUrl ? props.templateUrl : '',
                config: props.config ? props.config : null,
            };
        },
        getTransmissionServices: function () {
            return this.transmissionServicesMap;
        },
    };
    return service;
}
exports.AdminPublishSettingsService = AdminPublishSettingsService;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.transmissionTypes = {
    ftp: {
        label: 'FTP',
        templateUrl: 'scripts/apps/publish/views/ftp-config.html',
        config: { passive: true },
    },
    email: {
        label: 'Email',
        templateUrl: 'scripts/apps/publish/views/email-config.html',
    },
    ODBC: {
        label: 'ODBC',
        templateUrl: 'scripts/apps/publish/views/odbc-config.html',
    },
    File: {
        label: 'File',
        templateUrl: 'scripts/apps/publish/views/file-config.html',
    },
    http_push: {
        label: 'HTTP Push',
        templateUrl: 'scripts/apps/publish/views/http-push-config.html',
    },
};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AdminPublishSettingsController_1 = __webpack_require__(1505);
exports.AdminPublishSettingsController = AdminPublishSettingsController_1.AdminPublishSettingsController;
var DataConsistencyController_1 = __webpack_require__(1506);
exports.DataConsistencyController = DataConsistencyController_1.DataConsistencyController;
var PublishQueueController_1 = __webpack_require__(1507);
exports.PublishQueueController = PublishQueueController_1.PublishQueueController;
var SubscriberTokenController_1 = __webpack_require__(1509);
exports.SubscriberTokenController = SubscriberTokenController_1.SubscriberTokenController;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
AdminPublishSettingsController.$inject = ['$scope', 'privileges'];
function AdminPublishSettingsController($scope, privileges) {
    var userPrivileges = privileges.privileges;
    $scope.showSubscribers = Boolean(userPrivileges.subscribers);
    $scope.showFilterConditions = Boolean(userPrivileges.publish_filters);
}
exports.AdminPublishSettingsController = AdminPublishSettingsController;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DataConsistencyController.$inject = ['$scope', 'api'];
function DataConsistencyController($scope, api) {
    $scope.consistency_records = null;
    function fetchConsistencyRecords() {
        var criteria = criteria || {};
        criteria.max_results = 200;
        return api.consistency.query(criteria);
    }
    $scope.reload = function () {
        fetchConsistencyRecords().then(function (data) {
            $scope.consistency_records = data._items;
            $scope.lastRefreshedAt = new Date();
        });
    };
    $scope.reload();
}
exports.DataConsistencyController = DataConsistencyController;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var isSuperdeskContent_1 = __webpack_require__(1508);
var utils_1 = __webpack_require__(3);
PublishQueueController.$inject = [
    '$scope',
    'subscribersService',
    'api',
    '$q',
    'notify',
    '$location',
    'ingestSources',
    'vocabularies',
];
function PublishQueueController($scope, subscribersService, api, $q, notify, $location, ingestSources, vocabularies) {
    $scope.subscribers = null;
    $scope.subscriberLookup = {};
    $scope.ingestProviders = null;
    $scope.ingestProvidersLookup = {};
    $scope.publish_queue = [];
    $scope.contentTypes = null;
    $scope.selectedFilterSubscriber = null;
    $scope.selectedFilterIngestProvider = null;
    $scope.selectedFilterContentType = null;
    $scope.multiSelectCount = 0;
    $scope.selectedQueueItems = [];
    $scope.showResendBtn = false;
    $scope.showCancelBtn = false;
    $scope.showCancelSelectionBtn = false;
    $scope.queueSearch = false;
    $scope.selected = {};
    $scope.publish_queue_statuses = ['pending', 'in-progress', 'success', 'error', 'retrying', 'failed', 'canceled'];
    $scope.pageSize = 25;
    $scope.page = 1;
    $scope.$watch('page', function () {
        $scope.reload();
    });
    var promises = [];
    promises.push(subscribersService.fetchSubscribers().then(function (items) {
        $scope.subscribers = items;
        $scope.subscriberLookup = lodash_1.default.keyBy(items, '_id');
    }));
    promises.push(ingestSources.fetchAllIngestProviders().then(function (items) {
        $scope.ingestProviders = items;
        $scope.ingestProvidersLookup = lodash_1.default.keyBy($scope.ingestProviders, '_id');
    }));
    promises.push(vocabularies.getVocabulary('type').then(function (items) {
        $scope.contentTypes = items.items;
    }));
    /*
    * Get search input from search box to search for headline or unique_name,
    * and perfrom reload function to populate publish queue.
    */
    $scope.search = function (query) {
        $scope.searchQuery = query;
        $scope.page = 1;
        $scope.reload();
    };
    /*
    * Populates the publish queue and update the flags after fetch operation.
    */
    function populatePublishQueue() {
        fetchPublishQueue().then(function (queue) {
            var queuedItems = queue._items;
            lodash_1.default.forEach(queuedItems, function (item) {
                angular.extend(item, { selected: false });
            });
            $scope.publish_queue = queuedItems;
            $scope.lastRefreshedAt = new Date();
            $scope.showResendBtn = false;
            $scope.showCancelSelectionBtn = false;
            $scope.maxPage = Math.ceil(queue._meta.total / $scope.pageSize);
        });
    }
    /*
    * Fetch the publish queue on the basis of built criteria.
    */
    function fetchPublishQueue() {
        var criteria = criteria || {};
        criteria.max_results = $scope.pageSize;
        criteria.page = $scope.page;
        var orTerms = null;
        if (!lodash_1.default.isEmpty($scope.searchQuery)) {
            orTerms = { $or: [
                    { headline: {
                            $regex: $scope.searchQuery,
                            $options: '-i'
                        },
                    }, { unique_name: $scope.searchQuery },
                ] };
        }
        var filterTerms = [];
        if (!lodash_1.default.isNil($scope.selectedFilterSubscriber)) {
            filterTerms.push({ subscriber_id: $scope.selectedFilterSubscriber._id });
        }
        if (!lodash_1.default.isNil($scope.selectedFilterStatus)) {
            filterTerms.push({ state: $scope.selectedFilterStatus });
        }
        if (!lodash_1.default.isNil($scope.selectedFilterIngestProvider)) {
            filterTerms.push({ ingest_provider: $scope.selectedFilterIngestProvider._id });
        }
        if (!lodash_1.default.isNil($scope.selectedFilterContentType)) {
            filterTerms.push({ content_type: $scope.selectedFilterContentType.qcode });
        }
        var andTerms = [];
        lodash_1.default.each(filterTerms, function (term) {
            andTerms.push(term);
        });
        if (orTerms !== null) {
            andTerms.push(orTerms);
        }
        if (!lodash_1.default.isEmpty(andTerms)) {
            criteria.where = JSON.stringify({
                $and: andTerms,
            });
        }
        return api.publish_queue.query(criteria);
    }
    $scope.reload = function () {
        $q.all(promises).then(function () {
            populatePublishQueue();
            previewItem();
        });
    };
    $scope.buildNewSchedule = function (item) {
        var pickFields = ['item_id', 'item_version', 'publishing_action', 'formatted_item', 'headline',
            'content_type', 'subscriber_id', 'unique_name', 'destination', 'ingest_provider',
            'item_encoding', 'encoded_item_id'];
        var newItem = lodash_1.default.pick(item, pickFields);
        return newItem;
    };
    $scope.scheduleToSend = function (item) {
        var queueItems = [];
        if (angular.isDefined(item)) {
            queueItems.push($scope.buildNewSchedule(item));
        }
        else if ($scope.multiSelectCount > 0) {
            lodash_1.default.forEach($scope.selectedQueueItems, function (_item) {
                queueItems.push($scope.buildNewSchedule(_item));
            });
        }
        api.publish_queue.save([], queueItems).then(function (response) {
            $scope.reload();
            $scope.cancelSelection();
        }, function (response) {
            if (angular.isDefined(response.data._issues)) {
                if (angular.isDefined(response.data._issues['validator exception'])) {
                    notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
                }
            }
            else {
                notify.error(utils_1.gettext('Error: Failed to re-schedule'));
            }
        });
    };
    $scope.cancelSend = function (item) {
        var itemList = [];
        if (angular.isDefined(item)) {
            itemList.push(item);
        }
        else if ($scope.multiSelectCount > 0) {
            lodash_1.default.forEach($scope.selectedQueueItems, function (_item) {
                if (_item.state === 'pending' || _item.state === 'retrying') {
                    _item.state = 'canceled';
                    itemList.push(_item);
                }
            });
        }
        lodash_1.default.forEach(itemList, function (_item) {
            api.publish_queue.update(_item, { state: 'canceled' });
        });
        $scope.cancelSelection();
    };
    $scope.filterPublishQueue = function (item, type) {
        switch (type) {
            case 'subscriber':
                $scope.selectedFilterSubscriber = item;
                break;
            case 'ingest_provider':
                $scope.selectedFilterIngestProvider = item;
                break;
            case 'status':
                $scope.selectedFilterStatus = item;
                break;
            case 'type':
                $scope.selectedFilterContentType = item;
                break;
            default:
                $scope.selectedFilterSubscriber = null;
                $scope.selectedFilterIngestProvider = null;
                $scope.selectedFilterStatus = null;
                $scope.selectedFilterContentType = null;
        }
        populatePublishQueue();
        $scope.multiSelectCount = 0;
        $scope.selectedQueueItems = [];
        $scope.page = 1;
    };
    $scope.selectQueuedItem = function (queuedItem) {
        if (queuedItem.selected) {
            $scope.selectedQueueItems = lodash_1.default.union($scope.selectedQueueItems, [queuedItem]);
        }
        else {
            $scope.selectedQueueItems = lodash_1.default.without($scope.selectedQueueItems, queuedItem);
        }
        /* look for any items in states that cannot be resent */
        var idx = lodash_1.default.findIndex($scope.selectedQueueItems, function (item) { return lodash_1.default.includes(['pending', 'in-progress', 'retrying'], item.state); });
        /* All selected items can be resent */
        if (idx === -1) {
            $scope.showResendBtn = true;
            $scope.showCancelBtn = false;
            $scope.showCanceSelectionlBtn = false;
        }
        else {
            /* Find the index of any item that can be resent */
            idx = lodash_1.default.findIndex($scope.selectedQueueItems, function (item) { return item.state === 'success' || item.state === 'in-progress' || item.state === 'canceled' ||
                item.state === 'error' || item.state === 'retrying'; });
            /* Nothing to resend found */
            if (idx === -1) {
                $scope.showResendBtn = false;
                $scope.showCancelSelectionBtn = true;
                /* look for items that can be canceled */
                idx = lodash_1.default.findIndex($scope.selectedQueueItems, function (item) { return item.state === 'pending' || item.state === 'retrying'; });
                /* Something can be canceled so show the button */
                if (idx !== -1) {
                    $scope.showCancelBtn = true;
                }
                else {
                    $scope.showCancelBtn = false;
                }
            }
            else {
                $scope.showResendBtn = false;
                $scope.showCancelBtn = false;
                $scope.showCancelSelectionBtn = false;
            }
        }
        $scope.multiSelectCount = $scope.selectedQueueItems.length;
    };
    $scope.cancelSelection = function () {
        $scope.selectedQueueItems = [];
        $scope.multiSelectCount = 0;
        populatePublishQueue();
    };
    function refreshQueueState(data) {
        var item = lodash_1.default.find($scope.publish_queue, { _id: data.queue_id });
        if (item) {
            var fields = ['error_message', 'completed_at', 'state'];
            angular.extend(item, lodash_1.default.pick(data, fields));
            $scope.$apply();
        }
    }
    $scope.preview = function (queueItem) {
        $location.search('_id', queueItem ? queueItem._id : queueItem);
    };
    function previewItem() {
        var queueItem = lodash_1.default.find($scope.publish_queue, { _id: $location.search()._id }) || null;
        $scope.selected.extensionPoint = false;
        if (queueItem) {
            if (isSuperdeskContent_1.isSuperdeskContent(queueItem.content_type)) {
                api.archive.getById(queueItem.item_id, { version: queueItem.item_version })
                    .then(function (item) {
                    $scope.selected.preview = item;
                });
            }
            else {
                $scope.selected.preview = queueItem;
                $scope.selected.extensionPoint = true;
            }
        }
        else {
            $scope.selected.preview = null;
        }
    }
    $scope.$on('$routeUpdate', previewItem);
    $scope.$on('publish_queue:update', function (evt, data) {
        refreshQueueState(data);
    });
    $scope.reload();
}
exports.PublishQueueController = PublishQueueController;


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuperdeskContent = function (type) { return [
    'text',
    'audio',
    'video',
    'picture',
    'graphic',
    'composite',
].includes(type); };


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(__webpack_require__(5));
/**
 * @ngdoc controller
 * @module superdesk.apps.publish
 * @name SubscriberTokenController
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires api
 * @description SubscriberTokenController manages subsriber tokens for Content API.
 */
function SubscriberTokenController($scope, api) {
    var _this = this;
    var subscriber = $scope.subscriber;
    this.tokens = [];
    var fetchTokens = function () {
        if (subscriber._id) {
            api.query('subscriber_token', { where: { subscriber: subscriber._id } })
                .then(function (response) {
                _this.tokens = response._items;
            });
        }
    };
    var expiry = function (ttl) { return moment_1.default().utc()
        .add(parseInt(ttl, 10), 'days')
        .format(); };
    /**
     * @ngdoc method
     * @name SubscriberTokenController#generate
     * @param {string} ttl Token time to live in days.
     * @description Generate new token on server and refresh the list.
     */
    this.generate = function (ttl) {
        return api.save('subscriber_token', { subscriber: subscriber._id, expiry: expiry(ttl) })
            .then(fetchTokens);
    };
    /**
     * @ngdoc method
     * @name SubscriberTokenController#revoke
     * @param {Object} token Token object from api.
     * @description Revoke an existing token and refresh the list.
     */
    this.revoke = function (token) {
        return api.remove(token).then(fetchTokens);
    };
    /**
     * @ngdoc property
     * @name SubscriberTokenController#ttl
     * @type {string}
     * @description Default time to live value for new tokens.
     */
    this.ttl = '7'; // default ttl
    // init
    fetchTokens();
}
exports.SubscriberTokenController = SubscriberTokenController;
SubscriberTokenController.$inject = ['$scope', 'api'];


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DestinationDirective_1 = __webpack_require__(1511);
exports.DestinationDirective = DestinationDirective_1.DestinationDirective;
var SubscribersDirective_1 = __webpack_require__(1512);
exports.SubscribersDirective = SubscribersDirective_1.SubscribersDirective;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DestinationDirective.$inject = ['adminPublishSettingsService'];
function DestinationDirective(adminPublishSettingsService) {
    return {
        templateUrl: 'scripts/apps/publish/views/destination.html',
        scope: {
            destination: '=',
            actions: '=',
        },
        link: function ($scope) {
            $scope.types = adminPublishSettingsService.getTransmissionServices();
            $scope.$watch('destination.delivery_type', function (type) {
                if (type && !$scope.destination.config && $scope.types[type].config) {
                    $scope.destination.config = angular.extend({}, $scope.types[type].config);
                }
            });
        },
    };
}
exports.DestinationDirective = DestinationDirective;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.publish
 * @name sdAdminPubSubscribers
 * @requires notify
 * @requires api
 * @requires subscribersService
 * @requires adminPublishSettingsService
 * @requires modal
 * @requires metadata
 * @requires contentFilters
 * @requires $q
 * @requires $filter
 * @requires products
 * @param {Array} subscribersList - provided list of subscribers to display
 * @param {Boolean} hideHeader - controls the visibility of the header section
 * @description SubscribersDirective handles subscriber maintenance.
 */
SubscribersDirective.$inject = [
    'notify', 'api', 'subscribersService', 'adminPublishSettingsService', 'modal',
    'metadata', 'contentFilters', '$q', '$filter', 'products',
];
function SubscribersDirective(notify, api, subscribersService, adminPublishSettingsService, modal, metadata, contentFilters, $q, $filter, products) {
    return {
        scope: {
            subscribersList: '=',
            hideHeader: '=',
        },
        templateUrl: 'scripts/apps/publish/views/subscribers.html',
        link: function ($scope) {
            $scope.subscriber = null;
            $scope.origSubscriber = null;
            $scope.subscribers = $scope.subscribersList || null;
            $scope.newDestination = null;
            $scope.contentFilters = null;
            $scope.apiProducts = null;
            $scope.directProducts = null;
            $scope.subTypes = null;
            $scope.search = {};
            if (angular.isDefined(metadata.values.subscriber_types)) {
                $scope.subTypes = metadata.values.subscriber_types;
            }
            else {
                metadata.fetchMetadataValues().then(function () {
                    $scope.subTypes = metadata.values.subscriber_types;
                });
            }
            $scope.statusFilters = [
                { label: utils_1.gettext('Active'), value: true, id: 'active' },
                { label: utils_1.gettext('Both'), value: null, id: 'both' },
                { label: utils_1.gettext('Inactive'), value: false, id: 'inactive' },
            ];
            $scope.search.subscriber_status = $scope.statusFilters[0];
            /**
             * Fetches all subscribers from backend
             */
            var fetchSubscribers = function () {
                subscribersService.fetchSubscribers().then(function (result) {
                    $scope.subscribers = result;
                });
            };
            /**
             * Fetches content filters from backend and returns the same.
             *
             * @return {*}
             */
            var fetchProducts = function () {
                return products.fetchAllProducts().then(function (items) {
                    $scope.productLookup = [];
                    lodash_1.default.each(items, function (item) {
                        item.name += " [" + (item.product_type || 'both') + "]";
                        $scope.productLookup[item._id] = item;
                    });
                    $scope.directProducts = lodash_1.default.filter(items, function (item) {
                        return lodash_1.default.includes(['direct', 'both'], item.product_type || 'both');
                    });
                    $scope.apiProducts = lodash_1.default.filter(items, function (item) {
                        return lodash_1.default.includes(['api', 'both'], item.product_type || 'both');
                    });
                });
            };
            /**
             * Initializes the Global Filters on the selected subscriber.
             */
            var initGlobalFilters = function () {
                if (!$scope.subscriber) {
                    return;
                }
                if (!$scope.subscriber.global_filters) {
                    $scope.subscriber.global_filters = {};
                }
                lodash_1.default.each($scope.globalFilters, function (filter) {
                    if (!(filter._id in $scope.subscriber.global_filters)) {
                        $scope.subscriber.global_filters[filter._id] = true;
                    }
                });
            };
            /**
             * Fetches list of global content filters and returns the same.
             *
             * @return {*}
             */
            var fetchGlobalContentFilters = function () {
                return contentFilters.getGlobalContentFilters().then(function (filters) {
                    $scope.globalFilters = filters;
                });
            };
            /**
             * Fetch list of publish errors from the backend allowing the user to configure for the selected subscriber.
             *
             * @return {*}
             */
            var fetchPublishErrors = function () {
                return adminPublishSettingsService.fetchPublishErrors().then(function (result) {
                    $scope.all_errors = result._items[0].all_errors;
                });
            };
            /**
             * Initializes the new destination object.
             */
            $scope.addNewDestination = function () {
                $scope.newDestination = {};
            };
            /**
             * Reverts the changes made to the new destination object
             */
            $scope.cancelNewDestination = function () {
                $scope.newDestination = null;
            };
            /**
             * Saves the destination and adds it to the destinations list of the selected subscriber
             */
            $scope.saveNewDestination = function () {
                $scope.destinations.push($scope.newDestination);
                $scope.newDestination = null;
            };
            /**
             * Removes the selected destination from the destinations list of the selected subscriber.
             */
            $scope.deleteDestination = function (destination) {
                lodash_1.default.remove($scope.destinations, destination);
            };
            /**
             * Upserts the selected subscriber.
             */
            $scope.save = function () {
                $scope.subscriber.destinations = $scope.destinations;
                var diff = {};
                lodash_1.default.forOwn($scope.subscriber, function (value, key) {
                    if (lodash_1.default.includes(['api_products', 'products'], key)) {
                        diff[key] = lodash_1.default.map(value, '_id');
                        return;
                    }
                    diff[key] = value;
                });
                api.subscribers.save($scope.origSubscriber, diff)
                    .then(function () {
                    notify.success(utils_1.gettext('Subscriber saved.'));
                    $scope.cancel();
                }, function (response) {
                    if (angular.isDefined(response.data._issues)) {
                        if (angular.isDefined(response.data._issues['validator exception'])) {
                            notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
                        }
                        else if (angular.isDefined(response.data._issues.name) &&
                            angular.isDefined(response.data._issues.name.unique)) {
                            notify.error(utils_1.gettext('Error: Subscriber with Name ' + $scope.subscriber.name +
                                ' already exists.'));
                        }
                        else if (angular.isDefined(response.data._issues.destinations)) {
                            notify.error(utils_1.gettext('Error: Subscriber must have at least one destination.'));
                        }
                    }
                    else {
                        notify.error(utils_1.gettext('Error: Failed to save Subscriber.'));
                    }
                })
                    .then(fetchSubscribers);
            };
            /**
             * Either initializes a new Subscriber object for adding a new subscriber or
             * initializes the subscriber object with the selected subscriber allowing
             * user to update the subscriber details.
             */
            $scope.edit = function (subscriber) {
                var promises = [];
                promises.push(fetchPublishErrors());
                promises.push(fetchProducts());
                promises.push(fetchGlobalContentFilters());
                $q.all(promises).then(function () {
                    $scope.origSubscriber = subscriber || {};
                    $scope.subscriber = lodash_1.default.create($scope.origSubscriber);
                    $scope.subscriber.critical_errors = $scope.origSubscriber.critical_errors;
                    $scope.subscriber.sequence_num_settings = $scope.origSubscriber.sequence_num_settings;
                    if (!('is_targetable' in $scope.origSubscriber)) {
                        $scope.subscriber.is_targetable = true;
                    }
                    initSubscriberProducts('products');
                    initSubscriberProducts('api_products');
                    $scope.subscriber.global_filters = $scope.origSubscriber.global_filters || {};
                    $scope.destinations = [];
                    if (angular.isDefined($scope.subscriber.destinations)
                        && !lodash_1.default.isNull($scope.subscriber.destinations) &&
                        $scope.subscriber.destinations.length > 0) {
                        $scope.destinations = lodash_1.default.clone($scope.subscriber.destinations);
                    }
                    $scope.subscriberType = $scope.subscriber.subscriber_type || '';
                    $scope.changeFormats($scope.subscriberType);
                    initGlobalFilters();
                }, function () {
                    notify.error(utils_1.gettext('Subscriber could not be initialized!'));
                });
            };
            /**
             * Initialize Subscriber Products
             * @param field
             */
            function initSubscriberProducts(field) {
                $scope.subscriber[field] = [];
                if (lodash_1.default.get($scope.origSubscriber, field)) {
                    lodash_1.default.each($scope.origSubscriber[field], function (p) {
                        $scope.subscriber[field].push($scope.productLookup[p]);
                    });
                }
                $scope.subscriber[field] = $filter('sortByName')($scope.subscriber[field]);
            }
            /**
             * Reverts any changes made to the subscriber
             */
            $scope.cancel = function () {
                $scope.origSubscriber = null;
                $scope.subscriber = null;
                $scope.newDestination = null;
            };
            /**
             * Invoked when Subscriber Type is changed. Responsible for populating $scope.formats variable.
             * The $scope.formats variable is used to display format field in destination. The new value is changed.
             */
            $scope.changeFormats = function (newSubscriberType) {
                var formats = lodash_1.default.result(lodash_1.default.find($scope.subTypes, { qcode: newSubscriberType }), 'formats');
                if ($scope.destinations.length > 0 && $scope.subscriberType !== '' &&
                    $scope.subscriberType !== newSubscriberType) {
                    var oldFormats = lodash_1.default.result(lodash_1.default.find($scope.subTypes, { qcode: $scope.subscriberType }), 'formats');
                    if (!lodash_1.default.isEqual(oldFormats, formats)) {
                        notify.error(utils_1.gettext('Error: Please re-assign new format for each destination as the changed ' +
                            'subscriber type has formats which are not supported by existing destination(s).'));
                        lodash_1.default.each($scope.destinations, function (destination) {
                            destination.format = null;
                        });
                    }
                }
                $scope.subscriberType = $scope.subscriber.subscriber_type;
                $scope.formats = formats;
            };
            // If subscribers list provided don't fetch subscribers
            if (!$scope.subscribersList) {
                fetchSubscribers();
            }
        },
    };
}
exports.SubscribersDirective = SubscribersDirective;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc filter
 * @module superdesk.apps.publish
 * @name SubscribersFilter
 * @description Returns a function that allows filtering an array of
 * subscribes by various criteria.
 */
function SubscribersFilter() {
    /**
     * @description Returns a new array based on the passed filter.
     * @param {Array<Object>} items - Array of templates to filter.
     * @param {Object} search - The filter. search by name and subscriber type.
     * @returns {Array<Object>} The filtered array.
     */
    return function (items, search) {
        if (!items) {
            return;
        }
        var filteredItems = items;
        if (search.name && search.name !== '') {
            var regExp_1 = new RegExp(search.name, 'i');
            filteredItems = filteredItems.filter(function (item) { return item.name.match(regExp_1); });
        }
        if (search.subscriber_type && search.subscriber_type !== '') {
            filteredItems = filteredItems.filter(function (item) { return item.subscriber_type === search.subscriber_type; });
        }
        if (search.subscriber_status && search.subscriber_status.value != null) {
            filteredItems = filteredItems.filter(function (item) { return item.is_active === search.subscriber_status.value; });
        }
        return filteredItems;
    };
}
exports.SubscribersFilter = SubscribersFilter;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1515);
var services_1 = __webpack_require__(1517);
var filters_1 = __webpack_require__(1519);
var directive = __importStar(__webpack_require__(1520));
var ctrl = __importStar(__webpack_require__(1525));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.templates', [
    'superdesk.core.activity',
    'superdesk.apps.authoring',
    'superdesk.core.preferences',
])
    .service('templates', services_1.TemplatesService)
    .filter('templatesBy', filters_1.FilterTemplatesFilter)
    .directive('sdTemplates', directive.TemplatesDirective)
    .directive('sdTemplateSelect', directive.TemplateSelectDirective)
    .directive('sdTemplateList', directive.TemplateListDirective)
    .directive('sdTemplateEditorModal', directive.TemplateEditorModal)
    .controller('CreateTemplateController', ctrl.CreateTemplateController)
    .controller('TemplateMenu', ctrl.TemplateMenuController)
    .config(['superdeskProvider', 'apiProvider', function config(superdesk, apiProvider) {
        superdesk.activity('/settings/templates', {
            label: utils_1.gettext('Templates'),
            templateUrl: 'scripts/apps/templates/views/settings.html',
            controller: ctrl.TemplatesSettingsController,
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            priority: 2000,
        });
    }]);


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1516);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./templates.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./templates.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.template-card .card-box__header--dark {\n  background-color: #747c87; }\n\n.template-card .card-box__content {\n  min-height: 120px;\n  /* should be big enough to fit in dropdown menu */ }\n\n.template-card .card-box__content-list .creation-time {\n  display: inline-block; }\n\n.header .sortbar {\n  margin: 3px 10px 0 0;\n  padding: 0 5px 0 0;\n  border-right: 2px dotted #bcbcbc; }\n  .header .sortbar .lab {\n    margin-top: -2px; }\n\n.template-editor-modal * {\n  box-sizing: border-box; }\n\n.template-editor-modal .modal-body {\n  padding: 0; }\n\n.template-editor-modal .template-content {\n  display: inline-block;\n  vertical-align: top;\n  width: 63%;\n  box-shadow: 3px -3px 8px -3px rgba(0, 0, 0, 0.1); }\n\n.template-editor-modal .template-metadata {\n  display: inline-block;\n  position: absolute;\n  width: calc(37.25% - 2px);\n  height: 100%;\n  top: 0;\n  right: 0;\n  padding: 20px 31px; }\n  .template-editor-modal .template-metadata .field {\n    margin-bottom: 15px; }\n    .template-editor-modal .template-metadata .field--margin-double {\n      margin-bottom: 30px; }\n  .template-editor-modal .template-metadata .sd-toggle {\n    margin-top: 4px; }\n  .template-editor-modal .template-metadata .toggle-box__label {\n    color: #000; }\n  .template-editor-modal .template-metadata .multi-select {\n    margin-bottom: 20px; }\n    .template-editor-modal .template-metadata .multi-select ul li {\n      display: inline-block;\n      margin-bottom: 8px; }\n\n.template-editor-modal .template-icon {\n  display: inline-block;\n  vertical-align: middle;\n  padding: 20px 0px 20px 31px; }\n  .template-editor-modal .template-icon i {\n    width: 48px;\n    height: 48px;\n    font-size: 48px;\n    line-height: 48px;\n    opacity: .7; }\n\n.template-editor-modal .template-header {\n  display: inline-flex;\n  flex-wrap: wrap;\n  vertical-align: top;\n  padding: 20px 13px;\n  width: calc(100% - 95px); }\n  .template-editor-modal .template-header input#template-name {\n    font-size: 15px;\n    font-weight: 500; }\n  .template-editor-modal .template-header .authoring-header__item label {\n    min-width: 90px;\n    line-height: 16px; }\n\n.template-editor-modal .error {\n  color: #b94a48;\n  margin: -13px 10px;\n  width: 100%; }\n\n.template-editor-modal .template-editor {\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  background-color: #fff; }\n  .template-editor-modal .template-editor .authoring-header__general-info {\n    display: none; }\n  .template-editor-modal .template-editor .authoring-header {\n    border: 0;\n    padding: 16px 27px; }\n  .template-editor-modal .template-editor .main-article {\n    padding: 20px 38px;\n    border-width: 0; }\n\n.template-editor-modal select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  transition: all 0.3s; }\n\n.template-editor-modal .field--double > select, .template-editor-modal .field--double > input, .template-editor-modal .field--double > .field {\n  display: inline-block;\n  vertical-align: top;\n  width: 48%; }\n  .template-editor-modal .field--double > select:first-of-type, .template-editor-modal .field--double > input:first-of-type, .template-editor-modal .field--double > .field:first-of-type {\n    margin-right: 2%; }\n\n.target-field select {\n  width: 200px; }\n\n.target-field .terms {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-user-select: none;\n  padding-top: 10px;\n  *zoom: 1; }\n  .target-field .terms:before, .target-field .terms:after {\n    display: table;\n    content: \"\"; }\n  .target-field .terms:after {\n    clear: both; }\n  .target-field .terms li {\n    position: relative;\n    background: #e8e8e8;\n    line-height: 26px;\n    float: left;\n    height: 26px;\n    padding: 0 6px;\n    border-radius: 3px;\n    margin: 0 5px 5px 0;\n    transition: all 0.5s; }\n    .target-field .terms li i:not(.alt) {\n      position: absolute;\n      display: none;\n      right: 5px;\n      top: 6px;\n      opacity: 0;\n      filter: \"alpha(opacity=0)\";\n      transition: all 0.5s; }\n    .target-field .terms li:hover {\n      cursor: pointer;\n      background: #e0e0e0; }\n      .target-field .terms li:hover i {\n        opacity: 0.7;\n        filter: \"alpha(opacity=70)\"; }\n    .target-field .terms li:hover > i:not(.alt) {\n      display: inline-block; }\n    .target-field .terms li.selected {\n      background: #333333;\n      color: #e8e8e8; }\n", ""]);

// exports


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TemplatesService_1 = __webpack_require__(1518);
exports.TemplatesService = TemplatesService_1.TemplatesService;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
TemplatesService.$inject = ['api', 'session', '$q', 'preferencesService', 'privileges', 'desks'];
function TemplatesService(api, session, $q, preferencesService, privileges, desks) {
    var PAGE_SIZE = 10;
    var PREFERENCES_KEY = 'templates:recent';
    var KILL_TEMPLATE_IGNORE_FIELDS = ['dateline', 'template_desks', 'schedule_desk',
        'schedule_stage', 'schedule', 'next_run', 'last_run'];
    var self = this;
    this.TEMPLATE_METADATA = [
        'headline',
        'slugline',
        'abstract',
        'dateline',
        'byline',
        'subject',
        'genre',
        'type',
        'flags',
        'language',
        'anpa_category',
        'anpa_take_key',
        'keywords',
        'priority',
        'profile',
        'urgency',
        'pubstatus',
        'description_text',
        'body_html',
        'body_text',
        'body_footer',
        'place',
        'located',
        'creditline',
        'ednote',
        'language',
        'usageterms',
        'target_types',
        'target_regions',
        'target_subscribers',
        'format',
        'associations',
        'sign_off',
        'sms_message',
        'company_codes',
        'extra',
    ];
    /**
     * Filter out item data that is not usable for template
     *
     * @param {Object} item
     * @return {Object}
     */
    this.pickItemData = function (item) {
        return lodash_1.default.pick(item, this.TEMPLATE_METADATA);
    };
    var KILL_TYPE = 'kill';
    var CREATE_TYPE = 'create';
    var HIGHLIGHTS_TYPE = 'highlights';
    this.types = [
        { _id: KILL_TYPE, label: utils_1.gettext('Kill') },
        { _id: CREATE_TYPE, label: utils_1.gettext('Create') },
        { _id: HIGHLIGHTS_TYPE, label: utils_1.gettext('Highlights') },
    ];
    /*
     * To fetch all the templates based on the user and its user_type
     * Used in template management screen.
     */
    this.fetchAllTemplates = function (page, pageSize, type, templateName) {
        var params = {
            page: page || 1,
            max_results: pageSize || PAGE_SIZE,
            sort: 'template_name',
        };
        var criteria = {};
        // in template management only see the templates that are create by the user
        criteria.$or = [{ user: session.identity._id }];
        if (type !== undefined) {
            criteria.template_type = type;
        }
        if (templateName) {
            criteria.template_name = { $regex: templateName, $options: '-i' };
        }
        // if you are admin then you can edit public templates
        if (self.isAdmin(true)) {
            criteria.$or.push({ is_public: true });
        }
        else if (self.isAdmin()) {
            var _criteria = criteria;
            criteria = desks.fetchCurrentUserDesks().then(function (_desks) {
                _criteria.$or.push({
                    is_public: true,
                    template_desks: { $in: _desks.map(function (desk) { return desk._id; }) },
                });
                return _criteria;
            });
        }
        return $q.when(criteria)
            .then(function (criteriaReady) {
            params.where = JSON.stringify({
                $and: [criteriaReady],
            });
            return params;
        })
            .then(function (_params) { return api.query('content_templates', _params); });
    };
    this.fetchTemplatesByDesk = function (desk) {
        var params = {
            sort: 'template_name',
            max_results: 200,
        };
        var deskCriteria = [
            { is_public: true },
        ];
        if (desk) {
            deskCriteria.push({ template_desks: { $in: [desk] } });
        }
        var criteria = { $or: deskCriteria, template_type: CREATE_TYPE };
        if (!lodash_1.default.isEmpty(criteria)) {
            params.where = JSON.stringify({
                $and: [criteria],
            });
        }
        return api.query('content_templates', params);
    };
    this.fetchTemplatesByUserDesk = function (user, desk, page, pageSize, type, templateName) {
        var params = {
            page: page || 1,
            max_results: pageSize || PAGE_SIZE,
            sort: 'template_name',
        };
        var criteria = {};
        if (!user) {
            return $q.when();
        }
        var deskCriteria = [
            { template_desks: { $exists: false }, is_public: true },
            { template_desks: [], is_public: true },
        ];
        if (desk) {
            deskCriteria.push({ template_desks: { $in: [desk] }, is_public: true });
        }
        criteria.$or = [{ $or: deskCriteria }, { user: user, is_public: false }];
        if (type !== undefined) {
            criteria.template_type = type;
        }
        if (templateName) {
            criteria.template_name = { $regex: templateName, $options: '-i' };
        }
        if (!lodash_1.default.isEmpty(criteria)) {
            params.where = JSON.stringify({
                $and: [criteria],
            });
        }
        return api.query('content_templates', params);
    };
    this.fetchTemplatesByIds = function (templateIds) {
        if (!templateIds.length) {
            return $q.when([]);
        }
        var params = {
            max_results: PAGE_SIZE,
            page: 1,
            where: JSON.stringify({ _id: { $in: templateIds } }),
        };
        return api.query('content_templates', params)
            .then(function (result) {
            if (result && result._items) {
                result._items.sort(function (a, b) { return templateIds.indexOf(a._id) - templateIds.indexOf(b._id); });
            }
            return result;
        });
    };
    /**
     * Find template by id
     *
     * @param {String} id
     * @return {Promise}
     */
    this.find = function (id) {
        return api.find('content_templates', id);
    };
    /**
     * Test if user is admin
     *
     * @param {bool} strict - if true user must be `administrator`, otherwise it's enough to have privileges
     * @return {bool}
     */
    this.isAdmin = function (strict) {
        var admin = session.identity.user_type === 'administrator';
        if (strict) {
            return admin;
        }
        return admin || privileges.privileges.content_templates;
    };
    this.addRecentTemplate = function (deskId, templateId) {
        return preferencesService.get()
            .then(function (result) {
            if (result === void 0) { result = {}; }
            result[PREFERENCES_KEY] = result[PREFERENCES_KEY] || {};
            result[PREFERENCES_KEY][deskId] = result[PREFERENCES_KEY][deskId] || [];
            lodash_1.default.remove(result[PREFERENCES_KEY][deskId], function (i) { return i === templateId; });
            result[PREFERENCES_KEY][deskId].unshift(templateId);
            return preferencesService.update(result);
        });
    };
    this.getRecentTemplateIds = function (deskId, limit) {
        if (limit === void 0) { limit = PAGE_SIZE; }
        return preferencesService.get()
            .then(function (result) {
            if (result && result[PREFERENCES_KEY] && result[PREFERENCES_KEY][deskId]) {
                return lodash_1.default.take(result[PREFERENCES_KEY][deskId], limit);
            }
            return [];
        });
    };
    this.getRecentTemplates = function (deskId, limit) {
        if (limit === void 0) { limit = PAGE_SIZE; }
        return this.getRecentTemplateIds(deskId, limit)
            .then(this.fetchTemplatesByIds);
    };
    /**
     * Save template
     *
     * @param {Object} orig
     * @param {Object} updates
     * @return {Promise}
     */
    this.save = function (orig, updates) {
        var template = angular.extend({ data: {} }, updates);
        delete template._datelinedate;
        delete template.hasCrops;
        template.data.headline = trimSpaces(template.data.headline);
        template.data.body_html = trimSpaces(template.data.body_html);
        template.data = this.pickItemData(template.data);
        // certain field are not required for kill template
        if (template && template.template_type === 'kill') {
            template = lodash_1.default.omit(template, KILL_TEMPLATE_IGNORE_FIELDS);
        }
        return api.save('content_templates', orig, template);
    };
    function trimSpaces(value) {
        return value ? value.replace(/&nbsp;/g, '').trim() : '';
    }
}
exports.TemplatesService = TemplatesService;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc filter
 * @module superdesk.apps.templates
 * @name FilterTemplatesFilter
 * @description Returns a function that allows filtering an array of
 * templates by various criteria.
 */
FilterTemplatesFilter.$inject = [];
function FilterTemplatesFilter() {
    /**
     * @description Returns a new array based on the passed filter.
     * @param {Array<Object>} all - Array of templates to filter.
     * @param {Object} f - The filter. Contains keys 'label' and 'value'.
     * If the 'value' is 'All', the entire array is returned. For 'None',
     * only the items without a desk are returned. For 'Personal', only
     * non-public items are returned, and every other value is a hash that
     * represents the desk to filter by.
     * @returns {Array<Object>} The filtered array.
     */
    return function (all, f) {
        return (all || []).filter(function (item) {
            switch (f.value) {
                case 'All':
                    return all;
                case 'None':
                    return item.is_public && !(item.template_desks && item.template_desks.length);
                case 'Personal':
                    return !item.is_public;
                default:
                    return lodash_1.default.find(item.template_desks, function (desk) { return desk === f.value; });
            }
        });
    };
}
exports.FilterTemplatesFilter = FilterTemplatesFilter;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TemplatesDirective_1 = __webpack_require__(1521);
exports.TemplatesDirective = TemplatesDirective_1.TemplatesDirective;
var TemplateSelectDirective_1 = __webpack_require__(1522);
exports.TemplateSelectDirective = TemplateSelectDirective_1.TemplateSelectDirective;
var TemplateListDirective_1 = __webpack_require__(1523);
exports.TemplateListDirective = TemplateListDirective_1.TemplateListDirective;
var TemplateEditorModal_1 = __webpack_require__(1524);
exports.TemplateEditorModal = TemplateEditorModal_1.TemplateEditorModal;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __importDefault(__webpack_require__(555));
var utils_1 = __webpack_require__(3);
TemplatesDirective.$inject = ['notify', 'api', 'templates', 'modal', 'desks', 'weekdays',
    'content', '$filter', 'lodash'];
function TemplatesDirective(notify, api, templates, modal, desks, weekdays, content, $filter, _) {
    return {
        templateUrl: 'scripts/apps/templates/views/templates.html',
        link: function ($scope) {
            $scope.weekdays = weekdays;
            $scope.content_templates = null;
            $scope.origTemplate = null;
            $scope.template = null;
            $scope.desks = null;
            $scope.template_desk = null;
            $scope.error = {};
            function fetchTemplates() {
                templates.fetchAllTemplates(1, 200).then(function (result) {
                    result._items = $filter('sortByName')(result._items, 'template_name');
                    $scope.content_templates = result;
                });
            }
            desks.initialize().then(function () {
                $scope.desks = desks.desks;
                selectDesk(null);
            });
            content.getTypes().then(function () {
                $scope.content_types = content.types;
            });
            /*
             * Checks if the user is Admin or Not.
             */
            $scope.isAdmin = function () {
                return templates.isAdmin();
            };
            /*
             * Returns true if desks selection should be displayed
             */
            $scope.showDesks = function () {
                return !_.isNil($scope.template) &&
                    !_.isNil($scope.template.template_type) &&
                    $scope.template.template_type !== 'kill' &&
                    $scope.template.is_public;
            };
            /*
             * Returns true if stage selection should be displayed
             */
            $scope.showStages = function () {
                return $scope.showScheduling() &&
                    !_.isNil($scope.stages) && $scope.stages.length > 0;
            };
            /*
             * Returns true if scheduling should be displayed
             */
            $scope.showScheduling = function () {
                return !_.isNil($scope.template) &&
                    $scope.template.template_type !== 'kill' &&
                    $scope.template.is_public;
            };
            /*
             * Called on desk toggle on multiple desk selection
             */
            $scope.toggleDesk = function (desk) {
                desk.selected = !desk.selected;
                $scope.onDeskToggle(desk);
            };
            /*
             * Called on desk toggle on multiple desk selection
             */
            $scope.onDeskToggle = function (desk) {
                if (desk.selected && !$scope.template.template_desks) {
                    $scope.template.template_desks = [desk._id];
                    return;
                }
                var deskIndex = _.findIndex($scope.template.template_desks, function (val) { return val === desk._id; });
                if (desk.selected && deskIndex === -1) {
                    $scope.template.template_desks.push(desk._id);
                }
                if (!desk.selected && deskIndex !== -1) {
                    $scope.template.template_desks.splice(deskIndex, 1);
                }
            };
            /*
             * Set desk selected property for the given desk
             */
            function selectDesk(deskId) {
                $scope.template_desk = deskId;
                _.forEach($scope.desks._items, function (desk) {
                    desk.selected = desk._id === deskId;
                });
            }
            /*
             * Set desk selected property for the given desks
             */
            function selectDesks(desksIds) {
                if (desksIds instanceof Array) {
                    _.forEach($scope.desks._items, function (desk) {
                        var deskIndex = _.findIndex(desksIds, function (deskId) { return deskId === desk._id; });
                        desk.selected = deskIndex !== -1;
                    });
                }
            }
            /*
             * Sets the template template_desks list to null if deskId is null/empty or to a list with one element.
             */
            $scope.setTemplateDesks = function (deskId) {
                if (_.isNil(deskId) || deskId === '') {
                    $scope.template.template_desks = null;
                    selectDesk(null);
                }
                else {
                    $scope.template.template_desks = [deskId];
                    selectDesk(deskId);
                }
            };
            /*
             * Truncates the template template_desks list to the first element.
             */
            $scope.resetDesks = function () {
                if (!_.isNil($scope.template.template_desks) &&
                    $scope.template.template_type !== 'create' &&
                    $scope.template.template_desks.length > 0) {
                    $scope.template.template_desks.splice(1, $scope.template.template_desks.length - 1);
                    selectDesk($scope.template.template_desks[0]);
                }
                if ($scope.template.template_type === 'create') {
                    $scope.template_desk = null;
                }
            };
            $scope.templatesFilter = function (templateType) {
                if ($scope.template._id && $scope.template.template_type === 'kill') {
                    return templateType._id === 'kill';
                }
                return templateType._id !== 'kill';
            };
            /*
             * Returns desks names
             */
            $scope.getTemplateDesks = function (template) {
                var templateDesks = [];
                _.forEach(template.template_desks, function (deskId) {
                    var desk = _.find($scope.desks._items, { _id: deskId });
                    if (desk) {
                        templateDesks.splice(-1, 0, desk.name);
                    }
                });
                return templateDesks.join(', ');
            };
            /*
             * Returns the schedule desk stage name
             */
            $scope.getScheduleDesk = function (template) {
                if (!_.isNil(template)) {
                    var desk = _.find($scope.desks._items, { _id: template.schedule_desk });
                    return desk ? desk.name : null;
                }
                return null;
            };
            /*
             * Returns the schedule desk stage name
             */
            $scope.getScheduleStage = function (template) {
                if (!_.isNil(template)) {
                    var stage = _.find(desks.stages._items, { _id: template.schedule_stage });
                    return stage ? stage.name : null;
                }
                return null;
            };
            $scope.types = templates.types;
            function validate(orig, item) {
                $scope.error = {};
                if (!item.template_name) {
                    $scope.error.template_name = true;
                }
                if (!item.template_type) {
                    $scope.error.template_type = true;
                }
                return !_.has($scope.error, 'template_name') && !_.has($scope.error, 'template_type');
            }
            $scope.save = function () {
                $scope.template.schedule.cron_list = [];
                _.forEach($scope.cron_times, function (time) {
                    $scope.template.schedule.cron_list.push(time.substring(3, 5) + ' ' + time.substring(0, 2) +
                        ' * * ' + $scope.template.schedule.day_of_week.join(','));
                });
                if (validate($scope.origTemplate, $scope.template)) {
                    templates.save($scope.origTemplate, $scope.template)
                        .then(function () {
                        notify.success(utils_1.gettext('Template saved.'));
                        $scope.cancel();
                    }, function (response) {
                        helpers_1.default(response, notify);
                    })
                        .then(fetchTemplates);
                }
            };
            function getCronTimes(schedule) {
                var times = [];
                _.forEach(schedule.cron_list, function (cron) {
                    times.push(cron.split(' ')[1] + ':' + cron.split(' ')[0]);
                });
                return times;
            }
            $scope.removeCronTime = function (cron) {
                _.remove($scope.cron_times, function (c) { return c === cron; });
            };
            $scope.addCronTime = function () {
                if ($scope.new_time && $scope.new_time.picked && _.findIndex($scope.cron_times, function (t) { return t.toString() === $scope.new_time.picked.substring(0, 5); }) === -1) {
                    $scope.cron_times.push($scope.new_time.picked.substring(0, 5));
                    $scope.cron_times = _.sortBy($scope.cron_times);
                    $scope.new_time = { picked: null };
                }
            };
            $scope.edit = function (template) {
                $scope.origTemplate = template || { template_type: 'create', is_public: true };
                $scope.template = _.create($scope.origTemplate);
                $scope.template.schedule = $scope.origTemplate.schedule || {};
                $scope.template.data = $scope.origTemplate.data || {
                    headline: '',
                    abstract: '',
                    byline: '',
                    body_html: '',
                };
                $scope.template.template_desks = $scope.origTemplate.template_desks || [];
                $scope.template_desk = $scope.template.template_desks.length > 0 ?
                    $scope.template.template_desks[0] : '';
                $scope.stages = $scope.template.schedule_desk ? desks.deskStages[$scope.template.schedule_desk] : null;
                $scope.template.template_type = $scope.origTemplate.template_type;
                if (!templates.isAdmin()) {
                    // User with no admin privileges cannot create public templates.
                    $scope.template.is_public = false;
                }
                else {
                    $scope.template.is_public = $scope.template.is_public !== false;
                }
                $scope.item = $scope.template.data || {};
                $scope._editable = true;
                $scope.error = {};
                selectDesks($scope.template.template_desks);
                $scope.cron_times = getCronTimes($scope.template.schedule);
                $scope.new_time = { picked: null };
            };
            $scope.$watch('item.profile', function (profile) {
                if (profile) {
                    content.getType(profile).then(setupContentType);
                }
                else {
                    setupContentType();
                }
            });
            $scope.$watch('template.schedule.is_active', function (newValue, oldValue) {
                if (!newValue && oldValue && $scope.template) {
                    // clean schedule data
                    if ($scope.template.schedule) {
                        $scope.template.schedule.day_of_week = [];
                    }
                    delete $scope.template.schedule.create_at;
                    $scope.template.schedule.cron_list = [];
                    $scope.cron_times = [];
                    $scope.template.schedule_desk = null;
                    $scope.template.schedule_stage = null;
                }
            });
            function setupContentType(type) {
                if (type) {
                    $scope.schema = content.schema(type, $scope.item.type);
                    $scope.editor = content.editor(type, $scope.item.type);
                }
            }
            $scope.remove = function (template) {
                var _desks = _.filter($scope.desks._items, function (desk) {
                    return desk.default_content_template === template._id;
                });
                var deskNames = _desks.map(function (desk) { return desk.name; }).join(', ');
                if (deskNames) {
                    return notify.error(utils_1.gettext('This is a default template of the following desk(s): {{deskNames}}.', { deskNames: deskNames }) +
                        ' ' + utils_1.gettext('Please change the default templates first.'));
                }
                modal.confirm(utils_1.gettext('Are you sure you want to delete the template?'))
                    .then(function () { return api.remove(template); })
                    .then(function (result) {
                    _.remove($scope.templates, template);
                }, function (response) {
                    if (angular.isDefined(response.data._message)) {
                        notify.error(utils_1.gettext('Error: ' + response.data._message));
                    }
                    else {
                        notify.error(utils_1.gettext('There was an error. Template cannot be deleted.'));
                    }
                })
                    .then(fetchTemplates);
            };
            $scope.cancel = function () {
                $scope.origTemplate = null;
                $scope.template = null;
                $scope.vars = null;
                fetchTemplates();
            };
            $scope.updateStages = function (desk) {
                $scope.stages = desk ? desks.deskStages[desk] : null;
                $scope.template.schedule_stage = null;
            };
            $scope.isScheduleValid = function () { return $scope.showScheduling() && $scope.template.schedule.is_active ?
                $scope.template.schedule.day_of_week &&
                    $scope.template.schedule.day_of_week.length > 0 &&
                    $scope.cron_times.length > 0 &&
                    $scope.template.schedule_desk &&
                    $scope.template.schedule_stage : true; };
            $scope.filters = [
                { label: utils_1.gettext('All'), value: 'All' },
                { label: utils_1.gettext('Personal'), value: 'Personal' },
                { label: utils_1.gettext('No Desk'), value: 'None' },
            ];
            // holds the index of the active filter.
            $scope.activeFilter = 0;
            // sets the active filter to another index.
            $scope.filterBy = function (idx) {
                $scope.activeFilter = idx;
            };
            // fetch all desks for the current user and add them to
            // the list of filters.
            desks.fetchDesks().then(function (_desks) {
                $scope.filters = $scope.filters.concat(_desks._items.map(function (d) { return ({ label: d.name, value: d._id }); }));
            });
            fetchTemplates();
        },
    };
}
exports.TemplatesDirective = TemplatesDirective;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
TemplateSelectDirective.$inject = ['api', 'desks', 'session', 'templates', 'notify'];
function TemplateSelectDirective(api, desks, session, templates, notify) {
    var PAGE_SIZE = 200;
    return {
        templateUrl: 'scripts/apps/templates/views/sd-template-select.html',
        scope: {
            selectAction: '=',
            open: '=',
        },
        link: function (scope) {
            scope.options = {
                templateName: null,
            };
            scope.close = function () {
                scope.open = false;
            };
            scope.select = function (template) {
                scope.selectAction(template);
                scope.close();
            };
            scope.loading = false;
            /**
             * Fetch templates and assign it to scope but split it into public/private
             */
            function fetchTemplates() {
                scope.loading = true;
                templates.fetchTemplatesByUserDesk(session.identity._id, desks.getCurrentDeskId(), scope.options.page, PAGE_SIZE, 'create', scope.options.templateName)
                    .then(function (result) {
                    scope.loading = false;
                    if (result._items.length === 0) {
                        notify.error(utils_1.gettext('No Templates found.'));
                    }
                    else {
                        scope.open = true;
                        scope.publicTemplates = [];
                        scope.privateTemplates = [];
                        result._items.forEach(function (template) {
                            if (template.is_public === false) {
                                scope.privateTemplates.push(template);
                            }
                            else if (template.template_desks && template.template_desks.length > 0) {
                                scope.publicTemplates.push(template);
                            }
                        });
                    }
                });
            }
            scope.$watch('options.templateName', fetchTemplates);
        },
    };
}
exports.TemplateSelectDirective = TemplateSelectDirective;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function TemplateListDirective() {
    var ENTER = 13;
    return {
        scope: { templates: '=', select: '&' },
        templateUrl: 'scripts/apps/templates/views/template-list.html',
        link: function (scope) {
            /**
             * Call select on keyboard event if key was enter
             *
             * @param {Event} $event
             * @param {Object} template
             */
            scope.selectOnEnter = function ($event, template) {
                if ($event.key === ENTER) {
                    scope.select(template);
                }
            };
        },
    };
}
exports.TemplateListDirective = TemplateListDirective;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
function TemplateEditorModal() {
    return {
        templateUrl: 'scripts/apps/templates/views/template-editor-modal.html',
        link: function (scope) {
            lodash_1.default.defer(function () {
                var ENTER = 13;
                var modalBodyContainer = angular.element('.modal__body');
                function handleKeyDown(event) {
                    if (event.keyCode === ENTER && event.target.tagName === 'INPUT') {
                        event.preventDefault();
                    }
                }
                scope.$watch('template.schedule.day_of_week', function (newValue, oldValue) {
                    if (newValue && newValue.length > 0 && !lodash_1.default.isEqual(newValue, oldValue)) {
                        modalBodyContainer.scope().metadataForm.$setDirty();
                    }
                }, true);
                modalBodyContainer.on('keydown', handleKeyDown);
                scope.$on('$destroy', function () {
                    modalBodyContainer.off('keydown', handleKeyDown);
                });
                var _isDirty;
                /**
                 * Set dirty on autosave - it is called on change
                 */
                scope.autosave = function () {
                    _isDirty = true;
                };
                /**
                 * Test if scope is dirty
                 */
                scope.isDirty = function (templateForm, metadataForm) { return templateForm.$dirty || metadataForm.$dirty || _isDirty; };
            });
        },
    };
}
exports.TemplateEditorModal = TemplateEditorModal;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CreateTemplateController_1 = __webpack_require__(1526);
exports.CreateTemplateController = CreateTemplateController_1.CreateTemplateController;
var TemplateMenuController_1 = __webpack_require__(1527);
exports.TemplateMenuController = TemplateMenuController_1.TemplateMenuController;
// TODO: is this needed?
TemplatesSettingsController.$inject = ['$scope'];
function TemplatesSettingsController($scope) { }
exports.TemplatesSettingsController = TemplatesSettingsController;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __importDefault(__webpack_require__(555));
CreateTemplateController.$inject = ['item', 'templates', 'api', 'desks', '$q', 'notify', 'lodash'];
function CreateTemplateController(item, templates, api, desks, $q, notify, _) {
    var self = this;
    this.type = 'create';
    this.name = item.slugline || null;
    this.desk = desks.active.desk || null;
    this.is_public = false;
    this.types = templates.types;
    this.createTypes = _.filter(templates.types, function (element) { return element._id !== 'kill'; });
    this.save = save;
    activate();
    function activate() {
        if (item.template) {
            api.find('content_templates', item.template).then(function (template) {
                self.name = template.template_name;
                self.desk = !_.isNil(template.template_desks) ? template.template_desks[0] : null;
                self.is_public = template.is_public !== false;
                self.template = template;
            });
        }
        desks.fetchCurrentUserDesks().then(function (_desks) {
            self.desks = _desks;
        });
    }
    function save() {
        var data = {
            template_name: self.name,
            template_type: self.type,
            template_desks: self.is_public ? [self.desk] : null,
            is_public: self.is_public,
            data: templates.pickItemData(item),
        };
        var template = self.template ? self.template : data;
        var diff = self.template ? data : null;
        // in case there is old template but user renames it - create a new one
        if (self.template && self.name !== self.template.template_name) {
            template = data;
            diff = null;
        }
        return api.save('content_templates', template, diff)
            .then(function (_data) {
            self._issues = null;
            return _data;
        }, function (response) {
            helpers_1.default(response, notify);
            self._issues = response.data._issues;
            return $q.reject(self._issues);
        });
    }
}
exports.CreateTemplateController = CreateTemplateController;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
TemplateMenuController.$inject = ['$modal'];
function TemplateMenuController($modal) {
    this.create = createFromItem;
    function createFromItem(item) {
        $modal.open({
            templateUrl: 'scripts/apps/templates/views/create-template.html',
            controller: 'CreateTemplateController',
            controllerAs: 'template',
            resolve: {
                item: function () {
                    return item;
                },
            },
        });
    }
}
exports.TemplateMenuController = TemplateMenuController;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
var controllers_1 = __webpack_require__(1529);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.profiling
 * @name superdesk.apps.profiling
 * @packageName superdesk.apps
 * @description Enhances the application with profiling support for the workspace.
 */
exports.default = angular.module('superdesk.apps.profiling', [])
    .controller('profilingCtrl', controllers_1.ProfilingController)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/profiling', {
            label: utils_1.gettext('Profiling Data'),
            templateUrl: 'scripts/apps/profiling/views/profiling.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: controllers_1.ProfilingController,
            category: superdesk.MENU_MAIN,
            adminTools: false,
            privileges: { profiling: 1 },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('profiling', { type: 'http', backend: { rel: 'profiling' } });
    }]);


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ProfilingController_1 = __webpack_require__(1530);
exports.ProfilingController = ProfilingController_1.ProfilingController;


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ProfilingController.$inject = ['$scope', 'api'];
function ProfilingController($scope, api) {
    $scope.profiling_data = [];
    $scope.current_profile = null;
    $scope.profiles = ['rest', 'publish:enqueue', 'publish:transmit'];
    $scope.profile_names = {
        rest: 'Rest',
        'publish:enqueue': 'Publish Enqueue',
        'publish:transmit': 'Publish Transmit',
    };
    /*
    * Populates the profiling data.
    */
    function populateProfilingData() {
        api.profiling.getById($scope.current_profile).then(function (profile) {
            $scope.profiling_data = profile.profiling_data;
            $scope.lastRefreshedAt = new Date();
        });
    }
    $scope.reload = function () {
        populateProfilingData();
    };
    $scope.reset = function () {
        api.profiling.remove({ _links: { self: { href: 'profiling' } } });
        $scope.reload();
    };
    $scope.loadProfile = function (profile) {
        if (profile !== $scope.current_profile) {
            $scope.current_profile = profile;
            $scope.profiling_data = [];
            $scope.reload();
        }
    };
    $scope.reload();
}
exports.ProfilingController = ProfilingController;


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
* This file is part of Superdesk.
*
* Copyright 2013, 2014 Sourcefabric z.u. and contributors.
*
* For the full copyright and license information, please see the
* AUTHORS and LICENSE files distributed with this source code, or
* at https://www.sourcefabric.org/superdesk/license
*/
__webpack_require__(1532);
var ctrl = __importStar(__webpack_require__(1534));
var directive = __importStar(__webpack_require__(1538));
var services_1 = __webpack_require__(1559);
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.desks
 * @name superdesk.apps.desks
 * @packageName superdesk.apps
 * @description Superdesk app that allows managing and using desks.
 */
angular.module('superdesk.apps.desks', [
    'superdesk.core.ui',
    'superdesk.apps.users',
    'superdesk.apps.authoring.widgets',
    'superdesk.apps.aggregate.widgets',
    'superdesk.apps.aggregate',
])
    .factory('desks', services_1.DesksFactory)
    .directive('sdTaskStatusItems', directive.TaskStatusItemsDirective)
    .directive('sdUserRoleItems', directive.UserRoleItemListDirective)
    .directive('sdSluglinesItems', directive.SluglinesItemListDirective)
    .directive('sdDeskConfig', function () { return ({ controller: ctrl.DeskConfigController }); })
    .directive('sdDeskConfigModal', directive.DeskConfigModal)
    .directive('sdFocusElement', directive.FocusElement)
    .directive('sdContentExpiry', directive.ContentExpiry)
    .directive('sdDeskeditBasic', directive.DeskeditBasic)
    .directive('sdDeskeditStages', directive.DeskeditStages)
    .directive('sdUserSelectList', directive.UserSelectList)
    .directive('sdDeskeditPeople', directive.DeskeditPeople)
    .directive('sdDeskeditMacros', directive.DeskeditMacros)
    .directive('sdActionPicker', directive.ActionPicker)
    .directive('sdStageHeader', directive.StageHeaderDirective)
    .directive('sdDeskSelect', directive.DeskSelect)
    .directive('sdDeskSelectItem', directive.DeskSelectItem)
    .directive('sdMarkDesksDropdown', directive.MarkDesksDropdown)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/desks/', {
            label: utils_1.gettext('Master Desk'),
            description: utils_1.gettext('Navigate through the newsroom'),
            templateUrl: 'scripts/apps/desks/views/main.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: ctrl.DeskListController,
            priority: -100,
            adminTools: false,
            beta: true,
            category: superdesk.MENU_MAIN,
            privileges: { desks: 1 },
        })
            .activity('/settings/desks', {
            label: utils_1.gettext('Desks'),
            controller: ctrl.DeskSettingsController,
            templateUrl: 'scripts/apps/desks/views/settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.WORKFLOW,
            priority: -800,
            privileges: { desks: 1 },
        })
            .activity('mark.desk', {
            label: utils_1.gettext('Mark for desk'),
            priority: 30,
            icon: 'bell',
            dropdown: directive.DesksReactDropdown,
            keyboardShortcut: 'ctrl+shift+!',
            templateUrl: 'scripts/apps/desks/views/mark_desks_dropdown.html',
            filters: [
                { action: 'list', type: 'archive' },
            ],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).mark_item_for_desks;
                }],
            group: 'highlights',
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('desks', {
            type: 'http',
            backend: {
                rel: 'desks',
            },
        });
    }]);


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1533);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./desks.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./desks.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.label--lite {\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.65);\n  text-transform: uppercase; }\n\n.inline-tag-list {\n  *zoom: 1;\n  padding: 10px 0 0 0; }\n  .inline-tag-list:before, .inline-tag-list:after {\n    display: table;\n    content: \"\"; }\n  .inline-tag-list:after {\n    clear: both; }\n  .inline-tag-list li {\n    float: left; }\n    .inline-tag-list li .inline-tag {\n      line-height: 26px;\n      border-radius: 2px;\n      padding: 0px 0px 0px 8px;\n      background: #dedede;\n      color: #333;\n      margin: 0 5px 5px 0;\n      float: left; }\n      .inline-tag-list li .inline-tag.tag-prime {\n        background: #5ea9c8;\n        color: #fff; }\n      .inline-tag-list li .inline-tag.tag-darker {\n        background: #bababa; }\n      .inline-tag-list li .inline-tag span {\n        font-weight: 500;\n        margin-right: 5px;\n        text-transform: uppercase;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n      .inline-tag-list li .inline-tag button {\n        background: none;\n        border: 0;\n        float: right;\n        height: 26px;\n        margin-left: 5px;\n        padding-left: 2px;\n        border-radius: 0 3px 3px 0; }\n        .inline-tag-list li .inline-tag button i {\n          opacity: 0.3;\n          filter: \"alpha(opacity=30)\";\n          margin-top: -4px; }\n        .inline-tag-list li .inline-tag button:hover {\n          background: rgba(0, 0, 0, 0.1); }\n          .inline-tag-list li .inline-tag button:hover i {\n            opacity: 1;\n            filter: \"alpha(opacity=100)\"; }\n\n/*----------------------------------------\n  #Urgency label\n----------------------------------------*/\n.urgency-label {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 10px;\n  background: #cccccc;\n  box-sizing: border-box;\n  line-height: 17px;\n  vertical-align: top;\n  font-style: normal; }\n\n.urgency-label--0 {\n  background: #cccccc; }\n\n.urgency-label--1 {\n  background: #01405b; }\n\n.urgency-label--2 {\n  background: #005e84; }\n\n.urgency-label--3 {\n  background: #3684a4; }\n\n.urgency-label--4 {\n  background: #64a4bf; }\n\n.urgency-label--5 {\n  background: #a1c6d8; }\n\n/*----------------------------------------\n  #Priority label\n----------------------------------------*/\n.priority-label {\n  width: 16px;\n  height: 16px;\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n  color: #fff;\n  font-size: 10px;\n  background: #cccccc;\n  box-sizing: border-box;\n  line-height: 17px;\n  vertical-align: top;\n  font-style: normal; }\n\n.priority-label--0 {\n  background: #cccccc; }\n\n.priority-label--1 {\n  background: #b82f00; }\n\n.priority-label--2 {\n  background: #de6237; }\n\n.priority-label--3 {\n  background: #e49c56; }\n\n.priority-label--4 {\n  background: #edc175; }\n\n.priority-label--5 {\n  background: #b6c28b; }\n\n.priority-label--6 {\n  background: #c0c9a1; }\n\n/*----------------------------------------\n  #State labels\n----------------------------------------*/\n.state-label, .profile-label, .language-label {\n  display: inline-block;\n  line-height: 1.4rem;\n  font-size: 0.9rem;\n  letter-spacing: 0.125em;\n  text-transform: uppercase;\n  border-radius: 8px;\n  padding: 0 0.8rem;\n  margin-right: 1rem;\n  border: 1px solid;\n  vertical-align: middle;\n  border-color: #8c8c8c;\n  color: #8c8c8c;\n  font-weight: 500; }\n  .state-label.state_embargo, .state_embargo.profile-label, .state_embargo.language-label {\n    border-color: #ff3381 !important;\n    color: #ff3381 !important; }\n  .state-label.state-draft, .state-draft.profile-label, .state-draft.language-label {\n    border-color: #8c8c8c;\n    color: #8c8c8c; }\n  .state-label.state-ingested, .state-ingested.profile-label, .state-ingested.language-label, .state-label.state-routed, .state-routed.profile-label, .state-routed.language-label, .state-label.state-fetched, .state-fetched.profile-label, .state-fetched.language-label {\n    border-color: #5d9bc0;\n    color: #5d9bc0; }\n  .state-label.state-submitted, .state-submitted.profile-label, .state-submitted.language-label, .state-label.state-in_progress, .state-in_progress.profile-label, .state-in_progress.language-label, .state-label.state-subbed, .state-subbed.profile-label, .state-subbed.language-label {\n    border-color: #d2a800;\n    color: #d2a800; }\n  .state-label.state-published, .state-published.profile-label, .state-published.language-label {\n    border-color: #5e8d32;\n    color: #5e8d32; }\n  .state-label.state-spiked, .state-spiked.profile-label, .state-spiked.language-label, .state-label.state-recalled, .state-recalled.profile-label, .state-recalled.language-label, .state-label.state-killed, .state-killed.profile-label, .state-killed.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.state-killed, .state-killed.profile-label, .state-killed.language-label {\n    border-color: #be1600;\n    color: #be1600;\n    background-color: #ffeae7; }\n  .state-label.state-on_hold, .state-on_hold.profile-label, .state-on_hold.language-label, .state-label.state-scheduled, .state-scheduled.profile-label, .state-scheduled.language-label {\n    border-color: #da7200;\n    color: #da7200; }\n  .state-label.state-corrected, .state-corrected.profile-label, .state-corrected.language-label {\n    border-color: navy;\n    color: navy; }\n  .state-label.not-for-publication, .not-for-publication.profile-label, .not-for-publication.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.for-publication, .for-publication.profile-label, .for-publication.language-label {\n    border-color: #5e8d32;\n    color: #5e8d32; }\n  .state-label.legal, .legal.profile-label, .legal.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.missing-link, .missing-link.profile-label, .missing-link.language-label {\n    border-color: #be1600;\n    color: #be1600; }\n  .state-label.takes, .takes.profile-label, .takes.language-label {\n    border-color: darkmagenta;\n    color: darkmagenta; }\n    .state-label.takes div:hover, .takes.profile-label div:hover, .takes.language-label div:hover {\n      background-color: darkmagenta; }\n  .state-label.takes:hover, .takes.profile-label:hover, .takes.language-label:hover {\n    background-color: darkmagenta;\n    color: #fff; }\n  .state-label.sms, .sms.profile-label, .sms.language-label, .state-label.updated, .updated.profile-label, .updated.language-label {\n    border-color: navy;\n    color: navy; }\n  .state-label.updated:hover, .updated.profile-label:hover, .updated.language-label:hover {\n    background-color: navy;\n    color: #fff; }\n\n.profile-label {\n  background-color: #8c8c8c;\n  color: #fff; }\n\n.info-block {\n  max-width: 70%;\n  text-align: center;\n  margin: 0 auto;\n  padding: 15px 0;\n  color: #999; }\n\n/* board colors */\n.todo-status {\n  background: #b70000; }\n\n.inprogress-status {\n  background: #cc7800; }\n\n.done-status {\n  background: #288001; }\n\n.desk-tabs .online-users {\n  margin-top: -10px;\n  margin-left: 20px;\n  border-left: 1px solid #dfdfdf; }\n\n.master-desk-view {\n  overflow: hidden;\n  padding-bottom: 0 !important;\n  z-index: auto; }\n\n.main-desk-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  flex: 1 1;\n  flex-flow: row wrap;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  justify-content: flex-start;\n  height: auto;\n  padding: 20px;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n  -khtml-user-select: none;\n  -ms-user-select: none; }\n  .main-desk-container::-webkit-scrollbar {\n    width: 18px;\n    height: 18px;\n    border-top: 1px solid #d0d0d0; }\n  .main-desk-container::-webkit-scrollbar:hover {\n    background-color: #f8f8f8; }\n  .main-desk-container::-webkit-scrollbar-thumb {\n    border-top: 1px solid #d0d0d0;\n    background: #bbb;\n    box-shadow: inset 0px 1px 0px 3px #f8f8f8; }\n  .main-desk-container::-webkit-scrollbar-thumb:hover {\n    background: #777; }\n  .main-desk-container .desk-container {\n    flex: 0 0 20%;\n    min-width: 250px;\n    box-sizing: border-box;\n    position: relative; }\n  .main-desk-container .desk {\n    position: absolute;\n    left: 0;\n    right: 30px;\n    top: 0;\n    bottom: 0;\n    overflow: hidden; }\n    .main-desk-container .desk__header {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      height: 25px;\n      line-height: 25px;\n      border-bottom: 5px solid #4d4d4d; }\n    .main-desk-container .desk__name {\n      text-transform: uppercase;\n      float: left;\n      font-weight: 700; }\n      .main-desk-container .desk__name:hover {\n        cursor: default; }\n    .main-desk-container .desk__open {\n      margin-left: 10px; }\n      .main-desk-container .desk__open i {\n        margin-bottom: 3px;\n        color: #999; }\n      .main-desk-container .desk__open:hover {\n        cursor: pointer; }\n        .main-desk-container .desk__open:hover i {\n          color: #333; }\n    .main-desk-container .desk__action {\n      float: right; }\n      .main-desk-container .desk__action .dropdown__toggle {\n        opacity: 0.6;\n        filter: \"alpha(opacity=60)\";\n        border: 0;\n        background: none;\n        vertical-align: baseline; }\n      .main-desk-container .desk__action .dropdown__menu {\n        right: 5px; }\n    .main-desk-container .desk__content {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 30px;\n      bottom: 0;\n      overflow-x: hidden;\n      overflow-y: auto; }\n      .main-desk-container .desk__content::-webkit-scrollbar {\n        width: 10px;\n        height: 10px; }\n      .main-desk-container .desk__content::-webkit-scrollbar:hover {\n        background: #f8f8f8; }\n      .main-desk-container .desk__content::-webkit-scrollbar-thumb {\n        background: #ddd;\n        box-shadow: inset 3px 2px 0px 1px #f8f8f8; }\n      .main-desk-container .desk__content::-webkit-scrollbar-thumb:hover {\n        background: #ccc; }\n\n.inline-content-items {\n  min-height: 18px;\n  margin-bottom: 6px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .inline-content-items .item {\n    cursor: default;\n    background: #fff;\n    height: 32px;\n    line-height: 32px;\n    box-sizing: border-box;\n    border-left: 3px solid #d1d1d1;\n    border-right: 2px solid #fff;\n    border-bottom: 1px solid #eee;\n    position: relative; }\n    .inline-content-items .item:last-child {\n      border-bottom: none; }\n    .inline-content-items .item.active {\n      background: #eff7fa;\n      border-right-color: #5ea9c8; }\n    .inline-content-items .item.locked {\n      border-left-color: #b70101; }\n    .inline-content-items .item .type {\n      float: left;\n      height: 32px; }\n      .inline-content-items .item .type i {\n        margin: 0 8px;\n        text-align: center;\n        vertical-align: middle;\n        color: #999; }\n    .inline-content-items .item .urgency {\n      height: 32px;\n      float: left;\n      line-height: 30px;\n      margin-right: 10px; }\n    .inline-content-items .item .urgency-label, .inline-content-items .item .priority-label {\n      vertical-align: middle; }\n    .inline-content-items .item time {\n      color: #999;\n      font-size: 11px; }\n    .inline-content-items .item .text {\n      height: 32px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      font-size: 12px;\n      padding-right: 10px; }\n      .inline-content-items .item .text .keywords {\n        color: #216278;\n        font-weight: 500;\n        text-transform: uppercase;\n        margin-right: 5px; }\n    .inline-content-items .item:not(:-moz-handler-blocked) .text {\n      white-space: normal; }\n    .inline-content-items .item .action {\n      position: absolute;\n      right: 0;\n      top: 0;\n      display: none;\n      background-color: inherit; }\n      .inline-content-items .item .action button {\n        background: transparent;\n        height: 32px;\n        border: 0;\n        border-left: 1px solid #e0e0e0;\n        display: block;\n        float: left; }\n        .inline-content-items .item .action button:hover {\n          cursor: pointer;\n          background: #f0f0f0; }\n    .inline-content-items .item.active .action button:hover {\n      background: #c8e4ee; }\n    .inline-content-items .item.shifted:hover .text {\n      padding-right: 57px; }\n    .inline-content-items .item.shifted:hover .action {\n      display: block; }\n  .inline-content-items.content-tasks .item {\n    border-left: none; }\n  .inline-content-items.content-tasks .avatar {\n    margin: 4px 10px 0 4px; }\n\n.slugline-content .loading {\n  width: 18px;\n  height: 18px;\n  background: url(" + escape(__webpack_require__(34)) + ") center center no-repeat #f8f8f8;\n  background-size: 18px;\n  text-align: center; }\n\n.slugline-content .no-items {\n  color: #bababa;\n  font-weight: 500;\n  cursor: default; }\n\n.slugline-content .inline_slugline_item .place {\n  text-transform: uppercase;\n  color: #777;\n  font-weight: 500; }\n\n.slugline-content .inline_slugline_item .slugline {\n  padding-left: 20px;\n  color: #216278;\n  text-transform: uppercase;\n  font-weight: 500; }\n\n.slugline-content .inline_slugline_item .oldslugline {\n  padding-left: 20px;\n  color: #3599b6;\n  text-transform: uppercase; }\n\n.slugline-content .inline_slugline_item .headline {\n  padding-left: 40px;\n  text-transform: none;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n@media (max-width: 1560px) {\n  .main-desk-container .desk-container {\n    flex: 0 0 25%; } }\n\n@media (max-width: 1180px) {\n  .main-desk-container .desk-container {\n    flex: 0 0 33%; } }\n\n/* Desk create/edit popup */\n.sd-wizard .modal__body .modal__body-content {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  background: 0 0; }\n  .sd-wizard .modal__body .modal__body-content > div, .sd-wizard .modal__body .modal__body-content > div > div, .sd-wizard .modal__body .modal__body-content > form, .sd-wizard .modal__body .modal__body-content > form > fieldset {\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto; }\n  .sd-wizard .modal__body .modal__body-content .content {\n    flex: 1 1 auto;\n    width: 100%;\n    overflow-y: auto;\n    padding: 2rem;\n    background: #f8f8f8; }\n  .sd-wizard .modal__body .modal__body-content form.content, .sd-wizard .modal__body .modal__body-content .field {\n    display: block; }\n  .sd-wizard .modal__body .modal__body-content .modal__footer {\n    display: block;\n    flex: 0 0 auto; }\n\n.sd-wizard .stages .col {\n  position: absolute;\n  box-sizing: border-box;\n  top: 60px;\n  bottom: 10px;\n  left: 0;\n  right: 50%;\n  padding: 10px 20px;\n  overflow-x: hidden;\n  overflow-y: auto; }\n  .sd-wizard .stages .col:last-child {\n    left: 50%;\n    right: 0;\n    border-left: 1px solid #e0e0e0; }\n\n.sd-wizard .stages .row {\n  padding-top: 20px;\n  clear: both; }\n  .sd-wizard .stages .row label {\n    display: inline-block; }\n  .sd-wizard .stages .row .prevent-off {\n    pointer-events: none; }\n\n.sd-wizard .stages .heading {\n  padding: 2px 0;\n  color: #666;\n  margin-right: 10px;\n  text-transform: uppercase; }\n\n.sd-wizard .stages [sd-content-expiry] {\n  position: relative;\n  float: none; }\n  .sd-wizard .stages [sd-content-expiry] .right {\n    position: absolute;\n    top: -18px;\n    right: 0; }\n  .sd-wizard .stages [sd-content-expiry] label {\n    font-size: 13px;\n    color: #333; }\n\n.sd-wizard .stages .stage-type {\n  margin-bottom: 10px; }\n\n.sd-wizard .stages select {\n  margin-bottom: 10px; }\n\n.sd-wizard .stages .pills-list li {\n  cursor: pointer; }\n  .sd-wizard .stages .pills-list li label {\n    line-height: 12px; }\n  .sd-wizard .stages .pills-list li .global-label {\n    font-size: 12px;\n    color: #aaa;\n    margin-top: 5px;\n    margin-right: 5px;\n    text-transform: none; }\n    .sd-wizard .stages .pills-list li .global-label span:nth-child(2) {\n      margin-left: 0; }\n  .sd-wizard .stages .pills-list li.active .global-label {\n    color: #fff;\n    opacity: 0.8; }\n  .sd-wizard .stages .pills-list li.editable {\n    padding-top: 0; }\n    .sd-wizard .stages .pills-list li.editable .char-count.error {\n      font-weight: 500;\n      color: #D33C30; }\n\n.sd-wizard .stages .pills-list.edit-mode li.editable {\n  box-shadow: none;\n  outline: 1px solid #5ea9c8;\n  background-color: rgba(94, 169, 200, 0.1);\n  margin-bottom: 10px; }\n\n.sd-wizard .stages .pills-list.edit-mode li:not(.editable) {\n  display: none; }\n\n.sd-wizard .stages .status-list .status {\n  display: block;\n  border-radius: 3px;\n  box-sizing: border-box;\n  margin-bottom: 5px;\n  height: 28px;\n  padding: 5px 10px;\n  text-transform: uppercase; }\n  .sd-wizard .stages .status-list .status:hover {\n    cursor: pointer; }\n  .sd-wizard .stages .status-list .status.todo {\n    background: #b70000;\n    color: #b70000; }\n    .sd-wizard .stages .status-list .status.todo.active {\n      background: #b70000;\n      color: #fff; }\n  .sd-wizard .stages .status-list .status.in_progress {\n    background: #cc7800;\n    color: #cc7800; }\n    .sd-wizard .stages .status-list .status.in_progress.active {\n      background: #cc7800;\n      color: #fff; }\n  .sd-wizard .stages .status-list .status.done {\n    background: #288001;\n    color: #288001; }\n    .sd-wizard .stages .status-list .status.done.active {\n      background: #288001;\n      color: #fff; }\n\n.sd-wizard .people-stage .header .search-result {\n  overflow: auto;\n  border: 1px solid #ddd;\n  background: #fff;\n  padding: 10px;\n  z-index: 1; }\n\n.sd-wizard textarea {\n  height: 44px; }\n\n.sd-wizard .col-heading {\n  padding: 2px 0;\n  color: #666;\n  margin-right: 10px;\n  text-transform: uppercase; }\n\n.user-email {\n  color: #3599b6;\n  font-weight: 300;\n  display: inline-block;\n  padding: 0 2rem; }\n\n.content-expiry-label {\n  color: #333; }\n\n.modal--tabs .button-toolbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: #e9f0f3;\n  padding: 10px;\n  text-align: right;\n  width: 100%;\n  animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 0 0 rgba(0, 0, 0, 0.1); }\n\n.members-grid ul > li {\n  position: relative;\n  float: left;\n  margin: 5px;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  padding: 15px 10px;\n  width: 135px; }\n  .members-grid ul > li .avatar {\n    display: block;\n    width: 84px;\n    height: 84px;\n    float: none;\n    margin: 0 auto 10px; }\n    .members-grid ul > li .avatar.initials {\n      font-size: 34px;\n      line-height: 84px; }\n  .members-grid ul > li .name {\n    text-align: center;\n    width: 115px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .members-grid ul > li i {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    display: none;\n    opacity: 0.6;\n    filter: \"alpha(opacity=60)\"; }\n    .members-grid ul > li i:hover {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\";\n      cursor: pointer; }\n  .members-grid ul > li:hover {\n    border-color: rgba(0, 0, 0, 0.12);\n    box-shadow: 0 1px 3px 0 black; }\n    .members-grid ul > li:hover i {\n      display: block; }\n  .members-grid ul > li.inactive {\n    color: #ccc; }\n\n.members-list {\n  padding-top: 1rem; }\n\n/*----------------------------------------\n  #Item groups (stages, task statuses etc.)\n----------------------------------------*/\n.item-group {\n  margin-top: 5px;\n  margin-bottom: 10px; }\n  .item-group__content {\n    padding: 2px;\n    overflow: auto;\n    max-height: 330px;\n    overflow-x: hidden; }\n    .item-group__content--full-height {\n      max-height: none; }\n    .item-group__content::-webkit-scrollbar {\n      width: 4px;\n      height: 4px;\n      border: none; }\n    .item-group__content::-webkit-scrollbar:hover {\n      background-color: #f8f8f8; }\n    .item-group__content::-webkit-scrollbar-thumb {\n      border: none;\n      background: rgba(0, 0, 0, 0.1); }\n    .item-group__content::-webkit-scrollbar-thumb:hover {\n      background: rgba(0, 0, 0, 0.25); }\n  .item-group__loading {\n    width: 18px;\n    height: 18px;\n    background: url(" + escape(__webpack_require__(34)) + ") center center no-repeat #f8f8f8;\n    background-size: 18px;\n    text-align: center; }\n  .item-group__no-items {\n    color: #bababa;\n    font-weight: 500;\n    cursor: default; }\n  .item-group__header {\n    padding: 0;\n    height: 26px;\n    line-height: 16px; }\n  .item-group__name {\n    font-size: 12px;\n    text-transform: uppercase;\n    color: #777;\n    font-weight: 500;\n    cursor: default;\n    float: left; }\n    .item-group__name--todo {\n      color: #b70000; }\n    .item-group__name--in_progress {\n      color: #cc7800; }\n    .item-group__name--done {\n      color: #288001; }\n\n/*---------------------------------------------------------------\n  #Content item (list item for content, tasks, users and slulines\n----------------------------------------------------------------*/\n.content-item, .slugline-item {\n  cursor: default;\n  background: #fff;\n  height: 32px;\n  line-height: 32px;\n  box-sizing: border-box;\n  border-left: 3px solid rgba(255, 255, 255, 0);\n  border-right: 2px solid #fff;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  display: flex;\n  padding-right: 8px; }\n  .content-item--slugline-view {\n    min-height: 32px;\n    border-left: none;\n    height: auto;\n    line-height: 160%;\n    padding: 10px; }\n  .content-item:last-child, .slugline-item:last-child {\n    border-bottom: none; }\n  .content-item--active {\n    background: #eff7fa;\n    border-right-color: #5ea9c8; }\n  .content-item--locked {\n    border-left-color: #b70101; }\n  .content-item.gone, .gone.slugline-item {\n    opacity: 0.5; }\n  .content-item--no-border {\n    border-left: none; }\n  .content-item__type {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0; }\n    .content-item__type i {\n      margin: 0 8px 0 6px;\n      text-align: center;\n      color: #999;\n      flex-shrink: 0; }\n  .content-item__urgency-field {\n    height: 100%;\n    margin-right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0; }\n  .content-item .urgency-label, .slugline-item .urgency-label, .content-item .priority-label, .slugline-item .priority-label {\n    vertical-align: middle;\n    flex-shrink: 0; }\n  .content-item time, .slugline-item time {\n    color: #999;\n    font-size: 11px; }\n  .content-item__text {\n    height: 32px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-size: 12px;\n    padding-right: 10px;\n    flex-grow: 1; }\n    .content-item__text .keywords {\n      color: #216278;\n      font-weight: 500;\n      text-transform: uppercase;\n      margin-right: 5px; }\n  .content-item__date time {\n    white-space: nowrap; }\n  .content-item:not(:-moz-handler-blocked) .content-item__text, .slugline-item:not(:-moz-handler-blocked) .content-item__text {\n    white-space: normal; }\n  .content-item__action {\n    display: none;\n    background-color: inherit;\n    margin-right: -8px; }\n  .content-item.active .action button:hover, .active.slugline-item .action button:hover {\n    background: #c8e4ee; }\n  .content-item.active.custom-monitoring, .active.custom-monitoring.slugline-item {\n    background-color: #eff7fa !important; }\n  .content-item.shifted:hover .content-item__text, .shifted.slugline-item:hover .content-item__text {\n    padding-right: 0; }\n  .content-item.shifted:hover .content-item__action, .shifted.slugline-item:hover .content-item__action {\n    display: flex;\n    align-items: center;\n    justify-content: center; }\n  .content-item.shifted:hover time, .shifted.slugline-item:hover time {\n    display: none; }\n  .content-item.custom-monitoring:hover, .custom-monitoring.slugline-item:hover {\n    background-color: #f4f4f4;\n    cursor: pointer; }\n\n.slugline-item {\n  border-left: none;\n  height: auto;\n  line-height: 160%;\n  padding: 0 8px;\n  margin: 0;\n  display: block;\n  border-bottom: 1px #eee solid; }\n  .slugline-item:last-child {\n    border-bottom: none; }\n  .slugline-item__row {\n    height: 24px;\n    clear: both;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .slugline-item__row--main {\n      padding-top: 10px; }\n  .slugline-item .place {\n    font-size: 12px;\n    text-transform: uppercase;\n    color: #777;\n    font-weight: 500; }\n  .slugline-item .slugline {\n    color: #216278;\n    font-weight: 500;\n    text-transform: uppercase; }\n  .slugline-item .oldslugline {\n    color: #4badce;\n    font-weight: 400;\n    text-transform: uppercase; }\n  .slugline-item .headline {\n    font-weight: 400;\n    color: #555; }\n  .slugline-item time {\n    color: #999;\n    font-size: 11px; }\n", ""]);

// exports


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeskListController_1 = __webpack_require__(1535);
exports.DeskListController = DeskListController_1.DeskListController;
var DeskSettingsController_1 = __webpack_require__(1536);
exports.DeskSettingsController = DeskSettingsController_1.DeskSettingsController;
var DeskConfigController_1 = __webpack_require__(1537);
exports.DeskConfigController = DeskConfigController_1.DeskConfigController;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
DeskListController.$inject = ['$scope', 'desks', 'superdesk', 'privileges', 'tasks', 'api', 'betaService'];
function DeskListController($scope, desks, superdesk, privileges, tasks, api, beta) {
    var userDesks;
    function sorted(result) {
        var items = result._items || [];
        items.sort(compareNames);
        return items;
        function compareNames(a, b) {
            return a.name.localeCompare(b.name);
        }
    }
    desks.initialize()
        .then(function () {
        $scope.desks = desks.desks;
        $scope.deskStages = desks.deskStages;
        desks.fetchCurrentUserDesks().then(function (deskList) {
            userDesks = deskList;
        });
    });
    $scope.statuses = tasks.statuses;
    $scope.online_users = false;
    api('roles').query()
        .then(function (result) {
        $scope.roles = sorted(result);
    });
    $scope.privileges = privileges.privileges;
    beta.isBeta().then(function (isBeta) {
        var views = ['content', 'users', 'sluglines'];
        if (isBeta) {
            views = ['content', 'tasks', 'users', 'sluglines'];
        }
        $scope.$applyAsync(function () {
            $scope.views = views;
            $scope.view = $scope.views[0];
        });
    });
    $scope.setView = function (view) {
        $scope.view = view;
    };
    $scope.changeOnlineUsers = function (value) {
        $scope.online_users = value;
    };
    $scope.isMemberOf = function (desk) {
        return lodash_1.default.find(userDesks, { _id: desk._id }) !== null;
    };
    $scope.openDeskView = function (desk, target) {
        desks.setCurrentDeskId(desk._id);
        superdesk.intent('view', target);
    };
}
exports.DeskListController = DeskListController;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DeskSettingsController.$inject = ['$scope', 'desks'];
function DeskSettingsController($scope, desks) {
    desks.initialize()
        .then(function () {
        $scope.desks = desks.desks;
    });
}
exports.DeskSettingsController = DeskSettingsController;


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DeskConfigController.$inject = ['$scope', '$controller', 'notify', 'desks', 'WizardHandler', 'modal'];
function DeskConfigController($scope, $controller, notify, desks, WizardHandler, modal) {
    // expecting $scope.desks to be defined
    $scope.modalActive = false;
    $scope.numberOfUsers = 3;
    $scope.step = {
        current: null,
    };
    $scope.desk = {
        edit: null,
    };
    $scope.openDesk = function (step, desk) {
        $scope.modalActive = true;
        $scope.step.current = step;
        $scope.desk.edit = desk || {};
        $scope.desk.edit.desk_metadata = $scope.desk.edit.desk_metadata || {};
    };
    $scope.agg = $controller('AggregateCtrl', { $scope: $scope });
    $scope.openMonitoringSettings = function (desk) {
        $scope.agg.settings.desk = desk;
        $scope.agg.edit();
    };
    $scope.cancel = function () {
        $scope.modalActive = false;
        $scope.step.current = null;
        $scope.desk.edit = null;
    };
    $scope.remove = function (desk) {
        modal.confirm(utils_1.gettext('Please confirm you want to delete desk.')).then(function runConfirmed() {
            desks.remove(desk).then(function (response) {
                lodash_1.default.remove($scope.desks._items, function (deskToBeRemoved) { return deskToBeRemoved.name.toLowerCase() === desk.name.toLowerCase(); });
                notify.success(utils_1.gettext('Desk deleted.'), 3000);
            }, function (response) {
                if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('Unknown Error: There was a problem, desk was not deleted.'));
                }
            });
        });
    };
    $scope.getDeskStages = function (desk) {
        return desks.deskStages[desk._id];
    };
    $scope.getDeskUsers = function (desk) {
        return desks.deskMembers[desk._id];
    };
}
exports.DeskConfigController = DeskConfigController;


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TaskStatusItemsDirective_1 = __webpack_require__(1539);
exports.TaskStatusItemsDirective = TaskStatusItemsDirective_1.TaskStatusItemsDirective;
var UserRoleItemListDirective_1 = __webpack_require__(1540);
exports.UserRoleItemListDirective = UserRoleItemListDirective_1.UserRoleItemListDirective;
var SluglinesItemListDirective_1 = __webpack_require__(1541);
exports.SluglinesItemListDirective = SluglinesItemListDirective_1.SluglinesItemListDirective;
var StageHeaderDirective_1 = __webpack_require__(1542);
exports.StageHeaderDirective = StageHeaderDirective_1.StageHeaderDirective;
var DeskConfigModal_1 = __webpack_require__(1543);
exports.DeskConfigModal = DeskConfigModal_1.DeskConfigModal;
var FocusElement_1 = __webpack_require__(1544);
exports.FocusElement = FocusElement_1.FocusElement;
var ContentExpiry_1 = __webpack_require__(1545);
exports.ContentExpiry = ContentExpiry_1.ContentExpiry;
var DeskeditBasic_1 = __webpack_require__(1546);
exports.DeskeditBasic = DeskeditBasic_1.DeskeditBasic;
var DeskeditStages_1 = __webpack_require__(1547);
exports.DeskeditStages = DeskeditStages_1.DeskeditStages;
var UserSelectList_1 = __webpack_require__(1548);
exports.UserSelectList = UserSelectList_1.UserSelectList;
var DeskeditPeople_1 = __webpack_require__(1549);
exports.DeskeditPeople = DeskeditPeople_1.DeskeditPeople;
var DeskeditMacros_1 = __webpack_require__(1550);
exports.DeskeditMacros = DeskeditMacros_1.DeskeditMacros;
var ActionPicker_1 = __webpack_require__(1551);
exports.ActionPicker = ActionPicker_1.ActionPicker;
var DeskSelect_1 = __webpack_require__(1553);
exports.DeskSelect = DeskSelect_1.DeskSelect;
var DeskSelectItem_1 = __webpack_require__(1554);
exports.DeskSelectItem = DeskSelectItem_1.DeskSelectItem;
var MarkDesksDropdown_1 = __webpack_require__(1555);
exports.MarkDesksDropdown = MarkDesksDropdown_1.MarkDesksDropdown;
var DesksReactDropdown_1 = __webpack_require__(557);
exports.DesksReactDropdown = DesksReactDropdown_1.DesksReactDropdown;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
TaskStatusItemsDirective.$inject = ['search', 'api', 'desks'];
function TaskStatusItemsDirective(search, api, desks) {
    return {
        templateUrl: 'scripts/apps/desks/views/task-status-items.html',
        scope: {
            status: '=',
            desk: '=',
            total: '=',
        },
        link: function (scope, elem) {
            scope.users = desks.userLookup;
            var query = search.query({});
            query.filter({ and: [
                    { term: { 'task.status': scope.status } },
                    { term: { 'task.desk': scope.desk } },
                ] });
            query.size(10);
            var criteria = { source: query.getCriteria() };
            scope.loading = true;
            api('archive').query(criteria)
                .then(function (items) {
                scope.loading = false;
                scope.items = items._items;
                scope.total = items._meta.total;
            }, function () {
                scope.loading = false;
            });
        },
    };
}
exports.TaskStatusItemsDirective = TaskStatusItemsDirective;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
UserRoleItemListDirective.$inject = ['desks', 'usersService'];
function UserRoleItemListDirective(desks, usersService) {
    return {
        templateUrl: 'scripts/apps/desks/views/user-role-items.html',
        scope: {
            role: '=',
            desk: '=',
            total: '=',
            online: '=',
            privilege: '=',
        },
        link: function (scope, elem) {
            scope.users = desks.deskMembers[scope.desk];
            scope.total = 0;
            scope.items = [];
            scope.user = null;
            lodash_1.default.each(scope.users, function (user, index) {
                if (scope.role === user.role) {
                    scope.items.push(user);
                    scope.total = scope.total + 1;
                }
            });
            scope.isLoggedIn = function (user) {
                return usersService.isLoggedIn(user);
            };
            scope.openEditUser = function (user) {
                scope.user = user;
            };
            scope.closeEditUser = function () {
                scope.user = null;
            };
        },
    };
}
exports.UserRoleItemListDirective = UserRoleItemListDirective;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
SluglinesItemListDirective.$inject = ['api'];
function SluglinesItemListDirective(api) {
    return {
        templateUrl: 'scripts/apps/desks/views/slugline-items.html',
        scope: {
            desk: '=',
        },
        link: function (scope, elem) {
            scope.items = [];
            scope.loading = true;
            api.get('desks/' + scope.desk + '/sluglines').then(function (items) {
                scope.items = items._items;
            })
                .finally(function () {
                scope.loading = false;
            });
        },
    };
}
exports.SluglinesItemListDirective = SluglinesItemListDirective;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function StageHeaderDirective() {
    return { templateUrl: 'scripts/apps/desks/views/stage-header.html' };
}
exports.StageHeaderDirective = StageHeaderDirective;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name sdDeskConfigModal
 *
 * @requires metadata
 * @requires content
 * @requires api
 *
 * @description Generates modal for editing desks
 */
DeskConfigModal.$inject = ['metadata', 'content', 'templates', 'api', 'deployConfig'];
function DeskConfigModal(metadata, content, templates, api, deployConfig) {
    return {
        scope: {
            modalActive: '=active',
            desk: '=',
            step: '=',
            desks: '=',
            cancel: '&',
        },
        require: '^sdDeskConfig',
        templateUrl: 'scripts/apps/desks/views/desk-config-modal.html',
        link: function (scope, elem, attrs, ctrl) {
            scope.monitoringViews = {
                '': { label: utils_1.gettext('None') },
                list: { label: utils_1.gettext('List View'), icon: 'list-view' },
                swimlane: { label: utils_1.gettext('Swimlane View'), icon: 'kanban-view' },
                photogrid: { label: utils_1.gettext('Photo Grid View'), icon: 'grid-view' },
            };
            /*
             * Initialize metadata
             * @return {Object} metadata
             */
            metadata.initialize().then(function () {
                scope.metadata = metadata.values;
            });
            scope.systemExpiry = deployConfig.getSync('content_expiry_minutes');
            /*
             * Initialize content types
             * @return {Object} profiles
             */
            content.getTypes().then(function (profiles) {
                scope.profiles = profiles;
            });
            /*
             * Initialize languages
             * @return {Object} languages
             */
            api.query('languages').then(function (languages) {
                scope.languages = languages._items;
            });
            scope.$watch('desk', function (desk) {
                scope.templates = null;
                if (desk) {
                    templates.fetchTemplatesByDesk(desk._id).then(function (data) {
                        scope.templates = data._items;
                    });
                }
            });
        },
    };
}
exports.DeskConfigModal = DeskConfigModal;


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
function FocusElement() {
    return {
        link: function (scope, elem, attrs) {
            elem.click(function () {
                lodash_1.defer(function () {
                    angular.element(document.querySelector(attrs.target)).focus();
                });
            });
        },
    };
}
exports.FocusElement = FocusElement;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name sdContentExpiry
 *
 * @description
 *   This directive is responsible for rendering content expiry for ingest, desk and stages.
 */
function ContentExpiry() {
    return {
        templateUrl: 'scripts/apps/desks/views/content-expiry.html',
        scope: {
            item: '=',
            preview: '=',
            header: '@',
            expiryMinutes: '=',
            expiryContext: '@',
        },
        link: function (scope, elem, attrs) {
            var expiryfield = attrs.expiryfield;
            scope.contentExpiry = {
                expire: true,
                days: 0,
                hours: 0,
                minutes: 0,
                header: 'Content Expiry',
                actualExpiry: null,
            };
            scope.$watch('item', function () {
                setContentExpiry(scope.item);
            });
            scope.$watch('contentExpiry', function () {
                if (!scope.item) {
                    scope.item = {};
                }
                scope.item[expiryfield] = getTotalExpiryMinutes(scope.contentExpiry);
                getActualExpiry();
            }, true);
            function getExpiryDays(inputMin) {
                return Math.floor(inputMin / (60 * 24));
            }
            function getExpiryHours(inputMin) {
                return Math.floor(inputMin / 60 % 24);
            }
            function getExpiryMinutes(inputMin) {
                return Math.floor(inputMin % 60);
            }
            function getTotalExpiryMinutes(contentExpiry) {
                if (contentExpiry.expire) {
                    return contentExpiry.days * 24 * 60 + contentExpiry.hours * 60 + contentExpiry.minutes;
                }
                return -1;
            }
            /**
             * @ngdoc method
             * @name sdContentExpiry#getActualExpiry
             * @private
             * @description Calculate the expiry string to display based on the context.
             * The actual expiry is displayed if content expiry is not set.
             */
            function getActualExpiry() {
                // if desk or stage or ingest content expiry then don't calculate.
                if (scope.contentExpiry.expire && (scope.contentExpiry.days > 0 || scope.contentExpiry.hours > 0 ||
                    scope.contentExpiry.minutes > 0)) {
                    scope.contentExpiry.actualExpiry = null;
                    return;
                }
                var days, hours, minutes, expiry = null, text = 'OFF';
                if (scope.expiryMinutes > 0) {
                    days = getExpiryDays(scope.expiryMinutes);
                    hours = getExpiryHours(scope.expiryMinutes);
                    minutes = getExpiryMinutes(scope.expiryMinutes);
                    expiry = "days:" + days + " hr:" + hours + " min:" + minutes;
                    if (scope.preview) {
                        expiry = "(" + expiry + ")";
                    }
                    text = "Using " + scope.expiryContext + " default";
                }
                scope.contentExpiry.actualExpiry = {
                    text: text,
                    expiry: expiry,
                };
            }
            var setContentExpiry = function (item) {
                scope.contentExpiry.header = scope.header;
                scope.contentExpiry.expire = true;
                scope.contentExpiry.days = 0;
                scope.contentExpiry.hours = 0;
                scope.contentExpiry.minutes = 0;
                scope.contentExpiry.actualExpiry = null;
                if (item && !lodash_1.default.isNil(item[expiryfield])) {
                    if (item[expiryfield] < 0) {
                        scope.contentExpiry.expire = false;
                    }
                    else {
                        scope.contentExpiry.days = getExpiryDays(item[expiryfield]);
                        scope.contentExpiry.hours = getExpiryHours(item[expiryfield]);
                        scope.contentExpiry.minutes = getExpiryMinutes(item[expiryfield]);
                    }
                }
                getActualExpiry();
            };
        },
    };
}
exports.ContentExpiry = ContentExpiry;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(556);
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DeskeditBasic.$inject = ['desks', 'WizardHandler', 'metadata', 'config',
    '$filter', 'deployConfig'];
function DeskeditBasic(desks, WizardHandler, metadata, config, $filter, deployConfig) {
    return {
        link: function (scope, elem, attrs) {
            scope.limits = constants_1.limits;
            scope.deskTypes = [];
            scope.saving = false;
            scope.message = null;
            /**
             * Is Published Content Expiry is set
             */
            scope.isPublishedContentExpired = function () { return deployConfig.getSync('publish_content_expiry_minutes', 0) > 0; };
            scope.$watch('step.current', function (step) {
                if (step === 'general') {
                    if (scope.desk.edit && scope.desk.edit._id) {
                        scope.edit(scope.desk.edit);
                    }
                    scope.message = null;
                }
            });
            scope.edit = function (desk) {
                scope.desk.edit = lodash_1.default.create(desk);
                scope.desk.orig = desk;
                scope.desk.edit.desk_metadata = desk.desk_metadata || {};
                scope.desk.edit.content_profiles = desk.content_profiles || {};
            };
            /**
             * Save desk for adding or editing
             *
             * @param {object} desk
             * @param {boolean} done
             *      when true it exits after saving otherwise
             *      continues to next step in wizard handler.
             */
            scope.save = function (desk, done) {
                scope.saving = true;
                scope.message = utils_1.gettext('Saving...');
                var _new = !desk._id;
                desks.save(scope.desk.edit, desk).then(function (res) {
                    if (_new) {
                        scope.edit(scope.desk.edit);
                        scope.desks._items.unshift(scope.desk.edit);
                        desks.refreshStages();
                    }
                    else {
                        angular.extend(scope.desk.orig, res);
                    }
                    scope.desks._items = $filter('sortByName')(scope.desks._items);
                    desks.deskLookup[scope.desk.edit._id] = scope.desk.edit;
                    if (!done) {
                        WizardHandler.wizard('desks').next();
                    }
                    else {
                        WizardHandler.wizard('desks').finish();
                    }
                }, errorMessage)
                    .finally(function () {
                    scope.saving = false;
                    scope.message = null;
                });
            };
            function errorMessage(response) {
                scope._error = true;
                scope._errorMessage = utils_1.gettext('There was a problem, desk not created/updated.');
                if (response.data && response.data._issues) {
                    if (response.data._issues.name && response.data._issues.name.unique) {
                        scope._errorMessage = utils_1.gettext('Desk with name {{name}} already exists.', { name: scope.desk.edit.name });
                    }
                    else if (response.data._issues['validator exception']) {
                        scope._errorMessage = utils_1.gettext(response.data._issues['validator exception']);
                    }
                }
            }
            function clearErrorMessages() {
                if (scope._error || scope._errorLimits) {
                    scope._errorMessage = '';
                    scope._error = null;
                    scope._errorLimits = null;
                    scope.message = null;
                }
            }
            scope.handleEdit = function ($event) {
                clearErrorMessages();
                if (!lodash_1.default.isNil(scope.desk.edit.name)) {
                    scope._errorLimits = scope.desk.edit.name.length > scope.limits.desk ? true : null;
                }
            };
            scope.showNoPublishOnAuthoringDesk = function (deskType) {
                return deskType === 'authoring' && config.features.noPublishOnAuthoringDesk;
            };
            if (metadata.values.desk_types) {
                scope.deskTypes = metadata.values.desk_types;
            }
            else {
                metadata.fetchMetadataValues()
                    .then(function () {
                    scope.deskTypes = metadata.values.desk_types;
                });
            }
        },
    };
}
exports.DeskeditBasic = DeskeditBasic;


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(556);
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DeskeditStages.$inject = ['api', 'WizardHandler', 'tasks', '$rootScope', 'desks', 'notify',
    'macros', 'deployConfig'];
function DeskeditStages(api, WizardHandler, tasks, $rootScope, desks, notify, macros, deployConfig) {
    return {
        link: function (scope, elem, attrs) {
            var orig = null;
            scope.limits = constants_1.limits;
            scope.saving = false;
            scope.statuses = tasks.statuses;
            scope.systemExpiry = deployConfig.getSync('content_expiry_minutes');
            if (scope.desk.edit && scope.desk.edit.name) {
                macros.getByDesk(scope.desk.edit.name, true).then(function (_macros) {
                    scope.macros = lodash_1.default.reject(_macros, { action_type: 'interactive' });
                });
            }
            else {
                macros.get(true).then(function (_macros) {
                    scope.macros = lodash_1.default.reject(_macros, { action_type: 'interactive' });
                });
            }
            scope.$watch('step.current', function (step, previous) {
                if (step === 'stages') {
                    scope.editStage = null;
                    orig = null;
                    scope.stages = [];
                    scope.selected = null;
                    scope.message = null;
                    scope.getstages(previous);
                }
            });
            scope.getstages = function (previous) {
                if (scope.desk.edit && scope.desk.edit._id) {
                    scope.message = utils_1.gettext('loading...');
                    desks.fetchDeskStages(scope.desk.edit._id, true).then(function (stages) {
                        scope.stages = stages;
                        scope.message = null;
                    })
                        .finally(function () { });
                }
                else {
                    WizardHandler.wizard('desks').goTo(previous);
                }
            };
            /**
             * Save desk for adding or editing
             *
             * @param {boolean} done
             *      when true it exits otherwise continues
             *      to next step in wizard handler.
             */
            scope.next = function (done) {
                if (!done) {
                    WizardHandler.wizard('desks').next();
                }
                else {
                    WizardHandler.wizard('desks').finish();
                }
            };
            scope.edit = function (stage) {
                if (lodash_1.default.isNil(stage.is_visible)) {
                    stage.is_visible = true;
                }
                stage.local_readonly = !!stage.local_readonly;
                orig = stage;
                scope.editStage = lodash_1.default.create(stage);
                if (!scope.editStage._id) {
                    var lastStage = lodash_1.default.last(scope.stages);
                    if (lastStage) {
                        scope.editStage.task_status = lastStage.task_status;
                    }
                }
            };
            scope.isActive = function (stage) {
                return scope.editStage && scope.editStage._id === stage._id;
            };
            scope.shouldVisible = function () {
                scope.editStage.is_visible = scope.editStage.default_incoming ? true : scope.editStage.is_visible;
            };
            scope.cancel = function () {
                scope.editStage = null;
                clearErrorMessages();
            };
            scope.select = function (stage) {
                if (scope.editStage && scope.editStage._id !== stage._id) {
                    return false;
                }
                scope.selected = stage;
            };
            scope.setStatus = function (status) {
                scope.editStage.task_status = status._id;
            };
            scope.save = function () {
                scope.saving = true;
                scope.message = utils_1.gettext('Saving...');
                var dest = orig._id ? orig : {};
                var diff = orig._id ? scope.editStage : angular.extend(scope.editStage, { desk: scope.desk.edit._id });
                saveStage(dest, diff);
            };
            function saveStage(dest, diff) {
                api('stages').save(dest, diff)
                    .then(function (item) {
                    scope.select(item);
                    return desks.fetchDeskById(item.desk);
                })
                    .then(function (desk) {
                    scope.desk.edit = desk;
                    scope.getstages();
                }, errorMessage)
                    .finally(function () {
                    scope.saving = false;
                    scope.message = null;
                    scope.editStage = null;
                });
            }
            function errorMessage(response) {
                if (response.status === 412) {
                    notify.error(utils_1.gettext('Stage has been modified elsewhere. Please reload the desks'));
                }
                else if (response.data && response.data._issues) {
                    if (response.data._issues.name && response.data._issues.name.unique) {
                        scope._errorUniqueness = true;
                    }
                    else if (response.data._issues['validator exception']) {
                        notify.error(response.data._issues['validator exception']);
                    }
                }
                else {
                    scope._error = true;
                }
            }
            scope.handleEdit = function ($event) {
                clearErrorMessages();
                if (!lodash_1.default.isNil(scope.editStage.name)) {
                    scope._errorLimits = scope.editStage.name.length > scope.limits.stage ? true : null;
                }
            };
            scope.enableSave = function () {
                return scope.editStage && scope.editStage.name &&
                    scope.editStage.name.length > 0 && !scope._errorLimits;
            };
            function clearErrorMessages() {
                if (scope._errorUniqueness || scope._error || scope._errorLimits) {
                    scope._errorUniqueness = null;
                    scope._error = null;
                    scope._errorLimits = null;
                }
                scope.message = null;
            }
            scope.remove = function (stage) {
                api('stages').remove(stage)
                    .then(function () {
                    if (stage === scope.selected) {
                        scope.selected = null;
                    }
                    lodash_1.default.remove(scope.stages, stage);
                    scope.message = null;
                    return desks.fetchDeskById(stage.desk);
                })
                    .then(function (desk) {
                    scope.desk.edit = desk;
                    desks.refreshStages();
                }, function (response) {
                    if (angular.isDefined(response.data._message)) {
                        scope.message = utils_1.gettext('Error: ' + response.data._message);
                    }
                    else {
                        scope.message = utils_1.gettext('There was a problem, stage was not deleted.');
                    }
                });
            };
        },
    };
}
exports.DeskeditStages = DeskeditStages;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
UserSelectList.$inject = ['$filter', 'api'];
function UserSelectList($filter, api) {
    return {
        scope: {
            exclude: '=?',
            onchoose: '&',
            onsearch: '&',
            displayUser: '@',
            tabindex: '=',
        },
        templateUrl: 'scripts/apps/desks/views/user-select.html',
        link: function (scope, elem, attrs) {
            var ARROW_UP = 38, ARROW_DOWN = 40, ENTER = 13;
            scope.selected = null;
            scope.search = null;
            scope.users = {};
            scope.exclude = [];
            scope.refresh = true;
            scope.message = null;
            var _refresh = function () {
                scope.users = {};
                return api('users').query({ where: JSON.stringify({
                        $or: [
                            { username: { $regex: scope.search, $options: '-i' } },
                            { first_name: { $regex: scope.search, $options: '-i' } },
                            { last_name: { $regex: scope.search, $options: '-i' } },
                            { email: { $regex: scope.search, $options: '-i' } },
                        ],
                    }) })
                    .then(function (result) {
                    scope.users = result;
                    scope.users._items = lodash_1.default.filter(scope.users._items, function (item) { return lodash_1.default.findIndex(scope.exclude, { _id: item._id }) === -1; });
                    scope.selected = null;
                    if (scope.onsearch) {
                        scope.onsearch({ search: scope.search });
                    }
                });
            };
            var refresh = lodash_1.default.debounce(_refresh, 1000);
            scope.$watch('search', function () {
                if (scope.search && scope.refresh) {
                    refresh();
                }
                scope.refresh = true;
            });
            function getSelectedIndex() {
                if (scope.selected) {
                    return lodash_1.default.findIndex(scope.users._items, scope.selected);
                }
                return -1;
            }
            function previous() {
                var selectedIndex = getSelectedIndex();
                if (selectedIndex > 0) {
                    scope.select(scope.users._items[lodash_1.default.max([0, selectedIndex - 1])]);
                }
            }
            function next() {
                var selectedIndex = getSelectedIndex();
                scope.select(scope.users._items[lodash_1.default.min([scope.users._items.length - 1, selectedIndex + 1])]);
            }
            elem.bind('keydown keypress', function (event) {
                scope.$apply(function () {
                    switch (event.which) {
                        case ARROW_UP:
                            event.preventDefault();
                            previous();
                            break;
                        case ARROW_DOWN:
                            event.preventDefault();
                            next();
                            break;
                        case ENTER:
                            event.preventDefault();
                            if (getSelectedIndex() >= 0) {
                                scope.choose(scope.selected);
                            }
                            break;
                    }
                });
            });
            scope.choose = function (user) {
                scope.onchoose({ user: user });
                if (scope.displayUser) {
                    scope.refresh = false;
                    scope.users = {};
                    scope.search = user[scope.displayUser];
                }
                else {
                    scope.search = null;
                }
            };
            scope.select = function (user) {
                scope.selected = user;
            };
            scope.getUserDisplay = function (user) {
                if (scope.displayUser) {
                    return user[scope.displayUser];
                }
                return user.display_name;
            };
        },
    };
}
exports.UserSelectList = UserSelectList;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DeskeditPeople.$inject = ['WizardHandler', 'desks', '$rootScope'];
function DeskeditPeople(WizardHandler, desks, $rootScope) {
    return {
        link: function (scope, elem, attrs) {
            scope.$watch('step.current', function (step, previous) {
                if (step === 'people') {
                    scope.search = null;
                    scope.deskMembers = [];
                    scope.message = utils_1.gettext('loading...');
                    if (scope.desk.edit && scope.desk.edit._id) {
                        desks.fetchUsers().then(function (result) {
                            scope.users = desks.users._items;
                            scope.deskMembers = desks.deskMembers[scope.desk.edit._id] || [];
                            scope.message = null;
                        });
                    }
                    else {
                        WizardHandler.wizard('desks').goTo(previous);
                    }
                }
            });
            scope.add = function (user) {
                if (!lodash_1.default.find(scope.deskMembers, { _id: user._id })) {
                    scope.deskMembers.unshift(user);
                }
            };
            scope.remove = function (user) {
                lodash_1.default.remove(scope.deskMembers, user);
            };
            /**
             * Save members for editing desk
             *
             * @param {boolean} done
             *      when true it exits after saving otherwise
             *      continues to next step in wizard handler.
             */
            scope.save = function (done) {
                scope.message = utils_1.gettext('Saving...');
                var members = lodash_1.default.map(scope.deskMembers, function (obj) { return ({ user: obj._id }); });
                scope.saving = true;
                desks.save(scope.desk.edit, { members: members }).then(function (res) {
                    angular.extend(scope.desk.edit, res);
                    desks.deskMembers[scope.desk.edit._id] = scope.deskMembers;
                    angular.extend(scope.desk.orig, res);
                    if (!done) {
                        WizardHandler.wizard('desks').next();
                    }
                    else {
                        WizardHandler.wizard('desks').finish();
                    }
                }, function (response) {
                    if (angular.isDefined(response.data._message)) {
                        scope.message = utils_1.gettext('Error: ' + response.data._message);
                    }
                    else {
                        scope._errorMessage = utils_1.gettext('There was a problem, members not saved. Refresh Desks.');
                    }
                })
                    .finally(function () {
                    scope.saving = false;
                    scope.message = null;
                });
            };
        },
    };
}
exports.DeskeditPeople = DeskeditPeople;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DeskeditMacros.$inject = ['macros', 'WizardHandler'];
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name sdDeskeditMacros
 * @description
 *   Fetches and stores a list of macros for the current desk (if set,
 *   otherwise all macros), and defines the "previous" and "next"
 *   methods in the element's scope used by the Wizard handler.
 */
function DeskeditMacros(macros, WizardHandler) {
    return {
        link: function (scope) {
            if (scope.desk && scope.desk.edit) {
                macros.getByDesk(scope.desk.edit.name, true).then(function (_macros) {
                    scope.macros = _macros;
                });
            }
            else {
                macros.get().then(function (macroList) {
                    scope.macros = macroList;
                });
            }
            scope.save = function () {
                WizardHandler.wizard('desks').finish();
            };
        },
    };
}
exports.DeskeditMacros = DeskeditMacros;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * Action picker component
 *
 * Allows user to pick desk, stage and macro.
 * If required is specified it should be an object with {desk, stage, macro} set to true if required.
 */
ActionPicker.$inject = ['desks', 'macros'];
function ActionPicker(desks, macros) {
    return {
        scope: {
            desk: '=',
            stage: '=',
            macro: '=',
            required: '=',
        },
        template: __webpack_require__(1552),
        link: function (scope, elem, attrs) {
            scope.desks = null;
            scope.deskStages = null;
            scope.deskMacros = null;
            function updateMacros() {
                macros.getByDesk(desks.deskLookup[scope.desk].name, true).then(function (_macros) {
                    scope.deskMacros = lodash_1.default.filter(_macros, { action_type: 'direct' });
                });
                if (lodash_1.default.findIndex(scope.deskStages[scope.desk], { _id: scope.stage }) === -1) {
                    scope.stage = null;
                }
            }
            scope.$watchGroup(['desk', 'stage'], function () {
                if (!scope.desks || !scope.deskStages) {
                    desks.initialize()
                        .then(function () {
                        scope.desks = desks.desks._items;
                        scope.deskStages = desks.deskStages;
                        if (scope.desk) {
                            updateMacros();
                        }
                    });
                }
                else if (scope.desk) {
                    updateMacros();
                }
            });
        },
    };
}
exports.ActionPicker = ActionPicker;


/***/ }),
/* 1552 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form__row form__row--flex\">\n    <div class=\"form__row-item\">\n        <div sd-form-select\n             label=\"{{ :: 'Desk' | translate }}\"\n             model=\"desk\"\n             options=\"desks\"\n             option-label=\"name\"\n             option-value=\"_id\"\n             required=\"required.desk\">\n        </div>\n    </div>\n\n    <div class=\"form__row-item\">\n        <div sd-form-select\n             label=\"{{ :: 'Stage' | translate }}\"\n             model=\"stage\"\n             options=\"deskStages[desk]\"\n             option-label=\"name\"\n             option-value=\"_id\"\n             required=\"required.stage\">\n        </div>\n    </div>\n\n    <div class=\"form__row-item\">\n        <div sd-form-select\n             label=\"{{ :: 'Macro' | translate }}\"\n             model=\"macro\"\n             options=\"deskMacros\"\n             option-label=\"name\"\n             option-value=\"name\"\n             required=\"required.macro\">\n        </div>\n    </div>  \n\n</div>\n";

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name sdDeskSelect
 * @requires preferencesService
 * @description Directive to handle desk selection functionality in drop-downs/menus
 */
DeskSelect.$inject = ['Keys', 'lodash', 'preferencesService'];
function DeskSelect(Keys, _, preferencesService) {
    var UP = -1;
    var DOWN = 1;
    var DeskSelectController = /** @class */ (function () {
        function DeskSelectController() {
            this.active = null;
        }
        DeskSelectController.prototype.setActive = function (desk) {
            this.active = desk || null;
        };
        return DeskSelectController;
    }());
    return {
        templateUrl: 'scripts/apps/desks/views/desk-select.html',
        scope: {
            allDesks: '=desks',
            selectedDesk: '=',
            defaultDesk: '=',
            onChange: '&',
        },
        controller: DeskSelectController,
        controllerAs: 'ctrl',
        link: function (scope, elem, attrs) {
            elem[0].tabIndex = 0; // make elem recieve keyboard events
            scope.filter = '';
            preferencesService.get('desks:preferred').then(function (result) {
                scope.preferredDesks = result;
            });
            /**
             * @ngdoc property
             * @name sdDeskSelect#deskPreferenceOrdering
             * @type {function}
             * @private
             * @param {object} desk in the list of desks to be sorted
             * @returns {bool} false if desk is preferred and true if not (false < true for sorting)
             * @description Determines if a desk is a preferred desk.
             */
            scope.deskPreferenceOrdering = function (desk) {
                return scope.preferredDesks ? !scope.preferredDesks.selected[desk._id] : true;
            };
            /**
             * Reset state
             */
            function reset() {
                scope.filter = '';
                scope.ctrl.setActive();
                filterDesks();
            }
            scope.$watch('isOpen', reset);
            var filterActive = function (desk) { return desk._id === scope.ctrl.active._id; };
            /**
             * Move active item up or down
             *
             * @param {Number} diff
             */
            function moveActive(diff) {
                if (!scope.desks || !scope.desks.length) {
                    return;
                }
                var index = scope.ctrl.active ? _.findIndex(scope.desks, filterActive) : -diff;
                var next = Math.min(Math.max(0, index + diff), scope.desks.length - 1);
                scope.$apply(function () {
                    scope.ctrl.setActive(scope.desks[next]);
                });
            }
            /**
             * Filter desks by `scope.filter`
             */
            function filterDesks() {
                if (scope.allDesks) {
                    var filterRegexp = new RegExp('^' + scope.filter, 'i');
                    scope.desks = scope.allDesks.filter(function (desk) { return !scope.filter || filterRegexp.test(desk.name); });
                    // in case active item is filtered out keep focus
                    if (scope.ctrl.active && !scope.desks.find(filterActive)) {
                        elem.focus();
                    }
                }
            }
            /**
             * Remove last character and run filter on backspace
             */
            function backspaceAction() {
                scope.$apply(function () {
                    scope.filter = scope.filter.slice(0, -1);
                    filterDesks();
                });
            }
            scope.$on('key:down', function (e) {
                if (scope.isOpen) {
                    moveActive(DOWN);
                }
            });
            scope.$on('key:up', function (e) {
                if (scope.isOpen) {
                    moveActive(UP);
                }
            });
            scope.$on('key:backspace', function (e) {
                if (scope.isOpen) {
                    backspaceAction();
                }
            });
            // regexp for characters including unicode
            var charRegexp = /^[0-9a-zA-Z\u00C0-\u1FFF\u2C00-\uD7FF]$/;
            var handleEnter = function (e) {
                e.stopPropagation();
                if (!scope.isOpen) {
                    return;
                }
                // on enter select active or first
                if (scope.ctrl.active || scope.desks.length) {
                    scope.$apply(function () {
                        var desk = scope.ctrl.active || scope.desks[0];
                        scope.onChange({ desk: desk });
                    });
                }
                else {
                    return false;
                }
            };
            elem.on('keydown', function (e) {
                if (e.ctrlKey || e.metaKey || e.altKey) { // ignore when ctrl/alt/meta is used
                    return;
                }
                switch (e.which) {
                    case Keys.enter:
                        handleEnter(e);
                        break;
                    case Keys.backspace:
                        e.stopPropagation();
                        backspaceAction();
                        break;
                    case Keys.up:
                        e.preventDefault();
                        e.stopPropagation();
                        moveActive(UP);
                        break;
                    case Keys.down:
                        e.preventDefault();
                        e.stopPropagation();
                        moveActive(DOWN);
                        break;
                    default:
                        if (charRegexp.test(e.key)) {
                            e.stopPropagation();
                            scope.filter += e.key;
                            scope.$apply(filterDesks);
                        }
                }
            });
        },
    };
}
exports.DeskSelect = DeskSelect;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function DeskSelectItem() {
    return {
        require: '^sdDeskSelect',
        link: function (scope, elem, attrs, ctrl) {
            // set focus on element when it gets active
            scope.$watch('ctrl.active._id', function (activeId) {
                if (activeId && activeId === scope.desk._id) {
                    elem.focus();
                }
            });
            // when it gets focus via tab key update controller
            elem.on('focus', function () {
                if (!scope.active || scope.active._id !== scope.desk._id) {
                    scope.$applyAsync(function () {
                        ctrl.setActive(scope.desk);
                    });
                }
            });
            if (scope.preferredDesks && scope.preferredDesks.selected[scope.desk._id] === true) {
                elem.addClass('preferred-desk');
            }
        },
    };
}
exports.DeskSelectItem = DeskSelectItem;


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DesksReactDropdown_1 = __webpack_require__(557);
var react_dom_1 = __importDefault(__webpack_require__(15));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.desks
 * @name MarkDesksDropdown
 *
 * @requires desks
 * @requires $timeout
 *
 *
 * @description Creates dropdown react element with list of available desks
 */
MarkDesksDropdown.$inject = ['desks', '$timeout', '$injector'];
function MarkDesksDropdown(desks, $timeout, $injector) {
    return {
        link: function (scope, elem) {
            desks.fetchDesks().then(function () {
                var deskList = $injector.invoke(DesksReactDropdown_1.DesksReactDropdown, null, {
                    item: scope.item,
                    className: '',
                    noHighlightsLabel: utils_1.gettext('No available highlights'),
                    noDesksLabel: utils_1.gettext('No available desks'),
                    noLanguagesLabel: utils_1.gettext('No available translations'),
                });
                react_dom_1.default.render(deskList, elem[0]);
            });
        },
    };
}
exports.MarkDesksDropdown = MarkDesksDropdown;


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc React
 * @module superdesk.apps.desks
 * @name MarkBtn
 * @param {Object} item the story to be marked
 * @param {Object} desk desk for the item to be marked
 * @param {Object} desk desksService
 * @description Represents a button for given item to be marked for the given desk
 */
var MarkBtn = /** @class */ (function (_super) {
    __extends(MarkBtn, _super);
    function MarkBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.item = props.item;
        _this.desk = props.desk;
        _this.desks = props.desks;
        _this.isMarked = _this.item.marked_desks &&
            _this.item.marked_desks.some(function (md) { return md.desk_id === _this.desk._id; });
        _this.markDesk = _this.markDesk.bind(_this);
        return _this;
    }
    /** Marks the give item for a given desk */
    MarkBtn.prototype.markDesk = function (event) {
        event.stopPropagation();
        this.desks.markItem(this.desk._id, this.item);
    };
    MarkBtn.prototype.render = function () {
        return (react_1.default.createElement("button", { disabled: this.isMarked, onClick: this.markDesk },
            react_1.default.createElement("i", { className: "icon-bell" }),
            this.desk.name));
    };
    return MarkBtn;
}(react_1.default.Component));
exports.MarkBtn = MarkBtn;
/** Set the types of props for the MrkBtn */
MarkBtn.propTypes = {
    desks: prop_types_1.default.object.isRequired,
    desk: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(245);
/**
 * @ngdoc React
 * @module superdesk.apps.desks
 * @name MarkDesksDropdown
 * @param {String} className the class name for the ul element
 * @param {Object} item the story to be marked
 * @param {Object} desks desks service
 * @param {String} noDesksLabel the label to be visible when there's no desk
 * @description Creates a list of desks that is used for marking a story for a desk
 */
var MarkDesksDropdown = /** @class */ (function (_super) {
    __extends(MarkDesksDropdown, _super);
    function MarkDesksDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkDesksDropdown.prototype.render = function () {
        var _this = this;
        var items = this.props.desks.desks._items;
        return (react_1.default.createElement("ul", { className: this.props.className }, items.length ?
            items.map(function (d) { return react_1.default.createElement(components_1.MarkedDeskItem, { key: d._id, desk: d, item: _this.props.item, desks: _this.props.desks }); })
            : react_1.default.createElement("li", null,
                react_1.default.createElement("button", { disabled: true }, this.props.noDesksLabel))));
    };
    return MarkDesksDropdown;
}(react_1.default.Component));
exports.MarkDesksDropdown = MarkDesksDropdown;
/** Set the types of props for the MarkDesksDropdown */
MarkDesksDropdown.propTypes = {
    className: prop_types_1.default.string.isRequired,
    desks: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.object.isRequired,
    noDesksLabel: prop_types_1.default.string.isRequired,
};


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(245);
/**
 * @ngdoc React
 * @module superdesk.apps.desks
 * @name MarkedDeskItem
 * @param {Object} item the story to be marked
 * @param {Object} desk desk for the item to be marked
 * @param {Object} desks desksService
 * @description Represents a list item per given item and desk
 */
var MarkedDeskItem = /** @class */ (function (_super) {
    __extends(MarkedDeskItem, _super);
    function MarkedDeskItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkedDeskItem.prototype.render = function () {
        return (react_1.default.createElement("li", { key: 'desk-' + this.props.desk._id },
            react_1.default.createElement(components_1.MarkBtn, { item: this.props.item, desk: this.props.desk, desks: this.props.desks })));
    };
    return MarkedDeskItem;
}(react_1.default.Component));
exports.MarkedDeskItem = MarkedDeskItem;
/** Set the types of props for the MarkedDeskItem */
MarkedDeskItem.propTypes = {
    desks: prop_types_1.default.object.isRequired,
    desk: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DesksFactory_1 = __webpack_require__(1560);
exports.DesksFactory = DesksFactory_1.DesksFactory;


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.desks
 * @name desks
 *
 * @requires $q
 * @requires api
 * @requires preferencesService
 * @requires userList
 * @requires notify
 * @requires session
 * @requires $filter
 * @requires privileges
 *
 * @description Desks Service is responsible for managing desks and stages
 */
DesksFactory.$inject = ['$q', 'api', 'preferencesService', 'userList', 'notify',
    'session', '$filter', 'privileges', '$rootScope'];
function DesksFactory($q, api, preferencesService, userList, notify, session, $filter, privileges, $rootScope) {
    var _cache = {};
    var _fetchAll = function (endpoint, parent, page, items) {
        if (page === void 0) { page = 1; }
        if (items === void 0) { items = []; }
        var key;
        if (page === 1) {
            key = angular.toJson({ resource: endpoint, parent: parent });
            if (_cache[key]) {
                return _cache[key];
            }
        }
        var promise = api.query(endpoint, { max_results: 200, page: page }, parent)
            .then(function (result) {
            var pg = page;
            var extended = items.concat(result._items);
            if (result._links && result._links.next) {
                pg++;
                return _fetchAll(endpoint, parent, pg, extended);
            }
            return extended;
        });
        if (page === 1) {
            _cache[key] = promise;
        }
        return promise;
    };
    /**
     * Set desks.active which contains both desk and stage
     * refs and is updated only when one of those is changed.
     */
    function setActive(desks) {
        if (desks.active && desks.active.desk === desks.activeDeskId && desks.active.stage === desks.activeStageId) {
            // pass
            return;
        }
        desks.active = {
            desk: desks.activeDeskId,
            stage: desks.activeStageId,
        };
    }
    var desksService = {
        desks: null,
        users: null,
        stages: null,
        deskLookup: {},
        stageLookup: {},
        userLookup: {},
        deskMembers: {},
        deskStages: {},
        loading: null,
        activeDeskId: null,
        activeStageId: null,
        active: { desk: null, stage: null },
        /**
         * @description Fetches all desks in the system.
         * @returns {Promise}
         */
        fetchDesks: function () {
            var self = this;
            return _fetchAll('desks')
                .then(function (items) {
                var byName = $filter('sortByName')(items);
                self.desks = { _items: byName };
                lodash_1.default.each(byName, function (item) {
                    self.deskLookup[item._id] = item;
                });
                return self.desks;
            });
        },
        fetchUsers: function () {
            var self = this;
            return userList.getAll()
                .then(function (result) {
                self.users = {};
                self.users._items = result;
                lodash_1.default.each(result, function (user) {
                    self.userLookup[user._id] = user;
                });
            });
        },
        fetchStages: function () {
            var self = this;
            return _fetchAll('stages')
                .then(function (items) {
                self.stages = { _items: items };
                lodash_1.default.each(items, function (item) {
                    self.stageLookup[item._id] = item;
                });
            });
        },
        fetchDeskStages: function (desk, refresh) {
            var self = this;
            if (self.deskStages[desk] && !refresh) {
                return $q.when().then(returnDeskStages);
            }
            return self.fetchStages()
                .then(angular.bind(self, self.generateDeskStages))
                .then(returnDeskStages);
            function returnDeskStages() {
                return self.deskStages[desk];
            }
        },
        generateDeskMembers: function () {
            var self = this;
            lodash_1.default.each(this.desks._items, function (desk) {
                self.deskMembers[desk._id] = [];
                lodash_1.default.each(desk.members, function (member, index) {
                    var user = lodash_1.default.find(self.users._items, { _id: member.user });
                    if (user) {
                        self.deskMembers[desk._id].push(user);
                    }
                });
            });
            return $q.when();
        },
        generateDeskStages: function () {
            var self = this;
            this.deskStages = lodash_1.default.groupBy(self.stages._items, 'desk');
            return $q.when();
        },
        fetchUserDesks: function (user) {
            return _fetchAll('user_desks', { _id: user._id }).then(function (response) {
                if (!response) {
                    return;
                }
                return $q.when($filter('sortByName')(response));
            });
        },
        /**
         * Fetch current user desks and make sure active desk is present in there
         */
        fetchCurrentUserDesks: function () {
            var self = this;
            if (self.userDesks) {
                return $q.when(self.userDesks);
            }
            return this.fetchCurrentDeskId() // make sure there will be current desk
                .then(angular.bind(session, session.getIdentity))
                .then(angular.bind(this, this.fetchUserDesks))
                .then(angular.bind(this, function (desks) {
                self.userDesks = desks;
                setActive(this);
                return desks;
            }));
        },
        fetchCurrentDeskId: function () {
            var self = this;
            if (self.activeDeskId) {
                return $q.when(self.activeDeskId);
            }
            return preferencesService.get('desk:last_worked').then(function (result) {
                self.activeDeskId = null;
                if (angular.isDefined(result) && result !== '') {
                    self.activeDeskId = result;
                }
                else {
                    self.activeDeskId = self.getCurrentDeskId();
                }
                return self.activeDeskId;
            });
        },
        fetchCurrentStageId: function () {
            var self = this;
            if (self.activeStageId) {
                return $q.when(self.activeStageId);
            }
            return preferencesService.get('stage:items').then(function (result) {
                if (angular.isDefined(result)) {
                    self.activeStageId = angular.isArray(result) ? result[0] : result;
                }
            });
        },
        getCurrentDeskId: function () {
            if (!this.userDesks || this.userDesks.length === 0) {
                return null;
            }
            if (!this.activeDeskId || !lodash_1.default.find(this.userDesks, { _id: this.activeDeskId })) {
                if (session.identity.desk) {
                    var defaultDesk = lodash_1.default.find(this.userDesks, { _id: session.identity.desk });
                    return defaultDesk && defaultDesk._id || this.userDesks[0]._id;
                }
                return this.userDesks[0]._id;
            }
            return this.activeDeskId;
        },
        setCurrentDeskId: function (deskId) {
            if (this.activeDeskId !== deskId) {
                this.activeDeskId = deskId;
                this.activeStageId = null;
                setActive(this);
                preferencesService.update({
                    'desk:last_worked': this.activeDeskId,
                    'stage:items': [],
                }, 'desk:last_worked');
            }
        },
        getCurrentStageId: function () {
            return this.activeStageId;
        },
        setCurrentStageId: function (stageId) {
            if (this.activeStageId !== stageId) {
                this.activeStageId = stageId;
                setActive(this);
                preferencesService.update({
                    'desk:last_worked': this.activeDeskId,
                    'stage:items': [this.activeStageId],
                }, 'desk:last_worked');
            }
        },
        fetchDeskById: function (Id) {
            return api.desks.getById(Id);
        },
        getCurrentDesk: function () {
            return this.deskLookup[this.getCurrentDeskId()] || null;
        },
        setWorkspace: function (deskId, stageId) {
            if (deskId === void 0) { deskId = null; }
            if (stageId === void 0) { stageId = null; }
            if (this.activeDeskId !== deskId || this.activeStageId !== stageId) {
                this.activeDeskId = deskId;
                this.activeStageId = stageId;
                setActive(this);
                preferencesService.update({
                    'desk:last_worked': this.activeDeskId,
                    'stage:items': [this.activeStageId],
                }, 'desk:last_worked');
            }
        },
        initialize: function () {
            if (!this.loading) {
                this.fetchCurrentDeskId();
                this.fetchCurrentStageId();
                this.loading = this.fetchUsers()
                    .then(angular.bind(this, this.fetchDesks))
                    .then(angular.bind(this, this.generateDeskMembers))
                    .then(angular.bind(this, this.fetchStages))
                    .then(angular.bind(this, this.generateDeskStages))
                    .then(angular.bind(this, this.initActive));
            }
            return this.loading;
        },
        initActive: function () {
            setActive(this);
        },
        save: function (dest, diff) {
            return api.save('desks', dest, diff)
                .then(reset, handleSaveError);
        },
        remove: function (desk) {
            return api.remove(desk)
                .then(reset);
        },
        refreshStages: function () {
            return this.fetchStages().then(angular.bind(this, this.generateDeskStages));
        },
        refreshUsers: function () {
            return this.fetchUsers().then(angular.bind(this, this.generateDeskMembers));
        },
        /**
         * Get current desk for given item
         *
         * @param {Object} item
         */
        getItemDesk: function (item) {
            if (item.task && item.task.desk) {
                return this.deskLookup[item.task.desk] || null;
            }
        },
        isOutputType: function (type) {
            return type === 'deskOutput' || type === 'scheduledDeskOutput';
        },
        isPublishType: function (type) {
            return type === 'deskOutput' || type === 'scheduledDeskOutput' || type === 'highlights';
        },
        isReadOnlyStage: function (stageId) {
            return this.stageLookup[stageId] ? this.stageLookup[stageId].local_readonly : false;
        },
        /**
         * @ngdoc method
         * @name desks#markItem
         * @public
         * @description Toggles the marking for the given story
         * @param {string} deskId
         * @param {Object} markedItem
         * @returns {Object}
         */
        markItem: function (deskId, markedItem) {
            return api.save('marked_for_desks', { marked_desk: deskId, marked_item: markedItem._id });
        },
        /**
         * @ngdoc method
         * @name desks#hasMarkItemPrivilege
         * @public
         * @description Checks if the current user has the privilege
         * for marking stories for desks
         * @returns {boolean}
         */
        hasMarkItemPrivilege: function () {
            return !!privileges.privileges.mark_for_desks;
        },
    };
    $rootScope.$on('desk', reset);
    $rootScope.$on('stage', reset);
    return desksService;
    function reset(res) {
        desksService.loading = null;
        _cache = {};
        return res;
    }
    function handleSaveError(response) {
        if (response.status === 412) {
            notify.error(utils_1.gettext('Desk has been modified elsewhere. Please reload the desks.'));
        }
        return $q.reject(response);
    }
}
exports.DesksFactory = DesksFactory;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1562);
__webpack_require__(1564);
__webpack_require__(1566);
__webpack_require__(1568);
__webpack_require__(1570);
__webpack_require__(1573);
__webpack_require__(1575);
__webpack_require__(1577);
__webpack_require__(1579);
__webpack_require__(1581);
// scripts
__webpack_require__(1583);
__webpack_require__(1642);
__webpack_require__(1643);
__webpack_require__(1644);
__webpack_require__(1645);
__webpack_require__(1646);
__webpack_require__(1652);
__webpack_require__(1653);
__webpack_require__(1654);
__webpack_require__(1658);
__webpack_require__(1665);
__webpack_require__(1667);
__webpack_require__(1668);
__webpack_require__(1669);
__webpack_require__(1670);
__webpack_require__(1671);
__webpack_require__(1689);


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1563);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./comments.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./comments.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.comments .widget-content {\n  background: #f8f8f8; }\n\n.sd-widget.comments .notification-list li .date {\n  margin-top: 3px !important; }\n\n.sd-widget.comments .notification-list li .content {\n  padding: 0 0 0 40px; }\n\n.sd-widget.comments .notification-list li.no-comments {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 16% 0 0;\n  text-align: center;\n  color: #888; }\n  .sd-widget.comments .notification-list li.no-comments h3 {\n    font-weight: 400;\n    margin: 12px 0 4px; }\n  .sd-widget.comments .notification-list li.no-comments span {\n    font-weight: 300; }\n  .sd-widget.comments .notification-list li.no-comments .round-box {\n    display: block;\n    box-sizing: border-box;\n    padding-top: 16px;\n    height: 90px;\n    width: 90px;\n    background-color: #fff;\n    border-radius: 50%;\n    margin: 0 auto;\n    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08); }\n  .sd-widget.comments .notification-list li.no-comments i {\n    display: block;\n    width: 56px;\n    height: 48px;\n    opacity: 0.2;\n    margin: 1.4rem auto 0 auto;\n    font-size: 5.2rem; }\n\n.sd-widget.comments .notification-list li.loading-info {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 16% 0 0;\n  text-align: center;\n  color: #888; }\n\n.sd-widget.comments .add-comment {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n  border-top: 1px solid rgba(255, 255, 255, 0.75);\n  background: #f0f0f0;\n  padding: 10px;\n  box-shadow: 0px -1px 3px 0px rgba(0, 0, 0, 0.12); }\n  .sd-widget.comments .add-comment form {\n    margin: 0; }\n  .sd-widget.comments .add-comment .new-comment {\n    border: 2px solid #5ea9c8 !important;\n    border-radius: 3px !important; }\n  .sd-widget.comments .add-comment .actions {\n    height: 30px;\n    margin-top: 10px; }\n    .sd-widget.comments .add-comment .actions .post {\n      margin-top: 5px; }\n      .sd-widget.comments .add-comment .actions .post .sd-checkbox {\n        vertical-align: middle;\n        margin-top: -2px;\n        margin-right: 0; }\n", ""]);

// exports


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1565);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n.sd-widget.inline-comments .form__row, .sd-widget.suggestions .form__row {\n  display: flex;\n  justify-content: center; }\n\n.sd-widget.inline-comments .notification-list .item, .sd-widget.suggestions .notification-list .item {\n  padding: 1rem; }\n  .sd-widget.inline-comments .notification-list .item .commented-text, .sd-widget.suggestions .notification-list .item .commented-text {\n    margin-bottom: 1rem;\n    color: #999;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n    .sd-widget.inline-comments .notification-list .item .commented-text .text, .sd-widget.suggestions .notification-list .item .commented-text .text {\n      font-weight: bold; }\n  .sd-widget.inline-comments .notification-list .item .accepted, .sd-widget.suggestions .notification-list .item .accepted {\n    margin-left: 1rem; }\n\n.sd-widget.inline-comments .notification-list--empty li, .sd-widget.suggestions .notification-list--empty li {\n  background-color: transparent;\n  box-shadow: none;\n  padding: 16% 0 0;\n  text-align: center;\n  color: #888; }\n  .sd-widget.inline-comments .notification-list--empty li h3, .sd-widget.suggestions .notification-list--empty li h3 {\n    font-weight: 400;\n    margin: 12px 0 4px; }\n  .sd-widget.inline-comments .notification-list--empty li .round-box, .sd-widget.suggestions .notification-list--empty li .round-box {\n    padding-top: 16px;\n    height: 90px;\n    width: 90px;\n    background-color: #fff;\n    border-radius: 50%;\n    margin: 0 auto;\n    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08); }\n  .sd-widget.inline-comments .notification-list--empty li i, .sd-widget.suggestions .notification-list--empty li i {\n    display: block;\n    width: 56px;\n    height: 48px;\n    opacity: 0.2;\n    margin: 1.4rem auto 0 auto;\n    font-size: 5.2rem; }\n", ""]);

// exports


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1567);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./metadata.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./metadata.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.metadata .widget-content {\n  background: #f8f8f8;\n  padding: 0;\n  padding-bottom: 30px;\n  overflow: auto;\n  margin: 5px 0 0; }\n\n.sd-widget.metadata .ednote {\n  *zoom: 1;\n  height: auto !important; }\n  .sd-widget.metadata .ednote:before, .sd-widget.metadata .ednote:after {\n    display: table;\n    content: \"\"; }\n  .sd-widget.metadata .ednote:after {\n    clear: both; }\n  .sd-widget.metadata .ednote .data {\n    clear: both;\n    float: none !important;\n    height: auto !important;\n    width: 100% !important; }\n\n.basic-list {\n  margin-bottom: 20px; }\n  .basic-list--dotted .basic-list__item {\n    border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n  .basic-list--no-margin {\n    margin-bottom: 0; }\n  .basic-list .basic-list__item {\n    padding: 1rem 0 0.8rem;\n    display: flex;\n    flex-direction: row;\n    align-items: center; }\n    .basic-list .basic-list__item--stacked {\n      flex-direction: column;\n      align-items: stretch; }\n      .basic-list .basic-list__item--stacked .basic-list__item-label {\n        padding-bottom: 0.5rem; }\n      .basic-list .basic-list__item--stacked .basic-list__item-data {\n        text-align: left; }\n        .basic-list .basic-list__item--stacked .basic-list__item-data .basic-input {\n          max-width: auto;\n          text-align: left; }\n  .basic-list .basic-list__item-label {\n    flex-grow: 0;\n    font-size: 11px;\n    text-transform: uppercase;\n    padding-right: 1rem;\n    margin: 0;\n    color: rgba(0, 0, 0, 0.5);\n    font-weight: 500; }\n  .basic-list .basic-list__item-data {\n    flex-grow: 1;\n    margin-bottom: 2px;\n    text-align: right; }\n    .basic-list .basic-list__item-data .basic-input {\n      max-width: 160px;\n      text-align: right; }\n  .basic-list .state-label {\n    margin-right: 0; }\n    .basic-list .state-label + .state-label {\n      margin-left: 0.5rem; }\n", ""]);

// exports


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1569);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./packages.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./packages.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.packages .packages-content {\n  padding-left: 10px;\n  padding-right: 10px;\n  background: #f8f8f8; }\n  .sd-widget.packages .packages-content .package-preview {\n    margin-top: 5px;\n    margin-bottom: 5px;\n    border-radius: 5px;\n    border: 1px solid #efefef;\n    background: #fafafa;\n    padding: 5px; }\n    .sd-widget.packages .packages-content .package-preview .title {\n      padding-left: 5px;\n      padding-right: 5px; }\n      .sd-widget.packages .packages-content .package-preview .title .a {\n        font-weight: 500;\n        font-size: 14px;\n        color: #000; }\n", ""]);

// exports


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1571);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./authoring.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./authoring.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  margin: -1px 0;\n  position: fixed;\n  right: 10px; }\n\n::-webkit-scrollbar:hover {\n  background-color: #e8e8e8;\n  cursor: pointer; }\n\n::-webkit-scrollbar-thumb {\n  background: #bbb; }\n\n::-webkit-scrollbar-thumb:hover {\n  background: #777;\n  cursor: pointer; }\n\n/*\n    ----------------------------------------------------------------------\n    INPUT ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.sdselect {\n  width: 210px;\n  position: relative; }\n  .sdselect.open {\n    box-shadow: 0px 0px 5px 0px #d0d0d0 !important; }\n    .sdselect.open .sdselect-btn {\n      border-bottom: 0 !important; }\n  .sdselect:hover .sdselect-btn {\n    cursor: pointer; }\n  .sdselect .sdselect-btn {\n    display: inline-block;\n    box-sizing: border-box;\n    width: 100%;\n    border-radius: 2px;\n    border: 1px solid #d0d0d0;\n    padding: 6px;\n    height: 27px;\n    outline: none !important;\n    box-shadow: inset 0 0 0 #000 !important;\n    box-shadow: none !important;\n    text-decoration: none;\n    color: #333;\n    line-height: 15px;\n    font-size: 12px; }\n    .sdselect .sdselect-btn .caret {\n      margin: 5px 3px 0 0; }\n  .sdselect .sdselect-menu {\n    position: absolute;\n    background: #fff;\n    z-index: 10;\n    top: 26px;\n    left: 0;\n    right: 0;\n    height: auto;\n    border: 1px solid #d0d0d0;\n    border-radius: 0 0 2px 2px; }\n    .sdselect .sdselect-menu .sdselect-filter {\n      padding: 2px 7px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"] {\n        height: 21px !important;\n        padding: 3px !important;\n        border: 0 !important;\n        min-height: 0;\n        box-shadow: 0 0 0 0 #000; }\n        .sdselect .sdselect-menu .sdselect-filter input[type=\"text\"]:focus {\n          box-shadow: 0 0 0 0 #000 !important; }\n    .sdselect .sdselect-menu .sdselect-all {\n      padding: 4px 9px;\n      border-bottom: 1px solid #d0d0d0; }\n      .sdselect .sdselect-menu .sdselect-all a {\n        text-decoration: none;\n        font-size: 9px;\n        text-transform: uppercase;\n        color: #989898;\n        margin-right: 10px; }\n        .sdselect .sdselect-menu .sdselect-all a:hover {\n          cursor: pointer;\n          color: #666; }\n    .sdselect .sdselect-menu .list-holder {\n      height: auto;\n      max-height: 150px;\n      overflow-y: auto;\n      overflow-x: hidden;\n      margin: 7px 0; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar {\n        border-left: 5px solid #fff;\n        border-right: 5px solid #fff;\n        width: 13px;\n        background: #fff; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar:hover {\n          background: #e8e8e8; }\n      .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb {\n        border-left: 4px solid #fff;\n        border-right: 4px solid #fff;\n        background: #bbb; }\n        .sdselect .sdselect-menu .list-holder::-webkit-scrollbar-thumb:hover {\n          background: #787878; }\n    .sdselect .sdselect-menu ul li a {\n      display: block;\n      padding: 3px 7px;\n      font-size: 12px;\n      color: #333;\n      text-decoration: none; }\n      .sdselect .sdselect-menu ul li a:hover {\n        cursor: pointer;\n        color: #fff;\n        background: #0083c4; }\n      .sdselect .sdselect-menu ul li a i {\n        margin-right: 5px;\n        vertical-align: middle;\n        margin-top: -4px;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n\n.searchbar {\n  border-radius: 2px !important;\n  background: url(" + escape(__webpack_require__(75)) + ") no-repeat 9px 4px #ffffff !important;\n  padding: 0 0 0 35px !important; }\n  .searchbar.searchbar-large {\n    background-position: 9px 7px !important;\n    height: 32px !important;\n    font-size: 15px;\n    line-height: 26px; }\n\n.flat-searchbar {\n  flex-grow: 0; }\n  .flat-searchbar .search-handler {\n    min-width: 48px;\n    height: 48px;\n    padding: 10px 10px 10px 14px;\n    box-sizing: border-box;\n    background: none;\n    display: flex;\n    border-right: 1px solid #e0e0e0;\n    white-space: nowrap;\n    transition: all 0.3s ease; }\n    .flat-searchbar .search-handler input {\n      height: 28px;\n      line-height: 100%;\n      font-size: 14px;\n      border: 0 !important;\n      width: 0;\n      padding: 0;\n      background-color: rgba(255, 255, 255, 0);\n      transition: all 0.3s ease; }\n      .flat-searchbar .search-handler input:focus {\n        box-shadow: none !important; }\n    .flat-searchbar .search-handler .trigger-icon {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -o-user-select: none;\n      user-select: none;\n      -webkit-touch-callout: none;\n      -khtml-user-select: none;\n      -ms-user-select: none;\n      float: left;\n      width: 28px;\n      height: 28px;\n      display: inline-block;\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\"; }\n      .flat-searchbar .search-handler .trigger-icon:hover {\n        cursor: pointer;\n        opacity: 0.8;\n        filter: \"alpha(opacity=80)\"; }\n      .flat-searchbar .search-handler .trigger-icon i {\n        padding: 7px 3px 4px 6px; }\n  .flat-searchbar .separator-handler {\n    margin: 9px 0 0 5px;\n    border-right: 2px dotted #bcbcbc;\n    height: 30px;\n    float: left; }\n  .flat-searchbar .search-close {\n    border: 0;\n    background: none;\n    display: none;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n    .flat-searchbar .search-close.visible {\n      opacity: 0.4;\n      filter: \"alpha(opacity=40)\"; }\n      .flat-searchbar .search-close.visible:hover {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n  .flat-searchbar.extended {\n    flex-grow: 1; }\n    .flat-searchbar.extended .search-handler {\n      border-right: 1px solid #e0e0e0; }\n      .flat-searchbar.extended .search-handler input {\n        width: auto;\n        padding: 0 6px; }\n    .flat-searchbar.extended .separator-handler {\n      margin-left: 14px; }\n    .flat-searchbar.extended .search-close {\n      display: inline-block; }\n\n.ui-responsive-small .flat-searchbar.extended {\n  position: absolute;\n  z-index: 2; }\n\n.monitoring-backlink .separator-handler {\n  margin-top: 0;\n  margin-right: 10px; }\n\n.filter-type {\n  white-space: nowrap; }\n  .filter-type__item {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 3px 2px;\n    cursor: pointer; }\n    .filter-type__item i {\n      height: auto;\n      color: #999;\n      padding: 2px 8px 1px 8px;\n      background: rgba(255, 255, 255, 0.5);\n      border: 1px solid rgba(215, 215, 215, 0.7);\n      border-radius: 2px;\n      box-sizing: border-box; }\n    .filter-type__item a {\n      height: 21px;\n      font-size: 11px;\n      font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n      line-height: 21px;\n      text-decoration: none;\n      padding: 4px 10px;\n      border-radius: 2px;\n      border: 1px solid #999;\n      box-sizing: border-box;\n      text-transform: uppercase;\n      background: #fff !important;\n      color: #333;\n      opacity: 0.7; }\n      .filter-type__item a:hover {\n        color: #000;\n        opacity: 1; }\n      .filter-type__item a.filter-type__link--blue {\n        border-color: #5ea9c8;\n        color: #5ea9c8; }\n      .filter-type__item a.filter-type__link--dark-blue {\n        border-color: #216278;\n        color: #216278; }\n    .filter-type__item:hover i {\n      background: rgba(255, 255, 255, 0.8);\n      border: 1px solid #aaaaaa;\n      color: #666; }\n    .filter-type__item--active i {\n      opacity: 1;\n      color: #F5F5F5;\n      background: #505050;\n      border-color: #505050;\n      box-shadow: inset 0 1px 0px #373737 !important; }\n    .filter-type__item--active a {\n      opacity: 1;\n      background: #505050 !important;\n      border-color: #373737 #505050 #505050 !important;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0px #373737 !important; }\n    .filter-type__item--active:hover i {\n      border-color: rgba(80, 80, 80, 0.8);\n      background-color: rgba(80, 80, 80, 0.8);\n      color: #F5F5F5; }\n    .filter-type__item--active:hover a {\n      opacity: 0.8; }\n\n.filter-type--padded {\n  padding: 10px 0 10px 20px; }\n\n.result-type {\n  margin-left: 10px; }\n\n.dropdown__menu .filter-type {\n  padding: 0 10px; }\n\n.dropdown__menu--compare-versions {\n  max-height: 400px;\n  min-width: 250px;\n  overflow-y: auto;\n  overflow-x: hidden; }\n  .dropdown__menu--compare-versions li {\n    margin-bottom: 2px;\n    line-height: 14px !important; }\n    .dropdown__menu--compare-versions li .dropdown.open li .dropdown .dropdown__toggle:hover {\n      display: none; }\n    .dropdown__menu--compare-versions li button {\n      width: 300px;\n      padding-right: 30px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      position: relative;\n      border-radius: 0;\n      line-height: 14px !important;\n      box-shadow: 0px 1px 1px 0 rgba(0, 0, 0, 0.15); }\n      .dropdown__menu--compare-versions li button i {\n        position: absolute;\n        right: -5px;\n        top: 9px; }\n      .dropdown__menu--compare-versions li button.disabled, .dropdown__menu--compare-versions li button.disabled:hover {\n        background: #f0f0f0; }\n        .dropdown__menu--compare-versions li button.disabled i, .dropdown__menu--compare-versions li button.disabled:hover i {\n          opacity: 0.2;\n          filter: \"alpha(opacity=20)\"; }\n      .dropdown__menu--compare-versions li button .headline {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-size: 11px;\n        font-weight: 500;\n        width: 240px;\n        display: inline-block; }\n      .dropdown__menu--compare-versions li button .desk-details {\n        display: flex;\n        font-size: 10px;\n        margin: 4px 0; }\n        .dropdown__menu--compare-versions li button .desk-details span:first-of-type {\n          flex-grow: 1; }\n      .dropdown__menu--compare-versions li button em {\n        font-size: 10px;\n        font-weight: 500;\n        color: #888;\n        float: left;\n        padding-right: 10px; }\n    .dropdown__menu--compare-versions li .msg {\n      padding: 0 20px; }\n\n.dropdown__menu .fieldset button {\n  text-align: center;\n  width: auto;\n  min-width: 50px;\n  clear: none;\n  margin-right: 10px;\n  float: right; }\n\n.online-users {\n  float: left;\n  height: 48px;\n  padding-left: 15px;\n  margin-left: 5px; }\n  .online-users > * {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0;\n    padding: 16px 0;\n    line-height: 13px; }\n\n[sd-timezone] .timezone-label {\n  margin-bottom: 1rem; }\n\n[sd-timezone] .input-term input {\n  height: 3.2rem;\n  margin-bottom: 5px;\n  width: 100%;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  border: none;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.3rem;\n  color: inherit;\n  padding-left: 1rem; }\n  [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(0, 0, 0, 0.3);\n    background-color: rgba(0, 0, 0, 0.1); }\n  [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n[sd-timezone] .item-list {\n  width: 100%;\n  color: #333; }\n\n[sd-timezone] .pills-list li {\n  padding: 0.7rem 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 1.3rem; }\n  [sd-timezone] .pills-list li .icon-remove-sign {\n    color: inherit; }\n  [sd-timezone] .pills-list li #timezone {\n    padding-right: 2.5rem;\n    flex-grow: 1; }\n\n[class^=\"--dark-ui\"] [sd-timezone] .input-term input,\n[class*=\"--dark-ui\"] [sd-timezone] .input-term input {\n  background-color: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:hover,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  [class^=\"--dark-ui\"] [sd-timezone] .input-term input:focus,\n  [class*=\"--dark-ui\"] [sd-timezone] .input-term input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input, .timepicker-input {\n  position: relative;\n  width: auto;\n  min-width: 130px; }\n  .datepicker-input input, .timepicker-input input {\n    width: 100%;\n    transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n    padding-right: 3.2rem;\n    padding-left: 1rem;\n    min-height: 2.8rem;\n    border: none;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    font-size: 1.3rem;\n    color: inherit; }\n    .datepicker-input input:hover, .timepicker-input input:hover {\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n      background-color: rgba(0, 0, 0, 0.1); }\n    .datepicker-input input:focus, .timepicker-input input:focus {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n    .datepicker-input input.ng-invalid, .timepicker-input input.ng-invalid {\n      color: #d10000;\n      border-color: #b61818 !important;\n      box-shadow: 0 1px 0 0 #b61818 !important; }\n  .datepicker-input .icn-btn, .timepicker-input .icn-btn {\n    position: absolute;\n    right: 2px;\n    top: 0; }\n\n.datepicker-input--dark input, .timepicker-input--dark input {\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s;\n  background-color: rgba(255, 255, 255, 0.05);\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 1.3rem;\n  line-height: 1.8rem;\n  color: inherit;\n  min-height: 32px; }\n  .datepicker-input--dark input:hover, .timepicker-input--dark input:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4);\n    background-color: rgba(255, 255, 255, 0.1); }\n  .datepicker-input--dark input:focus, .timepicker-input--dark input:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8;\n    border-color: #5ea9c8; }\n\n.datepicker-input--dark .icn-btn, .timepicker-input--dark .icn-btn {\n  background: transparent;\n  top: 50%;\n  margin-top: -14px; }\n\n.datepicker-input--dark .name, .timepicker-input--dark .name {\n  background-color: #4f4f4f;\n  height: 24px;\n  font-size: 12px;\n  color: #fff; }\n\n.datepicker-input--dark ul > li, .timepicker-input--dark ul > li {\n  width: 90%; }\n\n.datepicker-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 260px;\n  box-sizing: border-box; }\n  .datepicker-wrapper .btn {\n    height: 28px; }\n    .datepicker-wrapper .btn:hover {\n      box-shadow: none; }\n  .datepicker-wrapper .btn--mini {\n    padding: 4px 6px;\n    font-size: 11px;\n    line-height: 11px !important;\n    height: auto; }\n  .datepicker-wrapper table {\n    width: 100%;\n    border-collapse: collapse;\n    border: 0; }\n    .datepicker-wrapper table td, .datepicker-wrapper table th {\n      padding: 1px;\n      border: 0; }\n  .datepicker-wrapper .datepicker-additional {\n    margin-bottom: 5px; }\n    .datepicker-wrapper .datepicker-additional table {\n      width: 100%; }\n    .datepicker-wrapper .datepicker-additional .btn {\n      width: 100%; }\n  .datepicker-wrapper .datepicker-core table {\n    width: 100%; }\n    .datepicker-wrapper .datepicker-core table thead tr th .btn {\n      background: none;\n      padding: 0; }\n    .datepicker-wrapper .datepicker-core table thead tr:last-child th small {\n      font-weight: 500; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn strong {\n      font-weight: normal;\n      font-size: 14px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th .btn i {\n      display: inline-block;\n      width: 14px;\n      height: 14px;\n      background-repeat: no-repeat; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:first-child .btn i {\n      margin-left: 3px;\n      background-position: -189px -165px; }\n    .datepicker-wrapper .datepicker-core table thead tr:first-child th:last-child .btn i {\n      margin-right: 3px;\n      background-position: -213px -165px; }\n    .datepicker-wrapper .datepicker-core table tbody tr:first-child td {\n      padding-top: 5px; }\n    .datepicker-wrapper .datepicker-core table tbody td {\n      padding: 0 2px; }\n      .datepicker-wrapper .datepicker-core table tbody td .btn {\n        width: 100% !important;\n        min-width: 28px !important;\n        padding: 0;\n        background: none;\n        color: #333;\n        box-shadow: none; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn .text-muted {\n          color: #999; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn:hover, .datepicker-wrapper .datepicker-core table tbody td .btn.active {\n          color: #333;\n          box-shadow: inset 0 0 1px 0 #5ea9c8;\n          background: #eff7fa; }\n        .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active {\n          color: #fff;\n          background: #5ea9c8; }\n          .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary .text-muted, .datepicker-wrapper .datepicker-core table tbody td .btn.btn--primary.active .text-muted {\n            color: #fff; }\n\n.timepicker-popup {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  background: #fff;\n  padding: 10px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.45);\n  border-radius: 3px;\n  width: 200px;\n  height: 310px;\n  box-sizing: border-box; }\n  .timepicker-popup .timepicker-additional {\n    margin-bottom: 5px; }\n    .timepicker-popup .timepicker-additional table {\n      width: 100%;\n      border-collapse: collapse;\n      border: 0; }\n      .timepicker-popup .timepicker-additional table td, .timepicker-popup .timepicker-additional table th {\n        padding: 1px; }\n    .timepicker-popup .timepicker-additional .btn {\n      width: 100%;\n      letter-spacing: 0; }\n    .timepicker-popup .timepicker-additional .btn--mini {\n      padding: 4px 6px;\n      font-size: 11px;\n      line-height: 11px !important;\n      height: 20px; }\n  .timepicker-popup .timepicker-core .select-area {\n    margin-top: 15px;\n    border-top: 1px solid #ddd; }\n    .timepicker-popup .timepicker-core .select-area .header {\n      margin-top: -10px;\n      float: left;\n      background: #fff;\n      text-transform: uppercase;\n      color: #adadad;\n      font-size: 11px;\n      padding-right: 10px; }\n    .timepicker-popup .timepicker-core .select-area ul {\n      padding-top: 15px;\n      *zoom: 1; }\n      .timepicker-popup .timepicker-core .select-area ul:before, .timepicker-popup .timepicker-core .select-area ul:after {\n        display: table;\n        content: \"\"; }\n      .timepicker-popup .timepicker-core .select-area ul:after {\n        clear: both; }\n      .timepicker-popup .timepicker-core .select-area ul > li {\n        float: left;\n        box-sizing: border-box;\n        width: 28px;\n        height: 28px;\n        line-height: 28px;\n        text-align: center;\n        margin: 0 2px 2px 0;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -o-user-select: none;\n        user-select: none;\n        -webkit-touch-callout: none;\n        -khtml-user-select: none;\n        -ms-user-select: none;\n        border-radius: 2px; }\n        .timepicker-popup .timepicker-core .select-area ul > li:hover {\n          background: #eff7fa;\n          cursor: pointer; }\n        .timepicker-popup .timepicker-core .select-area ul > li.active {\n          background: #5ea9c8;\n          color: #fff; }\n\n.pills-list.line-input > li {\n  width: 100%;\n  border-radius: 0 !important;\n  border: 0 !important;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background-color: transparent;\n  padding: 0;\n  height: 24px;\n  box-shadow: none; }\n  .pills-list.line-input > li .actions {\n    top: -9px; }\n  .pills-list.line-input > li:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: transparent !important;\n    box-shadow: none; }\n  .pills-list.line-input > li:focus {\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important;\n    background-color: transparent !important; }\n\n/*\n    ----------------------------------------------------------------------\n    OTHER CUSTOM ELEMENTS\n    ----------------------------------------------------------------------\n*/\n.backlink, a.backlink {\n  text-decoration: none !important;\n  color: #333;\n  border: 0;\n  transition: all ease 0.2s;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  padding: 0;\n  margin: 0;\n  cursor: pointer; }\n  .backlink:before, a.backlink:before {\n    font-family: 'sd_icons';\n    font-weight: normal;\n    font-style: normal;\n    content: \"\\E677\";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 16px;\n    flex-grow: 0;\n    margin: -1px 8px 0 0;\n    text-decoration: none !important;\n    transition: all ease 0.2s;\n    opacity: 0.7; }\n  .backlink.white, a.backlink.white {\n    color: #fff; }\n  .backlink:hover, a.backlink:hover {\n    color: #5ea9c8;\n    text-decoration: none !important; }\n    .backlink:hover:before, a.backlink:hover:before {\n      text-decoration: none !important;\n      margin: -1px 10px 0 -2px;\n      opacity: 1; }\n\n.stage-header__name a {\n  transition: all ease 0.2s; }\n\n.widget-content .stage-header__name a {\n  text-decoration: none !important; }\n\n.activity-log {\n  margin-top: 10px; }\n  .activity-log ul {\n    margin: 0;\n    padding: 0;\n    list-style-type: none; }\n    .activity-log ul li.activity .activity-content {\n      padding-left: 45px;\n      margin-top: -3px;\n      padding-right: 20px;\n      color: #555; }\n      .activity-log ul li.activity .activity-content b {\n        font-weight: 500; }\n    .activity-log ul li.activity .activity-date {\n      padding-left: 45px;\n      font-size: 11px;\n      color: #999;\n      margin-top: -5px; }\n    .activity-log ul li.activity.with-date {\n      margin-top: 35px; }\n      .activity-log ul li.activity.with-date .date {\n        border-top: 1px solid #ebebeb;\n        top: -17px;\n        position: absolute;\n        right: 0;\n        left: 0; }\n        .activity-log ul li.activity.with-date .date span {\n          font-size: 12px;\n          color: #999;\n          margin-top: -10px;\n          display: block;\n          float: left;\n          background: #f8f8f8;\n          padding-right: 5px; }\n    .activity-log ul li.activity:hover {\n      cursor: default; }\n\n.activity-load-more {\n  width: 100%;\n  font-size: 12px;\n  margin: 20px 0; }\n\n.notification-list {\n  margin: 0;\n  margin-bottom: 20px;\n  list-style-type: none; }\n  .notification-list li {\n    background: #393939;\n    padding: 10px 5px;\n    box-sizing: border-box;\n    border-radius: 2px;\n    width: 100%;\n    min-height: 45px;\n    margin: 10px 0;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5); }\n    .notification-list li .content {\n      padding-left: 40px; }\n      .notification-list li .content .text {\n        margin: 0;\n        font-size: 12px;\n        overflow: hidden;\n        color: #d7d7d7; }\n      .notification-list li .content .date, .notification-list li .content .date time, .notification-list li .content time {\n        font-size: 11px;\n        color: #848484;\n        margin-top: -3px;\n        display: block; }\n      .notification-list li .content a {\n        cursor: pointer;\n        color: #5ea9c8; }\n        .notification-list li .content a:hover {\n          text-decoration: none;\n          color: #97c7db; }\n    .notification-list li.unread {\n      border-color: #545454;\n      background: #2c2c2c; }\n    .notification-list li.important {\n      border: 1px solid #a60101 !important;\n      box-shadow: inset 0px 0px 1px 1px #e4b2b2, 0px 2px 2px 0px #d8d8d8 !important; }\n    .notification-list li.personal, .notification-list li.important {\n      border: 1px solid #c8c8c8;\n      border-radius: 3px;\n      background: #fff;\n      padding: 5px;\n      margin-bottom: 7px;\n      box-shadow: 0px 2px 2px 0 #d8d8d8; }\n      .notification-list li.personal + li, .notification-list li.important + li {\n        border-top-width: 0; }\n        .notification-list li.personal + li.personal, .notification-list li.personal + li.important, .notification-list li.important + li.personal, .notification-list li.important + li.important {\n          border-top-width: 1px; }\n    .notification-list li .info {\n      color: #e0e0e0; }\n  .notification-list.white li {\n    background: #fff;\n    border-color: #dedede;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12); }\n    .notification-list.white li .content .text {\n      color: #333; }\n    .notification-list.white li.active {\n      border-color: #999;\n      box-shadow: 0 1px 2px 0 #666; }\n\n.notification-pane ::-webkit-scrollbar:hover {\n  background-color: #4a4a4a; }\n\n.notification-pane ::-webkit-scrollbar-thumb {\n  background: #5a5a5a; }\n\n.notification-pane ::-webkit-scrollbar-thumb:hover {\n  background: #666; }\n\n.hard-error {\n  position: fixed;\n  top: 0;\n  right: 200px;\n  z-index: 9999;\n  width: auto;\n  max-width: 400px; }\n  .hard-error .alert {\n    border-radius: 0;\n    border: 0;\n    box-sizing: border-box;\n    height: 40px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 40px;\n    padding: 0 15px; }\n  .hard-error .alert-error {\n    background-color: #612525;\n    color: #cc7c7b;\n    text-shadow: none; }\n  .hard-error:hover .alert {\n    height: auto;\n    line-height: 20px;\n    padding: 10px 15px;\n    overflow: visible;\n    white-space: pre-wrap; }\n\n.sd-pagination {\n  padding: 7px 20px; }\n  .sd-pagination .btn {\n    padding: 10px; }\n    .sd-pagination .btn i {\n      margin-right: 0; }\n  .sd-pagination .page-info {\n    margin-right: 20px;\n    display: inline-block; }\n    .sd-pagination .page-info input {\n      display: inline-block;\n      width: 30px;\n      text-align: center;\n      margin-top: -1px;\n      padding: 6px 3px !important;\n      border-radius: 5px;\n      margin: 0 5px;\n      box-shadow: inset 0 5px 5px -5px #acacac; }\n  .sd-pagination .btn-group, .sd-pagination .btn-group > .btn {\n    display: inline-block;\n    vertical-align: middle;\n    float: none; }\n  .sd-pagination .btn-group > .btn + .btn {\n    margin-left: 0px; }\n\n.assignment-menu .assignment-box {\n  width: 270px; }\n  .assignment-menu .assignment-box h5 {\n    border: 0; }\n  .assignment-menu .assignment-box .assignment-content .assignment-result-list {\n    margin-top: 10px;\n    height: 140px;\n    overflow: auto; }\n    .assignment-menu .assignment-box .assignment-content .assignment-result-list ul {\n      list-style-type: none;\n      margin: 0;\n      padding: 0; }\n      .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li {\n        height: 32px;\n        margin-bottom: 3px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li .avatar-small {\n          width: 24px;\n          height: 24px;\n          border: 0;\n          padding: 0;\n          margin: 0;\n          background-size: 24px 24px; }\n        .assignment-menu .assignment-box .assignment-content .assignment-result-list ul li span {\n          font-size: 13px;\n          color: #4f4f4f;\n          line-height: 24px;\n          margin-left: 10px; }\n\n.sortbar {\n  white-space: nowrap;\n  margin: 0 5px;\n  padding: 0 10px; }\n  .sortbar > * {\n    display: inline-block !important;\n    vertical-align: middle; }\n  .sortbar > .dropdown {\n    margin-right: 10px; }\n  .sortbar .lab {\n    margin-right: 10px; }\n  .sortbar .dropdown__toggle {\n    color: #808080;\n    min-width: auto !important; }\n  .sortbar .direction {\n    background: none;\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.selectionlist {\n  list-style-type: none;\n  padding: 2px;\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  overflow: auto; }\n  .selectionlist li {\n    line-height: 16px;\n    height: 16px;\n    padding: 4px;\n    margin-bottom: 3px;\n    border-radius: 3px;\n    background: #e8e8e8; }\n  .selectionlist .sf-toggle-custom {\n    margin-top: -1px;\n    float: right; }\n\n.plain-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; }\n  .plain-list.plain-border-top {\n    border-top: 1px solid #e5e5e5; }\n  .plain-list > li {\n    border-bottom: 1px solid #e5e5e5;\n    height: 41px;\n    line-height: 40px;\n    cursor: pointer;\n    position: relative;\n    padding: 0 5px;\n    box-sizing: border-box; }\n    .plain-list > li:hover {\n      background: #eff7fa; }\n    .plain-list > li .btn--mini {\n      margin-top: 10px; }\n\n.plain-small > li {\n  height: 31px;\n  line-height: 30px; }\n\n.users-list > li .avatar {\n  margin-top: 5px;\n  margin-right: 15px; }\n\n.users-list > li .name {\n  font-size: 13px;\n  color: #3599b6; }\n\n.plain-small.users-list > li .avatar {\n  margin-top: 3px; }\n\n.users-list-embed {\n  position: relative; }\n  .users-list-embed > li {\n    height: 32px;\n    line-height: 32px;\n    margin-right: -5px; }\n    .users-list-embed > li .avatar {\n      margin: 3px 10px 4px 4px; }\n    .users-list-embed > li:hover, .users-list-embed > li.active {\n      cursor: pointer;\n      color: #fff; }\n    .users-list-embed > li:hover {\n      background: #84bdd5; }\n    .users-list-embed > li:active {\n      background: #97c7db; }\n    .users-list-embed > li.active {\n      background: #5ea9c8; }\n    .users-list-embed > li.inactive {\n      color: #ccc; }\n\n.mentio-menu {\n  padding: 5px;\n  border: 1px solid #ddd;\n  max-height: 126px;\n  z-index: 9999 !important;\n  overflow: auto;\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);\n  width: 190px;\n  bottom: 5px; }\n  .mentio-menu ul li {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n\n.card-list > li, .card {\n  display: block;\n  padding: 10px;\n  background: #fff;\n  border: none;\n  box-shadow: 0px 1px 2px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 2px;\n  margin-bottom: 7px;\n  position: relative; }\n  .card-list > li:not([disabled]):hover, .card:not([disabled]):hover {\n    cursor: pointer;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li:not([disabled]):hover .action, .card:not([disabled]):hover .action {\n      display: block !important; }\n  .card-list > li.selected, .card.selected {\n    background-color: #eff7fa;\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n    .card-list > li.selected:hover, .card.selected:hover {\n      box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n  .card-list > li[disabled], .card[disabled] {\n    cursor: default !important;\n    background-color: rgba(255, 255, 255, 0.45); }\n  .card-list > li .action, .card .action {\n    display: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    min-width: 200px; }\n    .card-list > li .action ul, .card .action ul {\n      height: 100%;\n      text-align: right; }\n    .card-list > li .action .item-field, .card .action .item-field {\n      height: 100%; }\n      .card-list > li .action .item-field span, .card .action .item-field span {\n        display: none; }\n      .card-list > li .action .item-field a, .card .action .item-field a {\n        padding: 0 23px;\n        line-height: 62px;\n        display: block; }\n\n.active .card {\n  background-color: #eff7fa;\n  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.35); }\n  .active .card:hover {\n    box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.45); }\n\n.pills-list {\n  max-width: 650px; }\n  .pills-list > li {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    background: #fff;\n    margin-bottom: 6px;\n    margin-right: 2px;\n    border-radius: 2px;\n    padding: 10px 16px;\n    min-height: 18px;\n    color: inherit;\n    position: relative;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 0 1px rgba(0, 0, 0, 0.08);\n    transition: all ease-in-out 0.2s; }\n    .pills-list > li:hover {\n      box-shadow: 0 0px 3px rgba(0, 0, 0, 0.3), 0 0 1px rgba(0, 0, 0, 0.2); }\n    .pills-list > li.active {\n      background: #5ea9c8;\n      color: #fff !important;\n      box-shadow: inset 0 2px 0 #3e92b5; }\n    .pills-list > li.inactive {\n      opacity: 0.5; }\n    .pills-list > li.empty-info {\n      background: transparent;\n      border: 1px dotted rgba(123, 123, 123, 0.5);\n      opacity: 0.75;\n      box-shadow: none !important; }\n    .pills-list > li .dropdown {\n      margin-top: -3px; }\n    .pills-list > li .actions {\n      display: none;\n      position: absolute;\n      top: 0px;\n      right: 4px; }\n      .pills-list > li .actions button {\n        transition: opacity ease-in-out 0.2s;\n        border: 0;\n        height: 30px;\n        width: 30px;\n        margin: 3px;\n        background: none;\n        text-align: center;\n        display: block;\n        float: left;\n        line-height: 0;\n        opacity: 0.4; }\n        .pills-list > li .actions button:hover {\n          cursor: pointer;\n          opacity: 1; }\n        .pills-list > li .actions button i {\n          margin-top: -2px; }\n    .pills-list > li h6 {\n      text-transform: none;\n      color: inherit;\n      font-size: 14px;\n      font-weight: 300;\n      float: left;\n      max-width: 99%;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis; }\n    .pills-list > li .label-group {\n      display: inline-block; }\n      .pills-list > li .label-group.label-group--right {\n        float: right; }\n    .pills-list > li .label {\n      font-size: 9px;\n      font-weight: 700;\n      padding: 2px 5px;\n      line-height: 12px;\n      margin-left: 5px;\n      letter-spacing: 0.1em;\n      text-transform: uppercase;\n      font-weight: 400; }\n    .pills-list > li:hover .actions {\n      display: block !important; }\n    .pills-list > li:hover h6 {\n      max-width: 550px; }\n    .pills-list > li .avatar {\n      display: inline-block;\n      float: none; }\n    .pills-list > li h5 {\n      display: inline-block; }\n  .pills-list.pills-editable li.editable {\n    padding: 0;\n    height: auto;\n    background: transparent; }\n    .pills-list.pills-editable li.editable input {\n      height: 30px;\n      line-height: 30px;\n      border-radius: 3px; }\n\n[class^=\"--dark-ui\"] .pills-list > li,\n[class*=\"--dark-ui\"] .pills-list > li {\n  background: #4f4f4f; }\n\n.pill-small {\n  width: 200px;\n  margin: 4px; }\n\n.item-field {\n  border-left: 1px solid #d8d8d8;\n  display: inline-block; }\n  .item-field span {\n    display: none; }\n  .item-field button {\n    border: 0;\n    padding: 0;\n    background: none;\n    vertical-align: text-top; }\n  .item-field:hover {\n    background: rgba(0, 0, 0, 0.1);\n    border-color: #e0e0e0; }\n  .item-field.disabled {\n    cursor: default; }\n    .item-field.disabled i {\n      opacity: 0.3;\n      filter: \"alpha(opacity=30)\"; }\n    .item-field.disabled:hover {\n      background: #e8e8e8; }\n\n.dropdown .item-field {\n  display: block;\n  border-left: 0; }\n  .dropdown .item-field span {\n    display: inline-block; }\n\n.dropdown .item-field:hover {\n  background: none; }\n\n.or-label {\n  position: relative;\n  text-align: center;\n  font-style: italic; }\n  .or-label:before {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: -75px; }\n  .or-label:after {\n    content: \"_________\";\n    position: absolute;\n    top: -6px;\n    color: #d0d0d0;\n    left: 50%;\n    margin-left: 15px; }\n\n.list-group {\n  box-sizing: border-box;\n  width: 300px; }\n  .list-group .list-group-item {\n    padding: 10px 15px;\n    border: 1px solid #ddd;\n    border-width: 0 1px 1px 1px;\n    background-color: #fff; }\n    .list-group .list-group-item:first-child {\n      border-width: 1px;\n      border-radius: 5px 5px 0 0; }\n    .list-group .list-group-item:last-child {\n      border-radius: 0 0 5px 5px; }\n    .list-group .list-group-item:hover {\n      background-color: #f4f4f4;\n      cursor: pointer; }\n    .list-group .list-group-item a {\n      text-decoration: none;\n      color: #444; }\n\n.shadow-list-holder {\n  overflow-y: auto;\n  width: 100%;\n  max-height: 100%;\n  min-height: 100%;\n  box-sizing: border-box; }\n\n.scroll-shadow {\n  height: 0; }\n  .scroll-shadow .inner {\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(transparent));\n    height: 4px;\n    position: relative;\n    z-index: 503;\n    transition: linear 0.1s all;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\"; }\n  .scroll-shadow.shadow .inner {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n\n.toggle-box__button {\n  transition: color ease-in-out 0.2s;\n  color: #999;\n  cursor: pointer; }\n  .toggle-box__button i {\n    color: inherit;\n    margin-right: 5px;\n    vertical-align: text-bottom; }\n  .toggle-box__button:hover {\n    text-decoration: none;\n    color: #fff; }\n\n.fade {\n  transition: opacity 0.15s linear;\n  opacity: 0; }\n  .fade.in {\n    opacity: 1; }\n\n.close {\n  float: right;\n  line-height: 18px;\n  opacity: 0.2;\n  filter: \"alpha(opacity=20)\"; }\n  .close:hover {\n    text-decoration: none;\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\";\n    cursor: pointer; }\n  .close i {\n    vertical-align: middle; }\n\n.draggable-list__item {\n  background-color: #fff;\n  padding: 18px 14px 19px 25px;\n  margin-bottom: 10px;\n  cursor: move;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);\n  position: relative; }\n  .draggable-list__item.placeholder {\n    background: none;\n    box-shadow: none;\n    border: 2px dashed #ebebeb; }\n  .draggable-list__item:after {\n    content: \"\";\n    width: 10px;\n    top: 0;\n    bottom: 0;\n    left: 2px;\n    background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 3px top 3px;\n    opacity: 0.2;\n    position: absolute;\n    display: block; }\n  .draggable-list__item:hover {\n    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4); }\n    .draggable-list__item:hover:after {\n      opacity: 0.8; }\n  .draggable-list__item--small {\n    padding: 10px 14px 10px 25px; }\n  .draggable-list__item--no-padding {\n    padding: 0 0 0 8px; }\n    .draggable-list__item--no-padding:after {\n      width: 6px;\n      left: 2px;\n      background: transparent url(" + escape(__webpack_require__(58)) + ") repeat-y left 0px top 3px; }\n\n.draggable-list.serial-decimal {\n  list-style-type: decimal !important;\n  padding-top: 0px;\n  margin-left: 5px; }\n  .draggable-list.serial-decimal > li {\n    word-spacing: 2px;\n    line-height: 0px; }\n  .draggable-list.serial-decimal .sort-item.active {\n    background-color: #eee; }\n\n.ui-resizable-e {\n  cursor: col-resize !important; }\n\n.spinner-big {\n  background-image: url(" + escape(__webpack_require__(34)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  vertical-align: middle;\n  text-align: center; }\n\n.spinner-alt {\n  background-image: url(" + escape(__webpack_require__(106)) + ");\n  background-repeat: no-repeat;\n  background-position: center;\n  display: inline-block;\n  width: 100%;\n  height: 32px;\n  line-height: 32px;\n  vertical-align: middle;\n  text-align: center; }\n\n.sd-check__wrapper .sd-checkbox + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: inherit;\n  height: auto;\n  text-transform: none; }\n  .sd-check__wrapper .sd-checkbox + label.label--active {\n    color: #479dc0; }\n\n.sd-toggle + label {\n  font-size: 13px;\n  font-weight: 400;\n  color: #333;\n  height: auto;\n  text-transform: none; }\n\n.definition-list .definition-list__term {\n  font-size: 1.6rem;\n  margin-bottom: 0.6rem;\n  font-weight: 400; }\n\n.definition-list .definition-list__item {\n  padding: 0.3rem 0;\n  margin-left: 0;\n  font-size: 1.4rem;\n  font-weight: 300; }\n\n.definition-list .definition-list__item + .definition-list__term {\n  margin-top: 2rem; }\n\n.nav-button-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2rem 0; }\n  .nav-button-bar .btn {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.modal__header--flex .icn-btn.close, .modal__header--flex .icn-btn.close-modal, .modal__header--flex .icn-btn.modal__close {\n  margin: 0 -0.6rem 0;\n  border: 0;\n  padding: .6rem;\n  opacity: 0.5; }\n  .modal__header--flex .icn-btn.close:hover, .modal__header--flex .icn-btn.close-modal:hover, .modal__header--flex .icn-btn.modal__close:hover {\n    opacity: 0.8; }\n  .modal__header--flex .icn-btn.close:active, .modal__header--flex .icn-btn.close-modal:active, .modal__header--flex .icn-btn.modal__close:active {\n    opacity: 1; }\n\n.sd-line-input__message--with-char-count {\n  padding-right: 10rem; }\n\n.sd-list-item.inactive {\n  background-color: transparent;\n  color: rgba(123, 123, 123, 0.75); }\n\n.sd-toggle + label {\n  letter-spacing: 0; }\n\n.sd-list-item__text-label time {\n  padding: 0;\n  font-style: normal; }\n\n[sd-meta-terms] {\n  min-height: 2.8rem; }\n\n.line-input--boxed .input-term input[type=\"text\"] {\n  width: 100%;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  font-size: 1.4rem;\n  border-radius: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 0 1rem;\n  height: 3.2rem;\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  .line-input--boxed .input-term input[type=\"text\"]:hover {\n    border-color: rgba(0, 0, 0, 0.3) !important;\n    background-color: rgba(0, 0, 0, 0.1) !important; }\n  .line-input--boxed .input-term input[type=\"text\"]:focus {\n    background-color: rgba(0, 0, 0, 0.05) !important;\n    box-shadow: 0 1px 0 0 #5ea9c8 !important;\n    border-color: #5ea9c8 !important; }\n\n.line-input--boxed .terms-list {\n  width: 100%;\n  margin-top: 0.8rem; }\n\nsd-tag-input + .sd-line-input__message {\n  margin-top: -2rem; }\n\nsd-multi-image-edit {\n  height: 100vh;\n  display: flex;\n  flex-direction: column; }\n\n.sd-wrap-helper {\n  display: contents !important; }\n\n.subnav {\n  z-index: 5; }\n\n.subnav + .subnav {\n  z-index: 4; }\n\n#main-container.authoring .authoring-embedded {\n  background: url(" + escape(__webpack_require__(34)) + ") no-repeat center; }\n\n.auth-screen {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0; }\n  .auth-screen .main-section {\n    transition: all ease 0.3s; }\n\n.authoring-embedded {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0; }\n  .authoring-embedded .embedded-auth-view {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    box-sizing: border-box; }\n  .authoring-embedded .page-content-container {\n    left: 0;\n    right: 50px;\n    top: 27px; }\n  .authoring-embedded .widget-wrapper.active-right.right-extended .page-content-container {\n    right: 50px; }\n  .authoring-embedded .widget-wrapper.active-right .page-content-container {\n    right: 50px; }\n\n.subnav--authoring {\n  z-index: 3;\n  position: absolute;\n  top: 48px;\n  left: 0;\n  right: 0;\n  background-color: #dedede; }\n  .subnav--authoring .highlights-toggle .dropdown__menu, .subnav--authoring .marks-toggle .dropdown__menu {\n    max-height: calc(100vh - 350px);\n    overflow-y: auto; }\n\n.subnav__authoring-topbar {\n  height: 30px;\n  max-width: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  padding: 0 0 0 20px; }\n  .subnav__authoring-topbar .assignment {\n    vertical-align: sub; }\n  .subnav__authoring-topbar .stage {\n    font-size: 10px;\n    font-weight: 300;\n    letter-spacing: 0.035em;\n    line-height: 29px;\n    color: #666;\n    border: 0;\n    background-color: transparent;\n    text-transform: uppercase;\n    display: inline-block;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n    .subnav__authoring-topbar .stage b {\n      color: #333;\n      font-weight: 500; }\n  .subnav__authoring-topbar.enable-overflow {\n    overflow: visible; }\n\n.compact .subnav__authoring-topbar .stage {\n  max-width: 132px; }\n\n.lock-avatar {\n  margin: 10px 0 10px 10px; }\n  .lock-avatar .avatar-with-info {\n    margin-top: 2px;\n    cursor: pointer; }\n    .lock-avatar .avatar-with-info .logged-info {\n      background-color: #cf0000;\n      border: 1px solid #cf0000;\n      box-shadow: 0px 0 0 2px #dedede; }\n  .lock-avatar .dropdown__menu {\n    padding: 10px;\n    top: 0px;\n    text-align: center; }\n    .lock-avatar .dropdown__menu .avatar {\n      display: inline-block;\n      margin: 10px 0;\n      float: none; }\n    .lock-avatar .dropdown__menu button {\n      text-align: center;\n      margin-top: 15px; }\n  .lock-avatar .dropdown__menu-label {\n    padding-left: 0; }\n\n.auto-save {\n  margin-right: 20px;\n  line-height: 28px;\n  opacity: 0.7;\n  filter: \"alpha(opacity=70)\"; }\n  .auto-save i {\n    margin-top: -4px; }\n\n.page-content-container {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 58px;\n  right: 58px;\n  overflow-y: auto; }\n\n.workqueue .page-content-container {\n  bottom: 30px; }\n\n.medium-editor-toolbar-actions li button {\n  height: 30px !important;\n  min-width: 40px !important;\n  padding-top: 10px !important; }\n\n.medium-toolbar-arrow-under:after {\n  top: 40px !important; }\n\n.text-editor-info {\n  font-size: 89%; }\n\n.text-editor, .text-editor.medium-editor-element {\n  min-height: 20px; }\n  .text-editor .sderror, .text-editor.medium-editor-element .sderror {\n    border-bottom: 1px dotted #cc0000;\n    background-color: rgba(204, 0, 0, 0.1);\n    line-height: normal; }\n  .text-editor .sdfindreplace, .text-editor.medium-editor-element .sdfindreplace {\n    background-color: rgba(0, 0, 0, 0.1); }\n  .text-editor .sdfindreplace.sdactive, .text-editor.medium-editor-element .sdfindreplace.sdactive {\n    background-color: #ffe600; }\n  .text-editor a, .text-editor.medium-editor-element a {\n    color: #5d9bc0; }\n\n.typing .text-editor .sderror, .typing .text-editor .typing .sdfindreplace {\n  border-bottom: none;\n  background-color: transparent; }\n\n.typing .text-editor.clone {\n  display: none; }\n\n[contenteditable=true]:before {\n  display: block;\n  /* For Firefox */ }\n\n[contenteditable=true]:empty:before {\n  content: attr(placeholder);\n  display: block;\n  /* For Firefox */\n  color: rgba(150, 150, 150, 0.5); }\n\n[contenteditable=true]:focus:before {\n  display: none; }\n\n.opened-articles {\n  position: fixed;\n  min-height: 30px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  z-index: 1030; }\n  .opened-articles ul > li {\n    box-sizing: border-box;\n    padding: 0 15px 0 15px;\n    max-width: 250px;\n    position: relative;\n    line-height: 30px; }\n    .opened-articles ul > li .close {\n      color: #fff;\n      border: none;\n      background: none;\n      position: absolute;\n      right: 5px;\n      top: 5px;\n      padding: 0; }\n    .opened-articles ul > li .title {\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      color: #8bcaf7;\n      font-size: 12px;\n      font-weight: 300; }\n      .opened-articles ul > li .title:hover {\n        color: #fff;\n        text-decoration: none;\n        cursor: pointer; }\n    .opened-articles ul > li:active {\n      background: #444; }\n    .opened-articles ul > li.active {\n      background: #3e92b5 !important;\n      margin-top: -1px;\n      padding-top: 1px; }\n      .opened-articles ul > li.active:hover {\n        cursor: default; }\n      .opened-articles ul > li.active .title {\n        color: #fff; }\n  .opened-articles .list {\n    margin-left: 31px;\n    margin-right: 250px; }\n    .opened-articles .list.full-width {\n      margin-right: 0; }\n    .opened-articles .list > li {\n      float: left;\n      border-right: 1px solid #333; }\n  .opened-articles .multiedit-item {\n    float: right; }\n    .opened-articles .multiedit-item > li {\n      border-left: 1px solid #333;\n      width: 250px; }\n  .opened-articles .quick-actions button {\n    background: none;\n    border: 0;\n    height: 30px;\n    line-height: 30px;\n    width: 30px;\n    text-align: center; }\n    .opened-articles .quick-actions button:hover {\n      cursor: pointer;\n      background: #5ea9c8; }\n  .opened-articles .quick-actions i {\n    margin: -5px 0 0 0; }\n\n.authoring-dashboard {\n  padding: 40px;\n  overflow: auto; }\n  .authoring-dashboard .card-list {\n    width: 0;\n    margin: 0 auto; }\n  .authoring-dashboard .card-list > li {\n    width: 140px;\n    height: 170px;\n    float: left;\n    margin: 10px;\n    padding: 15px 20px;\n    position: relative; }\n    .authoring-dashboard .card-list > li .title {\n      max-height: 135px;\n      overflow: hidden;\n      font-size: 14px;\n      line-height: 22px;\n      max-height: 110px;\n      overflow: hidden;\n      font-weight: 500; }\n    .authoring-dashboard .card-list > li .created {\n      position: absolute;\n      bottom: 15px;\n      left: 20px;\n      color: #888;\n      font-size: 12px;\n      width: 80%;\n      height: 14%;\n      float: left; }\n    .authoring-dashboard .card-list > li .text {\n      font-size: 12px;\n      color: #666;\n      line-height: 18px; }\n    .authoring-dashboard .card-list > li .close {\n      position: absolute;\n      right: 7px;\n      top: 3px; }\n    .authoring-dashboard .card-list > li .type-icon {\n      position: relative;\n      bottom: 6px;\n      margin: 0;\n      float: left; }\n    .authoring-dashboard .card-list > li .state-label {\n      position: relative;\n      bottom: 1px;\n      margin: auto;\n      float: right; }\n    .authoring-dashboard .card-list > li .subInfo {\n      position: absolute;\n      right: 15px;\n      bottom: 1px;\n      float: right; }\n    .authoring-dashboard .card-list > li .container {\n      font-weight: 500;\n      color: #216678;\n      margin-right: 20px; }\n\n.terms-box {\n  position: relative; }\n  .terms-box .dropdown__menu.nested-menu {\n    width: 100%; }\n\n.widget {\n  padding: 12px; }\n  .widget h3 {\n    margin-bottom: 0.5em; }\n  .widget .macro-option {\n    margin-bottom: 20px; }\n  .widget .link-list .btn {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px; }\n\n.modal-footer .pagination-box .page-info {\n  float: left; }\n\n.authoring-sticky {\n  position: absolute;\n  box-sizing: border-box;\n  left: 0;\n  right: 58px;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 10px 20px;\n  border: 1px solid #cacaca;\n  border-top: 0;\n  border-bottom: 0;\n  background-color: #fff;\n  z-index: 3;\n  transition: all 0.5s; }\n  .authoring-sticky .authoring-sticky__detailed {\n    display: inline-block; }\n    .authoring-sticky .authoring-sticky__detailed > div {\n      display: inline-block;\n      margin-left: 15px;\n      padding-left: 10px;\n      border-left: 1px solid #DADADA; }\n    .authoring-sticky .authoring-sticky__detailed label, .authoring-sticky .authoring-sticky__detailed time, .authoring-sticky .authoring-sticky__detailed b {\n      display: inline-block;\n      vertical-align: top;\n      font-size: 12px;\n      color: #909090;\n      padding-right: .3em;\n      margin: 0; }\n    .authoring-sticky .authoring-sticky__detailed b {\n      max-width: 45%;\n      color: #575656;\n      font-weight: 400;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden; }\n  .authoring-sticky.authoring-sticky--fixed {\n    z-index: 3;\n    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2); }\n\n.authoring-header {\n  position: relative;\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 5px 10px 12px 10px;\n  border: 1px solid #cacaca;\n  border-top: 0;\n  border-bottom: 0;\n  background-color: #fff;\n  z-index: 2;\n  box-sizing: border-box;\n  box-shadow: 0px 1px 4px -1px rgba(0, 0, 0, 0.25);\n  max-height: 0; }\n  .authoring-header > .authoring-header__holder {\n    height: 0px;\n    opacity: 0;\n    overflow: hidden;\n    transition: opacity 0.4s 0.1s; }\n  .authoring-header.active {\n    max-height: 800px; }\n    .authoring-header.active > .authoring-header__holder {\n      height: auto;\n      opacity: 1;\n      overflow: visible;\n      transition: opacity 0.4s 0.1s; }\n  .authoring-header * {\n    box-sizing: border-box; }\n\n.authoring-header__general-info {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin: 10px 0; }\n  .authoring-header__general-info > * {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    padding-left: 10px;\n    padding-right: 10px;\n    border-right: 1px solid #DADADA; }\n    .authoring-header__general-info > * > * {\n      margin-left: 0;\n      margin-right: 0; }\n      .authoring-header__general-info > * > * + * {\n        margin-left: 10px; }\n  .authoring-header__general-info [class^=\"filetype-icon-\"],\n  .authoring-header__general-info [class*=\"filetype-icon-\"] {\n    color: #999; }\n  .authoring-header__general-info .authoring-header__label {\n    font-size: 10px;\n    color: #909090;\n    letter-spacing: 0.06em; }\n  .authoring-header__general-info .authoring-header__label-2 {\n    font-size: 12px;\n    color: #909090; }\n  .authoring-header__general-info .authoring-header__value {\n    font-size: 13px;\n    margin-top: -2px;\n    text-transform: lowercase; }\n\n.authoring-header__detailed {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start; }\n  .authoring-header__detailed .data {\n    flex-grow: 1;\n    font-size: 13px;\n    line-height: 20px; }\n  .authoring-header__detailed input.slugline {\n    color: #216278;\n    font-weight: 500; }\n  .authoring-header__detailed textarea.ed-note {\n    color: #d25932; }\n  .authoring-header__detailed .dropdown {\n    width: 100%;\n    line-height: 0; }\n    .authoring-header__detailed .dropdown .dropdown__toggle {\n      transition: all 0.3s;\n      padding: 0; }\n      .authoring-header__detailed .dropdown .dropdown__toggle .dropdown__caret {\n        position: absolute;\n        top: 50%;\n        right: 3px;\n        margin-top: -3px; }\n      .authoring-header__detailed .dropdown .dropdown__toggle i {\n        vertical-align: middle; }\n      .authoring-header__detailed .dropdown .dropdown__toggle.line-input + .dropdown__menu {\n        margin-top: 20px; }\n      .authoring-header__detailed .dropdown .dropdown__toggle.line-input span {\n        vertical-align: baseline;\n        margin-right: 3px; }\n    .authoring-header__detailed .dropdown.open .dropdown__toggle {\n      box-shadow: 0 1px 0 0 #5ea9c8;\n      border-color: #5ea9c8; }\n    .authoring-header__detailed .dropdown .dropdown__menu .place-dropdown {\n      padding-left: 16px;\n      font-weight: 500; }\n\n.authoring-header__toggle {\n  position: absolute;\n  width: 23px;\n  height: 23px;\n  border: 0;\n  padding: 0;\n  left: 50%;\n  margin-left: -11.5px;\n  bottom: -11px;\n  background-color: #fff;\n  z-index: 3;\n  line-height: 0;\n  border-radius: 23px;\n  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.3);\n  transition: transform 0.5s; }\n  .authoring-header__toggle i {\n    height: 15px; }\n  .authoring-header__toggle.active {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg); }\n\n.authoring-header__row {\n  display: flex;\n  margin-bottom: 12px;\n  min-height: 24px; }\n\n.authoring-header__row--wrap {\n  flex-wrap: wrap;\n  align-content: flex-start; }\n\n.authoring-header__item {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  padding: 0 10px 12px;\n  min-height: 40px;\n  position: relative; }\n  .authoring-header__item label {\n    display: inline-block;\n    min-width: 75px;\n    font-size: 11px;\n    line-height: 12px;\n    color: #909090;\n    padding-right: 5px;\n    padding-top: 4px;\n    font-weight: 500; }\n  .authoring-header__item.template-schedule {\n    padding: 0 0 12px; }\n    .authoring-header__item.template-schedule label {\n      width: 105px;\n      line-height: inherit; }\n  .authoring-header__item input.slugline {\n    color: #216278;\n    font-weight: 500; }\n  .authoring-header__item .sd-invalid-text {\n    float: right;\n    margin-bottom: -16px; }\n  .authoring-header__item .char-count {\n    font-size: 11px;\n    font-style: italic;\n    color: #909090;\n    float: right;\n    margin-bottom: -16px;\n    margin-left: 5px; }\n    .authoring-header__item .char-count.error {\n      color: #E51C23; }\n  .authoring-header__item [sd-meta-terms] + .sd-invalid-text {\n    position: absolute;\n    left: 120px;\n    margin-top: 3px; }\n  .authoring-header__item----half {\n    flex-basis: 50%; }\n\n.authoring-header__item .authoring-header__hint {\n  font-size: 12px;\n  color: #747474;\n  margin: 2px 0 -2px 0;\n  font-weight: 300; }\n\n.authoring-header__item-label {\n  min-width: 80px;\n  max-width: 80px;\n  font-size: 11px;\n  line-height: 26px;\n  margin: 0;\n  color: #909090;\n  text-transform: uppercase;\n  padding-right: 6px;\n  flex-shrink: 1;\n  flex-grow: 1;\n  overflow: hidden;\n  word-wrap: break-word; }\n\n.authoring-header__input-holder {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  flex-grow: 1; }\n  .authoring-header__input-holder .arrow-down {\n    position: absolute;\n    top: 4px;\n    right: 4px; }\n  .authoring-header__input-holder:hover .arrow-down .caret {\n    opacity: 1; }\n\n.authoring-header__row--2 .authoring-header__item {\n  flex-basis: 50%; }\n\n.authoring-header__row--3 .authoring-header__item {\n  flex-basis: 33%; }\n\n.authoring-header__row--4 .authoring-header__item {\n  flex-basis: 25%; }\n\n.authoring-header__row--2-1-1 .authoring-header__item {\n  flex-basis: 25%; }\n  .authoring-header__row--2-1-1 .authoring-header__item:first-child {\n    flex-basis: 50%; }\n\n.authoring-header__row--inline .authoring-header__item {\n  flex-grow: 0; }\n\n.authoring-header__row--inline .authoring-header__item .authoring-header__item-label {\n  min-width: 0;\n  max-width: 100%;\n  padding-right: 12px;\n  width: auto;\n  flex-shrink: 1; }\n\n.authoring-header__row--inline .authoring-header__item:first-child .authoring-header__item-label {\n  min-width: 75px;\n  max-width: 75px;\n  padding-right: 6px; }\n\n.compact .authoring-header__item .authoring-header__item-label {\n  min-width: 0;\n  max-width: 50px; }\n\n.compact .authoring-header__item:first-child .authoring-header__item-label {\n  min-width: 75px;\n  max-width: 75px;\n  padding-right: 6px; }\n\n.compact .authoring-header__row--inline .authoring-header__item .authoring-header__item-label {\n  min-width: 0;\n  max-width: 50px; }\n\n.compact .authoring-header__row--inline .authoring-header__item:first-child .authoring-header__item-label {\n  min-width: 75px;\n  max-width: 75px;\n  padding-right: 6px; }\n\n.dropdown-terms {\n  width: auto !important; }\n  .dropdown-terms .dropdown__toggle {\n    width: 24px;\n    height: 24px;\n    background-color: #5ea9c8;\n    margin: 0 2px 3px 0;\n    opacity: 0.5;\n    filter: \"alpha(opacity=50)\";\n    border-radius: 2px;\n    padding: 0; }\n    .dropdown-terms .dropdown__toggle i {\n      margin-bottom: 2px; }\n    .dropdown-terms .dropdown__toggle:hover, .dropdown-terms .dropdown__toggle:focus {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .dropdown-terms.open .dropdown__toggle {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n  .dropdown-terms .dropdown__menu {\n    width: 260px;\n    max-height: 275px;\n    padding: 0; }\n    .dropdown-terms .dropdown__menu .input-term {\n      padding: 5px 0 5px 25px;\n      background: url(" + escape(__webpack_require__(75)) + ") left 10px center no-repeat white;\n      border-bottom: 1px solid #F5F5F5; }\n      .dropdown-terms .dropdown__menu .input-term input {\n        box-shadow: none !important;\n        border: 0 !important; }\n    .dropdown-terms .dropdown__menu .main-list {\n      background-color: #fff;\n      max-height: 215px;\n      padding: 8px 0;\n      overflow: auto; }\n      .dropdown-terms .dropdown__menu .main-list li {\n        position: relative; }\n        .dropdown-terms .dropdown__menu .main-list li button {\n          padding-right: 17px;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap; }\n          .dropdown-terms .dropdown__menu .main-list li button i {\n            margin-right: 0; }\n    .dropdown-terms .dropdown__menu .levelup {\n      display: flex;\n      padding: 4.5px;\n      margin-bottom: -1px;\n      border-bottom: 1px solid #F5F5F5;\n      background-color: #fff; }\n      .dropdown-terms .dropdown__menu .levelup i.backlink {\n        flex-grow: 0;\n        cursor: pointer;\n        height: 27px;\n        margin-top: 0; }\n      .dropdown-terms .dropdown__menu .levelup button {\n        flex-grow: 1;\n        min-width: 0 !important;\n        font-weight: 500;\n        text-overflow: ellipsis;\n        overflow: hidden; }\n        .dropdown-terms .dropdown__menu .levelup button b.category-hover {\n          display: none; }\n        .dropdown-terms .dropdown__menu .levelup button:hover b.category {\n          display: none; }\n        .dropdown-terms .dropdown__menu .levelup button:hover b.category-hover {\n          display: block; }\n    .dropdown-terms .dropdown__menu .item-list {\n      position: static;\n      max-height: 215px; }\n\n.terms-list {\n  width: calc(100% - 30px);\n  display: inline-block;\n  vertical-align: top;\n  text-align: left; }\n  .terms-list li {\n    display: inline-block;\n    position: relative;\n    font-size: 12px;\n    color: inherit;\n    background-color: rgba(123, 123, 123, 0.2);\n    margin-right: 3px;\n    margin-bottom: 3px;\n    padding: 3px 12px;\n    cursor: pointer;\n    border-radius: 12px;\n    transition: color 0.2s; }\n    .terms-list li i {\n      position: absolute;\n      margin-left: -7px;\n      color: #333;\n      left: 50%;\n      top: 5px;\n      opacity: 0;\n      filter: \"alpha(opacity=0)\";\n      transition: opacity 0.2s; }\n    .terms-list li:hover {\n      text-align: center;\n      background-color: rgba(123, 123, 123, 0.3);\n      color: rgba(123, 123, 123, 0.5); }\n      .terms-list li:hover i {\n        opacity: 0.85;\n        filter: \"alpha(opacity=85)\"; }\n    .terms-list li label {\n      display: inline;\n      min-width: auto;\n      font-size: 12px;\n      font-weight: 300;\n      color: inherit;\n      opacity: 0.75;\n      margin: 0;\n      padding: 0 4px 0 0; }\n  .terms-list--full {\n    width: 100%; }\n\n[sd-meta-terms] {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n  transition: border linear 0.2s, box-shadow linear 0.2s, background-color linear 0.2s; }\n  [sd-meta-terms].sd-terms--boxed {\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 2px;\n    padding-top: 3px;\n    padding-left: 3px; }\n  [sd-meta-terms]:hover {\n    border-color: rgba(0, 0, 0, 0.3); }\n    [sd-meta-terms]:hover.sd-terms--boxed {\n      background-color: rgba(0, 0, 0, 0.1); }\n\n.item-detail-info {\n  height: 0px;\n  overflow: hidden;\n  box-sizing: border-box; }\n  .item-detail-info.active {\n    height: auto; }\n  .item-detail-info + button {\n    position: absolute;\n    width: 23px;\n    height: 23px;\n    border: 0;\n    padding: 0 5px;\n    font-size: 0;\n    left: 98%;\n    margin-left: -11.5px;\n    margin-top: -13px;\n    background-color: #fff;\n    border-radius: 23px;\n    transition: transform 0.5s; }\n    .item-detail-info + button.active {\n      -webkit-transform: rotate(180deg);\n      transform: rotate(180deg); }\n  .item-detail-info .edit-photo {\n    display: none;\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 9px;\n    text-decoration: none;\n    text-align: center;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0; }\n  .item-detail-info:hover .edit-photo {\n    display: block; }\n\n.sd-photo-preview__edit-mode .sd-photo-preview__image {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  position: relative; }\n  .sd-photo-preview__edit-mode .sd-photo-preview__image sd-image-modify {\n    text-align: center;\n    height: 100%;\n    overflow: auto; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image sd-image-modify canvas {\n      max-width: 100%;\n      max-height: 100%;\n      height: auto;\n      margin: auto;\n      -webkit-transition: all .3s ease;\n      -moz-transition: all .3s ease;\n      -ms-transition: all .3s ease;\n      -o-transition: all .3s ease;\n      transition: all .3s ease; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image sd-image-modify.disable-transition canvas {\n      -webkit-transition: none;\n      -moz-transition: none;\n      -ms-transition: none;\n      -o-transition: none;\n      transition: none; }\n  .sd-photo-preview__edit-mode .sd-photo-preview__image--with-strip {\n    position: relative;\n    display: block;\n    height: 100%;\n    text-align: center; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image--with-strip .sd-photo-preview__label {\n      position: absolute;\n      bottom: 1rem;\n      left: 50%;\n      margin-left: -8rem;\n      display: inline-block;\n      pointer-events: none;\n      user-select: none; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image--with-strip sd-image-point, .sd-photo-preview__edit-mode .sd-photo-preview__image--with-strip div[sd-image-crop] {\n      display: inline-block !important;\n      margin-top: 6rem; }\n  .sd-photo-preview__edit-mode .sd-photo-preview__image--no-flex {\n    display: block;\n    height: 100%;\n    text-align: center; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image--no-flex div[sd-image-crop] {\n      display: inline-block !important; }\n      .sd-photo-preview__edit-mode .sd-photo-preview__image--no-flex div[sd-image-crop] .jcrop-tracker {\n        display: inline-block !important; }\n      .sd-photo-preview__edit-mode .sd-photo-preview__image--no-flex div[sd-image-crop] img {\n        max-height: none; }\n    .sd-photo-preview__edit-mode .sd-photo-preview__image--no-flex .sd-photo-preview__label {\n      display: inline-block; }\n\n.sd-column-box__main-column.toolbar-offset .sd-photo-preview__slide-in-button {\n  margin-top: 6rem; }\n\n.sd-grid-item .sd-grid-item__thumb > div:not(.sd-grid-item__checkbox) {\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  width: 100%;\n  height: 14rem;\n  overflow: hidden;\n  text-align: center; }\n\n.sd-grid-item.sd-grid-item--overflow-v .sd-grid-item__thumb > div:not(.sd-grid-item__checkbox) {\n  overflow: visible; }\n\n.sd-grid-item .sd-grid-item__thumb > sd-image-point {\n  text-align: center;\n  display: inline-block;\n  padding: 0;\n  height: 14rem;\n  overflow: hidden; }\n\n.sd-photo-preview__image {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  .sd-photo-preview__image > img, .sd-photo-preview__image > video {\n    max-width: 100%;\n    max-height: 100%;\n    height: auto;\n    margin: auto;\n    object-fit: contain; }\n  .sd-photo-preview__image .jcrop-holder img {\n    max-width: none;\n    max-height: none; }\n  .sd-photo-preview__image--with-strip {\n    display: block;\n    height: 100%;\n    text-align: center; }\n\n.sd-photo-preview__label {\n  background: rgba(0, 0, 0, 0.25);\n  color: inherit;\n  padding: 0.8rem 2rem;\n  margin: 1rem auto;\n  line-height: 100%;\n  border-radius: 2rem;\n  font-weight: 300;\n  min-width: 16rem; }\n\n.sd-grid-item .sd-grid-item__thumb .jcrop-holder img {\n  max-width: none;\n  max-height: none; }\n\n.preview-modal-control .preview-toggle {\n  z-index: 100; }\n\n.preview-pane .pane-holder {\n  width: 400px; }\n  .preview-pane .pane-holder.outer-pane {\n    top: 0; }\n  .preview-pane .pane-holder .send-to-pane {\n    width: 400px; }\n\n#macros-diff {\n  position: absolute;\n  bottom: 30px;\n  right: 60px;\n  padding: 5px;\n  opacity: 0.88;\n  z-index: 10;\n  text-align: right;\n  background-color: #fff; }\n  #macros-diff > * {\n    margin-left: 5px; }\n  #macros-diff .replace-btn {\n    margin-right: 8px; }\n  #macros-diff em {\n    font-size: 120%; }\n\n.media-container {\n  cursor: default;\n  position: relative;\n  padding: 1.2rem 1.2rem 1.6rem;\n  border-radius: 2px;\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.26), 0 0 1px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(123, 123, 123, 0.3);\n  transition: 0.3s linear box-shadow; }\n\n.item-association:hover .item-association__image-overlay, .item-association:hover .item-association__remove-item {\n  opacity: 1; }\n\n.item-association audio {\n  width: 96%;\n  margin: 2rem 2% 0.4rem; }\n\n.item-association__image-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: rgba(0, 0, 0, 0.5);\n  transition: 0.2s linear opacity;\n  z-index: 1;\n  opacity: 0;\n  color: #fff; }\n\n.item-association__metadata, .media-container__metadata {\n  padding: 0.4rem 0 0.2rem 0;\n  color: inherit;\n  font-family: \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 1.3rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));\n  grid-gap: 0 1.6rem;\n  z-index: 2;\n  transition: 0.2s linear opacity;\n  text-align: left;\n  margin: 1.6rem 1.6rem 0; }\n  .item-association__metadata span, .media-container__metadata span {\n    display: block;\n    padding: 0.6rem 0;\n    border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n    .item-association__metadata span em, .media-container__metadata span em {\n      font-style: normal;\n      color: inherit;\n      opacity: 0.75;\n      font-weight: 300;\n      padding-right: 0.4rem;\n      font-size: 1.1rem;\n      text-transform: uppercase;\n      letter-spacing: 0.05em; }\n    .item-association__metadata span:nth-child(1), .item-association__metadata span:nth-child(2), .media-container__metadata span:nth-child(1), .media-container__metadata span:nth-child(2) {\n      border-top: 1px dotted rgba(123, 123, 123, 0.5); }\n  .item-association__metadata--top-overlay, .media-container__metadata--top-overlay {\n    padding: 0.2rem 0 0.6rem 0;\n    margin-top: 0;\n    background: none;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, transparent 100%); }\n    .item-association__metadata--top-overlay span, .media-container__metadata--top-overlay span {\n      padding-bottom: 0.4rem;\n      border: none !important; }\n  .item-association__metadata--bottom-overlay, .media-container__metadata--bottom-overlay {\n    background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.12) 2%, rgba(0, 0, 0, 0.6) 100%); }\n  .item-association__metadata--side-marg0, .media-container__metadata--side-marg0 {\n    margin-left: 0;\n    margin-right: 0; }\n\n[class^=\"__image-overlay\"] .item-association__metadata span,\n[class*=\"__image-overlay\"] .item-association__metadata span {\n  border-color: rgba(255, 255, 255, 0.5) !important; }\n  [class^=\"__image-overlay\"] .item-association__metadata span:last-child,\n  [class*=\"__image-overlay\"] .item-association__metadata span:last-child {\n    border-bottom: none; }\n\n.media-container__metadata {\n  margin: 1.6rem 0 0; }\n  .media-container__metadata--image {\n    margin: 0;\n    padding: 0.5rem 1.6rem; }\n    .media-container__metadata--image span:nth-child(1), .media-container__metadata--image span:nth-child(2) {\n      border-top: none; }\n    .media-container__metadata--image span:nth-last-child(1), .media-container__metadata--image span:nth-last-child(2) {\n      border-bottom: none; }\n\n.item-association__title {\n  margin-bottom: 1.6rem;\n  font-size: 1.5rem;\n  font-weight: 500; }\n\n.media-container__action-bar, .item-association__action-bar {\n  text-align: right;\n  padding: 1rem 0 0;\n  margin: 0 1.6rem 0 0; }\n\n.media-container__action-bar {\n  margin: 0; }\n\n.item-association__icons-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  flex-grow: 1; }\n\n.item-association__image-action {\n  flex-grow: 0;\n  flex-shrink: 0;\n  color: #fff;\n  width: 5.6rem;\n  height: 5.6rem;\n  border: 2px solid rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: 0.2s linear all;\n  cursor: pointer;\n  text-decoration: none;\n  background-color: transparent; }\n  .item-association__image-action i {\n    color: #fff;\n    height: 2.4rem;\n    width: 2.4rem;\n    font-size: 2.4rem;\n    line-height: 1;\n    opacity: 0.5;\n    transition: 0.2s linear all; }\n  .item-association__image-action:hover {\n    border-color: white;\n    background-color: rgba(0, 0, 0, 0.4);\n    text-decoration: none; }\n    .item-association__image-action:hover i {\n      opacity: 1; }\n  .item-association__image-action:active {\n    border-color: #5ea9c8;\n    background-color: rgba(0, 0, 0, 0.6); }\n    .item-association__image-action:active i {\n      color: #5ea9c8; }\n\n.item-association__image-action + .item-association__image-action {\n  margin-left: 2rem; }\n\n.item-association__image-container,\n.item-association__video-container,\n.item-association__audio-container {\n  height: 100%;\n  position: relative; }\n\n.item-association__audio-container {\n  padding: 2.5rem 0 2rem; }\n  .item-association__audio-container audio {\n    margin-bottom: 1rem;\n    border-radius: 6px; }\n\n.item-association__video-container {\n  padding-bottom: 1.6rem; }\n  .item-association__video-container video {\n    display: block; }\n  .item-association__video-container .item-association__image-overlay {\n    bottom: 32px; }\n\n.item-association__image-container {\n  background-color: #2c2c2c;\n  color: #fff; }\n\n.item-association__remove-item {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 2;\n  color: #fff;\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  transition: 0.2s linear all;\n  cursor: pointer;\n  text-decoration: none;\n  background-color: rgba(0, 0, 0, 0.5);\n  transition: 0.2s linear opacity;\n  opacity: 0; }\n  .item-association__remove-item i {\n    color: #fff;\n    height: 1.8rem;\n    width: 1.8rem;\n    font-size: 1.8rem;\n    line-height: 1;\n    opacity: 0.75;\n    transition: 0.2s linear all; }\n  .item-association__remove-item:hover {\n    background-color: rgba(0, 0, 0, 0.75);\n    text-decoration: none; }\n    .item-association__remove-item:hover i {\n      opacity: 1; }\n  .item-association__remove-item:active {\n    border-color: #5ea9c8;\n    background-color: black; }\n    .item-association__remove-item:active i {\n      color: #5ea9c8; }\n\n.item-association {\n  border: 2px dashed rgba(150, 150, 150, 0.3);\n  background-color: rgba(150, 150, 150, 0.06);\n  color: inherit;\n  width: 100%;\n  height: 65px;\n  position: relative; }\n  .item-association:focus {\n    border-color: #5ea9c8; }\n  .item-association video {\n    max-width: 100%; }\n  .item-association--loading {\n    background-color: fade(#f7f7f7, 40%);\n    border-color: fade(#cfcfcf, 40%); }\n    .item-association--loading:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: 3;\n      background-image: url(" + escape(__webpack_require__(1572)) + ");\n      background-repeat: no-repeat;\n      background-position: center center;\n      background-size: 70px; }\n    .item-association--loading img {\n      opacity: .2; }\n    .item-association--loading .item-association__text-label {\n      opacity: 0.1; }\n  .item-association.dragover {\n    background: #eff7fa;\n    border-color: #5ea9c8; }\n  .item-association [contenteditable] {\n    padding: 8px;\n    min-height: 18px; }\n  .item-association:not(.item-association--preview) {\n    cursor: pointer; }\n  .item-association--preview {\n    border: 1px solid rgba(150, 150, 150, 0.15);\n    border-width: 0 0 1px 0; }\n  .item-association--marg-b10 {\n    margin-bottom: 1rem; }\n  .item-association img {\n    max-width: 100%; }\n    .item-association img:hover {\n      cursor: pointer; }\n  .item-association .not-editable:hover {\n    cursor: auto; }\n  .item-association--no-click:hover {\n    cursor: auto; }\n  .item-association .close-overlay {\n    z-index: 10000;\n    position: absolute;\n    top: 16px;\n    right: 16px; }\n\n.item-association__text-label {\n  font-weight: 500;\n  opacity: 0.4; }\n\nfeature-image .item-association [contenteditable] {\n  text-align: center; }\n\n.indent-article #bodyhtml p:first-of-type, .indent-article #bodyhtml p + p, .indent-article .text.body-text p:first-of-type, .indent-article .text.body-text p + p {\n  text-indent: 25px; }\n\n.indent-article #bodyhtml h2 + p:first-of-type,\n.indent-article #bodyhtml h3 + p:first-of-type,\n.indent-article #bodyhtml h4 + p:first-of-type,\n.indent-article #bodyhtml h5 + p:first-of-type, .indent-article .text.body-text h2 + p:first-of-type,\n.indent-article .text.body-text h3 + p:first-of-type,\n.indent-article .text.body-text h4 + p:first-of-type,\n.indent-article .text.body-text h5 + p:first-of-type {\n  text-indent: 0; }\n\n#timezoneTimestamp .timezone-label {\n  display: none; }\n\n#timezoneTimestamp ul.item-list {\n  right: auto;\n  top: -170px; }\n\n.panel-header {\n  margin-right: 20px;\n  cursor: pointer;\n  font-weight: 400 !important;\n  color: #999 !important; }\n  .panel-header :hover {\n    border-bottom: 2px solid #3299b7; }\n\n.panel-header-active {\n  color: #fff !important; }\n  .panel-header-active span {\n    border-bottom: 2px solid #3299b7; }\n\n.media-item--loading {\n  background-color: fade(#f7f7f7, 40%);\n  border-color: fade(#cfcfcf, 40%); }\n  .media-item--loading:before {\n    background-image: url(" + escape(__webpack_require__(34)) + ");\n    background-repeat: no-repeat;\n    background-position: center;\n    display: inline-block;\n    width: 100%;\n    height: 40px;\n    line-height: 40px;\n    vertical-align: middle;\n    text-align: center;\n    content: '';\n    top: 50%;\n    transform: translateY(-50%);\n    position: absolute; }\n  .media-item--loading img {\n    opacity: .2; }\n\n.field.media-item video, .field.media-item audio {\n  max-width: 100%; }\n\n.field.media-item img {\n  max-width: 100%; }\n\n.field.media-item video {\n  display: block; }\n\n.field.media-item audio {\n  width: 100%;\n  display: block;\n  border-radius: 6px; }\n\n.field.media-item figure {\n  display: block !important; }\n\n.media-item__item {\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1), 0 1px 5px rgba(0, 0, 0, 0.16);\n  margin-bottom: 2rem;\n  width: 100%; }\n  .media-item__item figure {\n    display: block !important;\n    margin: 0 !important; }\n  .media-item__item img {\n    display: block; }\n  .media-item__item .item-association {\n    height: auto; }\n\n.media-item__item-label {\n  text-align: center;\n  display: block;\n  padding: 1rem 0;\n  opacity: 0.7;\n  font-family: 'Roboto';\n  font-size: 1.3rem;\n  border-bottom: 1px solid rgba(123, 123, 123, 0.16);\n  background-color: rgba(123, 123, 123, 0.08); }\n\n.sd-line-input textarea.sd-line-input__input--formatted-preview {\n  height: 40rem;\n  font-family: \"Roboto Mono\", Consolas, Courier, monospace; }\n\n.image-carousel {\n  max-width: 100%; }\n\n.sd-media-carousel__thumb-strip-item {\n  transition: none; }\n\n.sd-editor--theme-blue .cropItems__item, .sd-editor--theme-blue .media-item__item, .sd-editor--theme-dark .cropItems__item, .sd-editor--theme-dark .media-item__item {\n  outline: 1px solid rgba(255, 255, 255, 0.2); }\n\n.related-items {\n  padding: 1rem 1rem 0;\n  background-color: rgba(150, 150, 150, 0.075);\n  border: 1px solid rgba(150, 150, 150, 0.2); }\n  .related-items .draggable-list .placeholder {\n    border: 2px dotted #5ea9c8;\n    background-color: rgba(94, 169, 200, 0.1);\n    min-height: 58px !important;\n    margin: 0 0 1rem; }\n  .related-items .draggable-list .sd-list-item:hover {\n    cursor: inherit; }\n  .related-items.dragover {\n    border: 1px dashed #5ea9c8;\n    background-color: rgba(94, 169, 200, 0.1); }\n\n.sd-list-item .type-icon {\n  opacity: 0.6; }\n\n.form__row--desk-select + .btn-list {\n  margin-top: 1rem; }\n\n[class^=\"--dark-ui\"] [sd-meta-terms],\n[class*=\"--dark-ui\"] [sd-meta-terms] {\n  border-bottom-color: rgba(255, 255, 255, 0.2); }\n  [class^=\"--dark-ui\"] [sd-meta-terms].sd-terms--boxed,\n  [class*=\"--dark-ui\"] [sd-meta-terms].sd-terms--boxed {\n    background-color: rgba(255, 255, 255, 0.05); }\n  [class^=\"--dark-ui\"] [sd-meta-terms]:hover,\n  [class*=\"--dark-ui\"] [sd-meta-terms]:hover {\n    border-bottom-color: rgba(255, 255, 255, 0.4); }\n    [class^=\"--dark-ui\"] [sd-meta-terms]:hover.sd-terms--boxed,\n    [class*=\"--dark-ui\"] [sd-meta-terms]:hover.sd-terms--boxed {\n      background-color: rgba(255, 255, 255, 0.1); }\n\n[class^=\"--dark-ui\"] .terms-list li,\n[class*=\"--dark-ui\"] .terms-list li {\n  background-color: rgba(123, 123, 123, 0.3); }\n  [class^=\"--dark-ui\"] .terms-list li i,\n  [class*=\"--dark-ui\"] .terms-list li i {\n    color: #fff; }\n  [class^=\"--dark-ui\"] .terms-list li:hover,\n  [class*=\"--dark-ui\"] .terms-list li:hover {\n    background-color: rgba(123, 123, 123, 0.4);\n    color: rgba(123, 123, 123, 0.8); }\n", ""]);

// exports


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "39341fa4af9a113a40f4bf53c5cc9e7f.svg";

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1574);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./multiedit.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./multiedit.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.close-multiedit {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  opacity: 0.6;\n  filter: \"alpha(opacity=60)\";\n  background: none;\n  border: 0;\n  padding: 0; }\n  .close-multiedit:hover {\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.multiedit-screen .boards-list {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 110px; }\n\n.multiedit-screen .boards-create {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 110px;\n  box-sizing: border-box; }\n  .multiedit-screen .boards-create i {\n    font-size: 48px;\n    line-height: 100px;\n    position: absolute;\n    top: 50%;\n    margin-top: -50px;\n    left: 50%;\n    margin-left: -20px; }\n  .multiedit-screen .boards-create:hover {\n    cursor: pointer;\n    background: #d8d8d8; }\n  .multiedit-screen .boards-create .multiedit-float .dropdown__menu {\n    position: fixed;\n    left: auto;\n    right: auto;\n    top: auto;\n    bottom: auto;\n    max-width: 270px; }\n    .multiedit-screen .boards-create .multiedit-float .dropdown__menu li button {\n      max-width: 250px !important; }\n\n.multiedit-screen .boards-list .board {\n  background: #fff;\n  float: left;\n  height: 100%;\n  box-sizing: border-box;\n  border: 1px solid #cacaca;\n  border-width: 0 1px;\n  overflow-y: auto;\n  position: relative; }\n  .multiedit-screen .boards-list .board > .dropdown {\n    left: 10px;\n    top: 5px;\n    border: 0;\n    position: absolute;\n    z-index: 2;\n    display: none; }\n    .multiedit-screen .boards-list .board > .dropdown .dropdown__toggle {\n      padding: 0 15px; }\n      .multiedit-screen .boards-list .board > .dropdown .dropdown__toggle i {\n        opacity: 0.7;\n        filter: \"alpha(opacity=70)\"; }\n    .multiedit-screen .boards-list .board > .dropdown.open .dropdown__toggle {\n      box-shadow: -3px -2px 1px -2px #999999, 3px -2px 1px -2px #999999; }\n    .multiedit-screen .boards-list .board > .dropdown .dropdown__menu {\n      margin-top: -4px; }\n  .multiedit-screen .boards-list .board > .board-article {\n    width: 100%;\n    height: 100%; }\n    .multiedit-screen .boards-list .board > .board-article > .main-article {\n      border: 0;\n      padding: 20px 20px 70px; }\n      .multiedit-screen .boards-list .board > .board-article > .main-article.locked {\n        border-left: 4px solid #e51c23; }\n      .multiedit-screen .boards-list .board > .board-article > .main-article .editbar {\n        visibility: hidden;\n        overflow: hidden;\n        margin: 0 0 20px; }\n  .multiedit-screen .boards-list .board:hover > .dropdown {\n    display: block; }\n  .multiedit-screen .boards-list .board:hover .editbar {\n    visibility: visible !important; }\n", ""]);

// exports


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1576);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./themes.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./themes.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\nbody, html {\n  height: 100%; }\n\n.modal-body .main-article {\n  border-width: 0;\n  padding: 10px; }\n\n.authoring-sticky__theme-controls {\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  display: flex;\n  flex-direction: row;\n  align-items: center; }\n  .authoring-sticky__theme-controls .icn-btn {\n    margin-left: 3px; }\n  .authoring-sticky__theme-controls .proofread-toggle:hover {\n    background-color: rgba(152, 152, 152, 0.3); }\n  .authoring-sticky__theme-controls .proofread-toggle.active {\n    box-shadow: inset 0 2px 0 rgba(55, 55, 55, 0.1);\n    background-color: #5ea9c8;\n    color: #fff; }\n  .authoring-sticky__theme-controls .theme-select {\n    display: inline-block; }\n    .authoring-sticky__theme-controls .theme-select .dropdown__toggle {\n      position: relative; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__toggle i {\n        margin-bottom: 1px; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__toggle:hover {\n        background-color: rgba(152, 152, 152, 0.3); }\n    .authoring-sticky__theme-controls .theme-select.open .dropdown__toggle {\n      box-shadow: inset 0 2px 0 rgba(55, 55, 55, 0.1);\n      background-color: rgba(152, 152, 152, 0.3); }\n    .authoring-sticky__theme-controls .theme-select .dropdown__menu {\n      min-width: 424px;\n      padding: 10px;\n      right: -9px; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-status {\n        position: absolute;\n        width: 8px;\n        height: 8px;\n        border-radius: 8px;\n        margin-top: 4px;\n        margin-left: 0px;\n        background-color: #ccc; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-status.active {\n          background-color: #107401; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__menu .dropdown__menu-label {\n        padding-left: 13px;\n        margin-bottom: 6px; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__menu > ul {\n        float: left;\n        vertical-align: top;\n        width: 50%;\n        padding-left: 9px;\n        box-sizing: border-box; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu > ul.normal-theme-list {\n          padding-right: 9px;\n          padding-left: 0;\n          border-right: 1px solid #e5e5e5; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__menu .btn-group {\n        margin-bottom: 20px;\n        display: flex;\n        justify-content: space-between; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .btn-group .toggle-button {\n          width: 48%; }\n      .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn {\n        border-radius: 2px;\n        margin-bottom: 6px;\n        border: 1px solid #e9e9e9;\n        position: relative;\n        padding-right: 20px;\n        padding-left: 12px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        min-width: auto !important;\n        width: 100%;\n        min-width: auto; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn i {\n          margin: 0;\n          position: absolute;\n          top: 10px;\n          right: 0px;\n          color: inherit !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.dark-theme {\n          border: 0;\n          background: #222222;\n          color: #aaccd1 !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.dark-blue-theme {\n          border: 0;\n          background: #06356a;\n          color: white !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.dark-theme-mono {\n          border: 0;\n          background: #222222;\n          color: #aaccd1 !important;\n          font-family: \"Roboto Mono\", Consolas, Courier, monospace; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.natural-theme {\n          border: 0;\n          background: #efe9c5;\n          color: #323232 !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.dark-khaki-theme {\n          border: 0;\n          background: #949e5f;\n          color: #252818 !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn.dark-turquoise-theme {\n          border: 0;\n          background: darkturquoise;\n          color: #122235 !important; }\n        .authoring-sticky__theme-controls .theme-select .dropdown__menu .theme-btn:hover {\n          background-color: inherit !important;\n          color: inherit !important; }\n\n.main-article {\n  width: auto;\n  background: #fff;\n  border: 1px solid #cacaca;\n  border-width: 0 1px;\n  position: relative;\n  z-index: 1;\n  padding: 35px 60px 90px;\n  margin: 0 auto;\n  min-height: 100%;\n  box-sizing: border-box;\n  max-width: 900px;\n  color: #333333; }\n  .main-article .field {\n    max-width: 100%;\n    margin-bottom: 20px; }\n    .main-article .field .full-preview {\n      display: inline-block; }\n    .main-article .field .dateline {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-end; }\n      .main-article .field .dateline input {\n        text-transform: uppercase; }\n      .main-article .field .dateline input, .main-article .field .dateline select, .main-article .field .dateline option {\n        color: inherit;\n        font-size: 14px;\n        font-weight: 400 !important;\n        padding: 0;\n        -webkit-appearance: none;\n        -moz-appearance: none; }\n      .main-article .field .dateline select {\n        width: 20%; }\n      .main-article .field .dateline .dateline-city {\n        display: flex;\n        flex: 1 1 auto;\n        font-size: 1.4rem;\n        line-height: 2.7rem;\n        padding-right: 2rem; }\n        .main-article .field .dateline .dateline-city .term-editor {\n          flex: 1 1 auto; }\n      .main-article .field .dateline .dateline-date {\n        flex: 0 1 20%;\n        display: flex;\n        flex-direction: row;\n        align-items: flex-end; }\n        .main-article .field .dateline .dateline-date #datelineMonth {\n          flex: 1 1 auto;\n          width: auto;\n          margin-right: 0.6rem; }\n        .main-article .field .dateline .dateline-date #datelineDay {\n          text-align: center;\n          flex: 0 1 3.4rem;\n          width: auto; }\n    .main-article .field .dropdown {\n      display: block; }\n  .main-article .field .field__label {\n    font-weight: 400;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 2px;\n    color: #fff;\n    display: inline-block;\n    padding: 2px 8px 1px;\n    margin-bottom: 15px;\n    font-size: 11px;\n    font-family: \"Roboto\", sans-serif;\n    line-height: 16px;\n    transition: all ease 0.2s;\n    opacity: 0.4;\n    text-transform: uppercase;\n    font-style: normal;\n    letter-spacing: 0.1em; }\n  .main-article .field.active .field__label {\n    background: #5ea9c8;\n    transition: all ease 0.6s; }\n  .main-article .main-article__fieldset {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-content: flex-start; }\n  .main-article .sd-validate .sd-required {\n    color: inherit;\n    opacity: 0.75;\n    letter-spacing: 0.04em;\n    font-family: \"Roboto\", sans-serif; }\n  .main-article .text-field__non-editable {\n    font-size: 1.6rem;\n    line-height: 150%;\n    min-height: 2.7rem;\n    padding: 2px 0 0 1px;\n    word-break: break-all; }\n  .main-article .text-editor, .main-article input, .main-article .field__select {\n    border: 1px solid rgba(123, 123, 123, 0) !important;\n    border-bottom-color: rgba(123, 123, 123, 0.3) !important;\n    padding: 0;\n    border-radius: 0;\n    background-color: transparent; }\n    .main-article .text-editor:focus, .main-article input:focus, .main-article .field__select:focus {\n      outline: none; }\n    .main-article .text-editor h1, .main-article .text-editor h2, .main-article .text-editor h3, .main-article .text-editor h4, .main-article .text-editor h5, .main-article .text-editor h6, .main-article input h1, .main-article input h2, .main-article input h3, .main-article input h4, .main-article input h5, .main-article input h6, .main-article .field__select h1, .main-article .field__select h2, .main-article .field__select h3, .main-article .field__select h4, .main-article .field__select h5, .main-article .field__select h6 {\n      font-size: 16px;\n      line-height: 18px;\n      margin-bottom: 9px; }\n  .main-article .field__select {\n    -moz-appearance: none;\n    -webkit-appearance: none; }\n  .main-article .text-editor:hover, .main-article .headline:hover, .main-article .abstract:hover, .main-article input:hover, .main-article .field__select:hover {\n    border-bottom-color: rgba(123, 123, 123, 0.6) !important;\n    cursor: text; }\n  .main-article .field__select:hover {\n    -moz-appearance: menulist-button;\n    -webkit-appearance: menulist-button; }\n  .main-article .text-editor:focus, .main-article .headline:focus, .main-article .abstract:focus, .main-article input:focus, .main-article .field__select:focus {\n    border-width: 1px !important;\n    border-color: rgba(94, 169, 200, 0.3) !important;\n    border-bottom-color: #5ea9c8 !important;\n    box-shadow: 0 1px 0 #5ea9c8 !important; }\n  .main-article.preview .text-editor {\n    border-color: #fff !important; }\n  .main-article .char-count {\n    font-family: \"Roboto\", sans-serif;\n    font-size: 11px;\n    font-style: italic;\n    color: inherit;\n    margin-left: 5px;\n    float: right;\n    opacity: 0;\n    filter: \"alpha(opacity=0)\";\n    transition: all ease 0.2s; }\n    .main-article .char-count.error {\n      font-weight: 500;\n      color: #D33C30;\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .main-article:hover .char-count, .main-article:focus .char-count {\n    opacity: 0.4;\n    filter: \"alpha(opacity=40)\"; }\n    .main-article:hover .char-count.error, .main-article:focus .char-count.error {\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .main-article:hover .field label, .main-article:focus .field label {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n  .main-article .field.limit-error .char-count {\n    opacity: 1;\n    filter: \"alpha(opacity=100)\"; }\n  .main-article .field.limit-error input, .main-article .field.limit-error textarea {\n    border-color: rgba(210, 60, 50, 0.15) !important; }\n  .main-article .field.limit-error input, .main-article .field.limit-error textarea {\n    font-weight: 500;\n    color: #D33C30 !important; }\n  .main-article figure {\n    width: 100%;\n    display: table;\n    table-layout: fixed;\n    margin: 10px 0; }\n    .main-article figure.item-association {\n      margin: 0; }\n  .main-article figure img {\n    display: block;\n    max-width: 100%;\n    margin: 0 auto; }\n  .main-article figcaption {\n    border: 1px solid rgba(150, 150, 150, 0.15);\n    padding: 8px;\n    min-height: 18px; }\n  .main-article .text-editor, .main-article .headline, .main-article .abstract, .main-article input {\n    color: inherit;\n    padding-left: 0;\n    padding-right: 0; }\n  .main-article .keyword {\n    text-transform: uppercase;\n    font-weight: 500; }\n  .main-article .byline {\n    font-size: 16px;\n    text-transform: none;\n    line-height: 150%; }\n    .main-article .byline .text-editor {\n      min-height: 24px; }\n    .main-article .byline::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0.4; }\n    .main-article .byline::-moz-placeholder {\n      color: inherit;\n      opacity: 0.4; }\n    .main-article .byline:focus::-webkit-input-placeholder {\n      color: transparent; }\n    .main-article .byline:focus::-moz-placeholder {\n      color: transparent; }\n  .main-article .image-caption {\n    font-size: 14px;\n    text-transform: none;\n    line-height: 140%; }\n    .main-article .image-caption::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0.4; }\n    .main-article .image-caption::-moz-placeholder {\n      color: inherit;\n      opacity: 0.4; }\n    .main-article .image-caption:focus::-webkit-input-placeholder {\n      color: transparent; }\n    .main-article .image-caption:focus::-moz-placeholder {\n      color: transparent; }\n  .main-article #body_footer .text-editor {\n    min-height: 26px;\n    padding: 0 !important;\n    margin-bottom: 10px !important;\n    font-size: 16px !important;\n    line-height: 150% !important;\n    font-weight: 300; }\n  .main-article .headline, .main-article .headline p, .main-article .headline div {\n    line-height: 120% !important;\n    font-weight: 500; }\n    .main-article .headline .text-editor, .main-article .headline p .text-editor, .main-article .headline div .text-editor {\n      min-height: 48px;\n      padding: 6px 0; }\n    .main-article .headline .html-preview, .main-article .headline p .html-preview, .main-article .headline div .html-preview {\n      font-size: 2.8rem; }\n  .main-article .body {\n    clear: left; }\n    .main-article .body .html-preview {\n      font-size: 1.6rem;\n      font-weight: 300;\n      line-height: 150%; }\n      .main-article .body .html-preview p {\n        font-size: 1.6rem; }\n\n.text-editor p, .preview-editor p {\n  padding: 0;\n  margin-bottom: 10px;\n  line-height: 150%;\n  font-weight: 300; }\n\n.text-editor p:last-of-type, .preview-editor p:last-of-type {\n  margin-bottom: 0 !important; }\n\n.text-editor h2, .preview-editor h2 {\n  font-size: 1.5em; }\n\n.text-editor h3, .preview-editor h3 {\n  font-size: 1.25em; }\n\n.text-editor.clone, .preview-editor.clone {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin-top: 0;\n  z-index: -1;\n  opacity: 0.5;\n  color: transparent !important;\n  border-bottom-color: transparent !important; }\n  .text-editor.clone .sderror, .preview-editor.clone .sderror {\n    font-size: inherit;\n    line-height: inherit;\n    font-weight: inherit; }\n\n.text-editor li, .preview-editor li {\n  padding: 0;\n  font-size: 16px;\n  line-height: 150%;\n  font-weight: 300; }\n\n.text-editor ol, .text-editor ul, .preview-editor ol, .preview-editor ul {\n  padding-left: 30px;\n  margin: 10px 0; }\n\n.text-editor ul, .preview-editor ul {\n  list-style-type: disc; }\n\n.text-editor table, .preview-editor table {\n  width: 100%;\n  border-collapse: collapse;\n  resize: both;\n  table-layout: auto;\n  border: 1px solid #dadada;\n  margin: 16px 0; }\n  .text-editor table td, .text-editor table th, .preview-editor table td, .preview-editor table th {\n    border: 1px solid #dadada;\n    padding: 5px 8px;\n    font-size: 14px;\n    font-weight: 400;\n    vertical-align: text-top; }\n  .text-editor table th, .preview-editor table th {\n    font-weight: 500;\n    text-align: left;\n    background-color: rgba(195, 195, 195, 0.2); }\n\n.text-editor blockquote, .preview-editor blockquote {\n  font-size: 16px;\n  line-height: 150%;\n  margin: 20px 0;\n  border-left: 3px solid rgba(160, 160, 160, 0.5);\n  padding: 4px 0 4px 16px;\n  font-style: italic; }\n\n.large-text.main-article .abstract {\n  font-size: 18px; }\n  .large-text.main-article .abstract .text-editor {\n    font-size: 18px; }\n\n.large-text.main-article .text-editor p {\n  font-size: 18px !important; }\n\n.large-text.main-article .headline {\n  font-size: 28px; }\n  .large-text.main-article .headline .text-editor {\n    font-size: 28px; }\n\n.dark-theme.main-article {\n  background: #222222;\n  color: #aaccd1 !important; }\n  .dark-theme.main-article .text-editor,\n  .dark-theme.main-article .headline,\n  .dark-theme.main-article .abstract,\n  .dark-theme.main-article .dateline input,\n  .dark-theme.main-article .dateline select,\n  .dark-theme.main-article input,\n  .dark-theme.main-article .text-editor p {\n    color: #aaccd1 !important; }\n  .dark-theme.main-article .field label {\n    background: rgba(73, 73, 73, 0.7);\n    color: rgba(255, 255, 255, 0.6); }\n\n.dark-theme .sderror {\n  border-bottom-color: #FF3D3D;\n  background-color: rgba(255, 61, 61, 0.25);\n  color: #222222 !important; }\n\n.dark-theme-mono.main-article {\n  background: #222222;\n  color: #aaccd1 !important; }\n  .dark-theme-mono.main-article .text-editor,\n  .dark-theme-mono.main-article .headline,\n  .dark-theme-mono.main-article .abstract,\n  .dark-theme-mono.main-article .dateline input,\n  .dark-theme-mono.main-article .dateline select,\n  .dark-theme-mono.main-article input,\n  .dark-theme-mono.main-article .text-editor p {\n    color: #aaccd1 !important;\n    font-family: \"Roboto Mono\", Consolas, Courier, monospace; }\n  .dark-theme-mono.main-article .field label {\n    background: rgba(73, 73, 73, 0.7);\n    color: rgba(255, 255, 255, 0.6); }\n\n.dark-theme-mono .sderror {\n  border-bottom-color: #FF3D3D;\n  background-color: rgba(255, 61, 61, 0.25);\n  color: #222222 !important; }\n\n.dark-blue-theme.main-article {\n  background: #06356a;\n  color: white !important; }\n  .dark-blue-theme.main-article .text-editor,\n  .dark-blue-theme.main-article .headline,\n  .dark-blue-theme.main-article .abstract,\n  .dark-blue-theme.main-article .dateline input,\n  .dark-blue-theme.main-article .dateline select,\n  .dark-blue-theme.main-article input,\n  .dark-blue-theme.main-article .text-editor p {\n    color: white !important; }\n  .dark-blue-theme.main-article .field label {\n    background: rgba(73, 73, 73, 0.7);\n    color: rgba(255, 255, 255, 0.6); }\n\n.dark-blue-theme .sderror {\n  border-bottom-color: #FF3D3D;\n  background-color: rgba(255, 61, 61, 0.25);\n  color: #06356a !important; }\n\n.natural-theme.main-article {\n  background: #efe9c5;\n  color: #323232 !important; }\n  .natural-theme.main-article .text-editor,\n  .natural-theme.main-article .headline,\n  .natural-theme.main-article .abstract,\n  .natural-theme.main-article .dateline input,\n  .natural-theme.main-article .dateline select,\n  .natural-theme.main-article input {\n    color: #323232 !important; }\n\n.natural-theme .sderror {\n  color: #efe9c5 !important; }\n\n.dark-khaki-theme.main-article {\n  background: #949e5f;\n  color: #252818 !important; }\n  .dark-khaki-theme.main-article .text-editor,\n  .dark-khaki-theme.main-article .headline,\n  .dark-khaki-theme.main-article .abstract,\n  .dark-khaki-theme.main-article .dateline input,\n  .dark-khaki-theme.main-article .dateline select,\n  .dark-khaki-theme.main-article input {\n    color: #252818 !important; }\n\n.dark-khaki-theme .sderror {\n  color: #949e5f !important; }\n\n.dark-turquoise-theme.main-article {\n  background: darkturquoise;\n  color: #122235 !important; }\n  .dark-turquoise-theme.main-article .text-editor,\n  .dark-turquoise-theme.main-article .headline,\n  .dark-turquoise-theme.main-article .abstract,\n  .dark-turquoise-theme.main-article .dateline input,\n  .dark-turquoise-theme.main-article .dateline select,\n  .dark-turquoise-theme.main-article input {\n    color: #122235 !important; }\n\n.dark-turquoise-theme .sderror {\n  color: darkturquoise !important; }\n\n.pale-yellow-theme.main-article {\n  background: #f7fa98;\n  color: #323232 !important; }\n  .pale-yellow-theme.main-article .text-editor,\n  .pale-yellow-theme.main-article .headline,\n  .pale-yellow-theme.main-article .abstract,\n  .pale-yellow-theme.main-article .dateline input,\n  .pale-yellow-theme.main-article .dateline select,\n  .pale-yellow-theme.main-article input {\n    color: #323232 !important; }\n\n.pale-yellow-theme .sderror {\n  color: #f7fa98 !important; }\n", ""]);

// exports


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1578);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./history.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./history.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.history-list .item {\n  padding: 10px 5px;\n  border-bottom: 1px dotted #666; }\n  .history-list .item em {\n    color: #666;\n    font-size: 13px;\n    font-style: normal; }\n  .history-list .item b {\n    color: #3599b6;\n    font-weight: 400; }\n\n.history-list .more-description {\n  margin: 10px 10px; }\n\n.history-list .queued {\n  padding: 5px 15px; }\n  .history-list .queued a {\n    color: #666;\n    font-size: 13px;\n    font-style: normal; }\n\n.history-list .version {\n  color: #3599b6;\n  font-style: italic; }\n", ""]);

// exports


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1580);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./versions.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./versions.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.sd-widget.versioning .widget-content {\n  background: #f8f8f8; }\n\n.sd-widget.versioning .article-versions {\n  position: absolute;\n  left: 0;\n  top: 50px;\n  right: 0;\n  overflow: auto;\n  bottom: 0; }\n  .sd-widget.versioning .article-versions .versions-list {\n    padding: 12px; }\n    .sd-widget.versioning .article-versions .versions-list .item {\n      margin-bottom: 12px; }\n      .sd-widget.versioning .article-versions .versions-list .item .header {\n        font-size: 12px; }\n        .sd-widget.versioning .article-versions .versions-list .item .header .user {\n          float: right;\n          color: #888; }\n      .sd-widget.versioning .article-versions .versions-list .item .desk-details {\n        font-size: 11px; }\n      .sd-widget.versioning .article-versions .versions-list .item .footer {\n        font-size: 12px; }\n        .sd-widget.versioning .article-versions .versions-list .item .footer em {\n          color: #888; }\n        .sd-widget.versioning .article-versions .versions-list .item .footer .state-label {\n          float: none;\n          margin-left: 10px; }\n      .sd-widget.versioning .article-versions .versions-list .item h6 {\n        font-weight: 500;\n        font-size: 15px;\n        height: 18px;\n        color: #333;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        text-transform: none;\n        margin: 5px 0; }\n        .sd-widget.versioning .article-versions .versions-list .item h6.no-title {\n          color: #888;\n          font-weight: normal; }\n      .sd-widget.versioning .article-versions .versions-list .item .content {\n        font-size: 13px;\n        color: #555;\n        line-height: 20px;\n        max-height: 40px;\n        overflow: hidden; }\n      .sd-widget.versioning .article-versions .versions-list .item:hover {\n        cursor: pointer; }\n    .sd-widget.versioning .article-versions .versions-list.draft {\n      background: none;\n      border-color: #dfdfdf; }\n      .sd-widget.versioning .article-versions .versions-list.draft.selected {\n        background: #eff7fa; }\n      .sd-widget.versioning .article-versions .versions-list.draft .close {\n        margin-left: 5px; }\n", ""]);

// exports


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1582);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widgets-article.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./widgets-article.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.widget-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden; }\n  .widget-wrapper.active-left .page-content-container {\n    left: 388px; }\n  .widget-wrapper.active-left.left-extended .page-content-container {\n    left: 518px; }\n  .widget-wrapper.active-right .page-content-container {\n    right: 388px; }\n  .widget-wrapper.active-right.right-extended .page-content-container {\n    right: 518px; }\n\n.workqueue .widget-wrapper .right-tabpane {\n  bottom: 30px; }\n\n.tabpane .sd-widget {\n  width: auto;\n  height: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 0; }\n  .tabpane .sd-widget .widget-line {\n    display: none; }\n  .tabpane .sd-widget .widget-header {\n    height: 48px;\n    box-sizing: border-box; }\n    .tabpane .sd-widget .widget-header .widget-icon {\n      display: none; }\n    .tabpane .sd-widget .widget-header .widget-title {\n      left: 0;\n      line-height: 48px;\n      font-size: 16px;\n      padding: 0 10px;\n      right: 0; }\n  .tabpane .sd-widget .widget-settings {\n    top: 8px; }\n  .tabpane .sd-widget .widget-content {\n    background-color: #f8f8f8;\n    padding-bottom: 65px;\n    top: 47px;\n    border-top: 1px solid #e0e0e0;\n    margin-top: 0;\n    overflow: auto;\n    bottom: 0; }\n    .tabpane .sd-widget .widget-content fieldset {\n      padding: 10px; }\n      .tabpane .sd-widget .widget-content fieldset.fieldset--no-padding {\n        padding: 0; }\n      .tabpane .sd-widget .widget-content fieldset .btn-group.pull-left {\n        margin-left: 0; }\n    .tabpane .sd-widget .widget-content span.chevron {\n      background-color: #f8f8f8; }\n      .tabpane .sd-widget .widget-content span.chevron ~ h6 {\n        background-color: #f8f8f8; }\n    .tabpane .sd-widget .widget-content .nav-tabs {\n      padding: 0 10px;\n      background-color: #fff;\n      box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1); }\n    .tabpane .sd-widget .widget-content .widget-content-padding {\n      padding: 10px; }\n    .tabpane .sd-widget .widget-content .widget-header__action {\n      position: fixed;\n      top: 106px;\n      right: 61px;\n      z-index: 999; }\n  .tabpane .sd-widget.remove-header .widget-content {\n    top: 0; }\n", ""]);

// exports


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1584);
var svc = __importStar(__webpack_require__(1585));
var directive = __importStar(__webpack_require__(1595));
var ctrl = __importStar(__webpack_require__(246));
var filter = __importStar(__webpack_require__(1625));
__webpack_require__(1626);
var media_1 = __importDefault(__webpack_require__(1633));
var superdesk_ui_framework_1 = __webpack_require__(59);
var article_url_fields_1 = __webpack_require__(1640);
var PopulateAuthorsController_1 = __webpack_require__(1641);
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.authoring.autosave', []).service('autosave', svc.AutosaveService);
/**
 * @ngdoc module
 * @module superdesk.apps.authoring
 * @name superdesk.apps.authoring
 * @packageName superdesk.apps
 * @description Superdesk authoring application module.
 */
angular.module('superdesk.apps.authoring', [
    'superdesk.core.menu',
    'superdesk.core.activity',
    'superdesk.apps.authoring.widgets',
    'superdesk.apps.authoring.metadata',
    'superdesk.apps.authoring.translations',
    'superdesk.apps.authoring.comments',
    'superdesk.apps.authoring.track-changes.inline-comments',
    'superdesk.apps.authoring.track-changes.suggestions',
    'superdesk.apps.authoring.versioning',
    'superdesk.apps.authoring.versioning.versions',
    'superdesk.apps.authoring.versioning.history',
    'superdesk.apps.authoring.workqueue',
    'superdesk.apps.authoring.packages',
    'superdesk.apps.authoring.find-replace',
    'superdesk.apps.authoring.macros',
    'superdesk.apps.authoring.attachments',
    'superdesk.apps.authoring.autosave',
    'superdesk.apps.authoring.suggest',
    'superdesk.apps.desks',
    'superdesk.apps.notification',
    'superdesk.apps.vocabularies',
    'superdesk.apps.relations',
    'contenteditable',
    'decipher.history',
    'superdesk.config',
    media_1.default.name,
])
    .service('authoring', svc.AuthoringService)
    .service('confirm', svc.ConfirmDirtyService)
    .service('lock', svc.LockService)
    .service('authThemes', svc.AuthoringThemesService)
    .service('authoringWorkspace', svc.AuthoringWorkspaceService)
    .service('renditions', svc.RenditionsService)
    .service('mediaIdGenerator', svc.MediaIdGeneratorService)
    .factory('history', svc.HistoryFactory)
    .directive('html5vfix', directive.Html5vfix)
    .directive('sdDashboardCard', directive.DashboardCard)
    .directive('sdSendItem', directive.SendItem)
    .directive('sdCharacterCount', directive.CharacterCount)
    .directive('sdWordCount', directive.WordCount)
    .directive('sdReadingTime', directive.ReadingTime)
    .directive('sdThemeSelect', directive.ThemeSelectDirective)
    .directive('sdArticleEdit', directive.ArticleEditDirective)
    .directive('sdAuthoring', directive.AuthoringDirective)
    .directive('sdAuthoringTopbar', directive.AuthoringTopbarDirective)
    .directive('sdPreviewFormatted', directive.PreviewFormattedDirective)
    .directive('sdAuthoringContainer', directive.AuthoringContainerDirective)
    .directive('sdAuthoringEmbedded', directive.AuthoringEmbeddedDirective)
    .directive('sdAuthoringHeader', directive.AuthoringHeaderDirective)
    .directive('sdItemAssociation', directive.ItemAssociationDirective)
    .directive('sdItemCarousel', directive.ItemCarouselDirective)
    .directive('sdFullPreview', directive.FullPreviewDirective)
    .directive('sdRemoveTags', directive.RemoveTagsDirective)
    .directive('tansaScopeSync', directive.TansaScopeSyncDirective)
    .directive('sdItemActionByIntent', directive.ItemActionsByIntentDirective)
    .component('sdArticleUrlFields', superdesk_ui_framework_1.reactToAngular1(article_url_fields_1.ArticleUrlFields, ['label', 'urls', 'helperText', 'onChange', 'fieldId', 'editable']))
    .controller('PopulateAuthorsController', PopulateAuthorsController_1.PopulateAuthorsController)
    .filter('embeddedFilter', filter.EmbeddedFilter)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('authoring', {
            category: '/authoring',
            href: '/authoring/:_id',
            when: '/authoring/:_id',
            label: utils_1.gettext('Authoring'),
            templateUrl: 'scripts/apps/authoring/views/authoring.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: ctrl.AuthoringController,
            filters: [{ action: 'author', type: 'article' }],
            resolve: {
                item: ['$route', 'authoring', function ($route, authoring) {
                        return authoring.open($route.current.params._id, false);
                    }],
                action: [function () {
                        return 'edit';
                    }],
            },
            authoring: true,
        })
            .activity('edit.item', {
            label: utils_1.gettext('Edit'),
            priority: 10,
            icon: 'pencil',
            keyboardShortcut: 'ctrl+alt+e',
            controller: ['data', 'authoringWorkspace', function (data, authoringWorkspace) {
                    authoringWorkspace.edit(data.item ? data.item : data);
                }],
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'edit', type: 'item' },
            ],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).edit;
                }],
        })
            .activity('edit.item.popup', {
            label: utils_1.gettext('Edit in new Window'),
            priority: 5,
            icon: 'pencil',
            keyboardShortcut: 'ctrl+alt+n',
            controller: ['data', 'authoringWorkspace', function (data, authoringWorkspace) {
                    authoringWorkspace.popup(data.item, 'edit');
                }],
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', 'config', function (authoring, item, config) {
                    return authoring.itemActions(item).edit;
                }],
        })
            .activity('edit.media.metadata', {
            label: utils_1.gettext('Edit Media Metadata'),
            priority: 3,
            icon: 'edit-line',
            keyboardShortcut: 'ctrl+alt+m',
            controller: ['data', 'multiImageEdit', 'authoring', 'api',
                function (data, multiImageEdit, authoring, api) {
                    api.find('archive', data.item._id).then(function (item) {
                        multiImageEdit.edit([item], function (response) { return authoring.save(item, response[0]); });
                    });
                }],
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'edit', type: 'metadata' },
            ],
            additionalCondition: ['item', 'authoring', function (item, authoring) {
                    var mediaTypes = ['audio', 'picture', 'video'];
                    return mediaTypes.includes(item.type) && authoring.itemActions(item).edit;
                }],
        })
            .activity('move.item', {
            label: utils_1.gettext('Send to'),
            icon: 'share-alt',
            controller: ['data', 'send', function (data, send) {
                    send.allAs([data.item], 'send_to');
                }],
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', 'config', function (authoring, item, config) {
                    return authoring.itemActions(item).send && item.type !== 'composite';
                },
            ],
        })
            .activity('kill.text', {
            label: utils_1.gettext('Kill item'),
            priority: 100,
            icon: 'kill',
            group: 'corrections',
            controller: ['data', 'authoringWorkspace', 'api', '$rootScope',
                function (data, authoringWorkspace, api, $rootScope) {
                    if (data.item._type === 'archived') {
                        $rootScope.$broadcast('open:archived_kill', data.item, 'kill');
                    }
                    else {
                        authoringWorkspace.kill(data.item);
                    }
                },
            ],
            filters: [{ action: 'list', type: 'archive' }, { action: 'list', type: 'archived' }],
            additionalCondition: ['authoring', 'item', 'privileges', function (authoring, item, privileges) {
                    if (item._type === 'archived') {
                        return privileges.privileges.archived && item.type === 'text';
                    }
                    return authoring.itemActions(item).kill;
                }],
            privileges: { kill: 1 },
        })
            .activity('takedown.text', {
            label: utils_1.gettext('Takedown item'),
            priority: 100,
            icon: 'kill',
            group: 'corrections',
            controller: ['data', 'authoringWorkspace', 'api', '$rootScope',
                function (data, authoringWorkspace, api, $rootScope) {
                    if (data.item._type === 'archived') {
                        $rootScope.$broadcast('open:archived_kill', data.item, 'takedown');
                    }
                    else {
                        authoringWorkspace.takedown(data.item);
                    }
                },
            ],
            filters: [{ action: 'list', type: 'archive' }, { action: 'list', type: 'archived' }],
            additionalCondition: ['authoring', 'item', 'privileges', function (authoring, item, privileges) {
                    if (item._type === 'archived') {
                        return privileges.privileges.archived && item.type === 'text';
                    }
                    return authoring.itemActions(item).takedown;
                }],
            privileges: { takedown: 1 },
        })
            .activity('correct.text', {
            label: utils_1.gettext('Correct item'),
            priority: 100,
            icon: 'edit-line',
            group: 'corrections',
            controller: ['data', 'authoringWorkspace', function (data, authoringWorkspace) {
                    authoringWorkspace.correct(data.item);
                }],
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).correct;
                }],
            privileges: { correct: 1 },
        })
            .activity('view.item', {
            label: utils_1.gettext('Open'),
            priority: 2000,
            icon: 'external',
            keyboardShortcut: 'alt+o',
            controller: ['data', 'authoringWorkspace', function (data, authoringWorkspace) {
                    authoringWorkspace.view(data.item || data);
                }],
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'list', type: 'archived' },
                { action: 'list', type: 'legal_archive' },
                { action: 'view', type: 'item' },
            ],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).view;
                }],
        })
            .activity('view.item.popup', {
            label: utils_1.gettext('Open in new Window'),
            priority: 1990,
            icon: 'external',
            keyboardShortcut: 'ctrl+alt+n',
            controller: ['data', 'authoringWorkspace', function (data, authoringWorkspace) {
                    authoringWorkspace.popup(data.item, 'view');
                }],
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'list', type: 'archived' },
                { action: 'list', type: 'legal_archive' },
            ],
            additionalCondition: ['authoring', 'item', 'config', function (authoring, item, config) {
                    return authoring.itemActions(item).view;
                }],
        })
            .activity('edit.crop', {
            label: utils_1.gettext('Details'),
            modal: true,
            cssClass: 'modal--fullscreen modal--dark-ui',
            controller: ctrl.ChangeImageController,
            templateUrl: 'scripts/apps/authoring/views/change-image.html',
            filters: [{ action: 'edit', type: 'crop' }],
        })
            .activity('preview', {
            href: '/preview/:_id',
            when: '/preview/:_id',
            template: '<div sd-full-preview data-item="item"></div>',
            controller: ['$scope', 'item', function ($scope, item) {
                    $scope.item = item;
                }],
            resolve: {
                item: ['$route', 'api', function ($route, api) {
                        return api.find('archive', $route.current.params._id);
                    }],
            },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('move', {
            type: 'http',
            backend: {
                rel: 'move',
            },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('content_templates_apply', {
            type: 'http',
            backend: {
                rel: 'content_templates_apply',
            },
        });
    }])
    .run(['keyboardManager', 'gettext', function (keyboardManager) {
        keyboardManager.register('Authoring', 'ctrl + shift + u', utils_1.gettext('Unlock current item'));
        keyboardManager.register('Authoring', 'ctrl + shift + e', utils_1.gettext('Close current item'));
        keyboardManager.register('Authoring', 'ctrl + shift + s', utils_1.gettext('Save current item'));
        keyboardManager.register('Authoring', 'ctrl + shift + l', utils_1.gettext('Preview formatted article, when previewFormats feature configured'));
        keyboardManager.register('Authoring', 'ctrl + shift + y', utils_1.gettext('Instant Spellchecking, when automatic spellchecking turned off'));
    }]);


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

/*global angular*/

/**
 * @ngdoc overview
 * @name decipher.history
 * @description
 * A history service for AngularJS.  Undo/redo, that sort of thing.  Has nothing to do with the "back" button, unless you want it to.
 *
 */
(function () {
  'use strict';

  var DEEPWATCH_EXP = /^\s*(.*?)\s+for\s+(?:([\$\w][\$\w\d]*)|(?:\(\s*([\$\w][\$\w\d]*)\s*,\s*([\$\w][\$\w\d]*)\s*\)))\s+in\s+(.*?)$/,
    DEFAULT_TIMEOUT = 1000,
    lazyBindFound = false,
    isDefined = angular.isDefined,
    isUndefined = angular.isUndefined,
    isFunction = angular.isFunction,
    isArray = angular.isArray,
    isString = angular.isString,
    isObject = angular.isObject,
    forEach = angular.forEach,
    copy = angular.copy,
    bind = angular.bind;

  /**
   * Polyfill for Object.keys
   *
   * @see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/Object/keys
   */
  if (!Object.keys) {
    Object.keys = (function () {
      var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

      return function (obj) {
        if (typeof obj !== 'object' && typeof obj !== 'function' ||
          obj === null) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [];

        for (var prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (var i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj,
              dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    })();
  }

  // stub out lazyBind if we don't have it.
  try {
    angular.module('lazyBind');
    lazyBindFound = true;
  }
  catch (e) {
    angular.module('lazyBind', []).factory('$lazyBind', function() {return angular.noop});
  }

  /**
   * @ngdoc service
   * @name decipher.history.service:History
   * @description
   * Provides an API for keeping a history of model values.
   */
  angular.module('decipher.history', ['lazyBind']).service('History',
    [
      '$parse',
      '$rootScope',
      '$interpolate',
      '$lazyBind',
      '$timeout',
      '$log',
      '$injector',
    function ($parse, $rootScope, $interpolate, $lazyBind, $timeout, $log,
      $injector) {
      var service = this,
        history = {},
        pointers = {},
        watches = {},
        watchObjs = {},
        lazyWatches = {},
        descriptions = {},
      // TODO: async safe?
        batching = false, // whether or not we are currently in a batch
        deepWatchId = 0; // incrementing ID of deep {@link decipher.history.object:Watch Watch instance}s

      /**
       * @ngdoc object
       * @name decipher.history.object:Watch
       * @overview
       * @constructor
       * @description
       * An object instance that provides several methods for executing handlers after
       * certain changes have been made.
       *
       * Each function return the `Watch` instance, so you can chain the calls.
       *
       * See the docs for {@link decipher.history.service:History#deepWatch History.deepWatch()} for an example of using these functions.
       *
       * @todo ability to remove all handlers at once, or all handlers of a certain type
       */
      var Watch = function Watch(exp, scope) {
        this.exp = exp;
        this.scope = scope || $rootScope;

        this.$handlers = {
          $change : {},
          $undo : {},
          $rollback : {},
          $redo : {},
          $revert : {},
        };

        this.$ignores = {};
      };

      /**
       * @description
       * Helper method for the add*Handler functions.
       * @param {string} where Type of handler, corresponds to object defined in constructor
       * @param {string} name Name of handler to be supplied by user
       * @param {Function} fn Handler function to execute
       * @param {Object} resolve Mapping of function parameters to values
       * @private
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype._addHandler =
        function _addHandler(where, name, fn, resolve) {
          if (!where || !name || !fn) {
            throw new Error('invalid parameters to _addHandler()');
          }
          this.$handlers[where][name] = {
            fn: fn,
            resolve: resolve || {}
          };
          return this;
        };

      /**
       * @description
       * Helper method for remove*Handler functions.
       * @param {string} where Type of handler, corresponds to object defined in constructor
       * @param {string} name Name of handler to be supplied by user
       * @private
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype._removeHandler = function (where, name) {
        if (!name) {
          throw new Error('invalid parameters to _removeHandler()');
        }
        delete this.$handlers[where][name];
        return this;
      };

      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#addChangeHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Unique name of handler
       * @param {Function} fn Function to execute upon change
       * @param {object} resolve Mapping of function parameters to values
       * @description
       * Adds a change handler function with name `name` to be executed
       * whenever a value matching this watch's expression changes (is archived).
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype.addChangeHandler =
        function addChangeHandler(name, fn, resolve) {
          if (!name || !fn) {
            throw new Error('invalid parameters');
          }
          return this._addHandler('$change', name, fn, resolve);
        };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#addUndoHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Unique name of handler
       * @param {Function} fn Function to execute upon change
       * @param {object} resolve Mapping of function parameters to values
       * @description
       * Adds an undo handler function with name `name` to be executed
       * whenever a value matching this watch's expression is undone.
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype.addUndoHandler =
        function addUndoHandler(name, fn, resolve) {
          if (!name || !fn) {
            throw new Error('invalid parameters');
          }
          return this._addHandler('$undo', name, fn, resolve);
        };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#addRedoHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Unique name of handler
       * @param {Function} fn Function to execute upon change
       * @param {object} resolve Mapping of function parameters to values
       * @description
       * Adds a redo handler function with name `name` to be executed
       * whenever a value matching this watch's expression is redone.
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype.addRedoHandler =
        function addRedoHandler(name, fn, resolve) {
          if (!name || !fn) {
            throw new Error('invalid parameters');
          }
          return this._addHandler('$redo', name, fn, resolve);
        };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#addRevertHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Unique name of handler
       * @param {Function} fn Function to execute upon change
       * @param {object} resolve Mapping of function parameters to values
       * @description
       * Adds a revert handler function with name `name` to be executed
       * whenever a value matching this watch's expression is reverted.
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype.addRevertHandler =
        function addRevertHandler(name, fn, resolve) {
          if (!name || !fn) {
            throw new Error('invalid parameters');
          }
          return this._addHandler('$revert', name, fn, resolve);
        };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#addRollbackHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Unique name of handler
       * @param {Function} fn Function to execute upon change
       * @param {object} resolve Mapping of function parameters to values
       * @description
       * Adds a rollback handler function with name `name` to be executed
       * whenever the batch tied to this watch is rolled back.
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       */
      Watch.prototype.addRollbackHandler =
        function addRollbackHandler(name, fn, resolve) {
          if (!name || !fn) {
            throw new Error('invalid parameters');
          }
          return this._addHandler('$rollback', name, fn, resolve);
        };

      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#removeRevertHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Name of handler to remove
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       * @description
       * Removes a revert handler with name `name`.
       */
      Watch.prototype.removeRevertHandler = function removeRevertHandler(name) {
        if (!name) {
          throw new Error('invalid parameters');
        }
        return this._removeHandler('$revert', name);
      };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#removeChangeHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Name of handler to remove
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       * @description
       * Removes a change handler with name `name`.
       */
      Watch.prototype.removeChangeHandler = function removeChangeHandler(name) {
        if (!name) {
          throw new Error('invalid parameters');
        }
        return this._removeHandler('$change', name);
      };
      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#removeUndoHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Name of handler to remove
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       * @description
       * Removes a undo handler with name `name`.
       */
      Watch.prototype.removeUndoHandler = function removeUndoHandler(name) {
        if (!name) {
          throw new Error('invalid parameters');
        }
        return this._removeHandler('$undo', name);
      };

      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#removeRollbackHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Name of handler to remove
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       * @description
       * Removes a rollback handler with name `name`.
       */
      Watch.prototype.removeRollbackHandler =
        function removeRollbackHandler(name) {
          return this._removeHandler('$rollback', name);
        };

      /**
       * @ngdoc function
       * @name decipher.history.object:Watch#removeRedoHandler
       * @methodOf decipher.history.object:Watch
       * @method
       * @param {string} name Name of handler to remove
       * @returns {Watch} This {@link decipher.history.object:Watch Watch instance}
       * @description
       * Removes a redo handler with name `name`.
       */
      Watch.prototype.removeRedoHandler =
        function removeRedoHandler(name) {
          if (!name) {
            throw new Error('invalid parameters');
          }
          return this._removeHandler('$redo', name);
        };

      /**
       * Fires all handlers for a particular type, optionally w/ a scope.
       * @param {string} where Watch type
       * @param {string} exp Expression
       * @param {Scope} [scope] Optional Scope
       * @private
       */
      Watch.prototype._fireHandlers =
        function _fireHandlers(where, exp, scope) {
          var hasScope = isDefined(scope),
            localScope = this.scope, that = this;
          forEach(this.$handlers[where], function (handler) {
            var locals = {
              $locals: localScope
            };
            if (isDefined(scope)) {
              locals.$locals = scope;
            }
            if (isDefined(exp)) {
              locals.$expression = exp;
            }
            forEach(handler.resolve, function (value, key) {
              if (hasScope) {
                locals[key] = $parse(value)(scope);
              } else {
                locals[key] = value;
              }
            });
            $injector.invoke(handler.fn, scope || that, locals);
          });
        };

      /**
       * Fires the change handlers
       * @param {Scope} scope Scope
       * @param {string} exp Expression
       * @private
       */
      Watch.prototype._fireChangeHandlers =
        function _fireChangeHandlers(exp, scope) {
          this._fireHandlers('$change', exp, scope);
        };

      /**
       * Fires the undo handlers
       * @param {Scope} scope Scope
       * @param {string} exp Expression
       * @private
       */
      Watch.prototype._fireUndoHandlers =
        function _fireUndoHandlers(exp, scope) {
          this._fireHandlers('$undo', exp, scope);
        };

      /**
       * Fires the redo handlers
       * @param {Scope} scope Scope
       * @param {string} exp Expression
       * @private
       */
      Watch.prototype._fireRedoHandlers =
        function _fireRedoHandlers(exp, scope) {
          this._fireHandlers('$redo', exp, scope);
        };

      /**
       * Fires the revert handlers
       * @param {Scope} scope Scope
       * @param {string} exp Expression
       * @private
       */
      Watch.prototype._fireRevertHandlers =
        function _fireRevertHandlers(exp, scope) {
          this._fireHandlers('$revert', exp, scope);
        };

      /**
       * Fires the rollback handlers (note lack of scope and expression)
       * @private
       */
      Watch.prototype._fireRollbackHandlers =
        function _fireRollbackHandlers() {
          this._fireHandlers('$rollback');
        };

      /**
       * Decline to broadcast an event for this Watch.
       * @param {string} eventName Name of event to avoid.  i.e. "History.archived"
       * @param {Function=} callback Optional callback
       * @param {Object=} resolve Optional mapping of parameters to invoke
       * the callback with.
       * @returns {Watch} this Watch object
       */
      Watch.prototype.ignoreEvent =
        function ignoreEvent(eventName, callback, resolve) {
          // special case; we cannot ignore History.archived within a Watch obj
          // created from a batch.  there may be a way around this.
          if (this.exp === null && eventName === 'History.archived') {
            $log.warn('cannot ignore History.archived event for batch');
            return this;
          }
          resolve = resolve || {};
          if (isFunction(callback)) {
            this.$ignores[eventName] = {
              callback: callback,
              resolve: resolve
            };
          } else if (isDefined(callback)) {
            this.$ignores[eventName] = {
              callback: function cb() {
                return callback;
              },
              resolve: resolve
            };
          }
          return this;
        };

      /**
       * Broadcasts an event, taking ignored events into account.
       * @param {string} eventName Event to broadcast
       * @param {*} data Some data to pass
       * @private
       */
      Watch.prototype._broadcast = function _broadcast(eventName, data) {
        var ignore = this.$ignores[eventName];
        if (!ignore ||
          (isFunction(ignore.callback) &&
            !$injector.invoke(ignore.callback, this.scope, angular.extend(ignore.resolve, {$data: data})))) {
          $rootScope.$broadcast(eventName, data);
        }
      };

      /**
       * Undoes last change against this watch object's target.
       */
      Watch.prototype.undo = function undo() {
        if (this.exp === null) {
          $log.warn("attempt to undo a batch; use rollback() instead");
          return;
        }
        service.undo(this.exp, this.scope);
      };

      /**
       * Redoes last undo against this watch object's target.
       */
      Watch.prototype.redo = function redo() {
        if (this.exp === null) {
          $log.warn("attempt to redo a batch; just execute the batch callback again");
        }
        service.redo(this.exp, this.scope);
      };

      /**
       * Reverts this target's watch object.
       * @param {number=0} pointer Pointer to revert to
       */
      Watch.prototype.revert = function revert(pointer) {
        if (this.exp === null) {
          $log.warn("attempt to revert a batch; use rollback() instead");
        }
        service.revert(this.exp, this.scope, pointer);
      };

      /**
       * Whether or not you may undo this watch object's target
       * @returns {boolean}
       */
      Watch.prototype.canUndo = function canUndo() {
        return this.exp === null ? false :
               service.canUndo(this.exp, this.scope);
      };

      /**
       * Whether or not you may redo this watch object's target
       * @returns {boolean}
       */
      Watch.prototype.canRedo = function canRedo() {
        return this.exp === null ? false :
               service.canRedo(this.exp, this.scope);
      };

      /**
       * Evaluates an expression on the scope lazily.  That means it will return
       * a new value every DEFAULT_TIMEOUT ms at maximum, even if you change it between
       * now and then.  This allows us to $broadcast at an interval instead of after
       * every scope change.
       * @param {Object} scope AngularJS Scope
       * @param {string} exp AngularJS expression to evaluate
       * @param {number} [timeout=DEFAULT_TIMEOUT] How often to change the value
       * @returns {Function}
       */
      var lazyWatch = function lazyWatch(scope, exp, timeout) {
        var bind = $lazyBind(scope);
        bind.cacheTime(timeout || DEFAULT_TIMEOUT);

        /**
         * This is the "expression function" we use to $watch with.  You normally
         * $watch a string, but you can also watch a function, and this is one of
         * those functions.  This is where the actual lazy evaluation happens.
         */
        return function () {
          return bind.call(scope, exp);
        };
      };

      /**
       * Initializes object stores for a Scope id
       * @param {string} id Sccope id
       * @private
       */
      this._initStores = function _initStores(id) {
        if (isUndefined(watches[id])) {
          watches[id] = {};
        }
        if (isUndefined(lazyWatches[id])) {
          lazyWatches[id] = {};
        }
        if (isUndefined(descriptions[id])) {
          descriptions[id] = {};
        }
        if (isUndefined(history[id])) {
          history[id] = {};
        }
        if (isUndefined(watchObjs[id])) {
          watchObjs[id] = {};
        }
        if (isUndefined(pointers[id])) {
          pointers[id] = {};
        }
      };

      /**
       * When an expression changes, store the information about it
       * and increment a pointer.
       * @param {string|Function} exp Expression
       * @param {string} id Scope $id
       * @param {Scope} locals AngularJS scope
       * @param {boolean} pass Whether or not to pass on the first call
       * @param {string} description AngularJS string to interpolate
       * @return {Function} Watch function
       * @private
       */
      this._archive = function (exp, id, locals, pass, description) {
        var _initStores = this._initStores;
        return function (newVal, oldVal) {
          var watchObj;
          _initStores(id);
          if (description) {
            descriptions[id][exp] = $interpolate(description)(locals);
          }
          if (pass) {
            pass = false;
            return;
          }
          if (isUndefined(history[id][exp])) {
            history[id][exp] = [];
          }
          if (isUndefined(pointers[id][exp])) {
            pointers[id][exp] = 0;
          }
          history[id][exp].splice(pointers[id][exp] + 1);
          history[id][exp].push(copy(newVal));
          pointers[id][exp] = history[id][exp].length - 1;
          if (pointers[id][exp] > 0 && isDefined(watchObjs[id]) &&
            isDefined(watchObj = watchObjs[id][exp])) {
            if (!batching) {
              watchObj._fireChangeHandlers(exp, locals);
            }
            watchObj._broadcast('History.archived', {
              expression: exp,
              newValue: newVal,
              oldValue: oldVal,
              description: descriptions[id][exp],
              locals: locals
            });
          }
        };
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#watch
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Register some expression(s) for watching.
       * @param {string|string[]} exps Array of expressions or one expression as a string
       * @param {Scope=} scope Scope; defaults to `$rootScope`
       * @param {string=} description Description of this change
       * @param {Object=} lazyOptions Options for lazy loading.  Only valid
       * property is `timeout` at this point
       * @returns {Watch|Array} {@link decipher.history.object:Watch Watch instance} or array of them
       *
       * @example
       * <example module="decipher.history">
       <file name="script.js">

       angular.module('decipher.history')
       .run(function(History, $rootScope) {
            $rootScope.foo = 'foo';

            $rootScope.$on('History.archived', function(evt, data) {
              $rootScope.message = data.description;
            });

            History.watch('foo', $rootScope, 'you changed the foo');
        });
       </file>
       <file name="index.html">
       <input type="text" ng-model="foo"/> {{foo}}<br/>
       <span ng-show="message">{{message}}</span><br/>
       </file>
       </example>
       */
      this.watch = function watch(exps, scope, description, lazyOptions) {
        if (isUndefined(exps)) {
          throw new Error('expression required');
        }
        scope = scope || $rootScope;
        description = description || '';
        var i,
          id = scope.$id,
          exp,
          objs = [],
          watchObj,
          model;

        if (!isArray(exps)) {
          exps = [exps];
        }

        this._initStores(id);

        i = exps.length;
        while (i--) {
          exp = exps[i];

          // assert we have an assignable model
          model = $parse(exp);
          if (isUndefined(model.assign)) {
            throw 'expression "' + exp +
              '" is not an assignable expression';
          }

          // blast any old watches
          if (isFunction(watches[id][exp])) {
            watches[id][exp]();
          }

          descriptions[id][exp] = $interpolate(description)(scope);

          this._watch(exp, scope, false, lazyOptions);
          watchObjs[id][exp] = watchObj = new Watch(exp, scope);
          objs.push(watchObj);
        }

        return objs.length > 1 ? objs : objs[0];
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#deepWatch
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Allows you to watch an entire array/object full of objects, but only watch
       * a certain property of each object.
       *
       * @example
       * <example module="decipher.history">
       <file name="script.js">
       angular.module('decipher.history')
       .run(function(History, $rootScope) {
            var exp, locals;

            $rootScope.foos = [
              {id: 1, name: 'herp'},
              {id: 2, name: 'derp'}
            ];

            $rootScope.$on('History.archived', function(evt, data) {
              $rootScope.message = data.description;
              exp = data.expression;
              locals = data.locals;
            })

            History.deepWatch('foo.name for foo in foos', $rootScope,
              'Changed {{foo.id}} to name "{{foo.name}}"')
              .addChangeHandler('myChangeHandler', function($expression,
                  $locals, foo) {
                console.log(foo);
                console.log("(totally hit the server and update the model)");
                $rootScope.undo = function() {
                  History.undo($expression, $locals);
                };
                $rootScope.canUndo = function() {
                  return History.canUndo($expression, $locals);
                };
              }, {foo: 'foo'});
          });
       </file>
       <file name="index.html">
       <input type="text" ng-model="foos[0].name"/> {{foos[0].name}}<br/>
       <span ng-show="message">{{message}}</span><br/>
       <button ng-disabled="!canUndo()" ng-click="undo()">Undo!</button>
       </file>
       </example>
       * @param {(string|string[])} exp Expression or array of expressions to watch
       * @param {Scope=} scope Scope; defaults to `$rootScope`
       * @param {string=} description Description of this change
       * @param {Object=} lazyOptions Options for lazy loading.  Only valid
       * property is `timeout` at this point
       * @return {Watch} {@link decipher.history.object:Watch Watch instance}
       */
      this.deepWatch =
        function deepWatch(exp, scope, description, lazyOptions) {
          var match,
            targetName,
            valueFn,
            keyName,
            value,
            valueName,
            valuesName,
            watchObj,
            id = scope.$id,
            _clear = bind(this, this._clear),
            _initStores = this._initStores,
            _archive = bind(this, this._archive),
            createDeepWatch = function createDeepWatch(targetName, valueName,
              keyName, watchObj) {
              return function (values) {
                forEach(values, function (v, k) {

                  var locals = scope.$new(),
                    id = locals.$id;
                  locals.$$deepWatchId = scope.$$deepWatch[targetName];
                  locals.$$deepWatchTargetName = targetName;
                  locals[valueName] = v;
                  if (keyName) {
                    locals[keyName] = k;
                  }
                  value = valueFn(scope, locals);

                  _initStores(id);

                  descriptions[id][exp] = $interpolate(description)(locals);

                  if (isFunction(watches[id][targetName])) {
                    watches[id][targetName]();
                  }

                  if (lazyBindFound && isObject(lazyOptions)) {
                    watches[id][targetName] =
                      locals.$watch(lazyWatch(locals, targetName,
                        lazyOptions.timeout || 500),
                        _archive(targetName, id, locals, false, description),
                        true);
                    lazyWatches[id][targetName] = true;
                  }
                  else {
                    watches[id][targetName] = locals.$watch(targetName,
                      _archive(targetName, id, locals, false, description),
                      true);
                    lazyWatches[id][targetName] = false;
                  }

                  watchObjs[id][targetName] = watchObj;

                  locals.$on('$destroy', function () {
                    _clear(scope);
                  });

                });

              };
            };

          description = description || '';
          if (!(match = exp.match(DEEPWATCH_EXP))) {
            throw 'expected expression in form of "_select_ for (_key_,)? _value_ in _collection_" but got "' +
              exp + '"';
          }
          targetName = match[1];
          valueName = match[4] || match[2];
          valueFn = $parse(valueName);
          keyName = match[3];
          valuesName = match[5];

          if (isUndefined(scope.$$deepWatch)) {
            scope.$$deepWatch = {};
          }

          // if we already have a deepWatch on this value, we
          // need to kill all the child scopes. because reasons
          if (isDefined(scope.$$deepWatch[targetName])) {
            _clear(scope, targetName);
          }
          scope.$$deepWatch[targetName] = ++deepWatchId;

          _initStores(id);
          watchObjs[id][targetName] = watchObj = new Watch(targetName, scope);

          // TODO: assert this doesn't leak memory like crazy. it might if
          // we remove things from the values context.
          watches[id][targetName] = scope.$watchCollection(valuesName,
            createDeepWatch(targetName, valueName, keyName,
              watchObj));

          return watchObj;
        };

      /**
       * Clears a bunch of information for a scope and optionally an array of expressions.
       * Lacking an expression, this will eliminate an entire scopesworth of data.
       * It will recognize deep watches and clear them out completely.
       * @param {Scope} scope Scope obj
       * @param {(string|string[])} exps Expression or array of expressions
       * @private
       */
      this._clear = function _clear(scope, exps) {
        var id = scope.$id,
          i,
          nextSibling,
          exp,
          clear = function clear(id, key) {
            var zap = function zap(what) {
              if (isDefined(what[id][key])) {
                delete what[id][key];
                if (Object.keys(what[id]).length === 0) {
                  delete what[id];
                }
              }
            };

            if (isDefined(watches[id]) &&
              isFunction(watches[id][key])) {
              watches[id][key]();
            }
            if (isDefined(watches[id])) {
              zap(watches);
            }
            if (isDefined(watchObjs[id])) {
              zap(watchObjs);
            }
            if (isDefined(history[id])) {
              zap(history);
            }
            if (isDefined(pointers[id])) {
              zap(pointers);
            }
            if (isDefined(lazyWatches[id])) {
              zap(lazyWatches);
            }
          },

          clearAll = function clearAll(id) {
            forEach(watches[id], function (watch) {
              return isFunction(watch) && watch();
            });
            delete watches[id];
            delete history[id];
            delete pointers[id];
            delete lazyWatches[id];
            delete watchObjs[id];
          };

        if (isString(exps)) {
          exps = [exps];
        }
        else if (isUndefined(exps) && isDefined(watches[id])) {
          exps = Object.keys(watches[id]);
        }

        if (isDefined(exps)) {
          i = exps.length;
          while (i--) {
            exp = exps[i];
            clear(id, exp);
          }
        } else {
          clearAll(id);
        }
        nextSibling = scope.$$childHead;
        while (nextSibling) {
          this._clear(nextSibling, exp);
          nextSibling = nextSibling.$$nextSibling;
        }
      };


      /**
       * @ngdoc function
       * @name decipher.history.service:History#forget
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Unregister some watched expression(s).
       * @param {(string|string[])} exps Array of expressions or one expression as a string
       * @param {Scope=} scope Scope object; defaults to $rootScope
       */
      this.forget = function forget(scope, exps) {
        scope = scope || $rootScope;
        if (isDefined(exps) && isString(exps)) {
          exps = [exps];
        }
        this._clear(scope, exps);
      };

      /**
       * Internal function to change some value in the stack to another.
       * Kills the watch and then calls `_watch()` to restore it.
       * @param {Scope} scope Scope object
       * @param {string} exp AngularJS expression
       * @param {array} stack History stack; see `History.history`
       * @param {number} pointer Pointer
       * @returns {{oldValue: {*}, newValue: {*}}} The old value and the new value
       * @private
       */
      this._do = function _do(scope, exp, stack, pointer) {
        var model,
          oldValue,
          id = scope.$id;
        if (isFunction(watches[id][exp])) {
          watches[id][exp]();
          delete watches[id][exp];
        }
        model = $parse(exp);
        oldValue = model(scope);
        // todo: assert there's no bug here with unassignable expressions
        model.assign(scope, copy(stack[pointer]));
        this._watch(exp, scope, true);
        return {
          oldValue: oldValue,
          newValue: model(scope)
        };
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#undo
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Undos an expression to last known value.
       * @param {string} exp Expression to undo
       * @param {Scope=} scope Scope; defaults to `$rootScope`
       */
      this.undo = function undo(exp, scope) {
        scope = scope || $rootScope;
        if (isUndefined(exp)) {
          throw new Error('expression required');
        }
        var id = scope.$id,
          scopeHistory = history[id],
          stack,
          values,
          pointer,
          watchObj;

        if (isUndefined(scopeHistory)) {
          throw 'could not find history for scope ' + id;
        }

        stack = scopeHistory[exp];
        if (isUndefined(stack)) {
          throw 'could not find history in scope "' + id +
            ' against expression "' + exp + '"';
        }
        pointer = --pointers[id][exp];
        if (pointer < 0) {
          $log.warn('attempt to undo past history');
          pointers[id][exp]++;
          return;
        }
        values = this._do(scope, exp, stack, pointer);
        if (isDefined(watchObjs[id]) &&
          isDefined(watchObjs[id][exp])) {
          watchObj = watchObjs[id][exp];
          watchObj._fireUndoHandlers(exp, scope);
          watchObj._broadcast('History.undone', {
            expression: exp,
            newValue: values.newValue,
            oldValue: values.oldValue,
            description: descriptions[id][exp],
            scope: scope
          });
        }
      };

      /**
       * Actually issues the appropriate scope.$watch
       * @param {string} exp Expression
       * @param {Scope=} scope Scope; defaults to $rootScope
       * @param {boolean=} pass Whether or not to skip the first watch execution.  Defaults to false
       * @param {Object} lazyOptions Options to send the lazy module
       * @private
       */
      this._watch = function _watch(exp, scope, pass, lazyOptions) {
        var id;
        scope = scope || $rootScope;
        pass = pass || false;
        id = scope.$id;

        // do we have an array or object?
        if (lazyBindFound && (isObject(lazyOptions) ||
          (lazyWatches[id] && !!lazyWatches[id][exp]))) {
          watches[id][exp] =
            scope.$watch(lazyWatch(scope, exp, lazyOptions.timeout),
              bind(this, this._archive(exp, id, scope, pass)), true);
          lazyWatches[id][exp] = true;
        }
        else {
          watches[id][exp] =
            scope.$watch(exp, bind(this, this._archive(exp, id, scope, pass)),
              true);
          lazyWatches[id][exp] = false;
        }

      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#redo
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Redoes (?) the last undo.
       * @param {string} exp Expression to redo
       * @param {Scope=} scope Scope; defaults to `$rootScope`
       */
      this.redo = function redo(exp, scope) {
        scope = scope || $rootScope;
        var id = scope.$id,
          stack = history[id][exp],
          values,
          pointer,
          watchObj;

        if (isUndefined(stack)) {
          throw 'could not find history in scope "' + id +
            ' against expression "' + exp + '"';
        }
        pointer = ++pointers[id][exp];
        if (pointer === stack.length) {
          $log.warn('attempt to redo past history');
          pointers[id][exp]--;
          return;
        }

        values = this._do(scope, exp, stack, pointer);

        if (isDefined(watchObjs[id]) &&
          isDefined(watchObjs[id][exp])) {
          watchObj = watchObjs[id][exp];
          watchObj._fireRedoHandlers(exp, scope);
          watchObj._broadcast('History.redone', {
            expression: exp,
            oldValue: copy(values.newValue),
            newValue: copy(values.oldValue),
            description: descriptions[id][exp],
            scope: scope
          });
        }
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#canUndo
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Whether or not we have accumulated any history for a particular expression.
       * @param {string} exp Expression
       * @param {Scope=} scope Scope; defaults to $rootScope
       * @return {boolean} Whether or not you can issue an `undo()`
       * @example
       * <example module="decipher.history">
       <file name="script.js">
       angular.module('decipher.history').run(function(History, $rootScope) {
              $rootScope.foo = 'bar';
              History.watch('foo');
              $rootScope.canUndo = History.canUndo;
            });
       </file>
       <file name="index.html">
       <input type="text" ng-model="foo"/>  Can undo?  {{canUndo('foo')}}
       </file>
       </example>
       */
      this.canUndo = function canUndo(exp, scope) {
        var id;
        scope = scope || $rootScope;
        id = scope.$id;
        return isDefined(pointers[id]) &&
          isDefined(pointers[id][exp]) &&
          pointers[id][exp] > 0;
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#canRedo
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Whether or not we can redo an expression's value.
       * @param {string} exp Expression
       * @param {Scope=} scope Scope; defaults to $rootScope
       * @return {Boolean} Whether or not you can issue a `redo()`
       * @example
       * <example module="decipher.history">
       <file name="script.js">
       angular.module('decipher.history').run(function(History, $rootScope) {
              $rootScope.foo = 'bar';
              History.watch('foo');
              $rootScope.canRedo = History.canRedo;
              $rootScope.canUndo = History.canUndo;
              $rootScope.undo = History.undo;
            });
       </file>
       <file name="index.html">
       <input type="text" ng-model="foo"/> <br/>
       <button ng-show="canUndo('foo')" ng-click="undo('foo')">Undo</button><br/>
       Can redo?  {{canRedo('foo')}}
       </file>
       </example>
       */
      this.canRedo = function canRedo(exp, scope) {
        var id;
        scope = scope || $rootScope;
        id = scope.$id;
        return isDefined(pointers[id]) &&
          isDefined(pointers[id][exp]) &&
          pointers[id][exp] < history[id][exp].length - 1;
      };

      /**
       * @ngdoc function
       * @method
       * @methodOf decipher.history.service:History
       * @name decipher.history.service:History#revert
       * @description
       * Reverts to earliest known value of some expression, or at a particular
       * pointer if you please.
       * @param {string} exp Expression
       * @param {Scope=} scope Scope; defaults to $rootScope
       * @param {number=} pointer Optional; defaults to 0
       */
      this.revert = function (exp, scope, pointer) {
        scope = scope || $rootScope;
        pointer = pointer || 0;
        var id = scope.$id,
          stack = history[id][exp],
          values,
          watchObj;

        if (isUndefined(stack)) {
          $log.warn('nothing to revert');
          return;
        }
        values = this._do(scope, exp, stack, pointer);

        // wait; what is this?
        history[id][exp].splice();
        pointers[id][exp] = pointer;

        if (isDefined(watchObjs[id]) &&
          isDefined(watchObjs[id][exp])) {
          watchObj = watchObjs[id][exp];
          watchObj._fireRevertHandlers(exp, scope);
          watchObj._broadcast('History.reverted', {
            expression: exp,
            oldValue: copy(values.newValue),
            newValue: copy(values.oldValue),
            description: descriptions[id][exp],
            scope: scope,
            pointer: pointer
          });
        }
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#batch
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Executes a function within a batch context which can then be rolled back.
       * @param {function} fn Function to execute
       * @param {Scope=} scope Scope object; defaults to `$rootScope`
       * @param {string=} description Description of this change
       * @returns {Watch} {@link decipher.history.object:Watch Watch instance}
       * @example
       <example module="decipher.history">
       <file name="script.js">
       angular.module('decipher.history').run(function(History, $rootScope) {
              var t;

              $rootScope.herp = 'derp';
              $rootScope.bar = 'baz';
              $rootScope.frick = 'frack';

              $rootScope.$on('History.batchEnded', function(evt, data) {
                t = data.transaction;
              });

              History.watch('herp');
              History.watch('bar');
              History.watch('frick');

              $rootScope.batch = function() {
                History.batch(function() {
                  $rootScope.herp = 'derp2';
                  $rootScope.bar = 'baz2';
                  $rootScope.frick = 'frack2';
                })
                  .addRollbackHandler('myRollbackHandler', function() {
                    $rootScope.message = 'rolled a bunch of stuff back';
                  });
                $rootScope.message = "batch complete";
              };

              $rootScope.rollback = function() {
                if (isDefined(t)) {
                  History.rollback(t);
                }
              };
            });
       </file>
       <file name="index.html">
       <ul>
       <li>herp: {{herp}}</li>
       <li>bar: {{bar}}</li>
       <li>frick: {{frick}}</li>
       </ul>
       <button ng-click="batch()">Batch</button>
       <button ng-click="rollback()">Rollback</button><br/>
       {{message}}
       </file>
       </example>
       */
      this.batch = function batch(fn, scope, description) {
        var _clear = bind(this, this._clear),
          _initStores = this._initStores,
          listener,
          watchObj,
          child;
        scope = scope || $rootScope;
        if (!isFunction(fn)) {
          throw new Error('transaction requires a function');
        }

        child = scope.$new();
        child.$on('$destroy', function () {
          _clear(child);
        });

        listener = scope.$on('History.archived', function (evt, data) {
          var deepChild,
            exp = data.expression,
            id;
          if (data.locals.$id !== child.$id) {
            deepChild = child.$new();
            deepChild.$on('$destroy', function () {
              _clear(deepChild);
            });
            deepChild.$$locals = data.locals;
            id = deepChild.$id;
            _initStores(id);
            history[id][exp] =
              copy(history[data.locals.$id][exp]);
            pointers[id][exp] = pointers[data.locals.$id][exp] - 1;
          }
        });

        watchObjs[child.$id] = watchObj = new Watch(null, child);
        watchObj._broadcast('History.batchBegan', {
          transaction: child,
          description: description
        });

        // we need to put this into a timeout and apply manually
        // since it's not clear when the watchers will get fired,
        // and we must ensure that any existing watchers on the archived
        // event can be skipped before the batchEnd occurs.
        batching = true;
        $timeout(function () {
          fn(child);
          scope.$apply();
        })
          .then(function () {
            listener();
            batching = false;
            watchObj._broadcast('History.batchEnded', {
              transaction: child,
              description: description
            });
          });


        return watchObj;
      };

      /**
       * @ngdoc function
       * @name decipher.history.service:History#rollback
       * @method
       * @methodOf decipher.history.service:History
       * @description
       * Rolls a transaction back that was executed via {@link decipher.history.service:History#batch batch()}.
       *
       * For an example, see {@link decipher.history.service:History#batch batch()}.
       * @param {Scope} t Scope object in which the transaction was executed.
       */
      this.rollback = function rollback(t) {

        var _do = bind(this, this._do),
          parent = t.$parent,
          packets = {},
          nextSibling,
          watchObj,
          nextSiblingLocals;
        if (!t || !isObject(t)) {
          throw new Error('must pass a scope to rollback');
        }

        function _rollback(scope, comparisonScope) {
          var id = scope.$id,
            comparisonScopeId = comparisonScope.$id,
            stack = history[id],
            pointer,
            descs,
            exp,
            values,
            exps,
            rolledback,
            i;
          if (stack) {
            exps = Object.keys(stack);
            i = exps.length;
          } else {
            // might not actually have history, it's ok
            return;
          }
          while (i--) {
            exp = exps[i];
            values = [];
            descs = [];
            pointer = pointers[comparisonScopeId][exp];
            rolledback = false;
            while (pointer > pointers[id][exp]) {
              pointer--;
              values.push(_do(comparisonScope,
                exp, history[comparisonScopeId][exp], pointer));
              pointers[comparisonScopeId][exp] = pointer;
              descs.push(descriptions[comparisonScopeId][exp]);
              // throw this off the history stack so
              // we don't end up with it in the stack while we
              // do normal undo() calls later against the same
              // expression and scope
              history[comparisonScopeId][exp].pop();
              rolledback = true;
            }
            if (rolledback) {
              packets[exp] = {
                values: values,
                scope: scope,
                comparisonScope: comparisonScope,
                descriptions: descs
              };
            }
          }
        }

        watchObj = watchObjs[t.$id];

        if (isDefined(parent) &&
          isDefined(history[parent.$id])) {
          _rollback(t, parent);
        }
        nextSibling = t.$$childHead;
        while (nextSibling) {
          nextSiblingLocals = nextSibling.$$locals;
          if (nextSiblingLocals) {
            _rollback(nextSibling, nextSiblingLocals);
          }
          nextSibling = nextSibling.$$nextSibling;
        }
        watchObj._fireRollbackHandlers();
        watchObj._broadcast('History.rolledback', packets);

      };

      /**
       * @ngdoc property
       * @name decipher.history.service:History#history
       * @propertyOf decipher.history.service:History
       * @description
       * The complete history stack, keyed by Scope `$id` and then expression.
       * @type {{}}
       */
      this.history = history;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#descriptions
       * @propertyOf decipher.history.service:History
       * @description
       * The complete map of change descriptions, keyed by Scope `$id` and then expression.
       * @type {{}}
       */
      this.descriptions = descriptions;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#pointers
       * @propertyOf decipher.history.service:History
       * @description
       * The complete pointer map, keyed by Scope `$id` and then expression.
       * @type {{}}
       */
      this.pointers = pointers;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#watches
       * @propertyOf decipher.history.service:History
       * @description
       * The complete index of all AngularJS `$watch`es, keyed by Scope `$id` and then expression.
       * @type {{}}
       */
      this.watches = watches;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#lazyWatches
       * @propertyOf decipher.history.service:History
       * @description
       * The complete index of all AngularJS `$watch`es designated to be "lazy", keyed by Scope `$id` and then expression.
       * @type {{}}
       */
      this.lazyWatches = lazyWatches;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#watchObjs
       * @propertyOf decipher.history.service:History
       * @description
       * The complete index of all {@link decipher.history.object:Watch Watch} objects registered, keyed by Scope `$id` and then (optionally) expression.
       * @type {{}}
       */
      this.watchObjs = watchObjs;

      /**
       * @ngdoc property
       * @name decipher.history.service:History#Watch
       * @propertyOf decipher.history.service:History
       * @description
       * Here's the Watch prototype for you to play with.
       * @type {Watch}
       */
      this.Watch = Watch;
    }]);
})();


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutosaveService_1 = __webpack_require__(1586);
exports.AutosaveService = AutosaveService_1.AutosaveService;
var AuthoringService_1 = __webpack_require__(1587);
exports.AuthoringService = AuthoringService_1.AuthoringService;
var ConfirmDirtyService_1 = __webpack_require__(1588);
exports.ConfirmDirtyService = ConfirmDirtyService_1.ConfirmDirtyService;
var LockService_1 = __webpack_require__(1589);
exports.LockService = LockService_1.LockService;
var AuthoringThemesService_1 = __webpack_require__(1590);
exports.AuthoringThemesService = AuthoringThemesService_1.AuthoringThemesService;
var AuthoringWorkspaceService_1 = __webpack_require__(1591);
exports.AuthoringWorkspaceService = AuthoringWorkspaceService_1.AuthoringWorkspaceService;
var RenditionsService_1 = __webpack_require__(1592);
exports.RenditionsService = RenditionsService_1.RenditionsService;
var HistoryFactory_1 = __webpack_require__(1593);
exports.HistoryFactory = HistoryFactory_1.HistoryFactory;
var MediaIdGeneratorService_1 = __webpack_require__(1594);
exports.MediaIdGeneratorService = MediaIdGeneratorService_1.MediaIdGeneratorService;


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __importStar(__webpack_require__(72));
var RESOURCE = 'archive_autosave', AUTOSAVE_TIMEOUT = 3000;
var $q, $timeout, api;
var AutosaveService = /** @class */ (function () {
    function AutosaveService(_$q, _$timeout, _api) {
        $q = _$q;
        $timeout = _$timeout;
        api = _api;
        this.timeouts = {};
    }
    /**
     * Open an item.
     */
    AutosaveService.prototype.open = function (item) {
        if (!item._locked || !item._editable) {
            // no way to get autosave
            return $q.when(item);
        }
        return this.get(item);
    };
    /**
     * Get the resource.
     */
    AutosaveService.prototype.get = function (item) {
        return api.find(RESOURCE, item._id).then(function (autosave) {
            item._autosave = autosave;
            return item;
        });
    };
    /**
     * Auto-saves an item
     */
    AutosaveService.prototype.save = function (item, orig, timeout) {
        if (timeout === void 0) { timeout = AUTOSAVE_TIMEOUT; }
        if (!item._editable || !item._locked) {
            return $q.reject( true ? 'locked' : 'editable');
        }
        this.stop(item);
        var id = item._id;
        this.timeouts[id] = $timeout(function () {
            var diff = helpers.extendItem({ _id: id }, item);
            helpers.filterDefaultValues(diff, orig);
            return api.save(RESOURCE, {}, diff).then(function (_autosave) {
                orig._autosave = _autosave;
                return _autosave;
            });
        }, timeout, false);
        return this.timeouts[id];
    };
    /**
     * Stop pending autosave
     */
    AutosaveService.prototype.stop = function (item) {
        var id = item._id;
        if (this.timeouts[id]) {
            $timeout.cancel(this.timeouts[id]);
            this.timeouts[id] = null;
        }
    };
    /**
     * Drop autosave
     */
    AutosaveService.prototype.drop = function (item) {
        this.stop(item);
        if (angular.isDefined(item._autosave) && item._autosave !== null) {
            api(RESOURCE).remove(item._autosave);
        }
        item._autosave = null;
    };
    return AutosaveService;
}());
exports.AutosaveService = AutosaveService;
AutosaveService.$inject = ['$q', '$timeout', 'api'];


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var helpers = __importStar(__webpack_require__(72));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.authoring
 * @name authoring
 *
 * @requires $q
 * @requires $location
 * @requires api
 * @requires lock
 * @requires autosave
 * @requires confirm
 * @requires privileges
 * @requires desks
 * @requires superdeskFlags
 * @requires notify
 * @requires session
 * @requires $injector
 * @requires moment
 * @requires config
 *
 * @description Authoring Service is responsible for management of the actions on a story
 */
AuthoringService.$inject = ['$q', '$location', 'api', 'lock', 'autosave', 'confirm', 'privileges',
    'desks', 'superdeskFlags', 'notify', 'session', '$injector', 'moment', 'config'];
function AuthoringService($q, $location, api, lock, autosave, confirm, privileges, desks, superdeskFlags, notify, session, $injector, moment, config) {
    var _this = this;
    var self = this;
    // TODO: have to trap desk update event for refereshing users desks.
    this.userDesks = [];
    /**
     * Returns the default properties which should be picked from item before sending API Request for save/update.
     *
     * @returns {Object}
     */
    this.getContentFieldDefaults = function () {
        return helpers.CONTENT_FIELDS_DEFAULTS;
    };
    desks.fetchCurrentUserDesks().then(function (desksList) {
        self.userDesks = desksList;
    });
    /**
     * Open an item for editing
     *
     * @param {string} _id Item _id.
     * @param {boolean} readOnly
     * @param {string} repo - repository where an item whose identifier is _id can be found.
     * @param {string} action - action performed to open the story: edit, correct or kill
     */
    this.open = function openAuthoring(_id, readOnly, repo, action) {
        if ($location.$$path !== '/multiedit') {
            superdeskFlags.flags.authoring = true;
        }
        if (lodash_1.default.includes(['legal_archive', 'archived'], repo)) {
            return api.find(repo, _id).then(function (item) {
                item._editable = false;
                return item;
            });
        }
        return api.find('archive', _id, { embedded: { lock_user: 1 } })
            .then(function _lock(item) {
            if (readOnly) {
                item._locked = lock.isLockedInCurrentSession(item);
                item._editable = false;
                return $q.when(item);
            }
            else if (lock.isLocked(item)) { // is locked by someone else
                item._locked = false;
                item._editable = false;
                return $q.when(item);
            }
            else if (lock.isLockedInCurrentSession(item)) { // we have lock
                item._locked = true;
                item._editable = true;
                return $q.when(item);
            }
            item._editable = true; // not locked at all, try to lock
            return lock.lock(item, false, action);
        })
            .then(function (item) { return autosave.open(item).then(null, function (err) { return item; }); });
    };
    this.rewrite = function (item) {
        var authoringWorkspace = $injector.get('authoringWorkspace');
        session.getIdentity()
            .then(function (user) {
            var updates = {
                desk_id: desks.getCurrentDeskId() || item.task.desk,
            };
            return api.save('archive_rewrite', {}, updates, item);
        })
            .then(function (newItem) {
            notify.success(utils_1.gettext('Update Created.'));
            authoringWorkspace.edit(newItem);
        }, function (response) {
            if (angular.isDefined(response.data._message)) {
                notify.error(utils_1.gettext('Failed to generate update: {{message}}', { message: response.data._message }));
            }
            else {
                notify.error(utils_1.gettext('There was an error. Failed to generate update.'));
            }
        });
    };
    /**
     * @ngdoc method
     * @name authoring#unlink
     * @public
     * @description Removes the update link of a given story
     * @param {Object} item
     */
    this.unlink = function (item) { return session.getIdentity()
        .then(function (user) { return api.remove(item, {}, 'archive_rewrite'); })
        .then(function (data) { return notify.success(utils_1.gettext('Link has been removed')); }, function (response) {
        if (angular.isDefined(response.data._message)) {
            notify.error(utils_1.gettext('Failed to remove link: {{message}}', { message: response.data._message }));
        }
        else {
            notify.error(utils_1.gettext('There was an error. Failed to remove link.'));
        }
    }); };
    /**
     * Close an item
     *
     *   and save it if dirty, unlock if editable, and remove from work queue at all times
     *
     * @param {Object} diff
     * @param {Object} orig
     * @param {boolean} isDirty $scope dirty status.
     */
    this.close = function closeAuthoring(diff, orig, isDirty, closeItem) {
        var promise = $q.when();
        if (this.isEditable(diff)) {
            if (isDirty) {
                if (!lodash_1.default.includes(['published', 'corrected'], orig.state)) {
                    promise = confirm.confirm()
                        .then(angular.bind(this, function save() {
                        return this.save(orig, diff);
                    }), function () {
                        return $q.when('ignore');
                    });
                }
                else {
                    promise = $q.when('ignore');
                }
            }
            promise = promise.then(function unlock(cancelType) {
                if (cancelType && cancelType === 'ignore') {
                    autosave.drop(orig);
                }
                if (!closeItem) {
                    return lock.unlock(diff);
                }
            });
        }
        return promise;
    };
    /**
     * Publish an item
     *
     *   and save it if dirty
     *
     * @param {Object} orig original item.
     * @param {Object} diff Edits.
     * @param {boolean} isDirty $scope dirty status.
     */
    this.publishConfirmation = function publishAuthoring(orig, diff, isDirty, action) {
        var promise = $q.when();
        if (this.isEditable(diff) && isDirty) {
            promise = confirm.confirmPublish(action)
                .then(angular.bind(this, function save() {
                return true;
            }), function () {
                return false;
            });
        }
        return promise;
    };
    /**
     * Removes certain properties which are irrelevant for publish actions depending on the orig.item.state.
     * If not removed the API will throw errors.
     */
    this.cleanUpdatesBeforePublishing = function (original, updates, action) {
        if (action === void 0) { action = 'publish'; }
        // check if rendition is dirty for real
        if (lodash_1.default.isEqual(original.renditions, updates.renditions)) {
            delete updates.renditions;
        }
        // Remove sign off from update (if it is not mapped), it will get the publishing user appended in the backend
        if (updates.sign_off && !(config.user && config.user.sign_off_mapping)) {
            delete updates.sign_off;
        }
        // for kill and take down action dateline is not required
        if (action === 'kill' || action === 'takedown') {
            delete updates.dateline;
        }
        helpers.stripHtml(updates);
        helpers.stripWhitespaces(updates);
        // If the text equivalent of the body_html is empty then set the body empty
        if (angular.isDefined(updates.body_html)) {
            var elem = document.createElement('div');
            elem.innerHTML = updates.body_html;
            if (elem.textContent === '') {
                updates.body_html = '';
            }
        }
    };
    this.publish = function publish(orig, diff, action) {
        if (action === void 0) { action = 'publish'; }
        var extDiff = helpers.extendItem({}, diff);
        // if there were some changes on image, we should update etag
        if (diff && diff._etag) {
            orig._etag = diff._etag;
        }
        this.cleanUpdatesBeforePublishing(orig, extDiff, action);
        helpers.filterDefaultValues(extDiff, orig);
        var endpoint = 'archive_' + action;
        return api.update(endpoint, orig, extDiff)
            .then(function (result) { return lock.unlock(result).catch(function () { return result; }); }); // ignore unlock err
    };
    this.saveWorkConfirmation = function saveWorkAuthoring(orig, diff, isDirty, message) {
        var promise = $q.when();
        if (isDirty) {
            if (this.isEditable(diff)) {
                promise = confirm.confirmSaveWork(message)
                    .then(angular.bind(this, function save() {
                    return this.saveWork(orig, diff);
                }), function (err) {
                    return $q.when();
                });
            }
        }
        return promise;
    };
    /**
     * Autosave the changes
     *
     * @param {Object} item
     * @param {Object} orig
     */
    this.autosave = function autosaveAuthoring(item, orig, timeout) {
        return autosave.save(item, orig, timeout);
    };
    /**
     * Save the item
     *
     * @param {Object} origItem
     * @param {Object} item
     */
    this.save = function saveAuthoring(origItem, item) {
        var diff = helpers.extendItem({}, item);
        // Finding if all the keys are dirty for real
        if (angular.isDefined(origItem)) {
            angular.forEach(lodash_1.default.keys(diff), function (key) {
                if (lodash_1.default.isEqual(diff[key], origItem[key])) {
                    delete diff[key];
                }
            });
        }
        helpers.stripHtml(diff);
        helpers.stripWhitespaces(diff);
        helpers.cutoffPreviousRenditions(diff, origItem);
        autosave.stop(item);
        if (diff._etag) { // make sure we use orig item etag
            delete diff._etag;
        }
        // if current document is image and it has been changed on 'media edit' we have to update the etag
        if (origItem.type === 'picture' && item._etag != null) {
            diff._etag = item._etag;
        }
        helpers.filterDefaultValues(diff, origItem);
        if (lodash_1.default.size(diff) > 0) {
            return api.save('archive', origItem, diff).then(function (_item) {
                if (origItem.type === 'picture') {
                    item._etag = _item._etag;
                }
                origItem._autosave = null;
                origItem._autosaved = false;
                origItem._locked = lock.isLockedInCurrentSession(item);
                $injector.get('authoringWorkspace').update(origItem);
                return origItem;
            });
        }
        if (origItem) {
            // if there is nothing to save. No diff.
            origItem._autosave = null;
            origItem._autosaved = false;
        }
        return $q.when(origItem);
    };
    /**
     * Save the item as new item in workspace when any critical configuration changes occur
     *
     * @param {Object} orig
     * @param {Object} item
     */
    this.saveWork = function saveWork(orig, item) {
        var _orig = { type: orig.type, version: 1, task: { desk: null, stage: null, user: orig.task.user } };
        var _diff = lodash_1.default.omit(item, ['unique_name', 'unique_id', '_id', 'guid']);
        var diff = helpers.extendItem(_orig, _diff);
        return api.save('archive', {}, diff).then(function (_item) {
            _item._autosave = null;
            return _item;
        });
    };
    /**
     * Test if an item is editable
     *
     * @param {Object} item
     */
    this.isEditable = function isEditable(item) {
        return lock.isLockedInCurrentSession(item);
    };
    /**
     * Test if an item is published
     *
     * @param {Object} item
     */
    this.isPublished = function isPublished(item) {
        return lodash_1.default.includes(['published', 'killed', 'scheduled', 'corrected', 'recalled'], item.state);
    };
    /**
     * Unlock an item - callback for item:unlock event
     *
     * @param {Object} item
     * @param {string} userId
     */
    this.unlock = function unlock(item, userId, headline) {
        autosave.stop(item);
        item.lock_session = null;
        item.lock_user = null;
        item._locked = false;
        confirm.unlock(userId, headline);
    };
    /**
     * Lock an item - callback for item:lock event
     *
     * @param {Object} item
     * @param {string} userId
     */
    this.lock = function (item, userId) {
        autosave.stop(item);
        api.find('users', userId).then(function (user) {
            item.lock_user = user;
        }, function (rejection) {
            item.lock_user = userId;
        });
        item._locked = true;
    };
    /**
    * Actions that it can perform on an item
    * @param {Object} item : item
    */
    this.itemActions = function (item, userDesks) {
        var currentItem = this._getCurrentItem(item);
        var userPrivileges = privileges.privileges;
        var action = angular.extend({}, helpers.DEFAULT_ACTIONS);
        var itemOnReadOnlyStage = item && item.task && item.task.stage && desks.isReadOnlyStage(item.task.stage);
        var isUndefinedOperation = angular.isUndefined(currentItem) || angular.isUndefined(userPrivileges);
        var isKilledItem = function (_item) { return lodash_1.default.get(_item, 'state') === 'killed' || lodash_1.default.get(_item, 'state') === 'recalled'; };
        action = this._updateActionsForContentApi(currentItem, action);
        // killed item and item that have last publish action are readonly
        if (isUndefinedOperation || itemOnReadOnlyStage || isKilledItem(currentItem) || !action.view) {
            return action;
        }
        // Archived items can be duplicated
        if (lodash_1.default.get(currentItem, '_type') === 'archived' && currentItem.type === 'text') {
            action.duplicate = true;
            return action;
        }
        var lockedByMe = !lock.isLocked(currentItem);
        action.view = !lockedByMe;
        action.unlinkUpdate = this._canUnlinkUpdate(currentItem);
        action.export = currentItem && currentItem.type && currentItem.type === 'text';
        // item is published state - corrected, published, scheduled, killed
        if (self.isPublished(currentItem)) {
            // if not the last published version
            if (item.last_published_version === false) {
                return angular.extend({}, helpers.DEFAULT_ACTIONS);
            }
            this._updatePublished(currentItem, action);
        }
        else {
            if (currentItem.state === 'spiked') {
                action = angular.extend({}, helpers.DEFAULT_ACTIONS);
                action.unspike = true;
                action.mark_item_for_desks = true;
                action.mark_item_for_highlight = true;
                return action;
            }
            this._updateUnpublished(currentItem, action);
        }
        this._updateGeneralActions(currentItem, action);
        return this._updateDeskActions(currentItem, action, userDesks || self.userDesks);
    };
    this._updateActionsForContentApi = function (item, action) {
        if (this.isContentApiItem(item)) {
            var _action = angular.extend({}, helpers.DEFAULT_ACTIONS);
            _action.view = false;
            return _action;
        }
        return action;
    };
    this.isContentApiItem = function (item) {
        return item._type === 'items';
    };
    this._isBroadcastItem = function (item) {
        return item.genre && item.genre.length > 0 &&
            lodash_1.default.includes(['text', 'preformatted'], item.type) &&
            item.genre.some(function (genre) { return genre.name === 'Broadcast Script'; });
    };
    /**
     * @ngdoc method
     * @name authoring#_canUnlinkUpdate
     * @private
     * @description Checks if the given item can be unlinked as an update
     * @param {Object} item
     * @returns {boolean}
     */
    this._canUnlinkUpdate = function (item) { return !_this._isReadOnly(item) && item.type === 'text' &&
        !_this.isPublished(item) && !lodash_1.default.isNil(item.rewrite_of) && lodash_1.default.isNil(item.rewritten_by); };
    this._isReadOnly = function (item) {
        return lodash_1.default.includes(['spiked', 'scheduled', 'killed', 'recalled'], item.state);
    };
    this._updatePublished = function (currentItem, action) {
        var userPrivileges = privileges.privileges;
        var lockedByMe = !lock.isLocked(currentItem);
        var isReadOnlyState = this._isReadOnly(currentItem);
        var isPublishedOrCorrected = currentItem.state === 'published' || currentItem.state === 'corrected';
        action.view = true;
        if (currentItem.state === 'scheduled') {
            action.deschedule = true;
        }
        else if (isPublishedOrCorrected) {
            action.kill = userPrivileges.kill && lockedByMe && !isReadOnlyState;
            action.correct = userPrivileges.correct && lockedByMe && !isReadOnlyState;
            action.takedown = userPrivileges.takedown && lockedByMe && !isReadOnlyState;
        }
    };
    this._updateUnpublished = function (currentItem, action) {
        var userPrivileges = privileges.privileges;
        var lockedByMe = !lock.isLocked(currentItem);
        action.save = currentItem.state !== 'spiked';
        action.publish = (!currentItem.flags || !currentItem.flags.marked_for_not_publication) &&
            currentItem.task && currentItem.task.desk &&
            (!currentItem.highlight || currentItem.type !== 'composite') &&
            userPrivileges.publish && currentItem.state !== 'draft';
        action.edit = currentItem.state !== 'spiked' && lockedByMe;
        action.spike = currentItem.state !== 'spiked' && userPrivileges.spike;
        action.send = currentItem._current_version > 0 && userPrivileges.move && lockedByMe;
    };
    this._getCurrentItem = function (item) {
        return item && item.archive_item && item.archive_item.state ? item.archive_item : item;
    };
    this._updateGeneralActions = function (currentItem, action) {
        var isReadOnlyState = this._isReadOnly(currentItem);
        var userPrivileges = privileges.privileges;
        action.re_write = !isReadOnlyState && lodash_1.default.includes(['text'], currentItem.type) &&
            !currentItem.embargo && !currentItem.rewritten_by &&
            (!currentItem.broadcast || !currentItem.broadcast.master_id) &&
            (!currentItem.rewrite_of || currentItem.rewrite_of && this.isPublished(currentItem));
        action.resend = lodash_1.default.includes(['text'], currentItem.type) &&
            lodash_1.default.includes(['published', 'corrected', 'killed', 'recalled'], currentItem.state);
        // mark item for highlights
        action.mark_item_for_highlight = currentItem.task && currentItem.task.desk &&
            !isReadOnlyState && currentItem.type === 'text' && userPrivileges.mark_for_highlights;
        // mark item for desks
        action.mark_item_for_desks = currentItem.task && currentItem.task.desk &&
            !isReadOnlyState && userPrivileges.mark_for_desks && currentItem.type === 'text';
        // allow all stories to be packaged if it doesn't have Embargo
        action.package_item = !lodash_1.default.includes(['spiked', 'scheduled', 'killed', 'recalled'], currentItem.state) &&
            !currentItem.embargo && (this.isPublished(currentItem) || !currentItem.publish_schedule);
        action.create_broadcast = lodash_1.default.includes(['published', 'corrected'], currentItem.state) &&
            lodash_1.default.includes(['text', 'preformatted'], currentItem.type) &&
            !this._isBroadcastItem(currentItem) && userPrivileges.archive_broadcast;
        action.multi_edit = !isReadOnlyState;
    };
    // check for desk membership for edit rights and returns updated
    // actions accordingly
    this._updateDeskActions = function (currentItem, oldAction, userDesks) {
        var action = oldAction;
        var reWrite = action.re_write;
        var userPrivileges = privileges.privileges;
        if (currentItem.task && currentItem.task.desk) {
            // in production
            action.duplicate = userPrivileges.duplicate &&
                !lodash_1.default.includes(['spiked', 'killed', 'recalled'], currentItem.state);
            action.add_to_current = !lodash_1.default.includes(['spiked', 'scheduled', 'killed', 'recalled'], currentItem.state);
            var desk = lodash_1.default.find(userDesks, { _id: currentItem.task.desk });
            if (!desk) {
                action = angular.extend({}, helpers.DEFAULT_ACTIONS);
                // user can action `update` even if the user is not a member.
                action.re_write = reWrite;
            }
        }
        else {
            // personal
            action.copy = true;
            action.view = false;
            action.package_item = false;
            action.re_write = false;
        }
        return action;
    };
    /**
     * Validate schedule
     *
     * should be both valid date and time and it should be some time in future
     *
     * @param {String} datePart
     * @param {String} timePart
     * @param {String} timestamp datePart + T + timepart
     * @param {String} timezone
     * @return {Object}
     */
    this.validateSchedule = function (datePart, timePart, timestamp, timezone) {
        function errors(key) {
            var _errors = {};
            _errors[key] = 1;
            return _errors;
        }
        if (!datePart) {
            return errors('date');
        }
        if (!timePart) {
            return errors('time');
        }
        var now = moment();
        var schedule = moment.tz(timestamp.replace('+0000', '').replace('Z', ''), // avoid timezone info here
        timezone || config.defaultTimezone);
        if (!schedule.isValid()) {
            return errors('timestamp');
        }
        if (schedule.isBefore(now)) {
            return errors('future');
        }
    };
}
exports.AuthoringService = AuthoringService;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.authoring
 * @name confirm
 *
 * @requires $window
 * @requires $q
 * @requires $filter
 * @requires api
 * @requires modal
 * @requires $interpolate
 * @requires $modal
 *
 * @description Confirm Service is responsible for displaying user prompts for content authoring.
 */
ConfirmDirtyService.$inject = ['$window', '$q', '$filter', 'api', 'modal',
    '$interpolate', '$modal'];
function ConfirmDirtyService($window, $q, $filter, api, modal, $interpolate, $modal) {
    /**
     * Will ask for user confirmation for user confirmation if there are some changes which are not saved.
     * - Detecting changes via $scope.dirty - it's up to the controller to set it.
     */
    this.setupWindow = function setupWindow($scope) {
        $window.onbeforeunload = function () {
            if ($scope.dirty) {
                return utils_1.gettext('There are unsaved changes. If you navigate away, your changes will be lost.');
            }
            $scope.$on('$destroy', function () {
                $window.onbeforeunload = angular.noop;
            });
        };
    };
    // Flag to set for instant checking if $scope is dirty for current item
    this.dirty = null;
    /**
     * Called from workqueue in case of unsaved changes.
     */
    this.reopen = function () {
        return modal.confirm(utils_1.gettext('There are some unsaved changes, go to the article to save changes?'), utils_1.gettext('Save changes?'), utils_1.gettext('Go-To'), utils_1.gettext('Ignore'), utils_1.gettext('Cancel'));
    };
    /**
     * In case $scope is dirty ask user if he want's to loose his changes.
     */
    this.confirm = function confirm() {
        return modal.confirm(utils_1.gettext('There are some unsaved changes, do you want to save it now?'), utils_1.gettext('Save changes?'), utils_1.gettext('Save'), utils_1.gettext('Ignore'), utils_1.gettext('Cancel'));
    };
    /**
     * In case publish is triggered by quick buttons, show confirmation dialog
     */
    this.confirmQuickPublish = function () {
        return modal.confirm(utils_1.gettext('Do you want to publish the article?'), utils_1.gettext('Publishing'), utils_1.gettext('Publish'), utils_1.gettext('Cancel'));
    };
    /**
     * In case $scope is dirty ask user if he want's to save changes and publish.
     */
    this.confirmPublish = function () {
        return modal.confirm(utils_1.gettext('There are some unsaved changes, do you want to save and publish it now?'), utils_1.gettext('Save changes?'), utils_1.gettext('Save and publish'), utils_1.gettext('Cancel'));
    };
    /**
     * In case $scope is dirty ask user if he want's to save changes and publish.
     */
    this.confirmSendTo = function confirmSendTo(action) {
        return modal.confirm(utils_1.gettext('There are some unsaved changes, do you want to save and send it now?'), utils_1.gettext('Save changes?'), utils_1.gettext('Save and send'), utils_1.gettext('Cancel'));
    };
    this.confirmSaveWork = function confirmSavework(message) {
        return modal.confirm(utils_1.gettext('Configuration has changed. {{message}} Would you like to save the story to your workspace?', { message: message }));
    };
    /**
     * Make user aware that an item was unlocked
     *
     * @param {string} userId Id of user who unlocked an item.
     * @param {string} headline Headline of item which is unlocked
     */
    this.unlock = function unlock(userId, headline) {
        api.find('users', userId).then(function (user) {
            var username = $filter('username')(user);
            var msg = headline ?
                utils_1.gettext('This item was unlocked by {{username}}.', { username: "<b>" + username + "</b>" })
                :
                    utils_1.gettext('Item {{headline}} was unlocked by {{username}}.', { headline: "<b>" + headline + "</b>", username: "<b>" + username + "</b>" });
            return modal.confirm(msg, utils_1.gettext('Item Unlocked'), utils_1.gettext('OK'), false);
        });
    };
    /**
     * Make user aware that an item was locked
     *
     * @param {string} userId Id of user who locked an item.
     */
    this.lock = function lock(userId) {
        api.find('users', userId).then(function (user) {
            var username = $filter('username')(user);
            var msg = utils_1.gettext('This item was locked by {{username}}.', { username: "<b>" + username + "</b>" });
            return modal.confirm(msg, utils_1.gettext('Item locked'), utils_1.gettext('OK'), false);
        });
    };
    /**
     * @ngdoc method
     * @name confirm#confirmFeatureMedia
     * @public
     * @returns {promise}
     * @description Prompts the user to add the associated media to the Update.
     * @param {Object} item
     */
    this.confirmFeatureMedia = function (item) {
        var defered = $q.defer();
        $modal.open({
            templateUrl: 'scripts/apps/authoring/views/confirm-media-associated.html',
            controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                    $scope.item = item;
                    $scope.useMedia = function () {
                        defered.resolve($scope.item);
                        $modalInstance.close();
                    };
                    $scope.cancel = function () {
                        defered.reject(false);
                        $modalInstance.dismiss();
                    };
                    $scope.publishWithoutMedia = function () {
                        defered.resolve({});
                        $modalInstance.dismiss();
                    };
                }],
        });
        return defered.promise;
    };
}
exports.ConfirmDirtyService = ConfirmDirtyService;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
LockService.$inject = ['$q', 'api', 'session', 'privileges', 'notify'];
function LockService($q, api, session, privileges, notify) {
    /**
     * Lock an item
     */
    this.lock = function lock(item, force, action) {
        if (!item.lock_user && item._editable || force) {
            return api.save('archive_lock', {}, { lock_action: action }, item).then(function (_lock) {
                lodash_1.default.extend(item, _lock);
                item._locked = true;
                item.lock_user = session.identity._id;
                item.lock_session = session.sessionId;
                item.lock_action = action || 'edit';
                return item;
            }, function (err) {
                var msg = lodash_1.default.get(err, 'data._message') ?
                    utils_1.gettext('Error: {{message}}', { message: err.data._message }) :
                    utils_1.gettext('Failed to get a lock on the item!');
                notify.error(msg);
                item._locked = false;
                item._editable = false;
                return item;
            });
        }
        item._locked = this.isLockedInCurrentSession(item);
        return $q.when(item);
    };
    /**
     * Unlock an item
     */
    this.unlock = function unlock(item) {
        return api('archive_unlock', item).save({})
            .then(function (lock) {
            lodash_1.default.extend(item, lock);
            item._locked = false;
            return item;
        });
    };
    /**
     * Test if an item is locked by some other session, so not editable
     *
     * @param {Object} item
     * @return {Boolean}
     */
    this.isLocked = function isLocked(item) {
        if (!item) {
            return false;
        }
        return !!item.lock_user && !this.isLockedInCurrentSession(item);
    };
    function getLockedUserId(item) {
        return !!item.lock_user && item.lock_user._id || item.lock_user;
    }
    /**
     * Test if an item is locked in current session
     *
     * @param {Object} item
     * @return {Boolean}
     */
    this.isLockedInCurrentSession = function (item) {
        return !!item.lock_session && item.lock_session === session.sessionId;
    };
    /**
     * Test if an item is locked by me, different session session
     *
     * @param {Object} item
     * @return {Boolean}
     */
    this.isLockedByMe = function isLockedByMe(item) {
        var userId = getLockedUserId(item);
        return !!userId && userId === session.identity._id;
    };
    /**
    * can unlock the item or not.
    */
    this.can_unlock = function canUnlock(item) {
        if (this.isLockedByMe(item)) {
            return true;
        }
        return item.state === 'draft' ? false : privileges.privileges.unlock;
    };
}
exports.LockService = LockService;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
AuthoringThemesService.$inject = ['storage', 'preferencesService'];
function AuthoringThemesService(storage, preferencesService) {
    var service = {};
    var PREFERENCES_KEY = 'editor:theme';
    var THEME_DEFAULT = {
        font: 'sans',
        theme: 'default',
        headline: 'medium',
        abstract: 'medium',
        body: 'medium',
    };
    service.availableThemes = {
        fonts: [
            {
                label: 'Sans-serif (Roboto)',
                key: 'sans',
            },
            {
                label: 'Serif (Merriweather)',
                key: 'serif',
            },
            {
                label: 'Monospace (Roboto Mono)',
                key: 'mono',
            },
        ],
        colors: [
            {
                label: 'Default',
                key: 'default',
            },
            {
                label: 'Dark',
                key: 'dark',
            },
            {
                label: 'Blue',
                key: 'blue',
            },
            {
                label: 'Turquoise',
                key: 'turquoise',
            },
            {
                label: 'Military',
                key: 'military',
            },
            {
                label: 'Natural',
                key: 'natural',
            },
        ],
        sizes: [
            {
                label: 'S',
                key: 'small',
            },
            {
                label: 'M',
                key: 'medium',
            },
            {
                label: 'L',
                key: 'large',
            },
        ],
    };
    service.get = function (key) {
        return preferencesService.get().then(function (result) {
            var theme = result[PREFERENCES_KEY] && result[PREFERENCES_KEY][key] ?
                result[PREFERENCES_KEY][key] : THEME_DEFAULT;
            try {
                theme = JSON.parse(theme);
            }
            catch (e) {
                theme = angular.copy(THEME_DEFAULT);
            }
            return theme;
        });
    };
    service.save = function (key, theme) {
        return preferencesService.get().then(function (result) {
            result[PREFERENCES_KEY][key] = JSON.stringify(theme);
            return preferencesService.update(result);
        });
    };
    return service;
}
exports.AuthoringThemesService = AuthoringThemesService;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
/**
 * @ngdoc service
 * @module superdesk.apps.authoring
 * @name authoringWorkspace
 *
 * @requires $location
 * @requires superdeskFlags
 * @requires authoring
 * @requires lock
 * @requires send
 * @requires config
 * @requires suggest
 * @requires search
 * @requires $rootscope
 *
 * @description Authoring Workspace Service is responsible for the actions done on the authoring workspace container
 */
AuthoringWorkspaceService.$inject = ['$location', 'superdeskFlags', 'authoring', 'lock', 'send', 'config', 'suggest',
    '$rootScope', 'search', '$window'];
function AuthoringWorkspaceService($location, superdeskFlags, authoring, lock, send, config, suggest, $rootScope, search, $window) {
    this.item = null;
    this.action = null;
    this.state = null;
    // Array<() => Promise<boolean>>
    var widgetVisibilityCheckerFuntions = [];
    this.addWidgetVisibilityCheckerFunction = function (fn) {
        widgetVisibilityCheckerFuntions.push(fn);
    };
    this.removeWidgetVisibilityCheckerFunction = function (fn) {
        widgetVisibilityCheckerFuntions = widgetVisibilityCheckerFuntions.filter(function (f) { return f !== fn; });
    };
    this.isWidgetVisible = function (widget) { return new Promise(function (resolve) {
        Promise.all(widgetVisibilityCheckerFuntions.map(function (fn) { return fn(widget); }))
            .then(function (res) {
            resolve(res.every(function (i) { return i === true; }));
        });
    }); };
    var self = this;
    /**
     * Initiate authoring workspace
     */
    this.init = init;
    /**
     * Open item for editing
     *
     * @param {Object} item
     * @param {string} action
     */
    this.edit = function (item, action) {
        if (item) {
            // disable edit of external ingest sources that are not editable (editFeaturedImage false or not available)
            if (item._type === 'externalsource' && !!lodash_1.get(config.features, 'editFeaturedImage') === false) {
                return;
            }
            authoringOpen(item._id, action || 'edit', item._type || null);
        }
        else {
            self.close();
        }
    };
    // plugin support
    this.authoringTopBarAdditionalButtons = {},
        this.authoringTopBarButtonsToHide = {};
    this.displayAuthoringHeaderCollapedByDefault = null;
    /**
     * Open an item in readonly mode without locking it
     *
     * @param {Object} item
     */
    this.view = function (item) {
        self.edit(item, 'view');
    };
    /**
     * Open an item - if possible for edit, otherwise read only
     *
     * @param {Object} item
     */
    this.open = function (item) {
        var _open = function (_item) {
            var actions = authoring.itemActions(_item);
            if (actions.edit) {
                this.edit(_item);
            }
            else {
                this.view(_item);
            }
        }.bind(this);
        // disable open for external ingest sources that are not editable (editFeaturedImage false or not available)
        if (item._type === 'externalsource' && !!lodash_1.get(config.features, 'editFeaturedImage') === false) {
            return;
        }
        if (lodash_1.includes(['ingest', 'externalsource'], item._type) || item.state === 'ingested') {
            send.one(item).then(_open);
        }
        else {
            _open(item);
        }
    };
    /**
     * Stop editing.
     *
     * @param {boolean} showMonitoring when true shows the monitoring if monitoring is hidden.
     */
    this.close = function (showMonitoring) {
        if ($rootScope.popup) {
            window.close();
        }
        suggest.setActive(false);
        self.item = null;
        self.action = null;
        if (showMonitoring && superdeskFlags.flags.hideMonitoring) {
            superdeskFlags.flags.hideMonitoring = false;
        }
        saveState();
        sendRowViewEvents();
    };
    /**
     * Kill an item
     *
     * @param {Object} item
     */
    this.kill = function (item) {
        self.edit(item, 'kill');
    };
    /**
     * Takedown an item
     *
     * @param {Object} item
     */
    this.takedown = function (item) {
        self.edit(item, 'takedown');
    };
    /**
     * Correct an item
     *
     * @param {Object} item
     */
    this.correct = function (item) {
        self.edit(item, 'correct');
    };
    /**
     * Get edited item
     *
     * return {Object}
     */
    this.getItem = function () {
        return self.item;
    };
    /**
     * Get current action
     *
     * @return {string}
     */
    this.getAction = function () {
        return self.action;
    };
    /**
     * Get current state
     *
     * @return {Object}
     */
    this.getState = function () {
        return self.state;
    };
    /**
     * Should be invoked when an item is saved by system without user interaction
     */
    this.addAutosave = function () {
        if (self.item) {
            self.item._autosaved = true;
        }
    };
    /*
     * Updates current item
     */
    this.update = function (item) {
        self.item = item;
    };
    /**
     * Edit/view item in a new window
     *
     * @param {Object} item
     * @param {string} action
     */
    this.popup = function (item, action) {
        var host = $location.host();
        var port = $location.port();
        var proto = $location.protocol();
        var baseURL = proto + "://" + host + (port !== 80 ? ':' + port : '');
        $window.open(baseURL + "/#/workspace/monitoring?item=" + item._id + "&action=" + action + "&popup", item._id);
    };
    /**
     * Save current item/action state into $location so that it can be
     * used on page reload
     */
    function saveState() {
        $location.search('item', self.item ? self.item._id : null);
        $location.search('action', self.action);
        superdeskFlags.flags.authoring = !!self.item;
        self.state = { item: self.item, action: self.action };
    }
    /**
     * @ngdoc method
     * @name authoringWorkspace#sendRowViewEvents
     * @private
     * @description If singLine:view preference is set, an item is being previewed, config has narrowView list
     * then, sends rowview event
     */
    function sendRowViewEvents() {
        var evnt = superdeskFlags.flags.authoring ? 'rowview:narrow' : 'rowview:default';
        if (superdeskFlags.flags.previewing && search.singleLine && lodash_1.get(config, 'list.narrowView')) {
            $rootScope.$broadcast(evnt);
        }
    }
    /**
     * On load try to fetch item set in url
     */
    function init() {
        if ($location.search().item && $location.search().action in self) {
            authoringOpen($location.search().item, $location.search().action);
        }
    }
    /**
     * Fetch item by id and start editing it
     */
    function authoringOpen(itemId, action, repo) {
        return authoring.open(itemId, action === 'view', repo, action)
            .then(function (item) {
            self.item = item;
            self.action = action !== 'view' && item._editable ? action : 'view';
        })
            .then(function () {
            saveState();
            // closes preview if already opened
            $rootScope.$broadcast('broadcast:preview', { item: null });
        });
    }
    init();
}
exports.AuthoringWorkspaceService = AuthoringWorkspaceService;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.authoring
 * @name renditions
 * @description Renditions Service allows the user to generate different crops.
 */
RenditionsService.$inject = ['metadata', '$q', 'api', 'superdesk', 'lodash', 'notify'];
function RenditionsService(metadata, $q, api, superdesk, _, notify) {
    var self = this;
    /**
     *  ngdoc method
     *  @name renditions#ingest
     *  @public
     *  @description Ingest the picture from external source.
     *
     *  @return {promise}
     */
    this.ingest = function (item) {
        var performRenditions = $q.when(item);
        // ingest picture if it comes from an external source (create renditions)
        if (item._type && item._type === 'externalsource') {
            performRenditions = superdesk.intent('list', 'externalsource', { item: item }, 'fetch-externalsource')
                .then(function (_item) { return api.find('archive', _item._id); });
        }
        return performRenditions;
    };
    /**
     *  ngdoc method
     *  @name renditions#get
     *  @public
     *  @description Get the crop sizes.
     *
     *  @return {promise} picture crops
     */
    this.get = function () {
        return metadata.initialize().then(function () {
            self.renditions = metadata.values.crop_sizes;
            return self.renditions;
        });
    };
    /**
     *  ngdoc method
     *  @name renditions#crop
     *  @public
     *  @description Crop the images.
     *
     *  @param {Object} item Media item
     *  @param {boolean} isNew to indicate if picture is new or not
     *  @param {boolean} editable to indicate if picture is editable or not
     *  @param {boolean} isAssociated to indicate if picture is isAssociated or not
     *  @return {promise} returns the modified picture item
     */
    this.crop = function (item, options) {
        var clonedItem = _.extend({}, item);
        clonedItem.renditions = _.cloneDeep(clonedItem.renditions);
        return self.get().then(function (renditions) {
            // we want to crop only renditions that change the ratio
            var withRatio = _.filter(renditions, function (rendition) { return angular.isDefined(rendition.ratio); });
            if (!withRatio.length) {
                withRatio = self.renditions;
            }
            // Merge options with defauts
            var cropOptions = __assign({ isNew: true, isAssociated: false, editable: true, defaultTab: false, tabs: item.type === 'picture' ? ['view', 'image-edit', 'crop'] : ['view'], showMetadata: false }, options);
            return superdesk.intent('edit', 'crop', __assign({ item: clonedItem, renditions: withRatio, poi: clonedItem.poi, showAoISelectionButton: true, showMetadataEditor: true }, cropOptions))
                .then(function (result) {
                var renditionNames = [];
                var savingImagePromises = [];
                // applying metadata changes
                angular.forEach(result.cropData, function (croppingData, renditionName) {
                    // if there a change in the crop co-ordinates
                    var keys = ['CropLeft', 'CropTop', 'CropBottom', 'CropRight'];
                    var canAdd = !keys.every(function (key) {
                        var sameCoords = angular.isDefined(item.renditions[renditionName]) &&
                            item.renditions[renditionName][key] === croppingData[key];
                        return sameCoords;
                    });
                    if (canAdd) {
                        renditionNames.push(renditionName);
                    }
                });
                // perform the request to make the cropped images
                renditionNames.forEach(function (renditionName) {
                    if (!lodash_1.isEmpty(result.cropData[renditionName]) &&
                        item.renditions[renditionName] !== result.cropData[renditionName]) {
                        savingImagePromises.push(api.save('picture_crop', { item: clonedItem, crop: result.cropData[renditionName] }));
                    }
                });
                return $q.all(savingImagePromises)
                    // return the cropped images
                    .then(function (croppedImages) {
                    // save created images in "association" property
                    croppedImages.forEach(function (image, index) {
                        var url = image.href;
                        // update association renditions
                        result.metadata.renditions[renditionNames[index]] = angular.extend(image.crop, {
                            href: url,
                            width: image.width,
                            height: image.height,
                            media: image._id,
                            mimetype: image.item.mimetype,
                        });
                    });
                    // apply the metadata changes
                    angular.extend(item, result.metadata);
                    return item;
                })
                    .catch(function () {
                    notify.error(utils_1.gettext('Failed to generate picture crops.'));
                });
            });
        });
    };
}
exports.RenditionsService = RenditionsService;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Watches an expression to keep history of its states
 * and binds ctrl-z and ctrl-y to undo/redo its states
 */
HistoryFactory.$inject = ['History', '$window', '$timeout'];
function HistoryFactory(History, $window, $timeout) {
    var _a;
    var KeyOperations = (_a = {},
        _a['Z'.charCodeAt(0)] = History.undo,
        _a['Y'.charCodeAt(0)] = History.redo,
        _a);
    return {
        watch: function (expression, scope) {
            $timeout(function () {
                History.watch(expression, scope);
            }, 0, false);
            var onHistoryKey = function (event, cb) {
                var modifier = (event.ctrlKey || event.metaKey) && !event.altKey && !event.shiftKey;
                if (modifier && KeyOperations[event.keyCode]) {
                    cb();
                }
            };
            var onHistoryKeydown = function (event) {
                onHistoryKey(event, function () {
                    var editor2FieldsExist = document.querySelector('[sd-text-editor]') != null;
                    if (editor2FieldsExist) {
                        // preventing default generally breaks undo via ctrl+z for native inputs/textareas,
                        // but is required for editor2
                        event.preventDefault();
                    }
                    // action is on keydown becuase command key (event.metakey) on OSX is not detected on keyup events
                    // for some reason.
                    scope.$apply(function () {
                        KeyOperations[event.keyCode].bind(History)(expression, scope);
                    });
                });
            };
            var onHistoryKeyup = function (event) {
                onHistoryKey(event, function () {
                    event.preventDefault();
                });
            };
            angular.element($window).on('keydown', onHistoryKeydown);
            angular.element($window).on('keyup', onHistoryKeyup);
            scope.$on('$destroy', function () {
                angular.element($window).unbind('keydown', onHistoryKeydown);
                angular.element($window).unbind('keyup', onHistoryKeyup);
                History.forget(scope, expression);
            });
        },
    };
}
exports.HistoryFactory = HistoryFactory;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MediaIdGeneratorService.$inject = ['$q', 'api'];
function MediaIdGeneratorService($q, api) {
    var MEDIA_FIELD_FORMAT = /(\S+)--(\d+)/i;
    /**
     * @ngdoc method
     * @name MediaIdGeneratorService#getFieldVersionName
     * @public
     * @description Generates a new identifer based on the root field and the last version
     *
     * @param {String} rootField
     * @param {Integer} lastVersion
     * @return {String}
     */
    this.getFieldVersionName = function (rootField, lastVersion) {
        return lastVersion === null || lastVersion === undefined ? rootField : rootField + '--' + lastVersion;
    };
    /**
     * @ngdoc method
     * @name MediaIdGeneratorService#getFieldParts
     * @public
     * @description Splits an association field containing versioning in the
     *              root part and the version number and returns them in an array.
     * @param {string} fieldId
     * @return {Array}
     */
    this.getFieldParts = function (fieldId) {
        var match = MEDIA_FIELD_FORMAT.exec(fieldId);
        if (!match) {
            return [fieldId, null];
        }
        if (match.length === 3) {
            return [match[1], parseInt(match[2], 10)];
        }
        return [match[1], null];
    };
}
exports.MediaIdGeneratorService = MediaIdGeneratorService;


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Html5vfix_1 = __webpack_require__(1596);
exports.Html5vfix = Html5vfix_1.Html5vfix;
var DashboardCard_1 = __webpack_require__(1597);
exports.DashboardCard = DashboardCard_1.DashboardCard;
var SendItem_1 = __webpack_require__(1598);
exports.SendItem = SendItem_1.SendItem;
var CharacterCount_1 = __webpack_require__(1600);
exports.CharacterCount = CharacterCount_1.CharacterCount;
var WordCount_1 = __webpack_require__(1601);
exports.WordCount = WordCount_1.WordCount;
var ReadingTime_1 = __webpack_require__(1603);
exports.ReadingTime = ReadingTime_1.ReadingTime;
var ThemeSelectDirective_1 = __webpack_require__(1604);
exports.ThemeSelectDirective = ThemeSelectDirective_1.ThemeSelectDirective;
var ArticleEditDirective_1 = __webpack_require__(1605);
exports.ArticleEditDirective = ArticleEditDirective_1.ArticleEditDirective;
var AuthoringDirective_1 = __webpack_require__(1606);
exports.AuthoringDirective = AuthoringDirective_1.AuthoringDirective;
var AuthoringTopbarDirective_1 = __webpack_require__(1610);
exports.AuthoringTopbarDirective = AuthoringTopbarDirective_1.AuthoringTopbarDirective;
var PreviewFormattedDirective_1 = __webpack_require__(1611);
exports.PreviewFormattedDirective = PreviewFormattedDirective_1.PreviewFormattedDirective;
var AuthoringContainerDirective_1 = __webpack_require__(1612);
exports.AuthoringContainerDirective = AuthoringContainerDirective_1.AuthoringContainerDirective;
var AuthoringEmbeddedDirective_1 = __webpack_require__(1613);
exports.AuthoringEmbeddedDirective = AuthoringEmbeddedDirective_1.AuthoringEmbeddedDirective;
var AuthoringHeaderDirective_1 = __webpack_require__(1614);
exports.AuthoringHeaderDirective = AuthoringHeaderDirective_1.AuthoringHeaderDirective;
var ItemAssociationDirective_1 = __webpack_require__(1615);
exports.ItemAssociationDirective = ItemAssociationDirective_1.ItemAssociationDirective;
var ItemCarouselDirective_1 = __webpack_require__(1618);
exports.ItemCarouselDirective = ItemCarouselDirective_1.ItemCarouselDirective;
var FullPreviewDirective_1 = __webpack_require__(1621);
exports.FullPreviewDirective = FullPreviewDirective_1.FullPreviewDirective;
var RemoveTagsDirective_1 = __webpack_require__(1622);
exports.RemoveTagsDirective = RemoveTagsDirective_1.RemoveTagsDirective;
var TansaScopeSyncDirective_1 = __webpack_require__(1623);
exports.TansaScopeSyncDirective = TansaScopeSyncDirective_1.TansaScopeSyncDirective;
var ItemActionsByIntentDirective_1 = __webpack_require__(1624);
exports.ItemActionsByIntentDirective = ItemActionsByIntentDirective_1.ItemActionsByIntentDirective;


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Html5 Source tag doesn't support {{ angular }}
 */
function Html5vfix() {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            attr.$set('src', attr.vsrc);
        },
    };
}
exports.Html5vfix = Html5vfix;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function DashboardCard() {
    return {
        link: function (scope, elem) {
            var p = elem.parent();
            var maxW = p.parent().width();
            var marginW = parseInt(elem.css('margin-left'), 10) + parseInt(elem.css('margin-right'), 10);
            var newW = p.outerWidth() + elem.outerWidth() + marginW;
            if (newW < maxW) {
                p.outerWidth(newW);
            }
        },
    };
}
exports.DashboardCard = DashboardCard;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var react_1 = __importDefault(__webpack_require__(0));
var previewModal_1 = __webpack_require__(1599);
var utils_1 = __webpack_require__(3);
SendItem.$inject = ['$q', 'api', 'search', 'desks', 'notify', 'authoringWorkspace',
    'superdeskFlags', '$location', 'macros', '$rootScope', 'deployConfig',
    'authoring', 'send', 'editorResolver', 'confirm', 'archiveService',
    'preferencesService', 'multi', 'datetimeHelper', 'config', 'privileges',
    'storage', 'modal', 'urls', 'extensionPoints', 'metadata'];
function SendItem($q, api, search, desks, notify, authoringWorkspace, superdeskFlags, $location, macros, $rootScope, deployConfig, authoring, send, editorResolver, confirm, archiveService, preferencesService, multi, datetimeHelper, config, privileges, storage, modal, urls, extensionPoints, metadata) {
    return {
        scope: {
            item: '=',
            view: '=',
            orig: '=',
            _beforeSend: '&beforeSend',
            _editable: '=editable',
            _publish: '&publish',
            _action: '=action',
            autosave: '&',
            mode: '@',
        },
        controller: function () {
            this.userActions = {
                send_to: 'send_to',
                publish: 'publish',
                duplicate_to: 'duplicate_to',
                externalsource_to: 'externalsource_to',
                publish_pane_two_columns: false,
            };
        },
        controllerAs: 'vm',
        templateUrl: 'scripts/apps/authoring/views/send-item.html',
        link: function sendItemLink(scope, elem, attrs, ctrl) {
            scope.mode = scope.mode || 'authoring';
            scope.desks = null;
            scope.stages = null;
            scope.macros = null;
            scope.userDesks = null;
            scope.allDesks = null;
            scope.task = null;
            scope.selectedDesk = null;
            scope.selectedStage = null;
            scope.selectedMacro = null;
            scope.beforeSend = scope._beforeSend || $q.when;
            scope.destination_last = { send_to: null, publish: null, duplicate_to: null };
            scope.origItem = angular.extend({}, scope.item);
            scope.subscribersWithPreviewConfigured = [];
            // if authoring:publish extension point is not defined
            // then publish pane is single column
            ctrl.userActions.publish_pane_two_columns = !lodash_1.default.isEmpty(extensionPoints.get('authoring:publish'));
            // key for the storing last desk/stage in the user preferences for send action.
            var PREFERENCE_KEY = 'destination:active';
            // key for the storing last user action (send to/publish) in the storage.
            var USER_ACTION_KEY = 'send_to_user_action';
            scope.$watch('item', activateItem);
            scope.$watch(send.getConfig, activateConfig);
            scope.metadata = metadata.values;
            scope.publish = function () {
                scope.loading = true;
                var result = scope._publish();
                return $q
                    .resolve(result)
                    .then(null, function (e) { return $q.reject(false); })
                    .finally(function () {
                    scope.loading = false;
                });
            };
            function activateConfig(_config, oldConfig) {
                if (scope.mode !== 'authoring' && _config !== oldConfig) {
                    scope.isActive = !!_config;
                    scope.item = scope.isActive ? {} : null;
                    scope.multiItems = multi.count ? multi.getItems() : null;
                    scope.config = _config;
                    scope.isPackage = _config != null && _config.isPackage;
                    activate();
                }
            }
            function activateItem(item) {
                if (scope.mode === 'monitoring') {
                    superdeskFlags.flags.fetching = !!item;
                }
                scope.isActive = !!item;
                if (scope.config == null) {
                    scope.isPackage = item != null && item.type === 'composite';
                }
                activate();
            }
            function activate() {
                if (scope.isActive) {
                    api.query('subscribers')
                        .then(function (res) {
                        var allSubscribers = res['_items'];
                        scope.subscribersWithPreviewConfigured = allSubscribers
                            .map(function (subscriber) {
                            subscriber.destinations = subscriber.destinations.filter(function (destination) { return typeof destination.preview_endpoint_url === 'string'
                                && destination.preview_endpoint_url.length > 0; });
                            return subscriber;
                        })
                            .filter(function (subscriber) { return subscriber.destinations.length > 0; });
                    });
                    desks
                        .initialize()
                        .then(fetchDesks)
                        .then(initialize)
                        .then(setDesksAndStages);
                }
            }
            scope.preview = function () {
                if (scope.$parent.save_enabled() === true) {
                    modal.alert({
                        headerText: utils_1.gettext('Preview'),
                        bodyText: utils_1.gettext('In order to preview the item, save the changes first.'),
                    });
                }
                else {
                    modal.createCustomModal()
                        .then(function (_a) {
                        var openModal = _a.openModal, closeModal = _a.closeModal;
                        openModal(react_1.default.createElement(previewModal_1.PreviewModal, { subscribersWithPreviewConfigured: scope.subscribersWithPreviewConfigured, documentId: scope.item._id, urls: urls, closeModal: closeModal }));
                    });
                }
            };
            scope.close = function () {
                if (scope.mode === 'monitoring') {
                    superdeskFlags.flags.fetching = false;
                }
                if (scope.$parent.views) {
                    scope.$parent.views.send = false;
                }
                else if (scope.item) {
                    scope.item = null;
                }
                $location.search('fetch', null);
                if (scope.config) {
                    scope.config.reject();
                }
            };
            scope.selectDesk = function (desk) {
                scope.selectedDesk = lodash_1.default.cloneDeep(desk);
                scope.selectedStage = null;
                fetchStages();
                fetchMacros();
            };
            scope.selectStage = function (stage) {
                scope.selectedStage = stage;
            };
            scope.selectMacro = function (macro) {
                if (scope.selectedMacro === macro) {
                    scope.selectedMacro = null;
                }
                else {
                    scope.selectedMacro = macro;
                }
            };
            scope.send = function (open, sendAllPackageItems) {
                updateLastDestination();
                return runSend(open, sendAllPackageItems);
            };
            scope.isSendToNextStage = false;
            scope.$on('item:nextStage', function (_e, data) {
                if (!scope.item) {
                    scope.item = data.item;
                    scope.selectedStage = data.selectedStage;
                    scope.selectedDesk = data.selectedDesk;
                    scope.mode = 'authoring';
                    scope.isSendToNextStage = true;
                }
                if (scope.item && scope.item._id === data.itemId) {
                    var oldStage = scope.selectedStage;
                    scope.selectedStage = data.stage;
                    scope.send().then(function (sent) {
                        if (!sent) {
                            scope.selectedStage = oldStage;
                        }
                    });
                }
            });
            // events on which panel should close
            var closePanelEvents = ['item:spike', 'broadcast:preview'];
            angular.forEach(closePanelEvents, function (event) {
                scope.$on(event, shouldClosePanel);
            });
            /**
             * @description Closes the opened 'duplicate/send To' panel if the same item getting
             * spiked or any item is opening for authoring.
             * @param {Object} event
             * @param {Object} data - contains the item(=itemId) that was spiked or {item: null} when
             * any item opened for authoring (utilising, 'broadcast:preview' with {item: null})
             */
            function shouldClosePanel(event, data) {
                if ((scope.config != null && data != null && lodash_1.default.includes(scope.config.itemIds, data.item))
                    || (data == null || data.item == null)) {
                    scope.close();
                }
            }
            /*
             * Returns true if Destination field and Send button needs to be displayed, false otherwise.
             * @returns {Boolean}
             */
            scope.showSendButtonAndDestination = function () {
                if (scope.itemActions) {
                    var preCondition = scope.mode === 'ingest' ||
                        scope.mode === 'personal' ||
                        scope.mode === 'monitoring' ||
                        scope.mode === 'authoring' &&
                            scope.isSendEnabled() &&
                            scope.itemActions.send ||
                        scope.mode === 'spike';
                    if (scope.currentUserAction === ctrl.userActions.publish) {
                        return preCondition && scope.showSendAndPublish();
                    }
                    return preCondition;
                }
            };
            /*
             * Returns true if Send and Send and Continue button needs to be disabled, false otherwise.
             * @returns {Boolean}
             */
            scope.disableSendButton = function () {
                return !scope.selectedDesk ||
                    scope.mode !== 'ingest' && scope.selectedStage && scope.mode !== 'spike' &&
                        (lodash_1.default.get(scope, 'item.task.stage') === scope.selectedStage._id ||
                            lodash_1.default.includes(lodash_1.default.map(scope.multiItems, 'task.stage'), scope.selectedStage._id));
            };
            /*
             * Returns true if user is not a member of selected desk, false otherwise.
             * @returns {Boolean}
             */
            scope.disableFetchAndOpenButton = function () {
                if (scope.selectedDesk) {
                    var _isNonMember = lodash_1.default.isEmpty(lodash_1.default.find(desks.userDesks, { _id: scope.selectedDesk._id }));
                    return _isNonMember;
                }
            };
            /**
             * Returns true if Publish Schedule needs to be displayed, false otherwise.
             */
            scope.showPublishSchedule = function () {
                return scope.item && archiveService.getType(scope.item) !== 'ingest' &&
                    scope.item.type !== 'composite' && !scope.item.embargo_date && !scope.item.embargo_time &&
                    ['published', 'killed', 'corrected', 'recalled'].indexOf(scope.item.state) === -1 &&
                    canPublishOnDesk();
            };
            /**
             * Returns true if timezone needs to be displayed, false otherwise.
             */
            scope.showTimezone = function () {
                return (scope.item && (scope.item.publish_schedule || scope.item.embargo)) &&
                    (scope.showPublishSchedule() || scope.showEmbargo());
            };
            /**
             * Returns true if Embargo needs to be displayed, false otherwise.
             */
            scope.showEmbargo = function () {
                // If user doesn't have embargo privilege then don't display embargo fields
                if (!privileges.privileges.embargo) {
                    return false;
                }
                if (config.ui && config.ui.publishEmbargo === false) {
                    return false;
                }
                var prePublishCondition = scope.item && archiveService.getType(scope.item) !== 'ingest' &&
                    scope.item.type !== 'composite' && !scope.item.publish_schedule_date &&
                    !scope.item.publish_schedule_time;
                if (prePublishCondition && authoring.isPublished(scope.item)) {
                    if (['published', 'corrected'].indexOf(scope.item.state) >= 0) {
                        return scope.origItem.embargo;
                    }
                    // for published states other than 'published', 'corrected'
                    return false;
                }
                return prePublishCondition;
            };
            /**
             * Returns true if Embargo needs to be displayed, false otherwise.
             */
            scope.isEmbargoEditable = function () {
                var publishedCondition = authoring.isPublished(scope.item) && scope.item.schedule_settings &&
                    scope.item.schedule_settings.utc_embargo &&
                    datetimeHelper.greaterThanUTC(scope.item.schedule_settings.utc_embargo);
                return scope.item && scope.item._editable &&
                    (!authoring.isPublished(scope.item) || publishedCondition);
            };
            /**
             * Send the content to different desk/stage
             * @param {Boolean} open - True to open the item.
             * @param {Boolean} sendAllPackageItems - True to include all contained items for packages
             * @return {Object} promise
             */
            function runSend(open, sendAllPackageItems) {
                scope.loading = true;
                scope.item.sendTo = true;
                var deskId = scope.selectedDesk._id;
                var stageId = scope.selectedStage._id || scope.selectedDesk.incoming_stage;
                if (scope.mode === 'authoring') {
                    return sendAuthoring(deskId, stageId, scope.selectedMacro, sendAllPackageItems);
                }
                else if (scope.mode === 'archive') {
                    return sendContent(deskId, stageId, scope.selectedMacro, open);
                }
                else if (scope.config) {
                    var data_1 = {
                        desk: deskId,
                        stage: stageId,
                        macro: scope.selectedMacro ? scope.selectedMacro.name : null,
                        open: open,
                        sendAllPackageItems: sendAllPackageItems,
                    };
                    scope.config.promise.finally(function () {
                        scope.loading = false;
                    });
                    if (sendAllPackageItems && scope.config.packageItemIds) {
                        return containsPublishedItems(scope.config.packageItemIds).then(function (result) {
                            if (result) {
                                return confirmMovePackage().then(function () { return scope.config.resolve(data_1); }, function () { return scope.config.reject(); });
                            }
                            return scope.config.resolve(data_1);
                        });
                    }
                    return scope.config.resolve(data_1);
                }
                else if (scope.mode === 'ingest') {
                    return sendIngest(deskId, stageId, scope.selectedMacro, open);
                }
            }
            /**
             * Enable Disable the Send and Publish button.
             * Send And Publish is enabled using `superdesk.config.js`.
             */
            scope.showSendAndPublish = function () { return !config.ui || angular.isUndefined(config.ui.sendAndPublish) ||
                config.ui.sendAndPublish; };
            /**
             * Check if the Send and Publish is allowed or not.
             * Following conditions are to met for Send and Publish action
             * - Item is not Published i.e. not state Published, Corrected, Killed or Scheduled
             * - Selected destination (desk/stage) should be different from item current location (desk/stage)
             * - Mode should be authoring
             * - Publish Action is allowed on that item.
             * @return {Boolean}
             */
            scope.canSendAndPublish = function () {
                if (scope.mode !== 'authoring' || !scope.item) {
                    return false;
                }
                // Selected destination desk should be different from item current location desk
                var isDestinationChanged = scope.selectedDesk && scope.item.task.desk !== scope.selectedDesk._id;
                return scope.showSendAndPublish() && !authoring.isPublished(scope.item) &&
                    isDestinationChanged && scope.mode === 'authoring' && scope.itemActions.publish;
            };
            /**
             * Returns true if 'send' button should be displayed. Otherwise, returns false.
             * @return {boolean}
             */
            scope.isSendEnabled = function () { return scope.item && !authoring.isPublished(scope.item); };
            /*
             * Send the current item to different desk or stage and publish the item from new location.
             */
            scope.sendAndPublish = function () {
                return runSendAndPublish();
            };
            /*
             * Returns true if 'send' action is allowed, otherwise false
             * @returns {Boolean}
             */
            scope.canSendItem = function () {
                var itemType = [], typesList;
                if (scope.multiItems) {
                    angular.forEach(scope.multiItems, function (item) {
                        itemType[item._type] = 1;
                    });
                    typesList = Object.keys(itemType);
                    itemType = typesList.length === 1 ? typesList[0] : null;
                }
                return scope.mode === 'authoring' || itemType === 'archive' || scope.mode === 'spike' ||
                    (scope.mode === 'monitoring' && lodash_1.default.get(scope, 'config.action') === scope.vm.userActions.send_to);
            };
            /**
             * Check if it is allowed to publish on current desk
             * @returns {Boolean}
             */
            function canPublishOnDesk() {
                return !(isAuthoringDesk() && config.features.noPublishOnAuthoringDesk);
            }
            /**
             * If the action is correct and kill then the publish privilege needs to be checked.
             */
            scope.canPublishItem = function () {
                if (!scope.itemActions || !canPublishOnDesk()) {
                    return false;
                }
                if (scope._action === 'edit') {
                    return scope.item ? !scope.item.flags.marked_for_not_publication && scope.itemActions.publish :
                        scope.itemActions.publish;
                }
                else if (scope._action === 'correct') {
                    return privileges.privileges.publish && scope.itemActions.correct;
                }
                else if (scope._action === 'kill') {
                    return privileges.privileges.publish && scope.itemActions.kill;
                }
                return false;
            };
            /**
             * Set the User Action.
             */
            scope.setUserAction = function (action) {
                if (scope.currentUserAction === action) {
                    return;
                }
                scope.currentUserAction = action;
                storage.setItem(USER_ACTION_KEY, action);
                setDesksAndStages();
            };
            /**
             * Checks if a given item is valid to publish
             *
             * @param {Object} item story to be validated
             * @return {Object} promise
             */
            var validatePublish = function (item) { return api.save('validate', { act: 'publish', type: item.type, validate: item }); };
            /**
             * Sends and publishes the current item in scope
             * First checks if the item is dirty and pops up save dialog if needed
             * Then checks if the story is valid to publish before sending
             * Then sends the story to the destination
             * Then publishes it
             *
             * @param {Object} item story to be validated
             * @return {Object} promise
             */
            var runSendAndPublish = function () {
                var deskId = scope.selectedDesk._id;
                var stageId = scope.selectedStage._id || scope.selectedDesk.incoming_stage;
                // send releases lock, increment version.
                return scope.beforeSend({ action: 'Send and Publish' })
                    .then(function () { return validatePublish(scope.item)
                    .then(function (validationResult) {
                    if (lodash_1.default.get(validationResult, 'errors.length')) {
                        for (var i = 0; i < validationResult.errors.length; i++) {
                            notify.error('\'' + lodash_1.default.trim(validationResult.errors[i]) + '\'');
                        }
                        return $q.reject();
                    }
                    return sendAuthoring(deskId, stageId, scope.selectedMacro, false)
                        .then(function (item) {
                        scope.loading = true;
                        // open the item for locking and publish
                        return authoring.open(scope.item._id, false);
                    })
                        .then(function (item) {
                        // update the original item to avoid 412 error.
                        scope.orig._etag = scope.item._etag = item._etag;
                        scope.orig._locked = scope.item._locked = item._locked;
                        scope.orig.task = scope.item.task = item.task;
                        // change the desk location.
                        $rootScope.$broadcast('desk_stage:change');
                        // if locked then publish
                        if (item._locked) {
                            return scope.publish();
                        }
                        return $q.reject();
                    })
                        .then(function (result) {
                        if (result) {
                            authoringWorkspace.close(false);
                        }
                    })
                        .catch(function (error) {
                        notify.error(utils_1.gettext('Failed to send and publish.'));
                    });
                })
                    .finally(function () {
                    scope.loading = false;
                }); });
            };
            /**
             * Run the macro and returns to the modified item.
             * @param {Object} item
             * @param {String} macro
             * @return {Object} promise
             */
            function runMacro(item, macro) {
                if (macro) {
                    return macros.call(macro, item, true).then(function (res) { return angular.extend(item, res); });
                }
                return $q.when(item);
            }
            var confirmMovePackage = function () {
                return modal.confirm(utils_1.gettext('The package contains published items which can\'t be moved.'), utils_1.gettext('Warning'), utils_1.gettext('Continue'), utils_1.gettext('Cancel'));
            };
            var containsPublishedItems = function (items) {
                var query = search.query();
                query.clear_filters();
                query.size(1).filter({ terms: { guid: items } });
                var criteria = query.getCriteria(true);
                criteria.repo = 'published';
                return api.query('search', criteria)
                    .then(function (result) { return result._items.length === 1; });
            };
            /**
             * Send to different location from authoring.
             * @param {String} deskId - selected desk Id
             * @param {String} stageId - selected stage Id
             * @param {String} macro - macro to apply
             * @param {Boolean} sendAllPackageItems - True to include all contained items for packages
             * @return {Object} promise
             */
            function sendAuthoring(deskId, stageId, macro, sendAllPackageItems) {
                var msg;
                scope.loading = true;
                return runMacro(scope.item, macro)
                    .then(function (item) {
                    if (!sendAllPackageItems) {
                        return $q.when(item);
                    }
                    var items = send.getItemsFromPackages([item]);
                    return containsPublishedItems(items).then(function (result) {
                        if (result) {
                            return confirmMovePackage().then(function () { return $q.when(item); }, function () { return $q.reject(); });
                        }
                        return $q.when(item);
                    });
                })
                    .then(function (item) { return api.find('tasks', scope.item._id)
                    .then(function (task) {
                    scope.task = task;
                    msg = 'Send';
                    return scope.beforeSend({ action: msg });
                })
                    .then(function (result) {
                    if (result && result._etag) {
                        scope.task._etag = result._etag;
                    }
                    return api.save('move', {}, {
                        task: { desk: deskId, stage: stageId },
                        allPackageItems: sendAllPackageItems,
                    }, scope.item);
                })
                    .then(function (value) {
                    notify.success(utils_1.gettext('Item sent.'));
                    if (scope.currentUserAction === ctrl.userActions.send_to) {
                        // Remember last destination desk and stage for send_to.
                        var lastDestination = scope.destination_last[scope.currentUserAction];
                        if (!lastDestination ||
                            (lastDestination.desk !== deskId || lastDestination.stage !== stageId)) {
                            updateLastDestination();
                        }
                    }
                    authoringWorkspace.close(true);
                    return true;
                }, function (err) {
                    if (err) {
                        if (angular.isDefined(err.data._message)) {
                            notify.error(err.data._message);
                        }
                        else if (angular.isDefined(err.data._issues['validator exception'])) {
                            notify.error(err.data._issues['validator exception']);
                        }
                    }
                }); })
                    .finally(function () {
                    scope.loading = false;
                });
            }
            /**
             * Update the preferences to store last destinations
             * @param {String} key
             */
            function updateLastDestination() {
                var updates = {};
                var deskId = scope.selectedDesk._id;
                var stageId = scope.selectedStage._id || scope.selectedDesk.incoming_stage;
                updates[PREFERENCE_KEY] = { desk: deskId, stage: stageId };
                preferencesService.update(updates, PREFERENCE_KEY);
            }
            /**
             * Send content to different desk and stage
             * @param {String} deskId
             * @param {String} stageId
             * @param {String} macro
             * @param {Boolean} open - If true open the item.
             */
            function sendContent(deskId, stageId, macro, open) {
                var finalItem;
                scope.loading = true;
                return api.save('duplicate', {}, { desk: scope.item.task.desk }, scope.item)
                    .then(function (item) { return api.find('archive', item._id); })
                    .then(function (item) { return runMacro(item, macro); })
                    .then(function (item) {
                    finalItem = item;
                    return api.find('tasks', item._id);
                })
                    .then(function (_task) {
                    scope.task = _task;
                    api.save('tasks', scope.task, {
                        task: lodash_1.default.extend(scope.task.task, { desk: deskId, stage: stageId }),
                    });
                })
                    .then(function () {
                    notify.success(utils_1.gettext('Item sent.'));
                    scope.close();
                    if (open) {
                        $location.url('/authoring/' + finalItem._id);
                    }
                    else {
                        $rootScope.$broadcast('item:fetch');
                    }
                })
                    .finally(function () {
                    scope.loading = false;
                });
            }
            /**
             * Fetch content from ingest to a different desk and stage
             * @param {String} deskId
             * @param {String} stageId
             * @param {String} macro
             * @param {Boolean} open - If true open the item.
             */
            function sendIngest(deskId, stageId, macro, open) {
                scope.loading = true;
                return send.oneAs(scope.item, {
                    desk: deskId,
                    stage: stageId,
                    macro: macro ? macro.name : macro,
                }).then(function (finalItem) {
                    notify.success(utils_1.gettext('Item fetched.'));
                    if (open) {
                        authoringWorkspace.edit(finalItem);
                    }
                    else {
                        $rootScope.$broadcast('item:fetch');
                    }
                })
                    .finally(function () {
                    scope.loading = false;
                });
            }
            /**
             * Fetch desk and last selected desk and stage for send_to and publish action
             * @return {Object} promise
             */
            function fetchDesks() {
                return desks.initialize()
                    .then(function () {
                    // get all desks
                    scope.allDesks = desks.desks._items;
                    // get user desks
                    return desks.fetchCurrentUserDesks();
                })
                    .then(function (deskList) {
                    scope.userDesks = deskList;
                    return preferencesService.get(PREFERENCE_KEY);
                })
                    .then(function (result) {
                    if (result) {
                        scope.destination_last.send_to = {
                            desk: result.desk,
                            stage: result.stage,
                        };
                        scope.destination_last.duplicate_to = {
                            desk: result.desk,
                            stage: result.stage,
                        };
                    }
                });
            }
            /**
             * Set the last selected desk based on the user action.
             * To be called after currentUserAction is set
             */
            function setDesksAndStages() {
                if (!scope.currentUserAction) {
                    return;
                }
                // set the desks for desk filter
                if (scope.currentUserAction === ctrl.userActions.publish) {
                    scope.desks = scope.userDesks;
                }
                else {
                    scope.desks = scope.allDesks;
                }
                if (scope.mode === 'ingest') {
                    scope.selectDesk(desks.getCurrentDesk());
                }
                else {
                    // set the last selected desk or current desk
                    var itemDesk = desks.getItemDesk(scope.item);
                    var lastDestination = scope.destination_last[scope.currentUserAction];
                    if (itemDesk) {
                        if (lastDestination && !lodash_1.default.isNil(lastDestination.desk)) {
                            scope.selectDesk(desks.deskLookup[lastDestination.desk]);
                        }
                        else {
                            scope.selectDesk(itemDesk);
                        }
                    }
                    else if (lastDestination && !lodash_1.default.isNil(lastDestination.desk)) {
                        scope.selectDesk(desks.deskLookup[lastDestination.desk]);
                    }
                    else {
                        scope.selectDesk(desks.getCurrentDesk());
                    }
                }
            }
            /**
             * Set stages and last selected stage.
             */
            function fetchStages() {
                if (!scope.selectedDesk) {
                    return;
                }
                scope.stages = desks.deskStages[scope.selectedDesk._id];
                var stage = null;
                if (scope.currentUserAction === ctrl.userActions.send_to ||
                    scope.currentUserAction === ctrl.userActions.duplicate_to) {
                    var lastDestination = scope.destination_last[scope.currentUserAction];
                    if (lastDestination) {
                        stage = lodash_1.default.find(scope.stages, { _id: lastDestination.stage });
                    }
                    else if (scope.item.task && scope.item.task.stage) {
                        stage = lodash_1.default.find(scope.stages, { _id: scope.item.task.stage });
                    }
                }
                if (!stage) {
                    stage = lodash_1.default.find(scope.stages, { _id: scope.selectedDesk.incoming_stage });
                }
                scope.selectedStage = stage;
            }
            /**
             * Fetch macros for the selected desk.
             */
            function fetchMacros() {
                if (!scope.selectedDesk) {
                    return;
                }
                macros.getByDesk(scope.selectedDesk.name)
                    .then(function (_macros) {
                    scope.macros = _macros;
                });
            }
            /**
             * Initialize Item Actios and User Actions.
             */
            function initialize() {
                initializeItemActions();
                initializeUserAction();
            }
            /**
             * Initialize User Action
             */
            function initializeUserAction() {
                // default user action
                scope.currentUserAction = storage.getItem(USER_ACTION_KEY) || ctrl.userActions.send_to;
                if (scope.orig || scope.item) {
                    if (scope.config && scope.config.action === 'externalsourceTo') {
                        scope.currentUserAction = ctrl.userActions.externalsource_to;
                    }
                    // if the last action is send to but item is published open publish tab.
                    if (scope.config && scope.config.action === 'duplicateTo') {
                        scope.currentUserAction = ctrl.userActions.duplicate_to;
                    }
                    if (scope.currentUserAction === ctrl.userActions.send_to &&
                        scope.canPublishItem() && !scope.isSendEnabled()) {
                        scope.currentUserAction = ctrl.userActions.publish;
                    }
                    else if (scope.currentUserAction === ctrl.userActions.publish &&
                        !scope.canPublishItem() && scope.showSendButtonAndDestination()) {
                        scope.currentUserAction = ctrl.userActions.send_to;
                    }
                    else if (scope.currentUserAction === ctrl.userActions.publish &&
                        isAuthoringDesk() && noPublishOnAuthoringDesk()) {
                        scope.currentUserAction = ctrl.userActions.send_to;
                    }
                }
            }
            /**
             * The itemActions defined in parent scope (Authoring Directive) is made accessible via this method.
             * scope.$parent isn't used as send-item directive is used in multiple places and has different
             * hierarchy.
             */
            function initializeItemActions() {
                if (scope.orig || scope.item) {
                    scope.itemActions = authoring.itemActions(scope.orig || scope.item);
                }
            }
            /**
             * Test if desk of current item is authoring type.
             *
             * @return {Boolean}
             */
            function isAuthoringDesk() {
                if (!lodash_1.default.get(scope, 'item.task.desk')) {
                    return false;
                }
                var desk = desks.getItemDesk(scope.item);
                return desk && desk.desk_type === 'authoring';
            }
            /**
             * Test if noPublishOnAuthoringDesk config is active.
             *
             * @return {Boolean}
             */
            function noPublishOnAuthoringDesk() {
                return config.features.noPublishOnAuthoringDesk;
            }
            // update actions on item save
            scope.$watch('orig._current_version', initializeItemActions);
        },
    };
}
exports.SendItem = SendItem;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var Modal_1 = __webpack_require__(383);
var ModalHeader_1 = __webpack_require__(170);
var ModalBody_1 = __webpack_require__(171);
var ModalFooter_1 = __webpack_require__(172);
var utils_1 = __webpack_require__(3);
var getFormattedDocument = function (url) { return fetch(url).then(function (response) { return response.text()
    .then(function (responseText) { return ({
    fomattedDocument: responseText,
    documentContentType: response.headers.get('content-type'),
}); }); }); };
var PreviewModal = /** @class */ (function (_super) {
    __extends(PreviewModal, _super);
    function PreviewModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewModal.prototype.openPreviewForItem = function (subscriberId, format, endpointUrl) {
        var _a = this.props, urls = _a.urls, documentId = _a.documentId;
        var nextWindow = window.open();
        nextWindow.document.body.innerText = utils_1.gettext('Loading preview');
        var url = urls.item('format-document-for-preview')
            + ("?subscriber_id=" + subscriberId + "&formatter=" + format + "&document_id=" + documentId);
        getFormattedDocument(url).then(function (_a) {
            var fomattedDocument = _a.fomattedDocument, documentContentType = _a.documentContentType;
            var headers = new Headers();
            headers.append('Content-Type', documentContentType);
            fetch(endpointUrl, {
                method: 'POST',
                mode: 'cors',
                body: fomattedDocument,
                headers: headers,
            })
                .then(function (res) { return res.text().then(function (responseText) {
                if (res.status === 200) {
                    nextWindow.document.body.innerHTML = responseText;
                }
                else {
                    nextWindow.document.body.innerHTML =
                        "<h1>" + utils_1.gettext('An error occured while trying to preview the item.') + "</h1>"
                            + ("<p>" + utils_1.gettext('Ensure correct preview endpoint is configured'
                                + ' or contact endpoint maintainers.') + "</p>")
                            + '<br /><br />' + responseText;
                }
            }); });
        });
    };
    PreviewModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeModal = _a.closeModal, subscribersWithPreviewConfigured = _a.subscribersWithPreviewConfigured;
        return (react_1.default.createElement(Modal_1.Modal, null,
            react_1.default.createElement(ModalHeader_1.ModalHeader, null, utils_1.gettext('Select preview target')),
            react_1.default.createElement(ModalBody_1.ModalBody, null,
                react_1.default.createElement("ul", null, subscribersWithPreviewConfigured.map(function (subscriber, i) { return (react_1.default.createElement("li", { key: i },
                    react_1.default.createElement("strong", null, subscriber.name),
                    react_1.default.createElement("ul", null, subscriber.destinations.map(function (destination, j) { return (react_1.default.createElement("li", { key: j, style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            margin: '4px 0',
                        } },
                        react_1.default.createElement("span", null, destination.name),
                        react_1.default.createElement("button", { className: "btn btn--primary btn--small", onClick: function () {
                                _this.openPreviewForItem(subscriber._id, destination.format, destination.preview_endpoint_url);
                            } }, utils_1.gettext('preview')))); })))); }))),
            react_1.default.createElement(ModalFooter_1.ModalFooter, null,
                react_1.default.createElement("button", { className: "btn", onClick: closeModal }, utils_1.gettext('Cancel')))));
    };
    return PreviewModal;
}(react_1.default.Component));
exports.PreviewModal = PreviewModal;
PreviewModal.propTypes = {
    subscribersWithPreviewConfigured: prop_types_1.default.array.isRequired,
    documentId: prop_types_1.default.string.isRequired,
    urls: prop_types_1.default.object.isRequired,
    closeModal: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __importStar(__webpack_require__(72));
var utils_1 = __webpack_require__(3);
CharacterCount.$inject = [];
function CharacterCount() {
    return {
        scope: {
            item: '=',
            limit: '=',
            html: '@',
        },
        template: '<span class="char-count" ng-class="{error: limit && numChars > limit}"> ' +
            utils_1.gettext('characters') + '</span>' +
            '<span class="char-count" ng-class="{error: limit && numChars > limit}">{{numChars}}' +
            '<span ng-if="limit" ng-class="{error: limit && numChars > limit}">/{{ limit }}</span></span>',
        link: function characterCountLink(scope, elem, attrs) {
            scope.html = scope.html || false;
            scope.numChars = 0;
            scope.$watch('item', function () {
                var input = scope.item || '';
                input = scope.html ? helpers.cleanHtml(input) : input;
                input = input.replace(/\r?\n|\r/g, '');
                scope.numChars = input.length || 0;
            });
        },
    };
}
exports.CharacterCount = CharacterCount;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __importStar(__webpack_require__(72));
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdWordCount
 * @description Display the number of words in an item.
 *
 * @param {String} item text to use
 */
function WordCount() {
    return {
        scope: {
            item: '=',
            html: '@',
            countOnly: '@',
        },
        template: __webpack_require__(1602),
        link: function wordCountLink(scope, elem, attrs) {
            /* This pattern matches http(s) links, numbers (1.000.000 or 1,000,000 or 1 000 000), regulars words,
            compound words (e.g. "two-done") or abbreviation (e.g. D.C.)
            If you modify, please keep in sync with superdesk-core/superdesk/text_utils.py
            */
            var WORD_PATTERN = /https?:[^ ]*|([0-9]+[,. ]?)+|([\w]\.)+|[\w][\w-]*/g;
            scope.html = scope.html || false;
            scope.countOnly = scope.countOnly || false;
            scope.numWords = 0;
            scope.$watch('item', function () {
                var input = scope.item || '';
                input = scope.html ? helpers.cleanHtml(input) : input;
                scope.numWords = (input.match(WORD_PATTERN) || '').length;
            });
        },
    };
}
exports.WordCount = WordCount;


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"!countOnly\" class=\"char-count words\" translate>{{numWords}} words</span>\n<span ng-if=\"countOnly\" class=\"char-count words\">{{numWords}}</span>";

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var helpers_1 = __webpack_require__(72);
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdReadingTime
 * @description Display the estimated number of minutes needed to read an item.
 * @param {String} item text to estimate
 */
function ReadingTime(deployConfig) {
    return {
        scope: {
            item: '=',
            html: '@',
            language: '=',
        },
        template: '<span ng-if="readingTime==0" class="char-count reading-time" translate>' +
            'less than one minute read</span>' +
            '<span ng-if="readingTime>0" class="char-count reading-time" translate>' +
            '{{readingTime}} min read</span>',
        link: function ReadingTimeLink(scope, elem, attrs) {
            scope.$watchGroup(['item', 'language'], function () {
                var html = scope.html, item = scope.item, language = scope.language;
                var input = html ? helpers_1.cleanHtml(item || '') : item || '';
                var readingTimeFloat = getReadingTime(input, language);
                var readingTimeMinutes = Math.floor(readingTimeFloat);
                var readingRemainingSec = Math.floor((readingTimeFloat - readingTimeMinutes) * 60);
                if (readingRemainingSec >= 30) {
                    readingTimeMinutes++;
                }
                scope.readingTime = readingTimeMinutes;
            });
        },
    };
    function getReadingTime(input, language) {
        if (language && language.startsWith('ja')) {
            return lodash_1.filter(input, function (x) { return !!lodash_1.trim(x); }).length / deployConfig.getSync('japanese_characters_per_minute', 600);
        }
        var numWords = lodash_1.compact(input.split(/\s+/)).length || 0;
        return numWords / 250;
    }
}
exports.ReadingTime = ReadingTime;
ReadingTime.$inject = ['deployConfig'];


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ThemeSelectDirective.$inject = ['authThemes'];
function ThemeSelectDirective(authThemes) {
    return {
        templateUrl: 'scripts/apps/authoring/views/theme-select.html',
        scope: { key: '@' },
        link: function themeSelectLink(scope, elem) {
            var DEFAULT_CLASS = 'main-article theme-container';
            scope.themes = authThemes.availableThemes;
            authThemes.get('theme').then(function (theme) {
                scope.themePref = theme;
                scope.applyTheme('theme', theme);
            });
            authThemes.get('proofreadTheme').then(function (theme) {
                scope.proofreadThemePref = theme;
                scope.applyTheme('proofreadTheme', theme);
            });
            /*
             * Color Theme picker
             * @param {string} key Color key
             */
            scope.pickTheme = function (themeKey, color) {
                scope[themeKey].theme = color;
            };
            scope.applyTheme = function (key, theme) {
                if (scope.key !== key) {
                    return false;
                }
                var themeClasses = '';
                angular.forEach(theme, function (value, _key) {
                    themeClasses += ' sd-editor--' + _key + '-' + value;
                });
                angular.element('.page-content-container')
                    .children('.theme-container')
                    .attr('class', DEFAULT_CLASS)
                    .addClass(themeClasses);
            };
            scope.saveTheme = function () {
                scope.applyTheme('theme', scope.themePref);
                scope.applyTheme('proofreadTheme', scope.proofreadThemePref);
                authThemes.save('theme', scope.themePref);
                authThemes.save('proofreadTheme', scope.proofreadThemePref);
                return scope.closeModal();
            };
            scope.closeModal = function () { return scope.modalEditorConfig = false; };
        },
    };
}
exports.ThemeSelectDirective = ThemeSelectDirective;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var fieldsMeta_1 = __webpack_require__(66);
var getLabelForFieldId_1 = __webpack_require__(62);
var constants_1 = __webpack_require__(158);
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdArticleEdit
 *
 * @requires autosave
 * @requires authoring
 * @requires metadata
 * @requires $filter
 * @requires superdesk
 * @requires content
 * @requires config
 * @requires deployConfig
 * @requires session
 * @requires history
 * @requires $interpolate
 * @requires suggest
 * @requires renditions
 *
 * @description
 *   This directive is responsible for generating handles editing of the main text fields of the item in authoring.
 *   It is also used in the Template Editor and for Archived Kill item.
 */
ArticleEditDirective.$inject = [
    'autosave',
    'authoring',
    'metadata',
    '$filter',
    'superdesk',
    'content',
    'config',
    'deployConfig',
    'session',
    'history',
    '$interpolate',
    'suggest',
    'renditions',
];
function ArticleEditDirective(autosave, authoring, metadata, $filter, superdesk, content, config, deployConfig, session, history, $interpolate, suggest, renditions) {
    return {
        templateUrl: 'scripts/apps/authoring/views/article-edit.html',
        link: function (scope, elem) {
            getLabelForFieldId_1.getLabelNameResolver().then(function (getLabelForFieldId) {
                scope.handleUrlsChange = function (fieldId, value) {
                    scope.item.extra[fieldId] = value;
                    scope.autosave(scope.item);
                };
                scope.toggleDetails = true;
                scope.errorMessage = null;
                scope.contentType = null;
                scope.canListEditSignOff = config.user && config.user.sign_off_mapping;
                scope.editSignOff = false;
                scope.mediaLoading = false;
                scope.validator = deployConfig.getSync('validator_media_metadata');
                scope.features = config.features;
                var mainEditScope = scope.$parent.$parent;
                var autopopulateByline = config.features && config.features.autopopulateByline;
                scope.label = function (id) { return getLabelForFieldId(id); };
                scope.FIELD_KEY_SEPARATOR = fieldsMeta_1.FIELD_KEY_SEPARATOR;
                scope.mediaTypes = constants_1.MEDIA_TYPES;
                /* Start: Dateline related properties */
                scope.monthNames = { Jan: '0', Feb: '1', Mar: '2', Apr: '3', May: '4', Jun: '5',
                    Jul: '6', Aug: '7', Sep: '8', Oct: '9', Nov: '10', Dec: '11' };
                scope.dateline = {
                    month: '',
                    day: '',
                };
                scope.preview = function (item) {
                    superdesk.intent('preview', 'item', item);
                };
                /* End: Dateline related properties */
                // watch item and save every change in history in order to perform undo/redo later
                // ONLY for editor2 (with blocks)
                try {
                    angular.module('superdesk.apps.editor2');
                    history.watch('item', mainEditScope || scope);
                }
                catch (e) {
                    // no-op
                }
                scope.$on('History.undone', triggerAutosave);
                scope.$on('History.redone', triggerAutosave);
                function triggerAutosave() {
                    if (mainEditScope) {
                        mainEditScope.$applyAsync(function () {
                            mainEditScope.autosave(mainEditScope.item);
                        });
                    }
                }
                scope.$watch('item', function (item) {
                    if (item) {
                        /* Creates a copy of dateline object from item.__proto__.dateline */
                        if (item.dateline) {
                            var updates = { dateline: {} };
                            updates.dateline = lodash_1.default.pick(item.dateline, ['source', 'date', 'located', 'text']);
                            if (item.dateline.located) {
                                var monthAndDay = $filter('parseDateline')(item.dateline.date, item.dateline.located);
                                scope.dateline.month = monthAndDay.month;
                                scope.dateline.day = monthAndDay.day;
                                scope.resetNumberOfDays(false);
                            }
                            lodash_1.default.extend(item, updates);
                        }
                        if (autopopulateByline && !item.byline) {
                            item.byline = session.identity.byline;
                        }
                    }
                });
                metadata.initialize().then(function () {
                    scope.metadata = metadata.values;
                    if (scope.item && !scope.item.sign_off) {
                        scope.modifySignOff(session.identity);
                    }
                });
                /**
                 * Invoked by the directive after updating the property in item. This method is responsible for updating
                 * the properties dependent on dateline.
                 */
                scope.updateDateline = function (item, city) {
                    var currentItem = lodash_1.default.cloneDeep(item);
                    if (city === '') {
                        currentItem.dateline.date = null;
                        currentItem.dateline.located = null;
                        currentItem.dateline.text = '';
                        scope.dateline.month = '';
                        scope.dateline.day = '';
                    }
                    else {
                        var monthAndDay = $filter('parseDateline')(currentItem.dateline.date, currentItem.dateline.located);
                        scope.dateline.month = monthAndDay.month;
                        scope.dateline.day = monthAndDay.day;
                        scope.resetNumberOfDays(false);
                        if (!currentItem.dateline.date) {
                            currentItem.dateline.date = $filter('relativeUTCTimestamp')(scope.item.dateline.located, parseInt(scope.dateline.month, 10), parseInt(scope.dateline.day, 10));
                        }
                        currentItem.dateline.text = $filter('formatDatelineText')(currentItem.dateline.located, $interpolate('{{ month | translate }}')({
                            month: lodash_1.default.findKey(scope.monthNames, function (m) { return m === scope.dateline.month; }),
                        }), scope.dateline.day, currentItem.source);
                    }
                    scope.autosave(currentItem);
                };
                /**
                 * Invoked when user changes a month in the datelineMonth.
                 * Populates the datelineDay field with the days in the selected month.
                 *
                 * @param {Boolean} resetDatelineDate if true resets the dateline.date to be relative to selected date.
                 * @param {String} datelineMonth - the selected month
                 */
                scope.resetNumberOfDays = function (resetDatelineDate, datelineMonth) {
                    if (scope.dateline.month !== '') {
                        scope.daysInMonth = $filter('daysInAMonth')(parseInt(scope.dateline.month, 10));
                        if (resetDatelineDate) {
                            if (datelineMonth) {
                                scope.dateline.month = datelineMonth;
                            }
                            scope.modifyDatelineDate(scope.dateline.day);
                        }
                    }
                    else {
                        scope.daysInMonth = [];
                        scope.dateline.day = '';
                    }
                };
                /**
                 * Return current signoff mapping
                 */
                scope.getSignOffMapping = function () {
                    if (config.user && config.user.sign_off_mapping) {
                        return config.user.sign_off_mapping;
                    }
                    return null;
                };
                /**
                 * Modify the sign-off with the value from sign_off_mapping field from user
                 */
                scope.modifySignOff = function (user) {
                    if (config.user && config.user.sign_off_mapping) {
                        scope.item.sign_off = user[config.user.sign_off_mapping];
                        autosave.save(scope.item, scope.origItem);
                    }
                };
                /**
                 * Update the sign-off with current search value
                 */
                scope.searchSignOff = function (search) {
                    scope.item.sign_off = search;
                    autosave.save(scope.item, scope.origItem);
                };
                /**
                 * Change the edit mode for Sign-Off input
                 */
                scope.changeSignOffEdit = function () {
                    scope.editSignOff = !scope.editSignOff;
                };
                /**
                 * Updates the sign_off field with the new value generated on the server side
                 * once the story is saved
                 */
                scope.$watch('origItem.sign_off', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        scope.item.sign_off = newValue;
                    }
                });
                /**
                 * Invoked when user selects a different day in dateline day list. This method calculates the
                 * relative UTC based on the new values of month and day and sets to dateline.date.
                 *
                 * @param {String} datelineDay - the selected day
                 */
                scope.modifyDatelineDate = function (datelineDay) {
                    if (scope.dateline.month !== '' && scope.dateline.day !== '') {
                        if (datelineDay) {
                            scope.dateline.day = datelineDay;
                        }
                        scope.item.dateline.date = $filter('relativeUTCTimestamp')(scope.item.dateline.located, parseInt(scope.dateline.month, 10), parseInt(scope.dateline.day, 10));
                        scope.item.dateline.text = $filter('formatDatelineText')(scope.item.dateline.located, $interpolate('{{ month | translate }}')({
                            month: lodash_1.default.findKey(scope.monthNames, function (m) { return m === scope.dateline.month; }),
                        }), scope.dateline.day, scope.item.dateline.source);
                        mainEditScope.dirty = true;
                        autosave.save(scope.item, scope.origItem);
                    }
                };
                /**
                 * @ngdoc method
                 * @name sdArticleEdit#editMedia
                 *
                 * @description Opens the Change Image Controller to modify the image metadata.
                 */
                scope.editMedia = function (defaultTab) {
                    if (defaultTab === void 0) { defaultTab = 'view'; }
                    var showTabs = [];
                    scope.mediaLoading = true;
                    if (scope.item.type === 'picture' && scope.metadata.crop_sizes) {
                        showTabs = ['view', 'image-edit', 'crop'];
                    }
                    else if (scope.item.type === 'picture' && !scope.metadata.crop_sizes) {
                        showTabs = ['view', 'image-edit'];
                    }
                    else {
                        showTabs = ['view'];
                    }
                    return renditions.crop(scope.item, {
                        isNew: false,
                        editable: true,
                        isAssociated: false,
                        defaultTab: defaultTab,
                        tabs: showTabs,
                        showMetadata: true,
                    })
                        .then(function (picture) {
                        scope.item._etag = picture._etag;
                        if (authoring.isPublished(scope.item)) {
                            mainEditScope.dirty = true;
                            // mark dirty in multiedit mode.
                            if (scope.articleEdit) {
                                scope.articleEdit.$setDirty();
                            }
                        }
                        else {
                            scope.save();
                        }
                    })
                        .finally(function () {
                        scope.mediaLoading = false;
                    });
                };
                /**
                 * @ngdoc method
                 * @name sdArticleEdit#applycrop
                 *
                 * @description Opens the Change Image Controller to modify the image metadata and crops.
                 */
                scope.applyCrop = function () {
                    return this.editMedia('crop');
                };
                /**
                 * Adds the selected Helpline to the item allowing user for further edit.
                 */
                scope.addHelplineToFooter = function () {
                    // determine and ignore if footer text have empty tags
                    var container = document.createElement('div');
                    container.innerHTML = scope.item.body_footer;
                    if (!scope.item.body_footer || container.textContent === '') {
                        scope.item.body_footer = '';
                    }
                    if (scope.extra.body_footer_value) {
                        scope.item.body_footer = scope.item.body_footer + scope.extra.body_footer_value.value;
                        mainEditScope.dirty = true;
                        autosave.save(scope.item, scope.origItem);
                    }
                    // first option should always be selected, as multiple helplines could be added in footer
                    lodash_1.default.defer(function () {
                        var ddlHelpline = elem.find('#helplines');
                        ddlHelpline[0].options[0].selected = true;
                    });
                };
                // Returns the maximum number upload files
                scope.maxUploads = function (fieldOptions) {
                    if (fieldOptions && fieldOptions.multiple_items &&
                        fieldOptions.multiple_items.enabled) {
                        return fieldOptions.multiple_items.max_items ? fieldOptions.multiple_items.max_items : 0;
                    }
                    return 1;
                };
                scope.toggleSMS = function () {
                    var isMarked = lodash_1.default.get(scope, 'item.flags.marked_for_sms');
                    var field = lodash_1.default.get(scope, 'editor.sms.sourceField', 'abstract');
                    if (isMarked) {
                        scope.item.sms_message = scope.item.sms_message || scope.item[field] || '';
                    }
                    else if (scope.item) {
                        scope.item.sms_message = '';
                    }
                };
                scope.$watch('item.body_html', function () { return suggest.trigger(scope.item, scope.origItem); });
                scope.$watch('item.profile', function (profile) {
                    if (profile) {
                        content.getType(profile)
                            .then(function (type) {
                            scope.contentType = type;
                            scope.editor = authoring.editor = content.editor(type, scope.item.type);
                            scope.schema = authoring.schema = content.schema(type, scope.item.type);
                            scope.fields = content.fields(type);
                        });
                    }
                    else {
                        scope.editor = authoring.editor = content.editor(null, scope.item.type);
                        scope.schema = authoring.schema = content.schema(null, scope.item.type);
                        scope.fields = null;
                    }
                });
                scope.extra = {}; // placeholder for fields not part of item
            });
        },
    };
}
exports.ArticleEditDirective = ArticleEditDirective;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __importStar(__webpack_require__(72));
var lodash_1 = __importDefault(__webpack_require__(2));
var postscribe_1 = __importDefault(__webpack_require__(1607));
var redux_thunk_1 = __importDefault(__webpack_require__(530));
var utils_1 = __webpack_require__(3);
var redux_1 = __webpack_require__(191);
var attachments_1 = __webpack_require__(1608);
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdAuthoring
 *
 * @requires superdesk
 * @requires superdeskFlags
 * @requires authoringWorkspace
 * @requires notify
 * @requires desks
 * @requires authoring
 * @requires api
 * @requires session
 * @requires lock
 * @requires privileges
 * @requires content
 * @requires $location
 * @requires referrer
 * @requires macros
 * @requires $timeout
 * @requires $q
 * @requires modal
 * @requires archiveService
 * @requires confirm
 * @requires reloadService
 * @requires $rootScope
 * @requires $interpolate
 * @requires metadata
 * @requires suggest
 * @requires config
 * @requires deployConfig
 * @requires editorResolver
 * @requires $sce
 * @requires mediaIdGenerator
 *
 * @description
 *   This directive is responsible for generating superdesk content authoring form.
 */
AuthoringDirective.$inject = [
    'superdesk',
    'superdeskFlags',
    'authoringWorkspace',
    'notify',
    'desks',
    'authoring',
    'api',
    'session',
    'lock',
    'privileges',
    'content',
    '$location',
    'referrer',
    'macros',
    '$timeout',
    '$q',
    'modal',
    'archiveService',
    'confirm',
    'reloadService',
    '$rootScope',
    '$interpolate',
    'metadata',
    'suggest',
    'config',
    'deployConfig',
    'editorResolver',
    'compareVersions',
    'embedService',
    '$sce',
    'mediaIdGenerator',
    'relationsService',
    '$injector',
];
function AuthoringDirective(superdesk, superdeskFlags, authoringWorkspace, notify, desks, authoring, api, session, lock, privileges, content, $location, referrer, macros, $timeout, $q, modal, archiveService, confirm, reloadService, $rootScope, $interpolate, metadata, suggest, config, deployConfig, editorResolver, compareVersions, embedService, $sce, mediaIdGenerator, relationsService, $injector) {
    return {
        link: function ($scope, elem, attrs) {
            var _closing;
            var mediaFields = {};
            var userDesks;
            var UNIQUE_NAME_ERROR = utils_1.gettext('Error: Unique Name is not unique.');
            var MEDIA_TYPES = ['video', 'picture', 'audio'];
            desks.fetchCurrentUserDesks().then(function (desksList) {
                userDesks = desksList;
                $scope.itemActions = authoring.itemActions($scope.origItem, userDesks);
            });
            $scope.privileges = privileges.privileges;
            $scope.dirty = false;
            $scope.views = { send: false };
            $scope.stage = null;
            $scope._editable = !!$scope.origItem._editable;
            $scope.isMediaType = lodash_1.default.includes(['audio', 'video', 'picture', 'graphic'], $scope.origItem.type);
            $scope.action = $scope.action || ($scope._editable ? 'edit' : 'view');
            $scope.highlight = !!$scope.origItem.highlight;
            $scope.showExportButton = $scope.highlight && $scope.origItem.type === 'composite';
            $scope.openSuggestions = function () { return suggest.setActive(); };
            $scope.openCompareVersions = function (item) { return compareVersions.init(item); };
            $scope.isValidEmbed = {};
            $scope.embedPreviews = {};
            $scope.mediaFieldVersions = {};
            $scope.refreshTrigger = 0;
            $scope.isPreview = false;
            $scope.$watch('origItem', function (newValue, oldValue) {
                $scope.itemActions = null;
                if (newValue) {
                    $scope.itemActions = authoring.itemActions(newValue, userDesks);
                }
            }, true);
            $scope.$watch('item.flags', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $scope.item.flags = lodash_1.default.clone($scope.origItem.flags);
                    $scope.item.flags = newValue;
                    $scope.origItem.flags = oldValue;
                    $scope.dirty = true;
                }
            }, true);
            $scope.$watch('item.profile', function (profile) {
                if (profile) {
                    content.getType(profile)
                        .then(function (type) {
                        $scope.contentType = type;
                        $scope.fields = content.fields(type);
                        initMedia();
                    });
                }
                else {
                    $scope.contentType = null;
                    $scope.fields = null;
                }
            });
            $scope._isInProductionStates = !authoring.isPublished($scope.origItem);
            $scope.fullPreview = false;
            $scope.fullPreviewUrl = '/#/preview/' + $scope.origItem._id;
            $scope.proofread = false;
            $scope.referrerUrl = referrer.getReferrerUrl();
            content.getTypes().then(function () {
                $scope.content_types = content.types;
            });
            /**
             * Get the Desk and Stage for the item.
             */
            function getDeskStage() {
                if ($scope.origItem.task && $scope.origItem.task.stage) {
                    if (archiveService.isLegal($scope.origItem)) {
                        $scope.deskName = $scope.origItem.task.desk;
                        $scope.stage = $scope.origItem.task.stage;
                    }
                    else {
                        api('stages').getById($scope.origItem.task.stage)
                            .then(function (result) {
                            $scope.stage = result;
                        });
                        desks.fetchDeskById($scope.origItem.task.desk).then(function (desk) {
                            $scope.deskName = desk.name;
                            $scope.deskType = desk.desk_type;
                        });
                    }
                }
            }
            /**
             * Check if it is allowed to publish on desk
             * @returns {Boolean}
             */
            $scope.canPublishOnDesk = function () {
                return !($scope.deskType === 'authoring' && config.features.noPublishOnAuthoringDesk);
            };
            getDeskStage();
            /**
             * `desk_stage:change` event from send and publish action.
             * If send action succeeds but publish fails then we need change item location.
             */
            $scope.$on('desk_stage:change', getDeskStage);
            /**
             * Start editing current item
             */
            $scope.edit = function edit() {
                if (archiveService.isPublished($scope.origItem)) {
                    authoringWorkspace.view($scope.origItem);
                }
                else {
                    authoringWorkspace.edit($scope.origItem);
                }
            };
            /**
             * Create a new version
             */
            $scope.save = function () {
                return authoring.save($scope.origItem, $scope.item).then(function (res) {
                    $scope.dirty = false;
                    lodash_1.default.merge($scope.item, res);
                    if (res.highlight) {
                        _previewHighlight(res._id);
                    }
                    notify.success(utils_1.gettext('Item updated.'));
                    initMedia();
                    return $scope.origItem;
                }, function (response) {
                    if (response.status === 412) {
                        notifyPreconditionFailed();
                        return;
                    }
                    if (angular.isDefined(response.data._issues)) {
                        if (angular.isDefined(response.data._issues.unique_name) &&
                            response.data._issues.unique_name.unique === 1) {
                            notify.error(UNIQUE_NAME_ERROR);
                            return;
                        }
                        else if (angular.isDefined(response.data._issues['validator exception'])) {
                            notify.error(utils_1.gettext('Error: {{message}}', { message: response.data._issues['validator exception'] }));
                            return;
                        }
                    }
                    notify.error(utils_1.gettext('Error. Item not updated.'));
                });
            };
            $scope.openFullPreview = function ($event) {
                if ($event.button === 0 && !$event.ctrlKey) {
                    $event.preventDefault();
                    $scope.fullPreview = true;
                }
            };
            $scope.closeFullPreview = function () {
                $scope.fullPreview = false;
            };
            /**
             * Export the list of highlights as a text item.
             */
            $scope.exportHighlight = function (item) {
                if ($scope.save_enabled()) {
                    modal.confirm(utils_1.gettext('You have unsaved changes, do you want to continue?'))
                        .then(function () {
                        _exportHighlight(item._id);
                    });
                }
                else {
                    _exportHighlight(item._id);
                }
            };
            $scope.canSaveTemplate = function () {
                return privileges.userHasPrivileges({ content_templates: 1 });
            };
            function _exportHighlight(_id) {
                api.generate_highlights.save({}, { package: _id })
                    .then(authoringWorkspace.edit, function (response) {
                    if (response.status === 403) {
                        _forceExportHighlight(_id);
                    }
                    else {
                        notify.error(utils_1.gettext('Error creating highlight.'));
                    }
                });
            }
            function _forceExportHighlight(_id) {
                modal.confirm(utils_1.gettext('There are items locked or not published. Do you want to continue?'))
                    .then(function () {
                    api.generate_highlights.save({}, { package: _id, export: true })
                        .then(authoringWorkspace.edit, function (response) {
                        notify.error(utils_1.gettext('Error creating highlight.'));
                    });
                });
            }
            function _previewHighlight(_id) {
                api.generate_highlights.save({}, { package: _id, preview: true })
                    .then(function (response) {
                    $scope.highlight_preview = response.body_html;
                }, function (data) {
                    $scope.highlight_preview = data.message;
                });
            }
            if ($scope.origItem.highlight) {
                _previewHighlight($scope.origItem._id);
            }
            /**
             * Invoked by validatePublishScheduleAndEmbargo() to validate the date and time values.
             *
             * @return {string} if the values are invalid then returns appropriate error message.
             *         Otherwise empty string.
             */
            function validateTimestamp(datePartOfTS, timePartOfTS, timestamp, timezone, fieldName) {
                var errors = authoring.validateSchedule(datePartOfTS, timePartOfTS, timestamp, timezone, fieldName);
                if (!errors) {
                    return;
                }
                if (errors.date) {
                    return utils_1.gettext('{{field}} date is required!', { field: fieldName });
                }
                if (errors.time) {
                    return utils_1.gettext('{{field}} time is required!', { field: fieldName });
                }
                if (errors.timestamp) {
                    return utils_1.gettext('{{field}} is not a valid date!', { field: fieldName });
                }
                if (errors.future && fieldName !== 'Embargo' || $scope._isInProductionStates) {
                    return utils_1.gettext('{{field}} cannot be earlier than now!', { field: fieldName });
                }
            }
            /**
             * Validates the Embargo Date and Time and Publish Schedule Date and Time if they are set on the item.
             *
             * @return {boolean} true if valid, false otherwise.
             */
            function validatePublishScheduleAndEmbargo(item) {
                if (item.embargo && item.publish_schedule) {
                    notify.error(utils_1.gettext('An Item can\'t have both Embargo and Publish Schedule.'));
                    return false;
                }
                var errorMessage;
                if (item.embargo_date || item.embargo_time) {
                    errorMessage = validateTimestamp(item.embargo_date, item.embargo_time, item.embargo, item.schedule_settings ? item.schedule_settings.time_zone : null, utils_1.gettext('Embargo'));
                }
                if (item.publish_schedule_date || item.publish_schedule_time) {
                    if (lodash_1.default.includes(['published', 'killed', 'corrected', 'recalled'], item.state)) {
                        return true;
                    }
                    errorMessage = validateTimestamp(item.publish_schedule_date, item.publish_schedule_time, item.publish_schedule, item.schedule_settings ? item.schedule_settings.time_zone : null, utils_1.gettext('Publish Schedule'));
                }
                if (errorMessage) {
                    notify.error(errorMessage);
                    return false;
                }
                return true;
            }
            /**
             * Checks if associations is with rewrite_of item then open then modal to add associations.
             * The user has options to add associated media to the current item and review the media change
             * or publish the current item without media.
             * User will be prompted in following scenarios:
             * 1. Edit feature image and confirm media update is enabled.
             * 2. Once item is published then no confirmation.
             * 3. If current item is update and updated story has associations
             */
            function checkMediaAssociatedToUpdate() {
                var rewriteOf = $scope.item.rewrite_of;
                if (!lodash_1.default.get(config, 'features.confirmMediaOnUpdate') ||
                    !lodash_1.default.get(config, 'features.editFeaturedImage') ||
                    !rewriteOf || lodash_1.default.includes(['kill', 'correct', 'takedown'], $scope.action) ||
                    $scope.item.associations && $scope.item.associations.featuremedia) {
                    return $q.when(true);
                }
                return api.find('archive', rewriteOf)
                    .then(function (rewriteOfItem) {
                    if (rewriteOfItem && rewriteOfItem.associations &&
                        rewriteOfItem.associations.featuremedia) {
                        return confirm.confirmFeatureMedia(rewriteOfItem);
                    }
                    return true;
                })
                    .then(function (result) {
                    if (result && result.associations) {
                        $scope.item.associations = result.associations;
                        $scope.autosave($scope.item);
                        return false;
                    }
                    return true;
                });
            }
            function publishItem(orig, item) {
                var action = $scope.action === 'edit' ? 'publish' : $scope.action;
                $scope.error = {};
                return checkMediaAssociatedToUpdate()
                    .then(function (result) {
                    if (result) {
                        return authoring.publish(orig, item, action);
                    }
                    return $q.reject(false);
                })
                    .then(function (response) {
                    notify.success(utils_1.gettext('Item published.'));
                    $scope.item = response;
                    $scope.dirty = false;
                    authoringWorkspace.close(true);
                    return true;
                }, function (response) {
                    var issues = lodash_1.default.get(response, 'data._issues');
                    if (issues) {
                        if (angular.isDefined(issues['validator exception'])) {
                            var errors = issues['validator exception'];
                            var modifiedErrors = errors.replace(/\[/g, '')
                                .replace(/\]/g, '')
                                .split(',');
                            for (var i = 0; i < modifiedErrors.length; i++) {
                                var message = lodash_1.default.trim(modifiedErrors[i]);
                                // the message format is 'Field error text' (contains ')
                                var field = message.split(' ')[0].substr(1);
                                $scope.error[field.toLowerCase()] = true;
                                notify.error(message);
                            }
                            if (errors.indexOf('9007') >= 0 || errors.indexOf('9009') >= 0) {
                                authoring.open(item._id, true).then(function (res) {
                                    $scope.origItem = res;
                                    $scope.dirty = false;
                                    $scope.item = lodash_1.default.create($scope.origItem);
                                });
                            }
                            return $q.reject(false);
                        }
                        if (issues.unique_name && issues.unique_name.unique) {
                            notify.error(UNIQUE_NAME_ERROR);
                            return $q.reject(false);
                        }
                    }
                    else if (response && response.status === 412) {
                        notifyPreconditionFailed();
                        return $q.reject(false);
                    }
                    notify.error(utils_1.gettext('Unknown Error: Item not published.'));
                    return $q.reject(false);
                });
            }
            function notifyPreconditionFailed() {
                notify.error(utils_1.gettext('Item has changed since it was opened. ' +
                    'Please close and reopen the item to continue. ' +
                    'Regrettably, your changes cannot be saved.'));
                $scope._editable = false;
                $scope.dirty = false;
            }
            function validateForPublish(item) {
                var validator = deployConfig.getSync('validator_media_metadata');
                if (item.type === 'picture' || item.type === 'graphic') {
                    // required media metadata fields are defined in superdesk.config.js
                    lodash_1.default.each(Object.keys(validator), function (key) {
                        if (validator[key].required && (lodash_1.default.isNil(item[key]) || lodash_1.default.isEmpty(item[key]))) {
                            notify.error(utils_1.gettext('Required field {{key}} is missing. ...', { key: key }));
                            return false;
                        }
                    });
                }
                return true;
            }
            $scope.hideLiveSuggestions = function () {
                return $rootScope.config.features && $rootScope.config.features.hideLiveSuggestions;
            };
            $scope.openExport = function () {
                $scope.export = true;
            };
            $scope.canExport = function () {
                return $scope.privileges.content_export ? $scope.item.lock_user === session.identity._id &&
                    $scope.itemActions.export : false;
            };
            $scope.closeExport = function () {
                $scope.export = false;
            };
            $scope.useTansaProofing = function () {
                return $rootScope.config.features && $rootScope.config.features.useTansaProofing;
            };
            var deregisterTansa = $rootScope.$on('tansa:end', afterTansa);
            $scope.runTansa = function () {
                if (window.RunTansaProofing) {
                    var _editor = editorResolver.get();
                    if (_editor && _editor.version() === '3') {
                        $('#editor3Tansa').html(_editor.getHtmlForTansa());
                    }
                    switch ($scope.item.language) {
                        case 'nb-NO':
                            window.tansa.settings.profileId = lodash_1.default.get($rootScope, 'config.tansa.profile.nb');
                            break;
                        case 'nn-NO':
                            window.tansa.settings.profileId = lodash_1.default.get($rootScope, 'config.tansa.profile.nn');
                            break;
                    }
                    window.RunTansaProofing();
                }
                else {
                    notify.error(utils_1.gettext('Tansa is not responding. You can continue editing or publish the story.'));
                }
            };
            $scope.isRemovedField = function (fieldName) {
                return lodash_1.default.has(config.infoRemovedFields, fieldName);
            };
            function afterTansa(e, isCancelled) {
                var _editor = editorResolver.get();
                if (_editor && _editor.version() === '3') {
                    _editor.setHtmlFromTansa($('#editor3Tansa').html());
                }
            }
            /**
             * Depending on the item state one of the publish, correct, kill actions will be executed on the item
             * in $scope.
             */
            $scope.publish = function () {
                if (helpers.itemHasUnresolvedSuggestions($scope.item)) {
                    modal.alert({
                        headerText: utils_1.gettext('Resolving suggestions'),
                        bodyText: utils_1.gettext('Article cannot be published. Please accept or reject all suggestions first.'),
                    });
                    return Promise.reject();
                }
                if (helpers.itemHasUnresolvedComments($scope.item)) {
                    modal.confirm({
                        bodyText: utils_1.gettext('This article contains unresolved comments.'
                            + 'Click on Cancel to go back to editing to'
                            + 'resolve those comments or OK to ignore and proceed with publishing'),
                        headerText: utils_1.gettext('Resolving comments'),
                        okText: utils_1.gettext('Ok'),
                        cancelText: utils_1.gettext('Cancel'),
                    }).then(function (ok) { return ok ? performPublish() : false; });
                    return Promise.reject();
                }
                // Check if there are unpublished related items without media-gallery
                return relationsService.getRelatedItemsWithoutMediaGallery($scope.item, $scope.fields)
                    .then(function (related) {
                    if (related.length > 0) {
                        return modal.confirm({
                            bodyText: utils_1.gettext('There are unpublished related items that won\'t be sent out as related items.'
                                + ' Do you want to publish the article anyway?'),
                        }).then(function (ok) { return ok ? performPublish() : false; });
                    }
                    return performPublish();
                });
            };
            function performPublish() {
                if (validatePublishScheduleAndEmbargo($scope.item) && validateForPublish($scope.item)) {
                    var message = 'publish';
                    if ($scope.action && $scope.action !== 'edit') {
                        message = $scope.action;
                    }
                    if ($scope.dirty && message === 'publish') {
                        // confirmation only required for publish
                        return authoring.publishConfirmation($scope.origItem, $scope.item, $scope.dirty, message)
                            .then(function (res) {
                            if (res) {
                                return publishItem($scope.origItem, $scope.item);
                            }
                        }, function (response) {
                            notify.error(utils_1.gettext('Error. Item not published.'));
                            return $q.reject(false);
                        });
                    }
                    return publishItem($scope.origItem, $scope.item);
                }
                return false;
            }
            $scope.showCustomButtons = function (item) {
                if ($location.path() === '/workspace/personal') {
                    return false;
                }
                return item.task && item.task.desk && item.state !== 'draft' || $scope.dirty;
            };
            $scope.saveAndContinue = function (customButtonAction, showConfirm) {
                if ($scope.dirty) {
                    showConfirm ?
                        $scope.saveTopbar()
                            .then(confirm.confirmQuickPublish)
                            .then(customButtonAction) :
                        $scope.saveTopbar()
                            .then(customButtonAction);
                }
                else {
                    showConfirm ?
                        confirm.confirmQuickPublish().then(customButtonAction) :
                        customButtonAction();
                }
                initMedia();
            };
            $scope.publishAndContinue = function () {
                $scope.publish(true).then(function (published) {
                    if (published) {
                        authoring.rewrite($scope.item);
                    }
                }, function (err) {
                    notify.error(utils_1.gettext('Failed to publish and continue.'));
                });
                initMedia();
            };
            $scope.deschedule = function () {
                $scope.item.publish_schedule = null;
                return $scope.save();
            };
            /**
             * Close an item - unlock
             */
            $scope.close = function () {
                _closing = true;
                // returned promise used by superdesk-fi
                return authoring.close($scope.item, $scope.origItem, $scope.save_enabled()).then(function () {
                    authoringWorkspace.close(true);
                });
            };
            /**
             * Cancel an action, i.e. go back to view mode.
             * This is used in the 'EDIT AND CORRECT' and 'EDIT AND KILL' actions.
             * When the user clicks on the 'CANCEL' button it takes them back to the view action on the item
             */
            $scope.cancel = function () {
                authoringWorkspace.view($scope.origItem);
            };
            /*
             * Minimize an item
             */
            $scope.minimize = function () {
                authoringWorkspace.close(true);
            };
            $scope.closeOpenNew = function (createFunction, paramValue) {
                _closing = true;
                authoring.close($scope.item, $scope.origItem, $scope.dirty, true).then(function () {
                    createFunction(paramValue);
                });
            };
            /**
             * Called by the sendItem directive before send.
             * If the $scope is dirty then upon confirmation save the item and then unlock the item.
             * If the $scope is not dirty then unlock the item.
             * @param {String} action - action to display in confirmation dialog
             * @return {Object} promise
             */
            $scope.beforeSend = function (action) {
                $scope.sending = true;
                if ($scope.dirty) {
                    return confirm.confirmSendTo(action)
                        .then(function () { return $scope.save().then(function () { return lock.unlock($scope.origItem); }); }, function () {
                        return $q.reject();
                    });
                }
                return lock.unlock($scope.origItem)
                    .catch(function () { return $scope.origItem; }); // ignore failed unlock
            };
            /**
             * Preview different version of an item
             */
            $scope.preview = function (version) {
                helpers.forcedExtend($scope.item, version);
                $scope.refreshTrigger++;
                $scope.isPreview = true;
                $scope._editable = false;
            };
            /**
             * Revert item to given version
             */
            $scope.revert = function (version) {
                $scope.isPreview = false;
                helpers.forcedExtend($scope.item, version);
                $scope.refreshTrigger++;
                if ($scope.item.annotations == null) {
                    $scope.item.annotations = [];
                }
                return $scope.save();
            };
            /**
             * Close preview and start working again
             */
            $scope.closePreview = function () {
                $scope.item = lodash_1.default.create($scope.origItem);
                $scope._editable = $scope.action !== 'view' && authoring.isEditable($scope.origItem);
                if ($scope.isPreview) {
                    $scope.isPreview = false;
                    $scope.refreshTrigger++;
                }
                // populate content fields so that it can undo to initial (empty) version later
                var autosave = $scope.origItem._autosave || {};
                Object.keys(helpers.CONTENT_FIELDS_DEFAULTS).forEach(function (key) {
                    var value = autosave[key] || $scope.origItem[key] || helpers.CONTENT_FIELDS_DEFAULTS[key];
                    $scope.item[key] = angular.copy(value);
                });
            };
            /**
             * Checks if the item can be unlocked or not.
             */
            $scope.can_unlock = function () {
                return !$scope.item.sendTo && lock.can_unlock($scope.item);
            };
            $scope.save_enabled = function () {
                confirm.dirty = $scope.dirty;
                return ($scope.dirty || $scope.item._autosave != null) &&
                    lodash_1.default.reduce($scope.isValidEmbed, function (agg, val) { return agg && val; }, true);
            };
            $scope.previewFormattedEnabled = function () {
                return !!lodash_1.default.get($rootScope.config, 'features.previewFormats');
            };
            // call the function to unlock and lock the story for editing.
            $scope.unlock = function () {
                $scope.unlockClicked = true;
                lock.unlock($scope.item).then(function (unlockedItem) {
                    $scope.edit(unlockedItem);
                });
            };
            $scope.openAction = function (action) {
                if (action === 'correct') {
                    authoringWorkspace.correct($scope.item);
                }
                else if (action === 'kill') {
                    authoringWorkspace.kill($scope.item);
                }
                else if (action === 'takedown') {
                    authoringWorkspace.takedown($scope.item);
                }
                else if (action === 'rewrite') {
                    authoring.rewrite($scope.item);
                }
            };
            $scope.isLocked = function () {
                return lock.isLocked($scope.item);
            };
            $scope.isLockedByMe = function () {
                return lock.isLockedByMe($scope.item);
            };
            /**
             * On change content profile the default values from new content profile
             * will overwrite the current values from item
             *
             * @function changeProfile
             * @param {Object} item - ucurrent edited content items
             */
            $scope.changeProfile = function (item) {
                angular.forEach($scope.content_types, function (profile) {
                    if (item.profile === profile._id && profile.schema) {
                        angular.forEach(profile.schema, function (schema, key) {
                            if (schema && schema.default) {
                                item[key] = lodash_1.default.cloneDeep(schema.default);
                            }
                        });
                    }
                });
                $scope.autosave(item);
            };
            $scope.autosave = function (item, timeout) {
                $scope.dirty = true;
                angular.extend($scope.item, item); // make sure all changes are available
                var autosavedItem = authoring.autosave($scope.item, $scope.origItem, timeout);
                authoringWorkspace.addAutosave();
                initMedia();
                return autosavedItem;
            };
            $scope.sendToNextStage = function () {
                var stageIndex, stageList = desks.deskStages[desks.activeDeskId];
                var selectedStage, selectedDesk = desks.deskLookup[desks.activeDeskId];
                for (var i = 0; i < stageList.length; i++) {
                    if (stageList[i]._id === $scope.stage._id) {
                        selectedStage = stageList[i];
                        stageIndex = i + 1 === stageList.length ? 0 : i + 1;
                        break;
                    }
                }
                $rootScope.$broadcast('item:nextStage', {
                    stage: stageList[stageIndex],
                    itemId: $scope.item._id,
                    selectedStage: selectedStage,
                    selectedDesk: selectedDesk,
                    item: $scope.item,
                });
                $scope.close();
            };
            // Returns true if the given text is an URL
            $scope.isURL = function (text) {
                return lodash_1.default.startsWith(lodash_1.default.lowerCase(lodash_1.default.trim(text)), 'http');
            };
            // Shows the preview for the given embed field.
            $scope.previewEmbed = function (fieldId) {
                if ($scope.item.extra[fieldId].embed) {
                    $scope.embedPreviews[fieldId] = true;
                    postscribe_1.default('#embed-preview-' + fieldId, $scope.item.extra[fieldId].embed);
                }
            };
            // Hides the preview for the given embed field.
            $scope.hideEmbedPreview = function (fieldId) {
                document.getElementById('embed-preview-' + fieldId).innerHTML = null;
                $scope.embedPreviews[fieldId] = false;
            };
            // Returns true if the preview for the given embed field was on.
            $scope.isPreviewOn = function (fieldId) {
                return !!$scope.embedPreviews && !!$scope.embedPreviews[fieldId];
            };
            // Validates the given embed field
            function validateEmbed(fieldId) {
                if (lodash_1.default.get($scope.item, "extra." + fieldId + ".embed")) {
                    $scope.isValidEmbed[fieldId] = !$scope.isURL($scope.item.extra[fieldId].embed);
                }
                else {
                    $scope.isValidEmbed[fieldId] = true;
                }
            }
            // Validates the given embed field, hides the preview and calls autosave if the embed was valid
            $scope.validateEmbed = function (fieldId) {
                $scope.hideEmbedPreview(fieldId);
                validateEmbed(fieldId);
                if ($scope.isValidEmbed[fieldId]) {
                    $scope.autosave($scope.item);
                }
            };
            // Retrieves the embed script for a given URL.
            $scope.processEmbed = function (fieldId) {
                if (lodash_1.default.startsWith($scope.item.extra[fieldId].embed, 'http')) {
                    embedService.get($scope.item.extra[fieldId].embed).then(function (data) {
                        $scope.item.extra[fieldId].embed = data.html;
                        $scope.isValidEmbed[fieldId] = true;
                        $scope.autosave($scope.item);
                    });
                }
            };
            // Clear the current embed value.
            $scope.clearEmbed = function (fieldId) {
                $scope.item.extra[fieldId].embed = '';
                $scope.validateEmbed(fieldId);
            };
            function refreshItem() {
                authoring.open($scope.item._id, true)
                    .then(function (item) {
                    $scope.origItem = item;
                    $scope.dirty = false;
                    $scope.closePreview();
                    $scope.item._editable = $scope._editable;
                    initMedia();
                });
            }
            $scope.$on('savework', function (e, msg) {
                var changeMsg = msg;
                authoring.saveWorkConfirmation($scope.origItem, $scope.item, $scope.dirty, changeMsg)
                    .then(function (res) {
                    // after saving work make sure this item won't be open again
                    desks.setCurrentDeskId(null);
                    $location.search('item', null);
                    $location.search('action', null);
                })
                    .finally(reloadService.forceReload);
            });
            $scope.$on('item:lock', function (_e, data) {
                if ($scope.item._id === data.item && !_closing &&
                    session.sessionId !== data.lock_session) {
                    authoring.lock($scope.item, data.user);
                }
            });
            $scope.$on('item:unlock', function (_e, data) {
                if ($scope.item._id === data.item && !_closing &&
                    (session.sessionId !== data.lock_session || lock.previewUnlock)) {
                    if (lock.previewUnlock) {
                        $scope.unlock();
                        lock.previewUnlock = false;
                    }
                    else {
                        authoring.unlock($scope.item, data.user);
                        $scope._editable = $scope.item._editable = false;
                        $scope.origItem._locked = $scope.item._locked = false;
                        $scope.origItem.lock_session = $scope.item.lock_session = null;
                        $scope.origItem.lock_user = $scope.item.lock_user = null;
                        if (data.state && data.state !== $scope.item.state) {
                            $scope.item.state = data.state;
                            $scope.origItem.state = data.state;
                        }
                    }
                }
            });
            $scope.$on('content:update', function (_e, data) {
                if (!$scope._editable && data.items && data.items[$scope.origItem._id]) {
                    refreshItem();
                }
            });
            $scope.$on('item:publish:wrong:format', function (_e, data) {
                if (data.item === $scope.item._id) {
                    notify.error(utils_1.gettext('No formatters found for {{formats}} while publishing item having unique name.', { formats: data.formats.join(','), name: data.unique_name }));
                }
            });
            $scope.$on('$destroy', deregisterTansa);
            var initEmbedFieldsValidation = function () {
                $scope.isValidEmbed = {};
                content.getTypes().then(function () {
                    lodash_1.default.forEach($scope.content_types, function (profile) {
                        if ($scope.item.profile === profile._id && profile.schema) {
                            lodash_1.default.forEach(profile.schema, function (schema, fieldId) {
                                if (schema && schema.type === 'embed') {
                                    validateEmbed(fieldId);
                                }
                            });
                        }
                    });
                });
            };
            /**
             * @ngdoc method
             * @name sdAuthoring#isMediaField
             * @private
             * @description Returns true if the given string is a vocabulary media
             *              field identifier, false otherwise.
             * @param {string} fieldId
             * @return {bool}
             */
            function isMediaField(fieldId) {
                var parts = mediaIdGenerator.getFieldParts(fieldId);
                var field = lodash_1.default.find($scope.fields, function (_field) { return _field._id === parts[0]; });
                return field && field.field_type === 'media';
            }
            /**
             * @ngdoc method
             * @name sdAuthoring#computeMediaFieldVersions
             * @private
             * @description Generates an array of name versions for a given vocabulary
             *              media field.
             * @param {string} fieldId
             */
            function computeMediaFieldVersions(fieldId) {
                $scope.mediaFieldVersions[fieldId] = [];
                var field = lodash_1.default.find($scope.fields, function (_field) { return _field._id === fieldId; });
                if (field) {
                    var multipleItems = lodash_1.default.get(field, 'field_options.multiple_items.enabled');
                    var maxItems = !multipleItems ? 1 : lodash_1.default.get(field, 'field_options.multiple_items.max_items');
                    if (!maxItems || !mediaFields[fieldId] || mediaFields[fieldId].length < maxItems) {
                        addMediaFieldVersion(fieldId, $scope.getNewMediaFieldId(fieldId));
                    }
                    lodash_1.default.forEach(mediaFields[fieldId], function (version) {
                        addMediaFieldVersion(fieldId, mediaIdGenerator.getFieldVersionName(fieldId, version));
                    });
                }
            }
            function addMediaFieldVersion(fieldId, fieldVersion) {
                var field = { fieldId: fieldVersion };
                if (lodash_1.default.has($scope.item.associations, fieldVersion)) {
                    field[fieldVersion] = $scope.item.associations[fieldVersion];
                }
                else {
                    field[fieldVersion] = null;
                }
                $scope.mediaFieldVersions[fieldId].push(field);
            }
            /**
             * @ngdoc method
             * @name sdAuthoring#addMediaField
             * @private
             * @description Adds the version of the given field name to the versions array.
             * @param {string} fieldId
             */
            function addMediaField(fieldId) {
                var _a = mediaIdGenerator.getFieldParts(fieldId), rootField = _a[0], index = _a[1];
                if (!lodash_1.default.has(mediaFields, rootField)) {
                    mediaFields[rootField] = [];
                }
                mediaFields[rootField].push(index);
                mediaFields[rootField].sort(function (a, b) {
                    if (b === null || b === undefined) {
                        return -1;
                    }
                    if (a === null || a === undefined) {
                        return 1;
                    }
                    return b - a;
                });
            }
            /**
             * @ngdoc method
             * @name sdAuthoring#initMedia
             * @private
             * @description Initializes arrays containing the media fields versions.
             */
            function initMedia() {
                mediaFields = {};
                $scope.mediaFieldVersions = {};
                lodash_1.default.forEach($scope.item.associations, function (association, fieldId) {
                    if (association && lodash_1.default.findIndex(MEDIA_TYPES, function (type) { return type === association.type; }) !== -1
                        && isMediaField(fieldId)) {
                        addMediaField(fieldId);
                    }
                });
                if ($scope.contentType && $scope.contentType.schema) {
                    lodash_1.default.forEach($scope.fields, function (field) {
                        if (isMediaField(field._id)) {
                            computeMediaFieldVersions(field._id);
                        }
                    });
                }
            }
            /**
             * @ngdoc method
             * @name sdAuthoring#getNewMediaFieldId
             * @public
             * @description Returns a new name version for a given media field.
             * @param {String} fieldId
             * @return {String}
             */
            $scope.getNewMediaFieldId = function (fieldId) {
                var field = lodash_1.default.find($scope.fields, function (_field) { return _field._id === fieldId; });
                var multipleItems = field ? lodash_1.default.get(field, 'field_options.multiple_items.enabled') : false;
                var parts = mediaIdGenerator.getFieldParts(fieldId);
                var newIndex = multipleItems ? 1 : null;
                if (lodash_1.default.has(mediaFields, parts[0])) {
                    var fieldVersions = mediaFields[parts[0]];
                    newIndex = fieldVersions.length ? 1 + fieldVersions[0] : 1;
                }
                return mediaIdGenerator.getFieldVersionName(parts[0], newIndex);
            };
            // init
            $scope.content = content;
            $scope.closePreview();
            macros.setupShortcuts($scope);
            initEmbedFieldsValidation();
            // init redux
            var initialState = {
                editable: !!$scope.origItem._editable,
                isLocked: $scope.isLocked(),
                isLockedByMe: $scope.isLockedByMe(),
            };
            function editor(state) {
                if (state === void 0) { state = initialState; }
                return state;
            }
            var reducer = redux_1.combineReducers({ attachments: attachments_1.attachments, editor: editor });
            $scope.store = redux_1.createStore(reducer, redux_1.applyMiddleware(redux_thunk_1.default.withExtraArgument({
                $scope: $scope,
                $window: $injector.get('$window'),
                urls: $injector.get('urls'),
                notify: notify,
                superdesk: superdesk,
                deployConfig: deployConfig,
                attachments: $injector.get('attachments'),
            })));
            $scope.store.dispatch(attachments_1.initAttachments($scope.item));
        },
    };
}
exports.AuthoringDirective = AuthoringDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @file postscribe
 * @description Asynchronously write javascript, even with document.write.
 * @version v2.0.8
 * @see {@link https://krux.github.io/postscribe}
 * @license MIT
 * @author Derek Brans
 * @copyright 2016 Krux Digital, Inc
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["postscribe"] = factory();
	else
		root["postscribe"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _postscribe = __webpack_require__(1);
	
	var _postscribe2 = _interopRequireDefault(_postscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = _postscribe2['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = postscribe;
	
	var _writeStream = __webpack_require__(2);
	
	var _writeStream2 = _interopRequireDefault(_writeStream);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * A function that intentionally does nothing.
	 */
	function doNothing() {}
	
	/**
	 * Available options and defaults.
	 *
	 * @type {Object}
	 */
	var OPTIONS = {
	  /**
	   * Called when an async script has loaded.
	   */
	  afterAsync: doNothing,
	
	  /**
	   * Called immediately before removing from the write queue.
	   */
	  afterDequeue: doNothing,
	
	  /**
	   * Called sync after a stream's first thread release.
	   */
	  afterStreamStart: doNothing,
	
	  /**
	   * Called after writing buffered document.write calls.
	   */
	  afterWrite: doNothing,
	
	  /**
	   * Allows disabling the autoFix feature of prescribe
	   */
	  autoFix: true,
	
	  /**
	   * Called immediately before adding to the write queue.
	   */
	  beforeEnqueue: doNothing,
	
	  /**
	   * Called before writing a token.
	   *
	   * @param {Object} tok The token
	   */
	  beforeWriteToken: function beforeWriteToken(tok) {
	    return tok;
	  },
	
	  /**
	   * Called before writing buffered document.write calls.
	   *
	   * @param {String} str The string
	   */
	  beforeWrite: function beforeWrite(str) {
	    return str;
	  },
	
	  /**
	   * Called when evaluation is finished.
	   */
	  done: doNothing,
	
	  /**
	   * Called when a write results in an error.
	   *
	   * @param {Error} e The error
	   */
	  error: function error(e) {
	    throw new Error(e.msg);
	  },
	
	
	  /**
	   * Whether to let scripts w/ async attribute set fall out of the queue.
	   */
	  releaseAsync: false
	};
	
	var nextId = 0;
	var queue = [];
	var active = null;
	
	function nextStream() {
	  var args = queue.shift();
	  if (args) {
	    var options = utils.last(args);
	
	    options.afterDequeue();
	    args.stream = runStream.apply(undefined, args);
	    options.afterStreamStart();
	  }
	}
	
	function runStream(el, html, options) {
	  active = new _writeStream2['default'](el, options);
	
	  // Identify this stream.
	  active.id = nextId++;
	  active.name = options.name || active.id;
	  postscribe.streams[active.name] = active;
	
	  // Override document.write.
	  var doc = el.ownerDocument;
	
	  var stash = {
	    close: doc.close,
	    open: doc.open,
	    write: doc.write,
	    writeln: doc.writeln
	  };
	
	  function _write(str) {
	    str = options.beforeWrite(str);
	    active.write(str);
	    options.afterWrite(str);
	  }
	
	  _extends(doc, {
	    close: doNothing,
	    open: doNothing,
	    write: function write() {
	      for (var _len = arguments.length, str = Array(_len), _key = 0; _key < _len; _key++) {
	        str[_key] = arguments[_key];
	      }
	
	      return _write(str.join(''));
	    },
	    writeln: function writeln() {
	      for (var _len2 = arguments.length, str = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        str[_key2] = arguments[_key2];
	      }
	
	      return _write(str.join('') + '\n');
	    }
	  });
	
	  // Override window.onerror
	  var oldOnError = active.win.onerror || doNothing;
	
	  // This works together with the try/catch around WriteStream::insertScript
	  // In modern browsers, exceptions in tag scripts go directly to top level
	  active.win.onerror = function (msg, url, line) {
	    options.error({ msg: msg + ' - ' + url + ': ' + line });
	    oldOnError.apply(active.win, [msg, url, line]);
	  };
	
	  // Write to the stream
	  active.write(html, function () {
	    // restore document.write
	    _extends(doc, stash);
	
	    // restore window.onerror
	    active.win.onerror = oldOnError;
	
	    options.done();
	    active = null;
	    nextStream();
	  });
	
	  return active;
	}
	
	function postscribe(el, html, options) {
	  if (utils.isFunction(options)) {
	    options = { done: options };
	  } else if (options === 'clear') {
	    queue = [];
	    active = null;
	    nextId = 0;
	    return;
	  }
	
	  options = utils.defaults(options, OPTIONS);
	
	  // id selector
	  if (/^#/.test(el)) {
	    el = window.document.getElementById(el.substr(1));
	  } else {
	    el = el.jquery ? el[0] : el;
	  }
	
	  var args = [el, html, options];
	
	  el.postscribe = {
	    cancel: function cancel() {
	      if (args.stream) {
	        args.stream.abort();
	      } else {
	        args[1] = doNothing;
	      }
	    }
	  };
	
	  options.beforeEnqueue(args);
	  queue.push(args);
	
	  if (!active) {
	    nextStream();
	  }
	
	  return el.postscribe;
	}
	
	_extends(postscribe, {
	  // Streams by name.
	  streams: {},
	  // Queue of streams.
	  queue: queue,
	  // Expose internal classes.
	  WriteStream: _writeStream2['default']
	});

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _prescribe = __webpack_require__(3);
	
	var _prescribe2 = _interopRequireDefault(_prescribe);
	
	var _utils = __webpack_require__(4);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Turn on to debug how each chunk affected the DOM.
	 * @type {boolean}
	 */
	var DEBUG_CHUNK = false;
	
	/**
	 * Prefix for data attributes on DOM elements.
	 * @type {string}
	 */
	var BASEATTR = 'data-ps-';
	
	/**
	 * ID for the style proxy
	 * @type {string}
	 */
	var PROXY_STYLE = 'ps-style';
	
	/**
	 * ID for the script proxy
	 * @type {string}
	 */
	var PROXY_SCRIPT = 'ps-script';
	
	/**
	 * Get data attributes
	 *
	 * @param {Object} el The DOM element.
	 * @param {String} name The attribute name.
	 * @returns {String}
	 */
	function getData(el, name) {
	  var attr = BASEATTR + name;
	
	  var val = el.getAttribute(attr);
	
	  // IE 8 returns a number if it's a number
	  return !utils.existy(val) ? val : String(val);
	}
	
	/**
	 * Set data attributes
	 *
	 * @param {Object} el The DOM element.
	 * @param {String} name The attribute name.
	 * @param {null|*} value The attribute value.
	 */
	function setData(el, name) {
	  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var attr = BASEATTR + name;
	
	  if (utils.existy(value) && value !== '') {
	    el.setAttribute(attr, value);
	  } else {
	    el.removeAttribute(attr);
	  }
	}
	
	/**
	 * Stream static html to an element, where "static html" denotes "html
	 * without scripts".
	 *
	 * This class maintains a *history of writes devoid of any attributes* or
	 * "proxy history".
	 *
	 * Injecting the proxy history into a temporary div has no side-effects,
	 * other than to create proxy elements for previously written elements.
	 *
	 * Given the `staticHtml` of a new write, a `tempDiv`'s innerHTML is set to
	 * `proxy_history + staticHtml`.
	 * The *structure* of `tempDiv`'s contents, (i.e., the placement of new nodes
	 * beside or inside of proxy elements), reflects the DOM structure that would
	 * have resulted if all writes had been squashed into a single write.
	 *
	 * For each descendent `node` of `tempDiv` whose parentNode is a *proxy*,
	 * `node` is appended to the corresponding *real* element within the DOM.
	 *
	 * Proxy elements are mapped to *actual* elements in the DOM by injecting a
	 * `data-id` attribute into each start tag in `staticHtml`.
	 *
	 */
	
	var WriteStream = function () {
	  /**
	   * Constructor.
	   *
	   * @param {Object} root The root element
	   * @param {?Object} options The options
	   */
	  function WriteStream(root) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, WriteStream);
	
	    this.root = root;
	    this.options = options;
	    this.doc = root.ownerDocument;
	    this.win = this.doc.defaultView || this.doc.parentWindow;
	    this.parser = new _prescribe2['default']('', { autoFix: options.autoFix });
	
	    // Actual elements by id.
	    this.actuals = [root];
	
	    // Embodies the "structure" of what's been written so far,
	    // devoid of attributes.
	    this.proxyHistory = '';
	
	    // Create a proxy of the root element.
	    this.proxyRoot = this.doc.createElement(root.nodeName);
	
	    this.scriptStack = [];
	    this.writeQueue = [];
	
	    setData(this.proxyRoot, 'proxyof', 0);
	  }
	
	  /**
	   * Writes the given strings.
	   *
	   * @param {...String} str The strings to write
	   */
	
	
	  WriteStream.prototype.write = function write() {
	    var _writeQueue;
	
	    (_writeQueue = this.writeQueue).push.apply(_writeQueue, arguments);
	
	    // Process writes
	    // When new script gets pushed or pending this will stop
	    // because new writeQueue gets pushed
	    while (!this.deferredRemote && this.writeQueue.length) {
	      var arg = this.writeQueue.shift();
	
	      if (utils.isFunction(arg)) {
	        this._callFunction(arg);
	      } else {
	        this._writeImpl(arg);
	      }
	    }
	  };
	
	  /**
	   * Calls the given function.
	   *
	   * @param {Function} fn The function to call
	   * @private
	   */
	
	
	  WriteStream.prototype._callFunction = function _callFunction(fn) {
	    var tok = { type: 'function', value: fn.name || fn.toString() };
	    this._onScriptStart(tok);
	    fn.call(this.win, this.doc);
	    this._onScriptDone(tok);
	  };
	
	  /**
	   * The write implementation
	   *
	   * @param {String} html The HTML to write.
	   * @private
	   */
	
	
	  WriteStream.prototype._writeImpl = function _writeImpl(html) {
	    this.parser.append(html);
	
	    var tok = void 0;
	    var script = void 0;
	    var style = void 0;
	    var tokens = [];
	
	    // stop if we see a script token
	    while ((tok = this.parser.readToken()) && !(script = utils.isScript(tok)) && !(style = utils.isStyle(tok))) {
	      tok = this.options.beforeWriteToken(tok);
	
	      if (tok) {
	        tokens.push(tok);
	      }
	    }
	
	    if (tokens.length > 0) {
	      this._writeStaticTokens(tokens);
	    }
	
	    if (script) {
	      this._handleScriptToken(tok);
	    }
	
	    if (style) {
	      this._handleStyleToken(tok);
	    }
	  };
	
	  /**
	   * Write contiguous non-script tokens (a chunk)
	   *
	   * @param {Array<Object>} tokens The tokens
	   * @returns {{tokens, raw, actual, proxy}|null}
	   * @private
	   */
	
	
	  WriteStream.prototype._writeStaticTokens = function _writeStaticTokens(tokens) {
	    var chunk = this._buildChunk(tokens);
	
	    if (!chunk.actual) {
	      // e.g., no tokens, or a noscript that got ignored
	      return null;
	    }
	
	    chunk.html = this.proxyHistory + chunk.actual;
	    this.proxyHistory += chunk.proxy;
	    this.proxyRoot.innerHTML = chunk.html;
	
	    if (DEBUG_CHUNK) {
	      chunk.proxyInnerHTML = this.proxyRoot.innerHTML;
	    }
	
	    this._walkChunk();
	
	    if (DEBUG_CHUNK) {
	      chunk.actualInnerHTML = this.root.innerHTML;
	    }
	
	    return chunk;
	  };
	
	  /**
	   * Build a chunk.
	   *
	   * @param {Array<Object>} tokens The tokens to use.
	   * @returns {{tokens: *, raw: string, actual: string, proxy: string}}
	   * @private
	   */
	
	
	  WriteStream.prototype._buildChunk = function _buildChunk(tokens) {
	    var nextId = this.actuals.length;
	
	    // The raw html of this chunk.
	    var raw = [];
	
	    // The html to create the nodes in the tokens (with id's injected).
	    var actual = [];
	
	    // Html that can later be used to proxy the nodes in the tokens.
	    var proxy = [];
	
	    var len = tokens.length;
	    for (var i = 0; i < len; i++) {
	      var tok = tokens[i];
	      var tokenRaw = tok.toString();
	
	      raw.push(tokenRaw);
	
	      if (tok.attrs) {
	        // tok.attrs <==> startTag or atomicTag or cursor
	        // Ignore noscript tags. They are atomic, so we don't have to worry about children.
	        if (!/^noscript$/i.test(tok.tagName)) {
	          var id = nextId++;
	
	          // Actual: inject id attribute: replace '>' at end of start tag with id attribute + '>'
	          actual.push(tokenRaw.replace(/(\/?>)/, ' ' + BASEATTR + 'id=' + id + ' $1'));
	
	          // Don't proxy scripts: they have no bearing on DOM structure.
	          if (tok.attrs.id !== PROXY_SCRIPT && tok.attrs.id !== PROXY_STYLE) {
	            // Proxy: strip all attributes and inject proxyof attribute
	            proxy.push(
	            // ignore atomic tags (e.g., style): they have no "structural" effect
	            tok.type === 'atomicTag' ? '' : '<' + tok.tagName + ' ' + BASEATTR + 'proxyof=' + id + (tok.unary ? ' />' : '>'));
	          }
	        }
	      } else {
	        // Visit any other type of token
	        // Actual: append.
	        actual.push(tokenRaw);
	
	        // Proxy: append endTags. Ignore everything else.
	        proxy.push(tok.type === 'endTag' ? tokenRaw : '');
	      }
	    }
	
	    return {
	      tokens: tokens,
	      raw: raw.join(''),
	      actual: actual.join(''),
	      proxy: proxy.join('')
	    };
	  };
	
	  /**
	   * Walk the chunks.
	   *
	   * @private
	   */
	
	
	  WriteStream.prototype._walkChunk = function _walkChunk() {
	    var node = void 0;
	    var stack = [this.proxyRoot];
	
	    // use shift/unshift so that children are walked in document order
	    while (utils.existy(node = stack.shift())) {
	      var isElement = node.nodeType === 1;
	      var isProxy = isElement && getData(node, 'proxyof');
	
	      // Ignore proxies
	      if (!isProxy) {
	        if (isElement) {
	          // New actual element: register it and remove the the id attr.
	          this.actuals[getData(node, 'id')] = node;
	          setData(node, 'id');
	        }
	
	        // Is node's parent a proxy?
	        var parentIsProxyOf = node.parentNode && getData(node.parentNode, 'proxyof');
	        if (parentIsProxyOf) {
	          // Move node under actual parent.
	          this.actuals[parentIsProxyOf].appendChild(node);
	        }
	      }
	
	      // prepend childNodes to stack
	      stack.unshift.apply(stack, utils.toArray(node.childNodes));
	    }
	  };
	
	  /**
	   * Handles Script tokens
	   *
	   * @param {Object} tok The token
	   */
	
	
	  WriteStream.prototype._handleScriptToken = function _handleScriptToken(tok) {
	    var _this = this;
	
	    var remainder = this.parser.clear();
	
	    if (remainder) {
	      // Write remainder immediately behind this script.
	      this.writeQueue.unshift(remainder);
	    }
	
	    tok.src = tok.attrs.src || tok.attrs.SRC;
	
	    tok = this.options.beforeWriteToken(tok);
	    if (!tok) {
	      // User has removed this token
	      return;
	    }
	
	    if (tok.src && this.scriptStack.length) {
	      // Defer this script until scriptStack is empty.
	      // Assumption 1: This script will not start executing until
	      // scriptStack is empty.
	      this.deferredRemote = tok;
	    } else {
	      this._onScriptStart(tok);
	    }
	
	    // Put the script node in the DOM.
	    this._writeScriptToken(tok, function () {
	      _this._onScriptDone(tok);
	    });
	  };
	
	  /**
	   * Handles style tokens
	   *
	   * @param {Object} tok The token
	   */
	
	
	  WriteStream.prototype._handleStyleToken = function _handleStyleToken(tok) {
	    var remainder = this.parser.clear();
	
	    if (remainder) {
	      // Write remainder immediately behind this style.
	      this.writeQueue.unshift(remainder);
	    }
	
	    tok.type = tok.attrs.type || tok.attrs.TYPE || 'text/css';
	
	    tok = this.options.beforeWriteToken(tok);
	
	    if (tok) {
	      // Put the style node in the DOM.
	      this._writeStyleToken(tok);
	    }
	
	    if (remainder) {
	      this.write();
	    }
	  };
	
	  /**
	   * Build a style and insert it into the DOM.
	   *
	   * @param {Object} tok The token
	   */
	
	
	  WriteStream.prototype._writeStyleToken = function _writeStyleToken(tok) {
	    var el = this._buildStyle(tok);
	
	    this._insertCursor(el, PROXY_STYLE);
	
	    // Set content
	    if (tok.content) {
	      if (el.styleSheet && !el.sheet) {
	        el.styleSheet.cssText = tok.content;
	      } else {
	        el.appendChild(this.doc.createTextNode(tok.content));
	      }
	    }
	  };
	
	  /**
	   * Build a style element from an atomic style token.
	   *
	   * @param {Object} tok The token
	   * @returns {Element}
	   */
	
	
	  WriteStream.prototype._buildStyle = function _buildStyle(tok) {
	    var el = this.doc.createElement(tok.tagName);
	
	    el.setAttribute('type', tok.type);
	
	    // Set attributes
	    utils.eachKey(tok.attrs, function (name, value) {
	      el.setAttribute(name, value);
	    });
	
	    return el;
	  };
	
	  /**
	   * Append a span to the stream. That span will act as a cursor
	   * (i.e. insertion point) for the element.
	   *
	   * @param {Object} el The element
	   * @param {string} which The type of proxy element
	   */
	
	
	  WriteStream.prototype._insertCursor = function _insertCursor(el, which) {
	    this._writeImpl('<span id="' + which + '"/>');
	
	    var cursor = this.doc.getElementById(which);
	
	    if (cursor) {
	      cursor.parentNode.replaceChild(el, cursor);
	    }
	  };
	
	  /**
	   * Called when a script is started.
	   *
	   * @param {Object} tok The token
	   * @private
	   */
	
	
	  WriteStream.prototype._onScriptStart = function _onScriptStart(tok) {
	    tok.outerWrites = this.writeQueue;
	    this.writeQueue = [];
	    this.scriptStack.unshift(tok);
	  };
	
	  /**
	   * Called when a script is done.
	   *
	   * @param {Object} tok The token
	   * @private
	   */
	
	
	  WriteStream.prototype._onScriptDone = function _onScriptDone(tok) {
	    // Pop script and check nesting.
	    if (tok !== this.scriptStack[0]) {
	      this.options.error({ msg: 'Bad script nesting or script finished twice' });
	      return;
	    }
	
	    this.scriptStack.shift();
	
	    // Append outer writes to queue and process them.
	    this.write.apply(this, tok.outerWrites);
	
	    // Check for pending remote
	
	    // Assumption 2: if remote_script1 writes remote_script2 then
	    // the we notice remote_script1 finishes before remote_script2 starts.
	    // I think this is equivalent to assumption 1
	    if (!this.scriptStack.length && this.deferredRemote) {
	      this._onScriptStart(this.deferredRemote);
	      this.deferredRemote = null;
	    }
	  };
	
	  /**
	   * Build a script and insert it into the DOM.
	   * Done is called once script has executed.
	   *
	   * @param {Object} tok The token
	   * @param {Function} done The callback when complete
	   */
	
	
	  WriteStream.prototype._writeScriptToken = function _writeScriptToken(tok, done) {
	    var el = this._buildScript(tok);
	    var asyncRelease = this._shouldRelease(el);
	    var afterAsync = this.options.afterAsync;
	
	    if (tok.src) {
	      // Fix for attribute "SRC" (capitalized). IE does not recognize it.
	      el.src = tok.src;
	      this._scriptLoadHandler(el, !asyncRelease ? function () {
	        done();
	        afterAsync();
	      } : afterAsync);
	    }
	
	    try {
	      this._insertCursor(el, PROXY_SCRIPT);
	      if (!el.src || asyncRelease) {
	        done();
	      }
	    } catch (e) {
	      this.options.error(e);
	      done();
	    }
	  };
	
	  /**
	   * Build a script element from an atomic script token.
	   *
	   * @param {Object} tok The token
	   * @returns {Element}
	   */
	
	
	  WriteStream.prototype._buildScript = function _buildScript(tok) {
	    var el = this.doc.createElement(tok.tagName);
	
	    // Set attributes
	    utils.eachKey(tok.attrs, function (name, value) {
	      el.setAttribute(name, value);
	    });
	
	    // Set content
	    if (tok.content) {
	      el.text = tok.content;
	    }
	
	    return el;
	  };
	
	  /**
	   * Setup the script load handler on an element.
	   *
	   * @param {Object} el The element
	   * @param {Function} done The callback
	   * @private
	   */
	
	
	  WriteStream.prototype._scriptLoadHandler = function _scriptLoadHandler(el, done) {
	    function cleanup() {
	      el = el.onload = el.onreadystatechange = el.onerror = null;
	    }
	
	    var error = this.options.error;
	
	    function success() {
	      cleanup();
	      if (done != null) {
	        done();
	      }
	      done = null;
	    }
	
	    function failure(err) {
	      cleanup();
	      error(err);
	      if (done != null) {
	        done();
	      }
	      done = null;
	    }
	
	    function reattachEventListener(el, evt) {
	      var handler = el['on' + evt];
	      if (handler != null) {
	        el['_on' + evt] = handler;
	      }
	    }
	
	    reattachEventListener(el, 'load');
	    reattachEventListener(el, 'error');
	
	    _extends(el, {
	      onload: function onload() {
	        if (el._onload) {
	          try {
	            el._onload.apply(this, Array.prototype.slice.call(arguments, 0));
	          } catch (err) {
	            failure({ msg: 'onload handler failed ' + err + ' @ ' + el.src });
	          }
	        }
	        success();
	      },
	      onerror: function onerror() {
	        if (el._onerror) {
	          try {
	            el._onerror.apply(this, Array.prototype.slice.call(arguments, 0));
	          } catch (err) {
	            failure({ msg: 'onerror handler failed ' + err + ' @ ' + el.src });
	            return;
	          }
	        }
	        failure({ msg: 'remote script failed ' + el.src });
	      },
	      onreadystatechange: function onreadystatechange() {
	        if (/^(loaded|complete)$/.test(el.readyState)) {
	          success();
	        }
	      }
	    });
	  };
	
	  /**
	   * Determines whether to release.
	   *
	   * @param {Object} el The element
	   * @returns {boolean}
	   * @private
	   */
	
	
	  WriteStream.prototype._shouldRelease = function _shouldRelease(el) {
	    var isScript = /^script$/i.test(el.nodeName);
	    return !isScript || !!(this.options.releaseAsync && el.src && el.hasAttribute('async'));
	  };
	
	  return WriteStream;
	}();
	
	exports['default'] = WriteStream;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file prescribe
	 * @description Tiny, forgiving HTML parser
	 * @version vundefined
	 * @see {@link https://github.com/krux/prescribe/}
	 * @license MIT
	 * @author Derek Brans
	 * @copyright 2016 Krux Digital, Inc
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Prescribe"] = factory();
		else
			root["Prescribe"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _HtmlParser = __webpack_require__(1);
	
		var _HtmlParser2 = _interopRequireDefault(_HtmlParser);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		module.exports = _HtmlParser2['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _supports = __webpack_require__(2);
	
		var supports = _interopRequireWildcard(_supports);
	
		var _streamReaders = __webpack_require__(3);
	
		var streamReaders = _interopRequireWildcard(_streamReaders);
	
		var _fixedReadTokenFactory = __webpack_require__(6);
	
		var _fixedReadTokenFactory2 = _interopRequireDefault(_fixedReadTokenFactory);
	
		var _utils = __webpack_require__(5);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
		function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		/**
		 * Detection regular expressions.
		 *
		 * Order of detection matters: detection of one can only
		 * succeed if detection of previous didn't
	
		 * @type {Object}
		 */
		var detect = {
		  comment: /^<!--/,
		  endTag: /^<\//,
		  atomicTag: /^<\s*(script|style|noscript|iframe|textarea)[\s\/>]/i,
		  startTag: /^</,
		  chars: /^[^<]/
		};
	
		/**
		 * HtmlParser provides the capability to parse HTML and return tokens
		 * representing the tags and content.
		 */
	
		var HtmlParser = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} stream The initial parse stream contents.
		   * @param {Object} options The options
		   * @param {boolean} options.autoFix Set to true to automatically fix errors
		   */
		  function HtmlParser() {
		    var _this = this;
	
		    var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		    _classCallCheck(this, HtmlParser);
	
		    this.stream = stream;
	
		    var fix = false;
		    var fixedTokenOptions = {};
	
		    for (var key in supports) {
		      if (supports.hasOwnProperty(key)) {
		        if (options.autoFix) {
		          fixedTokenOptions[key + 'Fix'] = true; // !supports[key];
		        }
		        fix = fix || fixedTokenOptions[key + 'Fix'];
		      }
		    }
	
		    if (fix) {
		      this._readToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
		        return _this._readTokenImpl();
		      });
		      this._peekToken = (0, _fixedReadTokenFactory2['default'])(this, fixedTokenOptions, function () {
		        return _this._peekTokenImpl();
		      });
		    } else {
		      this._readToken = this._readTokenImpl;
		      this._peekToken = this._peekTokenImpl;
		    }
		  }
	
		  /**
		   * Appends the given string to the parse stream.
		   *
		   * @param {string} str The string to append
		   */
	
	
		  HtmlParser.prototype.append = function append(str) {
		    this.stream += str;
		  };
	
		  /**
		   * Prepends the given string to the parse stream.
		   *
		   * @param {string} str The string to prepend
		   */
	
	
		  HtmlParser.prototype.prepend = function prepend(str) {
		    this.stream = str + this.stream;
		  };
	
		  /**
		   * The implementation of the token reading.
		   *
		   * @private
		   * @returns {?Token}
		   */
	
	
		  HtmlParser.prototype._readTokenImpl = function _readTokenImpl() {
		    var token = this._peekTokenImpl();
		    if (token) {
		      this.stream = this.stream.slice(token.length);
		      return token;
		    }
		  };
	
		  /**
		   * The implementation of token peeking.
		   *
		   * @returns {?Token}
		   */
	
	
		  HtmlParser.prototype._peekTokenImpl = function _peekTokenImpl() {
		    for (var type in detect) {
		      if (detect.hasOwnProperty(type)) {
		        if (detect[type].test(this.stream)) {
		          var token = streamReaders[type](this.stream);
	
		          if (token) {
		            if (token.type === 'startTag' && /script|style/i.test(token.tagName)) {
		              return null;
		            } else {
		              token.text = this.stream.substr(0, token.length);
		              return token;
		            }
		          }
		        }
		      }
		    }
		  };
	
		  /**
		   * The public token peeking interface.  Delegates to the basic token peeking
		   * or a version that performs fixups depending on the `autoFix` setting in
		   * options.
		   *
		   * @returns {object}
		   */
	
	
		  HtmlParser.prototype.peekToken = function peekToken() {
		    return this._peekToken();
		  };
	
		  /**
		   * The public token reading interface.  Delegates to the basic token reading
		   * or a version that performs fixups depending on the `autoFix` setting in
		   * options.
		   *
		   * @returns {object}
		   */
	
	
		  HtmlParser.prototype.readToken = function readToken() {
		    return this._readToken();
		  };
	
		  /**
		   * Read tokens and hand to the given handlers.
		   *
		   * @param {Object} handlers The handlers to use for the different tokens.
		   */
	
	
		  HtmlParser.prototype.readTokens = function readTokens(handlers) {
		    var tok = void 0;
		    while (tok = this.readToken()) {
		      // continue until we get an explicit "false" return
		      if (handlers[tok.type] && handlers[tok.type](tok) === false) {
		        return;
		      }
		    }
		  };
	
		  /**
		   * Clears the parse stream.
		   *
		   * @returns {string} The contents of the parse stream before clearing.
		   */
	
	
		  HtmlParser.prototype.clear = function clear() {
		    var rest = this.stream;
		    this.stream = '';
		    return rest;
		  };
	
		  /**
		   * Returns the rest of the parse stream.
		   *
		   * @returns {string} The contents of the parse stream.
		   */
	
	
		  HtmlParser.prototype.rest = function rest() {
		    return this.stream;
		  };
	
		  return HtmlParser;
		}();
	
		exports['default'] = HtmlParser;
	
	
		HtmlParser.tokenToString = function (tok) {
		  return tok.toString();
		};
	
		HtmlParser.escapeAttributes = function (attrs) {
		  var escapedAttrs = {};
	
		  for (var name in attrs) {
		    if (attrs.hasOwnProperty(name)) {
		      escapedAttrs[name] = (0, _utils.escapeQuotes)(attrs[name], null);
		    }
		  }
	
		  return escapedAttrs;
		};
	
		HtmlParser.supports = supports;
	
		for (var key in supports) {
		  if (supports.hasOwnProperty(key)) {
		    HtmlParser.browserHasFlaw = HtmlParser.browserHasFlaw || !supports[key] && key;
		  }
		}
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		var tagSoup = false;
		var selfClose = false;
	
		var work = window.document.createElement('div');
	
		try {
		  var html = '<P><I></P></I>';
		  work.innerHTML = html;
		  exports.tagSoup = tagSoup = work.innerHTML !== html;
		} catch (e) {
		  exports.tagSoup = tagSoup = false;
		}
	
		try {
		  work.innerHTML = '<P><i><P></P></i></P>';
		  exports.selfClose = selfClose = work.childNodes.length === 2;
		} catch (e) {
		  exports.selfClose = selfClose = false;
		}
	
		work = null;
	
		exports.tagSoup = tagSoup;
		exports.selfClose = selfClose;
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
		exports.comment = comment;
		exports.chars = chars;
		exports.startTag = startTag;
		exports.atomicTag = atomicTag;
		exports.endTag = endTag;
	
		var _tokens = __webpack_require__(4);
	
		/**
		 * Regular Expressions for parsing tags and attributes
		 *
		 * @type {Object}
		 */
		var REGEXES = {
		  startTag: /^<([\-A-Za-z0-9_]+)((?:\s+[\w\-]+(?:\s*=?\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/,
		  endTag: /^<\/([\-A-Za-z0-9_]+)[^>]*>/,
		  attr: /(?:([\-A-Za-z0-9_]+)\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))|(?:([\-A-Za-z0-9_]+)(\s|$)+)/g,
		  fillAttr: /^(checked|compact|declare|defer|disabled|ismap|multiple|nohref|noresize|noshade|nowrap|readonly|selected)$/i
		};
	
		/**
		 * Reads a comment token
		 *
		 * @param {string} stream The input stream
		 * @returns {CommentToken}
		 */
		function comment(stream) {
		  var index = stream.indexOf('-->');
		  if (index >= 0) {
		    return new _tokens.CommentToken(stream.substr(4, index - 1), index + 3);
		  }
		}
	
		/**
		 * Reads non-tag characters.
		 *
		 * @param {string} stream The input stream
		 * @returns {CharsToken}
		 */
		function chars(stream) {
		  var index = stream.indexOf('<');
		  return new _tokens.CharsToken(index >= 0 ? index : stream.length);
		}
	
		/**
		 * Reads start tag token.
		 *
		 * @param {string} stream The input stream
		 * @returns {StartTagToken}
		 */
		function startTag(stream) {
		  var endTagIndex = stream.indexOf('>');
		  if (endTagIndex !== -1) {
		    var match = stream.match(REGEXES.startTag);
		    if (match) {
		      var _ret = function () {
		        var attrs = {};
		        var booleanAttrs = {};
		        var rest = match[2];
	
		        match[2].replace(REGEXES.attr, function (match, name) {
		          if (!(arguments[2] || arguments[3] || arguments[4] || arguments[5])) {
		            attrs[name] = '';
		          } else if (arguments[5]) {
		            attrs[arguments[5]] = '';
		            booleanAttrs[arguments[5]] = true;
		          } else {
		            attrs[name] = arguments[2] || arguments[3] || arguments[4] || REGEXES.fillAttr.test(name) && name || '';
		          }
	
		          rest = rest.replace(match, '');
		        });
	
		        return {
		          v: new _tokens.StartTagToken(match[1], match[0].length, attrs, booleanAttrs, !!match[3], rest.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ''))
		        };
		      }();
	
		      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		    }
		  }
		}
	
		/**
		 * Reads atomic tag token.
		 *
		 * @param {string} stream The input stream
		 * @returns {AtomicTagToken}
		 */
		function atomicTag(stream) {
		  var start = startTag(stream);
		  if (start) {
		    var rest = stream.slice(start.length);
		    // for optimization, we check first just for the end tag
		    if (rest.match(new RegExp('<\/\\s*' + start.tagName + '\\s*>', 'i'))) {
		      // capturing the content is inefficient, so we do it inside the if
		      var match = rest.match(new RegExp('([\\s\\S]*?)<\/\\s*' + start.tagName + '\\s*>', 'i'));
		      if (match) {
		        return new _tokens.AtomicTagToken(start.tagName, match[0].length + start.length, start.attrs, start.booleanAttrs, match[1]);
		      }
		    }
		  }
		}
	
		/**
		 * Reads an end tag token.
		 *
		 * @param {string} stream The input stream
		 * @returns {EndTagToken}
		 */
		function endTag(stream) {
		  var match = stream.match(REGEXES.endTag);
		  if (match) {
		    return new _tokens.EndTagToken(match[1], match[0].length);
		  }
		}
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.EndTagToken = exports.AtomicTagToken = exports.StartTagToken = exports.TagToken = exports.CharsToken = exports.CommentToken = exports.Token = undefined;
	
		var _utils = __webpack_require__(5);
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		/**
		 * Token is a base class for all token types parsed.  Note we don't actually
		 * use intheritance due to IE8's non-existent ES5 support.
		 */
		var Token =
		/**
		 * Constructor.
		 *
		 * @param {string} type The type of the Token.
		 * @param {Number} length The length of the Token text.
		 */
		exports.Token = function Token(type, length) {
		  _classCallCheck(this, Token);
	
		  this.type = type;
		  this.length = length;
		  this.text = '';
		};
	
		/**
		 * CommentToken represents comment tags.
		 */
	
	
		var CommentToken = exports.CommentToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} content The content of the comment
		   * @param {Number} length The length of the Token text.
		   */
		  function CommentToken(content, length) {
		    _classCallCheck(this, CommentToken);
	
		    this.type = 'comment';
		    this.length = length || (content ? content.length : 0);
		    this.text = '';
		    this.content = content;
		  }
	
		  CommentToken.prototype.toString = function toString() {
		    return '<!--' + this.content;
		  };
	
		  return CommentToken;
		}();
	
		/**
		 * CharsToken represents non-tag characters.
		 */
	
	
		var CharsToken = exports.CharsToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {Number} length The length of the Token text.
		   */
		  function CharsToken(length) {
		    _classCallCheck(this, CharsToken);
	
		    this.type = 'chars';
		    this.length = length;
		    this.text = '';
		  }
	
		  CharsToken.prototype.toString = function toString() {
		    return this.text;
		  };
	
		  return CharsToken;
		}();
	
		/**
		 * TagToken is a base class for all tag-based Tokens.
		 */
	
	
		var TagToken = exports.TagToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} type The type of the token.
		   * @param {string} tagName The tag name.
		   * @param {Number} length The length of the Token text.
		   * @param {Object} attrs The dictionary of attributes and values
		   * @param {Object} booleanAttrs If an entry has 'true' then the attribute
		   *                              is a boolean attribute
		   */
		  function TagToken(type, tagName, length, attrs, booleanAttrs) {
		    _classCallCheck(this, TagToken);
	
		    this.type = type;
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.unary = false;
		    this.html5Unary = false;
		  }
	
		  /**
		   * Formats the given token tag.
		   *
		   * @param {TagToken} tok The TagToken to format.
		   * @param {?string} [content=null] The content of the token.
		   * @returns {string} The formatted tag.
		   */
	
	
		  TagToken.formatTag = function formatTag(tok) {
		    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		    var str = '<' + tok.tagName;
		    for (var key in tok.attrs) {
		      if (tok.attrs.hasOwnProperty(key)) {
		        str += ' ' + key;
	
		        var val = tok.attrs[key];
		        if (typeof tok.booleanAttrs === 'undefined' || typeof tok.booleanAttrs[key] === 'undefined') {
		          str += '="' + (0, _utils.escapeQuotes)(val) + '"';
		        }
		      }
		    }
	
		    if (tok.rest) {
		      str += ' ' + tok.rest;
		    }
	
		    if (tok.unary && !tok.html5Unary) {
		      str += '/>';
		    } else {
		      str += '>';
		    }
	
		    if (content !== undefined && content !== null) {
		      str += content + '</' + tok.tagName + '>';
		    }
	
		    return str;
		  };
	
		  return TagToken;
		}();
	
		/**
		 * StartTagToken represents a start token.
		 */
	
	
		var StartTagToken = exports.StartTagToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} tagName The tag name.
		   * @param {Number} length The length of the Token text
		   * @param {Object} attrs The dictionary of attributes and values
		   * @param {Object} booleanAttrs If an entry has 'true' then the attribute
		   *                              is a boolean attribute
		   * @param {boolean} unary True if the tag is a unary tag
		   * @param {string} rest The rest of the content.
		   */
		  function StartTagToken(tagName, length, attrs, booleanAttrs, unary, rest) {
		    _classCallCheck(this, StartTagToken);
	
		    this.type = 'startTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.html5Unary = false;
		    this.unary = unary;
		    this.rest = rest;
		  }
	
		  StartTagToken.prototype.toString = function toString() {
		    return TagToken.formatTag(this);
		  };
	
		  return StartTagToken;
		}();
	
		/**
		 * AtomicTagToken represents an atomic tag.
		 */
	
	
		var AtomicTagToken = exports.AtomicTagToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} tagName The name of the tag.
		   * @param {Number} length The length of the tag text.
		   * @param {Object} attrs The attributes.
		   * @param {Object} booleanAttrs If an entry has 'true' then the attribute
		   *                              is a boolean attribute
		   * @param {string} content The content of the tag.
		   */
		  function AtomicTagToken(tagName, length, attrs, booleanAttrs, content) {
		    _classCallCheck(this, AtomicTagToken);
	
		    this.type = 'atomicTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		    this.attrs = attrs;
		    this.booleanAttrs = booleanAttrs;
		    this.unary = false;
		    this.html5Unary = false;
		    this.content = content;
		  }
	
		  AtomicTagToken.prototype.toString = function toString() {
		    return TagToken.formatTag(this, this.content);
		  };
	
		  return AtomicTagToken;
		}();
	
		/**
		 * EndTagToken represents an end tag.
		 */
	
	
		var EndTagToken = exports.EndTagToken = function () {
		  /**
		   * Constructor.
		   *
		   * @param {string} tagName The name of the tag.
		   * @param {Number} length The length of the tag text.
		   */
		  function EndTagToken(tagName, length) {
		    _classCallCheck(this, EndTagToken);
	
		    this.type = 'endTag';
		    this.length = length;
		    this.text = '';
		    this.tagName = tagName;
		  }
	
		  EndTagToken.prototype.toString = function toString() {
		    return '</' + this.tagName + '>';
		  };
	
		  return EndTagToken;
		}();
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports.escapeQuotes = escapeQuotes;
	
		/**
		 * Escape quotes in the given value.
		 *
		 * @param {string} value The value to escape.
		 * @param {string} [defaultValue=''] The default value to return if value is falsy.
		 * @returns {string}
		 */
		function escapeQuotes(value) {
		  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
		  // There's no lookback in JS, so /(^|[^\\])"/ only matches the first of two `"`s.
		  // Instead, just match anything before a double-quote and escape if it's not already escaped.
		  return !value ? defaultValue : value.replace(/([^"]*)"/g, function (_, prefix) {
		    return (/\\/.test(prefix) ? prefix + '"' : prefix + '\\"'
		    );
		  });
		}
	
	/***/ },
	/* 6 */
	/***/ function(module, exports) {
	
		'use strict';
	
		exports.__esModule = true;
		exports['default'] = fixedReadTokenFactory;
		/**
		 * Empty Elements - HTML 4.01
		 *
		 * @type {RegExp}
		 */
		var EMPTY = /^(AREA|BASE|BASEFONT|BR|COL|FRAME|HR|IMG|INPUT|ISINDEX|LINK|META|PARAM|EMBED)$/i;
	
		/**
		 * Elements that you can intentionally leave open (and which close themselves)
		 *
		 * @type {RegExp}
		 */
		var CLOSESELF = /^(COLGROUP|DD|DT|LI|OPTIONS|P|TD|TFOOT|TH|THEAD|TR)$/i;
	
		/**
		 * Corrects a token.
		 *
		 * @param {Token} tok The token to correct
		 * @returns {Token} The corrected token
		 */
		function correct(tok) {
		  if (tok && tok.type === 'startTag') {
		    tok.unary = EMPTY.test(tok.tagName) || tok.unary;
		    tok.html5Unary = !/\/>$/.test(tok.text);
		  }
		  return tok;
		}
	
		/**
		 * Peeks at the next token in the parser.
		 *
		 * @param {HtmlParser} parser The parser
		 * @param {Function} readTokenImpl The underlying readToken implementation
		 * @returns {Token} The next token
		 */
		function peekToken(parser, readTokenImpl) {
		  var tmp = parser.stream;
		  var tok = correct(readTokenImpl());
		  parser.stream = tmp;
		  return tok;
		}
	
		/**
		 * Closes the last token.
		 *
		 * @param {HtmlParser} parser The parser
		 * @param {Array<Token>} stack The stack
		 */
		function closeLast(parser, stack) {
		  var tok = stack.pop();
	
		  // prepend close tag to stream.
		  parser.prepend('</' + tok.tagName + '>');
		}
	
		/**
		 * Create a new token stack.
		 *
		 * @returns {Array<Token>}
		 */
		function newStack() {
		  var stack = [];
	
		  stack.last = function () {
		    return this[this.length - 1];
		  };
	
		  stack.lastTagNameEq = function (tagName) {
		    var last = this.last();
		    return last && last.tagName && last.tagName.toUpperCase() === tagName.toUpperCase();
		  };
	
		  stack.containsTagName = function (tagName) {
		    for (var i = 0, tok; tok = this[i]; i++) {
		      if (tok.tagName === tagName) {
		        return true;
		      }
		    }
		    return false;
		  };
	
		  return stack;
		}
	
		/**
		 * Return a readToken implementation that fixes input.
		 *
		 * @param {HtmlParser} parser The parser
		 * @param {Object} options Options for fixing
		 * @param {boolean} options.tagSoupFix True to fix tag soup scenarios
		 * @param {boolean} options.selfCloseFix True to fix self-closing tags
		 * @param {Function} readTokenImpl The underlying readToken implementation
		 * @returns {Function}
		 */
		function fixedReadTokenFactory(parser, options, readTokenImpl) {
		  var stack = newStack();
	
		  var handlers = {
		    startTag: function startTag(tok) {
		      var tagName = tok.tagName;
	
		      if (tagName.toUpperCase() === 'TR' && stack.lastTagNameEq('TABLE')) {
		        parser.prepend('<TBODY>');
		        prepareNextToken();
		      } else if (options.selfCloseFix && CLOSESELF.test(tagName) && stack.containsTagName(tagName)) {
		        if (stack.lastTagNameEq(tagName)) {
		          closeLast(parser, stack);
		        } else {
		          parser.prepend('</' + tok.tagName + '>');
		          prepareNextToken();
		        }
		      } else if (!tok.unary) {
		        stack.push(tok);
		      }
		    },
		    endTag: function endTag(tok) {
		      var last = stack.last();
		      if (last) {
		        if (options.tagSoupFix && !stack.lastTagNameEq(tok.tagName)) {
		          // cleanup tag soup
		          closeLast(parser, stack);
		        } else {
		          stack.pop();
		        }
		      } else if (options.tagSoupFix) {
		        // cleanup tag soup part 2: skip this token
		        readTokenImpl();
		        prepareNextToken();
		      }
		    }
		  };
	
		  function prepareNextToken() {
		    var tok = peekToken(parser, readTokenImpl);
		    if (tok && handlers[tok.type]) {
		      handlers[tok.type](tok);
		    }
		  }
	
		  return function fixedReadToken() {
		    prepareNextToken();
		    return correct(readTokenImpl());
		  };
		}
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.existy = existy;
	exports.isFunction = isFunction;
	exports.each = each;
	exports.eachKey = eachKey;
	exports.defaults = defaults;
	exports.toArray = toArray;
	exports.last = last;
	exports.isTag = isTag;
	exports.isScript = isScript;
	exports.isStyle = isStyle;
	/**
	 * Determine if the thing is not undefined and not null.
	 *
	 * @param {*} thing The thing to test
	 * @returns {boolean} True if the thing is not undefined and not null.
	 */
	function existy(thing) {
	  return thing !== void 0 && thing !== null;
	}
	
	/**
	 * Is this a function?
	 *
	 * @param {*} x The variable to test
	 * @returns {boolean} True if the variable is a function
	 */
	function isFunction(x) {
	  return 'function' === typeof x;
	}
	
	/**
	 * Loop over each item in an array-like value.
	 *
	 * @param {Array<*>} arr The array to loop over
	 * @param {Function} fn The function to call
	 * @param {?Object} target The object to bind to the function
	 */
	function each(arr, fn, target) {
	  var i = void 0;
	  var len = arr && arr.length || 0;
	  for (i = 0; i < len; i++) {
	    fn.call(target, arr[i], i);
	  }
	}
	
	/**
	 * Loop over each key/value pair in a hash.
	 *
	 * @param {Object} obj The object
	 * @param {Function} fn The function to call
	 * @param {?Object} target The object to bind to the function
	 */
	function eachKey(obj, fn, target) {
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      fn.call(target, key, obj[key]);
	    }
	  }
	}
	
	/**
	 * Set default options where some option was not specified.
	 *
	 * @param {Object} options The destination
	 * @param {Object} _defaults The defaults
	 * @returns {Object}
	 */
	function defaults(options, _defaults) {
	  options = options || {};
	  eachKey(_defaults, function (key, val) {
	    if (!existy(options[key])) {
	      options[key] = val;
	    }
	  });
	  return options;
	}
	
	/**
	 * Convert value (e.g., a NodeList) to an array.
	 *
	 * @param {*} obj The object
	 * @returns {Array<*>}
	 */
	function toArray(obj) {
	  try {
	    return Array.prototype.slice.call(obj);
	  } catch (e) {
	    var _ret = function () {
	      var ret = [];
	      each(obj, function (val) {
	        ret.push(val);
	      });
	      return {
	        v: ret
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	
	/**
	 * Get the last item in an array
	 *
	 * @param {Array<*>} array The array
	 * @returns {*} The last item in the array
	 */
	function last(array) {
	  return array[array.length - 1];
	}
	
	/**
	 * Test if token is a script tag.
	 *
	 * @param {Object} tok The token
	 * @param {String} tag The tag name
	 * @returns {boolean} True if the token is a script tag
	 */
	function isTag(tok, tag) {
	  return !tok || !(tok.type === 'startTag' || tok.type === 'atomicTag') || !('tagName' in tok) ? !1 : !!~tok.tagName.toLowerCase().indexOf(tag);
	}
	
	/**
	 * Test if token is a script tag.
	 *
	 * @param {Object} tok The token
	 * @returns {boolean} True if the token is a script tag
	 */
	function isScript(tok) {
	  return isTag(tok, 'script');
	}
	
	/**
	 * Test if token is a style tag.
	 *
	 * @param {Object} tok The token
	 * @returns {boolean} True if the token is a style tag
	 */
	function isStyle(tok) {
	  return isTag(tok, 'style');
	}

/***/ }
/******/ ])
});
;
//# sourceMappingURL=postscribe.js.map

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var reducer_1 = __webpack_require__(1609);
exports.attachments = reducer_1.attachments;
var actions_1 = __webpack_require__(125);
exports.initAttachments = actions_1.initAttachments;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = __webpack_require__(125);
var initialState = {
    edit: null,
    files: [],
    maxSize: 0,
    maxFiles: 10,
};
function attachments(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions_1.INIT_ATTACHMENTS:
            return __assign({}, action.payload);
        case actions_1.ADD_ATTACHMENTS:
            return __assign({}, state, { files: state.files.concat(action.payload) });
        case actions_1.REMOVE_ATTACHMENT:
            return __assign({}, state, { files: state.files.filter(function (f) { return f !== action.payload; }) });
        case actions_1.OPEN_ATTACHMENT_FOR_EDITING:
            return __assign({}, state, { edit: action.payload });
        case actions_1.CLOSE_ATTACHMENT_EDITOR:
            return __assign({}, state, { edit: null });
        case actions_1.UPDATE_ATTACHMENT:
            return __assign({}, state, { edit: null, files: state.files.map(function (f) { return f._id !== action.payload._id ? f : action.payload; }) });
        default:
            return state;
    }
}
exports.attachments = attachments;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdAuthoringTopbar
 *
 * @requires TranslationService
 *
 * @description Generates authoring subnav bar
 */
AuthoringTopbarDirective.$inject = ['TranslationService', 'privileges', 'authoringWorkspace'];
function AuthoringTopbarDirective(TranslationService, privileges, authoringWorkspace) {
    return {
        templateUrl: 'scripts/apps/authoring/views/authoring-topbar.html',
        link: function (scope) {
            scope.additionalButtons = authoringWorkspace.authoringTopBarAdditionalButtons;
            scope.buttonsToHide = authoringWorkspace.authoringTopBarButtonsToHide;
            scope.saveDisabled = false;
            scope.userHasPrivileges = privileges.userHasPrivileges;
            /*
             * Save item
             * @return {promise}
             */
            scope.saveTopbar = function () {
                scope.saveDisabled = true;
                return scope.save(scope.item)
                    .finally(function () {
                    scope.saveDisabled = false;
                });
            };
            // Activate preview formatted item
            scope.previewFormattedItem = function () {
                scope.previewFormatted = true;
            };
            // Close preview formatted item
            scope.closePreviewFormatted = function () {
                scope.previewFormatted = false;
            };
            /*
             * Check if item is available for translating
             * @return {Boolean}
             */
            scope.isTranslationAvailable = function () {
                return TranslationService.checkAvailability(scope.item);
            };
        },
    };
}
exports.AuthoringTopbarDirective = AuthoringTopbarDirective;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
PreviewFormattedDirective.$inject = ['api', 'config', 'notify', 'storage'];
function PreviewFormattedDirective(api, config, notify, storage) {
    return {
        templateUrl: 'scripts/apps/authoring/views/preview-formatted.html',
        link: function (scope) {
            scope.loading = false;
            scope.selectedFormatter = storage.getItem('selectedFormatter');
            scope.format = function (formatterString) {
                scope.loading = true;
                storage.setItem('selectedFormatter', formatterString);
                var formatter = JSON.parse(formatterString);
                api.save('formatters', {}, { article_id: scope.item._id, formatter_name: formatter.name })
                    .then(function (item) {
                    scope.formattedItem = item._id.formatted_doc;
                }, function (error) {
                    if (angular.isDefined(error.data._message)) {
                        notify.error(utils_1.gettext(error.data._message));
                    }
                })
                    .finally(function () {
                    scope.loading = false;
                });
            };
            // Get formatters
            api.query('formatters', { criteria: 'can_preview' }).then(function (result) {
                scope.previewFormatters = result._items;
                if (!scope.selectedFormatter && scope.previewFormatters.length > 0) {
                    scope.selectedFormatter = JSON.stringify(scope.previewFormatters[0]);
                }
            });
        },
    };
}
exports.PreviewFormattedDirective = PreviewFormattedDirective;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
AuthoringContainerDirective.$inject = ['authoring', 'authoringWorkspace'];
function AuthoringContainerDirective(authoring, authoringWorkspace) {
    function AuthoringContainerController() {
        var self = this;
        this.state = {};
        this.showingSuggestions = false;
        /**
         * Start editing item using given action mode
         *
         * @param {string} item
         * @param {string} action
         */
        this.edit = function (item, action) {
            self.item = item;
            self.action = action;
            self.state.opened = !!item;
        };
    }
    return {
        controller: AuthoringContainerController,
        controllerAs: 'authoring',
        templateUrl: 'scripts/apps/authoring/views/authoring-container.html',
        scope: {},
        require: 'sdAuthoringContainer',
        link: function (scope, elem, attrs, ctrl) {
            scope.$watch(authoringWorkspace.getState, function (state) {
                if (state) {
                    ctrl.edit(null, null);
                    // do this in next digest cycle so that it can
                    // destroy authoring/packaging-embedded in current cycle
                    scope.$applyAsync(function () {
                        ctrl.edit(state.item, state.action);
                    });
                }
            });
        },
    };
}
exports.AuthoringContainerDirective = AuthoringContainerDirective;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var helpers = __importStar(__webpack_require__(72));
var utils_1 = __webpack_require__(3);
AuthoringEmbeddedDirective.$inject = ['api', 'notify', '$filter', 'config', 'deployConfig'];
function AuthoringEmbeddedDirective(api, notify, $filter, config, deployConfig) {
    return {
        templateUrl: 'scripts/apps/authoring/views/authoring.html',
        scope: {
            item: '=',
            action: '=',
        },
        link: function (scope) {
            function overrideEdnote(template) {
                /* Override Editor note with given template or default one
                 *
                 * @param {string} template - template to use (set in backend)
                 */
                var date = $filter('formatLocalDateTimeString')(scope.item.versioncreated, config.view.dateformat +
                    ' ' + config.view.timeformat);
                if (template == null) {
                    var lineBreak = '\r\n\r\n';
                    // no template specified in backend, we use default one
                    var slugline = scope.item.slugline ? '"' + scope.item.slugline + '" ' : '';
                    scope.item.ednote = utils_1.gettext('In the story {{slugline}} sent at: {{date}} {{lineBreak}}. This is corrected repeat.', { slugline: slugline, date: date, lineBreak: lineBreak });
                }
                else {
                    // we use template from backend
                    scope.item.ednote = template
                        .replace('{date}', date)
                        .replace('{slugline}', scope.item.slugline || '');
                }
            }
            if (scope.action === 'kill' || scope.action === 'takedown') {
                // kill template is applied on the item.
                // task is required to get the desk name.
                var fields = lodash_1.default.union(lodash_1.default.keys(helpers.CONTENT_FIELDS_DEFAULTS), ['_id', 'versioncreated', 'task']);
                var item = {
                    template_name: scope.action, item: lodash_1.default.pick(scope.item, fields),
                };
                api.save('content_templates_apply', {}, item, {}).then(function (result) {
                    item = lodash_1.default.pick(result, lodash_1.default.keys(helpers.CONTENT_FIELDS_DEFAULTS));
                    scope.origItem = angular.extend({}, scope.item);
                    lodash_1.default.each(item, function (value, key) {
                        scope.origItem[key] = value;
                    });
                }, function (err) {
                    notify.error(utils_1.gettext('Failed to apply kill template to the item.'));
                });
            }
            else if (scope.action === 'correct') {
                deployConfig.all({
                    override: 'override_ednote_for_corrections',
                    template: 'override_ednote_template',
                }).then(function (_config) {
                    if (_config.override) {
                        overrideEdnote(_config.template);
                    }
                    scope.origItem = scope.item;
                });
                scope.item.flags.marked_for_sms = false;
                scope.item.sms_message = '';
            }
            else {
                scope.origItem = scope.item;
            }
        },
    };
}
exports.AuthoringEmbeddedDirective = AuthoringEmbeddedDirective;


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var fieldsMeta_1 = __webpack_require__(66);
AuthoringHeaderDirective.$inject = [
    'api',
    'authoringWidgets',
    '$rootScope',
    'archiveService',
    'metadata',
    'content',
    'authoring',
    'vocabularies',
    '$timeout',
    'config',
    'moment',
    'features',
    'TranslationService',
    'authoringWorkspace',
];
function AuthoringHeaderDirective(api, authoringWidgets, $rootScope, archiveService, metadata, content, authoring, vocabularies, $timeout, config, moment, features, TranslationService, authoringWorkspace) {
    return {
        templateUrl: 'scripts/apps/authoring/views/authoring-header.html',
        require: '?^sdAuthoringWidgets',
        link: function (scope, elem, attrs, WidgetsManagerCtrl) {
            scope.contentType = null;
            scope.displayCompanyCodes = null;
            scope.features = features;
            scope.translationService = TranslationService;
            scope.FIELD_KEY_SEPARATOR = fieldsMeta_1.FIELD_KEY_SEPARATOR;
            scope.isCollapsed = authoringWorkspace.displayAuthoringHeaderCollapedByDefault == null
                ? false :
                authoringWorkspace.displayAuthoringHeaderCollapedByDefault;
            scope.toggleCollapsed = function () {
                scope.isCollapsed = !scope.isCollapsed;
            };
            if (TranslationService.translationsEnabled() === true) {
                TranslationService.getTranslations(scope.item)
                    .then(function (translations) {
                    scope.translationsInfo = {
                        count: translations._meta.total,
                        translatedFromReference: translations._items.find(function (item) { return item._id === scope.item.translated_from; }),
                    };
                })
                    .catch(function () {
                    // no translations found, do nothing
                });
            }
            scope.shouldDisplayUrgency = function () {
                return !(scope.editor.urgency || {}).service ||
                    Array.isArray(scope.item.anpa_category) &&
                        scope.item.anpa_category.length &&
                        scope.item.anpa_category[0].qcode &&
                        scope.editor.urgency.service[scope.item.anpa_category[0].qcode];
            };
            /**
             * Returns true if the Company Codes field should be displayed, false otherwise.
             * Company Codes field is displayed only if either Subject or Category has finance category.
             */
            scope.shouldDisplayCompanyCodes = function () {
                if (!metadata.values.company_codes) {
                    return false;
                }
                var display = scope.item.company_codes && scope.item.company_codes.length > 0;
                var financeCategory;
                if (!display && scope.item.anpa_category) {
                    financeCategory = lodash_1.find(scope.item.anpa_category, { qcode: 'f' });
                    display = !lodash_1.isUndefined(financeCategory) && !lodash_1.isNull(financeCategory);
                }
                if (!display && scope.item.subject) {
                    financeCategory = lodash_1.find(scope.item.subject, function (category) {
                        if (category.qcode === '04000000' || category.qcode === '04006018'
                            || category.qcode === '04019000') {
                            return category;
                        }
                    });
                    display = !lodash_1.isUndefined(financeCategory) && !lodash_1.isNull(financeCategory);
                }
                scope.displayCompanyCodes = display;
                return display;
            };
            scope.$watch('item', function (item) {
                if (!item) {
                    return;
                }
                scope.loaded = true;
                scope.missing_link = false;
                if (!archiveService.isLegal(scope.item)) {
                    var relatedItemWidget = lodash_1.filter(authoringWidgets, function (widget) { return widget._id === 'related-item'; });
                    scope.activateWidget = function () {
                        WidgetsManagerCtrl.activate(relatedItemWidget[0]);
                    };
                    scope.previewMasterStory = function () {
                        var itemId = item.broadcast.master_id;
                        return api.find('archive', itemId).then(function (_item) {
                            $rootScope.$broadcast('broadcast:preview', { item: _item });
                        });
                    };
                }
            });
            scope.activateTranslationsWidget = function () {
                WidgetsManagerCtrl.activate(authoringWidgets.find(function (widget) { return widget._id === 'translations'; }));
            };
            scope.$watch('item.profile', function (profile) {
                if (profile) {
                    content.getType(profile)
                        .then(function (type) {
                        scope.contentType = type;
                        scope.editor = authoring.editor = content.editor(type, scope.item.type);
                        scope.schema = authoring.schema = content.schema(type, scope.item.type);
                        initAnpaCategories();
                    });
                }
                else {
                    scope.editor = authoring.editor = content.editor(null, scope.item.type);
                    scope.schema = authoring.schema = content.schema(null, scope.item.type);
                }
            });
            function getNoMissingLink() {
                return config.features && 'noMissingLink' in config.features
                    && config.features.noMissingLink;
            }
            function getRelatedItems() {
                // Related Items
                scope.missing_link = false;
                if (scope.item.slugline && scope.item.type === 'text') {
                    // get the midnight based on the defaultTimezone not the user timezone.
                    var fromDateTime = moment().tz(config.defaultTimezone)
                        .format(config.view.dateformat);
                    archiveService.getRelatedItems(scope.item, fromDateTime)
                        .then(function (items) {
                        scope.relatedItems = items;
                        if (items && items._items.length && !getNoMissingLink()) {
                            // if takes package is missing or not rewrite of.
                            scope.missing_link = !scope.item.rewrite_of &&
                                !scope.item.rewritten_by;
                        }
                    });
                }
            }
            if (!archiveService.isLegal(scope.item)) {
                scope.$watch('item.slugline', function () {
                    $timeout(getRelatedItems, 800);
                });
            }
            /**
             * Sets the anpa category corresponding to the required subservice: if a subservice
             * field (defined in vocabularies) was declared as required in a content profile
             * then make sure that the corresponding anpa category was added to the anpa_category
             * field in the newly created item. Without this value the anpa category field is not
             * displayed.
             */
            function initAnpaCategories() {
                if (scope.schema.subject && scope.schema.subject.mandatory_in_list) {
                    lodash_1.forEach(scope.schema.subject.mandatory_in_list.scheme, function (subjectName) {
                        if (!lodash_1.startsWith(subjectName, 'subservice_')) {
                            return;
                        }
                        vocabularies.getVocabularies().then(function (vocabulariesColl) {
                            var vocabulary = lodash_1.find(vocabulariesColl, { _id: subjectName });
                            if (vocabulary) {
                                var qcode = lodash_1.keys(vocabulary.service).pop();
                                var categoriesVocabulary = lodash_1.find(vocabulariesColl, { _id: 'categories' });
                                var category = lodash_1.find(categoriesVocabulary.items, { qcode: qcode });
                                if (category && lodash_1.findIndex(scope.item.anpa_category, { name: category.name }) === -1) {
                                    if (!scope.item.anpa_category) {
                                        scope.item.anpa_category = [];
                                    }
                                    scope.item.anpa_category.splice(-1, 0, { name: category.name, qcode: category.qcode, scheme: category.scheme });
                                }
                            }
                        });
                    });
                }
            }
            metadata.initialize().then(function () {
                scope.helper_text = metadata.helper_text;
                scope.popup_width = metadata.popup_width;
                scope.single_value = metadata.single_value;
                scope.$watchGroup(['item.anpa_category', 'editor', 'schema'], function (_a) {
                    var services = _a[0], editor = _a[1], schema = _a[2];
                    if (editor == null || schema == null) {
                        return;
                    }
                    var qcodes = lodash_1.map(services, 'qcode');
                    metadata.getCustomVocabulariesForArticleHeader(qcodes, editor, schema).then(function (cvs) {
                        scope.cvs = lodash_1.sortBy(cvs, 'priority');
                        scope.genreInCvs = lodash_1.map(cvs, 'schema_field').indexOf('genre') !== -1;
                        scope.placeInCvs = lodash_1.map(cvs, 'schema_field').indexOf('place') !== -1;
                        scope.shouldDisplayCompanyCodes();
                    });
                });
                scope.$watch('item.subject', function () {
                    scope.shouldDisplayCompanyCodes();
                });
            });
            // If correction set focus to the ednote to encourage user to fill it in
            lodash_1.defer(function () {
                if (scope.action === 'correct') {
                    elem.find('#ednote').focus();
                }
                else {
                    elem.find('#slugline').focus();
                }
            });
        },
    };
}
exports.AuthoringHeaderDirective = AuthoringHeaderDirective;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ctrl = __importStar(__webpack_require__(246));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdItemAssociation
 *
 * @requires superdesk
 * @requires renditions
 * @requires config
 * @requires authoring
 * @requires $q
 * @requires api
 * @requires notify
 * @requires mediaIdGenerator
 *
 * @description
 *   This directive is responsible for rendering media associated with the item.
 */
ItemAssociationDirective.$inject = ['renditions'];
function ItemAssociationDirective(renditions) {
    return {
        scope: {
            rel: '=',
            item: '=',
            editable: '<',
            tabindex: '<',
            allowPicture: '<',
            allowVideo: '<',
            allowAudio: '<',
            onchange: '&',
            showTitle: '<',
            save: '&',
            maxUploads: '=',
        },
        controller: ctrl.AssociationController,
        controllerAs: 'associations',
        templateUrl: 'scripts/apps/authoring/views/item-association.html',
        link: function (scope, elem, attr, _ctrl) {
            var dragOverClass = 'dragover';
            var MEDIA_TYPES = [];
            if (scope.allowPicture) {
                MEDIA_TYPES.push('application/superdesk.item.picture');
                MEDIA_TYPES.push('application/superdesk.item.graphic');
            }
            if (scope.allowVideo) {
                MEDIA_TYPES.push('application/superdesk.item.video');
            }
            if (scope.allowAudio) {
                MEDIA_TYPES.push('application/superdesk.item.audio');
            }
            if (!elem.hasClass('no-drop-zone')) {
                // it should prevent default as long as this is valid image
                elem.on('dragover', function (event) {
                    if (MEDIA_TYPES.includes(utils_1.getSuperdeskType(event))) {
                        event.preventDefault();
                        event.stopPropagation();
                        addDragOverClass();
                    }
                    else {
                        removeDragOverClass();
                    }
                });
                elem.on('dragleave', function () {
                    removeDragOverClass();
                });
                // update item associations on drop
                elem.on('drop dragdrop', function (event) {
                    removeDragOverClass();
                    event.preventDefault();
                    event.stopPropagation();
                    _ctrl.initializeUploadOnDrop(scope, event);
                });
            }
            var addDragOverClass = function () {
                elem.find('figure').addClass(dragOverClass);
                elem.find('button.item-association').addClass(dragOverClass);
            };
            var removeDragOverClass = function () {
                elem.find('figure').removeClass(dragOverClass);
                elem.find('button.item-association').removeClass(dragOverClass);
            };
            // init associated item for preview
            scope.$watch('item.associations[rel]', function (related) {
                scope.related = related;
            });
            renditions.get();
            /**
             * @ngdoc method
             * @name sdItemAssociation#remove
             * @public
             * @description Remove the associations
             */
            scope.remove = function (item) {
                _ctrl.updateItemAssociation(scope, null, item.fieldId);
            };
            /**
             * @ngdoc method
             * @name sdItemAssociation#upload
             * @public
             * @description Upload media.
             */
            scope.upload = function () {
                if (scope.editable) {
                    _ctrl.uploadAndCropImages(scope);
                }
            };
            scope.onMetadataChange = function (field) {
                scope.related[field] = utils_1.stripHtmlTags(scope.related[field]);
                scope.onchange();
            };
        },
    };
}
exports.ItemAssociationDirective = ItemAssociationDirective;


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
AuthoringController.$inject = ['$scope', 'item', 'action', 'superdesk'];
function AuthoringController($scope, item, action, superdesk) {
    $scope.origItem = item;
    $scope.action = action || 'edit';
    $scope.lock = function () {
        superdesk.intent('author', 'article', item);
    };
}
exports.AuthoringController = AuthoringController;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var utils_2 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring
 * @name AssociationController
 *
 * @requires $scope
 *
 * @description Controller for handling adding/uploading images to association fields
 */
AssociationController.$inject = ['config', 'send', 'api', '$q', 'superdesk',
    'mediaIdGenerator', 'authoring', 'renditions', 'notify'];
function AssociationController(config, send, api, $q, superdesk, mediaIdGenerator, authoring, renditions, notify) {
    var self = this;
    /**
     * @ngdoc method
     * @name AssociationController#isMediaEditable
     * @public
     * @description Check if featured media can be edited or not. i.e. metadata/crops can be changed or not.
     */
    this.isMediaEditable = function () {
        return !(config.features && 'editFeaturedImage' in config.features
            && !config.features.editFeaturedImage);
    };
    /**
     * @ngdoc method
     * @name AssociationController#isImage
     * @public
     * @description Check if the rendition is image or not.
     * @param {Object} rendition Rendition of the item.
     */
    this.isImage = function (rendition) {
        return lodash_1.startsWith(rendition.mimetype, 'image');
    };
    /**
     * @ngdoc method
     * @name AssociationController#isVideo
     * @public
     * @description Check if the rendition is video or not.
     * @param {Object} rendition Rendition of the item.
     */
    this.isVideo = function (rendition) {
        if (lodash_1.startsWith(rendition.mimetype, 'video')) {
            return true;
        }
        return lodash_1.some(['.mp4', '.webm', '.ogv', '.ogg'], function (ext) { return lodash_1.endsWith(rendition.href, ext); });
    };
    /**
     * @ngdoc method
     * @name AssociationController#isAudio
     * @public
     * @description Check if the rendition is audio or not.
     * @param {Object} rendition Rendition of the item.
     */
    this.isAudio = function (rendition) {
        if (lodash_1.startsWith(rendition.mimetype, 'audio')) {
            return true;
        }
        return lodash_1.some(['.mp3', '.3gp', '.wav', '.ogg', 'wma', 'aa', 'aiff'], function (ext) { return lodash_1.endsWith(rendition.href, ext); });
    };
    /**
     * @ngdoc method
     * @name AssociationController#getItem
     * @private
     * @description Get superdesk item from event.
     *              If not externalsource then fetch for archive collection not all fields
     *              are available due to projections.
     * @param {Event} event
     * @param {string} dataType
     * @return {Object}
     */
    this.getItem = function (event, dataType) {
        var item = angular.fromJson(event.originalEvent.dataTransfer.getData(dataType));
        if (item._type !== 'externalsource') {
            if (item._type === 'ingest') {
                return send.one(item);
            }
            if (item.archive_item != null) {
                return $q.when(item.archive_item);
            }
            return api.find(item._type, item._id);
        }
        return $q.when(item);
    };
    /**
     * @ngdoc method
     * @name AssociationController#uploadAndCropImages
     * @private
     * @description Opens the file upload dialog. If files contains an array of files populates
     *              the dialog with the given files. Opens the crop dialog for each uploaded file.
     * @param {Object} scope Directive scope
     * @param {Array} files
     */
    this.uploadAndCropImages = function (scope, files) {
        var uploadData = {
            files: files,
            uniqueUpload: scope.maxUploads === undefined || scope.maxUploads === 1,
            maxUploads: scope.maxUploads,
            allowPicture: scope.allowPicture,
            allowVideo: scope.allowVideo,
            allowAudio: scope.allowAudio,
        };
        superdesk.intent('upload', 'media', uploadData).then(function (images) {
            // open the view to edit the point of interest and the cropping areas
            if (images) {
                scope.$applyAsync(function () {
                    var _a = mediaIdGenerator.getFieldParts(scope.rel), rootField = _a[0], index = _a[1];
                    var imagesWithIds = [];
                    function editNextFile() {
                        if (imagesWithIds.length > 0) {
                            var imageWithId = imagesWithIds.shift();
                            self.edit(scope, imageWithId.image, {
                                customRel: imageWithId.id,
                                isNew: true,
                            }, editNextFile);
                        }
                    }
                    lodash_1.forEach(images, function (image) {
                        imagesWithIds.push({ id: scope.rel, image: image });
                        scope.rel = mediaIdGenerator.getFieldVersionName(rootField, ++index);
                    });
                    editNextFile();
                });
            }
        });
    };
    /**
     * @ngdoc method
     * @name AssociationController#updateItemAssociation
     * @private
     * @description If the item is not published then it saves the changes otherwise calls autosave.
     * @param {Object} scope Directive scope
     * @param {Object} updated Item to be edited
     * @param {String} customRel association identifier
     * @param {Function} callback to call after save
     */
    this.updateItemAssociation = function (scope, updated, customRel, callback, autosave) {
        if (callback === void 0) { callback = null; }
        if (autosave === void 0) { autosave = false; }
        var data = {}, rel = customRel || scope.rel;
        data[rel] = updated;
        scope.item.associations = angular.extend({}, scope.item.associations, data);
        scope.rel = rel;
        var promise;
        if (!authoring.isPublished(scope.item) && updated && !autosave) {
            promise = scope.save();
        }
        else {
            promise = scope.onchange({ item: scope.item, data: data });
        }
        if (callback) {
            return promise.then(callback);
        }
        return promise;
    };
    /**
     * @ngdoc method
     * @name AssociationController#edit
     * @public
     * @description Opens the item for edit.
     * @param {Object} scope Directive scope
     * @param {Object} item Item to be edited
     * @param {Function} callback Callback function
     */
    this.edit = function (scope, item, options, callback) {
        if (options === void 0) { options = {}; }
        if (callback === void 0) { callback = null; }
        if (!self.isMediaEditable()) {
            return;
        }
        var isImage = self.isImage(item.renditions.original);
        var defaultTab = isImage ? 'crop' : 'view';
        var cropOptions = {
            isNew: 'isNew' in options ? options.isNew : false,
            editable: !!scope.editable,
            isAssociated: true,
            defaultTab: 'defaultTab' in options ? options.defaultTab : defaultTab,
            showMetadata: 'showMetadata' in options ? options.showMetadata : true,
        };
        if (item.renditions && item.renditions.original) {
            scope.loading = true;
            return renditions.crop(item, cropOptions)
                .then(function (rendition) {
                self.updateItemAssociation(scope, rendition, options.customRel, callback);
            })
                .finally(function () {
                scope.loading = false;
            });
        }
        else {
            scope.loading = false;
        }
        self.updateItemAssociation(scope, item, options.customRel, callback);
    };
    /**
     * @ngdoc method
     * @name AssociationController#initializeUploadOnDrop
     * @public
     * @description Initialize upload on drop in field
     * @param {Object} scope Directive scope
     * @param {Object} event Drop event
     */
    this.initializeUploadOnDrop = function (scope, event) {
        var superdeskType = utils_1.getSuperdeskType(event);
        if (superdeskType === 'Files') {
            if (self.isMediaEditable()) {
                var files = event.originalEvent.dataTransfer.files;
                self.uploadAndCropImages(scope, files);
            }
            return;
        }
        self.getItem(event, superdeskType).then(function (item) {
            if (!scope.editable) {
                return;
            }
            if (item.lock_user) {
                notify.error(utils_2.gettext('Item is locked. Cannot associate media item.'));
                return;
            }
            // save generated association id in order to be able to update the same item after editing.
            var originalRel = scope.rel;
            if (self.isMediaEditable() && lodash_1.get(item, '_type') === 'externalsource') {
                // if media is editable then association will be updated by self.edit method
                scope.loading = true;
                renditions.ingest(item)
                    .then(function (_item) { return self.edit(scope, _item, { customRel: originalRel }); })
                    .finally(function () {
                    scope.loading = false;
                });
            }
            else {
                // Update the association is media is not editable.
                self.updateItemAssociation(scope, item, null, null, true);
            }
        });
    };
}
exports.AssociationController = AssociationController;


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global _ */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1619);
var lodash_1 = __importDefault(__webpack_require__(2));
var ctrl = __importStar(__webpack_require__(246));
var waitForMediaToBeReady_1 = __webpack_require__(1620);
var utils_1 = __webpack_require__(3);
var utils_2 = __webpack_require__(3);
var carouselContainerSelector = '.sd-media-carousel__content';
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdItemCarousel
 *
 * @requires $timeout
 */
ItemCarouselDirective.$inject = ['$timeout', 'notify'];
function ItemCarouselDirective($timeout, notify) {
    return {
        scope: {
            items: '=',
            item: '=',
            tabindex: '<',
            editable: '<',
            allowPicture: '<',
            allowVideo: '<',
            allowAudio: '<',
            save: '&',
            onchange: '&',
            maxUploads: '=',
            field: '=',
        },
        transclude: true,
        templateUrl: 'scripts/apps/authoring/views/item-carousel.html',
        controller: ctrl.AssociationController,
        controllerAs: 'associations',
        link: function (scope, elem, attr, controller) {
            var carousel;
            var previousItemsString;
            var allowed = { picture: scope.allowPicture, video: scope.allowVideo, audio: scope.allowAudio };
            var ALLOWED_TYPES = Object.keys(allowed)
                .filter(function (key) { return allowed[key] === true; })
                .map(function (key) { return 'application/superdesk.item.' + key; });
            /*
             * Initialize carousel after all content is loaded
             * otherwise carousel height is messed up
             */
            scope.$watch('items', function (items) {
                var itemsString = angular.toJson(items);
                // Don't execute if there are no items or they are the same as before
                if (!items || previousItemsString === itemsString) {
                    return false;
                }
                scope.navCounter = 1;
                previousItemsString = itemsString;
                var field = lodash_1.default.find(items, function (item) { return !item[item.fieldId]; });
                scope.rel = field ? field.fieldId : null;
                scope.carouselItems = lodash_1.default.sortBy(lodash_1.default.filter(items, function (item) { return item[item.fieldId]; }), [function (item) { return item[item.fieldId].order; }]);
                scope.$applyAsync(function () {
                    // waiting for angular to render items
                    if (carousel) {
                        carousel.trigger('destroy.owl.carousel');
                    }
                    var carouselImages = Array.from(elem.get(0).querySelectorAll(carouselContainerSelector + " img"));
                    var carouselAudiosAndVideos = Array.from(elem.get(0).querySelectorAll(carouselContainerSelector + " video, " + carouselContainerSelector + " audio"));
                    if (items.length < 1 || (carouselImages.length + carouselAudiosAndVideos.length < 1)) {
                        return;
                    }
                    Promise.all([
                        waitForMediaToBeReady_1.waitForImagesToLoad(carouselImages),
                        waitForMediaToBeReady_1.waitForAudioAndVideoToLoadMetadata(carouselAudiosAndVideos),
                    ]).then(initCarousel);
                });
            });
            /*
             * Initialize carousel navigation
             */
            scope.navNext = function () {
                if (scope.navCounter < scope.carouselItems.length) {
                    carousel.trigger('next.owl.carousel');
                    scope.navCounter++;
                }
            };
            scope.navPrev = function () {
                if (scope.navCounter > 1) {
                    carousel.trigger('prev.owl.carousel');
                    scope.navCounter--;
                }
            };
            /*
             * Function for triggering thumbnail navigation
             */
            scope.goTo = function (index) {
                scope.crtIndex = index;
                scope.navCounter = index + 1;
                carousel.trigger('to.owl.carousel', [index]);
            };
            elem.on('dragover', function (event) {
                event.preventDefault();
                event.stopPropagation();
            });
            elem.on('drop dragdrop', function (event) {
                var type = utils_1.getSuperdeskType(event);
                event.preventDefault();
                event.stopPropagation();
                if (ALLOWED_TYPES.includes(type) || type === 'Files') {
                    var mediaItemsForCurrentField = Object.keys(scope.item.associations || {})
                        .filter(function (key) { return key.startsWith(scope.field._id) && scope.item.associations[key] != null; })
                        .map(function (key) { return scope.item.associations[key]; });
                    var currentUploads = mediaItemsForCurrentField.length;
                    var item_1 = angular.fromJson(event.originalEvent.dataTransfer.getData(type));
                    var itemAlreadyAddedAsMediaGallery = mediaItemsForCurrentField.some(function (mediaItem) { return mediaItem._id === item_1._id; });
                    if (currentUploads >= scope.maxUploads) {
                        notify.error(utils_2.gettext('Media item was not added, because the field reached the limit of allowed media items.'));
                        return;
                    }
                    if (itemAlreadyAddedAsMediaGallery) {
                        notify.error('This item is already added as media gallery.');
                        return;
                    }
                    controller.initializeUploadOnDrop(scope, event);
                }
                else {
                    var allowedTypeNames = [
                        (scope.allowPicture === true ? utils_2.gettext('image') : ''),
                        (scope.allowVideo === true ? utils_2.gettext('video') : ''),
                        (scope.allowAudio === true ? utils_2.gettext('audio') : ''),
                    ].filter(Boolean).join(', ');
                    var message = utils_2.gettext('Only the following content item types are allowed: ');
                    notify.error(message + allowedTypeNames);
                }
            });
            /**
             * @ngdoc method
             * @name sdItemAssociation#upload
             * @public
             * @description Upload media.
             */
            scope.upload = function () {
                if (scope.editable) {
                    controller.uploadAndCropImages(scope);
                }
            };
            /**
             * @ngdoc method
             * @name sdItemAssociation#remove
             * @public
             * @description Remove the associations
             * @param {Object} item Item object
             */
            scope.remove = function (item) {
                controller.updateItemAssociation(scope, null, item.fieldId);
            };
            /**
             * @ngdoc method
             * @name sdItemCarouselDirective#initCarousel
             * @private
             * @description Initialize carousel on page
             */
            function initCarousel() {
                var updated = false;
                carousel = elem.find(carouselContainerSelector).owlCarousel({
                    items: 1,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                });
                // Initialize sortable function for thumbnails
                elem.find('.sd-media-carousel__thumb-strip').sortable({
                    items: '.sd-media-carousel__thumb-strip-item',
                    start: function (event, ui) {
                        ui.item.data('start_index', ui.item.parent().find('.sd-media-carousel__thumb-strip-item')
                            .index(ui.item));
                    },
                    stop: function (event, ui) {
                        if (updated) {
                            updated = false;
                            var start = ui.item.data('start_index'), end = ui.item.parent().find('.sd-media-carousel__thumb-strip-item')
                                .index(ui.item);
                            scope.carouselItems.splice(end, 0, scope.carouselItems.splice(start, 1)[0]);
                            angular.forEach(scope.carouselItems, function (item) {
                                var data = {};
                                item[item.fieldId].order = scope.carouselItems.indexOf(item);
                                data[item.fieldId] = item[item.fieldId];
                                scope.item.associations = angular.extend({}, scope.item.associations, data);
                            });
                            scope.onchange();
                        }
                    },
                    update: function (event, ui) {
                        updated = true;
                    },
                });
                if (scope.crtIndex) {
                    carousel.trigger('to.owl.carousel', [scope.crtIndex]);
                }
            }
            scope.$on('$destroy', function () {
                elem.off('drop dragdrop dragover');
            });
        },
    };
}
exports.ItemCarouselDirective = ItemCarouselDirective;


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**
 * Owl Carousel v2.2.0
 * Copyright 2013-2016 David Deutsch
 * Licensed under MIT (https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE)
 */
/**
 * Owl carousel
 * @version 2.1.6
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
;(function($, window, document, undefined) {

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Proxied event handlers.
		 * @protected
		 */
		this._handlers = {};

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from beeing retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Widths of all items.
		 */
		this._widths = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		/**
		 * Current state information for the drag operation.
		 * @todo #261
		 * @protected
		 */
		this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {
				start: null,
				current: null
			},
			direction: null
		};

		/**
		 * Current state information and their tags.
		 * @type {Object}
		 * @protected
		 */
		this._states = {
			current: {},
			tags: {
				'initializing': [ 'busy' ],
				'animating': [ 'busy' ],
				'dragging': [ 'interacting' ]
			}
		};

		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
			this._handlers[handler] = $.proxy(this[handler], this);
		}, this));

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Workers, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,
		rewind: false,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,

		fallbackEasing: 'swing',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		refreshClass: 'owl-refresh',
		loadedClass: 'owl-loaded',
		loadingClass: 'owl-loading',
		rtlClass: 'owl-rtl',
		responsiveClass: 'owl-responsive',
		dragClass: 'owl-drag',
		itemClass: 'owl-item',
		stageClass: 'owl-stage',
		stageOuterClass: 'owl-stage-outer',
		grabClass: 'owl-grab'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Enumeration for types.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Type = {
		Event: 'event',
		State: 'state'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * List of workers involved in the update process.
	 */
	Owl.Workers = [ {
		filter: [ 'width', 'settings' ],
		run: function() {
			this._width = this.$element.width();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			this.$stage.children('.cloned').remove();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var margin = this.settings.margin || '',
				grid = !this.settings.autoWidth,
				rtl = this.settings.rtl,
				css = {
					'width': 'auto',
					'margin-left': rtl ? margin : '',
					'margin-right': rtl ? '' : margin
				};

			!grid && this.$stage.children().css(css);

			cache.css = css;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
				merge = null,
				iterator = this._items.length,
				grid = !this.settings.autoWidth,
				widths = [];

			cache.items = {
				merge: false,
				width: width
			};

			while (iterator--) {
				merge = this._mergers[iterator];
				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

				cache.items.merge = merge > 1 || cache.items.merge;

				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
			}

			this._widths = widths;
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var clones = [],
				items = this._items,
				settings = this.settings,
				view = Math.max(settings.items * 2, 4),
				size = Math.ceil(items.length / 2) * 2,
				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
				append = '',
				prepend = '';

			repeat /= 2;

			while (repeat--) {
				clones.push(this.normalize(clones.length / 2, true));
				append = append + items[clones[clones.length - 1]][0].outerHTML;
				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
			}

			this._clones = clones;

			$(append).addClass('cloned').appendTo(this.$stage);
			$(prepend).addClass('cloned').prependTo(this.$stage);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				size = this._clones.length + this._items.length,
				iterator = -1,
				previous = 0,
				current = 0,
				coordinates = [];

			while (++iterator < size) {
				previous = coordinates[iterator - 1] || 0;
				current = this._widths[this.relative(iterator)] + this.settings.margin;
				coordinates.push(previous + current * rtl);
			}

			this._coordinates = coordinates;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var padding = this.settings.stagePadding,
				coordinates = this._coordinates,
				css = {
					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
					'padding-left': padding || '',
					'padding-right': padding || ''
				};

			this.$stage.css(css);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var iterator = this._coordinates.length,
				grid = !this.settings.autoWidth,
				items = this.$stage.children();

			if (grid && cache.items.merge) {
				while (iterator--) {
					cache.css.width = this._widths[this.relative(iterator)];
					items.eq(iterator).css(cache.css);
				}
			} else if (grid) {
				cache.css.width = cache.items.width;
				items.css(cache.css);
			}
		}
	}, {
		filter: [ 'items' ],
		run: function() {
			this._coordinates.length < 1 && this.$stage.removeAttr('style');
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
			this.reset(cache.current);
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.active').removeClass('active');
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

			if (this.settings.center) {
				this.$stage.children('.center').removeClass('center');
				this.$stage.children().eq(this.current()).addClass('center');
			}
		}
	} ];

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.enter('initializing');
		this.trigger('initialize');

		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

		if (this.settings.autoWidth && !this.is('pre-loading')) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
			}
		}

		this.$element.addClass(this.options.loadingClass);

		// create stage
		this.$stage = $('<' + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>')
			.wrap('<div class="' + this.settings.stageOuterClass + '"/>');

		// append stage
		this.$element.append(this.$stage.parent());

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// check visibility
		if (this.$element.is(':visible')) {
			// update view
			this.refresh();
		} else {
			// invalidate width
			this.invalidate('width');
		}

		this.$element
			.removeClass(this.options.loadingClass)
			.addClass(this.options.loadedClass);

		// register event handlers
		this.registerEventHandlers();

		this.leave('initializing');
		this.trigger('initialized');
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			if (typeof settings.stagePadding === 'function') {
				settings.stagePadding = settings.stagePadding();
			}
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class',
					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
				);
			}
		}

		this.trigger('change', { property: { name: 'settings', value: settings } });
		this._breakpoint = match;
		this.settings = settings;
		this.invalidate('settings');
		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.options.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};

		!this.is('valid') && this.enter('valid');
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		this.enter('refreshing');
		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		this.$element.addClass(this.options.refreshClass);

		this.update();

		this.$element.removeClass(this.options.refreshClass);

		this.leave('refreshing');
		this.trigger('refreshed');
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (!this.$element.is(':visible')) {
			return false;
		}

		this.enter('resizing');

		if (this.trigger('resize').isDefaultPrevented()) {
			this.leave('resizing');
			return false;
		}

		this.invalidate('width');

		this.refresh();

		this.leave('resizing');
		this.trigger('resized');
	};

	/**
	 * Registers event handlers.
	 * @todo Check `msPointerEnabled`
	 * @todo #261
	 * @protected
	 */
	Owl.prototype.registerEventHandlers = function() {
		if ($.support.transition) {
			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
		}

		if (this.settings.responsive !== false) {
			this.on(window, 'resize', this._handlers.onThrottledResize);
		}

		if (this.settings.mouseDrag) {
			this.$element.addClass(this.options.dragClass);
			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
		}

		if (this.settings.touchDrag){
			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
		}
	};

	/**
	 * Handles `touchstart` and `mousedown` events.
	 * @todo Horizontal swipe threshold as option
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var stage = null;

		if (event.which === 3) {
			return;
		}

		if ($.support.transform) {
			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
			stage = {
				x: stage[stage.length === 16 ? 12 : 4],
				y: stage[stage.length === 16 ? 13 : 5]
			};
		} else {
			stage = this.$stage.position();
			stage = {
				x: this.settings.rtl ?
					stage.left + this.$stage.width() - this.width() + this.settings.margin :
					stage.left,
				y: stage.top
			};
		}

		if (this.is('animating')) {
			$.support.transform ? this.animate(stage.x) : this.$stage.stop()
			this.invalidate('position');
		}

		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

		this.speed(0);

		this._drag.time = new Date().getTime();
		this._drag.target = $(event.target);
		this._drag.stage.start = stage;
		this._drag.stage.current = stage;
		this._drag.pointer = this.pointer(event);

		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event));

			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
				return;
			}

			event.preventDefault();

			this.enter('dragging');
			this.trigger('drag');
		}, this));
	};

	/**
	 * Handles the `touchmove` and `mousemove` events.
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var minimum = null,
			maximum = null,
			pull = null,
			delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this.difference(this._drag.stage.start, delta);

		if (!this.is('dragging')) {
			return;
		}

		event.preventDefault();

		if (this.settings.loop) {
			minimum = this.coordinates(this.minimum());
			maximum = this.coordinates(this.maximum() + 1) - minimum;
			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
		} else {
			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
		}

		this._drag.stage.current = stage;

		this.animate(stage.x);
	};

	/**
	 * Handles the `touchend` and `mouseup` events.
	 * @todo #261
	 * @todo Threshold for click event
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragEnd = function(event) {
		var delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this._drag.stage.current,
			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

		$(document).off('.owl.core');

		this.$element.removeClass(this.options.grabClass);

		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
			this.invalidate('position');
			this.update();

			this._drag.direction = direction;

			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
				this._drag.target.one('click.owl.core', function() { return false; });
			}
		}

		if (!this.is('dragging')) {
			return;
		}

		this.leave('dragging');
		this.trigger('dragged');
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate, direction) {
		var position = -1,
			pull = 30,
			width = this.width(),
			coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				// on a left pull, check on current index
				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
					position = index;
				// on a right pull, check on previous index
				// to do so, subtract width from value and set position = index + 1
				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
					position = index + 1;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] || value - width)) {
					position = direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @todo #270
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		var animate = this.speed() > 0;

		this.is('animating') && this.onTransitionEnd();

		if (animate) {
			this.enter('animating');
			this.trigger('translate');
		}

		if ($.support.transform3d && $.support.transition) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
				transition: (this.speed() / 1000) + 's'
			});
		} else if (animate) {
			this.$stage.animate({
				left: coordinate + 'px'
			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
		} else {
			this.$stage.css({
				left: coordinate + 'px'
			});
		}
	};

	/**
	 * Checks whether the carousel is in a specific state or not.
	 * @param {String} state - The state to check.
	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	 */
	Owl.prototype.is = function(state) {
		return this._states.current[state] && this._states.current[state] > 0;
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} [part] - The part to invalidate.
	 * @returns {Array.<String>} - The invalidated parts.
	 */
	Owl.prototype.invalidate = function(part) {
		if ($.type(part) === 'string') {
			this._invalidated[part] = true;
			this.is('valid') && this.leave('valid');
		}
		return $.map(this._invalidated, function(v, i) { return i });
	};

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position of an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = this._items.length,
			m = relative ? 0 : this._clones.length;

		if (!this.isNumeric(position) || n < 1) {
			position = undefined;
		} else if (position < 0 || position >= n + m) {
			position = ((position - m / 2) % n + n) % n + m / 2;
		}

		return position;
	};

	/**
	 * Converts an absolute position of an item into a relative one.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position -= this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var settings = this.settings,
			maximum = this._coordinates.length,
			iterator,
			reciprocalItemsWidth,
			elementWidth;

		if (settings.loop) {
			maximum = this._clones.length / 2 + this._items.length - 1;
		} else if (settings.autoWidth || settings.merge) {
			iterator = this._items.length;
			reciprocalItemsWidth = this._items[--iterator].width();
			elementWidth = this.$element.width();
			while (iterator--) {
				reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
				if (reciprocalItemsWidth > elementWidth) {
					break;
				}
			}
			maximum = iterator + 1;
		} else if (settings.center) {
			maximum = this._items.length - 1;
		} else {
			maximum = this._items.length - settings.items;
		}

		if (relative) {
			maximum -= this._clones.length / 2;
		}

		return Math.max(maximum, 0);
	};

	/**
	 * Gets the minimum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		return relative ? 0 : this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var multiplier = 1,
			newPosition = position - 1,
			coordinate;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			if (this.settings.rtl) {
				multiplier = -1;
				newPosition = position + 1;
			}

			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
		} else {
			coordinate = this._coordinates[newPosition] || 0;
		}

		coordinate = Math.ceil(coordinate);

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}

		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		var current = this.current(),
			revert = null,
			distance = position - this.relative(current),
			direction = (distance > 0) - (distance < 0),
			items = this._items.length,
			minimum = this.minimum(),
			maximum = this.maximum();

		if (this.settings.loop) {
			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
				distance += direction * -1 * items;
			}

			position = current + distance;
			revert = ((position - minimum) % items + items) % items + minimum;

			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
				current = revert - distance;
				position = revert;
				this.reset(current);
			}
		} else if (this.settings.rewind) {
			maximum += 1;
			position = (position % maximum + maximum) % maximum;
		} else {
			position = Math.max(minimum, Math.min(maximum, position));
		}

		this.speed(this.duration(current, position, speed));
		this.current(position);

		if (this.$element.is(':visible')) {
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onTransitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.leave('animating');
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			throw 'Can not detect viewport width.';
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		var current = this.relative(this._current);

		position = position === undefined ? this._items.length : this.normalize(position, true);
		content = content instanceof jQuery ? content : $(content);

		this.trigger('add', { content: content, position: position });

		content = this.prepare(content);

		if (this._items.length === 0 || position === this._items.length) {
			this._items.length === 0 && this.$stage.append(content);
			this._items.length !== 0 && this._items[position - 1].after(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this._items[current] && this.reset(this._items[current].index());

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Preloads images with auto width.
	 * @todo Replace by a more generic approach
	 * @protected
	 */
	Owl.prototype.preloadAutoWidthImages = function(images) {
		images.each($.proxy(function(i, element) {
			this.enter('pre-loading');
			element = $(element);
			$(new Image()).one('load', $.proxy(function(e) {
				element.attr('src', e.target.src);
				element.css('opacity', 1);
				this.leave('pre-loading');
				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
		}, this));
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		this.$element.off('.owl.core');
		this.$stage.off('.owl.core');
		$(document).off('.owl.core');

		if (this.settings.responsive !== false) {
			window.clearTimeout(this.resizeTimer);
			this.off(window, 'resize', this._handlers.onThrottledResize);
		}

		for (var i in this._plugins) {
			this._plugins[i].destroy();
		}

		this.$stage.children('.cloned').remove();

		this.$stage.unwrap();
		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();

		this.$element
			.removeClass(this.options.refreshClass)
			.removeClass(this.options.loadingClass)
			.removeClass(this.options.loadedClass)
			.removeClass(this.options.rtlClass)
			.removeClass(this.options.dragClass)
			.removeClass(this.options.grabClass)
			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
			.removeData('owl.carousel');
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers a public event.
	 * @todo Remove `status`, `relatedTarget` should be used instead.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=carousel] - The event namespace.
	 * @param {String} [state] - The state which is associated with the event.
	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.register({ type: Owl.Type.Event, name: name });
			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].call(this, event);
			}
		}

		return event;
	};

	/**
	 * Enters a state.
	 * @param name - The state name.
	 */
	Owl.prototype.enter = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			if (this._states.current[name] === undefined) {
				this._states.current[name] = 0;
			}

			this._states.current[name]++;
		}, this));
	};

	/**
	 * Leaves a state.
	 * @param name - The state name.
	 */
	Owl.prototype.leave = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			this._states.current[name]--;
		}, this));
	};

	/**
	 * Registers an event or state.
	 * @public
	 * @param {Object} object - The event or state to register.
	 */
	Owl.prototype.register = function(object) {
		if (object.type === Owl.Type.Event) {
			if (!$.event.special[object.name]) {
				$.event.special[object.name] = {};
			}

			if (!$.event.special[object.name].owl) {
				var _default = $.event.special[object.name]._default;
				$.event.special[object.name]._default = function(e) {
					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
						return _default.apply(this, arguments);
					}
					return e.namespace && e.namespace.indexOf('owl') > -1;
				};
				$.event.special[object.name].owl = true;
			}
		} else if (object.type === Owl.Type.State) {
			if (!this._states.tags[object.name]) {
				this._states.tags[object.name] = object.tags;
			} else {
				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
			}

			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
				return $.inArray(tag, this._states.tags[object.name]) === i;
			}, this));
		}
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	};

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	};

	/**
	 * Gets unified pointer coordinates from event.
	 * @todo #261
	 * @protected
	 * @param {Event} - The `mousedown` or `touchstart` event.
	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	 */
	Owl.prototype.pointer = function(event) {
		var result = { x: null, y: null };

		event = event.originalEvent || event || window.event;

		event = event.touches && event.touches.length ?
			event.touches[0] : event.changedTouches && event.changedTouches.length ?
				event.changedTouches[0] : event;

		if (event.pageX) {
			result.x = event.pageX;
			result.y = event.pageY;
		} else {
			result.x = event.clientX;
			result.y = event.clientY;
		}

		return result;
	};

	/**
	 * Determines if the input is a Number or something that can be coerced to a Number
	 * @protected
	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	 */
	Owl.prototype.isNumeric = function(number) {
		return !isNaN(parseFloat(number));
	};

	/**
	 * Gets the difference of two vectors.
	 * @todo #261
	 * @protected
	 * @param {Object} - The first vector.
	 * @param {Object} - The second vector.
	 * @returns {Object} - The difference.
	 */
	Owl.prototype.difference = function(first, second) {
		return {
			x: first.x - second.x,
			y: first.y - second.y
		};
	};

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @todo Navigation plugin `next` and `prev`
	 * @public
	 */
	$.fn.owlCarousel = function(option) {
		var args = Array.prototype.slice.call(arguments, 1);

		return this.each(function() {
			var $this = $(this),
				data = $this.data('owl.carousel');

			if (!data) {
				data = new Owl(this, typeof option == 'object' && option);
				$this.data('owl.carousel', data);

				$.each([
					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
				], function(i, event) {
					data.register({ type: Owl.Type.Event, name: event });
					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
						if (e.namespace && e.relatedTarget !== this) {
							this.suppress([ event ]);
							data[event].apply(this, [].slice.call(arguments, 1));
							this.release([ event ]);
						}
					}, data));
				});
			}

			if (typeof option == 'string' && option.charAt(0) !== '_') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoRefresh Plugin
 * @version 2.1.0
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto refresh plugin.
	 * @class The Auto Refresh Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoRefresh = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Refresh interval.
		 * @protected
		 * @type {number}
		 */
		this._interval = null;

		/**
		 * Whether the element is currently visible or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._visible = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoRefresh) {
					this.watch();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoRefresh.Defaults = {
		autoRefresh: true,
		autoRefreshInterval: 500
	};

	/**
	 * Watches the element.
	 */
	AutoRefresh.prototype.watch = function() {
		if (this._interval) {
			return;
		}

		this._visible = this._core.$element.is(':visible');
		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	};

	/**
	 * Refreshes the element.
	 */
	AutoRefresh.prototype.refresh = function() {
		if (this._core.$element.is(':visible') === this._visible) {
			return;
		}

		this._visible = !this._visible;

		this._core.$element.toggleClass('owl-hidden', !this._visible);

		this._visible && (this._core.invalidate('width') && this._core.refresh());
	};

	/**
	 * Destroys the plugin.
	 */
	AutoRefresh.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this._interval);

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position)), load);
						position++;
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false
	};

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
				url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url(' + url + ')',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name == 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Video Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * All event handlers.
		 * @todo The cloned content removale is too late
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
				}
			}, this),
			'resize.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.is('resizing')) {
					this._core.$stage.find('.cloned .owl-video-frame').remove();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position' && this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				var $element = $(e.content).find('.owl-video');

				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {
			var type = (function() {
					if (target.attr('data-vimeo-id')) {
						return 'vimeo';
					} else if (target.attr('data-vzaar-id')) {
						return 'vzaar'
					} else {
						return 'youtube';
					}
				})(),
				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
				width = target.attr('data-width') || this._core.settings.videoWidth,
				height = target.attr('data-height') || this._core.settings.videoHeight,
				url = target.attr('href');

		if (url) {

			/*
					Parses the id's out of the following urls (and probably more):
					https://www.youtube.com/watch?v=:id
					https://youtu.be/:id
					https://vimeo.com/:id
					https://vimeo.com/channels/:channel/:id
					https://vimeo.com/groups/:group/videos/:id
					https://app.vzaar.com/videos/:id

					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
			*/

			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else if (id[3].indexOf('vzaar') > -1) {
				type = 'vzaar';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {
		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'style="width:' + video.width + 'px;height:' + video.height + 'px;"' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = '<div class="owl-video-tn ' + lazyClass + '" ' + srcType + '="' + path + '"></div>';
				} else {
					tnLink = '<div class="owl-video-tn" style="opacity:1;background-image:url(' + path + ')"></div>';
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap('<div class="owl-video-wrapper"' + dimensions + '></div>');

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		} else if (video.type === 'vzaar') {
			$.ajax({
				type: 'GET',
				url: '//vzaar.com/api/videos/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data.framegrab_url;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
		this._core.leave('playing');
		this._core.trigger('stopped', null, 'video');
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} event - The event arguments.
	 */
	Video.prototype.play = function(event) {
		var target = $(event.target),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html;

		if (this._playing) {
			return;
		}

		this._core.enter('playing');
		this._core.trigger('play', null, 'video');

		item = this._core.items(this._core.relative(item.index()));

		this._core.reset(item.index());

		if (video.type === 'youtube') {
			html = '<iframe width="' + width + '" height="' + height + '" src="//www.youtube.com/embed/' +
				video.id + '?autoplay=1&v=' + video.id + '" frameborder="0" allowfullscreen></iframe>';
		} else if (video.type === 'vimeo') {
			html = '<iframe src="//player.vimeo.com/video/' + video.id +
				'?autoplay=1" width="' + width + '" height="' + height +
				'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
		} else if (video.type === 'vzaar') {
			html = '<iframe frameborder="0"' + 'height="' + height + '"' + 'width="' + width +
				'" allowfullscreen mozallowfullscreen webkitAllowFullScreen ' +
				'src="//view.vzaar.com/' + video.id + '/player?autoplay=true"></iframe>';
		}

		$('<div class="owl-video-frame">' + html + '</div>').insertAfter(item.find('.owl-video'));

		this._playing = item.addClass('owl-video-playing');
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {
		var element = document.fullscreenElement || document.mozFullScreenElement ||
				document.webkitFullscreenElement;

		return element && $(element).parent().hasClass('owl-video-frame');
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this.swapping = e.type == 'translated';
				}
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1) {
			return;
		}

		if (!$.support.animation || !$.support.transition) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.one($.support.animation.end, clear)
				.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing);
		}

		if (incoming) {
			next.one($.support.animation.end, clear)
				.addClass('animated owl-animated-in')
				.addClass(incoming);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.onTransitionEnd();
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.1.0
 * @author Bartosz Wojciechowski
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * The autoplay timeout.
		 * @type {Timeout}
		 */
		this._timeout = null;

		/**
		 * Indicates whenever the autoplay is paused.
		 * @type {Boolean}
		 */
		this._paused = false;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'settings') {
					if (this._core.settings.autoplay) {
						this.play();
					} else {
						this.stop();
					}
				} else if (e.namespace && e.property.name === 'position') {
					//console.log('play?', e);
					if (this._core.settings.autoplay) {
						this._setAutoPlayInterval();
					}
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoplay) {
					this.play();
				}
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				if (e.namespace) {
					this.play(t, s);
				}
			}, this),
			'stop.owl.autoplay': $.proxy(function(e) {
				if (e.namespace) {
					this.stop();
				}
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.play();
				}
			}, this),
			'touchstart.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'touchend.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause) {
					this.play();
				}
			}, this)
		};

		// register event handlers
		this._core.$element.on(this._handlers);

		// set default options
		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		this._paused = false;

		if (this._core.is('rotating')) {
			return;
		}

		this._core.enter('rotating');

		this._setAutoPlayInterval();
	};

	/**
	 * Gets a new timeout
	 * @private
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 * @return {Timeout}
	 */
	Autoplay.prototype._getNextTimeout = function(timeout, speed) {
		if ( this._timeout ) {
			window.clearTimeout(this._timeout);
		}
		return window.setTimeout($.proxy(function() {
			if (this._paused || this._core.is('busy') || this._core.is('interacting') || document.hidden) {
				return;
			}
			this._core.next(speed || this._core.settings.autoplaySpeed);
		}, this), timeout || this._core.settings.autoplayTimeout);
	};

	/**
	 * Sets autoplay in motion.
	 * @private
	 */
	Autoplay.prototype._setAutoPlayInterval = function() {
		this._timeout = this._getNextTimeout();
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		if (!this._core.is('rotating')) {
			return;
		}

		window.clearTimeout(this._timeout);
		this._core.leave('rotating');
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		if (!this._core.is('rotating')) {
			return;
		}

		this._paused = true;
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		this.stop();

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.1.0
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
				}
			}, this),
			'added.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, this._templates.pop());
				}
			}, this),
			'remove.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && !this._initialized) {
					this._core.trigger('initialize', null, 'navigation');
					this.initialize();
					this.update();
					this.draw();
					this._initialized = true;
					this._core.trigger('initialized', null, 'navigation');
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._initialized) {
					this._core.trigger('refresh', null, 'navigation');
					this.update();
					this.draw();
					this._core.trigger('refreshed', null, 'navigation');
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navText: [ 'prev', 'next' ],
		navSpeed: false,
		navElement: 'div',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [ 'owl-prev', 'owl-next' ],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotsData: false,
		dotsSpeed: false,
		dotsContainer: false
	};

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var override,
			settings = this._core.settings;

		// create DOM structure for relative navigation
		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$previous = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[0])
			.html(settings.navText[0])
			.prependTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.prev(settings.navSpeed);
			}, this));
		this._controls.$next = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[1])
			.html(settings.navText[1])
			.appendTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.next(settings.navSpeed);
			}, this));

		// create DOM structure for absolute navigation
		if (!settings.dotsData) {
			this._templates = [ $('<div>')
				.addClass(settings.dotClass)
				.append($('<span>'))
				.prop('outerHTML') ];
		}

		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$absolute.on('click', 'div', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$absolute)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, settings.dotsSpeed);
		}, this));

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	};

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			this._controls[control].remove();
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			maximum = this._core.maximum(true),
			settings = this._core.settings,
			size = settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items;

		if (settings.slideBy !== 'page') {
			settings.slideBy = Math.min(settings.slideBy, settings.items);
		}

		if (settings.dots || settings.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: Math.min(maximum, i - lower),
						end: i - lower + size - 1
					});
					if (Math.min(maximum, i - lower) === maximum) {
						break;
					}
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	};

	/**
	 * Draws the user interface.
	 * @todo The option `dotsData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference,
			settings = this._core.settings,
			disabled = this._core.items().length <= settings.items,
			index = this._core.relative(this._core.current()),
			loop = settings.loop || settings.rewind;

		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

		if (settings.nav) {
			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
		}

		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

		if (settings.dots) {
			difference = this._pages.length - this._controls.$absolute.children().length;

			if (settings.dotsData && difference !== 0) {
				this._controls.$absolute.html(this._templates.join(''));
			} else if (difference > 0) {
				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
			} else if (difference < 0) {
				this._controls.$absolute.children().slice(difference).remove();
			}

			this._controls.$absolute.find('.active').removeClass('active');
			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}
	};

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items)
		};
	};

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var current = this._core.relative(this._core.current());
		return $.grep(this._pages, $.proxy(function(page, index) {
			return page.start <= current && page.end >= current;
		}, this)).pop();
	};

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			settings = this._core.settings;

		if (settings.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += settings.slideBy : position -= settings.slideBy;
		}

		return position;
	};

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	};

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	};

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard && this._pages.length) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.1.0
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash index for the items.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

					if (!hash) {
						return;
					}

					this._hashes[hash] = e.content;
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position') {
					var current = this._core.items(this._core.relative(this._core.current())),
						hash = $.map(this._hashes, function(item, hash) {
							return item === current ? hash : null;
						}).join();

					if (!hash || window.location.hash.slice(1) === hash) {
						return;
					}

					window.location.hash = hash;
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]);

			if (position === undefined || position === this._core.current()) {
				return;
			}

			this._core.to(this._core.relative(position), false, true);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Support Plugin
 *
 * @version 2.1.0
 * @author Vivid Planet Software GmbH
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	var style = $('<support>').get(0).style,
		prefixes = 'Webkit Moz O ms'.split(' '),
		events = {
			transition: {
				end: {
					WebkitTransition: 'webkitTransitionEnd',
					MozTransition: 'transitionend',
					OTransition: 'oTransitionEnd',
					transition: 'transitionend'
				}
			},
			animation: {
				end: {
					WebkitAnimation: 'webkitAnimationEnd',
					MozAnimation: 'animationend',
					OAnimation: 'oAnimationEnd',
					animation: 'animationend'
				}
			}
		},
		tests = {
			csstransforms: function() {
				return !!test('transform');
			},
			csstransforms3d: function() {
				return !!test('perspective');
			},
			csstransitions: function() {
				return !!test('transition');
			},
			cssanimations: function() {
				return !!test('animation');
			}
		};

	function test(property, prefixed) {
		var result = false,
			upper = property.charAt(0).toUpperCase() + property.slice(1);

		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
			if (style[property] !== undefined) {
				result = prefixed ? property : true;
				return false;
			}
		});

		return result;
	}

	function prefixed(property) {
		return test(property, true);
	}

	if (tests.csstransitions()) {
		/* jshint -W053 */
		$.support.transition = new String(prefixed('transition'))
		$.support.transition.end = events.transition.end[ $.support.transition ];
	}

	if (tests.cssanimations()) {
		/* jshint -W053 */
		$.support.animation = new String(prefixed('animation'))
		$.support.animation.end = events.animation.end[ $.support.animation ];
	}

	if (tests.csstransforms()) {
		/* jshint -W053 */
		$.support.transform = new String(prefixed('transform'));
		$.support.transform3d = tests.csstransforms3d();
	}

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(14)))

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param {Array<Node>} elements
 * @param {string} eventName
 */
var waitForEventToFireForAllElements = function (elements, eventName) { return new Promise(function (resolve) {
    var itemsLeftToLoad = elements.length;
    if (itemsLeftToLoad === 0) {
        resolve();
        return;
    }
    var onItemLoaded = function (event) {
        itemsLeftToLoad--;
        event.target.removeEventListener(eventName, onItemLoaded);
        if (itemsLeftToLoad === 0) {
            resolve();
        }
    };
    elements.forEach(function (element) {
        element.addEventListener(eventName, onItemLoaded);
    });
}); };
/**
 * @param {Array<Node>} elements
 */
exports.waitForImagesToLoad = function (elements) { return waitForEventToFireForAllElements(elements.filter(function (img) { return img.complete === false; }), 'load'); };
/**
 * @param {Array<Node>} elements
 */
exports.waitForAudioAndVideoToLoadMetadata = function (elements) { return waitForEventToFireForAllElements(elements.filter(function (media) { return media.readyState < 1; }), 'loadedmetadata'); };


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
FullPreviewDirective.$inject = ['api', '$timeout', 'config', 'content', '$sce'];
function FullPreviewDirective(api, $timeout, config, content, $sce) {
    return {
        scope: {
            item: '=',
            closeAction: '=',
        },
        templateUrl: 'scripts/apps/authoring/views/full-preview.html',
        link: function (scope, elem, attr, ctrl) {
            scope.hide_images = false;
            scope.filterKey = config.previewSubjectFilterKey || '';
            if (scope.item.profile) {
                content.getType(scope.item.profile)
                    .then(function (type) {
                    scope.editor = content.editor(type);
                    scope.fields = content.fields(type);
                });
            }
            else {
                scope.editor = content.editor();
            }
            scope.getHtml = function (html) {
                return $sce.trustAsHtml(html);
            };
            scope.isCustomList = function (field) {
                return ['text', 'date', 'media', 'embed'].indexOf(field.field_type) === -1;
            };
            scope.printPreview = function () {
                angular.element('body').addClass('prepare-print');
                var afterPrint = function () {
                    angular.element('body').removeClass('prepare-print');
                };
                if (window.matchMedia) {
                    var mediaQueryList = window.matchMedia('print');
                    mediaQueryList.addListener(function (mql) {
                        if (!mql.matches) {
                            afterPrint();
                        }
                    });
                }
                window.onafterprint = afterPrint;
                $timeout(function () {
                    window.print();
                }, 200, false);
                return false;
            };
            /**
             * @ngdoc method
             * @name mediaExists
             * @private
             * @description Check if there is any association for fieldId
             */
            scope.mediaExists = function (associations, fieldId) {
                return lodash_1.default.size(scope.getMediaItems(associations, fieldId));
            };
            /**
             * @ngdoc method
             * @name getMediaItems
             * @private
             * @description Return all associations for fieldId
             */
            scope.getMediaItems = function (associations, fieldId) {
                var result = lodash_1.default.filter(associations, function (association, key) { return key.indexOf(fieldId) !== -1; });
                return result;
            };
            scope.getLocaleName = function (term) {
                if (!term) {
                    return 'None';
                }
                if (term.translations && scope.item.language
                    && term.translations.name[scope.item.language]) {
                    return term.translations.name[scope.item.language];
                }
                return term.name;
            };
        },
    };
}
exports.FullPreviewDirective = FullPreviewDirective;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers = __importStar(__webpack_require__(72));
RemoveTagsDirective.$inject = [];
function RemoveTagsDirective() {
    return {
        require: 'ngModel',
        scope: {
            model: '=ngModel',
        },
        link: function (scope, elem, attr, ngModel) {
            scope.$watch('model', function () {
                if (scope.model) {
                    scope.model = helpers.stripHtmlRaw(scope.model);
                }
            });
        },
    };
}
exports.RemoveTagsDirective = RemoveTagsDirective;


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/*
 * TansaScopeSync synchornises any changes caused by tansa to the DOM with the ng-model of the host
 */
TansaScopeSyncDirective.$inject = ['$rootScope'];
function TansaScopeSyncDirective($rootScope) {
    return {
        require: ['ngModel'],
        link: function (scope, elem, attrs, controllers) {
            var ngModel = controllers[0];
            var deregisterTansa = $rootScope.$on('tansa:after', function () {
                var nodeValue = getValue(elem[0]);
                if (nodeValue !== ngModel.$viewValue) {
                    ngModel.$setViewValue(nodeValue);
                }
            });
            function getValue(node) {
                if ($(node).is('input') || $(node).is('textarea')) {
                    return node.value;
                }
                var txt = $(node).find('.text-editor');
                var tag = lodash_1.default.find(txt, function (_elem) { return $(_elem).is(':visible'); });
                if (tag) {
                    return tag.innerHTML;
                }
                return node.innerHTML;
            }
            scope.$on('$destroy', deregisterTansa);
        },
    };
}
exports.TansaScopeSyncDirective = TansaScopeSyncDirective;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdItemActionByIntent
 *
 * @requires superdesk
 * @requires activityService
 * @requires worflowService
 *
 * @description renders actions for item based on the intent.
 */
ItemActionsByIntentDirective.$inject = [
    'superdesk',
    'activityService',
    'workflowService',
];
function ItemActionsByIntentDirective(superdesk, activityService, workflowService) {
    return {
        templateUrl: 'scripts/apps/authoring/views/item-actions-by-intent.html',
        link: function ($scope, elem, attrs) {
            function getMenuGroups() {
                var intent = {};
                if (lodash_1.default.get(attrs, 'sdIntentType')) {
                    intent.type = lodash_1.default.get(attrs, 'sdIntentType');
                }
                if (lodash_1.default.get(attrs, 'sdIntentAction')) {
                    intent.action = lodash_1.default.get(attrs, 'sdIntentAction');
                }
                if (lodash_1.default.isEmpty(intent)) {
                    return [];
                }
                var groups = {};
                // find the activity based on the intent
                superdesk.findActivities(intent, $scope.item).forEach(function (activity) {
                    if (workflowService.isActionAllowed($scope.item, activity.action)) {
                        var group = activity.group || 'default';
                        groups[group] = groups[group] || [];
                        groups[group].push(activity);
                    }
                });
                $scope.menuGroups = lodash_1.default.keys(groups).map(function (key) { return ({ _id: key, actions: groups[key] }); });
            }
            getMenuGroups();
            $scope.run = function (activity) {
                return activityService.start(activity, { data: { item: $scope.item } });
            };
            $scope.$watch('item', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    getMenuGroups();
                }
            }, true);
        },
    };
}
exports.ItemActionsByIntentDirective = ItemActionsByIntentDirective;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function EmbeddedFilter() {
    return function (input) {
        var output = {};
        for (var i in input) {
            if (input.hasOwnProperty(i)) {
                if (!/^embedded/.test(i)) {
                    output[i] = input[i];
                }
            }
        }
        return output;
    };
}
exports.EmbeddedFilter = EmbeddedFilter;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1627);
var SuggestService_1 = __importDefault(__webpack_require__(1629));
var SuggestDirective_1 = __importDefault(__webpack_require__(1630));
exports.default = angular.module('superdesk.apps.authoring.suggest', [])
    .service('suggest', SuggestService_1.default)
    .directive('sdSuggest', SuggestDirective_1.default);


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1628);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./styles.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\nsd-suggest {\n  box-sizing: border-box;\n  max-width: 550px;\n  width: 100%;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  z-index: 100;\n  background: #fff;\n  position: absolute;\n  top: 0px;\n  left: -550px;\n  height: 100%;\n  padding: 48px 0 0;\n  overflow-x: scroll;\n  box-shadow: -2px -7px 5px 0 rgba(0, 0, 0, 0.25); }\n  sd-suggest h6.no-suggestions {\n    padding: 15px 18px; }\n  sd-suggest label {\n    display: inline-block; }\n  sd-suggest .live-suggest__header {\n    top: 0;\n    background: #fff; }\n    sd-suggest .live-suggest__header h3 {\n      color: #909090; }\n    sd-suggest .live-suggest__header .close i:before {\n      cursor: pointer;\n      font-weight: bold;\n      color: #000;\n      position: relative;\n      top: 13px;\n      right: 18px; }\n  sd-suggest .live-suggest__body .list-view {\n    height: 65%;\n    padding: 0;\n    overflow-x: scroll;\n    box-shadow: none; }\n    sd-suggest .live-suggest__body .list-view .list-item-view.active .media-box {\n      background-color: transparent !important;\n      border-right: none !important; }\n      sd-suggest .live-suggest__body .list-view .list-item-view.active .media-box:hover {\n        background-color: #f4f4f4 !important; }\n    sd-suggest .live-suggest__body .list-view .media-box {\n      padding: 0 18px 10px; }\n      sd-suggest .live-suggest__body .list-view .media-box .item-info {\n        padding: 10px 0 5px; }\n  sd-suggest .item-info {\n    padding: 10px 0 5px; }\n    sd-suggest .item-info label {\n      color: #909090; }\n    sd-suggest .item-info__right {\n      float: right; }\n    sd-suggest .item-info:hover {\n      padding: 10px 0 5px; }\n  sd-suggest i[sd-filetype-icon] {\n    color: #999;\n    width: 17px;\n    position: relative;\n    top: 3px; }\n  sd-suggest .keyword {\n    color: #216278;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 12px;\n    margin-right: 10px; }\n  sd-suggest .word-count span {\n    color: #909090;\n    font-size: 12px;\n    font-weight: bold; }\n  sd-suggest .item-details i.backlink {\n    cursor: pointer;\n    line-height: 28px;\n    font-size: 0.7em;\n    font-style: normal;\n    padding-left: 35px;\n    margin-top: 0px; }\n  sd-suggest .item-details .headline {\n    margin: 13px 0 0; }\n  sd-suggest .item-details .abstract {\n    margin: 10px 0; }\n  sd-suggest .item-details__body {\n    padding: 0 18px; }\n", ""]);

// exports


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc service
 * @module superdesk.apps.authoring
 * @name suggest
 * @requires api
 * @requires autosave
 * @description SuggestService handles the retrieval and synchronisation of live
 * suggest data. Users may use this service to trigger refreshes within the live
 * suggestions panel, as well as set it as active or inactive.
 */
var SuggestService = /** @class */ (function () {
    function SuggestService(api, autosave) {
        this.autosave = autosave;
        this.api = api;
        /**
         * @ngdoc property
         * @name suggest#active
         * @type {Boolean}
         * @private
         * @description Active reflects whether the service and panel are active
         * (visible) if true. Should not be set directly, instead, use
         * suggest#setActive method.
         * @see suggest#setActive
         */
        this.active = false;
        /**
         * @ngdoc property
         * @name suggest#_listener
         * @type {Function}
         * @private
         * @description Holds the function that will be called when new suggestions
         * have been received.
         */
        this._listener = function (data) { };
    }
    /**
      * @ngdoc method
      * @name suggest#_get
      * @param {(Array|Object)} item Array of items or item.
      * @returns {Promise} If resolved, suggestions were obtained successfully,
      * and all listeners were triggered.
      * @private
      * @description Requests a list of suggestions from the server and triggers
      * all listeners on success.
      */
    SuggestService.prototype._get = function (item) {
        var isArray = Array.isArray(item) && item.length > 0;
        var isObject = angular.isObject(item) && item.hasOwnProperty('_id');
        if (!isArray && !isObject) {
            return;
        }
        var id = isArray ? item[0]._id : item._id;
        return this.api
            .get("suggestions/" + id)
            .then(this._triggerListeners.bind(this));
    };
    /**
     * @ngdoc method
     * @name suggest#_triggerListeners
     * @param {Array} list List of items received from server.
     * @private
     * @description Triggers registered listeners.
     */
    SuggestService.prototype._triggerListeners = function (list) {
        this._listener(list);
    };
    /**
     * @ngdoc method
     * @name suggest#onUpdate
     * @param {Function} func The function to trigger on update.
     * @description Registers the function to be called when new suggestions are
     * received. The current implementation will only use one function. On subsequent
     * calls, it will be overwritten.
     */
    SuggestService.prototype.onUpdate = function (func) {
        this._listener = func;
    };
    /**
     * @ngdoc method
     * @name suggest#setActive
     * @param {Boolean} active When set to true, the service is set to active.
     * @description setActive sets the active state of the service.
     */
    SuggestService.prototype.setActive = function (active) {
        if (active === void 0) { active = true; }
        this.active = !!active; // force bool
    };
    /**
     * @ngdoc method
     * @name suggest#trigger
     * @param {Object} item The item to trigger live suggestions for.
     * @param {Object} orig The original, unmodified item.
     * @description Triggers the auto-suggest functionality. It will cause an autosave,
     * followed by a request for suggestions.
     */
    SuggestService.prototype.trigger = function (item, orig) {
        if (!angular.isObject(item) || !this.active) {
            return;
        }
        this.autosave.save(item, orig, 0).then(this._get.bind(this));
    };
    return SuggestService;
}());
exports.default = SuggestService;
SuggestService.$inject = ['api', 'autosave'];


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SuggestController_1 = __importDefault(__webpack_require__(1631));
var LinkFunction = /** @class */ (function () {
    function LinkFunction(suggest, scope, elem) {
        this.suggest = suggest;
        this.scope = scope;
        this.elem = elem;
        this.init();
    }
    /**
     * @ngdoc method
     * @name sdSuggest#init
     * @private
     * @description Initializes the directive with default values for the scope
     * and with necessary watchers.
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        this.scope.showItem = null;
        this.scope.$watch('ngShow', this.toggleActive.bind(this));
        this.scope.$watch(function () { return _this.suggest.active; }, this.toggleVisible.bind(this));
        this.suggest.onUpdate(this.onUpdate.bind(this));
    };
    /**
     * @ngdoc method
     * @name sdSuggest#onUpdate
     * @param {Object} resp The list of items received after the update.
     * @private
     * @description onUpdate is the callback that will be triggered whenever the
     * suggest service updates with new items.
     */
    LinkFunction.prototype.onUpdate = function (resp) {
        this.scope.items = resp._items;
        this.scope.$apply();
    };
    /**
     * @ngdoc method
     * @name sdSuggest#toggleActive
     * @param {Boolean} v The new value for the active state.
     * @private
     * @description Toggles the active state of the service.
     */
    LinkFunction.prototype.toggleActive = function (v) {
        this.suggest.setActive(v);
    };
    /**
     * @ngdoc method
     * @name sdSuggest#toggleVisible
     * @param {Boolean} v The new value for the visible state.
     * @private
     * @description Toggles the visible state of the panel.
     */
    LinkFunction.prototype.toggleVisible = function (v) {
        this.scope.ngShow = v;
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdSuggest
 * @requires suggest
 * @param {Boolean} ngShow ngShow determines the visibility of the directive.
 * @description sd-suggest operates the live suggestions panel that appears
 * to the left of the authoring component.
 */
function SuggestDirective(suggest) {
    return {
        scope: { ngShow: '=' },
        template: __webpack_require__(1632),
        controller: SuggestController_1.default,
        controllerAs: 'ctrl',
        link: function (scope, elem) { return new LinkFunction(suggest, scope, elem); },
    };
}
exports.default = SuggestDirective;
SuggestDirective.$inject = ['suggest'];


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring
 * @name SuggestController
 * @requires desks
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @description SuggestController holds a set of convenience functions used by
 * sdSuggest.
 * @see sdSuggest
 */
var SuggestController = /** @class */ (function () {
    function SuggestController(desks, scope) {
        this.desks = desks;
        this.scope = scope;
    }
    /**
     * @ngdoc method
     * @name SuggestController#displayName
     * @param {String} userId The ID of the user to look up.
     * @returns {String} The resolved user.
     * @description Gets the display name for the given user ID, otherwise returns
     * the string "-".
     */
    SuggestController.prototype.displayName = function (userId) {
        var usr = this.desks.userLookup[userId];
        return usr ? usr.display_name || '-' : '-';
    };
    /**
     * @ngdoc method
     * @name SuggestController#close
     * @description Closes the panel and resets it.
     */
    SuggestController.prototype.close = function () {
        this.scope.showItem = null;
        this.scope.ngShow = false;
    };
    /**
     * @ngdoc method
     * @name SuggestController#showItem
     * @param {Object} item The item to show.
     * @description Shows the passed item in the live suggestions panel.
     */
    SuggestController.prototype.showItem = function (item) {
        this.scope.showItem = item;
    };
    /**
     * @ngdoc method
     * @name SuggestController#hideItem
     * @description Resets the panel to the list view. This is used when a user
     * wants to go back from the item view to the list view.
     */
    SuggestController.prototype.hideItem = function () {
        this.scope.showItem = null;
    };
    return SuggestController;
}());
exports.default = SuggestController;
SuggestController.$inject = ['desks', '$scope'];


/***/ }),
/* 1632 */
/***/ (function(module, exports) {

module.exports = "<div class=\"live-suggest\">\n\t<div ng-show=\"showItem === null\" class=\"item-list\">\n\t\t<div class=\"live-suggest__header subnav\">\n\t\t\t<h3 class=\"subnav__page-title\">Live Suggestions</h3>\n\t\t\t<a class=\"close\" ng-click=\"ctrl.close()\"><i class=\"icon-close-small\"></i></a>\n\t\t</div>\n\t\t<div class=\"live-suggest__body\">\n\t\t\t<h6 class=\"no-suggestions\" ng-hide=\"items\">Suggestions will appear here once the article's body starts changing...</h6>\n\t\t\t<ul sd-list-view class=\"list-view compact-view\" data-items=\"items\" ng-show=\"items\">\n\t\t\t\t<li class=\"media-box\" ng-click=\"ctrl.showItem(item)\">\n\t\t\t\t\t<div class=\"line item-info\">\n\t\t\t\t\t\t<i sd-filetype-icon data-item=\"item\"></i>\n\t\t\t\t\t\t<span class=\"keyword\">{{ item.slugline || '-' }}</span>\n\t\t\t\t\t\t<span class=\"word-count\">\n\t\t\t\t\t\t\t<b>{{ item.word_count || 0 }}</b>\n\t\t\t\t\t\t\t<span translate translate-n=\"item.word_count\" translate-plural=\"WORDS\">\n\t\t\t\t\t\t\t\tWORD\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<div class=\"item-info__right\">\n\t\t\t\t\t\t\t<label translate>Created</label>&nbsp;\n\t\t\t\t\t\t\t<span class=\"date\" sd-datetime data=\"item.firstcreated\"></span>&nbsp;\n\t\t\t\t\t\t\t<label translate>by</label>\n\t\t\t\t\t\t\t&nbsp;{{ctrl.displayName(item.original_creator)}}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"info\">\n\t\t\t\t\t\t<b>{{ item.headline }}</b>\n\t\t\t\t\t\t<span ng-show=\"item.duedate\">\n\t\t\t\t\t\t\t<i class=\"icon-time\"></i>{{item.duedate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"item.tasks\">\n\t\t\t\t\t\t\t<i class=\"icon-tasks\"></i>{{item.tasks}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"item.attachments\">\n\t\t\t\t\t\t\t<i class=\"icon-attachment\"></i>{{item.attachments}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"item.links\">\n\t\t\t\t\t\t\t<i class=\"icon-link\"></i>{{item.links}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<span ng-show=\"item.comments\">\n\t\t\t\t\t\t\t<i class=\"icon-comment\"></i>{{item.comments}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t<div sd-html-preview=\"item.body_html\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\n\t<div ng-show=\"showItem !== null\" class=\"item-details\">\n\t\t<div class=\"live-suggest__header subnav\">\n\t\t\t<h3 class=\"subnav__page-title\" ng-click=\"ctrl.hideItem()\">\n\t\t\t\t<i class=\"backlink black\">Back</i>\n\t\t\t</h3>\n\t\t\t<a class=\"close\" ng-click=\"ngShow = false\"><i class=\"icon-close-small\"></i></a>\n\t\t</div>\n\t\t<div class=\"item-details__body\">\n\t\t\t<div class=\"line item-info\">\n\t\t\t\t<i sd-filetype-icon data-item=\"showItem\"></i>\n\t\t\t\t<span class=\"keyword\">{{ showItem.slugline || '-' }}</span>\n\t\t\t\t<span class=\"word-count\">\n\t\t\t\t\t<b>{{ showItem.word_count || 0 }}</b>\n\t\t\t\t\t<span translate translate-n=\"showItem.word_count\" translate-plural=\"WORDS\">\n\t\t\t\t\t\tWORD\n\t\t\t\t\t</span>\n\t\t\t\t</span>\n\t\t\t\t<div class=\"item-info__right\">\n\t\t\t\t\t<label translate>Created</label>\n\t\t\t\t\t<span class=\"date\" sd-datetime data=\"showItem.firstcreated\"></span>\n\t\t\t\t\t<label translate>by</label>\n\t\t\t\t\t{{ctrl.displayName(showItem.original_creator)}}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<h3 class=\"headline\">{{ showItem.headline }}</h3>\n\t\t\t<div class=\"abstract\" sd-html-preview=\"showItem.abstract\"></div>\n\t\t\t<div class=\"body\" sd-html-preview=\"showItem.body_html\"></div>\n\t\t</div>\n\t</div>\n</div>\n";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MediaMetadataEditorDirective_1 = __importDefault(__webpack_require__(1634));
var MediaMetadataViewDirective_1 = __importDefault(__webpack_require__(1636));
var MediaCopyMetadataDirective_1 = __importDefault(__webpack_require__(1638));
exports.default = angular.module('superdesk.apps.authoring.media', [])
    .directive('sdMediaMetadataEditor', MediaMetadataEditorDirective_1.default)
    .directive('sdMediaMetadataView', MediaMetadataViewDirective_1.default)
    .directive('sdMediaCopyMetadata', MediaCopyMetadataDirective_1.default);


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var getLabelForFieldId_1 = __webpack_require__(62);
MediaMetadataEditorDirective.$inject = ['metadata', 'deployConfig', 'features', '$q'];
function MediaMetadataEditorDirective(metadata, deployConfig, features, $q) {
    function getCV(field) {
        var cv = metadata.cvs.find(function (_cv) { return !_cv.field_type && (_cv._id === field || _cv.schema_field === field); });
        if (cv == null && field === 'subject') {
            return { items: metadata.values.subjectcodes }; // fallback for built in subjectcodes
        }
        return cv;
    }
    return {
        scope: {
            item: '=',
            validator: '=',
            placeholder: '=',
            disabled: '=',
            onChange: '&',
            onBlur: '&',
            dark: '@',
            boxed: '@',
            associated: '=',
        },
        template: __webpack_require__(1635),
        link: function (scope) {
            scope.features = features;
            scope.metadata = metadata;
            $q.all({
                getLabelForFieldId: getLabelForFieldId_1.getLabelNameResolver(),
                metdataInit: metadata.initialize(),
            }).then(function (_a) {
                var getLabelForFieldId = _a.getLabelForFieldId;
                var editor = lodash_1.get(deployConfig.getSync('editor'), 'picture', {});
                var schema = lodash_1.get(deployConfig.getSync('schema'), 'picture', {});
                // get last order
                var nextOrder = lodash_1.max(Object.keys(editor).map(function (field) { return lodash_1.get(editor, field + ".order", 0); })) + 1;
                // add missing fields from validator to editor/schema
                Object.keys(scope.validator || {}).forEach(function (field) {
                    if (!editor[field]) {
                        editor[field] = {
                            type: scope.validator[field].type || null,
                            order: scope.validator[field].order || nextOrder++,
                        };
                        schema[field] = scope.validator[field];
                    }
                });
                // set scope fields in order.
                // Only display fields required on the media editor based on the value of `displayOnMediaEditor`.
                // default is set to true to display all fields.
                scope.fields = lodash_1.sortBy(Object.keys(editor)
                    .filter(function (key) { return editor[key] != null; })
                    .filter(function (key) { return lodash_1.get(editor[key], 'displayOnMediaEditor', true); })
                    .map(function (field) { return Object.assign({
                    field: field,
                    label: getLabelForFieldId(field),
                    cv: getCV(field),
                }, editor[field], schema[field]); }), 'order');
                scope.$applyAsync();
            });
            /**
             * Test if field should be disabled for editing
             *
             * @param {Object} field
             * @return {Boolean}
             */
            scope.isDisabled = function (field) { return scope.disabled || (scope.associated && field.external); };
        },
    };
}
exports.default = MediaMetadataEditorDirective;


/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form__row\" ng-repeat=\"field in fields track by field.field\">\n    <sd-line-input\n        class=\"sd-line-input--no-margin\"\n        ng-if=\"field.type === 'string' || (!field.type && !field.cv)\"\n        ng-model=\"item[field.field]\"\n        data-sync=\"true\"\n        data-dark=\"dark\"\n        data-boxed=\"boxed\"\n        data-label=\"{{ field.label }}\"\n        data-required=\"field.required\"\n        data-disabled=\"isDisabled(field)\"\n        data-onchange=\"onChange({key: field.field})\"\n        data-onblur=\"onBlur()\"\n        data-maxlength=\"field.maxlength\"\n        data-placeholder=\"{{ placeholder[field.field] }}\"\n        data-textarea=\"field.textarea\"\n    />\n\n    <sd-line-input\n        class=\"sd-line-input--no-margin\"\n        ng-if=\"field.type === 'text'\"\n        data-sync=\"true\"\n        ng-model=\"item.extra[field.field]\"\n        data-dark=\"dark\"\n        data-boxed=\"boxed\"\n        data-label=\"{{ field.label }}\"\n        data-required=\"field.required\"\n        data-disabled=\"isDisabled(field)\"\n        data-onchange=\"onChange({key: 'extra'})\"\n        data-onblur=\"onBlur()\"\n        data-maxlength=\"field.maxlength\"\n        data-placeholder=\"{{ placeholder[field.field] }}\"\n    />\n\n    <div ng-if=\"field.type === 'list' || field.cv\">\n        <label class=\"form-label\">{{ field.label }}</label>\n\n        <div sd-meta-place ng-if=\"field.field === 'place' && features.places_autocomplete\"\n            class=\"data sd-terms--boxed\"\n            data-item=\"item\"\n            data-field=\"place\"\n            ng-disabled=\"isDisabled(field)\"\n            data-change=\"onChange({key: field})\"\n        ></div>\n\n        <div sd-meta-words-list ng-if=\"field.field === 'keywords'\"\n            class=\"data sd-terms--boxed sd-line-input--dark-ui sd-line-input--boxed\"\n            data-item=\"item\"\n            data-field=\"keywords\"\n            data-change=\"onChange({key: field})\"\n            data-list=\"metadata.keywords\"\n            data-disabled=\"isDisabled(field)\"\n            data-style=\"sd-line-input__input\"\n            data-header=\"true\"\n        ></div>\n\n        <div sd-meta-terms ng-if=\"!(field.field === 'place' && features.places_autocomplete) && field.field !== 'keywords'\"\n            class=\"data sd-terms--boxed\"\n            data-item=\"item\"\n            data-field=\"{{ field.cv.schema_field || 'subject'}}\"\n            data-unique=\"qcode\"\n            data-list=\"field.cv.items\"\n            data-cv=\"field.cv\"\n            ng-disabled=\"isDisabled(field)\"\n            data-header=\"true\"\n            data-change=\"onChange({key: field})\"\n            data-include-parent=\"{{ field.includeparent }}\"\n        ></div>\n    </div>\n\n    <div ng-if=\"field.type === 'date'\">\n        <label class=\"form-label\">{{ field.label }}</label>\n        <div sd-datepicker\n            ng-disabled=\"isDisabled(field)\"\n            ng-model=\"item.extra[field.field]\"\n            data-format=\"YYYY-MM-DDT00:00:00+0000\"\n            data-on-change=\"onChange({key: 'extra'})\"\n        ></div>\n    </div>\n</div>";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MediaMetadataViewDirective.$inject = ['deployConfig'];
function MediaMetadataViewDirective(deployConfig) {
    return {
        scope: {
            item: '=',
            showAltText: '@',
        },
        template: __webpack_require__(1637),
        link: function (scope) {
            scope.validator = deployConfig.getSync('validator_media_metadata');
        },
    };
}
exports.default = MediaMetadataViewDirective;


/***/ }),
/* 1637 */
/***/ (function(module, exports) {

module.exports = "<span ng-if=\"showAltText\">\n    <em>{{:: 'Alt text:' | translate}}</em>\n    {{item.alt_text || ('[No Value]' | translate)}}\n</span>\n<span ng-if=\"validator.byline\">\n    <em>{{:: 'Credit:' | translate}}</em>\n    {{item.byline || ('[No Value]' | translate)}}\n</span>\n<span ng-if=\"validator.copyrightholder\">\n    <em>{{:: 'Copyright holder:' | translate}}</em>\n    {{item.copyrightholder || ('[No Value]' | translate)}}\n</span>\n<span ng-if=\"validator.usageterms\">\n    <em>{{:: 'Assign rights:' | translate}}</em>\n    {{item.usageterms || ('[No Value]' | translate)}}\n</span>\n<span ng-if=\"validator.copyrightnotice\">\n    <em>{{:: 'Copyright notice:' | translate}}</em>\n    {{item.copyrightnotice || ('[No Value]' | translate)}}\n</span>\n";

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MediaCopyMetadataDirective.$inject = [];
function MediaCopyMetadataDirective() {
    return {
        scope: {
            metadata: '=',
            onChange: '&',
        },
        template: __webpack_require__(1639),
        link: function (scope) {
            var METADATA_ITEMS = 'metadata:items';
            scope.metadataFromStorage = !!localStorage.getItem(METADATA_ITEMS);
            scope.copyMetadata = function (metadata) {
                scope.metadataFromStorage = true;
                localStorage.setItem(METADATA_ITEMS, JSON.stringify(metadata));
            };
            scope.pasteMetadata = function () {
                scope.metadata = JSON.parse(localStorage.getItem(METADATA_ITEMS));
                scope.onChange();
            };
            scope.clearSavedMetadata = function () {
                localStorage.removeItem(METADATA_ITEMS);
                scope.metadataFromStorage = false;
            };
        },
    };
}
exports.default = MediaCopyMetadataDirective;


/***/ }),
/* 1639 */
/***/ (function(module, exports) {

module.exports = "<div class=\"btn-group--flex sd-margin-b--1\">\n    <button type=\"button\" class=\"btn btn--hollow btn--primary btn--expanded\" ng-click=\"copyMetadata(metadata)\" translate>Copy metadata</button>\n    <button type=\"button\" class=\"btn btn--hollow btn--expanded\" ng-click=\"pasteMetadata()\" ng-disabled=\"!metadataFromStorage\" translate>Paste metadata</button>\n</div>\n<a ng-click=\"clearSavedMetadata()\" class=\"text-link text-link--white pull-right\" ng-show=\"metadataFromStorage\" translate>Clear saved metadata</a>";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var utils_1 = __webpack_require__(3);
var ArticleUrlFields = /** @class */ (function (_super) {
    __extends(ArticleUrlFields, _super);
    function ArticleUrlFields(props) {
        var _this = _super.call(this, props) || this;
        // local state is used, because onChange is debounced
        _this.state = {
            urls: Array.isArray(props.urls) && props.urls.length > 0 ? props.urls : [],
        };
        return _this;
    }
    ArticleUrlFields.prototype.removeUrl = function (index) {
        var _this = this;
        this.setState({
            urls: this.state.urls.filter(function (_, i) { return i !== index; }),
        }, function () {
            _this.props.onChange(_this.props.fieldId, _this.state.urls);
        });
    };
    ArticleUrlFields.prototype.addUrl = function () {
        var _this = this;
        this.setState({
            urls: this.state.urls.concat({ url: 'https://', description: '' }),
        }, function () {
            _this.props.onChange(_this.props.fieldId, _this.state.urls);
        });
    };
    ArticleUrlFields.prototype.handleChange = function (index, field, event) {
        var _this = this;
        var nextUrls = this.state.urls.map(function (currentValue, i) {
            var _a;
            if (i === index) {
                return __assign({}, currentValue, (_a = {}, _a[field] = event.target.value, _a));
            }
            else {
                return currentValue;
            }
        });
        this.setState({
            urls: nextUrls,
        }, function () {
            _this.props.onChange(_this.props.fieldId, _this.state.urls);
        });
    };
    ArticleUrlFields.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, helperText = _a.helperText, editable = _a.editable;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", { className: "field__label" }, label),
            this.state.urls.map(function (item, i) { return (react_1.default.createElement("div", { key: i },
                react_1.default.createElement("div", { className: "space-between" },
                    react_1.default.createElement("input", { disabled: !editable, type: "text", value: item.url, onChange: _this.handleChange.bind(_this, i, 'url') }),
                    react_1.default.createElement("button", { disabled: !editable, type: "button", onClick: function () { return _this.removeUrl(i); } },
                        react_1.default.createElement("i", { className: "icon-remove-sign", style: { display: 'block' } }))),
                react_1.default.createElement("textarea", { style: { marginTop: 0.5 + 'em' }, disabled: !editable, className: "sd-editor__default-input", placeholder: utils_1.gettext('Description'), value: item.description, onChange: _this.handleChange.bind(_this, i, 'description') }))); }),
            react_1.default.createElement("div", null,
                react_1.default.createElement("button", { disabled: !editable, className: "btn btn--primary", onClick: function () { return _this.addUrl(); }, style: { marginTop: 10 } }, utils_1.gettext('Add URL'))),
            helperText == null ? null : react_1.default.createElement("div", { className: "sd-editor__info-text" }, helperText)));
    };
    return ArticleUrlFields;
}(react_1.default.Component));
exports.ArticleUrlFields = ArticleUrlFields;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var isNewItem = function (item) { return item._current_version === 0; };
/**
 * It will populate item.authors with current user when item is opened for authoring.
 */
function PopulateAuthorsController($scope, roles, session) {
    if (!$scope._editable) {
        return;
    }
    var stopWatch = $scope.$watch('metadata.authors', function (authors) {
        if (authors) {
            var itemAuthors_1 = $scope.item.authors || [];
            if (itemAuthors_1.find(function (author) { return author.parent === session.identity._id; })) {
                return; // current user is already in authors
            }
            if (!session.identity.role) {
                return; // no user role to pick default author role
            }
            roles.getUserRole(session.identity.role)
                .then(function (userRole) {
                if (isNewItem($scope.item) && userRole.author_role) {
                    addAuthor(userRole.author_role, itemAuthors_1);
                }
                if (!isNewItem($scope.item) && userRole.editor_role) {
                    addAuthor(userRole.editor_role, itemAuthors_1);
                }
            });
            stopWatch(); // it populates value, so just run this once
        }
    });
    function addAuthor(authorRoleId, itemAuthors) {
        var authorRole = $scope.metadata.authors.find(function (role) { return role.role === authorRoleId && role.parent === session.identity._id; });
        if (authorRole) {
            $scope.item.authors = itemAuthors.concat([authorRole]);
            $scope.autosave($scope.item);
        }
    }
}
exports.PopulateAuthorsController = PopulateAuthorsController;
PopulateAuthorsController.$inject = ['$scope', 'roles', 'session'];


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var WidgetsConfig_1 = __webpack_require__(548);
var utils_1 = __webpack_require__(3);
function AuthoringWidgetsProvider() {
    var widgets = [];
    /**
     * Register new widget
     *
     * @param {String} id
     * @param {Object} config Widget configuration
     *
     *   Object properties:
     *     - `label` - `{string}` - Widget label displayed on top
     *     - `icon` - `{string}` - Icon to use from `big-icon` font.
     *     - `side` - `{string}` - Side where to display it, can be `left` or `right`.
     *     - `order` - `{number}` - Widget order in the list, lower number is higher.
     *     - `template` - `{string}` - Widget template to include.
     *     - `display` - `{Object}` - Controll when to display widget.
     *     - `needEditable` - `{boolean}` - `True` if item must be editable.
     *     - `needUnlock` - `{boolean}` - `True` will make widget locked if item is locked.
     *     - `configurable` - `{boolean}` - `True` if widget is configurable.
     *     - `configurationTemplate` - `{string}` - Template to use for configuration.
     *     - `isWidgetVisible` - `{Function}` = Function which should return injectable
     *       function and gets single param `item`.
     *     - `badge` - `{Function}` - Injectable function to get badge number for item,
     *       gets `item` injected.
     *     - `badgeAsync` - `{Function}` - Injectable function to get badge number
     *       returning a promise, gets `item` injected.
     */
    this.widget = function (id, config) {
        widgets = widgets.filter(function (widget) { return widget._id !== id; });
        widgets.push(angular.extend({}, config, { _id: id })); // make a new instance for every widget
    };
    this.$get = function () {
        return widgets;
    };
}
WidgetsManagerCtrl.$inject = ['$scope', '$routeParams', 'authoringWidgets', 'archiveService', 'authoringWorkspace',
    'keyboardManager', '$location', 'desks', 'lock', 'content', 'config', 'lodash', 'privileges', '$injector'];
function WidgetsManagerCtrl($scope, $routeParams, authoringWidgets, archiveService, authoringWorkspace, keyboardManager, $location, desks, lock, content, config, _, privileges, $injector) {
    $scope.active = null;
    $scope.$watch('item', function (item) {
        if (!item) {
            $scope.widgets = null;
            unbindAllShortcuts();
            return;
        }
        var display;
        if (archiveService.isLegal(item)) {
            display = 'legalArchive';
        }
        else if (archiveService.isArchived(item)) {
            display = 'archived';
        }
        else if (archiveService.isPersonal(item)) {
            display = 'personal';
        }
        else {
            display = (item.state === 'killed' || item.state === 'recalled') ? 'killedItem' : 'authoring';
            if (item.type === 'composite') {
                display = 'packages';
            }
            if (item.type === 'picture') {
                display = 'picture';
            }
        }
        var widgets = authoringWidgets.filter(function (widget) { return (!!widget.display[display] &&
            // If the widget requires a feature configured, then test this
            // feature name against the config (defaulting to true)
            (!widget.feature || !!_.get(config.features, widget.feature, true))); });
        content.getType(item.profile).then(function (contentProfile) {
            var promises = widgets.map(function (widget) { return new Promise(function (resolve) {
                Promise.all([
                    // checking static superdesk config
                    typeof widget.isWidgetVisible === 'function'
                        ? $injector.invoke(widget.isWidgetVisible(item))
                        : Promise.resolve(true),
                    // checking result from plugins
                    authoringWorkspace.isWidgetVisible(widget),
                    Promise.resolve(WidgetsConfig_1.isWidgetVisibleForContentProfile(contentProfile.widgets_config, widget._id)),
                ])
                    .then(function (res) {
                    resolve(res.every(function (i) { return i === true; }));
                })
                    .catch(function () {
                    resolve(false);
                });
            }); });
            Promise.all(promises).then(function (result) {
                $scope.widgets = widgets.filter(function (__, i) { return result[i] === true; });
                $scope.widgets.forEach(function (widget) {
                    if (widget.badgeAsync != null) {
                        widget.badgeAsyncValue = null;
                        $injector.invoke(widget.badgeAsync, null, { item: item })
                            .then(function (value) { return widget.badgeAsyncValue = value; });
                    }
                });
                $scope.$apply(); // tell angular to re-render
            });
        });
        bindAllShortcuts();
    });
    var shortcuts = [];
    function unbindAllShortcuts() {
        shortcuts.forEach(function (sc) {
            keyboardManager.unbind(sc);
        });
        shortcuts = [];
    }
    function bindKeyShortcutToWidget(shortcut, widget) {
        shortcuts.push(shortcut);
        keyboardManager.bind(shortcut, function () {
            $scope.activate(widget);
        });
    }
    function bindAllShortcuts() {
        /*
         * Navigate through right tab widgets, include custom keys from `keyboardShortcut` property
         */
        angular.forEach(_.sortBy($scope.widgets, 'order'), function (widget, index) {
            // binding keys from `widget.keyboardShortcut` property
            if (angular.isDefined(widget.keyboardShortcut)) {
                bindKeyShortcutToWidget(widget.keyboardShortcut, widget);
            }
            if ($location.search()[widget._id]) {
                $scope.activate(widget);
            }
        });
    }
    $scope.isWidgetLocked = function (widget) {
        if (widget) {
            var locked = lock.isLocked($scope.item) && !lock.can_unlock($scope.item);
            var isReadOnlyStage = desks.isReadOnlyStage($scope.item.task.stage);
            return widget.needUnlock && (locked || isReadOnlyStage) ||
                widget.needEditable && (!$scope.item._editable || isReadOnlyStage);
        }
    };
    $scope.activate = function (widget) {
        if (!$scope.isWidgetLocked(widget)) {
            if ($scope.active === widget) {
                $scope.closeWidget();
            }
            else {
                $scope.active = widget;
            }
        }
    };
    // item is associated to an assignment
    $scope.isAssigned = function (item) { return _.get(item, 'assignment_id') != null
        && _.get(privileges, 'privileges.planning') === 1; };
    this.activate = function (widget) {
        $scope.activate(widget);
    };
    $scope.closeWidget = function () {
        if ($scope.active && typeof $scope.active.afterClose === 'function') {
            $scope.active.afterClose($scope);
        }
        $scope.active = null;
    };
    // activate widget based on query string
    angular.forEach($scope.widgets, function (widget) {
        if ($routeParams[widget._id]) {
            $scope.activate(widget);
        }
    });
    $scope.$watch('item._locked', function () {
        if ($scope.active) {
            var widget = $scope.active;
            $scope.closeWidget(widget);
            $scope.activate(widget);
        }
    });
    $scope.$on('$destroy', function () {
        unbindAllShortcuts();
    });
}
AuthoringWidgetsDir.$inject = ['desks', 'commentsService', '$injector'];
function AuthoringWidgetsDir(desks, commentsService, $injector) {
    return {
        controller: WidgetsManagerCtrl,
        templateUrl: 'scripts/apps/authoring/widgets/views/authoring-widgets.html',
        transclude: true,
        link: function (scope, elem) {
            scope.userLookup = desks.userLookup;
            var editor = elem.find('.page-content-container'), stickyHeader = elem.find('.authoring-sticky');
            var scrollHandler = lodash_1.debounce(clipHeader, 100);
            editor.on('scroll', scrollHandler);
            scope.$on('$destroy', function () {
                editor.off('scroll', scrollHandler);
            });
            function clipHeader() {
                if (editor.scrollTop() > 5) {
                    stickyHeader.addClass('authoring-sticky--fixed');
                }
                else {
                    stickyHeader.removeClass('authoring-sticky--fixed');
                }
            }
            function reload() {
                if (scope.item) {
                    commentsService.fetch(scope.item._id).then(function () {
                        scope.comments = commentsService.comments;
                    });
                }
            }
            scope.$on('item:comment', function (e, data) {
                if (data.item === scope.item.guid) {
                    reload();
                }
            });
            scope.badge = function (widget) {
                if (widget.badgeAsyncValue !== undefined) {
                    return widget.badgeAsyncValue;
                }
                if (widget.badge) {
                    return $injector.invoke(widget.badge, null, { item: scope.item });
                }
            };
            scope.generateHotkey = function (order, tooltip) {
                var shiftNums = { 1: '!', 2: '@', 3: '#', 4: '$', 5: '%', 6: '^', 7: '&', 8: '*', 9: '(' };
                if (order < 10) {
                    return "ctrl+alt+" + order;
                }
                else if (order === 10) {
                    return "ctrl+alt+0";
                }
                else if (order > 10) {
                    return tooltip ? "ctrl+shift+" + (order - 10) : "ctrl+shift+" + shiftNums[order - 10];
                }
            };
            reload();
        },
    };
}
angular.module('superdesk.apps.authoring.widgets', ['superdesk.core.keyboard'])
    .provider('authoringWidgets', AuthoringWidgetsProvider)
    .directive('sdAuthoringWidgets', AuthoringWidgetsDir)
    .run(['keyboardManager', function (keyboardManager) {
        keyboardManager.register('Authoring', 'ctrl + alt + {N}', utils_1.gettext('Toggle Nth widget, where \'N\' is order of widget it appears'));
    }]);


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var lodash_1 = __webpack_require__(2);
var ENTER = 13;
CommentsService.$inject = ['api'];
function CommentsService(api) {
    this.comments = null;
    this.fetch = function (item) {
        var criteria = {
            where: {
                item: item,
            },
            embedded: { user: 1 },
        };
        return api.item_comments.query(criteria)
            .then(angular.bind(this, function (result) {
            this.comments = result._items;
        }));
    };
    this.save = function (comment) {
        return api.item_comments.save(comment);
    };
}
CommentsCtrl.$inject = ['$scope', '$routeParams', 'commentsService'];
function CommentsCtrl($scope, $routeParams, commentsService) {
    $scope.text = null;
    $scope.saveEnterFlag = false;
    $scope.$watch('item._id', reload);
    $scope.users = [];
    $scope.saveOnEnter = function ($event) {
        if (!$scope.saveEnterFlag || $event.keyCode !== ENTER || $event.shiftKey) {
            return;
        }
        $scope.save();
    };
    $scope.save = function () {
        var text = $scope.text || '';
        if (!text.length) {
            return;
        }
        $scope.text = '';
        $scope.flags = { saving: true };
        commentsService.save({
            text: text,
            item: $scope.item._id,
        }).then(reload);
    };
    $scope.cancel = function () {
        $scope.text = '';
    };
    function reload() {
        if ($scope.item) {
            commentsService.fetch($scope.item._id).then(function () {
                $scope.comments = commentsService.comments;
            });
        }
    }
    $scope.$on('item:comment', function (e, data) {
        if (data.item === $scope.item.guid) {
            reload();
        }
    });
    function setActiveComment() {
        $scope.active = $routeParams.comments || null;
    }
    $scope.$on('$locationChangeSuccess', setActiveComment);
    setActiveComment();
}
CommentTextDirective.$inject = ['$compile'];
function CommentTextDirective($compile) {
    return {
        scope: {
            comment: '=',
        },
        link: function (scope, element, attrs) {
            var html;
            // replace new lines with paragraphs
            html = attrs.text.replace(/(?:\r\n|\r|\n)/g, '</p><p>');
            // map user mentions
            var mentionedUsers = html.match(/\@([a-zA-Z0-9-_.\w]+)/g);
            lodash_1.each(mentionedUsers, function (token) {
                var username = token.substring(1, token.length);
                if (scope.comment.mentioned_users && scope.comment.mentioned_users[username]) {
                    html = html.replace(token, '<i sd-user-info data-user="' + scope.comment.mentioned_users[username] + '">' + token + '</i>');
                }
            });
            // map desk mentions
            var mentionedDesks = html.match(/\#([a-zA-Z0-9-_.]\w+)/g);
            lodash_1.each(mentionedDesks, function (token) {
                var deskname = token.substring(1, token.length);
                if (scope.comment.mentioned_desks && scope.comment.mentioned_desks[deskname]) {
                    html = html.replace(token, '<a href="">' + token + '</a>');
                }
            });
            // build element
            element.html('<p><b>' + attrs.name + '</b> : ' + html + '</p>');
            $compile(element.contents())(scope);
        },
    };
}
angular.module('superdesk.apps.authoring.comments', [
    'superdesk.apps.authoring.widgets',
    'mentio',
    'superdesk.core.api',
    'superdesk.core.keyboard',
])
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('comments', {
            icon: 'chat',
            label: utils_1.gettext('Comments'),
            template: 'scripts/apps/authoring/comments/views/comments-widget.html',
            order: 3,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: true,
            },
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('item_comments', {
            type: 'http',
            backend: { rel: 'item_comments' },
        });
    }])
    .controller('CommentsWidgetCtrl', CommentsCtrl)
    .service('commentsService', CommentsService)
    .directive('sdCommentText', CommentTextDirective);


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var fieldsMeta_1 = __webpack_require__(66);
var editor3CustomData_1 = __webpack_require__(48);
var highlights_1 = __webpack_require__(41);
var highlightsConfig_1 = __webpack_require__(46);
var editor3CustomData_2 = __webpack_require__(48);
var getLabelForFieldId_1 = __webpack_require__(62);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
function getAllUserIdsFromComments(comments) {
    var users = [];
    comments.forEach(function (_a) {
        var data = _a.data;
        users.push(data.authorId);
        if (data.resolutionInfo) {
            users.push(data.resolutionInfo.resolverUserId);
        }
        data.replies.map(function (reply) { return users.push(reply.authorId); });
    });
    return users.filter(function (value, index, self) { return self.indexOf(value) === index; });
}
function filterUsers(users, ids) {
    return users.filter(function (user) { return ids.includes(user._id); });
}
function convertUsersArrayToObject(users) {
    var usersObj = {};
    users.forEach(function (user) {
        usersObj[user._id] = user;
    });
    return usersObj;
}
function getCommentsFromField(getLabelForFieldId) {
    return function (obj) { return ({
        fieldName: getLabelForFieldId(fieldsMeta_1.getFieldId(obj.contentKey)),
        comments: editor3CustomData_1.getCustomDataFromEditorRawState(obj[fieldsMeta_1.fieldsMetaKeys.draftjsState], editor3CustomData_1.editor3DataKeys.RESOLVED_COMMENTS_HISTORY) || [],
    }); };
}
InlineCommentsCtrl.$inject = ['$scope', 'userList', 'metadata', 'content'];
function InlineCommentsCtrl($scope, userList, metadata, content) {
    getLabelForFieldId_1.getLabelNameResolver().then(function (getLabelForFieldId) {
        var _a;
        $scope.resolvedFilter = 'RESOLVED';
        var editors = Object.keys($scope.item[fieldsMeta_1.META_FIELD_NAME])
            .map(function (contentKey) {
            var _a;
            return (_a = {
                    contentKey: contentKey
                },
                _a[fieldsMeta_1.fieldsMetaKeys.draftjsState] = fieldsMeta_1.getFieldMetadata($scope.item, contentKey, fieldsMeta_1.fieldsMetaKeys.draftjsState),
                _a);
        })
            .filter(function (obj) { return obj[fieldsMeta_1.fieldsMetaKeys.draftjsState] != null; });
        var resolvedComments = editors
            .map(getCommentsFromField(getLabelForFieldId))
            .filter(function (obj) { return obj.comments.length > 0; });
        var unresolvedComments = Object.keys($scope.item[fieldsMeta_1.META_FIELD_NAME]).map(function (contentKey) {
            var rawEditorState = fieldsMeta_1.getFieldMetadata($scope.item, contentKey, fieldsMeta_1.fieldsMetaKeys.draftjsState);
            var comments = editor3CustomData_2.getCustomMetadata($scope.item, contentKey, highlightsConfig_1.highlightsConfig.COMMENT.type)
                .map(function (highlight) {
                var highlightId = highlight.styleName;
                var highlightWithCommentTextAdded = __assign({}, highlight.obj, { data: __assign({}, highlight.obj.data, { commentedText: highlights_1.getRangeAndTextForStyleInRawState(rawEditorState, highlightId).highlightedText }) });
                return __assign({}, highlightWithCommentTextAdded, { highlightId: highlightId });
            });
            return {
                fieldId: contentKey,
                fieldName: getLabelForFieldId(fieldsMeta_1.getFieldId(contentKey)),
                comments: comments,
            };
        })
            .filter(function (obj) { return obj.comments.length > 0; });
        var allComments = (_a = []
            .concat.apply([], resolvedComments.map(function (obj) { return obj.comments; }))).concat.apply(_a, unresolvedComments.map(function (obj) { return obj.comments; }));
        var userIds = getAllUserIdsFromComments(allComments);
        var _comments = {
            RESOLVED: resolvedComments,
            UNRESOLVED: unresolvedComments,
        };
        userList.getAll().then(function (users) {
            $scope.users = convertUsersArrayToObject(filterUsers(users, userIds));
            $scope.items = _comments;
        });
    });
}
angular
    .module('superdesk.apps.authoring.track-changes.inline-comments', [
    'superdesk.apps.authoring.widgets',
])
    .config([
    'authoringWidgetsProvider',
    function (authoringWidgetsProvider) {
        authoringWidgetsProvider.widget('inline-comments', {
            icon: 'comments',
            label: utils_1.gettext('Inline comments'),
            template: 'scripts/apps/authoring/track-changes/views/inline-comments-widget.html',
            order: 9,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: true,
            },
            isWidgetVisible: function (item) { return ['content', function (content) {
                    if (item.profile == null) {
                        return Promise.resolve(true);
                    }
                    return new Promise(function (resolve) {
                        content.getType(item.profile).then(function (type) {
                            var editor3enabled = lodash_1.get(type, 'editor.body_html.editor3') === true;
                            resolve(editor3enabled);
                        });
                    });
                }]; },
            feature: 'editorInlineComments',
        });
    },
])
    .controller('InlineCommentsCtrl', InlineCommentsCtrl);


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var editor3CustomData_1 = __webpack_require__(48);
var Highlights = __importStar(__webpack_require__(41));
var getLabelForFieldId_1 = __webpack_require__(62);
var fieldsMeta_1 = __webpack_require__(66);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
function getAllUserIdsFromSuggestions(suggestions) {
    var users = [];
    suggestions.forEach(function (_a) {
        var resolutionInfo = _a.resolutionInfo, suggestionInfo = _a.suggestionInfo;
        users.push(resolutionInfo.resolverUserId);
        users.push(suggestionInfo.author);
    });
    return users.filter(function (value, index, self) { return self.indexOf(value) === index; });
}
function filterUsers(users, ids) {
    return users.filter(function (user) { return ids.includes(user._id); });
}
function convertUsersArrayToObject(users) {
    var usersObj = {};
    users.forEach(function (user) {
        usersObj[user._id] = user;
    });
    return usersObj;
}
function getLocalizedTypeText(type, blockType) {
    var description = Highlights.getHighlightDescription(type);
    var blockStyleDescription = Highlights.getBlockStylesDescription(blockType);
    var space = blockStyleDescription !== '' ? ' ' : '';
    return description + space + blockStyleDescription;
}
SuggestionsCtrl.$inject = ['$scope', 'userList', 'content'];
function SuggestionsCtrl($scope, userList, content) {
    getLabelForFieldId_1.getLabelNameResolver().then(function (getLabelForFieldId) {
        var suggestions = Object.keys($scope.item[fieldsMeta_1.META_FIELD_NAME])
            .map(function (contentKey) {
            var _a;
            return (_a = {
                    contentKey: contentKey
                },
                _a[fieldsMeta_1.fieldsMetaKeys.draftjsState] = fieldsMeta_1.getFieldMetadata($scope.item, contentKey, fieldsMeta_1.fieldsMetaKeys.draftjsState),
                _a);
        })
            .filter(function (obj) { return obj[fieldsMeta_1.fieldsMetaKeys.draftjsState] != null; })
            .map(function (obj) { return ({
            fieldName: getLabelForFieldId(fieldsMeta_1.getFieldId(obj.contentKey)),
            suggestions: editor3CustomData_1.getCustomDataFromEditorRawState(obj[fieldsMeta_1.fieldsMetaKeys.draftjsState], editor3CustomData_1.editor3DataKeys.RESOLVED_SUGGESTIONS_HISTORY) || [],
        }); })
            .filter(function (obj) { return obj.suggestions.length > 0; });
        if (suggestions.length === 0) {
            $scope.items = [];
            return;
        }
        var userIds = getAllUserIdsFromSuggestions([].concat.apply([], suggestions.map(function (obj) { return obj.suggestions; })));
        userList.getAll()
            .then(function (users) {
            $scope.users = convertUsersArrayToObject(filterUsers(users, userIds));
            $scope.items = suggestions;
        });
        $scope.getLocalizedTypeText = getLocalizedTypeText;
    });
}
angular
    .module('superdesk.apps.authoring.track-changes.suggestions', [
    'superdesk.apps.authoring.widgets',
])
    .config([
    'authoringWidgetsProvider',
    function (authoringWidgetsProvider) {
        authoringWidgetsProvider.widget('suggestions', {
            icon: 'suggestion',
            label: utils_1.gettext('Suggestions'),
            template: 'scripts/apps/authoring/track-changes/views/suggestions-widget.html',
            order: 10,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: true,
            },
            isWidgetVisible: function (item) { return ['content', function (content) {
                    if (item.profile == null) {
                        return Promise.resolve(true);
                    }
                    return new Promise(function (resolve) {
                        content.getType(item.profile).then(function (type) {
                            var editor3enabled = lodash_1.get(type, 'editor.body_html.editor3') === true;
                            resolve(editor3enabled);
                        });
                    });
                }]; },
            feature: 'editorSuggestions',
        });
    },
])
    .controller('SuggestionsCtrl', SuggestionsCtrl);


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superdesk_ui_framework_1 = __webpack_require__(59);
__webpack_require__(1647);
var utils_1 = __webpack_require__(3);
var AttachmentsEditorDirective_1 = __importDefault(__webpack_require__(1649));
var actions_1 = __webpack_require__(125);
var AttachmentsList_1 = __webpack_require__(1650);
var AttachmentsEditorModal_1 = __webpack_require__(1651);
function getFilesLength(state) {
    return state.attachments.files.length;
}
var AttachmentsController = /** @class */ (function () {
    function AttachmentsController($scope) {
        var _this = this;
        var dispatch = $scope.store.dispatch;
        // map dispatch
        this.selectFiles = function (files) { return dispatch(actions_1.selectFiles(files)); };
        this.closeEdit = function () { return dispatch(actions_1.closeEdit()); };
        var state = $scope.store.getState();
        // re-render on state change
        var unsubscribe = $scope.store.subscribe(function () {
            if ($scope.store.getState().attachments !== state.attachments) {
                var filesLengthChange_1 = getFilesLength($scope.store.getState()) !== getFilesLength(state);
                state = $scope.store.getState();
                $scope.$applyAsync(function () {
                    if (filesLengthChange_1) {
                        $scope.item.attachments = state.attachments.files.map(function (f) { return ({ attachment: f._id }); });
                        $scope.autosave();
                    }
                    _this.mapState($scope.store.getState());
                });
            }
        });
        $scope.$on('$destroy', unsubscribe);
        // init
        this.mapState($scope.store.getState());
    }
    AttachmentsController.prototype.mapState = function (state) {
        this.edit = state.attachments.edit;
        this.files = state.attachments.files;
        this.maxSize = state.attachments.maxSize;
        this.maxFiles = state.attachments.maxFiles;
        this.editable = state.editor.editable;
        this.isLocked = state.editor.isLocked;
        this.isLockedByMe = state.editor.isLockedByMe;
    };
    return AttachmentsController;
}());
AttachmentsController.$inject = ['$scope'];
AttachmentsFactory.$inject = ['api'];
function AttachmentsFactory(api) {
    var RESOURCE = 'attachments';
    var _byIdCache = {};
    var AttachmentsService = /** @class */ (function () {
        function AttachmentsService() {
        }
        /**
         * Get attachments by item
         *
         * @param {Object} item
         * @return {Promise}
         */
        AttachmentsService.prototype.byItem = function (item) {
            var attachments = item.attachments || [];
            return api.query(RESOURCE, { where: { _id: { $in: attachments.map(function (ref) { return ref.attachment; }) } } })
                .then(function (data) { return data._items; });
        };
        /**
         * Save attachment changes
         *
         * @param {Object} file
         * @param {Object} diff
         * @return {Promise}
         */
        AttachmentsService.prototype.save = function (file, diff) {
            clearCache(file);
            return api.save(RESOURCE, file, diff);
        };
        /**
         * Remove attachment
         *
         * @param {Object} file
         * @return {Promise}
         */
        AttachmentsService.prototype.remove = function (file) {
            clearCache(file);
            return api.remove(file);
        };
        /**
         * Get attachment by id
         *
         * @param {String} id
         * @return {Promise}
         */
        AttachmentsService.prototype.byId = function (id) {
            if (!_byIdCache[id]) {
                _byIdCache[id] = api.find(RESOURCE, id);
            }
            return _byIdCache[id];
        };
        return AttachmentsService;
    }());
    function clearCache(file) {
        if (_byIdCache[file._id]) {
            _byIdCache[file._id] = null;
        }
    }
    return new AttachmentsService();
}
var config = function (awp) {
    return awp.widget('attachments', {
        icon: 'attachment',
        label: utils_1.gettext('Attachments'),
        template: 'scripts/apps/authoring/attachments/attachments.html',
        order: 8,
        side: 'right',
        badge: ['item', function (item) { return item.attachments && item.attachments.length; }],
        display: {
            authoring: true,
            packages: true,
            killedItem: true,
            legalArchive: false,
            archived: false,
            picture: true,
            personal: true,
        },
        feature: 'editorAttachments',
    });
};
angular.module('superdesk.apps.authoring.attachments', [
    'ngFileUpload',
    'superdesk.config',
    'superdesk.core.api',
    'superdesk.apps.authoring.widgets',
])
    .factory('attachments', AttachmentsFactory)
    .controller('AttachmentsCtrl', AttachmentsController)
    .config(['authoringWidgetsProvider', config])
    .directive('sdAttachmentsEditor', AttachmentsEditorDirective_1.default)
    .component('sdAttachmentsEditorModal', superdesk_ui_framework_1.reactToAngular1(AttachmentsEditorModal_1.AttachmentsEditorModal, ['store']))
    .component('sdAttachmentsList', superdesk_ui_framework_1.reactToAngular1(AttachmentsList_1.AttachmentsList, ['store']));


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1648);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./attachments.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./attachments.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n.sd-widget.attachments .attachments-pane .attachments-list {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  bottom: 212px;\n  left: 12px;\n  overflow-y: scroll; }\n\n.sd-widget.attachments .attachments-pane .attach-indicator {\n  position: absolute;\n  bottom: 12px;\n  left: 50%;\n  margin-left: -125px;\n  width: 250px;\n  text-align: center; }\n  .sd-widget.attachments .attachments-pane .attach-indicator.empty {\n    bottom: 50%; }\n    .sd-widget.attachments .attachments-pane .attach-indicator.empty .round-box i.icon {\n      color: #5ea9c8; }\n  .sd-widget.attachments .attachments-pane .attach-indicator .round-box {\n    display: block;\n    box-sizing: border-box;\n    padding-top: 16px;\n    height: 90px;\n    width: 90px;\n    background-color: #fff;\n    border-radius: 50%;\n    margin: 0 auto;\n    box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.08); }\n    .sd-widget.attachments .attachments-pane .attach-indicator .round-box i.icon {\n      display: block;\n      width: 56px;\n      height: 48px;\n      margin: 1.4rem auto 0 auto;\n      font-size: 5.2rem; }\n  .sd-widget.attachments .attachments-pane .attach-indicator .subtext {\n    margin: 15px 0;\n    color: #909090; }\n", ""]);

// exports


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function AttachmentsEditorDirective() {
    return {
        templateUrl: 'scripts/apps/authoring/attachments/attachments.html',
    };
}
exports.default = AttachmentsEditorDirective;


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_redux_1 = __webpack_require__(25);
var utils_1 = __webpack_require__(3);
var ui_1 = __webpack_require__(148);
var actions_1 = __webpack_require__(125);
var List_1 = __webpack_require__(429);
var AttachmentsListComponent = /** @class */ (function (_super) {
    __extends(AttachmentsListComponent, _super);
    function AttachmentsListComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderFile = _this.renderFile.bind(_this);
        return _this;
    }
    AttachmentsListComponent.prototype.renderFile = function (file) {
        var _a = this.props, isLocked = _a.isLocked, _download = _a.download, _editFile = _a.editFile, _removeFile = _a.removeFile;
        return (react_1.default.createElement(List_1.Item, { key: file._id, shadow: 1 },
            react_1.default.createElement(List_1.Column, { border: true, title: file.mimetype },
                react_1.default.createElement("i", { className: "big-icon--" + ui_1.fileicon(file.mimetype) })),
            react_1.default.createElement(List_1.Column, { grow: true },
                react_1.default.createElement(List_1.Row, null,
                    react_1.default.createElement("h4", null, file.title)),
                react_1.default.createElement(List_1.Row, null,
                    react_1.default.createElement("h5", null,
                        file.filename,
                        " ", "(" + ui_1.filesize(file.media.length) + ")")),
                react_1.default.createElement(List_1.Row, null,
                    react_1.default.createElement("div", { className: "description" }, file.description))),
            react_1.default.createElement(List_1.ActionMenu, { row: true },
                react_1.default.createElement("button", { className: "dropdown__toggle", onClick: function () { return _download(file); }, title: utils_1.gettext('Download') },
                    react_1.default.createElement("i", { className: "icon-download" })),
                !isLocked && react_1.default.createElement("button", { className: "dropdown__toggle", onClick: function () { return _editFile(file); }, title: utils_1.gettext('Edit') },
                    react_1.default.createElement("i", { className: "icon-pencil" })),
                react_1.default.createElement("button", { className: "dropdown__toggle", onClick: function () { return _removeFile(file); }, title: utils_1.gettext('Remove') },
                    react_1.default.createElement("i", { className: "icon-trash" })))));
    };
    AttachmentsListComponent.prototype.render = function () {
        var files = this.props.files;
        return (react_1.default.createElement("div", { className: "attachments-list" }, !!files.length &&
            react_1.default.createElement("ul", null, files.map(this.renderFile))));
    };
    return AttachmentsListComponent;
}(react_1.default.PureComponent));
var mapStateToProps = function (state) { return ({
    files: state.attachments.files,
    isLocked: state.editor.isLocked,
}); };
var mapDispatchToProps = {
    editFile: actions_1.editFile,
    download: actions_1.download,
    removeFile: actions_1.removeFile,
};
var AttachmentsListConnected = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AttachmentsListComponent);
exports.AttachmentsList = function (props) { return (react_1.default.createElement(react_redux_1.Provider, { store: props.store },
    react_1.default.createElement(AttachmentsListConnected, null))); };


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_redux_1 = __webpack_require__(25);
var utils_1 = __webpack_require__(3);
var actions_1 = __webpack_require__(125);
var ModalBody_1 = __webpack_require__(171);
var ModalHeader_1 = __webpack_require__(170);
var ModalFooter_1 = __webpack_require__(172);
var Label_1 = __webpack_require__(430);
var Input_1 = __webpack_require__(432);
var TextArea_1 = __webpack_require__(433);
var AttachmentsEditorModalComponent = /** @class */ (function (_super) {
    __extends(AttachmentsEditorModalComponent, _super);
    function AttachmentsEditorModalComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { title: props.file.title, description: props.file.description };
        _this.update = _this.update.bind(_this);
        return _this;
    }
    AttachmentsEditorModalComponent.prototype.update = function (key, val) {
        var updates = {};
        updates[key] = val;
        this.setState(updates);
    };
    AttachmentsEditorModalComponent.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ModalHeader_1.ModalHeader, { onClose: this.props.closeEdit }, utils_1.gettext('Edit Attachment')),
            react_1.default.createElement(ModalBody_1.ModalBody, null,
                react_1.default.createElement("div", { className: "sd-line-input" },
                    react_1.default.createElement(Label_1.Label, { text: utils_1.gettext('Title') }),
                    react_1.default.createElement(Input_1.Input, { field: "title", value: this.state.title, onChange: this.update, required: true })),
                react_1.default.createElement("div", { className: "sd-line-input" },
                    react_1.default.createElement(Label_1.Label, { text: utils_1.gettext('Description') }),
                    react_1.default.createElement(TextArea_1.TextArea, { field: "description", value: this.state.description, onChange: this.update, required: true }))),
            react_1.default.createElement(ModalFooter_1.ModalFooter, null,
                react_1.default.createElement("button", { className: "btn btn--primary pull-right", onClick: function () { return _this.props.saveFile(_this.props.file, _this.state); }, disabled: !this.state.title || !this.state.description }, utils_1.gettext('Update')),
                react_1.default.createElement("button", { className: "btn pull-right", onClick: this.props.closeEdit }, utils_1.gettext('Cancel')))));
    };
    return AttachmentsEditorModalComponent;
}(react_1.default.Component));
var mapStateToProps = function (state) { return ({
    file: state.attachments.edit,
}); };
var mapDispatchToProps = {
    saveFile: actions_1.saveFile,
    closeEdit: actions_1.closeEdit,
};
var AttachmentsEditorModalConnected = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AttachmentsEditorModalComponent);
exports.AttachmentsEditorModal = function (props) { return (react_1.default.createElement(react_redux_1.Provider, { store: props.store },
    react_1.default.createElement(AttachmentsEditorModalConnected, null))); };


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.authoring.versioning', [])
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('versioning', {
            icon: 'history',
            label: utils_1.gettext('Versions') + '/' + utils_1.gettext('History'),
            removeHeader: true,
            template: 'scripts/apps/authoring/versioning/views/versioning.html',
            order: 4,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: true,
                archived: false,
                picture: true,
                personal: true,
            },
            afterClose: function (scope) {
                if (scope && typeof scope.closePreview === 'function' && !scope._editable) {
                    scope.closePreview();
                }
            },
        });
    }]);


/***/ }),
/* 1653 */
/***/ (function(module, exports) {

VersioningController.$inject = ['$scope', 'authoring', 'desks', 'archiveService'];
function VersioningController($scope, authoring, desks, archiveService) {
    $scope.last = null;
    $scope.versions = null;
    $scope.selected = null;
    $scope.users = null;
    $scope.canRevert = false;
    $scope.desks = null;
    $scope.stages = null;
    function fetchVersions() {
        desks.initialize()
            .then(function () {
            $scope.desks = desks.desks;
            $scope.stages = desks.deskStages;
            $scope.users = desks.users;
            archiveService.getVersions($scope.item, desks, 'versions').then(function (versions) {
                $scope.versions = versions;
                $scope.last = archiveService.lastVersion($scope.item, $scope.versions);
                if (archiveService.isLegal($scope.item)) {
                    $scope.canRevert = false;
                    $scope.openVersion($scope.last);
                }
                else {
                    $scope.canRevert = authoring.isEditable($scope.item) && !authoring.isPublished($scope.item);
                    if ($scope.item._autosave) {
                        $scope.selected = $scope.item._autosave;
                    }
                    else {
                        $scope.openVersion($scope.last);
                    }
                }
            });
        });
    }
    /**
     * Opens the given version for preview if the story is not editable
     * Or if editable but not dirty.
     * Then the last version can be edited only when editable and not dirty.
     */
    $scope.openVersion = function (version) {
        if (!$scope.item._editable) {
            $scope.preview(version);
        }
        else if ($scope.item._editable && !$scope.dirty) {
            $scope.selected = version;
            if (version === $scope.last && !$scope.item._autosave) {
                if (!$scope._editable) {
                    $scope.closePreview();
                }
            }
            else {
                $scope.preview(version);
            }
        }
    };
    /**
     * Revert to given version
     *
     * If the version is the last one and there is an autosave - drop autosave
     */
    $scope.revert = function (version) {
        $scope.$parent.revert(version).then(fetchVersions);
    };
    $scope.$watchGroup(['item._id', 'item._latest_version'], fetchVersions);
}
versioningVersionDirective.$inject = [];
function versioningVersionDirective() {
    return {
        templateUrl: 'scripts/apps/authoring/versioning/versions/views/versions.html',
    };
}
angular.module('superdesk.apps.authoring.versioning.versions', [])
    .directive('sdVersioningVersion', versioningVersionDirective)
    .controller('VersioningWidgetCtrl', VersioningController);


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TransmissionDetailsDirective_1 = __webpack_require__(1655);
var VersioningHistoryDirective_1 = __webpack_require__(1656);
var HistoryController_1 = __webpack_require__(1657);
angular.module('superdesk.apps.authoring.versioning.history', [])
    .directive('sdVersioningHistory', VersioningHistoryDirective_1.VersioningHistoryDirective)
    .directive('sdTransmissionDetails', TransmissionDetailsDirective_1.TransmissionDetailsDirective)
    .controller('HistoryWidgetCtrl', HistoryController_1.HistoryController);


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
TransmissionDetailsDirective.$inject = ['api'];
function TransmissionDetailsDirective(api) {
    return {
        templateUrl: 'scripts/apps/authoring/versioning/history/views/publish_queue.html',
        scope: {
            item: '=',
            type: '=',
        },
        link: function (scope) {
            scope.transmitted_item = null;
            scope.show_transmission_details = false;
            /**
             * Sets the model to be displayed in the modal-body.
             */
            scope.showFormattedItem = function (item) {
                scope.transmitted_item = item.formatted_item;
            };
            /**
             * Sets the model of the modal to null when and is hidden.
             */
            scope.hideFormattedItem = function () {
                scope.transmitted_item = null;
            };
            /**
             * Triggered when user clicks on +/- symbol in the Item History.
             *
             * When user clicks on + symbol, it hits the API to bring the transmission details from publish queue.
             */
            scope.showOrHideTransmissionDetails = function () {
                scope.show_transmission_details = !scope.show_transmission_details;
                if (scope.show_transmission_details) {
                    var criteria = { max_results: 20 };
                    criteria.where = JSON.stringify({
                        $and: [{ item_id: scope.item.item_id }, { item_version: scope.item.version }],
                    });
                    var promise;
                    if (scope.type === 'legal_archive') {
                        promise = api.legal_publish_queue.query(criteria);
                    }
                    else {
                        promise = api.publish_queue.query(criteria);
                    }
                    promise.then(function (response) {
                        lodash_1.default.each(response._items, function (item) {
                            if (angular.isUndefined(item.completed_at)) {
                                item.completed_at = item._updated;
                            }
                        });
                        scope.queuedItems = response._items;
                    });
                }
            };
        },
    };
}
exports.TransmissionDetailsDirective = TransmissionDetailsDirective;


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
VersioningHistoryDirective.$inject = [];
function VersioningHistoryDirective() {
    return {
        templateUrl: 'scripts/apps/authoring/versioning/history/views/history.html',
        scope: {
            item: '=',
        },
    };
}
exports.VersioningHistoryDirective = VersioningHistoryDirective;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
HistoryController.$inject = [
    '$scope',
    'desks',
    'api',
    'highlightsService',
    '$q',
    'archiveService',
    'authoringWorkspace'
];
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring.versioning.history
 * @name HistoryController
 * @requires $scope
 * @requires desks
 * @requires api
 * @requires highlightsService
 * @requires $q
 * @requires archiveService
 * @requires authoringWorkspace
 * @description Retrieves the history items for a given story,
 * merges with versions if need be.
 */
function HistoryController($scope, desks, api, highlightsService, $q, archiveService, authoringWorkspace) {
    $scope.highlightsById = {};
    $scope.historyItems = null;
    /**
     * @ngdoc method
     * @name HistoryController#fetchHistory
     * @description locates history items for the story. If history items do not exist or
     * they don't start from version 1 then uses versions to fill the gap
     */
    var fetchHistory = function () {
        initializeServices().then(function () {
            getHistory($scope.item)
                .then(function (historyItems) {
                var historyVersion = historyItems.length && historyItems[0].version || 200;
                if (!historyItems.length || historyItems[0].version > 1) {
                    // no or partial history so get versions
                    archiveService.getVersions($scope.item, desks, 'operations').then(function (versions) {
                        var processedVersions = versions.map(processVersion);
                        // use versions where version number is less than the history
                        $scope.historyItems = lodash_1.default.filter(processedVersions, function (v) { return v.version < historyVersion; });
                        // if there's any history items then merge them
                        if (historyItems.length) {
                            $scope.historyItems = $scope.historyItems.concat(historyItems);
                        }
                    });
                }
                else {
                    $scope.historyItems = historyItems;
                }
                // Filter out item_lock and item_unlock history entries
                if ($scope.historyItems && $scope.historyItems.length > 0) {
                    $scope.historyItems = $scope.historyItems.filter(function (entry) { return !entry.operation || ['item_lock', 'item_unlock'].indexOf(entry.operation) < 0; });
                }
            })
                .catch(function (error) {
                $scope.historyItems = null;
            });
        });
    };
    /**
     * @ngdoc method
     * @name HistoryController#open
     * @param {string} id - story id.
     * @description Opens the story by given id in view mode
     */
    $scope.open = function (id) {
        authoringWorkspace.edit({ _id: id }, 'view');
    };
    /**
     * @ngdoc method
     * @name HistoryController#initializeServices
     * @description initializes the desks and hightlight services
     */
    var initializeServices = function () {
        var promises = [];
        promises.push(desks.initialize().then(function () {
            $scope.deskLookup = desks.deskLookup;
        }));
        promises.push(highlightsService.get().then(function (result) {
            $scope.highlightsById = {};
            result._items.forEach(function (item) {
                $scope.highlightsById[item._id] = item;
            });
        }));
        return $q.all(promises);
    };
    /**
     * @ngdoc method
     * @name HistoryController#getHistory
     * @param {object} item - story
     * @description creates the queries for getting history items
     */
    var getHistory = function (item) {
        var criteria = {
            where: { item_id: item._id },
            max_results: 200,
            sort: '[(\'_created\', 1)]',
        };
        if (item._type === 'legal_archive') {
            return api.query('legal_archive_history', criteria)
                .then(function (historyItems) {
                historyItems._items.map(processLegalHistoryItem);
                return historyItems._items;
            });
        }
        return api.query('archive_history', criteria)
            .then(function (historyItems) {
            historyItems._items.map(processHistoryItem);
            return historyItems._items;
        });
    };
    /**
     * @ngdoc method
     * @name HistoryController#processVersion
     * @param {object} version - a version of a story
     * @description parses the version object
     */
    var processVersion = function (version) { return ({
        version: version._current_version,
        displayName: version.creator,
        isPublished: ['published', 'corrected', 'killed', 'recalled'].includes(version.state),
        operation: version.operation,
        item_id: version._id,
    }); };
    /**
     * @ngdoc method
     * @name HistoryController#processHistoryItem
     * @param {object} h - a history item of a story
     * @description parses the history item object
     */
    var processHistoryItem = function (h) {
        var historyDesk = lodash_1.default.get(h, 'update.task.desk');
        var historyStage = lodash_1.default.get(h, 'update.task.stage');
        h.displayName = h.user_id ? desks.userLookup[h.user_id].display_name : 'System';
        h.desk = historyDesk ? desks.deskLookup[historyDesk].name : null;
        h.stage = historyStage ? desks.stageLookup[historyStage].name : null;
        h.isPublished = ['publish', 'correct', 'kill', 'resend', 'takedown'].includes(h.operation);
        h.fieldsUpdated = h.update ? Object.keys(h.update).join(', ') : null;
    };
    /**
     * @ngdoc method
     * @name HistoryController#processLegalHistoryItem
     * @param {object} h - a legal history item of a story
     * @description parses the legal history item object
     */
    var processLegalHistoryItem = function (h) {
        h.displayName = h.user_id ? h.user_id : 'System';
        h.desk = lodash_1.default.get(h, 'update.task.desk');
        h.stage = lodash_1.default.get(h, 'update.task.stage');
        h.isPublished = ['publish', 'correct', 'kill', 'resend', 'takedown'].includes(h.operation);
        h.fieldsUpdated = h.update ? Object.keys(h.update).join(', ') : null;
    };
    $scope.$watchGroup(['item._id', 'item._latest_version'], fetchHistory);
}
exports.HistoryController = HistoryController;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var PreferedCvItemsConfigDirective_1 = __importDefault(__webpack_require__(1659));
var MetaPlaceDirective_1 = __importDefault(__webpack_require__(1661));
var constants_1 = __webpack_require__(158);
var utils_1 = __webpack_require__(3);
var PlacesService_1 = __importDefault(__webpack_require__(1663));
var SINGLE_SELECTION = constants_1.VOCABULARY_SELECTION_TYPES.SINGLE_SELECTION.id;
MetadataCtrl.$inject = [
    '$scope', 'desks', 'metadata', 'privileges', 'datetimeHelper', 'userList',
    'preferencesService', 'archiveService', 'config', 'moment', 'content',
];
function MetadataCtrl($scope, desks, metadata, privileges, datetimeHelper, userList, preferencesService, archiveService, config, moment, content) {
    desks.initialize();
    $scope.change_profile = config.item_profile && config.item_profile.change_profile === 1 &&
        lodash_1.default.get($scope, 'origItem.type') === 'text';
    metadata.initialize().then(function () {
        $scope.metadata = metadata.values;
        return preferencesService.get();
    })
        .then(setAvailableCategories)
        .then(setAvailableCompanyCodes);
    $scope.$watch(function () { return desks.active.desk; }, function (activeDeskId) {
        content.getDeskProfiles(activeDeskId ? desks.getCurrentDesk() : null, $scope.item.profile)
            .then(function (profiles) {
            $scope.desk_content_types = profiles;
        });
    });
    $scope.processGenre = function () {
        $scope.item.genre = lodash_1.default.map($scope.item.genre, function (g) { return lodash_1.default.pick(g, 'name'); });
    };
    /**
    * Builds a list of categories available for selection in scope. Used by
    * the "category" menu in the Authoring metadata section.
    *
    * @function setAvailableCategories
    * @param {Object} prefs - user preferences setting, including the
    *   preferred categories settings, among other things
    */
    function setAvailableCategories(prefs) {
        var all, // all available categories
        assigned = {}, // category codes already assigned to the article
        filtered, itemCategories, // existing categories assigned to the article
        // user's category preference settings , i.e. a map
        // object (<category_code> --> true/false)
        userPrefs;
        all = metadata.values.categories || [];
        userPrefs = prefs['categories:preferred'].selected;
        // gather article's existing category codes
        itemCategories = $scope.item.anpa_category || [];
        itemCategories.forEach(function (cat) {
            assigned[cat.qcode] = true;
        });
        filtered = lodash_1.default.filter(all, function (cat) { return !assigned[cat.qcode] && (lodash_1.default.isEmpty(userPrefs) || userPrefs[cat.qcode]); });
        $scope.availableCategories = lodash_1.default.sortBy(filtered, 'name');
    }
    /**
    * Builds a list of company_codes available for selection in scope. Used by
    * the "company_codes" menu in the Authoring metadata section.
    *
    * @function setAvailableCompanyCodes
    */
    function setAvailableCompanyCodes() {
        var all, // all available company codes
        assigned = {}, // company codes already assigned to the article
        filtered, itemCompanyCodes; // existing company codes assigned to the article
        all = lodash_1.default.cloneDeep(metadata.values.company_codes || []);
        all.forEach(function (companyCode) {
            companyCode.name = companyCode.name + ' (' + companyCode.qcode + ')';
        });
        // gather article's existing company codes
        itemCompanyCodes = $scope.item.company_codes || [];
        itemCompanyCodes.forEach(function (companyCode) {
            assigned[companyCode.qcode] = true;
        });
        filtered = lodash_1.default.filter(all, function (companyCode) { return !assigned[companyCode.qcode]; });
        $scope.availableCompanyCodes = lodash_1.default.sortBy(filtered, 'name');
    }
    $scope.$watch('item.publish_schedule_date', function (newValue, oldValue) {
        setPublishScheduleDate(newValue, oldValue);
    });
    $scope.$watch('item.publish_schedule_time', function (newValue, oldValue) {
        setPublishScheduleDate(newValue, oldValue);
    });
    $scope.$watch('item.time_zone', function (newValue, oldValue) {
        if ((newValue || oldValue) && newValue !== oldValue) {
            setTimeZone();
            setPublishScheduleDate(newValue, oldValue);
            setEmbargoTS(newValue, oldValue);
            if (!$scope.item.publish_schedule && !$scope.item.embargo) {
                $scope.item.schedule_settings = null;
            }
        }
    });
    function setTimeZone() {
        $scope.item.schedule_settings = {};
        if (!$scope.item.time_zone) {
            $scope.item.schedule_settings.time_zone = null;
        }
        else {
            $scope.item.schedule_settings.time_zone = $scope.item.time_zone;
        }
    }
    function setPublishScheduleDate(newValue, oldValue) {
        if ((newValue || oldValue) && newValue !== oldValue) {
            if ($scope.item.publish_schedule_date && $scope.item.publish_schedule_time) {
                $scope.item.publish_schedule = datetimeHelper.mergeDateTime($scope.item.publish_schedule_date, $scope.item.publish_schedule_time, $scope.item.time_zone);
                setTimeZone();
            }
            else {
                $scope.item.publish_schedule = null;
            }
            $scope.autosave($scope.item);
        }
    }
    $scope.$watch('item.embargo_date', function (newValue, oldValue) {
        // set embargo time default on initial date selection
        if (newValue && oldValue === undefined) {
            $scope.item.embargo_time = moment('00:01', 'HH:mm')
                .format(config.model.timeformat);
        }
        setEmbargoTS(newValue, oldValue);
    });
    $scope.$watch('item.embargo_time', function (newValue, oldValue) {
        setEmbargoTS(newValue, oldValue);
    });
    /**
     * Listener method which gets invoked when either Embargo Date or Embargo Time has changed. This function takes
     * values of both Embargo Date and Embargo Time to form Timestamp.
     */
    function setEmbargoTS(newValue, oldValue) {
        if ((newValue || oldValue) && newValue !== oldValue) {
            if ($scope.item.embargo_date && $scope.item.embargo_time) {
                $scope.item.embargo = datetimeHelper.mergeDateTime($scope.item.embargo_date, $scope.item.embargo_time, $scope.item.time_zone);
                setTimeZone();
            }
            else {
                $scope.item.embargo = null;
            }
            $scope.autosave($scope.item);
        }
    }
    /**
     * Publish Schedule and Embargo are saved as Timestamps in DB but each field has date and time as two different
     * inputs in UI. This function breaks the timestamp fetched from API to Date and Time and assigns those values to
     * the appropriate field.
     */
    function resolvePublishScheduleAndEmbargoTS() {
        var info;
        var embargo = datetimeHelper.removeTZ($scope.item.embargo);
        var publishSchedule = datetimeHelper.removeTZ($scope.item.publish_schedule);
        if ($scope.item.schedule_settings) {
            $scope.item.time_zone = $scope.item.schedule_settings.time_zone;
            if ($scope.item.schedule_settings.utc_embargo) {
                embargo = $scope.item.schedule_settings.utc_embargo;
            }
            if ($scope.item.schedule_settings.utc_publish_schedule) {
                publishSchedule = $scope.item.schedule_settings.utc_publish_schedule;
            }
        }
        if (embargo) {
            info = datetimeHelper.splitDateTime(embargo, $scope.item.time_zone);
            $scope.item.embargo_date = info.date;
            $scope.item.embargo_time = info.time;
        }
        if (publishSchedule) {
            info = datetimeHelper.splitDateTime(publishSchedule, $scope.item.time_zone);
            $scope.item.publish_schedule_date = info.date;
            $scope.item.publish_schedule_time = info.time;
        }
    }
    $scope.unique_name_editable = Boolean(privileges.privileges.metadata_uniquename &&
        $scope.action !== 'correct' && $scope.action !== 'kill');
    resolvePublishScheduleAndEmbargoTS();
    metadata.getFilteredCustomVocabularies([]).then(function (cvs) {
        $scope.genreInCvs = lodash_1.default.map(cvs, 'schema_field').indexOf('genre') !== -1;
        $scope.placeInCvs = lodash_1.default.map(cvs, 'schema_field').indexOf('place') !== -1;
    });
    $scope.originalCreator = $scope.item.original_creator;
    $scope.versionCreator = $scope.item.version_creator;
    if (!archiveService.isLegal($scope.item)) {
        if ($scope.item.original_creator) {
            userList.getUser($scope.item.original_creator)
                .then(function (user) {
                $scope.originalCreator = user.display_name;
            });
        }
        if ($scope.item.version_creator) {
            userList.getUser($scope.item.version_creator)
                .then(function (user) {
                $scope.versionCreator = user.display_name;
            });
        }
    }
}
MetaTargetedPublishingDirective.$inject = [];
function MetaTargetedPublishingDirective() {
    return {
        scope: {
            list: '=',
            disabled: '=ngDisabled',
            targets: '=',
            autosave: '&',
        },
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-target-publishing.html',
        link: function (scope, elem) {
            scope.removeTarget = function (target) {
                scope.targets = lodash_1.default.without(scope.targets, target);
                scope.autosave();
            };
            scope.addTarget = function (target) {
                if (angular.isUndefined(scope.targets)) {
                    scope.targets = [];
                }
                var parsedTarget = JSON.parse(target);
                var existing = lodash_1.default.find(scope.targets, { qcode: parsedTarget.qcode, name: parsedTarget.name, allow: !scope.deny });
                if (!existing) {
                    scope.targets.push({ qcode: parsedTarget.qcode, name: parsedTarget.name, allow: !scope.deny });
                    scope.autosave();
                }
                reset();
            };
            function reset() {
                scope.target = '';
                scope.deny = false;
            }
            scope.canAddTarget = function () {
                return scope.disabled || !scope.target || scope.target === '';
            };
        },
    };
}
MetadropdownFocusDirective.$inject = ['keyboardManager'];
function MetadropdownFocusDirective(keyboardManager) {
    return {
        require: 'dropdown',
        link: function (scope, elem, attrs, dropdown) {
            scope.$watch(dropdown.isOpen, function (isOpen) {
                if (isOpen) {
                    lodash_1.default.defer(function () {
                        var keyboardOptions = { inputDisabled: false, propagate: false };
                        // narrow the selection to consider only dropdown list's button items
                        var buttonList = elem.find('.dropdown__menu button');
                        if (buttonList.length > 0) {
                            buttonList[0].focus();
                        }
                        keyboardManager.push('up', function () {
                            if (buttonList.length > 0) {
                                var focusedElem = elem.find('button:focus')[0];
                                var indexValue = lodash_1.default.findIndex(buttonList, function (chr) { return chr === focusedElem; });
                                // select previous item on key UP
                                if (indexValue > 0 && indexValue < buttonList.length) {
                                    buttonList[indexValue - 1].focus();
                                }
                            }
                        }, keyboardOptions);
                        keyboardManager.push('down', function () {
                            if (buttonList.length > 0) {
                                var focusedElem = elem.find('button:focus')[0];
                                var indexValue = lodash_1.default.findIndex(buttonList, function (chr) { return chr === focusedElem; });
                                // select next item on key DOWN
                                if (indexValue < buttonList.length - 1) {
                                    buttonList[indexValue + 1].focus();
                                }
                            }
                        }, keyboardOptions);
                    });
                }
                else if (isOpen === false) {
                    keyboardManager.pop('down');
                    keyboardManager.pop('up');
                }
            });
        },
    };
}
MetaDropdownDirective.$inject = ['$filter'];
function MetaDropdownDirective($filter) {
    return {
        scope: {
            list: '=',
            disabled: '=ngDisabled',
            item: '=',
            field: '@',
            icon: '@',
            label: '@',
            change: '&',
            key: '@',
            tabindex: '=',
            containingDirective: '@',
        },
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-dropdown.html',
        link: function (scope, elem) {
            scope.listFields = ['place', 'genre', 'anpa_category', 'subject', 'authors'];
            scope.select = function (item) {
                var o = {};
                if (item) {
                    o[scope.field] = scope.key ? item[scope.key] : [item];
                }
                else {
                    o[scope.field] = null;
                }
                lodash_1.default.extend(scope.item, o);
                scope.change({ item: scope.item, field: scope.field });
                // retain focus on same dropdown control after selection.
                lodash_1.default.defer(function () {
                    elem.find('.dropdown__toggle').focus();
                });
                if (scope.values) {
                    scope.selected = scope.values[o[scope.field]] || null;
                }
            };
            scope.$watch(':: list', function () {
                scope.values = lodash_1.default.keyBy(scope.list, 'qcode');
            });
            // UI binding assignment only if we are editing a content profile (NOT in authoring header or other places)
            if (scope.containingDirective === 'sdContentSchemaEditor') {
                scope.item[scope.field] = scope.item.default;
            }
            scope.$applyAsync(function () {
                if (scope.list) {
                    if (scope.field === 'place') {
                        scope.places = lodash_1.default.groupBy(scope.list, 'group');
                    }
                    else if (scope.field === 'genre') {
                        scope.list = $filter('sortByName')(scope.list);
                    }
                }
            });
        },
    };
}
MetaTagsDirective.$inject = ['api', '$timeout'];
function MetaTagsDirective(api, $timeout) {
    var ENTER = 13;
    var ESC = 27;
    return {
        scope: {
            item: '=',
            field: '@',
            sourceField: '@',
            change: '&',
            disabled: '=',
        },
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-tags.html',
        link: function (scope, element) {
            var inputElem = element.find('input')[0];
            scope.adding = false;
            scope.refreshing = false;
            scope.newTag = null;
            scope.tags = null;
            scope.extractedTags = null;
            scope.item[scope.field] = scope.item[scope.field] || [];
            var add = function (tag) {
                scope.tags.push(tag);
                scope.tags = lodash_1.default.uniq(scope.tags);
                scope.toggle(tag);
                cancel();
            };
            var cancel = function () {
                scope.newTag = null;
                scope.adding = false;
            };
            scope.$watch('adding', function () {
                if (scope.adding) {
                    $timeout(function () {
                        inputElem.focus();
                    }, 0, false);
                }
            });
            scope.key = function ($event) {
                if ($event.keyCode === ENTER && !$event.shiftKey) {
                    add(scope.newTag);
                }
                else if ($event.keyCode === ESC && !$event.shiftKey) {
                    cancel();
                }
            };
            scope.isSelected = function (tag) {
                return scope.item[scope.field].indexOf(tag) !== -1;
            };
            scope.toggle = function (tag) {
                if (!scope.disabled) {
                    if (scope.isSelected(tag)) {
                        lodash_1.default.pull(scope.item[scope.field], tag);
                    }
                    else {
                        scope.item[scope.field].push(tag);
                    }
                    scope.change({ item: scope.item });
                }
            };
            scope.refresh = function () {
                scope.refreshing = true;
                var body = (scope.item[scope.sourceField] || '')
                    .replace(/<br[^>]*>/gi, '&nbsp;')
                    .replace(/(<figcaption\b[^>]*>)[^<>]*(<\/figcaption>)/gi, '')
                    .replace(/<\/?[^>]+>/gi, '')
                    .trim()
                    .replace(/&nbsp;/g, ' ');
                if (body) {
                    api.save('keywords', { text: body })
                        .then(function (result) {
                        scope.extractedTags = lodash_1.default.map(result.keywords, 'text');
                        scope.tags = lodash_1.default.uniq(scope.extractedTags.concat(scope.item[scope.field]));
                        scope.refreshing = false;
                    });
                }
                else {
                    scope.refreshing = false;
                }
            };
            scope.refresh();
        },
    };
}
MetaWordsListDirective.$inject = [];
function MetaWordsListDirective() {
    return {
        scope: {
            item: '=',
            field: '@',
            disabled: '=',
            list: '=',
            change: '&',
            header: '@',
            style: '@',
        },
        template: __webpack_require__(1664),
        link: function (scope, element) {
            scope.words = [];
            scope.selectedTerm = '';
            scope.$applyAsync(function () {
                element.find('input, select').addClass('line-input');
                if (scope.list) {
                    scope.words = scope.list;
                }
            });
            /**
             * sdTypeahead directive invokes this method and is responsible for searching word(s) where the word.name
             * matches wordToFind.
             *
             * @return {Array} list of word(s)
             */
            scope.search = function (wordToFind) {
                if (!wordToFind) {
                    scope.words = scope.list;
                }
                else {
                    scope.words = lodash_1.default.filter(scope.list, function (t) { return t.name.toLowerCase().indexOf(wordToFind.toLowerCase()) !== -1; });
                }
                scope.selectedTerm = wordToFind;
                return scope.words;
            };
            /**
             * sdTypeahead directive invokes this method and is responsible for updating the item with user selected
             * word.
             *
             * @param {Object} item selected word object
             */
            scope.select = function (item) {
                var keyword = item ? item.qcode : scope.selectedTerm;
                var t = lodash_1.default.clone(scope.item[scope.field]) || [];
                var index = lodash_1.default.findIndex(t, function (word) { return word.toLowerCase() === keyword.toLowerCase(); });
                if (index < 0) {
                    t.push(keyword);
                    var o = {};
                    o[scope.field] = t;
                    lodash_1.default.extend(scope.item, o);
                    scope.change({ item: scope.item });
                }
                scope.selectedTerm = '';
            };
            /**
             * Removes the term from the user selected terms
             */
            scope.removeTerm = function (term) {
                var temp = lodash_1.default.without(scope.item[scope.field], term);
                // build object
                var o = {};
                o[scope.field] = temp;
                lodash_1.default.extend(scope.item, o);
                scope.change({ item: scope.item });
            };
        },
    };
}
/**
 * Wraping  'sd-typeahead' directive for editing of metadata list attributes
 *
 * @param {Object} item - specify the content item itself
 * @param {String} field - specify the (metadata) filed under the item which will be edited
 * @param {Boolean} disabled - whether component should be disabled for editing or not
 * @param {Array} list - list of available values that can be added
 * @param {String} unique - specify the name of the field, in list item which is unique (qcode, value...)
 * @param {Boolean} searchUnique - to search unique field as well as name field
 * @param {Boolean} selectEntireCategory - to allow a whole category to be selected (i.e. field without parent)
 *
 */
MetaTermsDirective.$inject = ['metadata', '$filter', '$timeout', 'preferencesService', 'desks'];
function MetaTermsDirective(metadata, $filter, $timeout, preferencesService, desks) {
    return {
        scope: {
            item: '=',
            field: '@',
            disabled: '=ngDisabled',
            list: '=',
            unique: '@',
            postprocessing: '&',
            change: '&',
            header: '@',
            reloadList: '@',
            cv: '=',
            includeParent: '@',
            tabindex: '=',
            searchUnique: '@',
            setLanguage: '@',
            helperText: '@',
            selectEntireCategory: '@',
        },
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-terms.html',
        link: function (scope, elem, attrs) {
            metadata.subjectScope = scope;
            var reloadList = scope.reloadList === 'true';
            var includeParent = scope.includeParent === 'true';
            var searchUnique = scope.searchUnique === 'true';
            // we want true as default value to keep legacy behaviour
            scope.allowEntireCat = scope.selectEntireCategory !== 'false';
            scope.combinedList = [];
            scope.tree = {};
            scope.termPath = [];
            scope.$watch('unique', function (value) {
                scope.uniqueField = value || 'qcode';
            });
            scope.$watch('list', function (items) {
                if (!items || items.length === 0) {
                    return;
                }
                var tree = {}, updates = {};
                if (scope.cv && scope.cv.dependent) {
                    updates[scope.field] = [];
                }
                angular.forEach(items, function (item) {
                    var parent = item.parent || null;
                    if (!tree.hasOwnProperty(parent)) {
                        tree[parent] = [item];
                    }
                    else {
                        tree[parent].push(item);
                    }
                    // checks for dependent dropdowns to remain selected items if new list has them (not to reset)
                    angular.forEach(scope.item[scope.field], function (selectedItem) {
                        if (scope.cv && scope.cv.dependent) {
                            if (selectedItem.scheme === scope.cv._id) {
                                if (item.name === selectedItem.name) {
                                    updates[scope.field].push(selectedItem);
                                }
                                // this is for subject (which is not dependent)
                            }
                            else if (updates[scope.field].indexOf(selectedItem) === -1) {
                                updates[scope.field].push(selectedItem);
                            }
                        }
                    });
                });
                lodash_1.default.extend(scope.item, updates);
                scope.terms = filterSelected(items);
                scope.tree = tree;
                scope.activeTree = tree.null;
                scope.combinedList = lodash_1.default.union(scope.list, scope.item[scope.field] ? scope.item[scope.field] : []);
                setPreferredItems();
            });
            scope.$watch('item[field]', function (selected) {
                if (!selected) {
                    scope.selectedItems = [];
                    return;
                }
                scope.terms = filterSelected(scope.list);
                if (lodash_1.default.get(scope, 'cv._id')) { // filter out items from current cv
                    scope.selectedItems = selected.filter(function (term) { return term.scheme === (scope.cv._id || scope.cv.id); });
                }
                else {
                    scope.selectedItems = selected.filter(function (term) { return !term.scheme || term.scheme === scope.field; });
                }
            });
            scope.$on('$destroy', function () {
                metadata.subjectScope = null;
            });
            scope.openParent = function (term, $event) {
                var _a;
                var parent = lodash_1.default.find(scope.list, (_a = {}, _a[scope.uniqueField] = term.parent, _a));
                scope.openTree(parent, $event);
            };
            scope.openTree = function (term, $event) {
                if ($event.altKey) {
                    var activeTree = scope.tree[term ? term[scope.uniqueField] : null];
                    return angular.forEach(activeTree, function (_term) {
                        scope.selectTerm(_term, $event);
                    });
                }
                scope.activeTerm = term;
                scope.termPath.push(term);
                scope.activeTree = scope.tree[term ? term[scope.uniqueField] : null];
                $event.stopPropagation();
                lodash_1.default.defer(function () {
                    var el = elem.find('button:not([disabled]):not(.dropdown__toggle)');
                    if (typeof el === 'object'
                        && el != null
                        && typeof el[0] === 'object'
                        && typeof el[0].focus === 'function') {
                        el[0].focus();
                    }
                });
                scope.activeList = false;
            };
            scope.isSelected = function (term) { return !!lodash_1.default.find(scope.item[scope.field], term); };
            scope.activeList = false;
            scope.selectedTerm = '';
            scope.searchTerms = function (term) {
                if (!term) {
                    scope.terms = filterSelected(scope.list);
                    scope.activeList = false;
                }
                else {
                    var searchList;
                    if (!scope.allowEntireCat) {
                        searchList = lodash_1.default.filter(scope.list, function (item) { return !item.parent; });
                    }
                    else {
                        searchList = reloadList ? scope.list : scope.combinedList;
                    }
                    scope.terms = $filter('sortByName')(lodash_1.default.filter(filterSelected(searchList), function (t) {
                        var searchObj = {};
                        searchObj[scope.uniqueField] = t[scope.uniqueField];
                        if (searchUnique) {
                            return (t.name.toLowerCase().indexOf(term.toLowerCase()) !== -1 ||
                                t[scope.uniqueField].toLowerCase().indexOf(term.toLowerCase()) !== -1) &&
                                !lodash_1.default.find(scope.item[scope.field], searchObj);
                        }
                        return t.name.toLowerCase().indexOf(term.toLowerCase()) !== -1 &&
                            !lodash_1.default.find(scope.item[scope.field], searchObj);
                    }));
                    scope.activeList = true;
                }
                return scope.terms;
            };
            function filterSelected(terms) {
                var selected = {};
                angular.forEach(scope.item[scope.field], function (term) {
                    if (term) {
                        selected[term[scope.uniqueField]] = 1;
                    }
                });
                return lodash_1.default.filter(terms, function (term) { return term && !selected[term[scope.uniqueField]]; });
            }
            function addTerm(term) {
                if (!term) {
                    return;
                }
                var isSelected = filterSelected([term]).length === 0;
                // Only select terms that are not already selected
                if (!isSelected) {
                    // instead of simple push, extend the item[field] in order to trigger dirty $watch
                    var t = [];
                    if (term.selection_type !== SINGLE_SELECTION) {
                        t = lodash_1.default.clone(scope.item[scope.field]) || [];
                    }
                    if (scope.cv && scope.cv.selection_type === SINGLE_SELECTION) {
                        t = lodash_1.default.filter(t, function (_term) { return _term.scheme !== scope.cv._id; });
                    }
                    // build object
                    var o = {};
                    if (term.language && scope.setLanguage) {
                        o.language = term.language;
                    }
                    t.push(angular.extend({}, term, {
                        scheme: scope.cv ? scope.cv._id : null,
                    }));
                    o[scope.field] = t;
                    lodash_1.default.extend(scope.item, o);
                }
            }
            scope.selectTerm = function (term, $event) {
                if (term) {
                    addTerm(term);
                    if (includeParent) {
                        scope.termPath.forEach(function (_term) {
                            addTerm(_term);
                        });
                    }
                    if ($event && ($event.ctrlKey || $event.metaKey)) {
                        $event.stopPropagation();
                        return;
                    }
                    scope.activeTerm = '';
                    scope.selectedTerm = '';
                    scope.termPath = [];
                    scope.searchTerms();
                    if (!reloadList) {
                        // Remove the selected term from the terms
                        scope.terms = lodash_1.default.without(scope.terms, term);
                        scope.activeTree = scope.terms;
                    }
                    $timeout(function () {
                        scope.$applyAsync(function () {
                            scope.postprocessing();
                            scope.change({ item: scope.item, field: scope.field });
                        });
                    }, 50, false);
                    // retain focus and initialise activeTree on same dropdown control after selection.
                    lodash_1.default.defer(function () {
                        if (!lodash_1.default.isEmpty(elem.find('.dropdown__toggle'))) {
                            elem.find('.dropdown__toggle').focus();
                        }
                        if (reloadList) {
                            scope.activeTerm = null;
                            scope.searchTerms(null);
                            scope.activeTree = scope.tree.null;
                        }
                        else {
                            scope.terms = lodash_1.default.clone(scope.activeTree) || [];
                            scope.allSelected = scope.terms.length === 0;
                        }
                    });
                }
            };
            scope.removeTerm = function (term) {
                var tempItem = {}, subjectCodesArray = scope.item[scope.field], filteredArray = lodash_1.default.without(subjectCodesArray, term);
                if (subjectCodesArray && filteredArray.length === subjectCodesArray.length) {
                    lodash_1.default.remove(filteredArray, { name: term });
                }
                tempItem[scope.field] = filteredArray;
                lodash_1.default.extend(scope.item, tempItem);
                if (!reloadList) {
                    scope.terms.push(term);
                    if (scope.activeTree.find(function (item) { return item.qcode === term.qcode; }) == null) {
                        scope.activeTree.push(term);
                    }
                    scope.activeTree = $filter('sortByName')(scope.activeTree);
                    scope.allSelected = false;
                }
                scope.terms = $filter('sortByName')(scope.terms);
                scope.change({ item: scope.item, field: scope.field });
                elem.find('.dropdown__toggle').focus(); // retain focus
            };
            scope.getLocaleName = function (term) {
                if (!term) {
                    return 'None';
                }
                if (term.translations && scope.item.language
                    && term.translations.name[scope.item.language]) {
                    return term.translations.name[scope.item.language];
                }
                return term.name;
            };
            scope.setPreferredView = function (view, $event) {
                scope.preferredView = view;
                $event.stopPropagation();
                if (scope.activeTerm) {
                    scope.openParent({}, $event);
                }
            };
            function setPreferredItems() {
                scope.preferredView = null;
                scope.userPreferredItems = [];
                scope.deskPreferredItems = [];
                if (lodash_1.default.get(scope, 'cv._id')) {
                    preferencesService.get('cvs:preferred_items').then(function (prefered) {
                        var userPrefs = lodash_1.default.get(prefered, 'value', {});
                        var deskPrefs = lodash_1.default.get(desks.getCurrentDesk(), 'preferred_cv_items', {});
                        scope.userPreferredItems = getPreferredItems(userPrefs);
                        scope.deskPreferredItems = getPreferredItems(deskPrefs);
                        if (scope.userPreferredItems.length) {
                            scope.preferredView = 'user';
                        }
                        else if (scope.deskPreferredItems.length) {
                            scope.preferredView = 'desk';
                        }
                    });
                }
            }
            function getPreferredItems(prefs) {
                var preferredItems = lodash_1.default.get(prefs, scope.cv._id, []);
                return preferredItems
                    .map(function (preferedItem) {
                    return scope.list.find(function (item) { return item[scope.uniqueField] === preferedItem[scope.uniqueField]; });
                })
                    .filter(function (item) { return item != null; }); // filter out items missing in cv
            }
            scope.$on('clear: selectedUsageTerms', function (e) {
                scope.selectedItems = [];
                scope.activeTree = scope.tree.null;
                scope.allSelected = false;
            });
        },
    };
}
MetaLocatorsDirective.$inject = ['places'];
function MetaLocatorsDirective(places) {
    return {
        scope: {
            item: '=',
            fieldprefix: '@',
            field: '@',
            disabled: '=ngDisabled',
            change: '&',
            postprocessing: '&',
            header: '@',
            tabindex: '=',
            keepinput: '=',
        },
        controller: function () {
            this.selectedTerm = '';
        },
        controllerAs: '$ctrl',
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-locators.html',
        link: function (scope, element) {
            scope.locators = [];
            scope.$applyAsync(function () {
                if (scope.item) {
                    if (scope.fieldprefix && scope.item[scope.fieldprefix] &&
                        scope.item[scope.fieldprefix][scope.field]) {
                        scope.$ctrl.selectedTerm = scope.item[scope.fieldprefix][scope.field].city;
                    }
                    else if (scope.item[scope.field]) {
                        scope.$ctrl.selectedTerm = scope.item[scope.field].city;
                    }
                }
                if (scope.list) {
                    setLocators(scope.list);
                }
            });
            function setLocators(list) {
                scope.locators = list.slice(0, 10);
                scope.total = list.length;
                return scope.locators;
            }
            // update visible city on some external change, like after undo/redo
            scope.$watch('item[fieldprefix][field].city || item[field].city', function (located) {
                scope.$ctrl.selectedTerm = located;
            });
            /**
             * sdTypeahead directive invokes this method and is responsible for searching located object(s) where the
             * city name matches locatorToFind.
             *
             * @return {Array} list of located object(s)
             */
            scope.searchLocator = function (locatorToFind) {
                scope.$ctrl.selectedTerm = locatorToFind;
                scope.loading = true;
                return places.searchDateline(locatorToFind, scope.item.language)
                    .then(setLocators)
                    .finally(function () {
                    scope.$applyAsync(function () {
                        scope.loading = false;
                    });
                });
            };
            /**
             * sdTypeahead directive invokes this method and is responsible for updating the item with user selected
             * located object.
             *
             * @param {Object} locator user selected located object
             */
            scope.selectLocator = function (locator) {
                var updates = {};
                var loc = locator;
                if (!loc && scope.$ctrl.selectedTerm) {
                    var previousLocator = scope.fieldprefix ? scope.item[scope.fieldprefix][scope.field] :
                        scope.item[scope.field];
                    if (previousLocator && scope.$ctrl.selectedTerm === previousLocator.city) {
                        loc = previousLocator;
                    }
                    else {
                        loc = { city: scope.$ctrl.selectedTerm, city_code: scope.$ctrl.selectedTerm, tz: 'UTC',
                            dateline: 'city', country: '', country_code: '', state_code: '', state: '' };
                    }
                }
                if (loc) {
                    if (angular.isDefined(scope.fieldprefix)) {
                        if (!angular.isDefined(scope.item[scope.fieldprefix])) {
                            lodash_1.default.extend(scope.item, { dateline: {} });
                        }
                        updates[scope.fieldprefix] = scope.item[scope.fieldprefix];
                        updates[scope.fieldprefix][scope.field] = loc;
                    }
                    else {
                        updates[scope.field] = loc;
                    }
                    scope.$ctrl.selectedTerm = loc.city;
                    lodash_1.default.extend(scope.item, updates);
                }
                var selectedLocator = { item: scope.item, city: scope.$ctrl.selectedTerm };
                scope.postprocessing(selectedLocator);
                scope.change(selectedLocator);
            };
        },
    };
}
MetadataService.$inject = ['api', 'subscribersService', 'config', 'vocabularies', '$rootScope', 'session', '$filter'];
function MetadataService(api, subscribersService, config, vocabularies, $rootScope, session, $filter) {
    var service = {
        values: {},
        helper_text: {},
        popup_width: {},
        single_value: {},
        cvs: [],
        search_cvs: config.search_cvs || [
            { id: 'subject', name: 'Subject', field: 'subject', list: 'subjectcodes' },
            { id: 'companycodes', name: 'Company Codes', field: 'company_codes', list: 'company_codes' },
        ],
        search_config: config.search || {
            slugline: 1, headline: 1, unique_name: 1, story_text: 1, byline: 1,
            keywords: 1, creator: 1, from_desk: 1, to_desk: 1, spike: 1,
            scheduled: 1, company_codes: 1, ingest_provider: 1, marked_desks: 1,
            featuremedia: 1,
        },
        subjectScope: null,
        loaded: null,
        _urgencyByValue: {},
        _priorityByValue: {},
        fetchMetadataValues: function () {
            var self = this;
            return vocabularies.getAllActiveVocabularies().then(function (result) {
                lodash_1.default.each(result, function (vocabulary) {
                    self.values[vocabulary._id] = vocabulary.items;
                    if (lodash_1.default.has(vocabulary, 'helper_text')) {
                        self.helper_text[vocabulary._id] = vocabulary.helper_text;
                    }
                    if (lodash_1.default.has(vocabulary, 'popup_width')) {
                        self.popup_width[vocabulary._id] = vocabulary.popup_width;
                    }
                    if (lodash_1.default.has(vocabulary, 'selection_type')) {
                        self.single_value[vocabulary._id] = vocabulary.selection_type === SINGLE_SELECTION;
                    }
                });
                self.cvs = result;
                self.values.regions = lodash_1.default.sortBy(self.values.geographical_restrictions, function (target) { return target.value && target.value.toLowerCase() === 'all' ? '' : target.name; });
                self.values.subscriberTypes = lodash_1.default.sortBy(self.values.subscriber_types, function (target) { return target.value && target.value.toLowerCase() === 'all' ? '' : target.name; });
                if (self.values.urgency) {
                    self._urgencyByValue = lodash_1.default.keyBy(self.values.urgency, 'qcode');
                }
                if (self.values.priority) {
                    self._priorityByValue = lodash_1.default.keyBy(self.values.priority, 'qcode');
                }
            });
        },
        fetchSubscribers: function () {
            var self = this;
            self.values.customSubscribers = [];
            return subscribersService.fetchTargetableSubscribers().then(function (items) {
                lodash_1.default.each(items, function (item) {
                    self.values.customSubscribers.push({ _id: item._id, name: item.name });
                });
            });
        },
        fetchSubjectcodes: function (code) {
            var self = this;
            return api.get('/subjectcodes').then(function (result) {
                self.values.subjectcodes = result._items;
            });
        },
        fetchAuthors: function (code) {
            var self = this;
            self.values.authors = [];
            return api.getAll('users', { is_author: 1 }).then(function (users) {
                var first;
                lodash_1.default.each(users, function (user) {
                    var authorMetadata = { _id: user._id, name: user.display_name, user: user };
                    if (session.identity.is_author && user._id === session.identity._id) {
                        // we want logged user to appear first
                        first = authorMetadata;
                    }
                    else {
                        self.values.authors.push(authorMetadata);
                    }
                    lodash_1.default.each(self.values.author_roles, function (role) {
                        self.values.authors.push({
                            _id: [user._id, role.qcode],
                            role: role.qcode,
                            name: role.name,
                            parent: user._id,
                            sub_label: user.display_name
                        });
                    });
                });
                self.values.authors = $filter('sortByName')(self.values.authors);
                if (first) {
                    self.values.authors.unshift(first);
                }
            });
        },
        removeSubjectTerm: function (term) {
            if (!this.subjectScope) {
                return;
            }
            var self = this, tempItem = {};
            angular.forEach(this.search_cvs || [], function (cv) {
                if (lodash_1.default.isNil(term)) { // clear subject scope
                    self.subjectScope.item[cv.id].length = 0;
                }
                else {
                    var subjectCodesArray = self.subjectScope.item[cv.id], filteredArray = lodash_1.default.without(subjectCodesArray, term);
                    if (filteredArray.length === subjectCodesArray.length) {
                        lodash_1.default.remove(filteredArray, { name: term });
                    }
                    tempItem[cv.id] = filteredArray;
                }
            });
            lodash_1.default.extend(self.subjectScope.item, tempItem);
            self.subjectScope.change({ item: self.subjectScope.item });
        },
        fetchCities: function () {
            var self = this;
            if (!self.citiesPromise) {
                self.citiesPromise = api.get('/cities').then(function (result) {
                    self.values.cities = result._items;
                    return self.values.cities;
                });
            }
            return self.citiesPromise;
        },
        fetchAgendas: function () {
            var self = this;
            if ($rootScope.features.agenda) {
                return api.get('/agenda').then(function (result) {
                    var agendas = [];
                    lodash_1.default.each(result._items, function (item) {
                        if (item.is_enabled) {
                            agendas.push({ name: item.name, id: item._id, qcode: item.name });
                        }
                    });
                    self.values.agendas = agendas;
                });
            }
        },
        fetchEventsPlanningFilters: function () {
            var self = this;
            if ($rootScope.features.events_planning_filters) {
                return api.get('/events_planning_filters').then(function (result) {
                    self.values.eventsPlanningFilters = lodash_1.default.get(result, '_items', [])
                        .map(function (item) { return ({ name: item.name, qcode: item._id }); });
                });
            }
        },
        getFilteredCustomVocabularies: function (qcodes) {
            var _this = this;
            return this.fetchMetadataValues().then(function () { return _this.cvs.filter(function (cv) {
                var cvService = cv.service || {};
                if (cvService.all) {
                    cv.terms = (cv.items || []).filter(function (item) {
                        if (item.service) {
                            return qcodes.some(function (qcode) { return !!item.service[qcode]; });
                        }
                        else {
                            return true;
                        }
                    });
                    return true;
                }
                else {
                    cv.terms = cv.items;
                    return qcodes.some(function (qcode) { return !!cvService[qcode]; });
                }
            }); });
        },
        /**
         * Get custom vocabularies for selected services, used in authoring
         *
         * @param {Array} qcodes - selected service qcodes
         * @param {Object} editor
         * @param {Object} schema
         * @return {Array}
         */
        getCustomVocabulariesForArticleHeader: function (qcodes, editor, schema) {
            return this.getFilteredCustomVocabularies(qcodes)
                .then(function (cvs) { return cvs.filter(function (cv) { return cv.terms.length && (editor[cv._id] || schema[cv._id]); }); });
        },
        /**
         * Get all available custom vocabularies, used in content profile editor
         *
         * @param {Ojbect} editor
         * @param {Object} schema
         * @return {Array}
         */
        getAllCustomVocabulariesForArticleHeader: function (editor, schema) {
            var _this = this;
            return this.fetchMetadataValues().then(function () {
                var customVocabulariesForArticleHeader = _this.cvs.filter(function (cv) { return cv.items.length && cv.service && (editor[cv._id] || schema[cv._id]); });
                var customTextAndDateVocabularies = _this.cvs.filter(function (cv) { return cv.field_type === 'text' || cv.field_type === 'date'; });
                return { customVocabulariesForArticleHeader: customVocabulariesForArticleHeader, customTextAndDateVocabularies: customTextAndDateVocabularies };
            });
        },
        initialize: function () {
            if (!this.loaded) {
                this.loaded = this.fetchMetadataValues()
                    .then(angular.bind(this, this.fetchSubjectcodes))
                    .then(angular.bind(this, this.fetchAuthors))
                    .then(angular.bind(this, this.fetchSubscribers))
                    .then(angular.bind(this, this.fetchCities))
                    .then(angular.bind(this, this.fetchAgendas))
                    .then(angular.bind(this, this.fetchEventsPlanningFilters));
            }
            return this.loaded;
        },
        urgencyByValue: function (value) {
            return this._urgencyByValue[value] || null;
        },
        priorityByValue: function (value) {
            return this._priorityByValue[value] || null;
        },
    };
    $rootScope.$on('subscriber:create', function () { return service.fetchSubscribers(); });
    $rootScope.$on('subscriber:update', function () { return service.fetchSubscribers(); });
    // add new cvs to the list when created
    $rootScope.$on('vocabularies:created', function (event, data) {
        api.find('vocabularies', data.vocabulary_id).then(function (cv) {
            service.cvs = service.cvs.concat([cv]);
        });
    });
    // update cv on change
    $rootScope.$on('vocabularies:updated', function (event, data) {
        api.find('vocabularies', data.vocabulary_id).then(function (cv) {
            service.cvs = service.cvs.map(function (_cv) { return _cv._id === cv._id ? cv : _cv; });
        });
    });
    return service;
}
MetadataListItem.$inject = [];
function MetadataListItem() {
    return {
        scope: {
            label: '=',
        },
        transclude: true,
        templateUrl: 'scripts/apps/authoring/metadata/views/metadata-list-item.html',
    };
}
angular.module('superdesk.apps.authoring.metadata', [
    'superdesk.apps.authoring.widgets',
    'superdesk.apps.publish',
    'superdesk.apps.vocabularies',
    'vs-repeat',
])
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('metadata', {
            icon: 'info',
            label: utils_1.gettext('Info'),
            removeHeader: true,
            template: 'scripts/apps/authoring/metadata/views/metadata-widget.html',
            order: 1,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: true,
                archived: true,
                picture: true,
                personal: true,
            },
        });
    }])
    .controller('MetadataWidgetCtrl', MetadataCtrl)
    .service('metadata', MetadataService)
    .service('places', PlacesService_1.default)
    .directive('sdMetaTarget', MetaTargetedPublishingDirective)
    .directive('sdMetadataListItem', MetadataListItem)
    .directive('sdMetaTerms', MetaTermsDirective)
    .directive('sdMetaTags', MetaTagsDirective)
    .directive('sdMetaDropdown', MetaDropdownDirective)
    .directive('sdMetaWordsList', MetaWordsListDirective)
    .directive('sdMetadropdownFocus', MetadropdownFocusDirective)
    .directive('sdMetaLocators', MetaLocatorsDirective)
    .directive('sdPreferedCvItemsConfig', PreferedCvItemsConfigDirective_1.default)
    .directive('sdMetaPlace', MetaPlaceDirective_1.default);


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PreferedCvItemsConfigDirective.$inject = ['metadata'];
function PreferedCvItemsConfigDirective(metadata) {
    return {
        template: __webpack_require__(1660),
        scope: true,
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            ngModel.$render = function () {
                scope.updates = ngModel.$viewValue || {};
            };
            scope.updateModel = function () {
                ngModel.$setViewValue(Object.assign({}, scope.updates), 'change');
                ngModel.$setDirty();
            };
            metadata.initialize().then(function () {
                scope.cvs = metadata.cvs.filter(function (cv) { return cv.preffered_items; });
            });
        },
    };
}
exports.default = PreferedCvItemsConfigDirective;


/***/ }),
/* 1660 */
/***/ (function(module, exports) {

module.exports = "<div class=\"prefered-cv-items form__row\" ng-repeat=\"cv in cvs track by cv._id\">\n    <label class=\"form-label\">{{ :: cv.display_name }}</label>\n    <div sd-meta-terms\n        class=\"sd-line-input__select\"\n        data-item=\"updates\"\n        data-field=\"{{ cv._id }}\"\n        data-list=\"cv.items\"\n        data-unique=\"qcode\"\n        data-header=\"true\"\n        data-change=\"updateModel()\"\n        data-reload-list=\"true\"\n    />\n</div>\n<div ng-show=\"cvs.length === 0\" class=\"sd-alert sd-alert--hollow\">\n    <p translate>There are no vocabularies configured.</p>\n</div>\n";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
function getCode(item) {
    return lodash_1.get(item, 'code', lodash_1.get(item, 'qcode'));
}
MetaPlaceDirective.$inject = ['places'];
function MetaPlaceDirective(places) {
    return {
        scope: {
            item: '=',
            field: '@',
            disabled: '=ngDisabled',
            change: '&',
            tabindex: '=',
            language: '=',
        },
        template: __webpack_require__(1662),
        link: function (scope) {
            scope.terms = [];
            scope.searchTerms = function (name) {
                if (!name) {
                    scope.terms = [];
                    return;
                }
                scope.loading = true;
                places.searchGeonames(name, scope.item.language)
                    .then(function (results) {
                    scope.loading = false;
                    scope.terms = results;
                })
                    .finally(function () {
                    scope.loading = false;
                });
            };
            scope.selectTerm = function (term) {
                if (!getCode(term)) { // when search is in progress and user hits enter this gets called
                    return;
                }
                scope.terms = [];
                if (!scope.item[scope.field]) {
                    scope.item[scope.field] = [];
                }
                if (!scope.item[scope.field].find(function (item) { return getCode(item) === getCode(term); })) {
                    scope.$applyAsync(function () {
                        scope.item[scope.field] = scope.item[scope.field].concat([term]);
                        scope.change({ item: scope.item, field: scope.field });
                    });
                }
            };
            scope.removeTerm = function (term) {
                scope.$applyAsync(function () {
                    scope.item[scope.field] = scope.item[scope.field].filter(function (item) { return getCode(term) !== getCode(item); });
                    scope.change({ item: scope.item, field: scope.field });
                });
            };
        },
    };
}
exports.default = MetaPlaceDirective;


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown dropdown--dropright dropdown-terms\" dropdown sd-dropdown-focus sd-dropdown-position>\n    <button class=\"dropdown__toggle\" dropdown__toggle tabindex=\"{{ tabindex }}\" ng-disabled=\"disabled\" ng-if=\"!disabled\">\n        <i class=\"icon--white icon-plus-large\"></i>\n    </button>\n    <div class=\"dropdown__menu nested-menu pull-right\" sd-loading=\"loading\">\n        <div sd-typeahead\n            items=\"terms\"\n            term=\"selectedTerm\"\n            search=\"searchTerms(term)\"\n            select=\"selectTerm(item)\"\n            always-visible=\"true\"\n            data-disabled=\"disabled\"\n            data-debounce=\"1000\"\n        >\n            <ul class=\"item-list\">\n                <li typeahead-item=\"t\" ng-repeat=\"t in terms track by t.code\"j>\n                    <button>{{ :: t.name }} ({{ :: [t.state, t.country_code] | join }})\n                        <span ng-if=\"t.feature_class === 'A'\">\n                            <small ng-show=\"t.state\" class=\"label label--hollow\" translate>state, region, ...</small>\n                            <small ng-show=\"!t.state\" class=\"label label--hollow\" translate>country</small>\n                        </span>\n                    </button>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n\n<div class=\"terms-list\" ng-if=\"item[field].length\">\n    <ul>\n        <li ng-if=\"!disabled\" class=\"pull-left\"\n            ng-repeat=\"t in item[field]\"\n            ng-click=\"removeTerm(t)\">{{ t.name }} <i class=\"icon-close-small\"></i></li>\n        <li ng-if=\"disabled\" class=\"pull-left disabled\"\n            ng-repeat=\"t in item[field]\">{{ t.name }}</li>\n    </ul>\n</div>\n";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
PlacesServiceFactory.$inject = ['api', 'features', 'metadata'];
function PlacesServiceFactory(api, features, metadata) {
    var geonameToCity = function (data) { return ({
        dateline: 'city',
        country_code: data.country_code,
        tz: data.tz,
        city_code: data.name,
        state_code: data.state_code,
        state: data.state,
        city: data.name,
        country: data.country,
        code: data.code,
        scheme: data.scheme,
    }); };
    var PlacesService = /** @class */ (function () {
        function PlacesService() {
        }
        PlacesService.prototype.searchDateline = function (query, lang) {
            var _this = this;
            return this._searchGeonames(query, lang, true)
                .then(function (geonames) { return geonames.map(geonameToCity); })
                .catch(function () { return _this._searchCities(query); });
        };
        PlacesService.prototype.searchGeonames = function (query, lang) {
            return this._searchGeonames(query, lang);
        };
        PlacesService.prototype._searchCities = function (name) {
            return metadata.fetchCities().then(function (cities) {
                return name != null && name.length
                    ? cities.filter(function (t) { return t.city.toLowerCase().indexOf(name.toLowerCase()) !== -1; })
                    : cities;
            });
        };
        PlacesService.prototype._searchGeonames = function (name, lang, dateline) {
            if (dateline === void 0) { dateline = false; }
            var params = { name: name, lang: lang };
            if (name == null || name.length === 0) {
                return Promise.resolve([]);
            }
            if (dateline) {
                params['style'] = 'full';
                params['featureClass'] = 'P';
            }
            return features.places_autocomplete
                ? api.query('places_autocomplete', params)
                    .then(function (response) { return response._items.map(function (place) { return lodash_1.omit(place, ['_created', '_updated', '_etag']); }); })
                : Promise.reject();
        };
        return PlacesService;
    }());
    return new PlacesService();
}
exports.default = PlacesServiceFactory;


/***/ }),
/* 1664 */
/***/ (function(module, exports) {

module.exports = "<div class=\"term-editor data visible\" ng-show=\"header\">\n    <div sd-typeahead items=\"words\" term=\"selectedTerm\" search=\"search(term)\" select=\"select(item)\" data-disabled=\"disabled\" data-style=\"style\">\n        <ul>\n            <li typeahead-item=\"t\" ng-repeat=\"t in words\">\n                {{ :: t.name}}\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"terms terms-list\" ng-if=\"item[field].length\">\n    <ul>\n        <li ng-if=\"!disabled\" ng-repeat=\"t in item[field] track by t\" ng-click=\"removeTerm(t)\">{{ t}}<i class=\"icon-close-small\"></i></li>\n        <li ng-if=\"disabled\" ng-repeat=\"t in item[field] track by t\">{{ t}}</li>\n    </ul>\n</div>";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var superdesk_ui_framework_1 = __webpack_require__(59);
var translationsWidget_1 = __webpack_require__(1666);
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.authoring.translations', [
    'superdesk.apps.authoring.widgets',
])
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('translations', {
            icon: 'web',
            label: utils_1.gettext('Translations'),
            template: 'scripts/apps/authoring/translations/views/translations-widget.html',
            order: 7,
            side: 'right',
            isWidgetVisible: function (item) { return ['TranslationService', function (TranslationService) {
                    return new Promise(function (resolve) {
                        if (TranslationService.translationsEnabled() !== true) {
                            resolve(false);
                            return;
                        }
                        TranslationService.getTranslations(item)
                            .then(function (result) {
                            resolve(result._items.length > 0);
                        })
                            .catch(function () {
                            resolve(false);
                        });
                    });
                }]; },
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: true,
                archived: true,
                picture: true,
                personal: true,
            },
        });
    }])
    .component('translationsWidget', superdesk_ui_framework_1.reactToAngular1(translationsWidget_1.TranslationsWidget, ['item']));


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var relativeDate_1 = __webpack_require__(381);
var state_1 = __webpack_require__(559);
var ReactRenderAsync_1 = __webpack_require__(54);
var utils_1 = __webpack_require__(3);
var TranslationsWidgetComponent = /** @class */ (function (_super) {
    __extends(TranslationsWidgetComponent, _super);
    function TranslationsWidgetComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            translations: null,
            translationsLookup: null,
        };
        return _this;
    }
    TranslationsWidgetComponent.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, item = _a.item, TranslationService = _a.TranslationService;
        TranslationService.getTranslations(item)
            .then(function (response) {
            var translations = response._items;
            _this.setState({
                translations: translations,
                translationsLookup: translations.reduce(function (result, reference) {
                    result[reference._id] = reference;
                    return result;
                }, {}),
            });
        });
    };
    TranslationsWidgetComponent.prototype.render = function () {
        var _a = this.props, $filter = _a.$filter, authoringWorkspace = _a.authoringWorkspace, datetime = _a.datetime;
        var _b = this.state, translations = _b.translations, translationsLookup = _b.translationsLookup;
        if (translations == null) {
            return null;
        }
        var sortOldestFirst = function (a, b) {
            return new Date(b.firstcreated) > new Date(a.firstcreated) ? -1 : 1;
        };
        var listClassNames = 'sd-list-item__column sd-list-item__column--grow sd-list-item__column--no-border';
        return (react_1.default.createElement("div", { className: "widget" }, translations.sort(sortOldestFirst).map(function (translation) { return (react_1.default.createElement("div", { key: translation._id, onClick: function () { return authoringWorkspace.popup(translation, 'edit'); }, className: "sd-list-item sd-shadow--z1", style: { marginBottom: 6 } },
            react_1.default.createElement("div", { className: listClassNames },
                react_1.default.createElement("div", { className: "sd-list-item__row" },
                    react_1.default.createElement("span", { className: "label" }, translation.language),
                    react_1.default.createElement("span", { className: "sd-overflow-ellipsis sd-list-item--element-grow" }, translation.headline),
                    react_1.default.createElement("span", { style: { whiteSpace: 'nowrap' } },
                        react_1.default.createElement(relativeDate_1.RelativeDate, { datetime: translation.versioncreated }))),
                react_1.default.createElement("div", { className: "sd-list-item__row" },
                    react_1.default.createElement("div", { className: "sd-list-item--element-grow" }, translation.translated_from == null
                        ? (react_1.default.createElement("span", { className: "label label--primary label--hollow" }, utils_1.gettext('Original')))
                        : (react_1.default.createElement("div", { className: "flex-bar sibling-spacer-4" },
                            react_1.default.createElement("span", null, utils_1.gettext('Translated from')),
                            react_1.default.createElement("span", { className: "label label--hollow" }, translationsLookup[translation.translated_from].language)))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(state_1.state, { "$filter": $filter, datetime: datetime, item: translation, style: { marginRight: 0 } })))))); })));
    };
    return TranslationsWidgetComponent;
}(react_1.default.Component));
exports.TranslationsWidget = ReactRenderAsync_1.connectServices(TranslationsWidgetComponent, ['TranslationService', 'authoringWorkspace', '$filter', 'datetime']);


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(247);
/**
 * This file is part of Superdesk.
 *
 * Copyright 2015 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
WorkqueueService.$inject = ['session', 'api'];
function WorkqueueService(session, api) {
    this.items = [];
    /**
     * Get all items locked by current user
     */
    this.fetch = function () {
        return session.getIdentity()
            .then(angular.bind(this, function (identity) {
            var query = {
                source: {
                    query: {
                        bool: {
                            must: [
                                { term: { lock_user: identity._id } },
                                { terms: { lock_action: ['edit', 'correct', 'kill'] } },
                            ],
                        },
                    },
                },
                auto: 1,
            };
            return api.query('workqueue', query)
                .then(angular.bind(this, function (res) {
                this.items = null;
                this.items = res._items || [];
                return this.items;
            }));
        }));
    };
    /**
     * Update given item
     */
    this.updateItem = function (itemId) {
        var old = lodash_1.find(this.items, { _id: itemId });
        if (old) {
            return api.find('archive', itemId).then(function (item) { return angular.extend(old, item); });
        }
    };
}
WorkqueueCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$route',
    'workqueue',
    'authoringWorkspace',
    'multiEdit',
    'lock',
    '$location',
    'session',
    'authoring',
    'autosave',
    'confirm',
    'referrer',
    'notify',
];
function WorkqueueCtrl($scope, $rootScope, $route, workqueue, authoringWorkspace, multiEdit, lock, $location, session, authoring, autosave, confirm, referrer, notify) {
    $scope.active = null;
    $scope.workqueue = workqueue;
    $scope.multiEdit = multiEdit;
    $scope.$on('content:update', function (_e, data) {
        // only update the workqueue for content:update items in the workqueue
        if (data && data.items) {
            var updateItems = lodash_1.keys(data.items);
            if (updateItems.length) {
                var item = lodash_1.find(workqueue.items, function (_item) { return lodash_1.includes(updateItems, _item._id); });
                if (item) {
                    updateWorkqueue();
                }
            }
        }
    });
    $scope.$on('item:lock', function (_e, data) {
        // Update Workqueue only if the user has locked an item.
        if (data && data.user === session.identity._id) {
            updateWorkqueue(_e, data);
        }
    });
    $scope.$on('item:unlock', function (_e, data) {
        var item = workqueue.items.find(function (_item) { return _item._id === data.item; });
        if (item && lock.isLocked(item) && session.sessionId !== data.lock_session && $scope.active !== item) {
            authoring.unlock(item, data.user, item.headline);
        }
        if (item && item.linked_in_packages) {
            lodash_1.each(item.linked_in_packages, function (_item) {
                var pck = lodash_1.find(workqueue.items, { _id: _item.package });
                if (pck) {
                    authoringWorkspace.edit(pck);
                }
            });
        }
        if (item) {
            updateWorkqueue();
        }
    });
    $scope.$on('media_archive', function (e, data) {
        workqueue.updateItem(data.item);
    });
    updateWorkqueue();
    /**
     * Update list of opened items and set one active to currently opened item
     */
    function updateWorkqueue(e, data) {
        workqueue.fetch().then(function () {
            var route = $route.current || { _id: null, params: {} };
            $scope.isMultiedit = route._id === 'multiedit';
            $scope.active = null;
            var currentItemId = data && data.item ? data.item : route.params.item;
            if (currentItemId) {
                $scope.active = lodash_1.find(workqueue.items, { _id: currentItemId });
            }
        });
    }
    $scope.openDashboard = function () {
        $scope.dashboardActive = true;
    };
    $scope.closeDashboard = function () {
        $scope.dashboardActive = false;
    };
    /**
     * Closes item. If item is opened, close authoring workspace.
     * Updates multiedit items, if item is part of multiedit.
     * When closing last item that was in multiedit(no more items in multiedit), redirects to monitoring.
     * if there autosave version then open dialog to prompt the user to save.
     */
    $scope.closeItem = function (item) {
        autosave.get(item)
            .then(function (result) { return confirm.reopen(); })
            .then(function (reopen) {
            _reOpenItem(item);
        }, function (err) {
            if (angular.isDefined(err)) {
                // confirm dirty checking for current item just incase if it's before autosaved.
                if (confirm.dirty && $scope.active && $scope.active._id === item._id) {
                    return confirm.reopen().then(function (reopen) {
                        _reOpenItem(item);
                    });
                }
            }
            _closeItem(item);
        });
    };
    function _reOpenItem(item) {
        if ($scope.active && $scope.active._id !== item._id || !$scope.active && item) {
            authoringWorkspace.edit(item);
            $scope.active = item;
        }
        $scope.dashboardActive = false;
    }
    function _closeItem(item) {
        lock.unlock(item)
            .then(function () {
            if (authoringWorkspace.item && item._id === authoringWorkspace.item._id) {
                authoringWorkspace.close(true);
            }
            multiEdit.items = lodash_1.without(multiEdit.items, lodash_1.find(multiEdit.items, { article: item._id }));
            if (multiEdit.items.length === 0) {
                $scope.redirectOnCloseMulti();
            }
        })
            .catch(function (err) {
            var message = lodash_1.get(err, 'data._message') || constants_1.getGenericErrorMessage();
            notify.error(message);
        });
    }
    $scope.openMulti = function () {
        $scope.isMultiedit = true;
        updateWorkqueue();
        multiEdit.open();
    };
    /**
     * Close multiedit.
     */
    $scope.closeMulti = function () {
        multiEdit.exit();
        $scope.redirectOnCloseMulti();
    };
    /**
     * If multi edit screen is opened, redirect to monitoring.
     */
    $scope.redirectOnCloseMulti = function () {
        if (this.isMultiedit) {
            this.isMultiedit = false;
            $location.url(referrer.getReferrerUrl());
        }
    };
    /*
     * Open article for edit
     */
    $scope.edit = function (item, event) {
        if (!event.ctrlKey) {
            $scope.active = item;
            authoringWorkspace.edit(item, item.lock_action);
            $scope.redirectOnCloseMulti();
            $scope.dashboardActive = false;
            event.preventDefault();
        }
    };
    /**
     * Get relative path to article
     */
    $scope.link = function (item) {
        if (item) {
            return $rootScope.link('authoring', item);
        }
    };
}
function WorkqueueListDirective() {
    return {
        templateUrl: 'scripts/apps/authoring/views/opened-articles.html',
        controller: 'Workqueue',
    };
}
function ArticleDashboardDirective() {
    return {
        templateUrl: 'scripts/apps/authoring/views/dashboard-articles.html',
        scope: {
            closeDashboard: '&closeDashboard',
            _edit: '&edit',
            _closeItem: '&closeItem',
            _link: '&link',
            active: '=active',
            items: '=items',
        },
        link: function (scope, elem, attrs) {
            scope.closeItem = function (item) {
                scope._closeItem({ item: item });
            };
            scope.edit = function (item, event) {
                scope._edit({ item: item, event: event });
            };
            scope.link = function (item) {
                scope._link({ item: item });
            };
        },
    };
}
angular.module('superdesk.apps.authoring.workqueue', [
    'superdesk.core.activity',
    'superdesk.apps.notification',
    'superdesk.apps.authoring.multiedit',
    'superdesk.apps.authoring.compare_versions',
])
    .service('workqueue', WorkqueueService)
    .controller('Workqueue', WorkqueueCtrl)
    .directive('sdWorkqueue', WorkqueueListDirective)
    .directive('sdDashboardArticles', ArticleDashboardDirective);


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
PackagesCtrl.$inject = ['$scope', 'superdesk', 'api', 'search'];
function PackagesCtrl($scope, superdesk, api, search) {
    $scope.contentItems = [];
    function fetchPackages() {
        var query = search.query();
        query.clear_filters();
        var filter = [];
        lodash_1.default.forEach($scope.item.linked_in_packages, function (packageRef) {
            filter.push(packageRef.package);
        });
        query.size(25).filter({ terms: { guid: filter } });
        var criteria = query.getCriteria(true);
        criteria.repo = 'archive,published';
        api.query('search', criteria)
            .then(function (result) {
            $scope.contentItems = lodash_1.default.uniqBy(result._items, '_id');
        });
    }
    $scope.openPackage = function (packageItem) {
        if (packageItem._type === 'published') {
            superdesk.intent('view', 'item', packageItem);
        }
        else {
            superdesk.intent('edit', 'item', packageItem);
        }
    };
    if ($scope.item && $scope.item.linked_in_packages && $scope.item.linked_in_packages.length > 0) {
        fetchPackages();
    }
}
exports.default = angular.module('superdesk.apps.authoring.packages', ['superdesk.apps.authoring.widgets'])
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('packages', {
            icon: 'package',
            label: utils_1.gettext('Packages'),
            template: 'scripts/apps/authoring/packages/views/packages-widget.html',
            order: 5,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: true,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: false,
            },
        });
    }])
    .controller('PackagesWidgetCtrl', PackagesCtrl);


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/apps/license
 */
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
FindReplaceDirective.$inject = ['editorResolver', 'macros'];
/**
 * using directive here so that it can return focus
 */
function FindReplaceDirective(editorResolver, macros) {
    return {
        link: function (scope, elem) {
            var editor = editorResolver.get();
            scope.to = '';
            scope.from = '';
            scope.caseSensitive = true;
            // stop macros find/replace
            macros.diff = null;
            /**
             * Highlight next matching string
             */
            scope.next = function () {
                editor.selectNext();
            };
            /**
             * Highlight previous matching string
             */
            scope.prev = function () {
                editor.selectPrev();
            };
            /**
             * Replace currently highlighted matching string with text
             */
            scope.replace = function () {
                editor.replace(scope.to || '');
                editor.selectNext();
            };
            /**
             * Replace all matching string with text
             */
            scope.replaceAll = function () {
                editor.replaceAll(scope.to || '');
            };
            scope.$watch('from', function (needle) {
                var input = document.getElementById('find-replace-what');
                var selectionStart = input.selectionStart;
                var selectionEnd = input.selectionEnd;
                editor.setSettings({ findreplace: { diff: getDiff(), caseSensitive: scope.caseSensitive } });
                editor.render();
                editor.selectNext();
                input.setSelectionRange(selectionStart, selectionEnd);
            });
            function getDiff() {
                var diff = {};
                diff[scope.from || ''] = scope.to || '';
                return diff;
            }
            scope.$watch('caseSensitive', function (caseSensitive) {
                editor.setSettings({ findreplace: { diff: getDiff(), caseSensitive: caseSensitive } });
                editor.render();
            });
            scope.$on('$destroy', function () {
                editor.setSettings({ findreplace: null });
                editor.render();
            });
        },
    };
}
angular.module('superdesk.apps.authoring.find-replace', ['superdesk.apps.authoring.widgets'])
    .directive('sdFindReplace', FindReplaceDirective)
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('find-replace', {
            icon: 'find-replace',
            label: utils_1.gettext('Find and Replace'),
            template: 'scripts/apps/authoring/editor/views/find-replace.html',
            order: 2,
            side: 'right',
            needEditable: true,
            needUnlock: true,
            display: {
                authoring: true,
                packages: false,
                killedItem: false,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: true,
            },
        });
    }]);


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/**
 * This file is part of Superdesk.
 *
 * Copyright 2015 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var lodash_1 = __importDefault(__webpack_require__(2));
MultieditService.$inject = ['storage', 'superdesk', 'authoringWorkspace', 'referrer', '$location'];
function MultieditService(storage, superdesk, authoringWorkspace, referrer, $location) {
    // 1. Service manages multiedit screen
    // 2. Screen has it's boards, at least 2 of them
    // 3. Every board can be popuplated with one content item
    var MIN_BOARDS = 2;
    var STORAGE_KEY = 'multiedit';
    var saved = storage.getItem(STORAGE_KEY);
    this.items = saved === null ? [] : saved;
    this.minBoards = function () {
        return MIN_BOARDS;
    };
    this.create = function (_ids) {
        var self = this;
        self.items = [];
        if (_ids) {
            lodash_1.default.each(_ids, function (_id) {
                self.items.push(createBoard(_id));
            });
        }
        if (self.items.length < MIN_BOARDS) {
            for (var i = 0; i < MIN_BOARDS - self.items.length; i++) {
                self.items.push(createBoard(null));
            }
        }
        self.updateItems();
        self.open();
    };
    this.exit = function (item) {
        this.items = [];
        this.updateItems();
        $location.url(referrer.getReferrerUrl());
    };
    this.open = function () {
        if (authoringWorkspace.getState()) {
            authoringWorkspace.close(true);
        }
        referrer.setReferrerUrl($location.url());
        superdesk.intent('author', 'multiedit');
    };
    this.updateItems = function () {
        storage.setItem(STORAGE_KEY, this.items);
    };
    this.edit = function (_id, board) {
        if (!this.items[board]) {
            this.items[board] = createBoard(_id);
        }
        else {
            this.items[board].article = _id;
        }
        this.updateItems();
    };
    this.remove = function (_id) {
        lodash_1.default.extend(lodash_1.default.find(this.items, { article: _id }), { article: null });
        this.updateItems();
    };
    this.close = function (board) {
        if (this.items.length > MIN_BOARDS) {
            this.items.splice(board, 1);
            this.updateItems();
        }
    };
    function createBoard(_id) {
        return { article: _id };
    }
}
MultieditController.$inject = ['$scope', 'multiEdit', 'lock', 'workqueue'];
function MultieditController($scope, multiEdit, lock, workqueue) {
    $scope.$watch(function () { return multiEdit.items; }, function (items) {
        $scope.boards = items;
    });
    $scope.minBoards = multiEdit.minBoards();
    $scope.closeBoard = function (board) {
        multiEdit.close(board);
    };
    $scope.closeMulti = function () {
        multiEdit.exit();
    };
}
MultieditDropdownDirective.$inject = ['workqueue', 'multiEdit', '$route'];
function MultieditDropdownDirective(workqueue, multiEdit, $route) {
    return {
        templateUrl: 'scripts/apps/authoring/multiedit/views/sd-multiedit-dropdown.html',
        link: function (scope) {
            scope.current = $route.current.params.item;
            scope.queue = [scope.current];
            scope.$watch(function () { return workqueue.items; }, function (items) {
                scope.items = items;
            });
            scope.toggle = function (_id) {
                if (_id === scope.current) {
                    return false;
                }
                if (scope.selected(_id)) {
                    scope.queue = lodash_1.default.without(scope.queue, _id);
                }
                else {
                    scope.queue.push(_id);
                }
            };
            scope.selected = function (_id) {
                return lodash_1.default.indexOf(scope.queue, _id) !== -1;
            };
            scope.open = function () {
                multiEdit.create(scope.queue);
            };
        },
    };
}
MultieditDropdownInnerDirective.$inject = ['workqueue', 'multiEdit'];
function MultieditDropdownInnerDirective(workqueue, multiEdit) {
    return {
        templateUrl: 'scripts/apps/authoring/multiedit/views/sd-multiedit-inner-dropdown.html',
        link: function (scope, elem, attrs) {
            var workqueueItems = [], multieditItems = [];
            scope.$watch(function () { return multiEdit.items; }, function (items) {
                multieditItems = lodash_1.default.map(multiEdit.items, function (board) { return board.article; });
                filter();
            }, true);
            scope.$watch(function () { return workqueue.items; }, function (items) {
                workqueueItems = items;
                filter();
            });
            function filter() {
                scope.items = lodash_1.default.filter(workqueueItems, function (item) { return lodash_1.default.indexOf(multieditItems, item._id) === -1; });
            }
            scope.open = function (_id) {
                multiEdit.edit(_id, attrs.board);
            };
        },
    };
}
MultieditArticleDirective.$inject = ['authoring', 'multiEdit', 'lock', '$timeout'];
function MultieditArticleDirective(authoring, multiEdit, lock, $timeout) {
    return {
        templateUrl: 'scripts/apps/authoring/multiedit/views/sd-multiedit-article.html',
        scope: { article: '=', focus: '=' },
        link: function (scope, elem) {
            scope.$watch('article', function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    openItem();
                }
            });
            function openItem() {
                authoring.open(scope.article).then(function (item) {
                    scope.origItem = item;
                    scope.item = lodash_1.default.create(item);
                    scope._editable = authoring.isEditable(item);
                    scope.isMediaType = lodash_1.default.includes(['audio', 'video', 'picture', 'graphic'], scope.item.type);
                    if (scope.focus) {
                        $timeout(function () {
                            elem.children().focus();
                        }, 0, false);
                    }
                    scope.isLocked = lock.isLocked(item);
                });
            }
            openItem();
            scope.autosave = function (item) {
                scope.dirty = true;
                authoring.autosave(item, scope.origItem);
            };
            scope.$watch('item.flags', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.item.flags = newValue;
                    scope.origItem.flags = oldValue;
                    scope.dirty = true;
                }
            }, true);
            scope.save = function (item, form) {
                return authoring.save(scope.origItem, item).then(function (res) {
                    if (form) {
                        form.$setPristine();
                    }
                    return res;
                });
            };
            scope.remove = function (item) {
                multiEdit.remove(item._id);
            };
            scope.isPublished = function (item) {
                if (!lodash_1.default.isNil(item)) {
                    return authoring.isPublished(item);
                }
            };
        },
    };
}
MultieditFloatMenuDirective.$inject = ['$document'];
function MultieditFloatMenuDirective($document) {
    return {
        link: function (scope, elem) {
            var open = false;
            elem.bind('click', function (event) {
                if (!open) {
                    event.preventDefault();
                    event.stopPropagation();
                    $('#multiedit-float')
                        .css(getPosition(event.pageX, event.pageY))
                        .show();
                }
                else {
                    $('#multiedit-float').hide();
                }
                open = !open;
            });
            $document.bind('click', closeOnClick);
            scope.$on('$destroy', function () {
                $document.unbind('click', closeOnClick);
                elem.unbind('click');
            });
            function closeOnClick() {
                open = false;
                $('#multiedit-float').hide();
            }
            function getPosition(crdL, crdT) {
                var docHeight = $document.height();
                var docWidth = $document.width();
                var position = {
                    right: docWidth - crdL,
                };
                if (docHeight - crdT < 400) {
                    position.bottom = docHeight - crdT;
                    position.top = 'auto';
                }
                else {
                    position.top = crdT;
                    position.bottom = 'auto';
                }
                return position;
            }
        },
    };
}
angular.module('superdesk.apps.authoring.multiedit', ['superdesk.core.activity', 'superdesk.apps.authoring'])
    .service('multiEdit', MultieditService)
    .directive('sdMultieditDropdown', MultieditDropdownDirective)
    .directive('sdMultieditInnerDropdown', MultieditDropdownInnerDirective)
    .directive('sdMultieditArticle', MultieditArticleDirective)
    .directive('sdMultieditFloatMenu', MultieditFloatMenuDirective)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('multiedit', {
            category: '/authoring',
            href: '/multiedit',
            when: '/multiedit',
            label: utils_1.gettext('Authoring'),
            templateUrl: 'scripts/apps/authoring/multiedit/views/multiedit.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: MultieditController,
            filters: [{ action: 'author', type: 'multiedit' }],
        });
    }]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1672);
var CompareVersionsService_1 = __importDefault(__webpack_require__(1674));
var CompareVersionsController_1 = __importDefault(__webpack_require__(1675));
var directive = __importStar(__webpack_require__(1676));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.authoring.compare_versions
 * @name superdesk.apps.authoring.compare_versions
 * @packageName superdesk.apps
 * @description Superdesk compare_versions module allows to view selected versions of an opened article.
 */
angular.module('superdesk.apps.authoring.compare_versions', ['superdesk.core.activity', 'superdesk.apps.authoring'])
    .service('compareVersions', CompareVersionsService_1.default)
    .directive('sdCompareVersionsInnerDropdown', directive.CompareVersionsDropdownInnerDirective)
    .directive('sdCompareVersionsArticle', directive.CompareVersionsArticleDirective)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('compare-versions', {
            category: '/authoring',
            href: '/compare-versions',
            when: '/compare-versions',
            label: utils_1.gettext('Authoring'),
            templateUrl: 'scripts/apps/authoring/compare-versions/views/compare-versions.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: CompareVersionsController_1.default,
            filters: [{ action: 'author', type: 'compare-versions' }],
        });
    }]);


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1673);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./compare-versions.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./compare-versions.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.close-compare-versions {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  opacity: 0.6;\n  filter: \"alpha(opacity=60)\";\n  background: none;\n  border: 0;\n  padding: 0; }\n  .close-compare-versions:hover {\n    opacity: 0.8;\n    filter: \"alpha(opacity=80)\"; }\n\n.compare-versions-screen {\n  height: 90%;\n  overflow-y: auto; }\n  .compare-versions-screen .boards-list {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0; }\n  .compare-versions-screen .boards-create {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 0;\n    box-sizing: border-box; }\n    .compare-versions-screen .boards-create i {\n      font-size: 48px;\n      line-height: 100px;\n      position: absolute;\n      top: 50%;\n      margin-top: -50px;\n      left: 50%;\n      margin-left: -20px; }\n    .compare-versions-screen .boards-create:hover {\n      cursor: pointer;\n      background: #d8d8d8; }\n    .compare-versions-screen .boards-create .compare-versions-float .dropdown__menu {\n      position: fixed;\n      left: auto;\n      right: auto;\n      top: auto;\n      bottom: auto;\n      max-width: 270px; }\n      .compare-versions-screen .boards-create .compare-versions-float .dropdown__menu li button {\n        max-width: 250px !important; }\n  .compare-versions-screen .boards-list .board {\n    background: #fff;\n    float: left;\n    height: 100%;\n    box-sizing: border-box;\n    border: 1px solid #cacaca;\n    border-width: 0 1px;\n    position: relative; }\n    .compare-versions-screen .boards-list .board > .dropdown {\n      left: 8px;\n      top: 5px;\n      border: 0;\n      position: absolute;\n      z-index: 2;\n      width: 4rem; }\n      .compare-versions-screen .boards-list .board > .dropdown .dropdown__toggle {\n        padding: 0 12px; }\n        .compare-versions-screen .boards-list .board > .dropdown .dropdown__toggle i {\n          opacity: 0.4;\n          filter: \"alpha(opacity=40)\"; }\n      .compare-versions-screen .boards-list .board > .dropdown.open .dropdown__toggle {\n        box-shadow: -3px -2px 1px -2px #999999, 3px -2px 1px -2px #999999; }\n      .compare-versions-screen .boards-list .board > .dropdown .dropdown__menu {\n        margin-top: -4px; }\n      .compare-versions-screen .boards-list .board > .dropdown:hover .dropdown__toggle i {\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n    .compare-versions-screen .boards-list .board > .board-article {\n      width: 100%;\n      height: 100%; }\n      .compare-versions-screen .boards-list .board > .board-article > .main-article {\n        border: 0;\n        padding: 20px 20px 70px; }\n        .compare-versions-screen .boards-list .board > .board-article > .main-article.locked {\n          border-left: 4px solid #e51c23; }\n        .compare-versions-screen .boards-list .board > .board-article > .main-article .editbar {\n          visibility: hidden;\n          overflow: hidden;\n          margin: 0 0 20px; }\n        .compare-versions-screen .boards-list .board > .board-article > .main-article .board-article-header {\n          margin: 0 0 2.4rem 3.2rem; }\n          .compare-versions-screen .boards-list .board > .board-article > .main-article .board-article-header__metadata {\n            display: inline-block;\n            margin-right: .6rem;\n            font-size: 12px;\n            font-weight: 500;\n            color: #333; }\n            .compare-versions-screen .boards-list .board > .board-article > .main-article .board-article-header__metadata-label {\n              font-style: italic;\n              font-weight: 400;\n              color: #666; }\n            .compare-versions-screen .boards-list .board > .board-article > .main-article .board-article-header__metadata-content {\n              margin-right: 5px; }\n    .compare-versions-screen .boards-list .board__no-article {\n      margin: 20px 0 0 60px;\n      font-size: 1.2rem;\n      color: gray;\n      font-style: italic; }\n    .compare-versions-screen .boards-list .board:hover .editbar {\n      visibility: visible !important; }\n", ""]);

// exports


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc service
 * @module superdesk.apps.authoring.compare_versions
 * @name compareVersions
 * @requires superdesk
 * @requires authoringWorkspace
 * @requires referrer
 * @requires $location
 * @description CompareVersionsService maintains all versions and selected versions of currently
 * opened article and manages the compare-versions screen to display the selected versions.
 * Compare versions screen has its boards and displays at least 2 of them.
 * Every board can be popuplated with one version of opened item.
 */
var MIN_BOARDS = 2; // at least two boards to display for versions comparision.
var CompareVersionsService = /** @class */ (function () {
    function CompareVersionsService(superdesk, authoringWorkspace, referrer, desks, archiveService, $location) {
        this.superdesk = superdesk;
        this.authoringWorkspace = authoringWorkspace;
        this.referrer = referrer;
        this.desks = desks;
        this.archiveService = archiveService;
        this.$location = $location;
        /**
         * @ngdoc property
         * @name compareVersions#items
         * @type {Array<object>}
         * @description Maintains array of object that contains selected versions of an opened article
         * for viewing in boards.
         */
        this.items = [];
        /**
         * @ngdoc property
         * @name compareVersions#versions
         * @type {Array<object>}

         */
        this.versions = [];
    }
    /**
     * @ngdoc method
     * @name compareVersions#minBoards
     * @returns {Integer} - MIN_BOARDS
     * @description returns minimum number of boards (i.e: 2) to display.
     */
    CompareVersionsService.prototype.minBoards = function () {
        return MIN_BOARDS;
    };
    /**
     * @ngdoc method
     * @name compareVersions#create
     * @param {Array<object>} itemVersions - Array of selected versions objects each contains 'id' and 'version'
     * @description maintains array of object that contains all fetched versions of article.
     */
    CompareVersionsService.prototype.create = function (itemVersions) {
        var _this = this;
        this.items = [];
        if (itemVersions) {
            lodash_1.default.each(itemVersions, function (itemVersion) {
                _this.items.push(_this._createBoard(itemVersion));
            });
        }
        if (this.items.length < MIN_BOARDS) {
            for (var i = 0; i < MIN_BOARDS - this.items.length; i++) {
                this.items.push(this._createBoard(null));
            }
        }
        this.open();
    };
    /**
     * @ngdoc method
     * @name compareVersions#exit
     * @description closes compare-versions screen and returns to opened article.
     */
    CompareVersionsService.prototype.exit = function () {
        this.$location.url(this.referrer.getReferrerUrl());
        this.authoringWorkspace.init();
    };
    /**
     * @ngdoc method
     * @name compareVersions#open
     * @description opens compare-versions screen to view selected versions.
     */
    CompareVersionsService.prototype.open = function () {
        this.referrer.setReferrerUrl(this.$location.url());
        if (this.authoringWorkspace.getState()) {
            this.authoringWorkspace.close(true);
        }
        this.superdesk.intent('author', 'compare-versions');
    };
    /**
     * @ngdoc method
     * @name compareVersionsn#edit
     * @param {Object} itemVersion - {id: _id, version: _current_version}
     * @param {Integer} board - opened board index
     * @description displays the provided item version to opened board.
     */
    CompareVersionsService.prototype.edit = function (itemVersion, board) {
        if (!this.items[board]) {
            this.items[board] = this._createBoard(itemVersion);
        }
        else {
            this.items[board].article = itemVersion;
        }
    };
    /**
     * @ngdoc method
     * @name compareVersions#remove
     * @param {Object} itemVersion - {id: _id, version: _current_version}
     * @description removes the item from selected items list.
     */
    CompareVersionsService.prototype.remove = function (itemVersion) {
        lodash_1.default.extend(lodash_1.default.find(this.items, { article: itemVersion }), { article: null });
    };
    /**
     * @ngdoc method
     * @name compareVersions#close
     * @param {Integer} board index
     * @description removes board panel for provided board index.
     */
    CompareVersionsService.prototype.close = function (board) {
        if (this.items.length > MIN_BOARDS) {
            this.items.splice(board, 1);
        }
    };
    /**
     * @ngdoc method
     * @name compareVersions#_createBoard
     * @param {Object} itemVersion - {id: _id, version: _current_version}
     * @private
     * @description Creates board for provided items version.
     */
    CompareVersionsService.prototype._createBoard = function (itemVersion) {
        return { article: itemVersion };
    };
    CompareVersionsService.prototype.init = function (item) {
        var _this = this;
        this.desks.initialize()
            .then(function () { return _this.archiveService.getVersions(item, _this.desks, 'versions'); })
            .then(function (versions) {
            _this.versions = versions;
            lodash_1.default.each(_this.versions, function (itemVersion) {
                itemVersion.author = _this.desks.userLookup[itemVersion.version_creator];
            });
            _this.create([{
                    id: item._id,
                    version: item._current_version,
                    author: _this.desks.userLookup[item.version_creator],
                }]);
        });
    };
    return CompareVersionsService;
}());
exports.default = CompareVersionsService;
CompareVersionsService.$inject = ['superdesk', 'authoringWorkspace', 'referrer',
    'desks', 'archiveService', '$location'];


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring.compare_versions
 * @name CompareVersionsController
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires compareVersions
 * @requires lock
 * @description CompareVersionsController provides boards to display item's versions and
 * provides set of convenience functions used by compare-versions screen.
 */
var CompareVersionsController = /** @class */ (function () {
    function CompareVersionsController($scope, compareVersions, lock) {
        this.compareVersions = compareVersions;
        this.lock = lock;
        this.$scope = $scope;
        this.init();
    }
    /**
     * @ngdoc method
     * @name CompareVersionsController#init
     * @description Initializes the controller with default values for the scope
     * and with necessary watcher.
     */
    CompareVersionsController.prototype.init = function () {
        var _this = this;
        this.$scope.minBoards = this.compareVersions.minBoards();
        this.$scope.$watch(function () { return _this.compareVersions.items; }, function (items) {
            _this.$scope.boards = items;
        }, true);
        this.$scope.closeBoard = this.closeBoard.bind(this);
        this.$scope.closeScreen = this.closeScreen.bind(this);
    };
    /**
     * @ngdoc method
     * @name CompareVersionsController#closeBoard
     * @param {Integer} board - The board index.
     * @description Closes the board panel at provided board index.
     */
    CompareVersionsController.prototype.closeBoard = function (board) {
        this.compareVersions.close(board);
    };
    /**
     * @ngdoc method
     * @name CompareVersionsController#closeScreen
     * @description Closes the compare-versions screen.
     */
    CompareVersionsController.prototype.closeScreen = function () {
        this.compareVersions.exit();
    };
    return CompareVersionsController;
}());
exports.default = CompareVersionsController;
CompareVersionsController.$inject = ['$scope', 'compareVersions', 'lock'];


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CompareVersionsArticleDirective_1 = __webpack_require__(1677);
exports.CompareVersionsArticleDirective = CompareVersionsArticleDirective_1.CompareVersionsArticleDirective;
var CompareVersionsDropdownInnerDirective_1 = __webpack_require__(1687);
exports.CompareVersionsDropdownInnerDirective = CompareVersionsDropdownInnerDirective_1.CompareVersionsDropdownInnerDirective;


/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var diff_match_patch_1 = __importDefault(__webpack_require__(413));
var shortid_1 = __importDefault(__webpack_require__(1678));
var lodash_1 = __importDefault(__webpack_require__(2));
var LinkFunction = /** @class */ (function () {
    function LinkFunction(compareVersions, content, lock, $timeout, scope, elem) {
        this.compareVersions = compareVersions;
        this.content = content;
        this.lock = lock;
        this.$timeout = $timeout;
        this.scope = scope;
        this.elem = elem;
        this.diffMatchPatch = new diff_match_patch_1.default();
        this.init();
    }
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#init
     * @private
     * @description Initializes the directive with default values for the scope
     * and with necessary watchers.
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        this.scope.$watch('[article, compareWith]', function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                _this.openItem();
            }
        });
        this.scope.remove = this.remove.bind(this);
        this.openItem();
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#remove
     * @description Removes the item from opened board.
     */
    LinkFunction.prototype.remove = function (item) {
        this.compareVersions.remove({ id: item._id, version: item._current_version });
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#openItem
     * @private
     * @description Opens the selected article version in sdArticleEdit directive.
     */
    LinkFunction.prototype.openItem = function () {
        var _this = this;
        var item = lodash_1.default.find(this.compareVersions.versions, { _current_version: this.scope.article.version });
        this.scope.origItem = item;
        this.scope.item = lodash_1.default.cloneDeep(item);
        this.scope.compareView = true;
        this.scope._editable = false;
        this.scope.isMediaType = lodash_1.default.includes(['audio', 'video', 'picture', 'graphic'], this.scope.item.type);
        if (this.scope.compareWith && this.scope.article !== this.scope.compareWith) {
            var compareWithItem = lodash_1.default.find(this.compareVersions.versions, { _current_version: this.scope.compareWith.version });
            this.scope.compareWithItem = lodash_1.default.create(compareWithItem);
            this.setVersionsDifference(this.scope.item, this.scope.compareWithItem);
        }
        if (this.scope.focus) {
            this.$timeout(function () {
                _this.elem.children().focus();
            }, 0, false);
        }
        this.scope.isLocked = this.lock.isLocked(item);
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#setVersionsDifference
     * @param {Object} item - current item version
     * @param {Object} oldItem - old item to compare with
     * @description Changes 'headline', 'abstract', 'body_footer', 'body_html', 'byline' from item
     * in order to highlight the differences from oldItem
     */
    LinkFunction.prototype.setVersionsDifference = function (item, oldItem) {
        var _this = this;
        this.content.getCustomFields().then(function (customFields) {
            var fields = ['headline', 'abstract', 'body_footer', 'body_html', 'byline'];
            lodash_1.default.map(fields, function (field) {
                if (item[field] || oldItem[field]) {
                    item[field] = _this.highlightDifferences(item[field], oldItem[field]);
                }
            });
            if (item.extra) {
                lodash_1.default.map(customFields, function (field) {
                    if (item.extra[field._id] || oldItem.extra[field._id]) {
                        item.extra[field._id] = _this.highlightDifferences(item.extra[field._id], oldItem.extra[field._id]);
                    }
                });
            }
            if (item.associations && item.associations.featuremedia &&
                oldItem.associations && oldItem.associations.featuremedia) {
                item.associations.featuremedia.description_text = _this.highlightDifferences(item.associations.featuremedia.description_text, oldItem.associations.featuremedia.description_text);
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#highlightDifferences
     * @param {String} newText - current text
     * @param {String} oldText - old text to compare with
     * @description Highlight the differences between new text and old text
     */
    LinkFunction.prototype.highlightDifferences = function (newText, oldText) {
        var mapWords = {};
        var pOldText = this.extractHtml(oldText, mapWords);
        var pNewText = this.extractHtml(newText, mapWords);
        var diffs = this.diffMatchPatch.diff_main(pOldText, pNewText);
        this.diffMatchPatch.diff_cleanupSemantic(diffs);
        diffs = this.splitByTranslationOfTags(diffs, this.reverseMap(mapWords, false));
        var text = this.diffMatchPatch
            .diff_prettyHtml(diffs);
        text = this.replaceWords(text, this.reverseMap(mapWords, true));
        return text;
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#extractHtml
     * @param {String} text - html text
     * @param {Map} mapWords - translation for words
     * @description Replace all html tags with custom tags.
     */
    LinkFunction.prototype.extractHtml = function (text, mapWords) {
        var tags = (text || '').match(/<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g);
        lodash_1.default.map(tags, function (tag) {
            if (!mapWords[tag]) {
                mapWords[tag] = shortid_1.default.generate();
            }
        });
        return this.replaceWords(text, mapWords);
    };
    /**
     * @ngdoc replaceWords
     * @name sdCompareVersionsArticle#replaceWords
     * @param {String} text - text
     * @param {Map} mapWords - translation for words
     * @description Replace in text the words from mapWords with corespondent translation
     */
    LinkFunction.prototype.replaceWords = function (text, mapWords) {
        var result = text || '';
        result = result.replace(/\n/g, '');
        lodash_1.default.map(Object.keys(mapWords), function (key) {
            result = result.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), ' ' + mapWords[key] + ' ');
        });
        return result;
    };
    /**
     * @ngdoc reverseMap
     * @name sdCompareVersionsArticle#reverseMap
     * @param {Map} mapWords
     * @description Reverse the key with content on mapWords
     */
    LinkFunction.prototype.reverseMap = function (mapWords, addSpan) {
        var reversedMap = {};
        var before = addSpan ? '<span>' : '';
        var after = addSpan ? '</span>' : '';
        lodash_1.default.map(Object.keys(mapWords), function (key) {
            reversedMap[before + mapWords[key] + after] = key;
        });
        return reversedMap;
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsArticle#splitByTranslationOfTags
     * @param {Object} diffs - current diffs
     * @description If one item in diffs contain a translation of html tag, split
     * item by translation and put it as a nonchanged item.
     */
    LinkFunction.prototype.splitByTranslationOfTags = function (diffs, mapWords) {
        var result = [];
        lodash_1.default.map(diffs, function (diff) {
            var list = diff[1].split(' ');
            var first = true;
            var text = '';
            lodash_1.default.map(list, function (item) {
                if (!first) {
                    text = text + ' ';
                }
                first = false;
                if (mapWords[item]) {
                    result.push([diff[0], text]);
                    result.push([0, item]);
                    text = '';
                }
                else {
                    text = text + item;
                }
            });
            if (text) {
                result.push([diff[0], text]);
            }
        });
        return result;
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring.compare_versions
 * @name sdCompareVersionsArticle
 * @requires compareVersions
 * @requires content
 * @requires lock
 * @requires $timeout
 * @param {Object} article - current article's version to display on board - {id: _id, version: _current_version}
 * @param {Boolean} focus - determines if focus needs to set on this board.
 * @description Displays the board which contains sdArticleEdit directive to display the contents of the selected
 * version of opened article and provides a remove function to remove the item version from board.
 */
function CompareVersionsArticleDirective(compareVersions, content, lock, $timeout) {
    return {
        template: __webpack_require__(1686),
        scope: { article: '=', compareWith: '=', focus: '=' },
        link: function (scope, elem) { return new LinkFunction(compareVersions, content, lock, $timeout, scope, elem); },
    };
}
exports.CompareVersionsArticleDirective = CompareVersionsArticleDirective;
CompareVersionsArticleDirective.$inject = ['compareVersions', 'content', 'lock', '$timeout'];


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(1679);


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(159);
var encode = __webpack_require__(560);
var decode = __webpack_require__(1682);
var build = __webpack_require__(1683);
var isValid = __webpack_require__(1684);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(1685) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(159);

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(560);
var alphabet = __webpack_require__(159);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(159);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports = "<article class=\"main-article\" tabindex=\"0\" ng-class=\"{locked: isLocked}\">\n    <div>\n        <div class=\"board-article-header\">\n            <div class=\"board-article-header__metadata\">\n                <span class=\"board-article-header__metadata-label\">{{ :: 'version' | translate }}: </span>\n                <span class=\"board-article-header__metadata-content\"> {{ item._current_version }}</span>\n                <span class=\"board-article-header__metadata-label\">{{ :: 'author' | translate }}: </span>\n                <span class=\"board-article-header__metadata-content\">{{ item.author.display_name }}</span>\n            </div>\n            <div class=\"state-label state-{{item.state}}\">{{item.state}}</div>\n        </div>\n        <div ng-disabled=\"true\" class=\"fieldset main-article__fieldset\" sd-article-edit></div>\n    </div>\n</article>\n";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var LinkFunction = /** @class */ (function () {
    function LinkFunction(compareVersions, scope, elem, attrs) {
        this.compareVersions = compareVersions;
        this.scope = scope;
        this.elem = elem;
        this.attrs = attrs;
        // contains selected versions
        this.compareVersionsItems = [];
        this.init();
    }
    /**
     * @ngdoc method
     * @name sdCompareVersionsInnerDropdown#init
     * @private
     * @description Initializes the directive with default values for the scope
     * and with necessary watchers.
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        // watches the selected versions of an item and filter out unselected versions
        // to provide in inner dropdown as a rest of available versions.
        this.scope.$watch(function () { return _this.compareVersions.items; }, function (items) {
            _this.compareVersionsItems = lodash_1.default.map(_this.compareVersions.items, function (board) { return board.article; });
            _this.filter();
        }, true);
        this.scope.open = this.open.bind(this);
    };
    // provides unselected versions to fill in inner dropdown
    LinkFunction.prototype.filter = function () {
        var _this = this;
        this.scope.items = lodash_1.default.reject(this.compareVersions.versions, function (item) {
            return !!lodash_1.default.find(_this.compareVersionsItems, { id: item._id, version: item._current_version });
        });
    };
    /**
     * @ngdoc method
     * @name sdCompareVersionsInnerDropdown#open
     * @param {Object} itemVersion - {id: _id, version: _current_version}
     * @description opens the provided version in compare-versions screen's board.
     */
    LinkFunction.prototype.open = function (itemVersion) {
        this.compareVersions.edit(itemVersion, this.attrs.board);
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring.compare_versions
 * @name sdCompareVersionsInnerDropdown
 * @requires compareVersions
 * @description Displays the list of un-selected versions available to open in
 * compare-versions screen and that appears on menu selection located at top of each opened board.
 */
function CompareVersionsDropdownInnerDirective(compareVersions) {
    return {
        template: __webpack_require__(1688),
        link: function (scope, elem, attrs) { return new LinkFunction(compareVersions, scope, elem, attrs); },
    };
}
exports.CompareVersionsDropdownInnerDirective = CompareVersionsDropdownInnerDirective;
CompareVersionsDropdownInnerDirective.$inject = ['compareVersions'];


/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports = "<li ng-repeat=\"item in items\" ng-if=\"items.length\">\n    <button ng-click=\"open({id: item._id, version: item._current_version});\">\n        <span class=\"headline\" ng-show=\"item.headline\">{{ item.headline }}</span>\n        <span ng-show=\"!item.headline\">{{ :: 'Untitled' | translate }}</span>\n        <em>\n        \t{{ :: 'version' | translate }}: {{ item._current_version }},\n        \t{{ :: 'author' | translate }}: {{ item.author.display_name }}\n        </em>\n    </button>\n</li>\n<li ng-if=\"!items.length\" class=\"msg\" translate>No items to add!</li>\n";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @ngdoc service
 * @module superdesk.apps.authoring.macros
 * @name macros
 * @requires api
 * @requires notify
 * @description MacrosService provides set of methods which allows fetching of macros
 * and triggering of macros to be apply on provided item
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var lodash_1 = __importDefault(__webpack_require__(2));
MacrosService.$inject = ['api', 'notify'];
function MacrosService(api, notify) {
    /**
     * Recursively returns all macros
     *
     * @return {*}
     */
    var _getAllMacros = function (criteria, page, macros) {
        if (criteria === void 0) { criteria = {}; }
        if (page === void 0) { page = 1; }
        if (macros === void 0) { macros = []; }
        return api.query('macros', lodash_1.default.extend({ max_results: 200, page: page }, criteria), null, true)
            .then(function (result) {
            var all = macros.concat(result._items);
            var pg = page;
            if (result._links.next) {
                pg++;
                return _getAllMacros(criteria, pg, all);
            }
            return lodash_1.default.sortBy(all, ['order', 'label']);
        });
    };
    /**
     * Returns all frontend macros if includeBackend is false or none
     * If includeBackend is true then results will include the backend macros
     *
     * @param {bool} includeBackend
     */
    this.get = function (includeBackend) {
        return _getAllMacros({ backend: !!includeBackend }).then(angular.bind(this, function (macros) {
            this.macros = macros;
            return this.macros;
        }));
    };
    /**
     * Returns all frontend macros for a given desk if includeBackend is false or none
     * If includeBackend is true then results will include the backend macros for that desk
     *
     * @param {string} desk
     * @param {bool} includeBackend
     */
    this.getByDesk = function (desk, includeBackend) {
        return _getAllMacros({ desk: desk, backend: !!includeBackend }).then(angular.bind(this, function (macros) {
            this.macros = macros;
            return this.macros;
        }));
    };
    this.setupShortcuts = function ($scope) {
        this.get().then(function (macros) {
            angular.forEach(macros, function (macro) {
                if (macro.shortcut) {
                    $scope.$on('key:ctrl:' + macro.shortcut, function () {
                        triggerMacro(macro, $scope.item);
                    });
                }
            });
        });
    };
    this.call = triggerMacro;
    function triggerMacro(macro, item, commit) {
        return api.save('macros', {
            macro: macro.name,
            item: item,
            commit: !!commit,
        }).then(function (res) { return res; }, function (err) {
            if (angular.isDefined(err.data._message)) {
                notify.error(utils_1.gettext('Error: {{message}}', { message: err.data._message }));
            }
        });
    }
}
/**
 * @ngdoc controller
 * @module superdesk.apps.authoring.macros
 * @name Macros
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires macros
 * @requires desks
 * @requires autosave
 * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
 * @requires storage
 * @requires editorResolver
 * @description MacrosController holds a set of convenience functions used by macros widget
 */
MacrosController.$inject = ['$scope', 'macros', 'desks', 'autosave', '$rootScope', 'storage', 'editorResolver'];
function MacrosController($scope, macros, desks, autosave, $rootScope, storage, editorResolver) {
    var expandedGroup = storage.getItem('expandedGroup') || [];
    $scope.loading = true;
    macros.get().then(function () {
        var currentDeskId = desks.getCurrentDeskId();
        if (currentDeskId !== null) {
            macros.getByDesk(desks.getCurrentDesk().name).then(function (_macros) {
                displayMacros(_macros);
            });
        }
        else {
            displayMacros(macros.macros);
        }
    })
        .finally(function () {
        $scope.loading = false;
    });
    /**
     * @ngdoc method
     * @name Macros#displayMacros
     * @private
     * @param {Array<object>} macros - each of macro contains name, label, group, order etc.
     * @description displays the list of fetched macros
     */
    function displayMacros(fetchedMacros) {
        $scope.macros = fetchedMacros;
        // grouped macros list
        var macrosByGroup = lodash_1.default.groupBy(lodash_1.default.filter($scope.macros, 'group'), 'group');
        $scope.groupedMacros = lodash_1.default.isEmpty(macrosByGroup) ? null : macrosByGroup;
        // provide grouping macros list option and prepare list, if group available.
        if ($scope.groupedMacros) {
            $scope.groupedList = true;
            prepareMacrosList($scope.macros);
        }
        else {
            $scope.groupedList = false;
        }
    }
    function isString(value) {
        return typeof value === 'string' || value instanceof String;
    }
    /**
     * @ngdoc method
     * @name Macros#call
     * @param {Object} macro - contains name, label, group, order etc.
     * @returns {Promise} - If resolved then macro is applied successfully
     * @description
     * Triggers macros service call to apply the provided macro on opened article.
     * The macros that changes the body should return diff; for other fields the entire
     * content is replaced with the value changed by macro
     */
    $scope.call = function (macro) {
        var editor = editorResolver.get();
        var isEditor3 = editor.version() !== '2';
        var useReplace = macro.replace_type != null && macro.replace_type !== 'no-replace';
        var isSimpleReplace = macro.replace_type === 'simple-replace';
        var item = lodash_1.default.extend({}, $scope.origItem, $scope.item);
        if (isEditor3 && useReplace) {
            item.body_html = editor.getHtmlForTansa() || item.body_html;
        }
        $scope.loading = true;
        return macros.call(macro, item).then(function (res) {
            var ignoreFields = ['_etag', 'fields_meta'];
            // ignore fields is only required for editor3
            if (isEditor3) {
                ignoreFields.push('body_html');
                if (res.diff == null && useReplace === true && item.body_html !== res.item.body_html) {
                    editor.setHtmlFromTansa(res.item.body_html, isSimpleReplace);
                }
                Object.keys(res.item || {}).forEach(function (field) {
                    if (isString(res.item[field]) === false || field === 'body_html') {
                        return;
                    }
                    ignoreFields.push(field);
                    if (res.item[field] !== item[field]) {
                        $rootScope.$broadcast('macro:refreshField', field, res.item[field]);
                    }
                });
            }
            if (isEditor3 || res.diff == null) {
                angular.extend($scope.item, lodash_1.default.omit(res.item, ignoreFields));
                $scope.autosave($scope.item);
            }
            if (res.diff != null) {
                $rootScope.$broadcast('macro:diff', res.diff);
            }
            $scope.closeWidget();
        })
            .finally(function () {
            $scope.loading = false;
        });
    };
    /**
     * @ngdoc method
     * @name Macros#prepareMacrosList
     * @private
     * @param {Array<object>} macros - each of macro contains name, label, group, order etc.
     * @description Prepares sections for list of macros, which includes quick, grouped and
     * miscellaneous set of macros for display
     */
    function prepareMacrosList(allMacros) {
        // macros quick list, i.e. where order is defined
        $scope.quickList = lodash_1.default.filter(allMacros, 'order');
        // miscellaneous macros list, i.e, where group is not defined
        $scope.miscMacros = lodash_1.default.filter(allMacros, function (o) { return o.group === undefined; });
        // sort grouped macros
        var ordered = {};
        Object.keys($scope.groupedMacros)
            .sort()
            .forEach(function (key) {
            ordered[key] = lodash_1.default.sortBy($scope.groupedMacros[key], 'label');
        });
        // sorted grouped macros
        $scope.orderedGroupedMacros = ordered;
    }
    /**
     * @ngdoc method
     * @name Macros#getGroupStatus
     * @param {String} group - key that represents macro group, like area, currency etc.
     * @returns {Boolean}
     * @description gets the remembered toggle status of provided group,
     * retrieved from local storage
     */
    $scope.getGroupStatus = function (group) {
        return lodash_1.default.includes(expandedGroup, group);
    };
    /**
     * @ngdoc method
     * @name Macros#setGroupStatus
     * @param {String} group - key that represents macro group, like area, currency etc.
     * @description sets the toggle status of provided group to be remember in local storage
     */
    $scope.setGroupStatus = function (group) {
        var index = expandedGroup.indexOf(group);
        if (index > -1) {
            expandedGroup.splice(index, 1);
        }
        else {
            expandedGroup.push(group);
        }
        storage.setItem('expandedGroup', expandedGroup);
    };
}
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring.macros
 * @name sdMacrosReplace
 * @requires editor
 * @description sd-macro-replace performs the necessary replacement on editor's item in order to
 * apply the results of triggered macro with the use of available set of methods such that next,
 * prev and replace
 */
MacrosReplaceDirective.$inject = ['editorResolver'];
function MacrosReplaceDirective(editorResolver) {
    return {
        scope: true,
        templateUrl: 'scripts/apps/authoring/macros/views/macros-replace.html',
        link: function (scope) {
            scope.diff = null;
            // this is triggered from MacrosController.call and apply the changes to body field
            scope.$on('macro:diff', function (evt, diff) {
                scope.diff = diff;
                init(scope.diff);
            });
            function init(diff) {
                var editor = editorResolver.get();
                if (diff) {
                    scope.noMatch = Object.keys(diff || {}).length;
                    editor.setSettings({ findreplace: { diff: diff } });
                    editor.render();
                    editor.selectNext();
                    scope.preview = getCurrentReplace();
                }
                else {
                    editor.setSettings({ findreplace: null });
                    editor.render();
                }
            }
            scope.next = function () {
                var editor = editorResolver.get();
                editor.selectNext();
                scope.preview = getCurrentReplace();
            };
            scope.prev = function () {
                var editor = editorResolver.get();
                editor.selectPrev();
                scope.preview = getCurrentReplace();
            };
            scope.replace = function () {
                var editor = editorResolver.get();
                var to = getCurrentReplace();
                if (to) {
                    editor.replace(to);
                    editor.selectNext();
                }
                scope.preview = getCurrentReplace();
            };
            scope.close = function () {
                scope.diff = null;
                init(scope.diff);
            };
            function getCurrentReplace() {
                var editor = editorResolver.get();
                var from = editor.getActiveText();
                return scope.diff[from] || null;
            }
            init(scope.diff);
        },
    };
}
/**
 * @ngdoc module
 * @module superdesk.apps.authoring.macros
 * @name superdesk.apps.authoring.macros
 * @packageName superdesk.apps
 * @description Superdesk module that allows managing and using macros
 */
angular.module('superdesk.apps.authoring.macros', [
    'superdesk.core.api',
    'superdesk.core.notify',
    'superdesk.apps.authoring.widgets',
    'superdesk.apps.authoring.autosave',
])
    .service('macros', MacrosService)
    .controller('Macros', MacrosController)
    .directive('sdMacrosReplace', MacrosReplaceDirective)
    .config(['authoringWidgetsProvider', function (authoringWidgetsProvider) {
        authoringWidgetsProvider
            .widget('macros', {
            icon: 'macro',
            label: utils_1.gettext('Macros'),
            template: 'scripts/apps/authoring/macros/views/macros-widget.html',
            order: 6,
            needEditable: true,
            side: 'right',
            display: {
                authoring: true,
                packages: true,
                killedItem: false,
                legalArchive: false,
                archived: false,
                picture: true,
                personal: true,
            },
        });
    }]);


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1691);
var svc = __importStar(__webpack_require__(1693));
var directive = __importStar(__webpack_require__(1699));
var controllers_1 = __webpack_require__(572);
var controllers_2 = __webpack_require__(572);
var SearchMenuController_1 = __importDefault(__webpack_require__(1794));
var MultiImageEdit_1 = __webpack_require__(1795);
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.search.react', [
    'superdesk.apps.highlights',
    'superdesk.apps.translations',
    'superdesk.core.datetime',
    'superdesk.apps.authoring.metadata',
])
    .service('monitoringState', svc.MonitoringState)
    .directive('sdItemsList', directive.ItemList);
/**
 * @ngdoc module
 * @module superdesk.apps.search
 * @name superdesk.apps.search
 * @packageName superdesk.apps
 * @description Superdesk search module. Allows searching existing and ingested
 * content.
 */
angular.module('superdesk.apps.search', [
    'superdesk.core.api',
    'superdesk.apps.desks',
    'superdesk.apps.publish',
    'superdesk.core.activity',
    'superdesk.core.list',
    'superdesk.core.keyboard',
    'superdesk.apps.search.react',
    'superdesk.apps.workspace.menu',
])
    .value('searchCommon', { meta: {} })
    .service('search', svc.SearchService)
    .service('savedSearch', svc.SavedSearchService)
    .service('multiImageEdit', svc.MultiImageEditService)
    .service('tags', svc.TagService)
    .service('sort', svc.SortService)
    .controller('MultiActionBar', controllers_1.MultiActionBarController)
    .controller('SearchMenuController', SearchMenuController_1.default)
    .directive('sdSearchPanel', directive.SearchPanel)
    .directive('sdSearchTags', directive.SearchTags)
    .directive('sdSearchFilters', directive.SearchFilters)
    .directive('sdSearchResults', directive.SearchResults)
    .directive('sdSaveSearch', directive.SaveSearch)
    .directive('sdItemContainer', directive.ItemContainer)
    .directive('sdItemPreview', directive.ItemPreview)
    .directive('sdItemGlobalsearch', directive.ItemGlobalSearch)
    .directive('sdItemSearchbar', directive.ItemSearchbar)
    .directive('sdItemRepo', directive.ItemRepo)
    .directive('sdItemSortbar', directive.ItemSortbar)
    .directive('sdSavedSearchSelect', directive.SavedSearchSelect)
    .directive('sdSavedSearchEditOwnSubscription', directive.SavedSearchEditOwnSubscription)
    .directive('sdEditTimeInterval', directive.EditTimeInterval)
    .directive('sdSavedSearchManageSubscribers', directive.SavedSearchManageSubscribers)
    .directive('sdSavedSearches', directive.SavedSearches)
    .directive('sdSearchContainer', directive.SearchContainer)
    .directive('sdSearchParameters', directive.SearchParameters)
    .directive('sdMultiActionBar', directive.MultiActionBar)
    .directive('sdRawSearch', directive.RawSearch)
    .directive('sdRepoDropdown', directive.RepoDropdown)
    .directive('sdMultiImageEdit', MultiImageEdit_1.MultiImageEditDirective)
    .config(['superdeskProvider', 'assetProvider', 'workspaceMenuProvider',
    function (superdesk, asset, workspaceMenuProvider) {
        superdesk.activity('/search', {
            description: utils_1.gettext('Find live and archived content'),
            priority: 200,
            label: utils_1.gettext('Search'),
            templateUrl: asset.templateUrl('apps/search/views/search.html'),
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            controller: controllers_2.SearchController,
            controllerAs: 'search',
        });
        workspaceMenuProvider.item({
            href: '/search',
            label: utils_1.gettext('Search'),
            templateUrl: asset.templateUrl('apps/search/views/menu.html'),
            order: 800,
            group: 'personal',
        });
    },
])
    .run(['keyboardManager', function (keyboardManager) {
        keyboardManager.register('Search', 'ctrl + 0', utils_1.gettext('Show search modal'));
        keyboardManager.register('Search', 'v', utils_1.gettext('Toggle search view'));
    }]);


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1692);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./search.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./search.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n@keyframes dropOut {\n  0% {\n    transform: translateY(-43px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight {\n  0% {\n    transform: translateX(20px);\n    opacity: 0; }\n  50% {\n    transform: translateX(20px);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes slideInFromRight {\n  0% {\n    transform: translateX(400px); }\n  100% {\n    transform: translateX(0); } }\n\n@keyframes appearFromBottomLeft {\n  0% {\n    transform: translateY(900px);\n    opacity: 0; }\n  100% {\n    transform: translateY(0);\n    opacity: 1; } }\n\n@keyframes appearFromRight2 {\n  0% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  50% {\n    transform: translateX(40px) rotate(360deg);\n    opacity: 0; }\n  100% {\n    transform: translateX(0) rotate(0deg);\n    opacity: 1; } }\n\n@keyframes dropOut2 {\n  0% {\n    transform: translateY(-48px); }\n  100% {\n    transform: translateY(0); } }\n\n@keyframes appearFromRight3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n@keyframes fadeIn3 {\n  0% {\n    transform: translateX(100%);\n    opacity: 0; }\n  100% {\n    transform: translateX(0);\n    opacity: 1; } }\n\n.search-page-container .archive-content {\n  height: 100%; }\n\n.search-page-header {\n  display: flex;\n  position: relative;\n  width: 100%;\n  align-items: center; }\n  .search-page-header .searchbar-flex-handler {\n    flex-grow: 1; }\n\n.ui-responsive-medium .searchbar-flex-handler {\n  width: 52px;\n  flex-grow: 0;\n  background-color: #f8f8f8; }\n  .ui-responsive-medium .searchbar-flex-handler .item-searchbar.focused {\n    position: absolute;\n    z-index: 10; }\n\n.ui-responsive-medium .sortbar-flex-handler {\n  flex-grow: 1;\n  text-align: right; }\n\n.ui-responsive-small .searchbar-flex-handler {\n  width: 40px; }\n  .ui-responsive-small .searchbar-flex-handler .button.search-icon {\n    width: 40px; }\n\n.filter-trigger {\n  width: 48px;\n  height: 48px;\n  line-height: 54px;\n  text-align: center;\n  background: #ededed;\n  flex-shrink: 0;\n  transition: all ease 0.1s;\n  overflow: hidden; }\n  .filter-trigger i {\n    opacity: 0.6;\n    filter: \"alpha(opacity=60)\"; }\n  .filter-trigger:hover {\n    cursor: pointer; }\n  .filter-trigger--active {\n    background: #3599b6; }\n    .filter-trigger--active i {\n      color: white; }\n\n.filter-content {\n  float: left;\n  margin-top: 10px; }\n\n.panel-selector {\n  margin-top: 20px;\n  margin-bottom: 10px;\n  width: 100%; }\n  .panel-selector button {\n    width: 48%; }\n\n.multi-action-bar {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  line-height: 48px;\n  background-color: #fff;\n  padding: 0 16px;\n  animation: dropOut2 0.3s cubic-bezier(0.695, 0.105, 0.285, 1.275) 1;\n  background-color: #d2e5ed;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2); }\n  .multi-action-bar .navbtn {\n    border: none;\n    vertical-align: bottom; }\n  .multi-action-bar #multi-select-count {\n    margin-left: 15px; }\n  .multi-action-bar .toggle {\n    width: 23px;\n    height: 23px;\n    border: 0;\n    padding: 0;\n    margin-right: 10px;\n    z-index: 3;\n    line-height: 0;\n    border-radius: 23px;\n    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.3);\n    transition: transform 0.5s; }\n    .multi-action-bar .toggle i {\n      height: 15px; }\n    .multi-action-bar .toggle.active {\n      -webkit-transform: rotate(180deg);\n      transform: rotate(180deg); }\n  .multi-action-bar .right-stack {\n    margin-right: -16px; }\n\n.item-searchbar {\n  border-left: 1px solid #dfdfdf;\n  border-right: 1px solid #dfdfdf;\n  position: relative; }\n  .item-searchbar.focused {\n    background: #fff; }\n  .item-searchbar .search-icon {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -khtml-user-select: none;\n    -ms-user-select: none;\n    width: 28px;\n    height: 28px;\n    display: inline-block;\n    background: url(" + escape(__webpack_require__(75)) + ") no-repeat 5px 5px;\n    opacity: 0.85;\n    filter: \"alpha(opacity=85)\"; }\n    .item-searchbar .search-icon:hover {\n      cursor: pointer;\n      opacity: 1;\n      filter: \"alpha(opacity=100)\"; }\n  .item-searchbar .button {\n    position: absolute;\n    width: 48px;\n    height: 48px;\n    background-position: center;\n    top: 0;\n    border: 0;\n    margin: 0; }\n    .item-searchbar .button .svg-icon-right {\n      width: 18px;\n      margin-top: 3px; }\n  .item-searchbar input {\n    height: 48px;\n    line-height: 100%;\n    font-size: 14px;\n    border: 0 !important;\n    padding: 0 48px;\n    background: none; }\n    .item-searchbar input:focus, .item-searchbar input:active {\n      box-shadow: none !important; }\n    .item-searchbar input::-webkit-input-placeholder {\n      line-height: 17px; }\n  .item-searchbar .trigger {\n    right: 0;\n    background: none; }\n  .item-searchbar .search-cancel {\n    position: absolute;\n    top: 12px;\n    right: 55px;\n    background: transparent;\n    border: 0;\n    padding: 0;\n    opacity: 0.4;\n    height: 24px;\n    width: 24px;\n    padding: 4px;\n    cursor: pointer;\n    transition: all 300ms ease; }\n    .item-searchbar .search-cancel:hover {\n      opacity: 0.8; }\n\n.search-tags {\n  position: relative;\n  z-index: 2;\n  padding: 0 0 0 20px;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);\n  background-color: rgba(255, 255, 255, 0.5); }\n  .search-tags .search-tags__list {\n    flex-grow: 1; }\n    .search-tags .search-tags__list li {\n      display: inline-block;\n      padding: 8px 0 6px 0; }\n  .search-tags .tag-label {\n    line-height: 1.8rem;\n    margin: 2px 1px 2px 0; }\n    .search-tags .tag-label span {\n      text-transform: capitalize;\n      opacity: 0.75;\n      margin-right: 0.5rem; }\n  .search-tags .refresh-box {\n    display: none; }\n  .search-tags.refresh {\n    padding-right: 50px;\n    min-height: 44px; }\n    .search-tags.refresh .refresh-box {\n      display: block;\n      position: absolute;\n      right: 10px;\n      top: 8px; }\n\n.item-globalsearch {\n  float: left; }\n  .item-globalsearch .popup {\n    position: fixed;\n    top: 100px;\n    left: 50%;\n    width: 400px;\n    margin-left: -200px;\n    border-radius: 6px;\n    background: rgba(0, 0, 0, 0.3);\n    box-sizing: border-box;\n    padding: 12px;\n    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.25);\n    z-index: 11112000; }\n    .item-globalsearch .popup > .content {\n      width: 100%;\n      background: #fff; }\n  .item-globalsearch .trigger-popup {\n    height: 47px;\n    padding: 10px 10px 10px 15px;\n    box-sizing: border-box;\n    float: left; }\n  .item-globalsearch .separator-handler {\n    margin: 9px 0 0 0;\n    border-right: 2px dotted #bcbcbc;\n    height: 30px;\n    float: left; }\n  .item-globalsearch.extended .popup {\n    display: block; }\n\n.advanced-globalsearch form {\n  *zoom: 1; }\n  .advanced-globalsearch form:before, .advanced-globalsearch form:after {\n    display: table;\n    content: \"\"; }\n  .advanced-globalsearch form:after {\n    clear: both; }\n\n.advanced-globalsearch .advanced {\n  margin-top: 0;\n  position: static;\n  box-sizing: border-box;\n  box-shadow: 0 3px 5px 0 #aaa;\n  border-radius: 0px;\n  border: 0;\n  width: 100%;\n  border-top: 1px solid #e6e6e6;\n  box-shadow: inset 0 1px 3px 0 #eee; }\n  .advanced-globalsearch .advanced:before {\n    display: none; }\n  .advanced-globalsearch .advanced .close {\n    padding: 0 5px;\n    float: right;\n    width: auto;\n    background: none;\n    margin: 5px 5px 0 0; }\n  .advanced-globalsearch .advanced .content {\n    padding: 25px 10px 10px; }\n  .advanced-globalsearch .advanced .actions {\n    *zoom: 1;\n    padding: 10px 0; }\n    .advanced-globalsearch .advanced .actions:before, .advanced-globalsearch .advanced .actions:after {\n      display: table;\n      content: \"\"; }\n    .advanced-globalsearch .advanced .actions:after {\n      clear: both; }\n    .advanced-globalsearch .advanced .actions button {\n      width: auto;\n      clear: none; }\n\n#react-placeholder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 1px;\n  height: 1px; }\n\n.sortbar .label-total {\n  margin-right: 5px; }\n\n.search-parameters .keywords {\n  *zoom: 1; }\n  .search-parameters .keywords:before, .search-parameters .keywords:after {\n    display: table;\n    content: \"\"; }\n  .search-parameters .keywords:after {\n    clear: both; }\n\n.es-highlight {\n  background-color: rgba(255, 61, 61, 0.25); }\n\n.subnav.legal-archive .sortbar-container {\n  padding: 10px 16px 10px 0; }\n\n.subnav.legal-archive .sortbar {\n  margin: 0 0 0 15px;\n  padding: 0 0 0 10px;\n  height: 25px; }\n  .subnav.legal-archive .sortbar .lab {\n    line-height: 20px; }\n\n.subnav.legal-archive .dropdown .sortbar {\n  width: 100%;\n  height: auto;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n  border-left: 0; }\n  .subnav.legal-archive .dropdown .sortbar .dropdown {\n    min-width: 120px;\n    float: right; }\n  .subnav.legal-archive .dropdown .sortbar .direction {\n    line-height: 18px;\n    margin-left: 15px; }\n\n.subnav.legal-archive .dropdown .sd-pagination {\n  padding: 0 17px; }\n  .subnav.legal-archive .dropdown .sd-pagination em.page-info, .subnav.legal-archive .dropdown .sd-pagination .btn-group {\n    width: 100%;\n    text-align: center; }\n\n.subnav.legal-archive .dropdown__menu .label-group {\n  text-transform: capitalize; }\n\n.subnav.legal-archive .dropdown__menu-divider {\n  clear: both; }\n\n.sd-grid-item__footer {\n  overflow: hidden; }\n  .sd-grid-item__footer .sd-grid-item__footer-block--multi-r {\n    overflow: hidden; }\n    .sd-grid-item__footer .sd-grid-item__footer-block--multi-r .sd-grid-item__footer-block-item {\n      flex-shrink: 1 !important;\n      overflow: hidden; }\n  .sd-grid-item__footer .sd-grid-item__footer-block-item {\n    flex-grow: 0;\n    margin: 0 auto;\n    display: flex;\n    align-items: center; }\n    .sd-grid-item__footer .sd-grid-item__footer-block-item .state-label {\n      margin: 0 auto;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n\n.workspace .main-section.search-page-container .preview-layout .search-content {\n  display: flex;\n  flex-direction: row; }\n\n.workspace .main-section.search-page-container .preview-layout .search-content__main {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  position: relative;\n  overflow-x: auto; }\n  .workspace .main-section.search-page-container .preview-layout .search-content__main .search-tags {\n    flex-shrink: 0; }\n\n.workspace .main-section.search-page-container .preview-layout .search-preview {\n  height: 100%;\n  transition: all ease-in-out 0.2s;\n  width: 560px;\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  opacity: 1; }\n  .workspace .main-section.search-page-container .preview-layout .search-preview .content-item-preview {\n    top: 0 !important;\n    position: relative;\n    width: 100% !important;\n    height: 100%;\n    opacity: 1;\n    transition: opacity ease-in-out 0.4s;\n    transition-delay: 0.2s; }\n  @media only screen and (max-width: 1430px) {\n    .workspace .main-section.search-page-container .preview-layout .search-preview {\n      width: 360px; } }\n\n.workspace .main-section.search-page-container .preview-layout.closed .search-preview {\n  width: 0;\n  overflow: hidden; }\n  .workspace .main-section.search-page-container .preview-layout.closed .search-preview .content-item-preview {\n    opacity: 0; }\n\n.workspace.authoring .main-section.search-page-container .preview-layout .search-preview--overlay {\n  position: absolute;\n  top: 4.8rem;\n  right: 0;\n  bottom: 0;\n  width: 0;\n  overflow: visible;\n  opacity: 1;\n  z-index: 3; }\n  .workspace.authoring .main-section.search-page-container .preview-layout .search-preview--overlay .content-item-preview {\n    top: 0 !important;\n    position: absolute;\n    width: 320px;\n    right: -324px;\n    opacity: 1;\n    transition: all ease-in-out 0.2s;\n    overflow-y: visible !important;\n    box-shadow: inset 3px 0 2px -1px rgba(0, 0, 0, 0.12), 2px 0 8px 0 rgba(0, 0, 0, 0.3), 0 0 2px 0 rgba(0, 0, 0, 0.12); }\n    .workspace.authoring .main-section.search-page-container .preview-layout .search-preview--overlay .content-item-preview .shift-preview__toggle {\n      display: inline-block; }\n    .workspace.authoring .main-section.search-page-container .preview-layout .search-preview--overlay .content-item-preview.shift {\n      right: 0;\n      box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.3), 0 0 2px 0 rgba(0, 0, 0, 0.12); }\n\n.workspace.authoring .main-section.search-page-container .preview-layout .search-preview {\n  width: 400px; }\n  @media only screen and (max-width: 1430px) {\n    .workspace.authoring .main-section.search-page-container .preview-layout .search-preview {\n      width: 360px; } }\n\n.workspace.authoring .main-section.search-page-container .preview-layout.closed .search-preview {\n  width: 0;\n  overflow: hidden; }\n  .workspace.authoring .main-section.search-page-container .preview-layout.closed .search-preview .content-item-preview {\n    opacity: 0; }\n\n.workspace.authoring .main-section.search-page-container .preview-layout.closed .search-preview--overlay {\n  opacity: 0; }\n", ""]);

// exports


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SearchService_1 = __webpack_require__(248);
exports.SearchService = SearchService_1.SearchService;
var TagService_1 = __webpack_require__(1694);
exports.TagService = TagService_1.TagService;
var SavedSearchService_1 = __webpack_require__(1695);
exports.SavedSearchService = SavedSearchService_1.SavedSearchService;
var MonitoringState_1 = __webpack_require__(1696);
exports.MonitoringState = MonitoringState_1.MonitoringState;
var SortService_1 = __webpack_require__(1697);
exports.SortService = SortService_1.SortService;
var MultiImageEditService_1 = __webpack_require__(1698);
exports.MultiImageEditService = MultiImageEditService_1.MultiImageEditService;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(73);
var DateFilters_1 = __webpack_require__(126);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.search
 * @name tags
 *
 * @requires $location
 * @requires desks
 * @requires userList
 * @requires metadata
 * @requires search
 * @requires ingestSources
 * @requires subscribersService
 * @requires $q
 *
 * @description Provides set of methods to manipulate with tags in search bar
 */
TagService.$inject = ['$location', 'desks', 'userList', 'metadata', 'search',
    'ingestSources', 'subscribersService', '$q'];
function TagService($location, desks, userList, metadata, search, ingestSources, subscribersService, $q) {
    var tags = {};
    tags.selectedFacets = {};
    tags.selectedParameters = [];
    tags.selectedKeywords = [];
    tags.currentSearch = {};
    tags.removedFacets = {};
    var FacetKeys = {
        type: 1,
        category: 1,
        urgency: 1,
        priority: 1,
        source: 1,
        credit: 1,
        desk: 1,
        genre: 1,
        legal: 1,
        sms: 1,
        language: 1,
    };
    var cvs = search.cvs;
    function tag(label, value) {
        return {
            label: label,
            value: value || label,
        };
    }
    function initSelectedParameters(params) {
        var parameters = params;
        tags.selectedParameters = [];
        while (parameters.indexOf(':') > 0 &&
            parameters.indexOf(':') < parameters.indexOf('(', parameters.indexOf(':')) &&
            parameters.indexOf(':') < parameters.indexOf(')', parameters.indexOf(':'))) {
            var colonIndex = parameters.indexOf(':');
            var parameter = parameters.substring(parameters.lastIndexOf(' ', colonIndex), parameters.indexOf(')', colonIndex) + 1);
            var added = false;
            cvs.forEach(function (cv) {
                if (parameter.indexOf(cv.id) !== -1) {
                    var value = parameter.substring(parameter.indexOf('(') + 1, parameter.lastIndexOf(')')), codeList = metadata.values[cv.list], name = lodash_1.default.result(lodash_1.default.find(codeList, { qcode: value }), 'name');
                    if (name) {
                        tags.selectedParameters.push(tag(cv.id + '.name:(' + name + ')'));
                        added = true;
                    }
                }
            });
            if (!added) {
                var paramArr = parameter.split(':');
                var parameterTranslated = utils_1.gettext(paramArr[0]) + ':' + paramArr[1];
                tags.selectedParameters.push(tag(parameterTranslated, paramArr.join(':')));
            }
            parameters = parameters.replace(parameter, '');
        }
        return parameters;
    }
    /*
     * function to parse search input from the search bar.
     */
    function initSelectedKeywords(keywords) {
        tags.selectedKeywords = keywords ? keywords.split(' ') : [];
    }
    function processFromToDesk(index, value) {
        tags.selectedParameters.push(tag(value + ':' +
            desks.deskLookup[index.split('-')[0]].name));
    }
    function processMetadataFields(index, value, key) {
        var processSelectedItems = function (selectedItems, codeList) {
            lodash_1.default.forEach(selectedItems, function (selecteditem) {
                var name = lodash_1.default.result(lodash_1.default.find(codeList, { qcode: selecteditem }), 'name');
                if (name) {
                    tags.selectedParameters.push(tag(value + ':(' + name + ')'));
                }
            });
        };
        cvs.forEach(function (cv) {
            if (cv.id !== key) {
                return;
            }
            var codeList = metadata.values[cv.list];
            var selecteditems = JSON.parse(index);
            processSelectedItems(selecteditems, codeList);
        });
    }
    /**
     * @ngdoc object
     * @name tags#fieldProcessors
     * @private
     * @description field:action mapper for parsing fields used in parameters
     */
    var fieldProcessors = {
        original_creator: function (index, value) {
            userList.getUser(index).then(function (user) {
                tags.selectedParameters.push(tag(value + ':' + user.display_name));
            }, function (error) {
                tags.selectedParameters.push(tag(value + ':Unknown'));
            });
        },
        from_desk: processFromToDesk,
        to_desk: processFromToDesk,
        marked_desks: function (index, value) {
            JSON.parse(index).forEach(function (id) {
                tags.selectedParameters.push(tag(value + ':' + desks.deskLookup[id].name));
            });
        },
        company_codes: processMetadataFields,
        subject: processMetadataFields,
        spike: function (index, value) { return index !== 'exclude' ? tags.selectedParameters.push(tag(value + ':' + index)) : null; },
        featuremedia: processBooleanTags,
        ingest_provider: function (index, value) { return tags.selectedParameters.push(tag(value + ':' +
            ingestSources.providersLookup[index].name)); },
        subscriber: function (index, value) {
            var subscriberName = lodash_1.default.get(subscribersService, 'subscribersLookup.' + index + '.name', ':Unknown');
            tags.selectedParameters.push(tag(value + ':' + subscriberName, value));
        },
    };
    /**
     * @ngdoc method
     * @name tags#processBooleanTags
     * @private
     * @param: {boolean} value
     * @param: {string} label Value to be displayed for the tag
     * @description Add boolean tags to selected parameters.
     */
    function processBooleanTags(value, label) {
        if (value) {
            tags.selectedParameters.push(tag(label));
        }
    }
    /**
     * Parse $location.search and initialise tags for fields defined in the PARAMETERS.
     * @param {object} params - $location.search
     */
    function initParameters(params, urlParams) {
        var parameters = urlParams || constants_1.PARAMETERS;
        lodash_1.default.each(parameters, function (value, key) {
            if (!angular.isDefined(params[key])) {
                return;
            }
            if (key in fieldProcessors) {
                fieldProcessors[key](params[key], value, key);
            }
            else {
                tags.selectedParameters.push(tag(value + ':' + params[key]));
            }
        });
        angular.forEach(cvs, function (cv) {
            if (params[cv.id] && cv.field !== cv.id) {
                processMetadataFields(params[cv.id], cv.name, cv.id);
            }
        });
    }
    /**
     * Parses search parameters object and initialise tags for fields defined in the EXCLUDE_FACETS.
     * @param {object} params - $location.search
     */
    function initExcludedFacets(params) {
        lodash_1.default.each(constants_1.EXCLUDE_FACETS, function (label, key) {
            if (!angular.isDefined(params[key])) {
                return;
            }
            tags.removedFacets[key] = [];
            var removedFacets = JSON.parse(params[key]);
            lodash_1.default.each(removedFacets, function (facet) {
                // Tags will display the desk name but the $location.search object has desk id.
                var displayValue = key === 'notdesk' ? desks.deskLookup[facet].name : facet;
                tags.removedFacets[key].push({
                    label: label,
                    displayValue: displayValue,
                    value: facet,
                });
            });
        });
    }
    /**
     * Removes the tags by modifying the $location.search
     * @param {String} type
     * @param {String} key
     */
    function removeFacet(type, key) {
        var dateFilter = DateFilters_1.getDateFilters().find(function (_a) {
            var labelBlock = _a.labelBlock, labelFrom = _a.labelFrom, labelTo = _a.labelTo;
            return [labelBlock, labelFrom, labelTo].includes(type);
        });
        if (dateFilter != null) {
            removeDateFacet(type, dateFilter);
        }
        else {
            var _search = $location.search();
            if (_search[type]) {
                var keys = JSON.parse(_search[type]);
                keys.splice(keys.indexOf(key), 1);
                if (keys.length > 0) {
                    $location.search(type, JSON.stringify(keys));
                }
                else {
                    $location.search(type, null);
                }
            }
            // Used by aap multimedia datalayer.
            if (type === 'credit') {
                $location.search('creditqcode', null);
            }
        }
    }
    /**
     * @ngdoc method
     * @name tags#initSelectedFacets
     * @private
     * @param {String} key
     * @param {Object} dateFilter
     * @description Removes the date search related tags by modifying the $location.search
     */
    function removeDateFacet(key, dateFilter) {
        if (dateFilter != null) {
            var fieldname = dateFilter.fieldname;
            if (key === dateFilter.labelFrom) {
                $location.search(fieldname + 'from', null);
            }
            else if (key === dateFilter.labelTo) {
                $location.search(fieldname + 'to', null);
            }
            else {
                $location.search(fieldname, null);
            }
        }
        else if (search[key]) {
            $location.search(key, null);
        }
    }
    /**
     * @ngdoc method
     * @name tags#initSelectedFacets
     * @private
     * @description Parses search parameters object and create tags
     * @return {Promise} List of items
     */
    function initSelectedFacets(urlParams) {
        var promises = $q.all([desks.initialize(), subscribersService.initialize()]);
        return promises.then(function (result) {
            tags.selectedFacets = {};
            tags.selectedParameters = [];
            tags.selectedKeywords = [];
            tags.removedFacets = {};
            tags.currentSearch = $location.search();
            var parameters = tags.currentSearch.q;
            if (parameters) {
                var keywords = initSelectedParameters(parameters);
                initSelectedKeywords(keywords);
            }
            initParameters(tags.currentSearch, urlParams);
            initExcludedFacets(tags.currentSearch);
            var dateFilters = DateFilters_1.getDateFilters();
            /* eslint-disable complexity */
            lodash_1.default.forEach(tags.currentSearch, function (type, key) {
                if (key === 'q' || constants_1.EXCLUDE_FACETS[key]) {
                    return;
                }
                if (key === 'desk') {
                    tags.selectedFacets[key] = [];
                    var selectedDesks = JSON.parse(type);
                    lodash_1.default.forEach(selectedDesks, function (selectedDesk) {
                        tags.selectedFacets[key].push({
                            label: desks.deskLookup[selectedDesk].name,
                            value: selectedDesk
                        });
                    });
                }
                else if (key === 'language') {
                    tags.selectedFacets[key] = [];
                    var selected = JSON.parse(type);
                    var languages_1 = metadata.values.languages || [];
                    selected.forEach(function (code) {
                        tags.selectedFacets[key].push({
                            label: (languages_1.find(function (l) { return l.qcode === code; }) || {}).name || code,
                            value: code,
                        });
                    });
                }
                else if (dateFilters.some(function (_a) {
                    var fieldname = _a.fieldname;
                    return fieldname === key;
                })) {
                    var dateFilter = dateFilters.find(function (_a) {
                        var fieldname = _a.fieldname;
                        return fieldname === key;
                    });
                    tags.selectedFacets[dateFilter.labelBlock] = [DateFilters_1.dateRangesByKey[type].label];
                }
                else if (key === 'creditqcode') {
                    tags.selectedFacets.credit = JSON.parse(type);
                }
                else {
                    var dateFilter = dateFilters.find(function (_a) {
                        var fieldname = _a.fieldname;
                        return key === fieldname + 'from' || key === fieldname + 'to';
                    });
                    if (dateFilter != null) {
                        // remove predefined filters like 'last day', 'last week'
                        $location.search(dateFilter.fieldname, null);
                        if (key === dateFilter.fieldname + 'to') {
                            tags.selectedFacets[dateFilter.labelTo] = [type];
                        }
                        else {
                            tags.selectedFacets[dateFilter.labelFrom] = [type];
                        }
                    }
                    else if (FacetKeys[key]) {
                        tags.selectedFacets[key] = JSON.parse(type);
                    }
                }
            });
            return tags;
        });
    }
    return {
        initSelectedFacets: initSelectedFacets,
        removeFacet: removeFacet,
    };
}
exports.TagService = TagService;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
SavedSearchService.$inject = ['api', '$filter', '$q', '$rootScope'];
function SavedSearchService(api, $filter, $q, $rootScope) {
    var _getAll = function (endPoint, page, items, params) {
        if (page === void 0) { page = 1; }
        if (items === void 0) { items = []; }
        if (params === void 0) { params = null; }
        return api.query(endPoint, { max_results: 200, page: page }, params)
            .then(function (result) {
            var pg = page;
            var merged = items.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAll(endPoint, pg, merged, params);
            }
            return $filter('sortByName')(merged);
        });
    };
    this.savedSearches = null;
    this.savedSearchLookup = null;
    this.getAllSavedSearches = function (page, items) {
        var self = this;
        if (self.savedSearches) {
            return $q.when(self.savedSearches);
        }
        return _getAll('all_saved_searches', page, items)
            .then(function (savedSearches) {
            self.savedSearches = savedSearches;
            self.savedSearchLookup = {};
            lodash_1.default.each(savedSearches, function (item) {
                self.savedSearchLookup[item._id] = item;
            });
            return savedSearches;
        });
    };
    this.getUserSavedSearches = function (userId, page, items) {
        return _getAll('saved_searches', page, items, userId);
    };
    this.resetSavedSearches = function () {
        this.savedSearches = null;
        this.savedSearchLookup = null;
    };
    // reset cache on update
    $rootScope.$on('savedsearch:update', angular.bind(this, this.resetSavedSearches));
}
exports.SavedSearchService = SavedSearchService;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Monitoring state - keeps information required to render lists.
 */
MonitoringState.$inject = ['$q', '$rootScope', 'ingestSources', 'desks', 'highlightsService', 'content', 'metadata'];
function MonitoringState($q, $rootScope, ingestSources, desks, highlightsService, content, metadata) {
    this.init = init;
    this.state = {};
    this.setState = setState;
    this.moveActiveGroup = moveActiveGroup;
    // reset state on every page change
    $rootScope.$on('$routeChangeSuccess', reset);
    var self = this;
    var ready;
    /**
     * Update state
     *
     * @param {Object} updates
     */
    function setState(updates) {
        self.state = angular.extend({}, self.state, updates);
    }
    /**
     * Reset monitoring state
     */
    function reset() {
        self.state = {};
        ready = null;
    }
    /**
     * Init state for react rendering
     */
    function init() {
        if (!ready) {
            ready = $q.all({
                ingestProvidersById: ingestSources.initialize().then(function () {
                    setState({ ingestProvidersById: ingestSources.providersLookup });
                }),
                desksById: desks.initialize().then(function () {
                    setState({ desksById: desks.deskLookup });
                }),
                usersById: setState({ usersById: desks.userLookup }),
                highlightsById: highlightsService.get().then(function (result) {
                    var highlightsById = {};
                    result._items.forEach(function (item) {
                        highlightsById[item._id] = item;
                    });
                    setState({ highlightsById: highlightsById });
                }),
                markedDesksById: desks.fetchDesks().then(function (result) {
                    var markedDesksById = {};
                    result._items.forEach(function (item) {
                        markedDesksById[item._id] = item;
                    });
                    setState({ markedDesksById: markedDesksById });
                }),
                profilesById: content.getTypesLookup().then(function (profilesLookup) {
                    setState({ profilesById: profilesLookup });
                }),
                // populates cache for mark for highlights activity dropdown
                deskHighlights: highlightsService.get(desks.getCurrentDeskId()),
                metadata: metadata.initialize(),
            });
        }
        return ready;
    }
    /**
     * Move active group up/down
     *
     * @param {Integer} diff
     */
    function moveActiveGroup(diff) {
        var groups = self.state.groups;
        var next = groups.indexOf(self.state.activeGroup) + diff;
        if (next >= groups.length) {
            next = 0;
        }
        else if (next < 0) {
            next = groups.length - 1;
        }
        setState({ activeGroup: groups[next] });
    }
}
exports.MonitoringState = MonitoringState;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc service
 * @module superdesk.apps.content-api
 * @name sort
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description Parses the $location for sort parameter and set sort parameter
 */
var SortService = /** @class */ (function () {
    function SortService($location) {
        this.$location = $location;
    }
    /**
     * @ngdoc method
     * @name sort#getSort
     * @public
     * @description Get the sort from url
     * @param {object} sortOptions Sort options for the different repo.
     * @return {object} sort field and direction (asc or desc)
     */
    SortService.prototype.getSort = function (sortOptions) {
        var sortArray = (this.$location.search().sort || 'versioncreated:desc').split(':');
        var sort = lodash_1.default.extend({}, lodash_1.default.find(sortOptions, { field: sortArray[0] }), { dir: sortArray[1] });
        if (sort.field === undefined) {
            var customFieldSort = this.$location.search().sort.split(':');
            return { field: customFieldSort[0], dir: customFieldSort[1] };
        }
        return sort;
    };
    /**
     * @ngdoc method
     * @name sort#setSort
     * @public
     * @description Set the sort
     * @param {string} field Field to sort
     * @param {object} sortOptions Sort options for the different repo.
     */
    SortService.prototype.setSort = function (field, sortOptions) {
        var option = lodash_1.default.find(sortOptions, { field: field });
        this.setSortUrlParam(option.field, option.defaultDir || 'desc');
    };
    /**
     * @ngdoc method
     * @name sort#toggleSortDir
     * @public
     * @description toggle the sort direction
     * @param {object} sortOptions Sort options for the different repo.
     */
    SortService.prototype.toggleSortDir = function (sortOptions) {
        var sort = this.getSort(sortOptions);
        var dir = sort.dir === 'asc' ? 'desc' : 'asc';
        this.setSortUrlParam(sort.field, dir);
    };
    /**
     * @ngdoc method
     * @name sort#formatSort
     * @public
     * @description toggle the sort direction
     * @param {string} key field to sort
     * @param {string} dir direction to sort
     * @return {string}
     */
    SortService.prototype.formatSort = function (key, dir) {
        var val = dir === 'asc' ? 1 : -1;
        return '[("' + encodeURIComponent(key) + '", ' + val + ')]';
    };
    /**
     * @ngdoc method
     * @name sort#setSortUrlParam
     * @public
     * @description Set the sort and page url parameter
     * @param {string} field field to sort
     * @param {string} dir direction to sort
     * @return {string}
     */
    SortService.prototype.setSortUrlParam = function (field, dir) {
        this.$location.search('sort', field + ':' + dir);
        this.$location.search('page', null);
    };
    return SortService;
}());
exports.SortService = SortService;
SortService.$inject = ['$location'];


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MultiImageEditModalController.$inject = ['$scope', 'imagesOriginal', 'saveHandler', 'deployConfig'];
function MultiImageEditModalController($scope, imagesOriginal, saveHandler, deployConfig) {
    $scope.imagesOriginal = imagesOriginal;
    $scope.saveHandler = saveHandler;
    $scope.cancelHandler = function () { return $scope.$close(); };
    $scope.successHandler = function () { return $scope.$close(); };
    $scope.getThumbnailHtml = function (image) { return "<img src=\"" + image.renditions.thumbnail.href + "\" />"; };
    $scope.validator = deployConfig.getSync('validator_media_metadata');
}
MultiImageEditService.$inject = ['$modal'];
function MultiImageEditService($modal) {
    this.edit = function (imagesOriginal, saveHandler) {
        $modal.open({
            templateUrl: 'scripts/apps/search/views/multi-image-edit-modal.html',
            controller: MultiImageEditModalController,
            size: 'fullscreen modal--dark-ui',
            resolve: {
                imagesOriginal: function () { return imagesOriginal; },
                saveHandler: function () { return saveHandler; },
            },
        });
    };
}
exports.MultiImageEditService = MultiImageEditService;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ItemList_1 = __webpack_require__(1700);
exports.ItemList = ItemList_1.ItemList;
var SearchPanel_1 = __webpack_require__(1766);
exports.SearchPanel = SearchPanel_1.SearchPanel;
var SearchTags_1 = __webpack_require__(1767);
exports.SearchTags = SearchTags_1.SearchTags;
var SearchResults_1 = __webpack_require__(1768);
exports.SearchResults = SearchResults_1.SearchResults;
var SearchContainer_1 = __webpack_require__(1769);
exports.SearchContainer = SearchContainer_1.SearchContainer;
var SearchParameters_1 = __webpack_require__(1770);
exports.SearchParameters = SearchParameters_1.SearchParameters;
var SaveSearch_1 = __webpack_require__(1771);
exports.SaveSearch = SaveSearch_1.SaveSearch;
var ItemContainer_1 = __webpack_require__(1772);
exports.ItemContainer = ItemContainer_1.ItemContainer;
var ItemPreview_1 = __webpack_require__(1773);
exports.ItemPreview = ItemPreview_1.ItemPreview;
var ItemGlobalSearch_1 = __webpack_require__(1774);
exports.ItemGlobalSearch = ItemGlobalSearch_1.ItemGlobalSearch;
var ItemSearchbar_1 = __webpack_require__(1775);
exports.ItemSearchbar = ItemSearchbar_1.ItemSearchbar;
var ItemRepo_1 = __webpack_require__(1776);
exports.ItemRepo = ItemRepo_1.ItemRepo;
var ItemSortbar_1 = __webpack_require__(1778);
exports.ItemSortbar = ItemSortbar_1.ItemSortbar;
var SavedSearchSelect_1 = __webpack_require__(1779);
exports.SavedSearchSelect = SavedSearchSelect_1.SavedSearchSelect;
var SavedSearches_1 = __webpack_require__(1780);
exports.SavedSearches = SavedSearches_1.SavedSearches;
var SavedSearchEditOwnSubscription_1 = __webpack_require__(1781);
exports.SavedSearchEditOwnSubscription = SavedSearchEditOwnSubscription_1.SavedSearchEditOwnSubscription;
var EditTimeInterval_1 = __webpack_require__(1782);
exports.EditTimeInterval = EditTimeInterval_1.EditTimeInterval;
var SavedSearchManageSubscribers_1 = __webpack_require__(1785);
exports.SavedSearchManageSubscribers = SavedSearchManageSubscribers_1.SavedSearchManageSubscribers;
var MultiActionBar_1 = __webpack_require__(1786);
exports.MultiActionBar = MultiActionBar_1.MultiActionBar;
var RawSearch_1 = __webpack_require__(1787);
exports.RawSearch = RawSearch_1.RawSearch;
var SearchFilters_1 = __webpack_require__(1788);
exports.SearchFilters = SearchFilters_1.SearchFilters;
var RepoDropdown_1 = __webpack_require__(1790);
exports.RepoDropdown = RepoDropdown_1.RepoDropdown;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-render-return-value */
// TODO(*): Fix above?
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var lodash_1 = __importDefault(__webpack_require__(2));
var components_1 = __webpack_require__(22);
ItemList.$inject = [
    '$location',
    '$timeout',
    '$injector',
    '$filter',
    'search',
    'datetime',
    'superdesk',
    'workflowService',
    'archiveService',
    'activityService',
    'multi',
    'desks',
    'familyService',
    'Keys',
    'dragitem',
    'highlightsService',
    'TranslationService',
    'monitoringState',
    'authoringWorkspace',
    '$rootScope',
    'config',
    '$interpolate',
    'metadata',
    'storage',
    'keyboardManager',
    'session',
    'content',
];
/**
 * @ngdoc directive
 * @module superdesk.apps.ItemList
 * @name sdItemList
 *
 * @requires $location
 * @requires $timeout
 * @requires $injector
 * @requires $filter
 * @requires search
 * @requires datetime
 * @requires superdesk
 * @requires workflowService
 * @requires archiveService
 * @requires activityService
 * @requires multi
 * @requires desks
 * @requires familyService
 * @requires Keys
 * @requires dragitem
 * @requires highlightsService
 * @requires TranslationService
 * @requires monitoringState
 * @requires authoringWorkspace
 * @requires $rootScope
 * @requires config
 * @requires $interpolate
 * @requires metadata
 * @requires storage
 * @requires keyboardManager
 * @requires session
 *
 * @description Handles the functionality displaying list of items from repos (archive, ingest, publish,
 * external, content api, archived)
 */
function ItemList($location, $timeout, $injector, $filter, search, datetime, superdesk, workflowService, archiveService, activityService, multi, desks, familyService, Keys, dragitem, highlightsService, TranslationService, monitoringState, authoringWorkspace, $rootScope, config, $interpolate, metadata, storage, keyboardManager, session, content) {
    // contains all the injected services to be passed down to child
    // components via props
    var services = {
        $location: $location,
        $timeout: $timeout,
        $injector: $injector,
        $filter: $filter,
        search: search,
        datetime: datetime,
        superdesk: superdesk,
        workflowService: workflowService,
        archiveService: archiveService,
        activityService: activityService,
        multi: multi,
        desks: desks,
        familyService: familyService,
        Keys: Keys,
        dragitem: dragitem,
        highlightsService: highlightsService,
        TranslationService: TranslationService,
        monitoringState: monitoringState,
        authoringWorkspace: authoringWorkspace,
        $rootScope: $rootScope,
        config: config,
        $interpolate: $interpolate,
        metadata: metadata,
        storage: storage,
        keyboardManager: keyboardManager,
        session: session,
        content: content,
    };
    return {
        link: function (scope, elem) {
            elem.attr('tabindex', 0);
            var groupId = scope.$id;
            var groups = monitoringState.state.groups || [];
            monitoringState.setState({
                groups: groups.concat(scope.$id),
                activeGroup: monitoringState.state.activeGroup || groupId,
            });
            scope.$watch(function () { return monitoringState.state.activeGroup; }, function (activeGroup) {
                if (activeGroup === groupId) {
                    elem.focus();
                }
            });
            monitoringState.init().then(function () {
                var itemList = react_1.default.createElement(components_1.ItemList, angular.extend({
                    svc: services,
                    scope: scope,
                    hideActionsForMonitoringItems: scope.hideActionsForMonitoringItems,
                    onMonitoringItemSelect: scope.onMonitoringItemSelect,
                    onMonitoringItemDoubleClick: scope.onMonitoringItemDoubleClick,
                    disableMonitoringMultiSelect: scope.disableMonitoringMultiSelect,
                }, monitoringState.state));
                var listComponent = react_dom_1.default.render(itemList, elem[0]);
                /**
                 * Test if item a equals to item b
                 *
                 * @param {Object} a
                 * @param {Object} b
                 * @return {Boolean}
                 */
                function isSameVersion(a, b) {
                    return a._etag === b._etag && a._current_version === b._current_version &&
                        a._updated === b._updated && isSameElasticHighlights(a, b);
                }
                /**
                 * Test if item a and item b have same elastic highlights
                 *
                 * @param {Object} a
                 * @param {Object} b
                 * @return {Boolean}
                 */
                function isSameElasticHighlights(a, b) {
                    if (!a.es_highlight && !b.es_highlight) {
                        return true;
                    }
                    if (!a.es_highlight && b.es_highlight || a.es_highlight && !b.es_highlight) {
                        return false;
                    }
                    function getEsHighlight(item) {
                        return item[0];
                    }
                    return lodash_1.default.map(a.es_highlight, getEsHighlight).join('-') ===
                        lodash_1.default.map(b.es_highlight, getEsHighlight).join('-');
                }
                /**
                 * Test if archive_item of a equals to archive_item of b
                 *
                 * @param {Object} a
                 * @param {Object} b
                 * @return {Boolean}
                 */
                function isArchiveItemSameVersion(a, b) {
                    if (!a.archive_item && !b.archive_item) {
                        return true;
                    }
                    if (a.archive_item && b.archive_item) {
                        if (b.archive_item.takes) {
                            return false; // take package of the new item might have changed
                        }
                        return a.archive_item._current_version === b.archive_item._current_version &&
                            a.archive_item._updated === b.archive_item._updated;
                    }
                    return false;
                }
                /**
                 * @ngdoc method
                 * @name sdItemList#isContentApiItemAssociation
                 * @private
                 * @description
                 * @param {object} oldItem Existing scope item
                 * @param {object} newItem From search results
                 * @return {boolean} returns true if the id of the featuremedia is same
                 */
                function isContentApiItemAssociation(oldItem, newItem) {
                    if (lodash_1.default.get(oldItem, '_type') !== 'items' || lodash_1.default.get(newItem, '_type') !== 'items') {
                        return true;
                    }
                    if (oldItem && newItem) {
                        return lodash_1.default.get(oldItem, 'associations.featuremedia._id') ===
                            lodash_1.default.get(newItem, 'associations.featuremedia._id');
                    }
                    return false;
                }
                scope.$watch('items', function (items) {
                    if (!items || !items._items) {
                        return;
                    }
                    var itemsList = [];
                    var currentItems = {};
                    var itemsById = angular.extend({}, listComponent.state.itemsById);
                    items._items.forEach(function (item) {
                        var itemId = search.generateTrackByIdentifier(item);
                        var oldItem = itemsById[itemId] || null;
                        if (!oldItem || !isSameVersion(oldItem, item) ||
                            !isArchiveItemSameVersion(oldItem, item) ||
                            !isContentApiItemAssociation(oldItem, item)) {
                            itemsById[itemId] = angular.extend({}, oldItem, item);
                        }
                        if (!currentItems[itemId]) { // filter out possible duplicates
                            currentItems[itemId] = true;
                            itemsList.push(itemId);
                        }
                    });
                    listComponent.setState({
                        itemsList: itemsList,
                        itemsById: itemsById,
                        view: scope.view,
                    }, function () {
                        scope.rendering = scope.loading = false;
                    });
                }, true);
                scope.$watch('view', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        listComponent.setState({ view: newValue });
                    }
                });
                scope.$watch('viewColumn', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        scope.$applyAsync(function () {
                            listComponent.setState({ swimlane: newValue });
                            scope.refreshGroup();
                        });
                    }
                });
                scope.$on('item:lock', function (_e, data) {
                    var itemId = search.getTrackByIdentifier(data.item, data.item_version);
                    listComponent.updateItem(itemId, {
                        lock_user: data.user,
                        lock_session: data.lock_session,
                        lock_time: data.lock_time,
                        _etag: data._etag,
                    });
                });
                scope.$on('item:unlock', function (_e, data) {
                    listComponent.updateAllItems(data.item, {
                        lock_user: null,
                        lock_session: null,
                        lock_time: null,
                        _etag: data._etag,
                    });
                });
                scope.$on('item:unselect', function () {
                    listComponent.setState({ selected: null });
                    listComponent.unbindActionKeyShortcuts();
                });
                scope.$on('item:expired', function (_e, data) {
                    var itemsById = angular.extend({}, listComponent.state.itemsById);
                    var shouldUpdate = false;
                    lodash_1.default.forOwn(itemsById, function (item, key) {
                        if (data.items[item._id]) {
                            itemsById[key] = angular.extend({ gone: true }, item);
                            shouldUpdate = true;
                        }
                    });
                    if (shouldUpdate) {
                        listComponent.setState({ itemsById: itemsById });
                    }
                });
                scope.$on('item:unlink', function (_e, data) {
                    listComponent.updateAllItems(data.item, {
                        sequence: null,
                        anpa_take_key: null,
                        takes: undefined,
                    });
                });
                scope.$on('item:highlights', function (_e, data) { return updateMarkedItems('highlights', data); });
                scope.$on('item:marked_desks', function (_e, data) { return updateMarkedItems('marked_desks', data); });
                function updateMarkedItems(field, data) {
                    var _a;
                    var item = listComponent.findItemByPrefix(data.item_id);
                    function filterMark(mark) {
                        return mark !== data.mark_id;
                    }
                    if (item) {
                        var itemId = search.generateTrackByIdentifier(item);
                        var markedItems = item[field] || [];
                        if (field === 'marked_desks' && item[field]) {
                            markedItems = lodash_1.default.isString(markedItems[0]) ? markedItems : lodash_1.default.map(markedItems, 'desk_id');
                        }
                        if (data.marked) {
                            markedItems = markedItems.concat([data.mark_id]);
                        }
                        else {
                            markedItems = markedItems.filter(filterMark);
                        }
                        listComponent.updateItem(itemId, (_a = {}, _a[field] = markedItems, _a));
                    }
                }
                scope.$on('multi:reset', function (e, data) {
                    var ids = data.ids || [];
                    var shouldUpdate = false;
                    var itemsById = angular.extend({}, listComponent.state.itemsById);
                    lodash_1.default.forOwn(itemsById, function (value, key) {
                        ids.forEach(function (id) {
                            if (lodash_1.default.startsWith(key, id)) {
                                shouldUpdate = true;
                                itemsById[key] = angular.extend({}, value, { selected: null });
                            }
                        });
                    });
                    if (shouldUpdate) {
                        listComponent.setState({ itemsById: itemsById });
                    }
                });
                scope.singleLine = search.singleLine;
                scope.$on('rowview:narrow', function () {
                    listComponent.setNarrowView(true);
                });
                scope.$on('rowview:default', function () {
                    listComponent.setNarrowView(false);
                });
                var updateTimeout;
                /**
                 * Function for creating small delay,
                 * before activating render function
                 */
                function handleScroll($event) {
                    // force refresh the group or list, if scroll bar hits the top of list.
                    if (elem[0].scrollTop === 0) {
                        $rootScope.$broadcast('refresh:list', scope.group);
                    }
                    if (scope.rendering) { // ignore
                        $event.preventDefault();
                        return;
                    }
                    // only scroll the list, not its parent
                    $event.stopPropagation();
                    listComponent.closeActionsMenu();
                    $timeout.cancel(updateTimeout);
                    if (!scope.noScroll) {
                        updateTimeout = $timeout(renderIfNeeded, 100, false);
                    }
                }
                /**
                 * Trigger render in case user scrolls to the very end of list
                 */
                function renderIfNeeded() {
                    if (!scope.items) {
                        return; // automatic scroll after removing items
                    }
                    if (isListEnd(elem[0]) && !scope.rendering) {
                        scope.rendering = scope.loading = true;
                        scope.fetchNext(listComponent.state.itemsList.length);
                    }
                }
                /**
                 * Check if we reached end of the list elem
                 *
                 * @param {Element} elem
                 * @return {Boolean}
                 */
                function isListEnd(element) {
                    return element.scrollTop + element.offsetHeight + 200 >= element.scrollHeight;
                }
                elem.on('keydown', listComponent.handleKey);
                elem.on('scroll', handleScroll);
                // remove react elem on destroy
                scope.$on('$destroy', function () {
                    elem.off();
                    listComponent.unbindActionKeyShortcuts();
                    react_dom_1.default.unmountComponentAtNode(elem[0]);
                });
            });
        },
    };
}
exports.ItemList = ItemList;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.type = function (props) {
    if (props.item.type == null) {
        return null;
    }
    var _a = props.item, _type = _a._type, highlight = _a.highlight;
    return (react_1.default.createElement("span", { className: props.className },
        react_1.default.createElement(index_1.TypeIcon, { type: _type, highlight: highlight })));
};
exports.type.propTypes = {
    svc: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    className: prop_types_1.default.string,
};


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
exports.headline = function (props) {
    var _headline = typeof props.item.headline === 'string' && props.item.headline.length > 0
        ? props.item.headline
        : props.item.type;
    return react_1.default.createElement('span', { className: 'item-heading', key: 'headline',
        dangerouslySetInnerHTML: helpers_1.createMarkUp(_headline) });
};
exports.headline.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
function slugline(props) {
    if (props.item.slugline) {
        return react_1.default.createElement('span', { className: 'keyword', key: 'slugline',
            dangerouslySetInnerHTML: helpers_1.createMarkUp(props.item.slugline) });
    }
}
exports.slugline = slugline;
slugline['propTypes'] = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
function wordcount(props) {
    return react_1.default.createElement('span', { className: 'word-count', key: 'wordcount' }, props.item.word_count);
}
exports.wordcount = wordcount;
wordcount['propTypes'] = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
function highlights(props) {
    return react_1.default.createElement(index_1.HighlightsInfo, angular.extend({
        key: 'highlights',
    }, props));
}
exports.highlights = highlights;
highlights['propTypes'] = {
    // item is passed through to HighlightsInfo directly via props
    // eslint-disable-next-line react/no-unused-prop-types
    item: prop_types_1.default.any,
};


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
function markedDesks(props) {
    return react_1.default.createElement(index_1.MarkedDesksInfo, angular.extend({
        key: 'markedDesks',
    }, props));
}
exports.markedDesks = markedDesks;
markedDesks['propTypes'] = {
    // item is passed through to MarkedDesksInfo directly via props
    // eslint-disable-next-line react/no-unused-prop-types
    item: prop_types_1.default.any,
};


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.versioncreated = function (props) { return react_1.default.createElement(index_1.TimeElem, {
    date: props.item.versioncreated,
    key: 'versioncreated',
    svc: props.svc,
}); };
exports.versioncreated.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.versioncreator = function (props) { return react_1.default.createElement('span', { className: 'version-creator', key: 'versioncreator' }, props.versioncreator); };
exports.versioncreator.propTypes = {
    versioncreator: prop_types_1.default.any,
};


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.profile = function (props) {
    if (props.item.profile) {
        return react_1.default.createElement('div', { className: 'profile-label profile-label--' + props.item.profile, key: 'profile' }, props.profilesById[props.item.profile] ?
            props.profilesById[props.item.profile].label :
            props.item.profile);
    }
};
exports.profile.propTypes = {
    item: prop_types_1.default.any,
    profilesById: prop_types_1.default.any,
};


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.embargo = function (props) {
    if (props.item.embargo) {
        return react_1.default.createElement('span', { className: 'state-label state_embargo', title: utils_1.gettext('embargo'), key: 'embargo' }, utils_1.gettext('embargo'));
    }
};
exports.embargo.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.update = function (props) {
    if (props.item.correction_sequence) {
        return react_1.default.createElement('div', {
            className: 'provider',
            key: 'update',
            title: utils_1.gettext('correction sequence'),
        }, utils_1.gettext('Update {{sequence}}', { sequence: props.item.correction_sequence }));
    }
};
exports.update.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.updated = function (props) {
    var openItem = function (event) {
        event.stopPropagation();
        props.openAuthoringView(props.item.rewritten_by);
    };
    if (props.item.rewritten_by) {
        return react_1.default.createElement('div', { className: 'state-label updated', key: 'updated', onClick: openItem }, utils_1.gettext('Updated'));
    }
};
exports.updated.propTypes = {
    item: prop_types_1.default.any,
    openAuthoringView: prop_types_1.default.func,
};


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.takekey = function (props) {
    if (props.item.anpa_take_key) {
        return react_1.default.createElement('span', { className: 'takekey', key: 'takekey' }, utils_1.gettext(props.item.anpa_take_key));
    }
};
exports.takekey.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.signal = function (props) {
    if (props.item.signal) {
        return react_1.default.createElement('span', { className: 'signal', key: 'signal' }, props.item.signal);
    }
};
exports.signal.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.broadcast = function (props) {
    var _broadcast = props.item.broadcast || {};
    if (_broadcast.status) {
        return react_1.default.createElement('span', { className: 'broadcast-status', title: _broadcast.status, key: 'broadcast' }, '!');
    }
};
exports.broadcast.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.flags = function (props) {
    var _flags = props.item.flags || {};
    var elems = [
        _flags.marked_for_not_publication ?
            react_1.default.createElement('div', {
                className: 'state-label not-for-publication',
                title: utils_1.gettext('Not For Publication'),
                key: 'not-for-publication',
            }, utils_1.gettext('Not For Publication'))
            : null,
        _flags.marked_for_legal ?
            react_1.default.createElement('div', {
                className: 'state-label legal',
                title: utils_1.gettext('Legal'),
                key: 'legal',
            }, utils_1.gettext('Legal'))
            : null,
        _flags.marked_for_sms ?
            react_1.default.createElement('div', {
                className: 'state-label sms',
                key: 'sms'
            }, utils_1.gettext('Sms'))
            : null,
    ].filter(angular.identity);
    return elems.length ? react_1.default.createElement('div', { key: 'flags' }, elems) : null;
};
exports.flags.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.category = function (props) {
    var anpa = props.item.anpa_category || {};
    if (anpa.name) {
        return react_1.default.createElement('div', { className: 'category', key: 'category' }, anpa.name);
    }
};
exports.category.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.provider = function (props) {
    var _provider = props.ingestProvider ? props.ingestProvider.source : '';
    if (props.item.source) {
        _provider = props.item.source;
    }
    if (_provider) {
        return react_1.default.createElement('span', { className: 'provider', key: 'provider' }, _provider);
    }
};
exports.provider.propTypes = {
    item: prop_types_1.default.any,
    ingestProvider: prop_types_1.default.any,
};


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.expiry = function (props) {
    var datetime = props.svc.datetime;
    if (props.item.is_spiked) {
        return react_1.default.createElement('div', { className: 'expires', key: 'expiry' }, utils_1.gettext('expires') + ' ' + datetime.shortFormat(props.item.expiry));
    }
};
exports.expiry.propTypes = {
    svc: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.desk = function (props) {
    if (!props.item.archived) {
        return react_1.default.createElement(index_1.ItemContainer, {
            item: props.item,
            desk: props.desk,
            key: 'desk',
        });
    }
};
exports.desk.propTypes = {
    item: prop_types_1.default.any,
    desk: prop_types_1.default.any,
};


/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.fetchedDesk = function (props) {
    if (props.item.archived) {
        return react_1.default.createElement(index_1.FetchedDesksInfo, {
            item: props.item,
            key: 'desk',
            svc: props.svc,
        });
    }
};
exports.fetchedDesk.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.priority = function (props) { return props.item.priority ?
    react_1.default.createElement(index_1.ItemPriority, angular.extend({
        key: 'priority',
        svc: props.svc,
    }, props.item)) : null; };
exports.priority.propTypes = {
    svc: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.urgency = function (props) { return props.item.urgency ?
    react_1.default.createElement(index_1.ItemUrgency, angular.extend({ key: 'urgency', svc: props.svc }, props.item)) : null; };
exports.urgency.propTypes = {
    svc: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.associations = function (props) { return react_1.default.createElement(index_1.Associations, { item: props.item, openAuthoringView: props.openAuthoringView, key: "associations" }); };
/*
 * item: item having associations
 * openAuthoringView: Opens the item in view mode
 */
exports.associations.propTypes = {
    item: prop_types_1.default.any,
    openAuthoringView: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
exports.queueError = function (props) { return react_1.default.createElement(index_1.QueueError, { item: props.item, key: "queueError" }); };
/*
 * item: published item having queue errors
 */
exports.queueError.propTypes = {
    item: prop_types_1.default.any,
};


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
exports.assignment = function (_a) {
    var item = _a.item;
    if (!lodash_1.get(item, 'assignment_id')) {
        return null;
    }
    return (react_1.default.createElement("span", { key: "assignment", className: "assignment-icon", title: utils_1.gettext('Coverage') },
        react_1.default.createElement("i", { className: "icon-calendar" })));
};
exports.assignment.propTypes = {
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
exports.language = function (_a) {
    var item = _a.item;
    if (!lodash_1.get(item, 'language')) {
        return null;
    }
    return (react_1.default.createElement("span", { key: "language", className: "language-label" }, lodash_1.get(item, 'language')));
};
exports.language.propTypes = { item: prop_types_1.default.object.isRequired };


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.copyright = function (_a) {
    var item = _a.item;
    if (item.copyrightholder) {
        var title = item.usageterms || item.copyrightnotice || '';
        return (react_1.default.createElement("small", { key: "copyright", className: "copyright container", title: title },
            "\u00A9 ",
            item.copyrightholder));
    }
    return null;
};
exports.copyright.propTypes = {
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * Usage Terms field
 * @param {Object} props
 */
exports.usageterms = function (_a) {
    var item = _a.item;
    if (item.usageterms) {
        return (react_1.default.createElement("small", { key: "usageterms", className: "usageterms container" }, item.usageterms));
    }
    return null;
};
exports.usageterms.propTypes = {
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.nestedlink = function (props) { return (props.nestedCount > 0 ? (react_1.default.createElement("div", { key: "nestedlink", className: "element-with-badge" },
    react_1.default.createElement("a", { className: "text-link", onClick: props.toggleNested }, props.showNested ?
        utils_1.gettext('Hide previous items') :
        utils_1.gettext('Show previous items')),
    react_1.default.createElement("span", { className: "badge badge--light" }, props.nestedCount))) : null); };
exports.nestedlink.propTypes = {
    showNested: prop_types_1.default.bool,
    nestedCount: prop_types_1.default.number,
    toggleNested: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var AssociatedItemsList_1 = __webpack_require__(1732);
exports.associatedItems = function (_a) {
    var item = _a.item, svc = _a.svc;
    return (lodash_1.isEmpty(item.associations) ? null : react_1.default.createElement(AssociatedItemsList_1.AssociatedItemsList, { key: "associatedItems", item: item, svc: svc }));
};
exports.associatedItems.propTypes = {
    item: prop_types_1.default.object.isRequired,
    svc: prop_types_1.default.shape({
        content: prop_types_1.default.object.isRequired,
    }).isRequired,
};


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var TYPES_TO_ICONS = {
    picture: 'icon-photo',
    graphic: 'icon-graphic',
    video: 'icon-video',
    audio: 'icon-audio',
};
/**
 * Render icon with count for each item type present in associations.
 */
var AssociatedItemsList = /** @class */ (function (_super) {
    __extends(AssociatedItemsList, _super);
    function AssociatedItemsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { associations: [] };
        return _this;
    }
    AssociatedItemsList.prototype.componentDidMount = function () {
        this.getAssociations();
    };
    AssociatedItemsList.prototype.getAssociations = function () {
        var _this = this;
        var content = this.props.svc.content;
        content.fetchAssociations(this.props.item).then(function (associations) {
            _this.setState({ associations: Object.values(associations) });
        });
    };
    AssociatedItemsList.prototype.render = function () {
        var _this = this;
        var icons = Object.keys(TYPES_TO_ICONS).map(function (type) { return ({
            type: type,
            icon: TYPES_TO_ICONS[type],
            count: _this.state.associations.filter(function (assoc) { return assoc != null && assoc.type === type; }).length,
        }); })
            .filter(function (data) { return data.count > 0; })
            .map(function (associatedType) { return (react_1.default.createElement("span", { key: associatedType.type, className: "sd-text-icon sd-text-icon--aligned-r" },
            react_1.default.createElement("i", { className: associatedType.icon + " sd-opacity--40" }),
            associatedType.count)); });
        return icons.length ? (react_1.default.createElement("span", { style: { marginLeft: 'auto' } },
            " ",
            icons)) : null;
    };
    return AssociatedItemsList;
}(react_1.default.Component));
exports.AssociatedItemsList = AssociatedItemsList;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.TimeElem = function (props) {
    var datetime = props.svc.datetime;
    return react_1.default.createElement('time', { title: datetime.longFormat(props.date) }, datetime.shortFormat(props.date));
};
exports.TimeElem.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    date: prop_types_1.default.any,
};


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.ItemContainer = function (props) {
    var item = props.item;
    var desk = props.desk || null;
    var label;
    var value;
    if (item._type !== 'ingest') {
        if (desk) {
            label = utils_1.gettext('desk:');
            value = item._type !== 'archived' ? desk.name : utils_1.gettext('Archived from {{desk}}', { desk: desk.name });
        }
        else if (item._type === 'archive') {
            label = utils_1.gettext('location:');
            value = utils_1.gettext('workspace');
        }
        else if (item._type === 'archived') {
            label = '';
            value = utils_1.gettext('archived');
        }
    }
    return react_1.default.createElement('span', { className: 'container', title: value ? label + ' ' + value : null }, react_1.default.createElement('span', { className: 'location-desk-label' }, label), value);
};
exports.ItemContainer.propTypes = {
    item: prop_types_1.default.any,
    desk: prop_types_1.default.any,
};


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var SelectBox = /** @class */ (function (_super) {
    __extends(SelectBox, _super);
    function SelectBox(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    SelectBox.prototype.toggle = function (event) {
        if (event && (event.ctrlKey || event.shiftKey)) {
            return false;
        }
        event.stopPropagation();
        if (helpers_1.isCheckAllowed(this.props.item)) {
            var selected = !this.props.item.selected;
            this.props.onMultiSelect([this.props.item], selected, event);
        }
    };
    SelectBox.prototype.render = function () {
        if (this.props.item.selected) {
            this.props.item.selected = helpers_1.isCheckAllowed(this.props.item);
        }
        return react_1.default.createElement('div', {
            className: this.props.classes ? this.props.classes : 'selectbox',
            title: helpers_1.isCheckAllowed(this.props.item) ? null : 'selection not allowed',
            onClick: this.toggle,
        }, react_1.default.createElement('span', {
            className: 'sd-checkbox' + (this.props.item.selected ? ' checked' : ''),
        }));
    };
    return SelectBox;
}(react_1.default.Component));
exports.SelectBox = SelectBox;
SelectBox.propTypes = {
    item: prop_types_1.default.any,
    classes: prop_types_1.default.string,
    onMultiSelect: prop_types_1.default.func,
};


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var utils_1 = __webpack_require__(3);
var FetchedDesksInfo = /** @class */ (function (_super) {
    __extends(FetchedDesksInfo, _super);
    function FetchedDesksInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { desks: [] };
        _this.openDesk = _this.openDesk.bind(_this);
        return _this;
    }
    FetchedDesksInfo.prototype.componentDidMount = function () {
        var _this = this;
        var familyService = this.props.svc.familyService;
        familyService.fetchDesks(this.props.item, false)
            .then(function (fetchedDesks) {
            _this.setState({ desks: fetchedDesks });
        });
    };
    FetchedDesksInfo.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var familyService = this.props.svc.familyService;
        if (prevProps.item !== this.props.item) {
            familyService.fetchDesks(this.props.item, false)
                .then(function (fetchedDesks) {
                _this.setState({ desks: fetchedDesks });
            });
        }
    };
    FetchedDesksInfo.prototype.formatDeskName = function (name) {
        return name.substr(0, 10) + (name.length > 10 ? '...' : '');
    };
    FetchedDesksInfo.prototype.openDesk = function (desk) {
        var _a = this.props.svc, $location = _a.$location, desks = _a.desks, superdesk = _a.superdesk;
        return function (event) {
            event.stopPropagation();
            if (desk.isUserDeskMember) {
                desks.setCurrentDeskId(desk.desk._id);
                $location.url('/workspace/monitoring');
                if (desk.count === 1) {
                    superdesk.intent('edit', 'item', desk.item);
                }
            }
        };
    };
    FetchedDesksInfo.prototype.render = function () {
        var items = [];
        items.push(react_1.default.createElement('dt', {
            key: 'dt',
            style: { paddingRight: '5px' },
        }, utils_1.gettext('fetched in')));
        if (this.state.desks.length) {
            var desk = this.state.desks[0];
            var name = this.formatDeskName(desk.desk.name);
            items.push(react_1.default.createElement('dd', { key: 'dd1' }, desk.isUserDeskMember ?
                react_1.default.createElement('a', { onClick: this.openDesk(desk) }, name) :
                react_1.default.createElement('span', { className: 'container' }, name)));
            if (this.state.desks.length > 1) {
                items.push(react_1.default.createElement(index_1.DesksDropdown, {
                    key: 'dd2',
                    desks: this.state.desks,
                    openDesk: this.openDesk,
                    svc: this.props.svc,
                }));
            }
        }
        return react_1.default.createElement('div', {}, react_1.default.createElement('dl', {}, items));
    };
    return FetchedDesksInfo;
}(react_1.default.Component));
exports.FetchedDesksInfo = FetchedDesksInfo;
FetchedDesksInfo.propTypes = {
    svc: prop_types_1.default.object,
    item: prop_types_1.default.any,
};


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var closeTimeout;
var DesksDropdown = /** @class */ (function (_super) {
    __extends(DesksDropdown, _super);
    function DesksDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        _this.close = _this.close.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        return _this;
    }
    DesksDropdown.prototype.close = function (cancel) {
        var $timeout = this.props.svc.$timeout;
        if (cancel === true && closeTimeout) {
            $timeout.cancel(closeTimeout);
        }
        else {
            closeTimeout = $timeout(function () {
                helpers_1.closeActionsMenu();
            }, 200, false);
        }
    };
    DesksDropdown.prototype.toggle = function (event) {
        if (event) {
            event.stopPropagation();
        }
        this.close(true);
        this.renderDropdown();
    };
    DesksDropdown.prototype.render = function () {
        return react_1.default.createElement('dd', { className: 'dropdown dropdown--dropup more-actions' }, react_1.default.createElement('button', {
            className: 'dropdown__toggle',
            onMouseOver: this.toggle,
            onMouseLeave: this.close,
        }, react_1.default.createElement('i', { className: 'icon-dots' })));
    };
    DesksDropdown.prototype.renderDropdown = function () {
        var _this = this;
        var desks = this.props.desks.map(function (desk, index) { return react_1.default.createElement('li', { key: 'desk' + index }, react_1.default.createElement('a', { disabled: !desk.isUserDeskMember, onClick: _this.props.openDesk(desk) }, desk.desk.name + ' (' + desk.count + ')')); });
        var elem = react_1.default.createElement('div', {
            className: 'dropdown__menu more-activity-menu',
            onMouseOver: this.toggle,
            onMouseLeave: this.close,
        }, react_1.default.createElement('ul', {}, desks));
        var thisNode = react_dom_1.default.findDOMNode(this);
        var icon = thisNode.getElementsByClassName('dropdown__toggle')[0];
        helpers_1.renderToBody(elem, icon);
    };
    return DesksDropdown;
}(react_1.default.Component));
exports.DesksDropdown = DesksDropdown;
DesksDropdown.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    openDesk: prop_types_1.default.func,
    desks: prop_types_1.default.any,
};


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
/**
 * Type icon component
 */
exports.TypeIcon = function (props) {
    if (props.type === 'composite' && props.highlight) {
        return react_1.default.createElement('i', { className: 'filetype-icon-highlight-pack' });
    }
    return react_1.default.createElement('i', {
        className: 'filetype-icon-' + props.type,
        title: utils_1.gettext('Article Type: {{type}}', { type: props.type }),
    });
};
exports.TypeIcon.propTypes = {
    type: prop_types_1.default.any,
    highlight: prop_types_1.default.any,
};


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var index_1 = __webpack_require__(22);
var helpers_1 = __webpack_require__(27);
var HighlightsInfo = /** @class */ (function (_super) {
    __extends(HighlightsInfo, _super);
    function HighlightsInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.getHighlightStatuses = _this.getHighlightStatuses.bind(_this);
        _this.getHighlights = _this.getHighlights.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        return _this;
    }
    HighlightsInfo.prototype.toggle = function (event) {
        if (event) {
            event.stopPropagation();
        }
        helpers_1.closeActionsMenu(this.props.item._id);
        this.renderDropdown();
    };
    /**
     * Checks if the given item is in the daterange of the highlights
     * for every highlight given
     *
     * @param {array} highlights
     * @param {Object} item
     * @return {Object}
     */
    HighlightsInfo.prototype.getHighlightStatuses = function (highlights, item) {
        var _a = this.props.svc, $filter = _a.$filter, highlightsService = _a.highlightsService;
        var highlightStatuses = {};
        var highlightsById = this.props.highlightsById;
        lodash_1.forEach(highlights, function (highlight) {
            var hours = $filter('hoursFromNow')(item.versioncreated);
            highlightStatuses[highlight] = highlightsService.isInDateRange(highlightsById[highlight], hours);
        });
        return highlightStatuses;
    };
    HighlightsInfo.prototype.getHighlights = function () {
        var itemHighlights = [];
        if (helpers_1.isCheckAllowed(this.props.item)) {
            if (this.props.item.archive_item && this.props.item.archive_item.highlights &&
                this.props.item.archive_item.highlights.length) {
                itemHighlights = this.props.item.archive_item.highlights;
            }
            else {
                itemHighlights = this.props.item.highlights || [];
            }
        }
        return itemHighlights;
    };
    HighlightsInfo.prototype.render = function () {
        var $location = this.props.svc.$location;
        var highlights = this.getHighlights();
        var hasActiveHighlight = function () {
            var statuses = this.getHighlightStatuses(highlights, this.props.item);
            if ($location.path() === '/workspace/highlights') {
                return statuses[$location.search().highlight];
            }
            return highlights.some(function (h) { return statuses[h]; });
        }.call(this);
        return react_1.default.createElement('div', {
            className: 'highlights-box',
            onClick: this.toggle,
        }, highlights.length ? react_1.default.createElement('div', { className: 'highlights-list dropdown' }, react_1.default.createElement('button', { className: 'dropdown__toggle' }, react_1.default.createElement('i', {
            className: classnames_1.default({
                'icon-star': highlights.length === 1,
                'icon-multi-star': highlights.length > 1,
                red: hasActiveHighlight,
            }),
        }))) : null);
    };
    HighlightsInfo.prototype.renderDropdown = function () {
        var elem = react_1.default.createElement(index_1.HighlightsList, {
            item: this.props.item,
            highlights: this.getHighlights(),
            highlightsById: this.props.highlightsById,
            svc: this.props.svc,
            scope: this.props.scope,
        });
        var thisNode = react_dom_1.default.findDOMNode(this);
        var icon = thisNode.getElementsByClassName('icon-star')[0] ||
            thisNode.getElementsByClassName('icon-multi-star')[0];
        helpers_1.openActionsMenu(elem, icon, this.props.item._id);
    };
    return HighlightsInfo;
}(react_1.default.Component));
exports.HighlightsInfo = HighlightsInfo;
HighlightsInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    highlightsById: prop_types_1.default.any,
};


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var utils_1 = __webpack_require__(3);
var HighlightsList = /** @class */ (function (_super) {
    __extends(HighlightsList, _super);
    function HighlightsList(props) {
        var _this = _super.call(this, props) || this;
        _this.removeHighlight = _this.removeHighlight.bind(_this);
        _this.stopTimeout = _this.stopTimeout.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.closeMenu = _this.closeMenu.bind(_this);
        return _this;
    }
    HighlightsList.prototype.removeHighlight = function (highlight) {
        var _a = this.props.svc, highlightsService = _a.highlightsService, $rootScope = _a.$rootScope;
        var scope = this.props.scope;
        return function (event) {
            event.stopPropagation();
            highlightsService.markItem(highlight._id, this.props.item);
            this.closeMenu();
            if (scope.viewType === 'highlights' && this.props.item.highlights.length === 1) {
                $rootScope.$broadcast('multi:remove', this.props.item._id);
            }
        }.bind(this);
    };
    HighlightsList.prototype.componentDidMount = function () {
        this.timeout = null;
    };
    HighlightsList.prototype.componentWillUnmount = function () {
        this.stopTimeout();
    };
    HighlightsList.prototype.stopTimeout = function () {
        var $timeout = this.props.svc.$timeout;
        this.timeout = $timeout.cancel(this.timeout);
    };
    HighlightsList.prototype.closeMenu = function () {
        helpers_1.closeActionsMenu(this.props.item._id);
    };
    HighlightsList.prototype.close = function () {
        var $timeout = this.props.svc.$timeout;
        this.timeout = $timeout(this.closeMenu, 2000, false);
    };
    HighlightsList.prototype.render = function () {
        var highlightsService = this.props.svc.highlightsService;
        var highlights = this.props.highlights;
        var highlightsById = this.props.highlightsById || {};
        var createHighlight = function (id) {
            var highlight = highlightsById[id];
            if (highlight) {
                return react_1.default.createElement('li', { key: 'item-highlight-' + highlight._id }, highlight.name, highlightsService.hasMarkItemPrivilege() ? react_1.default.createElement('button', { className: 'btn btn--mini', onClick: this.removeHighlight(highlight) }, utils_1.gettext('REMOVE')) : null);
            }
        }.bind(this);
        var items = [
            react_1.default.createElement('li', { key: 'item-highlight-label' }, react_1.default.createElement('div', { className: 'dropdown__menu-label' }, utils_1.gettext('Marked For')), react_1.default.createElement('button', { className: 'dropdown__menu-close', onClick: this.closeMenu }, react_1.default.createElement('i', { className: 'icon-close-small icon--white' }))),
        ];
        return react_1.default.createElement('ul', {
            className: 'dropdown dropdown__menu highlights-list-menu open',
            onMouseEnter: this.stopTimeout,
            onMouseLeave: this.close,
        }, items.concat(highlights.map(createHighlight)));
    };
    return HighlightsList;
}(react_1.default.Component));
exports.HighlightsList = HighlightsList;
HighlightsList.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    highlights: prop_types_1.default.any,
    highlightsById: prop_types_1.default.any,
};


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var helpers_1 = __webpack_require__(27);
/**
 * @ngdoc React
 * @module superdesk.apps.search
 * @name MarkedDesksInfo
 * @param {Object} svc the services nedded: desks and $timeout
 * @param {Object} item story to be marked
 * @param {Object} markedDesksById the dict of deskId and desk object
 * @description Creates a list of desks that is used for marking a story for a desk
 */
var MarkedDesksInfo = /** @class */ (function (_super) {
    __extends(MarkedDesksInfo, _super);
    function MarkedDesksInfo(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.getMarkedDesks = _this.getMarkedDesks.bind(_this);
        _this.renderDropdown = _this.renderDropdown.bind(_this);
        return _this;
    }
    MarkedDesksInfo.prototype.toggle = function (event) {
        if (event) {
            event.stopPropagation();
        }
        helpers_1.closeActionsMenu(this.props.item._id);
        this.renderDropdown();
    };
    MarkedDesksInfo.prototype.getMarkedDesks = function () {
        var markedDesks = [];
        if (helpers_1.isCheckAllowed(this.props.item)) {
            if (this.props.item.archive_item && this.props.item.archive_item.marked_desks &&
                this.props.item.archive_item.marked_desks.length) {
                markedDesks = this.props.item.archive_item.marked_desks;
            }
            else {
                markedDesks = this.props.item.marked_desks || [];
            }
        }
        return markedDesks;
    };
    MarkedDesksInfo.prototype.render = function () {
        var markedDesks = this.getMarkedDesks();
        return (react_1.default.createElement("div", { className: "highlights-box", onClick: this.toggle }, markedDesks.length ? react_1.default.createElement("div", { className: "highlights-list dropdown" },
            react_1.default.createElement("button", { className: "dropdown__toggle" },
                react_1.default.createElement("i", { className: "icon-bell" }))) : null));
    };
    MarkedDesksInfo.prototype.renderDropdown = function () {
        var elem = react_1.default.createElement(index_1.MarkedDesksList, {
            item: this.props.item,
            desks: this.getMarkedDesks(),
            markedDesksById: this.props.markedDesksById,
            svc: this.props.svc,
        });
        var thisNode = react_dom_1.default.findDOMNode(this);
        var icon = thisNode.getElementsByClassName('icon-bell')[0] ||
            thisNode.getElementsByClassName('icon-bell')[0];
        helpers_1.openActionsMenu(elem, icon, this.props.item._id);
    };
    return MarkedDesksInfo;
}(react_1.default.Component));
exports.MarkedDesksInfo = MarkedDesksInfo;
/**
 * svc: contains $timeout and desks and is required
 * item: is the story to be marked
 * markedDesksById: dict of desks by desk id
 */
MarkedDesksInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
    markedDesksById: prop_types_1.default.any,
};


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.apps.search
 * @name MarkedDesksList
 * @param {Object} svc the services nedded: desks and $timeout
 * @param {Object} item story to be marked
 * @param {Object} markedDesksById the dict of deskId and desk object
 * @description Creates a list of desks that is used for marking a story for a desk
 */
var MarkedDesksList = /** @class */ (function (_super) {
    __extends(MarkedDesksList, _super);
    function MarkedDesksList(props) {
        var _this = _super.call(this, props) || this;
        _this.removeMarkedDesk = _this.removeMarkedDesk.bind(_this);
        _this.stopTimeout = _this.stopTimeout.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.closeMenu = _this.closeMenu.bind(_this);
        return _this;
    }
    MarkedDesksList.prototype.removeMarkedDesk = function (desk) {
        var desks = this.props.svc.desks;
        return function (event) {
            event.stopPropagation();
            desks.markItem(desk._id, this.props.item);
            this.closeMenu();
        }.bind(this);
    };
    MarkedDesksList.prototype.componentDidMount = function () {
        this.timeout = null;
    };
    MarkedDesksList.prototype.componentWillUnmount = function () {
        this.stopTimeout();
    };
    MarkedDesksList.prototype.closeMenu = function () {
        helpers_1.closeActionsMenu(this.props.item._id);
    };
    MarkedDesksList.prototype.stopTimeout = function () {
        var $timeout = this.props.svc.$timeout;
        this.timeout = $timeout.cancel(this.timeout);
    };
    MarkedDesksList.prototype.close = function () {
        var $timeout = this.props.svc.$timeout;
        this.timeout = $timeout(this.closeMenu, 2000, false);
    };
    MarkedDesksList.prototype.render = function () {
        var _this = this;
        var desks = this.props.svc.desks;
        var markedDesks = lodash_1.isString(this.props.item.marked_desks[0]) ?
            this.props.item.marked_desks : lodash_1.map(this.props.item.marked_desks, 'desk_id');
        var markedDesksById = this.props.markedDesksById || {};
        return (react_1.default.createElement("ul", { className: "dropdown dropdown__menu highlights-list-menu open", onMouseEnter: this.stopTimeout, onMouseLeave: this.close },
            react_1.default.createElement("li", { key: "item-marked-label" },
                react_1.default.createElement("div", { className: "dropdown__menu-label" },
                    utils_1.gettext('Marked For'),
                    react_1.default.createElement("button", { className: "dropdown__menu-close", onClick: this.closeMenu },
                        react_1.default.createElement("i", { className: "icon-close-small icon--white" })))),
            markedDesks.map(function (d) { return react_1.default.createElement("li", { key: 'item-marked-' + markedDesksById[d]._id },
                markedDesksById[d].name,
                desks.hasMarkItemPrivilege() ? react_1.default.createElement("button", { className: "btn btn--mini", onClick: _this.removeMarkedDesk(markedDesksById[d]) }, utils_1.gettext('REMOVE')) : null); })));
    };
    return MarkedDesksList;
}(react_1.default.Component));
exports.MarkedDesksList = MarkedDesksList;
/**
 * svc: contains $timeout and desks and is required
 * item: is the story to be marked
 * markedDesksById: dict of desks by desk id
 */
MarkedDesksList.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
    markedDesksById: prop_types_1.default.any,
};


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActionsMenu_1 = __webpack_require__(1744);
exports.ActionsMenu = ActionsMenu_1.ActionsMenu;


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var MenuItems_1 = __importDefault(__webpack_require__(1745));
var helpers_1 = __webpack_require__(27);
var ActionsMenu = /** @class */ (function (_super) {
    __extends(ActionsMenu, _super);
    function ActionsMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        _this.stopEvent = _this.stopEvent.bind(_this);
        return _this;
    }
    ActionsMenu.prototype.toggle = function (event) {
        this.stopEvent(event);
        helpers_1.closeActionsMenu(this.props.item._id);
        var icon = react_dom_1.default.findDOMNode(this)
            .getElementsByClassName('icon-dots-vertical')[0];
        helpers_1.openActionsMenu(react_1.default.createElement(MenuItems_1.default, { svc: this.props.svc, scope: this.props.scope, item: this.props.item, onActioning: this.props.onActioning }), icon, this.props.item._id);
    };
    ActionsMenu.prototype.stopEvent = function (event) {
        event.stopPropagation();
    };
    ActionsMenu.prototype.render = function () {
        return this.props.template(this.toggle, this.stopEvent);
    };
    return ActionsMenu;
}(react_1.default.Component));
exports.ActionsMenu = ActionsMenu;
ActionsMenu.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    onActioning: prop_types_1.default.func,
    template: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var Label_1 = __importDefault(__webpack_require__(1746));
var Divider_1 = __importDefault(__webpack_require__(1747));
var Item_1 = __importDefault(__webpack_require__(1748));
var SubmenuDropdown_1 = __importDefault(__webpack_require__(1749));
var constants_1 = __webpack_require__(570);
var helpers_1 = __webpack_require__(27);
var utils_1 = __webpack_require__(3);
var MenuItems = /** @class */ (function (_super) {
    __extends(MenuItems, _super);
    function MenuItems(props) {
        var _this = _super.call(this, props) || this;
        _this.getActions = _this.getActions.bind(_this);
        _this.getType = _this.getType.bind(_this);
        _this.renderMenu = _this.renderMenu.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        return _this;
    }
    MenuItems.prototype.componentDidMount = function () {
        document.addEventListener('click', this.handleClickOutside, true);
    };
    MenuItems.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.handleClickOutside, true);
    };
    MenuItems.prototype.handleClickOutside = function (event) {
        var domNode = react_dom_1.default.findDOMNode(helpers_1.menuHolderElem());
        if (!domNode || !domNode.contains(event.target)) {
            helpers_1.closeActionsMenu(this.props.item._id);
        }
    };
    MenuItems.prototype.getActions = function () {
        var item = this.props.item;
        var type = this.getType();
        var intent = { action: 'list', type: type };
        var groups = {};
        var _a = this.props.svc, superdesk = _a.superdesk, workflowService = _a.workflowService;
        superdesk.findActivities(intent, item).forEach(function (activity) {
            if (workflowService.isActionAllowed(item, activity.action) && activity.list !== false) {
                var group = activity.group || 'default';
                groups[group] = groups[group] || [];
                groups[group].push(activity);
            }
        });
        return groups;
    };
    MenuItems.prototype.getType = function () {
        var archiveService = this.props.svc.archiveService;
        return archiveService.getType(this.props.item);
    };
    MenuItems.prototype.renderMenu = function () {
        var _this = this;
        var menu = [];
        var item = this.props.item;
        var createAction = function (activity) {
            return react_1.default.createElement(Item_1.default, { key: activity._id, svc: _this.props.svc, scope: _this.props.scope, item: item, activity: activity, onActioning: _this.props.onActioning });
        };
        var actions = this.getActions();
        constants_1.AUTHORING_MENU_GROUPS.map(function (group) {
            if (actions[group._id]) {
                if (group.label === 'Actions') {
                    menu.push(react_1.default.createElement(Label_1.default, { label: group.label, key: "group-label-" + group._id, item: _this.props.item }), react_1.default.createElement(Divider_1.default, { key: "group-divider-" + group._id }));
                }
                else if (group.concate) {
                    var submenu = actions[group._id].map(function (action) { return createAction(action); });
                    menu.push(react_1.default.createElement("li", { key: "group-label-" + group._id },
                        react_1.default.createElement(SubmenuDropdown_1.default, { label: utils_1.gettext(group.label), submenu: submenu, icon: actions[group._id][0].icon })));
                    return null;
                }
                else {
                    menu.push(react_1.default.createElement(Divider_1.default, { key: "group-divider-" + group._id }));
                }
                menu.push.apply(menu, actions[group._id].map(createAction));
            }
            return null;
        });
        // adding menu item for the groups that are not define above
        Object.keys(actions).forEach(function (groupName) {
            var existingGroup = constants_1.AUTHORING_MENU_GROUPS.find(function (g) { return g._id === groupName; });
            if (!existingGroup) {
                menu.push(react_1.default.createElement(Divider_1.default, { key: "group-divider-" + groupName }));
                menu.push.apply(menu, actions[groupName].map(createAction));
            }
        });
        return menu;
    };
    MenuItems.prototype.render = function () {
        if (this.renderMenu().length > 0) {
            return (react_1.default.createElement("ul", { className: "dropdown dropdown__menu more-activity-menu open", style: { display: 'block', minWidth: 200 } }, this.renderMenu()));
        }
        else {
            return react_1.default.createElement("ul", null);
        }
    };
    return MenuItems;
}(react_1.default.Component));
exports.default = MenuItems;
MenuItems.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    onActioning: prop_types_1.default.func,
};


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(27);
var utils_1 = __webpack_require__(3);
var Label = function (props) {
    return react_1.default.createElement('li', null, react_1.default.createElement('div', {
        className: 'dropdown__menu-label',
    }, utils_1.gettext(props.label), props.label === 'Actions' ? react_1.default.createElement('button', { className: 'dropdown__menu-close', onClick: function () {
            helpers_1.closeActionsMenu(props.item._id);
        } }, react_1.default.createElement('i', { className: 'icon-close-small' })) : null));
};
Label.propTypes = {
    label: prop_types_1.default.any,
    item: prop_types_1.default.object,
};
exports.default = Label;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
function Divider() {
    return react_1.default.createElement('li', { className: 'dropdown__menu-divider' });
}
exports.default = Divider;


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var prop_types_1 = __importDefault(__webpack_require__(1));
var constants_1 = __webpack_require__(247);
var utils_1 = __webpack_require__(3);
var helpers_1 = __webpack_require__(27);
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        _this.run = _this.run.bind(_this);
        _this.open = _this.open.bind(_this);
        _this.setPosition = _this.setPosition.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.closeMenu = _this.closeMenu.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.updateActioningStatus = _this.updateActioningStatus.bind(_this);
        return _this;
    }
    Item.prototype.updateActioningStatus = function (isActioning) {
        if (!this.props.item.gone) {
            this.props.onActioning(isActioning);
        }
    };
    Item.prototype.run = function (event) {
        var _this = this;
        var scope = this.props.scope;
        var activityService = this.props.svc.activityService;
        // Stop event propagation so that click on item action
        // won't select that item for preview/authoring.
        event.stopPropagation();
        this.updateActioningStatus(true);
        scope.$apply(function () {
            activityService.start(_this.props.activity, { data: { item: _this.props.item } })
                .finally(function () { return _this.updateActioningStatus(false); });
        });
        helpers_1.closeActionsMenu(this.props.item._id);
    };
    Item.prototype.open = function () {
        var $timeout = this.props.svc.$timeout;
        $timeout.cancel(this.closeTimeout);
        this.closeTimeout = null;
        if (!this.state.open) {
            this.setPosition();
            this.setState({ open: true });
        }
    };
    Item.prototype.setPosition = function () {
        var thisNode = react_dom_1.default.findDOMNode(this);
        var targetRect = thisNode.getBoundingClientRect();
        var BUFFER = 250;
        if (targetRect.left < constants_1.LEFT_SIDEBAR_WIDTH + BUFFER) {
            this.setState({ position: 'dropdown__menu--submenu-right' });
        }
        else {
            this.setState({ position: 'dropdown__menu--submenu-left' });
        }
    };
    Item.prototype.close = function () {
        var _this = this;
        var $timeout = this.props.svc.$timeout;
        if (this.state.open && !this.closeTimeout) {
            this.closeTimeout = $timeout(function () {
                _this.closeTimeout = null;
                _this.setState({ open: false });
            }, 100, false);
        }
    };
    Item.prototype.closeMenu = function (event) {
        // called by the onclick event of the submenu dropdown to close actions menu.
        event.stopPropagation();
        helpers_1.closeActionsMenu(this.props.item._id);
    };
    Item.prototype.toggle = function (event) {
        if (!this.state.open) {
            this.open();
        }
        else {
            this.close();
            this.closeMenu(event);
        }
    };
    Item.prototype.componentWillUnmount = function () {
        var $timeout = this.props.svc.$timeout;
        $timeout.cancel(this.closeTimeout);
        this.closeTimeout = null;
    };
    Item.prototype.render = function () {
        var $injector = this.props.svc.$injector;
        var activity = this.props.activity;
        var invoke = typeof activity.dropdown === 'function' || typeof activity.dropdown === 'object';
        if (activity.dropdown) {
            return react_1.default.createElement('li', { onMouseEnter: this.open, onMouseLeave: this.close, onClick: this.toggle }, react_1.default.createElement('div', { className: 'dropdown dropdown--noarrow' + (this.state.open ? ' open' : '') }, react_1.default.createElement('a', {
                className: 'dropdown__toggle',
                title: utils_1.gettext(activity.label),
            }, activity.icon ? react_1.default.createElement('i', {
                className: 'icon-' + activity.icon,
            }, '') : null, utils_1.gettext(activity.label)), this.state.open && invoke ? $injector.invoke(activity.dropdown, activity, {
                item: this.props.item,
                className: 'dropdown__menu upward ' + this.state.position,
                noHighlightsLabel: utils_1.gettext('No available highlights'),
                noDesksLabel: utils_1.gettext('No available desks'),
                noLanguagesLabel: utils_1.gettext('No available translations'),
            }) : null));
        }
        return react_1.default.createElement('li', null, react_1.default.createElement('a', { title: utils_1.gettext(activity.label), onClick: this.run }, react_1.default.createElement('i', {
            className: 'icon-' + activity.icon,
        }), react_1.default.createElement('span', {
            style: { display: 'inline' },
        }, utils_1.gettext(activity.label))));
    };
    return Item;
}(react_1.default.Component));
exports.default = Item;
Item.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    item: prop_types_1.default.any,
    activity: prop_types_1.default.any,
    onActioning: prop_types_1.default.func,
};


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var Submenu_1 = __importDefault(__webpack_require__(1750));
/**
 * Submenu within item actions.
 */
var SubmenuDropdown = /** @class */ (function (_super) {
    __extends(SubmenuDropdown, _super);
    function SubmenuDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: false };
        _this.openSubmenu = _this.openSubmenu.bind(_this);
        _this.closeSubmenu = _this.closeSubmenu.bind(_this);
        return _this;
    }
    SubmenuDropdown.prototype.openSubmenu = function () {
        this.setState({ open: true });
    };
    SubmenuDropdown.prototype.closeSubmenu = function () {
        this.setState({ open: false });
    };
    SubmenuDropdown.prototype.toggleState = function (event) {
        event.stopPropagation();
        this.setState({ open: !this.state.open });
    };
    SubmenuDropdown.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "dropdown dropdown--noarrow", onMouseEnter: this.openSubmenu, onMouseLeave: this.closeSubmenu },
            react_1.default.createElement("a", { className: "dropdown__toggle", title: this.props.label },
                this.props.icon &&
                    react_1.default.createElement("i", { className: "icon-" + this.props.icon }),
                this.props.label),
            this.state.open && (react_1.default.createElement(Submenu_1.default, null, this.props.submenu))));
    };
    return SubmenuDropdown;
}(react_1.default.Component));
exports.default = SubmenuDropdown;
SubmenuDropdown.propTypes = {
    icon: prop_types_1.default.string,
    label: prop_types_1.default.string,
    submenu: prop_types_1.default.arrayOf(prop_types_1.default.element),
};


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var constants_1 = __webpack_require__(247);
/**
 * Submenu in SubmenuDropdown.
 *
 * When added to dom it checks its position and if it goes too far left
 * it will toggle the class to stay on the right side.
 */
var Submenu = /** @class */ (function (_super) {
    __extends(Submenu, _super);
    function Submenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { position: 'left' };
        return _this;
    }
    Submenu.prototype.componentDidMount = function () {
        var rect = this.element.getBoundingClientRect();
        if (rect.left <= constants_1.LEFT_SIDEBAR_WIDTH) {
            this.setState({ position: 'right' });
        }
    };
    Submenu.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("ul", { className: 'dropdown__menu foo dropdown__menu--submenu-' + this.state.position, ref: function (ref) { return _this.element = ref; } }, this.props.children));
    };
    return Submenu;
}(react_1.default.Component));
exports.default = Submenu;
Submenu.propTypes = {
    children: prop_types_1.default.arrayOf(prop_types_1.default.node),
};


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var utils_1 = __webpack_require__(3);
exports.ErrorBox = function (props) {
    return react_1.default.createElement('div', { className: 'error-box' }, react_1.default.createElement('p', { className: 'message' }, utils_1.gettext('There was an error archiving this item')), react_1.default.createElement('div', { className: 'buttons' }));
};
exports.ErrorBox.propTypes = {};


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var fields_1 = __webpack_require__(160);
var index_1 = __webpack_require__(22);
var helpers_1 = __webpack_require__(27);
var ItemSwimlane_1 = __webpack_require__(1753);
var ItemPhotoGrid_1 = __webpack_require__(1755);
var ItemListTemplate_1 = __webpack_require__(1757);
var ItemMgridTemplate_1 = __webpack_require__(1758);
var CLICK_TIMEOUT = 300;
var actionsMenuDefaultTemplate = function (toggle, stopEvent) { return (react_1.default.createElement("div", { className: "item-right toolbox" },
    react_1.default.createElement("div", { className: "item-actions-menu dropdown--big open" },
        react_1.default.createElement("button", { className: 'more-activity-toggle condensed dropdown__toggle', onClick: toggle, onDoubleClick: stopEvent },
            react_1.default.createElement("i", { className: "icon-dots-vertical" }))))); };
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hover: false, actioning: false, isActionMenuOpen: false, showNested: false };
        _this.select = _this.select.bind(_this);
        _this.edit = _this.edit.bind(_this);
        _this.dbClick = _this.dbClick.bind(_this);
        _this.setActioningState = _this.setActioningState.bind(_this);
        _this.setHoverState = _this.setHoverState.bind(_this);
        _this.unsetHoverState = _this.unsetHoverState.bind(_this);
        _this.onDragStart = _this.onDragStart.bind(_this);
        _this.openAuthoringView = _this.openAuthoringView.bind(_this);
        _this.toggleNested = _this.toggleNested.bind(_this);
        return _this;
    }
    Item.prototype.componentWillMount = function () {
        if (lodash_1.get(this.props, 'svc.config.apps', []).includes('superdesk-planning')) {
            this.loadPlanningModals();
        }
    };
    Item.prototype.componentWillUnmount = function () {
        helpers_1.closeActionsMenu(this.props.item._id);
    };
    Item.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.item !== this.props.item) {
            helpers_1.closeActionsMenu(this.props.item._id);
        }
    };
    Item.prototype.loadPlanningModals = function () {
        var _this = this;
        var _a = this.props.svc, session = _a.session, superdesk = _a.superdesk, activityService = _a.activityService;
        if (!['add_to_planning', 'fulfil_assignment'].includes(lodash_1.get(this.props, 'item.lock_action')) ||
            lodash_1.get(this.props, 'item.lock_user') !== session.identity._id ||
            lodash_1.get(this.props, 'item.lock_session') !== session.sessionId) {
            return;
        }
        var planningActivity;
        var activities = superdesk.findActivities({ action: 'list', type: 'archive' }, this.props.item);
        // Planning: if page probably was refreshed / loaded during the add-to-planning operation,
        // reload the add-to-planning modal
        if (this.props.item.lock_action === 'add_to_planning') {
            planningActivity = activities.find(function (a) { return a._id === 'planning.addto'; });
        }
        else if (this.props.item.lock_action === 'fulfil_assignment') {
            planningActivity = activities.find(function (a) { return a._id === 'planning.fulfil'; });
        }
        if (planningActivity) {
            this.setActioningState(true);
            activityService.start(planningActivity, { data: { item: this.props.item } })
                .finally(function () { return _this.setActioningState(false); });
        }
    };
    Item.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.swimlane !== this.props.swimlane || nextProps.item !== this.props.item ||
            nextProps.view !== this.props.view ||
            nextProps.flags.selected !== this.props.flags.selected ||
            nextProps.narrow !== this.props.narrow ||
            nextProps.actioning !== this.props.actioning ||
            nextState !== this.state;
    };
    Item.prototype.select = function (event) {
        var _this = this;
        if (!this.props.item.gone && !this.clickTimeout) {
            event.persist(); // make event available in timeout callback
            this.clickTimeout = window.setTimeout(function () {
                _this.clickTimeout = null;
                _this.props.onSelect(_this.props.item, event);
            }, CLICK_TIMEOUT);
        }
    };
    /**
     * Opens the item in authoring in view mode
     * @param {string} itemId Id of the document
     */
    Item.prototype.openAuthoringView = function (itemId) {
        var authoringWorkspace = this.props.svc.authoringWorkspace;
        authoringWorkspace.edit({ _id: itemId }, 'view');
    };
    Item.prototype.edit = function (event) {
        if (!this.props.item.gone) {
            this.props.onEdit(this.props.item);
        }
    };
    Item.prototype.dbClick = function (event) {
        if (this.clickTimeout) {
            window.clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
        }
        if (!this.props.item.gone) {
            this.props.onDbClick(this.props.item);
        }
    };
    /**
     * Set Actioning state
     * @param {Boolean} isActioning - true if activity is in-progress, and false if completed
     */
    Item.prototype.setActioningState = function (isActioning) {
        this.setState({ actioning: isActioning });
    };
    Item.prototype.setHoverState = function () {
        this.setState({ hover: true });
    };
    Item.prototype.unsetHoverState = function () {
        this.setState({ hover: false });
    };
    Item.prototype.onDragStart = function (event) {
        var dragitem = this.props.svc.dragitem;
        dragitem.start(event, this.props.item);
    };
    Item.prototype.toggleNested = function (event) {
        event.stopPropagation();
        this.setState({ showNested: !this.state.showNested });
    };
    Item.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, scope = _a.scope;
        var classes = this.props.view === 'photogrid' ?
            'sd-grid-item sd-grid-item--with-click' :
            'media-box media-' + item.type;
        // Customize item class from its props
        if (scope.customRender && typeof scope.customRender.getItemClass === 'function') {
            classes = classes + " " + scope.customRender.getItemClass(item);
        }
        var isLocked = (item.lock_user && item.lock_session) != null;
        var getActionsMenu = function (template) {
            if (template === void 0) { template = actionsMenuDefaultTemplate; }
            return _this.props.hideActions !== true && _this.state.hover && !item.gone ? react_1.default.createElement(index_1.ActionsMenu, {
                item: item,
                svc: _this.props.svc,
                scope: _this.props.scope,
                onActioning: _this.setActioningState,
                template: template,
            }) : null;
        };
        var getTemplate = function () {
            switch (_this.props.view) {
                case 'swimlane2':
                    return (react_1.default.createElement(ItemSwimlane_1.ItemSwimlane, { item: item, isLocked: isLocked, getActionsMenu: getActionsMenu, onMultiSelect: _this.props.onMultiSelect, svc: _this.props.svc }));
                case 'mgrid':
                    return (react_1.default.createElement(ItemMgridTemplate_1.ItemMgridTemplate, { item: item, desk: _this.props.desk, swimlane: _this.props.swimlane, svc: _this.props.svc, ingestProvider: _this.props.ingestProvider, onMultiSelect: _this.props.onMultiSelect, broadcast: fields_1.broadcast, getActionsMenu: getActionsMenu }));
                case 'photogrid':
                    return (react_1.default.createElement(ItemPhotoGrid_1.ItemPhotoGrid, { item: item, desk: _this.props.desk, ingestProvider: _this.props.ingestProvider, svc: _this.props.svc, swimlane: _this.props.swimlane, onMultiSelect: _this.props.onMultiSelect, getActionsMenu: getActionsMenu }));
                default:
                    return (react_1.default.createElement(ItemListTemplate_1.ListItemTemplate, { item: item, desk: _this.props.desk, svc: _this.props.svc, openAuthoringView: _this.openAuthoringView, ingestProvider: _this.props.ingestProvider, highlightsById: _this.props.highlightsById, markedDesksById: _this.props.markedDesksById, profilesById: _this.props.profilesById, swimlane: _this.props.swimlane, versioncreator: _this.props.versioncreator, narrow: _this.props.narrow, onMultiSelect: _this.props.onMultiSelect, getActionsMenu: getActionsMenu, scope: _this.props.scope, selectingDisabled: _this.props.multiSelectDisabled, showNested: _this.state.showNested, nestedCount: _this.props.nested.length, toggleNested: _this.toggleNested }));
            }
        };
        var getNested = function () {
            switch (_this.props.view) {
                case 'swimlane2':
                case 'mgrid':
                case 'photogrid':
                    return null;
                default:
                    if (!_this.props.nested.length || !_this.state.showNested) {
                        return null;
                    }
                    return (react_1.default.createElement("div", { className: "sd-list-item-nested__childs sd-shadow--z1" }, _this.props.nested.map(function (childItem) { return (react_1.default.createElement(Item, { item: childItem, key: childItem._id + childItem._current_version, svc: _this.props.svc, scope: _this.props.scope, flags: {}, nested: [], profilesById: _this.props.profilesById, isNested: true, narrow: true, hideActions: true, onSelect: function () { return null; }, multiSelectDisabled: false, swimlane: _this.props.swimlane, highlightsById: _this.props.highlightsById, markedDesksById: _this.props.markedDesksById, ingestProvider: _this.props.ingestProvider, desk: _this.props.desk, view: _this.props.view, versioncreator: _this.props.versioncreator, onEdit: _this.props.onEdit, onDbClick: _this.props.onDbClick, onMultiSelect: _this.props.onMultiSelect, actioning: false })); })));
            }
        };
        // avoid any actions on nested items
        var getCallback = function (func) { return _this.props.isNested ? function (event) { return event.stopPropagation(); } : func; };
        return react_1.default.createElement(this.props.isNested ? 'div' : 'li', {
            id: item._id,
            key: item._id,
            className: classnames_1.default('list-item-view', {
                'actions-visible': this.props.hideActions !== true,
                active: this.props.flags.selected,
                selected: this.props.item.selected && !this.props.flags.selected,
                'sd-list-item-nested': this.props.nested.length,
                'sd-list-item-nested--expanded': this.props.nested.length && this.state.showNested,
                'sd-list-item-nested--collapsed': this.props.nested.length && this.state.showNested === false,
            }),
            onMouseEnter: getCallback(this.setHoverState),
            onMouseLeave: getCallback(this.unsetHoverState),
            onDragStart: getCallback(this.onDragStart),
            onClick: getCallback(this.select),
            onDoubleClick: getCallback(this.dbClick),
            draggable: !this.props.isNested,
        }, (react_1.default.createElement("div", { className: classnames_1.default(classes, {
                active: this.props.flags.selected,
                locked: isLocked,
                selected: this.props.item.selected || this.props.flags.selected,
                archived: item.archived || item.created,
                gone: item.gone,
                actioning: this.state.actioning || this.props.actioning,
            }) }, getTemplate())), getNested());
    };
    return Item;
}(react_1.default.Component));
exports.Item = Item;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var lodash_1 = __webpack_require__(2);
var classnames_1 = __importDefault(__webpack_require__(4));
var ListTypeIcon_1 = __webpack_require__(249);
var SwimlaneField_1 = __webpack_require__(1754);
var constants_1 = __webpack_require__(73);
var renderGroup = function (groups, item, svc) { return groups.map(function (group, groupIndex) { return (react_1.default.createElement("span", { key: groupIndex, className: classnames_1.default({
        'sd-list-item__column': true,
        'sd-list-item__column--grow': group.ellipsis === true,
        'sd-list-item__column--no-border': groupIndex === groups.length - 1,
    }) },
    react_1.default.createElement("span", { className: "sd-list-item__row" },
        react_1.default.createElement("span", { className: classnames_1.default({ 'sd-overflow-ellipsis': group.ellipsis === true }) }, group.fields
            .map(function (field, fieldIndex) { return (react_1.default.createElement(SwimlaneField_1.SwimlaneField, { key: fieldIndex, fieldId: field, item: item, svc: svc })); }))))); }); };
var ItemSwimlane = /** @class */ (function (_super) {
    __extends(ItemSwimlane, _super);
    function ItemSwimlane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemSwimlane.prototype.render = function () {
        var _a = this.props, item = _a.item, isLocked = _a.isLocked, getActionsMenu = _a.getActionsMenu, svc = _a.svc;
        var swimlaneViewFieldsConfig = lodash_1.get(this.props.svc.config, 'swimlaneViewFields', constants_1.DEFAULT_SWIMLANE_FIELDS_CONFIG);
        return (react_1.default.createElement("div", { className: "sd-list-item", style: { borderBottom: '1px solid #e7e7e7' } },
            react_1.default.createElement("span", { style: {
                    minWidth: '4px',
                    maxWidth: '4px',
                    background: isLocked ? '#e51c23' : 'transparent',
                } }),
            react_1.default.createElement("span", { className: "sd-list-item__column" },
                react_1.default.createElement(ListTypeIcon_1.ListTypeIcon, { item: item, onMultiSelect: this.props.onMultiSelect, svc: svc })),
            renderGroup(swimlaneViewFieldsConfig.left, item, svc),
            react_1.default.createElement("span", { className: "sd-list-item--element-grow" }),
            renderGroup(swimlaneViewFieldsConfig.right, item, svc),
            getActionsMenu(function (toggle, stopEvent) { return (react_1.default.createElement("div", { className: "sd-list-item__action-menu" },
                react_1.default.createElement("button", { className: "icn-btn", onClick: toggle, onDoubleClick: stopEvent },
                    react_1.default.createElement("i", { className: "icon-dots-vertical" })))); })));
    };
    return ItemSwimlane;
}(react_1.default.Component));
exports.ItemSwimlane = ItemSwimlane;


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var fields = __importStar(__webpack_require__(160));
exports.SwimlaneField = function (props) {
    var item = props.item, fieldId = props.fieldId;
    var customRenderedAvailable = typeof fields[fieldId] === 'function';
    var value = customRenderedAvailable
        ? fields[fieldId]({ item: item, svc: props.svc })
        : item[fieldId];
    if (value == null) {
        return null;
    }
    return value;
};


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var PhotoDeskPreview_1 = __webpack_require__(564);
var PhotoDeskInfo_1 = __webpack_require__(566);
var PhotoDeskFooter_1 = __webpack_require__(1756);
var ItemPhotoGrid = /** @class */ (function (_super) {
    __extends(ItemPhotoGrid, _super);
    function ItemPhotoGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemPhotoGrid.prototype.render = function () {
        var item = this.props.item;
        return (react_1.default.createElement("div", { className: "sd-wrap-helper" },
            react_1.default.createElement(PhotoDeskPreview_1.PhotoDeskPreview, { item: item, desk: this.props.desk, onMultiSelect: this.props.onMultiSelect, swimlane: this.props.swimlane, svc: this.props.svc }),
            react_1.default.createElement(PhotoDeskInfo_1.PhotoDeskInfo, { item: item, ingestProvider: this.props.ingestProvider, svc: this.props.svc }),
            react_1.default.createElement(PhotoDeskFooter_1.PhotoDeskFooter, { item: item, svc: this.props.svc, getActionsMenu: this.props.getActionsMenu }),
            react_1.default.createElement("div", { className: "sd-grid-item__state-border" })));
    };
    return ItemPhotoGrid;
}(react_1.default.Component));
exports.ItemPhotoGrid = ItemPhotoGrid;


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __importDefault(__webpack_require__(2));
var PhotoDeskFields_1 = __webpack_require__(567);
var constants_1 = __webpack_require__(73);
exports.PhotoDeskFooter = function (props) {
    var item = props.item, svc = props.svc;
    var gridViewFooterFieldsConfig = lodash_1.default.get(svc.config, 'gridViewFooterFields', constants_1.DEFAULT_GRID_VIEW_FOOTER_CONFIG);
    var fieldsLeft = gridViewFooterFieldsConfig.left;
    var fieldsRight = gridViewFooterFieldsConfig.right;
    return (react_1.default.createElement("div", { className: "sd-grid-item__footer" },
        Array.isArray(fieldsLeft) === true && fieldsLeft.length > 0 ? (react_1.default.createElement("div", { className: "sd-grid-item__footer-block sd-grid-item__footer-block--multi-l" },
            react_1.default.createElement(PhotoDeskFields_1.PhotoDeskFields, { fieldsConfig: fieldsLeft, item: item, svc: svc, labelMode: "never-with-custom-renderer", itemClassName: "" }))) : null,
        Array.isArray(fieldsRight) === true && fieldsRight.length > 0 ? (react_1.default.createElement("div", { className: "sd-grid-item__footer-block sd-grid-item__footer-block--multi-r" },
            react_1.default.createElement(PhotoDeskFields_1.PhotoDeskFields, { fieldsConfig: fieldsRight, item: item, svc: svc, labelMode: "never-with-custom-renderer", itemClassName: "" }))) : null,
        props.getActionsMenu == null ? null : props.getActionsMenu()));
};
exports.PhotoDeskFooter.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.any,
    getActionsMenu: prop_types_1.default.func,
};


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var ListTypeIcon_1 = __webpack_require__(249);
var ListPriority_1 = __webpack_require__(569);
var ListItemInfo_1 = __webpack_require__(571);
var ListItemTemplate = /** @class */ (function (_super) {
    __extends(ListItemTemplate, _super);
    function ListItemTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListItemTemplate.prototype.render = function () {
        var item = this.props.item;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: "state-border" }),
            react_1.default.createElement(ListTypeIcon_1.ListTypeIcon, { item: item, onMultiSelect: this.props.onMultiSelect, svc: this.props.svc, selectingDisabled: this.props.selectingDisabled }),
            item.priority || item.urgency
                ? react_1.default.createElement(ListPriority_1.ListPriority, { item: item, svc: this.props.svc, scope: this.props.scope })
                : null,
            react_1.default.createElement(ListItemInfo_1.ListItemInfo, { item: item, openAuthoringView: this.props.openAuthoringView, desk: this.props.desk, ingestProvider: this.props.ingestProvider, highlightsById: this.props.highlightsById, markedDesksById: this.props.markedDesksById, profilesById: this.props.profilesById, swimlane: this.props.swimlane, versioncreator: this.props.versioncreator, narrow: this.props.narrow, svc: this.props.svc, scope: this.props.scope, showNested: this.props.showNested, nestedCount: this.props.nestedCount, toggleNested: this.props.toggleNested }),
            this.props.getActionsMenu()));
    };
    return ListItemTemplate;
}(react_1.default.Component));
exports.ListItemTemplate = ListItemTemplate;


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var MediaPreview_1 = __webpack_require__(563);
var MediaInfo_1 = __webpack_require__(565);
var GridTypeIcon_1 = __webpack_require__(568);
var ItemPriority_1 = __webpack_require__(561);
var ItemUrgency_1 = __webpack_require__(562);
var ItemMgridTemplate = /** @class */ (function (_super) {
    __extends(ItemMgridTemplate, _super);
    function ItemMgridTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemMgridTemplate.prototype.render = function () {
        var item = this.props.item;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(MediaPreview_1.MediaPreview, { item: item, desk: this.props.desk, onMultiSelect: this.props.onMultiSelect, swimlane: this.props.swimlane, svc: this.props.svc }),
            react_1.default.createElement(MediaInfo_1.MediaInfo, { item: item, ingestProvider: this.props.ingestProvider, svc: this.props.svc }),
            react_1.default.createElement("div", { className: "media-box__footer" },
                react_1.default.createElement(GridTypeIcon_1.GridTypeIcon, { item: item, svc: this.props.svc }),
                item.priority ? react_1.default.createElement(ItemPriority_1.ItemPriority, __assign({}, angular.extend({ svc: this.props.svc }, item))) : null,
                item.urgency ? react_1.default.createElement(ItemUrgency_1.ItemUrgency, __assign({}, angular.extend({ svc: this.props.svc }, item))) : null,
                this.props.broadcast({ item: item }),
                this.props.getActionsMenu())));
    };
    return ItemMgridTemplate;
}(react_1.default.Component));
exports.ItemMgridTemplate = ItemMgridTemplate;


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importStar(__webpack_require__(2));
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var index_1 = __webpack_require__(22);
var helpers_1 = __webpack_require__(27);
var querySelectorParent_1 = __webpack_require__(1760);
var utils_1 = __webpack_require__(3);
/**
 * Item list component
 */
var ItemList = /** @class */ (function (_super) {
    __extends(ItemList, _super);
    function ItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            itemsList: [],
            itemsById: {},
            selected: null,
            view: 'compact',
            narrow: false,
            bindedShortcuts: [],
            swimlane: null,
            actioning: {},
        };
        _this.multiSelect = _this.multiSelect.bind(_this);
        _this.select = _this.select.bind(_this);
        _this.selectItem = _this.selectItem.bind(_this);
        _this.selectMultipleItems = _this.selectMultipleItems.bind(_this);
        _this.dbClick = _this.dbClick.bind(_this);
        _this.edit = _this.edit.bind(_this);
        _this.deselectAll = _this.deselectAll.bind(_this);
        _this.updateAllItems = _this.updateAllItems.bind(_this);
        _this.findItemByPrefix = _this.findItemByPrefix.bind(_this);
        _this.setSelectedItem = _this.setSelectedItem.bind(_this);
        _this.getSelectedItem = _this.getSelectedItem.bind(_this);
        _this.updateItem = _this.updateItem.bind(_this);
        _this.handleKey = _this.handleKey.bind(_this);
        _this.closeActionsMenu = helpers_1.closeActionsMenu.bind(_this);
        _this.setSelectedComponent = _this.setSelectedComponent.bind(_this);
        _this.modifiedUserName = _this.modifiedUserName.bind(_this);
        _this.setNarrowView = _this.setNarrowView.bind(_this);
        _this.multiSelectCurrentItem = _this.multiSelectCurrentItem.bind(_this);
        _this.bindActionKeyShortcuts = _this.bindActionKeyShortcuts.bind(_this);
        _this.unbindActionKeyShortcuts = _this.unbindActionKeyShortcuts.bind(_this);
        return _this;
    }
    ItemList.prototype.multiSelect = function (items, selected, event) {
        var _a = this.props.svc, search = _a.search, multi = _a.multi;
        var scope = this.props.scope;
        var itemsById = angular.extend({}, this.state.itemsById);
        items.forEach(function (item) {
            var itemId = search.generateTrackByIdentifier(item);
            itemsById[itemId] = angular.extend({}, item, { selected: selected });
            scope.$applyAsync(function () {
                multi.toggle(itemsById[itemId]);
            });
        });
        this.select(lodash_1.default.last(items), event);
        this.setState({ itemsById: itemsById });
    };
    // Method to check the selectBox of the selected item
    ItemList.prototype.multiSelectCurrentItem = function () {
        var selectedItem = this.getSelectedItem();
        if (selectedItem) {
            this.multiSelect([selectedItem], !selectedItem.selected);
        }
    };
    // Function to make narrowView active/inactive
    ItemList.prototype.setNarrowView = function (setNarrow) {
        this.setState({ narrow: setNarrow });
    };
    ItemList.prototype.select = function (item, event) {
        var _this = this;
        if (typeof this.props.onMonitoringItemSelect === 'function') {
            this.props.onMonitoringItemSelect(item, event);
            return;
        }
        var $timeout = this.props.svc.$timeout;
        var scope = this.props.scope;
        if (event && event.shiftKey) {
            return this.selectMultipleItems(item);
        }
        this.setSelectedItem(item);
        if (event && event.ctrlKey) {
            return this.selectItem(item);
        }
        $timeout.cancel(this.updateTimeout);
        var showPreview = (event == null || event.target == null) ||
            querySelectorParent_1.querySelectorParent(event.target, '.sd-monitoring-item-multi-select-checkbox') == null;
        if (item && scope.preview) {
            scope.$apply(function () {
                if (showPreview) {
                    scope.preview(item);
                }
                _this.bindActionKeyShortcuts(item);
            });
        }
    };
    /*
     * Unbind all item actions
     */
    ItemList.prototype.unbindActionKeyShortcuts = function () {
        var keyboardManager = this.props.svc.keyboardManager;
        this.state.bindedShortcuts.forEach(function (shortcut) {
            keyboardManager.unbind(shortcut);
        });
        this.setState({ bindedShortcuts: [] });
    };
    /*
     * Bind item actions on keyboard shortcuts
     * Keyboard shortcuts are defined with actions
     *
     * @param {Object} item
     */
    ItemList.prototype.bindActionKeyShortcuts = function (selectedItem) {
        var _this = this;
        var _a = this.props.svc, superdesk = _a.superdesk, workflowService = _a.workflowService, activityService = _a.activityService, keyboardManager = _a.keyboardManager, archiveService = _a.archiveService;
        // First unbind all binded shortcuts
        if (this.state.bindedShortcuts.length) {
            this.unbindActionKeyShortcuts();
        }
        var intent = { action: 'list', type: archiveService.getType(selectedItem) };
        superdesk.findActivities(intent, selectedItem).forEach(function (activity) {
            if (activity.keyboardShortcut && workflowService.isActionAllowed(selectedItem, activity.action)) {
                _this.state.bindedShortcuts.push(activity.keyboardShortcut);
                keyboardManager.bind(activity.keyboardShortcut, function () {
                    if (lodash_1.default.includes(['mark.item', 'mark.desk'], activity._id)) {
                        helpers_1.bindMarkItemShortcut(activity.label);
                    }
                    else {
                        activityService.start(activity, { data: { item: selectedItem } });
                    }
                });
            }
        });
    };
    ItemList.prototype.selectItem = function (item) {
        if (helpers_1.isCheckAllowed(item)) {
            var selected = !item.selected;
            this.multiSelect([item], selected);
        }
    };
    ItemList.prototype.selectMultipleItems = function (lastItem) {
        var search = this.props.svc.search;
        var itemId = search.generateTrackByIdentifier(lastItem);
        var positionStart = 0;
        var positionEnd = lodash_1.default.indexOf(this.state.itemsList, itemId);
        var selectedItems = [];
        if (this.state.selected) {
            positionStart = lodash_1.default.indexOf(this.state.itemsList, this.state.selected);
        }
        var start = Math.min(positionStart, positionEnd);
        var end = Math.max(positionStart, positionEnd);
        for (var i = start; i <= end; i++) {
            var item = this.state.itemsById[this.state.itemsList[i]];
            if (helpers_1.isCheckAllowed(item)) {
                selectedItems.push(item);
            }
        }
        this.multiSelect(selectedItems, true);
    };
    ItemList.prototype.setActioning = function (item, isActioning) {
        var search = this.props.svc.search;
        var actioning = Object.assign({}, this.state.actioning);
        var itemId = search.generateTrackByIdentifier(item);
        actioning[itemId] = isActioning;
        this.setState({ actioning: actioning });
    };
    ItemList.prototype.dbClick = function (item) {
        var _this = this;
        if (typeof this.props.onMonitoringItemDoubleClick === 'function') {
            this.props.onMonitoringItemDoubleClick(item);
            return;
        }
        var _a = this.props.svc, superdesk = _a.superdesk, $timeout = _a.$timeout, authoringWorkspace = _a.authoringWorkspace;
        var scope = this.props.scope;
        var activities = superdesk.findActivities({ action: 'list', type: item._type }, item);
        var canEdit = lodash_1.default.reduce(activities, function (result, value) { return result || value._id === 'edit.item'; }, false);
        this.setSelectedItem(item);
        $timeout.cancel(this.updateTimeout);
        if (lodash_1.default.get(scope, 'flags.hideActions')) {
            return;
        }
        if (item._type === 'externalsource') {
            this.setActioning(item, true);
            superdesk.intent('list', 'externalsource', { item: item }, 'fetch-externalsource')
                .then(function (archiveItem) {
                archiveItem.guid = archiveItem._id; // fix item guid to match new item _id
                scope.$applyAsync(function () {
                    scope.edit ? scope.edit(archiveItem) : authoringWorkspace.open(archiveItem);
                });
            })
                .finally(function () {
                _this.setActioning(item, false);
            });
        }
        else if (canEdit && scope.edit) {
            scope.$apply(function () {
                scope.edit(item);
            });
        }
        else {
            scope.$apply(function () {
                authoringWorkspace.open(item);
            });
        }
    };
    ItemList.prototype.edit = function (item) {
        var _a = this.props.svc, $timeout = _a.$timeout, authoringWorkspace = _a.authoringWorkspace;
        var scope = this.props.scope;
        this.setSelectedItem(item);
        $timeout.cancel(this.updateTimeout);
        if (lodash_1.default.get(scope, 'flags.hideActions')) {
            return;
        }
        if (item && scope.edit) {
            scope.$apply(function () {
                scope.edit(item);
            });
        }
        else if (item) {
            scope.$apply(function () {
                authoringWorkspace.open(item);
            });
        }
    };
    ItemList.prototype.deselectAll = function () {
        this.setState({ selected: null });
        this.unbindActionKeyShortcuts();
    };
    ItemList.prototype.updateAllItems = function (itemId, changes) {
        var itemsById = angular.extend({}, this.state.itemsById);
        lodash_1.default.forOwn(itemsById, function (value, key) {
            if (lodash_1.default.startsWith(key, itemId)) {
                itemsById[key] = angular.extend({}, value, changes);
            }
        });
        this.setState({ itemsById: itemsById });
    };
    ItemList.prototype.findItemByPrefix = function (prefix) {
        var item;
        lodash_1.default.forOwn(this.state.itemsById, function (val, key) {
            if (lodash_1.default.startsWith(key, prefix)) {
                item = val;
            }
        });
        return item;
    };
    ItemList.prototype.setSelectedItem = function (item) {
        var _a = this.props.svc, monitoringState = _a.monitoringState, $rootScope = _a.$rootScope, search = _a.search;
        var scope = this.props.scope;
        if (monitoringState.state.activeGroup !== scope.$id) {
            // If selected item is from another group, deselect all
            $rootScope.$broadcast('item:unselect');
            monitoringState.setState({ activeGroup: scope.$id });
        }
        this.setState({ selected: item ? search.generateTrackByIdentifier(item) : null });
    };
    ItemList.prototype.getSelectedItem = function () {
        var selected = this.state.selected;
        return this.state.itemsById[selected];
    };
    ItemList.prototype.updateItem = function (itemId, changes) {
        var item = this.state.itemsById[itemId] || null;
        if (item) {
            var itemsById = angular.extend({}, this.state.itemsById);
            itemsById[itemId] = angular.extend({}, item, changes);
            this.setState({ itemsById: itemsById });
        }
    };
    ItemList.prototype.handleKey = function (event) {
        var _this = this;
        // don't do anything when modifier key is pressed
        // this allows shortcuts defined in activities to work without two actions firing for one shortcut
        if (event.ctrlKey || event.altKey || event.shiftKey) {
            return;
        }
        var scope = this.props.scope;
        var _a = this.props.svc, Keys = _a.Keys, monitoringState = _a.monitoringState;
        var KEY_CODES = Object.freeze({
            X: 'X'.charCodeAt(0),
        });
        var diff;
        var moveActiveGroup = function () {
            event.preventDefault();
            event.stopPropagation();
            _this.deselectAll(); // deselect active item
            scope.$applyAsync(function () {
                monitoringState.moveActiveGroup(event.keyCode === Keys.pageup ? -1 : 1);
            });
        };
        var openItem = function () {
            if (_this.state.selected) {
                _this.edit(_this.getSelectedItem());
            }
            event.stopPropagation();
        };
        var performMultiSelect = function () {
            event.preventDefault();
            event.stopPropagation();
            _this.multiSelectCurrentItem();
        };
        switch (event.keyCode) {
            case Keys.right:
            case Keys.down:
                diff = 1;
                this.closeActionsMenu();
                break;
            case Keys.left:
            case Keys.up:
                diff = -1;
                this.closeActionsMenu();
                break;
            case Keys.enter:
                openItem();
                this.closeActionsMenu();
                break;
            case Keys.pageup:
            case Keys.pagedown:
                moveActiveGroup();
                this.closeActionsMenu();
                break;
            case KEY_CODES.X:
                performMultiSelect();
                this.closeActionsMenu();
                break;
        }
        var highlightSelected = function (_event) {
            for (var i = 0; i < _this.state.itemsList.length; i++) {
                if (_this.state.itemsList[i] === _this.state.selected) {
                    var next = Math.min(_this.state.itemsList.length - 1, Math.max(0, i + diff));
                    _this.select(_this.state.itemsById[_this.state.itemsList[next]], _event);
                    return;
                }
            }
        };
        var checkRemaining = function (_event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.state.selected) {
                highlightSelected(_event);
            }
            else {
                _this.select(_this.state.itemsById[_this.state.itemsList[0]], _event);
            }
        };
        // This function is to bring the selected item (by key press) into view if it is out of container boundary.
        var scrollSelectedItemIfRequired = function (_event, _scope) {
            var container = _scope.viewColumn ? $(document).find('.content-list') : $(_event.currentTarget);
            var selectedItemElem = $(_event.currentTarget.firstChild).children('.list-item-view.active');
            if (selectedItemElem.length > 0) {
                // The following line translated to: top_Of_Selected_Item (minus) top_Of_Scrollable_Div
                var distanceOfSelItemFromVisibleTop = $(selectedItemElem[0]).offset().top - $(document).scrollTop() -
                    $(container[0]).offset().top - $(document).scrollTop();
                // If the selected item goes beyond container view, scroll it to middle.
                if (distanceOfSelItemFromVisibleTop >= container[0].clientHeight ||
                    distanceOfSelItemFromVisibleTop < 0) {
                    container.scrollTop(container.scrollTop() + distanceOfSelItemFromVisibleTop -
                        container[0].offsetHeight * 0.5);
                }
            }
        };
        if (!lodash_1.default.isNil(diff)) {
            checkRemaining(event);
            scrollSelectedItemIfRequired(event, scope);
        }
    };
    ItemList.prototype.componentWillUnmount = function () {
        this.unbindActionKeyShortcuts();
        this.closeActionsMenu();
    };
    ItemList.prototype.setSelectedComponent = function (com) {
        this.selectedCom = com;
    };
    ItemList.prototype.modifiedUserName = function (versionCreator) {
        return this.props.usersById[versionCreator] ?
            this.props.usersById[versionCreator].display_name : null;
    };
    /**
     * Get nested item parent
     *
     * This could be item with same guid for corrections or with guid == rewritten_by for updates
     */
    ItemList.prototype.getParent = function (item, itemId) {
        var _this = this;
        var parentId = item.rewritten_by &&
            this.state.itemsList.find(function (_itemId) { return _itemId.startsWith(item.rewritten_by); });
        if (parentId) {
            var parent = this.state.itemsById[parentId];
            if (parent) {
                return this.getParent(parent, parentId) || parentId; // return parent's parent or parent
            }
        }
        // check for previous version of same item
        return this.state.itemsList.find(function (_itemId) {
            return _itemId.startsWith(item.guid) // same guid
                && _itemId !== itemId // but different version
                && _this.state.itemsById[_itemId]._current_version > item._current_version;
        }); // and more recent one
    };
    ItemList.prototype.render = function () {
        var _this = this;
        var _a = this.props.svc, storage = _a.storage, config = _a.config;
        var scope = this.props.scope;
        var hideNested = lodash_1.get(config, 'features.nestedItemsInOutputStage', false) === true;
        var nested = {};
        var children = {};
        if (hideNested) {
            this.state.itemsList.forEach(function (itemId) {
                var item = _this.state.itemsById[itemId];
                if (item._type === 'published' && (item.rewritten_by || !item.last_published_version)) {
                    var parentId = _this.getParent(item, itemId);
                    if (parentId && parentId !== itemId) {
                        nested[itemId] = true;
                        var parentChildren = children[parentId] || [];
                        parentChildren.push(itemId);
                        children[parentId] = parentChildren;
                    }
                }
            });
        }
        var createItem = function (itemId) {
            var item = _this.state.itemsById[itemId];
            var task = item.task || { desk: null };
            var itemChildren = [];
            if (nested[itemId]) {
                return null; // hide nested items from list
            }
            else if (hideNested && children[itemId]) {
                itemChildren = children[itemId].map(function (childrenId) { return _this.state.itemsById[childrenId]; });
            }
            return react_1.default.createElement(index_1.Item, {
                key: itemId,
                item: item,
                view: _this.state.view,
                swimlane: _this.state.swimlane || storage.getItem('displaySwimlane'),
                flags: { selected: _this.state.selected === itemId },
                onEdit: _this.edit,
                onDbClick: _this.dbClick,
                onSelect: _this.select,
                onMultiSelect: _this.multiSelect,
                ingestProvider: _this.props.ingestProvidersById[item.ingest_provider] || null,
                desk: _this.props.desksById[task.desk] || null,
                highlightsById: _this.props.highlightsById,
                markedDesksById: _this.props.markedDesksById,
                profilesById: _this.props.profilesById,
                setSelectedComponent: _this.setSelectedComponent,
                versioncreator: _this.modifiedUserName(item.version_creator),
                narrow: _this.state.narrow,
                svc: _this.props.svc,
                hideActions: scope.hideActionsForMonitoringItems || lodash_1.get(scope, 'flags.hideActions'),
                multiSelectDisabled: scope.disableMonitoringMultiSelect,
                scope: scope,
                nested: itemChildren,
                actioning: !!_this.state.actioning[itemId],
            });
        };
        var isEmpty = !this.state.itemsList.length;
        return react_1.default.createElement('ul', {
            className: classnames_1.default(this.state.view === 'photogrid' ?
                'sd-grid-list sd-grid-list--no-margin' :
                (this.state.view || 'compact') + '-view list-view', { 'list-without-items': isEmpty }),
            onClick: this.closeActionsMenu,
        }, isEmpty && !scope.loading ?
            react_1.default.createElement('li', { onClick: this.closeActionsMenu }, utils_1.gettext('There are currently no items')) : this.state.itemsList.map(createItem));
    };
    return ItemList;
}(react_1.default.Component));
exports.ItemList = ItemList;
ItemList.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
    profilesById: prop_types_1.default.any,
    highlightsById: prop_types_1.default.any,
    markedDesksById: prop_types_1.default.any,
    desksById: prop_types_1.default.any,
    ingestProvidersById: prop_types_1.default.any,
    usersById: prop_types_1.default.any,
    onMonitoringItemSelect: prop_types_1.default.func,
    onMonitoringItemDoubleClick: prop_types_1.default.func,
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var findParent_1 = __webpack_require__(1761);
exports.querySelectorParent = function (element, selector) { return findParent_1.findParent(element, function (el) { return el.matches(selector); }, false); };


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function findParent(element, checkFn, checkCurrentElement) {
    var elementToCheck = checkCurrentElement === true ? element : element.parentElement;
    while (elementToCheck != null && checkFn(elementToCheck) !== true) {
        elementToCheck = elementToCheck.parentElement;
    }
    return elementToCheck;
}
exports.findParent = findParent;


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.apps.search
 * @name associations
 * @param {Object} item story to be marked
 * @param {function} openAuthoringView Open the associated item in view mode.
 * @description Creates an icon for the associated item.
 */
var Associations = /** @class */ (function (_super) {
    __extends(Associations, _super);
    function Associations(props) {
        var _this = _super.call(this, props) || this;
        _this.openItem = _this.openItem.bind(_this);
        return _this;
    }
    /**
     * Opens the item in authoring in view mode.
     * @param event
     */
    Associations.prototype.openItem = function (event) {
        event.stopPropagation();
        this.props.openAuthoringView(this.props.item.associations.featuremedia._id);
    };
    Associations.prototype.render = function () {
        if (this.props.item.associations &&
            this.props.item.associations.featuremedia && this.props.item.associations.featuremedia._id) {
            return (react_1.default.createElement("div", { className: "type-icon associations", onClick: this.openItem, title: utils_1.gettext('Associated ') + this.props.item.associations.featuremedia.type },
                react_1.default.createElement(index_1.TypeIcon, { type: this.props.item.associations.featuremedia.type })));
        }
        return null;
    };
    return Associations;
}(react_1.default.Component));
exports.Associations = Associations;
/*
 * item: item having associations
 * openAuthoringView: Opens the item in view mode
 */
Associations.propTypes = {
    item: prop_types_1.default.any,
    openAuthoringView: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * @ngdoc React
 * @module superdesk.apps.search
 * @name QueueError
 * @param {Object} item published item having error state
 * @description Creates an icon for the published items that have been failed to enqueue.
 */
var QueueError = /** @class */ (function (_super) {
    __extends(QueueError, _super);
    function QueueError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueueError.prototype.render = function () {
        if (this.props.item.queue_state && this.props.item.queue_state === 'error') {
            return (react_1.default.createElement("div", { className: "icon-warning-sign queue-error", title: this.props.item.error_message }));
        }
        return null;
    };
    return QueueError;
}(react_1.default.Component));
exports.QueueError = QueueError;
QueueError.propTypes = {
    item: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var index_1 = __webpack_require__(22);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.search
 * @name WidgetItemComponent
 * @param {Object} item The current item.
 * @param {Boolean} selected The item is selected.
 * @param {Boolean} allowed The edit of item is allowed.
 * @param {Boolean} customMonitoringWidget The custom flag from config file
 * @param {Object} svc The superdesk services
 * @param {Function} preview The callback function on item preview
 * @param {Function} select The callback function on item selection
 * @param {Function} edit The callback function on item edit
 * @description This component is a row in monitoring widget item list.
 */
var WidgetItem = /** @class */ (function (_super) {
    __extends(WidgetItem, _super);
    function WidgetItem(props) {
        var _this = _super.call(this, props) || this;
        _this.item = props.item;
        _this.preview = _this.preview.bind(_this);
        _this.select = _this.select.bind(_this);
        _this.edit = _this.edit.bind(_this);
        return _this;
    }
    WidgetItem.prototype.preview = function (event) {
        event.stopPropagation();
        this.props.preview(this.item);
    };
    WidgetItem.prototype.select = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!this.item.gone) {
            this.props.select(this.item);
        }
    };
    WidgetItem.prototype.edit = function (e) {
        e.stopPropagation();
        if (!this.item.gone) {
            this.props.edit(this.item);
        }
    };
    WidgetItem.prototype.render = function () {
        var className = classnames_1.default('content-item', { 'content-item--locked': this.item.lock_user }, { 'custom-monitoring': this.props.customMonitoringWidget }, { shifted: this.props.allowed }, { active: this.props.selected }, { gone: !!this.item.gone });
        return (react_1.default.createElement("li", { onClick: this.select, onDoubleClick: this.edit, className: className },
            react_1.default.createElement("div", { className: "content-item__type" },
                react_1.default.createElement(index_1.TypeIcon, { type: this.item.type, highlight: this.item.highlight })),
            react_1.default.createElement("div", { className: "content-item__urgency-field" },
                react_1.default.createElement(index_1.ItemUrgency, { svc: this.props.svc, item: this.item })),
            react_1.default.createElement("div", { className: "content-item__text" },
                react_1.default.createElement("span", { className: "keywords" }, this.item.slugline),
                react_1.default.createElement("span", { id: "title", className: "headline" }, this.item.headline)),
            react_1.default.createElement("div", { className: "content-item__date" },
                react_1.default.createElement("time", null, this.props.svc.datetime.shortFormat(this.item.versioncreated))),
            this.props.allowed && !this.item.gone ?
                react_1.default.createElement("div", { className: "content-item__action" },
                    this.item.type !== 'composite' ?
                        react_1.default.createElement("button", { className: "icn-btn", onMouseDown: this.preview, title: utils_1.gettext('Preview') },
                            react_1.default.createElement("i", { className: "icon-external" }))
                        :
                            '',
                    this.props.customMonitoringWidget ?
                        ''
                        :
                            react_1.default.createElement("button", { className: "icn-btn", onMouseDown: this.edit, title: utils_1.gettext('Edit') },
                                react_1.default.createElement("i", { className: "icon-pencil" })))
                :
                    ''));
    };
    return WidgetItem;
}(react_1.default.Component));
exports.WidgetItem = WidgetItem;
WidgetItem.propTypes = {
    item: prop_types_1.default.object,
    selected: prop_types_1.default.bool,
    allowed: prop_types_1.default.bool,
    customMonitoringWidget: prop_types_1.default.bool,
    svc: prop_types_1.default.object.isRequired,
    preview: prop_types_1.default.func.isRequired,
    select: prop_types_1.default.func.isRequired,
    edit: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var index_1 = __webpack_require__(22);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc React
 * @module superdesk.search
 * @name WidgetItemComponent
 * @param {Boolean} allowed The edit of item in the list is allowed.
 * @param {Boolean} customMonitoringWidget The custom flag from config file
 * @param {Object} svc The superdesk services
 * @param {Function} preview The callback function on item preview
 * @param {Function} select The callback function on item selection
 * @param {Function} edit The callback function on item edit
 * @param {Function} updateCallback The callback function for component state update
 * @description This component is the list of items from a monitoring widget group.
 */
var WidgetItemList = /** @class */ (function (_super) {
    __extends(WidgetItemList, _super);
    function WidgetItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { itemIds: [], itemsById: {}, loading: true, selected: null };
        _this.updateState = _this.updateState.bind(_this);
        props.updateCallback(_this.updateState);
        return _this;
    }
    WidgetItemList.prototype.updateState = function (updates) {
        this.setState(updates);
    };
    WidgetItemList.prototype.render = function () {
        var _this = this;
        if (this.state.loading) {
            return (react_1.default.createElement("div", { className: "item-group__loading" }));
        }
        if (!this.state.itemIds.length) {
            return (react_1.default.createElement("div", { className: "item-group__no-items" }, utils_1.gettext('No items in this stage')));
        }
        return (react_1.default.createElement("div", { tabIndex: 0 },
            react_1.default.createElement("ul", { className: "inline-content-items" }, this.state.itemIds.map(function (itemId) {
                var item = _this.state.itemsById[itemId];
                return (react_1.default.createElement(index_1.WidgetItem, { key: _this.props.svc.search.generateTrackByIdentifier(item), item: item, selected: _this.state.selected && _this.state.selected._id === item._id, allowed: _this.props.allowed, customMonitoringWidget: _this.props.customMonitoringWidget, svc: _this.props.svc, preview: _this.props.preview, select: _this.props.select, edit: _this.props.edit }));
            }))));
    };
    return WidgetItemList;
}(react_1.default.Component));
exports.WidgetItemList = WidgetItemList;
WidgetItemList.propTypes = {
    allowed: prop_types_1.default.bool,
    customMonitoringWidget: prop_types_1.default.bool,
    svc: prop_types_1.default.object.isRequired,
    preview: prop_types_1.default.func.isRequired,
    select: prop_types_1.default.func.isRequired,
    edit: prop_types_1.default.func.isRequired,
    updateCallback: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importStar(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.search
 * @name sdSearchPanel
 *
 * @requires $location
 * @requires desks
 * @requires privileges
 * @requires tags
 * @requires asset
 * @requires metadata
 * @requires $rootScope
 * @requires session
 *
 * @description
 *   A directive that generates the sidebar containing search results
 *   filters (so-called "aggregations" in Elastic's terms).
 */
SearchPanel.$inject = [
    '$location',
    'desks',
    'privileges',
    'tags',
    'asset',
    'metadata',
    '$rootScope',
    'session',
    'config',
];
function SearchPanel($location, desks, privileges, tags, asset, metadata, $rootScope, session, config) {
    desks.initialize();
    return {
        require: '^sdSearchContainer',
        templateUrl: asset.templateUrl('apps/search/views/search-panel.html'),
        scope: {
            items: '=',
            desk: '=',
            repo: '=',
            context: '=',
            toggleRepo: '=',
            providerType: '=',
        },
        link: function (scope, element, attrs, controller) {
            scope.config = config;
            scope.flags = controller.flags;
            scope.sTab = 'advancedSearch';
            scope.innerTab = 'parameters';
            scope.editingSearch = false;
            scope.showSaveSearch = false;
            scope.isManagingSubscriptions = false;
            scope.wrapper = {};
            scope.manageSubscriptions = function (nextValue) {
                scope.isManagingSubscriptions = nextValue;
            };
            scope.aggregations = {};
            scope.privileges = privileges.privileges;
            scope.userHasPrivileges = privileges.userHasPrivileges;
            scope.search_config = metadata.search_config;
            scope.$on('edit:search', function (event, args) {
                scope.sTab = 'advancedSearch';
                scope.innerTab = 'parameters';
                scope.activateSearchPane = false;
                scope.editingSearch = args;
                scope.wrapper.edit = lodash_1.cloneDeep(scope.editingSearch || {});
            });
            scope.changeTab = function (tabName) {
                scope.sTab = tabName;
            };
            scope.display = function (tabName) {
                scope.innerTab = tabName;
                if (tabName === 'filters') {
                    $rootScope.aggregations = 1;
                    $rootScope.$broadcast('aggregations:changed');
                }
                else {
                    $rootScope.aggregations = 0;
                }
            };
            scope.searching = function () {
                return !lodash_1.default.isEmpty($location.search());
            };
            scope.closeFacets = function () {
                scope.flags.facets = false;
                $rootScope.aggregations = 0;
            };
            scope.$watch('tags.currentSearch', function (currentSearch) {
                scope.showSaveSearch = !lodash_1.default.isEmpty(currentSearch);
            }, true);
            /*
             * Checks if the user is Admin or Not.
             */
            scope.isAdmin = function () {
                return session.identity.user_type === 'administrator';
            };
        },
    };
}
exports.SearchPanel = SearchPanel;


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(73);
/**
 * @ngdoc directive
 * @module superdesk.apps.search
 * @name sdSearchParameters
 *
 * @requires $location
 * @requires tags
 * @requires asset
 * @requires metadata
 * @requires desks
 * @requires $rootScope
 * @description
 *   A directive that parses location and generates tags.
 */
SearchTags.$inject = ['$location', 'tags', 'asset', 'metadata', 'desks', '$rootScope'];
function SearchTags($location, tags, asset, metadata, desks, $rootScope) {
    return {
        scope: {
            urlParams: '=',
        },
        templateUrl: asset.templateUrl('apps/search/views/search-tags.html'),
        link: function (scope) {
            scope.cvs = metadata.search_cvs;
            var urlParams = scope.urlParams || constants_1.PARAMETERS;
            scope.$watch(function getSearchParams() {
                return lodash_1.default.omit($location.search(), ['_id', 'item', 'action']);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    reloadTags();
                }
            }, true);
            function init() {
                metadata
                    .initialize()
                    .then(function () {
                    scope.metadata = metadata.values;
                });
                reloadTags();
            }
            function reloadTags() {
                tags.initSelectedFacets(urlParams).then(function (currentTags) {
                    scope.tags = currentTags;
                });
            }
            init();
            scope.refreshList = function () {
                $rootScope.$broadcast('refresh:list');
            };
            scope.removeFilter = function (type, key) {
                tags.removeFacet(type, key);
            };
            var removeMarkedDeskParameter = function (deskName) {
                var deskId = desks.desks._items.find(function (d) { return d.name === deskName; })._id;
                tags.removeFacet('marked_desks', deskId);
            };
            scope.removeParameter = function (param) {
                var searchParameters = $location.search();
                if (searchParameters.q && searchParameters.q.indexOf(param) >= 0) {
                    var newQuery = lodash_1.default.uniq(searchParameters.q.replace(param, '').trim()
                        .split(/[\s,]+/));
                    searchParameters.q = newQuery.join(' ');
                    $location.search('q', searchParameters.q || null);
                    $rootScope.$broadcast('tag:removed');
                    return;
                }
                var parameterValue = '';
                if (param.indexOf('(') >= 0) {
                    parameterValue = param.substring(param.indexOf('(') + 1, param.lastIndexOf(')'));
                }
                else {
                    var type = param.split(':')[0];
                    var value = param.split(':')[1];
                    Object.keys(urlParams).some(function (k) {
                        if (urlParams[k] === type && searchParameters[k]) {
                            if (k === 'marked_desks') {
                                removeMarkedDeskParameter(value);
                                return true;
                            }
                            $location.search(k, null);
                            return true;
                        }
                        return false;
                    });
                }
                angular.forEach(scope.cvs, function (cv) {
                    if (param.indexOf(cv.name) !== -1) {
                        var codeList = scope.metadata[cv.list];
                        var qcode = lodash_1.default.result(lodash_1.default.find(codeList, function (code) { return code.name === parameterValue || code.qcode === parameterValue; }), 'qcode');
                        if (qcode) {
                            if (searchParameters[cv.id]) {
                                tags.removeFacet(cv.id, qcode);
                            }
                            else {
                                searchParameters.q = searchParameters.q
                                    .replace(cv.id + '.qcode:(' + qcode + ')', '')
                                    .trim();
                                $location.search('q', searchParameters.q || null);
                            }
                        }
                    }
                });
            };
        },
    };
}
exports.SearchTags = SearchTags;


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
SearchResults.$inject = [
    '$location',
    'preferencesService',
    'packages',
    'asset',
    '$timeout',
    'api',
    'search',
    'session',
    '$rootScope',
    'config',
    'superdeskFlags',
    'notify',
];
var HEX_REG_EXP = /[a-f0-9]{24}/;
function isObjectId(value) {
    return value.length === 24 && HEX_REG_EXP.test(value);
}
/**
 * @ngdoc directive
 * @module superdesk.apps.search
 * @name sdSearchResults
 *
 * @requires $location
 * @requires preferencesService
 * @requires packages
 * @requires asset
 * @requires $timeout
 * @requires api
 * @requires search
 * @requires session
 * @requires $rootScope
 * @requires config
 *
 * @description Item list with sidebar preview
 */
function SearchResults($location, preferencesService, packages, asset, $timeout, api, search, session, $rootScope, config, superdeskFlags, notify) {
    var preferencesUpdate = {
        'archive:view': {
            allowed: [
                'mgrid',
                'compact',
            ],
            category: 'archive',
            view: 'mgrid',
            default: 'mgrid',
            label: 'Users archive view format',
            type: 'string',
        },
    };
    return {
        require: '^sdSearchContainer',
        templateUrl: asset.templateUrl('apps/search/views/search-results.html'),
        link: function (scope, elem, attr, controller) {
            var containerElem = elem.find('.shadow-list-holder');
            var GRID_VIEW = 'mgrid', LIST_VIEW = 'compact';
            var projections = search.getProjectedFields();
            var multiSelectable = attr.multiSelectable !== undefined;
            scope.previewingBroadcast = false;
            superdeskFlags.flags.previewing = false;
            // allow controller overwrite getSearch
            var getSearch = typeof scope.search.getSearch === 'function'
                ? scope.search.getSearch
                : function () { return $location.search(); };
            var criteria = search.query(getSearch()).getCriteria(true), oldQuery = lodash_1.default.omit(getSearch(), '_id');
            scope.flags = controller.flags;
            scope.selected = scope.selected || {};
            scope.showHistoryTab = true;
            scope.context = 'search';
            scope.$on('item:deleted:archived', itemDelete);
            scope.$on('item:fetch', queryItems);
            scope.$on('item:update', updateItem);
            scope.$on('item:deleted', scheduleIfShouldUpdate);
            scope.$on('item:unlink', queryItems);
            scope.$on('item:spike', scheduleIfShouldUpdate);
            scope.$on('item:unspike', scheduleIfShouldUpdate);
            scope.$on('item:duplicate', queryItems);
            scope.$on('item:translate', queryItems);
            // used by superdesk-fi
            scope.showtags = attr.showtags !== 'false';
            // Custom components for item fields
            scope.customRender = scope.search.customRender || {};
            scope.$on('ingest:update', function (event, args) {
                if (!scope.showRefresh) {
                    queryItems(event, args);
                }
            });
            scope.$on('content:update', queryItems);
            scope.$on('item:move', scheduleIfShouldUpdate);
            scope.$on('aggregations:changed', queryItems);
            scope.$on('broadcast:preview', function (event, args) {
                scope.previewingBroadcast = true;
                scope.preview(args.item);
            });
            scope.$on('broadcast:created', function (event, args) {
                scope.previewingBroadcast = true;
                queryItems();
                scope.preview(args.item);
            });
            scope.$watch('selected', function (newVal, oldVal) {
                if (!newVal && scope.previewingBroadcast) {
                    scope.previewingBroadcast = false;
                }
            });
            scope.$watch(function getSearchParams() {
                return lodash_1.default.omit(getSearch(), ['_id', 'item', 'action']);
            }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.refreshList();
                }
            }, true);
            // public api - called by list when needed
            scope.fetchNext = function () {
                render(null, true);
            };
            var nextUpdate;
            function updateItem(e, data) {
                var item = lodash_1.default.find(scope.items._items, { _id: data.item._id });
                if (item) {
                    angular.extend(item, data.item);
                }
            }
            /**
             * Schedule an update if it's not there yet
             */
            function queryItems(event, data) {
                if (!nextUpdate) {
                    if (scope.search.repo.search !== 'local' && !getSearch().q && !(data && data.force)) {
                        return; // ignore updates with external content
                    }
                    scope.loading = true;
                    nextUpdate = $timeout(function () {
                        _queryItems(event, data)
                            .finally(function () {
                            scope.$applyAsync(function () {
                                nextUpdate = null;
                            });
                        });
                    }, 1000, false);
                }
            }
            /**
             * Function for fetching total items and filling scope for the first time.
             */
            function _queryItems(event, data) {
                criteria = search.query(getSearch()).getCriteria(true);
                criteria.source.size = 50;
                var originalQuery;
                // when forced refresh or query then keep query size default as set 50 above.
                if (!(data && data.force)) {
                    // To compare current scope of items, consider fetching same number of items.
                    if (scope.items && scope.items._items.length > 50) {
                        criteria.source.size = scope.items._items.length;
                    }
                }
                if (data && (data.item || data.items || data.item_id) && scope.showRefresh && !data.force) {
                    // if we know the ids of the items then try to fetch those only
                    originalQuery = angular.extend({}, criteria.source.query);
                    var items = data.items || {};
                    if (data.item || data.item_id) {
                        items[data.item || data.item_id] = 1;
                    }
                    criteria.source.query = search.getItemQuery(data.items);
                }
                else {
                    criteria.aggregations = $rootScope.aggregations;
                }
                criteria.source.from = 0;
                scope.total = null;
                criteria.es_highlight = search.getElasticHighlight();
                criteria.projections = JSON.stringify(projections);
                if (getSearch().params) {
                    criteria.params = JSON.parse(getSearch().params);
                }
                return api.query(getProvider(criteria), criteria).then(function (items) {
                    if (config.features.autorefreshContent && data != null) {
                        data.force = true;
                    }
                    if (!scope.showRefresh && data && !data.force && data.user !== session.identity._id) {
                        var _data = {
                            newItems: items,
                            scopeItems: scope.items,
                            scrollTop: containerElem.scrollTop(),
                            isItemPreviewing: !!scope.selected.preview,
                        };
                        scope.showRefresh = search.canShowRefresh(_data);
                    }
                    if (!scope.showRefresh || data && data.force) {
                        scope.total = items._meta.total;
                        scope.$applyAsync(function () {
                            render(items, null, true);
                        });
                    }
                    else {
                        // update scope items only with the matching fetched items
                        scope.items = search.updateItems(items, scope.items);
                    }
                    if (originalQuery) {
                        criteria.source.query = originalQuery;
                    }
                }, function (error) {
                    notify.error(utils_1.gettext('Failed to run the query!'));
                    console.error(error, getProvider(criteria));
                })
                    .finally(function () {
                    scope.loading = false;
                });
            }
            function scheduleIfShouldUpdate(event, data) {
                if (data && data.item && lodash_1.default.includes(['item:spike', 'item:unspike', 'item:deleted'], event.name)) {
                    // item was spiked/unspikes from the list
                    extendItem(data.item, {
                        gone: true,
                        _etag: data.item,
                    });
                    queryItems(event, data);
                }
                else if (data && data.from_stage) {
                    // item was moved from current stage
                    extendItem(data.item, {
                        gone: true,
                        _etag: data.from_stage,
                    });
                    queryItems(event, data);
                }
            }
            function extendItem(itemId, updates) {
                scope.$apply(function () {
                    scope.items._items = scope.items._items.map(function (item) {
                        if (item._id === itemId) {
                            return angular.extend(item, updates);
                        }
                        return item;
                    });
                    scope.items = angular.extend({}, scope.items); // trigger a watch
                });
            }
            scope.$on('refresh:list', function (event, group) {
                scope.refreshList();
            });
            scope.refreshList = function () {
                scope.showRefresh = false;
                queryItems(null, { force: true });
                if (containerElem[0].scrollTop > 0) {
                    containerElem[0].scrollTop = 0;
                }
            };
            /*
             * Function to get the search endpoint name based on the criteria
             *
             * @param {Object} _criteria
             * @returns {string}
             */
            function getProvider(_criteria) {
                var provider = 'search';
                if (_criteria.repo && _criteria.repo.indexOf(',') === -1) {
                    provider = _criteria.repo;
                }
                if (scope.search.repo.search && scope.search.repo.search !== 'local') {
                    provider = scope.search.repo.search;
                }
                if (isObjectId(provider)) {
                    _criteria.repo = provider;
                    provider = 'search_providers_proxy';
                }
                if (provider === 'local') {
                    provider = 'search';
                }
                return provider;
            }
            /*
             * Function for fetching the elements from the database
             *
             * @param {items}
             */
            function render(items, next, force) {
                scope.loading = true;
                if (items) {
                    setScopeItems(items, force);
                }
                else if (next) {
                    scope.loading = true;
                    criteria.source.from = (criteria.source.from || 0) + criteria.source.size;
                    criteria.source.size = 50;
                    criteria.projections = JSON.stringify(projections);
                    api
                        .query(getProvider(criteria), criteria)
                        .then(setScopeItems)
                        .finally(function () {
                        scope.loading = false;
                    });
                }
                else {
                    var query = lodash_1.default.omit(getSearch(), '_id');
                    if (!lodash_1.default.isEqual(lodash_1.default.omit(query, 'page'), lodash_1.default.omit(oldQuery, 'page'))) {
                        $location.search('page', null);
                    }
                    criteria = search.query(getSearch()).getCriteria(true);
                    criteria.source.from = 0;
                    criteria.source.size = 50;
                    criteria.aggregations = $rootScope.aggregations;
                    criteria.es_highlight = search.getElasticHighlight();
                    scope.loading = true;
                    criteria.projections = JSON.stringify(projections);
                    api
                        .query(getProvider(criteria), criteria)
                        .then(setScopeItems)
                        .finally(function () {
                        scope.loading = false;
                    });
                    oldQuery = query;
                }
                function setScopeItems(_items, _force) {
                    scope.items = search.mergeItems(_items, scope.items, next, _force);
                    scope.total_records = _items._meta.total;
                    scope.loading = false;
                }
            }
            /*
             * Function for updating list
             * after item has been deleted
             */
            function itemDelete(e, data) {
                if (session.identity._id === data.user) {
                    queryItems();
                }
            }
            scope.preview = function preview(item) {
                if (multiSelectable) {
                    if (lodash_1.default.findIndex(scope.selectedList, { _id: item._id }) === -1) {
                        scope.selectedList.push(item);
                    }
                    else {
                        lodash_1.default.remove(scope.selectedList, { _id: item._id });
                    }
                }
                if (item) {
                    if (item._type === 'externalsource') {
                        processPreview(item);
                        return;
                    }
                    scope.loading = true;
                    var previewCriteria = search.getSingleItemCriteria(item);
                    api.query(getProvider(previewCriteria), previewCriteria).then(function (completeItems) {
                        var completeItem = search.mergeHighlightFields(completeItems._items[0]);
                        processPreview(completeItem);
                    })
                        .finally(function () {
                        scope.loading = false;
                    });
                }
                else {
                    delete scope.selected.preview;
                    superdeskFlags.flags.previewing = false;
                    sendRowViewEvents();
                }
            };
            /**
             * @ngdoc method
             * @name sdSearchResults#sendRowViewEvents
             * @private
             * @param {Object} item
             * @description If singLine:view preference is set, an item is being previewed, config has narrowView list
             * then, sends rowview event
             */
            function sendRowViewEvents(item) {
                var sendEvent = scope.singleLine && superdeskFlags.flags.authoring && config.list
                    && config.list.narrowView;
                var evnt = item ? 'rowview:narrow' : 'rowview:default';
                if (sendEvent) {
                    $rootScope.$broadcast(evnt);
                }
            }
            /**
             * @ngdoc method
             * @name sdSearchResults#processPreview
             * @private
             * @param {Object} item
             * @description Sets the preview item
             */
            function processPreview(item) {
                scope.selected.preview = item;
                if (!lodash_1.default.isNil(scope.selected.preview)) {
                    scope.showHistoryTab = scope.selected.preview.state !== 'ingested' &&
                        !lodash_1.default.includes(['archived', 'externalsource'], scope.selected.preview._type);
                    superdeskFlags.flags.previewing = true;
                    sendRowViewEvents(item);
                }
                $location.search('_id', item ? item._id : null);
            }
            scope.openLightbox = function openLightbox() {
                scope.selected.view = scope.selected.preview;
            };
            scope.closeLightbox = function closeLightbox() {
                scope.selected.view = null;
            };
            scope.openSingleItem = function (packageItem) {
                packages.fetchItem(packageItem).then(function (item) {
                    scope.selected.view = item;
                });
            };
            scope.setview = setView;
            var savedView;
            preferencesService.get('archive:view').then(function (result) {
                savedView = result.view;
                scope.view = !!savedView && savedView !== 'undefined' ? savedView : 'mgrid';
            });
            scope.$on('key:v', toggleView);
            scope.$on('open:archived_kill', function (evt, item, action) {
                scope.selected.archived_kill = item;
                scope.selected.archived_kill_action = action;
            });
            scope.$on('open:resend', function (evt, item) {
                scope.selected.resend = item;
            });
            function setView(view) {
                scope.view = view || 'mgrid';
                preferencesUpdate['archive:view'].view = view || 'mgrid';
                preferencesService.update(preferencesUpdate, 'archive:view');
            }
            function toggleView() {
                var nextView = scope.view === LIST_VIEW ? GRID_VIEW : LIST_VIEW;
                return setView(nextView);
            }
            /**
             * Generates Identifier to be used by track by expression.
             */
            scope.uuid = function (item) {
                return search.generateTrackByIdentifier(item);
            };
            // init
            $rootScope.aggregations = 0;
            _queryItems();
        },
    };
}
exports.SearchResults = SearchResults;


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
function SearchContainer() {
    return {
        controller: ['$scope', '$location', 'pageTitle',
            function SearchContainerController($scope, $location, pageTitle) {
                var _this = this;
                var query = lodash_1.omit($location.search(), '_id', 'repo');
                this.flags = $scope.flags || {};
                this.flags.facets = !lodash_1.isEmpty(query);
                pageTitle.setUrl(utils_1.gettext('Search'));
                $scope.$watch('search.activeProvider', function (activeProvider) {
                    if (activeProvider && activeProvider.advanced_search !== undefined) {
                        _this.flags.facets = !!activeProvider.advanced_search;
                    }
                });
            }],
    };
}
exports.SearchContainer = SearchContainer;


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(73);
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.search
 * @name sdSearchParameters
 *
 * @requires $location
 * @requires asset
 * @requires tags
 * @requires metadata
 * @requires searchCommon
 * @requires desks
 * @requires userList
 * @requires ingestSources
 * @requires subscribersService
 *
 * @description
 *   A directive that generates search parameter form.
 */
SearchParameters.$inject = [
    '$location', 'asset', 'tags', 'metadata',
    'searchCommon', 'desks', 'userList',
    'ingestSources', 'subscribersService',
    '$templateCache',
];
function SearchParameters($location, asset, tags, metadata, common, desks, userList, ingestSources, subscribersService, $templateCache) {
    return {
        scope: {
            repo: '=',
            context: '=',
            providerType: '=',
        },
        templateUrl: asset.templateUrl('apps/search/views/search-parameters.html'),
        link: function (scope, elem) {
            var ENTER = 13;
            scope.keyPressed = function (event) {
                if (event.keyCode === ENTER) {
                    searchParameters();
                    event.preventDefault();
                }
            };
            var getSearchConfig = function () {
                if (scope.isContentApi()) {
                    var searchConfig = lodash_1.default.pick(metadata.search_config, ['slugline', 'headline',
                        'byline', 'story_text']);
                    searchConfig.subscribers = 1;
                    return searchConfig;
                }
                return metadata.search_config;
            };
            scope.isContentApi = function () {
                return lodash_1.default.get(scope, 'repo.search') === 'content-api';
            };
            /*
             * init function to setup the directive initial state and called by $locationChangeSuccess event
             * @param {boolean} loadData.
             */
            function init(loadData) {
                var params = $location.search();
                scope.query = params.q;
                scope.flags = false;
                scope.common = common;
                scope.meta = lodash_1.default.extend({}, common.meta);
                scope.fields = {};
                scope.selecteditems = {};
                scope.selectedCodes = {};
                scope.cvs = metadata.search_cvs;
                scope.search_config = getSearchConfig();
                scope.lookupCvs = {};
                scope.params = params.params ? JSON.parse(params.params) : {};
                angular.forEach(scope.cvs, function (cv) {
                    scope.lookupCvs[cv.id] = cv;
                });
                if ($location.search().unique_name) {
                    scope.fields.unique_name = $location.search().unique_name;
                }
                if ($location.search().spike) {
                    scope.fields.spike = $location.search().spike;
                }
                else if (!scope.isContentApi()) {
                    scope.fields.spike = 'exclude';
                }
                if ($location.search().featuremedia) {
                    scope.fields.featuremedia = true;
                }
                if (loadData) {
                    fetchMetadata();
                    if (scope.isContentApi()) {
                        fetchSubscribers();
                    }
                    else {
                        fetchUsers();
                        fetchDesks();
                        fetchProviders();
                    }
                }
                else {
                    initializeItems();
                    if (scope.isContentApi()) {
                        initializeSubscriber();
                    }
                    else {
                        initializeDesksDropDown();
                        initializeMarkedDesks();
                        initializeProviders();
                        initializeCreators();
                    }
                }
            }
            init(true);
            /*
             * Initialize the creator drop down selection.
             */
            function fetchUsers() {
                userList.getAll()
                    .then(function (users) {
                    scope.userList = users;
                    initializeCreators();
                });
            }
            /*
             * Initialize the desk drop down
             */
            function fetchDesks() {
                scope.desks = [];
                desks.initialize()
                    .then(function () {
                    scope.desks = desks.desks;
                    initializeDesksDropDown();
                });
            }
            function fetchSubscribers() {
                if (scope.repo.search !== 'content-api') {
                    return;
                }
                subscribersService.initialize()
                    .then(function () {
                    scope.subscribers = subscribersService.subscribers;
                    initializeSubscriber();
                });
            }
            /*
             * Initialize the provider dropdown
             */
            function fetchProviders() {
                ingestSources.fetchAllIngestProviders().then(function (items) {
                    scope.providers = items;
                    initializeProviders();
                });
            }
            function initializeProviders() {
                if ($location.search().ingest_provider) {
                    scope.fields.ingest_provider = $location.search().ingest_provider;
                }
            }
            function initializeCreators() {
                if ($location.search().original_creator) {
                    scope.fields.original_creator = $location.search().original_creator;
                }
            }
            function initializeSubscriber() {
                if ($location.search().subscriber) {
                    scope.fields.subscriber = $location.search().subscriber;
                }
            }
            /*
             *  Initialize Desks DropDown
             */
            function initializeDesksDropDown() {
                if (scope.desks && scope.desks._items) {
                    initFromToDesk($location.search().from_desk, 'from_desk');
                    initFromToDesk($location.search().to_desk, 'to_desk');
                }
            }
            function initializeMarkedDesks() {
                if ($location.search().marked_desks) {
                    scope.fields.marked_desks = [];
                    scope.selecteditems.marked_desks = scope.selecteditems.marked_desks || [];
                    var markedDesks = JSON.parse($location.search().marked_desks);
                    markedDesks.map(function (d) {
                        scope.selecteditems.marked_desks.push(desks.deskLookup[d]);
                        scope.fields.marked_desks.push(desks.deskLookup[d]);
                        return true;
                    });
                }
                else {
                    scope.selecteditems.marked_desks = [];
                }
            }
            function initializeItems() {
                angular.forEach(scope.cvs, function (cv) {
                    if ($location.search()[cv.id]) {
                        scope.fields[cv.id] = [];
                        scope.selecteditems[cv.id] = scope.selecteditems[cv.id] || [];
                        var itemList = JSON.parse($location.search()[cv.id]);
                        angular.forEach(itemList, function (qcode) {
                            var match = lodash_1.default.find(scope.metadata[cv.list], function (m) { return m.qcode === qcode; });
                            if (match) {
                                scope.selecteditems[cv.id].push(angular.extend(match, {
                                    scheme: cv.id,
                                }));
                                scope.fields[cv.id].push(match);
                            }
                        });
                    }
                    else {
                        scope.selecteditems[cv.id] = [];
                    }
                });
            }
            /*
             * initialize the desk drop down selection.
             * @param {string} query string parameter from_desk or to_desk
             * @param {field} scope field to be updated.
             */
            function initFromToDesk(param, field) {
                if (param) {
                    var deskParams = param.split('-');
                    if (deskParams.length === 2) {
                        scope.fields[field] = deskParams[0];
                    }
                }
            }
            /*
             * Converting to object and adding pre-selected subject codes, location,
             * genre and service to list in left sidebar.
             */
            function fetchMetadata() {
                metadata
                    .initialize()
                    .then(function () {
                    scope.keywords = metadata.values.keywords;
                    return metadata.fetchSubjectcodes();
                })
                    .then(function () {
                    scope.subjectcodes = metadata.values.subjectcodes;
                    scope.metadata = metadata.values;
                    return tags.initSelectedFacets();
                })
                    .then(function (currentTags) {
                    initializeMarkedDesks();
                    initializeItems();
                });
            }
            scope.$on('$locationChangeSuccess', function () {
                if (scope.query !== $location.search().q || isFieldDifferentThanSearch()) {
                    init();
                }
            });
            function isFieldDifferentThanSearch() {
                var params = $location.search();
                return lodash_1.default.some(lodash_1.default.keys(constants_1.PARAMETERS), function (key) { return lodash_1.default.get(scope.fields, key) !== lodash_1.default.get(params, key); });
            }
            function getFirstKey(data) {
                for (var prop in data) {
                    if (data.hasOwnProperty(prop)) {
                        return prop;
                    }
                }
            }
            function booleanToBinaryString(bool) {
                return Number(bool).toString();
            }
            /*
             * Get Query function build the query string
             */
            function getQuery() {
                var metas = [];
                var pattern = /[()]/g;
                angular.forEach(scope.meta, function (val, key) {
                    // checkbox boolean values.
                    var v = val;
                    if (typeof val === 'boolean') {
                        v = booleanToBinaryString(val);
                    }
                    if (typeof val === 'string') {
                        v = val.replace(pattern, '');
                    }
                    if (key === '_all') {
                        metas.push(v.join(' '));
                    }
                    else if (v) {
                        var k_1 = key;
                        if (key.indexOf('scanpix_') === 0) {
                            k_1 = key.substring(8);
                        }
                        if (typeof v === 'string') {
                            if (v) {
                                metas.push(k_1 + ':(' + v + ')');
                            }
                        }
                        else if (angular.isArray(v)) {
                            angular.forEach(v, function (value) {
                                metas.push(k_1 + ':(' + value.replace(pattern, '') + ')');
                            });
                        }
                        else {
                            var subkey = getFirstKey(v);
                            if (v[subkey]) {
                                metas.push(k_1 + '.' + subkey + ':(' + v[subkey] + ')');
                            }
                        }
                    }
                });
                var fields = ['subject', 'company_codes'];
                angular.forEach(scope.cvs, function (cv) {
                    fields.push(cv.id);
                });
                angular.forEach(scope.fields, function (val, key) {
                    if (key === 'from_desk') {
                        $location.search('from_desk', getDeskParam('from_desk'));
                    }
                    else if (key === 'to_desk') {
                        $location.search('to_desk', getDeskParam('to_desk'));
                    }
                    else if (lodash_1.default.includes(fields, key)) {
                        $location.search(key, JSON.stringify(lodash_1.default.map(val, 'qcode')));
                    }
                    else if (key === 'marked_desks') {
                        $location.search(key, JSON.stringify(lodash_1.default.map(val, '_id')));
                    }
                    else if (key === 'featuremedia') {
                        $location.search(key, val ? true : null);
                    }
                    else {
                        $location.search(key, val);
                    }
                });
                if (metas.length) {
                    if (scope.query) {
                        return scope.query + ' ' + metas.join(' ');
                    }
                    return metas.join(' ');
                }
                return scope.query || null;
            }
            scope.$on('search:parameters', searchParameters);
            function searchParameters() {
                $location.search('q', getQuery() || null);
                $location.search('params', scope.params ? JSON.stringify(scope.params) : null);
                scope.meta = {};
            }
            /*
             * Get the Desk Type
             * @param {string} field from or to
             * @returns {string} desk querystring parameter
             */
            function getDeskParam(field) {
                var deskId = '';
                if (scope.fields[field]) {
                    deskId = scope.fields[field];
                    var deskType = lodash_1.default.result(lodash_1.default.find(scope.desks._items, function (item) { return item._id === deskId; }), 'desk_type');
                    return deskId + '-' + deskType;
                }
                return null;
            }
            /*
             * Filter content by subject search
             */
            scope.itemSearch = function (items, type) {
                if (items[type].length) {
                    scope.fields[type] = items[type];
                }
                else {
                    delete scope.fields[type];
                }
            };
            scope.getTemplate = function (providerType) { return "search-panel-" + providerType + ".html"; };
            scope.hasTemplate = function (providerType) {
                return providerType != null && $templateCache.get(scope.getTemplate(providerType)) != null;
            };
        },
    };
}
exports.SearchParameters = SearchParameters;


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var SavedSearch_1 = __webpack_require__(161);
var utils_1 = __webpack_require__(3);
var utils_2 = __webpack_require__(419);
SaveSearch.$inject = ['$location', 'asset', 'api', 'session', 'notify', '$rootScope'];
/**
 * Opens and manages save search panel
 */
function SaveSearch($location, asset, api, session, notify, $rootScope) {
    return {
        templateUrl: asset.templateUrl('apps/search/views/save-search.html'),
        link: function (scope, elem) {
            scope.edit = null;
            scope.activateSearchPane = false;
            scope.$on('edit:search', function (event, args) {
                scope.activateSearchPane = false;
                scope.editingSearch = args;
                scope.edit = lodash_1.create(scope.editingSearch) || {};
            });
            scope.editItem = function () {
                scope.activateSearchPane = true;
                scope.edit = lodash_1.create(scope.editingSearch) || {};
            };
            scope.saveas = function () {
                scope.activateSearchPane = true;
                scope.edit = lodash_1.clone(scope.editingSearch) || {};
                delete scope.edit._id;
                scope.edit.name = '';
                scope.edit.description = '';
            };
            scope.cancel = function () {
                scope.sTab = scope.editingSearch ? 'savedSearches' : 'advancedSearch';
                scope.editingSearch = false;
                scope.edit = null;
                scope.activateSearchPane = false;
            };
            scope.isValid = function (edit) {
                if (edit.filter.query.raw == null) {
                    return utils_2.isEmptyString(edit.name);
                }
                return edit.filter.query && utils_2.isEmptyString(edit.filter.query.raw)
                    && utils_2.isEmptyString(edit.name);
            };
            scope.clear = function () {
                scope.editingSearch = false;
                scope.edit = null;
                lodash_1.each($location.search(), function (item, key) {
                    if (key !== 'repo') {
                        $location.search(key, null);
                    }
                });
                $rootScope.$broadcast('tag:removed');
            };
            scope.search = function () {
                $rootScope.$broadcast('search:parameters');
            };
            /**
             * Patches or posts the given search
             */
            scope.save = function (editSearch) {
                function onSuccess() {
                    notify.success(utils_1.gettext('Search was saved successfully'));
                    scope.cancel();
                    scope.sTab = 'savedSearches';
                    scope.edit = null;
                }
                function onFail(error) {
                    scope.edit = null;
                    if (angular.isDefined(error.data._message)) {
                        notify.error(error.data._message);
                    }
                    else {
                        notify.error(utils_1.gettext('Error. Search could not be saved.'));
                    }
                }
                // perform search with selected parameters before saving
                // so parameters get in the url where they are later read from
                scope.search();
                editSearch.filter = editSearch.filter ? editSearch.filter : { query: lodash_1.clone($location.search()) };
                var originalSearch = editSearch._id ? scope.editingSearch : {};
                SavedSearch_1.saveOrUpdateSavedSearch(api, originalSearch, editSearch)
                    .then(onSuccess, onFail);
            };
        },
    };
}
exports.SaveSearch = SaveSearch;


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ItemContainer.$inject = ['desks'];
function ItemContainer(desks) {
    return {
        scope: {
            item: '=',
        },
        template: '<span class="location-desk-label sd-list-item__text-label">{{item.label}}</span> {{item.value}}',
        link: function (scope, elem) {
            if (scope.item._type !== 'ingest') {
                if (scope.item.task && scope.item.task.desk) {
                    desks.initialize().then(function () {
                        if (desks.deskLookup[scope.item.task.desk]) {
                            scope.item.label = 'desk:';
                            scope.item.value = desks.deskLookup[scope.item.task.desk].name;
                        }
                    });
                }
                else if (scope.item._type === 'archive') {
                    scope.item.label = 'location:';
                    scope.item.value = 'workspace';
                }
                else if (scope.item._type === 'archived') {
                    scope.item.label = '';
                    scope.item.value = 'archived';
                }
            }
        },
    };
}
exports.ItemContainer = ItemContainer;


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.ItemPreview
 * @name sdItemPreview
 *
 * @requires asset
 * @requires storage
 * @requires desks
 * @requires lodash
 * @requires familyService
 * @requires privileges
 *
 * @description Handles the functionality of previewing content item.
 */
ItemPreview.$inject = ['asset', 'storage', 'desks', 'lodash', 'familyService', 'privileges'];
function ItemPreview(asset, storage, desks, _, familyService, privileges) {
    /**
     * @description Closes the preview panel if the currently previewed
     * item is spiked / unspiked or moved.
     * @param {Object} scope - angular scope
     * @param {Object} _ - event data (unused)
     * @param {Object=} args - the item that was spiked/unspiked/moved
     */
    function shouldClosePreview(scope, __, args) {
        // if preview pane currently previewed then close
        if (__.name === 'content:update' && scope.item && args &&
            Object.keys(args.items)[0] === scope.item._id) {
            scope.close();
        }
        else if (scope.item && args && args.item === scope.item._id) {
            scope.close();
        }
    }
    return {
        templateUrl: asset.templateUrl('apps/search/views/item-preview.html'),
        scope: {
            item: '=',
            close: '&',
            openLightbox: '=',
            openSingleItem: '=',
            hideActionsMenu: '=',
            showHistoryTab: '=',
        },
        controller: function () {
            this.current_tab = 'content';
        },
        controllerAs: 'vm',
        link: function (scope) {
            scope.showRelatedTab = false;
            scope.toggleLeft = JSON.parse(storage.getItem('shiftLeft'));
            /**
             * Toggle preview pane position - left or right
             * available only when screen size is smaller and authoring is open.
             */
            scope.shiftPreview = function () {
                scope.$applyAsync(function () {
                    scope.toggleLeft = !scope.toggleLeft;
                    storage.setItem('shiftLeft', scope.toggleLeft);
                });
            };
            scope.$watch('item', function (newItem, oldItem) {
                scope.selected = { preview: newItem || null };
                if (newItem !== oldItem) {
                    fetchRelatedItems();
                    // Set the desk and stage names
                    if (newItem && newItem.task && newItem.task.stage) {
                        scope.deskName = desks.deskLookup[newItem.task.desk].name;
                        scope.stage = desks.stageLookup[newItem.task.stage].name;
                        scope.isMediaUsed = _.includes(['audio', 'video', 'picture', 'graphic'], scope.item.type) &&
                            scope.item.used;
                    }
                    else {
                        scope.deskName = scope.stage = null;
                    }
                    // item is associated to an assignment
                    scope.isAssigned = _.get(scope, 'item.assignment_id') && _.get(privileges, 'privileges.planning');
                    if (scope.vm.current_tab === 'assignment' && !scope.isAssigned) {
                        scope.vm.current_tab = 'content';
                    }
                }
            });
            var closePreviewEvents = [
                'item:deleted',
                'item:unlink',
                'item:spike',
                'item:unspike',
                'item:move',
                'content:update'
            ];
            angular.forEach(closePreviewEvents, function (event) {
                scope.$on(event, shouldClosePreview.bind(this, scope));
            });
            /**
             * Return true if the menu actions from
             * preview should be hidden
             *
             * @return {boolean}
             */
            scope.hideActions = function () {
                return scope.hideActionsMenu;
            };
            scope.$on('item:duplicate', fetchRelatedItems);
            /**
             * Reload the related items when navigating to the 'Duplicates' tab to ensure the list is current
             */
            scope.$watch('vm.current_tab', function (newTab, oldTab) {
                if (newTab !== oldTab && newTab === 'related') {
                    fetchRelatedItems();
                }
            });
            /**
             * Fetch related items to the current scope.item
             * This is then used to calculate if we show the 'Duplicates' tab,
             * as well as passed to the sd-media-related directive so we don't
             * double up with this api call
             */
            function fetchRelatedItems() {
                if (scope.item && _.includes(['archive', 'archived'], scope.item._type)) {
                    familyService.fetchItems(scope.item.family_id || scope.item._id, scope.item)
                        .then(setRelatedItems);
                }
                else {
                    setRelatedItems(null);
                }
            }
            /**
             * Sets the scope.relatedItems to the items provided,
             * Then calculates if we should change th current tab to the default one, `content`.
             * This get's around an issue where a previews an item, selects the `duplicates` tab,
             * Then selects a different item that doesn't have duplicates, the duplicate tab is hidden
             * But the duplicate tab is still selected.
             *
             * @param items: List of related items to scope.item
             */
            function setRelatedItems(items) {
                scope.relatedItems = items;
                scope.showRelatedTab = items && items._items.length > 0;
                if (!scope.showRelatedTab && scope.vm.current_tab === 'related') {
                    scope.vm.current_tab = 'content';
                }
            }
        },
    };
}
exports.ItemPreview = ItemPreview;


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
ItemGlobalSearch.$inject = [
    'session', 'api', 'notify', 'keyboardManager', 'asset', 'authoringWorkspace', 'authoring',
];
/**
 * Open Item dialog
 */
function ItemGlobalSearch(session, api, notify, keyboardManager, asset, authoringWorkspace, authoring) {
    return {
        scope: { repo: '=', context: '=' },
        templateUrl: asset.templateUrl('apps/search/views/item-globalsearch.html'),
        link: function (scope, elem) {
            var ENTER = 13;
            var ESC = 27;
            scope.meta = {};
            scope.flags = { enabled: false };
            keyboardManager.bind('ctrl+0', function () {
                scope.flags.enabled = true;
            }, { global: true });
            keyboardManager.bind('esc', function () {
                scope.flags.enabled = false;
            }, { global: true });
            scope.$on('$destroy', function () {
                keyboardManager.unbind('ctrl+0');
                keyboardManager.unbind('esc');
            });
            function reset() {
                scope.meta.unique_name = '';
            }
            function openItem(items) {
                if (items.length > 0) {
                    reset();
                    scope.flags.enabled = false;
                    if (authoring.itemActions(items[0]).edit) {
                        authoringWorkspace.edit(items[0]);
                    }
                    else {
                        authoringWorkspace.view(items[0]);
                    }
                }
                else {
                    notify.error(utils_1.gettext('Item not found...'));
                    scope.flags.enabled = true;
                }
            }
            function searchUserContent(criteria) {
                var resource = api('user_content', session.identity);
                resource.query(criteria).then(function (result) {
                    openItem(result._items);
                }, function (response) {
                    scope.message = utils_1.gettext('There was a problem, item can not open.');
                });
            }
            function fetchItem() {
                var filter = [
                    { not: { term: { state: 'spiked' } } },
                    { bool: { should: [{ term: { unique_name: scope.meta.unique_name } },
                                { term: { _id: scope.meta.unique_name } },
                                { term: { guid: scope.meta.unique_name } },
                                { term: { item_id: scope.meta.unique_name } },
                            ] },
                    },
                ];
                var criteria = {
                    repo: 'archive,published,archived',
                    source: {
                        query: { filtered: { filter: {
                                    and: filter,
                                } } },
                    },
                };
                api.query('search', criteria).then(function (result) {
                    scope.items = result._items;
                    if (scope.items.length > 0) {
                        openItem(scope.items);
                        reset();
                    }
                    else {
                        searchUserContent(criteria);
                    }
                }, function (response) {
                    scope.message = utils_1.gettext('There was a problem, item can not open.');
                });
            }
            scope.search = function () {
                fetchItem();
            };
            scope.openOnEnter = function ($event) {
                if ($event.keyCode === ENTER) {
                    scope.search();
                    $event.stopPropagation();
                }
                if ($event.keyCode === ESC) {
                    _closeDialog();
                }
            };
            scope.close = function () {
                _closeDialog();
            };
            function _closeDialog() {
                reset();
                scope.flags.enabled = false;
            }
        },
    };
}
exports.ItemGlobalSearch = ItemGlobalSearch;


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
ItemSearchbar.$inject = ['$location', '$document', 'asset'];
/**
 * Item search component
 */
function ItemSearchbar($location, $document, asset) {
    return {
        scope: true,
        templateUrl: asset.templateUrl('apps/search/views/item-searchbar.html'),
        link: function (scope, elem) {
            var ENTER = 13;
            scope.focused = false;
            var input = elem.find('#search-input');
            scope.searchOnEnter = function ($event) {
                if ($event.keyCode === ENTER) {
                    scope.search();
                    $event.stopPropagation();
                }
            };
            scope.search = function () {
                if (scope.query) {
                    var newQuery = lodash_1.default.uniq(scope.query.split(/[\s,]+/));
                    scope.query = newQuery.join(' ');
                }
                $location.search('q', scope.query || null);
            };
            scope.cancel = function () {
                scope.query = null;
                scope.search();
                input.focus();
                // to be implemented
            };
            var init = function () {
                var srch = $location.search();
                if (srch.q && srch.q !== '') {
                    scope.query = srch.q.replace(/[()]/g, '');
                }
                else {
                    scope.query = null;
                }
            };
            init();
            scope.$on('tag:removed', init);
            function closeOnClick() {
                scope.$applyAsync(function () {
                    scope.focused = false;
                });
            }
            $document.bind('click', closeOnClick);
            scope.$on('$destroy', function () {
                $document.unbind('click', closeOnClick);
            });
        },
    };
}
exports.ItemSearchbar = ItemSearchbar;


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ItemRepo.$inject = [];
function ItemRepo() {
    return {
        scope: {
            repo: '=',
            context: '=',
            toggleRepo: '=',
        },
        template: __webpack_require__(1777),
    };
}
exports.ItemRepo = ItemRepo;


/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports = "<fieldset ng-if=\"context\">\n    <div class=\"superdeskRepos flex-grid flex-grid--boxed-small flex-grid--wrap-items flex-grid--small-2\" ng-show=\"repo.search === 'local'\">\n        <button type=\"button\" id=\"ingest-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('ingest')\" ng-class=\"{'toggle-button--active': repo.ingest}\">{{:: 'Ingest' | translate}}</button>\n        <button type=\"button\" id=\"archive-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('archive')\" ng-class=\"{'toggle-button--active': repo.archive}\">{{:: 'Production' | translate}}</button>\n        <button type=\"button\" id=\"published-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('published')\" ng-class=\"{'toggle-button--active': repo.published}\">{{:: 'Published' | translate}}</button>\n        <button type=\"button\" id=\"archived-collection\" class=\"toggle-button\" ng-click=\"toggleRepo('archived')\" ng-class=\"{'toggle-button--active': repo.archived}\">{{:: 'Archived' | translate}}</button>\n    </div>\n</fieldset>\n";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSortBar_1 = __webpack_require__(162);
var LinkFunction = /** @class */ (function (_super) {
    __extends(LinkFunction, _super);
    function LinkFunction(search, $location, sort, scope, elem) {
        var _this = _super.call(this, scope, elem, sort) || this;
        _this.search = search;
        _this.$location = $location;
        _this.scope.canSort = _this.canSort.bind(_this);
        _this.scope.sortOptions = search.sortOptions;
        _this.repos = {
            aapmm: true,
            paimg: true,
            // temporaty fix to have several scanpix instances (SDNTB-217)
            // FIXME: need to be refactored (SD-4448)
            'scanpix(ntbtema)': true,
            'scanpix(ntbkultur)': true,
            'scanpix(desk)': true,
            'scanpix(npk)': true,
        };
        _super.prototype.getActive.call(_this);
        return _this;
    }
    /**
     * @ngdoc method
     * @name sdItemSortbar#canSort
     * @public
     * @description check if sort is available or not
     * @return {boolean}
     */
    LinkFunction.prototype.canSort = function () {
        var criteria = this.search.query(this.$location.search()).getCriteria(true);
        return !(angular.isDefined(criteria.repo) && this.repos[criteria.repo]);
    };
    return LinkFunction;
}(BaseSortBar_1.BaseSortBar));
/**
 * @ngdoc directive
 * @module superdesk.apps.content-api
 * @name sd-item-sortbar
 * @requires search
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires sort
 * @description sd-item-sortbar handle the sort functi0nality
 */
function ItemSortbar(search, $location, sort) {
    return {
        scope: { total: '=' },
        template: __webpack_require__(163),
        link: function (scope, elem) { return new LinkFunction(search, $location, sort, scope, elem); },
    };
}
exports.ItemSortbar = ItemSortbar;
ItemSortbar.$inject = ['search', '$location', 'sort'];


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
SavedSearchSelect.$inject = ['session', 'savedSearch'];
function SavedSearchSelect(session, savedSearch) {
    return {
        link: function (scope) {
            savedSearch.getUserSavedSearches(session.identity).then(function (res) {
                scope.searches = res;
            });
        },
    };
}
exports.SavedSearchSelect = SavedSearchSelect;


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SavedSearch_1 = __webpack_require__(161);
var lodash_1 = __webpack_require__(2);
var DateFilters_1 = __webpack_require__(126);
var utils_1 = __webpack_require__(3);
SavedSearches.$inject = [
    '$rootScope', 'api', 'session', 'modal', 'notify', 'asset',
    '$location', 'desks', 'privileges', 'search', 'savedSearch', 'config',
];
function SavedSearches($rootScope, api, session, modal, notify, asset, $location, desks, privileges, search, savedSearch, config) {
    return {
        templateUrl: asset.templateUrl('apps/search/views/saved-searches.html'),
        scope: {},
        link: function (scope) {
            var resource = api('saved_searches');
            scope.config = config;
            scope.selected = null;
            scope.searchText = null;
            scope.userSavedSearches = [];
            scope.globalSavedSearches = [];
            scope.privileges = privileges.privileges;
            scope.userHasPrivileges = privileges.userHasPrivileges;
            var originalUserSavedSearches = [];
            var originalGlobalSavedSearches = [];
            desks.initialize()
                .then(function () {
                scope.userLookup = desks.userLookup;
            });
            function initSavedSearches() {
                savedSearch.getUserSavedSearches(session.identity).then(function (searches) {
                    scope.userSavedSearches.length = 0;
                    scope.globalSavedSearches.length = 0;
                    scope.searches = searches;
                    lodash_1.forEach(scope.searches, function (_savedSearch) {
                        SavedSearch_1.mapFiltersServerToClient(_savedSearch);
                        if (_savedSearch.user === session.identity._id) {
                            scope.userSavedSearches.push(_savedSearch);
                        }
                        else if (_savedSearch.is_global) {
                            scope.globalSavedSearches.push(_savedSearch);
                        }
                    });
                    originalUserSavedSearches = lodash_1.clone(scope.userSavedSearches);
                    originalGlobalSavedSearches = lodash_1.clone(scope.globalSavedSearches);
                });
            }
            initSavedSearches();
            scope.select = function (_search) {
                scope.selected = _search;
                $location.search(DateFilters_1.mapPredefinedDateFiltersServerToClient(_search.filter.query));
            };
            scope.edit = function (_search) {
                scope.select(_search);
                $rootScope.$broadcast('edit:search', _search);
            };
            /**
             * Filters the content of global and user filters
             *
             */
            scope.filter = function () {
                scope.userSavedSearches = lodash_1.clone(originalUserSavedSearches);
                scope.globalSavedSearches = lodash_1.clone(originalGlobalSavedSearches);
                if (scope.searchText || scope.searchText !== '') {
                    scope.userSavedSearches = lodash_1.filter(originalUserSavedSearches, function (n) { return n.name.toUpperCase().indexOf(scope.searchText.toUpperCase()) >= 0; });
                    scope.globalSavedSearches = lodash_1.filter(originalGlobalSavedSearches, function (n) { return n.name.toUpperCase().indexOf(scope.searchText.toUpperCase()) >= 0; });
                }
            };
            scope.remove = function (_search) {
                modal.confirm(utils_1.gettext('Are you sure you want to delete saved search?'))
                    .then(function () {
                    resource.remove(_search).then(function () {
                        notify.success(utils_1.gettext('Saved search removed'));
                        initSavedSearches();
                    }, function () {
                        notify.error(utils_1.gettext('Error. Saved search not deleted.'));
                    });
                });
            };
            scope.isUserSubscribedToSavedSearch = function (_savedSearch) { return SavedSearch_1.isUserSubscribedToSavedSearch(_savedSearch, session.identity._id, function (deskId) { return desks.deskLookup[deskId]; }); };
            scope.editSubscription = function (event, _savedSearch) {
                event.stopPropagation();
                scope.selectedForEditingSubscription = _savedSearch;
            };
            scope.cancelEditingSubscription = function (event) {
                if (event != null) {
                    event.stopPropagation();
                }
                scope.selectedForEditingSubscription = null;
            };
        },
    };
}
exports.SavedSearches = SavedSearches;


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SavedSearch_1 = __webpack_require__(161);
SavedSearchEditOwnSubscription.$inject = ['asset', 'session', 'api'];
function SavedSearchEditOwnSubscription(asset, session, api) {
    return {
        scope: {
            savedSearch: '=',
            cancelEditingSubscription: '=',
        },
        templateUrl: asset.templateUrl('apps/search/views/saved-search-subscribe.html'),
        link: function (scope) {
            scope.closeModal = function () {
                scope.cancelEditingSubscription();
            };
            scope.handleIntervalChange = function (cronExpression) {
                scope.currentlySelectedInterval = cronExpression;
            };
            scope.savingEnabled = function () { return scope.ownSubscription == null
                || (scope.ownSubscription.scheduling !== scope.currentlySelectedInterval); };
            scope.isAlreadySubscribed = function () { return scope.ownSubscription != null; };
            scope.saveOrUpdate = function () {
                var userId = session.identity._id;
                var nextUserSubscriptions = scope.isAlreadySubscribed()
                    ? scope.savedSearch.subscribers.user_subscriptions.map(function (subscription) {
                        if (subscription.user === userId) {
                            return {
                                user: subscription.user,
                                scheduling: scope.currentlySelectedInterval,
                            };
                        }
                        else {
                            return subscription;
                        }
                    })
                    : scope.savedSearch.subscribers.user_subscriptions.concat([{
                            user: userId,
                            scheduling: scope.currentlySelectedInterval,
                        }]);
                var nextSubscribers = __assign({}, scope.savedSearch.subscribers, { user_subscriptions: nextUserSubscriptions });
                SavedSearch_1.updateSubscribers(scope.savedSearch, nextSubscribers, api)
                    .then(scope.closeModal);
            };
            scope.unsubscribeUser = function () {
                return SavedSearch_1.unsubscribeUser(scope.savedSearch, session.identity._id, api).then(scope.closeModal);
            };
            scope.$watch('savedSearch', function () {
                if (scope.savedSearch != null) {
                    if (scope.savedSearch.subscribers == null) {
                        scope.savedSearch.subscribers = {
                            user_subscriptions: [],
                            desk_subscriptions: [],
                        };
                    }
                    scope.ownSubscription = scope.savedSearch.subscribers.user_subscriptions.find(function (subscription) { return subscription.user === session.identity._id; });
                }
            });
        },
    };
}
exports.SavedSearchEditOwnSubscription = SavedSearchEditOwnSubscription;


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TimeInterval_1 = __webpack_require__(1783);
var hourNameLookUp = {
    0: '00:00',
    1: '01:00',
    2: '02:00',
    3: '03:00',
    4: '04:00',
    5: '05:00',
    6: '06:00',
    7: '07:00',
    8: '08:00',
    9: '09:00',
    10: '10:00',
    11: '11:00',
    12: '12:00',
    13: '13:00',
    14: '14:00',
    15: '15:00',
    16: '16:00',
    17: '17:00',
    18: '18:00',
    19: '19:00',
    20: '20:00',
    21: '21:00',
    22: '22:00',
    23: '23:00',
};
var weekdaysToNumbersLookup = {
    SUN: 0,
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
};
var numbersToWeekdaysLookup = {
    0: 'SUN',
    1: 'MON',
    2: 'TUE',
    3: 'WED',
    4: 'THU',
    5: 'FRI',
    6: 'SAT',
};
var cronExpressionToTimeIntervalUi = function (cron) {
    var cronArray = cron.split(' ');
    var hours = cronArray[1];
    var weekdays = cronArray[4];
    var everyHour = hours === '*';
    var everyDay = weekdays === '*';
    return {
        everyDay: everyDay ? 'true' : 'false',
        customWeekdays: everyDay ? [] : weekdays.split(',')
            .map(function (dayNumber) { return numbersToWeekdaysLookup[dayNumber]; }),
        everyHour: everyHour ? 'true' : 'false',
        customHours: everyHour ? [] : hours.split(',').map(function (hourNumber) { return hourNameLookUp[hourNumber]; }),
    };
};
var timeIntervalUiToCronExpression = function (timeInterval) {
    var weekdays = timeInterval.everyDay === 'true' || timeInterval.customWeekdays.length < 1
        ? '*'
        : timeInterval.customWeekdays
            .map(function (weekdayShort) { return weekdaysToNumbersLookup[weekdayShort]; })
            .sort(function (a, b) { return a - b; })
            .join(',');
    var hours = timeInterval.everyHour === 'true' || timeInterval.customHours.length < 1
        ? '*'
        : timeInterval.customHours
            .map(function (hourMinuteString) { return parseInt(hourMinuteString.slice(0, 2), 10); })
            .sort(function (a, b) { return a - b; })
            .join(',');
    return TimeInterval_1.createCronInterval('0', hours, '*', '*', weekdays);
};
function EditTimeInterval() {
    return {
        scope: {
            initialValue: '=',
            onChange: '=',
        },
        template: __webpack_require__(1784),
        link: function (scope) {
            var getDefaults = function () { return ({
                everyDay: 'true',
                customWeekdays: [],
                everyHour: 'true',
                customHours: [],
                hoursList: [
                    '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
                    '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
                    '18:00', '19:00', '20:00', '21:00', '22:00', '23:00',
                ],
            }); };
            scope.wrapper = getDefaults();
            scope.$watch('wrapper', function () {
                var cronExpression = timeIntervalUiToCronExpression(scope.wrapper);
                scope.onChange(cronExpression);
            }, true);
            scope.$watch('initialValue', function () {
                if (scope.initialValue != null) {
                    scope.wrapper = __assign({}, scope.wrapper, cronExpressionToTimeIntervalUi(scope.initialValue || TimeInterval_1.createCronInterval('0', '*', '*', '*', '*')));
                }
            }, true);
        },
    };
}
exports.EditTimeInterval = EditTimeInterval;


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.createCronInterval = function (minute, hour, dayOfMonth, month, dayOfWeek) { return minute + " " + hour + " " + dayOfMonth + " " + month + " " + dayOfWeek; };


/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-label\" translate>Schedule</div>\n\n<div class=\"form__row\">\n    <sd-check type=\"radio\" ng-model=\"wrapper.everyDay\" ng-value=\"true\" label-position=\"inside\">{{'Every day' | translate}}</sd-check>\n    <sd-check type=\"radio\" ng-model=\"wrapper.everyDay\" ng-value=\"false\" label-position=\"inside\">{{'Select days' | translate}}</sd-check>\n</div>\n\n<div\n    ng-if=\"wrapper.everyDay !== 'true'\"\n    sd-weekday-picker\n    data-short-weekday-labels=\"true\"\n    data-model=\"wrapper.customWeekdays\"\n    class=\"form__row\"></div>\n\n<div class=\"form-label\" translate>Time</div>\n\n<div class=\"form__row\">\n    <sd-check type=\"radio\" ng-model=\"wrapper.everyHour\" ng-value=\"true\" label-position=\"inside\">{{'Every hour' | translate}}</sd-check>\n    <sd-check type=\"radio\" ng-model=\"wrapper.everyHour\" ng-value=\"false\" label-position=\"inside\">{{'Select hours' | translate}}</sd-check>\n</div>\n\n<div ng-if=\"wrapper.everyHour !== 'true'\" class=\"form__row\">\n    <div sd-multi-select\n        data-item=\"wrapper.customHours\"\n        data-list=\"wrapper.hoursList\"\n        data-change=\"setDirty(true)\"></div>\n</div>";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SavedSearch_1 = __webpack_require__(161);
var typescript_helpers_1 = __webpack_require__(56);
var utils_1 = __webpack_require__(3);
function isUserSubscription(x) {
    return x != null && x.user !== undefined;
}
function isDeskSubscription(x) {
    return x != null && x.desk !== undefined;
}
SavedSearchManageSubscribers.$inject = ['asset', 'userList', 'api', 'modal', 'desks'];
function SavedSearchManageSubscribers(asset, userList, api, modal, desks) {
    return {
        scope: {
            savedSearch: '=',
            manageSubscriptions: '=',
        },
        templateUrl: asset.templateUrl('apps/search/views/saved-search-manage-subscribers.html'),
        link: function (scope) {
            var getDefaults = function () { return ({
                userSubscribers: [],
                subscriptionInCreateOrEditMode: null,
                currentlySelectedInterval: null,
                userLookup: null,
                users: [],
                desks: desks,
                newSubscriptionFilterText: '',
                modalOpen: false,
            }); };
            scope.editingUserSubscription = function () { return isUserSubscription(scope.wrapper.subscriptionInCreateOrEditMode); };
            scope.editingDeskSubscription = function () { return isDeskSubscription(scope.wrapper.subscriptionInCreateOrEditMode); };
            scope.usersFilter = function (user) {
                return !SavedSearch_1.isUserSubscribedToSavedSearch(scope.savedSearch, user._id, function (deskId) { return desks.deskLookup[deskId]; })
                    && (user.display_name.toLowerCase().includes(scope.wrapper.newSubscriptionFilterText.toLowerCase()))
                    && (scope.savedSearch.is_global === true || user._id === scope.savedSearch.user);
            };
            scope.desksFilter = function (desk) {
                return scope.savedSearch.is_global === true &&
                    desk.name.toLowerCase().includes(scope.wrapper.newSubscriptionFilterText.toLowerCase());
            };
            scope.getSubscriptionCount = function () {
                var count = 0;
                if (scope.savedSearch == null || scope.savedSearch.subscribers == null) {
                    return count;
                }
                if (scope.savedSearch.subscribers.user_subscriptions != null) {
                    count += scope.savedSearch.subscribers.user_subscriptions.length;
                }
                if (scope.savedSearch.subscribers.desk_subscriptions != null) {
                    count += scope.savedSearch.subscribers.desk_subscriptions.length;
                }
                return count;
            };
            scope.wrapper = getDefaults();
            scope.backToList = function () {
                scope.wrapper = __assign({}, scope.wrapper, { subscriptionInCreateOrEditMode: null, currentlySelectedInterval: null });
            };
            scope.subscribeUser = function (user) {
                scope.wrapper.subscriptionInCreateOrEditMode = {
                    user: user._id,
                    scheduling: null,
                };
            };
            scope.subscribeDesk = function (desk) {
                scope.wrapper.subscriptionInCreateOrEditMode = {
                    desk: desk._id,
                    scheduling: null,
                };
            };
            scope.saveChanges = function () {
                var _a = scope.savedSearch.subscribers, user_subscriptions = _a.user_subscriptions, desk_subscriptions = _a.desk_subscriptions;
                var subscriptionInCreateOrEditMode = scope.wrapper.subscriptionInCreateOrEditMode;
                var nextUserSubscriptions = scope.savedSearch.subscribers.user_subscriptions;
                if (isUserSubscription(subscriptionInCreateOrEditMode)) {
                    var userAlreadySubscribed = user_subscriptions.some(function (subscription) { return subscription.user === subscriptionInCreateOrEditMode.user; });
                    nextUserSubscriptions = (userAlreadySubscribed
                        ? user_subscriptions.map(function (subscription) { return subscription.user === subscriptionInCreateOrEditMode.user
                            ? __assign({}, subscriptionInCreateOrEditMode, { scheduling: scope.wrapper.currentlySelectedInterval }) : subscription; })
                        : user_subscriptions.concat(__assign({}, subscriptionInCreateOrEditMode, { scheduling: scope.wrapper.currentlySelectedInterval })));
                }
                var nextDeskSubscriptions = scope.savedSearch.subscribers.desk_subscriptions;
                if (isDeskSubscription(subscriptionInCreateOrEditMode)) {
                    var deskAlreadySubscribed = desk_subscriptions.some(function (subscription) { return subscription.desk === subscriptionInCreateOrEditMode.desk; });
                    nextDeskSubscriptions = (deskAlreadySubscribed
                        ? desk_subscriptions.map(function (subscription) { return subscription.desk === subscriptionInCreateOrEditMode.desk
                            ? __assign({}, subscriptionInCreateOrEditMode, { scheduling: scope.wrapper.currentlySelectedInterval }) : subscription; })
                        : desk_subscriptions.concat(__assign({}, subscriptionInCreateOrEditMode, { scheduling: scope.wrapper.currentlySelectedInterval })));
                }
                var nextSubscribers = __assign({}, scope.savedSearch.subscribers, { user_subscriptions: nextUserSubscriptions, desk_subscriptions: nextDeskSubscriptions });
                SavedSearch_1.updateSubscribers(scope.savedSearch, nextSubscribers, api).then(scope.backToList);
            };
            scope.handleIntervalChange = function (cronExpression) {
                scope.wrapper.currentlySelectedInterval = cronExpression;
            };
            scope.savingEnabled = function () {
                return scope.wrapper.subscriptionInCreateOrEditMode.scheduling !== scope.wrapper.currentlySelectedInterval;
            };
            scope.unsubscribeUser = function (user) {
                return modal.confirm(utils_1.gettext('Are you sure to remove this subscription?'), utils_1.gettext('Unsubscribe user')).then(function () {
                    SavedSearch_1.unsubscribeUser(scope.savedSearch, user._id, api);
                });
            };
            scope.unsubscribeDesk = function (desk) {
                return modal.confirm(utils_1.gettext('Are you sure to remove this subscription?'), utils_1.gettext('Unsubscribe desk')).then(function () {
                    SavedSearch_1.unsubscribeDesk(scope.savedSearch, desk._id, api);
                });
            };
            scope.editUserSubscription = function (user) {
                scope.wrapper.subscriptionInCreateOrEditMode = scope.savedSearch.subscribers.user_subscriptions.find(function (subscription) { return subscription.user === user._id; });
            };
            scope.editDeskSubscription = function (desk) {
                scope.wrapper.subscriptionInCreateOrEditMode = scope.savedSearch.subscribers.desk_subscriptions.find(function (subscription) { return subscription.desk === desk._id; });
            };
            scope.$watch(typescript_helpers_1.nameof('savedSearch')
                + '.'
                + typescript_helpers_1.nameof('subscribers'), function () {
                if (scope.savedSearch != null) {
                    scope.wrapper.modalOpen = true;
                    if (scope.savedSearch.subscribers == null) {
                        scope.savedSearch.subscribers = {
                            user_subscriptions: [],
                            desk_subscriptions: [],
                        };
                    }
                    userList.getAll().then(function (users) {
                        scope.wrapper.users = users;
                        scope.wrapper.userLookup = users.reduce(function (lookUpObj, user) {
                            lookUpObj[user._id] = user;
                            return lookUpObj;
                        }, {});
                        scope.wrapper.userSubscribers = scope.savedSearch.subscribers.user_subscriptions.map(function (subscription) { return users.find(function (user) { return user._id === subscription.user; }); });
                    });
                }
                else {
                    scope.wrapper = getDefaults();
                }
            });
            scope.$watch(typescript_helpers_1.nameof('wrapper')
                + '.'
                + typescript_helpers_1.nameof('modalOpen'), function () {
                // when modal is closed via ESC key, stop managing subscription so it can be started again.
                if (!scope.wrapper.modalOpen) {
                    scope.manageSubscriptions(false);
                }
            });
        },
    };
}
exports.SavedSearchManageSubscribers = SavedSearchManageSubscribers;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
MultiActionBar.$inject = ['asset', 'multi', 'authoringWorkspace', 'superdesk', 'keyboardManager'];
function MultiActionBar(asset, multi, authoringWorkspace, superdesk, keyboardManager) {
    return {
        controller: 'MultiActionBar',
        controllerAs: 'action',
        templateUrl: asset.templateUrl('apps/search/views/multi-action-bar.html'),
        scope: true,
        link: function (scope) {
            scope.multi = multi;
            scope.display = true;
            scope.$watch(multi.getItems, detectType);
            scope.$watch('multi.count', function () {
                scope.display = true;
            });
            scope.toggleDisplay = function () {
                scope.display = !scope.display;
            };
            scope.$on('item:lock', function (_e, data) {
                if (lodash_1.default.includes(multi.getIds(), data.item)) {
                    // locked item is in the selections so update lock info
                    var selectedItems = multi.getItems();
                    lodash_1.default.find(selectedItems, function (_item) { return _item._id === data.item; }).lock_user = data.user;
                    detectType(selectedItems);
                }
            });
            scope.isOpenItemType = function (type) {
                var openItem = authoringWorkspace.getItem();
                return openItem && openItem.type === type;
            };
            scope.openExport = function () {
                scope.export = true;
            };
            scope.closeExport = function () {
                scope.export = false;
            };
            /**
             * Detects type of all selected items and assign it to scope,
             * but only when it's same for all of them.
             *
             * @param {Array} items
             */
            function detectType(items) {
                var types = {};
                var states = [];
                var activities = {};
                angular.forEach(items, function (item) {
                    types[item._type] = 1;
                    states.push(item.state);
                    var _activities = superdesk.findActivities({ action: 'list', type: item._type }, item) || [];
                    var allowOnSessionOwnerLock = ['spike', 'export'];
                    _activities.forEach(function (activity) {
                        // Ignore activities if the item is locked (except those in allowOnSessionOwnerLock)
                        if (!item.lock_user || allowOnSessionOwnerLock.indexOf(activity._id) >= 0) {
                            activities[activity._id] = activities[activity._id] ? activities[activity._id] + 1 : 1;
                        }
                    });
                });
                // keep only activities available for all items
                Object.keys(activities).forEach(function (activity) {
                    if (activities[activity] < items.length) {
                        activities[activity] = 0;
                    }
                });
                var typesList = Object.keys(types);
                scope.type = typesList.length === 1 ? typesList[0] : null;
                scope.state = typesList.length === 1 ? states[0] : null;
                scope.activity = activities;
            }
            keyboardManager.bind('ctrl+shift+#', function () {
                if (scope.activity.spike > 0) {
                    scope.action.spikeItems();
                }
            });
        },
    };
}
exports.MultiActionBar = MultiActionBar;


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module superdesk.apps.search
 * @ngdoc directive
 * @name sdRawSearch
 * @requires asset
 * @requires $location
 * @description
 *   This directive handles the Raw search tab in the search panel. This is a textarea
 *   that allows the user enter a query string that will get passed to the search endpoint.
 */
RawSearch.$inject = ['asset', '$location'];
function RawSearch(asset, $location) {
    return {
        templateUrl: asset.templateUrl('apps/search/views/raw-search.html'),
        link: function (scope) {
            var params = $location.search();
            scope.rawquery = params.raw;
            var ENTER = 13;
            scope.keyPressed = function (event) {
                if (event.keyCode === ENTER) {
                    rawQuery();
                    event.preventDefault();
                }
            };
            scope.$on('search:parameters', rawQuery);
            function rawQuery() {
                $location.search('raw', scope.rawquery || null);
            }
        },
    };
}
exports.RawSearch = RawSearch;


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var moment_1 = __importDefault(__webpack_require__(5));
var DateFilters_1 = __webpack_require__(126);
var LinkFunction = /** @class */ (function () {
    function LinkFunction(desks, tags, $location, scope, elem, metadata) {
        this.scope = scope;
        this.elem = elem;
        this.tags = tags;
        this.$location = $location;
        this.desks = desks;
        this.scope.excludeFacet = this.excludeFacet.bind(this);
        this.scope.hasFilter = this.hasFilter.bind(this);
        this.scope.toggleFilter = this.toggleFilter.bind(this);
        this.scope.removeFilter = this.removeFilter.bind(this);
        this.scope.setFilter = this.setFilter.bind(this);
        this.scope.isEmpty = this.isEmpty.bind(this);
        this.scope.dateFilters = DateFilters_1.getDateFilters();
        this.scope.clearPredefinedFilters = this.clearPredefinedFilters.bind(this);
        this.scope.togglePredefinedDateFilter = this.togglePredefinedDateFilter.bind(this);
        this.scope.hasPredefinedDateFilter = this.hasPredefinedDateFilter.bind(this);
        this.aggregationsMapper = {
            genre: this._categoryMapper.bind(this),
            category: this._categoryMapper.bind(this),
            credit: this._creditMapper.bind(this),
            legal: this._legalMapper.bind(this),
            sms: this._legalMapper.bind(this),
            desk: this._deskMapper.bind(this),
            defaultMapper: this._defaultMapper.bind(this),
        };
        this.init();
        // fetch available languages
        metadata.initialize()
            .then(function () {
            if (metadata.values.languages) {
                scope.languageLabel = {};
                metadata.values.languages.forEach(function (language) {
                    scope.languageLabel[language.qcode] = language.name;
                });
            }
        });
    }
    LinkFunction.prototype.hasPredefinedDateFilter = function (fieldname, filterValue) {
        return this.$location.search()[fieldname] === filterValue;
    };
    LinkFunction.prototype.clearPredefinedFilters = function (fieldname) {
        this.$location.search(fieldname, null);
    };
    LinkFunction.prototype.togglePredefinedDateFilter = function (fieldname, filterValue) {
        // clear exact range filters
        this.$location.search(fieldname + 'from', null);
        this.$location.search(fieldname + 'to', null);
        if (this.hasPredefinedDateFilter(fieldname, filterValue)) {
            this.clearPredefinedFilters(fieldname);
        }
        else {
            this.$location.search(fieldname, filterValue);
        }
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#init
     * @description initialize directives
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        this._initAggregations();
        this.scope.$watch('tags.currentSearch', function (currentSearch) {
            _this.scope.showSaveSearch = !lodash_1.default.isEmpty(currentSearch);
        }, true);
        this.scope.$watch('items', function () {
            _this.tags.initSelectedFacets().then(function (currentTags) {
                _this.scope.tags = currentTags;
                if (!_this.scope.items || _this.scope.items._aggregations === undefined) {
                    return;
                }
                _this._initAggregations();
                var aggregationsKeys = ['type', 'category', 'genre', 'urgency',
                    'priority', 'source', 'credit', 'desk', 'legal', 'sms', 'language'];
                lodash_1.default.each(aggregationsKeys, function (key) {
                    if (lodash_1.default.get(_this.scope.items._aggregations, key)) {
                        if (key in _this.aggregationsMapper) {
                            _this.aggregationsMapper[key](key);
                        }
                        else {
                            _this.aggregationsMapper.defaultMapper(key);
                        }
                    }
                });
            });
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_categoryMapper
     * @description maps aggregations for category and genre
     */
    LinkFunction.prototype._categoryMapper = function (key) {
        var _this = this;
        lodash_1.default.each(this.scope.items._aggregations[key].buckets, function (bucketCount) {
            if (bucketCount.key !== '') {
                _this.scope.aggregations[key][bucketCount.key] = bucketCount.doc_count;
            }
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_creditMapper
     * @description maps aggregations for credit
     */
    LinkFunction.prototype._creditMapper = function (key) {
        var _this = this;
        lodash_1.default.each(this.scope.items._aggregations[key].buckets, function (bucketCount) {
            _this.scope.aggregations[key][bucketCount.key] = {
                count: bucketCount.doc_count,
                qcode: bucketCount.qcode,
            };
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_legalMapper
     * @description maps aggregations for legal
     */
    LinkFunction.prototype._legalMapper = function (key) {
        var _this = this;
        lodash_1.default.each(this.scope.items._aggregations[key].buckets, function (bucketCount) {
            if ((bucketCount.key === 'T' || bucketCount.key === 1) && bucketCount.doc_count > 0) {
                _this.scope.aggregations[key] = { count: bucketCount.doc_count };
            }
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_defaultMapper
     * @description maps aggregations for source, urgency, type
     */
    LinkFunction.prototype._defaultMapper = function (key) {
        var _this = this;
        lodash_1.default.each(this.scope.items._aggregations[key].buckets, function (bucketCount) {
            _this.scope.aggregations[key][bucketCount.key] = bucketCount.doc_count;
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_deskMapper
     * @description map desk aggregations
     */
    LinkFunction.prototype._deskMapper = function (key) {
        var _this = this;
        lodash_1.default.each(this.scope.items._aggregations[key].buckets, function (bucketCount) {
            var lookedUpDesk = _this.desks.deskLookup[bucketCount.key];
            if (typeof lookedUpDesk === 'undefined') {
                var msg = [
                    'Desk (key: ', bucketCount.key, ') not found in ',
                    'deskLookup, probable storage inconsistency.',
                ].join('');
                console.warn(msg);
                return;
            }
            _this.scope.aggregations[key][lookedUpDesk.name] = {
                count: bucketCount.doc_count,
                id: bucketCount.key,
            };
        });
    };
    /**
     * @ngdoc method
     * @private
     * @name sdSearchFilters#_initAggregations
     * @description initialize aggregations
     */
    LinkFunction.prototype._initAggregations = function () {
        this.scope.aggregations = {
            type: {},
            desk: {},
            source: {},
            credit: {},
            category: {},
            urgency: {},
            priority: {},
            genre: {},
            legal: {},
            sms: {},
            language: {},
        };
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#toggleFilter
     * @param {String} type - facet type
     * @param {String} key - facet value
     * @param {String?} fieldname
     */
    LinkFunction.prototype.toggleFilter = function (type, key) {
        if (this.hasFilter(type, key)) {
            this.removeFilter(type, key);
        }
        else {
            this.setFilter(type, key);
        }
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#excludeFacet
     * @description Removes the facets from the list of facets by changing the url
     * It adds the parameters to the url as: notdesk=['123','456']&nottype=['type','composite']
     * Change in location triggers request to 'search' endpoint.
     * @param {String} type - facet type
     * @param {String} key - facet value
     * @param {object} evt - click event
     */
    LinkFunction.prototype.excludeFacet = function (type, key, evt) {
        if (this.hasFilter(type, key)) {
            // If the filter is selected then the filter is unselected and filter is removed.
            this.removeFilter(type, key);
        }
        this.setUrlParameter('not' + type, key);
        evt.stopPropagation();
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#removeFilter
     * @description Removes the tags
     * @param type - facet type
     * @param key - facet value
     */
    LinkFunction.prototype.removeFilter = function (type, key) {
        this.tags.removeFacet(type, key);
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#setFilter
     * @description Filter the results further using the facets.
     * It changes the url based on the facet selected: desk=['123,'456']&type=['type','composite']
     * Change in location triggers request to 'search' endpoint.
     * @param {String} type - facet type
     * @param {String} key - facet value
     */
    LinkFunction.prototype.setFilter = function (type, key) {
        if (!this.isEmpty(type) && key) {
            this.setUrlParameter(type, key);
        }
        else {
            this.$location.search(type, null);
        }
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#setUrlParameter
     * @description Add parameter to the url.
     * @param {String} type - facet type
     * @param {String} key - facet value
     */
    LinkFunction.prototype.setUrlParameter = function (type, key) {
        var currentKeys = this.$location.search()[type];
        if (currentKeys) {
            currentKeys = JSON.parse(currentKeys);
            currentKeys.push(key);
            this.$location.search(type, JSON.stringify(currentKeys));
        }
        else if (type === 'credit') {
            this.$location.search('creditqcode', JSON.stringify([{ label: key, value: this.scope.aggregations.credit[key].qcode }]));
        }
        else {
            this.$location.search(type, JSON.stringify([key]));
        }
    };
    /**
     * @ngdoc method
     * @name sdSearchFilters#isEmpty
     * @public
     * @description check if aggregations are returned in the response
     * @param {string} type Aggregations type
     */
    LinkFunction.prototype.isEmpty = function (type) {
        return lodash_1.default.isEmpty(this.scope.aggregations[type]);
    };
    /**
     * @ngdoc method
     * @public
     * @name sdSearchFilters#format
     * @description formats the date
     */
    LinkFunction.prototype.format = function (date) {
        return date ? moment_1.default(date).format('YYYY-MM-DD') : null; // jshint ignore:line
    };
    /**
     * @ngdoc method
     * @name sdSearchFilters#hasFilter
     * @public
     * @description check if has filter defined.
     * @param {string} type Aggregations type
     * @param {string} key Aggregations key
     * @return {boolean}
     */
    LinkFunction.prototype.hasFilter = function (type, key) {
        if (!this.scope.tags || !this.scope.tags.selectedFacets[type]) {
            return false;
        }
        var facet = this.scope.tags.selectedFacets[type];
        var isValue = lodash_1.default.find(facet, function (f) { return f.value === key; });
        var isLabel = lodash_1.default.find(facet, function (f) { return f.label === key; });
        return isValue || isLabel || facet.indexOf(key) >= 0;
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.content-api
 * @name sdSearchFilters
 * @requires desks
 * @requires tags
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description sd-search-filters handles filtering using aggregates in the
 * left hand side panel of Global search page, archive search page and content api search.
 */
function SearchFilters(desks, tags, $location, metadata) {
    return {
        template: __webpack_require__(1789),
        link: function (scope, elem) { return new LinkFunction(desks, tags, $location, scope, elem, metadata); },
    };
}
exports.SearchFilters = SearchFilters;
SearchFilters.$inject = ['desks', 'tags', '$location', 'metadata'];


/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports = "<div class=\"filter-content\" ng-class=\"{pull: showSaveSearch}\" style=\"width:100%\">\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Content types' | translate }}\" ng-hide=\"isEmpty('type')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.type\" ng-click=\"toggleFilter('type', key)\" ng-class=\"{checked: hasFilter('type',key)}\">\n                <span class=\"filter-box__hover-box\">\n                    <i class=\"filetype-icon-{{key}}\"></i>\n                    <span id=\"filetype-icon-{{key}}\" class=\"sd-checkbox\" ng-checked=\"hasFilter('type',key)\"></span>\n                </span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('type', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{ :: 'Languages' | translate }}\" ng-hide=\"isEmpty('language')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(code, count) in aggregations.language\" ng-click=\"toggleFilter('language', code)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('language', code)\"></span>\n                <span class=\"filter-box__name\">{{ :: languageLabel[code] || code }} <i>{{ count }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('language', code, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Desks' | translate }}\" ng-hide=\"isEmpty('desk')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.desk\" ng-click=\"toggleFilter('desk', value.id)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('desk', value.id)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value.count }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('desk', value.id, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Sources' | translate }}\" ng-hide=\"isEmpty('source')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.source\" ng-click=\"toggleFilter('source', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('source',key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('source', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Credits' | translate }}\" ng-hide=\"isEmpty('credit')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.credit\" ng-click=\"toggleFilter('credit', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('credit', key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value.count }}</i></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Services' | translate }}\" ng-hide=\"isEmpty('category')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.category\" ng-click=\"toggleFilter('category', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('category',key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('category', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Genres' | translate }}\" ng-hide=\"isEmpty('genre')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.genre\" ng-click=\"toggleFilter('genre', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('genre',key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('genre', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Urgency' | translate }}\" ng-hide=\"isEmpty('urgency')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.urgency\" ng-click=\"toggleFilter('urgency', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('urgency',key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('urgency', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Priority' | translate }}\" ng-hide=\"isEmpty('priority')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-repeat=\"(key,value) in aggregations.priority\" ng-click=\"toggleFilter('priority', key)\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('priority',key)\"></span>\n                <span class=\"filter-box__name\">{{ key | translate}} <i>{{ value }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('priority', key, $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <div sd-toggle-box data-style=\"circle\" data-title=\"{{:: 'Flags' | translate }}\" ng-hide=\"isEmpty('legal') && isEmpty('sms')\" data-open=\"true\">\n        <ul class=\"filter-box\">\n            <li class=\"filter-box__item\" ng-click=\"toggleFilter('legal', 'true')\" ng-hide=\"isEmpty('legal')\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('legal', 'true')\"></span>\n                <span class=\"filter-box__name\">{{:: 'Legal' | translate}} <i>{{ aggregations.legal.count }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('legal', 'true', $event)\"></span>\n            </li>\n            <li class=\"filter-box__item\" ng-click=\"toggleFilter('sms', 'true')\" ng-hide=\"isEmpty('sms')\">\n                <span class=\"filter-box__check sd-checkbox\" ng-checked=\"hasFilter('sms', 'true')\"></span>\n                <span class=\"filter-box__name\">{{:: 'Sms' | translate}} <i>{{ aggregations.sms.count }}</i></span>\n                <span class=\"icon-ban-circle filter-box__negate-filter\"\n                      title=\"{{ :: 'Negate' | translate }}\"\n                      ng-if=\"repo.search === 'local'\"\n                      ng-click=\"excludeFacet('sms', 'true', $event)\"></span>\n            </li>\n        </ul>\n    </div>\n\n    <!-- ID only needed for E2E test -->\n    <div ng-repeat=\"dateFilter in dateFilters track by dateFilter.fieldname\"\n        sd-toggle-box data-style=\"circle\" data-title=\"{{:: dateFilter.labelBlock }}\"\n        data-open=\"false\"\n        id=\"filter-{{dateFilter.fieldname}}\"\n        ng-if=\"dateFilter.isEnabled(search_config)\">\n        <form class=\"date-filter\">\n            <div class=\"predefined-dates\">\n                <button ng-repeat=\"predefinedFilter in dateFilter.predefinedFilters track by predefinedFilter.key\"\n                        ng-click=\"togglePredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key)\" \n                        class=\"toggle-button\"\n                        title=\"{{predefinedFilter.label}}\" \n                        ng-class=\"{'toggle-button--active': hasPredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key), 'toggle-button--active': hasPredefinedDateFilter(dateFilter.fieldname, predefinedFilter.key)}\"\n                        id=\"filter-{{dateFilter.fieldname}}-{{predefinedFilter.key}}\">{{predefinedFilter.label}}</button>\n            </div>\n\n            <fieldset ng-show=\"(dateFilter.labelFrom != null && dateFilter.labelTo != null) && (repo.search === 'local' || providerType.startsWith('scanpix') || repo.search === 'content-api' || providerType === 'aapmm')\">\n                <div class=\"form__row form__row--no-padding form__row--flex\">\n                    <div class=\"form__row-item\" sd-date-param data-location=\"{{dateFilter.fieldname}}from\">\n                        <label class=\"form-label\">{{dateFilter.labelFrom}}</label>\n                        <div sd-datepicker on-change=\"clearPredefinedFilters(dateFilter.fieldname)\" ng-model=\"date\"></div>\n                    </div>\n                    <div class=\"form__row-item\" sd-date-param data-location=\"{{dateFilter.fieldname}}to\">\n                        <label class=\"form-label\">{{dateFilter.labelTo}}</label>\n                        <div sd-datepicker on-change=\"clearPredefinedFilters(dateFilter.fieldname)\" ng-model=\"date\"></div>\n                    </div>\n                </div>\n            </fieldset>\n       </form>\n    </div>\n</div>";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function RepoDropdown() {
    return {
        scope: {
            activeProvider: '=',
            toggleProvider: '=',
        },
        template: __webpack_require__(1791),
        link: function (scope) {
            scope.isActive = function (provider) { return scope.activeProvider != null ?
                scope.activeProvider._id === provider._id :
                provider._id !== ''; }; // superdesk has _id ''
        },
    };
}
exports.RepoDropdown = RepoDropdown;


/***/ }),
/* 1791 */
/***/ (function(module, exports) {

module.exports = "<div id=\"repo-dropdown\" class=\"dropdown\" dropdown ng-controller=\"SearchMenuController as search\">\n    <button class=\"dropdown__toggle navbtn navbtn--text-only\" dropdown__toggle>\n        {{ search.providerLabel(activeProvider) || 'Superdesk' }}\n        <span class=\"dropdown__caret\"></span>\n    </button>\n    <ul class=\"dropdown__menu\">\n        <li ng-repeat=\"provider in search.providers track by provider._id\"  ng-class=\"{active: isActive(provider)}\">\n            <button ng-click=\"toggleProvider(provider._id ? provider : null)\">{{ :: search.providerLabel(provider) }}</button>\n        </li>\n    </ul>\n</div>";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.search
 * @name MultiActionBarController
 * @requires $rootScope
 * @requires multi
 * @requires multiEdit
 * @requires send
 * @requires remove
 * @requires modal
 * @requires $q
 * @requires packages
 * @requires superdesk
 * @requires notify
 * @requires spike
 * @requires authoring
 * @requires $location
 * @requires config
 * @description MultiActionBarController holds a set of convenience functions which
 * are used by the Multi-Action bar wwhen an item is click-selected.
 */
MultiActionBarController.$inject = [
    '$rootScope', 'multi', 'multiEdit', 'multiImageEdit', 'send', 'remove', 'modal', '$q',
    'packages', 'superdesk', 'notify', 'spike', 'authoring', 'privileges', '$location', 'config', 'api',
];
function MultiActionBarController($rootScope, multi, multiEdit, multiImageEdit, send, remove, modal, $q, packages, superdesk, notify, spike, authoring, privileges, $location, config, api) {
    this.send = function () {
        send.all(multi.getItems());
    };
    this.sendAs = function () {
        send.allAs(multi.getItems());
    };
    this.canRemoveIngestItems = function () {
        var canRemove = true;
        multi.getItems().forEach(function (item) {
            canRemove = canRemove && remove.canRemove(item);
        });
        return canRemove;
    };
    /**
     * Remove multiple ingest items
     */
    this.removeIngestItems = function () {
        multi.getItems().forEach(function (item) {
            remove.remove(item);
        });
        multi.reset();
    };
    this.multiedit = function () {
        multiEdit.create(multi.getIds());
        multiEdit.open();
    };
    this.multiImageEdit = function () {
        var originalImages = multi.getItems();
        // load images fully. Using multi.getItems() doesn't work
        // since it doesn't contain "subject" required for "usage terms"
        Promise.all(multi.getIds().map(function (id) { return api.find('archive', id); }))
            .then(function (imagesFromDatabase) {
            // <TECHNICAL DEBT>
            // UI state(`selected` property of the article) is stored on a database/API entity
            // because of that, it's not possible to use the latest data from the API
            // and it has to be patched on top of old data in order for UI state related properties to be preserved
            imagesFromDatabase.forEach(function (imageFromDb) {
                var originalImage = originalImages.find(function (i) { return i._id === imageFromDb._id; });
                // attaching missing properties to originalImages
                for (var prop in imageFromDb) {
                    originalImage[prop] = imageFromDb[prop];
                }
            });
            // </TECHNICAL DEBT>
            multiImageEdit.edit(originalImages, function (editedImages) { return Promise.all(originalImages.map(function (image) { return authoring.save(image, lodash_1.default.find(editedImages, function (item) { return item._id === image._id; })); })); });
        });
    };
    this.createPackage = function () {
        packages.createPackageFromItems(multi.getItems())
            .then(function (newPackage) {
            superdesk.intent('edit', 'item', newPackage);
            multi.reset();
        }, function (response) {
            if (response.status === 403 && response.data && response.data._message) {
                notify.error(utils_1.gettext(response.data._message), 3000);
            }
        });
    };
    this.addToPackage = function () {
        $rootScope.$broadcast('package:addItems', { items: multi.getItems(), group: 'main' });
        multi.reset();
    };
    /**
     * Multiple item spike
     */
    this.spikeItems = function () {
        var message = utils_1.gettext('Are you sure you want to spike the items?');
        var assignedItems = lodash_1.default.get(privileges, 'privileges.planning') ?
            multi.getItems().filter(function (item) { return item.assignment_id; }) : [];
        var spikeMultiple = function () {
            spike.spikeMultiple(multi.getItems());
            $rootScope.$broadcast('item:spike');
            multi.reset();
        };
        if ($location.path() === '/workspace/personal') {
            message = utils_1.gettext('Do you want to delete the items permanently?');
        }
        else if (assignedItems.length) {
            message = utils_1.gettext('Some item/s are linked to in-progress planning coverage, spike anyway?');
        }
        else if (!lodash_1.default.get(config, 'confirm_spike', true)) {
            spikeMultiple();
            return;
        }
        return modal.confirm(message)
            .then(spikeMultiple);
    };
    /**
     * Multiple item unspike
     */
    this.unspikeItems = function () {
        spike.unspikeMultiple(multi.getItems());
        $rootScope.$broadcast('item:unspike');
        multi.reset();
    };
    this.canEditMetadata = function () { return multi.getItems().every(function (item) { return !item.lock_user && ['picture', 'video', 'audio'].includes(item.type); }); };
    this.canPackageItems = function () {
        var canPackage = true;
        multi.getItems().forEach(function (item) {
            canPackage = canPackage && item._type !== 'archived' && !item.lock_user &&
                !lodash_1.default.includes(['ingested', 'spiked', 'killed', 'recalled', 'draft'], item.state);
        });
        return canPackage;
    };
    /**
     * @ngdoc method
     * @name MultiActionBarController#canHighlightItems
     * @description Checks if all items multi-selected are eligible to be highlighted
     * @returns {Boolean}
     */
    this.canHighlightItems = function () {
        return multi.getItems().every(function (item) { return authoring.itemActions(item).mark_item_for_highlight; });
    };
    /**
     * Publish all items
     */
    this.publish = function () {
        $q.all(multi.getItems().map(function (item) { return authoring.publish(item, item); }))
            .then(function (responses) {
            var withErrors = responses.some(function (response) { return response.status >= 400; });
            if (withErrors) {
                notify.error(utils_1.gettext('Some items could not be published.'));
            }
            else {
                notify.success(utils_1.gettext('All items were published successfully.'));
                multi.reset();
            }
        });
    };
}
exports.MultiActionBarController = MultiActionBarController;


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
SearchController.$inject = ['$location', 'searchProviderService', 'config'];
function SearchController($location, searchProviderService, config) {
    var _this = this;
    var SUPERDESK = 'local';
    var INTERNAL = ['archive', 'published', 'ingest', 'archived'];
    var DEFAULT_CONFIG = Object.assign({}, {
        ingest: true,
        archive: true,
        published: true,
        archived: true,
        search: SUPERDESK,
    }, config.defaultSearch);
    var getActiveRepos = function () { return INTERNAL.filter(function (name) { return _this.repo[name]; }); };
    var resetInternalRepo = function () { return _this.repo = Object.assign({}, DEFAULT_CONFIG); };
    resetInternalRepo();
    // init based on $location
    if ($location.search().repo && !lodash_1.intersection($location.search().repo.split(','), INTERNAL).length) {
        this.repo.search = $location.search().repo;
    }
    // init search providers
    searchProviderService.getActiveSearchProviders()
        .then(function (providers) {
        _this.providers = providers;
        // init selected/default provider
        if (_this.providers.length) {
            var selectedProvider = _this.providers.find(function (provider) {
                return provider.search_provider === $location.search().repo || provider._id === $location.search().repo;
            });
            var defaultProvider = $location.search().repo === undefined &&
                _this.providers.find(function (provider) { return provider.is_default; });
            _this.activeProvider = selectedProvider || defaultProvider;
            if (_this.activeProvider) {
                _this.toggleProvider(_this.activeProvider);
                return;
            }
        }
        // internal search - init repos
        var repos = ($location.search().repo || '').split(',').filter(function (repo) { return !!repo; });
        INTERNAL.forEach(function (repo) {
            _this.repo[repo] = repos.length === 0 ? DEFAULT_CONFIG[repo] : repos.indexOf(repo) >= 0;
        });
    });
    /**
     * Toggle internal repo
     * @param {string} repoName
     */
    this.toggleRepo = function (repoName) {
        _this.repo[repoName] = !_this.repo[repoName];
        var active = getActiveRepos();
        if (active.length === 0) {
            // if no active repo then reset the state of the all repo buttons to active.
            resetInternalRepo();
            active = getActiveRepos();
        }
        $location.search('repo', active.join(','));
    };
    /**
     * Toggle search provider
     * @param {Object} provider
     */
    this.toggleProvider = function (provider) {
        _this.activeProvider = provider || null;
        _this.providerType = provider ? provider.search_provider : null;
        if (provider) {
            $location.search('repo', provider._id);
            _this.repo = { search: provider._id };
        }
        else {
            $location.search('repo', '');
            resetInternalRepo();
        }
    };
}
exports.SearchController = SearchController;


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
SearchMenuController.$inject = ['$rootScope', '$filter', '$location', '$route', 'searchProviderService', 'api'];
function SearchMenuController($rootScope, $filter, $location, $route, searchProviderService, api) {
    var _this = this;
    var providerLabels = {};
    var SUPERDESK_PROVIDER = {
        _id: '',
        name: 'Superdesk',
    };
    /**
     * Activate search shortcut
     *
     * @param {Object} provider
     */
    this.loadSearchShortcut = function (provider) {
        var repo = provider === SUPERDESK_PROVIDER ?
            '' : (provider._id || provider.search_provider || provider.source);
        $location.url('/search?repo=' + repo);
        $route.reload();
    };
    /**
     * Get provider label
     *
     * Keep it undefined until there is some value so one time watch will work.
     *
     * @param {Object} provider
     */
    this.providerLabel = function (provider) { return provider && (provider.name || providerLabels[provider.source]) || undefined; };
    // init search providers
    if ($rootScope.config && $rootScope.config.features && $rootScope.config.features.searchShortcut) {
        api.search_providers.query({ max_results: 200, where: { is_closed: { $ne: true } } })
            .then(function (result) {
            _this.providers = $filter('sortByName')(result._items, 'search_provider');
            var defaultProvider = _this.providers.find(function (provider) { return provider.is_default; });
            if (defaultProvider) {
                _this.providers = _this.providers.filter(function (provider) { return provider !== defaultProvider; });
                _this.providers.unshift(SUPERDESK_PROVIDER);
                _this.providers.unshift(defaultProvider);
            }
            else {
                _this.providers.unshift(SUPERDESK_PROVIDER);
            }
        });
        searchProviderService.getAllowedProviderTypes()
            .then(function (providerTypes) {
            providerLabels = searchProviderService.getProviderLabels(providerTypes);
        });
    }
}
exports.default = SearchMenuController;


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var ChangeImageController_1 = __webpack_require__(558);
var logger_1 = __webpack_require__(415);
var utils_1 = __webpack_require__(3);
MultiImageEditController.$inject = [
    '$scope',
    'modal',
    'notify',
];
function MultiImageEditController($scope, modal, notify) {
    var saveHandler = $scope.saveHandler;
    $scope.images = angular.copy($scope.imagesOriginal);
    var unsavedChangesExist = false;
    $scope.$watch('imagesOriginal', function (imagesOriginal) {
        // add and remove images without losing metadata of the ones which stay
        var updatedImages = imagesOriginal.map(function (image) {
            var existingImage = $scope.images.find(function (_a) {
                var _id = _a._id;
                return _id === image._id;
            });
            return existingImage != null
                ? existingImage
                : __assign({}, image, lodash_1.pickBy($scope.metadata, function (value) { return !lodash_1.isEmpty(value); }));
        });
        $scope.images = angular.copy(updatedImages);
    });
    $scope.placeholder = {};
    $scope.isDirty = function () { return unsavedChangesExist; };
    $scope.selectImage = function (image) {
        if ($scope.images.length === 1) {
            $scope.images[0].selected = true;
        }
        else {
            image.selected = !image.selected;
        }
        updateMetadata();
    };
    // wait for images for initial load
    $scope.$watch('images', function (images) {
        if (images != null && images.length) {
            images.forEach($scope.selectImage);
        }
    });
    $scope.onChange = function (field) {
        try {
            if (field == null) {
                throw new Error('field required');
            }
        }
        catch (e) {
            logger_1.logger.error(e);
            return;
        }
        unsavedChangesExist = true;
        $scope.placeholder[field] = '';
        $scope.images.forEach(function (item) {
            if (item.selected) {
                item[field] = $scope.metadata[field] || '';
            }
        });
    };
    $scope.save = function (close) {
        var imagesForSaving = angular.copy($scope.images);
        imagesForSaving.forEach(function (image) {
            delete image.selected;
        });
        try {
            imagesForSaving.forEach(function (metadata) {
                ChangeImageController_1.validateMediaFieldsThrows($scope.validator, metadata);
            });
        }
        catch (e) {
            notify.error(e);
            return;
        }
        saveHandler(imagesForSaving)
            .then(function (res) {
            if (res != null) {
                $scope.images = angular.copy(Array.isArray(res) && res.length > 0 ? res : [res]);
            }
            unsavedChangesExist = false;
            if (close && typeof $scope.successHandler === 'function') {
                $scope.successHandler();
            }
        });
    };
    $scope.close = function () {
        if ($scope.isDirty()) {
            modal.confirm(utils_1.gettext('You have unsaved changes, do you want to continue?'), utils_1.gettext('Confirm'))
                .then(function () {
                if (typeof $scope.cancelHandler === 'function') {
                    $scope.cancelHandler();
                }
            });
        }
        else if (typeof $scope.cancelHandler === 'function') {
            $scope.cancelHandler();
        }
    };
    $scope.getSelectedImages = function () { return ($scope.images || []).filter(function (item) { return item.selected; }); };
    function updateMetadata() {
        $scope.metadata = {
            // subject is required to "usage terms" and other custom fields are editable
            subject: compare('subject'),
            headline: compare('headline'),
            description_text: compare('description_text'),
            archive_description: compare('archive_description'),
            alt_text: compare('alt_text'),
            byline: compare('byline'),
            copyrightholder: compare('copyrightholder'),
            usageterms: compare('usageterms'),
            copyrightnotice: compare('copyrightnotice'),
        };
    }
    function compare(fieldName) {
        var uniqueValues = lodash_1.uniq($scope.getSelectedImages()
            .filter(function (item) { return item[fieldName] != null; })
            // IArticle['subject'] is a collection of custom vocabulary items
            // stringifying is required to compare arrays
            .map(function (item) { return JSON.stringify(item[fieldName]); }));
        var defaultValue = fieldName === 'subject' ? [] : '';
        if (uniqueValues.length < 1) {
            return defaultValue;
        }
        else if (uniqueValues.length > 1) {
            $scope.placeholder[fieldName] = '(multiple values)';
            return defaultValue;
        }
        else {
            $scope.placeholder[fieldName] = '';
            return JSON.parse(uniqueValues[0]);
        }
    }
}
exports.MultiImageEditController = MultiImageEditController;
MultiImageEditDirective.$inject = ['asset', '$sce'];
function MultiImageEditDirective(asset, $sce) {
    return {
        scope: {
            imagesOriginal: '=',
            isUpload: '=',
            saveHandler: '=',
            cancelHandler: '=',
            successHandler: '=',
            hideEditPane: '=',
            getThumbnailHtml: '=',
            getIconForItemType: '=',
            getProgress: '=',
            onRemoveItem: '=',
            uploadInProgress: '=',
            validator: '=',
        },
        transclude: {
            'additional-content': '?sdMultiEditAdditionalContent',
            'select-desk': '?sdMultiEditSelectDesk',
        },
        controller: MultiImageEditController,
        templateUrl: asset.templateUrl('apps/search/views/multi-image-edit.html'),
        link: function (scope) {
            scope.trustAsHtml = $sce.trustAsHtml;
            scope.handleItemClick = function (event, image) {
                if (event.target != null && event.target.classList.contains('icon-close-small')) {
                    scope.onRemoveItem(image);
                }
                else {
                    scope.selectImage(image);
                }
            };
            scope.updateMetadata = function () {
                lodash_1.forEach(scope.metadata, function (metadata, key) {
                    scope.onChange(key);
                });
            };
        },
    };
}
exports.MultiImageEditDirective = MultiImageEditDirective;


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = __webpack_require__(1797);
var controllers_1 = __webpack_require__(1799);
var directives_1 = __webpack_require__(1801);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.legal_archive
 * @name superdesk.apps.legal_archive
 * @packageName superdesk.apps
 * @description Application that adds legal archive support.
 */
exports.default = angular.module('superdesk.apps.legal_archive', [
    'superdesk.core.datetime',
    'superdesk.core.activity',
    'superdesk.core.api',
    'superdesk.apps.search',
])
    .service('legal', services_1.LegalArchiveService)
    .directive('sdLegalItemSortbar', directives_1.LegalItemSortbar)
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('legal_archive', {
            type: 'http',
            backend: { rel: 'legal_archive' },
        });
        apiProvider.api('legal_archive_versions', {
            type: 'http',
            backend: { rel: 'legal_archive_versions' },
        });
    }])
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/legal_archive/', {
            label: utils_1.gettext('Legal Archive'),
            description: utils_1.gettext('Confidential data'),
            priority: 100,
            category: superdesk.MENU_MAIN,
            adminTools: false,
            controller: controllers_1.LegalArchiveController,
            templateUrl: 'scripts/apps/legal-archive/views/legal_archive.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            reloadOnSearch: false,
            filters: [],
            privileges: { legal_archive: 1 },
            features: { legal_archive: 1 },
        });
    }]);


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LegalArchiveService_1 = __webpack_require__(1798);
exports.LegalArchiveService = LegalArchiveService_1.LegalArchiveService;


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.legal_archive
 * @name legal
 * @requires api
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires config
 * @requires moment
 * @requires sort
 *
 * @description Handles retrieval of data from legal archive
 */
LegalArchiveService.$inject = ['api', '$location', 'config', 'moment', 'sort'];
function LegalArchiveService(api, $location, config, moment, sortService) {
    var DEFAULT_PER_PAGE = 25;
    this.default_items = Object.freeze({ _meta: { max_results: DEFAULT_PER_PAGE, page: 1, total: 1 } });
    var sortOptions = [
        { field: 'versioncreated', label: utils_1.gettext('Updated') },
        { field: 'firstcreated', label: utils_1.gettext('Created') },
        { field: 'urgency', label: utils_1.gettext('Urgency') },
        { field: 'anpa_category.name', label: utils_1.gettext('Category') },
        { field: 'slugline', label: utils_1.gettext('Slugline') },
        { field: 'priority', label: utils_1.gettext('Priority') },
    ];
    sortService.setSort('versioncreated', sortOptions);
    this.sortOptions = sortOptions;
    this.getCriteria = function () {
        var params = $location.search(), criteria = {
            max_results: Number(params.max_results) || DEFAULT_PER_PAGE,
        };
        if (params.q) {
            criteria.where = params.q;
        }
        if (params.page) {
            criteria.page = parseInt(params.page, 10);
        }
        if (params.sort) {
            var sort = params.sort.split(':');
            criteria.sort = sortService.formatSort(sort[0], sort[1]);
        }
        else {
            criteria.sort = sortService.formatSort('versioncreated', 'desc');
        }
        return criteria;
    };
    this.updateSearchQuery = function updateSearchQuery(search) {
        var where = [];
        function prepareDate(val, timeSuffix) {
            var local = moment(val, config.view.dateformat).format('YYYY-MM-DD') + timeSuffix +
                moment.tz(config.defaultTimezone).format('ZZ');
            return moment(local, 'YYYY-MM-DDTHH:mm:ssZZ').utc()
                .format('YYYY-MM-DDTHH:mm:ssZZ');
        }
        var hasId = false;
        lodash_1.default.forEach(search, function (n, key) {
            var val = lodash_1.default.trim(n);
            if (val) {
                var clause = {};
                if (key === 'published_after') {
                    clause.versioncreated = { $gte: prepareDate(val, 'T00:00:00') };
                }
                else if (key === 'published_before') {
                    clause.versioncreated = { $lte: prepareDate(val, 'T23:59:59') };
                }
                else if (key === '_id') {
                    clause._id = val;
                    hasId = true;
                }
                else {
                    clause[key] = { $regex: val, $options: '-i' };
                }
                where.push(clause);
            }
        });
        var whereClause = null;
        if (hasId && where.length === 1) {
            whereClause = JSON.stringify(where[0]);
        }
        else if (where.length > 0) {
            whereClause = JSON.stringify({
                $and: where,
            });
        }
        $location.search('q', whereClause);
        return whereClause;
    };
    // query public api
    this.query = function query() {
        var searchCriteria = this.getCriteria();
        return api.legal_archive.query(searchCriteria);
    };
}
exports.LegalArchiveService = LegalArchiveService;


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LegalArchiveController_1 = __webpack_require__(1800);
exports.LegalArchiveController = LegalArchiveController_1.LegalArchiveController;


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
LegalArchiveController.$inject = ['$scope', '$location', 'legal', 'preferencesService'];
function LegalArchiveController($scope, $location, legal, preferencesService) {
    var viewUpdate = { 'archive:view': {
            allowed: ['mgrid', 'compact'],
            category: 'archive',
            view: 'mgrid',
            default: 'mgrid',
            label: 'Users archive view format',
            type: 'string'
        } };
    $scope.criteria = {};
    $scope.items = legal.default_items;
    $scope.loading = false;
    $scope.selected = {};
    $scope.openAdvanceSearch = false;
    // to stop itemList to fetch new items when scrolled
    $scope.noScroll = true;
    // Required to display action icons in grid view
    $scope.extras = { activity: { action: 'list' } };
    $scope.search = function () {
        $location.search('page', null);
        legal.updateSearchQuery($scope.criteria);
    };
    function refresh() {
        $scope.loading = true;
        $scope.preview(null);
        legal.query().then(function (items) {
            $scope.loading = false;
            $scope.items = items;
        });
    }
    $scope.preview = function (selectedItem) {
        $scope.selected.preview = selectedItem;
        if (selectedItem) {
            $scope.deskName = selectedItem.task.desk;
            $scope.stage = selectedItem.task.stage;
        }
    };
    $scope.openLightbox = function () {
        $scope.selected.view = $scope.selected.preview;
    };
    $scope.closeLightbox = function () {
        $scope.selected.view = null;
    };
    $scope.clear = function () {
        legal.criteria = $scope.criteria = {};
        $scope.search();
    };
    $scope.$watch(function getSearchParams() {
        return lodash_1.default.omit($location.search(), '_id');
    }, refresh, true);
    /**
     * Sets the item view to either grid or compact. Also, saves the same in loggedInUser's preference.
     */
    $scope.setview = function (view) {
        $scope.view = view || 'mgrid';
        viewUpdate['archive:view'].view = view || 'mgrid';
        preferencesService.update(viewUpdate, 'archive:view');
    };
    $scope.search();
    preferencesService.get('archive:view').then(function (result) {
        var savedView = result.view;
        $scope.view = !!savedView && savedView !== 'undefined' ? savedView : 'mgrid';
    });
}
exports.LegalArchiveController = LegalArchiveController;


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LegalItemSortbar_1 = __webpack_require__(1802);
exports.LegalItemSortbar = LegalItemSortbar_1.LegalItemSortbar;


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSortBar_1 = __webpack_require__(162);
var LinkFunction = /** @class */ (function (_super) {
    __extends(LinkFunction, _super);
    function LinkFunction(legal, sort, scope, elem) {
        var _this = _super.call(this, scope, elem, sort) || this;
        _this.legal = legal;
        _this.scope.canSort = _super.prototype.canSort.bind(_this);
        _this.scope.sortOptions = legal.sortOptions;
        _super.prototype.getActive.call(_this);
        return _this;
    }
    return LinkFunction;
}(BaseSortBar_1.BaseSortBar));
/**
 * @ngdoc directive
 * @module superdesk.apps.legal-archive
 * @name sdLegalItemSortBar
 * @requires legal
 * @requires sort
 * @description sd-legal-item-sort-bar handle sort functionality.
 */
function LegalItemSortbar(legal, sort) {
    return {
        scope: { total: '=' },
        template: __webpack_require__(163),
        link: function (scope, elem) { return new LinkFunction(legal, sort, scope, elem); },
    };
}
exports.LegalItemSortbar = LegalItemSortbar;
LegalItemSortbar.$inject = ['legal', 'sort'];


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(1804);
var services_1 = __webpack_require__(1806);
var directives_1 = __webpack_require__(1807);
var utils_1 = __webpack_require__(3);
exports.default = angular.module('superdesk.apps.stream', [
    'superdesk.core.activity',
    'superdesk.core.services.asset',
])
    .controller('StreamController', controllers_1.StreamController)
    .service('sdActivityMessage', services_1.ActivityMessageService)
    .directive('sdActivityStream', directives_1.ActivityStream)
    .directive('sdActivityMessage', directives_1.ActivityMessage)
    .config(['superdeskProvider', 'assetProvider', function (superdesk, asset) {
        superdesk.activity('/workspace/stream', {
            label: utils_1.gettext('Workspace'),
            controller: 'StreamController',
            beta: true,
            templateUrl: asset.templateUrl('apps/stream/views/workspace-stream.html'),
            topTemplateUrl: asset.templateUrl('apps/dashboard/views/workspace-topnav.html'),
        });
    }]);


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StreamController_1 = __webpack_require__(1805);
exports.StreamController = StreamController_1.StreamController;


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
StreamController.$inject = ['$scope', 'api', '$rootScope', 'desks'];
function StreamController($scope, api, $rootScope, desks) {
    $scope.desk = null;
    $scope.activities = null;
    $scope.pageLength = 10;
    $scope.max_results = $scope.pageLength;
    $scope.loadMore = function () {
        if ($scope.activities._meta.total > $scope.max_results) {
            $scope.max_results += $scope.pageLength;
            fetchActivities();
        }
    };
    $scope.showDateHeader = function (activity) {
        $scope.currentDate = new Date($scope.activities._items[activity.index]._created);
        if (activity.index === 0) {
            return true;
        }
        var previousDate = new Date($scope.activities._items[activity.index - 1]._created);
        return previousDate.getFullYear() !== $scope.currentDate.getFullYear() ||
            previousDate.getMonth() !== $scope.currentDate.getMonth() ||
            previousDate.getDate() !== $scope.currentDate.getDate();
    };
    var fetchActivities = function () {
        var filter = { max_results: $scope.max_results };
        if ($scope.desk) {
            filter.where = { desk: $scope.desk._id };
        }
        api('activity', { embedded: { user: 1 } }).query(filter)
            .then(function (result) {
            $scope.activities = result;
        });
    };
}
exports.StreamController = StreamController;


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
ActivityMessageService.$inject = [];
function ActivityMessageService() {
    return {
        format: function (activity) {
            if (activity && activity.name !== 'notify') {
                return utils_1.gettext(activity.message, activity.data);
            }
            return '';
        },
    };
}
exports.ActivityMessageService = ActivityMessageService;


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ActivityStream_1 = __webpack_require__(1808);
exports.ActivityStream = ActivityStream_1.ActivityStream;
var ActivityMessage_1 = __webpack_require__(1809);
exports.ActivityMessage = ActivityMessage_1.ActivityMessage;


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ActivityStream.$inject = ['asset', 'authoringWorkspace'];
function ActivityStream(asset, authoringWorkspace) {
    return {
        scope: {
            activities: '=',
            max_results: '=maxResults',
            loadMore: '&',
        },
        templateUrl: asset.templateUrl('apps/stream/views/activity-stream.html'),
        link: function (scope, element, attrs) {
            scope.openArticle = function (activity) {
                if (activity.item) {
                    authoringWorkspace.edit({ _id: activity.item }, 'edit');
                }
            };
        },
    };
}
exports.ActivityStream = ActivityStream;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ActivityMessage.$inject = ['sdActivityMessage'];
function ActivityMessage(sdActivityMessage) {
    return {
        scope: { activity: '=' },
        template: '{{display_message}}',
        link: function (scope, element, attrs) {
            scope.display_message = sdActivityMessage.format(scope.activity);
        },
    };
}
exports.ActivityMessage = ActivityMessage;


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1811);
var ctrl = __importStar(__webpack_require__(1813));
var directive = __importStar(__webpack_require__(1819));
var services_1 = __webpack_require__(1833);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.packaging
 * @name superdesk.apps.packaging
 * @packageName superdesk.apps
 * @description This module adds support for packages.
 */
angular.module('superdesk.apps.packaging', [
    'superdesk.core.api',
    'superdesk.core.activity',
    'superdesk.apps.authoring',
])
    .service('packages', services_1.PackagesService)
    .directive('sdPackageEdit', directive.PackageEdit)
    .directive('sdPackageItemsEdit', directive.PackageItemsEdit)
    .directive('sdSortPackageItems', directive.SortPackageItems)
    .directive('sdPackage', directive.Package)
    .directive('sdPackageItem', directive.PackageItem)
    .directive('sdPackageItemProxy', directive.PackageItemProxy)
    .directive('sdPackageRef', directive.PackageRef)
    .directive('sdPackageItemPreview', directive.PackageItemPreview)
    .directive('sdWidgetPreventPreview', directive.PreventPreview)
    .directive('sdAddPackageDropdown', directive.AddPackageDropdown)
    .controller('SearchWidgetCtrl', ctrl.SearchWidgetCtrl)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('create.package', {
            label: utils_1.gettext('Create package'),
            controller: ctrl.CreatePackageCtrl,
            filters: [{ action: 'create', type: 'package' }],
            condition: function (item) {
                return item ? (item.state !== 'killed' && item.state !== 'recalled') : true;
            },
        })
            .activity('packageitem', {
            label: utils_1.gettext('Create package'),
            priority: 50,
            icon: 'package-create',
            keyboardShortcut: 'ctrl+alt+p',
            controller: ctrl.PackageItemCtrl,
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', '$rootScope', function (authoring, item, $rootScope) {
                    return authoring.itemActions(item).package_item &&
                        !($rootScope.config && $rootScope.config.features
                            && $rootScope.config.features.hideCreatePackage);
                }],
            group: 'packaging',
        })
            .activity('addtopackage', {
            label: utils_1.gettext('Add to current'),
            priority: 5,
            dropdown: directive.AddToPackageDropdown,
            icon: 'package-plus',
            templateUrl: 'scripts/apps/packaging/views/add-to-package.html',
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoringWorkspace', 'item', 'authoring', 'packages',
                function (authoringWorkspace, item, authoring, packages) {
                    var pkg = authoringWorkspace.getItem();
                    var actions = authoring.itemActions(item);
                    var added = pkg ? packages.isAdded(pkg, item) : false;
                    return pkg && pkg.type === 'composite' && pkg._id !== item._id
                        && actions.add_to_current && !added;
                }],
            group: 'packaging',
        })
            .activity('combineinpackage', {
            label: utils_1.gettext('Combine with current'),
            priority: 49,
            icon: 'package-plus',
            controller: ctrl.CombinePackageCtrl,
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoringWorkspace', 'item', 'authoring',
                function (authoringWorkspace, item, authoring) {
                    var openItem = authoringWorkspace.getItem();
                    var actions = authoring.itemActions(item);
                    return openItem && openItem.type !== 'composite' && openItem._id !== item._id &&
                        actions.add_to_current;
                }],
            group: 'packaging',
        })
            .activity('movepackage', {
            label: utils_1.gettext('Send package to'),
            icon: 'share-alt',
            controller: ['data', 'send', function (data, send) {
                    send.allAs([data.item], 'send_to');
                }],
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', 'config', function (authoring, item, config) {
                    return authoring.itemActions(item).send && item.type === 'composite';
                },
            ],
            group: 'packaging',
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('archive', { type: 'http', backend: { rel: 'archive' } });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('archived', { type: 'http', backend: { rel: 'archived' } });
    }]);


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1812);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./packaging.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./packaging.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.package-item {\n  border-radius: 1px;\n  background: #fff;\n  box-shadow: 0px 1px 4px 0 rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  position: relative;\n  border-left: 4px solid #fff;\n  display: flex;\n  margin-bottom: 10px;\n  transition: all 0.2s; }\n  .package-item__icon-holder {\n    margin: 5px 10px 0 0 !important;\n    opacity: 0.5;\n    max-width: 24px;\n    min-width: 24px;\n    padding-right: 10px; }\n  .package-item__drag-handle {\n    position: absolute;\n    top: 3px;\n    bottom: 3px;\n    left: 2px;\n    background: url(" + escape(__webpack_require__(58)) + ") repeat 0 0;\n    width: 6px;\n    opacity: 0;\n    transition: all 0.2s; }\n  .package-item__open-item {\n    position: absolute;\n    right: 8px;\n    top: 8px;\n    opacity: 0;\n    cursor: pointer; }\n  .package-item.locked {\n    border-left-color: #be1600; }\n  .package-item.published {\n    border-left-color: #5e8d32; }\n  .package-item.killed {\n    border-left-color: #303030; }\n  .package-item__thumb-holder {\n    max-width: 120px;\n    min-width: 120px;\n    border-radius: 2px;\n    overflow: hidden;\n    height: 80px;\n    background: #f0f0f0;\n    float: left;\n    margin-right: 16px; }\n    .package-item__thumb-holder img {\n      margin: 0 !important; }\n    .package-item__thumb-holder .loading {\n      margin: 20px 0 0 40px; }\n    .package-item__thumb-holder .error-icon {\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\";\n      height: 80px;\n      line-height: 80px;\n      text-align: center; }\n      .package-item__thumb-holder .error-icon i {\n        vertical-align: middle;\n        zoom: 0.7; }\n  .package-item__item-text-group {\n    display: flex;\n    flex-direction: column; }\n  .package-item__item-headline {\n    padding-right: 40px;\n    max-height: 74px;\n    overflow: hidden;\n    font-size: 14px;\n    flex-grow: 1;\n    font-weight: bold; }\n  .package-item__item-abstract {\n    margin-top: 5px; }\n  .package-item__item-creator {\n    color: #909090; }\n  .package-item__action-menu {\n    position: absolute;\n    top: 5px;\n    right: 16px; }\n    .package-item__action-menu .more-activity-toggle {\n      width: 16px;\n      height: 16px !important;\n      padding: 2px 6px 3px !important;\n      font-size: 13px !important;\n      line-height: 18px !important; }\n  .package-item .loading {\n    width: 40px;\n    height: 40px;\n    background: #f0f0f0 url(" + escape(__webpack_require__(34)) + ") center center no-repeat; }\n  .package-item .alert-error {\n    font-size: 12px;\n    padding: 10px;\n    height: 80px; }\n  .package-item:hover .package-item__open-item {\n    opacity: 0.3; }\n    .package-item:hover .package-item__open-item:hover {\n      opacity: 1; }\n\n.sort-item .package-item:hover {\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.16), 0 1px 6px rgba(0, 0, 0, 0.4);\n  padding-left: 16px;\n  cursor: move; }\n  .sort-item .package-item:hover .package-item__drag-handle {\n    opacity: 0.5; }\n\n.packaging-screen .page-content-container > .content {\n  width: auto;\n  max-width: 800px;\n  min-height: 100%;\n  max-height: 100%;\n  margin: 0 auto;\n  border: 1px solid #ebebeb;\n  border-width: 0 1px;\n  background: #fcfcfc;\n  padding: 30px 60px 20px;\n  box-sizing: border-box;\n  overflow: auto; }\n\n.packaging-screen .page-content-container .toggle-box h6 {\n  background: #fcfcfc; }\n\n.packaging-screen .page-content-container .package-header {\n  margin-bottom: 30px;\n  position: relative;\n  min-height: 52px; }\n  .packaging-screen .page-content-container .package-header .title {\n    font-weight: 500;\n    font-size: 18px; }\n  .packaging-screen .page-content-container .package-header input, .packaging-screen .page-content-container .package-header textarea {\n    border-color: #fff !important; }\n    .packaging-screen .page-content-container .package-header input:hover, .packaging-screen .page-content-container .package-header input:focus, .packaging-screen .page-content-container .package-header textarea:hover, .packaging-screen .page-content-container .package-header textarea:focus {\n      border-color: #d0d0d0 !important; }\n\n.placeholder {\n  margin: 20px 0; }\n\n.item.composite .package-details {\n  display: none; }\n\n.package-edit {\n  padding: 10px 0 100px; }\n  .package-edit > li {\n    margin: 0;\n    padding: 0; }\n    .package-edit > li .group-info {\n      position: relative; }\n      .package-edit > li .group-info:before {\n        content: \" \";\n        position: absolute;\n        border-bottom: 1px solid #dcdcdc;\n        height: 1px;\n        top: 9px;\n        left: 20px;\n        right: 0px; }\n      .package-edit > li .group-info h6 {\n        background: #fcfcfc;\n        padding: 0 5px;\n        font-size: 11px;\n        text-transform: uppercase;\n        color: #666;\n        position: relative;\n        display: inline-block; }\n  .package-edit .package-edit-items {\n    min-height: 80px; }\n    .package-edit .package-edit-items .fake div {\n      padding: 10px 0; }\n    .package-edit .package-edit-items > li:not(.placeholder):not(.fake):first-child {\n      margin-top: -15px; }\n      .package-edit .package-edit-items > li:not(.placeholder):not(.fake):first-child .item-container {\n        margin-top: 30px; }\n    .package-edit .package-edit-items > li.fake:first-child div {\n      padding: 40px 0; }\n    .package-edit .package-edit-items .preview-container {\n      padding: 20px 20px; }\n    .package-edit .package-edit-items .item-container {\n      position: relative; }\n      .package-edit .package-edit-items .item-container .remove {\n        background: none;\n        border: 0;\n        position: absolute;\n        right: 25px;\n        top: 6px;\n        opacity: 0; }\n      .package-edit .package-edit-items .item-container:hover .remove {\n        opacity: 0.3; }\n        .package-edit .package-edit-items .item-container:hover .remove:hover {\n          opacity: 1; }\n", ""]);

// exports


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PackagingController_1 = __webpack_require__(1814);
exports.PackagingController = PackagingController_1.PackagingController;
var SearchWidgetCtrl_1 = __webpack_require__(1815);
exports.SearchWidgetCtrl = SearchWidgetCtrl_1.SearchWidgetCtrl;
var CreatePackageCtrl_1 = __webpack_require__(1816);
exports.CreatePackageCtrl = CreatePackageCtrl_1.CreatePackageCtrl;
var PackageItemCtrl_1 = __webpack_require__(1817);
exports.PackageItemCtrl = PackageItemCtrl_1.PackageItemCtrl;
var CombinePackageCtrl_1 = __webpack_require__(1818);
exports.CombinePackageCtrl = CombinePackageCtrl_1.CombinePackageCtrl;


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackagingController.$inject = ['$scope', 'item', 'packages', 'api', 'modal', 'notify', 'superdesk'];
function PackagingController($scope, item, packages, api, modal, notify, superdesk) {
    $scope.origItem = item;
    $scope.action = 'edit';
    $scope.lock = function () {
        superdesk.intent('author', 'package', item);
    };
    // Highlights related functionality
    $scope.highlight = !!item.highlight;
}
exports.PackagingController = PackagingController;


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
SearchWidgetCtrl.$inject = ['$scope', 'packages', 'api', 'search'];
function SearchWidgetCtrl($scope, packages, api, search) {
    $scope.selected = null;
    $scope.multiSelected = [];
    $scope.query = null;
    $scope.highlight = null;
    var packageItems = null;
    var init = false;
    $scope.groupList = packages.groupList;
    fetchContentItems();
    function fetchContentItems() {
        if (!init) {
            return;
        }
        var params = {};
        params.q = $scope.query;
        params.ignoreKilled = true;
        params.ignoreDigital = true;
        params.ignoreScheduled = true;
        params.onlyLastPublished = true;
        var query = search.query(params);
        query.filter({ not: { exists: { field: 'embargo' } } });
        query.size(25);
        if ($scope.highlight) {
            query.filter({ term: { highlights: $scope.highlight.toString() } });
        }
        var criteria = query.getCriteria(true);
        criteria.repo = 'archive,published';
        api.query('search', criteria)
            .then(function (result) {
            $scope.contentItems = result._items;
        });
    }
    $scope.$watch('query', function (query) {
        fetchContentItems();
    });
    $scope.$watch('highlight', function (highlight) {
        fetchContentItems();
    });
    $scope.$watch('item', function (item) {
        $scope.highlight = item.highlight;
        if ($scope.highlight) {
            api('highlights').getById($scope.highlight)
                .then(function (result) {
                $scope.groupList = result.groups;
                init = true;
                fetchContentItems();
            }, function (response) {
                init = true;
                fetchContentItems();
            });
        }
        else {
            init = true;
            fetchContentItems();
        }
    });
    $scope.$watch('item.groups', function () {
        getPackageItems();
    }, true);
    /**
     * Add a content item to a given group
     * @param {Object} group
     * @param {Object} item
     */
    $scope.addItemToGroup = function (group, item) {
        packages.addItemsToPackage($scope.item, group, [item]);
        $scope.autosave($scope.item);
    };
    $scope.preview = function (item) {
        $scope.selected = item;
    };
    function getPackageItems() {
        var items = [];
        if ($scope.item.groups) {
            lodash_1.default.each($scope.item.groups, function (group) {
                if (group.id !== 'root') {
                    lodash_1.default.each(group.refs, function (item) {
                        items.push(item.residRef);
                    });
                }
            });
        }
        packageItems = items;
    }
    $scope.itemInPackage = function (item) {
        return lodash_1.default.indexOf(packageItems, item._id) > -1;
    };
    $scope.addToSelected = function (pitem) {
        if (pitem.multi) {
            $scope.multiSelected.push(pitem);
        }
        else {
            lodash_1.default.remove($scope.multiSelected, pitem);
        }
    };
    $scope.addMultiItemsToGroup = function (group) {
        // add to group
        packages.addItemsToPackage($scope.item, group, $scope.multiSelected);
        $scope.autosave($scope.item);
        // uncheck all
        lodash_1.default.each($scope.multiSelected, function (item) {
            item.multi = false;
            packages.addPackageGroupItem(group, item, false);
        });
        // clear items
        $scope.multiSelected = [];
    };
}
exports.SearchWidgetCtrl = SearchWidgetCtrl;


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
CreatePackageCtrl.$inject = ['data', 'packages', 'authoringWorkspace'];
function CreatePackageCtrl(data, packages, authoringWorkspace) {
    function edit(item) {
        authoringWorkspace.edit(item);
    }
    if (data && data.items) {
        packages.createPackageFromItems(data.items, data.defaults).then(edit);
    }
    else {
        var defaultData = data && data.defaults ? data.defaults : {};
        packages.createEmptyPackage(defaultData).then(edit);
    }
}
exports.CreatePackageCtrl = CreatePackageCtrl;


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
PackageItemCtrl.$inject = ['data', 'packages', 'authoringWorkspace', 'notify'];
function PackageItemCtrl(data, packages, authoringWorkspace, notify) {
    packages.createPackageFromItems([data.item])
        .then(function (newPackage) {
        authoringWorkspace.edit(newPackage);
    }, function (response) {
        if (response.status === 403 && response.data && response.data._message) {
            notify.error(utils_1.gettext(response.data._message), 3000);
        }
    });
}
exports.PackageItemCtrl = PackageItemCtrl;


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
CombinePackageCtrl.$inject = ['data', 'packages', 'authoringWorkspace', 'notify'];
function CombinePackageCtrl(data, packages, authoringWorkspace, notify) {
    var openItem = authoringWorkspace.getItem();
    packages.createPackageFromItems([openItem, data.item])
        .then(function (newPackage) {
        authoringWorkspace.edit(newPackage);
    }, function (response) {
        if (response.status === 403 && response.data && response.data._message) {
            notify.error(utils_1.gettext(response.data._message), 3000);
        }
    });
}
exports.CombinePackageCtrl = CombinePackageCtrl;


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PreventPreview_1 = __webpack_require__(1820);
exports.PreventPreview = PreventPreview_1.PreventPreview;
var Package_1 = __webpack_require__(1821);
exports.Package = Package_1.Package;
var PackageEdit_1 = __webpack_require__(1822);
exports.PackageEdit = PackageEdit_1.PackageEdit;
var PackageRef_1 = __webpack_require__(1823);
exports.PackageRef = PackageRef_1.PackageRef;
var PackageItem_1 = __webpack_require__(1824);
exports.PackageItem = PackageItem_1.PackageItem;
var PackageItemPreview_1 = __webpack_require__(1825);
exports.PackageItemPreview = PackageItemPreview_1.PackageItemPreview;
var PackageItemProxy_1 = __webpack_require__(1826);
exports.PackageItemProxy = PackageItemProxy_1.PackageItemProxy;
var PackageItemsEdit_1 = __webpack_require__(1827);
exports.PackageItemsEdit = PackageItemsEdit_1.PackageItemsEdit;
var SortPackageItems_1 = __webpack_require__(1828);
exports.SortPackageItems = SortPackageItems_1.SortPackageItems;
var AddPackageDropdown_1 = __webpack_require__(1829);
exports.AddPackageDropdown = AddPackageDropdown_1.AddPackageDropdown;
var AddToPackageDropdown_1 = __webpack_require__(1830);
exports.AddToPackageDropdown = AddToPackageDropdown_1.AddToPackageDropdown;


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
function PreventPreview() {
    return {
        link: function (scope, el) {
            el.bind('click', previewOnClick);
            scope.$on('$destroy', function () {
                el.unbind('click', previewOnClick);
            });
            function previewOnClick(event) {
                if ($(event.target).closest('.group-select').length === 0) {
                    scope.$apply(function () {
                        scope.preview(scope.pitem);
                    });
                }
            }
        },
    };
}
exports.PreventPreview = PreventPreview;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
function Package() {
    var solveRefs = function (item, groups) {
        var items = { childId: '_items', childData: [] };
        var tree = [items];
        lodash_1.default.each(item.refs, function (ref) {
            if (ref.idRef) {
                tree.push({ childId: ref.idRef, childData: solveRefs(lodash_1.default.find(groups, { id: ref.idRef }), groups) });
            }
            else if (ref.residRef) {
                items.childData.push(ref);
            }
        });
        return tree;
    };
    return {
        templateUrl: 'scripts/apps/packaging/views/sd-package.html',
        scope: {
            item: '=',
            setitem: '&',
        },
        link: function (scope, elem, attrs) {
            scope.mode = attrs.mode || 'tree';
            scope.$watchGroup(['item', 'item.groups', 'item.deleted_groups'], function () {
                var isDeleted = scope.item.deleted_groups != null && scope.item.deleted_groups.length !== 0;
                var groups = isDeleted ? scope.item.deleted_groups : scope.item.groups;
                if (scope.item && groups) {
                    scope.tree = solveRefs(lodash_1.default.find(groups, { id: 'root' }), groups);
                }
            });
        },
    };
}
exports.Package = Package;


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackageEdit.$inject = ['authoring'];
function PackageEdit(authoring) {
    return {
        templateUrl: 'scripts/apps/packaging/views/sd-package-edit.html',
        link: function (scope) {
            scope.limits = authoring.limits;
            scope._editable = scope.origItem._editable;
            scope._isInPublishedStates = authoring.isPublished(scope.origItem);
        },
    };
}
exports.PackageEdit = PackageEdit;


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackageRef.$inject = ['api', '$rootScope'];
function PackageRef(api, $rootScope) {
    return {
        templateUrl: 'scripts/apps/packaging/views/sd-package-ref.html',
        scope: {
            item: '=',
            setitem: '&',
        },
    };
}
exports.PackageRef = PackageRef;


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function PackageItem() {
    return {
        templateUrl: 'scripts/apps/packaging/views/sd-package-item.html',
        scope: {
            id: '=',
            item: '=',
            setitem: '&',
            mode: '=',
        },
    };
}
exports.PackageItem = PackageItem;


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
PackageItemPreview.$inject = ['api', 'lock', 'superdesk', 'authoringWorkspace', '$location', '$sce',
    'desks', 'vocabularies'];
function PackageItemPreview(api, lock, superdesk, authoringWorkspace, $location, $sce, desks, vocabularies) {
    return {
        scope: {
            item: '=',
            readonly: '@',
        },
        templateUrl: 'scripts/apps/packaging/views/sd-package-item-preview.html',
        link: function (scope, elem) {
            scope.data = null;
            scope.error = null;
            scope.userLookup = desks.userLookup;
            scope.label = null;
            scope.labels = [];
            var packageItemLabelsVocabularyId = 'package-story-labels';
            var initLabels = function () {
                vocabularies.getVocabulary(packageItemLabelsVocabularyId).then(function (vocabulary) {
                    scope.labels = vocabulary.items;
                    scope.label = lodash_1.default.find(vocabulary.items, { qcode: scope.item.label });
                });
            };
            initLabels();
            if (scope.item.location) {
                var url = '';
                var endpoint = '';
                if (lodash_1.default.includes(['archive', 'legal_archive'], scope.item.location)) {
                    url = scope.item.location + '/' + scope.item.residRef;
                    url += scope.item._current_version ? '?version=' + scope.item._current_version : '';
                    endpoint = scope.item.location;
                }
                else if (lodash_1.default.includes('ingest', scope.item.location)) {
                    url = scope.item.location + '/' + scope.item.residRef;
                    endpoint = 'ingest';
                }
                else {
                    url = scope.item.location + '/' + scope.item.residRef + ':' + scope.item._current_version;
                    endpoint = 'archived';
                }
                api[endpoint].getByUrl(url)
                    .then(function (result) {
                    scope.data = result;
                    if (scope.data.abstract) {
                        scope.data.abstract = $sce.trustAsHtml(scope.data.abstract);
                    }
                    scope.isLocked = lock.isLocked(scope.data);
                    scope.isPublished = lodash_1.default.includes(['published', 'corrected'], scope.data.state);
                    scope.isKilled = (scope.data.state === 'killed' || scope.data.state === 'recalled');
                }, function (response) {
                    scope.error = true;
                });
            }
            scope.$on('item:lock', function (_e, data) {
                if (scope.data && scope.data._id === data.item) {
                    scope.$applyAsync(function () {
                        scope.data.lock_user = data.user;
                        scope.isLocked = lock.isLocked(scope.data);
                    });
                }
            });
            scope.$on('item:unlock', function (_e, data) {
                if (scope.data && scope.data._id === data.item) {
                    scope.$applyAsync(function () {
                        scope.data.lock_user = null;
                        scope.isLocked = false;
                    });
                }
            });
            scope.$on('item:publish', function (_e, data) {
                if (scope.data && scope.data._id === data.item) {
                    scope.$applyAsync(function () {
                        scope.isPublished = true;
                    });
                }
            });
            scope.$on('item:label', function (_e, data) {
                if (scope.data && scope.data._id === data.item.residRef) {
                    scope.label = lodash_1.default.find(scope.labels, { qcode: data.item.label });
                }
            });
            scope.$on('vocabularies:updated', function (_e, data) {
                if (data.vocabulary_id === packageItemLabelsVocabularyId) {
                    initLabels();
                }
            });
            scope.preview = function (item) {
                superdesk.intent('preview', 'item', item);
            };
            scope.open = function (item) {
                authoringWorkspace.open(item);
            };
        },
    };
}
exports.PackageItemPreview = PackageItemPreview;


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackageItemProxy.$inject = ['$compile'];
function PackageItemProxy($compile) {
    var template = '<div sd-package-item data-id="id"' +
        ' data-item="item"' +
        ' data-setitem="setitem({selected: selected})"' +
        ' data-mode="mode">' +
        '</div>';
    return {
        scope: {
            id: '=',
            item: '=',
            setitem: '&',
            mode: '=',
        },
        link: function (scope, elem) {
            elem.append($compile(template)(scope));
        },
    };
}
exports.PackageItemProxy = PackageItemProxy;


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
PackageItemsEdit.$inject = ['packages', 'notify', '$rootScope'];
function PackageItemsEdit(packages, notify, $rootScope) {
    return {
        scope: false,
        require: 'ngModel',
        templateUrl: 'scripts/apps/packaging/views/sd-package-items-edit.html',
        link: function (scope, elem, attrs, ngModel) {
            scope.$on('package:addItems', function (event, data) {
                var groupIndex = lodash_1.default.findIndex(scope.list, { id: data.group });
                if (groupIndex === -1) {
                    scope.list.push({ id: data.group, items: [] });
                    groupIndex = scope.list.length - 1;
                }
                for (var i = 0; i < data.items.length; i++) {
                    if (isAdded(data.items[i])) {
                        notify.error(utils_1.gettext('Item is already in this package.'));
                    }
                    else {
                        scope.list[groupIndex].items.unshift(packages.getReferenceFor(data.items[i]));
                    }
                }
                autosave();
            });
            scope.$on('package:updateGroupRef', function (event, data) {
                var group = lodash_1.default.find(scope.list, { id: data.group.id });
                if (group) {
                    var ref = lodash_1.default.find(group.items, { residRef: data.ref.residRef });
                    if (ref) {
                        lodash_1.default.merge(ref, data.ref);
                        $rootScope.$broadcast('item:label', { item: data.ref });
                    }
                }
                autosave();
            });
            scope.$on('$destroy', function () {
                packages.packageGroupItems = {};
            });
            ngModel.$render = function () {
                scope.list = ngModel.$viewValue || [];
            };
            ngModel.$parsers.unshift(function (viewValue) {
                var groups = null;
                if (viewValue && viewValue.list) {
                    groups = [];
                    groups.push({
                        role: 'grpRole:NEP',
                        refs: lodash_1.default.map(viewValue.list, function (r) { return ({ idRef: r.id }); }),
                        id: 'root',
                    });
                    lodash_1.default.each(viewValue.list, function (l) {
                        groups.push({
                            id: l.id,
                            role: 'grpRole:' + l.id,
                            refs: l.items,
                        });
                    });
                }
                return groups;
            });
            ngModel.$formatters.unshift(function (modelValue) {
                var root = lodash_1.default.find(modelValue, { id: 'root' });
                if (typeof root === 'undefined') {
                    return;
                }
                var firstLevelGroups = lodash_1.default.map(root.refs, function (group) { return ({
                    id: group.idRef,
                    items: [],
                }); });
                lodash_1.default.each(firstLevelGroups, function (group) {
                    group.items = visit(group.id);
                });
                function visit(groupId) {
                    var _group = lodash_1.default.find(modelValue, { id: groupId });
                    var items = [];
                    lodash_1.default.each(_group.refs, function (ref) {
                        if (_isNode(ref)) {
                            items = lodash_1.default.union(items, visit(ref.idRef));
                        }
                        else {
                            items.push(ref);
                        }
                    });
                    return items;
                }
                function _isNode(obj) {
                    return angular.isDefined(obj.idRef);
                }
                return firstLevelGroups;
            });
            scope.remove = function (groupId, residRef) {
                var group = lodash_1.default.find(scope.list, { id: groupId });
                var item = lodash_1.default.find(group.items, { residRef: residRef });
                lodash_1.default.remove(group.items, { residRef: residRef });
                packages.removePackageGroupItem(group, item);
                autosave();
            };
            scope.reorder = function (start, end) {
                var src = lodash_1.default.find(scope.list, { id: start.group });
                var dest = lodash_1.default.find(scope.list, { id: end.group });
                if (start.index !== end.index || start.group !== end.group) {
                    var item = src.items.splice(start.index, 1)[0];
                    dest.items.splice(end.index, 0, item);
                    packages.addPackageGroupItem(dest, item, false);
                }
                else {
                    // just change the address
                    dest.items = lodash_1.default.cloneDeep(dest.items);
                }
                autosave();
            };
            function autosave() {
                ngModel.$setViewValue({ list: scope.list });
                scope.autosave(scope.item);
            }
            function isAdded(item) {
                return scope.list.some(function (group) { return group.items.some(function (i) { return i.residRef === item._id; }); });
            }
        },
    };
}
exports.PackageItemsEdit = PackageItemsEdit;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
function SortPackageItems() {
    return {
        link: function (scope, element) {
            var updated = false;
            element.sortable({
                items: '.package-edit-items li',
                cursor: 'move',
                containment: '.package-edit-container',
                tolerance: 'pointer',
                placeholder: {
                    element: function (current) {
                        var height = current.height() - 40;
                        return $('<li class="placeholder" style="height:' + height + 'px"></li>')[0];
                    },
                    update: function () { },
                },
                start: function (event, ui) {
                    ui.item
                        .data('start_index', ui.item
                        .parent()
                        .find('li.sort-item')
                        .index(ui.item));
                    ui.item
                        .data('start_group', ui.item
                        .parent()
                        .data('group'));
                },
                stop: function (event, ui) {
                    if (updated) {
                        updated = false;
                        var start = {
                            index: ui.item
                                .data('start_index'),
                            group: ui.item
                                .data('start_group'),
                        };
                        var end = {
                            index: ui.item
                                .parent()
                                .find('li.sort-item')
                                .index(ui.item),
                            group: ui.item
                                .parent()
                                .data('group'),
                        };
                        ui.item.remove();
                        scope.reorder(start, end);
                        scope.$apply();
                    }
                },
                update: function (event, ui) {
                    updated = true;
                },
                cancel: '.fake',
            });
        },
    };
}
exports.SortPackageItems = SortPackageItems;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
AddPackageDropdown.$inject = ['$rootScope', 'api', 'packages', 'authoringWorkspace'];
function AddPackageDropdown($rootScope, api, packages, authoringWorkspace) {
    return {
        templateUrl: 'scripts/apps/packaging/views/sd-add-package-dropdown.html',
        link: function (scope) {
            var pkg = authoringWorkspace.getItem();
            scope.groupList = null;
            if (pkg.highlight) {
                api('highlights').getById(pkg.highlight)
                    .then(function (result) {
                    scope.groupList = result.groups;
                });
            }
            scope.groupList = scope.groupList || packages.groupList;
            scope.select = function (group) {
                packages.addPackageGroupItem(group, scope.item);
            };
        },
    };
}
exports.AddPackageDropdown = AddPackageDropdown;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var PackageGroupList_1 = __importDefault(__webpack_require__(1831));
AddToPackageDropdown.$inject = ['item', 'className', 'authoringWorkspace', 'packages', 'api', '$rootScope'];
function AddToPackageDropdown(item, className, authoringWorkspace, packages, api, $rootScope) {
    return react_1.default.createElement(PackageGroupList_1.default, {
        item: item,
        package: authoringWorkspace.getItem(),
        api: api,
        packages: packages,
        className: className,
    });
}
exports.AddToPackageDropdown = AddToPackageDropdown;


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var PackageGroup_1 = __importDefault(__webpack_require__(1832));
var PackageGroupList = /** @class */ (function (_super) {
    __extends(PackageGroupList, _super);
    function PackageGroupList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { groups: [] };
        return _this;
    }
    PackageGroupList.prototype.componentDidMount = function () {
        var _this = this;
        var pkg = this.props.package;
        if (pkg.highlight) {
            this.props.api.find('highlights', pkg.highlight)
                .then(function (result) {
                _this.setState({ groups: result.groups });
            });
        }
        else {
            // set it here to avoid flickering
            this.setState({ groups: this.props.packages.groupList });
        }
    };
    PackageGroupList.prototype.render = function () {
        var _this = this;
        var createGroup = function (group) {
            return react_1.default.createElement(PackageGroup_1.default, {
                group: group,
                key: 'group-' + group,
                item: _this.props.item,
                packages: _this.props.packages,
            });
        };
        return react_1.default.createElement('ul', { className: this.props.className }, this.state.groups.length ? this.state.groups.map(createGroup) : null);
    };
    return PackageGroupList;
}(react_1.default.Component));
exports.default = PackageGroupList;
PackageGroupList.propTypes = {
    package: prop_types_1.default.object,
    api: prop_types_1.default.func,
    item: prop_types_1.default.object,
    className: prop_types_1.default.any,
    packages: prop_types_1.default.object,
};


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var PackageGroup = /** @class */ (function (_super) {
    __extends(PackageGroup, _super);
    function PackageGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.select = _this.select.bind(_this);
        return _this;
    }
    PackageGroup.prototype.select = function () {
        this.props.packages.addPackageGroupItem(this.props.group, this.props.item);
    };
    PackageGroup.prototype.render = function () {
        var group = this.props.group;
        return (react_1.default.createElement("li", null,
            react_1.default.createElement("button", { "data-option": group, onClick: this.select },
                react_1.default.createElement("i", { className: "icon-plus" }),
                group)));
    };
    return PackageGroup;
}(react_1.default.Component));
exports.default = PackageGroup;
PackageGroup.propTypes = {
    group: prop_types_1.default.string,
    item: prop_types_1.default.object,
    packages: prop_types_1.default.object,
};


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PackagesService_1 = __webpack_require__(1834);
exports.PackagesService = PackagesService_1.PackagesService;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
PackagesService.$inject = ['api', '$q', 'archiveService', 'lock', 'autosave', 'authoring',
    'authoringWorkspace', 'desks', '$rootScope'];
function PackagesService(api, $q, archiveService, lock, autosave, authoring, authoringWorkspace, desks, $rootScope) {
    var self = this;
    this.groupList = ['main', 'story', 'sidebars', 'fact box'];
    this.packageGroupItems = {};
    this.fetch = function fetch(_id) {
        return api.find('archive', _id).then(function (result) { return result; });
    };
    this.open = function open(_id, readOnly) {
        return authoring.open(_id, readOnly);
    };
    this.createPackageFromItems = function (items, defaults) {
        var idRef = 'main';
        var item = items[0];
        var newPackage = {
            headline: item.headline || item.description_text || '',
            slugline: item.slugline || '',
            description_text: item.description_text || '',
            state: 'draft',
            type: 'composite',
            version: 0,
        };
        var groups = [{
                role: 'grpRole:NEP',
                refs: [{ idRef: idRef }],
                id: 'root',
            },
            getGroupFor(null, idRef),
        ];
        newPackage = setDefaults(newPackage, defaults);
        newPackage.groups = groups;
        if (!newPackage.task || !newPackage.task.desk) {
            newPackage.task = { desk: desks.getCurrentDeskId() };
        }
        this.addItemsToPackage(newPackage, idRef, items);
        return api.save('archive', newPackage);
    };
    this.createEmptyPackage = function (defaults, idRef) {
        if (idRef === void 0) { idRef = 'main'; }
        var newPackage = {
            headline: '',
            slugline: '',
            description_text: '',
            type: 'composite',
            version: 0,
            groups: [
                {
                    role: 'grpRole:NEP',
                    refs: [{ idRef: idRef }],
                    id: 'root',
                },
                getGroupFor(null, idRef),
            ],
        };
        newPackage = setDefaults(newPackage, defaults);
        if (!newPackage.task || !newPackage.task.desk) {
            newPackage.task = { desk: desks.getCurrentDeskId() };
        }
        return api.save('archive', newPackage);
    };
    this.addItemsToPackage = function (current, groupId, items) {
        var origGroups = lodash_1.default.cloneDeep(current.groups);
        var targetGroup = lodash_1.default.find(origGroups, function (group) { return group.id.toLowerCase() === groupId; });
        if (!targetGroup) {
            var rootGroup = lodash_1.default.find(origGroups, { id: 'root' });
            rootGroup.refs.push({ idRef: groupId });
            targetGroup = {
                id: groupId,
                refs: [],
                role: 'grpRole:' + groupId,
            };
            origGroups.push(targetGroup);
        }
        lodash_1.default.each(items, function (item) {
            targetGroup.refs.push(self.getReferenceFor(item));
        });
        lodash_1.default.extend(current, { groups: origGroups });
    };
    this.isAdded = function (pkg, item) {
        var added = pkg.groups ?
            pkg.groups.some(function (group) { return group.refs.some(function (ref) { return ref.guid === item._id || ref.residRef === item._id; }); })
            : false;
        var addedToPkg = this.isAddedToPackage(pkg, item);
        return added || addedToPkg;
    };
    this.fetchItem = function (packageItem) {
        var repo = packageItem.location || 'ingest';
        return api(repo).getById(packageItem.residRef)
            .then(function (item) { return item; }, function (response) {
            if (response.status === 404) {
                console.error('Item not found.');
            }
        });
    };
    this.getReferenceFor = function (item) {
        return {
            type: item.type || '',
            headline: item.headline || '',
            residRef: item._id,
            location: 'archive',
            slugline: item.slugline || '',
            renditions: item.renditions || {},
            itemClass: item.type ? 'icls:' + item.type : '',
        };
    };
    function setItemLabel(pkg, item, label) {
        lodash_1.default.forEach(pkg.groups, function (group) {
            var ref = lodash_1.default.find(group.refs, { residRef: item._id });
            if (ref) {
                ref.label = label ? label.qcode : null;
                $rootScope.$broadcast('package:updateGroupRef', { ref: ref, group: group });
            }
        });
    }
    this.setItemLabel = function (item, label) {
        var pkg = authoringWorkspace.getItem();
        if (pkg._autosaved) {
            autosave.get(pkg).then(function (autosavedPkg) {
                setItemLabel(autosavedPkg._autosave, item, label);
            });
        }
        else {
            setItemLabel(pkg, item, label);
        }
    };
    this.isSetItemLabel = function (item, label) {
        var qcode = label ? label.qcode : null;
        var pkg = authoringWorkspace.getItem();
        var isSet = false;
        lodash_1.default.forEach(pkg.groups, function (group) {
            var ref = lodash_1.default.find(group.refs, { guid: item._id });
            if (ref && ref.label === qcode) {
                isSet = true;
            }
        });
        return isSet;
    };
    this.addPackageGroupItem = function (group, item, broadcast) {
        var pkg = authoringWorkspace.getItem();
        var pkgId = pkg._id;
        if (typeof this.packageGroupItems[pkgId] === 'undefined') {
            this.packageGroupItems[pkgId] = [];
        }
        if (lodash_1.default.indexOf(this.packageGroupItems[pkgId], item._id) === -1) {
            this.packageGroupItems[pkgId].unshift(item._id);
        }
        if (typeof broadcast === 'undefined') {
            $rootScope.$broadcast('package:addItems', { items: [item], group: group });
        }
    };
    this.removePackageGroupItem = function (group, item) {
        var pkg = authoringWorkspace.getItem();
        lodash_1.default.remove(this.packageGroupItems[pkg._id], item._id);
    };
    this.isAddedToPackage = function (pkg, item) {
        return pkg ? lodash_1.default.indexOf(this.packageGroupItems[pkg._id], item._id) !== -1 : false;
    };
    function getGroupFor(item, idRef) {
        var refs = [];
        if (item) {
            refs.push({
                headline: item.headline || '',
                residRef: item._id,
                location: 'archive',
                slugline: item.slugline || '',
                renditions: item.renditions || {},
            });
        }
        return {
            refs: refs,
            id: idRef,
            role: 'grpRole:' + idRef,
        };
    }
    function setDefaults(item, defaults) {
        var obj = defaults;
        if (angular.isUndefined(defaults) || !lodash_1.default.isObject(defaults)) {
            obj = {};
        }
        archiveService.addTaskToArticle(obj);
        return lodash_1.default.merge(item, obj);
    }
}
exports.PackagesService = PackagesService;


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1836);
var services_1 = __webpack_require__(1838);
var ctrl = __importStar(__webpack_require__(1840));
var directive = __importStar(__webpack_require__(1843));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.highlights
 * @name superdesk.apps.highlights
 * @packageName superdesk.apps
 * @description Superdesk module that adds highlights functionality to archive
 * items.
 */
exports.default = angular.module('superdesk.apps.highlights', [
    'superdesk.apps.desks',
    'superdesk.apps.packaging',
    'superdesk.core.activity',
    'superdesk.core.api',
    'superdesk.apps.workspace.menu',
])
    .service('highlightsService', services_1.HighlightsService)
    .directive('sdCreateHighlightsButton', directive.CreateHighlightsButton)
    .directive('sdMarkHighlightsDropdown', directive.MarkHighlightsDropdown)
    .directive('sdMultiMarkHighlightsDropdown', directive.MultiMarkHighlightsDropdown)
    .directive('sdPackageHighlightsDropdown', directive.PackageHighlightsDropdown)
    .directive('sdHighlightsInfo', directive.HighlightsInfo)
    .directive('sdSearchHighlights', directive.SearchHighlights)
    .directive('sdHighlightsConfig', function () { return ({ controller: ctrl.HighlightsConfig }); })
    .directive('sdHighlightsConfigModal', directive.HighlightsConfigModal)
    .directive('sdHighlightLabel', directive.HighlightsLabel)
    .config(['superdeskProvider', 'workspaceMenuProvider', function (superdesk, workspaceMenuProvider) {
        superdesk
            .activity('mark.item', {
            label: utils_1.gettext('Mark for highlight'),
            priority: 30,
            icon: 'star',
            dropdown: directive.HighlightsReactDropdown,
            keyboardShortcut: 'ctrl+shift+^',
            templateUrl: 'scripts/apps/highlights/views/mark_highlights_dropdown.html',
            filters: [
                { action: 'list', type: 'archive' },
            ],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).mark_item_for_highlight;
                }],
            group: 'highlights',
        })
            .activity('/settings/highlights', {
            label: utils_1.gettext('Highlights'),
            controller: ctrl.HighlightsSettings,
            templateUrl: 'scripts/apps/highlights/views/settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            priority: -800,
            privileges: { highlights: 1 },
        })
            .activity('/workspace/highlights', {
            label: utils_1.gettext('Highlights View'),
            priority: 100,
            templateUrl: 'scripts/apps/monitoring/views/highlights-view.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
        });
        workspaceMenuProvider.item({
            href: '/workspace/highlights',
            label: utils_1.gettext('Highlights'),
            templateUrl: 'scripts/apps/highlights/views/menu.html',
            order: 400,
            shortcut: 'ctrl+alt+h',
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('highlights', {
            type: 'http',
            backend: { rel: 'highlights' },
        });
        apiProvider.api('markForHighlights', {
            type: 'http',
            backend: { rel: 'marked_for_highlights' },
        });
        apiProvider.api('generate_highlights', {
            type: 'http',
            backend: { rel: 'generate_highlights' },
        });
    }]);


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1837);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./highlights.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./highlights.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.highlights-config-popup .multi-select {\n  margin-top: 10px; }\n  .highlights-config-popup .multi-select li {\n    margin-bottom: 5px; }\n    .highlights-config-popup .multi-select li .text:hover {\n      cursor: pointer; }\n\n.highlights-config-popup .pills-list {\n  margin-top: 15px; }\n  .highlights-config-popup .pills-list h6 {\n    text-transform: none !important; }\n\n.highlights-config-popup .modal-body .char-count {\n  font-size: 11px;\n  font-style: italic; }\n  .highlights-config-popup .modal-body .char-count.error {\n    font-weight: 500;\n    color: #D33C30; }\n\n.highlights-title {\n  display: inline-block;\n  position: relative; }\n  .highlights-title .tooltip-inner {\n    width: 150px;\n    text-align: left; }\n    .highlights-title .tooltip-inner h5 {\n      font-size: 11px;\n      margin: 0 0 8px;\n      color: #a7a7a7; }\n    .highlights-title .tooltip-inner button {\n      position: absolute;\n      right: 7px;\n      color: #656565; }\n    .highlights-title .tooltip-inner li {\n      height: 1%;\n      overflow: hidden;\n      padding-right: 45px; }\n  .highlights-title:hover {\n    cursor: pointer; }\n\n.highlights-list {\n  display: inline-block;\n  vertical-align: middle; }\n\n.highlights-preview-list {\n  background-color: transparent; }\n\n.highlights-list-menu {\n  padding: 5px 0;\n  margin: 6px 0 0 0;\n  background-color: #000 !important; }\n  .highlights-list-menu:before {\n    display: none; }\n  .highlights-list-menu li {\n    position: relative;\n    color: #fff;\n    padding-right: 45px;\n    padding: 5px 75px 5px 10px;\n    max-width: 250px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis; }\n    .highlights-list-menu li .dropdown__menu-label {\n      font-size: 11px;\n      padding-left: 0;\n      color: #a7a7a7; }\n    .highlights-list-menu li .dropdown__menu-close {\n      position: absolute;\n      top: 5px;\n      right: 5px;\n      padding: 0;\n      margin: 0;\n      border: 0;\n      width: auto;\n      opacity: 0.5;\n      filter: \"alpha(opacity=50)\";\n      background-color: transparent; }\n      .highlights-list-menu li .dropdown__menu-close i {\n        margin-right: 0; }\n      .highlights-list-menu li .dropdown__menu-close:hover, .highlights-list-menu li .dropdown__menu-close:focus {\n        background-color: transparent;\n        opacity: 1;\n        filter: \"alpha(opacity=100)\"; }\n    .highlights-list-menu li .btn {\n      position: absolute;\n      width: auto;\n      top: 3px;\n      right: 10px;\n      background-color: rgba(94, 169, 200, 0.6);\n      font-size: 10px;\n      color: #fff;\n      padding: 2px 5px; }\n      .highlights-list-menu li .btn:hover {\n        color: #fff;\n        background-color: #5ea9c8; }\n    .highlights-list-menu li span {\n      color: #fff;\n      margin: 0;\n      padding: 0; }\n\n.highlights-dropdown .dropdown__menu .dropdown__menu-label {\n  text-align: left;\n  line-height: 16px;\n  padding: 0 16px;\n  margin-bottom: 5px; }\n\n.highlights-dropdown .dropdown__menu button {\n  max-width: 250px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n", ""]);

// exports


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HighlightsService_1 = __webpack_require__(1839);
exports.HighlightsService = HighlightsService_1.HighlightsService;


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * Service for highlights with caching.
 */
HighlightsService.$inject = ['api', '$q', '$cacheFactory', 'packages', 'privileges'];
function HighlightsService(api, $q, $cacheFactory, packages, privileges) {
    var service = {};
    var promise = {};
    var cache = $cacheFactory('highlightList');
    /**
     * Get cached value for given key
     *
     * @param {string} key
     * @return {Object}
     */
    service.getSync = function (key) {
        return cache.get(key);
    };
    /**
     * Fetches and caches highlights, or returns from the cache.
     */
    service.get = function (desk) {
        var DEFAULT_CACHE_KEY = '_nodesk';
        var key = desk || DEFAULT_CACHE_KEY;
        var value = service.getSync(key);
        if (value) {
            return $q.when(value);
        }
        else if (promise[key]) {
            return promise[key];
        }
        var criteria = {};
        if (desk) {
            criteria = { where: { $or: [
                        { desks: desk },
                        { desks: { $size: 0 } },
                    ],
                },
            };
        }
        promise[key] = api('highlights').query(criteria)
            .then(function (result) {
            result._items = lodash_1.default.sortBy(result._items, function (i) { return i.name.toLowerCase(); });
            setLabel(result._items);
            cache.put(key, result);
            promise[key] = null;
            return $q.when(result);
        });
        return promise[key];
    };
    function setLabel(objItems) {
        lodash_1.default.forEach(objItems, function (item) {
            item.label = item.desks.length ? item.name : item.name + ' ' + utils_1.gettext('(Global)');
        });
    }
    /**
     * Clear user cache
     */
    service.clearCache = function () {
        cache.removeAll();
        promise = {};
    };
    /**
     * Saves highlight configuration
     */
    service.saveConfig = function (config, configEdit) {
        return api.highlights.save(config, configEdit).then(function (item) {
            service.clearCache();
            return item;
        });
    };
    /**
     * Removes highlight configuration
     */
    service.removeConfig = function (config) {
        return api.highlights.remove(config).then(function () {
            service.clearCache();
        });
    };
    /**
     * Mark an item for a highlight
     */
    service.markItem = function (highlight, markedItem) {
        return api.save('marked_for_highlights', { highlights: highlight, marked_item: markedItem._id });
    };
    /**
     * Create empty highlight package
     */
    service.createEmptyHighlight = function (highlight) {
        var pkgDefaults = {
            headline: highlight.name,
            highlight: highlight._id,
        };
        var group = null;
        if (highlight.groups && highlight.groups.length > 0) {
            group = highlight.groups[0];
        }
        if (highlight.task) {
            pkgDefaults.task = highlight.task;
        }
        return packages.createEmptyPackage(pkgDefaults, group);
    };
    /**
     * Get single highlight by its id
     *
     * @param {string} _id
     * @return {Promise}
     */
    service.find = function (_id) {
        return api.find('highlights', _id);
    };
    service.hasMarkItemPrivilege = function () {
        return !!privileges.privileges.mark_for_highlights;
    };
    /**
     * Checks if the hourDifference falls in the
     * defined range in highlight
     *
     * @param {string} highlight id
     * @param {int} hourDifference
     * @return {bool}
     */
    service.isInDateRange = function (highlight, hourDifference) {
        if (highlight) {
            if (highlight.auto_insert === 'now/d') {
                return hourDifference <= 24;
            }
            else if (highlight.auto_insert === 'now/w') {
                return hourDifference <= 168; // 24*7
            }
            else if (lodash_1.default.startsWith(highlight.auto_insert, 'now-')) {
                var trimmedValue = lodash_1.default.trimStart(highlight.auto_insert, 'now-');
                trimmedValue = lodash_1.default.trimEnd(trimmedValue, 'h');
                return hourDifference <= lodash_1.default.parseInt(trimmedValue);
            }
        }
        // If non matches then return false
        return false;
    };
    return service;
}
exports.HighlightsService = HighlightsService;


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HighlightsSettings_1 = __webpack_require__(1841);
exports.HighlightsSettings = HighlightsSettings_1.HighlightsSettings;
var HighlightsConfig_1 = __webpack_require__(1842);
exports.HighlightsConfig = HighlightsConfig_1.HighlightsConfig;


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
HighlightsSettings.$inject = ['$scope', 'api', 'desks'];
function HighlightsSettings($scope, api, desks) {
    desks.initialize().then(function () {
        $scope.desks = desks.deskLookup;
    });
    api.query('content_templates', { where: { template_type: 'highlights' } }).then(function (result) {
        $scope.templates = result._items || [];
    });
    $scope.hours = lodash_1.default.range(1, 25);
    $scope.auto = { day: 'now/d', week: 'now/w' };
}
exports.HighlightsSettings = HighlightsSettings;


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
HighlightsConfig.$inject = ['$scope', 'highlightsService', 'desks', 'api', 'notify', 'modal'];
function HighlightsConfig($scope, highlightsService, desks, api, notify, modal) {
    highlightsService.get().then(function (items) {
        items._items = lodash_1.default.sortBy(items._items, function (i) { return i.name.toLowerCase(); });
        $scope.configurations = items;
    });
    $scope.configEdit = {};
    $scope.modalActive = false;
    var limits = {
        group: 45,
        highlight: 40,
    };
    $scope.limits = limits;
    var _config;
    $scope.edit = function (config) {
        clearErrorMessages();
        $scope.modalActive = true;
        $scope.configEdit = lodash_1.default.create(config);
        $scope.assignedDesks = deskList(config.desks);
        _config = config;
        if (!$scope.configEdit.auto_insert) {
            $scope.configEdit.auto_insert = 'now/d'; // today
        }
    };
    $scope.cancel = function () {
        $scope.modalActive = false;
    };
    $scope.save = function () {
        var _new = !_config._id;
        $scope.configEdit.desks = assignedDesks();
        $scope.configEdit.groups = ['main'];
        highlightsService.saveConfig(_config, $scope.configEdit).then(function (item) {
            $scope.message = null;
            if (_new) {
                $scope.configurations._items.unshift(item);
            }
            $scope.modalActive = false;
            $scope.configurations._items = lodash_1.default.sortBy($scope.configurations._items, function (i) { return i.name.toLowerCase(); });
        }, function (response) {
            errorMessage(response);
        });
        function errorMessage(response) {
            if (response.data && response.data._issues && response.data._issues.name
                && response.data._issues.name.unique) {
                $scope._errorUniqueness = true;
            }
            else {
                $scope.message = utils_1.gettext('There was a problem while saving highlights configuration');
            }
        }
    };
    $scope.remove = function (config) {
        modal.confirm(utils_1.gettext('Are you sure you want to delete configuration?'))
            .then(function () {
            highlightsService.removeConfig(config).then(function () {
                lodash_1.default.remove($scope.configurations._items, config);
                notify.success(utils_1.gettext('Configuration deleted.'), 3000);
            });
        });
    };
    $scope.getHourVal = function (hour) {
        return 'now-' + hour + 'h';
    };
    function deskList(arr) {
        return lodash_1.default.map($scope.desks, function (d) { return ({
            _id: d._id,
            name: d.name,
            included: isIncluded(arr, d._id),
        }); });
    }
    function isIncluded(arr, id) {
        return lodash_1.default.findIndex(arr, function (c) { return c === id; }) > -1;
    }
    function assignedDesks() {
        return lodash_1.default.map(lodash_1.default.filter($scope.assignedDesks, { included: true }), function (desk) { return desk._id; });
    }
    $scope.handleEdit = function ($event) {
        clearErrorMessages();
        if (!lodash_1.default.isNil($scope.configEdit.name)) {
            $scope._errorLimits = $scope.configEdit.name.length > $scope.limits.highlight ? true : null;
        }
    };
    function clearErrorMessages() {
        if ($scope._errorUniqueness || $scope._errorLimits) {
            $scope._errorUniqueness = null;
            $scope._errorLimits = null;
        }
        $scope.message = null;
    }
}
exports.HighlightsConfig = HighlightsConfig;


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MarkHighlightsDropdown_1 = __webpack_require__(1844);
exports.MarkHighlightsDropdown = MarkHighlightsDropdown_1.MarkHighlightsDropdown;
var MultiMarkHighlightsDropdown_1 = __webpack_require__(1845);
exports.MultiMarkHighlightsDropdown = MultiMarkHighlightsDropdown_1.MultiMarkHighlightsDropdown;
var HighlightsInfo_1 = __webpack_require__(1846);
exports.HighlightsInfo = HighlightsInfo_1.HighlightsInfo;
var SearchHighlights_1 = __webpack_require__(1847);
exports.SearchHighlights = SearchHighlights_1.SearchHighlights;
var PackageHighlightsDropdown_1 = __webpack_require__(1848);
exports.PackageHighlightsDropdown = PackageHighlightsDropdown_1.PackageHighlightsDropdown;
var HighlightsLabel_1 = __webpack_require__(1849);
exports.HighlightsLabel = HighlightsLabel_1.HighlightsLabel;
var CreateHighlightsButton_1 = __webpack_require__(1850);
exports.CreateHighlightsButton = CreateHighlightsButton_1.CreateHighlightsButton;
var HighlightsConfigModal_1 = __webpack_require__(1851);
exports.HighlightsConfigModal = HighlightsConfigModal_1.HighlightsConfigModal;
var HighlightsReactDropdown_1 = __webpack_require__(1852);
exports.HighlightsReactDropdown = HighlightsReactDropdown_1.HighlightsReactDropdown;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MarkHighlightsDropdown.$inject = ['desks', 'highlightsService', '$timeout'];
function MarkHighlightsDropdown(desks, highlightsService, $timeout) {
    return {
        templateUrl: 'scripts/apps/highlights/views/mark_highlights_dropdown_directive.html',
        link: function (scope) {
            scope.markItem = function (highlight) {
                scope.item.multiSelect = false;
                highlightsService.markItem(highlight._id, scope.item);
            };
            scope.isMarked = function (highlight) {
                return scope.item && scope.item.highlights && scope.item.highlights.indexOf(highlight._id) >= 0;
            };
            // If the user has no desks assigned - this user should not view ANY highlights (including global)
            if (desks.userDesks.length > 0) {
                highlightsService.get(desks.getCurrentDeskId()).then(function (result) {
                    scope.highlights = result._items;
                    $timeout(function () {
                        var highlightDropdown = angular.element('.more-activity-menu.open .dropdown--noarrow');
                        var buttons = highlightDropdown.find('button:not([disabled])');
                        if (buttons.length > 0) {
                            buttons[0].focus();
                        }
                    });
                });
            }
        },
    };
}
exports.MarkHighlightsDropdown = MarkHighlightsDropdown;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
MultiMarkHighlightsDropdown.$inject = ['desks', 'highlightsService', 'multi'];
function MultiMarkHighlightsDropdown(desks, highlightsService, multi) {
    return {
        templateUrl: 'scripts/apps/highlights/views/mark_highlights_dropdown_directive.html',
        link: function (scope) {
            scope.markItem = function (highlight) {
                angular.forEach(multi.getItems(), function (item) {
                    item.multiSelect = true;
                    if (!lodash_1.default.includes(item.highlights, highlight._id)) {
                        highlightsService.markItem(highlight._id, item);
                    }
                });
                multi.reset();
            };
            scope.isMarked = function (highlight) {
                var result = lodash_1.default.find(multi.getItems(), function (item) { return !item.highlights || item.highlights.indexOf(highlight._id) === -1; });
                return !result;
            };
            // If the user has no desks assigned - this user should not view ANY highlights (including global)
            if (desks.userDesks.length > 0) {
                highlightsService.get(desks.getCurrentDeskId()).then(function (result) {
                    scope.highlights = [];
                    result._items.forEach(function (item) {
                        // Multi mark highlights should only show global highlights
                        if (!item.desks.length) {
                            scope.highlights.push(item);
                        }
                    });
                });
            }
        },
    };
}
exports.MultiMarkHighlightsDropdown = MultiMarkHighlightsDropdown;


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
HighlightsInfo.$inject = [];
function HighlightsInfo() {
    return {
        scope: {
            item: '=item',
        },
        templateUrl: 'scripts/apps/highlights/views/highlights_info_directive.html',
    };
}
exports.HighlightsInfo = HighlightsInfo;


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
SearchHighlights.$inject = ['highlightsService'];
function SearchHighlights(highlightsService) {
    return {
        scope: { highlight_id: '=highlight' },
        templateUrl: 'scripts/apps/highlights/views/search_highlights_dropdown_directive.html',
        link: function (scope) {
            scope.selectHighlight = function (highlight) {
                scope.highlight_id = null;
                if (highlight) {
                    scope.highlight_id = highlight._id;
                }
            };
            scope.hasHighlights = function () {
                return lodash_1.default.size(scope.highlights) > 0;
            };
            highlightsService.get().then(function (result) {
                scope.highlights = result._items;
            });
        },
    };
}
exports.SearchHighlights = SearchHighlights;


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackageHighlightsDropdown.$inject = ['desks', 'highlightsService', '$location', '$route', 'lodash'];
function PackageHighlightsDropdown(desks, highlightsService, $location, $route, _) {
    return {
        scope: true,
        templateUrl: 'scripts/apps/highlights/views/package_highlights_dropdown_directive.html',
        link: function (scope) {
            scope.$watch(function () { return desks.active; }, function (active) {
                scope.selected = active;
                // If the user has no desks assigned - this user should not view ANY highlights (including global)
                if (!_.isEmpty(desks.userDesks)) {
                    highlightsService.get(desks.getCurrentDeskId()).then(function (result) {
                        scope.highlights = _.sortBy(result._items, function (i) { return i.name.toLowerCase(); });
                        scope.hasHighlights = _.size(scope.highlights) > 0;
                    });
                }
            });
            scope.listHighlight = function (highlight) {
                $location.url('workspace/highlights?highlight=' + highlight._id);
                $route.reload();
            };
        },
    };
}
exports.PackageHighlightsDropdown = PackageHighlightsDropdown;


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
HighlightsLabel.$inject = ['desks', 'highlightsService'];
function HighlightsLabel(desks, highlightsService) {
    return {
        scope: { highlight_id: '=highlight', totalItems: '=total' },
        template: '<span translate>{{ highlightItem.label }} ({{ totalItems }} items)</span>',
        link: function (scope) {
            highlightsService.get(desks.getCurrentDeskId()).then(function (result) {
                scope.highlightItem = lodash_1.default.find(result._items, { _id: scope.highlight_id });
            });
        },
    };
}
exports.HighlightsLabel = HighlightsLabel;


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
CreateHighlightsButton.$inject = ['highlightsService', 'authoringWorkspace', 'privileges'];
function CreateHighlightsButton(highlightsService, authoringWorkspace, privileges) {
    return {
        scope: { highlight_id: '=highlight' },
        templateUrl: 'scripts/apps/highlights/views/create_highlights_button_directive.html',
        link: function (scope) {
            /**
             * Create new highlight package for current highlight and start editing it
             */
            scope.createHighlight = function () {
                highlightsService.find(scope.highlight_id)
                    .then(highlightsService.createEmptyHighlight)
                    .then(authoringWorkspace.edit);
            };
            scope.hasMarkItemPrivilege = privileges.privileges.mark_for_highlights;
        },
    };
}
exports.CreateHighlightsButton = CreateHighlightsButton;


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function HighlightsConfigModal() {
    return {
        require: '^sdHighlightsConfig',
        templateUrl: 'scripts/apps/highlights/views/highlights_config_modal.html',
    };
}
exports.HighlightsConfigModal = HighlightsConfigModal;


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var HighlightBtn_1 = __importDefault(__webpack_require__(1853));
/**
 * @ngdoc directive
 * @module superdesk.apps.highlights
 * @name HighlightsReactDropdown
 *
 * @requires React
 * @requires item
 * @requires className
 * @requires highlightsService
 * @requires desks
 * @requires noHighlightsLabel
 *
 * @param {Object} [highlights] collection of highlights
 *
 * @description Creates dropdown react element with list of available highlights
 */
HighlightsReactDropdown.$inject = ['item', 'className', 'highlightsService', 'desks', 'noHighlightsLabel'];
function HighlightsReactDropdown(item, className, highlightsService, desks, noHighlightsLabel) {
    var highlights = highlightsService.getSync(desks.getCurrentDeskId()) || { _items: [] };
    var noHighlights = react_1.default.createElement("li", null,
        react_1.default.createElement("button", { disabled: true }, noHighlightsLabel));
    /*
     * Creates list with highlights
     * @return {React} List element
     */
    return (react_1.default.createElement("ul", { className: className }, highlights._items.length ? highlights._items.map(function (h) {
        return react_1.default.createElement("li", { key: "highlight-" + h._id },
            react_1.default.createElement(HighlightBtn_1.default, { item: item, highlight: h, service: highlightsService }));
    }) : noHighlights));
}
exports.HighlightsReactDropdown = HighlightsReactDropdown;


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/*
 * Creates specific highlight button in list
 * @return {React} Language button
 */
var HighlightBtn = /** @class */ (function (_super) {
    __extends(HighlightBtn, _super);
    function HighlightBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.markHighlight = _this.markHighlight.bind(_this);
        return _this;
    }
    HighlightBtn.prototype.markHighlight = function (event) {
        event.stopPropagation();
        this.props.service.markItem(this.props.highlight._id, this.props.item);
    };
    HighlightBtn.prototype.render = function () {
        var item = this.props.item;
        var highlight = this.props.highlight;
        var isMarked = item.highlights && item.highlights.indexOf(highlight._id) >= 0;
        return react_1.default.createElement('button', { disabled: isMarked, onClick: this.markHighlight }, react_1.default.createElement('i', { className: 'icon-star' }), highlight.label);
    };
    return HighlightBtn;
}(react_1.default.Component));
exports.default = HighlightBtn;
HighlightBtn.propTypes = {
    highlight: prop_types_1.default.object,
    item: prop_types_1.default.object,
    service: prop_types_1.default.any,
};


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var directive = __importStar(__webpack_require__(1855));
var svc = __importStar(__webpack_require__(1858));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.translations
 * @name superdesk.apps.translations
 * @packageName superdesk.apps
 * @description Superdesk authoring application module.
 */
angular.module('superdesk.apps.translations', [
    'superdesk.core.api',
])
    .service('TranslationService', svc.TranslationService)
    .directive('sdTranslationDropdown', directive.TranslationDropdown)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('translate', {
            label: utils_1.gettext('Translate'),
            icon: 'globe',
            dropdown: directive.TranslationReactDropdown,
            keyboardShortcut: 'ctrl+t',
            templateUrl: 'scripts/apps/translations/views/TranslationDropdownTemplate.html',
            filters: [
                { action: 'list', type: 'archive' },
            ],
            additionalCondition: ['TranslationService', 'item', function (TranslationService, item) {
                    return TranslationService.checkAvailability(item);
                }],
        });
    }]);


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TranslationReactDropdown_1 = __webpack_require__(1856);
exports.TranslationReactDropdown = TranslationReactDropdown_1.TranslationReactDropdown;
var TranslationDropdown_1 = __webpack_require__(1857);
exports.TranslationDropdown = TranslationDropdown_1.TranslationDropdown;


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-multi-comp */
var react_1 = __importDefault(__webpack_require__(0));
/**
 * @ngdoc directive
 * @module superdesk.apps.translations
 * @name TranslationReactDropdown
 *
 * @requires React
 * @requires item
 * @requires className
 * @requires TranslationService
 * @requires noLanguagesLabel
 *
 * @param {Object} [langugages] collection of languages
 *
 * @description Creates dropdown react element with list of available languages
 */
TranslationReactDropdown.$inject = ['item', 'className', 'TranslationService', 'noLanguagesLabel'];
function TranslationReactDropdown(item, className, TranslationService, noLanguagesLabel) {
    var languages = TranslationService.get() || { _items: [] };
    /*
     * Creates specific language button in list
     * @return {React} Language button
     */
    var TranslateBtn = /** @class */ (function (_super) {
        __extends(TranslateBtn, _super);
        function TranslateBtn(props) {
            var _this = _super.call(this, props) || this;
            _this.markTranslate = _this.markTranslate.bind(_this);
            return _this;
        }
        TranslateBtn.prototype.markTranslate = function (event) {
            event.stopPropagation();
            TranslationService.set(this.props.item, this.props.language);
        };
        TranslateBtn.prototype.render = function () {
            var _item = this.props.item;
            var language = this.props.language;
            var isCurrentLang = _item.language === language.language;
            if (!language.destination) {
                return false;
            }
            return react_1.default.createElement('button', {
                disabled: isCurrentLang,
                onClick: this.markTranslate,
            }, language.label);
        };
        return TranslateBtn;
    }(react_1.default.Component));
    /*
     * Creates list element for specific language
     * @return {React} Single list element
     */
    var createTranslateItem = function (language) {
        return react_1.default.createElement('li', { key: 'language-' + language._id }, react_1.default.createElement(TranslateBtn, { item: item, language: language }));
    };
    /*
     * If there are no languages, print none-langugage message
     * @return {React} List element
     */
    var noLanguage = function () {
        return react_1.default.createElement('li', {}, react_1.default.createElement('button', { disabled: true }, noLanguagesLabel));
    };
    /*
     * Creates list with languages
     * @return {React} List element
     */
    return react_1.default.createElement('ul', { className: className }, languages._items.length ? languages._items.map(createTranslateItem) : react_1.default.createElement(noLanguage));
}
exports.TranslationReactDropdown = TranslationReactDropdown;


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.translations
 * @name sdTranslationDropdown
 *
 * @requires TranslationService
 *
 * @param {Object} [langugages] collection of languages
 *
 * @description Creates dropdown element with list of available languages
 */
TranslationDropdown.$inject = ['TranslationService'];
function TranslationDropdown(TranslationService) {
    return {
        templateUrl: 'scripts/apps/translations/views/TranslationDropdown.html',
        link: function (scope) {
            scope.languages = lodash_1.default.filter(TranslationService.languages._items, { destination: true });
            /*
             * Check if item language and button language are same
             * @param {Object} Language
             * @return {Boolean}
             */
            scope.isCurrentLanguage = function (language) {
                return scope.item && scope.item.language === language.language;
            };
            /*
             * Function for translating item
             * @param {Object} New language
             */
            scope.translateItem = function (language) {
                TranslationService.set(scope.item, language);
            };
        },
    };
}
exports.TranslationDropdown = TranslationDropdown;


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TranslationService_1 = __webpack_require__(1859);
exports.TranslationService = TranslationService_1.TranslationService;


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.translations
 * @name TranslationService
 *
 * @requires api
 * @requires notify
 * @requires authoringWorkspace
 * @requires https://docs.angularjs.org/api/ng/service/$rootScope $rootScope
 *
 * @description Provides set of methods to translate items to different languages
 */
TranslationService.$inject = ['api', '$rootScope', 'notify', 'authoringWorkspace', 'desks', 'search'];
function TranslationService(api, $rootScope, notify, authoringWorkspace, desks, search) {
    var service = {};
    /**
     * @ngdoc method
     * @name TranslationService#fetch
     * @public
     * @returns {Object} Languages
     * @description Fetch languages from database
     */
    service.fetch = function () {
        return api.query('languages');
    };
    /**
     * @ngdoc method
     * @name TranslationService#get
     * @public
     * @description Return list of langugages
     * @return {Object} list of items
     */
    service.get = function () {
        return service.languages;
    };
    /**
     * @ngdoc method
     * @name TranslationService#get
     * @public
     * @description Create copy of item with new language set
     * @param {Object} item item to be translated
     * @param {Object} language translate language
     */
    service.set = function (item, language) {
        var params = {
            guid: item.guid,
            language: language.language,
            desk: desks.getCurrentDeskId(),
        };
        api.save('translate', params).then(function (_item) {
            authoringWorkspace.open(_item);
            $rootScope.$broadcast('item:translate');
            notify.success(utils_1.gettext('Item Translated'));
        });
    };
    service.translationsEnabled = function () {
        return typeof service.languages === 'object'
            && Array.isArray(service.languages._items)
            && service.languages._items.length > 0;
    };
    service.getTranslations = function (item) {
        if (item.translation_id == null) {
            return Promise.reject('translation_id is not present');
        }
        var query = search.query({});
        query.filter({ term: { translation_id: item.translation_id } });
        var criteria = query.getCriteria(true);
        criteria.repo = 'archive,published';
        return api.query('search', criteria);
    };
    /**
     * @ngdoc method
     * @name TranslationService#checkAvailability
     * @public
     * @description Check if item is available for translating
     * @return {boolean}
     */
    service.checkAvailability = function (item) {
        return service.translationsEnabled() ?
            lodash_1.default.find(service.languages._items, function (language) { return language.source && language.language === item.language; })
            : false;
    };
    // Fetch languages from database on service initialization
    service.fetch().then(function (languages) {
        service.languages = languages;
    });
    return service;
}
exports.TranslationService = TranslationService;


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014, 2015 Sourcefabric z.ú. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1861);
var services_1 = __webpack_require__(1863);
var directives_1 = __webpack_require__(1865);
var ctrl = __importStar(__webpack_require__(573));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
// XXX: For some reason, loading the superdesk.apps.content_filters module in
// tests fails to load due to "Unknown provider: superdeskProvider" error.
// This happens if any taste case uses the inject() function.
// Seems like something needs to be fixed in config, but for now loading
// superdesk.apps.publish module does the trick (FWIW, it's the module that
// contained the original code for the content_filters module).
/**
 * @ngdoc module
 * @module superdesk.apps.content_filters
 * @name superdesk.apps.content_filters
 * @packageName superdesk.apps
 * @description Superdesk package containing content filters.
 */
angular.module('superdesk.apps.content_filters', ['superdesk.apps.publish'])
    .config(['superdeskProvider', function (superdesk) {
        var templateUrl = 'scripts/apps/content-filters/' +
            'views/settings.html';
        superdesk.activity('/settings/content-filters', {
            label: utils_1.gettext('Content Filters'),
            controller: ctrl.ContentFiltersConfigController,
            controllerAs: 'ctrl',
            templateUrl: templateUrl,
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_FLOW,
            priority: -800,
            privileges: { dictionaries: 1 },
        });
    }])
    .service('contentFilters', services_1.ContentFiltersService)
    .controller('ContentFiltersConfigCtrl', ctrl.ContentFiltersConfigController)
    .controller('FilterConditionsCtrl', ctrl.FilterConditionsController)
    .controller('ManageContentFiltersCtrl', ctrl.ManageContentFiltersController)
    .controller('ProductionTestCtrl', ctrl.ProductionTestController)
    .controller('FilterSearchCtrl', ctrl.FilterSearchController)
    .directive('sdManageFiltersTab', directives_1.ManageFiltersTab);


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1862);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./content-filters.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./content-filters.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.padded--sides10 {\n  padding: 0 10px; }\n\n.panel-search {\n  padding: 3rem 2rem 0rem;\n  border-radius: 4px;\n  background-color: #fff;\n  min-width: 260px; }\n\n.panel-search-result .column-width {\n  width: 50%; }\n\n.wide {\n  max-width: 960px; }\n\ndiv {\n  -webkit-column-rule: 4px outset #ff00ff;\n  /* Chrome, Safari, Opera */\n  -moz-column-rule: 4px outset #ff00ff;\n  /* Firefox */\n  column-rule: 4px outset #ff00ff; }\n\n.filter-result-modal {\n  position: absolute; }\n  .filter-result-modal .content .active {\n    background-color: #eff7fa !important;\n    border-right: 2px solid rgba(94, 169, 200, 0.75) !important; }\n    .filter-result-modal .content .active:hover .item-functions {\n      background-color: #eff7fa; }\n      .filter-result-modal .content .active:hover .item-functions .item-field:hover {\n        background-color: #d6e8ef; }\n      .filter-result-modal .content .active:hover .item-functions .item-field.disabled:hover {\n        background-color: #d6e8ef; }\n  .filter-result-modal .filter-result-body {\n    flex: 1 1 auto !important; }\n\n.filter-condition-modal .modal-body {\n  overflow-y: inherit !important; }\n\n.content-filter-modal .content .field {\n  margin-bottom: 10px; }\n  .content-filter-modal .content .field textarea {\n    height: 22px; }\n\n.content-filter-modal .modal__body .filter-tags {\n  margin-bottom: 10px;\n  overflow: hidden;\n  padding: 12px;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.12);\n  box-sizing: border-box; }\n\n.destination-box {\n  margin: 0 0 12px 0;\n  padding: 12px 12px 0;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1), 0 1px 4px 0 rgba(0, 0, 0, 0.12);\n  box-sizing: border-box; }\n\n.subscriber-modal {\n  position: absolute; }\n  .subscriber-modal .content .field {\n    margin-bottom: 10px; }\n    .subscriber-modal .content .field textarea {\n      height: 22px; }\n  .subscriber-modal .add {\n    margin-top: -3px;\n    position: absolute;\n    padding: 0;\n    margin-left: 20px;\n    height: 22px;\n    width: 22px;\n    border-radius: 50%;\n    line-height: 20px; }\n    .subscriber-modal .add i {\n      margin-left: 2px; }\n\ntd .sd-page__content {\n  padding: 0; }\n", ""]);

// exports


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentFiltersService_1 = __webpack_require__(1864);
exports.ContentFiltersService = ContentFiltersService_1.ContentFiltersService;


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @name contentFilters
 * @module superdesk.apps.content_filters
 * @ngdoc service
 * @description
 *   This service implements a convenience layer on top of the server API,
 *   providing higher-level methods for fetching and modifying all content
 *   related to content filters on the server.
 */
ContentFiltersService.$inject = ['api', '$filter'];
function ContentFiltersService(api, $filter) {
    this.productionTestFilter = function (filter) {
        return filter;
    };
    this.getFilterConditionParameters = function () {
        return api.query('filter_conditions/parameters')
            .then(angular.bind(this, function (params) { return params._items; }));
    };
    this.saveFilterCondition = function (orig, diff) {
        return api.save('filter_conditions', orig, diff);
    };
    this.remove = function (item) {
        return api.remove(item);
    };
    this.getAllFilterConditions = function () { return api.getAll('filter_conditions'); };
    this.getFilterSearchResults = function (inputParams) {
        // call api to get search results
        return api.query('subscribers', { filter_condition: inputParams })
            .then(angular.bind(this, function (resultSet) { return resultSet._items; }));
    };
    this.getAllContentFilters = function () { return api.getAll('content_filters'); };
    this.saveContentFilter = function (orig, diff) {
        return api.save('content_filters', orig, diff);
    };
    this.testContentFilter = function (diff) {
        return api.save('content_filter_tests', {}, diff);
    };
    this.getGlobalContentFilters = function () {
        return api.query('content_filters', { is_global: true })
            .then(function (response) { return $filter('sortByName')(response._items); });
    };
}
exports.ContentFiltersService = ContentFiltersService;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ManageFiltersTab_1 = __webpack_require__(1866);
exports.ManageFiltersTab = ManageFiltersTab_1.ManageFiltersTab;


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(573);
/**
 * @ngdoc directive
 * @module superdesk.apps.content_filters
 * @name sdManageFiltersTab
 * @description
 *   A directive that simply loads the view for managing content filters and
 *   connects it with its controller (ManageContentFiltersCtrl).
 */
function ManageFiltersTab() {
    return {
        templateUrl: 'scripts/apps/content-filters/views/manage-filters.html',
        controller: controllers_1.ManageContentFiltersController,
    };
}
exports.ManageFiltersTab = ManageFiltersTab;


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc controller
 * @module superdesk.apps.content_filters
 * @name ContentFiltersConfigCtrl
 * @description Main controller for the Content Filters page under the system
 * settings section.
 */
ContentFiltersConfigController.$inject = [];
function ContentFiltersConfigController() {
    var self = this;
    self.TEMPLATES_DIR = 'scripts/apps/content-filters/views';
    self.activeTab = 'filters';
    /**
    * Sets the active tab name to the given value.
    *
    * @method changeTab
    * @param {string} newTabName - name of the new active tab
    */
    self.changeTab = function (newTabName) {
        self.activeTab = newTabName;
    };
}
exports.ContentFiltersConfigController = ContentFiltersConfigController;


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var getLabelForFieldId_1 = __webpack_require__(62);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.content_filters
 * @name FilterConditionsCtrl
 * @requires contentFilters
 * @requires notify
 * @requires modal
 * @requires filter
 * @description Controller for the Filter Conditions tab, found on the Content Filters
 * settings page.
 */
FilterConditionsController.$inject = ['$scope', 'contentFilters', 'notify', 'modal', '$filter', 'content'];
function FilterConditionsController($scope, contentFilters, notify, modal, $filter, content) {
    getLabelForFieldId_1.getLabelNameResolver().then(function (getLabelForFieldId) {
        $scope.filterConditions = null;
        $scope.filterCondition = null;
        $scope.origFilterCondition = null;
        $scope.filterConditionParameters = null;
        $scope.operatorLookup = {};
        $scope.valueLookup = {};
        $scope.valueFieldLookup = {};
        $scope.loadedFilters = false;
        $scope.edit = function (fc) {
            $scope.origFilterCondition = fc || {};
            $scope.filterCondition = lodash_1.default.create($scope.origFilterCondition);
            $scope.filterCondition.values = [];
            if ($scope.isListValue()) {
                var values = $scope.filterCondition.value.split(',');
                var allValues = $scope.valueLookup[$scope.filterCondition.field];
                var valueField = $scope.valueFieldLookup[$scope.filterCondition.field];
                lodash_1.default.each(values, function (value) {
                    var v = lodash_1.default.find(allValues, function (val) { return val[valueField].toString() === value; });
                    $scope.filterCondition.values.push(v);
                });
            }
        };
        $scope.isListValue = function () {
            return lodash_1.default.includes(['in', 'nin'], $scope.filterCondition.operator)
                && $scope.valueLookup[$scope.filterCondition.field];
        };
        /**
         * @ngdoc method
         * @name FilterConditionsCtrl#isComparisonValue
         * @public
         * @description Checks if filter condition operator is one of the comparison operators
         * @returns {Boolean}
         */
        $scope.isComparisonValue = function () {
            return lodash_1.default.includes(['eq', 'ne', 'lt', 'lte', 'gt', 'gte'], $scope.filterCondition.operator)
                && $scope.valueLookup[$scope.filterCondition.field];
        };
        /**
         * @description label returns the display name for a key.
         */
        $scope.label = function (id) { return getLabelForFieldId(id); };
        $scope.cancel = function () {
            $scope.origFilterCondition = null;
            $scope.filterCondition = null;
        };
        $scope.save = function () {
            $scope.filterCondition.value = getFilterValue();
            delete $scope.filterCondition.values;
            contentFilters.saveFilterCondition($scope.origFilterCondition, $scope.filterCondition)
                .then(function () {
                notify.success(utils_1.gettext('Filter condition saved.'));
                $scope.cancel();
            }, function (response) {
                if (angular.isDefined(response.data._issues)) {
                    if (response.data._issues.name && response.data._issues.name.unique) {
                        notify.error(utils_1.gettext('Error: Name needs to be unique'));
                    }
                    else {
                        notify.error(utils_1.gettext('Error: ' + JSON.stringify(response.data._issues)));
                    }
                }
                else if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('Error: Failed to save filter condition.'));
                }
            })
                .then(fetchFilterConditions);
        };
        $scope.remove = function (filterCondition) {
            modal.confirm(utils_1.gettext('Are you sure you want to delete filter condition?'))
                .then(function () { return contentFilters.remove(filterCondition); })
                .then(function (result) {
                lodash_1.default.remove($scope.filterConditions, filterCondition);
            }, function (response) {
                if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('There was an error. Filter condition cannot be deleted.'));
                }
            });
        };
        var getFilterValue = function () {
            if ($scope.isListValue()) {
                var values = [];
                lodash_1.default.each($scope.filterCondition.values, function (value) {
                    values.push(value[$scope.valueFieldLookup[$scope.filterCondition.field]]);
                });
                return values.join();
            }
            return $scope.filterCondition.value;
        };
        $scope.getFilterConditionSummary = function (filterCondition) {
            var labels = [];
            var values = filterCondition.value.split(',');
            lodash_1.default.each(values, function (value) {
                if ($scope.valueLookup[filterCondition.field]) {
                    var v = lodash_1.default.find($scope.valueLookup[filterCondition.field], function (val) { return val[$scope.valueFieldLookup[filterCondition.field]].toString() === value; });
                    labels.push(v.name);
                }
            });
            var conditionValue = labels.length > 0 ? labels.join(', ') : filterCondition.value;
            var itemLabel = $scope.label(filterCondition.field);
            return '(' + itemLabel + ' ' + filterCondition.operator + ' ' + conditionValue + ')';
        };
        var fetchFilterConditions = function () {
            contentFilters.getAllFilterConditions().then(function (_filterConditions) {
                $scope.filterConditions = $filter('sortByName')(_filterConditions);
            });
            contentFilters.getFilterConditionParameters().then(function (params) {
                $scope.filterConditionParameters = params;
                lodash_1.default.each(params, function (param) {
                    $scope.operatorLookup[param.field] = param.operators;
                    $scope.valueLookup[param.field] = param.values;
                    $scope.valueFieldLookup[param.field] = param.value_field;
                });
                $scope.loadedFilters = true;
            });
        };
        /**
         * Triggered when the value of Field property changes and clears the existing values from the condition.
         */
        $scope.clearConditionValues = function () {
            if ($scope.filterCondition.value) {
                $scope.filterCondition.value = null;
            }
            if ($scope.filterCondition.values && $scope.filterCondition.values.length > 0) {
                $scope.filterCondition.values.length = 0;
            }
        };
        fetchFilterConditions();
    });
}
exports.FilterConditionsController = FilterConditionsController;


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var getLabelForFieldId_1 = __webpack_require__(62);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.content_filters
 * @name ManageContentFiltersCtrl
 * @description
 *   Controller for the Filters tab, found on the Content Filters settings
 *   page.
 */
ManageContentFiltersController.$inject = ['$scope', 'contentFilters', 'notify', 'modal', '$filter'];
function ManageContentFiltersController($scope, contentFilters, notify, modal, $filter) {
    getLabelForFieldId_1.getLabelNameResolver().then(function (getLabelForFieldId) {
        $scope.filterConditions = null;
        $scope.contentFilters = null;
        $scope.contentFilter = null;
        $scope.origContentFilter = null;
        $scope.preview = null;
        $scope.filterConditionLookup = {};
        $scope.contentFiltersLookup = {};
        $scope.valueLookup = {};
        $scope.valueFieldLookup = {};
        $scope.label = function (id) { return getLabelForFieldId(id); };
        $scope.editFilter = function (pf) {
            $scope.origContentFilter = pf || {};
            $scope.contentFilter = lodash_1.default.create($scope.origContentFilter);
            $scope.contentFilter.name = $scope.origContentFilter.name;
            $scope.contentFilter.content_filter = lodash_1.default.cloneDeep($scope.origContentFilter.content_filter);
            initContentFilter();
            $scope.previewContentFilter();
        };
        $scope.close = function () {
            $scope.previewContentFilter();
            $scope.origContentFilter = null;
            $scope.contentFilter = null;
            $scope.test.test_result = null;
            $scope.test.article_id = null;
        };
        $scope.saveFilter = function () {
            delete $scope.contentFilter.article_id;
            contentFilters.saveContentFilter($scope.origContentFilter, $scope.contentFilter)
                .then(function () {
                notify.success(utils_1.gettext('Content filter saved.'));
                $scope.close();
            }, function (response) {
                if (angular.isDefined(response.data._issues) &&
                    angular.isDefined(response.data._issues['validator exception'])) {
                    notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
                }
                else if (angular.isDefined(response.data._issues)) {
                    if (response.data._issues.name && response.data._issues.name.unique) {
                        notify.error(utils_1.gettext('Error: Name needs to be unique'));
                    }
                    else {
                        notify.error(utils_1.gettext('Error: ' + JSON.stringify(response.data._issues)));
                    }
                }
                else if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else if (response.status === 500) {
                    notify.error(utils_1.gettext('Error: Internal error in Filter testing'));
                }
                else {
                    notify.error(utils_1.gettext('Error: Failed to test content filter.'));
                }
            })
                .then(fetchContentFilters);
        };
        $scope.remove = function (pf) {
            modal.confirm(utils_1.gettext('Are you sure you want to delete content filter?'))
                .then(function () { return contentFilters.remove(pf); })
                .then(function (result) {
                lodash_1.default.remove($scope.contentFilters, pf);
            }, function (response) {
                if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('There was an error. Content filter cannot be deleted.'));
                }
            });
        };
        $scope.addStatement = function () {
            $scope.contentFilter.content_filter.push({ expression: {} });
        };
        $scope.removeStatement = function (index) {
            $scope.contentFilter.content_filter.splice(index, 1);
            $scope.previewContentFilter();
        };
        $scope.addFilter = function (filterRow, filterType) {
            if (!(filterType in filterRow.expression)) {
                filterRow.expression[filterType] = [];
            }
            if (filterRow.selected && !lodash_1.default.includes(filterRow.expression[filterType], filterRow.selected)) {
                filterRow.expression[filterType].push(filterRow.selected);
                delete filterRow.selected;
                $scope.previewContentFilter();
            }
        };
        $scope.removeFilter = function (filterRow, filterId, filterType) {
            filterRow.expression[filterType] = lodash_1.default.without(filterRow.expression[filterType], filterId);
            $scope.previewContentFilter();
        };
        $scope.productionTest = function (filter) {
            $scope.$broadcast('triggerTest', filter);
        };
        $scope.test = function () {
            if (!$scope.test.article_id) {
                notify.error(utils_1.gettext('Please provide an article GUID'));
                return;
            }
            contentFilters.testContentFilter({ filter: $scope.contentFilter, article_id: $scope.test.article_id })
                .then(function (result) {
                $scope.test.test_result = result.match_results ? 'Does Match' : 'Doesn\'t Match';
            }, function (response) {
                if (angular.isDefined(response.data._issues)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._issues));
                }
                else if (angular.isDefined(response.data._message)) {
                    notify.error(utils_1.gettext('Error: ' + response.data._message));
                }
                else {
                    notify.error(utils_1.gettext('Error: Failed to save content filter.'));
                }
            });
        };
        $scope.previewContentFilter = function () {
            $scope.preview = parseContentFilter($scope.contentFilter.content_filter);
        };
        var parseContentFilter = function (contentFilter) {
            var previews = [];
            lodash_1.default.each(contentFilter, function (filterRow) {
                var statementPreviews = [];
                if ('pf' in filterRow.expression) {
                    lodash_1.default.each(filterRow.expression.pf, function (filterId) {
                        var f = $scope.contentFiltersLookup[filterId];
                        statementPreviews.push(parseContentFilter(f.content_filter));
                    });
                }
                if ('fc' in filterRow.expression) {
                    lodash_1.default.each(filterRow.expression.fc, function (filterId) {
                        var f = $scope.filterConditionLookup[filterId];
                        statementPreviews.push("(" + getFilterConditionSummary(f) + ")");
                    });
                }
                if (statementPreviews.length > 0) {
                    previews.push('[' + statementPreviews.join(' AND ') + ']');
                }
            });
            if (previews.length > 0) {
                return previews.join(' OR ');
            }
            return '';
        };
        /**
         * Returns the string representation of a given filter condition
         */
        var getFilterConditionSummary = function (filterCondition) {
            var labels = [];
            var values = filterCondition.value.split(',');
            lodash_1.default.each(values, function (value) {
                if ($scope.valueLookup[filterCondition.field]) {
                    var v = lodash_1.default.find($scope.valueLookup[filterCondition.field], function (val) { return val[$scope.valueFieldLookup[filterCondition.field]].toString() === value; });
                    labels.push(v.name);
                }
            });
            var conditionValue = labels.length > 0 ? labels.join(', ') : filterCondition.value;
            var fieldLabel = $scope.label(filterCondition.field);
            return fieldLabel + " " + filterCondition.operator + " \"" + conditionValue + "\"";
        };
        var initContentFilter = function () {
            if (!$scope.contentFilter.content_filter || $scope.contentFilter.content_filter.length === 0) {
                $scope.contentFilter.content_filter = [{ expression: {} }];
            }
        };
        /**
         * Fetches all filter conditions and filter condition parameters
         */
        var fetchFilterConditions = function () {
            contentFilters.getAllFilterConditions().then(function (_filterConditions) {
                $scope.filterConditions = $filter('sortByName')(_filterConditions);
                lodash_1.default.each(_filterConditions, function (filter) {
                    $scope.filterConditionLookup[filter._id] = filter;
                });
            });
            contentFilters.getFilterConditionParameters().then(function (params) {
                $scope.filterConditionParameters = params;
                lodash_1.default.each(params, function (param) {
                    $scope.valueLookup[param.field] = param.values;
                    $scope.valueFieldLookup[param.field] = param.value_field;
                });
            });
        };
        var fetchContentFilters = function () {
            contentFilters.getAllContentFilters().then(function (_filters) {
                $scope.contentFilters = $filter('sortByName')(_filters);
                lodash_1.default.each($scope.contentFilters, function (filter) {
                    $scope.contentFiltersLookup[filter._id] = filter;
                });
            });
        };
        fetchFilterConditions();
        fetchContentFilters();
    });
}
exports.ManageContentFiltersController = ManageContentFiltersController;


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.content_filters
 * @name ProductionTestCtrl
 * @description
 *   Controller for the modal page used for testing a content filter
 *   against existing content items. Triggered by the action under the
 *   Filters tab on the Content Filters settings page.
 */
ProductionTestController.$inject = ['$scope', 'contentFilters', 'notify', '$location', '$window'];
function ProductionTestController($scope, contentFilters, notify, $location, $window) {
    $scope.preview = null;
    $scope.selected = {};
    $scope.selectedItem = {};
    $scope.selectedfilter = null;
    $scope.testResult = null;
    var UP = -1, DOWN = 1, MOVES = {
        38: UP,
        40: DOWN,
    };
    $scope.resultType = [
        { id: 'Matching', value: 'true' },
        { id: 'Non-Matching', value: 'false' },
    ];
    $scope.model = { selectedType: 'true' };
    $scope.close = function () {
        $scope.filter_test = null;
        $scope.testResult = null;
    };
    $scope.preview = function (Item) {
        $location.search('_id', Item ? Item._id : Item);
    };
    $scope.openView = function (item) {
        $scope.openLightbox(item);
    };
    $scope.openLightbox = function (item) {
        $scope.selected.view = item;
    };
    $scope.closeLightbox = function () {
        $scope.selected.view = null;
    };
    $scope.hideActions = function () {
        return true;
    };
    $scope.$on('$routeUpdate', previewItem);
    function previewItem() {
        $scope.selectedItem = lodash_1.default.find($scope.testResult, { _id: $location.search()._id }) || null;
        if ($scope.selectedItem) {
            $scope.selected.preview = $scope.selectedItem;
        }
        else {
            $scope.selected.preview = null;
        }
    }
    $scope.handleKeyEvent = function (event) {
        var code = event.keyCode || event.which;
        if (MOVES[code]) {
            event.preventDefault();
            event.stopPropagation();
            move(MOVES[code], event);
        }
    };
    function move(diff, event) {
        var index = lodash_1.default.findIndex($scope.testResult, $scope.selectedItem), nextIndex;
        if (index !== -1) {
            nextIndex = Math.max(0, Math.min($scope.testResult.length - 1, index + diff));
        }
        clickItem($scope.testResult[nextIndex], event);
    }
    function select(item) {
        $scope.selectedItem = item;
        $location.search('_id', item ? item._id : item);
    }
    function clickItem(item, event) {
        select(item);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
    }
    $scope.fetchResults = function () {
        fetchProductionTestResult();
    };
    $scope.$on('triggerTest', function (event, filter) {
        $scope.productionTest = true;
        $scope.testResult = null;
        $scope.selectedfilter = filter._id;
        fetchProductionTestResult();
    });
    var fetchProductionTestResult = function () {
        contentFilters.testContentFilter({
            filter_id: $scope.selectedfilter,
            return_matching: $scope.$eval($scope.model.selectedType)
        }).then(function (result) {
            $scope.testResult = result.match_results;
        }, function (response) {
            if (angular.isDefined(response.data._issues)) {
                notify.error(utils_1.gettext('Error: ' + response.data._issues));
            }
            else if (angular.isDefined(response.data._message)) {
                notify.error(utils_1.gettext('Error: ' + response.data._message));
            }
            else {
                notify.error(utils_1.gettext('Error: Failed to fetch production test results.'));
            }
        });
    };
}
exports.ProductionTestController = ProductionTestController;


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.content_filters
 * @name FilterSearchCtrl
 * @description Controller for the Filter Search tab, found on the Content Filters
 * settings page.
 */
FilterSearchController.$inject = ['$scope', 'contentFilters', 'notify', '$filter'];
function FilterSearchController($scope, contentFilters, notify, $filter) {
    $scope.filterCondition = null;
    $scope.operatorLookup = {};
    $scope.valueLookup = {};
    $scope.valueFieldLookup = {};
    $scope.searchResult = null;
    $scope.contentFiltersLookup = {};
    $scope.isListValue = function () {
        if (!lodash_1.default.isNil($scope.filterCondition)) {
            return lodash_1.default.includes(['in', 'nin'], $scope.filterCondition.operator)
                && $scope.valueLookup[$scope.filterCondition.field];
        }
    };
    $scope.hideList = true;
    $scope.handleKey = function (event) {
        if ($scope.filterCondition.values.length > 0) {
            notify.error(utils_1.gettext('single value is required'));
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    };
    $scope.resetValues = function () {
        $scope.searchResult = null;
        $scope.filterCondition.values.length = 0;
        $scope.filterCondition.value = null;
    };
    $scope.getFilter = function (filterId) {
        return lodash_1.default.find($scope.contentFilters, { _id: filterId });
    };
    function fetchContentFilters() {
        contentFilters.getAllContentFilters().then(function (_filters) {
            $scope.contentFilters = _filters;
            lodash_1.default.each($scope.contentFilters, function (filter) {
                $scope.contentFiltersLookup[filter._id] = filter;
            });
        });
    }
    function populateData() {
        return contentFilters.getFilterConditionParameters().then(function (params) {
            $scope.filterConditionParameters = $filter('sortByName')(params, 'field');
            lodash_1.default.each(params, function (param) {
                $scope.operatorLookup[param.field] = param.operators;
                $scope.valueLookup[param.field] = param.values;
                $scope.valueFieldLookup[param.field] = param.value_field;
            });
            $scope.origFilterCondition = {};
            $scope.filterCondition = lodash_1.default.create($scope.origFilterCondition);
            $scope.filterCondition.values = [];
            setFilterValues();
        });
    }
    function setFilterValues() {
        var values = !lodash_1.default.isNil($scope.filterCondition.value) ? $scope.filterCondition.value.split(',') : [];
        var allValues = $scope.valueLookup[$scope.filterCondition.field];
        var valueField = $scope.valueFieldLookup[$scope.filterCondition.field];
        lodash_1.default.each(values, function (value) {
            var v = lodash_1.default.find(allValues, function (val) { return val[valueField].toString() === value; });
            $scope.filterCondition.values.push(v);
        });
    }
    function getFilterValue() {
        if ($scope.isListValue()) {
            var values = [];
            lodash_1.default.each($scope.filterCondition.values, function (value) {
                values.push(value[$scope.valueFieldLookup[$scope.filterCondition.field]]);
            });
            return values.join();
        }
        return $scope.filterCondition.value;
    }
    $scope.search = function () {
        if (!$scope.loading) {
            $scope.searchResult = null;
            $scope.filterCondition.value = getFilterValue();
            var inputs = {
                field: $scope.filterCondition.field,
                operator: $scope.filterCondition.operator,
                value: $scope.filterCondition.value,
            };
            $scope.loading = true;
            contentFilters.getFilterSearchResults(inputs).then(function (result) {
                if (result[0].filter_conditions.length === 0 &&
                    result[0].content_filters.length === 0 &&
                    result[0].selected_subscribers.length === 0) {
                    notify.error(utils_1.gettext('no results found'));
                }
                else {
                    $scope.searchResult = result[0];
                }
                $scope.filterCondition.value = null;
            })
                .finally(function () {
                $scope.loading = false;
            });
        }
    };
    $scope.clear = function () {
        $scope.searchResult = null;
        $scope.filterCondition = null;
    };
    populateData().then(function () {
        fetchContentFilters();
    });
}
exports.FilterSearchController = FilterSearchController;


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1873);
var services_1 = __webpack_require__(1875);
var controllers_1 = __webpack_require__(1877);
var directive = __importStar(__webpack_require__(1880));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.dictionaries
 * @name superdesk.apps.dictionaries
 * @packageName superdesk.apps
 * @description Superdesk module that adds dictionary functionality.
 */
angular.module('superdesk.apps.dictionaries', [
    'vs-repeat',
    'superdesk.core.activity',
    'superdesk.core.upload',
])
    .config(['superdeskProvider', function (superdesk) {
        superdesk.activity('/settings/dictionaries', {
            label: utils_1.gettext('Dictionaries'),
            controller: controllers_1.DictionaryConfigController,
            templateUrl: 'scripts/apps/dictionaries/views/settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            priority: -800,
            privileges: { dictionaries: 1 },
        });
    }])
    .service('dictionaries', services_1.DictionaryService)
    .controller('DictionaryEdit', controllers_1.DictionaryEditController)
    .directive('sdDictionaryConfig', function () { return ({ controller: controllers_1.DictionaryConfigController }); })
    .directive('sdDictionaryConfigModal', directive.DictionaryConfigModal)
    .directive('fileUpload', directive.FileUpload);


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1874);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dictionaries.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dictionaries.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.words-list {\n  margin-top: 4px;\n  max-height: 10em;\n  overflow-y: auto;\n  background-color: #fff;\n  border: 1px solid #dfdfdf; }\n  .words-list li {\n    padding: 2px 2px 2px 8px;\n    margin: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between; }\n    .words-list li:hover {\n      background-color: #e7f2f7; }\n    .words-list li.vs-repeat-before-content, .words-list li.vs-repeat-after-content {\n      padding: 0;\n      margin: 0; }\n\n.abbreviations-list__item {\n  padding: 0.6rem 0;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .abbreviations-list__item--heading {\n    padding: 0.8rem 0;\n    margin-top: 2rem;\n    border-top: 1px solid rgba(0, 0, 0, 0.15);\n    border-bottom: 2px solid rgba(0, 0, 0, 0.15); }\n    .abbreviations-list__item--heading .abbreviations-field {\n      font-weight: 500; }\n\n.abbreviations-field {\n  display: inline;\n  flex-grow: 0;\n  flex-shrink: 0; }\n  .abbreviations-field label {\n    width: 110px;\n    display: inline-block;\n    margin: 0 !important; }\n    .abbreviations-field label.case-sensitive {\n      text-transform: none; }\n  .abbreviations-field--grow {\n    flex-grow: 1; }\n  .abbreviations-field--abbreviation {\n    font-weight: 400;\n    font-size: 1.4rem;\n    color: #747474; }\n\n.abbreviations-field + .abbreviations-field {\n  margin-right: 1rem; }\n", ""]);

// exports


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DictionaryService_1 = __webpack_require__(1876);
exports.DictionaryService = DictionaryService_1.DictionaryService;


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
DictionaryService.$inject = ['api', 'urls', 'session', 'Upload', '$q'];
function DictionaryService(api, urls, session, Upload, $q) {
    this.dictionaries = null;
    this.currDictionary = null;
    this.getActive = getActive;
    this.getUserDictionary = getUserDictionary;
    this.addWordToUserDictionary = addWordToUserDictionary;
    this.getUserAbbreviations = getUserAbbreviations;
    function setPersonalName(data) {
        if (data.user) {
            data.name = data.user + ':' + data.language_id;
        }
    }
    this.fetch = function (success, error) {
        return session.getIdentity().then(function (identity) { return api.query('dictionaries', {
            projection: { content: 0 },
            where: {
                $or: [
                    { user: { $exists: false } },
                    { user: identity._id },
                ]
            },
        })
            .then(success, error); });
    };
    this.open = function (dictionary, success, error) {
        return api.find('dictionaries', dictionary._id).then(success, error);
    };
    this.upload = function (dictionary, data, file, success, error, progress) {
        var hasId = lodash_1.default.has(dictionary, '_id') && dictionary._id !== null;
        var method = hasId ? 'PATCH' : 'POST';
        var headers = hasId ? { 'If-Match': dictionary._etag } : {};
        var sendData = {};
        // pick own properties
        angular.forEach(data, function (val, key) {
            if (key !== 'content' && key[0] !== '_') {
                sendData[key] = val === null ? val : val.toString();
            }
        });
        setPersonalName(sendData);
        // send content as content_list which will accept string and will json.parse it later
        // (we send it as form data so each field is not parsed and it would fail list validation)
        if (data.hasOwnProperty('content')) {
            sendData.content_list = angular.toJson(data.content);
        }
        urls.resource('dictionaries').then(function (uploadURL) {
            var url = uploadURL;
            if (hasId) {
                url += '/' + dictionary._id;
            }
            return Upload.upload({
                url: url,
                method: method,
                data: sendData,
                file: file,
                headers: headers,
            }).then(success, error, progress);
        }, error);
    };
    this.update = function (dictionary, data, success, error) {
        var sendData = {};
        angular.forEach(data, function (val, key) {
            if (key[0] !== '_') {
                sendData[key] = key === 'is_active' ? val.toString() : val;
            }
        });
        setPersonalName(sendData);
        return api.save('dictionaries', dictionary, sendData).then(success, error);
    };
    this.remove = function (dictionary, success, error) {
        return api.remove(dictionary).then(success, error);
    };
    this.isAbbreviationsDictionary = function (dict) {
        return dict && dict.type === 'abbreviations';
    };
    /**
     * Get list of active abbreviations for given lang
     *
     * @param {string} lang
     */
    function getUserAbbreviations(lang, baseLang) {
        return session.getIdentity().then(function (identity) {
            var languageIds = [{ language_id: lang }];
            if (baseLang) {
                languageIds.push({ language_id: baseLang });
            }
            return api.query('dictionaries', {
                where: { $and: [{ $or: languageIds },
                        { is_active: 'true' },
                        { type: 'abbreviations' },
                        { user: identity._id }],
                }
            }).then(function (items) { return items._items; });
        });
    }
    /**
     * Get list of active dictionaries for given lang
     *
     * @param {string} lang
     */
    function getActive(lang, baseLang) {
        return session.getIdentity().then(function (identity) {
            var languageIds = [{ language_id: lang }];
            if (baseLang) {
                languageIds.push({ language_id: baseLang });
            }
            return api.query('dictionaries', {
                projection: { content: 0 },
                where: { $and: [{ $or: languageIds },
                        { is_active: { $in: ['true', null] } },
                        { $or: [{ type: { $exists: 0 } }, { type: 'dictionary' }] },
                        { $or: [{ user: identity._id }, { user: { $exists: false } }] }],
                }
            }).then(function (items) { return $q.all(items._items.map(fetchItem)); });
        });
        function fetchItem(item) {
            return api.find('dictionaries', item._id);
        }
    }
    /**
     * Get user dictionary for given language
     *
     * @param {string} lang
     */
    function getUserDictionary(lang) {
        return session.getIdentity().then(function (identity) {
            var where = {
                where: {
                    $and: [
                        { language_id: lang }, { user: identity._id },
                        { $or: [{ type: { $exists: 0 } }, { type: 'dictionary' }] },
                    ],
                },
            };
            return api.query('dictionaries', where)
                .then(function (response) { return response._items.length ? response._items[0] : {
                name: identity._id + ':' + lang,
                content: {},
                language_id: lang,
                user: identity._id,
            }; });
        });
    }
    /**
     * Add word to user dictionary
     *
     * @param {string} word
     * @param {string} lang
     */
    function addWordToUserDictionary(word, lang) {
        return getUserDictionary(lang).then(function (userDict) {
            var words = userDict.content || '{}';
            if (lodash_1.default.isString(words)) {
                words = JSON.parse(userDict.content || '{}');
            }
            words[word] = words[word] ? words[word] + 1 : 1;
            userDict.content = words;
            return api.save('dictionaries', userDict);
        });
    }
}
exports.DictionaryService = DictionaryService;


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DictionaryConfigController_1 = __webpack_require__(1878);
exports.DictionaryConfigController = DictionaryConfigController_1.DictionaryConfigController;
var DictionaryEditController_1 = __webpack_require__(1879);
exports.DictionaryEditController = DictionaryEditController_1.DictionaryEditController;


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DictionaryConfigController.$inject = ['$scope', 'dictionaries', 'session', 'modal', 'notify'];
function DictionaryConfigController($scope, dictionaries, session, modal, notify) {
    $scope.dictionaries = null;
    $scope.origDictionary = null;
    $scope.dictionary = null;
    $scope.isAdmin = function () {
        return session.identity.user_type === 'administrator';
    };
    $scope.fetchDictionaries = function () {
        dictionaries.fetch(function (result) {
            if (!$scope.isAdmin()) {
                $scope.dictionaries = lodash_1.default.filter(result._items, function (f) { return f.user === session.identity._id; });
            }
            else {
                $scope.dictionaries = result._items;
            }
        });
    };
    $scope.createDictionary = function () {
        $scope.dictionary = { is_active: 'true' };
        $scope.origDictionary = {
            type: 'dictionary',
        };
    };
    $scope.createPersonalDictionary = function () {
        return session.getIdentity().then(function (identity) {
            $scope.dictionary = {
                is_active: 'true',
                type: 'dictionary',
                user: identity._id,
                name: identity._id,
            };
            $scope.origDictionary = {};
        });
    };
    $scope.isAbbreviations = function (dict) {
        return dictionaries.isAbbreviationsDictionary(dict);
    };
    $scope.createAbbreviationsDictionary = function () {
        return session.getIdentity().then(function (identity) {
            $scope.dictionary = {
                is_active: 'true',
                type: 'abbreviations',
                user: identity._id,
                name: identity._id,
                content: {},
            };
            $scope.origDictionary = {};
        });
    };
    $scope.openDictionary = function (dictionary) {
        $scope.loading = true;
        dictionaries.open(dictionary, function (result) {
            $scope.origDictionary = result;
            $scope.dictionary = Object.create(result);
            $scope.dictionary.content = Object.create(result.content || {});
            $scope.dictionary.is_active = result.is_active !== 'false';
            if ($scope.isAbbreviations(result)) {
                $scope.dictionary.content = result.content || {};
            }
        });
    };
    $scope.searchDictionary = function (param) {
        var string = param.user ? 'Personal' : param.name;
        return !$scope.query || string.toLowerCase().indexOf($scope.query.toLowerCase()) !== -1;
    };
    $scope.stopLoading = function () {
        $scope.loading = false;
    };
    $scope.closeDictionary = function () {
        $scope.dictionary = $scope.origDictionary = null;
    };
    $scope.remove = function (dictionary) {
        modal.confirm(utils_1.gettext('Please confirm you want to delete dictionary.')).then(function runConfirmed() {
            dictionaries.remove(dictionary, function () {
                lodash_1.default.remove($scope.dictionaries, dictionary);
                notify.success(utils_1.gettext('Dictionary deleted.'), 3000);
            });
        });
    };
    $scope.fetchDictionaries();
}
exports.DictionaryConfigController = DictionaryConfigController;


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
DictionaryEditController.$inject = ['$scope', 'dictionaries', 'upload', 'notify',
    'modal', '$rootScope', '$q'];
function DictionaryEditController($scope, dictionaries, upload, notify, modal, $rootScope, $q) {
    function onSuccess(result) {
        if ($scope.isAbbreviations()) {
            $rootScope.$broadcast('abbreviations:updated', result.content);
        }
        $scope.closeDictionary();
        $scope.fetchDictionaries();
        notify.success(utils_1.gettext('Dictionary saved successfully'));
        $scope.progress = null;
        return result;
    }
    function onError(response) {
        if (angular.isDefined(response.data._issues)) {
            if (angular.isDefined(response.data._issues['validator exception'])) {
                notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
            }
            else if (angular.isDefined(response.data._issues.name)) {
                notify.error(utils_1.gettext('Error: The dictionary already exists.'));
                $scope._errorUniqueness = true;
            }
        }
        else {
            notify.error(utils_1.gettext('Error. Dictionary not saved.'));
        }
        $scope.progress = null;
    }
    // listen for the file selected event
    $scope.$on('fileSelected', function (event, args) {
        $scope.$apply(function () {
            $scope.file = args.file;
        });
    });
    $scope.save = function () {
        $scope._errorUniqueness = false;
        $scope.progress = { width: 1 };
        if ($scope.file) {
            dictionaries.upload($scope.origDictionary, $scope.dictionary, $scope.file, onSuccess, onError, function (update) {
                $scope.progress.width = Math.round(update.loaded / update.total * 100.0);
            });
        }
        else {
            dictionaries.update($scope.origDictionary, $scope.dictionary, onSuccess, onError);
        }
    };
    $scope.cancel = function () {
        $scope._errorUniqueness = false;
        $scope.closeDictionary();
    };
    $scope.addWord = function (word) {
        if (!$scope.dictionary.content.hasOwnProperty(word)) {
            addWordToTrie(word);
        }
        $scope.dictionary.content[word] = 1;
        $scope.filterWords(word);
        $scope.wordsCount++;
    };
    $scope.removeWord = function (word, search) {
        $scope.dictionary.content[word] = 0;
        $scope.filterWords(search);
        $scope.wordsCount--;
    };
    $scope.stopLoading = $scope.stopLoading || angular.noop;
    function isPrefix(prefix, word) {
        return word.length >= prefix.length && word.substr(0, prefix.length).toLowerCase() === prefix.toLowerCase();
    }
    $scope.filterWords = function filterWords(search) {
        $scope.words = [];
        $scope.isNew = !!search;
        if (!search) {
            return;
        }
        var key = search[0].toLowerCase();
        if (!wordsTrie[key]) {
            return;
        }
        var searchWords = wordsTrie[key], length = searchWords.length, words = [], word;
        for (var i = 0; i < length; i++) {
            word = searchWords[i];
            if ($scope.dictionary.content[word] > 0 && isPrefix(search, word)) {
                words.push(word);
                if (word === search) {
                    $scope.isNew = false;
                }
            }
        }
        words.sort();
        $scope.words = words;
    };
    var wordsTrie = {};
    $scope.wordsCount = 0;
    generateTrie();
    $scope.stopLoading();
    function addWordToTrie(word) {
        var key = word[0].toLowerCase();
        if (wordsTrie.hasOwnProperty(key)) {
            wordsTrie[key].push(word);
        }
        else {
            wordsTrie[key] = [word];
        }
    }
    function generateTrie() {
        var content = $scope.origDictionary.content || $scope.dictionary.content;
        var words = Object.keys(content || {});
        $scope.wordsCount = words.length;
        for (var i = 0; i < $scope.wordsCount; i++) {
            addWordToTrie(words[i]);
        }
    }
    $scope.isAbbreviations = function () {
        return dictionaries.isAbbreviationsDictionary($scope.dictionary);
    };
    $scope.editAbbreviations = function (abbreviation, phrase) {
        $scope.dictionary.content[abbreviation] = phrase;
    };
    $scope.removeAbbreviation = function (abbreviation) {
        modal.confirm(utils_1.gettext('Do you want to remove Abbreviation?'))
            .then(function () {
            delete $scope.dictionary.content[abbreviation];
            init();
        });
    };
    function confirmAdd() {
        if ($scope.dictionary.content[$scope.abbreviation.key]) {
            return modal.confirm(utils_1.gettext('Abbreviation already exists. Do you want to overwrite it?'))
                .then(function () { return true; }, function () { return false; });
        }
        return $q.when(true);
    }
    $scope.addAbbreviation = function () {
        confirmAdd().then(function (result) {
            if (result) {
                $scope.dictionary.content[$scope.abbreviation.key] = $scope.abbreviation.phrase;
                init();
            }
        });
    };
    function init() {
        if ($scope.isAbbreviations()) {
            $scope.abbreviation = {
                key: '', phrase: '',
            };
            $scope.abbreviationKeys = lodash_1.default.sortBy(Object.keys($scope.dictionary.content));
        }
    }
    init();
}
exports.DictionaryEditController = DictionaryEditController;


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DictionaryConfigModal_1 = __webpack_require__(1881);
exports.DictionaryConfigModal = DictionaryConfigModal_1.DictionaryConfigModal;
var FileUpload_1 = __webpack_require__(1882);
exports.FileUpload = FileUpload_1.FileUpload;


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function DictionaryConfigModal() {
    return {
        controller: 'DictionaryEdit',
        require: '^sdDictionaryConfig',
        templateUrl: 'scripts/apps/dictionaries/views/dictionary-config-modal.html',
    };
}
exports.DictionaryConfigModal = DictionaryConfigModal;


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function FileUpload() {
    return {
        scope: true,
        link: function (scope, element, attrs) {
            element.bind('change', function (event) {
                scope.$emit('fileSelected', { file: event.target.files[0] });
            });
        },
    };
}
exports.FileUpload = FileUpload;


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013-2015 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1884);
var services_1 = __webpack_require__(1886);
var ctrl = __importStar(__webpack_require__(1889));
var directive = __importStar(__webpack_require__(1892));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.vocabularies
 * @name superdesk.apps.vocabularies
 * @packageName superdesk.apps
 * @description Superdesk vocabularies module.
 */
angular.module('superdesk.apps.vocabularies', [
    'superdesk.core.activity',
])
    .service('vocabularies', services_1.VocabularyService)
    .controller('VocabularyEdit', ctrl.VocabularyEditController)
    .controller('VocabularyConfig', ctrl.VocabularyConfigController)
    .directive('sdVocabularyConfig', directive.VocabularyConfigDirective)
    .directive('sdVocabularyConfigModal', directive.VocabularyConfigModal)
    .directive('sdVocabularyObjectField', directive.VocabularyObjectField)
    .directive('sdVocabularyConfigModalItems', directive.VocabularyConfigModalItems)
    .factory('cvSchema', services_1.SchemaFactory)
    .config(['superdeskProvider', function (superdesk) {
        superdesk.activity('/settings/vocabularies', {
            label: utils_1.gettext('Metadata'),
            templateUrl: 'scripts/apps/vocabularies/views/settings.html',
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            priority: -800,
            privileges: { vocabularies: 1 },
        });
    }]);


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1885);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./vocabularies.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./vocabularies.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.vocabularyForm button.del {\n  width: 30px;\n  padding: 8px 10px; }\n\n.vocabularyForm table th, .vocabularyForm table td {\n  vertical-align: middle; }\n\n.vocabularyForm tbody tr td:last-child {\n  text-align: right; }\n\n.vocabularyForm tbody tr td:first-child {\n  padding-left: 0; }\n\n.vocabularyForm thead tr th {\n  font-weight: 500;\n  padding: 0.8rem 0.8rem; }\n  .vocabularyForm thead tr th label {\n    margin-bottom: 0; }\n  .vocabularyForm thead tr th:first-child {\n    padding-left: 0; }\n\n.vocabularyField {\n  display: inline; }\n  .vocabularyField label {\n    width: 140px;\n    display: inline-block;\n    padding-left: 6px; }\n  .vocabularyField input {\n    width: 140px;\n    margin: 3px; }\n    .vocabularyField input[type=\"color\"] {\n      width: 130px; }\n    .vocabularyField input.long-name {\n      width: 320px;\n      font-size: 10px; }\n\n.vocabularyStatus {\n  top: 5px; }\n  .vocabularyStatus.sd-toggle {\n    margin-top: 2px !important; }\n\n.divider {\n  height: 1px;\n  margin: 8px 1px;\n  overflow: hidden;\n  background-color: #e5e5e5;\n  border-bottom: 1px solid #fff;\n  *width: 100%;\n  *margin: -5px 0 5px; }\n\n.add-vocabulary-popup .modal-dialog {\n  width: auto !important;\n  white-space: normal; }\n\n.modal-header-fields {\n  background: #f8f8f8;\n  width: 100%;\n  flex: 0 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0px 20px;\n  border-bottom: 1px solid #e4e4e4; }\n  .modal-header-fields .long-name {\n    width: 310px; }\n\n.vocabulary-items__wrapper {\n  margin: 1rem 0 0; }\n  .vocabulary-items__wrapper h3 {\n    margin-bottom: 0.6rem;\n    font-size: 1.6rem;\n    line-height: 100%; }\n\n.vocabulary-items__button-bar {\n  padding: 1.2rem 0; }\n\n.vocabulary-items__wrapper table th {\n  position: sticky;\n  top: -20px;\n  background: #f8f8f8;\n  z-index: 1; }\n\n.date_shortcuts {\n  margin-top: 2em; }\n  .date_shortcuts .sd-line-input.date_shortcuts--smaller {\n    width: 5%; }\n", ""]);

// exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VocabularyService_1 = __webpack_require__(1887);
exports.VocabularyService = VocabularyService_1.VocabularyService;
var SchemaFactory_1 = __webpack_require__(1888);
exports.SchemaFactory = SchemaFactory_1.SchemaFactory;


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
exports.DEFAULT_DATEFIELD_SHORTCUTS = [
    {
        label: utils_1.gettext('Today'),
        value: 0,
        term: 'days',
    },
    {
        label: utils_1.gettext('Tomorrow'),
        value: 1,
        term: 'days',
    },
    {
        label: utils_1.gettext('In 3 days'),
        value: 3,
        term: 'days',
    },
];
/**
 * @ngdoc service
 * @module superdesk.apps.vocabularies
 * @name VocabularyService
 *
 * @requires api
 * @requires $q
 * @requires $filter
 * @requires $rootScope
 *
 * @description Provides a service to fetch and cache the vocabularies
 */
VocabularyService.$inject = ['api', '$q', '$filter', '$rootScope'];
function VocabularyService(api, $q, $filter, $rootScope) {
    var self = this;
    self.AllActiveVocabularies = null;
    self.vocabularies = null;
    /**
     * @ngdoc method
     * @name VocabularyService#getAllVocabularies
     * @public
     * @description Return all of the vocabularies filtered by active items only, either from
     * the cache or retrieved via an api request
     * @return {Promise} {Object} vocabularies
     */
    this.getAllActiveVocabularies = function () {
        if (lodash_1.default.isNil(self.AllActiveVocabularies)) {
            return api.getAll('vocabularies').then(function (result) {
                self.AllActiveVocabularies = result;
                return self.AllActiveVocabularies;
            });
        }
        return $q.when(self.AllActiveVocabularies);
    };
    /**
     * @ngdoc method
     * @name VocabularyService#getVocabularies
     * @public
     * @description Returns the manageable vocabularies.
     * @return {Promise} {Object} vocabularies
     */
    this.getVocabularies = function () {
        if (lodash_1.default.isNil(self.vocabularies)) {
            return api.getAll('vocabularies', { where: { type: 'manageable' } }).then(function (result) {
                result._items = $filter('sortByName')(result._items, 'display_name');
                self.vocabularies = result;
                return self.vocabularies;
            });
        }
        return $q.when(self.vocabularies);
    };
    /**
     * @ngdoc method
     * @name VocabularyService#isInit
     * @public
     * @description Returns true if the vocabularies were initialized.
     * @return {Boolean}
     */
    this.isInit = function () { return !!self.AllActiveVocabularies; };
    /**
     * @ngdoc method
     * @name VocabularyService#getVocabulary
     * @public
     * @description Returns the vocabulary identified by the given id.
     * @param {String} vocabularyId
     * @return {Promise} {Object} vocabulary
     */
    this.getVocabulary = function (vocabularyId) {
        return self.getAllActiveVocabularies().then(function (vocabularies) { return lodash_1.default.find(vocabularies, { _id: vocabularyId }); });
    };
    /**
     * @ngdoc method
     * @name VocabularyService#getVocabularySync
     * @public
     * @description Returns the vocabulary identified by the given id.
     * @param {String} vocabularyId
     * @return {Object} vocabulary
     */
    this.getVocabularySync = function (vocabularyId) {
        if (self.AllActiveVocabularies) {
            return lodash_1.default.find(self.AllActiveVocabularies, { _id: vocabularyId });
        }
    };
    /**
     * @ngdoc method
     * @name VocabularyService#_resetVocabularies
     * @private
     * @description Clears the cached vocabularies.
     */
    this._resetVocabularies = function () {
        self.AllActiveVocabularies = null;
        self.vocabularies = null;
    };
    this.getDefaultDatefieldShortcuts = function () {
        return exports.DEFAULT_DATEFIELD_SHORTCUTS;
    };
    // reset cache on update
    $rootScope.$on('vocabularies:updated', angular.bind(this, this._resetVocabularies));
}
exports.VocabularyService = VocabularyService;


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
SchemaFactory.$inject = [];
function SchemaFactory() {
    var colorScheme = {
        name: { type: 'text', label: utils_1.gettext('Name') },
        qcode: { type: 'text', label: utils_1.gettext('QCode') },
        color: { type: 'color', label: utils_1.gettext('Color') },
        short: { type: 'short', label: utils_1.gettext('List Name'), maxlength: 2 },
    };
    return {
        urgency: colorScheme,
        priority: colorScheme,
    };
}
exports.SchemaFactory = SchemaFactory;


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VocabularyConfigController_1 = __webpack_require__(1890);
exports.VocabularyConfigController = VocabularyConfigController_1.VocabularyConfigController;
var VocabularyEditController_1 = __webpack_require__(1891);
exports.VocabularyEditController = VocabularyEditController_1.VocabularyEditController;


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(158);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var OTHER = utils_1.gettext('Other');
function getTags(_vocabularies) {
    var wordSet = (_vocabularies || []).reduce(function (_wordSet, vocabulary) {
        (vocabulary.tags || []).forEach(function (tag) {
            if (tag.text !== OTHER) {
                _wordSet.add(tag.text);
            }
        });
        return _wordSet;
    }, new Set());
    var wordList = Array.from(wordSet).sort(function (a, b) { return a.localeCompare(b); });
    wordList.push(OTHER);
    return wordList.map(function (word) { return ({ text: word }); });
}
VocabularyConfigController.$inject = ['$scope', '$route', '$routeParams', 'vocabularies', '$rootScope',
    'api', 'notify', 'modal', 'session'];
function VocabularyConfigController($scope, $route, $routeParams, vocabularies, $rootScope, api, notify, modal, session) {
    $scope.loading = true;
    $scope.mediaTypes = constants_1.MEDIA_TYPES;
    /**
     * Open vocabulary in the edit modal.
     *
     * @param {Object} vocabulary
     */
    $scope.openVocabulary = function (vocabulary) {
        $route.updateParams({ id: vocabulary._id });
    };
    /**
     * Close vocabulary edit modal
     */
    $scope.closeVocabulary = function () {
        $route.updateParams({ id: null, new: null, type: null });
    };
    /**
     * Open modal with new item
     */
    $scope.createVocabulary = function () {
        $route.updateParams({ id: null, new: true, type: null });
    };
    /**
     * Create new custom field
     * @param {string} type (text, picture, video or embed)
     */
    $scope.createCustomField = function (type) {
        $route.updateParams({ id: null, new: true, type: type });
    };
    /**
     * Match field type to vocabularies tab
     */
    $scope.matchFieldTypeToTab = function (tab, fieldType) {
        return tab === 'vocabularies' && !fieldType || fieldType &&
            (tab === 'text-fields' && fieldType === 'text' ||
                tab === 'date-fields' && fieldType === 'date' ||
                tab === 'urls-fields' && fieldType === 'urls' ||
                tab === 'related-content-fields' && constants_1.MEDIA_TYPE_KEYS.includes(fieldType) ||
                tab === 'embed-fields' && fieldType === 'embed');
    };
    /**
     * Reload list of vocabularies
     */
    $scope.reloadList = function () {
        $scope.loading = true;
        vocabularies.getVocabularies().then(function (_vocabularies) {
            $scope.tags = getTags(_vocabularies);
            $scope.vocabularies = _vocabularies;
            $scope.loading = false;
            setupActiveVocabulary();
        });
    };
    function checkTag(vocabulary, currentTag, tab) {
        return $scope.matchFieldTypeToTab(tab, vocabulary.field_type) &&
            (currentTag.text === OTHER && (vocabulary.tags == null || vocabulary.tags.length === 0) ||
                (vocabulary.tags || []).some(function (tag) { return tag.text === currentTag.text; }));
    }
    $scope.getVocabulariesForTag = function (currentTag, tab) {
        return ($scope.vocabularies || []).filter(function (vocabulary) { return checkTag(vocabulary, currentTag, tab); });
    };
    $scope.existsVocabulariesForTag = function (currentTag, tab) {
        return ($scope.vocabularies || []).some(function (vocabulary) { return checkTag(vocabulary, currentTag, tab); });
    };
    /**
     * Don't show OTHER tag if it is the only tag available for current tab
     */
    $scope.canShowTag = function (currentTag, tab) {
        return currentTag.text !== OTHER ||
            ($scope.vocabularies || []).some(function (vocabulary) {
                return $scope.matchFieldTypeToTab(tab, vocabulary.field_type) &&
                    (vocabulary.tags || []).some(function (tag) { return tag.text !== OTHER; });
            });
    };
    /**
     * Update vocabulary in the list with given updates
     *
     * @param {Object} updates
     */
    $scope.updateVocabulary = function (updates) {
        var index = $scope.vocabularies.findIndex(function (v) { return v._id === updates._id; });
        var vocabulary = null;
        if (index === -1) {
            $scope.vocabularies = [updates].concat($scope.vocabularies);
            vocabulary = $scope.vocabularies;
        }
        else {
            $scope.vocabularies[index] = angular.extend({}, $scope.vocabularies[index], updates);
            vocabulary = $scope.vocabularies[index];
        }
        // refresh tags to get any new ones
        $scope.tags = getTags($scope.vocabularies);
        var dataVocabulary = {
            user: session.identity._id,
            vocabulary: vocabulary.display_name || vocabulary._id,
            vocabulary_id: vocabulary._id,
        };
        $rootScope.$broadcast('vocabularies:updated', dataVocabulary);
    };
    // remove is the UI callback for deleting a vocabulary entry
    $scope.remove = function (vocabulary) {
        modal.confirm(utils_1.gettext('Please confirm you want to delete the vocabulary.'))
            .then(function () { return api.remove(vocabulary, {}, 'vocabularies'); })
            .then(vocabularyRemoved(vocabulary), errorRemovingVocabulary);
    };
    // vocabularyRemoved updates the UI after the given vocabulary has been removed via the API.
    var vocabularyRemoved = function (vocabulary) { return function () {
        lodash_1.remove($scope.vocabularies, function (v) { return v._id === vocabulary._id; });
        $scope.reloadList();
        notify.success(utils_1.gettext('Vocabulary was deleted.'));
    }; };
    // errorRemoving alerts the user of an error that occurred while attempting to remove a vocabulary.
    var errorRemovingVocabulary = function (response) {
        var issues = response.data._issues;
        if (!issues) {
            notify.error(utils_1.gettext('Error removing the vocabulary.'));
        }
        else if (issues._message) {
            notify.error(issues._message);
        }
        else if (issues.content_types) {
            var contentTypes = lodash_1.reduce(issues.content_types, function (result, value) { return result ? result + ", " + value.label : value.label; }, null);
            notify.error(utils_1.gettext('The vocabulary is used in the following content types:') + ' ' + contentTypes);
        }
    };
    $scope.$on('$routeUpdate', setupActiveVocabulary);
    $scope.reloadList();
    function setupActiveVocabulary() {
        $scope.vocabulary = null;
        if ($routeParams.id) {
            $scope.vocabulary = $scope.vocabularies.find(function (v) { return v._id === $routeParams.id; });
        }
        if ($routeParams.new) {
            $scope.vocabulary = {
                field_type: $routeParams.type || null,
                items: [],
                type: 'manageable',
                schema: angular.extend({}, constants_1.DEFAULT_SCHEMA),
                service: { all: 1 },
            };
            if ($routeParams.type == null) {
                $scope.vocabulary.selection_type = constants_1.VOCABULARY_SELECTION_TYPES.MULTIPLE_SELECTION.id;
            }
        }
        if ($scope.vocabulary && $scope.vocabulary.field_type === 'date') {
            if (!$scope.vocabulary.date_shortcuts) {
                $scope.vocabulary.date_shortcuts = vocabularies.getDefaultDatefieldShortcuts();
            }
        }
    }
}
exports.VocabularyConfigController = VocabularyConfigController;


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(158);
var utils_1 = __webpack_require__(3);
VocabularyEditController.$inject = [
    '$scope',
    'notify',
    'api',
    'vocabularies',
    'metadata',
    'cvSchema',
];
var idRegex = '^[a-zA-Z0-9-_]+$';
function VocabularyEditController($scope, notify, api, vocabularies, metadata, cvSchema) {
    var origVocabulary = lodash_1.default.cloneDeep($scope.vocabulary);
    $scope.idRegex = idRegex;
    $scope.selectionTypes = constants_1.VOCABULARY_SELECTION_TYPES;
    function onSuccess(result) {
        notify.success(utils_1.gettext('Vocabulary saved successfully'));
        $scope.closeVocabulary();
        $scope.updateVocabulary(result);
        $scope.issues = null;
        return result;
    }
    function onError(response) {
        if (angular.isDefined(response.data._issues)) {
            if (angular.isDefined(response.data._issues['validator exception'])) {
                notify.error(utils_1.gettext('Error: ' +
                    response.data._issues['validator exception']));
            }
            else if (angular.isDefined(response.data._issues.error) &&
                response.data._issues.error.required_field) {
                var params = response.data._issues.params;
                notify.error(utils_1.gettext('Required {{field}} in item {{item}}', { field: params.field, item: params.item }));
            }
            else {
                $scope.issues = response.data._issues;
                notify.error(utils_1.gettext('Error. Vocabulary not saved.'));
            }
        }
    }
    function checkForUniqueValues() {
        var uniqueField = $scope.vocabulary.unique_field || 'qcode';
        var list = $scope.vocabulary.items || {};
        if (list.find(function (item) { return uniqueField in item; })) {
            var uniqueList = lodash_1.default.uniqBy(list, function (item) { return item[uniqueField]; });
            return list.length === uniqueList.length;
        }
        return true;
    }
    /**
     * Save current edit modal contents on backend.
     */
    $scope.save = function () {
        $scope._errorUniqueness = false;
        $scope.errorMessage = null;
        delete $scope.vocabulary._deleted;
        if ($scope.vocabulary._id === 'crop_sizes') {
            var activeItems = lodash_1.default.filter($scope.vocabulary.items, function (o) { return o.is_active; });
            activeItems.forEach(function (_a) {
                var width = _a.width, height = _a.height, name = _a.name;
                if (parseInt(height, 10) < 200 || parseInt(width, 10) < 200) {
                    $scope.errorMessage = utils_1.gettext('Minimum height and width should be greater than or equal to 200');
                }
                if (!name || name.match(idRegex) === null) {
                    $scope.errorMessage =
                        utils_1.gettext('Name field should only have alphanumeric characters, dashes and underscores');
                }
            });
        }
        if (!checkForUniqueValues()) {
            var uniqueField = $scope.vocabulary.unique_field || 'qcode';
            $scope.errorMessage = utils_1.gettext('The values should be unique for {{uniqueField}}', { uniqueField: uniqueField });
        }
        if ($scope.vocabulary.field_type === constants_1.MEDIA_TYPES.GALLERY) {
            var allowedTypes_1 = $scope.vocabulary.field_options.allowed_types;
            Object.keys(allowedTypes_1).forEach(function (key) {
                if (!['picture', 'video', 'audio'].includes(key)) {
                    allowedTypes_1[key] = false;
                }
            });
        }
        if (lodash_1.default.isNil($scope.errorMessage)) {
            api.save('vocabularies', $scope.vocabulary).then(onSuccess, onError);
        }
        // discard metadata cache:
        metadata.loaded = null;
        metadata.initialize();
    };
    /**
     * Return true if at least one content type should be selected
     */
    $scope.requireAllowedTypesSelection = function () {
        if (!constants_1.MEDIA_TYPE_KEYS.includes($scope.vocabulary.field_type)) {
            return false;
        }
        if ($scope.vocabulary.field_options == null || $scope.vocabulary.field_options.allowed_types == null) {
            return true;
        }
        var allowedTypes = $scope.vocabulary.field_options.allowed_types;
        var selectedKeys = Object.keys(allowedTypes).filter(function (key) { return allowedTypes[key] === true; });
        return selectedKeys.length === 0;
    };
    /**
     * Discard changes and close modal.
     */
    $scope.cancel = function () {
        angular.copy(origVocabulary, $scope.vocabulary);
        $scope.closeVocabulary();
    };
    /**
     * Add new blank vocabulary item.
     */
    $scope.addItem = function () {
        var newVocabulary = {};
        lodash_1.default.extend(newVocabulary, $scope.model);
        newVocabulary.is_active = true;
        $scope.vocabulary.items = $scope.vocabulary.items.concat([newVocabulary]);
    };
    // try to reproduce data model of vocabulary:
    var model = lodash_1.default.mapValues(lodash_1.default.keyBy(lodash_1.default.uniq(lodash_1.default.flatten(lodash_1.default.map($scope.vocabulary.items, function (o) { return lodash_1.default.keys(o); })))), function () { return null; });
    $scope.model = model;
    $scope.schema = $scope.vocabulary.schema || cvSchema[$scope.vocabulary._id] || null;
    if ($scope.schema) {
        $scope.schemaFields = Object.keys($scope.schema)
            .sort()
            .map(function (key) { return angular.extend({ key: key }, $scope.schema[key]); });
    }
    $scope.itemsValidation = { valid: true };
    /**
     * Remove item from vocabulary items
     *
     * @param {number} index
     */
    $scope.removeItem = function (index) {
        $scope.vocabulary.items.splice(index, 1);
        $scope.vocabulary.items = $scope.vocabulary.items.slice(); // trigger watch on items collection
    };
}
exports.VocabularyEditController = VocabularyEditController;


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var VocabularyConfigDirective_1 = __webpack_require__(1893);
exports.VocabularyConfigDirective = VocabularyConfigDirective_1.VocabularyConfigDirective;
var VocabularyConfigModal_1 = __webpack_require__(1894);
exports.VocabularyConfigModal = VocabularyConfigModal_1.VocabularyConfigModal;
var VocabularyObjectField_1 = __webpack_require__(1895);
exports.VocabularyObjectField = VocabularyObjectField_1.VocabularyObjectField;
var VocabularyConfigModalItems_1 = __webpack_require__(1896);
exports.VocabularyConfigModalItems = VocabularyConfigModalItems_1.VocabularyConfigModalItems;


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function VocabularyConfigDirective() {
    return {
        controller: 'VocabularyConfig',
        templateUrl: 'scripts/apps/vocabularies/views/vocabulary-config.html',
    };
}
exports.VocabularyConfigDirective = VocabularyConfigDirective;


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function VocabularyConfigModal() {
    return {
        controller: 'VocabularyEdit',
        templateUrl: 'scripts/apps/vocabularies/views/vocabulary-config-modal.html',
    };
}
exports.VocabularyConfigModal = VocabularyConfigModal;


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Directive which adds support for editing JSON objects
 *
 * It converts Object into string for rendering and string to JSON for storage.
 *
 * Use with ng-model on input/textarea fields.
 */
function VocabularyObjectField() {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            ngModel.$parsers.push(parseJson);
            ngModel.$formatters.push(formatJson);
            ngModel.$validators.json = validateJson;
        },
    };
    /**
     * Validate if string can be converted to JSON
     *
     * @param {String} modelValue
     * @param {String} viewValue
     * @return {Boolean}
     */
    function validateJson(modelValue, viewValue) {
        var value = modelValue || viewValue;
        try {
            angular.fromJson(value);
            return true;
        }
        catch (err) {
            return false;
        }
    }
    /**
     * Format JSON object as string
     *
     * @param {Object} value
     * @return {String}
     */
    function formatJson(value) {
        if (value) {
            return angular.toJson(value, true);
        }
    }
    /**
     * Parse given string into json object
     *
     * @param {String} value
     * @return {Object}
     */
    function parseJson(value) {
        if (value) {
            try {
                return angular.fromJson(value);
            }
            catch (err) {
                // noop
            }
        }
    }
}
exports.VocabularyObjectField = VocabularyObjectField;


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var ItemsTableComponent_1 = __importDefault(__webpack_require__(1897));
var lodash_1 = __webpack_require__(2);
exports.VocabularyConfigModalItems = function () { return ({
    require: '^^form',
    link: function (scope, element, attr, ngForm) {
        var component;
        var itemsValidation = [];
        function validateItem(item) {
            var itemValidation = {};
            lodash_1.forEach(scope.vocabulary.schema, function (desc, field) {
                itemValidation[field] = !desc.required || !!item[field];
            });
            return itemValidation;
        }
        function validItem(itemValidation) {
            return lodash_1.every(scope.vocabulary.schema, function (schema, schemaId) {
                return !schema.required || itemValidation[schemaId];
            });
        }
        var validateItems = function (items) {
            scope.itemsValidation.valid = true;
            itemsValidation = items.map(function (_item) {
                var itemValidation = validateItem(_item);
                scope.itemsValidation.valid = scope.itemsValidation.valid && validItem(itemValidation);
                return itemValidation;
            });
        };
        var update = function (item, key, value) {
            var _a;
            var updates = (_a = {}, _a[key] = value, _a);
            // sync scope
            scope.$applyAsync(function () {
                ngForm.$setDirty();
                var index = 0;
                scope.vocabulary.items = scope.vocabulary.items.map(function (_item) {
                    index++;
                    if (_item === item) {
                        var updated = Object.assign({}, item, updates);
                        itemsValidation[index - 1] = validateItem(updated);
                        scope.itemsValidation.valid = scope.itemsValidation.valid &&
                            validItem(itemsValidation[index - 1]);
                        return updated;
                    }
                    return _item;
                });
            });
        };
        var remove = function (index) {
            scope.$applyAsync(function () {
                ngForm.$setDirty();
                scope.removeItem(index);
            });
        };
        // render component
        react_dom_1.default.render(react_1.default.createElement(ItemsTableComponent_1.default, { ref: function (ref) { return component = ref; }, model: scope.model, schema: scope.schema, schemaFields: scope.schemaFields, remove: remove, update: update }), element[0]);
        // destroy component with directive
        scope.$on('$destroy', function () {
            react_dom_1.default.unmountComponentAtNode(element[0]);
            component = null;
        });
        // re-render on items changes
        scope.$watchCollection('vocabulary.items', function (items) {
            if (items && component) {
                validateItems(items);
                component.setState({ items: items, itemsValidation: itemsValidation });
            }
        });
    },
}); };
exports.VocabularyConfigModalItems.$inject = [];


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ObjectEditor_1 = __importDefault(__webpack_require__(1898));
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var ItemsTableComponent = /** @class */ (function (_super) {
    __extends(ItemsTableComponent, _super);
    function ItemsTableComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { items: [], itemsValidation: [], caretPosition: '', targetInput: '' };
        return _this;
    }
    ItemsTableComponent.prototype.componentDidUpdate = function () {
        var _a = this.state, targetInput = _a.targetInput, caretPosition = _a.caretPosition;
        if (caretPosition != null) {
            this.setCaretPosition(targetInput, caretPosition);
        }
    };
    ItemsTableComponent.prototype.getModelKeys = function () {
        var model = this.props.model;
        return Object.keys(model)
            .filter(function (key) { return key !== 'is_active'; })
            .map(function (key) { return (react_1.default.createElement("th", { key: key },
            react_1.default.createElement("label", null, utils_1.gettext(key)))); });
    };
    ItemsTableComponent.prototype.getSchemaKeys = function () {
        var schemaFields = this.props.schemaFields;
        return schemaFields.map(function (field) { return (react_1.default.createElement("th", { key: field.key },
            react_1.default.createElement("label", null, field.label || utils_1.gettext(field.key)))); });
    };
    ItemsTableComponent.prototype.header = function () {
        var schema = this.props.schema;
        var fields = schema ? this.getSchemaKeys() : this.getModelKeys();
        fields.push(react_1.default.createElement("th", { key: "is_active" },
            react_1.default.createElement("label", null, utils_1.gettext('Active'))));
        fields.push(react_1.default.createElement("th", { key: '' }));
        return react_1.default.createElement("tr", null, fields);
    };
    ItemsTableComponent.prototype.setCaretPosition = function (ctrl, pos) {
        if (ctrl.setSelectionRange) {
            ctrl.focus();
            ctrl.setSelectionRange(pos, pos);
        }
    };
    ItemsTableComponent.prototype.inputField = function (field, item, index) {
        var _this = this;
        var value = item[field.key] || '';
        var disabled = !item.is_active;
        var update = function (event) {
            var _value = field.type === 'integer' ? parseInt(event.target.value, 10) : event.target.value;
            var caretPosition = event.target.selectionStart;
            var targetInput = event.target;
            _this.setState({ targetInput: targetInput, caretPosition: caretPosition });
            _this.props.update(item, field.key, _value);
        };
        var required = this.state.itemsValidation.length && lodash_1.has(this.state.itemsValidation[index], field.key);
        var valid = !required || this.state.itemsValidation[index][field.key];
        var className = 'sd-line-input sd-line-input--no-margin sd-line-input--no-label sd-line-input--boxed';
        if (required) {
            className += ' sd-line-input--required';
        }
        if (!valid) {
            className += ' sd-line-input--invalid';
        }
        switch (field.type) {
            case 'bool':
                return (react_1.default.createElement("input", { type: "checkbox", checked: !!value, disabled: disabled, onChange: function (event) { return _this.props.update(item, field.key, !value); } }));
            case 'color':
                return (react_1.default.createElement("input", { type: "color", value: value, disabled: disabled, onChange: update }));
            case 'short':
                return (react_1.default.createElement("input", { type: "text", value: value, disabled: disabled, onChange: update }));
            case 'object': {
                return (react_1.default.createElement(ObjectEditor_1.default, { value: value, disabled: disabled, onChange: function (_value) { return _this.props.update(item, field.key, _value); } }));
            }
            case 'integer':
                return (react_1.default.createElement("div", { className: className },
                    react_1.default.createElement("input", { type: "number", value: value, disabled: disabled, onChange: update, className: field.key === 'name' ? 'long-name sd-line-input__input' : 'sd-line-input__input' })));
            default:
                return (react_1.default.createElement("div", { className: className },
                    react_1.default.createElement("input", { type: "text", value: value, disabled: disabled, onChange: update, className: field.key === 'name' ? 'long-name sd-line-input__input' : 'sd-line-input__input' })));
        }
    };
    ItemsTableComponent.prototype.modelItem = function (item, keys) {
        var _this = this;
        return keys.map(function (key) { return (react_1.default.createElement("td", { key: key }, _this.inputField({ key: key, type: key }, item))); });
    };
    ItemsTableComponent.prototype.modelBody = function () {
        var _this = this;
        var model = this.props.model;
        var keys = Object.keys(model).filter(function (key) { return key !== 'is_active'; });
        var removeDisabled = !this.props.schema && this.state.items.length <= 1;
        return this.state.items.map(function (item, index) { return (react_1.default.createElement("tr", { key: index },
            _this.modelItem(item, keys),
            _this.toggleActiveButton(item),
            _this.removeItemButton(index, removeDisabled))); });
    };
    ItemsTableComponent.prototype.schemaBody = function () {
        var _this = this;
        var schemaFields = this.props.schemaFields;
        return this.state.items.map(function (item, index) { return (react_1.default.createElement("tr", { key: index },
            schemaFields.map(function (field) { return (react_1.default.createElement("td", { key: field.key }, _this.inputField(field, item, index))); }),
            _this.toggleActiveButton(item),
            _this.removeItemButton(index))); });
    };
    ItemsTableComponent.prototype.toggleActiveButton = function (item) {
        var _this = this;
        return (react_1.default.createElement("td", null,
            react_1.default.createElement("span", { className: "vocabularyStatus" },
                react_1.default.createElement("input", { type: "checkbox", checked: !!item.is_active, onChange: function () { return _this.props.update(item, 'is_active', !item.is_active); } }))));
    };
    ItemsTableComponent.prototype.removeItemButton = function (index, disabled) {
        var _this = this;
        return (react_1.default.createElement("td", null,
            react_1.default.createElement("button", { className: "icn-btn", disabled: !!disabled, onClick: function () { return _this.props.remove(index); } },
                react_1.default.createElement("i", { className: "icon-close-small" }))));
    };
    ItemsTableComponent.prototype.body = function () {
        return this.props.schema ? this.schemaBody() : this.modelBody();
    };
    ItemsTableComponent.prototype.render = function () {
        return (react_1.default.createElement("table", null,
            react_1.default.createElement("thead", null, this.header()),
            react_1.default.createElement("tbody", null, this.body())));
    };
    return ItemsTableComponent;
}(react_1.default.Component));
exports.default = ItemsTableComponent;
ItemsTableComponent.propTypes = {
    model: prop_types_1.default.object,
    schema: prop_types_1.default.object,
    schemaFields: prop_types_1.default.array,
    update: prop_types_1.default.func.isRequired,
    remove: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var ObjectEditor = /** @class */ (function (_super) {
    __extends(ObjectEditor, _super);
    function ObjectEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { value: angular.toJson(props.value || {}, 2) };
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    ObjectEditor.prototype.onChange = function (event) {
        this.setState({ value: event.target.value });
        try {
            var parsed = angular.fromJson(event.target.value);
            this.props.onChange(parsed);
        }
        catch (err) {
            // pass
        }
    };
    ObjectEditor.prototype.render = function () {
        var lines = this.state.value.split('\n').length;
        return (react_1.default.createElement("textarea", { rows: lines, cols: 30, value: this.state.value, disabled: this.props.disabled, onChange: this.onChange }));
    };
    return ObjectEditor;
}(react_1.default.Component));
exports.default = ObjectEditor;
ObjectEditor.propTypes = {
    value: prop_types_1.default.object,
    disabled: prop_types_1.default.bool,
    onChange: prop_types_1.default.func.isRequired,
};


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1900);
__webpack_require__(1902);
__webpack_require__(1904);
var lodash_1 = __webpack_require__(2);
// scripts
__webpack_require__(1906);
var directive = __importStar(__webpack_require__(1907));
var svc = __importStar(__webpack_require__(1939));
var ctrl = __importStar(__webpack_require__(574));
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.archive.directives', [
    'superdesk.core.filters',
    'superdesk.apps.authoring',
    'superdesk.apps.ingest',
    'superdesk.core.workflow',
])
    .directive('sdItemLock', directive.ItemLock)
    .directive('sdItemState', directive.ItemState)
    .directive('sdInlineMeta', directive.InlineMeta)
    .directive('sdMediaPreview', directive.MediaPreview)
    .directive('sdMediaPreviewWidget', directive.MediaPreviewWidget)
    .directive('sdItemPreviewContainer', directive.ItemPreviewContainer)
    .directive('sdMediaView', directive.MediaView)
    .directive('sdMediaMetadata', directive.MediaMetadata)
    .directive('sdMediaRelated', directive.MediaRelated)
    .directive('sdFetchedDesks', directive.FetchedDesks)
    .directive('sdMetaIngest', directive.MetaIngest)
    .directive('sdSingleItem', directive.SingleItem)
    .directive('sdDraggableItem', directive.DraggableItem)
    .directive('sdItemCrops', directive.ItemCrops)
    .directive('sdItemRendition', directive.ItemRendition)
    .directive('sdRatioCalc', directive.RatioCalc)
    .directive('sdHtmlPreview', directive.HtmlPreview)
    .directive('sdProviderMenu', directive.ProviderMenu)
    .directive('sdContentResults', directive.ContentResults)
    .directive('sdArchivedItemKill', directive.ArchivedItemKill)
    .directive('sdResendItem', directive.ResendItem)
    .directive('sdItemPriority', directive.ItemPriority)
    .directive('sdItemUrgency', directive.ItemUrgency)
    .directive('sdMarkedItemTitle', directive.MarkedItemTitle)
    .directive('sdExport', directive.Export)
    .directive('sdAssociatedItemMetadata', directive.AssociatedItemMetadata)
    .directive('sdMediaUsed', directive.MediaUsed)
    .directive('sdPackageItemLabelsDropdown', directive.PackageItemLabelsDropdown)
    .directive('sdAssignmentIcon', directive.AssignmentIcon)
    .service('familyService', svc.FamilyService)
    .service('dragitem', svc.DragItemService);
/**
 * @ngdoc module
 * @module superdesk.apps.archive
 * @name superdesk.apps.archive
 * @packageName superdesk.apps
 * @description Superdesk archive specific application.
 */
angular.module('superdesk.apps.archive', [
    'superdesk.apps.search',
    'superdesk.apps.archive.directives',
    'superdesk.apps.dashboard',
    'superdesk.apps.dashboard.widgets.base',
    'superdesk.apps.dashboard.widgets.relatedItem',
    'superdesk.apps.workspace.menu',
])
    .service('spike', svc.SpikeService)
    .service('multi', svc.MultiService)
    .service('archiveService', svc.ArchiveService)
    .controller('UploadController', ctrl.UploadController)
    .controller('UploadAttachmentsController', ctrl.UploadAttachmentsController)
    .controller('ArchiveListController', ctrl.ArchiveListController)
    .config(['superdeskProvider', 'workspaceMenuProvider', function (superdesk, workspaceMenuProvider) {
        superdesk
            .activity('/workspace/content', {
            label: utils_1.gettext('Workspace'),
            priority: 100,
            controller: 'ArchiveListController',
            templateUrl: 'scripts/apps/archive/views/list.html',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            filters: [
                { action: 'view', type: 'content' },
            ],
            privileges: { archive: 1 },
        })
            .activity('upload.media', {
            label: utils_1.gettext('Upload media'),
            modal: true,
            cssClass: 'upload-media modal--fullscreen modal--dark-ui',
            controller: ctrl.UploadController,
            templateUrl: 'scripts/apps/archive/views/upload.html',
            filters: [
                { action: 'upload', type: 'media' },
            ],
            additionalCondition: ['$location', function ($location) {
                    return $location.path() !== '/planning';
                }],
            privileges: { archive: 1 },
        })
            .activity('upload.attachments', {
            label: utils_1.gettext('Attach files'),
            modal: true,
            cssClass: 'upload-media edit-attachments modal--z-index-fix modal--fill',
            controller: ctrl.UploadAttachmentsController,
            templateUrl: 'scripts/apps/archive/views/upload-attachments.html',
            filters: [
                { action: 'upload', type: 'attachments' },
            ],
            privileges: { archive: 1 },
        })
            .activity('spike', {
            label: utils_1.gettext('Spike Item'),
            icon: 'trash',
            monitor: true,
            controller: spikeActivity,
            filters: [{ action: 'list', type: 'archive' }],
            action: 'spike',
            keyboardShortcut: 'ctrl+shift+#',
            additionalCondition: ['session', 'authoring', 'item', function (session, authoring, item) {
                    return authoring.itemActions(item).spike &&
                        (item.lock_user === null || angular.isUndefined(item.lock_user) ||
                            item.lock_user === session.identity._id);
                }],
        })
            .activity('unspike', {
            label: utils_1.gettext('Unspike Item'),
            icon: 'unspike',
            monitor: true,
            controller: ['spike', 'data', '$rootScope', function unspikeActivity(spike, data, $rootScope) {
                    return spike.unspike(data.item).then(function (item) {
                        $rootScope.$broadcast('item:unspike');
                        return item;
                    });
                }],
            filters: [{ action: 'list', type: 'spike' }],
            action: 'unspike',
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).unspike;
                }],
        })
            .activity('duplicateInPlace', {
            label: utils_1.gettext('Duplicate in place'),
            icon: 'copy',
            monitor: true,
            controller: ctrl.DuplicateController,
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'list', type: 'archived' },
            ],
            keyboardShortcut: 'ctrl+alt+d',
            privileges: { duplicate: 1 },
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).duplicate &&
                        (item.state !== 'killed' || item.state !== 'recalled');
                }],
            group: 'duplicate',
            groupLabel: utils_1.gettext('Duplicate'),
            groupIcon: 'copy',
        })
            .activity('duplicateTo', {
            label: utils_1.gettext('Duplicate To'),
            icon: 'copy',
            monitor: true,
            controller: ['data', 'send', function (data, send) {
                    return send.allAs([data.item], 'duplicateTo');
                }],
            filters: [
                { action: 'list', type: 'archive' },
                { action: 'list', type: 'archived' },
            ],
            keyboardShortcut: 'ctrl+alt+r',
            privileges: { duplicate: 1 },
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return (item.state !== 'killed' || item.state !== 'recalled') &&
                        !authoring.isContentApiItem(item) && authoring.itemActions(item).duplicate;
                }],
            group: 'duplicate',
            groupLabel: utils_1.gettext('Duplicate'),
            groupIcon: 'copy',
        })
            .activity('label', {
            label: utils_1.gettext('Set label in current package'),
            priority: 30,
            icon: 'label',
            monitor: true,
            list: false,
            keyboardShortcut: 'ctrl+alt+l',
            filters: [{ action: 'list', type: 'archive' }],
            group: 'labels',
            dropdown: true,
            templateUrl: 'scripts/apps/archive/views/package_item_labels_dropdown.html',
            additionalCondition: ['authoring', 'item', 'vocabularies', 'authoringWorkspace', 'packages',
                function (authoring, item, vocabularies, authoringWorkspace, packages) {
                    var openedItem = authoringWorkspace.getItem();
                    return (item.state !== 'killed' || item.state !== 'recalled') &&
                        !authoring.isContentApiItem(item) && authoring.itemActions(item).set_label &&
                        openedItem && openedItem.type === 'composite' &&
                        packages.isAdded(openedItem, item) && vocabularies.isInit();
                }],
        })
            .activity('createBroadcast', {
            label: utils_1.gettext('Create Broadcast'),
            icon: 'broadcast',
            monitor: true,
            controller: ['api', 'notify', '$rootScope', 'data', 'desks', 'authoringWorkspace',
                function (api, notify, $rootScope, data, desks, authoringWorkspace) {
                    api.save('archive_broadcast', {}, { desk: desks.getCurrentDeskId() }, data.item)
                        .then(function (broadcastItem) {
                        authoringWorkspace.edit(broadcastItem);
                        $rootScope.$broadcast('broadcast:created', { item: data.item });
                    });
                }],
            filters: [{ action: 'list', type: 'archive' }],
            keyboardShortcut: 'ctrl+b',
            privileges: { archive_broadcast: 1 },
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).create_broadcast;
                }],
        })
            .activity('copy', {
            label: utils_1.gettext('Copy'),
            icon: 'copy',
            monitor: true,
            controller: ['api', 'data', '$rootScope', function (api, data, $rootScope) {
                    return api.save('copy', {}, {}, data.item)
                        .then(function (archiveItem) {
                        data.item.task_id = archiveItem.task_id;
                        data.item.created = archiveItem._created;
                        $rootScope.$broadcast('item:copy');
                    }, function (response) {
                        data.item.error = response;
                    })
                        .finally(function () {
                        if (data.item.actioning) {
                            data.item.actioning.archiveContent = false;
                        }
                    });
                }],
            filters: [{ action: 'list', type: 'archive' }],
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).copy;
                }],
        })
            .activity('resend', {
            label: utils_1.gettext('Resend item'),
            priority: 100,
            icon: 'share-alt',
            group: 'corrections',
            controller: ['data', '$rootScope', function (data, $rootScope) {
                    $rootScope.$broadcast('open:resend', data.item);
                }],
            filters: [{ action: 'list', type: 'archive' }],
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).resend;
                }],
            privileges: { resend: 1 },
        })
            .activity('rewrite', {
            label: utils_1.gettext('Update'),
            icon: 'edit-line',
            filters: [{ action: 'list', type: 'archive' }],
            group: 'corrections',
            privileges: { rewrite: 1 },
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).re_write;
                }],
            controller: ['data', 'authoring', function (data, authoring) {
                    authoring.rewrite(data.item);
                }],
        })
            .activity('unlinkRewrite', {
            label: utils_1.gettext('Unlink update'),
            icon: 'remove-sign',
            filters: [{ action: 'list', type: 'archive' }],
            group: 'corrections',
            privileges: { rewrite: 1 },
            condition: function (item) {
                return item.lock_user === null || angular.isUndefined(item.lock_user);
            },
            additionalCondition: ['authoring', 'item', function (authoring, item) {
                    return authoring.itemActions(item).unlinkUpdate;
                }],
            controller: ['data', 'authoring', function (data, authoring) {
                    authoring.unlink(data.item);
                }],
        })
            .activity('export', {
            label: utils_1.gettext('Export'),
            icon: 'download',
            templateUrl: 'scripts/apps/archive/views/export-dropdown.html',
            filters: [{ action: 'list', type: 'archive' }],
            privileges: { content_export: 1 },
            additionalCondition: ['config', 'session', 'authoring', 'item',
                function (config, session, authoring, item) {
                    var lockCond = item.lock_user === null || angular.isUndefined(item.lock_user) ||
                        item.lock_user === session.identity._id;
                    return lockCond && authoring.itemActions(item).export;
                }],
            modal: true,
            cssClass: 'modal-responsive',
            controller: ['$scope', function ($scope) {
                    $scope.export = true;
                    $scope.item = $scope.locals.data.item;
                    $scope.closeExport = function () {
                        $scope.export = false;
                        $scope.reject();
                    };
                }],
        });
        workspaceMenuProvider.item({
            href: '/workspace/content',
            label: utils_1.gettext('Content'),
            icon: 'archive',
            if: 'workspaceConfig.content && privileges.archive',
            order: 700,
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('copy', {
            type: 'http',
            backend: {
                rel: 'copy',
            },
        });
        apiProvider.api('duplicate', {
            type: 'http',
            backend: {
                rel: 'duplicate',
            },
        });
        apiProvider.api('notification', {
            type: 'http',
            backend: {
                rel: 'notification',
            },
        });
        apiProvider.api('archive', {
            type: 'http',
            backend: {
                rel: 'archive',
            },
        });
        apiProvider.api('archive_rewrite', {
            type: 'http',
            backend: {
                rel: 'archive_rewrite',
            },
        });
    }]);
spikeActivity.$inject = [
    'spike',
    'data',
    'modal',
    '$location',
    '$q',
    'multi',
    'privileges',
    'authoringWorkspace',
    'confirm',
    'autosave',
    'config',
];
function spikeActivity(spike, data, modal, $location, $q, multi, privileges, authoringWorkspace, confirm, autosave, config) {
    // For the sake of keyboard shortcut to work consistently,
    // if the item is multi-selected, let multibar controller handle its spike
    if (!data.item || multi.count > 0 && lodash_1.includes(multi.getIds(), data.item._id)) {
        return;
    }
    if (data.item.lock_user) { // current user has the lock
        return autosave.get(data.item)
            .then(function () { return confirm.reopen(); })
            .then(function () { return authoringWorkspace.edit(data.item); })
            .catch(_spike);
    }
    _spike();
    function _spike() {
        var message = utils_1.gettext('Are you sure you want to spike the item?');
        if ($location.path() === '/workspace/personal') {
            message = utils_1.gettext('Do you want to delete the item permanently?');
        }
        else if (lodash_1.get(privileges, 'privileges.planning') && data.item && data.item.assignment_id) {
            message = utils_1.gettext('This item is linked to in-progress planning coverage, spike anyway?');
        }
        else if (!lodash_1.get(config, 'confirm_spike', true)) {
            return spike.spike(data.item);
        }
        return modal.confirm(message, utils_1.gettext('Confirm'))
            .then(function () { return spike.spike(data.item); });
    }
}


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1901);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./related-item.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./related-item.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.related-item-list .relate-item-label {\n  border-radius: 6px;\n  width: 15px;\n  height: 15px;\n  color: #fff;\n  text-align: center;\n  padding: 2px 3px 2px; }\n  .related-item-list .relate-item-label.update-item {\n    background-color: #46a546; }\n  .related-item-list .relate-item-label.take-item {\n    background-color: #0064cd; }\n", ""]);

// exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1903);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./assignment.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./assignment.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, ".item-info .assignment-icon, .preview-header__flex-row .assignment-icon {\n  margin: 0 0.5rem; }\n\n.subnav__authoring-topbar .assignment-icon {\n  vertical-align: sub; }\n", ""]);

// exports


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1905);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./html-preview.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./html-preview.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "/*was 65*/\n.html-preview .annotation-text {\n  border-bottom: 1px dotted; }\n\nsup.annotation-id {\n  color: #5ea9c8; }\n\n.annotations {\n  margin-top: 1em; }\n  .annotations .annotation-body p {\n    display: inline; }\n  .annotations .simple-list {\n    list-style: none;\n    padding: 0; }\n", ""]);

// exports


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.dashboard.widgets.relatedItem', [
    'superdesk.apps.dashboard.widgets.base',
    'superdesk.apps.authoring.widgets',
])
    .controller('relatedItemController', RelatedItemController)
    .config(['authoringWidgetsProvider', function (authoringWidgets) {
        authoringWidgets.widget('related-item', {
            label: utils_1.gettext('Related Items'),
            icon: 'related',
            template: 'scripts/apps/archive/related-item-widget/widget-relatedItem.html',
            order: 7,
            side: 'right',
            display: {
                authoring: true,
                packages: false,
                killedItem: true,
                legalArchive: false,
                archived: false,
                picture: false,
                personal: false,
            },
            isWidgetVisible: function (item) { return ['content', function (content) {
                    if (item.profile == null) {
                        return Promise.resolve(true);
                    }
                    return new Promise(function (resolve) {
                        content.getType(item.profile).then(function (type) {
                            resolve(type.schema.hasOwnProperty('slugline'));
                        });
                    });
                }]; },
            configurationTemplate: 'scripts/apps/archive/related-item-widget/relatedItem-configuration.html',
            configurable: false,
            needEditable: true,
            needUnlock: true,
            configuration: {
                sluglineMatch: 'EXACT',
                modificationDateAfter: 'today',
            },
        });
    }]);
RelatedItemController.$inject = [
    '$scope',
    'api',
    'BaseWidgetController',
    'notify',
    'superdesk',
    '$q',
    'authoringWorkspace',
    'authoring',
    'privileges',
    'config',
    'storage',
    'familyService',
    'moment',
    'content',
];
function RelatedItemController($scope, api, BaseWidgetController, notify, superdesk, $q, authoringWorkspace, authoring, privileges, config, storage, familyService, moment, content) {
    $scope.type = 'archiveWidget';
    $scope.itemListOptions = {
        endpoint: 'search',
        repo: ['archive', 'published'],
        notStates: ['spiked'],
        types: ['text', 'composite'],
        page: 1,
        modificationDateAfter: storage.getItem('modificationDateAfter') === 'today' ? today() :
            storage.getItem('modificationDateAfter') || today(),
        sluglineMatch: storage.getItem('sluglineMatch') || 'EXACT',
    };
    $scope.options = {
        pinEnabled: true,
        modeEnabled: true,
        itemTypeEnabled: true,
        mode: 'basic',
        pinMode: 'archive',
        related: true,
        itemTypes: ['text', 'composite'],
        sort: [{ versioncreated: 'desc' }],
    };
    $scope.loading = true;
    familyService.fetchRelatedItems($scope.item)
        .then(function (items) {
        if (items && items._items && items._items.length > 1) {
            $scope.options.existingRelations = items._items;
            $scope.widget.configurable = false;
            $scope.options.searchEnabled = false;
            $scope.widget.label = utils_1.gettext('Related Items');
        }
        else {
            $scope.options.existingRelations = false;
            $scope.widget.configurable = true;
            $scope.options.searchEnabled = true;
            $scope.widget.label = utils_1.gettext('Relate an item');
        }
    })
        .finally(function () {
        $scope.loading = false;
    });
    function today() {
        if (config.search && config.search.useDefaultTimezone) {
            return moment()
                .tz(config.defaultTimezone)
                .format('YYYY-MM-DD') + 'T00:00:00' + moment.tz(config.defaultTimezone).format('ZZ');
        }
        return moment().format('YYYY-MM-DD') + 'T00:00:00' + moment().format('ZZ');
    }
    /**
     * Copies the field values from source object to destination
     * if destination has a content profile then copies fields
     * defined in the content profile only
     */
    var copyMetadata = function (source, destination) {
        var fields = ['subject', 'anpa_category', 'headline',
            'urgency', 'priority', 'slugline', 'place'];
        destination.related_to = source._id;
        if (destination.profile) {
            return content.getType(destination.profile).then(function (type) {
                fields.forEach(function (field) {
                    if (type.schema.hasOwnProperty(field)) {
                        destination[field] = source[field];
                    }
                });
                return $q.when(destination);
            });
        }
        fields.forEach(function (field) {
            destination[field] = source[field];
        });
        return $q.when(destination);
    };
    $scope.actions = {
        apply: {
            title: 'Associate metadata',
            method: function (item) {
                $scope.origItem = $scope.options.item;
                copyMetadata(item, {}).then(function (copied) { return api.save('archive', $scope.origItem, copied)
                    .then(function () {
                    Object.assign($scope.options.item, copied);
                    notify.success(utils_1.gettext('item metadata associated.'));
                    return item;
                }); });
            },
            class: 'open',
            icon: 'icon-expand',
            condition: function (item) {
                return item.type !== 'composite';
            },
        },
        update: {
            title: 'Associate as update',
            method: function (item) {
                api.save('archive_rewrite', {}, { update: angular.extend({}, $scope.origItem, $scope.item) }, item)
                    .then(function (newItem) {
                    notify.success(utils_1.gettext('Story is associated as update.'));
                    authoringWorkspace.edit(newItem);
                }, function (response) {
                    if (angular.isDefined(response.data._message)) {
                        notify.error(utils_1.gettext('Failed to associate update: {{message}}', { message: response.data._message }));
                    }
                    else {
                        notify.error(utils_1.gettext('There is an error. Failed to associate update.'));
                    }
                });
            },
            class: 'open',
            icon: 'icon-expand',
            condition: function (item) {
                var userHasPermission = privileges.userHasPrivileges({ rewrite: 1 });
                var canBeRewrite = !authoring.isPublished($scope.item) &&
                    $scope.item.type === 'text' &&
                    !$scope.item.rewrite_of && (!$scope.item.broadcast || !$scope.item.broadcast.master_id);
                var canBeRewritten = authoring.itemActions(item).re_write;
                return canBeRewritten && canBeRewrite && userHasPermission;
            },
        },
        open: {
            title: 'Open',
            method: function (item) {
                $q.when(superdesk.intent('edit', 'item', item)).then(null, function (value) {
                    superdesk.intent('view', 'item', item);
                });
            },
            class: 'open',
            icon: 'icon-external',
            condition: function (item) {
                return true;
            },
        },
    };
    BaseWidgetController.call(this, $scope);
    $scope.$watch('widget.configuration', function (_config) {
        if (_config && _config.sluglineMatch && _config.sluglineMatch !== $scope.itemListOptions.sluglineMatch) {
            $scope.itemListOptions.sluglineMatch = _config.sluglineMatch;
        }
        if (_config && _config.modificationDateAfter &&
            _config.modificationDateAfter !== $scope.itemListOptions.modificationDateAfter) {
            if (_config.modificationDateAfter === 'today') {
                $scope.itemListOptions.modificationDateAfter = today();
            }
            else {
                $scope.itemListOptions.modificationDateAfter = _config.modificationDateAfter;
            }
        }
    }, true);
    function reset() {
        if ($scope.widget && $scope.widget.configuration) {
            $scope.widget.configuration.modificationDateAfter = storage.getItem('modificationDateAfter') || 'today';
            $scope.widget.configuration.sluglineMatch = storage.getItem('sluglineMatch') || 'EXACT';
        }
    }
    if ($scope.widget) {
        $scope.widget.save = function () {
            storage.setItem('sluglineMatch', $scope.widget.configuration.sluglineMatch);
            storage.setItem('modificationDateAfter', $scope.widget.configuration.modificationDateAfter);
        };
    }
    reset();
}


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ItemLock_1 = __webpack_require__(1908);
exports.ItemLock = ItemLock_1.ItemLock;
var ItemState_1 = __webpack_require__(1909);
exports.ItemState = ItemState_1.ItemState;
var InlineMeta_1 = __webpack_require__(1910);
exports.InlineMeta = InlineMeta_1.InlineMeta;
var MediaPreview_1 = __webpack_require__(1911);
exports.MediaPreview = MediaPreview_1.MediaPreview;
exports.MediaPreviewWidget = MediaPreview_1.MediaPreviewWidget;
var ItemPreviewContainer_1 = __webpack_require__(1913);
exports.ItemPreviewContainer = ItemPreviewContainer_1.ItemPreviewContainer;
var MediaView_1 = __webpack_require__(1914);
exports.MediaView = MediaView_1.MediaView;
var MediaMetadata_1 = __webpack_require__(1915);
exports.MediaMetadata = MediaMetadata_1.MediaMetadata;
var MediaRelated_1 = __webpack_require__(1916);
exports.MediaRelated = MediaRelated_1.MediaRelated;
var FetchedDesks_1 = __webpack_require__(1917);
exports.FetchedDesks = FetchedDesks_1.FetchedDesks;
var MetaIngest_1 = __webpack_require__(1918);
exports.MetaIngest = MetaIngest_1.MetaIngest;
var SingleItem_1 = __webpack_require__(1919);
exports.SingleItem = SingleItem_1.SingleItem;
var DraggableItem_1 = __webpack_require__(1920);
exports.DraggableItem = DraggableItem_1.DraggableItem;
var ItemCrops_1 = __webpack_require__(1921);
exports.ItemCrops = ItemCrops_1.ItemCrops;
var ItemRendition_1 = __webpack_require__(1922);
exports.ItemRendition = ItemRendition_1.ItemRendition;
var RatioCalc_1 = __webpack_require__(1923);
exports.RatioCalc = RatioCalc_1.RatioCalc;
var HtmlPreview_1 = __webpack_require__(1924);
exports.HtmlPreview = HtmlPreview_1.HtmlPreview;
var ProviderMenu_1 = __webpack_require__(1925);
exports.ProviderMenu = ProviderMenu_1.ProviderMenu;
var ContentResults_1 = __webpack_require__(1926);
exports.ContentResults = ContentResults_1.ContentResults;
var ArchivedItemKill_1 = __webpack_require__(1927);
exports.ArchivedItemKill = ArchivedItemKill_1.ArchivedItemKill;
var ResendItem_1 = __webpack_require__(1928);
exports.ResendItem = ResendItem_1.ResendItem;
var ItemPriority_1 = __webpack_require__(1929);
exports.ItemPriority = ItemPriority_1.ItemPriority;
var ItemUrgency_1 = __webpack_require__(1930);
exports.ItemUrgency = ItemUrgency_1.ItemUrgency;
var MarkedItemTitle_1 = __webpack_require__(1931);
exports.MarkedItemTitle = MarkedItemTitle_1.MarkedItemTitle;
var Export_1 = __webpack_require__(1933);
exports.Export = Export_1.Export;
var AssociatedItemMetadata_1 = __webpack_require__(1934);
exports.AssociatedItemMetadata = AssociatedItemMetadata_1.AssociatedItemMetadata;
var MediaUsed_1 = __webpack_require__(1935);
exports.MediaUsed = MediaUsed_1.MediaUsed;
var PackageItemLabelsDropdown_1 = __webpack_require__(1937);
exports.PackageItemLabelsDropdown = PackageItemLabelsDropdown_1.PackageItemLabelsDropdown;
var AssignmentIcon_1 = __webpack_require__(1938);
exports.AssignmentIcon = AssignmentIcon_1.AssignmentIcon;


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
ItemLock.$inject = ['api', 'lock', 'privileges', 'desks'];
function ItemLock(api, lock, privileges, desks) {
    return {
        templateUrl: 'scripts/apps/archive/views/item-lock.html',
        scope: { item: '=' },
        link: function (scope) {
            init();
            scope.$watch('item.lock_session', function () {
                init();
                if (scope.item && lock.isLocked(scope.item)) {
                    api('users').getById(scope.item.lock_user)
                        .then(function (user) {
                        scope.lock.user = user;
                        scope.lock.lockbyme = lock.isLockedByMe(scope.item);
                    });
                }
            });
            function init() {
                scope.privileges = privileges.privileges;
                scope.lock = { user: null, lockbyme: false };
            }
            scope.unlock = function () {
                lock.previewUnlock = true;
                lock.unlock(scope.item).then(function () {
                    scope.item.lock_user = null;
                    scope.item.lock_session = null;
                    scope.lock = null;
                    scope.isLocked = false;
                });
            };
            scope.can_unlock = function () {
                if (lock.can_unlock(scope.item)) {
                    if (scope.item.task && scope.item.task.desk && desks.userDesks) {
                        return lodash_1.default.find(desks.userDesks, { _id: scope.item.task.desk });
                    }
                    return true;
                }
                return false;
            };
            scope.$on('item:lock', function (_e, data) {
                if (scope.item && scope.item._id === data.item) {
                    scope.item.lock_user = data.user;
                    scope.item.lock_time = data.lock_time;
                    scope.item.lock_session = data.lock_session;
                    scope.$digest();
                }
            });
            scope.$on('item:unlock', function (_e, data) {
                if (scope.item && scope.item._id === data.item) {
                    scope.item.lock_user = null;
                    scope.item.lock_session = null;
                    scope.$digest();
                }
            });
        },
    };
}
exports.ItemLock = ItemLock;


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ItemState() {
    return {
        templateUrl: 'scripts/apps/archive/views/item-state.html',
        scope: {
            state: '=',
            embargo: '=',
        },
    };
}
exports.ItemState = ItemState;


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function InlineMeta() {
    return {
        templateUrl: 'scripts/apps/archive/views/inline-meta.html',
        scope: {
            placeholder: '@',
            showmeta: '=',
            item: '=',
            setmeta: '&',
        },
    };
}
exports.InlineMeta = InlineMeta;


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.archive
 * @name sdMediaPreview
 *
 * @requires api
 * @requires $rootScope
 * @requires desks
 * @requires superdesk
 * @requires content
 * @requires storage
 *
 * @description Renders the preview of the list item.
 *
 */
MediaPreview.$inject = ['api', '$rootScope', 'desks', 'superdesk', 'content', 'storage'];
function MediaPreview(api, $rootScope, desks, superdesk, content, storage) {
    return {
        template: __webpack_require__(1912),
        link: function (scope) {
            var PREVIEW_HEADER_STATE = 'item_preview:header_state';
            scope.previewState = { toggleHeader: false };
            if (scope.selected.preview.profile) {
                content.getType(scope.selected.preview.profile)
                    .then(function (type) {
                    scope.editor = content.editor(type);
                    scope.fields = content.fields(type);
                });
            }
            else {
                scope.editor = content.editor();
            }
            /**
             * @ngDoc method
             * @name sdMediaPreview#setPreviewState
             *
             * @description Set the preview header state
             */
            var setPreviewState = function (state) {
                scope.previewState = { toggleHeader: state };
                storage.setItem(PREVIEW_HEADER_STATE, state);
            };
            setPreviewState(storage.getItem(PREVIEW_HEADER_STATE) || false);
            /**
             * @ngDoc method
             * @name sdMediaPreview#previewRewriteStory
             *
             * @description Preview the rewrite story.
             */
            scope.previewRewriteStory = function () {
                return api.find('archive', scope.item.rewrite_id).then(function (item) {
                    $rootScope.$broadcast('broadcast:preview', { item: item });
                });
            };
            /**
             * @ngDoc method
             * @name sdMediaPreview#previewRewriteStory
             *
             * @description Preview the item (picture, story).
             */
            scope.preview = function (item) {
                superdesk.intent('preview', 'item', item);
            };
            /**
             * @ngDoc method
             * @name sdMediaPreview#togglePreviewHeader
             *
             * @description Toggle the preview header.
             */
            scope.togglePreviewHeader = function () {
                setPreviewState(!scope.previewState.toggleHeader);
            };
            /**
             * @ngDoc method
             * @name sdMediaPreview#getCompanyCodes
             *
             * @description Get company codes for the item
             */
            scope.getCompanyCodes = function () {
                return lodash_1.default.map(scope.item.company_codes, 'qcode').join(', ');
            };
            desks.initialize().then(function () {
                scope.userLookup = desks.userLookup;
            });
        },
    };
}
exports.MediaPreview = MediaPreview;
function MediaPreviewWidget() {
    return {
        scope: { item: '=' },
        templateUrl: 'scripts/apps/archive/views/item-preview.html',
    };
}
exports.MediaPreviewWidget = MediaPreviewWidget;


/***/ }),
/* 1912 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"content-container\">\n\n      <header class=\"preview-header\" ng-class=\"{active: previewState.toggleHeader}\">\n        <div class=\"preview-header__timestamp\" title=\"{{userLookup[selected.preview.original_creator].display_name || selected.preview.original_creator}}\">\n            <label translate>Created</label><time sd-datetime data-date=\"selected.preview.firstcreated\"></time>\n            <label ng-if=\"selected.preview.original_creator\" translate>by</label><b>{{userLookup[selected.preview.original_creator].display_name || selected.preview.original_creator}}</b>\n            <div ng-if=\"selected.preview.versioncreated\" class=\"preview-header__border-block\">\n                <label translate>Modified</label>\n                <time sd-datetime data-date=\"selected.preview.versioncreated\"></time>\n            </div>\n        </div>\n\n        <div class=\"preview-header__flex-container\">\n          <div class=\"preview-header__icon-block\">\n            <div class=\"preview-header__flex-row\">\n              <i class=\"filetype-icon-{{selected.preview.type }}\" title=\"{{'Article Type' | translate }}: {{selected.preview.type}}\"></i>\n            </div>\n            <div class=\"preview-header__flex-row\"\n              sd-item-priority data-priority=\"selected.preview.priority\"></div>\n            <div class=\"preview-header__flex-row\"\n              sd-item-urgency data-urgency=\"selected.preview.urgency\"></div>\n          </div>\n          <div class=\"preview-header__main-block\">\n            <div class=\"preview-header__flex-row\">\n              <span ng-if=\"selected.preview.slugline\" class=\"keyword\" title=\"{{selected.preview.slugline}}\" sd-html-preview=\"selected.preview.slugline\"></span>\n            </div>\n            <div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.anpa_take_key\">\n              <span class=\"inline-label\">takekey:</span><span class=\"takekey\">{{selected.preview.anpa_take_key | translate}}</span>\n            </div>\n            <div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.ednote\">\n              <span class=\"inline-label\">ednote:</span><span class=\"ednote\">{{selected.preview.ednote | translate}}</span>\n            </div>\n            <div class=\"preview-header__flex-row preview-header__flex-row--single-line\" ng-if=\"selected.preview.company_codes.length\">\n              <span class=\"inline-label\">company codes:</span><span class=\"company-codes\">{{getCompanyCodes()}}</span>\n            </div>\n            <div class=\"preview-header__flex-row\">\n              <span sd-item-state data-state=selected.preview.state data-embargo=item.embargo></span>\n              <span class=\"state-label not-for-publication\" ng-if=\"item.flags.marked_for_not_publication\" translate>Not For Publication</span>\n              <span class=\"state-label legal\" ng-if=\"selected.preview.flags.marked_for_legal\" translate>Legal</span>\n              <span class=\"state-label sms\" ng-if=\"selected.preview.flags.marked_for_sms\" translate>Sms</span>\n              <span class=\"state-label updated\" ng-if=\"selected.preview.rewritten_by\" translate>Updated</span>\n            </div>\n            <div class=\"preview-header__flex-row preview-header__flex-row--single-line\">\n              <span ng-if=\"item._type === 'archived'\" class=\"stage\" tooltip=\"{{:: 'Archived from' | translate}} {{deskName}} / {{ stage }}\" tooltip-placement=\"bottom\" ng-show=\"stage\"><b>{{:: 'Archived from' | translate}} {{deskName}}</b> / {{ stage }}</span>\n              <span ng-if=\"item._type !== 'archived'\" class=\"stage\" tooltip=\"{{deskName}} / {{ stage }}\" tooltip-placement=\"bottom\" ng-show=\"stage\"><b>{{deskName}}</b> / {{ stage }}</span>\n            </div>\n          </div>\n          <div class=\"preview-header__side-block\">\n            <div class=\"preview-header__flex-row\" ng-if=\"item.type === 'text'\">\n                <span class=\"word-count\"><b>{{ selected.preview.word_count || 0 }}</b> <span translate translate-n=\"selected.preview.word_count\" translate-plural=\"WORDS\">WORD</span></span>\n            </div>\n            <div class=\"preview-header__flex-row\">\n              <span class=\"data\">{{ item.source }}</span>\n            </div>\n            <div class=\"preview-header__flex-row\">\n              <div sd-highlights-info data-item=\"selected.preview\"></div>\n            </div>\n            <div class=\"preview-header__flex-row\" sd-assignment-icon data-item=\"item\" />\n          </div>\n        </div>\n\n        <button\n                class=\"preview-header__toggle\"\n                ng-class=\"{active: previewState.toggleHeader}\"\n                ng-click=\"togglePreviewHeader()\"\n                tabindex=\"-1\"><i class=\"icon-chevron-down-thin\"></i></button>\n      </header>\n\n        <div class=\"composite-nav\" ng-if=\"selected.preview.type === 'composite'\">\n          <i class=\"filetype-icon-large-composite\"></i>\n          <p class=\"title preview-headline\"\n             ng-if=\"selected.preview.headline\"\n             ng-class=\"{condensed: !lock}\" sd-html-preview=\"selected.preview.headline\"></p>\n        </div>\n\n        <div ng-hide=\"hideActions()\" class=\"action-menu\">\n            <div sd-item-actions-menu data-item=\"selected.preview\" data-active=\"selected.preview\"></div>\n        </div>\n\n        <div id=\"locked\" class=\"clearfix\" sd-item-lock data-item=\"selected.preview\"></div>\n\n        <div class=\"rewrite\" ng-if=\"selected.preview.rewrite_id\">{{ :: 'This story has been rewritten by: ' | translate }}<a ng-click=\"previewRewriteStory()\"\n            class=\"open-item\"><i class=\"icon-external\"></i></a></div>\n\n        <p class=\"title preview-headline\"\n           ng-if=\"selected.preview.headline && selected.preview.type !== 'composite'\"\n           ng-class=\"{condensed: !lock}\" sd-html-preview=\"selected.preview.headline\"></p>\n\n        <p class=\"nav-space\" ng-if=\"!selected.preview.headline && !lock\"></p>\n\n        <div class=\"core-content\">\n\n            <p ng-if=\"selected.preview.is_spiked\" class=\"alert alert-warning expires\">\n                <span translate>expires</span> <time sd-datetime data-date=\"selected.preview.expiry\"></time>\n            </p>\n\n            <!-- item rendition -->\n            <div ng-if=\"selected.preview.type === 'picture' || selected.preview.type === 'graphic'\" class=\"picture-preview\">\n                <div>\n                    <span translate>Original</span>\n                    <div sd-item-rendition data-item=\"selected.preview\" data-rendition=\"viewImage\" ng-click=\"preview(item);\"></div>\n                    <p class=\"nav-space description-text\" ng-if=\"selected.preview.headline !== selected.preview.description_text &&\n                      selected.preview.description_text\">{{selected.preview.description_text}}</p>\n                </div>\n            </div>\n\n            <div ng-if=\"selected.preview.associations.featuremedia\">\n                <div sd-item-rendition data-item=\"selected.preview.associations.featuremedia\" data-rendition=\"viewImage\"></div>\n                <p class=\"nav-space description-text\">{{selected.preview.associations.featuremedia.description_text}}</p>\n            </div>\n\n            <div ng-if=\"selected.preview.type === 'audio'\">\n                <audio controls=\"controls\" sd-sources data-renditions=\"selected.preview.renditions\"></audio>\n            </div>\n\n            <div ng-if=\"selected.preview.type === 'video'\">\n                <video controls=\"controls\" sd-sources data-renditions=\"selected.preview.renditions\"></video>\n            </div>\n\n            <div class=\"text abstract\" ng-show=\"selected.preview.abstract\" sd-html-preview=\"selected.preview.abstract\"></div>\n\n            <div class=\"text byline\" ng-show=\"selected.preview.byline\" sd-html-preview=\"selected.preview.byline\"></div>\n\n            <div class=\"text dateline\" ng-show=\"selected.preview.dateline\" sd-html-preview=\"selected.preview.dateline.text\"></div>\n\n            <div class=\"text body-text\" ng-show=\"selected.preview.body_html\" sd-html-preview=\"selected.preview.body_html\" item=\"selected.preview\"></div>\n\n            <div class=\"text body-footer\" ng-show=\"selected.preview.body_footer\" sd-html-preview=\"selected.preview.body_footer\" item=\"selected.preview\"></div>\n\n            <div class=\"text sign-off\" ng-show=\"selected.preview.sign_off\" sd-html-preview=\"selected.preview.sign_off\"></div>\n\n            <!-- custom date, text and url fields -->\n            <div ng-repeat=\"field in fields track by field._id\" order=\"{{editor[field._id].order}}\"\n              ng-if=\"selected.preview.extra[field._id] && (field.field_type === 'text' || field.field_type === 'date' || field.field_type === 'urls')\">\n\n              <div class=\"text body-text\" sd-short-date ng-if=\"field.field_type === 'date'\" data-date=\"selected.preview.extra[field._id]\"></div>\n\n              <div class=\"text body-text\" ng-if=\"field.field_type === 'text'\" sd-html-preview=\"selected.preview.extra[field._id]\"></div>\n              \n              <ul class=\"text body-text\" ng-if=\"field.field_type === 'urls'\">\n                <li ng-repeat=\"item in selected.preview.extra[field._id] track by $index\">{{item.url}}<br>\n                  <p class=\"nav-space description-text\">{{item.description}}</p>\n                </li>\n              </ul>\n            </div>\n\n            <div class=\"composite-preview\" ng-if=\"selected.preview.type === 'composite'\">\n                <div sd-package data-item=\"selected.preview\" data-setitem=\"openSingleItem(selected)\"></div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ItemPreviewContainer() {
    return {
        template: '<div ng-if="item" sd-media-view data-item="item" data-close="close()"></div>',
        scope: {},
        link: function (scope) {
            scope.item = null;
            scope.$on('intent:preview:item', function (event, intent) {
                scope.item = intent.data;
            });
            /**
             * Close lightbox
             */
            scope.close = function () {
                scope.item = null;
            };
        },
    };
}
exports.ItemPreviewContainer = ItemPreviewContainer;


/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
MediaView.$inject = ['keyboardManager', 'packages'];
function MediaView(keyboardManager, packages) {
    return {
        templateUrl: 'scripts/apps/archive/views/media-view.html',
        scope: {
            items: '=',
            item: '=',
            close: '&',
        },
        link: function (scope, elem) {
            var packageStack = [];
            scope.singleItem = null;
            scope.packageItem = null;
            scope.prevEnabled = true;
            scope.nextEnabled = true;
            var getIndex = function (item) {
                return lodash_1.default.findIndex(scope.items, { _id: item._id });
            };
            var setItem = function (item) {
                resetStack();
                scope.item = item;
                scope.openItem(item);
                var index = getIndex(scope.item);
                scope.prevEnabled = index > -1 && !!scope.items[index - 1];
                scope.nextEnabled = index > -1 && !!scope.items[index + 1];
            };
            scope.prev = function () {
                var index = getIndex(scope.item);
                if (index > 0) {
                    setItem(scope.items[index - 1]);
                }
            };
            scope.next = function () {
                var index = getIndex(scope.item);
                if (index !== -1 && index < scope.items.length - 1) {
                    setItem(scope.items[index + 1]);
                }
            };
            keyboardManager.push('left', scope.prev);
            keyboardManager.push('right', scope.next);
            scope.$on('$destroy', function () {
                keyboardManager.pop('left');
                keyboardManager.pop('right');
            });
            scope.setPackageSingle = function (packageItem) {
                packages.fetchItem(packageItem).then(function (item) {
                    scope.openItem(item);
                });
            };
            scope.openItem = function (item) {
                if (item.type === 'composite') {
                    packageStack.push(item);
                    pickPackageItem();
                }
                scope.setSingleItem(item);
            };
            scope.setSingleItem = function (item) {
                scope.singleItem = item;
            };
            scope.nested = function () {
                return packageStack.length > 1;
            };
            scope.previousPackage = function () {
                lodash_1.default.remove(packageStack, lodash_1.default.last(packageStack));
                pickPackageItem();
                scope.setSingleItem(scope.packageItem);
            };
            var pickPackageItem = function () {
                scope.packageItem = lodash_1.default.last(packageStack) || null;
            };
            var resetStack = function () {
                packageStack = [];
                scope.packageItem = null;
            };
            setItem(scope.item);
        },
    };
}
exports.MediaView = MediaView;


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
MediaMetadata.$inject = ['userList', 'archiveService', 'metadata'];
function MediaMetadata(userList, archiveService, metadata) {
    return {
        scope: {
            item: '=',
        },
        templateUrl: 'scripts/apps/archive/views/metadata-view.html',
        link: function (scope, elem) {
            scope.$watch('item', reloadData);
            function reloadData() {
                var qcodes = [];
                metadata.getFilteredCustomVocabularies(qcodes).then(function (cvs) {
                    scope.cvs = lodash_1.default.sortBy(cvs, 'priority');
                    scope.genreInCvs = lodash_1.default.map(cvs, 'schema_field').indexOf('genre') !== -1;
                    scope.placeInCvs = lodash_1.default.map(cvs, 'schema_field').indexOf('place') !== -1;
                });
                scope.originalCreator = scope.item.original_creator;
                scope.versionCreator = scope.item.version_creator;
                if (!archiveService.isLegal(scope.item)) {
                    if (scope.item.original_creator) {
                        userList.getUser(scope.item.original_creator)
                            .then(function (user) {
                            scope.originalCreator = user.display_name;
                        });
                    }
                    if (scope.item.version_creator) {
                        userList.getUser(scope.item.version_creator)
                            .then(function (user) {
                            scope.versionCreator = user.display_name;
                        });
                    }
                }
            }
            scope.getLocaleName = function (terms, scheme) {
                var term = terms.find(function (element) { return element.scheme === scheme; });
                if (!term) {
                    return 'None';
                }
                if (term.translations && scope.item.language
                    && term.translations.name[scope.item.language]) {
                    return term.translations.name[scope.item.language];
                }
                return term.name;
            };
        },
    };
}
exports.MediaMetadata = MediaMetadata;


/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MediaRelated.$inject = ['superdesk'];
function MediaRelated(superdesk) {
    return {
        scope: {
            item: '=',
            relatedItems: '=',
        },
        templateUrl: 'scripts/apps/archive/views/related-view.html',
        link: function (scope, elem) {
            scope.open = function (item) {
                superdesk.intent('view', 'item', item).then(null, function () {
                    superdesk.intent('edit', 'item', item);
                });
            };
        },
    };
}
exports.MediaRelated = MediaRelated;


/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
FetchedDesks.$inject = ['desks', 'familyService', '$location', 'superdesk'];
function FetchedDesks(desks, familyService, $location, superdesk) {
    return {
        scope: {
            item: '=',
        },
        templateUrl: 'scripts/apps/archive/views/fetched-desks.html',
        link: function (scope, elem) {
            scope.$watchGroup(['item', 'item.archived'], function () {
                if (scope.item) {
                    familyService.fetchDesks(scope.item, false)
                        .then(function (fetchedDesks) {
                        scope.desks = fetchedDesks;
                    });
                }
            });
            scope.selectFetched = function (desk) {
                if (desk.isUserDeskMember) {
                    desks.setCurrentDeskId(desk.desk._id);
                    $location.url('/workspace/monitoring');
                    if (desk.count === 1) {
                        superdesk.intent('edit', 'item', desk.item);
                    }
                }
            };
        },
    };
}
exports.FetchedDesks = FetchedDesks;


/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
MetaIngest.$inject = ['ingestSources'];
function MetaIngest(ingestSources) {
    return {
        scope: {
            item: '=',
        },
        template: '{{ name }}',
        link: function (scope) {
            scope.$watch('item', renderIngest);
            function renderIngest() {
                ingestSources.initialize().then(function () {
                    if (scope.item && scope.item.ingest_provider in ingestSources.providersLookup) {
                        scope.name = ingestSources.providersLookup[scope.item.ingest_provider].name ||
                            ingestSources.providersLookup[scope.item.ingest_provider].search_provider;
                    }
                    else {
                        scope.name = '';
                    }
                });
            }
        },
    };
}
exports.MetaIngest = MetaIngest;


/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SingleItem() {
    return {
        templateUrl: 'scripts/apps/archive/views/single-item-preview.html',
        scope: {
            item: '=',
            contents: '=',
            setitem: '&',
        },
    };
}
exports.SingleItem = SingleItem;


/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DraggableItem.$inject = ['dragitem'];
function DraggableItem(dragitem) {
    return {
        link: function (scope, elem) {
            if (scope.item) {
                elem.attr('draggable', true);
                // set item data on event
                elem.on('dragstart', function (event) {
                    dragitem.start(event, scope.item);
                });
                scope.$on('$destroy', function () {
                    elem.off('dragstart');
                });
            }
        },
    };
}
exports.DraggableItem = DraggableItem;


/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.archive
 * @name sdItemCrops
 *
 * @requires metadata
 *
 * @description
 *   This directive is responsible for displaying custom crops in authoring
 *   below feature media and editor for media item.
 */
ItemCrops.$inject = ['metadata'];
function ItemCrops(metadata) {
    return {
        templateUrl: 'scripts/apps/archive/views/item-crops.html',
        scope: {
            item: '=',
        },
        link: function (scope, elem) {
            metadata.initialize().then(function () {
                scope.crop_sizes = metadata.values.crop_sizes;
            });
            /**
             * @ngdoc method
             * @name sdItemCrops#showCrops
             *
             * @description Checks if item has crops
             */
            scope.showCrops = function () { return (lodash_1.default.includes(['picture', 'graphic'], scope.item.type) && lodash_1.default.get(metadata, 'values.crop_sizes') &&
                metadata.values.crop_sizes.some(function (crop) { return scope.item.renditions && scope.item.renditions[crop.name]; })); };
        },
    };
}
exports.ItemCrops = ItemCrops;


/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ItemRendition() {
    return {
        templateUrl: 'scripts/apps/archive/views/item-rendition.html',
        scope: {
            item: '=',
            rendition: '@',
        },
        link: function (scope, elem, attrs) {
            scope.$watch('item.renditions[rendition].href', function (href) {
                var figure = elem.find('figure'), oldImg = figure.find('img').css('opacity', 0.5);
                if (href) {
                    var img = new Image();
                    img.onload = function () {
                        if (oldImg.length) {
                            oldImg.replaceWith(img);
                        }
                        else {
                            figure.html(img);
                        }
                        if (img.naturalWidth < img.naturalHeight) {
                            elem.addClass('portrait');
                        }
                        else {
                            elem.removeClass('portrait');
                        }
                    };
                    img.onerror = function () {
                        figure.html('');
                    };
                    img.src = href;
                }
            });
        },
    };
}
exports.ItemRendition = ItemRendition;


/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
RatioCalc.$inject = ['$window'];
function RatioCalc($window) {
    return {
        link: function (scope, elem) {
            var win = angular.element($window);
            calcRatio();
            function calcRatio() {
                scope.ratio = elem.outerWidth() / elem.outerHeight();
            }
            function ratioOnResize() {
                calcRatio();
                scope.$apply();
            }
            win.bind('resize', ratioOnResize);
            scope.$on('$destroy', function () {
                win.unbind('resize', ratioOnResize);
            });
        },
    };
}
exports.RatioCalc = RatioCalc;


/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var editor3CustomData_1 = __webpack_require__(48);
var fieldsMeta_1 = __webpack_require__(66);
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
function getAnnotationTypesAsync(scope) {
    ng_1.default.get('metadata').initialize()
        .then(function () {
        var annotationTypes = ng_1.default.get('metadata').values.annotation_types;
        // Use label instead of qcode
        scope.annotations = scope.annotations.map(function (a) { return (__assign({}, a, { type_label: utils_1.gettext(annotationTypes.find(function (t) { return t.qcode === a.type; }).name) })); });
    });
}
function getAllAnnotations(item) {
    var annotations = [];
    for (var field in item[fieldsMeta_1.META_FIELD_NAME]) {
        annotations.push.apply(annotations, editor3CustomData_1.getAnnotationsFromItem(item, field));
    }
    return annotations;
}
function annotationDecorator() {
    document.querySelectorAll('span[annotation-id]').forEach(function (elem) {
        var id = parseInt(elem.getAttribute('annotation-id'), 10);
        if (!document.querySelectorAll("#annotation-id-" + id).length) {
            elem.classList.add('annotation-text');
            elem.innerHTML += "<sup class=\"annotation-id\" id=\"annotation-id-" + id + "\">" + id + "</sup>";
        }
    });
}
function afterRender() {
    annotationDecorator();
}
HtmlPreview.$inject = ['$sce', '$timeout'];
function HtmlPreview($sce, $timeout) {
    return {
        scope: {
            sdHtmlPreview: '=',
            item: '=?',
        },
        templateUrl: 'scripts/apps/archive/views/html-preview.html',
        link: function (scope, elem, attrs) {
            scope.$watch('sdHtmlPreview', function (html) {
                scope.html = $sce.trustAsHtml(html);
                if (window.hasOwnProperty('instgrm')) {
                    window.instgrm.Embeds.process();
                }
            });
            scope.$watch('item', function (item) {
                if (item) {
                    var annotations = getAllAnnotations(item);
                    scope.annotations = annotations.map(function (a) { return (__assign({}, a, { body: $sce.trustAsHtml(a.body) })); });
                    getAnnotationTypesAsync(scope);
                }
            });
            $timeout(afterRender);
        },
    };
}
exports.HtmlPreview = HtmlPreview;


/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ProviderMenu.$inject = ['$location'];
function ProviderMenu($location) {
    return {
        scope: { items: '=' },
        templateUrl: 'scripts/apps/archive/views/provider-menu.html',
        link: function (scope, element, attrs) {
            scope.setProvider = function (provider) {
                scope.selected = provider;
                $location.search('provider', scope.selected);
            };
            scope.$watchCollection(function () { return $location.search(); }, function (search) {
                if (search.provider) {
                    scope.selected = search.provider;
                }
            });
        },
    };
}
exports.ProviderMenu = ProviderMenu;


/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
ContentResults.$inject = ['$location', 'preferencesService', 'packages', 'tags', 'asset', 'search'];
/*
 * TODO(x):
 * This directive is only temporarly,
 * it will be deleted with content and ingest
 */
function ContentResults($location, preferencesService, packages, tags, asset, search) {
    var update = {
        'archive:view': {
            allowed: [
                'mgrid',
                'compact',
            ],
            category: 'archive',
            view: 'mgrid',
            default: 'mgrid',
            label: 'Users archive view format',
            type: 'string',
        },
    };
    return {
        require: '^sdSearchContainer',
        templateUrl: asset.templateUrl('apps/search/views/search-results.html'),
        link: function (scope, elem, attr, controller) {
            var GRID_VIEW = 'mgrid', LIST_VIEW = 'compact';
            var multiSelectable = attr.multiSelectable !== undefined;
            scope.flags = controller.flags;
            scope.selected = scope.selected || {};
            scope.preview = function preview(item) {
                if (multiSelectable) {
                    if (lodash_1.default.findIndex(scope.selectedList, { _id: item._id }) === -1) {
                        scope.selectedList.push(item);
                    }
                    else {
                        lodash_1.default.remove(scope.selectedList, { _id: item._id });
                    }
                }
                scope.selected.preview = item;
                $location.search('_id', item ? item._id : null);
            };
            scope.openSingleItem = function (packageItem) {
                packages.fetchItem(packageItem).then(function (item) {
                    scope.selected.view = item;
                });
            };
            scope.setview = setView;
            var savedView;
            preferencesService.get('archive:view').then(function (result) {
                savedView = result.view;
                scope.view = !!savedView && savedView !== 'undefined' ? savedView : 'mgrid';
            });
            scope.$on('key:v', toggleView);
            function setView(view) {
                scope.view = view || 'mgrid';
                update['archive:view'].view = view || 'mgrid';
                preferencesService.update(update, 'archive:view');
            }
            function toggleView() {
                var nextView = scope.view === LIST_VIEW ? GRID_VIEW : LIST_VIEW;
                return setView(nextView);
            }
            /**
             * Generates Identifier to be used by track by expression.
             */
            scope.generateTrackByIdentifier = function (item) {
                return search.generateTrackByIdentifier(item);
            };
        },
    };
}
exports.ContentResults = ContentResults;


/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
ArchivedItemKill.$inject = ['authoring', 'api', 'notify'];
function ArchivedItemKill(authoring, api, notify) {
    return {
        templateUrl: 'scripts/apps/archive/views/archived-kill.html',
        scope: {
            item: '=',
            action: '=',
        },
        link: function (scope, elem, attr) {
            scope._editable = true;
            var itemToDelete = { _id: scope.item._id, _etag: scope.item._etag };
            api.remove(itemToDelete, {}, 'archived').then(function (response) {
                var fields = lodash_1.default.union(lodash_1.default.keys(authoring.getContentFieldDefaults()), ['_id', 'versioncreated']);
                var itemForTemplate = { template_name: scope.action, item: lodash_1.default.pick(scope.item, fields) };
                api.save('content_templates_apply', {}, itemForTemplate, {}).then(function (result) {
                    itemForTemplate = lodash_1.default.pick(result, lodash_1.default.keys(authoring.getContentFieldDefaults()));
                    scope.item = lodash_1.default.create(scope.item);
                    lodash_1.default.each(itemForTemplate, function (value, key) {
                        if (!lodash_1.default.isUndefined(value) && !lodash_1.default.isEmpty(value)) {
                            scope.item[key] = value;
                        }
                    });
                    scope.item['operation'] = scope.action;
                }, function (err) {
                    notify.error(utils_1.gettext('Failed to apply kill template to the item.'));
                });
            }, function (response) {
                if (response.data._message) {
                    notify.error(response.data._message);
                }
                else {
                    notify.error(utils_1.gettext('Unknown Error: Cannot kill the item'));
                }
            });
            scope.kill = function () {
                api.save('archived', scope.item, lodash_1.default.pick(scope.item, ['headline', 'abstract', 'body_html', 'operation']))
                    .then(function (response) {
                    notify.success(utils_1.gettext('Item has been killed.'));
                    scope.cancel();
                });
            };
            scope.cancel = function () {
                scope.item = null;
            };
        },
    };
}
exports.ArchivedItemKill = ArchivedItemKill;


/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
ResendItem.$inject = ['subscribersService', 'authoring', 'api', 'notify'];
function ResendItem(subscribersService, authoring, api, notify) {
    return {
        templateUrl: 'scripts/apps/archive/views/resend-configuration.html',
        scope: { item: '=' },
        link: function (scope, elem, attr) {
            scope.$watch('item', function (item) {
                scope.selectedSubscribers = { items: [] };
                if (item && !scope.customSubscribers) {
                    subscribersService.fetchTargetableSubscribers().then(function (items) {
                        scope.customSubscribers = [];
                        scope.subscribers = items._items;
                        lodash_1.default.each(items, function (_item) {
                            scope.customSubscribers.push({ qcode: _item._id, name: _item.name });
                        });
                    });
                }
            });
            function getSubscriberIds() {
                var subscriberIds = [];
                lodash_1.default.forEach(scope.selectedSubscribers.items, function (item) {
                    subscriberIds.push(item.qcode);
                });
                return subscriberIds;
            }
            scope.resendItem = function () {
                var data = { subscribers: getSubscriberIds(), version: scope.item._current_version };
                api.save('archive_resend', {}, data, scope.item)
                    .then(function () {
                    notify.success(utils_1.gettext('Item has been resent.'));
                    scope.cancel();
                }, function (response) {
                    if (response.data._message) {
                        notify.error(response.data._message);
                    }
                    else {
                        notify.error(utils_1.gettext('Unknown Error: Cannot resend the item'));
                    }
                });
            };
            scope.cancel = function () {
                scope.item = null;
            };
        },
    };
}
exports.ResendItem = ResendItem;


/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ItemPriority.$inject = ['metadata'];
function ItemPriority(metadata) {
    metadata.initialize();
    return {
        scope: { priority: '=' },
        template: [
            '<span ng-if="priority" class="priority-label priority-label--{{ priority }}" ',
            'ng-style="{backgroundColor: color}" title="{{ \'Priority\' | translate }}: {{ title }}">'
                + '{{ short }}</span>',
        ].join(''),
        link: function (scope, elem) {
            scope.$watch('priority', function (priority) {
                if (priority) {
                    var spec = metadata.priorityByValue(priority);
                    if (spec) {
                        scope.color = spec.color;
                        scope.short = spec.short || priority;
                        scope.title = spec.name;
                    }
                }
            });
        },
    };
}
exports.ItemPriority = ItemPriority;


/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
ItemUrgency.$inject = ['metadata'];
function ItemUrgency(metadata) {
    metadata.initialize();
    return {
        scope: { urgency: '=' },
        template: [
            '<span ng-if="urgency" class="urgency-label urgency-label--{{ urgency }}" ',
            'ng-style="{backgroundColor: color}" title="{{ \'Urgency\' | translate }}: {{ title }}">{{ short }}</span>',
        ].join(''),
        link: function (scope, elem) {
            scope.$watch('urgency', function (urgency) {
                if (urgency) {
                    var spec = metadata.urgencyByValue(urgency);
                    if (spec) {
                        scope.color = spec.color;
                        scope.short = spec.short || urgency;
                        scope.title = spec.name;
                    }
                }
            });
        },
    };
}
exports.ItemUrgency = ItemUrgency;


/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var LinkFunction = /** @class */ (function () {
    function LinkFunction(desks, authoring, highlightsService, $filter, $location, $timeout, scope, elem) {
        this.desks = desks;
        this.authoring = authoring;
        this.highlightsService = highlightsService;
        this.filter = $filter;
        this.location = $location;
        this.timeout = $timeout;
        this.scope = scope;
        this.elem = elem;
        this.init();
    }
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#init
     * @private
     * @description Initializes the directive with default values for the scope
     * and with necessary watchers.
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        // Initialize required data
        if (this.scope.markField === 'marked_desks') {
            this.scope.deskMarking = true;
            this.scope.service = this.desks;
            this.scope.fetchFunction = 'fetchDesks';
            this.scope.idField = 'desk_id';
            this.scope.hasMarkItemPrivilege = this.authoring.itemActions(this.scope.item).mark_item_for_desks;
        }
        else {
            this.scope.deskMarking = false;
            this.scope.service = this.highlightsService;
            this.scope.fetchFunction = 'get';
            this.scope.idField = '_id';
            this.scope.hasMarkItemPrivilege = this.authoring.itemActions(this.scope.item).mark_item_for_highlight;
        }
        // Watch marks updates - listen to the event from server
        this.scope.$on('item:' + this.scope.markField, function ($event, data) {
            if (_this.scope.item._id !== data.item_id) {
                return;
            }
            var marks = _this.scope.marks || [];
            _this.scope.$apply(function () {
                if (data.marked) {
                    _this.scope.marks = marks.concat(data.mark_id);
                }
                else {
                    _this.scope.marks = lodash_1.default.without(marks, data.mark_id);
                }
                _this.updateMarkedItems();
            });
        });
        // Watch if the item being previewing/authored has changed
        this.scope.$watch('item', function (item) {
            if (item) {
                _this.scope.marks = [];
                if (item[_this.scope.markField] && item[_this.scope.markField].length) {
                    // (if) marked_desks is an array of objects (else) highlights is an array if string: highlight ids
                    if (_this.scope.deskMarking) {
                        _this.scope.marks = lodash_1.default.map(item[_this.scope.markField], _this.scope.idField);
                    }
                    else {
                        _this.scope.marks = item[_this.scope.markField];
                    }
                }
                _this.updateMarkedItems();
            }
        });
        // Putting these two methods on scope as they are accessed by the template url's ng-click
        this.scope.toggleClass = this.toggleClass.bind(this);
        this.scope.unmark = this.unmark.bind(this);
    };
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#unmark
     * @private
     * @param {string} mark - _id of the mark to be removed
     * @description Remove mark of an item and close the marks popup dropdown
     */
    LinkFunction.prototype.unmark = function (mark) {
        var _this = this;
        this.scope.service.markItem(mark, this.scope.item).then(function () {
            _this.timeout(function () {
                var popup = $(_this.elem).find('.highlights-list');
                popup.filter('.open').children('.dropdown-toggle.dropdown__toggle')
                    .click();
            });
        });
    };
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#toggleClass
     * @param {Boolean} isOpen - toggle value to be applied
     * @description Toggles 'open' class on dropdown menu element
     * @returns {Boolean}
     */
    LinkFunction.prototype.toggleClass = function (isOpen, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        this.scope.open = isOpen;
    };
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#isActiveHighlights
     * @description Evaluates if any of item's highlights are active
     * @returns {Boolean}
     */
    LinkFunction.prototype.isActiveHighlights = function () {
        var _this = this;
        var highlightStatuses = {};
        lodash_1.default.forEach(this.scope.markObjects, function (highlight) {
            var hours = _this.filter('hoursFromNow')(_this.scope.item.versioncreated);
            highlightStatuses[highlight._id] = _this.highlightsService.isInDateRange(highlight, hours);
        });
        if (this.location.path() === '/workspace/highlights') {
            return highlightStatuses[this.location.search().highlight];
        }
        return this.scope.markObjects.some(function (h) { return highlightStatuses[h._id]; });
    };
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#updateMarkedItems
     * @description Updates the item's mark property
     */
    LinkFunction.prototype.updateMarkedItems = function () {
        var _this = this;
        this.scope.service[this.scope.fetchFunction]().then(function (result) {
            _this.scope.markObjects = result._items.filter(function (obj) { return (_this.scope.marks || []).includes(obj._id); });
            // (if) marked_desks is an array of objects (else) highlights is an array if string: highlight ids
            if (_this.scope.deskMarking) {
                var updatedDdeskMarks_1 = [];
                lodash_1.default.forEach(_this.scope.marks, function (m) {
                    updatedDdeskMarks_1.push({ desk_id: m });
                });
                _this.scope.item[_this.scope.markField] = updatedDdeskMarks_1;
            }
            else {
                _this.scope.item[_this.scope.markField] = _this.scope.marks;
            }
            // Do UI required changes
            if (_this.scope.marks) {
                _this.doIconUpdates();
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdMarkedItemTitle#doIconUpdates
     * @description Adds required UI classes to the mark icons
     */
    LinkFunction.prototype.doIconUpdates = function () {
        // To do - Change this method when a multi bell icon is added for desk markings
        // If highlights, add appropriate multi icon and color
        if (this.scope.deskMarking) {
            this.scope.className = 'icon-bell';
        }
        else {
            this.scope.className = this.scope.marks.length > 1 ? 'icon-multi-star' : 'icon-star';
            if (this.isActiveHighlights()) {
                this.scope.className += ' red';
            }
        }
    };
    return LinkFunction;
}());
/**
 * @module superdesk.apps.archive
 * @ngdoc directive
 * @name sdMarkedItemTitle
 * @requires desks
 * @requires authoring
 * @requires highlightServce
 * @requires $filter
 * @requires $location
 * @requires $timeout
 * @description This directive is used in authoring-topbar and item preview to mark a story as a highlight or
 *   to mark it for a desk.
 */
function MarkedItemTitle(desks, authoring, highlightsService, $filter, $location, $timeout) {
    return {
        scope: {
            item: '=item',
            markField: '@field',
        },
        template: __webpack_require__(1932),
        link: function (scope, elem) { return new LinkFunction(desks, authoring, highlightsService, $filter, $location, $timeout, scope, elem); },
    };
}
exports.MarkedItemTitle = MarkedItemTitle;
MarkedItemTitle.$inject = ['desks', 'authoring', 'highlightsService', '$filter', '$location', '$timeout'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

module.exports = "<div class=\"highlights-list dropdown\"\n     dropdown\n     dropdown-append-to-body\n     ng-if=\"marks.length>0\"\n     ng-click=\"toggleClass(open, $event)\">\n\n    <button class=\"dropdown__toggle\" dropdown__toggle>\n        <i class=\"{{className}} icon-open\"></i>\n    </button>\n\n    <ul class=\"dropdown dropdown__menu highlights-list-menu\" ng-class=\"{open: open}\" ng-click=\"$event.stopPropagation()\">\n        <li>\n            <div class=\"dropdown__menu-label\" translate>Marked For</div>\n            <button class=\"dropdown__menu-close\" dropdown-toggle>\n                <i class=\"icon-close-small icon--white\"></i>\n            </button>\n        </li>\n        <li ng-repeat=\"mark in markObjects | orderBy: 'name' track by mark._id\" title=\"{{ :: mark.name }}\">\n            {{ :: mark.name }}\n            <button class=\"btn btn--mini uppercase\" ng-if=\"hasMarkItemPrivilege\" ng-click=\"unmark(mark._id)\" translate>Remove</button>\n        </li>\n        <li class=\"none\" ng-show=\"marks.length === 0\" translate>None</li>\n    </ul>\n</div>\n";

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var LinkFunction = /** @class */ (function () {
    function LinkFunction(api, config, multi, notify, storage, session, urls, scope) {
        this.api = api;
        this.config = config;
        this.multi = multi;
        this.notify = notify;
        this.storage = storage;
        this.session = session;
        this.urls = urls;
        this.scope = scope;
        this.init();
    }
    /**
     * @ngdoc method
     * @name sdExport#init
     * @private
     * @description Initializes the directive with default values for the scope
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        this.scope.loading = false;
        this.scope.selectedFormatter = this.storage.getItem('selectedFormatter');
        this.scope.validate = false;
        this.scope.exportFile = this.exportFile.bind(this);
        this.scope.cancel = this.cancel.bind(this);
        this.scope.failures = 0;
        this.scope.error = false;
        this.scope.err_msg = null;
        this.api.query('formatters', { criteria: 'can_export' }).then(function (result) {
            _this.scope.exportFormatters = result._items;
            if (!_this.scope.selectedFormatter &&
                _this.scope.exportFormatters.length > 0) {
                _this.scope.selectedFormatter = JSON.stringify(_this.scope.exportFormatters[0]);
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdExport#cancel
     * @private
     * @description Closes the Export modal dialog
     */
    LinkFunction.prototype.cancel = function () {
        this.scope.closeExport();
    };
    /**
     * @ngdoc method
     * @name sdExport#exportFile
     * @private
     * @param {string} formatterString - name of the formatter selected
     * @param {Boolean} validate - item to be validated for publish action
     * @description Calls 'export' endpoint with the request and downloads file if export was successful
     * @return {Promise}
     */
    LinkFunction.prototype.exportFile = function (formatterString, validate) {
        var _this = this;
        this.scope.loading = true;
        this.storage.setItem('selectedFormatter', formatterString);
        var formatter = JSON.parse(formatterString);
        var itemIdList = this.scope.multi ? lodash_1.default.map(this.multi.getItems(), '_id') : [this.scope.item._id];
        return this.api.save('export', {}, { item_ids: itemIdList, format_type: formatter.name, validate: validate })
            .then(function (item) {
            _this.scope.failures = item.failures;
            // Click the url to triger download of file
            if (item.url) {
                var elem = $('#exportDownloadLink');
                if (elem[0]) {
                    elem[0].href = item.url;
                    elem[0].click();
                }
                if (_this.scope.failures === 0) {
                    _this.scope.closeExport();
                }
            }
        }, function (error) {
            _this.onError(error.data._message);
        })
            .finally(function () {
            _this.scope.loading = false;
        });
    };
    /**
     * @ngdoc method
     * @name sdExport#onError
     * @private
     * @param {string} msg - error msg to be displayed
     * @description Set error indicating variables
     */
    LinkFunction.prototype.onError = function (msg) {
        this.scope.error = true;
        this.scope.err_msg = msg;
    };
    return LinkFunction;
}());
/**
 * @module superdesk.apps.archive
 * @ngdoc directive
 * @name sdExport
 * @requires api
 * @requires config
 * @requires multi
 * @requires notify
 * @requires storage
 * @requires session
 * @requires urls
 * @description This directive is used to export articles in selected formats and download the exported file
 *
 */
function Export(api, config, multi, notify, storage, session, urls) {
    return {
        templateUrl: 'scripts/apps/archive/views/export.html',
        link: function (scope) { return new LinkFunction(api, config, multi, notify, storage, session, urls, scope); },
    };
}
exports.Export = Export;
Export.$inject = ['api', 'config', 'multi', 'notify', 'storage', 'session', 'urls'];

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module superdesk.apps.archive
 * @ngdoc directive
 * @name sdAssociatedItemMetadata
 * @description This directive is used to display associated item metadata.
 */
function AssociatedItemMetadata() {
    return {
        templateUrl: 'scripts/apps/archive/views/metadata-associateditem-view.html',
        scope: {
            association: '=',
            title: '@',
        },
    };
}
exports.AssociatedItemMetadata = AssociatedItemMetadata;


/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkFunction = /** @class */ (function () {
    function LinkFunction(superdesk, api, familyService, scope) {
        this.scope = scope;
        this.superdesk = superdesk;
        this.api = api;
        this.familyService = familyService;
        this.init();
        this.scope.open = this.open.bind(this);
        this.fetchUsedItems();
    }
    /**
     * @ngdoc method
     * @name sdMediaUsed#init
     * @private
     * @description Initializes the directive with default values for the scope
     * and with necessary watchers.
     */
    LinkFunction.prototype.init = function () {
        var _this = this;
        this.scope.$watch('item', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                _this.fetchUsedItems();
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdMediaUsed#fetchUsedItems
     * @private
     * @description Fetches stories using this media and assigns to scope
     */
    LinkFunction.prototype.fetchUsedItems = function () {
        var _this = this;
        return this.familyService.fetchMediaUsedItems(this.scope.item.unique_id).then(function (items) {
            _this.scope.usedItems = items;
        });
    };
    /**
     * @ngdoc method
     * @name sdMediaUsed#open
     * @private
     * @description Trigger opening of an item for edit
     */
    LinkFunction.prototype.open = function (item) {
        var _this = this;
        this.superdesk.intent('view', 'item', item).then(null, function () {
            _this.superdesk.intent('edit', 'item', item);
        });
    };
    return LinkFunction;
}());
/**
 * @module superdesk.apps.archive
 * @ngdoc directive
 * @name sdMediaUsed
 * @requires superdesk
 * @requires api
 * @requires familyService
 * @description This directive is used to fetch and display stories in which a media item is used
 */
function MediaUsed(superdesk, api, familyService) {
    return {
        scope: {
            item: '=item',
        },
        template: __webpack_require__(1936),
        link: function (scope, elem) { return new LinkFunction(superdesk, api, familyService, scope); },
    };
}
exports.MediaUsed = MediaUsed;
MediaUsed.$inject = ['superdesk', 'api', 'familyService'];


/***/ }),
/* 1936 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mediaUsed\">\n    <ul>\n        <li ng-repeat=\"usedItem in usedItems._items\">\n            <div class=\"mediaUsed--Item\" ng-click=\"open(usedItem)\">\n                <i class=\"type-icon\" sd-filetype-icon data-item=\"usedItem\"></i>\n                <span class=\"keyword\" ng-if=\"usedItem.slugline\">{{ usedItem.slugline }}</span>\n                <span sd-item-container data-item=\"usedItem\" class=\"container\"></span>\n                <span class=\"state-label state-{{usedItem.state}}\">{{ usedItem.state }}</span>\n                <div class=\"item\">\n                    <span ng-href=\"\" title=\"{{ usedItem.headline }}\" class=\"headline\">\n                        {{ usedItem.headline || usedItem.description_text }}\n                    </span>\n                </div>\n            </div>\n        </li>\n    </ul>\n</div>\n";

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
PackageItemLabelsDropdown.$inject = ['vocabularies', 'packages', 'authoringWorkspace'];
function PackageItemLabelsDropdown(vocabularies, packages, authoringWorkspace) {
    return {
        templateUrl: 'scripts/apps/archive/views/package_item_labels_dropdown_directive.html',
        link: function (scope) {
            scope.labels = [];
            vocabularies.getVocabulary('package-story-labels').then(function (vocabulary) {
                scope.labels = vocabulary.items;
            });
            scope.setItemLabel = function (label) {
                packages.setItemLabel(scope.item, label);
            };
            scope.isSetItemLabel = function (label) { return packages.isSetItemLabel(scope.item, label); };
        },
    };
}
exports.PackageItemLabelsDropdown = PackageItemLabelsDropdown;


/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @ngdoc directive
 * @module superdesk.apps.archive
 * @name sdAssignmentIcon
 *
 * @description Renders the assignment icon if the item is the output of an assignment.
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
function AssignmentIcon() {
    return {
        templateUrl: 'scripts/apps/archive/views/assignment-icon.html',
        scope: { item: '=' },
        link: function (scope, elem) {
            function handleAssignmentLink(event, data) {
                if (data.item !== scope.item._id) {
                    return;
                }
                if (event.name === 'content:link') {
                    scope.item.assignment_id = data.assignment;
                }
                else {
                    scope.item.assignment_id = null;
                }
            }
            scope.$on('content:link', handleAssignmentLink);
            scope.$on('content:unlink', handleAssignmentLink);
            scope.$on('assignments:removed', handleAssignmentLink);
        },
    };
}
exports.AssignmentIcon = AssignmentIcon;


/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DragItemService_1 = __webpack_require__(1940);
exports.DragItemService = DragItemService_1.DragItemService;
var FamilyService_1 = __webpack_require__(1941);
exports.FamilyService = FamilyService_1.FamilyService;
var MultiService_1 = __webpack_require__(1942);
exports.MultiService = MultiService_1.MultiService;
var SpikeService_1 = __webpack_require__(1943);
exports.SpikeService = SpikeService_1.SpikeService;
var ArchiveService_1 = __webpack_require__(1944);
exports.ArchiveService = ArchiveService_1.ArchiveService;


/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service to handle item dragging
 */
function DragItemService() {
    /**
     * Start dragging an item - add item data to event
     *
     * @param {Event} event
     * @param {Object} item
     */
    this.start = function (event, item) {
        var dt = event.dataTransfer || event.originalEvent.dataTransfer;
        dt.setData('application/superdesk.item.' + item.type, angular.toJson(item));
        dt.effectAllowed = 'link';
        if (item.renditions && item.renditions.thumbnail) {
            var img = new Image();
            var rendition = item.renditions.thumbnail;
            img.src = rendition.href;
            img.width = rendition.width;
            dt.setDragImage(img, rendition.width / 2, rendition.height / 2);
        }
    };
}
exports.DragItemService = DragItemService;


/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importStar(__webpack_require__(2));
/**
 * @ngdoc service
 * @module superdesk.apps.archive
 * @name family
 * @requires api
 * @requires desks
 * @description Family Service is responsible for returning related items of a given story
 */
FamilyService.$inject = ['api', 'desks'];
function FamilyService(api, desks) {
    var _this = this;
    var repo = 'archive,published';
    /**
     * @ngdoc method
     * @name family#fetchItems
     * @public
     * @description Returns duplicates of a given story
     * @param {string} familyId
     * @param {Object} excludeItem
     * @returns {Object}
     */
    this.fetchItems = function (familyId, excludeItem) {
        var filter = [
            { not: { term: { state: 'spiked' } } },
            { term: { family_id: familyId } },
        ];
        if (excludeItem && excludeItem.unique_id) {
            filter.push({ not: { term: { unique_id: excludeItem.unique_id } } });
        }
        return query(filter, 'versioncreated', 'desc');
    };
    /**
     * @ngdoc method
     * @name family#fetchMediaUsedItems
     * @public
     * @description Returns stories which have used a media item
     * @param {string} mediaUniqueId
     * @returns {Array}
     */
    this.fetchMediaUsedItems = function (mediaUniqueId) {
        var filter = [
            { not: { term: { state: 'spiked' } } },
            { term: { 'associations.featuremedia.unique_id': mediaUniqueId } },
        ];
        return query(filter, 'versioncreated', 'desc');
    };
    /**
     * @ngdoc method
     * @name family#query
     * @private
     * @description Creates the query object and performs the query
     * @param {Object} filter
     * @param {string} sortField
     * @param {string} order
     * @param {Object} queryString
     * @returns {Object}
     */
    var query = function (filter, sortField, order, queryString) {
        var params = {
            repo: repo,
            source: {
                query: { filtered: { filter: {
                            and: filter,
                        } } },
                size: 200,
                from: 0,
            },
        };
        if (queryString) {
            params.source.query.filtered.query = queryString;
        }
        params.source.sort = {};
        params.source.sort[sortField] = order;
        return api.query('search', params);
    };
    /**
     * @ngdoc method
     * @name family#fetchRelatedItems
     * @public
     * @description Returns takes, updates, corrections and kills of a given event_id
     * @param {Object} item - story to get related items of
     * @returns {Object}
     */
    this.fetchRelatedItems = function (item) {
        var filter = [
            { not: { term: { state: 'spiked' } } },
            { term: { event_id: item.event_id } },
            { not: { term: { type: 'composite' } } },
        ];
        return query(filter, 'versioncreated', 'asc');
    };
    /**
     * @ngdoc method
     * @name family#fetchRelatableItems
     * @public
     * @description Returns any story potentially linkable
     * @param {string} keyword - slugline to be matched
     * @param {string} sluglineMatch - type of matching rule for slugline
     * @param {item} item - authoring item that the user is trying to link
     * @param {string} modificationDateAfter - filter for versioncreated
     * @returns {Object}
     */
    this.fetchRelatableItems = function (keyword, sluglineMatch, item, modificationDateAfter) {
        var filter = [
            { not: { term: { state: 'spiked' } } },
            { not: { term: { event_id: item.event_id } } },
            { not: { term: { type: 'composite' } } },
            { not: { term: { last_published_version: 'false' } } },
            { term: { type: item.type } },
        ];
        if (lodash_1.get(item, 'genre[0].qcode')) {
            filter.push({ term: { 'genre.qcode': lodash_1.get(item, 'genre[0].qcode') } });
        }
        var queryString = null;
        var queryRelatedItem = [];
        var sanitizedKeyword = keyword.replace(/[\\:]/g, '').replace(/\//g, '\\/');
        var queryWords = sanitizedKeyword.split(' ');
        var addSlugs = function (list, words) {
            words.forEach(function (w) {
                if (w) {
                    list.push('slugline:(' + w + ')');
                }
            });
        };
        // process creation date
        if (modificationDateAfter) {
            var dateQuery = {};
            dateQuery.versioncreated = {
                gte: modificationDateAfter,
            };
            filter.push({ range: dateQuery });
        }
        switch (sluglineMatch) {
            case 'ANY': // any words in the slugline
                if (keyword.indexOf(' ') >= 0) {
                    queryRelatedItem.push('slugline:("' + sanitizedKeyword + '")');
                }
                addSlugs(queryRelatedItem, queryWords);
                if (queryRelatedItem.length) {
                    queryString = {
                        query_string: {
                            query: queryRelatedItem.join(' '),
                            lenient: false,
                            default_operator: 'OR',
                        },
                    };
                }
                break;
            case 'PREFIX': // phrase prefix
                queryString = {
                    match_phrase_prefix: {
                        'slugline.phrase': sanitizedKeyword,
                    },
                };
                break;
            default:
                // exact match on slugline
                queryString = {
                    query_string: {
                        query: 'slugline.phrase:("' + sanitizedKeyword + '")',
                        lenient: false,
                    },
                };
        }
        return query(filter, 'firstcreated', 'asc', queryString);
    };
    /**
     * @ngdoc method
     * @name family#fetchDesks
     * @public
     * @description Returns the fetched desk list of a given story
     * @param {Object} item - story
     * @param {bookean} excludeSelf
     * @returns {Object}
     */
    this.fetchDesks = function (item, excludeSelf) { return _this.fetchItems(item.state === 'ingested' ?
        item._id : item.family_id, excludeSelf ? item : undefined)
        .then(function (items) {
        var deskList = [];
        var deskIdList = [];
        lodash_1.default.each(items._items, function (i) {
            if (i.task && i.task.desk && desks.deskLookup[i.task.desk]) {
                if (deskIdList.indexOf(i.task.desk) < 0) {
                    var _isMember = !lodash_1.default.isEmpty(lodash_1.default.find(desks.userDesks, { _id: i.task.desk }));
                    deskList.push({
                        desk: desks.deskLookup[i.task.desk],
                        count: 1,
                        itemId: i._id,
                        isUserDeskMember: _isMember,
                        item: i,
                    });
                    deskIdList.push(i.task.desk);
                }
                else {
                    deskList[deskIdList.indexOf(i.task.desk)].count += 1;
                }
            }
        });
        return deskList;
    }); };
}
exports.FamilyService = FamilyService;


/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc service
 * @module superdesk.apps.archive
 * @name multi
 * @requires $rootScope
 * @description Multi Service keeps track of multiple selections
 */
MultiService.$inject = ['$rootScope'];
function MultiService($rootScope) {
    var items = [];
    var self = this;
    var findItem = function (item) { return lodash_1.default.find(items, function (i) { return i._id === item._id && i._current_version === item._current_version; }); };
    /**
     * @ngdoc method
     * @name multi#isSelected
     * @public
     * @description Checks if given item is selected
     * @param {Object} item - story
     * @returns {Boolean}
     */
    this.isSelected = function (item) {
        return lodash_1.default.size(findItem(item)) > 0;
    };
    /**
     * @ngdoc method
     * @name multi#toggle
     * @public
     * @description Toggles the given item selected state
     * @param {Object} item - story
     */
    this.toggle = function (item) {
        items = lodash_1.default.without(items, findItem(item));
        if (item.selected) {
            items = lodash_1.default.union(items, [item]);
        }
        this.count = items.length;
    };
    /**
     * @ngdoc method
     * @name multi#getIds
     * @public
     * @description Returns list of selected item identifiers
     * @returns {Array} item ids
     */
    this.getIds = function () {
        return lodash_1.default.map(items, '_id');
    };
    /**
     * @ngdoc method
     * @name multi#getItems
     * @public
     * @description Returns list of selected items
     * @returns {Array} items
     */
    this.getItems = function () {
        return items;
    };
    /**
     * @ngdoc method
     * @name multi#reset
     * @public
     * @description Resets selected items
     */
    this.reset = function () {
        var ids = [];
        lodash_1.default.each(items, function (item) {
            item.selected = false;
            ids.push(item._id);
        });
        items = [];
        this.count = 0;
        $rootScope.$broadcast('multi:reset', { ids: ids }); // let react know
    };
    /**
     * @ngdoc method
     * @name multi#remove
     * @public
     * @description Removes the item and updates count on deselection
     * @param {string} item id
     */
    this.remove = function (itemId) {
        lodash_1.default.remove(items, { _id: itemId });
        this.count = items.length;
    };
    // main
    this.reset();
    $rootScope.$on('$routeChangeStart', angular.bind(this, this.reset));
    $rootScope.$on('multi:remove', function (_e, itemId) {
        self.remove(itemId);
    });
    $rootScope.$on('item:spike', function (e, data) {
        if (!lodash_1.default.isNil(data)) {
            self.remove(data.item);
        }
    });
    $rootScope.$on('item:unspike', function (e, data) {
        if (!lodash_1.default.isNil(data)) {
            self.remove(data.item);
        }
    });
    $rootScope.$on('item:publish', function (e, data) {
        self.remove(data.item);
    });
    $rootScope.$on('item:move', function (e, data) {
        self.remove(data.item);
    });
}
exports.MultiService = MultiService;


/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc service
 * @module superdesk.apps.archive
 * @name spike
 *
 * @requires $location
 * @requires api
 * @requires notify
 * @requires send
 * @requires $q
 * @requires authoring
 * @requires authoringWorkspace
 * @requires superdeskFlags
 *
 * @description Spike Service is responsible for proving item (single and multiple) spike/un-spike functionality
 */
SpikeService.$inject = ['$location', 'api', 'notify', 'send', '$q', 'authoring', 'authoringWorkspace',
    'lock'];
function SpikeService($location, api, notify, send, $q, authoring, authoringWorkspace, lock) {
    var SPIKE_RESOURCE = 'archive_spike', UNSPIKE_RESOURCE = 'archive_unspike';
    /**
     * Spike given item.
     *
     * @param {Object} item
     * @returns {Promise}
     */
    this.spike = function (item) {
        return api.update(SPIKE_RESOURCE, item, { state: 'spiked' })
            .then(function () {
            if ($location.search()._id === item._id) {
                $location.search('_id', null);
            }
            closeAuthoring(item);
            return item;
        }, function (response) {
            item.error = response;
            if (angular.isDefined(response.data._issues) &&
                angular.isDefined(response.data._issues['validator exception'])) {
                notify.error(utils_1.gettext(response.data._issues['validator exception']));
            }
        });
    };
    /**
     * Spike given items.
     *
     * @param {Object} items
     * @returns {Promise}
     */
    this.spikeMultiple = function spikeMultiple(items) {
        return $q.all(items.map(this.spike));
    };
    /**
     * Unspike given item.
     *
     * @param {Object} item
     */
    this.unspike = function (item) {
        return getUnspikeDestination().then(function (config) { return unspike(item, config); });
    };
    function getUnspikeDestination() {
        return send.startConfig();
    }
    function unspike(item, config) {
        var data = {
            task: {
                desk: config.desk || null,
                stage: config.stage || null,
            },
        };
        return api.update(UNSPIKE_RESOURCE, item, data)
            .then(function () {
            if ($location.search()._id === item._id) {
                $location.search('_id', null);
            }
            closeAuthoring(item);
            return item;
        }, function (response) {
            item.error = response;
        });
    }
    /**
     * Unspike given items.
     *
     * @param {Object} items
     */
    this.unspikeMultiple = function unspikeMultiple(items) {
        getUnspikeDestination().then(function (config) {
            items.forEach(function (item) {
                unspike(item, config);
            });
        });
    };
    /**
     * @ngdoc method
     * @name spike#closeAuthoring
     * @private
     * @description Checks if the item is locked (and open by authoring). If yes, unlocks (and closes) it
     * @param {Object} item
     */
    function closeAuthoring(item) {
        var authoringItem = authoringWorkspace.getItem();
        var closeWorkSpace;
        if (authoringItem && authoringItem._id === item._id) {
            closeWorkSpace = true;
        }
        if (item.state === 'spiked' && closeWorkSpace) { // Unspiked item opened in authoring
            authoringWorkspace.close();
        }
        else if (item.lock_user) { // lock is held by session user (verified at activity.additionalCondition)
            lock.unlock(item);
            if (closeWorkSpace) {
                authoringWorkspace.close(true);
            }
        }
    }
}
exports.SpikeService = SpikeService;


/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var moment_1 = __importDefault(__webpack_require__(5));
ArchiveService.$inject = ['desks', 'session', 'api', '$q', 'search', '$location', 'config'];
function ArchiveService(desks, session, api, $q, search, $location, config) {
    /**
     * Adds 'task' property to the article represented by item.
     *
     * @param {Object} item
     * @param {Object} desk when passed the item will be assigned to this desk instead of user's activeDesk.
     */
    this.addTaskToArticle = function (item, desk) {
        if (desk === void 0) { desk = desks.getCurrentDesk(); }
        if ((!item.task || !item.task.desk) && desk && $location.path() !== '/workspace/personal') {
            item.task = { desk: desk._id, stage: desk.working_stage, user: session.identity._id };
        }
    };
    /**
     * Returns the _type aka repository of the item.
     *
     * @param {Object} item
     * @return String
     *      'ingest' if the state of the item is Ingested
     *      'spike' if the state of the item is Spiked
     *      'archived' if item is archived (no post publish actions)
     *      'archive' if none of the above is returned
     */
    this.getType = function (item) {
        var itemType;
        if (this.isLegal(item)) {
            itemType = item._type;
        }
        else if (this.isArchived(item)) {
            itemType = 'archived';
        }
        else if (item._type === 'externalsource') {
            itemType = 'externalsource';
        }
        else if (item.state === 'spiked') {
            itemType = 'spike';
        }
        else if (item.state === 'ingested') {
            itemType = 'ingest';
        }
        else {
            itemType = 'archive';
        }
        return itemType;
    };
    /**
     * Returns true if the item is fetched from Legal Archive
     *
     * @param {Object} item
     * @return boolean if the item is fetched from Legal Archive, false otherwise.
     */
    this.isLegal = function (item) {
        return item._type === 'legal_archive';
    };
    /**
     * Returns true if the item is fetched from Archived
     *
     * @param {Object} item
     * @return boolean if the item is fetched from Archived, false otherwise.
     */
    this.isArchived = function (item) {
        return item._type === 'archived';
    };
    /**
     * Returns true if the item is in personal workspace
     *
     * @param {Object} item
     * @return boolean
     */
    this.isPersonal = function (item) { return item.task && item.task.user && !item.task.desk; };
    /**
     *  Returns the list of items having the same slugline, type and genre from midnight onwards.
     *  @param {Object} item
     *  @param {Datetime} fromDateTime - from datetime
     *  @return {Object} the list of archive items
     */
    this.getRelatedItems = function (item, fromDateTime) {
        var beforeDateTime = fromDateTime || moment_1.default().subtract(1, 'days')
            .format(config.view.dateformat);
        var params = {};
        params.q = 'slugline.phrase:"' + lodash_1.default.trim(item.slugline) + '"'; // exact match
        params.ignoreKilled = true;
        params.ignoreDigital = true;
        params.versioncreatedfrom = beforeDateTime;
        var query = search.query(params);
        query.size(200);
        if (lodash_1.default.get(item, '_id')) {
            var filter = {
                bool: {
                    must_not: [
                        { bool: { must: [{ term: { _id: item._id } }, { term: { _type: 'archive' } }] } },
                        { bool: { must: [{ term: { item_id: item._id } }, { term: { _type: 'published' } }] } },
                    ],
                    must: [{ term: { type: item.type } }],
                },
            };
            if (lodash_1.default.get(item, 'genre[0].qcode')) {
                filter.bool.must.push({ term: { 'genre.qcode': lodash_1.default.get(item, 'genre[0].qcode') } });
            }
            query.filter(filter);
        }
        var criteria = query.getCriteria(true);
        criteria.repo = 'archive,published';
        return api.query('search', criteria).then(function (result) { return result; });
    };
    /**
     * Returns true if the state of the item is in one of the published states - Scheduled, Published, Corrected
     * and Killed.
     *
     * @param {Object} item
     * @return boolean if the state of the item is in one of the published states, false otherwise.
     */
    this.isPublished = function (item) {
        return lodash_1.default.includes(['published', 'killed', 'scheduled', 'corrected', 'recalled'], item.state);
    };
    /** *
     * Returns versions of the item.
     *
     * @param {Object} item
     * @param {Object} deskService
     * @param {String} versionType one of versions, operations
     * @return list of object where each object is a version of the item
     */
    this.getVersions = function (item, deskService, versionType) {
        if (this.isLegal(item)) {
            return api.find('legal_archive', item._id, { version: 'all', max_results: 200 })
                .then(function (result) {
                lodash_1.default.each(result._items, function (version) {
                    version.desk = version.task && version.task.desk ? version.task.desk : '';
                    version.stage = version.task && version.task.stage ? version.task.stage : '';
                    version.creator = version.version_creator || version.original_creator;
                    if (version.type === 'text') {
                        version.typeName = 'Story';
                    }
                    else {
                        version.typeName = lodash_1.default.capitalize(item.type);
                    }
                });
                if (versionType === 'versions') {
                    return $q.when(lodash_1.default.sortBy(lodash_1.default.reject(result._items, { version: 0 }), '_current_version').reverse());
                }
                else if (versionType === 'operations') {
                    return $q.when(lodash_1.default.sortBy(result._items, '_current_version'));
                }
            });
        }
        return api.find('archive', item._id, { version: 'all', embedded: { user: 1 }, max_results: 200 })
            .then(function (result) {
            lodash_1.default.each(result._items, function (version) {
                if (version.task) {
                    if (version.task.desk) {
                        var versiondesk = deskService.deskLookup[version.task.desk];
                        version.desk = versiondesk && versiondesk.name;
                    }
                    if (version.task.stage) {
                        var versionstage = deskService.stageLookup[version.task.stage];
                        version.stage = versionstage && versionstage.name;
                    }
                }
                if (version.version_creator || version.original_creator) {
                    var versioncreator = deskService.userLookup[version.version_creator || version.original_creator];
                    version.creator = versioncreator && versioncreator.display_name || 'System';
                }
                if (version.type === 'text') {
                    version.typeName = 'Story';
                }
                else {
                    version.typeName = lodash_1.default.capitalize(item.type);
                }
            });
            if (versionType === 'versions') {
                return $q.when(lodash_1.default.sortBy(lodash_1.default.reject(result._items, { version: 0 }), '_current_version').reverse());
            }
            else if (versionType === 'operations') {
                return $q.when(lodash_1.default.sortBy(result._items, '_current_version'));
            }
        });
    };
    /**
     * Get latest version from the list
     *
     * @param {Object} item
     * @param {Object} versions
     * @return last version of the item
     */
    this.lastVersion = function (item, versions) {
        if (item._latest_version) {
            return lodash_1.default.find(versions, { _current_version: item._latest_version });
        }
        var versionsMap = versions.map(function (v) { return v._current_version || v.version; });
        return lodash_1.default.max(versionsMap);
    };
}
exports.ArchiveService = ArchiveService;


/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseListController_1 = __webpack_require__(575);
var lodash_1 = __importDefault(__webpack_require__(2));
var ArchiveListController = /** @class */ (function (_super) {
    __extends(ArchiveListController, _super);
    function ArchiveListController($scope, $injector, $location, $q, $timeout, superdesk, session, api, desks, content, StagesCtrl, notify, multi, search) {
        var _this = _super.call(this, $scope, $location, search, desks) || this;
        var resource, self = _this;
        $scope.currentModule = 'archive';
        $scope.stages = new StagesCtrl($scope);
        $scope.content = content;
        $scope.type = 'archive';
        $scope.repo = {
            ingest: false,
            archive: true,
            search: 'local',
        };
        $scope.loading = false;
        $scope.spike = !!$location.search().spike;
        $scope.published = !!$location.search().published;
        $scope.togglePublished = function togglePublished() {
            if ($scope.spike) {
                $scope.toggleSpike();
            }
            $scope.published = !$scope.published;
            $location.search('published', $scope.published ? '1' : null);
            $location.search('_id', null);
            $scope.stages.select(null);
        };
        $scope.toggleSpike = function toggleSpike() {
            if ($scope.published) {
                $scope.togglePublished();
            }
            $scope.spike = !$scope.spike;
            $location.search('spike', $scope.spike ? 1 : null);
            $location.search('_id', null);
            $scope.stages.select(null);
        };
        $scope.stageSelect = function (stage) {
            if ($scope.spike) {
                $scope.toggleSpike();
            }
            if ($scope.published) {
                $scope.togglePublished();
            }
            $scope.stages.select(stage);
            multi.reset();
        };
        _this.fetchItems = function fetchItems(criteria, next) {
            if (lodash_1.default.isNil(resource)) {
                return;
            }
            $scope.loading = true;
            criteria.aggregations = 1;
            criteria.es_highlight = search.getElasticHighlight();
            resource.query(criteria).then(function (items) {
                $scope.loading = false;
                $scope.items = search.mergeItems(items, $scope.items, next);
                $scope.total = items._meta.total;
            }, function () {
                $scope.loading = false;
            });
        };
        _this.fetchItem = function fetchItem(id) {
            if (lodash_1.default.isNil(resource)) {
                return $q.reject(id);
            }
            return resource.getById(id);
        };
        var refreshPromise, refreshItems = function () {
            $timeout.cancel(refreshPromise);
            refreshPromise = $timeout(_refresh, 100, false);
        };
        function _refresh() {
            if (desks.active.desk) {
                if ($scope.published) {
                    resource = api('published');
                }
                else {
                    resource = api('archive');
                }
            }
            else {
                resource = api('user_content', session.identity);
            }
            self.refresh(true);
        }
        function reset(event, data) {
            if (data && data.item) {
                if ($location.search()._id === data.item) {
                    $location.search('_id', null);
                }
            }
            refreshItems();
        }
        $scope.$on('task:stage', function (_e, data) {
            if ($scope.stages.selected && ($scope.stages.selected._id === data.new_stage ||
                $scope.stages.selected._id === data.old_stage)) {
                refreshItems();
            }
        });
        $scope.$on('media_archive', refreshItems);
        $scope.$on('item:fetch', refreshItems);
        $scope.$on('item:copy', refreshItems);
        $scope.$on('item:take', refreshItems);
        $scope.$on('item:duplicate', refreshItems);
        $scope.$on('item:translate', refreshItems);
        $scope.$on('content:update', refreshItems);
        $scope.$on('item:deleted', refreshItems);
        $scope.$on('item:highlights', refreshItems);
        $scope.$on('item:unlink', refreshItems);
        $scope.$on('item:marked_desks', refreshItems);
        $scope.$on('item:spike', reset);
        $scope.$on('item:unspike', reset);
        desks.fetchCurrentUserDesks().then(function () {
            // only watch desk/stage after we get current user desk
            $scope.$watch(function () { return desks.active; }, function (active) {
                $scope.selected = active;
                if ($location.search().page) {
                    $location.search('page', null);
                    return; // will reload via $routeUpdate
                }
                refreshItems();
            });
        });
        // reload on route change if there is still the same _id
        var oldQuery = lodash_1.default.omit($location.search(), '_id', 'fetch');
        $scope.$on('$routeUpdate', function (e, route) {
            var query = lodash_1.default.omit($location.search(), '_id', 'fetch');
            if (!angular.equals(oldQuery, query)) {
                refreshItems();
            }
            oldQuery = query;
        });
        return _this;
    }
    return ArchiveListController;
}(BaseListController_1.BaseListController));
exports.ArchiveListController = ArchiveListController;
ArchiveListController.$inject = [
    '$scope', '$injector', '$location', '$q', '$timeout', 'superdesk',
    'session', 'api', 'desks', 'content', 'StagesCtrl', 'notify', 'multi', 'search',
];


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var exif_js_1 = __importDefault(__webpack_require__(1947));
var lodash_1 = __importDefault(__webpack_require__(2));
var image_preview_directive_1 = __webpack_require__(547);
var utils_1 = __webpack_require__(3);
var lodash_2 = __webpack_require__(2);
/* eslint-disable complexity */
var getExifData = function (file) { return new Promise(function (resolve) {
    exif_js_1.default.getData(file, function () {
        resolve(this);
    });
}); };
function serializePromises(promiseCreators) {
    var promise = Promise.resolve();
    return Promise.all(promiseCreators.map(function (promiseCreator) {
        promise = promise.then(promiseCreator);
        return promise;
    }));
}
UploadController.$inject = [
    '$scope',
    '$q',
    'upload',
    'api',
    'archiveService',
    'session',
    'deployConfig',
    'desks',
    'notify',
    '$location',
];
function UploadController($scope, $q, upload, api, archiveService, session, deployConfig, desks, notify, $location) {
    $scope.items = [];
    $scope.saving = false;
    $scope.failed = false;
    $scope.enableSave = false;
    $scope.currentUser = session.identity;
    $scope.uniqueUpload = $scope.locals && $scope.locals.data && $scope.locals.data.uniqueUpload === true;
    $scope.maxUploads = !$scope.uniqueUpload && $scope.locals && $scope.locals.data &&
        $scope.locals.data.maxUploads ? $scope.locals.data.maxUploads : undefined;
    $scope.allowPicture = !($scope.locals && $scope.locals.data && $scope.locals.data.allowPicture === false);
    $scope.allowVideo = !($scope.locals && $scope.locals.data && $scope.locals.data.allowVideo === false);
    $scope.allowAudio = !($scope.locals && $scope.locals.data && $scope.locals.data.allowAudio === false);
    $scope.validator = lodash_1.default.omit(deployConfig.getSync('validator_media_metadata'), ['archive_description']);
    $scope.deskSelectionAllowed = ($location.path() !== '/workspace/personal') && $scope.locals &&
        $scope.locals.data && $scope.locals.data.deskSelectionAllowed === true;
    if ($scope.deskSelectionAllowed === true) {
        Promise.all([desks.fetchDesks(), desks.getCurrentDesk()]).then(function (_a) {
            var _desks = _a[0], currentDesk = _a[1];
            $scope.desks = _desks._items;
            $scope.selectedDesk = currentDesk;
        });
    }
    $scope.selectDesk = function (desk) {
        $scope.selectedDesk = desk;
    };
    var pseudoId = 0;
    var getPseudoId = function () { return ++pseudoId; };
    var getItemByMetaId = function (metaId) { return $scope.items.find(function (item) { return item.meta_id === metaId; }); };
    $scope.onRemoveItem = function (imageMeta) {
        $scope.items = $scope.items.filter(function (item) { return item.meta_id !== imageMeta._id; });
        $scope.imagesMetadata = $scope.items.map(function (item) { return item.meta; });
    };
    $scope.imagesMetadata = [];
    $scope.getProgress = function (imageMeta) {
        var item = getItemByMetaId(imageMeta._id);
        if (item == null) {
            return 0;
        }
        else {
            return item.progress || 0;
        }
    };
    $scope.getThumbnailHtml = function (imageMeta) {
        var item = getItemByMetaId(imageMeta._id);
        return item == null ? '' : item.thumbnailHtml;
    };
    $scope.getIconForItemType = function (imageMeta) {
        var item = getItemByMetaId(imageMeta._id);
        return 'icon-' + (item.cssType === 'image' ? 'photo' : item.cssType);
    };
    $scope.invokeImagesInput = function () {
        var el = document.querySelector('#images-input');
        el.click();
    };
    $scope.isDragging = false;
    $scope.drag = function ($isDragging, $class, $event) {
        $scope.isDragging = $isDragging;
        $scope.$apply();
    };
    $scope.handleImageMetadataEdit = function (editedMetadataItems) {
        editedMetadataItems.forEach(function (metaItem) {
            var item = $scope.items.find(function (i) { return i.meta_id === metaItem._id; });
            if (item != null) {
                item.meta = metaItem;
                // the item is not created yet, so has no real id
                // it only has local pseudo-id for multi metadata editing to work
                delete item.meta._id;
            }
        });
        return $scope.save();
    };
    var uploadFile = function (item) {
        var handleError = function (reason) {
            item.model = false;
            $scope.failed = true;
            return $q.reject(reason);
        };
        return item.upload || api.archive.getUrl()
            .then(function (url) {
            item.upload = upload.start({
                method: 'POST',
                url: url,
                data: { media: item.file },
                headers: api.archive.getHeaders(),
            });
            item.upload.then(function (response) {
                if (response.data._issues) {
                    return handleError(response);
                }
                item.progress = 100;
                item.model = response.data;
                return item;
            }, handleError, function (progress) {
                // limit progress to 90% and set 100 only after request is done
                item.progress = Math.min(Math.round(progress.loaded / progress.total * 100.0), 90);
            });
            return item.upload;
        });
    };
    var checkFail = function () {
        $scope.failed = lodash_1.default.some($scope.items, { model: false });
    };
    var initFile = function (file, meta, id) {
        var item = {
            file: file,
            meta: meta,
            progress: 0,
            cssType: file.type.split('/')[0],
            thumbnailHtml: '',
        };
        if (id != null) {
            item.meta._id = id;
            item['meta_id'] = id;
        }
        $scope.items.unshift(item);
        $scope.enableSave = $scope.items.length > 0;
        return item;
    };
    $scope.addFiles = function (files) {
        $scope.isDragging = false;
        if (!files.length) {
            return false;
        }
        if ($scope.uniqueUpload && files.length > 1) {
            notify.error(utils_1.gettext('Only one file can be uploaded'));
            return false;
        }
        if (!$scope.uniqueUpload && $scope.maxUploads && (files.length + $scope.items.length) > $scope.maxUploads) {
            notify.error(utils_1.gettext('Select at most {{maxUploads}} files to upload.', { maxUploads: $scope.maxUploads }));
            return false;
        }
        var acceptedFiles = [];
        var uploadOfDisallowedFileTypesAttempted = false;
        lodash_1.default.each(files, function (file) {
            if (/^image/.test(file.type)) {
                if ($scope.allowPicture) {
                    acceptedFiles.push({
                        file: file,
                        getThumbnail: function (f) { return image_preview_directive_1.getDataUrl(f).then(function (uri) { return "<img src=\"" + uri + "\" />"; }); },
                    });
                }
                else {
                    uploadOfDisallowedFileTypesAttempted = true;
                }
            }
            else if (/^video/.test(file.type)) {
                if ($scope.allowVideo) {
                    acceptedFiles.push({
                        file: file,
                        getThumbnail: function () { return Promise.resolve('<i class="icon--2x icon-video"></i>'); },
                    });
                }
                else {
                    uploadOfDisallowedFileTypesAttempted = true;
                }
            }
            else if (/^audio/.test(file.type)) {
                if ($scope.allowAudio) {
                    acceptedFiles.push({
                        file: file,
                        getThumbnail: function () { return Promise.resolve('<i class="icon--2x icon-audio"></i>'); },
                    });
                }
                else {
                    uploadOfDisallowedFileTypesAttempted = true;
                }
            }
            else {
                uploadOfDisallowedFileTypesAttempted = true;
            }
        });
        if (uploadOfDisallowedFileTypesAttempted) {
            var message = utils_1.gettext('Only the following files are allowed: ')
                + ($scope.allowPicture ? utils_1.gettext('image') : '')
                + ($scope.allowVideo ? ', ' + utils_1.gettext('video') : '')
                + ($scope.allowAudio ? ', ' + utils_1.gettext('audio') : '');
            notify.error(message);
        }
        return acceptedFiles.length < 1
            ? Promise.resolve()
            : Promise.all(acceptedFiles.map(function (_a) {
                var file = _a.file, getThumbnail = _a.getThumbnail;
                return getExifData(file)
                    .then(function (fileWithExif) {
                    var fileMeta = fileWithExif['iptcdata'];
                    var item = initFile(fileWithExif, {
                        byline: fileMeta.byline || $scope.currentUser.byline,
                        headline: fileMeta.headline,
                        description_text: fileMeta.caption,
                        copyrightnotice: fileMeta.copyright,
                    }, getPseudoId());
                    return getThumbnail(file).then(function (htmlString) { return item.thumbnailHtml = htmlString; });
                });
            })).then(function () {
                $scope.$applyAsync(function () {
                    $scope.imagesMetadata = $scope.items.map(function (item) { return item.meta; });
                });
            });
    };
    $scope.upload = function () {
        if (lodash_2.isEmpty($scope.items)) {
            return Promise.resolve();
        }
        // upload items in sequence, and resolve when all are done
        return serializePromises($scope.items.map(function (item) {
            if (!item.model && !item.progress) {
                item.upload = null;
                return function () { return uploadFile(item); };
            }
            return function () { return Promise.resolve(item); };
        }));
    };
    $scope.save = function () {
        $scope.saving = true;
        return $scope.upload().then(function () {
            $q.all(lodash_1.default.map($scope.items, function (item) {
                archiveService.addTaskToArticle(item.meta, $scope.selectedDesk);
                return api.archive.update(item.model, item.meta);
            })).then(function (results) {
                $scope.resolve(results);
            });
        })
            .finally(function () {
            $scope.saving = false;
            checkFail();
        });
    };
    $scope.cancel = function () {
        $scope.reject();
    };
    $scope.tryAgain = function () {
        $scope.failed = null;
        $scope.upload();
    };
    $scope.canUpload = function () {
        if ($scope.uniqueUpload) {
            return $scope.items.length === 0;
        }
        return $scope.maxUploads === undefined || $scope.maxUploads > $scope.items.length;
    };
    if ($scope.locals && $scope.locals.data) {
        if ($scope.locals.data.files) {
            $scope.addFiles($scope.locals.data.files);
        }
        else {
            $scope.addFiles($scope.locals.data);
        }
    }
}
exports.UploadController = UploadController;


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

     // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
               var xmpdata= findXMPinJPEG(binFile);
               img.xmpdata = xmpdata || {};               
            }
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    function getNextIFDOffset(dataView, dirStart, bigEnd){
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);

        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }

    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        }
        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);

        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)

        // EXIF 2.3 specification for JPEG format thumbnail

        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');

            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                break;

            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);

        return tags;
    }

   function findXMPinJPEG(file) {

        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
           if (debug) console.log("Not a valid JPEG");
           return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < (length-4)) {
            if (getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );

                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp)
                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
                            + xmpString.slice(indexOfXmp)

                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
                return xml2Object(domDocument);
            } else{
             offset++;
            }
        }
    }

    function xml2json(xml) {
        var json = {};
      
        if (xml.nodeType == 1) { // element node
          if (xml.attributes.length > 0) {
            json['@attributes'] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) { // text node
          return xml.nodeValue;
        }
      
        // deal with children
        if (xml.hasChildNodes()) {
          for(var i = 0; i < xml.childNodes.length; i++) {
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) {
              json[nodeName] = xml2json(child);
            } else {
              if (json[nodeName].push == null) {
                var old = json[nodeName];
                json[nodeName] = [];
                json[nodeName].push(old);
              }
              json[nodeName].push(xml2json(child));
            }
          }
        }
        
        return json;
    }

    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
              for (var i = 0; i < xml.children.length; i++) {
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes) {
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;

                    if(dataKey !== undefined) {
                        obj[dataKey] = dataValue;
                    }
                }
                var nodeName = item.nodeName;

                if (typeof (obj[nodeName]) == "undefined") {
                  obj[nodeName] = xml2json(item);
                } else {
                  if (typeof (obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];

                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                  obj[nodeName].push(xml2json(item));
                }
              }
            } else {
              obj = xml.textContent;
            }
            return obj;
          } catch (e) {
              console.log(e.message);
          }
    }

    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    }

    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    }

    EXIF.getData = function(img, callback) {
        if (((self.Image && img instanceof self.Image)
            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
            && !img.complete)
            return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }
    
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
            return EXIF;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}.call(this));



/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
UploadAttachmentsController.$inject = ['$scope', '$q', 'urls', 'upload'];
function UploadAttachmentsController($scope, $q, urls, upload) {
    $scope.saving = false;
    $scope.items = $scope.locals.data;
    /**
     * Upload file
     */
    function uploadFile(item) {
        item.promise = urls.resource('attachments')
            .then(function (uploadURL) { return upload.start({
            method: 'POST',
            url: uploadURL,
            data: { media: item.file, title: item.meta.title, description: item.meta.description },
        }); })
            .then(function (response) {
            item.attachment = response.data;
            return item.attachment;
        }, function (error) {
            item.error = error;
        }, function (progress) {
            item.progress = progress.loaded / progress.total * 100.0;
        });
        return item.promise;
    }
    // init
    $scope.items = $scope.locals.data.map(function (file) { return ({ file: file }); });
    // upload files
    $scope.save = function () { return $q.all($scope.items.map(uploadFile))
        .then($scope.resolve); };
    // close
    $scope.cancel = function () { return $scope.reject(); };
    // remove uploaded item
    $scope.cancelItem = function (item) {
        $scope.items = lodash_1.default.without($scope.items, item);
        if (!$scope.items.length) {
            $scope.cancel();
        }
    };
}
exports.UploadAttachmentsController = UploadAttachmentsController;


/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
DuplicateController.$inject = ['api', 'notify', '$rootScope', 'data', 'desks', '$location', 'workspaces', 'session'];
function DuplicateController(api, notify, $rootScope, data, desks, $location, workspaces, session) {
    var currentDeskId;
    if ($location.path() === '/search' || workspaces.isCustom()) {
        currentDeskId = session.identity.desk || data.item.task.desk;
    }
    currentDeskId = currentDeskId || desks.getCurrentDeskId();
    api.save('duplicate', {}, {
        desk: currentDeskId,
        type: data.item._type,
        item_id: data.item.item_id,
    }, data.item)
        .then(function () {
        $rootScope.$broadcast('item:duplicate');
        notify.success(utils_1.gettext('Item Duplicated'));
    });
}
exports.DuplicateController = DuplicateController;


/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
__webpack_require__(1951);
__webpack_require__(1953);
__webpack_require__(1955);
var ctrl = __importStar(__webpack_require__(1956));
var config = __importStar(__webpack_require__(1958));
var directive = __importStar(__webpack_require__(1959));
var svc = __importStar(__webpack_require__(1968));
var filters_1 = __webpack_require__(1970);
var MonitoringController_1 = __webpack_require__(1971);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.monitoring
 * @name superdesk.apps.monitoring
 * @packageName superdesk.apps
 * @description Monitoring support for Superdesk content. Adds a new main tab
 * to the application.
 */
angular.module('superdesk.apps.monitoring', [
    'superdesk.core.api',
    'superdesk.apps.aggregate',
    'superdesk.apps.search',
    'superdesk.core.ui',
    'superdesk.apps.workspace.menu',
])
    .controller('Monitoring', MonitoringController_1.MonitoringController)
    .service('cards', svc.CardsService)
    .directive('sdMonitoringView', directive.MonitoringView)
    .directive('sdMonitoringGroup', directive.MonitoringGroup)
    .directive('sdMonitoringGroupHeader', directive.MonitoringGroupHeader)
    .directive('sdDeskNotifications', directive.DeskNotifications)
    .directive('sdItemActionsMenu', directive.ItemActionsMenu)
    .config(config.Monitoring)
    .config(config.SpikeMonitoring)
    .config(config.Personal)
    .filter('splitText', filters_1.SplitFilter)
    .run(['keyboardManager', function (keyboardManager) {
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + j', utils_1.gettext('Switch between grouped/single stage view'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + g', utils_1.gettext('Switch between grouped/single desk view'));
        keyboardManager.register('Monitoring / List actions', 'page down', utils_1.gettext('Move focus to next stage or group'));
        keyboardManager.register('Monitoring / List actions', 'page up', utils_1.gettext('Move focus to previous stage or group'));
        keyboardManager.register('Monitoring / List actions', 'down/right Arrow', utils_1.gettext('Select next item on focused stage or group'));
        keyboardManager.register('Monitoring / List actions', 'up/left Arrow', utils_1.gettext('Select previous item on focused stage or group'));
        keyboardManager.register('Monitoring / List actions', 'alt + o', utils_1.gettext('View an item'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + e', utils_1.gettext('Edit an item'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + enter', utils_1.gettext('Fetch an item'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + n', utils_1.gettext('Edit an item in a new Window'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + d', utils_1.gettext('Duplicate an item'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + b', utils_1.gettext('Create a broadcast'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + shift + #', utils_1.gettext('Spike item(s)'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + alt + p', utils_1.gettext('Create Package'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + shift + ^', utils_1.gettext('Mark for highlight'));
        keyboardManager.register('Monitoring / List actions', 'ctrl + shift + !', utils_1.gettext('Mark for desk'));
    }]);
angular.module('superdesk.apps.aggregate', [
    'superdesk.apps.authoring.widgets',
    'superdesk.apps.desks',
    'superdesk.apps.workspace',
])
    .controller('AggregateCtrl', ctrl.AggregateCtrl)
    .directive('sdAggregateSettings', directive.AggregateSettings)
    .directive('sdSortGroups', directive.SortGroups)
    .directive('sdWidgetGroup', directive.WidgetGroup);


/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1952);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./aggregate.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./aggregate.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.widget-search.tabpane,\n.widget-aggregate.tabpane {\n  width: auto; }\n  .widget-search.tabpane .widget-header,\n  .widget-aggregate.tabpane .widget-header {\n    display: none; }\n  .widget-search.tabpane .tabcontent,\n  .widget-aggregate.tabpane .tabcontent {\n    position: relative;\n    overflow: initial;\n    padding: 0;\n    left: 0;\n    right: 0;\n    height: 100%; }\n  .widget-search.tabpane .widget-content,\n  .widget-aggregate.tabpane .widget-content {\n    position: relative;\n    top: 0;\n    overflow: initial;\n    padding-bottom: 0;\n    border-top: 0;\n    height: 100%; }\n    .widget-search.tabpane .widget-content > div,\n    .widget-aggregate.tabpane .widget-content > div {\n      height: 100%; }\n\n.sd-widget.search,\n.tabpane .sd-widget.aggregate {\n  position: relative;\n  height: 100%; }\n\n.sd-widget.search .content-search,\n.sd-widget.aggregate .content-search {\n  position: relative;\n  background: #f5f5f5;\n  width: 460px;\n  height: 100%;\n  overflow: hidden; }\n  .sd-widget.search .content-search.extended,\n  .sd-widget.aggregate .content-search.extended {\n    width: 900px; }\n\n.sd-widget.search .search-container,\n.sd-widget.aggregate .search-container {\n  position: absolute;\n  width: 460px;\n  top: 0;\n  left: 0;\n  bottom: 0; }\n  .sd-widget.search .search-container .search-box,\n  .sd-widget.aggregate .search-container .search-box {\n    display: flex;\n    box-sizing: border-box;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 48px;\n    border-bottom: 1px solid #dcdcdc;\n    background: #fff url(" + escape(__webpack_require__(75)) + ") no-repeat 15px 16px; }\n    .sd-widget.search .search-container .search-box input,\n    .sd-widget.aggregate .search-container .search-box input {\n      position: static;\n      flex: 1;\n      width: auto;\n      height: 100%;\n      padding-left: 46px;\n      box-sizing: border-box;\n      border: 0 !important;\n      background: transparent; }\n      .sd-widget.search .search-container .search-box input:focus,\n      .sd-widget.aggregate .search-container .search-box input:focus {\n        box-shadow: none !important; }\n    .sd-widget.search .search-container .search-box .more-actions,\n    .sd-widget.aggregate .search-container .search-box .more-actions {\n      position: relative;\n      margin: auto;\n      height: 22px;\n      width: 28px;\n      right: 0px;\n      top: 0; }\n  .sd-widget.search .search-container .filter-list,\n  .sd-widget.aggregate .search-container .filter-list {\n    position: absolute;\n    top: 48px;\n    left: 0;\n    right: 0;\n    height: 48px;\n    box-sizing: border-box;\n    border-bottom: 1px solid #dcdcdc;\n    padding: 10px; }\n  .sd-widget.search .search-container .content-list,\n  .sd-widget.aggregate .search-container .content-list {\n    position: absolute;\n    top: 48px;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    padding: 0 10px 10px;\n    overflow: auto; }\n\n.sd-widget.search .preview-container,\n.sd-widget.aggregate .preview-container {\n  width: 440px;\n  position: absolute;\n  left: 460px;\n  bottom: 0;\n  top: 0;\n  border-right: 1px solid #bbb;\n  background: #fff;\n  box-sizing: border-box;\n  box-shadow: inset 1px 0 0 #dcdcdc; }\n  .sd-widget.search .preview-container > header,\n  .sd-widget.aggregate .preview-container > header {\n    border-bottom: 1px solid #dcdcdc;\n    padding: 0 15px; }\n  .sd-widget.search .preview-container .close-preview,\n  .sd-widget.aggregate .preview-container .close-preview {\n    position: absolute;\n    right: 10px;\n    top: 10px; }\n  .sd-widget.search .preview-container > .content-item-preview,\n  .sd-widget.aggregate .preview-container > .content-item-preview {\n    position: absolute;\n    top: 48px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 20px;\n    overflow: auto; }\n\n.sd-widget.search .search-container .content-list {\n  top: 96px; }\n  .sd-widget.search .search-container .content-list > ul {\n    padding-right: 10px; }\n    .sd-widget.search .search-container .content-list > ul > li {\n      position: relative;\n      background: #fff;\n      border-bottom: 1px solid #ededed;\n      box-sizing: border-box;\n      padding: 7px 10px;\n      line-height: 12px;\n      border-right: 2px solid #fff; }\n      .sd-widget.search .search-container .content-list > ul > li .select-box {\n        width: 32px;\n        height: 21px;\n        float: left;\n        margin-right: 10px; }\n        .sd-widget.search .search-container .content-list > ul > li .select-box .select {\n          position: absolute;\n          left: 15px;\n          top: 10px;\n          display: none; }\n        .sd-widget.search .search-container .content-list > ul > li .select-box i {\n          display: inline-block; }\n      .sd-widget.search .search-container .content-list > ul > li:not(.added) .select-box:hover .select {\n        display: block; }\n      .sd-widget.search .search-container .content-list > ul > li:not(.added) .select-box:hover i {\n        display: none; }\n      .sd-widget.search .search-container .content-list > ul > li .item-functions {\n        display: none;\n        position: absolute;\n        right: 0;\n        top: 0; }\n        .sd-widget.search .search-container .content-list > ul > li .item-functions li {\n          padding: 6px; }\n      .sd-widget.search .search-container .content-list > ul > li:hover {\n        background: #f4f4f4;\n        cursor: pointer;\n        padding-right: 40px;\n        border-right-color: #f4f4f4; }\n        .sd-widget.search .search-container .content-list > ul > li:hover .item-functions {\n          display: block; }\n      .sd-widget.search .search-container .content-list > ul > li [class^=\"filetype-icon-\"] {\n        margin: -1px 4px 0 -4px;\n        opacity: 0.8;\n        filter: \"alpha(opacity=80)\"; }\n      .sd-widget.search .search-container .content-list > ul > li p {\n        overflow: hidden;\n        width: 80%;\n        height: 18px;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        margin-left: 0; }\n        .sd-widget.search .search-container .content-list > ul > li p .keyword {\n          font-weight: 500;\n          text-transform: uppercase;\n          color: #216278;\n          margin-right: 10px; }\n      .sd-widget.search .search-container .content-list > ul > li .group-select .dropdown__menu {\n        margin-top: -3px;\n        padding: 0; }\n        .sd-widget.search .search-container .content-list > ul > li .group-select .dropdown__menu:before {\n          display: none; }\n        .sd-widget.search .search-container .content-list > ul > li .group-select .dropdown__menu > li {\n          padding: 3px 6px; }\n          .sd-widget.search .search-container .content-list > ul > li .group-select .dropdown__menu > li:first-child {\n            padding-top: 6px; }\n          .sd-widget.search .search-container .content-list > ul > li .group-select .dropdown__menu > li:last-child {\n            padding-bottom: 6px; }\n      .sd-widget.search .search-container .content-list > ul > li.added {\n        background: #fafafa;\n        border-right-color: #ddd;\n        opacity: 0.5;\n        filter: \"alpha(opacity=50)\"; }\n        .sd-widget.search .search-container .content-list > ul > li.added:hover {\n          padding-right: 10px; }\n      .sd-widget.search .search-container .content-list > ul > li.active {\n        background: #eff7fa;\n        border-right-color: #5ea9c8; }\n      .sd-widget.search .search-container .content-list > ul > li.multi-select {\n        background: #ccfbd6;\n        border-bottom-color: #a4e4b1; }\n\n.content-list .stage {\n  margin: 10px 0 15px; }\n  .content-list .stage .stage-content {\n    margin: 5px 0 20px;\n    overflow-y: auto;\n    position: relative; }\n\n.widget-container .content-list-holder {\n  background-color: #fafafa; }\n  .widget-container .content-list-holder .desk {\n    width: 100%; }\n\n.widget-container .content-list .stage {\n  margin: 10px 0 0; }\n  .widget-container .content-list .stage .stage-header {\n    margin: 0 4px 4px 4px; }\n  .widget-container .content-list .stage .stage-content {\n    padding: 5px 3px;\n    margin: 0 0 10px; }\n\n.stage-header {\n  display: flex;\n  align-items: center;\n  height: 20px;\n  margin-bottom: 8px; }\n  .stage-header .stage-header__line, .stage-header .stage-header__stretch-bar {\n    height: 1px;\n    margin: auto 4px;\n    background: #dcdcdc;\n    flex: 1; }\n  .stage-header .stage-header__stretch-bar {\n    background: transparent;\n    margin: auto 0; }\n  .stage-header .stage-header__name {\n    font-size: 11px;\n    line-height: 11px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    display: flex;\n    align-items: center; }\n    .stage-header .stage-header__name a, .stage-header .stage-header__name .stage-header__name-part {\n      display: inline-flex;\n      align-items: center; }\n    .stage-header .stage-header__name span + span {\n      margin-left: 5px; }\n  .stage-header .stage-header__separator {\n    padding: 0 6px; }\n  .stage-header .stage-header__toggle {\n    border: 0;\n    padding: 0;\n    margin: 0 5px 0 0;\n    display: flex;\n    background: transparent; }\n    .stage-header .stage-header__toggle i {\n      -webkit-transition: all 0.2s ease;\n      -o-transition: all 0.2s ease;\n      transition: all 0.2s ease; }\n    .stage-header .stage-header__toggle.closed i {\n      -webkit-transform: rotate(-90deg);\n      transform: rotate(-90deg);\n      margin: auto; }\n  .stage-header .stage-header__number,\n  .stage-header .stage-header__notification {\n    margin: 0 0 0 4px; }\n  .stage-header .stage-header__name + .stage-header__number {\n    margin-left: 10px; }\n\n.sd-kanban-list__board-header .stage-header {\n  margin-bottom: 0; }\n\n.notification-label, .label-total {\n  margin: 0;\n  box-sizing: border-box;\n  padding: 4px 6px;\n  height: 16px;\n  border-radius: 10px;\n  color: #fff !important;\n  background: #5ea9c8;\n  font-size: 10px;\n  line-height: 100%;\n  letter-spacing: .06em;\n  font-weight: 400;\n  vertical-align: middle; }\n\n.label-total {\n  background: #999; }\n\n.refresh-box {\n  display: flex; }\n  .refresh-box button {\n    background: none; }\n    .refresh-box button.btnRefresh {\n      margin-right: 3px;\n      padding-left: 0;\n      height: 26px;\n      position: absolute;\n      right: 12px; }\n      .refresh-box button.btnRefresh:hover {\n        opacity: 0.9;\n        filter: \"alpha(opacity=90)\"; }\n\n.content-list-holder {\n  position: absolute;\n  top: 38px;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n  .content-list-holder .desk {\n    width: 99%; }\n\n.sd-widget.aggregate .content-list-holder .content-list {\n  padding: 0 5px; }\n\n.sd-widget.aggregate .preview.preview-widget {\n  opacity: 0;\n  animation-delay: 0.5s;\n  animation: fadeIn3 0.2s ease-out 1;\n  opacity: 1; }\n  .sd-widget.aggregate .preview.preview-widget ul.nav {\n    height: 35px;\n    line-height: 35px;\n    background: inherit; }\n    .sd-widget.aggregate .preview.preview-widget ul.nav > li > button {\n      height: 35px;\n      line-height: 19px; }\n  .sd-widget.aggregate .preview.preview-widget ul.nav.nav-tabs {\n    height: 35px;\n    line-height: 35px;\n    border-bottom: none; }\n  .sd-widget.aggregate .preview.preview-widget .content-item-preview .content-container, .sd-widget.aggregate .preview.preview-widget .content-item-preview .metadata-view {\n    top: 70px; }\n  .sd-widget.aggregate .preview.preview-widget .package-item.item .item-actions-menu {\n    display: none; }\n\n.sd-widget.aggregate .preview.preview-widget.custom-widget .nav {\n  display: none; }\n\n.sd-widget.aggregate .preview.preview-widget.custom-widget ul.nav.nav-tabs {\n  display: flex;\n  border-top: 1px solid rgba(123, 123, 123, 0.3);\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 rgba(0, 0, 0, 0.08); }\n\n.sd-widget.aggregate .preview.preview-widget.custom-widget .content-item-preview .content-container, .sd-widget.aggregate .preview.preview-widget.custom-widget .content-item-preview .metadata-view {\n  top: 36px; }\n\n.aggregate-widget-config .legend {\n  color: #999;\n  text-transform: none;\n  font-size: 16px;\n  color: #333;\n  font-weight: 400;\n  margin-bottom: 16px;\n  margin-top: 10px;\n  padding: 0; }\n\n.aggregate-widget-config .legend + div[sd-toggle-box] {\n  margin-top: 30px; }\n\n.aggregate-widget-config .desk {\n  padding: 5px 0;\n  border-bottom: 1px dotted rgba(123, 123, 123, 0.5); }\n  .aggregate-widget-config .desk:first-of-type {\n    border-top: 1px dotted rgba(123, 123, 123, 0.5); }\n  .aggregate-widget-config .desk--item-count {\n    display: flex;\n    align-items: center; }\n    .aggregate-widget-config .desk--item-count .desk-title {\n      flex-grow: 1; }\n    .aggregate-widget-config .desk--item-count .box-items-count {\n      width: 14%; }\n\n.aggregate-widget-config .content .desk:first-of-type {\n  border-top: 1px dotted rgba(123, 123, 123, 0.5) !important; }\n\n.aggregate-widget-config .desk-title {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 5px 0; }\n  .aggregate-widget-config .desk-title i {\n    font-size: 12px;\n    font-weight: 100; }\n  .aggregate-widget-config .desk-title .search-description {\n    font-size: 12px;\n    font-weight: 300;\n    color: #747474; }\n  .aggregate-widget-config .desk-title--80 {\n    width: 80%; }\n  .aggregate-widget-config .desk-title--saved-search {\n    display: flex; }\n    .aggregate-widget-config .desk-title--saved-search .switch {\n      flex-grow: 0;\n      flex-shrink: 0; }\n    .aggregate-widget-config .desk-title--saved-search .desk-title__text {\n      flex-grow: 1; }\n\n.aggregate-widget-config .desk-title__text {\n  display: inline-block;\n  padding-left: 1rem; }\n\n.aggregate-widget-config .stages {\n  overflow: hidden;\n  margin: 5px 0 0; }\n  .aggregate-widget-config .stages li {\n    float: left;\n    overflow: hidden; }\n  .aggregate-widget-config .stages .sd-check__wrapper {\n    margin: 0 5px 5px 0; }\n\n.placeholder {\n  margin: 20px 0; }\n", ""]);

// exports


/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1954);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./monitoring.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./monitoring.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.monitoring {\n  position: absolute;\n  top: 48px;\n  left: 0;\n  right: 0;\n  bottom: 0; }\n  .monitoring .subnav {\n    top: 0; }\n    .monitoring .subnav .sortbar-container {\n      padding: 10px 16px 10px 0; }\n    .monitoring .subnav .sortbar {\n      margin: 0 0 0 15px;\n      padding: 0 0 0 10px;\n      height: 25px; }\n      .monitoring .subnav .sortbar .lab {\n        line-height: 20px; }\n    .monitoring .subnav .dropdown .sortbar {\n      width: 100%;\n      height: auto;\n      margin: 0;\n      padding: 0;\n      text-align: left;\n      border-left: 0; }\n    .monitoring .subnav .dropdown .dropdown {\n      min-width: 120px;\n      float: right; }\n    .monitoring .subnav .dropdown .direction {\n      line-height: 18px;\n      margin-left: 15px; }\n    .monitoring .subnav .navbtn.btnRearrange {\n      width: 80px !important; }\n    .monitoring .subnav .title {\n      text-transform: uppercase; }\n    .monitoring .subnav .dropdown__menu .label-group {\n      text-transform: capitalize; }\n  .monitoring .main-section {\n    top: 0; }\n    .monitoring .main-section .content-list {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      overflow-y: auto;\n      transition: all 0.3s;\n      box-sizing: border-box;\n      padding: 0 !important; }\n      .monitoring .main-section .content-list.monitoring__content {\n        display: flex;\n        flex-direction: column; }\n      .monitoring .main-section .content-list .list {\n        padding-top: 9px; }\n      .monitoring .main-section .content-list .stage {\n        padding: 0;\n        margin: 9px 0; }\n      .monitoring .main-section .content-list .single-group .stage {\n        margin: 0; }\n      .monitoring .main-section .content-list .stage-content {\n        max-height: 100%;\n        overflow-y: auto;\n        box-shadow: 0px 1px 4px 0 rgba(0, 0, 0, 0.2); }\n        .monitoring .main-section .content-list .stage-content:focus {\n          box-shadow: 0px 0px 10px 0px #939393; }\n        .monitoring .main-section .content-list .stage-content .compact-view, .monitoring .main-section .content-list .stage-content .mlist-view {\n          box-shadow: none; }\n        .monitoring .main-section .content-list .stage-content.refresh {\n          border: solid thin #5d9bc0;\n          box-shadow: 0px 0px 10px 0px #5d9bc0; }\n        .monitoring .main-section .content-list .stage-content .list-view {\n          margin-bottom: 0; }\n          .monitoring .main-section .content-list .stage-content .list-view.list-without-items {\n            height: 38px !important; }\n            .monitoring .main-section .content-list .stage-content .list-view.list-without-items li {\n              line-height: 38px;\n              text-align: center;\n              color: #999; }\n      .monitoring .main-section .content-list .inline-content-items {\n        box-sizing: border-box;\n        max-height: calc(100vh - 180px) !important; }\n    .monitoring .main-section .monitoring__toolbar-container {\n      flex-shrink: 1; }\n    .monitoring .main-section .monitoring__main-content {\n      position: relative;\n      flex-grow: 1;\n      display: flex;\n      overflow-y: auto; }\n\n.workspace .main-section .sd-preview-panel {\n  width: 0;\n  transition: all ease-in-out 0.2s; }\n\n.workspace .main-section [sd-item-preview] {\n  opacity: 0;\n  transition: all ease-in-out 0.4s; }\n\n.workspace .main-section .content-item-preview {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 560px; }\n  @media only screen and (max-width: 1430px) {\n    .workspace .main-section .content-item-preview {\n      width: 360px; } }\n  .workspace .main-section .content-item-preview .shift-preview__toggle {\n    display: none; }\n\n.workspace .main-section.with-preview .sd-preview-panel {\n  width: 560px;\n  flex-shrink: 0; }\n  @media only screen and (max-width: 1430px) {\n    .workspace .main-section.with-preview .sd-preview-panel {\n      width: 360px; } }\n\n.workspace .main-section.with-preview [sd-item-preview] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  opacity: 1; }\n  .workspace .main-section.with-preview [sd-item-preview].sd-preview--overlay {\n    position: absolute;\n    overflow: visible;\n    top: 9.6rem;\n    right: 0;\n    bottom: 0;\n    width: 0;\n    z-index: 3; }\n    .workspace .main-section.with-preview [sd-item-preview].sd-preview--overlay .content-item-preview {\n      width: 320px;\n      transition: all ease-in-out 0.2s;\n      overflow-y: visible !important;\n      right: -324px;\n      box-shadow: inset 3px 0 2px -1px rgba(0, 0, 0, 0.12), 2px 0 8px 0 rgba(0, 0, 0, 0.3), 0 0 2px 0 rgba(0, 0, 0, 0.12); }\n      .workspace .main-section.with-preview [sd-item-preview].sd-preview--overlay .content-item-preview.shift {\n        right: 0;\n        box-shadow: -2px 0 8px 0 rgba(0, 0, 0, 0.3), 0 0 2px 0 rgba(0, 0, 0, 0.12); }\n      .workspace .main-section.with-preview [sd-item-preview].sd-preview--overlay .content-item-preview .shift-preview__toggle {\n        display: inline-block; }\n\n.workspace .main-section.with-preview .compact .content-list {\n  overflow-y: visible; }\n\n.workspace .main-section.search-page-container .content-item-preview {\n  top: 48px; }\n\n.workspace .main-section.search .preview-layout [sd-item-preview] {\n  opacity: 1;\n  transition: all ease-in-out 0.4s; }\n\n.workspace .main-section.search .preview-layout.closed {\n  opacity: 1; }\n\n.shift-preview__toggle {\n  position: absolute;\n  display: none;\n  width: 24px;\n  height: 48px;\n  padding: 0;\n  top: 0;\n  right: -24px;\n  border: 0;\n  line-height: 0;\n  opacity: .65;\n  background-color: #fff;\n  border-radius: 0 2px 2px 0;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2), 2px 0 10px 0 rgba(0, 0, 0, 0.3); }\n  .shift-preview__toggle i {\n    height: 15px; }\n  .shift-preview__toggle:hover {\n    opacity: 1;\n    background-color: #5ea9c8; }\n    .shift-preview__toggle:hover i {\n      color: #fff; }\n  .shift-preview__toggle.shift {\n    top: 1px;\n    border-radius: 2px 0 0 2px;\n    box-shadow: -1px 0px 7px 0px rgba(0, 0, 0, 0.3);\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg); }\n\n.workspace.authoring .main-section .content-item-preview {\n  width: 400px; }\n  @media only screen and (max-width: 1630px) {\n    .workspace.authoring .main-section .content-item-preview {\n      width: 360px; } }\n\n.workspace.authoring .main-section.with-preview .sd-preview-panel {\n  width: 400px; }\n  @media only screen and (max-width: 1630px) {\n    .workspace.authoring .main-section.with-preview .sd-preview-panel {\n      width: 360px; } }\n\n.workspace.authoring .main-section.with-preview .navbtn.btnRearrange {\n  width: 80px !important; }\n  @media only screen and (max-width: 1430px) {\n    .workspace.authoring .main-section.with-preview .navbtn.btnRearrange {\n      display: none !important; } }\n\n.monitoring .sd-grid-group:not(.refresh) {\n  box-shadow: none !important; }\n  .monitoring .sd-grid-group:not(.refresh) .sd-grid-list {\n    margin: 1.4rem; }\n\n.sd-kanban-list-container {\n  height: 100%; }\n\n.sd-kanban-list {\n  overflow: auto; }\n  .sd-kanban-list .fix-stage {\n    flex: 1 1 0; }\n\n.notification-container {\n  display: inline-flex !important;\n  vertical-align: sub;\n  margin-top: 2px; }\n\n.monitoring-dropdown .dropdown__menu {\n  margin-top: 5px;\n  max-width: 220px !important; }\n\n.monitoring-dropdown a {\n  padding: 0px !important;\n  white-space: inherit !important;\n  display: inline !important; }\n  .monitoring-dropdown a .headline {\n    color: #5ea9c8 !important; }\n\n.monitoring-dropdown .buttons {\n  margin: 4px 0;\n  height: 1%;\n  overflow: hidden; }\n\n.monitoring-dropdown .acknowledge {\n  width: auto;\n  display: inline;\n  float: right; }\n\n.monitoring-dropdown .title {\n  padding-bottom: 6px;\n  margin-left: 15px;\n  font-weight: 500;\n  text-transform: uppercase;\n  font-size: 13px;\n  color: #666; }\n\n.monitoring-dropdown li {\n  display: block;\n  padding: 5px 15px 5px 20px;\n  border-bottom: 1px solid #ddd; }\n  .monitoring-dropdown li .slugline {\n    font-weight: 500;\n    color: #216278;\n    text-transform: uppercase;\n    font-size: 12px;\n    margin-right: 10px;\n    white-space: nowrap; }\n  .monitoring-dropdown li .headline, .monitoring-dropdown li .desk, .monitoring-dropdown li .stage {\n    color: #686b6c; }\n  .monitoring-dropdown li .location {\n    border-top: 1px solid #ebebeb;\n    margin-top: 10px; }\n  .monitoring-dropdown li .sender {\n    margin-top: 10px; }\n    .monitoring-dropdown li .sender span {\n      font-weight: 500;\n      margin-right: 5px;\n      font-size: 12px; }\n\n.subnav__stage-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 2rem;\n  font-size: 1.5rem; }\n  .subnav__stage-group .stage-group__split {\n    padding: 0 0.4rem 0 0.8rem;\n    opacity: 0.4; }\n  .subnav__stage-group .stage-group__badge {\n    padding: 0.4rem 0.8rem;\n    margin-left: 1rem; }\n  .subnav__stage-group .dropdown.open .navbtn {\n    background-color: transparent !important;\n    box-shadow: none; }\n    .subnav__stage-group .dropdown.open .navbtn:hover {\n      background-color: transparent !important; }\n  .subnav__stage-group .dropdown.open > .dropdown__menu {\n    margin: -4px 0 0 -10px; }\n\n.navbtn.navbtn--text-only.navbtn--padding-s {\n  padding: 0 0.4rem; }\n", ""]);

// exports


/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.aggregate.widgets', ['superdesk.apps.aggregate', 'superdesk.apps.dashboard.widgets'])
    .config(['dashboardWidgetsProvider', function (dashboardWidgets) {
        dashboardWidgets.addWidget('aggregate', {
            label: utils_1.gettext('Monitor'),
            multiple: true,
            icon: 'archive',
            max_sizex: 2,
            max_sizey: 3,
            sizex: 1,
            sizey: 2,
            classes: 'tabs modal--nested-fix',
            thumbnail: 'scripts/apps/monitoring/aggregate-widget/thumbnail.svg',
            template: 'scripts/apps/monitoring/aggregate-widget/aggregate-widget.html',
            configurationTemplate: 'scripts/apps/monitoring/aggregate-widget/configuration.html',
            description: 'Set up different monitors to follow any topics from ingest or production, desk outputs or ' +
                'any part of the workflow. All you need is to give it a sensible name, select a saved search or ' +
                'desk or its workflow stages. Monitor anything, anywhere, anytime. You can have as many Monitor ' +
                'widgets as you wish.',
            custom: true,
            removeHeader: true,
        });
    }]);


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AggregateCtrl_1 = __webpack_require__(1957);
exports.AggregateCtrl = AggregateCtrl_1.AggregateCtrl;


/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
AggregateCtrl.$inject = ['$scope', 'api', 'desks', 'workspaces', 'preferencesService', 'storage',
    'multi', 'config', '$timeout', 'savedSearch', 'deployConfig'];
function AggregateCtrl($scope, api, desks, workspaces, preferencesService, storage, multi, config, $timeout, savedSearch, deployConfig) {
    var PREFERENCES_KEY = 'agg:view';
    var defaultMaxItems = 10;
    var self = this;
    this.loading = true;
    this.selected = null;
    this.groups = [];
    this.spikeGroups = [];
    this.modalActive = false;
    this.displayOnlyCurrentStep = false;
    this.columnsLimit = null;
    this.currentStep = 'desks';
    this.searchLookup = {};
    this.deskLookup = {};
    this.stageLookup = {};
    this.fileTypes = ['all', 'text', 'picture', 'graphic', 'composite',
        'highlightsPackage', 'video', 'audio'];
    this.selectedFileType = $scope.type === 'monitoring' ? storage.getItem('selectedFileType') || [] : [];
    this.monitoringSearch = false;
    this.searchQuery = null;
    this.isOutputType = desks.isOutputType;
    desks.initialize()
        .then(angular.bind(this, function () {
        this.desks = desks.desks._items;
        this.deskLookup = desks.deskLookup;
        this.deskStages = desks.deskStages;
        lodash_1.default.each(this.desks, function (desk) {
            lodash_1.default.each(self.deskStages[desk._id], function (stage) {
                self.stageLookup[stage._id] = stage;
            });
        });
    }))
        .then(angular.bind(this, function () {
        return savedSearch.getAllSavedSearches().then(angular.bind(this, function (searchesList) {
            this.searches = searchesList;
            lodash_1.default.each(this.searches, function (item) {
                self.searchLookup[item._id] = item;
            });
        }));
    }))
        .then(angular.bind(this, function () {
        return this.readSettings()
            .then(angular.bind(this, function (settings) {
            initGroups(settings);
            setupCards();
            this.loading = false;
            this.settings = settings;
        }));
    }));
    /**
     * If view showed as widget set the current widget
     *
     *@param {object} widget
     */
    this.setWidget = function (widget) {
        this.widget = widget;
    };
    /**
     * Read the setting for currently selected workspace(desk or custom workspace)
     * If the view is showed in a widget, read the settings from widget configuration.
     * If the view is showed in a desk settings, read the settings from desk's monitoring settings.
     * If the current selected workspace is a custom workspace then settings are read from user preferences.
     * If the current selected workspace is a desk then settings are read from user preferences first, if
     * no user preference found then settings read from desk's monitoring settings.
     * @returns {Object} promise - when resolved return the list of settings
     */
    this.readSettings = function () {
        if (self.widget) {
            // when reading from monitoring widget
            return widgetMonitoringConfig(self.widget);
        }
        return workspaces.getActiveId().then(function (activeWorkspace) {
            if (!lodash_1.default.isNil(self.settings) && self.settings.desk) {
                // when viewing in desk's monitoring settings
                return deskSettingsMonitoringConfig(self.settings.desk);
            }
            // when viewing in monitoring view
            return workspaceMonitoringConfig(activeWorkspace);
        });
    };
    /**
     * Read settings in monitoring view for custom or desk workspace
     * according to active workspace type
     * @param {Object} activeWorkspace - contains workspace id and type.
     **/
    function workspaceMonitoringConfig(activeWorkspace) {
        if (activeWorkspace.type === 'workspace') {
            // when custom workspace selected in monitoring view.
            return customWorkspaceMonitoringConfig(activeWorkspace);
        }
        else if (activeWorkspace.type === 'desk') {
            // when desk selected in monitoring view.
            return deskWorkspaceMonitoringConfig(activeWorkspace);
        }
    }
    /**
     * Read aggregate settings in monitoring view for desk workspace,
     * settings read from user preferences first, if no preferences
     * found then settings read from desk's monitoring settings.
     * @param {Object} activeWorkspace - contains workspace id and type.
     * @return {Object} {type: {String}, groups: {Array}}
     **/
    function deskWorkspaceMonitoringConfig(activeWorkspace) {
        // Read available groups from user preferences first
        return preferencesService.get(PREFERENCES_KEY).then(function (preference) {
            var groups = [];
            var desk = self.deskLookup[activeWorkspace.id];
            var monitoringSettings = desk ? desk.monitoring_settings || [] : [];
            var activePrefGroups = preference[activeWorkspace.id] ? preference[activeWorkspace.id].groups || [] : [];
            if (activePrefGroups.length) {
                if (monitoringSettings.length) {
                    // compare and determine if set of groups in desk monitoring settings &
                    // user preferences are same or changed now, due to stages activated
                    // or deactivated in desk's monitoring settings.
                    var diff = lodash_1.default.xorBy(monitoringSettings, activePrefGroups, '_id');
                    if (diff.length) {
                        // if different, that means available stages/groups are changed now in desk monitoring settings
                        // so simply return recent desk monitoring settings.
                        groups = monitoringSettings;
                    }
                    else {
                        // update groups in preferences with any changes in desk's monitoring settings groups.
                        activePrefGroups.forEach(function (group) {
                            return angular.extend(group, monitoringSettings.find(function (grp) { return grp._id === group._id; }));
                        });
                        groups = activePrefGroups;
                    }
                }
                else {
                    groups = activePrefGroups;
                }
            }
            else {
                // when no user preferences found
                groups = monitoringSettings;
            }
            return { type: 'desk', groups: groups };
        });
    }
    /**
     * Read aggregate settings in monitoring view for custom workspace
     * @param {Object} activeWorkspace - contains workspace id and type.
     * @return {Object} {type: {String}, groups: {Array}}
     **/
    function customWorkspaceMonitoringConfig(activeWorkspace) {
        return preferencesService.get(PREFERENCES_KEY).then(function (preference) {
            var groups = [];
            if (preference && preference[activeWorkspace.id] && preference[activeWorkspace.id].groups) {
                groups = preference[activeWorkspace.id].groups;
            }
            return { type: 'workspace', groups: groups };
        });
    }
    /**
     * Read aggregate settings for monitoring widget
     * @param {Object} objWidget - contains widget configuration
     * @return {Object} {type: {String}, groups: {Array}}
     **/
    function widgetMonitoringConfig(objWidget) {
        return workspaces.readActive().then(function (workspace) {
            var groups = [];
            self.widget.configuration = objWidget.configuration || { groups: [], label: '' };
            lodash_1.default.each(workspace.widgets, function (widget) {
                if (widget.configuration && self.widget._id === widget._id
                    && self.widget.multiple_id === widget.multiple_id) {
                    groups = widget.configuration.groups || groups;
                    self.widget.configuration.label = widget.configuration.label || '';
                }
            });
            return { type: 'desk', groups: groups };
        });
    }
    /**
     * Read aggregate settings for desk monitoring settings
     * @param {Object} objDesk - contains desk configuration
     * @return {Object} {type: {String}, groups: {Array}, desk: {Object}}
     **/
    function deskSettingsMonitoringConfig(objDesk) {
        var groups = [];
        var desk = self.deskLookup[objDesk._id];
        if (desk && desk.monitoring_settings) {
            groups = desk.monitoring_settings;
        }
        return { type: 'desk', groups: groups, desk: objDesk };
    }
    /**
     * Init groups by filter out from groups stages or saved searches that
     * are not available(deleted or no right on them for stages only) and return all
     * stages for current desk if monitoring setting is not set
     **/
    function initGroups(settings) {
        if (self.groups.length > 0) {
            self.groups.length = 0;
        }
        if (settings && settings.groups.length > 0) {
            lodash_1.default.each(settings.groups, function (item) {
                if (item.type === 'stage' && !self.stageLookup[item._id]) {
                    return;
                }
                if (item.type === 'search' && !self.searchLookup[item._id]) {
                    return;
                }
                self.groups.push(item);
            });
        }
        else if (settings && settings.groups.length === 0 && settings.type === 'desk' && lodash_1.default.isNil(settings.desk)) {
            lodash_1.default.each(self.stageLookup, function (item) {
                if (item.desk === desks.getCurrentDeskId()) {
                    self.groups.push({ _id: item._id, type: 'stage', header: item.name });
                }
            });
            var currentDesk = desks.getCurrentDesk();
            if (currentDesk) {
                self.groups.push({ _id: currentDesk._id + ':output', type: 'deskOutput', header: currentDesk.name });
                if (config.monitoring && config.monitoring.scheduled) {
                    self.groups.push({
                        _id: currentDesk._id + ':scheduled',
                        type: 'scheduledDeskOutput',
                        header: currentDesk.name,
                    });
                }
            }
        }
        else if (settings && settings.groups.length === 0 && !lodash_1.default.isNil(settings.desk)) {
            lodash_1.default.each(self.stageLookup, function (item) {
                if (item.desk === settings.desk._id) {
                    self.groups.push({ _id: item._id, type: 'stage', header: item.name });
                }
            });
            var editingDesk = settings.desk;
            if (editingDesk) {
                self.groups.push({ _id: editingDesk._id + ':output', type: 'deskOutput', header: editingDesk.name });
            }
        }
        initSpikeGroups(settings.type === 'desk');
        updateFileTypeCriteria();
        self.search(self.searchQuery);
    }
    /**
     * Init the spike desks based on already initialized groups
     *
     * for desk workspace only show current desk spiked items
     *
     * @param {boolean} isDesk
     */
    function initSpikeGroups(isDesk) {
        var spikeDesks = {};
        if (self.spikeGroups.length > 0) {
            self.spikeGroups.length = 0;
        }
        if (isDesk) {
            var desk = desks.getCurrentDesk();
            if (desk) {
                self.spikeGroups = [{ _id: desk._id, type: 'spike' }];
            }
            return;
        }
        if (self.groups.length === 0) {
            return;
        }
        lodash_1.default.each(self.groups, function (item, index) {
            if (item.type === 'stage') {
                var stage = self.stageLookup[item._id];
                spikeDesks[stage.desk] = self.deskLookup[stage.desk];
            }
            else if (item.type === 'personal') {
                spikeDesks.personal = { _id: 'personal', name: 'personal' };
            }
        });
        lodash_1.default.each(spikeDesks, function (item) {
            if (item._id === 'personal') {
                self.spikeGroups.push({ _id: item._id, type: 'spike-personal', header: item.name });
            }
            else {
                self.spikeGroups.push({ _id: item._id, type: 'spike', header: item.name });
            }
        });
    }
    /**
     * Refresh view after setup
     */
    function refresh() {
        if (self.loading) {
            return null;
        }
        return self.readSettings()
            .then(function (settings) {
            initGroups(settings);
            setupCards();
            self.settings = settings;
        });
    }
    this.refreshGroups = refresh;
    /**
     * Read the settings when the current workspace
     * selection is changed
     */
    $scope.$watch(function () { return workspaces.active; }, refresh);
    /**
     * Return true if the 'fileType' filter is selected
     * param {string} fileType
     * @return boolean
     */
    this.hasFileType = function (fileType) {
        if (fileType === 'all') {
            return this.selectedFileType.length === 0;
        }
        return this.selectedFileType.indexOf(fileType) > -1;
    };
    /**
     * Return selected file types if the 'fileType' filter(s) is selected
     * @return [{string}] fileType
     */
    this.getSelectedFileTypes = function () {
        return this.selectedFileType.length === 0 ? null : JSON.stringify(this.selectedFileType);
    };
    /**
     * Update the type filter criteria
     */
    function updateFileTypeCriteria() {
        var value = self.selectedFileType.length === 0 ? null : JSON.stringify(self.selectedFileType);
        lodash_1.default.each(self.groups, function (item) {
            item.fileType = value;
        });
        lodash_1.default.each(self.spikeGroups, function (item) {
            item.fileType = value;
        });
    }
    /**
     * Set the current 'fileType' filter
     * param {string} fileType
     */
    this.setFileType = function (fileType) {
        if (fileType === 'all') {
            this.selectedFileType = [];
        }
        else {
            var index = this.selectedFileType.indexOf(fileType);
            if (index > -1) {
                this.selectedFileType.splice(index, 1);
            }
            else {
                this.selectedFileType.push(fileType);
            }
        }
        if ($scope.type === 'monitoring') {
            storage.setItem('selectedFileType', this.selectedFileType);
        }
        updateFileTypeCriteria();
    };
    /**
     * Add card metadata into current groups
     */
    function setupCards() {
        var cards = self.groups;
        angular.forEach(cards, setupCard);
        self.cards = cards;
        /**
         * Add card metadata into group
         */
        function setupCard(card) {
            if (card.type === 'stage') {
                var stage = self.stageLookup[card._id];
                var desk = self.deskLookup[stage.desk];
                card.deskId = stage.desk;
                card.header = desk.name;
                card.subheader = stage.name;
            }
            else if (desks.isOutputType(card.type)) {
                var deskId = card._id.substring(0, card._id.indexOf(':'));
                card.header = self.deskLookup[deskId].name;
            }
            else if (card.type === 'search') {
                card.search = self.searchLookup[card._id];
                card.header = card.search.name;
            }
            else if (card.type === 'personal') {
                card.header = utils_1.gettext('Personal');
            }
        }
    }
    this.preview = function (item) {
        this.selected = item;
    };
    /**
     * For edit monitoring settings add desk groups to the list
     */
    this.edit = function (currentStep, displayOnlyCurrentStep) {
        this.editGroups = {};
        var _groups = this.groups;
        this.refreshGroups().then(function () {
            lodash_1.default.each(_groups, function (item, index) {
                self.editGroups[item._id] = {
                    _id: item._id,
                    selected: true,
                    type: item.type,
                    max_items: item.max_items || defaultMaxItems,
                    order: index,
                };
                if (item.type === 'stage') {
                    var stage = self.stageLookup[item._id];
                    self.editGroups[stage.desk] = {
                        _id: stage._id,
                        selected: true,
                        type: 'desk',
                        order: 0,
                    };
                }
                else if (desks.isOutputType(item.type)) {
                    var deskId = item._id.substring(0, item._id.indexOf(':'));
                    self.editGroups[deskId] = {
                        _id: item._id,
                        selected: true,
                        type: 'desk',
                        order: 0,
                    };
                }
            });
        });
        this.modalActive = true;
        this.currentStep = currentStep || 'desks';
        this.displayOnlyCurrentStep = displayOnlyCurrentStep;
    };
    this.searchOnEnter = function ($event, query) {
        var ENTER = 13;
        if ($event.keyCode === ENTER) {
            this.search(query);
            $event.stopPropagation();
        }
    };
    /**
     * Set the search set by user on all groups
     */
    this.search = function (query) {
        this.searchQuery = query;
        lodash_1.default.each(this.groups, function (item) {
            item.query = query;
        });
        lodash_1.default.each(this.spikeGroups, function (item) {
            item.query = query;
        });
    };
    this.state = storage.getItem('agg:state') || {};
    this.state.expanded = this.state.expanded || {};
    this.switchExpandedState = function (key) {
        this.state.expanded[key] = !this.getExpandedState(key);
        storage.setItem('agg:state', this.state);
    };
    this.getExpandedState = function (key) {
        return this.state.expanded[key] === undefined ? true : this.state.expanded[key];
    };
    this.setSoloGroup = function (group) {
        this.state.solo = group;
        storage.setItem('agg:state', this.state);
    };
    this.getMaxHeightStyle = function (maxItems) {
        var maxHeight = 32 * (maxItems || defaultMaxItems);
        return { 'max-height': maxHeight.toString() + 'px' };
    };
    $scope.$on('open:archived_kill', function (evt, item, action) {
        $scope.archived_kill = item;
        $scope.archived_kill_action = action;
    });
    $scope.$on('open:resend', function (evt, item) {
        $scope.resend = item;
    });
}
exports.AggregateCtrl = AggregateCtrl;


/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
Monitoring.$inject = ['superdeskProvider', 'workspaceMenuProvider'];
function Monitoring(superdesk, workspaceMenuProvider) {
    superdesk
        .activity('/workspace/monitoring', {
        label: utils_1.gettext('Monitoring'),
        priority: 100,
        templateUrl: 'scripts/apps/monitoring/views/monitoring.html',
        topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
        sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
    });
    workspaceMenuProvider.item({
        icon: 'view',
        href: '/workspace/monitoring',
        label: utils_1.gettext('Monitoring'),
        shortcut: 'alt+m',
        order: 200,
    });
}
exports.Monitoring = Monitoring;
SpikeMonitoring.$inject = ['superdeskProvider', 'workspaceMenuProvider'];
function SpikeMonitoring(superdesk, workspaceMenuProvider) {
    superdesk
        .activity('/workspace/spike-monitoring', {
        label: utils_1.gettext('Spike Monitoring'),
        priority: 100,
        templateUrl: 'scripts/apps/monitoring/views/spike-monitoring.html',
        topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
        sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
    });
    workspaceMenuProvider.item({
        href: '/workspace/spike-monitoring',
        label: utils_1.gettext('Spike'),
        shortcut: 'ctrl+alt+k',
        icon: 'spike',
        order: 600,
    });
}
exports.SpikeMonitoring = SpikeMonitoring;
/**
 * Configure personal option from left menu
 */
Personal.$inject = ['superdeskProvider', 'workspaceMenuProvider'];
function Personal(superdesk, workspaceMenuProvider) {
    superdesk
        .activity('/workspace/personal', {
        label: utils_1.gettext('Personal'),
        priority: 100,
        templateUrl: 'scripts/apps/monitoring/views/personal.html',
        sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
    });
    workspaceMenuProvider.item({
        href: '/workspace/personal',
        label: utils_1.gettext('Personal'),
        shortcut: 'alt+p',
        icon: 'personal',
        order: 900,
        group: 'personal',
    });
}
exports.Personal = Personal;


/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MonitoringView_1 = __webpack_require__(1960);
exports.MonitoringView = MonitoringView_1.MonitoringView;
var MonitoringGroup_1 = __webpack_require__(1961);
exports.MonitoringGroup = MonitoringGroup_1.MonitoringGroup;
var MonitoringGroupHeader_1 = __webpack_require__(1962);
exports.MonitoringGroupHeader = MonitoringGroupHeader_1.MonitoringGroupHeader;
var DeskNotifications_1 = __webpack_require__(1963);
exports.DeskNotifications = DeskNotifications_1.DeskNotifications;
var ItemActionsMenu_1 = __webpack_require__(1964);
exports.ItemActionsMenu = ItemActionsMenu_1.ItemActionsMenu;
var AggregateSettings_1 = __webpack_require__(1965);
exports.AggregateSettings = AggregateSettings_1.AggregateSettings;
var SortGroups_1 = __webpack_require__(1966);
exports.SortGroups = SortGroups_1.SortGroups;
var WidgetGroup_1 = __webpack_require__(1967);
exports.WidgetGroup = WidgetGroup_1.WidgetGroup;


/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * Main monitoring view - list + preview
 *
 * it's a directive so that it can be put together with authoring into some container directive
 */
MonitoringView.$inject = ['$rootScope', 'authoringWorkspace', 'pageTitle', '$timeout', 'workspaces', 'desks'];
function MonitoringView($rootScope, authoringWorkspace, pageTitle, $timeout, workspaces, desks) {
    return {
        templateUrl: 'scripts/apps/monitoring/views/monitoring-view.html',
        controller: 'Monitoring',
        controllerAs: 'monitoring',
        scope: {
            type: '=',
            state: '=',
            customDataSource: '=?',
            onMonitoringItemSelect: '=?',
            onMonitoringItemDoubleClick: '=?',
            hideActionsForMonitoringItems: '=?',
            disableMonitoringMultiSelect: '=?',
            disableMonitoringCreateItem: '=?',
            hideMonitoringToolbar1: '=?',
            hideMonitoringToolbar2: '=?',
        },
        link: function (scope, elem) {
            var containerElem = elem.find('.content-list');
            pageTitle.setUrl(lodash_1.default.capitalize(utils_1.gettext(scope.type)));
            scope.shouldRefresh = true;
            scope.view = 'compact'; // default view
            scope.workspaces = workspaces;
            scope.$watch('workspaces.active', function (workspace) {
                scope.workspace = workspace;
            });
            workspaces.getActive();
            scope.desks = desks;
            scope.$watch(desks.getCurrentDesk.bind(desks), function (currentDesk) {
                if (currentDesk && currentDesk.monitoring_default_view) {
                    switch (currentDesk.monitoring_default_view) {
                        case 'list':
                            scope.switchView('compact');
                            break;
                        case 'swimlane':
                            scope.switchView('compact', true);
                            break;
                        case 'photogrid':
                            scope.switchView('photogrid');
                            break;
                        default:
                            scope.switchView('compact'); // list by default
                            break;
                    }
                }
            });
            scope.numberOfColumns = 1;
            /**
             * Toggle viewColumn to switch views between swimlane and list
             * @param {Boolean} value
             * @param {Boolean} swimlane
             */
            scope.switchView = function (value, swimlane) {
                scope.monitoring.switchViewColumn(swimlane, true);
                scope.view = value;
                scope.swimlane = swimlane;
            };
            /**
             * @description Returns true when group's item is selected for previewing, false otherwise.
             * @param {Object} group
             * @returns {Boolean}
             */
            scope.isActiveGroup = function (group) {
                return scope.monitoring.selectedGroup ? scope.monitoring.selectedGroup._id === group._id : true;
            };
            var updateTimeout;
            function handleContainerScroll($event) {
                if ($rootScope.itemToggle) {
                    scope.$applyAsync(function () {
                        $rootScope.itemToggle(false);
                        $rootScope.itemToggle = null;
                    });
                }
                if (scope.monitoring.viewColumn && containerElem[0].scrollTop === 0) {
                    scope.refreshGroup(scope.group);
                }
                $timeout.cancel(updateTimeout);
                updateTimeout = $timeout(renderIfNeeded, 100, false);
            }
            containerElem.on('scroll', handleContainerScroll);
            function isListEnd(container) {
                return container.scrollTop + container.offsetHeight + 200 >= container.scrollHeight;
            }
            /**
             * Trigger render in case user scrolls to the very end of list
             */
            function renderIfNeeded() {
                if (scope.monitoring.viewColumn && isListEnd(containerElem[0])) {
                    scheduleFetchNext();
                }
            }
            var fetchNextTimeout;
            /**
             * Schedule content fetchNext after some delay
             */
            function scheduleFetchNext() {
                if (!fetchNextTimeout) {
                    fetchNextTimeout = $timeout(function () {
                        scope.$broadcast('render:next');
                        scope.$applyAsync(function () {
                            fetchNextTimeout = null;
                        });
                    }, 1000, false);
                }
            }
            // force refresh on refresh button click when in specific view such as single, highlights or spiked.
            scope.refreshGroup = function (group) {
                scope.$broadcast('refresh:list', group);
            };
            scope.$on('$destroy', function () {
                containerElem.off();
            });
            scope.$on('$routeUpdate', function (event, data) {
                if (scope.shouldRefresh) {
                    scope.refreshGroup();
                }
                else {
                    scope.shouldRefresh = true;
                }
            });
            scope.$watch(function () { return authoringWorkspace.item; }, function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.shouldRefresh = false; // when item opened or closed
                    if (newValue) { // when item opened
                        scope.monitoring.closePreview();
                    }
                }
            });
        },
    };
}
exports.MonitoringView = MonitoringView;


/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable complexity */
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.monitoring
 * @name sdMonitoringGroup
 *
 * @requires cards
 * @requires api
 * @requires authoringWorkspace
 * @requires $timeout
 * @requires superdesk
 * @requires session
 * @requires activityService
 * @requires workflowService
 * @requires keyboardManager
 * @requires desks
 * @requires search
 * @requires multi
 * @requires archiveService
 * @requires $rootScope
 * @requires preferencesService
 *
 * @description
 *   A directive that generates group/section on stages of a desk or saved search.
 */
MonitoringGroup.$inject = ['cards', 'api', 'authoringWorkspace', '$timeout', 'superdesk', 'session',
    'activityService', 'desks', 'search', 'multi', 'archiveService', 'config', '$rootScope'];
function MonitoringGroup(cards, api, authoringWorkspace, $timeout, superdesk, session, activityService, desks, search, multi, archiveService, config, $rootScope) {
    var ITEM_HEIGHT = 57;
    var PAGE_SIZE = 25;
    var DEFAULT_GROUP_ITEMS = 10;
    return {
        templateUrl: 'scripts/apps/monitoring/views/monitoring-group.html',
        require: ['^sdMonitoringView'],
        scope: {
            // not required if using custom data source
            group: '=?',
            view: '=?',
            numItems: '=',
            viewType: '=',
            forceLimited: '@',
            customDataSource: '=?',
            hideActionsForMonitoringItems: '=?',
            disableMonitoringMultiSelect: '=?',
            onMonitoringItemSelect: '=?',
            onMonitoringItemDoubleClick: '=?',
        },
        link: function (scope, elem, attrs, ctrls) {
            if (scope.group == null) {
                scope.group = {};
            }
            if (scope.customDataSource != null
                && typeof scope.customDataSource === 'object'
                && typeof scope.customDataSource.getItem !== typeof scope.customDataSource.getItems) {
                throw new Error('Both values have to be either supplied or not. Supplying only one of them is not supported.');
            }
            var monitoring = ctrls[0];
            var projections = search.getProjectedFields();
            var containerElem = monitoring.viewColumn ? $(document).find('.content-list') : elem.find('.stage-content');
            ITEM_HEIGHT = search.singleLine ? 29 : 57;
            scope.page = 1;
            scope.fetching = false;
            scope.previewingBroadcast = false;
            scope.loading = false;
            scope.cacheNextItems = [];
            scope.cachePreviousItems = [];
            scope.viewColumn = monitoring.viewColumn;
            scope.$on('view:column', function (event, data) {
                scope.$applyAsync(function () {
                    scope.viewColumn = data.viewColumn;
                });
            });
            scope.style = {};
            scope.edit = edit;
            scope.select = select;
            scope.preview = preview;
            scope.viewSingleGroup = viewSingleGroup;
            scope.$watchCollection('group', function () {
                updateGroupStyle();
                scope.refreshGroup();
            });
            scope.$on('task:stage', scheduleQuery);
            scope.$on('item:spike', scheduleIfShouldUpdate);
            scope.$on('item:copy', scheduleQuery);
            scope.$on('item:unlink', scheduleQuery);
            scope.$on('item:duplicate', scheduleQuery);
            scope.$on('item:translate', scheduleQuery);
            scope.$on('broadcast:created', function (event, args) {
                scope.previewingBroadcast = true;
                queryItems();
                preview(args.item);
            });
            scope.$on('item:unspike', scheduleIfShouldUpdate);
            scope.$on('$routeUpdate', function (event, data) {
                if (scope.viewColumn) {
                    updateGroupStyle();
                }
            });
            scope.$on('broadcast:preview', function (event, args) {
                scope.previewingBroadcast = true;
                if (!lodash_1.default.isNil(args.item)) {
                    preview(args.item);
                }
                else {
                    monitoring.closePreview();
                }
            });
            scope.$on('item:highlights', scheduleQuery);
            scope.$on('item:marked_desks', scheduleQuery);
            scope.$on('content:update', scheduleIfShouldUpdate);
            if (scope.group.type === 'search' && search.doesSearchAgainstRepo(scope.group.search, 'ingest')) {
                scope.$on('ingest:update', function (event, data) {
                    if (!scope.showRefresh) {
                        scheduleQuery(event, data);
                    }
                });
            }
            // Determines if limited maxHeight style need to apply on group list
            function shouldLimited() {
                if (scope.customDataSource != null) {
                    return false;
                }
                var limited = !(monitoring.singleGroup || scope.group.type === 'highlights'
                    || scope.group.type === 'spike');
                if (!lodash_1.default.isNil(scope.forceLimited)) {
                    limited = JSON.parse(scope.forceLimited);
                }
                return limited;
            }
            function scheduleIfShouldUpdate(event, data) {
                if (data && data.from_stage && data.from_stage === scope.group._id) {
                    // item was moved from current stage
                    extendItem(data.item, {
                        gone: true,
                        _etag: data.from_stage,
                    });
                    scheduleQuery(event, data);
                }
                else if (scope.group.type === 'deskOutput' && data &&
                    scope.group._id === lodash_1.default.get(data, 'from_desk') + ':output') {
                    // item was moved to production desk, therefore it should comes in from_desk's output stage too
                    scheduleQuery(event, data);
                }
                else if (data && data.item && lodash_1.default.includes(['item:spike', 'item:unspike'], event.name)) {
                    // item was spiked/unspiked from the list
                    extendItem(data.item, {
                        gone: true,
                        _etag: data.item,
                    });
                    scheduleQuery(event, data);
                }
                else if (data && data.to_stage && data.to_stage === scope.group._id) {
                    // new item in current stage
                    scheduleQuery(event, data);
                }
                else if (data && cards.shouldUpdate(scope.group, data)) {
                    scheduleQuery(event, data);
                }
            }
            function extendItem(itemId, updates) {
                scope.$apply(function () {
                    scope.items._items = scope.items._items.map(function (item) {
                        if (item._id === itemId) {
                            return angular.extend(item, updates);
                        }
                        return item;
                    });
                    scope.items = angular.extend({}, scope.items); // trigger a watch
                });
            }
            scope.$on('item:fetch', scheduleIfShouldUpdate);
            scope.$on('item:move', scheduleIfShouldUpdate);
            scope.$watch('selected', function (newVal, oldVal) {
                if (!newVal && scope.previewingBroadcast) {
                    scope.previewingBroadcast = false;
                }
            });
            /*
             * Change between single stage/desk view and monitoring grouped view
             *
             * @param {string} type - type is 'desk' or 'stage' to switch single view
             */
            function toggleMonitoringSingleView(type) {
                if (lodash_1.default.isNil(monitoring.singleGroup) && scope.selected) {
                    scope.$applyAsync(function () {
                        monitoring.viewSingleGroup(monitoring.selectedGroup, type);
                    });
                }
                // Returns back to monitoring view from single view
                if (monitoring.singleGroup) {
                    scope.$applyAsync(function () {
                        monitoring.viewMonitoringHome();
                    });
                }
            }
            /*
             * Change between single stage view and grouped view by keyboard
             * Keyboard shortcut: Ctrl + alt + j
             */
            scope.$on('key:ctrl:alt:j', function (event, data) {
                toggleMonitoringSingleView('stage');
            });
            // refreshes the list for matching group or view type only or if swimlane view is ON.
            scope.$on('refresh:list', function (event, group) {
                var currentScope = event.currentScope;
                var _viewType = currentScope.viewType || '';
                var viewTypeMatches = [
                    'highlights',
                    'spiked',
                    'single_monitoring',
                    'monitoring',
                    'deskOutput',
                    'personal',
                ].includes(_viewType);
                if ((group && group._id === scope.group._id) || (!group && viewTypeMatches)) {
                    scope.refreshGroup();
                }
            });
            scope.$on('render:next', function (event) {
                scope.$applyAsync(function () {
                    if (scope.items) {
                        scope.fetchNext(scope.items._items.length);
                    }
                });
            });
            /*
             * Change between single desk view and grouped view by keyboard
             * Keyboard shortcut: Ctrl + alt + g
             */
            scope.$on('key:ctrl:alt:g', function () {
                toggleMonitoringSingleView('desk');
            });
            // forced refresh on refresh button click or on refresh:list
            scope.refreshGroup = function () {
                monitoring.showRefresh = scope.showRefresh = false;
                scheduleQuery(null, { force: true });
                // update scroll position to top when forced refresh
                if (containerElem[0].scrollTop > 0) {
                    containerElem[0].scrollTop = 0;
                }
            };
            function updateGroupStyle() {
                scope.style.maxHeight = null;
                if (scope.viewColumn) {
                    // maxHeight is not applicable for swimlane/column view, as each stages/column
                    // don't need to have scroll bars because container scroll bar of monitoring
                    // view will serve scrolling
                    $rootScope.$broadcast('resize:header');
                }
                else if (shouldLimited()) {
                    var groupItems = scope.group.max_items || DEFAULT_GROUP_ITEMS;
                    var scrollOffset = 0;
                    if (groupItems === PAGE_SIZE) {
                        scrollOffset = Math.round(ITEM_HEIGHT / 2);
                    }
                    scope.style.maxHeight = groupItems * ITEM_HEIGHT - scrollOffset;
                }
            }
            var queryTimeout;
            /**
             * Schedule content reload after some delay
             */
            function scheduleQuery(event, data) {
                if (!queryTimeout) {
                    queryTimeout = $timeout(function () {
                        queryItems(event, data, { auto: (data && data.force) ? 0 : 1 })
                            .finally(function () {
                            scope.$applyAsync(function () {
                                // ignore any updates requested in current $digest
                                queryTimeout = null;
                            });
                        });
                    }, 1000, false);
                }
            }
            var criteria;
            function edit(item) {
                if (item.state !== 'spiked') {
                    var intent = { action: 'list', type: undefined };
                    if (item._type === 'ingest') {
                        intent.type = 'ingest';
                        fetchAndEdit(intent, item, 'archive');
                    }
                    else if (item._type === 'externalsource') {
                        intent.type = 'externalsource';
                        fetchAndEdit(intent, item, 'externalsource');
                    }
                    else if (archiveService.isPublished(item)) {
                        authoringWorkspace.view(item);
                    }
                    else {
                        authoringWorkspace.edit(item);
                    }
                }
            }
            /**
             * Perform fetch for an item via activity and then edit fetched item
             *
             * @param {Object} intent
             * @param {Object} item
             * @param {String} activityId
             */
            function fetchAndEdit(intent, item, activityId) {
                var activity = lodash_1.default.find(superdesk.findActivities(intent, item), { _id: activityId });
                if (!lodash_1.default.isNil(activity)) {
                    activityService.start(activity, { data: { item: item } })
                        .then(function (_item) {
                        authoringWorkspace.edit(_item);
                    });
                }
            }
            function select(item) {
                scope.currentGroup = item.task ? item.task.stage : null;
                scope.selected = item;
                monitoring.selectedGroup = scope.group;
                monitoring.preview(item);
            }
            function preview(item) {
                if (item) {
                    // for items from external source or if type is undefined.
                    if (item._type === 'externalsource') {
                        select(item);
                        return;
                    }
                    scope.loading = true;
                    (function () {
                        if (scope.customDataSource != null && typeof scope.customDataSource.getItem === 'function') {
                            return scope.customDataSource.getItem(item);
                        }
                        else {
                            criteria = cards.criteria(scope.group, null, monitoring.queryParam);
                            var previewCriteria = search.getSingleItemCriteria(item, criteria);
                            return apiquery(previewCriteria, false);
                        }
                    })()
                        .then(function (completeItems) {
                        var completeItem = search.mergeHighlightFields(completeItems._items[0]);
                        select(completeItem);
                    })
                        .finally(function () {
                        scope.loading = false;
                        // Reset to get bulk query items
                        criteria = cards.criteria(scope.group, null, monitoring.queryParam);
                        criteria.source.size = PAGE_SIZE;
                    });
                }
                else {
                    select(item);
                }
                if (scope.viewColumn) {
                    updateGroupStyle();
                }
            }
            // For highlight page return only highlights items, i.e, include only last version if item type is published
            function getOnlyHighlightsItems(items) {
                items._items = lodash_1.default.filter(items._items, function (item) {
                    return item._type === 'published' && item.last_published_version || item._type !== 'published';
                });
                return items;
            }
            // Determine if item is previewing for its respective view type.
            function isItemPreviewing() {
                if (scope.group.type === 'spike') {
                    return monitoring.previewItem &&
                        monitoring.previewItem.task.desk === scope.group._id;
                }
                else if (scope.group.type === 'highlights') {
                    return monitoring.previewItem &&
                        lodash_1.default.includes(monitoring.previewItem.highlights, monitoring.queryParam.highlight);
                }
                else if (scope.group.type === 'search') {
                    return !!monitoring.previewItem;
                }
                return monitoring.previewItem && monitoring.previewItem.task.stage === scope.group._id;
            }
            function queryItems(event, data, params) {
                var originalQuery;
                if (desks.changeDesk) {
                    desks.changeDesk = false;
                    monitoring.singleGroup = null;
                    multi.reset();
                }
                return (function () {
                    if (scope.customDataSource != null && typeof scope.customDataSource.getItems === 'function') {
                        return scope.customDataSource.getItems(0, PAGE_SIZE);
                    }
                    else {
                        criteria = cards.criteria(scope.group, null, monitoring.queryParam);
                        criteria.source.from = 0;
                        criteria.source.size = PAGE_SIZE;
                        // when forced refresh or query then keep query size default as set PAGE_SIZE (25) above.
                        // To compare current scope of items, consider fetching same number of items.
                        if (!(data && data.force) && scope.items && scope.items._items.length > PAGE_SIZE) {
                            criteria.source.size = scope.items._items.length;
                        }
                        if (data && (data.item || data.items || data.item_id) && scope.showRefresh && !data.force) {
                            // if we know the ids of the items then try to fetch those only
                            originalQuery = angular.extend({}, criteria.source.query);
                            var items = data.items || {};
                            if (data.item || data.item_id) {
                                items[data.item || data.item_id] = 1;
                            }
                            criteria.source.query = search.getItemQuery(items);
                        }
                        if (params) {
                            angular.extend(criteria, params);
                        }
                        return apiquery(criteria, true)
                            .then(function (res) {
                            if (originalQuery) {
                                criteria.source.query = originalQuery;
                            }
                            return res;
                        });
                    }
                })()
                    .then(function (items) {
                    if (config.features.autorefreshContent && data != null) {
                        data.force = true;
                    }
                    if (!scope.showRefresh && data && !data.force && data.user !== session.identity._id) {
                        var itemPreviewing = isItemPreviewing();
                        var _data = {
                            newItems: items,
                            scopeItems: scope.items,
                            scrollTop: containerElem.scrollTop(),
                            isItemPreviewing: itemPreviewing,
                        };
                        monitoring.showRefresh = scope.showRefresh = search.canShowRefresh(_data);
                    }
                    if (!scope.showRefresh || data && data.force) {
                        scope.total = items._meta.total;
                        var onlyHighlighted = scope.group.type === 'highlights'
                            ? getOnlyHighlightsItems(items)
                            : items;
                        monitoring.totalItems = onlyHighlighted._meta.total;
                        scope.items = search.mergeItems(onlyHighlighted, scope.items, null, true);
                    }
                    else {
                        // update scope items only with the matching fetched items
                        scope.items = search.updateItems(items, scope.items);
                    }
                });
            }
            scope.fetchNext = function (from) {
                if (typeof criteria === 'object' && typeof criteria.source === 'object') {
                    criteria.source.from = from;
                }
                var next = true;
                (function () {
                    if (scope.customDataSource != null && typeof scope.customDataSource.getItems === 'function') {
                        return scope.customDataSource.getItems(from, PAGE_SIZE);
                    }
                    else {
                        return apiquery(criteria, true);
                    }
                })()
                    .then(function (items) {
                    scope.$applyAsync(function () {
                        if (scope.total !== items._meta.total) {
                            scope.total = items._meta.total;
                        }
                        var onlyHighlighted = scope.group.type === 'highlights'
                            ? getOnlyHighlightsItems(items)
                            : items;
                        scope.items = search.mergeItems(onlyHighlighted, scope.items, next);
                    });
                });
            };
            /**
             * Request the data on search or archive endpoints
             * return {promise} list of items
             */
            function apiquery(searchCriteria, applyProjections) {
                var provider = 'search';
                if (scope.group.type === 'search' || desks.isPublishType(scope.group.type)) {
                    if (searchCriteria.repo && searchCriteria.repo.indexOf(',') === -1) {
                        provider = searchCriteria.repo;
                        if (!angular.isDefined(searchCriteria.source.size)) {
                            searchCriteria.source.size = PAGE_SIZE;
                        }
                    }
                }
                else {
                    provider = 'archive';
                }
                if (applyProjections) {
                    searchCriteria.projections = JSON.stringify(projections);
                }
                return api.query(provider, searchCriteria);
            }
            function viewSingleGroup(group, type) {
                monitoring.viewSingleGroup(group, type);
            }
        },
    };
}
exports.MonitoringGroup = MonitoringGroup;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function MonitoringGroupHeader() {
    return {
        templateUrl: 'scripts/apps/monitoring/views/monitoring-group-header.html',
    };
}
exports.MonitoringGroupHeader = MonitoringGroupHeader;


/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * Displays the notifications of the desk of a given stage
 */
DeskNotifications.$inject = ['desks', 'deskNotifications', 'authoringWorkspace', '$timeout'];
function DeskNotifications(desks, deskNotifications, authoringWorkspace, $timeout) {
    return {
        scope: { stage: '=stage' },
        templateUrl: 'scripts/apps/monitoring/views/desk-notifications.html',
        link: function (scope) {
            function init() {
                // Update the figures if there's a desk mention message
                initNotifications();
                if (scope.default_incoming) {
                    scope.$on('activity', function (event, data) {
                        if (lodash_1.default.get(data, 'activity.name') === 'desk:mention' && data.activity.desk === scope.desk) {
                            $timeout(reload, 5000, false);
                        }
                    });
                }
            }
            function initNotifications() {
                scope.desk = desks.stageLookup[scope.stage].desk;
                scope.notifications = deskNotifications.getNotifications(scope.desk);
                scope.default_incoming = desks.stageLookup[scope.stage].default_incoming;
                scope.notificationCount = deskNotifications.getUnreadCount(scope.desk) || 0;
                scope.deskLookup = desks.deskLookup;
                scope.stageLookup = desks.stageLookup;
            }
            function reload() {
                deskNotifications.reload().then(initNotifications);
            }
            /**
             * Opens the story in the notification
             * and updates the notification as read
             *
             * @param {object} notification The notification to be checked
             */
            scope.open = function (notification) {
                authoringWorkspace.view(notification.item);
            };
            /**
             * Updates the notification as read
             *
             * @param {object} notification The notification to be checked
             */
            scope.acknowledge = function (notification) {
                deskNotifications.markAsRead(notification, scope.desk);
                $timeout(reload, 5000, false);
            };
            function getRecipient(notification) {
                return lodash_1.default.find(notification.recipients, { desk_id: scope.desk });
            }
            /**
             * Checks if the given notification is read
             *
             * @param {object} notification The notification to be checked
             * @return {boolean} True if the notification is read by any user
             */
            scope.isRead = function (notification) {
                var recipient = getRecipient(notification);
                return recipient && recipient.read;
            };
            /**
             * Returns the name of the user who read the notification
             *
             * @param {object} notification The notification to be checked
             * @return {string} Display name of the user
             */
            scope.readBy = function (notification) {
                var recipient = getRecipient(notification);
                if (recipient && recipient.read) {
                    return desks.userLookup[recipient.user_id].display_name;
                }
            };
            init();
        },
    };
}
exports.DeskNotifications = DeskNotifications;


/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(570);
ItemActionsMenu.$inject = ['superdesk', 'activityService', 'workflowService', 'archiveService', '$rootScope'];
function ItemActionsMenu(superdesk, activityService, workflowService, archiveService, $rootScope) {
    return {
        scope: {
            item: '=',
            active: '=',
        },
        templateUrl: 'scripts/apps/monitoring/views/item-actions-menu.html',
        link: function (scope) {
            /**
             * Populate scope actions when dropdown is opened.
             *
             * @param {boolean} isOpen
             */
            scope.toggleActions = function (isOpen) {
                scope.menuGroups = isOpen ? getActions(scope.item) : scope.menuGroups;
                scope.open = isOpen;
                if (!isOpen) {
                    // After close, return focus to parent of selected element
                    angular.element('.media-text.selected')
                        .parents('li')
                        .focus();
                    angular.element('.dropdown--noarrow.open')
                        .removeClass('open');
                }
                else {
                    $rootScope.itemToggle = scope.toggleActions;
                }
            };
            /*
             * If the item gets locked by another user when the activity menu is open then close the menu
             * as the actions for locked and unlocked are different.
             */
            scope.$on('item:lock', function (_e, data) {
                if (scope.open && scope.item && scope.item._id === data.item) {
                    scope.open = false;
                }
            });
            /**
             * Stope event propagation so that click on dropdown menu
             * won't select that item for preview/authoring.
             *
             * @param {Event} event
             */
            scope.stopEvent = function (event) {
                event.stopPropagation();
            };
            scope.run = function (activity) {
                return activityService.start(activity, { data: { item: scope.item } });
            };
            /**
             * Get available actions for given item.
             *
             * This is not context aware, it will return everything.
             *
             * @param {object} item
             * @return {object}
             */
            function getActions(item) {
                var intent = { action: 'list', type: getType(item) };
                var groups = {};
                superdesk.findActivities(intent, item).forEach(function (activity) {
                    if (workflowService.isActionAllowed(scope.item, activity.action)) {
                        var group = activity.group || 'default';
                        groups[group] = groups[group] || [];
                        groups[group].push(activity);
                    }
                });
                var menuGroups = [];
                constants_1.AUTHORING_MENU_GROUPS.forEach(function (mg) {
                    if (groups[mg._id]) {
                        var group = __assign({}, mg);
                        group.actions = groups[mg._id];
                        menuGroups.push(group);
                    }
                });
                Object.keys(groups).forEach(function (groupName) {
                    var existingGroup = constants_1.AUTHORING_MENU_GROUPS.find(function (g) { return g._id === groupName; });
                    if (!existingGroup) {
                        menuGroups.push({ _id: groupName, label: groupName, actions: groups[groupName] });
                    }
                });
                return menuGroups;
            }
            /**
             * Get actions type based on item state. Used with activity filter.
             *
             * @param {Object} item
             * @return {string}
             */
            function getType(item) {
                return archiveService.getType(item);
            }
        },
    };
}
exports.ItemActionsMenu = ItemActionsMenu;


/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
AggregateSettings.$inject = ['desks', 'workspaces', 'session', 'preferencesService', 'WizardHandler', '$filter'];
function AggregateSettings(desks, workspaces, session, preferencesService, WizardHandler, $filter) {
    return {
        templateUrl: 'scripts/apps/monitoring/views/aggregate-settings-configuration.html',
        scope: {
            modalActive: '=',
            desks: '=',
            deskStages: '=',
            searches: '=',
            deskLookup: '=',
            stageLookup: '=',
            searchLookup: '=',
            groups: '=',
            editGroups: '=',
            onclose: '&',
            widget: '=',
            settings: '=',
            currentStep: '=',
            displayOnlyCurrentStep: '=',
            columnsLimit: '=',
        },
        link: function (scope, elem) {
            var PREFERENCES_KEY = 'agg:view';
            var defaultMaxItems = 10;
            scope.showGlobalSavedSearches = false;
            scope.showPrivateSavedSearches = true;
            scope.privateSavedSearches = [];
            scope.globalSavedSearches = [];
            desks.initialize()
                .then(function () {
                scope.userLookup = desks.userLookup;
                scope.setCurrentStep();
            });
            scope.$watch('step.current', function (step) {
                if (step === 'searches') {
                    workspaces.getActiveId().then(function (activeWorkspace) {
                        if (activeWorkspace.type === 'workspace') {
                            scope.showPrivateSavedSearches = true;
                        }
                        else {
                            scope.showGlobalSavedSearches = true;
                            scope.showPrivateSavedSearches = false;
                        }
                    });
                    scope.initGlobalSavedSearches();
                    scope.initPrivateSavedSearches();
                }
            });
            scope.closeModal = function () {
                scope.step.current = 'desks';
                scope.modalActive = false;
                scope.showGlobalSavedSearches = false;
                scope.onclose();
            };
            scope.previous = function () {
                WizardHandler.wizard('aggregatesettings').previous();
            };
            scope.next = function () {
                WizardHandler.wizard('aggregatesettings').next();
            };
            /**
             * @description Returns true if this step in wizard should need to hide, false otherwise.
             * Only current step will be shown when displayOnlyCurrentStep is defined.
             * @param {String} code name of this step in wizard, i.e: desks, searches, reorder, maxitems
             * @returns {Boolean}
             */
            scope.shouldHideStep = function (code) {
                return !lodash_1.default.isNil(scope.displayOnlyCurrentStep) && !(scope.displayOnlyCurrentStep
                    && scope.currentStep === code);
            };
            /**
             * @description Sets current step in wizard, default is 'desks'.
             */
            scope.setCurrentStep = function () {
                scope.step = {
                    current: scope.currentStep || 'desks',
                };
            };
            scope.cancel = function () {
                scope.closeModal();
            };
            scope.setDeskInfo = function (_id) {
                var item = scope.editGroups[_id];
                item._id = _id;
                item.type = 'desk';
                item.order = 0;
                var deskOutput = scope.editGroups[_id + ':output'];
                if (deskOutput) {
                    deskOutput.selected = item.selected;
                }
                var scheduledDeskOutput = scope.editGroups[_id + ':scheduled'];
                if (scheduledDeskOutput) {
                    scheduledDeskOutput.selected = item.selected;
                }
            };
            scope.setStageInfo = function (_id) {
                var item = scope.editGroups[_id];
                if (!item.type) {
                    item._id = _id;
                    item.type = 'stage';
                    item.max_items = defaultMaxItems;
                    item.order = lodash_1.default.size(scope.editGroups);
                }
            };
            scope.setDeskOutputInfo = function (_id) {
                var item = scope.editGroups[_id];
                item._id = _id;
                item.type = 'deskOutput';
                item.max_items = defaultMaxItems;
                item.order = lodash_1.default.size(scope.editGroups);
                scope.editGroups[_id] = item;
            };
            scope.setScheduledDeskOutputInfo = function (_id) {
                var item = scope.editGroups[_id];
                item._id = _id;
                item.type = 'scheduledDeskOutput';
                item.max_items = defaultMaxItems;
                item.order = lodash_1.default.size(scope.editGroups);
                scope.editGroups[_id] = item;
            };
            scope.setSearchInfo = function (_id) {
                var item = scope.editGroups[_id];
                if (!item.type) {
                    item._id = _id;
                    item.type = 'search';
                    item.max_items = defaultMaxItems;
                    item.order = lodash_1.default.size(scope.editGroups);
                }
            };
            scope.setPersonalInfo = function () {
                var item = scope.editGroups.personal;
                if (!item.type) {
                    item._id = 'personal';
                    item.type = 'personal';
                    item.max_items = defaultMaxItems;
                    item.order = lodash_1.default.size(scope.editGroups);
                }
            };
            /**
             * Init private saved searches with all saved searches for this user
             */
            scope.initPrivateSavedSearches = function () {
                var user = session.identity._id;
                if (scope.privateSavedSearches.length > 0) {
                    scope.privateSavedSearches.length = 0;
                }
                lodash_1.default.each($filter('sortByName')(scope.searches), function (item) {
                    if (item.user === user && !item.is_global) {
                        scope.privateSavedSearches.push(item);
                    }
                });
            };
            /**
             * Init global saved searches with all saved searches for all users
             * where is_global flag is true
             */
            scope.initGlobalSavedSearches = function () {
                if (scope.globalSavedSearches.length > 0) {
                    scope.globalSavedSearches.length = 0;
                }
                lodash_1.default.each($filter('sortByName')(scope.searches), function (item) {
                    if (item.is_global) {
                        scope.globalSavedSearches.push(item);
                        var group = scope.editGroups[item._id];
                        if (group && group.selected) {
                            scope.showGlobalSavedSearches = true;
                        }
                    }
                });
            };
            /**
             * Return the list of selected groups (stages, personal or saved searches)
             * @return {Array} list of groups
             */
            scope.getValues = function () {
                var values = Object.keys(scope.editGroups).map(function (key) { return scope.editGroups[key]; });
                values = lodash_1.default.filter(values, function (item) {
                    if (item.type === 'desk' || !item.selected) {
                        return false;
                    }
                    if (item.type === 'stage') {
                        var stage = scope.stageLookup[item._id];
                        return scope.editGroups[stage.desk].selected;
                    }
                    if (item.type === 'personal') {
                        return scope.editGroups.personal.selected;
                    }
                    return true;
                });
                values = lodash_1.default.sortBy(values, function (item) { return item.order; });
                lodash_1.default.each(values, function (item) {
                    if (desks.isOutputType(item.type)) {
                        var deskId = item._id.substring(0, item._id.indexOf(':'));
                        item.name = desks.deskLookup[deskId].name;
                    }
                });
                return values;
            };
            scope.reorder = function (start, end, uiItem) {
                var values = scope.getValues();
                if (end.index !== start.index) {
                    values.splice(end.index, 0, values.splice(start.index, 1)[0]);
                    lodash_1.default.each(values, function (item, index) {
                        item.order = index;
                    });
                }
            };
            scope.save = function () {
                var groups = [];
                lodash_1.default.each(scope.getValues(), function (item, index) {
                    if (item.selected && item.type !== 'desk') {
                        groups.push({
                            _id: item._id,
                            type: item.type,
                            max_items: item.max_items,
                        });
                    }
                });
                if (scope.widget) {
                    workspaces.getActive()
                        .then(function (workspace) {
                        var widgets = angular.copy(workspace.widgets);
                        lodash_1.default.each(widgets, function (widget) {
                            if (scope.widget._id === widget._id
                                && scope.widget.multiple_id === widget.multiple_id) {
                                widget.configuration = {};
                                widget.configuration.groups = groups;
                                if (scope.widget.configuration.label) {
                                    widget.configuration.label = scope.widget.configuration.label;
                                }
                            }
                        });
                        workspaces.save(workspace, { widgets: widgets })
                            .then(function () {
                            scope.showGlobalSavedSearches = false;
                            scope.onclose();
                        });
                    });
                }
                else if (scope.settings && scope.settings.desk) {
                    desks.save(scope.deskLookup[scope.settings.desk._id], { monitoring_settings: groups })
                        .then(function () {
                        WizardHandler.wizard('aggregatesettings').finish();
                    });
                }
                else {
                    workspaces.getActiveId()
                        .then(function (activeWorkspace) {
                        if (activeWorkspace.type === 'workspace' || activeWorkspace.type === 'desk') {
                            preferencesService.get(PREFERENCES_KEY)
                                .then(function (preferences) {
                                var updates = {};
                                if (preferences) {
                                    updates[PREFERENCES_KEY] = preferences;
                                }
                                updates[PREFERENCES_KEY][activeWorkspace.id] = { groups: groups };
                                preferencesService.update(updates, PREFERENCES_KEY)
                                    .then(function () {
                                    WizardHandler.wizard('aggregatesettings').finish();
                                });
                            });
                        }
                    });
                    scope.showGlobalSavedSearches = false;
                    scope.onclose();
                }
            };
        },
    };
}
exports.AggregateSettings = AggregateSettings;


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
Object.defineProperty(exports, "__esModule", { value: true });
function SortGroups() {
    return {
        link: function (scope, element) {
            var updated = false;
            element.sortable({
                items: '.sort-item',
                cursor: 'move',
                containment: '.groups',
                tolerance: 'pointer',
                placeholder: {
                    element: function (current) {
                        var height = current.height() - 20;
                        return $('<li class="placeholder" style="height:' + height + 'px"></li>')[0];
                    },
                    update: function () { },
                },
                start: function (event, ui) {
                    ui.item
                        .data('start_index', ui.item
                        .parent()
                        .find('li.sort-item')
                        .index(ui.item));
                },
                stop: function (event, ui) {
                    if (updated) {
                        updated = false;
                        var start = {
                            index: ui.item.data('start_index'),
                        };
                        var end = {
                            index: ui.item
                                .parent()
                                .find('li.sort-item')
                                .index(ui.item),
                        };
                        scope.reorder(start, end, ui.item);
                        ui.item.remove();
                        scope.$apply();
                    }
                },
                update: function (event, ui) {
                    updated = true;
                },
                cancel: '.fake',
            });
        },
    };
}
exports.SortGroups = SortGroups;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var lodash_1 = __importDefault(__webpack_require__(2));
var components_1 = __webpack_require__(22);
WidgetGroup.$inject = [
    'search',
    'api',
    'superdesk',
    'desks',
    'cards',
    '$timeout',
    '$q',
    '$location',
    '$anchorScroll',
    'activityService',
    '$rootScope',
    'datetime',
    'metadata',
];
function WidgetGroup(search, api, superdesk, desks, cards, $timeout, $q, $location, $anchorScroll, activityService, $rootScope, datetime, metadata) {
    var services = {
        search: search,
        api: api,
        superdesk: superdesk,
        desks: desks,
        cards: cards,
        $timeout: $timeout,
        $q: $q,
        $location: $location,
        $anchorScroll: $anchorScroll,
        activityService: activityService,
        $rootScope: $rootScope,
        datetime: datetime,
        metadata: metadata,
    };
    return {
        scope: {
            stage: '=',
            total: '=',
            allowed: '=',
            showEmpty: '=?',
            maxItems: '=?',
            selected: '=?',
            action: '&',
            filter: '=',
        },
        link: function (scope, elem) {
            var criteria;
            scope.page = 1;
            scope.fetching = false;
            scope.itemIds = [];
            scope.itemsById = {};
            /**
              * Generates Identifier to be used by track by expression.
              */
            scope.generateTrackByIdentifier = function (item) {
                return search.generateTrackByIdentifier(item);
            };
            scope.preview = function (item) {
                superdesk.intent('preview', 'item', item);
            };
            scope.edit = function (item) {
                if (item._type === 'ingest') {
                    var activity = superdesk.findActivities({ action: 'list', type: 'ingest' }, item)[0];
                    activityService.start(activity, { data: { item: item } }).then(function (_item) {
                        initEdit(_item);
                    });
                }
                else {
                    initEdit(item);
                }
                function initEdit(_item) {
                    superdesk.intent('edit', 'item', _item).then(null, function () {
                        superdesk.intent('view', 'item', _item);
                    });
                }
            };
            function getProvider(_criteria) {
                var provider = 'archive';
                if (scope.stage.type && (desks.isOutputType(scope.stage.type) || scope.stage.type === 'search')) {
                    provider = 'search';
                }
                if (_criteria.repo && _criteria.repo.indexOf(',') === -1) {
                    provider = _criteria.repo;
                }
                return provider;
            }
            function queryItems(queryString, params) {
                if (!scope.fetching) {
                    // page reload disabled when the user scrolls
                    if (container.scrollTop > 20) {
                        return;
                    }
                    scope.page = 1;
                    scope.itemIds = [];
                    scope.itemsById = {};
                }
                criteria = cards.criteria(scope.stage, queryString);
                if (scope.page > 0 && criteria.source) {
                    criteria.source.from = (scope.page - 1) * criteria.source.size;
                }
                if (params) {
                    angular.extend(criteria, params);
                }
                api.query(getProvider(criteria), criteria)
                    .then(function (items) {
                    items._items.forEach(function (item) {
                        var itemId = search.generateTrackByIdentifier(item);
                        if (!scope.itemsById[itemId]) {
                            scope.itemIds.push(itemId);
                        }
                        scope.itemsById[itemId] = item;
                    });
                    scope.total = items._meta.total;
                })
                    .finally(function () {
                    scope.fetching = false;
                    if ($rootScope.config.features.customMonitoringWidget &&
                        !scope.selected && scope.itemIds && scope.itemIds.length) {
                        scope.selected = scope.itemsById[lodash_1.default.head(scope.itemIds)];
                        scope.action({ item: scope.selected });
                    }
                    scope.updateList({
                        itemIds: scope.itemIds,
                        itemsById: scope.itemsById,
                        loading: false,
                        selected: scope.selected,
                    });
                });
            }
            scope.updateItem = function (item, gone, schedule) {
                var itemId;
                if (!item) {
                    if (schedule) {
                        scheduleQuery();
                        return;
                    }
                    return;
                }
                itemId = search.generateTrackByIdentifier(item);
                if (scope.itemsById[itemId]) {
                    angular.extend(item, {
                        gone: gone,
                    });
                    scope.itemsById[itemId] = item;
                    scope.updateList({
                        itemIds: scope.itemIds,
                        itemsById: scope.itemsById,
                    });
                }
                else if (schedule) {
                    scheduleQuery();
                }
            };
            scope.$on('item:spike', scheduleQuery);
            scope.$on('item:unspike', scheduleQuery);
            scope.$on('item:copy', scheduleQuery);
            scope.$on('item:unlink', scheduleQuery);
            scope.$on('item:duplicate', scheduleQuery);
            scope.$on('item:translate', scheduleQuery);
            scope.$on('item:highlights', scheduleQuery);
            scope.$on('item:marked_desks', scheduleQuery);
            if (scope.stage.type === 'search' && search.doesSearchAgainstRepo(scope.stage.search, 'ingest')) {
                scope.$on('ingest:update', scheduleQuery);
            }
            scope.$watch('filter', function (query) {
                container.scrollTop = 0;
                queryItems(query);
            });
            scope.$on('task:stage', function (_e, data) {
                if (scope.stage && (data.new_stage === scope.stage._id || data.old_stage === scope.stage._id)) {
                    scope.updateItem(getItem(data.item), data.new_stage !== scope.stage._id, true);
                }
            });
            scope.$on('content:update', function (_e, data) {
                if (data && cards.shouldUpdate(scope.stage, data)) {
                    scheduleQuery();
                }
            });
            scope.$on('item:fetch', function (_e, data) {
                if (cards.shouldUpdate(scope.stage, data)) {
                    scheduleQuery();
                }
            });
            scope.$on('item:move', function (_e, data) {
                if (data.to_desk && data.from_desk !== data.to_desk ||
                    data.to_stage && data.from_stage !== data.to_stage) {
                    scope.updateItem(getItem(data.item), scope.stage._id !== data.to_stage, true);
                }
            });
            scope.$on('content:expired', function (_e, data) {
                scope.updateItem(getItem(data.item), true, false);
            });
            scope.$on('item:lock', function (_e, data) {
                var item = getItem(data.item);
                if (!item) {
                    return;
                }
                item.lock_user = data.user;
                scope.updateItem(item, false, false);
            });
            scope.$on('item:unlock', function (_e, data) {
                var item = getItem(data.item);
                if (!item) {
                    return;
                }
                item.lock_user = null;
                scope.updateItem(item, false, false);
            });
            function getItem(itemId) {
                var result;
                lodash_1.default.forOwn(scope.itemsById, function (item, key) {
                    if (item._id === itemId) {
                        result = item;
                    }
                });
                return result;
            }
            var queryTimeout;
            /**
             * Schedule content reload after some delay
             *
             * In case it gets called multiple times it will query only once
             */
            function scheduleQuery(delay) {
                if (delay === void 0) { delay = 5000; }
                if (!queryTimeout) {
                    queryTimeout = $timeout(function () {
                        queryItems(null, { auto: 1 });
                        scope.$applyAsync(function () {
                            // ignore any updates requested in current $digest
                            queryTimeout = null;
                        });
                    }, delay, false);
                }
            }
            var container = elem[0];
            var offsetY = 0;
            var itemHeight = 0;
            var lastScrollTop = 0;
            elem.bind('scroll', function (event) {
                if (scope.fetching) { // ignore scrolling while fetching
                    event.preventDefault();
                    return false;
                }
                if (container.scrollTop + container.offsetHeight >= container.scrollHeight - 3 &&
                    lastScrollTop <= container.scrollTop) {
                    lastScrollTop = container.scrollTop;
                    return scope.fetchNext().then(function () {
                        setFetching();
                        container.scrollTop -= 3;
                    });
                }
                if (container.scrollTop <= 2 && lastScrollTop >= container.scrollTop) {
                    lastScrollTop = container.scrollTop;
                    offsetY = 2 - container.scrollTop;
                    container.scrollTop += offsetY;
                }
            });
            /**
             * This will ignore scrolling for a while, used before we trigger scrolling
             */
            function setFetching() {
                scope.fetching = true;
                $timeout(function () {
                    scope.$applyAsync(function () {
                        scope.fetching = false;
                    });
                }, 200, false);
            }
            scope.fetchNext = function () {
                if (!scope.fetching) {
                    scope.page += 1;
                    scope.fetching = true;
                    queryItems();
                }
                return $q.when(false);
            };
            var UP = -1, DOWN = 1;
            var code;
            elem.on('keydown', function (e) {
                scope.$apply(function () {
                    if (e.keyCode) {
                        code = e.keyCode;
                    }
                    else if (e.which) {
                        code = e.which;
                    }
                    if (code === 38) {
                        scope.move(UP, e);
                    }
                    if (code === 40) {
                        scope.move(DOWN, e);
                    }
                    if (code === 13 && scope.selected) {
                        scope.edit(scope.selected);
                    }
                });
            });
            scope.move = function (diff, event) {
                if (!lodash_1.default.isNil(scope.selected) && $rootScope.config.features.customMonitoringWidget && scope.itemIds) {
                    var itemId = scope.generateTrackByIdentifier(scope.selected);
                    var index = scope.itemIds.findIndex(function (x) { return x === itemId; });
                    if (!itemHeight) {
                        var containerItems = container.getElementsByTagName('li');
                        if (containerItems.length) {
                            itemHeight = containerItems[0].offsetHeight;
                        }
                    }
                    if (index === -1) { // selected not in current items, select first
                        container.scrollTop = 0;
                        clickItem(scope.itemsById[lodash_1.default.head(scope.itemIds)], event);
                    }
                    var nextIndex = lodash_1.default.max([0, lodash_1.default.min([scope.itemIds.length - 1, index + diff])]);
                    if (nextIndex < 0) {
                        clickItem(scope.itemsById[lodash_1.default.last(scope.itemIds)], event);
                    }
                    if (index !== nextIndex) {
                        // scrolling in monitoring widget for ntb is done by keyboard
                        // when we select next item if item is out of focus (not visible) it will scroll down
                        if ((nextIndex + 2) * itemHeight > container.offsetHeight + container.scrollTop &&
                            nextIndex > index) {
                            container.scrollTop += itemHeight * 2;
                        }
                        // when we select previous item if item is out of focus (not visible) it will scroll up
                        if (nextIndex * itemHeight < container.scrollTop && nextIndex < index) {
                            container.scrollTop -= itemHeight * 2;
                        }
                        clickItem(scope.itemsById[scope.itemIds[nextIndex]], event);
                    }
                    else if (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                    }
                }
            };
            function clickItem(item, $event) {
                scope.select(item, false);
                if ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    $event.stopImmediatePropagation();
                }
            }
            scope.select = function (item, apply) {
                if (apply === void 0) { apply = true; }
                scope.action({ item: item });
                scope.updateList({ selected: item });
                if (apply) {
                    scope.$apply();
                }
            };
            scope.setLoading = function (loading) {
                scope.updateList({
                    loading: loading,
                });
            };
            scope.getUpdateCallback = function (updateCallback) {
                scope.updateList = updateCallback;
            };
            var itemList = react_1.default.createElement(components_1.WidgetItemList, {
                allowed: scope.allowed,
                customMonitoringWidget: $rootScope.config.features.customMonitoringWidget,
                svc: services,
                preview: scope.preview,
                select: scope.select,
                edit: scope.edit,
                updateCallback: scope.getUpdateCallback,
            });
            react_dom_1.default.render(itemList, elem[0]);
            // remove react elem on destroy
            scope.$on('$destroy', function () {
                elem.off();
                react_dom_1.default.unmountComponentAtNode(elem[0]);
            });
        },
    };
}
exports.WidgetGroup = WidgetGroup;


/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CardsService_1 = __webpack_require__(1969);
exports.CardsService = CardsService_1.CardsService;


/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var SearchService_1 = __webpack_require__(248);
CardsService.$inject = ['api', 'search', 'session', 'desks', 'config'];
function CardsService(api, search, session, desks, config) {
    this.criteria = getCriteria;
    this.shouldUpdate = shouldUpdate;
    function getCriteriaParams(card) {
        var params = {};
        if (card.type === 'search' && card.search && card.search.filter.query) {
            angular.copy(card.search.filter.query, params);
            if (card.query) {
                if (card.search.filter.query.q) {
                    params.q = '(' + card.query + ') ' + card.search.filter.query.q;
                }
                else {
                    params.q = '(' + card.query + ') ';
                }
            }
        }
        else {
            params.q = card.query;
        }
        if (card.type === 'spike' || card.type === 'spike-personal') {
            params.spike = 'only';
        }
        return params;
    }
    function filterQueryByCardType(query, queryParam, card) {
        var deskId;
        switch (card.type) {
            case 'search':
                break;
            case 'spike-personal':
            case 'personal':
                query.filter({ bool: {
                        must: { term: { original_creator: session.identity._id } },
                        must_not: { exists: { field: 'task.desk' } },
                    } });
                break;
            case 'spike':
                query.filter({ term: { 'task.desk': card._id } });
                break;
            case 'highlights':
                query.filter({ and: [
                        { term: { highlights: queryParam.highlight } },
                    ] });
                break;
            case 'deskOutput':
                filterQueryByDeskType(query, card);
                break;
            case 'scheduledDeskOutput':
                deskId = card._id.substring(0, card._id.indexOf(':'));
                query.filter({ and: [
                        { term: { 'task.desk': deskId } },
                        { term: { state: 'scheduled' } },
                    ] });
                break;
            default:
                if (!lodash_1.default.isNil(card.singleViewType) && card.singleViewType === 'desk') {
                    query.filter({ term: { 'task.desk': card.deskId } });
                }
                else {
                    query.filter({ term: { 'task.stage': card._id } });
                }
                break;
        }
    }
    function filterQueryByDeskType(query, card) {
        var deskId = card._id.substring(0, card._id.indexOf(':'));
        var desk = desks.deskLookup ? desks.deskLookup[deskId] : null;
        var states = ['scheduled', 'published', 'corrected', 'killed', 'recalled'];
        if (config.monitoring && config.monitoring.scheduled) {
            states = ['published', 'corrected', 'killed', 'recalled'];
        }
        if (desk) {
            if (desk.desk_type === 'authoring') {
                query.filter({ or: [
                        { term: { 'task.last_authoring_desk': deskId } },
                        { and: [
                                { term: { 'task.desk': deskId } },
                                { terms: { state: states } },
                            ] },
                    ] });
            }
            else if (desk.desk_type === 'production') {
                query.filter({ and: [
                        { term: { 'task.desk': deskId } },
                        { terms: { state: states } }
                    ] });
            }
        }
    }
    function filterQueryByCardFileType(query, card) {
        if (card.fileType) {
            var termsHighlightsPackage = { and: [
                    { bool: { must: { exists: { field: 'highlight' } } } },
                    { term: { type: 'composite' } },
                ] };
            var termsFileType = { terms: { type: JSON.parse(card.fileType) } };
            // Normal package
            if (lodash_1.default.includes(JSON.parse(card.fileType), 'composite')) {
                termsFileType = { and: [
                        { bool: { must_not: { exists: { field: 'highlight' } } } },
                        { terms: { type: JSON.parse(card.fileType) } },
                    ] };
            }
            if (lodash_1.default.includes(JSON.parse(card.fileType), 'highlightsPackage')) {
                query.filter({ or: [
                        termsHighlightsPackage,
                        termsFileType,
                    ] });
            }
            else {
                query.filter(termsFileType);
            }
        }
    }
    /**
     * Get items criteria for given card
     *
     * Card can be stage/personal/saved search.
     * There can be also extra string search query
     *
     * @param {Object} card
     * @param {string} queryString
     */
    function getCriteria(card, queryString, queryParam) {
        var params = getCriteriaParams(card);
        var query = search.query(SearchService_1.setFilters(params));
        var criteria = { es_highlight: card.query ? search.getElasticHighlight() : 0 };
        filterQueryByCardType(query, queryParam, card);
        filterQueryByCardFileType(query, card);
        if (queryString) {
            query.filter({ query: { query_string: { query: queryString, lenient: false } } });
            criteria.es_highlight = search.getElasticHighlight();
        }
        criteria.source = query.getCriteria();
        if (card.type === 'search' && card.search && card.search.filter.query.repo) {
            criteria.repo = card.search.filter.query.repo;
        }
        else if (desks.isPublishType(card.type)) {
            criteria.repo = 'archive,published';
        }
        criteria.source.from = 0;
        criteria.source.size = card.max_items || 25;
        return criteria;
    }
    function shouldUpdate(card, data) {
        switch (card.type) {
            case 'stage':
                // refresh stage if it matches updated stage
                return data.stages && !!data.stages[card._id];
            case 'personal':
                return data.user === session.identity._id;
            case 'deskOutput':
            case 'scheduledDeskOutput':
                var deskId = card._id.substring(0, card._id.indexOf(':'));
                if (deskId) {
                    return data.desks && !!data.desks[deskId];
                }
                return false;
            default:
                // no way to determine if item should be visible, refresh
                return true;
        }
    }
}
exports.CardsService = CardsService;


/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SplitFilter() {
    return function (input) {
        if (input === void 0) { input = ''; }
        var out = '';
        for (var i = 0; i < input.length; i++) {
            if (input.charAt(i) === input.charAt(i).toUpperCase()) {
                out = out + ' ';
            }
            out = out + input.charAt(i);
        }
        return out;
    };
}
exports.SplitFilter = SplitFilter;


/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc controller
 * @module superdesk.apps.monitoring
 */
MonitoringController.$inject = ['$rootScope', '$scope', '$location', 'desks', 'config', 'superdeskFlags',
    'search', '$filter', 'preferencesService', '$q'];
function MonitoringController($rootScope, $scope, $location, desks, config, superdeskFlags, search, $filter, preferencesService, $q) {
    var _this = this;
    this.state = {};
    this.preview = preview;
    this.closePreview = closePreview;
    this.previewItem = null;
    this.selectedGroup = null;
    this.singleGroup = null;
    this.viewSingleGroup = viewSingleGroup;
    this.viewMonitoringHome = viewMonitoringHome;
    this.hasSwimlaneView = config.features && config.features.swimlane ? 1 : 0;
    this.columnsLimit = null;
    // init swimlane view using preferences - use session preferences if set, or fallback to user preferences
    $q.all({
        userPreference: preferencesService.get('monitoring:view'),
        sessionPreference: preferencesService.get('monitoring:view:session'),
    }).then(function (_a) {
        var userPreference = _a.userPreference, sessionPreference = _a.sessionPreference;
        _this.viewColumn = sessionPreference !== null ?
            sessionPreference === 'swimlane' : userPreference.view === 'swimlane';
        _this.switchViewColumn(_this.viewColumn);
    });
    this.selectGroup = selectGroup;
    this.switchViewColumn = switchViewColumn;
    this.queryParam = $location.search();
    this.edit = edit;
    this.editItem = null;
    this.totalItems = '';
    this.showRefresh = false;
    this.showHistoryTab = true;
    this.scrollTop = false;
    this.getGroupLabel = getGroupLabel;
    this.isDeskChanged = function () {
        return desks.changeDesk;
    };
    this.highlightsDeskChanged = function () {
        if (desks.changeDesk) {
            $location.url('/workspace/monitoring');
        }
    };
    var self = this;
    function preview(item) {
        self.previewItem = item;
        self.state['with-preview'] = superdeskFlags.flags.previewing = !!item;
        var sendPreviewEvent = lodash_1.default.get(config, 'list.narrowView')
            && search.singleLine && superdeskFlags.flags.authoring;
        var evnt = item ? 'rowview:narrow' : 'rowview:default';
        if (!lodash_1.default.isNil(self.previewItem)) {
            self.showHistoryTab = self.previewItem.state !== 'ingested' &&
                !lodash_1.default.includes(['archived', 'externalsource'], self.previewItem._type);
        }
        if (!item) {
            self.selectedGroup = null;
        }
        if (sendPreviewEvent) {
            $rootScope.$broadcast(evnt);
        }
    }
    function closePreview() {
        preview(null);
        if (self.viewColumn) {
            $rootScope.$broadcast('resize:header');
        }
    }
    function edit(item) {
        self.editItem = item;
        self.state['with-authoring'] = !!item;
    }
    function viewSingleGroup(group, type) {
        group.singleViewType = type;
        self.singleGroup = group;
    }
    function viewMonitoringHome() {
        self.singleGroup.singleViewType = null;
        self.singleGroup = null;
    }
    /**
     * @description Switches the view to swimlane or list in monitoring view and
     * returns a columnsLimit a number or null for swimlane or list respectively.
     * @param {Boolean} viewColumn if set to true then function returns columnsLimit
     * for swimlane as per configuration.
     * @param {Boolean} updateSession if set it will update user session setting.
     * @returns {Number|null} function returns columnsLimit null if viewColumn is false.
     */
    function switchViewColumn(viewColumn, updateSession, numberOfColumns) {
        self.viewColumn = viewColumn;
        if (self.viewColumn) {
            self.columnsLimit = numberOfColumns ? numberOfColumns : config.features.swimlane.defaultNumberOfColumns;
        }
        else {
            self.columnsLimit = null;
        }
        $scope.$broadcast('view:column', { viewColumn: self.viewColumn });
        if (updateSession) {
            preferencesService.update({ 'monitoring:view:session': viewColumn }, 'monitoring:view:session');
        }
        return self.columnsLimit;
    }
    function selectGroup(group) {
        self.selectedGroup = self.selectedGroup && self.selectedGroup._id === group._id ? null : group;
        return self.selectedGroup;
    }
    function getGroupLabel(group, activeWorkspace) {
        var groupLabel;
        if (group.subheader) {
            groupLabel = activeWorkspace === 'workspace' ?
                group.header + ' ' + group.subheader : group.subheader;
        }
        else {
            groupLabel = group.header + ' ' + $filter('splitText')(group.type);
        }
        return groupLabel;
    }
}
exports.MonitoringController = MonitoringController;


/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
__webpack_require__(1973);
var superdesk_ui_framework_1 = __webpack_require__(59);
var settings_1 = __webpack_require__(1975);
var directive = __importStar(__webpack_require__(1976));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.settings
 * @name superdesk.apps.settings
 * @packageName superdesk.apps
 * @description Superdesk application settings UI module.
 */
exports.default = angular.module('superdesk.apps.settings', [])
    .config(['superdeskProvider', function (superdesk) {
        superdesk.activity('/settings', {
            label: utils_1.gettext('Settings'),
            description: utils_1.gettext('Do some admin chores'),
            controller: angular.noop,
            templateUrl: 'scripts/apps/settings/views/main.html',
            category: superdesk.MENU_MAIN,
            priority: 1000,
            adminTools: true,
            _settings: 1,
        });
    }])
    .component('sdSettingsView', superdesk_ui_framework_1.reactToAngular1(settings_1.Settings))
    .directive('sdDateParam', directive.DateParam)
    .directive('sdValidError', directive.ValidError)
    .directive('sdRoleUnique', directive.RoleUnique);


/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1974);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.settings-page {\n  position: absolute;\n  top: 48px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff; }\n  .settings-page .tabbable.outer {\n    height: 100%; }\n    .settings-page .tabbable.outer > .nav-stacked {\n      width: 180px;\n      position: absolute;\n      padding: 0;\n      bottom: 0;\n      top: 0;\n      left: 0;\n      margin: 0;\n      flex-direction: column;\n      background: #f8f8f8;\n      border-right: 1px solid #ddd;\n      box-shadow: inset -3px 0 8px -3px rgba(0, 0, 0, 0.1);\n      overflow-y: auto; }\n      .settings-page .tabbable.outer > .nav-stacked > li > a {\n        border: 1px solid #eee;\n        border-width: 1px 0;\n        color: #3097b5;\n        padding: 10px 8px 10px 16px;\n        display: block; }\n        .settings-page .tabbable.outer > .nav-stacked > li > a:hover {\n          background: #f5f5f5;\n          box-shadow: inset -3px 0 5px -3px rgba(0, 0, 0, 0.1); }\n      .settings-page .tabbable.outer > .nav-stacked > li.active > a {\n        border-color: #e0e0e0;\n        position: relative;\n        border-radius: 0 !important;\n        color: #484848;\n        box-shadow: inset -3px 0 2px #f0f0f0; }\n        .settings-page .tabbable.outer > .nav-stacked > li.active > a:hover {\n          background: #fff; }\n      .settings-page .tabbable.outer > .nav-stacked > li:first-child > a {\n        border-top-color: #f8f8f8 !important; }\n    .settings-page .tabbable.outer .tab-content.outer {\n      position: absolute;\n      bottom: 0;\n      top: 0;\n      left: 200px;\n      right: 0;\n      display: block;\n      width: auto; }\n      .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer {\n        display: block; }\n        .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > .nav, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > .header, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > header, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > form .header {\n          border-bottom: 1px solid #dedede;\n          padding: 10px 20px; }\n          .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > .nav h2, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > .header h2, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > header h2, .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > form .header h2 {\n            font-size: 16px;\n            color: #333;\n            font-weight: 500;\n            float: left;\n            line-height: 28px; }\n        .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content > .nav {\n          padding: 0 0 0 10px; }\n        .settings-page .tabbable.outer .tab-content.outer .tab-pane.outer .split-content .content {\n          padding-bottom: 20px; }\n\n.provider-list .last-updated, .sd-list-item .last-updated {\n  font-size: 1.2rem;\n  color: #777;\n  padding: 0 0.1rem; }\n  .provider-list .last-updated span, .sd-list-item .last-updated span {\n    color: #aaa; }\n\n.addSource.modal input {\n  height: 31px;\n  line-height: 19px; }\n  .addSource.modal input.blue-text::-webkit-input-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text:-moz-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text::-moz-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text::-ms-input-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input::-webkit-input-placeholder {\n    font-style: italic; }\n\n.addSource.modal .credentials {\n  margin-top: 20px; }\n  .addSource.modal .credentials label {\n    font-size: 16px; }\n  .addSource.modal .credentials input {\n    float: left;\n    width: 49%; }\n    .addSource.modal .credentials input.first {\n      margin-right: 2%; }\n\n.ruleset-modal header {\n  padding: 10px; }\n\n.ruleset-modal .rule-list > li {\n  position: relative; }\n  .ruleset-modal .rule-list > li .order {\n    position: absolute;\n    left: 0;\n    top: 0;\n    line-height: 28px;\n    color: #aaa; }\n  .ruleset-modal .rule-list > li .actions {\n    position: absolute;\n    right: 0;\n    top: 0; }\n    .ruleset-modal .rule-list > li .actions button {\n      border: 0;\n      background: none; }\n  .ruleset-modal .rule-list > li fieldset {\n    padding: 0 40px; }\n    .ruleset-modal .rule-list > li fieldset .field:first-child {\n      padding-right: 3%; }\n    .ruleset-modal .rule-list > li fieldset .field:last-child {\n      padding-left: 3%; }\n\n.day-filter-box .sd-check__wrapper {\n  margin-left: 0; }\n\n.day-filter-box .sd-checkbox {\n  margin-bottom: 5px;\n  margin-right: 4px; }\n\n.sd-page__header .nav-tabs {\n  padding: 0;\n  margin: 0 0 0 -10px;\n  box-shadow: none; }\n\n.sd-page__header .flat-searchbar {\n  margin-left: -20px;\n  margin-right: 20px; }\n", ""]);

// exports


/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var ReactRenderAsync_1 = __webpack_require__(54);
var lodash_1 = __webpack_require__(2);
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
var SettingsComponent = /** @class */ (function (_super) {
    __extends(SettingsComponent, _super);
    function SettingsComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true,
            flatMenuItems: [],
        };
        return _this;
    }
    SettingsComponent.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, $route = _a.$route, pageTitle = _a.pageTitle, superdesk = _a.superdesk;
        var currentRoute = $route.current;
        pageTitle.setUrl(lodash_1.capitalize(utils_1.gettext('Settings')));
        if (currentRoute.$$route.label !== 'Settings') {
            pageTitle.setWorkspace(lodash_1.capitalize(utils_1.gettext(currentRoute.$$route.label)));
        }
        else {
            pageTitle.setWorkspace(null);
        }
        superdesk.getMenu(superdesk.MENU_SETTINGS).then(function (flatMenuItems) {
            _this.setState({
                flatMenuItems: flatMenuItems.sort(function (a, b) {
                    return b.settings_menu_group.priority - a.settings_menu_group.priority;
                }),
                loading: false,
            });
        });
    };
    SettingsComponent.prototype.render = function () {
        if (this.state.loading) {
            return null;
        }
        var menuItemsByGroup = this.state.flatMenuItems.reduce(function (accumulator, item) {
            if (item.hasOwnProperty('settings_menu_group') === false) {
                throw new Error('Settings items must have a group');
            }
            if (Array.isArray(accumulator[item.settings_menu_group.id]) !== true) {
                accumulator[item.settings_menu_group.id] = [];
            }
            accumulator[item.settings_menu_group.id].push(item);
            return accumulator;
        }, {});
        var listToRender = [];
        var reactKey = 0;
        var currentRoute = this.props.$route.current;
        for (var key in menuItemsByGroup) {
            menuItemsByGroup[key] = menuItemsByGroup[key].sort(function (a, b) {
                var textA = a.label.toLowerCase();
                var textB = b.label.toLowerCase();
                // to sort alphabetically
                if (textA < textB) {
                    return -1;
                }
                if (textA > textB) {
                    return 1;
                }
                return 0;
            });
            var groupLabel = activity_1.coreMenuGroups[key].getLabel();
            listToRender.push(react_1.default.createElement("li", { key: ++reactKey, className: "sd-left-nav__group-header" }, groupLabel));
            menuItemsByGroup[key].forEach(function (item) {
                var className = 'sd-left-nav__btn'
                    + (currentRoute._id === item._id ? ' sd-left-nav__btn--active' : '');
                listToRender.push((react_1.default.createElement("li", { key: ++reactKey },
                    react_1.default.createElement("a", { href: '#' + item.href, className: className }, utils_1.gettext(item.label)))));
            });
        }
        return (react_1.default.createElement("div", { className: "sd-page" },
            react_1.default.createElement("nav", { className: "sd-page__sidebar sd-left-nav" },
                react_1.default.createElement("ul", null, listToRender)),
            react_1.default.createElement("section", { className: "sd-page__main-content" }, this.props.children)));
    };
    return SettingsComponent;
}(react_1.default.Component));
exports.Settings = ReactRenderAsync_1.connectServices(SettingsComponent, ['$route', 'superdesk', 'pageTitle']);


/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DateParam_1 = __webpack_require__(1977);
exports.DateParam = DateParam_1.DateParam;
var ValidError_1 = __webpack_require__(1978);
exports.ValidError = ValidError_1.ValidError;
var RoleUnique_1 = __webpack_require__(1979);
exports.RoleUnique = RoleUnique_1.RoleUnique;


/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
DateParam.$inject = ['$location'];
function DateParam($location) {
    return {
        scope: true,
        link: function (scope, elem, attrs) {
            var search = $location.search();
            if (search[attrs.location]) {
                scope.date = search[attrs.location];
            }
            scope.$watch('date', function (date) {
                $location.search(attrs.location, date);
            });
            scope.$on('$routeUpdate', function (event, route) {
                scope.date = route.params[attrs.location] || null;
            });
        },
    };
}
exports.DateParam = DateParam;


/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function ValidError() {
    return {
        link: function (scope, element) {
            element.addClass('validation-error');
        },
    };
}
exports.ValidError = ValidError;


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
RoleUnique.$inject = ['api', '$q'];
function RoleUnique(api, $q) {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {
            /**
             * Test if given value is unique for seleted field
             */
            function testUnique(modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (value) {
                    var criteria = { where: { name: value } };
                    if (!lodash_1.default.isNil(scope.editRole) && !lodash_1.default.isNil(scope.editRole._id)) {
                        criteria.where._id = { $ne: scope.editRole._id };
                    }
                    return api.roles.query(criteria)
                        .then(function (roles) {
                        if (roles._items.length) {
                            return $q.reject(roles);
                        }
                        return roles;
                    });
                }
                // mark as ok
                return $q.when();
            }
            ctrl.$asyncValidators.unique = testUnique;
        },
    };
}
exports.RoleUnique = RoleUnique;


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(1981);
__webpack_require__(1983);
__webpack_require__(1985);
var ctrl = __importStar(__webpack_require__(1986));
var svc = __importStar(__webpack_require__(1991));
var directive = __importStar(__webpack_require__(1996));
var filters_1 = __webpack_require__(2013);
var lodash_1 = __importDefault(__webpack_require__(2));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.ingest.send', ['superdesk.core.api', 'superdesk.apps.desks'])
    .service('send', svc.SendService);
/**
 * @ngdoc module
 * @module superdesk.apps.ingest
 * @name superdesk.apps.ingest
 * @packageName superdesk.apps
 * @description Adds functionality to ingest items from external sources.
 */
angular.module('superdesk.apps.ingest', [
    'superdesk.apps.search',
    'superdesk.apps.searchProviders',
    'superdesk.apps.dashboard',
    'superdesk.apps.dashboard.widgets.base',
    'superdesk.apps.dashboard.widgets.ingeststats',
    'superdesk.apps.ingest.send',
    'superdesk.config',
    'superdesk.apps.workspace.menu',
])
    .service('ingestSources', svc.IngestProviderService)
    .service('remove', svc.RemoveIngestedService)
    .factory('subjectService', svc.SubjectService)
    .directive('sdIngestSourcesContent', directive.IngestSourcesContent)
    .directive('sdIngestRulesContent', directive.IngestRulesContent)
    .directive('sdIngestRoutingContent', directive.IngestRoutingContent)
    .directive('sdIngestRoutingGeneral', directive.IngestRoutingGeneral)
    .directive('sdIngestRoutingFilter', directive.IngestRoutingFilter)
    .directive('sdIngestRoutingAction', directive.IngestRoutingAction)
    .directive('sdIngestRoutingSchedule', directive.IngestRoutingSchedule)
    .directive('sdPieChartDashboard', directive.PieChartDashboard)
    .directive('sdSortrules', directive.SortRules)
    .directive('sdUserIngestDashboardDropDown', directive.IngestUserDashboardDropdown)
    .directive('sdUserIngestDashboardList', directive.IngestUserDashboardList)
    .directive('sdUserIngestDashboard', directive.IngestUserDashboard)
    .directive('sdIngestProviderConfig', directive.IngestProviderConfig)
    .directive('sdIngestConfigErrors', directive.IngestConfigErrors)
    .filter('insert', filters_1.InsertFilter)
    .filter('scheduleFilter', filters_1.ScheduleFilter)
    .config(['superdeskProvider', 'workspaceMenuProvider', function (superdesk, workspaceMenuProvider) {
        superdesk
            .activity('/workspace/ingest', {
            label: utils_1.gettext('Workspace'),
            priority: 100,
            controller: ctrl.IngestListController,
            templateUrl: 'scripts/apps/archive/views/list.html',
            category: '/workspace',
            topTemplateUrl: 'scripts/apps/dashboard/views/workspace-topnav.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            privileges: { ingest: 1 },
        })
            .activity('/settings/ingest', {
            label: utils_1.gettext('Ingest'),
            templateUrl: 'scripts/apps/ingest/views/settings/settings.html',
            controller: ctrl.IngestSettingsController,
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_FLOW,
            privileges: { ingest_providers: 1 },
        })
            .activity('/ingest_dashboard', {
            label: utils_1.gettext('Ingest Dashboard'),
            templateUrl: 'scripts/apps/ingest/views/dashboard/dashboard.html',
            controller: ctrl.IngestDashboardController,
            category: superdesk.MENU_MAIN,
            priority: 100,
            adminTools: true,
            privileges: { ingest_providers: 1 },
        })
            .activity('remove_ingested', {
            label: utils_1.gettext('Remove'),
            icon: 'trash',
            controller: ['data', 'remove', function (data, remove) {
                    remove.remove(data.item);
                }],
            filters: [{ action: 'list', type: 'ingest' }],
            additionalCondition: ['remove', 'item', function (remove, item) {
                    return remove.canRemove(item);
                }],
            privileges: { fetch: 1 },
        })
            .activity('fetchAs', {
            label: utils_1.gettext('Fetch To'),
            icon: 'fetch-as',
            controller: ['data', 'send', function (data, send) {
                    return send.allAs([data.item], 'fetch_to');
                }],
            filters: [{ action: 'list', type: 'ingest' }],
            privileges: { fetch: 1 },
        })
            .activity('archive', {
            label: utils_1.gettext('Fetch'),
            icon: 'archive',
            monitor: true,
            controller: ['send', 'data', function (send, data) {
                    return send.one(data.item);
                }],
            keyboardShortcut: 'ctrl+enter',
            filters: [{ action: 'list', type: 'ingest' }],
            privileges: { fetch: 1 },
            key: 'f',
            additionalCondition: ['desks', function (desks) {
                    // fetching to 'personal' desk is not allowed
                    return !lodash_1.default.isNil(desks.getCurrentDeskId());
                }],
        })
            .activity('externalsourceTo', {
            label: utils_1.gettext('Fetch To'),
            icon: 'fetch-as',
            monitor: true,
            controller: ['data', 'send', function (data, send) {
                    return send.allAs([data.item], 'externalsourceTo');
                }],
            filters: [{ action: 'list', type: 'externalsource' }],
            privileges: { fetch: 1 },
            additionalCondition: ['config', 'desks', function (config, desks) {
                    // Fetching to 'personal' desk is not allowed
                    return config.features.editFeaturedImage && !lodash_1.default.isNil(desks.getCurrentDeskId());
                }],
        })
            .activity('externalsource', {
            label: utils_1.gettext('Fetch'),
            icon: 'archive',
            monitor: true,
            controller: ctrl.ExternalSourceController,
            filters: [{ action: 'list', type: 'externalsource', id: 'fetch-externalsource' }],
            privileges: { fetch: 1 },
            additionalCondition: ['config', 'desks', function (config, desks) {
                    // Fetching to 'personal' desk is not allowed
                    return config.features.editFeaturedImage && !lodash_1.default.isNil(desks.getCurrentDeskId());
                }],
        });
        workspaceMenuProvider.item({
            href: '/workspace/ingest',
            icon: 'fetch',
            label: utils_1.gettext('Ingest'),
            order: 1200,
            group: 'ingest',
            if: 'workspaceConfig.ingest && privileges.ingest',
            shortcut: 'alt+i',
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('fetch', {
            type: 'http',
            backend: { rel: 'fetch' },
        });
        apiProvider.api('ingest', {
            type: 'http',
            backend: { rel: 'ingest' },
        });
        apiProvider.api('ingestProviders', {
            type: 'http',
            backend: { rel: 'ingest_providers' },
        });
        apiProvider.api('activity', {
            type: 'http',
            backend: { rel: 'activity' },
        });
    }])
    .run(['remove', function (remove) {
        remove.fetchProviders();
    }]);


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1982);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dashboard.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./dashboard.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.ingest-dashboard {\n  padding: 40px;\n  overflow: auto; }\n  .ingest-dashboard .card-list {\n    display: flex;\n    flex-wrap: wrap; }\n  .ingest-dashboard .card-list > li {\n    width: 240px;\n    margin: 10px;\n    padding: 0px;\n    position: relative;\n    flex: 0 0 auto; }\n    .ingest-dashboard .card-list > li:hover {\n      cursor: default; }\n    .ingest-dashboard .card-list > li .card-list__controls {\n      position: absolute;\n      top: 7px;\n      right: 1px; }\n    .ingest-dashboard .card-list > li .header {\n      height: 110px;\n      background: #2c2c2c;\n      padding: 15px;\n      color: #fff;\n      box-sizing: border-box;\n      border-radius: 2px 2px 0 0; }\n      .ingest-dashboard .card-list > li .header .title {\n        padding-bottom: 6px;\n        font-weight: 500; }\n      .ingest-dashboard .card-list > li .header .sub-title {\n        color: #666; }\n        .ingest-dashboard .card-list > li .header .sub-title .text {\n          color: #999;\n          font-weight: 500; }\n    .ingest-dashboard .card-list > li .status {\n      color: #fff;\n      font-size: 14px;\n      padding: 10px 15px;\n      min-height: 36px;\n      box-sizing: content-box; }\n      .ingest-dashboard .card-list > li .status .time {\n        font-size: 11px; }\n      .ingest-dashboard .card-list > li .status.opened {\n        background: #107401; }\n      .ingest-dashboard .card-list > li .status.closed {\n        background: #970000; }\n      .ingest-dashboard .card-list > li .status .uppercase {\n        padding-right: .3em; }\n    .ingest-dashboard .card-list > li .ingested-count {\n      padding: 10px 15px;\n      text-align: center;\n      border-bottom: 1px  solid #e3e3e3; }\n      .ingest-dashboard .card-list > li .ingested-count .count {\n        font-size: 30px;\n        line-height: 34px;\n        font-weight: 700; }\n      .ingest-dashboard .card-list > li .ingested-count .text {\n        font-size: 11px;\n        color: #666; }\n    .ingest-dashboard .card-list > li .update-time {\n      padding: 0 15px 10px 15px;\n      border-bottom: 1px  solid #e3e3e3; }\n      .ingest-dashboard .card-list > li .update-time .text {\n        margin-top: 10px;\n        font-size: 12px;\n        text-transform: uppercase;\n        color: #666;\n        font-weight: 500; }\n      .ingest-dashboard .card-list > li .update-time .time {\n        font-size: 11px; }\n    .ingest-dashboard .card-list > li .error {\n      word-wrap: break-word;\n      color: #E51C23;\n      padding: 5px; }\n    .ingest-dashboard .card-list > li .toggle-box {\n      margin: 10px; }\n      .ingest-dashboard .card-list > li .toggle-box header:before {\n        display: none; }\n      .ingest-dashboard .card-list > li .toggle-box header h6 {\n        background: none; }\n      .ingest-dashboard .card-list > li .toggle-box header i {\n        opacity: 0.6;\n        filter: \"alpha(opacity=60)\"; }\n      .ingest-dashboard .card-list > li .toggle-box header .chevron {\n        background-color: #fff; }\n", ""]);

// exports


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(1984);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./settings.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.addSource.modal input {\n  height: 31px;\n  line-height: 19px; }\n  .addSource.modal input.blue-text::-webkit-input-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text:-moz-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text::-moz-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input.blue-text::-ms-input-placeholder {\n    font-style: normal !important; }\n  .addSource.modal input::-webkit-input-placeholder {\n    font-style: italic; }\n\n.addSource.modal .credentials {\n  margin-top: 20px; }\n  .addSource.modal .credentials label {\n    font-size: 16px; }\n  .addSource.modal .credentials input {\n    float: left;\n    width: 49%; }\n    .addSource.modal .credentials input.first {\n      margin-right: 2%; }\n\n.ingestsource-modal .modal-body {\n  flex: 1 1 auto !important; }\n  .ingestsource-modal .modal-body .popup-subnav {\n    padding-left: 10px; }\n    .ingestsource-modal .modal-body .popup-subnav label {\n      color: #989898; }\n    .ingestsource-modal .modal-body .popup-subnav .TabContent {\n      margin-bottom: 20px; }\n    .ingestsource-modal .modal-body .popup-subnav .field {\n      padding-left: 10px;\n      float: left; }\n      .ingestsource-modal .modal-body .popup-subnav .field .field {\n        padding-left: 0 !important; }\n  .ingestsource-modal .modal-body .article-type {\n    margin-bottom: 30px !important; }\n  .ingestsource-modal .modal-body .rss-config .empty {\n    width: 64px; }\n  .ingestsource-modal .modal-body .rss-config .btn-remove {\n    padding-right: 14px; }\n  .ingestsource-modal .modal-body .rss-config .multiple .field {\n    padding-right: 10px; }\n  .ingestsource-modal .modal-body .field .helper-text--padded {\n    padding-left: 0; }\n\n.ruleset-modal header {\n  padding: 10px; }\n\n.ruleset-modal .modal-body {\n  flex: 1 1 auto !important; }\n\n.ruleset-modal .rule-list > li {\n  position: relative; }\n  .ruleset-modal .rule-list > li .order {\n    position: absolute;\n    left: 0;\n    top: 0;\n    line-height: 28px;\n    color: #aaa; }\n  .ruleset-modal .rule-list > li .actions {\n    position: absolute;\n    right: 0;\n    top: 0; }\n    .ruleset-modal .rule-list > li .actions button {\n      border: 0;\n      background: none; }\n  .ruleset-modal .rule-list > li fieldset {\n    padding: 0 40px; }\n    .ruleset-modal .rule-list > li fieldset .field:first-child {\n      padding-right: 3%; }\n    .ruleset-modal .rule-list > li fieldset .field:last-child {\n      padding-left: 3%; }\n\n.ruleset-modal .modal-body {\n  flex: 1 1 auto !important; }\n\n.shadow-list-holder > .pills-list {\n  margin: 8px 0 0 5px; }\n\n.pills-list--draggable > li {\n  position: relative; }\n  .pills-list--draggable > li:after {\n    content: \"\";\n    width: 6px;\n    transition: opacity ease-in-out 0.2s;\n    top: 4px;\n    bottom: 4px;\n    left: 3px;\n    border: 2px dotted currentColor;\n    border-width: 0 2px;\n    opacity: 0.1;\n    position: absolute;\n    display: block; }\n  .pills-list--draggable > li:hover:after {\n    opacity: 0.6;\n    cursor: move; }\n\n.pills-list--draggable .ui-sortable-placeholder {\n  border: 1px dashed #5ea9c8 !important;\n  background-color: rgba(94, 169, 200, 0.1) !important;\n  visibility: visible !important;\n  box-shadow: none !important; }\n  .pills-list--draggable .ui-sortable-placeholder:after {\n    content: none !important; }\n\n.selected-field {\n  outline: 1px solid #5ea9c8;\n  background-color: rgba(94, 169, 200, 0.1);\n  padding: 0 1rem 1rem; }\n", ""]);

// exports


/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
angular.module('superdesk.apps.dashboard.widgets.ingeststats', [])
    .factory('colorSchemes', ['$resource', function ($resource) {
        return $resource('scripts/apps/ingest/static-resources/color-schemes.json');
    }])
    .config(['dashboardWidgetsProvider', function (dashboardWidgets) {
        dashboardWidgets.addWidget('ingest-stats', {
            label: utils_1.gettext('Ingest Stats'),
            multiple: true,
            icon: 'signal',
            max_sizex: 1,
            max_sizey: 1,
            sizex: 1,
            sizey: 1,
            thumbnail: 'scripts/apps/ingest/ingest-stats-widget/thumbnail.svg',
            template: 'scripts/apps/ingest/ingest-stats-widget/widget-ingeststats.html',
            configurationTemplate: 'scripts/apps/ingest/ingest-stats-widget/configuration.html',
            configuration: {
                source: 'provider',
                colorScheme: 'superdesk',
                updateInterval: 5,
            },
            description: 'Displaying news ingest statistics. You can switch color themes or graph sources.',
        });
    }])
    .controller('IngestStatsController', ['$scope', '$timeout', 'api',
    function ($scope, $timeout, api) {
        function updateData() {
            api.ingest.query().then(function (items) {
                $scope.items = items;
                $timeout(function () {
                    updateData();
                }, $scope.widget.configuration.updateInterval * 1000 * 60);
            });
        }
        updateData();
    }])
    .controller('IngestStatsConfigController', ['$scope', 'colorSchemes',
    function ($scope, colorSchemes) {
        colorSchemes.get(function (colorsData) {
            $scope.schemes = colorsData.schemes;
        });
    }]);


/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IngestListController_1 = __webpack_require__(1987);
exports.IngestListController = IngestListController_1.IngestListController;
var IngestSettingsController_1 = __webpack_require__(1988);
exports.IngestSettingsController = IngestSettingsController_1.IngestSettingsController;
var IngestDashboardController_1 = __webpack_require__(1989);
exports.IngestDashboardController = IngestDashboardController_1.IngestDashboardController;
var ExternalSourceController_1 = __webpack_require__(1990);
exports.ExternalSourceController = ExternalSourceController_1.ExternalSourceController;


/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var controllers_1 = __webpack_require__(574);
var IngestListController = /** @class */ (function (_super) {
    __extends(IngestListController, _super);
    function IngestListController($scope, $injector, $location, api, $rootScope, search, desks) {
        var _this = _super.call(this, $scope, $location, search, desks) || this;
        $scope.type = 'ingest';
        $scope.loading = false;
        $scope.repo = {
            ingest: true,
            archive: false,
            search: 'local',
        };
        $scope.api = api.ingest;
        $rootScope.currentModule = 'ingest';
        _this.fetchItems = function (criteria, next) {
            $scope.loading = true;
            criteria.aggregations = 1;
            criteria.es_highlight = search.getElasticHighlight();
            api.query('ingest', criteria).then(function (items) {
                $scope.items = search.mergeItems(items, $scope.items, next);
                $scope.total = items._meta.total;
            })
                .finally(function () {
                $scope.loading = false;
            });
        };
        _this.fetchItem = function (id) {
            return api.ingest.getById(id);
        };
        var oldQuery = lodash_1.default.omit($location.search(), '_id');
        var update = angular.bind(_this, function searchUpdated() {
            var newquery = lodash_1.default.omit($location.search(), '_id');
            if (!lodash_1.default.isEqual(lodash_1.default.omit(newquery, 'page'), lodash_1.default.omit(oldQuery, 'page'))) {
                $location.search('page', null);
            }
            var query = this.getQuery($location.search());
            this.fetchItems({ source: query });
            oldQuery = newquery;
        });
        $scope.$on('ingest:update', update);
        $scope.$on('item:fetch', update);
        $scope.$on('item:deleted', update);
        $scope.$watchCollection(function getSearchWithoutId() {
            return lodash_1.default.omit($location.search(), '_id');
        }, update);
        return _this;
    }
    return IngestListController;
}(controllers_1.BaseListController));
exports.IngestListController = IngestListController;
IngestListController.$inject = ['$scope', '$injector', '$location', 'api', '$rootScope', 'search', 'desks'];


/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
IngestSettingsController.$inject = ['$scope', 'privileges'];
function IngestSettingsController($scope, privileges) {
    var userPrivileges = privileges.privileges;
    $scope.showIngest = Boolean(userPrivileges.ingest_providers);
    $scope.showRuleset = Boolean(userPrivileges.rule_sets);
    $scope.showRouting = Boolean(userPrivileges.routing_rules);
}
exports.IngestSettingsController = IngestSettingsController;


/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
IngestDashboardController.$inject = ['$scope', 'api', 'ingestSources', 'preferencesService',
    'notify', 'config'];
function IngestDashboardController($scope, $api, ingestSources, preferencesService, notify, config) {
    $scope.items = [];
    $scope.dashboard_items = [];
    $scope.fetchItems = function () {
        ingestSources.fetchDashboardProviders().then(function (result) {
            $scope.items = result;
            $scope.dashboard_items = lodash_1.default.filter(result, { dashboard_enabled: true });
        });
    };
    $scope.setUserPreferences = function (refresh) {
        var preferences = [];
        var update = {};
        lodash_1.default.forEach(lodash_1.default.filter($scope.items, { dashboard_enabled: true }), function (item) {
            preferences.push(lodash_1.default.pick(item, lodash_1.default.union(['_id'], lodash_1.default.keys(config.ingest.PROVIDER_DASHBOARD_DEFAULTS))));
        });
        update['dashboard:ingest'] = preferences;
        preferencesService.update(update).then(function (result) {
            if (refresh) {
                $scope.fetchItems();
            }
        }, function (error) {
            notify.error(utils_1.gettext('Ingest Dashboard preferences could not be saved.'), 2000);
        });
    };
    $scope.fetchItems();
}
exports.IngestDashboardController = IngestDashboardController;


/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.ingest
 * @name ExternalSourceController
 *
 * @requires api
 * @requires data
 * @requires desks
 * @requires notify
 *
 * @description
 *   This controller fetches the item from external source ( like AAP Multimedia, Scanpix) into Superdesk.
 */
ExternalSourceController.$inject = ['api', 'data', 'desks', 'notify'];
function ExternalSourceController(api, data, desks, notify) {
    return api.save(data.item.fetch_endpoint, {
        guid: data.item.guid,
        desk: desks.getCurrentDeskId(),
    }, null, null, { repo: data.item.ingest_provider })
        .then(function (response) {
        data.item = response;
        data.item.actioning = angular.extend({}, data.item.actioning, { externalsource: false });
        notify.success(utils_1.gettext('Item Fetched.'));
        return data.item;
    }, function (error) {
        data.item.error = error;
        notify.error(utils_1.gettext('Failed to get item.'));
        return data.item;
    });
}
exports.ExternalSourceController = ExternalSourceController;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IngestProviderService_1 = __webpack_require__(1992);
exports.IngestProviderService = IngestProviderService_1.IngestProviderService;
var SubjectService_1 = __webpack_require__(1993);
exports.SubjectService = SubjectService_1.SubjectService;
var RemoveIngestedService_1 = __webpack_require__(1994);
exports.RemoveIngestedService = RemoveIngestedService_1.RemoveIngestedService;
var SendService_1 = __webpack_require__(1995);
exports.SendService = SendService_1.SendService;


/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
IngestProviderService.$inject = ['api', '$q', 'preferencesService', '$filter', 'searchProviderService', 'config'];
function IngestProviderService(api, $q, preferencesService, $filter, searchProviderService, config) {
    var _getAllIngestProviders = function (criteria, page, providers) {
        if (criteria === void 0) { criteria = {}; }
        if (page === void 0) { page = 1; }
        if (providers === void 0) { providers = []; }
        return api.query('ingest_providers', lodash_1.default.extend({ max_results: 200, page: page }, criteria))
            .then(function (result) {
            var pg = page;
            var merged = providers.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAllIngestProviders(criteria, pg, merged);
            }
            return $filter('sortByName')(merged);
        });
    };
    var _getAllFeedParsersAllowed = function (criteria, page, parsers) {
        if (criteria === void 0) { criteria = {}; }
        if (page === void 0) { page = 1; }
        if (parsers === void 0) { parsers = []; }
        return api.query('feed_parsers_allowed', lodash_1.default.extend({ max_results: 200, page: page }, criteria))
            .then(function (result) {
            var pg = page;
            var merged = parsers.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAllFeedParsersAllowed(criteria, pg, merged);
            }
            return $filter('sortByName')(merged, 'label');
        });
    };
    var _getAllFeedingServicesAllowed = function (criteria, page, services) {
        if (criteria === void 0) { criteria = {}; }
        if (page === void 0) { page = 1; }
        if (services === void 0) { services = []; }
        return api.query('feeding_services_allowed', lodash_1.default.extend({ max_results: 200, page: page }, criteria))
            .then(function (result) {
            var pg = page;
            // if we have a registered service map for the service return that instead
            // of default result from api
            var merged = services.concat(result._items);
            if (result._links.next) {
                pg++;
                return _getAllFeedingServicesAllowed(criteria, pg, merged);
            }
            return $filter('sortByName')(merged, 'label');
        });
    };
    var _forcedExtend = function (dest, src) {
        lodash_1.default.each(config.ingest.PROVIDER_DASHBOARD_DEFAULTS, function (value, key) {
            if (lodash_1.default.has(src, key)) {
                dest[key] = src[key];
            }
            else {
                dest[key] = config.ingest.PROVIDER_DASHBOARD_DEFAULTS[key];
            }
        });
    };
    var service = {
        providers: null,
        providersLookup: {},
        fetched: null,
        fetchProviders: function () {
            var self = this;
            var providersPromise = $q.all([_getAllIngestProviders(), searchProviderService.getSearchProviders()]);
            return providersPromise.then(function (results) {
                self.providers = [];
                results.forEach(function (result) {
                    self.providers = self.providers.concat(result);
                });
            });
        },
        generateLookup: function () {
            var self = this;
            this.providersLookup = lodash_1.default.keyBy(self.providers, '_id');
            return $q.when();
        },
        initialize: function () {
            if (!this.fetched) {
                this.fetched = this.fetchProviders()
                    .then(angular.bind(this, this.generateLookup));
            }
            return this.fetched;
        },
        fetchAllFeedingServicesAllowed: function (criteria) {
            return _getAllFeedingServicesAllowed(criteria, 1, []);
        },
        fetchAllIngestProviders: function (criteria) {
            return _getAllIngestProviders(criteria);
        },
        fetchAllFeedParsersAllowed: function (criteria) {
            return _getAllFeedParsersAllowed(criteria);
        },
        fetchDashboardProviders: function () {
            var deferred = $q.defer();
            _getAllIngestProviders().then(function (result) {
                var ingestProviders = result;
                preferencesService.get('dashboard:ingest').then(function (userIngestProviders) {
                    lodash_1.default.forEach(ingestProviders, function (provider) {
                        var userProvider = lodash_1.default.find(lodash_1.default.isArray ? userIngestProviders : [userIngestProviders], function (item) { return item._id === provider._id; });
                        provider.dashboard_enabled = !!userProvider;
                        _forcedExtend(provider, userProvider ? userProvider : config.ingest.PROVIDER_DASHBOARD_DEFAULTS);
                    });
                    deferred.resolve(ingestProviders);
                }, function (error) {
                    deferred.reject(error);
                });
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
    };
    return service;
}
exports.IngestProviderService = IngestProviderService;


/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
SubjectService.$inject = ['api'];
function SubjectService(api) {
    var service = {
        rawSubjects: null,
        qcodeLookup: {},
        subjects: [],
        fetched: null,
        fetchSubjects: function () {
            var self = this;
            return api.get('/subjectcodes')
                .then(function (result) {
                self.rawSubjects = result;
            });
        },
        process: function () {
            var self = this;
            lodash_1.default.each(this.rawSubjects._items, function (item) {
                self.qcodeLookup[item.qcode] = item;
            });
            lodash_1.default.each(this.rawSubjects._items, function (item) {
                self.subjects.push({ qcode: item.qcode, name: item.name, path: self.getPath(item) });
            });
            return this.subjects;
        },
        getPath: function (item) {
            var path = '';
            if (item.parent) {
                path = this.getPath(this.qcodeLookup[item.parent]) + this.qcodeLookup[item.parent].name + ' / ';
            }
            return path;
        },
        initialize: function () {
            if (!this.fetched) {
                this.fetched = this.fetchSubjects()
                    .then(angular.bind(this, this.process));
            }
            return this.fetched;
        },
    };
    return service;
}
exports.SubjectService = SubjectService;


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
RemoveIngestedService.$inject = ['api', '$rootScope'];
function RemoveIngestedService(api, $rootScope) {
    this.canRemove = canRemove;
    this.remove = remove;
    this.fetchProviders = fetchProviders;
    var providers = {};
    /**
     * Fetch ingest providers in order to read if remove is allowed
     */
    function fetchProviders() {
        if (api.ingestProviders) {
            return api.ingestProviders.query({ max_results: 200 })
                .then(function (result) {
                lodash_1.default.each(result._items, function (provider) {
                    providers[provider._id] = provider.allow_remove_ingested || false;
                });
            });
        }
    }
    $rootScope.$on('ingest_provider:create', fetchProviders);
    $rootScope.$on('ingest_provider:update', fetchProviders);
    /**
     * Return true if the item can be removed
     *
     * @param {Object} item
     * @returns {boolean}
     */
    function canRemove(item) {
        return item.ingest_provider && providers[item.ingest_provider];
    }
    /**
     * Remove an ingested item
     *
     * @param {Object} item
     */
    function remove(item) {
        return api('ingest').remove(item);
    }
}
exports.RemoveIngestedService = RemoveIngestedService;


/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
SendService.$inject = ['desks', 'api', '$q', 'notify', '$injector', 'multi', '$rootScope'];
function SendService(desks, api, $q, notify, $injector, multi, $rootScope) {
    this.one = sendOne;
    this.all = sendAll;
    this.oneAs = sendOneAs;
    this.allAs = sendAllAs;
    this.config = null;
    this.getConfig = getConfig;
    this.startConfig = startConfig;
    this.getItemsFromPackages = getItemsFromPackages;
    var self = this;
    /**
     * Send given item to a current user desk
     *
     * @param {Object} item
     * @returns {Promise}
     */
    function sendOne(item) {
        if (item._type === 'ingest') {
            return api
                .save('fetch', {}, { desk: desks.getCurrentDeskId() }, item)
                .then(function (archiveItem) {
                item.task_id = archiveItem.task_id;
                item.archived = archiveItem._created;
                multi.reset();
                return archiveItem;
            }, function (response) {
                var message = 'Failed to fetch the item';
                if (angular.isDefined(response.data._message)) {
                    message = message + ': ' + response.data._message;
                }
                notify.error(utils_1.gettext(message));
                item.error = response;
            })
                .finally(function () {
                if (item.actioning) {
                    item.actioning.archive = false;
                }
            });
        }
        else if (item._type === 'externalsource') {
            return api
                .save(item.fetch_endpoint, {
                guid: item.guid,
                desk: desks.getCurrentDeskId(),
            }, null, null, { repo: item.ingest_provider })
                .then(function (fetched) {
                notify.success(utils_1.gettext('Item Fetched.'));
                return fetched;
            }, function (error) {
                item.error = error;
                notify.error(utils_1.gettext('Failed to get item.'));
                return item;
            })
                .finally(function () {
                if (item.actioning) {
                    item.actioning.externalsource = false;
                }
            });
        }
    }
    /**
     * Send all given items to current user desk
     *
     * @param {Array} items
     */
    function sendAll(items) {
        angular.forEach(items, sendOne);
    }
    /**
     * Send given item using config
     *
     * @param {Object} item
     * @param {Object} config
     * @param {string} config.desk - desk id
     * @param {string} config.stage - stage id
     * @param {string} config.macro - macro name
     * @param {string} action - name of the original action
     * @returns {Promise}
     */
    function sendOneAs(item, config, action) {
        var data = getData(config);
        if (item._type === 'ingest') {
            return api.save('fetch', {}, data, item).then(function (archived) {
                item.archived = archived._created;
                if (config.open) {
                    $injector.get('authoringWorkspace').edit(archived);
                }
                return archived;
            });
        }
        else if (action && action === 'duplicateTo') {
            return api.save('duplicate', {}, { desk: data.desk, stage: data.stage, type: item._type, item_id: item.item_id }, item)
                .then(function (duplicate) {
                $rootScope.$broadcast('item:duplicate');
                notify.success(utils_1.gettext('Item Duplicated'));
                if (config.open) {
                    $injector.get('authoringWorkspace').edit({ _id: duplicate._id }, 'edit');
                }
                return duplicate;
            }, function (response) {
                var message = 'Failed to duplicate the item';
                if (angular.isDefined(response.data._message)) {
                    message = message + ': ' + response.data._message;
                }
                notify.error(utils_1.gettext(message));
                item.error = response;
            });
        }
        else if (action && action === 'externalsourceTo') {
            return api.save(item.fetch_endpoint, {
                guid: item.guid,
                desk: data.desk,
                stage: data.stage,
            }, null, null, { repo: item.ingest_provider })
                .then(function (fetched) {
                notify.success(utils_1.gettext('Item Fetched.'));
                if (config.open) {
                    $injector.get('authoringWorkspace').edit({ _id: fetched._id }, 'edit');
                }
                return fetched;
            }, function (error) {
                item.error = error;
                notify.error(utils_1.gettext('Failed to get item.'));
                return item;
            });
        }
        else if (!item.lock_user) {
            return api.save('move', {}, { task: data, allPackageItems: config.sendAllPackageItems }, item)
                .then(function (_item) {
                $rootScope.$broadcast('item:update', { item: _item });
                if (config.open) {
                    $injector.get('authoringWorkspace').edit(_item);
                }
                return _item;
            });
        }
        function getData(_config) {
            var _data = {
                desk: _config.desk,
            };
            if (_config.stage) {
                _data.stage = _config.stage;
            }
            if (_config.macro) {
                _data.macro = _config.macro;
            }
            return _data;
        }
    }
    function getItemsFromPackages(packages) {
        var items = [];
        (packages || []).forEach(function (packageItem) {
            (packageItem.groups || [])
                .filter(function (group) { return group.id !== 'root'; })
                .forEach(function (group) {
                group.refs.forEach(function (item) { return items.push(item.residRef); });
            });
        });
        return items;
    }
    /**
     * Send all given item using config once it's resolved
     *
     * At first it only creates a deferred config which is
     * picked by SendItem directive, once used sets the destination
     * it gets resolved and items are sent.
     *
     * @param {Array} items
     * @return {Promise}
     */
    function sendAllAs(items, action) {
        self.config = $q.defer();
        self.config.action = action;
        self.config.itemIds = lodash_1.default.map(items, '_id');
        self.config.isPackage = items.some(function (item) { return item.type === 'composite'; });
        if (self.config.isPackage) {
            self.config.packageItemIds = getItemsFromPackages(items);
        }
        return self.config.promise.then(function (config) {
            self.config = null;
            multi.reset();
            return $q.all(items.map(function (item) { return sendOneAs(item, config, action); }));
        }, function () {
            self.config = null;
            multi.reset();
        });
    }
    /**
     * Get deffered config if any. Used in $watch
     *
     * @returns {Object|null}
     */
    function getConfig() {
        return self.config;
    }
    /**
     * reset deffered config if any.
     */
    function resetConfig() {
        if (self.config) {
            self.config.reject();
            self.config = null;
        }
    }
    /**
     * Start config via send item sidebar
     *
     * @return {Promise}
     */
    function startConfig() {
        resetConfig();
        self.config = $q.defer();
        return self.config.promise.then(function (val) {
            self.config = null;
            return val;
        });
    }
}
exports.SendService = SendService;


/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PieChartDashboard_1 = __webpack_require__(1997);
exports.PieChartDashboard = PieChartDashboard_1.PieChartDashboard;
var IngestSourcesContent_1 = __webpack_require__(1998);
exports.IngestSourcesContent = IngestSourcesContent_1.IngestSourcesContent;
var IngestRulesContent_1 = __webpack_require__(1999);
exports.IngestRulesContent = IngestRulesContent_1.IngestRulesContent;
var IngestRoutingContent_1 = __webpack_require__(2000);
exports.IngestRoutingContent = IngestRoutingContent_1.IngestRoutingContent;
var IngestRoutingGeneral_1 = __webpack_require__(2001);
exports.IngestRoutingGeneral = IngestRoutingGeneral_1.IngestRoutingGeneral;
var IngestRoutingAction_1 = __webpack_require__(2002);
exports.IngestRoutingAction = IngestRoutingAction_1.IngestRoutingAction;
var IngestRoutingSchedule_1 = __webpack_require__(2003);
exports.IngestRoutingSchedule = IngestRoutingSchedule_1.IngestRoutingSchedule;
var IngestRoutingFilter_1 = __webpack_require__(2004);
exports.IngestRoutingFilter = IngestRoutingFilter_1.IngestRoutingFilter;
var SortRules_1 = __webpack_require__(2005);
exports.SortRules = SortRules_1.SortRules;
var IngestUserDashboard_1 = __webpack_require__(2006);
exports.IngestUserDashboard = IngestUserDashboard_1.IngestUserDashboard;
var IngestUserDashboardList_1 = __webpack_require__(2007);
exports.IngestUserDashboardList = IngestUserDashboardList_1.IngestUserDashboardList;
var IngestUserDashboardDropdown_1 = __webpack_require__(2008);
exports.IngestUserDashboardDropdown = IngestUserDashboardDropdown_1.IngestUserDashboardDropdown;
var IngestProviderConfig_1 = __webpack_require__(2009);
exports.IngestProviderConfig = IngestProviderConfig_1.IngestProviderConfig;
var IngestConfigErrors_1 = __webpack_require__(2011);
exports.IngestConfigErrors = IngestConfigErrors_1.IngestConfigErrors;


/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3_1 = __importDefault(__webpack_require__(550));
var lodash_1 = __importDefault(__webpack_require__(2));
PieChartDashboard.$inject = ['colorSchemes'];
function PieChartDashboard(colorSchemes) {
    return {
        replace: true,
        scope: {
            terms: '=',
            theme: '@',
            colors: '=',
        },
        link: function (scope, element, attrs) {
            var appendTarget = element[0];
            var horizBlocks = attrs.x ? parseInt(attrs.x, 10) : 1;
            var vertBlocks = attrs.y ? parseInt(attrs.y, 10) : 1;
            var graphSettings = {
                blockWidth: 300,
                blockHeight: 197,
                mergeSpaceLeft: 60,
                mergeSpaceBottom: 99,
            };
            var width = graphSettings.blockWidth * horizBlocks + graphSettings.mergeSpaceLeft * (horizBlocks - 1), height = graphSettings.blockHeight * vertBlocks + graphSettings.mergeSpaceBottom * (vertBlocks - 1), radius = Math.min(width, height) / 2;
            colorSchemes.get(function (colorsData) {
                var colorScheme = colorsData.schemes[0];
                var arc = d3_1.default.svg.arc()
                    .outerRadius(radius)
                    .innerRadius(radius * 8 / 13 / 2);
                var sort = attrs.sort || null;
                var pie = d3_1.default.layout.pie()
                    .value(function (d) { return d.doc_count; })
                    .sort(sort ? function (a, b) { return d3_1.default.ascending(a[sort], b[sort]); } : null);
                var svg = d3_1.default.select(appendTarget).append('svg')
                    .attr('width', width)
                    .attr('height', height)
                    .append('g')
                    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
                scope.$watchGroup(['terms', 'colors'], function renderData(newData) {
                    if (!lodash_1.default.isNil(newData[0])) {
                        if (newData[1] !== null) {
                            colorScheme = colorsData.schemes[lodash_1.default.findKey(colorsData.schemes, { name: newData[1] })];
                        }
                        var colorScale = d3_1.default.scale.ordinal()
                            .range(colorScheme.charts);
                        svg.selectAll('.arc').remove();
                        var g = svg.selectAll('.arc')
                            .data(pie(newData[0]))
                            .enter()
                            .append('g')
                            .attr('class', 'arc');
                        g.append('path')
                            .attr('d', arc)
                            .style('fill', function (d) { return colorScale(d.data.key); });
                        g.append('text')
                            .attr('class', 'place-label')
                            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')'; })
                            .style('text-anchor', 'middle')
                            .style('fill', colorScheme.text)
                            .text(function (d) { return d.data.key; });
                        arrangeLabels();
                    }
                });
                function arrangeLabels() {
                    var move = 1;
                    while (move > 0) {
                        move = 0;
                        svg.selectAll('.place-label')
                            .each(rerangeLabels);
                    }
                    function rerangeLabels() {
                        /* jshint validthis: true */
                        var self = this, a = self.getBoundingClientRect();
                        svg.selectAll('.place-label')
                            .each(function () {
                            if (this !== self) {
                                var b = this.getBoundingClientRect();
                                if (Math.abs(a.left - b.left) * 2 < a.width + b.width &&
                                    Math.abs(a.top - b.top) * 2 < a.height + b.height) {
                                    var dx = (Math.max(0, a.right - b.left) +
                                        Math.min(0, a.left - b.right)) * 0.01, dy = (Math.max(0, a.bottom - b.top) +
                                        Math.min(0, a.top - b.bottom)) * 0.02, tt = d3_1.default.transform(d3_1.default.select(this).attr('transform')), to = d3_1.default.transform(d3_1.default.select(self).attr('transform'));
                                    move += Math.abs(dx) + Math.abs(dy);
                                    to.translate = [to.translate[0] + dx, to.translate[1] + dy];
                                    tt.translate = [tt.translate[0] - dx, tt.translate[1] - dy];
                                    d3_1.default.select(this).attr('transform', 'translate(' + tt.translate + ')');
                                    d3_1.default.select(self).attr('transform', 'translate(' + to.translate + ')');
                                    a = this.getBoundingClientRect();
                                }
                            }
                        });
                    }
                }
            });
        },
    };
}
exports.PieChartDashboard = PieChartDashboard;


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var lodash_2 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
IngestSourcesContent.$inject = ['ingestSources', 'notify', 'api', '$location',
    'modal', '$filter', 'config', 'deployConfig', 'privileges'];
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestSourcesContent
 *
 * @requires ingestSources
 * @requires notify
 * @requires api
 * @requires $location
 * @requires modal
 * @requires $filter
 * @requires config
 * @requires deployConfig
 * @requires privileges
 *
 * @description Handles the management for Ingest Sources.
 */
function IngestSourcesContent(ingestSources, notify, api, $location, modal, $filter, config, deployConfig, privileges) {
    return {
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-sources-content.html',
        link: function ($scope) {
            $scope.waitForDirectiveReady = function () {
                return Promise.all([
                    ingestSources.fetchAllFeedingServicesAllowed(),
                ]);
            };
            $scope.waitForDirectiveReady().then(function (waitForDirectiveReadyResult) {
                $scope.feedingServices = waitForDirectiveReadyResult[0];
                $scope.provider = null;
                $scope.allFeedParsers = [];
                $scope.feedParsers = [];
                $scope.fileTypes = [
                    {
                        type: 'text',
                        icon: 'icon-text',
                    },
                    {
                        type: 'picture',
                        icon: 'icon-photo',
                    },
                    {
                        type: 'graphic',
                        icon: 'icon-graphic',
                    },
                    {
                        type: 'composite',
                        icon: 'icon-composite',
                    },
                    {
                        type: 'video',
                        icon: 'icon-video',
                    },
                    {
                        type: 'audio',
                        icon: 'icon-audio',
                    },
                ];
                if (lodash_1.default.get(privileges, 'privileges.planning')) {
                    $scope.fileTypes.push({
                        type: 'event',
                        icon: 'icon-calendar',
                    });
                }
                $scope.minutes = [0, 1, 2, 3, 4, 5, 8, 10, 15, 30, 45];
                $scope.seconds = [0, 5, 10, 15, 30, 45];
                $scope.hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
                    13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
                $scope.ingestExpiry = deployConfig.getSync('ingest_expiry_minutes');
                $scope.statusFilters = [
                    { label: utils_1.gettext('Active'), id: 'active' },
                    { label: utils_1.gettext('All'), id: 'all' },
                    { label: utils_1.gettext('Closed'), id: 'closed' },
                ];
                $scope.activeStatusFilter = $scope.statusFilters[0];
                $scope.filterIngestSources = function (id) {
                    $scope.activeStatusFilter = $scope.statusFilters.find(function (item) { return item.id === id; });
                    fetchProviders();
                };
                $scope.search = function (query) {
                    if (query) {
                        $scope.searchPage = 1;
                    }
                    $scope.searchQuery = query;
                    fetchProviders();
                };
                function fetchProviders() {
                    var criteria = criteria || {};
                    criteria.max_results = $location.search().max_results || 25;
                    criteria.page = $scope.searchPage || $location.search().page || 1;
                    criteria.sort = 'name';
                    var andTerms = [];
                    if (!lodash_1.default.isEmpty($scope.searchQuery)) {
                        andTerms.push({
                            name: {
                                $regex: $scope.searchQuery,
                                $options: '-i',
                            },
                        });
                    }
                    if ($scope.activeStatusFilter.id !== 'all') {
                        andTerms.push({ is_closed: $scope.activeStatusFilter.id !== 'active' });
                    }
                    if (!lodash_1.default.isEmpty(andTerms)) {
                        criteria.where = JSON.stringify({ $and: andTerms });
                    }
                    var searchTerm = $scope.searchQuery;
                    return api.ingestProviders.query(criteria)
                        .then(function (result) {
                        if ($scope.searchQuery === searchTerm) {
                            $scope.providers = result;
                            $scope.searchPage = null;
                        }
                    });
                }
                function openProviderModal() {
                    var providerId = $location.search()._id;
                    var provider;
                    if (providerId) {
                        if ($scope.providers && $scope.providers._items) {
                            provider = lodash_1.default.find($scope.providers._items, function (item) { return item._id === providerId; });
                        }
                        if (lodash_1.default.isNil(provider)) {
                            api.ingestProviders.getById(providerId).then(function (result) {
                                provider = result;
                            });
                        }
                        if (provider) {
                            $scope.edit(provider);
                        }
                    }
                }
                fetchProviders().then(function () {
                    openProviderModal();
                });
                api('rule_sets').query()
                    .then(function (result) {
                    $scope.rulesets = $filter('sortByName')(result._items);
                });
                api('routing_schemes').query()
                    .then(function (result) {
                    $scope.routingScheme = $filter('sortByName')(result._items);
                });
                ingestSources.fetchAllFeedParsersAllowed().then(function (result) {
                    $scope.allFeedParsers = result;
                    $scope.feedParsers = angular.copy(result);
                });
                /**
                * Returns the result of evaluation of a given expression. Identifiers enclosed in {}
                * are replaced with the values of corresponding fields.
                *
                * @method evalExpression
                * @param {String} expression
                * @return {Boolean}
                */
                function evalExpression(expression) {
                    if (!$scope.currentFeedingService) {
                        return false;
                    }
                    var toEvaluate = expression;
                    lodash_1.default.forEach($scope.currentFeedingService.fields, function (field) {
                        var regExp = new RegExp('{' + field.id + '}');
                        toEvaluate = toEvaluate.replace(regExp, $scope.provider.config[field.id]);
                    });
                    return $scope.$eval(toEvaluate);
                }
                /**
                * Returns true if the feeding service configuration field was required
                *
                * @method isConfigFieldRequired
                * @param {Object} field
                * @return {Boolean}
                */
                $scope.isConfigFieldRequired = function (field) {
                    if (field.required) {
                        return true;
                    }
                    if (field.required_expression) {
                        return evalExpression(field.required_expression);
                    }
                    return false;
                };
                /**
                * Returns true if the feeding service configuration field was visible
                *
                * @method isConfigFieldVisible
                * @param {Object} field
                * @return {Boolean}
                */
                $scope.isConfigFieldVisible = function (field) {
                    if (!field.show_expression) {
                        return true;
                    }
                    return evalExpression(field.show_expression);
                };
                /**
                * Returns the configuration field HTML identifier
                *
                * @method getConfigFieldId
                * @param {String} fieldId
                * @return {String}
                */
                $scope.getConfigFieldId = function (fieldId) {
                    if (!$scope.provider.feeding_service) {
                        return null;
                    }
                    return $scope.provider.feeding_service + '-' + fieldId;
                };
                /**
                * Fetches the list of errors for the current feeding service
                *
                * @method fetchSourceErrors
                */
                $scope.fetchSourceErrors = function () {
                    if ($scope.provider && $scope.provider.feeding_service) {
                        return api('io_errors').query({ source_type: $scope.provider.feeding_service })
                            .then(function (result) {
                            $scope.provider.source_errors = result._items[0].source_errors;
                            $scope.provider.all_errors = result._items[0].all_errors;
                        });
                    }
                };
                /**
                * Removed the given ingest provider
                *
                * @method remove
                * @param {Object} provider
                */
                $scope.remove = function (provider) {
                    modal.confirm(utils_1.gettext('Are you sure you want to delete Ingest Source?')).then(function removeIngestProviderChannel() {
                        api.ingestProviders.remove(provider)
                            .then(function () {
                            notify.success(utils_1.gettext('Ingest Source deleted.'));
                        }, function (response) {
                            if (angular.isDefined(response.data._message)) {
                                notify.error(response.data._message);
                            }
                            else {
                                notify.error(utils_1.gettext('Error: Unable to delete Ingest Source'));
                            }
                        })
                            .then(fetchProviders);
                    });
                };
                function initTupleFields() {
                    $scope.fieldAliases = {};
                    $scope.fieldsNotSelected = {};
                    $scope.currentFeedingService = $scope.provider ? lodash_1.default.find($scope.feedingServices, { feeding_service: $scope.provider.feeding_service }) : null;
                    if (!$scope.currentFeedingService) {
                        return;
                    }
                    lodash_1.default.forEach($scope.currentFeedingService.fields, function (field) {
                        if (field.default_value !== undefined && $scope.provider.config[field.id] === undefined) {
                            $scope.provider.config[field.id] = field.default_value;
                        }
                        if (field.type === 'mapping') {
                            var aliases = angular.isDefined($scope.provider.config)
                                && $scope.provider.config[field.id] || [];
                            var aliasObj_1 = {};
                            aliases.forEach(function (item) {
                                lodash_1.default.extend(aliasObj_1, item);
                            });
                            $scope.fieldAliases[field.id] = [];
                            Object.keys(aliasObj_1).forEach(function (fieldName) {
                                $scope.fieldAliases[field.id].push({ fieldName: fieldName, alias: aliasObj_1[fieldName] });
                            });
                            $scope.fieldsNotSelected[field.id] = field.first_field_options.values.filter(function (fieldName) { return !(fieldName in aliasObj_1); });
                        }
                        else if (
                        // preset value in dropdown
                        field.type === 'choices' &&
                            !(field.id in $scope.provider.config) &&
                            'default' in field) {
                            $scope.provider.config[field.id] = field.default;
                        }
                    });
                }
                /**
                 * Edit the given provider.
                 *

                * @method edit
                */
                $scope.edit = function (provider) {
                    $scope.provider = lodash_2.cloneDeep(provider || {});
                    $scope.provider.update_schedule = $scope.provider.update_schedule
                        || config.ingest.DEFAULT_SCHEDULE;
                    $scope.provider.idle_time = $scope.provider.idle_time || config.ingest.DEFAULT_IDLE_TIME;
                    initTupleFields();
                };
                $scope.cancel = function () {
                    $scope.provider = null;
                    $scope.error = null;
                };
                $scope.setConfig = function (provider) {
                    $scope.provider.config = provider.config;
                };
                /**
                * Appends a new (empty) item to the list of field aliases.
                *
                * @method addFieldAlias
                */
                $scope.addFieldAlias = function (fieldId) {
                    if (!$scope.fieldAliases[fieldId]) {
                        $scope.fieldAliases[fieldId] = [];
                    }
                    $scope.fieldAliases[fieldId].push({ fieldName: null, alias: '' });
                };
                /**
                * Removes a field alias from the list of field aliases at the
                * specified index.
                *
                * @method removeFieldAlias
                * @param {Number} itemIdx - index of the item to remove
                */
                $scope.removeFieldAlias = function (fieldId, itemIdx) {
                    var removed = $scope.fieldAliases[fieldId].splice(itemIdx, 1);
                    if (removed[0].fieldName) {
                        $scope.fieldsNotSelected[fieldId].push(removed[0].fieldName);
                    }
                };
                /**
                * Updates the list of content field names not selected in any
                * of the dropdown menus.
                *
                * @method fieldSelectionChanged
                */
                $scope.fieldSelectionChanged = function (field) {
                    var selectedFields = {};
                    $scope.fieldAliases[field.id].forEach(function (item) {
                        if (item.fieldName) {
                            selectedFields[item.fieldName] = true;
                        }
                    });
                    $scope.fieldsNotSelected[field.id] = field.first_field_options.values.filter(function (fieldName) { return !(fieldName in selectedFields); });
                };
                /**
                * Calculates a list of content field names that can be used as
                * options in a dropdown menu.
                *
                * The list is comprised of all field names that are currently
                * not selected in any of the other dropdown menus and
                * of a field name that should be selected in the current
                * dropdown menu (if any).
                *
                * @method availableFieldOptions
                * @param {String} [selectedName] - currently selected field
                * @return {String[]} list of field names
                */
                $scope.availableFieldOptions = function (fieldId, selectedName) {
                    if (!(fieldId in $scope.fieldsNotSelected)) {
                        return [];
                    }
                    var fieldNames = angular.copy($scope.fieldsNotSelected[fieldId]);
                    // add current field selection, if available
                    if (selectedName) {
                        fieldNames.push(selectedName);
                    }
                    return fieldNames;
                };
                /**
                 * Saves the ingest provider.
                 *
                 * @method save
                 */
                $scope.save = function () {
                    lodash_1.default.forEach($scope.currentFeedingService.fields, function (field) {
                        if (field.type !== 'mapping') {
                            return;
                        }
                        var newAliases = [];
                        $scope.fieldAliases[field.id].forEach(function (item) {
                            if (item.fieldName && item.alias) {
                                var newAlias = {};
                                newAlias[item.fieldName] = item.alias;
                                newAliases.push(newAlias);
                            }
                        });
                        if (typeof $scope.provider.config !== 'undefined') {
                            $scope.provider.config[field.id] = newAliases;
                        }
                    });
                    delete $scope.provider.all_errors;
                    delete $scope.provider.source_errors;
                    var originalProvider = $scope.providers._items.find(function (provider) { return provider._id === $scope.provider._id; });
                    $scope.loading = true;
                    api.ingestProviders.save(originalProvider || {}, $scope.provider)
                        .then(function () {
                        notify.success(utils_1.gettext('Provider saved!'));
                        $scope.cancel();
                        $scope.error = null;
                        fetchProviders();
                    }, function (error) {
                        $scope.error = error.data;
                    })
                        .finally(function () {
                        $scope.loading = null;
                    });
                };
                $scope.gotoIngest = function (provider) {
                    var contentTypes = provider.content_types;
                    var length = provider.content_types.includes('preformatted') ? 2 : 1;
                    if (contentTypes.length === length && contentTypes.includes('event')) {
                        var searchParams = {
                            page: 1,
                            noCalendarAssigned: false,
                            calendars: null,
                            advancedSearch: {
                                source: [{
                                        id: provider._id,
                                        name: provider.name,
                                    }],
                            },
                            spikeState: 'draft',
                            fulltext: '',
                        };
                        $location.path('/planning').search({
                            filter: 'EVENTS',
                            isNewSearch: true,
                            searchParams: angular.toJson(searchParams),
                            calendar: 'ALL_CALENDARS',
                        });
                    }
                    else {
                        $location.path('/search').search({ repo: 'ingest', ingest_provider: provider._id });
                    }
                };
                /**
                 * Add or remove the current 'fileType' from the provider.
                 *
                 * @param {string} fileType
                 */
                $scope.addOrRemoveFileType = function (fileType, editForm) {
                    editForm.$setDirty();
                    if (!$scope.provider.content_types) {
                        $scope.provider.content_types = [];
                    }
                    var index = $scope.provider.content_types.indexOf(fileType);
                    if (index > -1) {
                        $scope.provider.content_types.splice(index, 1);
                    }
                    else {
                        $scope.provider.content_types.push(fileType);
                    }
                };
                /**
                 * Return true if the 'fileType' is in provider.content_types list.
                 *
                 * @param {string} fileType
                 * @return boolean
                 */
                $scope.hasFileType = function (fileType) {
                    return $scope.provider && $scope.provider.content_types &&
                        $scope.provider.content_types.indexOf(fileType) > -1;
                };
                /**
                 * Initializes the configuration for the selected feeding service.
                 */
                $scope.initProviderConfig = function () {
                    var service = getCurrentService();
                    if (service && service.config) {
                        $scope.provider.config = angular.extend({}, service.config);
                    }
                    else {
                        $scope.provider.config = {};
                    }
                    initTupleFields();
                    $scope.provider.feed_parser = null;
                    $scope.feedParsers = angular.copy($scope.allFeedParsers);
                    if ($scope.currentFeedingService) {
                        if ($scope.currentFeedingService.parser_restricted_values &&
                            $scope.currentFeedingService.parser_restricted_values.length) {
                            if ($scope.currentFeedingService.parser_restricted_values.length === 1) {
                                $scope.provider.feed_parser =
                                    $scope.currentFeedingService.parser_restricted_values[0];
                            }
                            $scope.feedParsers = lodash_1.default.filter($scope.feedParsers, function (feedParser) {
                                return $scope.currentFeedingService.parser_restricted_values.includes(feedParser.feed_parser);
                            });
                        }
                        else if ($scope.currentFeedingService.parser_restricted_values === null) {
                            $scope.feedParsers = [];
                        }
                    }
                };
                /**
                 * Returns the HTML src from the templateURL (defined in superdesk-config.js
                 * for the selected feeding service.
                 * @returns {string}
                 */
                $scope.getConfigTemplateUrl = function () {
                    var feedingService = getCurrentService();
                    return feedingService ? feedingService.templateUrl : '';
                };
                function getCurrentService() {
                    return lodash_1.default.find($scope.feedingServices, { feeding_service: $scope.provider.feeding_service });
                }
                $scope.$on('$locationChangeSuccess', fetchProviders);
            });
        },
    };
}
exports.IngestSourcesContent = IngestSourcesContent;


/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
IngestRulesContent.$inject = ['api', 'notify', 'modal', '$filter'];
function IngestRulesContent(api, notify, modal, $filter) {
    return {
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-rules-content.html',
        link: function (scope) {
            var _orig = null;
            scope.editRuleset = null;
            api('rule_sets').query()
                .then(function (result) {
                scope.rulesets = $filter('sortByName')(result._items);
            });
            scope.edit = function (ruleset) {
                scope.editRuleset = lodash_1.default.create(ruleset);
                scope.editRuleset.rules = ruleset.rules || [];
                _orig = ruleset;
            };
            scope.save = function (ruleset) {
                var _new = !ruleset._id;
                api('rule_sets').save(_orig, ruleset)
                    .then(function () {
                    if (_new) {
                        scope.rulesets.push(_orig);
                    }
                    scope.rulesets = $filter('sortByName')(scope.rulesets);
                    notify.success(utils_1.gettext('Rule set saved.'));
                    scope.cancel();
                }, function (response) {
                    notify.error(utils_1.gettext('I\'m sorry but there was an error when saving the rule set.'));
                });
            };
            scope.cancel = function () {
                scope.editRuleset = null;
            };
            scope.remove = function (ruleset) {
                confirm().then(function () {
                    api('rule_sets').remove(ruleset)
                        .then(function (result) {
                        lodash_1.default.remove(scope.rulesets, ruleset);
                    }, function (response) {
                        if (angular.isDefined(response.data._message)) {
                            notify.error(utils_1.gettext('Error: ' + response.data._message));
                        }
                        else {
                            notify.error(utils_1.gettext('There was an error. Rule set cannot be deleted.'));
                        }
                    });
                });
            };
            function confirm() {
                return modal.confirm(utils_1.gettext('Are you sure you want to delete rule set?'));
            }
            scope.removeRule = function (rule) {
                lodash_1.default.remove(scope.editRuleset.rules, rule);
            };
            scope.addRule = function () {
                if (!scope.editRuleset.rules) {
                    scope.editRuleset.rules = [];
                }
                scope.editRuleset.rules.push({ old: null, new: null });
            };
            scope.reorder = function (start, end) {
                scope.editRuleset.rules.splice(end, 0, scope.editRuleset.rules.splice(start, 1)[0]);
            };
        },
    };
}
exports.IngestRulesContent = IngestRulesContent;


/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestRoutingContent
 * @description
 *   Creates the main page for adding or editing routing rules (in the
 *   modal for editing ingest routing schemes).
 */
IngestRoutingContent.$inject = ['api', 'notify', 'modal', 'contentFilters', '$filter'];
function IngestRoutingContent(api, notify, modal, contentFilters, $filter) {
    return {
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-routing-content.html',
        link: function (scope) {
            var _orig = null, _origRule = null, _new = false;
            var DEFAULT_DATA = {
                name: null,
                filter: null,
                actions: {
                    fetch: [],
                    publish: [],
                    exit: false,
                },
                schedule: {
                    day_of_week: ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'],
                    hour_of_day_from: null,
                    hour_of_day_to: null,
                    _allDay: true,
                },
            };
            scope.editScheme = null;
            scope.selectedRule = null;
            scope.rule = null;
            scope.schemes = [];
            scope.contentFilters = [];
            initSchemes();
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#edit
             * @param {Object} scheme Scheme data
             * @description Initiate edit modal
             */
            scope.edit = function (scheme) {
                scope.editScheme = lodash_1.default.clone(scheme);
                scope.editScheme.rules = lodash_1.default.clone(scheme.rules || []);
                _orig = scheme;
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#remove
             * @param {Object} scheme Scheme data
             * @description Remove complete scheme
             */
            scope.remove = function (scheme) { return confirm('scheme').then(function () {
                api('routing_schemes').remove(scheme)
                    .then(function () {
                    lodash_1.default.remove(scope.schemes, scheme);
                }, function (response) {
                    angular.isDefined(response.data._message) ?
                        notify.error(utils_1.gettext('Error: ' + response.data._message)) :
                        notify.error(utils_1.gettext('There was an error. Routing scheme cannot be deleted.'));
                });
            }); };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#cancel
             * @description Close Ingest Routing editing modal
             */
            scope.cancel = function () {
                _new = false;
                scope.editScheme = null;
                scope.selectedRule = null;
                scope.rule = null;
                scope.schemes = [];
                scope.contentFilters = [];
                initSchemes();
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#done
             * @description Close Ingest Routing editing modal
             */
            scope.done = function () {
                scope.save().then(function () {
                    scope.cancel();
                });
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#selectRule
             * @param {Object} rule Routing scheme rule's config data
             * @description Pick up rule for preview.
             */
            scope.selectRule = function (rule) {
                rule.filterName = rule.filter ? lodash_1.default.find(scope.contentFilters, { _id: rule.filter }).name : null;
                rule.schedule._allDay = !(lodash_1.default.get(rule, 'schedule.hour_of_day_from', false) ||
                    lodash_1.default.get(rule, 'schedule.hour_of_day_to', false));
                scope.selectedRule = rule;
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#addRule
             * @description Create new rule with default data
             */
            scope.addRule = function () {
                var rule = angular.copy(DEFAULT_DATA);
                scope.editScheme.rules.push(rule);
                scope.editRule(rule);
                _new = true;
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#editRule
             * @param {Object} rule Routing scheme rule's config data
             * @description Opens the given routing scheme rule for editing.
             */
            scope.editRule = function (rule) {
                _origRule = lodash_1.default.clone(rule);
                scope.rule = rule;
                scope.rule.filterName = rule.filter
                    ? lodash_1.default.find(scope.contentFilters, { _id: rule.filter }).name
                    : null;
                scope.rule.schedule._allDay = !(lodash_1.default.get(scope.rule, 'schedule.hour_of_day_from', false) ||
                    lodash_1.default.get(scope.rule, 'schedule.hour_of_day_to', false));
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#save
             * @param {Object} rule Routing scheme rule's config data
             * @description Opens the given routing scheme rule for editing.
             */
            scope.save = function () {
                var diff = lodash_1.default.cloneDeep(scope.editScheme);
                lodash_1.default.forEach(diff.rules, function (r) {
                    // filterName was only needed to display it in the UI
                    delete r.filterName;
                    // only need for display
                    delete r.schedule._allDay;
                });
                return api('routing_schemes').save(_orig, diff)
                    .then(function (result) {
                    if (!scope.editScheme._id) {
                        scope.schemes.push(_orig);
                    }
                    scope.schemes = $filter('sortByName')(scope.schemes);
                    scope.editScheme = lodash_1.default.clone(result);
                    notify.success(utils_1.gettext('Routing scheme saved.'));
                    scope.rule = null;
                    _new = false;
                    initSchemes();
                }, function (response) {
                    notify.error(utils_1.gettext('I\'m sorry but there was an error when saving the routing scheme.'));
                });
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#removeRule
             * @param {Object} rule Routing scheme rule's config data
             * @description Remove rule from list
             */
            scope.removeRule = function (rule) { return confirm('rule').then(function () {
                lodash_1.default.remove(scope.editScheme.rules, rule);
                scope.selectedRule = null;
                scope.rule = null;
            }); };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#reorder
             * @description Reorder schema rules
             */
            scope.reorder = function (start, end) {
                scope.editScheme.rules.splice(end, 0, scope.editScheme.rules.splice(start, 1)[0]);
            };
            /**
             * @ngdoc method
             * @name sdIngestRoutingContent#cancelRule
             * @description Cancel adding or editing schema rule
             */
            scope.cancelRule = function () {
                var index = lodash_1.default.indexOf(scope.editScheme.rules, scope.rule);
                _new ? scope.editScheme.rules.splice(-1, 1) :
                    scope.editScheme.rules[index] = _origRule;
                scope.rule = null;
                _new = false;
            };
            /**
             * @ngdoc function
             * @name sdIngestRoutingContent#confirm
             * @param {String} context Type of confirmation modal
             * @description Generate confirmation modal
             * @returns {Boolean} modal Based on context
             */
            function confirm(context) {
                return context === 'scheme' ?
                    modal.confirm(utils_1.gettext('Are you sure you want to delete this scheme?')) :
                    modal.confirm(utils_1.gettext('Are you sure you want to delete this scheme rule?'));
            }
            /**
             * @ngdoc function
             * @name sdIngestRoutingContent#initSchemes
             * @description Function for initialization default routing schemas
             */
            function initSchemes() {
                api('routing_schemes').query()
                    .then(function (result) {
                    scope.schemes = $filter('sortByName')(result._items);
                });
                contentFilters.getAllContentFilters(1, scope.contentFilters).then(function (filters) {
                    scope.contentFilters = filters;
                });
            }
        },
    };
}
exports.IngestRoutingContent = IngestRoutingContent;


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
IngestRoutingGeneral.$inject = ['weekdays', 'desks', 'macros'];
function IngestRoutingGeneral(weekdays, desks, macros) {
    return {
        scope: {
            rule: '=',
        },
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-routing-general.html',
        link: function (scope) {
            scope.dayLookup = weekdays;
            scope.macroLookup = {};
            desks.initialize()
                .then(function () {
                scope.deskLookup = desks.deskLookup;
                scope.stageLookup = desks.stageLookup;
            });
            macros.get().then(function (_macros) {
                lodash_1.default.transform(_macros, function (lookup, macro, idx) {
                    scope.macroLookup[macro.name] = macro;
                });
            });
        },
    };
}
exports.IngestRoutingGeneral = IngestRoutingGeneral;


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
IngestRoutingAction.$inject = ['desks', 'macros', 'subscribersService', 'metadata'];
function IngestRoutingAction(desks, macros, subscribersService, metadata) {
    return {
        scope: { rule: '=' },
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-routing-action.html',
        link: function (scope) {
            scope.newFetch = {};
            scope.newPublish = {};
            scope.deskLookup = {};
            scope.stageLookup = {};
            scope.macroLookup = {};
            scope.customSubscribers = [];
            scope.target_types = [];
            desks.initialize()
                .then(function () {
                scope.deskLookup = desks.deskLookup;
                scope.stageLookup = desks.stageLookup;
            });
            macros.get(true).then(function (_macros) {
                lodash_1.default.transform(_macros, function (lookup, macro, idx) {
                    scope.macroLookup[macro.name] = macro;
                });
            });
            subscribersService.fetchActiveSubscribers().then(function (items) {
                scope.customSubscribers = [];
                lodash_1.default.each(items, function (item) {
                    scope.customSubscribers.push({ _id: item._id, name: item.name });
                });
            });
            metadata.initialize()
                .then(function () {
                scope.target_types = metadata.values.subscriberTypes;
            });
            scope.getActionString = function (action) {
                if (scope.deskLookup[action.desk] && scope.stageLookup[action.stage]) {
                    var actionValues = [];
                    actionValues.push(scope.deskLookup[action.desk].name);
                    actionValues.push(scope.stageLookup[action.stage].name);
                    if (action.macro) {
                        actionValues.push(scope.macroLookup[action.macro].label ||
                            scope.macroLookup[action.macro].name);
                    }
                    else {
                        actionValues.push(' - ');
                    }
                    if (action.target_subscribers && action.target_subscribers.length > 0) {
                        actionValues.push(lodash_1.default.map(action.target_subscribers, 'name').join(','));
                    }
                    else {
                        actionValues.push(' - ');
                    }
                    if (action.target_types && action.target_types.length > 0) {
                        var targets = [];
                        lodash_1.default.forEach(action.target_types, function (targetType) {
                            targets.push((!targetType.allow ? utils_1.gettext('Not ') : '') + targetType.name);
                        });
                        actionValues.push(targets.join(','));
                    }
                    return actionValues.join(' / ');
                }
            };
            scope.addFetch = function () {
                if (scope.newFetch.desk && scope.newFetch.stage) {
                    scope.rule.actions.fetch.push(scope.newFetch);
                    scope.newFetch = {};
                }
            };
            scope.removeFetch = function (fetchAction) {
                lodash_1.default.remove(scope.rule.actions.fetch, function (f) { return f === fetchAction; });
            };
            scope.addPublish = function () {
                if (scope.newPublish.desk && scope.newPublish.stage) {
                    scope.rule.actions.publish.push(scope.newPublish);
                    scope.newPublish = {};
                    scope.newPublish.target_subscribers = [];
                    scope.newPublish.target_types = [];
                }
            };
            scope.removePublish = function (publishAction) {
                lodash_1.default.remove(scope.rule.actions.publish, function (p) { return p === publishAction; });
            };
        },
    };
}
exports.IngestRoutingAction = IngestRoutingAction;


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestRoutingSchedule
 * @description
 *   Creates the Schedule section (tab) of the routing rule edit form.
 */
IngestRoutingSchedule.$inject = ['tzdata'];
function IngestRoutingSchedule(tzdata) {
    return {
        scope: {
            rule: '=',
        },
        templateUrl: 'scripts/apps/ingest/views/settings/ingest-routing-schedule.html',
        link: function (scope) {
            scope.$watch('rule.schedule._allDay', function (newVal) {
                if (newVal) {
                    scope.rule.schedule.hour_of_day_from = null;
                    scope.rule.schedule.hour_of_day_to = null;
                }
                else {
                    if (!scope.rule.schedule.hour_of_day_from) {
                        scope.rule.schedule.hour_of_day_from = '00:00:00';
                    }
                    if (!scope.rule.schedule.hour_of_day_to) {
                        scope.rule.schedule.hour_of_day_to = '23:59:00';
                    }
                }
            });
        },
    };
}
exports.IngestRoutingSchedule = IngestRoutingSchedule;


/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestRoutingFilter
 * @description
 *   Creates the Filter tab used for defining a content filter for routing
 *   rules (found in the modal for editing ingest routing schemes).
 */
IngestRoutingFilter.$inject = [];
function IngestRoutingFilter() {
    /**
     * Creates an utility method on the built-in RegExp object used for
     * escaping arbitrary strings so that they can be safely used in
     * dynamically created regular expressions patterns.
     *
     * The idea is to find all characters in the given string that have a
     * special meaning in regex definition, and replace them with their
     * escaped versions. For example:
     *     '^' becomes '\\^', '*' becomes '\\*', etc.
     *
     * Usage example (creating a new regex pattern):
     *
     *     var regex = new RegExp(RegExp.escape(unsafeString));
     *
     * Taken from http://stackoverflow.com/a/3561711/5040035
     *
     * @method escape
     * @param {string} s - the string to escape
     * @return {string} - an escaped version of the given string
     */
    // XXX: should probably be moved into some utils module - but where?
    RegExp['escape'] = function (s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    return {
        scope: {
            rule: '=',
            filters: '=contentFilters',
        },
        templateUrl: 'scripts/apps/ingest/views/settings' +
            '/ingest-routing-filter.html',
        link: function (scope) {
            var currFilter;
            function init() {
                scope.matchingFilters = []; // used for filter search
                scope.filterSearchTerm = null;
                currFilter = lodash_1.default.find(scope.filters, { _id: scope.rule.filter });
                if (currFilter) {
                    scope.selectedFilter = currFilter;
                }
                else {
                    scope.selectedFilter = null;
                }
            }
            scope.$watch('rule', init);
            /**
             * Finds a subset of all content filters whose names contain
             * the given search term. The search is case-insensitive.
             * As a result, the matchingFilters list is updated.
             *
             * @method searchFilters
             * @param {string} term - the string to search for
             */
            scope.searchFilters = function (term) {
                var regex = new RegExp(RegExp['escape'](term), 'i');
                scope.matchingFilters = lodash_1.default.filter(scope.filters, function (filter) { return regex.test(filter.name); });
            };
            /**
             * Sets the given filter as the content filter for the routing
             * rule.
             *
             * @method selectFilter
             * @param {Object} filter - the content filter to select
             */
            scope.selectFilter = function (filter) {
                scope.selectedFilter = filter;
                scope.rule.filter = filter._id;
                scope.rule.filterName = filter.name;
                scope.filterSearchTerm = null;
            };
            /**
             * Clears the routing rule's content filter.
             *
             * @method clearSelectedFilter
             */
            scope.clearSelectedFilter = function () {
                scope.selectedFilter = null;
                scope.rule.filter = null;
                scope.rule.filterName = null;
            };
        },
    };
}
exports.IngestRoutingFilter = IngestRoutingFilter;


/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SortRules() {
    return {
        link: function (scope, element) {
            element.sortable({
                items: 'li',
                connectWith: '.rule-list',
                cursor: 'move',
                start: function (event, ui) {
                    ui.item.data('start', ui.item.index());
                },
                stop: function (event, ui) {
                    var start = ui.item.data('start'), end = ui.item.index();
                    scope.reorder(start, end);
                    scope.$apply();
                },
            });
        },
    };
}
exports.SortRules = SortRules;


/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
IngestUserDashboard.$inject = ['api', 'userList', 'privileges', 'config', 'moment'];
function IngestUserDashboard(api, userList, privileges, config, moment) {
    return {
        templateUrl: 'scripts/apps/ingest/views/dashboard/ingest-dashboard-widget.html',
        scope: {
            item: '=',
            setUserPreferences: '&',
        },
        link: function (scope) {
            function getCount() {
                var criteria = {
                    source: {
                        query: {
                            filtered: {
                                filter: {
                                    and: [
                                        { term: { ingest_provider: scope.item._id } },
                                        { range: { versioncreated: { gte: 'now-24h' } } },
                                    ],
                                },
                            },
                        },
                        size: 0,
                        from: 0,
                    },
                };
                api.ingest.query(criteria).then(function (result) {
                    scope.ingested_count = result._meta.total;
                });
            }
            function updateProvider() {
                api.ingestProviders.getById(scope.item._id).then(function (result) {
                    angular.extend(scope.item, result);
                    getUser();
                }, function (error) {
                    if (error.status === 404) {
                        scope.item.dashboard_enabled = false;
                        scope.setUserPreferences();
                    }
                });
            }
            function getLogMessages() {
                var criteria = {
                    max_results: 5,
                    sort: '[(\'_created\',-1)]',
                    embedded: { user: 1 },
                };
                var where = [
                    { resource: 'ingest_providers' },
                    { 'data.provider_id': scope.item._id },
                ];
                if (scope.item.log_messages === 'error') {
                    where.push({ name: 'error' });
                }
                criteria.where = JSON.stringify({
                    $and: where,
                });
                api.query('activity', criteria).then(function (result) {
                    scope.log_messages = result._items;
                });
            }
            function refreshItem(data) {
                if (data.provider_id === scope.item._id) {
                    getCount();
                    updateProvider();
                    getLogMessages();
                }
            }
            function getUser() {
                if (scope.item.is_closed && scope.item.last_closed && scope.item.last_closed.closed_by) {
                    userList.getUser(scope.item.last_closed.closed_by).then(function (result) {
                        scope.item.last_closed.display_name = result.display_name;
                    });
                }
                else if (!scope.item.is_closed && scope.item.last_opened && scope.item.last_opened.opened_by) {
                    userList.getUser(scope.item.last_opened.opened_by).then(function (result) {
                        scope.item.last_opened.display_name = result.display_name;
                    });
                }
            }
            function init() {
                scope.showIngest = Boolean(privileges.privileges.ingest_providers);
                scope.ingested_count = 0;
                getCount();
                getUser();
                getLogMessages();
            }
            init();
            scope.isIdle = function () {
                if (scope.item.last_item_update && !scope.item.is_closed) {
                    var idleTime = scope.item.idle_time || config.ingest.DEFAULT_IDLE_TIME;
                    var lastItemUpdate = moment(scope.item.last_item_update);
                    if (idleTime && !angular.equals(idleTime, config.ingest.DEFAULT_IDLE_TIME)) {
                        lastItemUpdate.add(idleTime.hours, 'h').add(idleTime.minutes, 'm');
                        if (moment() > lastItemUpdate) {
                            return true;
                        }
                        return false;
                    }
                }
                return false;
            };
            scope.filterLogMessages = function () {
                scope.setUserPreferences();
                getLogMessages();
            };
            scope.$on('ingest:update', function (evt, extras) {
                refreshItem(extras);
            });
            scope.$on('ingest_provider:update', function (evt, extras) {
                refreshItem(extras);
            });
        },
    };
}
exports.IngestUserDashboard = IngestUserDashboard;


/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
IngestUserDashboardList.$inject = [];
function IngestUserDashboardList() {
    return {
        templateUrl: 'scripts/apps/ingest/views/dashboard/ingest-dashboard-widget-list.html',
        scope: {
            items: '=',
            setUserPreferences: '&',
        },
    };
}
exports.IngestUserDashboardList = IngestUserDashboardList;


/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
IngestUserDashboardDropdown.$inject = ['privileges'];
function IngestUserDashboardDropdown(privileges) {
    return {
        templateUrl: 'scripts/apps/ingest/views/dashboard/ingest-sources-list.html',
        scope: {
            items: '=',
            setUserPreferences: '&',
        },
        link: function (scope) {
            scope.showIngest = Boolean(privileges.privileges.ingest_providers);
        },
    };
}
exports.IngestUserDashboardDropdown = IngestUserDashboardDropdown;


/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestProviderConfig
 *
 * @description Renders the config fields.
 */
function IngestProviderConfig() {
    return {
        template: __webpack_require__(2010),
    };
}
exports.IngestProviderConfig = IngestProviderConfig;


/***/ }),
/* 2010 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form__row form__row--s-padding\" ng-repeat=\"field in currentFeedingService.fields track by field.id\">\n    <div class=\"sd-line-input\" ng-if=\"field.type === 'text'\" ng-show=\"isConfigFieldVisible(field)\">\n        <label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label>\n        <input class=\"sd-line-input__input\" type=\"{{field.type}}\" id=\"{{getConfigFieldId(field.id)}}\" placeholder=\"{{:: field.placeholder | translate}}\"\n            ng-model=\"provider.config[field.id]\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\" ng-change=\"$parent.setConfig(provider)\"\n            ng-show=\"isConfigFieldVisible(field)\">\n        <div sd-ingest-config-errors></div>\n    </div>\n\n    <div class=\"sd-line-input\" ng-if=\"field.type === 'password'\" ng-show=\"isConfigFieldVisible(field)\">\n        <label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label>\n        <input class=\"sd-line-input__input\" type=\"password\" id=\"{{getConfigFieldId(field.id)}}\" placeholder=\"{{:: field.placeholder | translate}}\"\n            ng-model=\"provider.config[field.id]\" ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\" ng-change=\"$parent.setConfig(provider)\"\n            ng-show=\"isConfigFieldVisible(field)\" autocomplete=\"new-password\">\n        <div sd-ingest-config-errors></div>\n    </div>\n\n    <div class=\"form__row\" ng-if=\"field.type === 'boolean'\" ng-show=\"isConfigFieldVisible(field)\">\n        <span sd-switch id=\"{{getConfigFieldId(field.id)}}\" ng-model=\"provider.config[field.id]\"\n        ng-required=\"isConfigFieldRequired(field)\" ng-readonly=\"field.readonly === true\"></span>\n        <label for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label>\n        <div sd-ingest-config-errors></div>\n    </div>\n\n    <div class=\"sd-line-input sd-line-input--is-select\" ng-if=\"field.type === 'choices'\" ng-show=\"isConfigFieldVisible(field)\">\n        <label class=\"sd-line-input__label\" for=\"{{getConfigFieldId(field.id)}}\">{{field.label | translate}}</label>\n        <select id=\"{{getConfigFieldId(field.id)}}\"\n                class=\"sd-line-input__select\"\n                ng-required=\"isConfigFieldRequired(field)\"\n                ng-readonly=\"field.readonly === true\"\n                ng-options=\"r[0] as r[1] for r in field.choices\"\n                ng-model=\"provider.config[field.id]\">\n        </select>\n    </div>\n\n    <fieldset class=\"separated rss-config\" ng-if=\"field.type === 'mapping'\">\n      <legend translate>{{field.label | translate}}</legend>\n\n      <div class=\"sd-alert sd-alert--hollow sd-alert--small sd-alert--no-margin\" ng-show=\"provider.config[field.id].length == 0\" ng-hide=\"fieldAliases[field.id].length > 0\">\n        {{:: field.empty_label|translate }}\n      </div>\n\n      <div class=\"form__row form__row--flex form__row--s-padding\" ng-show=\"fieldAliases[field.id].length > 0\">\n        <div class=\"sd-line-input sd-line-input--no-margin\" style=\"max-width: 276px;\">\n          <label class=\"sd-line-input__label\">{{ field.first_field_options.label|translate}}</label>\n        </div>\n        <div class=\"sd-line-input sd-line-input--no-margin\">\n            <label class=\"sd-line-input__label\">{{ field.second_field_options.label|translate}}</label>\n        </div>\n      </div>\n\n      <div class=\"form__row form__row--flex form__row--s-padding\" ng-repeat=\"item in fieldAliases[field.id]\">\n        <div class=\"sd-line-input sd-line-input--is-select sd-line-input--boxed sd-line-input--no-margin sd-line-input--no-label\">\n          <select class=\"sd-line-input__select\"\n                  ng-options=\"fieldName for fieldName in (availableFieldOptions(field.id, item.fieldName) | orderBy)\"\n                  ng-model=\"item.fieldName\"\n                  ng-change=\"fieldSelectionChanged(field)\">\n          </select>\n        </div>\n        <div class=\"sd-line-input sd-line-input--boxed sd-line-input--no-margin  sd-line-input--no-label\">\n            <input class=\"sd-line-input__input\" type=\"text\"\n                  placeholder=\"{{:: field.second_field_options.placeholder|translate }}\"\n                  ng-model=\"item.alias\">\n        </div>\n        <button style=\"margin-left: 8px;\"\n            type=\"button\"\n            class=\"icn-btn\"\n            ng-click=\"removeFieldAlias(field.id, $index)\"\n            tooltip=\"{{:: field.remove_mapping_label|translate}}\"\n            tooltip-placement=\"bottom\"\n            tooltip-popup-delay=\"500\">\n          <i class=\"icon-trash\"></i>\n        </button>\n      </div>\n\n      <div class=\"form__row form__row--inner\" ng-show=\"!fieldAliases[field.id] || fieldAliases[field.id].length < field.first_field_options.values.length\" style=\"text-align: right;\">\n        <button\n            type=\"button\"\n            class=\"btn btn--primary btn--hollow\"\n            ng-click=\"addFieldAlias(field.id)\">\n          <i class=\"icon-plus-sign\"></i> {{:: field.add_mapping_label|translate}}\n        </button>\n      </div>\n\n    </fieldset>\n</div>\n";

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc directive
 * @module superdesk.apps.ingest
 * @name sdIngestConfigErrors
 *
 * @description Renders the errors related to the ingest provider configuration.
 */
function IngestConfigErrors() {
    return {
        template: __webpack_require__(2012),
    };
}
exports.IngestConfigErrors = IngestConfigErrors;


/***/ }),
/* 2012 */
/***/ (function(module, exports) {

module.exports = "<div ng-repeat=\"(errorCode, errorMessage) in field.errors\">\n    <div class=\"error\" ng-show=\"error.code == errorCode\" translate>{{errorMessage|translate}}</div>\n</div>\n";

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
function InsertFilter() {
    return function (input, location, addition) {
        if (addition === void 0) { addition = ''; }
        var loc = location || input.length;
        return input.substr(0, loc) + addition + input.substr(loc);
    };
}
exports.InsertFilter = InsertFilter;
function ScheduleFilter() {
    return function (input) {
        var schedule = '';
        if (lodash_1.default.isPlainObject(input)) {
            schedule += input.minutes && input.minutes > 0 ?
                input.minutes + (input.minutes > 1 ? ' minutes' : ' minute') : '';
            schedule += schedule.length > 0 ? ' ' : '';
            schedule += input.seconds && input.seconds > 0 ?
                input.seconds + (input.seconds > 1 ? ' seconds' : ' second') : '';
        }
        return schedule;
    };
}
exports.ScheduleFilter = ScheduleFilter;


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This file is part of Superdesk.
 *
 * Copyright 2013, 2014 Sourcefabric z.u. and contributors.
 *
 * For the full copyright and license information, please see the
 * AUTHORS and LICENSE files distributed with this source code, or
 * at https://www.sourcefabric.org/superdesk/license
 */
var constants_1 = __webpack_require__(2015);
var service_1 = __importDefault(__webpack_require__(2016));
var directive_1 = __importDefault(__webpack_require__(2017));
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
SearchProviderSettingsController.$inject = ['$scope', 'privileges'];
function SearchProviderSettingsController($scope, privileges) { }
/**
 * @ngdoc module
 * @module superdesk.apps.searchProviders
 * @name superdesk.apps.searchProviders
 * @packageName superdesk.apps
 * @description Adds support for various search providers to Superesk.
 */
exports.default = angular.module('superdesk.apps.searchProviders', [
    'superdesk.core.activity',
    'superdesk.core.api',
])
    .value('providerTypes', constants_1.providerTypes)
    .directive('sdSearchProviderConfig', directive_1.default)
    .service('searchProviderService', service_1.default)
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/settings/searchProviders', {
            label: utils_1.gettext('Search Providers'),
            templateUrl: 'scripts/apps/search-providers/views/settings.html',
            controller: SearchProviderSettingsController,
            category: superdesk.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_CONFIG,
            privileges: { search_providers: 1 },
            priority: 2000,
        });
    }])
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('search_providers', {
            type: 'http',
            backend: { rel: 'search_providers' },
        });
    }]);


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.providerTypes = {
    aapmm: 'AAP Multimedia',
    paimg: 'PA Images',
    // quick fix to have several scanpix instance (needed for SDNTB-237)
    // FIXME: temporary fix, need to be refactored (SD-4448)
    'scanpix(ntbtema)': 'ScanPix (ntbtema)',
    'scanpix(ntbkultur)': 'ScanPix (ntbkultur)',
    'scanpix(desk)': 'ScanPix (desk)',
    'scanpix(npk)': 'ScanPix (npk)',
};


/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function SearchProviderService($filter, api) {
    var _this = this;
    this.getAllowedProviderTypes = function () { return api.get('search_providers_allowed')
        .then(function (allowedTypes) { return allowedTypes._items; }); };
    this.getProviderLabels = function (_providerTypes) {
        var providerLabels = {};
        _providerTypes.forEach(function (type) {
            providerLabels[type.search_provider] = type.label;
        });
        return providerLabels;
    };
    this.getSearchProviders = function (criteria) { return api.query('search_providers', criteria)
        .then(function (result) { return $filter('sortByName')(result._items, 'search_provider'); }); };
    this.getActiveSearchProviders = function () { return _this.getSearchProviders({ where: { is_closed: { $ne: true } } }); };
}
exports.default = SearchProviderService;
SearchProviderService.$inject = ['$filter', 'api'];


/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
function SearchProviderConfigDirective(searchProviderService, notify, api, modal) {
    return {
        templateUrl: 'scripts/apps/search-providers/views/search-provider-config.html',
        link: function ($scope) {
            $scope.provider = null;
            $scope.origProvider = null;
            $scope.providers = null;
            $scope.newDestination = null;
            searchProviderService.getAllowedProviderTypes().then(function (providerTypes) {
                $scope.providerTypes = providerTypes;
                $scope.noProvidersAllowed = !$scope.providerTypes.length;
                $scope.providerLabels = searchProviderService.getProviderLabels(providerTypes);
                $scope.providerTypesOptions = providerTypes.map(function (t) { return ({ label: t.label, value: t.search_provider }); });
            });
            /**
             * Fetches all search providers from backend
             */
            function fetchSearchProviders() {
                searchProviderService.getSearchProviders().then(function (result) {
                    $scope.providers = result;
                });
            }
            /**
             * Upserts the selected search provider.
             */
            $scope.save = function () {
                api.search_providers.save($scope.origProvider, $scope.provider)
                    .then(function () {
                    notify.success(utils_1.gettext('Search Provider saved.'));
                    $scope.cancel();
                }, function (response) {
                    if (angular.isDefined(response.data._issues)) {
                        if (angular.isDefined(response.data._issues['validator exception'])) {
                            notify.error(utils_1.gettext('Error: ' + response.data._issues['validator exception']));
                        }
                        else if (angular.isDefined(response.data._issues.search_provider) &&
                            angular.isDefined(response.data._issues.search_provider.unique)) {
                            notify.error(utils_1.gettext('Error: A Search Provider with type ' +
                                $scope.providerTypes[$scope.provider.search_provider] + ' already exists.'));
                        }
                    }
                    else {
                        notify.error(utils_1.gettext('Error: Failed to save Search Provider.'));
                    }
                })
                    .then(fetchSearchProviders);
            };
            /**
             * Either initializes a new provider object for adding a new provider or initializes the provider object
             * with the selected provider allowing user to update the provider details.
             */
            $scope.edit = function (provider) {
                $scope.origProvider = provider || {};
                $scope.provider = lodash_1.default.create($scope.origProvider);
                $scope.provider.config = lodash_1.default.create($scope.origProvider.config || {});
            };
            /**
             * Removes the selected search provider.
             */
            $scope.remove = function (provider) {
                modal.confirm(utils_1.gettext('Are you sure you want to delete Search Provider?')).then(function removeSearchProvider() {
                    api.search_providers.remove(provider)
                        .then(function () {
                        notify.success(utils_1.gettext('Search Provider deleted.'));
                    }, function (response) {
                        if (angular.isDefined(response.data._message)) {
                            notify.error(response.data._message);
                        }
                        else {
                            notify.error(utils_1.gettext('Error: Unable to delete Search Provider.'));
                        }
                    })
                        .then(fetchSearchProviders);
                });
            };
            /**
             * Reverts any changes made to the provider
             */
            $scope.cancel = function () {
                $scope.origProvider = null;
                $scope.provider = null;
            };
            fetchSearchProviders();
        },
    };
}
exports.default = SearchProviderConfigDirective;
SearchProviderConfigDirective.$inject = ['searchProviderService', 'notify', 'api', 'modal'];


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var superdesk_ui_framework_1 = __webpack_require__(59);
var activity_1 = __webpack_require__(36);
var utils_1 = __webpack_require__(3);
var InternalDestinations_1 = __webpack_require__(2019);
var styles = 'display: flex; height: calc(100% - 48px)';
angular.module('superdesk.apps.internal-destinations', [])
    .component('sdInternalDestinations', superdesk_ui_framework_1.reactToAngular1(InternalDestinations_1.InternalDestinations, [], [], styles))
    .config(['superdeskProvider', function (superdeskProvider) {
        superdeskProvider
            .activity('/settings/internal-destinations', {
            label: utils_1.gettext('Internal Destinations'),
            template: __webpack_require__(2054),
            controllerAs: 'dest',
            category: superdeskProvider.MENU_SETTINGS,
            settings_menu_group: activity_1.coreMenuGroups.CONTENT_FLOW,
            privileges: { publish: 1 },
        });
    }]);


/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var generic_list_page_1 = __webpack_require__(2020);
var form_1 = __webpack_require__(74);
var ListItem_1 = __webpack_require__(576);
var form_field_1 = __webpack_require__(250);
var InternalDestinationsPageComponent = generic_list_page_1.getGenericListPageComponent('internal_destinations');
var nameField = {
    label: gettext('Destination name'),
    type: form_1.FormFieldType.textSingleLine,
    field: 'name',
    required: true,
};
var isActiveField = {
    label: gettext('Active'),
    type: form_1.FormFieldType.checkbox,
    field: 'is_active',
};
var contentFilterField = {
    label: gettext('Content filter'),
    type: form_1.FormFieldType.contentFilterSingleValue,
    field: 'filter',
};
var deskField = {
    label: gettext('Desk'),
    type: form_1.FormFieldType.deskSingleValue,
    field: 'desk',
    required: true,
};
var stageField = {
    label: gettext('Stage'),
    type: form_1.FormFieldType.stageSingleValue,
    field: 'stage',
    component_parameters: {
        deskField: 'desk',
    },
};
var macroField = {
    label: gettext('Macro'),
    type: form_1.FormFieldType.macroSingleValue,
    field: 'macro',
    component_parameters: {
        deskField: 'desk',
    },
};
var formConfig = {
    direction: 'vertical',
    type: 'inline',
    form: [
        isActiveField,
        nameField,
        contentFilterField,
        deskField,
        stageField,
        macroField,
    ],
};
var renderRow = function (key, item, page) { return (react_1.default.createElement(ListItem_1.ListItem, { key: key, onClick: function () { return page.openPreview(item._id); }, inactive: !item.is_active, "data-test-id": "internal-destinations-item" },
    react_1.default.createElement(ListItem_1.ListItemColumn, { ellipsisAndGrow: true, noBorder: true }, form_field_1.getFormFieldPreviewComponent(item, nameField)),
    item.is_active ? null : (react_1.default.createElement(ListItem_1.ListItemColumn, { noBorder: true },
        react_1.default.createElement("span", { className: "label label--hollow label--alert" }, gettext('Inactive')))),
    react_1.default.createElement(ListItem_1.ListItemActionsMenu, null,
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement("button", { onClick: function (event) {
                    event.stopPropagation();
                    page.startEditing(item._id);
                }, className: "icn-btn", title: gettext('Edit'), "data-test-id": "edit" },
                react_1.default.createElement("i", { className: "icon-pencil" })),
            react_1.default.createElement("button", { onClick: function (event) {
                    event.stopPropagation(); // prevents preview from opening
                    page.deleteItem(item);
                }, className: "icn-btn", title: gettext('Remove'), "data-test-id": "delete" },
                react_1.default.createElement("i", { className: "icon-trash" })))))); };
var InternalDestinations = /** @class */ (function (_super) {
    __extends(InternalDestinations, _super);
    function InternalDestinations() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InternalDestinations.prototype.render = function () {
        return (react_1.default.createElement(InternalDestinationsPageComponent, { renderRow: renderRow, formConfig: formConfig }));
    };
    return InternalDestinations;
}(react_1.default.Component));
exports.InternalDestinations = InternalDestinations;


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var lodash_1 = __webpack_require__(2);
var react_paginate_1 = __importDefault(__webpack_require__(2021));
var ListItem_1 = __webpack_require__(576);
var PageLayout_1 = __webpack_require__(2025);
var generic_list_page_item_view_edit_1 = __webpack_require__(2026);
var SidePanel_1 = __webpack_require__(577);
var components_1 = __webpack_require__(23);
var Nav_1 = __webpack_require__(491);
var SortBar_1 = __webpack_require__(2040);
var CrudManager_1 = __webpack_require__(2041);
var TagLabel_1 = __webpack_require__(2049);
var ReactRenderAsync_1 = __webpack_require__(54);
var get_form_group_for_filtering_1 = __webpack_require__(2050);
var form_field_1 = __webpack_require__(250);
var from_group_1 = __webpack_require__(578);
var get_initial_values_1 = __webpack_require__(2051);
var generate_filter_for_server_1 = __webpack_require__(2052);
var get_form_fields_flat_1 = __webpack_require__(2053);
var GenericListPageComponent = /** @class */ (function (_super) {
    __extends(GenericListPageComponent, _super);
    function GenericListPageComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            preview: {
                itemId: null,
                editMode: false,
            },
            newItem: {
                item: null,
                editMode: true,
            },
            filtersOpen: false,
            filterValues: {},
            searchValue: '',
            loading: true,
        };
        _this.openPreview = _this.openPreview.bind(_this);
        _this.closePreview = _this.closePreview.bind(_this);
        _this.setFiltersVisibility = _this.setFiltersVisibility.bind(_this);
        _this.handleFilterFieldChange = _this.handleFilterFieldChange.bind(_this);
        _this.openNewItemForm = _this.openNewItemForm.bind(_this);
        _this.closeNewItemForm = _this.closeNewItemForm.bind(_this);
        _this.deleteItem = _this.deleteItem.bind(_this);
        _this.removeFilter = _this.removeFilter.bind(_this);
        return _this;
    }
    GenericListPageComponent.prototype.openPreview = function (id) {
        if (this.state.preview.editMode === true) {
            this.props.modal.alert({
                headerText: gettext('Warning'),
                bodyText: gettext('Can\'t open a preview, because another item is in edit mode.'),
            });
        }
        else {
            this.setState({
                preview: {
                    itemId: id,
                    editMode: false,
                },
            });
        }
    };
    GenericListPageComponent.prototype.removeFilter = function (fieldName) {
        var _this = this;
        this.setState(function (prevState) { return (__assign({}, prevState, { filterValues: lodash_1.omit(prevState.filterValues, fieldName) })); }, function () {
            _this.props.items.removeFilter(fieldName);
        });
    };
    GenericListPageComponent.prototype.deleteItem = function (item) {
        var _this = this;
        var deleteNow = function () { return _this.props.items.delete(item); };
        this.props.modal.confirm(gettext('Are you sure you want to delete this item?'))
            .then(function () {
            if (_this.state.preview.editMode) {
                _this.props.modal.alert({
                    headerText: gettext('Warning'),
                    bodyText: gettext('The item in edit mode must be closed before you can delete.'),
                });
            }
            else if (_this.state.preview.itemId != null) {
                _this.setState({
                    preview: { itemId: null, editMode: false },
                }, deleteNow);
            }
            else {
                deleteNow();
            }
        });
    };
    GenericListPageComponent.prototype.startEditing = function (id) {
        if (this.state.preview.editMode === true) {
            this.props.modal.alert({
                headerText: gettext('Warning'),
                bodyText: gettext('Can\'t edit this item, because another item is in edit mode.'),
            });
        }
        else {
            this.setState({
                preview: {
                    itemId: id,
                    editMode: true,
                },
            });
        }
    };
    GenericListPageComponent.prototype.closePreview = function () {
        this.setState({
            preview: {
                itemId: null,
                editMode: false,
            },
        });
    };
    GenericListPageComponent.prototype.handleFilterFieldChange = function (field, nextValue, callback) {
        if (callback === void 0) { callback = lodash_1.noop; }
        this.setState(function (prevState) {
            var _a;
            return ({
                filterValues: __assign({}, prevState.filterValues, (_a = {}, _a[field] = nextValue, _a)),
            });
        }, callback);
    };
    GenericListPageComponent.prototype.executeFilters = function () {
        var _this = this;
        var execute = function () {
            var filterValues = _this.state.filterValues;
            var formConfigForFilters = get_form_group_for_filtering_1.getFormGroupForFiltering(_this.props.formConfig);
            var fieldTypesLookup = get_form_fields_flat_1.getFormFieldsFlat(formConfigForFilters)
                .reduce(function (accumulator, item) {
                var _a;
                return (__assign({}, accumulator, (_a = {}, _a[item.field] = item.type, _a)));
            }, {});
            var filtersValidated = Object.keys(filterValues).reduce(function (accumulator, key) {
                var value = filterValues[key];
                if (typeof value === 'string') {
                    var trimmedValue = value.trim();
                    if (trimmedValue.length > 0) {
                        accumulator[key] = trimmedValue;
                        return accumulator;
                    }
                    else {
                        return accumulator;
                    }
                }
                else {
                    if (value !== undefined) {
                        accumulator[key] = value;
                    }
                    return accumulator;
                }
            }, {});
            _this.props.items.read(1, _this.props.items.activeSortOption, filtersValidated, function (filters) {
                var filtersFormatted = {};
                for (var fieldName in filters) {
                    filtersFormatted[fieldName] = generate_filter_for_server_1.generateFilterForServer(fieldTypesLookup[fieldName], filters[fieldName]);
                }
                return filtersFormatted;
            });
        };
        if (this.state.preview.editMode) {
            this.props.modal.alert({
                headerText: gettext('Warning'),
                bodyText: gettext('The item in edit mode must be closed before you can filter.'),
            });
        }
        else if (this.state.preview.itemId != null) {
            this.setState({
                preview: { itemId: null, editMode: false },
            }, execute);
        }
        else {
            execute();
        }
    };
    GenericListPageComponent.prototype.closeNewItemForm = function () {
        this.setState({ newItem: { item: null, editMode: false } });
    };
    GenericListPageComponent.prototype.setFiltersVisibility = function (nextValue) {
        this.setState({ filtersOpen: nextValue });
    };
    GenericListPageComponent.prototype.openNewItemForm = function () {
        if (this.state.preview.editMode === true) {
            this.props.modal.alert({
                headerText: gettext('Warning'),
                bodyText: gettext('Can\'t add a new item, because another item is in edit mode.'),
            });
        }
        else {
            this.setState({
                newItem: {
                    item: __assign({}, get_initial_values_1.getInitialValues(this.props.formConfig), this.props.newItemTemplate == null ? {} : this.props.newItemTemplate),
                    editMode: true,
                },
                preview: {
                    itemId: null,
                    editMode: false,
                },
            });
        }
    };
    GenericListPageComponent.prototype.componentDidMount = function () {
        this.props.items.read(1);
    };
    GenericListPageComponent.prototype.render = function () {
        var _this = this;
        if (this.props.items._items == null) {
            // loading
            return null;
        }
        var activeFilters = this.props.items.activeFilters;
        var totalResults = this.props.items._meta.total;
        var pageSize = this.props.items._meta.max_results;
        var pageCount = Math.ceil(totalResults / pageSize);
        var _a = this.props, formConfig = _a.formConfig, renderRow = _a.renderRow;
        var formConfigForFilters = get_form_group_for_filtering_1.getFormGroupForFiltering(formConfig);
        var fieldsList = form_field_1.getFormFieldsRecursive(formConfig.form);
        var sortOptions = fieldsList.map(function (_a) {
            var label = _a.label, field = _a.field;
            return ({ label: label, field: field });
        }).concat([
            {
                label: gettext('Last updated'),
                field: '_updated',
            },
            {
                label: gettext('First created'),
                field: '_created',
            },
        ]);
        var getContents = function () {
            if (_this.props.items._items.length === 0) {
                if (Object.keys(activeFilters).length > 0) {
                    return (react_1.default.createElement(ListItem_1.ListItem, { noHover: true },
                        react_1.default.createElement(ListItem_1.ListItemColumn, null, gettext('There are no items matching the search.'))));
                }
                else {
                    return (react_1.default.createElement(ListItem_1.ListItem, { noHover: true },
                        react_1.default.createElement(ListItem_1.ListItemColumn, null, gettext('There are no items yet.'))));
                }
            }
            else {
                return (react_1.default.createElement("div", { "data-test-id": "list-page--items" }, _this.props.items._items.map(function (item) { return renderRow(item._id, item, _this); })));
            }
        };
        return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', width: '100%' } },
            react_1.default.createElement("div", { className: "subnav" },
                react_1.default.createElement(Nav_1.Button, { icon: "icon-filter-large", onClick: function () { return _this.setFiltersVisibility(!_this.state.filtersOpen); }, active: this.state.filtersOpen, darker: true, "data-test-id": "toggle-filters" }),
                react_1.default.createElement(components_1.SearchBar, { value: this.state.searchValue, allowCollapsed: false, onSearch: function (value) {
                        _this.handleFilterFieldChange('name', value, _this.executeFilters);
                    } }),
                react_1.default.createElement(SortBar_1.SortBar, { sortOptions: sortOptions, selected: this.props.items.activeSortOption, itemsCount: this.props.items._meta.total, onSortOptionChange: this.props.items.sort }),
                react_1.default.createElement(Nav_1.Button, { onClick: this.openNewItemForm, className: "sd-create-btn dropdown-toggle", icon: "icon-plus-large", "data-test-id": "list-page--add-item" },
                    react_1.default.createElement("span", { className: "circle" }))),
            react_1.default.createElement(PageLayout_1.PageContainer, null,
                this.state.filtersOpen ? (react_1.default.createElement(PageLayout_1.PageContainerItem, { "data-test-id": "list-page--filters-form" },
                    react_1.default.createElement(SidePanel_1.SidePanel, { side: "left", width: 240 },
                        react_1.default.createElement(SidePanel_1.SidePanelHeader, null,
                            react_1.default.createElement(SidePanel_1.SidePanelHeading, null, gettext('Refine search')),
                            react_1.default.createElement(SidePanel_1.SidePanelTools, null,
                                react_1.default.createElement("button", { className: "icn-btn", onClick: function () { return _this.setFiltersVisibility(false); } },
                                    react_1.default.createElement("i", { className: "icon-close-small" })))),
                        react_1.default.createElement(SidePanel_1.SidePanelContent, null,
                            react_1.default.createElement(SidePanel_1.SidePanelContentBlock, null,
                                react_1.default.createElement("form", { onSubmit: function (event) {
                                        event.preventDefault();
                                        _this.executeFilters();
                                    } },
                                    react_1.default.createElement(from_group_1.FormViewEdit, { item: this.state.filterValues, formConfig: formConfigForFilters, editMode: true, issues: {}, handleFieldChange: this.handleFilterFieldChange }),
                                    react_1.default.createElement("button", { className: "btn btn--primary btn--expanded", type: "submit", "data-test-id": "filters-submit" }, gettext('Filter')))))))) : null,
                react_1.default.createElement(PageLayout_1.PageContainerItem, { shrink: true },
                    react_1.default.createElement("div", { style: { margin: 20 } },
                        this.props.items._items.length === 0 ? null : (react_1.default.createElement("div", { style: { textAlign: 'center', marginTop: -20 } },
                            react_1.default.createElement(react_paginate_1.default, { previousLabel: gettext('prev'), nextLabel: gettext('next'), pageCount: pageCount, marginPagesDisplayed: 2, pageRangeDisplayed: 5, onPageChange: function (_a) {
                                    var selected = _a.selected;
                                    _this.props.items.goToPage(selected + 1);
                                }, initialPage: this.props.items._meta.page - 1, containerClassName: 'bs-pagination', activeClassName: "active" }))),
                        Object.keys(activeFilters).length < 1 ? null : (react_1.default.createElement("div", { className: "subnav", style: { background: 'transparent', boxShadow: 'none', marginTop: -20 }, "data-test-id": "list-page--filters-active" }, Object.keys(activeFilters).map(function (fieldName, i) {
                            var filterValuePreview = form_field_1.getFormFieldPreviewComponent(_this.props.items.activeFilters, get_form_fields_flat_1.getFormFieldsFlat(formConfigForFilters).find(function (_a) {
                                var field = _a.field;
                                return field === fieldName;
                            }));
                            return (react_1.default.createElement(TagLabel_1.TagLabel, { key: i, onRemove: function () {
                                    _this.removeFilter(fieldName);
                                } },
                                fieldName,
                                ":",
                                ' ',
                                react_1.default.createElement("strong", null, filterValuePreview)));
                        }))),
                        getContents())),
                this.state.preview.itemId != null ? (react_1.default.createElement(PageLayout_1.PageContainerItem, { "data-test-id": "list-page--view-edit" },
                    react_1.default.createElement(generic_list_page_item_view_edit_1.GenericListPageItemViewEdit, { editMode: this.state.preview.editMode, onEditModeChange: function (nextValue) {
                            _this.setState(function (prevState) { return (__assign({}, prevState, { preview: __assign({}, prevState.preview, { editMode: nextValue }) })); });
                        }, operation: "editing", formConfig: formConfig, item: this.props.items._items.find(function (_a) {
                            var _id = _a._id;
                            return _id === _this.state.preview.itemId;
                        }), onSave: function (nextItem) { return _this.props.items.update(nextItem); }, onClose: this.closePreview }))) : null,
                this.state.newItem.item != null ? (react_1.default.createElement(PageLayout_1.PageContainerItem, { "data-test-id": "list-page--new-item" },
                    react_1.default.createElement(generic_list_page_item_view_edit_1.GenericListPageItemViewEdit, { operation: "creation", formConfig: formConfig, editMode: this.state.newItem.editMode, onEditModeChange: function (nextValue) {
                            _this.setState(function (prevState) { return (__assign({}, prevState, { item: __assign({}, prevState.newItem, { editMode: nextValue }) })); });
                        }, item: this.state.newItem.item, onSave: function (item) { return _this.props.items.create(item).then(function (res) {
                            _this.closeNewItemForm();
                            _this.openPreview(res._id);
                        }); }, onClose: this.closeNewItemForm, onCancel: this.closeNewItemForm }))) : null)));
    };
    return GenericListPageComponent;
}(react_1.default.Component));
exports.GenericListPageComponent = GenericListPageComponent;
exports.getGenericListPageComponent = function (resource) {
    return ReactRenderAsync_1.connectServices(CrudManager_1.connectCrudManager(GenericListPageComponent, 'items', resource), ['modal']);
};


/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaginationBoxView = __webpack_require__(2022);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PageView = __webpack_require__(2023);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(2024);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));

    _this.handlePreviousPage = function (evt) {
      var selected = _this.state.selected;

      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (selected > 0) {
        _this.handlePageSelected(selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      var selected = _this.state.selected;
      var pageCount = _this.props.pageCount;


      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (selected < pageCount - 1) {
        _this.handlePageSelected(selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.handleBreakClick = function (index, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      var selected = _this.state.selected;


      _this.handlePageSelected(selected < index ? _this.getForwardJump() : _this.getBackwardJump(), evt);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== 'undefined' && typeof _this.props.onPageChange === 'function') {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = [];
      var _this$props = _this.props,
          pageRangeDisplayed = _this$props.pageRangeDisplayed,
          pageCount = _this$props.pageCount,
          marginPagesDisplayed = _this$props.marginPagesDisplayed,
          breakLabel = _this$props.breakLabel,
          breakClassName = _this$props.breakClassName,
          breakLinkClassName = _this$props.breakLinkClassName;
      var selected = _this.state.selected;


      if (pageCount <= pageRangeDisplayed) {
        for (var index = 0; index < pageCount; index++) {
          items.push(_this.getPageElement(index));
        }
      } else {
        var leftSide = pageRangeDisplayed / 2;
        var rightSide = pageRangeDisplayed - leftSide;

        // If the selected page index is on the default right side of the pagination,
        // we consider that the new right side is made up of it (= only one break element).
        // If the selected page index is on the default left side of the pagination,
        // we consider that the new left side is made up of it (= only one break element).
        if (selected > pageCount - pageRangeDisplayed / 2) {
          rightSide = pageCount - selected;
          leftSide = pageRangeDisplayed - rightSide;
        } else if (selected < pageRangeDisplayed / 2) {
          leftSide = selected;
          rightSide = pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;
        var createPageView = function createPageView(index) {
          return _this.getPageElement(index);
        };

        for (_index = 0; _index < pageCount; _index++) {
          page = _index + 1;

          // If the page index is lower than the margin defined,
          // the page has to be displayed on the left side of
          // the pagination.
          if (page <= marginPagesDisplayed) {
            items.push(createPageView(_index));
            continue;
          }

          // If the page index is greater than the page count
          // minus the margin defined, the page has to be
          // displayed on the right side of the pagination.
          if (page > pageCount - marginPagesDisplayed) {
            items.push(createPageView(_index));
            continue;
          }

          // If the page index is near the selected page index
          // and inside the defined range (pageRangeDisplayed)
          // we have to display it (it will create the center
          // part of the pagination).
          if (_index >= selected - leftSide && _index <= selected + rightSide) {
            items.push(createPageView(_index));
            continue;
          }

          // If the page index doesn't meet any of the conditions above,
          // we check if the last item of the current "items" array
          // is a break element. If not, we add a break element, else,
          // we do nothing (because we don't want to display the page).
          if (breakLabel && items[items.length - 1] !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              key: _index,
              breakLabel: breakLabel,
              breakClassName: breakClassName,
              breakLinkClassName: breakLinkClassName,
              onClick: _this.handleBreakClick.bind(null, _index)
            });
            items.push(breakView);
          }
        }
      }

      return items;
    };

    var initialSelected = void 0;
    if (props.initialPage) {
      initialSelected = props.initialPage;
    } else if (props.forcePage) {
      initialSelected = props.forcePage;
    } else {
      initialSelected = 0;
    }

    _this.state = {
      selected: initialSelected
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          initialPage = _props.initialPage,
          disableInitialCallback = _props.disableInitialCallback,
          extraAriaContext = _props.extraAriaContext;
      // Call the callback with the initialPage item:

      if (typeof initialPage !== 'undefined' && !disableInitialCallback) {
        this.callCallback(initialPage);
      }

      if (extraAriaContext) {
        console.warn('DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead.');
      }
    }
  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'getForwardJump',
    value: function getForwardJump() {
      var selected = this.state.selected;
      var _props2 = this.props,
          pageCount = _props2.pageCount,
          pageRangeDisplayed = _props2.pageRangeDisplayed;


      var forwardJump = selected + pageRangeDisplayed;
      return forwardJump >= pageCount ? pageCount - 1 : forwardJump;
    }
  }, {
    key: 'getBackwardJump',
    value: function getBackwardJump() {
      var selected = this.state.selected;
      var pageRangeDisplayed = this.props.pageRangeDisplayed;


      var backwardJump = selected - pageRangeDisplayed;
      return backwardJump < 0 ? 0 : backwardJump;
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      var _props3 = this.props,
          hrefBuilder = _props3.hrefBuilder,
          pageCount = _props3.pageCount;

      if (hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < pageCount) {
        return hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'ariaLabelBuilder',
    value: function ariaLabelBuilder(pageIndex) {
      var selected = pageIndex === this.state.selected;
      if (this.props.ariaLabelBuilder && pageIndex >= 0 && pageIndex < this.props.pageCount) {
        var label = this.props.ariaLabelBuilder(pageIndex + 1, selected);
        // DEPRECATED: The extraAriaContext prop was used to add additional context
        // to the aria-label. Users should now use the ariaLabelBuilder instead.
        if (this.props.extraAriaContext && !selected) {
          label = label + ' ' + this.props.extraAriaContext;
        }
        return label;
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      var selected = this.state.selected;
      var _props4 = this.props,
          pageClassName = _props4.pageClassName,
          pageLinkClassName = _props4.pageLinkClassName,
          activeClassName = _props4.activeClassName,
          activeLinkClassName = _props4.activeLinkClassName,
          extraAriaContext = _props4.extraAriaContext;


      return _react2.default.createElement(_PageView2.default, {
        key: index,
        onClick: this.handlePageSelected.bind(null, index),
        selected: selected === index,
        pageClassName: pageClassName,
        pageLinkClassName: pageLinkClassName,
        activeClassName: activeClassName,
        activeLinkClassName: activeLinkClassName,
        extraAriaContext: extraAriaContext,
        href: this.hrefBuilder(index),
        ariaLabel: this.ariaLabelBuilder(index),
        page: index + 1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          disabledClassName = _props5.disabledClassName,
          previousClassName = _props5.previousClassName,
          nextClassName = _props5.nextClassName,
          pageCount = _props5.pageCount,
          containerClassName = _props5.containerClassName,
          previousLinkClassName = _props5.previousLinkClassName,
          previousLabel = _props5.previousLabel,
          nextLinkClassName = _props5.nextLinkClassName,
          nextLabel = _props5.nextLabel;
      var selected = this.state.selected;


      var previousClasses = previousClassName + (selected === 0 ? ' ' + disabledClassName : '');
      var nextClasses = nextClassName + (selected === pageCount - 1 ? ' ' + disabledClassName : '');

      var previousAriaDisabled = selected === 0 ? 'true' : 'false';
      var nextAriaDisabled = selected === pageCount - 1 ? 'true' : 'false';

      return _react2.default.createElement(
        'ul',
        { className: containerClassName },
        _react2.default.createElement(
          'li',
          { className: previousClasses },
          _react2.default.createElement(
            'a',
            {
              onClick: this.handlePreviousPage,
              className: previousLinkClassName,
              href: this.hrefBuilder(selected - 1),
              tabIndex: '0',
              role: 'button',
              onKeyPress: this.handlePreviousPage,
              'aria-disabled': previousAriaDisabled
            },
            previousLabel
          )
        ),
        this.pagination(),
        _react2.default.createElement(
          'li',
          { className: nextClasses },
          _react2.default.createElement(
            'a',
            {
              onClick: this.handleNextPage,
              className: nextLinkClassName,
              href: this.hrefBuilder(selected + 1),
              tabIndex: '0',
              role: 'button',
              onKeyPress: this.handleNextPage,
              'aria-disabled': nextAriaDisabled
            },
            nextLabel
          )
        )
      );
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _propTypes2.default.number.isRequired,
  pageRangeDisplayed: _propTypes2.default.number.isRequired,
  marginPagesDisplayed: _propTypes2.default.number.isRequired,
  previousLabel: _propTypes2.default.node,
  nextLabel: _propTypes2.default.node,
  breakLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  hrefBuilder: _propTypes2.default.func,
  onPageChange: _propTypes2.default.func,
  initialPage: _propTypes2.default.number,
  forcePage: _propTypes2.default.number,
  disableInitialCallback: _propTypes2.default.bool,
  containerClassName: _propTypes2.default.string,
  pageClassName: _propTypes2.default.string,
  pageLinkClassName: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  activeLinkClassName: _propTypes2.default.string,
  previousClassName: _propTypes2.default.string,
  nextClassName: _propTypes2.default.string,
  previousLinkClassName: _propTypes2.default.string,
  nextLinkClassName: _propTypes2.default.string,
  disabledClassName: _propTypes2.default.string,
  breakClassName: _propTypes2.default.string,
  breakLinkClassName: _propTypes2.default.string,
  extraAriaContext: _propTypes2.default.string,
  ariaLabelBuilder: _propTypes2.default.func
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: 'selected',
  previousClassName: 'previous',
  nextClassName: 'next',
  previousLabel: 'Previous',
  nextLabel: 'Next',
  breakLabel: '...',
  disabledClassName: 'disabled',
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageView = function PageView(props) {
  var pageClassName = props.pageClassName;
  var pageLinkClassName = props.pageLinkClassName;

  var onClick = props.onClick;
  var href = props.href;
  var ariaLabel = props.ariaLabel || 'Page ' + props.page + (props.extraAriaContext ? ' ' + props.extraAriaContext : '');
  var ariaCurrent = null;

  if (props.selected) {
    ariaCurrent = 'page';

    ariaLabel = props.ariaLabel || 'Page ' + props.page + ' is your current page';

    if (typeof pageClassName !== 'undefined') {
      pageClassName = pageClassName + ' ' + props.activeClassName;
    } else {
      pageClassName = props.activeClassName;
    }

    if (typeof pageLinkClassName !== 'undefined') {
      if (typeof props.activeLinkClassName !== 'undefined') {
        pageLinkClassName = pageLinkClassName + ' ' + props.activeLinkClassName;
      }
    } else {
      pageLinkClassName = props.activeLinkClassName;
    }
  }

  return _react2.default.createElement(
    'li',
    { className: pageClassName },
    _react2.default.createElement(
      'a',
      {
        onClick: onClick,
        role: 'button',
        className: pageLinkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick
      },
      props.page
    )
  );
};

PageView.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  selected: _propTypes2.default.bool.isRequired,
  pageClassName: _propTypes2.default.string,
  pageLinkClassName: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  activeLinkClassName: _propTypes2.default.string,
  extraAriaContext: _propTypes2.default.string,
  href: _propTypes2.default.string,
  ariaLabel: _propTypes2.default.string,
  page: _propTypes2.default.number.isRequired
};

exports.default = PageView;
//# sourceMappingURL=PageView.js.map

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreakView = function BreakView(props) {
  var breakLabel = props.breakLabel,
      breakClassName = props.breakClassName,
      breakLinkClassName = props.breakLinkClassName,
      onClick = props.onClick;

  var className = breakClassName || 'break';

  return _react2.default.createElement(
    'li',
    { className: className },
    _react2.default.createElement(
      'a',
      {
        className: breakLinkClassName,
        onClick: onClick,
        role: 'button',
        tabIndex: '0',
        onKeyPress: onClick
      },
      breakLabel
    )
  );
};

BreakView.propTypes = {
  breakLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  breakClassName: _propTypes2.default.string,
  breakLinkClassName: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

exports.default = BreakView;
//# sourceMappingURL=BreakView.js.map

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-multi-comp */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var PageContainer = /** @class */ (function (_super) {
    __extends(PageContainer, _super);
    function PageContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageContainer.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "sd-column-box--3" }, this.props.children));
    };
    return PageContainer;
}(react_1.default.Component));
exports.PageContainer = PageContainer;
var PageContainerItem = /** @class */ (function (_super) {
    __extends(PageContainerItem, _super);
    function PageContainerItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageContainerItem.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.props.shrink ? 'sd-column-box__main-column' : null, "data-test-id": this.props['data-test-id'] }, this.props.children));
    };
    return PageContainerItem;
}(react_1.default.Component));
exports.PageContainerItem = PageContainerItem;


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable max-depth */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var SidePanel_1 = __webpack_require__(577);
var ReactRenderAsync_1 = __webpack_require__(54);
var from_group_1 = __webpack_require__(578);
var GenericListPageItemViewEditComponent = /** @class */ (function (_super) {
    __extends(GenericListPageItemViewEditComponent, _super);
    function GenericListPageItemViewEditComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            nextItem: _this.props.item,
            issues: {},
        };
        _this.enableEditMode = _this.enableEditMode.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.handleFieldChange = _this.handleFieldChange.bind(_this);
        _this.isFormDirty = _this.isFormDirty.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        return _this;
    }
    GenericListPageItemViewEditComponent.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.editMode === false) {
            // enable changing which item is previewed
            this.setState({
                nextItem: nextProps.item,
            });
        }
    };
    GenericListPageItemViewEditComponent.prototype.componentDidMount = function () {
        this._mounted = true;
    };
    GenericListPageItemViewEditComponent.prototype.componentWillUnmount = function () {
        this._mounted = false;
    };
    GenericListPageItemViewEditComponent.prototype.enableEditMode = function () {
        var _this = this;
        this.setState({
            nextItem: this.props.item,
        }, function () {
            _this.props.onEditModeChange(true);
        });
    };
    GenericListPageItemViewEditComponent.prototype.handleFieldChange = function (field, nextValue) {
        // using updater function to avoid race conditions
        this.setState(function (prevState) {
            var _a;
            return (__assign({}, prevState, { nextItem: __assign({}, prevState.nextItem, (_a = {}, _a[field] = nextValue, _a)) }));
        });
    };
    GenericListPageItemViewEditComponent.prototype.handleCancel = function () {
        var _this = this;
        var cancelFn = typeof this.props.onCancel === 'function'
            ? this.props.onCancel
            : function () {
                _this.setState({
                    nextItem: _this.props.item,
                }, function () {
                    _this.props.onEditModeChange(false);
                });
            };
        (this.isFormDirty() === false
            ? Promise.resolve()
            : this.props.modal.confirm(gettext('There are unsaved changes which will be discarded. Continue?'))).then(cancelFn)
            .catch(function () {
            // do nothing
        });
    };
    GenericListPageItemViewEditComponent.prototype.isFormDirty = function () {
        return JSON.stringify(this.props.item) !== JSON.stringify(this.state.nextItem);
    };
    GenericListPageItemViewEditComponent.prototype.handleSave = function () {
        var _this = this;
        this.props.onSave(this.state.nextItem).then(function () {
            if (_this._mounted === true) {
                _this.props.onEditModeChange(false);
            }
        })
            .catch(function (res) {
            var issues = {};
            for (var fieldName in res.data._issues) {
                var issuesForField = [];
                if (typeof res.data._issues[fieldName] === 'string') {
                    issuesForField.push(res.data._issues[fieldName]);
                }
                else {
                    for (var key in res.data._issues[fieldName]) {
                        if (key === 'required') {
                            issuesForField.push(gettext('Field is required'));
                        }
                        else {
                            issuesForField.push(gettext('Uknown validation error'));
                        }
                    }
                }
                issues[fieldName] = issuesForField;
            }
            _this.setState({
                issues: issues,
            });
        });
    };
    GenericListPageItemViewEditComponent.prototype.render = function () {
        return (react_1.default.createElement(SidePanel_1.SidePanel, { side: "right", width: 360, "data-test-id": "item-view-edit" },
            react_1.default.createElement(SidePanel_1.SidePanelHeader, null,
                react_1.default.createElement(SidePanel_1.SidePanelHeading, null, gettext('Details:')),
                this.props.editMode
                    ? (react_1.default.createElement("div", { className: "side-panel__sliding-toolbar side-panel__sliding-toolbar--right" },
                        react_1.default.createElement("button", { className: "btn", onClick: this.handleCancel, "data-test-id": "item-view-edit--cancel-save" }, gettext('Cancel')),
                        react_1.default.createElement("button", { disabled: !this.isFormDirty(), onClick: this.handleSave, className: "btn btn--primary", "data-test-id": "item-view-edit--save" }, gettext('Save'))))
                    : (react_1.default.createElement(SidePanel_1.SidePanelTools, null,
                        react_1.default.createElement("div", null,
                            this.props.operation === 'editing' ? (react_1.default.createElement("button", { onClick: this.enableEditMode, className: "icn-btn" },
                                react_1.default.createElement("i", { className: "icon-pencil" }))) : null,
                            react_1.default.createElement("button", { className: "icn-btn", onClick: this.props.onClose },
                                react_1.default.createElement("i", { className: "icon-close-small" })))))),
            react_1.default.createElement(SidePanel_1.SidePanelContent, null,
                react_1.default.createElement(SidePanel_1.SidePanelContentBlock, null,
                    react_1.default.createElement(from_group_1.FormViewEdit, { item: this.state.nextItem, formConfig: this.props.formConfig, editMode: this.props.editMode, issues: this.state.issues, handleFieldChange: this.handleFieldChange })))));
    };
    return GenericListPageItemViewEditComponent;
}(react_1.default.Component));
exports.GenericListPageItemViewEdit = ReactRenderAsync_1.connectServices(GenericListPageItemViewEditComponent, ['modal']);


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var TextSingleLine = /** @class */ (function (_super) {
    __extends(TextSingleLine, _super);
    function TextSingleLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextSingleLine.prototype.render = function () {
        var _this = this;
        if (this.props.previewOutput) {
            return react_1.default.createElement("div", { "data-test-id": "gform-output--" + this.props.formField.field }, this.props.value);
        }
        // default value is required so React doesn't complain that uncontrolled component is changed to controlled.
        var valueWithDefaultValue = this.props.value || '';
        return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
                'sd-line-input--invalid': this.props.issues.length > 0,
                'sd-line-input--required': this.props.formField.required === true,
            }) },
            react_1.default.createElement("label", { className: "sd-line-input__label" }, this.props.formField.label),
            react_1.default.createElement("input", { type: "text", disabled: this.props.disabled, value: valueWithDefaultValue, onChange: function (event) { return _this.props.onChange(event.target.value); }, className: "sd-line-input__input", "data-test-id": "gform-input--" + this.props.formField.field }),
            this.props.issues.map(function (str, i) { return (react_1.default.createElement("div", { key: i, className: "sd-line-input__message" }, str)); })));
    };
    return TextSingleLine;
}(react_1.default.Component));
exports.TextSingleLine = TextSingleLine;


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var select_single_value_1 = __webpack_require__(105);
var ng_1 = __importDefault(__webpack_require__(18));
exports.VocabularySingleValue = select_single_value_1.getSelectSingleValue(function (props) { return ng_1.default.getService('vocabularies')
    .then(function (vocabularies) { return vocabularies.getVocabulary(props.formField.component_parameters.vocabulary_id); })
    .then(function (vocabulary) { return vocabulary.items.map(function (_a) {
    var qcode = _a.qcode, name = _a.name;
    return ({ id: qcode, label: name });
}); }); });


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var draft_js_1 = __webpack_require__(16);
var react_2 = __webpack_require__(529);
var UserHtmlSingleLine_1 = __webpack_require__(2030);
var from_html_1 = __webpack_require__(124);
var editor3StateToHtml_1 = __webpack_require__(88);
function getRawDraftContentStateFromString(input) {
    return typeof input === 'string' && input.trim().length > 0
        ? draft_js_1.convertToRaw(from_html_1.getContentStateFromHtml(input))
        : draft_js_1.convertToRaw(draft_js_1.ContentState.createFromText(''));
}
var TextEditor3 = /** @class */ (function (_super) {
    __extends(TextEditor3, _super);
    function TextEditor3(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            rawDraftContentState: getRawDraftContentStateFromString(_this.props.value),
        };
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    TextEditor3.prototype.handleChange = function (rawDraftContentState) {
        this.setState({ rawDraftContentState: rawDraftContentState });
        this.props.onChange(editor3StateToHtml_1.editor3StateToHtml(draft_js_1.convertFromRaw(rawDraftContentState)));
    };
    TextEditor3.prototype.componentDidUpdate = function () {
        if (this.props.value !== editor3StateToHtml_1.editor3StateToHtml(draft_js_1.convertFromRaw(this.state.rawDraftContentState))) {
            // This component holds it's own state which is derived from props
            // internal state is reloaded when it doesn't match with what's in the props
            // holding own state is required to prevent infinite loops which would happen because
            // draftjs keys change every time content state is created from HTML
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ rawDraftContentState: getRawDraftContentStateFromString(this.props.value) });
        }
    };
    TextEditor3.prototype.render = function () {
        if (this.props.previewOutput) {
            return react_1.default.createElement(UserHtmlSingleLine_1.UserHtmlSingleLine, { html: this.props.value });
        }
        return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
                'sd-line-input--invalid': this.props.issues.length > 0,
                'sd-line-input--required': this.props.formField.required === true,
            }) },
            react_1.default.createElement("label", { className: "sd-line-input__label" }, this.props.formField.label),
            react_1.default.createElement(react_2.Editor3Standalone, { scrollContainer: 'window', onChange: this.handleChange, editorFormat: ['bold', 'italic', 'underline', 'link'], rawDraftContentState: this.state.rawDraftContentState, disableSpellchecker: true, readOnly: this.props.disabled }),
            this.props.issues.map(function (str, i) { return (react_1.default.createElement("div", { key: i, className: "sd-line-input__message" }, str)); })));
    };
    return TextEditor3;
}(react_1.default.Component));
exports.TextEditor3 = TextEditor3;


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
// is imported from fidelity repo
var UserHtmlSingleLine = /** @class */ (function (_super) {
    __extends(UserHtmlSingleLine, _super);
    function UserHtmlSingleLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserHtmlSingleLine.prototype.render = function () {
        return react_1.default.createElement("span", { className: "user-html-in-single-line", dangerouslySetInnerHTML: { __html: this.props.html } });
    };
    return UserHtmlSingleLine;
}(react_1.default.Component));
exports.UserHtmlSingleLine = UserHtmlSingleLine;


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var classnames_1 = __importDefault(__webpack_require__(4));
var Form_1 = __webpack_require__(30);
var CheckboxInput = /** @class */ (function (_super) {
    __extends(CheckboxInput, _super);
    function CheckboxInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxInput.prototype.render = function () {
        var _this = this;
        if (this.props.previewOutput) {
            return react_1.default.createElement("div", null, this.props.value ? gettext('Yes') : gettext('No'));
        }
        return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
                'sd-line-input--invalid': this.props.issues.length > 0,
                'sd-line-input--required': this.props.formField.required === true,
            }) },
            react_1.default.createElement(Form_1.Checkbox, { value: this.props.value, label: this.props.formField.label, onChange: function (field, value) {
                    _this.props.onChange(value === true);
                }, readOnly: this.props.disabled }),
            this.props.issues.map(function (str, i) { return (react_1.default.createElement("div", { key: i, className: "sd-line-input__message" }, str)); })));
    };
    return CheckboxInput;
}(react_1.default.Component));
exports.CheckboxInput = CheckboxInput;


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var select_single_value_1 = __webpack_require__(105);
var ng_1 = __importDefault(__webpack_require__(18));
exports.ContentFilterSingleValue = select_single_value_1.getSelectSingleValue(function () {
    return ng_1.default.getService('api')
        .then(function (api) { return api('content_filters').query({ max_results: 200 }); })
        .then(function (contentFilters) {
        return contentFilters._items.map(function (_a) {
            var _id = _a._id, name = _a.name;
            return ({ id: _id, label: name });
        });
    });
});


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
var select_single_value_1 = __webpack_require__(105);
exports.DeskSingleValue = select_single_value_1.getSelectSingleValue(function () {
    return ng_1.default.getService('api')
        .then(function (api) { return api('desks').query({ max_results: 200 }); })
        .then(function (contentFilters) {
        return contentFilters._items.map(function (_a) {
            var _id = _a._id, name = _a.name;
            return ({ id: _id, label: name });
        });
    });
});


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
var select_single_value_1 = __webpack_require__(105);
exports.StageSingleValue = select_single_value_1.getSelectSingleValue(function (props) {
    return ng_1.default.getService('api')
        .then(function (api) {
        var deskId = props.formValues[props.formField.component_parameters['deskField']];
        if (deskId == null) {
            return Promise.resolve(null);
        }
        else {
            return api('stages').query({
                where: { desk: deskId },
                max_results: 200,
            })
                .then(function (stages) {
                return stages._items.map(function (_a) {
                    var _id = _a._id, name = _a.name;
                    return ({ id: _id, label: name });
                });
            });
        }
    });
}, utils_1.gettext('Select a desk first'), function (props) { return [props.formField.component_parameters['deskField']]; });


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ng_1 = __importDefault(__webpack_require__(18));
var utils_1 = __webpack_require__(3);
var select_single_value_1 = __webpack_require__(105);
exports.MacroSingleValue = select_single_value_1.getSelectSingleValue(function (props) {
    return ng_1.default.getService('api')
        .then(function (api) {
        var deskId = props.formValues[props.formField.component_parameters['deskField']];
        if (deskId == null) {
            return Promise.resolve(null);
        }
        else {
            return api('macros').query({
                where: { desk: deskId },
                max_results: 200,
            })
                .then(function (stages) {
                return stages._items.map(function (_a) {
                    var label = _a.label;
                    return ({ id: label, label: label });
                });
            });
        }
    });
}, utils_1.gettext('Select a desk first'), function (props) { return [props.formField.component_parameters['deskField']]; });


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
var select_single_value_1 = __webpack_require__(105);
exports.YesNo = select_single_value_1.getSelectSingleValue(function () { return Promise.resolve([
    { id: 'true', label: utils_1.gettext('Yes') },
    { id: 'false', label: utils_1.gettext('No') },
]); });


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var form_group_display_wrapper_1 = __webpack_require__(2038);
var form_direction_wrapper_1 = __webpack_require__(2039);
var FormGroupWrapper = /** @class */ (function (_super) {
    __extends(FormGroupWrapper, _super);
    function FormGroupWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupWrapper.prototype.render = function () {
        return (react_1.default.createElement(form_group_display_wrapper_1.FormGroupDisplayWrapper, { group: this.props.group },
            react_1.default.createElement(form_direction_wrapper_1.FormGroupDirectionWrapper, { direction: this.props.group.direction }, this.props.children)));
    };
    return FormGroupWrapper;
}(react_1.default.Component));
exports.FormGroupWrapper = FormGroupWrapper;


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var lodash_1 = __webpack_require__(2);
var superdesk_ui_framework_1 = __webpack_require__(59);
var form_1 = __webpack_require__(74);
var typescript_helpers_1 = __webpack_require__(56);
// allows wrapping the form group into a custom display component, for example a toggle box
var FormGroupDisplayWrapper = /** @class */ (function (_super) {
    __extends(FormGroupDisplayWrapper, _super);
    function FormGroupDisplayWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupDisplayWrapper.prototype.render = function () {
        var group = this.props.group;
        if (group.type === 'inline') {
            return react_1.default.createElement("div", __assign({}, lodash_1.omit(this.props, ['group'])));
        }
        else if (form_1.isIFormGroupCollapsible(group.type)) {
            return (react_1.default.createElement(superdesk_ui_framework_1.ToggleBoxNext, { title: group.type.label, isOpen: group.type.openByDefault }, this.props.children));
        }
        else {
            typescript_helpers_1.assertNever(group.type);
        }
    };
    return FormGroupDisplayWrapper;
}(react_1.default.Component));
exports.FormGroupDisplayWrapper = FormGroupDisplayWrapper;


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var typescript_helpers_1 = __webpack_require__(56);
var lodash_1 = __webpack_require__(2);
var FormGroupDirectionWrapper = /** @class */ (function (_super) {
    __extends(FormGroupDirectionWrapper, _super);
    function FormGroupDirectionWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormGroupDirectionWrapper.prototype.render = function () {
        var direction = this.props.direction;
        if (direction === 'vertical') {
            return react_1.default.createElement("div", __assign({}, lodash_1.omit(this.props, ['direction'])));
        }
        else if (direction === 'horizontal') {
            var currentClassname = (this.props.className || '');
            var nextClassname = currentClassname.length > 0
                ? currentClassname + " form-group-horizontal"
                : 'form-group-horizontal';
            return react_1.default.createElement("div", { className: nextClassname });
        }
        else {
            typescript_helpers_1.assertNever(direction);
        }
    };
    return FormGroupDirectionWrapper;
}(react_1.default.Component));
exports.FormGroupDirectionWrapper = FormGroupDirectionWrapper;


/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var SortBar = /** @class */ (function (_super) {
    __extends(SortBar, _super);
    function SortBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SortBar.prototype.render = function () {
        var _this = this;
        var currentSortOption = this.props.sortOptions.find(function (option) { return option.field === _this.props.selected.field; });
        return (react_1.default.createElement("div", { className: "sortbar", "data-test-id": "sortbar" },
            react_1.default.createElement("span", null, gettext('Total:')),
            ' ',
            react_1.default.createElement("span", { className: "label-total" }, this.props.itemsCount),
            ' ',
            react_1.default.createElement("div", { className: "dropdown dropdown--hover" },
                react_1.default.createElement("button", { className: "dropdown__toggle", "data-test-id": "sortbar--selected" },
                    currentSortOption.label,
                    react_1.default.createElement("span", { className: "dropdown__caret" })),
                react_1.default.createElement("ul", { className: "dropdown__menu dropdown--align-right" }, this.props.sortOptions.map(function (option, i) { return (react_1.default.createElement("li", { key: i },
                    react_1.default.createElement("button", { onClick: function () { return _this.props.onSortOptionChange({
                            field: option.field,
                            direction: 'ascending',
                        }); }, "data-test-id": "sortbar--option" }, option.label))); }))),
            this.props.selected.direction === 'ascending'
                ? (react_1.default.createElement("button", { onClick: function () { return _this.props.onSortOptionChange(__assign({}, _this.props.selected, { direction: 'descending' })); }, className: "icn-btn direction", title: gettext('Ascending'), "data-test-id": "sortbar--sort-ascending" },
                    react_1.default.createElement("i", { className: "icon-ascending" })))
                : (react_1.default.createElement("button", { onClick: function () { return _this.props.onSortOptionChange(__assign({}, _this.props.selected, { direction: 'ascending' })); }, className: "icn-btn direction", title: gettext('Descending'), "data-test-id": "sortbar--sort-descending" },
                    react_1.default.createElement("i", { className: "icon-descending" })))));
    };
    return SortBar;
}(react_1.default.Component));
exports.SortBar = SortBar;


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/display-name */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var json_merge_patch_1 = __webpack_require__(2042);
var ReactRenderAsync_1 = __webpack_require__(54);
function connectCrudManager(WrappedComponent, name, endpoint) {
    var component = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.api = props.api(endpoint);
            _this.state = {
                _items: null,
                _meta: null,
                _links: null,
                activeSortOption: null,
                activeFilters: {},
            };
            _this.create = _this.create.bind(_this);
            _this.read = _this.read.bind(_this);
            _this.update = _this.update.bind(_this);
            _this.delete = _this.delete.bind(_this);
            _this.refresh = _this.refresh.bind(_this);
            _this.sort = _this.sort.bind(_this);
            _this.removeFilter = _this.removeFilter.bind(_this);
            _this.goToPage = _this.goToPage.bind(_this);
            return _this;
        }
        class_1.prototype.create = function (item) {
            var _this = this;
            // creating an item impacts sorting/filtering/pagination. Data is re-fetched to correct it.
            return this.api.save(item).then(function (res) { return _this.refresh().then(function () { return res; }); });
        };
        class_1.prototype.read = function (page, sortOption, filterValues, formatFiltersForServer) {
            var _this = this;
            if (sortOption === void 0) { sortOption = { field: 'name', direction: 'ascending' }; }
            if (filterValues === void 0) { filterValues = {}; }
            var query = {
                page: page,
            };
            if (sortOption != null) {
                query['sort'] = (sortOption.direction === 'descending' ? '-' : '') + sortOption.field;
            }
            if (Object.keys(filterValues).length > 0) {
                query['where'] = typeof formatFiltersForServer === 'function'
                    ? formatFiltersForServer(filterValues)
                    : filterValues;
            }
            return this.api.query(query)
                .then(function (res) { return new Promise(function (resolve) {
                _this.setState(__assign({}, res, { activeSortOption: sortOption, activeFilters: filterValues }), function () {
                    resolve(res);
                });
            }); });
        };
        class_1.prototype.update = function (nextItem) {
            var _this = this;
            var currentItem = this.state._items.find(function (_a) {
                var _id = _a._id;
                return _id === nextItem._id;
            });
            var patch = json_merge_patch_1.generate(currentItem, nextItem);
            // updating an item impacts sorting/filtering/pagination. Data is re-fetched to correct it.
            return this.api.save(currentItem, patch)
                .then(function (res) { return _this.refresh().then(function () { return res; }); });
        };
        class_1.prototype.delete = function (item) {
            var _this = this;
            // deleting an item impacts sorting/filtering/pagination. Data is re-fetched to correct it.
            return this.api.remove(item).then(function () { return _this.refresh().then(function () { return undefined; }); });
        };
        class_1.prototype.refresh = function () {
            return this.read(1, this.state.activeSortOption, this.state.activeFilters);
        };
        class_1.prototype.sort = function (sortOption) {
            return this.read(1, sortOption);
        };
        class_1.prototype.removeFilter = function (fieldName) {
            var nextFilters = __assign({}, this.state.activeFilters);
            delete nextFilters[fieldName];
            return this.read(1, this.state.activeSortOption, nextFilters);
        };
        class_1.prototype.goToPage = function (nextPage) {
            return this.read(nextPage, this.state.activeSortOption, this.state.activeFilters);
        };
        class_1.prototype.render = function () {
            var _a;
            // workaround for typescript bug
            // https://github.com/Microsoft/TypeScript/issues/28748#issuecomment-450497274
            var fixedProps = this.props;
            return (react_1.default.createElement(WrappedComponent, __assign({}, (_a = {},
                _a[name] = __assign({}, this.state, { create: this.create, read: this.read, update: this.update, delete: this.delete, sort: this.sort, removeFilter: this.removeFilter, goToPage: this.goToPage }),
                _a), fixedProps)));
        };
        return class_1;
    }(react_1.default.Component));
    return ReactRenderAsync_1.connectServices(component, ['api']);
}
exports.connectCrudManager = connectCrudManager;


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.apply = __webpack_require__(2043);
module.exports.generate = __webpack_require__(2044);
module.exports.merge = __webpack_require__(2048);


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function apply(target, patch) {
	if(patch === null || typeof patch !== 'object' || Array.isArray(patch)) {
		return patch;
	}
	if(target === null || typeof target !== 'object' || Array.isArray(target)) {
		target = {};
	}
	var keys = Object.keys(patch);
	for(var i=0; i<keys.length; i++) {
		var key = keys[i];
		if(patch[key] === null) {
			if(target.hasOwnProperty(key)) {
				delete target[key];
			}
		} else {
			target[key] = apply(target[key], patch[key]);
		}
	}
	return target;
};


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var equal = __webpack_require__(2045);

function arrayEquals(before, after) {
  if(before.length !== after.length) {
    return false;
  }
  for(var i=0; i<before.length; i++) {
    if(!equal(after[i], before[i])) {
      return false;
    }
  }
  return true;
}

module.exports = function generate(before, after) {
  if(before === null || after === null ||
    typeof before !== 'object' || typeof after !== 'object' ||
    Array.isArray(before) !== Array.isArray(after)) {
    return after;
  }

  if(Array.isArray(before)) {
    if(!arrayEquals(before, after)) {
      return after;
    }
    return undefined;
  }

  var patch = {};
  var beforeKeys = Object.keys(before);
  var afterKeys = Object.keys(after);

  var key, i;

  // new elements
  var newKeys = {};
  for(i=0; i < afterKeys.length; i++) {
    key = afterKeys[i];
    if(beforeKeys.indexOf(key) === -1) {
      newKeys[key] = true;
      patch[key] = after[key];
    }
  }

  // removed & modified elements
  var removedKeys = {};
  for(i=0; i < beforeKeys.length; i++) {
    key = beforeKeys[i];
    if(afterKeys.indexOf(key) === -1) {
      removedKeys[key] = true;
      patch[key] = null;
    } else {
      if(before[key] !== null && typeof before[key] === 'object') {
        var subPatch = generate(before[key], after[key]);
        if(subPatch !== undefined) {
          patch[key] = subPatch;
        }
      } else if(before[key] !== after[key]) {
        patch[key] = after[key];
      }
    }
  }

  return (Object.keys(patch).length > 0 ? patch : undefined);
};


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(2046);
var isArguments = __webpack_require__(2047);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 2046 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 2047 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function merge(patch1, patch2) {
  if(patch1 === null || patch2 === null ||
    typeof patch1 !== 'object' || typeof patch2 !== 'object' ||
    Array.isArray(patch1) !== Array.isArray(patch2)) {
    return patch2;
  }
  var patch = JSON.parse(JSON.stringify(patch1));

	Object.keys(patch2)
  .forEach(function(key) {
		if(patch1[key] !== undefined) {
  		patch[key] = merge(patch1[key], patch2[key]);
		} else {
			patch[key] = patch2[key];
		}
  });
	return patch;
};


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var TagLabel = /** @class */ (function (_super) {
    __extends(TagLabel, _super);
    function TagLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagLabel.prototype.render = function () {
        var classNames = ['tag-label'];
        var _a = this.props, type = _a.type, color = _a.color;
        if (type === 'square') {
            classNames.push('tag-label--square');
        }
        if (color === 'gray') {
            classNames.push('tag-label--darker');
        }
        else if (color === 'blue-lighter') {
            classNames.push('tag-label--highlight1');
        }
        else if (color === 'blue') {
            classNames.push('tag-label--highlight2');
        }
        return (react_1.default.createElement("div", { className: classNames.join(' '), "data-test-id": "tag-label" },
            this.props.children,
            typeof this.props.onRemove === 'function'
                ? (react_1.default.createElement("button", { onClick: this.props.onRemove, className: "tag-label__remove", "data-test-id": "tag-label--remove" },
                    react_1.default.createElement("i", { className: "icon-close-small" }))) : null));
    };
    return TagLabel;
}(react_1.default.Component));
exports.TagLabel = TagLabel;


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typescript_helpers_1 = __webpack_require__(56);
var form_1 = __webpack_require__(74);
// different components must be used for filtering than for entering/updating items
function getFieldTypeForFiltering(type) {
    switch (type) {
        case form_1.FormFieldType.textSingleLine:
            return form_1.FormFieldType.textSingleLine;
        case form_1.FormFieldType.textEditor3:
            // even though textEditor3 outputs HTML, plaintext has to be used for filtering
            return form_1.FormFieldType.textSingleLine;
        case form_1.FormFieldType.vocabularySingleValue:
            return form_1.FormFieldType.vocabularySingleValue;
        case form_1.FormFieldType.checkbox:
            return form_1.FormFieldType.yesNo;
        case form_1.FormFieldType.contentFilterSingleValue:
            return form_1.FormFieldType.contentFilterSingleValue;
        case form_1.FormFieldType.deskSingleValue:
            return form_1.FormFieldType.deskSingleValue;
        case form_1.FormFieldType.stageSingleValue:
            return form_1.FormFieldType.stageSingleValue;
        case form_1.FormFieldType.macroSingleValue:
            return form_1.FormFieldType.macroSingleValue;
        case form_1.FormFieldType.yesNo:
            return form_1.FormFieldType.yesNo;
        default:
            typescript_helpers_1.assertNever(type);
    }
}
function getFormForFiltering(form) {
    return form.map(function (item) {
        if (form_1.isIFormGroup(item)) {
            return getFormGroupForFiltering(item);
        }
        else if (form_1.isIFormField(item)) {
            return __assign({}, item, { type: getFieldTypeForFiltering(item.type), required: false });
        }
        else {
            return typescript_helpers_1.assertNever(item);
        }
    });
}
function getFormGroupForFiltering(group) {
    return __assign({}, group, { form: getFormForFiltering(group.form) });
}
exports.getFormGroupForFiltering = getFormGroupForFiltering;


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var typescript_helpers_1 = __webpack_require__(56);
var form_1 = __webpack_require__(74);
function getInitialValueForFieldType(fieldConfig) {
    var _a, _b, _c;
    var type = fieldConfig.type, field = fieldConfig.field;
    switch (type) {
        case form_1.FormFieldType.textSingleLine:
        case form_1.FormFieldType.textEditor3:
            return _a = {}, _a[field] = '', _a;
        case form_1.FormFieldType.vocabularySingleValue:
        case form_1.FormFieldType.contentFilterSingleValue:
        case form_1.FormFieldType.deskSingleValue:
        case form_1.FormFieldType.stageSingleValue:
        case form_1.FormFieldType.macroSingleValue:
        case form_1.FormFieldType.yesNo:
            return _b = {}, _b[field] = undefined, _b;
        case form_1.FormFieldType.checkbox:
            return _c = {}, _c[field] = false, _c;
        default:
            typescript_helpers_1.assertNever(type);
    }
}
function getInitialValuesForForm(form) {
    return form.map(function (item) {
        if (form_1.isIFormGroup(item)) {
            return getInitialValues(item);
        }
        else if (form_1.isIFormField(item)) {
            return getInitialValueForFieldType(item);
        }
        else {
            return typescript_helpers_1.assertNever(item);
        }
    })
        .reduce(function (accumulator, item) { return (__assign({}, accumulator, item)); }, {});
}
// Some fields need to be initialized automatically.
// For example `false` needs to be sent to the server by default in case of checkbox
// and not `undefined` which might be sent without initialization.
function getInitialValues(group) {
    return getInitialValuesForForm(group.form);
}
exports.getInitialValues = getInitialValues;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var typescript_helpers_1 = __webpack_require__(56);
var form_1 = __webpack_require__(74);
function generateFilterForServer(type, value) {
    switch (type) {
        case form_1.FormFieldType.textSingleLine:
            return {
                $regex: value,
                $options: 'i',
            };
        case form_1.FormFieldType.vocabularySingleValue:
        case form_1.FormFieldType.contentFilterSingleValue:
        case form_1.FormFieldType.checkbox:
        case form_1.FormFieldType.deskSingleValue:
        case form_1.FormFieldType.stageSingleValue:
        case form_1.FormFieldType.macroSingleValue:
            return value;
        case form_1.FormFieldType.textEditor3:
            throw new Error('Operation not supported. Plaintext input has to be used to filter this component\'s output');
        case form_1.FormFieldType.yesNo:
            if (value === 'true') {
                return true;
            }
            else if (value === 'false') {
                return false;
            }
            else {
                return undefined;
            }
        default:
            typescript_helpers_1.assertNever(type);
    }
}
exports.generateFilterForServer = generateFilterForServer;


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var typescript_helpers_1 = __webpack_require__(56);
var form_1 = __webpack_require__(74);
function getFormFieldsFromGroup(form) {
    var fields = [];
    form.forEach(function (item) {
        if (form_1.isIFormGroup(item)) {
            fields = fields.concat(getFormFieldsFlat(item));
        }
        else if (form_1.isIFormField(item)) {
            fields = fields.concat(item);
        }
        else {
            typescript_helpers_1.assertNever(item);
        }
    });
    return fields;
}
function getFormFieldsFlat(group) {
    return getFormFieldsFromGroup(group.form);
}
exports.getFormFieldsFlat = getFormFieldsFlat;


/***/ }),
/* 2054 */
/***/ (function(module, exports) {

module.exports = "<sd-settings-view>\n    <div class=\"sd-page__main-content\">\n        <div className=\"sd-page__content\" style=\"height: 100%; display: flex;flex-direction: column;\">\n            <div class=\"sd-page__header sd-page__header--white\">\n                <h2 class=\"sd-page__page-heading\" translate>Internal Destinations</h2>\n            </div>\n            <sd-internal-destinations style=\"display: contents\"></sd-internal-destinations>\n        </div>\n    </div>\n</sd-settings-view>\n";

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(2056);
var directives = __importStar(__webpack_require__(2058));
var services = __importStar(__webpack_require__(2064));
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.content_api
 * @name superdesk.apps.content_api
 * @packageName superdesk.apps
 * @description Superdesk Content API Application.
 */
angular.module('superdesk.apps.content-api', [
    'superdesk.core.api',
    'superdesk.apps.publish',
    'superdesk.apps.search',
])
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/content_api', {
            label: utils_1.gettext('Content API Search'),
            description: utils_1.gettext('Search items is content API'),
            priority: 100,
            category: superdesk.MENU_MAIN,
            adminTools: false,
            controller: controllers_1.ContentAPIController,
            templateUrl: 'scripts/apps/content-api/views/list.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            filters: [],
            reloadOnSearch: false,
            privileges: { search_capi: 1 },
        });
    }])
    .service('contentApiSearch', services.ContentAPISearchService)
    .directive('sdContentApiSearchPanel', directives.ContentAPISearchPanelDirective)
    .directive('sdContentApiSearchResults', directives.ContentAPISearchResultsDirective)
    .directive('sdContentApiSortBar', directives.ContentAPISortBarDirective)
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('search_capi', {
            type: 'http',
            backend: {
                rel: 'search_capi',
            },
        });
    }]);


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentAPIController_1 = __webpack_require__(2057);
exports.ContentAPIController = ContentAPIController_1.ContentAPIController;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.content-api
 * @name ContentAPIController
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires pageTitle
 * @requires preferencesService
 *
 * @description ContentAPIController
 */
var ContentAPIController = /** @class */ (function () {
    function ContentAPIController($scope, $location, pageTitle, preferencesService) {
        var _this = this;
        this.$scope = $scope;
        this.$location = $location;
        this.preferencesService = preferencesService;
        pageTitle.setUrl(utils_1.gettext('Content API Search'));
        this.$scope.flags = {
            hideActions: true,
        };
        this.$scope.selected = {
            preview: null,
        };
        this.$scope.setView = this.setView.bind(this);
        this.$scope.preview = this.preview.bind(this);
        this.preferencesUpdate = {
            'archive:view': {
                allowed: ['mgrid', 'compact'],
                category: 'archive',
                view: 'mgrid',
                default: 'mgrid',
                label: 'Users archive view format',
                type: 'string',
            },
        };
        preferencesService.get('archive:view').then(function (result) {
            _this.$scope.view = result.view ? result.view : 'mgrid';
        });
    }
    /**
     * @ngdoc method
     * @name ContentAPIController#setView
     * @description Sets the view to be List or Grid
     */
    ContentAPIController.prototype.setView = function (view) {
        this.$scope.view = view || 'mgrid';
        this.preferencesUpdate['archive:view'].view = this.$scope.view;
        this.preferencesService.update(this.preferencesUpdate, 'archive:view');
    };
    /**
     * @ngdoc method
     * @name ContentAPIController#preview
     * @description Preview the item
     */
    ContentAPIController.prototype.preview = function (item) {
        this.$scope.selected.preview = item;
        this.$location.search('_id', item ? item._id : null);
    };
    return ContentAPIController;
}());
exports.ContentAPIController = ContentAPIController;
ContentAPIController.$inject = ['$scope', '$location', 'pageTitle', 'preferencesService'];


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentAPISearchPanelDirective_1 = __webpack_require__(2059);
exports.ContentAPISearchPanelDirective = ContentAPISearchPanelDirective_1.ContentAPISearchPanelDirective;
var ContentAPISearchResultsDirective_1 = __webpack_require__(2061);
exports.ContentAPISearchResultsDirective = ContentAPISearchResultsDirective_1.ContentAPISearchResultsDirective;
var ContentAPISortBarDirective_1 = __webpack_require__(2063);
exports.ContentAPISortBarDirective = ContentAPISortBarDirective_1.ContentAPISortBarDirective;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkFunction = /** @class */ (function () {
    function LinkFunction($location, scope, elem) {
        var _this = this;
        this.scope = scope;
        this.elem = elem;
        this.scope.repo = { search: 'content-api' };
        this.scope.tab = 'parameters';
        this.$location = $location;
        this.scope.searchItems = this.search.bind(this);
        this.scope.clear = this.clear.bind(this);
        this.scope.$watch('tab', function (newVal, oldVal) {
            if (newVal === 'filters') {
                _this.scope.$broadcast('refresh:list');
            }
        });
    }
    /**
     * @ngdoc method
     * @name sdContentApiSearchPanel#search
     * @description broadcast 'search:parameters' event to trigger search.
     */
    LinkFunction.prototype.search = function () {
        this.scope.$broadcast('search:parameters');
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearchPanel#clear
     * @description clear all search and refresh the results.
     */
    LinkFunction.prototype.clear = function () {
        this.$location.search({});
        this.scope.$broadcast('tag:removed');
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.content-api
 * @name sdContentApiSearchPanel
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description sd-content-api-search-panel operates the search panel that appears
 * to the left of the content-api search page
 */
function ContentAPISearchPanelDirective($location) {
    return {
        template: __webpack_require__(2060),
        link: function (scope, elem) { return new LinkFunction($location, scope, elem); },
    };
}
exports.ContentAPISearchPanelDirective = ContentAPISearchPanelDirective;
ContentAPISearchPanelDirective.$inject = ['$location'];


/***/ }),
/* 2060 */
/***/ (function(module, exports) {

module.exports = "<div id=\"content-api-search-panel\">\n    <div class=\"header\">\n        <ul class=\"nav-tabs\">\n            <li ng-class=\"{'nav-tabs__tab--active': !tab || tab === 'parameters'}\" class=\"nav-tabs__tab\">\n                <button ng-click=\"tab = 'parameters'\" class=\"nav-tabs__link\"><span translate>Parameters</span></button>\n            </li>\n            <li ng-class=\"{'nav-tabs__tab--active': tab === 'filters'}\" class=\"nav-tabs__tab\">\n                <button ng-click=\"tab = 'filters'\" class=\"nav-tabs__link\"><span translate>Filters</span></button>\n            </li>\n        </ul>\n       <div class=\"doopen\" ng-click=\"flags.facets = !flags.facets\"><i class=\"icon-close-small\"></i></div>\n    </div>\n    <div class=\"nav-tabs__content content\">\n        <div ng-if=\"!tab || tab === 'parameters'\" class=\"nav-tabs__pane\">\n            <div sd-search-parameters data-repo=\"repo\"></div>\n        </div>\n        <div ng-if=\"tab === 'filters'\" class=\"nav-tabs__pane\">\n            <div sd-search-filters></div>\n        </div>\n    </div>\n   <div class=\"float-search-btn\" ng-if=\"tab==='parameters'\">\n        <a id=\"clear_filters\" class=\"save-search__link\" ng-click=\"clear()\" translate>Clear filters</a>\n        <button class=\"btn btn--primary btn--full search\" ng-click=\"searchItems()\" translate>Search</button>\n   </div>\n</div>\n";

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
var LinkFunction = /** @class */ (function () {
    function LinkFunction(contentApiSearch, search, notify, $location, scope, elem) {
        var _this = this;
        this.scope = scope;
        this.elem = elem;
        this.containerElem = elem.find('.shadow-list-holder');
        this.notify = notify;
        this.$location = $location;
        this.contentApiSearch = contentApiSearch;
        this.search = search;
        this.criteria = this.contentApiSearch.getCriteria();
        this.queryItems();
        this.scope.fetchNext = this.fetchNext.bind(this);
        this.scope.refreshList = this.refreshList.bind(this);
        // set the watch
        this.scope.$watch(function () { return lodash_1.default.omit(_this.$location.search(), ['_id', 'item']); }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _this.scope.refreshList();
            }
        }, true);
        this.scope.$on('refresh:list', function (event, group) {
            _this.scope.refreshList();
        });
    }
    /**
     * @ngdoc method
     * @name sdContentApiSearchResults#_getAggregations
     * @private
     * @description Set the aggregations args based on filters tab or not.
     */
    LinkFunction.prototype._getAggregations = function () {
        this.criteria.aggregations = this.scope.tab === 'filters' ? 1 : 0;
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearchResults#refreshList
     * @public
     * @description Refresh the search results
     */
    LinkFunction.prototype.refreshList = function () {
        this.queryItems(null, { force: true });
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearchResults#queryItems
     * @public
     * @description Function for fetching the items in case of first time.
     * @return {promise}
     */
    LinkFunction.prototype.queryItems = function (event, data) {
        var _this = this;
        this.criteria = this.contentApiSearch.getCriteria();
        this._getAggregations();
        return this.contentApiSearch.query(this.criteria).then(function (items) {
            _this.scope.$applyAsync(function () {
                _this.render(items, null, data && data.force);
            });
        }, function (error) {
            _this.notify.error(utils_1.gettext('Failed to run the query!'));
        })
            .finally(function () {
            _this.scope.loading = false;
            // update scroll position to top, when forced refresh
            if (data && data.force) {
                _this.containerElem[0].scrollTop = 0;
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearchResults#fetchNext
     * @public
     * @description Function for fetching next page
     */
    LinkFunction.prototype.fetchNext = function () {
        this.render(null, true);
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearchResults#render
     * @public
     * @param {Array<object>} items - Array of items to display.
     * @param {boolean} next - true then fetch next page and update the existing list of items.
     * @param {boolean} force - initialize and refresh the list to display.
     * @description Fetch the items from backend and display the items.
     */
    LinkFunction.prototype.render = function (items, next, force) {
        var _this = this;
        this.scope.loading = true;
        var setScopeItems = function (_items, _force) {
            _this.scope.items = _this.search.mergeItems(_items, _this.scope.items, next, _force);
            _this.scope.items._aggregations = _items._aggregations;
            _this.scope.total = _items._meta.total;
            _this.scope.loading = false;
        };
        if (items) {
            setScopeItems(items, force);
        }
        else if (next) {
            this.scope.loading = true;
            this.criteria.page = (this.criteria.page || 0) + 1;
            this._getAggregations();
            this.contentApiSearch.query(this.criteria)
                .then(setScopeItems)
                .finally(function () {
                _this.scope.loading = false;
            });
        }
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.content-api
 * @name sdContentApiSearchResults
 * @requires contentApiSearch
 * @requires search
 * @requires notify
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description sd-content-api-search-results displays the search based on the change to the route.
 */
function ContentAPISearchResultsDirective(contentApiSearch, search, notify, $location) {
    return {
        template: __webpack_require__(2062),
        link: function (scope, elem) { return new LinkFunction(contentApiSearch, search, notify, $location, scope, elem); },
    };
}
exports.ContentAPISearchResultsDirective = ContentAPISearchResultsDirective;
ContentAPISearchResultsDirective.$inject = ['contentApiSearch', 'search', 'notify', '$location'];


/***/ }),
/* 2062 */
/***/ (function(module, exports) {

module.exports = "<div class=\"preview-layout\" ng-class=\"{closed: !selected.preview && !selected.fetch}\" ng-init=\"extras={view: view, activity: {type: spike ? 'spike' : type, action: 'list'}, api: api}\">\n    <div class=\"list-pane {{ view || 'mgrid' }}-view\">\n        <div id=\"content-list\" class=\"content\">\n            <div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div>\n            <div class=\"search-tags\" ng-class=\"{'refresh': showRefresh}\" sd-search-tags></div>\n            <div class=\"shadow-list-holder\" sd-items-list></div>\n        </div>\n        <div sd-item-preview\n             data-item=\"selected.preview\"\n             data-close=\"preview()\"\n             data-open-single-item=\"openSingleItem\"\n             data-hide-actions-menu=\"true\">\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSortBar_1 = __webpack_require__(162);
var LinkFunction = /** @class */ (function (_super) {
    __extends(LinkFunction, _super);
    function LinkFunction(contentApiSearch, sort, scope, elem) {
        var _this = _super.call(this, scope, elem, sort) || this;
        _this.contentApiSearch = contentApiSearch;
        _this.scope.canSort = _super.prototype.canSort.bind(_this);
        _this.scope.sortOptions = contentApiSearch.sortOptions;
        _super.prototype.getActive.call(_this);
        return _this;
    }
    return LinkFunction;
}(BaseSortBar_1.BaseSortBar));
/**
 * @ngdoc directive
 * @module superdesk.apps.content-api
 * @name sdContentApiSortBar
 * @requires contentApiSearch
 * @requires sort
 * @description sd-content-api-sort-bar handle sort functionality.
 */
function ContentAPISortBarDirective(contentApiSearch, sort) {
    return {
        scope: { total: '=' },
        template: __webpack_require__(163),
        link: function (scope, elem) { return new LinkFunction(contentApiSearch, sort, scope, elem); },
    };
}
exports.ContentAPISortBarDirective = ContentAPISortBarDirective;
ContentAPISortBarDirective.$inject = ['contentApiSearch', 'sort'];


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContentAPISearchService_1 = __webpack_require__(2065);
exports.ContentAPISearchService = ContentAPISearchService_1.ContentAPISearchService;


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var utils_1 = __webpack_require__(3);
var DEFAULT_PAGE_SIZE = 25;
/**
 * @ngdoc service
 * @module superdesk.apps.content-api
 * @name sdContentApiSearch
 * @requires api
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires sort
 * @requires search
 * @description Handles retrieval of data from content api
 */
var ContentAPISearchService = /** @class */ (function () {
    function ContentAPISearchService(api, $location, sort, search) {
        this.api = api;
        this.$location = $location;
        this.sort = sort;
        this.sortOptions = [
            { field: 'versioncreated', label: utils_1.gettext('Updated') },
            { field: 'firstcreated', label: utils_1.gettext('Created') },
            { field: 'urgency', label: utils_1.gettext('Urgency') },
            { field: 'priority', label: utils_1.gettext('Priority') },
            { field: 'slugline', label: utils_1.gettext('Slugline') },
            { field: 'service.name', label: utils_1.gettext('Category') },
        ];
        this.search = search;
    }
    /**
     * @ngdoc method
     * @name sdContentApiSearch#_getFilters
     * @private
     * @param {object} params - $location.search()
     * @description Create elasticsearch filters.
     * @return {Array<object>} list of filters
     */
    ContentAPISearchService.prototype._getFilters = function (params) {
        var filters = [];
        // set filters for parameters
        if (params.subject) {
            filters.push({ or: [
                    { terms: { 'subject.code': JSON.parse(params.subject) } },
                    { terms: { 'subject.parent': JSON.parse(params.subject) } },
                ] });
        }
        if (params.company_codes) {
            filters.push({ terms: { 'organisation.symbols.ticker': JSON.parse(params.company_codes) } });
        }
        lodash_1.default.each(['genre', 'category', 'urgency', 'priority', 'type', 'source'], function (key) {
            if (!params[key]) {
                return;
            }
            var termKey = {
                type: 'type',
                genre: 'genre.name',
                category: 'service.name',
                urgency: 'urgency',
                source: 'source',
                priority: 'priority',
            }[key];
            if (termKey) {
                var f = { terms: {} };
                f.terms[termKey] = JSON.parse(params[key]);
                filters.push(f);
            }
        });
        return filters;
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearch#getCriteria
     * @public
     * @description Creates the url parameters object for backend query.
     * @param {object} param $location.search object
     * @return {object}
     */
    ContentAPISearchService.prototype.getCriteria = function (param) {
        var _this = this;
        var criteria = {};
        var params = param || this.$location.search();
        var sort = this.sort.getSort(this.sortOptions);
        criteria.max_results = DEFAULT_PAGE_SIZE;
        criteria.sort = this.sort.formatSort(sort.field, sort.dir);
        criteria.page = 1;
        var buildRangeFilter = function (paramsObject, _filters) {
            // created & modified date filters
            var hasParams = paramsObject.beforefirstcreated || paramsObject.afterfirstcreated ||
                paramsObject.beforeversioncreated || paramsObject.afterversioncreated;
            var zeroHourSuffix = 'T00:00:00', midnightSuffix = 'T23:59:59';
            if (hasParams) {
                var range = { firstcreated: {}, versioncreated: {} };
                if (paramsObject.beforefirstcreated) {
                    range.firstcreated.lte = _this.search.formatDate(paramsObject.beforefirstcreated, midnightSuffix);
                }
                if (paramsObject.afterfirstcreated) {
                    range.firstcreated.gte = _this.search.formatDate(paramsObject.afterfirstcreated, zeroHourSuffix);
                }
                if (paramsObject.beforeversioncreated) {
                    range.versioncreated.lte =
                        _this.search.formatDate(paramsObject.beforeversioncreated, midnightSuffix);
                }
                if (paramsObject.afterversioncreated) {
                    range.versioncreated.gte = _this.search.formatDate(paramsObject.afterversioncreated, zeroHourSuffix);
                }
                return _filters.concat([{ range: range }]);
            }
            else if (paramsObject.after) {
                var range = { firstcreated: {} };
                range.firstcreated.gte = paramsObject.after;
                return _filters.concat([{ range: range }]);
            }
            return _filters;
        };
        if (params.subscriber) {
            criteria.subscribers = params.subscriber;
        }
        if (params.q) {
            criteria.q = params.q;
            criteria.default_operator = 'AND';
        }
        var filters = this._getFilters(params);
        filters = buildRangeFilter(params, filters);
        if (filters.length > 0) {
            criteria.filter = JSON.stringify(filters);
        }
        return criteria;
    };
    /**
     * @ngdoc method
     * @name sdContentApiSearch#getCriteria
     * @public
     * @description Creates the url parameters object for backend query.
     * @param {object} param parameters to search
     * @return {promise}
     */
    ContentAPISearchService.prototype.query = function (param) {
        return this.api.search_capi.query(param);
    };
    return ContentAPISearchService;
}());
exports.ContentAPISearchService = ContentAPISearchService;
ContentAPISearchService.$inject = ['api', '$location', 'sort', 'search'];


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var directive = __importStar(__webpack_require__(2067));
var svc = __importStar(__webpack_require__(2069));
angular.module('superdesk.apps.extension-points', [])
    .directive('sdExtensionPoint', directive.ExtensionPointDirective)
    .service('extensionPoints', svc.ExtensionPointsService);


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExtensionPointDirective_1 = __webpack_require__(2068);
exports.ExtensionPointDirective = ExtensionPointDirective_1.ExtensionPointDirective;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_dom_1 = __importDefault(__webpack_require__(15));
var react_1 = __importDefault(__webpack_require__(0));
/**
 * @ngdoc directive
 * @module superdesk.apps.extension-points
 * @name extensionPointDirective
 * @packageName superdesk.apps
 * @description
 * External superdesk apps can register components that then will be hooked into
 * the core UI.
 * Place this tag in a view where you'd like to add an extension:
 *   <span sd-extension-point="MY_TYPE"></span>
 * See also ExtensionPointsService.
 */
ExtensionPointDirective.$inject = ['extensionPoints', 'lodash', '$q'];
function ExtensionPointDirective(extensionPoints, _, $q) {
    function _buildCompoment(extension, scope) {
        // for easy access put values from parent scope into ...
        var callback = extension.onInit && extension.onInit(extension, scope) || $q.resolve();
        return callback
            .then(function () {
            if (!_.get(extension, 'props.store', null)) {
                // ... the component's props or ...
                extension.data.forEach(function (value) {
                    extension.props[value] = scope.$parent.$eval(value);
                });
            }
            else {
                // ... into the component's redux store
                extension.data.forEach(function (value) {
                    extension.props.store.getState()[value] = scope.$parent.$eval(value);
                });
            }
            return react_1.default.createElement(extension.componentClass, extension.props);
        });
    }
    return {
        link: function (scope, elem, attr) {
            var registeredExtensions = extensionPoints.get(attr.sdExtensionPoint);
            $q.all(registeredExtensions.map(function (extension, index) { return (_buildCompoment(extension, scope)); }))
                .then(function (components) {
                var elements = components.map(function (component, index) { return (react_1.default.createElement("span", { key: attr.sdExtensionPoint + "-" + index }, component)); });
                react_dom_1.default.render(elements, elem[0]);
                scope.$on('$destroy', function () {
                    react_dom_1.default.unmountComponentAtNode(elem[0]);
                });
            });
        },
    };
}
exports.ExtensionPointDirective = ExtensionPointDirective;


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ExtensionPoints_1 = __webpack_require__(2070);
exports.ExtensionPointsService = ExtensionPoints_1.ExtensionPointsService;


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @ngdoc provider
 * @module superdesk.apps.extension-points
 * @name extensionPoints
 * @packageName superdesk.apps
 * @description
 * External superdesk apps can register components that then will be hooked into
 * the core UI.
 * Inject 'extensionPoints' into your module and then:
 *
 * extensionPoints.register('MY_TYPE', MyConnectedComponent, props, data, onInit); // do this in config phase
 *
 * where MyConnectedComponent is a React component, the props is a json object that may contain a
 * redux store and data is an array with names of variables that your component will receive as props
 * from the parent scope, for example: ['item'].
 * onInit: callback while rendering build React components
 * See also ExtensionPointsDirective.
 */
function ExtensionPointsService() {
    var _this = this;
    this.extensions = {};
    this.register = function (type, componentClass, props, data, onInit) {
        if (props === void 0) { props = {}; }
        if (data === void 0) { data = []; }
        if (onInit === void 0) { onInit = null; }
        if (typeof this.extensions[type] === 'undefined') {
            this.extensions[type] = [];
        }
        this.extensions[type].push({ type: type, componentClass: componentClass, props: props, data: data, onInit: onInit });
    };
    this.get = function (type) {
        if (typeof _this.extensions[type] === 'undefined') {
            return [];
        }
        return _this.extensions[type];
    };
}
exports.ExtensionPointsService = ExtensionPointsService;


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var controllers_1 = __webpack_require__(2072);
var directives = __importStar(__webpack_require__(2074));
var services = __importStar(__webpack_require__(2125));
__webpack_require__(2127);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc module
 * @module superdesk.apps.contacts
 * @name superdesk.apps.contacts
 * @packageName superdesk.apps
 * @description Superdesk Contacts Management.
 */
angular.module('superdesk.apps.contacts', [
    'superdesk.core.api',
    'superdesk.apps.publish',
    'superdesk.apps.search',
])
    .config(['superdeskProvider', function (superdesk) {
        superdesk
            .activity('/contacts', {
            label: utils_1.gettext('Media Contacts'),
            description: utils_1.gettext('View/Manage media contacts'),
            priority: 100,
            category: superdesk.MENU_MAIN,
            adminTools: true,
            controller: controllers_1.ContactsController,
            templateUrl: 'scripts/apps/contacts/views/list.html',
            sideTemplateUrl: 'scripts/apps/workspace/views/workspace-sidenav.html',
            filters: [],
            reloadOnSearch: false,
            features: { contacts: 1 },
            privileges: { view_contacts: 1 },
        });
    }])
    .service('contacts', services.ContactsService)
    .directive('sdContactsSearchPanel', directives.ContactsSearchPanelDirective)
    .directive('sdContactsSearchResults', directives.ContactsSearchResultsDirective)
    .directive('sdContactsSortBar', directives.ContactsSortBarDirective)
    .directive('sdContactsList', directives.ContactList)
    .directive('sdContactEditor', directives.ContactEditorDirective)
    .config(['apiProvider', function (apiProvider) {
        apiProvider.api('contacts', {
            type: 'http',
            backend: {
                rel: 'contacts',
            },
        });
    }]);


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactsController_1 = __webpack_require__(2073);
exports.ContactsController = ContactsController_1.ContactsController;


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(43);
var utils_1 = __webpack_require__(3);
/**
 * @ngdoc controller
 * @module superdesk.apps.contacts
 * @name ContactsController
 * @requires https://docs.angularjs.org/api/ng/type/$rootScope.Scope $scope
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires pageTitle
 * @requires preferencesService
 * @requires contacts service
 * @requires _ lodash
 *
 * @description ContactsController
 */
var ContactsController = /** @class */ (function () {
    function ContactsController($scope, $location, pageTitle, preferencesService, metadata, privileges, contacts) {
        var _this = this;
        this.$scope = $scope;
        this.$location = $location;
        this.contacts = contacts;
        this.preferencesService = preferencesService;
        this.$scope.privileges = privileges.privileges;
        pageTitle.setUrl(utils_1.gettext('Superdesk Contacts Management'));
        this.$scope.openAdvanceSearch = false;
        this.$scope.selected = {
            preview: null,
        };
        this.$scope.setView = this.setView.bind(this);
        this.$scope.preview = this.preview.bind(this);
        this.preferencesUpdate = {
            'contacts:view': {
                allowed: ['photogrid', 'compact'],
                category: 'contacts',
                view: 'photogrid',
                default: 'photogrid',
                label: 'Users contacts view format',
                type: 'string',
            },
        };
        preferencesService.get('contacts:view').then(function (result) {
            _this.$scope.view = result.view ? result.view : 'photogrid';
            // Contacts previously allowed mgrid view
            // Make sure the user preferences does not have this value
            if (['photogrid', 'compact'].indexOf(_this.$scope.view) < 0) {
                _this.$scope.view = 'photogrid';
                _this.updateViewPreferences();
            }
        });
        metadata.initialize().then(function () {
            _this.$scope.metadata = metadata.values;
        });
        this.$scope.createContact = this.createContact.bind(this);
        this.$scope.filterContacts = this.filterContacts.bind(this);
        this.$scope.filters = {
            privacyOptions: this.contacts.privacyOptions,
            statusOptions: this.contacts.statusOptions,
            selectedStatus: lodash_1.default.find(this.contacts.statusOptions, function (s) { return s.value === (lodash_1.default.get(_this.$location.search(), constants_1.FILTER_FIELDS.STATUS) || null); }),
            selectedPrivacy: lodash_1.default.find(this.contacts.privacyOptions, function (p) { return p.value === (lodash_1.default.get(_this.$location.search(), constants_1.FILTER_FIELDS.PRIVACY_LEVEL) || null); }),
        };
        // set default status filter as active
        if (!lodash_1.default.get(this.$location.search(), constants_1.FILTER_FIELDS.STATUS)) {
            this.filterContacts(constants_1.FILTER_FIELDS.STATUS, lodash_1.default.find(this.contacts.statusOptions, function (s) { return s.value === 'true'; }));
        }
    }
    /**
     * @ngdoc method
     * @name ContactsController#setView
     * @description Sets the view to be List or Grid
     */
    ContactsController.prototype.setView = function (view) {
        this.$scope.view = view || 'photogrid';
        this.updateViewPreferences();
    };
    ContactsController.prototype.updateViewPreferences = function () {
        this.preferencesUpdate['contacts:view'].view = this.$scope.view;
        this.preferencesService.update(this.preferencesUpdate, 'contacts:view');
    };
    /**
     * @ngdoc method
     * @name ContactsController#preview
     * @description Preview the item
     */
    ContactsController.prototype.preview = function (item) {
        this.$scope.selected.preview = item;
        this.$location.search('_id', item ? item._id : null);
    };
    ContactsController.prototype.createContact = function (type) {
        this.$scope.preview({});
    };
    ContactsController.prototype.filterContacts = function (field, option) {
        if (field === constants_1.FILTER_FIELDS.PRIVACY_LEVEL) {
            this.$scope.filters.selectedPrivacy = option;
        }
        if (field === constants_1.FILTER_FIELDS.STATUS) {
            this.$scope.filters.selectedStatus = option;
        }
        this.$location.search(field, lodash_1.default.get(option, 'value', null));
    };
    return ContactsController;
}());
exports.ContactsController = ContactsController;
ContactsController.$inject = ['$scope', '$location', 'pageTitle',
    'preferencesService', 'metadata', 'privileges', 'contacts'];


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactsSearchPanelDirective_1 = __webpack_require__(2075);
exports.ContactsSearchPanelDirective = ContactsSearchPanelDirective_1.ContactsSearchPanelDirective;
var ContactsSearchResultsDirective_1 = __webpack_require__(2120);
exports.ContactsSearchResultsDirective = ContactsSearchResultsDirective_1.ContactsSearchResultsDirective;
var ContactsSortBarDirective_1 = __webpack_require__(2122);
exports.ContactsSortBarDirective = ContactsSortBarDirective_1.ContactsSortBarDirective;
var ContactList_1 = __webpack_require__(2123);
exports.ContactList = ContactList_1.ContactList;
var ContactEditorDirective_1 = __webpack_require__(2124);
exports.ContactEditorDirective = ContactEditorDirective_1.ContactEditorDirective;


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(43);
var Form_1 = __webpack_require__(63);
var utils_1 = __webpack_require__(3);
var LinkFunction = /** @class */ (function () {
    function LinkFunction(contacts, $location, scope, elem) {
        var _this = this;
        this.scope = scope;
        this.elem = elem;
        this.orgField = document.getElementById('org-field');
        this.contacts = contacts;
        this.$location = $location;
        this.scope.searchItems = this.search.bind(this);
        this.scope.clear = this.clear.bind(this);
        this.setQueryString = this.setQueryString.bind(this);
        this.scope.toggle = { all: true };
        this.scope.keyPressed = this.keyPressed.bind(this);
        this.scope.searchField = this.searchField.bind(this);
        this.scope.isSearchDifferent = this.isSearchDifferent.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.init();
        this.scope.$on('$locationChangeSuccess', function () {
            if (_this.scope.query !== _this.$location.search().q || _this.scope.isSearchDifferent()) {
                _this.init();
            }
        });
        this.scope.$on('$destroy', function () {
            elem.off();
            react_dom_1.default.unmountComponentAtNode(_this.orgField);
        });
    }
    /*
     * init function to setup the directive initial state and called by $locationChangeSuccess event
     */
    LinkFunction.prototype.init = function () {
        var params = this.$location.search();
        this.scope.query = params.q;
        this.scope.flags = false;
        var meta = {};
        lodash_1.default.forEach(constants_1.URL_PARAMETERS, function (value, key) {
            if (lodash_1.default.get(params, key)) {
                meta[key] = params[key];
            }
        });
        this.scope.meta = meta;
        this.scope.filteredList = {};
        if (!params.organisation) {
            this.scope.filteredList['organisation'] = [];
        }
        this.renderSearchField('organisation', true);
        this.scope.selectedItem = '';
    };
    LinkFunction.prototype.isSearchDifferent = function () {
        var _this = this;
        var params = this.$location.search();
        return lodash_1.default.some(lodash_1.default.keys(constants_1.URL_PARAMETERS), function (key) { return lodash_1.default.get(_this.scope.meta, key) !== lodash_1.default.get(params, key); });
    };
    LinkFunction.prototype.handleOnChange = function (field, value) {
        this.scope.meta[field] = value;
        this.renderSearchField(field, false);
    };
    LinkFunction.prototype.renderSearchField = function (field, initValue) {
        var _this = this;
        var fieldElement;
        var fieldLabel;
        var querySearch = false;
        switch (field) {
            case 'organisation':
                fieldElement = this.orgField;
                fieldLabel = utils_1.gettext('Organisation');
                querySearch = true;
                break;
        }
        react_dom_1.default.render(react_1.default.createElement(Form_1.SelectFieldSearchInput, { field: field, label: fieldLabel, onChange: this.handleOnChange, value: lodash_1.default.get(this.scope.meta, field, ''), querySearch: querySearch, onQuerySearch: (function (searchText) { return _this.scope.searchField(field, searchText); }), dataList: this.scope.filteredList[field], initValue: initValue }), fieldElement);
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchPanel#setQueryString
     * @description function to set query string.
     */
    LinkFunction.prototype.setQueryString = function () {
        var _this = this;
        var pattern = /[()]/g;
        var params = this.$location.search();
        var booleanToBinaryString = function (bool) {
            return Number(bool).toString();
        };
        lodash_1.default.forEach(this.scope.meta, function (val, key) {
            var v = val;
            if (typeof val === 'boolean') {
                v = booleanToBinaryString(val);
            }
            if (typeof val === 'string') {
                v = val.replace(pattern, '');
            }
            if (v) {
                _this.$location.search(key, val);
            }
            else if (lodash_1.default.get(params, key)) {
                _this.$location.search(key, null);
            }
        });
        this.$location.search('q', this.scope.query || null);
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchPanel#search
     * @description function to perform search.
     */
    LinkFunction.prototype.search = function () {
        this.setQueryString();
    };
    /*
    * Get search input from field while typed and query the text input.
    */
    LinkFunction.prototype.searchField = function (field, text) {
        var _this = this;
        if (text) {
            this.contacts.queryField(field, text).then(function (items) {
                _this.scope.filteredList[field] = lodash_1.default.map(items._items, field);
                _this.scope.meta[field] = text;
                _this.renderSearchField(field);
            });
        }
    };
    LinkFunction.prototype.keyPressed = function (event) {
        var ENTER = 13;
        if (event.keyCode === ENTER) {
            this.search();
            event.preventDefault();
        }
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchPanel#clear
     * @description clear all search and refresh the results.
     */
    LinkFunction.prototype.clear = function () {
        var fields = lodash_1.default.keys(constants_1.URL_PARAMETERS).concat(['q']);
        this.$location.search(lodash_1.default.omit(this.$location.search(), fields));
        this.scope.$broadcast('tag:removed');
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.contacts
 * @name sdContactsSearchPanel
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description sd-contacts-search-panel operates the search panel that appears
 * to the left of the contacts search page
 */
function ContactsSearchPanelDirective(contacts, $location) {
    return {
        template: __webpack_require__(2119),
        link: function (scope, elem) { return new LinkFunction(contacts, $location, scope, elem); },
    };
}
exports.ContactsSearchPanelDirective = ContactsSearchPanelDirective;
ContactsSearchPanelDirective.$inject = ['contacts', '$location'];


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var helpers_1 = __webpack_require__(64);
var constants_1 = __webpack_require__(43);
var ContactProfile_1 = __webpack_require__(579);
var ActionBar_1 = __webpack_require__(582);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var ContactFormContainer = /** @class */ (function (_super) {
    __extends(ContactFormContainer, _super);
    function ContactFormContainer(props) {
        var _this = _super.call(this, props) || this;
        // Initialize
        _this.state = {
            currentContact: props.contact || {},
            errors: {},
            originalContact: props.contact || {},
            dirty: false,
            isFormValid: false,
        };
        _this.save = _this.save.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.validateForm = _this.validateForm.bind(_this);
        return _this;
    }
    ContactFormContainer.prototype.validateForm = function () {
        var valid = helpers_1.validateRequiredFormFields(this.state.currentContact) &&
            !lodash_1.some(this.state.errors, function (value) { return !lodash_1.isEmpty(value); });
        this.setState({ isFormValid: valid });
        if (this.state.dirty) {
            this.props.onDirty();
        }
        this.props.onValidation(valid);
    };
    ContactFormContainer.prototype.validateField = function (fieldName, value, e) {
        var fieldValidationErrors = this.state.errors;
        var contacts = this.props.svc.contacts;
        var twitterPattern = contacts.twitterPattern;
        if (e && e.target.type === 'email') {
            if (e.target.validity.typeMismatch) {
                fieldValidationErrors[e.target.name] = utils_1.gettext('Please provide a valid email address');
            }
            else {
                fieldValidationErrors[e.target.name] = '';
            }
        }
        switch (fieldName) {
            case 'twitter':
                fieldValidationErrors[fieldName] = value.match(twitterPattern) || lodash_1.isEmpty(value) ? '' :
                    utils_1.gettext('Please provide a valid twitter account');
                break;
            default:
                break;
        }
        return fieldValidationErrors;
    };
    ContactFormContainer.prototype.componentWillReceiveProps = function (nextProps) {
        if (!this.props.triggerSave && nextProps.triggerSave) {
            this.save();
        }
    };
    ContactFormContainer.prototype.save = function () {
        var _this = this;
        var _a = this.props, svc = _a.svc, onSave = _a.onSave;
        var notify = svc.notify, contacts = svc.contacts;
        var origContact = this.state.originalContact;
        notify.info(utils_1.gettext('Saving...'));
        var diff = {};
        lodash_1.each(this.state.currentContact, function (value, key) {
            var _a;
            if (!lodash_1.isEqual(origContact[key], value)) {
                lodash_1.extend(diff, (_a = {}, _a[key] = value, _a));
            }
        });
        if (diff.facebook) {
            diff.facebook = constants_1.FB_URL + this.state.currentContact.facebook;
        }
        if (diff.instagram) {
            diff.instagram = constants_1.IG_URL + this.state.currentContact.instagram;
        }
        // clean diff
        diff = lodash_1.omit(diff, 'type');
        return contacts.save(origContact, diff)
            .then(function (response) {
            notify.pop();
            notify.success(utils_1.gettext('contact saved.'));
            var result = helpers_1.replaceUrls(response);
            _this.setState({
                originalContact: result,
                currentContact: result,
                dirty: false,
            }, onSave(result));
        }, function (response) {
            notify.pop();
            var errorMessage = utils_1.gettext('There was an error when saving the contact.');
            if (response.data && response.data._issues) {
                if (!lodash_1.isNil(response.data._issues['validator exception'])) {
                    errorMessage = utils_1.gettext('Error: ' + response.data._issues['validator exception']);
                }
            }
            notify.error(errorMessage);
        });
    };
    ContactFormContainer.prototype.onChange = function (field, value, e) {
        var diff = lodash_1.cloneDeep(this.state.currentContact);
        var origContact = this.state.originalContact;
        lodash_1.set(diff, field, value);
        this.setState({
            currentContact: diff,
            dirty: !lodash_1.isEqual(origContact, diff),
            errors: this.validateField(field, value, e),
        }, this.validateForm);
    };
    ContactFormContainer.prototype.render = function () {
        var _a = this.props, svc = _a.svc, contact = _a.contact, onCancel = _a.onCancel, hideActionBar = _a.hideActionBar;
        var privileges = svc.privileges;
        var readOnly = !lodash_1.get(privileges, 'privileges.contacts', false);
        return (react_1.default.createElement("div", { id: contact._id, key: contact._id, className: "contact-form" },
            react_1.default.createElement("form", { name: "contactForm" },
                !hideActionBar && react_1.default.createElement(ActionBar_1.ActionBar, { svc: svc, readOnly: readOnly, onSave: this.save, onCancel: onCancel, dirty: lodash_1.get(this.state, 'dirty', false), valid: lodash_1.get(this.state, 'isFormValid', false) }),
                react_1.default.createElement(ContactProfile_1.ContactProfile, { svc: svc, contact: lodash_1.get(this.state, 'currentContact', {}), dirty: lodash_1.get(this.state, 'dirty', false), onChange: this.onChange, readOnly: readOnly, errors: lodash_1.get(this.state, 'errors', {}) }))));
    };
    return ContactFormContainer;
}(react_1.default.Component));
exports.ContactFormContainer = ContactFormContainer;
ContactFormContainer.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    contact: prop_types_1.default.object.isRequired,
    onSave: prop_types_1.default.func,
    onCancel: prop_types_1.default.func,
    onDirty: prop_types_1.default.func,
    onValidation: prop_types_1.default.func,
    triggerSave: prop_types_1.default.bool,
    hideActionBar: prop_types_1.default.bool,
};
ContactFormContainer.defaultProps = {
    onDirty: function () { },
    onValidation: function () { },
    onSave: function () { },
    hideActionBar: false,
};


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
exports.Notes = function (_a) {
    var item = _a.item;
    var notes = item.notes;
    var displayNotes = lodash_1.truncate(notes, { length: 120 });
    return (react_1.default.createElement("div", { key: "notes" }, notes &&
        react_1.default.createElement("span", { title: notes }, displayNotes)));
};
exports.Notes.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var notEmpty = function (str) { return typeof str === 'string' && str.length > 0; };
exports.ContactName = function (_a) {
    var item = _a.item;
    var displayContact = notEmpty(item.first_name) || notEmpty(item.last_name) ?
        [item.first_name, item.last_name].filter(notEmpty).join(' ')
        : item.organisation;
    return (react_1.default.createElement("span", { key: "contact-name-" + item._id, className: "contact-name" }, displayContact));
};
exports.ContactName.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.JobTitle = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("span", { key: "role-container-" + item._id, className: "container" },
        " ",
        item.job_title && "(" + item.job_title + ")"));
};
exports.JobTitle.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.State = function (_a) {
    var item = _a.item;
    var cssClass = item.contact_state ? 'state-label' : null;
    return (react_1.default.createElement("div", { key: "state", className: cssClass }, item.contact_state !== undefined && item.contact_state !== null &&
        react_1.default.createElement("span", { title: item.contact_state }, utils_1.gettext(item.contact_state))));
};
exports.State.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
exports.VersionCreated = function (_a) {
    var item = _a.item, svc = _a.svc;
    return react_1.default.createElement(components_1.TimeElem, { key: "version-created", date: item._updated, svc: svc });
};
exports.VersionCreated.propTypes = {
    item: prop_types_1.default.object,
    svc: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.TimeElem = function (_a) {
    var svc = _a.svc, date = _a.date;
    var datetime = svc.datetime;
    return (react_1.default.createElement("time", { title: datetime.longFormat(date) }, datetime.shortFormat(date)));
};
exports.TimeElem.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    date: prop_types_1.default.any,
};


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var lodash_1 = __webpack_require__(2);
var constants_1 = __webpack_require__(43);
var utils_1 = __webpack_require__(3);
var ItemContainer = /** @class */ (function (_super) {
    __extends(ItemContainer, _super);
    function ItemContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.init(props);
        return _this;
    }
    ItemContainer.prototype.getContactNumber = function (item, field) {
        return lodash_1.find(item[field], 'number') ? lodash_1.join(lodash_1.map(item[field], 'number'), ', ') : null;
    };
    ItemContainer.prototype.getContactNumberTitle = function (item, field) {
        return lodash_1.find(item[field], 'usage') ? lodash_1.join(lodash_1.map(item[field], 'usage'), ', ') : null;
    };
    ItemContainer.prototype.getEmailValue = function (item) {
        var emails = lodash_1.map(item.contact_email, function (email) { return (react_1.default.createElement("a", { href: "" + constants_1.MAILTO_URL + email, title: "" + email }, email)); });
        return lodash_1.map(emails, function (email, i) { return (react_1.default.createElement("span", { key: "emails-" + i },
            i > 0 && ', ',
            email)); });
    };
    ItemContainer.prototype.init = function (props) {
        var value;
        var title;
        var altTitle;
        var item;
        var key;
        var _class;
        var _link;
        var addressInfo = [];
        item = props.item;
        key = props.field || null;
        _class = 'container';
        _link = _class + ' link';
        if (item.contact_address) {
            addressInfo.push(item.contact_address[0]);
        }
        if (item.locality) {
            addressInfo.push(item.locality);
        }
        if (item.city) {
            addressInfo.push(item.city);
        }
        if (item.contact_state) {
            addressInfo.push(item.contact_state);
        }
        if (item.postcode) {
            addressInfo.push(item.postcode);
        }
        if (item.country) {
            addressInfo.push(item.country);
        }
        var contactAddress = addressInfo.join(', ');
        switch (key) {
            case 'contact_phone':
                value = this.getContactNumber(item, key);
                title = value && utils_1.gettext(this.getContactNumberTitle(item, key));
                break;
            case 'mobile':
                value = this.getContactNumber(item, key);
                title = value && utils_1.gettext(this.getContactNumberTitle(item, key));
                break;
            case 'contact_email':
                value = item.contact_email ? this.getEmailValue(item) : null;
                _class = _link;
                break;
            case 'website':
                value = (react_1.default.createElement("a", { href: item.website, target: "_blank", rel: "noopener noreferrer" }, item.website));
                title = value && item.website;
                _class = _link;
                break;
            case 'twitter':
                value = (react_1.default.createElement("a", { href: "" + constants_1.TWITTER_URL + item.twitter, target: "_blank", rel: "noopener noreferrer" },
                    react_1.default.createElement("i", { className: "icon-twitter" })));
                title = value && "" + constants_1.TWITTER_URL + item.twitter;
                _class = _link;
                break;
            case 'facebook':
                value = (react_1.default.createElement("a", { href: item.facebook, target: "_blank", rel: "noopener noreferrer" },
                    react_1.default.createElement("i", { className: "icon-facebook" })));
                title = value && item.facebook;
                _class = _link;
                break;
            case 'location':
                value = contactAddress ? (react_1.default.createElement("a", { href: "" + constants_1.MAP_URL + contactAddress, target: "_blank", rel: "noopener noreferrer" }, contactAddress)) : null;
                title = value && contactAddress;
                _class = _link;
                break;
        }
        altTitle = value ? value : null;
        this.elemProps = {
            key: key,
            className: _class,
            title: title ? title : altTitle,
        };
        this.elemValue = value;
    };
    ItemContainer.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.item !== this.props.item) {
            this.init(nextProps);
        }
    };
    ItemContainer.prototype.render = function () {
        return (react_1.default.createElement("span", __assign({}, this.elemProps), this.elemValue));
    };
    return ItemContainer;
}(react_1.default.Component));
exports.ItemContainer = ItemContainer;
ItemContainer.propTypes = {
    item: prop_types_1.default.object,
    svc: prop_types_1.default.object.isRequired,
    field: prop_types_1.default.string,
};


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var helpers_1 = __webpack_require__(64);
exports.ListItemInfo = function (props) {
    var cssClass = classnames_1.default('item-info', { 'item-info-reduced-rowheight': props.scope.singleLine });
    var itemProps = angular.extend({ svc: props.svc, scope: props.scope }, props);
    var elemProps = { className: 'line' };
    if (props.scope.singleLine) {
        return (react_1.default.createElement("div", { className: cssClass }, helpers_1.renderArea('singleLine', itemProps, elemProps)));
    }
    return (react_1.default.createElement("div", { className: cssClass },
        helpers_1.renderArea('firstLine', itemProps, elemProps),
        helpers_1.renderArea('secondLine', itemProps, elemProps)));
};
exports.ListItemInfo.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
};


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var helpers_1 = __webpack_require__(64);
var components_1 = __webpack_require__(57);
/**
 * Contact Item component
 */
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hover: false };
        _this.select = _this.select.bind(_this);
        _this.setHoverState = _this.setHoverState.bind(_this);
        _this.unsetHoverState = _this.unsetHoverState.bind(_this);
        return _this;
    }
    Item.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return nextProps.item !== this.props.item ||
            nextProps.view !== this.props.view ||
            nextProps.flags.selected !== this.props.flags.selected ||
            nextState !== this.state;
    };
    Item.prototype.select = function (event) {
        this.props.onSelect(this.props.item, event);
    };
    Item.prototype.setHoverState = function () {
        this.setState({ hover: true });
    };
    Item.prototype.unsetHoverState = function () {
        this.setState({ hover: false });
    };
    Item.prototype.render = function () {
        var _a = this.props, item = _a.item, svc = _a.svc, flags = _a.flags, view = _a.view, scope = _a.scope;
        var contents = [
            'div',
            {
                className: classnames_1.default(this.props.view === 'photogrid' ?
                    'sd-grid-item sd-grid-item--with-click' :
                    'media-box contacts', {
                    selected: flags.selected,
                }),
            },
        ];
        if (view === 'photogrid') {
            contents.push(react_1.default.createElement(components_1.ContactHeader, { item: item, svc: svc }), react_1.default.createElement(components_1.ContactInfo, { item: item }), react_1.default.createElement(components_1.ContactFooter, { item: item, svc: svc }));
        }
        else {
            contents.push(react_1.default.createElement(components_1.ListTypeIcon, { item: item, svc: svc }), react_1.default.createElement(components_1.ListItemInfo, { item: item, svc: svc, scope: scope }));
        }
        var cssClass = classnames_1.default('list-item-view', {
            active: flags.selected,
            inactive: !item.is_active,
        });
        return (react_1.default.createElement("li", { id: item._id, key: item._id, className: cssClass, onMouseEnter: this.setHoverState, onMouseLeave: this.unsetHoverState, onClick: this.select }, helpers_1.renderContents(contents)));
    };
    return Item;
}(react_1.default.Component));
exports.Item = Item;
Item.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.object.isRequired,
    item: prop_types_1.default.object,
    flags: prop_types_1.default.object,
    view: prop_types_1.default.string,
    onSelect: prop_types_1.default.func,
};


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var components_1 = __webpack_require__(57);
var utils_1 = __webpack_require__(3);
/**
 * Contact Item list component
 */
var ItemList = /** @class */ (function (_super) {
    __extends(ItemList, _super);
    function ItemList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { itemsList: [], itemsById: {}, selected: null, view: 'photogrid' };
        _this.select = _this.select.bind(_this);
        _this.setSelectedItem = _this.setSelectedItem.bind(_this);
        _this.getSelectedItem = _this.getSelectedItem.bind(_this);
        _this.handleKey = _this.handleKey.bind(_this);
        return _this;
    }
    ItemList.prototype.select = function (item, event) {
        var $timeout = this.props.svc.$timeout;
        var scope = this.props.scope;
        this.setSelectedItem(item);
        $timeout.cancel(this.updateTimeout);
        this.updateTimeout = $timeout(function () {
            if (item && scope.preview) {
                scope.$apply(function () {
                    scope.preview(item);
                });
            }
        }, 500, false);
    };
    ItemList.prototype.setSelectedItem = function (item) {
        this.setState({ selected: item ? item._id : null });
    };
    ItemList.prototype.getSelectedItem = function () {
        var selected = this.state.selected;
        return this.state.itemsById[selected];
    };
    ItemList.prototype.handleKey = function (event) {
        var _this = this;
        var scope = this.props.scope;
        var Keys = this.props.svc.Keys;
        var diff;
        switch (event.keyCode) {
            case Keys.right:
            case Keys.down:
                diff = 1;
                break;
            case Keys.left:
            case Keys.up:
                diff = -1;
                break;
        }
        var highlightSelected = function () {
            for (var i = 0; i < _this.state.itemsList.length; i++) {
                if (_this.state.itemsList[i] === _this.state.selected) {
                    var next = Math.min(_this.state.itemsList.length - 1, Math.max(0, i + diff));
                    _this.select(_this.state.itemsById[_this.state.itemsList[next]]);
                    return;
                }
            }
        };
        var checkRemaining = function () {
            event.preventDefault();
            event.stopPropagation();
            if (_this.state.selected) {
                highlightSelected();
            }
            else {
                _this.select(_this.state.itemsById[_this.state.itemsList[0]]);
            }
        };
        // This function is to bring the selected item (by key press) into view if it is out of container boundary.
        var scrollSelectedItemIfRequired = function (_event, _scope) {
            var container = _scope.viewColumn ? $(document).find('.content-list') : $(_event.currentTarget);
            var selectedItemElem = $(_event.currentTarget.firstChild).children('.list-item-view.active');
            if (selectedItemElem.length > 0) {
                // The following line translated to: top_Of_Selected_Item (minus) top_Of_Scrollable_Div
                var distanceOfSelItemFromVisibleTop = $(selectedItemElem[0]).offset().top - $(document).scrollTop() -
                    $(container[0]).offset().top - $(document).scrollTop();
                // If the selected item goes beyond container view, scroll it to middle.
                if (distanceOfSelItemFromVisibleTop >= container[0].clientHeight ||
                    distanceOfSelItemFromVisibleTop < 0) {
                    container.scrollTop(container.scrollTop() + distanceOfSelItemFromVisibleTop -
                        container[0].offsetHeight * 0.5);
                }
            }
        };
        if (!lodash_1.default.isNil(diff)) {
            checkRemaining();
            scrollSelectedItemIfRequired(event, scope);
        }
    };
    ItemList.prototype.render = function () {
        var _a = this.props, scope = _a.scope, svc = _a.svc;
        var _createItem = function createItem(itemId) {
            var item = this.state.itemsById[itemId];
            var flags = { selected: this.state.selected === itemId };
            return (react_1.default.createElement(components_1.Item, { key: itemId, item: item, view: this.state.view, flags: flags, onSelect: this.select, svc: svc, scope: scope }));
        }.bind(this);
        var isEmpty = !this.state.itemsList.length;
        var cssClass = classnames_1.default(this.state.view === 'photogrid' ?
            'sd-grid-list sd-grid-list--large sd-grid-list--small-margin' :
            (this.state.view || 'compact') + '-view list-view', { 'list-without-items': isEmpty });
        var listItems = isEmpty && !scope.loading ?
            react_1.default.createElement("span", { key: "no-items" }, utils_1.gettext('There are currently no items'))
            : this.state.itemsList.map(_createItem);
        return (react_1.default.createElement("ul", { className: cssClass }, listItems));
    };
    return ItemList;
}(react_1.default.Component));
exports.ItemList = ItemList;
ItemList.propTypes = {
    svc: prop_types_1.default.object.isRequired,
    scope: prop_types_1.default.any.isRequired,
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
/**
 * Contact header - renders header for contact card used in grid view
 */
exports.ContactHeader = function (_a) {
    var item = _a.item;
    var typeTooltip = item.first_name ? utils_1.gettext('Person Contact') : utils_1.gettext('Organisation Contact');
    var contactIcon = item.first_name ?
        react_1.default.createElement("i", { className: "icon-user" }) : react_1.default.createElement("i", { className: "icon-business" });
    return (react_1.default.createElement("div", { className: "contact__type-icon", key: "contact-header", "data-sd-tooltip": item.public ? typeTooltip : typeTooltip + ' ' + utils_1.gettext('(Private)'), "data-flow": "right" }, contactIcon));
};
exports.ContactHeader.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
var fields_1 = __webpack_require__(251);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
/**
 * Media Contact Info - renders contact's information
 */
exports.ContactInfo = function (_a) {
    var item = _a.item, labelInactive = _a.labelInactive;
    var meta = [];
    var info = [];
    var contactJobTitle = item.job_title ? react_1.default.createElement(fields_1.JobTitle, { item: item }) : null;
    var contactOrg = item.first_name && item.organisation ?
        react_1.default.createElement("span", null, item.organisation) : null;
    info.push(react_1.default.createElement("div", { className: "contact-header__container", key: "contact-container" },
        react_1.default.createElement("h3", { key: "contact-name" },
            react_1.default.createElement(fields_1.ContactName, { item: item }),
            contactJobTitle && react_1.default.createElement("span", { title: item.job_title }, contactJobTitle)),
        react_1.default.createElement("div", { key: "contact-org" },
            react_1.default.createElement("span", { className: "item-info" }, contactOrg),
            !item.is_active && labelInactive &&
                react_1.default.createElement("span", { title: "inactive", className: "label label--draft label--hollow pull-right" }, utils_1.gettext('Inactive')))));
    meta.push(react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-1" },
        react_1.default.createElement("span", { key: "2" },
            react_1.default.createElement("i", { key: "2.1", className: "icon-envelope" })),
        react_1.default.createElement("span", { key: "3" }, !lodash_1.isEmpty(item.contact_email) && (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "contact_email" })))));
    meta.push(react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-2" },
        react_1.default.createElement("span", { key: "10" },
            react_1.default.createElement("i", { key: "10.1", className: "icon-globe" })),
        react_1.default.createElement("span", { key: "11" }, item.website && (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "website" })))));
    meta.push(react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-3" },
        react_1.default.createElement("span", { key: "4" },
            react_1.default.createElement("i", { key: "4.1", className: "icon-phone" })),
        react_1.default.createElement("span", { key: "5", className: "dark" }, !lodash_1.isEmpty(item.contact_phone) && lodash_1.findKey(item.contact_phone, 'number') &&
            (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "contact_phone" })))));
    meta.push(react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-4" },
        react_1.default.createElement("span", { key: "mobile-dt" },
            react_1.default.createElement("i", { key: "mobile-icon", className: "icon-mobile" })),
        react_1.default.createElement("span", { key: "mobile-dd", className: "dark" }, !lodash_1.isEmpty(item.mobile) && lodash_1.findKey(item.mobile, 'number') &&
            (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "mobile" })))));
    meta.push(react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-5" },
        react_1.default.createElement("span", { key: "address-dt" },
            react_1.default.createElement("i", { key: "address-link", className: "icon-map-marker" })),
        react_1.default.createElement("span", { key: "address-dd" }, item && (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "location" })))));
    info.push(react_1.default.createElement("ul", { className: "simple-list simple-list--dotted simple-list--no-border-b simple-list--no-padding-b", key: "dl" },
        meta,
        react_1.default.createElement("li", { className: "simple-list__item simple-list__item--with-icon", key: "l-6" },
            react_1.default.createElement("i", { key: "12.1", className: "icon-info-sign" }),
            react_1.default.createElement("span", { key: "12.2" }, item.notes && (react_1.default.createElement(fields_1.Notes, { item: item }))))));
    return (react_1.default.createElement("div", { className: "sd-grid-item__content", "x-ms-format-detection": "none" }, info));
};
exports.ContactInfo.propTypes = {
    item: prop_types_1.default.object,
    labelInactive: prop_types_1.default.bool,
};


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var fields_1 = __webpack_require__(251);
var helpers_1 = __webpack_require__(64);
var classnames_1 = __importDefault(__webpack_require__(4));
var utils_1 = __webpack_require__(3);
/**
 * Contact footer - renders footer for contact card used in grid view
 */
exports.ContactFooter = function (_a) {
    var item = _a.item, svc = _a.svc;
    var cssClass = classnames_1.default('sd-grid-item__footer sd-grid-item__footer--padded', { padded: helpers_1.getContactType(item) === 'organisation' || !item.organisation });
    return (react_1.default.createElement("div", { key: "contact-footer", className: cssClass },
        react_1.default.createElement("span", { className: "update-info" },
            react_1.default.createElement("span", { className: "sd-grid-item__text-label" }, utils_1.gettext('Updated:')),
            react_1.default.createElement(fields_1.VersionCreated, { item: item, svc: svc })),
        react_1.default.createElement(fields_1.SocialInfo, { item: item })));
};
exports.ContactFooter.propTypes = {
    item: prop_types_1.default.object,
    svc: prop_types_1.default.object.isRequired,
};


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var utils_1 = __webpack_require__(3);
exports.ListTypeIcon = function (_a) {
    var item = _a.item;
    var iconClass = item.first_name ? 'icon-user' : 'icon-business';
    var typeTooltip = item.first_name ? utils_1.gettext('Person Contact') : utils_1.gettext('Organisation Contact');
    return (react_1.default.createElement("div", { key: "type-icon", className: "list-field type-icon", "data-sd-tooltip": item.public ? typeTooltip : typeTooltip + ' ' + utils_1.gettext('(Private)'), "data-flow": "right" },
        react_1.default.createElement("i", { className: iconClass })));
};
exports.ListTypeIcon.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
exports.Phone = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("div", { key: "phone-container-" + item._id, className: "container grow" },
        item.contact_phone && react_1.default.createElement("i", { className: "icon-phone" }),
        react_1.default.createElement(components_1.ItemContainer, { field: "contact_phone", item: item })));
};
exports.Phone.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
exports.Email = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("div", { key: "email-container-" + item._id, className: "container" },
        item.contact_email && react_1.default.createElement("i", { key: "email-icon", className: "icon-envelope" }),
        react_1.default.createElement(components_1.ItemContainer, { key: "email", field: "contact_email", item: item })));
};
exports.Email.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
/**
 * Org Name - to display organisation name of user contact
 */
exports.OrgName = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("div", { key: "org-name", className: "container" },
        item.first_name && item.organisation && react_1.default.createElement("i", { className: "icon-business" }),
        item.first_name && item.organisation &&
            react_1.default.createElement("span", null, item.organisation)));
};
exports.OrgName.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
exports.Mobile = function (_a) {
    var item = _a.item;
    return react_1.default.createElement(components_1.ItemContainer, { key: "mobile", field: "mobile", item: item });
};
exports.Mobile.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
var lodash_1 = __webpack_require__(2);
/**
 * ContactLocation - to display address/location of a contact item
 */
exports.ContactLocation = function (_a) {
    var item = _a.item;
    var ADDRESS_FIELDS = ['contact_address', 'locality', 'city', 'contact_state', 'postcode', 'country'];
    var canShow = lodash_1.some(ADDRESS_FIELDS, function (field) { return !lodash_1.isEmpty(item[field]); });
    return (react_1.default.createElement("div", { key: "contact-location", className: "container link" },
        canShow && react_1.default.createElement("i", { className: "icon-map-marker" }),
        canShow &&
            (react_1.default.createElement(components_1.ItemContainer, { item: item, field: "location" }))));
};
exports.ContactLocation.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var components_1 = __webpack_require__(57);
/**
 * SocialInfo - to display facebook, twitter etc. information of a contact
 */
exports.SocialInfo = function (_a) {
    var item = _a.item;
    return (react_1.default.createElement("div", { key: "contact-social", className: "social-info" },
        item.facebook && react_1.default.createElement(components_1.ItemContainer, { item: item, field: "facebook" }),
        item.twitter && react_1.default.createElement(components_1.ItemContainer, { item: item, field: "twitter" })));
};
exports.SocialInfo.propTypes = {
    item: prop_types_1.default.object,
};


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
exports.Row = function (_a) {
    var children = _a.children, flex = _a.flex, noPadding = _a.noPadding, halfWidth = _a.halfWidth, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('form__row', {
            'form__row--flex': flex,
            'form__row--no-padding': noPadding,
            'form__row--half-width': halfWidth,
        }, className) }, children));
};
exports.Row.propTypes = {
    children: prop_types_1.default.node,
    flex: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
    className: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
    ]),
    halfWidth: prop_types_1.default.bool,
};
exports.Row.defaultProps = {
    flex: false,
    noPadding: false,
};


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(63);
var lodash_1 = __webpack_require__(2);
exports.InputArray = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, addButtonText = _a.addButtonText, component = _a.component, defaultValue = _a.defaultValue, readOnly = _a.readOnly, errors = _a.errors, props = __rest(_a, ["field", "value", "onChange", "addButtonText", "component", "defaultValue", "readOnly", "errors"]);
    var add = function () {
        var clonedValue = lodash_1.cloneDeep(value);
        clonedValue.push(lodash_1.cloneDeep(defaultValue));
        onChange(field, clonedValue.slice());
    };
    var remove = function (index) {
        var clonedValue = lodash_1.cloneDeep(value);
        clonedValue.splice(index, 1);
        onChange(field, clonedValue.slice());
    };
    var Component = component;
    return (react_1.default.createElement(_1.Row, null,
        value.map(function (val, index) { return (react_1.default.createElement(Component, __assign({ key: index, field: field + "[" + index + "]", onChange: onChange, value: val, remove: remove.bind(null, index), readOnly: readOnly, errors: errors }, props))); }),
        !readOnly && (react_1.default.createElement("button", { className: "btn btn-small btn--expanded", onClick: add, type: "button" }, addButtonText ? addButtonText : react_1.default.createElement("i", { className: "icon-plus-large" })))));
};
exports.InputArray.propTypes = {
    field: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    value: prop_types_1.default.array,
    onChange: prop_types_1.default.func.isRequired,
    addButtonText: prop_types_1.default.string,
    component: prop_types_1.default.func.isRequired,
    defaultValue: prop_types_1.default.any,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    errors: prop_types_1.default.object,
};
exports.InputArray.defaultProps = {
    value: [],
    defaultValue: {},
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: true,
    errors: {},
};


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
exports.LineInput = function (_a) {
    var children = _a.children, required = _a.required, invalid = _a.invalid, readOnly = _a.readOnly, boxed = _a.boxed, isSelect = _a.isSelect, noMargin = _a.noMargin, noLabel = _a.noLabel, withButton = _a.withButton, labelLeft = _a.labelLeft, labelLeftAuto = _a.labelLeftAuto, hint = _a.hint, message = _a.message, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default('sd-line-input', {
            'sd-line-input--required': required,
            'sd-line-input--invalid': invalid,
            'sd-line-input--disabled': readOnly,
            'sd-line-input--boxed': boxed,
            'sd-line-input--is-select': isSelect,
            'sd-line-input--no-margin': noMargin,
            'sd-line-input--no-label': noLabel,
            'sd-line-input--with-button': withButton,
            'sd-line-input--label-left': labelLeft,
            'sd-line-input--label-left-auto': labelLeftAuto,
        }, className) },
        children,
        hint && react_1.default.createElement("div", { className: "sd-line-input__hint" }, hint),
        message && react_1.default.createElement("div", { className: classnames_1.default('sd-line-input__message', {
                'sd-line-input__message--add-padding': hint,
            }) }, message)));
};
exports.LineInputProps = {
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    isSelect: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    noLabel: prop_types_1.default.bool,
    withButton: prop_types_1.default.bool,
    labelLeft: prop_types_1.default.bool,
    labelLeftAuto: prop_types_1.default.bool,
    hint: prop_types_1.default.string,
    message: prop_types_1.default.string,
};
exports.LineInputDefaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    isSelect: false,
    noMargin: false,
    noLabel: false,
    withButton: false,
    labelLeft: false,
    labelLeftAuto: false,
};
exports.LineInput.propTypes = __assign({ children: prop_types_1.default.node.isRequired, className: prop_types_1.default.string }, exports.LineInputProps);
exports.LineInput.defaultProps = __assign({}, exports.LineInputDefaultProps);


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(63);
var constants_1 = __webpack_require__(43);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var MultiTextInput = /** @class */ (function (_super) {
    __extends(MultiTextInput, _super);
    function MultiTextInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            touched: {},
        };
        _this.onBlur = _this.onBlur.bind(_this);
        _this.isFieldInvalid = _this.isFieldInvalid.bind(_this);
        _this.errorMessage = '';
        return _this;
    }
    MultiTextInput.prototype.onBlur = function (e) {
        var _touched = this.state.touched;
        lodash_1.set(_touched, e.target.name, true);
        this.setState({ touched: _touched });
    };
    MultiTextInput.prototype.isFieldInvalid = function (field, value, errors) {
        this.errorMessage = lodash_1.get(this.state.touched, field, false) &&
            lodash_1.isEmpty(value) ? utils_1.gettext('This field is required.') : lodash_1.get(errors, field, '');
        return !lodash_1.isEmpty(this.errorMessage);
    };
    MultiTextInput.prototype.render = function () {
        var _a = this.props, value = _a.value, field = _a.field, remove = _a.remove, onChange = _a.onChange, label = _a.label, readOnly = _a.readOnly, errors = _a.errors, props = __rest(_a, ["value", "field", "remove", "onChange", "label", "readOnly", "errors"]);
        return (react_1.default.createElement(_1.Row, null,
            react_1.default.createElement(_1.LineInput, __assign({}, props, { readOnly: readOnly, invalid: this.isFieldInvalid(field, value, errors), message: this.errorMessage }),
                label && react_1.default.createElement("label", { className: "sd-line-input__label" }, label),
                react_1.default.createElement(_1.Input, { field: field, value: value, onChange: onChange, onBlur: this.onBlur, type: props.type, readOnly: readOnly }),
                !readOnly &&
                    (react_1.default.createElement("div", null,
                        react_1.default.createElement("a", { tabIndex: 0, className: "icn-btn sd-line-input__icon-right", onClick: remove, onKeyDown: function (event) {
                                if (event && event.keyCode === constants_1.KEYCODES.ENTER) {
                                    event.preventDefault();
                                    remove();
                                }
                            } },
                            react_1.default.createElement("i", { className: "icon-trash" })))))));
    };
    return MultiTextInput;
}(react_1.default.Component));
exports.MultiTextInput = MultiTextInput;
MultiTextInput.propTypes = {
    remove: prop_types_1.default.func,
    field: prop_types_1.default.string,
    type: prop_types_1.default.string,
    value: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    errors: prop_types_1.default.object,
};
MultiTextInput.defaultProps = {
    readOnly: false,
    value: '',
    type: 'text',
};


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
exports.Input = function (_a) {
    var field = _a.field, type = _a.type, value = _a.value, onChange = _a.onChange, placeholder = _a.placeholder, onBlur = _a.onBlur, onClick = _a.onClick, readOnly = _a.readOnly, required = _a.required, refNode = _a.refNode, className = _a.className, autoFocus = _a.autoFocus;
    var onInputChanged = function (e) {
        var data = e.target.value;
        if (type === 'file') {
            data = e.target.files;
        }
        onChange(field, data, e);
    };
    return (react_1.default.createElement("input", { className: className ? "sd-line-input__input " + className : 'sd-line-input__input', type: type, name: field, value: value, placeholder: placeholder, onChange: onInputChanged, onBlur: onBlur, onClick: onClick, disabled: readOnly, required: required, ref: refNode, autoFocus: autoFocus }));
};
exports.Input.propTypes = {
    field: prop_types_1.default.string,
    type: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
        prop_types_1.default.bool,
    ]),
    onChange: prop_types_1.default.func.isRequired,
    onBlur: prop_types_1.default.func,
    onClick: prop_types_1.default.func,
    placeholder: prop_types_1.default.string,
    readOnly: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    refNode: prop_types_1.default.func,
    className: prop_types_1.default.string,
    autoFocus: prop_types_1.default.bool,
};
exports.Input.defaultProps = {
    type: 'text',
    readOnly: false,
    required: false,
};


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(63);
var lodash_1 = __webpack_require__(2);
exports.SelectInput = function (_a) {
    var field = _a.field, label = _a.label, value = _a.value, options = _a.options, keyField = _a.keyField, labelField = _a.labelField, onChange = _a.onChange, readOnly = _a.readOnly, clearable = _a.clearable, props = __rest(_a, ["field", "label", "value", "options", "keyField", "labelField", "onChange", "readOnly", "clearable"]);
    var getKey = function () {
        var _key = '';
        if (clearable) {
            if (lodash_1.isObject(value)) {
                _key = lodash_1.get(value, keyField, '');
            }
            else {
                _key = value;
            }
        }
        else {
            _key = lodash_1.get(value, keyField, lodash_1.get(options, "[0]." + keyField));
        }
        return _key;
    };
    var key = getKey();
    var opts = options.map(function (opt) { return ({
        key: lodash_1.get(opt, keyField),
        label: lodash_1.get(opt, labelField),
    }); });
    var onChangeHandler = function (_field, _key) {
        var _value = options.find(function (option) { return lodash_1.get(option, keyField) === _key; }) || null;
        onChange(_field, lodash_1.get(_value, keyField, ''));
    };
    return (react_1.default.createElement(_1.LineInput, __assign({}, props, { isSelect: true, readOnly: readOnly }),
        label && react_1.default.createElement(_1.Label, { text: label }),
        react_1.default.createElement(_1.Select, { field: field, value: key, onChange: onChangeHandler, options: opts, readOnly: readOnly, clearable: clearable })));
};
exports.SelectInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.object,
    ]),
    onChange: prop_types_1.default.func.isRequired,
    required: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    boxed: prop_types_1.default.bool,
    noMargin: prop_types_1.default.bool,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.string,
        label: prop_types_1.default.string,
        value: prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.object,
            prop_types_1.default.number,
        ]),
    })).isRequired,
    keyField: prop_types_1.default.string,
    labelField: prop_types_1.default.string,
    clearable: prop_types_1.default.bool,
};
exports.SelectInput.defaultProps = {
    required: false,
    invalid: false,
    readOnly: false,
    boxed: false,
    noMargin: false,
    keyField: 'qcode',
    labelField: 'label',
    clearable: false,
};


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
exports.Select = function (_a) {
    var field = _a.field, value = _a.value, onChange = _a.onChange, options = _a.options, readOnly = _a.readOnly, clearable = _a.clearable;
    return (react_1.default.createElement("select", { className: classnames_1.default('sd-line-input__select'), value: value, onChange: function (e) { return onChange(field, e.target.value); }, name: field, disabled: readOnly },
        clearable && (react_1.default.createElement("option", { value: "" })),
        options.map(function (opt, index) { return (react_1.default.createElement("option", { key: opt.key || index, value: opt.key }, opt.label)); })));
};
exports.Select.propTypes = {
    field: prop_types_1.default.string,
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
    ]),
    onChange: prop_types_1.default.func.isRequired,
    options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.number,
        ]),
        label: prop_types_1.default.string,
    })),
    readOnly: prop_types_1.default.bool,
    clearable: prop_types_1.default.bool,
};
exports.Select.defaultProps = {
    readOnly: false,
    clearable: false,
};


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
exports.Label = function (_a) {
    var text = _a.text, row = _a.row, light = _a.light, className = _a.className;
    return (!text ? null : (react_1.default.createElement("label", { className: classnames_1.default({
            'sd-line-input__label': !row,
            'form-label': row,
            'form-label--light': row && light,
        }, className) }, text)));
};
exports.Label.propTypes = {
    text: prop_types_1.default.string,
    row: prop_types_1.default.bool,
    light: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.Label.defaultProps = {
    row: false,
    light: false,
};


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(43);
exports.Toggle = function (_a) {
    var value = _a.value, onChange = _a.onChange, readOnly = _a.readOnly, className = _a.className;
    var onClick = function () { return onChange({ target: { value: !value } }); };
    var handleKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                case constants_1.KEYCODES.SPACE:
                    event.preventDefault();
                    onClick();
                    break;
                default:
                    break;
            }
        }
    };
    var classes = classnames_1.default('sd-toggle', 'sd-line-input__input', {
        checked: value,
        disabled: readOnly,
    }, className);
    return (react_1.default.createElement("span", { tabIndex: 0, onKeyDown: handleKeyDown, className: classes, onClick: !readOnly && onChange ? onClick : null },
        react_1.default.createElement("span", { className: "inner" })));
};
exports.Toggle.propTypes = {
    value: prop_types_1.default.bool,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    className: prop_types_1.default.string,
};
exports.Toggle.defaultProps = {
    value: false,
    readOnly: false,
};


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var constants_1 = __webpack_require__(43);
var helpers_1 = __webpack_require__(64);
var ToggleBox = /** @class */ (function (_super) {
    __extends(ToggleBox, _super);
    function ToggleBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isOpen: _this.props.isOpen };
        _this.scrollInView = _this.scrollInView.bind(_this);
        _this.toggle = _this.toggle.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.dom = { node: null };
        return _this;
    }
    ToggleBox.prototype.handleKeyDown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.RIGHT && !this.state.isOpen) {
            helpers_1.onEventCapture();
            this.setState({ isOpen: true });
        }
        else if (event.keyCode === constants_1.KEYCODES.LEFT && this.state.isOpen) {
            helpers_1.onEventCapture();
            this.setState({ isOpen: false });
        }
    };
    ToggleBox.prototype.toggle = function () {
        this.setState({ isOpen: !this.state.isOpen });
    };
    ToggleBox.prototype.scrollInView = function () {
        if (this.state.isOpen && this.dom.node) {
            this.dom.node.scrollIntoView();
        }
    };
    ToggleBox.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Scroll into view only upon first opening
        if (prevState.isOpen !== this.state.isOpen &&
            this.state.isOpen &&
            this.props.scrollInView) {
            this.scrollInView();
        }
    };
    ToggleBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, title = _a.title, children = _a.children, hideUsingCSS = _a.hideUsingCSS;
        return (react_1.default.createElement("div", { className: classnames_1.default('toggle-box toggle-box--circle', style, { hidden: !this.state.isOpen }), ref: function (node) { return _this.dom.node = node; } },
            react_1.default.createElement("div", { className: "toggle-box__header", tabIndex: 0, onClick: this.toggle, onKeyDown: this.handleKeyDown },
                react_1.default.createElement("div", { className: "toggle-box__chevron" },
                    react_1.default.createElement("i", { className: "icon-chevron-right-thin" })),
                react_1.default.createElement("div", { className: "toggle-box__label" }, title),
                react_1.default.createElement("div", { className: "toggle-box__line" })),
            react_1.default.createElement("div", { className: "toggle-box__content-wraper" },
                this.state.isOpen && !hideUsingCSS && (react_1.default.createElement("div", { className: "toggle-box__content" }, children)),
                hideUsingCSS && (react_1.default.createElement("div", { className: classnames_1.default('toggle-box__content', { 'toggle-box__content--hidden': !this.state.isOpen }) }, children)))));
    };
    return ToggleBox;
}(react_1.default.Component));
exports.ToggleBox = ToggleBox;
ToggleBox.propTypes = {
    style: prop_types_1.default.string,
    isOpen: prop_types_1.default.bool,
    title: prop_types_1.default.string.isRequired,
    children: prop_types_1.default.node,
    scrollInView: prop_types_1.default.bool,
    hideUsingCSS: prop_types_1.default.bool,
};
ToggleBox.defaultProps = {
    isOpen: true,
    scrollInView: false,
    hideUsingCSS: false,
};


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var _1 = __webpack_require__(63);
var constants_1 = __webpack_require__(43);
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var ContactNumberInput = /** @class */ (function (_super) {
    __extends(ContactNumberInput, _super);
    function ContactNumberInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            preventSwitch: false,
            touched: {},
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.isFieldInvalid = _this.isFieldInvalid.bind(_this);
        return _this;
    }
    ContactNumberInput.prototype.onBlur = function (e) {
        var _touched = this.state.touched;
        lodash_1.set(_touched, e.target.name, true);
        this.setState({ touched: _touched });
    };
    ContactNumberInput.prototype.isFieldInvalid = function (field, value) {
        return lodash_1.get(this.state.touched, field, false) && lodash_1.isEmpty(value);
    };
    ContactNumberInput.prototype.onChange = function (field, value) {
        // Turn off and prevent public switch for confidential contact number
        if (value === 'Confidential') {
            this.props.value.public = false;
            this.setState({ preventSwitch: true });
        }
        else {
            this.setState({ preventSwitch: false });
        }
        this.props.onChange(field, value);
    };
    ContactNumberInput.prototype.render = function () {
        var _a = this.props, value = _a.value, field = _a.field, remove = _a.remove, onChange = _a.onChange, readOnly = _a.readOnly, usages = _a.usages;
        return (react_1.default.createElement(_1.Row, { flex: true },
            react_1.default.createElement(_1.LineInput, { readOnly: readOnly, invalid: this.isFieldInvalid(field + ".number", value.number), message: this.isFieldInvalid(field + ".number", value.number) ?
                    utils_1.gettext('This field is required.') : '' },
                react_1.default.createElement(_1.Label, { text: utils_1.gettext('Number') }),
                react_1.default.createElement(_1.Input, { field: field + ".number", value: lodash_1.get(value, 'number', ''), onChange: onChange, onBlur: this.onBlur, type: "text", readOnly: readOnly })),
            react_1.default.createElement(_1.LineInput, { readOnly: readOnly, className: "sd-line-input__usage" },
                react_1.default.createElement(_1.Label, { text: utils_1.gettext('usage') }),
                react_1.default.createElement(_1.SelectInput, { noMargin: true, field: field + ".usage", value: lodash_1.get(value, 'usage', ''), onChange: this.onChange, options: usages, labelField: "qcode", keyField: "qcode", clearable: true })),
            react_1.default.createElement(_1.LineInput, { readOnly: readOnly, className: "sd-line-input__usage-flag" },
                react_1.default.createElement(_1.Label, { text: utils_1.gettext('public') }),
                react_1.default.createElement(_1.Toggle, { value: lodash_1.get(value, 'public', true), onChange: function (e) { return onChange(field + ".public", e.target.value); }, readOnly: readOnly || this.state.preventSwitch })),
            react_1.default.createElement(_1.LineInput, { readOnly: readOnly }, !readOnly &&
                (react_1.default.createElement("a", { tabIndex: 0, className: "icn-btn sd-line-input__icon", onClick: remove, onKeyDown: function (event) {
                        if (event && event.keyCode === constants_1.KEYCODES.ENTER) {
                            event.preventDefault();
                            remove();
                        }
                    } },
                    react_1.default.createElement("i", { className: "icon-trash" }))))));
    };
    return ContactNumberInput;
}(react_1.default.Component));
exports.ContactNumberInput = ContactNumberInput;
ContactNumberInput.propTypes = {
    remove: prop_types_1.default.func,
    field: prop_types_1.default.string,
    value: prop_types_1.default.object,
    label: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    readOnly: prop_types_1.default.bool,
    usages: prop_types_1.default.array,
};
ContactNumberInput.defaultProps = {
    readOnly: false,
};


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_debounce_input_1 = __webpack_require__(223);
var __1 = __webpack_require__(63);
var SelectFieldPopup_1 = __webpack_require__(2109);
var lodash_1 = __webpack_require__(2);
var SelectFieldSearchInput = /** @class */ (function (_super) {
    __extends(SelectFieldSearchInput, _super);
    function SelectFieldSearchInput(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            filteredDataList: _this.props.dataList,
            searchText: '',
            openFilterList: false,
            search: false,
        };
        _this.openPopup = _this.openPopup.bind(_this);
        _this.closePopup = _this.closePopup.bind(_this);
        _this.filterDataList = _this.filterDataList.bind(_this);
        _this.onItemChange = _this.onItemChange.bind(_this);
        return _this;
    }
    SelectFieldSearchInput.prototype.openPopup = function () {
        this.setState({ openFilterList: true });
    };
    SelectFieldSearchInput.prototype.closePopup = function () {
        this.setState({ openFilterList: false });
    };
    SelectFieldSearchInput.prototype.filterDataList = function (event) {
        var _a = this.props, dataList = _a.dataList, onChange = _a.onChange, querySearch = _a.querySearch, onQuerySearch = _a.onQuerySearch;
        var value = event.target.value;
        var filterTextNoCase = value ? value.toLowerCase() : '';
        if (querySearch) {
            onQuerySearch(filterTextNoCase);
            this.setState({
                searchText: value,
                openFilterList: !lodash_1.isEmpty(value),
            }, onChange(this.props.field, value));
        }
        else {
            if (!value) {
                this.setState({
                    filteredDataList: dataList,
                    searchText: '',
                    openFilterList: false,
                }, onChange(this.props.field, value));
                return;
            }
            var newDataList = dataList.filter(function (fieldItem) { return (fieldItem.toLowerCase().substr(0, value.length) === filterTextNoCase ||
                fieldItem.toLowerCase().indexOf(filterTextNoCase) >= 0); });
            this.setState({
                filteredDataList: newDataList,
                searchText: value,
                openFilterList: true,
            }, onChange(this.props.field, value));
        }
    };
    SelectFieldSearchInput.prototype.onItemChange = function (inputItem) {
        this.props.onChange(this.props.field, inputItem);
        this.setState({
            openFilterList: false,
            searchText: inputItem,
        });
    };
    SelectFieldSearchInput.prototype.render = function () {
        var _a = this.props, value = _a.value, dataList = _a.dataList, label = _a.label, readOnly = _a.readOnly, querySearch = _a.querySearch, initValue = _a.initValue;
        var listData = querySearch ? dataList : this.state.filteredDataList;
        var inputValue = initValue ? value : this.state.searchText || value || '';
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(__1.Row, { noPadding: true },
                react_1.default.createElement(__1.LineInput, { noMargin: true },
                    react_1.default.createElement(__1.Label, { text: label }))),
            !readOnly && react_1.default.createElement(__1.Row, { noPadding: true },
                react_1.default.createElement(__1.LineInput, { isSelect: false, noLabel: !!value },
                    react_1.default.createElement(react_debounce_input_1.DebounceInput, { value: inputValue, className: "sd-line-input__input", minLength: 1, debounceTimeout: 500, onChange: this.filterDataList, placeholder: "Search" }),
                    this.state.openFilterList && (react_1.default.createElement(SelectFieldPopup_1.SelectFieldPopup, { onClose: this.closePopup, target: "sd-line-input__input", dataList: listData, onChange: this.onItemChange }))))));
    };
    return SelectFieldSearchInput;
}(react_1.default.Component));
exports.SelectFieldSearchInput = SelectFieldSearchInput;
SelectFieldSearchInput.propTypes = {
    field: prop_types_1.default.string,
    label: prop_types_1.default.string,
    value: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    dataList: prop_types_1.default.array,
    readOnly: prop_types_1.default.bool,
    querySearch: prop_types_1.default.bool,
    onQuerySearch: prop_types_1.default.func,
    initValue: prop_types_1.default.bool,
};
SelectFieldSearchInput.defaultProps = {
    querySearch: false,
};


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var lodash_1 = __webpack_require__(2);
var Popup_1 = __webpack_require__(2110);
var constants_1 = __webpack_require__(43);
var helpers_1 = __webpack_require__(64);
__webpack_require__(2117);
var SelectFieldPopup = /** @class */ (function (_super) {
    __extends(SelectFieldPopup, _super);
    function SelectFieldPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        _this.state = { activeIndex: -1 };
        _this.dom = { itemList: null };
        return _this;
    }
    SelectFieldPopup.prototype.onKeyDown = function (event) {
        if (event) {
            switch (event.keyCode) {
                case constants_1.KEYCODES.ENTER:
                    helpers_1.onEventCapture(event);
                    this.handleEnterKey(event);
                    break;
                case constants_1.KEYCODES.DOWN:
                    helpers_1.onEventCapture(event);
                    this.handleDownArrowKey(event);
                    break;
                case constants_1.KEYCODES.UP:
                    helpers_1.onEventCapture(event);
                    this.handleUpArrowKey(event);
                    break;
            }
        }
    };
    SelectFieldPopup.prototype.handleEnterKey = function (event) {
        this.props.onChange(this.props.dataList[this.state.activeIndex]);
    };
    SelectFieldPopup.prototype.handleDownArrowKey = function (event) {
        if (lodash_1.get(this.props, 'dataList.length', 0) > this.state.activeIndex) {
            this.setState({ activeIndex: this.state.activeIndex + 1 });
            helpers_1.scrollListItemIfNeeded(this.state.activeIndex, this.dom.itemList);
        }
    };
    SelectFieldPopup.prototype.handleUpArrowKey = function (event) {
        if (this.state.activeIndex > 0) {
            this.setState({ activeIndex: this.state.activeIndex - 1 });
            helpers_1.scrollListItemIfNeeded(this.state.activeIndex, this.dom.itemList);
        }
    };
    SelectFieldPopup.prototype.handleOnChange = function (item, event) {
        helpers_1.onEventCapture(event);
        this.props.onChange(item);
    };
    SelectFieldPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, target = _a.target, dataList = _a.dataList;
        return (react_1.default.createElement(Popup_1.Popup, { close: onClose, target: target, onKeyDown: this.onKeyDown, inheritWidth: true, noPadding: true },
            react_1.default.createElement("div", { className: "field-search__popup" },
                react_1.default.createElement("ul", { className: "field-search__popup-list", ref: function (ref) { return _this.dom.itemList = ref; } }, dataList && dataList.length > 0 && dataList.map(function (fieldItem, index) { return (react_1.default.createElement("li", { key: index, className: classnames_1.default('field-search__popup-item', { 'field-search__popup-item--active': index === _this.state.activeIndex }) },
                    react_1.default.createElement("button", { type: "button", onClick: _this.handleOnChange.bind(null, fieldItem) },
                        react_1.default.createElement("div", { className: "field-search__popup-item-label" }, fieldItem)))); })))));
    };
    return SelectFieldPopup;
}(react_1.default.Component));
exports.SelectFieldPopup = SelectFieldPopup;
SelectFieldPopup.propTypes = {
    onClose: prop_types_1.default.func,
    target: prop_types_1.default.string,
    dataList: prop_types_1.default.array,
    onChange: prop_types_1.default.func,
};


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Content_1 = __importDefault(__webpack_require__(2111));
exports.Content = Content_1.default;
var Footer_1 = __importDefault(__webpack_require__(2112));
exports.Footer = Footer_1.default;
var Header_1 = __importDefault(__webpack_require__(2113));
exports.Header = Header_1.default;
var Label_1 = __importDefault(__webpack_require__(583));
exports.Label = Label_1.default;
var Menu_1 = __importDefault(__webpack_require__(584));
exports.Menu = Menu_1.default;
var Popup_1 = __importDefault(__webpack_require__(2114));
exports.Popup = Popup_1.default;


/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Content = function (_a) {
    var children = _a.children, className = _a.className, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-content', { 'popup__menu-content--no-padding': noPadding }, className) }, children));
};
Content.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noPadding: prop_types_1.default.bool,
};
Content.defaultProps = { noPadding: false };
exports.default = Content;


/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Footer = function (_a) {
    var children = _a.children, className = _a.className, noBorder = _a.noBorder, noPadding = _a.noPadding;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-footer', {
            'popup__menu-footer--no-border': noBorder,
            'popup__menu-footer--no-padding': noPadding,
        }, className) }, children));
};
Footer.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noBorder: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
};
exports.default = Footer;


/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var classnames_1 = __importDefault(__webpack_require__(4));
var Label_1 = __importDefault(__webpack_require__(583));
var Header = function (_a) {
    var text = _a.text, onClose = _a.onClose, children = _a.children, className = _a.className, noBorder = _a.noBorder, noPadding = _a.noPadding, centerText = _a.centerText;
    return (react_1.default.createElement("div", { className: classnames_1.default('popup__menu-header', {
            'popup__menu-header--no-border': noBorder,
            'popup__menu-header--no-padding': noPadding,
        }, className) },
        text && (react_1.default.createElement(Label_1.default, { text: text, centerText: centerText }, onClose && (react_1.default.createElement("button", { className: "popup__menu-close", onClick: onClose },
            react_1.default.createElement("i", { className: "icon-close-small" }))))),
        children));
};
Header.propTypes = {
    text: prop_types_1.default.string,
    onClose: prop_types_1.default.func,
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    noBorder: prop_types_1.default.bool,
    noPadding: prop_types_1.default.bool,
    centerText: prop_types_1.default.bool,
};
exports.default = Header;


/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var prop_types_1 = __importDefault(__webpack_require__(1));
var react_portal_1 = __webpack_require__(437);
var constants_1 = __webpack_require__(43);
var Menu_1 = __importDefault(__webpack_require__(584));
__webpack_require__(2115);
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.setPortalNodes = _this.setPortalNodes.bind(_this);
        _this.setParentNode = _this.setParentNode.bind(_this);
        _this.dom = {
            portal: null,
            child: null,
            root: null,
            parent: null,
        };
        return _this;
    }
    Popup.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.handleKeydown);
        document.addEventListener('click', this.handleClickOutside);
        if (this.dom.root) {
            // First render it somewhere not visible
            this.dom.root.style.zIndex = -1;
            // Make sure it's rendered
            this.dom.child.style.display = 'block';
            if (this.props.inheritWidth) {
                this.dom.child.style.width = this.dom.parent.getBoundingClientRect().width + 'px';
            }
            var _a = this.dom.child.getBoundingClientRect(), width = _a.width, height = _a.height;
            var ACTION_MENU_FROM_TOP = 100; // top-menu + search bar
            var MENU_MARGIN_HEIGHT = 16;
            var LEFT_BAR_WIDTH = 48;
            var BOTTOM_BAR_HEIGHT = 30;
            var BUFFER = 5;
            // Get target position
            var target = this.dom.parent.getElementsByClassName(this.props.target)[0];
            var targetRect = target.getBoundingClientRect();
            // Get the workspace
            var workspace = document.getElementById(this.props.workspaceId) || document.body;
            // Compute menu position
            var top = targetRect.top + targetRect.height;
            var left = targetRect.left + targetRect.width - width;
            // Menu goes off on the right side
            if (left + width + BUFFER > workspace.clientWidth) {
                left -= width;
                left += targetRect.width;
            }
            // Menu goes off on the left side
            if (left - LEFT_BAR_WIDTH < 0) {
                left = targetRect.left;
            }
            // Menu goes out on the bottom side
            if (top + height + BOTTOM_BAR_HEIGHT + BUFFER > workspace.clientHeight) {
                top -= height;
                top -= targetRect.height;
                top -= MENU_MARGIN_HEIGHT;
                top = top < ACTION_MENU_FROM_TOP ? ACTION_MENU_FROM_TOP : top;
            }
            this.dom.child.style.top = top.toFixed() + 'px';
            this.dom.child.style.left = left.toFixed() + 'px';
            this.dom.child.style.position = 'absolute';
            this.dom.child.style.zIndex = 2100;
            this.dom.root.style.zIndex = 2000;
            this.dom.root.style.position = 'fixed';
            this.dom.root.style.top = 0;
            this.dom.root.style.left = 0;
        }
    };
    Popup.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleClickOutside);
    };
    Popup.prototype.handleClickOutside = function (event) {
        if (!this.dom.root || this.dom.root.contains(event.target) || !document.contains(event.target)) {
            return;
        }
        this.props.close();
    };
    Popup.prototype.handleKeydown = function (event) {
        if (event.keyCode === constants_1.KEYCODES.ESCAPE) {
            event.preventDefault();
            this.props.close();
        }
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
    };
    Popup.prototype.setParentNode = function (node) {
        if (node && node.parentNode) {
            this.dom.parent = node.parentNode;
        }
        else {
            this.dom.parent = null;
        }
    };
    Popup.prototype.setPortalNodes = function (node) {
        this.dom.portal = node;
        if (this.dom.portal) {
            this.dom.root = this.dom.portal.defaultNode || this.dom.portal.props.node;
        }
        else {
            this.dom.root = this.dom.child = null;
        }
    };
    Popup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, noPadding = _a.noPadding, popupContainer = _a.popupContainer;
        return (react_1.default.createElement("div", { ref: this.setParentNode },
            react_1.default.createElement(react_portal_1.Portal, { ref: this.setPortalNodes, node: popupContainer && popupContainer() },
                react_1.default.createElement("div", { ref: function (node) { return _this.dom.child = node; }, className: className ? "popup " + className : 'popup' },
                    react_1.default.createElement(Menu_1.default, { noPadding: noPadding }, children)))));
    };
    return Popup;
}(react_1.default.Component));
exports.default = Popup;
Popup.propTypes = {
    children: prop_types_1.default.node.isRequired,
    target: prop_types_1.default.string.isRequired,
    close: prop_types_1.default.func.isRequired,
    onKeyDown: prop_types_1.default.func,
    workspaceId: prop_types_1.default.string,
    className: prop_types_1.default.string,
    noPadding: prop_types_1.default.bool,
    popupContainer: prop_types_1.default.func,
    inheritWidth: prop_types_1.default.bool,
};
Popup.defaultProps = {
    workspaceId: 'main-container',
    noPadding: false,
    inheritWidth: false,
};


/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2116);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../css-loader/index.js!../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.popup__menu {\n  z-index: 1000;\n  min-width: 100px;\n  padding-top: 1rem;\n  margin: 0;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.4), 0 3px 1px -2px rgba(0, 0, 0, 0.1);\n  border-radius: 2px;\n  text-align: left; }\n  .popup__menu--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-divider {\n  height: 1px;\n  margin: 0.8rem 0;\n  overflow: hidden;\n  background-color: #e5e5e5; }\n\n.popup__menu-label {\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  color: #999;\n  font-weight: 500;\n  padding-left: 1.6rem;\n  margin-bottom: .6rem; }\n  .popup__menu-label .popup__menu-close {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    width: auto;\n    opacity: .3;\n    background-color: transparent;\n    cursor: pointer; }\n    .popup__menu-label .popup__menu-close i {\n      margin-right: 0 !important; }\n    .popup__menu-label .popup__menu-close:hover, .popup__menu-label .popup__menu-close:focus {\n      background-color: transparent;\n      opacity: 1; }\n  .popup__menu-label--center {\n    padding-left: 0;\n    text-align: center;\n    display: inline-block;\n    width: 100%; }\n\n.popup__menu-header {\n  font-weight: 300;\n  font-size: 1.5rem;\n  color: #999;\n  padding: 1rem 1rem 0 1rem;\n  border-bottom: 1px solid #e5e5e5; }\n  .popup__menu-header--no-border {\n    border-bottom: none; }\n  .popup__menu-header--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-footer {\n  padding: 1rem;\n  margin-top: 0.6rem;\n  border-top: 1px solid #e5e5e5;\n  display: inline-block;\n  width: 100%; }\n  .popup__menu-footer--no-border {\n    border-top: none; }\n  .popup__menu-footer--no-padding {\n    padding: 0 !important; }\n\n.popup__menu-content {\n  padding: 1rem;\n  min-width: 100px; }\n  .popup__menu-content--no-padding {\n    padding: 0 !important; }\n", ""]);

// exports


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2118);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss", function() {
		var newContent = require("!!../../../../../../../css-loader/index.js!../../../../../../../sass-loader/lib/loader.js!./style.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n.field-search__popup {\n  margin-top: 1px; }\n  .field-search__popup-list {\n    overflow-y: scroll;\n    max-height: 250px; }\n    .field-search__popup-list li {\n      margin: 5px 0; }\n  .field-search__popup-item {\n    margin: 5px;\n    padding: .3rem .8rem; }\n    .field-search__popup-item:hover {\n      background: #eff7fa; }\n    .field-search__popup-item--active {\n      background: #eff7fa; }\n  .field-search__popup-item-label {\n    padding-top: 5px;\n    display: inline-block;\n    width: 200px;\n    text-align: left; }\n", ""]);

// exports


/***/ }),
/* 2119 */
/***/ (function(module, exports) {

module.exports = "<div id=\"contacts-search-panel\">\n    <div class=\"header\">\n        <ul>\n            <li translate>Search</li>\n        </ul>\n        <div class=\"doopen\" ng-click=\"openAdvanceSearch = !openAdvanceSearch\">\n            <i class=\"icon-close-small\"></i>\n        </div>\n    </div>\n    <div class=\"nav-tabs__content content\">\n        <div class=\"nav-tabs__pane\">\n            <form>\n                <fieldset class=\"search-parameters\">\n                    <div class=\"field multiple\">\n                        <div class=\"field\">\n                            <label for=\"search-fname\" translate>First Name</label>\n                            <div class=\"control\">\n                                <input type=\"text\" ng-keypress=\"keyPressed($event)\" id=\"search-fname\"\n                                    ng-model=\"meta.first_name\">\n                            </div>\n                        </div>\n\n                        <div class=\"field\">\n                            <label for=\"search-lname\" translate>Last Name</label>\n                            <div class=\"control\">\n                                <input type=\"text\" id=\"search-lname\" ng-keypress=\"keyPressed($event)\"\n                                    ng-model=\"meta.last_name\">\n                            </div>\n                        </div>\n                    </div>\n                    <div id=\"org-field\"></div>\n                    <div class=\"field\">\n                        <label for=\"search-job_title\" translate>Job Title</label>\n                        <select ng-model=\"meta.job_title\"\n                                name=\"job_title\"\n                                id=\"job_title\"\n                                ng-options=\"job.name as job.name for job in metadata.contact_job_titles | orderBy:'name'\">\n                        </select>\n                    </div>\n                    <div class=\"field\">\n                        <label for=\"search-postcode\" translate>Email</label>\n                        <div class=\"control\">\n                            <input type=\"text\" id=\"search-email\" ng-keypress=\"keyPressed($event)\"\n                                ng-model=\"meta.contact_email\">\n                        </div>\n                    </div>\n                    <div class=\"field\">\n                        <label for=\"search-postcode\" translate>Post Code</label>\n                        <div class=\"control\">\n                            <input type=\"text\" id=\"search-postcode\" ng-keypress=\"keyPressed($event)\"\n                                ng-model=\"meta.postcode\">\n                        </div>\n                    </div>\n                    <div class=\"field\">\n                        <label for=\"search-city\" translate>City</label>\n                        <div class=\"control\">\n                            <input type=\"text\" id=\"search-city\" ng-keypress=\"keyPressed($event)\"\n                                ng-model=\"meta.city\">\n                        </div>\n                    </div>\n                    <div class=\"field\">\n                        <label for=\"search-state\" translate>State</label>\n                        <div class=\"control\">\n                            <input type=\"text\" id=\"search-state\" ng-keypress=\"keyPressed($event)\"\n                                ng-model=\"meta.contact_state\">\n                        </div>\n                    </div>\n                    <div class=\"field\">\n                        <label for=\"search-country\" translate>Country</label>\n                        <div class=\"control\">\n                            <input type=\"text\" id=\"search-country\" ng-keypress=\"keyPressed($event)\"\n                                ng-model=\"meta.country\">\n                        </div>\n                    </div>\n                </fieldset>\n            </form>\n        </div>\n    </div>\n   <div class=\"float-search-btn\">\n        <a id=\"clear_filters\" class=\"save-search__link\" ng-click=\"clear()\" translate>Clear filters</a>\n        <button class=\"btn btn--primary btn--full searchItemsch\" ng-click=\"searchItems()\" translate>Search</button>\n   </div>\n</div>\n";

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(__webpack_require__(2));
var constants_1 = __webpack_require__(43);
var utils_1 = __webpack_require__(3);
var LinkFunction = /** @class */ (function () {
    function LinkFunction(contacts, search, notify, $location, $timeout, scope, elem) {
        var _this = this;
        this.scope = scope;
        this.elem = elem;
        this.containerElem = elem.find('.contacts-list__holder');
        this.notify = notify;
        this.$location = $location;
        this.$timeout = $timeout;
        this.contacts = contacts;
        this.search = search;
        this.criteria = this.contacts.getCriteria();
        this.queryItems();
        this.scope.fetchNext = this.fetchNext.bind(this);
        this.scope.refreshList = this.refreshList.bind(this);
        this.scope.$watch(function () { return lodash_1.default.omit(_this.$location.search(), '_id'); }, function (newValue, oldValue) {
            if (newValue !== oldValue && _this.$location.path() === '/contacts') {
                _this.scope.refreshList({ force: true });
            }
        }, true);
        angular.forEach(['refresh:list'], function (evt) {
            _this.scope.$on(evt, function (event) {
                _this.scope.refreshList({ force: true });
            });
        });
        this.scope.$on('contacts:update', this.scope.refreshList);
        this.scope.$on('contacts:create', this.scope.refreshList);
        this.scope.urlParams = constants_1.URL_PARAMETERS;
    }
    /**
     * @ngdoc method
     * @name sdContactsSearchResults#refreshList
     * @public
     * @description Refresh the search results
     */
    LinkFunction.prototype.refreshList = function (data) {
        var _this = this;
        this.$timeout(function () {
            _this.queryItems(null, data);
        }, 800, false);
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchResults#queryItems
     * @public
     * @description Function for fetching the items.
     * @return {promise}
     */
    LinkFunction.prototype.queryItems = function (event, data) {
        var _this = this;
        this.criteria = this.contacts.getCriteria();
        if (!(data && data.force) && this.scope.items && this.scope.items._items.length > this.criteria.max_results) {
            this.criteria.max_results = this.scope.items._items.length;
        }
        return this.contacts.query(this.criteria).then(function (items) {
            _this.scope.$applyAsync(function () {
                _this.render(items, null, data && data.force);
            });
        }, function (error) {
            _this.notify.error(utils_1.gettext('Failed to run the query!'));
        })
            .finally(function () {
            _this.scope.loading = false;
            // update scroll position to top, when forced refresh
            if (data && data.force) {
                _this.containerElem[0].scrollTop = 0;
            }
        });
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchResults#fetchNext
     * @public
     * @description Function for fetching next page
     */
    LinkFunction.prototype.fetchNext = function () {
        this.render(null, true);
    };
    /**
     * @ngdoc method
     * @name sdContactsSearchResults#render
     * @public
     * @param {Array<object>} items - Array of items to display.
     * @param {boolean} next - true then fetch next page and update the existing list of items.
     * @param {boolean} force - initialize and refresh the list to display.
     * @description Fetch the items from backend and display the items.
     */
    LinkFunction.prototype.render = function (items, next, force) {
        var _this = this;
        this.scope.loading = true;
        var setScopeItems = function (_items, _force) {
            _this.scope.items = _this.search.mergeItems(_items, _this.scope.items, next, _force);
            _this.scope.total = _items._meta.total;
            _this.scope.loading = false;
        };
        if (items) {
            setScopeItems(items, force);
        }
        else if (next) {
            this.scope.loading = true;
            this.criteria.page = (this.criteria.page || 0) + 1;
            this.contacts.query(this.criteria)
                .then(setScopeItems)
                .finally(function () {
                _this.scope.loading = false;
            });
        }
    };
    return LinkFunction;
}());
/**
 * @ngdoc directive
 * @module superdesk.apps.contacts
 * @name sdContactsSearchResults
 * @requires Contacts service
 * @requires search
 * @requires notify
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @description sd-contacts-search-results displays the search based on the change to the route.
 */
function ContactsSearchResultsDirective(contacts, search, notify, $location, $timeout) {
    return {
        template: __webpack_require__(2121),
        link: function (scope, elem) { return new LinkFunction(contacts, search, notify, $location, $timeout, scope, elem); },
    };
}
exports.ContactsSearchResultsDirective = ContactsSearchResultsDirective;
ContactsSearchResultsDirective.$inject = ['contacts', 'search', 'notify', '$location', '$timeout'];


/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports = "<div class=\"preview-layout\" ng-class=\"{closed: !selected.preview}\" ng-init=\"extras={view: view, activity: {type: type, action: 'list'}, api: api}\">\n    <div class=\"list-pane {{ view || 'photogrid' }}-view\">\n        <div id=\"content-list\" class=\"content\">\n            <div class=\"loading-indicator\" ng-show=\"loading\" translate>loading</div>\n            <div class=\"search-tags\" sd-search-tags data-url-params=\"urlParams\"></div>\n            <div class=\"contacts-list__holder\" sd-contacts-list></div>\n        </div>\n        <div class=\"preview-pane content-item-preview\" ng-if=\"selected.preview\">\n            <div class=\"contact-details-pane\">\n                <div sd-contact-editor\n                    class=\"contact-editor\"\n                    data-contact=\"selected.preview\"\n                    data-oncancel=\"selected.preview = null\">\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n";

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseSortBar_1 = __webpack_require__(162);
var LinkFunction = /** @class */ (function (_super) {
    __extends(LinkFunction, _super);
    function LinkFunction(contacts, sort, scope, elem) {
        var _this = _super.call(this, scope, elem, sort) || this;
        _this.contacts = contacts;
        _this.scope.canSort = _super.prototype.canSort.bind(_this);
        _this.scope.sortOptions = contacts.sortOptions;
        sort.setSort('last_name', contacts.sortOptions);
        _super.prototype.getActive.call(_this);
        return _this;
    }
    return LinkFunction;
}(BaseSortBar_1.BaseSortBar));
/**
 * @ngdoc directive
 * @module superdesk.apps.contacts
 * @name sdContactsSortBar
 * @requires contacts
 * @requires sort
 * @description sd-contacts-sort-bar handle sort functionality.
 */
function ContactsSortBarDirective(contacts, sort) {
    return {
        scope: { total: '=' },
        template: __webpack_require__(163),
        link: function (scope, elem) { return new LinkFunction(contacts, sort, scope, elem); },
    };
}
exports.ContactsSortBarDirective = ContactsSortBarDirective;
ContactsSortBarDirective.$inject = ['contacts', 'sort'];


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-render-return-value */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var lodash_1 = __importDefault(__webpack_require__(2));
var components_1 = __webpack_require__(57);
ContactList.$inject = [
    '$timeout',
    '$filter',
    'search',
    'datetime',
    'Keys',
    '$rootScope',
];
/**
 * @ngdoc directive
 * @module superdesk.apps.ContactList
 * @name sdContactsList
 *
 * @requires $timeout
 * @requires $filter
 * @requires search
 * @requires datetime
 * @requires Keys
 * @requires $rootScope
 *
 * @description Handles the functionality displaying list of items from contacts collection
 */
function ContactList($timeout, $filter, search, datetime, Keys, $rootScope) {
    // contains all the injected services to be passed down to child
    // components via props
    var services = {
        $timeout: $timeout,
        $filter: $filter,
        datetime: datetime,
        Keys: Keys,
        $rootScope: $rootScope,
    };
    return {
        link: function (scope, elem) {
            elem.attr('tabindex', 0);
            var itemList = react_1.default.createElement(components_1.ItemList, angular.extend({
                svc: services,
                scope: scope,
            }));
            var listComponent = react_dom_1.default.render(itemList, elem[0]);
            scope.$watch('items', function (items) {
                if (!items || !items._items) {
                    return;
                }
                var itemsList = [];
                var currentItems = {};
                var itemsById = angular.extend({}, listComponent.state.itemsById);
                items._items.forEach(function (item) {
                    var oldItem = itemsById[item._id] || null;
                    if (!oldItem || !lodash_1.default.isEqual(oldItem, item)) {
                        itemsById[item._id] = angular.extend({}, oldItem, item);
                    }
                    if (!currentItems[item._id]) { // filter out possible duplicates
                        currentItems[item._id] = true;
                        itemsList.push(item._id);
                    }
                });
                listComponent.setState({
                    itemsList: itemsList,
                    itemsById: itemsById,
                    view: scope.view,
                }, function () {
                    scope.rendering = scope.loading = false;
                });
            }, true);
            scope.$watch('view', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    listComponent.setState({ view: newValue });
                }
            });
            scope.singleLine = search.singleLine;
            var updateTimeout;
            /**
             * Function for creating small delay,
             * before activating render function
             */
            function handleScroll($event) {
                // force refresh the list, if scroll bar hits the top of list.
                if (elem[0].scrollTop === 0) {
                    $rootScope.$broadcast('refresh:list');
                }
                if (scope.rendering) { // ignore
                    $event.preventDefault();
                    return;
                }
                // only scroll the list, not its parent
                $event.stopPropagation();
                $timeout.cancel(updateTimeout);
                updateTimeout = $timeout(renderIfNeeded, 100, false);
            }
            /**
             * Trigger render in case user scrolls to the very end of list
             */
            function renderIfNeeded() {
                if (!scope.items) {
                    return; // automatic scroll after removing items
                }
                if (isListEnd(elem[0]) && !scope.rendering) {
                    scope.rendering = scope.loading = true;
                    scope.fetchNext(listComponent.state.itemsList.length);
                }
            }
            /**
             * Check if we reached end of the list elem
             *
             * @param {Element} elem
             * @return {Boolean}
             */
            function isListEnd(element) {
                return element.scrollTop + element.offsetHeight + 200 >= element.scrollHeight;
            }
            elem.on('keydown', listComponent.handleKey);
            elem.on('scroll', handleScroll);
            // remove react elem on destroy
            scope.$on('$destroy', function () {
                elem.off();
                react_dom_1.default.unmountComponentAtNode(elem[0]);
            });
        },
    };
}
exports.ContactList = ContactList;


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable react/no-render-return-value */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(__webpack_require__(0));
var react_dom_1 = __importDefault(__webpack_require__(15));
var helpers_1 = __webpack_require__(64);
var Form_1 = __webpack_require__(63);
ContactEditorDirective.$inject = [
    'contacts',
    'notify',
    'privileges',
    'metadata',
    '$filter',
    'Keys',
    '$rootScope',
    'lodash',
];
function ContactEditorDirective(contacts, notify, privileges, metadata, $filter, Keys, $rootScope, _) {
    // contains all the injected services to be passed down to child
    // components via props
    var services = {
        contacts: contacts,
        notify: notify,
        privileges: privileges,
        metadata: metadata,
    };
    return {
        scope: {
            origContact: '=contact',
            oncancel: '&',
        },
        link: function (scope, elem) {
            scope.onCancel = function () {
                scope.$applyAsync(function () {
                    scope.oncancel();
                });
            };
            var contactFormContainer = react_1.default.createElement(Form_1.ContactFormContainer, angular.extend({
                svc: services,
                contact: scope.origContact,
                onCancel: scope.onCancel,
            }));
            var contactFormComponent = react_dom_1.default.render(contactFormContainer, elem[0]);
            scope.$watch('origContact', function () {
                var origContact = helpers_1.replaceUrls(scope.origContact);
                contactFormComponent.setState({
                    originalContact: origContact,
                    currentContact: origContact,
                });
            });
            // remove react elem on destroy
            scope.$on('$destroy', function () {
                elem.off();
                react_dom_1.default.unmountComponentAtNode(elem[0]);
            });
        },
    };
}
exports.ContactEditorDirective = ContactEditorDirective;


/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContactsService_1 = __webpack_require__(2126);
exports.ContactsService = ContactsService_1.ContactsService;


/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(43);
var utils_1 = __webpack_require__(3);
var DEFAULT_PAGE_SIZE = 50;
/**
 * @ngdoc service
 * @module superdesk.apps.contacts
 * @name sdContactsSearch
 * @requires api
 * @requires https://docs.angularjs.org/api/ng/service/$location $location
 * @requires sort
 * @requires search
 * @description Handles retrieval of data from contacts api
 */
var ContactsService = /** @class */ (function () {
    function ContactsService(api, $location, sort, search) {
        this.api = api;
        this.$location = $location;
        this.sort = sort;
        this.sortOptions = [
            { field: 'last_name', label: utils_1.gettext('Person (Last Name)'), defaultDir: 'asc' },
            { field: 'organisation', label: utils_1.gettext('Organisation'), defaultDir: 'asc' },
            { field: '_created', label: utils_1.gettext('Created') },
            { field: '_updated', label: utils_1.gettext('Updated') },
        ];
        this.search = search;
        this.toggleStatus = this.toggleStatus.bind(this);
        this.togglePublic = this.togglePublic.bind(this);
        this.save = this.save.bind(this);
        this.twitterPattern = /^@([A-Za-z0-9_]{1,15}$)/;
        this.privacyOptions = [
            { name: utils_1.gettext('All'), value: null },
            { name: utils_1.gettext('Public'), value: 'true' },
            { name: utils_1.gettext('Private'), value: 'false' },
        ];
        this.statusOptions = [
            { name: utils_1.gettext('All'), value: null },
            { name: utils_1.gettext('Active'), value: 'true' },
            { name: utils_1.gettext('Inactive'), value: 'false' },
        ];
    }
    /**
     * @ngdoc method
     * @name contacts#getCriteria
     * @public
     * @description Get the search criteria for given params.
     * @param {object} param $location.search object
     * @return {object}
     */
    ContactsService.prototype.getCriteria = function (param) {
        var criteria = {};
        var params = param || this.$location.search();
        var sort = this.sort.getSort(this.sortOptions);
        var filters = [];
        criteria.max_results = DEFAULT_PAGE_SIZE;
        criteria.sort = this.sort.formatSort(sort.field, sort.dir);
        criteria.page = 1;
        criteria.all = false; // to get all contacts
        var queryParams = params.q ? [params.q] : [];
        angular.forEach(constants_1.URL_PARAMETERS, function (val, key) {
            if (params[key]) {
                queryParams.push(key + ":(" + params[key] + ")");
            }
        });
        if (queryParams.length) {
            criteria.q = queryParams.join(' ');
            criteria.default_operator = 'AND';
        }
        Object.keys(constants_1.FILTER_FIELDS).forEach(function (key) {
            var _a;
            var paramName = constants_1.FILTER_FIELDS[key];
            if (angular.isDefined(params[paramName])) {
                filters.push({ term: (_a = {}, _a[paramName] = params[paramName], _a) });
            }
        });
        if (filters.length) {
            criteria.filter = JSON.stringify({ and: filters });
        }
        return criteria;
    };
    /**
     * @ngdoc method
     * @name contacts#query
     * @public
     * @description Calls contacts api and performs the query.
     * @param {object} param parameters to query
     * @return {promise}
     */
    ContactsService.prototype.query = function (param) {
        return this.api('contacts').query(param);
    };
    /**
      * @ngdoc method
      * @name contacts#queryField
      * @param {string} name of field in contacts collection
      * @param {string} search text to query with in given field
      * @returns {Promise}
      * @public
      * @description Requests a list of fields value suggestions from the server e.g.,
      * in case of organisation field returns organisations suggestions if resolved.
      */
    ContactsService.prototype.queryField = function (field, text) {
        switch (field) {
            case 'organisation':
                return this.api.get("contacts/organisations?q=" + text);
        }
    };
    /* Contact Form */
    /**
     * Toggle contact status
     */
    ContactsService.prototype.toggleStatus = function (contact, active) {
        return this.api.save('contacts', { is_active: active });
    };
    ContactsService.prototype.togglePublic = function (contact, isPublic) {
        return this.api.save('contacts', { public: isPublic });
    };
    ContactsService.prototype.save = function (contact, data) {
        return this.api.save('contacts', contact, data);
    };
    return ContactsService;
}());
exports.ContactsService = ContactsService;
ContactsService.$inject = ['api', '$location', 'sort', 'search'];


/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(2128);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(13)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./contacts.scss", function() {
		var newContent = require("!!../../../../../css-loader/index.js!../../../../../sass-loader/lib/loader.js!./contacts.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(33);
exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "[order=\"1\"] {\n  order: 1; }\n\n[order=\"2\"] {\n  order: 2; }\n\n[order=\"3\"] {\n  order: 3; }\n\n[order=\"4\"] {\n  order: 4; }\n\n[order=\"5\"] {\n  order: 5; }\n\n[order=\"6\"] {\n  order: 6; }\n\n[order=\"7\"] {\n  order: 7; }\n\n[order=\"8\"] {\n  order: 8; }\n\n[order=\"9\"] {\n  order: 9; }\n\n[order=\"10\"] {\n  order: 10; }\n\n[order=\"11\"] {\n  order: 11; }\n\n[order=\"12\"] {\n  order: 12; }\n\n[order=\"13\"] {\n  order: 13; }\n\n[order=\"14\"] {\n  order: 14; }\n\n[order=\"15\"] {\n  order: 15; }\n\n[order=\"16\"] {\n  order: 16; }\n\n[order=\"17\"] {\n  order: 17; }\n\n[order=\"18\"] {\n  order: 18; }\n\n[order=\"19\"] {\n  order: 19; }\n\n[order=\"20\"] {\n  order: 20; }\n\n[order=\"21\"] {\n  order: 21; }\n\n[order=\"22\"] {\n  order: 22; }\n\n[order=\"23\"] {\n  order: 23; }\n\n[order=\"24\"] {\n  order: 24; }\n\n[order=\"25\"] {\n  order: 25; }\n\n[order=\"26\"] {\n  order: 26; }\n\n[order=\"27\"] {\n  order: 27; }\n\n[order=\"28\"] {\n  order: 28; }\n\n[order=\"29\"] {\n  order: 29; }\n\n[order=\"30\"] {\n  order: 30; }\n\n[order=\"31\"] {\n  order: 31; }\n\n[order=\"32\"] {\n  order: 32; }\n\n[order=\"33\"] {\n  order: 33; }\n\n[order=\"34\"] {\n  order: 34; }\n\n[order=\"35\"] {\n  order: 35; }\n\n[order=\"36\"] {\n  order: 36; }\n\n[order=\"37\"] {\n  order: 37; }\n\n[order=\"38\"] {\n  order: 38; }\n\n[order=\"39\"] {\n  order: 39; }\n\n[order=\"40\"] {\n  order: 40; }\n\n[sd-width=\"full\"] {\n  flex-basis: 100%; }\n\n[sd-width=\"half\"] {\n  flex-basis: 50%; }\n\n[sd-width=\"third\"] {\n  flex-basis: 33%; }\n\n[sd-width=\"quarter\"] {\n  flex-basis: 25%; }\n\n/*was 65*/\n/*\n====================================================\n    contacts detail pane\n====================================================\n*/\n.contact-details-pane {\n  position: relative;\n  width: 100%;\n  display: flex; }\n  .contact-details-pane ::-webkit-scrollbar {\n    border-left: 9px solid #fff;\n    border-right: 1px solid #fff;\n    width: 13px;\n    background: #fff; }\n    .contact-details-pane ::-webkit-scrollbar:hover {\n      background: #e8e8e8; }\n  .contact-details-pane ::-webkit-scrollbar-thumb {\n    border-left: 8px solid #fff;\n    background: #bbb; }\n    .contact-details-pane ::-webkit-scrollbar-thumb:hover {\n      background: #787878; }\n  .contact-details-pane .profile-info {\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 180px);\n    position: relative;\n    overflow-y: auto; }\n    .contact-details-pane .profile-info .sd-line-input__input--add-min-height {\n      min-height: 6rem; }\n  .contact-details-pane .contact-form {\n    display: flex; }\n    .contact-details-pane .contact-form form {\n      display: flex;\n      flex-direction: column; }\n  .contact-details-pane .action-bar {\n    position: inherit !important;\n    padding: 10px; }\n    .contact-details-pane .action-bar.show {\n      top: 0px; }\n  .contact-details-pane .header-info {\n    background-color: rgba(94, 169, 200, 0.11);\n    padding: 10px 0 0; }\n    .contact-details-pane .header-info h2 {\n      text-align: center;\n      font-size: 18px;\n      line-height: 20px;\n      margin: 10px 0 4px 0;\n      padding: 0 20px; }\n    .contact-details-pane .header-info h5 {\n      text-align: center;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 16px;\n      padding: 0 20px;\n      margin-bottom: 10px;\n      color: rgba(0, 0, 0, 0.75); }\n    .contact-details-pane .header-info .active {\n      position: absolute;\n      top: 24px;\n      right: 15px; }\n  .contact-details-pane .date-time {\n    color: #999;\n    font-weight: 300; }\n  .contact-details-pane .details-info {\n    flex-grow: 1;\n    padding: 10px; }\n  .contact-details-pane .alert-info-msg {\n    font-size: 1.2rem;\n    line-height: 1.4rem;\n    transition: all 0.3s cubic-bezier(0.55, 0, 0.55, 0.2);\n    color: grey;\n    letter-spacing: .03em; }\n  .contact-details-pane .error-holder {\n    height: 40px;\n    margin: 0 -20px; }\n    .contact-details-pane .error-holder .alert {\n      padding: 10px 20px; }\n  .contact-details-pane .validation-error {\n    color: #ab3434;\n    font-size: 12px;\n    margin-top: 5px;\n    margin-bottom: 0; }\n  .contact-details-pane .validation-info {\n    font-size: 11px;\n    color: #888; }\n  .contact-details-pane .profile-pic {\n    width: 82px;\n    height: 82px;\n    position: relative;\n    margin: 0 auto; }\n    .contact-details-pane .profile-pic .avatar {\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      position: relative;\n      background-image: url(" + escape(__webpack_require__(552)) + "); }\n      .contact-details-pane .profile-pic .avatar.organisation {\n        background-image: url(" + escape(__webpack_require__(164)) + "); }\n      .contact-details-pane .profile-pic .avatar.initials {\n        font-size: 24px;\n        line-height: 82px;\n        font-weight: 300; }\n    .contact-details-pane .profile-pic .disabled-label {\n      position: absolute;\n      bottom: 15%;\n      left: 40%;\n      border: 1px solid #fff; }\n  .contact-details-pane .alert {\n    border-radius: 0px; }\n  .contact-details-pane .ng-invalid-required .required-info {\n    display: inline-block !important; }\n\n.prevent-switch {\n  pointer-events: none; }\n\n.preview-layout .preview-pane {\n  overflow-y: hidden !important; }\n\n.sd-line-input--add-min-width {\n  min-width: 90px; }\n\n.sd-line-input__message--add-padding {\n  padding-top: 2.4rem !important; }\n\n.sd-line-input__toggle .sd-line-input__label {\n  max-width: none; }\n\n.sd-line-input__usage {\n  min-width: 90px; }\n  .sd-line-input__usage .sd-line-input__label {\n    padding-top: 1.4rem !important; }\n    .sd-line-input__usage .sd-line-input__label:after {\n      content: none !important; }\n\n.sd-line-input__usage-flag {\n  line-height: 2.4rem; }\n  .sd-line-input__usage-flag .sd-line-input__label:after {\n    content: none !important; }\n\n.toggle-box .toggle-box__header:focus {\n  background: #eff7fa; }\n\n.toggle-box__content--hidden {\n  display: none; }\n\n.sd-toggle:focus {\n  box-shadow: 0 1px 1px 2px rgba(0, 0, 0, 0.15); }\n\n.sd-line-input .sd-line-input__label.sd-line-input__label--hide-required {\n  margin-top: 3px; }\n  .sd-line-input .sd-line-input__label.sd-line-input__label--hide-required:after {\n    content: none !important; }\n\n.contact__type-icon {\n  position: absolute;\n  top: 1.8rem;\n  left: 1rem;\n  background: #67afa1;\n  height: 3.4rem;\n  width: 3.4rem;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1; }\n  .contact__type-icon i {\n    color: #fff; }\n\n.contact-header__container {\n  padding-left: 4.4rem;\n  min-height: 3.7rem;\n  margin-top: 0.5rem; }\n  .contact-header__container h3 {\n    font-size: 1.6rem;\n    line-height: 120%;\n    font-weight: 500; }\n  .contact-header__container .item-info {\n    opacity: 0.85;\n    font-weight: 300; }\n\n.contacts-list__holder {\n  padding: 2rem;\n  overflow-y: auto; }\n  .contacts-list__holder .sd-grid-list--small-margin {\n    margin: 0; }\n  .contacts-list__holder .list-item-view.inactive {\n    opacity: 0.5; }\n  .contacts-list__holder .list-item-view .social-info {\n    margin: 0 0.5rem; }\n    .contacts-list__holder .list-item-view .social-info span {\n      margin-right: 0.5rem; }\n\n.contacts-section .contact-editor, .contacts-section .content-item-preview {\n  display: flex; }\n", ""]);

// exports


/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// services
var RelationsService_1 = __webpack_require__(2130);
var RelatedItemsDirective_1 = __webpack_require__(2131);
angular.module('superdesk.apps.relations', ['superdesk.apps.archive'])
    .service('relationsService', RelationsService_1.RelationsService)
    .directive('sdRelatedItems', RelatedItemsDirective_1.RelatedItemsDirective);


/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
RelationsService.$inject = ['archiveService', 'mediaIdGenerator', 'api', '$q'];
function RelationsService(archiveService, mediaIdGenerator, api, $q) {
    this.getRelatedItemsWithoutMediaGallery = function (item, fields) {
        if (!item.associations) {
            return [];
        }
        var relatedWithoutMedia = lodash_1.pickBy(item.associations, function (value, key) {
            var parts = mediaIdGenerator.getFieldParts(key);
            var field = fields.find(function (f) { return f._id === parts[0]; });
            return field && field.field_type === 'related_content';
        });
        var related = Object.values(relatedWithoutMedia);
        var relatedWithoutNull = related.filter(function (o) { return o != null && Object.keys(o).length < 2; });
        var relatedItems = relatedWithoutNull.map(function (o) { return api.find('archive', o._id); });
        return $q.all(relatedItems)
            .then(function (response) {
            var unpublished = response.filter(function (o) { return !archiveService.isPublished(o); });
            return unpublished;
        });
    };
    this.getRelatedKeys = function (item, fieldId) {
        return Object.keys(item.associations || {})
            .filter(function (key) { return key.startsWith(fieldId) && item.associations[key] != null; })
            .sort();
    };
    this.getRelatedItemsForField = function (item, fieldId) {
        var relatedItemsKeys = this.getRelatedKeys(item, fieldId);
        var associations = item.associations || {};
        return $q.all(relatedItemsKeys.map(function (key) {
            if (associations[key] && Object.keys(associations[key]).length < 2) {
                return api.find('archive', associations[key]._id);
            }
            return $q.when(associations[key]);
        })).then(function (values) { return lodash_1.zipObject(relatedItemsKeys, values); });
    };
}
exports.RelationsService = RelationsService;


/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __webpack_require__(2);
var utils_1 = __webpack_require__(3);
var utils_2 = __webpack_require__(3);
/**
 * @ngdoc directive
 * @module superdesk.apps.authoring
 * @name sdRelatedItems
 *
 * @description
 * This directive is responsible for rendering related items and support operations as reordering,
 * add related items by using drag and drop, delete related items and open related items.
 */
RelatedItemsDirective.$inject = ['authoringWorkspace', 'relationsService', 'notify'];
function RelatedItemsDirective(authoringWorkspace, relationsService, notify) {
    return {
        scope: {
            item: '=',
            editable: '<',
            field: '<',
            onchange: '&onchange',
        },
        templateUrl: 'scripts/apps/relations/views/related-items.html',
        link: function (scope, elem, attr) {
            var dragOverClass = 'dragover';
            var allowed = ((scope.field || {}).field_options || {}).allowed_types || {};
            var ALLOWED_TYPES = Object.keys(allowed)
                .filter(function (key) { return allowed[key] === true; })
                .map(function (key) { return 'application/superdesk.item.' + key; });
            if (!elem.hasClass('no-drop-zone') && scope.editable) {
                elem.on('dragover', function (event) {
                    if (ALLOWED_TYPES.includes(utils_1.getSuperdeskType(event))) {
                        event.preventDefault();
                        event.stopPropagation();
                        addDragOverClass();
                    }
                    else {
                        removeDragOverClass();
                    }
                });
                elem.on('dragleave', function () {
                    removeDragOverClass();
                });
                elem.on('drop dragdrop', function (event) {
                    removeDragOverClass();
                    event.preventDefault();
                    event.stopPropagation();
                    var relatedItemsForCurrentField = Object.keys(scope.item.associations || {})
                        .filter(function (key) { return key.startsWith(scope.field._id) && scope.item.associations[key] != null; })
                        .map(function (key) { return scope.item.associations[key]; });
                    var currentCount = relatedItemsForCurrentField.length;
                    var maxCount = lodash_1.get(scope, 'field.field_options.multiple_items.enabled') === true
                        ? lodash_1.get(scope, 'field.field_options.multiple_items.max_items')
                        : 1;
                    var type = utils_1.getSuperdeskType(event, false);
                    var item = angular.fromJson(event.originalEvent.dataTransfer.getData(type));
                    var itemAlreadyAddedAsRelated = relatedItemsForCurrentField.some(function (relatedItem) { return relatedItem._id === item._id; });
                    if (scope.item._id === item._id) {
                        notify.error('Cannot add self as related item.');
                        return;
                    }
                    if (itemAlreadyAddedAsRelated) {
                        notify.error('This item is already added as related.');
                        return;
                    }
                    if (currentCount >= maxCount) {
                        notify.error(utils_2.gettext('Related item was not added, because the field '
                            + 'reached the limit of related items allowed.'));
                        return;
                    }
                    scope.addRelatedItem(item);
                });
            }
            var addDragOverClass = function () {
                elem.find('.item-association').addClass(dragOverClass);
                elem.find('.related-items').addClass(dragOverClass);
            };
            var removeDragOverClass = function () {
                elem.find('.item-association').removeClass(dragOverClass);
                elem.find('.related-items').removeClass(dragOverClass);
            };
            /**
             * Get related items keys for fireldId
             *
             * @param {Object} item
             * @param {String} fieldId
             * @return {[String]}
             */
            function getRelatedKeys(item, fieldId) {
                return relationsService.getRelatedKeys(item, fieldId);
            }
            /**
            * Return true if there are association for current field
            *
            * @param {String} fieldId
            * @return {Boolean}
            */
            scope.isEmptyRelatedItems = function (fieldId) {
                var keys = Object.keys(scope.item.associations || {})
                    .filter(function (key) { return key.startsWith(fieldId) && scope.item.associations[key] != null; });
                return keys.length === 0;
            };
            /**
            * Get related items for fieldId
            *
            * @param {String} fieldId
            * @return {[Object]}
            */
            scope.refreshRelatedItems = function () {
                scope.loading = true;
                relationsService.getRelatedItemsForField(scope.item, scope.field._id)
                    .then(function (items) {
                    scope.relatedItems = items;
                    scope.loading = false;
                });
            };
            scope.refreshRelatedItems();
            /**
             * Reorder related items on related items list
             *
             * @param {int} start
             * @param {int} end
             */
            scope.reorder = function (start, end) {
                if (!scope.editable) {
                    return;
                }
                var related = getRelatedKeys(scope.item, scope.field._id);
                var newRelated = related.slice(0);
                newRelated.splice(end.index, 0, newRelated.splice(start.index, 1)[0]);
                var updated = related.reduce(function (obj, key, index) {
                    obj[key] = scope.item.associations[newRelated[index]];
                    return obj;
                }, {});
                scope.item.associations = angular.extend({}, scope.item.associations, updated);
                scope.onchange();
            };
            /**
             * Return the next key for related item associated to current field
             *
             * @param {Object} associations
             * @param {String} fieldId
             * @return {int} nextKey
             */
            function getNextKey(associations, fieldId) {
                for (var i = 1;; i++) {
                    var key = fieldId + '--' + i;
                    if (associations[key] == null) {
                        return key;
                    }
                }
            }
            /**
             * Add a new related item for current field
             *
             * @param {Object} item
             */
            scope.addRelatedItem = function (item) {
                var key = getNextKey(scope.item.associations || {}, scope.field._id);
                var data = {};
                if ('_type' in item && item._type !== 'archive') {
                    data[key] = item;
                }
                else {
                    data[key] = { _id: item._id };
                }
                scope.item.associations = angular.extend({}, scope.item.associations, data);
                scope.onchange();
            };
            /**
             * Remove the related item with key
             *
             * @param {int} key
             */
            scope.removeRelatedItem = function (key) {
                if (!scope.editable) {
                    return;
                }
                var data = {};
                data[key] = null;
                scope.item.associations = angular.extend({}, scope.item.associations, data);
                scope.onchange();
            };
            /**
             * Open related item
             *
             * @param {Object} item
             */
            scope.openRelatedItem = function (item) {
                authoringWorkspace.edit(item);
            };
            scope.$watchCollection('item.associations', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    scope.refreshRelatedItems();
                }
            });
        },
    };
}
exports.RelatedItemsDirective = RelatedItemsDirective;


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [];


/***/ }),
/* 2133 */
/***/ (function(module, exports) {

/*
 * This module enables the 'tansa' spellchecker functionality and installs
 * it based on the documentation provided by the user guide.
 */
/* jshint ignore:start */
// tansa server base urls e.g 'http://localhost:8080/tansaclient/'
var baseUrl = location.protocol + "//" + location.host + "/tansaclient/";
var tansaScript = "\n    <script type=\"text/javascript\">\n        var tansa = {\n            settings: {\n                baseUrl: '<baseUrl>',\n                clientExtenstionJs: 'tansa4ClientExtensionSimple.js',\n                // need to populate dynamically\n                tansaUserId: 'tansa',\n                checkboxPreference: false,\n                parentAppId: '02d65e3e-f62d-41f9-92c6-ffaf16bf209e',\n                licenseKey: '10747a8a5016-95b1-4d4c-846b-f34347e8f288'\n            }\n        };\n\n        // tansa apparently likes to polute window scope\n        window.tansa = tansa;\n\n        function afterProofing (isCancelled) {\n            let $rootScope = angular.element(document.body).injector().get('$rootScope');\n            $rootScope.$broadcast('tansa:after', isCancelled);\n            $rootScope.$broadcast('tansa:end', isCancelled);\n        }\n    </script>\n";
// workaround to avoid nggettext_extract parsing error
tansaScript = tansaScript.replace('<baseUrl>', baseUrl);
document.write(tansaScript);
var script = document.createElement('script');
script.src = location.protocol + "//" + location.host + "/tansaclient/tansaLoader.js?" + new Date().getTime();
document.write(script.outerHTML);
document.write("\n     <script type=\"text/javascript\">\n        var pgwBrowser = tansaJQuery.pgwBrowser();\n        window.tansa.settings.platformName = pgwBrowser.os.name;\n        window.tansa.settings.platformVersion = pgwBrowser.os.fullVersion;\n     </script>\n");
/* jshint ignore:end */


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.bundle.js